webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _antd = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(116);
	
	var _zh_CN = __webpack_require__(937);
	
	var _zh_CN2 = _interopRequireDefault(_zh_CN);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1000);
	
	__webpack_require__(307);
	
	__webpack_require__(948);
	
	__webpack_require__(946);
	
	__webpack_require__(947);
	
	__webpack_require__(943);
	
	var _action = __webpack_require__(515);
	
	var _routes = __webpack_require__(288);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	// import ReactDOMServer from 'react-dom/server';
	
	// import 'rt-sd-comp/sgiComp/SgiCompComm';
	
	// 引入cfca  api挂载window
	
	
	if (!window.sgiSrvUrl.openLog) {
	    // 关闭log
	    tool.sgiLogger.Level = {};
	}
	// // 暴露方法到全局对象
	// window.parentMethod = () => {
	//     return new Promise((resolve) => {
	//       verifyCertificate((res) => {
	//         if (res.errorcode === '0') {
	//           resolve(true); // 验证成功返回true
	//         } else {
	//           tool.popMessage(res.result, 'error');
	//           resolve(false); // 验证失败返回false
	//         }
	//       });
	//     });
	//   };
	// 暴露消息监听器
	window.addEventListener("message", function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
	        var res;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        if (!(event.origin !== window.location.origin)) {
	                            _context.next = 2;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 2:
	                        if (!(event.data === "REQUEST_UKY_VERIFY")) {
	                            _context.next = 15;
	                            break;
	                        }
	
	                        _context.prev = 3;
	                        _context.next = 6;
	                        return new Promise(function (resolve, reject) {
	                            (0, _action.verifyCertificate)().then(resolve).catch(reject); // 显式连接reject
	                        });
	
	                    case 6:
	                        res = _context.sent;
	
	                        console.log('返回校验结果', res);
	                        // 返回结果给子窗口
	                        event.source.postMessage({
	                            type: "UKY_RESULT",
	                            valid: res.errorcode === '0',
	                            message: tool.getCookie("currentSerialNo")
	                        }, event.origin);
	
	                        _context.next = 15;
	                        break;
	
	                    case 11:
	                        _context.prev = 11;
	                        _context.t0 = _context['catch'](3);
	
	                        console.error('Ukey验证错误:', _context.t0, tool.getCookie("currentSerialNo"));
	                        event.source.postMessage({
	                            type: "UKY_ERROR",
	                            error: _context.t0.result
	                        }, event.origin);
	
	                    case 15:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[3, 11]]);
	    }));
	
	    return function (_x) {
	        return _ref.apply(this, arguments);
	    };
	}());
	// 查看卸载-加载时间差，判断是否重新加载
	var unload_time = tool.sgiStorage.get("UNLOAD_TIME");
	var nowTime = new Date().getTime();
	var diff = nowTime - unload_time;
	tool.sgiLogger.debug('>>>>diff :', diff);
	if (diff > 5 * 1000) {
	    // 卸载时间大于3秒，删除上次登录信息
	    tool.sgiLogger.debug('>>>>diff time more than 5 seconds, will remove cookies by prefix[' + sgiConfig.abb_project + ']');
	    tool.removeCookieByPrefix(sgiConfig.abb_project);
	}
	
	// 初始化自定义全局方法
	// apJSLoading();
	// 杨某给初始化方法换登录后
	
	// 配置初始化程序接入口-hanzb
	var initGJSs = sgiConfig.initGJSs;
	if (initGJSs && initGJSs.length > 0) {
	    initGJSs.forEach(function (guid) {
	        var initPrm = PrmFactory.getPrm(guid);
	        if (initPrm && initPrm.guid) {
	            var funanme = initPrm.c;
	            var fun = initPrm.jsfun;
	            var params = initPrm.params;
	            if (funanme) {
	                try {
	                    var initFun = new (Function.prototype.bind.apply(Function, [null].concat(_toConsumableArray((params || "").split(',')), [fun])))();
	                    tool.sgiLogger.debug('\u6267\u884C\u521D\u59CB\u5316\u7A0B\u5E8F[' + funanme + ']');
	                    initFun();
	                } catch (error) {
	                    tool.sgiLogger.error("初始化程序错误，请检查！", error);
	                }
	            }
	        }
	    });
	}
	
	// Client render (optional):
	if (typeof document !== 'undefined') {
	    var outlet = document.getElementById('app');
	    // let Holder;
	    window.addEventListener('DOMContentLoaded', function () {});
	
	    // var _beforeUnload_time = 0, _gap_time = 0;
	    // window.addEventListener("beforeunload", (event) => {
	    //     _beforeUnload_time = new Date().getTime();
	    // });
	    window.addEventListener("unload", function () {
	        // _gap_time = new Date().getTime() - _beforeUnload_time;
	        // tool.sgiStorage.set("_gap_time", _gap_time);
	        // if (_gap_time < 10) {
	        // 认为页面关闭
	        // 清除页面storage缓存
	        tool.sgiStorage.removeByPrefix(sgiConfig.keyPre_app);
	        // } else {
	        // 认为页面刷新
	        // }
	
	        // 记录unload时间
	        tool.sgiStorage.set("UNLOAD_TIME", new Date().getTime());
	    });
	
	    //禁用右键
	    document.oncontextmenu = function () {
	        return false;
	    };
	
	    _reactDom2.default.render(_react2.default.createElement(
	        _antd.LocaleProvider,
	        { locale: _zh_CN2.default },
	        _react2.default.createElement(_reactRouter.Router, {
	            history: _reactRouter.browserHistory,
	            routes: _routes2.default
	        })
	    ), outlet);
	}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/**
	 * @module zrender/core/util
	 */
	// 用于处理merge时无法遍历Date等对象的问题
	var BUILTIN_OBJECT = {
	  '[object Function]': 1,
	  '[object RegExp]': 1,
	  '[object Date]': 1,
	  '[object Error]': 1,
	  '[object CanvasGradient]': 1,
	  '[object CanvasPattern]': 1,
	  // For node-canvas
	  '[object Image]': 1,
	  '[object Canvas]': 1
	};
	var TYPED_ARRAY = {
	  '[object Int8Array]': 1,
	  '[object Uint8Array]': 1,
	  '[object Uint8ClampedArray]': 1,
	  '[object Int16Array]': 1,
	  '[object Uint16Array]': 1,
	  '[object Int32Array]': 1,
	  '[object Uint32Array]': 1,
	  '[object Float32Array]': 1,
	  '[object Float64Array]': 1
	};
	var objToString = Object.prototype.toString;
	var arrayProto = Array.prototype;
	var nativeForEach = arrayProto.forEach;
	var nativeFilter = arrayProto.filter;
	var nativeSlice = arrayProto.slice;
	var nativeMap = arrayProto.map;
	var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  // Clear ctx instance for different environment
	  if (name === 'createCanvas') {
	    _ctx = null;
	  }
	
	  methods[name] = fn;
	}
	/**
	 * Those data types can be cloned:
	 *     Plain object, Array, TypedArray, number, string, null, undefined.
	 * Those data types will be assgined using the orginal data:
	 *     BUILTIN_OBJECT
	 * Instance of user defined class will be cloned to a plain object, without
	 * properties in prototype.
	 * Other data types is not supported (not sure what will happen).
	 *
	 * Caution: do not support clone Date, for performance consideration.
	 * (There might be a large number of date in `series.data`).
	 * So date should not be modified in and out of echarts.
	 *
	 * @param {*} source
	 * @return {*} new
	 */
	
	
	function clone(source) {
	  if (source == null || typeof source !== 'object') {
	    return source;
	  }
	
	  var result = source;
	  var typeStr = objToString.call(source);
	
	  if (typeStr === '[object Array]') {
	    if (!isPrimitive(source)) {
	      result = [];
	
	      for (var i = 0, len = source.length; i < len; i++) {
	        result[i] = clone(source[i]);
	      }
	    }
	  } else if (TYPED_ARRAY[typeStr]) {
	    if (!isPrimitive(source)) {
	      var Ctor = source.constructor;
	
	      if (source.constructor.from) {
	        result = Ctor.from(source);
	      } else {
	        result = new Ctor(source.length);
	
	        for (var i = 0, len = source.length; i < len; i++) {
	          result[i] = clone(source[i]);
	        }
	      }
	    }
	  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
	    result = {};
	
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        result[key] = clone(source[key]);
	      }
	    }
	  }
	
	  return result;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overwrite=false]
	 */
	
	
	function merge(target, source, overwrite) {
	  // We should escapse that source is string
	  // and enter for ... in ...
	  if (!isObject(source) || !isObject(target)) {
	    return overwrite ? clone(source) : target;
	  }
	
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      var targetProp = target[key];
	      var sourceProp = source[key];
	
	      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
	        // 如果需要递归覆盖，就递归调用merge
	        merge(targetProp, sourceProp, overwrite);
	      } else if (overwrite || !(key in target)) {
	        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
	        // NOTE，在 target[key] 不存在的时候也是直接覆盖
	        target[key] = clone(source[key], true);
	      }
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {Array} targetAndSources The first item is target, and the rests are source.
	 * @param {boolean} [overwrite=false]
	 * @return {*} target
	 */
	
	
	function mergeAll(targetAndSources, overwrite) {
	  var result = targetAndSources[0];
	
	  for (var i = 1, len = targetAndSources.length; i < len; i++) {
	    result = merge(result, targetAndSources[i], overwrite);
	  }
	
	  return result;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @memberOf module:zrender/core/util
	 */
	
	
	function extend(target, source) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overlay=false]
	 * @memberOf module:zrender/core/util
	 */
	
	
	function defaults(target, source, overlay) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var createCanvas = function () {
	  return methods.createCanvas();
	};
	
	methods.createCanvas = function () {
	  return document.createElement('canvas');
	}; // FIXME
	
	
	var _ctx;
	
	function getContext() {
	  if (!_ctx) {
	    // Use util.createCanvas instead of createCanvas
	    // because createCanvas may be overwritten in different environment
	    _ctx = createCanvas().getContext('2d');
	  }
	
	  return _ctx;
	}
	/**
	 * 查询数组中元素的index
	 * @memberOf module:zrender/core/util
	 */
	
	
	function indexOf(array, value) {
	  if (array) {
	    if (array.indexOf) {
	      return array.indexOf(value);
	    }
	
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === value) {
	        return i;
	      }
	    }
	  }
	
	  return -1;
	}
	/**
	 * 构造类继承关系
	 *
	 * @memberOf module:zrender/core/util
	 * @param {Function} clazz 源类
	 * @param {Function} baseClazz 基类
	 */
	
	
	function inherits(clazz, baseClazz) {
	  var clazzPrototype = clazz.prototype;
	
	  function F() {}
	
	  F.prototype = baseClazz.prototype;
	  clazz.prototype = new F();
	
	  for (var prop in clazzPrototype) {
	    if (clazzPrototype.hasOwnProperty(prop)) {
	      clazz.prototype[prop] = clazzPrototype[prop];
	    }
	  }
	
	  clazz.prototype.constructor = clazz;
	  clazz.superClass = baseClazz;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Object|Function} target
	 * @param {Object|Function} sorce
	 * @param {boolean} overlay
	 */
	
	
	function mixin(target, source, overlay) {
	  target = 'prototype' in target ? target.prototype : target;
	  source = 'prototype' in source ? source.prototype : source;
	  defaults(target, source, overlay);
	}
	/**
	 * Consider typed array.
	 * @param {Array|TypedArray} data
	 */
	
	
	function isArrayLike(data) {
	  if (!data) {
	    return;
	  }
	
	  if (typeof data === 'string') {
	    return false;
	  }
	
	  return typeof data.length === 'number';
	}
	/**
	 * 数组或对象遍历
	 * @memberOf module:zrender/core/util
	 * @param {Object|Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 */
	
	
	function each(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.forEach && obj.forEach === nativeForEach) {
	    obj.forEach(cb, context);
	  } else if (obj.length === +obj.length) {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      cb.call(context, obj[i], i, obj);
	    }
	  } else {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        cb.call(context, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * 数组映射
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function map(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.map && obj.map === nativeMap) {
	    return obj.map(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      result.push(cb.call(context, obj[i], i, obj));
	    }
	
	    return result;
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {Object} [memo]
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function reduce(obj, cb, memo, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.reduce && obj.reduce === nativeReduce) {
	    return obj.reduce(cb, memo, context);
	  } else {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      memo = cb.call(context, memo, obj[i], i, obj);
	    }
	
	    return memo;
	  }
	}
	/**
	 * 数组过滤
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function filter(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.filter && obj.filter === nativeFilter) {
	    return obj.filter(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      if (cb.call(context, obj[i], i, obj)) {
	        result.push(obj[i]);
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * 数组项查找
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {*}
	 */
	
	
	function find(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  for (var i = 0, len = obj.length; i < len; i++) {
	    if (cb.call(context, obj[i], i, obj)) {
	      return obj[i];
	    }
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @param {*} context
	 * @return {Function}
	 */
	
	
	function bind(func, context) {
	  var args = nativeSlice.call(arguments, 2);
	  return function () {
	    return func.apply(context, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @return {Function}
	 */
	
	
	function curry(func) {
	  var args = nativeSlice.call(arguments, 1);
	  return function () {
	    return func.apply(this, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isArray(value) {
	  return objToString.call(value) === '[object Array]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isFunction(value) {
	  return typeof value === 'function';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isString(value) {
	  return objToString.call(value) === '[object String]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return type === 'function' || !!value && type === 'object';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isBuiltInObject(value) {
	  return !!BUILTIN_OBJECT[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isTypedArray(value) {
	  return !!TYPED_ARRAY[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isDom(value) {
	  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
	}
	/**
	 * Whether is exactly NaN. Notice isNaN('a') returns true.
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function eqNaN(value) {
	  /* eslint-disable-next-line no-self-compare */
	  return value !== value;
	}
	/**
	 * If value1 is not null, then return value1, otherwise judget rest of values.
	 * Low performance.
	 * @memberOf module:zrender/core/util
	 * @return {*} Final value
	 */
	
	
	function retrieve(values) {
	  for (var i = 0, len = arguments.length; i < len; i++) {
	    if (arguments[i] != null) {
	      return arguments[i];
	    }
	  }
	}
	
	function retrieve2(value0, value1) {
	  return value0 != null ? value0 : value1;
	}
	
	function retrieve3(value0, value1, value2) {
	  return value0 != null ? value0 : value1 != null ? value1 : value2;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} arr
	 * @param {number} startIndex
	 * @param {number} endIndex
	 * @return {Array}
	 */
	
	
	function slice() {
	  return Function.call.apply(nativeSlice, arguments);
	}
	/**
	 * Normalize css liked array configuration
	 * e.g.
	 *  3 => [3, 3, 3, 3]
	 *  [4, 2] => [4, 2, 4, 2]
	 *  [4, 3, 2] => [4, 3, 2, 3]
	 * @param {number|Array.<number>} val
	 * @return {Array.<number>}
	 */
	
	
	function normalizeCssArray(val) {
	  if (typeof val === 'number') {
	    return [val, val, val, val];
	  }
	
	  var len = val.length;
	
	  if (len === 2) {
	    // vertical | horizontal
	    return [val[0], val[1], val[0], val[1]];
	  } else if (len === 3) {
	    // top | horizontal | bottom
	    return [val[0], val[1], val[2], val[1]];
	  }
	
	  return val;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {boolean} condition
	 * @param {string} message
	 */
	
	
	function assert(condition, message) {
	  if (!condition) {
	    throw new Error(message);
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {string} str string to be trimed
	 * @return {string} trimed string
	 */
	
	
	function trim(str) {
	  if (str == null) {
	    return null;
	  } else if (typeof str.trim === 'function') {
	    return str.trim();
	  } else {
	    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	  }
	}
	
	var primitiveKey = '__ec_primitive__';
	/**
	 * Set an object as primitive to be ignored traversing children in clone or merge
	 */
	
	function setAsPrimitive(obj) {
	  obj[primitiveKey] = true;
	}
	
	function isPrimitive(obj) {
	  return obj[primitiveKey];
	}
	/**
	 * @constructor
	 * @param {Object} obj Only apply `ownProperty`.
	 */
	
	
	function HashMap(obj) {
	  var isArr = isArray(obj); // Key should not be set on this, otherwise
	  // methods get/set/... may be overrided.
	
	  this.data = {};
	  var thisMap = this;
	  obj instanceof HashMap ? obj.each(visit) : obj && each(obj, visit);
	
	  function visit(value, key) {
	    isArr ? thisMap.set(value, key) : thisMap.set(key, value);
	  }
	}
	
	HashMap.prototype = {
	  constructor: HashMap,
	  // Do not provide `has` method to avoid defining what is `has`.
	  // (We usually treat `null` and `undefined` as the same, different
	  // from ES6 Map).
	  get: function (key) {
	    return this.data.hasOwnProperty(key) ? this.data[key] : null;
	  },
	  set: function (key, value) {
	    // Comparing with invocation chaining, `return value` is more commonly
	    // used in this case: `var someVal = map.set('a', genVal());`
	    return this.data[key] = value;
	  },
	  // Although util.each can be performed on this hashMap directly, user
	  // should not use the exposed keys, who are prefixed.
	  each: function (cb, context) {
	    context !== void 0 && (cb = bind(cb, context));
	    /* eslint-disable guard-for-in */
	
	    for (var key in this.data) {
	      this.data.hasOwnProperty(key) && cb(this.data[key], key);
	    }
	    /* eslint-enable guard-for-in */
	
	  },
	  // Do not use this method if performance sensitive.
	  removeKey: function (key) {
	    delete this.data[key];
	  }
	};
	
	function createHashMap(obj) {
	  return new HashMap(obj);
	}
	
	function concatArray(a, b) {
	  var newArray = new a.constructor(a.length + b.length);
	
	  for (var i = 0; i < a.length; i++) {
	    newArray[i] = a[i];
	  }
	
	  var offset = a.length;
	
	  for (i = 0; i < b.length; i++) {
	    newArray[i + offset] = b[i];
	  }
	
	  return newArray;
	}
	
	function noop() {}
	
	exports.$override = $override;
	exports.clone = clone;
	exports.merge = merge;
	exports.mergeAll = mergeAll;
	exports.extend = extend;
	exports.defaults = defaults;
	exports.createCanvas = createCanvas;
	exports.getContext = getContext;
	exports.indexOf = indexOf;
	exports.inherits = inherits;
	exports.mixin = mixin;
	exports.isArrayLike = isArrayLike;
	exports.each = each;
	exports.map = map;
	exports.reduce = reduce;
	exports.filter = filter;
	exports.find = find;
	exports.bind = bind;
	exports.curry = curry;
	exports.isArray = isArray;
	exports.isFunction = isFunction;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isBuiltInObject = isBuiltInObject;
	exports.isTypedArray = isTypedArray;
	exports.isDom = isDom;
	exports.eqNaN = eqNaN;
	exports.retrieve = retrieve;
	exports.retrieve2 = retrieve2;
	exports.retrieve3 = retrieve3;
	exports.slice = slice;
	exports.normalizeCssArray = normalizeCssArray;
	exports.assert = assert;
	exports.trim = trim;
	exports.setAsPrimitive = setAsPrimitive;
	exports.isPrimitive = isPrimitive;
	exports.createHashMap = createHashMap;
	exports.concatArray = concatArray;
	exports.noop = noop;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(168);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1137);


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = react_lz;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(3);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(16);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrender = __webpack_require__(285);
	
	var zrUtil = __webpack_require__(2);
	
	var colorTool = __webpack_require__(105);
	
	var env = __webpack_require__(58);
	
	var timsort = __webpack_require__(446);
	
	var Eventful = __webpack_require__(148);
	
	var GlobalModel = __webpack_require__(853);
	
	var ExtensionAPI = __webpack_require__(797);
	
	var CoordinateSystemManager = __webpack_require__(95);
	
	var OptionManager = __webpack_require__(1852);
	
	var backwardCompat = __webpack_require__(1860);
	
	var dataStack = __webpack_require__(1863);
	
	var ComponentModel = __webpack_require__(65);
	
	var SeriesModel = __webpack_require__(66);
	
	var ComponentView = __webpack_require__(275);
	
	var ChartView = __webpack_require__(103);
	
	var graphic = __webpack_require__(17);
	
	var modelUtil = __webpack_require__(27);
	
	var _throttle = __webpack_require__(131);
	
	var throttle = _throttle.throttle;
	
	var seriesColor = __webpack_require__(1872);
	
	var aria = __webpack_require__(1871);
	
	var loadingDefault = __webpack_require__(1851);
	
	var Scheduler = __webpack_require__(1866);
	
	var lightTheme = __webpack_require__(1868);
	
	var darkTheme = __webpack_require__(1867);
	
	__webpack_require__(821);
	
	var mapDataStorage = __webpack_require__(429);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var assert = zrUtil.assert;
	var each = zrUtil.each;
	var isFunction = zrUtil.isFunction;
	var isObject = zrUtil.isObject;
	var parseClassType = ComponentModel.parseClassType;
	var version = '4.9.0';
	var dependencies = {
	  zrender: '4.3.2'
	};
	var TEST_FRAME_REMAIN_TIME = 1;
	var PRIORITY_PROCESSOR_FILTER = 1000;
	var PRIORITY_PROCESSOR_SERIES_FILTER = 800;
	var PRIORITY_PROCESSOR_DATASTACK = 900;
	var PRIORITY_PROCESSOR_STATISTIC = 5000;
	var PRIORITY_VISUAL_LAYOUT = 1000;
	var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
	var PRIORITY_VISUAL_GLOBAL = 2000;
	var PRIORITY_VISUAL_CHART = 3000;
	var PRIORITY_VISUAL_POST_CHART_LAYOUT = 3500;
	var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
	// necessary?
	
	var PRIORITY_VISUAL_BRUSH = 5000;
	var PRIORITY = {
	  PROCESSOR: {
	    FILTER: PRIORITY_PROCESSOR_FILTER,
	    SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
	    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
	  },
	  VISUAL: {
	    LAYOUT: PRIORITY_VISUAL_LAYOUT,
	    PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
	    GLOBAL: PRIORITY_VISUAL_GLOBAL,
	    CHART: PRIORITY_VISUAL_CHART,
	    POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
	    COMPONENT: PRIORITY_VISUAL_COMPONENT,
	    BRUSH: PRIORITY_VISUAL_BRUSH
	  }
	}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
	// where they must not be invoked nestedly, except the only case: invoke
	// dispatchAction with updateMethod "none" in main process.
	// This flag is used to carry out this rule.
	// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
	
	var IN_MAIN_PROCESS = '__flagInMainProcess';
	var OPTION_UPDATED = '__optionUpdated';
	var ACTION_REG = /^[a-zA-Z0-9_]+$/;
	
	function createRegisterEventWithLowercaseName(method, ignoreDisposed) {
	  return function (eventName, handler, context) {
	    if (!ignoreDisposed && this._disposed) {
	      disposedWarning(this.id);
	      return;
	    } // Event name is all lowercase
	
	
	    eventName = eventName && eventName.toLowerCase();
	    Eventful.prototype[method].call(this, eventName, handler, context);
	  };
	}
	/**
	 * @module echarts~MessageCenter
	 */
	
	
	function MessageCenter() {
	  Eventful.call(this);
	}
	
	MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on', true);
	MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off', true);
	MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one', true);
	zrUtil.mixin(MessageCenter, Eventful);
	/**
	 * @module echarts~ECharts
	 */
	
	function ECharts(dom, theme, opts) {
	  opts = opts || {}; // Get theme by name
	
	  if (typeof theme === 'string') {
	    theme = themeStorage[theme];
	  }
	  /**
	   * @type {string}
	   */
	
	
	  this.id;
	  /**
	   * Group id
	   * @type {string}
	   */
	
	  this.group;
	  /**
	   * @type {HTMLElement}
	   * @private
	   */
	
	  this._dom = dom;
	  var defaultRenderer = 'canvas';
	
	  /**
	   * @type {module:zrender/ZRender}
	   * @private
	   */
	  var zr = this._zr = zrender.init(dom, {
	    renderer: opts.renderer || defaultRenderer,
	    devicePixelRatio: opts.devicePixelRatio,
	    width: opts.width,
	    height: opts.height
	  });
	  /**
	   * Expect 60 fps.
	   * @type {Function}
	   * @private
	   */
	
	  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
	  var theme = zrUtil.clone(theme);
	  theme && backwardCompat(theme, true);
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._theme = theme;
	  /**
	   * @type {Array.<module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsMap = {};
	  /**
	   * @type {Array.<module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsMap = {};
	  /**
	   * @type {module:echarts/CoordinateSystem}
	   * @private
	   */
	
	  this._coordSysMgr = new CoordinateSystemManager();
	  /**
	   * @type {module:echarts/ExtensionAPI}
	   * @private
	   */
	
	  var api = this._api = createExtensionAPI(this); // Sort on demand
	
	  function prioritySortFunc(a, b) {
	    return a.__prio - b.__prio;
	  }
	
	  timsort(visualFuncs, prioritySortFunc);
	  timsort(dataProcessorFuncs, prioritySortFunc);
	  /**
	   * @type {module:echarts/stream/Scheduler}
	   */
	
	  this._scheduler = new Scheduler(this, api, dataProcessorFuncs, visualFuncs);
	  Eventful.call(this, this._ecEventProcessor = new EventProcessor());
	  /**
	   * @type {module:echarts~MessageCenter}
	   * @private
	   */
	
	  this._messageCenter = new MessageCenter(); // Init mouse events
	
	  this._initEvents(); // In case some people write `window.onresize = chart.resize`
	
	
	  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure
	
	  this._pendingActions = [];
	  zr.animation.on('frame', this._onframe, this);
	  bindRenderedEvent(zr, this); // ECharts instance can be used as value.
	
	  zrUtil.setAsPrimitive(this);
	}
	
	var echartsProto = ECharts.prototype;
	
	echartsProto._onframe = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  var scheduler = this._scheduler; // Lazy update
	
	  if (this[OPTION_UPDATED]) {
	    var silent = this[OPTION_UPDATED].silent;
	    this[IN_MAIN_PROCESS] = true;
	    prepare(this);
	    updateMethods.update.call(this);
	    this[IN_MAIN_PROCESS] = false;
	    this[OPTION_UPDATED] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  } // Avoid do both lazy update and progress in one frame.
	  else if (scheduler.unfinished) {
	      // Stream progress.
	      var remainTime = TEST_FRAME_REMAIN_TIME;
	      var ecModel = this._model;
	      var api = this._api;
	      scheduler.unfinished = false;
	
	      do {
	        var startTime = +new Date();
	        scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
	
	        scheduler.performDataProcessorTasks(ecModel);
	        updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
	        // each frame is not a good user experience. So we follow the rule that
	        // the extent of the coordinate system is determin in the first frame (the
	        // frame is executed immedietely after task reset.
	        // this._coordSysMgr.update(ecModel, api);
	        // console.log('--- ec frame visual ---', remainTime);
	
	        scheduler.performVisualTasks(ecModel);
	        renderSeries(this, this._model, api, 'remain');
	        remainTime -= +new Date() - startTime;
	      } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
	
	
	      if (!scheduler.unfinished) {
	        this._zr.flush();
	      } // Else, zr flushing be ensue within the same frame,
	      // because zr flushing is after onframe event.
	
	    }
	};
	/**
	 * @return {HTMLElement}
	 */
	
	
	echartsProto.getDom = function () {
	  return this._dom;
	};
	/**
	 * @return {module:zrender~ZRender}
	 */
	
	
	echartsProto.getZr = function () {
	  return this._zr;
	};
	/**
	 * Usage:
	 * chart.setOption(option, notMerge, lazyUpdate);
	 * chart.setOption(option, {
	 *     notMerge: ...,
	 *     lazyUpdate: ...,
	 *     silent: ...
	 * });
	 *
	 * @param {Object} option
	 * @param {Object|boolean} [opts] opts or notMerge.
	 * @param {boolean} [opts.notMerge=false]
	 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
	 */
	
	
	echartsProto.setOption = function (option, notMerge, lazyUpdate) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var silent;
	
	  if (isObject(notMerge)) {
	    lazyUpdate = notMerge.lazyUpdate;
	    silent = notMerge.silent;
	    notMerge = notMerge.notMerge;
	  }
	
	  this[IN_MAIN_PROCESS] = true;
	
	  if (!this._model || notMerge) {
	    var optionManager = new OptionManager(this._api);
	    var theme = this._theme;
	    var ecModel = this._model = new GlobalModel();
	    ecModel.scheduler = this._scheduler;
	    ecModel.init(null, null, theme, optionManager);
	  }
	
	  this._model.setOption(option, optionPreprocessorFuncs);
	
	  if (lazyUpdate) {
	    this[OPTION_UPDATED] = {
	      silent: silent
	    };
	    this[IN_MAIN_PROCESS] = false;
	  } else {
	    prepare(this);
	    updateMethods.update.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
	    // fetched after `setOption`.
	
	    this._zr.flush();
	
	    this[OPTION_UPDATED] = false;
	    this[IN_MAIN_PROCESS] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  }
	};
	/**
	 * @DEPRECATED
	 */
	
	
	echartsProto.setTheme = function () {
	  console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
	};
	/**
	 * @return {module:echarts/model/Global}
	 */
	
	
	echartsProto.getModel = function () {
	  return this._model;
	};
	/**
	 * @return {Object}
	 */
	
	
	echartsProto.getOption = function () {
	  return this._model && this._model.getOption();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getWidth = function () {
	  return this._zr.getWidth();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getHeight = function () {
	  return this._zr.getHeight();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getDevicePixelRatio = function () {
	  return this._zr.painter.dpr || window.devicePixelRatio || 1;
	};
	/**
	 * Get canvas which has all thing rendered
	 * @param {Object} opts
	 * @param {string} [opts.backgroundColor]
	 * @return {string}
	 */
	
	
	echartsProto.getRenderedCanvas = function (opts) {
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  opts = opts || {};
	  opts.pixelRatio = opts.pixelRatio || 1;
	  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
	  var zr = this._zr; // var list = zr.storage.getDisplayList();
	  // Stop animations
	  // Never works before in init animation, so remove it.
	  // zrUtil.each(list, function (el) {
	  //     el.stopAnimation(true);
	  // });
	
	  return zr.painter.getRenderedCanvas(opts);
	};
	/**
	 * Get svg data url
	 * @return {string}
	 */
	
	
	echartsProto.getSvgDataURL = function () {
	  if (!env.svgSupported) {
	    return;
	  }
	
	  var zr = this._zr;
	  var list = zr.storage.getDisplayList(); // Stop animations
	
	  zrUtil.each(list, function (el) {
	    el.stopAnimation(true);
	  });
	  return zr.painter.toDataURL();
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 * @param {string} [opts.excludeComponents]
	 */
	
	
	echartsProto.getDataURL = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  opts = opts || {};
	  var excludeComponents = opts.excludeComponents;
	  var ecModel = this._model;
	  var excludesComponentViews = [];
	  var self = this;
	  each(excludeComponents, function (componentType) {
	    ecModel.eachComponent({
	      mainType: componentType
	    }, function (component) {
	      var view = self._componentsMap[component.__viewId];
	
	      if (!view.group.ignore) {
	        excludesComponentViews.push(view);
	        view.group.ignore = true;
	      }
	    });
	  });
	  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
	  each(excludesComponentViews, function (view) {
	    view.group.ignore = false;
	  });
	  return url;
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 */
	
	
	echartsProto.getConnectedDataURL = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  var isSvg = opts.type === 'svg';
	  var groupId = this.group;
	  var mathMin = Math.min;
	  var mathMax = Math.max;
	  var MAX_NUMBER = Infinity;
	
	  if (connectedGroups[groupId]) {
	    var left = MAX_NUMBER;
	    var top = MAX_NUMBER;
	    var right = -MAX_NUMBER;
	    var bottom = -MAX_NUMBER;
	    var canvasList = [];
	    var dpr = opts && opts.pixelRatio || 1;
	    zrUtil.each(instances, function (chart, id) {
	      if (chart.group === groupId) {
	        var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas(zrUtil.clone(opts));
	        var boundingRect = chart.getDom().getBoundingClientRect();
	        left = mathMin(boundingRect.left, left);
	        top = mathMin(boundingRect.top, top);
	        right = mathMax(boundingRect.right, right);
	        bottom = mathMax(boundingRect.bottom, bottom);
	        canvasList.push({
	          dom: canvas,
	          left: boundingRect.left,
	          top: boundingRect.top
	        });
	      }
	    });
	    left *= dpr;
	    top *= dpr;
	    right *= dpr;
	    bottom *= dpr;
	    var width = right - left;
	    var height = bottom - top;
	    var targetCanvas = zrUtil.createCanvas();
	    var zr = zrender.init(targetCanvas, {
	      renderer: isSvg ? 'svg' : 'canvas'
	    });
	    zr.resize({
	      width: width,
	      height: height
	    });
	
	    if (isSvg) {
	      var content = '';
	      each(canvasList, function (item) {
	        var x = item.left - left;
	        var y = item.top - top;
	        content += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
	      });
	      zr.painter.getSvgRoot().innerHTML = content;
	
	      if (opts.connectedBackgroundColor) {
	        zr.painter.setBackgroundColor(opts.connectedBackgroundColor);
	      }
	
	      zr.refreshImmediately();
	      return zr.painter.toDataURL();
	    } else {
	      // Background between the charts
	      if (opts.connectedBackgroundColor) {
	        zr.add(new graphic.Rect({
	          shape: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          style: {
	            fill: opts.connectedBackgroundColor
	          }
	        }));
	      }
	
	      each(canvasList, function (item) {
	        var img = new graphic.Image({
	          style: {
	            x: item.left * dpr - left,
	            y: item.top * dpr - top,
	            image: item.dom
	          }
	        });
	        zr.add(img);
	      });
	      zr.refreshImmediately();
	      return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
	    }
	  } else {
	    return this.getDataURL(opts);
	  }
	};
	/**
	 * Convert from logical coordinate system to pixel coordinate system.
	 * See CoordinateSystem#convertToPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId, geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	
	echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
	/**
	 * Convert from pixel coordinate system to logical coordinate system.
	 * See CoordinateSystem#convertFromPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');
	
	function doConvertPixel(methodName, finder, value) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var ecModel = this._model;
	
	  var coordSysList = this._coordSysMgr.getCoordinateSystems();
	
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	
	  for (var i = 0; i < coordSysList.length; i++) {
	    var coordSys = coordSysList[i];
	
	    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
	      return result;
	    }
	  }
	}
	/**
	 * Is the specified coordinate systems or components contain the given pixel point.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {boolean} result
	 */
	
	
	echartsProto.containPixel = function (finder, value) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var ecModel = this._model;
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	  zrUtil.each(finder, function (models, key) {
	    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
	      var coordSys = model.coordinateSystem;
	
	      if (coordSys && coordSys.containPoint) {
	        result |= !!coordSys.containPoint(value);
	      } else if (key === 'seriesModels') {
	        var view = this._chartsMap[model.__viewId];
	
	        if (view && view.containPoint) {
	          result |= view.containPoint(value, model);
	        } else {}
	      } else {}
	    }, this);
	  }, this);
	  return !!result;
	};
	/**
	 * Get visual from series or data.
	 * @param {string|Object} finder
	 *        If string, e.g., 'series', means {seriesIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            dataIndex / dataIndexInside
	 *        }
	 *        If dataIndex is not specified, series visual will be fetched,
	 *        but not data item visual.
	 *        If all of seriesIndex, seriesId, seriesName are not specified,
	 *        visual will be fetched from first series.
	 * @param {string} visualType 'color', 'symbol', 'symbolSize'
	 */
	
	
	echartsProto.getVisual = function (finder, visualType) {
	  var ecModel = this._model;
	  finder = modelUtil.parseFinder(ecModel, finder, {
	    defaultMainType: 'series'
	  });
	  var seriesModel = finder.seriesModel;
	  var data = seriesModel.getData();
	  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
	  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
	};
	/**
	 * Get view of corresponding component model
	 * @param  {module:echarts/model/Component} componentModel
	 * @return {module:echarts/view/Component}
	 */
	
	
	echartsProto.getViewOfComponentModel = function (componentModel) {
	  return this._componentsMap[componentModel.__viewId];
	};
	/**
	 * Get view of corresponding series model
	 * @param  {module:echarts/model/Series} seriesModel
	 * @return {module:echarts/view/Chart}
	 */
	
	
	echartsProto.getViewOfSeriesModel = function (seriesModel) {
	  return this._chartsMap[seriesModel.__viewId];
	};
	
	var updateMethods = {
	  prepareAndUpdate: function (payload) {
	    prepare(this);
	    updateMethods.update.call(this, payload);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  update: function (payload) {
	    // console.profile && console.profile('update');
	    var ecModel = this._model;
	    var api = this._api;
	    var zr = this._zr;
	    var coordSysMgr = this._coordSysMgr;
	    var scheduler = this._scheduler; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    scheduler.restoreData(ecModel, payload);
	    scheduler.performSeriesTasks(ecModel); // TODO
	    // Save total ecModel here for undo/redo (after restoring data and before processing data).
	    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
	    // Create new coordinate system each update
	    // In LineView may save the old coordinate system and use it to get the orignal point
	
	    coordSysMgr.create(ecModel, api);
	    scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
	    // stream modes after data processing, where the filtered data is used to
	    // deteming whether use progressive rendering.
	
	    updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
	    // can be fetched when coord sys updating (consider the barGrid extent fix). But
	    // the drawback is the full coord info can not be fetched. Fortunately this full
	    // coord is not requied in stream mode updater currently.
	
	    coordSysMgr.update(ecModel, api);
	    clearColorPalette(ecModel);
	    scheduler.performVisualTasks(ecModel, payload);
	    render(this, ecModel, api, payload); // Set background
	
	    var backgroundColor = ecModel.get('backgroundColor') || 'transparent'; // In IE8
	
	    if (!env.canvasSupported) {
	      var colorArr = colorTool.parse(backgroundColor);
	      backgroundColor = colorTool.stringify(colorArr, 'rgb');
	
	      if (colorArr[3] === 0) {
	        backgroundColor = 'transparent';
	      }
	    } else {
	      zr.setBackgroundColor(backgroundColor);
	    }
	
	    performPostUpdateFuncs(ecModel, api); // console.profile && console.profileEnd('update');
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateTransform: function (payload) {
	    var ecModel = this._model;
	    var ecIns = this;
	    var api = this._api; // update before setOption
	
	    if (!ecModel) {
	      return;
	    } // ChartView.markUpdateMethod(payload, 'updateTransform');
	
	
	    var componentDirtyList = [];
	    ecModel.eachComponent(function (componentType, componentModel) {
	      var componentView = ecIns.getViewOfComponentModel(componentModel);
	
	      if (componentView && componentView.__alive) {
	        if (componentView.updateTransform) {
	          var result = componentView.updateTransform(componentModel, ecModel, api, payload);
	          result && result.update && componentDirtyList.push(componentView);
	        } else {
	          componentDirtyList.push(componentView);
	        }
	      }
	    });
	    var seriesDirtyMap = zrUtil.createHashMap();
	    ecModel.eachSeries(function (seriesModel) {
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.updateTransform) {
	        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
	        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
	      } else {
	        seriesDirtyMap.set(seriesModel.uid, 1);
	      }
	    });
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true,
	      dirtyMap: seriesDirtyMap
	    }); // Currently, not call render of components. Geo render cost a lot.
	    // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
	
	
	    renderSeries(ecIns, ecModel, api, payload, seriesDirtyMap);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateView: function (payload) {
	    var ecModel = this._model; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    ChartView.markUpdateMethod(payload, 'updateView');
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true
	    });
	
	    render(this, this._model, this._api, payload);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateVisual: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateVisual');
	    // clearColorPalette(ecModel);
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateLayout: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateLayout');
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	    // this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  }
	};
	
	function prepare(ecIns) {
	  var ecModel = ecIns._model;
	  var scheduler = ecIns._scheduler;
	  scheduler.restorePipelines(ecModel);
	  scheduler.prepareStageTasks();
	  prepareView(ecIns, 'component', ecModel, scheduler);
	  prepareView(ecIns, 'chart', ecModel, scheduler);
	  scheduler.plan();
	}
	/**
	 * @private
	 */
	
	
	function updateDirectly(ecIns, method, payload, mainType, subType) {
	  var ecModel = ecIns._model; // broadcast
	
	  if (!mainType) {
	    // FIXME
	    // Chart will not be update directly here, except set dirty.
	    // But there is no such scenario now.
	    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
	    return;
	  }
	
	  var query = {};
	  query[mainType + 'Id'] = payload[mainType + 'Id'];
	  query[mainType + 'Index'] = payload[mainType + 'Index'];
	  query[mainType + 'Name'] = payload[mainType + 'Name'];
	  var condition = {
	    mainType: mainType,
	    query: query
	  };
	  subType && (condition.subType = subType); // subType may be '' by parseClassType;
	
	  var excludeSeriesId = payload.excludeSeriesId;
	
	  if (excludeSeriesId != null) {
	    excludeSeriesId = zrUtil.createHashMap(modelUtil.normalizeToArray(excludeSeriesId));
	  } // If dispatchAction before setOption, do nothing.
	
	
	  ecModel && ecModel.eachComponent(condition, function (model) {
	    if (!excludeSeriesId || excludeSeriesId.get(model.id) == null) {
	      callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
	    }
	  }, ecIns);
	
	  function callView(view) {
	    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
	  }
	}
	/**
	 * Resize the chart
	 * @param {Object} opts
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @param {boolean} [opts.silent=false]
	 */
	
	
	echartsProto.resize = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._zr.resize(opts);
	
	  var ecModel = this._model; // Resize loading effect
	
	  this._loadingFX && this._loadingFX.resize();
	
	  if (!ecModel) {
	    return;
	  }
	
	  var optionChanged = ecModel.resetOption('media');
	  var silent = opts && opts.silent;
	  this[IN_MAIN_PROCESS] = true;
	  optionChanged && prepare(this);
	  updateMethods.update.call(this);
	  this[IN_MAIN_PROCESS] = false;
	  flushPendingActions.call(this, silent);
	  triggerUpdatedEvent.call(this, silent);
	};
	
	function updateStreamModes(ecIns, ecModel) {
	  var chartsMap = ecIns._chartsMap;
	  var scheduler = ecIns._scheduler;
	  ecModel.eachSeries(function (seriesModel) {
	    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
	  });
	}
	/**
	 * Show loading effect
	 * @param  {string} [name='default']
	 * @param  {Object} [cfg]
	 */
	
	
	echartsProto.showLoading = function (name, cfg) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (isObject(name)) {
	    cfg = name;
	    name = '';
	  }
	
	  name = name || 'default';
	  this.hideLoading();
	
	  if (!loadingEffects[name]) {
	    return;
	  }
	
	  var el = loadingEffects[name](this._api, cfg);
	  var zr = this._zr;
	  this._loadingFX = el;
	  zr.add(el);
	};
	/**
	 * Hide loading effect
	 */
	
	
	echartsProto.hideLoading = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._loadingFX && this._zr.remove(this._loadingFX);
	  this._loadingFX = null;
	};
	/**
	 * @param {Object} eventObj
	 * @return {Object}
	 */
	
	
	echartsProto.makeActionFromEvent = function (eventObj) {
	  var payload = zrUtil.extend({}, eventObj);
	  payload.type = eventActionMap[eventObj.type];
	  return payload;
	};
	/**
	 * @pubilc
	 * @param {Object} payload
	 * @param {string} [payload.type] Action type
	 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
	 * @param {boolean} [opt.silent=false] Whether trigger events.
	 * @param {boolean} [opt.flush=undefined]
	 *                  true: Flush immediately, and then pixel in canvas can be fetched
	 *                      immediately. Caution: it might affect performance.
	 *                  false: Not flush.
	 *                  undefined: Auto decide whether perform flush.
	 */
	
	
	echartsProto.dispatchAction = function (payload, opt) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (!isObject(opt)) {
	    opt = {
	      silent: !!opt
	    };
	  }
	
	  if (!actions[payload.type]) {
	    return;
	  } // Avoid dispatch action before setOption. Especially in `connect`.
	
	
	  if (!this._model) {
	    return;
	  } // May dispatchAction in rendering procedure
	
	
	  if (this[IN_MAIN_PROCESS]) {
	    this._pendingActions.push(payload);
	
	    return;
	  }
	
	  doDispatchAction.call(this, payload, opt.silent);
	
	  if (opt.flush) {
	    this._zr.flush(true);
	  } else if (opt.flush !== false && env.browser.weChat) {
	    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
	    // hang when sliding page (on touch event), which cause that zr does not
	    // refresh util user interaction finished, which is not expected.
	    // But `dispatchAction` may be called too frequently when pan on touch
	    // screen, which impacts performance if do not throttle them.
	    this._throttledZrFlush();
	  }
	
	  flushPendingActions.call(this, opt.silent);
	  triggerUpdatedEvent.call(this, opt.silent);
	};
	
	function doDispatchAction(payload, silent) {
	  var payloadType = payload.type;
	  var escapeConnect = payload.escapeConnect;
	  var actionWrap = actions[payloadType];
	  var actionInfo = actionWrap.actionInfo;
	  var cptType = (actionInfo.update || 'update').split(':');
	  var updateMethod = cptType.pop();
	  cptType = cptType[0] != null && parseClassType(cptType[0]);
	  this[IN_MAIN_PROCESS] = true;
	  var payloads = [payload];
	  var batched = false; // Batch action
	
	  if (payload.batch) {
	    batched = true;
	    payloads = zrUtil.map(payload.batch, function (item) {
	      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
	      item.batch = null;
	      return item;
	    });
	  }
	
	  var eventObjBatch = [];
	  var eventObj;
	  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
	  each(payloads, function (batchItem) {
	    // Action can specify the event by return it.
	    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside
	
	    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType
	
	    eventObj.type = actionInfo.event || eventObj.type;
	    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
	
	    if (isHighDown) {
	      // method, payload, mainType, subType
	      updateDirectly(this, updateMethod, batchItem, 'series');
	    } else if (cptType) {
	      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
	    }
	  }, this);
	
	  if (updateMethod !== 'none' && !isHighDown && !cptType) {
	    // Still dirty
	    if (this[OPTION_UPDATED]) {
	      // FIXME Pass payload ?
	      prepare(this);
	      updateMethods.update.call(this, payload);
	      this[OPTION_UPDATED] = false;
	    } else {
	      updateMethods[updateMethod].call(this, payload);
	    }
	  } // Follow the rule of action batch
	
	
	  if (batched) {
	    eventObj = {
	      type: actionInfo.event || payloadType,
	      escapeConnect: escapeConnect,
	      batch: eventObjBatch
	    };
	  } else {
	    eventObj = eventObjBatch[0];
	  }
	
	  this[IN_MAIN_PROCESS] = false;
	  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
	}
	
	function flushPendingActions(silent) {
	  var pendingActions = this._pendingActions;
	
	  while (pendingActions.length) {
	    var payload = pendingActions.shift();
	    doDispatchAction.call(this, payload, silent);
	  }
	}
	
	function triggerUpdatedEvent(silent) {
	  !silent && this.trigger('updated');
	}
	/**
	 * Event `rendered` is triggered when zr
	 * rendered. It is useful for realtime
	 * snapshot (reflect animation).
	 *
	 * Event `finished` is triggered when:
	 * (1) zrender rendering finished.
	 * (2) initial animation finished.
	 * (3) progressive rendering finished.
	 * (4) no pending action.
	 * (5) no delayed setOption needs to be processed.
	 */
	
	
	function bindRenderedEvent(zr, ecIns) {
	  zr.on('rendered', function () {
	    ecIns.trigger('rendered'); // The `finished` event should not be triggered repeatly,
	    // so it should only be triggered when rendering indeed happend
	    // in zrender. (Consider the case that dipatchAction is keep
	    // triggering when mouse move).
	
	    if ( // Although zr is dirty if initial animation is not finished
	    // and this checking is called on frame, we also check
	    // animation finished for robustness.
	    zr.animation.isFinished() && !ecIns[OPTION_UPDATED] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
	      ecIns.trigger('finished');
	    }
	  });
	}
	/**
	 * @param {Object} params
	 * @param {number} params.seriesIndex
	 * @param {Array|TypedArray} params.data
	 */
	
	
	echartsProto.appendData = function (params) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var seriesIndex = params.seriesIndex;
	  var ecModel = this.getModel();
	  var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	  seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
	  // system, util some scenario require that. In the expected usage of
	  // `appendData`, the initial extent of coordinate system should better
	  // be fixed by axis `min`/`max` setting or initial data, otherwise if
	  // the extent changed while `appendData`, the location of the painted
	  // graphic elements have to be changed, which make the usage of
	  // `appendData` meaningless.
	
	  this._scheduler.unfinished = true;
	};
	/**
	 * Register event
	 * @method
	 */
	
	
	echartsProto.on = createRegisterEventWithLowercaseName('on', false);
	echartsProto.off = createRegisterEventWithLowercaseName('off', false);
	echartsProto.one = createRegisterEventWithLowercaseName('one', false);
	/**
	 * Prepare view instances of charts and components
	 * @param  {module:echarts/model/Global} ecModel
	 * @private
	 */
	
	function prepareView(ecIns, type, ecModel, scheduler) {
	  var isComponent = type === 'component';
	  var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
	  var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
	  var zr = ecIns._zr;
	  var api = ecIns._api;
	
	  for (var i = 0; i < viewList.length; i++) {
	    viewList[i].__alive = false;
	  }
	
	  isComponent ? ecModel.eachComponent(function (componentType, model) {
	    componentType !== 'series' && doPrepare(model);
	  }) : ecModel.eachSeries(doPrepare);
	
	  function doPrepare(model) {
	    // Consider: id same and type changed.
	    var viewId = '_ec_' + model.id + '_' + model.type;
	    var view = viewMap[viewId];
	
	    if (!view) {
	      var classType = parseClassType(model.type);
	      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);
	      view = new Clazz();
	      view.init(ecModel, api);
	      viewMap[viewId] = view;
	      viewList.push(view);
	      zr.add(view.group);
	    }
	
	    model.__viewId = view.__id = viewId;
	    view.__alive = true;
	    view.__model = model;
	    view.group.__ecComponentInfo = {
	      mainType: model.mainType,
	      index: model.componentIndex
	    };
	    !isComponent && scheduler.prepareView(view, model, ecModel, api);
	  }
	
	  for (var i = 0; i < viewList.length;) {
	    var view = viewList[i];
	
	    if (!view.__alive) {
	      !isComponent && view.renderTask.dispose();
	      zr.remove(view.group);
	      view.dispose(ecModel, api);
	      viewList.splice(i, 1);
	      delete viewMap[view.__id];
	      view.__id = view.group.__ecComponentInfo = null;
	    } else {
	      i++;
	    }
	  }
	} // /**
	//  * Encode visual infomation from data after data processing
	//  *
	//  * @param {module:echarts/model/Global} ecModel
	//  * @param {object} layout
	//  * @param {boolean} [layoutFilter] `true`: only layout,
	//  *                                 `false`: only not layout,
	//  *                                 `null`/`undefined`: all.
	//  * @param {string} taskBaseTag
	//  * @private
	//  */
	// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
	//     each(visualFuncs, function (visual, index) {
	//         var isLayout = visual.isLayout;
	//         if (layoutFilter == null
	//             || (layoutFilter === false && !isLayout)
	//             || (layoutFilter === true && isLayout)
	//         ) {
	//             visual.func(ecModel, api, payload);
	//         }
	//     });
	// }
	
	
	function clearColorPalette(ecModel) {
	  ecModel.clearColorPalette();
	  ecModel.eachSeries(function (seriesModel) {
	    seriesModel.clearColorPalette();
	  });
	}
	
	function render(ecIns, ecModel, api, payload) {
	  renderComponents(ecIns, ecModel, api, payload);
	  each(ecIns._chartsViews, function (chart) {
	    chart.__alive = false;
	  });
	  renderSeries(ecIns, ecModel, api, payload); // Remove groups of unrendered charts
	
	  each(ecIns._chartsViews, function (chart) {
	    if (!chart.__alive) {
	      chart.remove(ecModel, api);
	    }
	  });
	}
	
	function renderComponents(ecIns, ecModel, api, payload, dirtyList) {
	  each(dirtyList || ecIns._componentsViews, function (componentView) {
	    var componentModel = componentView.__model;
	    componentView.render(componentModel, ecModel, api, payload);
	    updateZ(componentModel, componentView);
	  });
	}
	/**
	 * Render each chart and component
	 * @private
	 */
	
	
	function renderSeries(ecIns, ecModel, api, payload, dirtyMap) {
	  // Render all charts
	  var scheduler = ecIns._scheduler;
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    var chartView = ecIns._chartsMap[seriesModel.__viewId];
	    chartView.__alive = true;
	    var renderTask = chartView.renderTask;
	    scheduler.updatePayload(renderTask, payload);
	
	    if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
	      renderTask.dirty();
	    }
	
	    unfinished |= renderTask.perform(scheduler.getPerformArgs(renderTask));
	    chartView.group.silent = !!seriesModel.get('silent');
	    updateZ(seriesModel, chartView);
	    updateBlend(seriesModel, chartView);
	  });
	  scheduler.unfinished |= unfinished; // If use hover layer
	
	  updateHoverLayerStatus(ecIns, ecModel); // Add aria
	
	  aria(ecIns._zr.dom, ecModel);
	}
	
	function performPostUpdateFuncs(ecModel, api) {
	  each(postUpdateFuncs, function (func) {
	    func(ecModel, api);
	  });
	}
	
	var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
	/**
	 * @private
	 */
	
	echartsProto._initEvents = function () {
	  each(MOUSE_EVENT_NAMES, function (eveName) {
	    var handler = function (e) {
	      var ecModel = this.getModel();
	      var el = e.target;
	      var params;
	      var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
	
	      if (isGlobalOut) {
	        params = {};
	      } else if (el && el.dataIndex != null) {
	        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
	        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType, el) || {};
	      } // If element has custom eventData of components
	      else if (el && el.eventData) {
	          params = zrUtil.extend({}, el.eventData);
	        } // Contract: if params prepared in mouse event,
	      // these properties must be specified:
	      // {
	      //    componentType: string (component main type)
	      //    componentIndex: number
	      // }
	      // Otherwise event query can not work.
	
	
	      if (params) {
	        var componentType = params.componentType;
	        var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
	        // markLine/markPoint/markArea, the componentType is
	        // 'markLine'/'markPoint'/'markArea', but we should better
	        // enable them to be queried by seriesIndex, since their
	        // option is set in each series.
	
	        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
	          componentType = 'series';
	          componentIndex = params.seriesIndex;
	        }
	
	        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
	        var view = model && this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
	        params.event = e;
	        params.type = eveName;
	        this._ecEventProcessor.eventInfo = {
	          targetEl: el,
	          packedEvent: params,
	          model: model,
	          view: view
	        };
	        this.trigger(eveName, params);
	      }
	    }; // Consider that some component (like tooltip, brush, ...)
	    // register zr event handler, but user event handler might
	    // do anything, such as call `setOption` or `dispatchAction`,
	    // which probably update any of the content and probably
	    // cause problem if it is called previous other inner handlers.
	
	
	    handler.zrEventfulCallAtLast = true;
	
	    this._zr.on(eveName, handler, this);
	  }, this);
	  each(eventActionMap, function (actionType, eventType) {
	    this._messageCenter.on(eventType, function (event) {
	      this.trigger(eventType, event);
	    }, this);
	  }, this);
	};
	/**
	 * @return {boolean}
	 */
	
	
	echartsProto.isDisposed = function () {
	  return this._disposed;
	};
	/**
	 * Clear
	 */
	
	
	echartsProto.clear = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this.setOption({
	    series: []
	  }, true);
	};
	/**
	 * Dispose instance
	 */
	
	
	echartsProto.dispose = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._disposed = true;
	  modelUtil.setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
	  var api = this._api;
	  var ecModel = this._model;
	  each(this._componentsViews, function (component) {
	    component.dispose(ecModel, api);
	  });
	  each(this._chartsViews, function (chart) {
	    chart.dispose(ecModel, api);
	  }); // Dispose after all views disposed
	
	  this._zr.dispose();
	
	  delete instances[this.id];
	};
	
	zrUtil.mixin(ECharts, Eventful);
	
	function disposedWarning(id) {}
	
	function updateHoverLayerStatus(ecIns, ecModel) {
	  var zr = ecIns._zr;
	  var storage = zr.storage;
	  var elCount = 0;
	  storage.traverse(function (el) {
	    elCount++;
	  });
	
	  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.preventUsingHoverLayer) {
	        return;
	      }
	
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.__alive) {
	        chartView.group.traverse(function (el) {
	          // Don't switch back.
	          el.useHoverLayer = true;
	        });
	      }
	    });
	  }
	}
	/**
	 * Update chart progressive and blend.
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateBlend(seriesModel, chartView) {
	  var blendMode = seriesModel.get('blendMode') || null;
	  chartView.group.traverse(function (el) {
	    // FIXME marker and other components
	    if (!el.isGroup) {
	      // Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
	      if (el.style.blend !== blendMode) {
	        el.setStyle('blend', blendMode);
	      }
	    }
	
	    if (el.eachPendingDisplayable) {
	      el.eachPendingDisplayable(function (displayable) {
	        displayable.setStyle('blend', blendMode);
	      });
	    }
	  });
	}
	/**
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateZ(model, view) {
	  var z = model.get('z');
	  var zlevel = model.get('zlevel'); // Set z and zlevel
	
	  view.group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	    }
	  });
	}
	
	function createExtensionAPI(ecInstance) {
	  var coordSysMgr = ecInstance._coordSysMgr;
	  return zrUtil.extend(new ExtensionAPI(ecInstance), {
	    // Inject methods
	    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
	    getComponentByElement: function (el) {
	      while (el) {
	        var modelInfo = el.__ecComponentInfo;
	
	        if (modelInfo != null) {
	          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
	        }
	
	        el = el.parent;
	      }
	    }
	  });
	}
	/**
	 * @class
	 * Usage of query:
	 * `chart.on('click', query, handler);`
	 * The `query` can be:
	 * + The component type query string, only `mainType` or `mainType.subType`,
	 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
	 * + The component query object, like:
	 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
	 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
	 * + The data query object, like:
	 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
	 * + The other query object (cmponent customized query), like:
	 *   `{element: 'some'}` (only available in custom series).
	 *
	 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
	 * same as there is no such prop in the `query` object.
	 */
	
	
	function EventProcessor() {
	  // These info required: targetEl, packedEvent, model, view
	  this.eventInfo;
	}
	
	EventProcessor.prototype = {
	  constructor: EventProcessor,
	  normalizeQuery: function (query) {
	    var cptQuery = {};
	    var dataQuery = {};
	    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
	
	    if (zrUtil.isString(query)) {
	      var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.
	
	      cptQuery.mainType = condCptType.main || null;
	      cptQuery.subType = condCptType.sub || null;
	    } // `query` is an object, convert to {mainType, index, name, id}.
	    else {
	        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
	        // can not be used in `compomentModel.filterForExposedEvent`.
	        var suffixes = ['Index', 'Name', 'Id'];
	        var dataKeys = {
	          name: 1,
	          dataIndex: 1,
	          dataType: 1
	        };
	        zrUtil.each(query, function (val, key) {
	          var reserved = false;
	
	          for (var i = 0; i < suffixes.length; i++) {
	            var propSuffix = suffixes[i];
	            var suffixPos = key.lastIndexOf(propSuffix);
	
	            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
	              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
	
	              if (mainType !== 'data') {
	                cptQuery.mainType = mainType;
	                cptQuery[propSuffix.toLowerCase()] = val;
	                reserved = true;
	              }
	            }
	          }
	
	          if (dataKeys.hasOwnProperty(key)) {
	            dataQuery[key] = val;
	            reserved = true;
	          }
	
	          if (!reserved) {
	            otherQuery[key] = val;
	          }
	        });
	      }
	
	    return {
	      cptQuery: cptQuery,
	      dataQuery: dataQuery,
	      otherQuery: otherQuery
	    };
	  },
	  filter: function (eventType, query, args) {
	    // They should be assigned before each trigger call.
	    var eventInfo = this.eventInfo;
	
	    if (!eventInfo) {
	      return true;
	    }
	
	    var targetEl = eventInfo.targetEl;
	    var packedEvent = eventInfo.packedEvent;
	    var model = eventInfo.model;
	    var view = eventInfo.view; // For event like 'globalout'.
	
	    if (!model || !view) {
	      return true;
	    }
	
	    var cptQuery = query.cptQuery;
	    var dataQuery = query.dataQuery;
	    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
	
	    function check(query, host, prop, propOnHost) {
	      return query[prop] == null || host[propOnHost || prop] === query[prop];
	    }
	  },
	  afterTrigger: function () {
	    // Make sure the eventInfo wont be used in next trigger.
	    this.eventInfo = null;
	  }
	};
	/**
	 * @type {Object} key: actionType.
	 * @inner
	 */
	
	var actions = {};
	/**
	 * Map eventType to actionType
	 * @type {Object}
	 */
	
	var eventActionMap = {};
	/**
	 * Data processor functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 * @inner
	 */
	
	var dataProcessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var optionPreprocessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var postUpdateFuncs = [];
	/**
	 * Visual encoding functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 */
	
	var visualFuncs = [];
	/**
	 * Theme storage
	 * @type {Object.<key, Object>}
	 */
	
	var themeStorage = {};
	/**
	 * Loading effects
	 */
	
	var loadingEffects = {};
	var instances = {};
	var connectedGroups = {};
	var idBase = new Date() - 0;
	var groupIdBase = new Date() - 0;
	var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
	
	function enableConnect(chart) {
	  var STATUS_PENDING = 0;
	  var STATUS_UPDATING = 1;
	  var STATUS_UPDATED = 2;
	  var STATUS_KEY = '__connectUpdateStatus';
	
	  function updateConnectedChartsStatus(charts, status) {
	    for (var i = 0; i < charts.length; i++) {
	      var otherChart = charts[i];
	      otherChart[STATUS_KEY] = status;
	    }
	  }
	
	  each(eventActionMap, function (actionType, eventType) {
	    chart._messageCenter.on(eventType, function (event) {
	      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
	        if (event && event.escapeConnect) {
	          return;
	        }
	
	        var action = chart.makeActionFromEvent(event);
	        var otherCharts = [];
	        each(instances, function (otherChart) {
	          if (otherChart !== chart && otherChart.group === chart.group) {
	            otherCharts.push(otherChart);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
	        each(otherCharts, function (otherChart) {
	          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
	            otherChart.dispatchAction(action);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
	      }
	    });
	  });
	}
	/**
	 * @param {HTMLElement} dom
	 * @param {Object} [theme]
	 * @param {Object} opts
	 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
	 * @param {string} [opts.renderer] Can choose 'canvas' or 'svg' to render the chart.
	 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
	 *                              Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
	 *                               Can be 'auto' (the same as null/undefined)
	 */
	
	
	function init(dom, theme, opts) {
	  var existInstance = getInstanceByDom(dom);
	
	  if (existInstance) {
	    return existInstance;
	  }
	
	  var chart = new ECharts(dom, theme, opts);
	  chart.id = 'ec_' + idBase++;
	  instances[chart.id] = chart;
	  modelUtil.setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
	  enableConnect(chart);
	  return chart;
	}
	/**
	 * @return {string|Array.<module:echarts~ECharts>} groupId
	 */
	
	
	function connect(groupId) {
	  // Is array of charts
	  if (zrUtil.isArray(groupId)) {
	    var charts = groupId;
	    groupId = null; // If any chart has group
	
	    each(charts, function (chart) {
	      if (chart.group != null) {
	        groupId = chart.group;
	      }
	    });
	    groupId = groupId || 'g_' + groupIdBase++;
	    each(charts, function (chart) {
	      chart.group = groupId;
	    });
	  }
	
	  connectedGroups[groupId] = true;
	  return groupId;
	}
	/**
	 * @DEPRECATED
	 * @return {string} groupId
	 */
	
	
	function disConnect(groupId) {
	  connectedGroups[groupId] = false;
	}
	/**
	 * @return {string} groupId
	 */
	
	
	var disconnect = disConnect;
	/**
	 * Dispose a chart instance
	 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
	 */
	
	function dispose(chart) {
	  if (typeof chart === 'string') {
	    chart = instances[chart];
	  } else if (!(chart instanceof ECharts)) {
	    // Try to treat as dom
	    chart = getInstanceByDom(chart);
	  }
	
	  if (chart instanceof ECharts && !chart.isDisposed()) {
	    chart.dispose();
	  }
	}
	/**
	 * @param  {HTMLElement} dom
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceByDom(dom) {
	  return instances[modelUtil.getAttribute(dom, DOM_ATTRIBUTE_KEY)];
	}
	/**
	 * @param {string} key
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceById(key) {
	  return instances[key];
	}
	/**
	 * Register theme
	 */
	
	
	function registerTheme(name, theme) {
	  themeStorage[name] = theme;
	}
	/**
	 * Register option preprocessor
	 * @param {Function} preprocessorFunc
	 */
	
	
	function registerPreprocessor(preprocessorFunc) {
	  optionPreprocessorFuncs.push(preprocessorFunc);
	}
	/**
	 * @param {number} [priority=1000]
	 * @param {Object|Function} processor
	 */
	
	
	function registerProcessor(priority, processor) {
	  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_FILTER);
	}
	/**
	 * Register postUpdater
	 * @param {Function} postUpdateFunc
	 */
	
	
	function registerPostUpdate(postUpdateFunc) {
	  postUpdateFuncs.push(postUpdateFunc);
	}
	/**
	 * Usage:
	 * registerAction('someAction', 'someEvent', function () { ... });
	 * registerAction('someAction', function () { ... });
	 * registerAction(
	 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
	 *     function () { ... }
	 * );
	 *
	 * @param {(string|Object)} actionInfo
	 * @param {string} actionInfo.type
	 * @param {string} [actionInfo.event]
	 * @param {string} [actionInfo.update]
	 * @param {string} [eventName]
	 * @param {Function} action
	 */
	
	
	function registerAction(actionInfo, eventName, action) {
	  if (typeof eventName === 'function') {
	    action = eventName;
	    eventName = '';
	  }
	
	  var actionType = isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
	    event: eventName
	  }][0]; // Event name is all lowercase
	
	  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
	  eventName = actionInfo.event; // Validate action type and event name.
	
	  assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));
	
	  if (!actions[actionType]) {
	    actions[actionType] = {
	      action: action,
	      actionInfo: actionInfo
	    };
	  }
	
	  eventActionMap[eventName] = actionType;
	}
	/**
	 * @param {string} type
	 * @param {*} CoordinateSystem
	 */
	
	
	function registerCoordinateSystem(type, CoordinateSystem) {
	  CoordinateSystemManager.register(type, CoordinateSystem);
	}
	/**
	 * Get dimensions of specified coordinate system.
	 * @param {string} type
	 * @return {Array.<string|Object>}
	 */
	
	
	function getCoordinateSystemDimensions(type) {
	  var coordSysCreator = CoordinateSystemManager.get(type);
	
	  if (coordSysCreator) {
	    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
	  }
	}
	/**
	 * Layout is a special stage of visual encoding
	 * Most visual encoding like color are common for different chart
	 * But each chart has it's own layout algorithm
	 *
	 * @param {number} [priority=1000]
	 * @param {Function} layoutTask
	 */
	
	
	function registerLayout(priority, layoutTask) {
	  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
	}
	/**
	 * @param {number} [priority=3000]
	 * @param {module:echarts/stream/Task} visualTask
	 */
	
	
	function registerVisual(priority, visualTask) {
	  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
	}
	/**
	 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
	 */
	
	
	function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
	  if (isFunction(priority) || isObject(priority)) {
	    fn = priority;
	    priority = defaultPriority;
	  }
	
	  var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
	  stageHandler.__prio = priority;
	  stageHandler.__raw = fn;
	  targetList.push(stageHandler);
	  return stageHandler;
	}
	/**
	 * @param {string} name
	 */
	
	
	function registerLoading(name, loadingFx) {
	  loadingEffects[name] = loadingFx;
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentModel(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentModel;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentView(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentView;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentView.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendSeriesModel(opts
	/*, superClass*/
	) {
	  // var Clazz = SeriesModel;
	  // if (superClass) {
	  //     superClass = 'series.' + superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return SeriesModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendChartView(opts
	/*, superClass*/
	) {
	  // var Clazz = ChartView;
	  // if (superClass) {
	  //     superClass = superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ChartView.getClass(classType.main, true);
	  // }
	  return ChartView.extend(opts);
	}
	/**
	 * ZRender need a canvas context to do measureText.
	 * But in node environment canvas may be created by node-canvas.
	 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
	 *
	 * Be careful of using it in the browser.
	 *
	 * @param {Function} creator
	 * @example
	 *     var Canvas = require('canvas');
	 *     var echarts = require('echarts');
	 *     echarts.setCanvasCreator(function () {
	 *         // Small size is enough.
	 *         return new Canvas(32, 32);
	 *     });
	 */
	
	
	function setCanvasCreator(creator) {
	  zrUtil.$override('createCanvas', creator);
	}
	/**
	 * @param {string} mapName
	 * @param {Array.<Object>|Object|string} geoJson
	 * @param {Object} [specialAreas]
	 *
	 * @example GeoJSON
	 *     $.get('USA.json', function (geoJson) {
	 *         echarts.registerMap('USA', geoJson);
	 *         // Or
	 *         echarts.registerMap('USA', {
	 *             geoJson: geoJson,
	 *             specialAreas: {}
	 *         })
	 *     });
	 *
	 *     $.get('airport.svg', function (svg) {
	 *         echarts.registerMap('airport', {
	 *             svg: svg
	 *         }
	 *     });
	 *
	 *     echarts.registerMap('eu', [
	 *         {svg: eu-topographic.svg},
	 *         {geoJSON: eu.json}
	 *     ])
	 */
	
	
	function registerMap(mapName, geoJson, specialAreas) {
	  mapDataStorage.registerMap(mapName, geoJson, specialAreas);
	}
	/**
	 * @param {string} mapName
	 * @return {Object}
	 */
	
	
	function getMap(mapName) {
	  // For backward compatibility, only return the first one.
	  var records = mapDataStorage.retrieveMap(mapName);
	  return records && records[0] && {
	    geoJson: records[0].geoJSON,
	    specialAreas: records[0].specialAreas
	  };
	}
	
	registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
	registerPreprocessor(backwardCompat);
	registerProcessor(PRIORITY_PROCESSOR_DATASTACK, dataStack);
	registerLoading('default', loadingDefault); // Default actions
	
	registerAction({
	  type: 'highlight',
	  event: 'highlight',
	  update: 'highlight'
	}, zrUtil.noop);
	registerAction({
	  type: 'downplay',
	  event: 'downplay',
	  update: 'downplay'
	}, zrUtil.noop); // Default theme
	
	registerTheme('light', lightTheme);
	registerTheme('dark', darkTheme); // For backward compatibility, where the namespace `dataTool` will
	// be mounted on `echarts` is the extension `dataTool` is imported.
	
	var dataTool = {};
	exports.version = version;
	exports.dependencies = dependencies;
	exports.PRIORITY = PRIORITY;
	exports.init = init;
	exports.connect = connect;
	exports.disConnect = disConnect;
	exports.disconnect = disconnect;
	exports.dispose = dispose;
	exports.getInstanceByDom = getInstanceByDom;
	exports.getInstanceById = getInstanceById;
	exports.registerTheme = registerTheme;
	exports.registerPreprocessor = registerPreprocessor;
	exports.registerProcessor = registerProcessor;
	exports.registerPostUpdate = registerPostUpdate;
	exports.registerAction = registerAction;
	exports.registerCoordinateSystem = registerCoordinateSystem;
	exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
	exports.registerLayout = registerLayout;
	exports.registerVisual = registerVisual;
	exports.registerLoading = registerLoading;
	exports.extendComponentModel = extendComponentModel;
	exports.extendComponentView = extendComponentView;
	exports.extendSeriesModel = extendSeriesModel;
	exports.extendChartView = extendChartView;
	exports.setCanvasCreator = setCanvasCreator;
	exports.registerMap = registerMap;
	exports.getMap = getMap;
	exports.dataTool = dataTool;
	var ___ec_export = __webpack_require__(852);
	(function () {
	    for (var key in ___ec_export) {
	        if (___ec_export.hasOwnProperty(key)) {
	            exports[key] = ___ec_export[key];
	        }
	    }
	})();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(7);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if ("function" === 'function' && _typeof(__webpack_require__(183)) === 'object' && __webpack_require__(183)) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	})();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if ("function" === 'function' && _typeof(__webpack_require__(183)) === 'object' && __webpack_require__(183)) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	})();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if ("function" === 'function' && _typeof(__webpack_require__(183)) === 'object' && __webpack_require__(183)) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	})();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "ConfigConsumer", {
	  enumerable: true,
	  get: function get() {
	    return _context.ConfigConsumer;
	  }
	});
	exports["default"] = exports.configConsumerProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _localeProvider = _interopRequireWildcard(__webpack_require__(574));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _context = __webpack_require__(231);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var configConsumerProps = ['getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader'];
	exports.configConsumerProps = configConsumerProps;
	
	var ConfigProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(ConfigProvider, _React$Component);
	
	  var _super = _createSuper(ConfigProvider);
	
	  function ConfigProvider() {
	    var _this;
	
	    _classCallCheck(this, ConfigProvider);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
	      var _this$props$prefixCls = _this.props.prefixCls,
	          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
	      if (customizePrefixCls) return customizePrefixCls;
	      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
	    };
	
	    _this.renderProvider = function (context, legacyLocale) {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          getPopupContainer = _this$props.getPopupContainer,
	          renderEmpty = _this$props.renderEmpty,
	          csp = _this$props.csp,
	          autoInsertSpaceInButton = _this$props.autoInsertSpaceInButton,
	          locale = _this$props.locale,
	          pageHeader = _this$props.pageHeader;
	
	      var config = _extends(_extends({}, context), {
	        getPrefixCls: _this.getPrefixCls,
	        csp: csp,
	        autoInsertSpaceInButton: autoInsertSpaceInButton
	      });
	
	      if (getPopupContainer) {
	        config.getPopupContainer = getPopupContainer;
	      }
	
	      if (renderEmpty) {
	        config.renderEmpty = renderEmpty;
	      }
	
	      if (pageHeader) {
	        config.pageHeader = pageHeader;
	      }
	
	      return (/*#__PURE__*/React.createElement(_context.ConfigContext.Provider, {
	          value: config
	        }, /*#__PURE__*/React.createElement(_localeProvider["default"], {
	          locale: locale || legacyLocale,
	          _ANT_MARK__: _localeProvider.ANT_MARK
	        }, children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(ConfigProvider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (_, __, legacyLocale) {
	          return (/*#__PURE__*/React.createElement(_context.ConfigConsumer, null, function (context) {
	              return _this2.renderProvider(context, legacyLocale);
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return ConfigProvider;
	}(React.Component);
	
	var _default = ConfigProvider;
	exports["default"] = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "ConfigConsumer", {
	  enumerable: true,
	  get: function get() {
	    return _context.ConfigConsumer;
	  }
	});
	exports["default"] = exports.configConsumerProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _localeProvider = _interopRequireWildcard(__webpack_require__(652));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _context = __webpack_require__(242);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var configConsumerProps = ['getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader'];
	exports.configConsumerProps = configConsumerProps;
	
	var ConfigProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(ConfigProvider, _React$Component);
	
	  var _super = _createSuper(ConfigProvider);
	
	  function ConfigProvider() {
	    var _this;
	
	    _classCallCheck(this, ConfigProvider);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
	      var _this$props$prefixCls = _this.props.prefixCls,
	          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
	      if (customizePrefixCls) return customizePrefixCls;
	      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
	    };
	
	    _this.renderProvider = function (context, legacyLocale) {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          getPopupContainer = _this$props.getPopupContainer,
	          renderEmpty = _this$props.renderEmpty,
	          csp = _this$props.csp,
	          autoInsertSpaceInButton = _this$props.autoInsertSpaceInButton,
	          locale = _this$props.locale,
	          pageHeader = _this$props.pageHeader;
	
	      var config = _extends(_extends({}, context), {
	        getPrefixCls: _this.getPrefixCls,
	        csp: csp,
	        autoInsertSpaceInButton: autoInsertSpaceInButton
	      });
	
	      if (getPopupContainer) {
	        config.getPopupContainer = getPopupContainer;
	      }
	
	      if (renderEmpty) {
	        config.renderEmpty = renderEmpty;
	      }
	
	      if (pageHeader) {
	        config.pageHeader = pageHeader;
	      }
	
	      return (/*#__PURE__*/React.createElement(_context.ConfigContext.Provider, {
	          value: config
	        }, /*#__PURE__*/React.createElement(_localeProvider["default"], {
	          locale: locale || legacyLocale,
	          _ANT_MARK__: _localeProvider.ANT_MARK
	        }, children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(ConfigProvider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (_, __, legacyLocale) {
	          return (/*#__PURE__*/React.createElement(_context.ConfigConsumer, null, function (context) {
	              return _this2.renderProvider(context, legacyLocale);
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return ConfigProvider;
	}(React.Component);
	
	var _default = ConfigProvider;
	exports["default"] = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "ConfigConsumer", {
	  enumerable: true,
	  get: function get() {
	    return _context.ConfigConsumer;
	  }
	});
	exports["default"] = exports.configConsumerProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _localeProvider = _interopRequireWildcard(__webpack_require__(754));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _context = __webpack_require__(255);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var configConsumerProps = ['getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader'];
	exports.configConsumerProps = configConsumerProps;
	
	var ConfigProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(ConfigProvider, _React$Component);
	
	  var _super = _createSuper(ConfigProvider);
	
	  function ConfigProvider() {
	    var _this;
	
	    _classCallCheck(this, ConfigProvider);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
	      var _this$props$prefixCls = _this.props.prefixCls,
	          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
	      if (customizePrefixCls) return customizePrefixCls;
	      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
	    };
	
	    _this.renderProvider = function (context, legacyLocale) {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          getPopupContainer = _this$props.getPopupContainer,
	          renderEmpty = _this$props.renderEmpty,
	          csp = _this$props.csp,
	          autoInsertSpaceInButton = _this$props.autoInsertSpaceInButton,
	          locale = _this$props.locale,
	          pageHeader = _this$props.pageHeader;
	
	      var config = _extends(_extends({}, context), {
	        getPrefixCls: _this.getPrefixCls,
	        csp: csp,
	        autoInsertSpaceInButton: autoInsertSpaceInButton
	      });
	
	      if (getPopupContainer) {
	        config.getPopupContainer = getPopupContainer;
	      }
	
	      if (renderEmpty) {
	        config.renderEmpty = renderEmpty;
	      }
	
	      if (pageHeader) {
	        config.pageHeader = pageHeader;
	      }
	
	      return (/*#__PURE__*/React.createElement(_context.ConfigContext.Provider, {
	          value: config
	        }, /*#__PURE__*/React.createElement(_localeProvider["default"], {
	          locale: locale || legacyLocale,
	          _ANT_MARK__: _localeProvider.ANT_MARK
	        }, children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(ConfigProvider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (_, __, legacyLocale) {
	          return (/*#__PURE__*/React.createElement(_context.ConfigConsumer, null, function (context) {
	              return _this2.renderProvider(context, legacyLocale);
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return ConfigProvider;
	}(React.Component);
	
	var _default = ConfigProvider;
	exports["default"] = _default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(11);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var pathTool = __webpack_require__(916);
	
	var colorTool = __webpack_require__(105);
	
	var matrix = __webpack_require__(75);
	
	var vector = __webpack_require__(49);
	
	var Path = __webpack_require__(55);
	
	var Transformable = __webpack_require__(284);
	
	var ZImage = __webpack_require__(181);
	
	exports.Image = ZImage;
	
	var Group = __webpack_require__(146);
	
	exports.Group = Group;
	
	var Text = __webpack_require__(147);
	
	exports.Text = Text;
	
	var Circle = __webpack_require__(911);
	
	exports.Circle = Circle;
	
	var Sector = __webpack_require__(2078);
	
	exports.Sector = Sector;
	
	var Ring = __webpack_require__(2077);
	
	exports.Ring = Ring;
	
	var Polygon = __webpack_require__(913);
	
	exports.Polygon = Polygon;
	
	var Polyline = __webpack_require__(914);
	
	exports.Polyline = Polyline;
	
	var Rect = __webpack_require__(452);
	
	exports.Rect = Rect;
	
	var Line = __webpack_require__(912);
	
	exports.Line = Line;
	
	var BezierCurve = __webpack_require__(2075);
	
	exports.BezierCurve = BezierCurve;
	
	var Arc = __webpack_require__(2074);
	
	exports.Arc = Arc;
	
	var CompoundPath = __webpack_require__(2070);
	
	exports.CompoundPath = CompoundPath;
	
	var LinearGradient = __webpack_require__(448);
	
	exports.LinearGradient = LinearGradient;
	
	var RadialGradient = __webpack_require__(2071);
	
	exports.RadialGradient = RadialGradient;
	
	var BoundingRect = __webpack_require__(51);
	
	exports.BoundingRect = BoundingRect;
	
	var IncrementalDisplayable = __webpack_require__(447);
	
	exports.IncrementalDisplayable = IncrementalDisplayable;
	
	var subPixelOptimizeUtil = __webpack_require__(451);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var EMPTY_OBJ = {};
	var Z2_EMPHASIS_LIFT = 1; // key: label model property nane, value: style property name.
	
	var CACHED_LABEL_STYLE_PROPERTIES = {
	  color: 'textFill',
	  textBorderColor: 'textStroke',
	  textBorderWidth: 'textStrokeWidth'
	};
	var EMPHASIS = 'emphasis';
	var NORMAL = 'normal'; // Reserve 0 as default.
	
	var _highlightNextDigit = 1;
	var _highlightKeyMap = {};
	var _customShapeMap = {};
	/**
	 * Extend shape with parameters
	 */
	
	function extendShape(opts) {
	  return Path.extend(opts);
	}
	/**
	 * Extend path
	 */
	
	
	function extendPath(pathData, opts) {
	  return pathTool.extendFromString(pathData, opts);
	}
	/**
	 * Register a user defined shape.
	 * The shape class can be fetched by `getShapeClass`
	 * This method will overwrite the registered shapes, including
	 * the registered built-in shapes, if using the same `name`.
	 * The shape can be used in `custom series` and
	 * `graphic component` by declaring `{type: name}`.
	 *
	 * @param {string} name
	 * @param {Object} ShapeClass Can be generated by `extendShape`.
	 */
	
	
	function registerShape(name, ShapeClass) {
	  _customShapeMap[name] = ShapeClass;
	}
	/**
	 * Find shape class registered by `registerShape`. Usually used in
	 * fetching user defined shape.
	 *
	 * [Caution]:
	 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
	 * to use user registered shapes.
	 * Because the built-in shape (see `getBuiltInShape`) will be registered by
	 * `registerShape` by default. That enables users to get both built-in
	 * shapes as well as the shapes belonging to themsleves. But users can overwrite
	 * the built-in shapes by using names like 'circle', 'rect' via calling
	 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
	 * in case that it is overwritten by users, except that some features, like
	 * `custom series`, `graphic component`, do it deliberately.
	 *
	 * (2) In the features like `custom series`, `graphic component`, the user input
	 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
	 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
	 * are reserved names, that is, if some user register a shape named `'image'`,
	 * the shape will not be used. If we intending to add some more reserved names
	 * in feature, that might bring break changes (disable some existing user shape
	 * names). But that case probably rearly happen. So we dont make more mechanism
	 * to resolve this issue here.
	 *
	 * @param {string} name
	 * @return {Object} The shape class. If not found, return nothing.
	 */
	
	
	function getShapeClass(name) {
	  if (_customShapeMap.hasOwnProperty(name)) {
	    return _customShapeMap[name];
	  }
	}
	/**
	 * Create a path element from path data string
	 * @param {string} pathData
	 * @param {Object} opts
	 * @param {module:zrender/core/BoundingRect} rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makePath(pathData, opts, rect, layout) {
	  var path = pathTool.createFromString(pathData, opts);
	
	  if (rect) {
	    if (layout === 'center') {
	      rect = centerGraphic(rect, path.getBoundingRect());
	    }
	
	    resizePath(path, rect);
	  }
	
	  return path;
	}
	/**
	 * Create a image element from image url
	 * @param {string} imageUrl image url
	 * @param {Object} opts options
	 * @param {module:zrender/core/BoundingRect} rect constrain rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makeImage(imageUrl, rect, layout) {
	  var path = new ZImage({
	    style: {
	      image: imageUrl,
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    onload: function (img) {
	      if (layout === 'center') {
	        var boundingRect = {
	          width: img.width,
	          height: img.height
	        };
	        path.setStyle(centerGraphic(rect, boundingRect));
	      }
	    }
	  });
	  return path;
	}
	/**
	 * Get position of centered element in bounding box.
	 *
	 * @param  {Object} rect         element local bounding box
	 * @param  {Object} boundingRect constraint bounding box
	 * @return {Object} element position containing x, y, width, and height
	 */
	
	
	function centerGraphic(rect, boundingRect) {
	  // Set rect to center, keep width / height ratio.
	  var aspect = boundingRect.width / boundingRect.height;
	  var width = rect.height * aspect;
	  var height;
	
	  if (width <= rect.width) {
	    height = rect.height;
	  } else {
	    width = rect.width;
	    height = width / aspect;
	  }
	
	  var cx = rect.x + rect.width / 2;
	  var cy = rect.y + rect.height / 2;
	  return {
	    x: cx - width / 2,
	    y: cy - height / 2,
	    width: width,
	    height: height
	  };
	}
	
	var mergePath = pathTool.mergePath;
	/**
	 * Resize a path to fit the rect
	 * @param {module:zrender/graphic/Path} path
	 * @param {Object} rect
	 */
	
	function resizePath(path, rect) {
	  if (!path.applyTransform) {
	    return;
	  }
	
	  var pathRect = path.getBoundingRect();
	  var m = pathRect.calculateTransform(rect);
	  path.applyTransform(m);
	}
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x1]
	 * @param {number} [param.shape.y1]
	 * @param {number} [param.shape.x2]
	 * @param {number} [param.shape.y2]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeLine(param) {
	  subPixelOptimizeUtil.subPixelOptimizeLine(param.shape, param.shape, param.style);
	  return param;
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x]
	 * @param {number} [param.shape.y]
	 * @param {number} [param.shape.width]
	 * @param {number} [param.shape.height]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeRect(param) {
	  subPixelOptimizeUtil.subPixelOptimizeRect(param.shape, param.shape, param.style);
	  return param;
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth Should be nonnegative integer.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	var subPixelOptimize = subPixelOptimizeUtil.subPixelOptimize;
	
	function hasFillOrStroke(fillOrStroke) {
	  return fillOrStroke != null && fillOrStroke !== 'none';
	} // Most lifted color are duplicated.
	
	
	var liftedColorMap = zrUtil.createHashMap();
	var liftedColorCount = 0;
	
	function liftColor(color) {
	  if (typeof color !== 'string') {
	    return color;
	  }
	
	  var liftedColor = liftedColorMap.get(color);
	
	  if (!liftedColor) {
	    liftedColor = colorTool.lift(color, -0.1);
	
	    if (liftedColorCount < 10000) {
	      liftedColorMap.set(color, liftedColor);
	      liftedColorCount++;
	    }
	  }
	
	  return liftedColor;
	}
	
	function cacheElementStl(el) {
	  if (!el.__hoverStlDirty) {
	    return;
	  }
	
	  el.__hoverStlDirty = false;
	  var hoverStyle = el.__hoverStl;
	
	  if (!hoverStyle) {
	    el.__cachedNormalStl = el.__cachedNormalZ2 = null;
	    return;
	  }
	
	  var normalStyle = el.__cachedNormalStl = {};
	  el.__cachedNormalZ2 = el.z2;
	  var elStyle = el.style;
	
	  for (var name in hoverStyle) {
	    // See comment in `singleEnterEmphasis`.
	    if (hoverStyle[name] != null) {
	      normalStyle[name] = elStyle[name];
	    }
	  } // Always cache fill and stroke to normalStyle for lifting color.
	
	
	  normalStyle.fill = elStyle.fill;
	  normalStyle.stroke = elStyle.stroke;
	}
	
	function singleEnterEmphasis(el) {
	  var hoverStl = el.__hoverStl;
	
	  if (!hoverStl || el.__highlighted) {
	    return;
	  }
	
	  var zr = el.__zr;
	  var useHoverLayer = el.useHoverLayer && zr && zr.painter.type === 'canvas';
	  el.__highlighted = useHoverLayer ? 'layer' : 'plain';
	
	  if (el.isGroup || !zr && el.useHoverLayer) {
	    return;
	  }
	
	  var elTarget = el;
	  var targetStyle = el.style;
	
	  if (useHoverLayer) {
	    elTarget = zr.addHover(el);
	    targetStyle = elTarget.style;
	  }
	
	  rollbackDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    cacheElementStl(elTarget);
	  } // styles can be:
	  // {
	  //    label: {
	  //        show: false,
	  //        position: 'outside',
	  //        fontSize: 18
	  //    },
	  //    emphasis: {
	  //        label: {
	  //            show: true
	  //        }
	  //    }
	  // },
	  // where properties of `emphasis` may not appear in `normal`. We previously use
	  // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
	  // But consider rich text and setOption in merge mode, it is impossible to cover
	  // all properties in merge. So we use merge mode when setting style here.
	  // But we choose the merge strategy that only properties that is not `null/undefined`.
	  // Because when making a textStyle (espacially rich text), it is not easy to distinguish
	  // `hasOwnProperty` and `null/undefined` in code, so we trade them as the same for simplicity.
	  // But this strategy brings a trouble that `null/undefined` can not be used to remove
	  // style any more in `emphasis`. Users can both set properties directly on normal and
	  // emphasis to avoid this issue, or we might support `'none'` for this case if required.
	
	
	  targetStyle.extendFrom(hoverStl);
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'fill');
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'stroke');
	  applyDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    el.dirty(false);
	    el.z2 += Z2_EMPHASIS_LIFT;
	  }
	}
	
	function setDefaultHoverFillStroke(targetStyle, hoverStyle, prop) {
	  if (!hasFillOrStroke(hoverStyle[prop]) && hasFillOrStroke(targetStyle[prop])) {
	    targetStyle[prop] = liftColor(targetStyle[prop]);
	  }
	}
	
	function singleEnterNormal(el) {
	  var highlighted = el.__highlighted;
	
	  if (!highlighted) {
	    return;
	  }
	
	  el.__highlighted = false;
	
	  if (el.isGroup) {
	    return;
	  }
	
	  if (highlighted === 'layer') {
	    el.__zr && el.__zr.removeHover(el);
	  } else {
	    var style = el.style;
	    var normalStl = el.__cachedNormalStl;
	
	    if (normalStl) {
	      rollbackDefaultTextStyle(style);
	      el.setStyle(normalStl);
	      applyDefaultTextStyle(style);
	    } // `__cachedNormalZ2` will not be reset if calling `setElementHoverStyle`
	    // when `el` is on emphasis state. So here by comparing with 1, we try
	    // hard to make the bug case rare.
	
	
	    var normalZ2 = el.__cachedNormalZ2;
	
	    if (normalZ2 != null && el.z2 - normalZ2 === Z2_EMPHASIS_LIFT) {
	      el.z2 = normalZ2;
	    }
	  }
	}
	
	function traverseUpdate(el, updater, commonParam) {
	  // If root is group, also enter updater for `highDownOnUpdate`.
	  var fromState = NORMAL;
	  var toState = NORMAL;
	  var trigger; // See the rule of `highDownOnUpdate` on `graphic.setAsHighDownDispatcher`.
	
	  el.__highlighted && (fromState = EMPHASIS, trigger = true);
	  updater(el, commonParam);
	  el.__highlighted && (toState = EMPHASIS, trigger = true);
	  el.isGroup && el.traverse(function (child) {
	    !child.isGroup && updater(child, commonParam);
	  });
	  trigger && el.__highDownOnUpdate && el.__highDownOnUpdate(fromState, toState);
	}
	/**
	 * Set hover style (namely "emphasis style") of element, based on the current
	 * style of the given `el`.
	 * This method should be called after all of the normal styles have been adopted
	 * to the `el`. See the reason on `setHoverStyle`.
	 *
	 * @param {module:zrender/Element} el Should not be `zrender/container/Group`.
	 * @param {Object} [el.hoverStyle] Can be set on el or its descendants,
	 *        e.g., `el.hoverStyle = ...; graphic.setHoverStyle(el); `.
	 *        Often used when item group has a label element and it's hoverStyle is different.
	 * @param {Object|boolean} [hoverStl] The specified hover style.
	 *        If set as `false`, disable the hover style.
	 *        Similarly, The `el.hoverStyle` can alse be set
	 *        as `false` to disable the hover style.
	 *        Otherwise, use the default hover style if not provided.
	 */
	
	
	function setElementHoverStyle(el, hoverStl) {
	  // For performance consideration, it might be better to make the "hover style" only the
	  // difference properties from the "normal style", but not a entire copy of all styles.
	  hoverStl = el.__hoverStl = hoverStl !== false && (el.hoverStyle || hoverStl || {});
	  el.__hoverStlDirty = true; // FIXME
	  // It is not completely right to save "normal"/"emphasis" flag on elements.
	  // It probably should be saved on `data` of series. Consider the cases:
	  // (1) A highlighted elements are moved out of the view port and re-enter
	  // again by dataZoom.
	  // (2) call `setOption` and replace elements totally when they are highlighted.
	
	  if (el.__highlighted) {
	    // Consider the case:
	    // The styles of a highlighted `el` is being updated. The new "emphasis style"
	    // should be adapted to the `el`. Notice here new "normal styles" should have
	    // been set outside and the cached "normal style" is out of date.
	    el.__cachedNormalStl = null; // Do not clear `__cachedNormalZ2` here, because setting `z2` is not a constraint
	    // of this method. In most cases, `z2` is not set and hover style should be able
	    // to rollback. Of course, that would bring bug, but only in a rare case, see
	    // `doSingleLeaveHover` for details.
	
	    singleEnterNormal(el);
	    singleEnterEmphasis(el);
	  }
	}
	
	function onElementMouseOver(e) {
	  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
	  && !this.__highByOuter && traverseUpdate(this, singleEnterEmphasis);
	}
	
	function onElementMouseOut(e) {
	  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
	  && !this.__highByOuter && traverseUpdate(this, singleEnterNormal);
	}
	
	function onElementEmphasisEvent(highlightDigit) {
	  this.__highByOuter |= 1 << (highlightDigit || 0);
	  traverseUpdate(this, singleEnterEmphasis);
	}
	
	function onElementNormalEvent(highlightDigit) {
	  !(this.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdate(this, singleEnterNormal);
	}
	
	function shouldSilent(el, e) {
	  return el.__highDownSilentOnTouch && e.zrByTouch;
	}
	/**
	 * Set hover style (namely "emphasis style") of element,
	 * based on the current style of the given `el`.
	 *
	 * (1)
	 * **CONSTRAINTS** for this method:
	 * <A> This method MUST be called after all of the normal styles having been adopted
	 * to the `el`.
	 * <B> The input `hoverStyle` (that is, "emphasis style") MUST be the subset of the
	 * "normal style" having been set to the el.
	 * <C> `color` MUST be one of the "normal styles" (because color might be lifted as
	 * a default hover style).
	 *
	 * The reason: this method treat the current style of the `el` as the "normal style"
	 * and cache them when enter/update the "emphasis style". Consider the case: the `el`
	 * is in "emphasis" state and `setOption`/`dispatchAction` trigger the style updating
	 * logic, where the el should shift from the original emphasis style to the new
	 * "emphasis style" and should be able to "downplay" back to the new "normal style".
	 *
	 * Indeed, it is error-prone to make a interface has so many constraints, but I have
	 * not found a better solution yet to fit the backward compatibility, performance and
	 * the current programming style.
	 *
	 * (2)
	 * Call the method for a "root" element once. Do not call it for each descendants.
	 * If the descendants elemenets of a group has itself hover style different from the
	 * root group, we can simply mount the style on `el.hoverStyle` for them, but should
	 * not call this method for them.
	 *
	 * (3) These input parameters can be set directly on `el`:
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} [el.hoverStyle] See `graphic.setElementHoverStyle`.
	 * @param {boolean} [el.highDownSilentOnTouch=false] See `graphic.setAsHighDownDispatcher`.
	 * @param {Function} [el.highDownOnUpdate] See `graphic.setAsHighDownDispatcher`.
	 * @param {Object|boolean} [hoverStyle] See `graphic.setElementHoverStyle`.
	 */
	
	
	function setHoverStyle(el, hoverStyle) {
	  setAsHighDownDispatcher(el, true);
	  traverseUpdate(el, setElementHoverStyle, hoverStyle);
	}
	/**
	 * @param {module:zrender/Element} el
	 * @param {Function} [el.highDownOnUpdate] Called when state updated.
	 *        Since `setHoverStyle` has the constraint that it must be called after
	 *        all of the normal style updated, `highDownOnUpdate` is not needed to
	 *        trigger if both `fromState` and `toState` is 'normal', and needed to
	 *        trigger if both `fromState` and `toState` is 'emphasis', which enables
	 *        to sync outside style settings to "emphasis" state.
	 *        @this {string} This dispatcher `el`.
	 *        @param {string} fromState Can be "normal" or "emphasis".
	 *               `fromState` might equal to `toState`,
	 *               for example, when this method is called when `el` is
	 *               on "emphasis" state.
	 *        @param {string} toState Can be "normal" or "emphasis".
	 *
	 *        FIXME
	 *        CAUTION: Do not expose `highDownOnUpdate` outside echarts.
	 *        Because it is not a complete solution. The update
	 *        listener should not have been mount in element,
	 *        and the normal/emphasis state should not have
	 *        mantained on elements.
	 *
	 * @param {boolean} [el.highDownSilentOnTouch=false]
	 *        In touch device, mouseover event will be trigger on touchstart event
	 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
	 *        conveniently use hoverStyle when tap on touch screen without additional
	 *        code for compatibility.
	 *        But if the chart/component has select feature, which usually also use
	 *        hoverStyle, there might be conflict between 'select-highlight' and
	 *        'hover-highlight' especially when roam is enabled (see geo for example).
	 *        In this case, `highDownSilentOnTouch` should be used to disable
	 *        hover-highlight on touch device.
	 * @param {boolean} [asDispatcher=true] If `false`, do not set as "highDownDispatcher".
	 */
	
	
	function setAsHighDownDispatcher(el, asDispatcher) {
	  var disable = asDispatcher === false; // Make `highDownSilentOnTouch` and `highDownOnUpdate` only work after
	  // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
	
	  el.__highDownSilentOnTouch = el.highDownSilentOnTouch;
	  el.__highDownOnUpdate = el.highDownOnUpdate; // Simple optimize, since this method might be
	  // called for each elements of a group in some cases.
	
	  if (!disable || el.__highDownDispatcher) {
	    var method = disable ? 'off' : 'on'; // Duplicated function will be auto-ignored, see Eventful.js.
	
	    el[method]('mouseover', onElementMouseOver)[method]('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually by API or other components like hover link.
	
	    el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent); // Also keep previous record.
	
	    el.__highByOuter = el.__highByOuter || 0;
	    el.__highDownDispatcher = !disable;
	  }
	}
	/**
	 * @param {module:zrender/src/Element} el
	 * @return {boolean}
	 */
	
	
	function isHighDownDispatcher(el) {
	  return !!(el && el.__highDownDispatcher);
	}
	/**
	 * Support hightlight/downplay record on each elements.
	 * For the case: hover highlight/downplay (legend, visualMap, ...) and
	 * user triggerred hightlight/downplay should not conflict.
	 * Only all of the highlightDigit cleared, return to normal.
	 * @param {string} highlightKey
	 * @return {number} highlightDigit
	 */
	
	
	function getHighlightDigit(highlightKey) {
	  var highlightDigit = _highlightKeyMap[highlightKey];
	
	  if (highlightDigit == null && _highlightNextDigit <= 32) {
	    highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
	  }
	
	  return highlightDigit;
	}
	/**
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} normalStyle
	 * @param {Object} emphasisStyle
	 * @param {module:echarts/model/Model} normalModel
	 * @param {module:echarts/model/Model} emphasisModel
	 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
	 * @param {string|Function} [opt.defaultText]
	 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
	 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {number} [opt.labelDataIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {number} [opt.labelDimIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {string} [opt.labelProp] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {Object} [normalSpecified]
	 * @param {Object} [emphasisSpecified]
	 */
	
	
	function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
	  opt = opt || EMPTY_OBJ;
	  var labelFetcher = opt.labelFetcher;
	  var labelDataIndex = opt.labelDataIndex;
	  var labelDimIndex = opt.labelDimIndex;
	  var labelProp = opt.labelProp; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
	  // is not supported util someone requests.
	
	  var showNormal = normalModel.getShallow('show');
	  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
	  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
	  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.
	
	  var baseText;
	
	  if (showNormal || showEmphasis) {
	    if (labelFetcher) {
	      baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, labelProp);
	    }
	
	    if (baseText == null) {
	      baseText = zrUtil.isFunction(opt.defaultText) ? opt.defaultText(labelDataIndex, opt) : opt.defaultText;
	    }
	  }
	
	  var normalStyleText = showNormal ? baseText : null;
	  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex, labelProp) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.
	
	  if (normalStyleText != null || emphasisStyleText != null) {
	    // Always set `textStyle` even if `normalStyle.text` is null, because default
	    // values have to be set on `normalStyle`.
	    // If we set default values on `emphasisStyle`, consider case:
	    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
	    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
	    // Then the 'red' will not work on emphasis.
	    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
	    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
	  }
	
	  normalStyle.text = normalStyleText;
	  emphasisStyle.text = emphasisStyleText;
	}
	/**
	 * Modify label style manually.
	 * Only works after `setLabelStyle` and `setElementHoverStyle` called.
	 *
	 * @param {module:zrender/src/Element} el
	 * @param {Object} [normalStyleProps] optional
	 * @param {Object} [emphasisStyleProps] optional
	 */
	
	
	function modifyLabelStyle(el, normalStyleProps, emphasisStyleProps) {
	  var elStyle = el.style;
	
	  if (normalStyleProps) {
	    rollbackDefaultTextStyle(elStyle);
	    el.setStyle(normalStyleProps);
	    applyDefaultTextStyle(elStyle);
	  }
	
	  elStyle = el.__hoverStl;
	
	  if (emphasisStyleProps && elStyle) {
	    rollbackDefaultTextStyle(elStyle);
	    zrUtil.extend(elStyle, emphasisStyleProps);
	    applyDefaultTextStyle(elStyle);
	  }
	}
	/**
	 * Set basic textStyle properties.
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} textStyle
	 * @param {module:echarts/model/Model} model
	 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
	 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
	 * @param {boolean} [isEmphasis]
	 */
	
	
	function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
	  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
	  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	
	  return textStyle;
	}
	/**
	 * Set text option in the style.
	 * See more info in `setTextStyleCommon`.
	 * @deprecated
	 * @param {Object} textStyle
	 * @param {module:echarts/model/Model} labelModel
	 * @param {string|boolean} defaultColor Default text color.
	 *        If set as false, it will be processed as a emphasis style.
	 */
	
	
	function setText(textStyle, labelModel, defaultColor) {
	  var opt = {
	    isRectText: true
	  };
	  var isEmphasis;
	
	  if (defaultColor === false) {
	    isEmphasis = true;
	  } else {
	    // Support setting color as 'auto' to get visual color.
	    opt.autoColor = defaultColor;
	  }
	
	  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	}
	/**
	 * The uniform entry of set text style, that is, retrieve style definitions
	 * from `model` and set to `textStyle` object.
	 *
	 * Never in merge mode, but in overwrite mode, that is, all of the text style
	 * properties will be set. (Consider the states of normal and emphasis and
	 * default value can be adopted, merge would make the logic too complicated
	 * to manage.)
	 *
	 * The `textStyle` object can either be a plain object or an instance of
	 * `zrender/src/graphic/Style`, and either be the style of normal or emphasis.
	 * After this mothod called, the `textStyle` object can then be used in
	 * `el.setStyle(textStyle)` or `el.hoverStyle = textStyle`.
	 *
	 * Default value will be adopted and `insideRollbackOpt` will be created.
	 * See `applyDefaultTextStyle` `rollbackDefaultTextStyle` for more details.
	 *
	 * opt: {
	 *      disableBox: boolean, Whether diable drawing box of block (outer most).
	 *      isRectText: boolean,
	 *      autoColor: string, specify a color when color is 'auto',
	 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
	 *              If autoColor specified, it is used as default textFill.
	 *      useInsideStyle:
	 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
	 *                  if `textFill` is not specified.
	 *              `false`: Do not use inside style.
	 *              `null/undefined`: use inside style if `isRectText` is true and
	 *                  `textFill` is not specified and textPosition contains `'inside'`.
	 *      forceRich: boolean
	 * }
	 */
	
	
	function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
	  // Consider there will be abnormal when merge hover style to normal style if given default value.
	  opt = opt || EMPTY_OBJ;
	
	  if (opt.isRectText) {
	    var textPosition;
	
	    if (opt.getTextPosition) {
	      textPosition = opt.getTextPosition(textStyleModel, isEmphasis);
	    } else {
	      textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
	      // in bar series, and magric type should be considered.
	
	      textPosition === 'outside' && (textPosition = 'top');
	    }
	
	    textStyle.textPosition = textPosition;
	    textStyle.textOffset = textStyleModel.getShallow('offset');
	    var labelRotate = textStyleModel.getShallow('rotate');
	    labelRotate != null && (labelRotate *= Math.PI / 180);
	    textStyle.textRotation = labelRotate;
	    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
	  }
	
	  var ecModel = textStyleModel.ecModel;
	  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
	  // {
	  //     data: [{
	  //         value: 12,
	  //         label: {
	  //             rich: {
	  //                 // no 'a' here but using parent 'a'.
	  //             }
	  //         }
	  //     }],
	  //     rich: {
	  //         a: { ... }
	  //     }
	  // }
	
	  var richItemNames = getRichItemNames(textStyleModel);
	  var richResult;
	
	  if (richItemNames) {
	    richResult = {};
	
	    for (var name in richItemNames) {
	      if (richItemNames.hasOwnProperty(name)) {
	        // Cascade is supported in rich.
	        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.
	        // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
	        // the default color `'blue'` will not be adopted if no color declared in `rich`.
	        // That might confuses users. So probably we should put `textStyleModel` as the
	        // root ancestor of the `richTextStyle`. But that would be a break change.
	
	        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
	      }
	    }
	  }
	
	  textStyle.rich = richResult;
	  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);
	
	  if (opt.forceRich && !opt.textStyle) {
	    opt.textStyle = {};
	  }
	
	  return textStyle;
	} // Consider case:
	// {
	//     data: [{
	//         value: 12,
	//         label: {
	//             rich: {
	//                 // no 'a' here but using parent 'a'.
	//             }
	//         }
	//     }],
	//     rich: {
	//         a: { ... }
	//     }
	// }
	
	
	function getRichItemNames(textStyleModel) {
	  // Use object to remove duplicated names.
	  var richItemNameMap;
	
	  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
	    var rich = (textStyleModel.option || EMPTY_OBJ).rich;
	
	    if (rich) {
	      richItemNameMap = richItemNameMap || {};
	
	      for (var name in rich) {
	        if (rich.hasOwnProperty(name)) {
	          richItemNameMap[name] = 1;
	        }
	      }
	    }
	
	    textStyleModel = textStyleModel.parentModel;
	  }
	
	  return richItemNameMap;
	}
	
	function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
	  // In merge mode, default value should not be given.
	  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
	  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
	  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
	  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
	
	  if (!isEmphasis) {
	    if (isBlock) {
	      textStyle.insideRollbackOpt = opt;
	      applyDefaultTextStyle(textStyle);
	    } // Set default finally.
	
	
	    if (textStyle.textFill == null) {
	      textStyle.textFill = opt.autoColor;
	    }
	  } // Do not use `getFont` here, because merge should be supported, where
	  // part of these properties may be changed in emphasis style, and the
	  // others should remain their original value got from normal style.
	
	
	  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
	  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
	  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
	  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
	  textStyle.textAlign = textStyleModel.getShallow('align');
	  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
	  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
	  textStyle.textWidth = textStyleModel.getShallow('width');
	  textStyle.textHeight = textStyleModel.getShallow('height');
	  textStyle.textTag = textStyleModel.getShallow('tag');
	
	  if (!isBlock || !opt.disableBox) {
	    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
	    textStyle.textPadding = textStyleModel.getShallow('padding');
	    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
	    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
	    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
	    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
	    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
	    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
	    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
	  }
	
	  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
	  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
	  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
	  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
	}
	
	function getAutoColor(color, opt) {
	  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
	}
	/**
	 * Give some default value to the input `textStyle` object, based on the current settings
	 * in this `textStyle` object.
	 *
	 * The Scenario:
	 * when text position is `inside` and `textFill` is not specified, we show
	 * text border by default for better view. But it should be considered that text position
	 * might be changed when hovering or being emphasis, where the `insideRollback` is used to
	 * restore the style.
	 *
	 * Usage (& NOTICE):
	 * When a style object (eithor plain object or instance of `zrender/src/graphic/Style`) is
	 * about to be modified on its text related properties, `rollbackDefaultTextStyle` should
	 * be called before the modification and `applyDefaultTextStyle` should be called after that.
	 * (For the case that all of the text related properties is reset, like `setTextStyleCommon`
	 * does, `rollbackDefaultTextStyle` is not needed to be called).
	 */
	
	
	function applyDefaultTextStyle(textStyle) {
	  var textPosition = textStyle.textPosition;
	  var opt = textStyle.insideRollbackOpt;
	  var insideRollback;
	
	  if (opt && textStyle.textFill == null) {
	    var autoColor = opt.autoColor;
	    var isRectText = opt.isRectText;
	    var useInsideStyle = opt.useInsideStyle;
	    var useInsideStyleCache = useInsideStyle !== false && (useInsideStyle === true || isRectText && textPosition // textPosition can be [10, 30]
	    && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0);
	    var useAutoColorCache = !useInsideStyleCache && autoColor != null; // All of the props declared in `CACHED_LABEL_STYLE_PROPERTIES` are to be cached.
	
	    if (useInsideStyleCache || useAutoColorCache) {
	      insideRollback = {
	        textFill: textStyle.textFill,
	        textStroke: textStyle.textStroke,
	        textStrokeWidth: textStyle.textStrokeWidth
	      };
	    }
	
	    if (useInsideStyleCache) {
	      textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.
	
	      if (textStyle.textStroke == null) {
	        textStyle.textStroke = autoColor;
	        textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
	      }
	    }
	
	    if (useAutoColorCache) {
	      textStyle.textFill = autoColor;
	    }
	  } // Always set `insideRollback`, so that the previous one can be cleared.
	
	
	  textStyle.insideRollback = insideRollback;
	}
	/**
	 * Consider the case: in a scatter,
	 * label: {
	 *     normal: {position: 'inside'},
	 *     emphasis: {position: 'top'}
	 * }
	 * In the normal state, the `textFill` will be set as '#fff' for pretty view (see
	 * `applyDefaultTextStyle`), but when switching to emphasis state, the `textFill`
	 * should be retured to 'autoColor', but not keep '#fff'.
	 */
	
	
	function rollbackDefaultTextStyle(style) {
	  var insideRollback = style.insideRollback;
	
	  if (insideRollback) {
	    // Reset all of the props in `CACHED_LABEL_STYLE_PROPERTIES`.
	    style.textFill = insideRollback.textFill;
	    style.textStroke = insideRollback.textStroke;
	    style.textStrokeWidth = insideRollback.textStrokeWidth;
	    style.insideRollback = null;
	  }
	}
	
	function getFont(opt, ecModel) {
	  var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
	  return zrUtil.trim([// FIXME in node-canvas fontWeight is before fontStyle
	  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
	}
	
	function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
	  if (typeof dataIndex === 'function') {
	    cb = dataIndex;
	    dataIndex = null;
	  } // Do not check 'animation' property directly here. Consider this case:
	  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
	  // but its parent model (`seriesModel`) does.
	
	
	  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
	
	  if (animationEnabled) {
	    var postfix = isUpdate ? 'Update' : '';
	    var duration = animatableModel.getShallow('animationDuration' + postfix);
	    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
	    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);
	
	    if (typeof animationDelay === 'function') {
	      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
	    }
	
	    if (typeof duration === 'function') {
	      duration = duration(dataIndex);
	    }
	
	    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
	  } else {
	    el.stopAnimation();
	    el.attr(props);
	    cb && cb();
	  }
	}
	/**
	 * Update graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} [cb]
	 * @example
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
	 *     // Or
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, function () { console.log('Animation done!'); });
	 */
	
	
	function updateProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Init graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} cb
	 */
	
	
	function initProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Get transform matrix of target (param target),
	 * in coordinate of its ancestor (param ancestor)
	 *
	 * @param {module:zrender/mixin/Transformable} target
	 * @param {module:zrender/mixin/Transformable} [ancestor]
	 */
	
	
	function getTransform(target, ancestor) {
	  var mat = matrix.identity([]);
	
	  while (target && target !== ancestor) {
	    matrix.mul(mat, target.getLocalTransform(), mat);
	    target = target.parent;
	  }
	
	  return mat;
	}
	/**
	 * Apply transform to an vertex.
	 * @param {Array.<number>} target [x, y]
	 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
	 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
	 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {Array.<number>} [x, y]
	 */
	
	
	function applyTransform(target, transform, invert) {
	  if (transform && !zrUtil.isArrayLike(transform)) {
	    transform = Transformable.getLocalTransform(transform);
	  }
	
	  if (invert) {
	    transform = matrix.invert([], transform);
	  }
	
	  return vector.applyTransform([], target, transform);
	}
	/**
	 * @param {string} direction 'left' 'right' 'top' 'bottom'
	 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
	 */
	
	
	function transformDirection(direction, transform, invert) {
	  // Pick a base, ensure that transform result will not be (0, 0).
	  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
	  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
	  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
	  vertex = applyTransform(vertex, transform, invert);
	  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
	}
	/**
	 * Apply group transition animation from g1 to g2.
	 * If no animatableModel, no animation.
	 */
	
	
	function groupTransition(g1, g2, animatableModel, cb) {
	  if (!g1 || !g2) {
	    return;
	  }
	
	  function getElMap(g) {
	    var elMap = {};
	    g.traverse(function (el) {
	      if (!el.isGroup && el.anid) {
	        elMap[el.anid] = el;
	      }
	    });
	    return elMap;
	  }
	
	  function getAnimatableProps(el) {
	    var obj = {
	      position: vector.clone(el.position),
	      rotation: el.rotation
	    };
	
	    if (el.shape) {
	      obj.shape = zrUtil.extend({}, el.shape);
	    }
	
	    return obj;
	  }
	
	  var elMap1 = getElMap(g1);
	  g2.traverse(function (el) {
	    if (!el.isGroup && el.anid) {
	      var oldEl = elMap1[el.anid];
	
	      if (oldEl) {
	        var newProp = getAnimatableProps(el);
	        el.attr(getAnimatableProps(oldEl));
	        updateProps(el, newProp, animatableModel, el.dataIndex);
	      } // else {
	      //     if (el.previousProps) {
	      //         graphic.updateProps
	      //     }
	      // }
	
	    }
	  });
	}
	/**
	 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
	 * @param {Object} rect {x, y, width, height}
	 * @return {Array.<Array.<number>>} A new clipped points.
	 */
	
	
	function clipPointsByRect(points, rect) {
	  // FIXME: this way migth be incorrect when grpahic clipped by a corner.
	  // and when element have border.
	  return zrUtil.map(points, function (point) {
	    var x = point[0];
	    x = mathMax(x, rect.x);
	    x = mathMin(x, rect.x + rect.width);
	    var y = point[1];
	    y = mathMax(y, rect.y);
	    y = mathMin(y, rect.y + rect.height);
	    return [x, y];
	  });
	}
	/**
	 * @param {Object} targetRect {x, y, width, height}
	 * @param {Object} rect {x, y, width, height}
	 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
	 */
	
	
	function clipRectByRect(targetRect, rect) {
	  var x = mathMax(targetRect.x, rect.x);
	  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
	  var y = mathMax(targetRect.y, rect.y);
	  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
	  // should be painted. So return undefined.
	
	  if (x2 >= x && y2 >= y) {
	    return {
	      x: x,
	      y: y,
	      width: x2 - x,
	      height: y2 - y
	    };
	  }
	}
	/**
	 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
	 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
	 * @param {Object} [rect] {x, y, width, height}
	 * @return {module:zrender/Element} Icon path or image element.
	 */
	
	
	function createIcon(iconStr, opt, rect) {
	  opt = zrUtil.extend({
	    rectHover: true
	  }, opt);
	  var style = opt.style = {
	    strokeNoScale: true
	  };
	  rect = rect || {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  };
	
	  if (iconStr) {
	    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new ZImage(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
	  }
	}
	/**
	 * Return `true` if the given line (line `a`) and the given polygon
	 * are intersect.
	 * Note that we do not count colinear as intersect here because no
	 * requirement for that. We could do that if required in future.
	 *
	 * @param {number} a1x
	 * @param {number} a1y
	 * @param {number} a2x
	 * @param {number} a2y
	 * @param {Array.<Array.<number>>} points Points of the polygon.
	 * @return {boolean}
	 */
	
	
	function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
	  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
	    var p = points[i];
	
	    if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
	      return true;
	    }
	
	    p2 = p;
	  }
	}
	/**
	 * Return `true` if the given two lines (line `a` and line `b`)
	 * are intersect.
	 * Note that we do not count colinear as intersect here because no
	 * requirement for that. We could do that if required in future.
	 *
	 * @param {number} a1x
	 * @param {number} a1y
	 * @param {number} a2x
	 * @param {number} a2y
	 * @param {number} b1x
	 * @param {number} b1y
	 * @param {number} b2x
	 * @param {number} b2y
	 * @return {boolean}
	 */
	
	
	function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
	  // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
	  var mx = a2x - a1x;
	  var my = a2y - a1y;
	  var nx = b2x - b1x;
	  var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
	  //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
	
	  var nmCrossProduct = crossProduct2d(nx, ny, mx, my);
	
	  if (nearZero(nmCrossProduct)) {
	    return false;
	  } // `vec_m` and `vec_n` are intersect iff
	  //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
	  //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
	  //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
	
	
	  var b1a1x = a1x - b1x;
	  var b1a1y = a1y - b1y;
	  var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
	
	  if (q < 0 || q > 1) {
	    return false;
	  }
	
	  var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
	
	  if (p < 0 || p > 1) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Cross product of 2-dimension vector.
	 */
	
	
	function crossProduct2d(x1, y1, x2, y2) {
	  return x1 * y2 - x2 * y1;
	}
	
	function nearZero(val) {
	  return val <= 1e-6 && val >= -1e-6;
	} // Register built-in shapes. These shapes might be overwirtten
	// by users, although we do not recommend that.
	
	
	registerShape('circle', Circle);
	registerShape('sector', Sector);
	registerShape('ring', Ring);
	registerShape('polygon', Polygon);
	registerShape('polyline', Polyline);
	registerShape('rect', Rect);
	registerShape('line', Line);
	registerShape('bezierCurve', BezierCurve);
	registerShape('arc', Arc);
	exports.Z2_EMPHASIS_LIFT = Z2_EMPHASIS_LIFT;
	exports.CACHED_LABEL_STYLE_PROPERTIES = CACHED_LABEL_STYLE_PROPERTIES;
	exports.extendShape = extendShape;
	exports.extendPath = extendPath;
	exports.registerShape = registerShape;
	exports.getShapeClass = getShapeClass;
	exports.makePath = makePath;
	exports.makeImage = makeImage;
	exports.mergePath = mergePath;
	exports.resizePath = resizePath;
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;
	exports.setElementHoverStyle = setElementHoverStyle;
	exports.setHoverStyle = setHoverStyle;
	exports.setAsHighDownDispatcher = setAsHighDownDispatcher;
	exports.isHighDownDispatcher = isHighDownDispatcher;
	exports.getHighlightDigit = getHighlightDigit;
	exports.setLabelStyle = setLabelStyle;
	exports.modifyLabelStyle = modifyLabelStyle;
	exports.setTextStyle = setTextStyle;
	exports.setText = setText;
	exports.getFont = getFont;
	exports.updateProps = updateProps;
	exports.initProps = initProps;
	exports.getTransform = getTransform;
	exports.applyTransform = applyTransform;
	exports.transformDirection = transformDirection;
	exports.groupTransition = groupTransition;
	exports.clipPointsByRect = clipPointsByRect;
	exports.clipRectByRect = clipRectByRect;
	exports.createIcon = createIcon;
	exports.linePolygonIntersect = linePolygonIntersect;
	exports.lineLineIntersect = lineLineIntersect;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Affix", {
	  enumerable: true,
	  get: function get() {
	    return _affix["default"];
	  }
	});
	Object.defineProperty(exports, "Anchor", {
	  enumerable: true,
	  get: function get() {
	    return _anchor["default"];
	  }
	});
	Object.defineProperty(exports, "AutoComplete", {
	  enumerable: true,
	  get: function get() {
	    return _autoComplete["default"];
	  }
	});
	Object.defineProperty(exports, "Alert", {
	  enumerable: true,
	  get: function get() {
	    return _alert["default"];
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _avatar["default"];
	  }
	});
	Object.defineProperty(exports, "BackTop", {
	  enumerable: true,
	  get: function get() {
	    return _backTop["default"];
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _badge["default"];
	  }
	});
	Object.defineProperty(exports, "Breadcrumb", {
	  enumerable: true,
	  get: function get() {
	    return _breadcrumb["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _button["default"];
	  }
	});
	Object.defineProperty(exports, "Calendar", {
	  enumerable: true,
	  get: function get() {
	    return _calendar["default"];
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _card["default"];
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _collapse["default"];
	  }
	});
	Object.defineProperty(exports, "Carousel", {
	  enumerable: true,
	  get: function get() {
	    return _carousel["default"];
	  }
	});
	Object.defineProperty(exports, "Cascader", {
	  enumerable: true,
	  get: function get() {
	    return _cascader["default"];
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _checkbox["default"];
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _col["default"];
	  }
	});
	Object.defineProperty(exports, "Comment", {
	  enumerable: true,
	  get: function get() {
	    return _comment["default"];
	  }
	});
	Object.defineProperty(exports, "ConfigProvider", {
	  enumerable: true,
	  get: function get() {
	    return _configProvider["default"];
	  }
	});
	Object.defineProperty(exports, "DatePicker", {
	  enumerable: true,
	  get: function get() {
	    return _datePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Descriptions", {
	  enumerable: true,
	  get: function get() {
	    return _descriptions["default"];
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _divider["default"];
	  }
	});
	Object.defineProperty(exports, "Dropdown", {
	  enumerable: true,
	  get: function get() {
	    return _dropdown["default"];
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _drawer["default"];
	  }
	});
	Object.defineProperty(exports, "Empty", {
	  enumerable: true,
	  get: function get() {
	    return _empty["default"];
	  }
	});
	Object.defineProperty(exports, "Form", {
	  enumerable: true,
	  get: function get() {
	    return _form["default"];
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _icon["default"];
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _input["default"];
	  }
	});
	Object.defineProperty(exports, "InputNumber", {
	  enumerable: true,
	  get: function get() {
	    return _inputNumber["default"];
	  }
	});
	Object.defineProperty(exports, "Layout", {
	  enumerable: true,
	  get: function get() {
	    return _layout["default"];
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _list["default"];
	  }
	});
	Object.defineProperty(exports, "LocaleProvider", {
	  enumerable: true,
	  get: function get() {
	    return _localeProvider["default"];
	  }
	});
	Object.defineProperty(exports, "message", {
	  enumerable: true,
	  get: function get() {
	    return _message["default"];
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _menu["default"];
	  }
	});
	Object.defineProperty(exports, "Mentions", {
	  enumerable: true,
	  get: function get() {
	    return _mentions["default"];
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _modal["default"];
	  }
	});
	Object.defineProperty(exports, "Statistic", {
	  enumerable: true,
	  get: function get() {
	    return _statistic["default"];
	  }
	});
	Object.defineProperty(exports, "notification", {
	  enumerable: true,
	  get: function get() {
	    return _notification["default"];
	  }
	});
	Object.defineProperty(exports, "PageHeader", {
	  enumerable: true,
	  get: function get() {
	    return _pageHeader["default"];
	  }
	});
	Object.defineProperty(exports, "Pagination", {
	  enumerable: true,
	  get: function get() {
	    return _pagination["default"];
	  }
	});
	Object.defineProperty(exports, "Popconfirm", {
	  enumerable: true,
	  get: function get() {
	    return _popconfirm["default"];
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _popover["default"];
	  }
	});
	Object.defineProperty(exports, "Progress", {
	  enumerable: true,
	  get: function get() {
	    return _progress["default"];
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _radio["default"];
	  }
	});
	Object.defineProperty(exports, "Rate", {
	  enumerable: true,
	  get: function get() {
	    return _rate["default"];
	  }
	});
	Object.defineProperty(exports, "Result", {
	  enumerable: true,
	  get: function get() {
	    return _result["default"];
	  }
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _row["default"];
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _select["default"];
	  }
	});
	Object.defineProperty(exports, "Skeleton", {
	  enumerable: true,
	  get: function get() {
	    return _skeleton["default"];
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _slider["default"];
	  }
	});
	Object.defineProperty(exports, "Spin", {
	  enumerable: true,
	  get: function get() {
	    return _spin["default"];
	  }
	});
	Object.defineProperty(exports, "Steps", {
	  enumerable: true,
	  get: function get() {
	    return _steps["default"];
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _switch["default"];
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _table["default"];
	  }
	});
	Object.defineProperty(exports, "Transfer", {
	  enumerable: true,
	  get: function get() {
	    return _transfer["default"];
	  }
	});
	Object.defineProperty(exports, "Tree", {
	  enumerable: true,
	  get: function get() {
	    return _tree["default"];
	  }
	});
	Object.defineProperty(exports, "TreeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _treeSelect["default"];
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _tabs["default"];
	  }
	});
	Object.defineProperty(exports, "Tag", {
	  enumerable: true,
	  get: function get() {
	    return _tag["default"];
	  }
	});
	Object.defineProperty(exports, "TimePicker", {
	  enumerable: true,
	  get: function get() {
	    return _timePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Timeline", {
	  enumerable: true,
	  get: function get() {
	    return _timeline["default"];
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _tooltip["default"];
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography["default"];
	  }
	});
	Object.defineProperty(exports, "Mention", {
	  enumerable: true,
	  get: function get() {
	    return _mention["default"];
	  }
	});
	Object.defineProperty(exports, "Upload", {
	  enumerable: true,
	  get: function get() {
	    return _upload["default"];
	  }
	});
	Object.defineProperty(exports, "version", {
	  enumerable: true,
	  get: function get() {
	    return _version["default"];
	  }
	});
	
	var _affix = _interopRequireDefault(__webpack_require__(634));
	
	var _anchor = _interopRequireDefault(__webpack_require__(1170));
	
	var _autoComplete = _interopRequireDefault(__webpack_require__(1172));
	
	var _alert = _interopRequireDefault(__webpack_require__(1167));
	
	var _avatar = _interopRequireDefault(__webpack_require__(635));
	
	var _backTop = _interopRequireDefault(__webpack_require__(1173));
	
	var _badge = _interopRequireDefault(__webpack_require__(1175));
	
	var _breadcrumb = _interopRequireDefault(__webpack_require__(637));
	
	var _button = _interopRequireDefault(__webpack_require__(136));
	
	var _calendar = _interopRequireDefault(__webpack_require__(1181));
	
	var _card = _interopRequireDefault(__webpack_require__(1184));
	
	var _collapse = _interopRequireDefault(__webpack_require__(1190));
	
	var _carousel = _interopRequireDefault(__webpack_require__(1185));
	
	var _cascader = _interopRequireDefault(__webpack_require__(1186));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(156));
	
	var _col = _interopRequireDefault(__webpack_require__(640));
	
	var _comment = _interopRequireDefault(__webpack_require__(1191));
	
	var _configProvider = _interopRequireDefault(__webpack_require__(14));
	
	var _datePicker = _interopRequireDefault(__webpack_require__(1196));
	
	var _descriptions = _interopRequireDefault(__webpack_require__(1199));
	
	var _divider = _interopRequireDefault(__webpack_require__(1200));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(356));
	
	var _drawer = _interopRequireDefault(__webpack_require__(1201));
	
	var _empty = _interopRequireDefault(__webpack_require__(643));
	
	var _form = _interopRequireDefault(__webpack_require__(1207));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _input = _interopRequireDefault(__webpack_require__(244));
	
	var _inputNumber = _interopRequireDefault(__webpack_require__(1211));
	
	var _layout = _interopRequireDefault(__webpack_require__(1217));
	
	var _list = _interopRequireDefault(__webpack_require__(1219));
	
	var _localeProvider = _interopRequireDefault(__webpack_require__(652));
	
	var _message = _interopRequireDefault(__webpack_require__(1225));
	
	var _menu = _interopRequireDefault(__webpack_require__(359));
	
	var _mentions = _interopRequireDefault(__webpack_require__(1222));
	
	var _modal = _interopRequireDefault(__webpack_require__(1228));
	
	var _statistic = _interopRequireDefault(__webpack_require__(1252));
	
	var _notification = _interopRequireDefault(__webpack_require__(1229));
	
	var _pageHeader = _interopRequireDefault(__webpack_require__(1230));
	
	var _pagination = _interopRequireDefault(__webpack_require__(361));
	
	var _popconfirm = _interopRequireDefault(__webpack_require__(1233));
	
	var _popover = _interopRequireDefault(__webpack_require__(1234));
	
	var _progress = _interopRequireDefault(__webpack_require__(654));
	
	var _radio = _interopRequireDefault(__webpack_require__(245));
	
	var _rate = _interopRequireDefault(__webpack_require__(1240));
	
	var _result = _interopRequireDefault(__webpack_require__(1241));
	
	var _row = _interopRequireDefault(__webpack_require__(655));
	
	var _select = _interopRequireDefault(__webpack_require__(202));
	
	var _skeleton = _interopRequireDefault(__webpack_require__(1248));
	
	var _slider = _interopRequireDefault(__webpack_require__(1249));
	
	var _spin = _interopRequireDefault(__webpack_require__(246));
	
	var _steps = _interopRequireDefault(__webpack_require__(1254));
	
	var _switch = _interopRequireDefault(__webpack_require__(1255));
	
	var _table = _interopRequireDefault(__webpack_require__(1265));
	
	var _transfer = _interopRequireDefault(__webpack_require__(1273));
	
	var _tree = _interopRequireDefault(__webpack_require__(1279));
	
	var _treeSelect = _interopRequireDefault(__webpack_require__(1277));
	
	var _tabs = _interopRequireDefault(__webpack_require__(658));
	
	var _tag = _interopRequireDefault(__webpack_require__(659));
	
	var _timePicker = _interopRequireDefault(__webpack_require__(660));
	
	var _timeline = _interopRequireDefault(__webpack_require__(1270));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(124));
	
	var _typography = _interopRequireDefault(__webpack_require__(1285));
	
	var _mention = _interopRequireDefault(__webpack_require__(1221));
	
	var _upload = _interopRequireDefault(__webpack_require__(1289));
	
	var _version = _interopRequireDefault(__webpack_require__(1290));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	/* @remove-on-es-build-begin */
	// this file is not used if use https://github.com/ant-design/babel-plugin-import
	var ENV = ("production");
	
	if (ENV !== 'production' && ENV !== 'test' && typeof console !== 'undefined' && console.warn && // eslint-disable-line no-console
	typeof window !== 'undefined') {
	  // eslint-disable-next-line no-console
	  console.warn('You are using a whole package of antd, ' + 'please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size.');
	}
	/* @remove-on-es-build-end */

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory();
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	})(undefined, function () {
	
		/*globals window, global, require*/
	
		/**
	  * CryptoJS core components.
	  */
		var CryptoJS = CryptoJS || function (Math, undefined) {
	
			var crypto;
	
			// Native crypto from window (Browser)
			if (typeof window !== 'undefined' && window.crypto) {
				crypto = window.crypto;
			}
	
			// Native crypto in web worker (Browser)
			if (typeof self !== 'undefined' && self.crypto) {
				crypto = self.crypto;
			}
	
			// Native crypto from worker
			if (typeof globalThis !== 'undefined' && globalThis.crypto) {
				crypto = globalThis.crypto;
			}
	
			// Native (experimental IE 11) crypto from window (Browser)
			if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
				crypto = window.msCrypto;
			}
	
			// Native crypto from global (NodeJS)
			if (!crypto && typeof global !== 'undefined' && global.crypto) {
				crypto = global.crypto;
			}
	
			// Native crypto import via require (NodeJS)
			if (!crypto && "function" === 'function') {
				try {
					crypto = __webpack_require__(2120);
				} catch (err) {}
			}
	
			/*
	   * Cryptographically secure pseudorandom number generator
	   *
	   * As Math.random() is cryptographically not safe to use
	   */
			var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
				if (crypto) {
					// Use getRandomValues method (Browser)
					if (typeof crypto.getRandomValues === 'function') {
						try {
							return crypto.getRandomValues(new Uint32Array(1))[0];
						} catch (err) {}
					}
	
					// Use randomBytes method (NodeJS)
					if (typeof crypto.randomBytes === 'function') {
						try {
							return crypto.randomBytes(4).readInt32LE();
						} catch (err) {}
					}
				}
	
				throw new Error('Native crypto module could not be used to get secure random number.');
			};
	
			/*
	   * Local polyfill of Object.create
	    */
			var create = Object.create || function () {
				function F() {}
	
				return function (obj) {
					var subtype;
	
					F.prototype = obj;
	
					subtype = new F();
	
					F.prototype = null;
	
					return subtype;
				};
			}();
	
			/**
	   * CryptoJS namespace.
	   */
			var C = {};
	
			/**
	   * Library namespace.
	   */
			var C_lib = C.lib = {};
	
			/**
	   * Base object for prototypal inheritance.
	   */
			var Base = C_lib.Base = function () {
	
				return {
					/**
	     * Creates a new object that inherits from this object.
	     *
	     * @param {Object} overrides Properties to copy into the new object.
	     *
	     * @return {Object} The new object.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var MyType = CryptoJS.lib.Base.extend({
	     *         field: 'value',
	     *
	     *         method: function () {
	     *         }
	     *     });
	     */
					extend: function extend(overrides) {
						// Spawn
						var subtype = create(this);
	
						// Augment
						if (overrides) {
							subtype.mixIn(overrides);
						}
	
						// Create default initializer
						if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
							subtype.init = function () {
								subtype.$super.init.apply(this, arguments);
							};
						}
	
						// Initializer's prototype is the subtype object
						subtype.init.prototype = subtype;
	
						// Reference supertype
						subtype.$super = this;
	
						return subtype;
					},
	
					/**
	     * Extends this object and runs the init method.
	     * Arguments to create() will be passed to init().
	     *
	     * @return {Object} The new object.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var instance = MyType.create();
	     */
					create: function create() {
						var instance = this.extend();
						instance.init.apply(instance, arguments);
	
						return instance;
					},
	
					/**
	     * Initializes a newly created object.
	     * Override this method to add some logic when your objects are created.
	     *
	     * @example
	     *
	     *     var MyType = CryptoJS.lib.Base.extend({
	     *         init: function () {
	     *             // ...
	     *         }
	     *     });
	     */
					init: function init() {},
	
					/**
	     * Copies properties into this object.
	     *
	     * @param {Object} properties The properties to mix in.
	     *
	     * @example
	     *
	     *     MyType.mixIn({
	     *         field: 'value'
	     *     });
	     */
					mixIn: function mixIn(properties) {
						for (var propertyName in properties) {
							if (properties.hasOwnProperty(propertyName)) {
								this[propertyName] = properties[propertyName];
							}
						}
	
						// IE won't copy toString using the loop above
						if (properties.hasOwnProperty('toString')) {
							this.toString = properties.toString;
						}
					},
	
					/**
	     * Creates a copy of this object.
	     *
	     * @return {Object} The clone.
	     *
	     * @example
	     *
	     *     var clone = instance.clone();
	     */
					clone: function clone() {
						return this.init.prototype.extend(this);
					}
				};
			}();
	
			/**
	   * An array of 32-bit words.
	   *
	   * @property {Array} words The array of 32-bit words.
	   * @property {number} sigBytes The number of significant bytes in this word array.
	   */
			var WordArray = C_lib.WordArray = Base.extend({
				/**
	    * Initializes a newly created word array.
	    *
	    * @param {Array} words (Optional) An array of 32-bit words.
	    * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.lib.WordArray.create();
	    *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	    *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	    */
				init: function init(words, sigBytes) {
					words = this.words = words || [];
	
					if (sigBytes != undefined) {
						this.sigBytes = sigBytes;
					} else {
						this.sigBytes = words.length * 4;
					}
				},
	
				/**
	    * Converts this word array to a string.
	    *
	    * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	    *
	    * @return {string} The stringified word array.
	    *
	    * @example
	    *
	    *     var string = wordArray + '';
	    *     var string = wordArray.toString();
	    *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	    */
				toString: function toString(encoder) {
					return (encoder || Hex).stringify(this);
				},
	
				/**
	    * Concatenates a word array to this word array.
	    *
	    * @param {WordArray} wordArray The word array to append.
	    *
	    * @return {WordArray} This word array.
	    *
	    * @example
	    *
	    *     wordArray1.concat(wordArray2);
	    */
				concat: function concat(wordArray) {
					// Shortcuts
					var thisWords = this.words;
					var thatWords = wordArray.words;
					var thisSigBytes = this.sigBytes;
					var thatSigBytes = wordArray.sigBytes;
	
					// Clamp excess bits
					this.clamp();
	
					// Concat
					if (thisSigBytes % 4) {
						// Copy one byte at a time
						for (var i = 0; i < thatSigBytes; i++) {
							var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
							thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
						}
					} else {
						// Copy one word at a time
						for (var j = 0; j < thatSigBytes; j += 4) {
							thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
						}
					}
					this.sigBytes += thatSigBytes;
	
					// Chainable
					return this;
				},
	
				/**
	    * Removes insignificant bits.
	    *
	    * @example
	    *
	    *     wordArray.clamp();
	    */
				clamp: function clamp() {
					// Shortcuts
					var words = this.words;
					var sigBytes = this.sigBytes;
	
					// Clamp
					words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
					words.length = Math.ceil(sigBytes / 4);
				},
	
				/**
	    * Creates a copy of this word array.
	    *
	    * @return {WordArray} The clone.
	    *
	    * @example
	    *
	    *     var clone = wordArray.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
					clone.words = this.words.slice(0);
	
					return clone;
				},
	
				/**
	    * Creates a word array filled with random bytes.
	    *
	    * @param {number} nBytes The number of random bytes to generate.
	    *
	    * @return {WordArray} The random word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.lib.WordArray.random(16);
	    */
				random: function random(nBytes) {
					var words = [];
	
					for (var i = 0; i < nBytes; i += 4) {
						words.push(cryptoSecureRandomInt());
					}
	
					return new WordArray.init(words, nBytes);
				}
			});
	
			/**
	   * Encoder namespace.
	   */
			var C_enc = C.enc = {};
	
			/**
	   * Hex encoding strategy.
	   */
			var Hex = C_enc.Hex = {
				/**
	    * Converts a word array to a hex string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The hex string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var hexChars = [];
					for (var i = 0; i < sigBytes; i++) {
						var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						hexChars.push((bite >>> 4).toString(16));
						hexChars.push((bite & 0x0f).toString(16));
					}
	
					return hexChars.join('');
				},
	
				/**
	    * Converts a hex string to a word array.
	    *
	    * @param {string} hexStr The hex string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	    */
				parse: function parse(hexStr) {
					// Shortcut
					var hexStrLength = hexStr.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < hexStrLength; i += 2) {
						words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
					}
	
					return new WordArray.init(words, hexStrLength / 2);
				}
			};
	
			/**
	   * Latin1 encoding strategy.
	   */
			var Latin1 = C_enc.Latin1 = {
				/**
	    * Converts a word array to a Latin1 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The Latin1 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var latin1Chars = [];
					for (var i = 0; i < sigBytes; i++) {
						var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						latin1Chars.push(String.fromCharCode(bite));
					}
	
					return latin1Chars.join('');
				},
	
				/**
	    * Converts a Latin1 string to a word array.
	    *
	    * @param {string} latin1Str The Latin1 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	    */
				parse: function parse(latin1Str) {
					// Shortcut
					var latin1StrLength = latin1Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < latin1StrLength; i++) {
						words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
					}
	
					return new WordArray.init(words, latin1StrLength);
				}
			};
	
			/**
	   * UTF-8 encoding strategy.
	   */
			var Utf8 = C_enc.Utf8 = {
				/**
	    * Converts a word array to a UTF-8 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-8 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					try {
						return decodeURIComponent(escape(Latin1.stringify(wordArray)));
					} catch (e) {
						throw new Error('Malformed UTF-8 data');
					}
				},
	
				/**
	    * Converts a UTF-8 string to a word array.
	    *
	    * @param {string} utf8Str The UTF-8 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	    */
				parse: function parse(utf8Str) {
					return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
				}
			};
	
			/**
	   * Abstract buffered block algorithm template.
	   *
	   * The property blockSize must be implemented in a concrete subtype.
	   *
	   * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	   */
			var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
				/**
	    * Resets this block algorithm's data buffer to its initial state.
	    *
	    * @example
	    *
	    *     bufferedBlockAlgorithm.reset();
	    */
				reset: function reset() {
					// Initial values
					this._data = new WordArray.init();
					this._nDataBytes = 0;
				},
	
				/**
	    * Adds new data to this block algorithm's buffer.
	    *
	    * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	    *
	    * @example
	    *
	    *     bufferedBlockAlgorithm._append('data');
	    *     bufferedBlockAlgorithm._append(wordArray);
	    */
				_append: function _append(data) {
					// Convert string to WordArray, else assume WordArray already
					if (typeof data == 'string') {
						data = Utf8.parse(data);
					}
	
					// Append
					this._data.concat(data);
					this._nDataBytes += data.sigBytes;
				},
	
				/**
	    * Processes available data blocks.
	    *
	    * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	    *
	    * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	    *
	    * @return {WordArray} The processed data.
	    *
	    * @example
	    *
	    *     var processedData = bufferedBlockAlgorithm._process();
	    *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	    */
				_process: function _process(doFlush) {
					var processedWords;
	
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
					var dataSigBytes = data.sigBytes;
					var blockSize = this.blockSize;
					var blockSizeBytes = blockSize * 4;
	
					// Count blocks ready
					var nBlocksReady = dataSigBytes / blockSizeBytes;
					if (doFlush) {
						// Round up to include partial blocks
						nBlocksReady = Math.ceil(nBlocksReady);
					} else {
						// Round down to include only full blocks,
						// less the number of blocks that must remain in the buffer
						nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
					}
	
					// Count words ready
					var nWordsReady = nBlocksReady * blockSize;
	
					// Count bytes ready
					var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
					// Process blocks
					if (nWordsReady) {
						for (var offset = 0; offset < nWordsReady; offset += blockSize) {
							// Perform concrete-algorithm logic
							this._doProcessBlock(dataWords, offset);
						}
	
						// Remove processed words
						processedWords = dataWords.splice(0, nWordsReady);
						data.sigBytes -= nBytesReady;
					}
	
					// Return processed words
					return new WordArray.init(processedWords, nBytesReady);
				},
	
				/**
	    * Creates a copy of this object.
	    *
	    * @return {Object} The clone.
	    *
	    * @example
	    *
	    *     var clone = bufferedBlockAlgorithm.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
					clone._data = this._data.clone();
	
					return clone;
				},
	
				_minBufferSize: 0
			});
	
			/**
	   * Abstract hasher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	   */
			var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
				/**
	    * Configuration options.
	    */
				cfg: Base.extend(),
	
				/**
	    * Initializes a newly created hasher.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	    *
	    * @example
	    *
	    *     var hasher = CryptoJS.algo.SHA256.create();
	    */
				init: function init(cfg) {
					// Apply config defaults
					this.cfg = this.cfg.extend(cfg);
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this hasher to its initial state.
	    *
	    * @example
	    *
	    *     hasher.reset();
	    */
				reset: function reset() {
					// Reset data buffer
					BufferedBlockAlgorithm.reset.call(this);
	
					// Perform concrete-hasher logic
					this._doReset();
				},
	
				/**
	    * Updates this hasher with a message.
	    *
	    * @param {WordArray|string} messageUpdate The message to append.
	    *
	    * @return {Hasher} This hasher.
	    *
	    * @example
	    *
	    *     hasher.update('message');
	    *     hasher.update(wordArray);
	    */
				update: function update(messageUpdate) {
					// Append
					this._append(messageUpdate);
	
					// Update the hash
					this._process();
	
					// Chainable
					return this;
				},
	
				/**
	    * Finalizes the hash computation.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} messageUpdate (Optional) A final message update.
	    *
	    * @return {WordArray} The hash.
	    *
	    * @example
	    *
	    *     var hash = hasher.finalize();
	    *     var hash = hasher.finalize('message');
	    *     var hash = hasher.finalize(wordArray);
	    */
				finalize: function finalize(messageUpdate) {
					// Final message update
					if (messageUpdate) {
						this._append(messageUpdate);
					}
	
					// Perform concrete-hasher logic
					var hash = this._doFinalize();
	
					return hash;
				},
	
				blockSize: 512 / 32,
	
				/**
	    * Creates a shortcut function to a hasher's object interface.
	    *
	    * @param {Hasher} hasher The hasher to create a helper for.
	    *
	    * @return {Function} The shortcut function.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	    */
				_createHelper: function _createHelper(hasher) {
					return function (message, cfg) {
						return new hasher.init(cfg).finalize(message);
					};
				},
	
				/**
	    * Creates a shortcut function to the HMAC's object interface.
	    *
	    * @param {Hasher} hasher The hasher to use in this HMAC helper.
	    *
	    * @return {Function} The shortcut function.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	    */
				_createHmacHelper: function _createHmacHelper(hasher) {
					return function (message, key) {
						return new C_algo.HMAC.init(hasher, key).finalize(message);
					};
				}
			});
	
			/**
	   * Algorithm namespace.
	   */
			var C_algo = C.algo = {};
	
			return C;
		}(Math);
	
		return CryptoJS;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory();
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	})(undefined, function () {
	
		/*globals window, global, require*/
	
		/**
	  * CryptoJS core components.
	  */
		var CryptoJS = CryptoJS || function (Math, undefined) {
	
			var crypto;
	
			// Native crypto from window (Browser)
			if (typeof window !== 'undefined' && window.crypto) {
				crypto = window.crypto;
			}
	
			// Native crypto in web worker (Browser)
			if (typeof self !== 'undefined' && self.crypto) {
				crypto = self.crypto;
			}
	
			// Native crypto from worker
			if (typeof globalThis !== 'undefined' && globalThis.crypto) {
				crypto = globalThis.crypto;
			}
	
			// Native (experimental IE 11) crypto from window (Browser)
			if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
				crypto = window.msCrypto;
			}
	
			// Native crypto from global (NodeJS)
			if (!crypto && typeof global !== 'undefined' && global.crypto) {
				crypto = global.crypto;
			}
	
			// Native crypto import via require (NodeJS)
			if (!crypto && "function" === 'function') {
				try {
					crypto = __webpack_require__(2121);
				} catch (err) {}
			}
	
			/*
	   * Cryptographically secure pseudorandom number generator
	   *
	   * As Math.random() is cryptographically not safe to use
	   */
			var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
				if (crypto) {
					// Use getRandomValues method (Browser)
					if (typeof crypto.getRandomValues === 'function') {
						try {
							return crypto.getRandomValues(new Uint32Array(1))[0];
						} catch (err) {}
					}
	
					// Use randomBytes method (NodeJS)
					if (typeof crypto.randomBytes === 'function') {
						try {
							return crypto.randomBytes(4).readInt32LE();
						} catch (err) {}
					}
				}
	
				throw new Error('Native crypto module could not be used to get secure random number.');
			};
	
			/*
	   * Local polyfill of Object.create
	    */
			var create = Object.create || function () {
				function F() {}
	
				return function (obj) {
					var subtype;
	
					F.prototype = obj;
	
					subtype = new F();
	
					F.prototype = null;
	
					return subtype;
				};
			}();
	
			/**
	   * CryptoJS namespace.
	   */
			var C = {};
	
			/**
	   * Library namespace.
	   */
			var C_lib = C.lib = {};
	
			/**
	   * Base object for prototypal inheritance.
	   */
			var Base = C_lib.Base = function () {
	
				return {
					/**
	     * Creates a new object that inherits from this object.
	     *
	     * @param {Object} overrides Properties to copy into the new object.
	     *
	     * @return {Object} The new object.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var MyType = CryptoJS.lib.Base.extend({
	     *         field: 'value',
	     *
	     *         method: function () {
	     *         }
	     *     });
	     */
					extend: function extend(overrides) {
						// Spawn
						var subtype = create(this);
	
						// Augment
						if (overrides) {
							subtype.mixIn(overrides);
						}
	
						// Create default initializer
						if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
							subtype.init = function () {
								subtype.$super.init.apply(this, arguments);
							};
						}
	
						// Initializer's prototype is the subtype object
						subtype.init.prototype = subtype;
	
						// Reference supertype
						subtype.$super = this;
	
						return subtype;
					},
	
					/**
	     * Extends this object and runs the init method.
	     * Arguments to create() will be passed to init().
	     *
	     * @return {Object} The new object.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var instance = MyType.create();
	     */
					create: function create() {
						var instance = this.extend();
						instance.init.apply(instance, arguments);
	
						return instance;
					},
	
					/**
	     * Initializes a newly created object.
	     * Override this method to add some logic when your objects are created.
	     *
	     * @example
	     *
	     *     var MyType = CryptoJS.lib.Base.extend({
	     *         init: function () {
	     *             // ...
	     *         }
	     *     });
	     */
					init: function init() {},
	
					/**
	     * Copies properties into this object.
	     *
	     * @param {Object} properties The properties to mix in.
	     *
	     * @example
	     *
	     *     MyType.mixIn({
	     *         field: 'value'
	     *     });
	     */
					mixIn: function mixIn(properties) {
						for (var propertyName in properties) {
							if (properties.hasOwnProperty(propertyName)) {
								this[propertyName] = properties[propertyName];
							}
						}
	
						// IE won't copy toString using the loop above
						if (properties.hasOwnProperty('toString')) {
							this.toString = properties.toString;
						}
					},
	
					/**
	     * Creates a copy of this object.
	     *
	     * @return {Object} The clone.
	     *
	     * @example
	     *
	     *     var clone = instance.clone();
	     */
					clone: function clone() {
						return this.init.prototype.extend(this);
					}
				};
			}();
	
			/**
	   * An array of 32-bit words.
	   *
	   * @property {Array} words The array of 32-bit words.
	   * @property {number} sigBytes The number of significant bytes in this word array.
	   */
			var WordArray = C_lib.WordArray = Base.extend({
				/**
	    * Initializes a newly created word array.
	    *
	    * @param {Array} words (Optional) An array of 32-bit words.
	    * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.lib.WordArray.create();
	    *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	    *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	    */
				init: function init(words, sigBytes) {
					words = this.words = words || [];
	
					if (sigBytes != undefined) {
						this.sigBytes = sigBytes;
					} else {
						this.sigBytes = words.length * 4;
					}
				},
	
				/**
	    * Converts this word array to a string.
	    *
	    * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	    *
	    * @return {string} The stringified word array.
	    *
	    * @example
	    *
	    *     var string = wordArray + '';
	    *     var string = wordArray.toString();
	    *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	    */
				toString: function toString(encoder) {
					return (encoder || Hex).stringify(this);
				},
	
				/**
	    * Concatenates a word array to this word array.
	    *
	    * @param {WordArray} wordArray The word array to append.
	    *
	    * @return {WordArray} This word array.
	    *
	    * @example
	    *
	    *     wordArray1.concat(wordArray2);
	    */
				concat: function concat(wordArray) {
					// Shortcuts
					var thisWords = this.words;
					var thatWords = wordArray.words;
					var thisSigBytes = this.sigBytes;
					var thatSigBytes = wordArray.sigBytes;
	
					// Clamp excess bits
					this.clamp();
	
					// Concat
					if (thisSigBytes % 4) {
						// Copy one byte at a time
						for (var i = 0; i < thatSigBytes; i++) {
							var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
							thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
						}
					} else {
						// Copy one word at a time
						for (var j = 0; j < thatSigBytes; j += 4) {
							thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
						}
					}
					this.sigBytes += thatSigBytes;
	
					// Chainable
					return this;
				},
	
				/**
	    * Removes insignificant bits.
	    *
	    * @example
	    *
	    *     wordArray.clamp();
	    */
				clamp: function clamp() {
					// Shortcuts
					var words = this.words;
					var sigBytes = this.sigBytes;
	
					// Clamp
					words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
					words.length = Math.ceil(sigBytes / 4);
				},
	
				/**
	    * Creates a copy of this word array.
	    *
	    * @return {WordArray} The clone.
	    *
	    * @example
	    *
	    *     var clone = wordArray.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
					clone.words = this.words.slice(0);
	
					return clone;
				},
	
				/**
	    * Creates a word array filled with random bytes.
	    *
	    * @param {number} nBytes The number of random bytes to generate.
	    *
	    * @return {WordArray} The random word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.lib.WordArray.random(16);
	    */
				random: function random(nBytes) {
					var words = [];
	
					for (var i = 0; i < nBytes; i += 4) {
						words.push(cryptoSecureRandomInt());
					}
	
					return new WordArray.init(words, nBytes);
				}
			});
	
			/**
	   * Encoder namespace.
	   */
			var C_enc = C.enc = {};
	
			/**
	   * Hex encoding strategy.
	   */
			var Hex = C_enc.Hex = {
				/**
	    * Converts a word array to a hex string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The hex string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var hexChars = [];
					for (var i = 0; i < sigBytes; i++) {
						var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						hexChars.push((bite >>> 4).toString(16));
						hexChars.push((bite & 0x0f).toString(16));
					}
	
					return hexChars.join('');
				},
	
				/**
	    * Converts a hex string to a word array.
	    *
	    * @param {string} hexStr The hex string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	    */
				parse: function parse(hexStr) {
					// Shortcut
					var hexStrLength = hexStr.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < hexStrLength; i += 2) {
						words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
					}
	
					return new WordArray.init(words, hexStrLength / 2);
				}
			};
	
			/**
	   * Latin1 encoding strategy.
	   */
			var Latin1 = C_enc.Latin1 = {
				/**
	    * Converts a word array to a Latin1 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The Latin1 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var latin1Chars = [];
					for (var i = 0; i < sigBytes; i++) {
						var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						latin1Chars.push(String.fromCharCode(bite));
					}
	
					return latin1Chars.join('');
				},
	
				/**
	    * Converts a Latin1 string to a word array.
	    *
	    * @param {string} latin1Str The Latin1 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	    */
				parse: function parse(latin1Str) {
					// Shortcut
					var latin1StrLength = latin1Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < latin1StrLength; i++) {
						words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
					}
	
					return new WordArray.init(words, latin1StrLength);
				}
			};
	
			/**
	   * UTF-8 encoding strategy.
	   */
			var Utf8 = C_enc.Utf8 = {
				/**
	    * Converts a word array to a UTF-8 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-8 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					try {
						return decodeURIComponent(escape(Latin1.stringify(wordArray)));
					} catch (e) {
						throw new Error('Malformed UTF-8 data');
					}
				},
	
				/**
	    * Converts a UTF-8 string to a word array.
	    *
	    * @param {string} utf8Str The UTF-8 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	    */
				parse: function parse(utf8Str) {
					return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
				}
			};
	
			/**
	   * Abstract buffered block algorithm template.
	   *
	   * The property blockSize must be implemented in a concrete subtype.
	   *
	   * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	   */
			var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
				/**
	    * Resets this block algorithm's data buffer to its initial state.
	    *
	    * @example
	    *
	    *     bufferedBlockAlgorithm.reset();
	    */
				reset: function reset() {
					// Initial values
					this._data = new WordArray.init();
					this._nDataBytes = 0;
				},
	
				/**
	    * Adds new data to this block algorithm's buffer.
	    *
	    * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	    *
	    * @example
	    *
	    *     bufferedBlockAlgorithm._append('data');
	    *     bufferedBlockAlgorithm._append(wordArray);
	    */
				_append: function _append(data) {
					// Convert string to WordArray, else assume WordArray already
					if (typeof data == 'string') {
						data = Utf8.parse(data);
					}
	
					// Append
					this._data.concat(data);
					this._nDataBytes += data.sigBytes;
				},
	
				/**
	    * Processes available data blocks.
	    *
	    * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	    *
	    * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	    *
	    * @return {WordArray} The processed data.
	    *
	    * @example
	    *
	    *     var processedData = bufferedBlockAlgorithm._process();
	    *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	    */
				_process: function _process(doFlush) {
					var processedWords;
	
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
					var dataSigBytes = data.sigBytes;
					var blockSize = this.blockSize;
					var blockSizeBytes = blockSize * 4;
	
					// Count blocks ready
					var nBlocksReady = dataSigBytes / blockSizeBytes;
					if (doFlush) {
						// Round up to include partial blocks
						nBlocksReady = Math.ceil(nBlocksReady);
					} else {
						// Round down to include only full blocks,
						// less the number of blocks that must remain in the buffer
						nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
					}
	
					// Count words ready
					var nWordsReady = nBlocksReady * blockSize;
	
					// Count bytes ready
					var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
					// Process blocks
					if (nWordsReady) {
						for (var offset = 0; offset < nWordsReady; offset += blockSize) {
							// Perform concrete-algorithm logic
							this._doProcessBlock(dataWords, offset);
						}
	
						// Remove processed words
						processedWords = dataWords.splice(0, nWordsReady);
						data.sigBytes -= nBytesReady;
					}
	
					// Return processed words
					return new WordArray.init(processedWords, nBytesReady);
				},
	
				/**
	    * Creates a copy of this object.
	    *
	    * @return {Object} The clone.
	    *
	    * @example
	    *
	    *     var clone = bufferedBlockAlgorithm.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
					clone._data = this._data.clone();
	
					return clone;
				},
	
				_minBufferSize: 0
			});
	
			/**
	   * Abstract hasher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	   */
			var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
				/**
	    * Configuration options.
	    */
				cfg: Base.extend(),
	
				/**
	    * Initializes a newly created hasher.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	    *
	    * @example
	    *
	    *     var hasher = CryptoJS.algo.SHA256.create();
	    */
				init: function init(cfg) {
					// Apply config defaults
					this.cfg = this.cfg.extend(cfg);
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this hasher to its initial state.
	    *
	    * @example
	    *
	    *     hasher.reset();
	    */
				reset: function reset() {
					// Reset data buffer
					BufferedBlockAlgorithm.reset.call(this);
	
					// Perform concrete-hasher logic
					this._doReset();
				},
	
				/**
	    * Updates this hasher with a message.
	    *
	    * @param {WordArray|string} messageUpdate The message to append.
	    *
	    * @return {Hasher} This hasher.
	    *
	    * @example
	    *
	    *     hasher.update('message');
	    *     hasher.update(wordArray);
	    */
				update: function update(messageUpdate) {
					// Append
					this._append(messageUpdate);
	
					// Update the hash
					this._process();
	
					// Chainable
					return this;
				},
	
				/**
	    * Finalizes the hash computation.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} messageUpdate (Optional) A final message update.
	    *
	    * @return {WordArray} The hash.
	    *
	    * @example
	    *
	    *     var hash = hasher.finalize();
	    *     var hash = hasher.finalize('message');
	    *     var hash = hasher.finalize(wordArray);
	    */
				finalize: function finalize(messageUpdate) {
					// Final message update
					if (messageUpdate) {
						this._append(messageUpdate);
					}
	
					// Perform concrete-hasher logic
					var hash = this._doFinalize();
	
					return hash;
				},
	
				blockSize: 512 / 32,
	
				/**
	    * Creates a shortcut function to a hasher's object interface.
	    *
	    * @param {Hasher} hasher The hasher to create a helper for.
	    *
	    * @return {Function} The shortcut function.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	    */
				_createHelper: function _createHelper(hasher) {
					return function (message, cfg) {
						return new hasher.init(cfg).finalize(message);
					};
				},
	
				/**
	    * Creates a shortcut function to the HMAC's object interface.
	    *
	    * @param {Hasher} hasher The hasher to use in this HMAC helper.
	    *
	    * @return {Function} The shortcut function.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	    */
				_createHmacHelper: function _createHmacHelper(hasher) {
					return function (message, key) {
						return new C_algo.HMAC.init(hasher, key).finalize(message);
					};
				}
			});
	
			/**
	   * Algorithm namespace.
	   */
			var C_algo = C.algo = {};
	
			return C;
		}(Math);
	
		return CryptoJS;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var allIcons = _interopRequireWildcard(__webpack_require__(507));
	
	var _iconsReact = _interopRequireDefault(__webpack_require__(184));
	
	var _IconFont = _interopRequireDefault(__webpack_require__(1050));
	
	var _utils = __webpack_require__(1052);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _twoTonePrimaryColor = __webpack_require__(1051);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable camelcase */
	
	// Initial setting
	_iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
	  return allIcons[key];
	})));
	
	(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
	var defaultTheme = 'outlined';
	var dangerousTheme;
	
	function unstable_ChangeThemeOfIconsDangerously(theme) {
	  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeThemeOfAllIconsDangerously', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
	  dangerousTheme = theme;
	}
	
	function unstable_ChangeDefaultThemeOfIcons(theme) {
	  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeDefaultThemeOfIcons', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
	  defaultTheme = theme;
	}
	
	var Icon = function Icon(props) {
	  var _classNames;
	
	  var className = props.className,
	      type = props.type,
	      Component = props.component,
	      viewBox = props.viewBox,
	      spin = props.spin,
	      rotate = props.rotate,
	      tabIndex = props.tabIndex,
	      onClick = props.onClick,
	      children = props.children,
	      theme = props.theme,
	      twoToneColor = props.twoToneColor,
	      restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children", "theme", "twoToneColor"]);
	
	  (0, _warning["default"])(Boolean(type || Component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');
	  var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
	  var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
	  var svgStyle = rotate ? {
	    msTransform: "rotate(".concat(rotate, "deg)"),
	    transform: "rotate(".concat(rotate, "deg)")
	  } : undefined;
	
	  var innerSvgProps = _extends(_extends({}, _utils.svgBaseProps), {
	    className: svgClassString,
	    style: svgStyle,
	    viewBox: viewBox
	  });
	
	  if (!viewBox) {
	    delete innerSvgProps.viewBox;
	  }
	
	  var renderInnerNode = function renderInnerNode() {
	    // component > children > type
	    if (Component) {
	      return (/*#__PURE__*/React.createElement(Component, innerSvgProps, children)
	      );
	    }
	
	    if (children) {
	      (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use', 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
	      return (/*#__PURE__*/React.createElement("svg", _extends({}, innerSvgProps, {
	          viewBox: viewBox
	        }), children)
	      );
	    }
	
	    if (typeof type === 'string') {
	      var computedType = type;
	
	      if (theme) {
	        var themeInName = (0, _utils.getThemeFromTypeName)(type);
	        (0, _warning["default"])(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
	      }
	
	      computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)((0, _utils.alias)(computedType)), dangerousTheme || theme || defaultTheme);
	      return (/*#__PURE__*/React.createElement(_iconsReact["default"], {
	          className: svgClassString,
	          type: computedType,
	          primaryColor: twoToneColor,
	          style: svgStyle
	        })
	      );
	    }
	  };
	
	  var iconTabIndex = tabIndex;
	
	  if (iconTabIndex === undefined && onClick) {
	    iconTabIndex = -1;
	  }
	
	  return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	      componentName: "Icon"
	    }, function (locale) {
	      return (/*#__PURE__*/React.createElement("i", _extends({
	          "aria-label": type && "".concat(locale.icon, ": ").concat(type)
	        }, restProps, {
	          tabIndex: iconTabIndex,
	          onClick: onClick,
	          className: classString
	        }), renderInnerNode())
	      );
	    })
	  );
	};
	
	Icon.createFromIconfontCN = _IconFont["default"];
	Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
	Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
	var _default = Icon;
	exports["default"] = _default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var allIcons = _interopRequireWildcard(__webpack_require__(507));
	
	var _iconsReact = _interopRequireDefault(__webpack_require__(184));
	
	var _IconFont = _interopRequireDefault(__webpack_require__(1208));
	
	var _utils = __webpack_require__(1210);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _twoTonePrimaryColor = __webpack_require__(1209);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable camelcase */
	
	// Initial setting
	_iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
	  return allIcons[key];
	})));
	
	(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
	var defaultTheme = 'outlined';
	var dangerousTheme;
	
	function unstable_ChangeThemeOfIconsDangerously(theme) {
	  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeThemeOfAllIconsDangerously', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
	  dangerousTheme = theme;
	}
	
	function unstable_ChangeDefaultThemeOfIcons(theme) {
	  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeDefaultThemeOfIcons', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
	  defaultTheme = theme;
	}
	
	var Icon = function Icon(props) {
	  var _classNames;
	
	  var className = props.className,
	      type = props.type,
	      Component = props.component,
	      viewBox = props.viewBox,
	      spin = props.spin,
	      rotate = props.rotate,
	      tabIndex = props.tabIndex,
	      onClick = props.onClick,
	      children = props.children,
	      theme = props.theme,
	      twoToneColor = props.twoToneColor,
	      restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children", "theme", "twoToneColor"]);
	
	  (0, _warning["default"])(Boolean(type || Component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');
	  var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
	  var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
	  var svgStyle = rotate ? {
	    msTransform: "rotate(".concat(rotate, "deg)"),
	    transform: "rotate(".concat(rotate, "deg)")
	  } : undefined;
	
	  var innerSvgProps = _extends(_extends({}, _utils.svgBaseProps), {
	    className: svgClassString,
	    style: svgStyle,
	    viewBox: viewBox
	  });
	
	  if (!viewBox) {
	    delete innerSvgProps.viewBox;
	  }
	
	  var renderInnerNode = function renderInnerNode() {
	    // component > children > type
	    if (Component) {
	      return (/*#__PURE__*/React.createElement(Component, innerSvgProps, children)
	      );
	    }
	
	    if (children) {
	      (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use', 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
	      return (/*#__PURE__*/React.createElement("svg", _extends({}, innerSvgProps, {
	          viewBox: viewBox
	        }), children)
	      );
	    }
	
	    if (typeof type === 'string') {
	      var computedType = type;
	
	      if (theme) {
	        var themeInName = (0, _utils.getThemeFromTypeName)(type);
	        (0, _warning["default"])(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
	      }
	
	      computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)((0, _utils.alias)(computedType)), dangerousTheme || theme || defaultTheme);
	      return (/*#__PURE__*/React.createElement(_iconsReact["default"], {
	          className: svgClassString,
	          type: computedType,
	          primaryColor: twoToneColor,
	          style: svgStyle
	        })
	      );
	    }
	  };
	
	  var iconTabIndex = tabIndex;
	
	  if (iconTabIndex === undefined && onClick) {
	    iconTabIndex = -1;
	  }
	
	  return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	      componentName: "Icon"
	    }, function (locale) {
	      return (/*#__PURE__*/React.createElement("i", _extends({
	          "aria-label": type && "".concat(locale.icon, ": ").concat(type)
	        }, restProps, {
	          tabIndex: iconTabIndex,
	          onClick: onClick,
	          className: classString
	        }), renderInnerNode())
	      );
	    })
	  );
	};
	
	Icon.createFromIconfontCN = _IconFont["default"];
	Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
	Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
	var _default = Icon;
	exports["default"] = _default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var allIcons = _interopRequireWildcard(__webpack_require__(507));
	
	var _iconsReact = _interopRequireDefault(__webpack_require__(184));
	
	var _IconFont = _interopRequireDefault(__webpack_require__(1398));
	
	var _utils = __webpack_require__(1400);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _twoTonePrimaryColor = __webpack_require__(1399);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable camelcase */
	
	// Initial setting
	_iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
	  return allIcons[key];
	})));
	
	(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
	var defaultTheme = 'outlined';
	var dangerousTheme;
	
	function unstable_ChangeThemeOfIconsDangerously(theme) {
	  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeThemeOfAllIconsDangerously', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
	  dangerousTheme = theme;
	}
	
	function unstable_ChangeDefaultThemeOfIcons(theme) {
	  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeDefaultThemeOfIcons', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
	  defaultTheme = theme;
	}
	
	var Icon = function Icon(props) {
	  var _classNames;
	
	  var className = props.className,
	      type = props.type,
	      Component = props.component,
	      viewBox = props.viewBox,
	      spin = props.spin,
	      rotate = props.rotate,
	      tabIndex = props.tabIndex,
	      onClick = props.onClick,
	      children = props.children,
	      theme = props.theme,
	      twoToneColor = props.twoToneColor,
	      restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children", "theme", "twoToneColor"]);
	
	  (0, _warning["default"])(Boolean(type || Component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');
	  var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
	  var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
	  var svgStyle = rotate ? {
	    msTransform: "rotate(".concat(rotate, "deg)"),
	    transform: "rotate(".concat(rotate, "deg)")
	  } : undefined;
	
	  var innerSvgProps = _extends(_extends({}, _utils.svgBaseProps), {
	    className: svgClassString,
	    style: svgStyle,
	    viewBox: viewBox
	  });
	
	  if (!viewBox) {
	    delete innerSvgProps.viewBox;
	  }
	
	  var renderInnerNode = function renderInnerNode() {
	    // component > children > type
	    if (Component) {
	      return (/*#__PURE__*/React.createElement(Component, innerSvgProps, children)
	      );
	    }
	
	    if (children) {
	      (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use', 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
	      return (/*#__PURE__*/React.createElement("svg", _extends({}, innerSvgProps, {
	          viewBox: viewBox
	        }), children)
	      );
	    }
	
	    if (typeof type === 'string') {
	      var computedType = type;
	
	      if (theme) {
	        var themeInName = (0, _utils.getThemeFromTypeName)(type);
	        (0, _warning["default"])(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
	      }
	
	      computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)((0, _utils.alias)(computedType)), dangerousTheme || theme || defaultTheme);
	      return (/*#__PURE__*/React.createElement(_iconsReact["default"], {
	          className: svgClassString,
	          type: computedType,
	          primaryColor: twoToneColor,
	          style: svgStyle
	        })
	      );
	    }
	  };
	
	  var iconTabIndex = tabIndex;
	
	  if (iconTabIndex === undefined && onClick) {
	    iconTabIndex = -1;
	  }
	
	  return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	      componentName: "Icon"
	    }, function (locale) {
	      return (/*#__PURE__*/React.createElement("i", _extends({
	          "aria-label": type && "".concat(locale.icon, ": ").concat(type)
	        }, restProps, {
	          tabIndex: iconTabIndex,
	          onClick: onClick,
	          className: classString
	        }), renderInnerNode())
	      );
	    })
	  );
	};
	
	Icon.createFromIconfontCN = _IconFont["default"];
	Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
	Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
	var _default = Icon;
	exports["default"] = _default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The method "quantile" was copied from "d3.js".
	* (See more details in the comment of the method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var RADIAN_EPSILON = 1e-4;
	
	function _trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	}
	/**
	 * Linear mapping a value from domain to range
	 * @memberOf module:echarts/util/number
	 * @param  {(number|Array.<number>)} val
	 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
	 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
	 * @param  {boolean} clamp
	 * @return {(number|Array.<number>}
	 */
	
	
	function linearMap(val, domain, range, clamp) {
	  var subDomain = domain[1] - domain[0];
	  var subRange = range[1] - range[0];
	
	  if (subDomain === 0) {
	    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
	  } // Avoid accuracy problem in edge, such as
	  // 146.39 - 62.83 === 83.55999999999999.
	  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
	  // It is a little verbose for efficiency considering this method
	  // is a hotspot.
	
	
	  if (clamp) {
	    if (subDomain > 0) {
	      if (val <= domain[0]) {
	        return range[0];
	      } else if (val >= domain[1]) {
	        return range[1];
	      }
	    } else {
	      if (val >= domain[0]) {
	        return range[0];
	      } else if (val <= domain[1]) {
	        return range[1];
	      }
	    }
	  } else {
	    if (val === domain[0]) {
	      return range[0];
	    }
	
	    if (val === domain[1]) {
	      return range[1];
	    }
	  }
	
	  return (val - domain[0]) / subDomain * subRange + range[0];
	}
	/**
	 * Convert a percent string to absolute number.
	 * Returns NaN if percent is not a valid string or number
	 * @memberOf module:echarts/util/number
	 * @param {string|number} percent
	 * @param {number} all
	 * @return {number}
	 */
	
	
	function parsePercent(percent, all) {
	  switch (percent) {
	    case 'center':
	    case 'middle':
	      percent = '50%';
	      break;
	
	    case 'left':
	    case 'top':
	      percent = '0%';
	      break;
	
	    case 'right':
	    case 'bottom':
	      percent = '100%';
	      break;
	  }
	
	  if (typeof percent === 'string') {
	    if (_trim(percent).match(/%$/)) {
	      return parseFloat(percent) / 100 * all;
	    }
	
	    return parseFloat(percent);
	  }
	
	  return percent == null ? NaN : +percent;
	}
	/**
	 * (1) Fix rounding error of float numbers.
	 * (2) Support return string to avoid scientific notation like '3.5e-7'.
	 *
	 * @param {number} x
	 * @param {number} [precision]
	 * @param {boolean} [returnStr]
	 * @return {number|string}
	 */
	
	
	function round(x, precision, returnStr) {
	  if (precision == null) {
	    precision = 10;
	  } // Avoid range error
	
	
	  precision = Math.min(Math.max(0, precision), 20);
	  x = (+x).toFixed(precision);
	  return returnStr ? x : +x;
	}
	/**
	 * asc sort arr.
	 * The input arr will be modified.
	 *
	 * @param {Array} arr
	 * @return {Array} The input arr.
	 */
	
	
	function asc(arr) {
	  arr.sort(function (a, b) {
	    return a - b;
	  });
	  return arr;
	}
	/**
	 * Get precision
	 * @param {number} val
	 */
	
	
	function getPrecision(val) {
	  val = +val;
	
	  if (isNaN(val)) {
	    return 0;
	  } // It is much faster than methods converting number to string as follows
	  //      var tmp = val.toString();
	  //      return tmp.length - 1 - tmp.indexOf('.');
	  // especially when precision is low
	
	
	  var e = 1;
	  var count = 0;
	
	  while (Math.round(val * e) / e !== val) {
	    e *= 10;
	    count++;
	  }
	
	  return count;
	}
	/**
	 * @param {string|number} val
	 * @return {number}
	 */
	
	
	function getPrecisionSafe(val) {
	  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'
	
	  var eIndex = str.indexOf('e');
	
	  if (eIndex > 0) {
	    var precision = +str.slice(eIndex + 1);
	    return precision < 0 ? -precision : 0;
	  } else {
	    var dotIndex = str.indexOf('.');
	    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
	  }
	}
	/**
	 * Minimal dicernible data precisioin according to a single pixel.
	 *
	 * @param {Array.<number>} dataExtent
	 * @param {Array.<number>} pixelExtent
	 * @return {number} precision
	 */
	
	
	function getPixelPrecision(dataExtent, pixelExtent) {
	  var log = Math.log;
	  var LN10 = Math.LN10;
	  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
	  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
	
	  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
	  return !isFinite(precision) ? 20 : precision;
	}
	/**
	 * Get a data of given precision, assuring the sum of percentages
	 * in valueList is 1.
	 * The largest remainer method is used.
	 * https://en.wikipedia.org/wiki/Largest_remainder_method
	 *
	 * @param {Array.<number>} valueList a list of all data
	 * @param {number} idx index of the data to be processed in valueList
	 * @param {number} precision integer number showing digits of precision
	 * @return {number} percent ranging from 0 to 100
	 */
	
	
	function getPercentWithPrecision(valueList, idx, precision) {
	  if (!valueList[idx]) {
	    return 0;
	  }
	
	  var sum = zrUtil.reduce(valueList, function (acc, val) {
	    return acc + (isNaN(val) ? 0 : val);
	  }, 0);
	
	  if (sum === 0) {
	    return 0;
	  }
	
	  var digits = Math.pow(10, precision);
	  var votesPerQuota = zrUtil.map(valueList, function (val) {
	    return (isNaN(val) ? 0 : val) / sum * digits * 100;
	  });
	  var targetSeats = digits * 100;
	  var seats = zrUtil.map(votesPerQuota, function (votes) {
	    // Assign automatic seats.
	    return Math.floor(votes);
	  });
	  var currentSum = zrUtil.reduce(seats, function (acc, val) {
	    return acc + val;
	  }, 0);
	  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
	    return votes - seats[idx];
	  }); // Has remainding votes.
	
	  while (currentSum < targetSeats) {
	    // Find next largest remainder.
	    var max = Number.NEGATIVE_INFINITY;
	    var maxId = null;
	
	    for (var i = 0, len = remainder.length; i < len; ++i) {
	      if (remainder[i] > max) {
	        max = remainder[i];
	        maxId = i;
	      }
	    } // Add a vote to max remainder.
	
	
	    ++seats[maxId];
	    remainder[maxId] = 0;
	    ++currentSum;
	  }
	
	  return seats[idx] / digits;
	} // Number.MAX_SAFE_INTEGER, ie do not support.
	
	
	var MAX_SAFE_INTEGER = 9007199254740991;
	/**
	 * To 0 - 2 * PI, considering negative radian.
	 * @param {number} radian
	 * @return {number}
	 */
	
	function remRadian(radian) {
	  var pi2 = Math.PI * 2;
	  return (radian % pi2 + pi2) % pi2;
	}
	/**
	 * @param {type} radian
	 * @return {boolean}
	 */
	
	
	function isRadianAroundZero(val) {
	  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
	}
	/* eslint-disable */
	
	
	var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
	
	/* eslint-enable */
	
	/**
	 * @param {string|Date|number} value These values can be accepted:
	 *   + An instance of Date, represent a time in its own time zone.
	 *   + Or string in a subset of ISO 8601, only including:
	 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
	 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
	 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
	 *     all of which will be treated as local time if time zone is not specified
	 *     (see <https://momentjs.com/>).
	 *   + Or other string format, including (all of which will be treated as loacal time):
	 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
	 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
	 *   + a timestamp, which represent a time in UTC.
	 * @return {Date} date
	 */
	
	function parseDate(value) {
	  if (value instanceof Date) {
	    return value;
	  } else if (typeof value === 'string') {
	    // Different browsers parse date in different way, so we parse it manually.
	    // Some other issues:
	    // new Date('1970-01-01') is UTC,
	    // new Date('1970/01/01') and new Date('1970-1-01') is local.
	    // See issue #3623
	    var match = TIME_REG.exec(value);
	
	    if (!match) {
	      // return Invalid Date.
	      return new Date(NaN);
	    } // Use local time when no timezone offset specifed.
	
	
	    if (!match[8]) {
	      // match[n] can only be string or undefined.
	      // But take care of '12' + 1 => '121'.
	      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
	    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
	    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
	    // For example, system timezone is set as "Time Zone: America/Toronto",
	    // then these code will get different result:
	    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
	    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
	    // So we should not use `new Date`, but use `Date.UTC`.
	    else {
	        var hour = +match[4] || 0;
	
	        if (match[8].toUpperCase() !== 'Z') {
	          hour -= match[8].slice(0, 3);
	        }
	
	        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
	      }
	  } else if (value == null) {
	    return new Date(NaN);
	  }
	
	  return new Date(Math.round(value));
	}
	/**
	 * Quantity of a number. e.g. 0.1, 1, 10, 100
	 *
	 * @param  {number} val
	 * @return {number}
	 */
	
	
	function quantity(val) {
	  return Math.pow(10, quantityExponent(val));
	}
	/**
	 * Exponent of the quantity of a number
	 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
	 *
	 * @param  {number} val non-negative value
	 * @return {number}
	 */
	
	
	function quantityExponent(val) {
	  if (val === 0) {
	    return 0;
	  }
	
	  var exp = Math.floor(Math.log(val) / Math.LN10);
	  /**
	   * exp is expected to be the rounded-down result of the base-10 log of val.
	   * But due to the precision loss with Math.log(val), we need to restore it
	   * using 10^exp to make sure we can get val back from exp. #11249
	   */
	
	  if (val / Math.pow(10, exp) >= 10) {
	    exp++;
	  }
	
	  return exp;
	}
	/**
	 * find a “nice” number approximately equal to x. Round the number if round = true,
	 * take ceiling if round = false. The primary observation is that the “nicest”
	 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
	 *
	 * See "Nice Numbers for Graph Labels" of Graphic Gems.
	 *
	 * @param  {number} val Non-negative value.
	 * @param  {boolean} round
	 * @return {number}
	 */
	
	
	function nice(val, round) {
	  var exponent = quantityExponent(val);
	  var exp10 = Math.pow(10, exponent);
	  var f = val / exp10; // 1 <= f < 10
	
	  var nf;
	
	  if (round) {
	    if (f < 1.5) {
	      nf = 1;
	    } else if (f < 2.5) {
	      nf = 2;
	    } else if (f < 4) {
	      nf = 3;
	    } else if (f < 7) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  } else {
	    if (f < 1) {
	      nf = 1;
	    } else if (f < 2) {
	      nf = 2;
	    } else if (f < 3) {
	      nf = 3;
	    } else if (f < 5) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  }
	
	  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
	  // 20 is the uppper bound of toFixed.
	
	  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
	}
	/**
	 * This code was copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
	 * See the license statement at the head of this file.
	 * @param {Array.<number>} ascArr
	 */
	
	
	function quantile(ascArr, p) {
	  var H = (ascArr.length - 1) * p + 1;
	  var h = Math.floor(H);
	  var v = +ascArr[h - 1];
	  var e = H - h;
	  return e ? v + e * (ascArr[h] - v) : v;
	}
	/**
	 * Order intervals asc, and split them when overlap.
	 * expect(numberUtil.reformIntervals([
	 *     {interval: [18, 62], close: [1, 1]},
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [1, 1]},
	 *     {interval: [62, 150], close: [1, 1]},
	 *     {interval: [106, 150], close: [1, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ])).toEqual([
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [0, 1]},
	 *     {interval: [18, 62], close: [0, 1]},
	 *     {interval: [62, 150], close: [0, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ]);
	 * @param {Array.<Object>} list, where `close` mean open or close
	 *        of the interval, and Infinity can be used.
	 * @return {Array.<Object>} The origin list, which has been reformed.
	 */
	
	
	function reformIntervals(list) {
	  list.sort(function (a, b) {
	    return littleThan(a, b, 0) ? -1 : 1;
	  });
	  var curr = -Infinity;
	  var currClose = 1;
	
	  for (var i = 0; i < list.length;) {
	    var interval = list[i].interval;
	    var close = list[i].close;
	
	    for (var lg = 0; lg < 2; lg++) {
	      if (interval[lg] <= curr) {
	        interval[lg] = curr;
	        close[lg] = !lg ? 1 - currClose : 1;
	      }
	
	      curr = interval[lg];
	      currClose = close[lg];
	    }
	
	    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
	      list.splice(i, 1);
	    } else {
	      i++;
	    }
	  }
	
	  return list;
	
	  function littleThan(a, b, lg) {
	    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
	  }
	}
	/**
	 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
	 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	 * subtraction forces infinities to NaN
	 *
	 * @param {*} v
	 * @return {boolean}
	 */
	
	
	function isNumeric(v) {
	  return v - parseFloat(v) >= 0;
	}
	
	exports.linearMap = linearMap;
	exports.parsePercent = parsePercent;
	exports.round = round;
	exports.asc = asc;
	exports.getPrecision = getPrecision;
	exports.getPrecisionSafe = getPrecisionSafe;
	exports.getPixelPrecision = getPixelPrecision;
	exports.getPercentWithPrecision = getPercentWithPrecision;
	exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
	exports.remRadian = remRadian;
	exports.isRadianAroundZero = isRadianAroundZero;
	exports.parseDate = parseDate;
	exports.quantity = quantity;
	exports.quantityExponent = quantityExponent;
	exports.nice = nice;
	exports.quantile = quantile;
	exports.reformIntervals = reformIntervals;
	exports.isNumeric = isNumeric;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(719);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
	
	var _flattenNames = __webpack_require__(1982);
	
	var _flattenNames2 = _interopRequireDefault(_flattenNames);
	
	var _mergeClasses = __webpack_require__(1984);
	
	var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
	
	var _autoprefix = __webpack_require__(1979);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _hover2 = __webpack_require__(1981);
	
	var _hover3 = _interopRequireDefault(_hover2);
	
	var _active = __webpack_require__(1980);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _loop2 = __webpack_require__(1983);
	
	var _loop3 = _interopRequireDefault(_loop2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.hover = _hover3.default;
	exports.handleHover = _hover3.default;
	exports.handleActive = _active2.default;
	exports.loop = _loop3.default;
	var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
	  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    activations[_key - 1] = arguments[_key];
	  }
	
	  var activeNames = (0, _flattenNames2.default)(activations);
	  var merged = (0, _mergeClasses2.default)(classes, activeNames);
	  return (0, _autoprefix2.default)(merged);
	};
	
	exports.default = ReactCSS;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var isArray = zrUtil.isArray;
	/**
	 * Make the name displayable. But we should
	 * make sure it is not duplicated with user
	 * specified name, so use '\0';
	 */
	
	var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
	/**
	 * If value is not array, then translate it to array.
	 * @param  {*} value
	 * @return {Array} [value] or value
	 */
	
	function normalizeToArray(value) {
	  return value instanceof Array ? value : value == null ? [] : [value];
	}
	/**
	 * Sync default option between normal and emphasis like `position` and `show`
	 * In case some one will write code like
	 *     label: {
	 *          show: false,
	 *          position: 'outside',
	 *          fontSize: 18
	 *     },
	 *     emphasis: {
	 *          label: { show: true }
	 *     }
	 * @param {Object} opt
	 * @param {string} key
	 * @param {Array.<string>} subOpts
	 */
	
	
	function defaultEmphasis(opt, key, subOpts) {
	  // Caution: performance sensitive.
	  if (opt) {
	    opt[key] = opt[key] || {};
	    opt.emphasis = opt.emphasis || {};
	    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
	
	    for (var i = 0, len = subOpts.length; i < len; i++) {
	      var subOptName = subOpts[i];
	
	      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
	        opt.emphasis[key][subOptName] = opt[key][subOptName];
	      }
	    }
	  }
	}
	
	var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
	//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
	//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
	//     // FIXME: deprecated, check and remove it.
	//     'textStyle'
	// ]);
	
	/**
	 * The method do not ensure performance.
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method retieves value from data.
	 * @param {string|number|Date|Array|Object} dataItem
	 * @return {number|string|Date|Array.<number|string|Date>}
	 */
	
	function getDataItemValue(dataItem) {
	  return isObject(dataItem) && !isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
	}
	/**
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method determine if dataItem has extra option besides value
	 * @param {string|number|Date|Array|Object} dataItem
	 */
	
	
	function isDataItemOption(dataItem) {
	  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
	  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
	}
	/**
	 * Mapping to exists for merge.
	 *
	 * @public
	 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
	 * @param {Object|Array.<Object>} newCptOptions
	 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          index of which is the same as exists.
	 */
	
	
	function mappingToExists(exists, newCptOptions) {
	  // Mapping by the order by original option (but not order of
	  // new option) in merge mode. Because we should ensure
	  // some specified index (like xAxisIndex) is consistent with
	  // original option, which is easy to understand, espatially in
	  // media query. And in most case, merge option is used to
	  // update partial option but not be expected to change order.
	  newCptOptions = (newCptOptions || []).slice();
	  var result = zrUtil.map(exists || [], function (obj, index) {
	    return {
	      exist: obj
	    };
	  }); // Mapping by id or name if specified.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    } // id has highest priority.
	
	
	    for (var i = 0; i < result.length; i++) {
	      if (!result[i].option // Consider name: two map to one.
	      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	
	    for (var i = 0; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Consider name: two map to one.
	      // Can not match when both ids exist but different.
	      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	  }); // Otherwise mapping by index.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    }
	
	    var i = 0;
	
	    for (; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Existing model that already has id should be able to
	      // mapped to (because after mapping performed model may
	      // be assigned with a id, whish should not affect next
	      // mapping), except those has inner id.
	      && !isIdInner(exist) // Caution:
	      // Do not overwrite id. But name can be overwritten,
	      // because axis use name as 'show label text'.
	      // 'exist' always has id and name and we dont
	      // need to check it.
	      && cptOption.id == null) {
	        result[i].option = cptOption;
	        break;
	      }
	    }
	
	    if (i >= result.length) {
	      result.push({
	        option: cptOption
	      });
	    }
	  });
	  return result;
	}
	/**
	 * Make id and name for mapping result (result of mappingToExists)
	 * into `keyInfo` field.
	 *
	 * @public
	 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          which order is the same as exists.
	 * @return {Array.<Object>} The input.
	 */
	
	
	function makeIdAndName(mapResult) {
	  // We use this id to hash component models and view instances
	  // in echarts. id can be specified by user, or auto generated.
	  // The id generation rule ensures new view instance are able
	  // to mapped to old instance when setOption are called in
	  // no-merge mode. So we generate model id by name and plus
	  // type in view id.
	  // name can be duplicated among components, which is convenient
	  // to specify multi components (like series) by one name.
	  // Ensure that each id is distinct.
	  var idMap = zrUtil.createHashMap();
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    existCpt && idMap.set(existCpt.id, item);
	  });
	  each(mapResult, function (item, index) {
	    var opt = item.option;
	    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
	    opt && opt.id != null && idMap.set(opt.id, item);
	    !item.keyInfo && (item.keyInfo = {});
	  }); // Make name and id.
	
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    var opt = item.option;
	    var keyInfo = item.keyInfo;
	
	    if (!isObject(opt)) {
	      return;
	    } // name can be overwitten. Consider case: axis.name = '20km'.
	    // But id generated by name will not be changed, which affect
	    // only in that case: setOption with 'not merge mode' and view
	    // instance will be recreated, which can be accepted.
	
	
	    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name // Avoid diffferent series has the same name,
	    // because name may be used like in color pallet.
	    : DUMMY_COMPONENT_NAME_PREFIX + index;
	
	    if (existCpt) {
	      keyInfo.id = existCpt.id;
	    } else if (opt.id != null) {
	      keyInfo.id = opt.id + '';
	    } else {
	      // Consider this situatoin:
	      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
	      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
	      // Series with the same name between optionA and optionB
	      // should be mapped.
	      var idNum = 0;
	
	      do {
	        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
	      } while (idMap.get(keyInfo.id));
	    }
	
	    idMap.set(keyInfo.id, item);
	  });
	}
	
	function isNameSpecified(componentModel) {
	  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
	
	  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
	}
	/**
	 * @public
	 * @param {Object} cptOption
	 * @return {boolean}
	 */
	
	
	function isIdInner(cptOption) {
	  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
	}
	/**
	 * A helper for removing duplicate items between batchA and batchB,
	 * and in themselves, and categorize by series.
	 *
	 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
	 */
	
	
	function compressBatches(batchA, batchB) {
	  var mapA = {};
	  var mapB = {};
	  makeMap(batchA || [], mapA);
	  makeMap(batchB || [], mapB, mapA);
	  return [mapToArray(mapA), mapToArray(mapB)];
	
	  function makeMap(sourceBatch, map, otherMap) {
	    for (var i = 0, len = sourceBatch.length; i < len; i++) {
	      var seriesId = sourceBatch[i].seriesId;
	      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
	      var otherDataIndices = otherMap && otherMap[seriesId];
	
	      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
	        var dataIndex = dataIndices[j];
	
	        if (otherDataIndices && otherDataIndices[dataIndex]) {
	          otherDataIndices[dataIndex] = null;
	        } else {
	          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
	        }
	      }
	    }
	  }
	
	  function mapToArray(map, isData) {
	    var result = [];
	
	    for (var i in map) {
	      if (map.hasOwnProperty(i) && map[i] != null) {
	        if (isData) {
	          result.push(+i);
	        } else {
	          var dataIndices = mapToArray(map[i], true);
	          dataIndices.length && result.push({
	            seriesId: i,
	            dataIndex: dataIndices
	          });
	        }
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
	 *                         each of which can be Array or primary type.
	 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
	 */
	
	
	function queryDataIndex(data, payload) {
	  if (payload.dataIndexInside != null) {
	    return payload.dataIndexInside;
	  } else if (payload.dataIndex != null) {
	    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
	      return data.indexOfRawIndex(value);
	    }) : data.indexOfRawIndex(payload.dataIndex);
	  } else if (payload.name != null) {
	    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
	      return data.indexOfName(value);
	    }) : data.indexOfName(payload.name);
	  }
	}
	/**
	 * Enable property storage to any host object.
	 * Notice: Serialization is not supported.
	 *
	 * For example:
	 * var inner = zrUitl.makeInner();
	 *
	 * function some1(hostObj) {
	 *      inner(hostObj).someProperty = 1212;
	 *      ...
	 * }
	 * function some2() {
	 *      var fields = inner(this);
	 *      fields.someProperty1 = 1212;
	 *      fields.someProperty2 = 'xx';
	 *      ...
	 * }
	 *
	 * @return {Function}
	 */
	
	
	function makeInner() {
	  // Consider different scope by es module import.
	  var key = '__\0ec_inner_' + innerUniqueIndex++ + '_' + Math.random().toFixed(5);
	  return function (hostObj) {
	    return hostObj[key] || (hostObj[key] = {});
	  };
	}
	
	var innerUniqueIndex = 0;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex, seriesId, seriesName,
	 *            geoIndex, geoId, geoName,
	 *            bmapIndex, bmapId, bmapName,
	 *            xAxisIndex, xAxisId, xAxisName,
	 *            yAxisIndex, yAxisId, yAxisName,
	 *            gridIndex, gridId, gridName,
	 *            ... (can be extended)
	 *        }
	 *        Each properties can be number|string|Array.<number>|Array.<string>
	 *        For example, a finder could be
	 *        {
	 *            seriesIndex: 3,
	 *            geoId: ['aa', 'cc'],
	 *            gridName: ['xx', 'rr']
	 *        }
	 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
	 *        If nothing or null/undefined specified, return nothing.
	 * @param {Object} [opt]
	 * @param {string} [opt.defaultMainType]
	 * @param {Array.<string>} [opt.includeMainTypes]
	 * @return {Object} result like:
	 *        {
	 *            seriesModels: [seriesModel1, seriesModel2],
	 *            seriesModel: seriesModel1, // The first model
	 *            geoModels: [geoModel1, geoModel2],
	 *            geoModel: geoModel1, // The first model
	 *            ...
	 *        }
	 */
	
	function parseFinder(ecModel, finder, opt) {
	  if (zrUtil.isString(finder)) {
	    var obj = {};
	    obj[finder + 'Index'] = 0;
	    finder = obj;
	  }
	
	  var defaultMainType = opt && opt.defaultMainType;
	
	  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
	    finder[defaultMainType + 'Index'] = 0;
	  }
	
	  var result = {};
	  each(finder, function (value, key) {
	    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.
	
	    if (key === 'dataIndex' || key === 'dataIndexInside') {
	      result[key] = value;
	      return;
	    }
	
	    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
	    var mainType = parsedKey[1];
	    var queryType = (parsedKey[2] || '').toLowerCase();
	
	    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
	      return;
	    }
	
	    var queryParam = {
	      mainType: mainType
	    };
	
	    if (queryType !== 'index' || value !== 'all') {
	      queryParam[queryType] = value;
	    }
	
	    var models = ecModel.queryComponents(queryParam);
	    result[mainType + 'Models'] = models;
	    result[mainType + 'Model'] = models[0];
	  });
	  return result;
	}
	
	function has(obj, prop) {
	  return obj && obj.hasOwnProperty(prop);
	}
	
	function setAttribute(dom, key, value) {
	  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
	}
	
	function getAttribute(dom, key) {
	  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
	}
	
	function getTooltipRenderMode(renderModeOption) {
	  if (renderModeOption === 'auto') {
	    // Using html when `document` exists, use richText otherwise
	    return env.domSupported ? 'html' : 'richText';
	  } else {
	    return renderModeOption || 'html';
	  }
	}
	/**
	 * Group a list by key.
	 *
	 * @param {Array} array
	 * @param {Function} getKey
	 *        param {*} Array item
	 *        return {string} key
	 * @return {Object} Result
	 *        {Array}: keys,
	 *        {module:zrender/core/util/HashMap} buckets: {key -> Array}
	 */
	
	
	function groupData(array, getKey) {
	  var buckets = zrUtil.createHashMap();
	  var keys = [];
	  zrUtil.each(array, function (item) {
	    var key = getKey(item);
	    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
	  });
	  return {
	    keys: keys,
	    buckets: buckets
	  };
	}
	
	exports.normalizeToArray = normalizeToArray;
	exports.defaultEmphasis = defaultEmphasis;
	exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
	exports.getDataItemValue = getDataItemValue;
	exports.isDataItemOption = isDataItemOption;
	exports.mappingToExists = mappingToExists;
	exports.makeIdAndName = makeIdAndName;
	exports.isNameSpecified = isNameSpecified;
	exports.isIdInner = isIdInner;
	exports.compressBatches = compressBatches;
	exports.queryDataIndex = queryDataIndex;
	exports.makeInner = makeInner;
	exports.parseFinder = parseFinder;
	exports.setAttribute = setAttribute;
	exports.getAttribute = getAttribute;
	exports.getTooltipRenderMode = getTooltipRenderMode;
	exports.groupData = groupData;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.destroyAllModal = exports.sgiEncrypt = exports.sgiZip = exports.removeCookieByPrefix = exports.deleteCookie = exports.getCookie = exports.setCookie = exports.itemForEach = exports.getType = exports.assignArrayStr = exports.assignPropsNotUndefined = exports.assignProps = exports.deepCopyAll = exports.DateOpt = exports.createElement = exports.md5 = exports.getJsonLength = exports.copyArr = exports.Format = exports.sgiArray = exports.copy = exports.getLeafByPrm = exports.copyJsonAttr = exports.getAP = exports.strToJson = exports.HtmlUtil = exports.funStrCheck = exports.isJSON = exports.jsonToStr = exports.uuidDate = exports.uuid = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               * @Descripttion: 
	                                                                                                                                                                                                                                                                               * @version: 
	                                                                                                                                                                                                                                                                               * @Author: wangz
	                                                                                                                                                                                                                                                                               * @Date: 2019-11-21 14:58:03
	                                                                                                                                                                                                                                                                               * @LastEditors: hanzb
	                                                                                                                                                                                                                                                                               * @LastEditTime: 2020-04-02 10:59:13
	                                                                                                                                                                                                                                                                               */
	
	var _sgiCommonConstant = __webpack_require__(241);
	
	var _sgiAntdModule = __webpack_require__(625);
	
	var _sgiAntdModule2 = _interopRequireDefault(_sgiAntdModule);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MD = __webpack_require__(1148);
	
	var _MD2 = _interopRequireDefault(_MD);
	
	var _jszip = __webpack_require__(1879);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	var _cryptoJs = __webpack_require__(1133);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	var _antd = __webpack_require__(296);
	
	var _sgiLogger = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sgiEncrypt = {
		aseKey: "12345678", //秘钥必须为：8/16/32位
		//加密 DES/AES切换只需要修改 CryptoJS.AES <=> CryptoJS.DES
		encrypt: function encrypt(message) {
			if (!message) return message;
			return _cryptoJs2.default.AES.encrypt(message + "", _cryptoJs2.default.enc.Utf8.parse(this.aseKey), {
				mode: _cryptoJs2.default.mode.ECB,
				padding: _cryptoJs2.default.pad.Pkcs7
			}).toString();
		},
		//解密
		decrypt: function decrypt(encryptMessage) {
			if (!encryptMessage) return encryptMessage;
			return _cryptoJs2.default.AES.decrypt(encryptMessage, _cryptoJs2.default.enc.Utf8.parse(this.aseKey), {
				mode: _cryptoJs2.default.mode.ECB,
				padding: _cryptoJs2.default.pad.Pkcs7
			}).toString(_cryptoJs2.default.enc.Utf8);
		}
	
		/**
	  * 平台提供压缩方法
	  */
	};var sgiZip = {
	
		zip: function zip(key, value) {
			try {
				var zip = new _jszip2.default();
				zip.file(key, value);
				return zip.generate({
					'compression': 'DEFLATE',
					type: "string"
				});
			} catch (error) {
				_sgiLogger.sgiLogger.log(error);
			}
		},
		unzip: function unzip(key, value) {
			try {
				var zip = new _jszip2.default();
				zip.load(value);
				return zip.file(key).asText();
			} catch (error) {
				_sgiLogger.sgiLogger.log(error);
			}
		}
	
		/**
	  * 用浏览器内部转换器实现html转码
	  * @namespace html转码器
	  * @alias tool.HtmlUtil
	  */
	};var HtmlUtil = {
		/**
	  * 1、用浏览器内部转换器实现html转码
	  * @param {*} html 
	  * @returns {*}
	  */
		htmlEncode: function htmlEncode(html) {
			//1.首先动态创建一个容器标签元素，如DIV
			var temp = document.createElement("div");
			//2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
			temp.textContent != undefined ? temp.textContent = html : temp.innerText = html;
			//3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
			var output = temp.innerHTML;
			temp = null;
			return output;
		},
		/**
	  * 2、用浏览器内部转换器实现html解码
	  * @param {*} text 
	  * @returns {*} 
	  */
		htmlDecode: function htmlDecode(text) {
			//1.首先动态创建一个容器标签元素，如DIV
			var temp = document.createElement("div");
			//2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
			temp.innerHTML = text;
			//3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
			var output = temp.innerText || temp.textContent;
			temp = null;
			return output;
		}
	};
	
	/**
	 * 指定长度和进制的UUID
	 * @param {number} [len] 长度
	 * @param {number} [radix] 进制，2,8,10,16
	 * @returns {string} id
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function uuid(len, radix) {
		var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
		var uuid = [],
		    i;
		radix = radix || chars.length;
	
		if (len) {
			// Compact form
			for (i = 0; i < len; i++) {
				uuid[i] = chars[0 | Math.random() * radix];
			}
		} else {
			// rfc4122, version 4 form
			var r;
	
			// rfc4122 requires these characters
			uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
			uuid[14] = '4';
	
			// Fill in random data. At i==19 set the high bits of clock sequence as per
			// rfc4122, sec. 4.1.5
			for (i = 0; i < 36; i++) {
				if (!uuid[i]) {
					r = 0 | Math.random() * 16;
					uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
				}
			}
		}
	
		return uuid.join('');
	}
	
	/**
	 * 包装React.createElement，动态创建组件
	 * @param {string} tag element标签，支持html原生（例："div"）、antd（以antd_开始，例："antd_Input"）、自定义组件
	 * @param {object} [attr] 属性对象
	 * @param {element|element[]} [children] 子组件/子组件数组
	 * @param {boolean} [customeFlag=false] 自定义组件标识
	 * @returns {element} 动态生成的元素实例
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function createElement(tag, attr, children, customeFlag) {
	
		if (!tag) return;
	
		if (typeof tag === "string" && (tag.substr(0, 5) === "antd_" || tag.substr(0, 5) === "antd-")) {
			// antd组件
			tag = _sgiAntdModule2.default[tag.substring(5)];
			if (!tag) return;
		} else if (customeFlag) {
			// 自定义组件
			tag = sgiCustomModule[tag];
			if (!tag) return;
		}
	
		if (attr) attr.ref = refFunction;
	
		return _react2.default.createElement(tag, attr, children);
	}
	
	/**
	 * 生成uuid，当前时间+指定长度的随机数，默认：6位
	 * @param {number} len 长度
	 * @param {string} [format="yyyyMMddhhmmss"] 格式化，默认"yyyyMMddhhmmss"
	 * @returns {string} 生成的uuid
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function uuidDate(len, format) {
		var date = new Date();
		var strD = date.format(format || "yyyyMMddhhmmss");
		var Num = "";
		if (!len && len !== 0) {
			len = 6;
		}
		for (var i = 0; i < len; i++) {
			Num += Math.floor(Math.random() * 10);
		}
		return strD + Num;
	}
	
	/**
	 * 添加部分日期操作方法
	 * @namespace 日期追加方法集
	 * @alias Date
	 */
	
	/**
	 * 日期格式化format，格式化样式例如："yyyy-MM-dd hh:mm:ss:SSS"
	 * @param {string} fmt 格式化
	 * @returns {string} 格式化后的日期字符串
	 */
	Date.prototype.format = function (fmt) {
		var o = {
			"M+": this.getMonth() + 1, //月份
			"d+": this.getDate(), //日
			"h+": this.getHours(), //小时
			"m+": this.getMinutes(), //分
			"s+": this.getSeconds(), //秒
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度
			"S+": this.getMilliseconds() //毫秒
		};
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
		for (var k in o) {
			// if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("000" + o[k]).substr(-RegExp.$1.length));
		}return fmt;
	};
	
	/**
	 * 把日期分割成数组,返回数组：[getFullYear(),getMonth(),getDate(),getHours(),getMinutes(),getSeconds()]
	 * @returns {array} [getFullYear(),getMonth(),getDate(),getHours(),getMinutes(),getSeconds()]
	 */
	//+--------------------------------------------------- 
	//| 把日期分割成数组 
	//+--------------------------------------------------- 
	Date.prototype.toArray = function () {
		var myDate = this;
		var myArray = Array();
		myArray[0] = myDate.getFullYear();
		myArray[1] = myDate.getMonth();
		myArray[2] = myDate.getDate();
		myArray[3] = myDate.getHours();
		myArray[4] = myDate.getMinutes();
		myArray[5] = myDate.getSeconds();
		return myArray;
	};
	
	/**
	 * 取得日期数据信息 
	 * 参数 interval 表示数据类型
	 * y年 m月 d日 w星期 ww周 h时 n分 s秒 
	 * @param {y|m|d|w|ww|h|n|s} interval 获取信息类型
	 * @returns {any} 对应信息
	 */
	//+--------------------------------------------------- 
	//| 取得日期数据信息 
	//| 参数 interval 表示数据类型 
	//| y 年 m月 d日 w星期 ww周 h时 n分 s秒 
	//+--------------------------------------------------- 
	Date.prototype.DatePart = function (interval) {
		var myDate = this;
		var partStr = '';
		var Week = ['日', '一', '二', '三', '四', '五', '六'];
		switch (interval) {
			case 'y':
				partStr = myDate.getFullYear();break;
			case 'm':
				partStr = myDate.getMonth() + 1;break;
			case 'd':
				partStr = myDate.getDate();break;
			case 'w':
				partStr = Week[myDate.getDay()];break;
			case 'ww':
				partStr = myDate.WeekNumOfYear();break;
			case 'h':
				partStr = myDate.getHours();break;
			case 'n':
				partStr = myDate.getMinutes();break;
			case 's':
				partStr = myDate.getSeconds();break;
		}
		return partStr;
	};
	
	/**
	 * 取得当前日期所在月的最大天数
	 * @returns {*} 最大天数
	 */
	//+--------------------------------------------------- 
	//| 取得当前日期所在月的最大天数 
	//+--------------------------------------------------- 
	Date.prototype.MaxDayOfDate = function () {
		var myDate = this;
		var ary = myDate.toArray();
		var date1 = new Date(ary[0], ary[1] + 1, 1);
		var date2 = date1.dateAdd(1, 'm', 1);
		var result = dateDiff(date1.Format('yyyy-MM-dd'), date2.Format('yyyy-MM-dd'));
		return result;
	};
	
	/**
	 * 判断闰年
	 * @returns {boolean} 是否是闰年
	 */
	//--------------------------------------------------- 
	// 判断闰年 
	//--------------------------------------------------- 
	Date.prototype.isLeapYear = function () {
		return 0 == this.getYear() % 4 && (this.getYear() % 100 != 0 || this.getYear() % 400 == 0);
	};
	
	/**
	 * 日期格式化Format
	 * 格式 YYYY/yyyy/YY/yy 表示年份 
	 * MM/M 月份 
	 * W/w 星期 
	 * dd/DD/d/D 日期 
	 * hh/HH/h/H 时间 
	 * mm/m 分钟 
	 * ss/SS/s/S 秒 
	 * @param {string} formatStr 格式化
	 * @returns {string} 格式化后的日期字符串
	 */
	//--------------------------------------------------- 
	// 日期格式化 
	// 格式 YYYY/yyyy/YY/yy 表示年份 
	// MM/M 月份 
	// W/w 星期 
	// dd/DD/d/D 日期 
	// hh/HH/h/H 时间 
	// mm/m 分钟 
	// ss/SS/s/S 秒 
	//--------------------------------------------------- 
	Date.prototype.Format = function (formatStr) {
		var str = formatStr;
		var Week = ['日', '一', '二', '三', '四', '五', '六'];
	
		str = str.replace(/yyyy|YYYY/, this.getFullYear());
		str = str.replace(/yy|YY/, this.getYear() % 100 > 9 ? (this.getYear() % 100).toString() : '0' + this.getYear() % 100);
	
		str = str.replace(/MM/, this.getMonth() > 9 ? this.getMonth().toString() : '0' + this.getMonth());
		str = str.replace(/M/g, this.getMonth());
	
		str = str.replace(/w|W/g, Week[this.getDay()]);
	
		str = str.replace(/dd|DD/, this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate());
		str = str.replace(/d|D/g, this.getDate());
	
		str = str.replace(/hh|HH/, this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours());
		str = str.replace(/h|H/g, this.getHours());
		str = str.replace(/mm/, this.getMinutes() > 9 ? this.getMinutes().toString() : '0' + this.getMinutes());
		str = str.replace(/m/g, this.getMinutes());
	
		str = str.replace(/ss|SS/, this.getSeconds() > 9 ? this.getSeconds().toString() : '0' + this.getSeconds());
		str = str.replace(/s|S/g, this.getSeconds());
	
		return str;
	};
	
	/**
	 * 日期计算：s-秒，n-分，h-小时，d-天，w-周，q-季度，m-月，y-年
	 * @param {s|n|h|d|w|q|m|y} strInterval 计算类型
	 * @param {number} Number 加多少，可为负数，代表减
	 * @returns {Date} 计算后的date
	 */
	//+--------------------------------------------------- 
	//| 日期计算 
	//+--------------------------------------------------- 
	Date.prototype.DateAdd = function (strInterval, Number) {
		var dtTmp = this;
		switch (strInterval) {
			case 's':
				return new Date(Date.parse(dtTmp) + 1000 * Number);
			case 'n':
				return new Date(Date.parse(dtTmp) + 60000 * Number);
			case 'h':
				return new Date(Date.parse(dtTmp) + 3600000 * Number);
			case 'd':
				return new Date(Date.parse(dtTmp) + 86400000 * Number);
			case 'w':
				return new Date(Date.parse(dtTmp) + 86400000 * 7 * Number);
			case 'q':
				return new Date(dtTmp.getFullYear(), dtTmp.getMonth() + Number * 3, dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
			case 'm':
				return new Date(dtTmp.getFullYear(), dtTmp.getMonth() + Number, dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
			case 'y':
				return new Date(dtTmp.getFullYear() + Number, dtTmp.getMonth(), dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
		}
	};
	
	/**
	 * 比较日期差 dtEnd 格式为日期型或者 有效日期格式字符串 
	 * @param {s|n|h|d|w|m|y} strInterval 比对类型
	 * @param {string|Date} dtEnd 格式为日期型或者 有效日期格式字符串
	 */
	//+--------------------------------------------------- 
	//| 比较日期差 dtEnd 格式为日期型或者 有效日期格式字符串 
	//+--------------------------------------------------- 
	Date.prototype.DateDiff = function (strInterval, dtEnd) {
		var dtStart = this;
		if (typeof dtEnd == 'string') //如果是字符串转换为日期型 
			{
				dtEnd = StringToDate(dtEnd);
			}
		switch (strInterval) {
			case 's':
				return parseInt((dtEnd - dtStart) / 1000);
			case 'n':
				return parseInt((dtEnd - dtStart) / 60000);
			case 'h':
				return parseInt((dtEnd - dtStart) / 3600000);
			case 'd':
				return parseInt((dtEnd - dtStart) / 86400000);
			case 'w':
				return parseInt((dtEnd - dtStart) / (86400000 * 7));
			case 'm':
				return dtEnd.getMonth() + 1 + (dtEnd.getFullYear() - dtStart.getFullYear()) * 12 - (dtStart.getMonth() + 1);
			case 'y':
				return dtEnd.getFullYear() - dtStart.getFullYear();
		}
	};
	
	/**
	 * 日期输出字符串，重载了系统的toString方法
	 * @param {boolean} showWeek 是否显示星期
	 * @returns {string} 返回日期字符串
	 */
	//+--------------------------------------------------- 
	//| 日期输出字符串，重载了系统的toString方法 
	//+--------------------------------------------------- 
	Date.prototype.toString = function (showWeek) {
		var myDate = this;
		var str = myDate.toLocaleDateString();
		if (showWeek) {
			var Week = ['日', '一', '二', '三', '四', '五', '六'];
			str += ' 星期' + Week[myDate.getDay()];
		}
		return str;
	};
	
	/**
	 * 部分日期操作方法集
	 * @namespace 日期操作方法集
	 * @alias tool.DateOpt
	 */
	var DateOpt = {
		/**
	  * 求两个时间的天数差，日期格式为："YYYY-MM-dd"
	  * @param {string} DateOne 第一个日期
	  * @param {string} DateTwo 第二个日期
	  * @returns {*} 天数差
	  */
		//+--------------------------------------------------- 
		//| 求两个时间的天数差 日期格式为 YYYY-MM-dd 
		//+--------------------------------------------------- 
		daysBetween: function daysBetween(DateOne, DateTwo) {
			var OneMonth = DateOne.substring(5, DateOne.lastIndexOf('-'));
			var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf('-') + 1);
			var OneYear = DateOne.substring(0, DateOne.indexOf('-'));
	
			var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf('-'));
			var TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf('-') + 1);
			var TwoYear = DateTwo.substring(0, DateTwo.indexOf('-'));
	
			var cha = (Date.parse(OneMonth + '/' + OneDay + '/' + OneYear) - Date.parse(TwoMonth + '/' + TwoDay + '/' + TwoYear)) / 86400000;
			return Math.abs(cha);
		},
		/**
	  * 日期合法性验证，格式为：YYYY-MM-DD或YYYY/MM/DD 
	  * @param {string} DateStr 日期字符串
	  * @returns {boolean} 是否合法
	  */
		//+--------------------------------------------------- 
		//| 日期合法性验证 
		//| 格式为：YYYY-MM-DD或YYYY/MM/DD 
		//+--------------------------------------------------- 
		IsValidDate: function IsValidDate(DateStr) {
			var sDate = DateStr.replace(/(^\s+|\s+$)/g, ''); //去两边空格; 
			if (sDate == '') return true;
			//如果格式满足YYYY-(/)MM-(/)DD或YYYY-(/)M-(/)DD或YYYY-(/)M-(/)D或YYYY-(/)MM-(/)D就替换为'' 
			//数据库中，合法日期可以是:YYYY-MM/DD(2003-3/21),数据库会自动转换为YYYY-MM-DD格式 
			var s = sDate.replace(/[\d]{ 4,4 }[\-/]{ 1 }[\d]{ 1,2 }[\-/]{ 1 }[\d]{ 1,2 }/g, '');
			if (s == '') //说明格式满足YYYY-MM-DD或YYYY-M-DD或YYYY-M-D或YYYY-MM-D 
				{
					var t = new Date(sDate.replace(/\-/g, '/'));
					var ar = sDate.split(/[-/:]/);
					if (ar[0] != t.getYear() || ar[1] != t.getMonth() + 1 || ar[2] != t.getDate()) {
						//alert('错误的日期格式！格式为：YYYY-MM-DD或YYYY/MM/DD。注意闰年。'); 
						return false;
					}
				} else {
				//alert('错误的日期格式！格式为：YYYY-MM-DD或YYYY/MM/DD。注意闰年。'); 
				return false;
			}
			return true;
		},
		/**
	  * 日期时间检查，格式为：YYYY-MM-DD HH:MM:SS 
	  * @param {string} str 日期字符串
	  * @returns {boolean} 是否符合
	  */
		//+--------------------------------------------------- 
		//| 日期时间检查 
		//| 格式为：YYYY-MM-DD HH:MM:SS 
		//+--------------------------------------------------- 
		CheckDateTime: function CheckDateTime(str) {
			var reg = /^(\d+)-(\d{ 1,2 })-(\d{ 1,2 }) (\d{ 1,2 }):(\d{ 1,2 }):(\d{ 1,2 })$/;
			var r = str.match(reg);
			if (r == null) return false;
			r[2] = r[2] - 1;
			var d = new Date(r[1], r[2], r[3], r[4], r[5], r[6]);
			if (d.getFullYear() != r[1]) return false;
			if (d.getMonth() != r[2]) return false;
			if (d.getDate() != r[3]) return false;
			if (d.getHours() != r[4]) return false;
			if (d.getMinutes() != r[5]) return false;
			if (d.getSeconds() != r[6]) return false;
			return true;
		},
	
		/**
	  * 字符串转成日期类型，格式：MM/dd/YYYY、MM-dd-YYYY、YYYY/MM/dd、YYYY-MM-dd 
	  * @param {string} DateStr 日期字符串
	  * @returns {Date} 返回对应date
	  */
		//+--------------------------------------------------- 
		//| 字符串转成日期类型 
		//| 格式 MM/dd/YYYY MM-dd-YYYY YYYY/MM/dd YYYY-MM-dd 
		//+--------------------------------------------------- 
		StringToDate: function StringToDate(DateStr) {
	
			var converted = Date.parse(DateStr);
			var myDate = new Date(converted);
			if (isNaN(myDate)) {
				//var delimCahar = DateStr.indexOf('/')!=-1?'/':'-'; 
				var arys = DateStr.split('-');
				myDate = new Date(arys[0], --arys[1], arys[2]);
			}
			return myDate;
		}
	
		/**
	  * 获取json对象长度
	  * @param {object} jsonData json对象
	  * @returns {number} 长度
	  * 
	  * @memberof tool
	  * @function
	  * @group _global_
	  */
	};function getJsonLength(jsonData) {
		var length = 0;
		for (var ever in jsonData) {
			length++;
		}
		return length;
	}
	
	/**
	 * 赋值数组
	 * @param {array} arr 要复制的数组
	 * @param {boolean} [flag=false] 是否深度赋值
	 * @returns {array} 新的数组
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function copyArr(arr, flag) {
		var res = [];
		for (var i = 0; i < arr.length; i++) {
			var tmp = void 0;
			if (flag) {
				tmp = copy(arr[i], true);
			} else {
				tmp = arr[i];
			}
			res.push(tmp);
		}
		return res;
	}
	
	/**
	 * 拷贝 包括深浅拷贝
	 * @param {object} obj 对象
	 * @param {boolean} [flag=false] 是否深拷贝
	 * @returns {object} 新的对象
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function copy(obj, flag) {
		if (flag) {
			return deepCopy(obj);
		}
		var newobj = {};
		for (var attr in obj) {
			if (attr != '_key') {
				newobj[attr] = obj[attr];
			}
		}
		return newobj;
	}
	
	/**
	 * 获取对象类型
	 * @param {any} obj js任意类型对象
	 * @returns {boolean|number|string|function|array|date|regExp|undefined|null|object|element} 对象类型字符串
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function getType(obj) {
		//tostring会返回对应不同的标签的构造函数
		var toString = Object.prototype.toString;
		var map = {
			'[object Boolean]': 'boolean',
			'[object Number]': 'number',
			'[object String]': 'string',
			'[object Function]': 'function',
			'[object Array]': 'array',
			'[object Date]': 'date',
			'[object RegExp]': 'regExp',
			'[object Undefined]': 'undefined',
			'[object Null]': 'null',
			'[object Object]': 'object'
		};
		if (obj instanceof Element) {
			return 'element';
		}
		return map[toString.call(obj)];
	}
	
	/**
	 * 深拷贝（去除_key属性）
	 * @param {any} data 任意对象
	 * @returns {any} 新的对象
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function deepCopy(data) {
		var type = getType(data);
		var obj;
		if (type === 'array') {
			obj = [];
		} else if (type === 'object') {
			obj = {};
		} else {
			//不再具有下一层次
			return data;
		}
		if (type === 'array') {
			for (var i = 0, len = data.length; i < len; i++) {
				obj.push(deepCopy(data[i]));
			}
		} else if (type === 'object') {
			for (var key in data) {
				if (key != '_key') {
					obj[key] = deepCopy(data[key]);
				}
			}
		}
		return obj;
	}
	
	/**
	 * 深拷贝
	 * @param {any} data 任意对象
	 * @returns {any} 新的对象
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function deepCopyAll(data) {
		var type = getType(data);
		var obj;
		if (type === 'array') {
			obj = [];
		} else if (type === 'object') {
			obj = {};
		} else {
			//不再具有下一层次
			return data;
		}
		if (type === 'array') {
			for (var i = 0, len = data.length; i < len; i++) {
				obj.push(deepCopyAll(data[i]));
			}
		} else if (type === 'object') {
			for (var key in data) {
				obj[key] = deepCopyAll(data[key]);
			}
		}
		return obj;
	}
	
	/**
	 * 判断字符串是否是json
	 * @param {string} str 字符串
	 * @returns {boolean} 是否是json
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function isJSON(str) {
		if (typeof str == 'string') {
			try {
				JSON.parse(str);
				return true;
			} catch (e) {
				// sgiLogger.log(e);
				return false;
			}
		}
		_sgiLogger.sgiLogger.log('It is not a string!');
	}
	
	/**
	 * 拷贝对象（根据属性数组，浅拷贝）
	 * @param {object} json 对象
	 * @param {string[]} attrs 要拷贝的属性数组
	 * @returns {object} 新的对象
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function copyJsonAttr(json, attrs) {
		if (!json) {
			return;
		}
		if (!attrs || attrs.length < 1) {
			return;
		}
		var newJson = {};
		attrs.forEach(function (element) {
			if (element) {
				newJson[element] = json[element];
			}
		});
		return newJson;
	}
	
	/**
	 * 对象转字符串（函数也转）
	 * @param {object} json 要转换的对象
	 * @returns {string} 转换后的字符串
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function jsonToStr(json) {
		var retrunVal;
		if ((typeof json === "undefined" ? "undefined" : _typeof(json)) === "object") {
			retrunVal = JSON.stringify(json);
			return retrunVal;
		}
		return json;
	}
	
	/**
	 * 字符串转json
	 * @param {string} str 要转换的字符串
	 * @returns {object} 转换后的对象
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function strToJson(str) {
		// 校验
		if (str === undefined || str === "") return null;
	
		var json;
		if ((typeof str === "undefined" ? "undefined" : _typeof(str)) != "object") {
			json = JSON.parse(str);
			return json;
		}
		return str;
	}
	
	/**
	 * 校验字符串是否是有效函数字符串，去除注释、空格、空行后是否有有效函数体
	 * @param {string} str 字符串
	 * @returns {boolean} 是否有效
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function funStrCheck(str) {
		if (!str) return false;
	
		// 正则表达式
		var reg = /("([^\\\"]*(\\.)?)*")|('([^\\\']*(\\.)?)*')|(\/{2,}.*?(\r|\n))|(\/\*(\n|.)*?\*\/)/g;
		// 去除注释，去除空格和换行
		var newStr = str.replace(reg, function (word) {
			return (/^\/{2,}/.test(word) || /^\/\*/.test(word) ? "" : word
			);
		}).replace(/[ |\r|\n]/g, "");
		return !!newStr;
	}
	
	/**
	 * 获取guid字符串中的ap
	 * @param {string} guid guid字符串
	 * @returns {string} ap字符串
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function getAP(guid) {
		if (!guid) {
			return "";
		}
		var elems = getWords(guid, _sgiCommonConstant.GUID.SP);
		if (!elems || elems.length != 4) {
			return "";
		}
		return elems[0];
	}
	
	/**
	 * 根据指定的分隔符，将一个字符串分割为字符串数组 str -- 输入参数，需要分解的字符串 spt --
	 * 输入参数，分隔符，允许多个，例如：',' 和 '.' 都是分隔符，spt = ",." 返回 字符串数组
	 * @param {string} str 要分割的字符串
	 * @param {string} spt 作为分隔的字符串
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function getWords(str, spt) {
		if (!str) return null;
		if (!spt) return [str];
		if (typeof str != 'string') return [];
		if (typeof spt != 'string') return [str];
		var sptExp = new RegExp("[" + spt + "]"); // 分隔符匹配正则表达式，separator
		// regular expression
		return str.split(sptExp);
	}
	/**
	 * 从树结构的json中取得json数据的最底层
	 * @param {object} treeJson 树json对象
	 * @returns {object[]} 所有叶子节点/最底层数据数组
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	function getLeafByPrm(treeJson) {
		var array = [];
		if (!treeJson) {
			return array;
		}
		var sGuid = [];
		var fn = function fn(node, sGuid) {
			var children = node.cldSet;
			if (children) {
				children.forEach(function (c) {
					var cCld = c.cldSet;
					var sc = c.sc;
					sGuid.push(sc);
					if (cCld) {
						fn(c, sGuid);
					} else {
						c.sc = sGuid.join("`");
						array.push(c);
					}
					sGuid.pop(sc);
				});
			}
		};
		fn(treeJson, sGuid);
		return array;
	}
	
	// 根据parm的json对象转化成获得treeModel对象
	// function cvtTreeByPrm(data) {
	// 	if (!data) {
	// 		return new Ext.data.TreeModel();
	// 	}
	// 	// 取得该数据的描述
	// 	var guid = data.desId;
	// 	// var eod = Ep.PrmFactory.getPrmJson(guid);
	// 	// if (!eod) {
	// 	// return new Ext.data.TreeModel();
	// 	// }
	// 	// 定义该类，创建该类对象
	// 	var cNClass = this.defineTMByEod(guid);
	// 	if (!cNClass) {
	// 		return new Ext.data.TreeModel();
	// 	}
	// 	var root = this.createTreeObj(cNClass, data);
	// 	this.addChilds(root, data.cldSet);
	// 	// 删除root中的cldSet属性,该属性只是后面创建节点信息，不属于本身信息
	// 	delete root.data.cldSet;
	// 	return root;
	// }
	
	/**
	 * 计算md5值
	 * @param {any} info 任意对象
	 * @returns {string} md5值
	 * 
	 * @memberof tool
	 * @function
	 * @group _global_
	 */
	var md5 = function md5(info) {
		if (typeof info == 'string') {
			return (0, _MD2.default)(info);
		} else {
			return (0, _MD2.default)(jsonToStr(info));
		}
	};
	
	/**
	 * 
	 * @param {*} target 
	 * @ignore
	 */
	var assignProps = function assignProps(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];
			// 遍历一个对象的自身和继承来的属性，
			// 常常配合hasOwnProperty筛选出对象自身的属性
			for (var key in source) {
				if (key === "style" && target[key]) {
					target[key] = assignProps(target[key], source[key]);
				} else {
					target[key] = source[key];
				}
				// // 使用call方法,避免原型对象扩展带来的干扰
				// if (Object.prototype.hasOwnProperty.call(source, key)) {
				// 	target[key] = source[key];
				// }
			}
		}
		return target;
	};
	/**
	 * 
	 * @param {*} target 
	 * @ignore
	 */
	var assignPropsNotUndefined = function assignPropsNotUndefined(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];
			for (var key in source) {
				if (source[key] === undefined) continue;
				if (key === "style") {
					target[key] = assignPropsNotUndefined(target[key], source[key]);
				} else {
					target[key] = source[key];
				}
			}
		}
		return target;
	};
	/**
	 * 
	 * @param {*} target 
	 * @ignore
	 */
	var assignArrayStr = function assignArrayStr(target) {
		var length = arguments.length;
		for (var i = 1; i < length; i++) {
			var source = arguments[i];
			if (Object.prototype.toString.call(source) !== "[object Array]") continue;
			var sLength = source.length;
			for (var j = 0; j < sLength; j++) {
				var element = source[j];
				if (target.indexOf(element) < 0) {
					target.push(element);
				}
			}
		}
		return target;
	};
	
	/**
	 * 
	 * @param {*} ctl 
	 * @ignore
	 */
	var refFunction = function refFunction(ctl) {
	
		if (!ctl || !ctl.props || !ctl.props.moduleDesc) {
			return;
		}
		// sgiLogger.log("refFunction", ctl.props.moduleDesc.cId);
		// sgiLogger.log("refFunction", ctl.props.moduleDesc.desId);
		var _ctl$props = ctl.props,
		    moduleDesc = _ctl$props.moduleDesc,
		    objFct = _ctl$props.objFct;
	
		var itemKey = moduleDesc.cId;
		if (!itemKey) {
			return;
		}
		ComponentManager.set(objFct.getUID(), moduleDesc.cId, ctl);
	};
	
	/**
	 * 
	 * @param {*} items 
	 * @param {*} foreach 
	 * @param {*} childName 
	 * @ignore
	 */
	var itemForEach = function itemForEach() {
		var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var foreach = arguments[1];
		var childName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "cldSet";
	
		if (!foreach || typeof foreach !== "function") return;
		items.forEach(function (item, index, arr) {
			foreach(item, index, arr);
			var cldSet = item[childName];
			if (cldSet && cldSet.length > 0) itemForEach(cldSet, foreach, childName);
		});
	};
	
	/**
	 * 提供数组操作相关方法
	 * @namespace 数组方法集
	 * @alias tool.Array
	 */
	var sgiArray = {
		/**
	  * 根据索引从数组中删除元素
	  * @param {array} array 源数组
	  * @param {number} index 要删除的索引
	  */
		removeIndex: function removeIndex(array, index) {
			if (!array || array.length == 0) {
				return;
			}
			if (index == undefined || index == null) {
				return;
			}
			array.splice(index, 1);
		},
		/**
	  * 从数组中删除对象（需要引用相同，会删除多个符合的元素）
	  * @param {array} array 源数组
	  * @param {object} obj 要删除的对象
	  */
		remove: function remove(array, obj) {
			if (!array || array.length == 0) {
				return;
			}
			if (obj == undefined || obj == null) {
				return;
			}
			for (var i = 0; i < array.length; i++) {
				var tmp = array[i];
				if (tmp == obj) {
					array.splice(i--, 1); //删除数组元素，索引会前移，配合自减运算
				}
			}
		},
		/**
	  * 从数组中删除元素（根据属性key与值，会删除多个符合的元素）
	  * @param {object[]} array 源数组
	  * @param {string} key 要删除对象的匹配属性key
	  * @param {object} value 要删除的对象的匹配属性值
	  */
		removeJson: function removeJson(array, key, value) {
			if (!array || array.length == 0) {
				return;
			}
			if (!key || !value) {
				return;
			}
			for (var i = 0; i < array.length; i++) {
				var tmp = array[i];
				if ((typeof tmp === "undefined" ? "undefined" : _typeof(tmp)) == "object") {
					if (tmp[key] === value) {
						array.splice(i--, 1); //删除数组元素，索引会前移，配合自减运算
					}
				}
			}
		},
		// swapItems: function (arr, index1, index2) {
		//     arr[index1] = arr.splice(index2, 1, arr[index1])[0];
		//     return arr;
		// }
	
		/**
	  * 数组内元素位置交换
	  * @param {array} arr 源数组
	  * @param {number} index 当前元素/被交换元素索引
	  * @param {number} tindex 交换元素索引
	  */
		swapItems: function swapItems(arr, index, tindex) {
			if (index > tindex) {
				arr.splice(tindex, 0, arr[index]);
				arr.splice(index + 1, 1);
			} else {
				arr.splice(tindex + 1, 0, arr[index]);
				arr.splice(index, 1);
			}
		},
		/**
	  * 向源数组中添加元素，obj可为数组，此时会被解构传入
	  * @param {array} arr 源数组
	  * @param {object|array} obj 要添加到源数组中的对象或数组
	  */
		//判断是否是 数组 如果是数组
		pushObj: function pushObj(arr, obj) {
			if (!arr || !obj) {
				return;
			}
			if (getType(obj) === 'array') {
				obj.forEach(function (element) {
					arr.push(element);
				});
			} else {
				arr.push(obj);
			}
		},
		/**
	  * 
	  * @param {*} arr 数组
	  * @param {*} key 排序key
	  * @param {*} sortType true 正序  false倒序
	  */
		sort: function sort(arr, key, sortType) {
			arr.sort(function (a, b) {
				if (sortType) {
					return a[key] > b[key];
				} else {
					return a[key] < b[key];
				}
			});
		}
	
		/**
	  * 提供部分常用格式化方法
	  * @namespace 格式化方法集
	  * @alias tool.Format
	  */
	};var Format = {
		/**
	  * 金额格式化
	  * @param {string} str 要格式化的字符串
	  * @param {number} fixed 保留小数位数
	  * @returns {string} 格式化后的金额字符串
	  */
		amount: function amount(str, fixed) {
			fixed = fixed || fixed === 0 ? fixed : 2;
			str = parseFloat(str || "0").toFixed(fixed) + "";
			var dotPos = str.indexOf(".") > -1 ? str.indexOf(".") : str.length;
			var intSum = str.substring(0, dotPos).replace(/\B(?=(?:\d{3})+$)/g, ','); //取到整数部分(添加,号)
			var dot = str.substring(str.length, dotPos); //取到小数部分
			return intSum + dot;
		},
		/**
	  * 计算百分比
	  * @param {number|string} num 被除数
	  * @param {number|string} total 总数/除数
	  * @param {number} [fixed=0] 保留小数位数
	  * @param {boolean} [noPerSign=false] 不带百分号%，默认带%
	  * @returns {string} 百分比字符串
	  */
		percent: function percent(num, total, fixed, noPerSign) {
			fixed = fixed || 0;
			num = parseFloat(num);
			total = parseFloat(total);
			if (isNaN(num) || isNaN(total) || total <= 0) {
				return 0.00.toFixed(fixed) + (noPerSign ? "" : " %");
			}
			return (num / total * 100).toFixed(fixed) + (noPerSign ? "" : " %");
		}
	};
	
	var setCookie = function setCookie(key, val, time) {
		//设置cookie方法
		if (!key) {
			return;
		}
		if (!val) {
			val = "";
		}
		val = sgiEncrypt.encrypt(val);
	
		var time = arguments[2] ? arguments[2] : 30;
		var date = new Date(); //获取当前时间
		var expiresDays = time; //将date设置为n天以后的时间
		date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); //格式化为cookie识别的时间
		document.cookie = sgiConfig.abb_project + "-" + key + "=" + val + ";expires=" + date.toGMTString() + ";path=/"; //设置cookie
	};
	
	var getCookie = function getCookie(key) {
		//获取cookie方法
		/*获取cookie参数*/
		var getCookie = document.cookie.replace(/[ ]/g, ""); //获取cookie，并且将获得的cookie格式化，去掉空格字符
		var arrCookie = getCookie.split(";"); //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
		var tips; //声明变量tips
		for (var i = 0; i < arrCookie.length; i++) {
			//使用for循环查找cookie中的tips变量
			var arr = arrCookie[i].split("="); //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
			if (sgiConfig.abb_project + "-" + key == arr[0]) {
				//匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
				var filterCookies = ['userId', 'token'];
				if (filterCookies.includes(key) && !arr[1]) {
					// console.log('getCookie', key, tips)
					console.log("getCookie- " + key + ": " + tips);
	
					tool.popMessage("登录超时，请重新登录", "warning");
					tool.logout();
					return;
				}
				tips = arr[1]; //将cookie的值赋给变量tips
				break; //终止for循环遍历
			}
		}
		if (tips) {
			tips = sgiEncrypt.decrypt(tips);
		}
		return tips;
	};
	
	var deleteCookie = function deleteCookie(key) {
		//删除cookie方法
		var date = new Date(); //获取当前时间
		date.setTime(date.getTime() - 10000); //将date设置为过去的时间
		// sgiLogger.log(date.toGMTString())
		var path = ";path=/";
		document.cookie = sgiConfig.abb_project + "-" + key + "=v; expires =" + date.toGMTString() + path; //设置cookie
	};
	// 批量删除cookie-根据前缀
	var removeCookieByPrefix = function removeCookieByPrefix(prefix) {
		if (!prefix) return;
		var preLength = prefix.length;
		var getCookie = document.cookie.replace(/[ ]/g, "");
		var arrCookie = getCookie.split(";");
		for (var i = 0; i < arrCookie.length; i++) {
			var arr = arrCookie[i].split("=");
			var key = arr[0];
			var pre = key.substr(0, preLength);
			if (prefix === pre) {
				document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
				break;
			}
		}
	};
	
	var destroyAllModal = function destroyAllModal() {
		_antd.Modal.destroyAll();
	};
	
	exports.uuid = uuid;
	exports.uuidDate = uuidDate;
	exports.jsonToStr = jsonToStr;
	exports.isJSON = isJSON;
	exports.funStrCheck = funStrCheck;
	exports.HtmlUtil = HtmlUtil;
	exports.strToJson = strToJson;
	exports.getAP = getAP;
	exports.copyJsonAttr = copyJsonAttr;
	exports.getLeafByPrm = getLeafByPrm;
	exports.copy = copy;
	exports.sgiArray = sgiArray;
	exports.Format = Format;
	exports.copyArr = copyArr;
	exports.getJsonLength = getJsonLength;
	exports.md5 = md5;
	exports.createElement = createElement;
	exports.DateOpt = DateOpt;
	exports.deepCopyAll = deepCopyAll;
	exports.assignProps = assignProps;
	exports.assignPropsNotUndefined = assignPropsNotUndefined;
	exports.assignArrayStr = assignArrayStr;
	exports.getType = getType;
	exports.itemForEach = itemForEach;
	exports.setCookie = setCookie;
	exports.getCookie = getCookie;
	exports.deleteCookie = deleteCookie;
	exports.removeCookieByPrefix = removeCookieByPrefix;
	exports.sgiZip = sgiZip;
	exports.sgiEncrypt = sgiEncrypt;
	exports.destroyAllModal = destroyAllModal;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	 * @Descripttion: 
	 * @version: 
	 * @Author: hanzb
	 * @Date: 2019-11-29 16:43:46
	 * @LastEditors: hanzb
	 * @LastEditTime: 2020-04-26 09:18:46
	 */
	/**
	 * 统一获取事件，优先从事件集中获取，其次是旧模式
	 * @param {object} module 
	 * @param {string} eventKey 事件名
	 */
	var getFunctionByKey = function getFunctionByKey(module, eventKey) {
		if (!module || !eventKey) return null;
		var _module$props = module.props,
		    objFct = _module$props.objFct,
		    moduleDesc = _module$props.moduleDesc;
	
		if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys[eventKey]) {
			// 事件集模式
			var funs = Object.assign({}, objFct ? objFct.get("@funs") : {}, module.funs);
			var key = moduleDesc.eventKeys[eventKey];
			return typeof funs[key] == "function" ? funs[key].bind(funs) : funs[key];
		} else {
			// 原事件模式
			// return module.data.functions[eventKey];
			// let functions = module.data && module.data.functions || module.state.functions || {};
			// return functions[eventKey];
			return module.data && module.data.functions && module.data.functions[eventKey] || //在data.functions中查找
			module.state.functions && module.state.functions[eventKey]; //在state.functions中查找
			// || (module.state && module.state[eventKey]);//在state中查找
		}
	};
	/**
	 * 其他位置需要存放方法，统一使用getFunctionByKey调用时使用
	 * @param {object} module module
	 * @param {string} key 存放方法的key
	 * @param {function} fun 存放的方法
	 */
	var setFunction = function setFunction(module, key, fun) {
		if (!module || !key || !fun) return;
		if (module.data && module.data.functions) {
			module.data.functions[key] = fun;
		} else if (module.state && module.state.functions) {
			module.state.functions[key] = fun;
		} else {
			if (module.data) module.data.functions = _defineProperty({}, key, fun);else module.data = { functions: _defineProperty({}, key, fun) };
		}
	};
	
	/**
	 * 统一获取常量，从对象工厂中获取，由事件集配置定义，获取不到直接返回原字符串
	 * @param {object} module 
	 * @param {string} cnstKey 常量名
	 */
	var getConstByKey = function getConstByKey(module, cnstKey) {
		if (!module || !cnstKey || typeof cnstKey !== "string") return cnstKey;
		var _module$props2 = module.props,
		    objFct = _module$props2.objFct,
		    moduleDesc = _module$props2.moduleDesc;
	
		if (!objFct) return cnstKey;
		var cnsts = objFct.get("@cnsts");
		if (!cnsts) return cnstKey;
		return cnstKey in cnsts ? cnsts[cnstKey] : cnstKey;
	};
	
	/**
	 * 校验当前react版本
	 * @param {object} module 当前控件this
	 * @param {number|string} vsn 版本号
	 */
	var testReactVsn = function testReactVsn(module, vsn) {
		if (!module || !vsn) return;
		switch (parseInt(vsn)) {
			case 15:
				return module._reactInternalInstance;
			case 16:
				return module._reactInternalFiber;
			default:
				break;
		}
	};
	
	/**
	 * 给包含数字的字符串添加px单位（antd4部分控件需要指定单位）
	 * @param {string} [str=""] 需要添加单位字符串
	 * @param {string} [addUnit=px] 要添加的单位，默认"px"
	 */
	var numStrAddPx = function numStrAddPx() {
		var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
		var addUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "px";
	
		return str.replace(/([\d]+)($|[^\d(px|vm)%])/g, "$1" + addUnit + "$2");
	};
	
	exports.getFunctionByKey = getFunctionByKey;
	exports.setFunction = setFunction;
	exports.getConstByKey = getConstByKey;
	exports.testReactVsn = testReactVsn;
	exports.numStrAddPx = numStrAddPx;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(169);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// This is CodeMirror (https://codemirror.net/5), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = global || self, global.CodeMirror = factory());
	})(undefined, function () {
	  'use strict';
	
	  // Kludges for bugs and behavior differences that can't be feature
	  // detected are enabled based on userAgent etc sniffing.
	
	  var userAgent = navigator.userAgent;
	  var platform = navigator.platform;
	
	  var gecko = /gecko\/\d/i.test(userAgent);
	  var ie_upto10 = /MSIE \d/.test(userAgent);
	  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
	  var edge = /Edge\/(\d+)/.exec(userAgent);
	  var ie = ie_upto10 || ie_11up || edge;
	  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
	  var webkit = !edge && /WebKit\//.test(userAgent);
	  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
	  var chrome = !edge && /Chrome\/(\d+)/.exec(userAgent);
	  var chrome_version = chrome && +chrome[1];
	  var presto = /Opera\//.test(userAgent);
	  var safari = /Apple Computer/.test(navigator.vendor);
	  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
	  var phantom = /PhantomJS/.test(userAgent);
	
	  var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
	  var android = /Android/.test(userAgent);
	  // This is woefully incomplete. Suggestions for alternative methods welcome.
	  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
	  var mac = ios || /Mac/.test(platform);
	  var chromeOS = /\bCrOS\b/.test(userAgent);
	  var windows = /win/i.test(platform);
	
	  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
	  if (presto_version) {
	    presto_version = Number(presto_version[1]);
	  }
	  if (presto_version && presto_version >= 15) {
	    presto = false;webkit = true;
	  }
	  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
	  var captureRightClick = gecko || ie && ie_version >= 9;
	
	  function classTest(cls) {
	    return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
	  }
	
	  var rmClass = function rmClass(node, cls) {
	    var current = node.className;
	    var match = classTest(cls).exec(current);
	    if (match) {
	      var after = current.slice(match.index + match[0].length);
	      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
	    }
	  };
	
	  function removeChildren(e) {
	    for (var count = e.childNodes.length; count > 0; --count) {
	      e.removeChild(e.firstChild);
	    }
	    return e;
	  }
	
	  function removeChildrenAndAdd(parent, e) {
	    return removeChildren(parent).appendChild(e);
	  }
	
	  function elt(tag, content, className, style) {
	    var e = document.createElement(tag);
	    if (className) {
	      e.className = className;
	    }
	    if (style) {
	      e.style.cssText = style;
	    }
	    if (typeof content == "string") {
	      e.appendChild(document.createTextNode(content));
	    } else if (content) {
	      for (var i = 0; i < content.length; ++i) {
	        e.appendChild(content[i]);
	      }
	    }
	    return e;
	  }
	  // wrapper for elt, which removes the elt from the accessibility tree
	  function eltP(tag, content, className, style) {
	    var e = elt(tag, content, className, style);
	    e.setAttribute("role", "presentation");
	    return e;
	  }
	
	  var range;
	  if (document.createRange) {
	    range = function range(node, start, end, endNode) {
	      var r = document.createRange();
	      r.setEnd(endNode || node, end);
	      r.setStart(node, start);
	      return r;
	    };
	  } else {
	    range = function range(node, start, end) {
	      var r = document.body.createTextRange();
	      try {
	        r.moveToElementText(node.parentNode);
	      } catch (e) {
	        return r;
	      }
	      r.collapse(true);
	      r.moveEnd("character", end);
	      r.moveStart("character", start);
	      return r;
	    };
	  }
	
	  function contains(parent, child) {
	    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	      {
	        child = child.parentNode;
	      }
	    if (parent.contains) {
	      return parent.contains(child);
	    }
	    do {
	      if (child.nodeType == 11) {
	        child = child.host;
	      }
	      if (child == parent) {
	        return true;
	      }
	    } while (child = child.parentNode);
	  }
	
	  function activeElt(rootNode) {
	    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	    // IE < 10 will throw when accessed while the page is loading or in an iframe.
	    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	    var doc = rootNode.ownerDocument || rootNode;
	    var activeElement;
	    try {
	      activeElement = rootNode.activeElement;
	    } catch (e) {
	      activeElement = doc.body || null;
	    }
	    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement) {
	      activeElement = activeElement.shadowRoot.activeElement;
	    }
	    return activeElement;
	  }
	
	  function addClass(node, cls) {
	    var current = node.className;
	    if (!classTest(cls).test(current)) {
	      node.className += (current ? " " : "") + cls;
	    }
	  }
	  function joinClasses(a, b) {
	    var as = a.split(" ");
	    for (var i = 0; i < as.length; i++) {
	      if (as[i] && !classTest(as[i]).test(b)) {
	        b += " " + as[i];
	      }
	    }
	    return b;
	  }
	
	  var selectInput = function selectInput(node) {
	    node.select();
	  };
	  if (ios) // Mobile Safari apparently has a bug where select() is broken.
	    {
	      selectInput = function selectInput(node) {
	        node.selectionStart = 0;node.selectionEnd = node.value.length;
	      };
	    } else if (ie) // Suppress mysterious IE10 errors
	    {
	      selectInput = function selectInput(node) {
	        try {
	          node.select();
	        } catch (_e) {}
	      };
	    }
	
	  function doc(cm) {
	    return cm.display.wrapper.ownerDocument;
	  }
	
	  function root(cm) {
	    return rootNode(cm.display.wrapper);
	  }
	
	  function rootNode(element) {
	    // Detect modern browsers (2017+).
	    return element.getRootNode ? element.getRootNode() : element.ownerDocument;
	  }
	
	  function win(cm) {
	    return doc(cm).defaultView;
	  }
	
	  function bind(f) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return function () {
	      return f.apply(null, args);
	    };
	  }
	
	  function copyObj(obj, target, overwrite) {
	    if (!target) {
	      target = {};
	    }
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) {
	        target[prop] = obj[prop];
	      }
	    }
	    return target;
	  }
	
	  // Counts the column offset in a string, taking tabs into account.
	  // Used mostly to find indentation.
	  function countColumn(string, end, tabSize, startIndex, startValue) {
	    if (end == null) {
	      end = string.search(/[^\s\u00a0]/);
	      if (end == -1) {
	        end = string.length;
	      }
	    }
	    for (var i = startIndex || 0, n = startValue || 0;;) {
	      var nextTab = string.indexOf("\t", i);
	      if (nextTab < 0 || nextTab >= end) {
	        return n + (end - i);
	      }
	      n += nextTab - i;
	      n += tabSize - n % tabSize;
	      i = nextTab + 1;
	    }
	  }
	
	  var Delayed = function Delayed() {
	    this.id = null;
	    this.f = null;
	    this.time = 0;
	    this.handler = bind(this.onTimeout, this);
	  };
	  Delayed.prototype.onTimeout = function (self) {
	    self.id = 0;
	    if (self.time <= +new Date()) {
	      self.f();
	    } else {
	      setTimeout(self.handler, self.time - +new Date());
	    }
	  };
	  Delayed.prototype.set = function (ms, f) {
	    this.f = f;
	    var time = +new Date() + ms;
	    if (!this.id || time < this.time) {
	      clearTimeout(this.id);
	      this.id = setTimeout(this.handler, ms);
	      this.time = time;
	    }
	  };
	
	  function indexOf(array, elt) {
	    for (var i = 0; i < array.length; ++i) {
	      if (array[i] == elt) {
	        return i;
	      }
	    }
	    return -1;
	  }
	
	  // Number of pixels added to scroller and sizer to hide scrollbar
	  var scrollerGap = 50;
	
	  // Returned or thrown by various protocols to signal 'I'm not
	  // handling this'.
	  var Pass = { toString: function toString() {
	      return "CodeMirror.Pass";
	    } };
	
	  // Reused option objects for setSelection & friends
	  var sel_dontScroll = { scroll: false },
	      sel_mouse = { origin: "*mouse" },
	      sel_move = { origin: "+move" };
	
	  // The inverse of countColumn -- find the offset that corresponds to
	  // a particular column.
	  function findColumn(string, goal, tabSize) {
	    for (var pos = 0, col = 0;;) {
	      var nextTab = string.indexOf("\t", pos);
	      if (nextTab == -1) {
	        nextTab = string.length;
	      }
	      var skipped = nextTab - pos;
	      if (nextTab == string.length || col + skipped >= goal) {
	        return pos + Math.min(skipped, goal - col);
	      }
	      col += nextTab - pos;
	      col += tabSize - col % tabSize;
	      pos = nextTab + 1;
	      if (col >= goal) {
	        return pos;
	      }
	    }
	  }
	
	  var spaceStrs = [""];
	  function spaceStr(n) {
	    while (spaceStrs.length <= n) {
	      spaceStrs.push(lst(spaceStrs) + " ");
	    }
	    return spaceStrs[n];
	  }
	
	  function lst(arr) {
	    return arr[arr.length - 1];
	  }
	
	  function map(array, f) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) {
	      out[i] = f(array[i], i);
	    }
	    return out;
	  }
	
	  function insertSorted(array, value, score) {
	    var pos = 0,
	        priority = score(value);
	    while (pos < array.length && score(array[pos]) <= priority) {
	      pos++;
	    }
	    array.splice(pos, 0, value);
	  }
	
	  function nothing() {}
	
	  function createObj(base, props) {
	    var inst;
	    if (Object.create) {
	      inst = Object.create(base);
	    } else {
	      nothing.prototype = base;
	      inst = new nothing();
	    }
	    if (props) {
	      copyObj(props, inst);
	    }
	    return inst;
	  }
	
	  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
	  function isWordCharBasic(ch) {
	    return (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
	    );
	  }
	  function isWordChar(ch, helper) {
	    if (!helper) {
	      return isWordCharBasic(ch);
	    }
	    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) {
	      return true;
	    }
	    return helper.test(ch);
	  }
	
	  function isEmpty(obj) {
	    for (var n in obj) {
	      if (obj.hasOwnProperty(n) && obj[n]) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  // Extending unicode characters. A series of a non-extending char +
	  // any number of extending chars is treated as a single unit as far
	  // as editing and measuring is concerned. This is not fully correct,
	  // since some scripts/fonts/browsers also treat other configurations
	  // of code points as a group.
	  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
	  function isExtendingChar(ch) {
	    return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
	  }
	
	  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
	  function skipExtendingChars(str, pos, dir) {
	    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) {
	      pos += dir;
	    }
	    return pos;
	  }
	
	  // Returns the value from the range [`from`; `to`] that satisfies
	  // `pred` and is closest to `from`. Assumes that at least `to`
	  // satisfies `pred`. Supports `from` being greater than `to`.
	  function findFirst(pred, from, to) {
	    // At any point we are certain `to` satisfies `pred`, don't know
	    // whether `from` does.
	    var dir = from > to ? -1 : 1;
	    for (;;) {
	      if (from == to) {
	        return from;
	      }
	      var midF = (from + to) / 2,
	          mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
	      if (mid == from) {
	        return pred(mid) ? from : to;
	      }
	      if (pred(mid)) {
	        to = mid;
	      } else {
	        from = mid + dir;
	      }
	    }
	  }
	
	  // BIDI HELPERS
	
	  function iterateBidiSections(order, from, to, f) {
	    if (!order) {
	      return f(from, to, "ltr", 0);
	    }
	    var found = false;
	    for (var i = 0; i < order.length; ++i) {
	      var part = order[i];
	      if (part.from < to && part.to > from || from == to && part.to == from) {
	        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
	        found = true;
	      }
	    }
	    if (!found) {
	      f(from, to, "ltr");
	    }
	  }
	
	  var bidiOther = null;
	  function getBidiPartAt(order, ch, sticky) {
	    var found;
	    bidiOther = null;
	    for (var i = 0; i < order.length; ++i) {
	      var cur = order[i];
	      if (cur.from < ch && cur.to > ch) {
	        return i;
	      }
	      if (cur.to == ch) {
	        if (cur.from != cur.to && sticky == "before") {
	          found = i;
	        } else {
	          bidiOther = i;
	        }
	      }
	      if (cur.from == ch) {
	        if (cur.from != cur.to && sticky != "before") {
	          found = i;
	        } else {
	          bidiOther = i;
	        }
	      }
	    }
	    return found != null ? found : bidiOther;
	  }
	
	  // Bidirectional ordering algorithm
	  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	  // that this (partially) implements.
	
	  // One-char codes used for character types:
	  // L (L):   Left-to-Right
	  // R (R):   Right-to-Left
	  // r (AL):  Right-to-Left Arabic
	  // 1 (EN):  European Number
	  // + (ES):  European Number Separator
	  // % (ET):  European Number Terminator
	  // n (AN):  Arabic Number
	  // , (CS):  Common Number Separator
	  // m (NSM): Non-Spacing Mark
	  // b (BN):  Boundary Neutral
	  // s (B):   Paragraph Separator
	  // t (S):   Segment Separator
	  // w (WS):  Whitespace
	  // N (ON):  Other Neutrals
	
	  // Returns null if characters are ordered as they appear
	  // (left-to-right), or an array of sections ({from, to, level}
	  // objects) in the order in which they occur visually.
	  var bidiOrdering = function () {
	    // Character types for codepoints 0 to 0xff
	    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
	    // Character types for codepoints 0x600 to 0x6f9
	    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
	    function charType(code) {
	      if (code <= 0xf7) {
	        return lowTypes.charAt(code);
	      } else if (0x590 <= code && code <= 0x5f4) {
	        return "R";
	      } else if (0x600 <= code && code <= 0x6f9) {
	        return arabicTypes.charAt(code - 0x600);
	      } else if (0x6ee <= code && code <= 0x8ac) {
	        return "r";
	      } else if (0x2000 <= code && code <= 0x200b) {
	        return "w";
	      } else if (code == 0x200c) {
	        return "b";
	      } else {
	        return "L";
	      }
	    }
	
	    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
	    var isNeutral = /[stwN]/,
	        isStrong = /[LRr]/,
	        countsAsLeft = /[Lb1n]/,
	        countsAsNum = /[1n]/;
	
	    function BidiSpan(level, from, to) {
	      this.level = level;
	      this.from = from;this.to = to;
	    }
	
	    return function (str, direction) {
	      var outerType = direction == "ltr" ? "L" : "R";
	
	      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) {
	        return false;
	      }
	      var len = str.length,
	          types = [];
	      for (var i = 0; i < len; ++i) {
	        types.push(charType(str.charCodeAt(i)));
	      }
	
	      // W1. Examine each non-spacing mark (NSM) in the level run, and
	      // change the type of the NSM to the type of the previous
	      // character. If the NSM is at the start of the level run, it will
	      // get the type of sor.
	      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
	        var type = types[i$1];
	        if (type == "m") {
	          types[i$1] = prev;
	        } else {
	          prev = type;
	        }
	      }
	
	      // W2. Search backwards from each instance of a European number
	      // until the first strong type (R, L, AL, or sor) is found. If an
	      // AL is found, change the type of the European number to Arabic
	      // number.
	      // W3. Change all ALs to R.
	      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
	        var type$1 = types[i$2];
	        if (type$1 == "1" && cur == "r") {
	          types[i$2] = "n";
	        } else if (isStrong.test(type$1)) {
	          cur = type$1;if (type$1 == "r") {
	            types[i$2] = "R";
	          }
	        }
	      }
	
	      // W4. A single European separator between two European numbers
	      // changes to a European number. A single common separator between
	      // two numbers of the same type changes to that type.
	      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
	        var type$2 = types[i$3];
	        if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") {
	          types[i$3] = "1";
	        } else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) {
	          types[i$3] = prev$1;
	        }
	        prev$1 = type$2;
	      }
	
	      // W5. A sequence of European terminators adjacent to European
	      // numbers changes to all European numbers.
	      // W6. Otherwise, separators and terminators change to Other
	      // Neutral.
	      for (var i$4 = 0; i$4 < len; ++i$4) {
	        var type$3 = types[i$4];
	        if (type$3 == ",") {
	          types[i$4] = "N";
	        } else if (type$3 == "%") {
	          var end = void 0;
	          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
	          var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
	          for (var j = i$4; j < end; ++j) {
	            types[j] = replace;
	          }
	          i$4 = end - 1;
	        }
	      }
	
	      // W7. Search backwards from each instance of a European number
	      // until the first strong type (R, L, or sor) is found. If an L is
	      // found, then change the type of the European number to L.
	      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
	        var type$4 = types[i$5];
	        if (cur$1 == "L" && type$4 == "1") {
	          types[i$5] = "L";
	        } else if (isStrong.test(type$4)) {
	          cur$1 = type$4;
	        }
	      }
	
	      // N1. A sequence of neutrals takes the direction of the
	      // surrounding strong text if the text on both sides has the same
	      // direction. European and Arabic numbers act as if they were R in
	      // terms of their influence on neutrals. Start-of-level-run (sor)
	      // and end-of-level-run (eor) are used at level run boundaries.
	      // N2. Any remaining neutrals take the embedding direction.
	      for (var i$6 = 0; i$6 < len; ++i$6) {
	        if (isNeutral.test(types[i$6])) {
	          var end$1 = void 0;
	          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
	          var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
	          var after = (end$1 < len ? types[end$1] : outerType) == "L";
	          var replace$1 = before == after ? before ? "L" : "R" : outerType;
	          for (var j$1 = i$6; j$1 < end$1; ++j$1) {
	            types[j$1] = replace$1;
	          }
	          i$6 = end$1 - 1;
	        }
	      }
	
	      // Here we depart from the documented algorithm, in order to avoid
	      // building up an actual levels array. Since there are only three
	      // levels (0, 1, 2) in an implementation that doesn't take
	      // explicit embedding into account, we can build up the order on
	      // the fly, without following the level-based algorithm.
	      var order = [],
	          m;
	      for (var i$7 = 0; i$7 < len;) {
	        if (countsAsLeft.test(types[i$7])) {
	          var start = i$7;
	          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
	          order.push(new BidiSpan(0, start, i$7));
	        } else {
	          var pos = i$7,
	              at = order.length,
	              isRTL = direction == "rtl" ? 1 : 0;
	          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
	          for (var j$2 = pos; j$2 < i$7;) {
	            if (countsAsNum.test(types[j$2])) {
	              if (pos < j$2) {
	                order.splice(at, 0, new BidiSpan(1, pos, j$2));at += isRTL;
	              }
	              var nstart = j$2;
	              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
	              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
	              at += isRTL;
	              pos = j$2;
	            } else {
	              ++j$2;
	            }
	          }
	          if (pos < i$7) {
	            order.splice(at, 0, new BidiSpan(1, pos, i$7));
	          }
	        }
	      }
	      if (direction == "ltr") {
	        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	          order[0].from = m[0].length;
	          order.unshift(new BidiSpan(0, 0, m[0].length));
	        }
	        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	          lst(order).to -= m[0].length;
	          order.push(new BidiSpan(0, len - m[0].length, len));
	        }
	      }
	
	      return direction == "rtl" ? order.reverse() : order;
	    };
	  }();
	
	  // Get the bidi ordering for the given line (and cache it). Returns
	  // false for lines that are fully left-to-right, and an array of
	  // BidiSpan objects otherwise.
	  function getOrder(line, direction) {
	    var order = line.order;
	    if (order == null) {
	      order = line.order = bidiOrdering(line.text, direction);
	    }
	    return order;
	  }
	
	  // EVENT HANDLING
	
	  // Lightweight event framework. on/off also work on DOM nodes,
	  // registering native DOM handlers.
	
	  var noHandlers = [];
	
	  var on = function on(emitter, type, f) {
	    if (emitter.addEventListener) {
	      emitter.addEventListener(type, f, false);
	    } else if (emitter.attachEvent) {
	      emitter.attachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers || (emitter._handlers = {});
	      map[type] = (map[type] || noHandlers).concat(f);
	    }
	  };
	
	  function getHandlers(emitter, type) {
	    return emitter._handlers && emitter._handlers[type] || noHandlers;
	  }
	
	  function off(emitter, type, f) {
	    if (emitter.removeEventListener) {
	      emitter.removeEventListener(type, f, false);
	    } else if (emitter.detachEvent) {
	      emitter.detachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers,
	          arr = map && map[type];
	      if (arr) {
	        var index = indexOf(arr, f);
	        if (index > -1) {
	          map[type] = arr.slice(0, index).concat(arr.slice(index + 1));
	        }
	      }
	    }
	  }
	
	  function signal(emitter, type /*, values...*/) {
	    var handlers = getHandlers(emitter, type);
	    if (!handlers.length) {
	      return;
	    }
	    var args = Array.prototype.slice.call(arguments, 2);
	    for (var i = 0; i < handlers.length; ++i) {
	      handlers[i].apply(null, args);
	    }
	  }
	
	  // The DOM events that CodeMirror handles can be overridden by
	  // registering a (non-DOM) handler on the editor for the event name,
	  // and preventDefault-ing the event in that handler.
	  function signalDOMEvent(cm, e, override) {
	    if (typeof e == "string") {
	      e = { type: e, preventDefault: function preventDefault() {
	          this.defaultPrevented = true;
	        } };
	    }
	    signal(cm, override || e.type, cm, e);
	    return e_defaultPrevented(e) || e.codemirrorIgnore;
	  }
	
	  function signalCursorActivity(cm) {
	    var arr = cm._handlers && cm._handlers.cursorActivity;
	    if (!arr) {
	      return;
	    }
	    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
	    for (var i = 0; i < arr.length; ++i) {
	      if (indexOf(set, arr[i]) == -1) {
	        set.push(arr[i]);
	      }
	    }
	  }
	
	  function hasHandler(emitter, type) {
	    return getHandlers(emitter, type).length > 0;
	  }
	
	  // Add on and off methods to a constructor's prototype, to make
	  // registering events on such objects more convenient.
	  function eventMixin(ctor) {
	    ctor.prototype.on = function (type, f) {
	      on(this, type, f);
	    };
	    ctor.prototype.off = function (type, f) {
	      off(this, type, f);
	    };
	  }
	
	  // Due to the fact that we still support jurassic IE versions, some
	  // compatibility wrappers are needed.
	
	  function e_preventDefault(e) {
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      e.returnValue = false;
	    }
	  }
	  function e_stopPropagation(e) {
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      e.cancelBubble = true;
	    }
	  }
	  function e_defaultPrevented(e) {
	    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
	  }
	  function e_stop(e) {
	    e_preventDefault(e);e_stopPropagation(e);
	  }
	
	  function e_target(e) {
	    return e.target || e.srcElement;
	  }
	  function e_button(e) {
	    var b = e.which;
	    if (b == null) {
	      if (e.button & 1) {
	        b = 1;
	      } else if (e.button & 2) {
	        b = 3;
	      } else if (e.button & 4) {
	        b = 2;
	      }
	    }
	    if (mac && e.ctrlKey && b == 1) {
	      b = 3;
	    }
	    return b;
	  }
	
	  // Detect drag-and-drop
	  var dragAndDrop = function () {
	    // There is *some* kind of drag-and-drop support in IE6-8, but I
	    // couldn't get it to work yet.
	    if (ie && ie_version < 9) {
	      return false;
	    }
	    var div = elt('div');
	    return "draggable" in div || "dragDrop" in div;
	  }();
	
	  var zwspSupported;
	  function zeroWidthElement(measure) {
	    if (zwspSupported == null) {
	      var test = elt("span", '\u200B');
	      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
	      if (measure.firstChild.offsetHeight != 0) {
	        zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
	      }
	    }
	    var node = zwspSupported ? elt("span", '\u200B') : elt("span", '\xA0', null, "display: inline-block; width: 1px; margin-right: -1px");
	    node.setAttribute("cm-text", "");
	    return node;
	  }
	
	  // Feature-detect IE's crummy client rect reporting for bidi text
	  var badBidiRects;
	  function hasBadBidiRects(measure) {
	    if (badBidiRects != null) {
	      return badBidiRects;
	    }
	    var txt = removeChildrenAndAdd(measure, document.createTextNode('A\u062EA'));
	    var r0 = range(txt, 0, 1).getBoundingClientRect();
	    var r1 = range(txt, 1, 2).getBoundingClientRect();
	    removeChildren(measure);
	    if (!r0 || r0.left == r0.right) {
	      return false;
	    } // Safari returns null in some cases (#2780)
	    return badBidiRects = r1.right - r0.right < 3;
	  }
	
	  // See if "".split is the broken IE version, if so, provide an
	  // alternative way to split lines.
	  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
	    var pos = 0,
	        result = [],
	        l = string.length;
	    while (pos <= l) {
	      var nl = string.indexOf("\n", pos);
	      if (nl == -1) {
	        nl = string.length;
	      }
	      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
	      var rt = line.indexOf("\r");
	      if (rt != -1) {
	        result.push(line.slice(0, rt));
	        pos += rt + 1;
	      } else {
	        result.push(line);
	        pos = nl + 1;
	      }
	    }
	    return result;
	  } : function (string) {
	    return string.split(/\r\n?|\n/);
	  };
	
	  var hasSelection = window.getSelection ? function (te) {
	    try {
	      return te.selectionStart != te.selectionEnd;
	    } catch (e) {
	      return false;
	    }
	  } : function (te) {
	    var range;
	    try {
	      range = te.ownerDocument.selection.createRange();
	    } catch (e) {}
	    if (!range || range.parentElement() != te) {
	      return false;
	    }
	    return range.compareEndPoints("StartToEnd", range) != 0;
	  };
	
	  var hasCopyEvent = function () {
	    var e = elt("div");
	    if ("oncopy" in e) {
	      return true;
	    }
	    e.setAttribute("oncopy", "return;");
	    return typeof e.oncopy == "function";
	  }();
	
	  var badZoomedRects = null;
	  function hasBadZoomedRects(measure) {
	    if (badZoomedRects != null) {
	      return badZoomedRects;
	    }
	    var node = removeChildrenAndAdd(measure, elt("span", "x"));
	    var normal = node.getBoundingClientRect();
	    var fromRange = range(node, 0, 1).getBoundingClientRect();
	    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
	  }
	
	  // Known modes, by name and by MIME
	  var modes = {},
	      mimeModes = {};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  function defineMode(name, mode) {
	    if (arguments.length > 2) {
	      mode.dependencies = Array.prototype.slice.call(arguments, 2);
	    }
	    modes[name] = mode;
	  }
	
	  function defineMIME(mime, spec) {
	    mimeModes[mime] = spec;
	  }
	
	  // Given a MIME type, a {name, ...options} config object, or a name
	  // string, return a mode config object.
	  function resolveMode(spec) {
	    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	      spec = mimeModes[spec];
	    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	      var found = mimeModes[spec.name];
	      if (typeof found == "string") {
	        found = { name: found };
	      }
	      spec = createObj(found, spec);
	      spec.name = found.name;
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	      return resolveMode("application/xml");
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	      return resolveMode("application/json");
	    }
	    if (typeof spec == "string") {
	      return { name: spec };
	    } else {
	      return spec || { name: "null" };
	    }
	  }
	
	  // Given a mode spec (anything that resolveMode accepts), find and
	  // initialize an actual mode object.
	  function getMode(options, spec) {
	    spec = resolveMode(spec);
	    var mfactory = modes[spec.name];
	    if (!mfactory) {
	      return getMode(options, "text/plain");
	    }
	    var modeObj = mfactory(options, spec);
	    if (modeExtensions.hasOwnProperty(spec.name)) {
	      var exts = modeExtensions[spec.name];
	      for (var prop in exts) {
	        if (!exts.hasOwnProperty(prop)) {
	          continue;
	        }
	        if (modeObj.hasOwnProperty(prop)) {
	          modeObj["_" + prop] = modeObj[prop];
	        }
	        modeObj[prop] = exts[prop];
	      }
	    }
	    modeObj.name = spec.name;
	    if (spec.helperType) {
	      modeObj.helperType = spec.helperType;
	    }
	    if (spec.modeProps) {
	      for (var prop$1 in spec.modeProps) {
	        modeObj[prop$1] = spec.modeProps[prop$1];
	      }
	    }
	
	    return modeObj;
	  }
	
	  // This can be used to attach properties to mode objects from
	  // outside the actual mode definition.
	  var modeExtensions = {};
	  function extendMode(mode, properties) {
	    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
	    copyObj(properties, exts);
	  }
	
	  function copyState(mode, state) {
	    if (state === true) {
	      return state;
	    }
	    if (mode.copyState) {
	      return mode.copyState(state);
	    }
	    var nstate = {};
	    for (var n in state) {
	      var val = state[n];
	      if (val instanceof Array) {
	        val = val.concat([]);
	      }
	      nstate[n] = val;
	    }
	    return nstate;
	  }
	
	  // Given a mode and a state (for that mode), find the inner mode and
	  // state at the position that the state refers to.
	  function innerMode(mode, state) {
	    var info;
	    while (mode.innerMode) {
	      info = mode.innerMode(state);
	      if (!info || info.mode == mode) {
	        break;
	      }
	      state = info.state;
	      mode = info.mode;
	    }
	    return info || { mode: mode, state: state };
	  }
	
	  function startState(mode, a1, a2) {
	    return mode.startState ? mode.startState(a1, a2) : true;
	  }
	
	  // STRING STREAM
	
	  // Fed to the mode parsers, provides helper functions to make
	  // parsers more succinct.
	
	  var StringStream = function StringStream(string, tabSize, lineOracle) {
	    this.pos = this.start = 0;
	    this.string = string;
	    this.tabSize = tabSize || 8;
	    this.lastColumnPos = this.lastColumnValue = 0;
	    this.lineStart = 0;
	    this.lineOracle = lineOracle;
	  };
	
	  StringStream.prototype.eol = function () {
	    return this.pos >= this.string.length;
	  };
	  StringStream.prototype.sol = function () {
	    return this.pos == this.lineStart;
	  };
	  StringStream.prototype.peek = function () {
	    return this.string.charAt(this.pos) || undefined;
	  };
	  StringStream.prototype.next = function () {
	    if (this.pos < this.string.length) {
	      return this.string.charAt(this.pos++);
	    }
	  };
	  StringStream.prototype.eat = function (match) {
	    var ch = this.string.charAt(this.pos);
	    var ok;
	    if (typeof match == "string") {
	      ok = ch == match;
	    } else {
	      ok = ch && (match.test ? match.test(ch) : match(ch));
	    }
	    if (ok) {
	      ++this.pos;return ch;
	    }
	  };
	  StringStream.prototype.eatWhile = function (match) {
	    var start = this.pos;
	    while (this.eat(match)) {}
	    return this.pos > start;
	  };
	  StringStream.prototype.eatSpace = function () {
	    var start = this.pos;
	    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) {
	      ++this.pos;
	    }
	    return this.pos > start;
	  };
	  StringStream.prototype.skipToEnd = function () {
	    this.pos = this.string.length;
	  };
	  StringStream.prototype.skipTo = function (ch) {
	    var found = this.string.indexOf(ch, this.pos);
	    if (found > -1) {
	      this.pos = found;return true;
	    }
	  };
	  StringStream.prototype.backUp = function (n) {
	    this.pos -= n;
	  };
	  StringStream.prototype.column = function () {
	    if (this.lastColumnPos < this.start) {
	      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
	      this.lastColumnPos = this.start;
	    }
	    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
	  };
	  StringStream.prototype.indentation = function () {
	    return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
	  };
	  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
	    if (typeof pattern == "string") {
	      var cased = function cased(str) {
	        return caseInsensitive ? str.toLowerCase() : str;
	      };
	      var substr = this.string.substr(this.pos, pattern.length);
	      if (cased(substr) == cased(pattern)) {
	        if (consume !== false) {
	          this.pos += pattern.length;
	        }
	        return true;
	      }
	    } else {
	      var match = this.string.slice(this.pos).match(pattern);
	      if (match && match.index > 0) {
	        return null;
	      }
	      if (match && consume !== false) {
	        this.pos += match[0].length;
	      }
	      return match;
	    }
	  };
	  StringStream.prototype.current = function () {
	    return this.string.slice(this.start, this.pos);
	  };
	  StringStream.prototype.hideFirstChars = function (n, inner) {
	    this.lineStart += n;
	    try {
	      return inner();
	    } finally {
	      this.lineStart -= n;
	    }
	  };
	  StringStream.prototype.lookAhead = function (n) {
	    var oracle = this.lineOracle;
	    return oracle && oracle.lookAhead(n);
	  };
	  StringStream.prototype.baseToken = function () {
	    var oracle = this.lineOracle;
	    return oracle && oracle.baseToken(this.pos);
	  };
	
	  // Find the line object corresponding to the given line number.
	  function getLine(doc, n) {
	    n -= doc.first;
	    if (n < 0 || n >= doc.size) {
	      throw new Error("There is no line " + (n + doc.first) + " in the document.");
	    }
	    var chunk = doc;
	    while (!chunk.lines) {
	      for (var i = 0;; ++i) {
	        var child = chunk.children[i],
	            sz = child.chunkSize();
	        if (n < sz) {
	          chunk = child;break;
	        }
	        n -= sz;
	      }
	    }
	    return chunk.lines[n];
	  }
	
	  // Get the part of a document between two positions, as an array of
	  // strings.
	  function getBetween(doc, start, end) {
	    var out = [],
	        n = start.line;
	    doc.iter(start.line, end.line + 1, function (line) {
	      var text = line.text;
	      if (n == end.line) {
	        text = text.slice(0, end.ch);
	      }
	      if (n == start.line) {
	        text = text.slice(start.ch);
	      }
	      out.push(text);
	      ++n;
	    });
	    return out;
	  }
	  // Get the lines between from and to, as array of strings.
	  function getLines(doc, from, to) {
	    var out = [];
	    doc.iter(from, to, function (line) {
	      out.push(line.text);
	    }); // iter aborts when callback returns truthy value
	    return out;
	  }
	
	  // Update the height of a line, propagating the height change
	  // upwards to parent nodes.
	  function updateLineHeight(line, height) {
	    var diff = height - line.height;
	    if (diff) {
	      for (var n = line; n; n = n.parent) {
	        n.height += diff;
	      }
	    }
	  }
	
	  // Given a line object, find its line number by walking up through
	  // its parent links.
	  function lineNo(line) {
	    if (line.parent == null) {
	      return null;
	    }
	    var cur = line.parent,
	        no = indexOf(cur.lines, line);
	    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	      for (var i = 0;; ++i) {
	        if (chunk.children[i] == cur) {
	          break;
	        }
	        no += chunk.children[i].chunkSize();
	      }
	    }
	    return no + cur.first;
	  }
	
	  // Find the line at the given vertical position, using the height
	  // information in the document tree.
	  function _lineAtHeight(chunk, h) {
	    var n = chunk.first;
	    outer: do {
	      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
	        var child = chunk.children[i$1],
	            ch = child.height;
	        if (h < ch) {
	          chunk = child;continue outer;
	        }
	        h -= ch;
	        n += child.chunkSize();
	      }
	      return n;
	    } while (!chunk.lines);
	    var i = 0;
	    for (; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i],
	          lh = line.height;
	      if (h < lh) {
	        break;
	      }
	      h -= lh;
	    }
	    return n + i;
	  }
	
	  function isLine(doc, l) {
	    return l >= doc.first && l < doc.first + doc.size;
	  }
	
	  function lineNumberFor(options, i) {
	    return String(options.lineNumberFormatter(i + options.firstLineNumber));
	  }
	
	  // A Pos instance represents a position within the text.
	  function Pos(line, ch, sticky) {
	    if (sticky === void 0) sticky = null;
	
	    if (!(this instanceof Pos)) {
	      return new Pos(line, ch, sticky);
	    }
	    this.line = line;
	    this.ch = ch;
	    this.sticky = sticky;
	  }
	
	  // Compare two positions, return 0 if they are the same, a negative
	  // number when a is less, and a positive number otherwise.
	  function cmp(a, b) {
	    return a.line - b.line || a.ch - b.ch;
	  }
	
	  function equalCursorPos(a, b) {
	    return a.sticky == b.sticky && cmp(a, b) == 0;
	  }
	
	  function copyPos(x) {
	    return Pos(x.line, x.ch);
	  }
	  function maxPos(a, b) {
	    return cmp(a, b) < 0 ? b : a;
	  }
	  function minPos(a, b) {
	    return cmp(a, b) < 0 ? a : b;
	  }
	
	  // Most of the external API clips given positions to make sure they
	  // actually exist within the document.
	  function clipLine(doc, n) {
	    return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
	  }
	  function _clipPos(doc, pos) {
	    if (pos.line < doc.first) {
	      return Pos(doc.first, 0);
	    }
	    var last = doc.first + doc.size - 1;
	    if (pos.line > last) {
	      return Pos(last, getLine(doc, last).text.length);
	    }
	    return clipToLen(pos, getLine(doc, pos.line).text.length);
	  }
	  function clipToLen(pos, linelen) {
	    var ch = pos.ch;
	    if (ch == null || ch > linelen) {
	      return Pos(pos.line, linelen);
	    } else if (ch < 0) {
	      return Pos(pos.line, 0);
	    } else {
	      return pos;
	    }
	  }
	  function clipPosArray(doc, array) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) {
	      out[i] = _clipPos(doc, array[i]);
	    }
	    return out;
	  }
	
	  var SavedContext = function SavedContext(state, lookAhead) {
	    this.state = state;
	    this.lookAhead = lookAhead;
	  };
	
	  var Context = function Context(doc, state, line, lookAhead) {
	    this.state = state;
	    this.doc = doc;
	    this.line = line;
	    this.maxLookAhead = lookAhead || 0;
	    this.baseTokens = null;
	    this.baseTokenPos = 1;
	  };
	
	  Context.prototype.lookAhead = function (n) {
	    var line = this.doc.getLine(this.line + n);
	    if (line != null && n > this.maxLookAhead) {
	      this.maxLookAhead = n;
	    }
	    return line;
	  };
	
	  Context.prototype.baseToken = function (n) {
	    if (!this.baseTokens) {
	      return null;
	    }
	    while (this.baseTokens[this.baseTokenPos] <= n) {
	      this.baseTokenPos += 2;
	    }
	    var type = this.baseTokens[this.baseTokenPos + 1];
	    return { type: type && type.replace(/( |^)overlay .*/, ""),
	      size: this.baseTokens[this.baseTokenPos] - n };
	  };
	
	  Context.prototype.nextLine = function () {
	    this.line++;
	    if (this.maxLookAhead > 0) {
	      this.maxLookAhead--;
	    }
	  };
	
	  Context.fromSaved = function (doc, saved, line) {
	    if (saved instanceof SavedContext) {
	      return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
	    } else {
	      return new Context(doc, copyState(doc.mode, saved), line);
	    }
	  };
	
	  Context.prototype.save = function (copy) {
	    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
	    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
	  };
	
	  // Compute a style array (an array starting with a mode generation
	  // -- for invalidation -- followed by pairs of end positions and
	  // style strings), which is used to highlight the tokens on the
	  // line.
	  function highlightLine(cm, line, context, forceToEnd) {
	    // A styles array always starts with a number identifying the
	    // mode/overlays that it is based on (for easy invalidation).
	    var st = [cm.state.modeGen],
	        lineClasses = {};
	    // Compute the base array of styles
	    runMode(cm, line.text, cm.doc.mode, context, function (end, style) {
	      return st.push(end, style);
	    }, lineClasses, forceToEnd);
	    var state = context.state;
	
	    // Run overlays, adjust style array.
	    var loop = function loop(o) {
	      context.baseTokens = st;
	      var overlay = cm.state.overlays[o],
	          i = 1,
	          at = 0;
	      context.state = true;
	      runMode(cm, line.text, overlay.mode, context, function (end, style) {
	        var start = i;
	        // Ensure there's a token end at the current position, and that i points at it
	        while (at < end) {
	          var i_end = st[i];
	          if (i_end > end) {
	            st.splice(i, 1, end, st[i + 1], i_end);
	          }
	          i += 2;
	          at = Math.min(end, i_end);
	        }
	        if (!style) {
	          return;
	        }
	        if (overlay.opaque) {
	          st.splice(start, i - start, end, "overlay " + style);
	          i = start + 2;
	        } else {
	          for (; start < i; start += 2) {
	            var cur = st[start + 1];
	            st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
	          }
	        }
	      }, lineClasses);
	      context.state = state;
	      context.baseTokens = null;
	      context.baseTokenPos = 1;
	    };
	
	    for (var o = 0; o < cm.state.overlays.length; ++o) {
	      loop(o);
	    }return { styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null };
	  }
	
	  function getLineStyles(cm, line, updateFrontier) {
	    if (!line.styles || line.styles[0] != cm.state.modeGen) {
	      var context = getContextBefore(cm, lineNo(line));
	      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
	      var result = highlightLine(cm, line, context);
	      if (resetState) {
	        context.state = resetState;
	      }
	      line.stateAfter = context.save(!resetState);
	      line.styles = result.styles;
	      if (result.classes) {
	        line.styleClasses = result.classes;
	      } else if (line.styleClasses) {
	        line.styleClasses = null;
	      }
	      if (updateFrontier === cm.doc.highlightFrontier) {
	        cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
	      }
	    }
	    return line.styles;
	  }
	
	  function getContextBefore(cm, n, precise) {
	    var doc = cm.doc,
	        display = cm.display;
	    if (!doc.mode.startState) {
	      return new Context(doc, true, n);
	    }
	    var start = findStartLine(cm, n, precise);
	    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
	    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
	
	    doc.iter(start, n, function (line) {
	      processLine(cm, line.text, context);
	      var pos = context.line;
	      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
	      context.nextLine();
	    });
	    if (precise) {
	      doc.modeFrontier = context.line;
	    }
	    return context;
	  }
	
	  // Lightweight form of highlight -- proceed over this line and
	  // update state, but don't save a style array. Used for lines that
	  // aren't currently visible.
	  function processLine(cm, text, context, startAt) {
	    var mode = cm.doc.mode;
	    var stream = new StringStream(text, cm.options.tabSize, context);
	    stream.start = stream.pos = startAt || 0;
	    if (text == "") {
	      callBlankLine(mode, context.state);
	    }
	    while (!stream.eol()) {
	      readToken(mode, stream, context.state);
	      stream.start = stream.pos;
	    }
	  }
	
	  function callBlankLine(mode, state) {
	    if (mode.blankLine) {
	      return mode.blankLine(state);
	    }
	    if (!mode.innerMode) {
	      return;
	    }
	    var inner = innerMode(mode, state);
	    if (inner.mode.blankLine) {
	      return inner.mode.blankLine(inner.state);
	    }
	  }
	
	  function readToken(mode, stream, state, inner) {
	    for (var i = 0; i < 10; i++) {
	      if (inner) {
	        inner[0] = innerMode(mode, state).mode;
	      }
	      var style = mode.token(stream, state);
	      if (stream.pos > stream.start) {
	        return style;
	      }
	    }
	    throw new Error("Mode " + mode.name + " failed to advance stream.");
	  }
	
	  var Token = function Token(stream, type, state) {
	    this.start = stream.start;this.end = stream.pos;
	    this.string = stream.current();
	    this.type = type || null;
	    this.state = state;
	  };
	
	  // Utility for getTokenAt and getLineTokens
	  function takeToken(cm, pos, precise, asArray) {
	    var doc = cm.doc,
	        mode = doc.mode,
	        style;
	    pos = _clipPos(doc, pos);
	    var line = getLine(doc, pos.line),
	        context = getContextBefore(cm, pos.line, precise);
	    var stream = new StringStream(line.text, cm.options.tabSize, context),
	        tokens;
	    if (asArray) {
	      tokens = [];
	    }
	    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	      stream.start = stream.pos;
	      style = readToken(mode, stream, context.state);
	      if (asArray) {
	        tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
	      }
	    }
	    return asArray ? tokens : new Token(stream, style, context.state);
	  }
	
	  function extractLineClasses(type, output) {
	    if (type) {
	      for (;;) {
	        var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
	        if (!lineClass) {
	          break;
	        }
	        type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
	        var prop = lineClass[1] ? "bgClass" : "textClass";
	        if (output[prop] == null) {
	          output[prop] = lineClass[2];
	        } else if (!new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)").test(output[prop])) {
	          output[prop] += " " + lineClass[2];
	        }
	      }
	    }
	    return type;
	  }
	
	  // Run the given mode's parser over a line, calling f for each token.
	  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
	    var flattenSpans = mode.flattenSpans;
	    if (flattenSpans == null) {
	      flattenSpans = cm.options.flattenSpans;
	    }
	    var curStart = 0,
	        curStyle = null;
	    var stream = new StringStream(text, cm.options.tabSize, context),
	        style;
	    var inner = cm.options.addModeClass && [null];
	    if (text == "") {
	      extractLineClasses(callBlankLine(mode, context.state), lineClasses);
	    }
	    while (!stream.eol()) {
	      if (stream.pos > cm.options.maxHighlightLength) {
	        flattenSpans = false;
	        if (forceToEnd) {
	          processLine(cm, text, context, stream.pos);
	        }
	        stream.pos = text.length;
	        style = null;
	      } else {
	        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
	      }
	      if (inner) {
	        var mName = inner[0].name;
	        if (mName) {
	          style = "m-" + (style ? mName + " " + style : mName);
	        }
	      }
	      if (!flattenSpans || curStyle != style) {
	        while (curStart < stream.start) {
	          curStart = Math.min(stream.start, curStart + 5000);
	          f(curStart, curStyle);
	        }
	        curStyle = style;
	      }
	      stream.start = stream.pos;
	    }
	    while (curStart < stream.pos) {
	      // Webkit seems to refuse to render text nodes longer than 57444
	      // characters, and returns inaccurate measurements in nodes
	      // starting around 5000 chars.
	      var pos = Math.min(stream.pos, curStart + 5000);
	      f(pos, curStyle);
	      curStart = pos;
	    }
	  }
	
	  // Finds the line to start with when starting a parse. Tries to
	  // find a line with a stateAfter, so that it can start with a
	  // valid state. If that fails, it returns the line with the
	  // smallest indentation, which tends to need the least context to
	  // parse correctly.
	  function findStartLine(cm, n, precise) {
	    var minindent,
	        minline,
	        doc = cm.doc;
	    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
	    for (var search = n; search > lim; --search) {
	      if (search <= doc.first) {
	        return doc.first;
	      }
	      var line = getLine(doc, search - 1),
	          after = line.stateAfter;
	      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier)) {
	        return search;
	      }
	      var indented = countColumn(line.text, null, cm.options.tabSize);
	      if (minline == null || minindent > indented) {
	        minline = search - 1;
	        minindent = indented;
	      }
	    }
	    return minline;
	  }
	
	  function retreatFrontier(doc, n) {
	    doc.modeFrontier = Math.min(doc.modeFrontier, n);
	    if (doc.highlightFrontier < n - 10) {
	      return;
	    }
	    var start = doc.first;
	    for (var line = n - 1; line > start; line--) {
	      var saved = getLine(doc, line).stateAfter;
	      // change is on 3
	      // state on line 1 looked ahead 2 -- so saw 3
	      // test 1 + 2 < 3 should cover this
	      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
	        start = line + 1;
	        break;
	      }
	    }
	    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
	  }
	
	  // Optimize some code when these features are not used.
	  var sawReadOnlySpans = false,
	      sawCollapsedSpans = false;
	
	  function seeReadOnlySpans() {
	    sawReadOnlySpans = true;
	  }
	
	  function seeCollapsedSpans() {
	    sawCollapsedSpans = true;
	  }
	
	  // TEXTMARKER SPANS
	
	  function MarkedSpan(marker, from, to) {
	    this.marker = marker;
	    this.from = from;this.to = to;
	  }
	
	  // Search an array of spans for a span matching the given marker.
	  function getMarkedSpanFor(spans, marker) {
	    if (spans) {
	      for (var i = 0; i < spans.length; ++i) {
	        var span = spans[i];
	        if (span.marker == marker) {
	          return span;
	        }
	      }
	    }
	  }
	
	  // Remove a span from an array, returning undefined if no spans are
	  // left (we don't store arrays for lines without spans).
	  function removeMarkedSpan(spans, span) {
	    var r;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i] != span) {
	        (r || (r = [])).push(spans[i]);
	      }
	    }
	    return r;
	  }
	
	  // Add a span to a line.
	  function addMarkedSpan(line, span, op) {
	    var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet()));
	    if (inThisOp && line.markedSpans && inThisOp.has(line.markedSpans)) {
	      line.markedSpans.push(span);
	    } else {
	      line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
	      if (inThisOp) {
	        inThisOp.add(line.markedSpans);
	      }
	    }
	    span.marker.attachLine(line);
	  }
	
	  // Used for the algorithm that adjusts markers for a change in the
	  // document. These functions cut an array of spans at a given
	  // character position, returning an array of remaining chunks (or
	  // undefined if nothing remains).
	  function markedSpansBefore(old, startCh, isInsert) {
	    var nw;
	    if (old) {
	      for (var i = 0; i < old.length; ++i) {
	        var span = old[i],
	            marker = span.marker;
	        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
	        if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	          var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
	        }
	      }
	    }
	    return nw;
	  }
	  function markedSpansAfter(old, endCh, isInsert) {
	    var nw;
	    if (old) {
	      for (var i = 0; i < old.length; ++i) {
	        var span = old[i],
	            marker = span.marker;
	        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
	        if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	          var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
	        }
	      }
	    }
	    return nw;
	  }
	
	  // Given a change object, compute the new set of marker spans that
	  // cover the line in which the change took place. Removes spans
	  // entirely within the change, reconnects spans belonging to the
	  // same marker that appear on both sides of the change, and cuts off
	  // spans partially within the change. Returns an array of span
	  // arrays with one element for each line in (after) the change.
	  function stretchSpansOverChange(doc, change) {
	    if (change.full) {
	      return null;
	    }
	    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
	    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
	    if (!oldFirst && !oldLast) {
	      return null;
	    }
	
	    var startCh = change.from.ch,
	        endCh = change.to.ch,
	        isInsert = cmp(change.from, change.to) == 0;
	    // Get the spans that 'stick out' on both sides
	    var first = markedSpansBefore(oldFirst, startCh, isInsert);
	    var last = markedSpansAfter(oldLast, endCh, isInsert);
	
	    // Next, merge those two ends
	    var sameLine = change.text.length == 1,
	        offset = lst(change.text).length + (sameLine ? startCh : 0);
	    if (first) {
	      // Fix up .to properties of first
	      for (var i = 0; i < first.length; ++i) {
	        var span = first[i];
	        if (span.to == null) {
	          var found = getMarkedSpanFor(last, span.marker);
	          if (!found) {
	            span.to = startCh;
	          } else if (sameLine) {
	            span.to = found.to == null ? null : found.to + offset;
	          }
	        }
	      }
	    }
	    if (last) {
	      // Fix up .from in last (or move them into first in case of sameLine)
	      for (var i$1 = 0; i$1 < last.length; ++i$1) {
	        var span$1 = last[i$1];
	        if (span$1.to != null) {
	          span$1.to += offset;
	        }
	        if (span$1.from == null) {
	          var found$1 = getMarkedSpanFor(first, span$1.marker);
	          if (!found$1) {
	            span$1.from = offset;
	            if (sameLine) {
	              (first || (first = [])).push(span$1);
	            }
	          }
	        } else {
	          span$1.from += offset;
	          if (sameLine) {
	            (first || (first = [])).push(span$1);
	          }
	        }
	      }
	    }
	    // Make sure we didn't create any zero-length spans
	    if (first) {
	      first = clearEmptySpans(first);
	    }
	    if (last && last != first) {
	      last = clearEmptySpans(last);
	    }
	
	    var newMarkers = [first];
	    if (!sameLine) {
	      // Fill gap with whole-line-spans
	      var gap = change.text.length - 2,
	          gapMarkers;
	      if (gap > 0 && first) {
	        for (var i$2 = 0; i$2 < first.length; ++i$2) {
	          if (first[i$2].to == null) {
	            (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
	          }
	        }
	      }
	      for (var i$3 = 0; i$3 < gap; ++i$3) {
	        newMarkers.push(gapMarkers);
	      }
	      newMarkers.push(last);
	    }
	    return newMarkers;
	  }
	
	  // Remove spans that are empty and don't have a clearWhenEmpty
	  // option of false.
	  function clearEmptySpans(spans) {
	    for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) {
	        spans.splice(i--, 1);
	      }
	    }
	    if (!spans.length) {
	      return null;
	    }
	    return spans;
	  }
	
	  // Used to 'clip' out readOnly ranges when making a change.
	  function removeReadOnlyRanges(doc, from, to) {
	    var markers = null;
	    doc.iter(from.line, to.line + 1, function (line) {
	      if (line.markedSpans) {
	        for (var i = 0; i < line.markedSpans.length; ++i) {
	          var mark = line.markedSpans[i].marker;
	          if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) {
	            (markers || (markers = [])).push(mark);
	          }
	        }
	      }
	    });
	    if (!markers) {
	      return null;
	    }
	    var parts = [{ from: from, to: to }];
	    for (var i = 0; i < markers.length; ++i) {
	      var mk = markers[i],
	          m = mk.find(0);
	      for (var j = 0; j < parts.length; ++j) {
	        var p = parts[j];
	        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) {
	          continue;
	        }
	        var newParts = [j, 1],
	            dfrom = cmp(p.from, m.from),
	            dto = cmp(p.to, m.to);
	        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) {
	          newParts.push({ from: p.from, to: m.from });
	        }
	        if (dto > 0 || !mk.inclusiveRight && !dto) {
	          newParts.push({ from: m.to, to: p.to });
	        }
	        parts.splice.apply(parts, newParts);
	        j += newParts.length - 3;
	      }
	    }
	    return parts;
	  }
	
	  // Connect or disconnect spans from a line.
	  function detachMarkedSpans(line) {
	    var spans = line.markedSpans;
	    if (!spans) {
	      return;
	    }
	    for (var i = 0; i < spans.length; ++i) {
	      spans[i].marker.detachLine(line);
	    }
	    line.markedSpans = null;
	  }
	  function attachMarkedSpans(line, spans) {
	    if (!spans) {
	      return;
	    }
	    for (var i = 0; i < spans.length; ++i) {
	      spans[i].marker.attachLine(line);
	    }
	    line.markedSpans = spans;
	  }
	
	  // Helpers used when computing which overlapping collapsed span
	  // counts as the larger one.
	  function extraLeft(marker) {
	    return marker.inclusiveLeft ? -1 : 0;
	  }
	  function extraRight(marker) {
	    return marker.inclusiveRight ? 1 : 0;
	  }
	
	  // Returns a number indicating which of two overlapping collapsed
	  // spans is larger (and thus includes the other). Falls back to
	  // comparing ids when the spans cover exactly the same range.
	  function compareCollapsedMarkers(a, b) {
	    var lenDiff = a.lines.length - b.lines.length;
	    if (lenDiff != 0) {
	      return lenDiff;
	    }
	    var aPos = a.find(),
	        bPos = b.find();
	    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
	    if (fromCmp) {
	      return -fromCmp;
	    }
	    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
	    if (toCmp) {
	      return toCmp;
	    }
	    return b.id - a.id;
	  }
	
	  // Find out whether a line ends or starts in a collapsed span. If
	  // so, return the marker for that span.
	  function collapsedSpanAtSide(line, start) {
	    var sps = sawCollapsedSpans && line.markedSpans,
	        found;
	    if (sps) {
	      for (var sp = void 0, i = 0; i < sps.length; ++i) {
	        sp = sps[i];
	        if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
	          found = sp.marker;
	        }
	      }
	    }
	    return found;
	  }
	  function collapsedSpanAtStart(line) {
	    return collapsedSpanAtSide(line, true);
	  }
	  function collapsedSpanAtEnd(line) {
	    return collapsedSpanAtSide(line, false);
	  }
	
	  function collapsedSpanAround(line, ch) {
	    var sps = sawCollapsedSpans && line.markedSpans,
	        found;
	    if (sps) {
	      for (var i = 0; i < sps.length; ++i) {
	        var sp = sps[i];
	        if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
	          found = sp.marker;
	        }
	      }
	    }
	    return found;
	  }
	
	  // Test whether there exists a collapsed span that partially
	  // overlaps (covers the start or end, but not both) of a new span.
	  // Such overlap is not allowed.
	  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
	    var line = getLine(doc, lineNo);
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) {
	      for (var i = 0; i < sps.length; ++i) {
	        var sp = sps[i];
	        if (!sp.marker.collapsed) {
	          continue;
	        }
	        var found = sp.marker.find(0);
	        var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
	        var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
	        if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) {
	          continue;
	        }
	        if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) {
	          return true;
	        }
	      }
	    }
	  }
	
	  // A visual line is a line as drawn on the screen. Folding, for
	  // example, can cause multiple logical lines to appear on the same
	  // visual line. This finds the start of the visual line that the
	  // given line is part of (usually that is the line itself).
	  function visualLine(line) {
	    var merged;
	    while (merged = collapsedSpanAtStart(line)) {
	      line = merged.find(-1, true).line;
	    }
	    return line;
	  }
	
	  function visualLineEnd(line) {
	    var merged;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;
	    }
	    return line;
	  }
	
	  // Returns an array of logical lines that continue the visual line
	  // started by the argument, or undefined if there are no such lines.
	  function visualLineContinued(line) {
	    var merged, lines;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;(lines || (lines = [])).push(line);
	    }
	    return lines;
	  }
	
	  // Get the line number of the start of the visual line that the
	  // given line number is part of.
	  function visualLineNo(doc, lineN) {
	    var line = getLine(doc, lineN),
	        vis = visualLine(line);
	    if (line == vis) {
	      return lineN;
	    }
	    return lineNo(vis);
	  }
	
	  // Get the line number of the start of the next visual line after
	  // the given line.
	  function visualLineEndNo(doc, lineN) {
	    if (lineN > doc.lastLine()) {
	      return lineN;
	    }
	    var line = getLine(doc, lineN),
	        merged;
	    if (!lineIsHidden(doc, line)) {
	      return lineN;
	    }
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;
	    }
	    return lineNo(line) + 1;
	  }
	
	  // Compute whether a line is hidden. Lines count as hidden when they
	  // are part of a visual line that starts with another line, or when
	  // they are entirely covered by collapsed, non-widget span.
	  function lineIsHidden(doc, line) {
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) {
	      for (var sp = void 0, i = 0; i < sps.length; ++i) {
	        sp = sps[i];
	        if (!sp.marker.collapsed) {
	          continue;
	        }
	        if (sp.from == null) {
	          return true;
	        }
	        if (sp.marker.widgetNode) {
	          continue;
	        }
	        if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) {
	          return true;
	        }
	      }
	    }
	  }
	  function lineIsHiddenInner(doc, line, span) {
	    if (span.to == null) {
	      var end = span.marker.find(1, true);
	      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
	    }
	    if (span.marker.inclusiveRight && span.to == line.text.length) {
	      return true;
	    }
	    for (var sp = void 0, i = 0; i < line.markedSpans.length; ++i) {
	      sp = line.markedSpans[i];
	      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) {
	        return true;
	      }
	    }
	  }
	
	  // Find the height above the given line.
	  function _heightAtLine(lineObj) {
	    lineObj = visualLine(lineObj);
	
	    var h = 0,
	        chunk = lineObj.parent;
	    for (var i = 0; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i];
	      if (line == lineObj) {
	        break;
	      } else {
	        h += line.height;
	      }
	    }
	    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
	        var cur = p.children[i$1];
	        if (cur == chunk) {
	          break;
	        } else {
	          h += cur.height;
	        }
	      }
	    }
	    return h;
	  }
	
	  // Compute the character length of a line, taking into account
	  // collapsed ranges (see markText) that might hide parts, and join
	  // other lines onto it.
	  function lineLength(line) {
	    if (line.height == 0) {
	      return 0;
	    }
	    var len = line.text.length,
	        merged,
	        cur = line;
	    while (merged = collapsedSpanAtStart(cur)) {
	      var found = merged.find(0, true);
	      cur = found.from.line;
	      len += found.from.ch - found.to.ch;
	    }
	    cur = line;
	    while (merged = collapsedSpanAtEnd(cur)) {
	      var found$1 = merged.find(0, true);
	      len -= cur.text.length - found$1.from.ch;
	      cur = found$1.to.line;
	      len += cur.text.length - found$1.to.ch;
	    }
	    return len;
	  }
	
	  // Find the longest line in the document.
	  function findMaxLine(cm) {
	    var d = cm.display,
	        doc = cm.doc;
	    d.maxLine = getLine(doc, doc.first);
	    d.maxLineLength = lineLength(d.maxLine);
	    d.maxLineChanged = true;
	    doc.iter(function (line) {
	      var len = lineLength(line);
	      if (len > d.maxLineLength) {
	        d.maxLineLength = len;
	        d.maxLine = line;
	      }
	    });
	  }
	
	  // LINE DATA STRUCTURE
	
	  // Line objects. These hold state related to a line, including
	  // highlighting info (the styles array).
	  var Line = function Line(text, markedSpans, estimateHeight) {
	    this.text = text;
	    attachMarkedSpans(this, markedSpans);
	    this.height = estimateHeight ? estimateHeight(this) : 1;
	  };
	
	  Line.prototype.lineNo = function () {
	    return lineNo(this);
	  };
	  eventMixin(Line);
	
	  // Change the content (text, markers) of a line. Automatically
	  // invalidates cached information and tries to re-estimate the
	  // line's height.
	  function updateLine(line, text, markedSpans, estimateHeight) {
	    line.text = text;
	    if (line.stateAfter) {
	      line.stateAfter = null;
	    }
	    if (line.styles) {
	      line.styles = null;
	    }
	    if (line.order != null) {
	      line.order = null;
	    }
	    detachMarkedSpans(line);
	    attachMarkedSpans(line, markedSpans);
	    var estHeight = estimateHeight ? estimateHeight(line) : 1;
	    if (estHeight != line.height) {
	      updateLineHeight(line, estHeight);
	    }
	  }
	
	  // Detach a line from the document tree and its markers.
	  function cleanUpLine(line) {
	    line.parent = null;
	    detachMarkedSpans(line);
	  }
	
	  // Convert a style as returned by a mode (either null, or a string
	  // containing one or more styles) to a CSS style. This is cached,
	  // and also looks for line-wide styles.
	  var styleToClassCache = {},
	      styleToClassCacheWithMode = {};
	  function interpretTokenStyle(style, options) {
	    if (!style || /^\s*$/.test(style)) {
	      return null;
	    }
	    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
	    return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
	  }
	
	  // Render the DOM representation of the text of a line. Also builds
	  // up a 'line map', which points at the DOM nodes that represent
	  // specific stretches of text, and is used by the measuring code.
	  // The returned object contains the DOM node, this map, and
	  // information about line-wide styles that were set by the mode.
	  function buildLineContent(cm, lineView) {
	    // The padding-right forces the element to have a 'border', which
	    // is needed on Webkit to be able to get line-level bounding
	    // rectangles for it (in measureChar).
	    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
	    var builder = { pre: eltP("pre", [content], "CodeMirror-line"), content: content,
	      col: 0, pos: 0, cm: cm,
	      trailingSpace: false,
	      splitSpaces: cm.getOption("lineWrapping") };
	    lineView.measure = {};
	
	    // Iterate over the logical lines that make up this visual line.
	    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	      var line = i ? lineView.rest[i - 1] : lineView.line,
	          order = void 0;
	      builder.pos = 0;
	      builder.addToken = buildToken;
	      // Optionally wire in some hacks into the token-rendering
	      // algorithm, to deal with browser quirks.
	      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) {
	        builder.addToken = buildTokenBadBidi(builder.addToken, order);
	      }
	      builder.map = [];
	      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
	      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
	      if (line.styleClasses) {
	        if (line.styleClasses.bgClass) {
	          builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
	        }
	        if (line.styleClasses.textClass) {
	          builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
	        }
	      }
	
	      // Ensure at least a single node is present, for measuring.
	      if (builder.map.length == 0) {
	        builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
	      }
	
	      // Store the map and a cache object for the current logical line
	      if (i == 0) {
	        lineView.measure.map = builder.map;
	        lineView.measure.cache = {};
	      } else {
	        (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);(lineView.measure.caches || (lineView.measure.caches = [])).push({});
	      }
	    }
	
	    // See issue #2901
	    if (webkit) {
	      var last = builder.content.lastChild;
	      if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) {
	        builder.content.className = "cm-tab-wrap-hack";
	      }
	    }
	
	    signal(cm, "renderLine", cm, lineView.line, builder.pre);
	    if (builder.pre.className) {
	      builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
	    }
	
	    return builder;
	  }
	
	  function defaultSpecialCharPlaceholder(ch) {
	    var token = elt("span", '\u2022', "cm-invalidchar");
	    token.title = '\\u' + ch.charCodeAt(0).toString(16);
	    token.setAttribute("aria-label", token.title);
	    return token;
	  }
	
	  // Build up the DOM representation for a single token, and add it to
	  // the line map. Takes care to render special characters separately.
	  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
	    if (!text) {
	      return;
	    }
	    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
	    var special = builder.cm.state.specialChars,
	        mustWrap = false;
	    var content;
	    if (!special.test(text)) {
	      builder.col += text.length;
	      content = document.createTextNode(displayText);
	      builder.map.push(builder.pos, builder.pos + text.length, content);
	      if (ie && ie_version < 9) {
	        mustWrap = true;
	      }
	      builder.pos += text.length;
	    } else {
	      content = document.createDocumentFragment();
	      var pos = 0;
	      while (true) {
	        special.lastIndex = pos;
	        var m = special.exec(text);
	        var skipped = m ? m.index - pos : text.length - pos;
	        if (skipped) {
	          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
	          if (ie && ie_version < 9) {
	            content.appendChild(elt("span", [txt]));
	          } else {
	            content.appendChild(txt);
	          }
	          builder.map.push(builder.pos, builder.pos + skipped, txt);
	          builder.col += skipped;
	          builder.pos += skipped;
	        }
	        if (!m) {
	          break;
	        }
	        pos += skipped + 1;
	        var txt$1 = void 0;
	        if (m[0] == "\t") {
	          var tabSize = builder.cm.options.tabSize,
	              tabWidth = tabSize - builder.col % tabSize;
	          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
	          txt$1.setAttribute("role", "presentation");
	          txt$1.setAttribute("cm-text", "\t");
	          builder.col += tabWidth;
	        } else if (m[0] == "\r" || m[0] == "\n") {
	          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? '\u240D' : '\u2424', "cm-invalidchar"));
	          txt$1.setAttribute("cm-text", m[0]);
	          builder.col += 1;
	        } else {
	          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
	          txt$1.setAttribute("cm-text", m[0]);
	          if (ie && ie_version < 9) {
	            content.appendChild(elt("span", [txt$1]));
	          } else {
	            content.appendChild(txt$1);
	          }
	          builder.col += 1;
	        }
	        builder.map.push(builder.pos, builder.pos + 1, txt$1);
	        builder.pos++;
	      }
	    }
	    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
	    if (style || startStyle || endStyle || mustWrap || css || attributes) {
	      var fullStyle = style || "";
	      if (startStyle) {
	        fullStyle += startStyle;
	      }
	      if (endStyle) {
	        fullStyle += endStyle;
	      }
	      var token = elt("span", [content], fullStyle, css);
	      if (attributes) {
	        for (var attr in attributes) {
	          if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") {
	            token.setAttribute(attr, attributes[attr]);
	          }
	        }
	      }
	      return builder.content.appendChild(token);
	    }
	    builder.content.appendChild(content);
	  }
	
	  // Change some spaces to NBSP to prevent the browser from collapsing
	  // trailing spaces at the end of a line when rendering text (issue #1362).
	  function splitSpaces(text, trailingBefore) {
	    if (text.length > 1 && !/  /.test(text)) {
	      return text;
	    }
	    var spaceBefore = trailingBefore,
	        result = "";
	    for (var i = 0; i < text.length; i++) {
	      var ch = text.charAt(i);
	      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) {
	        ch = '\xA0';
	      }
	      result += ch;
	      spaceBefore = ch == " ";
	    }
	    return result;
	  }
	
	  // Work around nonsense dimensions being reported for stretches of
	  // right-to-left text.
	  function buildTokenBadBidi(inner, order) {
	    return function (builder, text, style, startStyle, endStyle, css, attributes) {
	      style = style ? style + " cm-force-border" : "cm-force-border";
	      var start = builder.pos,
	          end = start + text.length;
	      for (;;) {
	        // Find the part that overlaps with the start of this text
	        var part = void 0;
	        for (var i = 0; i < order.length; i++) {
	          part = order[i];
	          if (part.to > start && part.from <= start) {
	            break;
	          }
	        }
	        if (part.to >= end) {
	          return inner(builder, text, style, startStyle, endStyle, css, attributes);
	        }
	        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
	        startStyle = null;
	        text = text.slice(part.to - start);
	        start = part.to;
	      }
	    };
	  }
	
	  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	    var widget = !ignoreWidget && marker.widgetNode;
	    if (widget) {
	      builder.map.push(builder.pos, builder.pos + size, widget);
	    }
	    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	      if (!widget) {
	        widget = builder.content.appendChild(document.createElement("span"));
	      }
	      widget.setAttribute("cm-marker", marker.id);
	    }
	    if (widget) {
	      builder.cm.display.input.setUneditable(widget);
	      builder.content.appendChild(widget);
	    }
	    builder.pos += size;
	    builder.trailingSpace = false;
	  }
	
	  // Outputs a number of spans to make up a line, taking highlighting
	  // and marked text into account.
	  function insertLineContent(line, builder, styles) {
	    var spans = line.markedSpans,
	        allText = line.text,
	        at = 0;
	    if (!spans) {
	      for (var i$1 = 1; i$1 < styles.length; i$1 += 2) {
	        builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
	      }
	      return;
	    }
	
	    var len = allText.length,
	        pos = 0,
	        i = 1,
	        text = "",
	        style,
	        css;
	    var nextChange = 0,
	        spanStyle,
	        spanEndStyle,
	        spanStartStyle,
	        collapsed,
	        attributes;
	    for (;;) {
	      if (nextChange == pos) {
	        // Update current marker set
	        spanStyle = spanEndStyle = spanStartStyle = css = "";
	        attributes = null;
	        collapsed = null;nextChange = Infinity;
	        var foundBookmarks = [],
	            endStyles = void 0;
	        for (var j = 0; j < spans.length; ++j) {
	          var sp = spans[j],
	              m = sp.marker;
	          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	            foundBookmarks.push(m);
	          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	              nextChange = sp.to;
	              spanEndStyle = "";
	            }
	            if (m.className) {
	              spanStyle += " " + m.className;
	            }
	            if (m.css) {
	              css = (css ? css + ";" : "") + m.css;
	            }
	            if (m.startStyle && sp.from == pos) {
	              spanStartStyle += " " + m.startStyle;
	            }
	            if (m.endStyle && sp.to == nextChange) {
	              (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
	            }
	            // support for the old title property
	            // https://github.com/codemirror/CodeMirror/pull/5673
	            if (m.title) {
	              (attributes || (attributes = {})).title = m.title;
	            }
	            if (m.attributes) {
	              for (var attr in m.attributes) {
	                (attributes || (attributes = {}))[attr] = m.attributes[attr];
	              }
	            }
	            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) {
	              collapsed = sp;
	            }
	          } else if (sp.from > pos && nextChange > sp.from) {
	            nextChange = sp.from;
	          }
	        }
	        if (endStyles) {
	          for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2) {
	            if (endStyles[j$1 + 1] == nextChange) {
	              spanEndStyle += " " + endStyles[j$1];
	            }
	          }
	        }
	
	        if (!collapsed || collapsed.from == pos) {
	          for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2) {
	            buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
	          }
	        }
	        if (collapsed && (collapsed.from || 0) == pos) {
	          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
	          if (collapsed.to == null) {
	            return;
	          }
	          if (collapsed.to == pos) {
	            collapsed = false;
	          }
	        }
	      }
	      if (pos >= len) {
	        break;
	      }
	
	      var upto = Math.min(len, nextChange);
	      while (true) {
	        if (text) {
	          var end = pos + text.length;
	          if (!collapsed) {
	            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
	            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
	          }
	          if (end >= upto) {
	            text = text.slice(upto - pos);pos = upto;break;
	          }
	          pos = end;
	          spanStartStyle = "";
	        }
	        text = allText.slice(at, at = styles[i++]);
	        style = interpretTokenStyle(styles[i++], builder.cm.options);
	      }
	    }
	  }
	
	  // These objects are used to represent the visible (currently drawn)
	  // part of the document. A LineView may correspond to multiple
	  // logical lines, if those are connected by collapsed ranges.
	  function LineView(doc, line, lineN) {
	    // The starting line
	    this.line = line;
	    // Continuing lines, if any
	    this.rest = visualLineContinued(line);
	    // Number of logical lines in this visual line
	    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
	    this.node = this.text = null;
	    this.hidden = lineIsHidden(doc, line);
	  }
	
	  // Create a range of LineView objects for the given lines.
	  function buildViewArray(cm, from, to) {
	    var array = [],
	        nextPos;
	    for (var pos = from; pos < to; pos = nextPos) {
	      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
	      nextPos = pos + view.size;
	      array.push(view);
	    }
	    return array;
	  }
	
	  var operationGroup = null;
	
	  function pushOperation(op) {
	    if (operationGroup) {
	      operationGroup.ops.push(op);
	    } else {
	      op.ownsGroup = operationGroup = {
	        ops: [op],
	        delayedCallbacks: []
	      };
	    }
	  }
	
	  function fireCallbacksForOps(group) {
	    // Calls delayed callbacks and cursorActivity handlers until no
	    // new ones appear
	    var callbacks = group.delayedCallbacks,
	        i = 0;
	    do {
	      for (; i < callbacks.length; i++) {
	        callbacks[i].call(null);
	      }
	      for (var j = 0; j < group.ops.length; j++) {
	        var op = group.ops[j];
	        if (op.cursorActivityHandlers) {
	          while (op.cursorActivityCalled < op.cursorActivityHandlers.length) {
	            op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
	          }
	        }
	      }
	    } while (i < callbacks.length);
	  }
	
	  function finishOperation(op, endCb) {
	    var group = op.ownsGroup;
	    if (!group) {
	      return;
	    }
	
	    try {
	      fireCallbacksForOps(group);
	    } finally {
	      operationGroup = null;
	      endCb(group);
	    }
	  }
	
	  var orphanDelayedCallbacks = null;
	
	  // Often, we want to signal events at a point where we are in the
	  // middle of some work, but don't want the handler to start calling
	  // other methods on the editor, which might be in an inconsistent
	  // state or simply not expect any other events to happen.
	  // signalLater looks whether there are any handlers, and schedules
	  // them to be executed when the last operation ends, or, if no
	  // operation is active, when a timeout fires.
	  function signalLater(emitter, type /*, values...*/) {
	    var arr = getHandlers(emitter, type);
	    if (!arr.length) {
	      return;
	    }
	    var args = Array.prototype.slice.call(arguments, 2),
	        list;
	    if (operationGroup) {
	      list = operationGroup.delayedCallbacks;
	    } else if (orphanDelayedCallbacks) {
	      list = orphanDelayedCallbacks;
	    } else {
	      list = orphanDelayedCallbacks = [];
	      setTimeout(fireOrphanDelayed, 0);
	    }
	    var loop = function loop(i) {
	      list.push(function () {
	        return arr[i].apply(null, args);
	      });
	    };
	
	    for (var i = 0; i < arr.length; ++i) {
	      loop(i);
	    }
	  }
	
	  function fireOrphanDelayed() {
	    var delayed = orphanDelayedCallbacks;
	    orphanDelayedCallbacks = null;
	    for (var i = 0; i < delayed.length; ++i) {
	      delayed[i]();
	    }
	  }
	
	  // When an aspect of a line changes, a string is added to
	  // lineView.changes. This updates the relevant part of the line's
	  // DOM structure.
	  function updateLineForChanges(cm, lineView, lineN, dims) {
	    for (var j = 0; j < lineView.changes.length; j++) {
	      var type = lineView.changes[j];
	      if (type == "text") {
	        updateLineText(cm, lineView);
	      } else if (type == "gutter") {
	        updateLineGutter(cm, lineView, lineN, dims);
	      } else if (type == "class") {
	        updateLineClasses(cm, lineView);
	      } else if (type == "widget") {
	        updateLineWidgets(cm, lineView, dims);
	      }
	    }
	    lineView.changes = null;
	  }
	
	  // Lines with gutter elements, widgets or a background class need to
	  // be wrapped, and have the extra elements added to the wrapper div
	  function ensureLineWrapped(lineView) {
	    if (lineView.node == lineView.text) {
	      lineView.node = elt("div", null, null, "position: relative");
	      if (lineView.text.parentNode) {
	        lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
	      }
	      lineView.node.appendChild(lineView.text);
	      if (ie && ie_version < 8) {
	        lineView.node.style.zIndex = 2;
	      }
	    }
	    return lineView.node;
	  }
	
	  function updateLineBackground(cm, lineView) {
	    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
	    if (cls) {
	      cls += " CodeMirror-linebackground";
	    }
	    if (lineView.background) {
	      if (cls) {
	        lineView.background.className = cls;
	      } else {
	        lineView.background.parentNode.removeChild(lineView.background);lineView.background = null;
	      }
	    } else if (cls) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
	      cm.display.input.setUneditable(lineView.background);
	    }
	  }
	
	  // Wrapper around buildLineContent which will reuse the structure
	  // in display.externalMeasured when possible.
	  function getLineContent(cm, lineView) {
	    var ext = cm.display.externalMeasured;
	    if (ext && ext.line == lineView.line) {
	      cm.display.externalMeasured = null;
	      lineView.measure = ext.measure;
	      return ext.built;
	    }
	    return buildLineContent(cm, lineView);
	  }
	
	  // Redraw the line's text. Interacts with the background and text
	  // classes because the mode may output tokens that influence these
	  // classes.
	  function updateLineText(cm, lineView) {
	    var cls = lineView.text.className;
	    var built = getLineContent(cm, lineView);
	    if (lineView.text == lineView.node) {
	      lineView.node = built.pre;
	    }
	    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
	    lineView.text = built.pre;
	    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	      lineView.bgClass = built.bgClass;
	      lineView.textClass = built.textClass;
	      updateLineClasses(cm, lineView);
	    } else if (cls) {
	      lineView.text.className = cls;
	    }
	  }
	
	  function updateLineClasses(cm, lineView) {
	    updateLineBackground(cm, lineView);
	    if (lineView.line.wrapClass) {
	      ensureLineWrapped(lineView).className = lineView.line.wrapClass;
	    } else if (lineView.node != lineView.text) {
	      lineView.node.className = "";
	    }
	    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
	    lineView.text.className = textClass || "";
	  }
	
	  function updateLineGutter(cm, lineView, lineN, dims) {
	    if (lineView.gutter) {
	      lineView.node.removeChild(lineView.gutter);
	      lineView.gutter = null;
	    }
	    if (lineView.gutterBackground) {
	      lineView.node.removeChild(lineView.gutterBackground);
	      lineView.gutterBackground = null;
	    }
	    if (lineView.line.gutterClass) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
	      cm.display.input.setUneditable(lineView.gutterBackground);
	      wrap.insertBefore(lineView.gutterBackground, lineView.text);
	    }
	    var markers = lineView.line.gutterMarkers;
	    if (cm.options.lineNumbers || markers) {
	      var wrap$1 = ensureLineWrapped(lineView);
	      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
	      gutterWrap.setAttribute("aria-hidden", "true");
	      cm.display.input.setUneditable(gutterWrap);
	      wrap$1.insertBefore(gutterWrap, lineView.text);
	      if (lineView.line.gutterClass) {
	        gutterWrap.className += " " + lineView.line.gutterClass;
	      }
	      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) {
	        lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
	      }
	      if (markers) {
	        for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
	          var id = cm.display.gutterSpecs[k].className,
	              found = markers.hasOwnProperty(id) && markers[id];
	          if (found) {
	            gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
	          }
	        }
	      }
	    }
	  }
	
	  function updateLineWidgets(cm, lineView, dims) {
	    if (lineView.alignable) {
	      lineView.alignable = null;
	    }
	    var isWidget = classTest("CodeMirror-linewidget");
	    for (var node = lineView.node.firstChild, next = void 0; node; node = next) {
	      next = node.nextSibling;
	      if (isWidget.test(node.className)) {
	        lineView.node.removeChild(node);
	      }
	    }
	    insertLineWidgets(cm, lineView, dims);
	  }
	
	  // Build a line's DOM representation from scratch
	  function buildLineElement(cm, lineView, lineN, dims) {
	    var built = getLineContent(cm, lineView);
	    lineView.text = lineView.node = built.pre;
	    if (built.bgClass) {
	      lineView.bgClass = built.bgClass;
	    }
	    if (built.textClass) {
	      lineView.textClass = built.textClass;
	    }
	
	    updateLineClasses(cm, lineView);
	    updateLineGutter(cm, lineView, lineN, dims);
	    insertLineWidgets(cm, lineView, dims);
	    return lineView.node;
	  }
	
	  // A lineView may contain multiple logical lines (when merged by
	  // collapsed spans). The widgets for all of them need to be drawn.
	  function insertLineWidgets(cm, lineView, dims) {
	    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
	    if (lineView.rest) {
	      for (var i = 0; i < lineView.rest.length; i++) {
	        insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
	      }
	    }
	  }
	
	  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	    if (!line.widgets) {
	      return;
	    }
	    var wrap = ensureLineWrapped(lineView);
	    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	      var widget = ws[i],
	          node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
	      if (!widget.handleMouseEvents) {
	        node.setAttribute("cm-ignore-events", "true");
	      }
	      positionLineWidget(widget, node, lineView, dims);
	      cm.display.input.setUneditable(node);
	      if (allowAbove && widget.above) {
	        wrap.insertBefore(node, lineView.gutter || lineView.text);
	      } else {
	        wrap.appendChild(node);
	      }
	      signalLater(widget, "redraw");
	    }
	  }
	
	  function positionLineWidget(widget, node, lineView, dims) {
	    if (widget.noHScroll) {
	      (lineView.alignable || (lineView.alignable = [])).push(node);
	      var width = dims.wrapperWidth;
	      node.style.left = dims.fixedPos + "px";
	      if (!widget.coverGutter) {
	        width -= dims.gutterTotalWidth;
	        node.style.paddingLeft = dims.gutterTotalWidth + "px";
	      }
	      node.style.width = width + "px";
	    }
	    if (widget.coverGutter) {
	      node.style.zIndex = 5;
	      node.style.position = "relative";
	      if (!widget.noHScroll) {
	        node.style.marginLeft = -dims.gutterTotalWidth + "px";
	      }
	    }
	  }
	
	  function widgetHeight(widget) {
	    if (widget.height != null) {
	      return widget.height;
	    }
	    var cm = widget.doc.cm;
	    if (!cm) {
	      return 0;
	    }
	    if (!contains(document.body, widget.node)) {
	      var parentStyle = "position: relative;";
	      if (widget.coverGutter) {
	        parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
	      }
	      if (widget.noHScroll) {
	        parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
	      }
	      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
	    }
	    return widget.height = widget.node.parentNode.offsetHeight;
	  }
	
	  // Return true when the given mouse event happened in a widget
	  function eventInWidget(display, e) {
	    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	      if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) {
	        return true;
	      }
	    }
	  }
	
	  // POSITION MEASUREMENT
	
	  function paddingTop(display) {
	    return display.lineSpace.offsetTop;
	  }
	  function paddingVert(display) {
	    return display.mover.offsetHeight - display.lineSpace.offsetHeight;
	  }
	  function paddingH(display) {
	    if (display.cachedPaddingH) {
	      return display.cachedPaddingH;
	    }
	    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
	    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
	    var data = { left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight) };
	    if (!isNaN(data.left) && !isNaN(data.right)) {
	      display.cachedPaddingH = data;
	    }
	    return data;
	  }
	
	  function scrollGap(cm) {
	    return scrollerGap - cm.display.nativeBarWidth;
	  }
	  function displayWidth(cm) {
	    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
	  }
	  function displayHeight(cm) {
	    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
	  }
	
	  // Ensure the lineView.wrapping.heights array is populated. This is
	  // an array of bottom offsets for the lines that make up a drawn
	  // line. When lineWrapping is on, there might be more than one
	  // height.
	  function ensureLineHeights(cm, lineView, rect) {
	    var wrapping = cm.options.lineWrapping;
	    var curWidth = wrapping && displayWidth(cm);
	    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	      var heights = lineView.measure.heights = [];
	      if (wrapping) {
	        lineView.measure.width = curWidth;
	        var rects = lineView.text.firstChild.getClientRects();
	        for (var i = 0; i < rects.length - 1; i++) {
	          var cur = rects[i],
	              next = rects[i + 1];
	          if (Math.abs(cur.bottom - next.bottom) > 2) {
	            heights.push((cur.bottom + next.top) / 2 - rect.top);
	          }
	        }
	      }
	      heights.push(rect.bottom - rect.top);
	    }
	  }
	
	  // Find a line map (mapping character offsets to text nodes) and a
	  // measurement cache for the given line number. (A line view might
	  // contain multiple lines when collapsed ranges are present.)
	  function mapFromLineView(lineView, line, lineN) {
	    if (lineView.line == line) {
	      return { map: lineView.measure.map, cache: lineView.measure.cache };
	    }
	    if (lineView.rest) {
	      for (var i = 0; i < lineView.rest.length; i++) {
	        if (lineView.rest[i] == line) {
	          return { map: lineView.measure.maps[i], cache: lineView.measure.caches[i] };
	        }
	      }
	      for (var i$1 = 0; i$1 < lineView.rest.length; i$1++) {
	        if (lineNo(lineView.rest[i$1]) > lineN) {
	          return { map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true };
	        }
	      }
	    }
	  }
	
	  // Render a line into the hidden node display.externalMeasured. Used
	  // when measurement is needed for a line that's not in the viewport.
	  function updateExternalMeasurement(cm, line) {
	    line = visualLine(line);
	    var lineN = lineNo(line);
	    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
	    view.lineN = lineN;
	    var built = view.built = buildLineContent(cm, view);
	    view.text = built.pre;
	    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
	    return view;
	  }
	
	  // Get a {top, bottom, left, right} box (in line-local coordinates)
	  // for a given character.
	  function measureChar(cm, line, ch, bias) {
	    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
	  }
	
	  // Find a line view that corresponds to the given line number.
	  function findViewForLine(cm, lineN) {
	    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) {
	      return cm.display.view[findViewIndex(cm, lineN)];
	    }
	    var ext = cm.display.externalMeasured;
	    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) {
	      return ext;
	    }
	  }
	
	  // Measurement can be split in two steps, the set-up work that
	  // applies to the whole line, and the measurement of the actual
	  // character. Functions like coordsChar, that need to do a lot of
	  // measurements in a row, can thus ensure that the set-up work is
	  // only done once.
	  function prepareMeasureForLine(cm, line) {
	    var lineN = lineNo(line);
	    var view = findViewForLine(cm, lineN);
	    if (view && !view.text) {
	      view = null;
	    } else if (view && view.changes) {
	      updateLineForChanges(cm, view, lineN, getDimensions(cm));
	      cm.curOp.forceUpdate = true;
	    }
	    if (!view) {
	      view = updateExternalMeasurement(cm, line);
	    }
	
	    var info = mapFromLineView(view, line, lineN);
	    return {
	      line: line, view: view, rect: null,
	      map: info.map, cache: info.cache, before: info.before,
	      hasHeights: false
	    };
	  }
	
	  // Given a prepared measurement object, measures the position of an
	  // actual character (or fetches it from the cache).
	  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	    if (prepared.before) {
	      ch = -1;
	    }
	    var key = ch + (bias || ""),
	        found;
	    if (prepared.cache.hasOwnProperty(key)) {
	      found = prepared.cache[key];
	    } else {
	      if (!prepared.rect) {
	        prepared.rect = prepared.view.text.getBoundingClientRect();
	      }
	      if (!prepared.hasHeights) {
	        ensureLineHeights(cm, prepared.view, prepared.rect);
	        prepared.hasHeights = true;
	      }
	      found = measureCharInner(cm, prepared, ch, bias);
	      if (!found.bogus) {
	        prepared.cache[key] = found;
	      }
	    }
	    return { left: found.left, right: found.right,
	      top: varHeight ? found.rtop : found.top,
	      bottom: varHeight ? found.rbottom : found.bottom };
	  }
	
	  var nullRect = { left: 0, right: 0, top: 0, bottom: 0 };
	
	  function nodeAndOffsetInLineMap(map, ch, bias) {
	    var node, start, end, collapse, mStart, mEnd;
	    // First, search the line map for the text node corresponding to,
	    // or closest to, the target character.
	    for (var i = 0; i < map.length; i += 3) {
	      mStart = map[i];
	      mEnd = map[i + 1];
	      if (ch < mStart) {
	        start = 0;end = 1;
	        collapse = "left";
	      } else if (ch < mEnd) {
	        start = ch - mStart;
	        end = start + 1;
	      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
	        end = mEnd - mStart;
	        start = end - 1;
	        if (ch >= mEnd) {
	          collapse = "right";
	        }
	      }
	      if (start != null) {
	        node = map[i + 2];
	        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) {
	          collapse = bias;
	        }
	        if (bias == "left" && start == 0) {
	          while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
	            node = map[(i -= 3) + 2];
	            collapse = "left";
	          }
	        }
	        if (bias == "right" && start == mEnd - mStart) {
	          while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
	            node = map[(i += 3) + 2];
	            collapse = "right";
	          }
	        }
	        break;
	      }
	    }
	    return { node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd };
	  }
	
	  function getUsefulRect(rects, bias) {
	    var rect = nullRect;
	    if (bias == "left") {
	      for (var i = 0; i < rects.length; i++) {
	        if ((rect = rects[i]).left != rect.right) {
	          break;
	        }
	      }
	    } else {
	      for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
	        if ((rect = rects[i$1]).left != rect.right) {
	          break;
	        }
	      }
	    }
	    return rect;
	  }
	
	  function measureCharInner(cm, prepared, ch, bias) {
	    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
	    var node = place.node,
	        start = place.start,
	        end = place.end,
	        collapse = place.collapse;
	
	    var rect;
	    if (node.nodeType == 3) {
	      // If it is a text node, use a range to retrieve the coordinates.
	      for (var i$1 = 0; i$1 < 4; i$1++) {
	        // Retry a maximum of 4 times when nonsense rectangles are returned
	        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) {
	          --start;
	        }
	        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) {
	          ++end;
	        }
	        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) {
	          rect = node.parentNode.getBoundingClientRect();
	        } else {
	          rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
	        }
	        if (rect.left || rect.right || start == 0) {
	          break;
	        }
	        end = start;
	        start = start - 1;
	        collapse = "right";
	      }
	      if (ie && ie_version < 11) {
	        rect = maybeUpdateRectForZooming(cm.display.measure, rect);
	      }
	    } else {
	      // If it is a widget, simply get the box for the whole widget.
	      if (start > 0) {
	        collapse = bias = "right";
	      }
	      var rects;
	      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) {
	        rect = rects[bias == "right" ? rects.length - 1 : 0];
	      } else {
	        rect = node.getBoundingClientRect();
	      }
	    }
	    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	      var rSpan = node.parentNode.getClientRects()[0];
	      if (rSpan) {
	        rect = { left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom };
	      } else {
	        rect = nullRect;
	      }
	    }
	
	    var rtop = rect.top - prepared.rect.top,
	        rbot = rect.bottom - prepared.rect.top;
	    var mid = (rtop + rbot) / 2;
	    var heights = prepared.view.measure.heights;
	    var i = 0;
	    for (; i < heights.length - 1; i++) {
	      if (mid < heights[i]) {
	        break;
	      }
	    }
	    var top = i ? heights[i - 1] : 0,
	        bot = heights[i];
	    var result = { left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	      right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	      top: top, bottom: bot };
	    if (!rect.left && !rect.right) {
	      result.bogus = true;
	    }
	    if (!cm.options.singleCursorHeightPerLine) {
	      result.rtop = rtop;result.rbottom = rbot;
	    }
	
	    return result;
	  }
	
	  // Work around problem with bounding client rects on ranges being
	  // returned incorrectly when zoomed on IE10 and below.
	  function maybeUpdateRectForZooming(measure, rect) {
	    if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) {
	      return rect;
	    }
	    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
	    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
	    return { left: rect.left * scaleX, right: rect.right * scaleX,
	      top: rect.top * scaleY, bottom: rect.bottom * scaleY };
	  }
	
	  function clearLineMeasurementCacheFor(lineView) {
	    if (lineView.measure) {
	      lineView.measure.cache = {};
	      lineView.measure.heights = null;
	      if (lineView.rest) {
	        for (var i = 0; i < lineView.rest.length; i++) {
	          lineView.measure.caches[i] = {};
	        }
	      }
	    }
	  }
	
	  function clearLineMeasurementCache(cm) {
	    cm.display.externalMeasure = null;
	    removeChildren(cm.display.lineMeasure);
	    for (var i = 0; i < cm.display.view.length; i++) {
	      clearLineMeasurementCacheFor(cm.display.view[i]);
	    }
	  }
	
	  function clearCaches(cm) {
	    clearLineMeasurementCache(cm);
	    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
	    if (!cm.options.lineWrapping) {
	      cm.display.maxLineChanged = true;
	    }
	    cm.display.lineNumChars = null;
	  }
	
	  function pageScrollX(doc) {
	    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
	    // which causes page_Offset and bounding client rects to use
	    // different reference viewports and invalidate our calculations.
	    if (chrome && android) {
	      return -(doc.body.getBoundingClientRect().left - parseInt(getComputedStyle(doc.body).marginLeft));
	    }
	    return doc.defaultView.pageXOffset || (doc.documentElement || doc.body).scrollLeft;
	  }
	  function pageScrollY(doc) {
	    if (chrome && android) {
	      return -(doc.body.getBoundingClientRect().top - parseInt(getComputedStyle(doc.body).marginTop));
	    }
	    return doc.defaultView.pageYOffset || (doc.documentElement || doc.body).scrollTop;
	  }
	
	  function widgetTopHeight(lineObj) {
	    var ref = visualLine(lineObj);
	    var widgets = ref.widgets;
	    var height = 0;
	    if (widgets) {
	      for (var i = 0; i < widgets.length; ++i) {
	        if (widgets[i].above) {
	          height += widgetHeight(widgets[i]);
	        }
	      }
	    }
	    return height;
	  }
	
	  // Converts a {top, bottom, left, right} box from line-local
	  // coordinates into another coordinate system. Context may be one of
	  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
	  // or "page".
	  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
	    if (!includeWidgets) {
	      var height = widgetTopHeight(lineObj);
	      rect.top += height;rect.bottom += height;
	    }
	    if (context == "line") {
	      return rect;
	    }
	    if (!context) {
	      context = "local";
	    }
	    var yOff = _heightAtLine(lineObj);
	    if (context == "local") {
	      yOff += paddingTop(cm.display);
	    } else {
	      yOff -= cm.display.viewOffset;
	    }
	    if (context == "page" || context == "window") {
	      var lOff = cm.display.lineSpace.getBoundingClientRect();
	      yOff += lOff.top + (context == "window" ? 0 : pageScrollY(doc(cm)));
	      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX(doc(cm)));
	      rect.left += xOff;rect.right += xOff;
	    }
	    rect.top += yOff;rect.bottom += yOff;
	    return rect;
	  }
	
	  // Coverts a box from "div" coords to another coordinate system.
	  // Context may be "window", "page", "div", or "local"./null.
	  function fromCoordSystem(cm, coords, context) {
	    if (context == "div") {
	      return coords;
	    }
	    var left = coords.left,
	        top = coords.top;
	    // First move into "page" coordinate system
	    if (context == "page") {
	      left -= pageScrollX(doc(cm));
	      top -= pageScrollY(doc(cm));
	    } else if (context == "local" || !context) {
	      var localBox = cm.display.sizer.getBoundingClientRect();
	      left += localBox.left;
	      top += localBox.top;
	    }
	
	    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
	    return { left: left - lineSpaceBox.left, top: top - lineSpaceBox.top };
	  }
	
	  function _charCoords(cm, pos, context, lineObj, bias) {
	    if (!lineObj) {
	      lineObj = getLine(cm.doc, pos.line);
	    }
	    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
	  }
	
	  // Returns a box for a given cursor position, which may have an
	  // 'other' property containing the position of the secondary cursor
	  // on a bidi boundary.
	  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
	  // and after `char - 1` in writing order of `char - 1`
	  // A cursor Pos(line, char, "after") is on the same visual line as `char`
	  // and before `char` in writing order of `char`
	  // Examples (upper-case letters are RTL, lower-case are LTR):
	  //     Pos(0, 1, ...)
	  //     before   after
	  // ab     a|b     a|b
	  // aB     a|B     aB|
	  // Ab     |Ab     A|b
	  // AB     B|A     B|A
	  // Every position after the last character on a line is considered to stick
	  // to the last character on the line.
	  function _cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	    lineObj = lineObj || getLine(cm.doc, pos.line);
	    if (!preparedMeasure) {
	      preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    }
	    function get(ch, right) {
	      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
	      if (right) {
	        m.left = m.right;
	      } else {
	        m.right = m.left;
	      }
	      return intoCoordSystem(cm, lineObj, m, context);
	    }
	    var order = getOrder(lineObj, cm.doc.direction),
	        ch = pos.ch,
	        sticky = pos.sticky;
	    if (ch >= lineObj.text.length) {
	      ch = lineObj.text.length;
	      sticky = "before";
	    } else if (ch <= 0) {
	      ch = 0;
	      sticky = "after";
	    }
	    if (!order) {
	      return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
	    }
	
	    function getBidi(ch, partPos, invert) {
	      var part = order[partPos],
	          right = part.level == 1;
	      return get(invert ? ch - 1 : ch, right != invert);
	    }
	    var partPos = getBidiPartAt(order, ch, sticky);
	    var other = bidiOther;
	    var val = getBidi(ch, partPos, sticky == "before");
	    if (other != null) {
	      val.other = getBidi(ch, other, sticky != "before");
	    }
	    return val;
	  }
	
	  // Used to cheaply estimate the coordinates for a position. Used for
	  // intermediate scroll updates.
	  function estimateCoords(cm, pos) {
	    var left = 0;
	    pos = _clipPos(cm.doc, pos);
	    if (!cm.options.lineWrapping) {
	      left = charWidth(cm.display) * pos.ch;
	    }
	    var lineObj = getLine(cm.doc, pos.line);
	    var top = _heightAtLine(lineObj) + paddingTop(cm.display);
	    return { left: left, right: left, top: top, bottom: top + lineObj.height };
	  }
	
	  // Positions returned by coordsChar contain some extra information.
	  // xRel is the relative x position of the input coordinates compared
	  // to the found position (so xRel > 0 means the coordinates are to
	  // the right of the character position, for example). When outside
	  // is true, that means the coordinates lie outside the line's
	  // vertical range.
	  function PosWithInfo(line, ch, sticky, outside, xRel) {
	    var pos = Pos(line, ch, sticky);
	    pos.xRel = xRel;
	    if (outside) {
	      pos.outside = outside;
	    }
	    return pos;
	  }
	
	  // Compute the character position closest to the given coordinates.
	  // Input must be lineSpace-local ("div" coordinate system).
	  function _coordsChar(cm, x, y) {
	    var doc = cm.doc;
	    y += cm.display.viewOffset;
	    if (y < 0) {
	      return PosWithInfo(doc.first, 0, null, -1, -1);
	    }
	    var lineN = _lineAtHeight(doc, y),
	        last = doc.first + doc.size - 1;
	    if (lineN > last) {
	      return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1);
	    }
	    if (x < 0) {
	      x = 0;
	    }
	
	    var lineObj = getLine(doc, lineN);
	    for (;;) {
	      var found = coordsCharInner(cm, lineObj, lineN, x, y);
	      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
	      if (!collapsed) {
	        return found;
	      }
	      var rangeEnd = collapsed.find(1);
	      if (rangeEnd.line == lineN) {
	        return rangeEnd;
	      }
	      lineObj = getLine(doc, lineN = rangeEnd.line);
	    }
	  }
	
	  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
	    y -= widgetTopHeight(lineObj);
	    var end = lineObj.text.length;
	    var begin = findFirst(function (ch) {
	      return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
	    }, end, 0);
	    end = findFirst(function (ch) {
	      return measureCharPrepared(cm, preparedMeasure, ch).top > y;
	    }, begin, end);
	    return { begin: begin, end: end };
	  }
	
	  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
	    if (!preparedMeasure) {
	      preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    }
	    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
	    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
	  }
	
	  // Returns true if the given side of a box is after the given
	  // coordinates, in top-to-bottom, left-to-right order.
	  function boxIsAfter(box, x, y, left) {
	    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
	  }
	
	  function coordsCharInner(cm, lineObj, lineNo, x, y) {
	    // Move y into line-local coordinate space
	    y -= _heightAtLine(lineObj);
	    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    // When directly calling `measureCharPrepared`, we have to adjust
	    // for the widgets at this line.
	    var widgetHeight = widgetTopHeight(lineObj);
	    var begin = 0,
	        end = lineObj.text.length,
	        ltr = true;
	
	    var order = getOrder(lineObj, cm.doc.direction);
	    // If the line isn't plain left-to-right text, first figure out
	    // which bidi section the coordinates fall into.
	    if (order) {
	      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo, preparedMeasure, order, x, y);
	      ltr = part.level != 1;
	      // The awkward -1 offsets are needed because findFirst (called
	      // on these below) will treat its first bound as inclusive,
	      // second as exclusive, but we want to actually address the
	      // characters in the part's range
	      begin = ltr ? part.from : part.to - 1;
	      end = ltr ? part.to : part.from - 1;
	    }
	
	    // A binary search to find the first character whose bounding box
	    // starts after the coordinates. If we run across any whose box wrap
	    // the coordinates, store that.
	    var chAround = null,
	        boxAround = null;
	    var ch = findFirst(function (ch) {
	      var box = measureCharPrepared(cm, preparedMeasure, ch);
	      box.top += widgetHeight;box.bottom += widgetHeight;
	      if (!boxIsAfter(box, x, y, false)) {
	        return false;
	      }
	      if (box.top <= y && box.left <= x) {
	        chAround = ch;
	        boxAround = box;
	      }
	      return true;
	    }, begin, end);
	
	    var baseX,
	        sticky,
	        outside = false;
	    // If a box around the coordinates was found, use that
	    if (boxAround) {
	      // Distinguish coordinates nearer to the left or right side of the box
	      var atLeft = x - boxAround.left < boxAround.right - x,
	          atStart = atLeft == ltr;
	      ch = chAround + (atStart ? 0 : 1);
	      sticky = atStart ? "after" : "before";
	      baseX = atLeft ? boxAround.left : boxAround.right;
	    } else {
	      // (Adjust for extended bound, if necessary.)
	      if (!ltr && (ch == end || ch == begin)) {
	        ch++;
	      }
	      // To determine which side to associate with, get the box to the
	      // left of the character and compare it's vertical position to the
	      // coordinates
	      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y == ltr ? "after" : "before";
	      // Now get accurate coordinates for this place, in order to get a
	      // base X position
	      var coords = _cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
	      baseX = coords.left;
	      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
	    }
	
	    ch = skipExtendingChars(lineObj.text, ch, 1);
	    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX);
	  }
	
	  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
	    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
	    // situation, we can take this ordering to correspond to the visual
	    // ordering. This finds the first part whose end is after the given
	    // coordinates.
	    var index = findFirst(function (i) {
	      var part = order[i],
	          ltr = part.level != 1;
	      return boxIsAfter(_cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
	    }, 0, order.length - 1);
	    var part = order[index];
	    // If this isn't the first part, the part's start is also after
	    // the coordinates, and the coordinates aren't on the same line as
	    // that start, move one part back.
	    if (index > 0) {
	      var ltr = part.level != 1;
	      var start = _cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
	      if (boxIsAfter(start, x, y, true) && start.top > y) {
	        part = order[index - 1];
	      }
	    }
	    return part;
	  }
	
	  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
	    // In a wrapped line, rtl text on wrapping boundaries can do things
	    // that don't correspond to the ordering in our `order` array at
	    // all, so a binary search doesn't work, and we want to return a
	    // part that only spans one line so that the binary search in
	    // coordsCharInner is safe. As such, we first find the extent of the
	    // wrapped line, and then do a flat search in which we discard any
	    // spans that aren't on the line.
	    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
	    var begin = ref.begin;
	    var end = ref.end;
	    if (/\s/.test(lineObj.text.charAt(end - 1))) {
	      end--;
	    }
	    var part = null,
	        closestDist = null;
	    for (var i = 0; i < order.length; i++) {
	      var p = order[i];
	      if (p.from >= end || p.to <= begin) {
	        continue;
	      }
	      var ltr = p.level != 1;
	      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
	      // Weigh against spans ending before this, so that they are only
	      // picked if nothing ends after
	      var dist = endX < x ? x - endX + 1e9 : endX - x;
	      if (!part || closestDist > dist) {
	        part = p;
	        closestDist = dist;
	      }
	    }
	    if (!part) {
	      part = order[order.length - 1];
	    }
	    // Clip the part to the wrapped line.
	    if (part.from < begin) {
	      part = { from: begin, to: part.to, level: part.level };
	    }
	    if (part.to > end) {
	      part = { from: part.from, to: end, level: part.level };
	    }
	    return part;
	  }
	
	  var measureText;
	  // Compute the default text height.
	  function textHeight(display) {
	    if (display.cachedTextHeight != null) {
	      return display.cachedTextHeight;
	    }
	    if (measureText == null) {
	      measureText = elt("pre", null, "CodeMirror-line-like");
	      // Measure a bunch of lines, for browsers that compute
	      // fractional heights.
	      for (var i = 0; i < 49; ++i) {
	        measureText.appendChild(document.createTextNode("x"));
	        measureText.appendChild(elt("br"));
	      }
	      measureText.appendChild(document.createTextNode("x"));
	    }
	    removeChildrenAndAdd(display.measure, measureText);
	    var height = measureText.offsetHeight / 50;
	    if (height > 3) {
	      display.cachedTextHeight = height;
	    }
	    removeChildren(display.measure);
	    return height || 1;
	  }
	
	  // Compute the default character width.
	  function charWidth(display) {
	    if (display.cachedCharWidth != null) {
	      return display.cachedCharWidth;
	    }
	    var anchor = elt("span", "xxxxxxxxxx");
	    var pre = elt("pre", [anchor], "CodeMirror-line-like");
	    removeChildrenAndAdd(display.measure, pre);
	    var rect = anchor.getBoundingClientRect(),
	        width = (rect.right - rect.left) / 10;
	    if (width > 2) {
	      display.cachedCharWidth = width;
	    }
	    return width || 10;
	  }
	
	  // Do a bulk-read of the DOM positions and sizes needed to draw the
	  // view, so that we don't interleave reading and writing to the DOM.
	  function getDimensions(cm) {
	    var d = cm.display,
	        left = {},
	        width = {};
	    var gutterLeft = d.gutters.clientLeft;
	    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	      var id = cm.display.gutterSpecs[i].className;
	      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
	      width[id] = n.clientWidth;
	    }
	    return { fixedPos: compensateForHScroll(d),
	      gutterTotalWidth: d.gutters.offsetWidth,
	      gutterLeft: left,
	      gutterWidth: width,
	      wrapperWidth: d.wrapper.clientWidth };
	  }
	
	  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	  // but using getBoundingClientRect to get a sub-pixel-accurate
	  // result.
	  function compensateForHScroll(display) {
	    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
	  }
	
	  // Returns a function that estimates the height of a line, to use as
	  // first approximation until the line becomes visible (and is thus
	  // properly measurable).
	  function estimateHeight(cm) {
	    var th = textHeight(cm.display),
	        wrapping = cm.options.lineWrapping;
	    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
	    return function (line) {
	      if (lineIsHidden(cm.doc, line)) {
	        return 0;
	      }
	
	      var widgetsHeight = 0;
	      if (line.widgets) {
	        for (var i = 0; i < line.widgets.length; i++) {
	          if (line.widgets[i].height) {
	            widgetsHeight += line.widgets[i].height;
	          }
	        }
	      }
	
	      if (wrapping) {
	        return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
	      } else {
	        return widgetsHeight + th;
	      }
	    };
	  }
	
	  function estimateLineHeights(cm) {
	    var doc = cm.doc,
	        est = estimateHeight(cm);
	    doc.iter(function (line) {
	      var estHeight = est(line);
	      if (estHeight != line.height) {
	        updateLineHeight(line, estHeight);
	      }
	    });
	  }
	
	  // Given a mouse event, find the corresponding position. If liberal
	  // is false, it checks whether a gutter or scrollbar was clicked,
	  // and returns null if it was. forRect is used by rectangular
	  // selections, and tries to estimate a character position even for
	  // coordinates beyond the right of the text.
	  function posFromMouse(cm, e, liberal, forRect) {
	    var display = cm.display;
	    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") {
	      return null;
	    }
	
	    var x,
	        y,
	        space = display.lineSpace.getBoundingClientRect();
	    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	    try {
	      x = e.clientX - space.left;y = e.clientY - space.top;
	    } catch (e$1) {
	      return null;
	    }
	    var coords = _coordsChar(cm, x, y),
	        line;
	    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
	      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
	    }
	    return coords;
	  }
	
	  // Find the view element corresponding to a given line. Return null
	  // when the line isn't visible.
	  function findViewIndex(cm, n) {
	    if (n >= cm.display.viewTo) {
	      return null;
	    }
	    n -= cm.display.viewFrom;
	    if (n < 0) {
	      return null;
	    }
	    var view = cm.display.view;
	    for (var i = 0; i < view.length; i++) {
	      n -= view[i].size;
	      if (n < 0) {
	        return i;
	      }
	    }
	  }
	
	  // Updates the display.view data structure for a given change to the
	  // document. From and to are in pre-change coordinates. Lendiff is
	  // the amount of lines added or subtracted by the change. This is
	  // used for changes that span multiple lines, or change the way
	  // lines are divided into visual lines. regLineChange (below)
	  // registers single-line changes.
	  function regChange(cm, from, to, lendiff) {
	    if (from == null) {
	      from = cm.doc.first;
	    }
	    if (to == null) {
	      to = cm.doc.first + cm.doc.size;
	    }
	    if (!lendiff) {
	      lendiff = 0;
	    }
	
	    var display = cm.display;
	    if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) {
	      display.updateLineNumbers = from;
	    }
	
	    cm.curOp.viewChanged = true;
	
	    if (from >= display.viewTo) {
	      // Change after
	      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) {
	        resetView(cm);
	      }
	    } else if (to <= display.viewFrom) {
	      // Change before
	      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	        resetView(cm);
	      } else {
	        display.viewFrom += lendiff;
	        display.viewTo += lendiff;
	      }
	    } else if (from <= display.viewFrom && to >= display.viewTo) {
	      // Full overlap
	      resetView(cm);
	    } else if (from <= display.viewFrom) {
	      // Top overlap
	      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cut) {
	        display.view = display.view.slice(cut.index);
	        display.viewFrom = cut.lineN;
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    } else if (to >= display.viewTo) {
	      // Bottom overlap
	      var cut$1 = viewCuttingPoint(cm, from, from, -1);
	      if (cut$1) {
	        display.view = display.view.slice(0, cut$1.index);
	        display.viewTo = cut$1.lineN;
	      } else {
	        resetView(cm);
	      }
	    } else {
	      // Gap in the middle
	      var cutTop = viewCuttingPoint(cm, from, from, -1);
	      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cutTop && cutBot) {
	        display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    }
	
	    var ext = display.externalMeasured;
	    if (ext) {
	      if (to < ext.lineN) {
	        ext.lineN += lendiff;
	      } else if (from < ext.lineN + ext.size) {
	        display.externalMeasured = null;
	      }
	    }
	  }
	
	  // Register a change to a single line. Type must be one of "text",
	  // "gutter", "class", "widget"
	  function regLineChange(cm, line, type) {
	    cm.curOp.viewChanged = true;
	    var display = cm.display,
	        ext = cm.display.externalMeasured;
	    if (ext && line >= ext.lineN && line < ext.lineN + ext.size) {
	      display.externalMeasured = null;
	    }
	
	    if (line < display.viewFrom || line >= display.viewTo) {
	      return;
	    }
	    var lineView = display.view[findViewIndex(cm, line)];
	    if (lineView.node == null) {
	      return;
	    }
	    var arr = lineView.changes || (lineView.changes = []);
	    if (indexOf(arr, type) == -1) {
	      arr.push(type);
	    }
	  }
	
	  // Clear the view.
	  function resetView(cm) {
	    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
	    cm.display.view = [];
	    cm.display.viewOffset = 0;
	  }
	
	  function viewCuttingPoint(cm, oldN, newN, dir) {
	    var index = findViewIndex(cm, oldN),
	        diff,
	        view = cm.display.view;
	    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) {
	      return { index: index, lineN: newN };
	    }
	    var n = cm.display.viewFrom;
	    for (var i = 0; i < index; i++) {
	      n += view[i].size;
	    }
	    if (n != oldN) {
	      if (dir > 0) {
	        if (index == view.length - 1) {
	          return null;
	        }
	        diff = n + view[index].size - oldN;
	        index++;
	      } else {
	        diff = n - oldN;
	      }
	      oldN += diff;newN += diff;
	    }
	    while (visualLineNo(cm.doc, newN) != newN) {
	      if (index == (dir < 0 ? 0 : view.length - 1)) {
	        return null;
	      }
	      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
	      index += dir;
	    }
	    return { index: index, lineN: newN };
	  }
	
	  // Force the view to cover a given range, adding empty view element
	  // or clipping off existing ones as needed.
	  function adjustView(cm, from, to) {
	    var display = cm.display,
	        view = display.view;
	    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	      display.view = buildViewArray(cm, from, to);
	      display.viewFrom = from;
	    } else {
	      if (display.viewFrom > from) {
	        display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
	      } else if (display.viewFrom < from) {
	        display.view = display.view.slice(findViewIndex(cm, from));
	      }
	      display.viewFrom = from;
	      if (display.viewTo < to) {
	        display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
	      } else if (display.viewTo > to) {
	        display.view = display.view.slice(0, findViewIndex(cm, to));
	      }
	    }
	    display.viewTo = to;
	  }
	
	  // Count the number of lines in the view whose DOM representation is
	  // out of date (or nonexistent).
	  function countDirtyView(cm) {
	    var view = cm.display.view,
	        dirty = 0;
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (!lineView.hidden && (!lineView.node || lineView.changes)) {
	        ++dirty;
	      }
	    }
	    return dirty;
	  }
	
	  function updateSelection(cm) {
	    cm.display.input.showSelection(cm.display.input.prepareSelection());
	  }
	
	  function prepareSelection(cm, primary) {
	    if (primary === void 0) primary = true;
	
	    var doc = cm.doc,
	        result = {};
	    var curFragment = result.cursors = document.createDocumentFragment();
	    var selFragment = result.selection = document.createDocumentFragment();
	
	    var customCursor = cm.options.$customCursor;
	    if (customCursor) {
	      primary = true;
	    }
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      if (!primary && i == doc.sel.primIndex) {
	        continue;
	      }
	      var range = doc.sel.ranges[i];
	      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) {
	        continue;
	      }
	      var collapsed = range.empty();
	      if (customCursor) {
	        var head = customCursor(cm, range);
	        if (head) {
	          drawSelectionCursor(cm, head, curFragment);
	        }
	      } else if (collapsed || cm.options.showCursorWhenSelecting) {
	        drawSelectionCursor(cm, range.head, curFragment);
	      }
	      if (!collapsed) {
	        drawSelectionRange(cm, range, selFragment);
	      }
	    }
	    return result;
	  }
	
	  // Draws a cursor for the given range
	  function drawSelectionCursor(cm, head, output) {
	    var pos = _cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
	
	    var cursor = output.appendChild(elt("div", '\xA0', "CodeMirror-cursor"));
	    cursor.style.left = pos.left + "px";
	    cursor.style.top = pos.top + "px";
	    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
	
	    if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
	      var charPos = _charCoords(cm, head, "div", null, null);
	      var width = charPos.right - charPos.left;
	      cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
	    }
	
	    if (pos.other) {
	      // Secondary cursor, shown when on a 'jump' in bi-directional text
	      var otherCursor = output.appendChild(elt("div", '\xA0', "CodeMirror-cursor CodeMirror-secondarycursor"));
	      otherCursor.style.display = "";
	      otherCursor.style.left = pos.other.left + "px";
	      otherCursor.style.top = pos.other.top + "px";
	      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
	    }
	  }
	
	  function cmpCoords(a, b) {
	    return a.top - b.top || a.left - b.left;
	  }
	
	  // Draws the given range as a highlighted selection
	  function drawSelectionRange(cm, range, output) {
	    var display = cm.display,
	        doc = cm.doc;
	    var fragment = document.createDocumentFragment();
	    var padding = paddingH(cm.display),
	        leftSide = padding.left;
	    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
	    var docLTR = doc.direction == "ltr";
	
	    function add(left, top, width, bottom) {
	      if (top < 0) {
	        top = 0;
	      }
	      top = Math.round(top);
	      bottom = Math.round(bottom);
	      fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
	    }
	
	    function drawForLine(line, fromArg, toArg) {
	      var lineObj = getLine(doc, line);
	      var lineLen = lineObj.text.length;
	      var start, end;
	      function coords(ch, bias) {
	        return _charCoords(cm, Pos(line, ch), "div", lineObj, bias);
	      }
	
	      function wrapX(pos, dir, side) {
	        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
	        var prop = dir == "ltr" == (side == "after") ? "left" : "right";
	        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
	        return coords(ch, prop)[prop];
	      }
	
	      var order = getOrder(lineObj, doc.direction);
	      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
	        var ltr = dir == "ltr";
	        var fromPos = coords(from, ltr ? "left" : "right");
	        var toPos = coords(to - 1, ltr ? "right" : "left");
	
	        var openStart = fromArg == null && from == 0,
	            openEnd = toArg == null && to == lineLen;
	        var first = i == 0,
	            last = !order || i == order.length - 1;
	        if (toPos.top - fromPos.top <= 3) {
	          // Single line
	          var openLeft = (docLTR ? openStart : openEnd) && first;
	          var openRight = (docLTR ? openEnd : openStart) && last;
	          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
	          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
	          add(left, fromPos.top, right - left, fromPos.bottom);
	        } else {
	          // Multiple lines
	          var topLeft, topRight, botLeft, botRight;
	          if (ltr) {
	            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
	            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
	            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
	            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
	          } else {
	            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
	            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
	            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
	            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
	          }
	          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
	          if (fromPos.bottom < toPos.top) {
	            add(leftSide, fromPos.bottom, null, toPos.top);
	          }
	          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
	        }
	
	        if (!start || cmpCoords(fromPos, start) < 0) {
	          start = fromPos;
	        }
	        if (cmpCoords(toPos, start) < 0) {
	          start = toPos;
	        }
	        if (!end || cmpCoords(fromPos, end) < 0) {
	          end = fromPos;
	        }
	        if (cmpCoords(toPos, end) < 0) {
	          end = toPos;
	        }
	      });
	      return { start: start, end: end };
	    }
	
	    var sFrom = range.from(),
	        sTo = range.to();
	    if (sFrom.line == sTo.line) {
	      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
	    } else {
	      var fromLine = getLine(doc, sFrom.line),
	          toLine = getLine(doc, sTo.line);
	      var singleVLine = visualLine(fromLine) == visualLine(toLine);
	      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
	      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
	      if (singleVLine) {
	        if (leftEnd.top < rightStart.top - 2) {
	          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
	          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
	        } else {
	          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
	        }
	      }
	      if (leftEnd.bottom < rightStart.top) {
	        add(leftSide, leftEnd.bottom, null, rightStart.top);
	      }
	    }
	
	    output.appendChild(fragment);
	  }
	
	  // Cursor-blinking
	  function restartBlink(cm) {
	    if (!cm.state.focused) {
	      return;
	    }
	    var display = cm.display;
	    clearInterval(display.blinker);
	    var on = true;
	    display.cursorDiv.style.visibility = "";
	    if (cm.options.cursorBlinkRate > 0) {
	      display.blinker = setInterval(function () {
	        if (!cm.hasFocus()) {
	          onBlur(cm);
	        }
	        display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
	      }, cm.options.cursorBlinkRate);
	    } else if (cm.options.cursorBlinkRate < 0) {
	      display.cursorDiv.style.visibility = "hidden";
	    }
	  }
	
	  function ensureFocus(cm) {
	    if (!cm.hasFocus()) {
	      cm.display.input.focus();
	      if (!cm.state.focused) {
	        onFocus(cm);
	      }
	    }
	  }
	
	  function delayBlurEvent(cm) {
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () {
	      if (cm.state.delayingBlurEvent) {
	        cm.state.delayingBlurEvent = false;
	        if (cm.state.focused) {
	          onBlur(cm);
	        }
	      }
	    }, 100);
	  }
	
	  function onFocus(cm, e) {
	    if (cm.state.delayingBlurEvent && !cm.state.draggingText) {
	      cm.state.delayingBlurEvent = false;
	    }
	
	    if (cm.options.readOnly == "nocursor") {
	      return;
	    }
	    if (!cm.state.focused) {
	      signal(cm, "focus", cm, e);
	      cm.state.focused = true;
	      addClass(cm.display.wrapper, "CodeMirror-focused");
	      // This test prevents this from firing when a context
	      // menu is closed (since the input reset would kill the
	      // select-all detection hack)
	      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	        cm.display.input.reset();
	        if (webkit) {
	          setTimeout(function () {
	            return cm.display.input.reset(true);
	          }, 20);
	        } // Issue #1730
	      }
	      cm.display.input.receivedFocus();
	    }
	    restartBlink(cm);
	  }
	  function onBlur(cm, e) {
	    if (cm.state.delayingBlurEvent) {
	      return;
	    }
	
	    if (cm.state.focused) {
	      signal(cm, "blur", cm, e);
	      cm.state.focused = false;
	      rmClass(cm.display.wrapper, "CodeMirror-focused");
	    }
	    clearInterval(cm.display.blinker);
	    setTimeout(function () {
	      if (!cm.state.focused) {
	        cm.display.shift = false;
	      }
	    }, 150);
	  }
	
	  // Read the actual heights of the rendered lines, and update their
	  // stored heights to match.
	  function updateHeightsInViewport(cm) {
	    var display = cm.display;
	    var prevBottom = display.lineDiv.offsetTop;
	    var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
	    var oldHeight = display.lineDiv.getBoundingClientRect().top;
	    var mustScroll = 0;
	    for (var i = 0; i < display.view.length; i++) {
	      var cur = display.view[i],
	          wrapping = cm.options.lineWrapping;
	      var height = void 0,
	          width = 0;
	      if (cur.hidden) {
	        continue;
	      }
	      oldHeight += cur.line.height;
	      if (ie && ie_version < 8) {
	        var bot = cur.node.offsetTop + cur.node.offsetHeight;
	        height = bot - prevBottom;
	        prevBottom = bot;
	      } else {
	        var box = cur.node.getBoundingClientRect();
	        height = box.bottom - box.top;
	        // Check that lines don't extend past the right of the current
	        // editor width
	        if (!wrapping && cur.text.firstChild) {
	          width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
	        }
	      }
	      var diff = cur.line.height - height;
	      if (diff > .005 || diff < -.005) {
	        if (oldHeight < viewTop) {
	          mustScroll -= diff;
	        }
	        updateLineHeight(cur.line, height);
	        updateWidgetHeight(cur.line);
	        if (cur.rest) {
	          for (var j = 0; j < cur.rest.length; j++) {
	            updateWidgetHeight(cur.rest[j]);
	          }
	        }
	      }
	      if (width > cm.display.sizerWidth) {
	        var chWidth = Math.ceil(width / charWidth(cm.display));
	        if (chWidth > cm.display.maxLineLength) {
	          cm.display.maxLineLength = chWidth;
	          cm.display.maxLine = cur.line;
	          cm.display.maxLineChanged = true;
	        }
	      }
	    }
	    if (Math.abs(mustScroll) > 2) {
	      display.scroller.scrollTop += mustScroll;
	    }
	  }
	
	  // Read and store the height of line widgets associated with the
	  // given line.
	  function updateWidgetHeight(line) {
	    if (line.widgets) {
	      for (var i = 0; i < line.widgets.length; ++i) {
	        var w = line.widgets[i],
	            parent = w.node.parentNode;
	        if (parent) {
	          w.height = parent.offsetHeight;
	        }
	      }
	    }
	  }
	
	  // Compute the lines that are visible in a given viewport (defaults
	  // the current scroll position). viewport may contain top,
	  // height, and ensure (see op.scrollToPos) properties.
	  function visibleLines(display, doc, viewport) {
	    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
	    top = Math.floor(top - paddingTop(display));
	    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
	
	    var from = _lineAtHeight(doc, top),
	        to = _lineAtHeight(doc, bottom);
	    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	    // forces those lines into the viewport (if possible).
	    if (viewport && viewport.ensure) {
	      var ensureFrom = viewport.ensure.from.line,
	          ensureTo = viewport.ensure.to.line;
	      if (ensureFrom < from) {
	        from = ensureFrom;
	        to = _lineAtHeight(doc, _heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
	      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	        from = _lineAtHeight(doc, _heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
	        to = ensureTo;
	      }
	    }
	    return { from: from, to: Math.max(to, from + 1) };
	  }
	
	  // SCROLLING THINGS INTO VIEW
	
	  // If an editor sits on the top or bottom of the window, partially
	  // scrolled out of view, this ensures that the cursor is visible.
	  function maybeScrollWindow(cm, rect) {
	    if (signalDOMEvent(cm, "scrollCursorIntoView")) {
	      return;
	    }
	
	    var display = cm.display,
	        box = display.sizer.getBoundingClientRect(),
	        doScroll = null;
	    var doc = display.wrapper.ownerDocument;
	    if (rect.top + box.top < 0) {
	      doScroll = true;
	    } else if (rect.bottom + box.top > (doc.defaultView.innerHeight || doc.documentElement.clientHeight)) {
	      doScroll = false;
	    }
	    if (doScroll != null && !phantom) {
	      var scrollNode = elt("div", '\u200B', null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
	      cm.display.lineSpace.appendChild(scrollNode);
	      scrollNode.scrollIntoView(doScroll);
	      cm.display.lineSpace.removeChild(scrollNode);
	    }
	  }
	
	  // Scroll a given position into view (immediately), verifying that
	  // it actually became visible (as line heights are accurately
	  // measured, the position of something may 'drift' during drawing).
	  function scrollPosIntoView(cm, pos, end, margin) {
	    if (margin == null) {
	      margin = 0;
	    }
	    var rect;
	    if (!cm.options.lineWrapping && pos == end) {
	      // Set pos and end to the cursor positions around the character pos sticks to
	      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
	      // If pos == Pos(_, 0, "before"), pos and end are unchanged
	      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
	      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
	    }
	    for (var limit = 0; limit < 5; limit++) {
	      var changed = false;
	      var coords = _cursorCoords(cm, pos);
	      var endCoords = !end || end == pos ? coords : _cursorCoords(cm, end);
	      rect = { left: Math.min(coords.left, endCoords.left),
	        top: Math.min(coords.top, endCoords.top) - margin,
	        right: Math.max(coords.left, endCoords.left),
	        bottom: Math.max(coords.bottom, endCoords.bottom) + margin };
	      var scrollPos = calculateScrollPos(cm, rect);
	      var startTop = cm.doc.scrollTop,
	          startLeft = cm.doc.scrollLeft;
	      if (scrollPos.scrollTop != null) {
	        updateScrollTop(cm, scrollPos.scrollTop);
	        if (Math.abs(cm.doc.scrollTop - startTop) > 1) {
	          changed = true;
	        }
	      }
	      if (scrollPos.scrollLeft != null) {
	        setScrollLeft(cm, scrollPos.scrollLeft);
	        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) {
	          changed = true;
	        }
	      }
	      if (!changed) {
	        break;
	      }
	    }
	    return rect;
	  }
	
	  // Scroll a given set of coordinates into view (immediately).
	  function scrollIntoView(cm, rect) {
	    var scrollPos = calculateScrollPos(cm, rect);
	    if (scrollPos.scrollTop != null) {
	      updateScrollTop(cm, scrollPos.scrollTop);
	    }
	    if (scrollPos.scrollLeft != null) {
	      setScrollLeft(cm, scrollPos.scrollLeft);
	    }
	  }
	
	  // Calculate a new scroll position needed to scroll the given
	  // rectangle into view. Returns an object with scrollTop and
	  // scrollLeft properties. When these are undefined, the
	  // vertical/horizontal position does not need to be adjusted.
	  function calculateScrollPos(cm, rect) {
	    var display = cm.display,
	        snapMargin = textHeight(cm.display);
	    if (rect.top < 0) {
	      rect.top = 0;
	    }
	    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
	    var screen = displayHeight(cm),
	        result = {};
	    if (rect.bottom - rect.top > screen) {
	      rect.bottom = rect.top + screen;
	    }
	    var docBottom = cm.doc.height + paddingVert(display);
	    var atTop = rect.top < snapMargin,
	        atBottom = rect.bottom > docBottom - snapMargin;
	    if (rect.top < screentop) {
	      result.scrollTop = atTop ? 0 : rect.top;
	    } else if (rect.bottom > screentop + screen) {
	      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
	      if (newTop != screentop) {
	        result.scrollTop = newTop;
	      }
	    }
	
	    var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
	    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
	    var screenw = displayWidth(cm) - display.gutters.offsetWidth;
	    var tooWide = rect.right - rect.left > screenw;
	    if (tooWide) {
	      rect.right = rect.left + screenw;
	    }
	    if (rect.left < 10) {
	      result.scrollLeft = 0;
	    } else if (rect.left < screenleft) {
	      result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10));
	    } else if (rect.right > screenw + screenleft - 3) {
	      result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
	    }
	    return result;
	  }
	
	  // Store a relative adjustment to the scroll position in the current
	  // operation (to be applied when the operation finishes).
	  function addToScrollTop(cm, top) {
	    if (top == null) {
	      return;
	    }
	    resolveScrollToPos(cm);
	    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
	  }
	
	  // Make sure that at the end of the operation the current cursor is
	  // shown.
	  function ensureCursorVisible(cm) {
	    resolveScrollToPos(cm);
	    var cur = cm.getCursor();
	    cm.curOp.scrollToPos = { from: cur, to: cur, margin: cm.options.cursorScrollMargin };
	  }
	
	  function scrollToCoords(cm, x, y) {
	    if (x != null || y != null) {
	      resolveScrollToPos(cm);
	    }
	    if (x != null) {
	      cm.curOp.scrollLeft = x;
	    }
	    if (y != null) {
	      cm.curOp.scrollTop = y;
	    }
	  }
	
	  function scrollToRange(cm, range) {
	    resolveScrollToPos(cm);
	    cm.curOp.scrollToPos = range;
	  }
	
	  // When an operation has its scrollToPos property set, and another
	  // scroll action is applied before the end of the operation, this
	  // 'simulates' scrolling that position into view in a cheap way, so
	  // that the effect of intermediate scroll commands is not ignored.
	  function resolveScrollToPos(cm) {
	    var range = cm.curOp.scrollToPos;
	    if (range) {
	      cm.curOp.scrollToPos = null;
	      var from = estimateCoords(cm, range.from),
	          to = estimateCoords(cm, range.to);
	      scrollToCoordsRange(cm, from, to, range.margin);
	    }
	  }
	
	  function scrollToCoordsRange(cm, from, to, margin) {
	    var sPos = calculateScrollPos(cm, {
	      left: Math.min(from.left, to.left),
	      top: Math.min(from.top, to.top) - margin,
	      right: Math.max(from.right, to.right),
	      bottom: Math.max(from.bottom, to.bottom) + margin
	    });
	    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
	  }
	
	  // Sync the scrollable area and scrollbars, ensure the viewport
	  // covers the visible area.
	  function updateScrollTop(cm, val) {
	    if (Math.abs(cm.doc.scrollTop - val) < 2) {
	      return;
	    }
	    if (!gecko) {
	      updateDisplaySimple(cm, { top: val });
	    }
	    setScrollTop(cm, val, true);
	    if (gecko) {
	      updateDisplaySimple(cm);
	    }
	    startWorker(cm, 100);
	  }
	
	  function setScrollTop(cm, val, forceScroll) {
	    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
	    if (cm.display.scroller.scrollTop == val && !forceScroll) {
	      return;
	    }
	    cm.doc.scrollTop = val;
	    cm.display.scrollbars.setScrollTop(val);
	    if (cm.display.scroller.scrollTop != val) {
	      cm.display.scroller.scrollTop = val;
	    }
	  }
	
	  // Sync scroller and scrollbar, ensure the gutter elements are
	  // aligned.
	  function setScrollLeft(cm, val, isScroller, forceScroll) {
	    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
	    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) {
	      return;
	    }
	    cm.doc.scrollLeft = val;
	    alignHorizontally(cm);
	    if (cm.display.scroller.scrollLeft != val) {
	      cm.display.scroller.scrollLeft = val;
	    }
	    cm.display.scrollbars.setScrollLeft(val);
	  }
	
	  // SCROLLBARS
	
	  // Prepare DOM reads needed to update the scrollbars. Done in one
	  // shot to minimize update/measure roundtrips.
	  function measureForScrollbars(cm) {
	    var d = cm.display,
	        gutterW = d.gutters.offsetWidth;
	    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
	    return {
	      clientHeight: d.scroller.clientHeight,
	      viewHeight: d.wrapper.clientHeight,
	      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	      viewWidth: d.wrapper.clientWidth,
	      barLeft: cm.options.fixedGutter ? gutterW : 0,
	      docHeight: docH,
	      scrollHeight: docH + scrollGap(cm) + d.barHeight,
	      nativeBarWidth: d.nativeBarWidth,
	      gutterWidth: gutterW
	    };
	  }
	
	  var NativeScrollbars = function NativeScrollbars(place, scroll, cm) {
	    this.cm = cm;
	    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
	    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
	    vert.tabIndex = horiz.tabIndex = -1;
	    place(vert);place(horiz);
	
	    on(vert, "scroll", function () {
	      if (vert.clientHeight) {
	        scroll(vert.scrollTop, "vertical");
	      }
	    });
	    on(horiz, "scroll", function () {
	      if (horiz.clientWidth) {
	        scroll(horiz.scrollLeft, "horizontal");
	      }
	    });
	
	    this.checkedZeroWidth = false;
	    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	    if (ie && ie_version < 8) {
	      this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
	    }
	  };
	
	  NativeScrollbars.prototype.update = function (measure) {
	    var needsH = measure.scrollWidth > measure.clientWidth + 1;
	    var needsV = measure.scrollHeight > measure.clientHeight + 1;
	    var sWidth = measure.nativeBarWidth;
	
	    if (needsV) {
	      this.vert.style.display = "block";
	      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
	      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
	      // A bug in IE8 can cause this value to be negative, so guard it.
	      this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
	    } else {
	      this.vert.scrollTop = 0;
	      this.vert.style.display = "";
	      this.vert.firstChild.style.height = "0";
	    }
	
	    if (needsH) {
	      this.horiz.style.display = "block";
	      this.horiz.style.right = needsV ? sWidth + "px" : "0";
	      this.horiz.style.left = measure.barLeft + "px";
	      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
	      this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
	    } else {
	      this.horiz.style.display = "";
	      this.horiz.firstChild.style.width = "0";
	    }
	
	    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	      if (sWidth == 0) {
	        this.zeroWidthHack();
	      }
	      this.checkedZeroWidth = true;
	    }
	
	    return { right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0 };
	  };
	
	  NativeScrollbars.prototype.setScrollLeft = function (pos) {
	    if (this.horiz.scrollLeft != pos) {
	      this.horiz.scrollLeft = pos;
	    }
	    if (this.disableHoriz) {
	      this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
	    }
	  };
	
	  NativeScrollbars.prototype.setScrollTop = function (pos) {
	    if (this.vert.scrollTop != pos) {
	      this.vert.scrollTop = pos;
	    }
	    if (this.disableVert) {
	      this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
	    }
	  };
	
	  NativeScrollbars.prototype.zeroWidthHack = function () {
	    var w = mac && !mac_geMountainLion ? "12px" : "18px";
	    this.horiz.style.height = this.vert.style.width = w;
	    this.horiz.style.visibility = this.vert.style.visibility = "hidden";
	    this.disableHoriz = new Delayed();
	    this.disableVert = new Delayed();
	  };
	
	  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
	    bar.style.visibility = "";
	    function maybeDisable() {
	      // To find out whether the scrollbar is still visible, we
	      // check whether the element under the pixel in the bottom
	      // right corner of the scrollbar box is the scrollbar box
	      // itself (when the bar is still visible) or its filler child
	      // (when the bar is hidden). If it is still visible, we keep
	      // it enabled, if it's hidden, we disable pointer events.
	      var box = bar.getBoundingClientRect();
	      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
	      if (elt != bar) {
	        bar.style.visibility = "hidden";
	      } else {
	        delay.set(1000, maybeDisable);
	      }
	    }
	    delay.set(1000, maybeDisable);
	  };
	
	  NativeScrollbars.prototype.clear = function () {
	    var parent = this.horiz.parentNode;
	    parent.removeChild(this.horiz);
	    parent.removeChild(this.vert);
	  };
	
	  var NullScrollbars = function NullScrollbars() {};
	
	  NullScrollbars.prototype.update = function () {
	    return { bottom: 0, right: 0 };
	  };
	  NullScrollbars.prototype.setScrollLeft = function () {};
	  NullScrollbars.prototype.setScrollTop = function () {};
	  NullScrollbars.prototype.clear = function () {};
	
	  function updateScrollbars(cm, measure) {
	    if (!measure) {
	      measure = measureForScrollbars(cm);
	    }
	    var startWidth = cm.display.barWidth,
	        startHeight = cm.display.barHeight;
	    updateScrollbarsInner(cm, measure);
	    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	      if (startWidth != cm.display.barWidth && cm.options.lineWrapping) {
	        updateHeightsInViewport(cm);
	      }
	      updateScrollbarsInner(cm, measureForScrollbars(cm));
	      startWidth = cm.display.barWidth;startHeight = cm.display.barHeight;
	    }
	  }
	
	  // Re-synchronize the fake scrollbars with the actual size of the
	  // content.
	  function updateScrollbarsInner(cm, measure) {
	    var d = cm.display;
	    var sizes = d.scrollbars.update(measure);
	
	    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
	    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
	    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
	
	    if (sizes.right && sizes.bottom) {
	      d.scrollbarFiller.style.display = "block";
	      d.scrollbarFiller.style.height = sizes.bottom + "px";
	      d.scrollbarFiller.style.width = sizes.right + "px";
	    } else {
	      d.scrollbarFiller.style.display = "";
	    }
	    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	      d.gutterFiller.style.display = "block";
	      d.gutterFiller.style.height = sizes.bottom + "px";
	      d.gutterFiller.style.width = measure.gutterWidth + "px";
	    } else {
	      d.gutterFiller.style.display = "";
	    }
	  }
	
	  var scrollbarModel = { "native": NativeScrollbars, "null": NullScrollbars };
	
	  function initScrollbars(cm) {
	    if (cm.display.scrollbars) {
	      cm.display.scrollbars.clear();
	      if (cm.display.scrollbars.addClass) {
	        rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
	      }
	    }
	
	    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
	      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
	      // Prevent clicks in the scrollbars from killing focus
	      on(node, "mousedown", function () {
	        if (cm.state.focused) {
	          setTimeout(function () {
	            return cm.display.input.focus();
	          }, 0);
	        }
	      });
	      node.setAttribute("cm-not-content", "true");
	    }, function (pos, axis) {
	      if (axis == "horizontal") {
	        setScrollLeft(cm, pos);
	      } else {
	        updateScrollTop(cm, pos);
	      }
	    }, cm);
	    if (cm.display.scrollbars.addClass) {
	      addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
	    }
	  }
	
	  // Operations are used to wrap a series of changes to the editor
	  // state in such a way that each change won't have to update the
	  // cursor and display (which would be awkward, slow, and
	  // error-prone). Instead, display updates are batched and then all
	  // combined and executed at once.
	
	  var nextOpId = 0;
	  // Start a new operation.
	  function _startOperation(cm) {
	    cm.curOp = {
	      cm: cm,
	      viewChanged: false, // Flag that indicates that lines might need to be redrawn
	      startHeight: cm.doc.height, // Used to detect need to update scrollbar
	      forceUpdate: false, // Used to force a redraw
	      updateInput: 0, // Whether to reset the input textarea
	      typing: false, // Whether this reset should be careful to leave existing text (for compositing)
	      changeObjs: null, // Accumulated changes, for firing change events
	      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	      selectionChanged: false, // Whether the selection needs to be redrawn
	      updateMaxLine: false, // Set when the widest line needs to be determined anew
	      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	      scrollToPos: null, // Used to scroll to a specific position
	      focus: false,
	      id: ++nextOpId, // Unique ID
	      markArrays: null // Used by addMarkedSpan
	    };
	    pushOperation(cm.curOp);
	  }
	
	  // Finish an operation, updating the display and signalling delayed events
	  function _endOperation(cm) {
	    var op = cm.curOp;
	    if (op) {
	      finishOperation(op, function (group) {
	        for (var i = 0; i < group.ops.length; i++) {
	          group.ops[i].cm.curOp = null;
	        }
	        endOperations(group);
	      });
	    }
	  }
	
	  // The DOM updates done when an operation finishes are batched so
	  // that the minimum number of relayouts are required.
	  function endOperations(group) {
	    var ops = group.ops;
	    for (var i = 0; i < ops.length; i++) // Read DOM
	    {
	      endOperation_R1(ops[i]);
	    }
	    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
	    {
	      endOperation_W1(ops[i$1]);
	    }
	    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
	    {
	      endOperation_R2(ops[i$2]);
	    }
	    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
	    {
	      endOperation_W2(ops[i$3]);
	    }
	    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
	    {
	      endOperation_finish(ops[i$4]);
	    }
	  }
	
	  function endOperation_R1(op) {
	    var cm = op.cm,
	        display = cm.display;
	    maybeClipScrollbars(cm);
	    if (op.updateMaxLine) {
	      findMaxLine(cm);
	    }
	
	    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
	    op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && { top: op.scrollTop, ensure: op.scrollToPos }, op.forceUpdate);
	  }
	
	  function endOperation_W1(op) {
	    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
	  }
	
	  function endOperation_R2(op) {
	    var cm = op.cm,
	        display = cm.display;
	    if (op.updatedDisplay) {
	      updateHeightsInViewport(cm);
	    }
	
	    op.barMeasure = measureForScrollbars(cm);
	
	    // If the max line changed since it was last measured, measure it,
	    // and ensure the document's width matches it.
	    // updateDisplay_W2 will use these properties to do the actual resizing
	    if (display.maxLineChanged && !cm.options.lineWrapping) {
	      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
	      cm.display.sizerWidth = op.adjustWidthTo;
	      op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
	      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
	    }
	
	    if (op.updatedDisplay || op.selectionChanged) {
	      op.preparedSelection = display.input.prepareSelection();
	    }
	  }
	
	  function endOperation_W2(op) {
	    var cm = op.cm;
	
	    if (op.adjustWidthTo != null) {
	      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
	      if (op.maxScrollLeft < cm.doc.scrollLeft) {
	        setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
	      }
	      cm.display.maxLineChanged = false;
	    }
	
	    var takeFocus = op.focus && op.focus == activeElt(root(cm));
	    if (op.preparedSelection) {
	      cm.display.input.showSelection(op.preparedSelection, takeFocus);
	    }
	    if (op.updatedDisplay || op.startHeight != cm.doc.height) {
	      updateScrollbars(cm, op.barMeasure);
	    }
	    if (op.updatedDisplay) {
	      setDocumentHeight(cm, op.barMeasure);
	    }
	
	    if (op.selectionChanged) {
	      restartBlink(cm);
	    }
	
	    if (cm.state.focused && op.updateInput) {
	      cm.display.input.reset(op.typing);
	    }
	    if (takeFocus) {
	      ensureFocus(op.cm);
	    }
	  }
	
	  function endOperation_finish(op) {
	    var cm = op.cm,
	        display = cm.display,
	        doc = cm.doc;
	
	    if (op.updatedDisplay) {
	      postUpdateDisplay(cm, op.update);
	    }
	
	    // Abort mouse wheel delta measurement, when scrolling explicitly
	    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) {
	      display.wheelStartX = display.wheelStartY = null;
	    }
	
	    // Propagate the scroll position to the actual DOM scroller
	    if (op.scrollTop != null) {
	      setScrollTop(cm, op.scrollTop, op.forceScroll);
	    }
	
	    if (op.scrollLeft != null) {
	      setScrollLeft(cm, op.scrollLeft, true, true);
	    }
	    // If we need to scroll a specific position into view, do so.
	    if (op.scrollToPos) {
	      var rect = scrollPosIntoView(cm, _clipPos(doc, op.scrollToPos.from), _clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
	      maybeScrollWindow(cm, rect);
	    }
	
	    // Fire events for markers that are hidden/unidden by editing or
	    // undoing
	    var hidden = op.maybeHiddenMarkers,
	        unhidden = op.maybeUnhiddenMarkers;
	    if (hidden) {
	      for (var i = 0; i < hidden.length; ++i) {
	        if (!hidden[i].lines.length) {
	          signal(hidden[i], "hide");
	        }
	      }
	    }
	    if (unhidden) {
	      for (var i$1 = 0; i$1 < unhidden.length; ++i$1) {
	        if (unhidden[i$1].lines.length) {
	          signal(unhidden[i$1], "unhide");
	        }
	      }
	    }
	
	    if (display.wrapper.offsetHeight) {
	      doc.scrollTop = cm.display.scroller.scrollTop;
	    }
	
	    // Fire change events, and delayed event handlers
	    if (op.changeObjs) {
	      signal(cm, "changes", cm, op.changeObjs);
	    }
	    if (op.update) {
	      op.update.finish();
	    }
	  }
	
	  // Run the given function in an operation
	  function runInOp(cm, f) {
	    if (cm.curOp) {
	      return f();
	    }
	    _startOperation(cm);
	    try {
	      return f();
	    } finally {
	      _endOperation(cm);
	    }
	  }
	  // Wraps a function in an operation. Returns the wrapped function.
	  function operation(cm, f) {
	    return function () {
	      if (cm.curOp) {
	        return f.apply(cm, arguments);
	      }
	      _startOperation(cm);
	      try {
	        return f.apply(cm, arguments);
	      } finally {
	        _endOperation(cm);
	      }
	    };
	  }
	  // Used to add methods to editor and doc instances, wrapping them in
	  // operations.
	  function methodOp(f) {
	    return function () {
	      if (this.curOp) {
	        return f.apply(this, arguments);
	      }
	      _startOperation(this);
	      try {
	        return f.apply(this, arguments);
	      } finally {
	        _endOperation(this);
	      }
	    };
	  }
	  function docMethodOp(f) {
	    return function () {
	      var cm = this.cm;
	      if (!cm || cm.curOp) {
	        return f.apply(this, arguments);
	      }
	      _startOperation(cm);
	      try {
	        return f.apply(this, arguments);
	      } finally {
	        _endOperation(cm);
	      }
	    };
	  }
	
	  // HIGHLIGHT WORKER
	
	  function startWorker(cm, time) {
	    if (cm.doc.highlightFrontier < cm.display.viewTo) {
	      cm.state.highlight.set(time, bind(highlightWorker, cm));
	    }
	  }
	
	  function highlightWorker(cm) {
	    var doc = cm.doc;
	    if (doc.highlightFrontier >= cm.display.viewTo) {
	      return;
	    }
	    var end = +new Date() + cm.options.workTime;
	    var context = getContextBefore(cm, doc.highlightFrontier);
	    var changedLines = [];
	
	    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
	      if (context.line >= cm.display.viewFrom) {
	        // Visible
	        var oldStyles = line.styles;
	        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
	        var highlighted = highlightLine(cm, line, context, true);
	        if (resetState) {
	          context.state = resetState;
	        }
	        line.styles = highlighted.styles;
	        var oldCls = line.styleClasses,
	            newCls = highlighted.classes;
	        if (newCls) {
	          line.styleClasses = newCls;
	        } else if (oldCls) {
	          line.styleClasses = null;
	        }
	        var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
	        for (var i = 0; !ischange && i < oldStyles.length; ++i) {
	          ischange = oldStyles[i] != line.styles[i];
	        }
	        if (ischange) {
	          changedLines.push(context.line);
	        }
	        line.stateAfter = context.save();
	        context.nextLine();
	      } else {
	        if (line.text.length <= cm.options.maxHighlightLength) {
	          processLine(cm, line.text, context);
	        }
	        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
	        context.nextLine();
	      }
	      if (+new Date() > end) {
	        startWorker(cm, cm.options.workDelay);
	        return true;
	      }
	    });
	    doc.highlightFrontier = context.line;
	    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
	    if (changedLines.length) {
	      runInOp(cm, function () {
	        for (var i = 0; i < changedLines.length; i++) {
	          regLineChange(cm, changedLines[i], "text");
	        }
	      });
	    }
	  }
	
	  // DISPLAY DRAWING
	
	  var DisplayUpdate = function DisplayUpdate(cm, viewport, force) {
	    var display = cm.display;
	
	    this.viewport = viewport;
	    // Store some values that we'll need later (but don't want to force a relayout for)
	    this.visible = visibleLines(display, cm.doc, viewport);
	    this.editorIsHidden = !display.wrapper.offsetWidth;
	    this.wrapperHeight = display.wrapper.clientHeight;
	    this.wrapperWidth = display.wrapper.clientWidth;
	    this.oldDisplayWidth = displayWidth(cm);
	    this.force = force;
	    this.dims = getDimensions(cm);
	    this.events = [];
	  };
	
	  DisplayUpdate.prototype.signal = function (emitter, type) {
	    if (hasHandler(emitter, type)) {
	      this.events.push(arguments);
	    }
	  };
	  DisplayUpdate.prototype.finish = function () {
	    for (var i = 0; i < this.events.length; i++) {
	      signal.apply(null, this.events[i]);
	    }
	  };
	
	  function maybeClipScrollbars(cm) {
	    var display = cm.display;
	    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
	      display.heightForcer.style.height = scrollGap(cm) + "px";
	      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
	      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
	      display.scrollbarsClipped = true;
	    }
	  }
	
	  function selectionSnapshot(cm) {
	    if (cm.hasFocus()) {
	      return null;
	    }
	    var active = activeElt(root(cm));
	    if (!active || !contains(cm.display.lineDiv, active)) {
	      return null;
	    }
	    var result = { activeElt: active };
	    if (window.getSelection) {
	      var sel = win(cm).getSelection();
	      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
	        result.anchorNode = sel.anchorNode;
	        result.anchorOffset = sel.anchorOffset;
	        result.focusNode = sel.focusNode;
	        result.focusOffset = sel.focusOffset;
	      }
	    }
	    return result;
	  }
	
	  function restoreSelection(snapshot) {
	    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt(rootNode(snapshot.activeElt))) {
	      return;
	    }
	    snapshot.activeElt.focus();
	    if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) && snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
	      var doc = snapshot.activeElt.ownerDocument;
	      var sel = doc.defaultView.getSelection(),
	          range = doc.createRange();
	      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
	      range.collapse(false);
	      sel.removeAllRanges();
	      sel.addRange(range);
	      sel.extend(snapshot.focusNode, snapshot.focusOffset);
	    }
	  }
	
	  // Does the actual updating of the line display. Bails out
	  // (returning false) when there is nothing to be done and forced is
	  // false.
	  function updateDisplayIfNeeded(cm, update) {
	    var display = cm.display,
	        doc = cm.doc;
	
	    if (update.editorIsHidden) {
	      resetView(cm);
	      return false;
	    }
	
	    // Bail out if the visible area is already rendered and nothing changed.
	    if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) {
	      return false;
	    }
	
	    if (maybeUpdateLineNumberWidth(cm)) {
	      resetView(cm);
	      update.dims = getDimensions(cm);
	    }
	
	    // Compute a suitable new viewport (from & to)
	    var end = doc.first + doc.size;
	    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
	    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
	    if (display.viewFrom < from && from - display.viewFrom < 20) {
	      from = Math.max(doc.first, display.viewFrom);
	    }
	    if (display.viewTo > to && display.viewTo - to < 20) {
	      to = Math.min(end, display.viewTo);
	    }
	    if (sawCollapsedSpans) {
	      from = visualLineNo(cm.doc, from);
	      to = visualLineEndNo(cm.doc, to);
	    }
	
	    var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
	    adjustView(cm, from, to);
	
	    display.viewOffset = _heightAtLine(getLine(cm.doc, display.viewFrom));
	    // Position the mover div to align with the current scroll position
	    cm.display.mover.style.top = display.viewOffset + "px";
	
	    var toUpdate = countDirtyView(cm);
	    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) {
	      return false;
	    }
	
	    // For big changes, we hide the enclosing element during the
	    // update, since that speeds up the operations on most browsers.
	    var selSnapshot = selectionSnapshot(cm);
	    if (toUpdate > 4) {
	      display.lineDiv.style.display = "none";
	    }
	    patchDisplay(cm, display.updateLineNumbers, update.dims);
	    if (toUpdate > 4) {
	      display.lineDiv.style.display = "";
	    }
	    display.renderedView = display.view;
	    // There might have been a widget with a focused element that got
	    // hidden or updated, if so re-focus it.
	    restoreSelection(selSnapshot);
	
	    // Prevent selection and cursors from interfering with the scroll
	    // width and height.
	    removeChildren(display.cursorDiv);
	    removeChildren(display.selectionDiv);
	    display.gutters.style.height = display.sizer.style.minHeight = 0;
	
	    if (different) {
	      display.lastWrapHeight = update.wrapperHeight;
	      display.lastWrapWidth = update.wrapperWidth;
	      startWorker(cm, 400);
	    }
	
	    display.updateLineNumbers = null;
	
	    return true;
	  }
	
	  function postUpdateDisplay(cm, update) {
	    var viewport = update.viewport;
	
	    for (var first = true;; first = false) {
	      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	        // Clip forced viewport to actual scrollable area.
	        if (viewport && viewport.top != null) {
	          viewport = { top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top) };
	        }
	        // Updated line heights might result in the drawn area not
	        // actually covering the viewport. Keep looping until it does.
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) {
	          break;
	        }
	      } else if (first) {
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	      }
	      if (!updateDisplayIfNeeded(cm, update)) {
	        break;
	      }
	      updateHeightsInViewport(cm);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.force = false;
	    }
	
	    update.signal(cm, "update", cm);
	    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
	      cm.display.reportedViewFrom = cm.display.viewFrom;cm.display.reportedViewTo = cm.display.viewTo;
	    }
	  }
	
	  function updateDisplaySimple(cm, viewport) {
	    var update = new DisplayUpdate(cm, viewport);
	    if (updateDisplayIfNeeded(cm, update)) {
	      updateHeightsInViewport(cm);
	      postUpdateDisplay(cm, update);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.finish();
	    }
	  }
	
	  // Sync the actual display DOM structure with display.view, removing
	  // nodes for lines that are no longer in view, and creating the ones
	  // that are not there yet, and updating the ones that are out of
	  // date.
	  function patchDisplay(cm, updateNumbersFrom, dims) {
	    var display = cm.display,
	        lineNumbers = cm.options.lineNumbers;
	    var container = display.lineDiv,
	        cur = container.firstChild;
	
	    function rm(node) {
	      var next = node.nextSibling;
	      // Works around a throw-scroll bug in OS X Webkit
	      if (webkit && mac && cm.display.currentWheelTarget == node) {
	        node.style.display = "none";
	      } else {
	        node.parentNode.removeChild(node);
	      }
	      return next;
	    }
	
	    var view = display.view,
	        lineN = display.viewFrom;
	    // Loop over the elements in the view, syncing cur (the DOM nodes
	    // in display.lineDiv) with the view as we go.
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (lineView.hidden) ;else if (!lineView.node || lineView.node.parentNode != container) {
	        // Not drawn yet
	        var node = buildLineElement(cm, lineView, lineN, dims);
	        container.insertBefore(node, cur);
	      } else {
	        // Already drawn
	        while (cur != lineView.node) {
	          cur = rm(cur);
	        }
	        var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
	        if (lineView.changes) {
	          if (indexOf(lineView.changes, "gutter") > -1) {
	            updateNumber = false;
	          }
	          updateLineForChanges(cm, lineView, lineN, dims);
	        }
	        if (updateNumber) {
	          removeChildren(lineView.lineNumber);
	          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
	        }
	        cur = lineView.node.nextSibling;
	      }
	      lineN += lineView.size;
	    }
	    while (cur) {
	      cur = rm(cur);
	    }
	  }
	
	  function updateGutterSpace(display) {
	    var width = display.gutters.offsetWidth;
	    display.sizer.style.marginLeft = width + "px";
	    // Send an event to consumers responding to changes in gutter width.
	    signalLater(display, "gutterChanged", display);
	  }
	
	  function setDocumentHeight(cm, measure) {
	    cm.display.sizer.style.minHeight = measure.docHeight + "px";
	    cm.display.heightForcer.style.top = measure.docHeight + "px";
	    cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
	  }
	
	  // Re-align line numbers and gutter marks to compensate for
	  // horizontal scrolling.
	  function alignHorizontally(cm) {
	    var display = cm.display,
	        view = display.view;
	    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) {
	      return;
	    }
	    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
	    var gutterW = display.gutters.offsetWidth,
	        left = comp + "px";
	    for (var i = 0; i < view.length; i++) {
	      if (!view[i].hidden) {
	        if (cm.options.fixedGutter) {
	          if (view[i].gutter) {
	            view[i].gutter.style.left = left;
	          }
	          if (view[i].gutterBackground) {
	            view[i].gutterBackground.style.left = left;
	          }
	        }
	        var align = view[i].alignable;
	        if (align) {
	          for (var j = 0; j < align.length; j++) {
	            align[j].style.left = left;
	          }
	        }
	      }
	    }
	    if (cm.options.fixedGutter) {
	      display.gutters.style.left = comp + gutterW + "px";
	    }
	  }
	
	  // Used to ensure that the line number gutter is still the right
	  // size for the current document size. Returns true when an update
	  // is needed.
	  function maybeUpdateLineNumberWidth(cm) {
	    if (!cm.options.lineNumbers) {
	      return false;
	    }
	    var doc = cm.doc,
	        last = lineNumberFor(cm.options, doc.first + doc.size - 1),
	        display = cm.display;
	    if (last.length != display.lineNumChars) {
	      var test = display.measure.appendChild(elt("div", [elt("div", last)], "CodeMirror-linenumber CodeMirror-gutter-elt"));
	      var innerW = test.firstChild.offsetWidth,
	          padding = test.offsetWidth - innerW;
	      display.lineGutter.style.width = "";
	      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
	      display.lineNumWidth = display.lineNumInnerWidth + padding;
	      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
	      display.lineGutter.style.width = display.lineNumWidth + "px";
	      updateGutterSpace(cm.display);
	      return true;
	    }
	    return false;
	  }
	
	  function getGutters(gutters, lineNumbers) {
	    var result = [],
	        sawLineNumbers = false;
	    for (var i = 0; i < gutters.length; i++) {
	      var name = gutters[i],
	          style = null;
	      if (typeof name != "string") {
	        style = name.style;name = name.className;
	      }
	      if (name == "CodeMirror-linenumbers") {
	        if (!lineNumbers) {
	          continue;
	        } else {
	          sawLineNumbers = true;
	        }
	      }
	      result.push({ className: name, style: style });
	    }
	    if (lineNumbers && !sawLineNumbers) {
	      result.push({ className: "CodeMirror-linenumbers", style: null });
	    }
	    return result;
	  }
	
	  // Rebuild the gutter elements, ensure the margin to the left of the
	  // code matches their width.
	  function renderGutters(display) {
	    var gutters = display.gutters,
	        specs = display.gutterSpecs;
	    removeChildren(gutters);
	    display.lineGutter = null;
	    for (var i = 0; i < specs.length; ++i) {
	      var ref = specs[i];
	      var className = ref.className;
	      var style = ref.style;
	      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
	      if (style) {
	        gElt.style.cssText = style;
	      }
	      if (className == "CodeMirror-linenumbers") {
	        display.lineGutter = gElt;
	        gElt.style.width = (display.lineNumWidth || 1) + "px";
	      }
	    }
	    gutters.style.display = specs.length ? "" : "none";
	    updateGutterSpace(display);
	  }
	
	  function updateGutters(cm) {
	    renderGutters(cm.display);
	    regChange(cm);
	    alignHorizontally(cm);
	  }
	
	  // The display handles the DOM integration, both for input reading
	  // and content drawing. It holds references to DOM nodes and
	  // display-related state.
	
	  function Display(place, doc, input, options) {
	    var d = this;
	    this.input = input;
	
	    // Covers bottom-right square when both scrollbars are present.
	    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
	    d.scrollbarFiller.setAttribute("cm-not-content", "true");
	    // Covers bottom of gutter when coverGutterNextToScrollbar is on
	    // and h scrollbar is present.
	    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
	    d.gutterFiller.setAttribute("cm-not-content", "true");
	    // Will contain the actual code, positioned to cover the viewport.
	    d.lineDiv = eltP("div", null, "CodeMirror-code");
	    // Elements are added to these to represent selection and cursors.
	    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
	    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
	    // A visibility: hidden element used to find the size of things.
	    d.measure = elt("div", null, "CodeMirror-measure");
	    // When lines outside of the viewport are measured, they are drawn in this.
	    d.lineMeasure = elt("div", null, "CodeMirror-measure");
	    // Wraps everything that needs to exist inside the vertically-padded coordinate system
	    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv], null, "position: relative; outline: none");
	    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
	    // Moved around its parent to cover visible view.
	    d.mover = elt("div", [lines], null, "position: relative");
	    // Set to the height of the document, allowing scrolling.
	    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
	    d.sizerWidth = null;
	    // Behavior of elts with overflow: auto and padding is
	    // inconsistent across browsers. This is used to ensure the
	    // scrollable area is big enough.
	    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
	    // Will contain the gutters, if any.
	    d.gutters = elt("div", null, "CodeMirror-gutters");
	    d.lineGutter = null;
	    // Actual scrollable element.
	    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
	    d.scroller.setAttribute("tabIndex", "-1");
	    // The element in which the editor lives.
	    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");
	    // See #6982. FIXME remove when this has been fixed for a while in Chrome
	    if (chrome && chrome_version >= 105) {
	      d.wrapper.style.clipPath = "inset(0px)";
	    }
	
	    // This attribute is respected by automatic translation systems such as Google Translate,
	    // and may also be respected by tools used by human translators.
	    d.wrapper.setAttribute('translate', 'no');
	
	    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	    if (ie && ie_version < 8) {
	      d.gutters.style.zIndex = -1;d.scroller.style.paddingRight = 0;
	    }
	    if (!webkit && !(gecko && mobile)) {
	      d.scroller.draggable = true;
	    }
	
	    if (place) {
	      if (place.appendChild) {
	        place.appendChild(d.wrapper);
	      } else {
	        place(d.wrapper);
	      }
	    }
	
	    // Current rendered range (may be bigger than the view window).
	    d.viewFrom = d.viewTo = doc.first;
	    d.reportedViewFrom = d.reportedViewTo = doc.first;
	    // Information about the rendered lines.
	    d.view = [];
	    d.renderedView = null;
	    // Holds info about a single rendered line when it was rendered
	    // for measurement, while not in view.
	    d.externalMeasured = null;
	    // Empty space (in pixels) above the view
	    d.viewOffset = 0;
	    d.lastWrapHeight = d.lastWrapWidth = 0;
	    d.updateLineNumbers = null;
	
	    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
	    d.scrollbarsClipped = false;
	
	    // Used to only resize the line number gutter when necessary (when
	    // the amount of lines crosses a boundary that makes its width change)
	    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
	    // Set to true when a non-horizontal-scrolling line widget is
	    // added. As an optimization, line widget aligning is skipped when
	    // this is false.
	    d.alignWidgets = false;
	
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	
	    // Tracks the maximum line length so that the horizontal scrollbar
	    // can be kept static when scrolling.
	    d.maxLine = null;
	    d.maxLineLength = 0;
	    d.maxLineChanged = false;
	
	    // Used for measuring wheel scrolling granularity
	    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
	
	    // True when shift is held down.
	    d.shift = false;
	
	    // Used to track whether anything happened since the context menu
	    // was opened.
	    d.selForContextMenu = null;
	
	    d.activeTouch = null;
	
	    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
	    renderGutters(d);
	
	    input.init(d);
	  }
	
	  // Since the delta values reported on mouse wheel events are
	  // unstandardized between browsers and even browser versions, and
	  // generally horribly unpredictable, this code starts by measuring
	  // the scroll effect that the first few mouse wheel events have,
	  // and, from that, detects the way it can convert deltas to pixel
	  // offsets afterwards.
	  //
	  // The reason we want to know the amount a wheel event will scroll
	  // is that it gives us a chance to update the display before the
	  // actual scrolling happens, reducing flickering.
	
	  var wheelSamples = 0,
	      wheelPixelsPerUnit = null;
	  // Fill in a browser-detected starting value on browsers where we
	  // know one. These don't have to be accurate -- the result of them
	  // being wrong would just be a slight flicker on the first wheel
	  // scroll (if it is large enough).
	  if (ie) {
	    wheelPixelsPerUnit = -.53;
	  } else if (gecko) {
	    wheelPixelsPerUnit = 15;
	  } else if (chrome) {
	    wheelPixelsPerUnit = -.7;
	  } else if (safari) {
	    wheelPixelsPerUnit = -1 / 3;
	  }
	
	  function wheelEventDelta(e) {
	    var dx = e.wheelDeltaX,
	        dy = e.wheelDeltaY;
	    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) {
	      dx = e.detail;
	    }
	    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) {
	      dy = e.detail;
	    } else if (dy == null) {
	      dy = e.wheelDelta;
	    }
	    return { x: dx, y: dy };
	  }
	  function wheelEventPixels(e) {
	    var delta = wheelEventDelta(e);
	    delta.x *= wheelPixelsPerUnit;
	    delta.y *= wheelPixelsPerUnit;
	    return delta;
	  }
	
	  function onScrollWheel(cm, e) {
	    // On Chrome 102, viewport updates somehow stop wheel-based
	    // scrolling. Turning off pointer events during the scroll seems
	    // to avoid the issue.
	    if (chrome && chrome_version == 102) {
	      if (cm.display.chromeScrollHack == null) {
	        cm.display.sizer.style.pointerEvents = "none";
	      } else {
	        clearTimeout(cm.display.chromeScrollHack);
	      }
	      cm.display.chromeScrollHack = setTimeout(function () {
	        cm.display.chromeScrollHack = null;
	        cm.display.sizer.style.pointerEvents = "";
	      }, 100);
	    }
	    var delta = wheelEventDelta(e),
	        dx = delta.x,
	        dy = delta.y;
	    var pixelsPerUnit = wheelPixelsPerUnit;
	    if (e.deltaMode === 0) {
	      dx = e.deltaX;
	      dy = e.deltaY;
	      pixelsPerUnit = 1;
	    }
	
	    var display = cm.display,
	        scroll = display.scroller;
	    // Quit if there's nothing to scroll here
	    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
	    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
	    if (!(dx && canScrollX || dy && canScrollY)) {
	      return;
	    }
	
	    // Webkit browsers on OS X abort momentum scrolls when the target
	    // of the scroll event is removed from the scrollable element.
	    // This hack (see related code in patchDisplay) makes sure the
	    // element is kept around.
	    if (dy && mac && webkit) {
	      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	        for (var i = 0; i < view.length; i++) {
	          if (view[i].node == cur) {
	            cm.display.currentWheelTarget = cur;
	            break outer;
	          }
	        }
	      }
	    }
	
	    // On some browsers, horizontal scrolling will cause redraws to
	    // happen before the gutter has been realigned, causing it to
	    // wriggle around in a most unseemly way. When we have an
	    // estimated pixels/delta value, we just handle horizontal
	    // scrolling entirely here. It'll be slightly off from native, but
	    // better than glitching out.
	    if (dx && !gecko && !presto && pixelsPerUnit != null) {
	      if (dy && canScrollY) {
	        updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit));
	      }
	      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
	      // Only prevent default scrolling if vertical scrolling is
	      // actually possible. Otherwise, it causes vertical scroll
	      // jitter on OSX trackpads when deltaX is small and deltaY
	      // is large (issue #3579)
	      if (!dy || dy && canScrollY) {
	        e_preventDefault(e);
	      }
	      display.wheelStartX = null; // Abort measurement, if in progress
	      return;
	    }
	
	    // 'Project' the visible viewport to cover the area that is being
	    // scrolled into view (if we know enough to estimate it).
	    if (dy && pixelsPerUnit != null) {
	      var pixels = dy * pixelsPerUnit;
	      var top = cm.doc.scrollTop,
	          bot = top + display.wrapper.clientHeight;
	      if (pixels < 0) {
	        top = Math.max(0, top + pixels - 50);
	      } else {
	        bot = Math.min(cm.doc.height, bot + pixels + 50);
	      }
	      updateDisplaySimple(cm, { top: top, bottom: bot });
	    }
	
	    if (wheelSamples < 20 && e.deltaMode !== 0) {
	      if (display.wheelStartX == null) {
	        display.wheelStartX = scroll.scrollLeft;display.wheelStartY = scroll.scrollTop;
	        display.wheelDX = dx;display.wheelDY = dy;
	        setTimeout(function () {
	          if (display.wheelStartX == null) {
	            return;
	          }
	          var movedX = scroll.scrollLeft - display.wheelStartX;
	          var movedY = scroll.scrollTop - display.wheelStartY;
	          var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
	          display.wheelStartX = display.wheelStartY = null;
	          if (!sample) {
	            return;
	          }
	          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
	          ++wheelSamples;
	        }, 200);
	      } else {
	        display.wheelDX += dx;display.wheelDY += dy;
	      }
	    }
	  }
	
	  // Selection objects are immutable. A new one is created every time
	  // the selection changes. A selection is one or more non-overlapping
	  // (and non-touching) ranges, sorted, and an integer that indicates
	  // which one is the primary selection (the one that's scrolled into
	  // view, that getCursor returns, etc).
	  var Selection = function Selection(ranges, primIndex) {
	    this.ranges = ranges;
	    this.primIndex = primIndex;
	  };
	
	  Selection.prototype.primary = function () {
	    return this.ranges[this.primIndex];
	  };
	
	  Selection.prototype.equals = function (other) {
	    if (other == this) {
	      return true;
	    }
	    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) {
	      return false;
	    }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var here = this.ranges[i],
	          there = other.ranges[i];
	      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  Selection.prototype.deepCopy = function () {
	    var out = [];
	    for (var i = 0; i < this.ranges.length; i++) {
	      out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head));
	    }
	    return new Selection(out, this.primIndex);
	  };
	
	  Selection.prototype.somethingSelected = function () {
	    for (var i = 0; i < this.ranges.length; i++) {
	      if (!this.ranges[i].empty()) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  Selection.prototype.contains = function (pos, end) {
	    if (!end) {
	      end = pos;
	    }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var range = this.ranges[i];
	      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  var Range = function Range(anchor, head) {
	    this.anchor = anchor;this.head = head;
	  };
	
	  Range.prototype.from = function () {
	    return minPos(this.anchor, this.head);
	  };
	  Range.prototype.to = function () {
	    return maxPos(this.anchor, this.head);
	  };
	  Range.prototype.empty = function () {
	    return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
	  };
	
	  // Take an unsorted, potentially overlapping set of ranges, and
	  // build a selection out of it. 'Consumes' ranges array (modifying
	  // it).
	  function normalizeSelection(cm, ranges, primIndex) {
	    var mayTouch = cm && cm.options.selectionsMayTouch;
	    var prim = ranges[primIndex];
	    ranges.sort(function (a, b) {
	      return cmp(a.from(), b.from());
	    });
	    primIndex = indexOf(ranges, prim);
	    for (var i = 1; i < ranges.length; i++) {
	      var cur = ranges[i],
	          prev = ranges[i - 1];
	      var diff = cmp(prev.to(), cur.from());
	      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
	        var from = minPos(prev.from(), cur.from()),
	            to = maxPos(prev.to(), cur.to());
	        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
	        if (i <= primIndex) {
	          --primIndex;
	        }
	        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
	      }
	    }
	    return new Selection(ranges, primIndex);
	  }
	
	  function simpleSelection(anchor, head) {
	    return new Selection([new Range(anchor, head || anchor)], 0);
	  }
	
	  // Compute the position of the end of a change (its 'to' property
	  // refers to the pre-change end).
	  function changeEnd(change) {
	    if (!change.text) {
	      return change.to;
	    }
	    return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
	  }
	
	  // Adjust a position to refer to the post-change position of the
	  // same text, or the end of the change if the change covers it.
	  function adjustForChange(pos, change) {
	    if (cmp(pos, change.from) < 0) {
	      return pos;
	    }
	    if (cmp(pos, change.to) <= 0) {
	      return changeEnd(change);
	    }
	
	    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1,
	        ch = pos.ch;
	    if (pos.line == change.to.line) {
	      ch += changeEnd(change).ch - change.to.ch;
	    }
	    return Pos(line, ch);
	  }
	
	  function computeSelAfterChange(doc, change) {
	    var out = [];
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      var range = doc.sel.ranges[i];
	      out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
	    }
	    return normalizeSelection(doc.cm, out, doc.sel.primIndex);
	  }
	
	  function offsetPos(pos, old, nw) {
	    if (pos.line == old.line) {
	      return Pos(nw.line, pos.ch - old.ch + nw.ch);
	    } else {
	      return Pos(nw.line + (pos.line - old.line), pos.ch);
	    }
	  }
	
	  // Used by replaceSelections to allow moving the selection to the
	  // start or around the replaced test. Hint may be "start" or "around".
	  function computeReplacedSel(doc, changes, hint) {
	    var out = [];
	    var oldPrev = Pos(doc.first, 0),
	        newPrev = oldPrev;
	    for (var i = 0; i < changes.length; i++) {
	      var change = changes[i];
	      var from = offsetPos(change.from, oldPrev, newPrev);
	      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
	      oldPrev = change.to;
	      newPrev = to;
	      if (hint == "around") {
	        var range = doc.sel.ranges[i],
	            inv = cmp(range.head, range.anchor) < 0;
	        out[i] = new Range(inv ? to : from, inv ? from : to);
	      } else {
	        out[i] = new Range(from, from);
	      }
	    }
	    return new Selection(out, doc.sel.primIndex);
	  }
	
	  // Used to get the editor into a consistent state again when options change.
	
	  function loadMode(cm) {
	    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
	    resetModeState(cm);
	  }
	
	  function resetModeState(cm) {
	    cm.doc.iter(function (line) {
	      if (line.stateAfter) {
	        line.stateAfter = null;
	      }
	      if (line.styles) {
	        line.styles = null;
	      }
	    });
	    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
	    startWorker(cm, 100);
	    cm.state.modeGen++;
	    if (cm.curOp) {
	      regChange(cm);
	    }
	  }
	
	  // DOCUMENT DATA STRUCTURE
	
	  // By default, updates that start and end at the beginning of a line
	  // are treated specially, in order to make the association of line
	  // widgets and marker elements with the text behave more intuitive.
	  function isWholeLineUpdate(doc, change) {
	    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
	  }
	
	  // Perform a change on the document data structure.
	  function updateDoc(doc, change, markedSpans, estimateHeight) {
	    function spansFor(n) {
	      return markedSpans ? markedSpans[n] : null;
	    }
	    function update(line, text, spans) {
	      updateLine(line, text, spans, estimateHeight);
	      signalLater(line, "change", line, change);
	    }
	    function linesFor(start, end) {
	      var result = [];
	      for (var i = start; i < end; ++i) {
	        result.push(new Line(text[i], spansFor(i), estimateHeight));
	      }
	      return result;
	    }
	
	    var from = change.from,
	        to = change.to,
	        text = change.text;
	    var firstLine = getLine(doc, from.line),
	        lastLine = getLine(doc, to.line);
	    var lastText = lst(text),
	        lastSpans = spansFor(text.length - 1),
	        nlines = to.line - from.line;
	
	    // Adjust the line structure
	    if (change.full) {
	      doc.insert(0, linesFor(0, text.length));
	      doc.remove(text.length, doc.size - text.length);
	    } else if (isWholeLineUpdate(doc, change)) {
	      // This is a whole-line replace. Treated specially to make
	      // sure line objects move the way they are supposed to.
	      var added = linesFor(0, text.length - 1);
	      update(lastLine, lastLine.text, lastSpans);
	      if (nlines) {
	        doc.remove(from.line, nlines);
	      }
	      if (added.length) {
	        doc.insert(from.line, added);
	      }
	    } else if (firstLine == lastLine) {
	      if (text.length == 1) {
	        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
	      } else {
	        var added$1 = linesFor(1, text.length - 1);
	        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
	        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	        doc.insert(from.line + 1, added$1);
	      }
	    } else if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
	      doc.remove(from.line + 1, nlines);
	    } else {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
	      var added$2 = linesFor(1, text.length - 1);
	      if (nlines > 1) {
	        doc.remove(from.line + 1, nlines - 1);
	      }
	      doc.insert(from.line + 1, added$2);
	    }
	
	    signalLater(doc, "change", doc, change);
	  }
	
	  // Call f for all linked documents.
	  function linkedDocs(doc, f, sharedHistOnly) {
	    function propagate(doc, skip, sharedHist) {
	      if (doc.linked) {
	        for (var i = 0; i < doc.linked.length; ++i) {
	          var rel = doc.linked[i];
	          if (rel.doc == skip) {
	            continue;
	          }
	          var shared = sharedHist && rel.sharedHist;
	          if (sharedHistOnly && !shared) {
	            continue;
	          }
	          f(rel.doc, shared);
	          propagate(rel.doc, doc, shared);
	        }
	      }
	    }
	    propagate(doc, null, true);
	  }
	
	  // Attach a document to an editor.
	  function attachDoc(cm, doc) {
	    if (doc.cm) {
	      throw new Error("This document is already in use.");
	    }
	    cm.doc = doc;
	    doc.cm = cm;
	    estimateLineHeights(cm);
	    loadMode(cm);
	    setDirectionClass(cm);
	    cm.options.direction = doc.direction;
	    if (!cm.options.lineWrapping) {
	      findMaxLine(cm);
	    }
	    cm.options.mode = doc.modeOption;
	    regChange(cm);
	  }
	
	  function setDirectionClass(cm) {
	    (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
	  }
	
	  function directionChanged(cm) {
	    runInOp(cm, function () {
	      setDirectionClass(cm);
	      regChange(cm);
	    });
	  }
	
	  function History(prev) {
	    // Arrays of change events and selections. Doing something adds an
	    // event to done and clears undo. Undoing moves events from done
	    // to undone, redoing moves them in the other direction.
	    this.done = [];this.undone = [];
	    this.undoDepth = prev ? prev.undoDepth : Infinity;
	    // Used to track when changes can be merged into a single undo
	    // event
	    this.lastModTime = this.lastSelTime = 0;
	    this.lastOp = this.lastSelOp = null;
	    this.lastOrigin = this.lastSelOrigin = null;
	    // Used by the isClean() method
	    this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
	  }
	
	  // Create a history change event from an updateDoc-style change
	  // object.
	  function historyChangeFromChange(doc, change) {
	    var histChange = { from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to) };
	    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    linkedDocs(doc, function (doc) {
	      return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    }, true);
	    return histChange;
	  }
	
	  // Pop all selection events off the end of a history array. Stop at
	  // a change event.
	  function clearSelectionEvents(array) {
	    while (array.length) {
	      var last = lst(array);
	      if (last.ranges) {
	        array.pop();
	      } else {
	        break;
	      }
	    }
	  }
	
	  // Find the top change event in the history. Pop off selection
	  // events that are in the way.
	  function lastChangeEvent(hist, force) {
	    if (force) {
	      clearSelectionEvents(hist.done);
	      return lst(hist.done);
	    } else if (hist.done.length && !lst(hist.done).ranges) {
	      return lst(hist.done);
	    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	      hist.done.pop();
	      return lst(hist.done);
	    }
	  }
	
	  // Register a change in the history. Merges changes that are within
	  // a single operation, or are close together with an origin that
	  // allows merging (starting with "+") into a single event.
	  function addChangeToHistory(doc, change, selAfter, opId) {
	    var hist = doc.history;
	    hist.undone.length = 0;
	    var time = +new Date(),
	        cur;
	    var last;
	
	    if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	      // Merge this change into the last event
	      last = lst(cur.changes);
	      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	        // Optimized case for simple insertion -- don't want to add
	        // new changesets for every character typed
	        last.to = changeEnd(change);
	      } else {
	        // Add new sub-event
	        cur.changes.push(historyChangeFromChange(doc, change));
	      }
	    } else {
	      // Can not be merged, start a new event.
	      var before = lst(hist.done);
	      if (!before || !before.ranges) {
	        pushSelectionToHistory(doc.sel, hist.done);
	      }
	      cur = { changes: [historyChangeFromChange(doc, change)],
	        generation: hist.generation };
	      hist.done.push(cur);
	      while (hist.done.length > hist.undoDepth) {
	        hist.done.shift();
	        if (!hist.done[0].ranges) {
	          hist.done.shift();
	        }
	      }
	    }
	    hist.done.push(selAfter);
	    hist.generation = ++hist.maxGeneration;
	    hist.lastModTime = hist.lastSelTime = time;
	    hist.lastOp = hist.lastSelOp = opId;
	    hist.lastOrigin = hist.lastSelOrigin = change.origin;
	
	    if (!last) {
	      signal(doc, "historyAdded");
	    }
	  }
	
	  function selectionEventCanBeMerged(doc, origin, prev, sel) {
	    var ch = origin.charAt(0);
	    return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date() - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
	  }
	
	  // Called whenever the selection changes, sets the new selection as
	  // the pending selection in the history, and pushes the old pending
	  // selection into the 'done' array when it was significantly
	  // different (in number of selected ranges, emptiness, or time).
	  function addSelectionToHistory(doc, sel, opId, options) {
	    var hist = doc.history,
	        origin = options && options.origin;
	
	    // A new event is started when the previous origin does not match
	    // the current, or the origins don't allow matching. Origins
	    // starting with * are always merged, those starting with + are
	    // merged when similar and close together in time.
	    if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) {
	      hist.done[hist.done.length - 1] = sel;
	    } else {
	      pushSelectionToHistory(sel, hist.done);
	    }
	
	    hist.lastSelTime = +new Date();
	    hist.lastSelOrigin = origin;
	    hist.lastSelOp = opId;
	    if (options && options.clearRedo !== false) {
	      clearSelectionEvents(hist.undone);
	    }
	  }
	
	  function pushSelectionToHistory(sel, dest) {
	    var top = lst(dest);
	    if (!(top && top.ranges && top.equals(sel))) {
	      dest.push(sel);
	    }
	  }
	
	  // Used to store marked span information in the history.
	  function attachLocalSpans(doc, change, from, to) {
	    var existing = change["spans_" + doc.id],
	        n = 0;
	    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
	      if (line.markedSpans) {
	        (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
	      }
	      ++n;
	    });
	  }
	
	  // When un/re-doing restores text containing marked spans, those
	  // that have been explicitly cleared should not be restored.
	  function removeClearedSpans(spans) {
	    if (!spans) {
	      return null;
	    }
	    var out;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i].marker.explicitlyCleared) {
	        if (!out) {
	          out = spans.slice(0, i);
	        }
	      } else if (out) {
	        out.push(spans[i]);
	      }
	    }
	    return !out ? spans : out.length ? out : null;
	  }
	
	  // Retrieve and filter the old marked spans stored in a change event.
	  function getOldSpans(doc, change) {
	    var found = change["spans_" + doc.id];
	    if (!found) {
	      return null;
	    }
	    var nw = [];
	    for (var i = 0; i < change.text.length; ++i) {
	      nw.push(removeClearedSpans(found[i]));
	    }
	    return nw;
	  }
	
	  // Used for un/re-doing changes from the history. Combines the
	  // result of computing the existing spans with the set of spans that
	  // existed in the history (so that deleting around a span and then
	  // undoing brings back the span).
	  function mergeOldSpans(doc, change) {
	    var old = getOldSpans(doc, change);
	    var stretched = stretchSpansOverChange(doc, change);
	    if (!old) {
	      return stretched;
	    }
	    if (!stretched) {
	      return old;
	    }
	
	    for (var i = 0; i < old.length; ++i) {
	      var oldCur = old[i],
	          stretchCur = stretched[i];
	      if (oldCur && stretchCur) {
	        spans: for (var j = 0; j < stretchCur.length; ++j) {
	          var span = stretchCur[j];
	          for (var k = 0; k < oldCur.length; ++k) {
	            if (oldCur[k].marker == span.marker) {
	              continue spans;
	            }
	          }
	          oldCur.push(span);
	        }
	      } else if (stretchCur) {
	        old[i] = stretchCur;
	      }
	    }
	    return old;
	  }
	
	  // Used both to provide a JSON-safe object in .getHistory, and, when
	  // detaching a document, to split the history in two
	  function copyHistoryArray(events, newGroup, instantiateSel) {
	    var copy = [];
	    for (var i = 0; i < events.length; ++i) {
	      var event = events[i];
	      if (event.ranges) {
	        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
	        continue;
	      }
	      var changes = event.changes,
	          newChanges = [];
	      copy.push({ changes: newChanges });
	      for (var j = 0; j < changes.length; ++j) {
	        var change = changes[j],
	            m = void 0;
	        newChanges.push({ from: change.from, to: change.to, text: change.text });
	        if (newGroup) {
	          for (var prop in change) {
	            if (m = prop.match(/^spans_(\d+)$/)) {
	              if (indexOf(newGroup, Number(m[1])) > -1) {
	                lst(newChanges)[prop] = change[prop];
	                delete change[prop];
	              }
	            }
	          }
	        }
	      }
	    }
	    return copy;
	  }
	
	  // The 'scroll' parameter given to many of these indicated whether
	  // the new cursor position should be scrolled into view after
	  // modifying the selection.
	
	  // If shift is held or the extend flag is set, extends a range to
	  // include a given position (and optionally a second position).
	  // Otherwise, simply returns the range between the given positions.
	  // Used for cursor motion and such.
	  function extendRange(range, head, other, extend) {
	    if (extend) {
	      var anchor = range.anchor;
	      if (other) {
	        var posBefore = cmp(head, anchor) < 0;
	        if (posBefore != cmp(other, anchor) < 0) {
	          anchor = head;
	          head = other;
	        } else if (posBefore != cmp(head, other) < 0) {
	          head = other;
	        }
	      }
	      return new Range(anchor, head);
	    } else {
	      return new Range(other || head, head);
	    }
	  }
	
	  // Extend the primary selection range, discard the rest.
	  function extendSelection(doc, head, other, options, extend) {
	    if (extend == null) {
	      extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    }
	    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
	  }
	
	  // Extend all selections (pos is an array of selections with length
	  // equal the number of selections)
	  function extendSelections(doc, heads, options) {
	    var out = [];
	    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
	    }
	    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
	    setSelection(doc, newSel, options);
	  }
	
	  // Updates a single range in the selection.
	  function replaceOneSelection(doc, i, range, options) {
	    var ranges = doc.sel.ranges.slice(0);
	    ranges[i] = range;
	    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
	  }
	
	  // Reset the selection to a single range.
	  function setSimpleSelection(doc, anchor, head, options) {
	    setSelection(doc, simpleSelection(anchor, head), options);
	  }
	
	  // Give beforeSelectionChange handlers a change to influence a
	  // selection update.
	  function filterSelectionChange(doc, sel, options) {
	    var obj = {
	      ranges: sel.ranges,
	      update: function update(ranges) {
	        this.ranges = [];
	        for (var i = 0; i < ranges.length; i++) {
	          this.ranges[i] = new Range(_clipPos(doc, ranges[i].anchor), _clipPos(doc, ranges[i].head));
	        }
	      },
	      origin: options && options.origin
	    };
	    signal(doc, "beforeSelectionChange", doc, obj);
	    if (doc.cm) {
	      signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
	    }
	    if (obj.ranges != sel.ranges) {
	      return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1);
	    } else {
	      return sel;
	    }
	  }
	
	  function setSelectionReplaceHistory(doc, sel, options) {
	    var done = doc.history.done,
	        last = lst(done);
	    if (last && last.ranges) {
	      done[done.length - 1] = sel;
	      setSelectionNoUndo(doc, sel, options);
	    } else {
	      setSelection(doc, sel, options);
	    }
	  }
	
	  // Set a new selection.
	  function setSelection(doc, sel, options) {
	    setSelectionNoUndo(doc, sel, options);
	    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
	  }
	
	  function setSelectionNoUndo(doc, sel, options) {
	    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) {
	      sel = filterSelectionChange(doc, sel, options);
	    }
	
	    var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
	    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
	
	    if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor") {
	      ensureCursorVisible(doc.cm);
	    }
	  }
	
	  function setSelectionInner(doc, sel) {
	    if (sel.equals(doc.sel)) {
	      return;
	    }
	
	    doc.sel = sel;
	
	    if (doc.cm) {
	      doc.cm.curOp.updateInput = 1;
	      doc.cm.curOp.selectionChanged = true;
	      signalCursorActivity(doc.cm);
	    }
	    signalLater(doc, "cursorActivity", doc);
	  }
	
	  // Verify that the selection does not partially select any atomic
	  // marked ranges.
	  function reCheckSelection(doc) {
	    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
	  }
	
	  // Return a selection that does not partially select any atomic
	  // ranges.
	  function skipAtomicInSelection(doc, sel, bias, mayClear) {
	    var out;
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i];
	      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
	      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
	      var newHead = range.head == range.anchor ? newAnchor : skipAtomic(doc, range.head, old && old.head, bias, mayClear);
	      if (out || newAnchor != range.anchor || newHead != range.head) {
	        if (!out) {
	          out = sel.ranges.slice(0, i);
	        }
	        out[i] = new Range(newAnchor, newHead);
	      }
	    }
	    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel;
	  }
	
	  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	    var line = getLine(doc, pos.line);
	    if (line.markedSpans) {
	      for (var i = 0; i < line.markedSpans.length; ++i) {
	        var sp = line.markedSpans[i],
	            m = sp.marker;
	
	        // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
	        // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
	        // is with selectLeft/Right
	        var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
	        var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
	
	        if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	          if (mayClear) {
	            signal(m, "beforeCursorEnter");
	            if (m.explicitlyCleared) {
	              if (!line.markedSpans) {
	                break;
	              } else {
	                --i;continue;
	              }
	            }
	          }
	          if (!m.atomic) {
	            continue;
	          }
	
	          if (oldPos) {
	            var near = m.find(dir < 0 ? 1 : -1),
	                diff = void 0;
	            if (dir < 0 ? preventCursorRight : preventCursorLeft) {
	              near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
	            }
	            if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) {
	              return skipAtomicInner(doc, near, pos, dir, mayClear);
	            }
	          }
	
	          var far = m.find(dir < 0 ? -1 : 1);
	          if (dir < 0 ? preventCursorLeft : preventCursorRight) {
	            far = movePos(doc, far, dir, far.line == pos.line ? line : null);
	          }
	          return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
	        }
	      }
	    }
	    return pos;
	  }
	
	  // Ensure a given position is not inside an atomic range.
	  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	    var dir = bias || 1;
	    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
	    if (!found) {
	      doc.cantEdit = true;
	      return Pos(doc.first, 0);
	    }
	    return found;
	  }
	
	  function movePos(doc, pos, dir, line) {
	    if (dir < 0 && pos.ch == 0) {
	      if (pos.line > doc.first) {
	        return _clipPos(doc, Pos(pos.line - 1));
	      } else {
	        return null;
	      }
	    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	      if (pos.line < doc.first + doc.size - 1) {
	        return Pos(pos.line + 1, 0);
	      } else {
	        return null;
	      }
	    } else {
	      return new Pos(pos.line, pos.ch + dir);
	    }
	  }
	
	  function selectAll(cm) {
	    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
	  }
	
	  // UPDATING
	
	  // Allow "beforeChange" event handlers to influence a change
	  function filterChange(doc, change, update) {
	    var obj = {
	      canceled: false,
	      from: change.from,
	      to: change.to,
	      text: change.text,
	      origin: change.origin,
	      cancel: function cancel() {
	        return obj.canceled = true;
	      }
	    };
	    if (update) {
	      obj.update = function (from, to, text, origin) {
	        if (from) {
	          obj.from = _clipPos(doc, from);
	        }
	        if (to) {
	          obj.to = _clipPos(doc, to);
	        }
	        if (text) {
	          obj.text = text;
	        }
	        if (origin !== undefined) {
	          obj.origin = origin;
	        }
	      };
	    }
	    signal(doc, "beforeChange", doc, obj);
	    if (doc.cm) {
	      signal(doc.cm, "beforeChange", doc.cm, obj);
	    }
	
	    if (obj.canceled) {
	      if (doc.cm) {
	        doc.cm.curOp.updateInput = 2;
	      }
	      return null;
	    }
	    return { from: obj.from, to: obj.to, text: obj.text, origin: obj.origin };
	  }
	
	  // Apply a change to a document, and add it to the document's
	  // history, and propagating it to all linked documents.
	  function makeChange(doc, change, ignoreReadOnly) {
	    if (doc.cm) {
	      if (!doc.cm.curOp) {
	        return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
	      }
	      if (doc.cm.state.suppressEdits) {
	        return;
	      }
	    }
	
	    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	      change = filterChange(doc, change, true);
	      if (!change) {
	        return;
	      }
	    }
	
	    // Possibly split or suppress the update based on the presence
	    // of read-only spans in its range.
	    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
	    if (split) {
	      for (var i = split.length - 1; i >= 0; --i) {
	        makeChangeInner(doc, { from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin });
	      }
	    } else {
	      makeChangeInner(doc, change);
	    }
	  }
	
	  function makeChangeInner(doc, change) {
	    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) {
	      return;
	    }
	    var selAfter = computeSelAfterChange(doc, change);
	    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
	
	    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
	    var rebased = [];
	
	    linkedDocs(doc, function (doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change);
	        rebased.push(doc.history);
	      }
	      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
	    });
	  }
	
	  // Revert a change stored in a document's history.
	  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	    var suppress = doc.cm && doc.cm.state.suppressEdits;
	    if (suppress && !allowSelectionOnly) {
	      return;
	    }
	
	    var hist = doc.history,
	        event,
	        selAfter = doc.sel;
	    var source = type == "undo" ? hist.done : hist.undone,
	        dest = type == "undo" ? hist.undone : hist.done;
	
	    // Verify that there is a useable event (so that ctrl-z won't
	    // needlessly clear selection events)
	    var i = 0;
	    for (; i < source.length; i++) {
	      event = source[i];
	      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) {
	        break;
	      }
	    }
	    if (i == source.length) {
	      return;
	    }
	    hist.lastOrigin = hist.lastSelOrigin = null;
	
	    for (;;) {
	      event = source.pop();
	      if (event.ranges) {
	        pushSelectionToHistory(event, dest);
	        if (allowSelectionOnly && !event.equals(doc.sel)) {
	          setSelection(doc, event, { clearRedo: false });
	          return;
	        }
	        selAfter = event;
	      } else if (suppress) {
	        source.push(event);
	        return;
	      } else {
	        break;
	      }
	    }
	
	    // Build up a reverse change object to add to the opposite history
	    // stack (redo when undoing, and vice versa).
	    var antiChanges = [];
	    pushSelectionToHistory(selAfter, dest);
	    dest.push({ changes: antiChanges, generation: hist.generation });
	    hist.generation = event.generation || ++hist.maxGeneration;
	
	    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
	
	    var loop = function loop(i) {
	      var change = event.changes[i];
	      change.origin = type;
	      if (filter && !filterChange(doc, change, false)) {
	        source.length = 0;
	        return {};
	      }
	
	      antiChanges.push(historyChangeFromChange(doc, change));
	
	      var after = i ? computeSelAfterChange(doc, change) : lst(source);
	      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
	      if (!i && doc.cm) {
	        doc.cm.scrollIntoView({ from: change.from, to: changeEnd(change) });
	      }
	      var rebased = [];
	
	      // Propagate to the linked documents
	      linkedDocs(doc, function (doc, sharedHist) {
	        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	          rebaseHist(doc.history, change);
	          rebased.push(doc.history);
	        }
	        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
	      });
	    };
	
	    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
	      var returned = loop(i$1);
	
	      if (returned) return returned.v;
	    }
	  }
	
	  // Sub-views need their line numbers shifted when text is added
	  // above or below them in the parent document.
	  function shiftDoc(doc, distance) {
	    if (distance == 0) {
	      return;
	    }
	    doc.first += distance;
	    doc.sel = new Selection(map(doc.sel.ranges, function (range) {
	      return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
	    }), doc.sel.primIndex);
	    if (doc.cm) {
	      regChange(doc.cm, doc.first, doc.first - distance, distance);
	      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++) {
	        regLineChange(doc.cm, l, "gutter");
	      }
	    }
	  }
	
	  // More lower-level change function, handling only a single document
	  // (not linked ones).
	  function makeChangeSingleDoc(doc, change, selAfter, spans) {
	    if (doc.cm && !doc.cm.curOp) {
	      return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
	    }
	
	    if (change.to.line < doc.first) {
	      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
	      return;
	    }
	    if (change.from.line > doc.lastLine()) {
	      return;
	    }
	
	    // Clip the change to the size of this doc
	    if (change.from.line < doc.first) {
	      var shift = change.text.length - 1 - (doc.first - change.from.line);
	      shiftDoc(doc, shift);
	      change = { from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	        text: [lst(change.text)], origin: change.origin };
	    }
	    var last = doc.lastLine();
	    if (change.to.line > last) {
	      change = { from: change.from, to: Pos(last, getLine(doc, last).text.length),
	        text: [change.text[0]], origin: change.origin };
	    }
	
	    change.removed = getBetween(doc, change.from, change.to);
	
	    if (!selAfter) {
	      selAfter = computeSelAfterChange(doc, change);
	    }
	    if (doc.cm) {
	      makeChangeSingleDocInEditor(doc.cm, change, spans);
	    } else {
	      updateDoc(doc, change, spans);
	    }
	    setSelectionNoUndo(doc, selAfter, sel_dontScroll);
	
	    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0))) {
	      doc.cantEdit = false;
	    }
	  }
	
	  // Handle the interaction of a change to a document with the editor
	  // that this document is part of.
	  function makeChangeSingleDocInEditor(cm, change, spans) {
	    var doc = cm.doc,
	        display = cm.display,
	        from = change.from,
	        to = change.to;
	
	    var recomputeMaxLength = false,
	        checkWidthStart = from.line;
	    if (!cm.options.lineWrapping) {
	      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
	      doc.iter(checkWidthStart, to.line + 1, function (line) {
	        if (line == display.maxLine) {
	          recomputeMaxLength = true;
	          return true;
	        }
	      });
	    }
	
	    if (doc.sel.contains(change.from, change.to) > -1) {
	      signalCursorActivity(cm);
	    }
	
	    updateDoc(doc, change, spans, estimateHeight(cm));
	
	    if (!cm.options.lineWrapping) {
	      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
	        var len = lineLength(line);
	        if (len > display.maxLineLength) {
	          display.maxLine = line;
	          display.maxLineLength = len;
	          display.maxLineChanged = true;
	          recomputeMaxLength = false;
	        }
	      });
	      if (recomputeMaxLength) {
	        cm.curOp.updateMaxLine = true;
	      }
	    }
	
	    retreatFrontier(doc, from.line);
	    startWorker(cm, 400);
	
	    var lendiff = change.text.length - (to.line - from.line) - 1;
	    // Remember that these lines changed, for updating the display
	    if (change.full) {
	      regChange(cm);
	    } else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) {
	      regLineChange(cm, from.line, "text");
	    } else {
	      regChange(cm, from.line, to.line + 1, lendiff);
	    }
	
	    var changesHandler = hasHandler(cm, "changes"),
	        changeHandler = hasHandler(cm, "change");
	    if (changeHandler || changesHandler) {
	      var obj = {
	        from: from, to: to,
	        text: change.text,
	        removed: change.removed,
	        origin: change.origin
	      };
	      if (changeHandler) {
	        signalLater(cm, "change", cm, obj);
	      }
	      if (changesHandler) {
	        (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
	      }
	    }
	    cm.display.selForContextMenu = null;
	  }
	
	  function _replaceRange(doc, code, from, to, origin) {
	    var assign;
	
	    if (!to) {
	      to = from;
	    }
	    if (cmp(to, from) < 0) {
	      assign = [to, from], from = assign[0], to = assign[1];
	    }
	    if (typeof code == "string") {
	      code = doc.splitLines(code);
	    }
	    makeChange(doc, { from: from, to: to, text: code, origin: origin });
	  }
	
	  // Rebasing/resetting history to deal with externally-sourced changes
	
	  function rebaseHistSelSingle(pos, from, to, diff) {
	    if (to < pos.line) {
	      pos.line += diff;
	    } else if (from < pos.line) {
	      pos.line = from;
	      pos.ch = 0;
	    }
	  }
	
	  // Tries to rebase an array of history events given a change in the
	  // document. If the change touches the same lines as the event, the
	  // event, and everything 'behind' it, is discarded. If the change is
	  // before the event, the event's positions are updated. Uses a
	  // copy-on-write scheme for the positions, to avoid having to
	  // reallocate them all on every rebase, but also avoid problems with
	  // shared position objects being unsafely updated.
	  function rebaseHistArray(array, from, to, diff) {
	    for (var i = 0; i < array.length; ++i) {
	      var sub = array[i],
	          ok = true;
	      if (sub.ranges) {
	        if (!sub.copied) {
	          sub = array[i] = sub.deepCopy();sub.copied = true;
	        }
	        for (var j = 0; j < sub.ranges.length; j++) {
	          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
	          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
	        }
	        continue;
	      }
	      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
	        var cur = sub.changes[j$1];
	        if (to < cur.from.line) {
	          cur.from = Pos(cur.from.line + diff, cur.from.ch);
	          cur.to = Pos(cur.to.line + diff, cur.to.ch);
	        } else if (from <= cur.to.line) {
	          ok = false;
	          break;
	        }
	      }
	      if (!ok) {
	        array.splice(0, i + 1);
	        i = 0;
	      }
	    }
	  }
	
	  function rebaseHist(hist, change) {
	    var from = change.from.line,
	        to = change.to.line,
	        diff = change.text.length - (to - from) - 1;
	    rebaseHistArray(hist.done, from, to, diff);
	    rebaseHistArray(hist.undone, from, to, diff);
	  }
	
	  // Utility for applying a change to a line by handle or number,
	  // returning the number and optionally registering the line as
	  // changed.
	  function changeLine(doc, handle, changeType, op) {
	    var no = handle,
	        line = handle;
	    if (typeof handle == "number") {
	      line = getLine(doc, clipLine(doc, handle));
	    } else {
	      no = lineNo(handle);
	    }
	    if (no == null) {
	      return null;
	    }
	    if (op(line, no) && doc.cm) {
	      regLineChange(doc.cm, no, changeType);
	    }
	    return line;
	  }
	
	  // The document is represented as a BTree consisting of leaves, with
	  // chunk of lines in them, and branches, with up to ten leaves or
	  // other branch nodes below them. The top node is always a branch
	  // node, and is the document object itself (meaning it has
	  // additional methods and properties).
	  //
	  // All nodes have parent links. The tree is used both to go from
	  // line numbers to line objects, and to go from objects to numbers.
	  // It also indexes by height, and is used to convert between height
	  // and line object, and to find the total height of the document.
	  //
	  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	  function LeafChunk(lines) {
	    this.lines = lines;
	    this.parent = null;
	    var height = 0;
	    for (var i = 0; i < lines.length; ++i) {
	      lines[i].parent = this;
	      height += lines[i].height;
	    }
	    this.height = height;
	  }
	
	  LeafChunk.prototype = {
	    chunkSize: function chunkSize() {
	      return this.lines.length;
	    },
	
	    // Remove the n lines at offset 'at'.
	    removeInner: function removeInner(at, n) {
	      for (var i = at, e = at + n; i < e; ++i) {
	        var line = this.lines[i];
	        this.height -= line.height;
	        cleanUpLine(line);
	        signalLater(line, "delete");
	      }
	      this.lines.splice(at, n);
	    },
	
	    // Helper used to collapse a small branch into a single leaf.
	    collapse: function collapse(lines) {
	      lines.push.apply(lines, this.lines);
	    },
	
	    // Insert the given array of lines at offset 'at', count them as
	    // having the given height.
	    insertInner: function insertInner(at, lines, height) {
	      this.height += height;
	      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
	      for (var i = 0; i < lines.length; ++i) {
	        lines[i].parent = this;
	      }
	    },
	
	    // Used to iterate over a part of the tree.
	    iterN: function iterN(at, n, op) {
	      for (var e = at + n; at < e; ++at) {
	        if (op(this.lines[at])) {
	          return true;
	        }
	      }
	    }
	  };
	
	  function BranchChunk(children) {
	    this.children = children;
	    var size = 0,
	        height = 0;
	    for (var i = 0; i < children.length; ++i) {
	      var ch = children[i];
	      size += ch.chunkSize();height += ch.height;
	      ch.parent = this;
	    }
	    this.size = size;
	    this.height = height;
	    this.parent = null;
	  }
	
	  BranchChunk.prototype = {
	    chunkSize: function chunkSize() {
	      return this.size;
	    },
	
	    removeInner: function removeInner(at, n) {
	      this.size -= n;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i],
	            sz = child.chunkSize();
	        if (at < sz) {
	          var rm = Math.min(n, sz - at),
	              oldHeight = child.height;
	          child.removeInner(at, rm);
	          this.height -= oldHeight - child.height;
	          if (sz == rm) {
	            this.children.splice(i--, 1);child.parent = null;
	          }
	          if ((n -= rm) == 0) {
	            break;
	          }
	          at = 0;
	        } else {
	          at -= sz;
	        }
	      }
	      // If the result is smaller than 25 lines, ensure that it is a
	      // single leaf node.
	      if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	        var lines = [];
	        this.collapse(lines);
	        this.children = [new LeafChunk(lines)];
	        this.children[0].parent = this;
	      }
	    },
	
	    collapse: function collapse(lines) {
	      for (var i = 0; i < this.children.length; ++i) {
	        this.children[i].collapse(lines);
	      }
	    },
	
	    insertInner: function insertInner(at, lines, height) {
	      this.size += lines.length;
	      this.height += height;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i],
	            sz = child.chunkSize();
	        if (at <= sz) {
	          child.insertInner(at, lines, height);
	          if (child.lines && child.lines.length > 50) {
	            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	            var remaining = child.lines.length % 25 + 25;
	            for (var pos = remaining; pos < child.lines.length;) {
	              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
	              child.height -= leaf.height;
	              this.children.splice(++i, 0, leaf);
	              leaf.parent = this;
	            }
	            child.lines = child.lines.slice(0, remaining);
	            this.maybeSpill();
	          }
	          break;
	        }
	        at -= sz;
	      }
	    },
	
	    // When a node has grown, check whether it should be split.
	    maybeSpill: function maybeSpill() {
	      if (this.children.length <= 10) {
	        return;
	      }
	      var me = this;
	      do {
	        var spilled = me.children.splice(me.children.length - 5, 5);
	        var sibling = new BranchChunk(spilled);
	        if (!me.parent) {
	          // Become the parent node
	          var copy = new BranchChunk(me.children);
	          copy.parent = me;
	          me.children = [copy, sibling];
	          me = copy;
	        } else {
	          me.size -= sibling.size;
	          me.height -= sibling.height;
	          var myIndex = indexOf(me.parent.children, me);
	          me.parent.children.splice(myIndex + 1, 0, sibling);
	        }
	        sibling.parent = me.parent;
	      } while (me.children.length > 10);
	      me.parent.maybeSpill();
	    },
	
	    iterN: function iterN(at, n, op) {
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i],
	            sz = child.chunkSize();
	        if (at < sz) {
	          var used = Math.min(n, sz - at);
	          if (child.iterN(at, used, op)) {
	            return true;
	          }
	          if ((n -= used) == 0) {
	            break;
	          }
	          at = 0;
	        } else {
	          at -= sz;
	        }
	      }
	    }
	  };
	
	  // Line widgets are block elements displayed above or below a line.
	
	  var LineWidget = function LineWidget(doc, node, options) {
	    if (options) {
	      for (var opt in options) {
	        if (options.hasOwnProperty(opt)) {
	          this[opt] = options[opt];
	        }
	      }
	    }
	    this.doc = doc;
	    this.node = node;
	  };
	
	  LineWidget.prototype.clear = function () {
	    var cm = this.doc.cm,
	        ws = this.line.widgets,
	        line = this.line,
	        no = lineNo(line);
	    if (no == null || !ws) {
	      return;
	    }
	    for (var i = 0; i < ws.length; ++i) {
	      if (ws[i] == this) {
	        ws.splice(i--, 1);
	      }
	    }
	    if (!ws.length) {
	      line.widgets = null;
	    }
	    var height = widgetHeight(this);
	    updateLineHeight(line, Math.max(0, line.height - height));
	    if (cm) {
	      runInOp(cm, function () {
	        adjustScrollWhenAboveVisible(cm, line, -height);
	        regLineChange(cm, no, "widget");
	      });
	      signalLater(cm, "lineWidgetCleared", cm, this, no);
	    }
	  };
	
	  LineWidget.prototype.changed = function () {
	    var this$1 = this;
	
	    var oldH = this.height,
	        cm = this.doc.cm,
	        line = this.line;
	    this.height = null;
	    var diff = widgetHeight(this) - oldH;
	    if (!diff) {
	      return;
	    }
	    if (!lineIsHidden(this.doc, line)) {
	      updateLineHeight(line, line.height + diff);
	    }
	    if (cm) {
	      runInOp(cm, function () {
	        cm.curOp.forceUpdate = true;
	        adjustScrollWhenAboveVisible(cm, line, diff);
	        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
	      });
	    }
	  };
	  eventMixin(LineWidget);
	
	  function adjustScrollWhenAboveVisible(cm, line, diff) {
	    if (_heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) {
	      addToScrollTop(cm, diff);
	    }
	  }
	
	  function addLineWidget(doc, handle, node, options) {
	    var widget = new LineWidget(doc, node, options);
	    var cm = doc.cm;
	    if (cm && widget.noHScroll) {
	      cm.display.alignWidgets = true;
	    }
	    changeLine(doc, handle, "widget", function (line) {
	      var widgets = line.widgets || (line.widgets = []);
	      if (widget.insertAt == null) {
	        widgets.push(widget);
	      } else {
	        widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget);
	      }
	      widget.line = line;
	      if (cm && !lineIsHidden(doc, line)) {
	        var aboveVisible = _heightAtLine(line) < doc.scrollTop;
	        updateLineHeight(line, line.height + widgetHeight(widget));
	        if (aboveVisible) {
	          addToScrollTop(cm, widget.height);
	        }
	        cm.curOp.forceUpdate = true;
	      }
	      return true;
	    });
	    if (cm) {
	      signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
	    }
	    return widget;
	  }
	
	  // TEXTMARKERS
	
	  // Created with markText and setBookmark methods. A TextMarker is a
	  // handle that can be used to clear or find a marked position in the
	  // document. Line objects hold arrays (markedSpans) containing
	  // {from, to, marker} object pointing to such marker objects, and
	  // indicating that such a marker is present on that line. Multiple
	  // lines may point to the same marker when it spans across lines.
	  // The spans will have null for their from/to properties when the
	  // marker continues beyond the start/end of the line. Markers have
	  // links back to the lines they currently touch.
	
	  // Collapsed markers have unique ids, in order to be able to order
	  // them, which is needed for uniquely determining an outer marker
	  // when they overlap (they may nest, but not partially overlap).
	  var nextMarkerId = 0;
	
	  var TextMarker = function TextMarker(doc, type) {
	    this.lines = [];
	    this.type = type;
	    this.doc = doc;
	    this.id = ++nextMarkerId;
	  };
	
	  // Clear the marker.
	  TextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) {
	      return;
	    }
	    var cm = this.doc.cm,
	        withOp = cm && !cm.curOp;
	    if (withOp) {
	      _startOperation(cm);
	    }
	    if (hasHandler(this, "clear")) {
	      var found = this.find();
	      if (found) {
	        signalLater(this, "clear", found.from, found.to);
	      }
	    }
	    var min = null,
	        max = null;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (cm && !this.collapsed) {
	        regLineChange(cm, lineNo(line), "text");
	      } else if (cm) {
	        if (span.to != null) {
	          max = lineNo(line);
	        }
	        if (span.from != null) {
	          min = lineNo(line);
	        }
	      }
	      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
	      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm) {
	        updateLineHeight(line, textHeight(cm.display));
	      }
	    }
	    if (cm && this.collapsed && !cm.options.lineWrapping) {
	      for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
	        var visual = visualLine(this.lines[i$1]),
	            len = lineLength(visual);
	        if (len > cm.display.maxLineLength) {
	          cm.display.maxLine = visual;
	          cm.display.maxLineLength = len;
	          cm.display.maxLineChanged = true;
	        }
	      }
	    }
	
	    if (min != null && cm && this.collapsed) {
	      regChange(cm, min, max + 1);
	    }
	    this.lines.length = 0;
	    this.explicitlyCleared = true;
	    if (this.atomic && this.doc.cantEdit) {
	      this.doc.cantEdit = false;
	      if (cm) {
	        reCheckSelection(cm.doc);
	      }
	    }
	    if (cm) {
	      signalLater(cm, "markerCleared", cm, this, min, max);
	    }
	    if (withOp) {
	      _endOperation(cm);
	    }
	    if (this.parent) {
	      this.parent.clear();
	    }
	  };
	
	  // Find the position of the marker in the document. Returns a {from,
	  // to} object by default. Side can be passed to get a specific side
	  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	  // Pos objects returned contain a line object, rather than a line
	  // number (used to prevent looking up the same line twice).
	  TextMarker.prototype.find = function (side, lineObj) {
	    if (side == null && this.type == "bookmark") {
	      side = 1;
	    }
	    var from, to;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (span.from != null) {
	        from = Pos(lineObj ? line : lineNo(line), span.from);
	        if (side == -1) {
	          return from;
	        }
	      }
	      if (span.to != null) {
	        to = Pos(lineObj ? line : lineNo(line), span.to);
	        if (side == 1) {
	          return to;
	        }
	      }
	    }
	    return from && { from: from, to: to };
	  };
	
	  // Signals that the marker's widget changed, and surrounding layout
	  // should be recomputed.
	  TextMarker.prototype.changed = function () {
	    var this$1 = this;
	
	    var pos = this.find(-1, true),
	        widget = this,
	        cm = this.doc.cm;
	    if (!pos || !cm) {
	      return;
	    }
	    runInOp(cm, function () {
	      var line = pos.line,
	          lineN = lineNo(pos.line);
	      var view = findViewForLine(cm, lineN);
	      if (view) {
	        clearLineMeasurementCacheFor(view);
	        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
	      }
	      cm.curOp.updateMaxLine = true;
	      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	        var oldHeight = widget.height;
	        widget.height = null;
	        var dHeight = widgetHeight(widget) - oldHeight;
	        if (dHeight) {
	          updateLineHeight(line, line.height + dHeight);
	        }
	      }
	      signalLater(cm, "markerChanged", cm, this$1);
	    });
	  };
	
	  TextMarker.prototype.attachLine = function (line) {
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;
	      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) {
	        (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
	      }
	    }
	    this.lines.push(line);
	  };
	
	  TextMarker.prototype.detachLine = function (line) {
	    this.lines.splice(indexOf(this.lines, line), 1);
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
	    }
	  };
	  eventMixin(TextMarker);
	
	  // Create a marker, wire it up to the right lines, and
	  function _markText(doc, from, to, options, type) {
	    // Shared markers (across linked documents) are handled separately
	    // (markTextShared will call out to this again, once per
	    // document).
	    if (options && options.shared) {
	      return markTextShared(doc, from, to, options, type);
	    }
	    // Ensure we are in an operation.
	    if (doc.cm && !doc.cm.curOp) {
	      return operation(doc.cm, _markText)(doc, from, to, options, type);
	    }
	
	    var marker = new TextMarker(doc, type),
	        diff = cmp(from, to);
	    if (options) {
	      copyObj(options, marker, false);
	    }
	    // Don't connect empty markers unless clearWhenEmpty is false
	    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) {
	      return marker;
	    }
	    if (marker.replacedWith) {
	      // Showing up as a widget implies collapsed (widget replaces text)
	      marker.collapsed = true;
	      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
	      if (!options.handleMouseEvents) {
	        marker.widgetNode.setAttribute("cm-ignore-events", "true");
	      }
	      if (options.insertLeft) {
	        marker.widgetNode.insertLeft = true;
	      }
	    }
	    if (marker.collapsed) {
	      if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) {
	        throw new Error("Inserting collapsed marker partially overlapping an existing one");
	      }
	      seeCollapsedSpans();
	    }
	
	    if (marker.addToHistory) {
	      addChangeToHistory(doc, { from: from, to: to, origin: "markText" }, doc.sel, NaN);
	    }
	
	    var curLine = from.line,
	        cm = doc.cm,
	        updateMaxLine;
	    doc.iter(curLine, to.line + 1, function (line) {
	      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) {
	        updateMaxLine = true;
	      }
	      if (marker.collapsed && curLine != from.line) {
	        updateLineHeight(line, 0);
	      }
	      addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
	      ++curLine;
	    });
	    // lineIsHidden depends on the presence of the spans, so needs a second pass
	    if (marker.collapsed) {
	      doc.iter(from.line, to.line + 1, function (line) {
	        if (lineIsHidden(doc, line)) {
	          updateLineHeight(line, 0);
	        }
	      });
	    }
	
	    if (marker.clearOnEnter) {
	      on(marker, "beforeCursorEnter", function () {
	        return marker.clear();
	      });
	    }
	
	    if (marker.readOnly) {
	      seeReadOnlySpans();
	      if (doc.history.done.length || doc.history.undone.length) {
	        doc.clearHistory();
	      }
	    }
	    if (marker.collapsed) {
	      marker.id = ++nextMarkerId;
	      marker.atomic = true;
	    }
	    if (cm) {
	      // Sync editor state
	      if (updateMaxLine) {
	        cm.curOp.updateMaxLine = true;
	      }
	      if (marker.collapsed) {
	        regChange(cm, from.line, to.line + 1);
	      } else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) {
	        for (var i = from.line; i <= to.line; i++) {
	          regLineChange(cm, i, "text");
	        }
	      }
	      if (marker.atomic) {
	        reCheckSelection(cm.doc);
	      }
	      signalLater(cm, "markerAdded", cm, marker);
	    }
	    return marker;
	  }
	
	  // SHARED TEXTMARKERS
	
	  // A shared marker spans multiple linked documents. It is
	  // implemented as a meta-marker-object controlling multiple normal
	  // markers.
	  var SharedTextMarker = function SharedTextMarker(markers, primary) {
	    this.markers = markers;
	    this.primary = primary;
	    for (var i = 0; i < markers.length; ++i) {
	      markers[i].parent = this;
	    }
	  };
	
	  SharedTextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) {
	      return;
	    }
	    this.explicitlyCleared = true;
	    for (var i = 0; i < this.markers.length; ++i) {
	      this.markers[i].clear();
	    }
	    signalLater(this, "clear");
	  };
	
	  SharedTextMarker.prototype.find = function (side, lineObj) {
	    return this.primary.find(side, lineObj);
	  };
	  eventMixin(SharedTextMarker);
	
	  function markTextShared(doc, from, to, options, type) {
	    options = copyObj(options);
	    options.shared = false;
	    var markers = [_markText(doc, from, to, options, type)],
	        primary = markers[0];
	    var widget = options.widgetNode;
	    linkedDocs(doc, function (doc) {
	      if (widget) {
	        options.widgetNode = widget.cloneNode(true);
	      }
	      markers.push(_markText(doc, _clipPos(doc, from), _clipPos(doc, to), options, type));
	      for (var i = 0; i < doc.linked.length; ++i) {
	        if (doc.linked[i].isParent) {
	          return;
	        }
	      }
	      primary = lst(markers);
	    });
	    return new SharedTextMarker(markers, primary);
	  }
	
	  function findSharedMarkers(doc) {
	    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) {
	      return m.parent;
	    });
	  }
	
	  function copySharedMarkers(doc, markers) {
	    for (var i = 0; i < markers.length; i++) {
	      var marker = markers[i],
	          pos = marker.find();
	      var mFrom = doc.clipPos(pos.from),
	          mTo = doc.clipPos(pos.to);
	      if (cmp(mFrom, mTo)) {
	        var subMark = _markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
	        marker.markers.push(subMark);
	        subMark.parent = marker;
	      }
	    }
	  }
	
	  function detachSharedMarkers(markers) {
	    var loop = function loop(i) {
	      var marker = markers[i],
	          linked = [marker.primary.doc];
	      linkedDocs(marker.primary.doc, function (d) {
	        return linked.push(d);
	      });
	      for (var j = 0; j < marker.markers.length; j++) {
	        var subMarker = marker.markers[j];
	        if (indexOf(linked, subMarker.doc) == -1) {
	          subMarker.parent = null;
	          marker.markers.splice(j--, 1);
	        }
	      }
	    };
	
	    for (var i = 0; i < markers.length; i++) {
	      loop(i);
	    }
	  }
	
	  var nextDocId = 0;
	  var Doc = function Doc(text, mode, firstLine, lineSep, direction) {
	    if (!(this instanceof Doc)) {
	      return new Doc(text, mode, firstLine, lineSep, direction);
	    }
	    if (firstLine == null) {
	      firstLine = 0;
	    }
	
	    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
	    this.first = firstLine;
	    this.scrollTop = this.scrollLeft = 0;
	    this.cantEdit = false;
	    this.cleanGeneration = 1;
	    this.modeFrontier = this.highlightFrontier = firstLine;
	    var start = Pos(firstLine, 0);
	    this.sel = simpleSelection(start);
	    this.history = new History(null);
	    this.id = ++nextDocId;
	    this.modeOption = mode;
	    this.lineSep = lineSep;
	    this.direction = direction == "rtl" ? "rtl" : "ltr";
	    this.extend = false;
	
	    if (typeof text == "string") {
	      text = this.splitLines(text);
	    }
	    updateDoc(this, { from: start, to: start, text: text });
	    setSelection(this, simpleSelection(start), sel_dontScroll);
	  };
	
	  Doc.prototype = createObj(BranchChunk.prototype, {
	    constructor: Doc,
	    // Iterate over the document. Supports two forms -- with only one
	    // argument, it calls that for each line in the document. With
	    // three, it iterates over the range given by the first two (with
	    // the second being non-inclusive).
	    iter: function iter(from, to, op) {
	      if (op) {
	        this.iterN(from - this.first, to - from, op);
	      } else {
	        this.iterN(this.first, this.first + this.size, from);
	      }
	    },
	
	    // Non-public interface for adding and removing lines.
	    insert: function insert(at, lines) {
	      var height = 0;
	      for (var i = 0; i < lines.length; ++i) {
	        height += lines[i].height;
	      }
	      this.insertInner(at - this.first, lines, height);
	    },
	    remove: function remove(at, n) {
	      this.removeInner(at - this.first, n);
	    },
	
	    // From here, the methods are part of the public interface. Most
	    // are also available from CodeMirror (editor) instances.
	
	    getValue: function getValue(lineSep) {
	      var lines = getLines(this, this.first, this.first + this.size);
	      if (lineSep === false) {
	        return lines;
	      }
	      return lines.join(lineSep || this.lineSeparator());
	    },
	    setValue: docMethodOp(function (code) {
	      var top = Pos(this.first, 0),
	          last = this.first + this.size - 1;
	      makeChange(this, { from: top, to: Pos(last, getLine(this, last).text.length),
	        text: this.splitLines(code), origin: "setValue", full: true }, true);
	      if (this.cm) {
	        scrollToCoords(this.cm, 0, 0);
	      }
	      setSelection(this, simpleSelection(top), sel_dontScroll);
	    }),
	    replaceRange: function replaceRange(code, from, to, origin) {
	      from = _clipPos(this, from);
	      to = to ? _clipPos(this, to) : from;
	      _replaceRange(this, code, from, to, origin);
	    },
	    getRange: function getRange(from, to, lineSep) {
	      var lines = getBetween(this, _clipPos(this, from), _clipPos(this, to));
	      if (lineSep === false) {
	        return lines;
	      }
	      if (lineSep === '') {
	        return lines.join('');
	      }
	      return lines.join(lineSep || this.lineSeparator());
	    },
	
	    getLine: function getLine(line) {
	      var l = this.getLineHandle(line);return l && l.text;
	    },
	
	    getLineHandle: function getLineHandle(line) {
	      if (isLine(this, line)) {
	        return getLine(this, line);
	      }
	    },
	    getLineNumber: function getLineNumber(line) {
	      return lineNo(line);
	    },
	
	    getLineHandleVisualStart: function getLineHandleVisualStart(line) {
	      if (typeof line == "number") {
	        line = getLine(this, line);
	      }
	      return visualLine(line);
	    },
	
	    lineCount: function lineCount() {
	      return this.size;
	    },
	    firstLine: function firstLine() {
	      return this.first;
	    },
	    lastLine: function lastLine() {
	      return this.first + this.size - 1;
	    },
	
	    clipPos: function clipPos(pos) {
	      return _clipPos(this, pos);
	    },
	
	    getCursor: function getCursor(start) {
	      var range = this.sel.primary(),
	          pos;
	      if (start == null || start == "head") {
	        pos = range.head;
	      } else if (start == "anchor") {
	        pos = range.anchor;
	      } else if (start == "end" || start == "to" || start === false) {
	        pos = range.to();
	      } else {
	        pos = range.from();
	      }
	      return pos;
	    },
	    listSelections: function listSelections() {
	      return this.sel.ranges;
	    },
	    somethingSelected: function somethingSelected() {
	      return this.sel.somethingSelected();
	    },
	
	    setCursor: docMethodOp(function (line, ch, options) {
	      setSimpleSelection(this, _clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
	    }),
	    setSelection: docMethodOp(function (anchor, head, options) {
	      setSimpleSelection(this, _clipPos(this, anchor), _clipPos(this, head || anchor), options);
	    }),
	    extendSelection: docMethodOp(function (head, other, options) {
	      extendSelection(this, _clipPos(this, head), other && _clipPos(this, other), options);
	    }),
	    extendSelections: docMethodOp(function (heads, options) {
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    extendSelectionsBy: docMethodOp(function (f, options) {
	      var heads = map(this.sel.ranges, f);
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    setSelections: docMethodOp(function (ranges, primary, options) {
	      if (!ranges.length) {
	        return;
	      }
	      var out = [];
	      for (var i = 0; i < ranges.length; i++) {
	        out[i] = new Range(_clipPos(this, ranges[i].anchor), _clipPos(this, ranges[i].head || ranges[i].anchor));
	      }
	      if (primary == null) {
	        primary = Math.min(ranges.length - 1, this.sel.primIndex);
	      }
	      setSelection(this, normalizeSelection(this.cm, out, primary), options);
	    }),
	    addSelection: docMethodOp(function (anchor, head, options) {
	      var ranges = this.sel.ranges.slice(0);
	      ranges.push(new Range(_clipPos(this, anchor), _clipPos(this, head || anchor)));
	      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
	    }),
	
	    getSelection: function getSelection(lineSep) {
	      var ranges = this.sel.ranges,
	          lines;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        lines = lines ? lines.concat(sel) : sel;
	      }
	      if (lineSep === false) {
	        return lines;
	      } else {
	        return lines.join(lineSep || this.lineSeparator());
	      }
	    },
	    getSelections: function getSelections(lineSep) {
	      var parts = [],
	          ranges = this.sel.ranges;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        if (lineSep !== false) {
	          sel = sel.join(lineSep || this.lineSeparator());
	        }
	        parts[i] = sel;
	      }
	      return parts;
	    },
	    replaceSelection: function replaceSelection(code, collapse, origin) {
	      var dup = [];
	      for (var i = 0; i < this.sel.ranges.length; i++) {
	        dup[i] = code;
	      }
	      this.replaceSelections(dup, collapse, origin || "+input");
	    },
	    replaceSelections: docMethodOp(function (code, collapse, origin) {
	      var changes = [],
	          sel = this.sel;
	      for (var i = 0; i < sel.ranges.length; i++) {
	        var range = sel.ranges[i];
	        changes[i] = { from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin };
	      }
	      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
	      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--) {
	        makeChange(this, changes[i$1]);
	      }
	      if (newSel) {
	        setSelectionReplaceHistory(this, newSel);
	      } else if (this.cm) {
	        ensureCursorVisible(this.cm);
	      }
	    }),
	    undo: docMethodOp(function () {
	      makeChangeFromHistory(this, "undo");
	    }),
	    redo: docMethodOp(function () {
	      makeChangeFromHistory(this, "redo");
	    }),
	    undoSelection: docMethodOp(function () {
	      makeChangeFromHistory(this, "undo", true);
	    }),
	    redoSelection: docMethodOp(function () {
	      makeChangeFromHistory(this, "redo", true);
	    }),
	
	    setExtending: function setExtending(val) {
	      this.extend = val;
	    },
	    getExtending: function getExtending() {
	      return this.extend;
	    },
	
	    historySize: function historySize() {
	      var hist = this.history,
	          done = 0,
	          undone = 0;
	      for (var i = 0; i < hist.done.length; i++) {
	        if (!hist.done[i].ranges) {
	          ++done;
	        }
	      }
	      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) {
	        if (!hist.undone[i$1].ranges) {
	          ++undone;
	        }
	      }
	      return { undo: done, redo: undone };
	    },
	    clearHistory: function clearHistory() {
	      var this$1 = this;
	
	      this.history = new History(this.history);
	      linkedDocs(this, function (doc) {
	        return doc.history = this$1.history;
	      }, true);
	    },
	
	    markClean: function markClean() {
	      this.cleanGeneration = this.changeGeneration(true);
	    },
	    changeGeneration: function changeGeneration(forceSplit) {
	      if (forceSplit) {
	        this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
	      }
	      return this.history.generation;
	    },
	    isClean: function isClean(gen) {
	      return this.history.generation == (gen || this.cleanGeneration);
	    },
	
	    getHistory: function getHistory() {
	      return { done: copyHistoryArray(this.history.done),
	        undone: copyHistoryArray(this.history.undone) };
	    },
	    setHistory: function setHistory(histData) {
	      var hist = this.history = new History(this.history);
	      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
	      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
	    },
	
	    setGutterMarker: docMethodOp(function (line, gutterID, value) {
	      return changeLine(this, line, "gutter", function (line) {
	        var markers = line.gutterMarkers || (line.gutterMarkers = {});
	        markers[gutterID] = value;
	        if (!value && isEmpty(markers)) {
	          line.gutterMarkers = null;
	        }
	        return true;
	      });
	    }),
	
	    clearGutter: docMethodOp(function (gutterID) {
	      var this$1 = this;
	
	      this.iter(function (line) {
	        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	          changeLine(this$1, line, "gutter", function () {
	            line.gutterMarkers[gutterID] = null;
	            if (isEmpty(line.gutterMarkers)) {
	              line.gutterMarkers = null;
	            }
	            return true;
	          });
	        }
	      });
	    }),
	
	    lineInfo: function lineInfo(line) {
	      var n;
	      if (typeof line == "number") {
	        if (!isLine(this, line)) {
	          return null;
	        }
	        n = line;
	        line = getLine(this, line);
	        if (!line) {
	          return null;
	        }
	      } else {
	        n = lineNo(line);
	        if (n == null) {
	          return null;
	        }
	      }
	      return { line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	        textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	        widgets: line.widgets };
	    },
	
	    addLineClass: docMethodOp(function (handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
	        if (!line[prop]) {
	          line[prop] = cls;
	        } else if (classTest(cls).test(line[prop])) {
	          return false;
	        } else {
	          line[prop] += " " + cls;
	        }
	        return true;
	      });
	    }),
	    removeLineClass: docMethodOp(function (handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
	        var cur = line[prop];
	        if (!cur) {
	          return false;
	        } else if (cls == null) {
	          line[prop] = null;
	        } else {
	          var found = cur.match(classTest(cls));
	          if (!found) {
	            return false;
	          }
	          var end = found.index + found[0].length;
	          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
	        }
	        return true;
	      });
	    }),
	
	    addLineWidget: docMethodOp(function (handle, node, options) {
	      return addLineWidget(this, handle, node, options);
	    }),
	    removeLineWidget: function removeLineWidget(widget) {
	      widget.clear();
	    },
	
	    markText: function markText(from, to, options) {
	      return _markText(this, _clipPos(this, from), _clipPos(this, to), options, options && options.type || "range");
	    },
	    setBookmark: function setBookmark(pos, options) {
	      var realOpts = { replacedWith: options && (options.nodeType == null ? options.widget : options),
	        insertLeft: options && options.insertLeft,
	        clearWhenEmpty: false, shared: options && options.shared,
	        handleMouseEvents: options && options.handleMouseEvents };
	      pos = _clipPos(this, pos);
	      return _markText(this, pos, pos, realOpts, "bookmark");
	    },
	    findMarksAt: function findMarksAt(pos) {
	      pos = _clipPos(this, pos);
	      var markers = [],
	          spans = getLine(this, pos.line).markedSpans;
	      if (spans) {
	        for (var i = 0; i < spans.length; ++i) {
	          var span = spans[i];
	          if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) {
	            markers.push(span.marker.parent || span.marker);
	          }
	        }
	      }
	      return markers;
	    },
	    findMarks: function findMarks(from, to, filter) {
	      from = _clipPos(this, from);to = _clipPos(this, to);
	      var found = [],
	          lineNo = from.line;
	      this.iter(from.line, to.line + 1, function (line) {
	        var spans = line.markedSpans;
	        if (spans) {
	          for (var i = 0; i < spans.length; i++) {
	            var span = spans[i];
	            if (!(span.to != null && lineNo == from.line && from.ch >= span.to || span.from == null && lineNo != from.line || span.from != null && lineNo == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) {
	              found.push(span.marker.parent || span.marker);
	            }
	          }
	        }
	        ++lineNo;
	      });
	      return found;
	    },
	    getAllMarks: function getAllMarks() {
	      var markers = [];
	      this.iter(function (line) {
	        var sps = line.markedSpans;
	        if (sps) {
	          for (var i = 0; i < sps.length; ++i) {
	            if (sps[i].from != null) {
	              markers.push(sps[i].marker);
	            }
	          }
	        }
	      });
	      return markers;
	    },
	
	    posFromIndex: function posFromIndex(off) {
	      var ch,
	          lineNo = this.first,
	          sepSize = this.lineSeparator().length;
	      this.iter(function (line) {
	        var sz = line.text.length + sepSize;
	        if (sz > off) {
	          ch = off;return true;
	        }
	        off -= sz;
	        ++lineNo;
	      });
	      return _clipPos(this, Pos(lineNo, ch));
	    },
	    indexFromPos: function indexFromPos(coords) {
	      coords = _clipPos(this, coords);
	      var index = coords.ch;
	      if (coords.line < this.first || coords.ch < 0) {
	        return 0;
	      }
	      var sepSize = this.lineSeparator().length;
	      this.iter(this.first, coords.line, function (line) {
	        // iter aborts when callback returns a truthy value
	        index += line.text.length + sepSize;
	      });
	      return index;
	    },
	
	    copy: function copy(copyHistory) {
	      var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
	      doc.scrollTop = this.scrollTop;doc.scrollLeft = this.scrollLeft;
	      doc.sel = this.sel;
	      doc.extend = false;
	      if (copyHistory) {
	        doc.history.undoDepth = this.history.undoDepth;
	        doc.setHistory(this.getHistory());
	      }
	      return doc;
	    },
	
	    linkedDoc: function linkedDoc(options) {
	      if (!options) {
	        options = {};
	      }
	      var from = this.first,
	          to = this.first + this.size;
	      if (options.from != null && options.from > from) {
	        from = options.from;
	      }
	      if (options.to != null && options.to < to) {
	        to = options.to;
	      }
	      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
	      if (options.sharedHist) {
	        copy.history = this.history;
	      }(this.linked || (this.linked = [])).push({ doc: copy, sharedHist: options.sharedHist });
	      copy.linked = [{ doc: this, isParent: true, sharedHist: options.sharedHist }];
	      copySharedMarkers(copy, findSharedMarkers(this));
	      return copy;
	    },
	    unlinkDoc: function unlinkDoc(other) {
	      if (other instanceof CodeMirror) {
	        other = other.doc;
	      }
	      if (this.linked) {
	        for (var i = 0; i < this.linked.length; ++i) {
	          var link = this.linked[i];
	          if (link.doc != other) {
	            continue;
	          }
	          this.linked.splice(i, 1);
	          other.unlinkDoc(this);
	          detachSharedMarkers(findSharedMarkers(this));
	          break;
	        }
	      }
	      // If the histories were shared, split them again
	      if (other.history == this.history) {
	        var splitIds = [other.id];
	        linkedDocs(other, function (doc) {
	          return splitIds.push(doc.id);
	        }, true);
	        other.history = new History(null);
	        other.history.done = copyHistoryArray(this.history.done, splitIds);
	        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
	      }
	    },
	    iterLinkedDocs: function iterLinkedDocs(f) {
	      linkedDocs(this, f);
	    },
	
	    getMode: function getMode() {
	      return this.mode;
	    },
	    getEditor: function getEditor() {
	      return this.cm;
	    },
	
	    splitLines: function splitLines(str) {
	      if (this.lineSep) {
	        return str.split(this.lineSep);
	      }
	      return splitLinesAuto(str);
	    },
	    lineSeparator: function lineSeparator() {
	      return this.lineSep || "\n";
	    },
	
	    setDirection: docMethodOp(function (dir) {
	      if (dir != "rtl") {
	        dir = "ltr";
	      }
	      if (dir == this.direction) {
	        return;
	      }
	      this.direction = dir;
	      this.iter(function (line) {
	        return line.order = null;
	      });
	      if (this.cm) {
	        directionChanged(this.cm);
	      }
	    })
	  });
	
	  // Public alias.
	  Doc.prototype.eachLine = Doc.prototype.iter;
	
	  // Kludge to work around strange IE behavior where it'll sometimes
	  // re-fire a series of drag-related events right after the drop (#1551)
	  var lastDrop = 0;
	
	  function onDrop(e) {
	    var cm = this;
	    clearDragCursor(cm);
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
	      return;
	    }
	    e_preventDefault(e);
	    if (ie) {
	      lastDrop = +new Date();
	    }
	    var pos = posFromMouse(cm, e, true),
	        files = e.dataTransfer.files;
	    if (!pos || cm.isReadOnly()) {
	      return;
	    }
	    // Might be a file drop, in which case we simply extract the text
	    // and insert it.
	    if (files && files.length && window.FileReader && window.File) {
	      var n = files.length,
	          text = Array(n),
	          read = 0;
	      var markAsReadAndPasteIfAllFilesAreRead = function markAsReadAndPasteIfAllFilesAreRead() {
	        if (++read == n) {
	          operation(cm, function () {
	            pos = _clipPos(cm.doc, pos);
	            var change = { from: pos, to: pos,
	              text: cm.doc.splitLines(text.filter(function (t) {
	                return t != null;
	              }).join(cm.doc.lineSeparator())),
	              origin: "paste" };
	            makeChange(cm.doc, change);
	            setSelectionReplaceHistory(cm.doc, simpleSelection(_clipPos(cm.doc, pos), _clipPos(cm.doc, changeEnd(change))));
	          })();
	        }
	      };
	      var readTextFromFile = function readTextFromFile(file, i) {
	        if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
	          markAsReadAndPasteIfAllFilesAreRead();
	          return;
	        }
	        var reader = new FileReader();
	        reader.onerror = function () {
	          return markAsReadAndPasteIfAllFilesAreRead();
	        };
	        reader.onload = function () {
	          var content = reader.result;
	          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
	            markAsReadAndPasteIfAllFilesAreRead();
	            return;
	          }
	          text[i] = content;
	          markAsReadAndPasteIfAllFilesAreRead();
	        };
	        reader.readAsText(file);
	      };
	      for (var i = 0; i < files.length; i++) {
	        readTextFromFile(files[i], i);
	      }
	    } else {
	      // Normal drop
	      // Don't do a replace if the drop happened inside of the selected text.
	      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	        cm.state.draggingText(e);
	        // Ensure the editor is re-focused
	        setTimeout(function () {
	          return cm.display.input.focus();
	        }, 20);
	        return;
	      }
	      try {
	        var text$1 = e.dataTransfer.getData("Text");
	        if (text$1) {
	          var selected;
	          if (cm.state.draggingText && !cm.state.draggingText.copy) {
	            selected = cm.listSelections();
	          }
	          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
	          if (selected) {
	            for (var i$1 = 0; i$1 < selected.length; ++i$1) {
	              _replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
	            }
	          }
	          cm.replaceSelection(text$1, "around", "paste");
	          cm.display.input.focus();
	        }
	      } catch (e$1) {}
	    }
	  }
	
	  function onDragStart(cm, e) {
	    if (ie && (!cm.state.draggingText || +new Date() - lastDrop < 100)) {
	      e_stop(e);return;
	    }
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
	      return;
	    }
	
	    e.dataTransfer.setData("Text", cm.getSelection());
	    e.dataTransfer.effectAllowed = "copyMove";
	
	    // Use dummy image instead of default browsers image.
	    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	    if (e.dataTransfer.setDragImage && !safari) {
	      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
	      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	      if (presto) {
	        img.width = img.height = 1;
	        cm.display.wrapper.appendChild(img);
	        // Force a relayout, or Opera won't use our image for some obscure reason
	        img._top = img.offsetTop;
	      }
	      e.dataTransfer.setDragImage(img, 0, 0);
	      if (presto) {
	        img.parentNode.removeChild(img);
	      }
	    }
	  }
	
	  function onDragOver(cm, e) {
	    var pos = posFromMouse(cm, e);
	    if (!pos) {
	      return;
	    }
	    var frag = document.createDocumentFragment();
	    drawSelectionCursor(cm, pos, frag);
	    if (!cm.display.dragCursor) {
	      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
	      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
	    }
	    removeChildrenAndAdd(cm.display.dragCursor, frag);
	  }
	
	  function clearDragCursor(cm) {
	    if (cm.display.dragCursor) {
	      cm.display.lineSpace.removeChild(cm.display.dragCursor);
	      cm.display.dragCursor = null;
	    }
	  }
	
	  // These must be handled carefully, because naively registering a
	  // handler for each editor will cause the editors to never be
	  // garbage collected.
	
	  function forEachCodeMirror(f) {
	    if (!document.getElementsByClassName) {
	      return;
	    }
	    var byClass = document.getElementsByClassName("CodeMirror"),
	        editors = [];
	    for (var i = 0; i < byClass.length; i++) {
	      var cm = byClass[i].CodeMirror;
	      if (cm) {
	        editors.push(cm);
	      }
	    }
	    if (editors.length) {
	      editors[0].operation(function () {
	        for (var i = 0; i < editors.length; i++) {
	          f(editors[i]);
	        }
	      });
	    }
	  }
	
	  var globalsRegistered = false;
	  function ensureGlobalHandlers() {
	    if (globalsRegistered) {
	      return;
	    }
	    registerGlobalHandlers();
	    globalsRegistered = true;
	  }
	  function registerGlobalHandlers() {
	    // When the window resizes, we need to refresh active editors.
	    var resizeTimer;
	    on(window, "resize", function () {
	      if (resizeTimer == null) {
	        resizeTimer = setTimeout(function () {
	          resizeTimer = null;
	          forEachCodeMirror(onResize);
	        }, 100);
	      }
	    });
	    // When the window loses focus, we want to show the editor as blurred
	    on(window, "blur", function () {
	      return forEachCodeMirror(onBlur);
	    });
	  }
	  // Called when the window resizes
	  function onResize(cm) {
	    var d = cm.display;
	    // Might be a text scaling operation, clear size caches.
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	    d.scrollbarsClipped = false;
	    cm.setSize();
	  }
	
	  var keyNames = {
	    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
	    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	    221: "]", 222: "'", 224: "Mod", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	  };
	
	  // Number keys
	  for (var i = 0; i < 10; i++) {
	    keyNames[i + 48] = keyNames[i + 96] = String(i);
	  }
	  // Alphabetic keys
	  for (var i$1 = 65; i$1 <= 90; i$1++) {
	    keyNames[i$1] = String.fromCharCode(i$1);
	  }
	  // Function keys
	  for (var i$2 = 1; i$2 <= 12; i$2++) {
	    keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
	  }
	
	  var keyMap = {};
	
	  keyMap.basic = {
	    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	    "Esc": "singleSelection"
	  };
	  // Note that the save and find-related commands aren't defined by
	  // default. User code or addons can define them. Unknown commands
	  // are simply ignored.
	  keyMap.pcDefault = {
	    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	    "fallthrough": "basic"
	  };
	  // Very basic readline/emacs-style bindings, which are standard on Mac.
	  keyMap.emacsy = {
	    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	    "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd", "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp",
	    "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine",
	    "Ctrl-T": "transposeChars", "Ctrl-O": "openLine"
	  };
	  keyMap.macDefault = {
	    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	    "fallthrough": ["basic", "emacsy"]
	  };
	  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
	
	  // KEYMAP DISPATCH
	
	  function normalizeKeyName(name) {
	    var parts = name.split(/-(?!$)/);
	    name = parts[parts.length - 1];
	    var alt, ctrl, shift, cmd;
	    for (var i = 0; i < parts.length - 1; i++) {
	      var mod = parts[i];
	      if (/^(cmd|meta|m)$/i.test(mod)) {
	        cmd = true;
	      } else if (/^a(lt)?$/i.test(mod)) {
	        alt = true;
	      } else if (/^(c|ctrl|control)$/i.test(mod)) {
	        ctrl = true;
	      } else if (/^s(hift)?$/i.test(mod)) {
	        shift = true;
	      } else {
	        throw new Error("Unrecognized modifier name: " + mod);
	      }
	    }
	    if (alt) {
	      name = "Alt-" + name;
	    }
	    if (ctrl) {
	      name = "Ctrl-" + name;
	    }
	    if (cmd) {
	      name = "Cmd-" + name;
	    }
	    if (shift) {
	      name = "Shift-" + name;
	    }
	    return name;
	  }
	
	  // This is a kludge to keep keymaps mostly working as raw objects
	  // (backwards compatibility) while at the same time support features
	  // like normalization and multi-stroke key bindings. It compiles a
	  // new normalized keymap, and then updates the old object to reflect
	  // this.
	  function normalizeKeyMap(keymap) {
	    var copy = {};
	    for (var keyname in keymap) {
	      if (keymap.hasOwnProperty(keyname)) {
	        var value = keymap[keyname];
	        if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) {
	          continue;
	        }
	        if (value == "...") {
	          delete keymap[keyname];continue;
	        }
	
	        var keys = map(keyname.split(" "), normalizeKeyName);
	        for (var i = 0; i < keys.length; i++) {
	          var val = void 0,
	              name = void 0;
	          if (i == keys.length - 1) {
	            name = keys.join(" ");
	            val = value;
	          } else {
	            name = keys.slice(0, i + 1).join(" ");
	            val = "...";
	          }
	          var prev = copy[name];
	          if (!prev) {
	            copy[name] = val;
	          } else if (prev != val) {
	            throw new Error("Inconsistent bindings for " + name);
	          }
	        }
	        delete keymap[keyname];
	      }
	    }
	    for (var prop in copy) {
	      keymap[prop] = copy[prop];
	    }
	    return keymap;
	  }
	
	  function lookupKey(key, map, handle, context) {
	    map = getKeyMap(map);
	    var found = map.call ? map.call(key, context) : map[key];
	    if (found === false) {
	      return "nothing";
	    }
	    if (found === "...") {
	      return "multi";
	    }
	    if (found != null && handle(found)) {
	      return "handled";
	    }
	
	    if (map.fallthrough) {
	      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]") {
	        return lookupKey(key, map.fallthrough, handle, context);
	      }
	      for (var i = 0; i < map.fallthrough.length; i++) {
	        var result = lookupKey(key, map.fallthrough[i], handle, context);
	        if (result) {
	          return result;
	        }
	      }
	    }
	  }
	
	  // Modifier key presses don't count as 'real' key presses for the
	  // purpose of keymap fallthrough.
	  function isModifierKey(value) {
	    var name = typeof value == "string" ? value : keyNames[value.keyCode];
	    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
	  }
	
	  function addModifierNames(name, event, noShift) {
	    var base = name;
	    if (event.altKey && base != "Alt") {
	      name = "Alt-" + name;
	    }
	    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") {
	      name = "Ctrl-" + name;
	    }
	    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") {
	      name = "Cmd-" + name;
	    }
	    if (!noShift && event.shiftKey && base != "Shift") {
	      name = "Shift-" + name;
	    }
	    return name;
	  }
	
	  // Look up the name of a key as indicated by an event object.
	  function keyName(event, noShift) {
	    if (presto && event.keyCode == 34 && event["char"]) {
	      return false;
	    }
	    var name = keyNames[event.keyCode];
	    if (name == null || event.altGraphKey) {
	      return false;
	    }
	    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
	    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
	    if (event.keyCode == 3 && event.code) {
	      name = event.code;
	    }
	    return addModifierNames(name, event, noShift);
	  }
	
	  function getKeyMap(val) {
	    return typeof val == "string" ? keyMap[val] : val;
	  }
	
	  // Helper for deleting text near the selection(s), used to implement
	  // backspace, delete, and similar functionality.
	  function deleteNearSelection(cm, compute) {
	    var ranges = cm.doc.sel.ranges,
	        kill = [];
	    // Build up a set of ranges to kill first, merging overlapping
	    // ranges.
	    for (var i = 0; i < ranges.length; i++) {
	      var toKill = compute(ranges[i]);
	      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	        var replaced = kill.pop();
	        if (cmp(replaced.from, toKill.from) < 0) {
	          toKill.from = replaced.from;
	          break;
	        }
	      }
	      kill.push(toKill);
	    }
	    // Next, remove those actual ranges.
	    runInOp(cm, function () {
	      for (var i = kill.length - 1; i >= 0; i--) {
	        _replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
	      }
	      ensureCursorVisible(cm);
	    });
	  }
	
	  function moveCharLogically(line, ch, dir) {
	    var target = skipExtendingChars(line.text, ch + dir, dir);
	    return target < 0 || target > line.text.length ? null : target;
	  }
	
	  function moveLogically(line, start, dir) {
	    var ch = moveCharLogically(line, start.ch, dir);
	    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
	  }
	
	  function endOfLine(visually, cm, lineObj, lineNo, dir) {
	    if (visually) {
	      if (cm.doc.direction == "rtl") {
	        dir = -dir;
	      }
	      var order = getOrder(lineObj, cm.doc.direction);
	      if (order) {
	        var part = dir < 0 ? lst(order) : order[0];
	        var moveInStorageOrder = dir < 0 == (part.level == 1);
	        var sticky = moveInStorageOrder ? "after" : "before";
	        var ch;
	        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
	        // it could be that the last bidi part is not on the last visual line,
	        // since visual lines contain content order-consecutive chunks.
	        // Thus, in rtl, we are looking for the first (content-order) character
	        // in the rtl chunk that is on the last line (that is, the same line
	        // as the last (content-order) character).
	        if (part.level > 0 || cm.doc.direction == "rtl") {
	          var prep = prepareMeasureForLine(cm, lineObj);
	          ch = dir < 0 ? lineObj.text.length - 1 : 0;
	          var targetTop = measureCharPrepared(cm, prep, ch).top;
	          ch = findFirst(function (ch) {
	            return measureCharPrepared(cm, prep, ch).top == targetTop;
	          }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
	          if (sticky == "before") {
	            ch = moveCharLogically(lineObj, ch, 1);
	          }
	        } else {
	          ch = dir < 0 ? part.to : part.from;
	        }
	        return new Pos(lineNo, ch, sticky);
	      }
	    }
	    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
	  }
	
	  function moveVisually(cm, line, start, dir) {
	    var bidi = getOrder(line, cm.doc.direction);
	    if (!bidi) {
	      return moveLogically(line, start, dir);
	    }
	    if (start.ch >= line.text.length) {
	      start.ch = line.text.length;
	      start.sticky = "before";
	    } else if (start.ch <= 0) {
	      start.ch = 0;
	      start.sticky = "after";
	    }
	    var partPos = getBidiPartAt(bidi, start.ch, start.sticky),
	        part = bidi[partPos];
	    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
	      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
	      // nothing interesting happens.
	      return moveLogically(line, start, dir);
	    }
	
	    var mv = function mv(pos, dir) {
	      return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir);
	    };
	    var prep;
	    var getWrappedLineExtent = function getWrappedLineExtent(ch) {
	      if (!cm.options.lineWrapping) {
	        return { begin: 0, end: line.text.length };
	      }
	      prep = prep || prepareMeasureForLine(cm, line);
	      return wrappedLineExtentChar(cm, line, prep, ch);
	    };
	    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
	
	    if (cm.doc.direction == "rtl" || part.level == 1) {
	      var moveInStorageOrder = part.level == 1 == dir < 0;
	      var ch = mv(start, moveInStorageOrder ? 1 : -1);
	      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
	        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
	        var sticky = moveInStorageOrder ? "before" : "after";
	        return new Pos(start.line, ch, sticky);
	      }
	    }
	
	    // Case 3: Could not move within this bidi part in this visual line, so leave
	    // the current bidi part
	
	    var searchInVisualLine = function searchInVisualLine(partPos, dir, wrappedLineExtent) {
	      var getRes = function getRes(ch, moveInStorageOrder) {
	        return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
	      };
	
	      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
	        var part = bidi[partPos];
	        var moveInStorageOrder = dir > 0 == (part.level != 1);
	        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
	        if (part.from <= ch && ch < part.to) {
	          return getRes(ch, moveInStorageOrder);
	        }
	        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
	        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) {
	          return getRes(ch, moveInStorageOrder);
	        }
	      }
	    };
	
	    // Case 3a: Look for other bidi parts on the same visual line
	    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
	    if (res) {
	      return res;
	    }
	
	    // Case 3b: Look for other bidi parts on the next visual line
	    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
	    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
	      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
	      if (res) {
	        return res;
	      }
	    }
	
	    // Case 4: Nowhere to move
	    return null;
	  }
	
	  // Commands are parameter-less actions that can be performed on an
	  // editor, mostly used for keybindings.
	  var commands = {
	    selectAll: selectAll,
	    singleSelection: function singleSelection(cm) {
	      return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
	    },
	    killLine: function killLine(cm) {
	      return deleteNearSelection(cm, function (range) {
	        if (range.empty()) {
	          var len = getLine(cm.doc, range.head.line).text.length;
	          if (range.head.ch == len && range.head.line < cm.lastLine()) {
	            return { from: range.head, to: Pos(range.head.line + 1, 0) };
	          } else {
	            return { from: range.head, to: Pos(range.head.line, len) };
	          }
	        } else {
	          return { from: range.from(), to: range.to() };
	        }
	      });
	    },
	    deleteLine: function deleteLine(cm) {
	      return deleteNearSelection(cm, function (range) {
	        return {
	          from: Pos(range.from().line, 0),
	          to: _clipPos(cm.doc, Pos(range.to().line + 1, 0))
	        };
	      });
	    },
	    delLineLeft: function delLineLeft(cm) {
	      return deleteNearSelection(cm, function (range) {
	        return {
	          from: Pos(range.from().line, 0), to: range.from()
	        };
	      });
	    },
	    delWrappedLineLeft: function delWrappedLineLeft(cm) {
	      return deleteNearSelection(cm, function (range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var leftPos = cm.coordsChar({ left: 0, top: top }, "div");
	        return { from: leftPos, to: range.from() };
	      });
	    },
	    delWrappedLineRight: function delWrappedLineRight(cm) {
	      return deleteNearSelection(cm, function (range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var rightPos = cm.coordsChar({ left: cm.display.lineDiv.offsetWidth + 100, top: top }, "div");
	        return { from: range.from(), to: rightPos };
	      });
	    },
	    undo: function undo(cm) {
	      return cm.undo();
	    },
	    redo: function redo(cm) {
	      return cm.redo();
	    },
	    undoSelection: function undoSelection(cm) {
	      return cm.undoSelection();
	    },
	    redoSelection: function redoSelection(cm) {
	      return cm.redoSelection();
	    },
	    goDocStart: function goDocStart(cm) {
	      return cm.extendSelection(Pos(cm.firstLine(), 0));
	    },
	    goDocEnd: function goDocEnd(cm) {
	      return cm.extendSelection(Pos(cm.lastLine()));
	    },
	    goLineStart: function goLineStart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineStart(cm, range.head.line);
	      }, { origin: "+move", bias: 1 });
	    },
	    goLineStartSmart: function goLineStartSmart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineStartSmart(cm, range.head);
	      }, { origin: "+move", bias: 1 });
	    },
	    goLineEnd: function goLineEnd(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineEnd(cm, range.head.line);
	      }, { origin: "+move", bias: -1 });
	    },
	    goLineRight: function goLineRight(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        return cm.coordsChar({ left: cm.display.lineDiv.offsetWidth + 100, top: top }, "div");
	      }, sel_move);
	    },
	    goLineLeft: function goLineLeft(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        return cm.coordsChar({ left: 0, top: top }, "div");
	      }, sel_move);
	    },
	    goLineLeftSmart: function goLineLeftSmart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        var pos = cm.coordsChar({ left: 0, top: top }, "div");
	        if (pos.ch < cm.getLine(pos.line).search(/\S/)) {
	          return lineStartSmart(cm, range.head);
	        }
	        return pos;
	      }, sel_move);
	    },
	    goLineUp: function goLineUp(cm) {
	      return cm.moveV(-1, "line");
	    },
	    goLineDown: function goLineDown(cm) {
	      return cm.moveV(1, "line");
	    },
	    goPageUp: function goPageUp(cm) {
	      return cm.moveV(-1, "page");
	    },
	    goPageDown: function goPageDown(cm) {
	      return cm.moveV(1, "page");
	    },
	    goCharLeft: function goCharLeft(cm) {
	      return cm.moveH(-1, "char");
	    },
	    goCharRight: function goCharRight(cm) {
	      return cm.moveH(1, "char");
	    },
	    goColumnLeft: function goColumnLeft(cm) {
	      return cm.moveH(-1, "column");
	    },
	    goColumnRight: function goColumnRight(cm) {
	      return cm.moveH(1, "column");
	    },
	    goWordLeft: function goWordLeft(cm) {
	      return cm.moveH(-1, "word");
	    },
	    goGroupRight: function goGroupRight(cm) {
	      return cm.moveH(1, "group");
	    },
	    goGroupLeft: function goGroupLeft(cm) {
	      return cm.moveH(-1, "group");
	    },
	    goWordRight: function goWordRight(cm) {
	      return cm.moveH(1, "word");
	    },
	    delCharBefore: function delCharBefore(cm) {
	      return cm.deleteH(-1, "codepoint");
	    },
	    delCharAfter: function delCharAfter(cm) {
	      return cm.deleteH(1, "char");
	    },
	    delWordBefore: function delWordBefore(cm) {
	      return cm.deleteH(-1, "word");
	    },
	    delWordAfter: function delWordAfter(cm) {
	      return cm.deleteH(1, "word");
	    },
	    delGroupBefore: function delGroupBefore(cm) {
	      return cm.deleteH(-1, "group");
	    },
	    delGroupAfter: function delGroupAfter(cm) {
	      return cm.deleteH(1, "group");
	    },
	    indentAuto: function indentAuto(cm) {
	      return cm.indentSelection("smart");
	    },
	    indentMore: function indentMore(cm) {
	      return cm.indentSelection("add");
	    },
	    indentLess: function indentLess(cm) {
	      return cm.indentSelection("subtract");
	    },
	    insertTab: function insertTab(cm) {
	      return cm.replaceSelection("\t");
	    },
	    insertSoftTab: function insertSoftTab(cm) {
	      var spaces = [],
	          ranges = cm.listSelections(),
	          tabSize = cm.options.tabSize;
	      for (var i = 0; i < ranges.length; i++) {
	        var pos = ranges[i].from();
	        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
	        spaces.push(spaceStr(tabSize - col % tabSize));
	      }
	      cm.replaceSelections(spaces);
	    },
	    defaultTab: function defaultTab(cm) {
	      if (cm.somethingSelected()) {
	        cm.indentSelection("add");
	      } else {
	        cm.execCommand("insertTab");
	      }
	    },
	    // Swap the two chars left and right of each selection's head.
	    // Move cursor behind the two swapped characters afterwards.
	    //
	    // Doesn't consider line feeds a character.
	    // Doesn't scan more than one line above to find a character.
	    // Doesn't do anything on an empty line.
	    // Doesn't do anything with non-empty selections.
	    transposeChars: function transposeChars(cm) {
	      return runInOp(cm, function () {
	        var ranges = cm.listSelections(),
	            newSel = [];
	        for (var i = 0; i < ranges.length; i++) {
	          if (!ranges[i].empty()) {
	            continue;
	          }
	          var cur = ranges[i].head,
	              line = getLine(cm.doc, cur.line).text;
	          if (line) {
	            if (cur.ch == line.length) {
	              cur = new Pos(cur.line, cur.ch - 1);
	            }
	            if (cur.ch > 0) {
	              cur = new Pos(cur.line, cur.ch + 1);
	              cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
	            } else if (cur.line > cm.doc.first) {
	              var prev = getLine(cm.doc, cur.line - 1).text;
	              if (prev) {
	                cur = new Pos(cur.line, 1);
	                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
	              }
	            }
	          }
	          newSel.push(new Range(cur, cur));
	        }
	        cm.setSelections(newSel);
	      });
	    },
	    newlineAndIndent: function newlineAndIndent(cm) {
	      return runInOp(cm, function () {
	        var sels = cm.listSelections();
	        for (var i = sels.length - 1; i >= 0; i--) {
	          cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
	        }
	        sels = cm.listSelections();
	        for (var i$1 = 0; i$1 < sels.length; i$1++) {
	          cm.indentLine(sels[i$1].from().line, null, true);
	        }
	        ensureCursorVisible(cm);
	      });
	    },
	    openLine: function openLine(cm) {
	      return cm.replaceSelection("\n", "start");
	    },
	    toggleOverwrite: function toggleOverwrite(cm) {
	      return cm.toggleOverwrite();
	    }
	  };
	
	  function lineStart(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLine(line);
	    if (visual != line) {
	      lineN = lineNo(visual);
	    }
	    return endOfLine(true, cm, visual, lineN, 1);
	  }
	  function lineEnd(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLineEnd(line);
	    if (visual != line) {
	      lineN = lineNo(visual);
	    }
	    return endOfLine(true, cm, line, lineN, -1);
	  }
	  function lineStartSmart(cm, pos) {
	    var start = lineStart(cm, pos.line);
	    var line = getLine(cm.doc, start.line);
	    var order = getOrder(line, cm.doc.direction);
	    if (!order || order[0].level == 0) {
	      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
	      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
	      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
	    }
	    return start;
	  }
	
	  // Run a handler that was bound to a key.
	  function doHandleBinding(cm, bound, dropShift) {
	    if (typeof bound == "string") {
	      bound = commands[bound];
	      if (!bound) {
	        return false;
	      }
	    }
	    // Ensure previous input has been read, so that the handler sees a
	    // consistent view of the document
	    cm.display.input.ensurePolled();
	    var prevShift = cm.display.shift,
	        done = false;
	    try {
	      if (cm.isReadOnly()) {
	        cm.state.suppressEdits = true;
	      }
	      if (dropShift) {
	        cm.display.shift = false;
	      }
	      done = bound(cm) != Pass;
	    } finally {
	      cm.display.shift = prevShift;
	      cm.state.suppressEdits = false;
	    }
	    return done;
	  }
	
	  function lookupKeyForEditor(cm, name, handle) {
	    for (var i = 0; i < cm.state.keyMaps.length; i++) {
	      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
	      if (result) {
	        return result;
	      }
	    }
	    return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
	  }
	
	  // Note that, despite the name, this function is also used to check
	  // for bound mouse clicks.
	
	  var stopSeq = new Delayed();
	
	  function dispatchKey(cm, name, e, handle) {
	    var seq = cm.state.keySeq;
	    if (seq) {
	      if (isModifierKey(name)) {
	        return "handled";
	      }
	      if (/\'$/.test(name)) {
	        cm.state.keySeq = null;
	      } else {
	        stopSeq.set(50, function () {
	          if (cm.state.keySeq == seq) {
	            cm.state.keySeq = null;
	            cm.display.input.reset();
	          }
	        });
	      }
	      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) {
	        return true;
	      }
	    }
	    return dispatchKeyInner(cm, name, e, handle);
	  }
	
	  function dispatchKeyInner(cm, name, e, handle) {
	    var result = lookupKeyForEditor(cm, name, handle);
	
	    if (result == "multi") {
	      cm.state.keySeq = name;
	    }
	    if (result == "handled") {
	      signalLater(cm, "keyHandled", cm, name, e);
	    }
	
	    if (result == "handled" || result == "multi") {
	      e_preventDefault(e);
	      restartBlink(cm);
	    }
	
	    return !!result;
	  }
	
	  // Handle a key from the keydown event.
	  function handleKeyBinding(cm, e) {
	    var name = keyName(e, true);
	    if (!name) {
	      return false;
	    }
	
	    if (e.shiftKey && !cm.state.keySeq) {
	      // First try to resolve full name (including 'Shift-'). Failing
	      // that, see if there is a cursor-motion command (starting with
	      // 'go') bound to the keyname without 'Shift-'.
	      return dispatchKey(cm, "Shift-" + name, e, function (b) {
	        return doHandleBinding(cm, b, true);
	      }) || dispatchKey(cm, name, e, function (b) {
	        if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) {
	          return doHandleBinding(cm, b);
	        }
	      });
	    } else {
	      return dispatchKey(cm, name, e, function (b) {
	        return doHandleBinding(cm, b);
	      });
	    }
	  }
	
	  // Handle a key from the keypress event
	  function handleCharBinding(cm, e, ch) {
	    return dispatchKey(cm, "'" + ch + "'", e, function (b) {
	      return doHandleBinding(cm, b, true);
	    });
	  }
	
	  var lastStoppedKey = null;
	  function onKeyDown(e) {
	    var cm = this;
	    if (e.target && e.target != cm.display.input.getField()) {
	      return;
	    }
	    cm.curOp.focus = activeElt(root(cm));
	    if (signalDOMEvent(cm, e)) {
	      return;
	    }
	    // IE does strange things with escape.
	    if (ie && ie_version < 11 && e.keyCode == 27) {
	      e.returnValue = false;
	    }
	    var code = e.keyCode;
	    cm.display.shift = code == 16 || e.shiftKey;
	    var handled = handleKeyBinding(cm, e);
	    if (presto) {
	      lastStoppedKey = handled ? code : null;
	      // Opera has no cut event... we try to at least catch the key combo
	      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) {
	        cm.replaceSelection("", null, "cut");
	      }
	    }
	    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand) {
	      document.execCommand("cut");
	    }
	
	    // Turn mouse into crosshair when Alt is held on Mac.
	    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) {
	      showCrossHair(cm);
	    }
	  }
	
	  function showCrossHair(cm) {
	    var lineDiv = cm.display.lineDiv;
	    addClass(lineDiv, "CodeMirror-crosshair");
	
	    function up(e) {
	      if (e.keyCode == 18 || !e.altKey) {
	        rmClass(lineDiv, "CodeMirror-crosshair");
	        off(document, "keyup", up);
	        off(document, "mouseover", up);
	      }
	    }
	    on(document, "keyup", up);
	    on(document, "mouseover", up);
	  }
	
	  function onKeyUp(e) {
	    if (e.keyCode == 16) {
	      this.doc.sel.shift = false;
	    }
	    signalDOMEvent(this, e);
	  }
	
	  function onKeyPress(e) {
	    var cm = this;
	    if (e.target && e.target != cm.display.input.getField()) {
	      return;
	    }
	    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) {
	      return;
	    }
	    var keyCode = e.keyCode,
	        charCode = e.charCode;
	    if (presto && keyCode == lastStoppedKey) {
	      lastStoppedKey = null;e_preventDefault(e);return;
	    }
	    if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) {
	      return;
	    }
	    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
	    // Some browsers fire keypress events for backspace
	    if (ch == "\x08") {
	      return;
	    }
	    if (handleCharBinding(cm, e, ch)) {
	      return;
	    }
	    cm.display.input.onKeyPress(e);
	  }
	
	  var DOUBLECLICK_DELAY = 400;
	
	  var PastClick = function PastClick(time, pos, button) {
	    this.time = time;
	    this.pos = pos;
	    this.button = button;
	  };
	
	  PastClick.prototype.compare = function (time, pos, button) {
	    return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
	  };
	
	  var lastClick, lastDoubleClick;
	  function clickRepeat(pos, button) {
	    var now = +new Date();
	    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
	      lastClick = lastDoubleClick = null;
	      return "triple";
	    } else if (lastClick && lastClick.compare(now, pos, button)) {
	      lastDoubleClick = new PastClick(now, pos, button);
	      lastClick = null;
	      return "double";
	    } else {
	      lastClick = new PastClick(now, pos, button);
	      lastDoubleClick = null;
	      return "single";
	    }
	  }
	
	  // A mouse down can be a single click, double click, triple click,
	  // start of selection drag, start of text drag, new cursor
	  // (ctrl-click), rectangle drag (alt-drag), or xwin
	  // middle-click-paste. Or it might be a click on something we should
	  // not interfere with, such as a scrollbar or widget.
	  function onMouseDown(e) {
	    var cm = this,
	        display = cm.display;
	    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) {
	      return;
	    }
	    display.input.ensurePolled();
	    display.shift = e.shiftKey;
	
	    if (eventInWidget(display, e)) {
	      if (!webkit) {
	        // Briefly turn off draggability, to allow widgets to do
	        // normal dragging things.
	        display.scroller.draggable = false;
	        setTimeout(function () {
	          return display.scroller.draggable = true;
	        }, 100);
	      }
	      return;
	    }
	    if (clickInGutter(cm, e)) {
	      return;
	    }
	    var pos = posFromMouse(cm, e),
	        button = e_button(e),
	        repeat = pos ? clickRepeat(pos, button) : "single";
	    win(cm).focus();
	
	    // #3261: make sure, that we're not starting a second selection
	    if (button == 1 && cm.state.selectingText) {
	      cm.state.selectingText(e);
	    }
	
	    if (pos && handleMappedButton(cm, button, pos, repeat, e)) {
	      return;
	    }
	
	    if (button == 1) {
	      if (pos) {
	        leftButtonDown(cm, pos, repeat, e);
	      } else if (e_target(e) == display.scroller) {
	        e_preventDefault(e);
	      }
	    } else if (button == 2) {
	      if (pos) {
	        extendSelection(cm.doc, pos);
	      }
	      setTimeout(function () {
	        return display.input.focus();
	      }, 20);
	    } else if (button == 3) {
	      if (captureRightClick) {
	        cm.display.input.onContextMenu(e);
	      } else {
	        delayBlurEvent(cm);
	      }
	    }
	  }
	
	  function handleMappedButton(cm, button, pos, repeat, event) {
	    var name = "Click";
	    if (repeat == "double") {
	      name = "Double" + name;
	    } else if (repeat == "triple") {
	      name = "Triple" + name;
	    }
	    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
	
	    return dispatchKey(cm, addModifierNames(name, event), event, function (bound) {
	      if (typeof bound == "string") {
	        bound = commands[bound];
	      }
	      if (!bound) {
	        return false;
	      }
	      var done = false;
	      try {
	        if (cm.isReadOnly()) {
	          cm.state.suppressEdits = true;
	        }
	        done = bound(cm, pos) != Pass;
	      } finally {
	        cm.state.suppressEdits = false;
	      }
	      return done;
	    });
	  }
	
	  function configureMouse(cm, repeat, event) {
	    var option = cm.getOption("configureMouse");
	    var value = option ? option(cm, repeat, event) : {};
	    if (value.unit == null) {
	      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
	      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
	    }
	    if (value.extend == null || cm.doc.extend) {
	      value.extend = cm.doc.extend || event.shiftKey;
	    }
	    if (value.addNew == null) {
	      value.addNew = mac ? event.metaKey : event.ctrlKey;
	    }
	    if (value.moveOnDrag == null) {
	      value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
	    }
	    return value;
	  }
	
	  function leftButtonDown(cm, pos, repeat, event) {
	    if (ie) {
	      setTimeout(bind(ensureFocus, cm), 0);
	    } else {
	      cm.curOp.focus = activeElt(root(cm));
	    }
	
	    var behavior = configureMouse(cm, repeat, event);
	
	    var sel = cm.doc.sel,
	        contained;
	    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) {
	      leftButtonStartDrag(cm, event, pos, behavior);
	    } else {
	      leftButtonSelect(cm, event, pos, behavior);
	    }
	  }
	
	  // Start a text drag. When it ends, see if any dragging actually
	  // happen, and treat as a click if it didn't.
	  function leftButtonStartDrag(cm, event, pos, behavior) {
	    var display = cm.display,
	        moved = false;
	    var dragEnd = operation(cm, function (e) {
	      if (webkit) {
	        display.scroller.draggable = false;
	      }
	      cm.state.draggingText = false;
	      if (cm.state.delayingBlurEvent) {
	        if (cm.hasFocus()) {
	          cm.state.delayingBlurEvent = false;
	        } else {
	          delayBlurEvent(cm);
	        }
	      }
	      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
	      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
	      off(display.scroller, "dragstart", dragStart);
	      off(display.scroller, "drop", dragEnd);
	      if (!moved) {
	        e_preventDefault(e);
	        if (!behavior.addNew) {
	          extendSelection(cm.doc, pos, null, null, behavior.extend);
	        }
	        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	        if (webkit && !safari || ie && ie_version == 9) {
	          setTimeout(function () {
	            display.wrapper.ownerDocument.body.focus({ preventScroll: true });display.input.focus();
	          }, 20);
	        } else {
	          display.input.focus();
	        }
	      }
	    });
	    var mouseMove = function mouseMove(e2) {
	      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
	    };
	    var dragStart = function dragStart() {
	      return moved = true;
	    };
	    // Let the drag handler handle this.
	    if (webkit) {
	      display.scroller.draggable = true;
	    }
	    cm.state.draggingText = dragEnd;
	    dragEnd.copy = !behavior.moveOnDrag;
	    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
	    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
	    on(display.scroller, "dragstart", dragStart);
	    on(display.scroller, "drop", dragEnd);
	
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () {
	      return display.input.focus();
	    }, 20);
	    // IE's approach to draggable
	    if (display.scroller.dragDrop) {
	      display.scroller.dragDrop();
	    }
	  }
	
	  function rangeForUnit(cm, pos, unit) {
	    if (unit == "char") {
	      return new Range(pos, pos);
	    }
	    if (unit == "word") {
	      return cm.findWordAt(pos);
	    }
	    if (unit == "line") {
	      return new Range(Pos(pos.line, 0), _clipPos(cm.doc, Pos(pos.line + 1, 0)));
	    }
	    var result = unit(cm, pos);
	    return new Range(result.from, result.to);
	  }
	
	  // Normal selection, as opposed to text dragging.
	  function leftButtonSelect(cm, event, start, behavior) {
	    if (ie) {
	      delayBlurEvent(cm);
	    }
	    var display = cm.display,
	        doc = cm.doc;
	    e_preventDefault(event);
	
	    var ourRange,
	        ourIndex,
	        startSel = doc.sel,
	        ranges = startSel.ranges;
	    if (behavior.addNew && !behavior.extend) {
	      ourIndex = doc.sel.contains(start);
	      if (ourIndex > -1) {
	        ourRange = ranges[ourIndex];
	      } else {
	        ourRange = new Range(start, start);
	      }
	    } else {
	      ourRange = doc.sel.primary();
	      ourIndex = doc.sel.primIndex;
	    }
	
	    if (behavior.unit == "rectangle") {
	      if (!behavior.addNew) {
	        ourRange = new Range(start, start);
	      }
	      start = posFromMouse(cm, event, true, true);
	      ourIndex = -1;
	    } else {
	      var range = rangeForUnit(cm, start, behavior.unit);
	      if (behavior.extend) {
	        ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend);
	      } else {
	        ourRange = range;
	      }
	    }
	
	    if (!behavior.addNew) {
	      ourIndex = 0;
	      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
	      startSel = doc.sel;
	    } else if (ourIndex == -1) {
	      ourIndex = ranges.length;
	      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex), { scroll: false, origin: "*mouse" });
	    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
	      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), { scroll: false, origin: "*mouse" });
	      startSel = doc.sel;
	    } else {
	      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
	    }
	
	    var lastPos = start;
	    function extendTo(pos) {
	      if (cmp(lastPos, pos) == 0) {
	        return;
	      }
	      lastPos = pos;
	
	      if (behavior.unit == "rectangle") {
	        var ranges = [],
	            tabSize = cm.options.tabSize;
	        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
	        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
	        var left = Math.min(startCol, posCol),
	            right = Math.max(startCol, posCol);
	        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++) {
	          var text = getLine(doc, line).text,
	              leftPos = findColumn(text, left, tabSize);
	          if (left == right) {
	            ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
	          } else if (text.length > leftPos) {
	            ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
	          }
	        }
	        if (!ranges.length) {
	          ranges.push(new Range(start, start));
	        }
	        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), { origin: "*mouse", scroll: false });
	        cm.scrollIntoView(pos);
	      } else {
	        var oldRange = ourRange;
	        var range = rangeForUnit(cm, pos, behavior.unit);
	        var anchor = oldRange.anchor,
	            head;
	        if (cmp(range.anchor, anchor) > 0) {
	          head = range.head;
	          anchor = minPos(oldRange.from(), range.anchor);
	        } else {
	          head = range.anchor;
	          anchor = maxPos(oldRange.to(), range.head);
	        }
	        var ranges$1 = startSel.ranges.slice(0);
	        ranges$1[ourIndex] = bidiSimplify(cm, new Range(_clipPos(doc, anchor), head));
	        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
	      }
	    }
	
	    var editorSize = display.wrapper.getBoundingClientRect();
	    // Used to ensure timeout re-tries don't fire when another extend
	    // happened in the meantime (clearTimeout isn't reliable -- at
	    // least on Chrome, the timeouts still happen even when cleared,
	    // if the clear happens after their scheduled firing time).
	    var counter = 0;
	
	    function extend(e) {
	      var curCount = ++counter;
	      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
	      if (!cur) {
	        return;
	      }
	      if (cmp(cur, lastPos) != 0) {
	        cm.curOp.focus = activeElt(root(cm));
	        extendTo(cur);
	        var visible = visibleLines(display, doc);
	        if (cur.line >= visible.to || cur.line < visible.from) {
	          setTimeout(operation(cm, function () {
	            if (counter == curCount) {
	              extend(e);
	            }
	          }), 150);
	        }
	      } else {
	        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
	        if (outside) {
	          setTimeout(operation(cm, function () {
	            if (counter != curCount) {
	              return;
	            }
	            display.scroller.scrollTop += outside;
	            extend(e);
	          }), 50);
	        }
	      }
	    }
	
	    function done(e) {
	      cm.state.selectingText = false;
	      counter = Infinity;
	      // If e is null or undefined we interpret this as someone trying
	      // to explicitly cancel the selection rather than the user
	      // letting go of the mouse button.
	      if (e) {
	        e_preventDefault(e);
	        display.input.focus();
	      }
	      off(display.wrapper.ownerDocument, "mousemove", move);
	      off(display.wrapper.ownerDocument, "mouseup", up);
	      doc.history.lastSelOrigin = null;
	    }
	
	    var move = operation(cm, function (e) {
	      if (e.buttons === 0 || !e_button(e)) {
	        done(e);
	      } else {
	        extend(e);
	      }
	    });
	    var up = operation(cm, done);
	    cm.state.selectingText = up;
	    on(display.wrapper.ownerDocument, "mousemove", move);
	    on(display.wrapper.ownerDocument, "mouseup", up);
	  }
	
	  // Used when mouse-selecting to adjust the anchor to the proper side
	  // of a bidi jump depending on the visual position of the head.
	  function bidiSimplify(cm, range) {
	    var anchor = range.anchor;
	    var head = range.head;
	    var anchorLine = getLine(cm.doc, anchor.line);
	    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) {
	      return range;
	    }
	    var order = getOrder(anchorLine);
	    if (!order) {
	      return range;
	    }
	    var index = getBidiPartAt(order, anchor.ch, anchor.sticky),
	        part = order[index];
	    if (part.from != anchor.ch && part.to != anchor.ch) {
	      return range;
	    }
	    var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
	    if (boundary == 0 || boundary == order.length) {
	      return range;
	    }
	
	    // Compute the relative visual position of the head compared to the
	    // anchor (<0 is to the left, >0 to the right)
	    var leftSide;
	    if (head.line != anchor.line) {
	      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
	    } else {
	      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
	      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
	      if (headIndex == boundary - 1 || headIndex == boundary) {
	        leftSide = dir < 0;
	      } else {
	        leftSide = dir > 0;
	      }
	    }
	
	    var usePart = order[boundary + (leftSide ? -1 : 0)];
	    var from = leftSide == (usePart.level == 1);
	    var ch = from ? usePart.from : usePart.to,
	        sticky = from ? "after" : "before";
	    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head);
	  }
	
	  // Determines whether an event happened in the gutter, and fires the
	  // handlers for the corresponding event.
	  function gutterEvent(cm, e, type, prevent) {
	    var mX, mY;
	    if (e.touches) {
	      mX = e.touches[0].clientX;
	      mY = e.touches[0].clientY;
	    } else {
	      try {
	        mX = e.clientX;mY = e.clientY;
	      } catch (e$1) {
	        return false;
	      }
	    }
	    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) {
	      return false;
	    }
	    if (prevent) {
	      e_preventDefault(e);
	    }
	
	    var display = cm.display;
	    var lineBox = display.lineDiv.getBoundingClientRect();
	
	    if (mY > lineBox.bottom || !hasHandler(cm, type)) {
	      return e_defaultPrevented(e);
	    }
	    mY -= lineBox.top - display.viewOffset;
	
	    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
	      var g = display.gutters.childNodes[i];
	      if (g && g.getBoundingClientRect().right >= mX) {
	        var line = _lineAtHeight(cm.doc, mY);
	        var gutter = cm.display.gutterSpecs[i];
	        signal(cm, type, cm, line, gutter.className, e);
	        return e_defaultPrevented(e);
	      }
	    }
	  }
	
	  function clickInGutter(cm, e) {
	    return gutterEvent(cm, e, "gutterClick", true);
	  }
	
	  // CONTEXT MENU HANDLING
	
	  // To make the context menu work, we need to briefly unhide the
	  // textarea (making it as unobtrusive as possible) to let the
	  // right-click take effect on it.
	  function onContextMenu(cm, e) {
	    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) {
	      return;
	    }
	    if (signalDOMEvent(cm, e, "contextmenu")) {
	      return;
	    }
	    if (!captureRightClick) {
	      cm.display.input.onContextMenu(e);
	    }
	  }
	
	  function contextMenuInGutter(cm, e) {
	    if (!hasHandler(cm, "gutterContextMenu")) {
	      return false;
	    }
	    return gutterEvent(cm, e, "gutterContextMenu", false);
	  }
	
	  function themeChanged(cm) {
	    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
	    clearCaches(cm);
	  }
	
	  var Init = { toString: function toString() {
	      return "CodeMirror.Init";
	    } };
	
	  var defaults = {};
	  var optionHandlers = {};
	
	  function defineOptions(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    function option(name, deflt, handle, notOnInit) {
	      CodeMirror.defaults[name] = deflt;
	      if (handle) {
	        optionHandlers[name] = notOnInit ? function (cm, val, old) {
	          if (old != Init) {
	            handle(cm, val, old);
	          }
	        } : handle;
	      }
	    }
	
	    CodeMirror.defineOption = option;
	
	    // Passed to option handlers when there is no old value.
	    CodeMirror.Init = Init;
	
	    // These two are, on init, called from the constructor because they
	    // have to be initialized before the editor can start at all.
	    option("value", "", function (cm, val) {
	      return cm.setValue(val);
	    }, true);
	    option("mode", null, function (cm, val) {
	      cm.doc.modeOption = val;
	      loadMode(cm);
	    }, true);
	
	    option("indentUnit", 2, loadMode, true);
	    option("indentWithTabs", false);
	    option("smartIndent", true);
	    option("tabSize", 4, function (cm) {
	      resetModeState(cm);
	      clearCaches(cm);
	      regChange(cm);
	    }, true);
	
	    option("lineSeparator", null, function (cm, val) {
	      cm.doc.lineSep = val;
	      if (!val) {
	        return;
	      }
	      var newBreaks = [],
	          lineNo = cm.doc.first;
	      cm.doc.iter(function (line) {
	        for (var pos = 0;;) {
	          var found = line.text.indexOf(val, pos);
	          if (found == -1) {
	            break;
	          }
	          pos = found + val.length;
	          newBreaks.push(Pos(lineNo, found));
	        }
	        lineNo++;
	      });
	      for (var i = newBreaks.length - 1; i >= 0; i--) {
	        _replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
	      }
	    });
	    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
	      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
	      if (old != Init) {
	        cm.refresh();
	      }
	    });
	    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) {
	      return cm.refresh();
	    }, true);
	    option("electricChars", true);
	    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
	      throw new Error("inputStyle can not (yet) be changed in a running editor"); // FIXME
	    }, true);
	    option("spellcheck", false, function (cm, val) {
	      return cm.getInputField().spellcheck = val;
	    }, true);
	    option("autocorrect", false, function (cm, val) {
	      return cm.getInputField().autocorrect = val;
	    }, true);
	    option("autocapitalize", false, function (cm, val) {
	      return cm.getInputField().autocapitalize = val;
	    }, true);
	    option("rtlMoveVisually", !windows);
	    option("wholeLineUpdateBefore", true);
	
	    option("theme", "default", function (cm) {
	      themeChanged(cm);
	      updateGutters(cm);
	    }, true);
	    option("keyMap", "default", function (cm, val, old) {
	      var next = getKeyMap(val);
	      var prev = old != Init && getKeyMap(old);
	      if (prev && prev.detach) {
	        prev.detach(cm, next);
	      }
	      if (next.attach) {
	        next.attach(cm, prev || null);
	      }
	    });
	    option("extraKeys", null);
	    option("configureMouse", null);
	
	    option("lineWrapping", false, wrappingChanged, true);
	    option("gutters", [], function (cm, val) {
	      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
	      updateGutters(cm);
	    }, true);
	    option("fixedGutter", true, function (cm, val) {
	      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
	      cm.refresh();
	    }, true);
	    option("coverGutterNextToScrollbar", false, function (cm) {
	      return updateScrollbars(cm);
	    }, true);
	    option("scrollbarStyle", "native", function (cm) {
	      initScrollbars(cm);
	      updateScrollbars(cm);
	      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
	      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
	    }, true);
	    option("lineNumbers", false, function (cm, val) {
	      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
	      updateGutters(cm);
	    }, true);
	    option("firstLineNumber", 1, updateGutters, true);
	    option("lineNumberFormatter", function (integer) {
	      return integer;
	    }, updateGutters, true);
	    option("showCursorWhenSelecting", false, updateSelection, true);
	
	    option("resetSelectionOnContextMenu", true);
	    option("lineWiseCopyCut", true);
	    option("pasteLinesPerSelection", true);
	    option("selectionsMayTouch", false);
	
	    option("readOnly", false, function (cm, val) {
	      if (val == "nocursor") {
	        onBlur(cm);
	        cm.display.input.blur();
	      }
	      cm.display.input.readOnlyChanged(val);
	    });
	
	    option("screenReaderLabel", null, function (cm, val) {
	      val = val === '' ? null : val;
	      cm.display.input.screenReaderLabelChanged(val);
	    });
	
	    option("disableInput", false, function (cm, val) {
	      if (!val) {
	        cm.display.input.reset();
	      }
	    }, true);
	    option("dragDrop", true, dragDropChanged);
	    option("allowDropFileTypes", null);
	
	    option("cursorBlinkRate", 530);
	    option("cursorScrollMargin", 0);
	    option("cursorHeight", 1, updateSelection, true);
	    option("singleCursorHeightPerLine", true, updateSelection, true);
	    option("workTime", 100);
	    option("workDelay", 100);
	    option("flattenSpans", true, resetModeState, true);
	    option("addModeClass", false, resetModeState, true);
	    option("pollInterval", 100);
	    option("undoDepth", 200, function (cm, val) {
	      return cm.doc.history.undoDepth = val;
	    });
	    option("historyEventDelay", 1250);
	    option("viewportMargin", 10, function (cm) {
	      return cm.refresh();
	    }, true);
	    option("maxHighlightLength", 10000, resetModeState, true);
	    option("moveInputWithCursor", true, function (cm, val) {
	      if (!val) {
	        cm.display.input.resetPosition();
	      }
	    });
	
	    option("tabindex", null, function (cm, val) {
	      return cm.display.input.getField().tabIndex = val || "";
	    });
	    option("autofocus", null);
	    option("direction", "ltr", function (cm, val) {
	      return cm.doc.setDirection(val);
	    }, true);
	    option("phrases", null);
	  }
	
	  function dragDropChanged(cm, value, old) {
	    var wasOn = old && old != Init;
	    if (!value != !wasOn) {
	      var funcs = cm.display.dragFunctions;
	      var toggle = value ? on : off;
	      toggle(cm.display.scroller, "dragstart", funcs.start);
	      toggle(cm.display.scroller, "dragenter", funcs.enter);
	      toggle(cm.display.scroller, "dragover", funcs.over);
	      toggle(cm.display.scroller, "dragleave", funcs.leave);
	      toggle(cm.display.scroller, "drop", funcs.drop);
	    }
	  }
	
	  function wrappingChanged(cm) {
	    if (cm.options.lineWrapping) {
	      addClass(cm.display.wrapper, "CodeMirror-wrap");
	      cm.display.sizer.style.minWidth = "";
	      cm.display.sizerWidth = null;
	    } else {
	      rmClass(cm.display.wrapper, "CodeMirror-wrap");
	      findMaxLine(cm);
	    }
	    estimateLineHeights(cm);
	    regChange(cm);
	    clearCaches(cm);
	    setTimeout(function () {
	      return updateScrollbars(cm);
	    }, 100);
	  }
	
	  // A CodeMirror instance represents an editor. This is the object
	  // that user code is usually dealing with.
	
	  function CodeMirror(place, options) {
	    var this$1 = this;
	
	    if (!(this instanceof CodeMirror)) {
	      return new CodeMirror(place, options);
	    }
	
	    this.options = options = options ? copyObj(options) : {};
	    // Determine effective options based on given values and defaults.
	    copyObj(defaults, options, false);
	
	    var doc = options.value;
	    if (typeof doc == "string") {
	      doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
	    } else if (options.mode) {
	      doc.modeOption = options.mode;
	    }
	    this.doc = doc;
	
	    var input = new CodeMirror.inputStyles[options.inputStyle](this);
	    var display = this.display = new Display(place, doc, input, options);
	    display.wrapper.CodeMirror = this;
	    themeChanged(this);
	    if (options.lineWrapping) {
	      this.display.wrapper.className += " CodeMirror-wrap";
	    }
	    initScrollbars(this);
	
	    this.state = {
	      keyMaps: [], // stores maps added by addKeyMap
	      overlays: [], // highlighting overlays, as added by addOverlay
	      modeGen: 0, // bumped when mode/overlay changes, used to invalidate highlighting info
	      overwrite: false,
	      delayingBlurEvent: false,
	      focused: false,
	      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
	      selectingText: false,
	      draggingText: false,
	      highlight: new Delayed(), // stores highlight worker timeout
	      keySeq: null, // Unfinished key sequence
	      specialChars: null
	    };
	
	    if (options.autofocus && !mobile) {
	      display.input.focus();
	    }
	
	    // Override magic textarea content restore that IE sometimes does
	    // on our hidden textarea on reload
	    if (ie && ie_version < 11) {
	      setTimeout(function () {
	        return this$1.display.input.reset(true);
	      }, 20);
	    }
	
	    registerEventHandlers(this);
	    ensureGlobalHandlers();
	
	    _startOperation(this);
	    this.curOp.forceUpdate = true;
	    attachDoc(this, doc);
	
	    if (options.autofocus && !mobile || this.hasFocus()) {
	      setTimeout(function () {
	        if (this$1.hasFocus() && !this$1.state.focused) {
	          onFocus(this$1);
	        }
	      }, 20);
	    } else {
	      onBlur(this);
	    }
	
	    for (var opt in optionHandlers) {
	      if (optionHandlers.hasOwnProperty(opt)) {
	        optionHandlers[opt](this, options[opt], Init);
	      }
	    }
	    maybeUpdateLineNumberWidth(this);
	    if (options.finishInit) {
	      options.finishInit(this);
	    }
	    for (var i = 0; i < initHooks.length; ++i) {
	      initHooks[i](this);
	    }
	    _endOperation(this);
	    // Suppress optimizelegibility in Webkit, since it breaks text
	    // measuring on line wrapping boundaries.
	    if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") {
	      display.lineDiv.style.textRendering = "auto";
	    }
	  }
	
	  // The default configuration options.
	  CodeMirror.defaults = defaults;
	  // Functions to run when options are changed.
	  CodeMirror.optionHandlers = optionHandlers;
	
	  // Attach the necessary event handlers when initializing the editor
	  function registerEventHandlers(cm) {
	    var d = cm.display;
	    on(d.scroller, "mousedown", operation(cm, onMouseDown));
	    // Older IE's will not fire a second mousedown for a double click
	    if (ie && ie_version < 11) {
	      on(d.scroller, "dblclick", operation(cm, function (e) {
	        if (signalDOMEvent(cm, e)) {
	          return;
	        }
	        var pos = posFromMouse(cm, e);
	        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) {
	          return;
	        }
	        e_preventDefault(e);
	        var word = cm.findWordAt(pos);
	        extendSelection(cm.doc, word.anchor, word.head);
	      }));
	    } else {
	      on(d.scroller, "dblclick", function (e) {
	        return signalDOMEvent(cm, e) || e_preventDefault(e);
	      });
	    }
	    // Some browsers fire contextmenu *after* opening the menu, at
	    // which point we can't mess with it anymore. Context menu is
	    // handled in onMouseDown for these browsers.
	    on(d.scroller, "contextmenu", function (e) {
	      return onContextMenu(cm, e);
	    });
	    on(d.input.getField(), "contextmenu", function (e) {
	      if (!d.scroller.contains(e.target)) {
	        onContextMenu(cm, e);
	      }
	    });
	
	    // Used to suppress mouse event handling when a touch happens
	    var touchFinished,
	        prevTouch = { end: 0 };
	    function finishTouch() {
	      if (d.activeTouch) {
	        touchFinished = setTimeout(function () {
	          return d.activeTouch = null;
	        }, 1000);
	        prevTouch = d.activeTouch;
	        prevTouch.end = +new Date();
	      }
	    }
	    function isMouseLikeTouchEvent(e) {
	      if (e.touches.length != 1) {
	        return false;
	      }
	      var touch = e.touches[0];
	      return touch.radiusX <= 1 && touch.radiusY <= 1;
	    }
	    function farAway(touch, other) {
	      if (other.left == null) {
	        return true;
	      }
	      var dx = other.left - touch.left,
	          dy = other.top - touch.top;
	      return dx * dx + dy * dy > 20 * 20;
	    }
	    on(d.scroller, "touchstart", function (e) {
	      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
	        d.input.ensurePolled();
	        clearTimeout(touchFinished);
	        var now = +new Date();
	        d.activeTouch = { start: now, moved: false,
	          prev: now - prevTouch.end <= 300 ? prevTouch : null };
	        if (e.touches.length == 1) {
	          d.activeTouch.left = e.touches[0].pageX;
	          d.activeTouch.top = e.touches[0].pageY;
	        }
	      }
	    });
	    on(d.scroller, "touchmove", function () {
	      if (d.activeTouch) {
	        d.activeTouch.moved = true;
	      }
	    });
	    on(d.scroller, "touchend", function (e) {
	      var touch = d.activeTouch;
	      if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date() - touch.start < 300) {
	        var pos = cm.coordsChar(d.activeTouch, "page"),
	            range;
	        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	          {
	            range = new Range(pos, pos);
	          } else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	          {
	            range = cm.findWordAt(pos);
	          } else // Triple tap
	          {
	            range = new Range(Pos(pos.line, 0), _clipPos(cm.doc, Pos(pos.line + 1, 0)));
	          }
	        cm.setSelection(range.anchor, range.head);
	        cm.focus();
	        e_preventDefault(e);
	      }
	      finishTouch();
	    });
	    on(d.scroller, "touchcancel", finishTouch);
	
	    // Sync scrolling between fake scrollbars and real scrollable
	    // area, ensure viewport is updated when scrolling.
	    on(d.scroller, "scroll", function () {
	      if (d.scroller.clientHeight) {
	        updateScrollTop(cm, d.scroller.scrollTop);
	        setScrollLeft(cm, d.scroller.scrollLeft, true);
	        signal(cm, "scroll", cm);
	      }
	    });
	
	    // Listen to wheel events in order to try and update the viewport on time.
	    on(d.scroller, "mousewheel", function (e) {
	      return onScrollWheel(cm, e);
	    });
	    on(d.scroller, "DOMMouseScroll", function (e) {
	      return onScrollWheel(cm, e);
	    });
	
	    // Prevent wrapper from ever scrolling
	    on(d.wrapper, "scroll", function () {
	      return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
	    });
	
	    d.dragFunctions = {
	      enter: function enter(e) {
	        if (!signalDOMEvent(cm, e)) {
	          e_stop(e);
	        }
	      },
	      over: function over(e) {
	        if (!signalDOMEvent(cm, e)) {
	          onDragOver(cm, e);e_stop(e);
	        }
	      },
	      start: function start(e) {
	        return onDragStart(cm, e);
	      },
	      drop: operation(cm, onDrop),
	      leave: function leave(e) {
	        if (!signalDOMEvent(cm, e)) {
	          clearDragCursor(cm);
	        }
	      }
	    };
	
	    var inp = d.input.getField();
	    on(inp, "keyup", function (e) {
	      return onKeyUp.call(cm, e);
	    });
	    on(inp, "keydown", operation(cm, onKeyDown));
	    on(inp, "keypress", operation(cm, onKeyPress));
	    on(inp, "focus", function (e) {
	      return onFocus(cm, e);
	    });
	    on(inp, "blur", function (e) {
	      return onBlur(cm, e);
	    });
	  }
	
	  var initHooks = [];
	  CodeMirror.defineInitHook = function (f) {
	    return initHooks.push(f);
	  };
	
	  // Indent the given line. The how parameter can be "smart",
	  // "add"/null, "subtract", or "prev". When aggressive is false
	  // (typically set to true for forced single-line indents), empty
	  // lines are not indented, and places where the mode returns Pass
	  // are left alone.
	  function indentLine(cm, n, how, aggressive) {
	    var doc = cm.doc,
	        state;
	    if (how == null) {
	      how = "add";
	    }
	    if (how == "smart") {
	      // Fall back to "prev" when the mode doesn't have an indentation
	      // method.
	      if (!doc.mode.indent) {
	        how = "prev";
	      } else {
	        state = getContextBefore(cm, n).state;
	      }
	    }
	
	    var tabSize = cm.options.tabSize;
	    var line = getLine(doc, n),
	        curSpace = countColumn(line.text, null, tabSize);
	    if (line.stateAfter) {
	      line.stateAfter = null;
	    }
	    var curSpaceString = line.text.match(/^\s*/)[0],
	        indentation;
	    if (!aggressive && !/\S/.test(line.text)) {
	      indentation = 0;
	      how = "not";
	    } else if (how == "smart") {
	      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
	      if (indentation == Pass || indentation > 150) {
	        if (!aggressive) {
	          return;
	        }
	        how = "prev";
	      }
	    }
	    if (how == "prev") {
	      if (n > doc.first) {
	        indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
	      } else {
	        indentation = 0;
	      }
	    } else if (how == "add") {
	      indentation = curSpace + cm.options.indentUnit;
	    } else if (how == "subtract") {
	      indentation = curSpace - cm.options.indentUnit;
	    } else if (typeof how == "number") {
	      indentation = curSpace + how;
	    }
	    indentation = Math.max(0, indentation);
	
	    var indentString = "",
	        pos = 0;
	    if (cm.options.indentWithTabs) {
	      for (var i = Math.floor(indentation / tabSize); i; --i) {
	        pos += tabSize;indentString += "\t";
	      }
	    }
	    if (pos < indentation) {
	      indentString += spaceStr(indentation - pos);
	    }
	
	    if (indentString != curSpaceString) {
	      _replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
	      line.stateAfter = null;
	      return true;
	    } else {
	      // Ensure that, if the cursor was in the whitespace at the start
	      // of the line, it is moved to the end of that space.
	      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
	        var range = doc.sel.ranges[i$1];
	        if (range.head.line == n && range.head.ch < curSpaceString.length) {
	          var pos$1 = Pos(n, curSpaceString.length);
	          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
	          break;
	        }
	      }
	    }
	  }
	
	  // This will be set to a {lineWise: bool, text: [string]} object, so
	  // that, when pasting, we know what kind of selections the copied
	  // text was made out of.
	  var lastCopied = null;
	
	  function setLastCopied(newLastCopied) {
	    lastCopied = newLastCopied;
	  }
	
	  function applyTextInput(cm, inserted, deleted, sel, origin) {
	    var doc = cm.doc;
	    cm.display.shift = false;
	    if (!sel) {
	      sel = doc.sel;
	    }
	
	    var recent = +new Date() - 200;
	    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
	    var textLines = splitLinesAuto(inserted),
	        multiPaste = null;
	    // When pasting N lines into N selections, insert one line per selection
	    if (paste && sel.ranges.length > 1) {
	      if (lastCopied && lastCopied.text.join("\n") == inserted) {
	        if (sel.ranges.length % lastCopied.text.length == 0) {
	          multiPaste = [];
	          for (var i = 0; i < lastCopied.text.length; i++) {
	            multiPaste.push(doc.splitLines(lastCopied.text[i]));
	          }
	        }
	      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
	        multiPaste = map(textLines, function (l) {
	          return [l];
	        });
	      }
	    }
	
	    var updateInput = cm.curOp.updateInput;
	    // Normal behavior is to insert the new text into every selection
	    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
	      var range = sel.ranges[i$1];
	      var from = range.from(),
	          to = range.to();
	      if (range.empty()) {
	        if (deleted && deleted > 0) // Handle deletion
	          {
	            from = Pos(from.line, from.ch - deleted);
	          } else if (cm.state.overwrite && !paste) // Handle overwrite
	          {
	            to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
	          } else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n")) {
	          from = to = Pos(from.line, 0);
	        }
	      }
	      var changeEvent = { from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
	        origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input") };
	      makeChange(cm.doc, changeEvent);
	      signalLater(cm, "inputRead", cm, changeEvent);
	    }
	    if (inserted && !paste) {
	      triggerElectric(cm, inserted);
	    }
	
	    ensureCursorVisible(cm);
	    if (cm.curOp.updateInput < 2) {
	      cm.curOp.updateInput = updateInput;
	    }
	    cm.curOp.typing = true;
	    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
	  }
	
	  function handlePaste(e, cm) {
	    var pasted = e.clipboardData && e.clipboardData.getData("Text");
	    if (pasted) {
	      e.preventDefault();
	      if (!cm.isReadOnly() && !cm.options.disableInput && cm.hasFocus()) {
	        runInOp(cm, function () {
	          return applyTextInput(cm, pasted, 0, null, "paste");
	        });
	      }
	      return true;
	    }
	  }
	
	  function triggerElectric(cm, inserted) {
	    // When an 'electric' character is inserted, immediately trigger a reindent
	    if (!cm.options.electricChars || !cm.options.smartIndent) {
	      return;
	    }
	    var sel = cm.doc.sel;
	
	    for (var i = sel.ranges.length - 1; i >= 0; i--) {
	      var range = sel.ranges[i];
	      if (range.head.ch > 100 || i && sel.ranges[i - 1].head.line == range.head.line) {
	        continue;
	      }
	      var mode = cm.getModeAt(range.head);
	      var indented = false;
	      if (mode.electricChars) {
	        for (var j = 0; j < mode.electricChars.length; j++) {
	          if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	            indented = indentLine(cm, range.head.line, "smart");
	            break;
	          }
	        }
	      } else if (mode.electricInput) {
	        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch))) {
	          indented = indentLine(cm, range.head.line, "smart");
	        }
	      }
	      if (indented) {
	        signalLater(cm, "electricInput", cm, range.head.line);
	      }
	    }
	  }
	
	  function copyableRanges(cm) {
	    var text = [],
	        ranges = [];
	    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	      var line = cm.doc.sel.ranges[i].head.line;
	      var lineRange = { anchor: Pos(line, 0), head: Pos(line + 1, 0) };
	      ranges.push(lineRange);
	      text.push(cm.getRange(lineRange.anchor, lineRange.head));
	    }
	    return { text: text, ranges: ranges };
	  }
	
	  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
	    field.setAttribute("autocorrect", autocorrect ? "on" : "off");
	    field.setAttribute("autocapitalize", autocapitalize ? "on" : "off");
	    field.setAttribute("spellcheck", !!spellcheck);
	  }
	
	  function hiddenTextarea() {
	    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
	    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
	    // The textarea is kept positioned near the cursor to prevent the
	    // fact that it'll be scrolled into view on input from scrolling
	    // our fake cursor out of view. On webkit, when wrap=off, paste is
	    // very slow. So make the area wide instead.
	    if (webkit) {
	      te.style.width = "1000px";
	    } else {
	      te.setAttribute("wrap", "off");
	    }
	    // If border: 0; -- iOS fails to open keyboard (issue #1287)
	    if (ios) {
	      te.style.border = "1px solid black";
	    }
	    return div;
	  }
	
	  // The publicly visible API. Note that methodOp(f) means
	  // 'wrap f in an operation, performed on its `this` parameter'.
	
	  // This is not the complete set of editor methods. Most of the
	  // methods defined on the Doc type are also injected into
	  // CodeMirror.prototype, for backwards compatibility and
	  // convenience.
	
	  function addEditorMethods(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    var helpers = CodeMirror.helpers = {};
	
	    CodeMirror.prototype = {
	      constructor: CodeMirror,
	      focus: function focus() {
	        win(this).focus();this.display.input.focus();
	      },
	
	      setOption: function setOption(option, value) {
	        var options = this.options,
	            old = options[option];
	        if (options[option] == value && option != "mode") {
	          return;
	        }
	        options[option] = value;
	        if (optionHandlers.hasOwnProperty(option)) {
	          operation(this, optionHandlers[option])(this, value, old);
	        }
	        signal(this, "optionChange", this, option);
	      },
	
	      getOption: function getOption(option) {
	        return this.options[option];
	      },
	      getDoc: function getDoc() {
	        return this.doc;
	      },
	
	      addKeyMap: function addKeyMap(map, bottom) {
	        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
	      },
	      removeKeyMap: function removeKeyMap(map) {
	        var maps = this.state.keyMaps;
	        for (var i = 0; i < maps.length; ++i) {
	          if (maps[i] == map || maps[i].name == map) {
	            maps.splice(i, 1);
	            return true;
	          }
	        }
	      },
	
	      addOverlay: methodOp(function (spec, options) {
	        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
	        if (mode.startState) {
	          throw new Error("Overlays may not be stateful.");
	        }
	        insertSorted(this.state.overlays, { mode: mode, modeSpec: spec, opaque: options && options.opaque,
	          priority: options && options.priority || 0 }, function (overlay) {
	          return overlay.priority;
	        });
	        this.state.modeGen++;
	        regChange(this);
	      }),
	      removeOverlay: methodOp(function (spec) {
	        var overlays = this.state.overlays;
	        for (var i = 0; i < overlays.length; ++i) {
	          var cur = overlays[i].modeSpec;
	          if (cur == spec || typeof spec == "string" && cur.name == spec) {
	            overlays.splice(i, 1);
	            this.state.modeGen++;
	            regChange(this);
	            return;
	          }
	        }
	      }),
	
	      indentLine: methodOp(function (n, dir, aggressive) {
	        if (typeof dir != "string" && typeof dir != "number") {
	          if (dir == null) {
	            dir = this.options.smartIndent ? "smart" : "prev";
	          } else {
	            dir = dir ? "add" : "subtract";
	          }
	        }
	        if (isLine(this.doc, n)) {
	          indentLine(this, n, dir, aggressive);
	        }
	      }),
	      indentSelection: methodOp(function (how) {
	        var ranges = this.doc.sel.ranges,
	            end = -1;
	        for (var i = 0; i < ranges.length; i++) {
	          var range = ranges[i];
	          if (!range.empty()) {
	            var from = range.from(),
	                to = range.to();
	            var start = Math.max(end, from.line);
	            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
	            for (var j = start; j < end; ++j) {
	              indentLine(this, j, how);
	            }
	            var newRanges = this.doc.sel.ranges;
	            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) {
	              replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
	            }
	          } else if (range.head.line > end) {
	            indentLine(this, range.head.line, how, true);
	            end = range.head.line;
	            if (i == this.doc.sel.primIndex) {
	              ensureCursorVisible(this);
	            }
	          }
	        }
	      }),
	
	      // Fetch the parser token for a given character. Useful for hacks
	      // that want to inspect the mode state (say, for completion).
	      getTokenAt: function getTokenAt(pos, precise) {
	        return takeToken(this, pos, precise);
	      },
	
	      getLineTokens: function getLineTokens(line, precise) {
	        return takeToken(this, Pos(line), precise, true);
	      },
	
	      getTokenTypeAt: function getTokenTypeAt(pos) {
	        pos = _clipPos(this.doc, pos);
	        var styles = getLineStyles(this, getLine(this.doc, pos.line));
	        var before = 0,
	            after = (styles.length - 1) / 2,
	            ch = pos.ch;
	        var type;
	        if (ch == 0) {
	          type = styles[2];
	        } else {
	          for (;;) {
	            var mid = before + after >> 1;
	            if ((mid ? styles[mid * 2 - 1] : 0) >= ch) {
	              after = mid;
	            } else if (styles[mid * 2 + 1] < ch) {
	              before = mid + 1;
	            } else {
	              type = styles[mid * 2 + 2];break;
	            }
	          }
	        }
	        var cut = type ? type.indexOf("overlay ") : -1;
	        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
	      },
	
	      getModeAt: function getModeAt(pos) {
	        var mode = this.doc.mode;
	        if (!mode.innerMode) {
	          return mode;
	        }
	        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
	      },
	
	      getHelper: function getHelper(pos, type) {
	        return this.getHelpers(pos, type)[0];
	      },
	
	      getHelpers: function getHelpers(pos, type) {
	        var found = [];
	        if (!helpers.hasOwnProperty(type)) {
	          return found;
	        }
	        var help = helpers[type],
	            mode = this.getModeAt(pos);
	        if (typeof mode[type] == "string") {
	          if (help[mode[type]]) {
	            found.push(help[mode[type]]);
	          }
	        } else if (mode[type]) {
	          for (var i = 0; i < mode[type].length; i++) {
	            var val = help[mode[type][i]];
	            if (val) {
	              found.push(val);
	            }
	          }
	        } else if (mode.helperType && help[mode.helperType]) {
	          found.push(help[mode.helperType]);
	        } else if (help[mode.name]) {
	          found.push(help[mode.name]);
	        }
	        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
	          var cur = help._global[i$1];
	          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1) {
	            found.push(cur.val);
	          }
	        }
	        return found;
	      },
	
	      getStateAfter: function getStateAfter(line, precise) {
	        var doc = this.doc;
	        line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
	        return getContextBefore(this, line + 1, precise).state;
	      },
	
	      cursorCoords: function cursorCoords(start, mode) {
	        var pos,
	            range = this.doc.sel.primary();
	        if (start == null) {
	          pos = range.head;
	        } else if ((typeof start === 'undefined' ? 'undefined' : _typeof(start)) == "object") {
	          pos = _clipPos(this.doc, start);
	        } else {
	          pos = start ? range.from() : range.to();
	        }
	        return _cursorCoords(this, pos, mode || "page");
	      },
	
	      charCoords: function charCoords(pos, mode) {
	        return _charCoords(this, _clipPos(this.doc, pos), mode || "page");
	      },
	
	      coordsChar: function coordsChar(coords, mode) {
	        coords = fromCoordSystem(this, coords, mode || "page");
	        return _coordsChar(this, coords.left, coords.top);
	      },
	
	      lineAtHeight: function lineAtHeight(height, mode) {
	        height = fromCoordSystem(this, { top: height, left: 0 }, mode || "page").top;
	        return _lineAtHeight(this.doc, height + this.display.viewOffset);
	      },
	      heightAtLine: function heightAtLine(line, mode, includeWidgets) {
	        var end = false,
	            lineObj;
	        if (typeof line == "number") {
	          var last = this.doc.first + this.doc.size - 1;
	          if (line < this.doc.first) {
	            line = this.doc.first;
	          } else if (line > last) {
	            line = last;end = true;
	          }
	          lineObj = getLine(this.doc, line);
	        } else {
	          lineObj = line;
	        }
	        return intoCoordSystem(this, lineObj, { top: 0, left: 0 }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - _heightAtLine(lineObj) : 0);
	      },
	
	      defaultTextHeight: function defaultTextHeight() {
	        return textHeight(this.display);
	      },
	      defaultCharWidth: function defaultCharWidth() {
	        return charWidth(this.display);
	      },
	
	      getViewport: function getViewport() {
	        return { from: this.display.viewFrom, to: this.display.viewTo };
	      },
	
	      addWidget: function addWidget(pos, node, scroll, vert, horiz) {
	        var display = this.display;
	        pos = _cursorCoords(this, _clipPos(this.doc, pos));
	        var top = pos.bottom,
	            left = pos.left;
	        node.style.position = "absolute";
	        node.setAttribute("cm-ignore-events", "true");
	        this.display.input.setUneditable(node);
	        display.sizer.appendChild(node);
	        if (vert == "over") {
	          top = pos.top;
	        } else if (vert == "above" || vert == "near") {
	          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	              hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
	          // Default to positioning above (if specified and possible); otherwise default to positioning below
	          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) {
	            top = pos.top - node.offsetHeight;
	          } else if (pos.bottom + node.offsetHeight <= vspace) {
	            top = pos.bottom;
	          }
	          if (left + node.offsetWidth > hspace) {
	            left = hspace - node.offsetWidth;
	          }
	        }
	        node.style.top = top + "px";
	        node.style.left = node.style.right = "";
	        if (horiz == "right") {
	          left = display.sizer.clientWidth - node.offsetWidth;
	          node.style.right = "0px";
	        } else {
	          if (horiz == "left") {
	            left = 0;
	          } else if (horiz == "middle") {
	            left = (display.sizer.clientWidth - node.offsetWidth) / 2;
	          }
	          node.style.left = left + "px";
	        }
	        if (scroll) {
	          scrollIntoView(this, { left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight });
	        }
	      },
	
	      triggerOnKeyDown: methodOp(onKeyDown),
	      triggerOnKeyPress: methodOp(onKeyPress),
	      triggerOnKeyUp: onKeyUp,
	      triggerOnMouseDown: methodOp(onMouseDown),
	
	      execCommand: function execCommand(cmd) {
	        if (commands.hasOwnProperty(cmd)) {
	          return commands[cmd].call(null, this);
	        }
	      },
	
	      triggerElectric: methodOp(function (text) {
	        triggerElectric(this, text);
	      }),
	
	      findPosH: function findPosH(from, amount, unit, visually) {
	        var dir = 1;
	        if (amount < 0) {
	          dir = -1;amount = -amount;
	        }
	        var cur = _clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          cur = _findPosH(this.doc, cur, dir, unit, visually);
	          if (cur.hitSide) {
	            break;
	          }
	        }
	        return cur;
	      },
	
	      moveH: methodOp(function (dir, unit) {
	        var this$1 = this;
	
	        this.extendSelectionsBy(function (range) {
	          if (this$1.display.shift || this$1.doc.extend || range.empty()) {
	            return _findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually);
	          } else {
	            return dir < 0 ? range.from() : range.to();
	          }
	        }, sel_move);
	      }),
	
	      deleteH: methodOp(function (dir, unit) {
	        var sel = this.doc.sel,
	            doc = this.doc;
	        if (sel.somethingSelected()) {
	          doc.replaceSelection("", null, "+delete");
	        } else {
	          deleteNearSelection(this, function (range) {
	            var other = _findPosH(doc, range.head, dir, unit, false);
	            return dir < 0 ? { from: other, to: range.head } : { from: range.head, to: other };
	          });
	        }
	      }),
	
	      findPosV: function findPosV(from, amount, unit, goalColumn) {
	        var dir = 1,
	            x = goalColumn;
	        if (amount < 0) {
	          dir = -1;amount = -amount;
	        }
	        var cur = _clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          var coords = _cursorCoords(this, cur, "div");
	          if (x == null) {
	            x = coords.left;
	          } else {
	            coords.left = x;
	          }
	          cur = _findPosV(this, coords, dir, unit);
	          if (cur.hitSide) {
	            break;
	          }
	        }
	        return cur;
	      },
	
	      moveV: methodOp(function (dir, unit) {
	        var this$1 = this;
	
	        var doc = this.doc,
	            goals = [];
	        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
	        doc.extendSelectionsBy(function (range) {
	          if (collapse) {
	            return dir < 0 ? range.from() : range.to();
	          }
	          var headPos = _cursorCoords(this$1, range.head, "div");
	          if (range.goalColumn != null) {
	            headPos.left = range.goalColumn;
	          }
	          goals.push(headPos.left);
	          var pos = _findPosV(this$1, headPos, dir, unit);
	          if (unit == "page" && range == doc.sel.primary()) {
	            addToScrollTop(this$1, _charCoords(this$1, pos, "div").top - headPos.top);
	          }
	          return pos;
	        }, sel_move);
	        if (goals.length) {
	          for (var i = 0; i < doc.sel.ranges.length; i++) {
	            doc.sel.ranges[i].goalColumn = goals[i];
	          }
	        }
	      }),
	
	      // Find the word at the given position (as returned by coordsChar).
	      findWordAt: function findWordAt(pos) {
	        var doc = this.doc,
	            line = getLine(doc, pos.line).text;
	        var start = pos.ch,
	            end = pos.ch;
	        if (line) {
	          var helper = this.getHelper(pos, "wordChars");
	          if ((pos.sticky == "before" || end == line.length) && start) {
	            --start;
	          } else {
	            ++end;
	          }
	          var startChar = line.charAt(start);
	          var check = isWordChar(startChar, helper) ? function (ch) {
	            return isWordChar(ch, helper);
	          } : /\s/.test(startChar) ? function (ch) {
	            return (/\s/.test(ch)
	            );
	          } : function (ch) {
	            return !/\s/.test(ch) && !isWordChar(ch);
	          };
	          while (start > 0 && check(line.charAt(start - 1))) {
	            --start;
	          }
	          while (end < line.length && check(line.charAt(end))) {
	            ++end;
	          }
	        }
	        return new Range(Pos(pos.line, start), Pos(pos.line, end));
	      },
	
	      toggleOverwrite: function toggleOverwrite(value) {
	        if (value != null && value == this.state.overwrite) {
	          return;
	        }
	        if (this.state.overwrite = !this.state.overwrite) {
	          addClass(this.display.cursorDiv, "CodeMirror-overwrite");
	        } else {
	          rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
	        }
	
	        signal(this, "overwriteToggle", this, this.state.overwrite);
	      },
	      hasFocus: function hasFocus() {
	        return this.display.input.getField() == activeElt(root(this));
	      },
	      isReadOnly: function isReadOnly() {
	        return !!(this.options.readOnly || this.doc.cantEdit);
	      },
	
	      scrollTo: methodOp(function (x, y) {
	        scrollToCoords(this, x, y);
	      }),
	      getScrollInfo: function getScrollInfo() {
	        var scroller = this.display.scroller;
	        return { left: scroller.scrollLeft, top: scroller.scrollTop,
	          height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	          width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	          clientHeight: displayHeight(this), clientWidth: displayWidth(this) };
	      },
	
	      scrollIntoView: methodOp(function (range, margin) {
	        if (range == null) {
	          range = { from: this.doc.sel.primary().head, to: null };
	          if (margin == null) {
	            margin = this.options.cursorScrollMargin;
	          }
	        } else if (typeof range == "number") {
	          range = { from: Pos(range, 0), to: null };
	        } else if (range.from == null) {
	          range = { from: range, to: null };
	        }
	        if (!range.to) {
	          range.to = range.from;
	        }
	        range.margin = margin || 0;
	
	        if (range.from.line != null) {
	          scrollToRange(this, range);
	        } else {
	          scrollToCoordsRange(this, range.from, range.to, range.margin);
	        }
	      }),
	
	      setSize: methodOp(function (width, height) {
	        var this$1 = this;
	
	        var interpret = function interpret(val) {
	          return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
	        };
	        if (width != null) {
	          this.display.wrapper.style.width = interpret(width);
	        }
	        if (height != null) {
	          this.display.wrapper.style.height = interpret(height);
	        }
	        if (this.options.lineWrapping) {
	          clearLineMeasurementCache(this);
	        }
	        var lineNo = this.display.viewFrom;
	        this.doc.iter(lineNo, this.display.viewTo, function (line) {
	          if (line.widgets) {
	            for (var i = 0; i < line.widgets.length; i++) {
	              if (line.widgets[i].noHScroll) {
	                regLineChange(this$1, lineNo, "widget");break;
	              }
	            }
	          }
	          ++lineNo;
	        });
	        this.curOp.forceUpdate = true;
	        signal(this, "refresh", this);
	      }),
	
	      operation: function operation(f) {
	        return runInOp(this, f);
	      },
	      startOperation: function startOperation() {
	        return _startOperation(this);
	      },
	      endOperation: function endOperation() {
	        return _endOperation(this);
	      },
	
	      refresh: methodOp(function () {
	        var oldHeight = this.display.cachedTextHeight;
	        regChange(this);
	        this.curOp.forceUpdate = true;
	        clearCaches(this);
	        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
	        updateGutterSpace(this.display);
	        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping) {
	          estimateLineHeights(this);
	        }
	        signal(this, "refresh", this);
	      }),
	
	      swapDoc: methodOp(function (doc) {
	        var old = this.doc;
	        old.cm = null;
	        // Cancel the current text selection if any (#5821)
	        if (this.state.selectingText) {
	          this.state.selectingText();
	        }
	        attachDoc(this, doc);
	        clearCaches(this);
	        this.display.input.reset();
	        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
	        this.curOp.forceScroll = true;
	        signalLater(this, "swapDoc", this, old);
	        return old;
	      }),
	
	      phrase: function phrase(phraseText) {
	        var phrases = this.options.phrases;
	        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
	      },
	
	      getInputField: function getInputField() {
	        return this.display.input.getField();
	      },
	      getWrapperElement: function getWrapperElement() {
	        return this.display.wrapper;
	      },
	      getScrollerElement: function getScrollerElement() {
	        return this.display.scroller;
	      },
	      getGutterElement: function getGutterElement() {
	        return this.display.gutters;
	      }
	    };
	    eventMixin(CodeMirror);
	
	    CodeMirror.registerHelper = function (type, name, value) {
	      if (!helpers.hasOwnProperty(type)) {
	        helpers[type] = CodeMirror[type] = { _global: [] };
	      }
	      helpers[type][name] = value;
	    };
	    CodeMirror.registerGlobalHelper = function (type, name, predicate, value) {
	      CodeMirror.registerHelper(type, name, value);
	      helpers[type]._global.push({ pred: predicate, val: value });
	    };
	  }
	
	  // Used for horizontal relative motion. Dir is -1 or 1 (left or
	  // right), unit can be "codepoint", "char", "column" (like char, but
	  // doesn't cross line boundaries), "word" (across next word), or
	  // "group" (to the start of next group of word or
	  // non-word-non-whitespace chars). The visually param controls
	  // whether, in right-to-left text, direction 1 means to move towards
	  // the next index in the string, or towards the character to the right
	  // of the current position. The resulting position will have a
	  // hitSide=true property if it reached the end of the document.
	  function _findPosH(doc, pos, dir, unit, visually) {
	    var oldPos = pos;
	    var origDir = dir;
	    var lineObj = getLine(doc, pos.line);
	    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
	    function findNextLine() {
	      var l = pos.line + lineDir;
	      if (l < doc.first || l >= doc.first + doc.size) {
	        return false;
	      }
	      pos = new Pos(l, pos.ch, pos.sticky);
	      return lineObj = getLine(doc, l);
	    }
	    function moveOnce(boundToLine) {
	      var next;
	      if (unit == "codepoint") {
	        var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
	        if (isNaN(ch)) {
	          next = null;
	        } else {
	          var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
	          next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
	        }
	      } else if (visually) {
	        next = moveVisually(doc.cm, lineObj, pos, dir);
	      } else {
	        next = moveLogically(lineObj, pos, dir);
	      }
	      if (next == null) {
	        if (!boundToLine && findNextLine()) {
	          pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir);
	        } else {
	          return false;
	        }
	      } else {
	        pos = next;
	      }
	      return true;
	    }
	
	    if (unit == "char" || unit == "codepoint") {
	      moveOnce();
	    } else if (unit == "column") {
	      moveOnce(true);
	    } else if (unit == "word" || unit == "group") {
	      var sawType = null,
	          group = unit == "group";
	      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
	      for (var first = true;; first = false) {
	        if (dir < 0 && !moveOnce(!first)) {
	          break;
	        }
	        var cur = lineObj.text.charAt(pos.ch) || "\n";
	        var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
	        if (group && !first && !type) {
	          type = "s";
	        }
	        if (sawType && sawType != type) {
	          if (dir < 0) {
	            dir = 1;moveOnce();pos.sticky = "after";
	          }
	          break;
	        }
	
	        if (type) {
	          sawType = type;
	        }
	        if (dir > 0 && !moveOnce(!first)) {
	          break;
	        }
	      }
	    }
	    var result = skipAtomic(doc, pos, oldPos, origDir, true);
	    if (equalCursorPos(oldPos, result)) {
	      result.hitSide = true;
	    }
	    return result;
	  }
	
	  // For relative vertical movement. Dir may be -1 or 1. Unit can be
	  // "page" or "line". The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function _findPosV(cm, pos, dir, unit) {
	    var doc = cm.doc,
	        x = pos.left,
	        y;
	    if (unit == "page") {
	      var pageSize = Math.min(cm.display.wrapper.clientHeight, win(cm).innerHeight || doc(cm).documentElement.clientHeight);
	      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
	      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
	    } else if (unit == "line") {
	      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
	    }
	    var target;
	    for (;;) {
	      target = _coordsChar(cm, x, y);
	      if (!target.outside) {
	        break;
	      }
	      if (dir < 0 ? y <= 0 : y >= doc.height) {
	        target.hitSide = true;break;
	      }
	      y += dir * 5;
	    }
	    return target;
	  }
	
	  // CONTENTEDITABLE INPUT STYLE
	
	  var ContentEditableInput = function ContentEditableInput(cm) {
	    this.cm = cm;
	    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
	    this.polling = new Delayed();
	    this.composing = null;
	    this.gracePeriod = false;
	    this.readDOMTimeout = null;
	  };
	
	  ContentEditableInput.prototype.init = function (display) {
	    var this$1 = this;
	
	    var input = this,
	        cm = input.cm;
	    var div = input.div = display.lineDiv;
	    div.contentEditable = true;
	    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
	
	    function belongsToInput(e) {
	      for (var t = e.target; t; t = t.parentNode) {
	        if (t == div) {
	          return true;
	        }
	        if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) {
	          break;
	        }
	      }
	      return false;
	    }
	
	    on(div, "paste", function (e) {
	      if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) {
	        return;
	      }
	      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	      if (ie_version <= 11) {
	        setTimeout(operation(cm, function () {
	          return this$1.updateFromDOM();
	        }), 20);
	      }
	    });
	
	    on(div, "compositionstart", function (e) {
	      this$1.composing = { data: e.data, done: false };
	    });
	    on(div, "compositionupdate", function (e) {
	      if (!this$1.composing) {
	        this$1.composing = { data: e.data, done: false };
	      }
	    });
	    on(div, "compositionend", function (e) {
	      if (this$1.composing) {
	        if (e.data != this$1.composing.data) {
	          this$1.readFromDOMSoon();
	        }
	        this$1.composing.done = true;
	      }
	    });
	
	    on(div, "touchstart", function () {
	      return input.forceCompositionEnd();
	    });
	
	    on(div, "input", function () {
	      if (!this$1.composing) {
	        this$1.readFromDOMSoon();
	      }
	    });
	
	    function onCopyCut(e) {
	      if (!belongsToInput(e) || signalDOMEvent(cm, e)) {
	        return;
	      }
	      if (cm.somethingSelected()) {
	        setLastCopied({ lineWise: false, text: cm.getSelections() });
	        if (e.type == "cut") {
	          cm.replaceSelection("", null, "cut");
	        }
	      } else if (!cm.options.lineWiseCopyCut) {
	        return;
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({ lineWise: true, text: ranges.text });
	        if (e.type == "cut") {
	          cm.operation(function () {
	            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
	            cm.replaceSelection("", null, "cut");
	          });
	        }
	      }
	      if (e.clipboardData) {
	        e.clipboardData.clearData();
	        var content = lastCopied.text.join("\n");
	        // iOS exposes the clipboard API, but seems to discard content inserted into it
	        e.clipboardData.setData("Text", content);
	        if (e.clipboardData.getData("Text") == content) {
	          e.preventDefault();
	          return;
	        }
	      }
	      // Old-fashioned briefly-focus-a-textarea hack
	      var kludge = hiddenTextarea(),
	          te = kludge.firstChild;
	      disableBrowserMagic(te);
	      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
	      te.value = lastCopied.text.join("\n");
	      var hadFocus = activeElt(rootNode(div));
	      selectInput(te);
	      setTimeout(function () {
	        cm.display.lineSpace.removeChild(kludge);
	        hadFocus.focus();
	        if (hadFocus == div) {
	          input.showPrimarySelection();
	        }
	      }, 50);
	    }
	    on(div, "copy", onCopyCut);
	    on(div, "cut", onCopyCut);
	  };
	
	  ContentEditableInput.prototype.screenReaderLabelChanged = function (label) {
	    // Label for screenreaders, accessibility
	    if (label) {
	      this.div.setAttribute('aria-label', label);
	    } else {
	      this.div.removeAttribute('aria-label');
	    }
	  };
	
	  ContentEditableInput.prototype.prepareSelection = function () {
	    var result = prepareSelection(this.cm, false);
	    result.focus = activeElt(rootNode(this.div)) == this.div;
	    return result;
	  };
	
	  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
	    if (!info || !this.cm.display.view.length) {
	      return;
	    }
	    if (info.focus || takeFocus) {
	      this.showPrimarySelection();
	    }
	    this.showMultipleSelections(info);
	  };
	
	  ContentEditableInput.prototype.getSelection = function () {
	    return this.cm.display.wrapper.ownerDocument.getSelection();
	  };
	
	  ContentEditableInput.prototype.showPrimarySelection = function () {
	    var sel = this.getSelection(),
	        cm = this.cm,
	        prim = cm.doc.sel.primary();
	    var from = prim.from(),
	        to = prim.to();
	
	    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
	      sel.removeAllRanges();
	      return;
	    }
	
	    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) {
	      return;
	    }
	
	    var view = cm.display.view;
	    var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || { node: view[0].measure.map[2], offset: 0 };
	    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
	    if (!end) {
	      var measure = view[view.length - 1].measure;
	      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
	      end = { node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3] };
	    }
	
	    if (!start || !end) {
	      sel.removeAllRanges();
	      return;
	    }
	
	    var old = sel.rangeCount && sel.getRangeAt(0),
	        rng;
	    try {
	      rng = range(start.node, start.offset, end.offset, end.node);
	    } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	    if (rng) {
	      if (!gecko && cm.state.focused) {
	        sel.collapse(start.node, start.offset);
	        if (!rng.collapsed) {
	          sel.removeAllRanges();
	          sel.addRange(rng);
	        }
	      } else {
	        sel.removeAllRanges();
	        sel.addRange(rng);
	      }
	      if (old && sel.anchorNode == null) {
	        sel.addRange(old);
	      } else if (gecko) {
	        this.startGracePeriod();
	      }
	    }
	    this.rememberSelection();
	  };
	
	  ContentEditableInput.prototype.startGracePeriod = function () {
	    var this$1 = this;
	
	    clearTimeout(this.gracePeriod);
	    this.gracePeriod = setTimeout(function () {
	      this$1.gracePeriod = false;
	      if (this$1.selectionChanged()) {
	        this$1.cm.operation(function () {
	          return this$1.cm.curOp.selectionChanged = true;
	        });
	      }
	    }, 20);
	  };
	
	  ContentEditableInput.prototype.showMultipleSelections = function (info) {
	    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
	    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
	  };
	
	  ContentEditableInput.prototype.rememberSelection = function () {
	    var sel = this.getSelection();
	    this.lastAnchorNode = sel.anchorNode;this.lastAnchorOffset = sel.anchorOffset;
	    this.lastFocusNode = sel.focusNode;this.lastFocusOffset = sel.focusOffset;
	  };
	
	  ContentEditableInput.prototype.selectionInEditor = function () {
	    var sel = this.getSelection();
	    if (!sel.rangeCount) {
	      return false;
	    }
	    var node = sel.getRangeAt(0).commonAncestorContainer;
	    return contains(this.div, node);
	  };
	
	  ContentEditableInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor") {
	      if (!this.selectionInEditor() || activeElt(rootNode(this.div)) != this.div) {
	        this.showSelection(this.prepareSelection(), true);
	      }
	      this.div.focus();
	    }
	  };
	  ContentEditableInput.prototype.blur = function () {
	    this.div.blur();
	  };
	  ContentEditableInput.prototype.getField = function () {
	    return this.div;
	  };
	
	  ContentEditableInput.prototype.supportsTouch = function () {
	    return true;
	  };
	
	  ContentEditableInput.prototype.receivedFocus = function () {
	    var this$1 = this;
	
	    var input = this;
	    if (this.selectionInEditor()) {
	      setTimeout(function () {
	        return this$1.pollSelection();
	      }, 20);
	    } else {
	      runInOp(this.cm, function () {
	        return input.cm.curOp.selectionChanged = true;
	      });
	    }
	
	    function poll() {
	      if (input.cm.state.focused) {
	        input.pollSelection();
	        input.polling.set(input.cm.options.pollInterval, poll);
	      }
	    }
	    this.polling.set(this.cm.options.pollInterval, poll);
	  };
	
	  ContentEditableInput.prototype.selectionChanged = function () {
	    var sel = this.getSelection();
	    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
	  };
	
	  ContentEditableInput.prototype.pollSelection = function () {
	    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) {
	      return;
	    }
	    var sel = this.getSelection(),
	        cm = this.cm;
	    // On Android Chrome (version 56, at least), backspacing into an
	    // uneditable block element will put the cursor in that element,
	    // and then, because it's not editable, hide the virtual keyboard.
	    // Because Android doesn't allow us to actually detect backspace
	    // presses in a sane way, this code checks for when that happens
	    // and simulates a backspace press in this case.
	    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
	      this.cm.triggerOnKeyDown({ type: "keydown", keyCode: 8, preventDefault: Math.abs });
	      this.blur();
	      this.focus();
	      return;
	    }
	    if (this.composing) {
	      return;
	    }
	    this.rememberSelection();
	    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (anchor && head) {
	      runInOp(cm, function () {
	        setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
	        if (anchor.bad || head.bad) {
	          cm.curOp.selectionChanged = true;
	        }
	      });
	    }
	  };
	
	  ContentEditableInput.prototype.pollContent = function () {
	    if (this.readDOMTimeout != null) {
	      clearTimeout(this.readDOMTimeout);
	      this.readDOMTimeout = null;
	    }
	
	    var cm = this.cm,
	        display = cm.display,
	        sel = cm.doc.sel.primary();
	    var from = sel.from(),
	        to = sel.to();
	    if (from.ch == 0 && from.line > cm.firstLine()) {
	      from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
	    }
	    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) {
	      to = Pos(to.line + 1, 0);
	    }
	    if (from.line < display.viewFrom || to.line > display.viewTo - 1) {
	      return false;
	    }
	
	    var fromIndex, fromLine, fromNode;
	    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	      fromLine = lineNo(display.view[0].line);
	      fromNode = display.view[0].node;
	    } else {
	      fromLine = lineNo(display.view[fromIndex].line);
	      fromNode = display.view[fromIndex - 1].node.nextSibling;
	    }
	    var toIndex = findViewIndex(cm, to.line);
	    var toLine, toNode;
	    if (toIndex == display.view.length - 1) {
	      toLine = display.viewTo - 1;
	      toNode = display.lineDiv.lastChild;
	    } else {
	      toLine = lineNo(display.view[toIndex + 1].line) - 1;
	      toNode = display.view[toIndex + 1].node.previousSibling;
	    }
	
	    if (!fromNode) {
	      return false;
	    }
	    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
	    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
	    while (newText.length > 1 && oldText.length > 1) {
	      if (lst(newText) == lst(oldText)) {
	        newText.pop();oldText.pop();toLine--;
	      } else if (newText[0] == oldText[0]) {
	        newText.shift();oldText.shift();fromLine++;
	      } else {
	        break;
	      }
	    }
	
	    var cutFront = 0,
	        cutEnd = 0;
	    var newTop = newText[0],
	        oldTop = oldText[0],
	        maxCutFront = Math.min(newTop.length, oldTop.length);
	    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront)) {
	      ++cutFront;
	    }
	    var newBot = lst(newText),
	        oldBot = lst(oldText);
	    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
	    while (cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	      ++cutEnd;
	    }
	    // Try to move start of change to start of selection if ambiguous
	    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
	      while (cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	        cutFront--;
	        cutEnd++;
	      }
	    }
	
	    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
	    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
	
	    var chFrom = Pos(fromLine, cutFront);
	    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
	    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	      _replaceRange(cm.doc, newText, chFrom, chTo, "+input");
	      return true;
	    }
	  };
	
	  ContentEditableInput.prototype.ensurePolled = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.reset = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.forceCompositionEnd = function () {
	    if (!this.composing) {
	      return;
	    }
	    clearTimeout(this.readDOMTimeout);
	    this.composing = null;
	    this.updateFromDOM();
	    this.div.blur();
	    this.div.focus();
	  };
	  ContentEditableInput.prototype.readFromDOMSoon = function () {
	    var this$1 = this;
	
	    if (this.readDOMTimeout != null) {
	      return;
	    }
	    this.readDOMTimeout = setTimeout(function () {
	      this$1.readDOMTimeout = null;
	      if (this$1.composing) {
	        if (this$1.composing.done) {
	          this$1.composing = null;
	        } else {
	          return;
	        }
	      }
	      this$1.updateFromDOM();
	    }, 80);
	  };
	
	  ContentEditableInput.prototype.updateFromDOM = function () {
	    var this$1 = this;
	
	    if (this.cm.isReadOnly() || !this.pollContent()) {
	      runInOp(this.cm, function () {
	        return regChange(this$1.cm);
	      });
	    }
	  };
	
	  ContentEditableInput.prototype.setUneditable = function (node) {
	    node.contentEditable = "false";
	  };
	
	  ContentEditableInput.prototype.onKeyPress = function (e) {
	    if (e.charCode == 0 || this.composing) {
	      return;
	    }
	    e.preventDefault();
	    if (!this.cm.isReadOnly()) {
	      operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
	    }
	  };
	
	  ContentEditableInput.prototype.readOnlyChanged = function (val) {
	    this.div.contentEditable = String(val != "nocursor");
	  };
	
	  ContentEditableInput.prototype.onContextMenu = function () {};
	  ContentEditableInput.prototype.resetPosition = function () {};
	
	  ContentEditableInput.prototype.needsContentAttribute = true;
	
	  function posToDOM(cm, pos) {
	    var view = findViewForLine(cm, pos.line);
	    if (!view || view.hidden) {
	      return null;
	    }
	    var line = getLine(cm.doc, pos.line);
	    var info = mapFromLineView(view, line, pos.line);
	
	    var order = getOrder(line, cm.doc.direction),
	        side = "left";
	    if (order) {
	      var partPos = getBidiPartAt(order, pos.ch);
	      side = partPos % 2 ? "right" : "left";
	    }
	    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
	    result.offset = result.collapse == "right" ? result.end : result.start;
	    return result;
	  }
	
	  function isInGutter(node) {
	    for (var scan = node; scan; scan = scan.parentNode) {
	      if (/CodeMirror-gutter-wrapper/.test(scan.className)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function badPos(pos, bad) {
	    if (bad) {
	      pos.bad = true;
	    }return pos;
	  }
	
	  function domTextBetween(cm, from, to, fromLine, toLine) {
	    var text = "",
	        closing = false,
	        lineSep = cm.doc.lineSeparator(),
	        extraLinebreak = false;
	    function recognizeMarker(id) {
	      return function (marker) {
	        return marker.id == id;
	      };
	    }
	    function close() {
	      if (closing) {
	        text += lineSep;
	        if (extraLinebreak) {
	          text += lineSep;
	        }
	        closing = extraLinebreak = false;
	      }
	    }
	    function addText(str) {
	      if (str) {
	        close();
	        text += str;
	      }
	    }
	    function walk(node) {
	      if (node.nodeType == 1) {
	        var cmText = node.getAttribute("cm-text");
	        if (cmText) {
	          addText(cmText);
	          return;
	        }
	        var markerID = node.getAttribute("cm-marker"),
	            range;
	        if (markerID) {
	          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
	          if (found.length && (range = found[0].find(0))) {
	            addText(getBetween(cm.doc, range.from, range.to).join(lineSep));
	          }
	          return;
	        }
	        if (node.getAttribute("contenteditable") == "false") {
	          return;
	        }
	        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
	        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) {
	          return;
	        }
	
	        if (isBlock) {
	          close();
	        }
	        for (var i = 0; i < node.childNodes.length; i++) {
	          walk(node.childNodes[i]);
	        }
	
	        if (/^(pre|p)$/i.test(node.nodeName)) {
	          extraLinebreak = true;
	        }
	        if (isBlock) {
	          closing = true;
	        }
	      } else if (node.nodeType == 3) {
	        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
	      }
	    }
	    for (;;) {
	      walk(from);
	      if (from == to) {
	        break;
	      }
	      from = from.nextSibling;
	      extraLinebreak = false;
	    }
	    return text;
	  }
	
	  function domToPos(cm, node, offset) {
	    var lineNode;
	    if (node == cm.display.lineDiv) {
	      lineNode = cm.display.lineDiv.childNodes[offset];
	      if (!lineNode) {
	        return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
	      }
	      node = null;offset = 0;
	    } else {
	      for (lineNode = node;; lineNode = lineNode.parentNode) {
	        if (!lineNode || lineNode == cm.display.lineDiv) {
	          return null;
	        }
	        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) {
	          break;
	        }
	      }
	    }
	    for (var i = 0; i < cm.display.view.length; i++) {
	      var lineView = cm.display.view[i];
	      if (lineView.node == lineNode) {
	        return locateNodeInLineView(lineView, node, offset);
	      }
	    }
	  }
	
	  function locateNodeInLineView(lineView, node, offset) {
	    var wrapper = lineView.text.firstChild,
	        bad = false;
	    if (!node || !contains(wrapper, node)) {
	      return badPos(Pos(lineNo(lineView.line), 0), true);
	    }
	    if (node == wrapper) {
	      bad = true;
	      node = wrapper.childNodes[offset];
	      offset = 0;
	      if (!node) {
	        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
	        return badPos(Pos(lineNo(line), line.text.length), bad);
	      }
	    }
	
	    var textNode = node.nodeType == 3 ? node : null,
	        topNode = node;
	    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	      textNode = node.firstChild;
	      if (offset) {
	        offset = textNode.nodeValue.length;
	      }
	    }
	    while (topNode.parentNode != wrapper) {
	      topNode = topNode.parentNode;
	    }
	    var measure = lineView.measure,
	        maps = measure.maps;
	
	    function find(textNode, topNode, offset) {
	      for (var i = -1; i < (maps ? maps.length : 0); i++) {
	        var map = i < 0 ? measure.map : maps[i];
	        for (var j = 0; j < map.length; j += 3) {
	          var curNode = map[j + 2];
	          if (curNode == textNode || curNode == topNode) {
	            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
	            var ch = map[j] + offset;
	            if (offset < 0 || curNode != textNode) {
	              ch = map[j + (offset ? 1 : 0)];
	            }
	            return Pos(line, ch);
	          }
	        }
	      }
	    }
	    var found = find(textNode, topNode, offset);
	    if (found) {
	      return badPos(found, bad);
	    }
	
	    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	      found = find(after, after.firstChild, 0);
	      if (found) {
	        return badPos(Pos(found.line, found.ch - dist), bad);
	      } else {
	        dist += after.textContent.length;
	      }
	    }
	    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
	      found = find(before, before.firstChild, -1);
	      if (found) {
	        return badPos(Pos(found.line, found.ch + dist$1), bad);
	      } else {
	        dist$1 += before.textContent.length;
	      }
	    }
	  }
	
	  // TEXTAREA INPUT STYLE
	
	  var TextareaInput = function TextareaInput(cm) {
	    this.cm = cm;
	    // See input.poll and input.reset
	    this.prevInput = "";
	
	    // Flag that indicates whether we expect input to appear real soon
	    // now (after some event like 'keypress' or 'input') and are
	    // polling intensively.
	    this.pollingFast = false;
	    // Self-resetting timeout for the poller
	    this.polling = new Delayed();
	    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	    this.hasSelection = false;
	    this.composing = null;
	    this.resetting = false;
	  };
	
	  TextareaInput.prototype.init = function (display) {
	    var this$1 = this;
	
	    var input = this,
	        cm = this.cm;
	    this.createField(display);
	    var te = this.textarea;
	
	    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
	
	    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	    if (ios) {
	      te.style.width = "0px";
	    }
	
	    on(te, "input", function () {
	      if (ie && ie_version >= 9 && this$1.hasSelection) {
	        this$1.hasSelection = null;
	      }
	      input.poll();
	    });
	
	    on(te, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) {
	        return;
	      }
	
	      cm.state.pasteIncoming = +new Date();
	      input.fastPoll();
	    });
	
	    function prepareCopyCut(e) {
	      if (signalDOMEvent(cm, e)) {
	        return;
	      }
	      if (cm.somethingSelected()) {
	        setLastCopied({ lineWise: false, text: cm.getSelections() });
	      } else if (!cm.options.lineWiseCopyCut) {
	        return;
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({ lineWise: true, text: ranges.text });
	        if (e.type == "cut") {
	          cm.setSelections(ranges.ranges, null, sel_dontScroll);
	        } else {
	          input.prevInput = "";
	          te.value = ranges.text.join("\n");
	          selectInput(te);
	        }
	      }
	      if (e.type == "cut") {
	        cm.state.cutIncoming = +new Date();
	      }
	    }
	    on(te, "cut", prepareCopyCut);
	    on(te, "copy", prepareCopyCut);
	
	    on(display.scroller, "paste", function (e) {
	      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) {
	        return;
	      }
	      if (!te.dispatchEvent) {
	        cm.state.pasteIncoming = +new Date();
	        input.focus();
	        return;
	      }
	
	      // Pass the `paste` event to the textarea so it's handled by its event listener.
	      var event = new Event("paste");
	      event.clipboardData = e.clipboardData;
	      te.dispatchEvent(event);
	    });
	
	    // Prevent normal selection in the editor (we handle our own)
	    on(display.lineSpace, "selectstart", function (e) {
	      if (!eventInWidget(display, e)) {
	        e_preventDefault(e);
	      }
	    });
	
	    on(te, "compositionstart", function () {
	      var start = cm.getCursor("from");
	      if (input.composing) {
	        input.composing.range.clear();
	      }
	      input.composing = {
	        start: start,
	        range: cm.markText(start, cm.getCursor("to"), { className: "CodeMirror-composing" })
	      };
	    });
	    on(te, "compositionend", function () {
	      if (input.composing) {
	        input.poll();
	        input.composing.range.clear();
	        input.composing = null;
	      }
	    });
	  };
	
	  TextareaInput.prototype.createField = function (_display) {
	    // Wraps and hides input textarea
	    this.wrapper = hiddenTextarea();
	    // The semihidden textarea that is focused when the editor is
	    // focused, and receives input.
	    this.textarea = this.wrapper.firstChild;
	    var opts = this.cm.options;
	    disableBrowserMagic(this.textarea, opts.spellcheck, opts.autocorrect, opts.autocapitalize);
	  };
	
	  TextareaInput.prototype.screenReaderLabelChanged = function (label) {
	    // Label for screenreaders, accessibility
	    if (label) {
	      this.textarea.setAttribute('aria-label', label);
	    } else {
	      this.textarea.removeAttribute('aria-label');
	    }
	  };
	
	  TextareaInput.prototype.prepareSelection = function () {
	    // Redraw the selection and/or cursor
	    var cm = this.cm,
	        display = cm.display,
	        doc = cm.doc;
	    var result = prepareSelection(cm);
	
	    // Move the hidden textarea near the cursor to prevent scrolling artifacts
	    if (cm.options.moveInputWithCursor) {
	      var headPos = _cursorCoords(cm, doc.sel.primary().head, "div");
	      var wrapOff = display.wrapper.getBoundingClientRect(),
	          lineOff = display.lineDiv.getBoundingClientRect();
	      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
	      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
	    }
	
	    return result;
	  };
	
	  TextareaInput.prototype.showSelection = function (drawn) {
	    var cm = this.cm,
	        display = cm.display;
	    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
	    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
	    if (drawn.teTop != null) {
	      this.wrapper.style.top = drawn.teTop + "px";
	      this.wrapper.style.left = drawn.teLeft + "px";
	    }
	  };
	
	  // Reset the input to correspond to the selection (or to be empty,
	  // when not typing and nothing is selected)
	  TextareaInput.prototype.reset = function (typing) {
	    if (this.contextMenuPending || this.composing && typing) {
	      return;
	    }
	    var cm = this.cm;
	    this.resetting = true;
	    if (cm.somethingSelected()) {
	      this.prevInput = "";
	      var content = cm.getSelection();
	      this.textarea.value = content;
	      if (cm.state.focused) {
	        selectInput(this.textarea);
	      }
	      if (ie && ie_version >= 9) {
	        this.hasSelection = content;
	      }
	    } else if (!typing) {
	      this.prevInput = this.textarea.value = "";
	      if (ie && ie_version >= 9) {
	        this.hasSelection = null;
	      }
	    }
	    this.resetting = false;
	  };
	
	  TextareaInput.prototype.getField = function () {
	    return this.textarea;
	  };
	
	  TextareaInput.prototype.supportsTouch = function () {
	    return false;
	  };
	
	  TextareaInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt(rootNode(this.textarea)) != this.textarea)) {
	      try {
	        this.textarea.focus();
	      } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	    }
	  };
	
	  TextareaInput.prototype.blur = function () {
	    this.textarea.blur();
	  };
	
	  TextareaInput.prototype.resetPosition = function () {
	    this.wrapper.style.top = this.wrapper.style.left = 0;
	  };
	
	  TextareaInput.prototype.receivedFocus = function () {
	    this.slowPoll();
	  };
	
	  // Poll for input changes, using the normal rate of polling. This
	  // runs as long as the editor is focused.
	  TextareaInput.prototype.slowPoll = function () {
	    var this$1 = this;
	
	    if (this.pollingFast) {
	      return;
	    }
	    this.polling.set(this.cm.options.pollInterval, function () {
	      this$1.poll();
	      if (this$1.cm.state.focused) {
	        this$1.slowPoll();
	      }
	    });
	  };
	
	  // When an event has just come in that is likely to add or change
	  // something in the input textarea, we poll faster, to ensure that
	  // the change appears on the screen quickly.
	  TextareaInput.prototype.fastPoll = function () {
	    var missed = false,
	        input = this;
	    input.pollingFast = true;
	    function p() {
	      var changed = input.poll();
	      if (!changed && !missed) {
	        missed = true;input.polling.set(60, p);
	      } else {
	        input.pollingFast = false;input.slowPoll();
	      }
	    }
	    input.polling.set(20, p);
	  };
	
	  // Read input from the textarea, and update the document to match.
	  // When something is selected, it is present in the textarea, and
	  // selected (unless it is huge, in which case a placeholder is
	  // used). When nothing is selected, the cursor sits after previously
	  // seen text (can be empty), which is stored in prevInput (we must
	  // not reset the textarea when typing, because that breaks IME).
	  TextareaInput.prototype.poll = function () {
	    var this$1 = this;
	
	    var cm = this.cm,
	        input = this.textarea,
	        prevInput = this.prevInput;
	    // Since this is called a *lot*, try to bail out as cheaply as
	    // possible when it is clear that nothing happened. hasSelection
	    // will be the case when there is a lot of text in the textarea,
	    // in which case reading its value would be expensive.
	    if (this.contextMenuPending || this.resetting || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) {
	      return false;
	    }
	
	    var text = input.value;
	    // If nothing changed, bail.
	    if (text == prevInput && !cm.somethingSelected()) {
	      return false;
	    }
	    // Work around nonsensical selection resetting in IE9/10, and
	    // inexplicable appearance of private area unicode characters on
	    // some key combos in Mac (#2689).
	    if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
	      cm.display.input.reset();
	      return false;
	    }
	
	    if (cm.doc.sel == cm.display.selForContextMenu) {
	      var first = text.charCodeAt(0);
	      if (first == 0x200b && !prevInput) {
	        prevInput = '\u200B';
	      }
	      if (first == 0x21da) {
	        this.reset();return this.cm.execCommand("undo");
	      }
	    }
	    // Find the part of the input that is actually new
	    var same = 0,
	        l = Math.min(prevInput.length, text.length);
	    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) {
	      ++same;
	    }
	
	    runInOp(cm, function () {
	      applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
	
	      // Don't leave long text in the textarea, since it makes further polling slow
	      if (text.length > 1000 || text.indexOf("\n") > -1) {
	        input.value = this$1.prevInput = "";
	      } else {
	        this$1.prevInput = text;
	      }
	
	      if (this$1.composing) {
	        this$1.composing.range.clear();
	        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), { className: "CodeMirror-composing" });
	      }
	    });
	    return true;
	  };
	
	  TextareaInput.prototype.ensurePolled = function () {
	    if (this.pollingFast && this.poll()) {
	      this.pollingFast = false;
	    }
	  };
	
	  TextareaInput.prototype.onKeyPress = function () {
	    if (ie && ie_version >= 9) {
	      this.hasSelection = null;
	    }
	    this.fastPoll();
	  };
	
	  TextareaInput.prototype.onContextMenu = function (e) {
	    var input = this,
	        cm = input.cm,
	        display = cm.display,
	        te = input.textarea;
	    if (input.contextMenuPending) {
	      input.contextMenuPending();
	    }
	    var pos = posFromMouse(cm, e),
	        scrollPos = display.scroller.scrollTop;
	    if (!pos || presto) {
	      return;
	    } // Opera is difficult.
	
	    // Reset the current text selection only if the click is done outside of the selection
	    // and 'resetSelectionOnContextMenu' option is true.
	    var reset = cm.options.resetSelectionOnContextMenu;
	    if (reset && cm.doc.sel.contains(pos) == -1) {
	      operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
	    }
	
	    var oldCSS = te.style.cssText,
	        oldWrapperCSS = input.wrapper.style.cssText;
	    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
	    input.wrapper.style.cssText = "position: static";
	    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
	    var oldScrollY;
	    if (webkit) {
	      oldScrollY = te.ownerDocument.defaultView.scrollY;
	    } // Work around Chrome issue (#2712)
	    display.input.focus();
	    if (webkit) {
	      te.ownerDocument.defaultView.scrollTo(null, oldScrollY);
	    }
	    display.input.reset();
	    // Adds "Select all" to context menu in FF
	    if (!cm.somethingSelected()) {
	      te.value = input.prevInput = " ";
	    }
	    input.contextMenuPending = rehide;
	    display.selForContextMenu = cm.doc.sel;
	    clearTimeout(display.detectingSelectAll);
	
	    // Select-all will be greyed out if there's nothing to select, so
	    // this adds a zero-width space so that we can later check whether
	    // it got selected.
	    function prepareSelectAllHack() {
	      if (te.selectionStart != null) {
	        var selected = cm.somethingSelected();
	        var extval = '\u200B' + (selected ? te.value : "");
	        te.value = '\u21DA'; // Used to catch context-menu undo
	        te.value = extval;
	        input.prevInput = selected ? "" : '\u200B';
	        te.selectionStart = 1;te.selectionEnd = extval.length;
	        // Re-set this, in case some other handler touched the
	        // selection in the meantime.
	        display.selForContextMenu = cm.doc.sel;
	      }
	    }
	    function rehide() {
	      if (input.contextMenuPending != rehide) {
	        return;
	      }
	      input.contextMenuPending = false;
	      input.wrapper.style.cssText = oldWrapperCSS;
	      te.style.cssText = oldCSS;
	      if (ie && ie_version < 9) {
	        display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
	      }
	
	      // Try to detect the user choosing select-all
	      if (te.selectionStart != null) {
	        if (!ie || ie && ie_version < 9) {
	          prepareSelectAllHack();
	        }
	        var i = 0,
	            poll = function poll() {
	          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == '\u200B') {
	            operation(cm, selectAll)(cm);
	          } else if (i++ < 10) {
	            display.detectingSelectAll = setTimeout(poll, 500);
	          } else {
	            display.selForContextMenu = null;
	            display.input.reset();
	          }
	        };
	        display.detectingSelectAll = setTimeout(poll, 200);
	      }
	    }
	
	    if (ie && ie_version >= 9) {
	      prepareSelectAllHack();
	    }
	    if (captureRightClick) {
	      e_stop(e);
	      var mouseup = function mouseup() {
	        off(window, "mouseup", mouseup);
	        setTimeout(rehide, 20);
	      };
	      on(window, "mouseup", mouseup);
	    } else {
	      setTimeout(rehide, 50);
	    }
	  };
	
	  TextareaInput.prototype.readOnlyChanged = function (val) {
	    if (!val) {
	      this.reset();
	    }
	    this.textarea.disabled = val == "nocursor";
	    this.textarea.readOnly = !!val;
	  };
	
	  TextareaInput.prototype.setUneditable = function () {};
	
	  TextareaInput.prototype.needsContentAttribute = false;
	
	  function fromTextArea(textarea, options) {
	    options = options ? copyObj(options) : {};
	    options.value = textarea.value;
	    if (!options.tabindex && textarea.tabIndex) {
	      options.tabindex = textarea.tabIndex;
	    }
	    if (!options.placeholder && textarea.placeholder) {
	      options.placeholder = textarea.placeholder;
	    }
	    // Set autofocus to true if this textarea is focused, or if it has
	    // autofocus and no other element is focused.
	    if (options.autofocus == null) {
	      var hasFocus = activeElt(rootNode(textarea));
	      options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
	    }
	
	    function save() {
	      textarea.value = cm.getValue();
	    }
	
	    var realSubmit;
	    if (textarea.form) {
	      on(textarea.form, "submit", save);
	      // Deplorable hack to make the submit method do the right thing.
	      if (!options.leaveSubmitMethodAlone) {
	        var form = textarea.form;
	        realSubmit = form.submit;
	        try {
	          var wrappedSubmit = form.submit = function () {
	            save();
	            form.submit = realSubmit;
	            form.submit();
	            form.submit = wrappedSubmit;
	          };
	        } catch (e) {}
	      }
	    }
	
	    options.finishInit = function (cm) {
	      cm.save = save;
	      cm.getTextArea = function () {
	        return textarea;
	      };
	      cm.toTextArea = function () {
	        cm.toTextArea = isNaN; // Prevent this from being ran twice
	        save();
	        textarea.parentNode.removeChild(cm.getWrapperElement());
	        textarea.style.display = "";
	        if (textarea.form) {
	          off(textarea.form, "submit", save);
	          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function") {
	            textarea.form.submit = realSubmit;
	          }
	        }
	      };
	    };
	
	    textarea.style.display = "none";
	    var cm = CodeMirror(function (node) {
	      return textarea.parentNode.insertBefore(node, textarea.nextSibling);
	    }, options);
	    return cm;
	  }
	
	  function addLegacyProps(CodeMirror) {
	    CodeMirror.off = off;
	    CodeMirror.on = on;
	    CodeMirror.wheelEventPixels = wheelEventPixels;
	    CodeMirror.Doc = Doc;
	    CodeMirror.splitLines = splitLinesAuto;
	    CodeMirror.countColumn = countColumn;
	    CodeMirror.findColumn = findColumn;
	    CodeMirror.isWordChar = isWordCharBasic;
	    CodeMirror.Pass = Pass;
	    CodeMirror.signal = signal;
	    CodeMirror.Line = Line;
	    CodeMirror.changeEnd = changeEnd;
	    CodeMirror.scrollbarModel = scrollbarModel;
	    CodeMirror.Pos = Pos;
	    CodeMirror.cmpPos = cmp;
	    CodeMirror.modes = modes;
	    CodeMirror.mimeModes = mimeModes;
	    CodeMirror.resolveMode = resolveMode;
	    CodeMirror.getMode = getMode;
	    CodeMirror.modeExtensions = modeExtensions;
	    CodeMirror.extendMode = extendMode;
	    CodeMirror.copyState = copyState;
	    CodeMirror.startState = startState;
	    CodeMirror.innerMode = innerMode;
	    CodeMirror.commands = commands;
	    CodeMirror.keyMap = keyMap;
	    CodeMirror.keyName = keyName;
	    CodeMirror.isModifierKey = isModifierKey;
	    CodeMirror.lookupKey = lookupKey;
	    CodeMirror.normalizeKeyMap = normalizeKeyMap;
	    CodeMirror.StringStream = StringStream;
	    CodeMirror.SharedTextMarker = SharedTextMarker;
	    CodeMirror.TextMarker = TextMarker;
	    CodeMirror.LineWidget = LineWidget;
	    CodeMirror.e_preventDefault = e_preventDefault;
	    CodeMirror.e_stopPropagation = e_stopPropagation;
	    CodeMirror.e_stop = e_stop;
	    CodeMirror.addClass = addClass;
	    CodeMirror.contains = contains;
	    CodeMirror.rmClass = rmClass;
	    CodeMirror.keyNames = keyNames;
	  }
	
	  // EDITOR CONSTRUCTOR
	
	  defineOptions(CodeMirror);
	
	  addEditorMethods(CodeMirror);
	
	  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
	  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
	  for (var prop in Doc.prototype) {
	    if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) {
	      CodeMirror.prototype[prop] = function (method) {
	        return function () {
	          return method.apply(this.doc, arguments);
	        };
	      }(Doc.prototype[prop]);
	    }
	  }
	
	  eventMixin(Doc);
	  CodeMirror.inputStyles = { "textarea": TextareaInput, "contenteditable": ContentEditableInput };
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  CodeMirror.defineMode = function (name /*, mode, …*/) {
	    if (!CodeMirror.defaults.mode && name != "null") {
	      CodeMirror.defaults.mode = name;
	    }
	    defineMode.apply(this, arguments);
	  };
	
	  CodeMirror.defineMIME = defineMIME;
	
	  // Minimal default mode.
	  CodeMirror.defineMode("null", function () {
	    return { token: function token(stream) {
	        return stream.skipToEnd();
	      } };
	  });
	  CodeMirror.defineMIME("text/plain", "null");
	
	  // EXTENSIONS
	
	  CodeMirror.defineExtension = function (name, func) {
	    CodeMirror.prototype[name] = func;
	  };
	  CodeMirror.defineDocExtension = function (name, func) {
	    Doc.prototype[name] = func;
	  };
	
	  CodeMirror.fromTextArea = fromTextArea;
	
	  addLegacyProps(CodeMirror);
	
	  CodeMirror.version = "5.65.19";
	
	  return CodeMirror;
	});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(10);

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) The code `if (__DEV__) ...` can be removed by build tool.
	// (2) If intend to use `__DEV__`, this module should be imported. Use a global
	// variable `__DEV__` may cause that miss the declaration (see #6535), or the
	// declaration is behind of the using position (for example in `Model.extent`,
	// And tools like rollup can not analysis the dependency if not import).
	var dev; // In browser
	
	if (typeof window !== 'undefined') {
	  dev = window.__DEV__;
	} // In node
	else if (typeof global !== 'undefined') {
	    dev = global.__DEV__;
	  }
	
	if (typeof dev === 'undefined') {
	  dev = true;
	}
	
	var __DEV__ = dev;
	exports.__DEV__ = __DEV__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(70));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(70)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Cipher core components.
	  */
		CryptoJS.lib.Cipher || function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
			var C_enc = C.enc;
			var Utf8 = C_enc.Utf8;
			var Base64 = C_enc.Base64;
			var C_algo = C.algo;
			var EvpKDF = C_algo.EvpKDF;
	
			/**
	   * Abstract base cipher template.
	   *
	   * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	   * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	   * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	   * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	   */
			var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
				/**
	    * Configuration options.
	    *
	    * @property {WordArray} iv The IV to use for this operation.
	    */
				cfg: Base.extend(),
	
				/**
	    * Creates this cipher in encryption mode.
	    *
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {Cipher} A cipher instance.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	    */
				createEncryptor: function createEncryptor(key, cfg) {
					return this.create(this._ENC_XFORM_MODE, key, cfg);
				},
	
				/**
	    * Creates this cipher in decryption mode.
	    *
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {Cipher} A cipher instance.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	    */
				createDecryptor: function createDecryptor(key, cfg) {
					return this.create(this._DEC_XFORM_MODE, key, cfg);
				},
	
				/**
	    * Initializes a newly created cipher.
	    *
	    * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	    */
				init: function init(xformMode, key, cfg) {
					// Apply config defaults
					this.cfg = this.cfg.extend(cfg);
	
					// Store transform mode and key
					this._xformMode = xformMode;
					this._key = key;
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this cipher to its initial state.
	    *
	    * @example
	    *
	    *     cipher.reset();
	    */
				reset: function reset() {
					// Reset data buffer
					BufferedBlockAlgorithm.reset.call(this);
	
					// Perform concrete-cipher logic
					this._doReset();
				},
	
				/**
	    * Adds data to be encrypted or decrypted.
	    *
	    * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	    *
	    * @return {WordArray} The data after processing.
	    *
	    * @example
	    *
	    *     var encrypted = cipher.process('data');
	    *     var encrypted = cipher.process(wordArray);
	    */
				process: function process(dataUpdate) {
					// Append
					this._append(dataUpdate);
	
					// Process available blocks
					return this._process();
				},
	
				/**
	    * Finalizes the encryption or decryption process.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	    *
	    * @return {WordArray} The data after final processing.
	    *
	    * @example
	    *
	    *     var encrypted = cipher.finalize();
	    *     var encrypted = cipher.finalize('data');
	    *     var encrypted = cipher.finalize(wordArray);
	    */
				finalize: function finalize(dataUpdate) {
					// Final data update
					if (dataUpdate) {
						this._append(dataUpdate);
					}
	
					// Perform concrete-cipher logic
					var finalProcessedData = this._doFinalize();
	
					return finalProcessedData;
				},
	
				keySize: 128 / 32,
	
				ivSize: 128 / 32,
	
				_ENC_XFORM_MODE: 1,
	
				_DEC_XFORM_MODE: 2,
	
				/**
	    * Creates shortcut functions to a cipher's object interface.
	    *
	    * @param {Cipher} cipher The cipher to create a helper for.
	    *
	    * @return {Object} An object with encrypt and decrypt shortcut functions.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	    */
				_createHelper: function () {
					function selectCipherStrategy(key) {
						if (typeof key == 'string') {
							return PasswordBasedCipher;
						} else {
							return SerializableCipher;
						}
					}
	
					return function (cipher) {
						return {
							encrypt: function encrypt(message, key, cfg) {
								return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
							},
	
							decrypt: function decrypt(ciphertext, key, cfg) {
								return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
							}
						};
					};
				}()
			});
	
			/**
	   * Abstract base stream cipher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	   */
			var StreamCipher = C_lib.StreamCipher = Cipher.extend({
				_doFinalize: function _doFinalize() {
					// Process partial blocks
					var finalProcessedBlocks = this._process(!!'flush');
	
					return finalProcessedBlocks;
				},
	
				blockSize: 1
			});
	
			/**
	   * Mode namespace.
	   */
			var C_mode = C.mode = {};
	
			/**
	   * Abstract base block cipher mode template.
	   */
			var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
				/**
	    * Creates this mode for encryption.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	    */
				createEncryptor: function createEncryptor(cipher, iv) {
					return this.Encryptor.create(cipher, iv);
				},
	
				/**
	    * Creates this mode for decryption.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	    */
				createDecryptor: function createDecryptor(cipher, iv) {
					return this.Decryptor.create(cipher, iv);
				},
	
				/**
	    * Initializes a newly created mode.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	    */
				init: function init(cipher, iv) {
					this._cipher = cipher;
					this._iv = iv;
				}
			});
	
			/**
	   * Cipher Block Chaining mode.
	   */
			var CBC = C_mode.CBC = function () {
				/**
	    * Abstract base CBC mode.
	    */
				var CBC = BlockCipherMode.extend();
	
				/**
	    * CBC encryptor.
	    */
				CBC.Encryptor = CBC.extend({
					/**
	     * Processes the data block at offset.
	     *
	     * @param {Array} words The data words to operate on.
	     * @param {number} offset The offset where the block starts.
	     *
	     * @example
	     *
	     *     mode.processBlock(data.words, offset);
	     */
					processBlock: function processBlock(words, offset) {
						// Shortcuts
						var cipher = this._cipher;
						var blockSize = cipher.blockSize;
	
						// XOR and encrypt
						xorBlock.call(this, words, offset, blockSize);
						cipher.encryptBlock(words, offset);
	
						// Remember this block to use with next block
						this._prevBlock = words.slice(offset, offset + blockSize);
					}
				});
	
				/**
	    * CBC decryptor.
	    */
				CBC.Decryptor = CBC.extend({
					/**
	     * Processes the data block at offset.
	     *
	     * @param {Array} words The data words to operate on.
	     * @param {number} offset The offset where the block starts.
	     *
	     * @example
	     *
	     *     mode.processBlock(data.words, offset);
	     */
					processBlock: function processBlock(words, offset) {
						// Shortcuts
						var cipher = this._cipher;
						var blockSize = cipher.blockSize;
	
						// Remember this block to use with next block
						var thisBlock = words.slice(offset, offset + blockSize);
	
						// Decrypt and XOR
						cipher.decryptBlock(words, offset);
						xorBlock.call(this, words, offset, blockSize);
	
						// This block becomes the previous block
						this._prevBlock = thisBlock;
					}
				});
	
				function xorBlock(words, offset, blockSize) {
					var block;
	
					// Shortcut
					var iv = this._iv;
	
					// Choose mixing block
					if (iv) {
						block = iv;
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					} else {
						block = this._prevBlock;
					}
	
					// XOR blocks
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= block[i];
					}
				}
	
				return CBC;
			}();
	
			/**
	   * Padding namespace.
	   */
			var C_pad = C.pad = {};
	
			/**
	   * PKCS #5/7 padding strategy.
	   */
			var Pkcs7 = C_pad.Pkcs7 = {
				/**
	    * Pads data using the algorithm defined in PKCS #5/7.
	    *
	    * @param {WordArray} data The data to pad.
	    * @param {number} blockSize The multiple that the data should be padded to.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	    */
				pad: function pad(data, blockSize) {
					// Shortcut
					var blockSizeBytes = blockSize * 4;
	
					// Count padding bytes
					var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
					// Create padding word
					var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
	
					// Create padding
					var paddingWords = [];
					for (var i = 0; i < nPaddingBytes; i += 4) {
						paddingWords.push(paddingWord);
					}
					var padding = WordArray.create(paddingWords, nPaddingBytes);
	
					// Add padding
					data.concat(padding);
				},
	
				/**
	    * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	    *
	    * @param {WordArray} data The data to unpad.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	    */
				unpad: function unpad(data) {
					// Get number of padding bytes from last byte
					var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
					// Remove padding
					data.sigBytes -= nPaddingBytes;
				}
			};
	
			/**
	   * Abstract base block cipher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	   */
			var BlockCipher = C_lib.BlockCipher = Cipher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {Mode} mode The block mode to use. Default: CBC
	    * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	    */
				cfg: Cipher.cfg.extend({
					mode: CBC,
					padding: Pkcs7
				}),
	
				reset: function reset() {
					var modeCreator;
	
					// Reset cipher
					Cipher.reset.call(this);
	
					// Shortcuts
					var cfg = this.cfg;
					var iv = cfg.iv;
					var mode = cfg.mode;
	
					// Reset block mode
					if (this._xformMode == this._ENC_XFORM_MODE) {
						modeCreator = mode.createEncryptor;
					} else /* if (this._xformMode == this._DEC_XFORM_MODE) */{
							modeCreator = mode.createDecryptor;
							// Keep at least one block in the buffer for unpadding
							this._minBufferSize = 1;
						}
	
					if (this._mode && this._mode.__creator == modeCreator) {
						this._mode.init(this, iv && iv.words);
					} else {
						this._mode = modeCreator.call(mode, this, iv && iv.words);
						this._mode.__creator = modeCreator;
					}
				},
	
				_doProcessBlock: function _doProcessBlock(words, offset) {
					this._mode.processBlock(words, offset);
				},
	
				_doFinalize: function _doFinalize() {
					var finalProcessedBlocks;
	
					// Shortcut
					var padding = this.cfg.padding;
	
					// Finalize
					if (this._xformMode == this._ENC_XFORM_MODE) {
						// Pad data
						padding.pad(this._data, this.blockSize);
	
						// Process final blocks
						finalProcessedBlocks = this._process(!!'flush');
					} else /* if (this._xformMode == this._DEC_XFORM_MODE) */{
							// Process final blocks
							finalProcessedBlocks = this._process(!!'flush');
	
							// Unpad data
							padding.unpad(finalProcessedBlocks);
						}
	
					return finalProcessedBlocks;
				},
	
				blockSize: 128 / 32
			});
	
			/**
	   * A collection of cipher parameters.
	   *
	   * @property {WordArray} ciphertext The raw ciphertext.
	   * @property {WordArray} key The key to this ciphertext.
	   * @property {WordArray} iv The IV used in the ciphering operation.
	   * @property {WordArray} salt The salt used with a key derivation function.
	   * @property {Cipher} algorithm The cipher algorithm.
	   * @property {Mode} mode The block mode used in the ciphering operation.
	   * @property {Padding} padding The padding scheme used in the ciphering operation.
	   * @property {number} blockSize The block size of the cipher.
	   * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	   */
			var CipherParams = C_lib.CipherParams = Base.extend({
				/**
	    * Initializes a newly created cipher params object.
	    *
	    * @param {Object} cipherParams An object with any of the possible cipher parameters.
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.lib.CipherParams.create({
	    *         ciphertext: ciphertextWordArray,
	    *         key: keyWordArray,
	    *         iv: ivWordArray,
	    *         salt: saltWordArray,
	    *         algorithm: CryptoJS.algo.AES,
	    *         mode: CryptoJS.mode.CBC,
	    *         padding: CryptoJS.pad.PKCS7,
	    *         blockSize: 4,
	    *         formatter: CryptoJS.format.OpenSSL
	    *     });
	    */
				init: function init(cipherParams) {
					this.mixIn(cipherParams);
				},
	
				/**
	    * Converts this cipher params object to a string.
	    *
	    * @param {Format} formatter (Optional) The formatting strategy to use.
	    *
	    * @return {string} The stringified cipher params.
	    *
	    * @throws Error If neither the formatter nor the default formatter is set.
	    *
	    * @example
	    *
	    *     var string = cipherParams + '';
	    *     var string = cipherParams.toString();
	    *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	    */
				toString: function toString(formatter) {
					return (formatter || this.formatter).stringify(this);
				}
			});
	
			/**
	   * Format namespace.
	   */
			var C_format = C.format = {};
	
			/**
	   * OpenSSL formatting strategy.
	   */
			var OpenSSLFormatter = C_format.OpenSSL = {
				/**
	    * Converts a cipher params object to an OpenSSL-compatible string.
	    *
	    * @param {CipherParams} cipherParams The cipher params object.
	    *
	    * @return {string} The OpenSSL-compatible string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	    */
				stringify: function stringify(cipherParams) {
					var wordArray;
	
					// Shortcuts
					var ciphertext = cipherParams.ciphertext;
					var salt = cipherParams.salt;
	
					// Format
					if (salt) {
						wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
					} else {
						wordArray = ciphertext;
					}
	
					return wordArray.toString(Base64);
				},
	
				/**
	    * Converts an OpenSSL-compatible string to a cipher params object.
	    *
	    * @param {string} openSSLStr The OpenSSL-compatible string.
	    *
	    * @return {CipherParams} The cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	    */
				parse: function parse(openSSLStr) {
					var salt;
	
					// Parse base64
					var ciphertext = Base64.parse(openSSLStr);
	
					// Shortcut
					var ciphertextWords = ciphertext.words;
	
					// Test for salt
					if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
						// Extract salt
						salt = WordArray.create(ciphertextWords.slice(2, 4));
	
						// Remove salt from ciphertext
						ciphertextWords.splice(0, 4);
						ciphertext.sigBytes -= 16;
					}
	
					return CipherParams.create({ ciphertext: ciphertext, salt: salt });
				}
			};
	
			/**
	   * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	   */
			var SerializableCipher = C_lib.SerializableCipher = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	    */
				cfg: Base.extend({
					format: OpenSSLFormatter
				}),
	
				/**
	    * Encrypts a message.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {WordArray|string} message The message to encrypt.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {CipherParams} A cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    */
				encrypt: function encrypt(cipher, message, key, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Encrypt
					var encryptor = cipher.createEncryptor(key, cfg);
					var ciphertext = encryptor.finalize(message);
	
					// Shortcut
					var cipherCfg = encryptor.cfg;
	
					// Create and return serializable cipher params
					return CipherParams.create({
						ciphertext: ciphertext,
						key: key,
						iv: cipherCfg.iv,
						algorithm: cipher,
						mode: cipherCfg.mode,
						padding: cipherCfg.padding,
						blockSize: cipher.blockSize,
						formatter: cfg.format
					});
				},
	
				/**
	    * Decrypts serialized ciphertext.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {WordArray} The plaintext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    */
				decrypt: function decrypt(cipher, ciphertext, key, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Convert string to CipherParams
					ciphertext = this._parse(ciphertext, cfg.format);
	
					// Decrypt
					var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
					return plaintext;
				},
	
				/**
	    * Converts serialized ciphertext to CipherParams,
	    * else assumed CipherParams already and returns ciphertext unchanged.
	    *
	    * @param {CipherParams|string} ciphertext The ciphertext.
	    * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	    *
	    * @return {CipherParams} The unserialized ciphertext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	    */
				_parse: function _parse(ciphertext, format) {
					if (typeof ciphertext == 'string') {
						return format.parse(ciphertext, this);
					} else {
						return ciphertext;
					}
				}
			});
	
			/**
	   * Key derivation function namespace.
	   */
			var C_kdf = C.kdf = {};
	
			/**
	   * OpenSSL key derivation function.
	   */
			var OpenSSLKdf = C_kdf.OpenSSL = {
				/**
	    * Derives a key and IV from a password.
	    *
	    * @param {string} password The password to derive from.
	    * @param {number} keySize The size in words of the key to generate.
	    * @param {number} ivSize The size in words of the IV to generate.
	    * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	    *
	    * @return {CipherParams} A cipher params object with the key, IV, and salt.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	    *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	    */
				execute: function execute(password, keySize, ivSize, salt, hasher) {
					// Generate random salt
					if (!salt) {
						salt = WordArray.random(64 / 8);
					}
	
					// Derive key and IV
					if (!hasher) {
						var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
					} else {
						var key = EvpKDF.create({ keySize: keySize + ivSize, hasher: hasher }).compute(password, salt);
					}
	
					// Separate key and IV
					var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
					key.sigBytes = keySize * 4;
	
					// Return params
					return CipherParams.create({ key: key, iv: iv, salt: salt });
				}
			};
	
			/**
	   * A serializable cipher wrapper that derives the key from a password,
	   * and returns ciphertext as a serializable cipher params object.
	   */
			var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	    */
				cfg: SerializableCipher.cfg.extend({
					kdf: OpenSSLKdf
				}),
	
				/**
	    * Encrypts a message using a password.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {WordArray|string} message The message to encrypt.
	    * @param {string} password The password.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {CipherParams} A cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	    *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	    */
				encrypt: function encrypt(cipher, message, password, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Derive key and other params
					var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
	
					// Add IV to config
					cfg.iv = derivedParams.iv;
	
					// Encrypt
					var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
					// Mix in derived params
					ciphertext.mixIn(derivedParams);
	
					return ciphertext;
				},
	
				/**
	    * Decrypts serialized ciphertext using a password.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	    * @param {string} password The password.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {WordArray} The plaintext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	    *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	    */
				decrypt: function decrypt(cipher, ciphertext, password, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Convert string to CipherParams
					ciphertext = this._parse(ciphertext, cfg.format);
	
					// Derive key and other params
					var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
	
					// Add IV to config
					cfg.iv = derivedParams.iv;
	
					// Decrypt
					var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
					return plaintext;
				}
			});
		}();
	});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "resetWarned", {
	  enumerable: true,
	  get: function get() {
	    return _warning.resetWarned;
	  }
	});
	exports["default"] = void 0;
	
	var _warning = _interopRequireWildcard(__webpack_require__(478));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var _default = function _default(valid, component, message) {
	  (0, _warning["default"])(valid, "[antd: ".concat(component, "] ").concat(message));
	};
	
	exports["default"] = _default;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(71));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(71)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Cipher core components.
	  */
		CryptoJS.lib.Cipher || function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
			var C_enc = C.enc;
			var Utf8 = C_enc.Utf8;
			var Base64 = C_enc.Base64;
			var C_algo = C.algo;
			var EvpKDF = C_algo.EvpKDF;
	
			/**
	   * Abstract base cipher template.
	   *
	   * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	   * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	   * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	   * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	   */
			var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
				/**
	    * Configuration options.
	    *
	    * @property {WordArray} iv The IV to use for this operation.
	    */
				cfg: Base.extend(),
	
				/**
	    * Creates this cipher in encryption mode.
	    *
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {Cipher} A cipher instance.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	    */
				createEncryptor: function createEncryptor(key, cfg) {
					return this.create(this._ENC_XFORM_MODE, key, cfg);
				},
	
				/**
	    * Creates this cipher in decryption mode.
	    *
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {Cipher} A cipher instance.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	    */
				createDecryptor: function createDecryptor(key, cfg) {
					return this.create(this._DEC_XFORM_MODE, key, cfg);
				},
	
				/**
	    * Initializes a newly created cipher.
	    *
	    * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	    */
				init: function init(xformMode, key, cfg) {
					// Apply config defaults
					this.cfg = this.cfg.extend(cfg);
	
					// Store transform mode and key
					this._xformMode = xformMode;
					this._key = key;
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this cipher to its initial state.
	    *
	    * @example
	    *
	    *     cipher.reset();
	    */
				reset: function reset() {
					// Reset data buffer
					BufferedBlockAlgorithm.reset.call(this);
	
					// Perform concrete-cipher logic
					this._doReset();
				},
	
				/**
	    * Adds data to be encrypted or decrypted.
	    *
	    * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	    *
	    * @return {WordArray} The data after processing.
	    *
	    * @example
	    *
	    *     var encrypted = cipher.process('data');
	    *     var encrypted = cipher.process(wordArray);
	    */
				process: function process(dataUpdate) {
					// Append
					this._append(dataUpdate);
	
					// Process available blocks
					return this._process();
				},
	
				/**
	    * Finalizes the encryption or decryption process.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	    *
	    * @return {WordArray} The data after final processing.
	    *
	    * @example
	    *
	    *     var encrypted = cipher.finalize();
	    *     var encrypted = cipher.finalize('data');
	    *     var encrypted = cipher.finalize(wordArray);
	    */
				finalize: function finalize(dataUpdate) {
					// Final data update
					if (dataUpdate) {
						this._append(dataUpdate);
					}
	
					// Perform concrete-cipher logic
					var finalProcessedData = this._doFinalize();
	
					return finalProcessedData;
				},
	
				keySize: 128 / 32,
	
				ivSize: 128 / 32,
	
				_ENC_XFORM_MODE: 1,
	
				_DEC_XFORM_MODE: 2,
	
				/**
	    * Creates shortcut functions to a cipher's object interface.
	    *
	    * @param {Cipher} cipher The cipher to create a helper for.
	    *
	    * @return {Object} An object with encrypt and decrypt shortcut functions.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	    */
				_createHelper: function () {
					function selectCipherStrategy(key) {
						if (typeof key == 'string') {
							return PasswordBasedCipher;
						} else {
							return SerializableCipher;
						}
					}
	
					return function (cipher) {
						return {
							encrypt: function encrypt(message, key, cfg) {
								return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
							},
	
							decrypt: function decrypt(ciphertext, key, cfg) {
								return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
							}
						};
					};
				}()
			});
	
			/**
	   * Abstract base stream cipher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	   */
			var StreamCipher = C_lib.StreamCipher = Cipher.extend({
				_doFinalize: function _doFinalize() {
					// Process partial blocks
					var finalProcessedBlocks = this._process(!!'flush');
	
					return finalProcessedBlocks;
				},
	
				blockSize: 1
			});
	
			/**
	   * Mode namespace.
	   */
			var C_mode = C.mode = {};
	
			/**
	   * Abstract base block cipher mode template.
	   */
			var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
				/**
	    * Creates this mode for encryption.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	    */
				createEncryptor: function createEncryptor(cipher, iv) {
					return this.Encryptor.create(cipher, iv);
				},
	
				/**
	    * Creates this mode for decryption.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	    */
				createDecryptor: function createDecryptor(cipher, iv) {
					return this.Decryptor.create(cipher, iv);
				},
	
				/**
	    * Initializes a newly created mode.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	    */
				init: function init(cipher, iv) {
					this._cipher = cipher;
					this._iv = iv;
				}
			});
	
			/**
	   * Cipher Block Chaining mode.
	   */
			var CBC = C_mode.CBC = function () {
				/**
	    * Abstract base CBC mode.
	    */
				var CBC = BlockCipherMode.extend();
	
				/**
	    * CBC encryptor.
	    */
				CBC.Encryptor = CBC.extend({
					/**
	     * Processes the data block at offset.
	     *
	     * @param {Array} words The data words to operate on.
	     * @param {number} offset The offset where the block starts.
	     *
	     * @example
	     *
	     *     mode.processBlock(data.words, offset);
	     */
					processBlock: function processBlock(words, offset) {
						// Shortcuts
						var cipher = this._cipher;
						var blockSize = cipher.blockSize;
	
						// XOR and encrypt
						xorBlock.call(this, words, offset, blockSize);
						cipher.encryptBlock(words, offset);
	
						// Remember this block to use with next block
						this._prevBlock = words.slice(offset, offset + blockSize);
					}
				});
	
				/**
	    * CBC decryptor.
	    */
				CBC.Decryptor = CBC.extend({
					/**
	     * Processes the data block at offset.
	     *
	     * @param {Array} words The data words to operate on.
	     * @param {number} offset The offset where the block starts.
	     *
	     * @example
	     *
	     *     mode.processBlock(data.words, offset);
	     */
					processBlock: function processBlock(words, offset) {
						// Shortcuts
						var cipher = this._cipher;
						var blockSize = cipher.blockSize;
	
						// Remember this block to use with next block
						var thisBlock = words.slice(offset, offset + blockSize);
	
						// Decrypt and XOR
						cipher.decryptBlock(words, offset);
						xorBlock.call(this, words, offset, blockSize);
	
						// This block becomes the previous block
						this._prevBlock = thisBlock;
					}
				});
	
				function xorBlock(words, offset, blockSize) {
					var block;
	
					// Shortcut
					var iv = this._iv;
	
					// Choose mixing block
					if (iv) {
						block = iv;
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					} else {
						block = this._prevBlock;
					}
	
					// XOR blocks
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= block[i];
					}
				}
	
				return CBC;
			}();
	
			/**
	   * Padding namespace.
	   */
			var C_pad = C.pad = {};
	
			/**
	   * PKCS #5/7 padding strategy.
	   */
			var Pkcs7 = C_pad.Pkcs7 = {
				/**
	    * Pads data using the algorithm defined in PKCS #5/7.
	    *
	    * @param {WordArray} data The data to pad.
	    * @param {number} blockSize The multiple that the data should be padded to.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	    */
				pad: function pad(data, blockSize) {
					// Shortcut
					var blockSizeBytes = blockSize * 4;
	
					// Count padding bytes
					var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
					// Create padding word
					var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
	
					// Create padding
					var paddingWords = [];
					for (var i = 0; i < nPaddingBytes; i += 4) {
						paddingWords.push(paddingWord);
					}
					var padding = WordArray.create(paddingWords, nPaddingBytes);
	
					// Add padding
					data.concat(padding);
				},
	
				/**
	    * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	    *
	    * @param {WordArray} data The data to unpad.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	    */
				unpad: function unpad(data) {
					// Get number of padding bytes from last byte
					var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
					// Remove padding
					data.sigBytes -= nPaddingBytes;
				}
			};
	
			/**
	   * Abstract base block cipher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	   */
			var BlockCipher = C_lib.BlockCipher = Cipher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {Mode} mode The block mode to use. Default: CBC
	    * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	    */
				cfg: Cipher.cfg.extend({
					mode: CBC,
					padding: Pkcs7
				}),
	
				reset: function reset() {
					var modeCreator;
	
					// Reset cipher
					Cipher.reset.call(this);
	
					// Shortcuts
					var cfg = this.cfg;
					var iv = cfg.iv;
					var mode = cfg.mode;
	
					// Reset block mode
					if (this._xformMode == this._ENC_XFORM_MODE) {
						modeCreator = mode.createEncryptor;
					} else /* if (this._xformMode == this._DEC_XFORM_MODE) */{
							modeCreator = mode.createDecryptor;
							// Keep at least one block in the buffer for unpadding
							this._minBufferSize = 1;
						}
	
					if (this._mode && this._mode.__creator == modeCreator) {
						this._mode.init(this, iv && iv.words);
					} else {
						this._mode = modeCreator.call(mode, this, iv && iv.words);
						this._mode.__creator = modeCreator;
					}
				},
	
				_doProcessBlock: function _doProcessBlock(words, offset) {
					this._mode.processBlock(words, offset);
				},
	
				_doFinalize: function _doFinalize() {
					var finalProcessedBlocks;
	
					// Shortcut
					var padding = this.cfg.padding;
	
					// Finalize
					if (this._xformMode == this._ENC_XFORM_MODE) {
						// Pad data
						padding.pad(this._data, this.blockSize);
	
						// Process final blocks
						finalProcessedBlocks = this._process(!!'flush');
					} else /* if (this._xformMode == this._DEC_XFORM_MODE) */{
							// Process final blocks
							finalProcessedBlocks = this._process(!!'flush');
	
							// Unpad data
							padding.unpad(finalProcessedBlocks);
						}
	
					return finalProcessedBlocks;
				},
	
				blockSize: 128 / 32
			});
	
			/**
	   * A collection of cipher parameters.
	   *
	   * @property {WordArray} ciphertext The raw ciphertext.
	   * @property {WordArray} key The key to this ciphertext.
	   * @property {WordArray} iv The IV used in the ciphering operation.
	   * @property {WordArray} salt The salt used with a key derivation function.
	   * @property {Cipher} algorithm The cipher algorithm.
	   * @property {Mode} mode The block mode used in the ciphering operation.
	   * @property {Padding} padding The padding scheme used in the ciphering operation.
	   * @property {number} blockSize The block size of the cipher.
	   * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	   */
			var CipherParams = C_lib.CipherParams = Base.extend({
				/**
	    * Initializes a newly created cipher params object.
	    *
	    * @param {Object} cipherParams An object with any of the possible cipher parameters.
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.lib.CipherParams.create({
	    *         ciphertext: ciphertextWordArray,
	    *         key: keyWordArray,
	    *         iv: ivWordArray,
	    *         salt: saltWordArray,
	    *         algorithm: CryptoJS.algo.AES,
	    *         mode: CryptoJS.mode.CBC,
	    *         padding: CryptoJS.pad.PKCS7,
	    *         blockSize: 4,
	    *         formatter: CryptoJS.format.OpenSSL
	    *     });
	    */
				init: function init(cipherParams) {
					this.mixIn(cipherParams);
				},
	
				/**
	    * Converts this cipher params object to a string.
	    *
	    * @param {Format} formatter (Optional) The formatting strategy to use.
	    *
	    * @return {string} The stringified cipher params.
	    *
	    * @throws Error If neither the formatter nor the default formatter is set.
	    *
	    * @example
	    *
	    *     var string = cipherParams + '';
	    *     var string = cipherParams.toString();
	    *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	    */
				toString: function toString(formatter) {
					return (formatter || this.formatter).stringify(this);
				}
			});
	
			/**
	   * Format namespace.
	   */
			var C_format = C.format = {};
	
			/**
	   * OpenSSL formatting strategy.
	   */
			var OpenSSLFormatter = C_format.OpenSSL = {
				/**
	    * Converts a cipher params object to an OpenSSL-compatible string.
	    *
	    * @param {CipherParams} cipherParams The cipher params object.
	    *
	    * @return {string} The OpenSSL-compatible string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	    */
				stringify: function stringify(cipherParams) {
					var wordArray;
	
					// Shortcuts
					var ciphertext = cipherParams.ciphertext;
					var salt = cipherParams.salt;
	
					// Format
					if (salt) {
						wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
					} else {
						wordArray = ciphertext;
					}
	
					return wordArray.toString(Base64);
				},
	
				/**
	    * Converts an OpenSSL-compatible string to a cipher params object.
	    *
	    * @param {string} openSSLStr The OpenSSL-compatible string.
	    *
	    * @return {CipherParams} The cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	    */
				parse: function parse(openSSLStr) {
					var salt;
	
					// Parse base64
					var ciphertext = Base64.parse(openSSLStr);
	
					// Shortcut
					var ciphertextWords = ciphertext.words;
	
					// Test for salt
					if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
						// Extract salt
						salt = WordArray.create(ciphertextWords.slice(2, 4));
	
						// Remove salt from ciphertext
						ciphertextWords.splice(0, 4);
						ciphertext.sigBytes -= 16;
					}
	
					return CipherParams.create({ ciphertext: ciphertext, salt: salt });
				}
			};
	
			/**
	   * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	   */
			var SerializableCipher = C_lib.SerializableCipher = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	    */
				cfg: Base.extend({
					format: OpenSSLFormatter
				}),
	
				/**
	    * Encrypts a message.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {WordArray|string} message The message to encrypt.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {CipherParams} A cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    */
				encrypt: function encrypt(cipher, message, key, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Encrypt
					var encryptor = cipher.createEncryptor(key, cfg);
					var ciphertext = encryptor.finalize(message);
	
					// Shortcut
					var cipherCfg = encryptor.cfg;
	
					// Create and return serializable cipher params
					return CipherParams.create({
						ciphertext: ciphertext,
						key: key,
						iv: cipherCfg.iv,
						algorithm: cipher,
						mode: cipherCfg.mode,
						padding: cipherCfg.padding,
						blockSize: cipher.blockSize,
						formatter: cfg.format
					});
				},
	
				/**
	    * Decrypts serialized ciphertext.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {WordArray} The plaintext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    */
				decrypt: function decrypt(cipher, ciphertext, key, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Convert string to CipherParams
					ciphertext = this._parse(ciphertext, cfg.format);
	
					// Decrypt
					var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
					return plaintext;
				},
	
				/**
	    * Converts serialized ciphertext to CipherParams,
	    * else assumed CipherParams already and returns ciphertext unchanged.
	    *
	    * @param {CipherParams|string} ciphertext The ciphertext.
	    * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	    *
	    * @return {CipherParams} The unserialized ciphertext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	    */
				_parse: function _parse(ciphertext, format) {
					if (typeof ciphertext == 'string') {
						return format.parse(ciphertext, this);
					} else {
						return ciphertext;
					}
				}
			});
	
			/**
	   * Key derivation function namespace.
	   */
			var C_kdf = C.kdf = {};
	
			/**
	   * OpenSSL key derivation function.
	   */
			var OpenSSLKdf = C_kdf.OpenSSL = {
				/**
	    * Derives a key and IV from a password.
	    *
	    * @param {string} password The password to derive from.
	    * @param {number} keySize The size in words of the key to generate.
	    * @param {number} ivSize The size in words of the IV to generate.
	    * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	    *
	    * @return {CipherParams} A cipher params object with the key, IV, and salt.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	    *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	    */
				execute: function execute(password, keySize, ivSize, salt, hasher) {
					// Generate random salt
					if (!salt) {
						salt = WordArray.random(64 / 8);
					}
	
					// Derive key and IV
					if (!hasher) {
						var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
					} else {
						var key = EvpKDF.create({ keySize: keySize + ivSize, hasher: hasher }).compute(password, salt);
					}
	
					// Separate key and IV
					var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
					key.sigBytes = keySize * 4;
	
					// Return params
					return CipherParams.create({ key: key, iv: iv, salt: salt });
				}
			};
	
			/**
	   * A serializable cipher wrapper that derives the key from a password,
	   * and returns ciphertext as a serializable cipher params object.
	   */
			var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	    */
				cfg: SerializableCipher.cfg.extend({
					kdf: OpenSSLKdf
				}),
	
				/**
	    * Encrypts a message using a password.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {WordArray|string} message The message to encrypt.
	    * @param {string} password The password.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {CipherParams} A cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	    *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	    */
				encrypt: function encrypt(cipher, message, password, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Derive key and other params
					var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
	
					// Add IV to config
					cfg.iv = derivedParams.iv;
	
					// Encrypt
					var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
					// Mix in derived params
					ciphertext.mixIn(derivedParams);
	
					return ciphertext;
				},
	
				/**
	    * Decrypts serialized ciphertext using a password.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	    * @param {string} password The password.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {WordArray} The plaintext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	    *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	    */
				decrypt: function decrypt(cipher, ciphertext, password, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Convert string to CipherParams
					ciphertext = this._parse(ciphertext, cfg.format);
	
					// Derive key and other params
					var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
	
					// Add IV to config
					cfg.iv = derivedParams.iv;
	
					// Decrypt
					var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
					return plaintext;
				}
			});
		}();
	});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "resetWarned", {
	  enumerable: true,
	  get: function get() {
	    return _warning.resetWarned;
	  }
	});
	exports["default"] = void 0;
	
	var _warning = _interopRequireWildcard(__webpack_require__(478));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var _default = function _default(valid, component, message) {
	  (0, _warning["default"])(valid, "[antd: ".concat(component, "] ").concat(message));
	};
	
	exports["default"] = _default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "resetWarned", {
	  enumerable: true,
	  get: function get() {
	    return _warning.resetWarned;
	  }
	});
	exports["default"] = void 0;
	
	var _warning = _interopRequireWildcard(__webpack_require__(478));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var _default = function _default(valid, component, message) {
	  (0, _warning["default"])(valid, "[antd: ".concat(component, "] ").concat(message));
	};
	
	exports["default"] = _default;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/*
	 * @Descripttion: 
	 * @version: 
	 * @Author: wangz
	 * @Date: 2019-11-21 14:58:03
	 * @LastEditors: hanzb
	 * @LastEditTime: 2020-04-03 17:26:08
	 */
	/*  记录日志
	 归属：企通前端平台-FC V2.0
	 版权：2017-2020 企通软件技术有限公司
	 --------------------------------------------------------------------------------
	 作者：wangz                           创建日期：2017/03/29
	 
	 --------------------------------------------------------------------------------
	 修改：hanzb                           修改日期：
	 修改内容
	 
	 
	 --------------------------------------------------------------------------------
	 
	 *******************************************************************************/
	
	/**
	 * 日志方法集，打印日志请统一使用该方法，统一管理日志
	 * @namespace 日志方法集
	 * @alias tool.sgiLogger
	 */
	var sgiLogger = {
	
		Level: {
			"error": 3,
			"warn": 2,
			"info": 1,
			"debug": 0,
			"debug-1": -1
		},
	
		/**
	  * 校验日志等级
	  * @param {string} level <debug|info|warn|error>
	  * @private
	  */
		checkLevel: function checkLevel(level) {
			return sgiConfig && sgiConfig.logger && sgiConfig.logger.level <= this.Level[level];
		},
	
		/**
	  * 不知道想用作什么
	  * @private
	  */
		setEnabled: function setEnabled() {},
	
		/**
	  * 打印 JavaScript 函数调用堆栈
	  * 配置文件sgiConfig中的logger.stack=true时，开启调用栈打印
	  * 
	  * @private
	  */
		printCallStack: function printCallStack() {
			if (sgiConfig && sgiConfig.logger && sgiConfig.logger.stack) {
				var error = new Error();
				var stack = error.stack.match(/(?:^|\n)[\s]*at.*/g)[2];
				console.debug("Error: 调用栈跟踪[非错误]" + stack); //"Error \n"为跟踪关键字，不能去掉或替换！！！
			}
		},
	
		/**
	  * 事件集使用，事件名称打印统一方法，级别为info（1级）
	  * @param {string} eventName 事件名称
	  */
		eventin: function eventin(eventName) {
			if (this.checkLevel("info")) {
				console.log(">>>> eventin: ", eventName);
				this.printCallStack();
			}
		},
	
		/**
	  * 同console.log，级别为info（1级）
	  * @param  {...any} msg 同console.log
	  */
		log: function log() {
			if (this.checkLevel("info")) {
				var _console;
	
				for (var _len = arguments.length, msg = Array(_len), _key = 0; _key < _len; _key++) {
					msg[_key] = arguments[_key];
				}
	
				(_console = console).log.apply(_console, [">>>> log: "].concat(msg));
				this.printCallStack();
			}
		},
	
		/**
	  * 同console.info，级别为info（1级）
	  * @param  {...any} msg 同console.info
	  */
		info: function info() {
			if (this.checkLevel("info")) {
				var _console2;
	
				for (var _len2 = arguments.length, msg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
					msg[_key2] = arguments[_key2];
				}
	
				(_console2 = console).info.apply(_console2, [">>>> info: "].concat(msg));
				this.printCallStack();
			}
		},
	
		/**
	  * 同console.debug，级别为debug（0级）
	  * @param  {...any} msg 同console.debug
	  */
		debug: function debug() {
			if (this.checkLevel("debug")) {
				var _console3;
	
				for (var _len3 = arguments.length, msg = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
					msg[_key3] = arguments[_key3];
				}
	
				(_console3 = console).debug.apply(_console3, [">>>> debug: "].concat(msg));
				this.printCallStack();
			}
		},
		/**
	  * 日志级别降低为-1时，打印日志；可用于部分测试日志输出使用
	  * 同console.debug，级别为debug（-1级）
	  * @param  {...any} msg 同console.debug
	  */
		debug_1: function debug_1() {
			if (this.checkLevel("debug-1")) {
				var _console4;
	
				for (var _len4 = arguments.length, msg = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
					msg[_key4] = arguments[_key4];
				}
	
				(_console4 = console).debug.apply(_console4, [">>>> debug_1: "].concat(msg));
				this.printCallStack();
			}
		},
		/**
	  * 同console.time，用于计时开始，级别为debug（0级）
	  * @param  {...any} msg 同console.time
	  */
		time: function time() {
			var _console5;
	
			if (this.checkLevel("debug")) (_console5 = console).time.apply(_console5, arguments);
		},
		/**
	  * 同console.timeEnd，用于计时结束，级别为debug（0级）
	  * @param  {...any} msg 同console.timeEnd
	  */
		timeEnd: function timeEnd() {
			var _console6;
	
			if (this.checkLevel("debug")) (_console6 = console).timeEnd.apply(_console6, arguments);
		},
	
		/**
	  * 同console.warn，级别为warn（2级）
	  * @param  {...any} msg 同console.warn
	  */
		warn: function warn() {
			if (this.checkLevel("warn")) {
				var _console7;
	
				for (var _len5 = arguments.length, msg = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
					msg[_key5] = arguments[_key5];
				}
	
				(_console7 = console).warn.apply(_console7, [">>>> warn: "].concat(msg));
				this.printCallStack();
			}
		},
	
		/**
	  * 同console.error，级别为error（3级）
	  * @param  {...any} msg 同console.error
	  */
		error: function error() {
			if (this.checkLevel("error")) {
				var _console8;
	
				for (var _len6 = arguments.length, msg = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
					msg[_key6] = arguments[_key6];
				}
	
				(_console8 = console).error.apply(_console8, [">>>> error: "].concat(msg));
				this.printCallStack();
			}
		},
	
		/**
	  * 事件集使用，catch错误打印统一方法，级别为error（3级）
	  * @param {object} error 错误信息{string:message,errorStack:stack}
	  */
		eventErr: function eventErr(error) {
			if (this.checkLevel("error")) {
				// console.error(">>>> eventErr message: ", error.message);
				// console.error(">>>> eventErr stack: ", error.stack);
				console.error(error);
			}
		}
	};
	
	exports.sgiLogger = sgiLogger;
	exports.default = sgiLogger;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(2);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// This is CodeMirror (https://codemirror.net/5), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = global || self, global.CodeMirror = factory());
	})(undefined, function () {
	  'use strict';
	
	  // Kludges for bugs and behavior differences that can't be feature
	  // detected are enabled based on userAgent etc sniffing.
	
	  var userAgent = navigator.userAgent;
	  var platform = navigator.platform;
	
	  var gecko = /gecko\/\d/i.test(userAgent);
	  var ie_upto10 = /MSIE \d/.test(userAgent);
	  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
	  var edge = /Edge\/(\d+)/.exec(userAgent);
	  var ie = ie_upto10 || ie_11up || edge;
	  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
	  var webkit = !edge && /WebKit\//.test(userAgent);
	  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
	  var chrome = !edge && /Chrome\/(\d+)/.exec(userAgent);
	  var chrome_version = chrome && +chrome[1];
	  var presto = /Opera\//.test(userAgent);
	  var safari = /Apple Computer/.test(navigator.vendor);
	  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
	  var phantom = /PhantomJS/.test(userAgent);
	
	  var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
	  var android = /Android/.test(userAgent);
	  // This is woefully incomplete. Suggestions for alternative methods welcome.
	  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
	  var mac = ios || /Mac/.test(platform);
	  var chromeOS = /\bCrOS\b/.test(userAgent);
	  var windows = /win/i.test(platform);
	
	  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
	  if (presto_version) {
	    presto_version = Number(presto_version[1]);
	  }
	  if (presto_version && presto_version >= 15) {
	    presto = false;webkit = true;
	  }
	  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
	  var captureRightClick = gecko || ie && ie_version >= 9;
	
	  function classTest(cls) {
	    return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
	  }
	
	  var rmClass = function rmClass(node, cls) {
	    var current = node.className;
	    var match = classTest(cls).exec(current);
	    if (match) {
	      var after = current.slice(match.index + match[0].length);
	      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
	    }
	  };
	
	  function removeChildren(e) {
	    for (var count = e.childNodes.length; count > 0; --count) {
	      e.removeChild(e.firstChild);
	    }
	    return e;
	  }
	
	  function removeChildrenAndAdd(parent, e) {
	    return removeChildren(parent).appendChild(e);
	  }
	
	  function elt(tag, content, className, style) {
	    var e = document.createElement(tag);
	    if (className) {
	      e.className = className;
	    }
	    if (style) {
	      e.style.cssText = style;
	    }
	    if (typeof content == "string") {
	      e.appendChild(document.createTextNode(content));
	    } else if (content) {
	      for (var i = 0; i < content.length; ++i) {
	        e.appendChild(content[i]);
	      }
	    }
	    return e;
	  }
	  // wrapper for elt, which removes the elt from the accessibility tree
	  function eltP(tag, content, className, style) {
	    var e = elt(tag, content, className, style);
	    e.setAttribute("role", "presentation");
	    return e;
	  }
	
	  var range;
	  if (document.createRange) {
	    range = function range(node, start, end, endNode) {
	      var r = document.createRange();
	      r.setEnd(endNode || node, end);
	      r.setStart(node, start);
	      return r;
	    };
	  } else {
	    range = function range(node, start, end) {
	      var r = document.body.createTextRange();
	      try {
	        r.moveToElementText(node.parentNode);
	      } catch (e) {
	        return r;
	      }
	      r.collapse(true);
	      r.moveEnd("character", end);
	      r.moveStart("character", start);
	      return r;
	    };
	  }
	
	  function contains(parent, child) {
	    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	      {
	        child = child.parentNode;
	      }
	    if (parent.contains) {
	      return parent.contains(child);
	    }
	    do {
	      if (child.nodeType == 11) {
	        child = child.host;
	      }
	      if (child == parent) {
	        return true;
	      }
	    } while (child = child.parentNode);
	  }
	
	  function activeElt(rootNode) {
	    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	    // IE < 10 will throw when accessed while the page is loading or in an iframe.
	    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	    var doc = rootNode.ownerDocument || rootNode;
	    var activeElement;
	    try {
	      activeElement = rootNode.activeElement;
	    } catch (e) {
	      activeElement = doc.body || null;
	    }
	    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement) {
	      activeElement = activeElement.shadowRoot.activeElement;
	    }
	    return activeElement;
	  }
	
	  function addClass(node, cls) {
	    var current = node.className;
	    if (!classTest(cls).test(current)) {
	      node.className += (current ? " " : "") + cls;
	    }
	  }
	  function joinClasses(a, b) {
	    var as = a.split(" ");
	    for (var i = 0; i < as.length; i++) {
	      if (as[i] && !classTest(as[i]).test(b)) {
	        b += " " + as[i];
	      }
	    }
	    return b;
	  }
	
	  var selectInput = function selectInput(node) {
	    node.select();
	  };
	  if (ios) // Mobile Safari apparently has a bug where select() is broken.
	    {
	      selectInput = function selectInput(node) {
	        node.selectionStart = 0;node.selectionEnd = node.value.length;
	      };
	    } else if (ie) // Suppress mysterious IE10 errors
	    {
	      selectInput = function selectInput(node) {
	        try {
	          node.select();
	        } catch (_e) {}
	      };
	    }
	
	  function doc(cm) {
	    return cm.display.wrapper.ownerDocument;
	  }
	
	  function root(cm) {
	    return rootNode(cm.display.wrapper);
	  }
	
	  function rootNode(element) {
	    // Detect modern browsers (2017+).
	    return element.getRootNode ? element.getRootNode() : element.ownerDocument;
	  }
	
	  function win(cm) {
	    return doc(cm).defaultView;
	  }
	
	  function bind(f) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return function () {
	      return f.apply(null, args);
	    };
	  }
	
	  function copyObj(obj, target, overwrite) {
	    if (!target) {
	      target = {};
	    }
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) {
	        target[prop] = obj[prop];
	      }
	    }
	    return target;
	  }
	
	  // Counts the column offset in a string, taking tabs into account.
	  // Used mostly to find indentation.
	  function countColumn(string, end, tabSize, startIndex, startValue) {
	    if (end == null) {
	      end = string.search(/[^\s\u00a0]/);
	      if (end == -1) {
	        end = string.length;
	      }
	    }
	    for (var i = startIndex || 0, n = startValue || 0;;) {
	      var nextTab = string.indexOf("\t", i);
	      if (nextTab < 0 || nextTab >= end) {
	        return n + (end - i);
	      }
	      n += nextTab - i;
	      n += tabSize - n % tabSize;
	      i = nextTab + 1;
	    }
	  }
	
	  var Delayed = function Delayed() {
	    this.id = null;
	    this.f = null;
	    this.time = 0;
	    this.handler = bind(this.onTimeout, this);
	  };
	  Delayed.prototype.onTimeout = function (self) {
	    self.id = 0;
	    if (self.time <= +new Date()) {
	      self.f();
	    } else {
	      setTimeout(self.handler, self.time - +new Date());
	    }
	  };
	  Delayed.prototype.set = function (ms, f) {
	    this.f = f;
	    var time = +new Date() + ms;
	    if (!this.id || time < this.time) {
	      clearTimeout(this.id);
	      this.id = setTimeout(this.handler, ms);
	      this.time = time;
	    }
	  };
	
	  function indexOf(array, elt) {
	    for (var i = 0; i < array.length; ++i) {
	      if (array[i] == elt) {
	        return i;
	      }
	    }
	    return -1;
	  }
	
	  // Number of pixels added to scroller and sizer to hide scrollbar
	  var scrollerGap = 50;
	
	  // Returned or thrown by various protocols to signal 'I'm not
	  // handling this'.
	  var Pass = { toString: function toString() {
	      return "CodeMirror.Pass";
	    } };
	
	  // Reused option objects for setSelection & friends
	  var sel_dontScroll = { scroll: false },
	      sel_mouse = { origin: "*mouse" },
	      sel_move = { origin: "+move" };
	
	  // The inverse of countColumn -- find the offset that corresponds to
	  // a particular column.
	  function findColumn(string, goal, tabSize) {
	    for (var pos = 0, col = 0;;) {
	      var nextTab = string.indexOf("\t", pos);
	      if (nextTab == -1) {
	        nextTab = string.length;
	      }
	      var skipped = nextTab - pos;
	      if (nextTab == string.length || col + skipped >= goal) {
	        return pos + Math.min(skipped, goal - col);
	      }
	      col += nextTab - pos;
	      col += tabSize - col % tabSize;
	      pos = nextTab + 1;
	      if (col >= goal) {
	        return pos;
	      }
	    }
	  }
	
	  var spaceStrs = [""];
	  function spaceStr(n) {
	    while (spaceStrs.length <= n) {
	      spaceStrs.push(lst(spaceStrs) + " ");
	    }
	    return spaceStrs[n];
	  }
	
	  function lst(arr) {
	    return arr[arr.length - 1];
	  }
	
	  function map(array, f) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) {
	      out[i] = f(array[i], i);
	    }
	    return out;
	  }
	
	  function insertSorted(array, value, score) {
	    var pos = 0,
	        priority = score(value);
	    while (pos < array.length && score(array[pos]) <= priority) {
	      pos++;
	    }
	    array.splice(pos, 0, value);
	  }
	
	  function nothing() {}
	
	  function createObj(base, props) {
	    var inst;
	    if (Object.create) {
	      inst = Object.create(base);
	    } else {
	      nothing.prototype = base;
	      inst = new nothing();
	    }
	    if (props) {
	      copyObj(props, inst);
	    }
	    return inst;
	  }
	
	  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
	  function isWordCharBasic(ch) {
	    return (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
	    );
	  }
	  function isWordChar(ch, helper) {
	    if (!helper) {
	      return isWordCharBasic(ch);
	    }
	    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) {
	      return true;
	    }
	    return helper.test(ch);
	  }
	
	  function isEmpty(obj) {
	    for (var n in obj) {
	      if (obj.hasOwnProperty(n) && obj[n]) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  // Extending unicode characters. A series of a non-extending char +
	  // any number of extending chars is treated as a single unit as far
	  // as editing and measuring is concerned. This is not fully correct,
	  // since some scripts/fonts/browsers also treat other configurations
	  // of code points as a group.
	  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
	  function isExtendingChar(ch) {
	    return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
	  }
	
	  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
	  function skipExtendingChars(str, pos, dir) {
	    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) {
	      pos += dir;
	    }
	    return pos;
	  }
	
	  // Returns the value from the range [`from`; `to`] that satisfies
	  // `pred` and is closest to `from`. Assumes that at least `to`
	  // satisfies `pred`. Supports `from` being greater than `to`.
	  function findFirst(pred, from, to) {
	    // At any point we are certain `to` satisfies `pred`, don't know
	    // whether `from` does.
	    var dir = from > to ? -1 : 1;
	    for (;;) {
	      if (from == to) {
	        return from;
	      }
	      var midF = (from + to) / 2,
	          mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
	      if (mid == from) {
	        return pred(mid) ? from : to;
	      }
	      if (pred(mid)) {
	        to = mid;
	      } else {
	        from = mid + dir;
	      }
	    }
	  }
	
	  // BIDI HELPERS
	
	  function iterateBidiSections(order, from, to, f) {
	    if (!order) {
	      return f(from, to, "ltr", 0);
	    }
	    var found = false;
	    for (var i = 0; i < order.length; ++i) {
	      var part = order[i];
	      if (part.from < to && part.to > from || from == to && part.to == from) {
	        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
	        found = true;
	      }
	    }
	    if (!found) {
	      f(from, to, "ltr");
	    }
	  }
	
	  var bidiOther = null;
	  function getBidiPartAt(order, ch, sticky) {
	    var found;
	    bidiOther = null;
	    for (var i = 0; i < order.length; ++i) {
	      var cur = order[i];
	      if (cur.from < ch && cur.to > ch) {
	        return i;
	      }
	      if (cur.to == ch) {
	        if (cur.from != cur.to && sticky == "before") {
	          found = i;
	        } else {
	          bidiOther = i;
	        }
	      }
	      if (cur.from == ch) {
	        if (cur.from != cur.to && sticky != "before") {
	          found = i;
	        } else {
	          bidiOther = i;
	        }
	      }
	    }
	    return found != null ? found : bidiOther;
	  }
	
	  // Bidirectional ordering algorithm
	  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	  // that this (partially) implements.
	
	  // One-char codes used for character types:
	  // L (L):   Left-to-Right
	  // R (R):   Right-to-Left
	  // r (AL):  Right-to-Left Arabic
	  // 1 (EN):  European Number
	  // + (ES):  European Number Separator
	  // % (ET):  European Number Terminator
	  // n (AN):  Arabic Number
	  // , (CS):  Common Number Separator
	  // m (NSM): Non-Spacing Mark
	  // b (BN):  Boundary Neutral
	  // s (B):   Paragraph Separator
	  // t (S):   Segment Separator
	  // w (WS):  Whitespace
	  // N (ON):  Other Neutrals
	
	  // Returns null if characters are ordered as they appear
	  // (left-to-right), or an array of sections ({from, to, level}
	  // objects) in the order in which they occur visually.
	  var bidiOrdering = function () {
	    // Character types for codepoints 0 to 0xff
	    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
	    // Character types for codepoints 0x600 to 0x6f9
	    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
	    function charType(code) {
	      if (code <= 0xf7) {
	        return lowTypes.charAt(code);
	      } else if (0x590 <= code && code <= 0x5f4) {
	        return "R";
	      } else if (0x600 <= code && code <= 0x6f9) {
	        return arabicTypes.charAt(code - 0x600);
	      } else if (0x6ee <= code && code <= 0x8ac) {
	        return "r";
	      } else if (0x2000 <= code && code <= 0x200b) {
	        return "w";
	      } else if (code == 0x200c) {
	        return "b";
	      } else {
	        return "L";
	      }
	    }
	
	    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
	    var isNeutral = /[stwN]/,
	        isStrong = /[LRr]/,
	        countsAsLeft = /[Lb1n]/,
	        countsAsNum = /[1n]/;
	
	    function BidiSpan(level, from, to) {
	      this.level = level;
	      this.from = from;this.to = to;
	    }
	
	    return function (str, direction) {
	      var outerType = direction == "ltr" ? "L" : "R";
	
	      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) {
	        return false;
	      }
	      var len = str.length,
	          types = [];
	      for (var i = 0; i < len; ++i) {
	        types.push(charType(str.charCodeAt(i)));
	      }
	
	      // W1. Examine each non-spacing mark (NSM) in the level run, and
	      // change the type of the NSM to the type of the previous
	      // character. If the NSM is at the start of the level run, it will
	      // get the type of sor.
	      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
	        var type = types[i$1];
	        if (type == "m") {
	          types[i$1] = prev;
	        } else {
	          prev = type;
	        }
	      }
	
	      // W2. Search backwards from each instance of a European number
	      // until the first strong type (R, L, AL, or sor) is found. If an
	      // AL is found, change the type of the European number to Arabic
	      // number.
	      // W3. Change all ALs to R.
	      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
	        var type$1 = types[i$2];
	        if (type$1 == "1" && cur == "r") {
	          types[i$2] = "n";
	        } else if (isStrong.test(type$1)) {
	          cur = type$1;if (type$1 == "r") {
	            types[i$2] = "R";
	          }
	        }
	      }
	
	      // W4. A single European separator between two European numbers
	      // changes to a European number. A single common separator between
	      // two numbers of the same type changes to that type.
	      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
	        var type$2 = types[i$3];
	        if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") {
	          types[i$3] = "1";
	        } else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) {
	          types[i$3] = prev$1;
	        }
	        prev$1 = type$2;
	      }
	
	      // W5. A sequence of European terminators adjacent to European
	      // numbers changes to all European numbers.
	      // W6. Otherwise, separators and terminators change to Other
	      // Neutral.
	      for (var i$4 = 0; i$4 < len; ++i$4) {
	        var type$3 = types[i$4];
	        if (type$3 == ",") {
	          types[i$4] = "N";
	        } else if (type$3 == "%") {
	          var end = void 0;
	          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
	          var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
	          for (var j = i$4; j < end; ++j) {
	            types[j] = replace;
	          }
	          i$4 = end - 1;
	        }
	      }
	
	      // W7. Search backwards from each instance of a European number
	      // until the first strong type (R, L, or sor) is found. If an L is
	      // found, then change the type of the European number to L.
	      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
	        var type$4 = types[i$5];
	        if (cur$1 == "L" && type$4 == "1") {
	          types[i$5] = "L";
	        } else if (isStrong.test(type$4)) {
	          cur$1 = type$4;
	        }
	      }
	
	      // N1. A sequence of neutrals takes the direction of the
	      // surrounding strong text if the text on both sides has the same
	      // direction. European and Arabic numbers act as if they were R in
	      // terms of their influence on neutrals. Start-of-level-run (sor)
	      // and end-of-level-run (eor) are used at level run boundaries.
	      // N2. Any remaining neutrals take the embedding direction.
	      for (var i$6 = 0; i$6 < len; ++i$6) {
	        if (isNeutral.test(types[i$6])) {
	          var end$1 = void 0;
	          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
	          var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
	          var after = (end$1 < len ? types[end$1] : outerType) == "L";
	          var replace$1 = before == after ? before ? "L" : "R" : outerType;
	          for (var j$1 = i$6; j$1 < end$1; ++j$1) {
	            types[j$1] = replace$1;
	          }
	          i$6 = end$1 - 1;
	        }
	      }
	
	      // Here we depart from the documented algorithm, in order to avoid
	      // building up an actual levels array. Since there are only three
	      // levels (0, 1, 2) in an implementation that doesn't take
	      // explicit embedding into account, we can build up the order on
	      // the fly, without following the level-based algorithm.
	      var order = [],
	          m;
	      for (var i$7 = 0; i$7 < len;) {
	        if (countsAsLeft.test(types[i$7])) {
	          var start = i$7;
	          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
	          order.push(new BidiSpan(0, start, i$7));
	        } else {
	          var pos = i$7,
	              at = order.length,
	              isRTL = direction == "rtl" ? 1 : 0;
	          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
	          for (var j$2 = pos; j$2 < i$7;) {
	            if (countsAsNum.test(types[j$2])) {
	              if (pos < j$2) {
	                order.splice(at, 0, new BidiSpan(1, pos, j$2));at += isRTL;
	              }
	              var nstart = j$2;
	              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
	              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
	              at += isRTL;
	              pos = j$2;
	            } else {
	              ++j$2;
	            }
	          }
	          if (pos < i$7) {
	            order.splice(at, 0, new BidiSpan(1, pos, i$7));
	          }
	        }
	      }
	      if (direction == "ltr") {
	        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	          order[0].from = m[0].length;
	          order.unshift(new BidiSpan(0, 0, m[0].length));
	        }
	        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	          lst(order).to -= m[0].length;
	          order.push(new BidiSpan(0, len - m[0].length, len));
	        }
	      }
	
	      return direction == "rtl" ? order.reverse() : order;
	    };
	  }();
	
	  // Get the bidi ordering for the given line (and cache it). Returns
	  // false for lines that are fully left-to-right, and an array of
	  // BidiSpan objects otherwise.
	  function getOrder(line, direction) {
	    var order = line.order;
	    if (order == null) {
	      order = line.order = bidiOrdering(line.text, direction);
	    }
	    return order;
	  }
	
	  // EVENT HANDLING
	
	  // Lightweight event framework. on/off also work on DOM nodes,
	  // registering native DOM handlers.
	
	  var noHandlers = [];
	
	  var on = function on(emitter, type, f) {
	    if (emitter.addEventListener) {
	      emitter.addEventListener(type, f, false);
	    } else if (emitter.attachEvent) {
	      emitter.attachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers || (emitter._handlers = {});
	      map[type] = (map[type] || noHandlers).concat(f);
	    }
	  };
	
	  function getHandlers(emitter, type) {
	    return emitter._handlers && emitter._handlers[type] || noHandlers;
	  }
	
	  function off(emitter, type, f) {
	    if (emitter.removeEventListener) {
	      emitter.removeEventListener(type, f, false);
	    } else if (emitter.detachEvent) {
	      emitter.detachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers,
	          arr = map && map[type];
	      if (arr) {
	        var index = indexOf(arr, f);
	        if (index > -1) {
	          map[type] = arr.slice(0, index).concat(arr.slice(index + 1));
	        }
	      }
	    }
	  }
	
	  function signal(emitter, type /*, values...*/) {
	    var handlers = getHandlers(emitter, type);
	    if (!handlers.length) {
	      return;
	    }
	    var args = Array.prototype.slice.call(arguments, 2);
	    for (var i = 0; i < handlers.length; ++i) {
	      handlers[i].apply(null, args);
	    }
	  }
	
	  // The DOM events that CodeMirror handles can be overridden by
	  // registering a (non-DOM) handler on the editor for the event name,
	  // and preventDefault-ing the event in that handler.
	  function signalDOMEvent(cm, e, override) {
	    if (typeof e == "string") {
	      e = { type: e, preventDefault: function preventDefault() {
	          this.defaultPrevented = true;
	        } };
	    }
	    signal(cm, override || e.type, cm, e);
	    return e_defaultPrevented(e) || e.codemirrorIgnore;
	  }
	
	  function signalCursorActivity(cm) {
	    var arr = cm._handlers && cm._handlers.cursorActivity;
	    if (!arr) {
	      return;
	    }
	    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
	    for (var i = 0; i < arr.length; ++i) {
	      if (indexOf(set, arr[i]) == -1) {
	        set.push(arr[i]);
	      }
	    }
	  }
	
	  function hasHandler(emitter, type) {
	    return getHandlers(emitter, type).length > 0;
	  }
	
	  // Add on and off methods to a constructor's prototype, to make
	  // registering events on such objects more convenient.
	  function eventMixin(ctor) {
	    ctor.prototype.on = function (type, f) {
	      on(this, type, f);
	    };
	    ctor.prototype.off = function (type, f) {
	      off(this, type, f);
	    };
	  }
	
	  // Due to the fact that we still support jurassic IE versions, some
	  // compatibility wrappers are needed.
	
	  function e_preventDefault(e) {
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      e.returnValue = false;
	    }
	  }
	  function e_stopPropagation(e) {
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      e.cancelBubble = true;
	    }
	  }
	  function e_defaultPrevented(e) {
	    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
	  }
	  function e_stop(e) {
	    e_preventDefault(e);e_stopPropagation(e);
	  }
	
	  function e_target(e) {
	    return e.target || e.srcElement;
	  }
	  function e_button(e) {
	    var b = e.which;
	    if (b == null) {
	      if (e.button & 1) {
	        b = 1;
	      } else if (e.button & 2) {
	        b = 3;
	      } else if (e.button & 4) {
	        b = 2;
	      }
	    }
	    if (mac && e.ctrlKey && b == 1) {
	      b = 3;
	    }
	    return b;
	  }
	
	  // Detect drag-and-drop
	  var dragAndDrop = function () {
	    // There is *some* kind of drag-and-drop support in IE6-8, but I
	    // couldn't get it to work yet.
	    if (ie && ie_version < 9) {
	      return false;
	    }
	    var div = elt('div');
	    return "draggable" in div || "dragDrop" in div;
	  }();
	
	  var zwspSupported;
	  function zeroWidthElement(measure) {
	    if (zwspSupported == null) {
	      var test = elt("span", '\u200B');
	      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
	      if (measure.firstChild.offsetHeight != 0) {
	        zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
	      }
	    }
	    var node = zwspSupported ? elt("span", '\u200B') : elt("span", '\xA0', null, "display: inline-block; width: 1px; margin-right: -1px");
	    node.setAttribute("cm-text", "");
	    return node;
	  }
	
	  // Feature-detect IE's crummy client rect reporting for bidi text
	  var badBidiRects;
	  function hasBadBidiRects(measure) {
	    if (badBidiRects != null) {
	      return badBidiRects;
	    }
	    var txt = removeChildrenAndAdd(measure, document.createTextNode('A\u062EA'));
	    var r0 = range(txt, 0, 1).getBoundingClientRect();
	    var r1 = range(txt, 1, 2).getBoundingClientRect();
	    removeChildren(measure);
	    if (!r0 || r0.left == r0.right) {
	      return false;
	    } // Safari returns null in some cases (#2780)
	    return badBidiRects = r1.right - r0.right < 3;
	  }
	
	  // See if "".split is the broken IE version, if so, provide an
	  // alternative way to split lines.
	  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
	    var pos = 0,
	        result = [],
	        l = string.length;
	    while (pos <= l) {
	      var nl = string.indexOf("\n", pos);
	      if (nl == -1) {
	        nl = string.length;
	      }
	      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
	      var rt = line.indexOf("\r");
	      if (rt != -1) {
	        result.push(line.slice(0, rt));
	        pos += rt + 1;
	      } else {
	        result.push(line);
	        pos = nl + 1;
	      }
	    }
	    return result;
	  } : function (string) {
	    return string.split(/\r\n?|\n/);
	  };
	
	  var hasSelection = window.getSelection ? function (te) {
	    try {
	      return te.selectionStart != te.selectionEnd;
	    } catch (e) {
	      return false;
	    }
	  } : function (te) {
	    var range;
	    try {
	      range = te.ownerDocument.selection.createRange();
	    } catch (e) {}
	    if (!range || range.parentElement() != te) {
	      return false;
	    }
	    return range.compareEndPoints("StartToEnd", range) != 0;
	  };
	
	  var hasCopyEvent = function () {
	    var e = elt("div");
	    if ("oncopy" in e) {
	      return true;
	    }
	    e.setAttribute("oncopy", "return;");
	    return typeof e.oncopy == "function";
	  }();
	
	  var badZoomedRects = null;
	  function hasBadZoomedRects(measure) {
	    if (badZoomedRects != null) {
	      return badZoomedRects;
	    }
	    var node = removeChildrenAndAdd(measure, elt("span", "x"));
	    var normal = node.getBoundingClientRect();
	    var fromRange = range(node, 0, 1).getBoundingClientRect();
	    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
	  }
	
	  // Known modes, by name and by MIME
	  var modes = {},
	      mimeModes = {};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  function defineMode(name, mode) {
	    if (arguments.length > 2) {
	      mode.dependencies = Array.prototype.slice.call(arguments, 2);
	    }
	    modes[name] = mode;
	  }
	
	  function defineMIME(mime, spec) {
	    mimeModes[mime] = spec;
	  }
	
	  // Given a MIME type, a {name, ...options} config object, or a name
	  // string, return a mode config object.
	  function resolveMode(spec) {
	    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	      spec = mimeModes[spec];
	    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	      var found = mimeModes[spec.name];
	      if (typeof found == "string") {
	        found = { name: found };
	      }
	      spec = createObj(found, spec);
	      spec.name = found.name;
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	      return resolveMode("application/xml");
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	      return resolveMode("application/json");
	    }
	    if (typeof spec == "string") {
	      return { name: spec };
	    } else {
	      return spec || { name: "null" };
	    }
	  }
	
	  // Given a mode spec (anything that resolveMode accepts), find and
	  // initialize an actual mode object.
	  function getMode(options, spec) {
	    spec = resolveMode(spec);
	    var mfactory = modes[spec.name];
	    if (!mfactory) {
	      return getMode(options, "text/plain");
	    }
	    var modeObj = mfactory(options, spec);
	    if (modeExtensions.hasOwnProperty(spec.name)) {
	      var exts = modeExtensions[spec.name];
	      for (var prop in exts) {
	        if (!exts.hasOwnProperty(prop)) {
	          continue;
	        }
	        if (modeObj.hasOwnProperty(prop)) {
	          modeObj["_" + prop] = modeObj[prop];
	        }
	        modeObj[prop] = exts[prop];
	      }
	    }
	    modeObj.name = spec.name;
	    if (spec.helperType) {
	      modeObj.helperType = spec.helperType;
	    }
	    if (spec.modeProps) {
	      for (var prop$1 in spec.modeProps) {
	        modeObj[prop$1] = spec.modeProps[prop$1];
	      }
	    }
	
	    return modeObj;
	  }
	
	  // This can be used to attach properties to mode objects from
	  // outside the actual mode definition.
	  var modeExtensions = {};
	  function extendMode(mode, properties) {
	    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
	    copyObj(properties, exts);
	  }
	
	  function copyState(mode, state) {
	    if (state === true) {
	      return state;
	    }
	    if (mode.copyState) {
	      return mode.copyState(state);
	    }
	    var nstate = {};
	    for (var n in state) {
	      var val = state[n];
	      if (val instanceof Array) {
	        val = val.concat([]);
	      }
	      nstate[n] = val;
	    }
	    return nstate;
	  }
	
	  // Given a mode and a state (for that mode), find the inner mode and
	  // state at the position that the state refers to.
	  function innerMode(mode, state) {
	    var info;
	    while (mode.innerMode) {
	      info = mode.innerMode(state);
	      if (!info || info.mode == mode) {
	        break;
	      }
	      state = info.state;
	      mode = info.mode;
	    }
	    return info || { mode: mode, state: state };
	  }
	
	  function startState(mode, a1, a2) {
	    return mode.startState ? mode.startState(a1, a2) : true;
	  }
	
	  // STRING STREAM
	
	  // Fed to the mode parsers, provides helper functions to make
	  // parsers more succinct.
	
	  var StringStream = function StringStream(string, tabSize, lineOracle) {
	    this.pos = this.start = 0;
	    this.string = string;
	    this.tabSize = tabSize || 8;
	    this.lastColumnPos = this.lastColumnValue = 0;
	    this.lineStart = 0;
	    this.lineOracle = lineOracle;
	  };
	
	  StringStream.prototype.eol = function () {
	    return this.pos >= this.string.length;
	  };
	  StringStream.prototype.sol = function () {
	    return this.pos == this.lineStart;
	  };
	  StringStream.prototype.peek = function () {
	    return this.string.charAt(this.pos) || undefined;
	  };
	  StringStream.prototype.next = function () {
	    if (this.pos < this.string.length) {
	      return this.string.charAt(this.pos++);
	    }
	  };
	  StringStream.prototype.eat = function (match) {
	    var ch = this.string.charAt(this.pos);
	    var ok;
	    if (typeof match == "string") {
	      ok = ch == match;
	    } else {
	      ok = ch && (match.test ? match.test(ch) : match(ch));
	    }
	    if (ok) {
	      ++this.pos;return ch;
	    }
	  };
	  StringStream.prototype.eatWhile = function (match) {
	    var start = this.pos;
	    while (this.eat(match)) {}
	    return this.pos > start;
	  };
	  StringStream.prototype.eatSpace = function () {
	    var start = this.pos;
	    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) {
	      ++this.pos;
	    }
	    return this.pos > start;
	  };
	  StringStream.prototype.skipToEnd = function () {
	    this.pos = this.string.length;
	  };
	  StringStream.prototype.skipTo = function (ch) {
	    var found = this.string.indexOf(ch, this.pos);
	    if (found > -1) {
	      this.pos = found;return true;
	    }
	  };
	  StringStream.prototype.backUp = function (n) {
	    this.pos -= n;
	  };
	  StringStream.prototype.column = function () {
	    if (this.lastColumnPos < this.start) {
	      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
	      this.lastColumnPos = this.start;
	    }
	    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
	  };
	  StringStream.prototype.indentation = function () {
	    return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
	  };
	  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
	    if (typeof pattern == "string") {
	      var cased = function cased(str) {
	        return caseInsensitive ? str.toLowerCase() : str;
	      };
	      var substr = this.string.substr(this.pos, pattern.length);
	      if (cased(substr) == cased(pattern)) {
	        if (consume !== false) {
	          this.pos += pattern.length;
	        }
	        return true;
	      }
	    } else {
	      var match = this.string.slice(this.pos).match(pattern);
	      if (match && match.index > 0) {
	        return null;
	      }
	      if (match && consume !== false) {
	        this.pos += match[0].length;
	      }
	      return match;
	    }
	  };
	  StringStream.prototype.current = function () {
	    return this.string.slice(this.start, this.pos);
	  };
	  StringStream.prototype.hideFirstChars = function (n, inner) {
	    this.lineStart += n;
	    try {
	      return inner();
	    } finally {
	      this.lineStart -= n;
	    }
	  };
	  StringStream.prototype.lookAhead = function (n) {
	    var oracle = this.lineOracle;
	    return oracle && oracle.lookAhead(n);
	  };
	  StringStream.prototype.baseToken = function () {
	    var oracle = this.lineOracle;
	    return oracle && oracle.baseToken(this.pos);
	  };
	
	  // Find the line object corresponding to the given line number.
	  function getLine(doc, n) {
	    n -= doc.first;
	    if (n < 0 || n >= doc.size) {
	      throw new Error("There is no line " + (n + doc.first) + " in the document.");
	    }
	    var chunk = doc;
	    while (!chunk.lines) {
	      for (var i = 0;; ++i) {
	        var child = chunk.children[i],
	            sz = child.chunkSize();
	        if (n < sz) {
	          chunk = child;break;
	        }
	        n -= sz;
	      }
	    }
	    return chunk.lines[n];
	  }
	
	  // Get the part of a document between two positions, as an array of
	  // strings.
	  function getBetween(doc, start, end) {
	    var out = [],
	        n = start.line;
	    doc.iter(start.line, end.line + 1, function (line) {
	      var text = line.text;
	      if (n == end.line) {
	        text = text.slice(0, end.ch);
	      }
	      if (n == start.line) {
	        text = text.slice(start.ch);
	      }
	      out.push(text);
	      ++n;
	    });
	    return out;
	  }
	  // Get the lines between from and to, as array of strings.
	  function getLines(doc, from, to) {
	    var out = [];
	    doc.iter(from, to, function (line) {
	      out.push(line.text);
	    }); // iter aborts when callback returns truthy value
	    return out;
	  }
	
	  // Update the height of a line, propagating the height change
	  // upwards to parent nodes.
	  function updateLineHeight(line, height) {
	    var diff = height - line.height;
	    if (diff) {
	      for (var n = line; n; n = n.parent) {
	        n.height += diff;
	      }
	    }
	  }
	
	  // Given a line object, find its line number by walking up through
	  // its parent links.
	  function lineNo(line) {
	    if (line.parent == null) {
	      return null;
	    }
	    var cur = line.parent,
	        no = indexOf(cur.lines, line);
	    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	      for (var i = 0;; ++i) {
	        if (chunk.children[i] == cur) {
	          break;
	        }
	        no += chunk.children[i].chunkSize();
	      }
	    }
	    return no + cur.first;
	  }
	
	  // Find the line at the given vertical position, using the height
	  // information in the document tree.
	  function _lineAtHeight(chunk, h) {
	    var n = chunk.first;
	    outer: do {
	      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
	        var child = chunk.children[i$1],
	            ch = child.height;
	        if (h < ch) {
	          chunk = child;continue outer;
	        }
	        h -= ch;
	        n += child.chunkSize();
	      }
	      return n;
	    } while (!chunk.lines);
	    var i = 0;
	    for (; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i],
	          lh = line.height;
	      if (h < lh) {
	        break;
	      }
	      h -= lh;
	    }
	    return n + i;
	  }
	
	  function isLine(doc, l) {
	    return l >= doc.first && l < doc.first + doc.size;
	  }
	
	  function lineNumberFor(options, i) {
	    return String(options.lineNumberFormatter(i + options.firstLineNumber));
	  }
	
	  // A Pos instance represents a position within the text.
	  function Pos(line, ch, sticky) {
	    if (sticky === void 0) sticky = null;
	
	    if (!(this instanceof Pos)) {
	      return new Pos(line, ch, sticky);
	    }
	    this.line = line;
	    this.ch = ch;
	    this.sticky = sticky;
	  }
	
	  // Compare two positions, return 0 if they are the same, a negative
	  // number when a is less, and a positive number otherwise.
	  function cmp(a, b) {
	    return a.line - b.line || a.ch - b.ch;
	  }
	
	  function equalCursorPos(a, b) {
	    return a.sticky == b.sticky && cmp(a, b) == 0;
	  }
	
	  function copyPos(x) {
	    return Pos(x.line, x.ch);
	  }
	  function maxPos(a, b) {
	    return cmp(a, b) < 0 ? b : a;
	  }
	  function minPos(a, b) {
	    return cmp(a, b) < 0 ? a : b;
	  }
	
	  // Most of the external API clips given positions to make sure they
	  // actually exist within the document.
	  function clipLine(doc, n) {
	    return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
	  }
	  function _clipPos(doc, pos) {
	    if (pos.line < doc.first) {
	      return Pos(doc.first, 0);
	    }
	    var last = doc.first + doc.size - 1;
	    if (pos.line > last) {
	      return Pos(last, getLine(doc, last).text.length);
	    }
	    return clipToLen(pos, getLine(doc, pos.line).text.length);
	  }
	  function clipToLen(pos, linelen) {
	    var ch = pos.ch;
	    if (ch == null || ch > linelen) {
	      return Pos(pos.line, linelen);
	    } else if (ch < 0) {
	      return Pos(pos.line, 0);
	    } else {
	      return pos;
	    }
	  }
	  function clipPosArray(doc, array) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) {
	      out[i] = _clipPos(doc, array[i]);
	    }
	    return out;
	  }
	
	  var SavedContext = function SavedContext(state, lookAhead) {
	    this.state = state;
	    this.lookAhead = lookAhead;
	  };
	
	  var Context = function Context(doc, state, line, lookAhead) {
	    this.state = state;
	    this.doc = doc;
	    this.line = line;
	    this.maxLookAhead = lookAhead || 0;
	    this.baseTokens = null;
	    this.baseTokenPos = 1;
	  };
	
	  Context.prototype.lookAhead = function (n) {
	    var line = this.doc.getLine(this.line + n);
	    if (line != null && n > this.maxLookAhead) {
	      this.maxLookAhead = n;
	    }
	    return line;
	  };
	
	  Context.prototype.baseToken = function (n) {
	    if (!this.baseTokens) {
	      return null;
	    }
	    while (this.baseTokens[this.baseTokenPos] <= n) {
	      this.baseTokenPos += 2;
	    }
	    var type = this.baseTokens[this.baseTokenPos + 1];
	    return { type: type && type.replace(/( |^)overlay .*/, ""),
	      size: this.baseTokens[this.baseTokenPos] - n };
	  };
	
	  Context.prototype.nextLine = function () {
	    this.line++;
	    if (this.maxLookAhead > 0) {
	      this.maxLookAhead--;
	    }
	  };
	
	  Context.fromSaved = function (doc, saved, line) {
	    if (saved instanceof SavedContext) {
	      return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
	    } else {
	      return new Context(doc, copyState(doc.mode, saved), line);
	    }
	  };
	
	  Context.prototype.save = function (copy) {
	    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
	    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
	  };
	
	  // Compute a style array (an array starting with a mode generation
	  // -- for invalidation -- followed by pairs of end positions and
	  // style strings), which is used to highlight the tokens on the
	  // line.
	  function highlightLine(cm, line, context, forceToEnd) {
	    // A styles array always starts with a number identifying the
	    // mode/overlays that it is based on (for easy invalidation).
	    var st = [cm.state.modeGen],
	        lineClasses = {};
	    // Compute the base array of styles
	    runMode(cm, line.text, cm.doc.mode, context, function (end, style) {
	      return st.push(end, style);
	    }, lineClasses, forceToEnd);
	    var state = context.state;
	
	    // Run overlays, adjust style array.
	    var loop = function loop(o) {
	      context.baseTokens = st;
	      var overlay = cm.state.overlays[o],
	          i = 1,
	          at = 0;
	      context.state = true;
	      runMode(cm, line.text, overlay.mode, context, function (end, style) {
	        var start = i;
	        // Ensure there's a token end at the current position, and that i points at it
	        while (at < end) {
	          var i_end = st[i];
	          if (i_end > end) {
	            st.splice(i, 1, end, st[i + 1], i_end);
	          }
	          i += 2;
	          at = Math.min(end, i_end);
	        }
	        if (!style) {
	          return;
	        }
	        if (overlay.opaque) {
	          st.splice(start, i - start, end, "overlay " + style);
	          i = start + 2;
	        } else {
	          for (; start < i; start += 2) {
	            var cur = st[start + 1];
	            st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
	          }
	        }
	      }, lineClasses);
	      context.state = state;
	      context.baseTokens = null;
	      context.baseTokenPos = 1;
	    };
	
	    for (var o = 0; o < cm.state.overlays.length; ++o) {
	      loop(o);
	    }return { styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null };
	  }
	
	  function getLineStyles(cm, line, updateFrontier) {
	    if (!line.styles || line.styles[0] != cm.state.modeGen) {
	      var context = getContextBefore(cm, lineNo(line));
	      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
	      var result = highlightLine(cm, line, context);
	      if (resetState) {
	        context.state = resetState;
	      }
	      line.stateAfter = context.save(!resetState);
	      line.styles = result.styles;
	      if (result.classes) {
	        line.styleClasses = result.classes;
	      } else if (line.styleClasses) {
	        line.styleClasses = null;
	      }
	      if (updateFrontier === cm.doc.highlightFrontier) {
	        cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
	      }
	    }
	    return line.styles;
	  }
	
	  function getContextBefore(cm, n, precise) {
	    var doc = cm.doc,
	        display = cm.display;
	    if (!doc.mode.startState) {
	      return new Context(doc, true, n);
	    }
	    var start = findStartLine(cm, n, precise);
	    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
	    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
	
	    doc.iter(start, n, function (line) {
	      processLine(cm, line.text, context);
	      var pos = context.line;
	      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
	      context.nextLine();
	    });
	    if (precise) {
	      doc.modeFrontier = context.line;
	    }
	    return context;
	  }
	
	  // Lightweight form of highlight -- proceed over this line and
	  // update state, but don't save a style array. Used for lines that
	  // aren't currently visible.
	  function processLine(cm, text, context, startAt) {
	    var mode = cm.doc.mode;
	    var stream = new StringStream(text, cm.options.tabSize, context);
	    stream.start = stream.pos = startAt || 0;
	    if (text == "") {
	      callBlankLine(mode, context.state);
	    }
	    while (!stream.eol()) {
	      readToken(mode, stream, context.state);
	      stream.start = stream.pos;
	    }
	  }
	
	  function callBlankLine(mode, state) {
	    if (mode.blankLine) {
	      return mode.blankLine(state);
	    }
	    if (!mode.innerMode) {
	      return;
	    }
	    var inner = innerMode(mode, state);
	    if (inner.mode.blankLine) {
	      return inner.mode.blankLine(inner.state);
	    }
	  }
	
	  function readToken(mode, stream, state, inner) {
	    for (var i = 0; i < 10; i++) {
	      if (inner) {
	        inner[0] = innerMode(mode, state).mode;
	      }
	      var style = mode.token(stream, state);
	      if (stream.pos > stream.start) {
	        return style;
	      }
	    }
	    throw new Error("Mode " + mode.name + " failed to advance stream.");
	  }
	
	  var Token = function Token(stream, type, state) {
	    this.start = stream.start;this.end = stream.pos;
	    this.string = stream.current();
	    this.type = type || null;
	    this.state = state;
	  };
	
	  // Utility for getTokenAt and getLineTokens
	  function takeToken(cm, pos, precise, asArray) {
	    var doc = cm.doc,
	        mode = doc.mode,
	        style;
	    pos = _clipPos(doc, pos);
	    var line = getLine(doc, pos.line),
	        context = getContextBefore(cm, pos.line, precise);
	    var stream = new StringStream(line.text, cm.options.tabSize, context),
	        tokens;
	    if (asArray) {
	      tokens = [];
	    }
	    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	      stream.start = stream.pos;
	      style = readToken(mode, stream, context.state);
	      if (asArray) {
	        tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
	      }
	    }
	    return asArray ? tokens : new Token(stream, style, context.state);
	  }
	
	  function extractLineClasses(type, output) {
	    if (type) {
	      for (;;) {
	        var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
	        if (!lineClass) {
	          break;
	        }
	        type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
	        var prop = lineClass[1] ? "bgClass" : "textClass";
	        if (output[prop] == null) {
	          output[prop] = lineClass[2];
	        } else if (!new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)").test(output[prop])) {
	          output[prop] += " " + lineClass[2];
	        }
	      }
	    }
	    return type;
	  }
	
	  // Run the given mode's parser over a line, calling f for each token.
	  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
	    var flattenSpans = mode.flattenSpans;
	    if (flattenSpans == null) {
	      flattenSpans = cm.options.flattenSpans;
	    }
	    var curStart = 0,
	        curStyle = null;
	    var stream = new StringStream(text, cm.options.tabSize, context),
	        style;
	    var inner = cm.options.addModeClass && [null];
	    if (text == "") {
	      extractLineClasses(callBlankLine(mode, context.state), lineClasses);
	    }
	    while (!stream.eol()) {
	      if (stream.pos > cm.options.maxHighlightLength) {
	        flattenSpans = false;
	        if (forceToEnd) {
	          processLine(cm, text, context, stream.pos);
	        }
	        stream.pos = text.length;
	        style = null;
	      } else {
	        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
	      }
	      if (inner) {
	        var mName = inner[0].name;
	        if (mName) {
	          style = "m-" + (style ? mName + " " + style : mName);
	        }
	      }
	      if (!flattenSpans || curStyle != style) {
	        while (curStart < stream.start) {
	          curStart = Math.min(stream.start, curStart + 5000);
	          f(curStart, curStyle);
	        }
	        curStyle = style;
	      }
	      stream.start = stream.pos;
	    }
	    while (curStart < stream.pos) {
	      // Webkit seems to refuse to render text nodes longer than 57444
	      // characters, and returns inaccurate measurements in nodes
	      // starting around 5000 chars.
	      var pos = Math.min(stream.pos, curStart + 5000);
	      f(pos, curStyle);
	      curStart = pos;
	    }
	  }
	
	  // Finds the line to start with when starting a parse. Tries to
	  // find a line with a stateAfter, so that it can start with a
	  // valid state. If that fails, it returns the line with the
	  // smallest indentation, which tends to need the least context to
	  // parse correctly.
	  function findStartLine(cm, n, precise) {
	    var minindent,
	        minline,
	        doc = cm.doc;
	    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
	    for (var search = n; search > lim; --search) {
	      if (search <= doc.first) {
	        return doc.first;
	      }
	      var line = getLine(doc, search - 1),
	          after = line.stateAfter;
	      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier)) {
	        return search;
	      }
	      var indented = countColumn(line.text, null, cm.options.tabSize);
	      if (minline == null || minindent > indented) {
	        minline = search - 1;
	        minindent = indented;
	      }
	    }
	    return minline;
	  }
	
	  function retreatFrontier(doc, n) {
	    doc.modeFrontier = Math.min(doc.modeFrontier, n);
	    if (doc.highlightFrontier < n - 10) {
	      return;
	    }
	    var start = doc.first;
	    for (var line = n - 1; line > start; line--) {
	      var saved = getLine(doc, line).stateAfter;
	      // change is on 3
	      // state on line 1 looked ahead 2 -- so saw 3
	      // test 1 + 2 < 3 should cover this
	      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
	        start = line + 1;
	        break;
	      }
	    }
	    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
	  }
	
	  // Optimize some code when these features are not used.
	  var sawReadOnlySpans = false,
	      sawCollapsedSpans = false;
	
	  function seeReadOnlySpans() {
	    sawReadOnlySpans = true;
	  }
	
	  function seeCollapsedSpans() {
	    sawCollapsedSpans = true;
	  }
	
	  // TEXTMARKER SPANS
	
	  function MarkedSpan(marker, from, to) {
	    this.marker = marker;
	    this.from = from;this.to = to;
	  }
	
	  // Search an array of spans for a span matching the given marker.
	  function getMarkedSpanFor(spans, marker) {
	    if (spans) {
	      for (var i = 0; i < spans.length; ++i) {
	        var span = spans[i];
	        if (span.marker == marker) {
	          return span;
	        }
	      }
	    }
	  }
	
	  // Remove a span from an array, returning undefined if no spans are
	  // left (we don't store arrays for lines without spans).
	  function removeMarkedSpan(spans, span) {
	    var r;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i] != span) {
	        (r || (r = [])).push(spans[i]);
	      }
	    }
	    return r;
	  }
	
	  // Add a span to a line.
	  function addMarkedSpan(line, span, op) {
	    var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet()));
	    if (inThisOp && line.markedSpans && inThisOp.has(line.markedSpans)) {
	      line.markedSpans.push(span);
	    } else {
	      line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
	      if (inThisOp) {
	        inThisOp.add(line.markedSpans);
	      }
	    }
	    span.marker.attachLine(line);
	  }
	
	  // Used for the algorithm that adjusts markers for a change in the
	  // document. These functions cut an array of spans at a given
	  // character position, returning an array of remaining chunks (or
	  // undefined if nothing remains).
	  function markedSpansBefore(old, startCh, isInsert) {
	    var nw;
	    if (old) {
	      for (var i = 0; i < old.length; ++i) {
	        var span = old[i],
	            marker = span.marker;
	        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
	        if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	          var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
	        }
	      }
	    }
	    return nw;
	  }
	  function markedSpansAfter(old, endCh, isInsert) {
	    var nw;
	    if (old) {
	      for (var i = 0; i < old.length; ++i) {
	        var span = old[i],
	            marker = span.marker;
	        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
	        if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	          var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
	        }
	      }
	    }
	    return nw;
	  }
	
	  // Given a change object, compute the new set of marker spans that
	  // cover the line in which the change took place. Removes spans
	  // entirely within the change, reconnects spans belonging to the
	  // same marker that appear on both sides of the change, and cuts off
	  // spans partially within the change. Returns an array of span
	  // arrays with one element for each line in (after) the change.
	  function stretchSpansOverChange(doc, change) {
	    if (change.full) {
	      return null;
	    }
	    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
	    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
	    if (!oldFirst && !oldLast) {
	      return null;
	    }
	
	    var startCh = change.from.ch,
	        endCh = change.to.ch,
	        isInsert = cmp(change.from, change.to) == 0;
	    // Get the spans that 'stick out' on both sides
	    var first = markedSpansBefore(oldFirst, startCh, isInsert);
	    var last = markedSpansAfter(oldLast, endCh, isInsert);
	
	    // Next, merge those two ends
	    var sameLine = change.text.length == 1,
	        offset = lst(change.text).length + (sameLine ? startCh : 0);
	    if (first) {
	      // Fix up .to properties of first
	      for (var i = 0; i < first.length; ++i) {
	        var span = first[i];
	        if (span.to == null) {
	          var found = getMarkedSpanFor(last, span.marker);
	          if (!found) {
	            span.to = startCh;
	          } else if (sameLine) {
	            span.to = found.to == null ? null : found.to + offset;
	          }
	        }
	      }
	    }
	    if (last) {
	      // Fix up .from in last (or move them into first in case of sameLine)
	      for (var i$1 = 0; i$1 < last.length; ++i$1) {
	        var span$1 = last[i$1];
	        if (span$1.to != null) {
	          span$1.to += offset;
	        }
	        if (span$1.from == null) {
	          var found$1 = getMarkedSpanFor(first, span$1.marker);
	          if (!found$1) {
	            span$1.from = offset;
	            if (sameLine) {
	              (first || (first = [])).push(span$1);
	            }
	          }
	        } else {
	          span$1.from += offset;
	          if (sameLine) {
	            (first || (first = [])).push(span$1);
	          }
	        }
	      }
	    }
	    // Make sure we didn't create any zero-length spans
	    if (first) {
	      first = clearEmptySpans(first);
	    }
	    if (last && last != first) {
	      last = clearEmptySpans(last);
	    }
	
	    var newMarkers = [first];
	    if (!sameLine) {
	      // Fill gap with whole-line-spans
	      var gap = change.text.length - 2,
	          gapMarkers;
	      if (gap > 0 && first) {
	        for (var i$2 = 0; i$2 < first.length; ++i$2) {
	          if (first[i$2].to == null) {
	            (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
	          }
	        }
	      }
	      for (var i$3 = 0; i$3 < gap; ++i$3) {
	        newMarkers.push(gapMarkers);
	      }
	      newMarkers.push(last);
	    }
	    return newMarkers;
	  }
	
	  // Remove spans that are empty and don't have a clearWhenEmpty
	  // option of false.
	  function clearEmptySpans(spans) {
	    for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) {
	        spans.splice(i--, 1);
	      }
	    }
	    if (!spans.length) {
	      return null;
	    }
	    return spans;
	  }
	
	  // Used to 'clip' out readOnly ranges when making a change.
	  function removeReadOnlyRanges(doc, from, to) {
	    var markers = null;
	    doc.iter(from.line, to.line + 1, function (line) {
	      if (line.markedSpans) {
	        for (var i = 0; i < line.markedSpans.length; ++i) {
	          var mark = line.markedSpans[i].marker;
	          if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) {
	            (markers || (markers = [])).push(mark);
	          }
	        }
	      }
	    });
	    if (!markers) {
	      return null;
	    }
	    var parts = [{ from: from, to: to }];
	    for (var i = 0; i < markers.length; ++i) {
	      var mk = markers[i],
	          m = mk.find(0);
	      for (var j = 0; j < parts.length; ++j) {
	        var p = parts[j];
	        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) {
	          continue;
	        }
	        var newParts = [j, 1],
	            dfrom = cmp(p.from, m.from),
	            dto = cmp(p.to, m.to);
	        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) {
	          newParts.push({ from: p.from, to: m.from });
	        }
	        if (dto > 0 || !mk.inclusiveRight && !dto) {
	          newParts.push({ from: m.to, to: p.to });
	        }
	        parts.splice.apply(parts, newParts);
	        j += newParts.length - 3;
	      }
	    }
	    return parts;
	  }
	
	  // Connect or disconnect spans from a line.
	  function detachMarkedSpans(line) {
	    var spans = line.markedSpans;
	    if (!spans) {
	      return;
	    }
	    for (var i = 0; i < spans.length; ++i) {
	      spans[i].marker.detachLine(line);
	    }
	    line.markedSpans = null;
	  }
	  function attachMarkedSpans(line, spans) {
	    if (!spans) {
	      return;
	    }
	    for (var i = 0; i < spans.length; ++i) {
	      spans[i].marker.attachLine(line);
	    }
	    line.markedSpans = spans;
	  }
	
	  // Helpers used when computing which overlapping collapsed span
	  // counts as the larger one.
	  function extraLeft(marker) {
	    return marker.inclusiveLeft ? -1 : 0;
	  }
	  function extraRight(marker) {
	    return marker.inclusiveRight ? 1 : 0;
	  }
	
	  // Returns a number indicating which of two overlapping collapsed
	  // spans is larger (and thus includes the other). Falls back to
	  // comparing ids when the spans cover exactly the same range.
	  function compareCollapsedMarkers(a, b) {
	    var lenDiff = a.lines.length - b.lines.length;
	    if (lenDiff != 0) {
	      return lenDiff;
	    }
	    var aPos = a.find(),
	        bPos = b.find();
	    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
	    if (fromCmp) {
	      return -fromCmp;
	    }
	    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
	    if (toCmp) {
	      return toCmp;
	    }
	    return b.id - a.id;
	  }
	
	  // Find out whether a line ends or starts in a collapsed span. If
	  // so, return the marker for that span.
	  function collapsedSpanAtSide(line, start) {
	    var sps = sawCollapsedSpans && line.markedSpans,
	        found;
	    if (sps) {
	      for (var sp = void 0, i = 0; i < sps.length; ++i) {
	        sp = sps[i];
	        if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
	          found = sp.marker;
	        }
	      }
	    }
	    return found;
	  }
	  function collapsedSpanAtStart(line) {
	    return collapsedSpanAtSide(line, true);
	  }
	  function collapsedSpanAtEnd(line) {
	    return collapsedSpanAtSide(line, false);
	  }
	
	  function collapsedSpanAround(line, ch) {
	    var sps = sawCollapsedSpans && line.markedSpans,
	        found;
	    if (sps) {
	      for (var i = 0; i < sps.length; ++i) {
	        var sp = sps[i];
	        if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
	          found = sp.marker;
	        }
	      }
	    }
	    return found;
	  }
	
	  // Test whether there exists a collapsed span that partially
	  // overlaps (covers the start or end, but not both) of a new span.
	  // Such overlap is not allowed.
	  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
	    var line = getLine(doc, lineNo);
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) {
	      for (var i = 0; i < sps.length; ++i) {
	        var sp = sps[i];
	        if (!sp.marker.collapsed) {
	          continue;
	        }
	        var found = sp.marker.find(0);
	        var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
	        var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
	        if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) {
	          continue;
	        }
	        if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) {
	          return true;
	        }
	      }
	    }
	  }
	
	  // A visual line is a line as drawn on the screen. Folding, for
	  // example, can cause multiple logical lines to appear on the same
	  // visual line. This finds the start of the visual line that the
	  // given line is part of (usually that is the line itself).
	  function visualLine(line) {
	    var merged;
	    while (merged = collapsedSpanAtStart(line)) {
	      line = merged.find(-1, true).line;
	    }
	    return line;
	  }
	
	  function visualLineEnd(line) {
	    var merged;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;
	    }
	    return line;
	  }
	
	  // Returns an array of logical lines that continue the visual line
	  // started by the argument, or undefined if there are no such lines.
	  function visualLineContinued(line) {
	    var merged, lines;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;(lines || (lines = [])).push(line);
	    }
	    return lines;
	  }
	
	  // Get the line number of the start of the visual line that the
	  // given line number is part of.
	  function visualLineNo(doc, lineN) {
	    var line = getLine(doc, lineN),
	        vis = visualLine(line);
	    if (line == vis) {
	      return lineN;
	    }
	    return lineNo(vis);
	  }
	
	  // Get the line number of the start of the next visual line after
	  // the given line.
	  function visualLineEndNo(doc, lineN) {
	    if (lineN > doc.lastLine()) {
	      return lineN;
	    }
	    var line = getLine(doc, lineN),
	        merged;
	    if (!lineIsHidden(doc, line)) {
	      return lineN;
	    }
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line;
	    }
	    return lineNo(line) + 1;
	  }
	
	  // Compute whether a line is hidden. Lines count as hidden when they
	  // are part of a visual line that starts with another line, or when
	  // they are entirely covered by collapsed, non-widget span.
	  function lineIsHidden(doc, line) {
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) {
	      for (var sp = void 0, i = 0; i < sps.length; ++i) {
	        sp = sps[i];
	        if (!sp.marker.collapsed) {
	          continue;
	        }
	        if (sp.from == null) {
	          return true;
	        }
	        if (sp.marker.widgetNode) {
	          continue;
	        }
	        if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) {
	          return true;
	        }
	      }
	    }
	  }
	  function lineIsHiddenInner(doc, line, span) {
	    if (span.to == null) {
	      var end = span.marker.find(1, true);
	      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
	    }
	    if (span.marker.inclusiveRight && span.to == line.text.length) {
	      return true;
	    }
	    for (var sp = void 0, i = 0; i < line.markedSpans.length; ++i) {
	      sp = line.markedSpans[i];
	      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) {
	        return true;
	      }
	    }
	  }
	
	  // Find the height above the given line.
	  function _heightAtLine(lineObj) {
	    lineObj = visualLine(lineObj);
	
	    var h = 0,
	        chunk = lineObj.parent;
	    for (var i = 0; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i];
	      if (line == lineObj) {
	        break;
	      } else {
	        h += line.height;
	      }
	    }
	    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
	        var cur = p.children[i$1];
	        if (cur == chunk) {
	          break;
	        } else {
	          h += cur.height;
	        }
	      }
	    }
	    return h;
	  }
	
	  // Compute the character length of a line, taking into account
	  // collapsed ranges (see markText) that might hide parts, and join
	  // other lines onto it.
	  function lineLength(line) {
	    if (line.height == 0) {
	      return 0;
	    }
	    var len = line.text.length,
	        merged,
	        cur = line;
	    while (merged = collapsedSpanAtStart(cur)) {
	      var found = merged.find(0, true);
	      cur = found.from.line;
	      len += found.from.ch - found.to.ch;
	    }
	    cur = line;
	    while (merged = collapsedSpanAtEnd(cur)) {
	      var found$1 = merged.find(0, true);
	      len -= cur.text.length - found$1.from.ch;
	      cur = found$1.to.line;
	      len += cur.text.length - found$1.to.ch;
	    }
	    return len;
	  }
	
	  // Find the longest line in the document.
	  function findMaxLine(cm) {
	    var d = cm.display,
	        doc = cm.doc;
	    d.maxLine = getLine(doc, doc.first);
	    d.maxLineLength = lineLength(d.maxLine);
	    d.maxLineChanged = true;
	    doc.iter(function (line) {
	      var len = lineLength(line);
	      if (len > d.maxLineLength) {
	        d.maxLineLength = len;
	        d.maxLine = line;
	      }
	    });
	  }
	
	  // LINE DATA STRUCTURE
	
	  // Line objects. These hold state related to a line, including
	  // highlighting info (the styles array).
	  var Line = function Line(text, markedSpans, estimateHeight) {
	    this.text = text;
	    attachMarkedSpans(this, markedSpans);
	    this.height = estimateHeight ? estimateHeight(this) : 1;
	  };
	
	  Line.prototype.lineNo = function () {
	    return lineNo(this);
	  };
	  eventMixin(Line);
	
	  // Change the content (text, markers) of a line. Automatically
	  // invalidates cached information and tries to re-estimate the
	  // line's height.
	  function updateLine(line, text, markedSpans, estimateHeight) {
	    line.text = text;
	    if (line.stateAfter) {
	      line.stateAfter = null;
	    }
	    if (line.styles) {
	      line.styles = null;
	    }
	    if (line.order != null) {
	      line.order = null;
	    }
	    detachMarkedSpans(line);
	    attachMarkedSpans(line, markedSpans);
	    var estHeight = estimateHeight ? estimateHeight(line) : 1;
	    if (estHeight != line.height) {
	      updateLineHeight(line, estHeight);
	    }
	  }
	
	  // Detach a line from the document tree and its markers.
	  function cleanUpLine(line) {
	    line.parent = null;
	    detachMarkedSpans(line);
	  }
	
	  // Convert a style as returned by a mode (either null, or a string
	  // containing one or more styles) to a CSS style. This is cached,
	  // and also looks for line-wide styles.
	  var styleToClassCache = {},
	      styleToClassCacheWithMode = {};
	  function interpretTokenStyle(style, options) {
	    if (!style || /^\s*$/.test(style)) {
	      return null;
	    }
	    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
	    return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
	  }
	
	  // Render the DOM representation of the text of a line. Also builds
	  // up a 'line map', which points at the DOM nodes that represent
	  // specific stretches of text, and is used by the measuring code.
	  // The returned object contains the DOM node, this map, and
	  // information about line-wide styles that were set by the mode.
	  function buildLineContent(cm, lineView) {
	    // The padding-right forces the element to have a 'border', which
	    // is needed on Webkit to be able to get line-level bounding
	    // rectangles for it (in measureChar).
	    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
	    var builder = { pre: eltP("pre", [content], "CodeMirror-line"), content: content,
	      col: 0, pos: 0, cm: cm,
	      trailingSpace: false,
	      splitSpaces: cm.getOption("lineWrapping") };
	    lineView.measure = {};
	
	    // Iterate over the logical lines that make up this visual line.
	    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	      var line = i ? lineView.rest[i - 1] : lineView.line,
	          order = void 0;
	      builder.pos = 0;
	      builder.addToken = buildToken;
	      // Optionally wire in some hacks into the token-rendering
	      // algorithm, to deal with browser quirks.
	      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) {
	        builder.addToken = buildTokenBadBidi(builder.addToken, order);
	      }
	      builder.map = [];
	      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
	      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
	      if (line.styleClasses) {
	        if (line.styleClasses.bgClass) {
	          builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
	        }
	        if (line.styleClasses.textClass) {
	          builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
	        }
	      }
	
	      // Ensure at least a single node is present, for measuring.
	      if (builder.map.length == 0) {
	        builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
	      }
	
	      // Store the map and a cache object for the current logical line
	      if (i == 0) {
	        lineView.measure.map = builder.map;
	        lineView.measure.cache = {};
	      } else {
	        (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);(lineView.measure.caches || (lineView.measure.caches = [])).push({});
	      }
	    }
	
	    // See issue #2901
	    if (webkit) {
	      var last = builder.content.lastChild;
	      if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) {
	        builder.content.className = "cm-tab-wrap-hack";
	      }
	    }
	
	    signal(cm, "renderLine", cm, lineView.line, builder.pre);
	    if (builder.pre.className) {
	      builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
	    }
	
	    return builder;
	  }
	
	  function defaultSpecialCharPlaceholder(ch) {
	    var token = elt("span", '\u2022', "cm-invalidchar");
	    token.title = '\\u' + ch.charCodeAt(0).toString(16);
	    token.setAttribute("aria-label", token.title);
	    return token;
	  }
	
	  // Build up the DOM representation for a single token, and add it to
	  // the line map. Takes care to render special characters separately.
	  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
	    if (!text) {
	      return;
	    }
	    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
	    var special = builder.cm.state.specialChars,
	        mustWrap = false;
	    var content;
	    if (!special.test(text)) {
	      builder.col += text.length;
	      content = document.createTextNode(displayText);
	      builder.map.push(builder.pos, builder.pos + text.length, content);
	      if (ie && ie_version < 9) {
	        mustWrap = true;
	      }
	      builder.pos += text.length;
	    } else {
	      content = document.createDocumentFragment();
	      var pos = 0;
	      while (true) {
	        special.lastIndex = pos;
	        var m = special.exec(text);
	        var skipped = m ? m.index - pos : text.length - pos;
	        if (skipped) {
	          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
	          if (ie && ie_version < 9) {
	            content.appendChild(elt("span", [txt]));
	          } else {
	            content.appendChild(txt);
	          }
	          builder.map.push(builder.pos, builder.pos + skipped, txt);
	          builder.col += skipped;
	          builder.pos += skipped;
	        }
	        if (!m) {
	          break;
	        }
	        pos += skipped + 1;
	        var txt$1 = void 0;
	        if (m[0] == "\t") {
	          var tabSize = builder.cm.options.tabSize,
	              tabWidth = tabSize - builder.col % tabSize;
	          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
	          txt$1.setAttribute("role", "presentation");
	          txt$1.setAttribute("cm-text", "\t");
	          builder.col += tabWidth;
	        } else if (m[0] == "\r" || m[0] == "\n") {
	          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? '\u240D' : '\u2424', "cm-invalidchar"));
	          txt$1.setAttribute("cm-text", m[0]);
	          builder.col += 1;
	        } else {
	          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
	          txt$1.setAttribute("cm-text", m[0]);
	          if (ie && ie_version < 9) {
	            content.appendChild(elt("span", [txt$1]));
	          } else {
	            content.appendChild(txt$1);
	          }
	          builder.col += 1;
	        }
	        builder.map.push(builder.pos, builder.pos + 1, txt$1);
	        builder.pos++;
	      }
	    }
	    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
	    if (style || startStyle || endStyle || mustWrap || css || attributes) {
	      var fullStyle = style || "";
	      if (startStyle) {
	        fullStyle += startStyle;
	      }
	      if (endStyle) {
	        fullStyle += endStyle;
	      }
	      var token = elt("span", [content], fullStyle, css);
	      if (attributes) {
	        for (var attr in attributes) {
	          if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") {
	            token.setAttribute(attr, attributes[attr]);
	          }
	        }
	      }
	      return builder.content.appendChild(token);
	    }
	    builder.content.appendChild(content);
	  }
	
	  // Change some spaces to NBSP to prevent the browser from collapsing
	  // trailing spaces at the end of a line when rendering text (issue #1362).
	  function splitSpaces(text, trailingBefore) {
	    if (text.length > 1 && !/  /.test(text)) {
	      return text;
	    }
	    var spaceBefore = trailingBefore,
	        result = "";
	    for (var i = 0; i < text.length; i++) {
	      var ch = text.charAt(i);
	      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) {
	        ch = '\xA0';
	      }
	      result += ch;
	      spaceBefore = ch == " ";
	    }
	    return result;
	  }
	
	  // Work around nonsense dimensions being reported for stretches of
	  // right-to-left text.
	  function buildTokenBadBidi(inner, order) {
	    return function (builder, text, style, startStyle, endStyle, css, attributes) {
	      style = style ? style + " cm-force-border" : "cm-force-border";
	      var start = builder.pos,
	          end = start + text.length;
	      for (;;) {
	        // Find the part that overlaps with the start of this text
	        var part = void 0;
	        for (var i = 0; i < order.length; i++) {
	          part = order[i];
	          if (part.to > start && part.from <= start) {
	            break;
	          }
	        }
	        if (part.to >= end) {
	          return inner(builder, text, style, startStyle, endStyle, css, attributes);
	        }
	        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
	        startStyle = null;
	        text = text.slice(part.to - start);
	        start = part.to;
	      }
	    };
	  }
	
	  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	    var widget = !ignoreWidget && marker.widgetNode;
	    if (widget) {
	      builder.map.push(builder.pos, builder.pos + size, widget);
	    }
	    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	      if (!widget) {
	        widget = builder.content.appendChild(document.createElement("span"));
	      }
	      widget.setAttribute("cm-marker", marker.id);
	    }
	    if (widget) {
	      builder.cm.display.input.setUneditable(widget);
	      builder.content.appendChild(widget);
	    }
	    builder.pos += size;
	    builder.trailingSpace = false;
	  }
	
	  // Outputs a number of spans to make up a line, taking highlighting
	  // and marked text into account.
	  function insertLineContent(line, builder, styles) {
	    var spans = line.markedSpans,
	        allText = line.text,
	        at = 0;
	    if (!spans) {
	      for (var i$1 = 1; i$1 < styles.length; i$1 += 2) {
	        builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
	      }
	      return;
	    }
	
	    var len = allText.length,
	        pos = 0,
	        i = 1,
	        text = "",
	        style,
	        css;
	    var nextChange = 0,
	        spanStyle,
	        spanEndStyle,
	        spanStartStyle,
	        collapsed,
	        attributes;
	    for (;;) {
	      if (nextChange == pos) {
	        // Update current marker set
	        spanStyle = spanEndStyle = spanStartStyle = css = "";
	        attributes = null;
	        collapsed = null;nextChange = Infinity;
	        var foundBookmarks = [],
	            endStyles = void 0;
	        for (var j = 0; j < spans.length; ++j) {
	          var sp = spans[j],
	              m = sp.marker;
	          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	            foundBookmarks.push(m);
	          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	              nextChange = sp.to;
	              spanEndStyle = "";
	            }
	            if (m.className) {
	              spanStyle += " " + m.className;
	            }
	            if (m.css) {
	              css = (css ? css + ";" : "") + m.css;
	            }
	            if (m.startStyle && sp.from == pos) {
	              spanStartStyle += " " + m.startStyle;
	            }
	            if (m.endStyle && sp.to == nextChange) {
	              (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
	            }
	            // support for the old title property
	            // https://github.com/codemirror/CodeMirror/pull/5673
	            if (m.title) {
	              (attributes || (attributes = {})).title = m.title;
	            }
	            if (m.attributes) {
	              for (var attr in m.attributes) {
	                (attributes || (attributes = {}))[attr] = m.attributes[attr];
	              }
	            }
	            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) {
	              collapsed = sp;
	            }
	          } else if (sp.from > pos && nextChange > sp.from) {
	            nextChange = sp.from;
	          }
	        }
	        if (endStyles) {
	          for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2) {
	            if (endStyles[j$1 + 1] == nextChange) {
	              spanEndStyle += " " + endStyles[j$1];
	            }
	          }
	        }
	
	        if (!collapsed || collapsed.from == pos) {
	          for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2) {
	            buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
	          }
	        }
	        if (collapsed && (collapsed.from || 0) == pos) {
	          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
	          if (collapsed.to == null) {
	            return;
	          }
	          if (collapsed.to == pos) {
	            collapsed = false;
	          }
	        }
	      }
	      if (pos >= len) {
	        break;
	      }
	
	      var upto = Math.min(len, nextChange);
	      while (true) {
	        if (text) {
	          var end = pos + text.length;
	          if (!collapsed) {
	            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
	            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
	          }
	          if (end >= upto) {
	            text = text.slice(upto - pos);pos = upto;break;
	          }
	          pos = end;
	          spanStartStyle = "";
	        }
	        text = allText.slice(at, at = styles[i++]);
	        style = interpretTokenStyle(styles[i++], builder.cm.options);
	      }
	    }
	  }
	
	  // These objects are used to represent the visible (currently drawn)
	  // part of the document. A LineView may correspond to multiple
	  // logical lines, if those are connected by collapsed ranges.
	  function LineView(doc, line, lineN) {
	    // The starting line
	    this.line = line;
	    // Continuing lines, if any
	    this.rest = visualLineContinued(line);
	    // Number of logical lines in this visual line
	    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
	    this.node = this.text = null;
	    this.hidden = lineIsHidden(doc, line);
	  }
	
	  // Create a range of LineView objects for the given lines.
	  function buildViewArray(cm, from, to) {
	    var array = [],
	        nextPos;
	    for (var pos = from; pos < to; pos = nextPos) {
	      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
	      nextPos = pos + view.size;
	      array.push(view);
	    }
	    return array;
	  }
	
	  var operationGroup = null;
	
	  function pushOperation(op) {
	    if (operationGroup) {
	      operationGroup.ops.push(op);
	    } else {
	      op.ownsGroup = operationGroup = {
	        ops: [op],
	        delayedCallbacks: []
	      };
	    }
	  }
	
	  function fireCallbacksForOps(group) {
	    // Calls delayed callbacks and cursorActivity handlers until no
	    // new ones appear
	    var callbacks = group.delayedCallbacks,
	        i = 0;
	    do {
	      for (; i < callbacks.length; i++) {
	        callbacks[i].call(null);
	      }
	      for (var j = 0; j < group.ops.length; j++) {
	        var op = group.ops[j];
	        if (op.cursorActivityHandlers) {
	          while (op.cursorActivityCalled < op.cursorActivityHandlers.length) {
	            op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
	          }
	        }
	      }
	    } while (i < callbacks.length);
	  }
	
	  function finishOperation(op, endCb) {
	    var group = op.ownsGroup;
	    if (!group) {
	      return;
	    }
	
	    try {
	      fireCallbacksForOps(group);
	    } finally {
	      operationGroup = null;
	      endCb(group);
	    }
	  }
	
	  var orphanDelayedCallbacks = null;
	
	  // Often, we want to signal events at a point where we are in the
	  // middle of some work, but don't want the handler to start calling
	  // other methods on the editor, which might be in an inconsistent
	  // state or simply not expect any other events to happen.
	  // signalLater looks whether there are any handlers, and schedules
	  // them to be executed when the last operation ends, or, if no
	  // operation is active, when a timeout fires.
	  function signalLater(emitter, type /*, values...*/) {
	    var arr = getHandlers(emitter, type);
	    if (!arr.length) {
	      return;
	    }
	    var args = Array.prototype.slice.call(arguments, 2),
	        list;
	    if (operationGroup) {
	      list = operationGroup.delayedCallbacks;
	    } else if (orphanDelayedCallbacks) {
	      list = orphanDelayedCallbacks;
	    } else {
	      list = orphanDelayedCallbacks = [];
	      setTimeout(fireOrphanDelayed, 0);
	    }
	    var loop = function loop(i) {
	      list.push(function () {
	        return arr[i].apply(null, args);
	      });
	    };
	
	    for (var i = 0; i < arr.length; ++i) {
	      loop(i);
	    }
	  }
	
	  function fireOrphanDelayed() {
	    var delayed = orphanDelayedCallbacks;
	    orphanDelayedCallbacks = null;
	    for (var i = 0; i < delayed.length; ++i) {
	      delayed[i]();
	    }
	  }
	
	  // When an aspect of a line changes, a string is added to
	  // lineView.changes. This updates the relevant part of the line's
	  // DOM structure.
	  function updateLineForChanges(cm, lineView, lineN, dims) {
	    for (var j = 0; j < lineView.changes.length; j++) {
	      var type = lineView.changes[j];
	      if (type == "text") {
	        updateLineText(cm, lineView);
	      } else if (type == "gutter") {
	        updateLineGutter(cm, lineView, lineN, dims);
	      } else if (type == "class") {
	        updateLineClasses(cm, lineView);
	      } else if (type == "widget") {
	        updateLineWidgets(cm, lineView, dims);
	      }
	    }
	    lineView.changes = null;
	  }
	
	  // Lines with gutter elements, widgets or a background class need to
	  // be wrapped, and have the extra elements added to the wrapper div
	  function ensureLineWrapped(lineView) {
	    if (lineView.node == lineView.text) {
	      lineView.node = elt("div", null, null, "position: relative");
	      if (lineView.text.parentNode) {
	        lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
	      }
	      lineView.node.appendChild(lineView.text);
	      if (ie && ie_version < 8) {
	        lineView.node.style.zIndex = 2;
	      }
	    }
	    return lineView.node;
	  }
	
	  function updateLineBackground(cm, lineView) {
	    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
	    if (cls) {
	      cls += " CodeMirror-linebackground";
	    }
	    if (lineView.background) {
	      if (cls) {
	        lineView.background.className = cls;
	      } else {
	        lineView.background.parentNode.removeChild(lineView.background);lineView.background = null;
	      }
	    } else if (cls) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
	      cm.display.input.setUneditable(lineView.background);
	    }
	  }
	
	  // Wrapper around buildLineContent which will reuse the structure
	  // in display.externalMeasured when possible.
	  function getLineContent(cm, lineView) {
	    var ext = cm.display.externalMeasured;
	    if (ext && ext.line == lineView.line) {
	      cm.display.externalMeasured = null;
	      lineView.measure = ext.measure;
	      return ext.built;
	    }
	    return buildLineContent(cm, lineView);
	  }
	
	  // Redraw the line's text. Interacts with the background and text
	  // classes because the mode may output tokens that influence these
	  // classes.
	  function updateLineText(cm, lineView) {
	    var cls = lineView.text.className;
	    var built = getLineContent(cm, lineView);
	    if (lineView.text == lineView.node) {
	      lineView.node = built.pre;
	    }
	    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
	    lineView.text = built.pre;
	    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	      lineView.bgClass = built.bgClass;
	      lineView.textClass = built.textClass;
	      updateLineClasses(cm, lineView);
	    } else if (cls) {
	      lineView.text.className = cls;
	    }
	  }
	
	  function updateLineClasses(cm, lineView) {
	    updateLineBackground(cm, lineView);
	    if (lineView.line.wrapClass) {
	      ensureLineWrapped(lineView).className = lineView.line.wrapClass;
	    } else if (lineView.node != lineView.text) {
	      lineView.node.className = "";
	    }
	    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
	    lineView.text.className = textClass || "";
	  }
	
	  function updateLineGutter(cm, lineView, lineN, dims) {
	    if (lineView.gutter) {
	      lineView.node.removeChild(lineView.gutter);
	      lineView.gutter = null;
	    }
	    if (lineView.gutterBackground) {
	      lineView.node.removeChild(lineView.gutterBackground);
	      lineView.gutterBackground = null;
	    }
	    if (lineView.line.gutterClass) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
	      cm.display.input.setUneditable(lineView.gutterBackground);
	      wrap.insertBefore(lineView.gutterBackground, lineView.text);
	    }
	    var markers = lineView.line.gutterMarkers;
	    if (cm.options.lineNumbers || markers) {
	      var wrap$1 = ensureLineWrapped(lineView);
	      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
	      gutterWrap.setAttribute("aria-hidden", "true");
	      cm.display.input.setUneditable(gutterWrap);
	      wrap$1.insertBefore(gutterWrap, lineView.text);
	      if (lineView.line.gutterClass) {
	        gutterWrap.className += " " + lineView.line.gutterClass;
	      }
	      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) {
	        lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
	      }
	      if (markers) {
	        for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
	          var id = cm.display.gutterSpecs[k].className,
	              found = markers.hasOwnProperty(id) && markers[id];
	          if (found) {
	            gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
	          }
	        }
	      }
	    }
	  }
	
	  function updateLineWidgets(cm, lineView, dims) {
	    if (lineView.alignable) {
	      lineView.alignable = null;
	    }
	    var isWidget = classTest("CodeMirror-linewidget");
	    for (var node = lineView.node.firstChild, next = void 0; node; node = next) {
	      next = node.nextSibling;
	      if (isWidget.test(node.className)) {
	        lineView.node.removeChild(node);
	      }
	    }
	    insertLineWidgets(cm, lineView, dims);
	  }
	
	  // Build a line's DOM representation from scratch
	  function buildLineElement(cm, lineView, lineN, dims) {
	    var built = getLineContent(cm, lineView);
	    lineView.text = lineView.node = built.pre;
	    if (built.bgClass) {
	      lineView.bgClass = built.bgClass;
	    }
	    if (built.textClass) {
	      lineView.textClass = built.textClass;
	    }
	
	    updateLineClasses(cm, lineView);
	    updateLineGutter(cm, lineView, lineN, dims);
	    insertLineWidgets(cm, lineView, dims);
	    return lineView.node;
	  }
	
	  // A lineView may contain multiple logical lines (when merged by
	  // collapsed spans). The widgets for all of them need to be drawn.
	  function insertLineWidgets(cm, lineView, dims) {
	    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
	    if (lineView.rest) {
	      for (var i = 0; i < lineView.rest.length; i++) {
	        insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
	      }
	    }
	  }
	
	  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	    if (!line.widgets) {
	      return;
	    }
	    var wrap = ensureLineWrapped(lineView);
	    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	      var widget = ws[i],
	          node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
	      if (!widget.handleMouseEvents) {
	        node.setAttribute("cm-ignore-events", "true");
	      }
	      positionLineWidget(widget, node, lineView, dims);
	      cm.display.input.setUneditable(node);
	      if (allowAbove && widget.above) {
	        wrap.insertBefore(node, lineView.gutter || lineView.text);
	      } else {
	        wrap.appendChild(node);
	      }
	      signalLater(widget, "redraw");
	    }
	  }
	
	  function positionLineWidget(widget, node, lineView, dims) {
	    if (widget.noHScroll) {
	      (lineView.alignable || (lineView.alignable = [])).push(node);
	      var width = dims.wrapperWidth;
	      node.style.left = dims.fixedPos + "px";
	      if (!widget.coverGutter) {
	        width -= dims.gutterTotalWidth;
	        node.style.paddingLeft = dims.gutterTotalWidth + "px";
	      }
	      node.style.width = width + "px";
	    }
	    if (widget.coverGutter) {
	      node.style.zIndex = 5;
	      node.style.position = "relative";
	      if (!widget.noHScroll) {
	        node.style.marginLeft = -dims.gutterTotalWidth + "px";
	      }
	    }
	  }
	
	  function widgetHeight(widget) {
	    if (widget.height != null) {
	      return widget.height;
	    }
	    var cm = widget.doc.cm;
	    if (!cm) {
	      return 0;
	    }
	    if (!contains(document.body, widget.node)) {
	      var parentStyle = "position: relative;";
	      if (widget.coverGutter) {
	        parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
	      }
	      if (widget.noHScroll) {
	        parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
	      }
	      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
	    }
	    return widget.height = widget.node.parentNode.offsetHeight;
	  }
	
	  // Return true when the given mouse event happened in a widget
	  function eventInWidget(display, e) {
	    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	      if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) {
	        return true;
	      }
	    }
	  }
	
	  // POSITION MEASUREMENT
	
	  function paddingTop(display) {
	    return display.lineSpace.offsetTop;
	  }
	  function paddingVert(display) {
	    return display.mover.offsetHeight - display.lineSpace.offsetHeight;
	  }
	  function paddingH(display) {
	    if (display.cachedPaddingH) {
	      return display.cachedPaddingH;
	    }
	    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
	    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
	    var data = { left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight) };
	    if (!isNaN(data.left) && !isNaN(data.right)) {
	      display.cachedPaddingH = data;
	    }
	    return data;
	  }
	
	  function scrollGap(cm) {
	    return scrollerGap - cm.display.nativeBarWidth;
	  }
	  function displayWidth(cm) {
	    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
	  }
	  function displayHeight(cm) {
	    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
	  }
	
	  // Ensure the lineView.wrapping.heights array is populated. This is
	  // an array of bottom offsets for the lines that make up a drawn
	  // line. When lineWrapping is on, there might be more than one
	  // height.
	  function ensureLineHeights(cm, lineView, rect) {
	    var wrapping = cm.options.lineWrapping;
	    var curWidth = wrapping && displayWidth(cm);
	    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	      var heights = lineView.measure.heights = [];
	      if (wrapping) {
	        lineView.measure.width = curWidth;
	        var rects = lineView.text.firstChild.getClientRects();
	        for (var i = 0; i < rects.length - 1; i++) {
	          var cur = rects[i],
	              next = rects[i + 1];
	          if (Math.abs(cur.bottom - next.bottom) > 2) {
	            heights.push((cur.bottom + next.top) / 2 - rect.top);
	          }
	        }
	      }
	      heights.push(rect.bottom - rect.top);
	    }
	  }
	
	  // Find a line map (mapping character offsets to text nodes) and a
	  // measurement cache for the given line number. (A line view might
	  // contain multiple lines when collapsed ranges are present.)
	  function mapFromLineView(lineView, line, lineN) {
	    if (lineView.line == line) {
	      return { map: lineView.measure.map, cache: lineView.measure.cache };
	    }
	    if (lineView.rest) {
	      for (var i = 0; i < lineView.rest.length; i++) {
	        if (lineView.rest[i] == line) {
	          return { map: lineView.measure.maps[i], cache: lineView.measure.caches[i] };
	        }
	      }
	      for (var i$1 = 0; i$1 < lineView.rest.length; i$1++) {
	        if (lineNo(lineView.rest[i$1]) > lineN) {
	          return { map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true };
	        }
	      }
	    }
	  }
	
	  // Render a line into the hidden node display.externalMeasured. Used
	  // when measurement is needed for a line that's not in the viewport.
	  function updateExternalMeasurement(cm, line) {
	    line = visualLine(line);
	    var lineN = lineNo(line);
	    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
	    view.lineN = lineN;
	    var built = view.built = buildLineContent(cm, view);
	    view.text = built.pre;
	    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
	    return view;
	  }
	
	  // Get a {top, bottom, left, right} box (in line-local coordinates)
	  // for a given character.
	  function measureChar(cm, line, ch, bias) {
	    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
	  }
	
	  // Find a line view that corresponds to the given line number.
	  function findViewForLine(cm, lineN) {
	    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) {
	      return cm.display.view[findViewIndex(cm, lineN)];
	    }
	    var ext = cm.display.externalMeasured;
	    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) {
	      return ext;
	    }
	  }
	
	  // Measurement can be split in two steps, the set-up work that
	  // applies to the whole line, and the measurement of the actual
	  // character. Functions like coordsChar, that need to do a lot of
	  // measurements in a row, can thus ensure that the set-up work is
	  // only done once.
	  function prepareMeasureForLine(cm, line) {
	    var lineN = lineNo(line);
	    var view = findViewForLine(cm, lineN);
	    if (view && !view.text) {
	      view = null;
	    } else if (view && view.changes) {
	      updateLineForChanges(cm, view, lineN, getDimensions(cm));
	      cm.curOp.forceUpdate = true;
	    }
	    if (!view) {
	      view = updateExternalMeasurement(cm, line);
	    }
	
	    var info = mapFromLineView(view, line, lineN);
	    return {
	      line: line, view: view, rect: null,
	      map: info.map, cache: info.cache, before: info.before,
	      hasHeights: false
	    };
	  }
	
	  // Given a prepared measurement object, measures the position of an
	  // actual character (or fetches it from the cache).
	  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	    if (prepared.before) {
	      ch = -1;
	    }
	    var key = ch + (bias || ""),
	        found;
	    if (prepared.cache.hasOwnProperty(key)) {
	      found = prepared.cache[key];
	    } else {
	      if (!prepared.rect) {
	        prepared.rect = prepared.view.text.getBoundingClientRect();
	      }
	      if (!prepared.hasHeights) {
	        ensureLineHeights(cm, prepared.view, prepared.rect);
	        prepared.hasHeights = true;
	      }
	      found = measureCharInner(cm, prepared, ch, bias);
	      if (!found.bogus) {
	        prepared.cache[key] = found;
	      }
	    }
	    return { left: found.left, right: found.right,
	      top: varHeight ? found.rtop : found.top,
	      bottom: varHeight ? found.rbottom : found.bottom };
	  }
	
	  var nullRect = { left: 0, right: 0, top: 0, bottom: 0 };
	
	  function nodeAndOffsetInLineMap(map, ch, bias) {
	    var node, start, end, collapse, mStart, mEnd;
	    // First, search the line map for the text node corresponding to,
	    // or closest to, the target character.
	    for (var i = 0; i < map.length; i += 3) {
	      mStart = map[i];
	      mEnd = map[i + 1];
	      if (ch < mStart) {
	        start = 0;end = 1;
	        collapse = "left";
	      } else if (ch < mEnd) {
	        start = ch - mStart;
	        end = start + 1;
	      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
	        end = mEnd - mStart;
	        start = end - 1;
	        if (ch >= mEnd) {
	          collapse = "right";
	        }
	      }
	      if (start != null) {
	        node = map[i + 2];
	        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) {
	          collapse = bias;
	        }
	        if (bias == "left" && start == 0) {
	          while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
	            node = map[(i -= 3) + 2];
	            collapse = "left";
	          }
	        }
	        if (bias == "right" && start == mEnd - mStart) {
	          while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
	            node = map[(i += 3) + 2];
	            collapse = "right";
	          }
	        }
	        break;
	      }
	    }
	    return { node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd };
	  }
	
	  function getUsefulRect(rects, bias) {
	    var rect = nullRect;
	    if (bias == "left") {
	      for (var i = 0; i < rects.length; i++) {
	        if ((rect = rects[i]).left != rect.right) {
	          break;
	        }
	      }
	    } else {
	      for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
	        if ((rect = rects[i$1]).left != rect.right) {
	          break;
	        }
	      }
	    }
	    return rect;
	  }
	
	  function measureCharInner(cm, prepared, ch, bias) {
	    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
	    var node = place.node,
	        start = place.start,
	        end = place.end,
	        collapse = place.collapse;
	
	    var rect;
	    if (node.nodeType == 3) {
	      // If it is a text node, use a range to retrieve the coordinates.
	      for (var i$1 = 0; i$1 < 4; i$1++) {
	        // Retry a maximum of 4 times when nonsense rectangles are returned
	        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) {
	          --start;
	        }
	        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) {
	          ++end;
	        }
	        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) {
	          rect = node.parentNode.getBoundingClientRect();
	        } else {
	          rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
	        }
	        if (rect.left || rect.right || start == 0) {
	          break;
	        }
	        end = start;
	        start = start - 1;
	        collapse = "right";
	      }
	      if (ie && ie_version < 11) {
	        rect = maybeUpdateRectForZooming(cm.display.measure, rect);
	      }
	    } else {
	      // If it is a widget, simply get the box for the whole widget.
	      if (start > 0) {
	        collapse = bias = "right";
	      }
	      var rects;
	      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) {
	        rect = rects[bias == "right" ? rects.length - 1 : 0];
	      } else {
	        rect = node.getBoundingClientRect();
	      }
	    }
	    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	      var rSpan = node.parentNode.getClientRects()[0];
	      if (rSpan) {
	        rect = { left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom };
	      } else {
	        rect = nullRect;
	      }
	    }
	
	    var rtop = rect.top - prepared.rect.top,
	        rbot = rect.bottom - prepared.rect.top;
	    var mid = (rtop + rbot) / 2;
	    var heights = prepared.view.measure.heights;
	    var i = 0;
	    for (; i < heights.length - 1; i++) {
	      if (mid < heights[i]) {
	        break;
	      }
	    }
	    var top = i ? heights[i - 1] : 0,
	        bot = heights[i];
	    var result = { left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	      right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	      top: top, bottom: bot };
	    if (!rect.left && !rect.right) {
	      result.bogus = true;
	    }
	    if (!cm.options.singleCursorHeightPerLine) {
	      result.rtop = rtop;result.rbottom = rbot;
	    }
	
	    return result;
	  }
	
	  // Work around problem with bounding client rects on ranges being
	  // returned incorrectly when zoomed on IE10 and below.
	  function maybeUpdateRectForZooming(measure, rect) {
	    if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) {
	      return rect;
	    }
	    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
	    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
	    return { left: rect.left * scaleX, right: rect.right * scaleX,
	      top: rect.top * scaleY, bottom: rect.bottom * scaleY };
	  }
	
	  function clearLineMeasurementCacheFor(lineView) {
	    if (lineView.measure) {
	      lineView.measure.cache = {};
	      lineView.measure.heights = null;
	      if (lineView.rest) {
	        for (var i = 0; i < lineView.rest.length; i++) {
	          lineView.measure.caches[i] = {};
	        }
	      }
	    }
	  }
	
	  function clearLineMeasurementCache(cm) {
	    cm.display.externalMeasure = null;
	    removeChildren(cm.display.lineMeasure);
	    for (var i = 0; i < cm.display.view.length; i++) {
	      clearLineMeasurementCacheFor(cm.display.view[i]);
	    }
	  }
	
	  function clearCaches(cm) {
	    clearLineMeasurementCache(cm);
	    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
	    if (!cm.options.lineWrapping) {
	      cm.display.maxLineChanged = true;
	    }
	    cm.display.lineNumChars = null;
	  }
	
	  function pageScrollX(doc) {
	    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
	    // which causes page_Offset and bounding client rects to use
	    // different reference viewports and invalidate our calculations.
	    if (chrome && android) {
	      return -(doc.body.getBoundingClientRect().left - parseInt(getComputedStyle(doc.body).marginLeft));
	    }
	    return doc.defaultView.pageXOffset || (doc.documentElement || doc.body).scrollLeft;
	  }
	  function pageScrollY(doc) {
	    if (chrome && android) {
	      return -(doc.body.getBoundingClientRect().top - parseInt(getComputedStyle(doc.body).marginTop));
	    }
	    return doc.defaultView.pageYOffset || (doc.documentElement || doc.body).scrollTop;
	  }
	
	  function widgetTopHeight(lineObj) {
	    var ref = visualLine(lineObj);
	    var widgets = ref.widgets;
	    var height = 0;
	    if (widgets) {
	      for (var i = 0; i < widgets.length; ++i) {
	        if (widgets[i].above) {
	          height += widgetHeight(widgets[i]);
	        }
	      }
	    }
	    return height;
	  }
	
	  // Converts a {top, bottom, left, right} box from line-local
	  // coordinates into another coordinate system. Context may be one of
	  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
	  // or "page".
	  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
	    if (!includeWidgets) {
	      var height = widgetTopHeight(lineObj);
	      rect.top += height;rect.bottom += height;
	    }
	    if (context == "line") {
	      return rect;
	    }
	    if (!context) {
	      context = "local";
	    }
	    var yOff = _heightAtLine(lineObj);
	    if (context == "local") {
	      yOff += paddingTop(cm.display);
	    } else {
	      yOff -= cm.display.viewOffset;
	    }
	    if (context == "page" || context == "window") {
	      var lOff = cm.display.lineSpace.getBoundingClientRect();
	      yOff += lOff.top + (context == "window" ? 0 : pageScrollY(doc(cm)));
	      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX(doc(cm)));
	      rect.left += xOff;rect.right += xOff;
	    }
	    rect.top += yOff;rect.bottom += yOff;
	    return rect;
	  }
	
	  // Coverts a box from "div" coords to another coordinate system.
	  // Context may be "window", "page", "div", or "local"./null.
	  function fromCoordSystem(cm, coords, context) {
	    if (context == "div") {
	      return coords;
	    }
	    var left = coords.left,
	        top = coords.top;
	    // First move into "page" coordinate system
	    if (context == "page") {
	      left -= pageScrollX(doc(cm));
	      top -= pageScrollY(doc(cm));
	    } else if (context == "local" || !context) {
	      var localBox = cm.display.sizer.getBoundingClientRect();
	      left += localBox.left;
	      top += localBox.top;
	    }
	
	    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
	    return { left: left - lineSpaceBox.left, top: top - lineSpaceBox.top };
	  }
	
	  function _charCoords(cm, pos, context, lineObj, bias) {
	    if (!lineObj) {
	      lineObj = getLine(cm.doc, pos.line);
	    }
	    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
	  }
	
	  // Returns a box for a given cursor position, which may have an
	  // 'other' property containing the position of the secondary cursor
	  // on a bidi boundary.
	  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
	  // and after `char - 1` in writing order of `char - 1`
	  // A cursor Pos(line, char, "after") is on the same visual line as `char`
	  // and before `char` in writing order of `char`
	  // Examples (upper-case letters are RTL, lower-case are LTR):
	  //     Pos(0, 1, ...)
	  //     before   after
	  // ab     a|b     a|b
	  // aB     a|B     aB|
	  // Ab     |Ab     A|b
	  // AB     B|A     B|A
	  // Every position after the last character on a line is considered to stick
	  // to the last character on the line.
	  function _cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	    lineObj = lineObj || getLine(cm.doc, pos.line);
	    if (!preparedMeasure) {
	      preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    }
	    function get(ch, right) {
	      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
	      if (right) {
	        m.left = m.right;
	      } else {
	        m.right = m.left;
	      }
	      return intoCoordSystem(cm, lineObj, m, context);
	    }
	    var order = getOrder(lineObj, cm.doc.direction),
	        ch = pos.ch,
	        sticky = pos.sticky;
	    if (ch >= lineObj.text.length) {
	      ch = lineObj.text.length;
	      sticky = "before";
	    } else if (ch <= 0) {
	      ch = 0;
	      sticky = "after";
	    }
	    if (!order) {
	      return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
	    }
	
	    function getBidi(ch, partPos, invert) {
	      var part = order[partPos],
	          right = part.level == 1;
	      return get(invert ? ch - 1 : ch, right != invert);
	    }
	    var partPos = getBidiPartAt(order, ch, sticky);
	    var other = bidiOther;
	    var val = getBidi(ch, partPos, sticky == "before");
	    if (other != null) {
	      val.other = getBidi(ch, other, sticky != "before");
	    }
	    return val;
	  }
	
	  // Used to cheaply estimate the coordinates for a position. Used for
	  // intermediate scroll updates.
	  function estimateCoords(cm, pos) {
	    var left = 0;
	    pos = _clipPos(cm.doc, pos);
	    if (!cm.options.lineWrapping) {
	      left = charWidth(cm.display) * pos.ch;
	    }
	    var lineObj = getLine(cm.doc, pos.line);
	    var top = _heightAtLine(lineObj) + paddingTop(cm.display);
	    return { left: left, right: left, top: top, bottom: top + lineObj.height };
	  }
	
	  // Positions returned by coordsChar contain some extra information.
	  // xRel is the relative x position of the input coordinates compared
	  // to the found position (so xRel > 0 means the coordinates are to
	  // the right of the character position, for example). When outside
	  // is true, that means the coordinates lie outside the line's
	  // vertical range.
	  function PosWithInfo(line, ch, sticky, outside, xRel) {
	    var pos = Pos(line, ch, sticky);
	    pos.xRel = xRel;
	    if (outside) {
	      pos.outside = outside;
	    }
	    return pos;
	  }
	
	  // Compute the character position closest to the given coordinates.
	  // Input must be lineSpace-local ("div" coordinate system).
	  function _coordsChar(cm, x, y) {
	    var doc = cm.doc;
	    y += cm.display.viewOffset;
	    if (y < 0) {
	      return PosWithInfo(doc.first, 0, null, -1, -1);
	    }
	    var lineN = _lineAtHeight(doc, y),
	        last = doc.first + doc.size - 1;
	    if (lineN > last) {
	      return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1);
	    }
	    if (x < 0) {
	      x = 0;
	    }
	
	    var lineObj = getLine(doc, lineN);
	    for (;;) {
	      var found = coordsCharInner(cm, lineObj, lineN, x, y);
	      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
	      if (!collapsed) {
	        return found;
	      }
	      var rangeEnd = collapsed.find(1);
	      if (rangeEnd.line == lineN) {
	        return rangeEnd;
	      }
	      lineObj = getLine(doc, lineN = rangeEnd.line);
	    }
	  }
	
	  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
	    y -= widgetTopHeight(lineObj);
	    var end = lineObj.text.length;
	    var begin = findFirst(function (ch) {
	      return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
	    }, end, 0);
	    end = findFirst(function (ch) {
	      return measureCharPrepared(cm, preparedMeasure, ch).top > y;
	    }, begin, end);
	    return { begin: begin, end: end };
	  }
	
	  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
	    if (!preparedMeasure) {
	      preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    }
	    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
	    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
	  }
	
	  // Returns true if the given side of a box is after the given
	  // coordinates, in top-to-bottom, left-to-right order.
	  function boxIsAfter(box, x, y, left) {
	    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
	  }
	
	  function coordsCharInner(cm, lineObj, lineNo, x, y) {
	    // Move y into line-local coordinate space
	    y -= _heightAtLine(lineObj);
	    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    // When directly calling `measureCharPrepared`, we have to adjust
	    // for the widgets at this line.
	    var widgetHeight = widgetTopHeight(lineObj);
	    var begin = 0,
	        end = lineObj.text.length,
	        ltr = true;
	
	    var order = getOrder(lineObj, cm.doc.direction);
	    // If the line isn't plain left-to-right text, first figure out
	    // which bidi section the coordinates fall into.
	    if (order) {
	      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo, preparedMeasure, order, x, y);
	      ltr = part.level != 1;
	      // The awkward -1 offsets are needed because findFirst (called
	      // on these below) will treat its first bound as inclusive,
	      // second as exclusive, but we want to actually address the
	      // characters in the part's range
	      begin = ltr ? part.from : part.to - 1;
	      end = ltr ? part.to : part.from - 1;
	    }
	
	    // A binary search to find the first character whose bounding box
	    // starts after the coordinates. If we run across any whose box wrap
	    // the coordinates, store that.
	    var chAround = null,
	        boxAround = null;
	    var ch = findFirst(function (ch) {
	      var box = measureCharPrepared(cm, preparedMeasure, ch);
	      box.top += widgetHeight;box.bottom += widgetHeight;
	      if (!boxIsAfter(box, x, y, false)) {
	        return false;
	      }
	      if (box.top <= y && box.left <= x) {
	        chAround = ch;
	        boxAround = box;
	      }
	      return true;
	    }, begin, end);
	
	    var baseX,
	        sticky,
	        outside = false;
	    // If a box around the coordinates was found, use that
	    if (boxAround) {
	      // Distinguish coordinates nearer to the left or right side of the box
	      var atLeft = x - boxAround.left < boxAround.right - x,
	          atStart = atLeft == ltr;
	      ch = chAround + (atStart ? 0 : 1);
	      sticky = atStart ? "after" : "before";
	      baseX = atLeft ? boxAround.left : boxAround.right;
	    } else {
	      // (Adjust for extended bound, if necessary.)
	      if (!ltr && (ch == end || ch == begin)) {
	        ch++;
	      }
	      // To determine which side to associate with, get the box to the
	      // left of the character and compare it's vertical position to the
	      // coordinates
	      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y == ltr ? "after" : "before";
	      // Now get accurate coordinates for this place, in order to get a
	      // base X position
	      var coords = _cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
	      baseX = coords.left;
	      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
	    }
	
	    ch = skipExtendingChars(lineObj.text, ch, 1);
	    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX);
	  }
	
	  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
	    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
	    // situation, we can take this ordering to correspond to the visual
	    // ordering. This finds the first part whose end is after the given
	    // coordinates.
	    var index = findFirst(function (i) {
	      var part = order[i],
	          ltr = part.level != 1;
	      return boxIsAfter(_cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
	    }, 0, order.length - 1);
	    var part = order[index];
	    // If this isn't the first part, the part's start is also after
	    // the coordinates, and the coordinates aren't on the same line as
	    // that start, move one part back.
	    if (index > 0) {
	      var ltr = part.level != 1;
	      var start = _cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
	      if (boxIsAfter(start, x, y, true) && start.top > y) {
	        part = order[index - 1];
	      }
	    }
	    return part;
	  }
	
	  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
	    // In a wrapped line, rtl text on wrapping boundaries can do things
	    // that don't correspond to the ordering in our `order` array at
	    // all, so a binary search doesn't work, and we want to return a
	    // part that only spans one line so that the binary search in
	    // coordsCharInner is safe. As such, we first find the extent of the
	    // wrapped line, and then do a flat search in which we discard any
	    // spans that aren't on the line.
	    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
	    var begin = ref.begin;
	    var end = ref.end;
	    if (/\s/.test(lineObj.text.charAt(end - 1))) {
	      end--;
	    }
	    var part = null,
	        closestDist = null;
	    for (var i = 0; i < order.length; i++) {
	      var p = order[i];
	      if (p.from >= end || p.to <= begin) {
	        continue;
	      }
	      var ltr = p.level != 1;
	      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
	      // Weigh against spans ending before this, so that they are only
	      // picked if nothing ends after
	      var dist = endX < x ? x - endX + 1e9 : endX - x;
	      if (!part || closestDist > dist) {
	        part = p;
	        closestDist = dist;
	      }
	    }
	    if (!part) {
	      part = order[order.length - 1];
	    }
	    // Clip the part to the wrapped line.
	    if (part.from < begin) {
	      part = { from: begin, to: part.to, level: part.level };
	    }
	    if (part.to > end) {
	      part = { from: part.from, to: end, level: part.level };
	    }
	    return part;
	  }
	
	  var measureText;
	  // Compute the default text height.
	  function textHeight(display) {
	    if (display.cachedTextHeight != null) {
	      return display.cachedTextHeight;
	    }
	    if (measureText == null) {
	      measureText = elt("pre", null, "CodeMirror-line-like");
	      // Measure a bunch of lines, for browsers that compute
	      // fractional heights.
	      for (var i = 0; i < 49; ++i) {
	        measureText.appendChild(document.createTextNode("x"));
	        measureText.appendChild(elt("br"));
	      }
	      measureText.appendChild(document.createTextNode("x"));
	    }
	    removeChildrenAndAdd(display.measure, measureText);
	    var height = measureText.offsetHeight / 50;
	    if (height > 3) {
	      display.cachedTextHeight = height;
	    }
	    removeChildren(display.measure);
	    return height || 1;
	  }
	
	  // Compute the default character width.
	  function charWidth(display) {
	    if (display.cachedCharWidth != null) {
	      return display.cachedCharWidth;
	    }
	    var anchor = elt("span", "xxxxxxxxxx");
	    var pre = elt("pre", [anchor], "CodeMirror-line-like");
	    removeChildrenAndAdd(display.measure, pre);
	    var rect = anchor.getBoundingClientRect(),
	        width = (rect.right - rect.left) / 10;
	    if (width > 2) {
	      display.cachedCharWidth = width;
	    }
	    return width || 10;
	  }
	
	  // Do a bulk-read of the DOM positions and sizes needed to draw the
	  // view, so that we don't interleave reading and writing to the DOM.
	  function getDimensions(cm) {
	    var d = cm.display,
	        left = {},
	        width = {};
	    var gutterLeft = d.gutters.clientLeft;
	    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	      var id = cm.display.gutterSpecs[i].className;
	      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
	      width[id] = n.clientWidth;
	    }
	    return { fixedPos: compensateForHScroll(d),
	      gutterTotalWidth: d.gutters.offsetWidth,
	      gutterLeft: left,
	      gutterWidth: width,
	      wrapperWidth: d.wrapper.clientWidth };
	  }
	
	  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	  // but using getBoundingClientRect to get a sub-pixel-accurate
	  // result.
	  function compensateForHScroll(display) {
	    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
	  }
	
	  // Returns a function that estimates the height of a line, to use as
	  // first approximation until the line becomes visible (and is thus
	  // properly measurable).
	  function estimateHeight(cm) {
	    var th = textHeight(cm.display),
	        wrapping = cm.options.lineWrapping;
	    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
	    return function (line) {
	      if (lineIsHidden(cm.doc, line)) {
	        return 0;
	      }
	
	      var widgetsHeight = 0;
	      if (line.widgets) {
	        for (var i = 0; i < line.widgets.length; i++) {
	          if (line.widgets[i].height) {
	            widgetsHeight += line.widgets[i].height;
	          }
	        }
	      }
	
	      if (wrapping) {
	        return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
	      } else {
	        return widgetsHeight + th;
	      }
	    };
	  }
	
	  function estimateLineHeights(cm) {
	    var doc = cm.doc,
	        est = estimateHeight(cm);
	    doc.iter(function (line) {
	      var estHeight = est(line);
	      if (estHeight != line.height) {
	        updateLineHeight(line, estHeight);
	      }
	    });
	  }
	
	  // Given a mouse event, find the corresponding position. If liberal
	  // is false, it checks whether a gutter or scrollbar was clicked,
	  // and returns null if it was. forRect is used by rectangular
	  // selections, and tries to estimate a character position even for
	  // coordinates beyond the right of the text.
	  function posFromMouse(cm, e, liberal, forRect) {
	    var display = cm.display;
	    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") {
	      return null;
	    }
	
	    var x,
	        y,
	        space = display.lineSpace.getBoundingClientRect();
	    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	    try {
	      x = e.clientX - space.left;y = e.clientY - space.top;
	    } catch (e$1) {
	      return null;
	    }
	    var coords = _coordsChar(cm, x, y),
	        line;
	    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
	      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
	    }
	    return coords;
	  }
	
	  // Find the view element corresponding to a given line. Return null
	  // when the line isn't visible.
	  function findViewIndex(cm, n) {
	    if (n >= cm.display.viewTo) {
	      return null;
	    }
	    n -= cm.display.viewFrom;
	    if (n < 0) {
	      return null;
	    }
	    var view = cm.display.view;
	    for (var i = 0; i < view.length; i++) {
	      n -= view[i].size;
	      if (n < 0) {
	        return i;
	      }
	    }
	  }
	
	  // Updates the display.view data structure for a given change to the
	  // document. From and to are in pre-change coordinates. Lendiff is
	  // the amount of lines added or subtracted by the change. This is
	  // used for changes that span multiple lines, or change the way
	  // lines are divided into visual lines. regLineChange (below)
	  // registers single-line changes.
	  function regChange(cm, from, to, lendiff) {
	    if (from == null) {
	      from = cm.doc.first;
	    }
	    if (to == null) {
	      to = cm.doc.first + cm.doc.size;
	    }
	    if (!lendiff) {
	      lendiff = 0;
	    }
	
	    var display = cm.display;
	    if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) {
	      display.updateLineNumbers = from;
	    }
	
	    cm.curOp.viewChanged = true;
	
	    if (from >= display.viewTo) {
	      // Change after
	      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) {
	        resetView(cm);
	      }
	    } else if (to <= display.viewFrom) {
	      // Change before
	      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	        resetView(cm);
	      } else {
	        display.viewFrom += lendiff;
	        display.viewTo += lendiff;
	      }
	    } else if (from <= display.viewFrom && to >= display.viewTo) {
	      // Full overlap
	      resetView(cm);
	    } else if (from <= display.viewFrom) {
	      // Top overlap
	      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cut) {
	        display.view = display.view.slice(cut.index);
	        display.viewFrom = cut.lineN;
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    } else if (to >= display.viewTo) {
	      // Bottom overlap
	      var cut$1 = viewCuttingPoint(cm, from, from, -1);
	      if (cut$1) {
	        display.view = display.view.slice(0, cut$1.index);
	        display.viewTo = cut$1.lineN;
	      } else {
	        resetView(cm);
	      }
	    } else {
	      // Gap in the middle
	      var cutTop = viewCuttingPoint(cm, from, from, -1);
	      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cutTop && cutBot) {
	        display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    }
	
	    var ext = display.externalMeasured;
	    if (ext) {
	      if (to < ext.lineN) {
	        ext.lineN += lendiff;
	      } else if (from < ext.lineN + ext.size) {
	        display.externalMeasured = null;
	      }
	    }
	  }
	
	  // Register a change to a single line. Type must be one of "text",
	  // "gutter", "class", "widget"
	  function regLineChange(cm, line, type) {
	    cm.curOp.viewChanged = true;
	    var display = cm.display,
	        ext = cm.display.externalMeasured;
	    if (ext && line >= ext.lineN && line < ext.lineN + ext.size) {
	      display.externalMeasured = null;
	    }
	
	    if (line < display.viewFrom || line >= display.viewTo) {
	      return;
	    }
	    var lineView = display.view[findViewIndex(cm, line)];
	    if (lineView.node == null) {
	      return;
	    }
	    var arr = lineView.changes || (lineView.changes = []);
	    if (indexOf(arr, type) == -1) {
	      arr.push(type);
	    }
	  }
	
	  // Clear the view.
	  function resetView(cm) {
	    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
	    cm.display.view = [];
	    cm.display.viewOffset = 0;
	  }
	
	  function viewCuttingPoint(cm, oldN, newN, dir) {
	    var index = findViewIndex(cm, oldN),
	        diff,
	        view = cm.display.view;
	    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) {
	      return { index: index, lineN: newN };
	    }
	    var n = cm.display.viewFrom;
	    for (var i = 0; i < index; i++) {
	      n += view[i].size;
	    }
	    if (n != oldN) {
	      if (dir > 0) {
	        if (index == view.length - 1) {
	          return null;
	        }
	        diff = n + view[index].size - oldN;
	        index++;
	      } else {
	        diff = n - oldN;
	      }
	      oldN += diff;newN += diff;
	    }
	    while (visualLineNo(cm.doc, newN) != newN) {
	      if (index == (dir < 0 ? 0 : view.length - 1)) {
	        return null;
	      }
	      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
	      index += dir;
	    }
	    return { index: index, lineN: newN };
	  }
	
	  // Force the view to cover a given range, adding empty view element
	  // or clipping off existing ones as needed.
	  function adjustView(cm, from, to) {
	    var display = cm.display,
	        view = display.view;
	    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	      display.view = buildViewArray(cm, from, to);
	      display.viewFrom = from;
	    } else {
	      if (display.viewFrom > from) {
	        display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
	      } else if (display.viewFrom < from) {
	        display.view = display.view.slice(findViewIndex(cm, from));
	      }
	      display.viewFrom = from;
	      if (display.viewTo < to) {
	        display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
	      } else if (display.viewTo > to) {
	        display.view = display.view.slice(0, findViewIndex(cm, to));
	      }
	    }
	    display.viewTo = to;
	  }
	
	  // Count the number of lines in the view whose DOM representation is
	  // out of date (or nonexistent).
	  function countDirtyView(cm) {
	    var view = cm.display.view,
	        dirty = 0;
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (!lineView.hidden && (!lineView.node || lineView.changes)) {
	        ++dirty;
	      }
	    }
	    return dirty;
	  }
	
	  function updateSelection(cm) {
	    cm.display.input.showSelection(cm.display.input.prepareSelection());
	  }
	
	  function prepareSelection(cm, primary) {
	    if (primary === void 0) primary = true;
	
	    var doc = cm.doc,
	        result = {};
	    var curFragment = result.cursors = document.createDocumentFragment();
	    var selFragment = result.selection = document.createDocumentFragment();
	
	    var customCursor = cm.options.$customCursor;
	    if (customCursor) {
	      primary = true;
	    }
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      if (!primary && i == doc.sel.primIndex) {
	        continue;
	      }
	      var range = doc.sel.ranges[i];
	      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) {
	        continue;
	      }
	      var collapsed = range.empty();
	      if (customCursor) {
	        var head = customCursor(cm, range);
	        if (head) {
	          drawSelectionCursor(cm, head, curFragment);
	        }
	      } else if (collapsed || cm.options.showCursorWhenSelecting) {
	        drawSelectionCursor(cm, range.head, curFragment);
	      }
	      if (!collapsed) {
	        drawSelectionRange(cm, range, selFragment);
	      }
	    }
	    return result;
	  }
	
	  // Draws a cursor for the given range
	  function drawSelectionCursor(cm, head, output) {
	    var pos = _cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
	
	    var cursor = output.appendChild(elt("div", '\xA0', "CodeMirror-cursor"));
	    cursor.style.left = pos.left + "px";
	    cursor.style.top = pos.top + "px";
	    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
	
	    if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
	      var charPos = _charCoords(cm, head, "div", null, null);
	      var width = charPos.right - charPos.left;
	      cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
	    }
	
	    if (pos.other) {
	      // Secondary cursor, shown when on a 'jump' in bi-directional text
	      var otherCursor = output.appendChild(elt("div", '\xA0', "CodeMirror-cursor CodeMirror-secondarycursor"));
	      otherCursor.style.display = "";
	      otherCursor.style.left = pos.other.left + "px";
	      otherCursor.style.top = pos.other.top + "px";
	      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
	    }
	  }
	
	  function cmpCoords(a, b) {
	    return a.top - b.top || a.left - b.left;
	  }
	
	  // Draws the given range as a highlighted selection
	  function drawSelectionRange(cm, range, output) {
	    var display = cm.display,
	        doc = cm.doc;
	    var fragment = document.createDocumentFragment();
	    var padding = paddingH(cm.display),
	        leftSide = padding.left;
	    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
	    var docLTR = doc.direction == "ltr";
	
	    function add(left, top, width, bottom) {
	      if (top < 0) {
	        top = 0;
	      }
	      top = Math.round(top);
	      bottom = Math.round(bottom);
	      fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
	    }
	
	    function drawForLine(line, fromArg, toArg) {
	      var lineObj = getLine(doc, line);
	      var lineLen = lineObj.text.length;
	      var start, end;
	      function coords(ch, bias) {
	        return _charCoords(cm, Pos(line, ch), "div", lineObj, bias);
	      }
	
	      function wrapX(pos, dir, side) {
	        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
	        var prop = dir == "ltr" == (side == "after") ? "left" : "right";
	        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
	        return coords(ch, prop)[prop];
	      }
	
	      var order = getOrder(lineObj, doc.direction);
	      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
	        var ltr = dir == "ltr";
	        var fromPos = coords(from, ltr ? "left" : "right");
	        var toPos = coords(to - 1, ltr ? "right" : "left");
	
	        var openStart = fromArg == null && from == 0,
	            openEnd = toArg == null && to == lineLen;
	        var first = i == 0,
	            last = !order || i == order.length - 1;
	        if (toPos.top - fromPos.top <= 3) {
	          // Single line
	          var openLeft = (docLTR ? openStart : openEnd) && first;
	          var openRight = (docLTR ? openEnd : openStart) && last;
	          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
	          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
	          add(left, fromPos.top, right - left, fromPos.bottom);
	        } else {
	          // Multiple lines
	          var topLeft, topRight, botLeft, botRight;
	          if (ltr) {
	            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
	            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
	            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
	            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
	          } else {
	            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
	            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
	            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
	            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
	          }
	          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
	          if (fromPos.bottom < toPos.top) {
	            add(leftSide, fromPos.bottom, null, toPos.top);
	          }
	          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
	        }
	
	        if (!start || cmpCoords(fromPos, start) < 0) {
	          start = fromPos;
	        }
	        if (cmpCoords(toPos, start) < 0) {
	          start = toPos;
	        }
	        if (!end || cmpCoords(fromPos, end) < 0) {
	          end = fromPos;
	        }
	        if (cmpCoords(toPos, end) < 0) {
	          end = toPos;
	        }
	      });
	      return { start: start, end: end };
	    }
	
	    var sFrom = range.from(),
	        sTo = range.to();
	    if (sFrom.line == sTo.line) {
	      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
	    } else {
	      var fromLine = getLine(doc, sFrom.line),
	          toLine = getLine(doc, sTo.line);
	      var singleVLine = visualLine(fromLine) == visualLine(toLine);
	      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
	      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
	      if (singleVLine) {
	        if (leftEnd.top < rightStart.top - 2) {
	          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
	          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
	        } else {
	          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
	        }
	      }
	      if (leftEnd.bottom < rightStart.top) {
	        add(leftSide, leftEnd.bottom, null, rightStart.top);
	      }
	    }
	
	    output.appendChild(fragment);
	  }
	
	  // Cursor-blinking
	  function restartBlink(cm) {
	    if (!cm.state.focused) {
	      return;
	    }
	    var display = cm.display;
	    clearInterval(display.blinker);
	    var on = true;
	    display.cursorDiv.style.visibility = "";
	    if (cm.options.cursorBlinkRate > 0) {
	      display.blinker = setInterval(function () {
	        if (!cm.hasFocus()) {
	          onBlur(cm);
	        }
	        display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
	      }, cm.options.cursorBlinkRate);
	    } else if (cm.options.cursorBlinkRate < 0) {
	      display.cursorDiv.style.visibility = "hidden";
	    }
	  }
	
	  function ensureFocus(cm) {
	    if (!cm.hasFocus()) {
	      cm.display.input.focus();
	      if (!cm.state.focused) {
	        onFocus(cm);
	      }
	    }
	  }
	
	  function delayBlurEvent(cm) {
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () {
	      if (cm.state.delayingBlurEvent) {
	        cm.state.delayingBlurEvent = false;
	        if (cm.state.focused) {
	          onBlur(cm);
	        }
	      }
	    }, 100);
	  }
	
	  function onFocus(cm, e) {
	    if (cm.state.delayingBlurEvent && !cm.state.draggingText) {
	      cm.state.delayingBlurEvent = false;
	    }
	
	    if (cm.options.readOnly == "nocursor") {
	      return;
	    }
	    if (!cm.state.focused) {
	      signal(cm, "focus", cm, e);
	      cm.state.focused = true;
	      addClass(cm.display.wrapper, "CodeMirror-focused");
	      // This test prevents this from firing when a context
	      // menu is closed (since the input reset would kill the
	      // select-all detection hack)
	      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	        cm.display.input.reset();
	        if (webkit) {
	          setTimeout(function () {
	            return cm.display.input.reset(true);
	          }, 20);
	        } // Issue #1730
	      }
	      cm.display.input.receivedFocus();
	    }
	    restartBlink(cm);
	  }
	  function onBlur(cm, e) {
	    if (cm.state.delayingBlurEvent) {
	      return;
	    }
	
	    if (cm.state.focused) {
	      signal(cm, "blur", cm, e);
	      cm.state.focused = false;
	      rmClass(cm.display.wrapper, "CodeMirror-focused");
	    }
	    clearInterval(cm.display.blinker);
	    setTimeout(function () {
	      if (!cm.state.focused) {
	        cm.display.shift = false;
	      }
	    }, 150);
	  }
	
	  // Read the actual heights of the rendered lines, and update their
	  // stored heights to match.
	  function updateHeightsInViewport(cm) {
	    var display = cm.display;
	    var prevBottom = display.lineDiv.offsetTop;
	    var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
	    var oldHeight = display.lineDiv.getBoundingClientRect().top;
	    var mustScroll = 0;
	    for (var i = 0; i < display.view.length; i++) {
	      var cur = display.view[i],
	          wrapping = cm.options.lineWrapping;
	      var height = void 0,
	          width = 0;
	      if (cur.hidden) {
	        continue;
	      }
	      oldHeight += cur.line.height;
	      if (ie && ie_version < 8) {
	        var bot = cur.node.offsetTop + cur.node.offsetHeight;
	        height = bot - prevBottom;
	        prevBottom = bot;
	      } else {
	        var box = cur.node.getBoundingClientRect();
	        height = box.bottom - box.top;
	        // Check that lines don't extend past the right of the current
	        // editor width
	        if (!wrapping && cur.text.firstChild) {
	          width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
	        }
	      }
	      var diff = cur.line.height - height;
	      if (diff > .005 || diff < -.005) {
	        if (oldHeight < viewTop) {
	          mustScroll -= diff;
	        }
	        updateLineHeight(cur.line, height);
	        updateWidgetHeight(cur.line);
	        if (cur.rest) {
	          for (var j = 0; j < cur.rest.length; j++) {
	            updateWidgetHeight(cur.rest[j]);
	          }
	        }
	      }
	      if (width > cm.display.sizerWidth) {
	        var chWidth = Math.ceil(width / charWidth(cm.display));
	        if (chWidth > cm.display.maxLineLength) {
	          cm.display.maxLineLength = chWidth;
	          cm.display.maxLine = cur.line;
	          cm.display.maxLineChanged = true;
	        }
	      }
	    }
	    if (Math.abs(mustScroll) > 2) {
	      display.scroller.scrollTop += mustScroll;
	    }
	  }
	
	  // Read and store the height of line widgets associated with the
	  // given line.
	  function updateWidgetHeight(line) {
	    if (line.widgets) {
	      for (var i = 0; i < line.widgets.length; ++i) {
	        var w = line.widgets[i],
	            parent = w.node.parentNode;
	        if (parent) {
	          w.height = parent.offsetHeight;
	        }
	      }
	    }
	  }
	
	  // Compute the lines that are visible in a given viewport (defaults
	  // the current scroll position). viewport may contain top,
	  // height, and ensure (see op.scrollToPos) properties.
	  function visibleLines(display, doc, viewport) {
	    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
	    top = Math.floor(top - paddingTop(display));
	    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
	
	    var from = _lineAtHeight(doc, top),
	        to = _lineAtHeight(doc, bottom);
	    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	    // forces those lines into the viewport (if possible).
	    if (viewport && viewport.ensure) {
	      var ensureFrom = viewport.ensure.from.line,
	          ensureTo = viewport.ensure.to.line;
	      if (ensureFrom < from) {
	        from = ensureFrom;
	        to = _lineAtHeight(doc, _heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
	      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	        from = _lineAtHeight(doc, _heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
	        to = ensureTo;
	      }
	    }
	    return { from: from, to: Math.max(to, from + 1) };
	  }
	
	  // SCROLLING THINGS INTO VIEW
	
	  // If an editor sits on the top or bottom of the window, partially
	  // scrolled out of view, this ensures that the cursor is visible.
	  function maybeScrollWindow(cm, rect) {
	    if (signalDOMEvent(cm, "scrollCursorIntoView")) {
	      return;
	    }
	
	    var display = cm.display,
	        box = display.sizer.getBoundingClientRect(),
	        doScroll = null;
	    var doc = display.wrapper.ownerDocument;
	    if (rect.top + box.top < 0) {
	      doScroll = true;
	    } else if (rect.bottom + box.top > (doc.defaultView.innerHeight || doc.documentElement.clientHeight)) {
	      doScroll = false;
	    }
	    if (doScroll != null && !phantom) {
	      var scrollNode = elt("div", '\u200B', null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
	      cm.display.lineSpace.appendChild(scrollNode);
	      scrollNode.scrollIntoView(doScroll);
	      cm.display.lineSpace.removeChild(scrollNode);
	    }
	  }
	
	  // Scroll a given position into view (immediately), verifying that
	  // it actually became visible (as line heights are accurately
	  // measured, the position of something may 'drift' during drawing).
	  function scrollPosIntoView(cm, pos, end, margin) {
	    if (margin == null) {
	      margin = 0;
	    }
	    var rect;
	    if (!cm.options.lineWrapping && pos == end) {
	      // Set pos and end to the cursor positions around the character pos sticks to
	      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
	      // If pos == Pos(_, 0, "before"), pos and end are unchanged
	      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
	      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
	    }
	    for (var limit = 0; limit < 5; limit++) {
	      var changed = false;
	      var coords = _cursorCoords(cm, pos);
	      var endCoords = !end || end == pos ? coords : _cursorCoords(cm, end);
	      rect = { left: Math.min(coords.left, endCoords.left),
	        top: Math.min(coords.top, endCoords.top) - margin,
	        right: Math.max(coords.left, endCoords.left),
	        bottom: Math.max(coords.bottom, endCoords.bottom) + margin };
	      var scrollPos = calculateScrollPos(cm, rect);
	      var startTop = cm.doc.scrollTop,
	          startLeft = cm.doc.scrollLeft;
	      if (scrollPos.scrollTop != null) {
	        updateScrollTop(cm, scrollPos.scrollTop);
	        if (Math.abs(cm.doc.scrollTop - startTop) > 1) {
	          changed = true;
	        }
	      }
	      if (scrollPos.scrollLeft != null) {
	        setScrollLeft(cm, scrollPos.scrollLeft);
	        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) {
	          changed = true;
	        }
	      }
	      if (!changed) {
	        break;
	      }
	    }
	    return rect;
	  }
	
	  // Scroll a given set of coordinates into view (immediately).
	  function scrollIntoView(cm, rect) {
	    var scrollPos = calculateScrollPos(cm, rect);
	    if (scrollPos.scrollTop != null) {
	      updateScrollTop(cm, scrollPos.scrollTop);
	    }
	    if (scrollPos.scrollLeft != null) {
	      setScrollLeft(cm, scrollPos.scrollLeft);
	    }
	  }
	
	  // Calculate a new scroll position needed to scroll the given
	  // rectangle into view. Returns an object with scrollTop and
	  // scrollLeft properties. When these are undefined, the
	  // vertical/horizontal position does not need to be adjusted.
	  function calculateScrollPos(cm, rect) {
	    var display = cm.display,
	        snapMargin = textHeight(cm.display);
	    if (rect.top < 0) {
	      rect.top = 0;
	    }
	    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
	    var screen = displayHeight(cm),
	        result = {};
	    if (rect.bottom - rect.top > screen) {
	      rect.bottom = rect.top + screen;
	    }
	    var docBottom = cm.doc.height + paddingVert(display);
	    var atTop = rect.top < snapMargin,
	        atBottom = rect.bottom > docBottom - snapMargin;
	    if (rect.top < screentop) {
	      result.scrollTop = atTop ? 0 : rect.top;
	    } else if (rect.bottom > screentop + screen) {
	      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
	      if (newTop != screentop) {
	        result.scrollTop = newTop;
	      }
	    }
	
	    var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
	    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
	    var screenw = displayWidth(cm) - display.gutters.offsetWidth;
	    var tooWide = rect.right - rect.left > screenw;
	    if (tooWide) {
	      rect.right = rect.left + screenw;
	    }
	    if (rect.left < 10) {
	      result.scrollLeft = 0;
	    } else if (rect.left < screenleft) {
	      result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10));
	    } else if (rect.right > screenw + screenleft - 3) {
	      result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
	    }
	    return result;
	  }
	
	  // Store a relative adjustment to the scroll position in the current
	  // operation (to be applied when the operation finishes).
	  function addToScrollTop(cm, top) {
	    if (top == null) {
	      return;
	    }
	    resolveScrollToPos(cm);
	    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
	  }
	
	  // Make sure that at the end of the operation the current cursor is
	  // shown.
	  function ensureCursorVisible(cm) {
	    resolveScrollToPos(cm);
	    var cur = cm.getCursor();
	    cm.curOp.scrollToPos = { from: cur, to: cur, margin: cm.options.cursorScrollMargin };
	  }
	
	  function scrollToCoords(cm, x, y) {
	    if (x != null || y != null) {
	      resolveScrollToPos(cm);
	    }
	    if (x != null) {
	      cm.curOp.scrollLeft = x;
	    }
	    if (y != null) {
	      cm.curOp.scrollTop = y;
	    }
	  }
	
	  function scrollToRange(cm, range) {
	    resolveScrollToPos(cm);
	    cm.curOp.scrollToPos = range;
	  }
	
	  // When an operation has its scrollToPos property set, and another
	  // scroll action is applied before the end of the operation, this
	  // 'simulates' scrolling that position into view in a cheap way, so
	  // that the effect of intermediate scroll commands is not ignored.
	  function resolveScrollToPos(cm) {
	    var range = cm.curOp.scrollToPos;
	    if (range) {
	      cm.curOp.scrollToPos = null;
	      var from = estimateCoords(cm, range.from),
	          to = estimateCoords(cm, range.to);
	      scrollToCoordsRange(cm, from, to, range.margin);
	    }
	  }
	
	  function scrollToCoordsRange(cm, from, to, margin) {
	    var sPos = calculateScrollPos(cm, {
	      left: Math.min(from.left, to.left),
	      top: Math.min(from.top, to.top) - margin,
	      right: Math.max(from.right, to.right),
	      bottom: Math.max(from.bottom, to.bottom) + margin
	    });
	    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
	  }
	
	  // Sync the scrollable area and scrollbars, ensure the viewport
	  // covers the visible area.
	  function updateScrollTop(cm, val) {
	    if (Math.abs(cm.doc.scrollTop - val) < 2) {
	      return;
	    }
	    if (!gecko) {
	      updateDisplaySimple(cm, { top: val });
	    }
	    setScrollTop(cm, val, true);
	    if (gecko) {
	      updateDisplaySimple(cm);
	    }
	    startWorker(cm, 100);
	  }
	
	  function setScrollTop(cm, val, forceScroll) {
	    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
	    if (cm.display.scroller.scrollTop == val && !forceScroll) {
	      return;
	    }
	    cm.doc.scrollTop = val;
	    cm.display.scrollbars.setScrollTop(val);
	    if (cm.display.scroller.scrollTop != val) {
	      cm.display.scroller.scrollTop = val;
	    }
	  }
	
	  // Sync scroller and scrollbar, ensure the gutter elements are
	  // aligned.
	  function setScrollLeft(cm, val, isScroller, forceScroll) {
	    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
	    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) {
	      return;
	    }
	    cm.doc.scrollLeft = val;
	    alignHorizontally(cm);
	    if (cm.display.scroller.scrollLeft != val) {
	      cm.display.scroller.scrollLeft = val;
	    }
	    cm.display.scrollbars.setScrollLeft(val);
	  }
	
	  // SCROLLBARS
	
	  // Prepare DOM reads needed to update the scrollbars. Done in one
	  // shot to minimize update/measure roundtrips.
	  function measureForScrollbars(cm) {
	    var d = cm.display,
	        gutterW = d.gutters.offsetWidth;
	    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
	    return {
	      clientHeight: d.scroller.clientHeight,
	      viewHeight: d.wrapper.clientHeight,
	      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	      viewWidth: d.wrapper.clientWidth,
	      barLeft: cm.options.fixedGutter ? gutterW : 0,
	      docHeight: docH,
	      scrollHeight: docH + scrollGap(cm) + d.barHeight,
	      nativeBarWidth: d.nativeBarWidth,
	      gutterWidth: gutterW
	    };
	  }
	
	  var NativeScrollbars = function NativeScrollbars(place, scroll, cm) {
	    this.cm = cm;
	    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
	    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
	    vert.tabIndex = horiz.tabIndex = -1;
	    place(vert);place(horiz);
	
	    on(vert, "scroll", function () {
	      if (vert.clientHeight) {
	        scroll(vert.scrollTop, "vertical");
	      }
	    });
	    on(horiz, "scroll", function () {
	      if (horiz.clientWidth) {
	        scroll(horiz.scrollLeft, "horizontal");
	      }
	    });
	
	    this.checkedZeroWidth = false;
	    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	    if (ie && ie_version < 8) {
	      this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
	    }
	  };
	
	  NativeScrollbars.prototype.update = function (measure) {
	    var needsH = measure.scrollWidth > measure.clientWidth + 1;
	    var needsV = measure.scrollHeight > measure.clientHeight + 1;
	    var sWidth = measure.nativeBarWidth;
	
	    if (needsV) {
	      this.vert.style.display = "block";
	      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
	      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
	      // A bug in IE8 can cause this value to be negative, so guard it.
	      this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
	    } else {
	      this.vert.scrollTop = 0;
	      this.vert.style.display = "";
	      this.vert.firstChild.style.height = "0";
	    }
	
	    if (needsH) {
	      this.horiz.style.display = "block";
	      this.horiz.style.right = needsV ? sWidth + "px" : "0";
	      this.horiz.style.left = measure.barLeft + "px";
	      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
	      this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
	    } else {
	      this.horiz.style.display = "";
	      this.horiz.firstChild.style.width = "0";
	    }
	
	    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	      if (sWidth == 0) {
	        this.zeroWidthHack();
	      }
	      this.checkedZeroWidth = true;
	    }
	
	    return { right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0 };
	  };
	
	  NativeScrollbars.prototype.setScrollLeft = function (pos) {
	    if (this.horiz.scrollLeft != pos) {
	      this.horiz.scrollLeft = pos;
	    }
	    if (this.disableHoriz) {
	      this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
	    }
	  };
	
	  NativeScrollbars.prototype.setScrollTop = function (pos) {
	    if (this.vert.scrollTop != pos) {
	      this.vert.scrollTop = pos;
	    }
	    if (this.disableVert) {
	      this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
	    }
	  };
	
	  NativeScrollbars.prototype.zeroWidthHack = function () {
	    var w = mac && !mac_geMountainLion ? "12px" : "18px";
	    this.horiz.style.height = this.vert.style.width = w;
	    this.horiz.style.visibility = this.vert.style.visibility = "hidden";
	    this.disableHoriz = new Delayed();
	    this.disableVert = new Delayed();
	  };
	
	  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
	    bar.style.visibility = "";
	    function maybeDisable() {
	      // To find out whether the scrollbar is still visible, we
	      // check whether the element under the pixel in the bottom
	      // right corner of the scrollbar box is the scrollbar box
	      // itself (when the bar is still visible) or its filler child
	      // (when the bar is hidden). If it is still visible, we keep
	      // it enabled, if it's hidden, we disable pointer events.
	      var box = bar.getBoundingClientRect();
	      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
	      if (elt != bar) {
	        bar.style.visibility = "hidden";
	      } else {
	        delay.set(1000, maybeDisable);
	      }
	    }
	    delay.set(1000, maybeDisable);
	  };
	
	  NativeScrollbars.prototype.clear = function () {
	    var parent = this.horiz.parentNode;
	    parent.removeChild(this.horiz);
	    parent.removeChild(this.vert);
	  };
	
	  var NullScrollbars = function NullScrollbars() {};
	
	  NullScrollbars.prototype.update = function () {
	    return { bottom: 0, right: 0 };
	  };
	  NullScrollbars.prototype.setScrollLeft = function () {};
	  NullScrollbars.prototype.setScrollTop = function () {};
	  NullScrollbars.prototype.clear = function () {};
	
	  function updateScrollbars(cm, measure) {
	    if (!measure) {
	      measure = measureForScrollbars(cm);
	    }
	    var startWidth = cm.display.barWidth,
	        startHeight = cm.display.barHeight;
	    updateScrollbarsInner(cm, measure);
	    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	      if (startWidth != cm.display.barWidth && cm.options.lineWrapping) {
	        updateHeightsInViewport(cm);
	      }
	      updateScrollbarsInner(cm, measureForScrollbars(cm));
	      startWidth = cm.display.barWidth;startHeight = cm.display.barHeight;
	    }
	  }
	
	  // Re-synchronize the fake scrollbars with the actual size of the
	  // content.
	  function updateScrollbarsInner(cm, measure) {
	    var d = cm.display;
	    var sizes = d.scrollbars.update(measure);
	
	    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
	    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
	    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
	
	    if (sizes.right && sizes.bottom) {
	      d.scrollbarFiller.style.display = "block";
	      d.scrollbarFiller.style.height = sizes.bottom + "px";
	      d.scrollbarFiller.style.width = sizes.right + "px";
	    } else {
	      d.scrollbarFiller.style.display = "";
	    }
	    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	      d.gutterFiller.style.display = "block";
	      d.gutterFiller.style.height = sizes.bottom + "px";
	      d.gutterFiller.style.width = measure.gutterWidth + "px";
	    } else {
	      d.gutterFiller.style.display = "";
	    }
	  }
	
	  var scrollbarModel = { "native": NativeScrollbars, "null": NullScrollbars };
	
	  function initScrollbars(cm) {
	    if (cm.display.scrollbars) {
	      cm.display.scrollbars.clear();
	      if (cm.display.scrollbars.addClass) {
	        rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
	      }
	    }
	
	    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
	      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
	      // Prevent clicks in the scrollbars from killing focus
	      on(node, "mousedown", function () {
	        if (cm.state.focused) {
	          setTimeout(function () {
	            return cm.display.input.focus();
	          }, 0);
	        }
	      });
	      node.setAttribute("cm-not-content", "true");
	    }, function (pos, axis) {
	      if (axis == "horizontal") {
	        setScrollLeft(cm, pos);
	      } else {
	        updateScrollTop(cm, pos);
	      }
	    }, cm);
	    if (cm.display.scrollbars.addClass) {
	      addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
	    }
	  }
	
	  // Operations are used to wrap a series of changes to the editor
	  // state in such a way that each change won't have to update the
	  // cursor and display (which would be awkward, slow, and
	  // error-prone). Instead, display updates are batched and then all
	  // combined and executed at once.
	
	  var nextOpId = 0;
	  // Start a new operation.
	  function _startOperation(cm) {
	    cm.curOp = {
	      cm: cm,
	      viewChanged: false, // Flag that indicates that lines might need to be redrawn
	      startHeight: cm.doc.height, // Used to detect need to update scrollbar
	      forceUpdate: false, // Used to force a redraw
	      updateInput: 0, // Whether to reset the input textarea
	      typing: false, // Whether this reset should be careful to leave existing text (for compositing)
	      changeObjs: null, // Accumulated changes, for firing change events
	      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	      selectionChanged: false, // Whether the selection needs to be redrawn
	      updateMaxLine: false, // Set when the widest line needs to be determined anew
	      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	      scrollToPos: null, // Used to scroll to a specific position
	      focus: false,
	      id: ++nextOpId, // Unique ID
	      markArrays: null // Used by addMarkedSpan
	    };
	    pushOperation(cm.curOp);
	  }
	
	  // Finish an operation, updating the display and signalling delayed events
	  function _endOperation(cm) {
	    var op = cm.curOp;
	    if (op) {
	      finishOperation(op, function (group) {
	        for (var i = 0; i < group.ops.length; i++) {
	          group.ops[i].cm.curOp = null;
	        }
	        endOperations(group);
	      });
	    }
	  }
	
	  // The DOM updates done when an operation finishes are batched so
	  // that the minimum number of relayouts are required.
	  function endOperations(group) {
	    var ops = group.ops;
	    for (var i = 0; i < ops.length; i++) // Read DOM
	    {
	      endOperation_R1(ops[i]);
	    }
	    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
	    {
	      endOperation_W1(ops[i$1]);
	    }
	    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
	    {
	      endOperation_R2(ops[i$2]);
	    }
	    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
	    {
	      endOperation_W2(ops[i$3]);
	    }
	    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
	    {
	      endOperation_finish(ops[i$4]);
	    }
	  }
	
	  function endOperation_R1(op) {
	    var cm = op.cm,
	        display = cm.display;
	    maybeClipScrollbars(cm);
	    if (op.updateMaxLine) {
	      findMaxLine(cm);
	    }
	
	    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
	    op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && { top: op.scrollTop, ensure: op.scrollToPos }, op.forceUpdate);
	  }
	
	  function endOperation_W1(op) {
	    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
	  }
	
	  function endOperation_R2(op) {
	    var cm = op.cm,
	        display = cm.display;
	    if (op.updatedDisplay) {
	      updateHeightsInViewport(cm);
	    }
	
	    op.barMeasure = measureForScrollbars(cm);
	
	    // If the max line changed since it was last measured, measure it,
	    // and ensure the document's width matches it.
	    // updateDisplay_W2 will use these properties to do the actual resizing
	    if (display.maxLineChanged && !cm.options.lineWrapping) {
	      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
	      cm.display.sizerWidth = op.adjustWidthTo;
	      op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
	      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
	    }
	
	    if (op.updatedDisplay || op.selectionChanged) {
	      op.preparedSelection = display.input.prepareSelection();
	    }
	  }
	
	  function endOperation_W2(op) {
	    var cm = op.cm;
	
	    if (op.adjustWidthTo != null) {
	      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
	      if (op.maxScrollLeft < cm.doc.scrollLeft) {
	        setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
	      }
	      cm.display.maxLineChanged = false;
	    }
	
	    var takeFocus = op.focus && op.focus == activeElt(root(cm));
	    if (op.preparedSelection) {
	      cm.display.input.showSelection(op.preparedSelection, takeFocus);
	    }
	    if (op.updatedDisplay || op.startHeight != cm.doc.height) {
	      updateScrollbars(cm, op.barMeasure);
	    }
	    if (op.updatedDisplay) {
	      setDocumentHeight(cm, op.barMeasure);
	    }
	
	    if (op.selectionChanged) {
	      restartBlink(cm);
	    }
	
	    if (cm.state.focused && op.updateInput) {
	      cm.display.input.reset(op.typing);
	    }
	    if (takeFocus) {
	      ensureFocus(op.cm);
	    }
	  }
	
	  function endOperation_finish(op) {
	    var cm = op.cm,
	        display = cm.display,
	        doc = cm.doc;
	
	    if (op.updatedDisplay) {
	      postUpdateDisplay(cm, op.update);
	    }
	
	    // Abort mouse wheel delta measurement, when scrolling explicitly
	    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) {
	      display.wheelStartX = display.wheelStartY = null;
	    }
	
	    // Propagate the scroll position to the actual DOM scroller
	    if (op.scrollTop != null) {
	      setScrollTop(cm, op.scrollTop, op.forceScroll);
	    }
	
	    if (op.scrollLeft != null) {
	      setScrollLeft(cm, op.scrollLeft, true, true);
	    }
	    // If we need to scroll a specific position into view, do so.
	    if (op.scrollToPos) {
	      var rect = scrollPosIntoView(cm, _clipPos(doc, op.scrollToPos.from), _clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
	      maybeScrollWindow(cm, rect);
	    }
	
	    // Fire events for markers that are hidden/unidden by editing or
	    // undoing
	    var hidden = op.maybeHiddenMarkers,
	        unhidden = op.maybeUnhiddenMarkers;
	    if (hidden) {
	      for (var i = 0; i < hidden.length; ++i) {
	        if (!hidden[i].lines.length) {
	          signal(hidden[i], "hide");
	        }
	      }
	    }
	    if (unhidden) {
	      for (var i$1 = 0; i$1 < unhidden.length; ++i$1) {
	        if (unhidden[i$1].lines.length) {
	          signal(unhidden[i$1], "unhide");
	        }
	      }
	    }
	
	    if (display.wrapper.offsetHeight) {
	      doc.scrollTop = cm.display.scroller.scrollTop;
	    }
	
	    // Fire change events, and delayed event handlers
	    if (op.changeObjs) {
	      signal(cm, "changes", cm, op.changeObjs);
	    }
	    if (op.update) {
	      op.update.finish();
	    }
	  }
	
	  // Run the given function in an operation
	  function runInOp(cm, f) {
	    if (cm.curOp) {
	      return f();
	    }
	    _startOperation(cm);
	    try {
	      return f();
	    } finally {
	      _endOperation(cm);
	    }
	  }
	  // Wraps a function in an operation. Returns the wrapped function.
	  function operation(cm, f) {
	    return function () {
	      if (cm.curOp) {
	        return f.apply(cm, arguments);
	      }
	      _startOperation(cm);
	      try {
	        return f.apply(cm, arguments);
	      } finally {
	        _endOperation(cm);
	      }
	    };
	  }
	  // Used to add methods to editor and doc instances, wrapping them in
	  // operations.
	  function methodOp(f) {
	    return function () {
	      if (this.curOp) {
	        return f.apply(this, arguments);
	      }
	      _startOperation(this);
	      try {
	        return f.apply(this, arguments);
	      } finally {
	        _endOperation(this);
	      }
	    };
	  }
	  function docMethodOp(f) {
	    return function () {
	      var cm = this.cm;
	      if (!cm || cm.curOp) {
	        return f.apply(this, arguments);
	      }
	      _startOperation(cm);
	      try {
	        return f.apply(this, arguments);
	      } finally {
	        _endOperation(cm);
	      }
	    };
	  }
	
	  // HIGHLIGHT WORKER
	
	  function startWorker(cm, time) {
	    if (cm.doc.highlightFrontier < cm.display.viewTo) {
	      cm.state.highlight.set(time, bind(highlightWorker, cm));
	    }
	  }
	
	  function highlightWorker(cm) {
	    var doc = cm.doc;
	    if (doc.highlightFrontier >= cm.display.viewTo) {
	      return;
	    }
	    var end = +new Date() + cm.options.workTime;
	    var context = getContextBefore(cm, doc.highlightFrontier);
	    var changedLines = [];
	
	    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
	      if (context.line >= cm.display.viewFrom) {
	        // Visible
	        var oldStyles = line.styles;
	        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
	        var highlighted = highlightLine(cm, line, context, true);
	        if (resetState) {
	          context.state = resetState;
	        }
	        line.styles = highlighted.styles;
	        var oldCls = line.styleClasses,
	            newCls = highlighted.classes;
	        if (newCls) {
	          line.styleClasses = newCls;
	        } else if (oldCls) {
	          line.styleClasses = null;
	        }
	        var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
	        for (var i = 0; !ischange && i < oldStyles.length; ++i) {
	          ischange = oldStyles[i] != line.styles[i];
	        }
	        if (ischange) {
	          changedLines.push(context.line);
	        }
	        line.stateAfter = context.save();
	        context.nextLine();
	      } else {
	        if (line.text.length <= cm.options.maxHighlightLength) {
	          processLine(cm, line.text, context);
	        }
	        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
	        context.nextLine();
	      }
	      if (+new Date() > end) {
	        startWorker(cm, cm.options.workDelay);
	        return true;
	      }
	    });
	    doc.highlightFrontier = context.line;
	    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
	    if (changedLines.length) {
	      runInOp(cm, function () {
	        for (var i = 0; i < changedLines.length; i++) {
	          regLineChange(cm, changedLines[i], "text");
	        }
	      });
	    }
	  }
	
	  // DISPLAY DRAWING
	
	  var DisplayUpdate = function DisplayUpdate(cm, viewport, force) {
	    var display = cm.display;
	
	    this.viewport = viewport;
	    // Store some values that we'll need later (but don't want to force a relayout for)
	    this.visible = visibleLines(display, cm.doc, viewport);
	    this.editorIsHidden = !display.wrapper.offsetWidth;
	    this.wrapperHeight = display.wrapper.clientHeight;
	    this.wrapperWidth = display.wrapper.clientWidth;
	    this.oldDisplayWidth = displayWidth(cm);
	    this.force = force;
	    this.dims = getDimensions(cm);
	    this.events = [];
	  };
	
	  DisplayUpdate.prototype.signal = function (emitter, type) {
	    if (hasHandler(emitter, type)) {
	      this.events.push(arguments);
	    }
	  };
	  DisplayUpdate.prototype.finish = function () {
	    for (var i = 0; i < this.events.length; i++) {
	      signal.apply(null, this.events[i]);
	    }
	  };
	
	  function maybeClipScrollbars(cm) {
	    var display = cm.display;
	    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
	      display.heightForcer.style.height = scrollGap(cm) + "px";
	      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
	      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
	      display.scrollbarsClipped = true;
	    }
	  }
	
	  function selectionSnapshot(cm) {
	    if (cm.hasFocus()) {
	      return null;
	    }
	    var active = activeElt(root(cm));
	    if (!active || !contains(cm.display.lineDiv, active)) {
	      return null;
	    }
	    var result = { activeElt: active };
	    if (window.getSelection) {
	      var sel = win(cm).getSelection();
	      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
	        result.anchorNode = sel.anchorNode;
	        result.anchorOffset = sel.anchorOffset;
	        result.focusNode = sel.focusNode;
	        result.focusOffset = sel.focusOffset;
	      }
	    }
	    return result;
	  }
	
	  function restoreSelection(snapshot) {
	    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt(rootNode(snapshot.activeElt))) {
	      return;
	    }
	    snapshot.activeElt.focus();
	    if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) && snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
	      var doc = snapshot.activeElt.ownerDocument;
	      var sel = doc.defaultView.getSelection(),
	          range = doc.createRange();
	      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
	      range.collapse(false);
	      sel.removeAllRanges();
	      sel.addRange(range);
	      sel.extend(snapshot.focusNode, snapshot.focusOffset);
	    }
	  }
	
	  // Does the actual updating of the line display. Bails out
	  // (returning false) when there is nothing to be done and forced is
	  // false.
	  function updateDisplayIfNeeded(cm, update) {
	    var display = cm.display,
	        doc = cm.doc;
	
	    if (update.editorIsHidden) {
	      resetView(cm);
	      return false;
	    }
	
	    // Bail out if the visible area is already rendered and nothing changed.
	    if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) {
	      return false;
	    }
	
	    if (maybeUpdateLineNumberWidth(cm)) {
	      resetView(cm);
	      update.dims = getDimensions(cm);
	    }
	
	    // Compute a suitable new viewport (from & to)
	    var end = doc.first + doc.size;
	    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
	    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
	    if (display.viewFrom < from && from - display.viewFrom < 20) {
	      from = Math.max(doc.first, display.viewFrom);
	    }
	    if (display.viewTo > to && display.viewTo - to < 20) {
	      to = Math.min(end, display.viewTo);
	    }
	    if (sawCollapsedSpans) {
	      from = visualLineNo(cm.doc, from);
	      to = visualLineEndNo(cm.doc, to);
	    }
	
	    var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
	    adjustView(cm, from, to);
	
	    display.viewOffset = _heightAtLine(getLine(cm.doc, display.viewFrom));
	    // Position the mover div to align with the current scroll position
	    cm.display.mover.style.top = display.viewOffset + "px";
	
	    var toUpdate = countDirtyView(cm);
	    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) {
	      return false;
	    }
	
	    // For big changes, we hide the enclosing element during the
	    // update, since that speeds up the operations on most browsers.
	    var selSnapshot = selectionSnapshot(cm);
	    if (toUpdate > 4) {
	      display.lineDiv.style.display = "none";
	    }
	    patchDisplay(cm, display.updateLineNumbers, update.dims);
	    if (toUpdate > 4) {
	      display.lineDiv.style.display = "";
	    }
	    display.renderedView = display.view;
	    // There might have been a widget with a focused element that got
	    // hidden or updated, if so re-focus it.
	    restoreSelection(selSnapshot);
	
	    // Prevent selection and cursors from interfering with the scroll
	    // width and height.
	    removeChildren(display.cursorDiv);
	    removeChildren(display.selectionDiv);
	    display.gutters.style.height = display.sizer.style.minHeight = 0;
	
	    if (different) {
	      display.lastWrapHeight = update.wrapperHeight;
	      display.lastWrapWidth = update.wrapperWidth;
	      startWorker(cm, 400);
	    }
	
	    display.updateLineNumbers = null;
	
	    return true;
	  }
	
	  function postUpdateDisplay(cm, update) {
	    var viewport = update.viewport;
	
	    for (var first = true;; first = false) {
	      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	        // Clip forced viewport to actual scrollable area.
	        if (viewport && viewport.top != null) {
	          viewport = { top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top) };
	        }
	        // Updated line heights might result in the drawn area not
	        // actually covering the viewport. Keep looping until it does.
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) {
	          break;
	        }
	      } else if (first) {
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	      }
	      if (!updateDisplayIfNeeded(cm, update)) {
	        break;
	      }
	      updateHeightsInViewport(cm);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.force = false;
	    }
	
	    update.signal(cm, "update", cm);
	    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
	      cm.display.reportedViewFrom = cm.display.viewFrom;cm.display.reportedViewTo = cm.display.viewTo;
	    }
	  }
	
	  function updateDisplaySimple(cm, viewport) {
	    var update = new DisplayUpdate(cm, viewport);
	    if (updateDisplayIfNeeded(cm, update)) {
	      updateHeightsInViewport(cm);
	      postUpdateDisplay(cm, update);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.finish();
	    }
	  }
	
	  // Sync the actual display DOM structure with display.view, removing
	  // nodes for lines that are no longer in view, and creating the ones
	  // that are not there yet, and updating the ones that are out of
	  // date.
	  function patchDisplay(cm, updateNumbersFrom, dims) {
	    var display = cm.display,
	        lineNumbers = cm.options.lineNumbers;
	    var container = display.lineDiv,
	        cur = container.firstChild;
	
	    function rm(node) {
	      var next = node.nextSibling;
	      // Works around a throw-scroll bug in OS X Webkit
	      if (webkit && mac && cm.display.currentWheelTarget == node) {
	        node.style.display = "none";
	      } else {
	        node.parentNode.removeChild(node);
	      }
	      return next;
	    }
	
	    var view = display.view,
	        lineN = display.viewFrom;
	    // Loop over the elements in the view, syncing cur (the DOM nodes
	    // in display.lineDiv) with the view as we go.
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (lineView.hidden) ;else if (!lineView.node || lineView.node.parentNode != container) {
	        // Not drawn yet
	        var node = buildLineElement(cm, lineView, lineN, dims);
	        container.insertBefore(node, cur);
	      } else {
	        // Already drawn
	        while (cur != lineView.node) {
	          cur = rm(cur);
	        }
	        var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
	        if (lineView.changes) {
	          if (indexOf(lineView.changes, "gutter") > -1) {
	            updateNumber = false;
	          }
	          updateLineForChanges(cm, lineView, lineN, dims);
	        }
	        if (updateNumber) {
	          removeChildren(lineView.lineNumber);
	          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
	        }
	        cur = lineView.node.nextSibling;
	      }
	      lineN += lineView.size;
	    }
	    while (cur) {
	      cur = rm(cur);
	    }
	  }
	
	  function updateGutterSpace(display) {
	    var width = display.gutters.offsetWidth;
	    display.sizer.style.marginLeft = width + "px";
	    // Send an event to consumers responding to changes in gutter width.
	    signalLater(display, "gutterChanged", display);
	  }
	
	  function setDocumentHeight(cm, measure) {
	    cm.display.sizer.style.minHeight = measure.docHeight + "px";
	    cm.display.heightForcer.style.top = measure.docHeight + "px";
	    cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
	  }
	
	  // Re-align line numbers and gutter marks to compensate for
	  // horizontal scrolling.
	  function alignHorizontally(cm) {
	    var display = cm.display,
	        view = display.view;
	    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) {
	      return;
	    }
	    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
	    var gutterW = display.gutters.offsetWidth,
	        left = comp + "px";
	    for (var i = 0; i < view.length; i++) {
	      if (!view[i].hidden) {
	        if (cm.options.fixedGutter) {
	          if (view[i].gutter) {
	            view[i].gutter.style.left = left;
	          }
	          if (view[i].gutterBackground) {
	            view[i].gutterBackground.style.left = left;
	          }
	        }
	        var align = view[i].alignable;
	        if (align) {
	          for (var j = 0; j < align.length; j++) {
	            align[j].style.left = left;
	          }
	        }
	      }
	    }
	    if (cm.options.fixedGutter) {
	      display.gutters.style.left = comp + gutterW + "px";
	    }
	  }
	
	  // Used to ensure that the line number gutter is still the right
	  // size for the current document size. Returns true when an update
	  // is needed.
	  function maybeUpdateLineNumberWidth(cm) {
	    if (!cm.options.lineNumbers) {
	      return false;
	    }
	    var doc = cm.doc,
	        last = lineNumberFor(cm.options, doc.first + doc.size - 1),
	        display = cm.display;
	    if (last.length != display.lineNumChars) {
	      var test = display.measure.appendChild(elt("div", [elt("div", last)], "CodeMirror-linenumber CodeMirror-gutter-elt"));
	      var innerW = test.firstChild.offsetWidth,
	          padding = test.offsetWidth - innerW;
	      display.lineGutter.style.width = "";
	      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
	      display.lineNumWidth = display.lineNumInnerWidth + padding;
	      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
	      display.lineGutter.style.width = display.lineNumWidth + "px";
	      updateGutterSpace(cm.display);
	      return true;
	    }
	    return false;
	  }
	
	  function getGutters(gutters, lineNumbers) {
	    var result = [],
	        sawLineNumbers = false;
	    for (var i = 0; i < gutters.length; i++) {
	      var name = gutters[i],
	          style = null;
	      if (typeof name != "string") {
	        style = name.style;name = name.className;
	      }
	      if (name == "CodeMirror-linenumbers") {
	        if (!lineNumbers) {
	          continue;
	        } else {
	          sawLineNumbers = true;
	        }
	      }
	      result.push({ className: name, style: style });
	    }
	    if (lineNumbers && !sawLineNumbers) {
	      result.push({ className: "CodeMirror-linenumbers", style: null });
	    }
	    return result;
	  }
	
	  // Rebuild the gutter elements, ensure the margin to the left of the
	  // code matches their width.
	  function renderGutters(display) {
	    var gutters = display.gutters,
	        specs = display.gutterSpecs;
	    removeChildren(gutters);
	    display.lineGutter = null;
	    for (var i = 0; i < specs.length; ++i) {
	      var ref = specs[i];
	      var className = ref.className;
	      var style = ref.style;
	      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
	      if (style) {
	        gElt.style.cssText = style;
	      }
	      if (className == "CodeMirror-linenumbers") {
	        display.lineGutter = gElt;
	        gElt.style.width = (display.lineNumWidth || 1) + "px";
	      }
	    }
	    gutters.style.display = specs.length ? "" : "none";
	    updateGutterSpace(display);
	  }
	
	  function updateGutters(cm) {
	    renderGutters(cm.display);
	    regChange(cm);
	    alignHorizontally(cm);
	  }
	
	  // The display handles the DOM integration, both for input reading
	  // and content drawing. It holds references to DOM nodes and
	  // display-related state.
	
	  function Display(place, doc, input, options) {
	    var d = this;
	    this.input = input;
	
	    // Covers bottom-right square when both scrollbars are present.
	    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
	    d.scrollbarFiller.setAttribute("cm-not-content", "true");
	    // Covers bottom of gutter when coverGutterNextToScrollbar is on
	    // and h scrollbar is present.
	    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
	    d.gutterFiller.setAttribute("cm-not-content", "true");
	    // Will contain the actual code, positioned to cover the viewport.
	    d.lineDiv = eltP("div", null, "CodeMirror-code");
	    // Elements are added to these to represent selection and cursors.
	    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
	    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
	    // A visibility: hidden element used to find the size of things.
	    d.measure = elt("div", null, "CodeMirror-measure");
	    // When lines outside of the viewport are measured, they are drawn in this.
	    d.lineMeasure = elt("div", null, "CodeMirror-measure");
	    // Wraps everything that needs to exist inside the vertically-padded coordinate system
	    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv], null, "position: relative; outline: none");
	    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
	    // Moved around its parent to cover visible view.
	    d.mover = elt("div", [lines], null, "position: relative");
	    // Set to the height of the document, allowing scrolling.
	    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
	    d.sizerWidth = null;
	    // Behavior of elts with overflow: auto and padding is
	    // inconsistent across browsers. This is used to ensure the
	    // scrollable area is big enough.
	    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
	    // Will contain the gutters, if any.
	    d.gutters = elt("div", null, "CodeMirror-gutters");
	    d.lineGutter = null;
	    // Actual scrollable element.
	    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
	    d.scroller.setAttribute("tabIndex", "-1");
	    // The element in which the editor lives.
	    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");
	    // See #6982. FIXME remove when this has been fixed for a while in Chrome
	    if (chrome && chrome_version >= 105) {
	      d.wrapper.style.clipPath = "inset(0px)";
	    }
	
	    // This attribute is respected by automatic translation systems such as Google Translate,
	    // and may also be respected by tools used by human translators.
	    d.wrapper.setAttribute('translate', 'no');
	
	    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	    if (ie && ie_version < 8) {
	      d.gutters.style.zIndex = -1;d.scroller.style.paddingRight = 0;
	    }
	    if (!webkit && !(gecko && mobile)) {
	      d.scroller.draggable = true;
	    }
	
	    if (place) {
	      if (place.appendChild) {
	        place.appendChild(d.wrapper);
	      } else {
	        place(d.wrapper);
	      }
	    }
	
	    // Current rendered range (may be bigger than the view window).
	    d.viewFrom = d.viewTo = doc.first;
	    d.reportedViewFrom = d.reportedViewTo = doc.first;
	    // Information about the rendered lines.
	    d.view = [];
	    d.renderedView = null;
	    // Holds info about a single rendered line when it was rendered
	    // for measurement, while not in view.
	    d.externalMeasured = null;
	    // Empty space (in pixels) above the view
	    d.viewOffset = 0;
	    d.lastWrapHeight = d.lastWrapWidth = 0;
	    d.updateLineNumbers = null;
	
	    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
	    d.scrollbarsClipped = false;
	
	    // Used to only resize the line number gutter when necessary (when
	    // the amount of lines crosses a boundary that makes its width change)
	    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
	    // Set to true when a non-horizontal-scrolling line widget is
	    // added. As an optimization, line widget aligning is skipped when
	    // this is false.
	    d.alignWidgets = false;
	
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	
	    // Tracks the maximum line length so that the horizontal scrollbar
	    // can be kept static when scrolling.
	    d.maxLine = null;
	    d.maxLineLength = 0;
	    d.maxLineChanged = false;
	
	    // Used for measuring wheel scrolling granularity
	    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
	
	    // True when shift is held down.
	    d.shift = false;
	
	    // Used to track whether anything happened since the context menu
	    // was opened.
	    d.selForContextMenu = null;
	
	    d.activeTouch = null;
	
	    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
	    renderGutters(d);
	
	    input.init(d);
	  }
	
	  // Since the delta values reported on mouse wheel events are
	  // unstandardized between browsers and even browser versions, and
	  // generally horribly unpredictable, this code starts by measuring
	  // the scroll effect that the first few mouse wheel events have,
	  // and, from that, detects the way it can convert deltas to pixel
	  // offsets afterwards.
	  //
	  // The reason we want to know the amount a wheel event will scroll
	  // is that it gives us a chance to update the display before the
	  // actual scrolling happens, reducing flickering.
	
	  var wheelSamples = 0,
	      wheelPixelsPerUnit = null;
	  // Fill in a browser-detected starting value on browsers where we
	  // know one. These don't have to be accurate -- the result of them
	  // being wrong would just be a slight flicker on the first wheel
	  // scroll (if it is large enough).
	  if (ie) {
	    wheelPixelsPerUnit = -.53;
	  } else if (gecko) {
	    wheelPixelsPerUnit = 15;
	  } else if (chrome) {
	    wheelPixelsPerUnit = -.7;
	  } else if (safari) {
	    wheelPixelsPerUnit = -1 / 3;
	  }
	
	  function wheelEventDelta(e) {
	    var dx = e.wheelDeltaX,
	        dy = e.wheelDeltaY;
	    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) {
	      dx = e.detail;
	    }
	    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) {
	      dy = e.detail;
	    } else if (dy == null) {
	      dy = e.wheelDelta;
	    }
	    return { x: dx, y: dy };
	  }
	  function wheelEventPixels(e) {
	    var delta = wheelEventDelta(e);
	    delta.x *= wheelPixelsPerUnit;
	    delta.y *= wheelPixelsPerUnit;
	    return delta;
	  }
	
	  function onScrollWheel(cm, e) {
	    // On Chrome 102, viewport updates somehow stop wheel-based
	    // scrolling. Turning off pointer events during the scroll seems
	    // to avoid the issue.
	    if (chrome && chrome_version == 102) {
	      if (cm.display.chromeScrollHack == null) {
	        cm.display.sizer.style.pointerEvents = "none";
	      } else {
	        clearTimeout(cm.display.chromeScrollHack);
	      }
	      cm.display.chromeScrollHack = setTimeout(function () {
	        cm.display.chromeScrollHack = null;
	        cm.display.sizer.style.pointerEvents = "";
	      }, 100);
	    }
	    var delta = wheelEventDelta(e),
	        dx = delta.x,
	        dy = delta.y;
	    var pixelsPerUnit = wheelPixelsPerUnit;
	    if (e.deltaMode === 0) {
	      dx = e.deltaX;
	      dy = e.deltaY;
	      pixelsPerUnit = 1;
	    }
	
	    var display = cm.display,
	        scroll = display.scroller;
	    // Quit if there's nothing to scroll here
	    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
	    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
	    if (!(dx && canScrollX || dy && canScrollY)) {
	      return;
	    }
	
	    // Webkit browsers on OS X abort momentum scrolls when the target
	    // of the scroll event is removed from the scrollable element.
	    // This hack (see related code in patchDisplay) makes sure the
	    // element is kept around.
	    if (dy && mac && webkit) {
	      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	        for (var i = 0; i < view.length; i++) {
	          if (view[i].node == cur) {
	            cm.display.currentWheelTarget = cur;
	            break outer;
	          }
	        }
	      }
	    }
	
	    // On some browsers, horizontal scrolling will cause redraws to
	    // happen before the gutter has been realigned, causing it to
	    // wriggle around in a most unseemly way. When we have an
	    // estimated pixels/delta value, we just handle horizontal
	    // scrolling entirely here. It'll be slightly off from native, but
	    // better than glitching out.
	    if (dx && !gecko && !presto && pixelsPerUnit != null) {
	      if (dy && canScrollY) {
	        updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit));
	      }
	      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
	      // Only prevent default scrolling if vertical scrolling is
	      // actually possible. Otherwise, it causes vertical scroll
	      // jitter on OSX trackpads when deltaX is small and deltaY
	      // is large (issue #3579)
	      if (!dy || dy && canScrollY) {
	        e_preventDefault(e);
	      }
	      display.wheelStartX = null; // Abort measurement, if in progress
	      return;
	    }
	
	    // 'Project' the visible viewport to cover the area that is being
	    // scrolled into view (if we know enough to estimate it).
	    if (dy && pixelsPerUnit != null) {
	      var pixels = dy * pixelsPerUnit;
	      var top = cm.doc.scrollTop,
	          bot = top + display.wrapper.clientHeight;
	      if (pixels < 0) {
	        top = Math.max(0, top + pixels - 50);
	      } else {
	        bot = Math.min(cm.doc.height, bot + pixels + 50);
	      }
	      updateDisplaySimple(cm, { top: top, bottom: bot });
	    }
	
	    if (wheelSamples < 20 && e.deltaMode !== 0) {
	      if (display.wheelStartX == null) {
	        display.wheelStartX = scroll.scrollLeft;display.wheelStartY = scroll.scrollTop;
	        display.wheelDX = dx;display.wheelDY = dy;
	        setTimeout(function () {
	          if (display.wheelStartX == null) {
	            return;
	          }
	          var movedX = scroll.scrollLeft - display.wheelStartX;
	          var movedY = scroll.scrollTop - display.wheelStartY;
	          var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
	          display.wheelStartX = display.wheelStartY = null;
	          if (!sample) {
	            return;
	          }
	          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
	          ++wheelSamples;
	        }, 200);
	      } else {
	        display.wheelDX += dx;display.wheelDY += dy;
	      }
	    }
	  }
	
	  // Selection objects are immutable. A new one is created every time
	  // the selection changes. A selection is one or more non-overlapping
	  // (and non-touching) ranges, sorted, and an integer that indicates
	  // which one is the primary selection (the one that's scrolled into
	  // view, that getCursor returns, etc).
	  var Selection = function Selection(ranges, primIndex) {
	    this.ranges = ranges;
	    this.primIndex = primIndex;
	  };
	
	  Selection.prototype.primary = function () {
	    return this.ranges[this.primIndex];
	  };
	
	  Selection.prototype.equals = function (other) {
	    if (other == this) {
	      return true;
	    }
	    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) {
	      return false;
	    }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var here = this.ranges[i],
	          there = other.ranges[i];
	      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  Selection.prototype.deepCopy = function () {
	    var out = [];
	    for (var i = 0; i < this.ranges.length; i++) {
	      out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head));
	    }
	    return new Selection(out, this.primIndex);
	  };
	
	  Selection.prototype.somethingSelected = function () {
	    for (var i = 0; i < this.ranges.length; i++) {
	      if (!this.ranges[i].empty()) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  Selection.prototype.contains = function (pos, end) {
	    if (!end) {
	      end = pos;
	    }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var range = this.ranges[i];
	      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  var Range = function Range(anchor, head) {
	    this.anchor = anchor;this.head = head;
	  };
	
	  Range.prototype.from = function () {
	    return minPos(this.anchor, this.head);
	  };
	  Range.prototype.to = function () {
	    return maxPos(this.anchor, this.head);
	  };
	  Range.prototype.empty = function () {
	    return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
	  };
	
	  // Take an unsorted, potentially overlapping set of ranges, and
	  // build a selection out of it. 'Consumes' ranges array (modifying
	  // it).
	  function normalizeSelection(cm, ranges, primIndex) {
	    var mayTouch = cm && cm.options.selectionsMayTouch;
	    var prim = ranges[primIndex];
	    ranges.sort(function (a, b) {
	      return cmp(a.from(), b.from());
	    });
	    primIndex = indexOf(ranges, prim);
	    for (var i = 1; i < ranges.length; i++) {
	      var cur = ranges[i],
	          prev = ranges[i - 1];
	      var diff = cmp(prev.to(), cur.from());
	      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
	        var from = minPos(prev.from(), cur.from()),
	            to = maxPos(prev.to(), cur.to());
	        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
	        if (i <= primIndex) {
	          --primIndex;
	        }
	        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
	      }
	    }
	    return new Selection(ranges, primIndex);
	  }
	
	  function simpleSelection(anchor, head) {
	    return new Selection([new Range(anchor, head || anchor)], 0);
	  }
	
	  // Compute the position of the end of a change (its 'to' property
	  // refers to the pre-change end).
	  function changeEnd(change) {
	    if (!change.text) {
	      return change.to;
	    }
	    return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
	  }
	
	  // Adjust a position to refer to the post-change position of the
	  // same text, or the end of the change if the change covers it.
	  function adjustForChange(pos, change) {
	    if (cmp(pos, change.from) < 0) {
	      return pos;
	    }
	    if (cmp(pos, change.to) <= 0) {
	      return changeEnd(change);
	    }
	
	    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1,
	        ch = pos.ch;
	    if (pos.line == change.to.line) {
	      ch += changeEnd(change).ch - change.to.ch;
	    }
	    return Pos(line, ch);
	  }
	
	  function computeSelAfterChange(doc, change) {
	    var out = [];
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      var range = doc.sel.ranges[i];
	      out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
	    }
	    return normalizeSelection(doc.cm, out, doc.sel.primIndex);
	  }
	
	  function offsetPos(pos, old, nw) {
	    if (pos.line == old.line) {
	      return Pos(nw.line, pos.ch - old.ch + nw.ch);
	    } else {
	      return Pos(nw.line + (pos.line - old.line), pos.ch);
	    }
	  }
	
	  // Used by replaceSelections to allow moving the selection to the
	  // start or around the replaced test. Hint may be "start" or "around".
	  function computeReplacedSel(doc, changes, hint) {
	    var out = [];
	    var oldPrev = Pos(doc.first, 0),
	        newPrev = oldPrev;
	    for (var i = 0; i < changes.length; i++) {
	      var change = changes[i];
	      var from = offsetPos(change.from, oldPrev, newPrev);
	      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
	      oldPrev = change.to;
	      newPrev = to;
	      if (hint == "around") {
	        var range = doc.sel.ranges[i],
	            inv = cmp(range.head, range.anchor) < 0;
	        out[i] = new Range(inv ? to : from, inv ? from : to);
	      } else {
	        out[i] = new Range(from, from);
	      }
	    }
	    return new Selection(out, doc.sel.primIndex);
	  }
	
	  // Used to get the editor into a consistent state again when options change.
	
	  function loadMode(cm) {
	    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
	    resetModeState(cm);
	  }
	
	  function resetModeState(cm) {
	    cm.doc.iter(function (line) {
	      if (line.stateAfter) {
	        line.stateAfter = null;
	      }
	      if (line.styles) {
	        line.styles = null;
	      }
	    });
	    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
	    startWorker(cm, 100);
	    cm.state.modeGen++;
	    if (cm.curOp) {
	      regChange(cm);
	    }
	  }
	
	  // DOCUMENT DATA STRUCTURE
	
	  // By default, updates that start and end at the beginning of a line
	  // are treated specially, in order to make the association of line
	  // widgets and marker elements with the text behave more intuitive.
	  function isWholeLineUpdate(doc, change) {
	    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
	  }
	
	  // Perform a change on the document data structure.
	  function updateDoc(doc, change, markedSpans, estimateHeight) {
	    function spansFor(n) {
	      return markedSpans ? markedSpans[n] : null;
	    }
	    function update(line, text, spans) {
	      updateLine(line, text, spans, estimateHeight);
	      signalLater(line, "change", line, change);
	    }
	    function linesFor(start, end) {
	      var result = [];
	      for (var i = start; i < end; ++i) {
	        result.push(new Line(text[i], spansFor(i), estimateHeight));
	      }
	      return result;
	    }
	
	    var from = change.from,
	        to = change.to,
	        text = change.text;
	    var firstLine = getLine(doc, from.line),
	        lastLine = getLine(doc, to.line);
	    var lastText = lst(text),
	        lastSpans = spansFor(text.length - 1),
	        nlines = to.line - from.line;
	
	    // Adjust the line structure
	    if (change.full) {
	      doc.insert(0, linesFor(0, text.length));
	      doc.remove(text.length, doc.size - text.length);
	    } else if (isWholeLineUpdate(doc, change)) {
	      // This is a whole-line replace. Treated specially to make
	      // sure line objects move the way they are supposed to.
	      var added = linesFor(0, text.length - 1);
	      update(lastLine, lastLine.text, lastSpans);
	      if (nlines) {
	        doc.remove(from.line, nlines);
	      }
	      if (added.length) {
	        doc.insert(from.line, added);
	      }
	    } else if (firstLine == lastLine) {
	      if (text.length == 1) {
	        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
	      } else {
	        var added$1 = linesFor(1, text.length - 1);
	        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
	        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	        doc.insert(from.line + 1, added$1);
	      }
	    } else if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
	      doc.remove(from.line + 1, nlines);
	    } else {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
	      var added$2 = linesFor(1, text.length - 1);
	      if (nlines > 1) {
	        doc.remove(from.line + 1, nlines - 1);
	      }
	      doc.insert(from.line + 1, added$2);
	    }
	
	    signalLater(doc, "change", doc, change);
	  }
	
	  // Call f for all linked documents.
	  function linkedDocs(doc, f, sharedHistOnly) {
	    function propagate(doc, skip, sharedHist) {
	      if (doc.linked) {
	        for (var i = 0; i < doc.linked.length; ++i) {
	          var rel = doc.linked[i];
	          if (rel.doc == skip) {
	            continue;
	          }
	          var shared = sharedHist && rel.sharedHist;
	          if (sharedHistOnly && !shared) {
	            continue;
	          }
	          f(rel.doc, shared);
	          propagate(rel.doc, doc, shared);
	        }
	      }
	    }
	    propagate(doc, null, true);
	  }
	
	  // Attach a document to an editor.
	  function attachDoc(cm, doc) {
	    if (doc.cm) {
	      throw new Error("This document is already in use.");
	    }
	    cm.doc = doc;
	    doc.cm = cm;
	    estimateLineHeights(cm);
	    loadMode(cm);
	    setDirectionClass(cm);
	    cm.options.direction = doc.direction;
	    if (!cm.options.lineWrapping) {
	      findMaxLine(cm);
	    }
	    cm.options.mode = doc.modeOption;
	    regChange(cm);
	  }
	
	  function setDirectionClass(cm) {
	    (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
	  }
	
	  function directionChanged(cm) {
	    runInOp(cm, function () {
	      setDirectionClass(cm);
	      regChange(cm);
	    });
	  }
	
	  function History(prev) {
	    // Arrays of change events and selections. Doing something adds an
	    // event to done and clears undo. Undoing moves events from done
	    // to undone, redoing moves them in the other direction.
	    this.done = [];this.undone = [];
	    this.undoDepth = prev ? prev.undoDepth : Infinity;
	    // Used to track when changes can be merged into a single undo
	    // event
	    this.lastModTime = this.lastSelTime = 0;
	    this.lastOp = this.lastSelOp = null;
	    this.lastOrigin = this.lastSelOrigin = null;
	    // Used by the isClean() method
	    this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
	  }
	
	  // Create a history change event from an updateDoc-style change
	  // object.
	  function historyChangeFromChange(doc, change) {
	    var histChange = { from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to) };
	    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    linkedDocs(doc, function (doc) {
	      return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    }, true);
	    return histChange;
	  }
	
	  // Pop all selection events off the end of a history array. Stop at
	  // a change event.
	  function clearSelectionEvents(array) {
	    while (array.length) {
	      var last = lst(array);
	      if (last.ranges) {
	        array.pop();
	      } else {
	        break;
	      }
	    }
	  }
	
	  // Find the top change event in the history. Pop off selection
	  // events that are in the way.
	  function lastChangeEvent(hist, force) {
	    if (force) {
	      clearSelectionEvents(hist.done);
	      return lst(hist.done);
	    } else if (hist.done.length && !lst(hist.done).ranges) {
	      return lst(hist.done);
	    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	      hist.done.pop();
	      return lst(hist.done);
	    }
	  }
	
	  // Register a change in the history. Merges changes that are within
	  // a single operation, or are close together with an origin that
	  // allows merging (starting with "+") into a single event.
	  function addChangeToHistory(doc, change, selAfter, opId) {
	    var hist = doc.history;
	    hist.undone.length = 0;
	    var time = +new Date(),
	        cur;
	    var last;
	
	    if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	      // Merge this change into the last event
	      last = lst(cur.changes);
	      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	        // Optimized case for simple insertion -- don't want to add
	        // new changesets for every character typed
	        last.to = changeEnd(change);
	      } else {
	        // Add new sub-event
	        cur.changes.push(historyChangeFromChange(doc, change));
	      }
	    } else {
	      // Can not be merged, start a new event.
	      var before = lst(hist.done);
	      if (!before || !before.ranges) {
	        pushSelectionToHistory(doc.sel, hist.done);
	      }
	      cur = { changes: [historyChangeFromChange(doc, change)],
	        generation: hist.generation };
	      hist.done.push(cur);
	      while (hist.done.length > hist.undoDepth) {
	        hist.done.shift();
	        if (!hist.done[0].ranges) {
	          hist.done.shift();
	        }
	      }
	    }
	    hist.done.push(selAfter);
	    hist.generation = ++hist.maxGeneration;
	    hist.lastModTime = hist.lastSelTime = time;
	    hist.lastOp = hist.lastSelOp = opId;
	    hist.lastOrigin = hist.lastSelOrigin = change.origin;
	
	    if (!last) {
	      signal(doc, "historyAdded");
	    }
	  }
	
	  function selectionEventCanBeMerged(doc, origin, prev, sel) {
	    var ch = origin.charAt(0);
	    return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date() - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
	  }
	
	  // Called whenever the selection changes, sets the new selection as
	  // the pending selection in the history, and pushes the old pending
	  // selection into the 'done' array when it was significantly
	  // different (in number of selected ranges, emptiness, or time).
	  function addSelectionToHistory(doc, sel, opId, options) {
	    var hist = doc.history,
	        origin = options && options.origin;
	
	    // A new event is started when the previous origin does not match
	    // the current, or the origins don't allow matching. Origins
	    // starting with * are always merged, those starting with + are
	    // merged when similar and close together in time.
	    if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) {
	      hist.done[hist.done.length - 1] = sel;
	    } else {
	      pushSelectionToHistory(sel, hist.done);
	    }
	
	    hist.lastSelTime = +new Date();
	    hist.lastSelOrigin = origin;
	    hist.lastSelOp = opId;
	    if (options && options.clearRedo !== false) {
	      clearSelectionEvents(hist.undone);
	    }
	  }
	
	  function pushSelectionToHistory(sel, dest) {
	    var top = lst(dest);
	    if (!(top && top.ranges && top.equals(sel))) {
	      dest.push(sel);
	    }
	  }
	
	  // Used to store marked span information in the history.
	  function attachLocalSpans(doc, change, from, to) {
	    var existing = change["spans_" + doc.id],
	        n = 0;
	    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
	      if (line.markedSpans) {
	        (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
	      }
	      ++n;
	    });
	  }
	
	  // When un/re-doing restores text containing marked spans, those
	  // that have been explicitly cleared should not be restored.
	  function removeClearedSpans(spans) {
	    if (!spans) {
	      return null;
	    }
	    var out;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i].marker.explicitlyCleared) {
	        if (!out) {
	          out = spans.slice(0, i);
	        }
	      } else if (out) {
	        out.push(spans[i]);
	      }
	    }
	    return !out ? spans : out.length ? out : null;
	  }
	
	  // Retrieve and filter the old marked spans stored in a change event.
	  function getOldSpans(doc, change) {
	    var found = change["spans_" + doc.id];
	    if (!found) {
	      return null;
	    }
	    var nw = [];
	    for (var i = 0; i < change.text.length; ++i) {
	      nw.push(removeClearedSpans(found[i]));
	    }
	    return nw;
	  }
	
	  // Used for un/re-doing changes from the history. Combines the
	  // result of computing the existing spans with the set of spans that
	  // existed in the history (so that deleting around a span and then
	  // undoing brings back the span).
	  function mergeOldSpans(doc, change) {
	    var old = getOldSpans(doc, change);
	    var stretched = stretchSpansOverChange(doc, change);
	    if (!old) {
	      return stretched;
	    }
	    if (!stretched) {
	      return old;
	    }
	
	    for (var i = 0; i < old.length; ++i) {
	      var oldCur = old[i],
	          stretchCur = stretched[i];
	      if (oldCur && stretchCur) {
	        spans: for (var j = 0; j < stretchCur.length; ++j) {
	          var span = stretchCur[j];
	          for (var k = 0; k < oldCur.length; ++k) {
	            if (oldCur[k].marker == span.marker) {
	              continue spans;
	            }
	          }
	          oldCur.push(span);
	        }
	      } else if (stretchCur) {
	        old[i] = stretchCur;
	      }
	    }
	    return old;
	  }
	
	  // Used both to provide a JSON-safe object in .getHistory, and, when
	  // detaching a document, to split the history in two
	  function copyHistoryArray(events, newGroup, instantiateSel) {
	    var copy = [];
	    for (var i = 0; i < events.length; ++i) {
	      var event = events[i];
	      if (event.ranges) {
	        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
	        continue;
	      }
	      var changes = event.changes,
	          newChanges = [];
	      copy.push({ changes: newChanges });
	      for (var j = 0; j < changes.length; ++j) {
	        var change = changes[j],
	            m = void 0;
	        newChanges.push({ from: change.from, to: change.to, text: change.text });
	        if (newGroup) {
	          for (var prop in change) {
	            if (m = prop.match(/^spans_(\d+)$/)) {
	              if (indexOf(newGroup, Number(m[1])) > -1) {
	                lst(newChanges)[prop] = change[prop];
	                delete change[prop];
	              }
	            }
	          }
	        }
	      }
	    }
	    return copy;
	  }
	
	  // The 'scroll' parameter given to many of these indicated whether
	  // the new cursor position should be scrolled into view after
	  // modifying the selection.
	
	  // If shift is held or the extend flag is set, extends a range to
	  // include a given position (and optionally a second position).
	  // Otherwise, simply returns the range between the given positions.
	  // Used for cursor motion and such.
	  function extendRange(range, head, other, extend) {
	    if (extend) {
	      var anchor = range.anchor;
	      if (other) {
	        var posBefore = cmp(head, anchor) < 0;
	        if (posBefore != cmp(other, anchor) < 0) {
	          anchor = head;
	          head = other;
	        } else if (posBefore != cmp(head, other) < 0) {
	          head = other;
	        }
	      }
	      return new Range(anchor, head);
	    } else {
	      return new Range(other || head, head);
	    }
	  }
	
	  // Extend the primary selection range, discard the rest.
	  function extendSelection(doc, head, other, options, extend) {
	    if (extend == null) {
	      extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    }
	    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
	  }
	
	  // Extend all selections (pos is an array of selections with length
	  // equal the number of selections)
	  function extendSelections(doc, heads, options) {
	    var out = [];
	    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
	    }
	    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
	    setSelection(doc, newSel, options);
	  }
	
	  // Updates a single range in the selection.
	  function replaceOneSelection(doc, i, range, options) {
	    var ranges = doc.sel.ranges.slice(0);
	    ranges[i] = range;
	    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
	  }
	
	  // Reset the selection to a single range.
	  function setSimpleSelection(doc, anchor, head, options) {
	    setSelection(doc, simpleSelection(anchor, head), options);
	  }
	
	  // Give beforeSelectionChange handlers a change to influence a
	  // selection update.
	  function filterSelectionChange(doc, sel, options) {
	    var obj = {
	      ranges: sel.ranges,
	      update: function update(ranges) {
	        this.ranges = [];
	        for (var i = 0; i < ranges.length; i++) {
	          this.ranges[i] = new Range(_clipPos(doc, ranges[i].anchor), _clipPos(doc, ranges[i].head));
	        }
	      },
	      origin: options && options.origin
	    };
	    signal(doc, "beforeSelectionChange", doc, obj);
	    if (doc.cm) {
	      signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
	    }
	    if (obj.ranges != sel.ranges) {
	      return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1);
	    } else {
	      return sel;
	    }
	  }
	
	  function setSelectionReplaceHistory(doc, sel, options) {
	    var done = doc.history.done,
	        last = lst(done);
	    if (last && last.ranges) {
	      done[done.length - 1] = sel;
	      setSelectionNoUndo(doc, sel, options);
	    } else {
	      setSelection(doc, sel, options);
	    }
	  }
	
	  // Set a new selection.
	  function setSelection(doc, sel, options) {
	    setSelectionNoUndo(doc, sel, options);
	    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
	  }
	
	  function setSelectionNoUndo(doc, sel, options) {
	    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) {
	      sel = filterSelectionChange(doc, sel, options);
	    }
	
	    var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
	    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
	
	    if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor") {
	      ensureCursorVisible(doc.cm);
	    }
	  }
	
	  function setSelectionInner(doc, sel) {
	    if (sel.equals(doc.sel)) {
	      return;
	    }
	
	    doc.sel = sel;
	
	    if (doc.cm) {
	      doc.cm.curOp.updateInput = 1;
	      doc.cm.curOp.selectionChanged = true;
	      signalCursorActivity(doc.cm);
	    }
	    signalLater(doc, "cursorActivity", doc);
	  }
	
	  // Verify that the selection does not partially select any atomic
	  // marked ranges.
	  function reCheckSelection(doc) {
	    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
	  }
	
	  // Return a selection that does not partially select any atomic
	  // ranges.
	  function skipAtomicInSelection(doc, sel, bias, mayClear) {
	    var out;
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i];
	      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
	      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
	      var newHead = range.head == range.anchor ? newAnchor : skipAtomic(doc, range.head, old && old.head, bias, mayClear);
	      if (out || newAnchor != range.anchor || newHead != range.head) {
	        if (!out) {
	          out = sel.ranges.slice(0, i);
	        }
	        out[i] = new Range(newAnchor, newHead);
	      }
	    }
	    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel;
	  }
	
	  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	    var line = getLine(doc, pos.line);
	    if (line.markedSpans) {
	      for (var i = 0; i < line.markedSpans.length; ++i) {
	        var sp = line.markedSpans[i],
	            m = sp.marker;
	
	        // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
	        // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
	        // is with selectLeft/Right
	        var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
	        var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
	
	        if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	          if (mayClear) {
	            signal(m, "beforeCursorEnter");
	            if (m.explicitlyCleared) {
	              if (!line.markedSpans) {
	                break;
	              } else {
	                --i;continue;
	              }
	            }
	          }
	          if (!m.atomic) {
	            continue;
	          }
	
	          if (oldPos) {
	            var near = m.find(dir < 0 ? 1 : -1),
	                diff = void 0;
	            if (dir < 0 ? preventCursorRight : preventCursorLeft) {
	              near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
	            }
	            if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) {
	              return skipAtomicInner(doc, near, pos, dir, mayClear);
	            }
	          }
	
	          var far = m.find(dir < 0 ? -1 : 1);
	          if (dir < 0 ? preventCursorLeft : preventCursorRight) {
	            far = movePos(doc, far, dir, far.line == pos.line ? line : null);
	          }
	          return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
	        }
	      }
	    }
	    return pos;
	  }
	
	  // Ensure a given position is not inside an atomic range.
	  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	    var dir = bias || 1;
	    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
	    if (!found) {
	      doc.cantEdit = true;
	      return Pos(doc.first, 0);
	    }
	    return found;
	  }
	
	  function movePos(doc, pos, dir, line) {
	    if (dir < 0 && pos.ch == 0) {
	      if (pos.line > doc.first) {
	        return _clipPos(doc, Pos(pos.line - 1));
	      } else {
	        return null;
	      }
	    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	      if (pos.line < doc.first + doc.size - 1) {
	        return Pos(pos.line + 1, 0);
	      } else {
	        return null;
	      }
	    } else {
	      return new Pos(pos.line, pos.ch + dir);
	    }
	  }
	
	  function selectAll(cm) {
	    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
	  }
	
	  // UPDATING
	
	  // Allow "beforeChange" event handlers to influence a change
	  function filterChange(doc, change, update) {
	    var obj = {
	      canceled: false,
	      from: change.from,
	      to: change.to,
	      text: change.text,
	      origin: change.origin,
	      cancel: function cancel() {
	        return obj.canceled = true;
	      }
	    };
	    if (update) {
	      obj.update = function (from, to, text, origin) {
	        if (from) {
	          obj.from = _clipPos(doc, from);
	        }
	        if (to) {
	          obj.to = _clipPos(doc, to);
	        }
	        if (text) {
	          obj.text = text;
	        }
	        if (origin !== undefined) {
	          obj.origin = origin;
	        }
	      };
	    }
	    signal(doc, "beforeChange", doc, obj);
	    if (doc.cm) {
	      signal(doc.cm, "beforeChange", doc.cm, obj);
	    }
	
	    if (obj.canceled) {
	      if (doc.cm) {
	        doc.cm.curOp.updateInput = 2;
	      }
	      return null;
	    }
	    return { from: obj.from, to: obj.to, text: obj.text, origin: obj.origin };
	  }
	
	  // Apply a change to a document, and add it to the document's
	  // history, and propagating it to all linked documents.
	  function makeChange(doc, change, ignoreReadOnly) {
	    if (doc.cm) {
	      if (!doc.cm.curOp) {
	        return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
	      }
	      if (doc.cm.state.suppressEdits) {
	        return;
	      }
	    }
	
	    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	      change = filterChange(doc, change, true);
	      if (!change) {
	        return;
	      }
	    }
	
	    // Possibly split or suppress the update based on the presence
	    // of read-only spans in its range.
	    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
	    if (split) {
	      for (var i = split.length - 1; i >= 0; --i) {
	        makeChangeInner(doc, { from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin });
	      }
	    } else {
	      makeChangeInner(doc, change);
	    }
	  }
	
	  function makeChangeInner(doc, change) {
	    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) {
	      return;
	    }
	    var selAfter = computeSelAfterChange(doc, change);
	    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
	
	    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
	    var rebased = [];
	
	    linkedDocs(doc, function (doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change);
	        rebased.push(doc.history);
	      }
	      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
	    });
	  }
	
	  // Revert a change stored in a document's history.
	  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	    var suppress = doc.cm && doc.cm.state.suppressEdits;
	    if (suppress && !allowSelectionOnly) {
	      return;
	    }
	
	    var hist = doc.history,
	        event,
	        selAfter = doc.sel;
	    var source = type == "undo" ? hist.done : hist.undone,
	        dest = type == "undo" ? hist.undone : hist.done;
	
	    // Verify that there is a useable event (so that ctrl-z won't
	    // needlessly clear selection events)
	    var i = 0;
	    for (; i < source.length; i++) {
	      event = source[i];
	      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) {
	        break;
	      }
	    }
	    if (i == source.length) {
	      return;
	    }
	    hist.lastOrigin = hist.lastSelOrigin = null;
	
	    for (;;) {
	      event = source.pop();
	      if (event.ranges) {
	        pushSelectionToHistory(event, dest);
	        if (allowSelectionOnly && !event.equals(doc.sel)) {
	          setSelection(doc, event, { clearRedo: false });
	          return;
	        }
	        selAfter = event;
	      } else if (suppress) {
	        source.push(event);
	        return;
	      } else {
	        break;
	      }
	    }
	
	    // Build up a reverse change object to add to the opposite history
	    // stack (redo when undoing, and vice versa).
	    var antiChanges = [];
	    pushSelectionToHistory(selAfter, dest);
	    dest.push({ changes: antiChanges, generation: hist.generation });
	    hist.generation = event.generation || ++hist.maxGeneration;
	
	    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
	
	    var loop = function loop(i) {
	      var change = event.changes[i];
	      change.origin = type;
	      if (filter && !filterChange(doc, change, false)) {
	        source.length = 0;
	        return {};
	      }
	
	      antiChanges.push(historyChangeFromChange(doc, change));
	
	      var after = i ? computeSelAfterChange(doc, change) : lst(source);
	      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
	      if (!i && doc.cm) {
	        doc.cm.scrollIntoView({ from: change.from, to: changeEnd(change) });
	      }
	      var rebased = [];
	
	      // Propagate to the linked documents
	      linkedDocs(doc, function (doc, sharedHist) {
	        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	          rebaseHist(doc.history, change);
	          rebased.push(doc.history);
	        }
	        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
	      });
	    };
	
	    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
	      var returned = loop(i$1);
	
	      if (returned) return returned.v;
	    }
	  }
	
	  // Sub-views need their line numbers shifted when text is added
	  // above or below them in the parent document.
	  function shiftDoc(doc, distance) {
	    if (distance == 0) {
	      return;
	    }
	    doc.first += distance;
	    doc.sel = new Selection(map(doc.sel.ranges, function (range) {
	      return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
	    }), doc.sel.primIndex);
	    if (doc.cm) {
	      regChange(doc.cm, doc.first, doc.first - distance, distance);
	      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++) {
	        regLineChange(doc.cm, l, "gutter");
	      }
	    }
	  }
	
	  // More lower-level change function, handling only a single document
	  // (not linked ones).
	  function makeChangeSingleDoc(doc, change, selAfter, spans) {
	    if (doc.cm && !doc.cm.curOp) {
	      return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
	    }
	
	    if (change.to.line < doc.first) {
	      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
	      return;
	    }
	    if (change.from.line > doc.lastLine()) {
	      return;
	    }
	
	    // Clip the change to the size of this doc
	    if (change.from.line < doc.first) {
	      var shift = change.text.length - 1 - (doc.first - change.from.line);
	      shiftDoc(doc, shift);
	      change = { from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	        text: [lst(change.text)], origin: change.origin };
	    }
	    var last = doc.lastLine();
	    if (change.to.line > last) {
	      change = { from: change.from, to: Pos(last, getLine(doc, last).text.length),
	        text: [change.text[0]], origin: change.origin };
	    }
	
	    change.removed = getBetween(doc, change.from, change.to);
	
	    if (!selAfter) {
	      selAfter = computeSelAfterChange(doc, change);
	    }
	    if (doc.cm) {
	      makeChangeSingleDocInEditor(doc.cm, change, spans);
	    } else {
	      updateDoc(doc, change, spans);
	    }
	    setSelectionNoUndo(doc, selAfter, sel_dontScroll);
	
	    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0))) {
	      doc.cantEdit = false;
	    }
	  }
	
	  // Handle the interaction of a change to a document with the editor
	  // that this document is part of.
	  function makeChangeSingleDocInEditor(cm, change, spans) {
	    var doc = cm.doc,
	        display = cm.display,
	        from = change.from,
	        to = change.to;
	
	    var recomputeMaxLength = false,
	        checkWidthStart = from.line;
	    if (!cm.options.lineWrapping) {
	      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
	      doc.iter(checkWidthStart, to.line + 1, function (line) {
	        if (line == display.maxLine) {
	          recomputeMaxLength = true;
	          return true;
	        }
	      });
	    }
	
	    if (doc.sel.contains(change.from, change.to) > -1) {
	      signalCursorActivity(cm);
	    }
	
	    updateDoc(doc, change, spans, estimateHeight(cm));
	
	    if (!cm.options.lineWrapping) {
	      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
	        var len = lineLength(line);
	        if (len > display.maxLineLength) {
	          display.maxLine = line;
	          display.maxLineLength = len;
	          display.maxLineChanged = true;
	          recomputeMaxLength = false;
	        }
	      });
	      if (recomputeMaxLength) {
	        cm.curOp.updateMaxLine = true;
	      }
	    }
	
	    retreatFrontier(doc, from.line);
	    startWorker(cm, 400);
	
	    var lendiff = change.text.length - (to.line - from.line) - 1;
	    // Remember that these lines changed, for updating the display
	    if (change.full) {
	      regChange(cm);
	    } else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) {
	      regLineChange(cm, from.line, "text");
	    } else {
	      regChange(cm, from.line, to.line + 1, lendiff);
	    }
	
	    var changesHandler = hasHandler(cm, "changes"),
	        changeHandler = hasHandler(cm, "change");
	    if (changeHandler || changesHandler) {
	      var obj = {
	        from: from, to: to,
	        text: change.text,
	        removed: change.removed,
	        origin: change.origin
	      };
	      if (changeHandler) {
	        signalLater(cm, "change", cm, obj);
	      }
	      if (changesHandler) {
	        (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
	      }
	    }
	    cm.display.selForContextMenu = null;
	  }
	
	  function _replaceRange(doc, code, from, to, origin) {
	    var assign;
	
	    if (!to) {
	      to = from;
	    }
	    if (cmp(to, from) < 0) {
	      assign = [to, from], from = assign[0], to = assign[1];
	    }
	    if (typeof code == "string") {
	      code = doc.splitLines(code);
	    }
	    makeChange(doc, { from: from, to: to, text: code, origin: origin });
	  }
	
	  // Rebasing/resetting history to deal with externally-sourced changes
	
	  function rebaseHistSelSingle(pos, from, to, diff) {
	    if (to < pos.line) {
	      pos.line += diff;
	    } else if (from < pos.line) {
	      pos.line = from;
	      pos.ch = 0;
	    }
	  }
	
	  // Tries to rebase an array of history events given a change in the
	  // document. If the change touches the same lines as the event, the
	  // event, and everything 'behind' it, is discarded. If the change is
	  // before the event, the event's positions are updated. Uses a
	  // copy-on-write scheme for the positions, to avoid having to
	  // reallocate them all on every rebase, but also avoid problems with
	  // shared position objects being unsafely updated.
	  function rebaseHistArray(array, from, to, diff) {
	    for (var i = 0; i < array.length; ++i) {
	      var sub = array[i],
	          ok = true;
	      if (sub.ranges) {
	        if (!sub.copied) {
	          sub = array[i] = sub.deepCopy();sub.copied = true;
	        }
	        for (var j = 0; j < sub.ranges.length; j++) {
	          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
	          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
	        }
	        continue;
	      }
	      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
	        var cur = sub.changes[j$1];
	        if (to < cur.from.line) {
	          cur.from = Pos(cur.from.line + diff, cur.from.ch);
	          cur.to = Pos(cur.to.line + diff, cur.to.ch);
	        } else if (from <= cur.to.line) {
	          ok = false;
	          break;
	        }
	      }
	      if (!ok) {
	        array.splice(0, i + 1);
	        i = 0;
	      }
	    }
	  }
	
	  function rebaseHist(hist, change) {
	    var from = change.from.line,
	        to = change.to.line,
	        diff = change.text.length - (to - from) - 1;
	    rebaseHistArray(hist.done, from, to, diff);
	    rebaseHistArray(hist.undone, from, to, diff);
	  }
	
	  // Utility for applying a change to a line by handle or number,
	  // returning the number and optionally registering the line as
	  // changed.
	  function changeLine(doc, handle, changeType, op) {
	    var no = handle,
	        line = handle;
	    if (typeof handle == "number") {
	      line = getLine(doc, clipLine(doc, handle));
	    } else {
	      no = lineNo(handle);
	    }
	    if (no == null) {
	      return null;
	    }
	    if (op(line, no) && doc.cm) {
	      regLineChange(doc.cm, no, changeType);
	    }
	    return line;
	  }
	
	  // The document is represented as a BTree consisting of leaves, with
	  // chunk of lines in them, and branches, with up to ten leaves or
	  // other branch nodes below them. The top node is always a branch
	  // node, and is the document object itself (meaning it has
	  // additional methods and properties).
	  //
	  // All nodes have parent links. The tree is used both to go from
	  // line numbers to line objects, and to go from objects to numbers.
	  // It also indexes by height, and is used to convert between height
	  // and line object, and to find the total height of the document.
	  //
	  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	  function LeafChunk(lines) {
	    this.lines = lines;
	    this.parent = null;
	    var height = 0;
	    for (var i = 0; i < lines.length; ++i) {
	      lines[i].parent = this;
	      height += lines[i].height;
	    }
	    this.height = height;
	  }
	
	  LeafChunk.prototype = {
	    chunkSize: function chunkSize() {
	      return this.lines.length;
	    },
	
	    // Remove the n lines at offset 'at'.
	    removeInner: function removeInner(at, n) {
	      for (var i = at, e = at + n; i < e; ++i) {
	        var line = this.lines[i];
	        this.height -= line.height;
	        cleanUpLine(line);
	        signalLater(line, "delete");
	      }
	      this.lines.splice(at, n);
	    },
	
	    // Helper used to collapse a small branch into a single leaf.
	    collapse: function collapse(lines) {
	      lines.push.apply(lines, this.lines);
	    },
	
	    // Insert the given array of lines at offset 'at', count them as
	    // having the given height.
	    insertInner: function insertInner(at, lines, height) {
	      this.height += height;
	      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
	      for (var i = 0; i < lines.length; ++i) {
	        lines[i].parent = this;
	      }
	    },
	
	    // Used to iterate over a part of the tree.
	    iterN: function iterN(at, n, op) {
	      for (var e = at + n; at < e; ++at) {
	        if (op(this.lines[at])) {
	          return true;
	        }
	      }
	    }
	  };
	
	  function BranchChunk(children) {
	    this.children = children;
	    var size = 0,
	        height = 0;
	    for (var i = 0; i < children.length; ++i) {
	      var ch = children[i];
	      size += ch.chunkSize();height += ch.height;
	      ch.parent = this;
	    }
	    this.size = size;
	    this.height = height;
	    this.parent = null;
	  }
	
	  BranchChunk.prototype = {
	    chunkSize: function chunkSize() {
	      return this.size;
	    },
	
	    removeInner: function removeInner(at, n) {
	      this.size -= n;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i],
	            sz = child.chunkSize();
	        if (at < sz) {
	          var rm = Math.min(n, sz - at),
	              oldHeight = child.height;
	          child.removeInner(at, rm);
	          this.height -= oldHeight - child.height;
	          if (sz == rm) {
	            this.children.splice(i--, 1);child.parent = null;
	          }
	          if ((n -= rm) == 0) {
	            break;
	          }
	          at = 0;
	        } else {
	          at -= sz;
	        }
	      }
	      // If the result is smaller than 25 lines, ensure that it is a
	      // single leaf node.
	      if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	        var lines = [];
	        this.collapse(lines);
	        this.children = [new LeafChunk(lines)];
	        this.children[0].parent = this;
	      }
	    },
	
	    collapse: function collapse(lines) {
	      for (var i = 0; i < this.children.length; ++i) {
	        this.children[i].collapse(lines);
	      }
	    },
	
	    insertInner: function insertInner(at, lines, height) {
	      this.size += lines.length;
	      this.height += height;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i],
	            sz = child.chunkSize();
	        if (at <= sz) {
	          child.insertInner(at, lines, height);
	          if (child.lines && child.lines.length > 50) {
	            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	            var remaining = child.lines.length % 25 + 25;
	            for (var pos = remaining; pos < child.lines.length;) {
	              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
	              child.height -= leaf.height;
	              this.children.splice(++i, 0, leaf);
	              leaf.parent = this;
	            }
	            child.lines = child.lines.slice(0, remaining);
	            this.maybeSpill();
	          }
	          break;
	        }
	        at -= sz;
	      }
	    },
	
	    // When a node has grown, check whether it should be split.
	    maybeSpill: function maybeSpill() {
	      if (this.children.length <= 10) {
	        return;
	      }
	      var me = this;
	      do {
	        var spilled = me.children.splice(me.children.length - 5, 5);
	        var sibling = new BranchChunk(spilled);
	        if (!me.parent) {
	          // Become the parent node
	          var copy = new BranchChunk(me.children);
	          copy.parent = me;
	          me.children = [copy, sibling];
	          me = copy;
	        } else {
	          me.size -= sibling.size;
	          me.height -= sibling.height;
	          var myIndex = indexOf(me.parent.children, me);
	          me.parent.children.splice(myIndex + 1, 0, sibling);
	        }
	        sibling.parent = me.parent;
	      } while (me.children.length > 10);
	      me.parent.maybeSpill();
	    },
	
	    iterN: function iterN(at, n, op) {
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i],
	            sz = child.chunkSize();
	        if (at < sz) {
	          var used = Math.min(n, sz - at);
	          if (child.iterN(at, used, op)) {
	            return true;
	          }
	          if ((n -= used) == 0) {
	            break;
	          }
	          at = 0;
	        } else {
	          at -= sz;
	        }
	      }
	    }
	  };
	
	  // Line widgets are block elements displayed above or below a line.
	
	  var LineWidget = function LineWidget(doc, node, options) {
	    if (options) {
	      for (var opt in options) {
	        if (options.hasOwnProperty(opt)) {
	          this[opt] = options[opt];
	        }
	      }
	    }
	    this.doc = doc;
	    this.node = node;
	  };
	
	  LineWidget.prototype.clear = function () {
	    var cm = this.doc.cm,
	        ws = this.line.widgets,
	        line = this.line,
	        no = lineNo(line);
	    if (no == null || !ws) {
	      return;
	    }
	    for (var i = 0; i < ws.length; ++i) {
	      if (ws[i] == this) {
	        ws.splice(i--, 1);
	      }
	    }
	    if (!ws.length) {
	      line.widgets = null;
	    }
	    var height = widgetHeight(this);
	    updateLineHeight(line, Math.max(0, line.height - height));
	    if (cm) {
	      runInOp(cm, function () {
	        adjustScrollWhenAboveVisible(cm, line, -height);
	        regLineChange(cm, no, "widget");
	      });
	      signalLater(cm, "lineWidgetCleared", cm, this, no);
	    }
	  };
	
	  LineWidget.prototype.changed = function () {
	    var this$1 = this;
	
	    var oldH = this.height,
	        cm = this.doc.cm,
	        line = this.line;
	    this.height = null;
	    var diff = widgetHeight(this) - oldH;
	    if (!diff) {
	      return;
	    }
	    if (!lineIsHidden(this.doc, line)) {
	      updateLineHeight(line, line.height + diff);
	    }
	    if (cm) {
	      runInOp(cm, function () {
	        cm.curOp.forceUpdate = true;
	        adjustScrollWhenAboveVisible(cm, line, diff);
	        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
	      });
	    }
	  };
	  eventMixin(LineWidget);
	
	  function adjustScrollWhenAboveVisible(cm, line, diff) {
	    if (_heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) {
	      addToScrollTop(cm, diff);
	    }
	  }
	
	  function addLineWidget(doc, handle, node, options) {
	    var widget = new LineWidget(doc, node, options);
	    var cm = doc.cm;
	    if (cm && widget.noHScroll) {
	      cm.display.alignWidgets = true;
	    }
	    changeLine(doc, handle, "widget", function (line) {
	      var widgets = line.widgets || (line.widgets = []);
	      if (widget.insertAt == null) {
	        widgets.push(widget);
	      } else {
	        widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget);
	      }
	      widget.line = line;
	      if (cm && !lineIsHidden(doc, line)) {
	        var aboveVisible = _heightAtLine(line) < doc.scrollTop;
	        updateLineHeight(line, line.height + widgetHeight(widget));
	        if (aboveVisible) {
	          addToScrollTop(cm, widget.height);
	        }
	        cm.curOp.forceUpdate = true;
	      }
	      return true;
	    });
	    if (cm) {
	      signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
	    }
	    return widget;
	  }
	
	  // TEXTMARKERS
	
	  // Created with markText and setBookmark methods. A TextMarker is a
	  // handle that can be used to clear or find a marked position in the
	  // document. Line objects hold arrays (markedSpans) containing
	  // {from, to, marker} object pointing to such marker objects, and
	  // indicating that such a marker is present on that line. Multiple
	  // lines may point to the same marker when it spans across lines.
	  // The spans will have null for their from/to properties when the
	  // marker continues beyond the start/end of the line. Markers have
	  // links back to the lines they currently touch.
	
	  // Collapsed markers have unique ids, in order to be able to order
	  // them, which is needed for uniquely determining an outer marker
	  // when they overlap (they may nest, but not partially overlap).
	  var nextMarkerId = 0;
	
	  var TextMarker = function TextMarker(doc, type) {
	    this.lines = [];
	    this.type = type;
	    this.doc = doc;
	    this.id = ++nextMarkerId;
	  };
	
	  // Clear the marker.
	  TextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) {
	      return;
	    }
	    var cm = this.doc.cm,
	        withOp = cm && !cm.curOp;
	    if (withOp) {
	      _startOperation(cm);
	    }
	    if (hasHandler(this, "clear")) {
	      var found = this.find();
	      if (found) {
	        signalLater(this, "clear", found.from, found.to);
	      }
	    }
	    var min = null,
	        max = null;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (cm && !this.collapsed) {
	        regLineChange(cm, lineNo(line), "text");
	      } else if (cm) {
	        if (span.to != null) {
	          max = lineNo(line);
	        }
	        if (span.from != null) {
	          min = lineNo(line);
	        }
	      }
	      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
	      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm) {
	        updateLineHeight(line, textHeight(cm.display));
	      }
	    }
	    if (cm && this.collapsed && !cm.options.lineWrapping) {
	      for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
	        var visual = visualLine(this.lines[i$1]),
	            len = lineLength(visual);
	        if (len > cm.display.maxLineLength) {
	          cm.display.maxLine = visual;
	          cm.display.maxLineLength = len;
	          cm.display.maxLineChanged = true;
	        }
	      }
	    }
	
	    if (min != null && cm && this.collapsed) {
	      regChange(cm, min, max + 1);
	    }
	    this.lines.length = 0;
	    this.explicitlyCleared = true;
	    if (this.atomic && this.doc.cantEdit) {
	      this.doc.cantEdit = false;
	      if (cm) {
	        reCheckSelection(cm.doc);
	      }
	    }
	    if (cm) {
	      signalLater(cm, "markerCleared", cm, this, min, max);
	    }
	    if (withOp) {
	      _endOperation(cm);
	    }
	    if (this.parent) {
	      this.parent.clear();
	    }
	  };
	
	  // Find the position of the marker in the document. Returns a {from,
	  // to} object by default. Side can be passed to get a specific side
	  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	  // Pos objects returned contain a line object, rather than a line
	  // number (used to prevent looking up the same line twice).
	  TextMarker.prototype.find = function (side, lineObj) {
	    if (side == null && this.type == "bookmark") {
	      side = 1;
	    }
	    var from, to;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (span.from != null) {
	        from = Pos(lineObj ? line : lineNo(line), span.from);
	        if (side == -1) {
	          return from;
	        }
	      }
	      if (span.to != null) {
	        to = Pos(lineObj ? line : lineNo(line), span.to);
	        if (side == 1) {
	          return to;
	        }
	      }
	    }
	    return from && { from: from, to: to };
	  };
	
	  // Signals that the marker's widget changed, and surrounding layout
	  // should be recomputed.
	  TextMarker.prototype.changed = function () {
	    var this$1 = this;
	
	    var pos = this.find(-1, true),
	        widget = this,
	        cm = this.doc.cm;
	    if (!pos || !cm) {
	      return;
	    }
	    runInOp(cm, function () {
	      var line = pos.line,
	          lineN = lineNo(pos.line);
	      var view = findViewForLine(cm, lineN);
	      if (view) {
	        clearLineMeasurementCacheFor(view);
	        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
	      }
	      cm.curOp.updateMaxLine = true;
	      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	        var oldHeight = widget.height;
	        widget.height = null;
	        var dHeight = widgetHeight(widget) - oldHeight;
	        if (dHeight) {
	          updateLineHeight(line, line.height + dHeight);
	        }
	      }
	      signalLater(cm, "markerChanged", cm, this$1);
	    });
	  };
	
	  TextMarker.prototype.attachLine = function (line) {
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;
	      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) {
	        (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
	      }
	    }
	    this.lines.push(line);
	  };
	
	  TextMarker.prototype.detachLine = function (line) {
	    this.lines.splice(indexOf(this.lines, line), 1);
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
	    }
	  };
	  eventMixin(TextMarker);
	
	  // Create a marker, wire it up to the right lines, and
	  function _markText(doc, from, to, options, type) {
	    // Shared markers (across linked documents) are handled separately
	    // (markTextShared will call out to this again, once per
	    // document).
	    if (options && options.shared) {
	      return markTextShared(doc, from, to, options, type);
	    }
	    // Ensure we are in an operation.
	    if (doc.cm && !doc.cm.curOp) {
	      return operation(doc.cm, _markText)(doc, from, to, options, type);
	    }
	
	    var marker = new TextMarker(doc, type),
	        diff = cmp(from, to);
	    if (options) {
	      copyObj(options, marker, false);
	    }
	    // Don't connect empty markers unless clearWhenEmpty is false
	    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) {
	      return marker;
	    }
	    if (marker.replacedWith) {
	      // Showing up as a widget implies collapsed (widget replaces text)
	      marker.collapsed = true;
	      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
	      if (!options.handleMouseEvents) {
	        marker.widgetNode.setAttribute("cm-ignore-events", "true");
	      }
	      if (options.insertLeft) {
	        marker.widgetNode.insertLeft = true;
	      }
	    }
	    if (marker.collapsed) {
	      if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) {
	        throw new Error("Inserting collapsed marker partially overlapping an existing one");
	      }
	      seeCollapsedSpans();
	    }
	
	    if (marker.addToHistory) {
	      addChangeToHistory(doc, { from: from, to: to, origin: "markText" }, doc.sel, NaN);
	    }
	
	    var curLine = from.line,
	        cm = doc.cm,
	        updateMaxLine;
	    doc.iter(curLine, to.line + 1, function (line) {
	      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) {
	        updateMaxLine = true;
	      }
	      if (marker.collapsed && curLine != from.line) {
	        updateLineHeight(line, 0);
	      }
	      addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
	      ++curLine;
	    });
	    // lineIsHidden depends on the presence of the spans, so needs a second pass
	    if (marker.collapsed) {
	      doc.iter(from.line, to.line + 1, function (line) {
	        if (lineIsHidden(doc, line)) {
	          updateLineHeight(line, 0);
	        }
	      });
	    }
	
	    if (marker.clearOnEnter) {
	      on(marker, "beforeCursorEnter", function () {
	        return marker.clear();
	      });
	    }
	
	    if (marker.readOnly) {
	      seeReadOnlySpans();
	      if (doc.history.done.length || doc.history.undone.length) {
	        doc.clearHistory();
	      }
	    }
	    if (marker.collapsed) {
	      marker.id = ++nextMarkerId;
	      marker.atomic = true;
	    }
	    if (cm) {
	      // Sync editor state
	      if (updateMaxLine) {
	        cm.curOp.updateMaxLine = true;
	      }
	      if (marker.collapsed) {
	        regChange(cm, from.line, to.line + 1);
	      } else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) {
	        for (var i = from.line; i <= to.line; i++) {
	          regLineChange(cm, i, "text");
	        }
	      }
	      if (marker.atomic) {
	        reCheckSelection(cm.doc);
	      }
	      signalLater(cm, "markerAdded", cm, marker);
	    }
	    return marker;
	  }
	
	  // SHARED TEXTMARKERS
	
	  // A shared marker spans multiple linked documents. It is
	  // implemented as a meta-marker-object controlling multiple normal
	  // markers.
	  var SharedTextMarker = function SharedTextMarker(markers, primary) {
	    this.markers = markers;
	    this.primary = primary;
	    for (var i = 0; i < markers.length; ++i) {
	      markers[i].parent = this;
	    }
	  };
	
	  SharedTextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) {
	      return;
	    }
	    this.explicitlyCleared = true;
	    for (var i = 0; i < this.markers.length; ++i) {
	      this.markers[i].clear();
	    }
	    signalLater(this, "clear");
	  };
	
	  SharedTextMarker.prototype.find = function (side, lineObj) {
	    return this.primary.find(side, lineObj);
	  };
	  eventMixin(SharedTextMarker);
	
	  function markTextShared(doc, from, to, options, type) {
	    options = copyObj(options);
	    options.shared = false;
	    var markers = [_markText(doc, from, to, options, type)],
	        primary = markers[0];
	    var widget = options.widgetNode;
	    linkedDocs(doc, function (doc) {
	      if (widget) {
	        options.widgetNode = widget.cloneNode(true);
	      }
	      markers.push(_markText(doc, _clipPos(doc, from), _clipPos(doc, to), options, type));
	      for (var i = 0; i < doc.linked.length; ++i) {
	        if (doc.linked[i].isParent) {
	          return;
	        }
	      }
	      primary = lst(markers);
	    });
	    return new SharedTextMarker(markers, primary);
	  }
	
	  function findSharedMarkers(doc) {
	    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) {
	      return m.parent;
	    });
	  }
	
	  function copySharedMarkers(doc, markers) {
	    for (var i = 0; i < markers.length; i++) {
	      var marker = markers[i],
	          pos = marker.find();
	      var mFrom = doc.clipPos(pos.from),
	          mTo = doc.clipPos(pos.to);
	      if (cmp(mFrom, mTo)) {
	        var subMark = _markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
	        marker.markers.push(subMark);
	        subMark.parent = marker;
	      }
	    }
	  }
	
	  function detachSharedMarkers(markers) {
	    var loop = function loop(i) {
	      var marker = markers[i],
	          linked = [marker.primary.doc];
	      linkedDocs(marker.primary.doc, function (d) {
	        return linked.push(d);
	      });
	      for (var j = 0; j < marker.markers.length; j++) {
	        var subMarker = marker.markers[j];
	        if (indexOf(linked, subMarker.doc) == -1) {
	          subMarker.parent = null;
	          marker.markers.splice(j--, 1);
	        }
	      }
	    };
	
	    for (var i = 0; i < markers.length; i++) {
	      loop(i);
	    }
	  }
	
	  var nextDocId = 0;
	  var Doc = function Doc(text, mode, firstLine, lineSep, direction) {
	    if (!(this instanceof Doc)) {
	      return new Doc(text, mode, firstLine, lineSep, direction);
	    }
	    if (firstLine == null) {
	      firstLine = 0;
	    }
	
	    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
	    this.first = firstLine;
	    this.scrollTop = this.scrollLeft = 0;
	    this.cantEdit = false;
	    this.cleanGeneration = 1;
	    this.modeFrontier = this.highlightFrontier = firstLine;
	    var start = Pos(firstLine, 0);
	    this.sel = simpleSelection(start);
	    this.history = new History(null);
	    this.id = ++nextDocId;
	    this.modeOption = mode;
	    this.lineSep = lineSep;
	    this.direction = direction == "rtl" ? "rtl" : "ltr";
	    this.extend = false;
	
	    if (typeof text == "string") {
	      text = this.splitLines(text);
	    }
	    updateDoc(this, { from: start, to: start, text: text });
	    setSelection(this, simpleSelection(start), sel_dontScroll);
	  };
	
	  Doc.prototype = createObj(BranchChunk.prototype, {
	    constructor: Doc,
	    // Iterate over the document. Supports two forms -- with only one
	    // argument, it calls that for each line in the document. With
	    // three, it iterates over the range given by the first two (with
	    // the second being non-inclusive).
	    iter: function iter(from, to, op) {
	      if (op) {
	        this.iterN(from - this.first, to - from, op);
	      } else {
	        this.iterN(this.first, this.first + this.size, from);
	      }
	    },
	
	    // Non-public interface for adding and removing lines.
	    insert: function insert(at, lines) {
	      var height = 0;
	      for (var i = 0; i < lines.length; ++i) {
	        height += lines[i].height;
	      }
	      this.insertInner(at - this.first, lines, height);
	    },
	    remove: function remove(at, n) {
	      this.removeInner(at - this.first, n);
	    },
	
	    // From here, the methods are part of the public interface. Most
	    // are also available from CodeMirror (editor) instances.
	
	    getValue: function getValue(lineSep) {
	      var lines = getLines(this, this.first, this.first + this.size);
	      if (lineSep === false) {
	        return lines;
	      }
	      return lines.join(lineSep || this.lineSeparator());
	    },
	    setValue: docMethodOp(function (code) {
	      var top = Pos(this.first, 0),
	          last = this.first + this.size - 1;
	      makeChange(this, { from: top, to: Pos(last, getLine(this, last).text.length),
	        text: this.splitLines(code), origin: "setValue", full: true }, true);
	      if (this.cm) {
	        scrollToCoords(this.cm, 0, 0);
	      }
	      setSelection(this, simpleSelection(top), sel_dontScroll);
	    }),
	    replaceRange: function replaceRange(code, from, to, origin) {
	      from = _clipPos(this, from);
	      to = to ? _clipPos(this, to) : from;
	      _replaceRange(this, code, from, to, origin);
	    },
	    getRange: function getRange(from, to, lineSep) {
	      var lines = getBetween(this, _clipPos(this, from), _clipPos(this, to));
	      if (lineSep === false) {
	        return lines;
	      }
	      if (lineSep === '') {
	        return lines.join('');
	      }
	      return lines.join(lineSep || this.lineSeparator());
	    },
	
	    getLine: function getLine(line) {
	      var l = this.getLineHandle(line);return l && l.text;
	    },
	
	    getLineHandle: function getLineHandle(line) {
	      if (isLine(this, line)) {
	        return getLine(this, line);
	      }
	    },
	    getLineNumber: function getLineNumber(line) {
	      return lineNo(line);
	    },
	
	    getLineHandleVisualStart: function getLineHandleVisualStart(line) {
	      if (typeof line == "number") {
	        line = getLine(this, line);
	      }
	      return visualLine(line);
	    },
	
	    lineCount: function lineCount() {
	      return this.size;
	    },
	    firstLine: function firstLine() {
	      return this.first;
	    },
	    lastLine: function lastLine() {
	      return this.first + this.size - 1;
	    },
	
	    clipPos: function clipPos(pos) {
	      return _clipPos(this, pos);
	    },
	
	    getCursor: function getCursor(start) {
	      var range = this.sel.primary(),
	          pos;
	      if (start == null || start == "head") {
	        pos = range.head;
	      } else if (start == "anchor") {
	        pos = range.anchor;
	      } else if (start == "end" || start == "to" || start === false) {
	        pos = range.to();
	      } else {
	        pos = range.from();
	      }
	      return pos;
	    },
	    listSelections: function listSelections() {
	      return this.sel.ranges;
	    },
	    somethingSelected: function somethingSelected() {
	      return this.sel.somethingSelected();
	    },
	
	    setCursor: docMethodOp(function (line, ch, options) {
	      setSimpleSelection(this, _clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
	    }),
	    setSelection: docMethodOp(function (anchor, head, options) {
	      setSimpleSelection(this, _clipPos(this, anchor), _clipPos(this, head || anchor), options);
	    }),
	    extendSelection: docMethodOp(function (head, other, options) {
	      extendSelection(this, _clipPos(this, head), other && _clipPos(this, other), options);
	    }),
	    extendSelections: docMethodOp(function (heads, options) {
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    extendSelectionsBy: docMethodOp(function (f, options) {
	      var heads = map(this.sel.ranges, f);
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    setSelections: docMethodOp(function (ranges, primary, options) {
	      if (!ranges.length) {
	        return;
	      }
	      var out = [];
	      for (var i = 0; i < ranges.length; i++) {
	        out[i] = new Range(_clipPos(this, ranges[i].anchor), _clipPos(this, ranges[i].head || ranges[i].anchor));
	      }
	      if (primary == null) {
	        primary = Math.min(ranges.length - 1, this.sel.primIndex);
	      }
	      setSelection(this, normalizeSelection(this.cm, out, primary), options);
	    }),
	    addSelection: docMethodOp(function (anchor, head, options) {
	      var ranges = this.sel.ranges.slice(0);
	      ranges.push(new Range(_clipPos(this, anchor), _clipPos(this, head || anchor)));
	      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
	    }),
	
	    getSelection: function getSelection(lineSep) {
	      var ranges = this.sel.ranges,
	          lines;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        lines = lines ? lines.concat(sel) : sel;
	      }
	      if (lineSep === false) {
	        return lines;
	      } else {
	        return lines.join(lineSep || this.lineSeparator());
	      }
	    },
	    getSelections: function getSelections(lineSep) {
	      var parts = [],
	          ranges = this.sel.ranges;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        if (lineSep !== false) {
	          sel = sel.join(lineSep || this.lineSeparator());
	        }
	        parts[i] = sel;
	      }
	      return parts;
	    },
	    replaceSelection: function replaceSelection(code, collapse, origin) {
	      var dup = [];
	      for (var i = 0; i < this.sel.ranges.length; i++) {
	        dup[i] = code;
	      }
	      this.replaceSelections(dup, collapse, origin || "+input");
	    },
	    replaceSelections: docMethodOp(function (code, collapse, origin) {
	      var changes = [],
	          sel = this.sel;
	      for (var i = 0; i < sel.ranges.length; i++) {
	        var range = sel.ranges[i];
	        changes[i] = { from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin };
	      }
	      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
	      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--) {
	        makeChange(this, changes[i$1]);
	      }
	      if (newSel) {
	        setSelectionReplaceHistory(this, newSel);
	      } else if (this.cm) {
	        ensureCursorVisible(this.cm);
	      }
	    }),
	    undo: docMethodOp(function () {
	      makeChangeFromHistory(this, "undo");
	    }),
	    redo: docMethodOp(function () {
	      makeChangeFromHistory(this, "redo");
	    }),
	    undoSelection: docMethodOp(function () {
	      makeChangeFromHistory(this, "undo", true);
	    }),
	    redoSelection: docMethodOp(function () {
	      makeChangeFromHistory(this, "redo", true);
	    }),
	
	    setExtending: function setExtending(val) {
	      this.extend = val;
	    },
	    getExtending: function getExtending() {
	      return this.extend;
	    },
	
	    historySize: function historySize() {
	      var hist = this.history,
	          done = 0,
	          undone = 0;
	      for (var i = 0; i < hist.done.length; i++) {
	        if (!hist.done[i].ranges) {
	          ++done;
	        }
	      }
	      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) {
	        if (!hist.undone[i$1].ranges) {
	          ++undone;
	        }
	      }
	      return { undo: done, redo: undone };
	    },
	    clearHistory: function clearHistory() {
	      var this$1 = this;
	
	      this.history = new History(this.history);
	      linkedDocs(this, function (doc) {
	        return doc.history = this$1.history;
	      }, true);
	    },
	
	    markClean: function markClean() {
	      this.cleanGeneration = this.changeGeneration(true);
	    },
	    changeGeneration: function changeGeneration(forceSplit) {
	      if (forceSplit) {
	        this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
	      }
	      return this.history.generation;
	    },
	    isClean: function isClean(gen) {
	      return this.history.generation == (gen || this.cleanGeneration);
	    },
	
	    getHistory: function getHistory() {
	      return { done: copyHistoryArray(this.history.done),
	        undone: copyHistoryArray(this.history.undone) };
	    },
	    setHistory: function setHistory(histData) {
	      var hist = this.history = new History(this.history);
	      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
	      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
	    },
	
	    setGutterMarker: docMethodOp(function (line, gutterID, value) {
	      return changeLine(this, line, "gutter", function (line) {
	        var markers = line.gutterMarkers || (line.gutterMarkers = {});
	        markers[gutterID] = value;
	        if (!value && isEmpty(markers)) {
	          line.gutterMarkers = null;
	        }
	        return true;
	      });
	    }),
	
	    clearGutter: docMethodOp(function (gutterID) {
	      var this$1 = this;
	
	      this.iter(function (line) {
	        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	          changeLine(this$1, line, "gutter", function () {
	            line.gutterMarkers[gutterID] = null;
	            if (isEmpty(line.gutterMarkers)) {
	              line.gutterMarkers = null;
	            }
	            return true;
	          });
	        }
	      });
	    }),
	
	    lineInfo: function lineInfo(line) {
	      var n;
	      if (typeof line == "number") {
	        if (!isLine(this, line)) {
	          return null;
	        }
	        n = line;
	        line = getLine(this, line);
	        if (!line) {
	          return null;
	        }
	      } else {
	        n = lineNo(line);
	        if (n == null) {
	          return null;
	        }
	      }
	      return { line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	        textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	        widgets: line.widgets };
	    },
	
	    addLineClass: docMethodOp(function (handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
	        if (!line[prop]) {
	          line[prop] = cls;
	        } else if (classTest(cls).test(line[prop])) {
	          return false;
	        } else {
	          line[prop] += " " + cls;
	        }
	        return true;
	      });
	    }),
	    removeLineClass: docMethodOp(function (handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
	        var cur = line[prop];
	        if (!cur) {
	          return false;
	        } else if (cls == null) {
	          line[prop] = null;
	        } else {
	          var found = cur.match(classTest(cls));
	          if (!found) {
	            return false;
	          }
	          var end = found.index + found[0].length;
	          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
	        }
	        return true;
	      });
	    }),
	
	    addLineWidget: docMethodOp(function (handle, node, options) {
	      return addLineWidget(this, handle, node, options);
	    }),
	    removeLineWidget: function removeLineWidget(widget) {
	      widget.clear();
	    },
	
	    markText: function markText(from, to, options) {
	      return _markText(this, _clipPos(this, from), _clipPos(this, to), options, options && options.type || "range");
	    },
	    setBookmark: function setBookmark(pos, options) {
	      var realOpts = { replacedWith: options && (options.nodeType == null ? options.widget : options),
	        insertLeft: options && options.insertLeft,
	        clearWhenEmpty: false, shared: options && options.shared,
	        handleMouseEvents: options && options.handleMouseEvents };
	      pos = _clipPos(this, pos);
	      return _markText(this, pos, pos, realOpts, "bookmark");
	    },
	    findMarksAt: function findMarksAt(pos) {
	      pos = _clipPos(this, pos);
	      var markers = [],
	          spans = getLine(this, pos.line).markedSpans;
	      if (spans) {
	        for (var i = 0; i < spans.length; ++i) {
	          var span = spans[i];
	          if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) {
	            markers.push(span.marker.parent || span.marker);
	          }
	        }
	      }
	      return markers;
	    },
	    findMarks: function findMarks(from, to, filter) {
	      from = _clipPos(this, from);to = _clipPos(this, to);
	      var found = [],
	          lineNo = from.line;
	      this.iter(from.line, to.line + 1, function (line) {
	        var spans = line.markedSpans;
	        if (spans) {
	          for (var i = 0; i < spans.length; i++) {
	            var span = spans[i];
	            if (!(span.to != null && lineNo == from.line && from.ch >= span.to || span.from == null && lineNo != from.line || span.from != null && lineNo == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) {
	              found.push(span.marker.parent || span.marker);
	            }
	          }
	        }
	        ++lineNo;
	      });
	      return found;
	    },
	    getAllMarks: function getAllMarks() {
	      var markers = [];
	      this.iter(function (line) {
	        var sps = line.markedSpans;
	        if (sps) {
	          for (var i = 0; i < sps.length; ++i) {
	            if (sps[i].from != null) {
	              markers.push(sps[i].marker);
	            }
	          }
	        }
	      });
	      return markers;
	    },
	
	    posFromIndex: function posFromIndex(off) {
	      var ch,
	          lineNo = this.first,
	          sepSize = this.lineSeparator().length;
	      this.iter(function (line) {
	        var sz = line.text.length + sepSize;
	        if (sz > off) {
	          ch = off;return true;
	        }
	        off -= sz;
	        ++lineNo;
	      });
	      return _clipPos(this, Pos(lineNo, ch));
	    },
	    indexFromPos: function indexFromPos(coords) {
	      coords = _clipPos(this, coords);
	      var index = coords.ch;
	      if (coords.line < this.first || coords.ch < 0) {
	        return 0;
	      }
	      var sepSize = this.lineSeparator().length;
	      this.iter(this.first, coords.line, function (line) {
	        // iter aborts when callback returns a truthy value
	        index += line.text.length + sepSize;
	      });
	      return index;
	    },
	
	    copy: function copy(copyHistory) {
	      var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
	      doc.scrollTop = this.scrollTop;doc.scrollLeft = this.scrollLeft;
	      doc.sel = this.sel;
	      doc.extend = false;
	      if (copyHistory) {
	        doc.history.undoDepth = this.history.undoDepth;
	        doc.setHistory(this.getHistory());
	      }
	      return doc;
	    },
	
	    linkedDoc: function linkedDoc(options) {
	      if (!options) {
	        options = {};
	      }
	      var from = this.first,
	          to = this.first + this.size;
	      if (options.from != null && options.from > from) {
	        from = options.from;
	      }
	      if (options.to != null && options.to < to) {
	        to = options.to;
	      }
	      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
	      if (options.sharedHist) {
	        copy.history = this.history;
	      }(this.linked || (this.linked = [])).push({ doc: copy, sharedHist: options.sharedHist });
	      copy.linked = [{ doc: this, isParent: true, sharedHist: options.sharedHist }];
	      copySharedMarkers(copy, findSharedMarkers(this));
	      return copy;
	    },
	    unlinkDoc: function unlinkDoc(other) {
	      if (other instanceof CodeMirror) {
	        other = other.doc;
	      }
	      if (this.linked) {
	        for (var i = 0; i < this.linked.length; ++i) {
	          var link = this.linked[i];
	          if (link.doc != other) {
	            continue;
	          }
	          this.linked.splice(i, 1);
	          other.unlinkDoc(this);
	          detachSharedMarkers(findSharedMarkers(this));
	          break;
	        }
	      }
	      // If the histories were shared, split them again
	      if (other.history == this.history) {
	        var splitIds = [other.id];
	        linkedDocs(other, function (doc) {
	          return splitIds.push(doc.id);
	        }, true);
	        other.history = new History(null);
	        other.history.done = copyHistoryArray(this.history.done, splitIds);
	        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
	      }
	    },
	    iterLinkedDocs: function iterLinkedDocs(f) {
	      linkedDocs(this, f);
	    },
	
	    getMode: function getMode() {
	      return this.mode;
	    },
	    getEditor: function getEditor() {
	      return this.cm;
	    },
	
	    splitLines: function splitLines(str) {
	      if (this.lineSep) {
	        return str.split(this.lineSep);
	      }
	      return splitLinesAuto(str);
	    },
	    lineSeparator: function lineSeparator() {
	      return this.lineSep || "\n";
	    },
	
	    setDirection: docMethodOp(function (dir) {
	      if (dir != "rtl") {
	        dir = "ltr";
	      }
	      if (dir == this.direction) {
	        return;
	      }
	      this.direction = dir;
	      this.iter(function (line) {
	        return line.order = null;
	      });
	      if (this.cm) {
	        directionChanged(this.cm);
	      }
	    })
	  });
	
	  // Public alias.
	  Doc.prototype.eachLine = Doc.prototype.iter;
	
	  // Kludge to work around strange IE behavior where it'll sometimes
	  // re-fire a series of drag-related events right after the drop (#1551)
	  var lastDrop = 0;
	
	  function onDrop(e) {
	    var cm = this;
	    clearDragCursor(cm);
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
	      return;
	    }
	    e_preventDefault(e);
	    if (ie) {
	      lastDrop = +new Date();
	    }
	    var pos = posFromMouse(cm, e, true),
	        files = e.dataTransfer.files;
	    if (!pos || cm.isReadOnly()) {
	      return;
	    }
	    // Might be a file drop, in which case we simply extract the text
	    // and insert it.
	    if (files && files.length && window.FileReader && window.File) {
	      var n = files.length,
	          text = Array(n),
	          read = 0;
	      var markAsReadAndPasteIfAllFilesAreRead = function markAsReadAndPasteIfAllFilesAreRead() {
	        if (++read == n) {
	          operation(cm, function () {
	            pos = _clipPos(cm.doc, pos);
	            var change = { from: pos, to: pos,
	              text: cm.doc.splitLines(text.filter(function (t) {
	                return t != null;
	              }).join(cm.doc.lineSeparator())),
	              origin: "paste" };
	            makeChange(cm.doc, change);
	            setSelectionReplaceHistory(cm.doc, simpleSelection(_clipPos(cm.doc, pos), _clipPos(cm.doc, changeEnd(change))));
	          })();
	        }
	      };
	      var readTextFromFile = function readTextFromFile(file, i) {
	        if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
	          markAsReadAndPasteIfAllFilesAreRead();
	          return;
	        }
	        var reader = new FileReader();
	        reader.onerror = function () {
	          return markAsReadAndPasteIfAllFilesAreRead();
	        };
	        reader.onload = function () {
	          var content = reader.result;
	          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
	            markAsReadAndPasteIfAllFilesAreRead();
	            return;
	          }
	          text[i] = content;
	          markAsReadAndPasteIfAllFilesAreRead();
	        };
	        reader.readAsText(file);
	      };
	      for (var i = 0; i < files.length; i++) {
	        readTextFromFile(files[i], i);
	      }
	    } else {
	      // Normal drop
	      // Don't do a replace if the drop happened inside of the selected text.
	      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	        cm.state.draggingText(e);
	        // Ensure the editor is re-focused
	        setTimeout(function () {
	          return cm.display.input.focus();
	        }, 20);
	        return;
	      }
	      try {
	        var text$1 = e.dataTransfer.getData("Text");
	        if (text$1) {
	          var selected;
	          if (cm.state.draggingText && !cm.state.draggingText.copy) {
	            selected = cm.listSelections();
	          }
	          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
	          if (selected) {
	            for (var i$1 = 0; i$1 < selected.length; ++i$1) {
	              _replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
	            }
	          }
	          cm.replaceSelection(text$1, "around", "paste");
	          cm.display.input.focus();
	        }
	      } catch (e$1) {}
	    }
	  }
	
	  function onDragStart(cm, e) {
	    if (ie && (!cm.state.draggingText || +new Date() - lastDrop < 100)) {
	      e_stop(e);return;
	    }
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
	      return;
	    }
	
	    e.dataTransfer.setData("Text", cm.getSelection());
	    e.dataTransfer.effectAllowed = "copyMove";
	
	    // Use dummy image instead of default browsers image.
	    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	    if (e.dataTransfer.setDragImage && !safari) {
	      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
	      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	      if (presto) {
	        img.width = img.height = 1;
	        cm.display.wrapper.appendChild(img);
	        // Force a relayout, or Opera won't use our image for some obscure reason
	        img._top = img.offsetTop;
	      }
	      e.dataTransfer.setDragImage(img, 0, 0);
	      if (presto) {
	        img.parentNode.removeChild(img);
	      }
	    }
	  }
	
	  function onDragOver(cm, e) {
	    var pos = posFromMouse(cm, e);
	    if (!pos) {
	      return;
	    }
	    var frag = document.createDocumentFragment();
	    drawSelectionCursor(cm, pos, frag);
	    if (!cm.display.dragCursor) {
	      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
	      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
	    }
	    removeChildrenAndAdd(cm.display.dragCursor, frag);
	  }
	
	  function clearDragCursor(cm) {
	    if (cm.display.dragCursor) {
	      cm.display.lineSpace.removeChild(cm.display.dragCursor);
	      cm.display.dragCursor = null;
	    }
	  }
	
	  // These must be handled carefully, because naively registering a
	  // handler for each editor will cause the editors to never be
	  // garbage collected.
	
	  function forEachCodeMirror(f) {
	    if (!document.getElementsByClassName) {
	      return;
	    }
	    var byClass = document.getElementsByClassName("CodeMirror"),
	        editors = [];
	    for (var i = 0; i < byClass.length; i++) {
	      var cm = byClass[i].CodeMirror;
	      if (cm) {
	        editors.push(cm);
	      }
	    }
	    if (editors.length) {
	      editors[0].operation(function () {
	        for (var i = 0; i < editors.length; i++) {
	          f(editors[i]);
	        }
	      });
	    }
	  }
	
	  var globalsRegistered = false;
	  function ensureGlobalHandlers() {
	    if (globalsRegistered) {
	      return;
	    }
	    registerGlobalHandlers();
	    globalsRegistered = true;
	  }
	  function registerGlobalHandlers() {
	    // When the window resizes, we need to refresh active editors.
	    var resizeTimer;
	    on(window, "resize", function () {
	      if (resizeTimer == null) {
	        resizeTimer = setTimeout(function () {
	          resizeTimer = null;
	          forEachCodeMirror(onResize);
	        }, 100);
	      }
	    });
	    // When the window loses focus, we want to show the editor as blurred
	    on(window, "blur", function () {
	      return forEachCodeMirror(onBlur);
	    });
	  }
	  // Called when the window resizes
	  function onResize(cm) {
	    var d = cm.display;
	    // Might be a text scaling operation, clear size caches.
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	    d.scrollbarsClipped = false;
	    cm.setSize();
	  }
	
	  var keyNames = {
	    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
	    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	    221: "]", 222: "'", 224: "Mod", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	  };
	
	  // Number keys
	  for (var i = 0; i < 10; i++) {
	    keyNames[i + 48] = keyNames[i + 96] = String(i);
	  }
	  // Alphabetic keys
	  for (var i$1 = 65; i$1 <= 90; i$1++) {
	    keyNames[i$1] = String.fromCharCode(i$1);
	  }
	  // Function keys
	  for (var i$2 = 1; i$2 <= 12; i$2++) {
	    keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
	  }
	
	  var keyMap = {};
	
	  keyMap.basic = {
	    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	    "Esc": "singleSelection"
	  };
	  // Note that the save and find-related commands aren't defined by
	  // default. User code or addons can define them. Unknown commands
	  // are simply ignored.
	  keyMap.pcDefault = {
	    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	    "fallthrough": "basic"
	  };
	  // Very basic readline/emacs-style bindings, which are standard on Mac.
	  keyMap.emacsy = {
	    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	    "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd", "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp",
	    "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine",
	    "Ctrl-T": "transposeChars", "Ctrl-O": "openLine"
	  };
	  keyMap.macDefault = {
	    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	    "fallthrough": ["basic", "emacsy"]
	  };
	  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
	
	  // KEYMAP DISPATCH
	
	  function normalizeKeyName(name) {
	    var parts = name.split(/-(?!$)/);
	    name = parts[parts.length - 1];
	    var alt, ctrl, shift, cmd;
	    for (var i = 0; i < parts.length - 1; i++) {
	      var mod = parts[i];
	      if (/^(cmd|meta|m)$/i.test(mod)) {
	        cmd = true;
	      } else if (/^a(lt)?$/i.test(mod)) {
	        alt = true;
	      } else if (/^(c|ctrl|control)$/i.test(mod)) {
	        ctrl = true;
	      } else if (/^s(hift)?$/i.test(mod)) {
	        shift = true;
	      } else {
	        throw new Error("Unrecognized modifier name: " + mod);
	      }
	    }
	    if (alt) {
	      name = "Alt-" + name;
	    }
	    if (ctrl) {
	      name = "Ctrl-" + name;
	    }
	    if (cmd) {
	      name = "Cmd-" + name;
	    }
	    if (shift) {
	      name = "Shift-" + name;
	    }
	    return name;
	  }
	
	  // This is a kludge to keep keymaps mostly working as raw objects
	  // (backwards compatibility) while at the same time support features
	  // like normalization and multi-stroke key bindings. It compiles a
	  // new normalized keymap, and then updates the old object to reflect
	  // this.
	  function normalizeKeyMap(keymap) {
	    var copy = {};
	    for (var keyname in keymap) {
	      if (keymap.hasOwnProperty(keyname)) {
	        var value = keymap[keyname];
	        if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) {
	          continue;
	        }
	        if (value == "...") {
	          delete keymap[keyname];continue;
	        }
	
	        var keys = map(keyname.split(" "), normalizeKeyName);
	        for (var i = 0; i < keys.length; i++) {
	          var val = void 0,
	              name = void 0;
	          if (i == keys.length - 1) {
	            name = keys.join(" ");
	            val = value;
	          } else {
	            name = keys.slice(0, i + 1).join(" ");
	            val = "...";
	          }
	          var prev = copy[name];
	          if (!prev) {
	            copy[name] = val;
	          } else if (prev != val) {
	            throw new Error("Inconsistent bindings for " + name);
	          }
	        }
	        delete keymap[keyname];
	      }
	    }
	    for (var prop in copy) {
	      keymap[prop] = copy[prop];
	    }
	    return keymap;
	  }
	
	  function lookupKey(key, map, handle, context) {
	    map = getKeyMap(map);
	    var found = map.call ? map.call(key, context) : map[key];
	    if (found === false) {
	      return "nothing";
	    }
	    if (found === "...") {
	      return "multi";
	    }
	    if (found != null && handle(found)) {
	      return "handled";
	    }
	
	    if (map.fallthrough) {
	      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]") {
	        return lookupKey(key, map.fallthrough, handle, context);
	      }
	      for (var i = 0; i < map.fallthrough.length; i++) {
	        var result = lookupKey(key, map.fallthrough[i], handle, context);
	        if (result) {
	          return result;
	        }
	      }
	    }
	  }
	
	  // Modifier key presses don't count as 'real' key presses for the
	  // purpose of keymap fallthrough.
	  function isModifierKey(value) {
	    var name = typeof value == "string" ? value : keyNames[value.keyCode];
	    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
	  }
	
	  function addModifierNames(name, event, noShift) {
	    var base = name;
	    if (event.altKey && base != "Alt") {
	      name = "Alt-" + name;
	    }
	    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") {
	      name = "Ctrl-" + name;
	    }
	    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") {
	      name = "Cmd-" + name;
	    }
	    if (!noShift && event.shiftKey && base != "Shift") {
	      name = "Shift-" + name;
	    }
	    return name;
	  }
	
	  // Look up the name of a key as indicated by an event object.
	  function keyName(event, noShift) {
	    if (presto && event.keyCode == 34 && event["char"]) {
	      return false;
	    }
	    var name = keyNames[event.keyCode];
	    if (name == null || event.altGraphKey) {
	      return false;
	    }
	    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
	    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
	    if (event.keyCode == 3 && event.code) {
	      name = event.code;
	    }
	    return addModifierNames(name, event, noShift);
	  }
	
	  function getKeyMap(val) {
	    return typeof val == "string" ? keyMap[val] : val;
	  }
	
	  // Helper for deleting text near the selection(s), used to implement
	  // backspace, delete, and similar functionality.
	  function deleteNearSelection(cm, compute) {
	    var ranges = cm.doc.sel.ranges,
	        kill = [];
	    // Build up a set of ranges to kill first, merging overlapping
	    // ranges.
	    for (var i = 0; i < ranges.length; i++) {
	      var toKill = compute(ranges[i]);
	      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	        var replaced = kill.pop();
	        if (cmp(replaced.from, toKill.from) < 0) {
	          toKill.from = replaced.from;
	          break;
	        }
	      }
	      kill.push(toKill);
	    }
	    // Next, remove those actual ranges.
	    runInOp(cm, function () {
	      for (var i = kill.length - 1; i >= 0; i--) {
	        _replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
	      }
	      ensureCursorVisible(cm);
	    });
	  }
	
	  function moveCharLogically(line, ch, dir) {
	    var target = skipExtendingChars(line.text, ch + dir, dir);
	    return target < 0 || target > line.text.length ? null : target;
	  }
	
	  function moveLogically(line, start, dir) {
	    var ch = moveCharLogically(line, start.ch, dir);
	    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
	  }
	
	  function endOfLine(visually, cm, lineObj, lineNo, dir) {
	    if (visually) {
	      if (cm.doc.direction == "rtl") {
	        dir = -dir;
	      }
	      var order = getOrder(lineObj, cm.doc.direction);
	      if (order) {
	        var part = dir < 0 ? lst(order) : order[0];
	        var moveInStorageOrder = dir < 0 == (part.level == 1);
	        var sticky = moveInStorageOrder ? "after" : "before";
	        var ch;
	        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
	        // it could be that the last bidi part is not on the last visual line,
	        // since visual lines contain content order-consecutive chunks.
	        // Thus, in rtl, we are looking for the first (content-order) character
	        // in the rtl chunk that is on the last line (that is, the same line
	        // as the last (content-order) character).
	        if (part.level > 0 || cm.doc.direction == "rtl") {
	          var prep = prepareMeasureForLine(cm, lineObj);
	          ch = dir < 0 ? lineObj.text.length - 1 : 0;
	          var targetTop = measureCharPrepared(cm, prep, ch).top;
	          ch = findFirst(function (ch) {
	            return measureCharPrepared(cm, prep, ch).top == targetTop;
	          }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
	          if (sticky == "before") {
	            ch = moveCharLogically(lineObj, ch, 1);
	          }
	        } else {
	          ch = dir < 0 ? part.to : part.from;
	        }
	        return new Pos(lineNo, ch, sticky);
	      }
	    }
	    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
	  }
	
	  function moveVisually(cm, line, start, dir) {
	    var bidi = getOrder(line, cm.doc.direction);
	    if (!bidi) {
	      return moveLogically(line, start, dir);
	    }
	    if (start.ch >= line.text.length) {
	      start.ch = line.text.length;
	      start.sticky = "before";
	    } else if (start.ch <= 0) {
	      start.ch = 0;
	      start.sticky = "after";
	    }
	    var partPos = getBidiPartAt(bidi, start.ch, start.sticky),
	        part = bidi[partPos];
	    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
	      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
	      // nothing interesting happens.
	      return moveLogically(line, start, dir);
	    }
	
	    var mv = function mv(pos, dir) {
	      return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir);
	    };
	    var prep;
	    var getWrappedLineExtent = function getWrappedLineExtent(ch) {
	      if (!cm.options.lineWrapping) {
	        return { begin: 0, end: line.text.length };
	      }
	      prep = prep || prepareMeasureForLine(cm, line);
	      return wrappedLineExtentChar(cm, line, prep, ch);
	    };
	    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
	
	    if (cm.doc.direction == "rtl" || part.level == 1) {
	      var moveInStorageOrder = part.level == 1 == dir < 0;
	      var ch = mv(start, moveInStorageOrder ? 1 : -1);
	      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
	        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
	        var sticky = moveInStorageOrder ? "before" : "after";
	        return new Pos(start.line, ch, sticky);
	      }
	    }
	
	    // Case 3: Could not move within this bidi part in this visual line, so leave
	    // the current bidi part
	
	    var searchInVisualLine = function searchInVisualLine(partPos, dir, wrappedLineExtent) {
	      var getRes = function getRes(ch, moveInStorageOrder) {
	        return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
	      };
	
	      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
	        var part = bidi[partPos];
	        var moveInStorageOrder = dir > 0 == (part.level != 1);
	        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
	        if (part.from <= ch && ch < part.to) {
	          return getRes(ch, moveInStorageOrder);
	        }
	        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
	        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) {
	          return getRes(ch, moveInStorageOrder);
	        }
	      }
	    };
	
	    // Case 3a: Look for other bidi parts on the same visual line
	    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
	    if (res) {
	      return res;
	    }
	
	    // Case 3b: Look for other bidi parts on the next visual line
	    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
	    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
	      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
	      if (res) {
	        return res;
	      }
	    }
	
	    // Case 4: Nowhere to move
	    return null;
	  }
	
	  // Commands are parameter-less actions that can be performed on an
	  // editor, mostly used for keybindings.
	  var commands = {
	    selectAll: selectAll,
	    singleSelection: function singleSelection(cm) {
	      return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
	    },
	    killLine: function killLine(cm) {
	      return deleteNearSelection(cm, function (range) {
	        if (range.empty()) {
	          var len = getLine(cm.doc, range.head.line).text.length;
	          if (range.head.ch == len && range.head.line < cm.lastLine()) {
	            return { from: range.head, to: Pos(range.head.line + 1, 0) };
	          } else {
	            return { from: range.head, to: Pos(range.head.line, len) };
	          }
	        } else {
	          return { from: range.from(), to: range.to() };
	        }
	      });
	    },
	    deleteLine: function deleteLine(cm) {
	      return deleteNearSelection(cm, function (range) {
	        return {
	          from: Pos(range.from().line, 0),
	          to: _clipPos(cm.doc, Pos(range.to().line + 1, 0))
	        };
	      });
	    },
	    delLineLeft: function delLineLeft(cm) {
	      return deleteNearSelection(cm, function (range) {
	        return {
	          from: Pos(range.from().line, 0), to: range.from()
	        };
	      });
	    },
	    delWrappedLineLeft: function delWrappedLineLeft(cm) {
	      return deleteNearSelection(cm, function (range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var leftPos = cm.coordsChar({ left: 0, top: top }, "div");
	        return { from: leftPos, to: range.from() };
	      });
	    },
	    delWrappedLineRight: function delWrappedLineRight(cm) {
	      return deleteNearSelection(cm, function (range) {
	        var top = cm.charCoords(range.head, "div").top + 5;
	        var rightPos = cm.coordsChar({ left: cm.display.lineDiv.offsetWidth + 100, top: top }, "div");
	        return { from: range.from(), to: rightPos };
	      });
	    },
	    undo: function undo(cm) {
	      return cm.undo();
	    },
	    redo: function redo(cm) {
	      return cm.redo();
	    },
	    undoSelection: function undoSelection(cm) {
	      return cm.undoSelection();
	    },
	    redoSelection: function redoSelection(cm) {
	      return cm.redoSelection();
	    },
	    goDocStart: function goDocStart(cm) {
	      return cm.extendSelection(Pos(cm.firstLine(), 0));
	    },
	    goDocEnd: function goDocEnd(cm) {
	      return cm.extendSelection(Pos(cm.lastLine()));
	    },
	    goLineStart: function goLineStart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineStart(cm, range.head.line);
	      }, { origin: "+move", bias: 1 });
	    },
	    goLineStartSmart: function goLineStartSmart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineStartSmart(cm, range.head);
	      }, { origin: "+move", bias: 1 });
	    },
	    goLineEnd: function goLineEnd(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        return lineEnd(cm, range.head.line);
	      }, { origin: "+move", bias: -1 });
	    },
	    goLineRight: function goLineRight(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        return cm.coordsChar({ left: cm.display.lineDiv.offsetWidth + 100, top: top }, "div");
	      }, sel_move);
	    },
	    goLineLeft: function goLineLeft(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        return cm.coordsChar({ left: 0, top: top }, "div");
	      }, sel_move);
	    },
	    goLineLeftSmart: function goLineLeftSmart(cm) {
	      return cm.extendSelectionsBy(function (range) {
	        var top = cm.cursorCoords(range.head, "div").top + 5;
	        var pos = cm.coordsChar({ left: 0, top: top }, "div");
	        if (pos.ch < cm.getLine(pos.line).search(/\S/)) {
	          return lineStartSmart(cm, range.head);
	        }
	        return pos;
	      }, sel_move);
	    },
	    goLineUp: function goLineUp(cm) {
	      return cm.moveV(-1, "line");
	    },
	    goLineDown: function goLineDown(cm) {
	      return cm.moveV(1, "line");
	    },
	    goPageUp: function goPageUp(cm) {
	      return cm.moveV(-1, "page");
	    },
	    goPageDown: function goPageDown(cm) {
	      return cm.moveV(1, "page");
	    },
	    goCharLeft: function goCharLeft(cm) {
	      return cm.moveH(-1, "char");
	    },
	    goCharRight: function goCharRight(cm) {
	      return cm.moveH(1, "char");
	    },
	    goColumnLeft: function goColumnLeft(cm) {
	      return cm.moveH(-1, "column");
	    },
	    goColumnRight: function goColumnRight(cm) {
	      return cm.moveH(1, "column");
	    },
	    goWordLeft: function goWordLeft(cm) {
	      return cm.moveH(-1, "word");
	    },
	    goGroupRight: function goGroupRight(cm) {
	      return cm.moveH(1, "group");
	    },
	    goGroupLeft: function goGroupLeft(cm) {
	      return cm.moveH(-1, "group");
	    },
	    goWordRight: function goWordRight(cm) {
	      return cm.moveH(1, "word");
	    },
	    delCharBefore: function delCharBefore(cm) {
	      return cm.deleteH(-1, "codepoint");
	    },
	    delCharAfter: function delCharAfter(cm) {
	      return cm.deleteH(1, "char");
	    },
	    delWordBefore: function delWordBefore(cm) {
	      return cm.deleteH(-1, "word");
	    },
	    delWordAfter: function delWordAfter(cm) {
	      return cm.deleteH(1, "word");
	    },
	    delGroupBefore: function delGroupBefore(cm) {
	      return cm.deleteH(-1, "group");
	    },
	    delGroupAfter: function delGroupAfter(cm) {
	      return cm.deleteH(1, "group");
	    },
	    indentAuto: function indentAuto(cm) {
	      return cm.indentSelection("smart");
	    },
	    indentMore: function indentMore(cm) {
	      return cm.indentSelection("add");
	    },
	    indentLess: function indentLess(cm) {
	      return cm.indentSelection("subtract");
	    },
	    insertTab: function insertTab(cm) {
	      return cm.replaceSelection("\t");
	    },
	    insertSoftTab: function insertSoftTab(cm) {
	      var spaces = [],
	          ranges = cm.listSelections(),
	          tabSize = cm.options.tabSize;
	      for (var i = 0; i < ranges.length; i++) {
	        var pos = ranges[i].from();
	        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
	        spaces.push(spaceStr(tabSize - col % tabSize));
	      }
	      cm.replaceSelections(spaces);
	    },
	    defaultTab: function defaultTab(cm) {
	      if (cm.somethingSelected()) {
	        cm.indentSelection("add");
	      } else {
	        cm.execCommand("insertTab");
	      }
	    },
	    // Swap the two chars left and right of each selection's head.
	    // Move cursor behind the two swapped characters afterwards.
	    //
	    // Doesn't consider line feeds a character.
	    // Doesn't scan more than one line above to find a character.
	    // Doesn't do anything on an empty line.
	    // Doesn't do anything with non-empty selections.
	    transposeChars: function transposeChars(cm) {
	      return runInOp(cm, function () {
	        var ranges = cm.listSelections(),
	            newSel = [];
	        for (var i = 0; i < ranges.length; i++) {
	          if (!ranges[i].empty()) {
	            continue;
	          }
	          var cur = ranges[i].head,
	              line = getLine(cm.doc, cur.line).text;
	          if (line) {
	            if (cur.ch == line.length) {
	              cur = new Pos(cur.line, cur.ch - 1);
	            }
	            if (cur.ch > 0) {
	              cur = new Pos(cur.line, cur.ch + 1);
	              cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
	            } else if (cur.line > cm.doc.first) {
	              var prev = getLine(cm.doc, cur.line - 1).text;
	              if (prev) {
	                cur = new Pos(cur.line, 1);
	                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
	              }
	            }
	          }
	          newSel.push(new Range(cur, cur));
	        }
	        cm.setSelections(newSel);
	      });
	    },
	    newlineAndIndent: function newlineAndIndent(cm) {
	      return runInOp(cm, function () {
	        var sels = cm.listSelections();
	        for (var i = sels.length - 1; i >= 0; i--) {
	          cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
	        }
	        sels = cm.listSelections();
	        for (var i$1 = 0; i$1 < sels.length; i$1++) {
	          cm.indentLine(sels[i$1].from().line, null, true);
	        }
	        ensureCursorVisible(cm);
	      });
	    },
	    openLine: function openLine(cm) {
	      return cm.replaceSelection("\n", "start");
	    },
	    toggleOverwrite: function toggleOverwrite(cm) {
	      return cm.toggleOverwrite();
	    }
	  };
	
	  function lineStart(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLine(line);
	    if (visual != line) {
	      lineN = lineNo(visual);
	    }
	    return endOfLine(true, cm, visual, lineN, 1);
	  }
	  function lineEnd(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLineEnd(line);
	    if (visual != line) {
	      lineN = lineNo(visual);
	    }
	    return endOfLine(true, cm, line, lineN, -1);
	  }
	  function lineStartSmart(cm, pos) {
	    var start = lineStart(cm, pos.line);
	    var line = getLine(cm.doc, start.line);
	    var order = getOrder(line, cm.doc.direction);
	    if (!order || order[0].level == 0) {
	      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
	      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
	      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
	    }
	    return start;
	  }
	
	  // Run a handler that was bound to a key.
	  function doHandleBinding(cm, bound, dropShift) {
	    if (typeof bound == "string") {
	      bound = commands[bound];
	      if (!bound) {
	        return false;
	      }
	    }
	    // Ensure previous input has been read, so that the handler sees a
	    // consistent view of the document
	    cm.display.input.ensurePolled();
	    var prevShift = cm.display.shift,
	        done = false;
	    try {
	      if (cm.isReadOnly()) {
	        cm.state.suppressEdits = true;
	      }
	      if (dropShift) {
	        cm.display.shift = false;
	      }
	      done = bound(cm) != Pass;
	    } finally {
	      cm.display.shift = prevShift;
	      cm.state.suppressEdits = false;
	    }
	    return done;
	  }
	
	  function lookupKeyForEditor(cm, name, handle) {
	    for (var i = 0; i < cm.state.keyMaps.length; i++) {
	      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
	      if (result) {
	        return result;
	      }
	    }
	    return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
	  }
	
	  // Note that, despite the name, this function is also used to check
	  // for bound mouse clicks.
	
	  var stopSeq = new Delayed();
	
	  function dispatchKey(cm, name, e, handle) {
	    var seq = cm.state.keySeq;
	    if (seq) {
	      if (isModifierKey(name)) {
	        return "handled";
	      }
	      if (/\'$/.test(name)) {
	        cm.state.keySeq = null;
	      } else {
	        stopSeq.set(50, function () {
	          if (cm.state.keySeq == seq) {
	            cm.state.keySeq = null;
	            cm.display.input.reset();
	          }
	        });
	      }
	      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) {
	        return true;
	      }
	    }
	    return dispatchKeyInner(cm, name, e, handle);
	  }
	
	  function dispatchKeyInner(cm, name, e, handle) {
	    var result = lookupKeyForEditor(cm, name, handle);
	
	    if (result == "multi") {
	      cm.state.keySeq = name;
	    }
	    if (result == "handled") {
	      signalLater(cm, "keyHandled", cm, name, e);
	    }
	
	    if (result == "handled" || result == "multi") {
	      e_preventDefault(e);
	      restartBlink(cm);
	    }
	
	    return !!result;
	  }
	
	  // Handle a key from the keydown event.
	  function handleKeyBinding(cm, e) {
	    var name = keyName(e, true);
	    if (!name) {
	      return false;
	    }
	
	    if (e.shiftKey && !cm.state.keySeq) {
	      // First try to resolve full name (including 'Shift-'). Failing
	      // that, see if there is a cursor-motion command (starting with
	      // 'go') bound to the keyname without 'Shift-'.
	      return dispatchKey(cm, "Shift-" + name, e, function (b) {
	        return doHandleBinding(cm, b, true);
	      }) || dispatchKey(cm, name, e, function (b) {
	        if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) {
	          return doHandleBinding(cm, b);
	        }
	      });
	    } else {
	      return dispatchKey(cm, name, e, function (b) {
	        return doHandleBinding(cm, b);
	      });
	    }
	  }
	
	  // Handle a key from the keypress event
	  function handleCharBinding(cm, e, ch) {
	    return dispatchKey(cm, "'" + ch + "'", e, function (b) {
	      return doHandleBinding(cm, b, true);
	    });
	  }
	
	  var lastStoppedKey = null;
	  function onKeyDown(e) {
	    var cm = this;
	    if (e.target && e.target != cm.display.input.getField()) {
	      return;
	    }
	    cm.curOp.focus = activeElt(root(cm));
	    if (signalDOMEvent(cm, e)) {
	      return;
	    }
	    // IE does strange things with escape.
	    if (ie && ie_version < 11 && e.keyCode == 27) {
	      e.returnValue = false;
	    }
	    var code = e.keyCode;
	    cm.display.shift = code == 16 || e.shiftKey;
	    var handled = handleKeyBinding(cm, e);
	    if (presto) {
	      lastStoppedKey = handled ? code : null;
	      // Opera has no cut event... we try to at least catch the key combo
	      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) {
	        cm.replaceSelection("", null, "cut");
	      }
	    }
	    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand) {
	      document.execCommand("cut");
	    }
	
	    // Turn mouse into crosshair when Alt is held on Mac.
	    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) {
	      showCrossHair(cm);
	    }
	  }
	
	  function showCrossHair(cm) {
	    var lineDiv = cm.display.lineDiv;
	    addClass(lineDiv, "CodeMirror-crosshair");
	
	    function up(e) {
	      if (e.keyCode == 18 || !e.altKey) {
	        rmClass(lineDiv, "CodeMirror-crosshair");
	        off(document, "keyup", up);
	        off(document, "mouseover", up);
	      }
	    }
	    on(document, "keyup", up);
	    on(document, "mouseover", up);
	  }
	
	  function onKeyUp(e) {
	    if (e.keyCode == 16) {
	      this.doc.sel.shift = false;
	    }
	    signalDOMEvent(this, e);
	  }
	
	  function onKeyPress(e) {
	    var cm = this;
	    if (e.target && e.target != cm.display.input.getField()) {
	      return;
	    }
	    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) {
	      return;
	    }
	    var keyCode = e.keyCode,
	        charCode = e.charCode;
	    if (presto && keyCode == lastStoppedKey) {
	      lastStoppedKey = null;e_preventDefault(e);return;
	    }
	    if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) {
	      return;
	    }
	    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
	    // Some browsers fire keypress events for backspace
	    if (ch == "\x08") {
	      return;
	    }
	    if (handleCharBinding(cm, e, ch)) {
	      return;
	    }
	    cm.display.input.onKeyPress(e);
	  }
	
	  var DOUBLECLICK_DELAY = 400;
	
	  var PastClick = function PastClick(time, pos, button) {
	    this.time = time;
	    this.pos = pos;
	    this.button = button;
	  };
	
	  PastClick.prototype.compare = function (time, pos, button) {
	    return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
	  };
	
	  var lastClick, lastDoubleClick;
	  function clickRepeat(pos, button) {
	    var now = +new Date();
	    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
	      lastClick = lastDoubleClick = null;
	      return "triple";
	    } else if (lastClick && lastClick.compare(now, pos, button)) {
	      lastDoubleClick = new PastClick(now, pos, button);
	      lastClick = null;
	      return "double";
	    } else {
	      lastClick = new PastClick(now, pos, button);
	      lastDoubleClick = null;
	      return "single";
	    }
	  }
	
	  // A mouse down can be a single click, double click, triple click,
	  // start of selection drag, start of text drag, new cursor
	  // (ctrl-click), rectangle drag (alt-drag), or xwin
	  // middle-click-paste. Or it might be a click on something we should
	  // not interfere with, such as a scrollbar or widget.
	  function onMouseDown(e) {
	    var cm = this,
	        display = cm.display;
	    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) {
	      return;
	    }
	    display.input.ensurePolled();
	    display.shift = e.shiftKey;
	
	    if (eventInWidget(display, e)) {
	      if (!webkit) {
	        // Briefly turn off draggability, to allow widgets to do
	        // normal dragging things.
	        display.scroller.draggable = false;
	        setTimeout(function () {
	          return display.scroller.draggable = true;
	        }, 100);
	      }
	      return;
	    }
	    if (clickInGutter(cm, e)) {
	      return;
	    }
	    var pos = posFromMouse(cm, e),
	        button = e_button(e),
	        repeat = pos ? clickRepeat(pos, button) : "single";
	    win(cm).focus();
	
	    // #3261: make sure, that we're not starting a second selection
	    if (button == 1 && cm.state.selectingText) {
	      cm.state.selectingText(e);
	    }
	
	    if (pos && handleMappedButton(cm, button, pos, repeat, e)) {
	      return;
	    }
	
	    if (button == 1) {
	      if (pos) {
	        leftButtonDown(cm, pos, repeat, e);
	      } else if (e_target(e) == display.scroller) {
	        e_preventDefault(e);
	      }
	    } else if (button == 2) {
	      if (pos) {
	        extendSelection(cm.doc, pos);
	      }
	      setTimeout(function () {
	        return display.input.focus();
	      }, 20);
	    } else if (button == 3) {
	      if (captureRightClick) {
	        cm.display.input.onContextMenu(e);
	      } else {
	        delayBlurEvent(cm);
	      }
	    }
	  }
	
	  function handleMappedButton(cm, button, pos, repeat, event) {
	    var name = "Click";
	    if (repeat == "double") {
	      name = "Double" + name;
	    } else if (repeat == "triple") {
	      name = "Triple" + name;
	    }
	    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
	
	    return dispatchKey(cm, addModifierNames(name, event), event, function (bound) {
	      if (typeof bound == "string") {
	        bound = commands[bound];
	      }
	      if (!bound) {
	        return false;
	      }
	      var done = false;
	      try {
	        if (cm.isReadOnly()) {
	          cm.state.suppressEdits = true;
	        }
	        done = bound(cm, pos) != Pass;
	      } finally {
	        cm.state.suppressEdits = false;
	      }
	      return done;
	    });
	  }
	
	  function configureMouse(cm, repeat, event) {
	    var option = cm.getOption("configureMouse");
	    var value = option ? option(cm, repeat, event) : {};
	    if (value.unit == null) {
	      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
	      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
	    }
	    if (value.extend == null || cm.doc.extend) {
	      value.extend = cm.doc.extend || event.shiftKey;
	    }
	    if (value.addNew == null) {
	      value.addNew = mac ? event.metaKey : event.ctrlKey;
	    }
	    if (value.moveOnDrag == null) {
	      value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
	    }
	    return value;
	  }
	
	  function leftButtonDown(cm, pos, repeat, event) {
	    if (ie) {
	      setTimeout(bind(ensureFocus, cm), 0);
	    } else {
	      cm.curOp.focus = activeElt(root(cm));
	    }
	
	    var behavior = configureMouse(cm, repeat, event);
	
	    var sel = cm.doc.sel,
	        contained;
	    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) {
	      leftButtonStartDrag(cm, event, pos, behavior);
	    } else {
	      leftButtonSelect(cm, event, pos, behavior);
	    }
	  }
	
	  // Start a text drag. When it ends, see if any dragging actually
	  // happen, and treat as a click if it didn't.
	  function leftButtonStartDrag(cm, event, pos, behavior) {
	    var display = cm.display,
	        moved = false;
	    var dragEnd = operation(cm, function (e) {
	      if (webkit) {
	        display.scroller.draggable = false;
	      }
	      cm.state.draggingText = false;
	      if (cm.state.delayingBlurEvent) {
	        if (cm.hasFocus()) {
	          cm.state.delayingBlurEvent = false;
	        } else {
	          delayBlurEvent(cm);
	        }
	      }
	      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
	      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
	      off(display.scroller, "dragstart", dragStart);
	      off(display.scroller, "drop", dragEnd);
	      if (!moved) {
	        e_preventDefault(e);
	        if (!behavior.addNew) {
	          extendSelection(cm.doc, pos, null, null, behavior.extend);
	        }
	        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	        if (webkit && !safari || ie && ie_version == 9) {
	          setTimeout(function () {
	            display.wrapper.ownerDocument.body.focus({ preventScroll: true });display.input.focus();
	          }, 20);
	        } else {
	          display.input.focus();
	        }
	      }
	    });
	    var mouseMove = function mouseMove(e2) {
	      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
	    };
	    var dragStart = function dragStart() {
	      return moved = true;
	    };
	    // Let the drag handler handle this.
	    if (webkit) {
	      display.scroller.draggable = true;
	    }
	    cm.state.draggingText = dragEnd;
	    dragEnd.copy = !behavior.moveOnDrag;
	    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
	    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
	    on(display.scroller, "dragstart", dragStart);
	    on(display.scroller, "drop", dragEnd);
	
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () {
	      return display.input.focus();
	    }, 20);
	    // IE's approach to draggable
	    if (display.scroller.dragDrop) {
	      display.scroller.dragDrop();
	    }
	  }
	
	  function rangeForUnit(cm, pos, unit) {
	    if (unit == "char") {
	      return new Range(pos, pos);
	    }
	    if (unit == "word") {
	      return cm.findWordAt(pos);
	    }
	    if (unit == "line") {
	      return new Range(Pos(pos.line, 0), _clipPos(cm.doc, Pos(pos.line + 1, 0)));
	    }
	    var result = unit(cm, pos);
	    return new Range(result.from, result.to);
	  }
	
	  // Normal selection, as opposed to text dragging.
	  function leftButtonSelect(cm, event, start, behavior) {
	    if (ie) {
	      delayBlurEvent(cm);
	    }
	    var display = cm.display,
	        doc = cm.doc;
	    e_preventDefault(event);
	
	    var ourRange,
	        ourIndex,
	        startSel = doc.sel,
	        ranges = startSel.ranges;
	    if (behavior.addNew && !behavior.extend) {
	      ourIndex = doc.sel.contains(start);
	      if (ourIndex > -1) {
	        ourRange = ranges[ourIndex];
	      } else {
	        ourRange = new Range(start, start);
	      }
	    } else {
	      ourRange = doc.sel.primary();
	      ourIndex = doc.sel.primIndex;
	    }
	
	    if (behavior.unit == "rectangle") {
	      if (!behavior.addNew) {
	        ourRange = new Range(start, start);
	      }
	      start = posFromMouse(cm, event, true, true);
	      ourIndex = -1;
	    } else {
	      var range = rangeForUnit(cm, start, behavior.unit);
	      if (behavior.extend) {
	        ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend);
	      } else {
	        ourRange = range;
	      }
	    }
	
	    if (!behavior.addNew) {
	      ourIndex = 0;
	      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
	      startSel = doc.sel;
	    } else if (ourIndex == -1) {
	      ourIndex = ranges.length;
	      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex), { scroll: false, origin: "*mouse" });
	    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
	      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), { scroll: false, origin: "*mouse" });
	      startSel = doc.sel;
	    } else {
	      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
	    }
	
	    var lastPos = start;
	    function extendTo(pos) {
	      if (cmp(lastPos, pos) == 0) {
	        return;
	      }
	      lastPos = pos;
	
	      if (behavior.unit == "rectangle") {
	        var ranges = [],
	            tabSize = cm.options.tabSize;
	        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
	        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
	        var left = Math.min(startCol, posCol),
	            right = Math.max(startCol, posCol);
	        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++) {
	          var text = getLine(doc, line).text,
	              leftPos = findColumn(text, left, tabSize);
	          if (left == right) {
	            ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
	          } else if (text.length > leftPos) {
	            ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
	          }
	        }
	        if (!ranges.length) {
	          ranges.push(new Range(start, start));
	        }
	        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), { origin: "*mouse", scroll: false });
	        cm.scrollIntoView(pos);
	      } else {
	        var oldRange = ourRange;
	        var range = rangeForUnit(cm, pos, behavior.unit);
	        var anchor = oldRange.anchor,
	            head;
	        if (cmp(range.anchor, anchor) > 0) {
	          head = range.head;
	          anchor = minPos(oldRange.from(), range.anchor);
	        } else {
	          head = range.anchor;
	          anchor = maxPos(oldRange.to(), range.head);
	        }
	        var ranges$1 = startSel.ranges.slice(0);
	        ranges$1[ourIndex] = bidiSimplify(cm, new Range(_clipPos(doc, anchor), head));
	        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
	      }
	    }
	
	    var editorSize = display.wrapper.getBoundingClientRect();
	    // Used to ensure timeout re-tries don't fire when another extend
	    // happened in the meantime (clearTimeout isn't reliable -- at
	    // least on Chrome, the timeouts still happen even when cleared,
	    // if the clear happens after their scheduled firing time).
	    var counter = 0;
	
	    function extend(e) {
	      var curCount = ++counter;
	      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
	      if (!cur) {
	        return;
	      }
	      if (cmp(cur, lastPos) != 0) {
	        cm.curOp.focus = activeElt(root(cm));
	        extendTo(cur);
	        var visible = visibleLines(display, doc);
	        if (cur.line >= visible.to || cur.line < visible.from) {
	          setTimeout(operation(cm, function () {
	            if (counter == curCount) {
	              extend(e);
	            }
	          }), 150);
	        }
	      } else {
	        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
	        if (outside) {
	          setTimeout(operation(cm, function () {
	            if (counter != curCount) {
	              return;
	            }
	            display.scroller.scrollTop += outside;
	            extend(e);
	          }), 50);
	        }
	      }
	    }
	
	    function done(e) {
	      cm.state.selectingText = false;
	      counter = Infinity;
	      // If e is null or undefined we interpret this as someone trying
	      // to explicitly cancel the selection rather than the user
	      // letting go of the mouse button.
	      if (e) {
	        e_preventDefault(e);
	        display.input.focus();
	      }
	      off(display.wrapper.ownerDocument, "mousemove", move);
	      off(display.wrapper.ownerDocument, "mouseup", up);
	      doc.history.lastSelOrigin = null;
	    }
	
	    var move = operation(cm, function (e) {
	      if (e.buttons === 0 || !e_button(e)) {
	        done(e);
	      } else {
	        extend(e);
	      }
	    });
	    var up = operation(cm, done);
	    cm.state.selectingText = up;
	    on(display.wrapper.ownerDocument, "mousemove", move);
	    on(display.wrapper.ownerDocument, "mouseup", up);
	  }
	
	  // Used when mouse-selecting to adjust the anchor to the proper side
	  // of a bidi jump depending on the visual position of the head.
	  function bidiSimplify(cm, range) {
	    var anchor = range.anchor;
	    var head = range.head;
	    var anchorLine = getLine(cm.doc, anchor.line);
	    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) {
	      return range;
	    }
	    var order = getOrder(anchorLine);
	    if (!order) {
	      return range;
	    }
	    var index = getBidiPartAt(order, anchor.ch, anchor.sticky),
	        part = order[index];
	    if (part.from != anchor.ch && part.to != anchor.ch) {
	      return range;
	    }
	    var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
	    if (boundary == 0 || boundary == order.length) {
	      return range;
	    }
	
	    // Compute the relative visual position of the head compared to the
	    // anchor (<0 is to the left, >0 to the right)
	    var leftSide;
	    if (head.line != anchor.line) {
	      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
	    } else {
	      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
	      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
	      if (headIndex == boundary - 1 || headIndex == boundary) {
	        leftSide = dir < 0;
	      } else {
	        leftSide = dir > 0;
	      }
	    }
	
	    var usePart = order[boundary + (leftSide ? -1 : 0)];
	    var from = leftSide == (usePart.level == 1);
	    var ch = from ? usePart.from : usePart.to,
	        sticky = from ? "after" : "before";
	    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head);
	  }
	
	  // Determines whether an event happened in the gutter, and fires the
	  // handlers for the corresponding event.
	  function gutterEvent(cm, e, type, prevent) {
	    var mX, mY;
	    if (e.touches) {
	      mX = e.touches[0].clientX;
	      mY = e.touches[0].clientY;
	    } else {
	      try {
	        mX = e.clientX;mY = e.clientY;
	      } catch (e$1) {
	        return false;
	      }
	    }
	    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) {
	      return false;
	    }
	    if (prevent) {
	      e_preventDefault(e);
	    }
	
	    var display = cm.display;
	    var lineBox = display.lineDiv.getBoundingClientRect();
	
	    if (mY > lineBox.bottom || !hasHandler(cm, type)) {
	      return e_defaultPrevented(e);
	    }
	    mY -= lineBox.top - display.viewOffset;
	
	    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
	      var g = display.gutters.childNodes[i];
	      if (g && g.getBoundingClientRect().right >= mX) {
	        var line = _lineAtHeight(cm.doc, mY);
	        var gutter = cm.display.gutterSpecs[i];
	        signal(cm, type, cm, line, gutter.className, e);
	        return e_defaultPrevented(e);
	      }
	    }
	  }
	
	  function clickInGutter(cm, e) {
	    return gutterEvent(cm, e, "gutterClick", true);
	  }
	
	  // CONTEXT MENU HANDLING
	
	  // To make the context menu work, we need to briefly unhide the
	  // textarea (making it as unobtrusive as possible) to let the
	  // right-click take effect on it.
	  function onContextMenu(cm, e) {
	    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) {
	      return;
	    }
	    if (signalDOMEvent(cm, e, "contextmenu")) {
	      return;
	    }
	    if (!captureRightClick) {
	      cm.display.input.onContextMenu(e);
	    }
	  }
	
	  function contextMenuInGutter(cm, e) {
	    if (!hasHandler(cm, "gutterContextMenu")) {
	      return false;
	    }
	    return gutterEvent(cm, e, "gutterContextMenu", false);
	  }
	
	  function themeChanged(cm) {
	    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
	    clearCaches(cm);
	  }
	
	  var Init = { toString: function toString() {
	      return "CodeMirror.Init";
	    } };
	
	  var defaults = {};
	  var optionHandlers = {};
	
	  function defineOptions(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    function option(name, deflt, handle, notOnInit) {
	      CodeMirror.defaults[name] = deflt;
	      if (handle) {
	        optionHandlers[name] = notOnInit ? function (cm, val, old) {
	          if (old != Init) {
	            handle(cm, val, old);
	          }
	        } : handle;
	      }
	    }
	
	    CodeMirror.defineOption = option;
	
	    // Passed to option handlers when there is no old value.
	    CodeMirror.Init = Init;
	
	    // These two are, on init, called from the constructor because they
	    // have to be initialized before the editor can start at all.
	    option("value", "", function (cm, val) {
	      return cm.setValue(val);
	    }, true);
	    option("mode", null, function (cm, val) {
	      cm.doc.modeOption = val;
	      loadMode(cm);
	    }, true);
	
	    option("indentUnit", 2, loadMode, true);
	    option("indentWithTabs", false);
	    option("smartIndent", true);
	    option("tabSize", 4, function (cm) {
	      resetModeState(cm);
	      clearCaches(cm);
	      regChange(cm);
	    }, true);
	
	    option("lineSeparator", null, function (cm, val) {
	      cm.doc.lineSep = val;
	      if (!val) {
	        return;
	      }
	      var newBreaks = [],
	          lineNo = cm.doc.first;
	      cm.doc.iter(function (line) {
	        for (var pos = 0;;) {
	          var found = line.text.indexOf(val, pos);
	          if (found == -1) {
	            break;
	          }
	          pos = found + val.length;
	          newBreaks.push(Pos(lineNo, found));
	        }
	        lineNo++;
	      });
	      for (var i = newBreaks.length - 1; i >= 0; i--) {
	        _replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
	      }
	    });
	    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
	      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
	      if (old != Init) {
	        cm.refresh();
	      }
	    });
	    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) {
	      return cm.refresh();
	    }, true);
	    option("electricChars", true);
	    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
	      throw new Error("inputStyle can not (yet) be changed in a running editor"); // FIXME
	    }, true);
	    option("spellcheck", false, function (cm, val) {
	      return cm.getInputField().spellcheck = val;
	    }, true);
	    option("autocorrect", false, function (cm, val) {
	      return cm.getInputField().autocorrect = val;
	    }, true);
	    option("autocapitalize", false, function (cm, val) {
	      return cm.getInputField().autocapitalize = val;
	    }, true);
	    option("rtlMoveVisually", !windows);
	    option("wholeLineUpdateBefore", true);
	
	    option("theme", "default", function (cm) {
	      themeChanged(cm);
	      updateGutters(cm);
	    }, true);
	    option("keyMap", "default", function (cm, val, old) {
	      var next = getKeyMap(val);
	      var prev = old != Init && getKeyMap(old);
	      if (prev && prev.detach) {
	        prev.detach(cm, next);
	      }
	      if (next.attach) {
	        next.attach(cm, prev || null);
	      }
	    });
	    option("extraKeys", null);
	    option("configureMouse", null);
	
	    option("lineWrapping", false, wrappingChanged, true);
	    option("gutters", [], function (cm, val) {
	      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
	      updateGutters(cm);
	    }, true);
	    option("fixedGutter", true, function (cm, val) {
	      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
	      cm.refresh();
	    }, true);
	    option("coverGutterNextToScrollbar", false, function (cm) {
	      return updateScrollbars(cm);
	    }, true);
	    option("scrollbarStyle", "native", function (cm) {
	      initScrollbars(cm);
	      updateScrollbars(cm);
	      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
	      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
	    }, true);
	    option("lineNumbers", false, function (cm, val) {
	      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
	      updateGutters(cm);
	    }, true);
	    option("firstLineNumber", 1, updateGutters, true);
	    option("lineNumberFormatter", function (integer) {
	      return integer;
	    }, updateGutters, true);
	    option("showCursorWhenSelecting", false, updateSelection, true);
	
	    option("resetSelectionOnContextMenu", true);
	    option("lineWiseCopyCut", true);
	    option("pasteLinesPerSelection", true);
	    option("selectionsMayTouch", false);
	
	    option("readOnly", false, function (cm, val) {
	      if (val == "nocursor") {
	        onBlur(cm);
	        cm.display.input.blur();
	      }
	      cm.display.input.readOnlyChanged(val);
	    });
	
	    option("screenReaderLabel", null, function (cm, val) {
	      val = val === '' ? null : val;
	      cm.display.input.screenReaderLabelChanged(val);
	    });
	
	    option("disableInput", false, function (cm, val) {
	      if (!val) {
	        cm.display.input.reset();
	      }
	    }, true);
	    option("dragDrop", true, dragDropChanged);
	    option("allowDropFileTypes", null);
	
	    option("cursorBlinkRate", 530);
	    option("cursorScrollMargin", 0);
	    option("cursorHeight", 1, updateSelection, true);
	    option("singleCursorHeightPerLine", true, updateSelection, true);
	    option("workTime", 100);
	    option("workDelay", 100);
	    option("flattenSpans", true, resetModeState, true);
	    option("addModeClass", false, resetModeState, true);
	    option("pollInterval", 100);
	    option("undoDepth", 200, function (cm, val) {
	      return cm.doc.history.undoDepth = val;
	    });
	    option("historyEventDelay", 1250);
	    option("viewportMargin", 10, function (cm) {
	      return cm.refresh();
	    }, true);
	    option("maxHighlightLength", 10000, resetModeState, true);
	    option("moveInputWithCursor", true, function (cm, val) {
	      if (!val) {
	        cm.display.input.resetPosition();
	      }
	    });
	
	    option("tabindex", null, function (cm, val) {
	      return cm.display.input.getField().tabIndex = val || "";
	    });
	    option("autofocus", null);
	    option("direction", "ltr", function (cm, val) {
	      return cm.doc.setDirection(val);
	    }, true);
	    option("phrases", null);
	  }
	
	  function dragDropChanged(cm, value, old) {
	    var wasOn = old && old != Init;
	    if (!value != !wasOn) {
	      var funcs = cm.display.dragFunctions;
	      var toggle = value ? on : off;
	      toggle(cm.display.scroller, "dragstart", funcs.start);
	      toggle(cm.display.scroller, "dragenter", funcs.enter);
	      toggle(cm.display.scroller, "dragover", funcs.over);
	      toggle(cm.display.scroller, "dragleave", funcs.leave);
	      toggle(cm.display.scroller, "drop", funcs.drop);
	    }
	  }
	
	  function wrappingChanged(cm) {
	    if (cm.options.lineWrapping) {
	      addClass(cm.display.wrapper, "CodeMirror-wrap");
	      cm.display.sizer.style.minWidth = "";
	      cm.display.sizerWidth = null;
	    } else {
	      rmClass(cm.display.wrapper, "CodeMirror-wrap");
	      findMaxLine(cm);
	    }
	    estimateLineHeights(cm);
	    regChange(cm);
	    clearCaches(cm);
	    setTimeout(function () {
	      return updateScrollbars(cm);
	    }, 100);
	  }
	
	  // A CodeMirror instance represents an editor. This is the object
	  // that user code is usually dealing with.
	
	  function CodeMirror(place, options) {
	    var this$1 = this;
	
	    if (!(this instanceof CodeMirror)) {
	      return new CodeMirror(place, options);
	    }
	
	    this.options = options = options ? copyObj(options) : {};
	    // Determine effective options based on given values and defaults.
	    copyObj(defaults, options, false);
	
	    var doc = options.value;
	    if (typeof doc == "string") {
	      doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
	    } else if (options.mode) {
	      doc.modeOption = options.mode;
	    }
	    this.doc = doc;
	
	    var input = new CodeMirror.inputStyles[options.inputStyle](this);
	    var display = this.display = new Display(place, doc, input, options);
	    display.wrapper.CodeMirror = this;
	    themeChanged(this);
	    if (options.lineWrapping) {
	      this.display.wrapper.className += " CodeMirror-wrap";
	    }
	    initScrollbars(this);
	
	    this.state = {
	      keyMaps: [], // stores maps added by addKeyMap
	      overlays: [], // highlighting overlays, as added by addOverlay
	      modeGen: 0, // bumped when mode/overlay changes, used to invalidate highlighting info
	      overwrite: false,
	      delayingBlurEvent: false,
	      focused: false,
	      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
	      selectingText: false,
	      draggingText: false,
	      highlight: new Delayed(), // stores highlight worker timeout
	      keySeq: null, // Unfinished key sequence
	      specialChars: null
	    };
	
	    if (options.autofocus && !mobile) {
	      display.input.focus();
	    }
	
	    // Override magic textarea content restore that IE sometimes does
	    // on our hidden textarea on reload
	    if (ie && ie_version < 11) {
	      setTimeout(function () {
	        return this$1.display.input.reset(true);
	      }, 20);
	    }
	
	    registerEventHandlers(this);
	    ensureGlobalHandlers();
	
	    _startOperation(this);
	    this.curOp.forceUpdate = true;
	    attachDoc(this, doc);
	
	    if (options.autofocus && !mobile || this.hasFocus()) {
	      setTimeout(function () {
	        if (this$1.hasFocus() && !this$1.state.focused) {
	          onFocus(this$1);
	        }
	      }, 20);
	    } else {
	      onBlur(this);
	    }
	
	    for (var opt in optionHandlers) {
	      if (optionHandlers.hasOwnProperty(opt)) {
	        optionHandlers[opt](this, options[opt], Init);
	      }
	    }
	    maybeUpdateLineNumberWidth(this);
	    if (options.finishInit) {
	      options.finishInit(this);
	    }
	    for (var i = 0; i < initHooks.length; ++i) {
	      initHooks[i](this);
	    }
	    _endOperation(this);
	    // Suppress optimizelegibility in Webkit, since it breaks text
	    // measuring on line wrapping boundaries.
	    if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") {
	      display.lineDiv.style.textRendering = "auto";
	    }
	  }
	
	  // The default configuration options.
	  CodeMirror.defaults = defaults;
	  // Functions to run when options are changed.
	  CodeMirror.optionHandlers = optionHandlers;
	
	  // Attach the necessary event handlers when initializing the editor
	  function registerEventHandlers(cm) {
	    var d = cm.display;
	    on(d.scroller, "mousedown", operation(cm, onMouseDown));
	    // Older IE's will not fire a second mousedown for a double click
	    if (ie && ie_version < 11) {
	      on(d.scroller, "dblclick", operation(cm, function (e) {
	        if (signalDOMEvent(cm, e)) {
	          return;
	        }
	        var pos = posFromMouse(cm, e);
	        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) {
	          return;
	        }
	        e_preventDefault(e);
	        var word = cm.findWordAt(pos);
	        extendSelection(cm.doc, word.anchor, word.head);
	      }));
	    } else {
	      on(d.scroller, "dblclick", function (e) {
	        return signalDOMEvent(cm, e) || e_preventDefault(e);
	      });
	    }
	    // Some browsers fire contextmenu *after* opening the menu, at
	    // which point we can't mess with it anymore. Context menu is
	    // handled in onMouseDown for these browsers.
	    on(d.scroller, "contextmenu", function (e) {
	      return onContextMenu(cm, e);
	    });
	    on(d.input.getField(), "contextmenu", function (e) {
	      if (!d.scroller.contains(e.target)) {
	        onContextMenu(cm, e);
	      }
	    });
	
	    // Used to suppress mouse event handling when a touch happens
	    var touchFinished,
	        prevTouch = { end: 0 };
	    function finishTouch() {
	      if (d.activeTouch) {
	        touchFinished = setTimeout(function () {
	          return d.activeTouch = null;
	        }, 1000);
	        prevTouch = d.activeTouch;
	        prevTouch.end = +new Date();
	      }
	    }
	    function isMouseLikeTouchEvent(e) {
	      if (e.touches.length != 1) {
	        return false;
	      }
	      var touch = e.touches[0];
	      return touch.radiusX <= 1 && touch.radiusY <= 1;
	    }
	    function farAway(touch, other) {
	      if (other.left == null) {
	        return true;
	      }
	      var dx = other.left - touch.left,
	          dy = other.top - touch.top;
	      return dx * dx + dy * dy > 20 * 20;
	    }
	    on(d.scroller, "touchstart", function (e) {
	      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
	        d.input.ensurePolled();
	        clearTimeout(touchFinished);
	        var now = +new Date();
	        d.activeTouch = { start: now, moved: false,
	          prev: now - prevTouch.end <= 300 ? prevTouch : null };
	        if (e.touches.length == 1) {
	          d.activeTouch.left = e.touches[0].pageX;
	          d.activeTouch.top = e.touches[0].pageY;
	        }
	      }
	    });
	    on(d.scroller, "touchmove", function () {
	      if (d.activeTouch) {
	        d.activeTouch.moved = true;
	      }
	    });
	    on(d.scroller, "touchend", function (e) {
	      var touch = d.activeTouch;
	      if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date() - touch.start < 300) {
	        var pos = cm.coordsChar(d.activeTouch, "page"),
	            range;
	        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	          {
	            range = new Range(pos, pos);
	          } else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	          {
	            range = cm.findWordAt(pos);
	          } else // Triple tap
	          {
	            range = new Range(Pos(pos.line, 0), _clipPos(cm.doc, Pos(pos.line + 1, 0)));
	          }
	        cm.setSelection(range.anchor, range.head);
	        cm.focus();
	        e_preventDefault(e);
	      }
	      finishTouch();
	    });
	    on(d.scroller, "touchcancel", finishTouch);
	
	    // Sync scrolling between fake scrollbars and real scrollable
	    // area, ensure viewport is updated when scrolling.
	    on(d.scroller, "scroll", function () {
	      if (d.scroller.clientHeight) {
	        updateScrollTop(cm, d.scroller.scrollTop);
	        setScrollLeft(cm, d.scroller.scrollLeft, true);
	        signal(cm, "scroll", cm);
	      }
	    });
	
	    // Listen to wheel events in order to try and update the viewport on time.
	    on(d.scroller, "mousewheel", function (e) {
	      return onScrollWheel(cm, e);
	    });
	    on(d.scroller, "DOMMouseScroll", function (e) {
	      return onScrollWheel(cm, e);
	    });
	
	    // Prevent wrapper from ever scrolling
	    on(d.wrapper, "scroll", function () {
	      return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
	    });
	
	    d.dragFunctions = {
	      enter: function enter(e) {
	        if (!signalDOMEvent(cm, e)) {
	          e_stop(e);
	        }
	      },
	      over: function over(e) {
	        if (!signalDOMEvent(cm, e)) {
	          onDragOver(cm, e);e_stop(e);
	        }
	      },
	      start: function start(e) {
	        return onDragStart(cm, e);
	      },
	      drop: operation(cm, onDrop),
	      leave: function leave(e) {
	        if (!signalDOMEvent(cm, e)) {
	          clearDragCursor(cm);
	        }
	      }
	    };
	
	    var inp = d.input.getField();
	    on(inp, "keyup", function (e) {
	      return onKeyUp.call(cm, e);
	    });
	    on(inp, "keydown", operation(cm, onKeyDown));
	    on(inp, "keypress", operation(cm, onKeyPress));
	    on(inp, "focus", function (e) {
	      return onFocus(cm, e);
	    });
	    on(inp, "blur", function (e) {
	      return onBlur(cm, e);
	    });
	  }
	
	  var initHooks = [];
	  CodeMirror.defineInitHook = function (f) {
	    return initHooks.push(f);
	  };
	
	  // Indent the given line. The how parameter can be "smart",
	  // "add"/null, "subtract", or "prev". When aggressive is false
	  // (typically set to true for forced single-line indents), empty
	  // lines are not indented, and places where the mode returns Pass
	  // are left alone.
	  function indentLine(cm, n, how, aggressive) {
	    var doc = cm.doc,
	        state;
	    if (how == null) {
	      how = "add";
	    }
	    if (how == "smart") {
	      // Fall back to "prev" when the mode doesn't have an indentation
	      // method.
	      if (!doc.mode.indent) {
	        how = "prev";
	      } else {
	        state = getContextBefore(cm, n).state;
	      }
	    }
	
	    var tabSize = cm.options.tabSize;
	    var line = getLine(doc, n),
	        curSpace = countColumn(line.text, null, tabSize);
	    if (line.stateAfter) {
	      line.stateAfter = null;
	    }
	    var curSpaceString = line.text.match(/^\s*/)[0],
	        indentation;
	    if (!aggressive && !/\S/.test(line.text)) {
	      indentation = 0;
	      how = "not";
	    } else if (how == "smart") {
	      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
	      if (indentation == Pass || indentation > 150) {
	        if (!aggressive) {
	          return;
	        }
	        how = "prev";
	      }
	    }
	    if (how == "prev") {
	      if (n > doc.first) {
	        indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
	      } else {
	        indentation = 0;
	      }
	    } else if (how == "add") {
	      indentation = curSpace + cm.options.indentUnit;
	    } else if (how == "subtract") {
	      indentation = curSpace - cm.options.indentUnit;
	    } else if (typeof how == "number") {
	      indentation = curSpace + how;
	    }
	    indentation = Math.max(0, indentation);
	
	    var indentString = "",
	        pos = 0;
	    if (cm.options.indentWithTabs) {
	      for (var i = Math.floor(indentation / tabSize); i; --i) {
	        pos += tabSize;indentString += "\t";
	      }
	    }
	    if (pos < indentation) {
	      indentString += spaceStr(indentation - pos);
	    }
	
	    if (indentString != curSpaceString) {
	      _replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
	      line.stateAfter = null;
	      return true;
	    } else {
	      // Ensure that, if the cursor was in the whitespace at the start
	      // of the line, it is moved to the end of that space.
	      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
	        var range = doc.sel.ranges[i$1];
	        if (range.head.line == n && range.head.ch < curSpaceString.length) {
	          var pos$1 = Pos(n, curSpaceString.length);
	          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
	          break;
	        }
	      }
	    }
	  }
	
	  // This will be set to a {lineWise: bool, text: [string]} object, so
	  // that, when pasting, we know what kind of selections the copied
	  // text was made out of.
	  var lastCopied = null;
	
	  function setLastCopied(newLastCopied) {
	    lastCopied = newLastCopied;
	  }
	
	  function applyTextInput(cm, inserted, deleted, sel, origin) {
	    var doc = cm.doc;
	    cm.display.shift = false;
	    if (!sel) {
	      sel = doc.sel;
	    }
	
	    var recent = +new Date() - 200;
	    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
	    var textLines = splitLinesAuto(inserted),
	        multiPaste = null;
	    // When pasting N lines into N selections, insert one line per selection
	    if (paste && sel.ranges.length > 1) {
	      if (lastCopied && lastCopied.text.join("\n") == inserted) {
	        if (sel.ranges.length % lastCopied.text.length == 0) {
	          multiPaste = [];
	          for (var i = 0; i < lastCopied.text.length; i++) {
	            multiPaste.push(doc.splitLines(lastCopied.text[i]));
	          }
	        }
	      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
	        multiPaste = map(textLines, function (l) {
	          return [l];
	        });
	      }
	    }
	
	    var updateInput = cm.curOp.updateInput;
	    // Normal behavior is to insert the new text into every selection
	    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
	      var range = sel.ranges[i$1];
	      var from = range.from(),
	          to = range.to();
	      if (range.empty()) {
	        if (deleted && deleted > 0) // Handle deletion
	          {
	            from = Pos(from.line, from.ch - deleted);
	          } else if (cm.state.overwrite && !paste) // Handle overwrite
	          {
	            to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
	          } else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n")) {
	          from = to = Pos(from.line, 0);
	        }
	      }
	      var changeEvent = { from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
	        origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input") };
	      makeChange(cm.doc, changeEvent);
	      signalLater(cm, "inputRead", cm, changeEvent);
	    }
	    if (inserted && !paste) {
	      triggerElectric(cm, inserted);
	    }
	
	    ensureCursorVisible(cm);
	    if (cm.curOp.updateInput < 2) {
	      cm.curOp.updateInput = updateInput;
	    }
	    cm.curOp.typing = true;
	    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
	  }
	
	  function handlePaste(e, cm) {
	    var pasted = e.clipboardData && e.clipboardData.getData("Text");
	    if (pasted) {
	      e.preventDefault();
	      if (!cm.isReadOnly() && !cm.options.disableInput && cm.hasFocus()) {
	        runInOp(cm, function () {
	          return applyTextInput(cm, pasted, 0, null, "paste");
	        });
	      }
	      return true;
	    }
	  }
	
	  function triggerElectric(cm, inserted) {
	    // When an 'electric' character is inserted, immediately trigger a reindent
	    if (!cm.options.electricChars || !cm.options.smartIndent) {
	      return;
	    }
	    var sel = cm.doc.sel;
	
	    for (var i = sel.ranges.length - 1; i >= 0; i--) {
	      var range = sel.ranges[i];
	      if (range.head.ch > 100 || i && sel.ranges[i - 1].head.line == range.head.line) {
	        continue;
	      }
	      var mode = cm.getModeAt(range.head);
	      var indented = false;
	      if (mode.electricChars) {
	        for (var j = 0; j < mode.electricChars.length; j++) {
	          if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	            indented = indentLine(cm, range.head.line, "smart");
	            break;
	          }
	        }
	      } else if (mode.electricInput) {
	        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch))) {
	          indented = indentLine(cm, range.head.line, "smart");
	        }
	      }
	      if (indented) {
	        signalLater(cm, "electricInput", cm, range.head.line);
	      }
	    }
	  }
	
	  function copyableRanges(cm) {
	    var text = [],
	        ranges = [];
	    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	      var line = cm.doc.sel.ranges[i].head.line;
	      var lineRange = { anchor: Pos(line, 0), head: Pos(line + 1, 0) };
	      ranges.push(lineRange);
	      text.push(cm.getRange(lineRange.anchor, lineRange.head));
	    }
	    return { text: text, ranges: ranges };
	  }
	
	  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
	    field.setAttribute("autocorrect", autocorrect ? "on" : "off");
	    field.setAttribute("autocapitalize", autocapitalize ? "on" : "off");
	    field.setAttribute("spellcheck", !!spellcheck);
	  }
	
	  function hiddenTextarea() {
	    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
	    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
	    // The textarea is kept positioned near the cursor to prevent the
	    // fact that it'll be scrolled into view on input from scrolling
	    // our fake cursor out of view. On webkit, when wrap=off, paste is
	    // very slow. So make the area wide instead.
	    if (webkit) {
	      te.style.width = "1000px";
	    } else {
	      te.setAttribute("wrap", "off");
	    }
	    // If border: 0; -- iOS fails to open keyboard (issue #1287)
	    if (ios) {
	      te.style.border = "1px solid black";
	    }
	    return div;
	  }
	
	  // The publicly visible API. Note that methodOp(f) means
	  // 'wrap f in an operation, performed on its `this` parameter'.
	
	  // This is not the complete set of editor methods. Most of the
	  // methods defined on the Doc type are also injected into
	  // CodeMirror.prototype, for backwards compatibility and
	  // convenience.
	
	  function addEditorMethods(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    var helpers = CodeMirror.helpers = {};
	
	    CodeMirror.prototype = {
	      constructor: CodeMirror,
	      focus: function focus() {
	        win(this).focus();this.display.input.focus();
	      },
	
	      setOption: function setOption(option, value) {
	        var options = this.options,
	            old = options[option];
	        if (options[option] == value && option != "mode") {
	          return;
	        }
	        options[option] = value;
	        if (optionHandlers.hasOwnProperty(option)) {
	          operation(this, optionHandlers[option])(this, value, old);
	        }
	        signal(this, "optionChange", this, option);
	      },
	
	      getOption: function getOption(option) {
	        return this.options[option];
	      },
	      getDoc: function getDoc() {
	        return this.doc;
	      },
	
	      addKeyMap: function addKeyMap(map, bottom) {
	        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
	      },
	      removeKeyMap: function removeKeyMap(map) {
	        var maps = this.state.keyMaps;
	        for (var i = 0; i < maps.length; ++i) {
	          if (maps[i] == map || maps[i].name == map) {
	            maps.splice(i, 1);
	            return true;
	          }
	        }
	      },
	
	      addOverlay: methodOp(function (spec, options) {
	        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
	        if (mode.startState) {
	          throw new Error("Overlays may not be stateful.");
	        }
	        insertSorted(this.state.overlays, { mode: mode, modeSpec: spec, opaque: options && options.opaque,
	          priority: options && options.priority || 0 }, function (overlay) {
	          return overlay.priority;
	        });
	        this.state.modeGen++;
	        regChange(this);
	      }),
	      removeOverlay: methodOp(function (spec) {
	        var overlays = this.state.overlays;
	        for (var i = 0; i < overlays.length; ++i) {
	          var cur = overlays[i].modeSpec;
	          if (cur == spec || typeof spec == "string" && cur.name == spec) {
	            overlays.splice(i, 1);
	            this.state.modeGen++;
	            regChange(this);
	            return;
	          }
	        }
	      }),
	
	      indentLine: methodOp(function (n, dir, aggressive) {
	        if (typeof dir != "string" && typeof dir != "number") {
	          if (dir == null) {
	            dir = this.options.smartIndent ? "smart" : "prev";
	          } else {
	            dir = dir ? "add" : "subtract";
	          }
	        }
	        if (isLine(this.doc, n)) {
	          indentLine(this, n, dir, aggressive);
	        }
	      }),
	      indentSelection: methodOp(function (how) {
	        var ranges = this.doc.sel.ranges,
	            end = -1;
	        for (var i = 0; i < ranges.length; i++) {
	          var range = ranges[i];
	          if (!range.empty()) {
	            var from = range.from(),
	                to = range.to();
	            var start = Math.max(end, from.line);
	            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
	            for (var j = start; j < end; ++j) {
	              indentLine(this, j, how);
	            }
	            var newRanges = this.doc.sel.ranges;
	            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) {
	              replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
	            }
	          } else if (range.head.line > end) {
	            indentLine(this, range.head.line, how, true);
	            end = range.head.line;
	            if (i == this.doc.sel.primIndex) {
	              ensureCursorVisible(this);
	            }
	          }
	        }
	      }),
	
	      // Fetch the parser token for a given character. Useful for hacks
	      // that want to inspect the mode state (say, for completion).
	      getTokenAt: function getTokenAt(pos, precise) {
	        return takeToken(this, pos, precise);
	      },
	
	      getLineTokens: function getLineTokens(line, precise) {
	        return takeToken(this, Pos(line), precise, true);
	      },
	
	      getTokenTypeAt: function getTokenTypeAt(pos) {
	        pos = _clipPos(this.doc, pos);
	        var styles = getLineStyles(this, getLine(this.doc, pos.line));
	        var before = 0,
	            after = (styles.length - 1) / 2,
	            ch = pos.ch;
	        var type;
	        if (ch == 0) {
	          type = styles[2];
	        } else {
	          for (;;) {
	            var mid = before + after >> 1;
	            if ((mid ? styles[mid * 2 - 1] : 0) >= ch) {
	              after = mid;
	            } else if (styles[mid * 2 + 1] < ch) {
	              before = mid + 1;
	            } else {
	              type = styles[mid * 2 + 2];break;
	            }
	          }
	        }
	        var cut = type ? type.indexOf("overlay ") : -1;
	        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
	      },
	
	      getModeAt: function getModeAt(pos) {
	        var mode = this.doc.mode;
	        if (!mode.innerMode) {
	          return mode;
	        }
	        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
	      },
	
	      getHelper: function getHelper(pos, type) {
	        return this.getHelpers(pos, type)[0];
	      },
	
	      getHelpers: function getHelpers(pos, type) {
	        var found = [];
	        if (!helpers.hasOwnProperty(type)) {
	          return found;
	        }
	        var help = helpers[type],
	            mode = this.getModeAt(pos);
	        if (typeof mode[type] == "string") {
	          if (help[mode[type]]) {
	            found.push(help[mode[type]]);
	          }
	        } else if (mode[type]) {
	          for (var i = 0; i < mode[type].length; i++) {
	            var val = help[mode[type][i]];
	            if (val) {
	              found.push(val);
	            }
	          }
	        } else if (mode.helperType && help[mode.helperType]) {
	          found.push(help[mode.helperType]);
	        } else if (help[mode.name]) {
	          found.push(help[mode.name]);
	        }
	        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
	          var cur = help._global[i$1];
	          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1) {
	            found.push(cur.val);
	          }
	        }
	        return found;
	      },
	
	      getStateAfter: function getStateAfter(line, precise) {
	        var doc = this.doc;
	        line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
	        return getContextBefore(this, line + 1, precise).state;
	      },
	
	      cursorCoords: function cursorCoords(start, mode) {
	        var pos,
	            range = this.doc.sel.primary();
	        if (start == null) {
	          pos = range.head;
	        } else if ((typeof start === 'undefined' ? 'undefined' : _typeof(start)) == "object") {
	          pos = _clipPos(this.doc, start);
	        } else {
	          pos = start ? range.from() : range.to();
	        }
	        return _cursorCoords(this, pos, mode || "page");
	      },
	
	      charCoords: function charCoords(pos, mode) {
	        return _charCoords(this, _clipPos(this.doc, pos), mode || "page");
	      },
	
	      coordsChar: function coordsChar(coords, mode) {
	        coords = fromCoordSystem(this, coords, mode || "page");
	        return _coordsChar(this, coords.left, coords.top);
	      },
	
	      lineAtHeight: function lineAtHeight(height, mode) {
	        height = fromCoordSystem(this, { top: height, left: 0 }, mode || "page").top;
	        return _lineAtHeight(this.doc, height + this.display.viewOffset);
	      },
	      heightAtLine: function heightAtLine(line, mode, includeWidgets) {
	        var end = false,
	            lineObj;
	        if (typeof line == "number") {
	          var last = this.doc.first + this.doc.size - 1;
	          if (line < this.doc.first) {
	            line = this.doc.first;
	          } else if (line > last) {
	            line = last;end = true;
	          }
	          lineObj = getLine(this.doc, line);
	        } else {
	          lineObj = line;
	        }
	        return intoCoordSystem(this, lineObj, { top: 0, left: 0 }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - _heightAtLine(lineObj) : 0);
	      },
	
	      defaultTextHeight: function defaultTextHeight() {
	        return textHeight(this.display);
	      },
	      defaultCharWidth: function defaultCharWidth() {
	        return charWidth(this.display);
	      },
	
	      getViewport: function getViewport() {
	        return { from: this.display.viewFrom, to: this.display.viewTo };
	      },
	
	      addWidget: function addWidget(pos, node, scroll, vert, horiz) {
	        var display = this.display;
	        pos = _cursorCoords(this, _clipPos(this.doc, pos));
	        var top = pos.bottom,
	            left = pos.left;
	        node.style.position = "absolute";
	        node.setAttribute("cm-ignore-events", "true");
	        this.display.input.setUneditable(node);
	        display.sizer.appendChild(node);
	        if (vert == "over") {
	          top = pos.top;
	        } else if (vert == "above" || vert == "near") {
	          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	              hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
	          // Default to positioning above (if specified and possible); otherwise default to positioning below
	          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) {
	            top = pos.top - node.offsetHeight;
	          } else if (pos.bottom + node.offsetHeight <= vspace) {
	            top = pos.bottom;
	          }
	          if (left + node.offsetWidth > hspace) {
	            left = hspace - node.offsetWidth;
	          }
	        }
	        node.style.top = top + "px";
	        node.style.left = node.style.right = "";
	        if (horiz == "right") {
	          left = display.sizer.clientWidth - node.offsetWidth;
	          node.style.right = "0px";
	        } else {
	          if (horiz == "left") {
	            left = 0;
	          } else if (horiz == "middle") {
	            left = (display.sizer.clientWidth - node.offsetWidth) / 2;
	          }
	          node.style.left = left + "px";
	        }
	        if (scroll) {
	          scrollIntoView(this, { left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight });
	        }
	      },
	
	      triggerOnKeyDown: methodOp(onKeyDown),
	      triggerOnKeyPress: methodOp(onKeyPress),
	      triggerOnKeyUp: onKeyUp,
	      triggerOnMouseDown: methodOp(onMouseDown),
	
	      execCommand: function execCommand(cmd) {
	        if (commands.hasOwnProperty(cmd)) {
	          return commands[cmd].call(null, this);
	        }
	      },
	
	      triggerElectric: methodOp(function (text) {
	        triggerElectric(this, text);
	      }),
	
	      findPosH: function findPosH(from, amount, unit, visually) {
	        var dir = 1;
	        if (amount < 0) {
	          dir = -1;amount = -amount;
	        }
	        var cur = _clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          cur = _findPosH(this.doc, cur, dir, unit, visually);
	          if (cur.hitSide) {
	            break;
	          }
	        }
	        return cur;
	      },
	
	      moveH: methodOp(function (dir, unit) {
	        var this$1 = this;
	
	        this.extendSelectionsBy(function (range) {
	          if (this$1.display.shift || this$1.doc.extend || range.empty()) {
	            return _findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually);
	          } else {
	            return dir < 0 ? range.from() : range.to();
	          }
	        }, sel_move);
	      }),
	
	      deleteH: methodOp(function (dir, unit) {
	        var sel = this.doc.sel,
	            doc = this.doc;
	        if (sel.somethingSelected()) {
	          doc.replaceSelection("", null, "+delete");
	        } else {
	          deleteNearSelection(this, function (range) {
	            var other = _findPosH(doc, range.head, dir, unit, false);
	            return dir < 0 ? { from: other, to: range.head } : { from: range.head, to: other };
	          });
	        }
	      }),
	
	      findPosV: function findPosV(from, amount, unit, goalColumn) {
	        var dir = 1,
	            x = goalColumn;
	        if (amount < 0) {
	          dir = -1;amount = -amount;
	        }
	        var cur = _clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          var coords = _cursorCoords(this, cur, "div");
	          if (x == null) {
	            x = coords.left;
	          } else {
	            coords.left = x;
	          }
	          cur = _findPosV(this, coords, dir, unit);
	          if (cur.hitSide) {
	            break;
	          }
	        }
	        return cur;
	      },
	
	      moveV: methodOp(function (dir, unit) {
	        var this$1 = this;
	
	        var doc = this.doc,
	            goals = [];
	        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
	        doc.extendSelectionsBy(function (range) {
	          if (collapse) {
	            return dir < 0 ? range.from() : range.to();
	          }
	          var headPos = _cursorCoords(this$1, range.head, "div");
	          if (range.goalColumn != null) {
	            headPos.left = range.goalColumn;
	          }
	          goals.push(headPos.left);
	          var pos = _findPosV(this$1, headPos, dir, unit);
	          if (unit == "page" && range == doc.sel.primary()) {
	            addToScrollTop(this$1, _charCoords(this$1, pos, "div").top - headPos.top);
	          }
	          return pos;
	        }, sel_move);
	        if (goals.length) {
	          for (var i = 0; i < doc.sel.ranges.length; i++) {
	            doc.sel.ranges[i].goalColumn = goals[i];
	          }
	        }
	      }),
	
	      // Find the word at the given position (as returned by coordsChar).
	      findWordAt: function findWordAt(pos) {
	        var doc = this.doc,
	            line = getLine(doc, pos.line).text;
	        var start = pos.ch,
	            end = pos.ch;
	        if (line) {
	          var helper = this.getHelper(pos, "wordChars");
	          if ((pos.sticky == "before" || end == line.length) && start) {
	            --start;
	          } else {
	            ++end;
	          }
	          var startChar = line.charAt(start);
	          var check = isWordChar(startChar, helper) ? function (ch) {
	            return isWordChar(ch, helper);
	          } : /\s/.test(startChar) ? function (ch) {
	            return (/\s/.test(ch)
	            );
	          } : function (ch) {
	            return !/\s/.test(ch) && !isWordChar(ch);
	          };
	          while (start > 0 && check(line.charAt(start - 1))) {
	            --start;
	          }
	          while (end < line.length && check(line.charAt(end))) {
	            ++end;
	          }
	        }
	        return new Range(Pos(pos.line, start), Pos(pos.line, end));
	      },
	
	      toggleOverwrite: function toggleOverwrite(value) {
	        if (value != null && value == this.state.overwrite) {
	          return;
	        }
	        if (this.state.overwrite = !this.state.overwrite) {
	          addClass(this.display.cursorDiv, "CodeMirror-overwrite");
	        } else {
	          rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
	        }
	
	        signal(this, "overwriteToggle", this, this.state.overwrite);
	      },
	      hasFocus: function hasFocus() {
	        return this.display.input.getField() == activeElt(root(this));
	      },
	      isReadOnly: function isReadOnly() {
	        return !!(this.options.readOnly || this.doc.cantEdit);
	      },
	
	      scrollTo: methodOp(function (x, y) {
	        scrollToCoords(this, x, y);
	      }),
	      getScrollInfo: function getScrollInfo() {
	        var scroller = this.display.scroller;
	        return { left: scroller.scrollLeft, top: scroller.scrollTop,
	          height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	          width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	          clientHeight: displayHeight(this), clientWidth: displayWidth(this) };
	      },
	
	      scrollIntoView: methodOp(function (range, margin) {
	        if (range == null) {
	          range = { from: this.doc.sel.primary().head, to: null };
	          if (margin == null) {
	            margin = this.options.cursorScrollMargin;
	          }
	        } else if (typeof range == "number") {
	          range = { from: Pos(range, 0), to: null };
	        } else if (range.from == null) {
	          range = { from: range, to: null };
	        }
	        if (!range.to) {
	          range.to = range.from;
	        }
	        range.margin = margin || 0;
	
	        if (range.from.line != null) {
	          scrollToRange(this, range);
	        } else {
	          scrollToCoordsRange(this, range.from, range.to, range.margin);
	        }
	      }),
	
	      setSize: methodOp(function (width, height) {
	        var this$1 = this;
	
	        var interpret = function interpret(val) {
	          return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
	        };
	        if (width != null) {
	          this.display.wrapper.style.width = interpret(width);
	        }
	        if (height != null) {
	          this.display.wrapper.style.height = interpret(height);
	        }
	        if (this.options.lineWrapping) {
	          clearLineMeasurementCache(this);
	        }
	        var lineNo = this.display.viewFrom;
	        this.doc.iter(lineNo, this.display.viewTo, function (line) {
	          if (line.widgets) {
	            for (var i = 0; i < line.widgets.length; i++) {
	              if (line.widgets[i].noHScroll) {
	                regLineChange(this$1, lineNo, "widget");break;
	              }
	            }
	          }
	          ++lineNo;
	        });
	        this.curOp.forceUpdate = true;
	        signal(this, "refresh", this);
	      }),
	
	      operation: function operation(f) {
	        return runInOp(this, f);
	      },
	      startOperation: function startOperation() {
	        return _startOperation(this);
	      },
	      endOperation: function endOperation() {
	        return _endOperation(this);
	      },
	
	      refresh: methodOp(function () {
	        var oldHeight = this.display.cachedTextHeight;
	        regChange(this);
	        this.curOp.forceUpdate = true;
	        clearCaches(this);
	        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
	        updateGutterSpace(this.display);
	        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping) {
	          estimateLineHeights(this);
	        }
	        signal(this, "refresh", this);
	      }),
	
	      swapDoc: methodOp(function (doc) {
	        var old = this.doc;
	        old.cm = null;
	        // Cancel the current text selection if any (#5821)
	        if (this.state.selectingText) {
	          this.state.selectingText();
	        }
	        attachDoc(this, doc);
	        clearCaches(this);
	        this.display.input.reset();
	        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
	        this.curOp.forceScroll = true;
	        signalLater(this, "swapDoc", this, old);
	        return old;
	      }),
	
	      phrase: function phrase(phraseText) {
	        var phrases = this.options.phrases;
	        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
	      },
	
	      getInputField: function getInputField() {
	        return this.display.input.getField();
	      },
	      getWrapperElement: function getWrapperElement() {
	        return this.display.wrapper;
	      },
	      getScrollerElement: function getScrollerElement() {
	        return this.display.scroller;
	      },
	      getGutterElement: function getGutterElement() {
	        return this.display.gutters;
	      }
	    };
	    eventMixin(CodeMirror);
	
	    CodeMirror.registerHelper = function (type, name, value) {
	      if (!helpers.hasOwnProperty(type)) {
	        helpers[type] = CodeMirror[type] = { _global: [] };
	      }
	      helpers[type][name] = value;
	    };
	    CodeMirror.registerGlobalHelper = function (type, name, predicate, value) {
	      CodeMirror.registerHelper(type, name, value);
	      helpers[type]._global.push({ pred: predicate, val: value });
	    };
	  }
	
	  // Used for horizontal relative motion. Dir is -1 or 1 (left or
	  // right), unit can be "codepoint", "char", "column" (like char, but
	  // doesn't cross line boundaries), "word" (across next word), or
	  // "group" (to the start of next group of word or
	  // non-word-non-whitespace chars). The visually param controls
	  // whether, in right-to-left text, direction 1 means to move towards
	  // the next index in the string, or towards the character to the right
	  // of the current position. The resulting position will have a
	  // hitSide=true property if it reached the end of the document.
	  function _findPosH(doc, pos, dir, unit, visually) {
	    var oldPos = pos;
	    var origDir = dir;
	    var lineObj = getLine(doc, pos.line);
	    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
	    function findNextLine() {
	      var l = pos.line + lineDir;
	      if (l < doc.first || l >= doc.first + doc.size) {
	        return false;
	      }
	      pos = new Pos(l, pos.ch, pos.sticky);
	      return lineObj = getLine(doc, l);
	    }
	    function moveOnce(boundToLine) {
	      var next;
	      if (unit == "codepoint") {
	        var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
	        if (isNaN(ch)) {
	          next = null;
	        } else {
	          var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
	          next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
	        }
	      } else if (visually) {
	        next = moveVisually(doc.cm, lineObj, pos, dir);
	      } else {
	        next = moveLogically(lineObj, pos, dir);
	      }
	      if (next == null) {
	        if (!boundToLine && findNextLine()) {
	          pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir);
	        } else {
	          return false;
	        }
	      } else {
	        pos = next;
	      }
	      return true;
	    }
	
	    if (unit == "char" || unit == "codepoint") {
	      moveOnce();
	    } else if (unit == "column") {
	      moveOnce(true);
	    } else if (unit == "word" || unit == "group") {
	      var sawType = null,
	          group = unit == "group";
	      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
	      for (var first = true;; first = false) {
	        if (dir < 0 && !moveOnce(!first)) {
	          break;
	        }
	        var cur = lineObj.text.charAt(pos.ch) || "\n";
	        var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
	        if (group && !first && !type) {
	          type = "s";
	        }
	        if (sawType && sawType != type) {
	          if (dir < 0) {
	            dir = 1;moveOnce();pos.sticky = "after";
	          }
	          break;
	        }
	
	        if (type) {
	          sawType = type;
	        }
	        if (dir > 0 && !moveOnce(!first)) {
	          break;
	        }
	      }
	    }
	    var result = skipAtomic(doc, pos, oldPos, origDir, true);
	    if (equalCursorPos(oldPos, result)) {
	      result.hitSide = true;
	    }
	    return result;
	  }
	
	  // For relative vertical movement. Dir may be -1 or 1. Unit can be
	  // "page" or "line". The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function _findPosV(cm, pos, dir, unit) {
	    var doc = cm.doc,
	        x = pos.left,
	        y;
	    if (unit == "page") {
	      var pageSize = Math.min(cm.display.wrapper.clientHeight, win(cm).innerHeight || doc(cm).documentElement.clientHeight);
	      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
	      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
	    } else if (unit == "line") {
	      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
	    }
	    var target;
	    for (;;) {
	      target = _coordsChar(cm, x, y);
	      if (!target.outside) {
	        break;
	      }
	      if (dir < 0 ? y <= 0 : y >= doc.height) {
	        target.hitSide = true;break;
	      }
	      y += dir * 5;
	    }
	    return target;
	  }
	
	  // CONTENTEDITABLE INPUT STYLE
	
	  var ContentEditableInput = function ContentEditableInput(cm) {
	    this.cm = cm;
	    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
	    this.polling = new Delayed();
	    this.composing = null;
	    this.gracePeriod = false;
	    this.readDOMTimeout = null;
	  };
	
	  ContentEditableInput.prototype.init = function (display) {
	    var this$1 = this;
	
	    var input = this,
	        cm = input.cm;
	    var div = input.div = display.lineDiv;
	    div.contentEditable = true;
	    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
	
	    function belongsToInput(e) {
	      for (var t = e.target; t; t = t.parentNode) {
	        if (t == div) {
	          return true;
	        }
	        if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) {
	          break;
	        }
	      }
	      return false;
	    }
	
	    on(div, "paste", function (e) {
	      if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) {
	        return;
	      }
	      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	      if (ie_version <= 11) {
	        setTimeout(operation(cm, function () {
	          return this$1.updateFromDOM();
	        }), 20);
	      }
	    });
	
	    on(div, "compositionstart", function (e) {
	      this$1.composing = { data: e.data, done: false };
	    });
	    on(div, "compositionupdate", function (e) {
	      if (!this$1.composing) {
	        this$1.composing = { data: e.data, done: false };
	      }
	    });
	    on(div, "compositionend", function (e) {
	      if (this$1.composing) {
	        if (e.data != this$1.composing.data) {
	          this$1.readFromDOMSoon();
	        }
	        this$1.composing.done = true;
	      }
	    });
	
	    on(div, "touchstart", function () {
	      return input.forceCompositionEnd();
	    });
	
	    on(div, "input", function () {
	      if (!this$1.composing) {
	        this$1.readFromDOMSoon();
	      }
	    });
	
	    function onCopyCut(e) {
	      if (!belongsToInput(e) || signalDOMEvent(cm, e)) {
	        return;
	      }
	      if (cm.somethingSelected()) {
	        setLastCopied({ lineWise: false, text: cm.getSelections() });
	        if (e.type == "cut") {
	          cm.replaceSelection("", null, "cut");
	        }
	      } else if (!cm.options.lineWiseCopyCut) {
	        return;
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({ lineWise: true, text: ranges.text });
	        if (e.type == "cut") {
	          cm.operation(function () {
	            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
	            cm.replaceSelection("", null, "cut");
	          });
	        }
	      }
	      if (e.clipboardData) {
	        e.clipboardData.clearData();
	        var content = lastCopied.text.join("\n");
	        // iOS exposes the clipboard API, but seems to discard content inserted into it
	        e.clipboardData.setData("Text", content);
	        if (e.clipboardData.getData("Text") == content) {
	          e.preventDefault();
	          return;
	        }
	      }
	      // Old-fashioned briefly-focus-a-textarea hack
	      var kludge = hiddenTextarea(),
	          te = kludge.firstChild;
	      disableBrowserMagic(te);
	      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
	      te.value = lastCopied.text.join("\n");
	      var hadFocus = activeElt(rootNode(div));
	      selectInput(te);
	      setTimeout(function () {
	        cm.display.lineSpace.removeChild(kludge);
	        hadFocus.focus();
	        if (hadFocus == div) {
	          input.showPrimarySelection();
	        }
	      }, 50);
	    }
	    on(div, "copy", onCopyCut);
	    on(div, "cut", onCopyCut);
	  };
	
	  ContentEditableInput.prototype.screenReaderLabelChanged = function (label) {
	    // Label for screenreaders, accessibility
	    if (label) {
	      this.div.setAttribute('aria-label', label);
	    } else {
	      this.div.removeAttribute('aria-label');
	    }
	  };
	
	  ContentEditableInput.prototype.prepareSelection = function () {
	    var result = prepareSelection(this.cm, false);
	    result.focus = activeElt(rootNode(this.div)) == this.div;
	    return result;
	  };
	
	  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
	    if (!info || !this.cm.display.view.length) {
	      return;
	    }
	    if (info.focus || takeFocus) {
	      this.showPrimarySelection();
	    }
	    this.showMultipleSelections(info);
	  };
	
	  ContentEditableInput.prototype.getSelection = function () {
	    return this.cm.display.wrapper.ownerDocument.getSelection();
	  };
	
	  ContentEditableInput.prototype.showPrimarySelection = function () {
	    var sel = this.getSelection(),
	        cm = this.cm,
	        prim = cm.doc.sel.primary();
	    var from = prim.from(),
	        to = prim.to();
	
	    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
	      sel.removeAllRanges();
	      return;
	    }
	
	    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) {
	      return;
	    }
	
	    var view = cm.display.view;
	    var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || { node: view[0].measure.map[2], offset: 0 };
	    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
	    if (!end) {
	      var measure = view[view.length - 1].measure;
	      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
	      end = { node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3] };
	    }
	
	    if (!start || !end) {
	      sel.removeAllRanges();
	      return;
	    }
	
	    var old = sel.rangeCount && sel.getRangeAt(0),
	        rng;
	    try {
	      rng = range(start.node, start.offset, end.offset, end.node);
	    } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	    if (rng) {
	      if (!gecko && cm.state.focused) {
	        sel.collapse(start.node, start.offset);
	        if (!rng.collapsed) {
	          sel.removeAllRanges();
	          sel.addRange(rng);
	        }
	      } else {
	        sel.removeAllRanges();
	        sel.addRange(rng);
	      }
	      if (old && sel.anchorNode == null) {
	        sel.addRange(old);
	      } else if (gecko) {
	        this.startGracePeriod();
	      }
	    }
	    this.rememberSelection();
	  };
	
	  ContentEditableInput.prototype.startGracePeriod = function () {
	    var this$1 = this;
	
	    clearTimeout(this.gracePeriod);
	    this.gracePeriod = setTimeout(function () {
	      this$1.gracePeriod = false;
	      if (this$1.selectionChanged()) {
	        this$1.cm.operation(function () {
	          return this$1.cm.curOp.selectionChanged = true;
	        });
	      }
	    }, 20);
	  };
	
	  ContentEditableInput.prototype.showMultipleSelections = function (info) {
	    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
	    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
	  };
	
	  ContentEditableInput.prototype.rememberSelection = function () {
	    var sel = this.getSelection();
	    this.lastAnchorNode = sel.anchorNode;this.lastAnchorOffset = sel.anchorOffset;
	    this.lastFocusNode = sel.focusNode;this.lastFocusOffset = sel.focusOffset;
	  };
	
	  ContentEditableInput.prototype.selectionInEditor = function () {
	    var sel = this.getSelection();
	    if (!sel.rangeCount) {
	      return false;
	    }
	    var node = sel.getRangeAt(0).commonAncestorContainer;
	    return contains(this.div, node);
	  };
	
	  ContentEditableInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor") {
	      if (!this.selectionInEditor() || activeElt(rootNode(this.div)) != this.div) {
	        this.showSelection(this.prepareSelection(), true);
	      }
	      this.div.focus();
	    }
	  };
	  ContentEditableInput.prototype.blur = function () {
	    this.div.blur();
	  };
	  ContentEditableInput.prototype.getField = function () {
	    return this.div;
	  };
	
	  ContentEditableInput.prototype.supportsTouch = function () {
	    return true;
	  };
	
	  ContentEditableInput.prototype.receivedFocus = function () {
	    var this$1 = this;
	
	    var input = this;
	    if (this.selectionInEditor()) {
	      setTimeout(function () {
	        return this$1.pollSelection();
	      }, 20);
	    } else {
	      runInOp(this.cm, function () {
	        return input.cm.curOp.selectionChanged = true;
	      });
	    }
	
	    function poll() {
	      if (input.cm.state.focused) {
	        input.pollSelection();
	        input.polling.set(input.cm.options.pollInterval, poll);
	      }
	    }
	    this.polling.set(this.cm.options.pollInterval, poll);
	  };
	
	  ContentEditableInput.prototype.selectionChanged = function () {
	    var sel = this.getSelection();
	    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
	  };
	
	  ContentEditableInput.prototype.pollSelection = function () {
	    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) {
	      return;
	    }
	    var sel = this.getSelection(),
	        cm = this.cm;
	    // On Android Chrome (version 56, at least), backspacing into an
	    // uneditable block element will put the cursor in that element,
	    // and then, because it's not editable, hide the virtual keyboard.
	    // Because Android doesn't allow us to actually detect backspace
	    // presses in a sane way, this code checks for when that happens
	    // and simulates a backspace press in this case.
	    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
	      this.cm.triggerOnKeyDown({ type: "keydown", keyCode: 8, preventDefault: Math.abs });
	      this.blur();
	      this.focus();
	      return;
	    }
	    if (this.composing) {
	      return;
	    }
	    this.rememberSelection();
	    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (anchor && head) {
	      runInOp(cm, function () {
	        setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
	        if (anchor.bad || head.bad) {
	          cm.curOp.selectionChanged = true;
	        }
	      });
	    }
	  };
	
	  ContentEditableInput.prototype.pollContent = function () {
	    if (this.readDOMTimeout != null) {
	      clearTimeout(this.readDOMTimeout);
	      this.readDOMTimeout = null;
	    }
	
	    var cm = this.cm,
	        display = cm.display,
	        sel = cm.doc.sel.primary();
	    var from = sel.from(),
	        to = sel.to();
	    if (from.ch == 0 && from.line > cm.firstLine()) {
	      from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
	    }
	    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) {
	      to = Pos(to.line + 1, 0);
	    }
	    if (from.line < display.viewFrom || to.line > display.viewTo - 1) {
	      return false;
	    }
	
	    var fromIndex, fromLine, fromNode;
	    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	      fromLine = lineNo(display.view[0].line);
	      fromNode = display.view[0].node;
	    } else {
	      fromLine = lineNo(display.view[fromIndex].line);
	      fromNode = display.view[fromIndex - 1].node.nextSibling;
	    }
	    var toIndex = findViewIndex(cm, to.line);
	    var toLine, toNode;
	    if (toIndex == display.view.length - 1) {
	      toLine = display.viewTo - 1;
	      toNode = display.lineDiv.lastChild;
	    } else {
	      toLine = lineNo(display.view[toIndex + 1].line) - 1;
	      toNode = display.view[toIndex + 1].node.previousSibling;
	    }
	
	    if (!fromNode) {
	      return false;
	    }
	    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
	    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
	    while (newText.length > 1 && oldText.length > 1) {
	      if (lst(newText) == lst(oldText)) {
	        newText.pop();oldText.pop();toLine--;
	      } else if (newText[0] == oldText[0]) {
	        newText.shift();oldText.shift();fromLine++;
	      } else {
	        break;
	      }
	    }
	
	    var cutFront = 0,
	        cutEnd = 0;
	    var newTop = newText[0],
	        oldTop = oldText[0],
	        maxCutFront = Math.min(newTop.length, oldTop.length);
	    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront)) {
	      ++cutFront;
	    }
	    var newBot = lst(newText),
	        oldBot = lst(oldText);
	    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
	    while (cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	      ++cutEnd;
	    }
	    // Try to move start of change to start of selection if ambiguous
	    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
	      while (cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	        cutFront--;
	        cutEnd++;
	      }
	    }
	
	    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
	    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
	
	    var chFrom = Pos(fromLine, cutFront);
	    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
	    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	      _replaceRange(cm.doc, newText, chFrom, chTo, "+input");
	      return true;
	    }
	  };
	
	  ContentEditableInput.prototype.ensurePolled = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.reset = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.forceCompositionEnd = function () {
	    if (!this.composing) {
	      return;
	    }
	    clearTimeout(this.readDOMTimeout);
	    this.composing = null;
	    this.updateFromDOM();
	    this.div.blur();
	    this.div.focus();
	  };
	  ContentEditableInput.prototype.readFromDOMSoon = function () {
	    var this$1 = this;
	
	    if (this.readDOMTimeout != null) {
	      return;
	    }
	    this.readDOMTimeout = setTimeout(function () {
	      this$1.readDOMTimeout = null;
	      if (this$1.composing) {
	        if (this$1.composing.done) {
	          this$1.composing = null;
	        } else {
	          return;
	        }
	      }
	      this$1.updateFromDOM();
	    }, 80);
	  };
	
	  ContentEditableInput.prototype.updateFromDOM = function () {
	    var this$1 = this;
	
	    if (this.cm.isReadOnly() || !this.pollContent()) {
	      runInOp(this.cm, function () {
	        return regChange(this$1.cm);
	      });
	    }
	  };
	
	  ContentEditableInput.prototype.setUneditable = function (node) {
	    node.contentEditable = "false";
	  };
	
	  ContentEditableInput.prototype.onKeyPress = function (e) {
	    if (e.charCode == 0 || this.composing) {
	      return;
	    }
	    e.preventDefault();
	    if (!this.cm.isReadOnly()) {
	      operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
	    }
	  };
	
	  ContentEditableInput.prototype.readOnlyChanged = function (val) {
	    this.div.contentEditable = String(val != "nocursor");
	  };
	
	  ContentEditableInput.prototype.onContextMenu = function () {};
	  ContentEditableInput.prototype.resetPosition = function () {};
	
	  ContentEditableInput.prototype.needsContentAttribute = true;
	
	  function posToDOM(cm, pos) {
	    var view = findViewForLine(cm, pos.line);
	    if (!view || view.hidden) {
	      return null;
	    }
	    var line = getLine(cm.doc, pos.line);
	    var info = mapFromLineView(view, line, pos.line);
	
	    var order = getOrder(line, cm.doc.direction),
	        side = "left";
	    if (order) {
	      var partPos = getBidiPartAt(order, pos.ch);
	      side = partPos % 2 ? "right" : "left";
	    }
	    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
	    result.offset = result.collapse == "right" ? result.end : result.start;
	    return result;
	  }
	
	  function isInGutter(node) {
	    for (var scan = node; scan; scan = scan.parentNode) {
	      if (/CodeMirror-gutter-wrapper/.test(scan.className)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function badPos(pos, bad) {
	    if (bad) {
	      pos.bad = true;
	    }return pos;
	  }
	
	  function domTextBetween(cm, from, to, fromLine, toLine) {
	    var text = "",
	        closing = false,
	        lineSep = cm.doc.lineSeparator(),
	        extraLinebreak = false;
	    function recognizeMarker(id) {
	      return function (marker) {
	        return marker.id == id;
	      };
	    }
	    function close() {
	      if (closing) {
	        text += lineSep;
	        if (extraLinebreak) {
	          text += lineSep;
	        }
	        closing = extraLinebreak = false;
	      }
	    }
	    function addText(str) {
	      if (str) {
	        close();
	        text += str;
	      }
	    }
	    function walk(node) {
	      if (node.nodeType == 1) {
	        var cmText = node.getAttribute("cm-text");
	        if (cmText) {
	          addText(cmText);
	          return;
	        }
	        var markerID = node.getAttribute("cm-marker"),
	            range;
	        if (markerID) {
	          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
	          if (found.length && (range = found[0].find(0))) {
	            addText(getBetween(cm.doc, range.from, range.to).join(lineSep));
	          }
	          return;
	        }
	        if (node.getAttribute("contenteditable") == "false") {
	          return;
	        }
	        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
	        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) {
	          return;
	        }
	
	        if (isBlock) {
	          close();
	        }
	        for (var i = 0; i < node.childNodes.length; i++) {
	          walk(node.childNodes[i]);
	        }
	
	        if (/^(pre|p)$/i.test(node.nodeName)) {
	          extraLinebreak = true;
	        }
	        if (isBlock) {
	          closing = true;
	        }
	      } else if (node.nodeType == 3) {
	        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
	      }
	    }
	    for (;;) {
	      walk(from);
	      if (from == to) {
	        break;
	      }
	      from = from.nextSibling;
	      extraLinebreak = false;
	    }
	    return text;
	  }
	
	  function domToPos(cm, node, offset) {
	    var lineNode;
	    if (node == cm.display.lineDiv) {
	      lineNode = cm.display.lineDiv.childNodes[offset];
	      if (!lineNode) {
	        return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
	      }
	      node = null;offset = 0;
	    } else {
	      for (lineNode = node;; lineNode = lineNode.parentNode) {
	        if (!lineNode || lineNode == cm.display.lineDiv) {
	          return null;
	        }
	        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) {
	          break;
	        }
	      }
	    }
	    for (var i = 0; i < cm.display.view.length; i++) {
	      var lineView = cm.display.view[i];
	      if (lineView.node == lineNode) {
	        return locateNodeInLineView(lineView, node, offset);
	      }
	    }
	  }
	
	  function locateNodeInLineView(lineView, node, offset) {
	    var wrapper = lineView.text.firstChild,
	        bad = false;
	    if (!node || !contains(wrapper, node)) {
	      return badPos(Pos(lineNo(lineView.line), 0), true);
	    }
	    if (node == wrapper) {
	      bad = true;
	      node = wrapper.childNodes[offset];
	      offset = 0;
	      if (!node) {
	        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
	        return badPos(Pos(lineNo(line), line.text.length), bad);
	      }
	    }
	
	    var textNode = node.nodeType == 3 ? node : null,
	        topNode = node;
	    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	      textNode = node.firstChild;
	      if (offset) {
	        offset = textNode.nodeValue.length;
	      }
	    }
	    while (topNode.parentNode != wrapper) {
	      topNode = topNode.parentNode;
	    }
	    var measure = lineView.measure,
	        maps = measure.maps;
	
	    function find(textNode, topNode, offset) {
	      for (var i = -1; i < (maps ? maps.length : 0); i++) {
	        var map = i < 0 ? measure.map : maps[i];
	        for (var j = 0; j < map.length; j += 3) {
	          var curNode = map[j + 2];
	          if (curNode == textNode || curNode == topNode) {
	            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
	            var ch = map[j] + offset;
	            if (offset < 0 || curNode != textNode) {
	              ch = map[j + (offset ? 1 : 0)];
	            }
	            return Pos(line, ch);
	          }
	        }
	      }
	    }
	    var found = find(textNode, topNode, offset);
	    if (found) {
	      return badPos(found, bad);
	    }
	
	    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	      found = find(after, after.firstChild, 0);
	      if (found) {
	        return badPos(Pos(found.line, found.ch - dist), bad);
	      } else {
	        dist += after.textContent.length;
	      }
	    }
	    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
	      found = find(before, before.firstChild, -1);
	      if (found) {
	        return badPos(Pos(found.line, found.ch + dist$1), bad);
	      } else {
	        dist$1 += before.textContent.length;
	      }
	    }
	  }
	
	  // TEXTAREA INPUT STYLE
	
	  var TextareaInput = function TextareaInput(cm) {
	    this.cm = cm;
	    // See input.poll and input.reset
	    this.prevInput = "";
	
	    // Flag that indicates whether we expect input to appear real soon
	    // now (after some event like 'keypress' or 'input') and are
	    // polling intensively.
	    this.pollingFast = false;
	    // Self-resetting timeout for the poller
	    this.polling = new Delayed();
	    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	    this.hasSelection = false;
	    this.composing = null;
	    this.resetting = false;
	  };
	
	  TextareaInput.prototype.init = function (display) {
	    var this$1 = this;
	
	    var input = this,
	        cm = this.cm;
	    this.createField(display);
	    var te = this.textarea;
	
	    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
	
	    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	    if (ios) {
	      te.style.width = "0px";
	    }
	
	    on(te, "input", function () {
	      if (ie && ie_version >= 9 && this$1.hasSelection) {
	        this$1.hasSelection = null;
	      }
	      input.poll();
	    });
	
	    on(te, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) {
	        return;
	      }
	
	      cm.state.pasteIncoming = +new Date();
	      input.fastPoll();
	    });
	
	    function prepareCopyCut(e) {
	      if (signalDOMEvent(cm, e)) {
	        return;
	      }
	      if (cm.somethingSelected()) {
	        setLastCopied({ lineWise: false, text: cm.getSelections() });
	      } else if (!cm.options.lineWiseCopyCut) {
	        return;
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({ lineWise: true, text: ranges.text });
	        if (e.type == "cut") {
	          cm.setSelections(ranges.ranges, null, sel_dontScroll);
	        } else {
	          input.prevInput = "";
	          te.value = ranges.text.join("\n");
	          selectInput(te);
	        }
	      }
	      if (e.type == "cut") {
	        cm.state.cutIncoming = +new Date();
	      }
	    }
	    on(te, "cut", prepareCopyCut);
	    on(te, "copy", prepareCopyCut);
	
	    on(display.scroller, "paste", function (e) {
	      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) {
	        return;
	      }
	      if (!te.dispatchEvent) {
	        cm.state.pasteIncoming = +new Date();
	        input.focus();
	        return;
	      }
	
	      // Pass the `paste` event to the textarea so it's handled by its event listener.
	      var event = new Event("paste");
	      event.clipboardData = e.clipboardData;
	      te.dispatchEvent(event);
	    });
	
	    // Prevent normal selection in the editor (we handle our own)
	    on(display.lineSpace, "selectstart", function (e) {
	      if (!eventInWidget(display, e)) {
	        e_preventDefault(e);
	      }
	    });
	
	    on(te, "compositionstart", function () {
	      var start = cm.getCursor("from");
	      if (input.composing) {
	        input.composing.range.clear();
	      }
	      input.composing = {
	        start: start,
	        range: cm.markText(start, cm.getCursor("to"), { className: "CodeMirror-composing" })
	      };
	    });
	    on(te, "compositionend", function () {
	      if (input.composing) {
	        input.poll();
	        input.composing.range.clear();
	        input.composing = null;
	      }
	    });
	  };
	
	  TextareaInput.prototype.createField = function (_display) {
	    // Wraps and hides input textarea
	    this.wrapper = hiddenTextarea();
	    // The semihidden textarea that is focused when the editor is
	    // focused, and receives input.
	    this.textarea = this.wrapper.firstChild;
	    var opts = this.cm.options;
	    disableBrowserMagic(this.textarea, opts.spellcheck, opts.autocorrect, opts.autocapitalize);
	  };
	
	  TextareaInput.prototype.screenReaderLabelChanged = function (label) {
	    // Label for screenreaders, accessibility
	    if (label) {
	      this.textarea.setAttribute('aria-label', label);
	    } else {
	      this.textarea.removeAttribute('aria-label');
	    }
	  };
	
	  TextareaInput.prototype.prepareSelection = function () {
	    // Redraw the selection and/or cursor
	    var cm = this.cm,
	        display = cm.display,
	        doc = cm.doc;
	    var result = prepareSelection(cm);
	
	    // Move the hidden textarea near the cursor to prevent scrolling artifacts
	    if (cm.options.moveInputWithCursor) {
	      var headPos = _cursorCoords(cm, doc.sel.primary().head, "div");
	      var wrapOff = display.wrapper.getBoundingClientRect(),
	          lineOff = display.lineDiv.getBoundingClientRect();
	      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
	      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
	    }
	
	    return result;
	  };
	
	  TextareaInput.prototype.showSelection = function (drawn) {
	    var cm = this.cm,
	        display = cm.display;
	    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
	    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
	    if (drawn.teTop != null) {
	      this.wrapper.style.top = drawn.teTop + "px";
	      this.wrapper.style.left = drawn.teLeft + "px";
	    }
	  };
	
	  // Reset the input to correspond to the selection (or to be empty,
	  // when not typing and nothing is selected)
	  TextareaInput.prototype.reset = function (typing) {
	    if (this.contextMenuPending || this.composing && typing) {
	      return;
	    }
	    var cm = this.cm;
	    this.resetting = true;
	    if (cm.somethingSelected()) {
	      this.prevInput = "";
	      var content = cm.getSelection();
	      this.textarea.value = content;
	      if (cm.state.focused) {
	        selectInput(this.textarea);
	      }
	      if (ie && ie_version >= 9) {
	        this.hasSelection = content;
	      }
	    } else if (!typing) {
	      this.prevInput = this.textarea.value = "";
	      if (ie && ie_version >= 9) {
	        this.hasSelection = null;
	      }
	    }
	    this.resetting = false;
	  };
	
	  TextareaInput.prototype.getField = function () {
	    return this.textarea;
	  };
	
	  TextareaInput.prototype.supportsTouch = function () {
	    return false;
	  };
	
	  TextareaInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt(rootNode(this.textarea)) != this.textarea)) {
	      try {
	        this.textarea.focus();
	      } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	    }
	  };
	
	  TextareaInput.prototype.blur = function () {
	    this.textarea.blur();
	  };
	
	  TextareaInput.prototype.resetPosition = function () {
	    this.wrapper.style.top = this.wrapper.style.left = 0;
	  };
	
	  TextareaInput.prototype.receivedFocus = function () {
	    this.slowPoll();
	  };
	
	  // Poll for input changes, using the normal rate of polling. This
	  // runs as long as the editor is focused.
	  TextareaInput.prototype.slowPoll = function () {
	    var this$1 = this;
	
	    if (this.pollingFast) {
	      return;
	    }
	    this.polling.set(this.cm.options.pollInterval, function () {
	      this$1.poll();
	      if (this$1.cm.state.focused) {
	        this$1.slowPoll();
	      }
	    });
	  };
	
	  // When an event has just come in that is likely to add or change
	  // something in the input textarea, we poll faster, to ensure that
	  // the change appears on the screen quickly.
	  TextareaInput.prototype.fastPoll = function () {
	    var missed = false,
	        input = this;
	    input.pollingFast = true;
	    function p() {
	      var changed = input.poll();
	      if (!changed && !missed) {
	        missed = true;input.polling.set(60, p);
	      } else {
	        input.pollingFast = false;input.slowPoll();
	      }
	    }
	    input.polling.set(20, p);
	  };
	
	  // Read input from the textarea, and update the document to match.
	  // When something is selected, it is present in the textarea, and
	  // selected (unless it is huge, in which case a placeholder is
	  // used). When nothing is selected, the cursor sits after previously
	  // seen text (can be empty), which is stored in prevInput (we must
	  // not reset the textarea when typing, because that breaks IME).
	  TextareaInput.prototype.poll = function () {
	    var this$1 = this;
	
	    var cm = this.cm,
	        input = this.textarea,
	        prevInput = this.prevInput;
	    // Since this is called a *lot*, try to bail out as cheaply as
	    // possible when it is clear that nothing happened. hasSelection
	    // will be the case when there is a lot of text in the textarea,
	    // in which case reading its value would be expensive.
	    if (this.contextMenuPending || this.resetting || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) {
	      return false;
	    }
	
	    var text = input.value;
	    // If nothing changed, bail.
	    if (text == prevInput && !cm.somethingSelected()) {
	      return false;
	    }
	    // Work around nonsensical selection resetting in IE9/10, and
	    // inexplicable appearance of private area unicode characters on
	    // some key combos in Mac (#2689).
	    if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
	      cm.display.input.reset();
	      return false;
	    }
	
	    if (cm.doc.sel == cm.display.selForContextMenu) {
	      var first = text.charCodeAt(0);
	      if (first == 0x200b && !prevInput) {
	        prevInput = '\u200B';
	      }
	      if (first == 0x21da) {
	        this.reset();return this.cm.execCommand("undo");
	      }
	    }
	    // Find the part of the input that is actually new
	    var same = 0,
	        l = Math.min(prevInput.length, text.length);
	    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) {
	      ++same;
	    }
	
	    runInOp(cm, function () {
	      applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
	
	      // Don't leave long text in the textarea, since it makes further polling slow
	      if (text.length > 1000 || text.indexOf("\n") > -1) {
	        input.value = this$1.prevInput = "";
	      } else {
	        this$1.prevInput = text;
	      }
	
	      if (this$1.composing) {
	        this$1.composing.range.clear();
	        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), { className: "CodeMirror-composing" });
	      }
	    });
	    return true;
	  };
	
	  TextareaInput.prototype.ensurePolled = function () {
	    if (this.pollingFast && this.poll()) {
	      this.pollingFast = false;
	    }
	  };
	
	  TextareaInput.prototype.onKeyPress = function () {
	    if (ie && ie_version >= 9) {
	      this.hasSelection = null;
	    }
	    this.fastPoll();
	  };
	
	  TextareaInput.prototype.onContextMenu = function (e) {
	    var input = this,
	        cm = input.cm,
	        display = cm.display,
	        te = input.textarea;
	    if (input.contextMenuPending) {
	      input.contextMenuPending();
	    }
	    var pos = posFromMouse(cm, e),
	        scrollPos = display.scroller.scrollTop;
	    if (!pos || presto) {
	      return;
	    } // Opera is difficult.
	
	    // Reset the current text selection only if the click is done outside of the selection
	    // and 'resetSelectionOnContextMenu' option is true.
	    var reset = cm.options.resetSelectionOnContextMenu;
	    if (reset && cm.doc.sel.contains(pos) == -1) {
	      operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
	    }
	
	    var oldCSS = te.style.cssText,
	        oldWrapperCSS = input.wrapper.style.cssText;
	    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
	    input.wrapper.style.cssText = "position: static";
	    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
	    var oldScrollY;
	    if (webkit) {
	      oldScrollY = te.ownerDocument.defaultView.scrollY;
	    } // Work around Chrome issue (#2712)
	    display.input.focus();
	    if (webkit) {
	      te.ownerDocument.defaultView.scrollTo(null, oldScrollY);
	    }
	    display.input.reset();
	    // Adds "Select all" to context menu in FF
	    if (!cm.somethingSelected()) {
	      te.value = input.prevInput = " ";
	    }
	    input.contextMenuPending = rehide;
	    display.selForContextMenu = cm.doc.sel;
	    clearTimeout(display.detectingSelectAll);
	
	    // Select-all will be greyed out if there's nothing to select, so
	    // this adds a zero-width space so that we can later check whether
	    // it got selected.
	    function prepareSelectAllHack() {
	      if (te.selectionStart != null) {
	        var selected = cm.somethingSelected();
	        var extval = '\u200B' + (selected ? te.value : "");
	        te.value = '\u21DA'; // Used to catch context-menu undo
	        te.value = extval;
	        input.prevInput = selected ? "" : '\u200B';
	        te.selectionStart = 1;te.selectionEnd = extval.length;
	        // Re-set this, in case some other handler touched the
	        // selection in the meantime.
	        display.selForContextMenu = cm.doc.sel;
	      }
	    }
	    function rehide() {
	      if (input.contextMenuPending != rehide) {
	        return;
	      }
	      input.contextMenuPending = false;
	      input.wrapper.style.cssText = oldWrapperCSS;
	      te.style.cssText = oldCSS;
	      if (ie && ie_version < 9) {
	        display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
	      }
	
	      // Try to detect the user choosing select-all
	      if (te.selectionStart != null) {
	        if (!ie || ie && ie_version < 9) {
	          prepareSelectAllHack();
	        }
	        var i = 0,
	            poll = function poll() {
	          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == '\u200B') {
	            operation(cm, selectAll)(cm);
	          } else if (i++ < 10) {
	            display.detectingSelectAll = setTimeout(poll, 500);
	          } else {
	            display.selForContextMenu = null;
	            display.input.reset();
	          }
	        };
	        display.detectingSelectAll = setTimeout(poll, 200);
	      }
	    }
	
	    if (ie && ie_version >= 9) {
	      prepareSelectAllHack();
	    }
	    if (captureRightClick) {
	      e_stop(e);
	      var mouseup = function mouseup() {
	        off(window, "mouseup", mouseup);
	        setTimeout(rehide, 20);
	      };
	      on(window, "mouseup", mouseup);
	    } else {
	      setTimeout(rehide, 50);
	    }
	  };
	
	  TextareaInput.prototype.readOnlyChanged = function (val) {
	    if (!val) {
	      this.reset();
	    }
	    this.textarea.disabled = val == "nocursor";
	    this.textarea.readOnly = !!val;
	  };
	
	  TextareaInput.prototype.setUneditable = function () {};
	
	  TextareaInput.prototype.needsContentAttribute = false;
	
	  function fromTextArea(textarea, options) {
	    options = options ? copyObj(options) : {};
	    options.value = textarea.value;
	    if (!options.tabindex && textarea.tabIndex) {
	      options.tabindex = textarea.tabIndex;
	    }
	    if (!options.placeholder && textarea.placeholder) {
	      options.placeholder = textarea.placeholder;
	    }
	    // Set autofocus to true if this textarea is focused, or if it has
	    // autofocus and no other element is focused.
	    if (options.autofocus == null) {
	      var hasFocus = activeElt(rootNode(textarea));
	      options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
	    }
	
	    function save() {
	      textarea.value = cm.getValue();
	    }
	
	    var realSubmit;
	    if (textarea.form) {
	      on(textarea.form, "submit", save);
	      // Deplorable hack to make the submit method do the right thing.
	      if (!options.leaveSubmitMethodAlone) {
	        var form = textarea.form;
	        realSubmit = form.submit;
	        try {
	          var wrappedSubmit = form.submit = function () {
	            save();
	            form.submit = realSubmit;
	            form.submit();
	            form.submit = wrappedSubmit;
	          };
	        } catch (e) {}
	      }
	    }
	
	    options.finishInit = function (cm) {
	      cm.save = save;
	      cm.getTextArea = function () {
	        return textarea;
	      };
	      cm.toTextArea = function () {
	        cm.toTextArea = isNaN; // Prevent this from being ran twice
	        save();
	        textarea.parentNode.removeChild(cm.getWrapperElement());
	        textarea.style.display = "";
	        if (textarea.form) {
	          off(textarea.form, "submit", save);
	          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function") {
	            textarea.form.submit = realSubmit;
	          }
	        }
	      };
	    };
	
	    textarea.style.display = "none";
	    var cm = CodeMirror(function (node) {
	      return textarea.parentNode.insertBefore(node, textarea.nextSibling);
	    }, options);
	    return cm;
	  }
	
	  function addLegacyProps(CodeMirror) {
	    CodeMirror.off = off;
	    CodeMirror.on = on;
	    CodeMirror.wheelEventPixels = wheelEventPixels;
	    CodeMirror.Doc = Doc;
	    CodeMirror.splitLines = splitLinesAuto;
	    CodeMirror.countColumn = countColumn;
	    CodeMirror.findColumn = findColumn;
	    CodeMirror.isWordChar = isWordCharBasic;
	    CodeMirror.Pass = Pass;
	    CodeMirror.signal = signal;
	    CodeMirror.Line = Line;
	    CodeMirror.changeEnd = changeEnd;
	    CodeMirror.scrollbarModel = scrollbarModel;
	    CodeMirror.Pos = Pos;
	    CodeMirror.cmpPos = cmp;
	    CodeMirror.modes = modes;
	    CodeMirror.mimeModes = mimeModes;
	    CodeMirror.resolveMode = resolveMode;
	    CodeMirror.getMode = getMode;
	    CodeMirror.modeExtensions = modeExtensions;
	    CodeMirror.extendMode = extendMode;
	    CodeMirror.copyState = copyState;
	    CodeMirror.startState = startState;
	    CodeMirror.innerMode = innerMode;
	    CodeMirror.commands = commands;
	    CodeMirror.keyMap = keyMap;
	    CodeMirror.keyName = keyName;
	    CodeMirror.isModifierKey = isModifierKey;
	    CodeMirror.lookupKey = lookupKey;
	    CodeMirror.normalizeKeyMap = normalizeKeyMap;
	    CodeMirror.StringStream = StringStream;
	    CodeMirror.SharedTextMarker = SharedTextMarker;
	    CodeMirror.TextMarker = TextMarker;
	    CodeMirror.LineWidget = LineWidget;
	    CodeMirror.e_preventDefault = e_preventDefault;
	    CodeMirror.e_stopPropagation = e_stopPropagation;
	    CodeMirror.e_stop = e_stop;
	    CodeMirror.addClass = addClass;
	    CodeMirror.contains = contains;
	    CodeMirror.rmClass = rmClass;
	    CodeMirror.keyNames = keyNames;
	  }
	
	  // EDITOR CONSTRUCTOR
	
	  defineOptions(CodeMirror);
	
	  addEditorMethods(CodeMirror);
	
	  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
	  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
	  for (var prop in Doc.prototype) {
	    if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) {
	      CodeMirror.prototype[prop] = function (method) {
	        return function () {
	          return method.apply(this.doc, arguments);
	        };
	      }(Doc.prototype[prop]);
	    }
	  }
	
	  eventMixin(Doc);
	  CodeMirror.inputStyles = { "textarea": TextareaInput, "contenteditable": ContentEditableInput };
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  CodeMirror.defineMode = function (name /*, mode, …*/) {
	    if (!CodeMirror.defaults.mode && name != "null") {
	      CodeMirror.defaults.mode = name;
	    }
	    defineMode.apply(this, arguments);
	  };
	
	  CodeMirror.defineMIME = defineMIME;
	
	  // Minimal default mode.
	  CodeMirror.defineMode("null", function () {
	    return { token: function token(stream) {
	        return stream.skipToEnd();
	      } };
	  });
	  CodeMirror.defineMIME("text/plain", "null");
	
	  // EXTENSIONS
	
	  CodeMirror.defineExtension = function (name, func) {
	    CodeMirror.prototype[name] = func;
	  };
	  CodeMirror.defineDocExtension = function (name, func) {
	    Doc.prototype[name] = func;
	  };
	
	  CodeMirror.fromTextArea = fromTextArea;
	
	  addLegacyProps(CodeMirror);
	
	  CodeMirror.version = "5.65.19";
	
	  return CodeMirror;
	});

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(20);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toCallSi = exports.getPropsFromItem = exports.refModalFunction2 = exports.refModalFunction = exports.refFunction = exports.convertModuleByGuid = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * 所有组件的公共方法
	                                                                                                                                                                                                                                                                   * wangz
	                                                                                                                                                                                                                                                                   * 2018.3.9
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _SgiCompConstant = __webpack_require__(107);
	
	var _SgiFormText = __webpack_require__(701);
	
	var _SgiFormTextArea = __webpack_require__(702);
	
	var _SgiFormInputNumber = __webpack_require__(697);
	
	var _SgiFormSelect = __webpack_require__(700);
	
	var _SgiFormRadio = __webpack_require__(699);
	
	var _SgiFormCheckboxGroup = __webpack_require__(695);
	
	var _SgiFormCheckbox = __webpack_require__(694);
	
	var _SgiFormTimePicker = __webpack_require__(703);
	
	var _SgiFormDatePicker = __webpack_require__(696);
	
	var _SgiFormUpload = __webpack_require__(705);
	
	var _SgiButton = __webpack_require__(684);
	
	var _SgiForm = __webpack_require__(692);
	
	var _SgiRow = __webpack_require__(715);
	
	var _SgiCol = __webpack_require__(688);
	
	var _SgiTabs = __webpack_require__(721);
	
	var _SgiPanel = __webpack_require__(251);
	
	var _SgiTable = __webpack_require__(719);
	
	var _SgiTree = __webpack_require__(724);
	
	var _SgiCard = __webpack_require__(686);
	
	var _SgiCollapse = __webpack_require__(689);
	
	var _SgiMainComp = __webpack_require__(125);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _ComponentManager = __webpack_require__(348);
	
	var _SgiFormTreeSelect = __webpack_require__(704);
	
	var _SgiToolbar = __webpack_require__(723);
	
	var _SgiFormInputSearch = __webpack_require__(698);
	
	var _SgiNest = __webpack_require__(712);
	
	var _SgiQuote = __webpack_require__(714);
	
	var _SgiMenu = __webpack_require__(710);
	
	var _SgiSteps = __webpack_require__(717);
	
	var _SgiSplitter = __webpack_require__(716);
	
	var _SgiIcon = __webpack_require__(706);
	
	var _SgiImg = __webpack_require__(707);
	
	var _SgiLabel = __webpack_require__(708);
	
	var _SgiTag = __webpack_require__(1325);
	
	var _SgiFormCascader = __webpack_require__(693);
	
	var _SgiList = __webpack_require__(709);
	
	var _SgiTile = __webpack_require__(722);
	
	var _SgiCommEcharts = __webpack_require__(690);
	
	var _SgiCommEcharts2 = _interopRequireDefault(_SgiCommEcharts);
	
	var _SgiCalendar = __webpack_require__(685);
	
	var _SgiEditor = __webpack_require__(691);
	
	var _SgiEChartsCommon = __webpack_require__(728);
	
	var _SgiEChartsCommon2 = _interopRequireDefault(_SgiEChartsCommon);
	
	var _SgiOverlap = __webpack_require__(713);
	
	var _SgiOverlap2 = _interopRequireDefault(_SgiOverlap);
	
	var _sgiConstants = __webpack_require__(198);
	
	var _sgiConstants2 = _interopRequireDefault(_sgiConstants);
	
	var _antd = __webpack_require__(18);
	
	var _SgiDV = __webpack_require__(370);
	
	var _SgiTV = __webpack_require__(718);
	
	var _sgiRunningCommon = __webpack_require__(307);
	
	var _SgiCodeMirror = __webpack_require__(687);
	
	var _SgiCodeMirror2 = _interopRequireDefault(_SgiCodeMirror);
	
	var _SgiFormCodeMirror = __webpack_require__(1316);
	
	var _SgiFormCodeMirror2 = _interopRequireDefault(_SgiFormCodeMirror);
	
	var _SgiJsoneditor = __webpack_require__(1320);
	
	var _SgiJsoneditor2 = _interopRequireDefault(_SgiJsoneditor);
	
	var _SgiG6Common = __webpack_require__(1331);
	
	var _SgiG6Common2 = _interopRequireDefault(_SgiG6Common);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	* 根据类型转换为指定控件
	* @param {描述信息} moduleDesc
	* @param {属性} formProps
	*/
	var convertModuleByGuid = function convertModuleByGuid(currentModule, moduleDesc, bdInst, objFct, type, parameters) {
	
	    var mdType = moduleDesc.desId;
	    var cId = (0, _SgiCommon.getConstByKey)(currentModule, moduleDesc.cId);
	    var module = void 0;
	    if (mdType === _SgiCompConstant.AllCompGUID.UCV) {
	        //主main
	        if (!cId) cId = "mainUcv_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiMainComp.SgiMainComp, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.WV) {
	        //form
	        if (!cId) cId = "form_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiForm.SgiForm, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.DV) {
	        //dv
	        if (!cId) cId = "dv_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiDV.SgiDV, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.SPLITTER) {
	        //分割窗
	        if (!cId) cId = "spliter_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiSplitter.SgiSplitter, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.TAB) {
	        //tab
	        if (!cId) cId = "tab_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiTabs.SgiTabs, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.CARD) {
	        //card
	        if (!cId) cId = "card_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiCard.SgiCard, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.OVERLAP) {
	        //新层叠面板
	        if (!cId) cId = "overlap_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiOverlap2.default, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.ACCORDION) {
	        //折叠面板
	        if (!cId) cId = "collapse_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiCollapse.SgiCollapse, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.FIELDSET) {//组控件
	
	    } else if (mdType === _SgiCompConstant.AllCompGUID.PANEL) {
	        //普通面板
	        // var setActiveWV;
	        // if (parameters && parameters["setActiveWV"]) {
	        //     setActiveWV = parameters["setActiveWV"];
	        // }
	
	        if (!cId) cId = "panel_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiPanel.SgiPanel, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.NEST) {
	        //嵌入面板
	        if (!cId) cId = "nest_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiNest.SgiNest, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.QUOTE) {
	        //组件的引用
	        if (!cId) cId = "quote_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiQuote.SgiQuote, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    } else if (mdType === _SgiCompConstant.AllCompGUID.TPL) {//模板
	
	    } else if (mdType === _SgiCompConstant.AllCompGUID.CONTAINER) {//自定义面板
	
	    } else if (mdType === _SgiCompConstant.AllCompGUID.DVPANEL) {//DVPANEL
	
	    } else if (mdType === _SgiCompConstant.AllCompGUID.DU) {} else if (mdType === _SgiCompConstant.AllCompGUID.FLOATWINDOW) {//浮动面板
	
	    } else if (mdType === _SgiCompConstant.AllCompGUID.MENU) {
	        //菜单
	        if (!cId) cId = "menu_" + (0, _sgiCommon.uuid)(8);
	        module = _react2.default.createElement(_SgiMenu.SgiMenu, _extends({ ref: cId, key: cId, parentModule: currentModule,
	            moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	    }
	    /**
	     * 创建基本控件
	     * 创建方法 创建物理控件。
	     */
	    else if (mdType === _SgiCompConstant.AllCompGUID.FIELDTEXT) {
	            //文本框
	            if (!cId) cId = "text_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormText.SgiFormText, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.NUMBER) {
	            //数字控件
	            if (!cId) cId = "num_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormInputNumber.SgiFormInputNumber, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.COMBOBOX) {
	            var _extends2;
	
	            //下拉框
	            if (!cId) cId = "select_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormSelect.SgiFormSelect, _extends((_extends2 = { ref: cId, key: cId }, _defineProperty(_extends2, 'key', cId), _defineProperty(_extends2, 'parentModule', currentModule), _defineProperty(_extends2, 'moduleDesc', moduleDesc), _defineProperty(_extends2, 'bdInst', bdInst), _defineProperty(_extends2, 'objFct', objFct), _defineProperty(_extends2, 'type', type), _extends2), parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.COMBOXTREE) {
	            //下拉树
	            if (!cId) cId = "treeselect_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormTreeSelect.SgiFormTreeSelect, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.COMBOXGRID) {//下拉表格
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.RADIOGROUP) {
	            //单选框
	            if (!cId) cId = "radio_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormRadio.SgiFormRadio, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.CHECKBOXGROUP) {
	            //多选框
	            if (!cId) cId = "ck_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormCheckboxGroup.SgiFormCheckboxGroup, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.CASCADER) {
	            //多选框
	            if (!cId) cId = "cas_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormCascader.SgiFormCascader, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.TIME) {
	            //时间
	            if (!cId) cId = "time_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormTimePicker.SgiFormTimePicker, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.DATE) {
	            //日期
	            if (!cId) cId = "date_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormDatePicker.SgiFormDatePicker, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.FILE) {
	            //文件
	            if (!cId) cId = "file_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormUpload.SgiFormUpload, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.UPLOADFILE) {
	            //上传
	            if (!cId) cId = "file_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormUpload.SgiFormUpload, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.TEXTAREA) {
	            //文本域
	            if (!cId) cId = "txta_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormTextArea.SgiFormTextArea, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.EDITORAREA) {
	            //富文本
	            if (!cId) cId = "editor_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiEditor.SgiEditor, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.CODEMIRROR_FORM) {
	            //codemirror-form
	            if (!cId) cId = "codemirror_form_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormCodeMirror2.default, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.BUTTON) {
	            //按钮
	            if (!cId) cId = "btn_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiButton.SgiButton, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.CHECKBOX) {
	            //checkbox
	            if (!cId) cId = "ck_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormCheckbox.SgiFormCheckbox, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.COLOR) {} else if (mdType === _SgiCompConstant.AllCompGUID.FONT) {} else if (mdType === _SgiCompConstant.AllCompGUID.PASSWORD) {//密码
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.MONETARYTEXT) {//金额控件
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.TOOLBAR) {
	            //工具条
	            if (!cId) cId = "toba_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiToolbar.SgiToolbar, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.TBFILL) {//工具条占位符
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.POPUI) {
	            //弹出窗
	            if (!cId) cId = "popui_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiFormInputSearch.SgiFormInputSearch, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.EDITOR) {
	            //富文本
	            if (!cId) cId = "editor_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiEditor.SgiEditor, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.TREE) {
	            if (!cId) cId = "tree_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiTree.SgiTree, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.TABLE) {
	            if (!cId) cId = "table_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiTable.SgiTable, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.TV) {
	            if (!cId) cId = "tv_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiTV.SgiTV, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.LINE) {//折线图
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.AREA) {//面积图
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.BAR) {//条形图
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.SCATTER) {//散点图
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.PIE) {//饼图
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.GAUGE) {//表盘图
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.RADAR) {//雷达图
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.PROGRESSBAR) {//进度条
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.IMG) {
	            //图片控件
	            if (!cId) cId = "img_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiImg.SgiImg, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.LIST) {
	            //列表控件
	            if (!cId) cId = "list_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiList.SgiList, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.ICON) {
	            //图标
	            if (!cId) cId = "icon_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiIcon.SgiIcon, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.LABEL) {
	            //标签控件
	            if (!cId) cId = "label_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiLabel.SgiLabel, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.TAG) {
	            //tag
	            if (!cId) cId = "tag_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiTag.SgiTag, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.FIELDDISPLAY) {//只读文本控件
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.COMPONENT) {//自定义标签
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.STATBUTTON) {//状态按钮
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.STEP) {
	            //步骤控件
	            if (!cId) cId = "steps_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiSteps.SgiSteps, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.MONETARY2TEXT) {//金额控件
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.PASSWORDSTRENGTH) {//密码强度控件//增加密码强度控件20170928-wangj
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.ITEM) {//
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.DIVCOMBOBOX) {//自定义下拉窗
	
	        } else if (mdType === _SgiCompConstant.AllCompGUID.EC_COMMON) {
	            //ECharts自定义
	            if (!cId) cId = "EChartsCommon_" + (0, _sgiCommon.uuidDate)(6, "yyyyMMddhhmmssSSS");
	            module = _react2.default.createElement(_SgiEChartsCommon2.default, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.Tile) {
	            //平铺组件
	            if (!cId) cId = "tile_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiTile.SgiTile, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.CommEcharts) {
	            //通用图表控件
	            if (!cId) cId = "commEcharts_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiCommEcharts2.default, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.Calendar) {
	            //日历
	            if (!cId) cId = "calendar_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiCalendar.SgiCalendar, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.CODEMIRROR) {
	            //codemirror
	            if (!cId) cId = "codemirror_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiCodeMirror2.default, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.JSONEDITOR) {
	            //jsoneditor
	            if (!cId) cId = "jsoneditor_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiJsoneditor2.default, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        } else if (mdType === _SgiCompConstant.AllCompGUID.G6_COMMON) {
	            //g6-common
	            if (!cId) cId = "g6_common_" + (0, _sgiCommon.uuid)(8);
	            module = _react2.default.createElement(_SgiG6Common2.default, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	        }
	
	        //创建布局
	        else if (mdType === _SgiCompConstant.AllCompGUID.LT_ROW) {
	                //行
	                if (!cId) cId = "ltrow_" + (0, _sgiCommon.uuid)(8);
	                module = _react2.default.createElement(_SgiRow.SgiRow, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                    moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	            } else if (mdType === _SgiCompConstant.AllCompGUID.LT_COL) {
	                //列
	                if (!cId) cId = "ltcol_" + (0, _sgiCommon.uuid)(8);
	                module = _react2.default.createElement(_SgiCol.SgiCol, _extends({ ref: cId, key: cId, parentModule: currentModule,
	                    moduleDesc: moduleDesc, bdInst: bdInst, objFct: objFct, type: type }, parameters));
	            }
	    // ComponentManager.set(uid, cId, module);
	    return module;
	};
	
	var refFunction = function refFunction(ctl) {
	
	    if (!ctl || !ctl.props || !ctl.props.moduleDesc) {
	        return;
	    }
	    // tool.sgiLogger.log("refFunction", ctl.props.moduleDesc.cId);
	    // tool.sgiLogger.log("refFunction", ctl.props.moduleDesc.desId);
	    var _ctl$props = ctl.props,
	        moduleDesc = _ctl$props.moduleDesc,
	        objFct = _ctl$props.objFct;
	
	    var itemKey = (0, _SgiCommon.getConstByKey)(ctl, moduleDesc.cId);
	    if (!itemKey) {
	        return;
	    }
	    _ComponentManager.ComponentManager.set(objFct.getUID(), itemKey, ctl);
	};
	
	var refModalFunction = function refModalFunction(ctl) {
	
	    if (!ctl) {
	        return;
	    }
	    var _ctl$props2 = ctl.props,
	        moduleDesc = _ctl$props2.moduleDesc,
	        objFct = _ctl$props2.objFct;
	
	    var mainComp = _ComponentManager.ComponentManager.get(objFct.getUID(), objFct.getUID());
	    mainComp.setModal(ctl);
	};
	
	// 弹出组件与父组件使用不同对象工厂时使用
	var refModalFunction2 = function refModalFunction2(ctl) {
	
	    if (!ctl) {
	        return;
	    }
	    var _ctl$props3 = ctl.props,
	        moduleDesc = _ctl$props3.moduleDesc,
	        objFct = _ctl$props3.objFct;
	
	    var pObjFct = objFct.getParent();
	    if (pObjFct) {
	        var mainComp = _ComponentManager.ComponentManager.get(pObjFct.getUID(), pObjFct.getUID());
	        mainComp.setModal(ctl);
	    }
	};
	
	// 数据与组件控制交互
	var getPropsFromItem = function getPropsFromItem(item) {
	    var cstmConst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!item || Object.prototype.toString.call(item) !== "[object Object]") return {};
	
	    var props = {};
	    for (var key in item) {
	        if (cstmConst[key] || _sgiConstants2.default[key]) {
	            var pkey = cstmConst[key] || _sgiConstants2.default[key];
	            switch (pkey) {
	                case "icon":
	                    //图标特殊处理
	                    if (typeof item[key] === "string") {
	                        props[pkey] = _react2.default.createElement(_antd.Icon, { type: item[key] });
	                    } else if (Object.prototype.toString.call(item[key]) === "[object Object]") {
	                        props[pkey] = _react2.default.createElement(_antd.Icon, item[key]);
	                    }
	                    break;
	                default:
	                    props[pkey] = item[key];
	                    break;
	            }
	        }
	    }
	
	    return props;
	};
	
	// 将convertModuleByGuid方法设置成全局方法
	if (_sgiRunningCommon.tool) _sgiRunningCommon.tool.convertModuleByGuid = convertModuleByGuid;
	
	/**
	 * 通用服务接口调用处理
	 */
	function toCallSi(moduleDesc, objFct) {
	    var _this = this;
	
	    if (!moduleDesc || !objFct || !moduleDesc.bdSI) return;
	
	    // 服务号去掉前后空格
	    var bdSI = moduleDesc.bdSI.trim();
	    if (!bdSI) return;
	
	    var req = {};
	    // 前处理
	    var callPre = moduleDesc.callPre; // 用户自定义点击前处理事件
	    if (callPre) {
	        try {
	            // 自定义前处理
	            var $callPre = new Function("module", "objFct", callPre);
	            // 返回false，不再调用服务
	            if ($callPre(this, objFct) === false) {
	                return;
	            }
	        } catch (error) {
	            _sgiRunningCommon.tool.sgiLogger.error(error);
	        }
	    }
	
	    // 请求体
	    if (moduleDesc.reqIst) {
	        req = objFct.get(moduleDesc.reqIst);
	    }
	
	    // 辅助信息
	    var assistBody = {};
	    if (moduleDesc.assistBody) {
	        assistBody = objFct.get(moduleDesc.assistBody);
	    }
	
	    // 后处理
	    var callback = function callback(res) {
	        if (res && res.head && res.head.code === "0000") {
	            // 服务成功
	            try {
	                // 提示
	                var succMsg = moduleDesc.succMsg;
	                if (succMsg) {
	                    var msg = eval('(`' + succMsg + '`)');
	                    _sgiRunningCommon.tool.sgiLogger.info(msg, res);
	                    _sgiRunningCommon.tool.popMessage(msg, "success");
	                }
	
	                if (moduleDesc.resIst) {
	                    objFct.set(moduleDesc.resIst, res.body);
	                }
	
	                // 刷新
	                var refreshID = moduleDesc.refreshID;
	                if (refreshID) {
	                    var ids = refreshID.split(",");
	                    ids.forEach(function (id) {
	                        return _sgiRunningCommon.tool.commonRefresh(id, objFct);
	                    });
	                }
	            } catch (error) {
	                _sgiRunningCommon.tool.sgiLogger.error(error);
	            }
	        } else {
	            // 服务失败
	            try {
	                // 提示
	                var failMsg = moduleDesc.failMsg;
	                if (failMsg) {
	                    var _msg = eval('(`' + failMsg + '`)');
	                    _sgiRunningCommon.tool.sgiLogger.error(_msg, res);
	                    _sgiRunningCommon.tool.popMessage(_msg, "warning");
	                }
	            } catch (error) {
	                _sgiRunningCommon.tool.sgiLogger.error(error);
	            }
	        }
	        // 自定义后处理
	        var callAft = moduleDesc.callAft;
	        if (callAft) {
	            var $callAft = new Function("module", "objFct", "res", callAft);
	            $callAft(_this, objFct, res);
	        }
	    };
	
	    // 服务调用
	    var async = moduleDesc.async;
	    var batchTBID = moduleDesc.batchTBID;
	    if (batchTBID) {
	        // 分批
	        _sgiRunningCommon.tool.tableBatchSelectSI(batchTBID, objFct, bdSI, req, async, 1, callback, null, assistBody);
	    } else {
	        // 不分批
	        commonClient.callSI(bdSI, objFct, req, async, callback, "POST", assistBody);
	    }
	}
	
	exports.convertModuleByGuid = convertModuleByGuid;
	exports.refFunction = refFunction;
	exports.refModalFunction = refModalFunction;
	exports.refModalFunction2 = refModalFunction2;
	exports.getPropsFromItem = getPropsFromItem;
	exports.toCallSi = toCallSi;
	exports.default = { convertModuleByGuid: convertModuleByGuid, refFunction: refFunction, refModalFunction: refModalFunction, refModalFunction2: refModalFunction2, getPropsFromItem: getPropsFromItem };

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var BoundingRect = __webpack_require__(51);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	var formatUtil = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Layout helpers for each component positioning
	var each = zrUtil.each;
	/**
	 * @public
	 */
	
	var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
	/**
	 * @public
	 */
	
	var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];
	
	function boxLayout(orient, group, gap, maxWidth, maxHeight) {
	  var x = 0;
	  var y = 0;
	
	  if (maxWidth == null) {
	    maxWidth = Infinity;
	  }
	
	  if (maxHeight == null) {
	    maxHeight = Infinity;
	  }
	
	  var currentLineMaxSize = 0;
	  group.eachChild(function (child, idx) {
	    var position = child.position;
	    var rect = child.getBoundingRect();
	    var nextChild = group.childAt(idx + 1);
	    var nextChildRect = nextChild && nextChild.getBoundingRect();
	    var nextX;
	    var nextY;
	
	    if (orient === 'horizontal') {
	      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
	      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
	      // FIXME compare before adding gap?
	
	      if (nextX > maxWidth || child.newline) {
	        x = 0;
	        nextX = moveX;
	        y += currentLineMaxSize + gap;
	        currentLineMaxSize = rect.height;
	      } else {
	        // FIXME: consider rect.y is not `0`?
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
	      }
	    } else {
	      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
	      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
	
	      if (nextY > maxHeight || child.newline) {
	        x += currentLineMaxSize + gap;
	        y = 0;
	        nextY = moveY;
	        currentLineMaxSize = rect.width;
	      } else {
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
	      }
	    }
	
	    if (child.newline) {
	      return;
	    }
	
	    position[0] = x;
	    position[1] = y;
	    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
	  });
	}
	/**
	 * VBox or HBox layouting
	 * @param {string} orient
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	
	var box = boxLayout;
	/**
	 * VBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var vbox = zrUtil.curry(boxLayout, 'vertical');
	/**
	 * HBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var hbox = zrUtil.curry(boxLayout, 'horizontal');
	/**
	 * If x or x2 is not specified or 'center' 'left' 'right',
	 * the width would be as long as possible.
	 * If y or y2 is not specified or 'middle' 'top' 'bottom',
	 * the height would be as long as possible.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.x]
	 * @param {number|string} [positionInfo.y]
	 * @param {number|string} [positionInfo.x2]
	 * @param {number|string} [positionInfo.y2]
	 * @param {Object} containerRect {width, height}
	 * @param {string|number} margin
	 * @return {Object} {width, height}
	 */
	
	function getAvailableSize(positionInfo, containerRect, margin) {
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var x = parsePercent(positionInfo.x, containerWidth);
	  var y = parsePercent(positionInfo.y, containerHeight);
	  var x2 = parsePercent(positionInfo.x2, containerWidth);
	  var y2 = parsePercent(positionInfo.y2, containerHeight);
	  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
	  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
	  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
	  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  return {
	    width: Math.max(x2 - x - margin[1] - margin[3], 0),
	    height: Math.max(y2 - y - margin[0] - margin[2], 0)
	  };
	}
	/**
	 * Parse position info.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width]
	 * @param {number|string} [positionInfo.height]
	 * @param {number|string} [positionInfo.aspect] Aspect is width / height
	 * @param {Object} containerRect
	 * @param {string|number} [margin]
	 *
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	
	function getLayoutRect(positionInfo, containerRect, margin) {
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var left = parsePercent(positionInfo.left, containerWidth);
	  var top = parsePercent(positionInfo.top, containerHeight);
	  var right = parsePercent(positionInfo.right, containerWidth);
	  var bottom = parsePercent(positionInfo.bottom, containerHeight);
	  var width = parsePercent(positionInfo.width, containerWidth);
	  var height = parsePercent(positionInfo.height, containerHeight);
	  var verticalMargin = margin[2] + margin[0];
	  var horizontalMargin = margin[1] + margin[3];
	  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
	
	  if (isNaN(width)) {
	    width = containerWidth - right - horizontalMargin - left;
	  }
	
	  if (isNaN(height)) {
	    height = containerHeight - bottom - verticalMargin - top;
	  }
	
	  if (aspect != null) {
	    // If width and height are not given
	    // 1. Graph should not exceeds the container
	    // 2. Aspect must be keeped
	    // 3. Graph should take the space as more as possible
	    // FIXME
	    // Margin is not considered, because there is no case that both
	    // using margin and aspect so far.
	    if (isNaN(width) && isNaN(height)) {
	      if (aspect > containerWidth / containerHeight) {
	        width = containerWidth * 0.8;
	      } else {
	        height = containerHeight * 0.8;
	      }
	    } // Calculate width or height with given aspect
	
	
	    if (isNaN(width)) {
	      width = aspect * height;
	    }
	
	    if (isNaN(height)) {
	      height = width / aspect;
	    }
	  } // If left is not specified, calculate left from right and width
	
	
	  if (isNaN(left)) {
	    left = containerWidth - right - width - horizontalMargin;
	  }
	
	  if (isNaN(top)) {
	    top = containerHeight - bottom - height - verticalMargin;
	  } // Align left and top
	
	
	  switch (positionInfo.left || positionInfo.right) {
	    case 'center':
	      left = containerWidth / 2 - width / 2 - margin[3];
	      break;
	
	    case 'right':
	      left = containerWidth - width - horizontalMargin;
	      break;
	  }
	
	  switch (positionInfo.top || positionInfo.bottom) {
	    case 'middle':
	    case 'center':
	      top = containerHeight / 2 - height / 2 - margin[0];
	      break;
	
	    case 'bottom':
	      top = containerHeight - height - verticalMargin;
	      break;
	  } // If something is wrong and left, top, width, height are calculated as NaN
	
	
	  left = left || 0;
	  top = top || 0;
	
	  if (isNaN(width)) {
	    // Width may be NaN if only one value is given except width
	    width = containerWidth - horizontalMargin - left - (right || 0);
	  }
	
	  if (isNaN(height)) {
	    // Height may be NaN if only one value is given except height
	    height = containerHeight - verticalMargin - top - (bottom || 0);
	  }
	
	  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
	  rect.margin = margin;
	  return rect;
	}
	/**
	 * Position a zr element in viewport
	 *  Group position is specified by either
	 *  {left, top}, {right, bottom}
	 *  If all properties exists, right and bottom will be igonred.
	 *
	 * Logic:
	 *     1. Scale (against origin point in parent coord)
	 *     2. Rotate (against origin point in parent coord)
	 *     3. Traslate (with el.position by this method)
	 * So this method only fixes the last step 'Traslate', which does not affect
	 * scaling and rotating.
	 *
	 * If be called repeatly with the same input el, the same result will be gotten.
	 *
	 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
	 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
	 * @param {Object} containerRect
	 * @param {string|number} margin
	 * @param {Object} [opt]
	 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
	 * @param {Array.<number>} [opt.boundingMode='all']
	 *        Specify how to calculate boundingRect when locating.
	 *        'all': Position the boundingRect that is transformed and uioned
	 *               both itself and its descendants.
	 *               This mode simplies confine the elements in the bounding
	 *               of their container (e.g., using 'right: 0').
	 *        'raw': Position the boundingRect that is not transformed and only itself.
	 *               This mode is useful when you want a element can overflow its
	 *               container. (Consider a rotated circle needs to be located in a corner.)
	 *               In this mode positionInfo.width/height can only be number.
	 */
	
	
	function positionElement(el, positionInfo, containerRect, margin, opt) {
	  var h = !opt || !opt.hv || opt.hv[0];
	  var v = !opt || !opt.hv || opt.hv[1];
	  var boundingMode = opt && opt.boundingMode || 'all';
	
	  if (!h && !v) {
	    return;
	  }
	
	  var rect;
	
	  if (boundingMode === 'raw') {
	    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
	  } else {
	    rect = el.getBoundingRect();
	
	    if (el.needLocalTransform()) {
	      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
	      // which should not be modified.
	
	      rect = rect.clone();
	      rect.applyTransform(transform);
	    }
	  } // The real width and height can not be specified but calculated by the given el.
	
	
	  positionInfo = getLayoutRect(zrUtil.defaults({
	    width: rect.width,
	    height: rect.height
	  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
	  // (see zrender/core/Transformable#getLocalTransform),
	  // we can just only modify el.position to get final result.
	
	  var elPos = el.position;
	  var dx = h ? positionInfo.x - rect.x : 0;
	  var dy = v ? positionInfo.y - rect.y : 0;
	  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
	}
	/**
	 * @param {Object} option Contains some of the properties in HV_NAMES.
	 * @param {number} hvIdx 0: horizontal; 1: vertical.
	 */
	
	
	function sizeCalculable(option, hvIdx) {
	  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
	}
	/**
	 * Consider Case:
	 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
	 * through setOption or media query, using normal zrUtil.merge will cause
	 * {right: 0} does not take effect.
	 *
	 * @example
	 * ComponentModel.extend({
	 *     init: function () {
	 *         ...
	 *         var inputPositionParams = layout.getLayoutParams(option);
	 *         this.mergeOption(inputPositionParams);
	 *     },
	 *     mergeOption: function (newOption) {
	 *         newOption && zrUtil.merge(thisOption, newOption, true);
	 *         layout.mergeLayoutParam(thisOption, newOption);
	 *     }
	 * });
	 *
	 * @param {Object} targetOption
	 * @param {Object} newOption
	 * @param {Object|string} [opt]
	 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
	 *  that width (or height) should not be calculated by left and right (or top and bottom).
	 */
	
	
	function mergeLayoutParam(targetOption, newOption, opt) {
	  !zrUtil.isObject(opt) && (opt = {});
	  var ignoreSize = opt.ignoreSize;
	  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
	  var hResult = merge(HV_NAMES[0], 0);
	  var vResult = merge(HV_NAMES[1], 1);
	  copy(HV_NAMES[0], targetOption, hResult);
	  copy(HV_NAMES[1], targetOption, vResult);
	
	  function merge(names, hvIdx) {
	    var newParams = {};
	    var newValueCount = 0;
	    var merged = {};
	    var mergedValueCount = 0;
	    var enoughParamNumber = 2;
	    each(names, function (name) {
	      merged[name] = targetOption[name];
	    });
	    each(names, function (name) {
	      // Consider case: newOption.width is null, which is
	      // set by user for removing width setting.
	      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
	      hasValue(newParams, name) && newValueCount++;
	      hasValue(merged, name) && mergedValueCount++;
	    });
	
	    if (ignoreSize[hvIdx]) {
	      // Only one of left/right is premitted to exist.
	      if (hasValue(newOption, names[1])) {
	        merged[names[2]] = null;
	      } else if (hasValue(newOption, names[2])) {
	        merged[names[1]] = null;
	      }
	
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // or targetOption: {right: ...} and newOption: {width: ...},
	    // There is no conflict when merged only has params count
	    // little than enoughParamNumber.
	
	
	    if (mergedValueCount === enoughParamNumber || !newValueCount) {
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // Than we can make sure user only want those two, and ignore
	    // all origin params in targetOption.
	    else if (newValueCount >= enoughParamNumber) {
	        return newParams;
	      } else {
	        // Chose another param from targetOption by priority.
	        for (var i = 0; i < names.length; i++) {
	          var name = names[i];
	
	          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
	            newParams[name] = targetOption[name];
	            break;
	          }
	        }
	
	        return newParams;
	      }
	  }
	
	  function hasProp(obj, name) {
	    return obj.hasOwnProperty(name);
	  }
	
	  function hasValue(obj, name) {
	    return obj[name] != null && obj[name] !== 'auto';
	  }
	
	  function copy(names, target, source) {
	    each(names, function (name) {
	      target[name] = source[name];
	    });
	  }
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function getLayoutParams(source) {
	  return copyLayoutParams({}, source);
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function copyLayoutParams(target, source) {
	  source && target && each(LOCATION_PARAMS, function (name) {
	    source.hasOwnProperty(name) && (target[name] = source[name]);
	  });
	  return target;
	}
	
	exports.LOCATION_PARAMS = LOCATION_PARAMS;
	exports.HV_NAMES = HV_NAMES;
	exports.box = box;
	exports.vbox = vbox;
	exports.hbox = hbox;
	exports.getAvailableSize = getAvailableSize;
	exports.getLayoutRect = getLayoutRect;
	exports.positionElement = positionElement;
	exports.sizeCalculable = sizeCalculable;
	exports.mergeLayoutParam = mergeLayoutParam;
	exports.getLayoutParams = getLayoutParams;
	exports.copyLayoutParams = copyLayoutParams;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var textContain = __webpack_require__(86);
	
	var numberUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Text from 'zrender/src/graphic/Text';
	
	/**
	 * add commas after every three numbers
	 * @param {string|number} x
	 * @return {string}
	 */
	function addCommas(x) {
	  if (isNaN(x)) {
	    return '-';
	  }
	
	  x = (x + '').split('.');
	  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
	}
	/**
	 * @param {string} str
	 * @param {boolean} [upperCaseFirst=false]
	 * @return {string} str
	 */
	
	
	function toCamelCase(str, upperCaseFirst) {
	  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
	    return group1.toUpperCase();
	  });
	
	  if (upperCaseFirst && str) {
	    str = str.charAt(0).toUpperCase() + str.slice(1);
	  }
	
	  return str;
	}
	
	var normalizeCssArray = zrUtil.normalizeCssArray;
	var replaceReg = /([&<>"'])/g;
	var replaceMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  '\'': '&#39;'
	};
	
	function encodeHTML(source) {
	  return source == null ? '' : (source + '').replace(replaceReg, function (str, c) {
	    return replaceMap[c];
	  });
	}
	
	var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
	
	var wrapVar = function (varName, seriesIdx) {
	  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
	};
	/**
	 * Template formatter
	 * @param {string} tpl
	 * @param {Array.<Object>|Object} paramsList
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTpl(tpl, paramsList, encode) {
	  if (!zrUtil.isArray(paramsList)) {
	    paramsList = [paramsList];
	  }
	
	  var seriesLen = paramsList.length;
	
	  if (!seriesLen) {
	    return '';
	  }
	
	  var $vars = paramsList[0].$vars || [];
	
	  for (var i = 0; i < $vars.length; i++) {
	    var alias = TPL_VAR_ALIAS[i];
	    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
	  }
	
	  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
	    for (var k = 0; k < $vars.length; k++) {
	      var val = paramsList[seriesIdx][$vars[k]];
	      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
	    }
	  }
	
	  return tpl;
	}
	/**
	 * simple Template formatter
	 *
	 * @param {string} tpl
	 * @param {Object} param
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTplSimple(tpl, param, encode) {
	  zrUtil.each(param, function (value, key) {
	    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
	  });
	  return tpl;
	}
	/**
	 * @param {Object|string} [opt] If string, means color.
	 * @param {string} [opt.color]
	 * @param {string} [opt.extraCssText]
	 * @param {string} [opt.type='item'] 'item' or 'subItem'
	 * @param {string} [opt.renderMode='html'] render mode of tooltip, 'html' or 'richText'
	 * @param {string} [opt.markerId='X'] id name for marker. If only one marker is in a rich text, this can be omitted.
	 * @return {string}
	 */
	
	
	function getTooltipMarker(opt, extraCssText) {
	  opt = zrUtil.isString(opt) ? {
	    color: opt,
	    extraCssText: extraCssText
	  } : opt || {};
	  var color = opt.color;
	  var type = opt.type;
	  var extraCssText = opt.extraCssText;
	  var renderMode = opt.renderMode || 'html';
	  var markerId = opt.markerId || 'X';
	
	  if (!color) {
	    return '';
	  }
	
	  if (renderMode === 'html') {
	    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
	  } else {
	    // Space for rich element marker
	    return {
	      renderMode: renderMode,
	      content: '{marker' + markerId + '|}  ',
	      style: {
	        color: color
	      }
	    };
	  }
	}
	
	function pad(str, len) {
	  str += '';
	  return '0000'.substr(0, len - str.length) + str;
	}
	/**
	 * ISO Date format
	 * @param {string} tpl
	 * @param {number} value
	 * @param {boolean} [isUTC=false] Default in local time.
	 *           see `module:echarts/scale/Time`
	 *           and `module:echarts/util/number#parseDate`.
	 * @inner
	 */
	
	
	function formatTime(tpl, value, isUTC) {
	  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
	    tpl = 'MM-dd\nyyyy';
	  }
	
	  var date = numberUtil.parseDate(value);
	  var utc = isUTC ? 'UTC' : '';
	  var y = date['get' + utc + 'FullYear']();
	  var M = date['get' + utc + 'Month']() + 1;
	  var d = date['get' + utc + 'Date']();
	  var h = date['get' + utc + 'Hours']();
	  var m = date['get' + utc + 'Minutes']();
	  var s = date['get' + utc + 'Seconds']();
	  var S = date['get' + utc + 'Milliseconds']();
	  tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
	  return tpl;
	}
	/**
	 * Capital first
	 * @param {string} str
	 * @return {string}
	 */
	
	
	function capitalFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
	}
	
	var truncateText = textContain.truncateText;
	/**
	 * @public
	 * @param {Object} opt
	 * @param {string} opt.text
	 * @param {string} opt.font
	 * @param {string} [opt.textAlign='left']
	 * @param {string} [opt.textVerticalAlign='top']
	 * @param {Array.<number>} [opt.textPadding]
	 * @param {number} [opt.textLineHeight]
	 * @param {Object} [opt.rich]
	 * @param {Object} [opt.truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	function getTextBoundingRect(opt) {
	  return textContain.getBoundingRect(opt.text, opt.font, opt.textAlign, opt.textVerticalAlign, opt.textPadding, opt.textLineHeight, opt.rich, opt.truncate);
	}
	/**
	 * @deprecated
	 * the `textLineHeight` was added later.
	 * For backward compatiblility, put it as the last parameter.
	 * But deprecated this interface. Please use `getTextBoundingRect` instead.
	 */
	
	
	function getTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate, textLineHeight) {
	  return textContain.getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate);
	}
	/**
	 * open new tab
	 * @param {string} link url
	 * @param {string} target blank or self
	 */
	
	
	function windowOpen(link, target) {
	  if (target === '_blank' || target === 'blank') {
	    var blank = window.open();
	    blank.opener = null;
	    blank.location = link;
	  } else {
	    window.open(link, target);
	  }
	}
	
	exports.addCommas = addCommas;
	exports.toCamelCase = toCamelCase;
	exports.normalizeCssArray = normalizeCssArray;
	exports.encodeHTML = encodeHTML;
	exports.formatTpl = formatTpl;
	exports.formatTplSimple = formatTplSimple;
	exports.getTooltipMarker = getTooltipMarker;
	exports.formatTime = formatTime;
	exports.capitalFirst = capitalFirst;
	exports.truncateText = truncateText;
	exports.getTextBoundingRect = getTextBoundingRect;
	exports.getTextRect = getTextRect;
	exports.windowOpen = windowOpen;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/* global Float32Array */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * 创建一个向量
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @return {Vector2}
	 */
	
	function create(x, y) {
	  var out = new ArrayCtor(2);
	
	  if (x == null) {
	    x = 0;
	  }
	
	  if (y == null) {
	    y = 0;
	  }
	
	  out[0] = x;
	  out[1] = y;
	  return out;
	}
	/**
	 * 复制向量数据
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function copy(out, v) {
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 克隆一个向量
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function clone(v) {
	  var out = new ArrayCtor(2);
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 设置向量的两个项
	 * @param {Vector2} out
	 * @param {number} a
	 * @param {number} b
	 * @return {Vector2} 结果
	 */
	
	
	function set(out, a, b) {
	  out[0] = a;
	  out[1] = b;
	  return out;
	}
	/**
	 * 向量相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function add(out, v1, v2) {
	  out[0] = v1[0] + v2[0];
	  out[1] = v1[1] + v2[1];
	  return out;
	}
	/**
	 * 向量缩放后相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} a
	 */
	
	
	function scaleAndAdd(out, v1, v2, a) {
	  out[0] = v1[0] + v2[0] * a;
	  out[1] = v1[1] + v2[1] * a;
	  return out;
	}
	/**
	 * 向量相减
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function sub(out, v1, v2) {
	  out[0] = v1[0] - v2[0];
	  out[1] = v1[1] - v2[1];
	  return out;
	}
	/**
	 * 向量长度
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	
	function len(v) {
	  return Math.sqrt(lenSquare(v));
	}
	
	var length = len; // jshint ignore:line
	
	/**
	 * 向量长度平方
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	function lenSquare(v) {
	  return v[0] * v[0] + v[1] * v[1];
	}
	
	var lengthSquare = lenSquare;
	/**
	 * 向量乘法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	function mul(out, v1, v2) {
	  out[0] = v1[0] * v2[0];
	  out[1] = v1[1] * v2[1];
	  return out;
	}
	/**
	 * 向量除法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function div(out, v1, v2) {
	  out[0] = v1[0] / v2[0];
	  out[1] = v1[1] / v2[1];
	  return out;
	}
	/**
	 * 向量点乘
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function dot(v1, v2) {
	  return v1[0] * v2[0] + v1[1] * v2[1];
	}
	/**
	 * 向量缩放
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {number} s
	 */
	
	
	function scale(out, v, s) {
	  out[0] = v[0] * s;
	  out[1] = v[1] * s;
	  return out;
	}
	/**
	 * 向量归一化
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	
	function normalize(out, v) {
	  var d = len(v);
	
	  if (d === 0) {
	    out[0] = 0;
	    out[1] = 0;
	  } else {
	    out[0] = v[0] / d;
	    out[1] = v[1] / d;
	  }
	
	  return out;
	}
	/**
	 * 计算向量间距离
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function distance(v1, v2) {
	  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
	}
	
	var dist = distance;
	/**
	 * 向量距离平方
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	function distanceSquare(v1, v2) {
	  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
	}
	
	var distSquare = distanceSquare;
	/**
	 * 求负向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	function negate(out, v) {
	  out[0] = -v[0];
	  out[1] = -v[1];
	  return out;
	}
	/**
	 * 插值两个点
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} t
	 */
	
	
	function lerp(out, v1, v2, t) {
	  out[0] = v1[0] + t * (v2[0] - v1[0]);
	  out[1] = v1[1] + t * (v2[1] - v1[1]);
	  return out;
	}
	/**
	 * 矩阵左乘向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {Vector2} m
	 */
	
	
	function applyTransform(out, v, m) {
	  var x = v[0];
	  var y = v[1];
	  out[0] = m[0] * x + m[2] * y + m[4];
	  out[1] = m[1] * x + m[3] * y + m[5];
	  return out;
	}
	/**
	 * 求两个向量最小值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function min(out, v1, v2) {
	  out[0] = Math.min(v1[0], v2[0]);
	  out[1] = Math.min(v1[1], v2[1]);
	  return out;
	}
	/**
	 * 求两个向量最大值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function max(out, v1, v2) {
	  out[0] = Math.max(v1[0], v2[0]);
	  out[1] = Math.max(v1[1], v2[1]);
	  return out;
	}
	
	exports.create = create;
	exports.copy = copy;
	exports.clone = clone;
	exports.set = set;
	exports.add = add;
	exports.scaleAndAdd = scaleAndAdd;
	exports.sub = sub;
	exports.len = len;
	exports.length = length;
	exports.lenSquare = lenSquare;
	exports.lengthSquare = lengthSquare;
	exports.mul = mul;
	exports.div = div;
	exports.dot = dot;
	exports.scale = scale;
	exports.normalize = normalize;
	exports.distance = distance;
	exports.dist = dist;
	exports.distanceSquare = distanceSquare;
	exports.distSquare = distSquare;
	exports.negate = negate;
	exports.lerp = lerp;
	exports.applyTransform = applyTransform;
	exports.min = min;
	exports.max = max;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__(1930);
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__(440);
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__(1931);
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__(1932);
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Raised = __webpack_require__(1933);
	
	Object.defineProperty(exports, 'Raised', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Raised).default;
	  }
	});
	
	var _Saturation = __webpack_require__(1934);
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(879);
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Swatch = __webpack_require__(1935);
	
	Object.defineProperty(exports, 'Swatch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(49);
	
	var matrix = __webpack_require__(75);
	
	/**
	 * @module echarts/core/BoundingRect
	 */
	var v2ApplyTransform = vec2.applyTransform;
	var mathMin = Math.min;
	var mathMax = Math.max;
	/**
	 * @alias module:echarts/core/BoundingRect
	 */
	
	function BoundingRect(x, y, width, height) {
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	  /**
	   * @type {number}
	   */
	
	
	  this.x = x;
	  /**
	   * @type {number}
	   */
	
	  this.y = y;
	  /**
	   * @type {number}
	   */
	
	  this.width = width;
	  /**
	   * @type {number}
	   */
	
	  this.height = height;
	}
	
	BoundingRect.prototype = {
	  constructor: BoundingRect,
	
	  /**
	   * @param {module:echarts/core/BoundingRect} other
	   */
	  union: function (other) {
	    var x = mathMin(other.x, this.x);
	    var y = mathMin(other.y, this.y);
	    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
	    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
	    this.x = x;
	    this.y = y;
	  },
	
	  /**
	   * @param {Array.<number>} m
	   * @methods
	   */
	  applyTransform: function () {
	    var lt = [];
	    var rb = [];
	    var lb = [];
	    var rt = [];
	    return function (m) {
	      // In case usage like this
	      // el.getBoundingRect().applyTransform(el.transform)
	      // And element has no transform
	      if (!m) {
	        return;
	      }
	
	      lt[0] = lb[0] = this.x;
	      lt[1] = rt[1] = this.y;
	      rb[0] = rt[0] = this.x + this.width;
	      rb[1] = lb[1] = this.y + this.height;
	      v2ApplyTransform(lt, lt, m);
	      v2ApplyTransform(rb, rb, m);
	      v2ApplyTransform(lb, lb, m);
	      v2ApplyTransform(rt, rt, m);
	      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
	      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
	      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
	      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
	      this.width = maxX - this.x;
	      this.height = maxY - this.y;
	    };
	  }(),
	
	  /**
	   * Calculate matrix of transforming from self to target rect
	   * @param  {module:zrender/core/BoundingRect} b
	   * @return {Array.<number>}
	   */
	  calculateTransform: function (b) {
	    var a = this;
	    var sx = b.width / a.width;
	    var sy = b.height / a.height;
	    var m = matrix.create(); // 矩阵右乘
	
	    matrix.translate(m, m, [-a.x, -a.y]);
	    matrix.scale(m, m, [sx, sy]);
	    matrix.translate(m, m, [b.x, b.y]);
	    return m;
	  },
	
	  /**
	   * @param {(module:echarts/core/BoundingRect|Object)} b
	   * @return {boolean}
	   */
	  intersect: function (b) {
	    if (!b) {
	      return false;
	    }
	
	    if (!(b instanceof BoundingRect)) {
	      // Normalize negative width/height.
	      b = BoundingRect.create(b);
	    }
	
	    var a = this;
	    var ax0 = a.x;
	    var ax1 = a.x + a.width;
	    var ay0 = a.y;
	    var ay1 = a.y + a.height;
	    var bx0 = b.x;
	    var bx1 = b.x + b.width;
	    var by0 = b.y;
	    var by1 = b.y + b.height;
	    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
	  },
	  contain: function (x, y) {
	    var rect = this;
	    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
	  },
	
	  /**
	   * @return {module:echarts/core/BoundingRect}
	   */
	  clone: function () {
	    return new BoundingRect(this.x, this.y, this.width, this.height);
	  },
	
	  /**
	   * Copy from another rect
	   */
	  copy: function (other) {
	    this.x = other.x;
	    this.y = other.y;
	    this.width = other.width;
	    this.height = other.height;
	  },
	  plain: function () {
	    return {
	      x: this.x,
	      y: this.y,
	      width: this.width,
	      height: this.height
	    };
	  }
	};
	/**
	 * @param {Object|module:zrender/core/BoundingRect} rect
	 * @param {number} rect.x
	 * @param {number} rect.y
	 * @param {number} rect.width
	 * @param {number} rect.height
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	BoundingRect.create = function (rect) {
	  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
	};
	
	var _default = BoundingRect;
	module.exports = _default;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sgiCtnBaseFun = exports.addCtnCommonAttribute = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * 容器组件的公共方法
	 * wangz
	 * 2018.3.9
	 */
	
	/**
	* 属性转换
	* @param {描述信息} moduleDesc
	* @param {属性} formProps
	*/
	var addCtnCommonAttribute = function addCtnCommonAttribute(currentModule, moduleDesc, ctnProps, ctnBodyProps) {
	    var cId = moduleDesc.cId; //cid 唯一标示
	    if (cId) ctnProps.id = (0, _SgiCommon.getConstByKey)(currentModule, cId);
	
	    var ctlW = moduleDesc.ctlW; //form宽度
	    ctnProps.style.width = ctlW;
	    if (ctlW == 0 || ctlW == '0px') {
	        ctnProps.style.width = undefined;
	    }
	
	    var ctlH = moduleDesc.ctlH; //form高度
	    ctnProps.style.height = ctlH;
	    if (ctlH == 0 || ctlH == '0px') {
	        ctnProps.style.height = undefined;
	    }
	
	    var isBrdr = moduleDesc.isBrdr; //form是否有边框??没实现
	    if (isBrdr) {
	        ctnProps.style.border = "1px solid rgb(217, 217, 217)"; /*边线宽度 类型 颜色*/;
	    } else {
	        ctnProps.style.border = undefined;
	    }
	
	    var mgn = moduleDesc.mgn; //form外边距
	    if (mgn) ctnProps.style.margin = mgn;
	    var pad = moduleDesc.pad; //form内边距
	    if (pad) ctnProps.style.padding = pad;
	
	    var isHdn = moduleDesc.isHdn; //form是否隐藏
	    if (isHdn) {
	        ctnProps.style.display = "none";
	    } else {
	        ctnProps.style.display = undefined;
	    }
	
	    var isScl = moduleDesc.isScl; //form是否可以滚动
	    if (isScl) {
	        if (!ctnBodyProps) ctnProps.style.overflow = "auto";
	        if (ctnBodyProps) ctnBodyProps.style.overflow = "auto";
	    } else {
	        if (!ctnBodyProps) ctnProps.style.overflow = undefined;
	        if (ctnBodyProps) ctnBodyProps.style.overflow = undefined;
	    }
	
	    //公共属性里统一进行文本资源转换，各个控件可直接从ctnProps.te中取出结果，不再需要单独转换
	    // if (moduleDesc.te || moduleDesc.teid) {//如果te和teid都不存在则不查找资源
	    //     var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
	    //     if (te) ctnProps.te = te;
	    // }
	    var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
	    ctnProps.te = te;
	
	    // 初始加载中
	    currentModule.state.loading = !!moduleDesc.loading;
	
	    // 自定义样式
	    var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(currentModule, "cstmStyle");
	    if (getCstmStyle) {
	        // currentModule.state.cstmStyle = getCstmStyle;
	    } else {
	        var cstmStyle = moduleDesc.cstmStyle;
	        var $cstmStyle = void 0;
	        if (cstmStyle) {
	            try {
	                $cstmStyle = new Function("module", "objFct", cstmStyle);
	            } catch (error) {
	                _sgiLogger.sgiLogger.eventErr(error);
	            }
	            // 不再在state中存放方法
	            // currentModule.state.cstmStyle = $cstmStyle;
	            (0, _SgiCommon.setFunction)(currentModule, "cstmStyle", $cstmStyle);
	        }
	    }
	};
	
	var sgiCtnBaseFun = {
	    /**
	     * 设置是否隐藏
	     */
	    setHidden: function setHidden(value) {
	        var props = this.state.formProps || this.state.panelProps || this.state.tabsProps || this.state.collapseProps || this.state.CardProps;
	        if (value) {
	            props.style.display = "none";
	        } else {
	            props.style.display = undefined;
	        }
	        if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	            // react16需要更新引用
	            props.style = _extends({}, props.style);
	        }
	        this.setState({ loading: false });
	    },
	    add: function add(module) {
	        if (!module) {
	            return;
	        }
	        var sonItems = this.state.formItems || this.state.panelItems;
	        if (!sonItems) {
	            return;
	        }
	        sonItems.push(module);
	        if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	            // react16需要更新引用
	            sonItems = [].concat(_toConsumableArray(sonItems));
	        }
	        this.setState({ loading: false });
	    },
	    removeAll: function removeAll() {
	        this.props.moduleDesc.cldSet = [];
	        this.refresh();
	    },
	    /**
	     * id 可能为guid 可能为cid
	     */
	    remove: function remove(id) {
	        if (!id) {
	            return;
	        }
	        var sonItems = this.props.moduleDesc.cldSet;
	        if (!sonItems) {
	            return;
	        }
	        var tmpItem = void 0;
	        var tmpId = void 0;
	        for (var i = 0; i < sonItems.length; i++) {
	            tmpItem = sonItems[i];
	            if (!tmpItem) {
	                continue;
	            }
	            tmpId = tmpItem.guid || (0, _SgiCommon.getConstByKey)(this, tmpItem.cId);
	            if (id == tmpId) {
	                sonItems.splice(i, 1);
	                break;
	            }
	        }
	        this.refresh();
	    },
	    setLoading: function setLoading(loading) {
	        this.setState({ loading: loading });
	    },
	    // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
	    renderBeforeReturn: function renderBeforeReturn(wrapProps) {
	        var _props = this.props,
	            parentModule = _props.parentModule,
	            moduleDesc = _props.moduleDesc,
	            objFct = _props.objFct,
	            type = _props.type;
	
	        // 自定义样式处理
	        // const getCstmStyle = this.state.cstmStyle;
	
	        var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(this, "cstmStyle");;
	        var cstmStyle = {};
	        if (getCstmStyle) {
	            try {
	                cstmStyle = getCstmStyle(this, objFct) || {};
	            } catch (error) {
	                tool.sgiLogger.log(error);
	            }
	        }
	        Object.assign(wrapProps.style, cstmStyle);
	    }
	};
	
	exports.addCtnCommonAttribute = addCtnCommonAttribute;
	exports.sgiCtnBaseFun = sgiCtnBaseFun;
	exports.default = { addCtnCommonAttribute: addCtnCommonAttribute, sgiCtnBaseFun: sgiCtnBaseFun };

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(14);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiEventHandler = undefined;
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _SgiCommon = __webpack_require__(29);
	
	/*  控件常用监听操作
	 归属：企通前端平台-ECP V5.1
	 版权：2014-2020 企通软件技术有限公司
	 --------------------------------------------------------------------------------
	 作者：王哲                           创建日期：2014/03/24
	 修改：                               修改日期：
	 修改内容
	 --------------------------------------------------------------------------------
	 常用控件的监听程序：包括
	 进入事件
	 变更事件
	 离开事件
	 点击事件
	 表格点击事件
	 树控件点击事件
	 *******************************************************************************/
	var SgiEventHandler = {
	    /**
	     * 点击事件
	     *
	     * @param {type}
	     *            ctl 控件本身
	     * @param {type}
	     *            eo 事件
	     */
	    onClick: function onClick(eo) {
	
	        try {
	            _rtSdCommon.sgiLogger.eventin(eo);
	            tool.sgiLogger.log('点击事件入口');
	
	            var objFct = this.props.objFct;
	            //2020 7.14增加重复点击功能
	
	            var that = this; // 为定时器中的setState绑定this
	            var repeatClickFlag = this.state.repeatClickFlag;
	
	            if (repeatClickFlag) {
	                return;
	            } else {
	                this.setState({ repeatClickFlag: true });
	            }
	            setTimeout(function () {
	                // 设置延迟事件，1秒后将执行
	                that.setState({ repeatClickFlag: false }); // 将isClick设置为true
	            }, 500);
	
	            var onClick = (0, _SgiCommon.getFunctionByKey)(this, "onClick");
	            if (onClick) {
	                onClick(this, objFct);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 进入事件
	     *
	     * @param {type}
	     *            ctl 控件本身
	     * @param {type}
	     *            eo 事件
	     */
	    onFocus: function onFocus(currentModule, eo) {
	        try {
	            _rtSdCommon.sgiLogger.eventin(eo);
	            tool.sgiLogger.log('进入事件入口');
	            var objFct = currentModule.props.objFct;
	            // let onFocus = currentModule.data.functions.onFocus;
	
	            var onFocus = (0, _SgiCommon.getFunctionByKey)(currentModule, "onFocus");
	            if (onFocus) {
	                onFocus(currentModule, objFct);
	            }
	            if (currentModule._onFocus) {
	                currentModule._onFocus();
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 焦点离开监听
	     *
	     * @param {type}
	     *            ctl 控件本身
	     * @param {type}
	     *            eo 事件
	     */
	    onBlur: function onBlur(currentModule, eo) {
	        try {
	            _rtSdCommon.sgiLogger.eventin(eo);
	            tool.sgiLogger.log('离开事件入口');
	            var objFct = currentModule.props.objFct;
	            // let onBlur = currentModule.data.functions.onBlur;
	
	            var onBlur = (0, _SgiCommon.getFunctionByKey)(currentModule, "onBlur");
	            if (onBlur) {
	                onBlur(currentModule, objFct);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 修改监听
	     *
	     * @param {type}
	     *            ctl 控件
	     * @param {type}
	     *            nV 新值
	     * @param {type}
	     *            oV 旧值
	     * @returns {undefined}
	     */
	    onChange: function onChange(currentModule, e, e2, e3) {
	        try {
	            tool.sgiLogger.log("change进入");
	            var _currentModule$props = currentModule.props,
	                moduleDesc = _currentModule$props.moduleDesc,
	                bdInst = _currentModule$props.bdInst,
	                objFct = _currentModule$props.objFct,
	                type = _currentModule$props.type;
	
	            var mdType = moduleDesc.desId;
	            var newvalue,
	                valueItem = {};
	            if (mdType === _rtSdCommon.AllCompGUID.DATE) {
	                //日期
	                newvalue = handleOnSelDate(currentModule, moduleDesc.c, bdInst, objFct, e, e2, moduleDesc.dateFmt);
	            } else if (mdType === _rtSdCommon.AllCompGUID.NUMBER) {
	                //数字
	                newvalue = handleOnNumberChange(currentModule, moduleDesc.c, bdInst, objFct, e);
	            } else if (mdType === _rtSdCommon.AllCompGUID.TIME) {
	                //时间
	                newvalue = handleOnSelTime(currentModule, moduleDesc.c, bdInst, objFct, e, e2, moduleDesc.dateFmt);
	            } else if (mdType === _rtSdCommon.AllCompGUID.UPLOADFILE) {
	                //上传
	                newvalue = handleOnFileChange(currentModule, moduleDesc.c, bdInst, objFct, e);
	            } else if (mdType === _rtSdCommon.AllCompGUID.CHECKBOXGROUP) {
	                //复选框组
	                newvalue = handleCheckBoxGroupChange(currentModule, moduleDesc.c, bdInst, objFct, e);
	            } else if (mdType === _rtSdCommon.AllCompGUID.CHECKBOX) {
	                //复选框
	                newvalue = handleCheckBoxChange(currentModule, moduleDesc.c, bdInst, objFct, e);
	            } else if (mdType === _rtSdCommon.AllCompGUID.COMBOXTREE) {
	                //下拉树
	                valueItem = handleOnTreeSelectChange(currentModule, moduleDesc.c, bdInst, objFct, e, e2, e3) || {};
	                newvalue = valueItem.value;
	            } else if (mdType === _rtSdCommon.AllCompGUID.COMBOBOX) {
	                //下拉窗
	                //多选的时候 e是选中事件还是取消选中的标志
	                valueItem = handleOnComboxChange(currentModule, moduleDesc.c, bdInst, objFct, e, e2) || {};
	                newvalue = valueItem.value;
	            } else if (mdType === _rtSdCommon.AllCompGUID.CASCADER) {
	                //级联组件
	                //多选的时候 e是选中事件还是取消选中的标志
	                valueItem = handleOnCascaderChange(currentModule, moduleDesc.c, bdInst, objFct, e, e2);
	                newvalue = valueItem.value;
	            } else if (mdType === _rtSdCommon.AllCompGUID.EDITOR) {
	                //富文本
	                newvalue = handleOnEditorChange(currentModule, moduleDesc.c, bdInst, objFct, e);
	            } else if (mdType === _rtSdCommon.AllCompGUID.TINYMCE) {
	                //tinymce富文本
	                newvalue = handleOnTinyMCEChange(currentModule, moduleDesc.c, bdInst, objFct, e, e2);
	            } else if (mdType === _rtSdCommon.AllCompGUID.CODEMIRROR_FORM) {
	                //codemirror
	                newvalue = e3;
	                currentModule.ctlRefresh(moduleDesc.c, bdInst, objFct, newvalue);
	            } else {
	                //调用统一  修改事件
	                newvalue = handleOnChange(currentModule, moduleDesc.c, bdInst, objFct, e);
	            }
	
	            // //调用自定义事件
	            // if (mdType === AllCompGUID.UPLOADFILE) {//文件控件特殊处理，添加status参数
	            //     let onChange = currentModule.data.functions.onChange;
	            //     if (onChange) {
	            //         sgiLogger.eventin('修改');
	            //         let status;
	            //         if (e && e.file && e.file.status) {
	            //             status = e.file.status;
	            //         }
	            //         onChange(currentModule, objFct, newvalue, objFct.get(bdInst), status);
	            //     }
	            // } else {//通用方式
	            //     let onChange = currentModule.data.functions.onChange;
	            //     if (onChange) {
	            //         sgiLogger.eventin('修改');
	            //         onChange(currentModule, objFct, newvalue, objFct.get(bdInst));
	            //     }
	            // }
	
	            //调用自定义事件
	            // let onChange = currentModule.data.functions.onChange;
	            var onChange = (0, _SgiCommon.getFunctionByKey)(currentModule, "onChange");
	            if (onChange) {
	                _rtSdCommon.sgiLogger.eventin('修改');
	                var bdInstData = void 0;
	                if (typeof bdInst === "string") {
	                    if (type === "tb") {
	                        //兼容表格内自定义组件自定义修改事件
	                        var bdInstKeyList = bdInst.split('`');
	                        var bdInstList = objFct.get(bdInstKeyList[0]);
	                        if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                            bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
	                        }
	                    } else {
	                        bdInstData = objFct.get(bdInst);
	                    }
	                } else {
	                    bdInstData = bdInst;
	                }
	
	                if (mdType === _rtSdCommon.AllCompGUID.UPLOADFILE) {
	                    //上传控件
	                    onChange(currentModule, objFct, bdInstData, newvalue, e.file, e.file.response, e.fileList);
	                } else if (mdType === _rtSdCommon.AllCompGUID.CODEMIRROR_FORM) {
	                    //codemirror
	                    onChange(currentModule, objFct, bdInstData, newvalue, e2, e);
	                } else {
	                    onChange(currentModule, objFct, bdInstData, newvalue, valueItem.title, valueItem.itemData, e2);
	                }
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	
	    /**
	     * codemirror修改事件
	     * @param {*} editor 
	     * @param {*} data 
	     * @param {*} value 
	     */
	    onCodeMirrorChange: function onCodeMirrorChange(editor, data, value) {
	        try {
	            _rtSdCommon.sgiLogger.debug("codemirror修改事件入口");
	            var objFct = this.props.objFct;
	
	            var onChange = (0, _SgiCommon.getFunctionByKey)(this, "onChange");
	            if (onChange) onChange(this, objFct, value, data, editor);
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	
	    /**
	     * jsoneditor修改事件
	     * @param {object} editor jsoneditor实例
	     * @param {string} text json字符串
	     * @param {json} json json对象|数组
	     */
	    onJsoneditorChange: function onJsoneditorChange(editor, text, json) {
	        try {
	            _rtSdCommon.sgiLogger.debug("jsoneditor修改事件入口");
	            var objFct = this.props.objFct;
	
	            var onChange = (0, _SgiCommon.getFunctionByKey)(this, "onChange");
	            if (onChange) onChange(this, editor, objFct, text, json);
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	
	    /**
	     * 菜单控件 MenuItem 点击事件
	     * @param  {[type]} item [description]
	     * @return {[type]}      [description]
	     */
	    menuClick: function menuClick(item) {
	        try {
	            // tool.sgiLogger.log(arguments);
	            // tool.sgiLogger.log("menuClick:", item);
	            tool.sgiLogger.log('菜单点击事件入口');
	            var objFct = this.props.objFct;
	            // let onClick = this.data.functions.onClick;
	
	            var onClick = (0, _SgiCommon.getFunctionByKey)(this, "onClick");
	            if (onClick) {
	                onClick(this, objFct, item.item.props.itemData, item);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 弹出窗自定义单击监听
	     * @param  {[type]} value [description]
	     * @return {[type]}       [description]
	     */
	    onSearch: function onSearch(value) {
	        try {
	            tool.sgiLogger.log(' 弹出窗自定义点击事件入口');
	            var objFct = this.props.objFct;
	            // let onSearch = this.data.functions.onSearch;
	
	            var onSearch = (0, _SgiCommon.getFunctionByKey)(this, "onSearch");
	            if (onSearch) {
	                onSearch(this, objFct, value);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 表格、树选择监听
	     *
	     * @param {type}
	     *            ctl
	     * @param {type}
	     *            r
	     * @param {type}
	     *            index
	     * @returns {undefined}
	     */
	    select: function select(ctl, r, index) {
	        try {
	            // tool.sgiLogger.log(arguments);
	            tool.sgiLogger.log('点击表格事件入口');
	            // tool.sgiLogger.log(this.data.functions);
	            var tcl = this.data.functions.tab;
	            if (tcl) {
	                tcl();
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 树单击监听
	     *
	     * @param {type}
	     *            selectedKeys
	     * @param {type}
	     *            info
	     * @returns {undefined}
	     */
	    itemclick: function itemclick(selectedKeys, e) {
	        var _this = this;
	
	        try {
	            tool.sgiLogger.log('点击树事件入口');
	            this.state.selectedKeys = selectedKeys;
	            // this.state.checkedKeys = selectedKeys;
	            this.setState({ loading: false });
	            // tool.sgiLogger.log('selected', selectedKeys, e);
	
	            // this.state.checkedNodes = [];
	            this.state.selectedNodes = [];
	            var checkedNodes = e.selectedNodes || e.checkedNodes;
	            // if (checkedNodes) checkedNodes.forEach(element => {
	            //     this.state.checkedNodes.push(element.props.itemData);
	            // })
	
	            if (checkedNodes) checkedNodes.forEach(function (element) {
	                _this.state.selectedNodes.push(element.props.itemData);
	            });
	
	            //当前操作节点，当前treeNode
	            var record = e.node.props.itemData;
	            var treeNode = e.node.props;
	
	            tool.sgiLogger.log("record", record);
	
	            var objFct = this.props.objFct;
	            // let onSelect = this.data.functions.onSelect;
	
	            var onSelect = (0, _SgiCommon.getFunctionByKey)(this, "onSelect");
	            if (onSelect) {
	                onSelect(this, objFct, record, treeNode, e);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 树双击事件
	     * @param {*} e 
	     * @param {*} node 
	     */
	    itemDoubleClick: function itemDoubleClick(e, node) {
	        try {
	            tool.sgiLogger.log('树双击事件');
	
	            var record = node.props.itemData;
	            var treeNode = node.props;
	            var objFct = this.props.objFct;
	
	
	            tool.sgiLogger.log("record", record);
	
	            // let onDoubleClick = this.data.functions.onDoubleClick;
	            var onDoubleClick = (0, _SgiCommon.getFunctionByKey)(this, "onDoubleClick");
	            if (onDoubleClick) {
	                onDoubleClick(this, objFct, record, treeNode, node, e);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 树勾选监听
	     *
	     * @param {type}
	     *            checkedKeys
	     * @param {type}
	     *            info
	     * @returns {undefined}
	     */
	    itemCheck: function itemCheck(checkedKeys, e) {
	        try {
	            tool.sgiLogger.log('勾选树事件入口');
	
	            //当前操作节点，当前treeNode
	            var record = e.node.props.itemData;
	            var treeNode = e.node.props;
	            var objFct = this.props.objFct;
	
	
	            tool.sgiLogger.log("record", record);
	
	            // let onCheck = this.data.functions.onCheck;
	            var onCheck = (0, _SgiCommon.getFunctionByKey)(this, "onCheck");
	            if (onCheck) {
	                onCheck(this, objFct, record, treeNode, e.checked, e);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 树右键点击事件
	     * @param {object} { event, node } 
	     */
	    itemRightClick: function itemRightClick(_ref) {
	        var event = _ref.event,
	            node = _ref.node;
	
	        try {
	            tool.sgiLogger.log('右键点击事件入口');
	
	            var treeNode = node.props;
	            var record = treeNode.itemData;
	            var objFct = this.props.objFct;
	
	            // let onRightClick = this.data.functions.onRightClick;
	
	            var onRightClick = (0, _SgiCommon.getFunctionByKey)(this, "onRightClick");
	
	            //右键菜单 是否可以点击
	            var rightMenuFlag = true;
	            if (onRightClick) {
	                rightMenuFlag = onRightClick(this, objFct, record, treeNode);
	            }
	
	            if (rightMenuFlag) {
	                this.setState({
	                    rightClickNodeTreeItem: {
	                        pageX: event.pageX,
	                        pageY: event.pageY,
	                        record: record,
	                        treeNode: treeNode
	                    },
	                    ContextMenuVisible: undefined
	                });
	            } else {
	                this.setState({
	                    ContextMenuVisible: "none"
	                });
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 树右键菜单点击事件
	     * @param {object} record 当前树节点数据对象
	     * @param {object} e 事件对象
	     */
	    menuOnClick: function menuOnClick(record, e) {
	        try {
	            tool.sgiLogger.log('菜单点击事件 record :', record);
	
	            var key = this.state.key;
	
	            var treeNode = this.state.keysTreeNode[record[key]].props;
	
	            this.setState({ ContextMenuVisible: "none" });
	
	            var onClick = this.state.menuFuns[e.key];
	            if (onClick) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	
	                onClick(this, objFct, record, treeNode);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 表格单击监听
	     *
	     * @param {type} 当前选中行对象
	     *            record
	     * @param {type} 行序号/索引，从0开始
	     *            index
	     * @returns {undefined}
	     */
	    tableClick: function tableClick(record, index) {
	        try {
	            tool.sgiLogger.log('表格单击事件', record, index);
	            //选择9的时候 没有单选多选控件的时候 点击放入选中数据
	            if (this.props.moduleDesc.rowSMd == '9') {
	                this.setState.selectedRows = [record];
	            }
	
	            var objFct = this.props.objFct;
	            // let onRowClick = this.data.functions.onRowClick;
	
	            var onRowClick = (0, _SgiCommon.getFunctionByKey)(this, "onRowClick");
	            if (onRowClick) {
	                onRowClick(this, objFct, record, index);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 双击监听
	     *
	     * @param {type}
	     *            ctl
	     * @param {type}
	     *            r
	     * @param {type}
	     *            item
	     * @param {type}
	     *            ind
	     * @returns {undefined}
	     */
	    itemdblclick: function itemdblclick(record, index) {
	        try {
	            tool.sgiLogger.log('表格双击事件', record, index);
	            // this.setState({ selectedRows: [record] });
	            var objFct = this.props.objFct;
	            // let onRowDoubleClick = this.data.functions.onRowDoubleClick;
	
	            var onRowDoubleClick = (0, _SgiCommon.getFunctionByKey)(this, "onRowDoubleClick");
	            if (onRowDoubleClick) {
	                onRowDoubleClick(this, objFct, record, index);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 表格勾选监听
	     *
	     * @param {type} 当前选中行对象
	     *            record
	     * @param {type} 行序号/索引，从0开始
	     *            index
	     * @returns {undefined}
	     */
	    tableCheck: function tableCheck(selectType, record, selected, selectedRows) {
	        try {
	            tool.sgiLogger.log('表格勾选事件', selectType, record, selected, selectedRows);
	
	            var objFct = this.props.objFct;
	            // let onRowCheck = this.data.functions.onRowCheck;
	
	            var onRowCheck = (0, _SgiCommon.getFunctionByKey)(this, "onRowCheck");
	            if (onRowCheck) {
	                onRowCheck(this, objFct, selectType, record, selected, selectedRows);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 选项卡切换监听器
	     *
	     * @param {object}
	     *            ctn 容器对象
	     * @returns {undefined}
	     */
	    tcl: function tcl(activeKey) {
	        try {
	            tool.sgiLogger.log('Tab切换事件');
	            var objFct = this.props.objFct;
	
	            this.setState({ activeKey: activeKey });
	            // let tcl = this.data.functions.tab;
	            var tcl = (0, _SgiCommon.getFunctionByKey)(this, "tab");
	            if (tcl) {
	                tcl(this, objFct, activeKey);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 层叠面板展开事件监听器
	     *
	     * @param {object}
	     *            ctn 容器对象
	     * @returns {undefined}
	     */
	    expd: function expd(key) {
	        try {
	            tool.sgiLogger.log('折叠面板事件', key);
	            // tool.sgiLogger.log('arguments', arguments);
	            var objFct = this.props.objFct;
	
	            this.setState({ activeKey: key });
	            // let expandLsn = this.data.functions.expandLsn;
	            var expandLsn = (0, _SgiCommon.getFunctionByKey)(this, "expandLsn");
	            if (expandLsn) {
	                expandLsn(this, objFct, key);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	    * 页面后处理事件
	    *
	    * @param {object}
	    *            ctn 容器对象
	    * @returns {undefined}
	    */
	    ctnAfter: function ctnAfter(ctn) {
	        try {
	            tool.sgiLogger.log(arguments);
	            // let tcl = this.data.functions.tab;
	            var tcl = (0, _SgiCommon.getFunctionByKey)(this, "tab");
	            if (tcl) {
	                tcl();
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 页面关闭事件监听器
	     *
	     * @param {object}
	     *            ctn 容器对象
	     * @returns {undefined}
	     */
	    ctnCls: function ctnCls(e) {
	        try {
	            tool.sgiLogger.log('弹出窗关闭事件', e);
	            var objFct = this.props.objFct;
	            // let afterClose = this.data.functions.afterClose;
	
	            var afterClose = (0, _SgiCommon.getFunctionByKey)(this, "afterClose");
	            if (afterClose) {
	                afterClose(this, objFct, e);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 页面销毁前事件监听器
	     *
	     * @param {object}
	     *            ctn 容器对象
	     * @returns {undefined}
	     */
	    ctnBfRmv: function ctnBfRmv(ctn) {
	        try {} catch (error) {}
	    },
	    /**
	     * 页面初始化监听器
	     *
	     * @param {object}
	     *            ctn 容器对象
	     * @returns {undefined}
	     */
	    init: function init(ctn) {
	        try {} catch (error) {}
	    },
	    /**
	     * 菜单前处理监听器
	     *
	     * @param {object}
	     *            ctn 容器对象
	     * @returns {undefined}
	     */
	    onbfsw: function onbfsw(ctn) {
	        try {} catch (error) {}
	    },
	    /**
	     * 页面折叠监听器
	     *
	     * @param {object}
	     *            ctn 容器对象
	     * @returns {undefined}
	     */
	    clp: function clp(ctn) {
	        try {} catch (error) {}
	    },
	
	    /**
	     * 日历选择事件
	     * @param {moment} e 当前选择的moment
	     */
	    calendarOnSelect: function calendarOnSelect(e) {
	        try {
	            tool.sgiLogger.log('日历选择事件');
	            var objFct = this.props.objFct;
	            // const onSelect = this.data.functions.onSelect;
	
	            var onSelect = (0, _SgiCommon.getFunctionByKey)(this, "onSelect");
	            if (onSelect) {
	                var value = e.format('YYYY-MM-DD');
	                onSelect(this, objFct, value, e);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 日历面板切换事件
	     * @param {moment} e 当前选择的moment
	     * @param {string} e2 当前选择的mode
	     */
	    calendarOnPanelChange: function calendarOnPanelChange(e, e2) {
	        try {
	            tool.sgiLogger.log('日历面板切换事件');
	            var objFct = this.props.objFct;
	            // const onPanelChange = this.data.functions.onPanelChange;
	
	            var onPanelChange = (0, _SgiCommon.getFunctionByKey)(this, "onPanelChange");
	            if (onPanelChange) {
	                var value = e.format('YYYY-MM-DD');
	                onPanelChange(this, objFct, value, e, e2);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	    /**
	     * 日历修改事件
	     * @param {moment} e 当前选择的moment
	     */
	    calendarOnChange: function calendarOnChange(e) {
	        try {
	
	            // 更新选择日期
	            // this.state.value = e;
	            this.setMoment(e);
	
	            tool.sgiLogger.log('日历修改事件');
	            var objFct = this.props.objFct;
	            // const onChange = this.data.functions.onChange;
	
	            var onChange = (0, _SgiCommon.getFunctionByKey)(this, "onChange");
	            if (onChange) {
	                var value = e.format('YYYY-MM-DD');
	                onChange(this, objFct, value, e);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    },
	
	    /**
	     * 图表点击事件
	     * @param {*} params 事件参数，即事件对象的数据的各个属性
	     */
	    eChartsEvent: function eChartsEvent(params) {
	        try {
	            tool.sgiLogger.log('图表事件入口');
	
	            var objFct = this.props.objFct;
	
	            var data = params.data;
	            var seriesName = params.seriesName;
	            // let getOn = this.data.functions.getOn;
	            var getOn = (0, _SgiCommon.getFunctionByKey)(this, "getOn");
	            if (getOn) {
	                getOn(this, data, seriesName, objFct, params);
	            }
	        } catch (error) {
	            _rtSdCommon.sgiLogger.eventErr(error);
	        }
	    }
	
	    // 这里的不用了，统一使用sgiBaseComp/SgiCommon中的
	    // /**
	    //  * 统一获取事件，优先从事件集中获取，其次是旧模式
	    //  * @param {object} module 
	    //  * @param {string} eventKey 事件名
	    //  */
	    // function getFunctionByKey(module, eventKey) {
	    //     if (!module) return null;
	    //     let { objFct, moduleDesc } = module.props;
	    //     if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys[eventKey]) {
	    //         // 事件集模式
	    //         let funs = Object.assign({}, objFct.get("@funs"), module.funs);
	    //         let key = moduleDesc.eventKeys[eventKey];
	    //         return funs[key];
	    //     } else {
	    //         // 原事件模式
	    //         // return module.data.functions[eventKey];
	    //         // let functions = module.data && module.data.functions || module.state.functions || {};
	    //         // return functions[eventKey];
	    //         return (module.data && module.data.functions && module.data.functions[eventKey]) || (module.state.functions && module.state.functions[eventKey]);
	    //     }
	    // }
	
	    /**
	     * form下控件的通过用change事件
	     * @param {控件绑定属性名称} attname
	     * @param {form绑定的数据key} bdInst
	     * @param {对象工厂} objFct
	     * @param {事件描述} e
	     */
	};var handleOnChange = function handleOnChange(currentModule, attname, bdInst, objFct, e) {
	    var value = e.target.value;
	    currentModule.ctlRefresh(attname, bdInst, objFct, value);
	    return value;
	};
	/**
	* form下文件控件的通过用change事件
	* @param {控件绑定属性名称} attname
	* @param {form绑定的数据key} bdInst
	* @param {对象工厂} objFct
	* @param {事件描述} e
	*/
	var handleOnFileChange = function handleOnFileChange(currentModule, attname, bdInst, objFct, e) {
	    //拼装value，逗号分隔
	    var fileList = e.fileList;
	    var value = "";
	    fileList.forEach(function (f) {
	        var response = f.response || {};
	        var url = response.fileDownloadUri || f.url;
	        if (!url) return;
	        if (!value) {
	            value = url;
	        } else {
	            value += "," + url;
	        }
	    });
	
	    currentModule.ctlRefresh(attname, bdInst, objFct, value);
	    return value;
	};
	/**
	 * form下checkbox控件的通过用change事件
	 * @param {控件绑定属性名称} attname
	 * @param {form绑定的数据key} bdInst
	 * @param {对象工厂} objFct
	 * @param {事件描述} e
	 */
	var handleCheckBoxGroupChange = function handleCheckBoxGroupChange(currentModule, attname, bdInst, objFct, e) {
	    var value = e;
	    var disValue;
	    if (value && value instanceof Array && value.length > 1) {
	        disValue = value.join(",");
	    } else if (value && value instanceof Array) {
	        disValue = value[0];
	    } else {
	        disValue = value;
	    }
	    currentModule.ctlRefresh(attname, bdInst, objFct, disValue);
	    return e;
	};
	/**
	 * form下checkbox控件的通过用change事件
	 * @param {控件绑定属性名称} attname
	 * @param {form绑定的数据key} bdInst
	 * @param {对象工厂} objFct
	 * @param {事件描述} e
	 */
	var handleCheckBoxChange = function handleCheckBoxChange(currentModule, attname, bdInst, objFct, e) {
	    var value = e.target.checked;
	    var escape = currentModule.state.escape;
	    if (escape) {
	        //转义
	        var escs = escape.split("/");
	        value = value ? escs[0] : escs[1];
	    }
	    currentModule.ctlRefresh(attname, bdInst, objFct, value);
	    return value;
	};
	/**
	* form下数字控件的通过用change事件
	* @param {控件绑定属性名称} attname
	* @param {form绑定的数据key} bdInst
	* @param {对象工厂} objFct
	* @param {事件描述} e
	*/
	var handleOnNumberChange = function handleOnNumberChange(currentModule, attname, bdInst, objFct, e) {
	    var value = e;
	    currentModule.ctlRefresh(attname, bdInst, objFct, value);
	    return value;
	};
	/**
	* form下数字控件的通过用change事件
	* @param {控件绑定属性名称} attname
	* @param {form绑定的数据key} bdInst
	* @param {对象工厂} objFct
	* @param {事件描述} e
	*/
	var handleOnComboxChange = function handleOnComboxChange(currentModule, attname, bdInst, objFct, value, element) {
	    var value = value;
	    // if (mode=='onSelect'){
	    //     //如果是选中,真事数据中 添加这个值，否则取消这个值
	    //     currentModule.state.showValue.push(value);
	    //     value = currentModule.state.showValue;
	    // } else if(mode=='onDeselect'){
	
	    // }
	    var disValue;
	    if (value && value instanceof Array && value.length > 1) {
	        disValue = value.join(",");
	    } else if (value && value instanceof Array) {
	        disValue = value[0];
	    } else {
	        disValue = value;
	    }
	    // tool.sgiLogger.log(1111111111111111111111111111111);
	    currentModule.ctlRefresh(attname, bdInst, objFct, disValue);
	    // return value;
	    var itemData = void 0,
	        title = void 0;
	    if (Object.prototype.toString.call(element) === "[object Array]") {
	        // 多选
	        itemData = element.map(function (item) {
	            return item.props.itemData;
	        });
	        title = element.map(function (item) {
	            return item.props.children;
	        });
	    } else {
	        // 单选
	        itemData = element ? element.props.itemData : undefined;
	        title = element ? element.props.children : undefined;
	    }
	    return { value: value, title: title, itemData: itemData };
	};
	/**
	* form下级联控件的通用change事件
	* @param {控件绑定属性名称} attname
	* @param {form绑定的数据key} bdInst
	* @param {对象工厂} objFct
	* @param {事件描述} e
	*/
	var handleOnCascaderChange = function handleOnCascaderChange(currentModule, attname, bdInst, objFct, values, items) {
	    currentModule.ctlRefresh(attname, bdInst, objFct, values);
	    // return values;
	    var titles = items.map(function (i) {
	        return i.label;
	    });
	    return { value: values, title: titles, itemData: items };
	};
	/**
	* form下富文本的通用change事件
	* @param {控件绑定属性名称} attname
	* @param {form绑定的数据key} bdInst
	* @param {对象工厂} objFct
	* @param {事件描述} e
	*/
	var handleOnEditorChange = function handleOnEditorChange(currentModule, attname, bdInst, objFct, e) {
	    // let value = currentModule.getCurrentContentHtml();
	    var value = e;
	    currentModule.ctlRefresh(attname, bdInst, objFct, value);
	    return value;
	};
	/**
	 * tinymce富文本的change事件
	 * @param {*} currentModule 
	 * @param {*} attname 
	 * @param {*} bdInst 
	 * @param {*} objFct 
	 * @param {*} content 
	 * @param {*} editor 
	 */
	var handleOnTinyMCEChange = function handleOnTinyMCEChange(currentModule, attname, bdInst, objFct, content, editor) {
	    var value = content;
	    currentModule.ctlRefresh(attname, bdInst, objFct, value);
	    return value;
	};
	/**
	 * form下日期控件的通过用change事件
	 * @param {控件绑定属性名称} attname
	 * @param {form绑定的数据key} bdInst
	 * @param {对象工厂} objFct
	 * @param {更新后的值date格式} date
	 * @param {更新后的值string格式} dateString
	 * @param {格式} dateFormat
	 */
	var handleOnSelDate = function handleOnSelDate(currentModule, attname, bdInst, objFct, date, dateString, dateFormat) {
	
	    // let newVal = "";
	    // if (!dateString) {
	
	    // } else if (Array.isArray(dateString)) {
	    //     newVal = dateString.join(",");
	    // } else {
	    //     newVal = dateString;
	    // }
	
	    var newVal = dateString || "";
	    //格式化 以后再说
	    currentModule.ctlRefresh(attname, bdInst, objFct, newVal);
	    return newVal;
	};
	/**
	 * form下时间控件的通过用change事件
	 * @param {控件绑定属性名称} attname
	 * @param {form绑定的数据key} bdInst
	 * @param {对象工厂} objFct
	 * @param {更新后的值date格式} Time
	 * @param {更新后的值string格式} timeString
	 * @param {格式} TimeFormat
	 */
	var handleOnSelTime = function handleOnSelTime(currentModule, attname, bdInst, objFct, time, timeString, TimeFormat) {
	    // if (dateString == null || dateString.length == 0) {
	    //     dateString = '';
	    // }
	    //格式化 以后再说
	    currentModule.ctlRefresh(attname, bdInst, objFct, timeString);
	    return timeString;
	};
	/**
	* 下拉树的通过用change事件
	* @param {控件绑定属性名称} attname
	* @param {form绑定的数据key} bdInst
	* @param {对象工厂} objFct
	* @param {事件描述} e
	*/
	var handleOnTreeSelectChange = function handleOnTreeSelectChange(currentModule, attname, bdInst, objFct, value, label, extra) {
	    var disValue;
	    var multiple = currentModule.state.inputprops.treeCheckable; // 是否多选
	    if (multiple) {
	        if (value && value.length > 1) {
	            for (var i = 0; i < value.length; i++) {
	                disValue = value.join(",");
	            }
	        } else {
	            disValue = value[0];
	        }
	    } else {
	        disValue = value;
	    }
	
	    currentModule.ctlRefresh(attname, bdInst, objFct, disValue);
	    // return value;
	    var title = (label || [])[0];
	    var itemData = extra.triggerNode ? extra.triggerNode.props.itemData : undefined;
	    return { value: value, title: title, itemData: itemData };
	};
	
	exports.SgiEventHandler = SgiEventHandler;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(228);
	
	var zrUtil = __webpack_require__(2);
	
	var PathProxy = __webpack_require__(180);
	
	var pathContain = __webpack_require__(2065);
	
	var Pattern = __webpack_require__(905);
	
	var getCanvasPattern = Pattern.prototype.getCanvasPattern;
	var abs = Math.abs;
	var pathProxyForDraw = new PathProxy(true);
	/**
	 * @alias module:zrender/graphic/Path
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	
	function Path(opts) {
	  Displayable.call(this, opts);
	  /**
	   * @type {module:zrender/core/PathProxy}
	   * @readOnly
	   */
	
	  this.path = null;
	}
	
	Path.prototype = {
	  constructor: Path,
	  type: 'path',
	  __dirtyPath: true,
	  strokeContainThreshold: 5,
	  // This item default to be false. But in map series in echarts,
	  // in order to improve performance, it should be set to true,
	  // so the shorty segment won't draw.
	  segmentIgnoreThreshold: 0,
	
	  /**
	   * See `module:zrender/src/graphic/helper/subPixelOptimize`.
	   * @type {boolean}
	   */
	  subPixelOptimize: false,
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var path = this.path || pathProxyForDraw;
	    var hasStroke = style.hasStroke();
	    var hasFill = style.hasFill();
	    var fill = style.fill;
	    var stroke = style.stroke;
	    var hasFillGradient = hasFill && !!fill.colorStops;
	    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
	    var hasFillPattern = hasFill && !!fill.image;
	    var hasStrokePattern = hasStroke && !!stroke.image;
	    style.bind(ctx, this, prevEl);
	    this.setTransform(ctx);
	
	    if (this.__dirty) {
	      var rect; // Update gradient because bounding rect may changed
	
	      if (hasFillGradient) {
	        rect = rect || this.getBoundingRect();
	        this._fillGradient = style.getGradient(ctx, fill, rect);
	      }
	
	      if (hasStrokeGradient) {
	        rect = rect || this.getBoundingRect();
	        this._strokeGradient = style.getGradient(ctx, stroke, rect);
	      }
	    } // Use the gradient or pattern
	
	
	    if (hasFillGradient) {
	      // PENDING If may have affect the state
	      ctx.fillStyle = this._fillGradient;
	    } else if (hasFillPattern) {
	      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
	    }
	
	    if (hasStrokeGradient) {
	      ctx.strokeStyle = this._strokeGradient;
	    } else if (hasStrokePattern) {
	      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
	    }
	
	    var lineDash = style.lineDash;
	    var lineDashOffset = style.lineDashOffset;
	    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy
	
	    var scale = this.getGlobalScale();
	    path.setScale(scale[0], scale[1], this.segmentIgnoreThreshold); // Proxy context
	    // Rebuild path in following 2 cases
	    // 1. Path is dirty
	    // 2. Path needs javascript implemented lineDash stroking.
	    //    In this case, lineDash information will not be saved in PathProxy
	
	    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
	      path.beginPath(ctx); // Setting line dash before build path
	
	      if (lineDash && !ctxLineDash) {
	        path.setLineDash(lineDash);
	        path.setLineDashOffset(lineDashOffset);
	      }
	
	      this.buildPath(path, this.shape, false); // Clear path dirty flag
	
	      if (this.path) {
	        this.__dirtyPath = false;
	      }
	    } else {
	      // Replay path building
	      ctx.beginPath();
	      this.path.rebuildPath(ctx);
	    }
	
	    if (hasFill) {
	      if (style.fillOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.fillOpacity * style.opacity;
	        path.fill(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.fill(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      ctx.setLineDash(lineDash);
	      ctx.lineDashOffset = lineDashOffset;
	    }
	
	    if (hasStroke) {
	      if (style.strokeOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.strokeOpacity * style.opacity;
	        path.stroke(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.stroke(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      // PENDING
	      // Remove lineDash
	      ctx.setLineDash([]);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
	  // Like in circle
	  buildPath: function (ctx, shapeCfg, inBundle) {},
	  createPathProxy: function () {
	    this.path = new PathProxy();
	  },
	  getBoundingRect: function () {
	    var rect = this._rect;
	    var style = this.style;
	    var needsUpdateRect = !rect;
	
	    if (needsUpdateRect) {
	      var path = this.path;
	
	      if (!path) {
	        // Create path on demand.
	        path = this.path = new PathProxy();
	      }
	
	      if (this.__dirtyPath) {
	        path.beginPath();
	        this.buildPath(path, this.shape, false);
	      }
	
	      rect = path.getBoundingRect();
	    }
	
	    this._rect = rect;
	
	    if (style.hasStroke()) {
	      // Needs update rect with stroke lineWidth when
	      // 1. Element changes scale or lineWidth
	      // 2. Shape is changed
	      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
	
	      if (this.__dirty || needsUpdateRect) {
	        rectWithStroke.copy(rect); // FIXME Must after updateTransform
	
	        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical
	
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill
	
	        if (!style.hasFill()) {
	          w = Math.max(w, this.strokeContainThreshold || 4);
	        } // Consider line width
	        // Line scale can't be 0;
	
	
	        if (lineScale > 1e-10) {
	          rectWithStroke.width += w / lineScale;
	          rectWithStroke.height += w / lineScale;
	          rectWithStroke.x -= w / lineScale / 2;
	          rectWithStroke.y -= w / lineScale / 2;
	        }
	      } // Return rect with stroke
	
	
	      return rectWithStroke;
	    }
	
	    return rect;
	  },
	  contain: function (x, y) {
	    var localPos = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    var style = this.style;
	    x = localPos[0];
	    y = localPos[1];
	
	    if (rect.contain(x, y)) {
	      var pathData = this.path.data;
	
	      if (style.hasStroke()) {
	        var lineWidth = style.lineWidth;
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;
	
	        if (lineScale > 1e-10) {
	          // Only add extra hover lineWidth when there are no fill
	          if (!style.hasFill()) {
	            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
	          }
	
	          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
	            return true;
	          }
	        }
	      }
	
	      if (style.hasFill()) {
	        return pathContain.contain(pathData, x, y);
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @param  {boolean} dirtyPath
	   */
	  dirty: function (dirtyPath) {
	    if (dirtyPath == null) {
	      dirtyPath = true;
	    } // Only mark dirty, not mark clean
	
	
	    if (dirtyPath) {
	      this.__dirtyPath = dirtyPath;
	      this._rect = null;
	    }
	
	    this.__dirty = this.__dirtyText = true;
	    this.__zr && this.__zr.refresh(); // Used as a clipping path
	
	    if (this.__clipTarget) {
	      this.__clipTarget.dirty();
	    }
	  },
	
	  /**
	   * Alias for animate('shape')
	   * @param {boolean} loop
	   */
	  animateShape: function (loop) {
	    return this.animate('shape', loop);
	  },
	  // Overwrite attrKV
	  attrKV: function (key, value) {
	    // FIXME
	    if (key === 'shape') {
	      this.setShape(value);
	      this.__dirtyPath = true;
	      this._rect = null;
	    } else {
	      Displayable.prototype.attrKV.call(this, key, value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setShape: function (key, value) {
	    var shape = this.shape; // Path from string may not have shape
	
	    if (shape) {
	      if (zrUtil.isObject(key)) {
	        for (var name in key) {
	          if (key.hasOwnProperty(name)) {
	            shape[name] = key[name];
	          }
	        }
	      } else {
	        shape[key] = value;
	      }
	
	      this.dirty(true);
	    }
	
	    return this;
	  },
	  getLineScale: function () {
	    var m = this.transform; // Get the line scale.
	    // Determinant of `m` means how much the area is enlarged by the
	    // transformation. So its square root can be used as a scale factor
	    // for width.
	
	    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
	  }
	};
	/**
	 * 扩展一个 Path element, 比如星形，圆等。
	 * Extend a path element
	 * @param {Object} props
	 * @param {string} props.type Path type
	 * @param {Function} props.init Initialize
	 * @param {Function} props.buildPath Overwrite buildPath method
	 * @param {Object} [props.style] Extended default style config
	 * @param {Object} [props.shape] Extended default shape config
	 */
	
	Path.extend = function (defaults) {
	  var Sub = function (opts) {
	    Path.call(this, opts);
	
	    if (defaults.style) {
	      // Extend default style
	      this.style.extendFrom(defaults.style, false);
	    } // Extend default shape
	
	
	    var defaultShape = defaults.shape;
	
	    if (defaultShape) {
	      this.shape = this.shape || {};
	      var thisShape = this.shape;
	
	      for (var name in defaultShape) {
	        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
	          thisShape[name] = defaultShape[name];
	        }
	      }
	    }
	
	    defaults.init && defaults.init.call(this, opts);
	  };
	
	  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象
	
	  for (var name in defaults) {
	    // Extending prototype values and methods
	    if (name !== 'style' && name !== 'shape') {
	      Sub.prototype[name] = defaults[name];
	    }
	  }
	
	  return Sub;
	};
	
	zrUtil.inherits(Path, Displayable);
	var _default = Path;
	module.exports = _default;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var DOMProperty = __webpack_require__(166);
	var ReactDOMComponentFlags = __webpack_require__(771);
	
	var invariant = __webpack_require__(32);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	var _clazz = __webpack_require__(115);
	
	var enableClassExtend = _clazz.enableClassExtend;
	var enableClassCheck = _clazz.enableClassCheck;
	
	var lineStyleMixin = __webpack_require__(1857);
	
	var areaStyleMixin = __webpack_require__(1854);
	
	var textStyleMixin = __webpack_require__(1858);
	
	var itemStyleMixin = __webpack_require__(1856);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/model/Model
	 */
	var mixin = zrUtil.mixin;
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Model
	 * @constructor
	 * @param {Object} [option]
	 * @param {module:echarts/model/Model} [parentModel]
	 * @param {module:echarts/model/Global} [ecModel]
	 */
	
	function Model(option, parentModel, ecModel) {
	  /**
	   * @type {module:echarts/model/Model}
	   * @readOnly
	   */
	  this.parentModel = parentModel;
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @type {Object}
	   * @protected
	   */
	
	  this.option = option; // Simple optimization
	  // if (this.init) {
	  //     if (arguments.length <= 4) {
	  //         this.init(option, parentModel, ecModel, extraOpt);
	  //     }
	  //     else {
	  //         this.init.apply(this, arguments);
	  //     }
	  // }
	}
	
	Model.prototype = {
	  constructor: Model,
	
	  /**
	   * Model 的初始化函数
	   * @param {Object} option
	   */
	  init: null,
	
	  /**
	   * 从新的 Option merge
	   */
	  mergeOption: function (option) {
	    zrUtil.merge(this.option, option, true);
	  },
	
	  /**
	   * @param {string|Array.<string>} path
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  get: function (path, ignoreParent) {
	    if (path == null) {
	      return this.option;
	    }
	
	    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
	  },
	
	  /**
	   * @param {string} key
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  getShallow: function (key, ignoreParent) {
	    var option = this.option;
	    var val = option == null ? option : option[key];
	    var parentModel = !ignoreParent && getParent(this, key);
	
	    if (val == null && parentModel) {
	      val = parentModel.getShallow(key);
	    }
	
	    return val;
	  },
	
	  /**
	   * @param {string|Array.<string>} [path]
	   * @param {module:echarts/model/Model} [parentModel]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path, parentModel) {
	    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
	    var thisParentModel;
	    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
	    return new Model(obj, parentModel, this.ecModel);
	  },
	
	  /**
	   * If model has option
	   */
	  isEmpty: function () {
	    return this.option == null;
	  },
	  restoreData: function () {},
	  // Pending
	  clone: function () {
	    var Ctor = this.constructor;
	    return new Ctor(zrUtil.clone(this.option));
	  },
	  setReadOnly: function (properties) {// clazzUtil.setReadOnly(this, properties);
	  },
	  // If path is null/undefined, return null/undefined.
	  parsePath: function (path) {
	    if (typeof path === 'string') {
	      path = path.split('.');
	    }
	
	    return path;
	  },
	
	  /**
	   * @param {Function} getParentMethod
	   *        param {Array.<string>|string} path
	   *        return {module:echarts/model/Model}
	   */
	  customizeGetParent: function (getParentMethod) {
	    inner(this).getParent = getParentMethod;
	  },
	  isAnimationEnabled: function () {
	    if (!env.node) {
	      if (this.option.animation != null) {
	        return !!this.option.animation;
	      } else if (this.parentModel) {
	        return this.parentModel.isAnimationEnabled();
	      }
	    }
	  }
	};
	
	function doGet(obj, pathArr, parentModel) {
	  for (var i = 0; i < pathArr.length; i++) {
	    // Ignore empty
	    if (!pathArr[i]) {
	      continue;
	    } // obj could be number/string/... (like 0)
	
	
	    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  if (obj == null && parentModel) {
	    obj = parentModel.get(pathArr);
	  }
	
	  return obj;
	} // `path` can be null/undefined
	
	
	function getParent(model, path) {
	  var getParentMethod = inner(model).getParent;
	  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
	} // Enable Model.extend.
	
	
	enableClassExtend(Model);
	enableClassCheck(Model);
	mixin(Model, lineStyleMixin);
	mixin(Model, areaStyleMixin);
	mixin(Model, textStyleMixin);
	mixin(Model, itemStyleMixin);
	var _default = Model;
	module.exports = _default;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/**
	 * echarts设备环境识别
	 *
	 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
	 * @author firede[firede@firede.us]
	 * @desc thanks zepto.
	 */
	
	/* global wx */
	var env = {};
	
	if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
	  // In Weixin Application
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    wxa: true,
	    // Weixin Application
	    canvasSupported: true,
	    svgSupported: false,
	    touchEventsSupported: true,
	    domSupported: false
	  };
	} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
	  // In worker
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    worker: true,
	    canvasSupported: true,
	    domSupported: false
	  };
	} else if (typeof navigator === 'undefined') {
	  // In node
	  env = {
	    browser: {},
	    os: {},
	    node: true,
	    worker: false,
	    // Assume canvas is supported
	    canvasSupported: true,
	    svgSupported: true,
	    domSupported: false
	  };
	} else {
	  env = detect(navigator.userAgent);
	}
	
	var _default = env; // Zepto.js
	// (c) 2010-2013 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	
	function detect(ua) {
	  var os = {};
	  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
	  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
	  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
	  // var touchpad = webos && ua.match(/TouchPad/);
	  // var kindle = ua.match(/Kindle\/([\d.]+)/);
	  // var silk = ua.match(/Silk\/([\d._]+)/);
	  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
	  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
	  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
	  // var playbook = ua.match(/PlayBook/);
	  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
	
	  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
	  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
	
	  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
	  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
	  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+
	
	  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
	  // - discern (more) between multiple browsers on android
	  // - decide if kindle fire in silk mode is android or not
	  // - Firefox on Android doesn't specify the Android version
	  // - possibly devide in os, device and browser hashes
	  // if (browser.webkit = !!webkit) browser.version = webkit[1];
	  // if (android) os.android = true, os.version = android[2];
	  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
	  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
	  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	  // if (webos) os.webos = true, os.version = webos[2];
	  // if (touchpad) os.touchpad = true;
	  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
	  // if (bb10) os.bb10 = true, os.version = bb10[2];
	  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
	  // if (playbook) browser.playbook = true;
	  // if (kindle) os.kindle = true, os.version = kindle[1];
	  // if (silk) browser.silk = true, browser.version = silk[1];
	  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
	  // if (chrome) browser.chrome = true, browser.version = chrome[1];
	
	  if (firefox) {
	    browser.firefox = true;
	    browser.version = firefox[1];
	  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
	  // if (webview) browser.webview = true;
	
	
	  if (ie) {
	    browser.ie = true;
	    browser.version = ie[1];
	  }
	
	  if (edge) {
	    browser.edge = true;
	    browser.version = edge[1];
	  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
	  // not be set on win phone. So we do not consider Win Phone.
	
	
	  if (weChat) {
	    browser.weChat = true;
	  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
	  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
	  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
	  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
	  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
	
	
	  return {
	    browser: browser,
	    os: os,
	    node: false,
	    // 原生canvas支持，改极端点了
	    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
	    canvasSupported: !!document.createElement('canvas').getContext,
	    svgSupported: typeof SVGRect !== 'undefined',
	    // works on most browsers
	    // IE10/11 does not support touch event, and MS Edge supports them but not by
	    // default, so we dont check navigator.maxTouchPoints for them here.
	    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
	    // <http://caniuse.com/#search=pointer%20event>.
	    pointerEventsSupported: // (1) Firefox supports pointer but not by default, only MS browsers are reliable on pointer
	    // events currently. So we dont use that on other browsers unless tested sufficiently.
	    // For example, in iOS 13 Mobile Chromium 78, if the touching behavior starts page
	    // scroll, the `pointermove` event can not be fired any more. That will break some
	    // features like "pan horizontally to move something and pan vertically to page scroll".
	    // The horizontal pan probably be interrupted by the casually triggered page scroll.
	    // (2) Although IE 10 supports pointer event, it use old style and is different from the
	    // standard. So we exclude that. (IE 10 is hardly used on touch device)
	    'onpointerdown' in window && (browser.edge || browser.ie && browser.version >= 11),
	    // passiveSupported: detectPassiveSupport()
	    domSupported: typeof document !== 'undefined'
	  };
	} // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
	// function detectPassiveSupport() {
	//     // Test via a getter in the options object to see if the passive property is accessed
	//     var supportsPassive = false;
	//     try {
	//         var opts = Object.defineProperty({}, 'passive', {
	//             get: function() {
	//                 supportsPassive = true;
	//             }
	//         });
	//         window.addEventListener('testPassive', function() {}, opts);
	//     } catch (e) {
	//     }
	//     return supportsPassive;
	// }
	
	
	module.exports = _default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(26);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(47);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandardCode = exports.Resource = exports.PrmFactory = exports.ObjFactory = exports.MediaResourceCode = exports.DataType = exports.DataElement = exports.DataDict = exports.ComponentManager = exports.sgiConstants = exports.getTypeName = exports.AllDndCompInfo = exports.AllCompGUID = exports.GUID = exports.sgiAntdModule = exports.sgiConfig = exports.SgiUCVEO = exports.SgiTVEO = exports.SgiTreeEO = exports.SgiTransferEO = exports.SgiTooltipEO = exports.SgiToolbarEO = exports.SgiTinyMCEEO = exports.SgiTileEO = exports.SgiTabsEO = exports.SgiTableEO = exports.SgiStepsEO = exports.SgiSplitterEO = exports.SgiSpinEO = exports.SgiRowEO = exports.SgiQuoteEO = exports.SgiPanelOldEO = exports.SgiPanelEO = exports.SgiOverPanelEO = exports.SgiOverlapEO = exports.SgiNestEO = exports.SgiMenuEO = exports.SgiListEO = exports.SgiLabelEO = exports.SgiImgEO = exports.SgiFormTimeEO = exports.SgiFormTextEO = exports.SgiFormTextAreaEO = exports.SgiFormRadioEO = exports.SgiFormPopUIEO = exports.SgiFormInputNumberEO = exports.SgiFormFileEO = exports.SgiFormEO = exports.SgiFormEditorEO = exports.SgiFormDateEO = exports.SgiFormComboxTreeEO = exports.SgiFormComboboxEO = exports.SgiFormCheckboxGroupEO = exports.SgiFormCheckboxEO = exports.SgiFormCascaderEO = exports.SgiEChartsCommonEO = exports.SgiDVEO = exports.SgiCreateEO = exports.SgiCommEchartsEO = exports.SgiCollapseEO = exports.SgiColEO = exports.SgiCodeMirrorEO = exports.SgiCheckBoxEO = exports.SgiCardEO = exports.SgiCalendarEO = exports.SgiButtonOldEO = exports.SgiButtonEO = exports.SgiBadgeEO = exports.tool = exports.sgiLogger = exports.uuidDate = exports.uuid = exports.strToJson = exports.md5 = exports.jsonToStr = exports.isJSON = exports.HtmlUtil = exports.getLeafByPrm = exports.getJsonLength = exports.getAP = exports.funStrCheck = exports.Format = exports.deepCopyAll = exports.DateOpt = exports.createElement = exports.copyJsonAttr = exports.copyArr = exports.copy = exports.assignPropsNotUndefined = exports.assignProps = exports.assignArrayStr = exports.sgiArray = exports.commonClient = exports.sgiPfClient = exports.sgiClient = exports.sgiLocalStorage = undefined;
	
	var _localStorage = __webpack_require__(239);
	
	Object.defineProperty(exports, 'sgiLocalStorage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_localStorage).default;
	  }
	});
	
	var _sgiClient = __webpack_require__(306);
	
	Object.defineProperty(exports, 'sgiClient', {
	  enumerable: true,
	  get: function get() {
	    return _sgiClient.sgiClient;
	  }
	});
	Object.defineProperty(exports, 'sgiPfClient', {
	  enumerable: true,
	  get: function get() {
	    return _sgiClient.sgiPfClient;
	  }
	});
	Object.defineProperty(exports, 'commonClient', {
	  enumerable: true,
	  get: function get() {
	    return _sgiClient.commonClient;
	  }
	});
	
	var _sgiCommon = __webpack_require__(28);
	
	Object.defineProperty(exports, 'sgiArray', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.sgiArray;
	  }
	});
	Object.defineProperty(exports, 'assignArrayStr', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.assignArrayStr;
	  }
	});
	Object.defineProperty(exports, 'assignProps', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.assignProps;
	  }
	});
	Object.defineProperty(exports, 'assignPropsNotUndefined', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.assignPropsNotUndefined;
	  }
	});
	Object.defineProperty(exports, 'copy', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.copy;
	  }
	});
	Object.defineProperty(exports, 'copyArr', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.copyArr;
	  }
	});
	Object.defineProperty(exports, 'copyJsonAttr', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.copyJsonAttr;
	  }
	});
	Object.defineProperty(exports, 'createElement', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.createElement;
	  }
	});
	Object.defineProperty(exports, 'DateOpt', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.DateOpt;
	  }
	});
	Object.defineProperty(exports, 'deepCopyAll', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.deepCopyAll;
	  }
	});
	Object.defineProperty(exports, 'Format', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.Format;
	  }
	});
	Object.defineProperty(exports, 'funStrCheck', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.funStrCheck;
	  }
	});
	Object.defineProperty(exports, 'getAP', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.getAP;
	  }
	});
	Object.defineProperty(exports, 'getJsonLength', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.getJsonLength;
	  }
	});
	Object.defineProperty(exports, 'getLeafByPrm', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.getLeafByPrm;
	  }
	});
	Object.defineProperty(exports, 'HtmlUtil', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.HtmlUtil;
	  }
	});
	Object.defineProperty(exports, 'isJSON', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.isJSON;
	  }
	});
	Object.defineProperty(exports, 'jsonToStr', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.jsonToStr;
	  }
	});
	Object.defineProperty(exports, 'md5', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.md5;
	  }
	});
	Object.defineProperty(exports, 'strToJson', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.strToJson;
	  }
	});
	Object.defineProperty(exports, 'uuid', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.uuid;
	  }
	});
	Object.defineProperty(exports, 'uuidDate', {
	  enumerable: true,
	  get: function get() {
	    return _sgiCommon.uuidDate;
	  }
	});
	
	var _sgiLogger = __webpack_require__(39);
	
	Object.defineProperty(exports, 'sgiLogger', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sgiLogger).default;
	  }
	});
	
	var _sgiRunningCommon = __webpack_require__(307);
	
	Object.defineProperty(exports, 'tool', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sgiRunningCommon).default;
	  }
	});
	
	var _SgiBadgeEO = __webpack_require__(618);
	
	Object.defineProperty(exports, 'SgiBadgeEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiBadgeEO).default;
	  }
	});
	
	var _SgiButtonEO = __webpack_require__(308);
	
	Object.defineProperty(exports, 'SgiButtonEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiButtonEO).default;
	  }
	});
	
	var _SgiButtonOldEO = __webpack_require__(1149);
	
	Object.defineProperty(exports, 'SgiButtonOldEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiButtonOldEO).default;
	  }
	});
	
	var _SgiCalendarEO = __webpack_require__(309);
	
	Object.defineProperty(exports, 'SgiCalendarEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCalendarEO).default;
	  }
	});
	
	var _SgiCardEO = __webpack_require__(619);
	
	Object.defineProperty(exports, 'SgiCardEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCardEO).default;
	  }
	});
	
	var _SgiCheckBoxEO = __webpack_require__(1150);
	
	Object.defineProperty(exports, 'SgiCheckBoxEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCheckBoxEO).default;
	  }
	});
	
	var _SgiCodeMirrorEO = __webpack_require__(1151);
	
	Object.defineProperty(exports, 'SgiCodeMirrorEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCodeMirrorEO).default;
	  }
	});
	
	var _SgiColEO = __webpack_require__(310);
	
	Object.defineProperty(exports, 'SgiColEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiColEO).default;
	  }
	});
	
	var _SgiCollapseEO = __webpack_require__(311);
	
	Object.defineProperty(exports, 'SgiCollapseEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCollapseEO).default;
	  }
	});
	
	var _SgiCommEchartsEO = __webpack_require__(312);
	
	Object.defineProperty(exports, 'SgiCommEchartsEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCommEchartsEO).default;
	  }
	});
	
	var _SgiCreateEO = __webpack_require__(1152);
	
	Object.defineProperty(exports, 'SgiCreateEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCreateEO).default;
	  }
	});
	
	var _SgiDVEO = __webpack_require__(313);
	
	Object.defineProperty(exports, 'SgiDVEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiDVEO).default;
	  }
	});
	
	var _SgiEChartsCommonEO = __webpack_require__(314);
	
	Object.defineProperty(exports, 'SgiEChartsCommonEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiEChartsCommonEO).default;
	  }
	});
	
	var _SgiFormCascaderEO = __webpack_require__(315);
	
	Object.defineProperty(exports, 'SgiFormCascaderEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCascaderEO).default;
	  }
	});
	
	var _SgiFormCheckboxEO = __webpack_require__(316);
	
	Object.defineProperty(exports, 'SgiFormCheckboxEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCheckboxEO).default;
	  }
	});
	
	var _SgiFormCheckboxGroupEO = __webpack_require__(317);
	
	Object.defineProperty(exports, 'SgiFormCheckboxGroupEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCheckboxGroupEO).default;
	  }
	});
	
	var _SgiFormComboboxEO = __webpack_require__(318);
	
	Object.defineProperty(exports, 'SgiFormComboboxEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormComboboxEO).default;
	  }
	});
	
	var _SgiFormComboxTreeEO = __webpack_require__(319);
	
	Object.defineProperty(exports, 'SgiFormComboxTreeEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormComboxTreeEO).default;
	  }
	});
	
	var _SgiFormDateEO = __webpack_require__(320);
	
	Object.defineProperty(exports, 'SgiFormDateEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormDateEO).default;
	  }
	});
	
	var _SgiFormEditorEO = __webpack_require__(322);
	
	Object.defineProperty(exports, 'SgiFormEditorEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormEditorEO).default;
	  }
	});
	
	var _SgiFormEO = __webpack_require__(321);
	
	Object.defineProperty(exports, 'SgiFormEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormEO).default;
	  }
	});
	
	var _SgiFormFileEO = __webpack_require__(323);
	
	Object.defineProperty(exports, 'SgiFormFileEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormFileEO).default;
	  }
	});
	
	var _SgiFormInputNumberEO = __webpack_require__(324);
	
	Object.defineProperty(exports, 'SgiFormInputNumberEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormInputNumberEO).default;
	  }
	});
	
	var _SgiFormPopUIEO = __webpack_require__(325);
	
	Object.defineProperty(exports, 'SgiFormPopUIEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormPopUIEO).default;
	  }
	});
	
	var _SgiFormRadioEO = __webpack_require__(326);
	
	Object.defineProperty(exports, 'SgiFormRadioEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormRadioEO).default;
	  }
	});
	
	var _SgiFormTextAreaEO = __webpack_require__(327);
	
	Object.defineProperty(exports, 'SgiFormTextAreaEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormTextAreaEO).default;
	  }
	});
	
	var _SgiFormTextEO = __webpack_require__(328);
	
	Object.defineProperty(exports, 'SgiFormTextEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormTextEO).default;
	  }
	});
	
	var _SgiFormTimeEO = __webpack_require__(329);
	
	Object.defineProperty(exports, 'SgiFormTimeEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormTimeEO).default;
	  }
	});
	
	var _SgiImgEO = __webpack_require__(330);
	
	Object.defineProperty(exports, 'SgiImgEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiImgEO).default;
	  }
	});
	
	var _SgiLabelEO = __webpack_require__(331);
	
	Object.defineProperty(exports, 'SgiLabelEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiLabelEO).default;
	  }
	});
	
	var _SgiListEO = __webpack_require__(332);
	
	Object.defineProperty(exports, 'SgiListEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiListEO).default;
	  }
	});
	
	var _SgiMenuEO = __webpack_require__(333);
	
	Object.defineProperty(exports, 'SgiMenuEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiMenuEO).default;
	  }
	});
	
	var _SgiNestEO = __webpack_require__(334);
	
	Object.defineProperty(exports, 'SgiNestEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiNestEO).default;
	  }
	});
	
	var _SgiOverlapEO = __webpack_require__(335);
	
	Object.defineProperty(exports, 'SgiOverlapEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiOverlapEO).default;
	  }
	});
	
	var _SgiOverPanelEO = __webpack_require__(1155);
	
	Object.defineProperty(exports, 'SgiOverPanelEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiOverPanelEO).default;
	  }
	});
	
	var _SgiPanelEO = __webpack_require__(336);
	
	Object.defineProperty(exports, 'SgiPanelEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiPanelEO).default;
	  }
	});
	
	var _SgiPanelOldEO = __webpack_require__(1156);
	
	Object.defineProperty(exports, 'SgiPanelOldEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiPanelOldEO).default;
	  }
	});
	
	var _SgiQuoteEO = __webpack_require__(620);
	
	Object.defineProperty(exports, 'SgiQuoteEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiQuoteEO).default;
	  }
	});
	
	var _SgiRowEO = __webpack_require__(337);
	
	Object.defineProperty(exports, 'SgiRowEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiRowEO).default;
	  }
	});
	
	var _SgiSpinEO = __webpack_require__(621);
	
	Object.defineProperty(exports, 'SgiSpinEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiSpinEO).default;
	  }
	});
	
	var _SgiSplitterEO = __webpack_require__(338);
	
	Object.defineProperty(exports, 'SgiSplitterEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiSplitterEO).default;
	  }
	});
	
	var _SgiStepsEO = __webpack_require__(339);
	
	Object.defineProperty(exports, 'SgiStepsEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiStepsEO).default;
	  }
	});
	
	var _SgiTableEO = __webpack_require__(341);
	
	Object.defineProperty(exports, 'SgiTableEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTableEO).default;
	  }
	});
	
	var _SgiTabsEO = __webpack_require__(342);
	
	Object.defineProperty(exports, 'SgiTabsEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTabsEO).default;
	  }
	});
	
	var _SgiTileEO = __webpack_require__(343);
	
	Object.defineProperty(exports, 'SgiTileEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTileEO).default;
	  }
	});
	
	var _SgiTinyMCEEO = __webpack_require__(623);
	
	Object.defineProperty(exports, 'SgiTinyMCEEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTinyMCEEO).default;
	  }
	});
	
	var _SgiToolbarEO = __webpack_require__(344);
	
	Object.defineProperty(exports, 'SgiToolbarEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiToolbarEO).default;
	  }
	});
	
	var _SgiTooltipEO = __webpack_require__(624);
	
	Object.defineProperty(exports, 'SgiTooltipEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTooltipEO).default;
	  }
	});
	
	var _SgiTransferEO = __webpack_require__(345);
	
	Object.defineProperty(exports, 'SgiTransferEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTransferEO).default;
	  }
	});
	
	var _SgiTreeEO = __webpack_require__(346);
	
	Object.defineProperty(exports, 'SgiTreeEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTreeEO).default;
	  }
	});
	
	var _SgiTVEO = __webpack_require__(340);
	
	Object.defineProperty(exports, 'SgiTVEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTVEO).default;
	  }
	});
	
	var _SgiUCVEO = __webpack_require__(1157);
	
	Object.defineProperty(exports, 'SgiUCVEO', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiUCVEO).default;
	  }
	});
	
	var _sgiConfig = __webpack_require__(347);
	
	Object.defineProperty(exports, 'sgiConfig', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sgiConfig).default;
	  }
	});
	
	var _sgiAntdModule = __webpack_require__(625);
	
	Object.defineProperty(exports, 'sgiAntdModule', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sgiAntdModule).default;
	  }
	});
	
	var _sgiCommonConstant = __webpack_require__(241);
	
	Object.defineProperty(exports, 'GUID', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sgiCommonConstant).default;
	  }
	});
	
	var _SgiCompConstant = __webpack_require__(107);
	
	Object.defineProperty(exports, 'AllCompGUID', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCompConstant.AllCompGUID;
	  }
	});
	Object.defineProperty(exports, 'AllDndCompInfo', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCompConstant.AllDndCompInfo;
	  }
	});
	Object.defineProperty(exports, 'getTypeName', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCompConstant.getTypeName;
	  }
	});
	
	var _sgiConstants = __webpack_require__(198);
	
	Object.defineProperty(exports, 'sgiConstants', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sgiConstants).default;
	  }
	});
	
	var _ComponentManager = __webpack_require__(348);
	
	Object.defineProperty(exports, 'ComponentManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ComponentManager).default;
	  }
	});
	
	var _DataDict = __webpack_require__(1158);
	
	Object.defineProperty(exports, 'DataDict', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DataDict).default;
	  }
	});
	
	var _DataElement = __webpack_require__(626);
	
	Object.defineProperty(exports, 'DataElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DataElement).default;
	  }
	});
	
	var _DataType = __webpack_require__(627);
	
	Object.defineProperty(exports, 'DataType', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DataType).default;
	  }
	});
	
	var _MediaResourceCode = __webpack_require__(349);
	
	Object.defineProperty(exports, 'MediaResourceCode', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MediaResourceCode).default;
	  }
	});
	
	var _ObjFactory = __webpack_require__(69);
	
	Object.defineProperty(exports, 'ObjFactory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ObjFactory).default;
	  }
	});
	
	var _PrmFactory = __webpack_require__(63);
	
	Object.defineProperty(exports, 'PrmFactory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrmFactory).default;
	  }
	});
	
	var _Resource = __webpack_require__(67);
	
	Object.defineProperty(exports, 'Resource', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Resource).default;
	  }
	});
	
	var _StandardCode = __webpack_require__(81);
	
	Object.defineProperty(exports, 'StandardCode', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StandardCode).default;
	  }
	});
	
	var _InitNameSpace = __webpack_require__(1147);
	
	var _InitNameSpace2 = _interopRequireDefault(_InitNameSpace);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 表单控件的maker的公共方法
	 * wangz
	 * 2018.3.9
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddFormCtlCommonAttribute = exports.setFormCtlLayout = exports.bindEvent = exports.bindValue = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 绑定显示值
	 * @param {描述信息} currentModule
	 * @param {描述信息} moduleDesc
	 * @param {数据} bdInst
	 * @param {对象工厂} objFct
	 * @param {属性} formItem
	 * @param {属性} inputprops
	 */
	var bindValue = function bindValue(currentModule, moduleDesc, bdInst, objFct, formItem, inputprops, checked) {
	
	    if (!moduleDesc.c) {
	        return;
	    }
	
	    //currentModule.bdInst = bdInst;
	    var attname = moduleDesc.c;
	    currentModule.state.attname = attname;
	
	    var bdInstValue;
	    if (!bdInst || !objFct) return;
	
	    if (typeof bdInst === "string") {
	        //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	        //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	        if (currentModule.props.type === 'tb') {
	            var bdInstKeyList = bdInst.split('`');
	            var bdInstList = objFct.get(bdInstKeyList[0]);
	            if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
	            }
	        } else {
	            bdInstValue = objFct.get(bdInst);
	        }
	    } else {
	        bdInstValue = bdInst;
	    }
	
	    // 带点./[/]解析
	    var evalFlg = RegExp(/[.|\[|\]]+/).test(attname);
	    var valueFlg = evalFlg && eval('(bdInstValue.' + attname + ')') !== undefined;
	
	    if (bdInstValue && (bdInstValue[attname] !== undefined || valueFlg)) {
	        //2018.04.27-yly,有value会导致默认值无法赋值
	        var value = void 0;
	        if (evalFlg) {
	            // 带层级解析，catch防止中断
	            try {
	                value = eval('(bdInstValue.' + attname + ')');
	            } catch (error) {
	                _sgiLogger.sgiLogger.error('\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D' + attname);
	                _sgiLogger.sgiLogger.eventErr(error);
	            }
	        } else value = bdInstValue[attname];
	        //给checkbox 使用
	        if (checked) {
	            var _checked = value ? true : false;
	            var _escape = currentModule.state.escape;
	            if (_escape) {
	                //转义
	                var escs = _escape.split("/");
	                _checked = value === escs[0];
	            }
	            inputprops.checked = _checked;
	            inputprops.value = value;
	        } else {
	            inputprops.value = value;
	        }
	    } else {
	        //20180704 wzhe 默认值 给当前value
	        inputprops.value = inputprops.defaultValue;
	        if (bdInstValue) {
	            if (evalFlg) {
	                // 带层级解析，catch防止中断
	                try {
	                    eval('(bdInstValue.' + attname + ' = inputprops.defaultValue)');
	                } catch (error) {
	                    _sgiLogger.sgiLogger.error('\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D' + attname);
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	            } else bdInstValue[attname] = inputprops.defaultValue;
	        }
	    }
	
	    // if (bdInstValue && bdInstValue[attname]) {//2018.04.27-yly,有value会导致默认值无法赋值
	    //     //给checkbox 使用
	    //     if (checked) {
	    //         // inputprops.checked = bdInstValue[attname] ? true : false;
	    //         let value = bdInstValue[attname];
	    //         let checked = value ? true : false;
	    //         let escape = currentModule.state.escape;
	    //         if (escape) {//转义
	    //             let escs = escape.split("/");
	    //             checked = (value === escs[0]);
	    //         }
	    //         inputprops.checked = checked;
	    //         inputprops.value = value;
	    //     } else {
	    //         inputprops.value = bdInstValue[attname];
	    //     }
	    // } else {//20180704 wzhe 默认值 给当前value
	    //     inputprops.value = inputprops.defaultValue;
	    //     if (bdInstValue) {
	    //         bdInstValue[attname] = inputprops.defaultValue;
	    //     }
	    // }
	};
	
	/**
	 * 属性转换
	 * @param {描述信息} currentModule
	 * @param {描述信息} moduleDesc
	 * @param {属性} formItem
	 * @param {属性} inputprops
	 */
	var AddFormCtlCommonAttribute = function AddFormCtlCommonAttribute(currentModule, moduleDesc, formItem, inputprops) {
	    // label样式回显
	    var isLabel = moduleDesc.isLabel;
	    currentModule.state.isLabel = !!isLabel;
	    if (isLabel) formItem.colon = true; // 显示冒号
	
	    var cId = moduleDesc.cId; //cid 唯一标示
	    if (cId) inputprops.id = (0, _SgiCommon.getConstByKey)(currentModule, cId);
	
	    var isDis = moduleDesc.isDis; //是否可用
	    inputprops.disabled = isDis;
	
	    var isRead = moduleDesc.isRead; //是否只读
	    // inputprops.style.readonly = 'expression(this.readonly = true)';
	    inputprops.readOnly = !!isRead;
	
	    if (moduleDesc.te || moduleDesc.teid) {
	        //避免不必要的执行getTRByPrm()方法
	        var text = _Resource.Resource.getTRByPrm(moduleDesc).te; //设置标签
	        if (text) formItem.label = text;
	    }
	
	    var ctlW = moduleDesc.ctlW; //控件宽度
	    // if (ctlW) formItem.style.width = ctlW;
	
	    var ctlH = moduleDesc.ctlH; //控件高度
	    if (ctlH) {
	        formItem.style.height = ctlH;
	        inputprops.style.height = ctlH; //输入框也随着高度变动
	    } else {
	        formItem.style.height = undefined; //编辑的时候即时刷新，也可以不加
	        inputprops.style.height = undefined; //编辑的时候即时刷新，也可以不加
	    }
	
	    var lblW = moduleDesc.lblW; //设置标签宽度
	
	    if (ctlW && lblW) {
	        var lblWSpan = parseInt(lblW / ctlW * 24);
	        var wrapperSpan = 24 - lblWSpan;
	        formItem.labelCol = { span: lblWSpan };
	        formItem.wrapperCol = { span: wrapperSpan };
	    } else {
	        formItem.labelCol = { span: 6 };
	        formItem.wrapperCol = { span: 18 };
	    }
	
	    var isLbl = moduleDesc.isLbl; //设置是否隐藏标签
	    if (isLbl) {
	        formItem.label = undefined;
	        formItem.labelCol = { span: 0 };
	        formItem.wrapperCol = { span: 24 };
	    }
	
	    var inpPopTe = moduleDesc.inpPopTe; //提示内容
	    if (inpPopTe) inputprops.placeholder = (0, _SgiCommon.getConstByKey)(currentModule, inpPopTe);
	
	    var defVal10 = moduleDesc.defVal10; //默认内容
	    if (defVal10 !== undefined) inputprops.defaultValue = defVal10; //数字控件是可以有0的，所以别用!判定
	
	    var bdText = moduleDesc.bdText; //后置内容
	    if (bdText) inputprops.addonAfter = bdText;
	
	    var alwBlk = moduleDesc.alwBlk; //是否允许为空
	    formItem.required = !alwBlk;
	    currentModule.state.validRules.required = !alwBlk;
	    currentModule.state.required = !alwBlk;
	    if (isLabel) {
	        //仅回显状态不校验
	        formItem.required = false;
	        currentModule.state.validRules.required = false;
	        currentModule.state.required = false;
	    }
	    // if (!alwBlk) {
	    //     formItem.required = !alwBlk;
	    //     currentModule.state.validRules.required = !alwBlk;
	    // } else {
	    //     formItem.required = !alwBlk;
	    //     currentModule.state.validRules.required = !alwBlk;
	    // }
	
	    if (moduleDesc.vldC) currentModule.state.validRules.dataType = moduleDesc.vldC;
	
	    var maxL = moduleDesc.maxL; //设置字段输入的最大长度
	    if (maxL) currentModule.state.validRules.maxL = maxL;else currentModule.state.validRules.maxL = undefined;
	    var minL = moduleDesc.minL; //设置字段输入的最小长度
	    if (minL) currentModule.state.validRules.minL = minL;else currentModule.state.validRules.minL = undefined;
	
	    var vldC = moduleDesc.vldC;
	    if (vldC && (vldC === "int" || vldC === "double" || vldC === "money" || vldC === "number")) {
	        var maxV = moduleDesc.maxV; //设置字段输入的最大值
	        if (maxV) currentModule.state.validRules.maxV = maxV;else currentModule.state.validRules.maxV = undefined;
	        var minV = moduleDesc.minV; //设置字段输入的最小值
	        if (minV) currentModule.state.validRules.minV = minV;else currentModule.state.validRules.minV = undefined;
	    }
	
	    var isHdn = moduleDesc.isHdn; //是否隐藏
	    if (isHdn) {
	        formItem.style.display = "none";
	    } else {
	        formItem.style.display = undefined;
	    }
	
	    inputprops.nowrap = !!moduleDesc.nowrap;
	
	    // form属性
	    currentModule.state._formProps = moduleDesc._formProps || {};
	
	    var lblAlg = moduleDesc.lblAlg; //设置标签对齐方式??没实现
	    var isClp = moduleDesc.isClp; //设置是否根据内容字段进行伸展和收缩??没实现
	    var msfTgt = moduleDesc.msfTgt; //设置错误信息提示位置??没实现
	
	    // var prefix = moduleDesc.prefix;//前缀图
	    // if (prefix) inputprops.prefix = prefix;
	
	    // 自定义样式
	    var cstmStyle = moduleDesc.cstmStyle;
	    var $cstmStyle = void 0;
	    if (cstmStyle) {
	        try {
	            $cstmStyle = new Function("module", "objFct", cstmStyle);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        // currentModule.state.cstmStyle = $cstmStyle;
	        (0, _SgiCommon.setFunction)(currentModule, "cstmStyle", $cstmStyle);
	    }
	
	    currentModule.state.showCheck = moduleDesc.showCheck;
	
	    // 自定义校验规则
	    var cstmValid = moduleDesc.cstmValid;
	    var $cstmValid = void 0;
	    if (cstmValid) {
	        try {
	            $cstmValid = new Function("module", "objFct", "value", cstmValid);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        currentModule.state.validRules.cstmValid = $cstmValid;
	    }
	};
	
	/**
	 * 设置布局
	 * @param {描述信息} moduleDesc
	 * @param {属性} formItem
	 * @param {属性} inputprops
	 */
	var setFormCtlLayout = function setFormCtlLayout(moduleDesc, formItem, inputprops) {};
	
	/**
	 * 事件转换
	 * @param {描述信息} currentModule
	 * @param {描述信息} moduleDesc
	 * @param {对象工厂} objFct
	 * @param {属性} inputprops
	 */
	var bindEvent = function bindEvent(currentModule, moduleDesc, objFct, inputprops, functions, type) {
	
	    //拖拽模式 不生成事件
	    if (type == 'dnd') {
	        return;
	    }
	
	    //onchange
	    var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
	    if (chgLsn) {
	        var $chgLsn;
	        try {
	            $chgLsn = new Function("module", "objFct", "record", "nv", "nt", "itemData", "extra", chgLsn);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        functions.onChange = $chgLsn;
	    }
	    inputprops.onChange = _SgiEventHandler.SgiEventHandler.onChange.bind(this, currentModule);
	
	    //onFocus
	    var inLsn = moduleDesc.inLsn; // 用户自定义点击事件
	    if (inLsn) {
	        var $inLsn;
	        try {
	            $inLsn = new Function("module", "objFct", inLsn);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        functions.onFocus = $inLsn;
	        inputprops.onFocus = _SgiEventHandler.SgiEventHandler.onFocus.bind(this, currentModule);
	    }
	
	    //onBlur
	    var lveLsn = moduleDesc.lveLsn; // 用户自定义点击事件
	    if (lveLsn) {
	
	        var $lveLsn;
	        try {
	            $lveLsn = new Function("module", "objFct", lveLsn);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        functions.onBlur = $lveLsn;
	        inputprops.onBlur = _SgiEventHandler.SgiEventHandler.onBlur.bind(this, currentModule);
	    }
	
	    // 自定义渲染组件
	    var cstmRender = moduleDesc.cstmRender;
	    if ((0, _sgiCommon.funStrCheck)(cstmRender)) {
	        var $cstmRender = void 0;
	        try {
	            $cstmRender = new Function("module", "inputprops", "value", "objFct", cstmRender);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        functions.cstmRender = $cstmRender;
	    }
	
	    // //onInput
	    // inputprops.onInput = function() {
	    //     message.info('获取焦点事件');
	    // }
	    // //点击事件
	    // inputprops.onClick = function () {
	    //     message.info('点击事件');
	    // }
	    // //双击事件
	    // inputprops.onDoubleClick = function () {
	    //     message.info('双击事件');
	    // }
	    // //onCopy
	    // inputprops.onCopy = function () {
	    //     message.info('复制事件');
	    // }
	    // //onCut
	    // inputprops.onCut = function () {
	    //     message.info('剪切事件');
	    // }
	    // //onPaste
	    // inputprops.onPaste = function () {
	    //     message.info('粘贴事件');
	    // }
	};
	exports.bindValue = bindValue;
	exports.bindEvent = bindEvent;
	exports.setFormCtlLayout = setFormCtlLayout;
	exports.AddFormCtlCommonAttribute = AddFormCtlCommonAttribute;
	exports.default = { bindValue: bindValue, bindEvent: bindEvent, setFormCtlLayout: setFormCtlLayout, AddFormCtlCommonAttribute: AddFormCtlCommonAttribute };

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PrmFactory = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               * @Descripttion: 
	                                                                                                                                                                                                                                                                               * @version: 
	                                                                                                                                                                                                                                                                               * @Author: wangz
	                                                                                                                                                                                                                                                                               * @Date: 2019-11-21 14:58:04
	                                                                                                                                                                                                                                                                               * @LastEditors: hanzb
	                                                                                                                                                                                                                                                                               * @LastEditTime: 2020-04-02 14:22:33
	                                                                                                                                                                                                                                                                               */
	/*   参数工厂
	 --------------------------------------------------------------------------------
	 作者：王哲                           创建日期：2018/03/12
	 --------------------------------------------------------------------------------
	 提供方法列表：
	 ★对象保存
	 ★对象读取
	 ★根据参数guid创建对象
	 ★对象删除
	 --------------------------------------------------------------------------------
	 修改：                               修改日期：
	 修改内容:
	
	 --------------------------------------------------------------------------------
	
	 *******************************************************************************/
	
	var _sgiCommonConstant = __webpack_require__(241);
	
	var _sgiCommon = __webpack_require__(28);
	
	var sgiCommon = _interopRequireWildcard(_sgiCommon);
	
	var _localStorage = __webpack_require__(239);
	
	var _sgiClient = __webpack_require__(306);
	
	var _sgiConfig = __webpack_require__(347);
	
	var _sgiConfig2 = _interopRequireDefault(_sgiConfig);
	
	var _smProjDndConfig = __webpack_require__(240);
	
	var _smProjDndConfig2 = _interopRequireDefault(_smProjDndConfig);
	
	var _SAPrmFactory = __webpack_require__(1159);
	
	var _sgiLogger = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var cacheFlag = false;
	
	/**
	 * 去掉参数中的特定无用字段，默认去掉_key字段
	 * @param {*} obj 
	 * @param {*} keyCode 
	 * @author hanzb 2018年11月13日
	 * @private
	 */
	var _keyFilter = function _keyFilter(obj, keyCode) {
		if (!obj) return;
		keyCode = keyCode || "_key";
		delete obj[keyCode];
		var cldSet = obj.cldSet;
		if (cldSet && cldSet.length > 0) {
			cldSet.forEach(function (cld) {
				delete cld[keyCode];
				_keyFilter(cld, keyCode);
			});
		}
	};
	
	/**
	 * 参数工厂操作方法
	 * @namespace 参数工厂方法集
	 */
	var PrmFactory = {
		/**
	  * 
	  * @param {*} pageInfo 
	  * @param {*} callback 
	  * @ignore
	  */
		batchPrm: function batchPrm(pageInfo, callback) {
			this.getPrmBySS();
		},
		/**
	  * 获取参数
	  *  @param {string} guid 参数唯一key
	  *  @param {boolean} [fromserver=false]	(暂不可用)强制从服务端获取参数标志，true表示强制从服务端获取
	  *  @return {object} 返回参数
	  */
		getPrm: function getPrm(guid, fromserver) {
	
			if (_smProjDndConfig2.default.isSAPrm(guid)) {
				return _SAPrmFactory.SAPrmFactory.getPrm(guid);
			}
	
			if (!guid) {
				return null;
			}
			if (typeof guid != 'string' || guid.constructor != String) {
				return null;
			}
			var ms = guid.split("`");
			var mguid = ms[0];
			var strJson = null;
			if (!fromserver && cacheFlag) {
				strJson = this.getPrmCache(mguid);
			}
			var json = {};
			if (!strJson) {
				if (_sgiConfig2.default.prmRelease) {
					strJson = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/prmFirst/" + guid, "GET");
				} else {
					strJson = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/prm/" + guid, "GET");
				}
				if (strJson) {
					switch (sgiCommon.getType(strJson)) {
						case "string":
							json = sgiCommon.strToJson(strJson);break;
						case "object":
							if (strJson.body) {
								strJson = strJson.body;
								json = sgiCommon.getType(strJson) === "string" ? sgiCommon.strToJson(strJson) : strJson;
							}
							break;
						default:
							break;
					}
				}
				// if (strJson && typeof strJson != "object") {
				// 	json = sgiCommon.strToJson(strJson);
				// }
			} else {
				json = sgiCommon.strToJson(strJson);
			}
			if (!json) {
				return null;
			}
			var length = ms.length;
			for (var i = 1; i < length; i++) {
				json = this.findMenber(json, ms[i]);
			}
			return json;
		},
		/**
	  * 获取发布参数
	  * @param {string} guid 参数唯一key
	  * @param {boolean} [fromserver=false]	(暂不可用)强制从服务端获取参数标志，true表示强制从服务端获取
	  * @return {object} 返回参数
	  * 
	  * @ignore
	  */
		getPrmPublish: function getPrmPublish(guid, fromserver) {
			if (!guid) {
				return null;
			}
			if (typeof guid != 'string' || guid.constructor != String) {
				return null;
			}
			var ms = guid.split("`");
			var mguid = ms[0];
			var strJson = null;
			if (!fromserver && cacheFlag) {
				strJson = this.getPrmCache(mguid);
			}
			var json = {};
			if (!strJson) {
				strJson = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/getPublish/" + guid, "GET");
				if (strJson && (typeof strJson === 'undefined' ? 'undefined' : _typeof(strJson)) != "object") {
					json = sgiCommon.strToJson(strJson);
				}
			} else {
				json = sgiCommon.strToJson(strJson);
			}
			if (!json) {
				return null;
			}
			var length = ms.length;
			for (var i = 1; i < length; i++) {
				json = this.findMenber(json, ms[i]);
			}
			return json;
		},
		/**
	  * 保存参数方法
	  *  @param {object} root 需要保存的参数对象
	  *  @return {number} 0-成功，-1-失败
	  */
		save: function save(root) {
			if (!root) {
				return -1;
			}
	
			if (!root && (typeof root === 'undefined' ? 'undefined' : _typeof(root)) !== "object") {
				return -1;
			}
	
			if (_smProjDndConfig2.default.isSAPrmByAP(root.ap)) {
				root.nam = root.te || root.n;
				var saResult = _SAPrmFactory.SAPrmFactory.save(root);
				return saResult ? 0 : -1;
			}
	
			var guid = this.makeGUID(root);
			root.guid = guid; //参数赋值/重写guid  hanzb 2018-5-11
	
			var data = {};
			var copyRoot = tool.copy(root, true);
			// 去掉_key属性
			_keyFilter(copyRoot);
			data.root = sgiCommon.jsonToStr(copyRoot);
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/prm/" + guid, "PUT", data);
	
			if (result === 0) {
				var newprm = this.getPrm(guid, true);
				root.prmVsn = newprm.prmVsn;
				root.auth = newprm.auth;
				root.crtTm = newprm.crtTm;
				root.edAuth = newprm.edAuth;
				root.edTm = newprm.edTm;
				root.prmT = newprm.prmT;
	
				if (cacheFlag) {
					this.saveLocal(guid, sgiCommon.jsonToStr(root)); //json
				}
	
				// 处理标准代码缓存
				if (StandardCode) StandardCode.delSC(guid);
	
				return 0;
			} else if (result === 1) {
				_sgiLogger.sgiLogger.log("提示:参数冲突.已经有人修改了该参数，请刷新");
				return -1;
			} else if (result === 2) {
				_sgiLogger.sgiLogger.log("提示:参数guid＝" + guid + "已经存在，请更改guid后再保存");
				return -1;
			} else if (result === -1) {
				_sgiLogger.sgiLogger.log("提示:保存参数异常");
				return -1;
			}
		},
		/**
	  * 发布参数方法
	  * @param {string} guid 要发布的参数guid
	  * @return {number} 0-成功，-1-失败
	  * 
	  * @ignore
	  */
		publish: function publish(guid, type) {
			if (!guid) return -1;
			if (sgiCommon.getType(guid) === "array") {
				return _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/publish/" + type, "POST", JSON.stringify(guid), { 'Content-Type': "application/json; charset=utf-8" });
			} else {
				return _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/publish/" + guid, "GET");
			}
		},
	
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmBySS: function getPrmBySS(ap, tt, ss) {
			if (!ap && !tt && !ss) {
				return null;
			}
	
			if (_smProjDndConfig2.default.isSAPrmByAP(ap)) {
				return _SAPrmFactory.SAPrmFactory.getPrmDetailBySS(ap, tt, ss);
			}
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/prm/" + "ap/" + ap + "/tt/" + tt + "/ss/" + ss, "GET");
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			return prms;
		},
	
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} guid 
	  * 
	  * @ignore
	  */
		getDSDPrmBySS: function getDSDPrmBySS(ap, guid) {
			if (!ap) return null;
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/prm/" + "ap/" + ap + "/guid/" + guid, "GET");
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			return prms;
		},
	
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmByTT: function getPrmByTT(ap, tt) {
			if (!ap && !tt) {
				return null;
			}
	
			if (_smProjDndConfig2.default.isSAPrmByAP(ap)) {
				return _SAPrmFactory.SAPrmFactory.getPrmDetailByTT(ap, tt, false);
			}
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/prm/" + "ap/" + ap + "/tt/" + tt, "GET");
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			return prms;
		},
	
		/**
	  * 保存资源
	  * @param {object} resource 要保存的资源对象
	  * @return {number} 0-成功，-1-失败
	  * 
	  * @ignore
	  */
		saveResources: function saveResources(resource) {
	
			if (!resource) return -1;
	
			var ap = resource.ap;
			var tt = resource.tt;
			var ss = resource.ss;
			var te = resource.te;
			if (!ap || !tt || !ss || !te) return -1;
	
			var vsn = resource.vsn;
			if (vsn) resource.vsn = parseInt(vsn) + 1; //版本管理
	
			var data = {};
			data.root = sgiCommon.jsonToStr(resource);
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/resource/" + resource.sc, "PUT", data);
			if (result == 0) {
				_sgiLogger.sgiLogger.log("提示:保存成功");
				return 0;
			} else if (result == 1) {
				_sgiLogger.sgiLogger.log("提示:参数冲突.已经有人修改了该参数，请刷新");
				return 1;
			} else {
				_sgiLogger.sgiLogger.log("提示:不等于0不等于0不等于0，请刷新");
				return -1;
			}
		},
	
		/**
	  * 获取资源
	  * @param {string} sc 资源id
	  * 
	  * @ignore
	  */
		getResource: function getResource(sc) {
	
			if (!sc) return null;
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/resource/" + sc, "GET");
			if (!result) return null;
			return result;
		},
	
		/**
	  * 获取资源列表，根据ap、tt、ss
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 资源对象数组
	  * 
	  * @ignore
	  */
		getResourceList: function getResourceList(ap, tt, ss) {
			if (!ap && !tt && !ss) {
				return null;
			}
			var condition = { ap: ap, tt: tt, ss: ss };
	
			var data = {};
			data.root = sgiCommon.jsonToStr(condition);
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/resource/list/", "PUT", data);
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			return prms;
		},
	
		/**
	  * 查询资源是否存在，存在返回资源对象
	  * @param {string} ap ap
	  * @param {string} tt tt
	  * @param {string} ss ss
	  * @param {string} text 资源文本
	  * @returns {object} 匹配的资源对象
	  * 
	  * @ignore
	  */
		existResource: function existResource(ap, tt, ss, text) {
	
			// if (!ap && !tt && !ss) return null;
	
			// if(text) text = "%" + text + "%";
	
			var condition = { ap: ap, tt: tt, ss: ss, te: text };
	
			var data = {};
			data.root = sgiCommon.jsonToStr(condition);
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/resource/list/", "PUT", data);
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
	
			if (prms.length >= 1) return prms[0];
	
			return null;
		},
	
		/**
	  * 条件查询文本资源
	  * @param {string} ap ap
	  * @param {string} tt tt
	  * @param {string} ss ss
	  * @param {string} text 资源文本
	  * @returns {object[]} 匹配到的资源对象数组
	  * 
	  * @ignore
	  */
		getRsList: function getRsList(ap, tt, ss, text) {
	
			if (!ap && !tt && !ss) return null;
	
			if (text) text = "%" + text + "%";else text = null; //消除空字符串影响
	
			var condition = { ap: ap, tt: tt, ss: ss, te: text };
	
			var data = {};
			data.root = sgiCommon.jsonToStr(condition);
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/resource/list/", "PUT", data);
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			return prms;
		},
	
		/**
	  * 查询参数历史版本
	  * @param {string} guid 参数guid
	  * @return {object[]} 历史版本参数数组
	  */
		getHisPrmsByGuid: function getHisPrmsByGuid(guid) {
	
			if (!guid) return;
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/history/" + guid, "GET");
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			return prms;
		},
	
		/**
	  * 查询参数历史版本,带分页功能
	  * @param {string} guid 参数guid
	  * @param {object} [params] 分批信息{pageSize:每页记录数,current:当前页号，从0开始}
	  * @return {object[]} 历史版本参数数组
	  */
		getHisPrmsByGuidWithPage: function getHisPrmsByGuidWithPage(guid, params) {
	
			if (!guid) return;
			params = params || {};
	
			var data = {};
			var header = {};
			if (params.pageSize) {
				header.pagesize = parseInt(params.pageSize);
			} else {
				header.pagesize = 0;
			}
			if (params.current) {
				header.pageno = params.current;
			} else {
				header.pageno = 0;
			}
			var result = undefined;
			var pagecount = 0;
			var total = 0;
			var success = function success(data, textStatus, xhr) {
				result = data;
				pagecount = xhr.getResponseHeader("pagecount");
				total = xhr.getResponseHeader("total");
			};
			_sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/history/" + guid, "GET", data, header, false, success);
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			var results = {};
			results.list = prms;
			results.pagecount = parseInt(pagecount);
			results.total = parseInt(total);
	
			return results;
		},
	
		/**
	  * 模糊查询
	  * @param {string} ap 系统编码
	  * @param {string} tt 顶级类型编码
	  * @param {string} ss 子系统编码
	  * @param {string} condition 参数条件
	  * @returns {object[]} 符合条件的参数列表
	  */
		getPrmsByCondition: function getPrmsByCondition(ap, tt, ss, condition) {
			if (!ap) return null;
	
			var data = {};
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/prm/ap/" + ap + "/tt/" + tt + "/ss/" + ss + "/condition/" + condition, "GET", data);
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			return prms;
		},
	
		/**
	  * 替换参数历史版本
	  * @param {object} root 要恢复的历史版本参数
	  * @return {number} 0成功，1失败
	  */
		recover: function recover(root) {
	
			if (!root) return;
			var guid = root.guid;
			if (!guid) return;
			var nowPrm = this.getPrm(guid);
	
			root.prmVsn = nowPrm.prmVsn;
	
			return this.save(root);
		},
	
		/**
	  * 根据guid删除指定参数
	  * @param {string} guid 制定guid
	  */
		remove: function remove(guid) {
			if (!guid) {
				return -1;
			}
			if (typeof guid != 'string' || guid.constructor != String) {
				return -1;
			}
			var ms = guid.split("`");
			var mguid = ms[0];
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/prm/" + guid, "DELETE");
			if (result == 0) {
				if (cacheFlag) {
					this.deleteLocal(guid);
				}
			}
			return result;
		},
	
		/**
	  * 从本地缓存获取参数
	  * @param {string} guid 参数guid
	  * @returns {object} 返回缓存参数
	  * 
	  * @ignore
	  */
		getPrmCache: function getPrmCache(guid) {
			return _localStorage.sgiLocalStorage.get(guid);
		},
		/**
	  * 将参数缓存至本地缓存中
	  * @param {string} guid 参数guid
	  * @param {object} json 参数对象
	  * 
	  * @ignore
	  */
		saveLocal: function saveLocal(guid, json) {
			_localStorage.sgiLocalStorage.set(guid, json);
		},
		/**
	  * 从本地缓存中删除参数
	  * @param {string} guid 参数guid
	  * 
	  * @ignore
	  */
		deleteLocal: function deleteLocal(guid) {
			_localStorage.sgiLocalStorage.remove(guid);
		},
	
		/**
	  * 组装guid
	  * @param {object} root 参数对象
	  * @returns {string} 返回的guid
	  * 
	  * @ignore
	  */
		makeGUID: function makeGUID(root) {
			if (root && root.guid) {
				return root.guid;
			}
			var ap, tt, ss, sc;
			ap = root.ap;
			tt = root.tt;
			ss = root.ss;
			sc = root.sc;
			if (!(ap && tt && ss && sc)) {
				return null;
			}
			// var guid = ap + GUID.SP + tt + GUID.SP + ss + GUID.SP + sc;
			var guid = ap + _sgiCommonConstant.GUID.SP + tt + _sgiCommonConstant.GUID.SP + sc;
			return guid;
		},
		/**
	  * 在参数对象子节点中寻找sc匹配的子节点对象
	  * @param {object} json 参数对象
	  * @param {string} sc sc
	  * @returns {object} 匹配的子节点参数对象
	  * 
	  * @ignore
	  */
		findMenber: function findMenber(json, sc) {
			if (!json) {
				return null;
			}
			var children = json.cldSet;
			if (!children) return null;
			var count = children.length;
			for (var i = 0; i < count; i++) {
				if (children[i].sc === sc) {
					json = children[i];
					break;
				}
			}
			return json;
		},
	
		/**
	  * 创建新的ap
	  * @param {object} application 新的ap对象
	  * @param {*} prmsIn something
	  * @returns {number} 0成功，-1失败
	  * 
	  * @ignore
	  */
		saveApplication: function saveApplication(application, prmsIn) {
	
			if (!application || !application.id) return -1;
	
			var data = {};
			data.root = sgiCommon.jsonToStr(application);
			if (prmsIn) data.prmsIn = sgiCommon.jsonToStr(prmsIn);
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/app/" + application.id, "PUT", data);
			if (result == 0) {
				_sgiLogger.sgiLogger.log("提示:保存成功");
			} else if (result == 1) {
				_sgiLogger.sgiLogger.log("提示:参数冲突.已经有人修改了该参数，请刷新");
			} else {
				_sgiLogger.sgiLogger.log("提示:不等于0不等于0不等于0，请刷新");
			}
			return result;
		},
	
		/**
	  * 获取所有ap列表
	  * @returns {object[]} 所有ap列表
	  */
		getAPList: function getAPList() {
			var data = {};
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/app/list/", "GET", data);
			var prms = new Array();
			if (result) {
				result = sgiCommon.strToJson(result);
				result.forEach(function (strJson, index) {
					var json = sgiCommon.strToJson(strJson);
					prms.push(json);
				});
			}
			return prms;
		},
	
		/**
	  * 删除ap
	  * @param {object} application ap参数对象
	  * @returns {number} 0成功，-1失败
	  * 
	  * @ignore
	  */
		deleteApplication: function deleteApplication(application) {
	
			if (!application || !application.id) return -1;
	
			var result = _sgiClient.sgiPfClient.restcall(_sgiConfig2.default.pf + "/app/" + application.id, "DELETE");
			return result;
		}
	
		// 初始化
	};if (!window.PrmFactory) window.PrmFactory = PrmFactory;
	// 添加方法
	else Object.assign(window.PrmFactory, PrmFactory);
	// 导出
	var wPrmFactory = window.PrmFactory;
	exports.PrmFactory = wPrmFactory;
	exports.default = wPrmFactory;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 表单控件的基础方法，供控件继承
	 * wangz
	 * 2018.3.12
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sgiFormCtlBaseFun = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _sgiFormCtlValidator = __webpack_require__(254);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiCommon = __webpack_require__(29);
	
	var sgiFormCtlBaseFun = {
	
	    /**
	     * 初始化state属性
	     */
	    initState: function initState() {
	        //初始化state
	        this.state = {
	            validRules: {},
	            validState: true,
	            required: false,
	            loading: false,
	            isLabel: false,
	            formItemProps: {
	                style: { 'margin-bottom': "1px", 'margin-top': "1px" },
	                hasFeedback: false,
	                help: undefined,
	                validateStatus: 'success'
	                // colon: false //不显示：
	            }, //存放formItem属性
	            inputprops: {
	                style: { width: "100%" },
	                // value: undefined,  //文本框显示值 //2018.04.27-yly,有value会导致默认值无法赋值
	                disabled: false //是否可用
	            }, //存放input属性
	            functions: {}, //存放事件函数
	            _formProps: {}, //存放form属性
	            noFI: this.props.noFI //去除FormItem
	        };
	    },
	
	    /**
	    * 设置value值
	    * 刷新控件时候，调用的方法
	    */
	    setValue: function setValue(value) {
	        //更新state
	        if (value === this.state.inputprops.value) {
	            return;
	        }
	        this.state.inputprops.value = value;
	
	        //调用自定义change事件  2018.6.11追加的  //不能要了，出bug了，hanzb 2018-6-14
	        // let onChange = this.state.functions.onChange;
	        // if (onChange) {
	        //     sgiLogger.eventin('修改');
	        //     onChange(this, this.props.objFct, value, this.props.objFct.get(this.props.bdInst));
	        // }
	
	        //页面校验 刷新不校验
	        // this.validate(value);
	        this.setState({ loading: false });
	    },
	
	    /**
	    * 获取value值
	    */
	    getValue: function getValue() {
	        return this.state.inputprops.value;
	    },
	
	    /**
	     * 设置是否禁用
	     */
	    setDisabled: function setDisabled(value) {
	        this.state.inputprops.disabled = value;
	        this.setState(this.state.inputprops);
	    },
	
	    /**
	     * 设置form禁用标识
	     * @param {boolean} formDisabled form禁用标识
	     */
	    setFormDisabled: function setFormDisabled(formDisabled) {
	        this.state.inputprops.formDisabled = formDisabled;
	        this.setState(this.state.inputprops);
	    },
	
	    /**
	    * 设置是否隐藏
	    */
	    setHidden: function setHidden(value) {
	        // this.state.inputprops.hidden = value; //2018.04.25-yly,修改弹窗无法隐藏问题
	        // this.setState(this.state.inputprops);
	        if (value) {
	            this.state.formItemProps.style.display = "none";
	        } else {
	            this.state.formItemProps.style.display = undefined;
	        }
	        if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	            // react16需要更新引用
	            this.state.formItemProps.style = _extends({}, this.state.formItemProps.style);
	        }
	        this.setState(this.state.formItemProps);
	    },
	
	    /**
	     * 设置是否必填
	     * @param {boolean} required 是否必填
	     */
	    setRequired: function setRequired(required) {
	        required = !!required;
	        this.state.required = required;
	        this.setState({});
	    },
	    // /**
	    // * 设置是否只读
	    // */
	    // setReadonly: function (value) {
	    //     this.state.inputprops.style.readonly = value;
	    //     this.setState(this.state.inputprops);
	    // },
	    /**
	     * 页面修改时，刷新工厂绑定的值
	     */
	    ctlRefresh: function ctlRefresh(attname, bdInst, objFct, value) {
	
	        //对象工厂的值刷新
	        this.setBindValue(attname, bdInst, objFct, value);
	        // if (bdInst && attname) {
	        //     //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	        //     //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	        //     let bdInstData;
	        //     if (this.props.type === 'tb') {
	        //         const bdInstKeyList = bdInst.split('`');
	        //         const bdInstList = objFct.get(bdInstKeyList[0]);
	        //         if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	        //             bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
	        //         }
	        //     } else {
	        //         bdInstData = objFct.get(bdInst);
	        //     }
	        //     bdInstData[attname] = value;
	        // }
	
	        //更新state
	        this.state.inputprops.value = value;
	
	        //页面校验
	        this.validate(value);
	    },
	
	    /**
	     * 仅更新工厂绑定值
	     * @param {string} attname 属性名
	     * @param {string} bdInst 绑定实例名
	     * @param {ObjFactory} objFct 对象工厂
	     * @param {object} value 值
	     */
	    setBindValue: function setBindValue(attname, bdInst, objFct, value) {
	        if (bdInst && attname) {
	            var bdInstData = void 0;
	            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	            if (typeof bdInst === "string") {
	                //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	                //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	                if (this.props.type === 'tb') {
	                    var bdInstKeyList = bdInst.split('`');
	                    var bdInstList = objFct.get(bdInstKeyList[0]);
	                    if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                        bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
	                    }
	                } else {
	                    bdInstData = objFct.get(bdInst);
	                }
	            } else {
	                bdInstData = bdInst;
	            }
	            if (bdInstData) {
	                if (RegExp(/[.|\[|\]]+/).test(attname)) {
	                    // 带层级赋值，catch避免中断
	                    try {
	                        eval("(bdInstData." + attname + " = value)");
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.error("\u4FEE\u6539\u7ED1\u5B9A\u5BF9\u8C61\u65F6\uFF0C\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D[" + attname + "]");
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                } else {
	                    bdInstData[attname] = value;
	                }
	            }
	            // if (bdInstData) bdInstData[attname] = value;
	        }
	    },
	
	    // 检查数据合法性
	    validate: function validate(value) {
	        if (!value) {
	            value = this.state.inputprops.value;
	        }
	        if (this.state.formItemProps.style.display == "none") {
	            this.setSuccess();
	            return false;
	        }
	        var validRules = this.state.validRules;
	        if (validRules.length === 0) {
	            this.setSuccess();
	            return false;
	        }
	
	        //var flag = true;
	        var msg = (0, _sgiFormCtlValidator.sgiFormCtlCheck)(validRules, value, { module: this, objFct: this.props.objFct });
	        if (Object.prototype.toString.call(msg) === "[object Object]") {
	            this.setValidate(msg.help, msg.validateStatus, msg.hasFeedback);
	        } else if (msg) {
	            this.setError(msg);
	        } else {
	            this.setSuccess();
	        }
	        return msg;
	    },
	    setError: function setError(msg) {
	        this.state.formItemProps.hasFeedback = true;
	        this.state.formItemProps.help = msg;
	        this.state.formItemProps.validateStatus = 'error';
	        this.setState(this.state.formItemProps);
	    },
	    setSuccess: function setSuccess() {
	        this.state.formItemProps.hasFeedback = this.state.showCheck || false;
	        this.state.formItemProps.help = undefined;
	        this.state.formItemProps.validateStatus = 'success';
	        this.setState(this.state.formItemProps);
	    },
	    // 设置组件校验(对外接口)
	    setValidate: function setValidate(message, status, hasFeedback) {
	        this.state.formItemProps.help = message;
	        this.state.formItemProps.validateStatus = status;
	        this.state.formItemProps.hasFeedback = !!hasFeedback;
	        this.setState({});
	    },
	    refresh: function refresh() {
	        this.loaded = false;
	        this.setState({ loading: false });
	    },
	    getIsLabel: function getIsLabel() {
	        // isLabel
	        var isLabel = this.state.isLabel || this.state.formIsLabel;
	
	        // 标签和非标签特殊处理
	        var _state = this.state,
	            formItemProps = _state.formItemProps,
	            validRules = _state.validRules;
	        var moduleDesc = this.props.moduleDesc;
	
	        if (isLabel) {
	            formItemProps.required = false;
	            validRules.required = false;
	        } else {
	            var alwBlk = moduleDesc.alwBlk; //是否允许为空
	            formItemProps.required = !alwBlk;
	            validRules.required = !alwBlk;
	        }
	
	        // 返回
	        return isLabel;
	    },
	    getReviseProps: function getReviseProps() {
	        var _state2 = this.state,
	            inputprops = _state2.inputprops,
	            formItemProps = _state2.formItemProps,
	            _formProps = _state2._formProps;
	
	        var isLabel = this.getIsLabel();
	        var reviseProps = {
	            _inputProps: {
	                isLabel: isLabel,
	                disabled: inputprops.disabled || inputprops.formDisabled,
	                title: inputprops.value,
	                className: inputprops.nowrap ? "sgiFormItemSpan" : undefined
	            },
	            _formItemProps: {
	                colon: isLabel || _formProps.colon //冒号
	            }
	        };
	        return reviseProps;
	    },
	
	    // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
	    renderBeforeReturn: function renderBeforeReturn() {
	        var _props = this.props,
	            parentModule = _props.parentModule,
	            moduleDesc = _props.moduleDesc,
	            objFct = _props.objFct,
	            type = _props.type;
	        var _state3 = this.state,
	            formItemProps = _state3.formItemProps,
	            inputprops = _state3.inputprops,
	            required = _state3.required;
	
	        // 自定义样式处理
	        // const getCstmStyle = this.state.cstmStyle;
	
	        var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(this, "cstmStyle");;
	        var cstmStyle = {};
	        if (getCstmStyle) {
	            try {
	                cstmStyle = getCstmStyle(this, objFct) || {};
	            } catch (error) {
	                tool.sgiLogger.log(error);
	            }
	        }
	        for (var key in cstmStyle) {
	            if (key.toLowerCase() === "formItemStyle".toLowerCase() || key.toLowerCase() === "formItemProps".toLowerCase()) {
	                Object.assign(formItemProps.style, cstmStyle[key] || {}); //formTtem样式
	            } else if (key.toLowerCase() === "inputStyle".toLowerCase() || key.toLowerCase() === "inputProps".toLowerCase()) {
	                Object.assign(inputprops.style, cstmStyle[key] || {}); //input样式
	            } else {
	                this.state[key] = cstmStyle[key]; //其他样式，富文本等的其他样式
	            }
	        }
	
	        // 必填属性处理
	        formItemProps.required = required;
	        this.state.validRules.required = required;
	    }
	};
	exports.sgiFormCtlBaseFun = sgiFormCtlBaseFun;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Model = __webpack_require__(57);
	
	var componentUtil = __webpack_require__(224);
	
	var _clazz = __webpack_require__(115);
	
	var enableClassManagement = _clazz.enableClassManagement;
	var parseClassType = _clazz.parseClassType;
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	var layout = __webpack_require__(47);
	
	var boxLayoutMixin = __webpack_require__(1855);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Component model
	 *
	 * @module echarts/model/Component
	 */
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Component
	 * @constructor
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {module:echarts/model/Model} ecModel
	 */
	
	var ComponentModel = Model.extend({
	  type: 'component',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  id: '',
	
	  /**
	   * Because simplified concept is probably better, series.name (or component.name)
	   * has been having too many resposibilities:
	   * (1) Generating id (which requires name in option should not be modified).
	   * (2) As an index to mapping series when merging option or calling API (a name
	   * can refer to more then one components, which is convinient is some case).
	   * (3) Display.
	   * @readOnly
	   */
	  name: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  mainType: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  subType: '',
	
	  /**
	   * @readOnly
	   * @type {number}
	   */
	  componentIndex: 0,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	  ecModel: null,
	
	  /**
	   * key: componentType
	   * value:  Component model list, can not be null.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @readOnly
	   */
	  dependentModels: [],
	
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  uid: null,
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  $constructor: function (option, parentModel, ecModel, extraOpt) {
	    Model.call(this, option, parentModel, ecModel, extraOpt);
	    this.uid = componentUtil.getUID('ec_cpt_model');
	  },
	  init: function (option, parentModel, ecModel, extraOpt) {
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
	    var themeModel = ecModel.getTheme();
	    zrUtil.merge(option, themeModel.get(this.mainType));
	    zrUtil.merge(option, this.getDefaultOption());
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (option, extraOpt) {
	    zrUtil.merge(this.option, option, true);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(this.option, option, layoutMode);
	    }
	  },
	  // Hooker after init or mergeOption
	  optionUpdated: function (newCptOption, isInit) {},
	  getDefaultOption: function () {
	    var fields = inner(this);
	
	    if (!fields.defaultOption) {
	      var optList = [];
	      var Class = this.constructor;
	
	      while (Class) {
	        var opt = Class.prototype.defaultOption;
	        opt && optList.push(opt);
	        Class = Class.superClass;
	      }
	
	      var defaultOption = {};
	
	      for (var i = optList.length - 1; i >= 0; i--) {
	        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
	      }
	
	      fields.defaultOption = defaultOption;
	    }
	
	    return fields.defaultOption;
	  },
	  getReferringComponents: function (mainType) {
	    return this.ecModel.queryComponents({
	      mainType: mainType,
	      index: this.get(mainType + 'Index', true),
	      id: this.get(mainType + 'Id', true)
	    });
	  }
	}); // Reset ComponentModel.extend, add preConstruct.
	// clazzUtil.enableClassExtend(
	//     ComponentModel,
	//     function (option, parentModel, ecModel, extraOpt) {
	//         // Set dependentModels, componentIndex, name, id, mainType, subType.
	//         zrUtil.extend(this, extraOpt);
	//         this.uid = componentUtil.getUID('componentModel');
	//         // this.setReadOnly([
	//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
	//         //     'dependentModels', 'componentIndex'
	//         // ]);
	//     }
	// );
	// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	enableClassManagement(ComponentModel, {
	  registerWhenExtend: true
	});
	componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.
	
	componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);
	
	function getDependencies(componentType) {
	  var deps = [];
	  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
	    deps = deps.concat(Clazz.prototype.dependencies || []);
	  }); // Ensure main type.
	
	  deps = zrUtil.map(deps, function (type) {
	    return parseClassType(type).main;
	  }); // Hack dataset for convenience.
	
	  if (componentType !== 'dataset' && zrUtil.indexOf(deps, 'dataset') <= 0) {
	    deps.unshift('dataset');
	  }
	
	  return deps;
	}
	
	zrUtil.mixin(ComponentModel, boxLayoutMixin);
	var _default = ComponentModel;
	module.exports = _default;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	var _format = __webpack_require__(48);
	
	var formatTime = _format.formatTime;
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	var getTooltipMarker = _format.getTooltipMarker;
	
	var modelUtil = __webpack_require__(27);
	
	var ComponentModel = __webpack_require__(65);
	
	var colorPaletteMixin = __webpack_require__(854);
	
	var dataFormatMixin = __webpack_require__(432);
	
	var _layout = __webpack_require__(47);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var _task = __webpack_require__(433);
	
	var createTask = _task.createTask;
	
	var _sourceHelper = __webpack_require__(114);
	
	var prepareSource = _sourceHelper.prepareSource;
	var getSource = _sourceHelper.getSource;
	
	var _dataProvider = __webpack_require__(143);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var SeriesModel = ComponentModel.extend({
	  type: 'series.__base__',
	
	  /**
	   * @readOnly
	   */
	  seriesIndex: 0,
	  // coodinateSystem will be injected in the echarts/CoordinateSystem
	  coordinateSystem: null,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * legend visual provider to the legend component
	   * @type {Object}
	   */
	  // PENDING
	  legendVisualProvider: null,
	
	  /**
	   * Access path of color for visual
	   */
	  visualColorAccessPath: 'itemStyle.color',
	
	  /**
	   * Access path of borderColor for visual
	   */
	  visualBorderColorAccessPath: 'itemStyle.borderColor',
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  init: function (option, parentModel, ecModel, extraOpt) {
	    /**
	     * @type {number}
	     * @readOnly
	     */
	    this.seriesIndex = this.componentIndex;
	    this.dataTask = createTask({
	      count: dataTaskCount,
	      reset: dataTaskReset
	    });
	    this.dataTask.context = {
	      model: this
	    };
	    this.mergeDefaultAndTheme(option, ecModel);
	    prepareSource(this);
	    var data = this.getInitialData(option, ecModel);
	    wrapData(data, this);
	    this.dataTask.context.data = data;
	
	    /**
	     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
	     * @private
	     */
	    inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
	    // dataBeforeProcessed by cloneShallow), cloneShallow will
	    // cause data.graph.data !== data when using
	    // module:echarts/data/Graph or module:echarts/data/Tree.
	    // See module:echarts/data/helper/linkList
	    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
	    // init or merge stage, because the data can be restored. So we do not `restoreData`
	    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
	    // Call `seriesModel.getRawData()` instead.
	    // this.restoreData();
	
	    autoSeriesName(this);
	  },
	
	  /**
	   * Util for merge default and theme to option
	   * @param  {Object} option
	   * @param  {module:echarts/model/Global} ecModel
	   */
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
	    // But if name duplicate between series subType
	    // (for example: parallel) add component mainType,
	    // add suffix 'Series'.
	
	    var themeSubType = this.subType;
	
	    if (ComponentModel.hasClass(themeSubType)) {
	      themeSubType += 'Series';
	    }
	
	    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
	    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	    this.fillDataTextStyle(option.data);
	
	    if (layoutMode) {
	      mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (newSeriesOption, ecModel) {
	    // this.settingTask.dirty();
	    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
	    this.fillDataTextStyle(newSeriesOption.data);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
	    }
	
	    prepareSource(this);
	    var data = this.getInitialData(newSeriesOption, ecModel);
	    wrapData(data, this);
	    this.dataTask.dirty();
	    this.dataTask.context.data = data;
	    inner(this).dataBeforeProcessed = data;
	    autoSeriesName(this);
	  },
	  fillDataTextStyle: function (data) {
	    // Default data label emphasis `show`
	    // FIXME Tree structure data ?
	    // FIXME Performance ?
	    if (data && !zrUtil.isTypedArray(data)) {
	      var props = ['show'];
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i] && data[i].label) {
	          modelUtil.defaultEmphasis(data[i], 'label', props);
	        }
	      }
	    }
	  },
	
	  /**
	   * Init a data structure from data related option in series
	   * Must be overwritten
	   */
	  getInitialData: function () {},
	
	  /**
	   * Append data to list
	   * @param {Object} params
	   * @param {Array|TypedArray} params.data
	   */
	  appendData: function (params) {
	    // FIXME ???
	    // (1) If data from dataset, forbidden append.
	    // (2) support append data of dataset.
	    var data = this.getRawData();
	    data.appendData(params.data);
	  },
	
	  /**
	   * Consider some method like `filter`, `map` need make new data,
	   * We should make sure that `seriesModel.getData()` get correct
	   * data in the stream procedure. So we fetch data from upstream
	   * each time `task.perform` called.
	   * @param {string} [dataType]
	   * @return {module:echarts/data/List}
	   */
	  getData: function (dataType) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var data = task.context.data;
	      return dataType == null ? data : data.getLinkedData(dataType);
	    } else {
	      // When series is not alive (that may happen when click toolbox
	      // restore or setOption with not merge mode), series data may
	      // be still need to judge animation or something when graphic
	      // elements want to know whether fade out.
	      return inner(this).data;
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/List} data
	   */
	  setData: function (data) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var context = task.context; // Consider case: filter, data sample.
	
	      if (context.data !== data && task.modifyOutputEnd) {
	        task.setOutputEnd(data.count());
	      }
	
	      context.outputData = data; // Caution: setData should update context.data,
	      // Because getData may be called multiply in a
	      // single stage and expect to get the data just
	      // set. (For example, AxisProxy, x y both call
	      // getData and setDate sequentially).
	      // So the context.data should be fetched from
	      // upstream each time when a stage starts to be
	      // performed.
	
	      if (task !== this.dataTask) {
	        context.data = data;
	      }
	    }
	
	    inner(this).data = data;
	  },
	
	  /**
	   * @see {module:echarts/data/helper/sourceHelper#getSource}
	   * @return {module:echarts/data/Source} source
	   */
	  getSource: function () {
	    return getSource(this);
	  },
	
	  /**
	   * Get data before processed
	   * @return {module:echarts/data/List}
	   */
	  getRawData: function () {
	    return inner(this).dataBeforeProcessed;
	  },
	
	  /**
	   * Get base axis if has coordinate system and has axis.
	   * By default use coordSys.getBaseAxis();
	   * Can be overrided for some chart.
	   * @return {type} description
	   */
	  getBaseAxis: function () {
	    var coordSys = this.coordinateSystem;
	    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
	  },
	  // FIXME
	
	  /**
	   * Default tooltip formatter
	   *
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @param {string} [renderMode='html'] valid values: 'html' and 'richText'.
	   *                                     'html' is used for rendering tooltip in extra DOM form, and the result
	   *                                     string is used as DOM HTML content.
	   *                                     'richText' is used for rendering tooltip in rich text form, for those where
	   *                                     DOM operation is not supported.
	   * @return {Object} formatted tooltip with `html` and `markers`
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var series = this;
	    renderMode = renderMode || 'html';
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    var isRichText = renderMode === 'richText';
	    var markers = {};
	    var markerId = 0;
	
	    function formatArrayValue(value) {
	      // ??? TODO refactor these logic.
	      // check: category-no-encode-has-axis-data in dataset.html
	      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
	        var dimItem = data.getDimensionInfo(idx);
	        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
	      }, 0);
	      var result = [];
	      tooltipDims.length ? zrUtil.each(tooltipDims, function (dim) {
	        setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
	      }) // By default, all dims is used on tooltip.
	      : zrUtil.each(value, setEachItem);
	
	      function setEachItem(val, dim) {
	        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
	
	        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
	          return;
	        }
	
	        var dimType = dimInfo.type;
	        var markName = 'sub' + series.seriesIndex + 'at' + markerId;
	        var dimHead = getTooltipMarker({
	          color: color,
	          type: 'subItem',
	          renderMode: renderMode,
	          markerId: markName
	        });
	        var dimHeadStr = typeof dimHead === 'string' ? dimHead : dimHead.content;
	        var valStr = (vertially ? dimHeadStr + encodeHTML(dimInfo.displayName || '-') + ': ' : '') + // FIXME should not format time for raw data?
	        encodeHTML(dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
	        valStr && result.push(valStr);
	
	        if (isRichText) {
	          markers[markName] = color;
	          ++markerId;
	        }
	      }
	
	      var newLine = vertially ? isRichText ? '\n' : '<br/>' : '';
	      var content = newLine + result.join(newLine || ', ');
	      return {
	        renderMode: renderMode,
	        content: content,
	        style: markers
	      };
	    }
	
	    function formatSingleValue(val) {
	      // return encodeHTML(addCommas(val));
	      return {
	        renderMode: renderMode,
	        content: encodeHTML(addCommas(val)),
	        style: markers
	      };
	    }
	
	    var data = this.getData();
	    var tooltipDims = data.mapDimension('defaultedTooltip', true);
	    var tooltipDimLen = tooltipDims.length;
	    var value = this.getRawValue(dataIndex);
	    var isValueArr = zrUtil.isArray(value);
	    var color = data.getItemVisual(dataIndex, 'color');
	
	    if (zrUtil.isObject(color) && color.colorStops) {
	      color = (color.colorStops[0] || {}).color;
	    }
	
	    color = color || 'transparent'; // Complicated rule for pretty tooltip.
	
	    var formattedValue = tooltipDimLen > 1 || isValueArr && !tooltipDimLen ? formatArrayValue(value) : tooltipDimLen ? formatSingleValue(retrieveRawValue(data, dataIndex, tooltipDims[0])) : formatSingleValue(isValueArr ? value[0] : value);
	    var content = formattedValue.content;
	    var markName = series.seriesIndex + 'at' + markerId;
	    var colorEl = getTooltipMarker({
	      color: color,
	      type: 'item',
	      renderMode: renderMode,
	      markerId: markName
	    });
	    markers[markName] = color;
	    ++markerId;
	    var name = data.getName(dataIndex);
	    var seriesName = this.name;
	
	    if (!modelUtil.isNameSpecified(this)) {
	      seriesName = '';
	    }
	
	    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? newLine : ': ') : '';
	    var colorStr = typeof colorEl === 'string' ? colorEl : colorEl.content;
	    var html = !multipleSeries ? seriesName + colorStr + (name ? encodeHTML(name) + ': ' + content : content) : colorStr + seriesName + content;
	    return {
	      html: html,
	      markers: markers
	    };
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var animationEnabled = this.getShallow('animation');
	
	    if (animationEnabled) {
	      if (this.getData().count() > this.getShallow('animationThreshold')) {
	        animationEnabled = false;
	      }
	    }
	
	    return animationEnabled;
	  },
	  restoreData: function () {
	    this.dataTask.dirty();
	  },
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    var ecModel = this.ecModel; // PENDING
	
	    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope, requestColorNum);
	
	    if (!color) {
	      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
	    }
	
	    return color;
	  },
	
	  /**
	   * Use `data.mapDimension(coordDim, true)` instead.
	   * @deprecated
	   */
	  coordDimToDataDim: function (coordDim) {
	    return this.getRawData().mapDimension(coordDim, true);
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressive: function () {
	    return this.get('progressive');
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressiveThreshold: function () {
	    return this.get('progressiveThreshold');
	  },
	
	  /**
	   * Get data indices for show tooltip content. See tooltip.
	   * @abstract
	   * @param {Array.<string>|string} dim
	   * @param {Array.<number>} value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis
	   * @return {Object} {dataIndices, nestestValue}.
	   */
	  getAxisTooltipData: null,
	
	  /**
	   * See tooltip.
	   * @abstract
	   * @param {number} dataIndex
	   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
	   */
	  getTooltipPosition: null,
	
	  /**
	   * @see {module:echarts/stream/Scheduler}
	   */
	  pipeTask: null,
	
	  /**
	   * Convinient for override in extended class.
	   * @protected
	   * @type {Function}
	   */
	  preventIncremental: null,
	
	  /**
	   * @public
	   * @readOnly
	   * @type {Object}
	   */
	  pipelineContext: null
	});
	zrUtil.mixin(SeriesModel, dataFormatMixin);
	zrUtil.mixin(SeriesModel, colorPaletteMixin);
	/**
	 * MUST be called after `prepareSource` called
	 * Here we need to make auto series, especially for auto legend. But we
	 * do not modify series.name in option to avoid side effects.
	 */
	
	function autoSeriesName(seriesModel) {
	  // User specified name has higher priority, otherwise it may cause
	  // series can not be queried unexpectedly.
	  var name = seriesModel.name;
	
	  if (!modelUtil.isNameSpecified(seriesModel)) {
	    seriesModel.name = getSeriesAutoName(seriesModel) || name;
	  }
	}
	
	function getSeriesAutoName(seriesModel) {
	  var data = seriesModel.getRawData();
	  var dataDims = data.mapDimension('seriesName', true);
	  var nameArr = [];
	  zrUtil.each(dataDims, function (dataDim) {
	    var dimInfo = data.getDimensionInfo(dataDim);
	    dimInfo.displayName && nameArr.push(dimInfo.displayName);
	  });
	  return nameArr.join(' ');
	}
	
	function dataTaskCount(context) {
	  return context.model.getRawData().count();
	}
	
	function dataTaskReset(context) {
	  var seriesModel = context.model;
	  seriesModel.setData(seriesModel.getRawData().cloneShallow());
	  return dataTaskProgress;
	}
	
	function dataTaskProgress(param, context) {
	  // Avoid repead cloneShallow when data just created in reset.
	  if (context.outputData && param.end > context.outputData.count()) {
	    context.model.getRawData().cloneShallow(context.outputData);
	  }
	} // TODO refactor
	
	
	function wrapData(data, seriesModel) {
	  zrUtil.each(data.CHANGABLE_METHODS, function (methodName) {
	    data.wrapMethod(methodName, zrUtil.curry(onDataSelfChange, seriesModel));
	  });
	}
	
	function onDataSelfChange(seriesModel) {
	  var task = getCurrentTask(seriesModel);
	
	  if (task) {
	    // Consider case: filter, selectRange
	    task.setOutputEnd(this.count());
	  }
	}
	
	function getCurrentTask(seriesModel) {
	  var scheduler = (seriesModel.ecModel || {}).scheduler;
	  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
	
	  if (pipeline) {
	    // When pipline finished, the currrentTask keep the last
	    // task (renderTask).
	    var task = pipeline.currentTask;
	
	    if (task) {
	      var agentStubMap = task.agentStubMap;
	
	      if (agentStubMap) {
	        task = agentStubMap.get(seriesModel.uid);
	      }
	    }
	
	    return task;
	  }
	}
	
	var _default = SeriesModel;
	module.exports = _default;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Resource = undefined;
	
	var _sgiCommon = __webpack_require__(28);
	
	var sgiCommon = _interopRequireWildcard(_sgiCommon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var prmkey = 'teid'; //显示名称使用方式：1-te, 2-teid
	
	/**
	 * @namespace 资源管理器
	 */
	/*
	 * @Descripttion: 
	 * @version: 
	 * @Author: wangz
	 * @Date: 2019-11-21 14:58:03
	 * @LastEditors: hanzb
	 * @LastEditTime: 2020-04-02 14:24:14
	 */
	/*  资源文件提供者
	 归属：企通前端平台-ECP V5.1
	 版权：2014-2020 企通软件技术有限公司
	 --------------------------------------------------------------------------------
	 作者：王哲                           创建日期：2014/03/13
	 修改：                               修改日期：
	 修改内容
	 --------------------------------------------------------------------------------
	 文本资源 这里向使用者提供根据代码ID，获得数据字典的方法getTR(rpID)
	 图片资源 这里向使用者提供根据代码ID，获得数据字典的方法getIR(rpID)
	 声音资源 这里向使用者提供根据代码ID，获得数据字典的方法getVR(rpID)
	 图像资源 这里向使用者提供根据代码ID，获得数据字典的方法getMR(rpID)
	
	 !!!! 目前采用程序直接量的方式定义各种代码，最终将改为从参数中读取，但对外接口将保持不变
	
	 *******************************************************************************/
	// import { PrmFactory } from '../sgiFactory/PrmFactory';
	var Resource = {
		/**
	  * 对外接口，根据key值取得图标资源对象
	  * @param {type} key
	  * @returns 文本资源对象
	  */
		getIR: function getIR(key) {
			var ir;
			var ap = sgiCommon.getAP(key);
			if (!ap) {
				ir = {};
				ir.c = key;
				return ir;
			}
			//图片资源缓存对象
			var irMap = Resource[ap + "IrMap"];
			if (!irMap) {
				irMap = this.initIR(ap);
			}
			ir = irMap[key];
			if (!ir) {
				ir = {};
				ir.c = key;
				return ir;
			}
			return ir;
		},
		/**
	  * 对外接口，根据key值取得文本资源对象
	  * @param {type} key
	  * @returns 文本资源对象
	  */
		getTR: function getTR(key) {
			var tr;
			var ap = sgiCommon.getAP(key);
			if (!ap) {
				tr = {};
				tr.te = key;
				return tr;
			}
			//文本资源缓存对象
			var trMap = Resource[ap + "TrMap"];
			if (!trMap) {
				trMap = this.initTR(ap);
			}
			tr = trMap[key];
			if (!tr) {
				tr = {};
				tr.te = key;
			}
			return tr;
		},
		/**
	  * 对外接口，根据dm值取得文本资源对象
	  * @param {type} dm
	  * @returns 文本资源对象
	  */
		getTRByPrm: function getTRByPrm(dm) {
	
			//暂时不取资源文件
			if (!window.sgiConfig || !window.sgiConfig.openTResource) {
				return dm;
			}
	
			if (!dm.te && !dm.teid) {
				return { te: undefined };
			}
	
			var tr;
			var key = dm[prmkey];
	
			if (prmkey === "te") {
				//直接返回
				tr = {};
				tr.te = key;
			} else if (prmkey === "teid") {
				//根据id查询返回
				var ap = tool.Global.currentAP || "SD";
	
				var trMap = Resource[ap + "TrMap"];
				if (!trMap) {
					trMap = this.initTR(ap);
				}
				tr = trMap[key];
				if (!tr) {
					tr = {};
					tr.te = dm.te;
				}
			}
			return tr;
		},
		/**
	  * 对外接口，根据key值取得CSS资源对象
	  * @param {type} key
	  * @returns 文本资源对象
	  */
		getCR: function getCR(key) {
			var cr;
			var ap = sgiCommon.getAP(key);
			if (!ap) {
				cr = {};
				cr.te = key;
				return cr;
			}
			//文本资源缓存对象
			var crMap = Resource[ap + "CrMap"];
			if (!crMap) {
				crMap = this.initCR(ap);
			}
			cr = crMap[key];
			if (!cr) {
				cr = {};
				cr.te = key;
			}
			return cr;
		},
		/**
	  * 对外接口，根据key值取得字体图标资源对象
	  * @param {type} key
	  * @returns 文本资源对象
	  */
		getFR: function getFR(key) {
			var ir;
			var ap = sgiCommon.getAP(key);
			if (!ap) {
				ir = {};
				ir.c = key;
				return ir;
			}
			//图片资源缓存对象
			var frMap = Resource[ap + "FrMap"];
			if (!frMap) {
				frMap = this.initFR(ap);
			}
			fr = frMap[key];
			if (!fr) {
				fr = {};
				fr.c = key;
				return fr;
			}
			return fr;
		},
		/**
	  * 加载文本资源文件缓存对象
	  * @param {type} ap
	  * @param {type} trMap
	  * @returns {undefined}
	  */
		initTR: function initTR(ap) {
	
			//如果ap未设定值时从SD中取值
			ap = ap || "SD";
			var tt = "RP";
			var ss = "TR";
	
			var trMap = {};
			Resource[ap + "TrMap"] = trMap;
			/** 以下的结构划分没有用了 */
			//划分结构为1、普通文本，文本下以A-Z中问首字母拼音为区分，Axxx xxx为编号
			//         2、特殊文本，某特定控件或者业务描述所需一组资源。AAZZ AA为特殊文本含义缩写  ZZ为编号
	
			//换用新的资源表
			var rList = PrmFactory.getResourceList(ap, tt, ss);
			rList.forEach(function (record) {
				trMap[record.sc] = record;
			});
			// var guid = ap + "_RP_TR_0001";
			// var rpTreeJson = PrmFactory.getPrm(guid);
			// var rpArray = sgiCommon.getLeafByPrm(rpTreeJson);
			// rpArray.forEach(record => {
			//     trMap[guid + "`" + record.sc]= record;
			// });
			return trMap;
		},
	
		/**
	  * 加载文本资源文件缓存对象
	  * @param {type} ap
	  * @param {type} trMap
	  * @returns {undefined}
	  */
		initFR: function initFR(ap) {
			var frMap = {};
			Resource[ap + "FrMap"] = frMap;
	
			var guid = ap + "_RP_FR_0001";
			var rpTreeJson = PrmFactory.getPrm(guid);
			var rpArray = sgiCommon.getLeafByPrm(rpTreeJson);
			rpArray.forEach(function (record) {
				frMap[guid + "`" + record.sc] = record;
			});
			return frMap;
		},
		/**
	  * 加载图片资源文件缓存对象
	  * @param {type} ap
	  * @param {type} irMap
	  * @returns {undefined}
	  */
		initIR: function initIR(ap) {
			var irMap = {};
			Resource[ap + "IrMap"] = irMap;
			//划分结构为以类别化为  XXnn XX:类别缩写  nn:编号
			// 视图类UInn
			//如果ap未设定值时从SD中取值
			var guid = ap + "_RP_IR_0001";
			var rpTreeJson = PrmFactory.getPrm(guid);
			var rpArray = sgiCommon.getLeafByPrm(rpTreeJson);
			rpArray.forEach(function (record) {
				if (record.c && record.c.indexOf("resources") >= 0) {
					//record.c = record.c;
				} else if (record.c && record.c.indexOf("http:") >= 0) {
					//record.c = record.c;
				} else if (record.c && record.c.indexOf("https:") >= 0) {
					//record.c = record.c;
				} else if (record.c && record.c.indexOf("base64") >= 0) {
					//record.c = record.c;
				} else {
					var iconPath = "resources/images/";
					record.c = iconPath + record.c;
				}
				irMap[guid + "`" + record.sc] = record;
			});
			return irMap;
		},
		/**
	  * 加载CSS资源文件缓存对象
	  * @param {type} ap
	  * @param {type} irMap
	  * @returns {undefined}
	  */
		initCR: function initCR(ap) {
			var crMap = {};
			Resource[ap + "CrMap"] = crMap;
			//划分结构为以类别化为  XXnn XX:类别缩写  nn:编号
			// 视图类UInn
			//如果ap未设定值时从SD中取值
			var guid = ap + "_RP_CR_0001";
			var rpTreeJson = PrmFactory.getPrm(guid);
			var rpArray = sgiCommon.getLeafByPrm(rpTreeJson);
			rpArray.forEach(function (record) {
				crMap[guid + "`" + record.sc] = record;
			});
			return crMap;
		}
	
		// 初始化
	};if (!window.Resource) window.Resource = Resource;
	// 添加方法
	else Object.assign(window.Resource, Resource);
	// 导出
	var wResource = window.Resource;
	exports.Resource = wResource;
	exports.default = wResource;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(40);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ObjFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _sgiLogger = __webpack_require__(39);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// import ObjectManager from './ObjectManager'
	/*     对象工厂
	 --------------------------------------------------------------------------------
	 作者：王哲                           创建日期：2018/03/12
	 --------------------------------------------------------------------------------
	 提供方法列表：
	 ★对象保存
	 ★对象读取
	 ★根据参数guid创建对象  
	 ★对象删除
	 --------------------------------------------------------------------------------
	 修改：                               修改日期：
	 修改内容: 
	
	 --------------------------------------------------------------------------------
	 
	 *******************************************************************************/
	var ObjFactory = function () {
	
		// objFct = null;
		// _pObjFct = null;
	
		function ObjFactory(uid, transferData, _pObjFct) {
			_classCallCheck(this, ObjFactory);
	
			this.objFct = {};
			this._pObjFct = null;
	
			if (uid) this.objFct['@currentObjFctUID'] = uid;
			if (transferData) {
				for (var key in transferData) {
					this.objFct[key] = transferData[key];
				}
			}
			if (_pObjFct) this._pObjFct = _pObjFct;
			// ObjectManager.add(uid, this.objFct);
		}
	
		_createClass(ObjFactory, [{
			key: 'setUID',
			value: function setUID(uid) {
				if (uid) {
					this.objFct['@currentObjFctUID'] = uid;
				}
			}
		}, {
			key: 'getUID',
			value: function getUID() {
				var uid = this.objFct['@currentObjFctUID'];
				return uid;
			}
		}, {
			key: 'setParent',
			value: function setParent(_pObjFct) {
				if (_pObjFct) this._pObjFct = _pObjFct;
			}
		}, {
			key: 'getParent',
			value: function getParent() {
				return this._pObjFct;
			}
		}, {
			key: 'getAP',
			value: function getAP() {
				var uid = this.getUID();
				if (!uid) return null;
				var ap = uid.split("_")[0];
				return ap;
			}
			/**
	   * 将对象保存到对象工厂中
	   * @param {type} pObj
	   * @param {type} pInstanceName
	   * @returns {undefined}
	   */
	
		}, {
			key: 'set',
			value: function set(pInstanceName, pObj) {
				if (!pInstanceName) return;
				if (RegExp(/[.|\[|\]]+/).test(pInstanceName)) {
					// 带层级写入，避免为空报错
					try {
						eval('(this.objFct.' + pInstanceName + ' = pObj)');
					} catch (error) {
						_sgiLogger.sgiLogger.eventErr(error);
					}
				} else {
					this.objFct[pInstanceName] = pObj;
				}
			}
			/**
	   * 取得对象工厂中缓存的对象
	   * @param {type} pInstanceName
	   * @returns {unresolved}
	   */
	
		}, {
			key: 'get',
			value: function get(pInstanceName) {
				if (!pInstanceName) return null;
				if (RegExp(/[.|\[|\]]+/).test(pInstanceName)) {
					// 带层级读取，避免为空报错
					var obj = void 0;
					try {
						obj = eval('(this.objFct.' + pInstanceName + ')');
					} catch (error) {
						_sgiLogger.sgiLogger.eventErr(error);
					}
					return obj;
				} else {
					return this.objFct[pInstanceName];
				}
			}
			/**
	   * 删除对象工厂中的对象
	   * @param {type} pInstanceName
	   * @returns {undefined}
	   */
	
		}, {
			key: 'remove',
			value: function remove(pInstanceName) {
				delete this.objFct[pInstanceName];
			}
		}, {
			key: 'clear',
			value: function clear(sonItems) {
				var clearObj = void 0;
				if (sonItems) {
					clearObj = sonItems;
				} else {
					clearObj = this.objFct;
				}
				for (var key in clearObj) {
					// const element = clearObj[key];
					delete clearObj[key];
				}
				clearObj = undefined;
			}
		}]);
	
		return ObjFactory;
	}();
	
	;
	
	exports.ObjFactory = ObjFactory;
	exports.default = ObjFactory;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(229), __webpack_require__(149));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(229), __webpack_require__(149)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var MD5 = C_algo.MD5;
	
			/**
	   * This key derivation function is meant to conform with EVP_BytesToKey.
	   * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	   */
			var EvpKDF = C_algo.EvpKDF = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	    * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	    * @property {number} iterations The number of iterations to perform. Default: 1
	    */
				cfg: Base.extend({
					keySize: 128 / 32,
					hasher: MD5,
					iterations: 1
				}),
	
				/**
	    * Initializes a newly created key derivation function.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	    *
	    * @example
	    *
	    *     var kdf = CryptoJS.algo.EvpKDF.create();
	    *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	    *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	    */
				init: function init(cfg) {
					this.cfg = this.cfg.extend(cfg);
				},
	
				/**
	    * Derives a key from a password.
	    *
	    * @param {WordArray|string} password The password.
	    * @param {WordArray|string} salt A salt.
	    *
	    * @return {WordArray} The derived key.
	    *
	    * @example
	    *
	    *     var key = kdf.compute(password, salt);
	    */
				compute: function compute(password, salt) {
					var block;
	
					// Shortcut
					var cfg = this.cfg;
	
					// Init hasher
					var hasher = cfg.hasher.create();
	
					// Initial values
					var derivedKey = WordArray.create();
	
					// Shortcuts
					var derivedKeyWords = derivedKey.words;
					var keySize = cfg.keySize;
					var iterations = cfg.iterations;
	
					// Generate key
					while (derivedKeyWords.length < keySize) {
						if (block) {
							hasher.update(block);
						}
						block = hasher.update(password).finalize(salt);
						hasher.reset();
	
						// Iterations
						for (var i = 1; i < iterations; i++) {
							block = hasher.finalize(block);
							hasher.reset();
						}
	
						derivedKey.concat(block);
					}
					derivedKey.sigBytes = keySize * 4;
	
					return derivedKey;
				}
			});
	
			/**
	   * Derives a key from a password.
	   *
	   * @param {WordArray|string} password The password.
	   * @param {WordArray|string} salt A salt.
	   * @param {Object} cfg (Optional) The configuration options to use for this computation.
	   *
	   * @return {WordArray} The derived key.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var key = CryptoJS.EvpKDF(password, salt);
	   *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	   *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	   */
			C.EvpKDF = function (password, salt, cfg) {
				return EvpKDF.create(cfg).compute(password, salt);
			};
		})();
	
		return CryptoJS.EvpKDF;
	});

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(236), __webpack_require__(153));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(236), __webpack_require__(153)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var MD5 = C_algo.MD5;
	
			/**
	   * This key derivation function is meant to conform with EVP_BytesToKey.
	   * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	   */
			var EvpKDF = C_algo.EvpKDF = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	    * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	    * @property {number} iterations The number of iterations to perform. Default: 1
	    */
				cfg: Base.extend({
					keySize: 128 / 32,
					hasher: MD5,
					iterations: 1
				}),
	
				/**
	    * Initializes a newly created key derivation function.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	    *
	    * @example
	    *
	    *     var kdf = CryptoJS.algo.EvpKDF.create();
	    *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	    *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	    */
				init: function init(cfg) {
					this.cfg = this.cfg.extend(cfg);
				},
	
				/**
	    * Derives a key from a password.
	    *
	    * @param {WordArray|string} password The password.
	    * @param {WordArray|string} salt A salt.
	    *
	    * @return {WordArray} The derived key.
	    *
	    * @example
	    *
	    *     var key = kdf.compute(password, salt);
	    */
				compute: function compute(password, salt) {
					var block;
	
					// Shortcut
					var cfg = this.cfg;
	
					// Init hasher
					var hasher = cfg.hasher.create();
	
					// Initial values
					var derivedKey = WordArray.create();
	
					// Shortcuts
					var derivedKeyWords = derivedKey.words;
					var keySize = cfg.keySize;
					var iterations = cfg.iterations;
	
					// Generate key
					while (derivedKeyWords.length < keySize) {
						if (block) {
							hasher.update(block);
						}
						block = hasher.update(password).finalize(salt);
						hasher.reset();
	
						// Iterations
						for (var i = 1; i < iterations; i++) {
							block = hasher.finalize(block);
							hasher.reset();
						}
	
						derivedKey.concat(block);
					}
					derivedKey.sigBytes = keySize * 4;
	
					return derivedKey;
				}
			});
	
			/**
	   * Derives a key from a password.
	   *
	   * @param {WordArray|string} password The password.
	   * @param {WordArray|string} salt A salt.
	   * @param {Object} cfg (Optional) The configuration options to use for this computation.
	   *
	   * @return {WordArray} The derived key.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var key = CryptoJS.EvpKDF(password, salt);
	   *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	   *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	   */
			C.EvpKDF = function (password, salt, cfg) {
				return EvpKDF.create(cfg).compute(password, salt);
			};
		})();
	
		return CryptoJS.EvpKDF;
	});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _default = _interopRequireDefault(__webpack_require__(1062));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var LocaleReceiver = /*#__PURE__*/function (_React$Component) {
	  _inherits(LocaleReceiver, _React$Component);
	
	  var _super = _createSuper(LocaleReceiver);
	
	  function LocaleReceiver() {
	    _classCallCheck(this, LocaleReceiver);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(LocaleReceiver, [{
	    key: "getLocale",
	    value: function getLocale() {
	      var _this$props = this.props,
	          componentName = _this$props.componentName,
	          defaultLocale = _this$props.defaultLocale;
	      var locale = defaultLocale || _default["default"][componentName || 'global'];
	      var antLocale = this.context.antLocale;
	      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
	      return _extends(_extends({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
	    }
	  }, {
	    key: "getLocaleCode",
	    value: function getLocaleCode() {
	      var antLocale = this.context.antLocale;
	      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale
	
	      if (antLocale && antLocale.exist && !localeCode) {
	        return _default["default"].locale;
	      }
	
	      return localeCode;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context.antLocale);
	    }
	  }]);
	
	  return LocaleReceiver;
	}(React.Component);
	
	exports["default"] = LocaleReceiver;
	LocaleReceiver.defaultProps = {
	  componentName: 'global'
	};
	LocaleReceiver.contextTypes = {
	  antLocale: PropTypes.object
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _default = _interopRequireDefault(__webpack_require__(1220));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var LocaleReceiver = /*#__PURE__*/function (_React$Component) {
	  _inherits(LocaleReceiver, _React$Component);
	
	  var _super = _createSuper(LocaleReceiver);
	
	  function LocaleReceiver() {
	    _classCallCheck(this, LocaleReceiver);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(LocaleReceiver, [{
	    key: "getLocale",
	    value: function getLocale() {
	      var _this$props = this.props,
	          componentName = _this$props.componentName,
	          defaultLocale = _this$props.defaultLocale;
	      var locale = defaultLocale || _default["default"][componentName || 'global'];
	      var antLocale = this.context.antLocale;
	      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
	      return _extends(_extends({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
	    }
	  }, {
	    key: "getLocaleCode",
	    value: function getLocaleCode() {
	      var antLocale = this.context.antLocale;
	      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale
	
	      if (antLocale && antLocale.exist && !localeCode) {
	        return _default["default"].locale;
	      }
	
	      return localeCode;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context.antLocale);
	    }
	  }]);
	
	  return LocaleReceiver;
	}(React.Component);
	
	exports["default"] = LocaleReceiver;
	LocaleReceiver.defaultProps = {
	  componentName: 'global'
	};
	LocaleReceiver.contextTypes = {
	  antLocale: PropTypes.object
	};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _default = _interopRequireDefault(__webpack_require__(1410));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var LocaleReceiver = /*#__PURE__*/function (_React$Component) {
	  _inherits(LocaleReceiver, _React$Component);
	
	  var _super = _createSuper(LocaleReceiver);
	
	  function LocaleReceiver() {
	    _classCallCheck(this, LocaleReceiver);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(LocaleReceiver, [{
	    key: "getLocale",
	    value: function getLocale() {
	      var _this$props = this.props,
	          componentName = _this$props.componentName,
	          defaultLocale = _this$props.defaultLocale;
	      var locale = defaultLocale || _default["default"][componentName || 'global'];
	      var antLocale = this.context.antLocale;
	      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
	      return _extends(_extends({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
	    }
	  }, {
	    key: "getLocaleCode",
	    value: function getLocaleCode() {
	      var antLocale = this.context.antLocale;
	      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale
	
	      if (antLocale && antLocale.exist && !localeCode) {
	        return _default["default"].locale;
	      }
	
	      return localeCode;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context.antLocale);
	    }
	  }]);
	
	  return LocaleReceiver;
	}(React.Component);
	
	exports["default"] = LocaleReceiver;
	LocaleReceiver.defaultProps = {
	  componentName: 'global'
	};
	LocaleReceiver.contextTypes = {
	  antLocale: PropTypes.object
	};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * 3x2矩阵操作类
	 * @exports zrender/tool/matrix
	 */
	
	/* global Float32Array */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * Create a identity matrix.
	 * @return {Float32Array|Array.<number>}
	 */
	
	function create() {
	  var out = new ArrayCtor(6);
	  identity(out);
	  return out;
	}
	/**
	 * 设置矩阵为单位矩阵
	 * @param {Float32Array|Array.<number>} out
	 */
	
	
	function identity(out) {
	  out[0] = 1;
	  out[1] = 0;
	  out[2] = 0;
	  out[3] = 1;
	  out[4] = 0;
	  out[5] = 0;
	  return out;
	}
	/**
	 * 复制矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m
	 */
	
	
	function copy(out, m) {
	  out[0] = m[0];
	  out[1] = m[1];
	  out[2] = m[2];
	  out[3] = m[3];
	  out[4] = m[4];
	  out[5] = m[5];
	  return out;
	}
	/**
	 * 矩阵相乘
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m1
	 * @param {Float32Array|Array.<number>} m2
	 */
	
	
	function mul(out, m1, m2) {
	  // Consider matrix.mul(m, m2, m);
	  // where out is the same as m2.
	  // So use temp variable to escape error.
	  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
	  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
	  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
	  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
	  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
	  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
	  out[0] = out0;
	  out[1] = out1;
	  out[2] = out2;
	  out[3] = out3;
	  out[4] = out4;
	  out[5] = out5;
	  return out;
	}
	/**
	 * 平移变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function translate(out, a, v) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  out[4] = a[4] + v[0];
	  out[5] = a[5] + v[1];
	  return out;
	}
	/**
	 * 旋转变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {number} rad
	 */
	
	
	function rotate(out, a, rad) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var st = Math.sin(rad);
	  var ct = Math.cos(rad);
	  out[0] = aa * ct + ab * st;
	  out[1] = -aa * st + ab * ct;
	  out[2] = ac * ct + ad * st;
	  out[3] = -ac * st + ct * ad;
	  out[4] = ct * atx + st * aty;
	  out[5] = ct * aty - st * atx;
	  return out;
	}
	/**
	 * 缩放变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function scale(out, a, v) {
	  var vx = v[0];
	  var vy = v[1];
	  out[0] = a[0] * vx;
	  out[1] = a[1] * vy;
	  out[2] = a[2] * vx;
	  out[3] = a[3] * vy;
	  out[4] = a[4] * vx;
	  out[5] = a[5] * vy;
	  return out;
	}
	/**
	 * 求逆矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function invert(out, a) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var det = aa * ad - ab * ac;
	
	  if (!det) {
	    return null;
	  }
	
	  det = 1.0 / det;
	  out[0] = ad * det;
	  out[1] = -ab * det;
	  out[2] = -ac * det;
	  out[3] = aa * det;
	  out[4] = (ac * aty - ad * atx) * det;
	  out[5] = (ab * atx - aa * aty) * det;
	  return out;
	}
	/**
	 * Clone a new matrix.
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function clone(a) {
	  var b = create();
	  copy(b, a);
	  return b;
	}
	
	exports.create = create;
	exports.identity = identity;
	exports.copy = copy;
	exports.mul = mul;
	exports.translate = translate;
	exports.rotate = rotate;
	exports.scale = scale;
	exports.invert = invert;
	exports.clone = clone;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * Base64 encoding strategy.
	   */
			var Base64 = C_enc.Base64 = {
				/**
	    * Converts a word array to a Base64 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The Base64 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
					var map = this._map;
	
					// Clamp excess bits
					wordArray.clamp();
	
					// Convert
					var base64Chars = [];
					for (var i = 0; i < sigBytes; i += 3) {
						var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
						var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
	
						var triplet = byte1 << 16 | byte2 << 8 | byte3;
	
						for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
							base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
						}
					}
	
					// Add padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						while (base64Chars.length % 4) {
							base64Chars.push(paddingChar);
						}
					}
	
					return base64Chars.join('');
				},
	
				/**
	    * Converts a Base64 string to a word array.
	    *
	    * @param {string} base64Str The Base64 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	    */
				parse: function parse(base64Str) {
					// Shortcuts
					var base64StrLength = base64Str.length;
					var map = this._map;
					var reverseMap = this._reverseMap;
	
					if (!reverseMap) {
						reverseMap = this._reverseMap = [];
						for (var j = 0; j < map.length; j++) {
							reverseMap[map.charCodeAt(j)] = j;
						}
					}
	
					// Ignore padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						var paddingIndex = base64Str.indexOf(paddingChar);
						if (paddingIndex !== -1) {
							base64StrLength = paddingIndex;
						}
					}
	
					// Convert
					return parseLoop(base64Str, base64StrLength, reverseMap);
				},
	
				_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
			};
	
			function parseLoop(base64Str, base64StrLength, reverseMap) {
				var words = [];
				var nBytes = 0;
				for (var i = 0; i < base64StrLength; i++) {
					if (i % 4) {
						var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
						var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
						var bitsCombined = bits1 | bits2;
						words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
						nBytes++;
					}
				}
				return WordArray.create(words, nBytes);
			}
		})();
	
		return CryptoJS.enc.Base64;
	});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Constants table
			var T = [];
	
			// Compute constants
			(function () {
				for (var i = 0; i < 64; i++) {
					T[i] = Math.abs(Math.sin(i + 1)) * 0x100000000 | 0;
				}
			})();
	
			/**
	   * MD5 hash algorithm.
	   */
			var MD5 = C_algo.MD5 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Swap endian
					for (var i = 0; i < 16; i++) {
						// Shortcuts
						var offset_i = offset + i;
						var M_offset_i = M[offset_i];
	
						M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
					}
	
					// Shortcuts
					var H = this._hash.words;
	
					var M_offset_0 = M[offset + 0];
					var M_offset_1 = M[offset + 1];
					var M_offset_2 = M[offset + 2];
					var M_offset_3 = M[offset + 3];
					var M_offset_4 = M[offset + 4];
					var M_offset_5 = M[offset + 5];
					var M_offset_6 = M[offset + 6];
					var M_offset_7 = M[offset + 7];
					var M_offset_8 = M[offset + 8];
					var M_offset_9 = M[offset + 9];
					var M_offset_10 = M[offset + 10];
					var M_offset_11 = M[offset + 11];
					var M_offset_12 = M[offset + 12];
					var M_offset_13 = M[offset + 13];
					var M_offset_14 = M[offset + 14];
					var M_offset_15 = M[offset + 15];
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
	
					// Computation
					a = FF(a, b, c, d, M_offset_0, 7, T[0]);
					d = FF(d, a, b, c, M_offset_1, 12, T[1]);
					c = FF(c, d, a, b, M_offset_2, 17, T[2]);
					b = FF(b, c, d, a, M_offset_3, 22, T[3]);
					a = FF(a, b, c, d, M_offset_4, 7, T[4]);
					d = FF(d, a, b, c, M_offset_5, 12, T[5]);
					c = FF(c, d, a, b, M_offset_6, 17, T[6]);
					b = FF(b, c, d, a, M_offset_7, 22, T[7]);
					a = FF(a, b, c, d, M_offset_8, 7, T[8]);
					d = FF(d, a, b, c, M_offset_9, 12, T[9]);
					c = FF(c, d, a, b, M_offset_10, 17, T[10]);
					b = FF(b, c, d, a, M_offset_11, 22, T[11]);
					a = FF(a, b, c, d, M_offset_12, 7, T[12]);
					d = FF(d, a, b, c, M_offset_13, 12, T[13]);
					c = FF(c, d, a, b, M_offset_14, 17, T[14]);
					b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
					a = GG(a, b, c, d, M_offset_1, 5, T[16]);
					d = GG(d, a, b, c, M_offset_6, 9, T[17]);
					c = GG(c, d, a, b, M_offset_11, 14, T[18]);
					b = GG(b, c, d, a, M_offset_0, 20, T[19]);
					a = GG(a, b, c, d, M_offset_5, 5, T[20]);
					d = GG(d, a, b, c, M_offset_10, 9, T[21]);
					c = GG(c, d, a, b, M_offset_15, 14, T[22]);
					b = GG(b, c, d, a, M_offset_4, 20, T[23]);
					a = GG(a, b, c, d, M_offset_9, 5, T[24]);
					d = GG(d, a, b, c, M_offset_14, 9, T[25]);
					c = GG(c, d, a, b, M_offset_3, 14, T[26]);
					b = GG(b, c, d, a, M_offset_8, 20, T[27]);
					a = GG(a, b, c, d, M_offset_13, 5, T[28]);
					d = GG(d, a, b, c, M_offset_2, 9, T[29]);
					c = GG(c, d, a, b, M_offset_7, 14, T[30]);
					b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
					a = HH(a, b, c, d, M_offset_5, 4, T[32]);
					d = HH(d, a, b, c, M_offset_8, 11, T[33]);
					c = HH(c, d, a, b, M_offset_11, 16, T[34]);
					b = HH(b, c, d, a, M_offset_14, 23, T[35]);
					a = HH(a, b, c, d, M_offset_1, 4, T[36]);
					d = HH(d, a, b, c, M_offset_4, 11, T[37]);
					c = HH(c, d, a, b, M_offset_7, 16, T[38]);
					b = HH(b, c, d, a, M_offset_10, 23, T[39]);
					a = HH(a, b, c, d, M_offset_13, 4, T[40]);
					d = HH(d, a, b, c, M_offset_0, 11, T[41]);
					c = HH(c, d, a, b, M_offset_3, 16, T[42]);
					b = HH(b, c, d, a, M_offset_6, 23, T[43]);
					a = HH(a, b, c, d, M_offset_9, 4, T[44]);
					d = HH(d, a, b, c, M_offset_12, 11, T[45]);
					c = HH(c, d, a, b, M_offset_15, 16, T[46]);
					b = HH(b, c, d, a, M_offset_2, 23, T[47]);
	
					a = II(a, b, c, d, M_offset_0, 6, T[48]);
					d = II(d, a, b, c, M_offset_7, 10, T[49]);
					c = II(c, d, a, b, M_offset_14, 15, T[50]);
					b = II(b, c, d, a, M_offset_5, 21, T[51]);
					a = II(a, b, c, d, M_offset_12, 6, T[52]);
					d = II(d, a, b, c, M_offset_3, 10, T[53]);
					c = II(c, d, a, b, M_offset_10, 15, T[54]);
					b = II(b, c, d, a, M_offset_1, 21, T[55]);
					a = II(a, b, c, d, M_offset_8, 6, T[56]);
					d = II(d, a, b, c, M_offset_15, 10, T[57]);
					c = II(c, d, a, b, M_offset_6, 15, T[58]);
					b = II(b, c, d, a, M_offset_13, 21, T[59]);
					a = II(a, b, c, d, M_offset_4, 6, T[60]);
					d = II(d, a, b, c, M_offset_11, 10, T[61]);
					c = II(c, d, a, b, M_offset_2, 15, T[62]);
					b = II(b, c, d, a, M_offset_9, 21, T[63]);
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
	
					var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
					var nBitsTotalL = nBitsTotal;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
	
					data.sigBytes = (dataWords.length + 1) * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var hash = this._hash;
					var H = hash.words;
	
					// Swap endian
					for (var i = 0; i < 4; i++) {
						// Shortcut
						var H_i = H[i];
	
						H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
					}
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			function FF(a, b, c, d, x, s, t) {
				var n = a + (b & c | ~b & d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function GG(a, b, c, d, x, s, t) {
				var n = a + (b & d | c & ~d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function HH(a, b, c, d, x, s, t) {
				var n = a + (b ^ c ^ d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function II(a, b, c, d, x, s, t) {
				var n = a + (c ^ (b | ~d)) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.MD5('message');
	   *     var hash = CryptoJS.MD5(wordArray);
	   */
			C.MD5 = Hasher._createHelper(MD5);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacMD5(message, key);
	   */
			C.HmacMD5 = Hasher._createHmacHelper(MD5);
		})(Math);
	
		return CryptoJS.MD5;
	});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tupleNum = exports.tuple = void 0;
	
	// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
	var tuple = function tuple() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args;
	};
	
	exports.tuple = tuple;
	
	var tupleNum = function tupleNum() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return args;
	};
	
	exports.tupleNum = tupleNum;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * Base64 encoding strategy.
	   */
			var Base64 = C_enc.Base64 = {
				/**
	    * Converts a word array to a Base64 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The Base64 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
					var map = this._map;
	
					// Clamp excess bits
					wordArray.clamp();
	
					// Convert
					var base64Chars = [];
					for (var i = 0; i < sigBytes; i += 3) {
						var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
						var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
	
						var triplet = byte1 << 16 | byte2 << 8 | byte3;
	
						for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
							base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
						}
					}
	
					// Add padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						while (base64Chars.length % 4) {
							base64Chars.push(paddingChar);
						}
					}
	
					return base64Chars.join('');
				},
	
				/**
	    * Converts a Base64 string to a word array.
	    *
	    * @param {string} base64Str The Base64 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	    */
				parse: function parse(base64Str) {
					// Shortcuts
					var base64StrLength = base64Str.length;
					var map = this._map;
					var reverseMap = this._reverseMap;
	
					if (!reverseMap) {
						reverseMap = this._reverseMap = [];
						for (var j = 0; j < map.length; j++) {
							reverseMap[map.charCodeAt(j)] = j;
						}
					}
	
					// Ignore padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						var paddingIndex = base64Str.indexOf(paddingChar);
						if (paddingIndex !== -1) {
							base64StrLength = paddingIndex;
						}
					}
	
					// Convert
					return parseLoop(base64Str, base64StrLength, reverseMap);
				},
	
				_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
			};
	
			function parseLoop(base64Str, base64StrLength, reverseMap) {
				var words = [];
				var nBytes = 0;
				for (var i = 0; i < base64StrLength; i++) {
					if (i % 4) {
						var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
						var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
						var bitsCombined = bits1 | bits2;
						words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
						nBytes++;
					}
				}
				return WordArray.create(words, nBytes);
			}
		})();
	
		return CryptoJS.enc.Base64;
	});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Constants table
			var T = [];
	
			// Compute constants
			(function () {
				for (var i = 0; i < 64; i++) {
					T[i] = Math.abs(Math.sin(i + 1)) * 0x100000000 | 0;
				}
			})();
	
			/**
	   * MD5 hash algorithm.
	   */
			var MD5 = C_algo.MD5 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Swap endian
					for (var i = 0; i < 16; i++) {
						// Shortcuts
						var offset_i = offset + i;
						var M_offset_i = M[offset_i];
	
						M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
					}
	
					// Shortcuts
					var H = this._hash.words;
	
					var M_offset_0 = M[offset + 0];
					var M_offset_1 = M[offset + 1];
					var M_offset_2 = M[offset + 2];
					var M_offset_3 = M[offset + 3];
					var M_offset_4 = M[offset + 4];
					var M_offset_5 = M[offset + 5];
					var M_offset_6 = M[offset + 6];
					var M_offset_7 = M[offset + 7];
					var M_offset_8 = M[offset + 8];
					var M_offset_9 = M[offset + 9];
					var M_offset_10 = M[offset + 10];
					var M_offset_11 = M[offset + 11];
					var M_offset_12 = M[offset + 12];
					var M_offset_13 = M[offset + 13];
					var M_offset_14 = M[offset + 14];
					var M_offset_15 = M[offset + 15];
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
	
					// Computation
					a = FF(a, b, c, d, M_offset_0, 7, T[0]);
					d = FF(d, a, b, c, M_offset_1, 12, T[1]);
					c = FF(c, d, a, b, M_offset_2, 17, T[2]);
					b = FF(b, c, d, a, M_offset_3, 22, T[3]);
					a = FF(a, b, c, d, M_offset_4, 7, T[4]);
					d = FF(d, a, b, c, M_offset_5, 12, T[5]);
					c = FF(c, d, a, b, M_offset_6, 17, T[6]);
					b = FF(b, c, d, a, M_offset_7, 22, T[7]);
					a = FF(a, b, c, d, M_offset_8, 7, T[8]);
					d = FF(d, a, b, c, M_offset_9, 12, T[9]);
					c = FF(c, d, a, b, M_offset_10, 17, T[10]);
					b = FF(b, c, d, a, M_offset_11, 22, T[11]);
					a = FF(a, b, c, d, M_offset_12, 7, T[12]);
					d = FF(d, a, b, c, M_offset_13, 12, T[13]);
					c = FF(c, d, a, b, M_offset_14, 17, T[14]);
					b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
					a = GG(a, b, c, d, M_offset_1, 5, T[16]);
					d = GG(d, a, b, c, M_offset_6, 9, T[17]);
					c = GG(c, d, a, b, M_offset_11, 14, T[18]);
					b = GG(b, c, d, a, M_offset_0, 20, T[19]);
					a = GG(a, b, c, d, M_offset_5, 5, T[20]);
					d = GG(d, a, b, c, M_offset_10, 9, T[21]);
					c = GG(c, d, a, b, M_offset_15, 14, T[22]);
					b = GG(b, c, d, a, M_offset_4, 20, T[23]);
					a = GG(a, b, c, d, M_offset_9, 5, T[24]);
					d = GG(d, a, b, c, M_offset_14, 9, T[25]);
					c = GG(c, d, a, b, M_offset_3, 14, T[26]);
					b = GG(b, c, d, a, M_offset_8, 20, T[27]);
					a = GG(a, b, c, d, M_offset_13, 5, T[28]);
					d = GG(d, a, b, c, M_offset_2, 9, T[29]);
					c = GG(c, d, a, b, M_offset_7, 14, T[30]);
					b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
					a = HH(a, b, c, d, M_offset_5, 4, T[32]);
					d = HH(d, a, b, c, M_offset_8, 11, T[33]);
					c = HH(c, d, a, b, M_offset_11, 16, T[34]);
					b = HH(b, c, d, a, M_offset_14, 23, T[35]);
					a = HH(a, b, c, d, M_offset_1, 4, T[36]);
					d = HH(d, a, b, c, M_offset_4, 11, T[37]);
					c = HH(c, d, a, b, M_offset_7, 16, T[38]);
					b = HH(b, c, d, a, M_offset_10, 23, T[39]);
					a = HH(a, b, c, d, M_offset_13, 4, T[40]);
					d = HH(d, a, b, c, M_offset_0, 11, T[41]);
					c = HH(c, d, a, b, M_offset_3, 16, T[42]);
					b = HH(b, c, d, a, M_offset_6, 23, T[43]);
					a = HH(a, b, c, d, M_offset_9, 4, T[44]);
					d = HH(d, a, b, c, M_offset_12, 11, T[45]);
					c = HH(c, d, a, b, M_offset_15, 16, T[46]);
					b = HH(b, c, d, a, M_offset_2, 23, T[47]);
	
					a = II(a, b, c, d, M_offset_0, 6, T[48]);
					d = II(d, a, b, c, M_offset_7, 10, T[49]);
					c = II(c, d, a, b, M_offset_14, 15, T[50]);
					b = II(b, c, d, a, M_offset_5, 21, T[51]);
					a = II(a, b, c, d, M_offset_12, 6, T[52]);
					d = II(d, a, b, c, M_offset_3, 10, T[53]);
					c = II(c, d, a, b, M_offset_10, 15, T[54]);
					b = II(b, c, d, a, M_offset_1, 21, T[55]);
					a = II(a, b, c, d, M_offset_8, 6, T[56]);
					d = II(d, a, b, c, M_offset_15, 10, T[57]);
					c = II(c, d, a, b, M_offset_6, 15, T[58]);
					b = II(b, c, d, a, M_offset_13, 21, T[59]);
					a = II(a, b, c, d, M_offset_4, 6, T[60]);
					d = II(d, a, b, c, M_offset_11, 10, T[61]);
					c = II(c, d, a, b, M_offset_2, 15, T[62]);
					b = II(b, c, d, a, M_offset_9, 21, T[63]);
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
	
					var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
					var nBitsTotalL = nBitsTotal;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
	
					data.sigBytes = (dataWords.length + 1) * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var hash = this._hash;
					var H = hash.words;
	
					// Swap endian
					for (var i = 0; i < 4; i++) {
						// Shortcut
						var H_i = H[i];
	
						H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
					}
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			function FF(a, b, c, d, x, s, t) {
				var n = a + (b & c | ~b & d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function GG(a, b, c, d, x, s, t) {
				var n = a + (b & d | c & ~d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function HH(a, b, c, d, x, s, t) {
				var n = a + (b ^ c ^ d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function II(a, b, c, d, x, s, t) {
				var n = a + (c ^ (b | ~d)) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.MD5('message');
	   *     var hash = CryptoJS.MD5(wordArray);
	   */
			C.MD5 = Hasher._createHelper(MD5);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacMD5(message, key);
	   */
			C.HmacMD5 = Hasher._createHmacHelper(MD5);
		})(Math);
	
		return CryptoJS.MD5;
	});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.StandardCode = undefined;
	
	var _PrmFactory = __webpack_require__(63);
	
	var _Resource = __webpack_require__(67);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _sgiLogger2 = _interopRequireDefault(_sgiLogger);
	
	var _sgiCommon = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// var this.SCMap = {};
	
	/**
	 * @namespace 标准代码管理器
	 */
	/*     标准代码提供者
	 归属：企通前端平台-ECP V5.1
	 版权：2014-2020 企通软件技术有限公司
	 --------------------------------------------------------------------------------
	 作者：纪青君                         创建日期：2014/03/13
	 修改：                               修改日期：
	 修改内容
	 --------------------------------------------------------------------------------
	 这里向使用者提供根据代码ID，获得代码的方法getSC(scID)
	 scID 符合XXXX,xx`xx`xx...的定义规则
	 输入参数scID包含的项不同，你得到的结果也不同，例如：
	 getSC（XXXX），你可能得到的是一个代码数组或代码树。
	 getSC(XXXX,xx)，你可能得到的是一个具体的代码值，也可能你得到的还是一个代码
	 数组或代码树，这样依据你的代码结构而定。
	 
	 !!!! 目前采用程序直接量的方式定义各种代码，最终将改为从参数中读取，但对外接口将保持不变
	 --------------------------------------------------------------------------------
	 修改： liux                              修改日期：2014/04/30
	 修改内容
	 getSC方法修改为使用参数工厂从参数库中读取一个代码。
	 指定的scID可以使一个代码参数的GUID，也可以是某个代码参数中的任意子节点的sGUID。
	 但是该方法返回的是参数的json形式对象或json对象的数组,而不是一个model对象。
	 --------------------------------------------------------------------------------
	 //0XXX：控件公共信息
	 //1XXX：容器控件
	 //2XXX：基本控件
	 //3XXX：自定义控件
	 //4XXX：布局属性
	 //5XXX: 图形控件
	 //6XXX—8XXX:保留
	 //9XXX:公共
	 
	 *******************************************************************************/
	var StandardCode = {
	
		SCMap: {},
		onChangeMap: {},
	
		/**
	  * 获取标准代码下拉项
	  * @param {string} scID 标准代码guid
	  */
		getSC: function getSC(scID) {
			_sgiLogger2.default.debug_1('\u6807\u51C6\u4EE3\u7801\u7BA1\u7406\u5668[StandardCode]-\u83B7\u53D6\u6807\u51C6\u4EE3\u7801[getSC]: scID=[' + scID + ']');
			/**
	     if (!scID) {
	         return null;
	     }
	     if (typeof (scID) != "string") {
	         return null;
	     }
	     var sc = Ep.this.SCMap.get(scID);
	     if (!sc) {
	         sc = Ep.PrmFactory.getPrmJsonNoLocal(scID);
	         if (!sc) {
	             return null;
	         } else {
	             sc.te = Ep.getTR(sc.te).te;
	             Ext.each(sc.cldSet, function(record) {
	                 record.te = Ep.getTR(record.te).te;
	             });
	             Ep.this.SCMap.add(scID, sc);
	         }
	     }
	     **/
			var sc = this.getFullSC(scID);
	
			if (!sc) {
				return null;
			}
	
			if (sc.cldSet) {
				return sc.cldSet;
			} else {
				sc.cldSet = [];
				return sc.cldSet;
			}
		},
		/**
	  * 获取标注代码参数（包含根节点）
	  * @param {string} scID 标准代码guid
	  */
		getFullSC: function getFullSC(scID) {
			_sgiLogger2.default.debug_1('\u6807\u51C6\u4EE3\u7801\u7BA1\u7406\u5668[StandardCode]-\u83B7\u53D6\u5B8C\u6574\u6807\u51C6\u4EE3\u7801[getFullSC]: scID=[' + scID + ']');
			if (!scID) {
				return null;
			}
			if (typeof scID != "string") {
				return null;
			}
			var sc = this.SCMap[scID];
			if (!sc) {
				sc = _PrmFactory.PrmFactory.getPrm(scID);
				if (!sc) {
					return null;
				} else {
					sc.te = _Resource.Resource.getTRByPrm(sc).te; //Resource.getTR(sc.te).te;
					var array = sc.cldSet;
					if (array instanceof Array && array.length > 0) {
						array.forEach(function (record) {
							record.te = _Resource.Resource.getTRByPrm(record).te; //Resource.getTR(record.te).te;
						});
					} else if (sc.initFun) {
						var initFun = sc.initFun;
						try {
							var reg = new RegExp(/console/gi);
							initFun = initFun.replace(reg, "tool.sgiLogger");
							var init = new Function(initFun);
							var dataObj = init() || {};
							if (dataObj.data) {
								var codeCode = dataObj.code || "c";
								var textCode = dataObj.text || "te";
								var childName = dataObj.childName || "cldSet";
								var data = dataObj.data;
								if (codeCode !== "c" || textCode !== "te" || childName !== "cldSet") {
									// 对数据进行处理
									(0, _sgiCommon.itemForEach)(data, function (item) {
										if (codeCode !== "c" && item[codeCode]) item.c = item[codeCode];
										if (textCode !== "te" && item[textCode]) item.te = item[textCode];
										if (childName !== "cldSet" && item[childName]) item.cldSet = item[childName];
									});
								}
								sc.cldSet = data;
							}
						} catch (error) {
							_sgiLogger2.default.eventErr(error);
						}
					}
					// sgiLogger.debug('StandardCode SCMap old:', this.SCMap);
					this.SCMap[scID] = sc;
					// sgiLogger.debug('StandardCode SCMap new:', this.SCMap);
				}
			}
			if (sc) {
				return sc;
			} else {
				return {};
			}
		},
		/**
	  * 判断是否存在下拉内容
	  * @param {string} scID 标准代码guid
	  * true-下拉项数量大于0
	  * false-标准代码不存在|下拉项数量=0
	  */
		contains: function contains(scID) {
			_sgiLogger2.default.debug_1('\u6807\u51C6\u4EE3\u7801\u7BA1\u7406\u5668[StandardCode]-\u5224\u65AD\u4E0B\u62C9\u9879[contains]: scID=[' + scID + ']');
			var scList = this.getSC(scID);
			if (!scList) {
				return false;
			}
			if (scList.length > 0) {
				return true;
			} else {
				return false;
			}
		},
		/**
	  * 删除标准代码缓存
	  * @param {string} scID 标准代码guid
	  */
		delSC: function delSC(scID) {
			_sgiLogger2.default.debug_1('\u6807\u51C6\u4EE3\u7801\u7BA1\u7406\u5668[StandardCode]-\u5220\u9664\u6807\u51C6\u4EE3\u7801[delSC]: scID=[' + scID + ']');
			if (!scID) {
				return null;
			}
			delete this.SCMap[scID];
		},
		/**
	  * 设置标准代码缓存参数
	  * @param {string} scID 标准代码guid
	  * @param {object} sc 标准代码参数
	  */
		setSC: function setSC(scID, sc) {
			_sgiLogger2.default.debug_1('\u6807\u51C6\u4EE3\u7801\u7BA1\u7406\u5668[StandardCode]-\u8BBE\u7F6E\u6807\u51C6\u4EE3\u7801[setSC]: scID=[' + scID + '], \u6807\u51C6\u4EE3\u7801\u5185\u5BB9sc=\u3010' + JSON.stringify(sc) + '\u3011');
			if (!scID) {
				return null;
			}
			var oldSc = this.SCMap[scID];
			if (!oldSc) {
				// this.SCMap.removeAtKey(scID);
				delete this.SCMap[scID];
			}
			// sgiLogger.debug('StandardCode SCMap old:', this.SCMap);
			this.SCMap[scID] = sc;
			this.onSCChange(scID);
			// sgiLogger.debug('StandardCode SCMap new:', this.SCMap);
		},
		/**
	  * 重载标准代码
	  * @param {string} scID 标准代码guid
	  */
		reloadSC: function reloadSC(scID) {
			_sgiLogger2.default.debug_1('\u6807\u51C6\u4EE3\u7801\u7BA1\u7406\u5668[StandardCode]-\u91CD\u8F7D\u6807\u51C6\u4EE3\u7801[reloadSC]: scID=[' + scID + ']');
			if (!scID) return;
			this.delSC(scID);
			this.getFullSC(scID);
			this.onSCChange(scID);
		},
		onSCChange: function onSCChange(scID) {
			var _this = this;
	
			_sgiLogger2.default.debug_1('\u6807\u51C6\u4EE3\u7801\u7BA1\u7406\u5668[StandardCode]-\u6807\u51C6\u4EE3\u7801\u4FEE\u6539[onSCChange]: scID=[' + scID + ']');
			var scOnChanges = this.onChangeMap[scID];
			if (scOnChanges && scOnChanges.length > 0) {
				// 执行标准代码修改回调
				scOnChanges.forEach(function (f) {
					setTimeout(function () {
						try {
							_sgiLogger2.default.debug('\u6807\u51C6\u4EE3\u7801[' + scID + ']\u4FEE\u6539\uFF0C\u6267\u884C\u63A7\u4EF6\u8BA2\u9605\u4E8B\u4EF6');
							f(_this.SCMap[scID].cldSet);
						} catch (error) {
							_sgiLogger2.default.eventErr(error);
						}
					}, 0);
				});
			}
		},
		subscribe: function subscribe(scID, callback) {
			_sgiLogger2.default.debug_1('\u6807\u51C6\u4EE3\u7801\u7BA1\u7406\u5668[StandardCode]-\u8BA2\u9605\u6807\u51C6\u4EE3\u7801[subscribe]: scID=[' + scID + '], \u8BA2\u9605\u56DE\u8C03\u4E8B\u4EF6=\u3010' + JSON.stringify(callback) + '\u3011');
			// 校验
			if (!scID || !callback || typeof callback !== "function") return;
			// 添加订阅事件
			var onChanges = this.onChangeMap[scID];
			if (!onChanges) onChanges = this.onChangeMap[scID] = [callback];else if (onChanges.indexOf(callback) < 0) onChanges.push(callback);
			// 返回取消订阅的方法
			return function unsubscribe() {
				onChanges.splice(onChanges.indexOf(callback), 1);
			};
		}
	
		// 初始化
	};if (!window.StandardCode) window.StandardCode = StandardCode;
	// 添加方法
	else Object.assign(window.StandardCode, StandardCode);
	// 导出
	var wStandardCode = window.StandardCode;
	exports.StandardCode = wStandardCode;
	exports.default = wStandardCode;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tupleNum = exports.tuple = void 0;
	
	// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
	var tuple = function tuple() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args;
	};
	
	exports.tuple = tuple;
	
	var tupleNum = function tupleNum() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return args;
	};
	
	exports.tupleNum = tupleNum;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tupleNum = exports.tuple = void 0;
	
	// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
	var tuple = function tuple() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args;
	};
	
	exports.tuple = tuple;
	
	var tupleNum = function tupleNum() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return args;
	};
	
	exports.tupleNum = tupleNum;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1507);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1097);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var BoundingRect = __webpack_require__(51);
	
	var imageHelper = __webpack_require__(450);
	
	var _util = __webpack_require__(2);
	
	var getContext = _util.getContext;
	var extend = _util.extend;
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var trim = _util.trim;
	var textWidthCache = {};
	var textWidthCacheCounter = 0;
	var TEXT_CACHE_MAX = 5000;
	var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
	var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  methods[name] = fn;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {number} width
	 */
	
	
	function getWidth(text, font) {
	  font = font || DEFAULT_FONT;
	  var key = text + ':' + font;
	
	  if (textWidthCache[key]) {
	    return textWidthCache[key];
	  }
	
	  var textLines = (text + '').split('\n');
	  var width = 0;
	
	  for (var i = 0, l = textLines.length; i < l; i++) {
	    // textContain.measureText may be overrided in SVG or VML
	    width = Math.max(measureText(textLines[i], font).width, width);
	  }
	
	  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
	    textWidthCacheCounter = 0;
	    textWidthCache = {};
	  }
	
	  textWidthCacheCounter++;
	  textWidthCache[key] = width;
	  return width;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {string} [textAlign='left']
	 * @param {string} [textVerticalAlign='top']
	 * @param {Array.<number>} [textPadding]
	 * @param {Object} [rich]
	 * @param {Object} [truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	
	function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate);
	}
	
	function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate) {
	  var contentBlock = parsePlainText(text, font, textPadding, textLineHeight, truncate);
	  var outerWidth = getWidth(text, font);
	
	  if (textPadding) {
	    outerWidth += textPadding[1] + textPadding[3];
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
	  rect.lineHeight = contentBlock.lineHeight;
	  return rect;
	}
	
	function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  var contentBlock = parseRichText(text, {
	    rich: rich,
	    truncate: truncate,
	    font: font,
	    textAlign: textAlign,
	    textPadding: textPadding,
	    textLineHeight: textLineHeight
	  });
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  return new BoundingRect(x, y, outerWidth, outerHeight);
	}
	/**
	 * @public
	 * @param {number} x
	 * @param {number} width
	 * @param {string} [textAlign='left']
	 * @return {number} Adjusted x.
	 */
	
	
	function adjustTextX(x, width, textAlign) {
	  // FIXME Right to left language
	  if (textAlign === 'right') {
	    x -= width;
	  } else if (textAlign === 'center') {
	    x -= width / 2;
	  }
	
	  return x;
	}
	/**
	 * @public
	 * @param {number} y
	 * @param {number} height
	 * @param {string} [textVerticalAlign='top']
	 * @return {number} Adjusted y.
	 */
	
	
	function adjustTextY(y, height, textVerticalAlign) {
	  if (textVerticalAlign === 'middle') {
	    y -= height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y -= height;
	  }
	
	  return y;
	}
	/**
	 * Follow same interface to `Displayable.prototype.calculateTextPosition`.
	 * @public
	 * @param {Obejct} [out] Prepared out object. If not input, auto created in the method.
	 * @param {module:zrender/graphic/Style} style where `textPosition` and `textDistance` are visited.
	 * @param {Object} rect {x, y, width, height} Rect of the host elment, according to which the text positioned.
	 * @return {Object} The input `out`. Set: {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function calculateTextPosition(out, style, rect) {
	  var textPosition = style.textPosition;
	  var distance = style.textDistance;
	  var x = rect.x;
	  var y = rect.y;
	  distance = distance || 0;
	  var height = rect.height;
	  var width = rect.width;
	  var halfHeight = height / 2;
	  var textAlign = 'left';
	  var textVerticalAlign = 'top';
	
	  switch (textPosition) {
	    case 'left':
	      x -= distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'right':
	      x += distance + width;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'top':
	      x += width / 2;
	      y -= distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'bottom':
	      x += width / 2;
	      y += height + distance;
	      textAlign = 'center';
	      break;
	
	    case 'inside':
	      x += width / 2;
	      y += halfHeight;
	      textAlign = 'center';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideLeft':
	      x += distance;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideRight':
	      x += width - distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideTop':
	      x += width / 2;
	      y += distance;
	      textAlign = 'center';
	      break;
	
	    case 'insideBottom':
	      x += width / 2;
	      y += height - distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideTopLeft':
	      x += distance;
	      y += distance;
	      break;
	
	    case 'insideTopRight':
	      x += width - distance;
	      y += distance;
	      textAlign = 'right';
	      break;
	
	    case 'insideBottomLeft':
	      x += distance;
	      y += height - distance;
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideBottomRight':
	      x += width - distance;
	      y += height - distance;
	      textAlign = 'right';
	      textVerticalAlign = 'bottom';
	      break;
	  }
	
	  out = out || {};
	  out.x = x;
	  out.y = y;
	  out.textAlign = textAlign;
	  out.textVerticalAlign = textVerticalAlign;
	  return out;
	}
	/**
	 * To be removed. But still do not remove in case that some one has imported it.
	 * @deprecated
	 * @public
	 * @param {stirng} textPosition
	 * @param {Object} rect {x, y, width, height}
	 * @param {number} distance
	 * @return {Object} {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function adjustTextPositionOnRect(textPosition, rect, distance) {
	  var dummyStyle = {
	    textPosition: textPosition,
	    textDistance: distance
	  };
	  return calculateTextPosition({}, dummyStyle, rect);
	}
	/**
	 * Show ellipsis if overflow.
	 *
	 * @public
	 * @param  {string} text
	 * @param  {string} containerWidth
	 * @param  {string} font
	 * @param  {number} [ellipsis='...']
	 * @param  {Object} [options]
	 * @param  {number} [options.maxIterations=3]
	 * @param  {number} [options.minChar=0] If truncate result are less
	 *                  then minChar, ellipsis will not show, which is
	 *                  better for user hint in some cases.
	 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
	 * @return {string}
	 */
	
	
	function truncateText(text, containerWidth, font, ellipsis, options) {
	  if (!containerWidth) {
	    return '';
	  }
	
	  var textLines = (text + '').split('\n');
	  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
	  // It is not appropriate that every line has '...' when truncate multiple lines.
	
	  for (var i = 0, len = textLines.length; i < len; i++) {
	    textLines[i] = truncateSingleLine(textLines[i], options);
	  }
	
	  return textLines.join('\n');
	}
	
	function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
	  options = extend({}, options);
	  options.font = font;
	  var ellipsis = retrieve2(ellipsis, '...');
	  options.maxIterations = retrieve2(options.maxIterations, 2);
	  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
	  // Other languages?
	
	  options.cnCharWidth = getWidth('国', font); // FIXME
	  // Consider proportional font?
	
	  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
	  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
	  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.
	
	  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.
	
	  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
	    contentWidth -= ascCharWidth;
	  }
	
	  var ellipsisWidth = getWidth(ellipsis, font);
	
	  if (ellipsisWidth > contentWidth) {
	    ellipsis = '';
	    ellipsisWidth = 0;
	  }
	
	  contentWidth = containerWidth - ellipsisWidth;
	  options.ellipsis = ellipsis;
	  options.ellipsisWidth = ellipsisWidth;
	  options.contentWidth = contentWidth;
	  options.containerWidth = containerWidth;
	  return options;
	}
	
	function truncateSingleLine(textLine, options) {
	  var containerWidth = options.containerWidth;
	  var font = options.font;
	  var contentWidth = options.contentWidth;
	
	  if (!containerWidth) {
	    return '';
	  }
	
	  var lineWidth = getWidth(textLine, font);
	
	  if (lineWidth <= containerWidth) {
	    return textLine;
	  }
	
	  for (var j = 0;; j++) {
	    if (lineWidth <= contentWidth || j >= options.maxIterations) {
	      textLine += options.ellipsis;
	      break;
	    }
	
	    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
	    textLine = textLine.substr(0, subLength);
	    lineWidth = getWidth(textLine, font);
	  }
	
	  if (textLine === '') {
	    textLine = options.placeholder;
	  }
	
	  return textLine;
	}
	
	function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
	  var width = 0;
	  var i = 0;
	
	  for (var len = text.length; i < len && width < contentWidth; i++) {
	    var charCode = text.charCodeAt(i);
	    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
	  }
	
	  return i;
	}
	/**
	 * @public
	 * @param {string} font
	 * @return {number} line height
	 */
	
	
	function getLineHeight(font) {
	  // FIXME A rough approach.
	  return getWidth('国', font);
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {Object} width
	 */
	
	
	function measureText(text, font) {
	  return methods.measureText(text, font);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	methods.measureText = function (text, font) {
	  var ctx = getContext();
	  ctx.font = font || DEFAULT_FONT;
	  return ctx.measureText(text);
	};
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {Object} [truncate]
	 * @return {Object} block: {lineHeight, lines, height, outerHeight, canCacheByTextString}
	 *  Notice: for performance, do not calculate outerWidth util needed.
	 *  `canCacheByTextString` means the result `lines` is only determined by the input `text`.
	 *  Thus we can simply comparing the `input` text to determin whether the result changed,
	 *  without travel the result `lines`.
	 */
	
	
	function parsePlainText(text, font, padding, textLineHeight, truncate) {
	  text != null && (text += '');
	  var lineHeight = retrieve2(textLineHeight, getLineHeight(font));
	  var lines = text ? text.split('\n') : [];
	  var height = lines.length * lineHeight;
	  var outerHeight = height;
	  var canCacheByTextString = true;
	
	  if (padding) {
	    outerHeight += padding[0] + padding[2];
	  }
	
	  if (text && truncate) {
	    canCacheByTextString = false;
	    var truncOuterHeight = truncate.outerHeight;
	    var truncOuterWidth = truncate.outerWidth;
	
	    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
	      text = '';
	      lines = [];
	    } else if (truncOuterWidth != null) {
	      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
	        minChar: truncate.minChar,
	        placeholder: truncate.placeholder
	      }); // FIXME
	      // It is not appropriate that every line has '...' when truncate multiple lines.
	
	      for (var i = 0, len = lines.length; i < len; i++) {
	        lines[i] = truncateSingleLine(lines[i], options);
	      }
	    }
	  }
	
	  return {
	    lines: lines,
	    height: height,
	    outerHeight: outerHeight,
	    lineHeight: lineHeight,
	    canCacheByTextString: canCacheByTextString
	  };
	}
	/**
	 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
	 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
	 *
	 * @public
	 * @param {string} text
	 * @param {Object} style
	 * @return {Object} block
	 * {
	 *      width,
	 *      height,
	 *      lines: [{
	 *          lineHeight,
	 *          width,
	 *          tokens: [[{
	 *              styleName,
	 *              text,
	 *              width,      // include textPadding
	 *              height,     // include textPadding
	 *              textWidth, // pure text width
	 *              textHeight, // pure text height
	 *              lineHeihgt,
	 *              font,
	 *              textAlign,
	 *              textVerticalAlign
	 *          }], [...], ...]
	 *      }, ...]
	 * }
	 * If styleName is undefined, it is plain text.
	 */
	
	
	function parseRichText(text, style) {
	  var contentBlock = {
	    lines: [],
	    width: 0,
	    height: 0
	  };
	  text != null && (text += '');
	
	  if (!text) {
	    return contentBlock;
	  }
	
	  var lastIndex = STYLE_REG.lastIndex = 0;
	  var result;
	
	  while ((result = STYLE_REG.exec(text)) != null) {
	    var matchedIndex = result.index;
	
	    if (matchedIndex > lastIndex) {
	      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
	    }
	
	    pushTokens(contentBlock, result[2], result[1]);
	    lastIndex = STYLE_REG.lastIndex;
	  }
	
	  if (lastIndex < text.length) {
	    pushTokens(contentBlock, text.substring(lastIndex, text.length));
	  }
	
	  var lines = contentBlock.lines;
	  var contentHeight = 0;
	  var contentWidth = 0; // For `textWidth: 100%`
	
	  var pendingList = [];
	  var stlPadding = style.textPadding;
	  var truncate = style.truncate;
	  var truncateWidth = truncate && truncate.outerWidth;
	  var truncateHeight = truncate && truncate.outerHeight;
	
	  if (stlPadding) {
	    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
	    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
	  } // Calculate layout info of tokens.
	
	
	  for (var i = 0; i < lines.length; i++) {
	    var line = lines[i];
	    var lineHeight = 0;
	    var lineWidth = 0;
	
	    for (var j = 0; j < line.tokens.length; j++) {
	      var token = line.tokens[j];
	      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.
	
	      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.
	
	      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.
	
	      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
	      // as box height of the block.
	      tokenStyle.textHeight, getLineHeight(font));
	      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
	      token.height = tokenHeight;
	      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
	      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
	      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';
	
	      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
	        return {
	          lines: [],
	          width: 0,
	          height: 0
	        };
	      }
	
	      token.textWidth = getWidth(token.text, font);
	      var tokenWidth = tokenStyle.textWidth;
	      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
	      // line when box width is needed to be auto.
	
	      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
	        token.percentWidth = tokenWidth;
	        pendingList.push(token);
	        tokenWidth = 0; // Do not truncate in this case, because there is no user case
	        // and it is too complicated.
	      } else {
	        if (tokenWidthNotSpecified) {
	          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
	          // `getBoundingRect()` will not get correct result.
	
	          var textBackgroundColor = tokenStyle.textBackgroundColor;
	          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
	          // (1) If image is not loaded, it will be loaded at render phase and call
	          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
	          // image, and then the right size will be calculated here at the next tick.
	          // See `graphic/helper/text.js`.
	          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
	          // use `imageHelper.findExistImage` to find cached image.
	          // `imageHelper.findExistImage` will always be called here before
	          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
	          // which ensures that image will not be rendered before correct size calcualted.
	
	          if (bgImg) {
	            bgImg = imageHelper.findExistImage(bgImg);
	
	            if (imageHelper.isImageReady(bgImg)) {
	              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
	            }
	          }
	        }
	
	        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
	        tokenWidth += paddingW;
	        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;
	
	        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
	          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
	            token.text = '';
	            token.textWidth = tokenWidth = 0;
	          } else {
	            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
	              minChar: truncate.minChar
	            });
	            token.textWidth = getWidth(token.text, font);
	            tokenWidth = token.textWidth + paddingW;
	          }
	        }
	      }
	
	      lineWidth += token.width = tokenWidth;
	      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
	    }
	
	    line.width = lineWidth;
	    line.lineHeight = lineHeight;
	    contentHeight += lineHeight;
	    contentWidth = Math.max(contentWidth, lineWidth);
	  }
	
	  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
	  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);
	
	  if (stlPadding) {
	    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
	    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
	  }
	
	  for (var i = 0; i < pendingList.length; i++) {
	    var token = pendingList[i];
	    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.
	
	    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
	  }
	
	  return contentBlock;
	}
	
	function pushTokens(block, str, styleName) {
	  var isEmptyStr = str === '';
	  var strs = str.split('\n');
	  var lines = block.lines;
	
	  for (var i = 0; i < strs.length; i++) {
	    var text = strs[i];
	    var token = {
	      styleName: styleName,
	      text: text,
	      isLineHolder: !text && !isEmptyStr
	    }; // The first token should be appended to the last line.
	
	    if (!i) {
	      var tokens = (lines[lines.length - 1] || (lines[0] = {
	        tokens: []
	      })).tokens; // Consider cases:
	      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
	      // (which is a placeholder) should be replaced by new token.
	      // (2) A image backage, where token likes {a|}.
	      // (3) A redundant '' will affect textAlign in line.
	      // (4) tokens with the same tplName should not be merged, because
	      // they should be displayed in different box (with border and padding).
	
	      var tokensLen = tokens.length;
	      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
	      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
	      (text || !tokensLen || isEmptyStr) && tokens.push(token);
	    } // Other tokens always start a new line.
	    else {
	        // If there is '', insert it as a placeholder.
	        lines.push({
	          tokens: [token]
	        });
	      }
	  }
	}
	
	function makeFont(style) {
	  // FIXME in node-canvas fontWeight is before fontStyle
	  // Use `fontSize` `fontFamily` to check whether font properties are defined.
	  var font = (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
	  style.fontFamily || 'sans-serif'].join(' ');
	  return font && trim(font) || style.textFont || style.font;
	}
	
	exports.DEFAULT_FONT = DEFAULT_FONT;
	exports.$override = $override;
	exports.getWidth = getWidth;
	exports.getBoundingRect = getBoundingRect;
	exports.adjustTextX = adjustTextX;
	exports.adjustTextY = adjustTextY;
	exports.calculateTextPosition = calculateTextPosition;
	exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
	exports.truncateText = truncateText;
	exports.getLineHeight = getLineHeight;
	exports.measureText = measureText;
	exports.parsePlainText = parsePlainText;
	exports.parseRichText = parseRichText;
	exports.makeFont = makeFont;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(45);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var Model = __webpack_require__(57);
	
	var DataDiffer = __webpack_require__(142);
	
	var Source = __webpack_require__(219);
	
	var _dataProvider = __webpack_require__(143);
	
	var defaultDimValueGetters = _dataProvider.defaultDimValueGetters;
	var DefaultDataProvider = _dataProvider.DefaultDataProvider;
	
	var _dimensionHelper = __webpack_require__(220);
	
	var summarizeDimensions = _dimensionHelper.summarizeDimensions;
	
	var DataDimensionInfo = __webpack_require__(848);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float64Array, Int32Array, Uint32Array, Uint16Array */
	
	/**
	 * List for data storage
	 * @module echarts/data/List
	 */
	var isObject = zrUtil.isObject;
	var UNDEFINED = 'undefined';
	var INDEX_NOT_FOUND = -1; // Use prefix to avoid index to be the same as otherIdList[idx],
	// which will cause weird udpate animation.
	
	var ID_PREFIX = 'e\0\0';
	var dataCtors = {
	  'float': typeof Float64Array === UNDEFINED ? Array : Float64Array,
	  'int': typeof Int32Array === UNDEFINED ? Array : Int32Array,
	  // Ordinal data type can be string or int
	  'ordinal': Array,
	  'number': Array,
	  'time': Array
	}; // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
	// different from the Ctor of typed array.
	
	var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
	var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
	var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;
	
	function getIndicesCtor(list) {
	  // The possible max value in this._indicies is always this._rawCount despite of filtering.
	  return list._rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
	}
	
	function cloneChunk(originalChunk) {
	  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
	
	  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
	}
	
	var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_rawData', '_chunkSize', '_chunkCount', '_dimValueGetter', '_count', '_rawCount', '_nameDimIdx', '_idDimIdx'];
	var CLONE_PROPERTIES = ['_extent', '_approximateExtent', '_rawExtent'];
	
	function transferProperties(target, source) {
	  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
	    if (source.hasOwnProperty(propName)) {
	      target[propName] = source[propName];
	    }
	  });
	  target.__wrappedMethods = source.__wrappedMethods;
	  zrUtil.each(CLONE_PROPERTIES, function (propName) {
	    target[propName] = zrUtil.clone(source[propName]);
	  });
	  target._calculationInfo = zrUtil.extend(source._calculationInfo);
	}
	/**
	 * @constructor
	 * @alias module:echarts/data/List
	 *
	 * @param {Array.<string|Object|module:data/DataDimensionInfo>} dimensions
	 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
	 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	
	var List = function (dimensions, hostModel) {
	  dimensions = dimensions || ['x', 'y'];
	  var dimensionInfos = {};
	  var dimensionNames = [];
	  var invertedIndicesMap = {};
	
	  for (var i = 0; i < dimensions.length; i++) {
	    // Use the original dimensions[i], where other flag props may exists.
	    var dimensionInfo = dimensions[i];
	
	    if (zrUtil.isString(dimensionInfo)) {
	      dimensionInfo = new DataDimensionInfo({
	        name: dimensionInfo
	      });
	    } else if (!(dimensionInfo instanceof DataDimensionInfo)) {
	      dimensionInfo = new DataDimensionInfo(dimensionInfo);
	    }
	
	    var dimensionName = dimensionInfo.name;
	    dimensionInfo.type = dimensionInfo.type || 'float';
	
	    if (!dimensionInfo.coordDim) {
	      dimensionInfo.coordDim = dimensionName;
	      dimensionInfo.coordDimIndex = 0;
	    }
	
	    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
	    dimensionNames.push(dimensionName);
	    dimensionInfos[dimensionName] = dimensionInfo;
	    dimensionInfo.index = i;
	
	    if (dimensionInfo.createInvertedIndices) {
	      invertedIndicesMap[dimensionName] = [];
	    }
	  }
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	
	
	  this.dimensions = dimensionNames;
	  /**
	   * Infomation of each data dimension, like data type.
	   * @type {Object}
	   */
	
	  this._dimensionInfos = dimensionInfos;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.dataType;
	  /**
	   * Indices stores the indices of data subset after filtered.
	   * This data subset will be used in chart.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	
	  this._indices = null;
	  this._count = 0;
	  this._rawCount = 0;
	  /**
	   * Data storage
	   * @type {Object.<key, Array.<TypedArray|Array>>}
	   * @private
	   */
	
	  this._storage = {};
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._nameList = [];
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._idList = [];
	  /**
	   * Models of data option is stored sparse for optimizing memory cost
	   * @type {Array.<module:echarts/model/Model>}
	   * @private
	   */
	
	  this._optionModels = [];
	  /**
	   * Global visual properties after visual coding
	   * @type {Object}
	   * @private
	   */
	
	  this._visual = {};
	  /**
	   * Globel layout properties.
	   * @type {Object}
	   * @private
	   */
	
	  this._layout = {};
	  /**
	   * Item visual properties after visual coding
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemVisuals = [];
	  /**
	   * Key: visual type, Value: boolean
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.hasItemVisual = {};
	  /**
	   * Item layout properties after layout
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemLayouts = [];
	  /**
	   * Graphic elemnents
	   * @type {Array.<module:zrender/Element>}
	   * @private
	   */
	
	  this._graphicEls = [];
	  /**
	   * Max size of each chunk.
	   * @type {number}
	   * @private
	   */
	
	  this._chunkSize = 1e5;
	  /**
	   * @type {number}
	   * @private
	   */
	
	  this._chunkCount = 0;
	  /**
	   * @type {Array.<Array|Object>}
	   * @private
	   */
	
	  this._rawData;
	  /**
	   * Raw extent will not be cloned, but only transfered.
	   * It will not be calculated util needed.
	   * key: dim,
	   * value: {end: number, extent: Array.<number>}
	   * @type {Object}
	   * @private
	   */
	
	  this._rawExtent = {};
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._extent = {};
	  /**
	   * key: dim
	   * value: extent
	   * @type {Object}
	   * @private
	   */
	
	  this._approximateExtent = {};
	  /**
	   * Cache summary info for fast visit. See "dimensionHelper".
	   * @type {Object}
	   * @private
	   */
	
	  this._dimensionsSummary = summarizeDimensions(this);
	  /**
	   * @type {Object.<Array|TypedArray>}
	   * @private
	   */
	
	  this._invertedIndicesMap = invertedIndicesMap;
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._calculationInfo = {};
	  /**
	   * User output info of this data.
	   * DO NOT use it in other places!
	   *
	   * When preparing user params for user callbacks, we have
	   * to clone these inner data structures to prevent users
	   * from modifying them to effect built-in logic. And for
	   * performance consideration we make this `userOutput` to
	   * avoid clone them too many times.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.userOutput = this._dimensionsSummary.userOutput;
	};
	
	var listProto = List.prototype;
	listProto.type = 'list';
	/**
	 * If each data item has it's own option
	 * @type {boolean}
	 */
	
	listProto.hasItemOption = true;
	/**
	 * The meanings of the input parameter `dim`:
	 *
	 * + If dim is a number (e.g., `1`), it means the index of the dimension.
	 *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
	 * + If dim is a number-like string (e.g., `"1"`):
	 *     + If there is the same concrete dim name defined in `this.dimensions`, it means that concrete name.
	 *     + If not, it will be converted to a number, which means the index of the dimension.
	 *        (why? because of the backward compatbility. We have been tolerating number-like string in
	 *        dimension setting, although now it seems that it is not a good idea.)
	 *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
	 *     if no dimension name is defined as `"1"`.
	 * + If dim is a not-number-like string, it means the concrete dim name.
	 *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
	 *   or customized in `dimensions` property of option like `"age"`.
	 *
	 * Get dimension name
	 * @param {string|number} dim See above.
	 * @return {string} Concrete dim name.
	 */
	
	listProto.getDimension = function (dim) {
	  if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
	  || !isNaN(dim) && !this._dimensionInfos.hasOwnProperty(dim)) {
	    dim = this.dimensions[dim];
	  }
	
	  return dim;
	};
	/**
	 * Get type and calculation info of particular dimension
	 * @param {string|number} dim
	 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	 */
	
	
	listProto.getDimensionInfo = function (dim) {
	  // Do not clone, because there may be categories in dimInfo.
	  return this._dimensionInfos[this.getDimension(dim)];
	};
	/**
	 * @return {Array.<string>} concrete dimension name list on coord.
	 */
	
	
	listProto.getDimensionsOnCoord = function () {
	  return this._dimensionsSummary.dataDimsOnCoord.slice();
	};
	/**
	 * @param {string} coordDim
	 * @param {number} [idx] A coordDim may map to more than one data dim.
	 *        If idx is `true`, return a array of all mapped dims.
	 *        If idx is not specified, return the first dim not extra.
	 * @return {string|Array.<string>} concrete data dim.
	 *        If idx is number, and not found, return null/undefined.
	 *        If idx is `true`, and not found, return empty array (always return array).
	 */
	
	
	listProto.mapDimension = function (coordDim, idx) {
	  var dimensionsSummary = this._dimensionsSummary;
	
	  if (idx == null) {
	    return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
	  }
	
	  var dims = dimensionsSummary.encode[coordDim];
	  return idx === true // always return array if idx is `true`
	  ? (dims || []).slice() : dims && dims[idx];
	};
	/**
	 * Initialize from data
	 * @param {Array.<Object|number|Array>} data source or data or data provider.
	 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
	 *        default label/tooltip.
	 *        A name can be specified in encode.itemName,
	 *        or dataItem.name (only for series option data),
	 *        or provided in nameList from outside.
	 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
	 */
	
	
	listProto.initData = function (data, nameList, dimValueGetter) {
	  var notProvider = Source.isInstance(data) || zrUtil.isArrayLike(data);
	
	  if (notProvider) {
	    data = new DefaultDataProvider(data, this.dimensions.length);
	  }
	
	  this._rawData = data; // Clear
	
	  this._storage = {};
	  this._indices = null;
	  this._nameList = nameList || [];
	  this._idList = [];
	  this._nameRepeatCount = {};
	
	  if (!dimValueGetter) {
	    this.hasItemOption = false;
	  }
	  /**
	   * @readOnly
	   */
	
	
	  this.defaultDimValueGetter = defaultDimValueGetters[this._rawData.getSource().sourceFormat]; // Default dim value getter
	
	  this._dimValueGetter = dimValueGetter = dimValueGetter || this.defaultDimValueGetter;
	  this._dimValueGetterArrayRows = defaultDimValueGetters.arrayRows; // Reset raw extent.
	
	  this._rawExtent = {};
	
	  this._initDataFromProvider(0, data.count()); // If data has no item option.
	
	
	  if (data.pure) {
	    this.hasItemOption = false;
	  }
	};
	
	listProto.getProvider = function () {
	  return this._rawData;
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 */
	
	
	listProto.appendData = function (data) {
	  var rawData = this._rawData;
	  var start = this.count();
	  rawData.appendData(data);
	  var end = rawData.count();
	
	  if (!rawData.persistent) {
	    end += start;
	  }
	
	  this._initDataFromProvider(start, end);
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 * This method does not modify `rawData` (`dataProvider`), but only
	 * add values to storage.
	 *
	 * The final count will be increased by `Math.max(values.length, names.length)`.
	 *
	 * @param {Array.<Array.<*>>} values That is the SourceType: 'arrayRows', like
	 *        [
	 *            [12, 33, 44],
	 *            [NaN, 43, 1],
	 *            ['-', 'asdf', 0]
	 *        ]
	 *        Each item is exaclty cooresponding to a dimension.
	 * @param {Array.<string>} [names]
	 */
	
	
	listProto.appendValues = function (values, names) {
	  var chunkSize = this._chunkSize;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var rawExtent = this._rawExtent;
	  var start = this.count();
	  var end = start + Math.max(values.length, names ? names.length : 0);
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, this._dimensionInfos[dim], chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var emptyDataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    var sourceIdx = idx - start;
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	
	      var val = this._dimValueGetterArrayRows(values[sourceIdx] || emptyDataItem, dim, sourceIdx, k);
	
	      storage[dim][chunkIndex][chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    }
	
	    if (names) {
	      this._nameList[idx] = names[sourceIdx];
	    }
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	listProto._initDataFromProvider = function (start, end) {
	  // Optimize.
	  if (start >= end) {
	    return;
	  }
	
	  var chunkSize = this._chunkSize;
	  var rawData = this._rawData;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var dimensionInfoMap = this._dimensionInfos;
	  var nameList = this._nameList;
	  var idList = this._idList;
	  var rawExtent = this._rawExtent;
	  var nameRepeatCount = this._nameRepeatCount = {};
	  var nameDimIdx;
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    var dimInfo = dimensionInfoMap[dim];
	
	    if (dimInfo.otherDims.itemName === 0) {
	      nameDimIdx = this._nameDimIdx = i;
	    }
	
	    if (dimInfo.otherDims.itemId === 0) {
	      this._idDimIdx = i;
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, dimInfo, chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var dataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    // NOTICE: Try not to write things into dataItem
	    dataItem = rawData.getItem(idx, dataItem); // Each data item is value
	    // [1, 2]
	    // 2
	    // Bar chart, line chart which uses category axis
	    // only gives the 'y' value. 'x' value is the indices of category
	    // Use a tempValue to normalize the value to be a (x, y) value
	
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	      var dimStorage = storage[dim][chunkIndex]; // PENDING NULL is empty or zero
	
	      var val = this._dimValueGetter(dataItem, dim, idx, k);
	
	      dimStorage[chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    } // ??? FIXME not check by pure but sourceFormat?
	    // TODO refactor these logic.
	
	
	    if (!rawData.pure) {
	      var name = nameList[idx];
	
	      if (dataItem && name == null) {
	        // If dataItem is {name: ...}, it has highest priority.
	        // That is appropriate for many common cases.
	        if (dataItem.name != null) {
	          // There is no other place to persistent dataItem.name,
	          // so save it to nameList.
	          nameList[idx] = name = dataItem.name;
	        } else if (nameDimIdx != null) {
	          var nameDim = dimensions[nameDimIdx];
	          var nameDimChunk = storage[nameDim][chunkIndex];
	
	          if (nameDimChunk) {
	            name = nameDimChunk[chunkOffset];
	            var ordinalMeta = dimensionInfoMap[nameDim].ordinalMeta;
	
	            if (ordinalMeta && ordinalMeta.categories.length) {
	              name = ordinalMeta.categories[name];
	            }
	          }
	        }
	      } // Try using the id in option
	      // id or name is used on dynamical data, mapping old and new items.
	
	
	      var id = dataItem == null ? null : dataItem.id;
	
	      if (id == null && name != null) {
	        // Use name as id and add counter to avoid same name
	        nameRepeatCount[name] = nameRepeatCount[name] || 0;
	        id = name;
	
	        if (nameRepeatCount[name] > 0) {
	          id += '__ec__' + nameRepeatCount[name];
	        }
	
	        nameRepeatCount[name]++;
	      }
	
	      id != null && (idList[idx] = id);
	    }
	  }
	
	  if (!rawData.persistent && rawData.clean) {
	    // Clean unused data if data source is typed array.
	    rawData.clean();
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	function prepareChunks(storage, dimInfo, chunkSize, chunkCount, end) {
	  var DataCtor = dataCtors[dimInfo.type];
	  var lastChunkIndex = chunkCount - 1;
	  var dim = dimInfo.name;
	  var resizeChunkArray = storage[dim][lastChunkIndex];
	
	  if (resizeChunkArray && resizeChunkArray.length < chunkSize) {
	    var newStore = new DataCtor(Math.min(end - lastChunkIndex * chunkSize, chunkSize)); // The cost of the copy is probably inconsiderable
	    // within the initial chunkSize.
	
	    for (var j = 0; j < resizeChunkArray.length; j++) {
	      newStore[j] = resizeChunkArray[j];
	    }
	
	    storage[dim][lastChunkIndex] = newStore;
	  } // Create new chunks.
	
	
	  for (var k = chunkCount * chunkSize; k < end; k += chunkSize) {
	    storage[dim].push(new DataCtor(Math.min(end - k, chunkSize)));
	  }
	}
	
	function prepareInvertedIndex(list) {
	  var invertedIndicesMap = list._invertedIndicesMap;
	  zrUtil.each(invertedIndicesMap, function (invertedIndices, dim) {
	    var dimInfo = list._dimensionInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
	
	    var ordinalMeta = dimInfo.ordinalMeta;
	
	    if (ordinalMeta) {
	      invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
	      // mapping to 0, we should set it as INDEX_NOT_FOUND.
	
	      for (var i = 0; i < invertedIndices.length; i++) {
	        invertedIndices[i] = INDEX_NOT_FOUND;
	      }
	
	      for (var i = 0; i < list._count; i++) {
	        // Only support the case that all values are distinct.
	        invertedIndices[list.get(dim, i)] = i;
	      }
	    }
	  });
	}
	
	function getRawValueFromStore(list, dimIndex, rawIndex) {
	  var val;
	
	  if (dimIndex != null) {
	    var chunkSize = list._chunkSize;
	    var chunkIndex = Math.floor(rawIndex / chunkSize);
	    var chunkOffset = rawIndex % chunkSize;
	    var dim = list.dimensions[dimIndex];
	    var chunk = list._storage[dim][chunkIndex];
	
	    if (chunk) {
	      val = chunk[chunkOffset];
	      var ordinalMeta = list._dimensionInfos[dim].ordinalMeta;
	
	      if (ordinalMeta && ordinalMeta.categories.length) {
	        val = ordinalMeta.categories[val];
	      }
	    }
	  }
	
	  return val;
	}
	/**
	 * @return {number}
	 */
	
	
	listProto.count = function () {
	  return this._count;
	};
	
	listProto.getIndices = function () {
	  var newIndices;
	  var indices = this._indices;
	
	  if (indices) {
	    var Ctor = indices.constructor;
	    var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
	
	    if (Ctor === Array) {
	      newIndices = new Ctor(thisCount);
	
	      for (var i = 0; i < thisCount; i++) {
	        newIndices[i] = indices[i];
	      }
	    } else {
	      newIndices = new Ctor(indices.buffer, 0, thisCount);
	    }
	  } else {
	    var Ctor = getIndicesCtor(this);
	    var newIndices = new Ctor(this.count());
	
	    for (var i = 0; i < newIndices.length; i++) {
	      newIndices[i] = i;
	    }
	  }
	
	  return newIndices;
	};
	/**
	 * Get value. Return NaN if idx is out of range.
	 * @param {string} dim Dim must be concrete name.
	 * @param {number} idx
	 * @param {boolean} stack
	 * @return {number}
	 */
	
	
	listProto.get = function (dim, idx
	/*, stack */
	) {
	  if (!(idx >= 0 && idx < this._count)) {
	    return NaN;
	  }
	
	  var storage = this._storage;
	
	  if (!storage[dim]) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  idx = this.getRawIndex(idx);
	  var chunkIndex = Math.floor(idx / this._chunkSize);
	  var chunkOffset = idx % this._chunkSize;
	  var chunkStore = storage[dim][chunkIndex];
	  var value = chunkStore[chunkOffset]; // FIXME ordinal data type is not stackable
	  // if (stack) {
	  //     var dimensionInfo = this._dimensionInfos[dim];
	  //     if (dimensionInfo && dimensionInfo.stackable) {
	  //         var stackedOn = this.stackedOn;
	  //         while (stackedOn) {
	  //             // Get no stacked data of stacked on
	  //             var stackedValue = stackedOn.get(dim, idx);
	  //             // Considering positive stack, negative stack and empty data
	  //             if ((value >= 0 && stackedValue > 0)  // Positive stack
	  //                 || (value <= 0 && stackedValue < 0) // Negative stack
	  //             ) {
	  //                 value += stackedValue;
	  //             }
	  //             stackedOn = stackedOn.stackedOn;
	  //         }
	  //     }
	  // }
	
	  return value;
	};
	/**
	 * @param {string} dim concrete dim
	 * @param {number} rawIndex
	 * @return {number|string}
	 */
	
	
	listProto.getByRawIndex = function (dim, rawIdx) {
	  if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
	    return NaN;
	  }
	
	  var dimStore = this._storage[dim];
	
	  if (!dimStore) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = dimStore[chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
	 * Hack a much simpler _getFast
	 * @private
	 */
	
	
	listProto._getFast = function (dim, rawIdx) {
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = this._storage[dim][chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * Get value for multi dimensions.
	 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getValues = function (dimensions, idx
	/*, stack */
	) {
	  var values = [];
	
	  if (!zrUtil.isArray(dimensions)) {
	    // stack = idx;
	    idx = dimensions;
	    dimensions = this.dimensions;
	  }
	
	  for (var i = 0, len = dimensions.length; i < len; i++) {
	    values.push(this.get(dimensions[i], idx
	    /*, stack */
	    ));
	  }
	
	  return values;
	};
	/**
	 * If value is NaN. Inlcuding '-'
	 * Only check the coord dimensions.
	 * @param {string} dim
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.hasValue = function (idx) {
	  var dataDimsOnCoord = this._dimensionsSummary.dataDimsOnCoord;
	
	  for (var i = 0, len = dataDimsOnCoord.length; i < len; i++) {
	    // Ordinal type originally can be string or number.
	    // But when an ordinal type is used on coord, it can
	    // not be string but only number. So we can also use isNaN.
	    if (isNaN(this.get(dataDimsOnCoord[i], idx))) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Get extent of data in one dimension
	 * @param {string} dim
	 * @param {boolean} stack
	 */
	
	
	listProto.getDataExtent = function (dim
	/*, stack */
	) {
	  // Make sure use concrete dim as cache name.
	  dim = this.getDimension(dim);
	  var dimData = this._storage[dim];
	  var initialExtent = getInitialExtent(); // stack = !!((stack || false) && this.getCalculationInfo(dim));
	
	  if (!dimData) {
	    return initialExtent;
	  } // Make more strict checkings to ensure hitting cache.
	
	
	  var currEnd = this.count(); // var cacheName = [dim, !!stack].join('_');
	  // var cacheName = dim;
	  // Consider the most cases when using data zoom, `getDataExtent`
	  // happened before filtering. We cache raw extent, which is not
	  // necessary to be cleared and recalculated when restore data.
	
	  var useRaw = !this._indices; // && !stack;
	
	  var dimExtent;
	
	  if (useRaw) {
	    return this._rawExtent[dim].slice();
	  }
	
	  dimExtent = this._extent[dim];
	
	  if (dimExtent) {
	    return dimExtent.slice();
	  }
	
	  dimExtent = initialExtent;
	  var min = dimExtent[0];
	  var max = dimExtent[1];
	
	  for (var i = 0; i < currEnd; i++) {
	    // var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
	    var value = this._getFast(dim, this.getRawIndex(i));
	
	    value < min && (min = value);
	    value > max && (max = value);
	  }
	
	  dimExtent = [min, max];
	  this._extent[dim] = dimExtent;
	  return dimExtent;
	};
	/**
	 * Optimize for the scenario that data is filtered by a given extent.
	 * Consider that if data amount is more than hundreds of thousand,
	 * extent calculation will cost more than 10ms and the cache will
	 * be erased because of the filtering.
	 */
	
	
	listProto.getApproximateExtent = function (dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  return this._approximateExtent[dim] || this.getDataExtent(dim
	  /*, stack */
	  );
	};
	
	listProto.setApproximateExtent = function (extent, dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  this._approximateExtent[dim] = extent.slice();
	};
	/**
	 * @param {string} key
	 * @return {*}
	 */
	
	
	listProto.getCalculationInfo = function (key) {
	  return this._calculationInfo[key];
	};
	/**
	 * @param {string|Object} key or k-v object
	 * @param {*} [value]
	 */
	
	
	listProto.setCalculationInfo = function (key, value) {
	  isObject(key) ? zrUtil.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
	};
	/**
	 * Get sum of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getSum = function (dim
	/*, stack */
	) {
	  var dimData = this._storage[dim];
	  var sum = 0;
	
	  if (dimData) {
	    for (var i = 0, len = this.count(); i < len; i++) {
	      var value = this.get(dim, i
	      /*, stack */
	      );
	
	      if (!isNaN(value)) {
	        sum += value;
	      }
	    }
	  }
	
	  return sum;
	};
	/**
	 * Get median of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getMedian = function (dim
	/*, stack */
	) {
	  var dimDataArray = []; // map all data of one dimension
	
	  this.each(dim, function (val, idx) {
	    if (!isNaN(val)) {
	      dimDataArray.push(val);
	    }
	  }); // TODO
	  // Use quick select?
	  // immutability & sort
	
	  var sortedDimDataArray = [].concat(dimDataArray).sort(function (a, b) {
	    return a - b;
	  });
	  var len = this.count(); // calculate median
	
	  return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
	}; // /**
	//  * Retreive the index with given value
	//  * @param {string} dim Concrete dimension.
	//  * @param {number} value
	//  * @return {number}
	//  */
	// Currently incorrect: should return dataIndex but not rawIndex.
	// Do not fix it until this method is to be used somewhere.
	// FIXME Precision of float value
	// listProto.indexOf = function (dim, value) {
	//     var storage = this._storage;
	//     var dimData = storage[dim];
	//     var chunkSize = this._chunkSize;
	//     if (dimData) {
	//         for (var i = 0, len = this.count(); i < len; i++) {
	//             var chunkIndex = Math.floor(i / chunkSize);
	//             var chunkOffset = i % chunkSize;
	//             if (dimData[chunkIndex][chunkOffset] === value) {
	//                 return i;
	//             }
	//         }
	//     }
	//     return -1;
	// };
	
	/**
	 * Only support the dimension which inverted index created.
	 * Do not support other cases until required.
	 * @param {string} concrete dim
	 * @param {number|string} value
	 * @return {number} rawIndex
	 */
	
	
	listProto.rawIndexOf = function (dim, value) {
	  var invertedIndices = dim && this._invertedIndicesMap[dim];
	  var rawIndex = invertedIndices[value];
	
	  if (rawIndex == null || isNaN(rawIndex)) {
	    return INDEX_NOT_FOUND;
	  }
	
	  return rawIndex;
	};
	/**
	 * Retreive the index with given name
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfName = function (name) {
	  for (var i = 0, len = this.count(); i < len; i++) {
	    if (this.getName(i) === name) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index with given raw data index
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfRawIndex = function (rawIndex) {
	  if (rawIndex >= this._rawCount || rawIndex < 0) {
	    return -1;
	  }
	
	  if (!this._indices) {
	    return rawIndex;
	  } // Indices are ascending
	
	
	  var indices = this._indices; // If rawIndex === dataIndex
	
	  var rawDataIndex = indices[rawIndex];
	
	  if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
	    return rawIndex;
	  }
	
	  var left = 0;
	  var right = this._count - 1;
	
	  while (left <= right) {
	    var mid = (left + right) / 2 | 0;
	
	    if (indices[mid] < rawIndex) {
	      left = mid + 1;
	    } else if (indices[mid] > rawIndex) {
	      right = mid - 1;
	    } else {
	      return mid;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index of nearest value
	 * @param {string} dim
	 * @param {number} value
	 * @param {number} [maxDistance=Infinity]
	 * @return {Array.<number>} If and only if multiple indices has
	 *        the same value, they are put to the result.
	 */
	
	
	listProto.indicesOfNearest = function (dim, value, maxDistance) {
	  var storage = this._storage;
	  var dimData = storage[dim];
	  var nearestIndices = [];
	
	  if (!dimData) {
	    return nearestIndices;
	  }
	
	  if (maxDistance == null) {
	    maxDistance = Infinity;
	  }
	
	  var minDist = Infinity;
	  var minDiff = -1;
	  var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/List.js`.
	
	  for (var i = 0, len = this.count(); i < len; i++) {
	    var diff = value - this.get(dim, i);
	    var dist = Math.abs(diff);
	
	    if (dist <= maxDistance) {
	      // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
	      // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
	      // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
	      // So we chose the one that `diff >= 0` in this csae.
	      // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
	      // should be push to `nearestIndices`.
	      if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        nearestIndicesLen = 0;
	      }
	
	      if (diff === minDiff) {
	        nearestIndices[nearestIndicesLen++] = i;
	      }
	    }
	  }
	
	  nearestIndices.length = nearestIndicesLen;
	  return nearestIndices;
	};
	/**
	 * Get raw data index
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawIndex = getRawIndexWithoutIndices;
	
	function getRawIndexWithoutIndices(idx) {
	  return idx;
	}
	
	function getRawIndexWithIndices(idx) {
	  if (idx < this._count && idx >= 0) {
	    return this._indices[idx];
	  }
	
	  return -1;
	}
	/**
	 * Get raw data item
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawDataItem = function (idx) {
	  if (!this._rawData.persistent) {
	    var val = [];
	
	    for (var i = 0; i < this.dimensions.length; i++) {
	      var dim = this.dimensions[i];
	      val.push(this.get(dim, idx));
	    }
	
	    return val;
	  } else {
	    return this._rawData.getItem(this.getRawIndex(idx));
	  }
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getName = function (idx) {
	  var rawIndex = this.getRawIndex(idx);
	  return this._nameList[rawIndex] || getRawValueFromStore(this, this._nameDimIdx, rawIndex) || '';
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getId = function (idx) {
	  return getId(this, this.getRawIndex(idx));
	};
	
	function getId(list, rawIndex) {
	  var id = list._idList[rawIndex];
	
	  if (id == null) {
	    id = getRawValueFromStore(list, list._idDimIdx, rawIndex);
	  }
	
	  if (id == null) {
	    // FIXME Check the usage in graph, should not use prefix.
	    id = ID_PREFIX + rawIndex;
	  }
	
	  return id;
	}
	
	function normalizeDimensions(dimensions) {
	  if (!zrUtil.isArray(dimensions)) {
	    dimensions = [dimensions];
	  }
	
	  return dimensions;
	}
	
	function validateDimensions(list, dims) {
	  for (var i = 0; i < dims.length; i++) {
	    // stroage may be empty when no data, so use
	    // dimensionInfos to check.
	    if (!list._dimensionInfos[dims[i]]) {
	      console.error('Unkown dimension ' + dims[i]);
	    }
	  }
	}
	/**
	 * Data iteration
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 *
	 * @example
	 *  list.each('x', function (x, idx) {});
	 *  list.each(['x', 'y'], function (x, y, idx) {});
	 *  list.each(function (idx) {})
	 */
	
	
	listProto.each = function (dims, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dims === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dims;
	    dims = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
	  var dimSize = dims.length;
	
	  for (var i = 0; i < this.count(); i++) {
	    // Simple optimization
	    switch (dimSize) {
	      case 0:
	        cb.call(context, i);
	        break;
	
	      case 1:
	        cb.call(context, this.get(dims[0], i), i);
	        break;
	
	      case 2:
	        cb.call(context, this.get(dims[0], i), this.get(dims[1], i), i);
	        break;
	
	      default:
	        var k = 0;
	        var value = [];
	
	        for (; k < dimSize; k++) {
	          value[k] = this.get(dims[k], i);
	        } // Index
	
	
	        value[k] = i;
	        cb.apply(context, value);
	    }
	  }
	};
	/**
	 * Data filter
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 */
	
	
	listProto.filterSelf = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var count = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(count);
	  var value = [];
	  var dimSize = dimensions.length;
	  var offset = 0;
	  var dim0 = dimensions[0];
	
	  for (var i = 0; i < count; i++) {
	    var keep;
	    var rawIdx = this.getRawIndex(i); // Simple optimization
	
	    if (dimSize === 0) {
	      keep = cb.call(context, i);
	    } else if (dimSize === 1) {
	      var val = this._getFast(dim0, rawIdx);
	
	      keep = cb.call(context, val, i);
	    } else {
	      for (var k = 0; k < dimSize; k++) {
	        value[k] = this._getFast(dim0, rawIdx);
	      }
	
	      value[k] = i;
	      keep = cb.apply(context, value);
	    }
	
	    if (keep) {
	      newIndices[offset++] = rawIdx;
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < count) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Select data in range. (For optimization of filter)
	 * (Manually inline code, support 5 million data filtering in data zoom.)
	 */
	
	
	listProto.selectRange = function (range) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  var dimensions = [];
	
	  for (var dim in range) {
	    if (range.hasOwnProperty(dim)) {
	      dimensions.push(dim);
	    }
	  }
	
	  var dimSize = dimensions.length;
	
	  if (!dimSize) {
	    return;
	  }
	
	  var originalCount = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(originalCount);
	  var offset = 0;
	  var dim0 = dimensions[0];
	  var min = range[dim0][0];
	  var max = range[dim0][1];
	  var quickFinished = false;
	
	  if (!this._indices) {
	    // Extreme optimization for common case. About 2x faster in chrome.
	    var idx = 0;
	
	    if (dimSize === 1) {
	      var dimStorage = this._storage[dimensions[0]];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
	          // value indicates the line should be broken. But for the case like
	          // scatter plot, a data item with empty value will not be rendered,
	          // but the axis extent may be effected if some other dim of the data
	          // item has value. Fortunately it is not a significant negative effect.
	
	          if (val >= min && val <= max || isNaN(val)) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    } else if (dimSize === 2) {
	      var dimStorage = this._storage[dim0];
	      var dimStorage2 = this._storage[dimensions[1]];
	      var min2 = range[dimensions[1]][0];
	      var max2 = range[dimensions[1]][1];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var chunkStorage2 = dimStorage2[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i];
	          var val2 = chunkStorage2[i]; // Do not filter NaN, see comment above.
	
	          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    }
	  }
	
	  if (!quickFinished) {
	    if (dimSize === 1) {
	      for (var i = 0; i < originalCount; i++) {
	        var rawIndex = this.getRawIndex(i);
	
	        var val = this._getFast(dim0, rawIndex); // Do not filter NaN, see comment above.
	
	
	        if (val >= min && val <= max || isNaN(val)) {
	          newIndices[offset++] = rawIndex;
	        }
	      }
	    } else {
	      for (var i = 0; i < originalCount; i++) {
	        var keep = true;
	        var rawIndex = this.getRawIndex(i);
	
	        for (var k = 0; k < dimSize; k++) {
	          var dimk = dimensions[k];
	
	          var val = this._getFast(dim, rawIndex); // Do not filter NaN, see comment above.
	
	
	          if (val < range[dimk][0] || val > range[dimk][1]) {
	            keep = false;
	          }
	        }
	
	        if (keep) {
	          newIndices[offset++] = this.getRawIndex(i);
	        }
	      }
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < originalCount) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Data mapping to a plain array
	 * @param {string|Array.<string>} [dimensions]
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.mapArray = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  var result = [];
	  this.each(dimensions, function () {
	    result.push(cb && cb.apply(this, arguments));
	  }, context);
	  return result;
	}; // Data in excludeDimensions is copied, otherwise transfered.
	
	
	function cloneListForMapAndSample(original, excludeDimensions) {
	  var allDimensions = original.dimensions;
	  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
	
	  transferProperties(list, original);
	  var storage = list._storage = {};
	  var originalStorage = original._storage; // Init storage
	
	  for (var i = 0; i < allDimensions.length; i++) {
	    var dim = allDimensions[i];
	
	    if (originalStorage[dim]) {
	      // Notice that we do not reset invertedIndicesMap here, becuase
	      // there is no scenario of mapping or sampling ordinal dimension.
	      if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
	        storage[dim] = cloneDimStore(originalStorage[dim]);
	        list._rawExtent[dim] = getInitialExtent();
	        list._extent[dim] = null;
	      } else {
	        // Direct reference for other dimensions
	        storage[dim] = originalStorage[dim];
	      }
	    }
	  }
	
	  return list;
	}
	
	function cloneDimStore(originalDimStore) {
	  var newDimStore = new Array(originalDimStore.length);
	
	  for (var j = 0; j < originalDimStore.length; j++) {
	    newDimStore[j] = cloneChunk(originalDimStore[j]);
	  }
	
	  return newDimStore;
	}
	
	function getInitialExtent() {
	  return [Infinity, -Infinity];
	}
	/**
	 * Data mapping to a new List with given dimensions
	 * @param {string|Array.<string>} dimensions
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.map = function (dimensions, cb, context, contextCompat) {
	  'use strict'; // contextCompat just for compat echarts3
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
	  // So we can reference to the same value
	
	  list._indices = this._indices;
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  var storage = list._storage;
	  var tmpRetValue = [];
	  var chunkSize = this._chunkSize;
	  var dimSize = dimensions.length;
	  var dataCount = this.count();
	  var values = [];
	  var rawExtent = list._rawExtent;
	
	  for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
	    for (var dimIndex = 0; dimIndex < dimSize; dimIndex++) {
	      values[dimIndex] = this.get(dimensions[dimIndex], dataIndex
	      /*, stack */
	      );
	    }
	
	    values[dimSize] = dataIndex;
	    var retValue = cb && cb.apply(context, values);
	
	    if (retValue != null) {
	      // a number or string (in oridinal dimension)?
	      if (typeof retValue !== 'object') {
	        tmpRetValue[0] = retValue;
	        retValue = tmpRetValue;
	      }
	
	      var rawIndex = this.getRawIndex(dataIndex);
	      var chunkIndex = Math.floor(rawIndex / chunkSize);
	      var chunkOffset = rawIndex % chunkSize;
	
	      for (var i = 0; i < retValue.length; i++) {
	        var dim = dimensions[i];
	        var val = retValue[i];
	        var rawExtentOnDim = rawExtent[dim];
	        var dimStore = storage[dim];
	
	        if (dimStore) {
	          dimStore[chunkIndex][chunkOffset] = val;
	        }
	
	        if (val < rawExtentOnDim[0]) {
	          rawExtentOnDim[0] = val;
	        }
	
	        if (val > rawExtentOnDim[1]) {
	          rawExtentOnDim[1] = val;
	        }
	      }
	    }
	  }
	
	  return list;
	};
	/**
	 * Large data down sampling on given dimension
	 * @param {string} dimension
	 * @param {number} rate
	 * @param {Function} sampleValue
	 * @param {Function} sampleIndex Sample index for name and id
	 */
	
	
	listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
	  var list = cloneListForMapAndSample(this, [dimension]);
	  var targetStorage = list._storage;
	  var frameValues = [];
	  var frameSize = Math.floor(1 / rate);
	  var dimStore = targetStorage[dimension];
	  var len = this.count();
	  var chunkSize = this._chunkSize;
	  var rawExtentOnDim = list._rawExtent[dimension];
	  var newIndices = new (getIndicesCtor(this))(len);
	  var offset = 0;
	
	  for (var i = 0; i < len; i += frameSize) {
	    // Last frame
	    if (frameSize > len - i) {
	      frameSize = len - i;
	      frameValues.length = frameSize;
	    }
	
	    for (var k = 0; k < frameSize; k++) {
	      var dataIdx = this.getRawIndex(i + k);
	      var originalChunkIndex = Math.floor(dataIdx / chunkSize);
	      var originalChunkOffset = dataIdx % chunkSize;
	      frameValues[k] = dimStore[originalChunkIndex][originalChunkOffset];
	    }
	
	    var value = sampleValue(frameValues);
	    var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
	    var sampleChunkIndex = Math.floor(sampleFrameIdx / chunkSize);
	    var sampleChunkOffset = sampleFrameIdx % chunkSize; // Only write value on the filtered data
	
	    dimStore[sampleChunkIndex][sampleChunkOffset] = value;
	
	    if (value < rawExtentOnDim[0]) {
	      rawExtentOnDim[0] = value;
	    }
	
	    if (value > rawExtentOnDim[1]) {
	      rawExtentOnDim[1] = value;
	    }
	
	    newIndices[offset++] = sampleFrameIdx;
	  }
	
	  list._count = offset;
	  list._indices = newIndices;
	  list.getRawIndex = getRawIndexWithIndices;
	  return list;
	};
	/**
	 * Get model of one data item.
	 *
	 * @param {number} idx
	 */
	// FIXME Model proxy ?
	
	
	listProto.getItemModel = function (idx) {
	  var hostModel = this.hostModel;
	  return new Model(this.getRawDataItem(idx), hostModel, hostModel && hostModel.ecModel);
	};
	/**
	 * Create a data differ
	 * @param {module:echarts/data/List} otherList
	 * @return {module:echarts/data/DataDiffer}
	 */
	
	
	listProto.diff = function (otherList) {
	  var thisList = this;
	  return new DataDiffer(otherList ? otherList.getIndices() : [], this.getIndices(), function (idx) {
	    return getId(otherList, idx);
	  }, function (idx) {
	    return getId(thisList, idx);
	  });
	};
	/**
	 * Get visual property.
	 * @param {string} key
	 */
	
	
	listProto.getVisual = function (key) {
	  var visual = this._visual;
	  return visual && visual[key];
	};
	/**
	 * Set visual property
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setVisual('color', color);
	 *  setVisual({
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setVisual = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setVisual(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._visual = this._visual || {};
	  this._visual[key] = val;
	};
	/**
	 * Set layout property.
	 * @param {string|Object} key
	 * @param {*} [val]
	 */
	
	
	listProto.setLayout = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setLayout(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._layout[key] = val;
	};
	/**
	 * Get layout property.
	 * @param  {string} key.
	 * @return {*}
	 */
	
	
	listProto.getLayout = function (key) {
	  return this._layout[key];
	};
	/**
	 * Get layout of single data item
	 * @param {number} idx
	 */
	
	
	listProto.getItemLayout = function (idx) {
	  return this._itemLayouts[idx];
	};
	/**
	 * Set layout of single data item
	 * @param {number} idx
	 * @param {Object} layout
	 * @param {boolean=} [merge=false]
	 */
	
	
	listProto.setItemLayout = function (idx, layout, merge) {
	  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
	};
	/**
	 * Clear all layout of single data item
	 */
	
	
	listProto.clearItemLayouts = function () {
	  this._itemLayouts.length = 0;
	};
	/**
	 * Get visual property of single data item
	 * @param {number} idx
	 * @param {string} key
	 * @param {boolean} [ignoreParent=false]
	 */
	
	
	listProto.getItemVisual = function (idx, key, ignoreParent) {
	  var itemVisual = this._itemVisuals[idx];
	  var val = itemVisual && itemVisual[key];
	
	  if (val == null && !ignoreParent) {
	    // Use global visual property
	    return this.getVisual(key);
	  }
	
	  return val;
	};
	/**
	 * Set visual property of single data item
	 *
	 * @param {number} idx
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setItemVisual(0, 'color', color);
	 *  setItemVisual(0, {
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setItemVisual = function (idx, key, value) {
	  var itemVisual = this._itemVisuals[idx] || {};
	  var hasItemVisual = this.hasItemVisual;
	  this._itemVisuals[idx] = itemVisual;
	
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        itemVisual[name] = key[name];
	        hasItemVisual[name] = true;
	      }
	    }
	
	    return;
	  }
	
	  itemVisual[key] = value;
	  hasItemVisual[key] = true;
	};
	/**
	 * Clear itemVisuals and list visual.
	 */
	
	
	listProto.clearAllVisual = function () {
	  this._visual = {};
	  this._itemVisuals = [];
	  this.hasItemVisual = {};
	};
	
	var setItemDataAndSeriesIndex = function (child) {
	  child.seriesIndex = this.seriesIndex;
	  child.dataIndex = this.dataIndex;
	  child.dataType = this.dataType;
	};
	/**
	 * Set graphic element relative to data. It can be set as null
	 * @param {number} idx
	 * @param {module:zrender/Element} [el]
	 */
	
	
	listProto.setItemGraphicEl = function (idx, el) {
	  var hostModel = this.hostModel;
	
	  if (el) {
	    // Add data index and series index for indexing the data by element
	    // Useful in tooltip
	    el.dataIndex = idx;
	    el.dataType = this.dataType;
	    el.seriesIndex = hostModel && hostModel.seriesIndex;
	
	    if (el.type === 'group') {
	      el.traverse(setItemDataAndSeriesIndex, el);
	    }
	  }
	
	  this._graphicEls[idx] = el;
	};
	/**
	 * @param {number} idx
	 * @return {module:zrender/Element}
	 */
	
	
	listProto.getItemGraphicEl = function (idx) {
	  return this._graphicEls[idx];
	};
	/**
	 * @param {Function} cb
	 * @param {*} context
	 */
	
	
	listProto.eachItemGraphicEl = function (cb, context) {
	  zrUtil.each(this._graphicEls, function (el, idx) {
	    if (el) {
	      cb && cb.call(context, el, idx);
	    }
	  });
	};
	/**
	 * Shallow clone a new list except visual and layout properties, and graph elements.
	 * New list only change the indices.
	 */
	
	
	listProto.cloneShallow = function (list) {
	  if (!list) {
	    var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
	    list = new List(dimensionInfoList, this.hostModel);
	  } // FIXME
	
	
	  list._storage = this._storage;
	  transferProperties(list, this); // Clone will not change the data extent and indices
	
	  if (this._indices) {
	    var Ctor = this._indices.constructor;
	    list._indices = new Ctor(this._indices);
	  } else {
	    list._indices = null;
	  }
	
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return list;
	};
	/**
	 * Wrap some method to add more feature
	 * @param {string} methodName
	 * @param {Function} injectFunction
	 */
	
	
	listProto.wrapMethod = function (methodName, injectFunction) {
	  var originalMethod = this[methodName];
	
	  if (typeof originalMethod !== 'function') {
	    return;
	  }
	
	  this.__wrappedMethods = this.__wrappedMethods || [];
	
	  this.__wrappedMethods.push(methodName);
	
	  this[methodName] = function () {
	    var res = originalMethod.apply(this, arguments);
	    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
	  };
	}; // Methods that create a new list based on this list should be listed here.
	// Notice that those method should `RETURN` the new list.
	
	
	listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.
	
	listProto.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
	var _default = List;
	module.exports = _default;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var BoundingRect = __webpack_require__(51);
	
	var _text = __webpack_require__(86);
	
	var calculateTextPosition = _text.calculateTextPosition;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Symbol factory
	
	/**
	 * Triangle shape
	 * @inner
	 */
	var Triangle = graphic.extendShape({
	  type: 'triangle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy + height);
	    path.lineTo(cx - width, cy + height);
	    path.closePath();
	  }
	});
	/**
	 * Diamond shape
	 * @inner
	 */
	
	var Diamond = graphic.extendShape({
	  type: 'diamond',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy);
	    path.lineTo(cx, cy + height);
	    path.lineTo(cx - width, cy);
	    path.closePath();
	  }
	});
	/**
	 * Pin shape
	 * @inner
	 */
	
	var Pin = graphic.extendShape({
	  type: 'pin',
	  shape: {
	    // x, y on the cusp
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var x = shape.x;
	    var y = shape.y;
	    var w = shape.width / 5 * 3; // Height must be larger than width
	
	    var h = Math.max(w, shape.height);
	    var r = w / 2; // Dist on y with tangent point and circle center
	
	    var dy = r * r / (h - r);
	    var cy = y - h + r + dy;
	    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
	
	    var dx = Math.cos(angle) * r;
	    var tanX = Math.sin(angle);
	    var tanY = Math.cos(angle);
	    var cpLen = r * 0.6;
	    var cpLen2 = r * 0.7;
	    path.moveTo(x - dx, cy + dy);
	    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
	    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
	    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
	    path.closePath();
	  }
	});
	/**
	 * Arrow shape
	 * @inner
	 */
	
	var Arrow = graphic.extendShape({
	  type: 'arrow',
	  shape: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var height = shape.height;
	    var width = shape.width;
	    var x = shape.x;
	    var y = shape.y;
	    var dx = width / 3 * 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(x + dx, y + height);
	    ctx.lineTo(x, y + height / 4 * 3);
	    ctx.lineTo(x - dx, y + height);
	    ctx.lineTo(x, y);
	    ctx.closePath();
	  }
	});
	/**
	 * Map of path contructors
	 * @type {Object.<string, module:zrender/graphic/Path>}
	 */
	
	var symbolCtors = {
	  line: graphic.Line,
	  rect: graphic.Rect,
	  roundRect: graphic.Rect,
	  square: graphic.Rect,
	  circle: graphic.Circle,
	  diamond: Diamond,
	  pin: Pin,
	  arrow: Arrow,
	  triangle: Triangle
	};
	var symbolShapeMakers = {
	  line: function (x, y, w, h, shape) {
	    // FIXME
	    shape.x1 = x;
	    shape.y1 = y + h / 2;
	    shape.x2 = x + w;
	    shape.y2 = y + h / 2;
	  },
	  rect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	  },
	  roundRect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	    shape.r = Math.min(w, h) / 4;
	  },
	  square: function (x, y, w, h, shape) {
	    var size = Math.min(w, h);
	    shape.x = x;
	    shape.y = y;
	    shape.width = size;
	    shape.height = size;
	  },
	  circle: function (x, y, w, h, shape) {
	    // Put circle in the center of square
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.r = Math.min(w, h) / 2;
	  },
	  diamond: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  pin: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  arrow: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  triangle: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  }
	};
	var symbolBuildProxies = {};
	zrUtil.each(symbolCtors, function (Ctor, name) {
	  symbolBuildProxies[name] = new Ctor();
	});
	var SymbolClz = graphic.extendShape({
	  type: 'symbol',
	  shape: {
	    symbolType: '',
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  calculateTextPosition: function (out, style, rect) {
	    var res = calculateTextPosition(out, style, rect);
	    var shape = this.shape;
	
	    if (shape && shape.symbolType === 'pin' && style.textPosition === 'inside') {
	      res.y = rect.y + rect.height * 0.4;
	    }
	
	    return res;
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    var symbolType = shape.symbolType;
	
	    if (symbolType !== 'none') {
	      var proxySymbol = symbolBuildProxies[symbolType];
	
	      if (!proxySymbol) {
	        // Default rect
	        symbolType = 'rect';
	        proxySymbol = symbolBuildProxies[symbolType];
	      }
	
	      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
	      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
	    }
	  }
	}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
	
	function symbolPathSetColor(color, innerColor) {
	  if (this.type !== 'image') {
	    var symbolStyle = this.style;
	    var symbolShape = this.shape;
	
	    if (symbolShape && symbolShape.symbolType === 'line') {
	      symbolStyle.stroke = color;
	    } else if (this.__isEmptyBrush) {
	      symbolStyle.stroke = color;
	      symbolStyle.fill = innerColor || '#fff';
	    } else {
	      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
	      symbolStyle.fill && (symbolStyle.fill = color);
	      symbolStyle.stroke && (symbolStyle.stroke = color);
	    }
	
	    this.dirty(false);
	  }
	}
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolType
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
	 *                            for path and image only.
	 */
	
	
	function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
	  // TODO Support image object, DynamicImage.
	  var isEmpty = symbolType.indexOf('empty') === 0;
	
	  if (isEmpty) {
	    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
	  }
	
	  var symbolPath;
	
	  if (symbolType.indexOf('image://') === 0) {
	    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else if (symbolType.indexOf('path://') === 0) {
	    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else {
	    symbolPath = new SymbolClz({
	      shape: {
	        symbolType: symbolType,
	        x: x,
	        y: y,
	        width: w,
	        height: h
	      }
	    });
	  }
	
	  symbolPath.__isEmptyBrush = isEmpty;
	  symbolPath.setColor = symbolPathSetColor;
	  symbolPath.setColor(color);
	  return symbolPath;
	}
	
	exports.createSymbol = createSymbol;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(34);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(41);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(53);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(79);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordinateSystemCreators = {};
	
	function CoordinateSystemManager() {
	  this._coordinateSystems = [];
	}
	
	CoordinateSystemManager.prototype = {
	  constructor: CoordinateSystemManager,
	  create: function (ecModel, api) {
	    var coordinateSystems = [];
	    zrUtil.each(coordinateSystemCreators, function (creater, type) {
	      var list = creater.create(ecModel, api);
	      coordinateSystems = coordinateSystems.concat(list || []);
	    });
	    this._coordinateSystems = coordinateSystems;
	  },
	  update: function (ecModel, api) {
	    zrUtil.each(this._coordinateSystems, function (coordSys) {
	      coordSys.update && coordSys.update(ecModel, api);
	    });
	  },
	  getCoordinateSystems: function () {
	    return this._coordinateSystems.slice();
	  }
	};
	
	CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
	  coordinateSystemCreators[type] = coordinateSystemCreator;
	};
	
	CoordinateSystemManager.get = function (type) {
	  return coordinateSystemCreators[type];
	};
	
	var _default = CoordinateSystemManager;
	module.exports = _default;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var OrdinalScale = __webpack_require__(1864);
	
	var IntervalScale = __webpack_require__(273);
	
	var Scale = __webpack_require__(274);
	
	var numberUtil = __webpack_require__(24);
	
	var _barGrid = __webpack_require__(272);
	
	var prepareLayoutBarSeries = _barGrid.prepareLayoutBarSeries;
	var makeColumnLayout = _barGrid.makeColumnLayout;
	var retrieveColumnLayout = _barGrid.retrieveColumnLayout;
	
	var BoundingRect = __webpack_require__(51);
	
	__webpack_require__(1865);
	
	__webpack_require__(855);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Get axis scale extent before niced.
	 * Item of returned array can only be number (including Infinity and NaN).
	 */
	function getScaleExtent(scale, model) {
	  var scaleType = scale.type;
	  var min = model.getMin();
	  var max = model.getMax();
	  var originalExtent = scale.getExtent();
	  var axisDataLen;
	  var boundaryGap;
	  var span;
	
	  if (scaleType === 'ordinal') {
	    axisDataLen = model.getCategories().length;
	  } else {
	    boundaryGap = model.get('boundaryGap');
	
	    if (!zrUtil.isArray(boundaryGap)) {
	      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
	    }
	
	    if (typeof boundaryGap[0] === 'boolean') {
	      boundaryGap = [0, 0];
	    }
	
	    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
	    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
	    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
	  } // Notice: When min/max is not set (that is, when there are null/undefined,
	  // which is the most common case), these cases should be ensured:
	  // (1) For 'ordinal', show all axis.data.
	  // (2) For others:
	  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
	  //      disabled).
	  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
	  //      be the result that originalExtent enlarged by boundaryGap.
	  // (3) If no data, it should be ensured that `scale.setBlank` is set.
	  // FIXME
	  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
	  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
	  // that the results processed by boundaryGap are positive/negative?
	
	
	  if (min === 'dataMin') {
	    min = originalExtent[0];
	  } else if (typeof min === 'function') {
	    min = min({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  if (max === 'dataMax') {
	    max = originalExtent[1];
	  } else if (typeof max === 'function') {
	    max = max({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  var fixMin = min != null;
	  var fixMax = max != null;
	
	  if (min == null) {
	    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
	  }
	
	  if (max == null) {
	    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
	  }
	
	  (min == null || !isFinite(min)) && (min = NaN);
	  (max == null || !isFinite(max)) && (max = NaN);
	  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max) || scaleType === 'ordinal' && !scale.getOrdinalMeta().categories.length); // Evaluate if axis needs cross zero
	
	  if (model.getNeedCrossZero()) {
	    // Axis is over zero and min is not set
	    if (min > 0 && max > 0 && !fixMin) {
	      min = 0;
	    } // Axis is under zero and max is not set
	
	
	    if (min < 0 && max < 0 && !fixMax) {
	      max = 0;
	    }
	  } // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
	  // is base axis
	  // FIXME
	  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
	  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
	  //     Should not depend on series type `bar`?
	  // (3) Fix that might overlap when using dataZoom.
	  // (4) Consider other chart types using `barGrid`?
	  // See #6728, #4862, `test/bar-overflow-time-plot.html`
	
	
	  var ecModel = model.ecModel;
	
	  if (ecModel && scaleType === 'time'
	  /*|| scaleType === 'interval' */
	  ) {
	    var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
	    var isBaseAxisAndHasBarSeries;
	    zrUtil.each(barSeriesModels, function (seriesModel) {
	      isBaseAxisAndHasBarSeries |= seriesModel.getBaseAxis() === model.axis;
	    });
	
	    if (isBaseAxisAndHasBarSeries) {
	      // Calculate placement of bars on axis
	      var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow
	
	      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
	      min = adjustedScale.min;
	      max = adjustedScale.max;
	    }
	  }
	
	  return {
	    extent: [min, max],
	    // "fix" means "fixed", the value should not be
	    // changed in the subsequent steps.
	    fixMin: fixMin,
	    fixMax: fixMax
	  };
	}
	
	function adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
	  // Get Axis Length
	  var axisExtent = model.axis.getExtent();
	  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
	
	  var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);
	
	  if (barsOnCurrentAxis === undefined) {
	    return {
	      min: min,
	      max: max
	    };
	  }
	
	  var minOverflow = Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    minOverflow = Math.min(item.offset, minOverflow);
	  });
	  var maxOverflow = -Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
	  });
	  minOverflow = Math.abs(minOverflow);
	  maxOverflow = Math.abs(maxOverflow);
	  var totalOverFlow = minOverflow + maxOverflow; // Calulate required buffer based on old range and overflow
	
	  var oldRange = max - min;
	  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
	  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
	  max += overflowBuffer * (maxOverflow / totalOverFlow);
	  min -= overflowBuffer * (minOverflow / totalOverFlow);
	  return {
	    min: min,
	    max: max
	  };
	}
	
	function niceScaleExtent(scale, model) {
	  var extentInfo = getScaleExtent(scale, model);
	  var extent = extentInfo.extent;
	  var splitNumber = model.get('splitNumber');
	
	  if (scale.type === 'log') {
	    scale.base = model.get('logBase');
	  }
	
	  var scaleType = scale.type;
	  scale.setExtent(extent[0], extent[1]);
	  scale.niceExtent({
	    splitNumber: splitNumber,
	    fixMin: extentInfo.fixMin,
	    fixMax: extentInfo.fixMax,
	    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
	    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
	  }); // If some one specified the min, max. And the default calculated interval
	  // is not good enough. He can specify the interval. It is often appeared
	  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
	  // to be 60.
	  // FIXME
	
	  var interval = model.get('interval');
	
	  if (interval != null) {
	    scale.setInterval && scale.setInterval(interval);
	  }
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @param {string} [axisType] Default retrieve from model.type
	 * @return {module:echarts/scale/*}
	 */
	
	
	function createScaleByModel(model, axisType) {
	  axisType = axisType || model.get('type');
	
	  if (axisType) {
	    switch (axisType) {
	      // Buildin scale
	      case 'category':
	        return new OrdinalScale(model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(), [Infinity, -Infinity]);
	
	      case 'value':
	        return new IntervalScale();
	      // Extended scale, like time and log
	
	      default:
	        return (Scale.getClass(axisType) || IntervalScale).create(model);
	    }
	  }
	}
	/**
	 * Check if the axis corss 0
	 */
	
	
	function ifAxisCrossZero(axis) {
	  var dataExtent = axis.scale.getExtent();
	  var min = dataExtent[0];
	  var max = dataExtent[1];
	  return !(min > 0 && max > 0 || min < 0 && max < 0);
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {Function} Label formatter function.
	 *         param: {number} tickValue,
	 *         param: {number} idx, the index in all ticks.
	 *                         If category axis, this param is not requied.
	 *         return: {string} label string.
	 */
	
	
	function makeLabelFormatter(axis) {
	  var labelFormatter = axis.getLabelModel().get('formatter');
	  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
	
	  if (typeof labelFormatter === 'string') {
	    labelFormatter = function (tpl) {
	      return function (val) {
	        // For category axis, get raw value; for numeric axis,
	        // get foramtted label like '1,333,444'.
	        val = axis.scale.getLabel(val);
	        return tpl.replace('{value}', val != null ? val : '');
	      };
	    }(labelFormatter); // Consider empty array
	
	
	    return labelFormatter;
	  } else if (typeof labelFormatter === 'function') {
	    return function (tickValue, idx) {
	      // The original intention of `idx` is "the index of the tick in all ticks".
	      // But the previous implementation of category axis do not consider the
	      // `axisLabel.interval`, which cause that, for example, the `interval` is
	      // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
	      // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
	      // the definition here for back compatibility.
	      if (categoryTickStart != null) {
	        idx = tickValue - categoryTickStart;
	      }
	
	      return labelFormatter(getAxisRawValue(axis, tickValue), idx);
	    };
	  } else {
	    return function (tick) {
	      return axis.scale.getLabel(tick);
	    };
	  }
	}
	
	function getAxisRawValue(axis, value) {
	  // In category axis with data zoom, tick is not the original
	  // index of axis.data. So tick should not be exposed to user
	  // in category axis.
	  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
	 */
	
	
	function estimateLabelUnionRect(axis) {
	  var axisModel = axis.model;
	  var scale = axis.scale;
	
	  if (!axisModel.get('axisLabel.show') || scale.isBlank()) {
	    return;
	  }
	
	  var isCategory = axis.type === 'category';
	  var realNumberScaleTicks;
	  var tickCount;
	  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
	
	  if (isCategory) {
	    tickCount = scale.count();
	  } else {
	    realNumberScaleTicks = scale.getTicks();
	    tickCount = realNumberScaleTicks.length;
	  }
	
	  var axisLabelModel = axis.getLabelModel();
	  var labelFormatter = makeLabelFormatter(axis);
	  var rect;
	  var step = 1; // Simple optimization for large amount of labels
	
	  if (tickCount > 40) {
	    step = Math.ceil(tickCount / 40);
	  }
	
	  for (var i = 0; i < tickCount; i += step) {
	    var tickValue = realNumberScaleTicks ? realNumberScaleTicks[i] : categoryScaleExtent[0] + i;
	    var label = labelFormatter(tickValue);
	    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
	    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
	    rect ? rect.union(singleRect) : rect = singleRect;
	  }
	
	  return rect;
	}
	
	function rotateTextRect(textRect, rotate) {
	  var rotateRadians = rotate * Math.PI / 180;
	  var boundingBox = textRect.plain();
	  var beforeWidth = boundingBox.width;
	  var beforeHeight = boundingBox.height;
	  var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
	  var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
	  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
	  return rotatedRect;
	}
	/**
	 * @param {module:echarts/src/model/Model} model axisLabelModel or axisTickModel
	 * @return {number|String} Can be null|'auto'|number|function
	 */
	
	
	function getOptionCategoryInterval(model) {
	  var interval = model.get('interval');
	  return interval == null ? 'auto' : interval;
	}
	/**
	 * Set `categoryInterval` as 0 implicitly indicates that
	 * show all labels reguardless of overlap.
	 * @param {Object} axis axisModel.axis
	 * @return {boolean}
	 */
	
	
	function shouldShowAllLabels(axis) {
	  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
	}
	
	exports.getScaleExtent = getScaleExtent;
	exports.niceScaleExtent = niceScaleExtent;
	exports.createScaleByModel = createScaleByModel;
	exports.ifAxisCrossZero = ifAxisCrossZero;
	exports.makeLabelFormatter = makeLabelFormatter;
	exports.getAxisRawValue = getAxisRawValue;
	exports.estimateLabelUnionRect = estimateLabelUnionRect;
	exports.getOptionCategoryInterval = getOptionCategoryInterval;
	exports.shouldShowAllLabels = shouldShowAllLabels;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(178);
	var compressions = __webpack_require__(435);
	var nodeBuffer = __webpack_require__(436);
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer, mimeType) {
	    exports.checkSupport("blob");
		mimeType = mimeType || 'application/zip';
	
	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: mimeType
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob(mimeType);
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }
	
	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	exports.extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isvalidColorString = exports.red = exports.getContrastingColor = exports.isValidHex = exports.toState = exports.simpleCheckForValidColor = undefined;
	
	var _each = __webpack_require__(1903);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _tinycolor = __webpack_require__(2103);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var simpleCheckForValidColor = exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
	  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
	  var checked = 0;
	  var passed = 0;
	  (0, _each2.default)(keysToCheck, function (letter) {
	    if (data[letter]) {
	      checked += 1;
	      if (!isNaN(data[letter])) {
	        passed += 1;
	      }
	      if (letter === 's' || letter === 'l') {
	        var percentPatt = /^\d+%$/;
	        if (percentPatt.test(data[letter])) {
	          passed += 1;
	        }
	      }
	    }
	  });
	  return checked === passed ? data : false;
	};
	
	var toState = exports.toState = function toState(data, oldHue) {
	  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	  var hsl = color.toHsl();
	  var hsv = color.toHsv();
	  var rgb = color.toRgb();
	  var hex = color.toHex();
	  if (hsl.s === 0) {
	    hsl.h = oldHue || 0;
	    hsv.h = oldHue || 0;
	  }
	  var transparent = hex === '000000' && rgb.a === 0;
	
	  return {
	    hsl: hsl,
	    hex: transparent ? 'transparent' : '#' + hex,
	    rgb: rgb,
	    hsv: hsv,
	    oldHue: data.h || oldHue || hsl.h,
	    source: data.source
	  };
	};
	
	var isValidHex = exports.isValidHex = function isValidHex(hex) {
	  if (hex === 'transparent') {
	    return true;
	  }
	  // disable hex4 and hex8
	  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
	  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
	};
	
	var getContrastingColor = exports.getContrastingColor = function getContrastingColor(data) {
	  if (!data) {
	    return '#fff';
	  }
	  var col = toState(data);
	  if (col.hex === 'transparent') {
	    return 'rgba(0,0,0,0.4)';
	  }
	  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
	  return yiq >= 128 ? '#000' : '#fff';
	};
	
	var red = exports.red = {
	  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
	  hex: '#ff0000',
	  rgb: { r: 255, g: 0, b: 0, a: 1 },
	  hsv: { h: 0, s: 1, v: 1, a: 1 }
	};
	
	var isvalidColorString = exports.isvalidColorString = function isvalidColorString(string, type) {
	  var stringWithoutDegree = string.replace('°', '');
	  return (0, _tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
	};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(119);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(53);
	
	var CallbackQueue = __webpack_require__(769);
	var PooledClass = __webpack_require__(139);
	var ReactFeatureFlags = __webpack_require__(774);
	var ReactReconciler = __webpack_require__(167);
	var Transaction = __webpack_require__(262);
	
	var invariant = __webpack_require__(32);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function initialize() {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function close() {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function initialize() {
	    this.callbackQueue.reset();
	  },
	  close: function close() {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function getTransactionWrappers() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function destructor() {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function perform(method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function flushBatchedUpdates() {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function injectReconcileTransaction(ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function injectBatchingStrategy(_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	var isString = _util.isString;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Note that it is too complicated to support 3d stack by value
	 * (have to create two-dimension inverted index), so in 3d case
	 * we just support that stacked by index.
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
	 *        The input dimensionInfoList will be modified.
	 * @param {Object} [opt]
	 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
	 * @param {boolean} [opt.byIndex=false]
	 * @return {Object} calculationInfo
	 * {
	 *     stackedDimension: string
	 *     stackedByDimension: string
	 *     isStackedByIndex: boolean
	 *     stackedOverDimension: string
	 *     stackResultDimension: string
	 * }
	 */
	function enableDataStack(seriesModel, dimensionInfoList, opt) {
	  opt = opt || {};
	  var byIndex = opt.byIndex;
	  var stackedCoordDimension = opt.stackedCoordDimension; // Compatibal: when `stack` is set as '', do not stack.
	
	  var mayStack = !!(seriesModel && seriesModel.get('stack'));
	  var stackedByDimInfo;
	  var stackedDimInfo;
	  var stackResultDimension;
	  var stackedOverDimension;
	  each(dimensionInfoList, function (dimensionInfo, index) {
	    if (isString(dimensionInfo)) {
	      dimensionInfoList[index] = dimensionInfo = {
	        name: dimensionInfo
	      };
	    }
	
	    if (mayStack && !dimensionInfo.isExtraCoord) {
	      // Find the first ordinal dimension as the stackedByDimInfo.
	      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
	        stackedByDimInfo = dimensionInfo;
	      } // Find the first stackable dimension as the stackedDimInfo.
	
	
	      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
	        stackedDimInfo = dimensionInfo;
	      }
	    }
	  });
	
	  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
	    // Compatible with previous design, value axis (time axis) only stack by index.
	    // It may make sense if the user provides elaborately constructed data.
	    byIndex = true;
	  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
	  // That put stack logic in List is for using conveniently in echarts extensions, but it
	  // might not be a good way.
	
	
	  if (stackedDimInfo) {
	    // Use a weird name that not duplicated with other names.
	    stackResultDimension = '__\0ecstackresult';
	    stackedOverDimension = '__\0ecstackedover'; // Create inverted index to fast query index by value.
	
	    if (stackedByDimInfo) {
	      stackedByDimInfo.createInvertedIndices = true;
	    }
	
	    var stackedDimCoordDim = stackedDimInfo.coordDim;
	    var stackedDimType = stackedDimInfo.type;
	    var stackedDimCoordIndex = 0;
	    each(dimensionInfoList, function (dimensionInfo) {
	      if (dimensionInfo.coordDim === stackedDimCoordDim) {
	        stackedDimCoordIndex++;
	      }
	    });
	    dimensionInfoList.push({
	      name: stackResultDimension,
	      coordDim: stackedDimCoordDim,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	    stackedDimCoordIndex++;
	    dimensionInfoList.push({
	      name: stackedOverDimension,
	      // This dimension contains stack base (generally, 0), so do not set it as
	      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
	      coordDim: stackedOverDimension,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	  }
	
	  return {
	    stackedDimension: stackedDimInfo && stackedDimInfo.name,
	    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
	    isStackedByIndex: byIndex,
	    stackedOverDimension: stackedOverDimension,
	    stackResultDimension: stackResultDimension
	  };
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} stackedDim
	 */
	
	
	function isDimensionStacked(data, stackedDim
	/*, stackedByDim*/
	) {
	  // Each single series only maps to one pair of axis. So we do not need to
	  // check stackByDim, whatever stacked by a dimension or stacked by index.
	  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension'); // && (
	  //     stackedByDim != null
	  //         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
	  //         : data.getCalculationInfo('isStackedByIndex')
	  // );
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} targetDim
	 * @param {string} [stackedByDim] If not input this parameter, check whether
	 *                                stacked by index.
	 * @return {string} dimension
	 */
	
	
	function getStackedDimension(data, targetDim) {
	  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
	}
	
	exports.enableDataStack = enableDataStack;
	exports.isDimensionStacked = isDimensionStacked;
	exports.getStackedDimension = getStackedDimension;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	
	var Group = __webpack_require__(146);
	
	var componentUtil = __webpack_require__(224);
	
	var clazzUtil = __webpack_require__(115);
	
	var modelUtil = __webpack_require__(27);
	
	var graphicUtil = __webpack_require__(17);
	
	var _task = __webpack_require__(433);
	
	var createTask = _task.createTask;
	
	var createRenderPlanner = __webpack_require__(171);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var renderPlanner = createRenderPlanner();
	
	function Chart() {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewChart');
	  this.renderTask = createTask({
	    plan: renderTaskPlan,
	    reset: renderTaskReset
	  });
	  this.renderTask.context = {
	    view: this
	  };
	}
	
	Chart.prototype = {
	  type: 'chart',
	
	  /**
	   * Init the chart.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {},
	
	  /**
	   * Render the chart.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  render: function (seriesModel, ecModel, api, payload) {},
	
	  /**
	   * Highlight series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  highlight: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
	  },
	
	  /**
	   * Downplay series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  downplay: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'normal');
	  },
	
	  /**
	   * Remove self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  remove: function (ecModel, api) {
	    this.group.removeAll();
	  },
	
	  /**
	   * Dispose self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  dispose: function () {},
	
	  /**
	   * Rendering preparation in progressive mode.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalPrepareRender: null,
	
	  /**
	   * Render in progressive mode.
	   * @param  {Object} params See taskParams in `stream/task.js`
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalRender: null,
	
	  /**
	   * Update transform directly.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   * @return {Object} {update: true}
	   */
	  updateTransform: null,
	
	  /**
	   * The view contains the given point.
	   * @interface
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  // containPoint: function () {}
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var chartProto = Chart.prototype;
	
	chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
	  this.render(seriesModel, ecModel, api, payload);
	};
	/**
	 * Set state of single element
	 * @param {module:zrender/Element} el
	 * @param {string} state 'normal'|'emphasis'
	 * @param {number} highlightDigit
	 */
	
	
	function elSetState(el, state, highlightDigit) {
	  if (el) {
	    el.trigger(state, highlightDigit);
	
	    if (el.isGroup // Simple optimize.
	    && !graphicUtil.isHighDownDispatcher(el)) {
	      for (var i = 0, len = el.childCount(); i < len; i++) {
	        elSetState(el.childAt(i), state, highlightDigit);
	      }
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload
	 * @param {string} state 'normal'|'emphasis'
	 */
	
	
	function toggleHighlight(data, payload, state) {
	  var dataIndex = modelUtil.queryDataIndex(data, payload);
	  var highlightDigit = payload && payload.highlightKey != null ? graphicUtil.getHighlightDigit(payload.highlightKey) : null;
	
	  if (dataIndex != null) {
	    each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
	      elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
	    });
	  } else {
	    data.eachItemGraphicEl(function (el) {
	      elSetState(el, state, highlightDigit);
	    });
	  }
	} // Enable Chart.extend.
	
	
	clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Chart, {
	  registerWhenExtend: true
	});
	
	Chart.markUpdateMethod = function (payload, methodName) {
	  inner(payload).updateMethod = methodName;
	};
	
	function renderTaskPlan(context) {
	  return renderPlanner(context.model);
	}
	
	function renderTaskReset(context) {
	  var seriesModel = context.model;
	  var ecModel = context.ecModel;
	  var api = context.api;
	  var payload = context.payload; // ???! remove updateView updateVisual
	
	  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
	  var view = context.view;
	  var updateMethod = payload && inner(payload).updateMethod;
	  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
	  // is less than progressive threshold.
	  : 'render';
	
	  if (methodName !== 'render') {
	    view[methodName](seriesModel, ecModel, api, payload);
	  }
	
	  return progressMethodMap[methodName];
	}
	
	var progressMethodMap = {
	  incrementalPrepareRender: {
	    progress: function (params, context) {
	      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
	    }
	  },
	  render: {
	    // Put view.render in `progress` to support appendData. But in this case
	    // view.render should not be called in reset, otherwise it will be called
	    // twise. Use `forceFirstProgress` to make sure that view.render is called
	    // in any cases.
	    forceFirstProgress: true,
	    progress: function (params, context) {
	      context.view.render(context.model, context.ecModel, context.api, context.payload);
	    }
	  }
	};
	var _default = Chart;
	module.exports = _default;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var Eventful = __webpack_require__(148);
	
	exports.Dispatcher = Eventful;
	
	var env = __webpack_require__(58);
	
	var _dom = __webpack_require__(903);
	
	var isCanvasEl = _dom.isCanvasEl;
	var transformCoordWithViewport = _dom.transformCoordWithViewport;
	
	/**
	 * Utilities for mouse or touch events.
	 */
	var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
	var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
	var _calcOut = [];
	/**
	 * Get the `zrX` and `zrY`, which are relative to the top-left of
	 * the input `el`.
	 * CSS transform (2D & 3D) is supported.
	 *
	 * The strategy to fetch the coords:
	 * + If `calculate` is not set as `true`, users of this method should
	 * ensure that `el` is the same or the same size & location as `e.target`.
	 * Otherwise the result coords are probably not expected. Because we
	 * firstly try to get coords from e.offsetX/e.offsetY.
	 * + If `calculate` is set as `true`, the input `el` can be any element
	 * and we force to calculate the coords based on `el`.
	 * + The input `el` should be positionable (not position:static).
	 *
	 * The force `calculate` can be used in case like:
	 * When mousemove event triggered on ec tooltip, `e.target` is not `el`(zr painter.dom).
	 *
	 * @param {HTMLElement} el DOM element.
	 * @param {Event} e Mouse event or touch event.
	 * @param {Object} out Get `out.zrX` and `out.zrY` as the result.
	 * @param {boolean} [calculate=false] Whether to force calculate
	 *        the coordinates but not use ones provided by browser.
	 */
	
	function clientToLocal(el, e, out, calculate) {
	  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
	  // to the padding edge of the target element. The only browser using this convention
	  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
	  // not support the properties.
	  // (see http://www.jacklmoore.com/notes/mouse-position/)
	  // In zr painter.dom, padding edge equals to border edge.
	
	  if (calculate || !env.canvasSupported) {
	    calculateZrXY(el, e, out);
	  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
	  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
	  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
	  // zoom-factor, overflow / opacity layers, transforms ...)
	  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
	  // <https://bugs.jquery.com/ticket/8523#comment:14>
	  // BTW3, In ff, offsetX/offsetY is always 0.
	  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
	      out.zrX = e.layerX;
	      out.zrY = e.layerY;
	    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
	    else if (e.offsetX != null) {
	        out.zrX = e.offsetX;
	        out.zrY = e.offsetY;
	      } // For some other device, e.g., IOS safari.
	      else {
	          calculateZrXY(el, e, out);
	        }
	
	  return out;
	}
	
	function calculateZrXY(el, e, out) {
	  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect.
	  if (env.domSupported && el.getBoundingClientRect) {
	    var ex = e.clientX;
	    var ey = e.clientY;
	
	    if (isCanvasEl(el)) {
	      // Original approach, which do not support CSS transform.
	      // marker can not be locationed in a canvas container
	      // (getBoundingClientRect is always 0). We do not support
	      // that input a pre-created canvas to zr while using css
	      // transform in iOS.
	      var box = el.getBoundingClientRect();
	      out.zrX = ex - box.left;
	      out.zrY = ey - box.top;
	      return;
	    } else {
	      if (transformCoordWithViewport(_calcOut, el, ex, ey)) {
	        out.zrX = _calcOut[0];
	        out.zrY = _calcOut[1];
	        return;
	      }
	    }
	  }
	
	  out.zrX = out.zrY = 0;
	}
	/**
	 * Find native event compat for legency IE.
	 * Should be called at the begining of a native event listener.
	 *
	 * @param {Event} [e] Mouse event or touch event or pointer event.
	 *        For lagency IE, we use `window.event` is used.
	 * @return {Event} The native event.
	 */
	
	
	function getNativeEvent(e) {
	  return e || window.event;
	}
	/**
	 * Normalize the coordinates of the input event.
	 *
	 * Get the `e.zrX` and `e.zrY`, which are relative to the top-left of
	 * the input `el`.
	 * Get `e.zrDelta` if using mouse wheel.
	 * Get `e.which`, see the comment inside this function.
	 *
	 * Do not calculate repeatly if `zrX` and `zrY` already exist.
	 *
	 * Notice: see comments in `clientToLocal`. check the relationship
	 * between the result coords and the parameters `el` and `calculate`.
	 *
	 * @param {HTMLElement} el DOM element.
	 * @param {Event} [e] See `getNativeEvent`.
	 * @param {boolean} [calculate=false] Whether to force calculate
	 *        the coordinates but not use ones provided by browser.
	 * @return {UIEvent} The normalized native UIEvent.
	 */
	
	
	function normalizeEvent(el, e, calculate) {
	  e = getNativeEvent(e);
	
	  if (e.zrX != null) {
	    return e;
	  }
	
	  var eventType = e.type;
	  var isTouch = eventType && eventType.indexOf('touch') >= 0;
	
	  if (!isTouch) {
	    clientToLocal(el, e, e, calculate);
	    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
	  } else {
	    var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
	    touch && clientToLocal(el, touch, e, calculate);
	  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
	  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
	  // If e.which has been defined, it may be readonly,
	  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
	
	
	  var button = e.button;
	
	  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
	    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
	  } // [Caution]: `e.which` from browser is not always reliable. For example,
	  // when press left button and `mousemove (pointermove)` in Edge, the `e.which`
	  // is 65536 and the `e.button` is -1. But the `mouseup (pointerup)` and
	  // `mousedown (pointerdown)` is the same as Chrome does.
	
	
	  return e;
	}
	/**
	 * @param {HTMLElement} el
	 * @param {string} name
	 * @param {Function} handler
	 * @param {Object|boolean} opt If boolean, means `opt.capture`
	 * @param {boolean} [opt.capture=false]
	 * @param {boolean} [opt.passive=false]
	 */
	
	
	function addEventListener(el, name, handler, opt) {
	  if (isDomLevel2) {
	    // Reproduct the console warning:
	    // [Violation] Added non-passive event listener to a scroll-blocking <some> event.
	    // Consider marking event handler as 'passive' to make the page more responsive.
	    // Just set console log level: verbose in chrome dev tool.
	    // then the warning log will be printed when addEventListener called.
	    // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	    // We have not yet found a neat way to using passive. Because in zrender the dom event
	    // listener delegate all of the upper events of element. Some of those events need
	    // to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
	    // Before passive can be adopted, these issues should be considered:
	    // (1) Whether and how a zrender user specifies an event listener passive. And by default,
	    // passive or not.
	    // (2) How to tread that some zrender event listener is passive, and some is not. If
	    // we use other way but not preventDefault of mousewheel and touchmove, browser
	    // compatibility should be handled.
	    // var opts = (env.passiveSupported && name === 'mousewheel')
	    //     ? {passive: true}
	    //     // By default, the third param of el.addEventListener is `capture: false`.
	    //     : void 0;
	    // el.addEventListener(name, handler /* , opts */);
	    el.addEventListener(name, handler, opt);
	  } else {
	    // For simplicity, do not implement `setCapture` for IE9-.
	    el.attachEvent('on' + name, handler);
	  }
	}
	/**
	 * Parameter are the same as `addEventListener`.
	 *
	 * Notice that if a listener is registered twice, one with capture and one without,
	 * remove each one separately. Removal of a capturing listener does not affect a
	 * non-capturing version of the same listener, and vice versa.
	 */
	
	
	function removeEventListener(el, name, handler, opt) {
	  if (isDomLevel2) {
	    el.removeEventListener(name, handler, opt);
	  } else {
	    el.detachEvent('on' + name, handler);
	  }
	}
	/**
	 * preventDefault and stopPropagation.
	 * Notice: do not use this method in zrender. It can only be
	 * used by upper applications if necessary.
	 *
	 * @param {Event} e A mouse or touch event.
	 */
	
	
	var stop = isDomLevel2 ? function (e) {
	  e.preventDefault();
	  e.stopPropagation();
	  e.cancelBubble = true;
	} : function (e) {
	  e.returnValue = false;
	  e.cancelBubble = true;
	};
	/**
	 * This method only works for mouseup and mousedown. The functionality is restricted
	 * for fault tolerance, See the `e.which` compatibility above.
	 *
	 * @param {MouseEvent} e
	 * @return {boolean}
	 */
	
	function isMiddleOrRightButtonOnMouseUpDown(e) {
	  return e.which === 2 || e.which === 3;
	}
	/**
	 * To be removed.
	 * @deprecated
	 */
	
	
	function notLeftMouse(e) {
	  // If e.which is undefined, considered as left mouse event.
	  return e.which > 1;
	} // For backward compatibility
	
	
	exports.clientToLocal = clientToLocal;
	exports.getNativeEvent = getNativeEvent;
	exports.normalizeEvent = normalizeEvent;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.stop = stop;
	exports.isMiddleOrRightButtonOnMouseUpDown = isMiddleOrRightButtonOnMouseUpDown;
	exports.notLeftMouse = notLeftMouse;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(902);
	
	var kCSSColorTable = {
	  'transparent': [0, 0, 0, 0],
	  'aliceblue': [240, 248, 255, 1],
	  'antiquewhite': [250, 235, 215, 1],
	  'aqua': [0, 255, 255, 1],
	  'aquamarine': [127, 255, 212, 1],
	  'azure': [240, 255, 255, 1],
	  'beige': [245, 245, 220, 1],
	  'bisque': [255, 228, 196, 1],
	  'black': [0, 0, 0, 1],
	  'blanchedalmond': [255, 235, 205, 1],
	  'blue': [0, 0, 255, 1],
	  'blueviolet': [138, 43, 226, 1],
	  'brown': [165, 42, 42, 1],
	  'burlywood': [222, 184, 135, 1],
	  'cadetblue': [95, 158, 160, 1],
	  'chartreuse': [127, 255, 0, 1],
	  'chocolate': [210, 105, 30, 1],
	  'coral': [255, 127, 80, 1],
	  'cornflowerblue': [100, 149, 237, 1],
	  'cornsilk': [255, 248, 220, 1],
	  'crimson': [220, 20, 60, 1],
	  'cyan': [0, 255, 255, 1],
	  'darkblue': [0, 0, 139, 1],
	  'darkcyan': [0, 139, 139, 1],
	  'darkgoldenrod': [184, 134, 11, 1],
	  'darkgray': [169, 169, 169, 1],
	  'darkgreen': [0, 100, 0, 1],
	  'darkgrey': [169, 169, 169, 1],
	  'darkkhaki': [189, 183, 107, 1],
	  'darkmagenta': [139, 0, 139, 1],
	  'darkolivegreen': [85, 107, 47, 1],
	  'darkorange': [255, 140, 0, 1],
	  'darkorchid': [153, 50, 204, 1],
	  'darkred': [139, 0, 0, 1],
	  'darksalmon': [233, 150, 122, 1],
	  'darkseagreen': [143, 188, 143, 1],
	  'darkslateblue': [72, 61, 139, 1],
	  'darkslategray': [47, 79, 79, 1],
	  'darkslategrey': [47, 79, 79, 1],
	  'darkturquoise': [0, 206, 209, 1],
	  'darkviolet': [148, 0, 211, 1],
	  'deeppink': [255, 20, 147, 1],
	  'deepskyblue': [0, 191, 255, 1],
	  'dimgray': [105, 105, 105, 1],
	  'dimgrey': [105, 105, 105, 1],
	  'dodgerblue': [30, 144, 255, 1],
	  'firebrick': [178, 34, 34, 1],
	  'floralwhite': [255, 250, 240, 1],
	  'forestgreen': [34, 139, 34, 1],
	  'fuchsia': [255, 0, 255, 1],
	  'gainsboro': [220, 220, 220, 1],
	  'ghostwhite': [248, 248, 255, 1],
	  'gold': [255, 215, 0, 1],
	  'goldenrod': [218, 165, 32, 1],
	  'gray': [128, 128, 128, 1],
	  'green': [0, 128, 0, 1],
	  'greenyellow': [173, 255, 47, 1],
	  'grey': [128, 128, 128, 1],
	  'honeydew': [240, 255, 240, 1],
	  'hotpink': [255, 105, 180, 1],
	  'indianred': [205, 92, 92, 1],
	  'indigo': [75, 0, 130, 1],
	  'ivory': [255, 255, 240, 1],
	  'khaki': [240, 230, 140, 1],
	  'lavender': [230, 230, 250, 1],
	  'lavenderblush': [255, 240, 245, 1],
	  'lawngreen': [124, 252, 0, 1],
	  'lemonchiffon': [255, 250, 205, 1],
	  'lightblue': [173, 216, 230, 1],
	  'lightcoral': [240, 128, 128, 1],
	  'lightcyan': [224, 255, 255, 1],
	  'lightgoldenrodyellow': [250, 250, 210, 1],
	  'lightgray': [211, 211, 211, 1],
	  'lightgreen': [144, 238, 144, 1],
	  'lightgrey': [211, 211, 211, 1],
	  'lightpink': [255, 182, 193, 1],
	  'lightsalmon': [255, 160, 122, 1],
	  'lightseagreen': [32, 178, 170, 1],
	  'lightskyblue': [135, 206, 250, 1],
	  'lightslategray': [119, 136, 153, 1],
	  'lightslategrey': [119, 136, 153, 1],
	  'lightsteelblue': [176, 196, 222, 1],
	  'lightyellow': [255, 255, 224, 1],
	  'lime': [0, 255, 0, 1],
	  'limegreen': [50, 205, 50, 1],
	  'linen': [250, 240, 230, 1],
	  'magenta': [255, 0, 255, 1],
	  'maroon': [128, 0, 0, 1],
	  'mediumaquamarine': [102, 205, 170, 1],
	  'mediumblue': [0, 0, 205, 1],
	  'mediumorchid': [186, 85, 211, 1],
	  'mediumpurple': [147, 112, 219, 1],
	  'mediumseagreen': [60, 179, 113, 1],
	  'mediumslateblue': [123, 104, 238, 1],
	  'mediumspringgreen': [0, 250, 154, 1],
	  'mediumturquoise': [72, 209, 204, 1],
	  'mediumvioletred': [199, 21, 133, 1],
	  'midnightblue': [25, 25, 112, 1],
	  'mintcream': [245, 255, 250, 1],
	  'mistyrose': [255, 228, 225, 1],
	  'moccasin': [255, 228, 181, 1],
	  'navajowhite': [255, 222, 173, 1],
	  'navy': [0, 0, 128, 1],
	  'oldlace': [253, 245, 230, 1],
	  'olive': [128, 128, 0, 1],
	  'olivedrab': [107, 142, 35, 1],
	  'orange': [255, 165, 0, 1],
	  'orangered': [255, 69, 0, 1],
	  'orchid': [218, 112, 214, 1],
	  'palegoldenrod': [238, 232, 170, 1],
	  'palegreen': [152, 251, 152, 1],
	  'paleturquoise': [175, 238, 238, 1],
	  'palevioletred': [219, 112, 147, 1],
	  'papayawhip': [255, 239, 213, 1],
	  'peachpuff': [255, 218, 185, 1],
	  'peru': [205, 133, 63, 1],
	  'pink': [255, 192, 203, 1],
	  'plum': [221, 160, 221, 1],
	  'powderblue': [176, 224, 230, 1],
	  'purple': [128, 0, 128, 1],
	  'red': [255, 0, 0, 1],
	  'rosybrown': [188, 143, 143, 1],
	  'royalblue': [65, 105, 225, 1],
	  'saddlebrown': [139, 69, 19, 1],
	  'salmon': [250, 128, 114, 1],
	  'sandybrown': [244, 164, 96, 1],
	  'seagreen': [46, 139, 87, 1],
	  'seashell': [255, 245, 238, 1],
	  'sienna': [160, 82, 45, 1],
	  'silver': [192, 192, 192, 1],
	  'skyblue': [135, 206, 235, 1],
	  'slateblue': [106, 90, 205, 1],
	  'slategray': [112, 128, 144, 1],
	  'slategrey': [112, 128, 144, 1],
	  'snow': [255, 250, 250, 1],
	  'springgreen': [0, 255, 127, 1],
	  'steelblue': [70, 130, 180, 1],
	  'tan': [210, 180, 140, 1],
	  'teal': [0, 128, 128, 1],
	  'thistle': [216, 191, 216, 1],
	  'tomato': [255, 99, 71, 1],
	  'turquoise': [64, 224, 208, 1],
	  'violet': [238, 130, 238, 1],
	  'wheat': [245, 222, 179, 1],
	  'white': [255, 255, 255, 1],
	  'whitesmoke': [245, 245, 245, 1],
	  'yellow': [255, 255, 0, 1],
	  'yellowgreen': [154, 205, 50, 1]
	};
	
	function clampCssByte(i) {
	  // Clamp to integer 0 .. 255.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 255 ? 255 : i;
	}
	
	function clampCssAngle(i) {
	  // Clamp to integer 0 .. 360.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 360 ? 360 : i;
	}
	
	function clampCssFloat(f) {
	  // Clamp to float 0.0 .. 1.0.
	  return f < 0 ? 0 : f > 1 ? 1 : f;
	}
	
	function parseCssInt(str) {
	  // int or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssByte(parseFloat(str) / 100 * 255);
	  }
	
	  return clampCssByte(parseInt(str, 10));
	}
	
	function parseCssFloat(str) {
	  // float or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssFloat(parseFloat(str) / 100);
	  }
	
	  return clampCssFloat(parseFloat(str));
	}
	
	function cssHueToRgb(m1, m2, h) {
	  if (h < 0) {
	    h += 1;
	  } else if (h > 1) {
	    h -= 1;
	  }
	
	  if (h * 6 < 1) {
	    return m1 + (m2 - m1) * h * 6;
	  }
	
	  if (h * 2 < 1) {
	    return m2;
	  }
	
	  if (h * 3 < 2) {
	    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
	  }
	
	  return m1;
	}
	
	function lerpNumber(a, b, p) {
	  return a + (b - a) * p;
	}
	
	function setRgba(out, r, g, b, a) {
	  out[0] = r;
	  out[1] = g;
	  out[2] = b;
	  out[3] = a;
	  return out;
	}
	
	function copyRgba(out, a) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  return out;
	}
	
	var colorCache = new LRU(20);
	var lastRemovedArr = null;
	
	function putToCache(colorStr, rgbaArr) {
	  // Reuse removed array
	  if (lastRemovedArr) {
	    copyRgba(lastRemovedArr, rgbaArr);
	  }
	
	  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
	}
	/**
	 * @param {string} colorStr
	 * @param {Array.<number>} out
	 * @return {Array.<number>}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function parse(colorStr, rgbaArr) {
	  if (!colorStr) {
	    return;
	  }
	
	  rgbaArr = rgbaArr || [];
	  var cached = colorCache.get(colorStr);
	
	  if (cached) {
	    return copyRgba(rgbaArr, cached);
	  } // colorStr may be not string
	
	
	  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.
	
	  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.
	
	  if (str in kCSSColorTable) {
	    copyRgba(rgbaArr, kCSSColorTable[str]);
	    putToCache(colorStr, rgbaArr);
	    return rgbaArr;
	  } // #abc and #abc123 syntax.
	
	
	  if (str.charAt(0) === '#') {
	    if (str.length === 4) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xfff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    } else if (str.length === 7) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xffffff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    }
	
	    return;
	  }
	
	  var op = str.indexOf('(');
	  var ep = str.indexOf(')');
	
	  if (op !== -1 && ep + 1 === str.length) {
	    var fname = str.substr(0, op);
	    var params = str.substr(op + 1, ep - (op + 1)).split(',');
	    var alpha = 1; // To allow case fallthrough.
	
	    switch (fname) {
	      case 'rgba':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        alpha = parseCssFloat(params.pop());
	      // jshint ignore:line
	      // Fall through.
	
	      case 'rgb':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsla':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        params[3] = parseCssFloat(params[3]);
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsl':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      default:
	        return;
	    }
	  }
	
	  setRgba(rgbaArr, 0, 0, 0, 1);
	  return;
	}
	/**
	 * @param {Array.<number>} hsla
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} rgba
	 */
	
	
	function hsla2rgba(hsla, rgba) {
	  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
	  // NOTE(deanm): According to the CSS spec s/l should only be
	  // percentages, but we don't bother and let float or percentage.
	
	  var s = parseCssFloat(hsla[1]);
	  var l = parseCssFloat(hsla[2]);
	  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	  var m1 = l * 2 - m2;
	  rgba = rgba || [];
	  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
	
	  if (hsla.length === 4) {
	    rgba[3] = hsla[3];
	  }
	
	  return rgba;
	}
	/**
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} hsla
	 */
	
	
	function rgba2hsla(rgba) {
	  if (!rgba) {
	    return;
	  } // RGB from 0 to 255
	
	
	  var R = rgba[0] / 255;
	  var G = rgba[1] / 255;
	  var B = rgba[2] / 255;
	  var vMin = Math.min(R, G, B); // Min. value of RGB
	
	  var vMax = Math.max(R, G, B); // Max. value of RGB
	
	  var delta = vMax - vMin; // Delta RGB value
	
	  var L = (vMax + vMin) / 2;
	  var H;
	  var S; // HSL results from 0 to 1
	
	  if (delta === 0) {
	    H = 0;
	    S = 0;
	  } else {
	    if (L < 0.5) {
	      S = delta / (vMax + vMin);
	    } else {
	      S = delta / (2 - vMax - vMin);
	    }
	
	    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
	    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
	    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
	
	    if (R === vMax) {
	      H = deltaB - deltaG;
	    } else if (G === vMax) {
	      H = 1 / 3 + deltaR - deltaB;
	    } else if (B === vMax) {
	      H = 2 / 3 + deltaG - deltaR;
	    }
	
	    if (H < 0) {
	      H += 1;
	    }
	
	    if (H > 1) {
	      H -= 1;
	    }
	  }
	
	  var hsla = [H * 360, S, L];
	
	  if (rgba[3] != null) {
	    hsla.push(rgba[3]);
	  }
	
	  return hsla;
	}
	/**
	 * @param {string} color
	 * @param {number} level
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function lift(color, level) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    for (var i = 0; i < 3; i++) {
	      if (level < 0) {
	        colorArr[i] = colorArr[i] * (1 - level) | 0;
	      } else {
	        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
	      }
	
	      if (colorArr[i] > 255) {
	        colorArr[i] = 255;
	      } else if (color[i] < 0) {
	        colorArr[i] = 0;
	      }
	    }
	
	    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
	  }
	}
	/**
	 * @param {string} color
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function toHex(color) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
	  }
	}
	/**
	 * Map value to color. Faster than lerp methods because color is represented by rgba array.
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<Array.<number>>} colors List of rgba color array
	 * @param {Array.<number>} [out] Mapped gba color array
	 * @return {Array.<number>} will be null/undefined if input illegal.
	 */
	
	
	function fastLerp(normalizedValue, colors, out) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  out = out || [];
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = colors[leftIndex];
	  var rightColor = colors[rightIndex];
	  var dv = value - leftIndex;
	  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
	  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
	  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
	  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
	  return out;
	}
	/**
	 * @deprecated
	 */
	
	
	var fastMapToColor = fastLerp;
	/**
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<string>} colors Color list.
	 * @param {boolean=} fullOutput Default false.
	 * @return {(string|Object)} Result color. If fullOutput,
	 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
	 * @memberOf module:zrender/util/color
	 */
	
	function lerp(normalizedValue, colors, fullOutput) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = parse(colors[leftIndex]);
	  var rightColor = parse(colors[rightIndex]);
	  var dv = value - leftIndex;
	  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
	  return fullOutput ? {
	    color: color,
	    leftIndex: leftIndex,
	    rightIndex: rightIndex,
	    value: value
	  } : color;
	}
	/**
	 * @deprecated
	 */
	
	
	var mapToColor = lerp;
	/**
	 * @param {string} color
	 * @param {number=} h 0 ~ 360, ignore when null.
	 * @param {number=} s 0 ~ 1, ignore when null.
	 * @param {number=} l 0 ~ 1, ignore when null.
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	function modifyHSL(color, h, s, l) {
	  color = parse(color);
	
	  if (color) {
	    color = rgba2hsla(color);
	    h != null && (color[0] = clampCssAngle(h));
	    s != null && (color[1] = parseCssFloat(s));
	    l != null && (color[2] = parseCssFloat(l));
	    return stringify(hsla2rgba(color), 'rgba');
	  }
	}
	/**
	 * @param {string} color
	 * @param {number=} alpha 0 ~ 1
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	
	function modifyAlpha(color, alpha) {
	  color = parse(color);
	
	  if (color && alpha != null) {
	    color[3] = clampCssFloat(alpha);
	    return stringify(color, 'rgba');
	  }
	}
	/**
	 * @param {Array.<number>} arrColor like [12,33,44,0.4]
	 * @param {string} type 'rgba', 'hsva', ...
	 * @return {string} Result color. (If input illegal, return undefined).
	 */
	
	
	function stringify(arrColor, type) {
	  if (!arrColor || !arrColor.length) {
	    return;
	  }
	
	  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
	
	  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
	    colorStr += ',' + arrColor[3];
	  }
	
	  return type + '(' + colorStr + ')';
	}
	
	exports.parse = parse;
	exports.lift = lift;
	exports.toHex = toHex;
	exports.fastLerp = fastLerp;
	exports.fastMapToColor = fastMapToColor;
	exports.lerp = lerp;
	exports.mapToColor = mapToColor;
	exports.modifyHSL = modifyHSL;
	exports.modifyAlpha = modifyAlpha;
	exports.stringify = stringify;

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = interopDefault;
	
	// https://github.com/moment/moment/issues/3650
	// since we are using ts 3.5.1, it should be safe to remove.
	function interopDefault(m) {
	  return m["default"] || m;
	}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.AllDndCompInfo = exports.getTypeName = exports.AllCompGUID = undefined;
	
	var _SgiBadgeEO = __webpack_require__(618);
	
	var _SgiBadgeEO2 = _interopRequireDefault(_SgiBadgeEO);
	
	var _SgiButtonEO = __webpack_require__(308);
	
	var _SgiCalendarEO = __webpack_require__(309);
	
	var _SgiColEO = __webpack_require__(310);
	
	var _SgiCollapseEO = __webpack_require__(311);
	
	var _SgiCommEchartsEO = __webpack_require__(312);
	
	var _SgiDVEO = __webpack_require__(313);
	
	var _SgiEChartsCommonEO = __webpack_require__(314);
	
	var _SgiFormCascaderEO = __webpack_require__(315);
	
	var _SgiFormCheckboxEO = __webpack_require__(316);
	
	var _SgiFormCheckboxGroupEO = __webpack_require__(317);
	
	var _SgiFormComboboxEO = __webpack_require__(318);
	
	var _SgiFormComboxTreeEO = __webpack_require__(319);
	
	var _SgiFormDateEO = __webpack_require__(320);
	
	var _SgiFormEditorEO = __webpack_require__(322);
	
	var _SgiFormEO = __webpack_require__(321);
	
	var _SgiFormFileEO = __webpack_require__(323);
	
	var _SgiFormInputNumberEO = __webpack_require__(324);
	
	var _SgiFormPopUIEO = __webpack_require__(325);
	
	var _SgiFormRadioEO = __webpack_require__(326);
	
	var _SgiFormTextAreaEO = __webpack_require__(327);
	
	var _SgiFormTextEO = __webpack_require__(328);
	
	var _SgiFormTimeEO = __webpack_require__(329);
	
	var _SgiG6CommonEO = __webpack_require__(1153);
	
	var _SgiG6CommonEO2 = _interopRequireDefault(_SgiG6CommonEO);
	
	var _SgiImgEO = __webpack_require__(330);
	
	var _SgiJsoneditorEO = __webpack_require__(1154);
	
	var _SgiJsoneditorEO2 = _interopRequireDefault(_SgiJsoneditorEO);
	
	var _SgiLabelEO = __webpack_require__(331);
	
	var _SgiTagEO = __webpack_require__(622);
	
	var _SgiListEO = __webpack_require__(332);
	
	var _SgiMenuEO = __webpack_require__(333);
	
	var _SgiNestEO = __webpack_require__(334);
	
	var _SgiOverlapEO = __webpack_require__(335);
	
	var _SgiPanelEO = __webpack_require__(336);
	
	var _SgiQuoteEO = __webpack_require__(620);
	
	var _SgiRowEO = __webpack_require__(337);
	
	var _SgiSpinEO = __webpack_require__(621);
	
	var _SgiSpinEO2 = _interopRequireDefault(_SgiSpinEO);
	
	var _SgiSplitterEO = __webpack_require__(338);
	
	var _SgiStepsEO = __webpack_require__(339);
	
	var _SgiTableEO = __webpack_require__(341);
	
	var _SgiTabsEO = __webpack_require__(342);
	
	var _SgiTileEO = __webpack_require__(343);
	
	var _SgiTinyMCEEO = __webpack_require__(623);
	
	var _SgiToolbarEO = __webpack_require__(344);
	
	var _SgiTooltipEO = __webpack_require__(624);
	
	var _SgiTooltipEO2 = _interopRequireDefault(_SgiTooltipEO);
	
	var _SgiTransferEO = __webpack_require__(345);
	
	var _SgiTreeEO = __webpack_require__(346);
	
	var _SgiTVEO = __webpack_require__(340);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllCompGUID = {
		//UI部分
		UCV: "EP_EO_UI_0001",
		PANEL: "EP_EO_UI_4001",
		PANEL_PURE: "EP_EO_UI_40012",
		WV: "EP_EO_UI_4002",
		DU: "EP_EO_UI_4003",
		MENU: "EP_EO_UI_4004",
		QUOTE: 'EP_EO_UI_4005', //wzhe 2018.5.29 添加，组件的引用 
		SPIN: "EP_EO_UI_4006",
		CARD_PURE: "EP_EO_UI_4007",
		TOOLTIP: "EP_EO_UI_4008",
		BADGE: "EP_EO_UI_4009",
		SPLITTER: "EP_EO_UI_4101",
		TAB: "EP_EO_UI_4102",
		CARD: "EP_EO_UI_4103",
		// OVERPANEL: "EP_EO_UI_4103",
		OVERLAP: "EP_EO_UI_41032",
		ACCORDION: "EP_EO_UI_4104",
		FIELDSET: "EP_EO_UI_4105",
		NEST: "EP_EO_UI_4106",
		//TPL : "EP_EO_UI_4107",    
	
		LABEL: "EP_EO_UI_3002",
		BUTTON: "EP_EO_UI_3003",
		BUTTON_PURE: "EP_EO_UI_30032",
		IMG: "EP_EO_UI_3004",
		ICON: "EP_EO_UI_3005",
		PROGRESSBAR: "EP_EO_UI_3006",
		TREE: "EP_EO_UI_3007",
		TABLE: "EP_EO_UI_3008",
		AMOUNTTEXT: "EP_EO_UI_3009",
		MONETARYTEXT: "EP_EO_UI_3009",
		TOOLBAR: "EP_EO_UI_3010",
		POPUI: "EP_EO_UI_3011",
		EDITOR: "EP_EO_UI_3012",
		STATBUTTON: "EP_EO_UI_3013",
		STEP: "EP_EO_UI_3015",
		TBFILL: "EP_EO_UI_3016",
		TRANSFER: "EP_EO_UI_3017",
		TAG: "EP_EO_UI_3018",
	
		//表单组件
		FIELDTEXT: "EP_EO_UI_3101",
		TEXTAREA: "EP_EO_UI_3102",
		FILE: "EP_EO_UI_3103",
		NUMBER: "EP_EO_UI_3104",
		TIME: "EP_EO_UI_3105",
		DATE: "EP_EO_UI_3106",
		COMBOBOX: "EP_EO_UI_3107",
		COMBOXTREE: 'EP_EO_NUI_0001',
		COMBOXGRID: 'EP_EO_NUI_0002',
		CHECKBOXGROUP: "EP_EO_UI_3108",
		RADIOGROUP: "EP_EO_UI_3109",
		CHECKBOX: "EP_EO_UI_3110",
		COLOR: "EP_EO_UI_3111",
		FONT: "EP_EO_UI_3112",
		PASSWORD: "EP_EO_UI_3113",
		EDITORAREA: "EP_EO_UI_3114",
		FIELDDISPLAY: "EP_EO_UI_3115",
		COMPONENT: "EP_EO_UI_3116",
		CONTAINER: "EP_EO_UI_3117",
		UPLOADFILE: "EP_EO_UI_3118",
		MONETARY2TEXT: "EP_EO_UI_3119",
		CASCADER: "EP_EO_UI_3122",
		CODEMIRROR_FORM: "EP_EO_UI_3123",
		LINE: "EP_EO_UI_7001",
		AREA: "EP_EO_UI_7002",
		BAR: "EP_EO_UI_7003",
		SCATTER: "EP_EO_UI_7004",
		PIE: "EP_EO_UI_7005",
		GAUGE: "EP_EO_UI_7006",
		RADAR: "EP_EO_UI_7007",
		/***add by zuan ***/
		LIST: "EP_EO_UI_4107",
		AUDIO: "EP_EO_UI_4108",
		VIDEO: "EP_EO_UI_4109",
		CAROUSEL: "EP_EO_UI_4110",
		NESTEDLIST: "EP_EO_UI_4111", //嵌套列表控件
		EMAIL: "EP_EO_UI_4112", //email地址
		SEARCH: "EP_EO_UI_4113", //搜索控件
		TOGGLE: "EP_EO_UI_4114", //切换控件
		DVPANEL: "EP_EO_UI_3014", //DVpanel控件
		FLOATWINDOW: "EP_EO_UI_3120", //浮动窗口
		PASSWORDSTRENGTH: "EP_EO_UI_3121", //密码强度控件
		ITEM: "EP_EO_UI_6004", //菜单项
		DIVCOMBOBOX: "EP_EO_NUI_0003", //自定义下拉窗
	
		//布局
		LT_COLUMN: "EP_EO_UI_5001",
		LT_FIT: "EP_EO_UI_5002",
		LT_TABLE: "EP_EO_UI_5003",
		LT_VBOX: "EP_EO_UI_5004",
		LT_HBOX: "EP_EO_UI_5005",
		LT_ANCHOR: "EP_EO_UI_5006",
		//2018.3.14追加新布局PC端
		LT_ROW: "EP_EO_UI_5101",
		LT_COL: "EP_EO_UI_5102",
	
		//打印部分
		PTROOT: "EP_EO_PT_0001",
		PTGROUP: "EP_EO_PT_0003",
		PTTEXT: "EP_EO_PT_2001",
		PTTABLE: "EP_EO_PT_3001",
		PTTABLEHEADER: "EP_EO_PT_3101",
		PTTABLEBODY: "EP_EO_PT_3102",
		PTTABLEFOOTER: "EP_EO_PT_3103",
	
		// 高级组件
		Tile: "EP_EO_UI_SgiTile",
		CommEcharts: "EP_EO_UI_SgiCommEcharts",
	
		// 新增组件
		Calendar: "EP_EO_UI_SgiCalendar",
		TINYMCE: "EP_EO_UI_TinyMCE",
		CODEMIRROR: "EP_EO_UI_CODEMIRROR",
		JSONEDITOR: "EP_EO_UI_JSONEDITOR",
	
		// ECharts
		EC_COMMON: "EP_EO_UI_EC0001",
	
		// G6
		G6_COMMON: "EP_EO_UI_G60001",
	
		DV: "EP_EO_UI_DV",
		TV: "EP_EO_UI_TV"
	};
	
	var getTypeName = function getTypeName(guid) {
		for (var key in AllCompGUID) {
			if (guid === AllCompGUID[key]) {
				return key;
			}
		}
	};
	
	/**
	 * 注意：
	 * _type: 非实际组件的组件类型，而是拖拽组件的类型，ctn--该组件内部可拖入其他组件、ctl--该组件内部不可拖入其他组件
	 * dndCompKey: 拖拽组件key
	 * dndCompRef: 拖拽组件内部使用组件的ref
	 * dndCompExp: (选填)拖拽组件描述
	 * dndCompEKey: (选填)拖拽组件使用描述编辑页面key，默认dndCompKey+"Editor"
	 * dndCompEditor: 拖拽组件使用描述编辑页面组件(dnd模式使用，需要dnd自己转成对应组件)
	 * sgiComp: 拖拽组件内部使用组件(组件模式使用，需要comp项目自己转成对应组件)
	 * sgiCompEO: 组件获取初始描述方法
	 * dndSourceType: (选填)拖拽组件拖拽源类型，默认与dndCompKey相同
	 * propsParams: 需要额外传递的属性
	 */
	var AllDndCompInfo = {
		//UI部分
		// UCV: "EP_EO_UI_0001",
		"EP_EO_UI_0001": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiMainComp",
			dndCompRef: "Dnd_SgiMainComp_SgiMainComp",
			dndCompEditor: "Dnd_SgiMainCompEditor",
			sgiComp: "SgiMainComp"
		},
		"EP_EO_UI_4001": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiPanel",
			dndCompRef: "Dnd_SgiPanel_SgiPanel",
			dndCompEditor: "Dnd_SgiPanelEditor",
			sgiComp: "SgiPanel",
			sgiCompEO: _SgiPanelEO.SgiPanelEO
		},
		// WV: "EP_EO_UI_4002",
		"EP_EO_UI_4002": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiForm",
			dndCompRef: "Dnd_SgiForm_SgiForm",
			dndCompEditor: "Dnd_SgiFormEditor",
			sgiComp: "SgiForm",
			sgiCompEO: _SgiFormEO.SgiFormEO
		},
		// Spin: "EP_EO_UI_4006",
		"EP_EO_UI_4006": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiSpin",
			dndCompRef: "Dnd_SgiSpin_SgiSpin",
			dndCompEditor: "Dnd_SgiSpinEditor",
			sgiComp: "SgiSpin",
			sgiCompEO: _SgiSpinEO2.default
		},
		// Card: "EP_EO_UI_4007",
		// "EP_EO_UI_4007": {
		// 	_type: "ctn",
		// 	dndCompKey: "Dnd_SgiCard",
		// 	dndCompRef: "Dnd_SgiCard_SgiCard",
		// 	dndCompEditor: "Dnd_SgiCardEditor",
		// 	sgiComp: "SgiCard",
		// 	sgiCompEO: SgiCardEO,
		// },
		// Tooltip: "EP_EO_UI_4008",
		"EP_EO_UI_4008": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiTooltip",
			dndCompRef: "Dnd_SgiTooltip_SgiTooltip",
			dndCompEditor: "Dnd_SgiTooltipEditor",
			sgiComp: "SgiTooltip",
			sgiCompEO: _SgiTooltipEO2.default
		},
		// Badge: "EP_EO_UI_4009",
		"EP_EO_UI_4009": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiBadge",
			dndCompRef: "Dnd_SgiBadge_SgiBadge",
			dndCompEditor: "Dnd_SgiBadgeEditor",
			sgiComp: "SgiBadge",
			sgiCompEO: _SgiBadgeEO2.default
		},
		// SPLITTER: "EP_EO_UI_4101",
		"EP_EO_UI_4101": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiSplitter",
			dndCompRef: "Dnd_SgiSplitter_SgiSplitter",
			dndCompExp: "分割组件,请拖入普通面板或FORM",
			dndCompEditor: "Dnd_SgiSplitterEditor",
			sgiComp: "SgiSplitter",
			sgiCompEO: _SgiSplitterEO.SgiSplitterEO
			// propsParams: { addSgiSplitterCtlDndInfo }
		},
		// TAB: "EP_EO_UI_4102",
		"EP_EO_UI_4102": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiTabs",
			dndCompRef: "Dnd_SgiTabs_SgiTabs",
			dndCompExp: "tab组件,请拖入普通面板或FORM",
			dndCompEditor: "Dnd_SgiTabsEditor",
			sgiComp: "SgiTabs",
			sgiCompEO: _SgiTabsEO.SgiTabsEO
			// propsParams: { addTabCtlDndInfo }
		},
		// OVERPANEL: "EP_EO_UI_4103",
		"EP_EO_UI_4103": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiCollapse",
			dndCompEKey: "Dnd_SgiOverlapEditor",
			dndCompRef: "Dnd_SgiCollapse_SgiCollapse",
			dndCompExp: "重叠面板为了方便编辑，开发时使用折叠面板显示，请添加普通面板或FORM",
			dndCompEditor: "Dnd_SgiOverlapEditor",
			sgiComp: "SgiCollapse",
			sgiCompEO: _SgiOverlapEO.SgiOverlapEO
			// propsParams: { addCollapseCtlDndInfo }
		},
		// ACCORDION: "EP_EO_UI_4104",
		"EP_EO_UI_4104": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiCollapse",
			dndCompRef: "Dnd_SgiCollapse_SgiCollapse",
			dndCompExp: "折叠组件,请拖入普通面板或FORM",
			dndCompEditor: "Dnd_SgiCollapseEditor",
			sgiComp: "SgiCollapse",
			sgiCompEO: _SgiCollapseEO.SgiCollapseEO
			// propsParams: { addCollapseCtlDndInfo }
		},
		// NEST: "EP_EO_UI_4106",
		"EP_EO_UI_4106": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiNest",
			dndCompRef: "Dnd_SgiNest_SgiNest",
			dndCompExp: "嵌入面板,不能再拖拽子组件，只能嵌入其他UI",
			dndCompEditor: "Dnd_SgiNestEditor",
			sgiComp: "SgiNest",
			sgiCompEO: _SgiNestEO.SgiNestEO
		},
		// MENU: "EP_EO_UI_4004",
		"EP_EO_UI_4004": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiMenu",
			dndCompRef: "Dnd_SgiMenu_SgiMenu",
			// dndCompExp: "菜单组件,不能再拖拽子组件，只能嵌入其他UI",
			dndCompEditor: "Dnd_SgiMenuEditor",
			sgiComp: "SgiMenu",
			sgiCompEO: _SgiMenuEO.SgiMenuEO
		},
		//TPL : "EP_EO_UI_4107",    
		// QUOTE: 'EP_EO_UI_4005', //wzhe 2018.5.29 添加，组件的引用 
		"EP_EO_UI_4005": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiQuote",
			dndCompRef: "Dnd_SgiQuote_SgiQuote",
			// dndCompExp: "引用面板,不能再拖拽子组件，只能引用其他组件",
			// dndCompEditor: "Dnd_SgiQuoteEditor",
			sgiComp: "SgiQuote",
			sgiCompEO: _SgiQuoteEO.SgiQuoteEO
		},
	
		// LABEL: "EP_EO_UI_3002",
		"EP_EO_UI_3002": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiLabel",
			dndCompRef: "Dnd_SgiLabel_SgiLabel",
			dndCompEditor: "Dnd_SgiLabelEditor",
			sgiComp: "SgiLabel",
			sgiCompEO: _SgiLabelEO.SgiLabelEO
		},
		"EP_EO_UI_3003": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiButton",
			dndCompRef: "Dnd_SgiButton_SgiButton",
			dndCompEditor: "Dnd_SgiButtonEditor",
			sgiComp: "SgiButton",
			sgiCompEO: _SgiButtonEO.SgiButtonEO
		},
		// IMG: "EP_EO_UI_3004",
		"EP_EO_UI_3004": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiImg",
			dndCompRef: "Dnd_SgiImg_SgiImg",
			dndCompEditor: "Dnd_SgiImgEditor",
			sgiComp: "SgiImg",
			sgiCompEO: _SgiImgEO.SgiImgEO
		},
		// TREE: "EP_EO_UI_3007",
		"EP_EO_UI_3007": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiTree",
			dndCompRef: "Dnd_SgiTree_SgiTree",
			dndCompEditor: "Dnd_SgiTreeEditor",
			sgiComp: "SgiTree",
			sgiCompEO: _SgiTreeEO.SgiTreeEO
		},
		// TABLE: "EP_EO_UI_3008",
		"EP_EO_UI_3008": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiTable",
			dndCompRef: "Dnd_SgiTable_SgiTable",
			dndCompExp: "表格组件,不能再拖拽子组件，只能嵌入其他UI",
			dndCompEditor: "Dnd_SgiTableEditor",
			sgiComp: "SgiTable",
			sgiCompEO: _SgiTableEO.SgiTableEO
		},
		// TOOLBAR: "EP_EO_UI_3010",
		"EP_EO_UI_3010": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiToolbar",
			dndCompRef: "Dnd_SgiToolbar_SgiToolbar",
			dndCompExp: "工具条组件,请拖入按钮",
			dndCompEditor: "Dnd_SgiToolbarEditor",
			sgiComp: "SgiToolbar",
			sgiCompEO: _SgiToolbarEO.SgiToolbarEO
			// propsParams: { addToolbarCtlDndInfo }
		},
		// POPUI: "EP_EO_UI_3011",
		"EP_EO_UI_3011": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormPopUI",
			dndCompRef: "Dnd_SgiFormPopUI_SgiFormPopUI",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormPopUIEditor",
			sgiComp: "SgiFormInputSearch",
			sgiCompEO: _SgiFormPopUIEO.SgiFormPopUIEO
		},
		// EDITOR: "EP_EO_UI_3012",
		"EP_EO_UI_3012": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormEditorE",
			dndCompEKey: "Dnd_SgiFormEditorEditor",
			dndCompRef: "Dnd_SgiFormEditor_SgiFormEditor",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormEditorEditor",
			sgiComp: "SgiEditor",
			sgiCompEO: _SgiFormEditorEO.SgiFormEditorEO
		},
		// STEP: "EP_EO_UI_3015",
		"EP_EO_UI_3015": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiSteps",
			dndCompRef: "Dnd_SgiSteps_SgiSteps",
			dndCompExp: "步骤组件,不能再拖拽子组件，只能嵌入其他UI",
			dndCompEditor: "Dnd_SgiStepsEditor",
			sgiComp: "SgiSteps",
			sgiCompEO: _SgiStepsEO.SgiStepsEO
		},
		// TRANSFER: "EP_EO_UI_3017",
		"EP_EO_UI_3017": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiTransfer",
			dndCompRef: "Dnd_SgiTransfer_SgiTransfer",
			dndCompExp: "穿梭框组件,不能再拖拽子组件，只能嵌入其他UI",
			dndCompEditor: "Dnd_SgiTransferEditor",
			sgiComp: "SgiTransfer",
			sgiCompEO: _SgiTransferEO.SgiTransferEO
		},
		// TAG: "EP_EO_UI_3018",
		"EP_EO_UI_3018": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiTag",
			dndCompRef: "Dnd_SgiTag_SgiTag",
			dndCompEditor: "Dnd_SgiTagEditor",
			sgiComp: "SgiTag",
			sgiCompEO: _SgiTagEO.SgiTagEO
		},
	
		//表单组件
		// FIELDTEXT: "EP_EO_UI_3101",
		"EP_EO_UI_3101": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormText",
			dndCompRef: "Dnd_SgiFormText_SgiFormText",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormTextEditor",
			sgiComp: "SgiFormText",
			sgiCompEO: _SgiFormTextEO.SgiFormTextEO
		},
		// TEXTAREA: "EP_EO_UI_3102",
		"EP_EO_UI_3102": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormTextArea",
			dndCompRef: "Dnd_SgiFormTextArea_SgiFormTextArea",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormTextAreaEditor",
			sgiComp: "SgiFormTextArea",
			sgiCompEO: _SgiFormTextAreaEO.SgiFormTextAreaEO
		},
		// NUMBER: "EP_EO_UI_3104",
		"EP_EO_UI_3104": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormNumber",
			dndCompRef: "Dnd_SgiFormNumber_SgiFormNumber",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormNumberEditor",
			sgiComp: "SgiFormInputNumber",
			sgiCompEO: _SgiFormInputNumberEO.SgiFormInputNumberEO
		},
		// TIME: "EP_EO_UI_3105",
		"EP_EO_UI_3105": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormTime",
			dndCompRef: "Dnd_SgiFormTime_SgiFormTime",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormTimeEditor",
			sgiComp: "SgiFormTimePicker",
			sgiCompEO: _SgiFormTimeEO.SgiFormTimeEO
		},
		// DATE: "EP_EO_UI_3106",
		"EP_EO_UI_3106": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormDate",
			dndCompRef: "Dnd_SgiFormDate_SgiFormDate",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormDateEditor",
			sgiComp: "SgiFormDatePicker",
			sgiCompEO: _SgiFormDateEO.SgiFormDateEO
		},
		// COMBOBOX: "EP_EO_UI_3107",
		"EP_EO_UI_3107": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormCombobox",
			dndCompRef: "Dnd_SgiFormCombobox_SgiFormCombobox",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormComboboxEditor",
			sgiComp: "SgiFormSelect",
			sgiCompEO: _SgiFormComboboxEO.SgiFormComboboxEO
		},
		// COMBOXTREE: 'EP_EO_NUI_0001',
		"EP_EO_NUI_0001": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormComboxTree",
			dndCompRef: "Dnd_SgiFormComboxTree_SgiFormComboxTree",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormComboxTreeEditor",
			sgiComp: "SgiFormTreeSelect",
			sgiCompEO: _SgiFormComboxTreeEO.SgiFormComboxTreeEO
		},
		// CHECKBOXGROUP: "EP_EO_UI_3108",
		"EP_EO_UI_3108": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormCheckboxGroup",
			dndCompRef: "Dnd_SgiFormCheckboxGroup_SgiFormCheckboxGroup",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormCheckboxGroupEditor",
			sgiComp: "SgiFormCheckboxGroup",
			sgiCompEO: _SgiFormCheckboxGroupEO.SgiFormCheckboxGroupEO
		},
		// RADIOGROUP: "EP_EO_UI_3109",
		"EP_EO_UI_3109": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormRadio",
			dndCompRef: "Dnd_SgiFormRadio_SgiFormRadio",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormRadioEditor",
			sgiComp: "SgiFormRadio",
			sgiCompEO: _SgiFormRadioEO.SgiFormRadioEO
		},
		// CHECKBOX: "EP_EO_UI_3110",
		"EP_EO_UI_3110": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormCheckbox",
			dndCompRef: "Dnd_SgiFormCheckbox_SgiFormCheckbox",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormCheckboxEditor",
			sgiComp: "SgiFormCheckbox",
			sgiCompEO: _SgiFormCheckboxEO.SgiFormCheckboxEO
		},
		// UPLOADFILE: "EP_EO_UI_3118",
		"EP_EO_UI_3118": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormFile",
			dndCompRef: "Dnd_SgiFormFile_SgiFormFile",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormFileEditor",
			sgiComp: "SgiFormUpload",
			sgiCompEO: _SgiFormFileEO.SgiFormFileEO
		},
		// CASCADER: "EP_EO_UI_3122",
		"EP_EO_UI_3122": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormCascader",
			dndCompRef: "Dnd_SgiFormCascader_SgiFormCascader",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiFormCascaderEditor",
			sgiComp: "SgiFormCascader",
			sgiCompEO: _SgiFormCascaderEO.SgiFormCascaderEO
		},
		// LIST: "EP_EO_UI_4107",
		"EP_EO_UI_4107": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiList",
			dndCompRef: "Dnd_SgiList_SgiList",
			dndCompEditor: "Dnd_SgiListEditor",
			sgiComp: "SgiList",
			sgiCompEO: _SgiListEO.SgiListEO
		},
		// LT_ROW: "EP_EO_UI_5101",
		"EP_EO_UI_5101": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiRow",
			dndCompRef: "Dnd_SgiRow_SgiRow",
			dndCompEditor: "Dnd_SgiRowEditor",
			sgiComp: "SgiRow",
			sgiCompEO: _SgiRowEO.SgiRowEO
		},
		// LT_COL: "EP_EO_UI_5102",
		"EP_EO_UI_5102": {
			_type: "ctn",
			dndCompKey: "Dnd_SgiCol",
			dndCompRef: "Dnd_SgiCol_SgiCol",
			dndCompEditor: "Dnd_SgiColEditor",
			sgiComp: "SgiCol",
			sgiCompEO: _SgiColEO.SgiColEO
		},
	
		// Tile: "EP_EO_UI_SgiTile",
		"EP_EO_UI_SgiTile": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiTile",
			dndCompRef: "Dnd_SgiTile_SgiTile",
			dndCompExp: "平铺组件，请填写自定义子组件渲染方法",
			dndCompEditor: "Dnd_SgiTileEditor",
			sgiComp: "SgiTile",
			sgiCompEO: _SgiTileEO.SgiTileEO
		},
		// CommEcharts: "EP_EO_UI_SgiCommEcharts",
		"EP_EO_UI_SgiCommEcharts": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiCommEcharts",
			dndCompRef: "Dnd_SgiCommEcharts_SgiCommEcharts",
			dndCompExp: "通用图表，请填写自定义option方法",
			dndCompEditor: "Dnd_SgiCommEchartsEditor",
			sgiComp: "SgiCommEcharts",
			sgiCompEO: _SgiCommEchartsEO.SgiCommEchartsEO
		},
	
		// 新增组件
		// Calendar: "EP_EO_UI_SgiCalendar",
		"EP_EO_UI_SgiCalendar": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiCalendar",
			dndCompRef: "Dnd_SgiCalendar_SgiCalendar",
			dndCompEditor: "Dnd_SgiCalendarEditor",
			sgiComp: "SgiCalendar",
			sgiCompEO: _SgiCalendarEO.SgiCalendarEO
		},
		// TINYMCE: "EP_EO_UI_TinyMCE",
		"EP_EO_UI_TinyMCE": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiFormTinyMCE",
			dndCompRef: "Dnd_SgiTinyMCE_SgiTinyMCE",
			dndSourceType: "Dnd_SgiFormCtl",
			dndCompEditor: "Dnd_SgiTinyMCEEditor",
			sgiComp: "SgiTinyMCE",
			sgiCompEO: _SgiTinyMCEEO.SgiTinyMCEEO
		},
		// CODEMIRROR: "EP_EO_UI_CODEMIRROR",
		"EP_EO_UI_CODEMIRROR": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiCodemirror",
			dndCompRef: "Dnd_SgiCodemirror_SgiCodemirror",
			dndSourceType: "Dnd_SgiCodeMirror",
			dndCompEditor: "Dnd_SgiCodeMirrorEditor",
			sgiComp: "SgiCodeMirror"
			// sgiCompEO: SgiCodeMirrorEO,
		},
		// JSONEDITOR: "EP_EO_UI_JSONEDITOR",
		"EP_EO_UI_JSONEDITOR": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiJsoneditor",
			dndCompRef: "Dnd_SgiJsoneditor_SgiJsoneditor",
			dndSourceType: "Dnd_SgiJsoneditor",
			dndCompEditor: "Dnd_SgiJsoneditorEditor",
			sgiComp: "SgiJsoneditor",
			sgiCompEO: _SgiJsoneditorEO2.default
		},
		// ECharts
		// EC_COMMON: "EP_EO_UI_EC0001",
		"EP_EO_UI_EC0001": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiEChartsCommon",
			dndCompRef: "Dnd_SgiEChartsCommon_SgiEChartsCommon",
			dndCompExp: "ECharts图表，请填写自定义option方法",
			dndCompEditor: "Dnd_SgiEChartsCommonEditor",
			sgiComp: "SgiEChartsCommon",
			sgiCompEO: _SgiEChartsCommonEO.SgiEChartsCommonEO
		},
		// G6
		// G6_COMMON: "EP_EO_UI_G60001",
		"EP_EO_UI_G60001": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiG6Common",
			dndCompRef: "Dnd_SgiG6Common_SgiG6Common",
			dndCompEditor: "_prmEditor",
			sgiComp: "SgiG6Common",
			sgiCompEO: _SgiG6CommonEO2.default
		},
		"EP_EO_UI_DV": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiDV",
			dndCompRef: "Dnd_SgiDV_SgiDV",
			dndCompExp: "ECharts图表，请填写自定义option方法",
			dndCompEditor: "Dnd_SgiDVEditor",
			sgiComp: "SgiDV",
			sgiCompEO: _SgiDVEO.SgiDVEO
		},
		"EP_EO_UI_TV": {
			_type: "ctl",
			dndCompKey: "Dnd_SgiTV",
			dndCompRef: "Dnd_SgiTV_SgiTV",
			dndCompExp: "ECharts图表，请填写自定义option方法",
			dndCompEditor: "Dnd_SgiTVEditor",
			sgiComp: "SgiTV",
			sgiCompEO: _SgiTVEO.SgiTVEO
		}
	};
	
	exports.AllCompGUID = AllCompGUID;
	exports.getTypeName = getTypeName;
	exports.AllDndCompInfo = AllDndCompInfo;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = interopDefault;
	
	// https://github.com/moment/moment/issues/3650
	// since we are using ts 3.5.1, it should be safe to remove.
	function interopDefault(m) {
	  return m["default"] || m;
	}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * 指定长度和进制的UUID
	 * @param len       长度
	 * @param radix     进制，2,8,10,16
	 * @returns {string}
	 */
	function uuid(len, radix) {
	    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	    var uuid = [],
	        i;
	    radix = radix || chars.length;
	
	    if (len) {
	        // Compact form
	        for (i = 0; i < len; i++) {
	            uuid[i] = chars[0 | Math.random() * radix];
	        }
	    } else {
	        // rfc4122, version 4 form
	        var r;
	
	        // rfc4122 requires these characters
	        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
	        uuid[14] = '4';
	
	        // Fill in random data. At i==19 set the high bits of clock sequence as per
	        // rfc4122, sec. 4.1.5
	        for (i = 0; i < 36; i++) {
	            if (!uuid[i]) {
	                r = 0 | Math.random() * 16;
	                uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
	            }
	        }
	    }
	
	    return uuid.join('');
	}
	
	exports.uuid = uuid;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = interopDefault;
	
	// https://github.com/moment/moment/issues/3650
	// since we are using ts 3.5.1, it should be safe to remove.
	function interopDefault(m) {
	  return m["default"] || m;
	}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var PooledClass = __webpack_require__(139);
	
	var emptyFunction = __webpack_require__(120);
	var warning = __webpack_require__(44);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function timeStamp(event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function preventDefault() {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function persist() {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function destructor() {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function E() {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function construct(target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function apply(constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function set(target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var List = __webpack_require__(88);
	
	var createDimensions = __webpack_require__(176);
	
	var _sourceType = __webpack_require__(221);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	
	var _dimensionHelper = __webpack_require__(220);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _model = __webpack_require__(27);
	
	var getDataItemValue = _model.getDataItemValue;
	
	var CoordinateSystem = __webpack_require__(95);
	
	var _referHelper = __webpack_require__(1859);
	
	var getCoordSysInfoBySeries = _referHelper.getCoordSysInfoBySeries;
	
	var Source = __webpack_require__(219);
	
	var _dataStackHelper = __webpack_require__(102);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	
	var _sourceHelper = __webpack_require__(114);
	
	var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/Source|Array} source Or raw data.
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object} [opt]
	 * @param {string} [opt.generateCoord]
	 * @param {boolean} [opt.useEncodeDefaulter]
	 */
	function createListFromArray(source, seriesModel, opt) {
	  opt = opt || {};
	
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var registeredCoordSys = CoordinateSystem.get(coordSysName);
	  var coordSysInfo = getCoordSysInfoBySeries(seriesModel);
	  var coordSysDimDefs;
	
	  if (coordSysInfo) {
	    coordSysDimDefs = zrUtil.map(coordSysInfo.coordSysDims, function (dim) {
	      var dimInfo = {
	        name: dim
	      };
	      var axisModel = coordSysInfo.axisMap.get(dim);
	
	      if (axisModel) {
	        var axisType = axisModel.get('type');
	        dimInfo.type = getDimensionTypeByAxis(axisType); // dimInfo.stackable = isStackable(axisType);
	      }
	
	      return dimInfo;
	    });
	  }
	
	  if (!coordSysDimDefs) {
	    // Get dimensions from registered coordinate system
	    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
	  }
	
	  var dimInfoList = createDimensions(source, {
	    coordDimensions: coordSysDimDefs,
	    generateCoord: opt.generateCoord,
	    encodeDefaulter: opt.useEncodeDefaulter ? zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null
	  });
	  var firstCategoryDimIndex;
	  var hasNameEncode;
	  coordSysInfo && zrUtil.each(dimInfoList, function (dimInfo, dimIndex) {
	    var coordDim = dimInfo.coordDim;
	    var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
	
	    if (categoryAxisModel) {
	      if (firstCategoryDimIndex == null) {
	        firstCategoryDimIndex = dimIndex;
	      }
	
	      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
	    }
	
	    if (dimInfo.otherDims.itemName != null) {
	      hasNameEncode = true;
	    }
	  });
	
	  if (!hasNameEncode && firstCategoryDimIndex != null) {
	    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
	  }
	
	  var stackCalculationInfo = enableDataStack(seriesModel, dimInfoList);
	  var list = new List(dimInfoList, seriesModel);
	  list.setCalculationInfo(stackCalculationInfo);
	  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
	    // Use dataIndex as ordinal value in categoryAxis
	    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
	  } : null;
	  list.hasItemOption = false;
	  list.initData(source, null, dimValueGetter);
	  return list;
	}
	
	function isNeedCompleteOrdinalData(source) {
	  if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var sampleItem = firstDataNotNull(source.data || []);
	    return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
	  }
	}
	
	function firstDataNotNull(data) {
	  var i = 0;
	
	  while (i < data.length && data[i] == null) {
	    i++;
	  }
	
	  return data[i];
	}
	
	var _default = createListFromArray;
	module.exports = _default;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	var getDataItemValue = _model.getDataItemValue;
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var map = _util.map;
	var isArray = _util.isArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	var isTypedArray = _util.isTypedArray;
	var isArrayLike = _util.isArrayLike;
	var extend = _util.extend;
	var assert = _util.assert;
	
	var Source = __webpack_require__(219);
	
	var _sourceType = __webpack_require__(221);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SERIES_LAYOUT_BY_ROW = _sourceType.SERIES_LAYOUT_BY_ROW;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// The result of `guessOrdinal`.
	var BE_ORDINAL = {
	  Must: 1,
	  // Encounter string but not '-' and not number-like.
	  Might: 2,
	  // Encounter string but number-like.
	  Not: 3 // Other cases
	
	};
	var inner = makeInner();
	/**
	 * @see {module:echarts/data/Source}
	 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
	 * @return {string} sourceFormat
	 */
	
	function detectSourceFormat(datasetModel) {
	  var data = datasetModel.option.source;
	  var sourceFormat = SOURCE_FORMAT_UNKNOWN;
	
	  if (isTypedArray(data)) {
	    sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
	  } else if (isArray(data)) {
	    // FIXME Whether tolerate null in top level array?
	    if (data.length === 0) {
	      sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	    }
	
	    for (var i = 0, len = data.length; i < len; i++) {
	      var item = data[i];
	
	      if (item == null) {
	        continue;
	      } else if (isArray(item)) {
	        sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	        break;
	      } else if (isObject(item)) {
	        sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
	        break;
	      }
	    }
	  } else if (isObject(data)) {
	    for (var key in data) {
	      if (data.hasOwnProperty(key) && isArrayLike(data[key])) {
	        sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
	        break;
	      }
	    }
	  } else if (data != null) {
	    throw new Error('Invalid data');
	  }
	
	  inner(datasetModel).sourceFormat = sourceFormat;
	}
	/**
	 * [Scenarios]:
	 * (1) Provide source data directly:
	 *     series: {
	 *         encode: {...},
	 *         dimensions: [...]
	 *         seriesLayoutBy: 'row',
	 *         data: [[...]]
	 *     }
	 * (2) Refer to datasetModel.
	 *     series: [{
	 *         encode: {...}
	 *         // Ignore datasetIndex means `datasetIndex: 0`
	 *         // and the dimensions defination in dataset is used
	 *     }, {
	 *         encode: {...},
	 *         seriesLayoutBy: 'column',
	 *         datasetIndex: 1
	 *     }]
	 *
	 * Get data from series itself or datset.
	 * @return {module:echarts/data/Source} source
	 */
	
	
	function getSource(seriesModel) {
	  return inner(seriesModel).source;
	}
	/**
	 * MUST be called before mergeOption of all series.
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function resetSourceDefaulter(ecModel) {
	  // `datasetMap` is used to make default encode.
	  inner(ecModel).datasetMap = createHashMap();
	}
	/**
	 * [Caution]:
	 * MUST be called after series option merged and
	 * before "series.getInitailData()" called.
	 *
	 * [The rule of making default encode]:
	 * Category axis (if exists) alway map to the first dimension.
	 * Each other axis occupies a subsequent dimension.
	 *
	 * [Why make default encode]:
	 * Simplify the typing of encode in option, avoiding the case like that:
	 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
	 * where the "y" have to be manually typed as "1, 2, 3, ...".
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 */
	
	
	function prepareSource(seriesModel) {
	  var seriesOption = seriesModel.option;
	  var data = seriesOption.data;
	  var sourceFormat = isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
	  var fromDataset = false;
	  var seriesLayoutBy = seriesOption.seriesLayoutBy;
	  var sourceHeader = seriesOption.sourceHeader;
	  var dimensionsDefine = seriesOption.dimensions;
	  var datasetModel = getDatasetModel(seriesModel);
	
	  if (datasetModel) {
	    var datasetOption = datasetModel.option;
	    data = datasetOption.source;
	    sourceFormat = inner(datasetModel).sourceFormat;
	    fromDataset = true; // These settings from series has higher priority.
	
	    seriesLayoutBy = seriesLayoutBy || datasetOption.seriesLayoutBy;
	    sourceHeader == null && (sourceHeader = datasetOption.sourceHeader);
	    dimensionsDefine = dimensionsDefine || datasetOption.dimensions;
	  }
	
	  var completeResult = completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine);
	  inner(seriesModel).source = new Source({
	    data: data,
	    fromDataset: fromDataset,
	    seriesLayoutBy: seriesLayoutBy,
	    sourceFormat: sourceFormat,
	    dimensionsDefine: completeResult.dimensionsDefine,
	    startIndex: completeResult.startIndex,
	    dimensionsDetectCount: completeResult.dimensionsDetectCount,
	    // Note: dataset option does not have `encode`.
	    encodeDefine: seriesOption.encode
	  });
	} // return {startIndex, dimensionsDefine, dimensionsCount}
	
	
	function completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
	  if (!data) {
	    return {
	      dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine)
	    };
	  }
	
	  var dimensionsDetectCount;
	  var startIndex;
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    // Rule: Most of the first line are string: it is header.
	    // Caution: consider a line with 5 string and 1 number,
	    // it still can not be sure it is a head, because the
	    // 5 string may be 5 values of category columns.
	    if (sourceHeader === 'auto' || sourceHeader == null) {
	      arrayRowsTravelFirst(function (val) {
	        // '-' is regarded as null/undefined.
	        if (val != null && val !== '-') {
	          if (isString(val)) {
	            startIndex == null && (startIndex = 1);
	          } else {
	            startIndex = 0;
	          }
	        } // 10 is an experience number, avoid long loop.
	
	      }, seriesLayoutBy, data, 10);
	    } else {
	      startIndex = sourceHeader ? 1 : 0;
	    }
	
	    if (!dimensionsDefine && startIndex === 1) {
	      dimensionsDefine = [];
	      arrayRowsTravelFirst(function (val, index) {
	        dimensionsDefine[index] = val != null ? val : '';
	      }, seriesLayoutBy, data);
	    }
	
	    dimensionsDetectCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? data.length : data[0] ? data[0].length : null;
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = objectRowsCollectDimensions(data);
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = [];
	      each(data, function (colArr, key) {
	        dimensionsDefine.push(key);
	      });
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var value0 = getDataItemValue(data[0]);
	    dimensionsDetectCount = isArray(value0) && value0.length || 1;
	  } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {}
	
	  return {
	    startIndex: startIndex,
	    dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine),
	    dimensionsDetectCount: dimensionsDetectCount
	  };
	} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
	// which is reasonable. But dimension name is duplicated.
	// Returns undefined or an array contains only object without null/undefiend or string.
	
	
	function normalizeDimensionsDefine(dimensionsDefine) {
	  if (!dimensionsDefine) {
	    // The meaning of null/undefined is different from empty array.
	    return;
	  }
	
	  var nameMap = createHashMap();
	  return map(dimensionsDefine, function (item, index) {
	    item = extend({}, isObject(item) ? item : {
	      name: item
	    }); // User can set null in dimensions.
	    // We dont auto specify name, othewise a given name may
	    // cause it be refered unexpectedly.
	
	    if (item.name == null) {
	      return item;
	    } // Also consider number form like 2012.
	
	
	    item.name += ''; // User may also specify displayName.
	    // displayName will always exists except user not
	    // specified or dim name is not specified or detected.
	    // (A auto generated dim name will not be used as
	    // displayName).
	
	    if (item.displayName == null) {
	      item.displayName = item.name;
	    }
	
	    var exist = nameMap.get(item.name);
	
	    if (!exist) {
	      nameMap.set(item.name, {
	        count: 1
	      });
	    } else {
	      item.name += '-' + exist.count++;
	    }
	
	    return item;
	  });
	}
	
	function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
	  maxLoop == null && (maxLoop = Infinity);
	
	  if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      cb(data[i] ? data[i][0] : null, i);
	    }
	  } else {
	    var value0 = data[0] || [];
	
	    for (var i = 0; i < value0.length && i < maxLoop; i++) {
	      cb(value0[i], i);
	    }
	  }
	}
	
	function objectRowsCollectDimensions(data) {
	  var firstIndex = 0;
	  var obj;
	
	  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line
	
	
	  if (obj) {
	    var dimensions = [];
	    each(obj, function (value, key) {
	      dimensions.push(key);
	    });
	    return dimensions;
	  }
	}
	/**
	 * [The strategy of the arrengment of data dimensions for dataset]:
	 * "value way": all axes are non-category axes. So series one by one take
	 *     several (the number is coordSysDims.length) dimensions from dataset.
	 *     The result of data arrengment of data dimensions like:
	 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
	 * "category way": at least one axis is category axis. So the the first data
	 *     dimension is always mapped to the first category axis and shared by
	 *     all of the series. The other data dimensions are taken by series like
	 *     "value way" does.
	 *     The result of data arrengment of data dimensions like:
	 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
	 *
	 * @param {Array.<Object|string>} coordDimensions [{name: <string>, type: <string>, dimsDef: <Array>}, ...]
	 * @param {module:model/Series} seriesModel
	 * @param {module:data/Source} source
	 * @return {Object} encode Never be `null/undefined`.
	 */
	
	
	function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
	  var encode = {};
	  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	  if (!datasetModel || !coordDimensions) {
	    return encode;
	  }
	
	  var encodeItemName = [];
	  var encodeSeriesName = [];
	  var ecModel = seriesModel.ecModel;
	  var datasetMap = inner(ecModel).datasetMap;
	  var key = datasetModel.uid + '_' + source.seriesLayoutBy;
	  var baseCategoryDimIndex;
	  var categoryWayValueDimStart;
	  coordDimensions = coordDimensions.slice();
	  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	    !isObject(coordDimInfo) && (coordDimensions[coordDimIdx] = {
	      name: coordDimInfo
	    });
	
	    if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
	      baseCategoryDimIndex = coordDimIdx;
	      categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimensions[coordDimIdx]);
	    }
	
	    encode[coordDimInfo.name] = [];
	  });
	  var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
	    categoryWayDim: categoryWayValueDimStart,
	    valueWayDim: 0
	  }); // TODO
	  // Auto detect first time axis and do arrangement.
	
	  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	    var coordDimName = coordDimInfo.name;
	    var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
	
	    if (baseCategoryDimIndex == null) {
	      var start = datasetRecord.valueWayDim;
	      pushDim(encode[coordDimName], start, count);
	      pushDim(encodeSeriesName, start, count);
	      datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
	      // especially when encode x y specified.
	      // consider: when mutiple series share one dimension
	      // category axis, series name should better use
	      // the other dimsion name. On the other hand, use
	      // both dimensions name.
	    } // In category way, the first category axis.
	    else if (baseCategoryDimIndex === coordDimIdx) {
	        pushDim(encode[coordDimName], 0, count);
	        pushDim(encodeItemName, 0, count);
	      } // In category way, the other axis.
	      else {
	          var start = datasetRecord.categoryWayDim;
	          pushDim(encode[coordDimName], start, count);
	          pushDim(encodeSeriesName, start, count);
	          datasetRecord.categoryWayDim += count;
	        }
	  });
	
	  function pushDim(dimIdxArr, idxFrom, idxCount) {
	    for (var i = 0; i < idxCount; i++) {
	      dimIdxArr.push(idxFrom + i);
	    }
	  }
	
	  function getDataDimCountOnCoordDim(coordDimInfo) {
	    var dimsDef = coordDimInfo.dimsDef;
	    return dimsDef ? dimsDef.length : 1;
	  }
	
	  encodeItemName.length && (encode.itemName = encodeItemName);
	  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
	  return encode;
	}
	/**
	 * Work for data like [{name: ..., value: ...}, ...].
	 *
	 * @param {module:model/Series} seriesModel
	 * @param {module:data/Source} source
	 * @return {Object} encode Never be `null/undefined`.
	 */
	
	
	function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
	  var encode = {};
	  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	  if (!datasetModel) {
	    return encode;
	  }
	
	  var sourceFormat = source.sourceFormat;
	  var dimensionsDefine = source.dimensionsDefine;
	  var potentialNameDimIndex;
	
	  if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    each(dimensionsDefine, function (dim, idx) {
	      if ((isObject(dim) ? dim.name : dim) === 'name') {
	        potentialNameDimIndex = idx;
	      }
	    });
	  } // idxResult: {v, n}.
	
	
	  var idxResult = function () {
	    var idxRes0 = {};
	    var idxRes1 = {};
	    var guessRecords = []; // 5 is an experience value.
	
	    for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
	      var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
	      guessRecords.push(guessResult);
	      var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
	      // and then find a name dim with the priority:
	      // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
	
	      if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
	        idxRes0.v = i;
	      }
	
	      if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
	        idxRes0.n = i;
	      }
	
	      if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
	        return idxRes0;
	      } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
	      // find the first BE_ORDINAL.Might as the value dim,
	      // and then find a name dim with the priority:
	      // "other dim" > "the value dim itself".
	      // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
	      // treated as number.
	
	
	      if (!isPureNumber) {
	        if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
	          idxRes1.v = i;
	        }
	
	        if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
	          idxRes1.n = i;
	        }
	      }
	    }
	
	    function fulfilled(idxResult) {
	      return idxResult.v != null && idxResult.n != null;
	    }
	
	    return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
	  }();
	
	  if (idxResult) {
	    encode.value = idxResult.v; // `potentialNameDimIndex` has highest priority.
	
	    var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
	    // So we dont set encodeLabel here.
	
	    encode.itemName = [nameDimIndex];
	    encode.seriesName = [nameDimIndex];
	  }
	
	  return encode;
	}
	/**
	 * If return null/undefined, indicate that should not use datasetModel.
	 */
	
	
	function getDatasetModel(seriesModel) {
	  var option = seriesModel.option; // Caution: consider the scenario:
	  // A dataset is declared and a series is not expected to use the dataset,
	  // and at the beginning `setOption({series: { noData })` (just prepare other
	  // option but no data), then `setOption({series: {data: [...]}); In this case,
	  // the user should set an empty array to avoid that dataset is used by default.
	
	  var thisData = option.data;
	
	  if (!thisData) {
	    return seriesModel.ecModel.getComponent('dataset', option.datasetIndex || 0);
	  }
	}
	/**
	 * The rule should not be complex, otherwise user might not
	 * be able to known where the data is wrong.
	 * The code is ugly, but how to make it neat?
	 *
	 * @param {module:echars/data/Source} source
	 * @param {number} dimIndex
	 * @return {BE_ORDINAL} guess result.
	 */
	
	
	function guessOrdinal(source, dimIndex) {
	  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
	} // dimIndex may be overflow source data.
	// return {BE_ORDINAL}
	
	
	function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
	  var result; // Experience value.
	
	  var maxLoop = 5;
	
	  if (isTypedArray(data)) {
	    return BE_ORDINAL.Not;
	  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
	  // always exists in source.
	
	
	  var dimName;
	  var dimType;
	
	  if (dimensionsDefine) {
	    var dimDefItem = dimensionsDefine[dimIndex];
	
	    if (isObject(dimDefItem)) {
	      dimName = dimDefItem.name;
	      dimType = dimDefItem.type;
	    } else if (isString(dimDefItem)) {
	      dimName = dimDefItem;
	    }
	  }
	
	  if (dimType != null) {
	    return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
	  }
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	      var sample = data[dimIndex];
	
	      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
	        if ((result = detectValue(sample[startIndex + i])) != null) {
	          return result;
	        }
	      }
	    } else {
	      for (var i = 0; i < data.length && i < maxLoop; i++) {
	        var row = data[startIndex + i];
	
	        if (row && (result = detectValue(row[dimIndex])) != null) {
	          return result;
	        }
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimName) {
	      return BE_ORDINAL.Not;
	    }
	
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	
	      if (item && (result = detectValue(item[dimName])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimName) {
	      return BE_ORDINAL.Not;
	    }
	
	    var sample = data[dimName];
	
	    if (!sample || isTypedArray(sample)) {
	      return BE_ORDINAL.Not;
	    }
	
	    for (var i = 0; i < sample.length && i < maxLoop; i++) {
	      if ((result = detectValue(sample[i])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	      var val = getDataItemValue(item);
	
	      if (!isArray(val)) {
	        return BE_ORDINAL.Not;
	      }
	
	      if ((result = detectValue(val[dimIndex])) != null) {
	        return result;
	      }
	    }
	  }
	
	  function detectValue(val) {
	    var beStr = isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
	    // `isFinit('')` get `true`.
	
	    if (val != null && isFinite(val) && val !== '') {
	      return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
	    } else if (beStr && val !== '-') {
	      return BE_ORDINAL.Must;
	    }
	  }
	
	  return BE_ORDINAL.Not;
	}
	
	exports.BE_ORDINAL = BE_ORDINAL;
	exports.detectSourceFormat = detectSourceFormat;
	exports.getSource = getSource;
	exports.resetSourceDefaulter = resetSourceDefaulter;
	exports.prepareSource = prepareSource;
	exports.makeSeriesEncodeForAxisCoordSys = makeSeriesEncodeForAxisCoordSys;
	exports.makeSeriesEncodeForNameBased = makeSeriesEncodeForNameBased;
	exports.guessOrdinal = guessOrdinal;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TYPE_DELIMITER = '.';
	var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
	/**
	 * Notice, parseClassType('') should returns {main: '', sub: ''}
	 * @public
	 */
	
	function parseClassType(componentType) {
	  var ret = {
	    main: '',
	    sub: ''
	  };
	
	  if (componentType) {
	    componentType = componentType.split(TYPE_DELIMITER);
	    ret.main = componentType[0] || '';
	    ret.sub = componentType[1] || '';
	  }
	
	  return ret;
	}
	/**
	 * @public
	 */
	
	
	function checkClassType(componentType) {
	  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
	}
	/**
	 * @public
	 */
	
	
	function enableClassExtend(RootClass, mandatoryMethods) {
	  RootClass.$constructor = RootClass;
	
	  RootClass.extend = function (proto) {
	    var superClass = this;
	
	    var ExtendedClass = function () {
	      if (!proto.$constructor) {
	        superClass.apply(this, arguments);
	      } else {
	        proto.$constructor.apply(this, arguments);
	      }
	    };
	
	    zrUtil.extend(ExtendedClass.prototype, proto);
	    ExtendedClass.extend = this.extend;
	    ExtendedClass.superCall = superCall;
	    ExtendedClass.superApply = superApply;
	    zrUtil.inherits(ExtendedClass, this);
	    ExtendedClass.superClass = superClass;
	    return ExtendedClass;
	  };
	}
	
	var classBase = 0;
	/**
	 * Can not use instanceof, consider different scope by
	 * cross domain or es module import in ec extensions.
	 * Mount a method "isInstance()" to Clz.
	 */
	
	function enableClassCheck(Clz) {
	  var classAttr = ['__\0is_clz', classBase++, Math.random().toFixed(3)].join('_');
	  Clz.prototype[classAttr] = true;
	
	  Clz.isInstance = function (obj) {
	    return !!(obj && obj[classAttr]);
	  };
	} // superCall should have class info, which can not be fetch from 'this'.
	// Consider this case:
	// class A has method f,
	// class B inherits class A, overrides method f, f call superApply('f'),
	// class C inherits class B, do not overrides method f,
	// then when method of class C is called, dead loop occured.
	
	
	function superCall(context, methodName) {
	  var args = zrUtil.slice(arguments, 2);
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	
	function superApply(context, methodName, args) {
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	/**
	 * @param {Object} entity
	 * @param {Object} options
	 * @param {boolean} [options.registerWhenExtend]
	 * @public
	 */
	
	
	function enableClassManagement(entity, options) {
	  options = options || {};
	  /**
	   * Component model classes
	   * key: componentType,
	   * value:
	   *     componentClass, when componentType is 'xxx'
	   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
	   * @type {Object}
	   */
	
	  var storage = {};
	
	  entity.registerClass = function (Clazz, componentType) {
	    if (componentType) {
	      checkClassType(componentType);
	      componentType = parseClassType(componentType);
	
	      if (!componentType.sub) {
	        storage[componentType.main] = Clazz;
	      } else if (componentType.sub !== IS_CONTAINER) {
	        var container = makeContainer(componentType);
	        container[componentType.sub] = Clazz;
	      }
	    }
	
	    return Clazz;
	  };
	
	  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
	    var Clazz = storage[componentMainType];
	
	    if (Clazz && Clazz[IS_CONTAINER]) {
	      Clazz = subType ? Clazz[subType] : null;
	    }
	
	    if (throwWhenNotFound && !Clazz) {
	      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
	    }
	
	    return Clazz;
	  };
	
	  entity.getClassesByMainType = function (componentType) {
	    componentType = parseClassType(componentType);
	    var result = [];
	    var obj = storage[componentType.main];
	
	    if (obj && obj[IS_CONTAINER]) {
	      zrUtil.each(obj, function (o, type) {
	        type !== IS_CONTAINER && result.push(o);
	      });
	    } else {
	      result.push(obj);
	    }
	
	    return result;
	  };
	
	  entity.hasClass = function (componentType) {
	    // Just consider componentType.main.
	    componentType = parseClassType(componentType);
	    return !!storage[componentType.main];
	  };
	  /**
	   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
	   */
	
	
	  entity.getAllClassMainTypes = function () {
	    var types = [];
	    zrUtil.each(storage, function (obj, type) {
	      types.push(type);
	    });
	    return types;
	  };
	  /**
	   * If a main type is container and has sub types
	   * @param  {string}  mainType
	   * @return {boolean}
	   */
	
	
	  entity.hasSubTypes = function (componentType) {
	    componentType = parseClassType(componentType);
	    var obj = storage[componentType.main];
	    return obj && obj[IS_CONTAINER];
	  };
	
	  entity.parseClassType = parseClassType;
	
	  function makeContainer(componentType) {
	    var container = storage[componentType.main];
	
	    if (!container || !container[IS_CONTAINER]) {
	      container = storage[componentType.main] = {};
	      container[IS_CONTAINER] = true;
	    }
	
	    return container;
	  }
	
	  if (options.registerWhenExtend) {
	    var originalExtend = entity.extend;
	
	    if (originalExtend) {
	      entity.extend = function (proto) {
	        var ExtendedClass = originalExtend.call(this, proto);
	        return entity.registerClass(ExtendedClass, proto.type);
	      };
	    }
	  }
	
	  return entity;
	}
	/**
	 * @param {string|Array.<string>} properties
	 */
	
	
	function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
	  // if (!zrUtil.isArray(properties)) {
	  //     properties = properties != null ? [properties] : [];
	  // }
	  // zrUtil.each(properties, function (prop) {
	  //     var value = obj[prop];
	  //     Object.defineProperty
	  //         && Object.defineProperty(obj, prop, {
	  //             value: value, writable: false
	  //         });
	  //     zrUtil.isArray(obj[prop])
	  //         && Object.freeze
	  //         && Object.freeze(obj[prop]);
	  // });
	}
	
	exports.parseClassType = parseClassType;
	exports.enableClassExtend = enableClassExtend;
	exports.enableClassCheck = enableClassCheck;
	exports.enableClassManagement = enableClassManagement;
	exports.setReadOnly = setReadOnly;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1388);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(23);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(239);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(248);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(38);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var X32WordArray = C_lib.WordArray;
	
			/**
	   * x64 namespace.
	   */
			var C_x64 = C.x64 = {};
	
			/**
	   * A 64-bit word.
	   */
			var X64Word = C_x64.Word = Base.extend({
				/**
	    * Initializes a newly created 64-bit word.
	    *
	    * @param {number} high The high 32 bits.
	    * @param {number} low The low 32 bits.
	    *
	    * @example
	    *
	    *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	    */
				init: function init(high, low) {
					this.high = high;
					this.low = low;
				}
	
				/**
	    * Bitwise NOTs this word.
	    *
	    * @return {X64Word} A new x64-Word object after negating.
	    *
	    * @example
	    *
	    *     var negated = x64Word.not();
	    */
				// not: function () {
				// var high = ~this.high;
				// var low = ~this.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise ANDs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to AND with this word.
	    *
	    * @return {X64Word} A new x64-Word object after ANDing.
	    *
	    * @example
	    *
	    *     var anded = x64Word.and(anotherX64Word);
	    */
				// and: function (word) {
				// var high = this.high & word.high;
				// var low = this.low & word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise ORs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to OR with this word.
	    *
	    * @return {X64Word} A new x64-Word object after ORing.
	    *
	    * @example
	    *
	    *     var ored = x64Word.or(anotherX64Word);
	    */
				// or: function (word) {
				// var high = this.high | word.high;
				// var low = this.low | word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise XORs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to XOR with this word.
	    *
	    * @return {X64Word} A new x64-Word object after XORing.
	    *
	    * @example
	    *
	    *     var xored = x64Word.xor(anotherX64Word);
	    */
				// xor: function (word) {
				// var high = this.high ^ word.high;
				// var low = this.low ^ word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Shifts this word n bits to the left.
	    *
	    * @param {number} n The number of bits to shift.
	    *
	    * @return {X64Word} A new x64-Word object after shifting.
	    *
	    * @example
	    *
	    *     var shifted = x64Word.shiftL(25);
	    */
				// shiftL: function (n) {
				// if (n < 32) {
				// var high = (this.high << n) | (this.low >>> (32 - n));
				// var low = this.low << n;
				// } else {
				// var high = this.low << (n - 32);
				// var low = 0;
				// }
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Shifts this word n bits to the right.
	    *
	    * @param {number} n The number of bits to shift.
	    *
	    * @return {X64Word} A new x64-Word object after shifting.
	    *
	    * @example
	    *
	    *     var shifted = x64Word.shiftR(7);
	    */
				// shiftR: function (n) {
				// if (n < 32) {
				// var low = (this.low >>> n) | (this.high << (32 - n));
				// var high = this.high >>> n;
				// } else {
				// var low = this.high >>> (n - 32);
				// var high = 0;
				// }
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Rotates this word n bits to the left.
	    *
	    * @param {number} n The number of bits to rotate.
	    *
	    * @return {X64Word} A new x64-Word object after rotating.
	    *
	    * @example
	    *
	    *     var rotated = x64Word.rotL(25);
	    */
				// rotL: function (n) {
				// return this.shiftL(n).or(this.shiftR(64 - n));
				// },
	
				/**
	    * Rotates this word n bits to the right.
	    *
	    * @param {number} n The number of bits to rotate.
	    *
	    * @return {X64Word} A new x64-Word object after rotating.
	    *
	    * @example
	    *
	    *     var rotated = x64Word.rotR(7);
	    */
				// rotR: function (n) {
				// return this.shiftR(n).or(this.shiftL(64 - n));
				// },
	
				/**
	    * Adds this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to add with this word.
	    *
	    * @return {X64Word} A new x64-Word object after adding.
	    *
	    * @example
	    *
	    *     var added = x64Word.add(anotherX64Word);
	    */
				// add: function (word) {
				// var low = (this.low + word.low) | 0;
				// var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
				// var high = (this.high + word.high + carry) | 0;
	
				// return X64Word.create(high, low);
				// }
			});
	
			/**
	   * An array of 64-bit words.
	   *
	   * @property {Array} words The array of CryptoJS.x64.Word objects.
	   * @property {number} sigBytes The number of significant bytes in this word array.
	   */
			var X64WordArray = C_x64.WordArray = Base.extend({
				/**
	    * Initializes a newly created word array.
	    *
	    * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	    * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create();
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create([
	    *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	    *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	    *     ]);
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create([
	    *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	    *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	    *     ], 10);
	    */
				init: function init(words, sigBytes) {
					words = this.words = words || [];
	
					if (sigBytes != undefined) {
						this.sigBytes = sigBytes;
					} else {
						this.sigBytes = words.length * 8;
					}
				},
	
				/**
	    * Converts this 64-bit word array to a 32-bit word array.
	    *
	    * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	    *
	    * @example
	    *
	    *     var x32WordArray = x64WordArray.toX32();
	    */
				toX32: function toX32() {
					// Shortcuts
					var x64Words = this.words;
					var x64WordsLength = x64Words.length;
	
					// Convert
					var x32Words = [];
					for (var i = 0; i < x64WordsLength; i++) {
						var x64Word = x64Words[i];
						x32Words.push(x64Word.high);
						x32Words.push(x64Word.low);
					}
	
					return X32WordArray.create(x32Words, this.sigBytes);
				},
	
				/**
	    * Creates a copy of this word array.
	    *
	    * @return {X64WordArray} The clone.
	    *
	    * @example
	    *
	    *     var clone = x64WordArray.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
	
					// Clone "words" array
					var words = clone.words = this.words.slice(0);
	
					// Clone each X64Word object
					var wordsLength = words.length;
					for (var i = 0; i < wordsLength; i++) {
						words[i] = words[i].clone();
					}
	
					return clone;
				}
			});
		})();
	
		return CryptoJS;
	});

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcTooltip = _interopRequireDefault(__webpack_require__(483));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _placements = _interopRequireDefault(__webpack_require__(1113));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var splitObject = function splitObject(obj, keys) {
	  var picked = {};
	
	  var omitted = _extends({}, obj);
	
	  keys.forEach(function (key) {
	    if (obj && key in obj) {
	      picked[key] = obj[key];
	      delete omitted[key];
	    }
	  });
	  return {
	    picked: picked,
	    omitted: omitted
	  };
	}; // Fix Tooltip won't hide at disabled button
	// mouse events don't trigger at disabled button in Chrome
	// https://github.com/react-component/tooltip/issues/18
	
	
	function getDisabledCompatibleChildren(element) {
	  var elementType = element.type;
	
	  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === 'button') && element.props.disabled) {
	    // Pick some layout related style properties up to span
	    // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
	    var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
	        picked = _splitObject.picked,
	        omitted = _splitObject.omitted;
	
	    var spanStyle = _extends(_extends({
	      display: 'inline-block'
	    }, picked), {
	      cursor: 'not-allowed',
	      width: element.props.block ? '100%' : null
	    });
	
	    var buttonStyle = _extends(_extends({}, omitted), {
	      pointerEvents: 'none'
	    });
	
	    var child = /*#__PURE__*/React.cloneElement(element, {
	      style: buttonStyle,
	      className: null
	    });
	    return (/*#__PURE__*/React.createElement("span", {
	        style: spanStyle,
	        className: element.props.className
	      }, child)
	    );
	  }
	
	  return element;
	}
	
	var Tooltip = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tooltip, _React$Component);
	
	  var _super = _createSuper(Tooltip);
	
	  function Tooltip(props) {
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    _this = _super.call(this, props);
	
	    _this.onVisibleChange = function (visible) {
	      var onVisibleChange = _this.props.onVisibleChange;
	
	      if (!('visible' in _this.props)) {
	        _this.setState({
	          visible: _this.isNoTitle() ? false : visible
	        });
	      }
	
	      if (onVisibleChange && !_this.isNoTitle()) {
	        onVisibleChange(visible);
	      }
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    }; // 动态设置动画点
	
	
	    _this.onPopupAlign = function (domNode, align) {
	      var placements = _this.getPlacements(); // 当前返回的位置
	
	
	      var placement = Object.keys(placements).filter(function (key) {
	        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
	      })[0];
	
	      if (!placement) {
	        return;
	      } // 根据当前坐标设置动画点
	
	
	      var rect = domNode.getBoundingClientRect();
	      var transformOrigin = {
	        top: '50%',
	        left: '50%'
	      };
	
	      if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
	        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
	      } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
	        transformOrigin.top = "".concat(-align.offset[1], "px");
	      }
	
	      if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
	        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
	      } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
	        transformOrigin.left = "".concat(-align.offset[0], "px");
	      }
	
	      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
	    };
	
	    _this.renderTooltip = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          openClassName = props.openClassName,
	          getPopupContainer = props.getPopupContainer,
	          getTooltipContainer = props.getTooltipContainer;
	      var children = props.children;
	      var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
	      var visible = state.visible; // Hide tooltip when there is no title
	
	      if (!('visible' in props) && _this.isNoTitle()) {
	        visible = false;
	      }
	
	      var child = getDisabledCompatibleChildren( /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement("span", null, children));
	      var childProps = child.props;
	      var childCls = (0, _classnames["default"])(childProps.className, _defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true));
	      return (/*#__PURE__*/React.createElement(_rcTooltip["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
	          ref: _this.saveTooltip,
	          builtinPlacements: _this.getPlacements(),
	          overlay: _this.getOverlay(),
	          visible: visible,
	          onVisibleChange: _this.onVisibleChange,
	          onPopupAlign: _this.onPopupAlign
	        }), visible ? /*#__PURE__*/React.cloneElement(child, {
	          className: childCls
	        }) : child)
	      );
	    };
	
	    _this.state = {
	      visible: !!props.visible || !!props.defaultVisible
	    };
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getPlacements",
	    value: function getPlacements() {
	      var _this$props = this.props,
	          builtinPlacements = _this$props.builtinPlacements,
	          arrowPointAtCenter = _this$props.arrowPointAtCenter,
	          autoAdjustOverflow = _this$props.autoAdjustOverflow;
	      return builtinPlacements || (0, _placements["default"])({
	        arrowPointAtCenter: arrowPointAtCenter,
	        verticalArrowShift: 8,
	        autoAdjustOverflow: autoAdjustOverflow
	      });
	    }
	  }, {
	    key: "isNoTitle",
	    value: function isNoTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          overlay = _this$props2.overlay;
	      return !title && !overlay && title !== 0; // overlay for old version compatibility
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          overlay = _this$props3.overlay;
	
	      if (title === 0) {
	        return title;
	      }
	
	      return overlay || title || '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTooltip)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tooltip;
	}(React.Component);
	
	Tooltip.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big-fast',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  arrowPointAtCenter: false,
	  autoAdjustOverflow: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Tooltip);
	var _default = Tooltip;
	exports["default"] = _default;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var X32WordArray = C_lib.WordArray;
	
			/**
	   * x64 namespace.
	   */
			var C_x64 = C.x64 = {};
	
			/**
	   * A 64-bit word.
	   */
			var X64Word = C_x64.Word = Base.extend({
				/**
	    * Initializes a newly created 64-bit word.
	    *
	    * @param {number} high The high 32 bits.
	    * @param {number} low The low 32 bits.
	    *
	    * @example
	    *
	    *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	    */
				init: function init(high, low) {
					this.high = high;
					this.low = low;
				}
	
				/**
	    * Bitwise NOTs this word.
	    *
	    * @return {X64Word} A new x64-Word object after negating.
	    *
	    * @example
	    *
	    *     var negated = x64Word.not();
	    */
				// not: function () {
				// var high = ~this.high;
				// var low = ~this.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise ANDs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to AND with this word.
	    *
	    * @return {X64Word} A new x64-Word object after ANDing.
	    *
	    * @example
	    *
	    *     var anded = x64Word.and(anotherX64Word);
	    */
				// and: function (word) {
				// var high = this.high & word.high;
				// var low = this.low & word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise ORs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to OR with this word.
	    *
	    * @return {X64Word} A new x64-Word object after ORing.
	    *
	    * @example
	    *
	    *     var ored = x64Word.or(anotherX64Word);
	    */
				// or: function (word) {
				// var high = this.high | word.high;
				// var low = this.low | word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise XORs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to XOR with this word.
	    *
	    * @return {X64Word} A new x64-Word object after XORing.
	    *
	    * @example
	    *
	    *     var xored = x64Word.xor(anotherX64Word);
	    */
				// xor: function (word) {
				// var high = this.high ^ word.high;
				// var low = this.low ^ word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Shifts this word n bits to the left.
	    *
	    * @param {number} n The number of bits to shift.
	    *
	    * @return {X64Word} A new x64-Word object after shifting.
	    *
	    * @example
	    *
	    *     var shifted = x64Word.shiftL(25);
	    */
				// shiftL: function (n) {
				// if (n < 32) {
				// var high = (this.high << n) | (this.low >>> (32 - n));
				// var low = this.low << n;
				// } else {
				// var high = this.low << (n - 32);
				// var low = 0;
				// }
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Shifts this word n bits to the right.
	    *
	    * @param {number} n The number of bits to shift.
	    *
	    * @return {X64Word} A new x64-Word object after shifting.
	    *
	    * @example
	    *
	    *     var shifted = x64Word.shiftR(7);
	    */
				// shiftR: function (n) {
				// if (n < 32) {
				// var low = (this.low >>> n) | (this.high << (32 - n));
				// var high = this.high >>> n;
				// } else {
				// var low = this.high >>> (n - 32);
				// var high = 0;
				// }
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Rotates this word n bits to the left.
	    *
	    * @param {number} n The number of bits to rotate.
	    *
	    * @return {X64Word} A new x64-Word object after rotating.
	    *
	    * @example
	    *
	    *     var rotated = x64Word.rotL(25);
	    */
				// rotL: function (n) {
				// return this.shiftL(n).or(this.shiftR(64 - n));
				// },
	
				/**
	    * Rotates this word n bits to the right.
	    *
	    * @param {number} n The number of bits to rotate.
	    *
	    * @return {X64Word} A new x64-Word object after rotating.
	    *
	    * @example
	    *
	    *     var rotated = x64Word.rotR(7);
	    */
				// rotR: function (n) {
				// return this.shiftR(n).or(this.shiftL(64 - n));
				// },
	
				/**
	    * Adds this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to add with this word.
	    *
	    * @return {X64Word} A new x64-Word object after adding.
	    *
	    * @example
	    *
	    *     var added = x64Word.add(anotherX64Word);
	    */
				// add: function (word) {
				// var low = (this.low + word.low) | 0;
				// var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
				// var high = (this.high + word.high + carry) | 0;
	
				// return X64Word.create(high, low);
				// }
			});
	
			/**
	   * An array of 64-bit words.
	   *
	   * @property {Array} words The array of CryptoJS.x64.Word objects.
	   * @property {number} sigBytes The number of significant bytes in this word array.
	   */
			var X64WordArray = C_x64.WordArray = Base.extend({
				/**
	    * Initializes a newly created word array.
	    *
	    * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	    * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create();
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create([
	    *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	    *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	    *     ]);
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create([
	    *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	    *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	    *     ], 10);
	    */
				init: function init(words, sigBytes) {
					words = this.words = words || [];
	
					if (sigBytes != undefined) {
						this.sigBytes = sigBytes;
					} else {
						this.sigBytes = words.length * 8;
					}
				},
	
				/**
	    * Converts this 64-bit word array to a 32-bit word array.
	    *
	    * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	    *
	    * @example
	    *
	    *     var x32WordArray = x64WordArray.toX32();
	    */
				toX32: function toX32() {
					// Shortcuts
					var x64Words = this.words;
					var x64WordsLength = x64Words.length;
	
					// Convert
					var x32Words = [];
					for (var i = 0; i < x64WordsLength; i++) {
						var x64Word = x64Words[i];
						x32Words.push(x64Word.high);
						x32Words.push(x64Word.low);
					}
	
					return X32WordArray.create(x32Words, this.sigBytes);
				},
	
				/**
	    * Creates a copy of this word array.
	    *
	    * @return {X64WordArray} The clone.
	    *
	    * @example
	    *
	    *     var clone = x64WordArray.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
	
					// Clone "words" array
					var words = clone.words = this.words.slice(0);
	
					// Clone each X64Word object
					var wordsLength = words.length;
					for (var i = 0; i < wordsLength; i++) {
						words[i] = words[i].clone();
					}
	
					return clone;
				}
			});
		})();
	
		return CryptoJS;
	});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcTooltip = _interopRequireDefault(__webpack_require__(483));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _placements = _interopRequireDefault(__webpack_require__(1271));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var splitObject = function splitObject(obj, keys) {
	  var picked = {};
	
	  var omitted = _extends({}, obj);
	
	  keys.forEach(function (key) {
	    if (obj && key in obj) {
	      picked[key] = obj[key];
	      delete omitted[key];
	    }
	  });
	  return {
	    picked: picked,
	    omitted: omitted
	  };
	}; // Fix Tooltip won't hide at disabled button
	// mouse events don't trigger at disabled button in Chrome
	// https://github.com/react-component/tooltip/issues/18
	
	
	function getDisabledCompatibleChildren(element) {
	  var elementType = element.type;
	
	  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === 'button') && element.props.disabled) {
	    // Pick some layout related style properties up to span
	    // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
	    var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
	        picked = _splitObject.picked,
	        omitted = _splitObject.omitted;
	
	    var spanStyle = _extends(_extends({
	      display: 'inline-block'
	    }, picked), {
	      cursor: 'not-allowed',
	      width: element.props.block ? '100%' : null
	    });
	
	    var buttonStyle = _extends(_extends({}, omitted), {
	      pointerEvents: 'none'
	    });
	
	    var child = /*#__PURE__*/React.cloneElement(element, {
	      style: buttonStyle,
	      className: null
	    });
	    return (/*#__PURE__*/React.createElement("span", {
	        style: spanStyle,
	        className: element.props.className
	      }, child)
	    );
	  }
	
	  return element;
	}
	
	var Tooltip = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tooltip, _React$Component);
	
	  var _super = _createSuper(Tooltip);
	
	  function Tooltip(props) {
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    _this = _super.call(this, props);
	
	    _this.onVisibleChange = function (visible) {
	      var onVisibleChange = _this.props.onVisibleChange;
	
	      if (!('visible' in _this.props)) {
	        _this.setState({
	          visible: _this.isNoTitle() ? false : visible
	        });
	      }
	
	      if (onVisibleChange && !_this.isNoTitle()) {
	        onVisibleChange(visible);
	      }
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    }; // 动态设置动画点
	
	
	    _this.onPopupAlign = function (domNode, align) {
	      var placements = _this.getPlacements(); // 当前返回的位置
	
	
	      var placement = Object.keys(placements).filter(function (key) {
	        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
	      })[0];
	
	      if (!placement) {
	        return;
	      } // 根据当前坐标设置动画点
	
	
	      var rect = domNode.getBoundingClientRect();
	      var transformOrigin = {
	        top: '50%',
	        left: '50%'
	      };
	
	      if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
	        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
	      } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
	        transformOrigin.top = "".concat(-align.offset[1], "px");
	      }
	
	      if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
	        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
	      } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
	        transformOrigin.left = "".concat(-align.offset[0], "px");
	      }
	
	      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
	    };
	
	    _this.renderTooltip = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          openClassName = props.openClassName,
	          getPopupContainer = props.getPopupContainer,
	          getTooltipContainer = props.getTooltipContainer;
	      var children = props.children;
	      var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
	      var visible = state.visible; // Hide tooltip when there is no title
	
	      if (!('visible' in props) && _this.isNoTitle()) {
	        visible = false;
	      }
	
	      var child = getDisabledCompatibleChildren( /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement("span", null, children));
	      var childProps = child.props;
	      var childCls = (0, _classnames["default"])(childProps.className, _defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true));
	      return (/*#__PURE__*/React.createElement(_rcTooltip["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
	          ref: _this.saveTooltip,
	          builtinPlacements: _this.getPlacements(),
	          overlay: _this.getOverlay(),
	          visible: visible,
	          onVisibleChange: _this.onVisibleChange,
	          onPopupAlign: _this.onPopupAlign
	        }), visible ? /*#__PURE__*/React.cloneElement(child, {
	          className: childCls
	        }) : child)
	      );
	    };
	
	    _this.state = {
	      visible: !!props.visible || !!props.defaultVisible
	    };
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getPlacements",
	    value: function getPlacements() {
	      var _this$props = this.props,
	          builtinPlacements = _this$props.builtinPlacements,
	          arrowPointAtCenter = _this$props.arrowPointAtCenter,
	          autoAdjustOverflow = _this$props.autoAdjustOverflow;
	      return builtinPlacements || (0, _placements["default"])({
	        arrowPointAtCenter: arrowPointAtCenter,
	        verticalArrowShift: 8,
	        autoAdjustOverflow: autoAdjustOverflow
	      });
	    }
	  }, {
	    key: "isNoTitle",
	    value: function isNoTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          overlay = _this$props2.overlay;
	      return !title && !overlay && title !== 0; // overlay for old version compatibility
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          overlay = _this$props3.overlay;
	
	      if (title === 0) {
	        return title;
	      }
	
	      return overlay || title || '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTooltip)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tooltip;
	}(React.Component);
	
	Tooltip.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big-fast',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  arrowPointAtCenter: false,
	  autoAdjustOverflow: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Tooltip);
	var _default = Tooltip;
	exports["default"] = _default;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SgiMainComp = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiModal = __webpack_require__(711);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiMainComp = function (_React$Component) {
		_inherits(SgiMainComp, _React$Component);
	
		function SgiMainComp(props) {
			_classCallCheck(this, SgiMainComp);
	
			var _this = _possibleConstructorReturn(this, (SgiMainComp.__proto__ || Object.getPrototypeOf(SgiMainComp)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.state = {
				loading: false,
				loaded: false,
				mainUIProps: { style: { width: '100%' } },
				mainUIItems: [],
				modalItems: [],
				modalInstanceItems: []
			};
	
			var _this$props = _this.props,
			    objFct = _this$props.objFct,
			    type = _this$props.type;
	
	
			if (type !== 'dnd' && _this.props.type != "dnd-nest") {
				// 事件集解析
				if (_this.props.moduleDesc && _this.props.moduleDesc.funs) {
					var funs = _this.props.moduleDesc.funs;
					var reg = new RegExp(/console/gi);
					funs = funs.replace(reg, "tool.sgiLogger");
					try {
						var $funs = new Function("module", "objFct", funs);
						funs = $funs(_this, objFct);
						if (objFct) {
							var oFuns = objFct.get("@funs");
							if (!oFuns) {
								oFuns = {};
								objFct.set("@funs", oFuns);
							}
							Object.assign(oFuns, funs);
						}
					} catch (error) {
						_sgiLogger.sgiLogger.error("事件集解析出错，请检查组件自定义事件集书写是否正确！");
						_sgiLogger.sgiLogger.eventErr(error);
					}
				}
	
				// 事件集对象解析
				if (_this.props.moduleDesc && _this.props.moduleDesc.funObj) {
					var moduleDesc = _this.props.moduleDesc;
					// sgiLogger.time("事件集对象解析");
					var funObj = moduleDesc.funObj;
					var cnsts = funObj.cnsts; //常量
					var attrs = funObj.attrs; //属性
					var events = funObj.events; //事件
					var cnstObj = void 0;
					var retFlg = false,
					    cnstFlg = false;
					var belongUID = '[' + (moduleDesc.n || moduleDesc.te) + '][' + moduleDesc.guid + ']';
					var funStr = '';
					if (cnsts && cnsts.length > 0) {
						funStr += '' + cnsts.map(function (c) {
							return "const " + c.cnstKey + " = " + (c.cnstVal || "undefined") + ";\n";
						}).join("");
						cnstFlg = true;
						// 常量存储
						// cnstObj = {};
						// cnsts.forEach(c => cnstObj[c.cnstKey] = c.cnstVal ? eval(`(${c.cnstVal})`) : c.cnstVal);
						// if (objFct) {
						// 	let oCnsts = objFct.get("@cnsts");
						// 	if (!oCnsts) {
						// 		oCnsts = {};
						// 		objFct.set("@cnsts", oCnsts);
						// 	}
						// 	Object.assign(oCnsts, cnstObj);
						// }
					}
					if (attrs && attrs.length > 0) {
						funStr += 'return {\n';
						retFlg = true;
						funStr += '' + attrs.map(function (a) {
							return a.attrKey + ": " + (a.attrVal || "undefined") + ",\n";
						}).join("");
					}
					if (events && events.length > 0) {
						if (!retFlg) funStr += 'return {\n';
						retFlg = true;
						funStr += '' + events.map(function (e) {
							return e.eventKey + "(" + e.eventPrm + "){\ntool.sgiLogger.info('" + belongUID + "事件集执行, 方法名为：'+ '" + e.eventKey + "');\n" + e.eventBody + "\n},\n";
						}).join("");
					}
					if (retFlg) {
						if (cnstFlg) funStr += '_getAllConst(){ return { ' + cnsts.map(function (c) {
							return c.cnstKey;
						}).join(",") + ' }\n\t\t\t\t} \n\n\t\t\t} ';else funStr += '} ';
					} else if (cnstFlg) funStr += 'return { _getAllConst() { return { ' + cnsts.map(function (c) {
						return c.cnstKey;
					}).join(",") + ' } }\n\t}';
					// sgiLogger.debug_1("事件集配置解析，funStr：", funStr);
					if (funStr) {
						try {
							var _reg = new RegExp(/console/gi);
							funStr = funStr.replace(_reg, "tool.sgiLogger");
							var $f = new Function("module", "objFct", funStr);
							var fs = $f(_this, objFct);
							if (objFct) {
								// 存储事件
								var _oFuns = objFct.get("@funs");
								if (!_oFuns) {
									_oFuns = {};
									objFct.set("@funs", _oFuns);
								}
								Object.assign(_oFuns, fs);
								// 存储常量
								if (cnstFlg) {
									var oCnsts = objFct.get("@cnsts");
									if (!oCnsts) {
										oCnsts = {};
										objFct.set("@cnsts", oCnsts);
									}
									Object.assign(oCnsts, fs._getAllConst());
								}
							}
							// module存储一份
							if (_this.funs) Object.assign(_this.funs, fs);else _this.funs = Object.assign({}, fs);
						} catch (error) {
							_sgiLogger.sgiLogger.error("事件集配置解析出错，请检查UCV事件集配置是否正确！");
							_sgiLogger.sgiLogger.eventErr(error);
						}
					}
					// sgiLogger.timeEnd("事件集对象解析");
				}
			}
			return _this;
		}
	
		/**
	   * 根据描述创建form
	   * @param {父组件} parentModule
	   * @param {描述} moduleDesc
	   * @param {对象工厂} objFct
	   * @param {make类型} type
	   */
	
	
		_createClass(SgiMainComp, [{
			key: 'main_mk',
			value: function main_mk(parentModule, moduleDesc, objFct, type) {
				//获取需要展示的数据信息
				if (!moduleDesc) {
					return;
				}
				//传入的对象工厂是否为空
				if (!objFct) {
					return;
				}
	
				this.state.mainUIItems = []; //再次渲染的时候清空
				//转换form公共属性
				(0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.mainUIProps);
				//组装form表单下的控件信息
				if (type !== "dnd") this.fitMainUIItems(moduleDesc, this.state.mainUIItems, objFct, type);
			}
	
			/**
	   * 根据描述组装子对象
	   * @param {描述信息} moduleDesc
	   * @param {属性} formProps
	   */
	
	
			//render之前调用，业务逻辑都应该放在这里，如对state的操作等
	
		}, {
			key: 'getGuidSameGuidOpenSgiMain',
	
	
			/**
	   * 获取最顶的真实guid
	   * 同一个guid 打开2个不同个页面，会导致对象工厂冲突
	   * 所以在同一个guid 打开2个不同页面的时候，添加@@+随机数
	   * 含有@@的guid要用 uid存储变量，不含照旧
	   * @param {*} objFct 
	   */
			value: function getGuidSameGuidOpenSgiMain(objFct) {
				var uid = objFct.getUID();
				if (uid && uid.indexOf('@@') > 0) {
					var newGuid = uid.substr(0, uid.indexOf('@@'));
					return newGuid;
				} else {
					return uid;
				}
			}
	
			/**
	   * 获取注册的guid，主要区分顶级uid和嵌入弹出uid区别
	   * 同一个guid 打开2个不同个页面，会导致对象工厂冲突
	   * 所以在同一个guid 打开2个不同页面的时候，添加@@+随机数
	   * 含有@@的guid要用 uid存储变量，不含照旧
	   * @param {} objFct 
	   * @param {*} guid 
	   */
	
		}, {
			key: 'getUIDSameGuidOpenSgiMain',
			value: function getUIDSameGuidOpenSgiMain(guid, objFct) {
				var uid = objFct.getUID();
				if (uid && uid.indexOf('@@') > 0) {
					var newGuid = uid.substr(0, uid.indexOf('@@'));
					if (newGuid === guid) {
						return uid;
					} else {
						return guid;
					}
				} else {
					return guid;
				}
			}
	
			//该方法发生在render方法之后。在该方法中，ReactJS会使用render生成返回的虚拟DOM对象来创建真实的DOM结构
	
		}, {
			key: 'refresh',
			value: function refresh() {
				this.state.loaded = false;
				this.setState({ loading: false });
			}
		}, {
			key: 'removeModal',
			value: function removeModal() {
				this.state.modalItems.pop();
				this.state.modalInstanceItems.pop();
			}
	
			/**
	   * 添加展示modal 虚拟dom
	   * @param {} modal 
	   */
	
		}, {
			key: 'addModal',
			value: function addModal(modal) {
				if (!modal) {
					return;
				}
				this.state.modalItems.push(modal);
			}
	
			// 通过描述添加Modal
	
		}, {
			key: 'addModalByProps',
			value: function addModalByProps(prps) {
				if (!prps) return;
				this.state.modalItems.push(_react2.default.createElement(_SgiModal.SgiModal, prps));
			}
	
			/**
	   * 获取加载后的 组件
	   */
	
		}, {
			key: 'getModal',
			value: function getModal() {
				if (!this.state.modalInstanceItems.length) {
					return;
				}
				return this.state.modalInstanceItems[this.state.modalInstanceItems.length - 1];
			}
	
			/**
	   * 设置加载后的 组件
	   * 将加载后的组件信息管理起来，为了管理获取组件，操纵组件,跟addModal一起使用
	   * modal是在创建的的时候使用
	   * @param {*} modal
	   */
	
		}, {
			key: 'setModal',
			value: function setModal(modal) {
				if (!modal) {
					return;
				}
				this.state.modalInstanceItems.push(modal);
			}
	
			//渲染并返回一个虚拟DOM
	
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var _props = this.props,
				    moduleDesc = _props.moduleDesc,
				    objFct = _props.objFct;
	
				if (!objFct || !moduleDesc) return;
	
				// 销毁注册组件
				var guid = moduleDesc.guid; //获取当前页面guid
				// const uid = objFct.getUID();//获取主页面uid
	
				var uid = this.getGuidSameGuidOpenSgiMain(objFct); //获取主页面uid
				if (guid === uid) {
					// // 关闭事件
					// var clsLsn = moduleDesc.clsLsn;// 页面加载后监听器
					// if (clsLsn && this.props.type != 'dnd') {
					// 	try {
					// 		// sgiLogger.eventin('加载后');
					// 		var clsLsn = new Function("module", "objFct", clsLsn);
					// 		tool.sgiLogger.log('关闭事件');
					// 		clsLsn(this, objFct);
					// 	} catch (error) {
					// 		sgiLogger.eventErr(error);
					// 	}
					// }
					// 关闭事件
					if (this.props.type != 'dnd' && this.props.type != "dnd-nest") {
						try {
							if (moduleDesc.clsLsn && typeof moduleDesc.clsLsn == 'string') {
								var reg = new RegExp(/console/gi);
								moduleDesc.clsLsn = moduleDesc.clsLsn.replace(reg, "tool.sgiLogger");
							}
							var cls = (0, _SgiCommon.getFunctionByKey)(this, "clsLsn") || (moduleDesc.clsLsn ? new Function("module", "objFct", moduleDesc.clsLsn) : null);
							if (cls && typeof cls == "function") {
								_sgiLogger.sgiLogger.debug('关闭事件');
								cls(this, objFct);
							}
							// let cls;
							// if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys["clsLsn"]) {
							// 	// 事件集模式
							// 	// let funs = Object.assign({}, objFct.get("@funs"), this.funs);
							// 	// let key = moduleDesc.eventKeys["clsLsn"];
							// 	// cls = funs[key];
							// 	cls = getFunctionByKey(this, "clsLsn");
							// } else {
							// 	// 原事件模式
							// 	var clsLsn = moduleDesc.clsLsn;// 页面加载后监听器
							// 	cls = new Function("module", "objFct", clsLsn);
							// }
							// // var clsLsn = new Function("module", "objFct", clsLsn);
							// sgiLogger.debug('关闭事件');
							// cls(this, objFct);
	
							//清空对象工厂
							objFct.clear();
	
							//清空moduleDesc
							for (var key in moduleDesc) {
								delete moduleDesc[key];
							}
						} catch (error) {
							_sgiLogger.sgiLogger.eventErr(error);
						}
					}
	
					// 当前页面为主页面
					//删除主页面对应所有注册组件
					ComponentManager.deleteByUid(objFct.getUID() || uid); //使用弹出窗会出现bug
				} else {
						// 当前页面为弹出窗等页面，暂时不进行处理
						// ComponentManager.deleteById(guid);
	
					}
			}
		}]);
	
		return SgiMainComp;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
		var _this2 = this;
	
		this.fitMainUIItems = function (moduleDesc, mainUIItems, objFct, type) {
			var me = this;
	
			//form下的子节点添加到form组件中
			var cldSet = moduleDesc.cldSet;
			if (cldSet && cldSet.length && cldSet.length > 0) {
				cldSet.forEach(function (item, index) {
					var tmpSonComp = (0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type);
					if (tmpSonComp) {
						mainUIItems.push(tmpSonComp);
					}
				});
			}
		};
	
		this.componentWillMount = function () {
			//添加页面初始化监听器
			var _props2 = this.props,
			    moduleDesc = _props2.moduleDesc,
			    objFct = _props2.objFct;
	
			if (!moduleDesc || !objFct) {
				return;
			}
	
			//追加服务列表 地址放入对象工厂 wz 2020/3/10
			//wz 追加 服务列表放入到对象工厂
			if (moduleDesc.rlsSIList) {
				moduleDesc.rlsSIList.forEach(function (element) {
					var copyElement = {};
					if (element.siUrl && element.siUrl.indexOf("http") < 0) {
						// element.siUrl = sgiConfig.service + "/" + element.siUrl;
						copyElement.siUrl = sgiConfig.service + "/" + element.siUrl;
						copyElement.rlsGuid = element.rlsGuid;
						// objFct.set(element.siKey, sgiConfig.service + "/" + element.siUrl);
					} else {
						copyElement.siUrl = element.siUrl;
						copyElement.rlsGuid = element.rlsGuid;
						// objFct.set(element.siKey, element.siUrl);
					}
					//服务调用的时候 去处理拆分
					objFct.set(element.siKey, copyElement);
				});
			}
	
			// var initLsn = moduleDesc.initLsn;// 页面初始化监听器
			// if (initLsn && this.props.type != 'dnd') {
			// 	try {
			// 		// sgiLogger.eventin('初始化');
			// 		var initFn = new Function("module", "objFct", initLsn);
			// 		tool.sgiLogger.log('初始化');
			// 		tool.sgiLogger.time("初始化[" + moduleDesc.guid + "]");
			// 		initFn(this, objFct);
			// 		tool.sgiLogger.timeEnd("初始化[" + moduleDesc.guid + "]");
			// 	} catch (error) {
			// 		sgiLogger.eventErr(error);
			// 	}
			// }
			if (this.props.type != 'dnd' && this.props.type != "dnd-nest") {
				try {
	
					if (moduleDesc.initLsn && typeof moduleDesc.initLsn == "string") {
						var reg = new RegExp(/console/gi);
						moduleDesc.initLsn = moduleDesc.initLsn.replace(reg, "tool.sgiLogger");
					}
	
					var initFn = (0, _SgiCommon.getFunctionByKey)(this, "initLsn") || (moduleDesc.initLsn ? new Function("module", "objFct", moduleDesc.initLsn) : null);
					if (initFn && typeof initFn == "function") {
						_sgiLogger.sgiLogger.time("初始化[" + moduleDesc.guid + "]");
						initFn(this, objFct);
						_sgiLogger.sgiLogger.timeEnd("初始化[" + moduleDesc.guid + "]");
					}
					// let initFn;
					// if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys["initLsn"]) {
					// 	// 事件集模式
					// 	// let funs = Object.assign({}, objFct.get("@funs"), this.funs);
					// 	// let key = moduleDesc.eventKeys["initLsn"];
					// 	// initFn = funs[key];
					// 	initFn = getFunctionByKey(this, "initLsn");
					// } else {
					// 	// 原事件模式
					// 	var initLsn = moduleDesc.initLsn;// 页面初始化监听器
					// 	initFn = new Function("module", "objFct", initLsn);
					// }
					// var initFn = new Function("module", "objFct", initLsn);
					// sgiLogger.eventin('初始化');
					// sgiLogger.time("初始化[" + moduleDesc.guid + "]");
					// initFn(this, objFct);
					// sgiLogger.timeEnd("初始化[" + moduleDesc.guid + "]");
				} catch (error) {
					_sgiLogger.sgiLogger.eventErr(error);
				}
			}
		};
	
		this.componentDidMount = function () {
			tool.sgiLogger.log('SgiMainCompcomponentDidMount');
			//添加页面初始化监听器
			var _props3 = this.props,
			    moduleDesc = _props3.moduleDesc,
			    objFct = _props3.objFct;
	
			if (!moduleDesc || !objFct) {
				return;
			}
			//将所有引用 都放入到统一Manager里面管理起来
			this.fitComponentManager(this.refs, objFct.getUID());
			//把自己放进去 将所有引用 都放入到统一Manager里面管理起来
			ComponentManager.set(objFct.getUID(), this.getUIDSameGuidOpenSgiMain(_PrmFactory.PrmFactory.makeGUID(moduleDesc), objFct), this);
	
			// var initAftLsn = moduleDesc.initAftLsn;// 页面加载后监听器
			// if (initAftLsn && this.props.type != 'dnd') {
			// 	try {
			// 		// sgiLogger.eventin('加载后');
			// 		var initAftLsn = new Function("module", "objFct", initAftLsn);
			// 		tool.sgiLogger.log('加载后');
			// 		tool.sgiLogger.time("加载后[" + moduleDesc.guid + "]");
			// 		initAftLsn(this, objFct);
			// 		tool.sgiLogger.timeEnd("加载后[" + moduleDesc.guid + "]");
			// 	} catch (error) {
			// 		sgiLogger.eventErr(error);
			// 	}
			// }
			if (this.props.type != 'dnd' && this.props.type != "dnd-nest") {
				try {
					if (moduleDesc.initAftLsn && typeof moduleDesc.initAftLsn == 'string') {
						var reg = new RegExp(/console/gi);
						moduleDesc.initAftLsn = moduleDesc.initAftLsn.replace(reg, "tool.sgiLogger");
					}
					var initAft = (0, _SgiCommon.getFunctionByKey)(this, "initAftLsn") || (moduleDesc.initAftLsn ? new Function("module", "objFct", moduleDesc.initAftLsn) : null);
					if (initAft && typeof initAft == "function") {
						_sgiLogger.sgiLogger.time("加载后[" + moduleDesc.guid + "]");
						initAft(this, objFct);
						_sgiLogger.sgiLogger.timeEnd("加载后[" + moduleDesc.guid + "]");
					}
					// 掉服务接口配置
					(0, _SgiCompComm.toCallSi)(moduleDesc, objFct);
					// let initAft;
					// if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys["initAftLsn"]) {
					// 	// 事件集模式
					// 	// let funs = Object.assign({}, objFct.get("@funs"), this.funs);
					// 	// let key = moduleDesc.eventKeys["initAftLsn"];
					// 	// initAft = funs[key];
					// 	initAft = getFunctionByKey(this, "initAftLsn");
					// } else {
					// 	// 原事件模式
					// 	var initAftLsn = moduleDesc.initAftLsn;// 页面加载后监听器
					// 	initAft = new Function("module", "objFct", initAftLsn);
					// }
					// // var initAftLsn = new Function("module", "objFct", initAftLsn);
					// // sgiLogger.eventin('加载后');
					// sgiLogger.time("加载后[" + moduleDesc.guid + "]");
					// initAft(this, objFct);
					// sgiLogger.timeEnd("加载后[" + moduleDesc.guid + "]");
				} catch (error) {
					_sgiLogger.sgiLogger.eventErr(error);
				}
			}
		};
	
		this.fitComponentManager = function (refs, uid) {
			var itemRef = void 0;
			for (var itemRefKey in refs) {
				itemRef = refs[itemRefKey];
				ComponentManager.set(uid, itemRefKey, itemRef);
				if (itemRef.refs) {
					_this2.fitComponentManager(itemRef.refs, uid);
				}
			}
		};
	
		this.render = function () {
			var _props4 = this.props,
			    parentModule = _props4.parentModule,
			    moduleDesc = _props4.moduleDesc,
			    objFct = _props4.objFct,
			    type = _props4.type;
	
	
			if (!this.state.loaded) {
				//组装属性
				this.main_mk(parentModule, moduleDesc, objFct, type);
				this.state.loaded = true;
			}
	
			// 自定义样式处理
			// const getCstmStyle = this.state.cstmStyle;
			var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(this, "cstmStyle");
			var cstmStyle = {};
			if (getCstmStyle /* && type !== "dnd"*/) {
					cstmStyle = getCstmStyle(this, objFct) || {};
				}
			Object.assign(this.state.mainUIProps.style, cstmStyle);
	
			return _react2.default.createElement(
				'div',
				this.state.mainUIProps,
				this.state.mainUIItems,
				this.state.modalItems,
				this.props.children
			);
		};
	};
	
	exports.SgiMainComp = SgiMainComp;
	exports.default = SgiMainComp;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcTooltip = _interopRequireDefault(__webpack_require__(483));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _placements = _interopRequireDefault(__webpack_require__(1461));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var splitObject = function splitObject(obj, keys) {
	  var picked = {};
	
	  var omitted = _extends({}, obj);
	
	  keys.forEach(function (key) {
	    if (obj && key in obj) {
	      picked[key] = obj[key];
	      delete omitted[key];
	    }
	  });
	  return {
	    picked: picked,
	    omitted: omitted
	  };
	}; // Fix Tooltip won't hide at disabled button
	// mouse events don't trigger at disabled button in Chrome
	// https://github.com/react-component/tooltip/issues/18
	
	
	function getDisabledCompatibleChildren(element) {
	  var elementType = element.type;
	
	  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === 'button') && element.props.disabled) {
	    // Pick some layout related style properties up to span
	    // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
	    var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
	        picked = _splitObject.picked,
	        omitted = _splitObject.omitted;
	
	    var spanStyle = _extends(_extends({
	      display: 'inline-block'
	    }, picked), {
	      cursor: 'not-allowed',
	      width: element.props.block ? '100%' : null
	    });
	
	    var buttonStyle = _extends(_extends({}, omitted), {
	      pointerEvents: 'none'
	    });
	
	    var child = /*#__PURE__*/React.cloneElement(element, {
	      style: buttonStyle,
	      className: null
	    });
	    return (/*#__PURE__*/React.createElement("span", {
	        style: spanStyle,
	        className: element.props.className
	      }, child)
	    );
	  }
	
	  return element;
	}
	
	var Tooltip = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tooltip, _React$Component);
	
	  var _super = _createSuper(Tooltip);
	
	  function Tooltip(props) {
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    _this = _super.call(this, props);
	
	    _this.onVisibleChange = function (visible) {
	      var onVisibleChange = _this.props.onVisibleChange;
	
	      if (!('visible' in _this.props)) {
	        _this.setState({
	          visible: _this.isNoTitle() ? false : visible
	        });
	      }
	
	      if (onVisibleChange && !_this.isNoTitle()) {
	        onVisibleChange(visible);
	      }
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    }; // 动态设置动画点
	
	
	    _this.onPopupAlign = function (domNode, align) {
	      var placements = _this.getPlacements(); // 当前返回的位置
	
	
	      var placement = Object.keys(placements).filter(function (key) {
	        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
	      })[0];
	
	      if (!placement) {
	        return;
	      } // 根据当前坐标设置动画点
	
	
	      var rect = domNode.getBoundingClientRect();
	      var transformOrigin = {
	        top: '50%',
	        left: '50%'
	      };
	
	      if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
	        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
	      } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
	        transformOrigin.top = "".concat(-align.offset[1], "px");
	      }
	
	      if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
	        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
	      } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
	        transformOrigin.left = "".concat(-align.offset[0], "px");
	      }
	
	      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
	    };
	
	    _this.renderTooltip = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          openClassName = props.openClassName,
	          getPopupContainer = props.getPopupContainer,
	          getTooltipContainer = props.getTooltipContainer;
	      var children = props.children;
	      var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
	      var visible = state.visible; // Hide tooltip when there is no title
	
	      if (!('visible' in props) && _this.isNoTitle()) {
	        visible = false;
	      }
	
	      var child = getDisabledCompatibleChildren( /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement("span", null, children));
	      var childProps = child.props;
	      var childCls = (0, _classnames["default"])(childProps.className, _defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true));
	      return (/*#__PURE__*/React.createElement(_rcTooltip["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
	          ref: _this.saveTooltip,
	          builtinPlacements: _this.getPlacements(),
	          overlay: _this.getOverlay(),
	          visible: visible,
	          onVisibleChange: _this.onVisibleChange,
	          onPopupAlign: _this.onPopupAlign
	        }), visible ? /*#__PURE__*/React.cloneElement(child, {
	          className: childCls
	        }) : child)
	      );
	    };
	
	    _this.state = {
	      visible: !!props.visible || !!props.defaultVisible
	    };
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getPlacements",
	    value: function getPlacements() {
	      var _this$props = this.props,
	          builtinPlacements = _this$props.builtinPlacements,
	          arrowPointAtCenter = _this$props.arrowPointAtCenter,
	          autoAdjustOverflow = _this$props.autoAdjustOverflow;
	      return builtinPlacements || (0, _placements["default"])({
	        arrowPointAtCenter: arrowPointAtCenter,
	        verticalArrowShift: 8,
	        autoAdjustOverflow: autoAdjustOverflow
	      });
	    }
	  }, {
	    key: "isNoTitle",
	    value: function isNoTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          overlay = _this$props2.overlay;
	      return !title && !overlay && title !== 0; // overlay for old version compatibility
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          overlay = _this$props3.overlay;
	
	      if (title === 0) {
	        return title;
	      }
	
	      return overlay || title || '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTooltip)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tooltip;
	}(React.Component);
	
	Tooltip.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big-fast',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  arrowPointAtCenter: false,
	  autoAdjustOverflow: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Tooltip);
	var _default = Tooltip;
	exports["default"] = _default;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var retrieve = _util.retrieve;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var each = _util.each;
	
	var formatUtil = __webpack_require__(48);
	
	var graphic = __webpack_require__(17);
	
	var Model = __webpack_require__(57);
	
	var _number = __webpack_require__(24);
	
	var isRadianAroundZero = _number.isRadianAroundZero;
	var remRadian = _number.remRadian;
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var matrixUtil = __webpack_require__(75);
	
	var _vector = __webpack_require__(49);
	
	var v2ApplyTransform = _vector.applyTransform;
	
	var _axisHelper = __webpack_require__(96);
	
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * A final axis is translated and rotated from a "standard axis".
	 * So opt.position and opt.rotation is required.
	 *
	 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
	 * for example: (0, 0) ------------> (0, 50)
	 *
	 * nameDirection or tickDirection or labelDirection is 1 means tick
	 * or label is below the standard axis, whereas is -1 means above
	 * the standard axis. labelOffset means offset between label and axis,
	 * which is useful when 'onZero', where axisLabel is in the grid and
	 * label in outside grid.
	 *
	 * Tips: like always,
	 * positive rotation represents anticlockwise, and negative rotation
	 * represents clockwise.
	 * The direction of position coordinate is the same as the direction
	 * of screen coordinate.
	 *
	 * Do not need to consider axis 'inverse', which is auto processed by
	 * axis extent.
	 *
	 * @param {module:zrender/container/Group} group
	 * @param {Object} axisModel
	 * @param {Object} opt Standard axis parameters.
	 * @param {Array.<number>} opt.position [x, y]
	 * @param {number} opt.rotation by radian
	 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
	 * @param {number} [opt.tickDirection=1] 1 or -1
	 * @param {number} [opt.labelDirection=1] 1 or -1
	 * @param {number} [opt.labelOffset=0] Usefull when onZero.
	 * @param {string} [opt.axisLabelShow] default get from axisModel.
	 * @param {string} [opt.axisName] default get from axisModel.
	 * @param {number} [opt.axisNameAvailableWidth]
	 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
	 * @param {number} [opt.strokeContainThreshold] Default label interval when label
	 * @param {number} [opt.nameTruncateMaxWidth]
	 */
	
	var AxisBuilder = function (axisModel, opt) {
	  /**
	   * @readOnly
	   */
	  this.opt = opt;
	  /**
	   * @readOnly
	   */
	
	  this.axisModel = axisModel; // Default value
	
	  defaults(opt, {
	    labelOffset: 0,
	    nameDirection: 1,
	    tickDirection: 1,
	    labelDirection: 1,
	    silent: true
	  });
	  /**
	   * @readOnly
	   */
	
	  this.group = new graphic.Group(); // FIXME Not use a seperate text group?
	
	  var dumbGroup = new graphic.Group({
	    position: opt.position.slice(),
	    rotation: opt.rotation
	  }); // this.group.add(dumbGroup);
	  // this._dumbGroup = dumbGroup;
	
	  dumbGroup.updateTransform();
	  this._transform = dumbGroup.transform;
	  this._dumbGroup = dumbGroup;
	};
	
	AxisBuilder.prototype = {
	  constructor: AxisBuilder,
	  hasBuilder: function (name) {
	    return !!builders[name];
	  },
	  add: function (name) {
	    builders[name].call(this);
	  },
	  getGroup: function () {
	    return this.group;
	  }
	};
	var builders = {
	  /**
	   * @private
	   */
	  axisLine: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	
	    if (!axisModel.get('axisLine.show')) {
	      return;
	    }
	
	    var extent = this.axisModel.axis.getExtent();
	    var matrix = this._transform;
	    var pt1 = [extent[0], 0];
	    var pt2 = [extent[1], 0];
	
	    if (matrix) {
	      v2ApplyTransform(pt1, pt1, matrix);
	      v2ApplyTransform(pt2, pt2, matrix);
	    }
	
	    var lineStyle = extend({
	      lineCap: 'round'
	    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
	    this.group.add(new graphic.Line({
	      // Id for animation
	      anid: 'line',
	      subPixelOptimize: true,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: lineStyle,
	      strokeContainThreshold: opt.strokeContainThreshold || 5,
	      silent: true,
	      z2: 1
	    }));
	    var arrows = axisModel.get('axisLine.symbol');
	    var arrowSize = axisModel.get('axisLine.symbolSize');
	    var arrowOffset = axisModel.get('axisLine.symbolOffset') || 0;
	
	    if (typeof arrowOffset === 'number') {
	      arrowOffset = [arrowOffset, arrowOffset];
	    }
	
	    if (arrows != null) {
	      if (typeof arrows === 'string') {
	        // Use the same arrow for start and end point
	        arrows = [arrows, arrows];
	      }
	
	      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
	        // Use the same size for width and height
	        arrowSize = [arrowSize, arrowSize];
	      }
	
	      var symbolWidth = arrowSize[0];
	      var symbolHeight = arrowSize[1];
	      each([{
	        rotate: opt.rotation + Math.PI / 2,
	        offset: arrowOffset[0],
	        r: 0
	      }, {
	        rotate: opt.rotation - Math.PI / 2,
	        offset: arrowOffset[1],
	        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
	      }], function (point, index) {
	        if (arrows[index] !== 'none' && arrows[index] != null) {
	          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true); // Calculate arrow position with offset
	
	          var r = point.r + point.offset;
	          var pos = [pt1[0] + r * Math.cos(opt.rotation), pt1[1] - r * Math.sin(opt.rotation)];
	          symbol.attr({
	            rotation: point.rotate,
	            position: pos,
	            silent: true,
	            z2: 11
	          });
	          this.group.add(symbol);
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  axisTickLabel: function () {
	    var axisModel = this.axisModel;
	    var opt = this.opt;
	    var ticksEls = buildAxisMajorTicks(this, axisModel, opt);
	    var labelEls = buildAxisLabel(this, axisModel, opt);
	    fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
	    buildAxisMinorTicks(this, axisModel, opt);
	  },
	
	  /**
	   * @private
	   */
	  axisName: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	    var name = retrieve(opt.axisName, axisModel.get('name'));
	
	    if (!name) {
	      return;
	    }
	
	    var nameLocation = axisModel.get('nameLocation');
	    var nameDirection = opt.nameDirection;
	    var textStyleModel = axisModel.getModel('nameTextStyle');
	    var gap = axisModel.get('nameGap') || 0;
	    var extent = this.axisModel.axis.getExtent();
	    var gapSignal = extent[0] > extent[1] ? -1 : 1;
	    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
	    // Reuse labelOffset.
	    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
	    var labelLayout;
	    var nameRotation = axisModel.get('nameRotate');
	
	    if (nameRotation != null) {
	      nameRotation = nameRotation * PI / 180; // To radian.
	    }
	
	    var axisNameAvailableWidth;
	
	    if (isNameLocationCenter(nameLocation)) {
	      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
	      nameDirection);
	    } else {
	      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
	      axisNameAvailableWidth = opt.axisNameAvailableWidth;
	
	      if (axisNameAvailableWidth != null) {
	        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
	        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
	      }
	    }
	
	    var textFont = textStyleModel.getFont();
	    var truncateOpt = axisModel.get('nameTruncate', true) || {};
	    var ellipsis = truncateOpt.ellipsis;
	    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
	    // truncate rich text? (consider performance)
	
	    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
	      minChar: 2,
	      placeholder: truncateOpt.placeholder
	    }) : name;
	    var tooltipOpt = axisModel.get('tooltip', true);
	    var mainType = axisModel.mainType;
	    var formatterParams = {
	      componentType: mainType,
	      name: name,
	      $vars: ['name']
	    };
	    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'name',
	      __fullText: name,
	      __truncatedText: truncatedText,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: isLabelSilent(axisModel),
	      z2: 1,
	      tooltip: tooltipOpt && tooltipOpt.show ? extend({
	        content: name,
	        formatter: function () {
	          return name;
	        },
	        formatterParams: formatterParams
	      }, tooltipOpt) : null
	    });
	    graphic.setTextStyle(textEl.style, textStyleModel, {
	      text: truncatedText,
	      textFont: textFont,
	      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
	      textAlign: textStyleModel.get('align') || labelLayout.textAlign,
	      textVerticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
	    });
	
	    if (axisModel.get('triggerEvent')) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisName';
	      textEl.eventData.name = name;
	    } // FIXME
	
	
	    this._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    this.group.add(textEl);
	    textEl.decomposeTransform();
	  }
	};
	
	var makeAxisEventDataBase = AxisBuilder.makeAxisEventDataBase = function (axisModel) {
	  var eventData = {
	    componentType: axisModel.mainType,
	    componentIndex: axisModel.componentIndex
	  };
	  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
	  return eventData;
	};
	/**
	 * @public
	 * @static
	 * @param {Object} opt
	 * @param {number} axisRotation in radian
	 * @param {number} textRotation in radian
	 * @param {number} direction
	 * @return {Object} {
	 *  rotation, // according to axis
	 *  textAlign,
	 *  textVerticalAlign
	 * }
	 */
	
	
	var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
	  var rotationDiff = remRadian(textRotation - axisRotation);
	  var textAlign;
	  var textVerticalAlign;
	
	  if (isRadianAroundZero(rotationDiff)) {
	    // Label is parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI)) {
	    // Label is inverse parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff > 0 && rotationDiff < PI) {
	      textAlign = direction > 0 ? 'right' : 'left';
	    } else {
	      textAlign = direction > 0 ? 'left' : 'right';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	};
	
	function endTextLayout(opt, textPosition, textRotate, extent) {
	  var rotationDiff = remRadian(textRotate - opt.rotation);
	  var textAlign;
	  var textVerticalAlign;
	  var inverse = extent[0] > extent[1];
	  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
	
	  if (isRadianAroundZero(rotationDiff - PI / 2)) {
	    textVerticalAlign = onLeft ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
	    textVerticalAlign = onLeft ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
	      textAlign = onLeft ? 'left' : 'right';
	    } else {
	      textAlign = onLeft ? 'right' : 'left';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	
	var isLabelSilent = AxisBuilder.isLabelSilent = function (axisModel) {
	  var tooltipOpt = axisModel.get('tooltip');
	  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
	  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
	};
	
	function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
	  if (shouldShowAllLabels(axisModel.axis)) {
	    return;
	  } // If min or max are user set, we need to check
	  // If the tick on min(max) are overlap on their neighbour tick
	  // If they are overlapped, we need to hide the min(max) tick label
	
	
	  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
	  // Have not consider onBand yet, where tick els is more than label els.
	
	  labelEls = labelEls || [];
	  tickEls = tickEls || [];
	  var firstLabel = labelEls[0];
	  var nextLabel = labelEls[1];
	  var lastLabel = labelEls[labelEls.length - 1];
	  var prevLabel = labelEls[labelEls.length - 2];
	  var firstTick = tickEls[0];
	  var nextTick = tickEls[1];
	  var lastTick = tickEls[tickEls.length - 1];
	  var prevTick = tickEls[tickEls.length - 2];
	
	  if (showMinLabel === false) {
	    ignoreEl(firstLabel);
	    ignoreEl(firstTick);
	  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
	    if (showMinLabel) {
	      ignoreEl(nextLabel);
	      ignoreEl(nextTick);
	    } else {
	      ignoreEl(firstLabel);
	      ignoreEl(firstTick);
	    }
	  }
	
	  if (showMaxLabel === false) {
	    ignoreEl(lastLabel);
	    ignoreEl(lastTick);
	  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
	    if (showMaxLabel) {
	      ignoreEl(prevLabel);
	      ignoreEl(prevTick);
	    } else {
	      ignoreEl(lastLabel);
	      ignoreEl(lastTick);
	    }
	  }
	}
	
	function ignoreEl(el) {
	  el && (el.ignore = true);
	}
	
	function isTwoLabelOverlapped(current, next, labelLayout) {
	  // current and next has the same rotation.
	  var firstRect = current && current.getBoundingRect().clone();
	  var nextRect = next && next.getBoundingRect().clone();
	
	  if (!firstRect || !nextRect) {
	    return;
	  } // When checking intersect of two rotated labels, we use mRotationBack
	  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
	
	
	  var mRotationBack = matrixUtil.identity([]);
	  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
	  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
	  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
	  return firstRect.intersect(nextRect);
	}
	
	function isNameLocationCenter(nameLocation) {
	  return nameLocation === 'middle' || nameLocation === 'center';
	}
	
	function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, aniid) {
	  var tickEls = [];
	  var pt1 = [];
	  var pt2 = [];
	
	  for (var i = 0; i < ticksCoords.length; i++) {
	    var tickCoord = ticksCoords[i].coord;
	    pt1[0] = tickCoord;
	    pt1[1] = 0;
	    pt2[0] = tickCoord;
	    pt2[1] = tickEndCoord;
	
	    if (tickTransform) {
	      v2ApplyTransform(pt1, pt1, tickTransform);
	      v2ApplyTransform(pt2, pt2, tickTransform);
	    } // Tick line, Not use group transform to have better line draw
	
	
	    var tickEl = new graphic.Line({
	      // Id for animation
	      anid: aniid + '_' + ticksCoords[i].tickValue,
	      subPixelOptimize: true,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: tickLineStyle,
	      z2: 2,
	      silent: true
	    });
	    tickEls.push(tickEl);
	  }
	
	  return tickEls;
	}
	
	function buildAxisMajorTicks(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var tickModel = axisModel.getModel('axisTick');
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var lineStyleModel = tickModel.getModel('lineStyle');
	  var tickEndCoord = opt.tickDirection * tickModel.get('length');
	  var ticksCoords = axis.getTicksCoords();
	  var ticksEls = createTicks(ticksCoords, axisBuilder._transform, tickEndCoord, defaults(lineStyleModel.getLineStyle(), {
	    stroke: axisModel.get('axisLine.lineStyle.color')
	  }), 'ticks');
	
	  for (var i = 0; i < ticksEls.length; i++) {
	    axisBuilder.group.add(ticksEls[i]);
	  }
	
	  return ticksEls;
	}
	
	function buildAxisMinorTicks(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var minorTickModel = axisModel.getModel('minorTick');
	
	  if (!minorTickModel.get('show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var minorTicksCoords = axis.getMinorTicksCoords();
	
	  if (!minorTicksCoords.length) {
	    return;
	  }
	
	  var lineStyleModel = minorTickModel.getModel('lineStyle');
	  var tickEndCoord = opt.tickDirection * minorTickModel.get('length');
	  var minorTickLineStyle = defaults(lineStyleModel.getLineStyle(), defaults(axisModel.getModel('axisTick').getLineStyle(), {
	    stroke: axisModel.get('axisLine.lineStyle.color')
	  }));
	
	  for (var i = 0; i < minorTicksCoords.length; i++) {
	    var minorTicksEls = createTicks(minorTicksCoords[i], axisBuilder._transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
	
	    for (var k = 0; k < minorTicksEls.length; k++) {
	      axisBuilder.group.add(minorTicksEls[k]);
	    }
	  }
	}
	
	function buildAxisLabel(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));
	
	  if (!show || axis.scale.isBlank()) {
	    return;
	  }
	
	  var labelModel = axisModel.getModel('axisLabel');
	  var labelMargin = labelModel.get('margin');
	  var labels = axis.getViewLabels(); // Special label rotate.
	
	  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
	  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
	  var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
	  var labelEls = [];
	  var silent = isLabelSilent(axisModel);
	  var triggerEvent = axisModel.get('triggerEvent');
	  each(labels, function (labelItem, index) {
	    var tickValue = labelItem.tickValue;
	    var formattedLabel = labelItem.formattedLabel;
	    var rawLabel = labelItem.rawLabel;
	    var itemLabelModel = labelModel;
	
	    if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	      itemLabelModel = new Model(rawCategoryData[tickValue].textStyle, labelModel, axisModel.ecModel);
	    }
	
	    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
	    var tickCoord = axis.dataToCoord(tickValue);
	    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'label_' + tickValue,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: silent,
	      z2: 10
	    });
	    graphic.setTextStyle(textEl.style, itemLabelModel, {
	      text: formattedLabel,
	      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
	      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
	      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
	      // index of axis.data. So tick should not be exposed to user
	      // in category axis.
	      // (2) Compatible with previous version, which always use formatted label as
	      // input. But in interval scale the formatted label is like '223,445', which
	      // maked user repalce ','. So we modify it to return original val but remain
	      // it as 'string' to avoid error in replacing.
	      axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
	    }); // Pack data for mouse event
	
	    if (triggerEvent) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisLabel';
	      textEl.eventData.value = rawLabel;
	    } // FIXME
	
	
	    axisBuilder._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    labelEls.push(textEl);
	    axisBuilder.group.add(textEl);
	    textEl.decomposeTransform();
	  });
	  return labelEls;
	}
	
	var _default = AxisBuilder;
	module.exports = _default;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var features = {};
	
	function register(name, ctor) {
	  features[name] = ctor;
	}
	
	function get(name) {
	  return features[name];
	}
	
	exports.register = register;
	exports.get = get;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	var map = _util.map;
	
	var _number = __webpack_require__(24);
	
	var linearMap = _number.linearMap;
	var getPixelPrecision = _number.getPixelPrecision;
	var round = _number.round;
	
	var _axisTickLabelBuilder = __webpack_require__(1811);
	
	var createAxisTicks = _axisTickLabelBuilder.createAxisTicks;
	var createAxisLabels = _axisTickLabelBuilder.createAxisLabels;
	var calculateCategoryInterval = _axisTickLabelBuilder.calculateCategoryInterval;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMALIZED_EXTENT = [0, 1];
	/**
	 * Base class of Axis.
	 * @constructor
	 */
	
	var Axis = function (dim, scale, extent) {
	  /**
	   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
	   * @type {string}
	   */
	  this.dim = dim;
	  /**
	   * Axis scale
	   * @type {module:echarts/coord/scale/*}
	   */
	
	  this.scale = scale;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  this._extent = extent || [0, 0];
	  /**
	   * @type {boolean}
	   */
	
	  this.inverse = false;
	  /**
	   * Usually true when axis has a ordinal scale
	   * @type {boolean}
	   */
	
	  this.onBand = false;
	};
	
	Axis.prototype = {
	  constructor: Axis,
	
	  /**
	   * If axis extent contain given coord
	   * @param {number} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var extent = this._extent;
	    var min = Math.min(extent[0], extent[1]);
	    var max = Math.max(extent[0], extent[1]);
	    return coord >= min && coord <= max;
	  },
	
	  /**
	   * If axis extent contain given data
	   * @param {number} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.scale.contain(data);
	  },
	
	  /**
	   * Get coord extent.
	   * @return {Array.<number>}
	   */
	  getExtent: function () {
	    return this._extent.slice();
	  },
	
	  /**
	   * Get precision used for formatting
	   * @param {Array.<number>} [dataExtent]
	   * @return {number}
	   */
	  getPixelPrecision: function (dataExtent) {
	    return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
	  },
	
	  /**
	   * Set coord extent
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var extent = this._extent;
	    extent[0] = start;
	    extent[1] = end;
	  },
	
	  /**
	   * Convert data to coord. Data is the rank if it has an ordinal scale
	   * @param {number} data
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  dataToCoord: function (data, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	    data = scale.normalize(data);
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
	  },
	
	  /**
	   * Convert coord to data. Data is the rank if it has an ordinal scale
	   * @param {number} coord
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  coordToData: function (coord, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
	    return this.scale.scale(t);
	  },
	
	  /**
	   * Convert pixel point to data in axis
	   * @param {Array.<number>} point
	   * @param  {boolean} clamp
	   * @return {number} data
	   */
	  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
	  },
	
	  /**
	   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
	   * `axis.getTicksCoords` considers `onBand`, which is used by
	   * `boundaryGap:true` of category axis and splitLine and splitArea.
	   * @param {Object} [opt]
	   * @param {Model} [opt.tickModel=axis.model.getModel('axisTick')]
	   * @param {boolean} [opt.clamp] If `true`, the first and the last
	   *        tick must be at the axis end points. Otherwise, clip ticks
	   *        that outside the axis extent.
	   * @return {Array.<Object>} [{
	   *     coord: ...,
	   *     tickValue: ...
	   * }, ...]
	   */
	  getTicksCoords: function (opt) {
	    opt = opt || {};
	    var tickModel = opt.tickModel || this.getTickModel();
	    var result = createAxisTicks(this, tickModel);
	    var ticks = result.ticks;
	    var ticksCoords = map(ticks, function (tickValue) {
	      return {
	        coord: this.dataToCoord(tickValue),
	        tickValue: tickValue
	      };
	    }, this);
	    var alignWithLabel = tickModel.get('alignWithLabel');
	    fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
	    return ticksCoords;
	  },
	
	  /**
	   * @return {Array.<Array.<Object>>} [{ coord: ..., tickValue: ...}]
	   */
	  getMinorTicksCoords: function () {
	    if (this.scale.type === 'ordinal') {
	      // Category axis doesn't support minor ticks
	      return [];
	    }
	
	    var minorTickModel = this.model.getModel('minorTick');
	    var splitNumber = minorTickModel.get('splitNumber'); // Protection.
	
	    if (!(splitNumber > 0 && splitNumber < 100)) {
	      splitNumber = 5;
	    }
	
	    var minorTicks = this.scale.getMinorTicks(splitNumber);
	    var minorTicksCoords = map(minorTicks, function (minorTicksGroup) {
	      return map(minorTicksGroup, function (minorTick) {
	        return {
	          coord: this.dataToCoord(minorTick),
	          tickValue: minorTick
	        };
	      }, this);
	    }, this);
	    return minorTicksCoords;
	  },
	
	  /**
	   * @return {Array.<Object>} [{
	   *     formattedLabel: string,
	   *     rawLabel: axis.scale.getLabel(tickValue)
	   *     tickValue: number
	   * }, ...]
	   */
	  getViewLabels: function () {
	    return createAxisLabels(this).labels;
	  },
	
	  /**
	   * @return {module:echarts/coord/model/Model}
	   */
	  getLabelModel: function () {
	    return this.model.getModel('axisLabel');
	  },
	
	  /**
	   * Notice here we only get the default tick model. For splitLine
	   * or splitArea, we should pass the splitLineModel or splitAreaModel
	   * manually when calling `getTicksCoords`.
	   * In GL, this method may be overrided to:
	   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
	   * @return {module:echarts/coord/model/Model}
	   */
	  getTickModel: function () {
	    return this.model.getModel('axisTick');
	  },
	
	  /**
	   * Get width of band
	   * @return {number}
	   */
	  getBandWidth: function () {
	    var axisExtent = this._extent;
	    var dataExtent = this.scale.getExtent();
	    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
	
	    len === 0 && (len = 1);
	    var size = Math.abs(axisExtent[1] - axisExtent[0]);
	    return Math.abs(size) / len;
	  },
	
	  /**
	   * @abstract
	   * @return {boolean} Is horizontal
	   */
	  isHorizontal: null,
	
	  /**
	   * @abstract
	   * @return {number} Get axis rotate, by degree.
	   */
	  getRotate: null,
	
	  /**
	   * Only be called in category axis.
	   * Can be overrided, consider other axes like in 3D.
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    return calculateCategoryInterval(this);
	  }
	};
	
	function fixExtentWithBands(extent, nTick) {
	  var size = extent[1] - extent[0];
	  var len = nTick;
	  var margin = size / len / 2;
	  extent[0] += margin;
	  extent[1] -= margin;
	} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
	// |---1---|---2---|---3---|---4---|.
	// So the displayed ticks and splitLine/splitArea should between
	// each data item, otherwise cause misleading (e.g., split tow bars
	// of a single data item when there are two bar series).
	// Also consider if tickCategoryInterval > 0 and onBand, ticks and
	// splitLine/spliteArea should layout appropriately corresponding
	// to displayed labels. (So we should not use `getBandWidth` in this
	// case).
	
	
	function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
	  var ticksLen = ticksCoords.length;
	
	  if (!axis.onBand || alignWithLabel || !ticksLen) {
	    return;
	  }
	
	  var axisExtent = axis.getExtent();
	  var last;
	  var diffSize;
	
	  if (ticksLen === 1) {
	    ticksCoords[0].coord = axisExtent[0];
	    last = ticksCoords[1] = {
	      coord: axisExtent[0]
	    };
	  } else {
	    var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
	    var shift = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
	    each(ticksCoords, function (ticksItem) {
	      ticksItem.coord -= shift / 2;
	    });
	    var dataExtent = axis.scale.getExtent();
	    diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
	    last = {
	      coord: ticksCoords[ticksLen - 1].coord + shift * diffSize
	    };
	    ticksCoords.push(last);
	  }
	
	  var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
	
	  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
	    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
	  }
	
	  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
	    ticksCoords.unshift({
	      coord: axisExtent[0]
	    });
	  }
	
	  if (littleThan(axisExtent[1], last.coord)) {
	    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
	  }
	
	  if (clamp && littleThan(last.coord, axisExtent[1])) {
	    ticksCoords.push({
	      coord: axisExtent[1]
	    });
	  }
	
	  function littleThan(a, b) {
	    // Avoid rounding error cause calculated tick coord different with extent.
	    // It may cause an extra unecessary tick added.
	    a = round(a);
	    b = round(b);
	    return inverse ? a > b : a < b;
	  }
	}
	
	var _default = Axis;
	module.exports = _default;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Language: (Simplified) Chinese.
	 */
	var _default = {
	  legend: {
	    selector: {
	      all: '全选',
	      inverse: '反选'
	    }
	  },
	  toolbox: {
	    brush: {
	      title: {
	        rect: '矩形选择',
	        polygon: '圈选',
	        lineX: '横向选择',
	        lineY: '纵向选择',
	        keep: '保持选择',
	        clear: '清除选择'
	      }
	    },
	    dataView: {
	      title: '数据视图',
	      lang: ['数据视图', '关闭', '刷新']
	    },
	    dataZoom: {
	      title: {
	        zoom: '区域缩放',
	        back: '区域缩放还原'
	      }
	    },
	    magicType: {
	      title: {
	        line: '切换为折线图',
	        bar: '切换为柱状图',
	        stack: '切换为堆叠',
	        tiled: '切换为平铺'
	      }
	    },
	    restore: {
	      title: '还原'
	    },
	    saveAsImage: {
	      title: '保存为图片',
	      lang: ['右键另存为图片']
	    }
	  },
	  series: {
	    typeNames: {
	      pie: '饼图',
	      bar: '柱状图',
	      line: '折线图',
	      scatter: '散点图',
	      effectScatter: '涟漪散点图',
	      radar: '雷达图',
	      tree: '树图',
	      treemap: '矩形树图',
	      boxplot: '箱型图',
	      candlestick: 'K线图',
	      k: 'K线图',
	      heatmap: '热力图',
	      map: '地图',
	      parallel: '平行坐标图',
	      lines: '线图',
	      graph: '关系图',
	      sankey: '桑基图',
	      funnel: '漏斗图',
	      gauge: '仪表盘图',
	      pictorialBar: '象形柱图',
	      themeRiver: '主题河流图',
	      sunburst: '旭日图'
	    }
	  },
	  aria: {
	    general: {
	      withTitle: '这是一个关于“{title}”的图表。',
	      withoutTitle: '这是一个图表，'
	    },
	    series: {
	      single: {
	        prefix: '',
	        withName: '图表类型是{seriesType}，表示{seriesName}。',
	        withoutName: '图表类型是{seriesType}。'
	      },
	      multiple: {
	        prefix: '它由{seriesCount}个图表系列组成。',
	        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
	        withoutName: '第{seriesId}个系列是一个{seriesType}，',
	        separator: {
	          middle: '；',
	          end: '。'
	        }
	      }
	    },
	    data: {
	      allData: '其数据是——',
	      partialData: '其中，前{displayCnt}项是——',
	      withName: '{name}的数据是{value}',
	      withoutName: '{value}',
	      separator: {
	        middle: '，',
	        end: ''
	      }
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ORIGIN_METHOD = '\0__throttleOriginMethod';
	var RATE = '\0__throttleRate';
	var THROTTLE_TYPE = '\0__throttleType';
	/**
	 * @public
	 * @param {(Function)} fn
	 * @param {number} [delay=0] Unit: ms.
	 * @param {boolean} [debounce=false]
	 *        true: If call interval less than `delay`, only the last call works.
	 *        false: If call interval less than `delay, call works on fixed rate.
	 * @return {(Function)} throttled fn.
	 */
	
	function throttle(fn, delay, debounce) {
	  var currCall;
	  var lastCall = 0;
	  var lastExec = 0;
	  var timer = null;
	  var diff;
	  var scope;
	  var args;
	  var debounceNextCall;
	  delay = delay || 0;
	
	  function exec() {
	    lastExec = new Date().getTime();
	    timer = null;
	    fn.apply(scope, args || []);
	  }
	
	  var cb = function () {
	    currCall = new Date().getTime();
	    scope = this;
	    args = arguments;
	    var thisDelay = debounceNextCall || delay;
	    var thisDebounce = debounceNextCall || debounce;
	    debounceNextCall = null;
	    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
	    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
	    // than a new call of `cb`, that is, preserving the command order. Consider
	    // calculating "scale rate" when roaming as an example. When a call of `cb`
	    // happens, either the `exec` is called dierectly, or the call is delayed.
	    // But the delayed call should never be later than next call of `cb`. Under
	    // this assurance, we can simply update view state each time `dispatchAction`
	    // triggered by user roaming, but not need to add extra code to avoid the
	    // state being "rolled-back".
	
	    if (thisDebounce) {
	      timer = setTimeout(exec, thisDelay);
	    } else {
	      if (diff >= 0) {
	        exec();
	      } else {
	        timer = setTimeout(exec, -diff);
	      }
	    }
	
	    lastCall = currCall;
	  };
	  /**
	   * Clear throttle.
	   * @public
	   */
	
	
	  cb.clear = function () {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  };
	  /**
	   * Enable debounce once.
	   */
	
	
	  cb.debounceNextCall = function (debounceDelay) {
	    debounceNextCall = debounceDelay;
	  };
	
	  return cb;
	}
	/**
	 * Create throttle method or update throttle rate.
	 *
	 * @example
	 * ComponentView.prototype.render = function () {
	 *     ...
	 *     throttle.createOrUpdate(
	 *         this,
	 *         '_dispatchAction',
	 *         this.model.get('throttle'),
	 *         'fixRate'
	 *     );
	 * };
	 * ComponentView.prototype.remove = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 * ComponentView.prototype.dispose = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 * @param {number} [rate]
	 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
	 * @return {Function} throttled function.
	 */
	
	
	function createOrUpdate(obj, fnAttr, rate, throttleType) {
	  var fn = obj[fnAttr];
	
	  if (!fn) {
	    return;
	  }
	
	  var originFn = fn[ORIGIN_METHOD] || fn;
	  var lastThrottleType = fn[THROTTLE_TYPE];
	  var lastRate = fn[RATE];
	
	  if (lastRate !== rate || lastThrottleType !== throttleType) {
	    if (rate == null || !throttleType) {
	      return obj[fnAttr] = originFn;
	    }
	
	    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
	    fn[ORIGIN_METHOD] = originFn;
	    fn[THROTTLE_TYPE] = throttleType;
	    fn[RATE] = rate;
	  }
	
	  return fn;
	}
	/**
	 * Clear throttle. Example see throttle.createOrUpdate.
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 */
	
	
	function clear(obj, fnAttr) {
	  var fn = obj[fnAttr];
	
	  if (fn && fn[ORIGIN_METHOD]) {
	    obj[fnAttr] = fn[ORIGIN_METHOD];
	  }
	}
	
	exports.throttle = throttle;
	exports.createOrUpdate = createOrUpdate;
	exports.clear = clear;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(2110),
	    baseIteratee = __webpack_require__(2112),
	    baseMap = __webpack_require__(1892),
	    isArray = __webpack_require__(499);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(49);
	
	var v2Create = _vector.create;
	var v2DistSquare = _vector.distSquare;
	
	/**
	 * 曲线辅助模块
	 * @module zrender/core/curve
	 * @author pissang(https://www.github.com/pissang)
	 */
	var mathPow = Math.pow;
	var mathSqrt = Math.sqrt;
	var EPSILON = 1e-8;
	var EPSILON_NUMERIC = 1e-4;
	var THREE_SQRT = mathSqrt(3);
	var ONE_THIRD = 1 / 3; // 临时变量
	
	var _v0 = v2Create();
	
	var _v1 = v2Create();
	
	var _v2 = v2Create();
	
	function isAroundZero(val) {
	  return val > -EPSILON && val < EPSILON;
	}
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * 计算三次贝塞尔值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
	}
	/**
	 * 计算三次贝塞尔导数值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicDerivativeAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
	}
	/**
	 * 计算三次贝塞尔方程根，使用盛金公式
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} val
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function cubicRootAt(p0, p1, p2, p3, val, roots) {
	  // Evaluate roots of cubic functions
	  var a = p3 + 3 * (p1 - p2) - p0;
	  var b = 3 * (p2 - p1 * 2 + p0);
	  var c = 3 * (p1 - p0);
	  var d = p0 - val;
	  var A = b * b - 3 * a * c;
	  var B = b * c - 9 * a * d;
	  var C = c * c - 3 * b * d;
	  var n = 0;
	
	  if (isAroundZero(A) && isAroundZero(B)) {
	    if (isAroundZero(b)) {
	      roots[0] = 0;
	    } else {
	      var t1 = -c / b; //t1, t2, t3, b is not zero
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = B * B - 4 * A * C;
	
	    if (isAroundZero(disc)) {
	      var K = B / A;
	      var t1 = -b / a + K; // t1, a is not zero
	
	      var t2 = -K / 2; // t2, t3
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
	      var Y2 = A * b + 1.5 * a * (-B - discSqrt);
	
	      if (Y1 < 0) {
	        Y1 = -mathPow(-Y1, ONE_THIRD);
	      } else {
	        Y1 = mathPow(Y1, ONE_THIRD);
	      }
	
	      if (Y2 < 0) {
	        Y2 = -mathPow(-Y2, ONE_THIRD);
	      } else {
	        Y2 = mathPow(Y2, ONE_THIRD);
	      }
	
	      var t1 = (-b - (Y1 + Y2)) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else {
	      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
	      var theta = Math.acos(T) / 3;
	      var ASqrt = mathSqrt(A);
	      var tmp = Math.cos(theta);
	      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
	      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
	      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	
	      if (t3 >= 0 && t3 <= 1) {
	        roots[n++] = t3;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算三次贝塞尔方程极限值的位置
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {Array.<number>} extrema
	 * @return {number} 有效数目
	 */
	
	
	function cubicExtrema(p0, p1, p2, p3, extrema) {
	  var b = 6 * p2 - 12 * p1 + 6 * p0;
	  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
	  var c = 3 * p1 - 3 * p0;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      extrema[0] = -b / (2 * a);
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        extrema[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 细分三次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function cubicSubdivide(p0, p1, p2, p3, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p23 = (p3 - p2) * t + p2;
	  var p012 = (p12 - p01) * t + p01;
	  var p123 = (p23 - p12) * t + p12;
	  var p0123 = (p123 - p012) * t + p012; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012;
	  out[3] = p0123; // Seg1
	
	  out[4] = p0123;
	  out[5] = p123;
	  out[6] = p23;
	  out[7] = p3;
	}
	/**
	 * 投射点到三次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} [out] 投射点
	 * @return {number}
	 */
	
	
	function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  var prev;
	  var next;
	  var d1;
	  var d2;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
	    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
	    d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    prev = t - interval;
	    next = t + interval; // t - interval
	
	    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
	    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
	    d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = cubicAt(x0, x1, x2, x3, next);
	      _v2[1] = cubicAt(y0, y1, y2, y3, next);
	      d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = cubicAt(x0, x1, x2, x3, t);
	    out[1] = cubicAt(y0, y1, y2, y3, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	/**
	 * 计算二次方贝塞尔值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticAt(p0, p1, p2, t) {
	  var onet = 1 - t;
	  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
	}
	/**
	 * 计算二次方贝塞尔导数值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticDerivativeAt(p0, p1, p2, t) {
	  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
	}
	/**
	 * 计算二次方贝塞尔方程根
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function quadraticRootAt(p0, p1, p2, val, roots) {
	  var a = p0 - 2 * p1 + p2;
	  var b = 2 * (p1 - p0);
	  var c = p0 - val;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      var t1 = -b / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算二次贝塞尔方程极限值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @return {number}
	 */
	
	
	function quadraticExtremum(p0, p1, p2) {
	  var divider = p0 + p2 - 2 * p1;
	
	  if (divider === 0) {
	    // p1 is center of p0 and p2
	    return 0.5;
	  } else {
	    return (p0 - p1) / divider;
	  }
	}
	/**
	 * 细分二次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function quadraticSubdivide(p0, p1, p2, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p012 = (p12 - p01) * t + p01; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012; // Seg1
	
	  out[3] = p012;
	  out[4] = p12;
	  out[5] = p2;
	}
	/**
	 * 投射点到二次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} out 投射点
	 * @return {number}
	 */
	
	
	function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = quadraticAt(x0, x1, x2, _t);
	    _v1[1] = quadraticAt(y0, y1, y2, _t);
	    var d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    var prev = t - interval;
	    var next = t + interval; // t - interval
	
	    _v1[0] = quadraticAt(x0, x1, x2, prev);
	    _v1[1] = quadraticAt(y0, y1, y2, prev);
	    var d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = quadraticAt(x0, x1, x2, next);
	      _v2[1] = quadraticAt(y0, y1, y2, next);
	      var d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = quadraticAt(x0, x1, x2, t);
	    out[1] = quadraticAt(y0, y1, y2, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	
	exports.cubicAt = cubicAt;
	exports.cubicDerivativeAt = cubicDerivativeAt;
	exports.cubicRootAt = cubicRootAt;
	exports.cubicExtrema = cubicExtrema;
	exports.cubicSubdivide = cubicSubdivide;
	exports.cubicProjectPoint = cubicProjectPoint;
	exports.quadraticAt = quadraticAt;
	exports.quadraticDerivativeAt = quadraticDerivativeAt;
	exports.quadraticRootAt = quadraticRootAt;
	exports.quadraticExtremum = quadraticExtremum;
	exports.quadraticSubdivide = quadraticSubdivide;
	exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _button = _interopRequireDefault(__webpack_require__(1021));
	
	var _buttonGroup = _interopRequireDefault(__webpack_require__(1020));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_button["default"].Group = _buttonGroup["default"];
	var _default = _button["default"];
	exports["default"] = _default;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _button = _interopRequireDefault(__webpack_require__(1179));
	
	var _buttonGroup = _interopRequireDefault(__webpack_require__(1178));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_button["default"].Group = _buttonGroup["default"];
	var _default = _button["default"];
	exports["default"] = _default;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UserModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	
	var roleList = [{ roleName: '省行领导', roleId: '1045209085940596736' }, { roleName: '客户经理', roleId: '1045209085940596736' }]; // 调用服务取
	var modalRoleListColumns = [{
	    title: '角色名称', // 列头显示名称
	    dataIndex: 'roleName' // 列数据在数据项中对应的 key
	}];
	var userList = [];
	var modalUserList = [];
	
	/**
	 *添加审批人弹出窗
	 *
	 * @class UserModal
	 * @extends {React.Component}
	 */
	
	var UserModal = function (_React$Component) {
	    _inherits(UserModal, _React$Component);
	
	    function UserModal(props) {
	        _classCallCheck(this, UserModal);
	
	        var _this = _possibleConstructorReturn(this, (UserModal.__proto__ || Object.getPrototypeOf(UserModal)).call(this, props));
	
	        _this.getTBData = function (tData) {
	            if (!tData) {
	                tData = [];
	                return tData;
	            }
	            tData.forEach(function (element) {
	                if (!element._key) element._key = (0, _CommonFunc.uuid)(8);
	            });
	            return tData;
	        };
	
	        _this.roleOnRowClick = function (record, index) {
	            return {
	                onClick: function onClick() {
	                    // 点击行
	                    console.log("列表行单击事件", record);
	                    // 调用服务查询当前角色下的员工列表
	                    userList = [{ empName: 'admin', userId: '1054707176943124480' }, { empName: '穆芳阁', userId: '1041971932871786502' }, { empName: '文阳', userId: '1041971932871786503' }, { empName: '王哲', userId: '1059760369871880192' }];
	                    // 刷新员工列表
	                    modalUserList = _this.getTBData(userList);
	                    _this.setState({ loading: false });
	                }
	            };
	        };
	
	        _this.modalHandleOk = function (e) {
	            _this.props.parent.reload(); // 刷新审批人列表
	            _this.setState({
	                modalShow: false
	            });
	        };
	
	        _this.modalHandleCancel = function (e) {
	            _this.setState({
	                modalShow: false
	            });
	        };
	
	        _this.state = {
	            modalShow: props.modalShow,
	            title: props.title,
	            loading: false
	        };
	        return _this;
	    }
	
	    // 创建表格绑定store（生成数据key）
	
	    // 角色列表行单击事件，record：当前行数据，index：行下标，从0开始
	
	    // 输入参数modal确认按钮事件
	
	    // 输入参数modal取消按钮事件
	
	
	    _createClass(UserModal, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var modalRoleList = this.getTBData(roleList);
	            var modalUserListColumns = [{
	                title: '员工名称', // 列头显示名称
	                dataIndex: 'empName' // 列数据在数据项中对应的 key
	            }];
	            // 勾选事件
	            var rowSelection = {
	                onChange: function onChange(selectedRowKeys, selectedRows) {
	                    console.log('selectedRowKeys: ' + selectedRowKeys, 'selectedRows: ', selectedRows);
	                    _this2.props.approvalUserList.splice(0, _this2.props.approvalUserList.length); // 清空数组，不改变引用地址
	                    _this2.props.approvalUserList.push.apply(_this2.props.approvalUserList, selectedRows); // 追加数组元素，不改变引用地址
	                }
	            };
	            return _react2.default.createElement(
	                _antd.Modal,
	                {
	                    title: this.state.title,
	                    visible: this.state.modalShow,
	                    onOk: this.modalHandleOk,
	                    onCancel: this.modalHandleCancel,
	                    okText: '\u786E\u8BA4',
	                    cancelText: '\u53D6\u6D88',
	                    destroyOnClose: true
	                },
	                _react2.default.createElement(
	                    _antd.Row,
	                    { gutter: 16 },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                            rowClassName: function rowClassName() {
	                                return 'roleList-row';
	                            } // 表格行的类名
	                            , bordered: true // 是否展示外边框和列边框
	                            , dataSource: modalRoleList,
	                            columns: modalRoleListColumns,
	                            onRow: this.roleOnRowClick.bind(this) // onRowClick：已弃用
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                            rowClassName: function rowClassName() {
	                                return 'userList-row';
	                            } // 表格行的类名
	                            , bordered: true // 是否展示外边框和列边框
	                            , dataSource: modalUserList,
	                            columns: modalUserListColumns,
	                            rowSelection: rowSelection
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserModal;
	}(_react2.default.Component);
	
	exports.UserModal = UserModal;
	exports.default = UserModal;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _button = _interopRequireDefault(__webpack_require__(1369));
	
	var _buttonGroup = _interopRequireDefault(__webpack_require__(1368));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_button["default"].Group = _buttonGroup["default"];
	var _default = _button["default"];
	exports["default"] = _default;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function oneArgumentPooler(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function threeArgumentPooler(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
	  if (payload && zrUtil.indexOf(validPayloadTypes, payload.type) >= 0) {
	    var root = seriesModel.getData().tree.root;
	    var targetNode = payload.targetNode;
	
	    if (typeof targetNode === 'string') {
	      targetNode = root.getNodeById(targetNode);
	    }
	
	    if (targetNode && root.contains(targetNode)) {
	      return {
	        node: targetNode
	      };
	    }
	
	    var targetNodeId = payload.targetNodeId;
	
	    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
	      return {
	        node: targetNode
	      };
	    }
	  }
	} // Not includes the given node at the last item.
	
	
	function getPathToRoot(node) {
	  var path = [];
	
	  while (node) {
	    node = node.parentNode;
	    node && path.push(node);
	  }
	
	  return path.reverse();
	}
	
	function aboveViewRoot(viewRoot, node) {
	  var viewPath = getPathToRoot(viewRoot);
	  return zrUtil.indexOf(viewPath, node) >= 0;
	} // From root to the input node (the input node will be included).
	
	
	function wrapTreePathInfo(node, seriesModel) {
	  var treePathInfo = [];
	
	  while (node) {
	    var nodeDataIndex = node.dataIndex;
	    treePathInfo.push({
	      name: node.name,
	      dataIndex: nodeDataIndex,
	      value: seriesModel.getRawValue(nodeDataIndex)
	    });
	    node = node.parentNode;
	  }
	
	  treePathInfo.reverse();
	  return treePathInfo;
	}
	
	exports.retrieveTargetInfo = retrieveTargetInfo;
	exports.getPathToRoot = getPathToRoot;
	exports.aboveViewRoot = aboveViewRoot;
	exports.wrapTreePathInfo = wrapTreePathInfo;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var axisPointerModelHelper = __webpack_require__(267);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Base class of AxisView.
	 */
	var AxisView = echarts.extendComponentView({
	  type: 'axis',
	
	  /**
	   * @private
	   */
	  _axisPointer: null,
	
	  /**
	   * @protected
	   * @type {string}
	   */
	  axisPointerClass: null,
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    // FIXME
	    // This process should proformed after coordinate systems updated
	    // (axis scale updated), and should be performed each time update.
	    // So put it here temporarily, although it is not appropriate to
	    // put a model-writing procedure in `view`.
	    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
	    AxisView.superApply(this, 'render', arguments);
	    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
	  },
	
	  /**
	   * Action handler.
	   * @public
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/model/Global} ecModel
	   * @param {module:echarts/ExtensionAPI} api
	   * @param {Object} payload
	   */
	  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
	    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    var axisPointer = this._axisPointer;
	    axisPointer && axisPointer.remove(api);
	    AxisView.superApply(this, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    disposeAxisPointer(this, api);
	    AxisView.superApply(this, 'dispose', arguments);
	  }
	});
	
	function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
	  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);
	
	  if (!Clazz) {
	    return;
	  }
	
	  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
	  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
	}
	
	function disposeAxisPointer(axisView, ecModel, api) {
	  var axisPointer = axisView._axisPointer;
	  axisPointer && axisPointer.dispose(ecModel, api);
	  axisView._axisPointer = null;
	}
	
	var axisPointerClazz = [];
	
	AxisView.registerAxisPointerClass = function (type, clazz) {
	  axisPointerClazz[type] = clazz;
	};
	
	AxisView.getAxisPointerClass = function (type) {
	  return type && axisPointerClazz[type];
	};
	
	var _default = AxisView;
	module.exports = _default;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function defaultKeyGetter(item) {
	  return item;
	}
	/**
	 * @param {Array} oldArr
	 * @param {Array} newArr
	 * @param {Function} oldKeyGetter
	 * @param {Function} newKeyGetter
	 * @param {Object} [context] Can be visited by this.context in callback.
	 */
	
	
	function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
	  this._old = oldArr;
	  this._new = newArr;
	  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
	  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
	  this.context = context;
	}
	
	DataDiffer.prototype = {
	  constructor: DataDiffer,
	
	  /**
	   * Callback function when add a data
	   */
	  add: function (func) {
	    this._add = func;
	    return this;
	  },
	
	  /**
	   * Callback function when update a data
	   */
	  update: function (func) {
	    this._update = func;
	    return this;
	  },
	
	  /**
	   * Callback function when remove a data
	   */
	  remove: function (func) {
	    this._remove = func;
	    return this;
	  },
	  execute: function () {
	    var oldArr = this._old;
	    var newArr = this._new;
	    var oldDataIndexMap = {};
	    var newDataIndexMap = {};
	    var oldDataKeyArr = [];
	    var newDataKeyArr = [];
	    var i;
	    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
	    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this);
	
	    for (i = 0; i < oldArr.length; i++) {
	      var key = oldDataKeyArr[i];
	      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.
	
	      if (idx != null) {
	        // Consider there is duplicate key (for example, use dataItem.name as key).
	        // We should make sure every item in newArr and oldArr can be visited.
	        var len = idx.length;
	
	        if (len) {
	          len === 1 && (newDataIndexMap[key] = null);
	          idx = idx.shift();
	        } else {
	          newDataIndexMap[key] = null;
	        }
	
	        this._update && this._update(idx, i);
	      } else {
	        this._remove && this._remove(i);
	      }
	    }
	
	    for (var i = 0; i < newDataKeyArr.length; i++) {
	      var key = newDataKeyArr[i];
	
	      if (newDataIndexMap.hasOwnProperty(key)) {
	        var idx = newDataIndexMap[key];
	
	        if (idx == null) {
	          continue;
	        } // idx can never be empty array here. see 'set null' logic above.
	
	
	        if (!idx.length) {
	          this._add && this._add(idx);
	        } else {
	          for (var j = 0, len = idx.length; j < len; j++) {
	            this._add && this._add(idx[j]);
	          }
	        }
	      }
	    }
	  }
	};
	
	function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
	  for (var i = 0; i < arr.length; i++) {
	    // Add prefix to avoid conflict with Object.prototype.
	    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
	    var existence = map[key];
	
	    if (existence == null) {
	      keyArr.push(key);
	      map[key] = i;
	    } else {
	      if (!existence.length) {
	        map[key] = existence = [existence];
	      }
	
	      existence.push(i);
	    }
	  }
	}
	
	var _default = DataDiffer;
	module.exports = _default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(2);
	
	var isTypedArray = _util.isTypedArray;
	var extend = _util.extend;
	var assert = _util.assert;
	var each = _util.each;
	var isObject = _util.isObject;
	
	var _model = __webpack_require__(27);
	
	var getDataItemValue = _model.getDataItemValue;
	var isDataItemOption = _model.isDataItemOption;
	
	var _number = __webpack_require__(24);
	
	var parseDate = _number.parseDate;
	
	var Source = __webpack_require__(219);
	
	var _sourceType = __webpack_require__(221);
	
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO
	// ??? refactor? check the outer usage of data provider.
	// merge with defaultDimValueGetter?
	
	/**
	 * If normal array used, mutable chunk size is supported.
	 * If typed array used, chunk size must be fixed.
	 */
	function DefaultDataProvider(source, dimSize) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  this._source = source;
	  var data = this._data = source.data;
	  var sourceFormat = source.sourceFormat; // Typed array. TODO IE10+?
	
	  if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
	    this._offset = 0;
	    this._dimSize = dimSize;
	    this._data = data;
	  }
	
	  var methods = providerMethods[sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + source.seriesLayoutBy : sourceFormat];
	  extend(this, methods);
	}
	
	var providerProto = DefaultDataProvider.prototype; // If data is pure without style configuration
	
	providerProto.pure = false; // If data is persistent and will not be released after use.
	
	providerProto.persistent = true; // ???! FIXME legacy data provider do not has method getSource
	
	providerProto.getSource = function () {
	  return this._source;
	};
	
	var providerMethods = {
	  'arrayRows_column': {
	    pure: true,
	    count: function () {
	      return Math.max(0, this._data.length - this._source.startIndex);
	    },
	    getItem: function (idx) {
	      return this._data[idx + this._source.startIndex];
	    },
	    appendData: appendDataSimply
	  },
	  'arrayRows_row': {
	    pure: true,
	    count: function () {
	      var row = this._data[0];
	      return row ? Math.max(0, row.length - this._source.startIndex) : 0;
	    },
	    getItem: function (idx) {
	      idx += this._source.startIndex;
	      var item = [];
	      var data = this._data;
	
	      for (var i = 0; i < data.length; i++) {
	        var row = data[i];
	        item.push(row ? row[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function () {
	      throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
	    }
	  },
	  'objectRows': {
	    pure: true,
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'keyedColumns': {
	    pure: true,
	    count: function () {
	      var dimName = this._source.dimensionsDefine[0].name;
	      var col = this._data[dimName];
	      return col ? col.length : 0;
	    },
	    getItem: function (idx) {
	      var item = [];
	      var dims = this._source.dimensionsDefine;
	
	      for (var i = 0; i < dims.length; i++) {
	        var col = this._data[dims[i].name];
	        item.push(col ? col[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function (newData) {
	      var data = this._data;
	      each(newData, function (newCol, key) {
	        var oldCol = data[key] || (data[key] = []);
	
	        for (var i = 0; i < (newCol || []).length; i++) {
	          oldCol.push(newCol[i]);
	        }
	      });
	    }
	  },
	  'original': {
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'typedArray': {
	    persistent: false,
	    pure: true,
	    count: function () {
	      return this._data ? this._data.length / this._dimSize : 0;
	    },
	    getItem: function (idx, out) {
	      idx = idx - this._offset;
	      out = out || [];
	      var offset = this._dimSize * idx;
	
	      for (var i = 0; i < this._dimSize; i++) {
	        out[i] = this._data[offset + i];
	      }
	
	      return out;
	    },
	    appendData: function (newData) {
	      this._data = newData;
	    },
	    // Clean self if data is already used.
	    clean: function () {
	      // PENDING
	      this._offset += this.count();
	      this._data = null;
	    }
	  }
	};
	
	function countSimply() {
	  return this._data.length;
	}
	
	function getItemSimply(idx) {
	  return this._data[idx];
	}
	
	function appendDataSimply(newData) {
	  for (var i = 0; i < newData.length; i++) {
	    this._data.push(newData[i]);
	  }
	}
	
	var rawValueGetters = {
	  arrayRows: getRawValueSimply,
	  objectRows: function (dataItem, dataIndex, dimIndex, dimName) {
	    return dimIndex != null ? dataItem[dimName] : dataItem;
	  },
	  keyedColumns: getRawValueSimply,
	  original: function (dataItem, dataIndex, dimIndex, dimName) {
	    // FIXME
	    // In some case (markpoint in geo (geo-map.html)), dataItem
	    // is {coord: [...]}
	    var value = getDataItemValue(dataItem);
	    return dimIndex == null || !(value instanceof Array) ? value : value[dimIndex];
	  },
	  typedArray: getRawValueSimply
	};
	
	function getRawValueSimply(dataItem, dataIndex, dimIndex, dimName) {
	  return dimIndex != null ? dataItem[dimIndex] : dataItem;
	}
	
	var defaultDimValueGetters = {
	  arrayRows: getDimValueSimply,
	  objectRows: function (dataItem, dimName, dataIndex, dimIndex) {
	    return converDataValue(dataItem[dimName], this._dimensionInfos[dimName]);
	  },
	  keyedColumns: getDimValueSimply,
	  original: function (dataItem, dimName, dataIndex, dimIndex) {
	    // Performance sensitive, do not use modelUtil.getDataItemValue.
	    // If dataItem is an plain object with no value field, the var `value`
	    // will be assigned with the object, but it will be tread correctly
	    // in the `convertDataValue`.
	    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value); // If any dataItem is like { value: 10 }
	
	    if (!this._rawData.pure && isDataItemOption(dataItem)) {
	      this.hasItemOption = true;
	    }
	
	    return converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
	    : value, this._dimensionInfos[dimName]);
	  },
	  typedArray: function (dataItem, dimName, dataIndex, dimIndex) {
	    return dataItem[dimIndex];
	  }
	};
	
	function getDimValueSimply(dataItem, dimName, dataIndex, dimIndex) {
	  return converDataValue(dataItem[dimIndex], this._dimensionInfos[dimName]);
	}
	/**
	 * This helper method convert value in data.
	 * @param {string|number|Date} value
	 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
	 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
	 */
	
	
	function converDataValue(value, dimInfo) {
	  // Performance sensitive.
	  var dimType = dimInfo && dimInfo.type;
	
	  if (dimType === 'ordinal') {
	    // If given value is a category string
	    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
	    return ordinalMeta ? ordinalMeta.parseAndCollect(value) : value;
	  }
	
	  if (dimType === 'time' // spead up when using timestamp
	  && typeof value !== 'number' && value != null && value !== '-') {
	    value = +parseDate(value);
	  } // dimType defaults 'number'.
	  // If dimType is not ordinal and value is null or undefined or NaN or '-',
	  // parse to NaN.
	
	
	  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
	  // If object, also parse to NaN
	  : +value;
	} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
	// Consider persistent.
	// Caution: why use raw value to display on label or tooltip?
	// A reason is to avoid format. For example time value we do not know
	// how to format is expected. More over, if stack is used, calculated
	// value may be 0.91000000001, which have brings trouble to display.
	// TODO: consider how to treat null/undefined/NaN when display?
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string|number} [dim] dimName or dimIndex
	 * @return {Array.<number>|string|number} can be null/undefined.
	 */
	
	
	function retrieveRawValue(data, dataIndex, dim) {
	  if (!data) {
	    return;
	  } // Consider data may be not persistent.
	
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (dataItem == null) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	  var dimName;
	  var dimIndex;
	  var dimInfo = data.getDimensionInfo(dim);
	
	  if (dimInfo) {
	    dimName = dimInfo.name;
	    dimIndex = dimInfo.index;
	  }
	
	  return rawValueGetters[sourceFormat](dataItem, dataIndex, dimIndex, dimName);
	}
	/**
	 * Compatible with some cases (in pie, map) like:
	 * data: [{name: 'xx', value: 5, selected: true}, ...]
	 * where only sourceFormat is 'original' and 'objectRows' supported.
	 *
	 * ??? TODO
	 * Supported detail options in data item when using 'arrayRows'.
	 *
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string} attr like 'selected'
	 */
	
	
	function retrieveRawAttr(data, dataIndex, attr) {
	  if (!data) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	
	  if (sourceFormat !== SOURCE_FORMAT_ORIGINAL && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
	    return;
	  }
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (sourceFormat === SOURCE_FORMAT_ORIGINAL && !isObject(dataItem)) {
	    dataItem = null;
	  }
	
	  if (dataItem) {
	    return dataItem[attr];
	  }
	}
	
	exports.DefaultDataProvider = DefaultDataProvider;
	exports.defaultDimValueGetters = defaultDimValueGetters;
	exports.retrieveRawValue = retrieveRawValue;
	exports.retrieveRawAttr = retrieveRawAttr;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var zrColor = __webpack_require__(105);
	
	var _number = __webpack_require__(24);
	
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
	/**
	 * @param {Object} option
	 * @param {string} [option.type] See visualHandlers.
	 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
	 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
	 *                                              required when mappingMethod is 'linear'
	 * @param {Array.<Object>=} [option.pieceList] [
	 *                                             {value: someValue},
	 *                                             {interval: [min1, max1], visual: {...}},
	 *                                             {interval: [min2, max2]}
	 *                                             ],
	 *                                            required when mappingMethod is 'piecewise'.
	 *                                            Visual for only each piece can be specified.
	 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
	 *                                            required when mappingMethod is 'category'.
	 *                                            If no option.categories, categories is set
	 *                                            as [0, 1, 2, ...].
	 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
	 * @param {(Array|Object|*)} [option.visual]  Visual data.
	 *                                            when mappingMethod is 'category',
	 *                                            visual data can be array or object
	 *                                            (like: {cate1: '#222', none: '#fff'})
	 *                                            or primary types (which represents
	 *                                            default category visual), otherwise visual
	 *                                            can be array or primary (which will be
	 *                                            normalized to array).
	 *
	 */
	
	var VisualMapping = function (option) {
	  var mappingMethod = option.mappingMethod;
	  var visualType = option.type;
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	
	  var thisOption = this.option = zrUtil.clone(option);
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.type = visualType;
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.mappingMethod = mappingMethod;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._normalizeData = normalizers[mappingMethod];
	  var visualHandler = visualHandlers[visualType];
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.applyVisual = visualHandler.applyVisual;
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.getColorMapper = visualHandler.getColorMapper;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._doMap = visualHandler._doMap[mappingMethod];
	
	  if (mappingMethod === 'piecewise') {
	    normalizeVisualRange(thisOption);
	    preprocessForPiecewise(thisOption);
	  } else if (mappingMethod === 'category') {
	    thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
	    // which need no more preprocess except normalize visual.
	    : normalizeVisualRange(thisOption, true);
	  } else {
	    // mappingMethod === 'linear' or 'fixed'
	    zrUtil.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
	    normalizeVisualRange(thisOption);
	  }
	};
	
	VisualMapping.prototype = {
	  constructor: VisualMapping,
	  mapValueToVisual: function (value) {
	    var normalized = this._normalizeData(value);
	
	    return this._doMap(normalized, value);
	  },
	  getNormalizer: function () {
	    return zrUtil.bind(this._normalizeData, this);
	  }
	};
	var visualHandlers = VisualMapping.visualHandlers = {
	  color: {
	    applyVisual: makeApplyVisual('color'),
	
	    /**
	     * Create a mapper function
	     * @return {Function}
	     */
	    getColorMapper: function () {
	      var thisOption = this.option;
	      return zrUtil.bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
	        !isNormalized && (value = this._normalizeData(value));
	        return doMapCategory.call(this, value);
	      } : function (value, isNormalized, out) {
	        // If output rgb array
	        // which will be much faster and useful in pixel manipulation
	        var returnRGBArray = !!out;
	        !isNormalized && (value = this._normalizeData(value));
	        out = zrColor.fastLerp(value, thisOption.parsedVisual, out);
	        return returnRGBArray ? out : zrColor.stringify(out, 'rgba');
	      }, this);
	    },
	    _doMap: {
	      linear: function (normalized) {
	        return zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	      },
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  colorHue: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, value);
	  }),
	  colorSaturation: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, value);
	  }),
	  colorLightness: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, null, value);
	  }),
	  colorAlpha: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyAlpha(color, value);
	  }),
	  opacity: {
	    applyVisual: makeApplyVisual('opacity'),
	    _doMap: makeDoMap([0, 1])
	  },
	  liftZ: {
	    applyVisual: makeApplyVisual('liftZ'),
	    _doMap: {
	      linear: doMapFixed,
	      category: doMapFixed,
	      piecewise: doMapFixed,
	      fixed: doMapFixed
	    }
	  },
	  symbol: {
	    applyVisual: function (value, getter, setter) {
	      var symbolCfg = this.mapValueToVisual(value);
	
	      if (zrUtil.isString(symbolCfg)) {
	        setter('symbol', symbolCfg);
	      } else if (isObject(symbolCfg)) {
	        for (var name in symbolCfg) {
	          if (symbolCfg.hasOwnProperty(name)) {
	            setter(name, symbolCfg[name]);
	          }
	        }
	      }
	    },
	    _doMap: {
	      linear: doMapToArray,
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = doMapToArray.call(this, normalized);
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  symbolSize: {
	    applyVisual: makeApplyVisual('symbolSize'),
	    _doMap: makeDoMap([0, 1])
	  }
	};
	
	function preprocessForPiecewise(thisOption) {
	  var pieceList = thisOption.pieceList;
	  thisOption.hasSpecialVisual = false;
	  zrUtil.each(pieceList, function (piece, index) {
	    piece.originIndex = index; // piece.visual is "result visual value" but not
	    // a visual range, so it does not need to be normalized.
	
	    if (piece.visual != null) {
	      thisOption.hasSpecialVisual = true;
	    }
	  });
	}
	
	function preprocessForSpecifiedCategory(thisOption) {
	  // Hash categories.
	  var categories = thisOption.categories;
	  var visual = thisOption.visual;
	  var categoryMap = thisOption.categoryMap = {};
	  each(categories, function (cate, index) {
	    categoryMap[cate] = index;
	  }); // Process visual map input.
	
	  if (!zrUtil.isArray(visual)) {
	    var visualArr = [];
	
	    if (zrUtil.isObject(visual)) {
	      each(visual, function (v, cate) {
	        var index = categoryMap[cate];
	        visualArr[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
	      });
	    } else {
	      // Is primary type, represents default visual.
	      visualArr[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
	    }
	
	    visual = setVisualToOption(thisOption, visualArr);
	  } // Remove categories that has no visual,
	  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
	
	
	  for (var i = categories.length - 1; i >= 0; i--) {
	    if (visual[i] == null) {
	      delete categoryMap[categories[i]];
	      categories.pop();
	    }
	  }
	}
	
	function normalizeVisualRange(thisOption, isCategory) {
	  var visual = thisOption.visual;
	  var visualArr = [];
	
	  if (zrUtil.isObject(visual)) {
	    each(visual, function (v) {
	      visualArr.push(v);
	    });
	  } else if (visual != null) {
	    visualArr.push(visual);
	  }
	
	  var doNotNeedPair = {
	    color: 1,
	    symbol: 1
	  };
	
	  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
	    // Do not care visualArr.length === 0, which is illegal.
	    visualArr[1] = visualArr[0];
	  }
	
	  setVisualToOption(thisOption, visualArr);
	}
	
	function makePartialColorVisualHandler(applyValue) {
	  return {
	    applyVisual: function (value, getter, setter) {
	      value = this.mapValueToVisual(value); // Must not be array value
	
	      setter('color', applyValue(getter('color'), value));
	    },
	    _doMap: makeDoMap([0, 1])
	  };
	}
	
	function doMapToArray(normalized) {
	  var visual = this.option.visual;
	  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {};
	}
	
	function makeApplyVisual(visualType) {
	  return function (value, getter, setter) {
	    setter(visualType, this.mapValueToVisual(value));
	  };
	}
	
	function doMapCategory(normalized) {
	  var visual = this.option.visual;
	  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
	}
	
	function doMapFixed() {
	  return this.option.visual[0];
	}
	
	function makeDoMap(sourceExtent) {
	  return {
	    linear: function (normalized) {
	      return linearMap(normalized, sourceExtent, this.option.visual, true);
	    },
	    category: doMapCategory,
	    piecewise: function (normalized, value) {
	      var result = getSpecifiedVisual.call(this, value);
	
	      if (result == null) {
	        result = linearMap(normalized, sourceExtent, this.option.visual, true);
	      }
	
	      return result;
	    },
	    fixed: doMapFixed
	  };
	}
	
	function getSpecifiedVisual(value) {
	  var thisOption = this.option;
	  var pieceList = thisOption.pieceList;
	
	  if (thisOption.hasSpecialVisual) {
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
	    var piece = pieceList[pieceIndex];
	
	    if (piece && piece.visual) {
	      return piece.visual[this.type];
	    }
	  }
	}
	
	function setVisualToOption(thisOption, visualArr) {
	  thisOption.visual = visualArr;
	
	  if (thisOption.type === 'color') {
	    thisOption.parsedVisual = zrUtil.map(visualArr, function (item) {
	      return zrColor.parse(item);
	    });
	  }
	
	  return visualArr;
	}
	/**
	 * Normalizers by mapping methods.
	 */
	
	
	var normalizers = {
	  linear: function (value) {
	    return linearMap(value, this.option.dataExtent, [0, 1], true);
	  },
	  piecewise: function (value) {
	    var pieceList = this.option.pieceList;
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);
	
	    if (pieceIndex != null) {
	      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
	    }
	  },
	  category: function (value) {
	    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal
	
	    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
	  },
	  fixed: zrUtil.noop
	};
	/**
	 * List available visual types.
	 *
	 * @public
	 * @return {Array.<string>}
	 */
	
	VisualMapping.listVisualTypes = function () {
	  var visualTypes = [];
	  zrUtil.each(visualHandlers, function (handler, key) {
	    visualTypes.push(key);
	  });
	  return visualTypes;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.addVisualHandler = function (name, handler) {
	  visualHandlers[name] = handler;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.isValidType = function (visualType) {
	  return visualHandlers.hasOwnProperty(visualType);
	};
	/**
	 * Convinent method.
	 * Visual can be Object or Array or primary type.
	 *
	 * @public
	 */
	
	
	VisualMapping.eachVisual = function (visual, callback, context) {
	  if (zrUtil.isObject(visual)) {
	    zrUtil.each(visual, callback, context);
	  } else {
	    callback.call(context, visual);
	  }
	};
	
	VisualMapping.mapVisual = function (visual, callback, context) {
	  var isPrimary;
	  var newVisual = zrUtil.isArray(visual) ? [] : zrUtil.isObject(visual) ? {} : (isPrimary = true, null);
	  VisualMapping.eachVisual(visual, function (v, key) {
	    var newVal = callback.call(context, v, key);
	    isPrimary ? newVisual = newVal : newVisual[key] = newVal;
	  });
	  return newVisual;
	};
	/**
	 * @public
	 * @param {Object} obj
	 * @return {Object} new object containers visual values.
	 *                 If no visuals, return null.
	 */
	
	
	VisualMapping.retrieveVisuals = function (obj) {
	  var ret = {};
	  var hasVisual;
	  obj && each(visualHandlers, function (h, visualType) {
	    if (obj.hasOwnProperty(visualType)) {
	      ret[visualType] = obj[visualType];
	      hasVisual = true;
	    }
	  });
	  return hasVisual ? ret : null;
	};
	/**
	 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
	 *
	 * @public
	 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
	 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
	 * @return {Array.<string>} Sorted visual types.
	 */
	
	
	VisualMapping.prepareVisualTypes = function (visualTypes) {
	  if (isObject(visualTypes)) {
	    var types = [];
	    each(visualTypes, function (item, type) {
	      types.push(type);
	    });
	    visualTypes = types;
	  } else if (zrUtil.isArray(visualTypes)) {
	    visualTypes = visualTypes.slice();
	  } else {
	    return [];
	  }
	
	  visualTypes.sort(function (type1, type2) {
	    // color should be front of colorSaturation, colorAlpha, ...
	    // symbol and symbolSize do not matter.
	    return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
	  });
	  return visualTypes;
	};
	/**
	 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
	 * Other visuals are only depends on themself.
	 *
	 * @public
	 * @param {string} visualType1
	 * @param {string} visualType2
	 * @return {boolean}
	 */
	
	
	VisualMapping.dependsOn = function (visualType1, visualType2) {
	  return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
	};
	/**
	 * @param {number} value
	 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
	 *                         Always from small to big.
	 * @param {boolean} [findClosestWhenOutside=false]
	 * @return {number} index
	 */
	
	
	VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
	  var possibleI;
	  var abs = Infinity; // value has the higher priority.
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var pieceValue = pieceList[i].value;
	
	    if (pieceValue != null) {
	      if (pieceValue === value // FIXME
	      // It is supposed to compare value according to value type of dimension,
	      // but currently value type can exactly be string or number.
	      // Compromise for numeric-like string (like '12'), especially
	      // in the case that visualMap.categories is ['22', '33'].
	      || typeof pieceValue === 'string' && pieceValue === value + '') {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(pieceValue, i);
	    }
	  }
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var piece = pieceList[i];
	    var interval = piece.interval;
	    var close = piece.close;
	
	    if (interval) {
	      if (interval[0] === -Infinity) {
	        if (littleThan(close[1], value, interval[1])) {
	          return i;
	        }
	      } else if (interval[1] === Infinity) {
	        if (littleThan(close[0], interval[0], value)) {
	          return i;
	        }
	      } else if (littleThan(close[0], interval[0], value) && littleThan(close[1], value, interval[1])) {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(interval[0], i);
	      findClosestWhenOutside && updatePossible(interval[1], i);
	    }
	  }
	
	  if (findClosestWhenOutside) {
	    return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
	  }
	
	  function updatePossible(val, index) {
	    var newAbs = Math.abs(val - value);
	
	    if (newAbs < abs) {
	      abs = newAbs;
	      possibleI = index;
	    }
	  }
	};
	
	function littleThan(close, a, b) {
	  return close ? a <= b : a < b;
	}
	
	var _default = VisualMapping;
	module.exports = _default;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var isFunction = _util.isFunction;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, defaultSymbolType, legendSymbol) {
	  // Encoding visual for all series include which is filtered for legend drawing
	  return {
	    seriesType: seriesType,
	    // For legend.
	    performRawSeries: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var symbolType = seriesModel.get('symbol');
	      var symbolSize = seriesModel.get('symbolSize');
	      var keepAspect = seriesModel.get('symbolKeepAspect');
	      var symbolRotate = seriesModel.get('symbolRotate');
	      var hasSymbolTypeCallback = isFunction(symbolType);
	      var hasSymbolSizeCallback = isFunction(symbolSize);
	      var hasSymbolRotateCallback = isFunction(symbolRotate);
	      var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback;
	      var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : defaultSymbolType;
	      var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
	      var seriesSymbolRotate = !hasSymbolRotateCallback ? seriesSymbolRotate : null;
	      data.setVisual({
	        legendSymbol: legendSymbol || seriesSymbol,
	        // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
	        // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
	        // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
	        // some cases but generally it is not recommanded.
	        symbol: seriesSymbol,
	        symbolSize: seriesSymbolSize,
	        symbolKeepAspect: keepAspect,
	        symbolRotate: symbolRotate
	      }); // Only visible series has each data be visual encoded
	
	      if (ecModel.isSeriesFiltered(seriesModel)) {
	        return;
	      }
	
	      function dataEach(data, idx) {
	        if (hasCallback) {
	          var rawValue = seriesModel.getRawValue(idx);
	          var params = seriesModel.getDataParams(idx);
	          hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
	          hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
	          hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
	        }
	
	        if (data.hasItemOption) {
	          var itemModel = data.getItemModel(idx);
	          var itemSymbolType = itemModel.getShallow('symbol', true);
	          var itemSymbolSize = itemModel.getShallow('symbolSize', true);
	          var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
	          var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
	
	          if (itemSymbolType != null) {
	            data.setItemVisual(idx, 'symbol', itemSymbolType);
	          }
	
	          if (itemSymbolSize != null) {
	            // PENDING Transform symbolSize ?
	            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
	          }
	
	          if (itemSymbolRotate != null) {
	            data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
	          }
	
	          if (itemSymbolKeepAspect != null) {
	            data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
	          }
	        }
	      }
	
	      return {
	        dataEach: data.hasItemOption || hasCallback ? dataEach : null
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(2);
	
	var Element = __webpack_require__(894);
	
	var BoundingRect = __webpack_require__(51);
	
	/**
	 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
	 * @module zrender/graphic/Group
	 * @example
	 *     var Group = require('zrender/container/Group');
	 *     var Circle = require('zrender/graphic/shape/Circle');
	 *     var g = new Group();
	 *     g.position[0] = 100;
	 *     g.position[1] = 100;
	 *     g.add(new Circle({
	 *         style: {
	 *             x: 100,
	 *             y: 100,
	 *             r: 20,
	 *         }
	 *     }));
	 *     zr.add(g);
	 */
	
	/**
	 * @alias module:zrender/graphic/Group
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @extends module:zrender/mixin/Eventful
	 */
	var Group = function (opts) {
	  opts = opts || {};
	  Element.call(this, opts);
	
	  for (var key in opts) {
	    if (opts.hasOwnProperty(key)) {
	      this[key] = opts[key];
	    }
	  }
	
	  this._children = [];
	  this.__storage = null;
	  this.__dirty = true;
	};
	
	Group.prototype = {
	  constructor: Group,
	  isGroup: true,
	
	  /**
	   * @type {string}
	   */
	  type: 'group',
	
	  /**
	   * 所有子孙元素是否响应鼠标事件
	   * @name module:/zrender/container/Group#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * @return {Array.<module:zrender/Element>}
	   */
	  children: function () {
	    return this._children.slice();
	  },
	
	  /**
	   * 获取指定 index 的儿子节点
	   * @param  {number} idx
	   * @return {module:zrender/Element}
	   */
	  childAt: function (idx) {
	    return this._children[idx];
	  },
	
	  /**
	   * 获取指定名字的儿子节点
	   * @param  {string} name
	   * @return {module:zrender/Element}
	   */
	  childOfName: function (name) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].name === name) {
	        return children[i];
	      }
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  childCount: function () {
	    return this._children.length;
	  },
	
	  /**
	   * 添加子节点到最后
	   * @param {module:zrender/Element} child
	   */
	  add: function (child) {
	    if (child && child !== this && child.parent !== this) {
	      this._children.push(child);
	
	      this._doAdd(child);
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加子节点在 nextSibling 之前
	   * @param {module:zrender/Element} child
	   * @param {module:zrender/Element} nextSibling
	   */
	  addBefore: function (child, nextSibling) {
	    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
	      var children = this._children;
	      var idx = children.indexOf(nextSibling);
	
	      if (idx >= 0) {
	        children.splice(idx, 0, child);
	
	        this._doAdd(child);
	      }
	    }
	
	    return this;
	  },
	  _doAdd: function (child) {
	    if (child.parent) {
	      child.parent.remove(child);
	    }
	
	    child.parent = this;
	    var storage = this.__storage;
	    var zr = this.__zr;
	
	    if (storage && storage !== child.__storage) {
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	  },
	
	  /**
	   * 移除子节点
	   * @param {module:zrender/Element} child
	   */
	  remove: function (child) {
	    var zr = this.__zr;
	    var storage = this.__storage;
	    var children = this._children;
	    var idx = zrUtil.indexOf(children, child);
	
	    if (idx < 0) {
	      return this;
	    }
	
	    children.splice(idx, 1);
	    child.parent = null;
	
	    if (storage) {
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	    return this;
	  },
	
	  /**
	   * 移除所有子节点
	   */
	  removeAll: function () {
	    var children = this._children;
	    var storage = this.__storage;
	    var child;
	    var i;
	
	    for (i = 0; i < children.length; i++) {
	      child = children[i];
	
	      if (storage) {
	        storage.delFromStorage(child);
	
	        if (child instanceof Group) {
	          child.delChildrenFromStorage(storage);
	        }
	      }
	
	      child.parent = null;
	    }
	
	    children.length = 0;
	    return this;
	  },
	
	  /**
	   * 遍历所有子节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  eachChild: function (cb, context) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	      cb.call(context, child, i);
	    }
	
	    return this;
	  },
	
	  /**
	   * 深度优先遍历所有子孙节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      cb.call(context, child);
	
	      if (child.type === 'group') {
	        child.traverse(cb, context);
	      }
	    }
	
	    return this;
	  },
	  addChildrenToStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	  },
	  delChildrenFromStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	  },
	  dirty: function () {
	    this.__dirty = true;
	    this.__zr && this.__zr.refresh();
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function (includeChildren) {
	    // TODO Caching
	    var rect = null;
	    var tmpRect = new BoundingRect(0, 0, 0, 0);
	    var children = includeChildren || this._children;
	    var tmpMat = [];
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	
	      if (child.ignore || child.invisible) {
	        continue;
	      }
	
	      var childRect = child.getBoundingRect();
	      var transform = child.getLocalTransform(tmpMat); // TODO
	      // The boundingRect cacluated by transforming original
	      // rect may be bigger than the actual bundingRect when rotation
	      // is used. (Consider a circle rotated aginst its center, where
	      // the actual boundingRect should be the same as that not be
	      // rotated.) But we can not find better approach to calculate
	      // actual boundingRect yet, considering performance.
	
	      if (transform) {
	        tmpRect.copy(childRect);
	        tmpRect.applyTransform(transform);
	        rect = rect || tmpRect.clone();
	        rect.union(tmpRect);
	      } else {
	        rect = rect || childRect.clone();
	        rect.union(childRect);
	      }
	    }
	
	    return rect || tmpRect;
	  }
	};
	zrUtil.inherits(Group, Element);
	var _default = Group;
	module.exports = _default;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(228);
	
	var zrUtil = __webpack_require__(2);
	
	var textContain = __webpack_require__(86);
	
	var textHelper = __webpack_require__(283);
	
	var _constant = __webpack_require__(282);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	
	/**
	 * @alias zrender/graphic/Text
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	var Text = function (opts) {
	  // jshint ignore:line
	  Displayable.call(this, opts);
	};
	
	Text.prototype = {
	  constructor: Text,
	  type: 'text',
	  brush: function (ctx, prevEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.
	
	    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
	    var text = style.text; // Convert to string
	
	    text != null && (text += ''); // Do not apply style.bind in Text node. Because the real bind job
	    // is in textHelper.renderText, and performance of text render should
	    // be considered.
	    // style.bind(ctx, this, prevEl);
	
	    if (!textHelper.needDrawText(text, style)) {
	      // The current el.style is not applied
	      // and should not be used as cache.
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	      return;
	    }
	
	    this.setTransform(ctx);
	    textHelper.renderText(this, ctx, text, style, null, prevEl);
	    this.restoreTransform(ctx);
	  },
	  getBoundingRect: function () {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	
	    if (!this._rect) {
	      var text = style.text;
	      text != null ? text += '' : text = '';
	      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.textLineHeight, style.rich);
	      rect.x += style.x || 0;
	      rect.y += style.y || 0;
	
	      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
	        var w = style.textStrokeWidth;
	        rect.x -= w / 2;
	        rect.y -= w / 2;
	        rect.width += w;
	        rect.height += w;
	      }
	
	      this._rect = rect;
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(Text, Displayable);
	var _default = Text;
	module.exports = _default;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	/**
	 * Event Mixin
	 * @module zrender/mixin/Eventful
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         pissang (https://www.github.com/pissang)
	 */
	var arrySlice = Array.prototype.slice;
	/**
	 * Event dispatcher.
	 *
	 * @alias module:zrender/mixin/Eventful
	 * @constructor
	 * @param {Object} [eventProcessor] The object eventProcessor is the scope when
	 *        `eventProcessor.xxx` called.
	 * @param {Function} [eventProcessor.normalizeQuery]
	 *        param: {string|Object} Raw query.
	 *        return: {string|Object} Normalized query.
	 * @param {Function} [eventProcessor.filter] Event will be dispatched only
	 *        if it returns `true`.
	 *        param: {string} eventType
	 *        param: {string|Object} query
	 *        return: {boolean}
	 * @param {Function} [eventProcessor.afterTrigger] Called after all handlers called.
	 *        param: {string} eventType
	 */
	
	var Eventful = function (eventProcessor) {
	  this._$handlers = {};
	  this._$eventProcessor = eventProcessor;
	};
	
	Eventful.prototype = {
	  constructor: Eventful,
	
	  /**
	   * The handler can only be triggered once, then removed.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} context
	   */
	  one: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, true);
	  },
	
	  /**
	   * Bind a handler.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} [context]
	   */
	  on: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, false);
	  },
	
	  /**
	   * Whether any handler has bound.
	   *
	   * @param  {string}  event
	   * @return {boolean}
	   */
	  isSilent: function (event) {
	    var _h = this._$handlers;
	    return !_h[event] || !_h[event].length;
	  },
	
	  /**
	   * Unbind a event.
	   *
	   * @param {string} [event] The event name.
	   *        If no `event` input, "off" all listeners.
	   * @param {Function} [handler] The event handler.
	   *        If no `handler` input, "off" all listeners of the `event`.
	   */
	  off: function (event, handler) {
	    var _h = this._$handlers;
	
	    if (!event) {
	      this._$handlers = {};
	      return this;
	    }
	
	    if (handler) {
	      if (_h[event]) {
	        var newList = [];
	
	        for (var i = 0, l = _h[event].length; i < l; i++) {
	          if (_h[event][i].h !== handler) {
	            newList.push(_h[event][i]);
	          }
	        }
	
	        _h[event] = newList;
	      }
	
	      if (_h[event] && _h[event].length === 0) {
	        delete _h[event];
	      }
	    } else {
	      delete _h[event];
	    }
	
	    return this;
	  },
	
	  /**
	   * Dispatch a event.
	   *
	   * @param {string} type The event name.
	   */
	  trigger: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 3) {
	        args = arrySlice.call(args, 1);
	      }
	
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(hItem.ctx);
	            break;
	
	          case 2:
	            hItem.h.call(hItem.ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(hItem.ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(hItem.ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  },
	
	  /**
	   * Dispatch a event with context, which is specified at the last parameter.
	   *
	   * @param {string} type The event name.
	   */
	  triggerWithContext: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 4) {
	        args = arrySlice.call(args, 1, args.length - 1);
	      }
	
	      var ctx = args[args.length - 1];
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(ctx);
	            break;
	
	          case 2:
	            hItem.h.call(ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  }
	};
	
	function normalizeQuery(host, query) {
	  var eventProcessor = host._$eventProcessor;
	
	  if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
	    query = eventProcessor.normalizeQuery(query);
	  }
	
	  return query;
	}
	
	function on(eventful, event, query, handler, context, isOnce) {
	  var _h = eventful._$handlers;
	
	  if (typeof query === 'function') {
	    context = handler;
	    handler = query;
	    query = null;
	  }
	
	  if (!handler || !event) {
	    return eventful;
	  }
	
	  query = normalizeQuery(eventful, query);
	
	  if (!_h[event]) {
	    _h[event] = [];
	  }
	
	  for (var i = 0; i < _h[event].length; i++) {
	    if (_h[event][i].h === handler) {
	      return eventful;
	    }
	  }
	
	  var wrap = {
	    h: handler,
	    one: isOnce,
	    query: query,
	    ctx: context || eventful,
	    // FIXME
	    // Do not publish this feature util it is proved that it makes sense.
	    callAtLast: handler.zrEventfulCallAtLast
	  };
	  var lastIndex = _h[event].length - 1;
	  var lastWrap = _h[event][lastIndex];
	  lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
	  return eventful;
	} // ----------------------
	// The events in zrender
	// ----------------------
	
	/**
	 * @event module:zrender/mixin/Eventful#onclick
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseout
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousemove
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousewheel
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousedown
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseup
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrag
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragstart
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragend
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragenter
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragleave
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrop
	 * @type {Function}
	 * @default null
	 */
	
	
	var _default = Eventful;
	module.exports = _default;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var C_enc = C.enc;
			var Utf8 = C_enc.Utf8;
			var C_algo = C.algo;
	
			/**
	   * HMAC algorithm.
	   */
			var HMAC = C_algo.HMAC = Base.extend({
				/**
	    * Initializes a newly created HMAC.
	    *
	    * @param {Hasher} hasher The hash algorithm to use.
	    * @param {WordArray|string} key The secret key.
	    *
	    * @example
	    *
	    *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	    */
				init: function init(hasher, key) {
					// Init hasher
					hasher = this._hasher = new hasher.init();
	
					// Convert string to WordArray, else assume WordArray already
					if (typeof key == 'string') {
						key = Utf8.parse(key);
					}
	
					// Shortcuts
					var hasherBlockSize = hasher.blockSize;
					var hasherBlockSizeBytes = hasherBlockSize * 4;
	
					// Allow arbitrary length keys
					if (key.sigBytes > hasherBlockSizeBytes) {
						key = hasher.finalize(key);
					}
	
					// Clamp excess bits
					key.clamp();
	
					// Clone key for inner and outer pads
					var oKey = this._oKey = key.clone();
					var iKey = this._iKey = key.clone();
	
					// Shortcuts
					var oKeyWords = oKey.words;
					var iKeyWords = iKey.words;
	
					// XOR keys with pad constants
					for (var i = 0; i < hasherBlockSize; i++) {
						oKeyWords[i] ^= 0x5c5c5c5c;
						iKeyWords[i] ^= 0x36363636;
					}
					oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this HMAC to its initial state.
	    *
	    * @example
	    *
	    *     hmacHasher.reset();
	    */
				reset: function reset() {
					// Shortcut
					var hasher = this._hasher;
	
					// Reset
					hasher.reset();
					hasher.update(this._iKey);
				},
	
				/**
	    * Updates this HMAC with a message.
	    *
	    * @param {WordArray|string} messageUpdate The message to append.
	    *
	    * @return {HMAC} This HMAC instance.
	    *
	    * @example
	    *
	    *     hmacHasher.update('message');
	    *     hmacHasher.update(wordArray);
	    */
				update: function update(messageUpdate) {
					this._hasher.update(messageUpdate);
	
					// Chainable
					return this;
				},
	
				/**
	    * Finalizes the HMAC computation.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} messageUpdate (Optional) A final message update.
	    *
	    * @return {WordArray} The HMAC.
	    *
	    * @example
	    *
	    *     var hmac = hmacHasher.finalize();
	    *     var hmac = hmacHasher.finalize('message');
	    *     var hmac = hmacHasher.finalize(wordArray);
	    */
				finalize: function finalize(messageUpdate) {
					// Shortcut
					var hasher = this._hasher;
	
					// Compute HMAC
					var innerHash = hasher.finalize(messageUpdate);
					hasher.reset();
					var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
					return hmac;
				}
			});
		})();
	});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Initialization and round constants tables
			var H = [];
			var K = [];
	
			// Compute constants
			(function () {
				function isPrime(n) {
					var sqrtN = Math.sqrt(n);
					for (var factor = 2; factor <= sqrtN; factor++) {
						if (!(n % factor)) {
							return false;
						}
					}
	
					return true;
				}
	
				function getFractionalBits(n) {
					return (n - (n | 0)) * 0x100000000 | 0;
				}
	
				var n = 2;
				var nPrime = 0;
				while (nPrime < 64) {
					if (isPrime(n)) {
						if (nPrime < 8) {
							H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
						}
						K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
						nPrime++;
					}
	
					n++;
				}
			})();
	
			// Reusable object
			var W = [];
	
			/**
	   * SHA-256 hash algorithm.
	   */
			var SHA256 = C_algo.SHA256 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init(H.slice(0));
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var H = this._hash.words;
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
					var e = H[4];
					var f = H[5];
					var g = H[6];
					var h = H[7];
	
					// Computation
					for (var i = 0; i < 64; i++) {
						if (i < 16) {
							W[i] = M[offset + i] | 0;
						} else {
							var gamma0x = W[i - 15];
							var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
	
							var gamma1x = W[i - 2];
							var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
	
							W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
						}
	
						var ch = e & f ^ ~e & g;
						var maj = a & b ^ a & c ^ b & c;
	
						var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
						var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
	
						var t1 = h + sigma1 + ch + K[i] + W[i];
						var t2 = sigma0 + maj;
	
						h = g;
						g = f;
						f = e;
						e = d + t1 | 0;
						d = c;
						c = b;
						b = a;
						a = t1 + t2 | 0;
					}
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
					H[4] = H[4] + e | 0;
					H[5] = H[5] + f | 0;
					H[6] = H[6] + g | 0;
					H[7] = H[7] + h | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Return final computed hash
					return this._hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA256('message');
	   *     var hash = CryptoJS.SHA256(wordArray);
	   */
			C.SHA256 = Hasher._createHelper(SHA256);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA256(message, key);
	   */
			C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		})(Math);
	
		return CryptoJS.SHA256;
	});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(561));
	
	var _Group = _interopRequireDefault(__webpack_require__(1029));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Checkbox["default"].Group = _Group["default"];
	var _default = _Checkbox["default"];
	exports["default"] = _default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(190));
	
	var _en_US2 = _interopRequireDefault(__webpack_require__(293));
	
	var _en_US3 = _interopRequireDefault(__webpack_require__(304));
	
	var _en_US4 = _interopRequireDefault(__webpack_require__(560));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = {
	  locale: 'en',
	  Pagination: _en_US["default"],
	  DatePicker: _en_US2["default"],
	  TimePicker: _en_US3["default"],
	  Calendar: _en_US4["default"],
	  global: {
	    placeholder: 'Please select'
	  },
	  Table: {
	    filterTitle: 'Filter menu',
	    filterConfirm: 'OK',
	    filterReset: 'Reset',
	    selectAll: 'Select current page',
	    selectInvert: 'Invert current page',
	    sortTitle: 'Sort',
	    expand: 'Expand row',
	    collapse: 'Collapse row'
	  },
	  Modal: {
	    okText: 'OK',
	    cancelText: 'Cancel',
	    justOkText: 'OK'
	  },
	  Popconfirm: {
	    okText: 'OK',
	    cancelText: 'Cancel'
	  },
	  Transfer: {
	    titles: ['', ''],
	    searchPlaceholder: 'Search here',
	    itemUnit: 'item',
	    itemsUnit: 'items'
	  },
	  Upload: {
	    uploading: 'Uploading...',
	    removeFile: 'Remove file',
	    uploadError: 'Upload error',
	    previewFile: 'Preview file',
	    downloadFile: 'Download file'
	  },
	  Empty: {
	    description: 'No Data'
	  },
	  Icon: {
	    icon: 'icon'
	  },
	  Text: {
	    edit: 'Edit',
	    copy: 'Copy',
	    copied: 'Copied',
	    expand: 'Expand'
	  },
	  PageHeader: {
	    back: 'Back'
	  }
	};
	exports["default"] = _default;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var C_enc = C.enc;
			var Utf8 = C_enc.Utf8;
			var C_algo = C.algo;
	
			/**
	   * HMAC algorithm.
	   */
			var HMAC = C_algo.HMAC = Base.extend({
				/**
	    * Initializes a newly created HMAC.
	    *
	    * @param {Hasher} hasher The hash algorithm to use.
	    * @param {WordArray|string} key The secret key.
	    *
	    * @example
	    *
	    *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	    */
				init: function init(hasher, key) {
					// Init hasher
					hasher = this._hasher = new hasher.init();
	
					// Convert string to WordArray, else assume WordArray already
					if (typeof key == 'string') {
						key = Utf8.parse(key);
					}
	
					// Shortcuts
					var hasherBlockSize = hasher.blockSize;
					var hasherBlockSizeBytes = hasherBlockSize * 4;
	
					// Allow arbitrary length keys
					if (key.sigBytes > hasherBlockSizeBytes) {
						key = hasher.finalize(key);
					}
	
					// Clamp excess bits
					key.clamp();
	
					// Clone key for inner and outer pads
					var oKey = this._oKey = key.clone();
					var iKey = this._iKey = key.clone();
	
					// Shortcuts
					var oKeyWords = oKey.words;
					var iKeyWords = iKey.words;
	
					// XOR keys with pad constants
					for (var i = 0; i < hasherBlockSize; i++) {
						oKeyWords[i] ^= 0x5c5c5c5c;
						iKeyWords[i] ^= 0x36363636;
					}
					oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this HMAC to its initial state.
	    *
	    * @example
	    *
	    *     hmacHasher.reset();
	    */
				reset: function reset() {
					// Shortcut
					var hasher = this._hasher;
	
					// Reset
					hasher.reset();
					hasher.update(this._iKey);
				},
	
				/**
	    * Updates this HMAC with a message.
	    *
	    * @param {WordArray|string} messageUpdate The message to append.
	    *
	    * @return {HMAC} This HMAC instance.
	    *
	    * @example
	    *
	    *     hmacHasher.update('message');
	    *     hmacHasher.update(wordArray);
	    */
				update: function update(messageUpdate) {
					this._hasher.update(messageUpdate);
	
					// Chainable
					return this;
				},
	
				/**
	    * Finalizes the HMAC computation.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} messageUpdate (Optional) A final message update.
	    *
	    * @return {WordArray} The HMAC.
	    *
	    * @example
	    *
	    *     var hmac = hmacHasher.finalize();
	    *     var hmac = hmacHasher.finalize('message');
	    *     var hmac = hmacHasher.finalize(wordArray);
	    */
				finalize: function finalize(messageUpdate) {
					// Shortcut
					var hasher = this._hasher;
	
					// Compute HMAC
					var innerHash = hasher.finalize(messageUpdate);
					hasher.reset();
					var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
					return hmac;
				}
			});
		})();
	});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Initialization and round constants tables
			var H = [];
			var K = [];
	
			// Compute constants
			(function () {
				function isPrime(n) {
					var sqrtN = Math.sqrt(n);
					for (var factor = 2; factor <= sqrtN; factor++) {
						if (!(n % factor)) {
							return false;
						}
					}
	
					return true;
				}
	
				function getFractionalBits(n) {
					return (n - (n | 0)) * 0x100000000 | 0;
				}
	
				var n = 2;
				var nPrime = 0;
				while (nPrime < 64) {
					if (isPrime(n)) {
						if (nPrime < 8) {
							H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
						}
						K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
						nPrime++;
					}
	
					n++;
				}
			})();
	
			// Reusable object
			var W = [];
	
			/**
	   * SHA-256 hash algorithm.
	   */
			var SHA256 = C_algo.SHA256 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init(H.slice(0));
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var H = this._hash.words;
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
					var e = H[4];
					var f = H[5];
					var g = H[6];
					var h = H[7];
	
					// Computation
					for (var i = 0; i < 64; i++) {
						if (i < 16) {
							W[i] = M[offset + i] | 0;
						} else {
							var gamma0x = W[i - 15];
							var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
	
							var gamma1x = W[i - 2];
							var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
	
							W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
						}
	
						var ch = e & f ^ ~e & g;
						var maj = a & b ^ a & c ^ b & c;
	
						var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
						var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
	
						var t1 = h + sigma1 + ch + K[i] + W[i];
						var t2 = sigma0 + maj;
	
						h = g;
						g = f;
						f = e;
						e = d + t1 | 0;
						d = c;
						c = b;
						b = a;
						a = t1 + t2 | 0;
					}
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
					H[4] = H[4] + e | 0;
					H[5] = H[5] + f | 0;
					H[6] = H[6] + g | 0;
					H[7] = H[7] + h | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Return final computed hash
					return this._hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA256('message');
	   *     var hash = CryptoJS.SHA256(wordArray);
	   */
			C.SHA256 = Hasher._createHelper(SHA256);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA256(message, key);
	   */
			C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		})(Math);
	
		return CryptoJS.SHA256;
	});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _assign = __webpack_require__(53);
	
	var ReactCurrentOwner = __webpack_require__(614);
	
	var warning = __webpack_require__(44);
	var canDefineProperty = __webpack_require__(617);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(615);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function warnAboutAccessingKey() {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function warnAboutAccessingRef() {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(639));
	
	var _Group = _interopRequireDefault(__webpack_require__(1187));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Checkbox["default"].Group = _Group["default"];
	var _default = _Checkbox["default"];
	exports["default"] = _default;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(190));
	
	var _en_US2 = _interopRequireDefault(__webpack_require__(354));
	
	var _en_US3 = _interopRequireDefault(__webpack_require__(364));
	
	var _en_US4 = _interopRequireDefault(__webpack_require__(638));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = {
	  locale: 'en',
	  Pagination: _en_US["default"],
	  DatePicker: _en_US2["default"],
	  TimePicker: _en_US3["default"],
	  Calendar: _en_US4["default"],
	  global: {
	    placeholder: 'Please select'
	  },
	  Table: {
	    filterTitle: 'Filter menu',
	    filterConfirm: 'OK',
	    filterReset: 'Reset',
	    selectAll: 'Select current page',
	    selectInvert: 'Invert current page',
	    sortTitle: 'Sort',
	    expand: 'Expand row',
	    collapse: 'Collapse row'
	  },
	  Modal: {
	    okText: 'OK',
	    cancelText: 'Cancel',
	    justOkText: 'OK'
	  },
	  Popconfirm: {
	    okText: 'OK',
	    cancelText: 'Cancel'
	  },
	  Transfer: {
	    titles: ['', ''],
	    searchPlaceholder: 'Search here',
	    itemUnit: 'item',
	    itemsUnit: 'items'
	  },
	  Upload: {
	    uploading: 'Uploading...',
	    removeFile: 'Remove file',
	    uploadError: 'Upload error',
	    previewFile: 'Preview file',
	    downloadFile: 'Download file'
	  },
	  Empty: {
	    description: 'No Data'
	  },
	  Icon: {
	    icon: 'icon'
	  },
	  Text: {
	    edit: 'Edit',
	    copy: 'Copy',
	    copied: 'Copied',
	    expand: 'Expand'
	  },
	  PageHeader: {
	    back: 'Back'
	  }
	};
	exports["default"] = _default;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var ie_lt8 = /MSIE \d/.test(navigator.userAgent) && (document.documentMode == null || document.documentMode < 8);
	
	  var Pos = CodeMirror.Pos;
	
	  var matching = { "(": ")>", ")": "(<", "[": "]>", "]": "[<", "{": "}>", "}": "{<", "<": ">>", ">": "<<" };
	
	  function bracketRegex(config) {
	    return config && config.bracketRegex || /[(){}[\]]/;
	  }
	
	  function findMatchingBracket(cm, where, config) {
	    var line = cm.getLineHandle(where.line),
	        pos = where.ch - 1;
	    var afterCursor = config && config.afterCursor;
	    if (afterCursor == null) afterCursor = /(^| )cm-fat-cursor($| )/.test(cm.getWrapperElement().className);
	    var re = bracketRegex(config);
	
	    // A cursor is defined as between two characters, but in vim command mode
	    // (i.e. not insert mode), the cursor is visually represented as a
	    // highlighted box on top of the 2nd character. Otherwise, we allow matches
	    // from before or after the cursor.
	    var match = !afterCursor && pos >= 0 && re.test(line.text.charAt(pos)) && matching[line.text.charAt(pos)] || re.test(line.text.charAt(pos + 1)) && matching[line.text.charAt(++pos)];
	    if (!match) return null;
	    var dir = match.charAt(1) == ">" ? 1 : -1;
	    if (config && config.strict && dir > 0 != (pos == where.ch)) return null;
	    var style = cm.getTokenTypeAt(Pos(where.line, pos + 1));
	
	    var found = scanForBracket(cm, Pos(where.line, pos + (dir > 0 ? 1 : 0)), dir, style, config);
	    if (found == null) return null;
	    return { from: Pos(where.line, pos), to: found && found.pos,
	      match: found && found.ch == match.charAt(0), forward: dir > 0 };
	  }
	
	  // bracketRegex is used to specify which type of bracket to scan
	  // should be a regexp, e.g. /[[\]]/
	  //
	  // Note: If "where" is on an open bracket, then this bracket is ignored.
	  //
	  // Returns false when no bracket was found, null when it reached
	  // maxScanLines and gave up
	  function scanForBracket(cm, where, dir, style, config) {
	    var maxScanLen = config && config.maxScanLineLength || 10000;
	    var maxScanLines = config && config.maxScanLines || 1000;
	
	    var stack = [];
	    var re = bracketRegex(config);
	    var lineEnd = dir > 0 ? Math.min(where.line + maxScanLines, cm.lastLine() + 1) : Math.max(cm.firstLine() - 1, where.line - maxScanLines);
	    for (var lineNo = where.line; lineNo != lineEnd; lineNo += dir) {
	      var line = cm.getLine(lineNo);
	      if (!line) continue;
	      var pos = dir > 0 ? 0 : line.length - 1,
	          end = dir > 0 ? line.length : -1;
	      if (line.length > maxScanLen) continue;
	      if (lineNo == where.line) pos = where.ch - (dir < 0 ? 1 : 0);
	      for (; pos != end; pos += dir) {
	        var ch = line.charAt(pos);
	        if (re.test(ch) && (style === undefined || (cm.getTokenTypeAt(Pos(lineNo, pos + 1)) || "") == (style || ""))) {
	          var match = matching[ch];
	          if (match && match.charAt(1) == ">" == dir > 0) stack.push(ch);else if (!stack.length) return { pos: Pos(lineNo, pos), ch: ch };else stack.pop();
	        }
	      }
	    }
	    return lineNo - dir == (dir > 0 ? cm.lastLine() : cm.firstLine()) ? false : null;
	  }
	
	  function matchBrackets(cm, autoclear, config) {
	    // Disable brace matching in long lines, since it'll cause hugely slow updates
	    var maxHighlightLen = cm.state.matchBrackets.maxHighlightLineLength || 1000,
	        highlightNonMatching = config && config.highlightNonMatching;
	    var marks = [],
	        ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      var match = ranges[i].empty() && findMatchingBracket(cm, ranges[i].head, config);
	      if (match && (match.match || highlightNonMatching !== false) && cm.getLine(match.from.line).length <= maxHighlightLen) {
	        var style = match.match ? "CodeMirror-matchingbracket" : "CodeMirror-nonmatchingbracket";
	        marks.push(cm.markText(match.from, Pos(match.from.line, match.from.ch + 1), { className: style }));
	        if (match.to && cm.getLine(match.to.line).length <= maxHighlightLen) marks.push(cm.markText(match.to, Pos(match.to.line, match.to.ch + 1), { className: style }));
	      }
	    }
	
	    if (marks.length) {
	      // Kludge to work around the IE bug from issue #1193, where text
	      // input stops going to the textarea whenever this fires.
	      if (ie_lt8 && cm.state.focused) cm.focus();
	
	      var clear = function clear() {
	        cm.operation(function () {
	          for (var i = 0; i < marks.length; i++) {
	            marks[i].clear();
	          }
	        });
	      };
	      if (autoclear) setTimeout(clear, 800);else return clear;
	    }
	  }
	
	  function doMatchBrackets(cm) {
	    cm.operation(function () {
	      if (cm.state.matchBrackets.currentlyHighlighted) {
	        cm.state.matchBrackets.currentlyHighlighted();
	        cm.state.matchBrackets.currentlyHighlighted = null;
	      }
	      cm.state.matchBrackets.currentlyHighlighted = matchBrackets(cm, false, cm.state.matchBrackets);
	    });
	  }
	
	  function clearHighlighted(cm) {
	    if (cm.state.matchBrackets && cm.state.matchBrackets.currentlyHighlighted) {
	      cm.state.matchBrackets.currentlyHighlighted();
	      cm.state.matchBrackets.currentlyHighlighted = null;
	    }
	  }
	
	  CodeMirror.defineOption("matchBrackets", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.off("cursorActivity", doMatchBrackets);
	      cm.off("focus", doMatchBrackets);
	      cm.off("blur", clearHighlighted);
	      clearHighlighted(cm);
	    }
	    if (val) {
	      cm.state.matchBrackets = (typeof val === "undefined" ? "undefined" : _typeof(val)) == "object" ? val : {};
	      cm.on("cursorActivity", doMatchBrackets);
	      cm.on("focus", doMatchBrackets);
	      cm.on("blur", clearHighlighted);
	    }
	  });
	
	  CodeMirror.defineExtension("matchBrackets", function () {
	    matchBrackets(this, true);
	  });
	  CodeMirror.defineExtension("findMatchingBracket", function (pos, config, oldConfig) {
	    // Backwards-compatibility kludge
	    if (oldConfig || typeof config == "boolean") {
	      if (!oldConfig) {
	        config = config ? { strict: true } : null;
	      } else {
	        oldConfig.strict = config;
	        config = oldConfig;
	      }
	    }
	    return findMatchingBracket(this, pos, config);
	  });
	  CodeMirror.defineExtension("scanForBracket", function (pos, dir, style, config) {
	    return scanForBracket(this, pos, dir, style, config);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var Pos = CodeMirror.Pos;
	
	  function regexpFlags(regexp) {
	    var flags = regexp.flags;
	    return flags != null ? flags : (regexp.ignoreCase ? "i" : "") + (regexp.global ? "g" : "") + (regexp.multiline ? "m" : "");
	  }
	
	  function ensureFlags(regexp, flags) {
	    var current = regexpFlags(regexp),
	        target = current;
	    for (var i = 0; i < flags.length; i++) {
	      if (target.indexOf(flags.charAt(i)) == -1) target += flags.charAt(i);
	    }return current == target ? regexp : new RegExp(regexp.source, target);
	  }
	
	  function maybeMultiline(regexp) {
	    return (/\\s|\\n|\n|\\W|\\D|\[\^/.test(regexp.source)
	    );
	  }
	
	  function searchRegexpForward(doc, regexp, start) {
	    regexp = ensureFlags(regexp, "g");
	    for (var line = start.line, ch = start.ch, last = doc.lastLine(); line <= last; line++, ch = 0) {
	      regexp.lastIndex = ch;
	      var string = doc.getLine(line),
	          match = regexp.exec(string);
	      if (match) return { from: Pos(line, match.index),
	        to: Pos(line, match.index + match[0].length),
	        match: match };
	    }
	  }
	
	  function searchRegexpForwardMultiline(doc, regexp, start) {
	    if (!maybeMultiline(regexp)) return searchRegexpForward(doc, regexp, start);
	
	    regexp = ensureFlags(regexp, "gm");
	    var string,
	        chunk = 1;
	    for (var line = start.line, last = doc.lastLine(); line <= last;) {
	      // This grows the search buffer in exponentially-sized chunks
	      // between matches, so that nearby matches are fast and don't
	      // require concatenating the whole document (in case we're
	      // searching for something that has tons of matches), but at the
	      // same time, the amount of retries is limited.
	      for (var i = 0; i < chunk; i++) {
	        if (line > last) break;
	        var curLine = doc.getLine(line++);
	        string = string == null ? curLine : string + "\n" + curLine;
	      }
	      chunk = chunk * 2;
	      regexp.lastIndex = start.ch;
	      var match = regexp.exec(string);
	      if (match) {
	        var before = string.slice(0, match.index).split("\n"),
	            inside = match[0].split("\n");
	        var startLine = start.line + before.length - 1,
	            startCh = before[before.length - 1].length;
	        return { from: Pos(startLine, startCh),
	          to: Pos(startLine + inside.length - 1, inside.length == 1 ? startCh + inside[0].length : inside[inside.length - 1].length),
	          match: match };
	      }
	    }
	  }
	
	  function lastMatchIn(string, regexp, endMargin) {
	    var match,
	        from = 0;
	    while (from <= string.length) {
	      regexp.lastIndex = from;
	      var newMatch = regexp.exec(string);
	      if (!newMatch) break;
	      var end = newMatch.index + newMatch[0].length;
	      if (end > string.length - endMargin) break;
	      if (!match || end > match.index + match[0].length) match = newMatch;
	      from = newMatch.index + 1;
	    }
	    return match;
	  }
	
	  function searchRegexpBackward(doc, regexp, start) {
	    regexp = ensureFlags(regexp, "g");
	    for (var line = start.line, ch = start.ch, first = doc.firstLine(); line >= first; line--, ch = -1) {
	      var string = doc.getLine(line);
	      var match = lastMatchIn(string, regexp, ch < 0 ? 0 : string.length - ch);
	      if (match) return { from: Pos(line, match.index),
	        to: Pos(line, match.index + match[0].length),
	        match: match };
	    }
	  }
	
	  function searchRegexpBackwardMultiline(doc, regexp, start) {
	    if (!maybeMultiline(regexp)) return searchRegexpBackward(doc, regexp, start);
	    regexp = ensureFlags(regexp, "gm");
	    var string,
	        chunkSize = 1,
	        endMargin = doc.getLine(start.line).length - start.ch;
	    for (var line = start.line, first = doc.firstLine(); line >= first;) {
	      for (var i = 0; i < chunkSize && line >= first; i++) {
	        var curLine = doc.getLine(line--);
	        string = string == null ? curLine : curLine + "\n" + string;
	      }
	      chunkSize *= 2;
	
	      var match = lastMatchIn(string, regexp, endMargin);
	      if (match) {
	        var before = string.slice(0, match.index).split("\n"),
	            inside = match[0].split("\n");
	        var startLine = line + before.length,
	            startCh = before[before.length - 1].length;
	        return { from: Pos(startLine, startCh),
	          to: Pos(startLine + inside.length - 1, inside.length == 1 ? startCh + inside[0].length : inside[inside.length - 1].length),
	          match: match };
	      }
	    }
	  }
	
	  var doFold, noFold;
	  if (String.prototype.normalize) {
	    doFold = function doFold(str) {
	      return str.normalize("NFD").toLowerCase();
	    };
	    noFold = function noFold(str) {
	      return str.normalize("NFD");
	    };
	  } else {
	    doFold = function doFold(str) {
	      return str.toLowerCase();
	    };
	    noFold = function noFold(str) {
	      return str;
	    };
	  }
	
	  // Maps a position in a case-folded line back to a position in the original line
	  // (compensating for codepoints increasing in number during folding)
	  function adjustPos(orig, folded, pos, foldFunc) {
	    if (orig.length == folded.length) return pos;
	    for (var min = 0, max = pos + Math.max(0, orig.length - folded.length);;) {
	      if (min == max) return min;
	      var mid = min + max >> 1;
	      var len = foldFunc(orig.slice(0, mid)).length;
	      if (len == pos) return mid;else if (len > pos) max = mid;else min = mid + 1;
	    }
	  }
	
	  function searchStringForward(doc, query, start, caseFold) {
	    // Empty string would match anything and never progress, so we
	    // define it to match nothing instead.
	    if (!query.length) return null;
	    var fold = caseFold ? doFold : noFold;
	    var lines = fold(query).split(/\r|\n\r?/);
	
	    search: for (var line = start.line, ch = start.ch, last = doc.lastLine() + 1 - lines.length; line <= last; line++, ch = 0) {
	      var orig = doc.getLine(line).slice(ch),
	          string = fold(orig);
	      if (lines.length == 1) {
	        var found = string.indexOf(lines[0]);
	        if (found == -1) continue search;
	        var start = adjustPos(orig, string, found, fold) + ch;
	        return { from: Pos(line, adjustPos(orig, string, found, fold) + ch),
	          to: Pos(line, adjustPos(orig, string, found + lines[0].length, fold) + ch) };
	      } else {
	        var cutFrom = string.length - lines[0].length;
	        if (string.slice(cutFrom) != lines[0]) continue search;
	        for (var i = 1; i < lines.length - 1; i++) {
	          if (fold(doc.getLine(line + i)) != lines[i]) continue search;
	        }var end = doc.getLine(line + lines.length - 1),
	            endString = fold(end),
	            lastLine = lines[lines.length - 1];
	        if (endString.slice(0, lastLine.length) != lastLine) continue search;
	        return { from: Pos(line, adjustPos(orig, string, cutFrom, fold) + ch),
	          to: Pos(line + lines.length - 1, adjustPos(end, endString, lastLine.length, fold)) };
	      }
	    }
	  }
	
	  function searchStringBackward(doc, query, start, caseFold) {
	    if (!query.length) return null;
	    var fold = caseFold ? doFold : noFold;
	    var lines = fold(query).split(/\r|\n\r?/);
	
	    search: for (var line = start.line, ch = start.ch, first = doc.firstLine() - 1 + lines.length; line >= first; line--, ch = -1) {
	      var orig = doc.getLine(line);
	      if (ch > -1) orig = orig.slice(0, ch);
	      var string = fold(orig);
	      if (lines.length == 1) {
	        var found = string.lastIndexOf(lines[0]);
	        if (found == -1) continue search;
	        return { from: Pos(line, adjustPos(orig, string, found, fold)),
	          to: Pos(line, adjustPos(orig, string, found + lines[0].length, fold)) };
	      } else {
	        var lastLine = lines[lines.length - 1];
	        if (string.slice(0, lastLine.length) != lastLine) continue search;
	        for (var i = 1, start = line - lines.length + 1; i < lines.length - 1; i++) {
	          if (fold(doc.getLine(start + i)) != lines[i]) continue search;
	        }var top = doc.getLine(line + 1 - lines.length),
	            topString = fold(top);
	        if (topString.slice(topString.length - lines[0].length) != lines[0]) continue search;
	        return { from: Pos(line + 1 - lines.length, adjustPos(top, topString, top.length - lines[0].length, fold)),
	          to: Pos(line, adjustPos(orig, string, lastLine.length, fold)) };
	      }
	    }
	  }
	
	  function SearchCursor(doc, query, pos, options) {
	    this.atOccurrence = false;
	    this.afterEmptyMatch = false;
	    this.doc = doc;
	    pos = pos ? doc.clipPos(pos) : Pos(0, 0);
	    this.pos = { from: pos, to: pos };
	
	    var caseFold;
	    if ((typeof options === "undefined" ? "undefined" : _typeof(options)) == "object") {
	      caseFold = options.caseFold;
	    } else {
	      // Backwards compat for when caseFold was the 4th argument
	      caseFold = options;
	      options = null;
	    }
	
	    if (typeof query == "string") {
	      if (caseFold == null) caseFold = false;
	      this.matches = function (reverse, pos) {
	        return (reverse ? searchStringBackward : searchStringForward)(doc, query, pos, caseFold);
	      };
	    } else {
	      query = ensureFlags(query, "gm");
	      if (!options || options.multiline !== false) this.matches = function (reverse, pos) {
	        return (reverse ? searchRegexpBackwardMultiline : searchRegexpForwardMultiline)(doc, query, pos);
	      };else this.matches = function (reverse, pos) {
	        return (reverse ? searchRegexpBackward : searchRegexpForward)(doc, query, pos);
	      };
	    }
	  }
	
	  SearchCursor.prototype = {
	    findNext: function findNext() {
	      return this.find(false);
	    },
	    findPrevious: function findPrevious() {
	      return this.find(true);
	    },
	
	    find: function find(reverse) {
	      var head = this.doc.clipPos(reverse ? this.pos.from : this.pos.to);
	      if (this.afterEmptyMatch && this.atOccurrence) {
	        // do not return the same 0 width match twice
	        head = Pos(head.line, head.ch);
	        if (reverse) {
	          head.ch--;
	          if (head.ch < 0) {
	            head.line--;
	            head.ch = (this.doc.getLine(head.line) || "").length;
	          }
	        } else {
	          head.ch++;
	          if (head.ch > (this.doc.getLine(head.line) || "").length) {
	            head.ch = 0;
	            head.line++;
	          }
	        }
	        if (CodeMirror.cmpPos(head, this.doc.clipPos(head)) != 0) {
	          return this.atOccurrence = false;
	        }
	      }
	      var result = this.matches(reverse, head);
	      this.afterEmptyMatch = result && CodeMirror.cmpPos(result.from, result.to) == 0;
	
	      if (result) {
	        this.pos = result;
	        this.atOccurrence = true;
	        return this.pos.match || true;
	      } else {
	        var end = Pos(reverse ? this.doc.firstLine() : this.doc.lastLine() + 1, 0);
	        this.pos = { from: end, to: end };
	        return this.atOccurrence = false;
	      }
	    },
	
	    from: function from() {
	      if (this.atOccurrence) return this.pos.from;
	    },
	    to: function to() {
	      if (this.atOccurrence) return this.pos.to;
	    },
	
	    replace: function replace(newText, origin) {
	      if (!this.atOccurrence) return;
	      var lines = CodeMirror.splitLines(newText);
	      this.doc.replaceRange(lines, this.pos.from, this.pos.to, origin);
	      this.pos.to = Pos(this.pos.from.line + lines.length - 1, lines[lines.length - 1].length + (lines.length == 1 ? this.pos.from.ch : 0));
	    }
	  };
	
	  CodeMirror.defineExtension("getSearchCursor", function (query, pos, caseFold) {
	    return new SearchCursor(this.doc, query, pos, caseFold);
	  });
	  CodeMirror.defineDocExtension("getSearchCursor", function (query, pos, caseFold) {
	    return new SearchCursor(this, query, pos, caseFold);
	  });
	
	  CodeMirror.defineExtension("selectMatches", function (query, caseFold) {
	    var ranges = [];
	    var cur = this.getSearchCursor(query, this.getCursor("from"), caseFold);
	    while (cur.findNext()) {
	      if (CodeMirror.cmpPos(cur.to(), this.getCursor("to")) > 0) break;
	      ranges.push({ anchor: cur.from(), head: cur.to() });
	    }
	    if (ranges.length) this.setSelections(ranges, 0);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var EditorDom = {
		stopPropagation: function stopPropagation(e) {
			e = e || event;
			if (e.stopPropagation) {
				e.stopPropagation();
			} else {
				e.cancelBubble = true;
			}
		},
		isTextNode: function isTextNode(node) {
			if (!node) return false;
			return node.nodeType == 3 || node.nodeName == "#text";
		},
		isSpanNode: function isSpanNode(node) {
			if (!node) return false;
			return node.nodeType == 1 && node.nodeName == "SPAN";
		},
		isNullOfTextNode: function isNullOfTextNode(node) {
			if (this.isTextNode(node)) {
				return node.nodeValue == "";
			} else {
				return false;
			}
		},
		getOffsetRootParentPosition: function getOffsetRootParentPosition(target, root) {
			var rootRect = root.getBoundingClientRect();
			var targetRect = target.getBoundingClientRect();
	
			return {
				x: targetRect.x - rootRect.x,
				y: targetRect.y - rootRect.y,
				w: targetRect.width,
				h: targetRect.height
			};
		},
		isEditorDom: function isEditorDom(target, root) {
			var parentNode = target.parentNode;
			while (parentNode && parentNode != root) {
				parentNode = parentNode.parentNode;
			}
			return parentNode == root;
		},
		createTextNode: function createTextNode(text) {
			return document.createTextNode(text);
		},
		createNodeByTag: function createNodeByTag(tag, html) {
			var node = document.createElement(tag);
			node.innerHTML = html;
			return node;
		},
		createHR: function createHR() {
			var node = document.createElement('hr');
			return node;
		},
		createBR: function createBR() {
			var node = document.createElement('br');
			return node;
		},
		focusNode: function focusNode(node) {
			var scrollTop = node.scrollTop;
			var scrollLeft = node.scrollLeft;
			node.focus && node.focus();
			node.scrollTo(scrollLeft, scrollTop);
		}
	};
	
	exports.default = EditorDom;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _SgiComponent2 = __webpack_require__(204);
	
	var _SgiComponent3 = _interopRequireDefault(_SgiComponent2);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiCtlComponent = function (_SgiComponent) {
	    _inherits(SgiCtlComponent, _SgiComponent);
	
	    function SgiCtlComponent(props) {
	        _classCallCheck(this, SgiCtlComponent);
	
	        return _possibleConstructorReturn(this, (SgiCtlComponent.__proto__ || Object.getPrototypeOf(SgiCtlComponent)).call(this, props));
	    }
	
	    _createClass(SgiCtlComponent, [{
	        key: "_maker",
	        value: function _maker() {
	            _get(SgiCtlComponent.prototype.__proto__ || Object.getPrototypeOf(SgiCtlComponent.prototype), "_maker", this).call(this);
	
	            var _props2 = this.props,
	                parentModule = _props2.parentModule,
	                moduleDesc = _props2.moduleDesc,
	                objFct = _props2.objFct,
	                type = _props2.type;
	            var _state = this.state,
	                _props = _state._props,
	                _class = _state._class,
	                _style = _state._style;
	
	            // 属性和类名合并
	
	            (0, _rtSdCommon.assignProps)(_props, _props);
	            (0, _rtSdCommon.assignArrayStr)(_class, _class);
	
	            /**************** 转换公共属性 ****************/
	
	            /**************** 控件自身属性 ****************/
	            this.__AddAttribute();
	            /**************** 绑定事件 ****************/
	            this.__bindEvent();
	        }
	
	        /**
	            * 渲染前处理，包括自定义样式等
	            * 初步设计为渲染前的通用处理，例如自定义样式等
	            */
	
	    }, {
	        key: "_renderBeforeReturn",
	        value: function _renderBeforeReturn() {
	            var _props3 = this.props,
	                parentModule = _props3.parentModule,
	                moduleDesc = _props3.moduleDesc,
	                objFct = _props3.objFct,
	                type = _props3.type;
	            var _state2 = this.state,
	                _props = _state2._props,
	                _class = _state2._class,
	                _style = _state2._style;
	            var functions = this.data.functions;
	
	            // 自定义样式处理
	            // const getCstmStyle = functions.cstmStyle;
	
	            var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(this, "cstmStyle");
	            var cstmStyle = {};
	            if (getCstmStyle) {
	                try {
	                    cstmStyle = getCstmStyle(this, objFct) || {};
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.error(error);
	                }
	            }
	            Object.assign(_style, cstmStyle);
	
	            // className
	            _props.className = _class.join(" ");
	            _props.style = _style || {};
	        }
	    }, {
	        key: "__AddAttribute",
	        value: function __AddAttribute() {}
	    }, {
	        key: "__bindEvent",
	        value: function __bindEvent() {}
	    }, {
	        key: "setHidden",
	        value: function setHidden(value) {
	            var _class = this.state._class;
	            if (value && _class.indexOf("sgi-hidden") < 0) {
	                _class.push("sgi-hidden");
	            } else if (!value && _class.indexOf("sgi-hidden") > -1) {
	                _class.splice(_class.indexOf("sgi-hidden"), 1);
	            }
	            this.setState({ _class: _class });
	        }
	    }, {
	        key: "setDisabled",
	        value: function setDisabled(value) {
	            var _props = this.state._props;
	            if (_props.disabled === value) return;
	
	            _props.disabled = value;
	            this.setState({ _props: _props });
	        }
	    }, {
	        key: "setValue",
	        value: function setValue(value) {
	            if (value === this.state._props.value) return;
	            this.state._props.value = value;
	            this.setState({});
	        }
	    }, {
	        key: "getValue",
	        value: function getValue() {
	            return this.state._props.value;
	        }
	    }]);
	
	    return SgiCtlComponent;
	}(_SgiComponent3.default);
	
	exports.default = SgiCtlComponent;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	var _UserModal = __webpack_require__(137);
	
	var _RoleModal = __webpack_require__(372);
	
	var _Condition = __webpack_require__(1334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	var RadioGroup = _antd.Radio.Group;
	
	var PubInfoFrom = function (_Component) {
	    _inherits(PubInfoFrom, _Component);
	
	    function PubInfoFrom(props) {
	        _classCallCheck(this, PubInfoFrom);
	
	        var _this = _possibleConstructorReturn(this, (PubInfoFrom.__proto__ || Object.getPrototypeOf(PubInfoFrom)).call(this, props));
	
	        _this.reload = function () {
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.selectOnChange = function (attname, value) {
	            //change传入对象为value
	            tool.sgiLogger.log("事件：selectOnChange");
	            _this.refresh(attname, value);
	        };
	
	        _this.checkboxGroupOnChange = function (attname, checkedValue) {
	            tool.sgiLogger.log("事件：checkboxGroupOnChange");
	            _this.refresh(attname, checkedValue);
	        };
	
	        _this.state = {
	            // parent: props.parent,
	            node: props.node,
	            show: props.show != null && props.show == true ? props.show : 'none',
	            nodedata: props.nodedata,
	            percondition: props.percondition == null || props.percondition == true ? true : false,
	            aftcondition: props.aftcondition == null || props.aftcondition == true ? true : false,
	
	            loading: false
	
	        };
	
	        return _this;
	    }
	
	    _createClass(PubInfoFrom, [{
	        key: 'setValues',
	        value: function setValues(values) {}
	        // 重新加载页面方法
	
	    }, {
	        key: 'conditionOnChange',
	
	        // 条件表达式修改事件
	        value: function conditionOnChange(attname, e) {
	            tool.sgiLogger.log("事件：conditionOnChange");
	            var value = e.getValue();
	
	            this.refresh(attname, value);
	            this.refresh(attname + "Exp", e.getContentStateToRowForJson());
	        }
	        // 文本修改事件
	
	    }, {
	        key: 'textOnChange',
	        value: function textOnChange(attname, e, e2) {
	            tool.sgiLogger.log("事件：textOnChange");
	            var value = e.target.value;
	            this.refresh(attname, value);
	        }
	        // 下拉窗修改事件
	
	        // 复选框组修改事件，checkedValue为数组["01","02"]
	
	    }, {
	        key: 'radioGroupOnChange',
	
	        // 单选框组修改事件
	        value: function radioGroupOnChange(attname, e) {
	            tool.sgiLogger.log("事件：radioGroupOnChange");
	            var value = e.target.value;
	            this.refresh(attname, value);
	        }
	        // 数字组件修改事件
	
	    }, {
	        key: 'numberOnChange',
	        value: function numberOnChange(attname, e) {
	            var value = e;
	            this.refresh(attname, value);
	        }
	        // 属性更新
	
	    }, {
	        key: 'refresh',
	        value: function refresh(attname, value) {
	            // || this.state.nodedata.type == "99"
	            if (this.state.nodedata.type == "01") {} else {
	                if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
	            }
	            this.state.nodedata[attname] = value;
	        }
	        // 表格添加方法
	        // handleAdd = (modalType) => {
	        //     tool.sgiLogger.log("handleAdd添加审批人/角色方法");
	        //     if (!modalType || modalType == '') {
	        //         this.state.modalContent = null;
	        //     }
	        //     if (modalType == 'user') {
	        //         this.state.modalContent = <UserModal key={uuid(8)} modalShow={true}
	        //             approvalUserList={this.state.nodedata.users} parent={this} />
	        //     } else if (modalType == 'role') {
	        //         this.state.modalContent = <RoleModal key={uuid(8)} modalShow={true}
	        //             approvalRoleList={this.state.nodedata.roles} parent={this} />
	        //     } else if (modalType == 'overTimeout') {
	        //         this.state.modalContent = <UserModal key={uuid(8)} modalShow={true}
	        //             approvalUserList={this.state.nodedata.overTimeoutUsers} parent={this} />
	        //     }
	        //     this.setState({
	        //         loading: false
	        //     });
	        // }
	        // 表格删除方法
	        // handleDelete = (delData, dataSource) => {
	        //     if (dataSource && delData) {
	        //         for (var i = 0; i < dataSource.length; i++) {
	        //             if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
	        //                 dataSource.splice(i, 1);
	        //             }
	        //         }
	        //     }
	        //     this.setState({ loading: false });
	        // }
	        // 创建表格绑定store（生成数据key）
	        // getTBData = (tData) => {
	        //     if (!tData) {
	        //         tData = [];
	        //         return tData;
	        //     }
	        //     tData.forEach(element => {
	        //         if (!element._key) element._key = uuid(8);
	        //     })
	        //     return tData;
	        // }
	        // 刷新form
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            tool.sgiLogger.log('事件：PubInfo加载后');
	            this.props.form.setFieldsValue({
	                id: this.state.nodedata.id,
	                name: this.state.nodedata.name,
	                type: this.state.nodedata.type,
	                status: this.state.nodedata.status,
	                inCondition: this.state.nodedata.inCondition,
	                outCondition: this.state.nodedata.outCondition,
	                ann: this.state.nodedata.ann,
	                isfallback: this.state.nodedata.isfallback,
	                fallback: this.state.nodedata.fallback
	                // ishuman: this.state.nodedata.ishuman,
	                // interventionUsers: this.state.nodedata.interventionUsers
	            });
	            if (this.state.percondition) this.refs.inCondition.refreshByContentStateToRowJson(this.state.nodedata.inConditionExp);
	            if (this.state.aftcondition) this.refs.outCondition.refreshByContentStateToRowJson(this.state.nodedata.outConditionExp);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var getFieldDecorator = this.props.form.getFieldDecorator;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _antd.Row,
	                    { gutter: 16 },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: '\u8282\u70B9\u5E8F\u53F7' },
	                            getFieldDecorator('id', {
	                                rules: [{ required: false, message: '' }]
	                            })(_react2.default.createElement(_antd.Input, { placeholder: '', readOnly: true,
	                                onChange: this.textOnChange.bind(this, 'id')
	                            }))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: '\u8282\u70B9\u540D\u79F0' },
	                            getFieldDecorator('name', {
	                                rules: [{ required: true, message: '请输入节点名称' }]
	                            })(_react2.default.createElement(_antd.Input, {
	                                style: { width: '100%' },
	                                placeholder: '\u8BF7\u8F93\u5165\u8282\u70B9\u540D\u79F0',
	                                onChange: this.textOnChange.bind(this, 'name')
	                            }))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _antd.Row,
	                    { gutter: 16 },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: '\u8282\u70B9\u7C7B\u578B' },
	                            getFieldDecorator('type', {
	                                rules: [{ required: true, message: 'Please select an owner' }]
	                            })(_react2.default.createElement(
	                                _antd.Select,
	                                { placeholder: '\u8BF7\u9009\u62E9\u8282\u70B9\u7C7B\u578B', disabled: true,
	                                    onChange: this.selectOnChange.bind(this, 'type')
	                                },
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '01' },
	                                    '\u5F00\u59CB\u8282\u70B9'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '02' },
	                                    '\u8DF3\u8F6C\u8282\u70B9'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '03' },
	                                    '\u670D\u52A1\u8282\u70B9'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '04' },
	                                    '\u811A\u672C\u8282\u70B9'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '05' },
	                                    '\u6D41\u7A0B\u8282\u70B9'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '06' },
	                                    '\u4EFB\u52A1\u8282\u70B9'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '99' },
	                                    '\u7ED3\u675F\u8282\u70B9'
	                                )
	                            ))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: '\u8282\u70B9\u72B6\u6001' },
	                            getFieldDecorator('status', {
	                                readOnly: true,
	                                rules: [{ required: true, message: '请输入节点状态' }]
	                            })(_react2.default.createElement(
	                                _antd.Select,
	                                { placeholder: '\u8BF7\u9009\u62E9\u8282\u70B9\u72B6\u6001', disabled: true,
	                                    onChange: this.selectOnChange.bind(this, 'status')
	                                },
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '00' },
	                                    '\u672A\u6267\u884C'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '01' },
	                                    '\u6267\u884C\u4E2D'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '02' },
	                                    '\u5DF2\u5B8C\u6210'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '03' },
	                                    '\u5DF2\u6302\u8D77'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '04' },
	                                    '\u5DF2\u9A73\u56DE'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '05' },
	                                    '\u5DF2\u64A4\u9500'
	                                ),
	                                _react2.default.createElement(
	                                    Option,
	                                    { value: '99' },
	                                    '\u5F02\u5E38'
	                                )
	                            ))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _antd.Row,
	                    { gutter: 16 },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: '\u5141\u8BB8\u56DE\u9000' },
	                            getFieldDecorator('isfallback', {
	                                rules: [{ required: false, message: '' }]
	                            })(_react2.default.createElement(
	                                RadioGroup,
	                                { onChange: this.radioGroupOnChange.bind(this, 'isfallback') },
	                                _react2.default.createElement(
	                                    _antd.Radio,
	                                    { value: "0" },
	                                    '\u4E0D\u5141\u8BB8'
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Radio,
	                                    { value: "1" },
	                                    '\u5141\u8BB8'
	                                )
	                            ))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: '\u56DE\u9000\u5904\u7406' },
	                            getFieldDecorator('fallback', {
	                                rules: [{ required: false, message: '请输入回退处理' }]
	                            })(_react2.default.createElement(_antd.Input, { placeholder: '\u56DE\u9000\u5904\u7406',
	                                onChange: this.textOnChange.bind(this, 'fallback')
	                            }))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _antd.Row,
	                    { gutter: 16 },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 24 },
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: '\u8BF4\u660E' },
	                            getFieldDecorator('ann', {
	                                rules: [{ required: false, message: '请输入说明信息' }]
	                            })(_react2.default.createElement(_antd.Input.TextArea, { rows: 4, placeholder: '\u8BF7\u8F93\u5165\u8BF4\u660E\u4FE1\u606F',
	                                onChange: this.textOnChange.bind(this, 'ann')
	                            }))
	                        )
	                    )
	                ),
	                this.state.percondition ? _react2.default.createElement(
	                    _antd.Row,
	                    { gutter: 16 },
	                    _react2.default.createElement(
	                        _antd.Card,
	                        { title: '\u524D\u7F6E\u5904\u7406' },
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: 24 },
	                            _react2.default.createElement(_antd.Form.Item, { label: '\u51C6\u5165\u6761\u4EF6' }),
	                            _react2.default.createElement(_Condition.Condition, { title: '\u51C6\u5165\u6761\u4EF6', ref: 'inCondition', onChange: this.conditionOnChange.bind(this, 'inCondition'), contentStateToRowJson: this.state.inCondition })
	                        )
	                    )
	                ) : null,
	                this.state.aftcondition ? _react2.default.createElement(
	                    _antd.Row,
	                    { gutter: 16 },
	                    _react2.default.createElement(
	                        _antd.Card,
	                        { title: '\u540E\u7F6E\u5904\u7406' },
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: 24 },
	                            _react2.default.createElement(_antd.Form.Item, { label: '\u51C6\u51FA\u6761\u4EF6' }),
	                            _react2.default.createElement(_Condition.Condition, { title: '\u51C6\u51FA\u6761\u4EF6', ref: 'outCondition', onChange: this.conditionOnChange.bind(this, 'outCondition'), contentStateToRowJson: this.state.outCondition })
	                        )
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return PubInfoFrom;
	}(_react.Component);
	
	var PubInfo = _antd.Form.create()(PubInfoFrom);
	exports.default = PubInfo;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(741));
	
	var _Group = _interopRequireDefault(__webpack_require__(1377));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Checkbox["default"].Group = _Group["default"];
	var _default = _Checkbox["default"];
	exports["default"] = _default;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(190));
	
	var _en_US2 = _interopRequireDefault(__webpack_require__(377));
	
	var _en_US3 = _interopRequireDefault(__webpack_require__(387));
	
	var _en_US4 = _interopRequireDefault(__webpack_require__(740));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = {
	  locale: 'en',
	  Pagination: _en_US["default"],
	  DatePicker: _en_US2["default"],
	  TimePicker: _en_US3["default"],
	  Calendar: _en_US4["default"],
	  global: {
	    placeholder: 'Please select'
	  },
	  Table: {
	    filterTitle: 'Filter menu',
	    filterConfirm: 'OK',
	    filterReset: 'Reset',
	    selectAll: 'Select current page',
	    selectInvert: 'Invert current page',
	    sortTitle: 'Sort',
	    expand: 'Expand row',
	    collapse: 'Collapse row'
	  },
	  Modal: {
	    okText: 'OK',
	    cancelText: 'Cancel',
	    justOkText: 'OK'
	  },
	  Popconfirm: {
	    okText: 'OK',
	    cancelText: 'Cancel'
	  },
	  Transfer: {
	    titles: ['', ''],
	    searchPlaceholder: 'Search here',
	    itemUnit: 'item',
	    itemsUnit: 'items'
	  },
	  Upload: {
	    uploading: 'Uploading...',
	    removeFile: 'Remove file',
	    uploadError: 'Upload error',
	    previewFile: 'Preview file',
	    downloadFile: 'Download file'
	  },
	  Empty: {
	    description: 'No Data'
	  },
	  Icon: {
	    icon: 'icon'
	  },
	  Text: {
	    edit: 'Edit',
	    copy: 'Copy',
	    copied: 'Copied',
	    expand: 'Expand'
	  },
	  PageHeader: {
	    back: 'Back'
	  }
	};
	exports["default"] = _default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(394);
	var setInnerHTML = __webpack_require__(264);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(402);
	var setTextContent = __webpack_require__(787);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function injectDOMPropertyConfig(domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function isCustomAttribute(attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1530);
	var ReactInstrumentation = __webpack_require__(94);
	
	var warning = __webpack_require__(44);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function mountComponent(internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function getHostNode(internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function unmountComponent(internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function receiveComponent(internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function performUpdateIfNecessary(internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var ReactBaseClasses = __webpack_require__(789);
	var ReactChildren = __webpack_require__(1559);
	var ReactDOMFactories = __webpack_require__(1560);
	var ReactElement = __webpack_require__(169);
	var ReactPropTypes = __webpack_require__(1561);
	var ReactVersion = __webpack_require__(1562);
	
	var createReactClass = __webpack_require__(1563);
	var onlyChild = __webpack_require__(1567);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _assign = __webpack_require__(53);
	
	var ReactCurrentOwner = __webpack_require__(112);
	
	var warning = __webpack_require__(44);
	var canDefineProperty = __webpack_require__(793);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(791);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function warnAboutAccessingKey() {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function warnAboutAccessingRef() {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createDimensions = __webpack_require__(176);
	
	var List = __webpack_require__(88);
	
	var _util = __webpack_require__(2);
	
	var extend = _util.extend;
	var isArray = _util.isArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Usage]:
	 * (1)
	 * createListSimply(seriesModel, ['value']);
	 * (2)
	 * createListSimply(seriesModel, {
	 *     coordDimensions: ['value'],
	 *     dimensionsCount: 5
	 * });
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object|Array.<string|Object>} opt opt or coordDimensions
	 *        The options in opt, see `echarts/data/helper/createDimensions`
	 * @param {Array.<string>} [nameList]
	 * @return {module:echarts/data/List}
	 */
	function _default(seriesModel, opt, nameList) {
	  opt = isArray(opt) && {
	    coordDimensions: opt
	  } || extend({}, opt);
	  var source = seriesModel.getSource();
	  var dimensionsInfo = createDimensions(source, opt);
	  var list = new List(dimensionsInfo, seriesModel);
	  list.initData(source, nameList);
	  return list;
	}
	
	module.exports = _default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @return {string} If large mode changed, return string 'reset';
	 */
	function _default() {
	  var inner = makeInner();
	  return function (seriesModel) {
	    var fields = inner(seriesModel);
	    var pipelineContext = seriesModel.pipelineContext;
	    var originalLarge = fields.large;
	    var originalProgressive = fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
	    // exists. See #11611 . Probably we need to modify this structure, see the comment
	    // on `performRawSeries` in `Schedular.js`.
	
	    var large = fields.large = pipelineContext && pipelineContext.large;
	    var progressive = fields.progressiveRender = pipelineContext && pipelineContext.progressiveRender;
	    return !!(originalLarge ^ large || originalProgressive ^ progressive) && 'reset';
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	var modelUtil = __webpack_require__(27);
	
	var helper = __webpack_require__(418);
	
	var AxisProxy = __webpack_require__(1750);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var eachAxisDim = helper.eachAxisDim;
	var DataZoomModel = echarts.extendComponentModel({
	  type: 'dataZoom',
	  dependencies: ['xAxis', 'yAxis', 'zAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 4,
	    // Higher than normal component (z: 2).
	    orient: null,
	    // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
	    xAxisIndex: null,
	    // Default the first horizontal category axis.
	    yAxisIndex: null,
	    // Default the first vertical category axis.
	    filterMode: 'filter',
	    // Possible values: 'filter' or 'empty' or 'weakFilter'.
	    // 'filter': data items which are out of window will be removed. This option is
	    //          applicable when filtering outliers. For each data item, it will be
	    //          filtered if one of the relevant dimensions is out of the window.
	    // 'weakFilter': data items which are out of window will be removed. This option
	    //          is applicable when filtering outliers. For each data item, it will be
	    //          filtered only if all  of the relevant dimensions are out of the same
	    //          side of the window.
	    // 'empty': data items which are out of window will be set to empty.
	    //          This option is applicable when user should not neglect
	    //          that there are some data items out of window.
	    // 'none': Do not filter.
	    // Taking line chart as an example, line will be broken in
	    // the filtered points when filterModel is set to 'empty', but
	    // be connected when set to 'filter'.
	    throttle: null,
	    // Dispatch action by the fixed rate, avoid frequency.
	    // default 100. Do not throttle when use null/undefined.
	    // If animation === true and animationDurationUpdate > 0,
	    // default value is 100, otherwise 20.
	    start: 0,
	    // Start percent. 0 ~ 100
	    end: 100,
	    // End percent. 0 ~ 100
	    startValue: null,
	    // Start value. If startValue specified, start is ignored.
	    endValue: null,
	    // End value. If endValue specified, end is ignored.
	    minSpan: null,
	    // 0 ~ 100
	    maxSpan: null,
	    // 0 ~ 100
	    minValueSpan: null,
	    // The range of dataZoom can not be smaller than that.
	    maxValueSpan: null,
	    // The range of dataZoom can not be larger than that.
	    rangeMode: null // Array, can be 'value' or 'percent'.
	
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * key like x_0, y_1
	     * @private
	     * @type {Object}
	     */
	    this._dataIntervalByAxis = {};
	    /**
	     * @private
	     */
	
	    this._dataInfo = {};
	    /**
	     * key like x_0, y_1
	     * @private
	     */
	
	    this._axisProxies = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * @private
	     */
	
	    this._autoThrottle = true;
	    /**
	     * It is `[rangeModeForMin, rangeModeForMax]`.
	     * The optional values for `rangeMode`:
	     * + `'value'` mode: the axis extent will always be determined by
	     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
	     *     how data like and how `axis.min` and `axis.max` are.
	     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
	     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
	     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
	     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
	     *
	     * For example, when users are using dynamic data (update data periodically via `setOption`),
	     * if in `'value`' mode, the window will be kept in a fixed value range despite how
	     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
	     * the appended data (suppose `axis.min` and `axis.max` are not specified).
	     *
	     * @private
	     */
	
	    this._rangePropMode = ['percent', 'percent'];
	    var inputRawOption = retrieveRawOption(option);
	    /**
	     * Suppose a "main process" start at the point that model prepared (that is,
	     * model initialized or merged or method called in `action`).
	     * We should keep the `main process` idempotent, that is, given a set of values
	     * on `option`, we get the same result.
	     *
	     * But sometimes, values on `option` will be updated for providing users
	     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
	     * should not be the base/input of the `main process`.
	     *
	     * So in that case we should save and keep the input of the `main process`
	     * separately, called `settledOption`.
	     *
	     * For example, consider the case:
	     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
	     *     where the original input `option.startValue`, `option.endValue` are earsed by
	     *     calculated value.
	     * (Step)2) click the legend to hide and show a series,
	     *     where the new range is calculated by the earsed `startValue` and `endValue`,
	     *     which brings incorrect result.
	     *
	     * @readOnly
	     */
	
	    this.settledOption = inputRawOption;
	    this.mergeDefaultAndTheme(option, ecModel);
	    this.doInit(inputRawOption);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var inputRawOption = retrieveRawOption(newOption); //FIX #2591
	
	    zrUtil.merge(this.option, newOption, true);
	    zrUtil.merge(this.settledOption, inputRawOption, true);
	    this.doInit(inputRawOption);
	  },
	
	  /**
	   * @protected
	   */
	  doInit: function (inputRawOption) {
	    var thisOption = this.option; // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    this._setDefaultThrottle(inputRawOption);
	
	    updateRangeUse(this, inputRawOption);
	    var settledOption = this.settledOption;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	      // start/end has higher priority over startValue/endValue if they
	      // both set, but we should make chart.setOption({endValue: 1000})
	      // effective, rather than chart.setOption({endValue: 1000, end: null}).
	      if (this._rangePropMode[index] === 'value') {
	        thisOption[names[0]] = settledOption[names[0]] = null;
	      } // Otherwise do nothing and use the merge result.
	
	    }, this);
	    this.textStyleModel = this.getModel('textStyle');
	
	    this._resetTarget();
	
	    this._giveAxisProxies();
	  },
	
	  /**
	   * @private
	   */
	  _giveAxisProxies: function () {
	    var axisProxies = this._axisProxies;
	    this.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel, ecModel) {
	      var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.
	
	      var axisProxy = axisModel.__dzAxisProxy || ( // Use the first dataZoomModel as the main model of axisProxy.
	      axisModel.__dzAxisProxy = new AxisProxy(dimNames.name, axisIndex, this, ecModel)); // FIXME
	      // dispose __dzAxisProxy
	
	      axisProxies[dimNames.name + '_' + axisIndex] = axisProxy;
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetTarget: function () {
	    var thisOption = this.option;
	
	    var autoMode = this._judgeAutoMode();
	
	    eachAxisDim(function (dimNames) {
	      var axisIndexName = dimNames.axisIndex;
	      thisOption[axisIndexName] = modelUtil.normalizeToArray(thisOption[axisIndexName]);
	    }, this);
	
	    if (autoMode === 'axisIndex') {
	      this._autoSetAxisIndex();
	    } else if (autoMode === 'orient') {
	      this._autoSetOrient();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _judgeAutoMode: function () {
	    // Auto set only works for setOption at the first time.
	    // The following is user's reponsibility. So using merged
	    // option is OK.
	    var thisOption = this.option;
	    var hasIndexSpecified = false;
	    eachAxisDim(function (dimNames) {
	      // When user set axisIndex as a empty array, we think that user specify axisIndex
	      // but do not want use auto mode. Because empty array may be encountered when
	      // some error occured.
	      if (thisOption[dimNames.axisIndex] != null) {
	        hasIndexSpecified = true;
	      }
	    }, this);
	    var orient = thisOption.orient;
	
	    if (orient == null && hasIndexSpecified) {
	      return 'orient';
	    } else if (!hasIndexSpecified) {
	      if (orient == null) {
	        thisOption.orient = 'horizontal';
	      }
	
	      return 'axisIndex';
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetAxisIndex: function () {
	    var autoAxisIndex = true;
	    var orient = this.get('orient', true);
	    var thisOption = this.option;
	    var dependentModels = this.dependentModels;
	
	    if (autoAxisIndex) {
	      // Find axis that parallel to dataZoom as default.
	      var dimName = orient === 'vertical' ? 'y' : 'x';
	
	      if (dependentModels[dimName + 'Axis'].length) {
	        thisOption[dimName + 'AxisIndex'] = [0];
	        autoAxisIndex = false;
	      } else {
	        each(dependentModels.singleAxis, function (singleAxisModel) {
	          if (autoAxisIndex && singleAxisModel.get('orient', true) === orient) {
	            thisOption.singleAxisIndex = [singleAxisModel.componentIndex];
	            autoAxisIndex = false;
	          }
	        });
	      }
	    }
	
	    if (autoAxisIndex) {
	      // Find the first category axis as default. (consider polar)
	      eachAxisDim(function (dimNames) {
	        if (!autoAxisIndex) {
	          return;
	        }
	
	        var axisIndices = [];
	        var axisModels = this.dependentModels[dimNames.axis];
	
	        if (axisModels.length && !axisIndices.length) {
	          for (var i = 0, len = axisModels.length; i < len; i++) {
	            if (axisModels[i].get('type') === 'category') {
	              axisIndices.push(i);
	            }
	          }
	        }
	
	        thisOption[dimNames.axisIndex] = axisIndices;
	
	        if (axisIndices.length) {
	          autoAxisIndex = false;
	        }
	      }, this);
	    }
	
	    if (autoAxisIndex) {
	      // FIXME
	      // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
	      // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
	      // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
	      // dataZoom component auto adopts series that reference to
	      // both xAxis and yAxis which type is 'value'.
	      this.ecModel.eachSeries(function (seriesModel) {
	        if (this._isSeriesHasAllAxesTypeOf(seriesModel, 'value')) {
	          eachAxisDim(function (dimNames) {
	            var axisIndices = thisOption[dimNames.axisIndex];
	            var axisIndex = seriesModel.get(dimNames.axisIndex);
	            var axisId = seriesModel.get(dimNames.axisId);
	            var axisModel = seriesModel.ecModel.queryComponents({
	              mainType: dimNames.axis,
	              index: axisIndex,
	              id: axisId
	            })[0];
	            axisIndex = axisModel.componentIndex;
	
	            if (zrUtil.indexOf(axisIndices, axisIndex) < 0) {
	              axisIndices.push(axisIndex);
	            }
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetOrient: function () {
	    var dim; // Find the first axis
	
	    this.eachTargetAxis(function (dimNames) {
	      !dim && (dim = dimNames.name);
	    }, this);
	    this.option.orient = dim === 'y' ? 'vertical' : 'horizontal';
	  },
	
	  /**
	   * @private
	   */
	  _isSeriesHasAllAxesTypeOf: function (seriesModel, axisType) {
	    // FIXME
	    // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
	    // 例如series.type === scatter时。
	    var is = true;
	    eachAxisDim(function (dimNames) {
	      var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
	      var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];
	
	      if (!axisModel || axisModel.get('type') !== axisType) {
	        is = false;
	      }
	    }, this);
	    return is;
	  },
	
	  /**
	   * @private
	   */
	  _setDefaultThrottle: function (inputRawOption) {
	    // When first time user set throttle, auto throttle ends.
	    if (inputRawOption.hasOwnProperty('throttle')) {
	      this._autoThrottle = false;
	    }
	
	    if (this._autoThrottle) {
	      var globalOption = this.ecModel.option;
	      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
	    }
	  },
	
	  /**
	   * @public
	   */
	  getFirstTargetAxisModel: function () {
	    var firstAxisModel;
	    eachAxisDim(function (dimNames) {
	      if (firstAxisModel == null) {
	        var indices = this.get(dimNames.axisIndex);
	
	        if (indices.length) {
	          firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
	        }
	      }
	    }, this);
	    return firstAxisModel;
	  },
	
	  /**
	   * @public
	   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
	   */
	  eachTargetAxis: function (callback, context) {
	    var ecModel = this.ecModel;
	    eachAxisDim(function (dimNames) {
	      each(this.get(dimNames.axisIndex), function (axisIndex) {
	        callback.call(context, dimNames, axisIndex, this, ecModel);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
	   */
	  getAxisProxy: function (dimName, axisIndex) {
	    return this._axisProxies[dimName + '_' + axisIndex];
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/model/Model} If not found, return null/undefined.
	   */
	  getAxisModel: function (dimName, axisIndex) {
	    var axisProxy = this.getAxisProxy(dimName, axisIndex);
	    return axisProxy && axisProxy.getAxisModel();
	  },
	
	  /**
	   * If not specified, set to undefined.
	   *
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  setRawRange: function (opt) {
	    var thisOption = this.option;
	    var settledOption = this.settledOption;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
	      // Consider the pair <start, startValue>:
	      // If one has value and the other one is `null/undefined`, we both set them
	      // to `settledOption`. This strategy enables the feature to clear the original
	      // value in `settledOption` to `null/undefined`.
	      // But if both of them are `null/undefined`, we do not set them to `settledOption`
	      // and keep `settledOption` with the original value. This strategy enables users to
	      // only set <end or endValue> but not set <start or startValue> when calling
	      // `dispatchAction`.
	      // The pair <end, endValue> is treated in the same way.
	      if (opt[names[0]] != null || opt[names[1]] != null) {
	        thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
	        thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
	      }
	    }, this);
	    updateRangeUse(this, opt);
	  },
	
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  setCalculatedRange: function (opt) {
	    var option = this.option;
	    each(['start', 'startValue', 'end', 'endValue'], function (name) {
	      option[name] = opt[name];
	    });
	  },
	
	  /**
	   * @public
	   * @return {Array.<number>} [startPercent, endPercent]
	   */
	  getPercentRange: function () {
	    var axisProxy = this.findRepresentativeAxisProxy();
	
	    if (axisProxy) {
	      return axisProxy.getDataPercentWindow();
	    }
	  },
	
	  /**
	   * @public
	   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
	   *
	   * @param {string} [axisDimName]
	   * @param {number} [axisIndex]
	   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
	   */
	  getValueRange: function (axisDimName, axisIndex) {
	    if (axisDimName == null && axisIndex == null) {
	      var axisProxy = this.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        return axisProxy.getDataValueWindow();
	      }
	    } else {
	      return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
	    }
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
	   *      corresponding to the axisModel
	   * @return {module:echarts/component/dataZoom/AxisProxy}
	   */
	  findRepresentativeAxisProxy: function (axisModel) {
	    if (axisModel) {
	      return axisModel.__dzAxisProxy;
	    } // Find the first hosted axisProxy
	
	
	    var axisProxies = this._axisProxies;
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    } // If no hosted axis find not hosted axisProxy.
	    // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
	    // and the option.start or option.end settings are different. The percentRange
	    // should follow axisProxy.
	    // (We encounter this problem in toolbox data zoom.)
	
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    }
	  },
	
	  /**
	   * @return {Array.<string>}
	   */
	  getRangePropMode: function () {
	    return this._rangePropMode.slice();
	  }
	});
	/**
	 * Retrieve the those raw params from option, which will be cached separately.
	 * becasue they will be overwritten by normalized/calculated values in the main
	 * process.
	 */
	
	function retrieveRawOption(option) {
	  var ret = {};
	  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
	    option.hasOwnProperty(name) && (ret[name] = option[name]);
	  });
	  return ret;
	}
	
	function updateRangeUse(dataZoomModel, inputRawOption) {
	  var rangePropMode = dataZoomModel._rangePropMode;
	  var rangeModeInOption = dataZoomModel.get('rangeMode');
	  each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	    var percentSpecified = inputRawOption[names[0]] != null;
	    var valueSpecified = inputRawOption[names[1]] != null;
	
	    if (percentSpecified && !valueSpecified) {
	      rangePropMode[index] = 'percent';
	    } else if (!percentSpecified && valueSpecified) {
	      rangePropMode[index] = 'value';
	    } else if (rangeModeInOption) {
	      rangePropMode[index] = rangeModeInOption[index];
	    } else if (percentSpecified) {
	      // percentSpecified && valueSpecified
	      rangePropMode[index] = 'percent';
	    } // else remain its original setting.
	
	  });
	}
	
	var _default = DataZoomModel;
	module.exports = _default;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(275);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'dataZoom',
	  render: function (dataZoomModel, ecModel, api, payload) {
	    this.dataZoomModel = dataZoomModel;
	    this.ecModel = ecModel;
	    this.api = api;
	  },
	
	  /**
	   * Find the first target coordinate system.
	   *
	   * @protected
	   * @return {Object} {
	   *                   grid: [
	   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
	   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
	   *                       ...
	   *                   ],  // cartesians must not be null/undefined.
	   *                   polar: [
	   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
	   *                       ...
	   *                   ],  // polars must not be null/undefined.
	   *                   singleAxis: [
	   *                       {model: coord0, axisModels: [], coordIndex: 0}
	   *                   ]
	   */
	  getTargetCoordInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var ecModel = this.ecModel;
	    var coordSysLists = {};
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);
	
	      if (axisModel) {
	        var coordModel = axisModel.getCoordSysModel();
	        coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
	      }
	    }, this);
	
	    function save(coordModel, axisModel, store, coordIndex) {
	      var item;
	
	      for (var i = 0; i < store.length; i++) {
	        if (store[i].model === coordModel) {
	          item = store[i];
	          break;
	        }
	      }
	
	      if (!item) {
	        store.push(item = {
	          model: coordModel,
	          axisModels: [],
	          coordIndex: coordIndex
	        });
	      }
	
	      item.axisModels.push(axisModel);
	    }
	
	    return coordSysLists;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Calculate slider move result.
	 * Usage:
	 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
	 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
	 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
	 *
	 * @param {number} delta Move length.
	 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
	 *              handleEnds will be modified in this method.
	 * @param {Array.<number>} extent handleEnds is restricted by extent.
	 *              extent[0] should less or equals than extent[1].
	 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds.
	 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
	 *              If not set, handle0 and cross handle1. If set as a non-negative
	 *              number (including `0`), handles will push each other when reaching
	 *              the minSpan.
	 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
	 * @return {Array.<number>} The input handleEnds.
	 */
	function _default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
	  delta = delta || 0;
	  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.
	
	  if (minSpan != null) {
	    minSpan = restrict(minSpan, [0, extentSpan]);
	  }
	
	  if (maxSpan != null) {
	    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
	  }
	
	  if (handleIndex === 'all') {
	    var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
	    handleSpan = restrict(handleSpan, [0, extentSpan]);
	    minSpan = maxSpan = restrict(handleSpan, [minSpan, maxSpan]);
	    handleIndex = 0;
	  }
	
	  handleEnds[0] = restrict(handleEnds[0], extent);
	  handleEnds[1] = restrict(handleEnds[1], extent);
	  var originalDistSign = getSpanSign(handleEnds, handleIndex);
	  handleEnds[handleIndex] += delta; // Restrict in extent.
	
	  var extentMinSpan = minSpan || 0;
	  var realExtent = extent.slice();
	  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
	  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
	    // If minSpan exists, 'cross' is forbidden.
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
	  } // Shrink span.
	
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (maxSpan != null && currDistSign.span > maxSpan) {
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
	  }
	
	  return handleEnds;
	}
	
	function getSpanSign(handleEnds, handleIndex) {
	  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
	  // is at left of handleEnds[1] for non-cross case.
	
	  return {
	    span: Math.abs(dist),
	    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
	  };
	}
	
	function restrict(value, extend) {
	  return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
	}
	
	module.exports = _default;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as axisHelper from './axisHelper';
	var _default = {
	  /**
	   * @param {boolean} origin
	   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
	   */
	  getMin: function (origin) {
	    var option = this.option;
	    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;
	
	    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
	      min = this.axis.scale.parse(min);
	    }
	
	    return min;
	  },
	
	  /**
	   * @param {boolean} origin
	   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
	   */
	  getMax: function (origin) {
	    var option = this.option;
	    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;
	
	    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
	      max = this.axis.scale.parse(max);
	    }
	
	    return max;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  getNeedCrossZero: function () {
	    var option = this.option;
	    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
	  },
	
	  /**
	   * Should be implemented by each axis model if necessary.
	   * @return {module:echarts/model/Component} coordinate system model
	   */
	  getCoordSysModel: zrUtil.noop,
	
	  /**
	   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
	   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
	   */
	  setRange: function (rangeStart, rangeEnd) {
	    this.option.rangeStart = rangeStart;
	    this.option.rangeEnd = rangeEnd;
	  },
	
	  /**
	   * Reset range
	   */
	  resetRange: function () {
	    // rangeStart and rangeEnd is readonly.
	    this.option.rangeStart = this.option.rangeEnd = null;
	  }
	};
	module.exports = _default;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var completeDimensions = __webpack_require__(850);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Substitute `completeDimensions`.
	 * `completeDimensions` is to be deprecated.
	 */
	
	/**
	 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
	 * @param {Object|Array} [opt]
	 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
	 * @param {number} [opt.dimensionsCount]
	 * @param {string} [opt.generateCoord]
	 * @param {string} [opt.generateCoordCount]
	 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
	 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
	 * @param {Function} [opt.encodeDefaulter] Make default encode if user not specified.
	 * @return {Array.<Object>} dimensionsInfo
	 */
	function _default(source, opt) {
	  opt = opt || {};
	  return completeDimensions(opt.coordDimensions || [], source, {
	    dimsDef: opt.dimensionsDefine || source.dimensionsDefine,
	    encodeDef: opt.encodeDefine || source.encodeDefine,
	    dimCount: opt.dimensionsCount,
	    encodeDefaulter: opt.encodeDefaulter,
	    generateCoord: opt.generateCoord,
	    generateCoordCount: opt.generateCoordCount
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Parse shadow style
	// TODO Only shallow path support
	function _default(properties) {
	  // Normalize
	  for (var i = 0; i < properties.length; i++) {
	    if (!properties[i][1]) {
	      properties[i][1] = properties[i][0];
	    }
	  }
	
	  return function (model, excludes, includes) {
	    var style = {};
	
	    for (var i = 0; i < properties.length; i++) {
	      var propName = properties[i][1];
	
	      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
	        continue;
	      }
	
	      var val = model.getShallow(propName);
	
	      if (val != null) {
	        style[properties[i][0]] = val;
	      }
	    }
	
	    return style;
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(795).Buffer))

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAB4CAYAAABhLdg6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAKTWlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVN3WJP3Fj7f92UPVkLY8LGXbIEAIiOsCMgQWaIQkgBhhBASQMWFiApWFBURnEhVxILVCkidiOKgKLhnQYqIWotVXDjuH9yntX167+3t+9f7vOec5/zOec8PgBESJpHmomoAOVKFPDrYH49PSMTJvYACFUjgBCAQ5svCZwXFAADwA3l4fnSwP/wBr28AAgBw1S4kEsfh/4O6UCZXACCRAOAiEucLAZBSAMguVMgUAMgYALBTs2QKAJQAAGx5fEIiAKoNAOz0ST4FANipk9wXANiiHKkIAI0BAJkoRyQCQLsAYFWBUiwCwMIAoKxAIi4EwK4BgFm2MkcCgL0FAHaOWJAPQGAAgJlCLMwAIDgCAEMeE80DIEwDoDDSv+CpX3CFuEgBAMDLlc2XS9IzFLiV0Bp38vDg4iHiwmyxQmEXKRBmCeQinJebIxNI5wNMzgwAABr50cH+OD+Q5+bk4eZm52zv9MWi/mvwbyI+IfHf/ryMAgQAEE7P79pf5eXWA3DHAbB1v2upWwDaVgBo3/ldM9sJoFoK0Hr5i3k4/EAenqFQyDwdHAoLC+0lYqG9MOOLPv8z4W/gi372/EAe/tt68ABxmkCZrcCjg/1xYW52rlKO58sEQjFu9+cj/seFf/2OKdHiNLFcLBWK8ViJuFAiTcd5uVKRRCHJleIS6X8y8R+W/QmTdw0ArIZPwE62B7XLbMB+7gECiw5Y0nYAQH7zLYwaC5EAEGc0Mnn3AACTv/mPQCsBAM2XpOMAALzoGFyolBdMxggAAESggSqwQQcMwRSswA6cwR28wBcCYQZEQAwkwDwQQgbkgBwKoRiWQRlUwDrYBLWwAxqgEZrhELTBMTgN5+ASXIHrcBcGYBiewhi8hgkEQcgIE2EhOogRYo7YIs4IF5mOBCJhSDSSgKQg6YgUUSLFyHKkAqlCapFdSCPyLXIUOY1cQPqQ28ggMor8irxHMZSBslED1AJ1QLmoHxqKxqBz0XQ0D12AlqJr0Rq0Hj2AtqKn0UvodXQAfYqOY4DRMQ5mjNlhXIyHRWCJWBomxxZj5Vg1Vo81Yx1YN3YVG8CeYe8IJAKLgBPsCF6EEMJsgpCQR1hMWEOoJewjtBK6CFcJg4Qxwicik6hPtCV6EvnEeGI6sZBYRqwm7iEeIZ4lXicOE1+TSCQOyZLkTgohJZAySQtJa0jbSC2kU6Q+0hBpnEwm65Btyd7kCLKArCCXkbeQD5BPkvvJw+S3FDrFiOJMCaIkUqSUEko1ZT/lBKWfMkKZoKpRzame1AiqiDqfWkltoHZQL1OHqRM0dZolzZsWQ8ukLaPV0JppZ2n3aC/pdLoJ3YMeRZfQl9Jr6Afp5+mD9HcMDYYNg8dIYigZaxl7GacYtxkvmUymBdOXmchUMNcyG5lnmA+Yb1VYKvYqfBWRyhKVOpVWlX6V56pUVXNVP9V5qgtUq1UPq15WfaZGVbNQ46kJ1Bar1akdVbupNq7OUndSj1DPUV+jvl/9gvpjDbKGhUaghkijVGO3xhmNIRbGMmXxWELWclYD6yxrmE1iW7L57Ex2Bfsbdi97TFNDc6pmrGaRZp3mcc0BDsax4PA52ZxKziHODc57LQMtPy2x1mqtZq1+rTfaetq+2mLtcu0W7eva73VwnUCdLJ31Om0693UJuja6UbqFutt1z+o+02PreekJ9cr1Dund0Uf1bfSj9Rfq79bv0R83MDQINpAZbDE4Y/DMkGPoa5hpuNHwhOGoEctoupHEaKPRSaMnuCbuh2fjNXgXPmasbxxirDTeZdxrPGFiaTLbpMSkxeS+Kc2Ua5pmutG003TMzMgs3KzYrMnsjjnVnGueYb7ZvNv8jYWlRZzFSos2i8eW2pZ8ywWWTZb3rJhWPlZ5VvVW16xJ1lzrLOtt1ldsUBtXmwybOpvLtqitm63Edptt3xTiFI8p0in1U27aMez87ArsmuwG7Tn2YfYl9m32zx3MHBId1jt0O3xydHXMdmxwvOuk4TTDqcSpw+lXZxtnoXOd8zUXpkuQyxKXdpcXU22niqdun3rLleUa7rrStdP1o5u7m9yt2W3U3cw9xX2r+00umxvJXcM970H08PdY4nHM452nm6fC85DnL152Xlle+70eT7OcJp7WMG3I28Rb4L3Le2A6Pj1l+s7pAz7GPgKfep+Hvqa+It89viN+1n6Zfgf8nvs7+sv9j/i/4XnyFvFOBWABwQHlAb2BGoGzA2sDHwSZBKUHNQWNBbsGLww+FUIMCQ1ZH3KTb8AX8hv5YzPcZyya0RXKCJ0VWhv6MMwmTB7WEY6GzwjfEH5vpvlM6cy2CIjgR2yIuB9pGZkX+X0UKSoyqi7qUbRTdHF09yzWrORZ+2e9jvGPqYy5O9tqtnJ2Z6xqbFJsY+ybuIC4qriBeIf4RfGXEnQTJAntieTE2MQ9ieNzAudsmjOc5JpUlnRjruXcorkX5unOy553PFk1WZB8OIWYEpeyP+WDIEJQLxhP5aduTR0T8oSbhU9FvqKNolGxt7hKPJLmnVaV9jjdO31D+miGT0Z1xjMJT1IreZEZkrkj801WRNberM/ZcdktOZSclJyjUg1plrQr1zC3KLdPZisrkw3keeZtyhuTh8r35CP5c/PbFWyFTNGjtFKuUA4WTC+oK3hbGFt4uEi9SFrUM99m/ur5IwuCFny9kLBQuLCz2Lh4WfHgIr9FuxYji1MXdy4xXVK6ZHhp8NJ9y2jLspb9UOJYUlXyannc8o5Sg9KlpUMrglc0lamUycturvRauWMVYZVkVe9ql9VbVn8qF5VfrHCsqK74sEa45uJXTl/VfPV5bdra3kq3yu3rSOuk626s91m/r0q9akHV0IbwDa0b8Y3lG19tSt50oXpq9Y7NtM3KzQM1YTXtW8y2rNvyoTaj9nqdf13LVv2tq7e+2Sba1r/dd3vzDoMdFTve75TsvLUreFdrvUV99W7S7oLdjxpiG7q/5n7duEd3T8Wej3ulewf2Re/ranRvbNyvv7+yCW1SNo0eSDpw5ZuAb9qb7Zp3tXBaKg7CQeXBJ9+mfHvjUOihzsPcw83fmX+39QjrSHkr0jq/dawto22gPaG97+iMo50dXh1Hvrf/fu8x42N1xzWPV56gnSg98fnkgpPjp2Snnp1OPz3Umdx590z8mWtdUV29Z0PPnj8XdO5Mt1/3yfPe549d8Lxw9CL3Ytslt0utPa49R35w/eFIr1tv62X3y+1XPK509E3rO9Hv03/6asDVc9f41y5dn3m978bsG7duJt0cuCW69fh29u0XdwruTNxdeo94r/y+2v3qB/oP6n+0/rFlwG3g+GDAYM/DWQ/vDgmHnv6U/9OH4dJHzEfVI0YjjY+dHx8bDRq98mTOk+GnsqcTz8p+Vv9563Or59/94vtLz1j82PAL+YvPv655qfNy76uprzrHI8cfvM55PfGm/K3O233vuO+638e9H5ko/ED+UPPR+mPHp9BP9z7nfP78L/eE8/sl0p8zAAA4b2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMwNjcgNzkuMTU3NzQ3LCAyMDE1LzAzLzMwLTIzOjQwOjQyICAgICAgICAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIKICAgICAgICAgICAgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIgogICAgICAgICAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgICAgICAgICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIj4KICAgICAgICAgPHhtcDpDcmVhdG9yVG9vbD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxNSAoTWFjaW50b3NoKTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8eG1wOkNyZWF0ZURhdGU+MjAxNC0wMy0xOVQxNDo0MDoyNiswODowMDwveG1wOkNyZWF0ZURhdGU+CiAgICAgICAgIDx4bXA6TW9kaWZ5RGF0ZT4yMDE2LTA5LTE4VDE0OjQ2OjQzKzA4OjAwPC94bXA6TW9kaWZ5RGF0ZT4KICAgICAgICAgPHhtcDpNZXRhZGF0YURhdGU+MjAxNi0wOS0xOFQxNDo0Njo0MyswODowMDwveG1wOk1ldGFkYXRhRGF0ZT4KICAgICAgICAgPGRjOmZvcm1hdD5pbWFnZS9wbmc8L2RjOmZvcm1hdD4KICAgICAgICAgPHBob3Rvc2hvcDpDb2xvck1vZGU+MzwvcGhvdG9zaG9wOkNvbG9yTW9kZT4KICAgICAgICAgPHBob3Rvc2hvcDpJQ0NQcm9maWxlPnNSR0IgSUVDNjE5NjYtMi4xPC9waG90b3Nob3A6SUNDUHJvZmlsZT4KICAgICAgICAgPHhtcE1NOkluc3RhbmNlSUQ+eG1wLmlpZDpmYzY1NjliOC05NjI1LTRjMDItYTY3OC02YzY5OGJjMjA4ZmQ8L3htcE1NOkluc3RhbmNlSUQ+CiAgICAgICAgIDx4bXBNTTpEb2N1bWVudElEPnhtcC5kaWQ6ZmM2NTY5YjgtOTYyNS00YzAyLWE2NzgtNmM2OThiYzIwOGZkPC94bXBNTTpEb2N1bWVudElEPgogICAgICAgICA8eG1wTU06T3JpZ2luYWxEb2N1bWVudElEPnhtcC5kaWQ6ZmM2NTY5YjgtOTYyNS00YzAyLWE2NzgtNmM2OThiYzIwOGZkPC94bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ+CiAgICAgICAgIDx4bXBNTTpIaXN0b3J5PgogICAgICAgICAgICA8cmRmOlNlcT4KICAgICAgICAgICAgICAgPHJkZjpsaSByZGY6cGFyc2VUeXBlPSJSZXNvdXJjZSI+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDphY3Rpb24+Y3JlYXRlZDwvc3RFdnQ6YWN0aW9uPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6aW5zdGFuY2VJRD54bXAuaWlkOmZjNjU2OWI4LTk2MjUtNGMwMi1hNjc4LTZjNjk4YmMyMDhmZDwvc3RFdnQ6aW5zdGFuY2VJRD4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OndoZW4+MjAxNC0wMy0xOVQxNDo0MDoyNiswODowMDwvc3RFdnQ6d2hlbj4KICAgICAgICAgICAgICAgICAgPHN0RXZ0OnNvZnR3YXJlQWdlbnQ+QWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAgIDwvcmRmOmxpPgogICAgICAgICAgICA8L3JkZjpTZXE+CiAgICAgICAgIDwveG1wTU06SGlzdG9yeT4KICAgICAgICAgPHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgICAgPHRpZmY6WFJlc29sdXRpb24+NzIwMDAwLzEwMDAwPC90aWZmOlhSZXNvbHV0aW9uPgogICAgICAgICA8dGlmZjpZUmVzb2x1dGlvbj43MjAwMDAvMTAwMDA8L3RpZmY6WVJlc29sdXRpb24+CiAgICAgICAgIDx0aWZmOlJlc29sdXRpb25Vbml0PjI8L3RpZmY6UmVzb2x1dGlvblVuaXQ+CiAgICAgICAgIDxleGlmOkNvbG9yU3BhY2U+MTwvZXhpZjpDb2xvclNwYWNlPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+MTAwMDwvZXhpZjpQaXhlbFhEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj4xMjA8L2V4aWY6UGl4ZWxZRGltZW5zaW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAKPD94cGFja2V0IGVuZD0idyI/PrkSIsUAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAlztJREFUeNrsnWdAFMf7x797dxwdDrAjIHZBEawhtsQWW0xRE2NLMYmamF6M//Sqpnc1xvwSe2JJNLbEXgixIiioKNJFVOBo1+/m/2LZZe/Yu9s7jpJkPm9ub8uzs7OzM/Od8gxDCAGFQqFQKBQKhUKhUCiUpkVGo4DybyMl7SIBQFueKBQKhUKhUCgUyj8KBY0CCsV98m5qyNYMBvIqGSYMMCOyhR9DY4VCoVCaluNJSaRSpwMABPr4YMCgQR7Pm19dso4AwPsLptF8n0Kxg6+vH99hotVqmOZqk0KhAv1fyrFMHflsmwnvTFeia1slzTCaEGIxg5HJG/w+G06W4cXR7cDAgo/+vImXx/jRyG9kNm7aTKZMnuT0e3tl4UKyeNGiJvkuM7L05PCZMuw9oUb+NS8oggLQ1q8MI3u1w9BbvBHTyZvmF5Rmz/YdOyWNTJowflyjp+fkzyeR4ivXAADlFdVQ9umLvncugklbjtS9i3F+xZMkOMgfANC6YxskPru5XmF8dck6MujOafx2cxbpH27Ukq1HKhAR6Y8VT/gi0E8uGtbLV/JIbvYlu3aiorugc8dIp8/5+Zpjbo1gMxlMUCgVeHbGQOafnN8LOZ6URLZs347mEJbGFOScaBZui/2vr31n96NQqEAX4Zc/y8gPh414ZKgX7hsd0ugfzPGkJLL13dm46/WVDdJ6bsupy+wtTBrPjq6u1JjJkt3FSL9ZgUt5BnSJVGJ6Lz9MToz8T2RCm5LzyNqzGv7ZY1sEYcGY1nYrGQAaRZwDQEVNOUAg47ebmpJqMzlxwYy0K2YUV9Z+4pU6C+I7AB1bM+jfXY4wf3mjBthe5b6+lfnOXXti6fLlZN6cOXbtTJ06lcyYOatJ3scvf5aRX/YXIzQyGsOHhqBjazaYV4pVOJ0D7F2RjfuGtyaNmUceT0qqVyZlLz8dN24cbzcoKIjfHxyssjovJDQEABxWWufMmetWGJcvX8ZQew3HwFuGwABfAIASWqvtjX/uw+iBfbB9x04i5bt+ZeFCAgBlpWVW+8vL1bV5bEUFv71z5067NouvXEP3LnG4cCkN3Z9aBaWXN3wVBmh9g9H9tpdhGKRH0U/z+HM8Ic4vaAi8NDoMunNasxbpL0/xZV6e4ouBD2WRjIJwDOxat3zMyLhErmRfQuItAxEWFla3XCkpQfLfx2DQ6UlMTBfGmdB+8ZFBAICPf0jity0WNombCWAxGWAws+WT0ahn95vM+GlrWqPk9w1VHtmy7+hRpKWmIiXtIkmI6/afEulA3d5trVbD1EdEi13L2aSSjvKfEOiOKgvxfRIwc8YMBPj7O/zAvthuwJNzWuOL5cW4b3RtxuksUBs2bHD5w6088yHJupAKAOgx8lOkXryM8yuexH2jE7Dny6cwYNBpSXbEnltqBeiJcd7M4QwjsS0o6vO8hSUmMum7i2gbJkdipwjcMcgHBblarD1bgP3Z+eSjSe3h780wAPDh7kLy8pjwRi0ANm7aTPbu2WO1b+SoUZgyeRKzdPlycuZ0Cr//zokTnRZ+wmeo1hPy0uYCFFVpENu+Pe4Y5IuKazokZ+Vj1Bdl2Px4NxIephC111g96NN6h2HS9xcBAG/e1qrJP+jCEhP5dCsBwKBSJ0PbFma0aEMgr5KhuIrgTA6DMzkEe1It+L/7QRpbpCfcMtqqUr9/18+SK/N2bcZ1Ywrzs4i9Shv3TTdFrx7XSDm8bxQC/IHiKoKsa6zrj9aBZsR3kKGqZRR+OFwJoKzRRHqlTofbhg9369qD+/fbPeZIQDW18Pyv2WsoiopL7R4LNFfDyycUkdGxkr5rT/YqlldUAwCuF+bh+gfj4R3IiszgIH/+mL6yBNEdIvn/9RHn54qq4evFfssXNASD7pyGl99ZSj58Yx7jrEFC7LkdHfOEvR+3Xych7QMxsKuPqP0r2ZfQt99A7Ny1G0ePHOEb0bgGlMFDhmDkqDE4dfIYYmK61Otd8eWzWeQ9GnSNlt83RHlk/a2UkHI129j0d/JBJMR1a7Lvlpx8vU5d1G/IJ9AcecFqH9PvXf7Z9TeLiXeL1rQ3mkJpTgJ9+fJlDCcuhQLylYULyaEDBwAA8+bMcWh85kBffPLidTw2w7de4ttJRk8Wf/QxjDeTMXVoDNpGqHB6zRMovnIN8XE9kJ2Th6FPf+VSJemVhQtJTnY2Zsyc5VKlfurHVQQA3vnViA0venvkeZceuo4+UUHo3LU9Sq9XIyf1Kjq0DsWQPt1w5PRFvLS5AJ9PaUv+93c5Vh0twctjwp0K6v/9sBI7d+5kjp1KI2+//orV8TffXYyBfeOYVxYuJGmpqYiIiERIaIjdSsOUyZOYKZMnQSytzJszh9m+YydZs3oV3vvgQ0lD41YdLQEA8uLodpjxEyt8h/TpBlO5BmcuaNHCl/1/ObMASw9dx3v3tqtjw2DUN1oPekwnbybxUiABgPiuoS6/6/z8ArJm3Vps++03nDmTimeefQazZj6CLt06w0vOMPaO2+vB2HrMjEod0LYFwfN3KWDbgFFYYiLf7TOh6KYFPx+y4Ilx8kbNcEqKC63+h4SwlUDb3gxXK0i94+Kg1Wqxes1aMnPGdKv8Kj8/D2++u7jRM9eMLD35ZX8xYrt2QjUx43IO8OwdDGI6ecFMCK6VMli73wgAGN47EL/sz0XPTn6ksYa7WyzAubmhyK2WIcrfAgBOt3suK3WcBwoaJMV6zbl85PFv9eS7J6Q9p5RGTil5rVQ7Uu16KlwN9dwZGZdIUVEetDo9v8/XxxsjRoxgAGDfvn3E9ljbtpFw1jvq52P/sEXZGsf/+gMaSzDC/KU9pzAtvLJwIXHUm+4sLvVGNVqFR9bZzw1tR5B/vb6ZjZs2k9gJrDgX4qXRYdVBM4JaPOJQpHPPNmfOXCJskHF39IRUe7/8WUa2Hy3FxjfsC+uysjK0aalCQWGBaGPRoiVLSOtQb5SVlUkK25Llf6CKKBDAmPD6sn0IYEyoImyVU7jtDp7K7xuqPOI4euQgnnziSbz33nv4fetW3H33ZNK2ddg/QvAeT0oi7Z+YB9WoEcTv48/cDrO9Hm937YldS3vPKf8pgW6P2NieyMnORm5OjtNz504PYuZOD2q4Cqaxilze/QGMNzNwx9R3sHnvLkyCGj1vG4gc2UVkX76Advd/6PLwdq7Qa6UKdq0i92KAxzPevRfLMLJ3FI6cZsVqYmQgthzP4XvUk7Pycf//Lku2d7PkJsrKynD5Sh4Z2DeOeeLJ+eTsubNYuGABs33HTvLrpvXIPH+WlJWWYefOnbzAdpcJ48cxv2/bRqSIc47kvErM31DAPm+nCBw5fRFFJWbcm6BCcl4l2qr9EaoKwd7UXLyHdk328Xy4u5CI/Zc6iiE/v4C89NKLyM3N5cW3sCHE2XExztR8lq/eo4DSq+7ogvAwBfPqPSDzV5j5c8W47/1fyS+v3sMIt+97/1f+eW3/2+7nrhWr3G/ec742P2nvmV6M8PBwdO7aE7t3/YbtO3aScaOHYsmn3yAtNRVxvXtjQEJso6ePw3+z4qd1oAmXb8hw70AG3Tp64dudepzJAd68X47Z45RY+JMJnVtaoGjRHof/1iOmk3ejhpMT4VK3HZGamgqVSlVT2a0dmhwUFGQltAJ9ZJJFuqcadT3dOOxpe560n5FxiaRnpGHwkNvQtnXtcOWSkhIsXb6cAMDdd0+uc2z/gYMA4HAIs9I7AIRRgiEG/hcACKPE7YP68OelnflbkjgP9KldTCYnOxuA9bB2ThCq1WpJz96+hR8KbmpwuVhr54w8t+J09Zq1ZOoD02Ax6fHFtRqxYGS/i9Mp0vTB8uXLGE48c6JaKKZdHUUh1d4n60pRWKZFjwfS8NqstmTupDZ17lNVXYWsnEJ07tQZi5YsIZ07dcaUyZOYjZs2k8tZl9G5U2dcyS9FVXWV03CVG3R4+/HRkMkYvL5sHyYNT+CPbd6fgjtu72/1X3j8563HGi2/b6jyiONy1mVMmTyJuXPiRPLtN19j757dmDljepPUV7JTjiL2aTZu078ciOiEwWwcDPmkzr78/AKSW6JGz1EjYLySh+NJScSVenRjzwGnc84p/zmBLiwkOdLTzwEAHn1sXpME2GKsIpqsK7h6aQNKsi4irFM3PDf9Vny29g3cMfUd/LBpPV69H5h6aztsANC7W2eX7BcVl5D8/DwEBQUhonN3l64d89p1AgDP3qPCmL6ecRJXVc2OASsqMWPz490QHqZgnry9HZnx00UkZ+Ujtn173NQCLXyBS3lXnNoL8A9AXFxvJP91BJ071i0oglUqHD1yBPfdN4UX2EePHnFa+xBLK3xhXa526Zm5Z4pVhSA5Kx8AsOeZ7gj0kzPckP+RqhA+bpoKToi/tuUqAYD37m3n0jtfs24tcnNzERISgrvumlhHfDs77gi5Qu7kmOtxJya+hfvEBLtY5f6BCf2tKvG2vRgA0CthqEuVIpmMYRLiuqH0Rj+yZ+9enD13FkcOHQIAPPPsi2Bk8kYvwPeevYrQyGgUV8oAWLDlGMGWYwb+eLXBAh8f9j0VVyoQ5CfD3rPZmIugBg+bVqeHwQScKA1A/1DxCrdvVK140+aWsCLMYrbqkbXl/PnzTuN56sdVJMjPCxUaI6Z+bCT2Gjabqsf732AvPSMNtwwciL17aocrB6tUaB/eHgH+AWz63LMbBYUFKFerUVZahvg+CZgwbjz+PuZ4CLOvjxfYVSyFv7DZdg434gzwwtSPq8iGFwMYTzR6cOL8gW+Pix7f+ud2RAYpXRbn902ZDIuJ/X6fHOyHb45qrMR5kJ8XmJxl+PDDZxhnopp718J37u6zS7F37MdOTm137dwZ369YivsfeAgJffrj+xVLMWXyJJw6dRKPPjYPGh3B9yuWYtTIkU7DZKo0QCZj+G3bY47+N2Z+31DlEcCOUOnVsxdfj1qzehVZv25tkwn06ITB0BypFeXctubIC7x41xwZjPz8AvL3sWOYfO/d2CFn4L3hUYxysZPL3hxze/PSPWHbU/YplH+EQOcQOv6JiIjEY489Jmm4siedxGX+/n8kYw+bAWs7d0ePVjqEdWLn8xTlqzF1aAx+2LQe906YgM/WfoSpQ2PQN7o1Tq95AonPbpZ8n7yC2szZ1aFIK58LxdkcCz7/VY0xfT0zHznAX84LdW64sr83w3w/vQsZ/+UFxLZnxbnUAqNd2zYYPGQIdmz/HTNnTIdWq8W2337Dtt9+IyEhIfj44y8we/YsPPNM7bykpvQ+WlRixo6nu/MO4cLDFExVtZnc1NbGTWPwxLp8/hsoqqrGr4935+OkVFdX7N7z3QXSNqB2OOW30yLqxOGqH39E79692Urj1m14ZeFCIhy+7uy4GCM7a7AlzQt7TjMY01e8ErrntBEVGiPujTMCEO+tzSoxoe/zG4nYfttte7/2Kvc/bPpL0BhTtxejTUhrHDz6N/xkWpcrRSNGjGBKy9Rk7549CAoKwoyZs9BUQwrzr3khqqsMlTrr3ue2LQhevssb6iozvtxhBOsvwIK2LQhSj3s5rJi4JcZFKitaM4ECBnyWEQAgALPjfDGhl3UjW8seneAX2RKavBu4wRUYJj20ZiKprBBzErd8+TJmw4sBDCfOHI06au493s3Z3s2Sm2jVqiXS08/x07ZmTJuONu3C4SXQLvn5Bfjm22/4c8LbqHCz5KbbjX8uPW9NOqjQGPl0wPX+uuMk7oZWhuycPJRXVKOsXIfrhVmQK3zqnBdorkavhJGS8xZOnFtXnAx44hZg8iJ2qLtK5QcmZxmWOxHnwnct/Fbq67vBE/Zqpj6Qn9f/CACI6tCB//1+xVIAwKiRI/kpEs7gHMIBdXvFnf1vrPy+IcujPXv34tDBg3j/vXetMkypXujF8vv6CE9hD7qYeAeOIfXyFZz/603c+/AUpP4yC0dTI7G44KpL95z/9POE+/36y0896mndnm1P2adQ/lECvaysDMnJyVZzfF577TXs2bvX6RIWYk7iEhMTnVYyhffjiBr9JkqypsG3jQ/8/Fvz+0uyLqL4yjXEjBqGR25l8MP27bj37pfww/btmNrb9aFsedmXUFZWhrgaYeQKqgA5Pv+1FF8+qeL3ufu8HH2igpBewA73NhhNhBu2vPLINbQNk+OmVlrYevToQZztU6vVmDRpIgBwv/xxKT1j9uamOepdF61camt/24bJsfLINX5uvcFoIgBQXFKAPlFBjfahMLoKTBzYEiePGfCtQJwLjwv59fHuzPs/FJB+A5XYduyGqM2cnFxegN9++204dPAgykrLsHz5MknHxbhnhAp7Lxvw4wEDQgItxNYh0LFMHfnxgAlBfl64+3Yfh8986tMpDABRoe4ucoUcj00dwv//6+jBOr0YQqQMk7WpFJLQEBXy8/MwZNiwJnEMJ/oNaNi55kF+Xpg+hB3S+/bPZgAMKjRGBPl5oegm47LQdhuDDkaTCTk5uZjX3Rcr01qhrFyBKP9q9A+tgm9UGPwiWwIA+3s+CwCgsbDX2uPAgYPo0CGqNk9UcXlhLj+/k81rNNj9XitJzyMUHo5wJkqk2pFq11PhaqjnzriYg9jYnli0ZAkJVqnwzbffiF4frFJh0ZIlJDa2J1LPFzq9n5eX56ZgbHgxgGFHngXUNBjkWZUjwmHtOTm5kmzqK0sA+CMwQLzlWjhP3png4sS50cQ2OnopFPz2sb//xku3AytSBiL4+krJ4lzs3Y4bN44I36PUZdGk2nNF8I4YMYL/f/lKHunauTO6du7MryUvXF/e0bJrJrMZxMI2Xt9/10ArMS78/8P6vXjkgZFW/xsrv2+o8ig/v4CkpaZa1e0yMi6R2bNnYfOmjZgyeZKkhlVPrvXN9pCzHS/csHaheO/eTotte7bgpTefxfkdq7H31/NY/PNal++5csUyzH5sLlauWIavv/zU7vO4gz3bnrJPofxjBLqY4Fq8aBGTmJhIDh086LQlUMxJnCMx6ghvb2+mz7x1ZMvyJ1B5aDW8A8NwQytD+KAE9B3VDaeyi9GjlQ6P3BqFT1atxp0TJ+KX9d/jqU9WuHSfy1mX+UqLq0x6lxViT3+jxu73WtXreTmGRxOsPctuVxoYhHmxc51rnKlJGtbOCexFS5aQhQsWMJw4/+jjT1BWVob09HNYvGgRk59fQEaPHgUA+OjjT1wq7KQ6jpHC0RTrZ7qUxzqOe3lMOHNTZ7SKGwcFNz/EzhNcNbG9Rl4xXlj/5wnywOj+vPGiqmoA1r1K6/88QVp06QjAzF/rrPEiJCQEq1atshLgzo7XqTzLGWbxdDN5Za0XPttmxBv36HmnYxlZevLZNlacL3pQAaWX/Upf5dUyydtivyOmvEv2bXydEavcf7u6tgIW275uLwbHI5NvlfRuqi6kEdPegwCAuUdZOy+88AL27N2L9V/OJmNlveE79X40tjfaiDZGFJbqEeTnZSXU31gLAAZRER/RxtgoYdPVVLDndffFgYpSjA0CtMXABQAXrsjgm6/A7NaFaBsfjqIzhbiQwb7b9oJr69OIIFWc10fgNpSdhrLnSftdO3fGsm8+w50TJ2Lo8LvQtqUPblQAKX//id+3bQPArqrRK2Go1bFl33zGT2+yh0wugwIGmKB0+CsVYVrwRJx6B4YB1TrRufKuzJO3FecArMQ5AASoWmJY4FrMe1G6OBc22icnJzPc/8TERMLVF6Qsi+aKPXewXXZt0ZIlGDBoEPYdPYqFCxY4XHatWlMJvZGB0WhGtaYStsfqgyfz+4YojwBg+84dePiR2Vb7YmK6MBPvvpus+vFHyXO667skmZD0LwfWEeacWO/eTot7bvPBS28+i4t/5WHbni1442et2z3cX3/5KbNyxTIi7Om27eH2pG1P2KdQ/lEC3Z5TFqnOWjztJM7b25u5c/aXZFnSEHQO8kXipGFsobR5J7rGd4L2GoA2uZh3O7B49SpMmjwdrUNda+1PTUmBWq0W9PxIx5VKp1RujwvHWzvSEeAvR/ZNDcL8A/HymHDGmbd2W2zXPR46dBiOHj2C2Nietc+exq4/+vSzz+Lbb77GhPHjcDwpiaxctdqp8xp7aeJ4UhIRDnV1xrn34hze52qpCQH+chSVmHF7nHgcMLpKj4pzXohnA72jGaSq29UR6e0UZitxnm9ph96hZlRW2Bczs2bNwuHDh/i0plarMWvWLMnH7REa7Me8dp+GPP65BisPheCTTuz+lYdkUKs1+OThUKdroGdueJyRum3vVww/XxlefHw0/3/Xzl11ejFcrawljxzD/58NYN/MB9G2bSTukQEVH+7CCewCFi9G4t7dJKB7XKOJ9MRewdhyrBqx3a3zkk8e9oEqQI7ZX1l7gs7Pq8a9A4MbK3iorNJhaA9gKELrHIvyL0b58WKUHz/DyTIAgF7neAkk24qRsDcdgMCBXIhTQSZl9JEY9kTJf8neiBEjmKtF18jRo0dw9OgRq2ODh7DfmtixkaNGOR3C7CUzA5DDC45/pcD1/Io5ghPrMXdFqPj6eMFk0kOhUEJ8zjxcEudc+k/+mx0m3EoVjFMnk+FoPW5nYtqRqF62+ZrDZdFctecqtsuuxfdJ4L/hOXPmOl12jVvbHKjbK27vf7XWAn9fWaPl954uj7g6z5eff46vv/66zjEu//v0q6/wfXw8cbZUsatp3hHCOegcmiMvYOuq/TiRWYL5Cwfjt9+uozDpvFviHGB7uDdu2gQAOLR3D4aNHFWnp9tdGtI2hfKPE+hicGtrqlQqjB07ptEDHODvz8x9+0ey7M2HoM0uRmFSCgYldoJvGx/k/JWDDm06IHV3Ot77YBs6RoRC5uWaZ/XcXLZS0LVzZ5fDNujpYr6wTPrSM711Yf5yZtbgMLIlRY1TeQb0i3LPzrCRo7hNolKpsGqVtWf2Lz7/gnToEIWvv/4aI0aMYA4dOEB8ff1Ihw5Rkoa39+7dG6mpqVbLvWRkXCKffvUVJk2e4rH3fyqP7Zm5N0GFxlzDm5tzvik5jwzvEYKcq2a8tuUqGdS6GO0U7FzvXUkpJKm4NeLbtsbwdkHIuVqGyYmRzOREcZvPPPMCQkJDsPW33wAAd919N2bNfETycTE+3Kgl88YroTOyn3b6lTIArQTbrHOySo2ZLN1hwMtTfBu1V1nO1L2dbS8GxxMznTsjMv/f2+j/yitQzX+a0d8sJofjE3ifCXt++okk7t2NgO5xjPrrL8neb+fh7i+TGu1Zx94SiuSz2ci7ykCl8uP3VxssUNkImAqNEW39yjD2luhGCVtVdRWUCuDweXtnyDC0B7uV5quB+jwb/iE11zZ0ZdKRkKX2pCFcfsqjlQa553x/eHIUQlm5Bmjtyy6pdk0HuUIOucLXbXucONfrdPD28bES574+3jh17pxL4lzYAGFbpiYnJzPCKWe//FlG9p5QO1wWzRV7bsVnWRlah3rXWXaNe+ZFS5aQNi1VdkfPVQkGAwmHsH/1w5946pHRDv83Vn7v6fLoeFISefDRRwEA8+fPx9PPPsuv1T516lSSmpoKgF3ton+/fvjzzz0kIqJ9k07D0nbujjfen4INT72CXPlFt8U518M9ZfJkQDA9kuvpFg5Bd3VkgDPbQpvu2KdQ/lECnRNnOTm56NGjB8nJyQX3f9asWXjttdfgrPXPk07irER69zhm6NNfka3vzsaEMbHwbeODvb+ex6DEaOz99Tzmvr0KAS4s68Vlnlu3buOfcf78+Zj10EP8kHApvDGHwTvLCaaPUXn0JT15ezsk51UiNV8DIMy9TNgmo3K2hr2rDos2bNjALFqyhKz68Uc+7URHR+OBadMhxSGKVHafv4G2YXI8eXvTLK82PKYFvtiZjlvjojAkCADC8cxYFSoMepRUaTFEBai8QvH7X2fxzDjHS73ExHRhFi9ahMWLFrl1XIz9qZXYKnC6HxhkHfWVFQQPLyrjj708xbdR42/7jp119tn2YrjC8ePJGLVlMwOAG9JIbPMKAFDNf5rxb7+Y4MvGe9aYTt7MfcNbk0/WsWuHcyL9jbUGCIe4q9UalBVUYt7kUDTWGugA4O3jg1f3ZjpvaCAmVDEK/hqpOOpN53qSpIhSqT3Lzmw1VY+3u8K7oe27C/Hg3bhndNRz7m4luz5z5WfOmM4sXb6czJk1A/oakV6zBB1CQ1TIvHzZZXEuJqTtHZOyLJor9txtxLuSX8ovuyYcVahWq9G5U2dk5RSKNthVay0gBgu/7Sk8nd97ujwaMGgQc/78eY/UqTwN0+9d0bXt59/RDUveWYbokS/hjXo06q1csczuGuVcT7fwuCvftRTb9bFPofyjBLonEreYkzgprbpSCpYBgwYxeH0l2fouO88nJNgPScnZGPr0V3BnGKsnMs/oUBWemVCNL7ar8cS41h57Xn9vhvni3khy34ps5N3UkMgWfs0y41m4YAGzcMGCBrOfWWQgRSVm/PJYNPy9mSaJg9BgP+aZcbHki53p8A9ph94RXtBUVgHe7LDJ1HwjqsvOYvaoWIQG+9ECQoCYT4PtO3YSeT1fJTef79irC0nQgw/y+4MefBDHXl1IBr6/iLGd4tFY1DRMkl/2FyP7XCVC2gfyQp0T5hFtjHhkWmuPNmJKYfWaNQ1q31MVJE8J0Obe493Uwlsqcg9mvZ58RtIiBicyM6AtvoFdulZ4zwdgZO739s+bM4dZunw5mTBuPDIzLyI0hBWo7opzV5CyLFpDwy27Nm3mXAy49Q6EqnwR6CeHwWhCWRFBcdVVh8uuvfPldn7btlfc2f/GyO8bqjz6J/HOW2/DeHM0egx5DFMmjq/X0mfcrzDft7e/udimUJozDCENV29dtraCrFijw2MzfDB3elCDfEBVF9LIpyvfgP7sBdz1+koMcHG9Rk/CDXGPiPR3uHyQu5RUm8nJnBLcEduqWWVGUh1y1DcT/SP9OunfPsCp8K0pwAGgweLJYDSRC5cKsSdFiWM5rMOgHh3bY1LvVujRLRJe/6VSvh5s37HTrYqU8F2X389OoeCGPgqPq7/+kpxYvBgAEPzzxibLHzKy9GTX36VIPluO7NRQKFqzwnxkr3a4pb8J8V1DaXqh/Cu+V6nfbnMJp7MwLl2+nNgK9//K+169Zi1JTz9n93jfvv08OkJOijhvyPy+vuURhUKh/CME+n+N5iqg/2scT0oi/RNvASOT0/dAoVAoFAqFQqFQ/jEoaBR4jjB/OXNHbCsaEc2A+gxtpFAoFAqFQqFQKJQm0TG0B51CoVAoFAqFQqFQKJSmR0ajgEKhUCgUCoVCoVAoFCrQKRQKhUKhUCgUCoVCoYDOQad4gONJSeRidg66RXeo4zXV0TEKpbml49yia9i8aaOk8ydNnoLQEBVGjBjBNFV4K3U6AECgj0+9vy9P26sPGRmXyJXsS07Pa9mmPQb2jaP5CoVCoVAolH+vQN+4aTPZu2eP1b6Ro0ZhyuRJzNLly8mZ0yn8/jsnTvzXLDlRXpROik+uheJaMgzF+QAAXeeB8POPQut+0xHcNrbRn3P9nydIcnK2S9ckJkbjgdH9GyWsmhefI8YreSg/nozefyajeHQiygckWjk1sD3m1TESfh9/5jR8RjMhN2+WIq+gEDeuFUCr1SIyugsi24ejRYvQJlnGLPnzSZIcNiQ+u5lpbHsjprxLsq9cRXTHdti38XVJ93d0jaftNff4A4DcomuYMnkSNm/aiAfnfwPGNxCBuIFKtGRFK26gQusDAPjp6ycxZfIkbNy0uVHTX/GVa+x3VVENZZ++6HvnIpi05UjduxjnVzxJgoP8AQCtO7Zx+tyetletr3VocuScEUN6ekna9veu+y1fyb6EhFtGQwktDPAFANHt/bt+xsC+cS7F48ZNmwmUPo5PMugadfkoABg3bhwBgAkzH5d0/vbV3wEAdu7c2WjhnDNnLklLS0VUVBQqKioQERGJ5cuXMc6ONRWrjunJr6nZ+PXx7rQR5z/ApBe+JpMemc//P/TTF1j+4TNMfc91xtLly0k1I0dZmR+M+nKUVxlgkrXGysVTmYZ+Xtt9LeTmOs/x+ZpjbjmbMhlMUCgVeHbGwAZ9juYePgqlWQj0KZMnMVMmT8LUqVMJAGzYsIFP+PPmzGG279hJ1qxehfc++BCdO0b+Kz6KyjMfkuwLqYgdOhCWwAXw8hnM7r+ZCz+yD+mHPkCn7r1JYPzLDp+XYeuZUjMapw76ykoK8eWb94FYzJKf5Yt1Jx0eT0m7SJZ98xlfcZo6dSqpqKhAUFAQvl+5EqvXrMGhAwdQUVHhtOJnvJIHMnwYYrMuIenyOQwKawEyfJjVObbHjPsPOX2GqupqcvDgIZSVlaFrj17o228gACCvoBB79+xGSEgIbrttGAnw92/09Ndn9mMOj59euaJJ7GVfucr/Si3shNc0tL3mHn8AoNPpeMFdrDZDV1wKH28vAGoAQI5eDsAIAKioqGhUcQ4AxVeuoXuXOFy4lIbuT62C0ssbvgoDtL7B6H7byzAM0qPop3n8OY1tDwB0JgtOXDBjUA85vGRmVBoYjOmrBACUVJsxIt4LFbracxxRUlzYYHE5ZuQY6LQatpJnMtQWiAolfHz9sHvnb01SFj38yGzcfc9dTs+TyYCWXmb874eVjRq+tLRUhISEoEN0NMpKy5CWlirpWGOUR3XaWIwmMn/d2Xo978CHslwWDsd+7NRo5ZKj8P1Z8TKqsy7Bv1OXOr/BW8Qb28aNG0eE8fx/M+4lL99yG3987Z9/4MltOxh759uSmJhYJ3zJycmNFj83zfIGOdeWRx99HAYTm//pdATVBgs++Wypx5/HYiFk2rQHrOrlgx54En6+FgBAEOR2heyLjwwCAHz8QxK/bbGQmvyEwYTHt2D952zeYzTqAQBmkxk/bU1r8PfU3MNHoTQLge6MCePHMb9v20akiPMXfjCSTx7xqnPe5St5ZM+eXThzOgXl5eo61wkzn/peZy8MQnFuyNqHHuOfg4UTnrqjAACfAMCCrugxvissF9ag8syHTkU6AEYg0utVEGm0LWEmBKPv/8Dpufny1ri4bjaU8iKH5/2dfBDl5WqkpF0kCXHdGIDtgVm0ZAlJv5CFQwcO2I1/W6qzLkHVMRInSm4i+c1ZUJV4Y1COdY+/7TF11iUEOxHnv/76G1pExyCxR08EB4cg7cxxxMUPQMcO0QgLUeFSUQl+/fU33HPP3Y0u0mWVmTWVeut4VijaNqm96I7twPVeP/nAAHjVLAFvrmkE4gYcmAWNQr9v/RPZV65C0SWhwe019/gTNFBaiR6d3mKd5nUE/j4Mf+7qNWsbLe2VV1QDAK4X5uH6B+PhHRgGAAgO8ueP6StLEN0hkv/fmPYsZgt2nDPhnl4KyOQyKL0YhHnVHg/zr608Duohh4EAJ84ZeQFvi19NPP957DQOXiE4m5OBobJ8lJerERysQoeO0VCpVO5XCk0GVFdbP5e/P8CQpnPNcjnrMmQytuJpt2HUIoePkj23sUlOTmZ8ff1IdnY2cnJyodVqGCnHGqM8suXNQ4W4b0wQftldgZ0ZIONi3CuPn5zXHooAb5iq9E7P/WZpQaO/E3vhq378Etqc/AswMai+JRGBP/+EQBODa7ckOiyDhYRXWNssDPJ2Ob04E+yepgLmBjnX5fxF1rpBxDnXkMW+oMEesW0wmgAASrkJBrO1LCg36JpcqDT38FEojSrQKyoq7FfsRMSxqPjVWfD4t3ry3RPeVpn0xo3rceSQdU/qzp07GWetsa5e9/i3eoeFQXlRek3P+XhYair7lsCufKWf27YEdoUifACKdvwKS+vxRMJwd06k10uom41VMBkM8A2Jxe3DEmFWqiA3qOHvw6BaZ/1om7bvhYnIUFnh69DmoQMH8NxL/4e/kw8iIa4bKioq+ELzqfnz3UpEAwYkYgAARLO96l4dI2G8klfnmJQC6ODBQ2jXtg1ahoQiODgEAHD85EnExQ9gxUNwCMJ1BEAMDh48hDvGjCWNOdxdKAQZrRrEVwWt4QZ83RSFnrK3b+PrzOvL9pE3HhsOmYxteSYMwNQkE0uNkGYAEAawWIBta17D1z/+iQVz7mAa2l5zjz8OTnDr9JY63xi73wzU9FI0pjjn0BvVaBUeWWc/NxQd3G8T2Pv1bK0496/J8pcuXw5uWlSHjtGYMW06IiLaw2A04dfTZozvab+N2MsnFDsO7cXKE0Z0ClPgrhZVGDVyCmJ6xkOpAM6cOYM9e/di46bNxNXh6Eq5CUoFq8irq6vh7SWDQukLpQIgjE+TFcjl6tqytdLAwEchg85k4X8DlUT03MakQ4co9O7d2+VjjVUeAcAf6ddJSIAPHo5qi192p+HI1VyMi4nCyV1GknfRiHuf9ZOcXrJyCQBWBJgDTJBXNS/XPZklRshza9OFOcAE32s1acPEPmabv5MBU/3vZSvYKQ4q15Zij9qTyRhmw4YNmDp1KuEarcSGuNvj9WX7EMCYcORUNQ7+vUX0nElP7Wiy+Gru4aNQmo1A9yS2Il0ossvKyhASEiLJjivXORPnAFB8ci26dWJgCeyK8ztWg+zbCf+J8xDdtw0AWO2Lum0o2vfthpyTaxF85wdSgivsSSeoR296SWU1ks+WAyiHuSMgPwv294qNwBUM1RTjeFISSU1NxUMz7kd0dDTmzZkDgG3lXrp8OVm9Zg1yc3PrXFetJ0RsnigAXog72+doP0dhYSHyC/IxaMgYvvdMDD8fBm0C/XAuuwzXrhYiIqJ9o340ptIQePlm86LQD16AVg2Tb9PaC2BMkAtSncWCGnFtc2LNcaUCqCKKRrPX3OMPAKZPm4b169aiWkdqxLg1Gp0ZPt6sQJ85Y3qTiPT2LfxwvMuT8JcHsBU3QzEsytremiRzFfzbB+CnX/aSanMVnnjgbsaZvcWar+yfcB1AG+D3Vy4QANi0WHw+7/ieChgIUFxgQEwnb2zfsRO5OTn45NNPcK24BK/938sAgIULFuBGBRyKcwDw8ybYecCCDoHF6FhViGkz58IUZcT/rp9A9O8bMXr2d2jbNhJbf9+Cffv2EVed9TEKXyihZbvNa9Ivo/CFUm5CU1NpYB9FZ7JY/bL7LfBRNn4vPzfHPDo6GhUVFVCpVOjRowfhRjGo1WqoVCpUVFQgOjoaiYmJJC6ut9156A1RHnEsSyoVzjsnF65oUakxky2fsSMm7n3WT9Izv/VYBcYO6sT/T0m7iN49u0ImY00fO5WGfn168cc7IhtAp0Z7J289VoExiR3AyOR8+BLiuqGk2hf6L4BrtySy4hyAWemHG32cN55wvhAAYLyCfU5lTjYMHaLrHG+OaLSyBjnXEd9//x2Ec9BLNCENVrm2HVGStP4bq+Mt5GZM+/AZ64Y/gw5vPz4cMhmDI49vwazJt9fGgcEIP6UXNAZjnXvp9BZs/+Ovhm+YdBC+VZsOOP1PofznBHpZWZnofke961bnaWo/+KkfG8mGFwMYABgybBi2/fZbnfvYux+H1OumflxlU4CID8vSXsqGom8iUJmJnG27EeUPZKxfjqjb1kJmsy+6bxugTQwsSeddqgPWR6RXqEtgNFlXFjlRbivOAcBoMqFCXWLX3pbt2/F/r76GmTOmM3PmzCXHk5JIdnY2fH39SIcOUfjzzz3IzcmBr68fAYCKqmqcztIjIVohmlQ+nzQPH74xz6UE9+2SJVho51hRXi469BwAs0mHyiqgskoLAEhNSUFBYd15zd2iO6AoL7dRBTonBklFJb/vy9Mza0/wvQ2Hl/9hlf4c9iiL2JPLA2DxZ2AqZRuglki0V0UUMNukfKGYFvoyYGRyp74NPG2v2cdfdRWWr/iupmJihkYn/jyccF+6fHmTZNoFNzVAF+DeCbfXOWY7BHD11t8d2jJW3UTBTQ0K2ppx6PnOkCmUVu+Xq/jzefCHGQ7tcUPcAWD82DvQShWMX3/9DUePHEFFRQXf69tKJUeFjh0SP2ug+LxJXx8ZMk7tQf+plRjV52FcDg7DngsEQGuk6tfgDhPbmzegXz8cP3kSI0aMcNpAeV1djlOnTjqdux3Xuzd8fX1JK1Vwo3uzZwgA7ypAHwBvbyP00NfZbgIfmTh8+BCio6MRV9NDnpOdDbVajaioKAQHq3D48CGEhIQgIiISIaEhyMnOxuHDhxqtPOL48O9isi+9CkHPnOS/+33pVdjznR79xilxcqcBJ3cZSb+xXk4jUV1t4ufBmglg4Oa+EgI5w6BUZ+ZHFZmbQLaqq00gkIFYCB8+i4UgRKnFNQAtTp4Gar4TuUGDlqdTHYp025GI/zfjXqKsmbbG/briC+CbieOtYmVGy9A6+ziEc9vrg61g9dS5jvD0HHRbp3MlmhAoLMV1nL9t/mS+pDgzVRogkzEw1iRSWzFu+184tauksrrB0zEXPu5bcwQXHi7MjRE+CqVZCXRnYtkdpn5cRTa8GMCMGXs3ytVqHDp4EGrBMD21kyF7Uq6rK87tYzm/G0AiACC632gcSzqKgYMG80Pcuyfeh8MHt2PgoNp5Ptq0DQBcyniFIh2cYzjGwxWsEqJ1es7iRYv4m3K9GufPn7c9B4sXLUJhiYms+MOAx+7wtusxPcS7AkYzwYpftiLQXI1KOdsTZW973v13Ogzfxewc9Izrx/+PioqA2WRGRUUFv82LlMKrULbsgbPHd2HAoEGN+tHIqgkgD4DZXMXve+6REbxI5X6JxYzPfzzosj2zuQry6gBAVmubE0yO7JkqDXWEs6gos8jhBTOMFjl/TWPYa+7xBwDz5szB71u3ImnT43bzQG7kzrw5cxpVpN/QypCdk4fyimpUVrA9vbfddhvOnKnrjCs+vjf+3HfUqb2CmxqUV1RDjhZQeinw6fprSD5bjncei8YbK7LxzmPR+GTFr4jpNQzPTmsDeVELu/b2JVVgRN9AyORsxG/a8hv+98NKDBk2DI88/gTefv0VlJWW8ZUw7nx7EMYHo0Z0R/mpZMTMikdGyXcAHsORX7PRTXsL26hXlIf4+Hj88ovzpfEuZudg5ozp+Pabr3mRaY+01FQsev89rFm3odHyFy69FZRqofBWAjBArwWAutt5N0mDldNOw1nK3pNrqLdtsC8vVyMkNMRpQ76nyyMAyLupIclpZbjwXizaBfoyALBwby6JKg4BbgCD7vXCyZ0G5F00ot9YL6fPalCX40TKWZTqzAj1kaNUZ8YfyWeszhH+v1Hl26jvwlH4egNQQAeAnXcedvwEvAwal+yHV+iBNu6Hb/roO+o2Itb0xisF/mr+l5nJbycmJhJ3HclxglU4DNwT57olOusxB10o+Ku1euiMino7nbNYCORMraDV6S3w8ZbV8bMiRGyaV0PBlQslldX47H/brY45+0+h/KcEuj2xfDwpiQQFBbl1M64HPSGuG5MQt4jf36NHD0m5gJTrNrwYwLgi0nXXdfBp5YOYqYmImZoI3fVahxOdJvVAp0k9rPa5CT8nnWEYp97bheh1OpQQLcIlnusMMyFE7qR1YGcGyLl0I56928vpcmYWkwH+8gDcd+9YMDI51v96sM62CUrs/GMnqlyIxvbh7WA2mTFxwmgMu+02zHhgMoKCghAcrAIADB4yBIm3DmmSj8bL0hJG2Q3Ia4YYV6hLYDDUzs0zmGqjzNGIBnv2uH36GoFZpTFItkcsrFD2krG/jkS1FDxtr7nH39Lly1FWVoY3PtqOSg1rINDPwm/zFYQ3xzVZDzofT2YFQkJCcGjvHngFtsCtAxPw17EUGCtv4q333wcApz4peFEVVAzAWnxnG85Co2Bznoyzh2Cx3O/QxqAasW0xWwDI+fXkFy5YgKLiEpSVlSGud28QBrheZubPt/t8BLj7rqH46atkGOW+OOYbA2gBb81FTLylO7x9ap8tJNT5NKmq6iro9XqUlZUhJzvbqVg2GE0oKGx8p1/ffvLuP6oSIcyXXcWT5dHVSi3p+W4GNj4eyYtzAHhqYCt8PUmPuX/y887JyZ0GScPcywyBSIiLqW2EOn4WIwb0qvPfaJHDHwaknTvYqHFvL3zXytk871q/W/ljJQP6N3raUOZkS94vdCBXH5HebCrXHpqDLmeUACz1tjNo+praem+NKBdzgtpUCMM3Z3ptw87ytX9gzvQ7+LD+tGkPHpw8ig/vpu17qZKj/LcEeu/evZGamoo5c+YSrnU7I+MS+fSrrzBp8hRJxtXq2tba3e+1arTMdsOLAcyY164LcpoA8cpBRD9epBdu/86hzU6PPA1yLYO/xkWsnMVJ7T036stRrWPPLcw9AQAIC/RHSWU1/2tVoTWx19ijWk/Ih1v1mD5ERrq2VTJix7/ZpkNxpQKLZnpB6aVwGtAqkwJKVTC2/bEXJp9Wdrfh04pfGsMe7dq2wbVKDdoE1lacVq/9GTOn34/Va3+2OreySovKKi3atW3TJB8OJwq9LC2tRKXZZIZcIXfohVmKPat0KtFWtaaSF8qOBDMroGqvaSx7zT3+AGDuY49i1Y8/ssus6dkhdKWV1hUYzot7Y/egW4ki5MBAgDXrN8HLyxuXL9d69O6RcAvWrN/kkj3/An9YGBkulaci21CJ3KKWKDmdj0NHq1BcqsRbr46CnAFy5I7nbG49ZsZjd7DD5IODVcjNzUVGxiUcOrKfFRSlZZAzDFoGATcqgC3pRjw1VLwYClQSjBjQC4eio3EpNRlt5deQemIeJj01Aw+2GwKDzIzQlu2RdeECYmN7SiiP1KiqquKHZUs5tykcsR06KE3kDbvttiZJe1xjSHm5Gjk5tXPEc3JyER0dzYt1Zw35niyPTuZWkuGfXgQATPkuD+deDyCRLfyYD/8uJp3/DsSFjKv4v9EgFzJqp0oV5/mT1pGOh7kr5UUgFjMMZgXvm0BvrJmXLTdBXW2q+W+BXt7478Je+AK8gJu/7cXev//C4N4JMJt08FbIsGxjCr588z6X62JnvX3QS98w3rI53zScILcnzue8/AUxyVrzwldse/mHzzCch3MpPeO250q9h60d2zno3DronqQ+9qo1lfhz5TQYjXrcMmeNJDHOTeWSMjqzvoiFjxPkJUTLO23192FQQrRWYW+M8FEozUqgb9iwgVm0ZAlZ9eOP/Jyw6OhoPDBtOlz1mOtMnHOFvLCwl4Kj63a/18pGpItUchP6w5C1D379+0DZOgIt+4+FT6+XrDOpsx/BkLUPuus6GLKzEZTgUiu08P4uF4rlVQa0bROC9LXsWs8Wk8FqTiixmCFTKPlhwTIZe409jpwz4lhaBS7m+eGd6bCqFGVk6ck7vxoRHuqNRTMZSeIcAJia+W1jRo4BQ3T4PSnDanv4iDHwBrvtjK5du2H7zh0IHzIGJpMBCoUSIcH+WL32ZwQHh0AG9tksUEKjI0g6shsTxo1v1A/m3MFjNntuwKhvZyUCuW2TyeCwwcSePbsFtAR7toLZEQaJjeWetNec40+tVmPxRx/zlQN7Xtz9fdhsc9GSJU2WcReoA6Fk2FXZbePdQGozGykjEACgICQIcoaB8kYFAAbfrGLnDq87dRQlmfnoG+EHRsY4Fed3DZRDp7fAy0+OZ555AbNnz8KkSRMxdOgwhISEID+frYwr5HJsPWbAvQPtDzPm8rR7J0zAvqNHMX3GY3j4tocAvR5GhRJejAXGypv49Kuv0DshwXl5cSUbeYU3kZOTK6msySu8yQ/nbmxWrlwluv/FF59BREQk8vPzGj1sKpUK2dnZyBaMPoiP720lrLjjKpWKdxrXGOVRv6hApuKLuo3nD7YLxRc7q/FTZjcE+skZQIUtn2vImo9zkLTFiHufdTzMvbLCF1sOWa+zvP3oadH/BnW55O/NUzgKn0FdDn95AFLOXapt9PJx3QHi++d2oZ2yE7YZstBO6ZoDPOHQdanY6zk3yVpjwTP38v8/+WwpXnhuntV/ru4qddi62LlS7mHLvDlzJNWX7Hldt51LLup0rp498sIOEtuyTcwhamMjDN8Ha36zOvbpxm1W/5f//jtVb5T/rkAHgIULFjALFyyoR+FBkPRl6yYbprT7vVbMoKeL7cqGdl2m4sIvJxAXXYa28eEoOrELLQFYWo+Hj1cLGAp+wo0Tu9A2PhwwpuFiugVdHpvuqjh3+/lHDu6M+Qu/dPkae4zpq2QqSrzID4c1ePobDT59OJh06aDEr/vU+OGwEZHtgvHOdAWUXtInyFcZAZW/AkdT2EqC7fbxM7XbOicV/DbtwhHgHwCtthxGUyCUCgMsUCI4WAkZ2G1OaJlNOrQIa4E27cIbLT0lPrtZ9AF+fWcpMdl40DeaGKev3p69l99ZSp6bc5+1sHRir2PfeSQ7MwPbtx3A2b++hcVsgYEASsa+cO4/dD5qriFXTi1lGtJec48/QZ7HO6K0V2nhKjcLFyxoVJFeVq4BWvvyS6AJhXjpjQL+N7JTZ0kNJrb2LBaCaq0FbauUeOjhfnhxYQ5KTufjrRdnwERkcDZjd8IAdgm61QdNeHQUQUxMFyQnJ4uee7nYyJ9vDy85AzMh6HvrrajU6bBj+0b07dkTnXsmgJhKcTmnED+sWo3gYBW2/fYb2oe3JzNnTHf4ko2VNxEf3xtxcU7moKelwlh5s9HLrLJSdnWSSq0Wz86fg7i43pj75HO8c7KmhFvn/Pbbb0NQUBC2bt0GrfY8Y+/4mTOpVscbozwSUpxnJF88Wo17n/OvEecs3e+UAx8DJ3cacNvDIKHBjpdcu2NgLL/9x7F0q/+///EX7ryjdhj5J8t+a/T3Yi98ROGNP5NOY1hiT/jUzO9963PX5u5yjtvGjRtHdu6+4PJ7sHX8Vp+h62F+ZfAXrF4QHKCs818ovKXaFZ4rZtPePaRi2wAw6IEn4efLNnoHQQ6VSEg97XSOq6tJEeT2nKM2NMLwzbnzTuj07Iopy3//HQ+OHscf++nPnZgy9A74+cih0Zmx9pfNVMlR/jsC3dfXrwWASrDuz3VGIztB1MtLGa7Vaq76+vp5AQjRajXXHRmXKs61Wg0j/JWKlOschSGgexzTbeIocmX7d4i64xa0jQ+HJmsfbtQMd1e2jkDb+HDI5QG4snMvuk18HIHO10AXivN6ifcpE8czUyZa75v0wtdkQNcuAIDjmZcke/HkuG90CHPTpCdrd6vx2Bdqfn9sdxU+m62Es+VrbPH39UZst24eSYxecoYZN3YM+WXTJtySeBsCoiKAmt5UTpzLFXLcKC7F38kHcd/kyfBqCnfGNpRXcQLQGsaicTiiwZP2sjMz+N+n3/xZ0n2E1zS0veYefxyLliyBWq1GtY7wFRWuIsDh4y2HWq1u0h50gB29QhTe+O7rj/HOW2+zInnCnXjjrTfx+PwX+dEtUjGZzdj391WE9YnA7XFsw1dYnwg8OC4MgAVm4nh4u86owN4UM0YmMLhRAVQbDOjUxgtyhkFhiQmtVKwYz75utDr/iXF1i6GO0V2wfcfOOvv3HT2KLdtZkRGsUvHewuPieuPbb74GALsivbxcjevqcpw5k+rUIWlOTi6uq8tRXq5umnerq7RqVGhOk3HLysocOqdzdrwhyyOOjCw9eW1YFgDgg8eApX91Ia0jvRiu9xwALmRcxaOxwJaCGLt2hD3iWpMSBnU5P8LHANYHgnD0T6WucddIdxQ+rVEPg7ocPhbC73OnB7254OUdDB/B8qti/z2BJ+8hHEIPAAgfXOccdSNM+67WWkAMbKOA4VqVS4Lc9vzGCB/XgKDTm2G4VmUVRi48TdWQQKE0qUDXajVc14EeABQKBbf/as2vEezquP94AuNfZsIBkr5tD0LbmtA2Phwdo9n1Ps3mKmjybiA7vZgV5/EvuyPO65X9jpjybp3r/8w7bvf4vo2vOw3jE+O8GT8LQ5ZuqoQiKKBelSGVnwxh/n4eex9hYWHMfZMnk182bcLfycCwIcPRunUoGIUvrhUW8nNZ75s8GWFhYc2m3vr+F6ub1F501xhkZ2YgumsMVi6eKileDuw5RLhrGtpec48/AChXq7F40SKs+vFHqx4G24pAaY0DpoULFuCVhQsbLY2RFjE4fOQQfFu3BOc1kjHpMWfuU5gz9ykbta2XZO9EZga0xTdQ2hlQeilwad9zXGMZMvc8zd5DJq/xAMyg1IHPtL0pBCMT2KSy9Rgr1LOuGfn92dctVucIt22JienCxMR0kRQvq9esJTu2/+5UpFdUVODo0SN45tln8MyzL+Lhr8xQ+9+Aqpr1W8Btr5hjwDfffoOjR49IXlLUkwQFBaFS4PBTuM3N63bXUWt94HrHOQ/4UVFR8PX1I1wDOXecW2bN9nhjlEd8+unkzYgJ73uf9WPufda1/InrFa/UKRDoY8Kpr3ch0MfEi/FT53exlaXqInj7t2309+I8fNvrFT5u3fNx48YRV5ZY8zQhIRr4KNhGQovZgpAQDZQM+FUjQkI09b5HqzZe/D04m/W5h+0QentD3KVQ3znt73xZO3pixapfml1d3FH4bHvJaa855b+ASx7F/81UXUgjVy9tQEXKCRRcOI0ofwtyfWMQM2oY2nWZioDuccy/7ZkziwykrNKCgV193Hq2RUuWEFedKAWrVFi4YIFz53PV1eRSVgHOpZ3kPSm3D2+PnnH90KVTewT4+zM01VI8ySsLF5Ky0jKsWrVK0vmzZs1CSGiI1XJRjcXTb/9CuEq4s18pTqF8p9yQXBBoN7Zk7OUnAPDbUTPuHsz2lkvZFnMQ5iqcSA8OViE/P8/hWs1Lly8n8+bMsdpntikHv/vuO8nzSj2F0Iu1KzSWt+vExESiVqsRXdOAzc01F85Bd3S8ocsjKyHePkNyXG4piKFliQSR7o44F0vT7qbXpcuXk0cffRwA639n5Q8rYfu/vt9sQ99D6hx0qeugUygUKtApFAqFQmm2rF6zlqxftxYPTJsOR3PRN27aTG6WOJ5f3iKshcvOUCkUCoVCoVCoQKdQKBQKhUKhUCgUCuVfgoxGAYVCoVAoFAqFQqFQKFSgUygUCoVCoVAoFAqFQqECnUKhUCgUyn+FqMVyOq+PQqFQKM0aBY0CCoXSmKRl5BKtttzhOZ07hDerZfT+rdyyKJ38vTC2QeJZf7OYAIB3i9Zu2d+VlEJCfeSSzy/VmTF2UAJNMxSH4vyjafcharGc5L5idppWkk4Vkgqd9BVlg3xaYVDf8EZPg5lFBnLmbDUAYFDfQISHKTwThnP7CYkZBkYmt7JXXpROgtvazzemflxFbsoMkm/z7QMBklZzyMy+Ts5c8oLGYESfDjLE9Wzh9nOu//ME8QpsDWNlMbwCnS9hZqwsxgOj+zPuvJvf95dg8u2BiGoXUO/34uvr51YDk7PlDhsqvBQKpZkK9D/Sr5O/0nKdnndrXBTuiG3lMDM4npREckvUrhXIYSoMGDSojt0315+oVyv62w9YZ9T/NXtihYTUAsAeryxc6FYYm2KZq+ZMStpFUpif5fS8Vqpg0W+jzjdXdA1Q+tT7m+MoLCvFiAG9UGlgT9FbrCtyqWkXcPxCHgZ0B3Ek0sOfu+FWein8THyZsA6ps92yl9N7pZW9jdt2WNsx6KziT6Pzhp+P3u7/KRPHO1+G8EIaSV+9HhHbdyC9xiN5bFgL5E8Yj9iZD7i0LOQti9LJ19Mise34NZwtM6OohF33vW2YHL1C5Jg4oA36RQW6/I2ZFy9mNz7+zO203D+hF7+dcfkqenYNr9UOmYWI6dyO///z3pOSbG7fsZP4+nhDq6uJc8YXvt4WaPUy+HpbUFqtg6/CDxPG3U7zlX8QH3/3vd3v9/o1I35WzsdH0+6D2XcnOJH+VOhy/pwXH3+UsW0giu3WDW1DatOYl5yB0Uzs/i8q02JXUgoRayiyWAgpKCpD/jUtAr29HT5LpV6PlqFeiI5sCS+54/Xgd58ykB8PGNAt0hdVVXJsSdPhnelK4onlC81/b4M86wSquo0lAOAX1Qma3Cwwmz4E7n6EoOdw0XscKdSiR4S0xrXz+WaUVVqAto4bSt5/6yRkbc247ZbWUCgV+GJNNorSfcl9cxLx0IRWLj9rjw6dENspBPsv+KB/+wAEBvjWOUent+Cv7BIM794S+y/4uBWHV64Ce87L4e9ThbmTAuqdzutbz2rs8NaHqupqotfpYDFWoFzDpqdgPzN8A1vRpXYpVKDXl7/ScnHnrd2Rp2AQaSJ2f3//6wLuiG3l0FZuiRpTJo6XXrgQgi2/78QA+6KTE6/8dk1BCpPZDKNFDovZAgMBvtx2Gs+Mi0WVEVi5J73R7XXqGOfwWbOupLllL+tKmt1tR/a4QsLX149otRrG3VZdKWL7eFIS2bJ9Oz54/wPIZNaVFXdFfX3hlnRyhjtrx9aXy5nncOvtdzk9b/+unzFg0CDH31zRNUyZPMml+2/ctkP0m9O8+BxJ2vAzeoe1ALfIVbpguaugBx9EwBPzUVVyFVMmjseupBTEdwZp29q+SC/8rKVLYQt/7oYzse2SvQ6ps+s+p84bM6aMAEMAwgAWCyATTCbi9gv/mwkgZ4DVm/Y5vaf66y+JZsX3iACgGjUC/Tuw604rc7KB7TtQsX0HTI89SlTzn5aU9uK7RuGVzQZ0jmqL2PbAkD7+AIDS69W4rgXmr8vF3F4tiSuV4KoLaaRiD/sslgtpxJUGg8Ygpmc8FAol5Ao5zCa2QYLb3r1rGwbenojtO3aSCePHOQ33KwsXksWLFtk9np9fgL+PHcP/fljpMD+YM2euW3nZ8uXLmIa01VA2GyKMLz7+aJ19GRmXMHZbd16cA+BF+kvr5iD3FTM+/u77ut9ZtQltQ3zxxoE8yWF7a2Q4kk6bRI8VFJVhf4oJ3sqr0BuiAAB+Si8E+llYUa6pzSTMuIrCks7QVZcgrmcLu/fLLDKQz39V4+1ZQRjY1QdmQrDnNMEbaw345GEZcbcnvepCGvE9+gNMZw4gTZ+HmD3r4PXRX5D5+jMBF3eRlNwdiFl2Ft5zP7Mr0vc+HyrpXiM/LXV4fNfREvLVkpNYunwEotoFMAajiVRpDAidMZApLdeQWS/thlodTp6dMVDysxqMJnI+JwuXS1rjSrkcqfllAMrsN5hU5MNYWQxj95bEWYOJkGo9IekXShBgKkfulWxUakaTQD95vfJCqXUtd4R8Q4TXHdQl+eT69auQebdFi2AGci8FItuwDSTFJXqUF5fAoj9HuvYYSEU6hQr0+pCnYBBerUCev8nur7RcVQczIfjlK7YQlt+tQVgVKzrX505ASb7F6vRNj3Vje6/sYLEQyGQML+blDAOLpTbvs5it7elkDADSJPbK9Ran0eOKPY7ishJ0qtm+qfXjt6XYq29hIAWjmZB9R48iLTUVJ1LOYmDfuCb/aJYuX05+37rVM2L6Sh7Jzb6EESNG8PG3b98+Eh8fbzXEW2yfI0qKCz32vBYLweClf+Kp++5zeu79YWq731zShp8RG2Zd2YwNa8GL9IqffkLAE/Nxo9qIb9f/BgDIzsvFEw/c3Sjv9UZBCdC7/tdUm6tgsQCf7bkqes1zo9rhsz+viu6vNlc5FecnFi/GgAGJ8OoYCeOVPDBXWAFhrBHsxit5OL54MfoDkkR61yh/dI1iRfmR0xdRlFrbg946rD1G9o7CstRcAJAk0i0WQsz/9zb8O3Vh88L/exuWTZuIbeOa00patQkZl2vjqbqyBMdOlQAArpToUXzdAs2NHPiEtIfZpINBXS7ZdllJXVGgN1ngragVSR2ju2D7zgNEak96YmKi6P6f1knLKxwJT0+K2OZisyHCaCv4qvRFKGLirMQ5L4Jre9Ih7Em3SssmdnRPVNv2aKXS4rra1+5vblEBTHr7vcbpOblQqw3wYXpAR85DpYpGz/Y3ERbQAeXmMhiMOuRf90FusRE+3lFgNKdw2hCHuJ72n/XKVSCyXTAGdvUGAEbOMBjTV0muFBO88D8dPnnYxy2RHtA9joFpIkk79hNbUYy/HTJftsdSHxiFTlHjoQfgbUec83Ww5DwM6NICkS38JO0Xo1O4GWvWjML5y2WYN2cfAQBZWzMAkAl33Iot30zEhYtql55P6aVgQsOjyODOLfHNgavIKbVfv+oQKsPYPhHYdRpwRZwDwMY9N5B8thyFuSeQlqNF3NHTeGB0f0lC216dqiF70Lnw6kozsDnnplV4G4OSkhJScv0ywlp1RufOsQAAk1HLVv+JH/5UE1RdDcKoDlUIa9MRKSf+JAn9R1ORTqEC3R1CzBaPnqc166FiukM5Qg5UASUBJ3BXyIMoD26HnbiK6Kgu8NWwFU2LE5NvfrcfsuAgbD+Rg+0ncpzeW3iOsIe8MezBw/aeEfTIaw1V8FUGwKzLh9bQBr7KgDrPIGZPyOdrjknuDXGlpfva1UKUq9nCd//eXegT34u4Wkh6kmOn0ggA/LJxIwL8/ZmNmzYTAJgyeRIDsL1Cjzz+BAb2dd5juHT5cvL8s88BAN54603y+KOPYsKECThzJpUriFFSUkJs90nBx9fXI8+r0+nAwIKzPr0g146D2XcnDvxu/WHdfqeg58eFPrF2qWm42rtug8uwoWxaCwkKRWraBaeNB7aNTrVhYRvJzIQNlJRkYzQTVJAK9E1/nhXfAF6NmYsFHe5Ap7RH+X1HbvsYvf06ORaBCpNbx+xRdSGNaFZ8jwEDWCFo6BANJQBjjUD36hgJQ4doMFfyMGBAIqpXfA/FyNvs9l5XVVcTgO0p5ygqMeO2ijUYNuE+FJeF48T1XOzNZHvZl53NRXxXBYnvGuowIk8m/4X2WZegGjWCFdp79uHlV77EOd1UEhHpjz49yzGsYxgGdvVxaEflr7Aawp5xGejZNRyfrzmGe8f0QoifN46mpEFdcB33j+yHC9cqpFfQfeoOMVYCUHoHwMfHB8eSD3AnSms7Nprw07qtqJD5QtaiGLLCUFjCSxFwPQgywk5xKCsrc2hj3qlKu1/P0r6uTTFwZmvq1Kmixzds2GB/XrGDa9wJe2JiIgGA5ORkh9dzNoTnOzq3c5QSANDCF2gf1R37f9uEl9ZNBgB8NO0+HFVvxGDVFLy07hcAv9jtQQcAE5S4YdQjzHwDrcAO972uZvPWj39LAgDMum0k21hn1EOv09oNV3FZOAouXUGbqLMI8O6FW2N10FWH4HReBQA5gnyN6BmlBeCL05laaHRd0LVFGoCRdm326iDD57+WIiMrGDGd2DT95i9sA2mfKDle+J8O38zzJWH+bvSC9hzOdCwZTnzmT0H1X9vhfbOYeLdozXgl3gnv4VMZ/c1iUuVgdExJtRnTlp7GK3fG4p0pXfDGxkuIa++N2+PCrfY7bUCMbsUYjCby67Z8vhcdYOejL1m+HzptNFq3kiH9arZoGhrZtztahtVNgwE6I99pUoJA+wId1XU6VyQ3dITp8OlTrfD2V154ZtZQfL/xGC943RXaDTkHvTa8Z/DBs3dYhbfBG8ivZZNyjRydO8fCZNSiosI2v9Thcr4SMj+CyzozfBUWtI/oghvXsknLNtFUpFOoQHcVQ4v2iDQR7L/CVmzzbhbA0KI9LgOIkF3FIUs7dO4VLFksKIkCP+pS8Tj6IHzfJfT4Ph257x1Gh+GdazMiP7aiSSxm6HQ6O4VlCb6ZdwcvbB+6ewKUjAYGUrdF96mhvuj7/EbcP34cAODnHTvrZQ8AfvxtO059OgUA0Pf5jU7tPX7PcBiIn12brtrTGtieutIyLWvPUIXSMi0v2AE4tGdHeLMVlx+S8OIjg3gBBQAmM9srpzdKz0ctFkIOHjqEWTMfwTvZr+PIoUOYMW06IiLaN9kHU6W+gZkzZvDzny5nXUb7cDY8RcUlJD8/D7HdO0lqKX7+2efw3YoVmDljOnPsVBr57vvvERUVheTkZGbfPranQGyfJIGuFP+0DySdxo5LlTibk4G4rufRIimGOHOsZSKsAJ+95xM8wGy3EuUHfrfgwO8WPDc2wOo7lSg4WRG34Wd+X6B3CCr1ZZKur7Tkokwbiuj/S0FkoBJp77DzlVXPneL/m0HQ+/WzyKs0oOzzvqi05AKwPyzeIjcjAP7IjFmOrpjDC3ITY+bPOXLbx+jq3R5as96uHWIxw6Axu3xMo7UftvTV6xFRs+3VMRJ+j80BvL2h/vpLAIDf/Kfhp9dDk5PNi/b01esx8H3xUSfpF7IAyLE31dpHyMGgGXimcxuYDFoMNgZi+19FOFRSgADvtvj1VBbiu9ofumoxVpHy+6eg59T7a4X2qBGYvG4JEv6YD41Whsxc4PQ2Ex663UDG9HV9nuyt0Sas3JOO2aNiMXZQAnYlpUiaf15UXEIAtmecL590eih9vKH0rk2/twwcCCJj89hLF1Ikhan42jX4KgCZUQcUK+HtqwFKffD3qSOA0gc3qo2S7HyXr6yz7/EIg1t5lSNbjoS4PZxd42rYbYW22PVCG86EOUd3bTrad2oLv+BIAMBD99yD8ef+wBtX7qhz7l+P6R3a0uu0YKoILBoGlzXVAKoh82P/A8DvU/vhzg17ce+Q3mCqHGfPanU22zina4/RAwzIKpQjI9eAsGA5WqvkOHshEIUlZsR3MeJ0JqAvLsINH8cNreFhCjwy1AvP/68cnz4cTGI6eTNPj/fCk0u1CA/1RnioAk8u1WLFE75OhypbtNVElnUMwiHr8g/ehHf3OMZ7+FT+PK4nXff4E+xzDR8mOlInzF+O96b1x6qjJYhrn4fFv6fjlTtjceD8BfTp0QWP3h4uvUHNS8F8/PYtSDt3k0x460/SOtSAEO8OGNqnBfrGt4fSy0v0ulOXnPs/qqrUwFBVaf+E0EC36wuTEyMZAFAbb5K4mCjmyzej6l0Hacge9IYIrxRKSkpIuUaOyDa+dYS50VjbmJ3YVoZQBRBkIWAMFQDjh7Ky62jZJpqqOQoV6K6ivFmAPEUsImRXazxgCjPl8Jqe12CUyaWt+OZVU8Z8t+M0Hv1iP2LDWiB33o+Q/dkCHbvH4MoFoCTfgrZhcjAyx05KhL1rAOoIX62xttX01KdT8OG+arftPTXU1+n1juxxtoQ2heFz154wrKEhvnYbFJy15JoMJo+nHTMBCgoLMG7sGIyfcCfWr1uLg4cOYfq0aS4Pl/UUwqHoAJCakoLhI8cCADLOnUFQUJAk5yX7DxzEXXdNxMwZ0xkAGNg3jtm/dxcJDlbVuY/YPqfvxqduhWXnvmNYvOcYQkZPwG1jRsIrcwvePXMdQIpDkc4N8wSAzbsWY9LYVxBvYtNJ/Fj754qKwprh7IOm3g98/z9YHn0YsXv28fvTL15EqI8cpTozQuKcz2EM8pFhRGwA9qVXoUxrQfZNdoRBXqUBl4uN/PaI2ACnI2rMh4tgvKMmHTPAls4LMaTgRbyfsQzfVWzEjYISvBozF129pTUQVeiNLqUtYjE7PH7ybBov0I1X8qCvVMPbuzVU85+uFRSVal6c+3fqgpNn0zDQjr287Et4MkKHkNB2VvvXrFqOa8Vv11aKeviidUklfskB0iodV1Yrlv9QZxoDwE5lCFr3GlKmvYf47r5I7aDBjwcMCAm0EHs96cIh7mdzrqL4ugVnc66iY1ggbok04+M9G/H5/bMwvF8MXtqyAX3l4Q7FOTesfVdKAMYmVFlte3vJ4OPHNhT7+LZFVaUaCoWy1pGcDQMfyiLHfuzEAEBaairmzHkcZWVlCAkJYUWYzTYAFBviHYv8gmsAIsX393VNJDiz5ekedHfCLuwRP752N/xixf1hHD+cBPSdAik96MRixvJDexFXdB7joh5C4pChAICUq1fEGzIdDOIovl7Tu6qUQdjPaxHRRxYNgxKlzOq6Og2dBhNy9GEY2Zrt6f79WBXCQ+TwU/qgUgPAR4ODZ/UAgtCnqxwrM1VArtrZq2buGx1CgDI89oUan84PJgO7+uCbeb6YvqgEHUO0CGWAx74Nw6pnfIjSy8Fwd6U39MueY+eVZ52APjAKAcOnMmKNcGt/3ooRWZeQXnKT9TciyIOEdAw2IzPvCq6Us72wrBNK9piU4e22DfZ/Hr+IzV+Nh7e3N5N0qpD8ui0f/ft5Yf/punH+8IQQnLrkoMHOYEZ3Atw0+qCyyt+BgC+BgbBe3MXSuBRUXi0c1p9cEeENOQfdUXgbVKBfv4wOUR2h0eqsBLlV8iQaxCnZ8r24ogqZJAkRzCBUV5WDQqEC3Q0MLdo7LLTK5DKXsrzSmhFkk+43I0Qbi/Tv0pHZJwGPRsQg79Q1dI8bjPNR/jh59KJTsSDsGbYVuy/d7lNH4L88wh+v7axyy551xZ3UOd+ZvR9/2+40blyxJwyfVlMKeKlQWqa12u/MnrAAKDfosGT5H6gibJISbtvy7twRkt714YP70blTZ3j7+GDc2DHYsf13rF+3FvdNmQxvJ15wG4P8/AKSm5uLdq1YIXm16Bovpp1xOesyeickWO2bMuUB9IrtjvJyNXnvgw/RuWMkI7ZPUmOMom7j1LZjF+AX2BWty9i4a3NLa0RUZWPXuWsYOyhB8nNvqjqJkca30MvroFvxNmBAIiyPPgzT3oPILKlE7317EPTZ56j46SdEdmAdRQYIRJozUZsYGYh96VU4mVOCnFI5IgOVyKs04MDlSnQIZUXvmB4tnQpgANCjVpBFebfEqzFz8X7GMl6cz4lItDrHfLgIsPFbWVnhC6NFjs8ndhW9h9EiLt6NFjnMRvv5S9fTKfAfUDvPWff4E/BauwoyX7ZyadFW871awmvsodPp0DOuH/+/fTgr1L/9+iN+GwBMJgOAQgy7Xo4N+fa9+upvFpMTixezjS+2Fb5RI5D+009gxrwIEqpCbx8/HGhXid/PVWBg13b2nzm6NRiZHD/vv4DHJidiy+6zQE38J4bFwGQ2g5HJEVzeHgi1X28tKynFrhQ27GMTqhAY6MtvCwW7Kox1Ja1QKOHj6wdfH/v5DCfSPeUIkhSb4ScvqbvfbPa4LU/3oLsTdqHQ1lRmwqtafKSHpjITzoQ5r1ZlcmSHbkMcumDxnmOI63EZky+2RHmFmZ3D4CKV1Wx5WFYlPiqIa5cuq9JhSu5i/PETkBgzDhBpFjv4dzHOFPthwuBQ7Ek1olMbJW7pbkFIiBEWkxHllYCPty8OFVzFhK5t8Pd5LXStr0oJJlNaqSfj4k14+oNCfPl/4RjY1QdrF4bxIt10swDPfumLL56NtDtFTHb+MDL0ecAXkxDjHQmvj/6qGx9nPiRZF1LRgklA0utvov26tQhcu6rueTUjlQZ0aYE+PbrgtXUn8MqdsfjzsgGnz1/Ce9Nqh01X6YsAOB91JpMxDDcyDwBahnqhV2wVDCYFSso1bn1zOh0Bo6vAtVLxUVvemosovrgPWe1mwqDWuv1tr1xct6HDXQHd0F7c7YW3oanUymCxEedKokGFKRhBinIUq6sg824Li74I/teXo7ByH9ARiAgYRJUchQp0d1DeLAAQzAv1+lBVXYUQWW1BeeWhFrhQOQBdIsIAAJGtShGiugagDU4CqDIpUFUtXuEtLdPi4Hv3wkCA0a9vsRLPQd4MXt9dmxm/Ny4AFgvBG7vt94Bz9gDgtte28HaEgpz75QtskfvbCx83vJ6za2tr195dkuxx4YNRDQDIKjGhHwAY1ex2zX5n4RNjwRx2COHry/bhjttrC+DN+1MwaXiCS+/aaCZkz969OHTwID795GNrofn7dpc9izcEBw8dQkhICCIi2jMAkJ5+DiGhIW7b69wxkjmbfoE8PX8u7hx/B86fPy+6TwpeXnWFRcrBdLR5ZQjadAxHRGgS8ksHIRSDUFwwD8CD9t+FyQRNGPuNcXXcB07/CNXa71HdcRVmdcvgh7gbTc5HUvh89y20G36GZsX3KC9ZjMPCb/waW8kv1ZnRJr6N83RikaN3BDtaIDXfiNyrNzCsoxxXTQFIu3QN5e3YBpPbOwfCaHG+7I+O2G/U+65iIx4kfZ3nUzUNU2/8kS16/J07onGzjDi8VpIIGz6MF+cAIPP1Bxk+DMz+Qy6nPU6QT5wwGsNuuw0PzrwfQUFBfIPT4CFDMCyuH/7KzQAQK2rDvHixaO85R2xYC2R+NAvqxWxjY2g3OU7+qgDutdO4W+P0jVjMKA8ugPr6Ddw7phe27D6L1q1kGJbYEzd1tQ0dSpX9qVIhYaEYm1Ar0rkh7ACbz3MiXRUGGI16+AUEwEtmttuDDgDFOVvR4TaQnIPPe6Qym3fhLCDSi5x34SyA7i71ejuzNW7cOFFbjhobHF3j7H5iCHvES66WQXF1heh5JSLn2wujmRAMPxuGE8WB6N46Cdgdik0AKv8uBYbWPT/7pgZh/uI9/CaDCYxShmsFVxDaMRoZV+p+z0oF8JT5FyADmDC0G3xa+UB3PQvH9m4mA0dOEg3nFW05Ms6a0bqrGbdAha//1iPURw6ZuRrelb44dMWMwe2vuFQ9Kyk3YdthPSYO9cbTHxTi7aciMKavEmsXhmHckzl469GWWLn9Bp75PA9fPxdpPQJNryfY/Tn0e9bZCGJFHXFuyNqH3p0HAJdTUKQH+qxfD5m3t933EdnCD6M7K3H6PDC+oxYT2lUCQ1sCyMHxpBwAwJdDAdw4heM3aj3S2i7TeTwpSTTt9Qj3heHGeYzqxv7fmlpbzzRBaddxZKXGTM7mFMNYWYwWvsCrQ+vmPbknvgbkwMTb/XH+1A/IzS9BRs8oEhPTpdnNd579ygbirqhu6HXVpRAS0gol1y/bK1HB1cYt+iJUG1U4E60F0oDQ6p7wbRMOCoUKdDfghDkr1NkP6Y/06+R8SjYMLdpLdg7HoTYwiL1ehQtfAemtAoBWAUjX64H/bYT8bg1KSk6g+sodiAuMhTfsz4Vlh3PXZNZXy6wEb4WeALoKwCeI39d92grcN2saoKtA5dUyp/Y4O++O8eV74t8bx1YOX9tZhcqrZXXOr0/4XLXntDXTib06lZlKg+i22H97lAlasXNz85GWmootgpEDGefO4LXXXsPmTRtx9z33Ei85w5SVljXJh1NVXU2+/eZrTLz7bqvwDx4yxOoce8PdVSoVDh04ICrSd+7cicTERLJv3z4yYsQIRmyfs/DJRKaMjBrRHaZT5xHRrwgDtRnIxyAcX7sbHZhbHDaKGUy1t6v0Da/t3Z7+KILzRmLVxVl4biw7rNpgYuw2inEcjrffWBPQhm0I4O6h0F13+i4Gd24JIA/JeZUoKgHuTVAhrFKDLakGdDFVIjJQifBQL9fer1mHbE0x3s9Yhpbt2TDdKCjB87LN+LS7tMYhV4e4OyOzTwJis9gxm6pRI+BXM6xUf7MYAODdgh3ursnJhrpmibPMPgkYZa+hxMcH1yo1aBNYO9R09dqfMXP6/Vi99mfr/KCKrSJ1CwsSj68LaSR5w8+ived8mh81Al03/Iz008dR3WcA2vsGYFu1/Ty6zBCIlLQMAMDYyDj8/HsSHpw1GeNGsOmnSpDMBg/phcPb9+Lz6xbR5Zbatg5j2rYOA3CJsGK8xEqYA0BAcBi8vQi8vZTQGy0wmByLcwDwlDgH7Pcicz3IrvR6O7PlTq+/o2uc3U8ModC+vuNjp+GR0oMuZxiUBT+A1sFAcdvhKC4COoUpoPc/B+APthHupC/vdy1PwaCfo0YwA1s/4eaXb58xBHqdFkoF23t+OeUgAGDy5N7IPnUNpw4XY/Lk3rhyeCcGjrTOJ/yiGKCYHeadeFsgtqSocfVUJfalVyFQFoUQfy26RJoxrKMc+ZZ2AK6jKEDa6IlXH2kPjS6XF+mPvpOO79+IxR0JciiC2Nz0i5c6494XcvHZ+mt4Ybpg0XFvbwZ3LYD3XQsQM783AQB9m15QrF4A+aOfW4nz0KgB0Fao0bVVKHoMegreDsQ53yA5pQvemdIFx5OSnC7rWSPGRfc7u/Z4UhLKBJ3cnGM3k8hIykA/OdM9DKRvr94o3peCHh26wC+QjSdD5Q1sWfE+Jvb1R/eEIFxIqcA9dyhxIcUfqXsXIzzkeRLcNtal7+eTtUXkheltGVeEsSsCWG286Xa+0xg98s5o2SaakXkFETk0MBpN0Bm9oK2ysxKNPhddih+Gf6dnoS41IbxFCCgUKtAlcjK3kly6eAEXSljv7D7l4WjdSsaL89R8I9onDEREQCEqqwdChypJdqsZOZQKNk/rEhGG7ndrsPlnOR4f34ct5H9Lx70PTwH6AutOpcNgikU1I95rVlqmteoZ/mXVOrv3/WWV83Ps2ftlFZC54XF+f9ep3/HbibNXumzPEa7Yq6jJkyuvlvHbwv3O7IkhXFLu563HrI4J/8e/NNahHWIxkz17duGBadMRGOADPxmgsQDx8fGYePfdWPXjjzh8cD9GjBjRJB9NVXU1eXT2bKjVanTuVOucMC2N9bQ+c8Z05OcXkIOHDmHmjOmiNkaNGovnn32OXz7tck4h8rIvIaFPf4QE+0OtViNA1RIbN20mtvuk4CWrW7G7+66hePfMdVRVZQMBMUhNvwJNZSYmTxltv+BXq0FMWgABsMR4IzivB8pyT0AW2QGWGG8gD9CbnsJbN6vwVou3QUxau99c0IMPouKnnxwK0KBrtcNkvVuHOU9zZgtk8tp56ADwdkRL5JSGIu9oNvLSDZjZ21eyF94qMysYszXFmJT8Hlq2D8OWzgtxXa/GXCzF9rzd6B3QAZPaxjq1Za+XXGdyzyNwv15xSD+dgtiwFjB0iIafXg99pRolI1gJHrZvD7wDVTDUrIueXnIT/SaMt2svqm0bnDp3HOFDxsBkMkChUCI4OASr1/6M4ODaSo/JZIDOJEfK8YMYGCk+HL3i/hkA2KX0nKbNX94B+mxHgbYKvfzt11FNBhNierDxXFWpRnZeLn5atQk9E7pA5a+ATBWOsABflNQ0HgydMBIrf0uCcv1v5IkH7hatdHI96QHBbNoam1CCgOAwtGkVBEYmh05vqRHpBEovf4fPwYnzVxYutPsQaamptQ0OZWUORaa9XmTui3ClB92ZLa432hUR7OgaZ/dzxZ4nhHqdxqFI8Ur8dbWvtVsc2zqHjh06nX49BwAwYc0Rq+Ovq7KhYrpDd12H6L5tEN3X8aifig5mFJWY0XuQFy5VKrC5CAjvHgxAjatGb3QBwdQRKnz6RyUqOphxa5jkKhrz/hNRJDS4CJ/9cg3z7mqJR99JBwBMHBqKO26NhEzG4K1HVXjrezVeEC+WYPYZDvkrryCoRWs+jm3FOQD4DFkEmZd9ca4rK4ByVoHVvm3T2ZEKp98cAebqadHrElaUgWiviR4zmgnOzQ11eN3cse2hCg6El4KgqlLtcNnK4usW7NyXgpKqKuw9eh6KGseq+mr2GVu29caH3xexYT9VjdkTQpHz1wVUmIIR7GL6MytVDSKMNyXnkQGRAVB5tUBaRi75fuMxfPnmfS7ZbYw57VJgl5AVlvntkXm+dnWg6qpytNJsgCIzG5oO9wABA+GlrOadFlIoVKA7Ib2wkBw9UgCfhH64s5sGeQoGajVwoZzNoP5Ky0WnjnHwUVXhBoKB4Cro1AGSe9L1NR6iTaHDIcd2xF6vQknACYRV9YcqrAeO5mdgcEQMK/RMjucM/fp/bOV15Pw12Pv1DIfnCs9JmPc/p/buu28Cv/+1LVfx3r3t8NqWq/z+X37Z7rY90UYEF+2JYdtT7sxenQq12czP873/roFW4lz43xknkv/Gl59/jnfefQ/ePn6QyRkmAICXQsFn1itWrEB8fDxpio/mhedfQGpqKlQqFUaMqm1siIqKwuHDh9CjRw8CAO+8+55dG507RjLPPPsMmTDhTgDAp59/BgDoFcsOB501axYG9o1jTp9MJrb7JNXWRBwkjrwlHsAZ7Dp3DakFaxAB4Kkpz9Q4b7SPzGhmxTiAsjHdELIbKDuyETgClAGQDZmCX7y9gZvAt+0AY5l4tXzg+4sYvL8IG7ftIFMmjkfezdp5g5X6Mgxr1Zr1cG5W1IzecNwDrSsrgIEkACYLxvRoyQv0fh3CEBZQa/v2HoH8aBBdWQHgsM+MFedz85fy//3l3oj2a83/fz9jGYC5dkX6DYvRYYOAPb/lFrMFNyz2n5kZNwGoaeDQrPgeSkFPOQCUjBgF1agR0Aj2MePs5xsDBg1iTp07R3RlBUBY7TBkoTjnK8e6KlRVV2HmDPE1wdulpjFC6f7qt7nkmC4QXYaJj1xoD+DSISMGtrOfRwvn4wcEqhAdGYWQMBPOpVzCJZMvzKVJmHzHQISG13oavm94X6zftA1PPCBus23rMCbj3BkyuFMkvLyUkIWHwmgm4Pxb+3jL4CVnYLEQ6PV6u3PQbXvOFy9aVDf8hMBsYvPDnIJSPPvkQw7TnbNeZFd60J3ZshW5JSUlhK0guyeMpfSAe0JoS7K7fmadfX/s3o2TZ2q2r2v4hcvmxjqe9pJbVIjvx4qP+EndvhAjb+8N3XUdth++yDYEMN2hJhfQKnZanfNbtu2KSK0Z5SolNuap8eCAALS4ZMLFagOuGTS4O0SF/j3CsPN8CYpKzIgMVMLYsocrj868ML0t8fdh8N6qImz+qAf6d/YWLkPJhLbyJ4DargH5K6/AWyDONfufIoayTCtx7nvb52Bkjj3CB2rr9n6aTGzD4aasYOjSZZjZj80jfaPC0LJHJ9w4n2XlZNeqbqLTwUvOYPVJGYb2AKL8LfCNCoOydQQMxfn8dZv3sB0Bfj6chPaF0SQeVHvLvR7bu5l4B9c2zs2eEIrDqQxuFOnQ4dYOOHd4AyKmvyjphSzbfI0MjWfz08zs62T/aQvmTmrjsXRfVeKD57deh65Uicnv/IG3H0lw2UZz6EEX4/KVPMIJc77+n5kNQ3E+0AHIv1qF+Pi+oFCoQJfIjrOALC4KQZAjT8HApzwA/riOHsG1hUJAeyN06gCE6tihRy1bFKJAwhx1Y1kJDCZAVyRDNjYCNZ0Tm3+WA2BbZO8u8cYWpMP/bg2AO+2KBQDQGdnHLzEb+W17SDlHaK9UZ92D+cS6fI/a81T4bG0L9zuzJ6RaU4kqjQFeXt6o1lTWOSaVffv2kfnz5wMA3nj9NdwsuYl5c+bAYiHkwQcfRGpNj1RqaioGDx6MoUOHNfpHM3jIEBw+fAizHnoIocF+fOG24P/exrJvPkNaWipmPfQQvza6PRYvWsTcM/kBAoAX3n36JVr9nzdnDmO7TwpedupPYwcl1DiEexAbN23GFCfiXIyyMd0AdKsVllwjkfdcfOuwz6ym0qdjRU9RLjvnLKBNGDv3vBXrEEwJE2BWQEkU/LkO8a7C5D4qTO5TWzmJbuGH7A8S3Hq/rbxV2NJ5IVAzOKK6Zjk14T7hfjEMBPh+ehcrUc41EtgeE17jiAGDBjG7FjxH0pd8htiwFlbinIPbl15yE6YFz9WZy2nLsCHDsfX3LRgT2AJRURG8oOQr7Ao5bhSXYveu33DXnfdK/0biAnBqtwmlF2UI7VZXBKWdKYei1IQh97S1a0NdYcEH3/wp0mIUgk5KoM+waLyx8U+8MWW0lUjPqHDs1Ver07PiXMbwo37Mgri3WAhkMgZeXkqHc9Ct3p3RhGFDhwjFJ+QMAyjkkuPMkz3Kbtoi7vSguyvEG6IH3d565tevGUWdxNk7HwBefGQQ8/EPSeSvs2frHIsxrMOEod2Qfeoa32ueoZyGYKUPXnzkJdHwyYP1CGp7A2jRBhlVwE8ZwLi4dugPoKWpHDcUwThxvgSHytQoV/khJOgK2ilc9t3DzJ3Uhvh4yzDppfP4/o1YCJcy3Hv0Jvr2sl+uC8V55u//RypSLkDRtRV8K9TwDVKB6feupPKiZOOTjFjZDgBnSnUouwn45rdG/9Ab6A7AL7IllKUGyBkGVYa6dR2TkW24TL4J4DwwtIcM3QG0jQ+HJk/JX+fnEwyNrhyPTR1iVTa7QseefbD3l51o2ZagS0QYVm4vQZz+Blr27obDqQwG3zPVJXvP/4/Nj37d8geefrg7ADa9uOvFXciUUS1RUm5G8tkYTOqSjQmD+7j8vM1hDnqdhofqalJZcgEAcC0zDf5qAu9uHdme8w6AUdUdEQEBcNaoSKFQgS7M3ILNuKJRwMTooQMrzs1MKwDsepS3xkUh9Ww52oR4gQkoh5lpheTzQKKEhuJytRrKABVe+GIFDCbAZNBCofRFUUAZonRsKyWj8IXZZIYMBnj7+KBcrbZr77UfdtRWFp5e4bwC5eQcob2ff932j7Fnb1tKnNRpRDGyFdof1u+12i/8/+Wb99m9fsSIEYyYIzSZjGE2bNhQZ/+cOXMbvRd95ozpjNjQ9YS4bszy5ctcsmUrusVEuCvCHGCHLq9es9bped2iO0j65ohvAEpxXdK9iSLA4TcHADfUOdxz8fvM7drViCO2999bZgbxqj3XIfoAj71bR6LbFV79aU+DpL2xT73E7AJI+hJ2xIWtUzZuuTrTgucw9qmXnKabmJguTKV2LNm96zd4hYRh3OBhaBMeDmLSori4FDuPHoKxrATDR46FK86Rxg4OY4rV18mGvw0ouaZAWBtWqJdeNKPkmgWKUhOm3gI4Wgd90Utjnd7vRrWRvLPxT8wZNhKtW8nwzsY/Mbt/a8cVUh9vmAkgEzRmcULdVrQ78uJu25Bx6PARVBoY+ChkMJoJvOQM5AyD/PwCyIiFX27NHeHpSRHbXGxKsSelZ58X1I8/Knpe1GI58VvflfeD+dG0+5xeIxTpYvvXf7mO+LTywanDxbxAf3euY98gQ9u1wEmBo8pSA4M1J4vQun0bGK9Xo9TAjvppo/QDWmgAtEFQiFt5G/PQhFbET+mFR99Jx2uz2pKEXirsPXoTS7fewF8ru0kyciq7GD26toIp8zrM3XuDiX+5Xu+fE9n3t7qK1BaAtvgGDhcD7Disv6HNLYH5UfHi3FgzIimxJrs7fB64rtdjaM11qnsJSjVyVKjZBuJPlv0GgHU6t3D+XZKWPuUIaxmBS/kl8L18Az1u7YDR4VrkGzsgL6UclwrNmBQmfQWZfv38kV9citQzpxAT5YXenaM8KnD9vRkmtnsY2XNejqiOKjhb676xhba7XM07B/+AYJQVFkCzJRkaAO27dYRR1R3+AcGoLixAQv/RVJxTqEB3hQGRASg4cAnX46LQqioE1e39kHfgGAYPYYed3xHbigGuk/MpZ5AllyHEnI3EIe0xJCrc6ccWrFLh/55/0qXwdOgYLbr/l1fv8ejH/V+zZ4tw3pMjAe6MphDc/zYGDBrESHHGI4VglQoLX37eI98cAOj1euJPzFi0ZIkkWyqVyuHxtvN+92jc3frO9HrbWPbEmAb91sY+9RKzL6YPCdi/F7+eTeOXUsvsk4B+E8ajavhIjJXgSFDYAMToKsnF7Bxs/X0L38ASrFKhfXh7dIsdjAEuNhIBwEMTWjGtVSXkaFolDv7tg22/ytCnrQW3dddh8JgAjB1c/96PmrnmZN/JE8ioKMfs/q2dii6tTo/DB/fzveO+Pt5Ot50KdIbB4Joe9GJDPLw1B/m0+9O6rZBBx6+LTnEO52DTEz1kua+YmSjICQC8tO4Xq/3u2uwYMw6661mYPLm35GvG9G+FHH8lsoz+MF4vgler2vnqXq3aQtisxG0/1dXtKhpz3+gQEhTmj+83XsHqQwx6R5mRtLSL5PXHL+WXoGPMTMR0z0JgPcU5AFRUsavgPPjjmTrHuCHqcoZBqabuqBOucevTlBK71+l0Ory/YHq9wymTK5gFH20iS16ajLRT1egS0R6X8tn7Pv/WWij9pIv9flGBzMnW1WRjxU306hKBmI6tPF42dGwHjOphxtjEQLeuby5z0IVUV5XDPyAYyuBAtBzOOrFVBrPPpy41wd4KCRTKvwmGEM/robybGpJ0Op13EtcjIbpGmFMoFAqFQqH8szm2dzO5krETKqY7Qnt0bK6iQayC1yThXL1mLXG2wgfHvDlzrMK4dPly4s519Yo4i5mUlqlx5tg+9B2YCL+gtlB6KVy2n3dTQ0bOX4P/vTQeg/qG03qwBDIyLpGinJQ6+0Pb90ZCXDcahxQq0CkUCoVCoVAoFAqFQqE0DjIaBRQKhUKhUCgUCoVCoVCBTqFQKBQKhUKhUCgUCoUKdAqFQqFQKBQKhUKhUKhAp1AoFAqFQqFQKBQKhUIFOoVCoVAoFAqFQqFQKFSgUygUCoVCoVAoFAqFQqECnUKhUCgUCoVCoVAoFCrQKRQKhUKhUCgUCoVCoVCBTqFQKBQKhUKhUCgUChXoFAqFQqFQKBQKhUKhUKhAp1AoFAqFQqFQKBQKhQp0CoVCoVAoFAqFQqFQKFSgUygUCoVCoVAoFAqFQgU6hUKhUCgUCoVCoVAoFCrQKRQKhUKhUCgUCoVCoQKdQqFQKBQKhUKhUCgUChXoFAqFQqFQKBQKhUKhUIFOoVAoFAqFQqFQKBQKRQIKewde+vIssXfso6d7MTTqKJT/Hn4vnCOaT3oy9v5TKBTPkZiYSJKTk+n3RaFQKBQKFei8EBcT7h6vgNjua64VEr8XzpH6XO9MyHy6LqVe9p+fluA03j5ek0IYBiAAGAIQxvoSBmwQCAHqnEcIXpyR0OTP4OkKrpQ44eIDcD1OHIXD1f224XYnTqSE11Ea5kS5J8S58JvibNpud+jVy+71GQ8RxhP3uLx3mt3r26WmUYHUzPPOf6s4/6eI9Ie/yCU3Co3Y/mHnBmu8E9qzt02hUCgUyr9eoDcGthUPMcHuKWH2zcTx5OGuXfn//8vMxJPbdjCuCKM5cRFuhWd5Wr7TcwgBXpieAAD4ZF0KXpiW4PD8T9aewQvT42u2UySFw0IYvDyDvebD1Sn8ti0frj5T59iHq1M89gzCsNfuc25fSkVf80lPRpiOuG1779VRnHy4+gxenln7DIt/OoNXHox3KU4aCkKAZx+Ic+maz9en1bthw5k4d1VQCO2Ibcf8CCIQ5Ij50fW6uLN7XO0N0i6VjZurveMg3HZFTNnL22J+ZEh9Ghmk3udq7zhS34aGhmo0bci8899IcnIy4644f5kbAccA/NfjaBvAh0+5PzLuRqERhZeSAHRuEHEuzHeWjmbT0U+Hysm8bfmg4rxhv1sKhUKhNDOB7unecopzwcVvW1w8X2KzhkVg12xhJJ0n5XxXn0EsvFKfQfNJT0cC3qpiIqWC6yhOLE7eg5Q4EfaESa1YSQk7F19ag7R481VKj2OxcCUnJ/PC3Lb3ylMNa80BTpzXR1A5ig93Gxmk3qc+DQ2uPktzwN6onddOeVn9f6+vkd92d6SO8F6O7AuRci9HI4/sHXNkl5ERLJnPvvMFX6dJ2nYlX7DNl9iec+fiXGqDg73zlk6MwG3dg7GrDRDfIRj1uUd9r3Hn2vqMJJHSEPFP+m4pFAqF4oZAdzbP3FlB829t1VarG1KgM3yP7FtnvPBGyjmnr89C2PMZSItusxl45/tUEABLzivw7gvn7Np+p84xBRZ67BkUIse88OIMaXFVoTF7LN4dx4ltPNT97yxOHPWE1WeIu/ADbPP6eYdhuPZuj5qLpH+WYve3Febcf+G5rlQMpeYTGQ+ROttSRa7UewgFraui1jauGqrnypX71KehoSGepSHzzudrRup8ui6F337t1DnMiYuAWg38nJdvdY4n7vXaqXO4PzICKhXbyy8WBlfuJXb9xq/gll2ZYJqOtG3XRalYGrEV5/URibbXpt66AgCwSwXEdw/GmQvlmLctH/O25ZPefz3m8TQllgd7YrqBOyNJpIwiaaw8iEKhUChNKNClFFhVH8eKnhfwYvq/MrLe62vE89OsW+2FlSZH+3qtu+LUvoUQLJiVUCNuzzktyJen5fPDr5esklYR1JsYvPN4b/aaF865VFmQUkmQ+gzL0/LrHGuqoayO4sQ2nGL/mwqLQGzzAtzpNe6Lcw5nc9BdqRhKHQrLiXF3ep+l3sNW0LZLTXO557mhGhlcoT4NDf/EvNPVkUSEuB/nUq51Z2STvWsmz//WzjmOw/HFFQZf8A2JUrZlWFSPRhzb74ybk16fKWxi9/jpUDmJ78CK8/gOwVhxN8H0ISoGSHbrHhQKhUKh/KMFep1hureugMFgqHcAvpk43qowndEytM4+Dtv54lLDLLTt7JymxGIzXFromMzVa6VXOBv+GcTQfNITz/5Y3iw/CtswO/tfH8Hr6n7rgNRuSu1Br+/rFlbCPeUorrlhK3A9RX0aGVzBEw0N/yQHZRYCfLwmhU/f3DZgPQT94zVnQEDAMPUQ6AA+WpNSM2JJYWO/bhhIPZ/B3raUguH+SOmNrz/n5dcrL7PNB9RqWM1Jdylfc3DevG35UKuBhYfzsXQiMG9bAaYPUbl1Dyl1Aan7XKEhR5L8k75bCoVCoXhAoNsO0/V74RzR6fRsPYHUVB8YxmXxInTa5oj/ZWZaFULOCh+x42LCvzkVYhYRIShZoEuMd7OIgCZA7QB57k+NPcJwHsvdfwZR+wA+fygYT/+v3CX7DYFOz2DBV2dBQADI8N1Z68qqs/9Sha2r1zgTvmZSV4A7b0CpX1zZhskT4lzMq7q1F/e6ItfT97gM655md3qdG6tyLPU+9Wlo+CdV7glh8NLMeACsU0du23YKzYszas9xO4+2gB+1VNd+Qp0wSL2XvWdwtO0MlcqFB8vzbL7w65tRDPCgR9+zsBFg4eF88uCwYObBYcEecUjXWOldbCQJh9joEQ4pI/D+ad8thUKhUDwg0MUy/3bv5DVqYG09czd2YWSxsJ7GrZfZAj5ZkwIwVu0U+GRNCr8MFzwUys8eDMZzP9Wv19lsZmwEe60A57WzUEpaao5ZpMYRg3dXnuGTl9D+V7PrVky+fDgYT60sl2y/pqLmclpxVHmRyRgsfpJVgV+/cA6PxESAqYmMlRn5mB1T2xO1MiMfs3tEsO+bAD+cly7WxZzb+b1wzu5+p5V6wTR8qT3oFoktIY21LNY7CbWOtT5ek0LeSai7DZyuV5qXco91CT/Zvf5FD1fy69t77uw+9W1oaAhHVs7yTtTkOwTAx2vPgCGEbRyE8xErwkYnKQ1QXCOiK2UId66UhlBXw+PoGrvbEsLRUNNvGiNvsHcP4X57267kP42d3zUkDe2AjkKhUCjNQKC/xC3TIsJHT/dimiJDd8Uzd4MIdMFyXBwfrk6xWoaL3XcGL8+Mr7OvOWCxEKveYmKpbViw1ea1StCVOALefDSeAYBFL5wjQvtPrqhtXPjmMVasC/fVR+jaCtv6pBXbOLGtZFsI3B4rbs+5nTtO79yZg+5KQ0hjLIslk0HSPGR7+5rLPZxXjj2zIobT+4xcZ/+7QcO+e0fvXXremSJynuO8kxDggx9TwdR8lLXb1sXboh/PYNvyeQCArUshebSD7fSurUuBiXOWitonNYPfhduSGpHShM4npW2/4sDeG3EmfjlI4dKQdrdXuVY+NUbe0NjL8v0blgFsKAd0FAqFQmkmAr1GiIsJd48GQDh03VWh3vjitu4+2yHjV3vHYQaAqx9bnzcDAGamObFft3dbJvPsM/h4E7zzONur9vUL5+o95LluRZxYSXpH9uctd380gCe9uCu9LA7fs7P/TYU7XtwtoPzTK8f/xEq41GUbxfY5+94sFuDVR1gnj+//cIbftl2hYuFD8Vj4UDLzzsoz5I3Z8ZLXGBdO7+KuBUDE7NeGoXa7Id6rs/cpLDckbdP+00b7DriRJBz2RpQIS1KGvh8KhUKhAr0xsXX81pydm5jN0iqe7q5DbCGwGh7+QwZbCRP2GH/2INvzzPUU157vXpR5XKCbpa0j7vfCOczsHNFs3u0b36XWbMnxU6Z15dfZ/6as7Hkp5NAazJJ60L0Ucpfed0M6M6I0bzz97qXmnaJC3uw83xTbtgMRCm+p4bc5l3gwPA0S5wxDeIdyDAOn2zIXFXpj5A2Nnf80xv1enJHA/JvijEKhUChNINA93VveHHCnx57DZGH49bJr/agxePv7VF4iPyoi1CULLkLw5qPxAIBFL5zDg10j4OMDPPdTOS/MAfb/nLgILE/Lx+uz2fPfXHGmeQh0Ary6LK1m4qgcqy/bF7OOjjU23DJrH79wDtM71jYcrL2S7/R/U0Hc8eIucQ56Qy8pKEx/tV63a5G6r7ncozErxw19n4ZwZOUs7xRIS7z9fSp/DvvLOHm/DN5akVpzlnBbbnXeWyu4fLoeXtxr7gUR+2+v4J6PsdqWiiue1J0hY4AXprPv6ZO1KRK2z9QrfXg6b2is/Kex7yfmAd5THRIN7YCOQqFQKM1EoDfGEPfGhOutd7eX3mypFXIcby5Pxdtzavdd/cr9dYjFep81NRNH5ywtx/J5wZiztFzStfafQaSHm7Fy3M4OueOry7We3KWJRgYfzGOfl3ybhg+eEH/2//smFR88aR2XH65OaZJ04ShOuEYHYZwQi2tx0mAC3eLGHHTSvAan/FvmoDdW5fifWgmXknfa21c7ukUcnUGGRTVOHhd+c5bfXmIzBP2tx3rXnOP+Eno6A4NFT7J52oc29t/k7Z+1Co8UnulIRJ/B/rbjZxAOiRZub/r6CbwwPVnkHLp0eGMhnDJB12ynUCgUissCneJYyNnb54l1iMWwJ85degazyDrlxHrMZp1t4sp6vozodp1wEGlxKYanvbg7ixPeaZxAsLsSJw0FF79BfnIXrqH1QUrzzTul7rOXpqWkbwupzzfn2jcm9Xuzd439bec2hY1LUrYpjSPOHf2nUCgUCsWpQG+M3vLGbkGuz1rFZpFeapODyqOr6xC7Mjyc49WlqWxXiMRYtPXiviHXs0O0CSFY8HXtMy/4qiYNMXUXVheex+LcI57U1QNc8eLuLE6c/ZeKvYYFKQ0OonENgoVfp6G2u79mULCVByKuxcG1emBTLylIaTrEHFkJEp11GuCSHRw7spKad4rtMzsZHUQsDF7+8iw/3IffBmPlTO1lLi+qzxB3wljZ+Tkvn19D/OWvztbEBWO1LcmuvWcg9p/NEc9PE5/rvPErEHvHmlPe0Nj5z78hv5PqgM7ajSt1QEehUCjNEYb8B3vU3B3i/vJXaYQBA1KzgA4BYbUxqV3I99nvZ9i9vl1qGi0KKRQBH69J4eqPgsok4TWIsGIMwXGuYvzidOdio7HvUbdybHMvG1H7wnTpgsml+9hUwl25j6dxnndy4SQ1UW997odPxdG80wPlHrdNe27pe6BQKBQKFegUCoVCoVCaWBxSUUihUCgUChXoFAqFQqFQKBQKhUKhUJwgo1FAoVAoFAqFQqFQKBQKFegUCoVCoVAoFAqFQqFQqECnUCgUCoVCoVAoFAqFCnQKhUKhUCgUCoVCoVAoVKBTKBQKhdJ8+eKLL/4RXlyPHj1Kfv/9d6uwrl+/3qNhF9rbsGEDaaj7UCgUCoXS1Nj14n7p0iW7hV6XLl3+k8u0bN++nQCATMa2a1gsFshkMnBxyP0yjO3avgwsFgsmTJhAl7eh/OO/AWE6tv1PoVA8L86feeYZl76xpKSkOuU3wzAQK++5/YMGDXL7O962bRtJTU3F66+/znACeurUqR7PF9avX08GDRqEpKQkDB48GEePHsUDDzxA8x8KhUKh/HcEepcuXersz8zMRNeuXT1WIK5cubJOAGbPnt0sC9ydO3eS6Oho0cqO2H+haM/KynIq0DMzM4mtuHcFKQ0nFy9eJFxYxe4lfAaZTAaLxWL1LN26dXN4D3sNO8L72TZkcMcIIR5NW1z6cpSeLl68SMTeGbdtG1eEEKvwOouPf7NI37FjBxk/fjxTX1vc9oQJExjuv3C7VatWdtPrgAEDHN5/x44dhHtvnE2GYTB+/Hhmx44dhBACPz8/u9cPHz6cqW8eduzYMSJMX9y2xWLBwIED/xPph4tre9+Zbd5jm6/+VxuBvvjiC+KqOAeAv/76i9x6663cNrjt5ORkJCYm1tmuOUfSfZYsWUIWLFjAOBLR9kSzs2udnZefn09atGiBqqoqBAcHo7i4GBEREYw796jvNe5c++OPP9rt+BCWNWLfwkMPPSQp3mz3uftcFAqFQmk6FC4resazeb2teBKr7HpKmG3YsIH07t2b/5+SkoJp06YxUgWdxWKRVJm0PS41zhiGAdcoUtMQAieCnj8nMzNTctxw11y8eBHdunWzJ1xh20Bz8eJFp7ZrRDYn1iHWyMOF1x37QkEnbEAQVv7Hjx/PCNMRt23vvXJxYBsfFy9etHoH58+fR48ePVwKr6M05ep+R40tjip8Is/LuBtmTjw7EudSwy+052j7+PHjhGEYMAyD/v374/jx45LTuq24E25z4d+/fz8ZPnw4arYh3HYlH+Oe2zYPE76HAQMG4Pjx43YbHOrbGLB//35Sn8YGKfdwB0IIOnXqJCmd2v6/cuWKXbtnz54lwkYz7tr09HQrezExMfw5cXFxbj9LWloa39iSnp5u9R5jYmL4+wvzIyn34+zae0YunxOKuF69ejFSymkp6czVtGgrBDkRuGHDBitxLiYY3b1HVFQUCCEYOXIkQkNDUVpaiqNHjwIAycvL83jlSEx410fIc/To0YOvS9iOxhP7LiwWi+SyhnsXXDjrE/8UCoVCaYYCnRCCS5cuuV2RbI4IBba7aLXaOhUaR5VLd8MnxYbwHKn3FN7DUXyI2ZMSf8LrPBHfdgSdIwFvJSiciUVHcWgbftvvwN337Ek6d+7s0vmXLl1yWwzOnj2bF+acuOV6091tWJMqHoSipyHjnRPnrmCbvsTSm23jXX3yCUeNAcJncLexQco9GhJX4oUQgri4OE7kolevXgCA9PR0dO/eHRqNBnl5eVbn1BfO1rlz5xAZGQlfX19cvHjR6h5cQ7Ar9xNez20fOHCAf6bU1FR+/9mzZx3ays3NRU5ODv8/JyeH/9a4/TKZjN9PCOF706WKQNt9wmHtR48eJYWFhRATuPW5R35+PgkODkZpaSmCg4MxePBg0R705l4XsRXjXGMzt80wDMxmMwBALpe7/V5o7zmFQqH8ywS6s6HGnEMYbqimbS/mnXfe2ewKBttC0VW6detWp9dXrJdYbF9gYKCke3At5ZcuXcKlS5f4eBUbbu5OwwkhBOfOnQPDMMjOzsaVK1fqVIi5e16+fLnOsDthD7LUZ7DXcJGZmWlVMWEYxm6Pvi1c5UX4XO7GB9cTlpOTg6ysLCuRkJWVZWU3KyvLKp13795dksi1J3Ic7XfWaykUfGKiz/bdCf0luCM8gdpeZ06Ycz3SwnNdEXRShsgTQjBgwAD+/8CBAwEAx44dk9KYIylRCMWsO4LWWQND//7964TflZEArjQG1KexwdV7uALXuCnWaCGlYcYTeX19G3fsjYyy12Drzv2E19x+++2i50hp/IyMjHR4D2GYXemBdibOAaCiokJ0VJdUwWjvvKSkJPTp0wenTp0SzkF36x62iAl7qftcobq6WjTt204Bk/KNUCgUCuU/JtCliAZ7PZlcL2Zzo749ug1dUBJCeMF3+fJldOzY0W5BzTAMsrKyeEF74cIFyXHQs2dPAEB2drbVPZzBiVepz3Dp0iWrYa3CZ8jKyqoz5DU7O1tyxVvsXbjzfkwmE99DlZOTYxUfXBi5cNuGWUp8CHsipYpwqUPEhRW63bt3i4oErgFk7NixdYSEq+KcY8eOHQ7noLsi6Hbu3EnGjRvn9HxOzHJDxKU+i1QndrZidvjw4R4T6YQQflj7wIED6zXEvakbG9yla9eudabseKJxkxCC1NRU/j+3bZsXCM+pb2MLZ0vop8L2Hq7ez95z2Nt2lnY43wrCfMBenskNna8Ptg7hxo0bx4wbN86jaUjYCHD69GkSERHBPPDAAx5xSNdYPc1xcXHo06eP6LHTp087POZqQ4MnhuNTKBQKpZkLdNuewFatWlkJXtsedKmsW7fOyjO6v78/v4QKNy+Lu4/tfHGpYebw9/d3ek5Dim9XzrE9X6xV3Z2eGlsncK5WTl2x72hI+IQJE3D+/Pl6xZGYUx1PPpM9p3bNscFpzJgxos8kjB9utEt9EIry8ePHM/X14u5KunUn/l29xlbcupM/2mugEHOK2BB4orFByvM05HtwBW44eWpqKr8tzFsYhrE6p775OGcrIyPD6tnEwuHK/exd767dixcvWpUVzhyZSmX9+vXEduSTWH4jPEd4Tyliev369USswVG4/+eff+bn5m/YsIEI7+2qZ3fb64VlpL1RHMJzpd7P3W/eleuoKKdQKJT/kEC37Qnctm0bsVfZd0UEJCQkSDovJSXFqvLorNIodpxrDHB2nqNCkpuXL9yXmZlZpyIkdOoiVTTaE5/2xKi7Q7odFfpitj0pJITP1KNHD5w/f94l8eVoKTtX0x4AGI1GPm1xw/6FUwlspwBwvebcPEGp344n9jvijz/+sNuAI5PJMHr0aI+8P9se8/p61yaEQOi5nfP2zW0DQMuWLfm45nrPpaZJhmEg5hmes88wDHx8fKwErDs9zlLf2fHjx+v0vDZEY0B9GhvcTYMNIUxcsWvrw0PMZwF3jqve0bnzpQw/lurnQ8pz2Nt2Fp/du3fny9YzZ84gPj7e6bZUZDIZP3JLmB/bE+fCeJI60ot7Btsyw175JPzvikM14bvs1q1bHcejtiO2xBzBuvJMjt6bJ3y22PMSb29IvfC5HnzwQSrsKRQK5Z8m0G0rbQzD8MNqbVvSG6K3RCaTwdYzd30rke7MSRfzPG47dFPMO7qUSoOjSgc3/5vrGXI3jsUcoYk1BAiPi/WEOLLPiW7OAy1HbGxsnfN79OjBzwGXUolnGAY7duywiiMxcS7Vi7tMJuN7pYqKitChQwc+HDk5OejQoYOVWOf+E0KQm5srKU440SnsjbG3xB33PFKGfQvjZMyYMXUqso6W05MaZi48QgdG9pydCbelCveuXbvy12RmZpIuXbqAEIKLFy+Szp07w5mXemcIpyRw9msa0IjQwZ5Yg5TUeBMuISZMV1J63hpCPNe3sWH79u1EbIUEZ2HnVlCwly9wc5KFaZJr3BSK6szMTIilPXuiRth4K9wWvr/Tp0/jyJEjAIDDhw8TV0Q6tx4593vo0CEMGTKkTvoXDkNOSUlx6R1fvHgR58+f58MsLC8uXLhgtZ+7LyeunZVt9ubKu+rpXazMsJcexI67cg/bsIk1WHPp0/Zbc0foChtlbcNpa8/Zszvj1KlTVmlH+FwnTpwQrQe4EndCL/EA62TOnjjnynfb0WwUCoVCaaYCXWw9a66w6NKlC9MUTuCkeuZ2pVCu7/m2+7gKcWFhYZ1zpTpAk1KZr4+n+DNnztTpBbD3K3xGqUPcY2JiGADIzs62Ei7nzp3jt7l58MJ9UhsAHHlx58S7O2nFYrGIVsbsTTdwZXi2WJi3b99ud7+r6XH37t2iPVcc3BB4V8Js6yPAnhi3xdGyWGLpW8rcZLFlB6V4pJfJZKLznKXOh5aKvSXEHCHFh4FYY4BYI56zRh9X8guGYRAdHe1yw4Kz55HakCl2niO4nmLhHF5hrybDMOjTpw/69OnDnDp1ivTt25dxpQf9mWee4c8/efIk6devHwOA2IaLu/epU6f4balzhy0WSx2Hk2Ke/4XfgzNcmdPuKhqNxq1yy5WRUtXV1Va2HK0TXt+RZQzD1HHe5mhKgLvTA2rSToMjbKAxm811OiNsnaxSKBQK5R8i0AGIrmHtSqVVCikpKZJ6aIUFjKeHX3oad5c5EuvddtTL745I9/Ly4sVxYWGh3ZZ8sQq+C8usEW5b2Atn20Nx9uxZtytWXAWjvs62bJewEfakCAW6J3qDzGaz6PW2z+LqcH+hALf37lwVamLpztaevcp4Qwxnbs5LPTa2l2Vbx46OxAL3blxpNLH3PM6e01FeJaVx094+R/d1tKyjyHV8g6Erw9tFzieOGuvc/RYciV7bfE5KXuzKnHZXloPr2bMn71iT4+zZs5L2SW2Qrc89nC1BJ0ZsbKzb9wsKCpJ8HzEP8J6eM841bFAoFArlXyrQGwNbx2+e6h2XUoF0dYi72WzmKxhC0ckN0bYVEa7O/ySE8I6HuDVqbXtfuWXOuF7W9PR0l8SLmLCyXb6tPgJEzAmdUKRzx7dv346IiIh6zXX3xLrS3LJz3LX5+flW79J2GHtubq7LYtFenIp5pHf3GXbv3l0nXQrtcV7cpdq3WCxWy2JJdXDmCY/Q/0R0Op3DnreGFPGORjW4c1+GYeosiSblWRpjnrlYOj1x4gT/XzhEWJhmhefUNyxCW8K0Ltx/8uRJl+ODy3ts41k41F/qNDJ7w9cPHjzIi/Km+E7pkmGsIOc8rHt6zfZevXqhb9++osdOnTpl95grXuIpFAqF0sQC3dO95U2NxWJBamqq1XxaV+F6nzlsW9SLi4vdXuaIEMLP087JyUFERAS8vLxw/vx5q/XHL1y4gE6dOiErK4s/X2rPhFjvsCcrToQQpKWl8cJfuL6ubaWzsLBQtIfdlYpnfcPPMAz/TnNzc9G+fXv+WEFBASIiIqwq0Lb/3RVSXHoUeyeupGfhMmr2RkAIG0yk2u/WrZvkYea25wUEBLj0DEJv0xy2w4dtHS+6Yl8499mZfXfEtFhcOYofDkfLhzlKQ7YNJ1IaqFx5pq5du7r1PI7KC7PZjPT0dKvwcI2btvPMufOk5AkmkwmJiYkAgL/++gu33norAHaZSuEzc+vQJycn1yt/E97Pdki/8B7cOVLv16FDB6trpGw74+zZs3wcCLeFS7WlpqY2qlCXeq/m0MjXEGGw7S33dO+5p3zTUCgUCqUZC/TGGOLemHC99e720ksdkunuMkdiwzWNRiMAdghiXFyc1VBEd4SdvWGgtsMnxXpwpBb0XA8NAKttIcLhlfZEk6M48tQ60rYCVmyIu73zXa1sOpu36O5IAM5ho+08TWGvm6tz0KVW/upbsRObg26vIcCTc9ClzktvbjRmY4AnIYQ4bdwU5nNCHDU+SnUs6an0KmW0i7ujYNzdFiMuLk40czpw4ADp3bt3vVde4IaRC/OctLS0OuWGcJ+rjugc3cM2Hdnmoe4+k+31Yra5MDibgtbckLKkKIVCoVCauUCnLarS4sRRPLm6zJEz4WY7T7C+66Bz/8U8xtsOtfR0enC2PJGjisTOnTutzhUTtVK9uIstXWRvjXlPLHEn1thR37VxCSEe9+Iu9Z3V17bY9bSy+M/KAxsi75SaLxBCkJSUxKd14bZwScy//vrLY+Uadw+GYaxGCCUlJfHpl9t2JX7EnkN4P26/u9+I0Bu9q3PwpYh/T9IY92iq+3HD2rlh7p60bTabcfLkSdFyhxBidcydBngKhUKhNLFAZxhGtAfJ00JNKKQaA6lrCNurRAnXzObg1pDl4sbdZY6Ew8O5yp/YeqzC1ntOtLtS2eW8uMtkMly9erWOeBT2DLjiwZ2zI1xTNyUlRXTZGNvzpGJvGSdbpHpxF8YHIQSFhYVWTgsLCgqshC7nnd/dnm5hHNgTpK5WlhQKhUtpTGo6EQoc7lqh92juOcSWz/J0eDwpDD2NcJi+2P0vXrzodIm9phTPUt899wzCkS72Vg1wV6C7KuQHDRokelNuqLunufXWW5mGuIe95/AkQm/0tOrTdHhalAvp378/fbcUCoXyL4D5L/aUN6QjOgrFFuG60kJxLzbknTsmZR3x1NRU4kywifXWx8fHN5u0f/HiRWKv4cLR0kpcY1KXLl0cPktmZiYRs2fbYGK7ljJ3rGvXrs0qn7h48SKxDbsw3Ygd4/Y15bOkpKTUCbez5bKE/xMSEmh+TaFQKBQKhQp0CoVCoVAoFAqFQqFQKI2DjEYBhUKhUCgUCoVCoVAoTc//DwAZOp+r9KKKDQAAAABJRU5ErkJggg=="

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(134);
	
	var vec2 = __webpack_require__(49);
	
	var bbox = __webpack_require__(226);
	
	var BoundingRect = __webpack_require__(51);
	
	var _config = __webpack_require__(280);
	
	var dpr = _config.devicePixelRatio;
	
	/**
	 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
	 * 可以用于 isInsidePath 判断以及获取boundingRect
	 *
	 * @module zrender/core/PathProxy
	 * @author Yi Shen (http://www.github.com/pissang)
	 */
	// TODO getTotalLength, getPointAtLength
	
	/* global Float32Array */
	var CMD = {
	  M: 1,
	  L: 2,
	  C: 3,
	  Q: 4,
	  A: 5,
	  Z: 6,
	  // Rect
	  R: 7
	}; // var CMD_MEM_SIZE = {
	//     M: 3,
	//     L: 3,
	//     C: 7,
	//     Q: 5,
	//     A: 9,
	//     R: 5,
	//     Z: 1
	// };
	
	var min = [];
	var max = [];
	var min2 = [];
	var max2 = [];
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathCos = Math.cos;
	var mathSin = Math.sin;
	var mathSqrt = Math.sqrt;
	var mathAbs = Math.abs;
	var hasTypedArray = typeof Float32Array !== 'undefined';
	/**
	 * @alias module:zrender/core/PathProxy
	 * @constructor
	 */
	
	var PathProxy = function (notSaveData) {
	  this._saveData = !(notSaveData || false);
	
	  if (this._saveData) {
	    /**
	     * Path data. Stored as flat array
	     * @type {Array.<Object>}
	     */
	    this.data = [];
	  }
	
	  this._ctx = null;
	};
	/**
	 * 快速计算Path包围盒（并不是最小包围盒）
	 * @return {Object}
	 */
	
	
	PathProxy.prototype = {
	  constructor: PathProxy,
	  _xi: 0,
	  _yi: 0,
	  _x0: 0,
	  _y0: 0,
	  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
	  _ux: 0,
	  _uy: 0,
	  _len: 0,
	  _lineDash: null,
	  _dashOffset: 0,
	  _dashIdx: 0,
	  _dashSum: 0,
	
	  /**
	   * @readOnly
	   */
	  setScale: function (sx, sy, segmentIgnoreThreshold) {
	    // Compat. Previously there is no segmentIgnoreThreshold.
	    segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
	    this._ux = mathAbs(segmentIgnoreThreshold / dpr / sx) || 0;
	    this._uy = mathAbs(segmentIgnoreThreshold / dpr / sy) || 0;
	  },
	  getContext: function () {
	    return this._ctx;
	  },
	
	  /**
	   * @param  {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  beginPath: function (ctx) {
	    this._ctx = ctx;
	    ctx && ctx.beginPath();
	    ctx && (this.dpr = ctx.dpr); // Reset
	
	    if (this._saveData) {
	      this._len = 0;
	    }
	
	    if (this._lineDash) {
	      this._lineDash = null;
	      this._dashOffset = 0;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  moveTo: function (x, y) {
	    this.addData(CMD.M, x, y);
	    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
	    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
	    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
	    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持
	
	    this._x0 = x;
	    this._y0 = y;
	    this._xi = x;
	    this._yi = y;
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  lineTo: function (x, y) {
	    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
	    || this._len < 5;
	    this.addData(CMD.L, x, y);
	
	    if (this._ctx && exceedUnit) {
	      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
	    }
	
	    if (exceedUnit) {
	      this._xi = x;
	      this._yi = y;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @param  {number} x3
	   * @param  {number} y3
	   * @return {module:zrender/core/PathProxy}
	   */
	  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
	    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	    }
	
	    this._xi = x3;
	    this._yi = y3;
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @return {module:zrender/core/PathProxy}
	   */
	  quadraticCurveTo: function (x1, y1, x2, y2) {
	    this.addData(CMD.Q, x1, y1, x2, y2);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
	    }
	
	    this._xi = x2;
	    this._yi = y2;
	    return this;
	  },
	
	  /**
	   * @param  {number} cx
	   * @param  {number} cy
	   * @param  {number} r
	   * @param  {number} startAngle
	   * @param  {number} endAngle
	   * @param  {boolean} anticlockwise
	   * @return {module:zrender/core/PathProxy}
	   */
	  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
	    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
	    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
	    this._xi = mathCos(endAngle) * r + cx;
	    this._yi = mathSin(endAngle) * r + cy;
	    return this;
	  },
	  // TODO
	  arcTo: function (x1, y1, x2, y2, radius) {
	    if (this._ctx) {
	      this._ctx.arcTo(x1, y1, x2, y2, radius);
	    }
	
	    return this;
	  },
	  // TODO
	  rect: function (x, y, w, h) {
	    this._ctx && this._ctx.rect(x, y, w, h);
	    this.addData(CMD.R, x, y, w, h);
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/PathProxy}
	   */
	  closePath: function () {
	    this.addData(CMD.Z);
	    var ctx = this._ctx;
	    var x0 = this._x0;
	    var y0 = this._y0;
	
	    if (ctx) {
	      this._needsDash() && this._dashedLineTo(x0, y0);
	      ctx.closePath();
	    }
	
	    this._xi = x0;
	    this._yi = y0;
	    return this;
	  },
	
	  /**
	   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
	   * stroke 同样
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  fill: function (ctx) {
	    ctx && ctx.fill();
	    this.toStatic();
	  },
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  stroke: function (ctx) {
	    ctx && ctx.stroke();
	    this.toStatic();
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDash: function (lineDash) {
	    if (lineDash instanceof Array) {
	      this._lineDash = lineDash;
	      this._dashIdx = 0;
	      var lineDashSum = 0;
	
	      for (var i = 0; i < lineDash.length; i++) {
	        lineDashSum += lineDash[i];
	      }
	
	      this._dashSum = lineDashSum;
	    }
	
	    return this;
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDashOffset: function (offset) {
	    this._dashOffset = offset;
	    return this;
	  },
	
	  /**
	   *
	   * @return {boolean}
	   */
	  len: function () {
	    return this._len;
	  },
	
	  /**
	   * 直接设置 Path 数据
	   */
	  setData: function (data) {
	    var len = data.length;
	
	    if (!(this.data && this.data.length === len) && hasTypedArray) {
	      this.data = new Float32Array(len);
	    }
	
	    for (var i = 0; i < len; i++) {
	      this.data[i] = data[i];
	    }
	
	    this._len = len;
	  },
	
	  /**
	   * 添加子路径
	   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
	   */
	  appendPath: function (path) {
	    if (!(path instanceof Array)) {
	      path = [path];
	    }
	
	    var len = path.length;
	    var appendSize = 0;
	    var offset = this._len;
	
	    for (var i = 0; i < len; i++) {
	      appendSize += path[i].len();
	    }
	
	    if (hasTypedArray && this.data instanceof Float32Array) {
	      this.data = new Float32Array(offset + appendSize);
	    }
	
	    for (var i = 0; i < len; i++) {
	      var appendPathData = path[i].data;
	
	      for (var k = 0; k < appendPathData.length; k++) {
	        this.data[offset++] = appendPathData[k];
	      }
	    }
	
	    this._len = offset;
	  },
	
	  /**
	   * 填充 Path 数据。
	   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
	   */
	  addData: function (cmd) {
	    if (!this._saveData) {
	      return;
	    }
	
	    var data = this.data;
	
	    if (this._len + arguments.length > data.length) {
	      // 因为之前的数组已经转换成静态的 Float32Array
	      // 所以不够用时需要扩展一个新的动态数组
	      this._expandData();
	
	      data = this.data;
	    }
	
	    for (var i = 0; i < arguments.length; i++) {
	      data[this._len++] = arguments[i];
	    }
	
	    this._prevCmd = cmd;
	  },
	  _expandData: function () {
	    // Only if data is Float32Array
	    if (!(this.data instanceof Array)) {
	      var newData = [];
	
	      for (var i = 0; i < this._len; i++) {
	        newData[i] = this.data[i];
	      }
	
	      this.data = newData;
	    }
	  },
	
	  /**
	   * If needs js implemented dashed line
	   * @return {boolean}
	   * @private
	   */
	  _needsDash: function () {
	    return this._lineDash;
	  },
	  _dashedLineTo: function (x1, y1) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var dx = x1 - x0;
	    var dy = y1 - y0;
	    var dist = mathSqrt(dx * dx + dy * dy);
	    var x = x0;
	    var y = y0;
	    var dash;
	    var nDash = lineDash.length;
	    var idx;
	    dx /= dist;
	    dy /= dist;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum;
	    x -= offset * dx;
	    y -= offset * dy;
	
	    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
	      idx = this._dashIdx;
	      dash = lineDash[idx];
	      x += dx * dash;
	      y += dy * dash;
	      this._dashIdx = (idx + 1) % nDash; // Skip positive offset
	
	      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
	        continue;
	      }
	
	      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
	    } // Offset for next lineTo
	
	
	    dx = x - x1;
	    dy = y - y1;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  // Not accurate dashed line to
	  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var t;
	    var dx;
	    var dy;
	    var cubicAt = curve.cubicAt;
	    var bezierLen = 0;
	    var idx = this._dashIdx;
	    var nDash = lineDash.length;
	    var x;
	    var y;
	    var tmpLen = 0;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum; // Bezier approx length
	
	    for (t = 0; t < 1; t += 0.1) {
	      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
	      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
	      bezierLen += mathSqrt(dx * dx + dy * dy);
	    } // Find idx after add offset
	
	
	    for (; idx < nDash; idx++) {
	      tmpLen += lineDash[idx];
	
	      if (tmpLen > offset) {
	        break;
	      }
	    }
	
	    t = (tmpLen - offset) / bezierLen;
	
	    while (t <= 1) {
	      x = cubicAt(x0, x1, x2, x3, t);
	      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
	      // Bad result if dash is long
	
	      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
	      t += lineDash[idx] / bezierLen;
	      idx = (idx + 1) % nDash;
	    } // Finish the last segment and calculate the new offset
	
	
	    idx % 2 !== 0 && ctx.lineTo(x3, y3);
	    dx = x3 - x;
	    dy = y3 - y;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  _dashedQuadraticTo: function (x1, y1, x2, y2) {
	    // Convert quadratic to cubic using degree elevation
	    var x3 = x2;
	    var y3 = y2;
	    x2 = (x2 + 2 * x1) / 3;
	    y2 = (y2 + 2 * y1) / 3;
	    x1 = (this._xi + 2 * x1) / 3;
	    y1 = (this._yi + 2 * y1) / 3;
	
	    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
	  },
	
	  /**
	   * 转成静态的 Float32Array 减少堆内存占用
	   * Convert dynamic array to static Float32Array
	   */
	  toStatic: function () {
	    var data = this.data;
	
	    if (data instanceof Array) {
	      data.length = this._len;
	
	      if (hasTypedArray) {
	        this.data = new Float32Array(data);
	      }
	    }
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
	    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
	    var data = this.data;
	    var xi = 0;
	    var yi = 0;
	    var x0 = 0;
	    var y0 = 0;
	
	    for (var i = 0; i < data.length;) {
	      var cmd = data[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = data[i];
	        yi = data[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	          // 在 closePath 的时候使用
	          x0 = data[i++];
	          y0 = data[i++];
	          xi = x0;
	          yi = y0;
	          min2[0] = x0;
	          min2[1] = y0;
	          max2[0] = x0;
	          max2[1] = y0;
	          break;
	
	        case CMD.L:
	          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.C:
	          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.Q:
	          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.A:
	          // TODO Arc 判断的开销比较大
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++];
	          var endAngle = data[i++] + startAngle; // TODO Arc 旋转
	
	          i += 1;
	          var anticlockwise = 1 - data[i++];
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(startAngle) * rx + cx;
	            y0 = mathSin(startAngle) * ry + cy;
	          }
	
	          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = data[i++];
	          y0 = yi = data[i++];
	          var width = data[i++];
	          var height = data[i++]; // Use fromLine
	
	          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
	          break;
	
	        case CMD.Z:
	          xi = x0;
	          yi = y0;
	          break;
	      } // Union
	
	
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * Rebuild path from current data
	   * Rebuild path will not consider javascript implemented line dash.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  rebuildPath: function (ctx) {
	    var d = this.data;
	    var x0;
	    var y0;
	    var xi;
	    var yi;
	    var x;
	    var y;
	    var ux = this._ux;
	    var uy = this._uy;
	    var len = this._len;
	
	    for (var i = 0; i < len;) {
	      var cmd = d[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = d[i];
	        yi = d[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          x0 = xi = d[i++];
	          y0 = yi = d[i++];
	          ctx.moveTo(xi, yi);
	          break;
	
	        case CMD.L:
	          x = d[i++];
	          y = d[i++]; // Not draw too small seg between
	
	          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
	            ctx.lineTo(x, y);
	            xi = x;
	            yi = y;
	          }
	
	          break;
	
	        case CMD.C:
	          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.Q:
	          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.A:
	          var cx = d[i++];
	          var cy = d[i++];
	          var rx = d[i++];
	          var ry = d[i++];
	          var theta = d[i++];
	          var dTheta = d[i++];
	          var psi = d[i++];
	          var fs = d[i++];
	          var r = rx > ry ? rx : ry;
	          var scaleX = rx > ry ? 1 : rx / ry;
	          var scaleY = rx > ry ? ry / rx : 1;
	          var isEllipse = Math.abs(rx - ry) > 1e-3;
	          var endAngle = theta + dTheta;
	
	          if (isEllipse) {
	            ctx.translate(cx, cy);
	            ctx.rotate(psi);
	            ctx.scale(scaleX, scaleY);
	            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
	            ctx.scale(1 / scaleX, 1 / scaleY);
	            ctx.rotate(-psi);
	            ctx.translate(-cx, -cy);
	          } else {
	            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
	          }
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(theta) * rx + cx;
	            y0 = mathSin(theta) * ry + cy;
	          }
	
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = d[i];
	          y0 = yi = d[i + 1];
	          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
	          break;
	
	        case CMD.Z:
	          ctx.closePath();
	          xi = x0;
	          yi = y0;
	      }
	    }
	  }
	};
	PathProxy.CMD = CMD;
	var _default = PathProxy;
	module.exports = _default;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(228);
	
	var BoundingRect = __webpack_require__(51);
	
	var zrUtil = __webpack_require__(2);
	
	var imageHelper = __webpack_require__(450);
	
	/**
	 * @alias zrender/graphic/Image
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	function ZImage(opts) {
	  Displayable.call(this, opts);
	}
	
	ZImage.prototype = {
	  constructor: ZImage,
	  type: 'image',
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var src = style.image; // Must bind each time
	
	    style.bind(ctx, this, prevEl);
	    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);
	
	    if (!image || !imageHelper.isImageReady(image)) {
	      return;
	    } // 图片已经加载完成
	    // if (image.nodeName.toUpperCase() == 'IMG') {
	    //     if (!image.complete) {
	    //         return;
	    //     }
	    // }
	    // Else is canvas
	
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var width = style.width;
	    var height = style.height;
	    var aspect = image.width / image.height;
	
	    if (width == null && height != null) {
	      // Keep image/height ratio
	      width = height * aspect;
	    } else if (height == null && width != null) {
	      height = width / aspect;
	    } else if (width == null && height == null) {
	      width = image.width;
	      height = image.height;
	    } // 设置transform
	
	
	    this.setTransform(ctx);
	
	    if (style.sWidth && style.sHeight) {
	      var sx = style.sx || 0;
	      var sy = style.sy || 0;
	      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
	    } else if (style.sx && style.sy) {
	      var sx = style.sx;
	      var sy = style.sy;
	      var sWidth = width - sx;
	      var sHeight = height - sy;
	      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
	    } else {
	      ctx.drawImage(image, x, y, width, height);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  getBoundingRect: function () {
	    var style = this.style;
	
	    if (!this._rect) {
	      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(ZImage, Displayable);
	var _default = ZImage;
	module.exports = _default;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(124);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1438);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(283);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(551);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(558);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(562);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(563);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(574);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(577);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(583);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(613);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(66);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.onExpand = exports.onSelect = exports.renderTreeNodes = exports.getExpressOptions = exports.createSimpleFormInfo = exports.createFormInfo_readOnly = exports.createFormInfo = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _rtSdComp = __webpack_require__(199);
	
	var _rtSdCommon = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	var TreeNode = _antd.Tree.TreeNode;
	
	var formItemLayout3 = {
	    labelCol: { span: 12 },
	    wrapperCol: { span: 12 }
	};
	
	var formItemLayout2 = {
	    labelCol: { span: 6 },
	    wrapperCol: { span: 18 }
	};
	
	var formItemLayout2_noTree = {
	    labelCol: { span: 23 },
	    style: {
	        width: "100%",
	        margin: "1px -7px 1px auto"
	    }
	};
	var formItemLayout3_noTree = {
	    labelCol: { span: 14 },
	    wrapperCol: { span: 10 }
	};
	
	var createFormInfo = function createFormInfo(thisObj, dataRef, matchType, value1, value2) {
	
	    dataRef.desId = dataRef.desId || "EP_EO_UI_3101"; //添加默认值-文本框
	    var moveStyle = {};
	    if (dataRef.desId === "EP_EO_UI_3101" && dataRef.bdText) {
	        // 文本组件存在后置文本时需要进行偏移，这是antd的bug，修复后这里可以取消
	        moveStyle.marginTop = 4;
	        moveStyle.marginBottom = -4;
	    }
	
	    var attc = dataRef.c;
	    var text = dataRef.te;
	
	    var bdInst = attc + "_tmp";
	
	    var ctl2ShowFlg = false;
	
	    //显示的所有属性的集合
	    thisObj.state.checkedAtts[attc] = true;
	
	    thisObj.state.objFct.set(bdInst, thisObj.state.formsValue[attc]);
	
	    //修改c值，给每组值起同样的key
	    dataRef.cRef = attc;
	    var dataRef1 = (0, _rtSdCommon.copy)(dataRef);
	    dataRef1.c = "value1";
	    dataRef1.isLbl = true;
	    if (value1) dataRef1.value = value1;
	    var ctl1 = (0, _rtSdComp.convertModuleByGuid)(thisObj, dataRef1, bdInst, thisObj.state.objFct, "N");
	    ctl1.ref = thisObj.refModalFunction.bind(thisObj);
	    var dataRef2 = (0, _rtSdCommon.copy)(dataRef);
	    dataRef2.c = "value2";
	    // dataRef2.isLbl = false;
	    // dataRef2.te = '-';
	    dataRef2.isLbl = true;
	    dataRef2.ctlW = 24;
	    dataRef2.lblW = 2;
	    // dataRef2.alwBlk = true;
	    if (value2) dataRef2.value = value2;
	    var ctl2 = (0, _rtSdComp.convertModuleByGuid)(thisObj, dataRef2, bdInst, thisObj.state.objFct, "N");
	    if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
	        ctl2.ref = thisObj.refModalFunction.bind(thisObj);
	        ctl2ShowFlg = true;
	    } else {
	        delete ctl2.ref;
	        ctl2ShowFlg = false;
	    }
	
	    var ctl1Span = 6;
	    if (matchType && (matchType == "In" || matchType == "NotIn")) {
	        ctl1Span = 13;
	    }
	
	    if (thisObj.props.noTree) {
	        if (!ctl2ShowFlg) {
	            ctl1Span = 13;
	        }
	        thisObj.state.forms[attc] = _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: dataRef.matchDis ? 7 : 12 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({ style: { 'margin-bottom': "1px", 'margin-top': "1px" } }, dataRef.matchDis ? formItemLayout2_noTree : formItemLayout3_noTree, { hasFeedback: false, label: text }),
	                    dataRef.matchDis ? null : _react2.default.createElement(
	                        _antd.Select,
	                        { disabled: dataRef.matchDis, value: thisObj.state.formsValue[attc]["match_type"], style: { width: '100%' }, onChange: this.handleChange.bind(this, attc, "match_type", dataRef) },
	                        getExpressOptions()
	                    )
	                )
	            ),
	            dataRef.matchDis ? null : _react2.default.createElement(_antd.Col, { span: 1 }),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: ctl1Span },
	                _react2.default.createElement(
	                    'div',
	                    { style: _extends({}, moveStyle, { float: "left", width: "100%" }) },
	                    ctl1
	                )
	            ),
	            ctl2ShowFlg ? _react2.default.createElement(
	                _antd.Col,
	                { span: 1 },
	                _react2.default.createElement(
	                    'div',
	                    { style: { textAlign: "center", marginTop: 9 } },
	                    '~'
	                )
	            ) : null,
	            ctl2ShowFlg ? _react2.default.createElement(
	                _antd.Col,
	                { span: 6, style: { display: thisObj.state.formsValue[attc]["ctl2Display"] } },
	                _react2.default.createElement(
	                    'div',
	                    { style: _extends({}, moveStyle, { float: "left", width: "100%" }) },
	                    ctl2
	                )
	            ) : null
	        );
	    } else {
	        thisObj.state.forms[attc] = _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 10 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout3, { style: { 'margin-bottom': "1px", 'margin-top': "1px" }, hasFeedback: false, label: text }),
	                    _react2.default.createElement(
	                        _antd.Select,
	                        { disabled: dataRef.matchDis, value: thisObj.state.formsValue[attc]["match_type"], style: { width: '100%' }, onChange: thisObj.handleChange.bind(thisObj, attc, "match_type", dataRef) },
	                        getExpressOptions()
	                    )
	                )
	            ),
	            _react2.default.createElement(_antd.Col, { span: 1 }),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: ctl1Span },
	                _react2.default.createElement(
	                    'div',
	                    { style: _extends({}, moveStyle, { float: "left", width: "100%" }) },
	                    ctl1
	                )
	            ),
	            ctl2ShowFlg ? _react2.default.createElement(
	                _antd.Col,
	                { span: 1 },
	                _react2.default.createElement(
	                    'div',
	                    { style: { textAlign: "center", marginTop: 9 } },
	                    '~'
	                )
	            ) : null,
	            ctl2ShowFlg ? _react2.default.createElement(
	                _antd.Col,
	                { span: 6, style: { display: thisObj.state.formsValue[attc]["ctl2Display"] } },
	                _react2.default.createElement(
	                    'div',
	                    { style: _extends({}, moveStyle, { float: "left", width: "100%" }) },
	                    ctl2
	                )
	            ) : null
	        );
	    }
	};
	var createFormInfo_readOnly = function createFormInfo_readOnly(thisObj, dataRef, matchType, value1, value2) {
	
	    dataRef.desId = dataRef.desId || "EP_EO_UI_3101"; //添加默认值-文本框
	    var moveStyle = {};
	    if (dataRef.desId === "EP_EO_UI_3101" && dataRef.bdText) {
	        // 文本组件存在后置文本时需要进行偏移，这是antd的bug，修复后这里可以取消
	        moveStyle.marginTop = 4;
	        moveStyle.marginBottom = -4;
	    }
	
	    var attc = dataRef.c;
	    var text = dataRef.te;
	
	    var bdInst = attc + "_tmp";
	
	    var ctl2ShowFlg = false;
	
	    //显示的所有属性的集合
	    thisObj.state.checkedAtts[attc] = true;
	
	    thisObj.state.objFct.set(bdInst, thisObj.state.formsValue[attc]);
	
	    //修改c值，给每组值起同样的key
	    dataRef.cRef = attc;
	    var dataRef1 = (0, _rtSdCommon.copy)(dataRef);
	    dataRef1.c = "value1";
	    dataRef1.isLbl = true;
	    dataRef1.isDis = true;
	    if (value1) dataRef1.value = value1;
	    var ctl1 = (0, _rtSdComp.convertModuleByGuid)(thisObj, dataRef1, bdInst, thisObj.state.objFct, "N");
	    ctl1.ref = thisObj.refModalFunction.bind(thisObj);
	    var dataRef2 = (0, _rtSdCommon.copy)(dataRef);
	    dataRef2.c = "value2";
	    dataRef2.isLbl = true;
	    dataRef2.isDis = true;
	    // dataRef2.te = '-';
	    dataRef2.ctlW = 24;
	    dataRef2.lblW = 2;
	    dataRef2.alwBlk = true;
	    if (value2) dataRef2.value = value2;
	    var ctl2 = (0, _rtSdComp.convertModuleByGuid)(thisObj, dataRef2, bdInst, thisObj.state.objFct, "N");
	    if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
	        ctl2.ref = thisObj.refModalFunction.bind(thisObj);
	        ctl2ShowFlg = true;
	    } else {
	        delete ctl2.ref;
	        ctl2ShowFlg = false;
	    }
	
	    var ctl1Span = 6;
	    if (matchType && (matchType == "In" || matchType == "NotIn")) {
	        ctl1Span = 13;
	    }
	
	    thisObj.state.forms[attc] = _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	            _antd.Col,
	            { span: 10 },
	            _react2.default.createElement(
	                FormItem,
	                _extends({}, formItemLayout3, { style: { 'margin-bottom': "1px", 'margin-top': "1px" }, hasFeedback: false, label: text }),
	                _react2.default.createElement(
	                    _antd.Select,
	                    { disabled: true, value: thisObj.state.formsValue[attc]["match_type"], style: { width: '100%' }, onChange: thisObj.handleChange.bind(thisObj, attc, "match_type", dataRef) },
	                    getExpressOptions()
	                )
	            )
	        ),
	        _react2.default.createElement(_antd.Col, { span: 1 }),
	        _react2.default.createElement(
	            _antd.Col,
	            { span: ctl1Span },
	            _react2.default.createElement(
	                'div',
	                { style: _extends({}, moveStyle, { float: "left", width: "100%" }) },
	                ctl1
	            )
	        ),
	        ctl2ShowFlg ? _react2.default.createElement(
	            _antd.Col,
	            { span: 1 },
	            _react2.default.createElement(
	                'div',
	                { style: { textAlign: "center", marginTop: 9 } },
	                '~'
	            )
	        ) : null,
	        ctl2ShowFlg ? _react2.default.createElement(
	            _antd.Col,
	            { span: 6, style: { display: thisObj.state.formsValue[attc]["ctl2Display"] } },
	            _react2.default.createElement(
	                'div',
	                { style: _extends({}, moveStyle, { float: "left", width: "100%" }) },
	                ctl2
	            )
	        ) : null
	    );
	};
	
	/**
	 *  获取  表达式  的标准代码StandardCode
	 */
	var getExpressOptions = function getExpressOptions() {
	
	    var expressSC = StandardCode.getSC('param_SC_param_0002');
	
	    if (!expressSC) {
	        return _react2.default.createElement(
	            Option,
	            { value: '' },
	            '\u4E0D\u5B58\u5728'
	        );
	    }
	
	    var expressOptions = [];
	    expressSC.forEach(function (element) {
	        expressOptions.push(_react2.default.createElement(
	            Option,
	            { value: element.c },
	            element.te
	        ));
	    });
	
	    return expressOptions;
	};
	
	var createSimpleFormInfo = function createSimpleFormInfo(thisObj, dataRef, matchType, value1, value2) {
	
	    dataRef.desId = dataRef.desId || "EP_EO_UI_3101"; //添加默认值-文本框
	
	    var attc = dataRef.c;
	    var text = dataRef.te;
	
	    var bdInst = attc + "_tmp";
	
	    //显示的所有属性的集合
	    thisObj.state.checkedAtts[attc] = true;
	
	    thisObj.state.objFct.set(bdInst, thisObj.state.formsValue[attc]);
	
	    //修改c值，给每组值起同样的key
	    dataRef.cRef = attc;
	    var dataRef1 = (0, _rtSdCommon.copy)(dataRef);
	    dataRef1.c = "value1";
	    dataRef1.isLbl = true;
	    if (value1) dataRef1.value = value1;
	    var ctl1 = (0, _rtSdComp.convertModuleByGuid)(thisObj, dataRef1, bdInst, thisObj.state.objFct, "N");
	    ctl1.ref = thisObj.refModalFunction.bind(thisObj);
	    var dataRef2 = (0, _rtSdCommon.copy)(dataRef);
	    dataRef2.c = "value2";
	    dataRef2.isLbl = false;
	    dataRef2.te = '-';
	    dataRef2.ctlW = 24;
	    dataRef2.lblW = 2, dataRef2.alwBlk = true;
	    if (value2) dataRef2.value = value2;
	    var ctl2 = (0, _rtSdComp.convertModuleByGuid)(thisObj, dataRef2, bdInst, thisObj.state.objFct, "N");
	    if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
	        ctl2.ref = thisObj.refModalFunction.bind(thisObj);
	    } else {
	        delete ctl2.ref;
	    }
	
	    thisObj.state.forms[attc] = _react2.default.createElement(
	        FormItem,
	        _extends({ colon: false }, formItemLayout2, { style: { 'margin-bottom': "1px", 'margin-top': "-3px" }, hasFeedback: false, label: text }),
	        ctl1
	    );
	};
	
	/**
	 * key使用_key,_key没有自动创建
	* @param {*} data
	*/
	var renderTreeNodes = function renderTreeNodes(data, parentDataRef) {
	    return data.map(function (item) {
	        item._key = item._key || tool.uuid();
	        if (item.cldSet) {
	            return _react2.default.createElement(
	                TreeNode,
	                { title: item.te, key: item._key, dataRef: item, parentDataRef: parentDataRef },
	                renderTreeNodes(item.cldSet, item)
	            );
	        }
	        return _react2.default.createElement(TreeNode, { title: item.te, key: item._key, dataRef: item, parentDataRef: parentDataRef });
	    });
	};
	
	var onSelect = function onSelect(selectedKeys, info) {
	    tool.sgiLogger.info('onSelect', info);
	    this.setState({ selectedKeys: selectedKeys });
	};
	
	var onExpand = function onExpand(expandedKeys) {
	    tool.sgiLogger.info('onExpand', expandedKeys);
	    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
	    // or, you can remove all expanded children keys.
	    this.setState({
	        expandedKeys: expandedKeys
	        // autoExpandParent: false,
	    });
	};
	
	exports.createFormInfo = createFormInfo;
	exports.createFormInfo_readOnly = createFormInfo_readOnly;
	exports.createSimpleFormInfo = createSimpleFormInfo;
	exports.getExpressOptions = getExpressOptions;
	exports.renderTreeNodes = renderTreeNodes;
	exports.onSelect = onSelect;
	exports.onExpand = onExpand;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapperRaf;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var id = 0;
	var ids = {}; // Support call raf with delay specified frame
	
	function wrapperRaf(callback) {
	  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var myId = id++;
	  var restFrames = delayFrames;
	
	  function internalCallback() {
	    restFrames -= 1;
	
	    if (restFrames <= 0) {
	      callback();
	      delete ids[myId];
	    } else {
	      ids[myId] = (0, _raf["default"])(internalCallback);
	    }
	  }
	
	  ids[myId] = (0, _raf["default"])(internalCallback);
	  return myId;
	}
	
	wrapperRaf.cancel = function cancel(pid) {
	  if (pid === undefined) return;
	
	  _raf["default"].cancel(ids[pid]);
	
	  delete ids[pid];
	};
	
	wrapperRaf.ids = ids; // export this for test usage

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fixControlledValue = fixControlledValue;
	exports.resolveOnChange = resolveOnChange;
	exports.getInputClassName = getInputClassName;
	exports["default"] = exports.InputSizes = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _type = __webpack_require__(78);
	
	var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(571));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var InputSizes = (0, _type.tuple)('small', 'default', 'large');
	exports.InputSizes = InputSizes;
	
	function fixControlledValue(value) {
	  if (typeof value === 'undefined' || value === null) {
	    return '';
	  }
	
	  return value;
	}
	
	function resolveOnChange(target, e, onChange) {
	  if (onChange) {
	    var event = e;
	
	    if (e.type === 'click') {
	      // click clear icon
	      event = Object.create(e);
	      event.target = target;
	      event.currentTarget = target;
	      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input
	
	      target.value = '';
	      onChange(event); // reset target ref value
	
	      target.value = originalInputValue;
	      return;
	    }
	
	    onChange(event);
	  }
	}
	
	function getInputClassName(prefixCls, size, disabled) {
	  var _classNames;
	
	  return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
	}
	
	var Input = /*#__PURE__*/function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  var _super = _createSuper(Input);
	
	  function Input(props) {
	    var _this;
	
	    _classCallCheck(this, Input);
	
	    _this = _super.call(this, props);
	
	    _this.saveClearableInput = function (input) {
	      _this.clearableInput = input;
	    };
	
	    _this.saveInput = function (input) {
	      _this.input = input;
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.focus();
	      });
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.renderInput = function (prefixCls) {
	      var _this$props = _this.props,
	          className = _this$props.className,
	          addonBefore = _this$props.addonBefore,
	          addonAfter = _this$props.addonAfter,
	          size = _this$props.size,
	          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop
	
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
	      // specify either the value prop, or the defaultValue prop, but not both.
	      'defaultValue', 'size', 'inputType']);
	      return (/*#__PURE__*/React.createElement("input", _extends({}, otherProps, {
	          onChange: _this.handleChange,
	          onKeyDown: _this.handleKeyDown,
	          className: (0, _classnames["default"])(getInputClassName(prefixCls, size, disabled), _defineProperty({}, className, className && !addonBefore && !addonAfter)),
	          ref: _this.saveInput
	        }))
	      );
	    };
	
	    _this.clearPasswordValueAttribute = function () {
	      // https://github.com/ant-design/ant-design/issues/20541
	      _this.removePasswordTimeout = setTimeout(function () {
	        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
	          _this.input.removeAttribute('value');
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props2 = _this.props,
	          onPressEnter = _this$props2.onPressEnter,
	          onKeyDown = _this$props2.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          inputType: "input",
	          value: fixControlledValue(value),
	          element: _this.renderInput(prefixCls),
	          handleReset: _this.handleReset,
	          ref: _this.saveClearableInput
	        }))
	      );
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.clearPasswordValueAttribute();
	    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
	    // We keep an empty function here.
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
	        (0, _warning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
	      }
	
	      return null;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.removePasswordTimeout) {
	        clearTimeout(this.removePasswordTimeout);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Input;
	}(React.Component);
	
	Input.defaultProps = {
	  type: 'text'
	};
	Input.propTypes = {
	  type: PropTypes.string,
	  id: PropTypes.string,
	  size: PropTypes.oneOf(InputSizes),
	  maxLength: PropTypes.number,
	  disabled: PropTypes.bool,
	  value: PropTypes.any,
	  defaultValue: PropTypes.any,
	  className: PropTypes.string,
	  addonBefore: PropTypes.node,
	  addonAfter: PropTypes.node,
	  prefixCls: PropTypes.string,
	  onPressEnter: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onKeyUp: PropTypes.func,
	  onFocus: PropTypes.func,
	  onBlur: PropTypes.func,
	  prefix: PropTypes.node,
	  suffix: PropTypes.node,
	  allowClear: PropTypes.bool
	};
	(0, _reactLifecyclesCompat.polyfill)(Input);
	var _default = Input;
	exports["default"] = _default;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSelect = _interopRequireWildcard(__webpack_require__(191));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _type = __webpack_require__(78);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SelectSizes = (0, _type.tuple)('default', 'large', 'small');
	var ModeOptions = (0, _type.tuple)('default', 'multiple', 'tags', 'combobox', 'SECRET_COMBOBOX_MODE_DO_NOT_USE');
	var SelectPropTypes = {
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  size: PropTypes.oneOf(SelectSizes),
	  notFoundContent: PropTypes.any,
	  showSearch: PropTypes.bool,
	  optionLabelProp: PropTypes.string,
	  transitionName: PropTypes.string,
	  choiceTransitionName: PropTypes.string,
	  id: PropTypes.string
	};
	
	var Select = /*#__PURE__*/function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  var _super = _createSuper(Select);
	
	  function Select(props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _super.call(this, props);
	
	    _this.saveSelect = function (node) {
	      _this.rcSelect = node;
	    };
	
	    _this.renderSelect = function (_ref) {
	      var _classNames;
	
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          _a$className = _a.className,
	          className = _a$className === void 0 ? '' : _a$className,
	          size = _a.size,
	          mode = _a.mode,
	          getPopupContainer = _a.getPopupContainer,
	          removeIcon = _a.removeIcon,
	          clearIcon = _a.clearIcon,
	          menuItemSelectedIcon = _a.menuItemSelectedIcon,
	          showArrow = _a.showArrow,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "mode", "getPopupContainer", "removeIcon", "clearIcon", "menuItemSelectedIcon", "showArrow"]);
	
	      var rest = (0, _omit["default"])(restProps, ['inputIcon']);
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-show-arrow"), showArrow), _classNames), className);
	      var optionLabelProp = _this.props.optionLabelProp;
	
	      if (_this.isCombobox()) {
	        // children 带 dom 结构时，无法填入输入框
	        optionLabelProp = optionLabelProp || 'value';
	      }
	
	      var modeConfig = {
	        multiple: mode === 'multiple',
	        tags: mode === 'tags',
	        combobox: _this.isCombobox()
	      };
	      var finalRemoveIcon = removeIcon && ( /*#__PURE__*/React.isValidElement(removeIcon) ? /*#__PURE__*/React.cloneElement(removeIcon, {
	        className: (0, _classnames["default"])(removeIcon.props.className, "".concat(prefixCls, "-remove-icon"))
	      }) : removeIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        className: "".concat(prefixCls, "-remove-icon")
	      });
	      var finalClearIcon = clearIcon && ( /*#__PURE__*/React.isValidElement(clearIcon) ? /*#__PURE__*/React.cloneElement(clearIcon, {
	        className: (0, _classnames["default"])(clearIcon.props.className, "".concat(prefixCls, "-clear-icon"))
	      }) : clearIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-clear-icon")
	      });
	      var finalMenuItemSelectedIcon = menuItemSelectedIcon && ( /*#__PURE__*/React.isValidElement(menuItemSelectedIcon) ? /*#__PURE__*/React.cloneElement(menuItemSelectedIcon, {
	        className: (0, _classnames["default"])(menuItemSelectedIcon.props.className, "".concat(prefixCls, "-selected-icon"))
	      }) : menuItemSelectedIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "check",
	        className: "".concat(prefixCls, "-selected-icon")
	      });
	      return (/*#__PURE__*/React.createElement(_rcSelect["default"], _extends({
	          inputIcon: _this.renderSuffixIcon(prefixCls),
	          removeIcon: finalRemoveIcon,
	          clearIcon: finalClearIcon,
	          menuItemSelectedIcon: finalMenuItemSelectedIcon,
	          showArrow: showArrow
	        }, rest, modeConfig, {
	          prefixCls: prefixCls,
	          className: cls,
	          optionLabelProp: optionLabelProp || 'children',
	          notFoundContent: _this.getNotFoundContent(renderEmpty),
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          ref: _this.saveSelect
	        }))
	      );
	    };
	
	    (0, _warning["default"])(props.mode !== 'combobox', 'Select', 'The combobox mode is deprecated, ' + 'it will be removed in next major version, ' + 'please use AutoComplete instead');
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "getNotFoundContent",
	    value: function getNotFoundContent(renderEmpty) {
	      var notFoundContent = this.props.notFoundContent;
	
	      if (notFoundContent !== undefined) {
	        return notFoundContent;
	      }
	
	      if (this.isCombobox()) {
	        return null;
	      }
	
	      return renderEmpty('Select');
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcSelect.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSelect.blur();
	    }
	  }, {
	    key: "isCombobox",
	    value: function isCombobox() {
	      var mode = this.props.mode;
	      return mode === 'combobox' || mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE;
	    }
	  }, {
	    key: "renderSuffixIcon",
	    value: function renderSuffixIcon(prefixCls) {
	      var _this$props = this.props,
	          loading = _this$props.loading,
	          suffixIcon = _this$props.suffixIcon;
	
	      if (suffixIcon) {
	        return (/*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	            className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-arrow-icon"))
	          }) : suffixIcon
	        );
	      }
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading"
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "down",
	          className: "".concat(prefixCls, "-arrow-icon")
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSelect)
	      );
	    }
	  }]);
	
	  return Select;
	}(React.Component);
	
	exports["default"] = Select;
	Select.Option = _rcSelect.Option;
	Select.OptGroup = _rcSelect.OptGroup;
	Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
	Select.defaultProps = {
	  showSearch: false,
	  transitionName: 'slide-up',
	  choiceTransitionName: 'zoom'
	};
	Select.propTypes = SelectPropTypes;

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var sgiConstants = {
	    // 层叠面板使用
	    allWVItemKey: "_allWVItems",
	
	    // 数据与属性交互使用【！！！以下数据为key为开发参数使用，不可修改！！！】
	    _checkable: "checkable", //可选
	    _disabled: "disabled", //禁用
	    _selectable: "selectable", //是否可选
	    _draggable: "draggable", //可拖拽
	    _disableCheckbox: "disableCheckbox", //禁掉checkbox
	    _icon: "icon", //图表
	    _checked: "checked", //勾选
	
	    // 操作同步到数据使用，与上面一致
	    checked: "_checked" //勾选
	};
	
	exports.default = sgiConstants;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgiBadge = __webpack_require__(1314);
	
	Object.defineProperty(exports, 'SgiBadge', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiBadge).default;
	  }
	});
	
	var _SgiButton = __webpack_require__(684);
	
	Object.defineProperty(exports, 'SgiButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiButton).default;
	  }
	});
	
	var _SgiCalendar = __webpack_require__(685);
	
	Object.defineProperty(exports, 'SgiCalendar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCalendar).default;
	  }
	});
	
	var _SgiCard = __webpack_require__(686);
	
	Object.defineProperty(exports, 'SgiCard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCard).default;
	  }
	});
	
	var _SgiCodeMirror = __webpack_require__(687);
	
	Object.defineProperty(exports, 'SgiCodeMirror', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCodeMirror).default;
	  }
	});
	
	var _SgiCol = __webpack_require__(688);
	
	Object.defineProperty(exports, 'SgiCol', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCol).default;
	  }
	});
	
	var _SgiCollapse = __webpack_require__(689);
	
	Object.defineProperty(exports, 'SgiCollapse', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCollapse).default;
	  }
	});
	
	var _SgiCommEcharts = __webpack_require__(690);
	
	Object.defineProperty(exports, 'SgiCommEcharts', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCommEcharts).default;
	  }
	});
	
	var _SgiCompComm = __webpack_require__(45);
	
	Object.defineProperty(exports, 'SgiCompComm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCompComm).default;
	  }
	});
	Object.defineProperty(exports, 'convertModuleByGuid', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCompComm.convertModuleByGuid;
	  }
	});
	Object.defineProperty(exports, 'refFunction', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCompComm.refFunction;
	  }
	});
	Object.defineProperty(exports, 'refModalFunction', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCompComm.refModalFunction;
	  }
	});
	Object.defineProperty(exports, 'refModalFunction2', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCompComm.refModalFunction2;
	  }
	});
	Object.defineProperty(exports, 'getPropsFromItem', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCompComm.getPropsFromItem;
	  }
	});
	
	var _SgiCtnComm = __webpack_require__(52);
	
	Object.defineProperty(exports, 'SgiCtnComm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCtnComm).default;
	  }
	});
	Object.defineProperty(exports, 'addCtnCommonAttribute', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCtnComm.addCtnCommonAttribute;
	  }
	});
	Object.defineProperty(exports, 'sgiCtnBaseFun', {
	  enumerable: true,
	  get: function get() {
	    return _SgiCtnComm.sgiCtnBaseFun;
	  }
	});
	
	var _SgiDV = __webpack_require__(370);
	
	Object.defineProperty(exports, 'SgiDV', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiDV).default;
	  }
	});
	
	var _SgiEchartLine = __webpack_require__(1315);
	
	Object.defineProperty(exports, 'SgiEchartLine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiEchartLine).default;
	  }
	});
	
	var _SgiEditor = __webpack_require__(691);
	
	Object.defineProperty(exports, 'SgiEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiEditor).default;
	  }
	});
	
	var _SgiEventHandler = __webpack_require__(54);
	
	Object.defineProperty(exports, 'SgiEventHandler', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiEventHandler).default;
	  }
	});
	
	var _SgiForm = __webpack_require__(692);
	
	Object.defineProperty(exports, 'SgiForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiForm).default;
	  }
	});
	
	var _SgiFormCascader = __webpack_require__(693);
	
	Object.defineProperty(exports, 'SgiFormCascader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCascader).default;
	  }
	});
	
	var _SgiFormCheckbox = __webpack_require__(694);
	
	Object.defineProperty(exports, 'SgiFormCheckbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCheckbox).default;
	  }
	});
	
	var _SgiFormCheckboxGroup = __webpack_require__(695);
	
	Object.defineProperty(exports, 'SgiFormCheckboxGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCheckboxGroup).default;
	  }
	});
	
	var _SgiFormCtlBaseFun = __webpack_require__(1317);
	
	Object.defineProperty(exports, 'SgiFormCtlBaseFun', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCtlBaseFun).default;
	  }
	});
	
	var _SgiFormCtlComm = __webpack_require__(1318);
	
	Object.defineProperty(exports, 'SgiFormCtlComm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCtlComm).default;
	  }
	});
	
	var _SgiFormCtlValidator = __webpack_require__(1319);
	
	Object.defineProperty(exports, 'SgiFormCtlValidator', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCtlValidator).default;
	  }
	});
	
	var _SgiFormDatePicker = __webpack_require__(696);
	
	Object.defineProperty(exports, 'SgiFormDatePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormDatePicker).default;
	  }
	});
	
	var _SgiFormInputNumber = __webpack_require__(697);
	
	Object.defineProperty(exports, 'SgiFormInputNumber', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormInputNumber).default;
	  }
	});
	
	var _SgiFormInputSearch = __webpack_require__(698);
	
	Object.defineProperty(exports, 'SgiFormInputSearch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormInputSearch).default;
	  }
	});
	
	var _SgiFormRadio = __webpack_require__(699);
	
	Object.defineProperty(exports, 'SgiFormRadio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormRadio).default;
	  }
	});
	
	var _SgiFormSelect = __webpack_require__(700);
	
	Object.defineProperty(exports, 'SgiFormSelect', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormSelect).default;
	  }
	});
	
	var _SgiFormText = __webpack_require__(701);
	
	Object.defineProperty(exports, 'SgiFormText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormText).default;
	  }
	});
	
	var _SgiFormTextArea = __webpack_require__(702);
	
	Object.defineProperty(exports, 'SgiFormTextArea', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormTextArea).default;
	  }
	});
	
	var _SgiFormTimePicker = __webpack_require__(703);
	
	Object.defineProperty(exports, 'SgiFormTimePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormTimePicker).default;
	  }
	});
	
	var _SgiFormTreeSelect = __webpack_require__(704);
	
	Object.defineProperty(exports, 'SgiFormTreeSelect', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormTreeSelect).default;
	  }
	});
	
	var _SgiFormUpload = __webpack_require__(705);
	
	Object.defineProperty(exports, 'SgiFormUpload', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormUpload).default;
	  }
	});
	
	var _SgiIcon = __webpack_require__(706);
	
	Object.defineProperty(exports, 'SgiIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiIcon).default;
	  }
	});
	
	var _SgiImg = __webpack_require__(707);
	
	Object.defineProperty(exports, 'SgiImg', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiImg).default;
	  }
	});
	
	var _SgiLabel = __webpack_require__(708);
	
	Object.defineProperty(exports, 'SgiLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiLabel).default;
	  }
	});
	
	var _SgiList = __webpack_require__(709);
	
	Object.defineProperty(exports, 'SgiList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiList).default;
	  }
	});
	
	var _SgiMainComp = __webpack_require__(125);
	
	Object.defineProperty(exports, 'SgiMainComp', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiMainComp).default;
	  }
	});
	
	var _SgiMainCompDemo = __webpack_require__(1321);
	
	Object.defineProperty(exports, 'SgiMainCompDemo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiMainCompDemo).default;
	  }
	});
	
	var _SgiMenu = __webpack_require__(710);
	
	Object.defineProperty(exports, 'SgiMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiMenu).default;
	  }
	});
	
	var _SgiModal = __webpack_require__(711);
	
	Object.defineProperty(exports, 'SgiModal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiModal).default;
	  }
	});
	
	var _SgiNest = __webpack_require__(712);
	
	Object.defineProperty(exports, 'SgiNest', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiNest).default;
	  }
	});
	
	var _SgiOverlap = __webpack_require__(713);
	
	Object.defineProperty(exports, 'SgiOverlap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiOverlap).default;
	  }
	});
	
	var _SgiPanel = __webpack_require__(251);
	
	Object.defineProperty(exports, 'SgiPanel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiPanel).default;
	  }
	});
	
	var _SgiPassword = __webpack_require__(1322);
	
	Object.defineProperty(exports, 'SgiPassword', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiPassword).default;
	  }
	});
	
	var _SgiProgress = __webpack_require__(1323);
	
	Object.defineProperty(exports, 'SgiProgress', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiProgress).default;
	  }
	});
	
	var _SgiQuote = __webpack_require__(714);
	
	Object.defineProperty(exports, 'SgiQuote', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiQuote).default;
	  }
	});
	
	var _SgiRow = __webpack_require__(715);
	
	Object.defineProperty(exports, 'SgiRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiRow).default;
	  }
	});
	
	var _SgiSpin = __webpack_require__(1324);
	
	Object.defineProperty(exports, 'SgiSpin', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiSpin).default;
	  }
	});
	
	var _SgiSplitter = __webpack_require__(716);
	
	Object.defineProperty(exports, 'SgiSplitter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiSplitter).default;
	  }
	});
	
	var _SgiSteps = __webpack_require__(717);
	
	Object.defineProperty(exports, 'SgiSteps', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiSteps).default;
	  }
	});
	
	var _SgiTable = __webpack_require__(719);
	
	Object.defineProperty(exports, 'SgiTable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTable).default;
	  }
	});
	
	var _SgiTableBaseFun = __webpack_require__(371);
	
	Object.defineProperty(exports, 'SgiTableBaseFun', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTableBaseFun).default;
	  }
	});
	
	var _SgiTableEditorCell = __webpack_require__(252);
	
	Object.defineProperty(exports, 'SgiTableEditorCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTableEditorCell).default;
	  }
	});
	
	var _SgiTabs = __webpack_require__(721);
	
	Object.defineProperty(exports, 'SgiTabs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTabs).default;
	  }
	});
	
	var _SgiTile = __webpack_require__(722);
	
	Object.defineProperty(exports, 'SgiTile', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTile).default;
	  }
	});
	
	var _SgiTinyMCE = __webpack_require__(1326);
	
	Object.defineProperty(exports, 'SgiTinyMCE', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTinyMCE).default;
	  }
	});
	
	var _SgiToolbar = __webpack_require__(723);
	
	Object.defineProperty(exports, 'SgiToolbar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiToolbar).default;
	  }
	});
	
	var _SgiTooltip = __webpack_require__(1327);
	
	Object.defineProperty(exports, 'SgiTooltip', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTooltip).default;
	  }
	});
	
	var _SgiTransfer = __webpack_require__(1328);
	
	Object.defineProperty(exports, 'SgiTransfer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTransfer).default;
	  }
	});
	
	var _SgiTree = __webpack_require__(724);
	
	Object.defineProperty(exports, 'SgiTree', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTree).default;
	  }
	});
	
	var _SgiTreeBaseFun = __webpack_require__(725);
	
	Object.defineProperty(exports, 'SgiTreeBaseFun', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTreeBaseFun).default;
	  }
	});
	
	var _SgiTV = __webpack_require__(718);
	
	Object.defineProperty(exports, 'SgiTV', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTV).default;
	  }
	});
	
	var _FormCtlMKComm = __webpack_require__(726);
	
	Object.defineProperty(exports, 'FormCtlMKComm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormCtlMKComm).default;
	  }
	});
	
	var _SgiTextMaker = __webpack_require__(1329);
	
	Object.defineProperty(exports, 'SgiTextMaker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiTextMaker).default;
	  }
	});
	
	var _SgiCommon = __webpack_require__(29);
	
	Object.defineProperty(exports, 'SgiCommon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCommon).default;
	  }
	});
	
	var _SgiComponent = __webpack_require__(204);
	
	Object.defineProperty(exports, 'SgiComponent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiComponent).default;
	  }
	});
	
	var _SgiCtlComponent = __webpack_require__(161);
	
	Object.defineProperty(exports, 'SgiCtlComponent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCtlComponent).default;
	  }
	});
	
	var _SgiCtnCommon = __webpack_require__(1330);
	
	Object.defineProperty(exports, 'SgiCtnCommon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCtnCommon).default;
	  }
	});
	
	var _SgiCtnComponent = __webpack_require__(253);
	
	Object.defineProperty(exports, 'SgiCtnComponent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiCtnComponent).default;
	  }
	});
	
	var _SgiFormCtlComponent = __webpack_require__(727);
	
	Object.defineProperty(exports, 'SgiFormCtlComponent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiFormCtlComponent).default;
	  }
	});
	
	var _SgiEChartsCommon = __webpack_require__(728);
	
	Object.defineProperty(exports, 'SgiEChartsCommon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiEChartsCommon).default;
	  }
	});
	
	var _SgiEChartsComponent = __webpack_require__(729);
	
	Object.defineProperty(exports, 'SgiEChartsComponent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SgiEChartsComponent).default;
	  }
	});
	
	var _sgiCustomModule = __webpack_require__(1333);
	
	Object.defineProperty(exports, 'sgiCustomModule', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sgiCustomModule).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapperRaf;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var id = 0;
	var ids = {}; // Support call raf with delay specified frame
	
	function wrapperRaf(callback) {
	  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var myId = id++;
	  var restFrames = delayFrames;
	
	  function internalCallback() {
	    restFrames -= 1;
	
	    if (restFrames <= 0) {
	      callback();
	      delete ids[myId];
	    } else {
	      ids[myId] = (0, _raf["default"])(internalCallback);
	    }
	  }
	
	  ids[myId] = (0, _raf["default"])(internalCallback);
	  return myId;
	}
	
	wrapperRaf.cancel = function cancel(pid) {
	  if (pid === undefined) return;
	
	  _raf["default"].cancel(ids[pid]);
	
	  delete ids[pid];
	};
	
	wrapperRaf.ids = ids; // export this for test usage

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fixControlledValue = fixControlledValue;
	exports.resolveOnChange = resolveOnChange;
	exports.getInputClassName = getInputClassName;
	exports["default"] = exports.InputSizes = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _type = __webpack_require__(82);
	
	var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(649));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var InputSizes = (0, _type.tuple)('small', 'default', 'large');
	exports.InputSizes = InputSizes;
	
	function fixControlledValue(value) {
	  if (typeof value === 'undefined' || value === null) {
	    return '';
	  }
	
	  return value;
	}
	
	function resolveOnChange(target, e, onChange) {
	  if (onChange) {
	    var event = e;
	
	    if (e.type === 'click') {
	      // click clear icon
	      event = Object.create(e);
	      event.target = target;
	      event.currentTarget = target;
	      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input
	
	      target.value = '';
	      onChange(event); // reset target ref value
	
	      target.value = originalInputValue;
	      return;
	    }
	
	    onChange(event);
	  }
	}
	
	function getInputClassName(prefixCls, size, disabled) {
	  var _classNames;
	
	  return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
	}
	
	var Input = /*#__PURE__*/function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  var _super = _createSuper(Input);
	
	  function Input(props) {
	    var _this;
	
	    _classCallCheck(this, Input);
	
	    _this = _super.call(this, props);
	
	    _this.saveClearableInput = function (input) {
	      _this.clearableInput = input;
	    };
	
	    _this.saveInput = function (input) {
	      _this.input = input;
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.focus();
	      });
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.renderInput = function (prefixCls) {
	      var _this$props = _this.props,
	          className = _this$props.className,
	          addonBefore = _this$props.addonBefore,
	          addonAfter = _this$props.addonAfter,
	          size = _this$props.size,
	          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop
	
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
	      // specify either the value prop, or the defaultValue prop, but not both.
	      'defaultValue', 'size', 'inputType']);
	      return (/*#__PURE__*/React.createElement("input", _extends({}, otherProps, {
	          onChange: _this.handleChange,
	          onKeyDown: _this.handleKeyDown,
	          className: (0, _classnames["default"])(getInputClassName(prefixCls, size, disabled), _defineProperty({}, className, className && !addonBefore && !addonAfter)),
	          ref: _this.saveInput
	        }))
	      );
	    };
	
	    _this.clearPasswordValueAttribute = function () {
	      // https://github.com/ant-design/ant-design/issues/20541
	      _this.removePasswordTimeout = setTimeout(function () {
	        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
	          _this.input.removeAttribute('value');
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props2 = _this.props,
	          onPressEnter = _this$props2.onPressEnter,
	          onKeyDown = _this$props2.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          inputType: "input",
	          value: fixControlledValue(value),
	          element: _this.renderInput(prefixCls),
	          handleReset: _this.handleReset,
	          ref: _this.saveClearableInput
	        }))
	      );
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.clearPasswordValueAttribute();
	    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
	    // We keep an empty function here.
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
	        (0, _warning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
	      }
	
	      return null;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.removePasswordTimeout) {
	        clearTimeout(this.removePasswordTimeout);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Input;
	}(React.Component);
	
	Input.defaultProps = {
	  type: 'text'
	};
	Input.propTypes = {
	  type: PropTypes.string,
	  id: PropTypes.string,
	  size: PropTypes.oneOf(InputSizes),
	  maxLength: PropTypes.number,
	  disabled: PropTypes.bool,
	  value: PropTypes.any,
	  defaultValue: PropTypes.any,
	  className: PropTypes.string,
	  addonBefore: PropTypes.node,
	  addonAfter: PropTypes.node,
	  prefixCls: PropTypes.string,
	  onPressEnter: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onKeyUp: PropTypes.func,
	  onFocus: PropTypes.func,
	  onBlur: PropTypes.func,
	  prefix: PropTypes.node,
	  suffix: PropTypes.node,
	  allowClear: PropTypes.bool
	};
	(0, _reactLifecyclesCompat.polyfill)(Input);
	var _default = Input;
	exports["default"] = _default;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSelect = _interopRequireWildcard(__webpack_require__(191));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _type = __webpack_require__(82);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SelectSizes = (0, _type.tuple)('default', 'large', 'small');
	var ModeOptions = (0, _type.tuple)('default', 'multiple', 'tags', 'combobox', 'SECRET_COMBOBOX_MODE_DO_NOT_USE');
	var SelectPropTypes = {
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  size: PropTypes.oneOf(SelectSizes),
	  notFoundContent: PropTypes.any,
	  showSearch: PropTypes.bool,
	  optionLabelProp: PropTypes.string,
	  transitionName: PropTypes.string,
	  choiceTransitionName: PropTypes.string,
	  id: PropTypes.string
	};
	
	var Select = /*#__PURE__*/function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  var _super = _createSuper(Select);
	
	  function Select(props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _super.call(this, props);
	
	    _this.saveSelect = function (node) {
	      _this.rcSelect = node;
	    };
	
	    _this.renderSelect = function (_ref) {
	      var _classNames;
	
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          _a$className = _a.className,
	          className = _a$className === void 0 ? '' : _a$className,
	          size = _a.size,
	          mode = _a.mode,
	          getPopupContainer = _a.getPopupContainer,
	          removeIcon = _a.removeIcon,
	          clearIcon = _a.clearIcon,
	          menuItemSelectedIcon = _a.menuItemSelectedIcon,
	          showArrow = _a.showArrow,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "mode", "getPopupContainer", "removeIcon", "clearIcon", "menuItemSelectedIcon", "showArrow"]);
	
	      var rest = (0, _omit["default"])(restProps, ['inputIcon']);
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-show-arrow"), showArrow), _classNames), className);
	      var optionLabelProp = _this.props.optionLabelProp;
	
	      if (_this.isCombobox()) {
	        // children 带 dom 结构时，无法填入输入框
	        optionLabelProp = optionLabelProp || 'value';
	      }
	
	      var modeConfig = {
	        multiple: mode === 'multiple',
	        tags: mode === 'tags',
	        combobox: _this.isCombobox()
	      };
	      var finalRemoveIcon = removeIcon && ( /*#__PURE__*/React.isValidElement(removeIcon) ? /*#__PURE__*/React.cloneElement(removeIcon, {
	        className: (0, _classnames["default"])(removeIcon.props.className, "".concat(prefixCls, "-remove-icon"))
	      }) : removeIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        className: "".concat(prefixCls, "-remove-icon")
	      });
	      var finalClearIcon = clearIcon && ( /*#__PURE__*/React.isValidElement(clearIcon) ? /*#__PURE__*/React.cloneElement(clearIcon, {
	        className: (0, _classnames["default"])(clearIcon.props.className, "".concat(prefixCls, "-clear-icon"))
	      }) : clearIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-clear-icon")
	      });
	      var finalMenuItemSelectedIcon = menuItemSelectedIcon && ( /*#__PURE__*/React.isValidElement(menuItemSelectedIcon) ? /*#__PURE__*/React.cloneElement(menuItemSelectedIcon, {
	        className: (0, _classnames["default"])(menuItemSelectedIcon.props.className, "".concat(prefixCls, "-selected-icon"))
	      }) : menuItemSelectedIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "check",
	        className: "".concat(prefixCls, "-selected-icon")
	      });
	      return (/*#__PURE__*/React.createElement(_rcSelect["default"], _extends({
	          inputIcon: _this.renderSuffixIcon(prefixCls),
	          removeIcon: finalRemoveIcon,
	          clearIcon: finalClearIcon,
	          menuItemSelectedIcon: finalMenuItemSelectedIcon,
	          showArrow: showArrow
	        }, rest, modeConfig, {
	          prefixCls: prefixCls,
	          className: cls,
	          optionLabelProp: optionLabelProp || 'children',
	          notFoundContent: _this.getNotFoundContent(renderEmpty),
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          ref: _this.saveSelect
	        }))
	      );
	    };
	
	    (0, _warning["default"])(props.mode !== 'combobox', 'Select', 'The combobox mode is deprecated, ' + 'it will be removed in next major version, ' + 'please use AutoComplete instead');
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "getNotFoundContent",
	    value: function getNotFoundContent(renderEmpty) {
	      var notFoundContent = this.props.notFoundContent;
	
	      if (notFoundContent !== undefined) {
	        return notFoundContent;
	      }
	
	      if (this.isCombobox()) {
	        return null;
	      }
	
	      return renderEmpty('Select');
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcSelect.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSelect.blur();
	    }
	  }, {
	    key: "isCombobox",
	    value: function isCombobox() {
	      var mode = this.props.mode;
	      return mode === 'combobox' || mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE;
	    }
	  }, {
	    key: "renderSuffixIcon",
	    value: function renderSuffixIcon(prefixCls) {
	      var _this$props = this.props,
	          loading = _this$props.loading,
	          suffixIcon = _this$props.suffixIcon;
	
	      if (suffixIcon) {
	        return (/*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	            className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-arrow-icon"))
	          }) : suffixIcon
	        );
	      }
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading"
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "down",
	          className: "".concat(prefixCls, "-arrow-icon")
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSelect)
	      );
	    }
	  }]);
	
	  return Select;
	}(React.Component);
	
	exports["default"] = Select;
	Select.Option = _rcSelect.Option;
	Select.OptGroup = _rcSelect.OptGroup;
	Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
	Select.defaultProps = {
	  showSearch: false,
	  transitionName: 'slide-up',
	  choiceTransitionName: 'zoom'
	};
	Select.propTypes = SelectPropTypes;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var EditorIconTypes = exports.EditorIconTypes = {
		"source": {
			title: "源代码",
			disabled: false
		},
		"separator": {
			disabled: false
		},
		"undo": {
			title: "撤销",
			disabled: false
		},
		"redo": {
			title: "重做",
			disabled: false
		},
		"bold": {
			title: "加粗",
			disabled: false
		},
		"italic": {
			title: "斜线",
			disabled: false
		},
		"underline": {
			title: "下划线",
			disabled: false
		},
		"strikethrough": {
			title: "删除线",
			disabled: false
		},
		"superscript": {
			title: "上标",
			disabled: false
		},
		"subscript": {
			title: "下标",
			disabled: false
		},
		"forecolor": {
			title: "字体颜色",
			disabled: false
		},
		"backcolor": {
			title: "背景色",
			disabled: false
		},
		"removeformat": {
			title: "清除格式",
			disabled: false
		},
		"insertunorderedlist": {
			title: "无序列表",
			disabled: false
		},
		"insertorderedlist": {
			title: "有序列表",
			disabled: false
		},
		"selectall": {
			title: "全选",
			disabled: false
		},
		"cleardoc": {
			title: "清空文档",
			disabled: false
		},
		"paragraph": {
			title: "段落格式",
			disabled: false
		},
		"fontfamily": {
			title: "字体",
			disabled: false
		},
		"fontsize": {
			title: "字号",
			disabled: false
		},
		"justifyleft": {
			title: "居左对齐",
			disabled: false
		},
		"justifycenter": {
			title: "居中对齐",
			disabled: false
		},
		"justifyright": {
			title: "居右对齐",
			disabled: false
		},
		"link": {
			title: "超链接",
			disabled: false
		},
		"unlink": {
			title: "取消链接",
			disabled: false
		},
		"emotion": {
			title: "表情",
			disabled: false
		},
		"image": {
			title: "图片",
			disabled: false
		},
		"video": {
			title: "视频",
			disabled: false
		},
		"map": {
			title: "百度地图",
			disabled: false
		},
		"horizontal": {
			title: "分隔线",
			disabled: false
		},
		"print": {
			title: "打印",
			disabled: false
		},
		"preview": {
			title: "预览",
			disabled: false
		},
		"drafts": {
			title: "草稿箱",
			disabled: false
		},
		"formula": {
			title: "数学公式",
			disabled: false
		},
		"inserttable": {
			title: "插入表格",
			disabled: false
		},
		"touppercase": {
			title: "转换大写",
			disabled: false
		},
		"tolowercase": {
			title: "转换小写",
			disabled: false
		},
		"indent": {
			title: "增加缩进",
			disabled: false
		},
		"outdent": {
			title: "减少缩进",
			disabled: false
		},
		"spechars": {
			title: "特殊符号",
			disabled: false
		},
		"fontborder": {
			title: "字体边框",
			disabled: false
		},
		"date": {
			title: "插入日期",
			disabled: false
		},
		"time": {
			title: "插入时间",
			disabled: false
		},
		"emphasis": {
			title: "着重号",
			disabled: false
		}
	};
	
	var ColorTypes = exports.ColorTypes = {
		themeColors: [["#fff", "#000", "#eeece1", "#1f497d", "#4f81bd", "#c0504d", "#9bbb59", "#8064a2", "#4bacc6", "#f79646"], ["#f2f2f2", "7f7f7f", "#ddd9c3", "#c6d9f0", "#dbe5f1", "#f2dcdb", "#ebf1dd", "#e5e0ec", "#dbeef3", "#fdeada"], ["#d8d8d8", "#595959", "#c4bd97", "#8db3e2", "#b8cce4", "#e5b9b7", "#d7e3bc", "#ccc1d9", "#b7dde8", "#fbd5b5"], ["#bfbfbf", "#3f3f3f", "#938953", "#548dd4", "#95b3d7", "#d99694", "#c3d69b", "#b2a2c7", "#92cddc", "#fac08f"], ["#a5a5a5", "#262626", "#494429", "#17365d", "#366092", "#953734", "#76923c", "#5f497a", "#31859b", "#e36c09"], ["#7f7f7f", "#0c0c0c", "#1d1b10", "#0f243e", "#244061", "#632423", "#4f6128", "#3f3151", "#205867", "#974806"]],
		standardColors: ["#c00000", "#ff0000", "#ffc000", "#ffff00", "#92d050", "#00b050", "#00b0f0", "#0070c0", "#002060", "#7030a0"]
	};
	
	var FormulaTypes = exports.FormulaTypes = {
		commonFormulas: [{ backgroundPosition: "-0px -0px", latex: "\\frac{ }{ }" }, { backgroundPosition: "-30px -0px", latex: "^{ }/_{ }" }, { backgroundPosition: "-60px -0px", latex: "x^{ }" }, { backgroundPosition: "-90px -0px", latex: "x_{ }" }, { backgroundPosition: "-120px -0px", latex: "x^{ }_{ }" }, { backgroundPosition: "-150px -0px", latex: "\\bar{ }" }, { backgroundPosition: "-180px -0px", latex: "\\sqrt{ }" }, { backgroundPosition: "-210px -0px", latex: "\\nthroot{ }{ }" }, { backgroundPosition: "-0px -30px", latex: "\\sum^{ }_{n=}" }, { backgroundPosition: "-60px -30px", latex: "\\log_{ }" }, { backgroundPosition: "-90px -30px", latex: "\\ln" }, { backgroundPosition: "-120px -30px", latex: "\\int_{ }^{ }" }, { backgroundPosition: "-150px -30px", latex: "\\oint_{ }^{ }" }],
		symbolFormulas: [{ backgroundPosition: "-0px -60px", latex: "+" }, { backgroundPosition: "-30px -60px", latex: "-" }, { backgroundPosition: "-60px -60px", latex: "\\pm" }, { backgroundPosition: "-90px -60px", latex: "\\times" }, { backgroundPosition: "-120px -60px", latex: "\\ast" }, { backgroundPosition: "-150px -60px", latex: "\\div" }, { backgroundPosition: "-180px -60px", latex: "/" }, { backgroundPosition: "-210px -60px", latex: "\\bigtriangleup" }, { backgroundPosition: "-0px -90px", latex: "=" }, { backgroundPosition: "-30px -90px", latex: "\\ne" }, { backgroundPosition: "-60px -90px", latex: "\\approx" }, { backgroundPosition: "-90px -90px", latex: ">" }, { backgroundPosition: "-120px -90px", latex: "<" }, { backgroundPosition: "-150px -90px", latex: "\\ge" }, { backgroundPosition: "-180px -90px", latex: "\\le" }, { backgroundPosition: "-210px -90px", latex: "\\infty" }, { backgroundPosition: "-0px -120px", latex: "\\cap" }, { backgroundPosition: "-30px -120px", latex: "\\cup" }, { backgroundPosition: "-60px -120px", latex: "\\because" }, { backgroundPosition: "-90px -120px", latex: "\\therefore" }, { backgroundPosition: "-120px -120px", latex: "\\subset" }, { backgroundPosition: "-150px -120px", latex: "\\supset" }, { backgroundPosition: "-180px -120px", latex: "\\subseteq" }, { backgroundPosition: "-210px -120px", latex: "\\supseteq" }, { backgroundPosition: "-0px -150px", latex: "\\nsubseteq" }, { backgroundPosition: "-30px -150px", latex: "\\nsupseteq" }, { backgroundPosition: "-60px -150px", latex: "\\in" }, { backgroundPosition: "-90px -150px", latex: "\\ni" }, { backgroundPosition: "-120px -150px", latex: "\\notin" }, { backgroundPosition: "-150px -150px", latex: "\\mapsto" }, { backgroundPosition: "-180px -150px", latex: "\\leftarrow" }, { backgroundPosition: "-210px -150px", latex: "\\rightarrow" }, { backgroundPosition: "-0px -180px", latex: "\\Leftarrow" }, { backgroundPosition: "-30px -180px", latex: "\\Rightarrow" }, { backgroundPosition: "-60px -180px", latex: "\\leftrightarrow" }, { backgroundPosition: "-90px -180px", latex: "\\Leftrightarrow" }],
		arabicFormulas: [{ backgroundPosition: "-0px -210px", latex: "\\alpha" }, { backgroundPosition: "-30px -210px", latex: "\\beta" }, { backgroundPosition: "-60px -210px", latex: "\\gamma" }, { backgroundPosition: "-90px -210px", latex: "\\delta" }, { backgroundPosition: "-120px -210px", latex: "\\varepsilon" }, { backgroundPosition: "-150px -210px", latex: "\\varphi" }, { backgroundPosition: "-180px -210px", latex: "\\lambda" }, { backgroundPosition: "-210px -210px", latex: "\\mu" }, { backgroundPosition: "-0px -240px", latex: "\\rho" }, { backgroundPosition: "-30px -240px", latex: "\\sigma" }, { backgroundPosition: "-60px -240px", latex: "\\omega" }, { backgroundPosition: "-90px -240px", latex: "\\Gamma" }, { backgroundPosition: "-120px -240px", latex: "\\Delta" }, { backgroundPosition: "-150px -240px", latex: "\\Theta" }, { backgroundPosition: "-180px -240px", latex: "\\Lambda" }, { backgroundPosition: "-210px -240px", latex: "\\Xi" }, { backgroundPosition: "-0px -270px", latex: "\\Pi" }, { backgroundPosition: "-30px -270px", latex: "\\Sigma" }, { backgroundPosition: "-60px -270px", latex: "\\Upsilon" }, { backgroundPosition: "-90px -270px", latex: "\\Phi" }, { backgroundPosition: "-120px -270px", latex: "\\Psi" }, { backgroundPosition: "-150px -270px", latex: "\\Omega" }]
	};
	
	var toArray = function toArray(str) {
		return str.split(",");
	};
	var SpecialChars = exports.SpecialChars = [{ name: "tsfh", title: "特殊字符", chars: toArray("、,。,·,ˉ,ˇ,¨,〃,々,—,～,‖,…,‘,’,“,”,〔,〕,〈,〉,《,》,「,」,『,』,〖,〗,【,】,±,×,÷,∶,∧,∨,∑,∏,∪,∩,∈,∷,√,⊥,∥,∠,⌒,⊙,∫,∮,≡,≌,≈,∽,∝,≠,≮,≯,≤,≥,∞,∵,∴,♂,♀,°,′,″,℃,＄,¤,￠,￡,‰,§,№,☆,★,○,●,◎,◇,◆,□,■,△,▲,※,→,←,↑,↓,〓,〡,〢,〣,〤,〥,〦,〧,〨,〩,㊣,㎎,㎏,㎜,㎝,㎞,㎡,㏄,㏎,㏑,㏒,㏕,︰,￢,￤,℡,ˊ,ˋ,˙,–,―,‥,‵,℅,℉,↖,↗,↘,↙,∕,∟,∣,≒,≦,≧,⊿,═,║,╒,╓,╔,╕,╖,╗,╘,╙,╚,╛,╜,╝,╞,╟,╠,╡,╢,╣,╤,╥,╦,╧,╨,╩,╪,╫,╬,╭,╮,╯,╰,╱,╲,╳,▁,▂,▃,▄,▅,▆,▇,�,█,▉,▊,▋,▌,▍,▎,▏,▓,▔,▕,▼,▽,◢,◣,◤,◥,☉,⊕,〒,〝,〞") }, { name: "lmsz", title: "罗马字符", chars: toArray("ⅰ,ⅱ,ⅲ,ⅳ,ⅴ,ⅵ,ⅶ,ⅷ,ⅸ,ⅹ,Ⅰ,Ⅱ,Ⅲ,Ⅳ,Ⅴ,Ⅵ,Ⅶ,Ⅷ,Ⅸ,Ⅹ,Ⅺ,Ⅻ") }, { name: "szfh", title: "数学字符", chars: toArray("⒈,⒉,⒊,⒋,⒌,⒍,⒎,⒏,⒐,⒑,⒒,⒓,⒔,⒕,⒖,⒗,⒘,⒙,⒚,⒛,⑴,⑵,⑶,⑷,⑸,⑹,⑺,⑻,⑼,⑽,⑾,⑿,⒀,⒁,⒂,⒃,⒄,⒅,⒆,⒇,①,②,③,④,⑤,⑥,⑦,⑧,⑨,⑩,㈠,㈡,㈢,㈣,㈤,㈥,㈦,㈧,㈨,㈩") }, { name: "rwfh", title: "日文字符", chars: toArray("ぁ,あ,ぃ,い,ぅ,う,ぇ,え,ぉ,お,か,が,き,ぎ,く,ぐ,け,げ,こ,ご,さ,ざ,し,じ,す,ず,せ,ぜ,そ,ぞ,た,だ,ち,ぢ,っ,つ,づ,て,で,と,ど,な,に,ぬ,ね,の,は,ば,ぱ,ひ,び,ぴ,ふ,ぶ,ぷ,へ,べ,ぺ,ほ,ぼ,ぽ,ま,み,む,め,も,ゃ,や,ゅ,ゆ,ょ,よ,ら,り,る,れ,ろ,ゎ,わ,ゐ,ゑ,を,ん,ァ,ア,ィ,イ,ゥ,ウ,ェ,エ,ォ,オ,カ,ガ,キ,ギ,ク,グ,ケ,ゲ,コ,ゴ,サ,ザ,シ,ジ,ス,ズ,セ,ゼ,ソ,ゾ,タ,ダ,チ,ヂ,ッ,ツ,ヅ,テ,デ,ト,ド,ナ,ニ,ヌ,ネ,ノ,ハ,バ,パ,ヒ,ビ,ピ,フ,ブ,プ,ヘ,ベ,ペ,ホ,ボ,ポ,マ,ミ,ム,メ,モ,ャ,ヤ,ュ,ユ,ョ,ヨ,ラ,リ,ル,レ,ロ,ヮ,ワ,ヰ,ヱ,ヲ,ン,ヴ,ヵ,ヶ") }, { name: "xlzm", title: "希腊字符", chars: toArray("Α,Β,Γ,Δ,Ε,Ζ,Η,Θ,Ι,Κ,Λ,Μ,Ν,Ξ,Ο,Π,Ρ,Σ,Τ,Υ,Φ,Χ,Ψ,Ω,α,β,γ,δ,ε,ζ,η,θ,ι,κ,λ,μ,ν,ξ,ο,π,ρ,σ,τ,υ,φ,χ,ψ,ω") }, { name: "ewzm", title: "俄文字符", chars: toArray("А,Б,В,Г,Д,Е,Ё,Ж,З,И,Й,К,Л,М,Н,О,П,Р,С,Т,У,Ф,Х,Ц,Ч,Ш,Щ,Ъ,Ы,Ь,Э,Ю,Я,а,б,в,г,д,е,ё,ж,з,и,й,к,л,м,н,о,п,р,с,т,у,ф,х,ц,ч,ш,щ,ъ,ы,ь,э,ю,я") }, { name: "pyzm", title: "拼音字母", chars: toArray("ā,á,ǎ,à,ē,é,ě,è,ī,í,ǐ,ì,ō,ó,ǒ,ò,ū,ú,ǔ,ù,ǖ,ǘ,ǚ,ǜ,ü") }, { name: "yyyb", title: "英语音标", chars: toArray("i:,i,e,æ,ʌ,ə:,ə,u:,u,ɔ:,ɔ,a:,ei,ai,ɔi,əu,au,iə,εə,uə,p,t,k,b,d,g,f,s,ʃ,θ,h,v,z,ʒ,ð,tʃ,tr,ts,dʒ,dr,dz,m,n,ŋ,l,r,w,j,") }, { name: "zyzf", title: "其它", chars: toArray("ㄅ,ㄆ,ㄇ,ㄈ,ㄉ,ㄊ,ㄋ,ㄌ,ㄍ,ㄎ,ㄏ,ㄐ,ㄑ,ㄒ,ㄓ,ㄔ,ㄕ,ㄖ,ㄗ,ㄘ,ㄙ,ㄚ,ㄛ,ㄜ,ㄝ,ㄞ,ㄟ,ㄠ,ㄡ,ㄢ,ㄣ,ㄤ,ㄥ,ㄦ,ㄧ,ㄨ") }];
	var EmotionImages = exports.EmotionImages = {
		DemoUrl: "http://img.baidu.com/hi/tsj/t_0001.gif",
		BaseUrl: "http://img.baidu.com/hi/",
		SmileyInfor: {
			tab0: ['Kiss', 'Love', 'Yeah', '啊！', '背扭', '顶', '抖胸', '88', '汗', '瞌睡', '鲁拉', '拍砖', '揉脸', '生日快乐', '大笑', '瀑布汗~', '惊讶', '臭美', '傻笑', '抛媚眼', '发怒', '打酱油', '俯卧撑', '气愤', '?', '吻', '怒', '胜利', 'HI', 'KISS', '不说', '不要', '扯花', '大心', '顶', '大惊', '飞吻', '鬼脸', '害羞', '口水', '狂哭', '来', '发财了', '吃西瓜', '套牢', '害羞', '庆祝', '我来了', '敲打', '晕了', '胜利', '臭美', '被打了', '贪吃', '迎接', '酷', '微笑', '亲吻', '调皮', '惊恐', '耍酷', '发火', '害羞', '汗水', '大哭', '', '加油', '困', '你NB', '晕倒', '开心', '偷笑', '大哭', '滴汗', '叹气', '超赞', '??', '飞吻', '天使', '撒花', '生气', '被砸', '吓傻', '随意吐'],
			tab1: ['Kiss', 'Love', 'Yeah', '啊！', '背扭', '顶', '抖胸', '88', '汗', '瞌睡', '鲁拉', '拍砖', '揉脸', '生日快乐', '摊手', '睡觉', '瘫坐', '无聊', '星星闪', '旋转', '也不行', '郁闷', '正Music', '抓墙', '撞墙至死', '歪头', '戳眼', '飘过', '互相拍砖', '砍死你', '扔桌子', '少林寺', '什么？', '转头', '我爱牛奶', '我踢', '摇晃', '晕厥', '在笼子里', '震荡'],
			tab2: ['大笑', '瀑布汗~', '惊讶', '臭美', '傻笑', '抛媚眼', '发怒', '我错了', 'money', '气愤', '挑逗', '吻', '怒', '胜利', '委屈', '受伤', '说啥呢？', '闭嘴', '不', '逗你玩儿', '飞吻', '眩晕', '魔法', '我来了', '睡了', '我打', '闭嘴', '打', '打晕了', '刷牙', '爆揍', '炸弹', '倒立', '刮胡子', '邪恶的笑', '不要不要', '爱恋中', '放大仔细看', '偷窥', '超高兴', '晕', '松口气', '我跑', '享受', '修养', '哭', '汗', '啊~', '热烈欢迎', '打酱油', '俯卧撑', '?'],
			tab3: ['HI', 'KISS', '不说', '不要', '扯花', '大心', '顶', '大惊', '飞吻', '鬼脸', '害羞', '口水', '狂哭', '来', '泪眼', '流泪', '生气', '吐舌', '喜欢', '旋转', '再见', '抓狂', '汗', '鄙视', '拜', '吐血', '嘘', '打人', '蹦跳', '变脸', '扯肉', '吃To', '吃花', '吹泡泡糖', '大变身', '飞天舞', '回眸', '可怜', '猛抽', '泡泡', '苹果', '亲', '', '骚舞', '烧香', '睡', '套娃娃', '捅捅', '舞倒', '西红柿', '爱慕', '摇', '摇摆', '杂耍', '招财', '被殴', '被球闷', '大惊', '理想', '欧打', '呕吐', '碎', '吐痰'],
			tab4: ['发财了', '吃西瓜', '套牢', '害羞', '庆祝', '我来了', '敲打', '晕了', '胜利', '臭美', '被打了', '贪吃', '迎接', '酷', '顶', '幸运', '爱心', '躲', '送花', '选择'],
			tab5: ['微笑', '亲吻', '调皮', '惊讶', '耍酷', '发火', '害羞', '汗水', '大哭', '得意', '鄙视', '困', '夸奖', '晕倒', '疑问', '媒婆', '狂吐', '青蛙', '发愁', '亲吻', '', '爱心', '心碎', '玫瑰', '礼物', '哭', '奸笑', '可爱', '得意', '呲牙', '暴汗', '楚楚可怜', '困', '哭', '生气', '惊讶', '口水', '彩虹', '夜空', '太阳', '钱钱', '灯泡', '咖啡', '蛋糕', '音乐', '爱', '胜利', '赞', '鄙视', 'OK'],
			tab6: ['男兜', '女兜', '开心', '乖乖', '偷笑', '大笑', '抽泣', '大哭', '无奈', '滴汗', '叹气', '狂晕', '委屈', '超赞', '??', '疑问', '飞吻', '天使', '撒花', '生气', '被砸', '口水', '泪奔', '吓傻', '吐舌头', '点头', '随意吐', '旋转', '困困', '鄙视', '狂顶', '篮球', '再见', '欢迎光临', '恭喜发财', '稍等', '我在线', '恕不议价', '库房有货', '货在路上']
		},
		EmotionTabs: {
			tab0: { name: "精选", prefix: "j_00", path: "jx2/" },
			tab1: { name: "兔斯基", prefix: "t_00", path: "tsj/" },
			tab2: { name: "绿豆蛙", prefix: "w_00", path: "ldw/" },
			tab3: { name: "BOBO", prefix: "B_00", path: "bobo/" },
			tab4: { name: "baby猫", prefix: "C_00", path: "babycat/" },
			tab5: { name: "泡泡", prefix: "i_f", path: "face/" },
			tab6: { name: "有啊", prefix: "y_00", path: "youa/" }
		}
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiComponent = function (_React$Component) {
	    _inherits(SgiComponent, _React$Component);
	
	    /******************************** 生命周期 ********************************/
	    /**************** 加载阶段 ****************/
	    /**
	     * 生命周期-constructor
	     * 加载的时候调用一次，可以初始化state
	     * @param {*} props 
	     */
	    function SgiComponent(props) {
	        _classCallCheck(this, SgiComponent);
	
	        var _this = _possibleConstructorReturn(this, (SgiComponent.__proto__ || Object.getPrototypeOf(SgiComponent)).call(this, props));
	
	        _this.reload = function () {
	            _this.loaded = false;
	
	            // 重置数据（引用，否则react16不更新组件）--并没有解决实际问题
	            // this.constructor(this.props);
	
	            _this.setState({});
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({});
	        };
	
	        _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + props._name + '][' + props._key + '] constructor');
	        // 状态集
	        _this.state = {
	            _props: {},
	            _class: [],
	            _style: {}
	        };
	        // 数据集
	        _this.data = {
	            functions: {}
	        };
	        // 事件集，外部为组件自定义的事件集
	        _this.funs = {};
	
	        // 事件集解析
	        if (_this.props.moduleDesc && _this.props.moduleDesc.funs) {
	            var funs = _this.props.moduleDesc.funs;
	            try {
	                var $funs = new Function("module", "objFct", funs);
	                var objFct = _this.props.objFct;
	
	                funs = $funs(_this, objFct);
	                Object.assign(_this.funs, funs);
	                if (objFct) {
	                    var oFuns = objFct.get("@funs");
	                    if (!oFuns) {
	                        oFuns = {};
	                        objFct.set("@funs", oFuns);
	                    }
	                    Object.assign(oFuns, funs);
	                }
	            } catch (error) {
	                _rtSdCommon.sgiLogger.error("事件集解析出错，请检查组件自定义事件集书写是否正确！");
	                _rtSdCommon.sgiLogger.eventErr(error);
	            }
	        }
	        return _this;
	    }
	    /**
	     * 生命周期-componentWillMount(加载前)
	     * 组件加载时只调用，以后组件更新不调用，整个生命周期只调用一次，此时可以修改state
	     * @deprecated 【不建议使用！react17将移除】
	     */
	
	
	    _createClass(SgiComponent, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] componentWillMount');
	            this.__componentWillMount();
	            // 自定义生命周期
	            var cstmCycle = this.data.functions.componentWillMount;
	            if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this);
	        }
	        /**
	         * 生命周期-render(渲染)
	         * react最重要的步骤，创建虚拟dom，进行diff算法，更新dom树都在此进行
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.loaded) {
	                this._maker();
	                this.loaded = true;
	            }
	            this._renderBeforeReturn();
	            return this.__render();
	        }
	        /**
	         * 生命周期-componentDidMount(加载后)
	         * 组件渲染之后调用，只调用一次
	         */
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] componentDidMount');
	            this.__componentDidMount();
	            // 自定义生命周期
	            var cstmCycle = this.data.functions.componentDidMount;
	            if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this);
	        }
	
	        /**************** 更新阶段 ****************/
	        /**
	         * 生命周期-componentWillReceiveProps
	         * 组件加载时不调用，组件接受新的props时调用
	         * @deprecated 【不建议使用！react17将移除】
	         * @param {*} nextProps 
	         */
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] componentWillReceiveProps');
	            this.__componentWillReceiveProps(nextProps);
	            // 自定义生命周期
	            var cstmCycle = this.data.functions.componentWillReceiveProps;
	            if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this, nextProps);
	        }
	        /**
	         * 生命周期-getDerivedStateFromProps-【react16新增，constructor后render前也会执行】
	         * 组件每次被rerender的时候，包括在组件构建之后(虚拟dom之后，实际dom挂载之前)，每次获取新的props或state之后；
	         * 每次接收新的props之后都会返回一个对象作为新的state，返回null则说明不需要更新state；
	         * 配合componentDidUpdate，可以覆盖componentWillReceiveProps的所有用法
	         * @param {*} props 
	         * @param {*} state 
	         */
	
	    }, {
	        key: 'getDerivedStateFromProps',
	        value: function getDerivedStateFromProps(props, state) {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + props._name + '][' + props._key + '] getDerivedStateFromProps');
	            var ret = this.__getDerivedStateFromProps(props, state);
	            // 自定义生命周期
	            // let cstmCycle = this.data.functions.getDerivedStateFromProps;
	            // let cstmRet;
	            // if (cstmCycle && typeof cstmCycle === "function") cstmRet = cstmCycle.call(this, props, state);
	            // if (ret && cstmRet) {
	            // 	ret = Object.assign(ret, cstmRet);
	            // } else {
	            // 	ret = ret || cstmRet;
	            // }
	            return ret;
	        }
	        /**
	         * 生命周期-shouldComponentUpdate
	         * 组件接收到新的props或者state时调用，
	         * return true就会更新dom（使用diff算法更新），
	         * return false能阻止更新（不调用render）
	         * @param {*} nextProps 
	         * @param {*} nextState 
	         */
	
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] shouldComponentUpdate');
	            var should = this.__shouldComponentUpdate(nextProps, nextState);
	            // 自定义生命周期
	            // let cstmCycle = this.data.functions.shouldComponentUpdate;
	            // let cstmShould;
	            // if (cstmCycle && typeof cstmCycle === "function") cstmShould = cstmCycle.call(this, nextProps, nextState);
	            return should;
	        }
	        /**
	         * 生命周期-componentWillUpdate(更新前)
	         * 组件加载时不调用，只有在组件将要更新时才调用，此时可以修改state
	         * @deprecated 【不建议使用！react17将移除】
	         * @param {*} nextProps 
	         * @param {*} nextState 
	         */
	
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] componentWillUpdate');
	            this.__componentWillUpdate(nextProps, nextState);
	            // 自定义生命周期
	            var cstmCycle = this.data.functions.componentWillUpdate;
	            if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this, nextProps, nextState);
	        }
	        /**
	         * 生命周期-getSnapshotBeforeUpdate-【react16新增】
	         * 触发时间: update发生的时候，在render之后，在组件dom渲染之前；
	         * 返回一个值，作为componentDidUpdate的第三个参数；
	         * 配合componentDidUpdate, 可以覆盖componentWillUpdate的所有用法
	         * @param {*} prevProps 
	         * @param {*} prevState 
	         * ！！！注意：目前该生命周期接口会导致componentWillMount初始化生命周期失效，暂不使用！！！
	         */
	        // getSnapshotBeforeUpdate(prevProps, prevState) {
	        // 	sgiLogger.debug_1(`>>>>SgiComponent [${this.props._name}][${this.props._key}] getSnapshotBeforeUpdate`);
	        // 	return this.__getSnapshotBeforeUpdate(prevProps, prevState);
	        // }
	        /**
	         * 生命周期-componentDidUpdate(更新后)
	         * 组件加载时不调用，组件更新完成后调用
	         */
	
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState, snapshot) {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] componentDidUpdate');
	            this.__componentDidUpdate(prevProps, prevState, snapshot);
	            // 自定义生命周期
	            var cstmCycle = this.data.functions.componentDidUpdate;
	            if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this, prevProps, prevState, snapshot);
	        }
	
	        /**************** 卸载阶段 ****************/
	        /**
	         * 生命周期-componentWillUnmount(卸载前)
	         * 组件卸载前调用，只调用一次
	         */
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] componentWillUnmount');
	            this.__componentWillUnmount();
	            // 自定义生命周期
	            var cstmCycle = this.data.functions.componentWillUnmount;
	            if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this);
	        }
	
	        /**************** 全阶段 ****************/
	        /**
	         * 生命周期-componentDidCatch(错误处理)-【react16新增】
	         * 任何一处的javascript报错会触发
	         * @param {*} error 
	         * @param {*} info 
	         */
	
	    }, {
	        key: 'componentDidCatch',
	        value: function componentDidCatch(error, info) {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] componentDidCatch');
	            this.__componentDidCatch(error, info);
	            // 自定义生命周期
	            var cstmCycle = this.data.functions.componentDidCatch;
	            if (cstmCycle && typeof cstmCycle === "function") cstmCycle.call(this, error, info);
	        }
	
	        /******************************** 方法接管 ********************************/
	        // 接管setState
	
	    }, {
	        key: 'setState',
	        value: function setState() {
	            var _get2;
	
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] setState call');
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            (_get2 = _get(SgiComponent.prototype.__proto__ || Object.getPrototypeOf(SgiComponent.prototype), 'setState', this)).call.apply(_get2, [this].concat(args));
	        }
	
	        /******************************** 子类实现 ********************************/
	        // maker程序
	
	    }, {
	        key: '_maker',
	        value: function _maker() {
	            _rtSdCommon.sgiLogger.debug_1('>>>>SgiComponent [' + this.props._name + '][' + this.props._key + '] _maker');
	
	            var _props2 = this.props,
	                parentModule = _props2.parentModule,
	                moduleDesc = _props2.moduleDesc,
	                objFct = _props2.objFct,
	                type = _props2.type;
	            var _state = this.state,
	                _props = _state._props,
	                _class = _state._class,
	                _style = _state._style;
	            var functions = this.data.functions;
	
	            // 转换基于描述
	
	            if (!moduleDesc) return;
	
	            var key = moduleDesc.key; //key
	            if (key) _props.key = key;
	
	            var cId = moduleDesc.cId; //id
	            if (cId) _props.id = (0, _SgiCommon.getConstByKey)(this, cId);
	
	            var ctlW = moduleDesc.ctlW; //控件宽度
	            if (ctlW == 0 || ctlW == '0px') _style.width = undefined;else if (/^[0-9]+$/.test(ctlW)) _style.width = parseInt(ctlW);else _style.width = ctlW;
	
	            var ctlH = moduleDesc.ctlH; //控件高度
	            if (ctlH == 0 || ctlH == '0px') _style.height = undefined;else if (/^[0-9]+$/.test(ctlH)) _style.height = parseInt(ctlH);else _style.height = ctlH;
	
	            var isBrdr = moduleDesc.isBrdr; //是否有边框
	            if (isBrdr) {
	                if (_class.indexOf("sgi-border") < 0) _class.push("sgi-border");
	            } else if (_class.indexOf("sgi-border") > -1) {
	                _class.splice(_class.indexOf("sgi-border"), 1);
	            }
	
	            _style.margin = moduleDesc.mgn; //控件外边距
	            _style.padding = moduleDesc.pad; //控件内边距
	
	            var isHdn = moduleDesc.isHdn; //是否隐藏
	            if (isHdn) {
	                _style.display = "none";
	            } else {
	                _style.display = undefined;
	            }
	
	            //公共属性里统一进行文本资源转换，各个控件可直接从ctnProps.te中取出结果，不再需要单独转换
	            // if (moduleDesc.te || moduleDesc.teid) {//如果te和teid都不存在则不查找资源
	            //     let te = Resource.getTRByPrm(moduleDesc).te; //显示名称
	            //     if (te) ctnProps.te = te;
	            // }
	            var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
	            _props.te = te;
	
	            // 初始加载中
	            this.state.loading = moduleDesc.loading;
	
	            // 自定义样式
	            var cstmStyle = moduleDesc.cstmStyle;
	            var $cstmStyle = void 0;
	            if (cstmStyle) {
	                try {
	                    $cstmStyle = new Function("module", "objFct", cstmStyle);
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.eventErr(error);
	                }
	                functions.cstmStyle = $cstmStyle;
	            }
	
	            // 属性透传，约定以"_"开始或以"antd_""antd-"开始的属性直接透传至props上
	            for (var _key2 in moduleDesc) {
	                if (_key2.substr(0, 1) === "_" && moduleDesc[_key2] !== undefined) {
	                    _props[_key2.substring(1)] = moduleDesc[_key2];
	                } else if ((_key2.substr(0, 5) === "antd_" || _key2.substr(0, 5) === "antd-") && moduleDesc[_key2] !== undefined) {
	                    _props[_key2.substring(5)] = moduleDesc[_key2];
	                }
	            }
	
	            // 事件集--放入构建中，优先处理
	            // let funs = moduleDesc.funs;
	            // if (funs) {
	            // 	var $funs;
	            // 	try {
	            // 		$funs = new Function("module", "objFct", funs);
	            // 	} catch (error) {
	            // 		sgiLogger.error("事件集解析出错，请检查组件自定义事件集");
	            // 		sgiLogger.eventErr(error);
	            // 	}
	            // 	if ($funs) {
	            // 		funs = $funs(this, objFct);
	            // 		Object.assign(this.funs, funs);
	            // 		if (objFct) {
	            // 			let oFuns = objFct.get("@funs");
	            // 			if (!oFuns) {
	            // 				oFuns = {};
	            // 				objFct.set("@funs", oFuns);
	            // 			}
	            // 			Object.assign(oFuns, funs);
	            // 		}
	            // 	}
	            // }
	
	            // 外部自定义生命周期
	            var lifes = moduleDesc.lifes;
	            if (lifes) {
	                try {
	                    lifes = eval('(' + lifes + ')');
	                    Object.assign(this.data.functions, lifes);
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.error("生命周期解析出错，请检查组件自定义生命周期");
	                    _rtSdCommon.sgiLogger.eventErr(error);
	                }
	            }
	        }
	
	        /**
	            * 渲染前处理，包括自定义样式等
	            * 初步设计为渲染前的通用处理，例如自定义样式等
	            */
	
	    }, {
	        key: '_renderBeforeReturn',
	        value: function _renderBeforeReturn() {
	            var _props3 = this.props,
	                parentModule = _props3.parentModule,
	                moduleDesc = _props3.moduleDesc,
	                objFct = _props3.objFct,
	                type = _props3.type;
	            var _state2 = this.state,
	                _props = _state2._props,
	                _style = _state2._style;
	
	            // 自定义样式处理
	            // const getCstmStyle = this.data.functions.cstmStyle;
	
	            var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(this, "cstmStyle");
	            var cstmStyle = {};
	            if (getCstmStyle) {
	                try {
	                    cstmStyle = getCstmStyle(this, objFct) || {};
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.error(error);
	                }
	            }
	            Object.assign(_style, cstmStyle);
	        }
	
	        // 子组件实现
	
	    }, {
	        key: '__render',
	        value: function __render() {
	            return "__render未被实现";
	        }
	    }, {
	        key: '__componentWillMount',
	        value: function __componentWillMount() {}
	    }, {
	        key: '__componentDidMount',
	        value: function __componentDidMount() {}
	    }, {
	        key: '__componentWillReceiveProps',
	        value: function __componentWillReceiveProps(nextProps) {}
	    }, {
	        key: '__getDerivedStateFromProps',
	        value: function __getDerivedStateFromProps(props, state) {
	            return state;
	        }
	    }, {
	        key: '__shouldComponentUpdate',
	        value: function __shouldComponentUpdate(nextProps, nextState) {
	            return true;
	        }
	    }, {
	        key: '__componentWillUpdate',
	        value: function __componentWillUpdate(nextProps, nextState) {}
	    }, {
	        key: '__getSnapshotBeforeUpdate',
	        value: function __getSnapshotBeforeUpdate(prevProps, prevState) {
	            return null;
	        }
	    }, {
	        key: '__componentDidUpdate',
	        value: function __componentDidUpdate() {}
	    }, {
	        key: '__componentWillUnmount',
	        value: function __componentWillUnmount() {}
	    }, {
	        key: '__componentDidCatch',
	        value: function __componentDidCatch(error, info) {}
	        // sgiLogger.error(error);
	        // sgiLogger.error(info.componentStack);
	
	
	        /******************************** 基本方法 ********************************/
	
	    }, {
	        key: 'setLoading',
	        value: function setLoading(loading) {
	            this.setState({ loading: loading });
	        }
	
	        // 通用动态方法
	
	    }, {
	        key: 'setProps',
	        value: function setProps(key, value, type) {
	            type = type || "_props";
	            var p = this.state[type];
	            if (p && key) {
	                p[key] = value;
	                this.setState(_defineProperty({}, type, p));
	            }
	            return p;
	        }
	    }, {
	        key: 'addClass',
	        value: function addClass(value, type) {
	            type = type || "_class";
	            var c = this.state[type];
	            if (c && value && c.indexOf(value) < 0) {
	                c.push(value);
	                this.setState(_defineProperty({}, type, c));
	            }
	            return c;
	        }
	    }, {
	        key: 'removeClass',
	        value: function removeClass(value, type) {
	            type = type || "_class";
	            var c = this.state[type];
	            if (c && value && c.indexOf(value) > -1) {
	                c.splice(c.indexOf(value), 1);
	                this.setState(_defineProperty({}, type, c));
	            }
	            return c;
	        }
	    }, {
	        key: 'setStyle',
	        value: function setStyle(key, value, type) {
	            type = type || "_style";
	            var s = this.state[type];
	            if (s && key) {
	                s[key] = value;
	                this.setState(_defineProperty({}, type, s));
	            }
	            return s;
	        }
	    }]);
	
	    return SgiComponent;
	}(_react2.default.Component);
	
	exports.default = SgiComponent;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapperRaf;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var id = 0;
	var ids = {}; // Support call raf with delay specified frame
	
	function wrapperRaf(callback) {
	  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var myId = id++;
	  var restFrames = delayFrames;
	
	  function internalCallback() {
	    restFrames -= 1;
	
	    if (restFrames <= 0) {
	      callback();
	      delete ids[myId];
	    } else {
	      ids[myId] = (0, _raf["default"])(internalCallback);
	    }
	  }
	
	  ids[myId] = (0, _raf["default"])(internalCallback);
	  return myId;
	}
	
	wrapperRaf.cancel = function cancel(pid) {
	  if (pid === undefined) return;
	
	  _raf["default"].cancel(ids[pid]);
	
	  delete ids[pid];
	};
	
	wrapperRaf.ids = ids; // export this for test usage

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Affix", {
	  enumerable: true,
	  get: function get() {
	    return _affix["default"];
	  }
	});
	Object.defineProperty(exports, "Anchor", {
	  enumerable: true,
	  get: function get() {
	    return _anchor["default"];
	  }
	});
	Object.defineProperty(exports, "AutoComplete", {
	  enumerable: true,
	  get: function get() {
	    return _autoComplete["default"];
	  }
	});
	Object.defineProperty(exports, "Alert", {
	  enumerable: true,
	  get: function get() {
	    return _alert["default"];
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _avatar["default"];
	  }
	});
	Object.defineProperty(exports, "BackTop", {
	  enumerable: true,
	  get: function get() {
	    return _backTop["default"];
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _badge["default"];
	  }
	});
	Object.defineProperty(exports, "Breadcrumb", {
	  enumerable: true,
	  get: function get() {
	    return _breadcrumb["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _button["default"];
	  }
	});
	Object.defineProperty(exports, "Calendar", {
	  enumerable: true,
	  get: function get() {
	    return _calendar["default"];
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _card["default"];
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _collapse["default"];
	  }
	});
	Object.defineProperty(exports, "Carousel", {
	  enumerable: true,
	  get: function get() {
	    return _carousel["default"];
	  }
	});
	Object.defineProperty(exports, "Cascader", {
	  enumerable: true,
	  get: function get() {
	    return _cascader["default"];
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _checkbox["default"];
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _col["default"];
	  }
	});
	Object.defineProperty(exports, "Comment", {
	  enumerable: true,
	  get: function get() {
	    return _comment["default"];
	  }
	});
	Object.defineProperty(exports, "ConfigProvider", {
	  enumerable: true,
	  get: function get() {
	    return _configProvider["default"];
	  }
	});
	Object.defineProperty(exports, "DatePicker", {
	  enumerable: true,
	  get: function get() {
	    return _datePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Descriptions", {
	  enumerable: true,
	  get: function get() {
	    return _descriptions["default"];
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _divider["default"];
	  }
	});
	Object.defineProperty(exports, "Dropdown", {
	  enumerable: true,
	  get: function get() {
	    return _dropdown["default"];
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _drawer["default"];
	  }
	});
	Object.defineProperty(exports, "Empty", {
	  enumerable: true,
	  get: function get() {
	    return _empty["default"];
	  }
	});
	Object.defineProperty(exports, "Form", {
	  enumerable: true,
	  get: function get() {
	    return _form["default"];
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _icon["default"];
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _input["default"];
	  }
	});
	Object.defineProperty(exports, "InputNumber", {
	  enumerable: true,
	  get: function get() {
	    return _inputNumber["default"];
	  }
	});
	Object.defineProperty(exports, "Layout", {
	  enumerable: true,
	  get: function get() {
	    return _layout["default"];
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _list["default"];
	  }
	});
	Object.defineProperty(exports, "LocaleProvider", {
	  enumerable: true,
	  get: function get() {
	    return _localeProvider["default"];
	  }
	});
	Object.defineProperty(exports, "message", {
	  enumerable: true,
	  get: function get() {
	    return _message["default"];
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _menu["default"];
	  }
	});
	Object.defineProperty(exports, "Mentions", {
	  enumerable: true,
	  get: function get() {
	    return _mentions["default"];
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _modal["default"];
	  }
	});
	Object.defineProperty(exports, "Statistic", {
	  enumerable: true,
	  get: function get() {
	    return _statistic["default"];
	  }
	});
	Object.defineProperty(exports, "notification", {
	  enumerable: true,
	  get: function get() {
	    return _notification["default"];
	  }
	});
	Object.defineProperty(exports, "PageHeader", {
	  enumerable: true,
	  get: function get() {
	    return _pageHeader["default"];
	  }
	});
	Object.defineProperty(exports, "Pagination", {
	  enumerable: true,
	  get: function get() {
	    return _pagination["default"];
	  }
	});
	Object.defineProperty(exports, "Popconfirm", {
	  enumerable: true,
	  get: function get() {
	    return _popconfirm["default"];
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _popover["default"];
	  }
	});
	Object.defineProperty(exports, "Progress", {
	  enumerable: true,
	  get: function get() {
	    return _progress["default"];
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _radio["default"];
	  }
	});
	Object.defineProperty(exports, "Rate", {
	  enumerable: true,
	  get: function get() {
	    return _rate["default"];
	  }
	});
	Object.defineProperty(exports, "Result", {
	  enumerable: true,
	  get: function get() {
	    return _result["default"];
	  }
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _row["default"];
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _select["default"];
	  }
	});
	Object.defineProperty(exports, "Skeleton", {
	  enumerable: true,
	  get: function get() {
	    return _skeleton["default"];
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _slider["default"];
	  }
	});
	Object.defineProperty(exports, "Spin", {
	  enumerable: true,
	  get: function get() {
	    return _spin["default"];
	  }
	});
	Object.defineProperty(exports, "Steps", {
	  enumerable: true,
	  get: function get() {
	    return _steps["default"];
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _switch["default"];
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _table["default"];
	  }
	});
	Object.defineProperty(exports, "Transfer", {
	  enumerable: true,
	  get: function get() {
	    return _transfer["default"];
	  }
	});
	Object.defineProperty(exports, "Tree", {
	  enumerable: true,
	  get: function get() {
	    return _tree["default"];
	  }
	});
	Object.defineProperty(exports, "TreeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _treeSelect["default"];
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _tabs["default"];
	  }
	});
	Object.defineProperty(exports, "Tag", {
	  enumerable: true,
	  get: function get() {
	    return _tag["default"];
	  }
	});
	Object.defineProperty(exports, "TimePicker", {
	  enumerable: true,
	  get: function get() {
	    return _timePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Timeline", {
	  enumerable: true,
	  get: function get() {
	    return _timeline["default"];
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _tooltip["default"];
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography["default"];
	  }
	});
	Object.defineProperty(exports, "Mention", {
	  enumerable: true,
	  get: function get() {
	    return _mention["default"];
	  }
	});
	Object.defineProperty(exports, "Upload", {
	  enumerable: true,
	  get: function get() {
	    return _upload["default"];
	  }
	});
	Object.defineProperty(exports, "version", {
	  enumerable: true,
	  get: function get() {
	    return _version["default"];
	  }
	});
	
	var _affix = _interopRequireDefault(__webpack_require__(736));
	
	var _anchor = _interopRequireDefault(__webpack_require__(1360));
	
	var _autoComplete = _interopRequireDefault(__webpack_require__(1362));
	
	var _alert = _interopRequireDefault(__webpack_require__(1357));
	
	var _avatar = _interopRequireDefault(__webpack_require__(737));
	
	var _backTop = _interopRequireDefault(__webpack_require__(1363));
	
	var _badge = _interopRequireDefault(__webpack_require__(1365));
	
	var _breadcrumb = _interopRequireDefault(__webpack_require__(739));
	
	var _button = _interopRequireDefault(__webpack_require__(138));
	
	var _calendar = _interopRequireDefault(__webpack_require__(1371));
	
	var _card = _interopRequireDefault(__webpack_require__(1374));
	
	var _collapse = _interopRequireDefault(__webpack_require__(1380));
	
	var _carousel = _interopRequireDefault(__webpack_require__(1375));
	
	var _cascader = _interopRequireDefault(__webpack_require__(1376));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(163));
	
	var _col = _interopRequireDefault(__webpack_require__(742));
	
	var _comment = _interopRequireDefault(__webpack_require__(1381));
	
	var _configProvider = _interopRequireDefault(__webpack_require__(15));
	
	var _datePicker = _interopRequireDefault(__webpack_require__(1386));
	
	var _descriptions = _interopRequireDefault(__webpack_require__(1389));
	
	var _divider = _interopRequireDefault(__webpack_require__(1390));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(379));
	
	var _drawer = _interopRequireDefault(__webpack_require__(1391));
	
	var _empty = _interopRequireDefault(__webpack_require__(745));
	
	var _form = _interopRequireDefault(__webpack_require__(1397));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _input = _interopRequireDefault(__webpack_require__(257));
	
	var _inputNumber = _interopRequireDefault(__webpack_require__(1401));
	
	var _layout = _interopRequireDefault(__webpack_require__(1407));
	
	var _list = _interopRequireDefault(__webpack_require__(1409));
	
	var _localeProvider = _interopRequireDefault(__webpack_require__(754));
	
	var _message = _interopRequireDefault(__webpack_require__(1415));
	
	var _menu = _interopRequireDefault(__webpack_require__(382));
	
	var _mentions = _interopRequireDefault(__webpack_require__(1412));
	
	var _modal = _interopRequireDefault(__webpack_require__(1418));
	
	var _statistic = _interopRequireDefault(__webpack_require__(1442));
	
	var _notification = _interopRequireDefault(__webpack_require__(1419));
	
	var _pageHeader = _interopRequireDefault(__webpack_require__(1420));
	
	var _pagination = _interopRequireDefault(__webpack_require__(384));
	
	var _popconfirm = _interopRequireDefault(__webpack_require__(1423));
	
	var _popover = _interopRequireDefault(__webpack_require__(1424));
	
	var _progress = _interopRequireDefault(__webpack_require__(756));
	
	var _radio = _interopRequireDefault(__webpack_require__(258));
	
	var _rate = _interopRequireDefault(__webpack_require__(1430));
	
	var _result = _interopRequireDefault(__webpack_require__(1431));
	
	var _row = _interopRequireDefault(__webpack_require__(757));
	
	var _select = _interopRequireDefault(__webpack_require__(208));
	
	var _skeleton = _interopRequireDefault(__webpack_require__(1438));
	
	var _slider = _interopRequireDefault(__webpack_require__(1439));
	
	var _spin = _interopRequireDefault(__webpack_require__(259));
	
	var _steps = _interopRequireDefault(__webpack_require__(1444));
	
	var _switch = _interopRequireDefault(__webpack_require__(1445));
	
	var _table = _interopRequireDefault(__webpack_require__(1455));
	
	var _transfer = _interopRequireDefault(__webpack_require__(1463));
	
	var _tree = _interopRequireDefault(__webpack_require__(1469));
	
	var _treeSelect = _interopRequireDefault(__webpack_require__(1467));
	
	var _tabs = _interopRequireDefault(__webpack_require__(760));
	
	var _tag = _interopRequireDefault(__webpack_require__(761));
	
	var _timePicker = _interopRequireDefault(__webpack_require__(762));
	
	var _timeline = _interopRequireDefault(__webpack_require__(1460));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(126));
	
	var _typography = _interopRequireDefault(__webpack_require__(1475));
	
	var _mention = _interopRequireDefault(__webpack_require__(1411));
	
	var _upload = _interopRequireDefault(__webpack_require__(1479));
	
	var _version = _interopRequireDefault(__webpack_require__(1480));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	/* @remove-on-es-build-begin */
	// this file is not used if use https://github.com/ant-design/babel-plugin-import
	var ENV = ("production");
	
	if (ENV !== 'production' && ENV !== 'test' && typeof console !== 'undefined' && console.warn && // eslint-disable-line no-console
	typeof window !== 'undefined') {
	  // eslint-disable-next-line no-console
	  console.warn('You are using a whole package of antd, ' + 'please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size.');
	}
	/* @remove-on-es-build-end */

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fixControlledValue = fixControlledValue;
	exports.resolveOnChange = resolveOnChange;
	exports.getInputClassName = getInputClassName;
	exports["default"] = exports.InputSizes = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _type = __webpack_require__(83);
	
	var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(751));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var InputSizes = (0, _type.tuple)('small', 'default', 'large');
	exports.InputSizes = InputSizes;
	
	function fixControlledValue(value) {
	  if (typeof value === 'undefined' || value === null) {
	    return '';
	  }
	
	  return value;
	}
	
	function resolveOnChange(target, e, onChange) {
	  if (onChange) {
	    var event = e;
	
	    if (e.type === 'click') {
	      // click clear icon
	      event = Object.create(e);
	      event.target = target;
	      event.currentTarget = target;
	      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input
	
	      target.value = '';
	      onChange(event); // reset target ref value
	
	      target.value = originalInputValue;
	      return;
	    }
	
	    onChange(event);
	  }
	}
	
	function getInputClassName(prefixCls, size, disabled) {
	  var _classNames;
	
	  return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
	}
	
	var Input = /*#__PURE__*/function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  var _super = _createSuper(Input);
	
	  function Input(props) {
	    var _this;
	
	    _classCallCheck(this, Input);
	
	    _this = _super.call(this, props);
	
	    _this.saveClearableInput = function (input) {
	      _this.clearableInput = input;
	    };
	
	    _this.saveInput = function (input) {
	      _this.input = input;
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.focus();
	      });
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.renderInput = function (prefixCls) {
	      var _this$props = _this.props,
	          className = _this$props.className,
	          addonBefore = _this$props.addonBefore,
	          addonAfter = _this$props.addonAfter,
	          size = _this$props.size,
	          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop
	
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
	      // specify either the value prop, or the defaultValue prop, but not both.
	      'defaultValue', 'size', 'inputType']);
	      return (/*#__PURE__*/React.createElement("input", _extends({}, otherProps, {
	          onChange: _this.handleChange,
	          onKeyDown: _this.handleKeyDown,
	          className: (0, _classnames["default"])(getInputClassName(prefixCls, size, disabled), _defineProperty({}, className, className && !addonBefore && !addonAfter)),
	          ref: _this.saveInput
	        }))
	      );
	    };
	
	    _this.clearPasswordValueAttribute = function () {
	      // https://github.com/ant-design/ant-design/issues/20541
	      _this.removePasswordTimeout = setTimeout(function () {
	        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
	          _this.input.removeAttribute('value');
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props2 = _this.props,
	          onPressEnter = _this$props2.onPressEnter,
	          onKeyDown = _this$props2.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          inputType: "input",
	          value: fixControlledValue(value),
	          element: _this.renderInput(prefixCls),
	          handleReset: _this.handleReset,
	          ref: _this.saveClearableInput
	        }))
	      );
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.clearPasswordValueAttribute();
	    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
	    // We keep an empty function here.
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
	        (0, _warning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
	      }
	
	      return null;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.removePasswordTimeout) {
	        clearTimeout(this.removePasswordTimeout);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Input;
	}(React.Component);
	
	Input.defaultProps = {
	  type: 'text'
	};
	Input.propTypes = {
	  type: PropTypes.string,
	  id: PropTypes.string,
	  size: PropTypes.oneOf(InputSizes),
	  maxLength: PropTypes.number,
	  disabled: PropTypes.bool,
	  value: PropTypes.any,
	  defaultValue: PropTypes.any,
	  className: PropTypes.string,
	  addonBefore: PropTypes.node,
	  addonAfter: PropTypes.node,
	  prefixCls: PropTypes.string,
	  onPressEnter: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onKeyUp: PropTypes.func,
	  onFocus: PropTypes.func,
	  onBlur: PropTypes.func,
	  prefix: PropTypes.node,
	  suffix: PropTypes.node,
	  allowClear: PropTypes.bool
	};
	(0, _reactLifecyclesCompat.polyfill)(Input);
	var _default = Input;
	exports["default"] = _default;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSelect = _interopRequireWildcard(__webpack_require__(191));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _type = __webpack_require__(83);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SelectSizes = (0, _type.tuple)('default', 'large', 'small');
	var ModeOptions = (0, _type.tuple)('default', 'multiple', 'tags', 'combobox', 'SECRET_COMBOBOX_MODE_DO_NOT_USE');
	var SelectPropTypes = {
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  size: PropTypes.oneOf(SelectSizes),
	  notFoundContent: PropTypes.any,
	  showSearch: PropTypes.bool,
	  optionLabelProp: PropTypes.string,
	  transitionName: PropTypes.string,
	  choiceTransitionName: PropTypes.string,
	  id: PropTypes.string
	};
	
	var Select = /*#__PURE__*/function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  var _super = _createSuper(Select);
	
	  function Select(props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _super.call(this, props);
	
	    _this.saveSelect = function (node) {
	      _this.rcSelect = node;
	    };
	
	    _this.renderSelect = function (_ref) {
	      var _classNames;
	
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          _a$className = _a.className,
	          className = _a$className === void 0 ? '' : _a$className,
	          size = _a.size,
	          mode = _a.mode,
	          getPopupContainer = _a.getPopupContainer,
	          removeIcon = _a.removeIcon,
	          clearIcon = _a.clearIcon,
	          menuItemSelectedIcon = _a.menuItemSelectedIcon,
	          showArrow = _a.showArrow,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "mode", "getPopupContainer", "removeIcon", "clearIcon", "menuItemSelectedIcon", "showArrow"]);
	
	      var rest = (0, _omit["default"])(restProps, ['inputIcon']);
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-show-arrow"), showArrow), _classNames), className);
	      var optionLabelProp = _this.props.optionLabelProp;
	
	      if (_this.isCombobox()) {
	        // children 带 dom 结构时，无法填入输入框
	        optionLabelProp = optionLabelProp || 'value';
	      }
	
	      var modeConfig = {
	        multiple: mode === 'multiple',
	        tags: mode === 'tags',
	        combobox: _this.isCombobox()
	      };
	      var finalRemoveIcon = removeIcon && ( /*#__PURE__*/React.isValidElement(removeIcon) ? /*#__PURE__*/React.cloneElement(removeIcon, {
	        className: (0, _classnames["default"])(removeIcon.props.className, "".concat(prefixCls, "-remove-icon"))
	      }) : removeIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        className: "".concat(prefixCls, "-remove-icon")
	      });
	      var finalClearIcon = clearIcon && ( /*#__PURE__*/React.isValidElement(clearIcon) ? /*#__PURE__*/React.cloneElement(clearIcon, {
	        className: (0, _classnames["default"])(clearIcon.props.className, "".concat(prefixCls, "-clear-icon"))
	      }) : clearIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-clear-icon")
	      });
	      var finalMenuItemSelectedIcon = menuItemSelectedIcon && ( /*#__PURE__*/React.isValidElement(menuItemSelectedIcon) ? /*#__PURE__*/React.cloneElement(menuItemSelectedIcon, {
	        className: (0, _classnames["default"])(menuItemSelectedIcon.props.className, "".concat(prefixCls, "-selected-icon"))
	      }) : menuItemSelectedIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "check",
	        className: "".concat(prefixCls, "-selected-icon")
	      });
	      return (/*#__PURE__*/React.createElement(_rcSelect["default"], _extends({
	          inputIcon: _this.renderSuffixIcon(prefixCls),
	          removeIcon: finalRemoveIcon,
	          clearIcon: finalClearIcon,
	          menuItemSelectedIcon: finalMenuItemSelectedIcon,
	          showArrow: showArrow
	        }, rest, modeConfig, {
	          prefixCls: prefixCls,
	          className: cls,
	          optionLabelProp: optionLabelProp || 'children',
	          notFoundContent: _this.getNotFoundContent(renderEmpty),
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          ref: _this.saveSelect
	        }))
	      );
	    };
	
	    (0, _warning["default"])(props.mode !== 'combobox', 'Select', 'The combobox mode is deprecated, ' + 'it will be removed in next major version, ' + 'please use AutoComplete instead');
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "getNotFoundContent",
	    value: function getNotFoundContent(renderEmpty) {
	      var notFoundContent = this.props.notFoundContent;
	
	      if (notFoundContent !== undefined) {
	        return notFoundContent;
	      }
	
	      if (this.isCombobox()) {
	        return null;
	      }
	
	      return renderEmpty('Select');
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcSelect.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSelect.blur();
	    }
	  }, {
	    key: "isCombobox",
	    value: function isCombobox() {
	      var mode = this.props.mode;
	      return mode === 'combobox' || mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE;
	    }
	  }, {
	    key: "renderSuffixIcon",
	    value: function renderSuffixIcon(prefixCls) {
	      var _this$props = this.props,
	          loading = _this$props.loading,
	          suffixIcon = _this$props.suffixIcon;
	
	      if (suffixIcon) {
	        return (/*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	            className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-arrow-icon"))
	          }) : suffixIcon
	        );
	      }
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading"
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "down",
	          className: "".concat(prefixCls, "-arrow-icon")
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSelect)
	      );
	    }
	  }]);
	
	  return Select;
	}(React.Component);
	
	exports["default"] = Select;
	Select.Option = _rcSelect.Option;
	Select.OptGroup = _rcSelect.OptGroup;
	Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
	Select.defaultProps = {
	  showSearch: false,
	  transitionName: 'slide-up',
	  choiceTransitionName: 'zoom'
	};
	Select.propTypes = SelectPropTypes;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(46);
	
	var EventPluginRegistry = __webpack_require__(395);
	var EventPluginUtils = __webpack_require__(396);
	var ReactErrorUtils = __webpack_require__(400);
	
	var accumulateInto = __webpack_require__(780);
	var forEachAccumulated = __webpack_require__(781);
	var invariant = __webpack_require__(32);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function executeDispatchesAndRelease(event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function executeDispatchesAndReleaseSimulated(e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function executeDispatchesAndReleaseTopLevel(e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function putListener(inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener === 'undefined' ? 'undefined' : _typeof(listener)) : _prodInvariant('94', registrationName, typeof listener === 'undefined' ? 'undefined' : _typeof(listener)) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function getListener(inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function deleteListener(inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function deleteAllListeners(inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function enqueueEvents(events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function processEventQueue(simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function __purge() {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function __getListenerBank() {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(209);
	var EventPluginUtils = __webpack_require__(396);
	
	var accumulateInto = __webpack_require__(780);
	var forEachAccumulated = __webpack_require__(781);
	var warning = __webpack_require__(44);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function remove(key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function get(key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function has(key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function set(key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	var getEventTarget = __webpack_require__(405);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function view(event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function detail(event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var SymbolClz = __webpack_require__(265);
	
	var _util = __webpack_require__(2);
	
	var isObject = _util.isObject;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/SymbolDraw
	 */
	
	/**
	 * @constructor
	 * @alias module:echarts/chart/helper/SymbolDraw
	 * @param {module:zrender/graphic/Group} [symbolCtor]
	 */
	function SymbolDraw(symbolCtor) {
	  this.group = new graphic.Group();
	  this._symbolCtor = symbolCtor || SymbolClz;
	}
	
	var symbolDrawProto = SymbolDraw.prototype;
	
	function symbolNeedsDraw(data, point, idx, opt) {
	  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
	  // the symbol element shape. We use the same clip shape here as
	  // the line clip.
	  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
	}
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.updateData = function (data, opt) {
	  opt = normalizeUpdateOpt(opt);
	  var group = this.group;
	  var seriesModel = data.hostModel;
	  var oldData = this._data;
	  var SymbolCtor = this._symbolCtor;
	  var seriesScope = makeSeriesScope(data); // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldData) {
	    group.removeAll();
	  }
	
	  data.diff(oldData).add(function (newIdx) {
	    var point = data.getItemLayout(newIdx);
	
	    if (symbolNeedsDraw(data, point, newIdx, opt)) {
	      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
	      symbolEl.attr('position', point);
	      data.setItemGraphicEl(newIdx, symbolEl);
	      group.add(symbolEl);
	    }
	  }).update(function (newIdx, oldIdx) {
	    var symbolEl = oldData.getItemGraphicEl(oldIdx);
	    var point = data.getItemLayout(newIdx);
	
	    if (!symbolNeedsDraw(data, point, newIdx, opt)) {
	      group.remove(symbolEl);
	      return;
	    }
	
	    if (!symbolEl) {
	      symbolEl = new SymbolCtor(data, newIdx);
	      symbolEl.attr('position', point);
	    } else {
	      symbolEl.updateData(data, newIdx, seriesScope);
	      graphic.updateProps(symbolEl, {
	        position: point
	      }, seriesModel);
	    } // Add back
	
	
	    group.add(symbolEl);
	    data.setItemGraphicEl(newIdx, symbolEl);
	  }).remove(function (oldIdx) {
	    var el = oldData.getItemGraphicEl(oldIdx);
	    el && el.fadeOut(function () {
	      group.remove(el);
	    });
	  }).execute();
	  this._data = data;
	};
	
	symbolDrawProto.isPersistent = function () {
	  return true;
	};
	
	symbolDrawProto.updateLayout = function () {
	  var data = this._data;
	
	  if (data) {
	    // Not use animation
	    data.eachItemGraphicEl(function (el, idx) {
	      var point = data.getItemLayout(idx);
	      el.attr('position', point);
	    });
	  }
	};
	
	symbolDrawProto.incrementalPrepareUpdate = function (data) {
	  this._seriesScope = makeSeriesScope(data);
	  this._data = null;
	  this.group.removeAll();
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.incrementalUpdate = function (taskParams, data, opt) {
	  opt = normalizeUpdateOpt(opt);
	
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var point = data.getItemLayout(idx);
	
	    if (symbolNeedsDraw(data, point, idx, opt)) {
	      var el = new this._symbolCtor(data, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      el.attr('position', point);
	      this.group.add(el);
	      data.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function normalizeUpdateOpt(opt) {
	  if (opt != null && !isObject(opt)) {
	    opt = {
	      isIgnore: opt
	    };
	  }
	
	  return opt || {};
	}
	
	symbolDrawProto.remove = function (enableAnimation) {
	  var group = this.group;
	  var data = this._data; // Incremental model do not have this._data.
	
	  if (data && enableAnimation) {
	    data.eachItemGraphicEl(function (el) {
	      el.fadeOut(function () {
	        group.remove(el);
	      });
	    });
	  } else {
	    group.removeAll();
	  }
	};
	
	function makeSeriesScope(data) {
	  var seriesModel = data.hostModel;
	  return {
	    itemStyle: seriesModel.getModel('itemStyle').getItemStyle(['color']),
	    hoverItemStyle: seriesModel.getModel('emphasis.itemStyle').getItemStyle(),
	    symbolRotate: seriesModel.get('symbolRotate'),
	    symbolOffset: seriesModel.get('symbolOffset'),
	    hoverAnimation: seriesModel.get('hoverAnimation'),
	    labelModel: seriesModel.getModel('label'),
	    hoverLabelModel: seriesModel.getModel('emphasis.label'),
	    cursorStyle: seriesModel.get('cursor')
	  };
	}
	
	var _default = SymbolDraw;
	module.exports = _default;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var _number = __webpack_require__(24);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function createGridClipPath(cartesian, hasAnimation, seriesModel) {
	  var rect = cartesian.getArea();
	  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
	  var x = rect.x;
	  var y = rect.y;
	  var width = rect.width;
	  var height = rect.height;
	  var lineWidth = seriesModel.get('lineStyle.width') || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
	
	  x -= lineWidth / 2;
	  y -= lineWidth / 2;
	  width += lineWidth;
	  height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
	
	  x = Math.floor(x);
	  width = Math.round(width);
	  var clipPath = new graphic.Rect({
	    shape: {
	      x: x,
	      y: y,
	      width: width,
	      height: height
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
	    graphic.initProps(clipPath, {
	      shape: {
	        width: width,
	        height: height
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createPolarClipPath(polar, hasAnimation, seriesModel) {
	  var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	
	  var clipPath = new graphic.Sector({
	    shape: {
	      cx: round(polar.cx, 1),
	      cy: round(polar.cy, 1),
	      r0: round(sectorArea.r0, 1),
	      r: round(sectorArea.r, 1),
	      startAngle: sectorArea.startAngle,
	      endAngle: sectorArea.endAngle,
	      clockwise: sectorArea.clockwise
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape.endAngle = sectorArea.startAngle;
	    graphic.initProps(clipPath, {
	      shape: {
	        endAngle: sectorArea.endAngle
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createClipPath(coordSys, hasAnimation, seriesModel) {
	  if (!coordSys) {
	    return null;
	  } else if (coordSys.type === 'polar') {
	    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	  } else if (coordSys.type === 'cartesian2d') {
	    return createGridClipPath(coordSys, hasAnimation, seriesModel);
	  }
	
	  return null;
	}
	
	exports.createGridClipPath = createGridClipPath;
	exports.createPolarClipPath = createPolarClipPath;
	exports.createClipPath = createClipPath;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var axisPointerModelHelper = __webpack_require__(267);
	
	var axisTrigger = __webpack_require__(1733);
	
	__webpack_require__(1729);
	
	__webpack_require__(1730);
	
	__webpack_require__(813);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// CartesianAxisPointer is not supposed to be required here. But consider
	// echarts.simple.js and online build tooltip, which only require gridSimple,
	// CartesianAxisPointer should be able to required somewhere.
	echarts.registerPreprocessor(function (option) {
	  // Always has a global axisPointerModel for default setting.
	  if (option) {
	    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
	    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
	    // is not set, remain null/undefined, otherwise it will
	    // override existent link setting.
	
	    if (link && !zrUtil.isArray(link)) {
	      option.axisPointer.link = [link];
	    }
	  }
	}); // This process should proformed after coordinate systems created
	// and series data processed. So put it on statistic processing stage.
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
	  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	  // allAxesInfo should be updated when setOption performed.
	  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
	}); // Broadcast to all views.
	
	echarts.registerAction({
	  type: 'updateAxisPointer',
	  event: 'updateAxisPointer',
	  update: ':updateAxisPointer'
	}, axisTrigger);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	__webpack_require__(427);
	
	__webpack_require__(1728);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid view
	echarts.extendComponentView({
	  type: 'grid',
	  render: function (gridModel, ecModel) {
	    this.group.removeAll();
	
	    if (gridModel.get('show')) {
	      this.group.add(new graphic.Rect({
	        shape: gridModel.coordinateSystem.getRect(),
	        style: zrUtil.defaults({
	          fill: gridModel.get('backgroundColor')
	        }, gridModel.getItemStyle()),
	        silent: true,
	        z2: -1
	      }));
	    }
	  }
	});
	echarts.registerPreprocessor(function (option) {
	  // Only create grid when need
	  if (option.xAxis && option.yAxis && !option.grid) {
	    option.grid = {};
	  }
	});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Eventful = __webpack_require__(148);
	
	var eventTool = __webpack_require__(104);
	
	var interactionMutex = __webpack_require__(825);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @alias module:echarts/component/helper/RoamController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	function RoamController(zr) {
	  /**
	   * @type {Function}
	   */
	  this.pointerChecker;
	  /**
	   * @type {module:zrender}
	   */
	
	  this._zr = zr;
	  /**
	   * @type {Object}
	   */
	
	  this._opt = {}; // Avoid two roamController bind the same handler
	
	  var bind = zrUtil.bind;
	  var mousedownHandler = bind(mousedown, this);
	  var mousemoveHandler = bind(mousemove, this);
	  var mouseupHandler = bind(mouseup, this);
	  var mousewheelHandler = bind(mousewheel, this);
	  var pinchHandler = bind(pinch, this);
	  Eventful.call(this);
	  /**
	   * @param {Function} pointerChecker
	   *                   input: x, y
	   *                   output: boolean
	   */
	
	  this.setPointerChecker = function (pointerChecker) {
	    this.pointerChecker = pointerChecker;
	  };
	  /**
	   * Notice: only enable needed types. For example, if 'zoom'
	   * is not needed, 'zoom' should not be enabled, otherwise
	   * default mousewheel behaviour (scroll page) will be disabled.
	   *
	   * @param  {boolean|string} [controlType=true] Specify the control type,
	   *                          which can be null/undefined or true/false
	   *                          or 'pan/move' or 'zoom'/'scale'
	   * @param {Object} [opt]
	   * @param {Object} [opt.zoomOnMouseWheel=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseMove=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseWheel=false] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
	   */
	
	
	  this.enable = function (controlType, opt) {
	    // Disable previous first
	    this.disable();
	    this._opt = zrUtil.defaults(zrUtil.clone(opt) || {}, {
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      // By default, wheel do not trigger move.
	      moveOnMouseWheel: false,
	      preventDefaultMouseMove: true
	    });
	
	    if (controlType == null) {
	      controlType = true;
	    }
	
	    if (controlType === true || controlType === 'move' || controlType === 'pan') {
	      zr.on('mousedown', mousedownHandler);
	      zr.on('mousemove', mousemoveHandler);
	      zr.on('mouseup', mouseupHandler);
	    }
	
	    if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
	      zr.on('mousewheel', mousewheelHandler);
	      zr.on('pinch', pinchHandler);
	    }
	  };
	
	  this.disable = function () {
	    zr.off('mousedown', mousedownHandler);
	    zr.off('mousemove', mousemoveHandler);
	    zr.off('mouseup', mouseupHandler);
	    zr.off('mousewheel', mousewheelHandler);
	    zr.off('pinch', pinchHandler);
	  };
	
	  this.dispose = this.disable;
	
	  this.isDragging = function () {
	    return this._dragging;
	  };
	
	  this.isPinching = function () {
	    return this._pinching;
	  };
	}
	
	zrUtil.mixin(RoamController, Eventful);
	
	function mousedown(e) {
	  if (eventTool.isMiddleOrRightButtonOnMouseUpDown(e) || e.target && e.target.draggable) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY; // Only check on mosedown, but not mousemove.
	  // Mouse can be out of target when mouse moving.
	
	  if (this.pointerChecker && this.pointerChecker(e, x, y)) {
	    this._x = x;
	    this._y = y;
	    this._dragging = true;
	  }
	}
	
	function mousemove(e) {
	  if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY;
	  var oldX = this._x;
	  var oldY = this._y;
	  var dx = x - oldX;
	  var dy = y - oldY;
	  this._x = x;
	  this._y = y;
	  this._opt.preventDefaultMouseMove && eventTool.stop(e.event);
	  trigger(this, 'pan', 'moveOnMouseMove', e, {
	    dx: dx,
	    dy: dy,
	    oldX: oldX,
	    oldY: oldY,
	    newX: x,
	    newY: y
	  });
	}
	
	function mouseup(e) {
	  if (!eventTool.isMiddleOrRightButtonOnMouseUpDown(e)) {
	    this._dragging = false;
	  }
	}
	
	function mousewheel(e) {
	  var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
	  var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
	  var wheelDelta = e.wheelDelta;
	  var absWheelDeltaDelta = Math.abs(wheelDelta);
	  var originX = e.offsetX;
	  var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.
	
	  if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
	    return;
	  } // If both `shouldZoom` and `shouldMove` is true, trigger
	  // their event both, and the final behavior is determined
	  // by event listener themselves.
	
	
	  if (shouldZoom) {
	    // Convenience:
	    // Mac and VM Windows on Mac: scroll up: zoom out.
	    // Windows: scroll up: zoom in.
	    // FIXME: Should do more test in different environment.
	    // wheelDelta is too complicated in difference nvironment
	    // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
	    // although it has been normallized by zrender.
	    // wheelDelta of mouse wheel is bigger than touch pad.
	    var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
	    var scale = wheelDelta > 0 ? factor : 1 / factor;
	    checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
	      scale: scale,
	      originX: originX,
	      originY: originY
	    });
	  }
	
	  if (shouldMove) {
	    // FIXME: Should do more test in different environment.
	    var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.
	
	    var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
	    checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
	      scrollDelta: scrollDelta,
	      originX: originX,
	      originY: originY
	    });
	  }
	}
	
	function pinch(e) {
	  if (interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
	  checkPointerAndTrigger(this, 'zoom', null, e, {
	    scale: scale,
	    originX: e.pinchX,
	    originY: e.pinchY
	  });
	}
	
	function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
	    // When mouse is out of roamController rect,
	    // default befavoius should not be be disabled, otherwise
	    // page sliding is disabled, contrary to expectation.
	    eventTool.stop(e.event);
	    trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
	  }
	}
	
	function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  // Also provide behavior checker for event listener, for some case that
	  // multiple components share one listener.
	  contollerEvent.isAvailableBehavior = zrUtil.bind(isAvailableBehavior, null, behaviorToCheck, e);
	  controller.trigger(eventName, contollerEvent);
	} // settings: {
	//     zoomOnMouseWheel
	//     moveOnMouseMove
	//     moveOnMouseWheel
	// }
	// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	
	
	function isAvailableBehavior(behaviorToCheck, e, settings) {
	  var setting = settings[behaviorToCheck];
	  return !behaviorToCheck || setting && (!zrUtil.isString(setting) || e.event[setting + 'Key']);
	}
	
	var _default = RoamController;
	module.exports = _default;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	var isTypedArray = _util.isTypedArray;
	
	var _clazz = __webpack_require__(115);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	var _sourceType = __webpack_require__(221);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [sourceFormat]
	 *
	 * + "original":
	 * This format is only used in series.data, where
	 * itemStyle can be specified in data item.
	 *
	 * + "arrayRows":
	 * [
	 *     ['product', 'score', 'amount'],
	 *     ['Matcha Latte', 89.3, 95.8],
	 *     ['Milk Tea', 92.1, 89.4],
	 *     ['Cheese Cocoa', 94.4, 91.2],
	 *     ['Walnut Brownie', 85.4, 76.9]
	 * ]
	 *
	 * + "objectRows":
	 * [
	 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
	 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
	 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
	 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
	 * ]
	 *
	 * + "keyedColumns":
	 * {
	 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
	 *     'count': [823, 235, 1042, 988],
	 *     'score': [95.8, 81.4, 91.2, 76.9]
	 * }
	 *
	 * + "typedArray"
	 *
	 * + "unknown"
	 */
	
	/**
	 * @constructor
	 * @param {Object} fields
	 * @param {string} fields.sourceFormat
	 * @param {Array|Object} fields.fromDataset
	 * @param {Array|Object} [fields.data]
	 * @param {string} [seriesLayoutBy='column']
	 * @param {Array.<Object|string>} [dimensionsDefine]
	 * @param {Objet|HashMap} [encodeDefine]
	 * @param {number} [startIndex=0]
	 * @param {number} [dimensionsDetectCount]
	 */
	function Source(fields) {
	  /**
	   * @type {boolean}
	   */
	  this.fromDataset = fields.fromDataset;
	  /**
	   * Not null/undefined.
	   * @type {Array|Object}
	   */
	
	  this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
	  /**
	   * See also "detectSourceFormat".
	   * Not null/undefined.
	   * @type {string}
	   */
	
	  this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN;
	  /**
	   * 'row' or 'column'
	   * Not null/undefined.
	   * @type {string} seriesLayoutBy
	   */
	
	  this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
	  /**
	   * dimensions definition in option.
	   * can be null/undefined.
	   * @type {Array.<Object|string>}
	   */
	
	  this.dimensionsDefine = fields.dimensionsDefine;
	  /**
	   * encode definition in option.
	   * can be null/undefined.
	   * @type {Objet|HashMap}
	   */
	
	  this.encodeDefine = fields.encodeDefine && createHashMap(fields.encodeDefine);
	  /**
	   * Not null/undefined, uint.
	   * @type {number}
	   */
	
	  this.startIndex = fields.startIndex || 0;
	  /**
	   * Can be null/undefined (when unknown), uint.
	   * @type {number}
	   */
	
	  this.dimensionsDetectCount = fields.dimensionsDetectCount;
	}
	/**
	 * Wrap original series data for some compatibility cases.
	 */
	
	
	Source.seriesDataToSource = function (data) {
	  return new Source({
	    data: data,
	    sourceFormat: isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL,
	    fromDataset: false
	  });
	};
	
	enableClassCheck(Source);
	var _default = Source;
	module.exports = _default;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var OTHER_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'seriesName']);
	
	function summarizeDimensions(data) {
	  var summary = {};
	  var encode = summary.encode = {};
	  var notExtraCoordDimMap = createHashMap();
	  var defaultedLabel = [];
	  var defaultedTooltip = []; // See the comment of `List.js#userOutput`.
	
	  var userOutput = summary.userOutput = {
	    dimensionNames: data.dimensions.slice(),
	    encode: {}
	  };
	  each(data.dimensions, function (dimName) {
	    var dimItem = data.getDimensionInfo(dimName);
	    var coordDim = dimItem.coordDim;
	
	    if (coordDim) {
	      var coordDimIndex = dimItem.coordDimIndex;
	      getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
	
	      if (!dimItem.isExtraCoord) {
	        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
	        // because when dataset is used, it is hard to guess which dimension
	        // can be value dimension. If both show x, y on label is not look good,
	        // and conventionally y axis is focused more.
	
	        if (mayLabelDimType(dimItem.type)) {
	          defaultedLabel[0] = dimName;
	        } // User output encode do not contain generated coords.
	        // And it only has index. User can use index to retrieve value from the raw item array.
	
	
	        getOrCreateEncodeArr(userOutput.encode, coordDim)[coordDimIndex] = dimItem.index;
	      }
	
	      if (dimItem.defaultTooltip) {
	        defaultedTooltip.push(dimName);
	      }
	    }
	
	    OTHER_DIMENSIONS.each(function (v, otherDim) {
	      var encodeArr = getOrCreateEncodeArr(encode, otherDim);
	      var dimIndex = dimItem.otherDims[otherDim];
	
	      if (dimIndex != null && dimIndex !== false) {
	        encodeArr[dimIndex] = dimItem.name;
	      }
	    });
	  });
	  var dataDimsOnCoord = [];
	  var encodeFirstDimNotExtra = {};
	  notExtraCoordDimMap.each(function (v, coordDim) {
	    var dimArr = encode[coordDim]; // ??? FIXME extra coord should not be set in dataDimsOnCoord.
	    // But should fix the case that radar axes: simplify the logic
	    // of `completeDimension`, remove `extraPrefix`.
	
	    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
	    // dim canot on more than one coordDim.
	
	    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
	  });
	  summary.dataDimsOnCoord = dataDimsOnCoord;
	  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
	  var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
	  // in this way. Use label.formatter instead. May be remove this approach someday.
	
	  if (encodeLabel && encodeLabel.length) {
	    defaultedLabel = encodeLabel.slice();
	  }
	
	  var encodeTooltip = encode.tooltip;
	
	  if (encodeTooltip && encodeTooltip.length) {
	    defaultedTooltip = encodeTooltip.slice();
	  } else if (!defaultedTooltip.length) {
	    defaultedTooltip = defaultedLabel.slice();
	  }
	
	  encode.defaultedLabel = defaultedLabel;
	  encode.defaultedTooltip = defaultedTooltip;
	  return summary;
	}
	
	function getOrCreateEncodeArr(encode, dim) {
	  if (!encode.hasOwnProperty(dim)) {
	    encode[dim] = [];
	  }
	
	  return encode[dim];
	}
	
	function getDimensionTypeByAxis(axisType) {
	  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
	}
	
	function mayLabelDimType(dimType) {
	  // In most cases, ordinal and time do not suitable for label.
	  // Ordinal info can be displayed on axis. Time is too long.
	  return !(dimType === 'ordinal' || dimType === 'time');
	} // function findTheLastDimMayLabel(data) {
	//     // Get last value dim
	//     var dimensions = data.dimensions.slice();
	//     var valueType;
	//     var valueDim;
	//     while (dimensions.length && (
	//         valueDim = dimensions.pop(),
	//         valueType = data.getDimensionInfo(valueDim).type,
	//         valueType === 'ordinal' || valueType === 'time'
	//     )) {} // jshint ignore:line
	//     return valueDim;
	// }
	
	
	exports.OTHER_DIMENSIONS = OTHER_DIMENSIONS;
	exports.summarizeDimensions = summarizeDimensions;
	exports.getDimensionTypeByAxis = getDimensionTypeByAxis;

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Avoid typo.
	var SOURCE_FORMAT_ORIGINAL = 'original';
	var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
	var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
	var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
	var SOURCE_FORMAT_UNKNOWN = 'unknown'; // ??? CHANGE A NAME
	
	var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
	var SERIES_LAYOUT_BY_COLUMN = 'column';
	var SERIES_LAYOUT_BY_ROW = 'row';
	exports.SOURCE_FORMAT_ORIGINAL = SOURCE_FORMAT_ORIGINAL;
	exports.SOURCE_FORMAT_ARRAY_ROWS = SOURCE_FORMAT_ARRAY_ROWS;
	exports.SOURCE_FORMAT_OBJECT_ROWS = SOURCE_FORMAT_OBJECT_ROWS;
	exports.SOURCE_FORMAT_KEYED_COLUMNS = SOURCE_FORMAT_KEYED_COLUMNS;
	exports.SOURCE_FORMAT_UNKNOWN = SOURCE_FORMAT_UNKNOWN;
	exports.SOURCE_FORMAT_TYPED_ARRAY = SOURCE_FORMAT_TYPED_ARRAY;
	exports.SERIES_LAYOUT_BY_COLUMN = SERIES_LAYOUT_BY_COLUMN;
	exports.SERIES_LAYOUT_BY_ROW = SERIES_LAYOUT_BY_ROW;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var map = _util.map;
	
	var createRenderPlanner = __webpack_require__(171);
	
	var _dataStackHelper = __webpack_require__(102);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    plan: createRenderPlanner(),
	    reset: function (seriesModel) {
	      var data = seriesModel.getData();
	      var coordSys = seriesModel.coordinateSystem;
	      var pipelineContext = seriesModel.pipelineContext;
	      var isLargeRender = pipelineContext.large;
	
	      if (!coordSys) {
	        return;
	      }
	
	      var dims = map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }).slice(0, 2);
	      var dimLen = dims.length;
	      var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	      if (isDimensionStacked(data, dims[0]
	      /*, dims[1]*/
	      )) {
	        dims[0] = stackResultDim;
	      }
	
	      if (isDimensionStacked(data, dims[1]
	      /*, dims[0]*/
	      )) {
	        dims[1] = stackResultDim;
	      }
	
	      function progress(params, data) {
	        var segCount = params.end - params.start;
	        var points = isLargeRender && new Float32Array(segCount * dimLen);
	
	        for (var i = params.start, offset = 0, tmpIn = [], tmpOut = []; i < params.end; i++) {
	          var point;
	
	          if (dimLen === 1) {
	            var x = data.get(dims[0], i);
	            point = !isNaN(x) && coordSys.dataToPoint(x, null, tmpOut);
	          } else {
	            var x = tmpIn[0] = data.get(dims[0], i);
	            var y = tmpIn[1] = data.get(dims[1], i); // Also {Array.<number>}, not undefined to avoid if...else... statement
	
	            point = !isNaN(x) && !isNaN(y) && coordSys.dataToPoint(tmpIn, null, tmpOut);
	          }
	
	          if (isLargeRender) {
	            points[offset++] = point ? point[0] : NaN;
	            points[offset++] = point ? point[1] : NaN;
	          } else {
	            data.setItemLayout(i, point && point.slice() || [NaN, NaN]);
	          }
	        }
	
	        isLargeRender && data.setLayout('symbolPoints', points);
	      }
	
	      return dimLen && {
	        progress: progress
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    reset: function (seriesModel, ecModel) {
	      var legendModels = ecModel.findComponents({
	        mainType: 'legend'
	      });
	
	      if (!legendModels || !legendModels.length) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      data.filterSelf(function (idx) {
	        var name = data.getName(idx); // If in any legend component the status is not selected.
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(name)) {
	            return false;
	          }
	        }
	
	        return true;
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var _clazz = __webpack_require__(115);
	
	var parseClassType = _clazz.parseClassType;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var base = 0;
	/**
	 * @public
	 * @param {string} type
	 * @return {string}
	 */
	
	function getUID(type) {
	  // Considering the case of crossing js context,
	  // use Math.random to make id as unique as possible.
	  return [type || '', base++, Math.random().toFixed(5)].join('_');
	}
	/**
	 * @inner
	 */
	
	
	function enableSubTypeDefaulter(entity) {
	  var subTypeDefaulters = {};
	
	  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
	    componentType = parseClassType(componentType);
	    subTypeDefaulters[componentType.main] = defaulter;
	  };
	
	  entity.determineSubType = function (componentType, option) {
	    var type = option.type;
	
	    if (!type) {
	      var componentTypeMain = parseClassType(componentType).main;
	
	      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
	        type = subTypeDefaulters[componentTypeMain](option);
	      }
	    }
	
	    return type;
	  };
	
	  return entity;
	}
	/**
	 * Topological travel on Activity Network (Activity On Vertices).
	 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
	 *
	 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
	 *
	 * If there is circle dependencey, Error will be thrown.
	 *
	 */
	
	
	function enableTopologicalTravel(entity, dependencyGetter) {
	  /**
	   * @public
	   * @param {Array.<string>} targetNameList Target Component type list.
	   *                                           Can be ['aa', 'bb', 'aa.xx']
	   * @param {Array.<string>} fullNameList By which we can build dependency graph.
	   * @param {Function} callback Params: componentType, dependencies.
	   * @param {Object} context Scope of callback.
	   */
	  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
	    if (!targetNameList.length) {
	      return;
	    }
	
	    var result = makeDepndencyGraph(fullNameList);
	    var graph = result.graph;
	    var stack = result.noEntryList;
	    var targetNameSet = {};
	    zrUtil.each(targetNameList, function (name) {
	      targetNameSet[name] = true;
	    });
	
	    while (stack.length) {
	      var currComponentType = stack.pop();
	      var currVertex = graph[currComponentType];
	      var isInTargetNameSet = !!targetNameSet[currComponentType];
	
	      if (isInTargetNameSet) {
	        callback.call(context, currComponentType, currVertex.originalDeps.slice());
	        delete targetNameSet[currComponentType];
	      }
	
	      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
	    }
	
	    zrUtil.each(targetNameSet, function () {
	      throw new Error('Circle dependency may exists');
	    });
	
	    function removeEdge(succComponentType) {
	      graph[succComponentType].entryCount--;
	
	      if (graph[succComponentType].entryCount === 0) {
	        stack.push(succComponentType);
	      }
	    } // Consider this case: legend depends on series, and we call
	    // chart.setOption({series: [...]}), where only series is in option.
	    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
	    // not be called, but only sereis.mergeOption is called. Thus legend
	    // have no chance to update its local record about series (like which
	    // name of series is available in legend).
	
	
	    function removeEdgeAndAdd(succComponentType) {
	      targetNameSet[succComponentType] = true;
	      removeEdge(succComponentType);
	    }
	  };
	  /**
	   * DepndencyGraph: {Object}
	   * key: conponentType,
	   * value: {
	   *     successor: [conponentTypes...],
	   *     originalDeps: [conponentTypes...],
	   *     entryCount: {number}
	   * }
	   */
	
	
	  function makeDepndencyGraph(fullNameList) {
	    var graph = {};
	    var noEntryList = [];
	    zrUtil.each(fullNameList, function (name) {
	      var thisItem = createDependencyGraphItem(graph, name);
	      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
	      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
	      thisItem.entryCount = availableDeps.length;
	
	      if (thisItem.entryCount === 0) {
	        noEntryList.push(name);
	      }
	
	      zrUtil.each(availableDeps, function (dependentName) {
	        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
	          thisItem.predecessor.push(dependentName);
	        }
	
	        var thatItem = createDependencyGraphItem(graph, dependentName);
	
	        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
	          thatItem.successor.push(name);
	        }
	      });
	    });
	    return {
	      graph: graph,
	      noEntryList: noEntryList
	    };
	  }
	
	  function createDependencyGraphItem(graph, name) {
	    if (!graph[name]) {
	      graph[name] = {
	        predecessor: [],
	        successor: []
	      };
	    }
	
	    return graph[name];
	  }
	
	  function getAvailableDependencies(originalDeps, fullNameList) {
	    var availableDeps = [];
	    zrUtil.each(originalDeps, function (dep) {
	      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
	    });
	    return availableDeps;
	  }
	}
	
	exports.getUID = getUID;
	exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
	exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * LegendVisualProvider is an bridge that pick encoded color from data and
	 * provide to the legend component.
	 * @param {Function} getDataWithEncodedVisual Function to get data after filtered. It stores all the encoding info
	 * @param {Function} getRawData Function to get raw data before filtered.
	 */
	function LegendVisualProvider(getDataWithEncodedVisual, getRawData) {
	  this.getAllNames = function () {
	    var rawData = getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
	    // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
	
	    return rawData.mapArray(rawData.getName);
	  };
	
	  this.containName = function (name) {
	    var rawData = getRawData();
	    return rawData.indexOfName(name) >= 0;
	  };
	
	  this.indexOfName = function (name) {
	    // Only get data when necessary.
	    // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
	    // Invoking Series#getData immediately will throw an error.
	    var dataWithEncodedVisual = getDataWithEncodedVisual();
	    return dataWithEncodedVisual.indexOfName(name);
	  };
	
	  this.getItemVisual = function (dataIndex, key) {
	    // Get encoded visual properties from final filtered data.
	    var dataWithEncodedVisual = getDataWithEncodedVisual();
	    return dataWithEncodedVisual.getItemVisual(dataIndex, key);
	  };
	}
	
	var _default = LegendVisualProvider;
	module.exports = _default;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(49);
	
	var curve = __webpack_require__(134);
	
	/**
	 * @author Yi Shen(https://github.com/pissang)
	 */
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI2 = Math.PI * 2;
	var start = vec2.create();
	var end = vec2.create();
	var extremity = vec2.create();
	/**
	 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
	 * @module zrender/core/bbox
	 * @param {Array<Object>} points 顶点数组
	 * @param {number} min
	 * @param {number} max
	 */
	
	function fromPoints(points, min, max) {
	  if (points.length === 0) {
	    return;
	  }
	
	  var p = points[0];
	  var left = p[0];
	  var right = p[0];
	  var top = p[1];
	  var bottom = p[1];
	  var i;
	
	  for (i = 1; i < points.length; i++) {
	    p = points[i];
	    left = mathMin(left, p[0]);
	    right = mathMax(right, p[0]);
	    top = mathMin(top, p[1]);
	    bottom = mathMax(bottom, p[1]);
	  }
	
	  min[0] = left;
	  min[1] = top;
	  max[0] = right;
	  max[1] = bottom;
	}
	/**
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromLine(x0, y0, x1, y1, min, max) {
	  min[0] = mathMin(x0, x1);
	  min[1] = mathMin(y0, y1);
	  max[0] = mathMax(x0, x1);
	  max[1] = mathMax(y0, y1);
	}
	
	var xDim = [];
	var yDim = [];
	/**
	 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
	  var cubicExtrema = curve.cubicExtrema;
	  var cubicAt = curve.cubicAt;
	  var i;
	  var n = cubicExtrema(x0, x1, x2, x3, xDim);
	  min[0] = Infinity;
	  min[1] = Infinity;
	  max[0] = -Infinity;
	  max[1] = -Infinity;
	
	  for (i = 0; i < n; i++) {
	    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
	    min[0] = mathMin(x, min[0]);
	    max[0] = mathMax(x, max[0]);
	  }
	
	  n = cubicExtrema(y0, y1, y2, y3, yDim);
	
	  for (i = 0; i < n; i++) {
	    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
	    min[1] = mathMin(y, min[1]);
	    max[1] = mathMax(y, max[1]);
	  }
	
	  min[0] = mathMin(x0, min[0]);
	  max[0] = mathMax(x0, max[0]);
	  min[0] = mathMin(x3, min[0]);
	  max[0] = mathMax(x3, max[0]);
	  min[1] = mathMin(y0, min[1]);
	  max[1] = mathMax(y0, max[1]);
	  min[1] = mathMin(y3, min[1]);
	  max[1] = mathMax(y3, max[1]);
	}
	/**
	 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
	  var quadraticExtremum = curve.quadraticExtremum;
	  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero
	
	  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
	  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
	  var x = quadraticAt(x0, x1, x2, tx);
	  var y = quadraticAt(y0, y1, y2, ty);
	  min[0] = mathMin(x0, x2, x);
	  min[1] = mathMin(y0, y2, y);
	  max[0] = mathMax(x0, x2, x);
	  max[1] = mathMax(y0, y2, y);
	}
	/**
	 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
	 * @method
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x
	 * @param {number} y
	 * @param {number} rx
	 * @param {number} ry
	 * @param {number} startAngle
	 * @param {number} endAngle
	 * @param {number} anticlockwise
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
	  var vec2Min = vec2.min;
	  var vec2Max = vec2.max;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff % PI2 < 1e-4 && diff > 1e-4) {
	    // Is a circle
	    min[0] = x - rx;
	    min[1] = y - ry;
	    max[0] = x + rx;
	    max[1] = y + ry;
	    return;
	  }
	
	  start[0] = mathCos(startAngle) * rx + x;
	  start[1] = mathSin(startAngle) * ry + y;
	  end[0] = mathCos(endAngle) * rx + x;
	  end[1] = mathSin(endAngle) * ry + y;
	  vec2Min(min, start, end);
	  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]
	
	  startAngle = startAngle % PI2;
	
	  if (startAngle < 0) {
	    startAngle = startAngle + PI2;
	  }
	
	  endAngle = endAngle % PI2;
	
	  if (endAngle < 0) {
	    endAngle = endAngle + PI2;
	  }
	
	  if (startAngle > endAngle && !anticlockwise) {
	    endAngle += PI2;
	  } else if (startAngle < endAngle && anticlockwise) {
	    startAngle += PI2;
	  }
	
	  if (anticlockwise) {
	    var tmp = endAngle;
	    endAngle = startAngle;
	    startAngle = tmp;
	  } // var number = 0;
	  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;
	
	
	  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
	    if (angle > startAngle) {
	      extremity[0] = mathCos(angle) * rx + x;
	      extremity[1] = mathSin(angle) * ry + y;
	      vec2Min(min, extremity, min);
	      vec2Max(max, extremity, max);
	    }
	  }
	}
	
	exports.fromPoints = fromPoints;
	exports.fromLine = fromLine;
	exports.fromCubic = fromCubic;
	exports.fromQuadratic = fromQuadratic;
	exports.fromArc = fromArc;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(280);
	
	var debugMode = _config.debugMode;
	
	var logError = function () {};
	
	if (debugMode === 1) {
	  logError = console.error;
	}
	
	var _default = logError;
	module.exports = _default;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(2);
	
	var Style = __webpack_require__(449);
	
	var Element = __webpack_require__(894);
	
	var RectText = __webpack_require__(910);
	
	/**
	 * Base class of all displayable graphic objects
	 * @module zrender/graphic/Displayable
	 */
	
	/**
	 * @alias module:zrender/graphic/Displayable
	 * @extends module:zrender/Element
	 * @extends module:zrender/graphic/mixin/RectText
	 */
	function Displayable(opts) {
	  opts = opts || {};
	  Element.call(this, opts); // Extend properties
	
	  for (var name in opts) {
	    if (opts.hasOwnProperty(name) && name !== 'style') {
	      this[name] = opts[name];
	    }
	  }
	  /**
	   * @type {module:zrender/graphic/Style}
	   */
	
	
	  this.style = new Style(opts.style, this);
	  this._rect = null; // Shapes for cascade clipping.
	  // Can only be `null`/`undefined` or an non-empty array, MUST NOT be an empty array.
	  // because it is easy to only using null to check whether clipPaths changed.
	
	  this.__clipPaths = null; // FIXME Stateful must be mixined after style is setted
	  // Stateful.call(this, opts);
	}
	
	Displayable.prototype = {
	  constructor: Displayable,
	  type: 'displayable',
	
	  /**
	   * Dirty flag. From which painter will determine if this displayable object needs brush.
	   * @name module:zrender/graphic/Displayable#__dirty
	   * @type {boolean}
	   */
	  __dirty: true,
	
	  /**
	   * Whether the displayable object is visible. when it is true, the displayable object
	   * is not drawn, but the mouse event can still trigger the object.
	   * @name module:/zrender/graphic/Displayable#invisible
	   * @type {boolean}
	   * @default false
	   */
	  invisible: false,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z: 0,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z2: 0,
	
	  /**
	   * The z level determines the displayable object can be drawn in which layer canvas.
	   * @name module:/zrender/graphic/Displayable#zlevel
	   * @type {number}
	   * @default 0
	   */
	  zlevel: 0,
	
	  /**
	   * Whether it can be dragged.
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  draggable: false,
	
	  /**
	   * Whether is it dragging.
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  dragging: false,
	
	  /**
	   * Whether to respond to mouse events.
	   * @name module:/zrender/graphic/Displayable#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * If enable culling
	   * @type {boolean}
	   * @default false
	   */
	  culling: false,
	
	  /**
	   * Mouse cursor when hovered
	   * @name module:/zrender/graphic/Displayable#cursor
	   * @type {string}
	   */
	  cursor: 'pointer',
	
	  /**
	   * If hover area is bounding rect
	   * @name module:/zrender/graphic/Displayable#rectHover
	   * @type {string}
	   */
	  rectHover: false,
	
	  /**
	   * Render the element progressively when the value >= 0,
	   * usefull for large data.
	   * @type {boolean}
	   */
	  progressive: false,
	
	  /**
	   * @type {boolean}
	   */
	  incremental: false,
	
	  /**
	   * Scale ratio for global scale.
	   * @type {boolean}
	   */
	  globalScaleRatio: 1,
	  beforeBrush: function (ctx) {},
	  afterBrush: function (ctx) {},
	
	  /**
	   * Graphic drawing method.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  // Interface
	  brush: function (ctx, prevEl) {},
	
	  /**
	   * Get the minimum bounding box.
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // Interface
	  getBoundingRect: function () {},
	
	  /**
	   * If displayable element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  contain: function (x, y) {
	    return this.rectContain(x, y);
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    cb.call(context, this);
	  },
	
	  /**
	   * If bounding rect of element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  rectContain: function (x, y) {
	    var coord = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    return rect.contain(coord[0], coord[1]);
	  },
	
	  /**
	   * Mark displayable element dirty and refresh next frame
	   */
	  dirty: function () {
	    this.__dirty = this.__dirtyText = true;
	    this._rect = null;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * If displayable object binded any event
	   * @return {boolean}
	   */
	  // TODO, events bound by bind
	  // isSilent: function () {
	  //     return !(
	  //         this.hoverable || this.draggable
	  //         || this.onmousemove || this.onmouseover || this.onmouseout
	  //         || this.onmousedown || this.onmouseup || this.onclick
	  //         || this.ondragenter || this.ondragover || this.ondragleave
	  //         || this.ondrop
	  //     );
	  // },
	
	  /**
	   * Alias for animate('style')
	   * @param {boolean} loop
	   */
	  animateStyle: function (loop) {
	    return this.animate('style', loop);
	  },
	  attrKV: function (key, value) {
	    if (key !== 'style') {
	      Element.prototype.attrKV.call(this, key, value);
	    } else {
	      this.style.set(value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setStyle: function (key, value) {
	    this.style.set(key, value);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * Use given style object
	   * @param  {Object} obj
	   */
	  useStyle: function (obj) {
	    this.style = new Style(obj, this);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * The string value of `textPosition` needs to be calculated to a real postion.
	   * For example, `'inside'` is calculated to `[rect.width/2, rect.height/2]`
	   * by default. See `contain/text.js#calculateTextPosition` for more details.
	   * But some coutom shapes like "pin", "flag" have center that is not exactly
	   * `[width/2, height/2]`. So we provide this hook to customize the calculation
	   * for those shapes. It will be called if the `style.textPosition` is a string.
	   * @param {Obejct} [out] Prepared out object. If not provided, this method should
	   *        be responsible for creating one.
	   * @param {module:zrender/graphic/Style} style
	   * @param {Object} rect {x, y, width, height}
	   * @return {Obejct} out The same as the input out.
	   *         {
	   *             x: number. mandatory.
	   *             y: number. mandatory.
	   *             textAlign: string. optional. use style.textAlign by default.
	   *             textVerticalAlign: string. optional. use style.textVerticalAlign by default.
	   *         }
	   */
	  calculateTextPosition: null
	};
	zrUtil.inherits(Displayable, Element);
	zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);
	
	var _default = Displayable;
	module.exports = _default;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Reusable object
			var W = [];
	
			/**
	   * SHA-1 hash algorithm.
	   */
			var SHA1 = C_algo.SHA1 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var H = this._hash.words;
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
					var e = H[4];
	
					// Computation
					for (var i = 0; i < 80; i++) {
						if (i < 16) {
							W[i] = M[offset + i] | 0;
						} else {
							var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
							W[i] = n << 1 | n >>> 31;
						}
	
						var t = (a << 5 | a >>> 27) + e + W[i];
						if (i < 20) {
							t += (b & c | ~b & d) + 0x5a827999;
						} else if (i < 40) {
							t += (b ^ c ^ d) + 0x6ed9eba1;
						} else if (i < 60) {
							t += (b & c | b & d | c & d) - 0x70e44324;
						} else /* if (i < 80) */{
								t += (b ^ c ^ d) - 0x359d3e2a;
							}
	
						e = d;
						d = c;
						c = b << 30 | b >>> 2;
						b = a;
						a = t;
					}
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
					H[4] = H[4] + e | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Return final computed hash
					return this._hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA1('message');
	   *     var hash = CryptoJS.SHA1(wordArray);
	   */
			C.SHA1 = Hasher._createHelper(SHA1);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA1(message, key);
	   */
			C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		})();
	
		return CryptoJS.SHA1;
	});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(121));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(121)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Hasher = C_lib.Hasher;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var X64WordArray = C_x64.WordArray;
			var C_algo = C.algo;
	
			function X64Word_create() {
				return X64Word.create.apply(X64Word, arguments);
			}
	
			// Constants
			var K = [X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd), X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc), X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019), X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118), X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe), X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2), X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1), X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694), X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3), X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65), X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483), X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5), X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210), X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4), X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725), X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70), X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926), X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df), X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8), X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b), X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001), X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30), X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910), X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8), X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53), X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8), X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb), X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3), X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60), X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec), X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9), X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b), X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207), X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178), X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6), X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b), X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493), X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c), X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a), X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)];
	
			// Reusable objects
			var W = [];
			(function () {
				for (var i = 0; i < 80; i++) {
					W[i] = X64Word_create();
				}
			})();
	
			/**
	   * SHA-512 hash algorithm.
	   */
			var SHA512 = C_algo.SHA512 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new X64WordArray.init([new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b), new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1), new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f), new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcuts
					var H = this._hash.words;
	
					var H0 = H[0];
					var H1 = H[1];
					var H2 = H[2];
					var H3 = H[3];
					var H4 = H[4];
					var H5 = H[5];
					var H6 = H[6];
					var H7 = H[7];
	
					var H0h = H0.high;
					var H0l = H0.low;
					var H1h = H1.high;
					var H1l = H1.low;
					var H2h = H2.high;
					var H2l = H2.low;
					var H3h = H3.high;
					var H3l = H3.low;
					var H4h = H4.high;
					var H4l = H4.low;
					var H5h = H5.high;
					var H5l = H5.low;
					var H6h = H6.high;
					var H6l = H6.low;
					var H7h = H7.high;
					var H7l = H7.low;
	
					// Working variables
					var ah = H0h;
					var al = H0l;
					var bh = H1h;
					var bl = H1l;
					var ch = H2h;
					var cl = H2l;
					var dh = H3h;
					var dl = H3l;
					var eh = H4h;
					var el = H4l;
					var fh = H5h;
					var fl = H5l;
					var gh = H6h;
					var gl = H6l;
					var hh = H7h;
					var hl = H7l;
	
					// Rounds
					for (var i = 0; i < 80; i++) {
						var Wil;
						var Wih;
	
						// Shortcut
						var Wi = W[i];
	
						// Extend message
						if (i < 16) {
							Wih = Wi.high = M[offset + i * 2] | 0;
							Wil = Wi.low = M[offset + i * 2 + 1] | 0;
						} else {
							// Gamma0
							var gamma0x = W[i - 15];
							var gamma0xh = gamma0x.high;
							var gamma0xl = gamma0x.low;
							var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
							var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
	
							// Gamma1
							var gamma1x = W[i - 2];
							var gamma1xh = gamma1x.high;
							var gamma1xl = gamma1x.low;
							var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
							var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
	
							// W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
							var Wi7 = W[i - 7];
							var Wi7h = Wi7.high;
							var Wi7l = Wi7.low;
	
							var Wi16 = W[i - 16];
							var Wi16h = Wi16.high;
							var Wi16l = Wi16.low;
	
							Wil = gamma0l + Wi7l;
							Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
							Wil = Wil + gamma1l;
							Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
							Wil = Wil + Wi16l;
							Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
	
							Wi.high = Wih;
							Wi.low = Wil;
						}
	
						var chh = eh & fh ^ ~eh & gh;
						var chl = el & fl ^ ~el & gl;
						var majh = ah & bh ^ ah & ch ^ bh & ch;
						var majl = al & bl ^ al & cl ^ bl & cl;
	
						var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
						var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
						var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
						var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
	
						// t1 = h + sigma1 + ch + K[i] + W[i]
						var Ki = K[i];
						var Kih = Ki.high;
						var Kil = Ki.low;
	
						var t1l = hl + sigma1l;
						var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
						var t1l = t1l + chl;
						var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
						var t1l = t1l + Kil;
						var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
						var t1l = t1l + Wil;
						var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
	
						// t2 = sigma0 + maj
						var t2l = sigma0l + majl;
						var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
	
						// Update working variables
						hh = gh;
						hl = gl;
						gh = fh;
						gl = fl;
						fh = eh;
						fl = el;
						el = dl + t1l | 0;
						eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
						dh = ch;
						dl = cl;
						ch = bh;
						cl = bl;
						bh = ah;
						bl = al;
						al = t1l + t2l | 0;
						ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
					}
	
					// Intermediate hash value
					H0l = H0.low = H0l + al;
					H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
					H1l = H1.low = H1l + bl;
					H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
					H2l = H2.low = H2l + cl;
					H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
					H3l = H3.low = H3l + dl;
					H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
					H4l = H4.low = H4l + el;
					H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
					H5l = H5.low = H5l + fl;
					H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
					H6l = H6.low = H6l + gl;
					H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
					H7l = H7.low = H7l + hl;
					H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Convert hash to 32-bit word array before returning
					var hash = this._hash.toX32();
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				},
	
				blockSize: 1024 / 32
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA512('message');
	   *     var hash = CryptoJS.SHA512(wordArray);
	   */
			C.SHA512 = Hasher._createHelper(SHA512);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA512(message, key);
	   */
			C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		})();
	
		return CryptoJS.SHA512;
	});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withConfigConsumer = withConfigConsumer;
	exports.ConfigConsumer = exports.ConfigContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _renderEmpty = _interopRequireDefault(__webpack_require__(1034));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var ConfigContext = (0, _createReactContext["default"])({
	  // We provide a default function for Context without provider
	  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
	    if (customizePrefixCls) return customizePrefixCls;
	    return "ant-".concat(suffixCls);
	  },
	  renderEmpty: _renderEmpty["default"]
	});
	exports.ConfigContext = ConfigContext;
	var ConfigConsumer = ConfigContext.Consumer;
	exports.ConfigConsumer = ConfigConsumer;
	
	function withConfigConsumer(config) {
	  return function withConfigConsumerFunc(Component) {
	    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
	    var SFC = function SFC(props) {
	      return (/*#__PURE__*/React.createElement(ConfigConsumer, null, function (configProps) {
	          var basicPrefixCls = config.prefixCls;
	          var getPrefixCls = configProps.getPrefixCls;
	          var customizePrefixCls = props.prefixCls;
	          var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
	          return (/*#__PURE__*/React.createElement(Component, _extends({}, configProps, props, {
	              prefixCls: prefixCls
	            }))
	          );
	        })
	      );
	    };
	
	    var cons = Component.constructor;
	    var name = cons && cons.displayName || Component.name || 'Component';
	    SFC.displayName = "withConfigConsumer(".concat(name, ")");
	    return SFC;
	  };
	}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _row["default"];
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _col["default"];
	  }
	});
	
	var _row = _interopRequireDefault(__webpack_require__(570));
	
	var _col = _interopRequireDefault(__webpack_require__(569));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Input = _interopRequireDefault(__webpack_require__(196));
	
	var _Group = _interopRequireDefault(__webpack_require__(1054));
	
	var _Search = _interopRequireDefault(__webpack_require__(1057));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(572));
	
	var _Password = _interopRequireDefault(__webpack_require__(1055));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Input["default"].Group = _Group["default"];
	_Input["default"].Search = _Search["default"];
	_Input["default"].TextArea = _TextArea["default"];
	_Input["default"].Password = _Password["default"];
	var _default = _Input["default"];
	exports["default"] = _default;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Group", {
	  enumerable: true,
	  get: function get() {
	    return _group["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _radioButton["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _radio = _interopRequireDefault(__webpack_require__(303));
	
	var _group = _interopRequireDefault(__webpack_require__(1080));
	
	var _radioButton = _interopRequireDefault(__webpack_require__(1081));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_radio["default"].Button = _radioButton["default"];
	_radio["default"].Group = _group["default"];
	var _default = _radio["default"];
	exports["default"] = _default;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _configProvider = __webpack_require__(13);
	
	var _type = __webpack_require__(78);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SpinSizes = (0, _type.tuple)('small', 'default', 'large'); // Render indicator
	
	var defaultIndicator = null;
	
	function renderIndicator(prefixCls, props) {
	  var indicator = props.indicator;
	  var dotClassName = "".concat(prefixCls, "-dot"); // should not be render default indicator when indicator value is null
	
	  if (indicator === null) {
	    return null;
	  }
	
	  if ( /*#__PURE__*/React.isValidElement(indicator)) {
	    return (/*#__PURE__*/React.cloneElement(indicator, {
	        className: (0, _classnames["default"])(indicator.props.className, dotClassName)
	      })
	    );
	  }
	
	  if ( /*#__PURE__*/React.isValidElement(defaultIndicator)) {
	    return (/*#__PURE__*/React.cloneElement(defaultIndicator, {
	        className: (0, _classnames["default"])(defaultIndicator.props.className, dotClassName)
	      })
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement("span", {
	      className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
	    }, /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }))
	  );
	}
	
	function shouldDelay(spinning, delay) {
	  return !!spinning && !!delay && !isNaN(Number(delay));
	}
	
	var Spin = /*#__PURE__*/function (_React$Component) {
	  _inherits(Spin, _React$Component);
	
	  var _super = _createSuper(Spin);
	
	  function Spin(props) {
	    var _this;
	
	    _classCallCheck(this, Spin);
	
	    _this = _super.call(this, props);
	
	    _this.debouncifyUpdateSpinning = function (props) {
	      var _ref = props || _this.props,
	          delay = _ref.delay;
	
	      if (delay) {
	        _this.cancelExistingSpin();
	
	        _this.updateSpinning = (0, _debounce["default"])(_this.originalUpdateSpinning, delay);
	      }
	    };
	
	    _this.updateSpinning = function () {
	      var spinning = _this.props.spinning;
	      var currentSpinning = _this.state.spinning;
	
	      if (currentSpinning !== spinning) {
	        _this.setState({
	          spinning: spinning
	        });
	      }
	    };
	
	    _this.renderSpin = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          size = _a.size,
	          tip = _a.tip,
	          wrapperClassName = _a.wrapperClassName,
	          style = _a.style,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);
	
	      var spinning = _this.state.spinning;
	      var prefixCls = getPrefixCls('spin', customizePrefixCls);
	      var spinClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _classNames), className); // fix https://fb.me/react-unknown-prop
	
	      var divProps = (0, _omit["default"])(restProps, ['spinning', 'delay', 'indicator']);
	      var spinElement = /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        style: style,
	        className: spinClassName
	      }), renderIndicator(prefixCls, _this.props), tip ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-text")
	      }, tip) : null);
	
	      if (_this.isNestedPattern()) {
	        var containerClassName = (0, _classnames["default"])("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
	        return (/*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	            className: (0, _classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
	          }), spinning && /*#__PURE__*/React.createElement("div", {
	            key: "loading"
	          }, spinElement), /*#__PURE__*/React.createElement("div", {
	            className: containerClassName,
	            key: "container"
	          }, _this.props.children))
	        );
	      }
	
	      return spinElement;
	    };
	
	    var spinning = props.spinning,
	        delay = props.delay;
	    var shouldBeDelayed = shouldDelay(spinning, delay);
	    _this.state = {
	      spinning: spinning && !shouldBeDelayed
	    };
	    _this.originalUpdateSpinning = _this.updateSpinning;
	
	    _this.debouncifyUpdateSpinning(props);
	
	    return _this;
	  }
	
	  _createClass(Spin, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateSpinning();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.debouncifyUpdateSpinning();
	      this.updateSpinning();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.cancelExistingSpin();
	    }
	  }, {
	    key: "cancelExistingSpin",
	    value: function cancelExistingSpin() {
	      var updateSpinning = this.updateSpinning;
	
	      if (updateSpinning && updateSpinning.cancel) {
	        updateSpinning.cancel();
	      }
	    }
	  }, {
	    key: "isNestedPattern",
	    value: function isNestedPattern() {
	      return !!(this.props && this.props.children);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSpin)
	      );
	    }
	  }], [{
	    key: "setDefaultIndicator",
	    value: function setDefaultIndicator(indicator) {
	      defaultIndicator = indicator;
	    }
	  }]);
	
	  return Spin;
	}(React.Component);
	
	Spin.defaultProps = {
	  spinning: true,
	  size: 'default',
	  wrapperClassName: ''
	};
	Spin.propTypes = {
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  spinning: PropTypes.bool,
	  size: PropTypes.oneOf(SpinSizes),
	  wrapperClassName: PropTypes.string,
	  indicator: PropTypes.element
	};
	var _default = Spin;
	exports["default"] = _default;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Reusable object
			var W = [];
	
			/**
	   * SHA-1 hash algorithm.
	   */
			var SHA1 = C_algo.SHA1 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var H = this._hash.words;
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
					var e = H[4];
	
					// Computation
					for (var i = 0; i < 80; i++) {
						if (i < 16) {
							W[i] = M[offset + i] | 0;
						} else {
							var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
							W[i] = n << 1 | n >>> 31;
						}
	
						var t = (a << 5 | a >>> 27) + e + W[i];
						if (i < 20) {
							t += (b & c | ~b & d) + 0x5a827999;
						} else if (i < 40) {
							t += (b ^ c ^ d) + 0x6ed9eba1;
						} else if (i < 60) {
							t += (b & c | b & d | c & d) - 0x70e44324;
						} else /* if (i < 80) */{
								t += (b ^ c ^ d) - 0x359d3e2a;
							}
	
						e = d;
						d = c;
						c = b << 30 | b >>> 2;
						b = a;
						a = t;
					}
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
					H[4] = H[4] + e | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Return final computed hash
					return this._hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA1('message');
	   *     var hash = CryptoJS.SHA1(wordArray);
	   */
			C.SHA1 = Hasher._createHelper(SHA1);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA1(message, key);
	   */
			C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		})();
	
		return CryptoJS.SHA1;
	});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(123));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(123)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Hasher = C_lib.Hasher;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var X64WordArray = C_x64.WordArray;
			var C_algo = C.algo;
	
			function X64Word_create() {
				return X64Word.create.apply(X64Word, arguments);
			}
	
			// Constants
			var K = [X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd), X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc), X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019), X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118), X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe), X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2), X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1), X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694), X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3), X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65), X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483), X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5), X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210), X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4), X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725), X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70), X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926), X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df), X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8), X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b), X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001), X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30), X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910), X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8), X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53), X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8), X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb), X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3), X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60), X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec), X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9), X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b), X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207), X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178), X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6), X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b), X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493), X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c), X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a), X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)];
	
			// Reusable objects
			var W = [];
			(function () {
				for (var i = 0; i < 80; i++) {
					W[i] = X64Word_create();
				}
			})();
	
			/**
	   * SHA-512 hash algorithm.
	   */
			var SHA512 = C_algo.SHA512 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new X64WordArray.init([new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b), new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1), new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f), new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcuts
					var H = this._hash.words;
	
					var H0 = H[0];
					var H1 = H[1];
					var H2 = H[2];
					var H3 = H[3];
					var H4 = H[4];
					var H5 = H[5];
					var H6 = H[6];
					var H7 = H[7];
	
					var H0h = H0.high;
					var H0l = H0.low;
					var H1h = H1.high;
					var H1l = H1.low;
					var H2h = H2.high;
					var H2l = H2.low;
					var H3h = H3.high;
					var H3l = H3.low;
					var H4h = H4.high;
					var H4l = H4.low;
					var H5h = H5.high;
					var H5l = H5.low;
					var H6h = H6.high;
					var H6l = H6.low;
					var H7h = H7.high;
					var H7l = H7.low;
	
					// Working variables
					var ah = H0h;
					var al = H0l;
					var bh = H1h;
					var bl = H1l;
					var ch = H2h;
					var cl = H2l;
					var dh = H3h;
					var dl = H3l;
					var eh = H4h;
					var el = H4l;
					var fh = H5h;
					var fl = H5l;
					var gh = H6h;
					var gl = H6l;
					var hh = H7h;
					var hl = H7l;
	
					// Rounds
					for (var i = 0; i < 80; i++) {
						var Wil;
						var Wih;
	
						// Shortcut
						var Wi = W[i];
	
						// Extend message
						if (i < 16) {
							Wih = Wi.high = M[offset + i * 2] | 0;
							Wil = Wi.low = M[offset + i * 2 + 1] | 0;
						} else {
							// Gamma0
							var gamma0x = W[i - 15];
							var gamma0xh = gamma0x.high;
							var gamma0xl = gamma0x.low;
							var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
							var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
	
							// Gamma1
							var gamma1x = W[i - 2];
							var gamma1xh = gamma1x.high;
							var gamma1xl = gamma1x.low;
							var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
							var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
	
							// W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
							var Wi7 = W[i - 7];
							var Wi7h = Wi7.high;
							var Wi7l = Wi7.low;
	
							var Wi16 = W[i - 16];
							var Wi16h = Wi16.high;
							var Wi16l = Wi16.low;
	
							Wil = gamma0l + Wi7l;
							Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
							Wil = Wil + gamma1l;
							Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
							Wil = Wil + Wi16l;
							Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
	
							Wi.high = Wih;
							Wi.low = Wil;
						}
	
						var chh = eh & fh ^ ~eh & gh;
						var chl = el & fl ^ ~el & gl;
						var majh = ah & bh ^ ah & ch ^ bh & ch;
						var majl = al & bl ^ al & cl ^ bl & cl;
	
						var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
						var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
						var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
						var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
	
						// t1 = h + sigma1 + ch + K[i] + W[i]
						var Ki = K[i];
						var Kih = Ki.high;
						var Kil = Ki.low;
	
						var t1l = hl + sigma1l;
						var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
						var t1l = t1l + chl;
						var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
						var t1l = t1l + Kil;
						var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
						var t1l = t1l + Wil;
						var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
	
						// t2 = sigma0 + maj
						var t2l = sigma0l + majl;
						var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
	
						// Update working variables
						hh = gh;
						hl = gl;
						gh = fh;
						gl = fl;
						fh = eh;
						fl = el;
						el = dl + t1l | 0;
						eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
						dh = ch;
						dl = cl;
						ch = bh;
						cl = bl;
						bh = ah;
						bl = al;
						al = t1l + t2l | 0;
						ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
					}
	
					// Intermediate hash value
					H0l = H0.low = H0l + al;
					H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
					H1l = H1.low = H1l + bl;
					H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
					H2l = H2.low = H2l + cl;
					H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
					H3l = H3.low = H3l + dl;
					H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
					H4l = H4.low = H4l + el;
					H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
					H5l = H5.low = H5l + fl;
					H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
					H6l = H6.low = H6l + gl;
					H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
					H7l = H7.low = H7l + hl;
					H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Convert hash to 32-bit word array before returning
					var hash = this._hash.toX32();
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				},
	
				blockSize: 1024 / 32
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA512('message');
	   *     var hash = CryptoJS.SHA512(wordArray);
	   */
			C.SHA512 = Hasher._createHelper(SHA512);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA512(message, key);
	   */
			C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		})();
	
		return CryptoJS.SHA512;
	});

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.sgiLocalStorage = undefined;
	
	var _sgiCommon = __webpack_require__(28);
	
	/**
	 * 本地缓存方法集，封装window.localStorage
	 * @namespace 本地缓存方法集
	 * @alias tool.sgiStorage
	 */
	var sgiLocalStorage = {
		localMap: null,
		localSupported: undefined,
	
		/**
	  * 设置localStorage缓存
	  * @param {string} key 存储key
	  * @param {object} value 存储值
	  */
		set: function set(key, value) {
			// var zip = new JSZip();
			// zip.file(key, value);
			// value = zip.generate({
			// 	'compression': 'DEFLATE',
			// 	type: "string"
			// });
			value = _sgiCommon.sgiZip.zip(key, value);
			if (this.localStorageSupported()) {
				return window.localStorage.setItem(key, value);
			} else {
				return this.localMap.add(key, value);
			}
		},
	
		/**
	  * 根据key值获取本地存储
	  * @param {string} key 存储key
	  * @returns {object} 存储值
	  */
		get: function get(key) {
			var value;
			if (this.localStorageSupported()) {
				value = window.localStorage.getItem(key);
			} else {
				value = this.localMap.get(key);
			}
			if (value) {
				// var zip = new JSZip();
				// zip.load(value);
				// return zip.file(key).asText();
				// return value;
				return _sgiCommon.sgiZip.unzip(key, value);
			} else {
				return null;
			}
		},
	
		/**
	  * 清空本地存储
	  */
		clear: function clear() {
			if (this.localStorageSupported()) {
				window.localStorage.clear();
			} else {
	
				this.localMap.clear();
			}
		},
	
		/**
	  * 根据key删除本地存储
	  * @param {string} key 存储key
	  */
		remove: function remove(key) {
			if (this.localStorageSupported()) {
				window.localStorage.removeItem(key);
			} else {
				this.localMap.removeByKey(key);
			}
		},
	
		/**
	  * 根据前缀批量删除本地存储（谨慎使用，以免误删前缀相同存储）
	  * @param {string} prefix 存储key值前缀
	  */
		removeByPrefix: function removeByPrefix(prefix) {
			if (!prefix) return;
			var preLength = prefix.length;
			if (this.localStorageSupported()) {
				var storage = window.localStorage;
				// let length = storage.length;//删除后，length会变
				for (var i = 0; i < storage.length; i++) {
					var key = storage.key(i);
					var pre = key.substr(0, preLength);
					if (pre === prefix) {
						storage.removeItem(key);
						i--;
					}
				}
			} else {
				this.localMap.removeByPrefix(prefix);
			}
		},
	
		/**
	  * 获取本地缓存长度
	  * @returns {number} 缓存长度
	  */
		length: function length() {
			if (this.localStorageSupported()) {
				return window.localStorage.length;
			} else {
				return this.localMap.length;
			}
		},
	
		/**
	  * 根据索引序号获取存储key
	  * @param {number} index 索引序号
	  */
		key: function key(index) {
			if (this.localStorageSupported()) {
				return window.localStorage.key(index);
			} else {
				return this.localMap.key(index);
			}
		},
	
		/**
	  * 判断window本地缓存支持情况
	  * @returns {boolean} window是否支持localstorage本地缓存
	  */
		localStorageSupported: function localStorageSupported() {
			var testKey = 'test',
			    storage = window.localStorage;
			if (this.localSupported === undefined) {
				try {
					storage.setItem(testKey, '1');
					storage.removeItem(testKey);
					this.localSupported = true;
				} catch (error) {
					this.localSupported = false;
				}
			}
			return this.localSupported;
		}
	
	}; // import JSZip from 'jszip'
	exports.sgiLocalStorage = sgiLocalStorage;
	exports.default = sgiLocalStorage;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var smProjDndConfig = {
	
	    projTyp: undefined,
	    setProjTyp: function setProjTyp(projTyp) {
	        this.projTyp = projTyp;
	    },
	    getProjTyp: function getProjTyp() {
	        return this.projTyp;
	    },
	    isSAPrm: function isSAPrm(guid) {
	
	        if (guid) {
	            var guidArray = guid.split("_");
	            return this.isSAPrmByAP(guidArray[0]);
	        }
	    },
	    isSAPrmByAP: function isSAPrmByAP(ap) {
	        if (!ap) {
	            return;
	        }
	
	        if (sgiSrvUrl.allOldParamFlag) {
	            return false;
	        }
	        //"sd", "rtsd", "param", "rtuam", "workbench","gw", "knowledgeBase", "stats"
	        var oldParamAPs = [];
	        oldParamAPs.push.apply(oldParamAPs, _toConsumableArray(sgiSrvUrl.oldParamAPs || []));
	        if (oldParamAPs.indexOf(ap) < 0) {
	            return true;
	        }
	    },
	    getPrmByTT: function getPrmByTT(ap, tt) {
	        if (this.projTyp === "sm") {
	            return SAPrmFactory.getPrmDetailByTT(ap, tt);
	        } else {
	            return PrmFactory.getPrmByTT(ap, tt);
	        }
	    },
	
	    getDSDSelectGuid: function getDSDSelectGuid() {
	        if (this.projTyp === "sm") {
	            // return "sd_UI_bruUI.dbase.sub_15018-08";
	            return "sm_UI_du.sd_021501-06";
	        } else {
	            return "rtsd_UI_DSD_2001";
	        }
	    },
	    getDSDPreviewSelectGuid: function getDSDPreviewSelectGuid() {
	        if (this.projTyp === "sm") {
	            // return "sd_UI_bruUI.dbase.sub_15018-06";
	            return "sm_UI_du.sd_021601";
	        } else {
	            return "rtsd_UI_DSD_0005";
	        }
	    },
	
	
	    // getDSDPreviewSelectGuid() {
	    //     if (this.projTyp === "sm") {
	    //         return "sd_UI_bruUI.dbase.sub_15018-09";
	    //     } else {
	    //         return "rtsd_UI_DSD_0005";
	    //     }
	    // },
	
	    getPrm: function getPrm(item) {
	        if (this.projTyp === "sm") {
	            return SAPrmFactory.getPrm(item);
	        } else {
	            return PrmFactory.getPrm(item);
	        }
	    }
	
	    // getDndDevMainCUIInsertInit: function (ap, tt) {
	    //     if (this.projTyp === "sm") {
	    //         return SAPrmFactory.getPrmDetailByTT(ap, tt) || [];
	    //     } else {
	    //         return PrmFactory.getPrmByTT(ap, tt) || [];
	    //     }
	    // }
	};
	
	exports.default = smProjDndConfig;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var GUID = {
	    SP: "_",
	    MenSP: "`"
	};
	
	exports.GUID = GUID;
	exports.default = GUID;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withConfigConsumer = withConfigConsumer;
	exports.ConfigConsumer = exports.ConfigContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _renderEmpty = _interopRequireDefault(__webpack_require__(1192));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var ConfigContext = (0, _createReactContext["default"])({
	  // We provide a default function for Context without provider
	  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
	    if (customizePrefixCls) return customizePrefixCls;
	    return "ant-".concat(suffixCls);
	  },
	  renderEmpty: _renderEmpty["default"]
	});
	exports.ConfigContext = ConfigContext;
	var ConfigConsumer = ConfigContext.Consumer;
	exports.ConfigConsumer = ConfigConsumer;
	
	function withConfigConsumer(config) {
	  return function withConfigConsumerFunc(Component) {
	    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
	    var SFC = function SFC(props) {
	      return (/*#__PURE__*/React.createElement(ConfigConsumer, null, function (configProps) {
	          var basicPrefixCls = config.prefixCls;
	          var getPrefixCls = configProps.getPrefixCls;
	          var customizePrefixCls = props.prefixCls;
	          var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
	          return (/*#__PURE__*/React.createElement(Component, _extends({}, configProps, props, {
	              prefixCls: prefixCls
	            }))
	          );
	        })
	      );
	    };
	
	    var cons = Component.constructor;
	    var name = cons && cons.displayName || Component.name || 'Component';
	    SFC.displayName = "withConfigConsumer(".concat(name, ")");
	    return SFC;
	  };
	}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _row["default"];
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _col["default"];
	  }
	});
	
	var _row = _interopRequireDefault(__webpack_require__(648));
	
	var _col = _interopRequireDefault(__webpack_require__(647));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Input = _interopRequireDefault(__webpack_require__(201));
	
	var _Group = _interopRequireDefault(__webpack_require__(1212));
	
	var _Search = _interopRequireDefault(__webpack_require__(1215));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(650));
	
	var _Password = _interopRequireDefault(__webpack_require__(1213));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Input["default"].Group = _Group["default"];
	_Input["default"].Search = _Search["default"];
	_Input["default"].TextArea = _TextArea["default"];
	_Input["default"].Password = _Password["default"];
	var _default = _Input["default"];
	exports["default"] = _default;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Group", {
	  enumerable: true,
	  get: function get() {
	    return _group["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _radioButton["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _radio = _interopRequireDefault(__webpack_require__(363));
	
	var _group = _interopRequireDefault(__webpack_require__(1238));
	
	var _radioButton = _interopRequireDefault(__webpack_require__(1239));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_radio["default"].Button = _radioButton["default"];
	_radio["default"].Group = _group["default"];
	var _default = _radio["default"];
	exports["default"] = _default;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _configProvider = __webpack_require__(14);
	
	var _type = __webpack_require__(82);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SpinSizes = (0, _type.tuple)('small', 'default', 'large'); // Render indicator
	
	var defaultIndicator = null;
	
	function renderIndicator(prefixCls, props) {
	  var indicator = props.indicator;
	  var dotClassName = "".concat(prefixCls, "-dot"); // should not be render default indicator when indicator value is null
	
	  if (indicator === null) {
	    return null;
	  }
	
	  if ( /*#__PURE__*/React.isValidElement(indicator)) {
	    return (/*#__PURE__*/React.cloneElement(indicator, {
	        className: (0, _classnames["default"])(indicator.props.className, dotClassName)
	      })
	    );
	  }
	
	  if ( /*#__PURE__*/React.isValidElement(defaultIndicator)) {
	    return (/*#__PURE__*/React.cloneElement(defaultIndicator, {
	        className: (0, _classnames["default"])(defaultIndicator.props.className, dotClassName)
	      })
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement("span", {
	      className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
	    }, /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }))
	  );
	}
	
	function shouldDelay(spinning, delay) {
	  return !!spinning && !!delay && !isNaN(Number(delay));
	}
	
	var Spin = /*#__PURE__*/function (_React$Component) {
	  _inherits(Spin, _React$Component);
	
	  var _super = _createSuper(Spin);
	
	  function Spin(props) {
	    var _this;
	
	    _classCallCheck(this, Spin);
	
	    _this = _super.call(this, props);
	
	    _this.debouncifyUpdateSpinning = function (props) {
	      var _ref = props || _this.props,
	          delay = _ref.delay;
	
	      if (delay) {
	        _this.cancelExistingSpin();
	
	        _this.updateSpinning = (0, _debounce["default"])(_this.originalUpdateSpinning, delay);
	      }
	    };
	
	    _this.updateSpinning = function () {
	      var spinning = _this.props.spinning;
	      var currentSpinning = _this.state.spinning;
	
	      if (currentSpinning !== spinning) {
	        _this.setState({
	          spinning: spinning
	        });
	      }
	    };
	
	    _this.renderSpin = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          size = _a.size,
	          tip = _a.tip,
	          wrapperClassName = _a.wrapperClassName,
	          style = _a.style,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);
	
	      var spinning = _this.state.spinning;
	      var prefixCls = getPrefixCls('spin', customizePrefixCls);
	      var spinClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _classNames), className); // fix https://fb.me/react-unknown-prop
	
	      var divProps = (0, _omit["default"])(restProps, ['spinning', 'delay', 'indicator']);
	      var spinElement = /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        style: style,
	        className: spinClassName
	      }), renderIndicator(prefixCls, _this.props), tip ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-text")
	      }, tip) : null);
	
	      if (_this.isNestedPattern()) {
	        var containerClassName = (0, _classnames["default"])("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
	        return (/*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	            className: (0, _classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
	          }), spinning && /*#__PURE__*/React.createElement("div", {
	            key: "loading"
	          }, spinElement), /*#__PURE__*/React.createElement("div", {
	            className: containerClassName,
	            key: "container"
	          }, _this.props.children))
	        );
	      }
	
	      return spinElement;
	    };
	
	    var spinning = props.spinning,
	        delay = props.delay;
	    var shouldBeDelayed = shouldDelay(spinning, delay);
	    _this.state = {
	      spinning: spinning && !shouldBeDelayed
	    };
	    _this.originalUpdateSpinning = _this.updateSpinning;
	
	    _this.debouncifyUpdateSpinning(props);
	
	    return _this;
	  }
	
	  _createClass(Spin, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateSpinning();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.debouncifyUpdateSpinning();
	      this.updateSpinning();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.cancelExistingSpin();
	    }
	  }, {
	    key: "cancelExistingSpin",
	    value: function cancelExistingSpin() {
	      var updateSpinning = this.updateSpinning;
	
	      if (updateSpinning && updateSpinning.cancel) {
	        updateSpinning.cancel();
	      }
	    }
	  }, {
	    key: "isNestedPattern",
	    value: function isNestedPattern() {
	      return !!(this.props && this.props.children);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSpin)
	      );
	    }
	  }], [{
	    key: "setDefaultIndicator",
	    value: function setDefaultIndicator(indicator) {
	      defaultIndicator = indicator;
	    }
	  }]);
	
	  return Spin;
	}(React.Component);
	
	Spin.defaultProps = {
	  spinning: true,
	  size: 'default',
	  wrapperClassName: ''
	};
	Spin.propTypes = {
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  spinning: PropTypes.bool,
	  size: PropTypes.oneOf(SpinSizes),
	  wrapperClassName: PropTypes.string,
	  indicator: PropTypes.element
	};
	var _default = Spin;
	exports["default"] = _default;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  function doFold(cm, pos, options, force) {
	    if (options && options.call) {
	      var finder = options;
	      options = null;
	    } else {
	      var finder = getOption(cm, options, "rangeFinder");
	    }
	    if (typeof pos == "number") pos = CodeMirror.Pos(pos, 0);
	    var minSize = getOption(cm, options, "minFoldSize");
	
	    function getRange(allowFolded) {
	      var range = finder(cm, pos);
	      if (!range || range.to.line - range.from.line < minSize) return null;
	      if (force === "fold") return range;
	
	      var marks = cm.findMarksAt(range.from);
	      for (var i = 0; i < marks.length; ++i) {
	        if (marks[i].__isFold) {
	          if (!allowFolded) return null;
	          range.cleared = true;
	          marks[i].clear();
	        }
	      }
	      return range;
	    }
	
	    var range = getRange(true);
	    if (getOption(cm, options, "scanUp")) while (!range && pos.line > cm.firstLine()) {
	      pos = CodeMirror.Pos(pos.line - 1, 0);
	      range = getRange(false);
	    }
	    if (!range || range.cleared || force === "unfold") return;
	
	    var myWidget = makeWidget(cm, options, range);
	    CodeMirror.on(myWidget, "mousedown", function (e) {
	      myRange.clear();
	      CodeMirror.e_preventDefault(e);
	    });
	    var myRange = cm.markText(range.from, range.to, {
	      replacedWith: myWidget,
	      clearOnEnter: getOption(cm, options, "clearOnEnter"),
	      __isFold: true
	    });
	    myRange.on("clear", function (from, to) {
	      CodeMirror.signal(cm, "unfold", cm, from, to);
	    });
	    CodeMirror.signal(cm, "fold", cm, range.from, range.to);
	  }
	
	  function makeWidget(cm, options, range) {
	    var widget = getOption(cm, options, "widget");
	
	    if (typeof widget == "function") {
	      widget = widget(range.from, range.to);
	    }
	
	    if (typeof widget == "string") {
	      var text = document.createTextNode(widget);
	      widget = document.createElement("span");
	      widget.appendChild(text);
	      widget.className = "CodeMirror-foldmarker";
	    } else if (widget) {
	      widget = widget.cloneNode(true);
	    }
	    return widget;
	  }
	
	  // Clumsy backwards-compatible interface
	  CodeMirror.newFoldFunction = function (rangeFinder, widget) {
	    return function (cm, pos) {
	      doFold(cm, pos, { rangeFinder: rangeFinder, widget: widget });
	    };
	  };
	
	  // New-style interface
	  CodeMirror.defineExtension("foldCode", function (pos, options, force) {
	    doFold(this, pos, options, force);
	  });
	
	  CodeMirror.defineExtension("isFolded", function (pos) {
	    var marks = this.findMarksAt(pos);
	    for (var i = 0; i < marks.length; ++i) {
	      if (marks[i].__isFold) return true;
	    }
	  });
	
	  CodeMirror.commands.toggleFold = function (cm) {
	    cm.foldCode(cm.getCursor());
	  };
	  CodeMirror.commands.fold = function (cm) {
	    cm.foldCode(cm.getCursor(), null, "fold");
	  };
	  CodeMirror.commands.unfold = function (cm) {
	    cm.foldCode(cm.getCursor(), { scanUp: false }, "unfold");
	  };
	  CodeMirror.commands.foldAll = function (cm) {
	    cm.operation(function () {
	      for (var i = cm.firstLine(), e = cm.lastLine(); i <= e; i++) {
	        cm.foldCode(CodeMirror.Pos(i, 0), { scanUp: false }, "fold");
	      }
	    });
	  };
	  CodeMirror.commands.unfoldAll = function (cm) {
	    cm.operation(function () {
	      for (var i = cm.firstLine(), e = cm.lastLine(); i <= e; i++) {
	        cm.foldCode(CodeMirror.Pos(i, 0), { scanUp: false }, "unfold");
	      }
	    });
	  };
	
	  CodeMirror.registerHelper("fold", "combine", function () {
	    var funcs = Array.prototype.slice.call(arguments, 0);
	    return function (cm, start) {
	      for (var i = 0; i < funcs.length; ++i) {
	        var found = funcs[i](cm, start);
	        if (found) return found;
	      }
	    };
	  });
	
	  CodeMirror.registerHelper("fold", "auto", function (cm, start) {
	    var helpers = cm.getHelpers(start, "fold");
	    for (var i = 0; i < helpers.length; i++) {
	      var cur = helpers[i](cm, start);
	      if (cur) return cur;
	    }
	  });
	
	  var defaultOptions = {
	    rangeFinder: CodeMirror.fold.auto,
	    widget: "\u2194",
	    minFoldSize: 0,
	    scanUp: false,
	    clearOnEnter: true
	  };
	
	  CodeMirror.defineOption("foldOptions", null);
	
	  function getOption(cm, options, name) {
	    if (options && options[name] !== undefined) return options[name];
	    var editorOptions = cm.options.foldOptions;
	    if (editorOptions && editorOptions[name] !== undefined) return editorOptions[name];
	    return defaultOptions[name];
	  }
	
	  CodeMirror.defineExtension("foldOption", function (options, name) {
	    return getOption(this, options, name);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineExtension("annotateScrollbar", function (options) {
	    if (typeof options == "string") options = { className: options };
	    return new Annotation(this, options);
	  });
	
	  CodeMirror.defineOption("scrollButtonHeight", 0);
	
	  function Annotation(cm, options) {
	    this.cm = cm;
	    this.options = options;
	    this.buttonHeight = options.scrollButtonHeight || cm.getOption("scrollButtonHeight");
	    this.annotations = [];
	    this.doRedraw = this.doUpdate = null;
	    this.div = cm.getWrapperElement().appendChild(document.createElement("div"));
	    this.div.style.cssText = "position: absolute; right: 0; top: 0; z-index: 7; pointer-events: none";
	    this.computeScale();
	
	    function scheduleRedraw(delay) {
	      clearTimeout(self.doRedraw);
	      self.doRedraw = setTimeout(function () {
	        self.redraw();
	      }, delay);
	    }
	
	    var self = this;
	    cm.on("refresh", this.resizeHandler = function () {
	      clearTimeout(self.doUpdate);
	      self.doUpdate = setTimeout(function () {
	        if (self.computeScale()) scheduleRedraw(20);
	      }, 100);
	    });
	    cm.on("markerAdded", this.resizeHandler);
	    cm.on("markerCleared", this.resizeHandler);
	    if (options.listenForChanges !== false) cm.on("changes", this.changeHandler = function () {
	      scheduleRedraw(250);
	    });
	  }
	
	  Annotation.prototype.computeScale = function () {
	    var cm = this.cm;
	    var hScale = (cm.getWrapperElement().clientHeight - cm.display.barHeight - this.buttonHeight * 2) / cm.getScrollerElement().scrollHeight;
	    if (hScale != this.hScale) {
	      this.hScale = hScale;
	      return true;
	    }
	  };
	
	  Annotation.prototype.update = function (annotations) {
	    this.annotations = annotations;
	    this.redraw();
	  };
	
	  Annotation.prototype.redraw = function (compute) {
	    if (compute !== false) this.computeScale();
	    var cm = this.cm,
	        hScale = this.hScale;
	
	    var frag = document.createDocumentFragment(),
	        anns = this.annotations;
	
	    var wrapping = cm.getOption("lineWrapping");
	    var singleLineH = wrapping && cm.defaultTextHeight() * 1.5;
	    var curLine = null,
	        curLineObj = null;
	
	    function getY(pos, top) {
	      if (curLine != pos.line) {
	        curLine = pos.line;
	        curLineObj = cm.getLineHandle(pos.line);
	        var visual = cm.getLineHandleVisualStart(curLineObj);
	        if (visual != curLineObj) {
	          curLine = cm.getLineNumber(visual);
	          curLineObj = visual;
	        }
	      }
	      if (curLineObj.widgets && curLineObj.widgets.length || wrapping && curLineObj.height > singleLineH) return cm.charCoords(pos, "local")[top ? "top" : "bottom"];
	      var topY = cm.heightAtLine(curLineObj, "local");
	      return topY + (top ? 0 : curLineObj.height);
	    }
	
	    var lastLine = cm.lastLine();
	    if (cm.display.barWidth) for (var i = 0, nextTop; i < anns.length; i++) {
	      var ann = anns[i];
	      if (ann.to.line > lastLine) continue;
	      var top = nextTop || getY(ann.from, true) * hScale;
	      var bottom = getY(ann.to, false) * hScale;
	      while (i < anns.length - 1) {
	        if (anns[i + 1].to.line > lastLine) break;
	        nextTop = getY(anns[i + 1].from, true) * hScale;
	        if (nextTop > bottom + .9) break;
	        ann = anns[++i];
	        bottom = getY(ann.to, false) * hScale;
	      }
	      if (bottom == top) continue;
	      var height = Math.max(bottom - top, 3);
	
	      var elt = frag.appendChild(document.createElement("div"));
	      elt.style.cssText = "position: absolute; right: 0px; width: " + Math.max(cm.display.barWidth - 1, 2) + "px; top: " + (top + this.buttonHeight) + "px; height: " + height + "px";
	      elt.className = this.options.className;
	      if (ann.id) {
	        elt.setAttribute("annotation-id", ann.id);
	      }
	    }
	    this.div.textContent = "";
	    this.div.appendChild(frag);
	  };
	
	  Annotation.prototype.clear = function () {
	    this.cm.off("refresh", this.resizeHandler);
	    this.cm.off("markerAdded", this.resizeHandler);
	    this.cm.off("markerCleared", this.resizeHandler);
	    if (this.changeHandler) this.cm.off("changes", this.changeHandler);
	    this.div.parentNode.removeChild(this.div);
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31), __webpack_require__(159), __webpack_require__(248));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(159), __webpack_require__(248)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineExtension("showMatchesOnScrollbar", function (query, caseFold, options) {
	    if (typeof options == "string") options = { className: options };
	    if (!options) options = {};
	    return new SearchAnnotation(this, query, caseFold, options);
	  });
	
	  function SearchAnnotation(cm, query, caseFold, options) {
	    this.cm = cm;
	    this.options = options;
	    var annotateOptions = { listenForChanges: false };
	    for (var prop in options) {
	      annotateOptions[prop] = options[prop];
	    }if (!annotateOptions.className) annotateOptions.className = "CodeMirror-search-match";
	    this.annotation = cm.annotateScrollbar(annotateOptions);
	    this.query = query;
	    this.caseFold = caseFold;
	    this.gap = { from: cm.firstLine(), to: cm.lastLine() + 1 };
	    this.matches = [];
	    this.update = null;
	
	    this.findMatches();
	    this.annotation.update(this.matches);
	
	    var self = this;
	    cm.on("change", this.changeHandler = function (_cm, change) {
	      self.onChange(change);
	    });
	  }
	
	  var MAX_MATCHES = 1000;
	
	  SearchAnnotation.prototype.findMatches = function () {
	    if (!this.gap) return;
	    for (var i = 0; i < this.matches.length; i++) {
	      var match = this.matches[i];
	      if (match.from.line >= this.gap.to) break;
	      if (match.to.line >= this.gap.from) this.matches.splice(i--, 1);
	    }
	    var cursor = this.cm.getSearchCursor(this.query, CodeMirror.Pos(this.gap.from, 0), { caseFold: this.caseFold, multiline: this.options.multiline });
	    var maxMatches = this.options && this.options.maxMatches || MAX_MATCHES;
	    while (cursor.findNext()) {
	      var match = { from: cursor.from(), to: cursor.to() };
	      if (match.from.line >= this.gap.to) break;
	      this.matches.splice(i++, 0, match);
	      if (this.matches.length > maxMatches) break;
	    }
	    this.gap = null;
	  };
	
	  function offsetLine(line, changeStart, sizeChange) {
	    if (line <= changeStart) return line;
	    return Math.max(changeStart, line + sizeChange);
	  }
	
	  SearchAnnotation.prototype.onChange = function (change) {
	    var startLine = change.from.line;
	    var endLine = CodeMirror.changeEnd(change).line;
	    var sizeChange = endLine - change.to.line;
	    if (this.gap) {
	      this.gap.from = Math.min(offsetLine(this.gap.from, startLine, sizeChange), change.from.line);
	      this.gap.to = Math.max(offsetLine(this.gap.to, startLine, sizeChange), change.from.line);
	    } else {
	      this.gap = { from: change.from.line, to: endLine + 1 };
	    }
	
	    if (sizeChange) for (var i = 0; i < this.matches.length; i++) {
	      var match = this.matches[i];
	      var newFrom = offsetLine(match.from.line, startLine, sizeChange);
	      if (newFrom != match.from.line) match.from = CodeMirror.Pos(newFrom, match.from.ch);
	      var newTo = offsetLine(match.to.line, startLine, sizeChange);
	      if (newTo != match.to.line) match.to = CodeMirror.Pos(newTo, match.to.ch);
	    }
	    clearTimeout(this.update);
	    var self = this;
	    this.update = setTimeout(function () {
	      self.updateAfterChange();
	    }, 250);
	  };
	
	  SearchAnnotation.prototype.updateAfterChange = function () {
	    this.findMatches();
	    this.annotation.update(this.matches);
	  };
	
	  SearchAnnotation.prototype.clear = function () {
	    this.cm.off("change", this.changeHandler);
	    this.annotation.clear();
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var React = __webpack_require__(1);
	
	var TabGroup = function (_React$Component) {
		_inherits(TabGroup, _React$Component);
	
		function TabGroup(props) {
			_classCallCheck(this, TabGroup);
	
			var _this = _possibleConstructorReturn(this, (TabGroup.__proto__ || Object.getPrototypeOf(TabGroup)).call(this, props));
	
			_this.state = {
				tabIndex: 0
			};
			return _this;
		}
	
		_createClass(TabGroup, [{
			key: "setTabIndex",
			value: function setTabIndex(index) {
				this.setState({
					tabIndex: index
				});
			}
		}, {
			key: "getTabIndex",
			value: function getTabIndex() {
				return this.state.tabIndex;
			}
		}, {
			key: "handleClick",
			value: function handleClick(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var index = parseInt(target.getAttribute("data-index"));
				this.setTabIndex(index);
				if (e.stopPropagation) {
					e.stopPropagation();
				} else {
					e.cancelBubble = true;
				}
			}
		}, {
			key: "render",
			value: function render() {
				var tabIndex = this.state.tabIndex;
				var tabs = this.props.tabs || [];
				var component = tabs[tabIndex] ? tabs[tabIndex].component : "";
				var handleClick = this.handleClick.bind(this);
				return React.createElement("div", { className: "tab-group" }, React.createElement("ul", { className: "tab-nav" }, tabs.map(function (ele, pos) {
					return React.createElement("li", { key: pos, className: "tab-item" + (tabIndex == pos ? " active" : "") }, React.createElement("a", { "data-index": pos, className: "tab-text", onClick: handleClick }, ele.title));
				})), React.createElement("div", { className: "tab-content" }, component));
			}
		}]);
	
		return TabGroup;
	}(React.Component);
	
	module.exports = TabGroup;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiPanel = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiPanel = __webpack_require__(444);
	
	var _SgiPanel2 = _interopRequireDefault(_SgiPanel);
	
	var _SgiCompConstant = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Resource } from 'rt-sd-common/sgiFactory/Resource';
	
	
	// const TabPane = Tabs.TabPane;
	// const Panel = Collapse.Panel;
	
	var SgiPanel = function (_React$Component) {
	    _inherits(SgiPanel, _React$Component);
	
	    // 注意这里有分号
	
	    //这个暂时不好用 以后在处理
	    function SgiPanel(props) {
	        _classCallCheck(this, SgiPanel);
	
	        var _this = _possibleConstructorReturn(this, (SgiPanel.__proto__ || Object.getPrototypeOf(SgiPanel)).call(this, props));
	
	        _this.fitPanelItems = function (moduleDesc, panelItems, objFct, type) {
	            var _this2 = this;
	
	            this.state.extras = [];
	            var me = this;
	            //form下的子节点添加到form组件中
	            var cldSet = moduleDesc.cldSet;
	            if (cldSet && cldSet.length && cldSet.length > 0) {
	                cldSet.forEach(function (item, index) {
	                    if (item.desId === _SgiCompConstant.AllCompGUID.TOOLBAR) {
	                        if (item.inTitle) {
	                            _this2.state.btnAlg = item.btnAlg || "right"; //记录按钮位置
	                            // const itemSons = item.cldSet;
	                            // if (itemSons) {
	                            //     itemSons.forEach(son => {
	                            //         this.state.extras.push(convertModuleByGuid(this, son, null, objFct, type));
	                            //     });
	                            // }
	                            _this2.state.extras.push((0, _SgiCompComm.convertModuleByGuid)(_this2, item, null, objFct, type));
	                        } else {
	                            if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
	                                _this2.state.toolbarTopItems.push((0, _SgiCompComm.convertModuleByGuid)(_this2, item, null, objFct, type));
	                            } else {
	                                _this2.state.toolbarBottomItems.push((0, _SgiCompComm.convertModuleByGuid)(_this2, item, null, objFct, type));
	                            }
	                        }
	                    } else {
	                        panelItems.push((0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type));
	                    }
	                });
	            }
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.state.panelUUID = (0, _sgiCommon.uuid)(8);
	            _this.setState({});
	        };
	
	        _this.render = function () {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded) {
	                //组装属性
	                this.panel_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            // 通用渲染前处理，添加自定义样式等
	            this.renderBeforeReturn(this.state.panelProps);
	            // // 自定义样式处理
	            // const getCstmStyle = this.state.cstmStyle;
	            // let cstmStyle = {};
	            // if (getCstmStyle/* && type !== "dnd"*/) {
	            //     cstmStyle = getCstmStyle(this, objFct) || {};
	            // }
	            // Object.assign(this.state.panelProps.style, cstmStyle);
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ className: _SgiPanel2.default.panel }, this.state.panelProps),
	                this.state.toolbarTopItems ? this.state.toolbarTopItems : null,
	                this.state.isCard ? _react2.default.createElement(
	                    _antd.Card,
	                    _extends({ title: this.getTitle(),
	                        className: 'sgiCard'
	                        // bordered={!!this.state.panelProps.style.border}
	                        , bordered: false,
	                        size: 'small',
	                        extra: this.state.btnAlg === "left" ? null : this.state.extras
	                    }, this.state.cardProps),
	                    this.getChildContent(type, false)
	                ) : _react2.default.createElement(
	                    'div',
	                    { style: { flex: 1, height: '100%', width: '100%', display: 'inherit', 'flex-direction': 'inherit' } },
	                    _react2.default.createElement(
	                        'div',
	                        _extends({ className: _SgiPanel2.default.title }, this.state.panelTitleProps),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.state.panelTitleProps.title
	                        )
	                    ),
	                    this.getChildContent(type, this.state.spinProps.style.overflow)
	                ),
	                this.state.toolbarBottomItems ? this.state.toolbarBottomItems : null
	            );
	        };
	
	        _this.AddAttribute = function (moduleDesc, panelProps, panelTitleProps, panelBodyProps, cardProps, parentModule) {
	            var type;
	            if (parentModule && parentModule.state && parentModule.state.itemPanelType) {
	                type = parentModule.state.itemPanelType;
	            }
	
	            var text = panelProps.te; //公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
	            if (text) panelTitleProps.title = text;
	
	            var ttlAlgn = moduleDesc.ttlAlgn; //form标题对齐方式
	            if (ttlAlgn) panelTitleProps.style['text-align'] = ttlAlgn;
	
	            var isTtl = moduleDesc.isTtl; //form是否显示标题
	            if (!isTtl) {
	                panelTitleProps.style.display = "none";
	            } else {
	                panelTitleProps.style.display = undefined;
	            }
	            this.state.isTtl = !!isTtl;
	
	            // 是否card样式
	            var isCard = moduleDesc.isCard;
	            this.state.isCard = !!isCard;
	
	            if (type === 'tabs' || type == 'cos') {
	                panelTitleProps.style.display = "none";
	            }
	
	            // body样式
	            panelBodyProps.style.margin = moduleDesc.bdMgn; //body外边距
	            panelBodyProps.style.padding = moduleDesc.bdPad || "5px 10px"; //body内边距 //保持原有样式，默认5px 10px
	
	            // card样式
	            cardProps.headStyle.width = moduleDesc.cardHeadW; //card header宽度
	            cardProps.headStyle.height = moduleDesc.cardHeadH; //card header高度//保持原有样式，默认100%
	
	            var isScl = moduleDesc.isScl; //是否滚动
	            if (isScl) {
	                cardProps.bodyStyle.overflow = "auto";
	                // cardProps.headStyle.height = cardProps.headStyle.height || 0;
	            } else {
	                cardProps.bodyStyle.overflow = undefined;
	            }
	
	            var icon = moduleDesc.icon; //form背景图片??没实现        
	            var bdsty = moduleDesc.bdsty; //form背景颜色??没实现        
	            var ttlAlg = moduleDesc.ttlAlg; //form标题位置??没实现
	            var isCls = moduleDesc.isCls; //form是否可以关闭??没实现
	            var isFrm = moduleDesc.isFrm; //form是否填充??没实现-----del     
	            var html = moduleDesc.html; //form显示html元素??没实现     
	            var isDis = moduleDesc.isDis; //form是否禁用??没实现 
	            var csstyle = moduleDesc.csstyle; //form样式??没实现
	            var flx = moduleDesc.flx; //form占比??没实      
	        };
	
	        _this.state = {
	            //ctnProps: { style: {} },//form属性
	            panelProps: { style: { heigth: '100%', width: '100%' } }, //panel全局属性
	            panelTitleProps: { style: {} }, //panel的title属性
	            panelBodyProps: { style: {} }, //panel的body属性
	            cardProps: { headStyle: {}, bodyStyle: {} }, //card属性
	            spinProps: { style: {} }, //加载框属性
	            panelItems: [], //面板下控件数组loading
	            loading: false,
	            toolbarTopItems: [],
	            toolbarBottomItems: [],
	            panelUUID: undefined,
	            isCard: false,
	            title: null
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建form
	     * @param {父组件} parentModule 
	     * @param {描述} moduleDesc       
	     * @param {对象工厂} objFct 
	     * @param {make类型} type 
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiPanel, [{
	        key: 'panel_mk',
	        value: function panel_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.panelItems = []; //再次渲染的时候清空
	
	            //转换form公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.panelProps, this.state.spinProps);
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.panelProps, this.state.panelTitleProps, this.state.panelBodyProps, this.state.cardProps, parentModule);
	            //设置布局
	            //this.setFormCtlLayout(moduleDesc, formProps);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.panelProps);
	            //组装form表单下的控件信息
	            if (type !== "dnd") this.fitPanelItems(moduleDesc, this.state.panelItems, objFct, type);
	            //组装自定义form下ucv，且重新创建objFct
	            this.fitUCVNEWObjectItems(moduleDesc, this.state.panelItems, objFct, type);
	        }
	
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc 
	         * @param {*} formProps 
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, formProps) {}
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formProps 
	         */
	
	    }, {
	        key: 'fitUCVNEWObjectItems',
	        value: function fitUCVNEWObjectItems(moduleDesc, panelItems, objFct, type) {
	            var me = this;
	            var customCldSet = moduleDesc.customCldSet;
	            if (customCldSet && customCldSet.length > 0) {
	                customCldSet.forEach(function (element) {
	                    //重新创建 对象工厂
	                    var newObjFct = new _ObjFactory.ObjFactory(element.guid + "@@" + (0, _sgiCommon.uuid)(6), element.transferData);
	                    panelItems.push((0, _SgiCompComm.convertModuleByGuid)(me, element, null, newObjFct, type));
	                });
	            }
	        }
	    }, {
	        key: 'getChildContent',
	        value: function getChildContent(type, overflow) {
	            var loading = this.state.loading;
	
	            var spinProps = this.state.spinProps;
	            if ((typeof loading === 'undefined' ? 'undefined' : _typeof(loading)) === "object") {
	                Object.assign(spinProps, loading);
	            } else {
	                spinProps.spinning = loading;
	            }
	            if (type === "dnd") spinProps.spinning = false;
	            return (
	                // <Spin wrapperClassName="sgiSpin" {...spinProps}>
	                _react2.default.createElement(
	                    _antd.Spin,
	                    _extends({ wrapperClassName: 'sgiSpin ' + (overflow ? "_overflow" : null) }, spinProps),
	                    _react2.default.createElement(
	                        'div',
	                        _extends({ key: this.state.panelUUID, className: _SgiPanel2.default.body }, this.state.panelBodyProps),
	                        this.state.panelItems,
	                        this.props.children,
	                        this.state.customCldSet
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'getTitle',
	        value: function getTitle() {
	
	            // 自定义title
	            if (this.state.title || this.state.title == "") {
	                return this.state.title;
	            }
	
	            // 通常title
	            var isTtl = this.state.isTtl;
	            var titleText = this.state.panelTitleProps.title;
	            var btnAlg = this.state.btnAlg;
	            if (btnAlg === "left") {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { lineHeight: 0 } },
	                    isTtl ? _react2.default.createElement(
	                        'span',
	                        { style: { marginRight: "10px" } },
	                        titleText
	                    ) : null,
	                    this.state.extras
	                );
	            } else {
	                return isTtl ? titleText : null;
	            }
	        }
	
	        // 外部接口
	
	    }, {
	        key: 'setTitle',
	        value: function setTitle(title) {
	            this.setState({ title: title });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc 
	         * @param {属性} panelProps 
	         */
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props2 = this.props,
	                didMountCallback = _props2.didMountCallback,
	                objFct = _props2.objFct;
	            // 自定义渲染后事件
	
	            if (didMountCallback && typeof didMountCallback === "function") {
	                didMountCallback(this, objFct);
	            }
	        }
	    }]);
	
	    return SgiPanel;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiPanel.defaultProps = {};
	SgiPanel.propTypes = {};
	Object.assign(SgiPanel.prototype, _SgiCtnComm.sgiCtnBaseFun);
	exports.SgiPanel = SgiPanel;
	exports.default = SgiPanel;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _Resource = __webpack_require__(67);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiCompConstant = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { text_mk } from './formCtlMK/SgiTextMaker';
	
	
	var FormItem = _antd.Form.Item;
	
	var SgiTableEditorCell = function (_React$Component) {
	  _inherits(SgiTableEditorCell, _React$Component);
	
	  //这个暂时不好用 以后在处理
	  function SgiTableEditorCell(props) {
	    _classCallCheck(this, SgiTableEditorCell);
	
	    var _this = _possibleConstructorReturn(this, (SgiTableEditorCell.__proto__ || Object.getPrototypeOf(SgiTableEditorCell)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  } // 注意这里有分号
	
	
	  _createClass(SgiTableEditorCell, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          moduleDesc = _props.moduleDesc,
	          tableBDInst = _props.tableBDInst,
	          objFct = _props.objFct,
	          record = _props.record;
	
	      if (!moduleDesc.mdType || moduleDesc.mdType == 'text') {
	        moduleDesc.desId = _SgiCompConstant.AllCompGUID.FIELDTEXT;
	      } else if (moduleDesc.mdType == 'combox') {
	        moduleDesc.desId = _SgiCompConstant.AllCompGUID.COMBOBOX;
	      } else if (moduleDesc.mdType == 'num') {
	        moduleDesc.desId = _SgiCompConstant.AllCompGUID.NUMBER;
	      } else if (moduleDesc.mdType == 'time') {
	        moduleDesc.desId = _SgiCompConstant.AllCompGUID.TIME;
	      } else if (moduleDesc.mdType == 'date') {
	        moduleDesc.desId = _SgiCompConstant.AllCompGUID.DATE;
	      } else if (moduleDesc.mdType == 'ckbox') {
	        moduleDesc.desId = _SgiCompConstant.AllCompGUID.CHECKBOX;
	      } else if (moduleDesc.mdType == 'area') {
	        moduleDesc.desId = _SgiCompConstant.AllCompGUID.AREA;
	      } else {
	        moduleDesc.desId = _SgiCompConstant.AllCompGUID.FIELDTEXT;
	      }
	
	      moduleDesc.isLbl = true;
	      moduleDesc.c = moduleDesc.dataIndex;
	      // objFct.set(tableBDInst, record);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'editable-cell' },
	        (0, _SgiCompComm.convertModuleByGuid)(this, this.props.moduleDesc, record, objFct, 'tb')
	      );
	    }
	  }]);
	
	  return SgiTableEditorCell;
	}(_react2.default.Component);
	
	SgiTableEditorCell.defaultProps = {};
	SgiTableEditorCell.propTypes = {};
	exports.default = SgiTableEditorCell;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _SgiComponent2 = __webpack_require__(204);
	
	var _SgiComponent3 = _interopRequireDefault(_SgiComponent2);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiCtnComponent = function (_SgiComponent) {
	    _inherits(SgiCtnComponent, _SgiComponent);
	
	    function SgiCtnComponent(props) {
	        _classCallCheck(this, SgiCtnComponent);
	
	        var _this = _possibleConstructorReturn(this, (SgiCtnComponent.__proto__ || Object.getPrototypeOf(SgiCtnComponent)).call(this, props));
	
	        _this.state = _extends({}, _this.state, { //由super构造器产生
	            ctnWrapProps: {}, //ctn容器属性
	            ctnHeadProps: {}, //ctnhead属性
	            ctnBodyProps: {} //ctnbody属性
	        });
	        return _this;
	    }
	
	    _createClass(SgiCtnComponent, [{
	        key: "_maker",
	        value: function _maker(parentModule, moduleDesc, objFct, type) {
	            _get(SgiCtnComponent.prototype.__proto__ || Object.getPrototypeOf(SgiCtnComponent.prototype), "_maker", this).call(this, parentModule, moduleDesc, objFct, type);
	
	            // 获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            // 转换容器公共属性
	            addCtnCommonAttribute(this, moduleDesc, this.state.ctnWrapProps, this.state.ctnHeadProps, this.state.ctnBodyProps);
	        }
	    }, {
	        key: "setHidden",
	        value: function setHidden(value) {
	            var props = this.state.formProps || this.state.panelProps || this.state.tabsProps || this.state.collapseProps || this.state.CardProps;
	            if (value) {
	                props.style.display = "none";
	            } else {
	                props.style.display = undefined;
	            }
	            if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	                // react16需要更新引用
	                props.style = _extends({}, props.style);
	            }
	            this.setState({ loading: false });
	        }
	    }, {
	        key: "add",
	        value: function add(module) {
	            if (!module) {
	                return;
	            }
	            var sonItems = this.state.formItems || this.state.panelItems;
	            if (!sonItems) {
	                return;
	            }
	            sonItems.push(module);
	            if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	                // react16需要更新引用
	                sonItems = [].concat(_toConsumableArray(sonItems));
	            }
	            this.setState({ loading: false });
	        }
	    }, {
	        key: "removeAll",
	        value: function removeAll() {
	            this.props.moduleDesc.cldSet = [];
	            this.refresh();
	        }
	
	        /**
	         * id 可能为guid 可能为cid
	         */
	
	    }, {
	        key: "remove",
	        value: function remove(id) {
	            if (!id) {
	                return;
	            }
	            var sonItems = this.props.moduleDesc.cldSet;
	            if (!sonItems) {
	                return;
	            }
	            var tmpItem = void 0;
	            var tmpId = void 0;
	            for (var i = 0; i < sonItems.length; i++) {
	                tmpItem = sonItems[i];
	                if (!tmpItem) {
	                    continue;
	                }
	                tmpId = tmpItem.guid || (0, _SgiCommon.getConstByKey)(this, tmpItem.cId);
	                if (id == tmpId) {
	                    sonItems.splice(i, 1);
	                    break;
	                }
	            }
	            this.refresh();
	        }
	    }, {
	        key: "setLoading",
	        value: function setLoading(loading) {
	            this.setState({ loading: loading });
	        }
	
	        // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
	
	    }, {
	        key: "renderBeforeReturn",
	        value: function renderBeforeReturn(ctnProps) {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	            // 自定义样式处理
	            // const getCstmStyle = this.state.cstmStyle;
	
	            var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(this, "cstmStyle");
	            var cstmStyle = {};
	            if (getCstmStyle) {
	                try {
	                    cstmStyle = getCstmStyle(this, objFct) || {};
	                } catch (error) {
	                    tool.sgiLogger.log(error);
	                }
	            }
	            Object.assign(ctnProps.style, cstmStyle);
	        }
	    }]);
	
	    return SgiCtnComponent;
	}(_SgiComponent3.default);
	
	exports.default = SgiCtnComponent;

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	/**
	 * 表单控件的校验的公共方法
	 * wangz 
	 * 2018.3.9
	 */
	
	"use strict";
	
	// 校验规则
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function FormVerify() {
	    // 1 代表 2009-09-30 , 2 代表 2009/09/30 , 3 代表 20090930 , 4 代表 2009年09月30日
	    this.regDate3 = /^[1-2]\d{6,7}$/;
	    this.regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
	    this.regPhone = /^((\(\d{1,5}\))|(\d{1,5}\-))?(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?$/;
	    this.regPhones = /^(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?([,|;](\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?)*$/;
	    this.regMobile = /^((\(\d{3}\))|(\d{3}\-))?1[1-9]\d{9}$/;
	    this.regUrl = /^http:\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/; //';
	    this.className = /^([_a-z0-9]+\.)*[A-Z][_A-Za-z0-9]+$/;
	    this.regIdCard15 = /^\d{15}(\d{2}[A-Za-z0-9])?$/;
	    this.regIdCard18 = /^\d{17}(?:\d|x|X)$/;
	    this.regMoney = /^[-\+]?\d+(\.\d{0,2})?$/;
	    this.regNumber = /^\d+$/;
	    this.regZip = /^[0-9]\d{5}$/;
	    this.regQQ = /^[1-9]\d{3,9}$/;
	    this.regInteger = /^[-\+]?\d+$/;
	    this.regDouble = /^[-\+]?\d+(\.\d+)?$/;
	    this.regEnglish = /^[A-Za-z]+$/;
	    this.regEnglish2 = /^[A-Za-z\s]+$/;
	    this.regChinese = /^[\u0391-\uFFE5]+$/;
	    this.regUnSafe = /^(([A-Z]*|[a-z]*|\d*|[-_\~!@#\$%\^&\*\.\(\)\[\]\{\}<>\?\\\/\'\"]*)|.{0,5})$|\s/; //';
	    this.regNotChar = /^[^`~!@#$%^&*()+=|\\\][\]\{\}:;'\,.<>/?]{1}[^`~!@$%^&()+=|\\\][\]\{\}:;'\,.<>?]{0,19}$/;
	    this.regChar = /[(\/)(\\)(')(")(<)(>)]/g; //';
	};
	
	var FormVerifyObj = new FormVerify();
	
	// required，max,min,dataType,pattern,patternPrompt,validator
	function sgiFormCtlCheck(rule, value, parameters) {
	    var isEmpty = value === '' || value === null || typeof value === "undefined";
	    //校验是否为空
	    if (rule.required === true) {
	        if (isEmpty) {
	            return '请输入,不允许为空';
	        }
	    }
	
	    if (isEmpty) {
	        return '';
	    }
	
	    //校验最长最小输入
	    if (rule.maxL > 0) {
	        // if (typeof rule.maxL === "number") {
	        if (value.length > rule.maxL) {
	            return '最多输入【' + rule.maxL + '】个字符';
	        }
	    }
	    if (rule.minL > 0) {
	        // if (typeof rule.minL === "number") {
	        if (value.length < rule.minL) {
	            return '至少输入【' + rule.minL + '】个字符';
	        }
	    }
	    //校验最大最小值
	    // if (rule.maxV > 0) {
	    if (typeof rule.maxV === "number") {
	        if (parseFloat(value) > rule.maxV) {
	            return '最大值【' + rule.maxV + '】';
	        }
	    }
	    // if (rule.minV > 0) {
	    if (typeof rule.minV === "number") {
	        if (parseFloat(value) < rule.minV) {
	            return '最小值【' + rule.minV + '】';
	        }
	    }
	
	    //常用类型校验
	    if (rule.dataType !== '' && rule.dataType !== null && typeof rule.dataType !== "undefined") {
	        var msg = _checkDataType(value, rule.dataType);
	        if (msg !== '' && msg !== null && typeof msg !== "undefined") {
	            return msg;
	        }
	    }
	
	    //自定义校验方法
	    if (rule.validator !== '' && rule.validator !== null && typeof rule.validator !== "undefined") {
	        var msg = rule.validator(value, rule, page);
	        if (msg !== '' && msg !== null && typeof msg !== "undefined") {
	            return msg;
	        }
	    }
	
	    // 自定义校验
	    if (rule.cstmValid && typeof rule.cstmValid === "function") {
	        try {
	            tool.sgiLogger.log("自定义校验");
	            var module = parameters.module,
	                objFct = parameters.objFct;
	
	            return rule.cstmValid(module, objFct, value);
	        } catch (error) {
	            tool.sgiLogger.error("custom verification error :", error);
	        }
	    }
	
	    return '';
	}
	
	// 检查域的有效性
	function _checkDataType(str, dataType) {
	    for (var x = _isValidMethod.length - 1; x >= 0; x--) {
	        var c = _isValidMethod[x];
	        if (c.type == dataType) {
	            return c.isValid(str);
	        }
	    }
	
	    return '未知的数据类型[' + dataType + ']';
	};
	
	// 有效性函数
	// isValid=检查数据有效性
	// checkValid=检查数据是否越界
	var _isValidMethod = [{
	    type: 'int',
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regInteger.test(str) == false) return "请输入整数!";
	    }
	}, {
	    type: 'double',
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regDouble.test(str) == false) return "请输入Double数据，比如：55.069!";
	    }
	}, {
	    type: 'money',
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regMoney.test(str) == false) return "请输入金额，比如：2355.00!";
	    }
	}, {
	    type: "email",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regEmail.test(str) == false) return "请输入电子邮件地址!";
	    }
	}, {
	    type: "idcard",
	    isValid: isIdCard
	}, {
	    type: "idcard18",
	    isValid: isIdCard
	}, {
	    type: "phone",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regPhone.test(str) == false) return "请输入电话号码!";
	    }
	}, {
	    type: "phones",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regPhones.test(str) == false) return "请输入电话号码，[,]分割!";
	    }
	}, {
	    type: "mobile",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regMobile.test(str) == false) return "请输入手机号码!";
	    }
	}, {
	    type: "zip",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regZip.test(str) == false) return "请输入六位数字的邮政编码!";
	    }
	}, {
	    type: "url",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regUrl.test(str.toLowerCase()) == false) return "请输入HTTP地址!";
	    }
	}, {
	    type: "classname",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.className.test(str) == false) return "请输入有效的类名称!";
	    }
	}, {
	    type: "qq",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regQQ.test(str) == false) return "请输入QQ号!";
	    }
	}, {
	    type: "number",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regNumber.test(str) == false) return "请输入数字!";
	    }
	}, {
	    type: "汉字",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regChinese.test(str) == false) return "请输入汉字!";
	    }
	}, {
	    type: "字母",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regEnglish2.test(str) == false) return "请输入字母或空格!";
	    }
	}];
	
	// 检测身份证号码输入的合法性	15位或者18位的数字
	function isIdCard(str) {
	    if (str.length != 18 && str.length != 15) return "请输入有效的身份证号码!";
	    var reg = str.length == 18 ? FormVerifyObj.regIdCard18 : FormVerifyObj.regIdCard15;
	    if (reg.test(str) == false) {
	        return "请输入有效的身份证号码!";
	    }
	
	    // 日期
	    var y = '';
	    var m = '';
	    var d = '';
	    if (str.length == 18) {
	        y = str.substr(6, 4);
	        m = str.substr(10, 2);
	        d = str.substr(12, 2);
	    } else if (str.length == 15) {
	        y = "19" + str.substr(6, 2);
	        m = str.substr(8, 2);
	        d = str.substr(10, 2);
	    }
	
	    if (checkYearMonthDay(y, m, d) == false) {
	        return "日期的取值范围不正确!";
	    }
	
	    // 强制检查身份证的校验位
	    var checkValue = strictCheckIdcard(str);
	    if (checkValue != null) {
	        return "请输入有效的身份证号码!";
	    }
	};
	
	// 检查日期中年月日的合法性
	function checkYearMonthDay(years, months, days) {
	    var reg = /^\d+$/;
	
	    //处理年
	    if (years.length != 4 || years == 0) return false;
	    if (!reg.test(years)) return false;
	
	    var leapyear = parseInt(years) % 4 == 0 && parseInt(years) % 100 != 0 || parseInt(years) % 400 == 0;
	
	    //处理月
	    if (!months || months == 0) return false;
	    if (!reg.test(months)) return false;
	    var mon = parseInt(months, 10);
	    if (mon > 12) return false;
	
	    //处理日
	    if (!days || days == 0) return false;
	    if (!reg.test(days)) return false;
	
	    var mdays = [29, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	    if (mon == 2 && leapyear) mon = 0;
	    if (days > mdays[mon]) return false;
	
	    return true;
	};
	
	// 严格检查身份证的有效性
	function strictCheckIdcard(id) {
	    // 只检查18位身份证
	    if (id.length != 18) {
	        return null;
	    }
	
	    var checkValue = getIdCheckNumber(id);
	    var iv = id.substring(17).toUpperCase();
	    if (checkValue != iv) {
	        return checkValue;
	    }
	
	    return null;
	};
	
	function getIdCheckNumber(id) {
	    var arrVerifyCode = "1,0,X,9,8,7,6,5,4,3,2".split(",");
	    var wi = "7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2".split(",");
	
	    var checkNumber = 0;
	    for (var i = 0; i < 17; i++) {
	        checkNumber = checkNumber + parseInt(id.substring(i, i + 1)) * wi[i];
	    }
	
	    var modValue = checkNumber % 11;
	    var checkValue = arrVerifyCode[modValue];
	
	    return checkValue;
	};
	
	exports.sgiFormCtlCheck = sgiFormCtlCheck;
	exports.default = { sgiFormCtlCheck: sgiFormCtlCheck };

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withConfigConsumer = withConfigConsumer;
	exports.ConfigConsumer = exports.ConfigContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _renderEmpty = _interopRequireDefault(__webpack_require__(1382));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var ConfigContext = (0, _createReactContext["default"])({
	  // We provide a default function for Context without provider
	  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
	    if (customizePrefixCls) return customizePrefixCls;
	    return "ant-".concat(suffixCls);
	  },
	  renderEmpty: _renderEmpty["default"]
	});
	exports.ConfigContext = ConfigContext;
	var ConfigConsumer = ConfigContext.Consumer;
	exports.ConfigConsumer = ConfigConsumer;
	
	function withConfigConsumer(config) {
	  return function withConfigConsumerFunc(Component) {
	    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
	    var SFC = function SFC(props) {
	      return (/*#__PURE__*/React.createElement(ConfigConsumer, null, function (configProps) {
	          var basicPrefixCls = config.prefixCls;
	          var getPrefixCls = configProps.getPrefixCls;
	          var customizePrefixCls = props.prefixCls;
	          var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
	          return (/*#__PURE__*/React.createElement(Component, _extends({}, configProps, props, {
	              prefixCls: prefixCls
	            }))
	          );
	        })
	      );
	    };
	
	    var cons = Component.constructor;
	    var name = cons && cons.displayName || Component.name || 'Component';
	    SFC.displayName = "withConfigConsumer(".concat(name, ")");
	    return SFC;
	  };
	}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _row["default"];
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _col["default"];
	  }
	});
	
	var _row = _interopRequireDefault(__webpack_require__(750));
	
	var _col = _interopRequireDefault(__webpack_require__(749));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Input = _interopRequireDefault(__webpack_require__(207));
	
	var _Group = _interopRequireDefault(__webpack_require__(1402));
	
	var _Search = _interopRequireDefault(__webpack_require__(1405));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(752));
	
	var _Password = _interopRequireDefault(__webpack_require__(1403));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Input["default"].Group = _Group["default"];
	_Input["default"].Search = _Search["default"];
	_Input["default"].TextArea = _TextArea["default"];
	_Input["default"].Password = _Password["default"];
	var _default = _Input["default"];
	exports["default"] = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Group", {
	  enumerable: true,
	  get: function get() {
	    return _group["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _radioButton["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _radio = _interopRequireDefault(__webpack_require__(386));
	
	var _group = _interopRequireDefault(__webpack_require__(1428));
	
	var _radioButton = _interopRequireDefault(__webpack_require__(1429));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_radio["default"].Button = _radioButton["default"];
	_radio["default"].Group = _group["default"];
	var _default = _radio["default"];
	exports["default"] = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _configProvider = __webpack_require__(15);
	
	var _type = __webpack_require__(83);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SpinSizes = (0, _type.tuple)('small', 'default', 'large'); // Render indicator
	
	var defaultIndicator = null;
	
	function renderIndicator(prefixCls, props) {
	  var indicator = props.indicator;
	  var dotClassName = "".concat(prefixCls, "-dot"); // should not be render default indicator when indicator value is null
	
	  if (indicator === null) {
	    return null;
	  }
	
	  if ( /*#__PURE__*/React.isValidElement(indicator)) {
	    return (/*#__PURE__*/React.cloneElement(indicator, {
	        className: (0, _classnames["default"])(indicator.props.className, dotClassName)
	      })
	    );
	  }
	
	  if ( /*#__PURE__*/React.isValidElement(defaultIndicator)) {
	    return (/*#__PURE__*/React.cloneElement(defaultIndicator, {
	        className: (0, _classnames["default"])(defaultIndicator.props.className, dotClassName)
	      })
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement("span", {
	      className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
	    }, /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }), /*#__PURE__*/React.createElement("i", {
	      className: "".concat(prefixCls, "-dot-item")
	    }))
	  );
	}
	
	function shouldDelay(spinning, delay) {
	  return !!spinning && !!delay && !isNaN(Number(delay));
	}
	
	var Spin = /*#__PURE__*/function (_React$Component) {
	  _inherits(Spin, _React$Component);
	
	  var _super = _createSuper(Spin);
	
	  function Spin(props) {
	    var _this;
	
	    _classCallCheck(this, Spin);
	
	    _this = _super.call(this, props);
	
	    _this.debouncifyUpdateSpinning = function (props) {
	      var _ref = props || _this.props,
	          delay = _ref.delay;
	
	      if (delay) {
	        _this.cancelExistingSpin();
	
	        _this.updateSpinning = (0, _debounce["default"])(_this.originalUpdateSpinning, delay);
	      }
	    };
	
	    _this.updateSpinning = function () {
	      var spinning = _this.props.spinning;
	      var currentSpinning = _this.state.spinning;
	
	      if (currentSpinning !== spinning) {
	        _this.setState({
	          spinning: spinning
	        });
	      }
	    };
	
	    _this.renderSpin = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          size = _a.size,
	          tip = _a.tip,
	          wrapperClassName = _a.wrapperClassName,
	          style = _a.style,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);
	
	      var spinning = _this.state.spinning;
	      var prefixCls = getPrefixCls('spin', customizePrefixCls);
	      var spinClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _classNames), className); // fix https://fb.me/react-unknown-prop
	
	      var divProps = (0, _omit["default"])(restProps, ['spinning', 'delay', 'indicator']);
	      var spinElement = /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        style: style,
	        className: spinClassName
	      }), renderIndicator(prefixCls, _this.props), tip ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-text")
	      }, tip) : null);
	
	      if (_this.isNestedPattern()) {
	        var containerClassName = (0, _classnames["default"])("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
	        return (/*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	            className: (0, _classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
	          }), spinning && /*#__PURE__*/React.createElement("div", {
	            key: "loading"
	          }, spinElement), /*#__PURE__*/React.createElement("div", {
	            className: containerClassName,
	            key: "container"
	          }, _this.props.children))
	        );
	      }
	
	      return spinElement;
	    };
	
	    var spinning = props.spinning,
	        delay = props.delay;
	    var shouldBeDelayed = shouldDelay(spinning, delay);
	    _this.state = {
	      spinning: spinning && !shouldBeDelayed
	    };
	    _this.originalUpdateSpinning = _this.updateSpinning;
	
	    _this.debouncifyUpdateSpinning(props);
	
	    return _this;
	  }
	
	  _createClass(Spin, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateSpinning();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.debouncifyUpdateSpinning();
	      this.updateSpinning();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.cancelExistingSpin();
	    }
	  }, {
	    key: "cancelExistingSpin",
	    value: function cancelExistingSpin() {
	      var updateSpinning = this.updateSpinning;
	
	      if (updateSpinning && updateSpinning.cancel) {
	        updateSpinning.cancel();
	      }
	    }
	  }, {
	    key: "isNestedPattern",
	    value: function isNestedPattern() {
	      return !!(this.props && this.props.children);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSpin)
	      );
	    }
	  }], [{
	    key: "setDefaultIndicator",
	    value: function setDefaultIndicator(indicator) {
	      defaultIndicator = indicator;
	    }
	  }]);
	
	  return Spin;
	}(React.Component);
	
	Spin.defaultProps = {
	  spinning: true,
	  size: 'default',
	  wrapperClassName: ''
	};
	Spin.propTypes = {
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  spinning: PropTypes.bool,
	  size: PropTypes.oneOf(SpinSizes),
	  wrapperClassName: PropTypes.string,
	  indicator: PropTypes.element
	};
	var _default = Spin;
	exports["default"] = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var EventPluginRegistry = __webpack_require__(395);
	var ReactEventEmitterMixin = __webpack_require__(1522);
	var ViewportMetrics = __webpack_require__(779);
	
	var getVendorPrefixedEventName = __webpack_require__(1554);
	var isEventSupported = __webpack_require__(406);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function injectReactEventListener(ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function setEnabled(enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function isEnabled() {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function listenTo(registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function trapBubbledEvent(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function trapCapturedEvent(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function supportsEventPageXY() {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function ensureScrollValueMonitoring() {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(212);
	var ViewportMetrics = __webpack_require__(779);
	
	var getEventModifierState = __webpack_require__(404);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function button(event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function relatedTarget(event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function pageX(event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function pageY(event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function reinitializeTransaction() {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function isInTransaction() {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function perform(method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function initializeAll(startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function closeAll(startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(90);
	var DOMNamespaces = __webpack_require__(394);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(402);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function setInnerHTML(node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(17);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	var _labelHelper = __webpack_require__(414);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Symbol
	 */
	
	/**
	 * @constructor
	 * @alias {module:echarts/chart/helper/Symbol}
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	function SymbolClz(data, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.updateData(data, idx, seriesScope);
	}
	
	var symbolProto = SymbolClz.prototype;
	/**
	 * @public
	 * @static
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {Array.<number>} [width, height]
	 */
	
	var getSymbolSize = SymbolClz.getSymbolSize = function (data, idx) {
	  var symbolSize = data.getItemVisual(idx, 'symbolSize');
	  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	};
	
	function getScale(symbolSize) {
	  return [symbolSize[0] / 2, symbolSize[1] / 2];
	}
	
	function driftSymbol(dx, dy) {
	  this.parent.drift(dx, dy);
	}
	
	symbolProto._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
	  // Remove paths created before
	  this.removeAll();
	  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
	  //     symbolType, -0.5, -0.5, 1, 1, color
	  // );
	  // If width/height are set too small (e.g., set to 1) on ios10
	  // and macOS Sierra, a circle stroke become a rect, no matter what
	  // the scale is set. So we set width/height as 2. See #4150.
	
	  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color, keepAspect);
	  symbolPath.attr({
	    z2: 100,
	    culling: true,
	    scale: getScale(symbolSize)
	  }); // Rewrite drift method
	
	  symbolPath.drift = driftSymbol;
	  this._symbolType = symbolType;
	  this.add(symbolPath);
	};
	/**
	 * Stop animation
	 * @param {boolean} toLastFrame
	 */
	
	
	symbolProto.stopSymbolAnimation = function (toLastFrame) {
	  this.childAt(0).stopAnimation(toLastFrame);
	};
	/**
	 * FIXME:
	 * Caution: This method breaks the encapsulation of this module,
	 * but it indeed brings convenience. So do not use the method
	 * unless you detailedly know all the implements of `Symbol`,
	 * especially animation.
	 *
	 * Get symbol path element.
	 */
	
	
	symbolProto.getSymbolPath = function () {
	  return this.childAt(0);
	};
	/**
	 * Get scale(aka, current symbol size).
	 * Including the change caused by animation
	 */
	
	
	symbolProto.getScale = function () {
	  return this.childAt(0).scale;
	};
	/**
	 * Highlight symbol
	 */
	
	
	symbolProto.highlight = function () {
	  this.childAt(0).trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	symbolProto.downplay = function () {
	  this.childAt(0).trigger('normal');
	};
	/**
	 * @param {number} zlevel
	 * @param {number} z
	 */
	
	
	symbolProto.setZ = function (zlevel, z) {
	  var symbolPath = this.childAt(0);
	  symbolPath.zlevel = zlevel;
	  symbolPath.z = z;
	};
	
	symbolProto.setDraggable = function (draggable) {
	  var symbolPath = this.childAt(0);
	  symbolPath.draggable = draggable;
	  symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
	};
	/**
	 * Update symbol properties
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Object} [seriesScope]
	 * @param {Object} [seriesScope.itemStyle]
	 * @param {Object} [seriesScope.hoverItemStyle]
	 * @param {Object} [seriesScope.symbolRotate]
	 * @param {Object} [seriesScope.symbolOffset]
	 * @param {module:echarts/model/Model} [seriesScope.labelModel]
	 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
	 * @param {boolean} [seriesScope.hoverAnimation]
	 * @param {Object} [seriesScope.cursorStyle]
	 * @param {module:echarts/model/Model} [seriesScope.itemModel]
	 * @param {string} [seriesScope.symbolInnerColor]
	 * @param {Object} [seriesScope.fadeIn=false]
	 */
	
	
	symbolProto.updateData = function (data, idx, seriesScope) {
	  this.silent = false;
	  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	  var seriesModel = data.hostModel;
	  var symbolSize = getSymbolSize(data, idx);
	  var isInit = symbolType !== this._symbolType;
	
	  if (isInit) {
	    var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
	
	    this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
	  } else {
	    var symbolPath = this.childAt(0);
	    symbolPath.silent = false;
	    graphic.updateProps(symbolPath, {
	      scale: getScale(symbolSize)
	    }, seriesModel, idx);
	  }
	
	  this._updateCommon(data, idx, symbolSize, seriesScope);
	
	  if (isInit) {
	    var symbolPath = this.childAt(0);
	    var fadeIn = seriesScope && seriesScope.fadeIn;
	    var target = {
	      scale: symbolPath.scale.slice()
	    };
	    fadeIn && (target.style = {
	      opacity: symbolPath.style.opacity
	    });
	    symbolPath.scale = [0, 0];
	    fadeIn && (symbolPath.style.opacity = 0);
	    graphic.initProps(symbolPath, target, seriesModel, idx);
	  }
	
	  this._seriesModel = seriesModel;
	}; // Update common properties
	
	
	var normalStyleAccessPath = ['itemStyle'];
	var emphasisStyleAccessPath = ['emphasis', 'itemStyle'];
	var normalLabelAccessPath = ['label'];
	var emphasisLabelAccessPath = ['emphasis', 'label'];
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Array.<number>} symbolSize
	 * @param {Object} [seriesScope]
	 */
	
	symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
	  var symbolPath = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var color = data.getItemVisual(idx, 'color'); // Reset style
	
	  if (symbolPath.type !== 'image') {
	    symbolPath.useStyle({
	      strokeNoScale: true
	    });
	  } else {
	    symbolPath.setStyle({
	      opacity: 1,
	      shadowBlur: null,
	      shadowOffsetX: null,
	      shadowOffsetY: null,
	      shadowColor: null
	    });
	  }
	
	  var itemStyle = seriesScope && seriesScope.itemStyle;
	  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
	  var symbolOffset = seriesScope && seriesScope.symbolOffset;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
	  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
	  var cursorStyle = seriesScope && seriesScope.cursorStyle;
	
	  if (!seriesScope || data.hasItemOption) {
	    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
	    // Because symbol provide setColor individually to set fill and stroke
	
	    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
	    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
	    symbolOffset = itemModel.getShallow('symbolOffset');
	    labelModel = itemModel.getModel(normalLabelAccessPath);
	    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
	    hoverAnimation = itemModel.getShallow('hoverAnimation');
	    cursorStyle = itemModel.getShallow('cursor');
	  } else {
	    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
	  }
	
	  var elStyle = symbolPath.style;
	  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
	
	  if (symbolOffset) {
	    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
	  }
	
	  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!
	
	  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
	  symbolPath.setStyle(itemStyle);
	  var opacity = data.getItemVisual(idx, 'opacity');
	
	  if (opacity != null) {
	    elStyle.opacity = opacity;
	  }
	
	  var liftZ = data.getItemVisual(idx, 'liftZ');
	  var z2Origin = symbolPath.__z2Origin;
	
	  if (liftZ != null) {
	    if (z2Origin == null) {
	      symbolPath.__z2Origin = symbolPath.z2;
	      symbolPath.z2 += liftZ;
	    }
	  } else if (z2Origin != null) {
	    symbolPath.z2 = z2Origin;
	    symbolPath.__z2Origin = null;
	  }
	
	  var useNameLabel = seriesScope && seriesScope.useNameLabel;
	  graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: idx,
	    defaultText: getLabelDefaultText,
	    isRectText: true,
	    autoColor: color
	  }); // Do not execute util needed.
	
	  function getLabelDefaultText(idx, opt) {
	    return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
	  }
	
	  symbolPath.__symbolOriginalScale = getScale(symbolSize);
	  symbolPath.hoverStyle = hoverItemStyle;
	  symbolPath.highDownOnUpdate = hoverAnimation && seriesModel.isAnimationEnabled() ? highDownOnUpdate : null;
	  graphic.setHoverStyle(symbolPath);
	};
	
	function highDownOnUpdate(fromState, toState) {
	  // Do not support this hover animation util some scenario required.
	  // Animation can only be supported in hover layer when using `el.incremetal`.
	  if (this.incremental || this.useHoverLayer) {
	    return;
	  }
	
	  if (toState === 'emphasis') {
	    var scale = this.__symbolOriginalScale;
	    var ratio = scale[1] / scale[0];
	    var emphasisOpt = {
	      scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
	    }; // FIXME
	    // modify it after support stop specified animation.
	    // toState === fromState
	    //     ? (this.stopAnimation(), this.attr(emphasisOpt))
	
	    this.animateTo(emphasisOpt, 400, 'elasticOut');
	  } else if (toState === 'normal') {
	    this.animateTo({
	      scale: this.__symbolOriginalScale
	    }, 400, 'elasticOut');
	  }
	}
	/**
	 * @param {Function} cb
	 * @param {Object} [opt]
	 * @param {Object} [opt.keepLabel=true]
	 */
	
	
	symbolProto.fadeOut = function (cb, opt) {
	  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out
	
	  this.silent = symbolPath.silent = true; // Not show text when animating
	
	  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
	  graphic.updateProps(symbolPath, {
	    style: {
	      opacity: 0
	    },
	    scale: [0, 0]
	  }, this._seriesModel, this.dataIndex, cb);
	};
	
	zrUtil.inherits(SymbolClz, graphic.Group);
	var _default = SymbolClz;
	module.exports = _default;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var KEY_DELIMITER = '-->';
	/**
	 * params handler
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @returns {*}
	 */
	
	var getAutoCurvenessParams = function (seriesModel) {
	  return seriesModel.get('autoCurveness') || null;
	};
	/**
	 * Generate a list of edge curvatures, 20 is the default
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param {number} appendLength
	 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
	 */
	
	
	var createCurveness = function (seriesModel, appendLength) {
	  var autoCurvenessParmas = getAutoCurvenessParams(seriesModel);
	  var length = 20;
	  var curvenessList = []; // handler the function set
	
	  if (typeof autoCurvenessParmas === 'number') {
	    length = autoCurvenessParmas;
	  } else if (zrUtil.isArray(autoCurvenessParmas)) {
	    seriesModel.__curvenessList = autoCurvenessParmas;
	    return;
	  } // append length
	
	
	  if (appendLength > length) {
	    length = appendLength;
	  } // make sure the length is even
	
	
	  var len = length % 2 ? length + 2 : length + 3;
	  curvenessList = [];
	
	  for (var i = 0; i < len; i++) {
	    curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
	  }
	
	  seriesModel.__curvenessList = curvenessList;
	};
	/**
	 * Create different cache key data in the positive and negative directions, in order to set the curvature later
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @returns {string} key
	 */
	
	
	var getKeyOfEdges = function (n1, n2, seriesModel) {
	  var source = [n1.id, n1.dataIndex].join('.');
	  var target = [n2.id, n2.dataIndex].join('.');
	  return [seriesModel.uid, source, target].join(KEY_DELIMITER);
	};
	/**
	 * get opposite key
	 * @param {string} key
	 * @returns {string}
	 */
	
	
	var getOppositeKey = function (key) {
	  var keys = key.split(KEY_DELIMITER);
	  return [keys[0], keys[2], keys[1]].join(KEY_DELIMITER);
	};
	/**
	 * get edgeMap with key
	 * @param edge
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 */
	
	
	var getEdgeFromMap = function (edge, seriesModel) {
	  var key = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	  return seriesModel.__edgeMap[key];
	};
	/**
	 * calculate all cases total length
	 * @param edge
	 * @param seriesModel
	 * @returns {number}
	 */
	
	
	var getTotalLengthBetweenNodes = function (edge, seriesModel) {
	  var len = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
	  var lenV = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
	  return len + lenV;
	};
	/**
	 *
	 * @param key
	 */
	
	
	var getEdgeMapLengthWithKey = function (key, seriesModel) {
	  var edgeMap = seriesModel.__edgeMap;
	  return edgeMap[key] ? edgeMap[key].length : 0;
	};
	/**
	 * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
	 * @see /graph/GraphSeries.js@getInitialData
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 */
	
	
	function initCurvenessList(seriesModel) {
	  if (!getAutoCurvenessParams(seriesModel)) {
	    return;
	  }
	
	  seriesModel.__curvenessList = [];
	  seriesModel.__edgeMap = {}; // calc the array of curveness List
	
	  createCurveness(seriesModel);
	}
	/**
	 * set edgeMap with key
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param {number} index
	 */
	
	
	function createEdgeMapForCurveness(n1, n2, seriesModel, index) {
	  if (!getAutoCurvenessParams(seriesModel)) {
	    return;
	  }
	
	  var key = getKeyOfEdges(n1, n2, seriesModel);
	  var edgeMap = seriesModel.__edgeMap;
	  var oppositeEdges = edgeMap[getOppositeKey(key)]; // set direction
	
	  if (edgeMap[key] && !oppositeEdges) {
	    edgeMap[key].isForward = true;
	  } else if (oppositeEdges && edgeMap[key]) {
	    oppositeEdges.isForward = true;
	    edgeMap[key].isForward = false;
	  }
	
	  edgeMap[key] = edgeMap[key] || [];
	  edgeMap[key].push(index);
	}
	/**
	 * get curvature for edge
	 * @param edge
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param index
	 */
	
	
	function getCurvenessForEdge(edge, seriesModel, index, needReverse) {
	  var autoCurvenessParams = getAutoCurvenessParams(seriesModel);
	  var isArrayParam = zrUtil.isArray(autoCurvenessParams);
	
	  if (!autoCurvenessParams) {
	    return null;
	  }
	
	  var edgeArray = getEdgeFromMap(edge, seriesModel);
	
	  if (!edgeArray) {
	    return null;
	  }
	
	  var edgeIndex = -1;
	
	  for (var i = 0; i < edgeArray.length; i++) {
	    if (edgeArray[i] === index) {
	      edgeIndex = i;
	      break;
	    }
	  } // if totalLen is Longer createCurveness
	
	
	  var totalLen = getTotalLengthBetweenNodes(edge, seriesModel);
	  createCurveness(seriesModel, totalLen);
	  edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number
	
	  var curKey = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	  var curvenessList = seriesModel.__curvenessList; // if pass array no need parity
	
	  var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
	
	  if (!edgeArray.isForward) {
	    // the opposite edge show outside
	    var oppositeKey = getOppositeKey(curKey);
	    var len = getEdgeMapLengthWithKey(oppositeKey, seriesModel);
	    var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
	
	    if (needReverse) {
	      // set as array may make the parity handle with the len of opposite
	      if (isArrayParam) {
	        if (autoCurvenessParams && autoCurvenessParams[0] === 0) {
	          return (len + parityCorrection) % 2 ? resValue : -resValue;
	        } else {
	          return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
	        }
	      } else {
	        return (len + parityCorrection) % 2 ? resValue : -resValue;
	      }
	    } else {
	      return curvenessList[edgeIndex + len + parityCorrection];
	    }
	  } else {
	    return curvenessList[parityCorrection + edgeIndex];
	  }
	}
	
	exports.initCurvenessList = initCurvenessList;
	exports.createEdgeMapForCurveness = createEdgeMapForCurveness;
	exports.getCurvenessForEdge = getCurvenessForEdge;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Model = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	// allAxesInfo should be updated when setOption performed.
	
	function collect(ecModel, api) {
	  var result = {
	    /**
	     * key: makeKey(axis.model)
	     * value: {
	     *      axis,
	     *      coordSys,
	     *      axisPointerModel,
	     *      triggerTooltip,
	     *      involveSeries,
	     *      snap,
	     *      seriesModels,
	     *      seriesDataCount
	     * }
	     */
	    axesInfo: {},
	    seriesInvolved: false,
	
	    /**
	     * key: makeKey(coordSys.model)
	     * value: Object: key makeKey(axis.model), value: axisInfo
	     */
	    coordSysAxesInfo: {},
	    coordSysMap: {}
	  };
	  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
	
	  result.seriesInvolved && collectSeriesInfo(result, ecModel);
	  return result;
	}
	
	function collectAxesInfo(result, ecModel, api) {
	  var globalTooltipModel = ecModel.getComponent('tooltip');
	  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
	
	  var linksOption = globalAxisPointerModel.get('link', true) || [];
	  var linkGroups = []; // Collect axes info.
	
	  each(api.getCoordinateSystems(), function (coordSys) {
	    // Some coordinate system do not support axes, like geo.
	    if (!coordSys.axisPointerEnabled) {
	      return;
	    }
	
	    var coordSysKey = makeKey(coordSys.model);
	    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
	    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
	    // for user. So we enable seting tooltip on coordSys model.
	
	    var coordSysModel = coordSys.model;
	    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
	    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
	    // Notice this case: coordSys is `grid` but not `cartesian2D` here.
	
	    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
	    // show but axisPointer will show as normal.
	    && baseTooltipModel.get('show')) {
	      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
	      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
	      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
	      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
	      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));
	
	      if (triggerAxis || cross) {
	        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
	      }
	
	      if (cross) {
	        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
	      }
	    } // fromTooltip: true | false | 'cross'
	    // triggerTooltip: true | false | null
	
	
	    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
	      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
	      var axisPointerShow = axisPointerModel.get('show');
	
	      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
	        return;
	      }
	
	      if (triggerTooltip == null) {
	        triggerTooltip = axisPointerModel.get('triggerTooltip');
	      }
	
	      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
	      var snap = axisPointerModel.get('snap');
	      var key = makeKey(axis.model);
	      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
	
	      var axisInfo = result.axesInfo[key] = {
	        key: key,
	        axis: axis,
	        coordSys: coordSys,
	        axisPointerModel: axisPointerModel,
	        triggerTooltip: triggerTooltip,
	        involveSeries: involveSeries,
	        snap: snap,
	        useHandle: isHandleTrigger(axisPointerModel),
	        seriesModels: []
	      };
	      axesInfoInCoordSys[key] = axisInfo;
	      result.seriesInvolved |= involveSeries;
	      var groupIndex = getLinkGroupIndex(linksOption, axis);
	
	      if (groupIndex != null) {
	        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
	          axesInfo: {}
	        });
	        linkGroup.axesInfo[key] = axisInfo;
	        linkGroup.mapper = linksOption[groupIndex].mapper;
	        axisInfo.linkGroup = linkGroup;
	      }
	    }
	  });
	}
	
	function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
	  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
	  var volatileOption = {};
	  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
	    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
	  }); // category axis do not auto snap, otherwise some tick that do not
	  // has value can not be hovered. value/time/log axis default snap if
	  // triggered from tooltip and trigger tooltip.
	
	  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
	  // Only these properties can be overrided from tooltip to axisPointer.
	
	  if (tooltipAxisPointerModel.get('type') === 'cross') {
	    volatileOption.type = 'line';
	  }
	
	  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
	
	  labelOption.show == null && (labelOption.show = false);
	
	  if (fromTooltip === 'cross') {
	    // When 'cross', both axes show labels.
	    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get('label.show');
	    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
	    // (cross style is dashed by default)
	
	    if (!triggerTooltip) {
	      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
	      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
	    }
	  }
	
	  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
	}
	
	function collectSeriesInfo(result, ecModel) {
	  // Prepare data for axis trigger
	  ecModel.eachSeries(function (seriesModel) {
	    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
	    var seriesTooltipShow = seriesModel.get('tooltip.show', true);
	
	    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
	      return;
	    }
	
	    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
	      var axis = axisInfo.axis;
	
	      if (coordSys.getAxis(axis.dim) === axis) {
	        axisInfo.seriesModels.push(seriesModel);
	        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
	        axisInfo.seriesDataCount += seriesModel.getData().count();
	      }
	    });
	  }, this);
	}
	/**
	 * For example:
	 * {
	 *     axisPointer: {
	 *         links: [{
	 *             xAxisIndex: [2, 4],
	 *             yAxisIndex: 'all'
	 *         }, {
	 *             xAxisId: ['a5', 'a7'],
	 *             xAxisName: 'xxx'
	 *         }]
	 *     }
	 * }
	 */
	
	
	function getLinkGroupIndex(linksOption, axis) {
	  var axisModel = axis.model;
	  var dim = axis.dim;
	
	  for (var i = 0; i < linksOption.length; i++) {
	    var linkOption = linksOption[i] || {};
	
	    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
	      return i;
	    }
	  }
	}
	
	function checkPropInLink(linkPropValue, axisPropValue) {
	  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
	}
	
	function fixValue(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	
	  if (!axisInfo) {
	    return;
	  }
	
	  var axisPointerModel = axisInfo.axisPointerModel;
	  var scale = axisInfo.axis.scale;
	  var option = axisPointerModel.option;
	  var status = axisPointerModel.get('status');
	  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
	
	  if (value != null) {
	    value = scale.parse(value);
	  }
	
	  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
	  // and status should be initialized.
	
	  if (status == null) {
	    option.status = useHandle ? 'show' : 'hide';
	  }
	
	  var extent = scale.getExtent().slice();
	  extent[0] > extent[1] && extent.reverse();
	
	  if ( // Pick a value on axis when initializing.
	  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
	  // where we should re-pick a value to keep `handle` displaying normally.
	  || value > extent[1]) {
	    // Make handle displayed on the end of the axis when init, which looks better.
	    value = extent[1];
	  }
	
	  if (value < extent[0]) {
	    value = extent[0];
	  }
	
	  option.value = value;
	
	  if (useHandle) {
	    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
	  }
	}
	
	function getAxisInfo(axisModel) {
	  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
	  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
	}
	
	function getAxisPointerModel(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	  return axisInfo && axisInfo.axisPointerModel;
	}
	
	function isHandleTrigger(axisPointerModel) {
	  return !!axisPointerModel.get('handle.show');
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @return {string} unique key
	 */
	
	
	function makeKey(model) {
	  return model.type + '||' + model.id;
	}
	
	exports.collect = collect;
	exports.fixValue = fixValue;
	exports.getAxisInfo = getAxisInfo;
	exports.getAxisPointerModel = getAxisPointerModel;
	exports.makeKey = makeKey;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var textContain = __webpack_require__(86);
	
	var formatUtil = __webpack_require__(48);
	
	var matrix = __webpack_require__(75);
	
	var axisHelper = __webpack_require__(96);
	
	var AxisBuilder = __webpack_require__(127);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Model} axisPointerModel
	 */
	function buildElStyle(axisPointerModel) {
	  var axisPointerType = axisPointerModel.get('type');
	  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
	  var style;
	
	  if (axisPointerType === 'line') {
	    style = styleModel.getLineStyle();
	    style.fill = null;
	  } else if (axisPointerType === 'shadow') {
	    style = styleModel.getAreaStyle();
	    style.stroke = null;
	  }
	
	  return style;
	}
	/**
	 * @param {Function} labelPos {align, verticalAlign, position}
	 */
	
	
	function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
	  var value = axisPointerModel.get('value');
	  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
	    precision: axisPointerModel.get('label.precision'),
	    formatter: axisPointerModel.get('label.formatter')
	  });
	  var labelModel = axisPointerModel.getModel('label');
	  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
	  var font = labelModel.getFont();
	  var textRect = textContain.getBoundingRect(text, font);
	  var position = labelPos.position;
	  var width = textRect.width + paddings[1] + paddings[3];
	  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
	
	  var align = labelPos.align;
	  align === 'right' && (position[0] -= width);
	  align === 'center' && (position[0] -= width / 2);
	  var verticalAlign = labelPos.verticalAlign;
	  verticalAlign === 'bottom' && (position[1] -= height);
	  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
	
	  confineInContainer(position, width, height, api);
	  var bgColor = labelModel.get('backgroundColor');
	
	  if (!bgColor || bgColor === 'auto') {
	    bgColor = axisModel.get('axisLine.lineStyle.color');
	  }
	
	  elOption.label = {
	    shape: {
	      x: 0,
	      y: 0,
	      width: width,
	      height: height,
	      r: labelModel.get('borderRadius')
	    },
	    position: position.slice(),
	    // TODO: rich
	    style: {
	      text: text,
	      textFont: font,
	      textFill: labelModel.getTextColor(),
	      textPosition: 'inside',
	      textPadding: paddings,
	      fill: bgColor,
	      stroke: labelModel.get('borderColor') || 'transparent',
	      lineWidth: labelModel.get('borderWidth') || 0,
	      shadowBlur: labelModel.get('shadowBlur'),
	      shadowColor: labelModel.get('shadowColor'),
	      shadowOffsetX: labelModel.get('shadowOffsetX'),
	      shadowOffsetY: labelModel.get('shadowOffsetY')
	    },
	    // Lable should be over axisPointer.
	    z2: 10
	  };
	} // Do not overflow ec container
	
	
	function confineInContainer(position, width, height, api) {
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  position[0] = Math.min(position[0] + width, viewWidth) - width;
	  position[1] = Math.min(position[1] + height, viewHeight) - height;
	  position[0] = Math.max(position[0], 0);
	  position[1] = Math.max(position[1], 0);
	}
	/**
	 * @param {number} value
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} opt
	 * @param {Array.<Object>} seriesDataIndices
	 * @param {number|string} opt.precision 'auto' or a number
	 * @param {string|Function} opt.formatter label formatter
	 */
	
	
	function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
	  value = axis.scale.parse(value);
	  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
	  // helps to debounce when when moving label.
	  value, {
	    precision: opt.precision
	  });
	  var formatter = opt.formatter;
	
	  if (formatter) {
	    var params = {
	      value: axisHelper.getAxisRawValue(axis, value),
	      axisDimension: axis.dim,
	      axisIndex: axis.index,
	      seriesData: []
	    };
	    zrUtil.each(seriesDataIndices, function (idxItem) {
	      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	      var dataIndex = idxItem.dataIndexInside;
	      var dataParams = series && series.getDataParams(dataIndex);
	      dataParams && params.seriesData.push(dataParams);
	    });
	
	    if (zrUtil.isString(formatter)) {
	      text = formatter.replace('{value}', text);
	    } else if (zrUtil.isFunction(formatter)) {
	      text = formatter(params);
	    }
	  }
	
	  return text;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @param {number} value
	 * @param {Object} layoutInfo {
	 *  rotation, position, labelOffset, labelDirection, labelMargin
	 * }
	 */
	
	
	function getTransformedPosition(axis, value, layoutInfo) {
	  var transform = matrix.create();
	  matrix.rotate(transform, transform, layoutInfo.rotation);
	  matrix.translate(transform, transform, layoutInfo.position);
	  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
	}
	
	function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
	  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
	  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
	  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
	    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
	    align: textLayout.textAlign,
	    verticalAlign: textLayout.textVerticalAlign
	  });
	}
	/**
	 * @param {Array.<number>} p1
	 * @param {Array.<number>} p2
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeLineShape(p1, p2, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x1: p1[xDimIndex],
	    y1: p1[1 - xDimIndex],
	    x2: p2[xDimIndex],
	    y2: p2[1 - xDimIndex]
	  };
	}
	/**
	 * @param {Array.<number>} xy
	 * @param {Array.<number>} wh
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeRectShape(xy, wh, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x: xy[xDimIndex],
	    y: xy[1 - xDimIndex],
	    width: wh[xDimIndex],
	    height: wh[1 - xDimIndex]
	  };
	}
	
	function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
	  return {
	    cx: cx,
	    cy: cy,
	    r0: r0,
	    r: r,
	    startAngle: startAngle,
	    endAngle: endAngle,
	    clockwise: true
	  };
	}
	
	exports.buildElStyle = buildElStyle;
	exports.buildLabelElOption = buildLabelElOption;
	exports.getValueLabel = getValueLabel;
	exports.getTransformedPosition = getTransformedPosition;
	exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
	exports.makeLineShape = makeLineShape;
	exports.makeRectShape = makeRectShape;
	exports.makeSectorShape = makeSectorShape;

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var IRRELEVANT_EXCLUDES = {
	  'axisPointer': 1,
	  'tooltip': 1,
	  'brush': 1
	};
	/**
	 * Avoid that: mouse click on a elements that is over geo or graph,
	 * but roam is triggered.
	 */
	
	function onIrrelevantElement(e, api, targetCoordSysModel) {
	  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.
	
	  var coordSys = model && model.coordinateSystem;
	  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
	}
	
	exports.onIrrelevantElement = onIrrelevantElement;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var axisDefault = __webpack_require__(841);
	
	var ComponentModel = __webpack_require__(65);
	
	var _layout = __webpack_require__(47);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var OrdinalMeta = __webpack_require__(849);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME axisType is fixed ?
	var AXIS_TYPES = ['value', 'category', 'time', 'log'];
	/**
	 * Generate sub axis model class
	 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
	 * @param {module:echarts/model/Component} BaseAxisModelClass
	 * @param {Function} axisTypeDefaulter
	 * @param {Object} [extraDefaultOption]
	 */
	
	function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
	  zrUtil.each(AXIS_TYPES, function (axisType) {
	    BaseAxisModelClass.extend({
	      /**
	       * @readOnly
	       */
	      type: axisName + 'Axis.' + axisType,
	      mergeDefaultAndTheme: function (option, ecModel) {
	        var layoutMode = this.layoutMode;
	        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
	        var themeModel = ecModel.getTheme();
	        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
	        zrUtil.merge(option, this.getDefaultOption());
	        option.type = axisTypeDefaulter(axisName, option);
	
	        if (layoutMode) {
	          mergeLayoutParam(option, inputPositionParams, layoutMode);
	        }
	      },
	
	      /**
	       * @override
	       */
	      optionUpdated: function () {
	        var thisOption = this.option;
	
	        if (thisOption.type === 'category') {
	          this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
	        }
	      },
	
	      /**
	       * Should not be called before all of 'getInitailData' finished.
	       * Because categories are collected during initializing data.
	       */
	      getCategories: function (rawData) {
	        var option = this.option; // FIXME
	        // warning if called before all of 'getInitailData' finished.
	
	        if (option.type === 'category') {
	          if (rawData) {
	            return option.data;
	          }
	
	          return this.__ordinalMeta.categories;
	        }
	      },
	      getOrdinalMeta: function () {
	        return this.__ordinalMeta;
	      },
	      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
	    });
	  });
	  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
	}
	
	module.exports = _default;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var mapDataStorage = __webpack_require__(429);
	
	var geoJSONLoader = __webpack_require__(1826);
	
	var geoSVGLoader = __webpack_require__(1827);
	
	var BoundingRect = __webpack_require__(51);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var loaders = {
	  geoJSON: geoJSONLoader,
	  svg: geoSVGLoader
	};
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} nameMap
	   * @param {string} nameProperty
	   * @return {Object} source {regions, regionsMap, nameCoordMap, boundingRect}
	   */
	  load: function (mapName, nameMap, nameProperty) {
	    var regions = [];
	    var regionsMap = createHashMap();
	    var nameCoordMap = createHashMap();
	    var boundingRect;
	    var mapRecords = retrieveMap(mapName);
	    each(mapRecords, function (record) {
	      var singleSource = loaders[record.type].load(mapName, record, nameProperty);
	      each(singleSource.regions, function (region) {
	        var regionName = region.name; // Try use the alias in geoNameMap
	
	        if (nameMap && nameMap.hasOwnProperty(regionName)) {
	          region = region.cloneShallow(regionName = nameMap[regionName]);
	        }
	
	        regions.push(region);
	        regionsMap.set(regionName, region);
	        nameCoordMap.set(regionName, region.center);
	      });
	      var rect = singleSource.boundingRect;
	
	      if (rect) {
	        boundingRect ? boundingRect.union(rect) : boundingRect = rect.clone();
	      }
	    });
	    return {
	      regions: regions,
	      regionsMap: regionsMap,
	      nameCoordMap: nameCoordMap,
	      // FIXME Always return new ?
	      boundingRect: boundingRect || new BoundingRect(0, 0, 0, 0)
	    };
	  },
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   * @return {Array.<module:zrender/Element>} Roots.
	   */
	  makeGraphic: makeInvoker('makeGraphic'),
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   */
	  removeGraphic: makeInvoker('removeGraphic')
	};
	
	function makeInvoker(methodName) {
	  return function (mapName, hostKey) {
	    var mapRecords = retrieveMap(mapName);
	    var results = [];
	    each(mapRecords, function (record) {
	      var method = loaders[record.type][methodName];
	      method && results.push(method(mapName, record, hostKey));
	    });
	    return results;
	  };
	}
	
	function mapNotExistsError(mapName) {}
	
	function retrieveMap(mapName) {
	  var mapRecords = mapDataStorage.retrieveMap(mapName) || [];
	  return mapRecords;
	}
	
	module.exports = _default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(102);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var createRenderPlanner = __webpack_require__(171);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var STACK_PREFIX = '__ec_stack_';
	var LARGE_BAR_MIN_WIDTH = 0.5;
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
	}
	
	function getAxisKey(axis) {
	  return axis.dim + axis.index;
	}
	/**
	 * @param {Object} opt
	 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
	 * @param {number} opt.count Positive interger.
	 * @param {number} [opt.barWidth]
	 * @param {number} [opt.barMaxWidth]
	 * @param {number} [opt.barMinWidth]
	 * @param {number} [opt.barGap]
	 * @param {number} [opt.barCategoryGap]
	 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
	 */
	
	
	function getLayoutOnAxis(opt) {
	  var params = [];
	  var baseAxis = opt.axis;
	  var axisKey = 'axis0';
	
	  if (baseAxis.type !== 'category') {
	    return;
	  }
	
	  var bandWidth = baseAxis.getBandWidth();
	
	  for (var i = 0; i < opt.count || 0; i++) {
	    params.push(zrUtil.defaults({
	      bandWidth: bandWidth,
	      axisKey: axisKey,
	      stackId: STACK_PREFIX + i
	    }, opt));
	  }
	
	  var widthAndOffsets = doCalBarWidthAndOffset(params);
	  var result = [];
	
	  for (var i = 0; i < opt.count; i++) {
	    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
	    item.offsetCenter = item.offset + item.width / 2;
	    result.push(item);
	  }
	
	  return result;
	}
	
	function prepareLayoutBarSeries(seriesType, ecModel) {
	  var seriesModels = [];
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for cartesian2d only
	    if (isOnCartesian(seriesModel) && !isInLargeMode(seriesModel)) {
	      seriesModels.push(seriesModel);
	    }
	  });
	  return seriesModels;
	}
	/**
	 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
	 * values.
	 * This works for time axes, value axes, and log axes.
	 * For a single time axis, return value is in the form like
	 * {'x_0': [1000000]}.
	 * The value of 1000000 is in milliseconds.
	 */
	
	
	function getValueAxesMinGaps(barSeries) {
	  /**
	   * Map from axis.index to values.
	   * For a single time axis, axisValues is in the form like
	   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
	   * Items in axisValues[x], e.g. 1495555200000, are time values of all
	   * series.
	   */
	  var axisValues = {};
	  zrUtil.each(barSeries, function (seriesModel) {
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	
	    if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var key = baseAxis.dim + '_' + baseAxis.index;
	    var dim = data.mapDimension(baseAxis.dim);
	
	    for (var i = 0, cnt = data.count(); i < cnt; ++i) {
	      var value = data.get(dim, i);
	
	      if (!axisValues[key]) {
	        // No previous data for the axis
	        axisValues[key] = [value];
	      } else {
	        // No value in previous series
	        axisValues[key].push(value);
	      } // Ignore duplicated time values in the same axis
	
	    }
	  });
	  var axisMinGaps = [];
	
	  for (var key in axisValues) {
	    if (axisValues.hasOwnProperty(key)) {
	      var valuesInAxis = axisValues[key];
	
	      if (valuesInAxis) {
	        // Sort axis values into ascending order to calculate gaps
	        valuesInAxis.sort(function (a, b) {
	          return a - b;
	        });
	        var min = null;
	
	        for (var j = 1; j < valuesInAxis.length; ++j) {
	          var delta = valuesInAxis[j] - valuesInAxis[j - 1];
	
	          if (delta > 0) {
	            // Ignore 0 delta because they are of the same axis value
	            min = min === null ? delta : Math.min(min, delta);
	          }
	        } // Set to null if only have one data
	
	
	        axisMinGaps[key] = min;
	      }
	    }
	  }
	
	  return axisMinGaps;
	}
	
	function makeColumnLayout(barSeries) {
	  var axisMinGaps = getValueAxesMinGaps(barSeries);
	  var seriesInfoList = [];
	  zrUtil.each(barSeries, function (seriesModel) {
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth;
	
	    if (baseAxis.type === 'category') {
	      bandWidth = baseAxis.getBandWidth();
	    } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
	      var key = baseAxis.dim + '_' + baseAxis.index;
	      var minGap = axisMinGaps[key];
	      var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
	      var scale = baseAxis.scale.getExtent();
	      var scaleSpan = Math.abs(scale[1] - scale[0]);
	      bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
	    } else {
	      var data = seriesModel.getData();
	      bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    }
	
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barMinWidth = parsePercent( // barMinWidth by default is 1 in cartesian. Because in value axis,
	    // the auto-calculated bar width might be less than 1.
	    seriesModel.get('barMinWidth') || 1, bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	    seriesInfoList.push({
	      bandWidth: bandWidth,
	      barWidth: barWidth,
	      barMaxWidth: barMaxWidth,
	      barMinWidth: barMinWidth,
	      barGap: barGap,
	      barCategoryGap: barCategoryGap,
	      axisKey: getAxisKey(baseAxis),
	      stackId: getSeriesStackId(seriesModel)
	    });
	  });
	  return doCalBarWidthAndOffset(seriesInfoList);
	}
	
	function doCalBarWidthAndOffset(seriesInfoList) {
	  // Columns info on each category axis. Key is cartesian name
	  var columnsMap = {};
	  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
	    var axisKey = seriesInfo.axisKey;
	    var bandWidth = seriesInfo.bandWidth;
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = seriesInfo.stackId;
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    }; // Caution: In a single coordinate system, these barGrid attributes
	    // will be shared by series. Consider that they have default values,
	    // only the attributes set on the last series will work.
	    // Do not change this fact unless there will be a break change.
	
	    var barWidth = seriesInfo.barWidth;
	
	    if (barWidth && !stacks[stackId].width) {
	      // See #6312, do not restrict width.
	      stacks[stackId].width = barWidth;
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    var barMaxWidth = seriesInfo.barMaxWidth;
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    var barMinWidth = seriesInfo.barMinWidth;
	    barMinWidth && (stacks[stackId].minWidth = barMinWidth);
	    var barGap = seriesInfo.barGap;
	    barGap != null && (columnsOnAxis.gap = barGap);
	    var barCategoryGap = seriesInfo.barCategoryGap;
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column) {
	      var maxWidth = column.maxWidth;
	      var minWidth = column.minWidth;
	
	      if (!column.width) {
	        var finalWidth = autoWidth;
	
	        if (maxWidth && maxWidth < finalWidth) {
	          finalWidth = Math.min(maxWidth, remainedWidth);
	        } // `minWidth` has higher priority. `minWidth` decide that wheter the
	        // bar is able to be visible. So `minWidth` should not be restricted
	        // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
	        // the extreme cases for `value` axis, bars are allowed to overlap
	        // with each other if `minWidth` specified.
	
	
	        if (minWidth && minWidth > finalWidth) {
	          finalWidth = minWidth;
	        }
	
	        if (finalWidth !== autoWidth) {
	          column.width = finalWidth;
	          remainedWidth -= finalWidth + barGapPercent * finalWidth;
	          autoWidthCount--;
	        }
	      } else {
	        // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
	        // CSS does. Becuase barWidth can be a percent value, where
	        // `barMaxWidth` can be used to restrict the final width.
	        var finalWidth = column.width;
	
	        if (maxWidth) {
	          finalWidth = Math.min(finalWidth, maxWidth);
	        } // `minWidth` has higher priority, as described above
	
	
	        if (minWidth) {
	          finalWidth = Math.max(finalWidth, minWidth);
	        }
	
	        column.width = finalWidth;
	        remainedWidth -= finalWidth + barGapPercent * finalWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        bandWidth: bandWidth,
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	/**
	 * @param {Object} barWidthAndOffset The result of makeColumnLayout
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
	 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
	 */
	
	
	function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
	  if (barWidthAndOffset && axis) {
	    var result = barWidthAndOffset[getAxisKey(axis)];
	
	    if (result != null && seriesModel != null) {
	      result = result[getSeriesStackId(seriesModel)];
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function layout(seriesType, ecModel) {
	  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
	  var barWidthAndOffset = makeColumnLayout(seriesModels);
	  var lastStackCoords = {};
	  var lastStackCoordsOrigin = {};
	  zrUtil.each(seriesModels, function (seriesModel) {
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243
	
	    data.setLayout({
	      bandWidth: columnLayoutInfo.bandWidth,
	      offset: columnOffset,
	      size: columnWidth
	    });
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var isValueAxisH = valueAxis.isHorizontal();
	    var valueAxisStart = getValueAxisStart(baseAxis, valueAxis, stacked);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	
	      if (stacked) {
	        // Only ordinal axis can be stacked.
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var x;
	      var y;
	      var width;
	      var height;
	
	      if (isValueAxisH) {
	        var coord = cartesian.dataToPoint([value, baseValue]);
	        x = baseCoord;
	        y = coord[1] + columnOffset;
	        width = coord[0] - valueAxisStart;
	        height = columnWidth;
	
	        if (Math.abs(width) < barMinHeight) {
	          width = (width < 0 ? -1 : 1) * barMinHeight;
	        } // Ignore stack from NaN value
	
	
	        if (!isNaN(width)) {
	          stacked && (lastStackCoords[stackId][baseValue][sign] += width);
	        }
	      } else {
	        var coord = cartesian.dataToPoint([baseValue, value]);
	        x = coord[0] + columnOffset;
	        y = baseCoord;
	        width = columnWidth;
	        height = coord[1] - valueAxisStart;
	
	        if (Math.abs(height) < barMinHeight) {
	          // Include zero to has a positive bar
	          height = (height <= 0 ? -1 : 1) * barMinHeight;
	        } // Ignore stack from NaN value
	
	
	        if (!isNaN(height)) {
	          stacked && (lastStackCoords[stackId][baseValue][sign] += height);
	        }
	      }
	
	      data.setItemLayout(idx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, this);
	} // TODO: Do not support stack in large mode yet.
	
	
	var largeLayout = {
	  seriesType: 'bar',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    if (!isOnCartesian(seriesModel) || !isInLargeMode(seriesModel)) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var coordLayout = cartesian.grid.getRect();
	    var baseAxis = cartesian.getBaseAxis();
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var valueAxisHorizontal = valueAxis.isHorizontal();
	    var valueDimIdx = valueAxisHorizontal ? 0 : 1;
	    var barWidth = retrieveColumnLayout(makeColumnLayout([seriesModel]), baseAxis, seriesModel).width;
	
	    if (!(barWidth > LARGE_BAR_MIN_WIDTH)) {
	      // jshint ignore:line
	      barWidth = LARGE_BAR_MIN_WIDTH;
	    }
	
	    return {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var count = params.count;
	      var largePoints = new LargeArr(count * 2);
	      var largeBackgroundPoints = new LargeArr(count * 2);
	      var largeDataIndices = new LargeArr(count);
	      var dataIndex;
	      var coord = [];
	      var valuePair = [];
	      var pointsOffset = 0;
	      var idxOffset = 0;
	
	      while ((dataIndex = params.next()) != null) {
	        valuePair[valueDimIdx] = data.get(valueDim, dataIndex);
	        valuePair[1 - valueDimIdx] = data.get(baseDim, dataIndex);
	        coord = cartesian.dataToPoint(valuePair, null, coord); // Data index might not be in order, depends on `progressiveChunkMode`.
	
	        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
	        largePoints[pointsOffset++] = coord[0];
	        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
	        largePoints[pointsOffset++] = coord[1];
	        largeDataIndices[idxOffset++] = dataIndex;
	      }
	
	      data.setLayout({
	        largePoints: largePoints,
	        largeDataIndices: largeDataIndices,
	        largeBackgroundPoints: largeBackgroundPoints,
	        barWidth: barWidth,
	        valueAxisStart: getValueAxisStart(baseAxis, valueAxis, false),
	        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
	        valueAxisHorizontal: valueAxisHorizontal
	      });
	    }
	  }
	};
	
	function isOnCartesian(seriesModel) {
	  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
	}
	
	function isInLargeMode(seriesModel) {
	  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
	} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
	
	
	function getValueAxisStart(baseAxis, valueAxis, stacked) {
	  return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
	}
	
	exports.getLayoutOnAxis = getLayoutOnAxis;
	exports.prepareLayoutBarSeries = prepareLayoutBarSeries;
	exports.makeColumnLayout = makeColumnLayout;
	exports.retrieveColumnLayout = retrieveColumnLayout;
	exports.layout = layout;
	exports.largeLayout = largeLayout;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(24);
	
	var formatUtil = __webpack_require__(48);
	
	var Scale = __webpack_require__(274);
	
	var helper = __webpack_require__(856);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Interval scale
	 * @module echarts/scale/Interval
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @alias module:echarts/coord/scale/Interval
	 * @constructor
	 */
	
	var IntervalScale = Scale.extend({
	  type: 'interval',
	  _interval: 0,
	  _intervalPrecision: 2,
	  setExtent: function (start, end) {
	    var thisExtent = this._extent; //start,end may be a Number like '25',so...
	
	    if (!isNaN(start)) {
	      thisExtent[0] = parseFloat(start);
	    }
	
	    if (!isNaN(end)) {
	      thisExtent[1] = parseFloat(end);
	    }
	  },
	  unionExtent: function (other) {
	    var extent = this._extent;
	    other[0] < extent[0] && (extent[0] = other[0]);
	    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
	
	    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
	  },
	
	  /**
	   * Get interval
	   */
	  getInterval: function () {
	    return this._interval;
	  },
	
	  /**
	   * Set interval
	   */
	  setInterval: function (interval) {
	    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
	    // We assume user wan't to set both interval, min, max to get a better result
	
	    this._niceExtent = this._extent.slice();
	    this._intervalPrecision = helper.getIntervalPrecision(interval);
	  },
	
	  /**
	   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
	   * @return {Array.<number>}
	   */
	  getTicks: function (expandToNicedExtent) {
	    var interval = this._interval;
	    var extent = this._extent;
	    var niceTickExtent = this._niceExtent;
	    var intervalPrecision = this._intervalPrecision;
	    var ticks = []; // If interval is 0, return [];
	
	    if (!interval) {
	      return ticks;
	    } // Consider this case: using dataZoom toolbox, zoom and zoom.
	
	
	    var safeLimit = 10000;
	
	    if (extent[0] < niceTickExtent[0]) {
	      if (expandToNicedExtent) {
	        ticks.push(roundNumber(niceTickExtent[0] - interval, intervalPrecision));
	      } else {
	        ticks.push(extent[0]);
	      }
	    }
	
	    var tick = niceTickExtent[0];
	
	    while (tick <= niceTickExtent[1]) {
	      ticks.push(tick); // Avoid rounding error
	
	      tick = roundNumber(tick + interval, intervalPrecision);
	
	      if (tick === ticks[ticks.length - 1]) {
	        // Consider out of safe float point, e.g.,
	        // -3711126.9907707 + 2e-10 === -3711126.9907707
	        break;
	      }
	
	      if (ticks.length > safeLimit) {
	        return [];
	      }
	    } // Consider this case: the last item of ticks is smaller
	    // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
	
	
	    var lastNiceTick = ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1];
	
	    if (extent[1] > lastNiceTick) {
	      if (expandToNicedExtent) {
	        ticks.push(roundNumber(lastNiceTick + interval, intervalPrecision));
	      } else {
	        ticks.push(extent[1]);
	      }
	    }
	
	    return ticks;
	  },
	
	  /**
	   * @param {number} [splitNumber=5]
	   * @return {Array.<Array.<number>>}
	   */
	  getMinorTicks: function (splitNumber) {
	    var ticks = this.getTicks(true);
	    var minorTicks = [];
	    var extent = this.getExtent();
	
	    for (var i = 1; i < ticks.length; i++) {
	      var nextTick = ticks[i];
	      var prevTick = ticks[i - 1];
	      var count = 0;
	      var minorTicksGroup = [];
	      var interval = nextTick - prevTick;
	      var minorInterval = interval / splitNumber;
	
	      while (count < splitNumber - 1) {
	        var minorTick = numberUtil.round(prevTick + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
	
	        if (minorTick > extent[0] && minorTick < extent[1]) {
	          minorTicksGroup.push(minorTick);
	        }
	
	        count++;
	      }
	
	      minorTicks.push(minorTicksGroup);
	    }
	
	    return minorTicks;
	  },
	
	  /**
	   * @param {number} data
	   * @param {Object} [opt]
	   * @param {number|string} [opt.precision] If 'auto', use nice presision.
	   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
	   * @return {string}
	   */
	  getLabel: function (data, opt) {
	    if (data == null) {
	      return '';
	    }
	
	    var precision = opt && opt.precision;
	
	    if (precision == null) {
	      precision = numberUtil.getPrecisionSafe(data) || 0;
	    } else if (precision === 'auto') {
	      // Should be more precise then tick.
	      precision = this._intervalPrecision;
	    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
	    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
	
	
	    data = roundNumber(data, precision, true);
	    return formatUtil.addCommas(data);
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   *
	   * @param {number} [splitNumber = 5] Desired number of ticks
	   * @param {number} [minInterval]
	   * @param {number} [maxInterval]
	   */
	  niceTicks: function (splitNumber, minInterval, maxInterval) {
	    splitNumber = splitNumber || 5;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (!isFinite(span)) {
	      return;
	    } // User may set axis min 0 and data are all negative
	    // FIXME If it needs to reverse ?
	
	
	    if (span < 0) {
	      span = -span;
	      extent.reverse();
	    }
	
	    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
	    this._intervalPrecision = result.intervalPrecision;
	    this._interval = result.interval;
	    this._niceExtent = result.niceTickExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @param {Object} opt
	   * @param {number} [opt.splitNumber = 5] Given approx tick number
	   * @param {boolean} [opt.fixMin=false]
	   * @param {boolean} [opt.fixMax=false]
	   * @param {boolean} [opt.minInterval]
	   * @param {boolean} [opt.maxInterval]
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      if (extent[0] !== 0) {
	        // Expand extent
	        var expandSize = extent[0]; // In the fowllowing case
	        //      Axis has been fixed max 100
	        //      Plus data are all 100 and axis extent are [100, 100].
	        // Extend to the both side will cause expanded max is larger than fixed max.
	        // So only expand to the smaller side.
	
	        if (!opt.fixMax) {
	          extent[1] += expandSize / 2;
	          extent[0] -= expandSize / 2;
	        } else {
	          extent[0] -= expandSize / 2;
	        }
	      } else {
	        extent[1] = 1;
	      }
	    }
	
	    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
	
	    if (!isFinite(span)) {
	      extent[0] = 0;
	      extent[1] = 1;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
	    }
	  }
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	IntervalScale.create = function () {
	  return new IntervalScale();
	};
	
	var _default = IntervalScale;
	module.exports = _default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var clazzUtil = __webpack_require__(115);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * // Scale class management
	 * @module echarts/scale/Scale
	 */
	
	/**
	 * @param {Object} [setting]
	 */
	function Scale(setting) {
	  this._setting = setting || {};
	  /**
	   * Extent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._extent = [Infinity, -Infinity];
	  /**
	   * Step is calculated in adjustExtent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._interval = 0;
	  this.init && this.init.apply(this, arguments);
	}
	/**
	 * Parse input val to valid inner number.
	 * @param {*} val
	 * @return {number}
	 */
	
	
	Scale.prototype.parse = function (val) {
	  // Notice: This would be a trap here, If the implementation
	  // of this method depends on extent, and this method is used
	  // before extent set (like in dataZoom), it would be wrong.
	  // Nevertheless, parse does not depend on extent generally.
	  return val;
	};
	
	Scale.prototype.getSetting = function (name) {
	  return this._setting[name];
	};
	
	Scale.prototype.contain = function (val) {
	  var extent = this._extent;
	  return val >= extent[0] && val <= extent[1];
	};
	/**
	 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.normalize = function (val) {
	  var extent = this._extent;
	
	  if (extent[1] === extent[0]) {
	    return 0.5;
	  }
	
	  return (val - extent[0]) / (extent[1] - extent[0]);
	};
	/**
	 * Scale normalized value
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.scale = function (val) {
	  var extent = this._extent;
	  return val * (extent[1] - extent[0]) + extent[0];
	};
	/**
	 * Set extent from data
	 * @param {Array.<number>} other
	 */
	
	
	Scale.prototype.unionExtent = function (other) {
	  var extent = this._extent;
	  other[0] < extent[0] && (extent[0] = other[0]);
	  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
	  // this.setExtent(extent[0], extent[1]);
	};
	/**
	 * Set extent from data
	 * @param {module:echarts/data/List} data
	 * @param {string} dim
	 */
	
	
	Scale.prototype.unionExtentFromData = function (data, dim) {
	  this.unionExtent(data.getApproximateExtent(dim));
	};
	/**
	 * Get extent
	 * @return {Array.<number>}
	 */
	
	
	Scale.prototype.getExtent = function () {
	  return this._extent.slice();
	};
	/**
	 * Set extent
	 * @param {number} start
	 * @param {number} end
	 */
	
	
	Scale.prototype.setExtent = function (start, end) {
	  var thisExtent = this._extent;
	
	  if (!isNaN(start)) {
	    thisExtent[0] = start;
	  }
	
	  if (!isNaN(end)) {
	    thisExtent[1] = end;
	  }
	};
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	
	
	Scale.prototype.isBlank = function () {
	  return this._isBlank;
	},
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	Scale.prototype.setBlank = function (isBlank) {
	  this._isBlank = isBlank;
	};
	/**
	 * @abstract
	 * @param {*} tick
	 * @return {string} label of the tick.
	 */
	
	Scale.prototype.getLabel = null;
	clazzUtil.enableClassExtend(Scale);
	clazzUtil.enableClassManagement(Scale, {
	  registerWhenExtend: true
	});
	var _default = Scale;
	module.exports = _default;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Group = __webpack_require__(146);
	
	var componentUtil = __webpack_require__(224);
	
	var clazzUtil = __webpack_require__(115);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Component = function () {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewComponent');
	};
	
	Component.prototype = {
	  constructor: Component,
	  init: function (ecModel, api) {},
	  render: function (componentModel, ecModel, api, payload) {},
	  dispose: function () {},
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var componentProto = Component.prototype;
	
	componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
	}; // Enable Component.extend.
	
	
	clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Component, {
	  registerWhenExtend: true
	});
	var _default = Component;
	module.exports = _default;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Pick color from palette for each data item.
	// Applicable for charts that require applying color palette
	// in data level (like pie, funnel, chord).
	function _default(seriesType) {
	  return {
	    getTargetSeries: function (ecModel) {
	      // Pie and funnel may use diferrent scope
	      var paletteScope = {};
	      var seiresModelMap = createHashMap();
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        seriesModel.__paletteScope = paletteScope;
	        seiresModelMap.set(seriesModel.uid, seriesModel);
	      });
	      return seiresModelMap;
	    },
	    reset: function (seriesModel, ecModel) {
	      var dataAll = seriesModel.getRawData();
	      var idxMap = {};
	      var data = seriesModel.getData();
	      data.each(function (idx) {
	        var rawIdx = data.getRawIndex(idx);
	        idxMap[rawIdx] = idx;
	      });
	      dataAll.each(function (rawIdx) {
	        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded
	
	        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);
	        var singleDataBorderColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'borderColor', true);
	        var itemModel;
	
	        if (!singleDataColor || !singleDataBorderColor) {
	          // FIXME Performance
	          itemModel = dataAll.getItemModel(rawIdx);
	        }
	
	        if (!singleDataColor) {
	          var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx) || rawIdx + '', seriesModel.__paletteScope, dataAll.count()); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'color', color);
	          }
	        }
	
	        if (!singleDataBorderColor) {
	          var borderColor = itemModel.get('itemStyle.borderColor'); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'borderColor', borderColor);
	          }
	        }
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var VisualMapping = __webpack_require__(144);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual solution, for consistent option specification.
	 */
	var each = zrUtil.each;
	
	function hasKeys(obj) {
	  if (obj) {
	    for (var name in obj) {
	      if (obj.hasOwnProperty(name)) {
	        return true;
	      }
	    }
	  }
	}
	/**
	 * @param {Object} option
	 * @param {Array.<string>} stateList
	 * @param {Function} [supplementVisualOption]
	 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
	 */
	
	
	function createVisualMappings(option, stateList, supplementVisualOption) {
	  var visualMappings = {};
	  each(stateList, function (state) {
	    var mappings = visualMappings[state] = createMappings();
	    each(option[state], function (visualData, visualType) {
	      if (!VisualMapping.isValidType(visualType)) {
	        return;
	      }
	
	      var mappingOption = {
	        type: visualType,
	        visual: visualData
	      };
	      supplementVisualOption && supplementVisualOption(mappingOption, state);
	      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
	      // is not supported, such as rendering using gradient color.
	
	      if (visualType === 'opacity') {
	        mappingOption = zrUtil.clone(mappingOption);
	        mappingOption.type = 'colorAlpha';
	        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
	      }
	    });
	  });
	  return visualMappings;
	
	  function createMappings() {
	    var Creater = function () {}; // Make sure hidden fields will not be visited by
	    // object iteration (with hasOwnProperty checking).
	
	
	    Creater.prototype.__hidden = Creater.prototype;
	    var obj = new Creater();
	    return obj;
	  }
	}
	/**
	 * @param {Object} thisOption
	 * @param {Object} newOption
	 * @param {Array.<string>} keys
	 */
	
	
	function replaceVisualOption(thisOption, newOption, keys) {
	  // Visual attributes merge is not supported, otherwise it
	  // brings overcomplicated merge logic. See #2853. So if
	  // newOption has anyone of these keys, all of these keys
	  // will be reset. Otherwise, all keys remain.
	  var has;
	  zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      has = true;
	    }
	  });
	  has && zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      thisOption[key] = zrUtil.clone(newOption[key]);
	    } else {
	      delete thisOption[key];
	    }
	  });
	}
	/**
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {module:echarts/data/List} list
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {object} [scope] Scope for getValueState
	 * @param {string} [dimension] Concrete dimension, if used.
	 */
	// ???! handle brush?
	
	
	function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	  var dataIndex;
	
	  function getVisual(key) {
	    return data.getItemVisual(dataIndex, key);
	  }
	
	  function setVisual(key, value) {
	    data.setItemVisual(dataIndex, key, value);
	  }
	
	  if (dimension == null) {
	    data.each(eachItem);
	  } else {
	    data.each([dimension], eachItem);
	  }
	
	  function eachItem(valueOrIndex, index) {
	    dataIndex = dimension == null ? valueOrIndex : index;
	    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	    if (rawDataItem && rawDataItem.visualMap === false) {
	      return;
	    }
	
	    var valueState = getValueState.call(scope, valueOrIndex);
	    var mappings = visualMappings[valueState];
	    var visualTypes = visualTypesMap[valueState];
	
	    for (var i = 0, len = visualTypes.length; i < len; i++) {
	      var type = visualTypes[i];
	      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {number} [dim] dimension or dimension index.
	 */
	
	
	function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	
	  function progress(params, data) {
	    if (dim != null) {
	      dim = data.getDimension(dim);
	    }
	
	    function getVisual(key) {
	      return data.getItemVisual(dataIndex, key);
	    }
	
	    function setVisual(key, value) {
	      data.setItemVisual(dataIndex, key, value);
	    }
	
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	      if (rawDataItem && rawDataItem.visualMap === false) {
	        continue;
	      }
	
	      var value = dim != null ? data.get(dim, dataIndex, true) : dataIndex;
	      var valueState = getValueState(value);
	      var mappings = visualMappings[valueState];
	      var visualTypes = visualTypesMap[valueState];
	
	      for (var i = 0, len = visualTypes.length; i < len; i++) {
	        var type = visualTypes[i];
	        mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
	      }
	    }
	  }
	
	  return {
	    progress: progress
	  };
	}
	
	exports.createVisualMappings = createVisualMappings;
	exports.replaceVisualOption = replaceVisualOption;
	exports.applyVisual = applyVisual;
	exports.incrementalApplyVisual = incrementalApplyVisual;

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dontSetMe = dontSetMe;
	exports.findInArray = findInArray;
	exports.int = int;
	exports.isFunction = isFunction;
	exports.isNum = isNum;
	
	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array
	/*: Array<any> | TouchList*/
	, callback
	/*: Function*/
	)
	/*: any*/
	{
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}
	
	function isFunction(func
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  // $FlowIgnore[method-unbinding]
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}
	
	function isNum(num
	/*: any*/
	)
	/*: boolean %checks*/
	{
	  return typeof num === 'number' && !isNaN(num);
	}
	
	function int(a
	/*: string*/
	)
	/*: number*/
	{
	  return parseInt(a, 10);
	}
	
	function dontSetMe(props
	/*: Object*/
	, propName
	/*: string*/
	, componentName
	/*: string*/
	)
	/*: ?Error*/
	{
	  if (props[propName]) {
	    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
	  }
	}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1606);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js?modules!./Draft.css", function() {
				var newContent = require("!!../../css-loader/index.js?modules!./Draft.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	var dpr = 1; // If in browser environment
	
	if (typeof window !== 'undefined') {
	  dpr = Math.max(window.devicePixelRatio || 1, 1);
	}
	/**
	 * config默认配置项
	 * @exports zrender/config
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 */
	
	/**
	 * Debug log mode:
	 * 0: Do nothing, for release.
	 * 1: console.error, for debug.
	 */
	
	
	var debugMode = 0; // retina 屏幕优化
	
	var devicePixelRatio = dpr;
	exports.debugMode = debugMode;
	exports.devicePixelRatio = devicePixelRatio;

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	/**
	 * @param {Array.<Object>} colorStops
	 */
	var Gradient = function (colorStops) {
	  this.colorStops = colorStops || [];
	};
	
	Gradient.prototype = {
	  constructor: Gradient,
	  addColorStop: function (offset, color) {
	    this.colorStops.push({
	      offset: offset,
	      color: color
	    });
	  }
	};
	var _default = Gradient;
	module.exports = _default;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	var ContextCachedBy = {
	  NONE: 0,
	  STYLE_BIND: 1,
	  PLAIN_TEXT: 2
	}; // Avoid confused with 0/false.
	
	var WILL_BE_RESTORED = 9;
	exports.ContextCachedBy = ContextCachedBy;
	exports.WILL_BE_RESTORED = WILL_BE_RESTORED;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(2);
	
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var each = _util.each;
	var normalizeCssArray = _util.normalizeCssArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	
	var textContain = __webpack_require__(86);
	
	var roundRectHelper = __webpack_require__(909);
	
	var imageHelper = __webpack_require__(450);
	
	var fixShadow = __webpack_require__(907);
	
	var _constant = __webpack_require__(282);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	var DEFAULT_FONT = textContain.DEFAULT_FONT; // TODO: Have not support 'start', 'end' yet.
	
	var VALID_TEXT_ALIGN = {
	  left: 1,
	  right: 1,
	  center: 1
	};
	var VALID_TEXT_VERTICAL_ALIGN = {
	  top: 1,
	  bottom: 1,
	  middle: 1
	}; // Different from `STYLE_COMMON_PROPS` of `graphic/Style`,
	// the default value of shadowColor is `'transparent'`.
	
	var SHADOW_STYLE_COMMON_PROPS = [['textShadowBlur', 'shadowBlur', 0], ['textShadowOffsetX', 'shadowOffsetX', 0], ['textShadowOffsetY', 'shadowOffsetY', 0], ['textShadowColor', 'shadowColor', 'transparent']];
	var _tmpTextPositionResult = {};
	var _tmpBoxPositionResult = {};
	/**
	 * @param {module:zrender/graphic/Style} style
	 * @return {module:zrender/graphic/Style} The input style.
	 */
	
	function normalizeTextStyle(style) {
	  normalizeStyle(style);
	  each(style.rich, normalizeStyle);
	  return style;
	}
	
	function normalizeStyle(style) {
	  if (style) {
	    style.font = textContain.makeFont(style);
	    var textAlign = style.textAlign;
	    textAlign === 'middle' && (textAlign = 'center');
	    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.
	
	    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
	    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
	    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
	    var textPadding = style.textPadding;
	
	    if (textPadding) {
	      style.textPadding = normalizeCssArray(style.textPadding);
	    }
	  }
	}
	/**
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {string} text
	 * @param {module:zrender/graphic/Style} style
	 * @param {Object|boolean} [rect] {x, y, width, height}
	 *                  If set false, rect text is not used.
	 * @param {Element|module:zrender/graphic/helper/constant.WILL_BE_RESTORED} [prevEl] For ctx prop cache.
	 */
	
	
	function renderText(hostEl, ctx, text, style, rect, prevEl) {
	  style.rich ? renderRichText(hostEl, ctx, text, style, rect, prevEl) : renderPlainText(hostEl, ctx, text, style, rect, prevEl);
	} // Avoid setting to ctx according to prevEl if possible for
	// performance in scenarios of large amount text.
	
	
	function renderPlainText(hostEl, ctx, text, style, rect, prevEl) {
	  'use strict';
	
	  var needDrawBg = needDrawBackground(style);
	  var prevStyle;
	  var checkCache = false;
	  var cachedByMe = ctx.__attrCachedBy === ContextCachedBy.PLAIN_TEXT; // Only take and check cache for `Text` el, but not RectText.
	
	  if (prevEl !== WILL_BE_RESTORED) {
	    if (prevEl) {
	      prevStyle = prevEl.style;
	      checkCache = !needDrawBg && cachedByMe && prevStyle;
	    } // Prevent from using cache in `Style::bind`, because of the case:
	    // ctx property is modified by other properties than `Style::bind`
	    // used, and Style::bind is called next.
	
	
	    ctx.__attrCachedBy = needDrawBg ? ContextCachedBy.NONE : ContextCachedBy.PLAIN_TEXT;
	  } // Since this will be restored, prevent from using these props to check cache in the next
	  // entering of this method. But do not need to clear other cache like `Style::bind`.
	  else if (cachedByMe) {
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	    }
	
	  var styleFont = style.font || DEFAULT_FONT; // PENDING
	  // Only `Text` el set `font` and keep it (`RectText` will restore). So theoretically
	  // we can make font cache on ctx, which can cache for text el that are discontinuous.
	  // But layer save/restore needed to be considered.
	  // if (styleFont !== ctx.__fontCache) {
	  //     ctx.font = styleFont;
	  //     if (prevEl !== WILL_BE_RESTORED) {
	  //         ctx.__fontCache = styleFont;
	  //     }
	  // }
	
	  if (!checkCache || styleFont !== (prevStyle.font || DEFAULT_FONT)) {
	    ctx.font = styleFont;
	  } // Use the final font from context-2d, because the final
	  // font might not be the style.font when it is illegal.
	  // But get `ctx.font` might be time consuming.
	
	
	  var computedFont = hostEl.__computedFont;
	
	  if (hostEl.__styleFont !== styleFont) {
	    hostEl.__styleFont = styleFont;
	    computedFont = hostEl.__computedFont = ctx.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var textLines = contentBlock.lines;
	  var lineHeight = contentBlock.lineHeight;
	  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign || 'left';
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY;
	
	  if (needDrawBg || textPadding) {
	    // Consider performance, do not call getTextWidth util necessary.
	    var textWidth = textContain.getWidth(text, computedFont);
	    var outerWidth = textWidth;
	    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
	    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	    if (textPadding) {
	      textX = getTextXForPadding(baseX, textAlign, textPadding);
	      textY += textPadding[0];
	    }
	  } // Always set textAlign and textBase line, because it is difficute to calculate
	  // textAlign from prevEl, and we dont sure whether textAlign will be reset if
	  // font set happened.
	
	
	  ctx.textAlign = textAlign; // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  ctx.textBaseline = 'middle'; // Set text opacity
	
	  ctx.globalAlpha = style.opacity || 1; // Always set shadowBlur and shadowOffset to avoid leak from displayable.
	
	  for (var i = 0; i < SHADOW_STYLE_COMMON_PROPS.length; i++) {
	    var propItem = SHADOW_STYLE_COMMON_PROPS[i];
	    var styleProp = propItem[0];
	    var ctxProp = propItem[1];
	    var val = style[styleProp];
	
	    if (!checkCache || val !== prevStyle[styleProp]) {
	      ctx[ctxProp] = fixShadow(ctx, ctxProp, val || propItem[2]);
	    }
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  var textStrokeWidth = style.textStrokeWidth;
	  var textStrokeWidthPrev = checkCache ? prevStyle.textStrokeWidth : null;
	  var strokeWidthChanged = !checkCache || textStrokeWidth !== textStrokeWidthPrev;
	  var strokeChanged = !checkCache || strokeWidthChanged || style.textStroke !== prevStyle.textStroke;
	  var textStroke = getStroke(style.textStroke, textStrokeWidth);
	  var textFill = getFill(style.textFill);
	
	  if (textStroke) {
	    if (strokeWidthChanged) {
	      ctx.lineWidth = textStrokeWidth;
	    }
	
	    if (strokeChanged) {
	      ctx.strokeStyle = textStroke;
	    }
	  }
	
	  if (textFill) {
	    if (!checkCache || style.textFill !== prevStyle.textFill) {
	      ctx.fillStyle = textFill;
	    }
	  } // Optimize simply, in most cases only one line exists.
	
	
	  if (textLines.length === 1) {
	    // Fill after stroke so the outline will not cover the main part.
	    textStroke && ctx.strokeText(textLines[0], textX, textY);
	    textFill && ctx.fillText(textLines[0], textX, textY);
	  } else {
	    for (var i = 0; i < textLines.length; i++) {
	      // Fill after stroke so the outline will not cover the main part.
	      textStroke && ctx.strokeText(textLines[i], textX, textY);
	      textFill && ctx.fillText(textLines[i], textX, textY);
	      textY += lineHeight;
	    }
	  }
	}
	
	function renderRichText(hostEl, ctx, text, style, rect, prevEl) {
	  // Do not do cache for rich text because of the complexity.
	  // But `RectText` this will be restored, do not need to clear other cache like `Style::bind`.
	  if (prevEl !== WILL_BE_RESTORED) {
	    ctx.__attrCachedBy = ContextCachedBy.NONE;
	  }
	
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
	  }
	
	  drawRichText(hostEl, ctx, contentBlock, style, rect);
	}
	
	function drawRichText(hostEl, ctx, contentBlock, style, rect) {
	  var contentWidth = contentBlock.width;
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var textPadding = style.textPadding;
	  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign;
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var xLeft = boxX;
	  var lineTop = boxY;
	
	  if (textPadding) {
	    xLeft += textPadding[3];
	    lineTop += textPadding[0];
	  }
	
	  var xRight = xLeft + contentWidth;
	  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	  for (var i = 0; i < contentBlock.lines.length; i++) {
	    var line = contentBlock.lines[i];
	    var tokens = line.tokens;
	    var tokenCount = tokens.length;
	    var lineHeight = line.lineHeight;
	    var usedWidth = line.width;
	    var leftIndex = 0;
	    var lineXLeft = xLeft;
	    var lineXRight = xRight;
	    var rightIndex = tokenCount - 1;
	    var token;
	
	    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
	      usedWidth -= token.width;
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
	      usedWidth -= token.width;
	      lineXRight -= token.width;
	      rightIndex--;
	    } // The other tokens are placed as textAlign 'center' if there is enough space.
	
	
	    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;
	
	    while (leftIndex <= rightIndex) {
	      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.
	
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    lineTop += lineHeight;
	  }
	}
	
	function applyTextRotation(ctx, style, rect, x, y) {
	  // textRotation only apply in RectText.
	  if (rect && style.textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      x = rect.width / 2 + rect.x;
	      y = rect.height / 2 + rect.y;
	    } else if (origin) {
	      x = origin[0] + rect.x;
	      y = origin[1] + rect.y;
	    }
	
	    ctx.translate(x, y); // Positive: anticlockwise
	
	    ctx.rotate(-style.textRotation);
	    ctx.translate(-x, -y);
	  }
	}
	
	function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
	  var tokenStyle = style.rich[token.styleName] || {};
	  tokenStyle.text = token.text; // 'ctx.textBaseline' is always set as 'middle', for sake of
	  // the bias of "Microsoft YaHei".
	
	  var textVerticalAlign = token.textVerticalAlign;
	  var y = lineTop + lineHeight / 2;
	
	  if (textVerticalAlign === 'top') {
	    y = lineTop + token.height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y = lineTop + lineHeight - token.height / 2;
	  }
	
	  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
	  var textPadding = token.textPadding;
	
	  if (textPadding) {
	    x = getTextXForPadding(x, textAlign, textPadding);
	    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
	  }
	
	  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
	  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
	  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
	  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  setCtx(ctx, 'textBaseline', 'middle');
	  setCtx(ctx, 'font', token.font || DEFAULT_FONT);
	  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
	  var textFill = getFill(tokenStyle.textFill || style.textFill);
	  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.
	
	  if (textStroke) {
	    setCtx(ctx, 'lineWidth', textStrokeWidth);
	    setCtx(ctx, 'strokeStyle', textStroke);
	    ctx.strokeText(token.text, x, y);
	  }
	
	  if (textFill) {
	    setCtx(ctx, 'fillStyle', textFill);
	    ctx.fillText(token.text, x, y);
	  }
	}
	
	function needDrawBackground(style) {
	  return !!(style.textBackgroundColor || style.textBorderWidth && style.textBorderColor);
	} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius, text}
	// shape: {x, y, width, height}
	
	
	function drawBackground(hostEl, ctx, style, x, y, width, height) {
	  var textBackgroundColor = style.textBackgroundColor;
	  var textBorderWidth = style.textBorderWidth;
	  var textBorderColor = style.textBorderColor;
	  var isPlainBg = isString(textBackgroundColor);
	  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
	  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
	  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);
	
	  if (isPlainBg || textBorderWidth && textBorderColor) {
	    ctx.beginPath();
	    var textBorderRadius = style.textBorderRadius;
	
	    if (!textBorderRadius) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        r: textBorderRadius
	      });
	    }
	
	    ctx.closePath();
	  }
	
	  if (isPlainBg) {
	    setCtx(ctx, 'fillStyle', textBackgroundColor);
	
	    if (style.fillOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.fillOpacity * style.opacity;
	      ctx.fill();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.fill();
	    }
	  } else if (isObject(textBackgroundColor)) {
	    var image = textBackgroundColor.image;
	    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);
	
	    if (image && imageHelper.isImageReady(image)) {
	      ctx.drawImage(image, x, y, width, height);
	    }
	  }
	
	  if (textBorderWidth && textBorderColor) {
	    setCtx(ctx, 'lineWidth', textBorderWidth);
	    setCtx(ctx, 'strokeStyle', textBorderColor);
	
	    if (style.strokeOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.strokeOpacity * style.opacity;
	      ctx.stroke();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.stroke();
	    }
	  }
	}
	
	function onBgImageLoaded(image, textBackgroundColor) {
	  // Replace image, so that `contain/text.js#parseRichText`
	  // will get correct result in next tick.
	  textBackgroundColor.image = image;
	}
	
	function getBoxPosition(out, hostEl, style, rect) {
	  var baseX = style.x || 0;
	  var baseY = style.y || 0;
	  var textAlign = style.textAlign;
	  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord
	
	  if (rect) {
	    var textPosition = style.textPosition;
	
	    if (textPosition instanceof Array) {
	      // Percent
	      baseX = rect.x + parsePercent(textPosition[0], rect.width);
	      baseY = rect.y + parsePercent(textPosition[1], rect.height);
	    } else {
	      var res = hostEl && hostEl.calculateTextPosition ? hostEl.calculateTextPosition(_tmpTextPositionResult, style, rect) : textContain.calculateTextPosition(_tmpTextPositionResult, style, rect);
	      baseX = res.x;
	      baseY = res.y; // Default align and baseline when has textPosition
	
	      textAlign = textAlign || res.textAlign;
	      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
	    } // textOffset is only support in RectText, otherwise
	    // we have to adjust boundingRect for textOffset.
	
	
	    var textOffset = style.textOffset;
	
	    if (textOffset) {
	      baseX += textOffset[0];
	      baseY += textOffset[1];
	    }
	  }
	
	  out = out || {};
	  out.baseX = baseX;
	  out.baseY = baseY;
	  out.textAlign = textAlign;
	  out.textVerticalAlign = textVerticalAlign;
	  return out;
	}
	
	function setCtx(ctx, prop, value) {
	  ctx[prop] = fixShadow(ctx, prop, value);
	  return ctx[prop];
	}
	/**
	 * @param {string} [stroke] If specified, do not check style.textStroke.
	 * @param {string} [lineWidth] If specified, do not check style.textStroke.
	 * @param {number} style
	 */
	
	
	function getStroke(stroke, lineWidth) {
	  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
	  : stroke.image || stroke.colorStops ? '#000' : stroke;
	}
	
	function getFill(fill) {
	  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
	  : fill.image || fill.colorStops ? '#000' : fill;
	}
	
	function parsePercent(value, maxValue) {
	  if (typeof value === 'string') {
	    if (value.lastIndexOf('%') >= 0) {
	      return parseFloat(value) / 100 * maxValue;
	    }
	
	    return parseFloat(value);
	  }
	
	  return value;
	}
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	/**
	 * @param {string} text
	 * @param {module:zrender/Style} style
	 * @return {boolean}
	 */
	
	
	function needDrawText(text, style) {
	  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
	}
	
	exports.normalizeTextStyle = normalizeTextStyle;
	exports.renderText = renderText;
	exports.getBoxPosition = getBoxPosition;
	exports.getStroke = getStroke;
	exports.getFill = getFill;
	exports.parsePercent = parsePercent;
	exports.needDrawText = needDrawText;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var matrix = __webpack_require__(75);
	
	var vector = __webpack_require__(49);
	
	/**
	 * 提供变换扩展
	 * @module zrender/mixin/Transformable
	 * @author pissang (https://www.github.com/pissang)
	 */
	var mIdentity = matrix.identity;
	var EPSILON = 5e-5;
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * @alias module:zrender/mixin/Transformable
	 * @constructor
	 */
	
	
	var Transformable = function (opts) {
	  opts = opts || {}; // If there are no given position, rotation, scale
	
	  if (!opts.position) {
	    /**
	     * 平移
	     * @type {Array.<number>}
	     * @default [0, 0]
	     */
	    this.position = [0, 0];
	  }
	
	  if (opts.rotation == null) {
	    /**
	     * 旋转
	     * @type {Array.<number>}
	     * @default 0
	     */
	    this.rotation = 0;
	  }
	
	  if (!opts.scale) {
	    /**
	     * 缩放
	     * @type {Array.<number>}
	     * @default [1, 1]
	     */
	    this.scale = [1, 1];
	  }
	  /**
	   * 旋转和缩放的原点
	   * @type {Array.<number>}
	   * @default null
	   */
	
	
	  this.origin = this.origin || null;
	};
	
	var transformableProto = Transformable.prototype;
	transformableProto.transform = null;
	/**
	 * 判断是否需要有坐标变换
	 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
	 */
	
	transformableProto.needLocalTransform = function () {
	  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
	};
	
	var scaleTmp = [];
	
	transformableProto.updateTransform = function () {
	  var parent = this.parent;
	  var parentHasTransform = parent && parent.transform;
	  var needLocalTransform = this.needLocalTransform();
	  var m = this.transform;
	
	  if (!(needLocalTransform || parentHasTransform)) {
	    m && mIdentity(m);
	    return;
	  }
	
	  m = m || matrix.create();
	
	  if (needLocalTransform) {
	    this.getLocalTransform(m);
	  } else {
	    mIdentity(m);
	  } // 应用父节点变换
	
	
	  if (parentHasTransform) {
	    if (needLocalTransform) {
	      matrix.mul(m, parent.transform, m);
	    } else {
	      matrix.copy(m, parent.transform);
	    }
	  } // 保存这个变换矩阵
	
	
	  this.transform = m;
	  var globalScaleRatio = this.globalScaleRatio;
	
	  if (globalScaleRatio != null && globalScaleRatio !== 1) {
	    this.getGlobalScale(scaleTmp);
	    var relX = scaleTmp[0] < 0 ? -1 : 1;
	    var relY = scaleTmp[1] < 0 ? -1 : 1;
	    var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
	    var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
	    m[0] *= sx;
	    m[1] *= sx;
	    m[2] *= sy;
	    m[3] *= sy;
	  }
	
	  this.invTransform = this.invTransform || matrix.create();
	  matrix.invert(this.invTransform, m);
	};
	
	transformableProto.getLocalTransform = function (m) {
	  return Transformable.getLocalTransform(this, m);
	};
	/**
	 * 将自己的transform应用到context上
	 * @param {CanvasRenderingContext2D} ctx
	 */
	
	
	transformableProto.setTransform = function (ctx) {
	  var m = this.transform;
	  var dpr = ctx.dpr || 1;
	
	  if (m) {
	    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
	  } else {
	    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	  }
	};
	
	transformableProto.restoreTransform = function (ctx) {
	  var dpr = ctx.dpr || 1;
	  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	};
	
	var tmpTransform = [];
	var originTransform = matrix.create();
	
	transformableProto.setLocalTransform = function (m) {
	  if (!m) {
	    // TODO return or set identity?
	    return;
	  }
	
	  var sx = m[0] * m[0] + m[1] * m[1];
	  var sy = m[2] * m[2] + m[3] * m[3];
	  var position = this.position;
	  var scale = this.scale;
	
	  if (isNotAroundZero(sx - 1)) {
	    sx = Math.sqrt(sx);
	  }
	
	  if (isNotAroundZero(sy - 1)) {
	    sy = Math.sqrt(sy);
	  }
	
	  if (m[0] < 0) {
	    sx = -sx;
	  }
	
	  if (m[3] < 0) {
	    sy = -sy;
	  }
	
	  position[0] = m[4];
	  position[1] = m[5];
	  scale[0] = sx;
	  scale[1] = sy;
	  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
	};
	/**
	 * 分解`transform`矩阵到`position`, `rotation`, `scale`
	 */
	
	
	transformableProto.decomposeTransform = function () {
	  if (!this.transform) {
	    return;
	  }
	
	  var parent = this.parent;
	  var m = this.transform;
	
	  if (parent && parent.transform) {
	    // Get local transform and decompose them to position, scale, rotation
	    matrix.mul(tmpTransform, parent.invTransform, m);
	    m = tmpTransform;
	  }
	
	  var origin = this.origin;
	
	  if (origin && (origin[0] || origin[1])) {
	    originTransform[4] = origin[0];
	    originTransform[5] = origin[1];
	    matrix.mul(tmpTransform, m, originTransform);
	    tmpTransform[4] -= origin[0];
	    tmpTransform[5] -= origin[1];
	    m = tmpTransform;
	  }
	
	  this.setLocalTransform(m);
	};
	/**
	 * Get global scale
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.getGlobalScale = function (out) {
	  var m = this.transform;
	  out = out || [];
	
	  if (!m) {
	    out[0] = 1;
	    out[1] = 1;
	    return out;
	  }
	
	  out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
	  out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
	
	  if (m[0] < 0) {
	    out[0] = -out[0];
	  }
	
	  if (m[3] < 0) {
	    out[1] = -out[1];
	  }
	
	  return out;
	};
	/**
	 * 变换坐标位置到 shape 的局部坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToLocal = function (x, y) {
	  var v2 = [x, y];
	  var invTransform = this.invTransform;
	
	  if (invTransform) {
	    vector.applyTransform(v2, v2, invTransform);
	  }
	
	  return v2;
	};
	/**
	 * 变换局部坐标位置到全局坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToGlobal = function (x, y) {
	  var v2 = [x, y];
	  var transform = this.transform;
	
	  if (transform) {
	    vector.applyTransform(v2, v2, transform);
	  }
	
	  return v2;
	};
	/**
	 * @static
	 * @param {Object} target
	 * @param {Array.<number>} target.origin
	 * @param {number} target.rotation
	 * @param {Array.<number>} target.position
	 * @param {Array.<number>} [m]
	 */
	
	
	Transformable.getLocalTransform = function (target, m) {
	  m = m || [];
	  mIdentity(m);
	  var origin = target.origin;
	  var scale = target.scale || [1, 1];
	  var rotation = target.rotation || 0;
	  var position = target.position || [0, 0];
	
	  if (origin) {
	    // Translate to origin
	    m[4] -= origin[0];
	    m[5] -= origin[1];
	  }
	
	  matrix.scale(m, m, scale);
	
	  if (rotation) {
	    matrix.rotate(m, m, rotation);
	  }
	
	  if (origin) {
	    // Translate back from origin
	    m[4] += origin[0];
	    m[5] += origin[1];
	  }
	
	  m[4] += position[0];
	  m[5] += position[1];
	  return m;
	};
	
	var _default = Transformable;
	module.exports = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(904);
	
	var env = __webpack_require__(58);
	
	var zrUtil = __webpack_require__(2);
	
	var Handler = __webpack_require__(2056);
	
	var Storage = __webpack_require__(2059);
	
	var Painter = __webpack_require__(2058);
	
	var Animation = __webpack_require__(2060);
	
	var HandlerProxy = __webpack_require__(2069);
	
	/*!
	* ZRender, a high performance 2d drawing library.
	*
	* Copyright (c) 2013, Baidu Inc.
	* All rights reserved.
	*
	* LICENSE
	* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
	*/
	var useVML = !env.canvasSupported;
	var painterCtors = {
	  canvas: Painter
	};
	var instances = {}; // ZRender实例map索引
	
	/**
	 * @type {string}
	 */
	
	var version = '4.3.2';
	/**
	 * Initializing a zrender instance
	 * @param {HTMLElement} dom
	 * @param {Object} [opts]
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @return {module:zrender/ZRender}
	 */
	
	function init(dom, opts) {
	  var zr = new ZRender(guid(), dom, opts);
	  instances[zr.id] = zr;
	  return zr;
	}
	/**
	 * Dispose zrender instance
	 * @param {module:zrender/ZRender} zr
	 */
	
	
	function dispose(zr) {
	  if (zr) {
	    zr.dispose();
	  } else {
	    for (var key in instances) {
	      if (instances.hasOwnProperty(key)) {
	        instances[key].dispose();
	      }
	    }
	
	    instances = {};
	  }
	
	  return this;
	}
	/**
	 * Get zrender instance by id
	 * @param {string} id zrender instance id
	 * @return {module:zrender/ZRender}
	 */
	
	
	function getInstance(id) {
	  return instances[id];
	}
	
	function registerPainter(name, Ctor) {
	  painterCtors[name] = Ctor;
	}
	
	function delInstance(id) {
	  delete instances[id];
	}
	/**
	 * @module zrender/ZRender
	 */
	
	/**
	 * @constructor
	 * @alias module:zrender/ZRender
	 * @param {string} id
	 * @param {HTMLElement} dom
	 * @param {Object} opts
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 */
	
	
	var ZRender = function (id, dom, opts) {
	  opts = opts || {};
	  /**
	   * @type {HTMLDomElement}
	   */
	
	  this.dom = dom;
	  /**
	   * @type {string}
	   */
	
	  this.id = id;
	  var self = this;
	  var storage = new Storage();
	  var rendererType = opts.renderer; // TODO WebGL
	
	  if (useVML) {
	    if (!painterCtors.vml) {
	      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
	    }
	
	    rendererType = 'vml';
	  } else if (!rendererType || !painterCtors[rendererType]) {
	    rendererType = 'canvas';
	  }
	
	  var painter = new painterCtors[rendererType](dom, storage, opts, id);
	  this.storage = storage;
	  this.painter = painter;
	  var handerProxy = !env.node && !env.worker ? new HandlerProxy(painter.getViewportRoot(), painter.root) : null;
	  this.handler = new Handler(storage, painter, handerProxy, painter.root);
	  /**
	   * @type {module:zrender/animation/Animation}
	   */
	
	  this.animation = new Animation({
	    stage: {
	      update: zrUtil.bind(this.flush, this)
	    }
	  });
	  this.animation.start();
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
	  // FIXME 有点ugly
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	    el && el.removeSelfFromZr(self);
	  };
	
	  storage.addToStorage = function (el) {
	    oldAddToStorage.call(storage, el);
	    el.addSelfToZr(self);
	  };
	};
	
	ZRender.prototype = {
	  constructor: ZRender,
	
	  /**
	   * 获取实例唯一标识
	   * @return {string}
	   */
	  getId: function () {
	    return this.id;
	  },
	
	  /**
	   * 添加元素
	   * @param  {module:zrender/Element} el
	   */
	  add: function (el) {
	    this.storage.addRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * 删除元素
	   * @param  {module:zrender/Element} el
	   */
	  remove: function (el) {
	    this.storage.delRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Change configuration of layer
	   * @param {string} zLevel
	   * @param {Object} config
	   * @param {string} [config.clearColor=0] Clear color
	   * @param {string} [config.motionBlur=false] If enable motion blur
	   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
	  */
	  configLayer: function (zLevel, config) {
	    if (this.painter.configLayer) {
	      this.painter.configLayer(zLevel, config);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Set background color
	   * @param {string} backgroundColor
	   */
	  setBackgroundColor: function (backgroundColor) {
	    if (this.painter.setBackgroundColor) {
	      this.painter.setBackgroundColor(backgroundColor);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Repaint the canvas immediately
	   */
	  refreshImmediately: function () {
	    // var start = new Date();
	    // Clear needsRefresh ahead to avoid something wrong happens in refresh
	    // Or it will cause zrender refreshes again and again.
	    this._needsRefresh = this._needsRefreshHover = false;
	    this.painter.refresh(); // Avoid trigger zr.refresh in Element#beforeUpdate hook
	
	    this._needsRefresh = this._needsRefreshHover = false; // var end = new Date();
	    // var log = document.getElementById('log');
	    // if (log) {
	    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
	    // }
	  },
	
	  /**
	   * Mark and repaint the canvas in the next frame of browser
	   */
	  refresh: function () {
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Perform all refresh
	   */
	  flush: function () {
	    var triggerRendered;
	
	    if (this._needsRefresh) {
	      triggerRendered = true;
	      this.refreshImmediately();
	    }
	
	    if (this._needsRefreshHover) {
	      triggerRendered = true;
	      this.refreshHoverImmediately();
	    }
	
	    triggerRendered && this.trigger('rendered');
	  },
	
	  /**
	   * Add element to hover layer
	   * @param  {module:zrender/Element} el
	   * @param {Object} style
	   */
	  addHover: function (el, style) {
	    if (this.painter.addHover) {
	      var elMirror = this.painter.addHover(el, style);
	      this.refreshHover();
	      return elMirror;
	    }
	  },
	
	  /**
	   * Add element from hover layer
	   * @param  {module:zrender/Element} el
	   */
	  removeHover: function (el) {
	    if (this.painter.removeHover) {
	      this.painter.removeHover(el);
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Clear all hover elements in hover layer
	   * @param  {module:zrender/Element} el
	   */
	  clearHover: function () {
	    if (this.painter.clearHover) {
	      this.painter.clearHover();
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Refresh hover in next frame
	   */
	  refreshHover: function () {
	    this._needsRefreshHover = true;
	  },
	
	  /**
	   * Refresh hover immediately
	   */
	  refreshHoverImmediately: function () {
	    this._needsRefreshHover = false;
	    this.painter.refreshHover && this.painter.refreshHover();
	  },
	
	  /**
	   * Resize the canvas.
	   * Should be invoked when container size is changed
	   * @param {Object} [opts]
	   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	   */
	  resize: function (opts) {
	    opts = opts || {};
	    this.painter.resize(opts.width, opts.height);
	    this.handler.resize();
	  },
	
	  /**
	   * Stop and clear all animation immediately
	   */
	  clearAnimation: function () {
	    this.animation.clear();
	  },
	
	  /**
	   * Get container width
	   */
	  getWidth: function () {
	    return this.painter.getWidth();
	  },
	
	  /**
	   * Get container height
	   */
	  getHeight: function () {
	    return this.painter.getHeight();
	  },
	
	  /**
	   * Export the canvas as Base64 URL
	   * @param {string} type
	   * @param {string} [backgroundColor='#fff']
	   * @return {string} Base64 URL
	   */
	  // toDataURL: function(type, backgroundColor) {
	  //     return this.painter.getRenderedCanvas({
	  //         backgroundColor: backgroundColor
	  //     }).toDataURL(type);
	  // },
	
	  /**
	   * Converting a path to image.
	   * It has much better performance of drawing image rather than drawing a vector path.
	   * @param {module:zrender/graphic/Path} e
	   * @param {number} width
	   * @param {number} height
	   */
	  pathToImage: function (e, dpr) {
	    return this.painter.pathToImage(e, dpr);
	  },
	
	  /**
	   * Set default cursor
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    this.handler.setCursorStyle(cursorStyle);
	  },
	
	  /**
	   * Find hovered element
	   * @param {number} x
	   * @param {number} y
	   * @return {Object} {target, topTarget}
	   */
	  findHover: function (x, y) {
	    return this.handler.findHover(x, y);
	  },
	
	  /**
	   * Bind event
	   *
	   * @param {string} eventName Event name
	   * @param {Function} eventHandler Handler function
	   * @param {Object} [context] Context object
	   */
	  on: function (eventName, eventHandler, context) {
	    this.handler.on(eventName, eventHandler, context);
	  },
	
	  /**
	   * Unbind event
	   * @param {string} eventName Event name
	   * @param {Function} [eventHandler] Handler function
	   */
	  off: function (eventName, eventHandler) {
	    this.handler.off(eventName, eventHandler);
	  },
	
	  /**
	   * Trigger event manually
	   *
	   * @param {string} eventName Event name
	   * @param {event=} event Event object
	   */
	  trigger: function (eventName, event) {
	    this.handler.trigger(eventName, event);
	  },
	
	  /**
	   * Clear all objects and the canvas.
	   */
	  clear: function () {
	    this.storage.delRoot();
	    this.painter.clear();
	  },
	
	  /**
	   * Dispose self.
	   */
	  dispose: function () {
	    this.animation.stop();
	    this.clear();
	    this.storage.dispose();
	    this.painter.dispose();
	    this.handler.dispose();
	    this.animation = this.storage = this.painter = this.handler = null;
	    delInstance(this.id);
	  }
	};
	exports.version = version;
	exports.init = init;
	exports.dispose = dispose;
	exports.getInstance = getInstance;
	exports.registerPainter = registerPainter;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1037);

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(216);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainMenu = exports.saveLastVisitRoute = exports.menusForEach = exports.addNewPath = undefined;
	
	var _UIEditor = __webpack_require__(997);
	
	var _UIPreview = __webpack_require__(998);
	
	var _Login = __webpack_require__(958);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _indexPage = __webpack_require__(970);
	
	var _indexPage2 = _interopRequireDefault(_indexPage);
	
	var _MainIndex = __webpack_require__(961);
	
	var _MainIndex2 = _interopRequireDefault(_MainIndex);
	
	var _ModifyUserInfo = __webpack_require__(963);
	
	var _ModifyUserInfo2 = _interopRequireDefault(_ModifyUserInfo);
	
	var _ModifyPassword = __webpack_require__(962);
	
	var _ModifyPassword2 = _interopRequireDefault(_ModifyPassword);
	
	var _ParamMngPrmDef = __webpack_require__(989);
	
	var _ParamMngPrmDef2 = _interopRequireDefault(_ParamMngPrmDef);
	
	var _CustQueryCondition = __webpack_require__(987);
	
	var _CustQueryCondition2 = _interopRequireDefault(_CustQueryCondition);
	
	var _CustAdvanceQuery = __webpack_require__(986);
	
	var _CustAdvanceQuery2 = _interopRequireDefault(_CustAdvanceQuery);
	
	var _ParamMngDef = __webpack_require__(523);
	
	var _ParamMngDef2 = _interopRequireDefault(_ParamMngDef);
	
	var _ParamMngDefDisplay = __webpack_require__(988);
	
	var _ParamMngDefDisplay2 = _interopRequireDefault(_ParamMngDefDisplay);
	
	var _FirstLoginChgPwd = __webpack_require__(956);
	
	var _FirstLoginChgPwd2 = _interopRequireDefault(_FirstLoginChgPwd);
	
	var _HelpDoc = __webpack_require__(960);
	
	var _HelpDoc2 = _interopRequireDefault(_HelpDoc);
	
	var _LockPage = __webpack_require__(955);
	
	var _LockPage2 = _interopRequireDefault(_LockPage);
	
	var _index = __webpack_require__(992);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(951);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(953);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//修改信息
	//首页布局
	var MainMenu = [];
	
	//显示在content内
	//首次登陆修改密码
	//修改密码
	//首页默认内容页
	//登录页
	var noMenulist = [
	  // { path: '/main/paramMngPrmDef', component: ParamMngPrmDef },
	  // { path: '/main/CustQueryCondition', component: CustQueryCondition },
	  // { path: '/main/custAdvanceQuery', component: CustAdvanceQuery },
	  // { path: '/main/ParamMngDef', component: ParamMngDef },
	  // { path: '/main/ParamMngDefDisplay', component: ParamMngDefDisplay },
	];
	noMenulist.forEach(function (item) {
	  MainMenu.push(item);
	});
	
	var menusForEach = function menusForEach(menus) {
	  menus.forEach(function (item) {
	    if (item.children) {
	      menusForEach(item.children);
	    } else {
	      if (item.uid) {
	        MainMenu.push({ path: item.routeParam, component: _UIPreview.UIPreview });
	      }
	    }
	  });
	};
	
	var saveLastVisitRoute = function saveLastVisitRoute(item) {
	  var value = escape(JSON.stringify(item));
	  tool.sgiStorage.set("LastVisitRoute", value);
	};
	
	var getLastVisitRoute = function getLastVisitRoute() {
	  var lvr = unescape(tool.sgiStorage.get("LastVisitRoute"));
	  if (lvr == "undefined") {
	    return;
	  }
	  var item = JSON.parse(lvr);
	  if (item) {
	    menusForEach([item]);
	  }
	};
	
	var addNewPath = function addNewPath(path) {
	  MainMenu.push({ path: path, component: _UIPreview.UIPreview });
	};
	
	// menusForEach(menus);
	getLastVisitRoute();
	
	MainMenu.push({ path: "/dev/uiEditor", component: _UIEditor.UIEditor });
	MainMenu.push({ path: "/dev/uiPreview", component: _UIPreview.UIPreview });
	MainMenu.push({ path: "/main/ModifyUserInfo", component: _ModifyPassword2.default });
	MainMenu.push({ path: "/main/FlowChart", component: _index6.default });
	//MainMenu.push({ path: "/pages/ChangePassword/index", component: ChangePassword });
	
	
	//显示在整个页面
	var routes = [{
	  path: "/HelpDoc",
	  component: _HelpDoc2.default
	}, {
	  path: "/FirstLoginChgPwd",
	  component: _FirstLoginChgPwd2.default
	},
	
	// {
	//   path: "/ModifyPassword",
	//   component: ModifyPassword,
	// },
	{
	  path: "/ModifyUserInfo",
	  component: _ModifyUserInfo2.default
	}, {
	  path: "/UIPreview",
	  component: _UIPreview.UIPreview
	},
	// {
	//   path: "/",
	//   component: indexPage,
	// },
	{
	  path: "/",
	  component: _Login2.default
	}, {
	  path: "/index.html",
	  component: _Login2.default
	}, {
	  path: "main",
	  component: _indexPage2.default,
	  indexRoute: { component: _MainIndex2.default },
	  childRoutes: MainMenu
	}, {
	  path: "/lock",
	  component: _LockPage2.default
	}, {
	  path: "/Register",
	  component: _index2.default
	}, {
	  path: "/ChangePassword",
	  component: _index4.default
	}, {
	  path: '*',
	  component: _Login2.default,
	  // indexRoute: { component: MainIndex },
	  childRoutes: MainMenu
	}];
	
	exports.addNewPath = addNewPath;
	exports.menusForEach = menusForEach;
	exports.saveLastVisitRoute = saveLastVisitRoute;
	exports.MainMenu = MainMenu;
	exports.default = routes;

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getScroll;
	
	function getScroll(target, top) {
	  if (typeof window === 'undefined') {
	    return 0;
	  }
	
	  var prop = top ? 'pageYOffset' : 'pageXOffset';
	  var method = top ? 'scrollTop' : 'scrollLeft';
	  var isWindow = target === window;
	  var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode
	
	  if (isWindow && typeof ret !== 'number') {
	    ret = document.documentElement[method];
	  }
	
	  return ret;
	}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = scrollTo;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	var _getScroll = _interopRequireDefault(__webpack_require__(289));
	
	var _easings = __webpack_require__(1002);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function scrollTo(y) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$getContainer = options.getContainer,
	      getContainer = _options$getContainer === void 0 ? function () {
	    return window;
	  } : _options$getContainer,
	      callback = options.callback,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 450 : _options$duration;
	  var container = getContainer();
	  var scrollTop = (0, _getScroll["default"])(container, true);
	  var startTime = Date.now();
	
	  var frameFunc = function frameFunc() {
	    var timestamp = Date.now();
	    var time = timestamp - startTime;
	    var nextScrollTop = (0, _easings.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);
	
	    if (container === window) {
	      window.scrollTo(window.pageXOffset, nextScrollTop);
	    } else {
	      container.scrollTop = nextScrollTop;
	    }
	
	    if (time < duration) {
	      (0, _raf["default"])(frameFunc);
	    } else if (typeof callback === 'function') {
	      callback();
	    }
	  };
	
	  (0, _raf["default"])(frameFunc);
	}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/**
	 * Wrap of sub component which need use as Button capacity (like Icon component).
	 * This helps accessibility reader to tread as a interactive button to operation.
	 */
	
	var inlineStyle = {
	  border: 0,
	  background: 'transparent',
	  padding: 0,
	  lineHeight: 'inherit',
	  display: 'inline-block'
	};
	
	var TransButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(TransButton, _React$Component);
	
	  var _super = _createSuper(TransButton);
	
	  function TransButton() {
	    var _this;
	
	    _classCallCheck(this, TransButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (event) {
	      var keyCode = event.keyCode;
	
	      if (keyCode === _KeyCode["default"].ENTER) {
	        event.preventDefault();
	      }
	    };
	
	    _this.onKeyUp = function (event) {
	      var keyCode = event.keyCode;
	      var onClick = _this.props.onClick;
	
	      if (keyCode === _KeyCode["default"].ENTER && onClick) {
	        onClick();
	      }
	    };
	
	    _this.setRef = function (btn) {
	      _this.div = btn;
	    };
	
	    return _this;
	  }
	
	  _createClass(TransButton, [{
	    key: "focus",
	    value: function focus() {
	      if (this.div) {
	        this.div.focus();
	      }
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      if (this.div) {
	        this.div.blur();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          style = _a.style,
	          noStyle = _a.noStyle,
	          restProps = __rest(_a, ["style", "noStyle"]);
	
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          role: "button",
	          tabIndex: 0,
	          ref: this.setRef
	        }, restProps, {
	          onKeyDown: this.onKeyDown,
	          onKeyUp: this.onKeyUp,
	          style: _extends(_extends({}, !noStyle ? inlineStyle : null), style)
	        }))
	      );
	    }
	  }]);
	
	  return TransButton;
	}(React.Component);
	
	var _default = TransButton;
	exports["default"] = _default;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactDom = __webpack_require__(16);
	
	var _Event = _interopRequireDefault(__webpack_require__(494));
	
	var _raf = _interopRequireDefault(__webpack_require__(195));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var styleForPesudo; // Where el is the DOM element you'd like to test for visibility
	
	function isHidden(element) {
	  if (false) {
	    return false;
	  }
	
	  return !element || element.offsetParent === null;
	}
	
	function isNotGrey(color) {
	  // eslint-disable-next-line no-useless-escape
	  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
	
	  if (match && match[1] && match[2] && match[3]) {
	    return !(match[1] === match[2] && match[2] === match[3]);
	  }
	
	  return true;
	}
	
	var Wave = /*#__PURE__*/function (_React$Component) {
	  _inherits(Wave, _React$Component);
	
	  var _super = _createSuper(Wave);
	
	  function Wave() {
	    var _this;
	
	    _classCallCheck(this, Wave);
	
	    _this = _super.apply(this, arguments);
	    _this.animationStart = false;
	    _this.destroy = false;
	
	    _this.onClick = function (node, waveColor) {
	      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
	        return;
	      }
	
	      var insertExtraNode = _this.props.insertExtraNode;
	      _this.extraNode = document.createElement('div');
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          extraNode = _assertThisInitialize.extraNode;
	
	      extraNode.className = 'ant-click-animating-node';
	
	      var attributeName = _this.getAttributeName();
	
	      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey
	
	      styleForPesudo = styleForPesudo || document.createElement('style');
	
	      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
	      waveColor !== 'transparent') {
	        // Add nonce if CSP exist
	        if (_this.csp && _this.csp.nonce) {
	          styleForPesudo.nonce = _this.csp.nonce;
	        }
	
	        extraNode.style.borderColor = waveColor;
	        styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");
	
	        if (!document.body.contains(styleForPesudo)) {
	          document.body.appendChild(styleForPesudo);
	        }
	      }
	
	      if (insertExtraNode) {
	        node.appendChild(extraNode);
	      }
	
	      _Event["default"].addStartEventListener(node, _this.onTransitionStart);
	
	      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
	    };
	
	    _this.onTransitionStart = function (e) {
	      if (_this.destroy) return;
	      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));
	
	      if (!e || e.target !== node) {
	        return;
	      }
	
	      if (!_this.animationStart) {
	        _this.resetEffect(node);
	      }
	    };
	
	    _this.onTransitionEnd = function (e) {
	      if (!e || e.animationName !== 'fadeEffect') {
	        return;
	      }
	
	      _this.resetEffect(e.target);
	    };
	
	    _this.bindAnimationEvent = function (node) {
	      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
	        return;
	      }
	
	      var onClick = function onClick(e) {
	        // Fix radio button click twice
	        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
	          return;
	        }
	
	        _this.resetEffect(node); // Get wave color from target
	
	
	        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
	        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
	        _this.clickWaveTimeoutId = window.setTimeout(function () {
	          return _this.onClick(node, waveColor);
	        }, 0);
	
	        _raf["default"].cancel(_this.animationStartId);
	
	        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
	
	        _this.animationStartId = (0, _raf["default"])(function () {
	          _this.animationStart = false;
	        }, 10);
	      };
	
	      node.addEventListener('click', onClick, true);
	      return {
	        cancel: function cancel() {
	          node.removeEventListener('click', onClick, true);
	        }
	      };
	    };
	
	    _this.renderWave = function (_ref) {
	      var csp = _ref.csp;
	      var children = _this.props.children;
	      _this.csp = csp;
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Wave, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var node = (0, _reactDom.findDOMNode)(this);
	
	      if (!node || node.nodeType !== 1) {
	        return;
	      }
	
	      this.instance = this.bindAnimationEvent(node);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.instance) {
	        this.instance.cancel();
	      }
	
	      if (this.clickWaveTimeoutId) {
	        clearTimeout(this.clickWaveTimeoutId);
	      }
	
	      this.destroy = true;
	    }
	  }, {
	    key: "getAttributeName",
	    value: function getAttributeName() {
	      var insertExtraNode = this.props.insertExtraNode;
	      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
	    }
	  }, {
	    key: "resetEffect",
	    value: function resetEffect(node) {
	      if (!node || node === this.extraNode || !(node instanceof Element)) {
	        return;
	      }
	
	      var insertExtraNode = this.props.insertExtraNode;
	      var attributeName = this.getAttributeName();
	      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466
	
	      if (styleForPesudo) {
	        styleForPesudo.innerHTML = '';
	      }
	
	      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
	        node.removeChild(this.extraNode);
	      }
	
	      _Event["default"].removeStartEventListener(node, this.onTransitionStart);
	
	      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWave)
	      );
	    }
	  }]);
	
	  return Wave;
	}(React.Component);
	
	exports["default"] = Wave;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(501));
	
	var _en_US2 = _interopRequireDefault(__webpack_require__(304));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	// Merge into a locale object
	var locale = {
	  lang: _extends({
	    placeholder: 'Select date',
	    rangePlaceholder: ['Start date', 'End date']
	  }, _en_US["default"]),
	  timePickerLocale: _extends({}, _en_US2["default"])
	}; // All settings at:
	// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
	
	var _default = locale;
	exports["default"] = _default;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcDropdown = _interopRequireDefault(__webpack_require__(465));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _type = __webpack_require__(78);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');
	
	var Dropdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  var _super = _createSuper(Dropdown);
	
	  function Dropdown() {
	    var _this;
	
	    _classCallCheck(this, Dropdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderOverlay = function (prefixCls) {
	      // rc-dropdown already can process the function of overlay, but we have check logic here.
	      // So we need render the element to check and pass back to rc-dropdown.
	      var overlay = _this.props.overlay;
	      var overlayNode;
	
	      if (typeof overlay === 'function') {
	        overlayNode = overlay();
	      } else {
	        overlayNode = overlay;
	      }
	
	      overlayNode = React.Children.only(overlayNode);
	      var overlayProps = overlayNode.props; // Warning if use other mode
	
	      (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', 'Dropdown', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
	      // menu should be focusable in dropdown defaultly
	
	      var _overlayProps$selecta = overlayProps.selectable,
	          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
	          _overlayProps$focusab = overlayProps.focusable,
	          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
	      var expandIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-submenu-arrow")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
	      }));
	      var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlay : /*#__PURE__*/React.cloneElement(overlayNode, {
	        mode: 'vertical',
	        selectable: selectable,
	        focusable: focusable,
	        expandIcon: expandIcon
	      });
	      return fixedModeOverlay;
	    };
	
	    _this.renderDropDown = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          children = _this$props.children,
	          trigger = _this$props.trigger,
	          disabled = _this$props.disabled,
	          getPopupContainer = _this$props.getPopupContainer;
	      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
	      var child = React.Children.only(children);
	      var dropdownTrigger = /*#__PURE__*/React.cloneElement(child, {
	        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
	        disabled: disabled
	      });
	      var triggerActions = disabled ? [] : trigger;
	      var alignPoint;
	
	      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
	        alignPoint = true;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcDropdown["default"], _extends({
	          alignPoint: alignPoint
	        }, _this.props, {
	          prefixCls: prefixCls,
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          transitionName: _this.getTransitionName(),
	          trigger: triggerActions,
	          overlay: function overlay() {
	            return _this.renderOverlay(prefixCls);
	          }
	        }), dropdownTrigger)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: "getTransitionName",
	    value: function getTransitionName() {
	      var _this$props2 = this.props,
	          _this$props2$placemen = _this$props2.placement,
	          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen,
	          transitionName = _this$props2.transitionName;
	
	      if (transitionName !== undefined) {
	        return transitionName;
	      }
	
	      if (placement.indexOf('top') >= 0) {
	        return 'slide-down';
	      }
	
	      return 'slide-up';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDropDown)
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(React.Component);
	
	exports["default"] = Dropdown;
	Dropdown.defaultProps = {
	  mouseEnterDelay: 0.15,
	  mouseLeaveDelay: 0.1,
	  placement: 'bottomLeft'
	};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _dropdown = _interopRequireDefault(__webpack_require__(294));
	
	var _dropdownButton = _interopRequireDefault(__webpack_require__(1044));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_dropdown["default"].Button = _dropdownButton["default"];
	var _default = _dropdown["default"];
	exports["default"] = _default;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Affix", {
	  enumerable: true,
	  get: function get() {
	    return _affix["default"];
	  }
	});
	Object.defineProperty(exports, "Anchor", {
	  enumerable: true,
	  get: function get() {
	    return _anchor["default"];
	  }
	});
	Object.defineProperty(exports, "AutoComplete", {
	  enumerable: true,
	  get: function get() {
	    return _autoComplete["default"];
	  }
	});
	Object.defineProperty(exports, "Alert", {
	  enumerable: true,
	  get: function get() {
	    return _alert["default"];
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _avatar["default"];
	  }
	});
	Object.defineProperty(exports, "BackTop", {
	  enumerable: true,
	  get: function get() {
	    return _backTop["default"];
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _badge["default"];
	  }
	});
	Object.defineProperty(exports, "Breadcrumb", {
	  enumerable: true,
	  get: function get() {
	    return _breadcrumb["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _button["default"];
	  }
	});
	Object.defineProperty(exports, "Calendar", {
	  enumerable: true,
	  get: function get() {
	    return _calendar["default"];
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _card["default"];
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _collapse["default"];
	  }
	});
	Object.defineProperty(exports, "Carousel", {
	  enumerable: true,
	  get: function get() {
	    return _carousel["default"];
	  }
	});
	Object.defineProperty(exports, "Cascader", {
	  enumerable: true,
	  get: function get() {
	    return _cascader["default"];
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _checkbox["default"];
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _col["default"];
	  }
	});
	Object.defineProperty(exports, "Comment", {
	  enumerable: true,
	  get: function get() {
	    return _comment["default"];
	  }
	});
	Object.defineProperty(exports, "ConfigProvider", {
	  enumerable: true,
	  get: function get() {
	    return _configProvider["default"];
	  }
	});
	Object.defineProperty(exports, "DatePicker", {
	  enumerable: true,
	  get: function get() {
	    return _datePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Descriptions", {
	  enumerable: true,
	  get: function get() {
	    return _descriptions["default"];
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _divider["default"];
	  }
	});
	Object.defineProperty(exports, "Dropdown", {
	  enumerable: true,
	  get: function get() {
	    return _dropdown["default"];
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _drawer["default"];
	  }
	});
	Object.defineProperty(exports, "Empty", {
	  enumerable: true,
	  get: function get() {
	    return _empty["default"];
	  }
	});
	Object.defineProperty(exports, "Form", {
	  enumerable: true,
	  get: function get() {
	    return _form["default"];
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _icon["default"];
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _input["default"];
	  }
	});
	Object.defineProperty(exports, "InputNumber", {
	  enumerable: true,
	  get: function get() {
	    return _inputNumber["default"];
	  }
	});
	Object.defineProperty(exports, "Layout", {
	  enumerable: true,
	  get: function get() {
	    return _layout["default"];
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _list["default"];
	  }
	});
	Object.defineProperty(exports, "LocaleProvider", {
	  enumerable: true,
	  get: function get() {
	    return _localeProvider["default"];
	  }
	});
	Object.defineProperty(exports, "message", {
	  enumerable: true,
	  get: function get() {
	    return _message["default"];
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _menu["default"];
	  }
	});
	Object.defineProperty(exports, "Mentions", {
	  enumerable: true,
	  get: function get() {
	    return _mentions["default"];
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _modal["default"];
	  }
	});
	Object.defineProperty(exports, "Statistic", {
	  enumerable: true,
	  get: function get() {
	    return _statistic["default"];
	  }
	});
	Object.defineProperty(exports, "notification", {
	  enumerable: true,
	  get: function get() {
	    return _notification["default"];
	  }
	});
	Object.defineProperty(exports, "PageHeader", {
	  enumerable: true,
	  get: function get() {
	    return _pageHeader["default"];
	  }
	});
	Object.defineProperty(exports, "Pagination", {
	  enumerable: true,
	  get: function get() {
	    return _pagination["default"];
	  }
	});
	Object.defineProperty(exports, "Popconfirm", {
	  enumerable: true,
	  get: function get() {
	    return _popconfirm["default"];
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _popover["default"];
	  }
	});
	Object.defineProperty(exports, "Progress", {
	  enumerable: true,
	  get: function get() {
	    return _progress["default"];
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _radio["default"];
	  }
	});
	Object.defineProperty(exports, "Rate", {
	  enumerable: true,
	  get: function get() {
	    return _rate["default"];
	  }
	});
	Object.defineProperty(exports, "Result", {
	  enumerable: true,
	  get: function get() {
	    return _result["default"];
	  }
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _row["default"];
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _select["default"];
	  }
	});
	Object.defineProperty(exports, "Skeleton", {
	  enumerable: true,
	  get: function get() {
	    return _skeleton["default"];
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _slider["default"];
	  }
	});
	Object.defineProperty(exports, "Spin", {
	  enumerable: true,
	  get: function get() {
	    return _spin["default"];
	  }
	});
	Object.defineProperty(exports, "Steps", {
	  enumerable: true,
	  get: function get() {
	    return _steps["default"];
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _switch["default"];
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _table["default"];
	  }
	});
	Object.defineProperty(exports, "Transfer", {
	  enumerable: true,
	  get: function get() {
	    return _transfer["default"];
	  }
	});
	Object.defineProperty(exports, "Tree", {
	  enumerable: true,
	  get: function get() {
	    return _tree["default"];
	  }
	});
	Object.defineProperty(exports, "TreeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _treeSelect["default"];
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _tabs["default"];
	  }
	});
	Object.defineProperty(exports, "Tag", {
	  enumerable: true,
	  get: function get() {
	    return _tag["default"];
	  }
	});
	Object.defineProperty(exports, "TimePicker", {
	  enumerable: true,
	  get: function get() {
	    return _timePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Timeline", {
	  enumerable: true,
	  get: function get() {
	    return _timeline["default"];
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _tooltip["default"];
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography["default"];
	  }
	});
	Object.defineProperty(exports, "Mention", {
	  enumerable: true,
	  get: function get() {
	    return _mention["default"];
	  }
	});
	Object.defineProperty(exports, "Upload", {
	  enumerable: true,
	  get: function get() {
	    return _upload["default"];
	  }
	});
	Object.defineProperty(exports, "version", {
	  enumerable: true,
	  get: function get() {
	    return _version["default"];
	  }
	});
	
	var _affix = _interopRequireDefault(__webpack_require__(556));
	
	var _anchor = _interopRequireDefault(__webpack_require__(1012));
	
	var _autoComplete = _interopRequireDefault(__webpack_require__(1014));
	
	var _alert = _interopRequireDefault(__webpack_require__(1009));
	
	var _avatar = _interopRequireDefault(__webpack_require__(557));
	
	var _backTop = _interopRequireDefault(__webpack_require__(1015));
	
	var _badge = _interopRequireDefault(__webpack_require__(1017));
	
	var _breadcrumb = _interopRequireDefault(__webpack_require__(559));
	
	var _button = _interopRequireDefault(__webpack_require__(135));
	
	var _calendar = _interopRequireDefault(__webpack_require__(1023));
	
	var _card = _interopRequireDefault(__webpack_require__(1026));
	
	var _collapse = _interopRequireDefault(__webpack_require__(1032));
	
	var _carousel = _interopRequireDefault(__webpack_require__(1027));
	
	var _cascader = _interopRequireDefault(__webpack_require__(1028));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(151));
	
	var _col = _interopRequireDefault(__webpack_require__(562));
	
	var _comment = _interopRequireDefault(__webpack_require__(1033));
	
	var _configProvider = _interopRequireDefault(__webpack_require__(13));
	
	var _datePicker = _interopRequireDefault(__webpack_require__(1038));
	
	var _descriptions = _interopRequireDefault(__webpack_require__(1041));
	
	var _divider = _interopRequireDefault(__webpack_require__(1042));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(295));
	
	var _drawer = _interopRequireDefault(__webpack_require__(1043));
	
	var _empty = _interopRequireDefault(__webpack_require__(565));
	
	var _form = _interopRequireDefault(__webpack_require__(1049));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _input = _interopRequireDefault(__webpack_require__(233));
	
	var _inputNumber = _interopRequireDefault(__webpack_require__(1053));
	
	var _layout = _interopRequireDefault(__webpack_require__(1059));
	
	var _list = _interopRequireDefault(__webpack_require__(1061));
	
	var _localeProvider = _interopRequireDefault(__webpack_require__(574));
	
	var _message = _interopRequireDefault(__webpack_require__(1067));
	
	var _menu = _interopRequireDefault(__webpack_require__(299));
	
	var _mentions = _interopRequireDefault(__webpack_require__(1064));
	
	var _modal = _interopRequireDefault(__webpack_require__(1070));
	
	var _statistic = _interopRequireDefault(__webpack_require__(1094));
	
	var _notification = _interopRequireDefault(__webpack_require__(1071));
	
	var _pageHeader = _interopRequireDefault(__webpack_require__(1072));
	
	var _pagination = _interopRequireDefault(__webpack_require__(301));
	
	var _popconfirm = _interopRequireDefault(__webpack_require__(1075));
	
	var _popover = _interopRequireDefault(__webpack_require__(1076));
	
	var _progress = _interopRequireDefault(__webpack_require__(576));
	
	var _radio = _interopRequireDefault(__webpack_require__(234));
	
	var _rate = _interopRequireDefault(__webpack_require__(1082));
	
	var _result = _interopRequireDefault(__webpack_require__(1083));
	
	var _row = _interopRequireDefault(__webpack_require__(577));
	
	var _select = _interopRequireDefault(__webpack_require__(197));
	
	var _skeleton = _interopRequireDefault(__webpack_require__(1090));
	
	var _slider = _interopRequireDefault(__webpack_require__(1091));
	
	var _spin = _interopRequireDefault(__webpack_require__(235));
	
	var _steps = _interopRequireDefault(__webpack_require__(1096));
	
	var _switch = _interopRequireDefault(__webpack_require__(1097));
	
	var _table = _interopRequireDefault(__webpack_require__(1107));
	
	var _transfer = _interopRequireDefault(__webpack_require__(1115));
	
	var _tree = _interopRequireDefault(__webpack_require__(1121));
	
	var _treeSelect = _interopRequireDefault(__webpack_require__(1119));
	
	var _tabs = _interopRequireDefault(__webpack_require__(580));
	
	var _tag = _interopRequireDefault(__webpack_require__(581));
	
	var _timePicker = _interopRequireDefault(__webpack_require__(582));
	
	var _timeline = _interopRequireDefault(__webpack_require__(1112));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(122));
	
	var _typography = _interopRequireDefault(__webpack_require__(1127));
	
	var _mention = _interopRequireDefault(__webpack_require__(1063));
	
	var _upload = _interopRequireDefault(__webpack_require__(1131));
	
	var _version = _interopRequireDefault(__webpack_require__(1132));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	/* @remove-on-es-build-begin */
	// this file is not used if use https://github.com/ant-design/babel-plugin-import
	var ENV = ("production");
	
	if (ENV !== 'production' && ENV !== 'test' && typeof console !== 'undefined' && console.warn && // eslint-disable-line no-console
	typeof window !== 'undefined') {
	  // eslint-disable-next-line no-console
	  console.warn('You are using a whole package of antd, ' + 'please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size.');
	}
	/* @remove-on-es-build-end */

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SiderContext = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _layout = __webpack_require__(573);
	
	var _configProvider = __webpack_require__(13);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _isNumeric = _interopRequireDefault(__webpack_require__(1003));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	}
	
	var dimensionMaxMap = {
	  xs: '479.98px',
	  sm: '575.98px',
	  md: '767.98px',
	  lg: '991.98px',
	  xl: '1199.98px',
	  xxl: '1599.98px'
	};
	var SiderContext = (0, _createReactContext["default"])({});
	exports.SiderContext = SiderContext;
	
	var generateId = function () {
	  var i = 0;
	  return function () {
	    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    i += 1;
	    return "".concat(prefix).concat(i);
	  };
	}();
	
	var InternalSider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalSider, _React$Component);
	
	  var _super = _createSuper(InternalSider);
	
	  function InternalSider(props) {
	    var _this;
	
	    _classCallCheck(this, InternalSider);
	
	    _this = _super.call(this, props);
	
	    _this.responsiveHandler = function (mql) {
	      _this.setState({
	        below: mql.matches
	      });
	
	      var onBreakpoint = _this.props.onBreakpoint;
	
	      if (onBreakpoint) {
	        onBreakpoint(mql.matches);
	      }
	
	      if (_this.state.collapsed !== mql.matches) {
	        _this.setCollapsed(mql.matches, 'responsive');
	      }
	    };
	
	    _this.setCollapsed = function (collapsed, type) {
	      if (!('collapsed' in _this.props)) {
	        _this.setState({
	          collapsed: collapsed
	        });
	      }
	
	      var onCollapse = _this.props.onCollapse;
	
	      if (onCollapse) {
	        onCollapse(collapsed, type);
	      }
	    };
	
	    _this.toggle = function () {
	      var collapsed = !_this.state.collapsed;
	
	      _this.setCollapsed(collapsed, 'clickTrigger');
	    };
	
	    _this.belowShowChange = function () {
	      _this.setState(function (_ref) {
	        var belowShow = _ref.belowShow;
	        return {
	          belowShow: !belowShow
	        };
	      });
	    };
	
	    _this.renderSider = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          theme = _a.theme,
	          collapsible = _a.collapsible,
	          reverseArrow = _a.reverseArrow,
	          trigger = _a.trigger,
	          style = _a.style,
	          width = _a.width,
	          collapsedWidth = _a.collapsedWidth,
	          zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle,
	          others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth", "zeroWidthTriggerStyle"]);
	
	      var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
	      var divProps = (0, _omit["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint', 'siderHook', 'zeroWidthTriggerStyle']);
	      var rawWidth = _this.state.collapsed ? collapsedWidth : width; // use "px" as fallback unit for width
	
	      var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0
	
	      var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/React.createElement("span", {
	        onClick: _this.toggle,
	        className: "".concat(prefixCls, "-zero-width-trigger ").concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left'),
	        style: zeroWidthTriggerStyle
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "bars"
	      })) : null;
	      var iconObj = {
	        expanded: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }),
	        collapsed: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        })
	      };
	      var status = _this.state.collapsed ? 'collapsed' : 'expanded';
	      var defaultTrigger = iconObj[status];
	      var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-trigger"),
	        onClick: _this.toggle,
	        style: {
	          width: siderWidth
	        }
	      }, trigger || defaultTrigger) : null;
	
	      var divStyle = _extends(_extends({}, style), {
	        flex: "0 0 ".concat(siderWidth),
	        maxWidth: siderWidth,
	        minWidth: siderWidth,
	        width: siderWidth
	      });
	
	      var siderCls = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), !!_this.state.collapsed), _defineProperty(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty(_classNames, "".concat(prefixCls, "-below"), !!_this.state.below), _defineProperty(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames));
	      return (/*#__PURE__*/React.createElement("aside", _extends({
	          className: siderCls
	        }, divProps, {
	          style: divStyle
	        }), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-children")
	        }, _this.props.children), collapsible || _this.state.below && zeroWidthTrigger ? triggerDom : null)
	      );
	    };
	
	    _this.uniqueId = generateId('ant-sider-');
	    var matchMedia;
	
	    if (typeof window !== 'undefined') {
	      matchMedia = window.matchMedia;
	    }
	
	    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMaxMap) {
	      _this.mql = matchMedia("(max-width: ".concat(dimensionMaxMap[props.breakpoint], ")"));
	    }
	
	    var collapsed;
	
	    if ('collapsed' in props) {
	      collapsed = props.collapsed;
	    } else {
	      collapsed = props.defaultCollapsed;
	    }
	
	    _this.state = {
	      collapsed: collapsed,
	      below: false
	    };
	    return _this;
	  }
	
	  _createClass(InternalSider, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.mql) {
	        this.mql.addListener(this.responsiveHandler);
	        this.responsiveHandler(this.mql);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.addSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.mql) {
	        this.mql.removeListener(this.responsiveHandler);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.removeSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var collapsed = this.state.collapsed;
	      var collapsedWidth = this.props.collapsedWidth;
	      return (/*#__PURE__*/React.createElement(SiderContext.Provider, {
	          value: {
	            siderCollapsed: collapsed,
	            collapsedWidth: collapsedWidth
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSider))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('collapsed' in nextProps) {
	        return {
	          collapsed: nextProps.collapsed
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return InternalSider;
	}(React.Component);
	
	InternalSider.defaultProps = {
	  collapsible: false,
	  defaultCollapsed: false,
	  reverseArrow: false,
	  width: 200,
	  collapsedWidth: 80,
	  style: {},
	  theme: 'dark'
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalSider); // eslint-disable-next-line react/prefer-stateless-function
	
	var Sider = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Sider, _React$Component2);
	
	  var _super2 = _createSuper(Sider);
	
	  function Sider() {
	    _classCallCheck(this, Sider);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Sider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_layout.LayoutContext.Consumer, null, function (context) {
	          return (/*#__PURE__*/React.createElement(InternalSider, _extends({}, context, _this2.props))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Sider;
	}(React.Component);
	
	exports["default"] = Sider;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var MenuContext = (0, _createReactContext["default"])({
	  inlineCollapsed: false
	});
	var _default = MenuContext;
	exports["default"] = _default;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(93));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(1066));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(1065));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _Sider = __webpack_require__(297);
	
	var _raf = _interopRequireDefault(__webpack_require__(195));
	
	var _motion = _interopRequireDefault(__webpack_require__(552));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(298));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var InternalMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalMenu, _React$Component);
	
	  var _super = _createSuper(InternalMenu);
	
	  function InternalMenu(props) {
	    var _this;
	
	    _classCallCheck(this, InternalMenu);
	
	    _this = _super.call(this, props); // Restore vertical mode when menu is collapsed responsively when mounted
	    // https://github.com/ant-design/ant-design/issues/13104
	    // TODO: not a perfect solution, looking a new way to avoid setting switchingModeFromInline in this situation
	
	    _this.handleMouseEnter = function (e) {
	      _this.restoreModeVerticalFromInline();
	
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(e);
	      }
	    };
	
	    _this.handleTransitionEnd = function (e) {
	      // when inlineCollapsed menu width animation finished
	      // https://github.com/ant-design/ant-design/issues/12864
	      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function
	      // https://github.com/ant-design/ant-design/issues/15699
	
	      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during an animation.
	
	      var classNameValue = Object.prototype.toString.call(className) === '[object SVGAnimatedString]' ? className.animVal : className; // Fix for <Menu style={{ width: '100%' }} />, the width transition won't trigger when menu is collapsed
	      // https://github.com/ant-design/ant-design-pro/issues/2783
	
	      var iconScaled = e.propertyName === 'font-size' && classNameValue.indexOf('anticon') >= 0;
	
	      if (widthCollapsed || iconScaled) {
	        _this.restoreModeVerticalFromInline();
	      }
	    };
	
	    _this.handleClick = function (e) {
	      _this.handleOpenChange([]);
	
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.handleOpenChange = function (openKeys) {
	      _this.setOpenKeys(openKeys);
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(openKeys);
	      }
	    };
	
	    _this.renderMenu = function (_ref) {
	      var getPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          theme = _this$props.theme,
	          collapsedWidth = _this$props.collapsedWidth;
	      var passProps = (0, _omit["default"])(_this.props, ['collapsedWidth', 'siderCollapsed']);
	
	      var menuMode = _this.getRealMenuMode();
	
	      var menuOpenMotion = _this.getOpenMotionProps(menuMode);
	
	      var prefixCls = getPrefixCls('menu', customizePrefixCls);
	      var menuClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()));
	
	      var menuProps = _extends({
	        openKeys: _this.state.openKeys,
	        onOpenChange: _this.handleOpenChange,
	        className: menuClassName,
	        mode: menuMode
	      }, menuOpenMotion);
	
	      if (menuMode !== 'inline') {
	        // closing vertical popup submenu after click it
	        menuProps.onClick = _this.handleClick;
	      } // https://github.com/ant-design/ant-design/issues/8587
	
	
	      var hideMenu = _this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px');
	
	      if (hideMenu) {
	        menuProps.openKeys = [];
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcMenu["default"], _extends({
	          getPopupContainer: getPopupContainer
	        }, passProps, menuProps, {
	          prefixCls: prefixCls,
	          onTransitionEnd: _this.handleTransitionEnd,
	          onMouseEnter: _this.handleMouseEnter
	        }))
	      );
	    };
	
	    (0, _warning["default"])(!('onOpen' in props || 'onClose' in props), 'Menu', '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
	    (0, _warning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
	    (0, _warning["default"])(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
	    var openKeys;
	
	    if ('openKeys' in props) {
	      openKeys = props.openKeys;
	    } else if ('defaultOpenKeys' in props) {
	      openKeys = props.defaultOpenKeys;
	    }
	
	    _this.state = {
	      openKeys: openKeys || [],
	      switchingModeFromInline: false,
	      inlineOpenKeys: [],
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(InternalMenu, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountRafId);
	    }
	  }, {
	    key: "setOpenKeys",
	    value: function setOpenKeys(openKeys) {
	      if (!('openKeys' in this.props)) {
	        this.setState({
	          openKeys: openKeys
	        });
	      }
	    }
	  }, {
	    key: "getRealMenuMode",
	    value: function getRealMenuMode() {
	      var inlineCollapsed = this.getInlineCollapsed();
	
	      if (this.state.switchingModeFromInline && inlineCollapsed) {
	        return 'inline';
	      }
	
	      var mode = this.props.mode;
	      return inlineCollapsed ? 'vertical' : mode;
	    }
	  }, {
	    key: "getInlineCollapsed",
	    value: function getInlineCollapsed() {
	      var inlineCollapsed = this.props.inlineCollapsed;
	
	      if (this.props.siderCollapsed !== undefined) {
	        return this.props.siderCollapsed;
	      }
	
	      return inlineCollapsed;
	    }
	  }, {
	    key: "getOpenMotionProps",
	    value: function getOpenMotionProps(menuMode) {
	      var _this$props2 = this.props,
	          openTransitionName = _this$props2.openTransitionName,
	          openAnimation = _this$props2.openAnimation,
	          motion = _this$props2.motion; // Provides by user
	
	      if (motion) {
	        return {
	          motion: motion
	        };
	      }
	
	      if (openAnimation) {
	        (0, _warning["default"])(typeof openAnimation === 'string', 'Menu', '`openAnimation` do not support object. Please use `motion` instead.');
	        return {
	          openAnimation: openAnimation
	        };
	      }
	
	      if (openTransitionName) {
	        return {
	          openTransitionName: openTransitionName
	        };
	      } // Default logic
	
	
	      if (menuMode === 'horizontal') {
	        return {
	          motion: {
	            motionName: 'slide-up'
	          }
	        };
	      }
	
	      if (menuMode === 'inline') {
	        return {
	          motion: _motion["default"]
	        };
	      } // When mode switch from inline
	      // submenu should hide without animation
	
	
	      return {
	        motion: {
	          motionName: this.state.switchingModeFromInline ? '' : 'zoom-big'
	        }
	      };
	    }
	  }, {
	    key: "restoreModeVerticalFromInline",
	    value: function restoreModeVerticalFromInline() {
	      var switchingModeFromInline = this.state.switchingModeFromInline;
	
	      if (switchingModeFromInline) {
	        this.setState({
	          switchingModeFromInline: false
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Provider, {
	          value: {
	            inlineCollapsed: this.getInlineCollapsed() || false,
	            antdMenuTheme: this.props.theme
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if (prevProps.mode === 'inline' && nextProps.mode !== 'inline') {
	        newState.switchingModeFromInline = true;
	      }
	
	      if ('openKeys' in nextProps) {
	        newState.openKeys = nextProps.openKeys;
	      } else {
	        // [Legacy] Old code will return after `openKeys` changed.
	        // Not sure the reason, we should keep this logic still.
	        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
	          newState.switchingModeFromInline = true;
	          newState.inlineOpenKeys = prevState.openKeys;
	          newState.openKeys = [];
	        }
	
	        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
	          newState.openKeys = prevState.inlineOpenKeys;
	          newState.inlineOpenKeys = [];
	        }
	      }
	
	      return newState;
	    }
	  }]);
	
	  return InternalMenu;
	}(React.Component);
	
	InternalMenu.defaultProps = {
	  className: '',
	  theme: 'light',
	  focusable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalMenu); // We should keep this as ref-able
	
	var Menu = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Menu, _React$Component2);
	
	  var _super2 = _createSuper(Menu);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Menu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, function (context) {
	          return (/*#__PURE__*/React.createElement(InternalMenu, _extends({}, _this2.props, context))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Menu;
	}(React.Component);
	
	exports["default"] = Menu;
	Menu.Divider = _rcMenu.Divider;
	Menu.Item = _MenuItem["default"];
	Menu.SubMenu = _SubMenu["default"];
	Menu.ItemGroup = _rcMenu.ItemGroup;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeConfirmLocale = changeConfirmLocale;
	exports.getConfirmLocale = getConfirmLocale;
	
	var _default = _interopRequireDefault(__webpack_require__(152));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var runtimeLocale = _extends({}, _default["default"].Modal);
	
	function changeConfirmLocale(newLocale) {
	  if (newLocale) {
	    runtimeLocale = _extends(_extends({}, runtimeLocale), newLocale);
	  } else {
	    runtimeLocale = _extends({}, _default["default"].Modal);
	  }
	}
	
	function getConfirmLocale() {
	  return runtimeLocale;
	}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Pagination = _interopRequireDefault(__webpack_require__(1074));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Pagination["default"];
	exports["default"] = _default;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validProgress = validProgress;
	
	// eslint-disable-next-line import/prefer-default-export
	function validProgress(progress) {
	  if (!progress || progress < 0) {
	    return 0;
	  }
	
	  if (progress > 100) {
	    return 100;
	  }
	
	  return progress;
	}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(187));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Radio = /*#__PURE__*/function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  var _super = _createSuper(Radio);
	
	  function Radio() {
	    var _this;
	
	    _classCallCheck(this, Radio);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.onChange = function (e) {
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	
	      if (_this.context.radioGroup && _this.context.radioGroup.onChange) {
	        _this.context.radioGroup.onChange(e);
	      }
	    };
	
	    _this.renderRadio = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          style = props.style,
	          restProps = __rest(props, ["prefixCls", "className", "children", "style"]);
	
	      var radioGroup = context.radioGroup;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	
	      var radioProps = _extends({}, restProps);
	
	      if (radioGroup) {
	        radioProps.name = radioGroup.name;
	        radioProps.onChange = _this.onChange;
	        radioProps.checked = props.value === radioGroup.value;
	        radioProps.disabled = props.disabled || radioGroup.disabled;
	      }
	
	      var wrapperClassString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _classNames));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: wrapperClassString,
	          style: style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, radioProps, {
	          prefixCls: prefixCls,
	          ref: _this.saveCheckbox
	        })), children !== undefined ? /*#__PURE__*/React.createElement("span", null, children) : null)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Radio, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.radioGroup, nextContext.radioGroup);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadio)
	      );
	    }
	  }]);
	
	  return Radio;
	}(React.Component);
	
	exports["default"] = Radio;
	Radio.defaultProps = {
	  type: 'radio'
	};
	Radio.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var locale = {
	  placeholder: 'Select time'
	};
	var _default = locale;
	exports["default"] = _default;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _findDOMNode = _interopRequireDefault(__webpack_require__(493));
	
	var _copyToClipboard = _interopRequireDefault(__webpack_require__(508));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _configProvider = __webpack_require__(13);
	
	var _context = __webpack_require__(231);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _transButton = _interopRequireDefault(__webpack_require__(291));
	
	var _raf = _interopRequireDefault(__webpack_require__(195));
	
	var _styleChecker = _interopRequireDefault(__webpack_require__(555));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(122));
	
	var _Typography = _interopRequireDefault(__webpack_require__(585));
	
	var _Editable = _interopRequireDefault(__webpack_require__(1123));
	
	var _util = _interopRequireDefault(__webpack_require__(1128));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var isLineClampSupport = (0, _styleChecker["default"])('webkitLineClamp');
	var isTextOverflowSupport = (0, _styleChecker["default"])('textOverflow');
	
	function wrapperDecorations(_ref, content) {
	  var mark = _ref.mark,
	      code = _ref.code,
	      underline = _ref.underline,
	      del = _ref["delete"],
	      strong = _ref.strong;
	  var currentContent = content;
	
	  function wrap(needed, tag) {
	    if (!needed) return;
	    currentContent = /*#__PURE__*/React.createElement(tag, {}, currentContent);
	  }
	
	  wrap(strong, 'strong');
	  wrap(underline, 'u');
	  wrap(del, 'del');
	  wrap(code, 'code');
	  wrap(mark, 'mark');
	  return currentContent;
	}
	
	var ELLIPSIS_STR = '...';
	
	var Base = /*#__PURE__*/function (_React$Component) {
	  _inherits(Base, _React$Component);
	
	  var _super = _createSuper(Base);
	
	  function Base() {
	    var _this;
	
	    _classCallCheck(this, Base);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      edit: false,
	      copied: false,
	      ellipsisText: '',
	      ellipsisContent: null,
	      isEllipsis: false,
	      expanded: false,
	      clientRendered: false
	    }; // =============== Expend ===============
	
	    _this.onExpandClick = function () {
	      var _this$getEllipsis = _this.getEllipsis(),
	          onExpand = _this$getEllipsis.onExpand;
	
	      _this.setState({
	        expanded: true
	      });
	
	      if (onExpand) {
	        onExpand();
	      }
	    }; // ================ Edit ================
	
	
	    _this.onEditClick = function () {
	      _this.triggerEdit(true);
	    };
	
	    _this.onEditChange = function (value) {
	      var _this$getEditable = _this.getEditable(),
	          onChange = _this$getEditable.onChange;
	
	      if (onChange) {
	        onChange(value);
	      }
	
	      _this.triggerEdit(false);
	    };
	
	    _this.onEditCancel = function () {
	      _this.triggerEdit(false);
	    }; // ================ Copy ================
	
	
	    _this.onCopyClick = function () {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          copyable = _this$props.copyable;
	
	      var copyConfig = _extends({}, _typeof(copyable) === 'object' ? copyable : null);
	
	      if (copyConfig.text === undefined) {
	        copyConfig.text = String(children);
	      }
	
	      (0, _copyToClipboard["default"])(copyConfig.text || '');
	
	      _this.setState({
	        copied: true
	      }, function () {
	        if (copyConfig.onCopy) {
	          copyConfig.onCopy();
	        }
	
	        _this.copyId = window.setTimeout(function () {
	          _this.setState({
	            copied: false
	          });
	        }, 3000);
	      });
	    };
	
	    _this.setContentRef = function (node) {
	      _this.content = node;
	    };
	
	    _this.setEditRef = function (node) {
	      _this.editIcon = node;
	    };
	
	    _this.triggerEdit = function (edit) {
	      var _this$getEditable2 = _this.getEditable(),
	          onStart = _this$getEditable2.onStart;
	
	      if (edit && onStart) {
	        onStart();
	      }
	
	      _this.setState({
	        edit: edit
	      }, function () {
	        if (!edit && _this.editIcon) {
	          _this.editIcon.focus();
	        }
	      });
	    }; // ============== Ellipsis ==============
	
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.rafId);
	
	      _this.rafId = (0, _raf["default"])(function () {
	        // Do not bind `syncEllipsis`. It need for test usage on prototype
	        _this.syncEllipsis();
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Base, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        clientRendered: true
	      });
	      this.resizeOnNextFrame();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var children = this.props.children;
	      var ellipsis = this.getEllipsis();
	      var prevEllipsis = this.getEllipsis(prevProps);
	
	      if (children !== prevProps.children || ellipsis.rows !== prevEllipsis.rows) {
	        this.resizeOnNextFrame();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.copyId);
	
	      _raf["default"].cancel(this.rafId);
	    }
	  }, {
	    key: "getEditable",
	    value: function getEditable(props) {
	      var edit = this.state.edit;
	
	      var _ref2 = props || this.props,
	          editable = _ref2.editable;
	
	      if (!editable) return {
	        editing: edit
	      };
	      return _extends({
	        editing: edit
	      }, _typeof(editable) === 'object' ? editable : null);
	    }
	  }, {
	    key: "getEllipsis",
	    value: function getEllipsis(props) {
	      var _ref3 = props || this.props,
	          ellipsis = _ref3.ellipsis;
	
	      if (!ellipsis) return {};
	      return _extends({
	        rows: 1,
	        expandable: false
	      }, _typeof(ellipsis) === 'object' ? ellipsis : null);
	    }
	  }, {
	    key: "canUseCSSEllipsis",
	    value: function canUseCSSEllipsis() {
	      var clientRendered = this.state.clientRendered;
	      var _this$props2 = this.props,
	          editable = _this$props2.editable,
	          copyable = _this$props2.copyable;
	
	      var _this$getEllipsis2 = this.getEllipsis(),
	          rows = _this$getEllipsis2.rows,
	          expandable = _this$getEllipsis2.expandable; // Can't use css ellipsis since we need to provide the place for button
	
	
	      if (editable || copyable || expandable || !clientRendered) {
	        return false;
	      }
	
	      if (rows === 1) {
	        return isTextOverflowSupport;
	      }
	
	      return isLineClampSupport;
	    }
	  }, {
	    key: "syncEllipsis",
	    value: function syncEllipsis() {
	      var _this$state = this.state,
	          ellipsisText = _this$state.ellipsisText,
	          isEllipsis = _this$state.isEllipsis,
	          expanded = _this$state.expanded;
	
	      var _this$getEllipsis3 = this.getEllipsis(),
	          rows = _this$getEllipsis3.rows;
	
	      var children = this.props.children;
	      if (!rows || rows < 0 || !this.content || expanded) return; // Do not measure if css already support ellipsis
	
	      if (this.canUseCSSEllipsis()) return;
	      (0, _warning["default"])((0, _toArray["default"])(children).every(function (child) {
	        return typeof child === 'string';
	      }), 'Typography', '`ellipsis` should use string as children only.');
	
	      var _measure = (0, _util["default"])((0, _findDOMNode["default"])(this.content), rows, children, this.renderOperations(true), ELLIPSIS_STR),
	          content = _measure.content,
	          text = _measure.text,
	          ellipsis = _measure.ellipsis;
	
	      if (ellipsisText !== text || isEllipsis !== ellipsis) {
	        this.setState({
	          ellipsisText: text,
	          ellipsisContent: content,
	          isEllipsis: ellipsis
	        });
	      }
	    }
	  }, {
	    key: "renderExpand",
	    value: function renderExpand(forceRender) {
	      var _this$getEllipsis4 = this.getEllipsis(),
	          expandable = _this$getEllipsis4.expandable;
	
	      var prefixCls = this.props.prefixCls;
	      var _this$state2 = this.state,
	          expanded = _this$state2.expanded,
	          isEllipsis = _this$state2.isEllipsis;
	      if (!expandable) return null; // force render expand icon for measure usage or it will cause dead loop
	
	      if (!forceRender && (expanded || !isEllipsis)) return null;
	      return (/*#__PURE__*/React.createElement("a", {
	          key: "expand",
	          className: "".concat(prefixCls, "-expand"),
	          onClick: this.onExpandClick,
	          "aria-label": this.expandStr
	        }, this.expandStr)
	      );
	    }
	  }, {
	    key: "renderEdit",
	    value: function renderEdit() {
	      var _this$props3 = this.props,
	          editable = _this$props3.editable,
	          prefixCls = _this$props3.prefixCls;
	      if (!editable) return;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          key: "edit",
	          title: this.editStr
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          ref: this.setEditRef,
	          className: "".concat(prefixCls, "-edit"),
	          onClick: this.onEditClick,
	          "aria-label": this.editStr
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          role: "button",
	          type: "edit"
	        })))
	      );
	    }
	  }, {
	    key: "renderCopy",
	    value: function renderCopy() {
	      var copied = this.state.copied;
	      var _this$props4 = this.props,
	          copyable = _this$props4.copyable,
	          prefixCls = _this$props4.prefixCls;
	      if (!copyable) return;
	      var title = copied ? this.copiedStr : this.copyStr;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          key: "copy",
	          title: title
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-copy"), copied && "".concat(prefixCls, "-copy-success")),
	          onClick: this.onCopyClick,
	          "aria-label": title
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          role: "button",
	          type: copied ? 'check' : 'copy'
	        })))
	      );
	    }
	  }, {
	    key: "renderEditInput",
	    value: function renderEditInput() {
	      var _this$props5 = this.props,
	          children = _this$props5.children,
	          prefixCls = _this$props5.prefixCls,
	          className = _this$props5.className,
	          style = _this$props5.style;
	      return (/*#__PURE__*/React.createElement(_Editable["default"], {
	          value: typeof children === 'string' ? children : '',
	          onSave: this.onEditChange,
	          onCancel: this.onEditCancel,
	          prefixCls: prefixCls,
	          className: className,
	          style: style
	        })
	      );
	    }
	  }, {
	    key: "renderOperations",
	    value: function renderOperations(forceRenderExpanded) {
	      return [this.renderExpand(forceRenderExpanded), this.renderEdit(), this.renderCopy()].filter(function (node) {
	        return node;
	      });
	    }
	  }, {
	    key: "renderContent",
	    value: function renderContent() {
	      var _this2 = this;
	
	      var _this$state3 = this.state,
	          ellipsisContent = _this$state3.ellipsisContent,
	          isEllipsis = _this$state3.isEllipsis,
	          expanded = _this$state3.expanded;
	
	      var _a = this.props,
	          component = _a.component,
	          children = _a.children,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          style = _a.style,
	          restProps = __rest(_a, ["component", "children", "className", "prefixCls", "type", "disabled", "style"]);
	
	      var _this$getEllipsis5 = this.getEllipsis(),
	          rows = _this$getEllipsis5.rows;
	
	      var textProps = (0, _omit["default"])(restProps, ['prefixCls', 'editable', 'copyable', 'ellipsis', 'mark', 'underline', 'mark', 'code', 'delete', 'underline', 'strong'].concat(_toConsumableArray(_configProvider.configConsumerProps)));
	      var cssEllipsis = this.canUseCSSEllipsis();
	      var cssTextOverflow = rows === 1 && cssEllipsis;
	      var cssLineClamp = rows && rows > 1 && cssEllipsis;
	      var textNode = children;
	      var ariaLabel = null; // Only use js ellipsis when css ellipsis not support
	
	      if (rows && isEllipsis && !expanded && !cssEllipsis) {
	        ariaLabel = String(children); // We move full content to outer element to avoid repeat read the content by accessibility
	
	        textNode = /*#__PURE__*/React.createElement("span", {
	          title: String(children),
	          "aria-hidden": "true"
	        }, ellipsisContent, ELLIPSIS_STR);
	      }
	
	      textNode = wrapperDecorations(this.props, textNode);
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Text"
	        }, function (_ref4) {
	          var _classNames;
	
	          var edit = _ref4.edit,
	              copyStr = _ref4.copy,
	              copied = _ref4.copied,
	              expand = _ref4.expand;
	          _this2.editStr = edit;
	          _this2.copyStr = copyStr;
	          _this2.copiedStr = copied;
	          _this2.expandStr = expand;
	          return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	              onResize: _this2.resizeOnNextFrame,
	              disabled: !rows
	            }, /*#__PURE__*/React.createElement(_Typography["default"], _extends({
	              className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis"), rows), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis-single-line"), cssTextOverflow), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis-multiple-line"), cssLineClamp), _classNames)),
	              style: _extends(_extends({}, style), {
	                WebkitLineClamp: cssLineClamp ? rows : null
	              }),
	              component: component,
	              ref: _this2.setContentRef,
	              "aria-label": ariaLabel
	            }, textProps), textNode, _this2.renderOperations()))
	          );
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$getEditable3 = this.getEditable(),
	          editing = _this$getEditable3.editing;
	
	      if (editing) {
	        return this.renderEditInput();
	      }
	
	      return this.renderContent();
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var children = nextProps.children,
	          editable = nextProps.editable;
	      (0, _warning["default"])(!editable || typeof children === 'string', 'Typography', 'When `editable` is enabled, the `children` should use string.');
	      return {};
	    }
	  }]);
	
	  return Base;
	}(React.Component);
	
	Base.defaultProps = {
	  children: ''
	};
	(0, _reactLifecyclesCompat.polyfill)(Base);
	
	var _default = (0, _context.withConfigConsumer)({
	  prefixCls: 'typography'
	})(Base);
	
	exports["default"] = _default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.commonClient = exports.sgiPfClient = exports.sgiClient = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * @Descripttion: 
	                                                                                                                                                                                                                                                                   * @version: 
	                                                                                                                                                                                                                                                                   * @Author: liux
	                                                                                                                                                                                                                                                                   * @Date: 2019-11-21 14:58:03
	                                                                                                                                                                                                                                                                   * @LastEditors: hanzb
	                                                                                                                                                                                                                                                                   * @LastEditTime: 2020-04-02 13:53:54
	                                                                                                                                                                                                                                                                   */
	/*  
	 通讯出口
	 归属：企通前端平台-ECP V5.1
	 版权：2014-2020 企通软件技术有限公司
	 --------------------------------------------------------------------------------
	 作者：刘鑫                           创建日期：2018/03/22
	 修改：                               修改日期：
	 修改内容
	 --------------------------------------------------------------------------------
	 
	 *******************************************************************************/
	
	
	var _jquery = __webpack_require__(1134);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _sgiLogger = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @namespace 客户端通用服务调用方法集
	 * @alias commonClient
	 */
	var commonClient = {
	
		/**
	  * 缺省描述（请作者补充一下）
	  * @param {*} serviceId 
	  * @param {*} refreshDBKey 
	  * @param {*} params 
	  * @param {*} refreshTableCallBack 
	  * @param {*} objFct 
	  */
		callBatch: function callBatch(serviceId, refreshDBKey, params, refreshTableCallBack, objFct) {
			if (!params || !refreshTableCallBack || !refreshDBKey) {
				return;
			}
	
			//设置前处理,讲分批信息放入到request中
			var beforefunc = function beforefunc(request) {
				if (!request.head) request.head = {};
	
				if (params.pageSize) {
					request.head.pageSize = parseInt(params.pageSize);
				} else {
					request.head.pageSize = 10;
				}
				if (params.current) {
					request.head.offset = params.current;
				} else {
					request.head.offset = 1;
				}
			};
			//设置后处理，负责取值刷新
			var recordCount = void 0;
			var afterfunc = function afterfunc(response) {
				if (!response.head) response.head = {};
				var pageCount = response.head.pageCount;
				recordCount = response.head.recordCount;
			};
			var res = commonClient.call(serviceId, objFct, afterfunc, beforefunc);
	
			var rtList = objFct.get(refreshDBKey);
			refreshTableCallBack(recordCount, rtList);
	
			return res;
		},
	
		/**
	  * 缺省描述（请作者补充一下）
	  * @param {*} serviceId 
	  * @param {*} objFct 
	  * @param {*} aftercall 
	  * @param {*} beforecall 
	  * @param {*} callback 
	  * @param {*} flag 
	  */
		call: function call(serviceId, objFct, aftercall, beforecall, callback, flag) {
			if (!serviceId || !objFct) {
				return;
			}
			beforecall = beforecall || function () {};
			aftercall = aftercall || function () {};
	
			var guid = serviceId.replace("_SI_", "_SV_");
	
			var prm = PrmFactory.getPrm(guid);
			if (!prm) {
				return;
			}
			var path = prm.subSVID;
			var type = prm.svType;
			var app = prm.belong;
	
			var request = {};
			var header = {
				'Content-Type': "application/json; charset=utf-8"
				//'Content-Type': "application/x-www-form-urlencoded; charset=utf-8"
			};
	
			var head = {};
			head.serviceId = serviceId;
			head.cvt = "vi";
			request.head = head;
	
			var data = {};
			var cfgs = prm.cldSet || [];
			cfgs.forEach(function (cfg) {
				var io = cfg.iobType;
				var mult = cfg.isMult;
	
				var instance = cfg.oKey;
	
				if (!(io == 'I' || io == 'B')) return;
				var value = objFct.get(instance);
				if (!value) {
					return;
				}
				if (mult) {
					var cvtList = [];
					value.forEach(function (obj) {
						var cvtObj = {};
						var bks = cfg.cfgs || [];
						bks.forEach(function (cbk) {
							var buskey = cbk.busCode || cbk.fieldCode;
							if (!buskey || !obj[buskey]) return;
							cvtObj[buskey] = obj[buskey];
						});
						cvtList.push(cvtObj);
					});
					var dKey = cfg.dKey || cfg.eoName;
					data[dKey] = cvtList;
				} else {
					// for (var f in value) {
					// 	data[f] = value[f];
					// }
					var bks = cfg.cfgs || [];
					bks.forEach(function (cbk) {
						var buskey = cbk.busCode || cbk.fieldCode;
						if (!buskey || value[buskey] == null) return; //空字符串允许通过
						data[buskey] = value[buskey];
					});
				}
			});
			request.body = data;
	
			beforecall(request);
	
			var response = {};
			var sucfunc = function sucfunc(res) {
				response = res || {};
			};
			var failfunc = function failfunc(xhr, textStatus, errorThrown) {
				_sgiLogger.sgiLogger.log("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
				if (!response.head) {
					response.head = {};
				}
				response.head.code = xhr.status;
				response.head.msg = textStatus;
			};
			var url = sgiConfig.service + "/" + app + path;
			request = tool.jsonToStr(request);
			_sgiLogger.sgiLogger.log("request:", request);
	
			sgiClient.restcall(url, type, request, header, false, sucfunc, failfunc);
	
			_sgiLogger.sgiLogger.log("response:", response);
			aftercall(response);
	
			var code = response.head.code;
			var msg = response.head.msg;
			var result = response.body;
			if (code === "00000000") {
				cfgs.forEach(function (cfg) {
					var io = cfg.iobType;
					var mult = cfg.isMult;
	
					var instance = cfg.oKey;
	
					if (!(io == 'O' || io == 'B')) return;
	
					if (mult) {
						var dKey = cfg.dKey;
						var eoKey = cfg.eoName;
						if (!dKey) {
							dKey = eoKey;
						}
						objFct.set(instance, result[dKey]);
					} else {
						var vo = {};
						var bks = cfg.cfgs || [];
						bks.forEach(function (cbk) {
							var buskey = cbk.busCode || cbk.fieldCode;
							if (!buskey || !result[buskey]) return;
							vo[buskey] = result[buskey];
						});
						objFct.set(instance, vo);
					}
				});
			}
			return { code: code, msg: msg };
		},
	
		/**
	  * 服务接口调用
	  * @param {string} SIID 服务接口guid
	  * @param {ObjFactory} objFct 对象工厂实例
	  * @param {boolean} flag 异步标识
	  * @param {function} callback 回调函数，(res)=>{}
	  * @param {string} reqType 服务调用类型，默认POST
	  */
		callSIOld: function callSIOld(SIID, objFct, flag, callback) {
			var reqType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "POST";
	
			if (!SIID || !objFct) return;
	
			var prm = PrmFactory.getPrm(SIID);
			if (!prm || !prm.guid) return;
	
			// let path = prm.subSVID;//服务描述guid
			var path = prm.url; //服务地址
			// let type = prm.svType;
			// let app = prm.belong;
	
			var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
			request.head.serviceId = SIID;
			request.head.cvt = "vi";
	
			var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
			if (!header['Content-Type']) header['Content-Type'] = "application/json; charset=utf-8";
	
			var data = void 0,
			    inInst = void 0,
			    outInst = void 0;
			var cfgs = prm.cldSet || [];
			cfgs.some(function (cfg) {
				var io = cfg.iobType; //输入输出类型
				// let mult = cfg.isMult;//是否多条
				var instance = cfg.oKey; //实例名
				if (!inInst && io == "I") {
					inInst = instance;
					data = objFct.get(instance);
				}
				if (!outInst && io == "O") {
					outInst = instance;
				}
				return inInst && outInst;
			});
			request.body = data;
	
			var response = { head: {}, body: {} };
			var sucfunc = function sucfunc(res) {
				// 赋值
				response = res || {};
				// session超时校验
				if (res && res.head && (res.head.code == '0405' || res.head.code == '0401')) {
					// 失效 重新登录
					if (tool && tool.logout) {
						// message.warning('登录超时，请重新登录');
						tool.popMessage("登录超时，请重新登录", "warning");
						tool.logout();
					}
					return;
				} else {
					// 成功，对象工厂赋值
					objFct.set(outInst, res.body);
				}
				// 回调
				if (callback && typeof callback == "function") callback(res);
			};
			var failfunc = function failfunc(xhr, textStatus, errorThrown) {
				_sgiLogger.sgiLogger.error("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
				response.head.code = xhr.status;
				response.head.msg = textStatus;
				// 回调
				if (callback && typeof callback == "function") callback(response);
			};
	
			var url = sgiConfig.service + "/" + path;
			request = tool.jsonToStr(request);
			sgiClient.restcall(url, reqType, request, header, flag, sucfunc, failfunc);
	
			return response;
		},
		/**
	    * 服务接口调用
	    * @param {string} SIID 服务接口guid
	    * @param {ObjFactory} objFct 对象工厂实例
	    * @param {boolean} flag 异步标识
	    * @param {function} callback 回调函数，(res)=>{}
	    * @param {string} reqType 服务调用类型，默认POST
	    */
		callSI: function callSI(SIID, objFct, req, flag, callback) {
			var reqType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "POST";
			var assistBody = arguments[6];
	
			if (!SIID || !objFct) return;
	
			//let path = prm.url; //服务地址
			// let type = prm.svType;
			// let app = prm.belong;
	
			var request = {
				head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {}
			};
			request.head.serviceId = SIID;
			request.head.cvt = "vi";
			// 增加辅助信息
			request.assistBody = assistBody;
	
			var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
			if (!header["Content-Type"]) header["Content-Type"] = "application/json; charset=utf-8";
	
			request.body = req;
	
			var response = { head: {}, body: {} };
			var sucfunc = function sucfunc(res) {
				// 赋值
				response = res || {};
				// session超时校验
				if (res && res.head && (res.head.code == "0405" || res.head.code == "0401")) {
					// 失效 重新登录
					if (tool && tool.logout) {
						// message.warning('登录超时，请重新登录');
						tool.popMessage("登录超时，请重新登录", "warning");
						tool.logout();
					}
					return;
				} else {}
				// 成功，对象工厂赋值
				//objFct.set(outInst, res.body);
	
				// 回调
				if (callback && typeof callback == "function") callback(res);
			};
			var failfunc = function failfunc(xhr, textStatus, errorThrown) {
				console.error("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
				response.head.code = xhr.status;
				response.head.msg = textStatus;
				// 回调
				if (callback && typeof callback == "function") callback(response);
			};
	
			//let url = sgiConfig.service + "/" + path;
	
			var url = sgiSrvUrl.service + "/bdl/invoke/" + SIID;
			request = tool.jsonToStr(request);
			sgiClient.restcall(url, reqType, request, header, flag, sucfunc, failfunc);
	
			return response;
		},
		/**
	  * 发送服务请求
	  * @param {string} path 服务地址
	  * @param {any} data 请求数据
	  * @param {function} callback 服务返回后回调
	  * @param {boolean} flag 异步标识，默认false
	  * @param {string} reqType 请求类型 POST|GET|···
	  * @param {function} aftercall 请求后处理 (res)=>void
	  * @param {function} beforecall 请求前处理 (request)=>void
	  */
		simplecall: function simplecall(path, data, callback, flag, reqType, aftercall, beforecall) {
			if (!path) {
				return;
			}
	
			//wzhe 2020-3-10
			//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
			var url = void 0;
			var siGuid = void 0;
			if (path.constructor === Object) {
				url = path.siUrl;
				siGuid = path.rlsGuid;
			} else {
				url = path;
			}
	
			var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
			//wzhe 2020-3-10
			//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
			request.head.serviceId = siGuid;
	
			if (data) {
				request.body = data;
			}
	
			if (beforecall) {
				beforecall(request);
			}
	
			request = tool.jsonToStr(request);
	
			var response = { head: {}, body: {} };
			var sucfunc = function sucfunc(res) {
				response = res;
	
				//session超时校验
				if (response && response.head && (response.head.code == '0405' || response.head.code == '0401')) {
					//失效 重新登录
					if (tool && tool.logout) {
						// message.warning('登录超时，请重新登录');
						tool.popMessage("登录超时，请重新登录", "warning");
						tool.logout();
					}
					return;
				}
	
				if (callback) {
					callback(res);
				}
				if (aftercall) {
					aftercall(res);
				}
			};
			var failfunc = function failfunc(xhr, textStatus, errorThrown) {
				_sgiLogger.sgiLogger.log("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
				response.head.code = xhr.status;
				response.head.msg = textStatus;
				if (callback) {
					callback(response);
				}
				if (aftercall) {
					aftercall(response);
				}
			};
			// let url = path;
	
			var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
			if (!reqType) {
				reqType = 'post';
				header['Content-Type'] = "application/json; charset=utf-8";
			}
			//wzhe 2020-3-10
			//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
			header.serviceId = siGuid;
	
			sgiClient.restcall(url, reqType, request, header, flag, sucfunc, failfunc);
	
			return response;
		},
	
		/**
	  * 缺省描述（请作者补充一下）
	  * @param {*} path 
	  * @param {*} request 
	  * @param {*} callback 
	  * @param {*} flag 
	  * @param {*} reqType 
	  * @param {*} aftercall 
	  * @param {*} beforecall 
	  */
		requestCall: function requestCall(path, request, callback, flag, reqType, aftercall, beforecall) {
			if (!path) {
				return;
			}
	
			if (request) {
				var head = request.head;
				if (!head) head = request.head = {};
				if (tool && tool.getLoginInfo) {
					Object.assign(head, tool.getLoginInfo());
				}
			} else {
				request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
			}
	
			if (beforecall) {
				beforecall(request);
			}
	
			request = tool.jsonToStr(request);
	
			var response = { head: {}, body: {} };
			var sucfunc = function sucfunc(res) {
				response = res;
	
				//session超时校验
				if (response && response.head && (response.head.code == '0405' || response.head.code == '0401')) {
					//失效 重新登录
					if (tool && tool.logout) {
						// message.warning('登录超时，请重新登录');
						tool.popMessage("登录超时，请重新登录", "warning");
						tool.logout();
					}
					return;
				}
	
				if (callback) {
					callback(res);
				}
				if (aftercall) {
					aftercall(res);
				}
			};
			var failfunc = function failfunc(xhr, textStatus, errorThrown) {
				_sgiLogger.sgiLogger.log("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
				response.head.code = xhr.status;
				response.head.msg = textStatus;
				if (callback) {
					callback(response);
				}
				if (aftercall) {
					aftercall(response);
				}
			};
			var url = path;
	
			var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
			if (!reqType) {
				reqType = 'post';
				header['Content-Type'] = "application/json; charset=utf-8";
			}
	
			sgiClient.restcall(url, reqType, request, header, flag, sucfunc, failfunc);
	
			return response;
		}
	
	};
	window.commonClient = commonClient;
	
	/**
	 * @namespace 参数服务请求方法集
	 * @alias sgiPfClient
	 */
	var sgiPfClient = {
		/**
	  * 缺省描述（请作者补充一下）
	  * @param {*} url 
	  * @param {*} method 
	  * @param {*} datas 
	  * @param {*} header 
	  * @param {*} async 
	  * @param {*} success 
	  * @param {*} failure 
	  * @param {*} callback 
	  */
		restcall: function restcall(url, method, datas, header, async, success, failure, callback) {
			url = url || 'http://pf.server.com/pf';
			datas = datas || {};
			datas.head = _extends({}, datas.head, tool && tool.getLoginInfo ? tool.getLoginInfo() : {});
			header = _extends({}, header, tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {});
			var head = header || {};
	
			async = async || false;
	
			var result = undefined;
			var successfunc = function successfunc(datas, textStatus, xhr) {
				result = datas;
				if (result && result.head && (result.head.code == '0405' || result.head.code == '0401')) {
					//失效 重新登录
					if (tool && tool.logout) {
						// message.warning('登录超时，请重新登录');
						tool.popMessage("登录超时，请重新登录", "warning");
						tool.logout();
					}
					return;
				}
				if (success) {
					success(datas, textStatus, xhr);
				}
			};
			var failfunc = function failfunc(xhr, textStatus, errorThrown) {
				_sgiLogger.sgiLogger.log("pfclient:状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
				if (failure) {
					failure(xhr, textStatus, errorThrown);
				}
			};
			_sgiLogger.sgiLogger.time("pfclient"); //计时器jqueryAjax开始
			sgiClient.jqueryAjax(url, method, datas, head, async, successfunc, failfunc, callback);
			_sgiLogger.sgiLogger.timeEnd("pfclient"); //计时器jqueryAjax结束
			return result;
		}
	
	};
	window.sgiPfClient = sgiPfClient;
	
	/**
	 * @namespace 服务调用方法集
	 * @alias sgiClient
	 */
	var sgiClient = {
	
		/**
	  * 缺省描述（请作者补充一下）
	  * @param {*} url 
	  * @param {*} method 
	  * @param {*} datas 
	  * @param {*} head 
	  * @param {*} async 
	  * @param {*} success 
	  * @param {*} failure 
	  * @param {*} callback 
	  * @param {*} callbefore 
	  */
		restcall: function restcall(url, method, datas, head, async, success, failure, callback, callbefore) {
			url = url || '';
			async = async || false;
			datas = datas || {};
			head = head || { 'Content-Type': "application/json; charset=utf-8" };
	
			this.jqueryAjax(url, method, datas, head, async, success, failure, callback, callbefore);
		},
		/**
	  * 缺省描述（请作者补充一下）
	  * @param {*} url 
	  * @param {*} method 
	  * @param {*} datas 
	  * @param {*} head 
	  * @param {*} async 
	  * @param {*} success 
	  * @param {*} failure 
	  * @param {*} callback 
	  * @param {*} callbefore 
	  */
		jqueryAjax: function jqueryAjax(url, method, datas, head, async, success, failure, callback, callbefore) {
			method = method.toUpperCase() || 'POST';
			if (method == "GET") {
				datas = undefined;
			}
			_jquery2.default.ajax({
				type: method,
				async: async,
				url: url,
				headers: head,
				data: datas,
				beforeSend: callbefore,
				success: success,
				error: failure,
				complete: callback
				// dataType: 'json'
			});
		}
	
		// ajax: function (url, method, datas, async, success, failure, callback) {
		// 	try {
		// 		method = method.toUpperCase() || 'POST';
		// 		url = url || '';
		// 		async = async || false;
		// 		datas = datas || {};
		// 		success = success || function () { };
		// 		failure = failure || function () { };
		// 		callback = callback || function () { };
	
		// 		var xmlHttp = null;
		// 		if (XMLHttpRequest) {
		// 			xmlHttp = new XMLHttpRequest();
		// 		} else {
		// 			xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
		// 		}
		// 		xmlHttp.withCredentials = true;
		// 		xmlHttp.onreadystatechange = function () {
		// 			if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
		// 				success(xmlHttp.responseText);
		// 			} else {
		// 				failure(xmlHttp.responseText);
		// 			}
		// 			callback(xmlHttp.responseText);
		// 		};
	
		// 		var params = [];
		// 		params.push("_method=" + method);
		// 		for (var key in datas) {
		// 			params.push(key + '=' + datas[key]);
		// 		}
		// 		var req = params.join('&');
		// 		if (method.toUpperCase() === 'GET') {
		// 			//xmlHttp.open('GET', url + '?' + req, async);
		// 			//xmlHttp.send(null);
		// 			xmlHttp.open('GET', url, async);
		// 			xmlHttp.send(req);
		// 		} else {
		// 			xmlHttp.open('POST', url, async);
		// 			xmlHttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8');
		// 			xmlHttp.send(req);
		// 		}
		// 	} catch (e) {
	
		// 	}
		// }
	};
	window.sgiClient = sgiClient;
	
	exports.sgiClient = sgiClient;
	exports.sgiPfClient = sgiPfClient;
	exports.commonClient = commonClient;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.tool = undefined;
	
	var _antd = __webpack_require__(296);
	
	var _moment = __webpack_require__(40);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(116);
	
	var _sgiConstants = __webpack_require__(198);
	
	var _sgiConstants2 = _interopRequireDefault(_sgiConstants);
	
	var _ComponentManager = __webpack_require__(348);
	
	var _localStorage = __webpack_require__(239);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _sgiClient = __webpack_require__(306);
	
	var sgiClient = _interopRequireWildcard(_sgiClient);
	
	var _sgiCommon = __webpack_require__(28);
	
	var sgiCommon = _interopRequireWildcard(_sgiCommon);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _StandardCode = __webpack_require__(81);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
	                                                                                                                                                                                                     * @Descripttion: 
	                                                                                                                                                                                                     * @version: 
	                                                                                                                                                                                                     * @Author: somebody
	                                                                                                                                                                                                     * @Date: 2019-11-21 14:58:03
	                                                                                                                                                                                                     * @LastEditors: kanhin
	                                                                                                                                                                                                     * @LastEditTime: 2024-06-05 14:35:04
	                                                                                                                                                                                                     */
	
	// import sgiConfig from '../sgiConfig/sgiConfig';
	
	
	var confirm = _antd.Modal.confirm; //使用 confirm() 可以快捷地弹出确认框
	
	/**
	 * 导入全局Moment
	 * @namespace 全局使用moment对象
	 * @alias Moment
	 */
	var Moment = _moment2.default;
	window.Moment = Moment;
	
	/**
	 * 
	 * @param {*} ctl 
	 * 
	 * @ignore
	 */
	var refModalFunction = function refModalFunction(ctl) {
	
		if (!ctl) {
			return;
		}
		var _ctl$props = ctl.props,
		    moduleDesc = _ctl$props.moduleDesc,
		    objFct = _ctl$props.objFct;
	
		var mainComp = _ComponentManager.ComponentManager.get(objFct.getUID(), objFct.getUID());
		mainComp.setModal(ctl);
	};
	/**
	 * 弹出组件与父组件使用不同对象工厂时使用
	 * @param {*} ctl 
	 * 
	 * @ignore
	 */
	var refModalFunction2 = function refModalFunction2(ctl) {
	
		if (!ctl) {
			return;
		}
		var _ctl$props2 = ctl.props,
		    moduleDesc = _ctl$props2.moduleDesc,
		    objFct = _ctl$props2.objFct;
	
		var pObjFct = objFct.getParent();
		if (pObjFct) {
			var mainComp = _ComponentManager.ComponentManager.get(pObjFct.getUID(), pObjFct.getUID());
			mainComp.setModal(ctl);
		}
	};
	
	/**
	 * tool工具函数,全局方法
	 * @namespace 通用工具函数.
	 */
	var tool = { //注意：这里暂时不能使用let，否则jsdoc-toolkit没办法正确识别构建jsdoc帮助文档！ [hanzb 2020-4-2]
	
		/**
	  * @namespace 全局变量
	  */
		Global: {
			/**
	   * 当前系统ap值
	   */
			// currentAP: sgiLocalStorage.get('currentAP') || sgiConfig.currentAP
			currentAP: sgiSrvUrl.currentAP
		},
		sgiStorage: _localStorage.sgiLocalStorage,
		sgiLogger: _sgiLogger.sgiLogger,
		/**
	  * 根据组件标识cid，获取组件实例
	  * @param {string} cid 组件标识
	  * @param {ObjFactory} objFct 对象工厂
	  * @returns {object} 组件实例
	  *  
	  * @group ctl
	  * @example 例：
	  * let panel = tool.getCmp("cid_panel_left", objFct);
	  */
		getCmp: function getCmp(cid, objFct) {
			if (!cid || !objFct) {
				return;
			}
			var uid = objFct.getUID();
			if (!uid) {
				return;
			}
			return _ComponentManager.ComponentManager.get(uid, cid);
		},
		/**
	  * 根据wv/form组件id刷新wv/form数据
	  * @param {string} wvId wv/form组件标识id
	  * @param {ObjFactory} objFct 对象工厂
	  * @returns {boolean} 刷新是否成功 刷新成功：true 刷新失败：false
	  * 
	  * @group form
	  * @example 例:
	  * objFct.set("db_wv_condition", {});
	  * tool.refreshWV("cid_wv_condition", objFct);
	  */
		refreshWV: function refreshWV(wvId, objFct) {
			if (!wvId || !objFct) {
				return false;
			}
			var uid = objFct.getUID();
			if (!uid) {
				return false;
			}
			var wv = _ComponentManager.ComponentManager.get(uid, wvId);
			if (wv) {
				if (wv.props.setActiveWV) {
					wv.props.setActiveWV(wvId);
				}
				wv.refreshValues();
				return true;
			}
		},
		/**
	  * 通用控件刷新，支持form、表格、树、平铺、echarts
	  * @param {string} ctlId 组件id
	  * @param {ObjFactory} objFct 对象工厂实例
	  * @param {boolean} clearFlg 清空勾选标识
	  * 
	  * @group _global_
	  * @example
	  * 刷新form：
	  * objFct.set("db_wv_condition", {});
	  * tool.commonRefresh("cid_wv_condition", objFct);
	  * 
	  * 刷新树：
	  * objFct.set("db_tr_prm", []);
	  * tool.commonRefresh("cid_tr_prm", objFct);
	  * // tool.commonRefresh("cid_tr_prm", objFct, true);// 带checkbox勾选的树，清空上次勾选
	  * 
	  * 刷新表格：
	  * objFct.set("db_tb_prm", []);
	  * tool.commonRefresh("cid_tb_prm", objFct);
	  * // tool.commonRefresh("cid_tb_prm", objFct, true);// 带checkbox勾选的表格，清空上次勾选
	  * 
	  * 刷新平铺/echarts：
	  * objFct.set("db_list_prm", []);
	  * tool.commonRefresh("cid_list_prm", objFct);
	  */
		commonRefresh: function commonRefresh(ctlId, objFct, clearFlg) {
			if (!ctlId || !objFct) return;
	
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) return;
	
			// 刷新form
			if (ctl.refreshValues) {
				if (ctl.props.setActiveWV) ctl.props.setActiveWV(ctlId);
				ctl.refreshValues();
				return;
			}
			// 刷新树
			if (ctl.refreshTree) {
				var treeData = objFct.get(ctl.state.insName) || [];
				if (clearFlg) ctl.state.checkedNodes = [];
				ctl.refreshTree(treeData);
				return;
			}
			// 刷新表格
			if (ctl.refreshTable) {
				var tableData = objFct.get(ctl.state.insName) || [];
				ctl.refreshTable(tableData);
				if (clearFlg) ctl.state.selectedRows = [];
				return;
			}
			// 刷新平铺/echarts
			if (ctl.refreshByData) {
				var data = objFct.get(ctl.state.insName) || [];
				ctl.refreshByData(data);
				return;
			}
		},
		/**
	  * 刷新dv控件，动态更新绑定dvid或者绑定dv描述
	  * @param {string} ctlId dv控件id
	  * @param {string|object} bdDv 绑定dvid或者绑定dv描述
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group dv
	  * @example
	  * 动态更新绑定dvid：
	  * tool.refreshDVByBdDv("cid_dv_cond", "sd_DSD_1199619114738384896_0001", objFct);
	  * 动态更新dv描述：
	  * // 组装一个参数
	  * // let dvPrm = {
	  * // 	cldSet: [
	  * // 		{ desId: "EP_EO_UI_3101", c: "code", te: "编码" },
	  * // 		{ desId: "EP_EO_UI_3107", c: "gender", te: "性别", scId: "sd_SC_common_0001" },
	  * // 	]
	  * // };
	  * let dvPrm = PrmFactory.getPrm("sd_DSD_1199619114738384896_0001"); // 查询一个参数
	  * tool.refreshDVByBdDv("cid_dv_cond", dvPrm, objFct);
	  */
		refreshDVByBdDv: function refreshDVByBdDv(ctlId, bdDv, objFct) {
			if (!ctlId || !bdDv || !objFct) return;
			var ctl = this.getCmp(ctlId, objFct);
			if (ctl) {
				ctl.refreshByBdDv(bdDv);
			}
		},
		/**
	  * 刷新tv控件，动态更新绑定tvid或者绑定tv描述
	  * @param {string} ctlId tv控件id
	  * @param {string|object} bdTv 绑定tvid或者绑定的tv描述
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group tv
	  * @example
	  * 动态更新绑定tvid：
	  * tool.refreshTVByBdTv("cid_tv_result", "sd_DSD_1199619114738384896_0001", objFct);
	  * 动态更新tv描述：
	  * // 组装一个参数
	  * // let tvPrm = {
	  * // 	cldSet: [
	  * // 		{ desId: "EP_EO_UI_3101", c: "code", te: "编码", isEd: true },
	  * // 		{ desId: "EP_EO_UI_3107", c: "gender", te: "性别", scId: "sd_SC_common_0001" },
	  * // 	]
	  * // };
	  * let tvPrm = PrmFactory.getPrm("sd_DSD_1199619114738384896_0001"); // 查询一个参数
	  * tool.refreshTVByBdTv("cid_tv_result", tvPrm, objFct);
	  */
		refreshTVByBdTv: function refreshTVByBdTv(ctlId, bdTv, objFct) {
			if (!ctlId || !bdTv || !objFct) return;
			var ctl = this.getCmp(ctlId, objFct);
			if (ctl) {
				ctl.refreshByBdTv(bdTv);
			}
		},
		/**
	  * 动态刷新嵌入面板
	  * @param {string} ctlId 嵌入面板id
	  * @param {string|object} ui 嵌入UI的guid或描述
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group nest
	  * @example
	  * 动态更新绑定页面guid：
	  * tool.refreshNestByUI("cid_nt_dynamic", "sd_UI_common_0001", objFct);
	  * 动态更新绑定页面描述：
	  * // 组装一个参数
	  * // let prm = {
	  * // 	desId: "EP_EO_UI_0001",
	  * // 	ctlN: "UCV",
	  * // 	cldSet: [
	  * // 		{ desId: "EP_EO_UI_4001", ctlN: "普通面板" },
	  * // 		{ desId: "EP_EO_UI_4101", ctlN: "分割面板" },
	  * // 	]
	  * // };
	  * let prm = PrmFactory.getPrm("sd_UI_common_0001"); // 查询一个参数
	  * tool.refreshNestByUI("cid_nt_dynamic", prm, objFct);
	  */
		refreshNestByUI: function refreshNestByUI(ctlId, ui, objFct) {
			if (!ctlId || !ui || !objFct) return;
			var ctl = this.getCmp(ctlId, objFct);
			if (ctl) {
				ctl.refreshByUI(ui);
			}
		},
		/**
	  * 根据wv/form组件id校验表单信息合法性
	  * @param {string} wvid wv/form组件id
	  * @param {ObjFactory} objFct 对象工厂
	  * @returns {boolean} true-合法，false-不合法
	  * 
	  * @group form
	  * @example
	  * let flag = tool.isValid("cid_dv_info", objFct);
	  * if (!flag) {
	  * 	tool.popMessage("输入项不符合要求，请检查后重新输入！", "warning");
	  * 	return;
	  * }
	  */
		isValid: function isValid(wvid, objFct) {
			var wv = this.getCmp(wvid, objFct);
			if (!wv || !wv.validateFields) {
				return false;
			}
			return wv.validateFields();
		},
	
		/**
	  * 设置form组件是否为仅显示样式
	  * @author hanzb
	  * @param {String} wvid 表单id
	  * @param {boolean} isLabel 是否仅显示
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group form
	  * @example
	  * // 设置整个表单为仅显示样式
	  * tool.setFormIsLabel("cid_dv_info", true, objFct);
	  * // 取消仅显示
	  * tool.setFormIsLabel("cid_dv_info", false, objFct);
	  */
		setFormIsLabel: function setFormIsLabel(wvid, isLabel, objFct) {
			var wv = this.getCmp(wvid, objFct);
			if (!wv || !wv.setIsLabel) return;
			wv.setIsLabel(isLabel);
		},
	
		/**
	  * 设置文件控件 还原方法
	  * @author wangz
	  * @param {String} wvid 表单id
	  * @param {boolean} isLabel 是否仅显示
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group upload
	  * @example
	  * let fileList = [];
	  * encls.forEach(e => fileList.push({
	  * 	url: e.enclUrl, //文件地址，必须
	  * 	name: e.enclNam, //文件名称，必须
	  * 	uid: e.enclId, //id，必须
	  * 	status: "done", //文件状态，必须
	  * }));
	  * tool.setFileList('id_upload_reqCollect_encl', fileList, objFct);
	  */
		setFileList: function setFileList(wvid, fileList, objFct) {
			var fileCtl = this.getCmp(wvid, objFct);
			if (!fileCtl) return;
			fileCtl.setFileList(fileList);
		},
	
		/**
	  * 按钮控件添加角标
	  * @param {String} buttonId 按钮id
	  * @param {*} badge 角标
	  * @param {ObjFactory} objFct 对象工厂实例
	  * 
	  * @group button
	  * @example
	  * tool.setBadge("cid_btn", 5, objFct);
	  */
		setBadge: function setBadge(buttonId, badge, objFct) {
			var button = this.getCmp(buttonId, objFct);
			if (!button || !button.setBadge) return;
			button.setBadge(badge);
		},
	
		/**
	  * 弹出单按钮文本信息对话框
	  * @param {string} title 对话框标题
	  * @param {string} msg 对话框文本内容
	  * @param {function} callbackClose 对话框关闭事件
	  * @param {info|success|error|warning|confirm} [state="info"] 对话框类型,显示图标不同，默认info
	  * @param {string} [okText="确定"] 确认按钮文本内容，默认确定
	  * 
	  * @group _global_
	  * @example
	  * // 默认对话框提示
	  * tool.popMsgDialog("title", "message");
	  * // 等同于
	  * tool.popMsgDialog("title", "message", onClose, "info", "okText");
	  * // 成功提示
	  * tool.popMsgDialog("title", "message", onClose, "success", "okText");
	  * // 警告提示
	  * tool.popMsgDialog("title", "message", onClose, "warning", "okText");
	  * // 错误提示
	  * tool.popMsgDialog("title", "message", onClose, "error", "okText");
	  * // 确认提示
	  * tool.popMsgDialog("title", "message", onClose, "confirm", "okText");
	  */
		popMsgDialog: function popMsgDialog(title, msg, callbackClose, state, okText) {
			var something = {
				title: title,
				content: msg,
				onOk: callbackClose,
				okText: okText
			};
			switch (state) {
				case "info":
				default:
					_antd.Modal.info(something);
					break;
				case "success":
					_antd.Modal.success(something);
					break;
				case "error":
					_antd.Modal.error(something);
					break;
				case "warning":
					_antd.Modal.warning(something);
					break;
				case "confirm":
					_antd.Modal.confirm(something);
					break;
			}
		},
		/**
	  * 弹出双按钮确认对话框
	  * @param {string} title 对话框标题
	  * @param {string} msg 对话框内容
	  * @param {function} callbackCancel 取消按钮点击回调函数
	  * @param {function} callbackConfirm 确认按钮点击回调函数
	  * @param {string} [cancelText="取消"] 取消按钮文字，默认：取消
	  * @param {string} [okText="确定"] 确认按钮文字，默认：确定
	  * 
	  * @group _global_
	  * @example
	  * tool.popConfirmDialog("title", "content", onCancel, onConfirm, "cancelText", "okText");
	  */
		popConfirmDialog: function popConfirmDialog(title, msg, callbackCancel, callbackConfirm, cancelText, okText) {
			confirm({
				title: title,
				content: msg,
				onCancel: callbackCancel,
				onOk: callbackConfirm,
				cancelText: cancelText,
				okText: okText
			});
		},
		/**
	  * loading提示，带有mask遮罩
	  * @param {string} msg loading提示信息
	  * @returns {Modal.info} 销毁时调用info.destroy();
	  * 
	  * @group _global_
	  * @example
	  * // 提示loading
	  * let loading = tool.popLoading("message");
	  * // 销毁
	  * loading.destroy();
	  */
		popLoading: function popLoading(msg) {
			return _antd.Modal.info({
				content: msg,
				icon: "loading",
				className: "sgiLoading",
				okButtonProps: { style: { display: "none" } },
				cancelButtonProps: { style: { display: "none" } },
				height: undefined,
				width: "fit-content"
			});
		},
		/**
	  * 信息提示
	  * @param {string} content 提示内容
	  * @param {success|error|info|warning|warn|loading} [state="info"] 提示的类型，默认“info”
	  * @param {function} [onClose] 关闭事件
	  * @param {number} [duration=3] 自动关闭延时，默认3秒
	  * 
	  * @group _global_
	  * @example 
	  * // 成功提示
	  * tool.popMessage("some message", "success");
	  * // 错误提示
	  * tool.popMessage("some message", "error");
	  * // loading提示
	  * let hide = tool.popMessage("some message", "loading", onClose, 5);
	  * // 主动关闭loading
	  * hide();
	  */
		popMessage: function popMessage(content, state, onClose, duration) {
	
			// 设置最大显示数, 超过限制时，最早的消息会被自动关闭
			_antd.message.config({ maxCount: sgiConfig.popMessageMaxCount || 1 });
	
			var result = void 0;
			switch (state) {
				case "info":
				default:
					result = _antd.message.info(content, duration, onClose);
					break;
				case "success":
					result = _antd.message.success(content, duration, onClose);
					break;
				case "error":
					result = _antd.message.error(content, duration, onClose);
					break;
				case "warning":
					result = _antd.message.warning(content, duration, onClose);
					break;
				case "warn":
					result = _antd.message.warn(content, duration, onClose);
					break;
				case "loading":
					result = _antd.message.loading(content, duration, onClose);
					break;
			}
			return result;
		},
		/**
	  * 通用的弹出窗体，使用任何页面作为弹出窗，可以指定高度宽度
	  * @param {string} uid 页面guid
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {string} [curtitle] 指定标题
	  * @param {number|string} [width] 指定宽度
	  * @param {number|string} [height] 指定高度
	  * 
	  * @group _global_
	  * @example
	  * // 普通调用
	  * tool.popUI("guid", objFct, "tittle");
	  * // 控制宽高
	  * tool.popUI("guid", objFct, "tittle", width, height);
	  */
		popUI: function popUI(uid, objFct, curtitle, width, height) {
			var mainComp = this.getCmp(objFct.getUID(), objFct);
			mainComp.addModalByProps({
				ref: refModalFunction,
				onCancel: mainComp.removeModal.bind(mainComp),
				key: sgiCommon.uuid(8),
				uid: uid,
				objFct: objFct,
				curtitle: curtitle,
				visible: true,
				width: width,
				height: height
			});
			// <SgiModal
			// 	ref={refModalFunction}
			// 	onCancel={mainComp.removeModal.bind(mainComp)}
			// 	key={sgiCommon.uuid(8)} uid={uid} objFct={objFct}
			// 	curtitle={curtitle} visible={true}
			// 	width={width} height={height} />);
	
			mainComp.setState({ loading: false });
		},
		/**
	  * 【独立对象工厂】通用的弹出窗体，使用任何页面作为弹出窗，可以指定高度宽度
	  * @param {string} uid 页面id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {string} [curtitle] 指定标题
	  * @param {object} [transferData] 新对象工厂需要赋的初始值
	  * @param {number|string} [width] 指定宽度
	  * @param {number|string} [height] 指定高度
	  * 
	  * @group _global_
	  * @example
	  * // 独立对象工厂，普通调用
	  * tool.popUI2("guid", objFct, "tittle", { record });
	  * // 控制宽高
	  * tool.popUI2("guid", objFct, "tittle", { record }, width, height);
	  */
		popUI2: function popUI2(uid, objFct, curtitle, transferData, width, height) {
			var mainComp = this.getCmp(objFct.getUID(), objFct);
			var newObjFct = new _ObjFactory.ObjFactory(uid, transferData, objFct);
			mainComp.addModalByProps({
				ref: refModalFunction2,
				onCancel: mainComp.removeModal.bind(mainComp),
				key: sgiCommon.uuid(8),
				uid: uid,
				objFct: newObjFct,
				curtitle: curtitle,
				visible: true,
				width: width,
				height: height
			});
			// mainComp.addModal(
			// 	<SgiModal
			// 		ref={refModalFunction2}
			// 		onCancel={mainComp.removeModal.bind(mainComp)}
			// 		key={sgiCommon.uuid(8)} uid={uid} objFct={newObjFct}
			// 		curtitle={curtitle} visible={true}
			// 		width={width} height={height} />);
	
			mainComp.setState({ loading: false });
		},
		/**
	  * 通用页面切换，由各平台自行实现
	  * @param {string} uid 页面guid
	  * @param {object} transferData 像新页面对象工厂传递的json数据
	  * @param {string} [curtitle] 指定标题
	  * @abstract 各平台自行实现
	  * 
	  * @group _global_
	  * @example
	  * tool.popUIByUcv("sd_UI_common_0001", { record }, "xxx页面");
	  */
		popUIByUcv: function popUIByUcv(uid, transferData, curtitle) {
			//由相应的平台自主实现,无法做公共的
		},
		/**
	  * 关闭最后一个弹出窗体
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group _global_
	  * @example
	  * // 相同对象工厂
	  * tool.popClose(objFct);
	  * // 不同对象工厂
	  * let pObjFct = objFct.getParent();
	  * tool.popClose(pObjFct);
	  */
		popClose: function popClose(objFct) {
			var mainComp = this.getCmp(objFct.getUID(), objFct);
			var sgiModal = mainComp.getModal();
			if (!sgiModal) {
				return;
			}
			sgiModal.onCancel();
			mainComp.removeModal();
			mainComp.setState({ loading: false });
		},
	
		/**
	  * 现行事件集外部调用方法
	  * @param {string} name 事件集中函数调用名
	  * @param {ObjFactory} objFct 对象工厂
	  * @param  {...any} args 要向调用的方法中传入的参数
	  * 
	  * @group _global_
	  * @example
	  * tool.callFun("init", objFct, arg1, arg2, arg3...);
	  */
		callFun: function callFun(name, objFct) {
			_sgiLogger.sgiLogger.debug('[callFun]\u6267\u884C\u4E8B\u4EF6\u96C6\u65B9\u6CD5[' + name + ']');
			if (!name || !objFct) {
				_sgiLogger.sgiLogger.debug('[callFun]\uFF1A\u4F20\u5165\u53C2\u6570\u3010name\u3011\u6216\u3010objFct\u3011\u4E3A\u7A7A');
				return;
			}
			var funs = objFct.get("@funs");
	
			for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
				args[_key - 2] = arguments[_key];
			}
	
			if (funs && funs[name] && typeof funs[name] === "function") return funs[name].apply(funs, args);else _sgiLogger.sgiLogger.debug('[callFun]\uFF1A\u627E\u4E0D\u5230\u65B9\u6CD5\u540D\u4E3A\u3010' + name + '\u3011\u7684\u65B9\u6CD5\uFF0C\u8BF7\u68C0\u67E5\u4E8B\u4EF6\u96C6\u4E2D\u662F\u5426\u5B58\u5728\u5176\u5B9A\u4E49');
		},
	
		/**
	  * 现行事件集常量外部获取方法
	  * @param {string} name 事件集中常量名
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group _global_
	  * @example
	  * let AP = tool.getConst("AP", objFct);
	  */
		getConst: function getConst(name, objFct) {
			_sgiLogger.sgiLogger.debug('[getConst]\u83B7\u53D6\u5E38\u91CF[' + name + ']');
			if (!name || !objFct) {
				_sgiLogger.sgiLogger.debug('[getConst]\uFF1A\u4F20\u5165\u53C2\u6570\u3010name\u3011\u6216\u3010objFct\u3011\u4E3A\u7A7A');
				return;
			}
			var cnsts = objFct.get("@cnsts") || {};
			return cnsts[name];
		},
	
		/**
	  * 递归遍历所有节点，执行foreach【注意：请勿操作childName对应结构，否则可能造成死循环】（注意：不会中断，全部遍历）
	  * @param {Array} [items=[]] 需要遍历的json数组，可以带层级
	  * @param {Function} foreach 遍历到的每一项执行的操作，function(item,index,arr)
	  * @param {string} [childName="cldSet"] 层级结构属性名，默认“cldSet”
	  * 
	  * @group _global_
	  * @example
	  * tool.itemForEach(items, (item, index, arr) => {  每一项的操作  });
	  */
		itemForEach: function itemForEach() {
			var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
			var _this = this;
	
			var foreach = arguments[1];
			var childName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "cldSet";
	
			if (!foreach || typeof foreach !== "function") {
				_sgiLogger.sgiLogger.debug('tool\u65B9\u6CD5[itemForEach]\uFF1A\u4F20\u5165\u51FD\u6570\u3010foreach\u3011\u4E3A\u7A7A');
				return;
			}
			items.forEach(function (item, index, arr) {
				foreach(item, index, arr);
				var cldSet = item[childName];
				if (cldSet && cldSet.length > 0) _this.itemForEach(cldSet, foreach, childName);
			});
		},
		/**
	  * 递归遍历(every遍历)所有节点，执行foreach（注意：返回false则中断）
	  * @param {Array} [items=[]] 需要遍历的json数组，可以带层级
	  * @param {Function} foreach 遍历到的每一项执行的操作，function(item,index,arr)
	  * @param {string} [childName="cldSet"] 层级结构属性名，默认“cldSet”
	  * 
	  * @group _global_
	  * @example
	  * tool.itemForEvery(items, (item, index, arr) => {  每一项的操作，返回false终止  });
	  */
		itemForEvery: function itemForEvery() {
			var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
			var _this2 = this;
	
			var foreach = arguments[1];
			var childName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "cldSet";
	
			if (!foreach || typeof foreach !== "function") {
				_sgiLogger.sgiLogger.debug('tool\u65B9\u6CD5[itemForEvery]\uFF1A\u4F20\u5165\u51FD\u6570\u3010foreach\u3011\u4E3A\u7A7A');
				return;
			}
			items.every(function (item, index, arr) {
				if (!foreach(item, index, arr)) return false;
				var cldSet = item[childName];
				if (cldSet && cldSet.length > 0) {
					if (!_this2.itemForEvery(cldSet, foreach, childName)) return false;
				}
			});
		},
		/**
	  * 递归遍历(some遍历)所有节点，执行foreach（注意：返回true则中断）
	  * @param {Array} [items=[]] 需要遍历的json数组，可以带层级
	  * @param {Function} foreach 遍历到的每一项执行的操作，function(item,index,arr)
	  * @param {string} [childName="cldSet"] 层级结构属性名，默认“cldSet”
	  * 
	  * @group _global_
	  * @example
	  * tool.itemForEvery(items, (item, index, arr) => {  每一项的操作，返回true终止  });
	  */
		itemForSome: function itemForSome() {
			var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
			var _this3 = this;
	
			var foreach = arguments[1];
			var childName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "cldSet";
	
			if (!foreach || typeof foreach !== "function") {
				_sgiLogger.sgiLogger.debug('tool\u65B9\u6CD5[itemForSome]\uFF1A\u4F20\u5165\u51FD\u6570\u3010foreach\u3011\u4E3A\u7A7A');
				return;
			}
			items.some(function (item, index, arr) {
				if (foreach(item, index, arr)) return true;
				var cldSet = item[childName];
				if (cldSet && cldSet.length > 0) {
					if (_this3.itemForSome(cldSet, foreach, childName)) return true;
				}
			});
		},
	
		/**************** 以上弹出窗部分 ****************/
		/**************** 以下浏览器跳转部分 ****************/
	
		/**
	  * 路由跳转
	  * @param {string} pathname 路径path
	  * @param {object} [data] state
	  * 
	  * @group _global_
	  * @example
	  * tool.browserPush("/dev/UIEditor", { record });
	  */
		browserPush: function browserPush(pathname, data) {
			if (!pathname) {
				return;
			}
			_reactRouter.browserHistory.push({
				pathname: pathname,
				state: data
			});
		},
	
		/**
	  * 
	  * @param {*} contentOrPath 
	  * @param {*} fileName 
	  * 
	  * @ignore
	  */
		IEdownloadFile: function IEdownloadFile(contentOrPath, fileName) {
			if (!contentOrPath) {
				return;
			}
			var aLink = document.createElement("a"),
			    evt = document.createEvent("MouseEvent");
	
			evt.initEvent("click", false, false);
			if (fileName) {
				aLink.download = fileName;
			}
			aLink.href = contentOrPath;
			aLink.dispatchEvent(evt);
		},
		/**
	  * 	
	  * @param {*} contentOrPath 
	  * @param {*} fileName 
	  * 
	  * @ignore
	  */
		downloadFile: function downloadFile(contentOrPath, fileName) {
			var imgPath = "download?path=" + contentOrPath;
			this.IEdownloadFile(imgPath, fileName);
		},
	
		/**************** 以上浏览器跳转部分 ****************/
		/**************** 以下树控件方法部分 ****************/
	
		/**
	  * 刷新树
	  * @param {string} treeId 树控件id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {boolean} clearFlg 是否清除现有勾选
	  * 
	  * @group tree
	  * @example
	  * objFct.set("db_tr_prm", []);
	  * tool.commonRefresh("cid_tr_prm", objFct);
	  * // tool.commonRefresh("cid_tr_prm", objFct, true);// 带checkbox勾选的树，清空上次勾选
	  */
		refreshTree: function refreshTree(treeId, objFct, clearFlg) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			var treeData = objFct.get(tree.state.insName);
			if (!treeData) {
				treeData = [];
			}
			if (clearFlg) tree.state.checkedNodes = [];
			tree.refreshTree(treeData);
		},
		/**
	  * 动态添加自定义菜单
	  * @param {string} treeId 树控件id
	  * @param {*} customMenuItems 例子：[{icon:'',mnCLsn:function("module", "objFct", "record", "treeNode"),te:''}]
	  * @param {*} flag 
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * Probably the method added by Wangz
	  * //动态设置menu
	  * let menuList = [];
	  * bruSelData.forEach(element => {
	  *	 menuList.push({ icon: 'plus', mnCLsn: menuMnCLsn.bind(this, element.id), te: element.nam });
	  * });
	  * tool.addCustomMenuItems('cid_tree_xrainfo', menuList, false, objFct);
	  */
		addCustomMenuItems: function addCustomMenuItems(treeId, customMenuItems, flag, objFct) {
			if (!treeId) {
				return;
			}
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			return tree.addCustomMenuItems(customMenuItems, flag);
		},
		/**
	  * 获取已选中/勾选节点
	  * @param  {string} treeId 树控件id
	  * @param  {ObjFactory} objFct 对象工厂
	  * @return {object[]} 已选中/勾选的节点数据数组
	  * 
	  * @group tree
	  * @example
	  * let list = tool.getSelection("cid_tr", objFct);
	  */
		getSelection: function getSelection(treeId, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			return tree.getSelection();
		},
		/**
	  * 选中树的某个节点
	  * @param  {string} treeId 树控件id
	  * @param  {object} record 树节点数据信息，含有key值
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.select('SCprmsTree',record,objFct);
	  * record为单击事件中的record,结构如下:
	  * record = { _key:"……",
	  *			//_pKey:"……",
	  *			节点的数据信息}
	  */
		select: function select(treeId, record, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			tree.select(record);
		},
		/**
	  * 选中树的某个节点
	  * @param {string} treeId 树控件id
	  * @param {object} record 树节点数据信息
	  * @param {string} key 查找节点依据key
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.selectByData("channelTree", prmClds[0], "channelCode", objFct);
	  */
		selectByData: function selectByData(treeId, record, key, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			var inRecords = tree.getTreeRecord(record, key);
			tree.select(inRecords[0]);
		},
		/**
	  * 选中首行树节点
	  * @param {string} treeId  树控件id
	  * @param {ObjFactory} objFct  对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.selFirst("id_org_tree_010010",objFct);
	  */
		selFirst: function selFirst(treeId, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			tree.selFirst();
		},
		/**
	  * 根据record checked树上这些节点
	  * key值如果不为空，遍历所有节点，根据key属性，找到与records相同的值，这些records checked
	  * 如果为空，默认这些record就是树上的records，直接选中
	  * @param {string} treeId 树控件id
	  * @param {object[]} records 要勾选的数组
	  * @param {string} key 勾选比对的key值
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.setTreeChecked("cid_tree", [{id:'1'}], 'id', objFct);
	  */
		setTreeChecked: function setTreeChecked(treeId, records, key, objFct) {
			if (!records) return;
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			if (key) {
				var inRecords = tree.getTreeRecord(records, key);
				tree.setTreeChecked(inRecords);
			} else {
				tree.setTreeChecked(records);
			}
		},
	
		/**
	  * 动态设置树是否可以勾选
	  * @param {string} treeId 树id
	  * @param {boolean} checkable 是否可勾选
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.setTreeCheckable("cid_tree", true||fasle, objFct);
	  */
		setTreeCheckable: function setTreeCheckable(treeId, checkable, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			tree.setCheckable(checkable);
		},
	
		/**
	  * 获取树的勾选数据(树结构json数据)
	  * @param {string} treeId 树控件id
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.getTreeCheckData("cid_tree", objFct);
	  */
		getTreeCheckData: function getTreeCheckData(treeId, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			return tree.getCheckData();
		},
		/**
	  * 设置树的勾选数据(树结构json数据)
	  * @param {string} treeId 树控件id
	  * @param {object[]} checkData 树结构勾选数据
	  * @param {string} key 勾选比对的key值
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {object[]} [treeData] 树数据数组
	  * 
	  * @group tree
	  * @example
	  * tool.setTreeCheckData("cid_tree", [{c:'1'}], "c", objFct);
	  */
		setTreeCheckData: function setTreeCheckData(treeId, checkData, key, objFct, treeData) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			return tree.setCheckData(checkData, key, treeData);
		},
	
		/**
	  * 展开树的某个节点
	  * @param  {string} treeId 树控件id
	  * @param  {object} record 树节点数据信息，含有key值
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.expand('cid_tree_0002',record,objFct);
	  * record为单击事件中的record,结构如下:
	  * {
	  * 	_key: '...',
	  *  _pKey: '...',
	  *  其他数据信息
	  * }
	  */
		expand: function expand(treeId, record, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			tree.expand(record);
		},
		/**
	  * 展开树的某个节点
	  * @param  {string} treeId 树控件id
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.expandAll('cid_tree_0002', objFct);
	  */
		expandAll: function expandAll(treeId, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			tree.expandAll();
		},
		/**
	  * 删除树的选中数据
	  * @param  {string} treeId 树控件id
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.delTreeSel('cid_tree_0002', objFct);
	  */
		delTreeSel: function delTreeSel(treeId, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			tree.delTreeSel();
		},
		/**
	  * 删除树的一个节点
	  * @param  {string} treeId 树控件id
	  * @param  {object} node record节点数据信息
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.delTreeNode('cid_tree_0002', record, objFct);
	  */
		delTreeNode: function delTreeNode(treeId, node, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			tree.delTreeNode(node);
		},
		/**
	 * 获取所有叶子节点
	 * @param {object} record 当前节点数据record
	 * @param {string} [childCode="cldSet"] 子节点属性编码，默认“cldSet”
	 * @returns {object[]} 返回的叶子节点数组
	 * 
	 * @group tree
	 * @example
	 * tool.getAllLeaf(treeRecord, 'cldSet');
	 */
		getAllLeaf: function getAllLeaf(record, childCode) {
			var _this4 = this;
	
			if (!record) return null;
			var cldCode = childCode || "cldSet";
			var leaf = [];
			if (record[cldCode]) {
				var clds = record[cldCode];
				clds.forEach(function (cld) {
					var rLeaf = _this4.getAllLeaf(cld, childCode); //不+this调不到
					leaf.push.apply(leaf, _toConsumableArray(rLeaf));
				});
			} else {
				leaf.push(record);
			}
			return leaf;
		},
		/**
	  * 根据列表数据组装树结构对象
	  * @param {object[]} datas  列表数据数组
	  * @param {string} id  节点属性key
	  * @param {string} pid  父节点属性key
	  * @param {string} treeId  树控件id
	  * @param {object} virtual  虚拟根节点对象，null时为无虚拟根节点
	  * @param {ObjFactory} objFct  对象工厂
	  * @returns {object[]} treeData 带有层级关系的树数据数组
	  * 
	  * @group _global_
	  * @example
	  * tool.ctTrStrByData(list, "id", "pid", "treeId", virtual, objFct);
	  */
		ctTrStrByData: function ctTrStrByData(datas, id, pid, treeId, virtual, objFct) {
			//eoid, 
	
			var treeData = {};
			// 刷新树，并放数据
			var tree = this.getCmp(treeId, objFct);
			var childrenName = void 0;
			if (tree) {
				childrenName = tree.state.childrenName;
				treeData = this.ctListToTreeJson(datas, id, pid, childrenName, virtual);
				tree.refreshTree(treeData);
				objFct.set(tree.state.insName, treeData);
			} else {
				treeData = this.ctListToTreeJson(datas, id, pid, null, virtual);
			}
	
			return treeData;
		},
		/**
	  * 根据列表数据组装树结构对象
	  * @param {object[]} datas  列表数据数组
	  * @param {string} id  节点属性key
	  * @param {string} pid  父节点属性key
	  * @param {string} treeId  树控件id
	  * @param {object} virtual  虚拟根节点对象，null时为无虚拟根节点
	  * @param {ObjFactory} objFct  对象工厂
	  * @returns {object[]} treeData 带有层级关系的树数据数组
	  * @example
	  * //表格树要正常显示 需要设置_key属性，react要求
	  * list.forEach(element => {
	  *	if (!element._key) element._key = tool.uuid(8);
	  * });
	  * list = tool.ctListToTreeJson(list, "requireId", "parentId", "children");
	  */
		ctListToTreeJson: function ctListToTreeJson(datas, id, pid, childrenName, virtual) {
			//eoid, 
			if (!datas) {
				return [];
			}
			var tempNodes = datas.concat();
	
			if (!childrenName) childrenName = "cldSet";
	
			function createChild(node) {
				var curid = node && node[id];
				if (!curid) curid = "";
				// var childrenName = "cldSet";
				// if (tree && tree.state && tree.state.childrenName) childrenName = tree.state.childrenName;
	
				for (var i = 0; i < tempNodes.length; i++) {
					var record = tempNodes[i];
					if (!record) continue;
					var parentid = record[pid];
					if (!parentid) {
						parentid = "";
					}
					if (parentid == curid) {
						// 是当前节点的子节点，添加到当前节点下。
						if (!node[childrenName]) {
							// 当前node下子节点为空
							node[childrenName] = [];
						}
						node[childrenName].push(record);
						tempNodes.splice(i, 1);
						i--;
					}
				}
				if (tempNodes.length > 0) {
					var childnodes = node[childrenName];
					if (childnodes) {
						var len = childnodes.length;
						for (var i = 0; i < len; i++) {
							// 对当前节点的子节点循环添加孙子节点。
							if (tempNodes.length <= 0) break;
							createChild(childnodes[i]);
						}
					}
				}
			}
	
			var treeData = {};
			if (virtual) {
				// 有虚拟根节点
				treeData = virtual;
			}
			createChild(treeData);
	
			if (virtual) {
				// 有虚拟根节点
				treeData = [treeData];
			} else {
				treeData = treeData[childrenName];
			}
			return treeData;
		},
		/**
	  * 将树节点数据转换为结构
	  * @param {string} treeId  树控件id
	  * @param {object} info  树节点数据，含有key值
	  * @param {ObjFactory} objFct  对象工厂
	  * 
	  * @group tree
	  * @example
	  * tool.cytNode('cid_tree', {_key:''}, objFct);
	  */
		cvtNode: function cvtNode(treeId, info, objFct) {
			var tree = this.getCmp(treeId, objFct);
			if (!tree) {
				return;
			}
			return tree.cvtNode(info);
		},
	
		/**************** 以上树控件方法部分 ****************/
		/**************** 以下表格控件方法部分 ****************/
	
		/**
	  * 表格刷新方法
	  * @param {string} tableId 表格Id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {boolean} clearFlg 清理选中
	  * 
	  * @group table
	  * @example
	  * objFct.set("db_tb_prm", []);
	  * tool.refreshTable("cid_tb_prm", objFct);
	  * // tool.refreshTable("cid_tb_prm", objFct, true);// 带checkbox勾选的表格，清空上次勾选
	  */
		refreshTable: function refreshTable(tableId, objFct, clearFlg) {
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			var tableData = objFct.get(table.state.insName);
			if (!tableData) {
				tableData = [];
			}
			table.refreshTable(tableData);
	
			// 清理选中
			if (clearFlg) {
				table.state.selectedRows = [];
			}
		},
		/**
	  * 修改表格选择类型
	  * @param  {string} tableId 表格控件id
	  * @param  {none|radio|checkbox} type 表格选择类型，none-无选择框，radio-单选原框，checkbox-复选方框
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group table
	  * @example
	  * tool.setTbSelType('cid_table', 'none'||'radio'||'checkbox', objFct);
	  */
		setTbSelType: function setTbSelType(tableId, type, objFct) {
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			table.setTbSelType(type);
		},
	
		// tableBatchSelect: function (tableId, fun, objFct, current) {
		//     var table = this.getCmp(tableId, objFct);
		//     if (!table) {
		//         return;
		//     }
		//     table.setBatchFun(fun);
		//     table.batchSelect(current);
		// },
		/**
	  * 表格分批服务调用
	  * @param {string} tableId 表格控件id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {string} path 服务访问url地址
	  * @param {any} data 发送的请求数据
	  * @param {function} callback 请求返回后的回调函数
	  * @param {boolean} [flag=false] 异步访问标识
	  * @param {number} [current=1] 当前表格页序号，默认1
	  * @param {string} [reqType="POST"] 服务请求类型，默认"POST"
	  * 
	  * @group table
	  * @example
	  * tool.tableBatchSelect("tableId", objFct, sgiConfig.service_program + "program/query", req, (res) => {
	  * 	if (res && res.head && res.head.code === "0000") {
	  * 		tool.sgiLogger.info("查询成功 res :", res);
	  * 		objFct.set("tableInst", res.body || []);
	  * 		tool.refreshTable("tableId", objFct);
	  * 	} else {
	  * 		tool.sgiLogger.error("查询失败 res :", res);
	  * 	}
	  * }, true);
	  */
		tableBatchSelect: function tableBatchSelect(tableId, objFct, path, data, callback, flag, current, reqType) {
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			table.setBatchInfo(path, data, callback, reqType, flag);
			// table.setBatchFun(callback);
			table.batchSelect(current || 1);
		},
		/**
	  * 表格分批服务调用
	  * @param {string} tableId 表格控件id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {string} SIID 服务接口id
	  * @param {boolean} [flag=false] 异步访问标识
	  * @param {number} [current=1] 当前表格页序号，默认1
	  * @param {function} callback 请求返回后的回调函数
	  * @param {string} [reqType="POST"] 服务请求类型，默认"POST"
	  * 
	  * @group table
	  * @example
	  * // 常规调用
	  * tool.tableBatchSelectSI("tableId", objFct, "sd_SI_group_2001000010", true);
	  * // 自定义调用
	  * tool.tableBatchSelectSI("tableId", objFct, "sd_SI_group_2001000010", true, 1, (res)=>{}, "POST");
	  */
		tableBatchSelectSIOld: function tableBatchSelectSIOld(tableId, objFct, SIID, flag) {
			var current = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
			var callback = arguments[5];
			var reqType = arguments[6];
	
			var table = this.getCmp(tableId, objFct);
			if (!table) return;
	
			var prm = PrmFactory.getPrm(SIID);
			if (!prm || !prm.guid) return;
	
			var path = sgiConfig.service + "/" + prm.url; //服务地址
	
			var data = void 0,
			    inInst = void 0,
			    outInst = void 0;
			var cfgs = prm.cldSet || [];
			cfgs.some(function (cfg) {
				var io = cfg.iobType; //输入输出类型
				var instance = cfg.oKey; //实例名
				if (!inInst && io == "I") {
					inInst = instance;
					data = objFct.get(instance);
				}
				if (!outInst && io == "O") {
					outInst = instance;
				}
				return inInst && outInst;
			});
	
			var _callback = function _callback(res) {
				// 成功，对象工厂赋值
				if (res && res.head && res.head.code == "0000") objFct.set(outInst, res.body);
				// 同上回调
				callback(res);
			};
			table.setBatchInfo(path, data, _callback, reqType, flag);
			table.batchSelect(current);
		},
		tableBatchSelectSI: function tableBatchSelectSI(tableId, objFct, SIID, req, flag) {
			var current = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
			var callback = arguments[6];
			var reqType = arguments[7];
			var assistBody = arguments[8];
	
			var table = this.getCmp(tableId, objFct);
			if (!table) return;
	
			// let prm = PrmFactory.getPrm(SIID);
			// if (!prm || !prm.guid) return;
	
			//let path = sgiConfig.service + "/" + prm.url;//服务地址
			var path = sgiSrvUrl.service + "/bdl/invoke/" + SIID;
	
			// let data, inInst, outInst;
			// let cfgs = prm.cldSet || [];
			// cfgs.some(cfg => {
			// 	let io = cfg.iobType;//输入输出类型
			// 	let instance = cfg.oKey;//实例名
			// 	if (!inInst && io == "I") {
			// 		inInst = instance;
			// 		data = objFct.get(instance);
			// 	}
			// 	if (!outInst && io == "O") {
			// 		outInst = instance;
			// 	}
			// 	return inInst && outInst;
			// });
			var data = req;
			var _callback = function _callback(res) {
				// 成功，对象工厂赋值
				if (res && res.head && res.head.code == "0000")
					// objFct.set(outInst, res.body);
					// 同上回调
					callback(res);
			};
			table.setBatchInfo(path, data, _callback, reqType, flag, assistBody);
			table.batchSelect(current);
		},
		/**
	  * 获取表格已选中/已勾选数据
	  * @param  {string} tableId 表格控件id
	  * @param  {ObjFactory} objFct 对象工厂
	  * @return {object[]} 已选中/已勾选行对象数组
	  * 
	  * @group table
	  * @example
	  * tool.setTbSelType('cid_table', objFct);
	  */
		getTbSels: function getTbSels(tableId, objFct) {
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			return table.getTbSels();
		},
		/**
	  * 设置表格勾选
	  * key值如果不为空，遍历所有节点，根据key属性，找到与records相同的值，这些records checked
	  * 如果key为空，默认这些record就是树上的records，直接选中
	  * @param {string} tableId 表格控件id
	  * @param {object[]} records 要勾选的表格数据数组
	  * @param {string} [key] 勾选数据匹配依据的key，主键标识
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group table
	  * @example
	  * tool.setTbSels('cid_table', [{id:'1'}], 'id', objFct);
	  */
		setTbSels: function setTbSels(tableId, records, key, objFct) {
			if (!records) return;
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			if (key) {
				var inRecords = table.getTbDataByKey(records, key);
				table.setTbSels(inRecords);
			} else {
				table.setTbSels(records);
			}
		},
		/**
	  * 获取表格所有数据
	  * @deprecated 不推荐使用，可直接从表格绑定对象工厂中取值
	  * @param  {string} tableId 表格控件id
	  * @param  {ObjFactory} objFct 对象工厂
	  * @return {array} 表格数据对象数组
	  * 
	  * @group table
	  * @example
	  * tool.getTbData('cid_table', objFct);
	  */
		getTbData: function getTbData(tableId, objFct) {
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			return table.getTbData();
		},
		/**
	  * 向表格中添加新数据
	  * @param  {string} tableId 表格控件id
	  * @param  {object} newData 要添加的数据对象
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group table
	  * @example
	  * var newData = {ap:"ap2",tt:"tt2",ss:"ss2",sc:"sc2"};
	  * tool.addTbNewData("cid_tb_table_0004", newData, objFct);
	  */
		addTbNewData: function addTbNewData(tableId, newData, objFct) {
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			table.addTbNewData(newData);
		},
		/**
	  * 删除表格选中数据
	  * @param  {string} tableId 表格控件id
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group table
	  * @example
	  * tool.delTableSel("cid_tb_table_0004", objFct);
	  */
		delTableSel: function delTableSel(tableId, objFct) {
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			table.delTableSel();
		},
		/**
	  * 删除表格指定行数据
	  * @param  {string} tableId 表格控件id
	  * @param  {object} delData 要删除的单行数据
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group table
	  * @example
	  * tool.delTableObj("tableId", record, objFct);
	  */
		delTableObj: function delTableObj(tableId, delData, objFct) {
			var table = this.getCmp(tableId, objFct);
			if (!table) {
				return;
			}
			table.delTableObj(delData);
		},
		/**
	  * 设置表格加载状态【不建议使用该方法，建议使用通用setLoading方法，传参相同】
	  * @param {string} tableId 表格id
	  * @param {boolean|object} loading 加载状态(object为antd-spin组件描述)
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group table
	  * @example
	  * tool.setTableLoading("cid_tb_table_0004", true||false, objFct);
	  */
		setTableLoading: function setTableLoading(tableId, loading, objFct) {
			var table = this.getCmp(tableId, objFct);
			if (!table) return;
			table.setLoading(loading);
		},
	
		/**************** 以上表格控件方法部分 ****************/
		/**************** 以下页面处理部分 ****************/
	
		/**
	  * 切换选项卡/层叠面板/折叠面板到指定itemId的页面
	  * @param  {string} ctnId 容器控件id
	  * @param  {string} itemId 子面板id
	  * @param  {ObjFactory} objFct 对象工厂
	  * @param  {function} callback 面板激活后/加载后回调
	  * 
	  * @group tabs
	  * @example
	  * // 同步加载所有面板，激活方法
	  * tool.setActiveItem("ctnId", "panelId", objFct);
	  * // TODO something
	  * // 异步加载其余面板，激活方法
	  * tool.setActiveItem("ctnId", "panelId", objFct, ()=>{
	  * 	// TODO something
	  * });
	  */
		setActiveItem: function setActiveItem(ctnId, itemId, objFct, callback) {
			var activePanel = this.getCmp(itemId, objFct);
			if (activePanel) {
				// 面板已创建
				activePanel.props.setActiveWV(itemId);
				if (callback && typeof callback === "function") {
					callback(activePanel, objFct);
				}
			} else {
				// 面板未创建
				var container = this.getCmp(ctnId, objFct);
				if (!container) {
					return;
				}
				container.setActiveItem(itemId, callback);
			}
		},
		/**
	  * 激活指定wvId面板（选项卡/层叠面板）
	  * @param  {string} wvId 面板id
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group tabs
	  * @example
	  * tool.setActiveWV("cid_wv_sc_scEditor", objFct);
	  */
		setActiveWV: function setActiveWV(wvId, objFct) {
			var container = this.getCmp(wvId, objFct);
			if (container) {
				container.props.setActiveWV(wvId);
			} else {
				var allWVItems = objFct.get(_sgiConstants2.default.allWVItemKey);
				if (allWVItems && allWVItems[wvId]) {
					var _allWVItems$wvId = allWVItems[wvId],
					    moduleDesc = _allWVItems$wvId.moduleDesc,
					    module = _allWVItems$wvId.module,
					    parentModule = _allWVItems$wvId.parentModule;
	
					if (parentModule) parentModule.setActiveItem(wvId);
				}
			}
		},
		/**
	  * 获取当前激活面板的组件标识
	  * @param  {string} ctnId 容器id
	  * @param  {ObjFactory} objFct 对象工厂
	  * @return {string} 当前激活面板的组件id
	  * 
	  * @group tabs
	  * @example
	  * var str = tool.getActiveItem('tab_editor', objFct);
	  */
		getActiveItem: function getActiveItem(ctnId, objFct) {
			var container = this.getCmp(ctnId, objFct);
			if (!container) {
				return;
			}
			return container.getActiveItem(ctnId);
		},
		/**
	  * 动态设置选项卡项(根据子组件描述)
	  * @author hanzb
	  * @param {string} tabsId 选项卡id
	  * @param {array} sonDescs 子组件描述数组
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {string} activeKey 激活key
	  * 
	  * @group tabs
	  * @example
	  * const propss = [
	  *	{ tab: "发卡数", key: "cid_panel_card_number" },
	  *	{ tab: "激活数", key: "cid_panel_active_number" }
	  * ];
	  * tool.setTabsItemsByDescs('cid_tab', propss, objFct, 'cid_tab_panel')
	  */
		setTabsItemsByDescs: function setTabsItemsByDescs(tabsId, sonDescs, objFct, activeKey) {
			var tabs = this.getCmp(tabsId, objFct);
			if (!tabs) {
				return;
			}
			tabs.setTabsItemsByDescs(sonDescs, activeKey);
		},
		/**
	  * 动态设置选项卡项(根据TabPane属性)
	  * @author hanzb
	  * @param {string} tabsId 选项卡id
	  * @param {array} propss TabPane属性
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {string} activeKey 激活key
	  * 
	  * @group tabs
	  * @example
	  * const propss = [
	  *	{ tab: "发卡数", key: "cid_panel_card_number" },
	  *	{ tab: "激活数", key: "cid_panel_active_number" }
	  * ];
	  * tool.setTabsItemsByTabPaneProps("cid_tabs_dynamic", propss, objFct, "cid_panel_card_number");
	  */
		setTabsItemsByTabPaneProps: function setTabsItemsByTabPaneProps(tabsId, propss, objFct, activeKey) {
			var tabs = this.getCmp(tabsId, objFct);
			if (!tabs) {
				return;
			}
			tabs.setTabsItemsByTabPaneProps(propss, activeKey);
		},
		/**
	  * 动态设置选项卡面板title
	  * @param {string} tabsId 选项卡id
	  * @param {string} tabId 选项卡子面板组件标识
	  * @param {string|Element} title 标题名或组件
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group tabs
	  * @example
	  * tool.setTabsTabTitle('cid_tab', 'cid_tab_panel', '标题'，objFct)
	  */
		setTabsTabTitle: function setTabsTabTitle(tabsId, tabId, title, objFct) {
			var tabs = this.getCmp(tabsId, objFct);
			if (!tabs) return;
			tabs.setTabTitle(tabId, title);
		},
		/**
	  * 获取对象值
	  * @param  {object} obj 对象
	  * @param  {string} code 属性编码key
	  * @return {object} 属性值
	  * 
	  * @group object
	  * @example
	  * var value = tool.getVal(dv,"te")
	  */
		getVal: function getVal(obj, code) {
			if (!obj || !code) {
				return;
			}
			return obj[code];
		},
		/**
	  * 设置对象值
	  * @param  {object} obj 对象
	  * @param  {string} code 属性编码key
	  * @param  {object} value 属性值
	  * 
	  * @group object
	  * @example
	  * tool.setVal(currentSCNode,"teid","111");
	  */
		setVal: function setVal(obj, code, value) {
			if (!obj || !code) {
				return;
			}
			obj[code] = value;
		},
		panelAddUcvNewObject: function panelAddUcvNewObject(wvid, ucvid, objFct, flag, transferData) {
			var panel = this.getCmp(wvid, objFct);
			if (!panel) {
				return;
			}
			// 设置添加列表
			if (!panel.addUCVList) {
				panel.addUCVList = {};
			}
			// 是否清空重新添加
			if (flag) {
				panel.props.moduleDesc.customCldSet = [];
				panel.addUCVList = {};
			} else {
				// 判断是否已经添加过了 添加过了 返回不再添加
				if (panel.addUCVList[ucvid]) {
					return;
				}
			}
			//获取 uid信息
			var uiJson = PrmFactory.getPrm(ucvid);
			if (!uiJson) {
				return;
			}
			if (!panel.props.moduleDesc.customCldSet) {
				panel.props.moduleDesc.customCldSet = [];
			}
			uiJson.transferData = transferData;
			panel.props.moduleDesc.customCldSet.push(uiJson);
			panel.refresh();
			// 设置添加标示
			panel.addUCVList[ucvid] = true;
		},
		/**
	  * （往普通面板中）嵌入ui面板
	  * @param  {string} wvid 父面板id
	  * @param  {string} ucvid 要嵌入的guid
	  * @param  {ObjFactory} objFct 对象工厂
	  * @param  {boolean} flag 是否清空重新添加
	  * 
	  * @group panel
	  * @example
	  * tool.panelAddUcv("cid_test", "rnt_UI_webTest_0003", objFct);
	  */
		panelAddUcv: function panelAddUcv(wvid, ucvid, objFct, flag) {
			var panel = this.getCmp(wvid, objFct);
			if (!panel) {
				return;
			}
	
			// 设置添加列表
			if (!panel.addUCVList) {
				panel.addUCVList = {};
			}
	
			// 是否清空重新添加
			if (flag) {
				panel.props.moduleDesc.cldSet = [];
				panel.addUCVList = {};
			} else {
				// 判断是否已经添加过了 添加过了 返回不再添加
				if (panel.addUCVList[ucvid]) {
					return;
				}
			}
	
			var uiJson = PrmFactory.getPrm(ucvid);
			if (!uiJson) {
				return;
			}
	
			if (!panel.props.moduleDesc.cldSet) {
				panel.props.moduleDesc.cldSet = [];
			}
			panel.props.moduleDesc.cldSet.push(uiJson);
			panel.refresh();
			// 设置添加标示
			panel.addUCVList[ucvid] = true;
		},
		/**
	  * （从普通面板中）删除指定ui面板
	  * @param  {string} wvid 父面板id
	  * @param  {string} ucvid 要删除ui的guid
	  * @param  {ObjFactory} objFct 对象工厂
	  * 
	  * @group panel
	  * @example
	  * tool.panelRemoveUcv('cid_wv', 'sm_UI_text_0001', objFct);
	  */
		panelRemoveUcv: function panelRemoveUcv(wvid, ucvid, objFct) {
			var panel = this.getCmp(wvid, objFct);
			if (!panel) {
				return;
			}
			panel.remove(ucvid);
		},
	
		/**
	  * 平铺组件刷新方法
	  * @author hanzb
	  * @param {string} tileId 平铺组件id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {any} parameters 保留第三参数，暂无功能
	  * 
	  * @group tile
	  * @example 例：
	  *  // 平铺组件数据
	  *	objFct.set("db_tile_task_overview", [{
	  *		type: "book", color: "blue", num: 0, title: "总任务数"
	  *	}, {
	  *		type: "phone", color: "orange", num: 0, title: "计划拨打数"
	  *	}]);
	  *	tool.refreshTile("cid_tile_task_overview", objFct);
	  *  // 自定义子组件渲染事件填写每一个小单元需要渲染的内容
	  */
		refreshTile: function refreshTile(tileId, objFct, parameters) {
			var tile = this.getCmp(tileId, objFct);
			if (!tile) {
				return;
			}
			var tileData = objFct.get(tile.state.insName) || [];
			tile.refreshByData(tileData, parameters);
		},
	
		/**
	  * 通用图表刷新方法
	  * @author hanzb
	  * @param {string} echartsId 图表id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {any} parameters 保留第三参数，暂无功能
	  * 
	  * @group echarts
	  * @example 例：
	  * objFct.set("db_echarts_my_achievement", faka.details);
	  * tool.refreshEcharts("cid_echarts_my_achievement", objFct);
	  */
		refreshEcharts: function refreshEcharts(echartsId, objFct, parameters) {
			var echarts = this.getCmp(echartsId, objFct);
			if (!echarts) {
				return;
			}
			var echartsData = objFct.get(echarts.state.insName) || [];
			echarts.refreshByData(echartsData, parameters);
		},
		/**
	  * 设置容器类组件加载状态
	  * @param {string} ctnId 组件id(目前仅支持普通面板、表格)
	  * @param {boolean|object} loading 加载状态(object为antd-spin组件描述)
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group panel
	  * @example 例：
	  * tool.setLoading('cid_wv', true||false, objFct);
	  */
		setLoading: function setLoading(ctnId, loading, objFct) {
			var ctn = this.getCmp(ctnId, objFct);
			if (!ctn) return;
			ctn.setLoading(loading);
		},
	
		/**************** 以上页面处理部分 ****************/
		/**************** 以下控件部分 ****************/
	
		/**
	  * 根据控件id，设置控件是否禁用
	  * @param {string} ctlId 控件id
	  * @param {boolean} disabled 是否禁用
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group ctl
	  * @example 例：
	  * 表单元素需要禁用时、表单回显时，或由禁用改为可用时
	  * tool.setDisabled("cid_search",true,objFct);
	  * tool.setDisabled("cid_btn",false,objFct);
	  */
		setDisabled: function setDisabled(ctlId, disabled, objFct) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) {
				return;
			}
			ctl.setDisabled(disabled);
		},
		/**
	  * 根据控件id，设置控件是否隐藏
	  * @param {string} ctlId 控件id
	  * @param {boolean} hidden 是否隐藏
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group ctl
	  * @example 例：
	  * 表单元素需要分情况需要隐藏或显示时
	  * tool.setHidden("cid_btn",true,objFct);
	  * tool.setHidden("cid_btn",false,objFct);
	  */
		setHidden: function setHidden(ctlId, hidden, objFct) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) {
				return;
			}
			ctl.setHidden(hidden);
		},
		/**
	  * 设置组件是否必填
	  * @param {string} ctlId 组件id
	  * @param {boolean} required 是否必填
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group ctl
	  * @example 例：
	  * 表单元素需要动态设置是否必填时
	  * tool.setRequired("cid_input",true,objFct);
	  * tool.setRequired("cid_input",false,objFct);
	  */
		setRequired: function setRequired(ctlId, required, objFct) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) {
				return;
			}
			ctl.setRequired(required);
		},
		/**
	  * 设置组件校验状态
	  * @param {string} ctlId 组件id
	  * @param {string} message 提示信息
	  * @param {string} status 组件校验状态，可选'success','warning','error','validating'
	  * @param {boolean} hasFeedback 是否显示校验图标
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group ctl
	  * @example 例：
	  * 表单元素需要动态设置校验时
	  * tool.setValidate("cid_input","输入格式不正确","warning",true,objFct);
	  */
		setValidate: function setValidate(ctlId, message, status, hasFeedback, objFct) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl || !ctl.setValidate) return;
			ctl.setValidate(message, status, hasFeedback);
		},
		/**
	  * 设置控件显示值
	  * @param  {string} ctlId 控件id
	  * @param  {object} value 显示值
	  * @param  {object} objFct 对象工厂
	  * 
	  * @group ctl
	  * @example 例：
	  * 动态设置表单元素显示值
	  * tool.ctlSetValue("cid_search",'显示值',objFct); 
	  */
		ctlSetValue: function ctlSetValue(ctlId, value, objFct) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) {
				return;
			}
			ctl.setValue(value);
		},
		/**
	  * 组件通用赋值方法，需组件提供setValue接口
	  * @param {string} ctlId 组件id
	  * @param {string|object} value 组件新值
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {object} parameters 相关参数
	  * 
	  * @group ctl
	  * @example 例：
	  * 通用设置组件显示值
	  * tool.setValue("cid_search",'显示值',objFct,{}); 
	  */
		setValue: function setValue(ctlId, value, objFct, parameters) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) return;
			ctl.setValue(value, parameters); //赋值
			if (ctl.validate) ctl.validate(); //校验
	
			//刷新对象工厂值
			var _ctl$props3 = ctl.props,
			    moduleDesc = _ctl$props3.moduleDesc,
			    bdInst = _ctl$props3.bdInst;
	
			var attname = moduleDesc.c;
			if (ctl.setBindValue) ctl.setBindValue(attname, bdInst, objFct, value); //刷新绑定值
		},
		// /**
		//  * 组件通用赋值方法（并进行校验）
		//  * @param {string} ctlId 组件id
		//  * @param {string|object} value 组件新值
		//  * @param {ObjFactory} objFct 对象工厂
		//  * @param {object} parameters 相关参数
		//  */
		// setValueValid: function (ctlId, value, objFct, parameters) {
		//     var ctl = this.getCmp(ctlId, objFct);
		//     if (!ctl) return;
		//     ctl.setValue(value, parameters);
		//     ctl.validate();
	
		//     //刷新对象工厂值
		//     var { moduleDesc, bdInst } = ctl.props;
		//     let attname = moduleDesc.c
		//     ctl.setBindValue(attname, bdInst, objFct, value);
		// },
		/**
	  * 组件通用取值方法，需组件提供getValue接口
	  * @param {string} ctlId 组件id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {object} parameters 相关参数
	  * 
	  * @group ctl
	  * @example 例：
	  * 通用获取组件值
	  * tool.getValue("cid_search",objFct,{}); 
	  */
		getValue: function getValue(ctlId, objFct, parameters) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) return;
			return ctl.getValue(parameters);
		},
		/**
	  * 组件标题设置方法，需组件自身提供setTitle接口，目前用于面板(card)的标题设置
	  * @param {string} ctlId 组件id
	  * @param {string|Element} title 组件标题
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {object} parameters 相关参数
	  * 
	  * @group card
	  * @example 例：
	  * let subTitle = tool.createElement("span", { style: { color: "#9eacb4", fontSize: 13, marginLeft: 5 } }, year + "年");
	  * tool.setTitle("cid_view_panel_overdue", ["不良逾期率分析", subTitle], objFct);
	  */
		setTitle: function setTitle(ctlId, title, objFct, parameters) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl || !ctl.setTitle) return;
			ctl.setTitle(title, parameters);
		},
		/**
	  * 组件通用刷新方法，需组件自身提供refresh接口
	  * @param {string} ctlId 组件id
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {object} parameters 相关参数
	  * 
	  * @group ctl
	  * @example 例：
	  * tool.refresh('cid_form', objFct);
	  * tool.refresh('cid_table', objFct);
	  */
		refresh: function refresh(ctlId, objFct, parameters) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) return;
			return ctl.refresh(parameters);
		},
		/**
	  * 控件通用函数调用方法
	  * @param {string} ctlId 控件id
	  * @param {string} funName 调用函数名称
	  * @param {ObjFactory} objFct 对象工厂
	  * @param  {...any} parameters 函数传参
	  * 
	  * @group _global_
	  * @example 例：
	  * tool.callCtlFun('cid_tree', 'expand', objFct, 'cid_tree', record, objFct);
	  * 
	  * let type;
	  * switch (activeKey) {
	  * 	case "cid_fold_panel_event": 
	  *	 type = "事件"; 
	  *   break;
	  *	default: 
	  *   type = "事件"; 
	  *   break;
	  * }
	  * tool.callCtlFun("cid_btn_add_event", "setText", objFct, `添加${type}`);
	  */
		callCtlFun: function callCtlFun(ctlId, funName, objFct) {
			var ctl = this.getCmp(ctlId, objFct);
			if (!ctl) return;
			if (!ctl[funName]) {
				_sgiLogger.sgiLogger.debug('\u5728\u7EC4\u4EF6\u3010' + ctlId + '\u3011\u4E2D\u627E\u4E0D\u5230\u51FD\u6570\u540D\u4E3A\u3010' + funName + '\u3011\u7684\u65B9\u6CD5\uFF0C\u8BF7\u68C0\u67E5\u4EE3\u7801\u662F\u5426\u6B63\u786E');
				return;
			}
	
			for (var _len2 = arguments.length, parameters = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
				parameters[_key2 - 3] = arguments[_key2];
			}
	
			return ctl[funName].apply(ctl, parameters);
		},
	
		/**************** 以上弹出窗部分 ****************/
		/**************** 以下页面处理部分 ****************/
	
		/**
	  * 下拉窗/单选组/复选组件刷新选项数组
	  * @param {string} comboxid 下拉窗/单选组/复选组控件id
	  * @param {object[]} newlist 组件新的选项数组
	  * @param {string} codeCode 作为实际取值的属性key
	  * @param {string} textCode 作为显示的属性key
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group combox
	  * @example 例：
	  * 动态刷新下拉窗等的选项数据
	  * var newlist = [{c:"1",te:"男"}, {c:"2",te:"女"}]; 
	  * tool.refreshComboxByid("cid_combox", newlist, "c", "te", objFct);
	  */
		refreshComboxByid: function refreshComboxByid(comboxid, newlist, codeCode, textCode, objFct) {
			if (!comboxid || !newlist) {
				return;
			}
			var combox = this.getCmp(comboxid, objFct);
			if (!combox) {
				return;
			}
			var list = newlist.filter(function (l) {
				return l[codeCode || "c"];
			}); //去除codeCode属性为null产生的异常数据
			combox.dynamicRefreshCombox(list, codeCode, textCode);
		},
	
		/**
	  * 动态设置下拉框 显示列表 筛选部分显示
	  * @param {*} comboxid  下拉框id
	  * @param {*} showList 要显示的业务数组
	  * @param {*} key  业务要在下拉框中 保存的属性id
	  * @param {*} objFct 
	  * 
	  * @group combox
	  * @example 例：
	  * 筛选下拉窗的部分显示数据
	  * var newlist = [{c:"1",te:"男"}, {c:"2",te:"女"}]; 
	  * tool.refreshSelectShowsList("cid_combox", newlist, "c", objFct);
	  */
		refreshSelectShowsList: function refreshSelectShowsList(comboxid, showList, key, objFct) {
			//获取下拉框 
			if (!comboxid || !showList || !key || !objFct) {
				return;
			}
			var combox = this.getCmp(comboxid, objFct);
			if (!combox) {
				return;
			}
			var selectShowList = [];
			showList.forEach(function (element) {
				selectShowList.push(element[key]);
			});
			combox.state.shows = selectShowList;
			combox.fitSelectOption(combox.props.moduleDesc);
			combox.setState({ loading: false });
		},
	
		/**
	  * 下拉树控件刷新选项数组
	  * @param {string} comboxid 下拉树控件id
	  * @param {object[]} newlist 下拉树新的选项数组
	  * @param {string} codeCode 作为实际取值的属性key
	  * @param {string} textCode 作为显示的属性key
	  * @param {ObjFactory} objFct 对象工厂
	  * @param {string} [childCode="cldSet"] 子节点属性标识，默认“策略的Set”
	  * 
	  * @group comboxTree
	  * @example 例：
	  * 动态刷新下拉树的选项数据
	  * var data = tool.ctTrStrByData(list, 'pk', 'parentPk', null, null, objFct); 
	  * tool.refreshComboxTreeByid("cid_wfType", data, "pk", "className", objFct, "cldSet");
	  */
		refreshComboxTreeByid: function refreshComboxTreeByid(comboxid, newlist, codeCode, textCode, objFct, childCode) {
			if (!comboxid || !newlist) {
				return;
			}
			var combox = this.getCmp(comboxid, objFct);
			if (!combox) {
				return;
			}
			combox.dynamicRefreshCombox(newlist, codeCode, textCode, childCode);
		},
	
		/**
	  * 刷新步骤条显示节点
	  * @param {string} stepsId 步骤条id
	  * @param {string[]} showKeys 要显示的节点key数组
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group steps
	  * @example 例：
	  * tool.setStepsShowKeys("cid_step", ["1", "9"], objFct);
	  */
		setStepsShowKeys: function setStepsShowKeys(stepsId, showKeys, objFct) {
			if (!showKeys) return;
	
			var steps = this.getCmp(stepsId, objFct);
			if (!steps) return;
	
			steps.setShowKeys(showKeys);
		},
	
		/**
	  * 设置禁用项，设置不可选项
	  * @param {string} comboxid 下拉窗控件id
	  * @param {object[]} disabledList 要禁用的选项数组
	  * @param {string} codeCode 匹配属性key，依据disabledList中每个对象的该属性值进行匹配
	  * @param {ObjFactory} objFct 对象工厂
	  * 
	  * @group combox
	  * @example 例：
	  * tool.setDisabledItems("cid_combox", [{id:'1', id:'2'}], 'id', objFct);
	  */
		setDisabledItems: function setDisabledItems(comboxid, disabledList, codeCode, objFct) {
			if (!comboxid || !disabledList) {
				return;
			}
			var combox = this.getCmp(comboxid, objFct);
			if (!combox) {
				return;
			}
			combox.setDisabledItems(disabledList, codeCode);
		},
	
		/**************** 以上控件处理部分 ****************/
		/**************** 以下通用部分 ****************/
	
		/**
	    * scCode: list codeCode textCode noclearFlag 如果 scCode存在 是否不清空
	    */
		/**
	  * 设置标准代码选项数组（注意：该操作会改变所有使用该标准代码的控件选项内容）
	  * @param {string} scCode 标准代码guid
	  * @param {object[]} list 新的子节点数组
	  * @param {string} codeCode list中作为实际值的属性key
	  * @param {string} textCode list中作为展示值的属性key
	  * @param {boolean} [noclearFlag=false] 是否保留原有选项数组，默认为false不保存
	  * @param {string[]} [code] list中用作额外辅助的数据code数组
	  * 
	  * @group combox
	  * @example 例：
	  * 动态设置标准代码显示内容
	  * var scCode = "Emos_SC_plan_310010", list = [{useId:'1',userNickname:'用户',userAge:20}], codeCode = "userId", textCode = "userNickname", noclearFlag = false;
	  * tool.setSCList(scCode, list, codeCode, textCode, noclearFlag, ['userAge']);
	  */
		setSCList: function setSCList(scCode, list) {
			var codeCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "c";
			var textCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "te";
			var noclearFlag = arguments[4];
			var otherCodes = arguments[5];
	
			if (!list || list.length < 1) {
				return;
			}
			//检查otherCodes如果存在，是否为数组
			if (otherCodes && !(otherCodes instanceof Array)) {
				_sgiLogger.sgiLogger.log("传入的额外辅助数据不是数组结构");
				return;
			}
	
			var roleList = list.filter(function (l) {
				return l[codeCode];
			}); //去除codeCode属性为null产生的异常数据
			var scList = _StandardCode.StandardCode.getSC(scCode);
	
			if (!noclearFlag) {
				scList.splice(0, scList.length);
			}
			if (!scList) {
				return;
			}
			roleList.forEach(function (record) {
				var addflag = true;
				if (noclearFlag) {
					// 查看 数组中是否存在 改record
					for (var i = 0; i < scList.length; i++) {
						var tmpitem = scList[i];
						var newc;
						newc = record[codeCode];
						var c;
						c = tmpitem.sc;
						if (newc === c) {
							addflag = false;
							break;
						}
					}
				}
				if (addflag) {
					var node = {};
					var c, te;
					c = record[codeCode];
					te = record[textCode];
					node.sc = c;
					node.n = te;
					node.te = te;
					node.c = c;
	
					if (otherCodes) {
						otherCodes.forEach(function (element) {
							if (!element) return;
							node[element] = record[element];
						});
					}
					scList.push(node);
				}
			});
			_StandardCode.StandardCode.onSCChange(scCode); //执行订阅事件
			return scList;
		},
	
		setSCtree: function setSCtree(scCode, list) {
			var codeCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "c";
			var textCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "te";
			var noclearFlag = arguments[4];
			var otherCodes = arguments[5];
	
			if (!list || list.length < 1) {
				return;
			}
			//检查otherCodes如果存在，是否为数组
			if (otherCodes && !(otherCodes instanceof Array)) {
				_sgiLogger.sgiLogger.log("传入的额外辅助数据不是数组结构");
				return;
			}
	
			var roleList = list.filter(function (l) {
				return l[codeCode];
			}); //去除codeCode属性为null产生的异常数据
			var scList = _StandardCode.StandardCode.getSC(scCode);
	
			if (!noclearFlag) {
				scList.splice(0, scList.length);
			}
			if (!scList) {
				return;
			}
			//递归处理
			next(roleList, scList);
	
			function next(roleList, newList) {
				roleList.forEach(function (record) {
					var addflag = true;
					if (noclearFlag) {
						// 查看 数组中是否存在 改record
						for (var i = 0; i < scList.length; i++) {
							var tmpitem = scList[i];
							var newc;
							newc = record[codeCode];
							var c;
							c = tmpitem.sc;
							if (newc === c) {
								addflag = false;
								break;
							}
						}
					}
					if (addflag) {
						var node = {};
						var _c = void 0,
						    te = void 0;
						_c = record[codeCode];
						te = record[textCode];
						node.sc = _c;
						node.n = te;
						node.te = te;
						node.c = _c;
						if (otherCodes) {
							otherCodes.forEach(function (element) {
								if (!element) return;
								node[element] = record[element];
							});
						}
						var cldSet = record.cldSet;
						if (cldSet && cldSet.length > 0) {
							node.cldSet = [];
							next(cldSet, node.cldSet);
						}
						newList.push(node);
					}
				});
			}
			_StandardCode.StandardCode.onSCChange(scCode); //执行订阅事件
			return scList;
		},
	
		/**
	  * 设置标准代码
	  * @param {string} scCode 标准代码guid
	  * @param {object} scPrm 要设置的参数
	  * @param {string} codeCode 作为存储的key
	  * @param {string} textCode 作为显示的key
	  * @param {boolean} noclearFlag 是否保留现有下拉项
	  * 
	  * @group sc
	  * @example 例：
	  * 动态设置标准代码选项参数
	  * tool.setSCPrm('sm_sc_001', {id:'1', text:'一'}, 'id', 'text', true)
	  */
		setSCPrm: function setSCPrm(scCode, scPrm, codeCode, textCode, noclearFlag) {
			if (!scCode || !scPrm) return;
	
			var oldPrm = _StandardCode.StandardCode.getFullSC(scCode) || {};
			if (!noclearFlag) {
				for (var key in oldPrm) {
					delete oldPrm[key];
				}
			}
	
			var newSCPrm = mergeObj(oldPrm, scPrm);
			_StandardCode.StandardCode.setSC(scCode, newSCPrm);
	
			function mergeObj(target, source) {
				// 目标和源相同，直接返回
				if (target === source) return target;
				// 分情况处理
				if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
					if (codeCode) source["c"] = source[codeCode];
					if (textCode) source["te"] = source[textCode];
					for (var _key3 in source) {
						if (target[_key3] === source[_key3]) continue; //相同，跳过
						if (!target[_key3]) target[_key3] = source[_key3]; //target属性不存在，直接赋值
						else target[_key3] = merge(target[_key3], source[_key3]); //target属性存在，合并
					}
				} else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
					for (var i = 0; i < source.length; i++) {
						if (codeCode) source["c"] = source[codeCode];
						if (textCode) source["te"] = source[textCode];
						if (target[i] === source[i]) continue; //相同，跳过
						if (!target[i]) target.push(source[i]); //target元素不存在，直接添加
						else target[i] = merge(target[i], source[i]); //target元素存在，合并
					}
				} else {
					//其他情况，直接赋值
					target = source;
				}
				// 返回target
				return target;
			}
		},
		/**
	  * 根据当前值 获取显示内容
	  * @param {*} value 
	  * @param {*} scId 
	 //  * @param {*} comboxList 
	  * @example 例：
	  * tool.getSCShowValue('1', 'sm_sc_001');
	  */
		getSCShowValue: function getSCShowValue(value, scId) {
	
			if (!scId || !value) {
				_sgiLogger.sgiLogger.debug('\u8F93\u5165\u5185\u5BB9scId\u6216\u8005value\u4E0D\u5B58\u5728');
				return;
			}
	
			var comboBoxData = _StandardCode.StandardCode.getSC(scId) || [];
	
			if (!comboBoxData || comboBoxData.length.length == 0) {
				_sgiLogger.sgiLogger.debug('\u8F93\u5165\u5185\u5BB9scId\u83B7\u53D6\u4E0D\u5230\u6807\u51C6\u4EE3\u7801');
				return;
			}
	
			var newcomboBoxData = [];
			if (value && !(value instanceof Array)) {
				var valueList = value.split(","); //拆分
				for (var i = 0; i < valueList.length; i++) {
					var uceC = valueList[i];
					newcomboBoxData.push(uceC);
				}
			} else if (value) {
				newcomboBoxData = value;
			}
	
			var showValue = [];
	
			for (var j = 0; j < newcomboBoxData.length; j++) {
				for (var _i = 0; _i < comboBoxData.length; _i++) {
					var item = comboBoxData[_i];
					if (newcomboBoxData[j] == item["c"]) {
						showValue.push(item["te"]);
						break;
					} else if (_i === comboBoxData.length - 1) {
						// 最后一个仍然不匹配
						showValue.push(newcomboBoxData[j]);
					}
				}
			}
	
			return showValue.join(",");
		}
	};
	
	Object.assign(tool, sgiCommon, { Array: sgiCommon.sgiArray });
	Object.assign(tool, sgiClient.sgiClient);
	// 初始化
	if (!window.tool) window.tool = tool;
	// 追加
	else Object.assign(window.tool, tool);
	// 导出（window.tool与tool的引用并不一定相同，已window.tool为主，tool仅作为定义工具集函数使用，像window.tool内追加）
	var wTool = window.tool;
	exports.tool = wTool;
	exports.default = wTool;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiButtonEO = function SgiButtonEO() {
	    return {
	        ann: "注释",
	        // badgeText: "5",//右上角标
	        // btnIconPh: "search",//按钮图标
	        // cId: "cid_button",//组件标识
	        // ctlH: 0,
	        ctlN: "按钮",
	        // ctlW: 100,
	        desId: "EP_EO_UI_3003",
	        // hvInfo: "按钮的提示信息",//按钮的提示信息
	        isDis: false,
	        isHdn: false,
	        te: "显示名称"
	        // bdrW: 20,//边框宽度
	        // csstyle: "button-default",
	        // fontIcon: "",//字体图标
	        // iconAlg: "left",//按钮图片位置
	        // iconPh: "SD_RP_IR_0001`UI`UI10",
	        // isBrdr: true,//是否有边框,显示边框
	        // mgn: 10,//外边距
	        // n: "名称",
	        // pad: 10,//内边距
	        // new_flag: true,
	        // sNo: 0,//排序号
	        // bkImgPh: "SD_RP_IR_0001`UI`UI10",//背景图片
	        // bkImgRptType: "",//背景图重复方式
	        // teAl: "center",//文本位置
	        // teid: "20171123172212960752",//显示名称代码
	        // useTim: 0,//使用次数
	        // visible: true,
	        // x: "0",
	        // y: "0",
	    };
	};
	exports.SgiButtonEO = SgiButtonEO;
	exports.default = SgiButtonEO;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiCalendarEO = function SgiCalendarEO() {
	    return {
	        te: "我是日历x",
	        // cId: '222',
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "日历",
	        // style: { minHeight: '200px' },  
	        desId: "EP_EO_UI_SgiCalendar",
	        // isBrdr: true,
	        // isHdn: false,
	        // isScl: false,
	        // isTtl: true,
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        // ttlAlgn: "center",
	        mode: "month" //初始模式-月模式
	    };
	};
	exports.SgiCalendarEO = SgiCalendarEO;
	exports.default = SgiCalendarEO;

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Row布局
	 * wzhe
	 */
	var SgiColEO = function SgiColEO() {
	    return {
	        ctlH: "100%",
	        ctlN: "列",
	        span: 8,
	        desId: "EP_EO_UI_5102",
	        style: {}
	    };
	};
	exports.SgiColEO = SgiColEO;
	exports.default = SgiColEO;

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiCollapseEO = function SgiCollapseEO() {
	    return {
	        atvTab: '',
	        ctlN: "折叠",
	        ctlH: '100%',
	        ctlW: '100%',
	        desId: "EP_EO_UI_4104"
	    };
	};
	exports.SgiCollapseEO = SgiCollapseEO;
	exports.default = SgiCollapseEO;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiCommEchartsEO = function SgiCommEchartsEO() {
	    return {
	        te: "我是通用图表控件x",
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "通用图表",
	        desId: "EP_EO_UI_SgiCommEcharts",
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0"
	    };
	};
	exports.SgiCommEchartsEO = SgiCommEchartsEO;
	exports.default = SgiCommEchartsEO;

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiDVEO = function SgiDVEO() {
	    return {
	        te: "我是DV",
	        // cId: '222',
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "dv",
	        style: { minHeight: '200px' },
	        desId: "EP_EO_UI_DV",
	        isBrdr: false,
	        isHdn: false,
	        isScl: false,
	        bdInst: '',
	        bdDvId: '',
	        isTtl: true,
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        ttlAlgn: "center",
	        lblAlgn: "right"
	    };
	};
	exports.SgiDVEO = SgiDVEO;
	exports.default = SgiDVEO;

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiEChartsCommonEO = function SgiEChartsCommonEO() {
	    return {
	        te: "我是ECharts通用图表控件x",
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "通用图表",
	        desId: "EP_EO_UI_EC0001",
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        eventName: "click"
	    };
	};
	exports.SgiEChartsCommonEO = SgiEChartsCommonEO;
	exports.default = SgiEChartsCommonEO;

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * 级联下拉
	 * wangj
	 */
	
	var SgiFormCascaderEO = function SgiFormCascaderEO() {
	    var _ref;
	
	    return _ref = {
	        ctlW: 24,
	        lblW: 6,
	        ctlN: "级联组件",
	        te: '级联选择',
	        isDis: false,
	        emptyText: '未找到匹配值',
	        // expandTrigger: 'hover',//使用默认的click方式更好一些，避免因为鼠标的移动产生数据的切换
	        allowClear: false,
	        chgOnsel: false,
	        // scId: 'SD_SC_rp_0090',//标准代码GUID
	        desId: 'EP_EO_UI_3122',
	        // insName:'',//预留
	        // showkey:'',//预留
	        // saveKey:'',//预留
	        showSearch: false, //搜索框
	        // c: "attribute1",
	        ctlH: 0
	    }, _defineProperty(_ref, 'ctlN', "下拉窗"), _defineProperty(_ref, 'isHdn', false), _defineProperty(_ref, 'n', "属性1"), _defineProperty(_ref, 'sNo', 0), _defineProperty(_ref, 't', "combox"), _defineProperty(_ref, 'useCodes', ''), _defineProperty(_ref, 'cId', ''), _defineProperty(_ref, 'alwBlk', true), _defineProperty(_ref, 'lblAlg', "right"), _ref;
	};
	
	exports.SgiFormCascaderEO = SgiFormCascaderEO;
	exports.default = SgiFormCascaderEO;

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 复选框组控件
	 * wangj
	 */
	
	var SgiFormCheckboxEO = function SgiFormCheckboxEO() {
	    return {
	        // isBtn:true,
	        // checked:['1',''],
	        // c : "col2",
	        ctlH: 0,
	        ctlN: "单选框",
	        ctlW: 24,
	        desId: "EP_EO_UI_3110",
	        isDis: false,
	        isHdn: false,
	        lblAlg: "right",
	        lblW: 6,
	        // n : "字段2",
	        sNo: 0,
	        // scId: 'SD_SC_PT_0001',//标准代码GUID
	        // t : "radio",
	        te: '复选框',
	        // ctlClu:1,
	        // useCodes:'',
	
	        alwBlk: true
	        // isGw : false,
	        // isLbl : true,
	        // isRead : false,
	        // isSrp : true,
	
	        // maxL : 0,
	        // minL : 0,
	        // msfTgt : "qtip",
	        // useTim : 0,
	        // visible : true,
	        // x : "0",
	        // y : "0",
	    };
	};
	
	exports.SgiFormCheckboxEO = SgiFormCheckboxEO;
	exports.default = SgiFormCheckboxEO;

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 复选框组控件
	 * wangj
	 */
	
	var SgiFormCheckboxGroupEO = function SgiFormCheckboxGroupEO() {
	    return {
	        // isBtn:true,
	        // checked:['1',''],
	        // c : "col2",
	        ctlH: 0,
	        ctlN: "多选框",
	        ctlW: 24,
	        desId: "EP_EO_UI_3108",
	        isDis: false,
	        isHdn: false,
	        lblAlg: "right",
	        lblW: 6,
	        // n : "字段2",
	        sNo: 0,
	        // scId: 'SD_SC_PT_0001',//标准代码GUID
	        // t : "radio",
	        te: '复选框组'
	        // ctlClu:1,
	        // useCodes:'',
	
	        // alwBlk : true,
	        // isGw : false,
	        // isLbl : true,
	        // isRead : false,
	        // isSrp : true,
	
	        // maxL : 0,
	        // minL : 0,
	        // msfTgt : "qtip",
	        // useTim : 0,
	        // visible : true,
	        // x : "0",
	        // y : "0",
	    };
	};
	
	exports.SgiFormCheckboxGroupEO = SgiFormCheckboxGroupEO;
	exports.default = SgiFormCheckboxGroupEO;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 下拉窗
	 * wangj
	 */
	
	var SgiFormComboboxEO = function SgiFormComboboxEO() {
	    return {
	        emptyText: '未找到匹配值',
	        inpPopTe: "--请选择--",
	        showSearch: true, //搜索框
	        // scId: 'SD_SC_PT_0001',//标准代码GUID
	        alwBlk: true,
	        allowClear: true, //支持清除
	        // c : "attribute1",
	        ctlH: 0,
	        ctlN: "下拉窗",
	        ctlW: 24,
	        isDis: false,
	        isHdn: false,
	        lblW: 6,
	        mulSel: false, // 设置是否允许多选 默认为false
	        // n : "属性1",
	        sNo: 0,
	        // scH : 0,
	        // t : "combox",
	        te: "下拉窗",
	        cId: '', // 系统唯一的表示，默认时系统会自动生成
	        // useCodes:'',
	        // autoSel : true,
	        desId: "EP_EO_UI_3107",
	        // isGw : true,
	        // isLbl : false,
	        // isRead : false,
	        // isSrp : false,
	        lblAlg: "right"
	        // maxL : 500,
	        // minL : 500,
	        // msfTgt : "qtip",
	        // useTim : 0,
	        // visible : false,
	        // x : "0",
	        // y : "0",
	    };
	};
	
	exports.SgiFormComboboxEO = SgiFormComboboxEO;
	exports.default = SgiFormComboboxEO;

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 下拉树
	 * wangj
	 */
	
	var SgiFormComboxTreeEO = function SgiFormComboxTreeEO() {
	    return {
	        alwBlk: true, //是否允许为空
	        // c:"value",//树显示字段名
	        ctlH: 0, //组件高度
	        ctlN: "下拉树", //控件名称
	        ctlW: 24, //组件宽度
	        desId: "EP_EO_NUI_0001", //描述GUID
	        isDis: false, //是否禁用
	        lblAlg: "right", //设置标签位置
	        lblW: 6, //标签宽度
	        mulSel: false, //设置是否允许多选
	        inpPopTe: "--请选择--",
	        // n:"子系统菜单",//名称
	        // sNo:10,//排序号
	        // scId:"SD_SC_PUB_test1",//下拉窗列表值在标准代码中的id
	        te: "下拉树" //显示名称
	        // saveKey:'value',//保存属性名
	        // showKey:'title',//显示属性名
	        // insName:'EOCat',//实例名
	        // autoSel:true,//自动选择状态
	
	        // isGw:false,//延伸状态
	        // isHdn:false,//隐藏状态
	        // isLbl:true,//是否显示标签
	        // isRead:true,//是否只读
	        // isSrp:true,//键盘过滤状态
	        // maxL:0,//最大长度
	        // minL:0,//最小长度
	        // msfTgt:"qtip",//提示信息位置
	        // t:"comboxTree",//类型
	        // useTim:0,//使用次数
	        // visible:true,
	        // x:"0",//X轴位置
	        // y:"0",//Y轴位置
	    };
	};
	
	exports.SgiFormComboxTreeEO = SgiFormComboxTreeEO;
	exports.default = SgiFormComboxTreeEO;

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiFormDateEO = function SgiFormDateEO() {
	    return {
	        alwBlk: true,
	        // c:"desId",
	        ctlH: 0,
	        ctlN: "日期控件",
	        ctlW: 24,
	        // dateFmt:"YYYY-MM-DD", // 日期格式 HH:mm:ss
	        // dateTimeFlag: false, // 是否显示时间
	        desId: "EP_EO_UI_3106",
	        isDis: false,
	        isHdn: false,
	        lblW: 6,
	        te: "日期",
	
	        isLbl: false,
	        lblAlg: "right",
	        ctlMode: "date", //默认模式：日期模式
	        inpPopTe: "请选择日期"
	        // csstyle:"date-default", // 显示样式
	        // disDays:"0", // 禁止选择星期
	        // isRead:false,
	        // optBDt:moment("2018-02-01", 'YYYY-MM-DD'), // 可选的起始日期
	        // optEDt:moment("2018-05-01", 'YYYY-MM-DD'), // 可选的结束日期
	        // msfTgt:"qtip",
	
	        // isGw:false, //延伸状态
	        // isSrp:true, //键盘过滤状态
	        // maxL:20,
	        // minL:0,
	        // n:"描述GUID",
	        // sNo:10,
	        // t:"date",
	        // useTim:0,
	        // visible:true,
	        // x:"0",
	        // y:"0",
	    };
	};
	
	exports.SgiFormDateEO = SgiFormDateEO;
	exports.default = SgiFormDateEO;

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiFormEO = function SgiFormEO() {
	    return {
	        te: "我是Formx",
	        // cId: '222',
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "Form",
	        style: { minHeight: '200px' },
	        desId: "EP_EO_UI_4002",
	        isBrdr: false,
	        isHdn: false,
	        isScl: false,
	        bdInst: '',
	        bdDvId: '',
	        isTtl: true,
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        ttlAlgn: "center",
	        lblAlgn: "right"
	    };
	};
	exports.SgiFormEO = SgiFormEO;
	exports.default = SgiFormEO;

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiFormEditorEO = function SgiFormEditorEO() {
	    return {
	        alwBlk: true,
	        // c:"attribute1",
	        ctlH: 0,
	        // ctlN:"弹出窗",
	        ctlW: 24,
	        desId: "EP_EO_UI_3012",
	        isDis: false,
	        isHdn: false,
	        isLbl: false,
	        isRead: false,
	        lblAlg: "right",
	        lblW: 3,
	
	        maxL: 0,
	        minL: 0,
	        // n:"属性1",
	        sNo: 0,
	        // t:"umeditor",
	        te: "富文本",
	        // useTim:0,
	        visible: true
	        // x:"0",
	        // y:"0",
	    };
	};
	
	exports.SgiFormEditorEO = SgiFormEditorEO;
	exports.default = SgiFormEditorEO;

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiFormFileEO = function SgiFormFileEO() {
	    return {
	        alwBlk: true,
	        btnN: "上传文件", // 按钮名称
	        ctlN: "文件",
	        // c:"desId",
	        cluW: 150, // 按钮宽度
	        ctlH: 0,
	        ctlW: 24,
	        desId: "EP_EO_UI_3118",
	        iconPh: "upload", // 按钮图标
	        // inpPopTe:"输入提示",
	        isDis: false,
	        isHdn: false,
	        lblW: 6,
	        mulSel: true, // 设置是否允许多选
	        disType: "text", //上传文件列表样式
	
	        // closeI:"SD_RP_IR_0001`UI`UI05", // 关闭按钮图标
	        // fileNameI:"SD_RP_IR_0001`UI`UI03", // 文件图标
	        // isLbl:false,
	        // isRead:false,
	        lblAlg: "right",
	        // msfTgt:"qtip",
	
	
	        // isGw:false,
	        // isSrp:true,
	        // maxL:20,
	        // minL:0,
	        // n:"描述GUID",
	        // sNo:10,
	        // t:"uploadFile",
	        te: "上传文件"
	        // useTim:0,
	        // visible:true,
	        // x:"0",
	        // y:"0",
	    };
	};
	
	exports.SgiFormFileEO = SgiFormFileEO;
	exports.default = SgiFormFileEO;

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiFormInputNumberEO = function SgiFormInputNumberEO() {
	    return {
	        alwBlk: true,
	        // c:"desId",
	        ctlH: 0,
	        ctlN: "数字",
	        ctlW: 24,
	        dcmDgt: 2, // 小数位
	        desId: "EP_EO_UI_3104",
	        inpPopTe: "请输入数字", // 输入提示文本
	        isDis: false,
	        isHdn: false,
	        lblW: 6,
	        maxV: 9999, // 输入最大值
	        minV: 0, // 输入最小值
	        step: 1, //微调的数字间距
	        te: "数字",
	        selectType: "00", //添加符号
	        isLbl: false,
	        lblAlg: "right",
	        // isRead:false,
	        // msfTgt:"qtip",
	
	        // isHdnTg:false, // 是否隐藏微调
	        // intDgt:0, // 整数位
	        maxL: 0, // 最大输入长度
	        minL: 0 // 最小输入长度
	        // isSrp:true, //x键盘过滤状态
	        // isGw:false, //延伸状态
	        // n:"描述GUID",
	        // sNo:10,
	        // t:"num",
	        // useTim:0,
	        // visible:true,
	        // x:"0",
	        // y:"0",
	    };
	};
	
	exports.SgiFormInputNumberEO = SgiFormInputNumberEO;
	exports.default = SgiFormInputNumberEO;

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * @Descripttion: 
	 * @version: 
	 * @Author: hanzb
	 * @Date: 2019-11-21 14:58:03
	 * @LastEditors: hanzb
	 * @LastEditTime: 2020-04-13 15:53:21
	 */
	var SgiFormPopUIEO = function SgiFormPopUIEO() {
	    return {
	        alwBlk: true,
	        // btnN:"上传文件", // 按钮名称
	        // c:"desId",
	        cluW: 80, // 按钮宽度
	        ctlH: 0,
	        ctlW: 24,
	        ctlN: "弹出",
	        desId: "EP_EO_UI_3011",
	        // iconPh:"upload", // 按钮图标
	        inpPopTe: "--请选择--",
	        isDis: false,
	        isHdn: false,
	        lblW: 6,
	        // mulSel:true, // 设置是否允许多选
	
	        // closeI:"SD_RP_IR_0001`UI`UI05", // 关闭按钮图标
	        // fileNameI:"SD_RP_IR_0001`UI`UI03", // 文件图标
	        // isLbl:false,
	        // isRead:false,
	        lblAlg: "right",
	        // msfTgt:"qtip",
	
	
	        isGw: false,
	        isSrp: true,
	        // maxL: 40,//谁打开的？？没事别打开！！
	        // minL: 0,
	        // n:"描述GUID",
	        sNo: 10,
	        // t:"uploadFile",
	        te: "弹出窗",
	        // useTim:0,
	        // visible:true,
	        // x:"0",
	        // y:"0",
	
	        title: "我是标题",
	        okText: "确认按钮文字",
	        cancelText: "取消按钮文字",
	        closable: true, // 是否显示右上角的关闭按钮
	        width: 520, // 宽度，string|number	520
	        // footer: [
	        //         <Button key="back" onClick={this.handleCancel}>返回</Button>,
	        //         <Button key="submit" type="primary" onClick={this.handleOk}>
	        //           提交
	        //         </Button>,
	        //       ],// 底部内容，当不需要默认底部按钮时，可以设为 footer={null}
	        footer: [], //
	
	        modalContext: [//自己加的
	            // <p>Some contents...</p>,
	            // <p>Some contents...</p>,
	            // <p>Some contents...</p>
	        ]
	    };
	};
	
	exports.SgiFormPopUIEO = SgiFormPopUIEO;
	exports.default = SgiFormPopUIEO;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 单选按钮
	 * wangj
	 */
	
	var SgiFormRadioEO = function SgiFormRadioEO() {
	    return {
	        // isBtn:false,
	        // checked:'1',
	        // c : "col2",
	        ctlH: 0,
	        ctlN: "单选框",
	        ctlW: 24,
	        desId: "EP_EO_UI_3109",
	        isDis: false,
	        isHdn: false,
	        lblAlg: "right",
	        lblW: 6,
	        // n : "字段2",
	        sNo: 0,
	        // scId: 'SD_SC_PT_0001',//标准代码GUID
	        // t : "radio",
	        te: '单选框组',
	        // ctlClu:1,
	        // useCodes:'',
	
	        alwBlk: true
	        // isGw : false,
	        // isLbl : true,
	        // isRead : false,
	        // isSrp : true,
	
	        // maxL : 0,
	        // minL : 0,
	        // msfTgt : "qtip",
	        // useTim : 0,
	        // visible : true,
	        // x : "0",
	        // y : "0",
	    };
	};
	
	exports.SgiFormRadioEO = SgiFormRadioEO;
	exports.default = SgiFormRadioEO;

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiFormTextAreaEO = function SgiFormTextAreaEO() {
	    return {
	        alwBlk: true,
	        // c: "desId",
	        ctlH: 0,
	        ctlN: "文本域",
	        ctlRow: 4,
	        ctlW: 24,
	        desId: "EP_EO_UI_3102", //描述GUID
	        isDis: false,
	        isHdn: false,
	        isScl: true, //滚动条（滚动状态）
	        lblW: 6,
	        maxL: 0,
	        minL: 0,
	        te: "文本域",
	        inpPopTe: "请输入文本内容",
	        // isLbl: false,
	        lblAlg: "right"
	        // isRead:false,
	        // msfTgt:"qtip",
	
	        // isGw:false, //x延伸状态
	        // isSrp:true, //x键盘过滤状态
	        // n:"描述GUID",
	        // sNo:10,
	        // t:"area",
	        // useTim:0,
	        // visible:true,
	        // x:"0",
	        // y:"0",
	    };
	};
	
	exports.SgiFormTextAreaEO = SgiFormTextAreaEO;
	exports.default = SgiFormTextAreaEO;

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiFormTextEO = function SgiFormTextEO() {
	    return {
	        // cId: '',
	        alwBlk: true,
	        // c: "guid",
	        ctlH: 0,
	        ctlW: 24,
	        lblW: 6,
	        desId: "EP_EO_UI_3101",
	        isDis: false,
	        isHdn: false,
	        isLbl: false,
	        lblAlg: "right",
	        bdText: '',
	        maxL: 0,
	        minL: 0,
	        te: "文本",
	        teAl: "left",
	        vldC: "",
	        inpPopTe: "请输入文本",
	        // visible: true,
	        // x: "0",
	        // y: "0",
	        ctlN: "普通文本框",
	        // iconPh: "SD_RP_IR_0001`UI`UI09",
	        // msfTgt: "qtip",
	        // n: "GUID/guid",
	        // sNo: 0,
	        // t: "text",
	        isPwd: false
	        // isRead: false,
	        // isSrp: true,
	        // isGw: false,
	    };
	};
	
	exports.SgiFormTextEO = SgiFormTextEO;
	exports.default = SgiFormTextEO;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormTimeEO = undefined;
	
	var _moment = __webpack_require__(40);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SgiFormTimeEO = function SgiFormTimeEO() {
	    return {
	        alwBlk: true,
	        // c:"desId",
	        ctlH: 0,
	        ctlN: "时间控件",
	        ctlW: 24,
	        // defVal10:moment('12:08:23', 'HH:mm:ss'), //传入的是moment对象
	        desId: "EP_EO_UI_3105",
	        isDis: false,
	        isHdn: false,
	        lblW: 6,
	        te: "时间",
	
	        isLbl: false,
	        lblAlg: "right",
	        inpPopTe: "请选择时间",
	        // csstyle:"time-default", // 自定义css样式
	        // mgn:"10",
	        // pad:"20",
	        // msfTgt:"qtip",
	        // isRead:false,
	        hourStep: 1, // 微调的时间间距：原平台为step
	        minuteStep: 1, // 微调的时间间距
	        secondStep: 1 // 微调的时间间距
	
	        // isSrp:true, //键盘过滤状态
	        // maxL:20, //不需要
	        // minL:0, //不需要
	        // isGw:false, //延伸状态
	        // n:"描述GUID",
	        // sNo:10,
	        // t:"time",
	        // useTim:0,
	        // visible:true,
	        // x:"0",
	        // y:"0",
	    };
	};
	
	exports.SgiFormTimeEO = SgiFormTimeEO;
	exports.default = SgiFormTimeEO;

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 图片
	 * 
	 */
	
	var SgiImgEO = function SgiImgEO() {
	
	    return {
	        disply: "", //图片地址
	        alt: "图片加载失败", //规定图像的替代文本
	        ctlH: "100%",
	        ctlW: "100%",
	        desId: "EP_EO_UI_3004",
	        c: '', //
	        ctlN: "图片",
	        cId: '', //组件编号
	        // sc:'',//语义代码
	        n: "图片",
	        // t: "text",
	        te: "我是图片组件x"
	
	    };
	};
	
	exports.SgiImgEO = SgiImgEO;
	exports.default = SgiImgEO;

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 图片
	 * 
	 */
	
	var SgiLabelEO = function SgiLabelEO() {
	
	    return {
	        disply: "", //图片地址
	        // alt: "图片加载失败",//规定图像的替代文本
	        ctlH: "",
	        ctlW: "",
	        // ctlH: "",
	        // ctlW: "",
	        desId: "EP_EO_UI_3002",
	        c: '', //
	        ctlN: "标签",
	        cId: '', //组件编号
	        // sc:'',//语义代码
	        n: "标签",
	        // t: "text",
	        te: "标签"
	
	    };
	};
	
	exports.SgiLabelEO = SgiLabelEO;
	exports.default = SgiLabelEO;

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 图片
	 * 
	 */
	
	var SgiListEO = function SgiListEO() {
	
	    return {
	        // disply: "",//图片地址
	        // alt: "图片加载失败",//规定图像的替代文本
	        ctlH: "100%",
	        ctlW: "100%",
	        desId: "EP_EO_UI_4107",
	        c: '', //
	        ctlN: "列表",
	        cId: '', //组件编号
	        // sc:'',//语义代码
	        n: "列表",
	        // t: "text",
	        te: "我是列表组件x"
	
	    };
	};
	
	exports.SgiListEO = SgiListEO;
	exports.default = SgiListEO;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 菜单
	 * wangj
	 */
	
	var SgiMenuEO = function SgiMenuEO() {
	
	    return {
	        // autoHide: false,
	        // docket: "top",//停靠位置，现在支持垂直、水平、和内嵌模式三种
	        // indented: true,
	        // ignoreParentClicks: false,
	        // otherMenus: false,
	        // plain: false,
	        // flx: 0,
	        // separator: false,
	        // mouseLeaveDelay: 50,
	        // ctlH: "",
	        // ctlW: "",
	        desId: "EP_EO_UI_4004",
	        // rSC:"SD_SC_PUB_test1",//下拉窗列表值在标准代码中的id
	        // cldSet:'',//
	        mode: 'inline', //菜单类型，现在支持垂直、水平、和内嵌模式三种
	        // sNo: 0,
	        // ann:'',//
	        c: '', //
	        ctlN: "菜单",
	        cId: '', //组件编号
	        // sc:'',//语义代码
	        n: "菜单",
	        // t: "text",
	        te: "我是菜单组件x",
	        // teAl: "left",
	
	        theme: "light",
	        insName: "" //绑定实例名-y
	        // inlineCollapsed: "",//inline 时菜单是否收起状态
	    };
	};
	
	exports.SgiMenuEO = SgiMenuEO;
	exports.default = SgiMenuEO;

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiNestEO = function SgiNestEO() {
	    return {
	        te: "我是嵌入面板x",
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "嵌入面板",
	        style: { minHeight: '200px' },
	        desId: "EP_EO_UI_4106",
	        isBrdr: true,
	        // isHdn: false,
	        isScl: false,
	        // isTtl: true,
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        ttlAlgn: "center"
	    };
	};
	exports.SgiNestEO = SgiNestEO;
	exports.default = SgiNestEO;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiOverlapEO = function SgiOverlapEO() {
	    return {
	        cId: "",
	        ctlN: "新层叠面板",
	        ctlH: '100%',
	        ctlW: '100%',
	        desId: "EP_EO_UI_41032",
	        te: "",
	        pad: "0 0 0 0",
	        mgn: "0 0 0 0",
	        isBrdr: true
	    };
	};
	exports.SgiOverlapEO = SgiOverlapEO;
	exports.default = SgiOverlapEO;

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiPanelEO = function SgiPanelEO() {
	    return {
	        te: "我是面板x",
	        // cId: '222',
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "普通面板",
	        style: { minHeight: '200px' },
	        desId: "EP_EO_UI_4001",
	        isBrdr: true,
	        isHdn: false,
	        isScl: false,
	        isTtl: true,
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        ttlAlgn: "center",
	        loading: false //初始加载中
	    };
	};
	exports.SgiPanelEO = SgiPanelEO;
	exports.default = SgiPanelEO;

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * @Descripttion: 
	 * @version: 
	 * @Author: wzhe
	 * @Date: 2019-11-21 14:58:04
	 * @LastEditors: hanzb
	 * @LastEditTime: 2020-04-15 16:05:26
	 */
	var SgiRowEO = function SgiRowEO() {
	    return {
	        justify: 'start',
	        type: 'flex',
	        ctlN: "行",
	        align: 'top',
	        // ctlH: "100%", //在form里拖行的时候高度100%比较恶心
	        ctlW: "100%",
	        // cldSet: [col1, col2],
	        desId: "EP_EO_UI_5101"
	    };
	};
	
	exports.SgiRowEO = SgiRowEO;
	exports.default = SgiRowEO;

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiSplitterEO = function SgiSplitterEO() {
	    return {
	        cid: '', // 控件编号
	        ctlH: '100%',
	        ctlN: "分割面板",
	        ctlW: '100%',
	        desId: "EP_EO_UI_4101",
	        isBrdr: false,
	        isEdwSpt: false, //纵向分割
	        // isHdn: false,
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        sptLnW: 5,
	        sptSca: "" //分割比例
	    };
	};
	exports.SgiSplitterEO = SgiSplitterEO;
	exports.default = SgiSplitterEO;

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 菜单
	 * wangj
	 */
	
	var SgiStepsEO = function SgiStepsEO() {
	
	    return {
	
	        // ctlH: "",
	        // ctlW: "",
	        desId: "EP_EO_UI_3015",
	        // rSC:"rnt_SC_webTest_0001",//下拉窗列表值在标准代码中的id
	        current: 0, //指定当前步骤，从 0 开始记数 //数字类型，不能是字符串类型！
	        direction: "horizontal",
	        c: '', //
	        ctlN: "步骤",
	        cId: '', //组件编号
	        // sc:'',//语义代码
	        n: "步骤",
	        // t: "text",
	        te: "我是步骤组件x"
	
	    };
	};
	
	exports.SgiStepsEO = SgiStepsEO;
	exports.default = SgiStepsEO;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiTVEO = function SgiTVEO() {
	    return {
	        // cId: "UIprmsTable",
	        isSt: true,
	        chkMd: "0",
	        // cluDes: "SD_TV_UI_000101",
	        // cpB: 0,
	        ctlH: '100%',
	        ctlN: "表格",
	        ctlW: '100%',
	        desId: "EP_EO_UI_TV",
	        // insName: "UIprms",
	        // isBatch: false,
	        // isBrdr: false,
	        isEd: false,
	        isHeaders: false,
	        isPg: true,
	        isPage: true, //显示翻页器
	        size: "small", //表格大小，默认为小
	        // isRowNo: false,
	        // isSch: true,
	        isTbSpt: true,
	        isTtl: true,
	        // pgRows: 8,
	        rowSMd: "9",
	        sNo: 0,
	        selFirst: false,
	        loading: false, //初始加载中
	        tbLayout: "fixed" //- | 'auto' | 'fixed' -- 表格元素的 table-layout 属性，设为 fixed 表示内容不会影响列的布局
	    };
	};
	exports.SgiTVEO = SgiTVEO;
	exports.default = SgiTVEO;

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiTableEO = function SgiTableEO() {
	    return {
	        // cId: "UIprmsTable",
	        isSt: true,
	        chkMd: "0",
	        // cluDes: "SD_TV_UI_000101",
	        // cpB: 0,
	        ctlH: '100%',
	        ctlN: "表格",
	        ctlW: '100%',
	        desId: "EP_EO_UI_3008",
	        // insName: "UIprms",
	        // isBatch: false,
	        // isBrdr: false,
	        isEd: false,
	        isHeaders: false,
	        isPg: true,
	        isPage: true, //显示翻页器
	        size: "small", //表格大小，默认为小
	        // isRowNo: false,
	        // isSch: true,
	        isTbSpt: true,
	        isTtl: true,
	        // pgRows: 8,
	        rowSMd: "9",
	        sNo: 0,
	        selFirst: false,
	        loading: false //初始加载中
	        // clpDrt: "top",
	        // clpd: false,
	        // isClp: false,
	        // isClpFst: true,
	        // isFill: true,
	        // isHClpTl: false,
	        // isLkClu: false,
	        // isMsMu: false,
	        // isIntSch: true,
	        // isTal: true,
	        // isRowexp: false,
	        // isttlClp: false,
	        // flx: 0,
	        // iconPh: "SD_RP_IR_0001`UI`UI08",
	        // smayFlag: false,
	        // ttlAlg: "top",
	        // ttlAlgn: "0",
	        // useTim: 0,
	        // visible: true
	    };
	};
	exports.SgiTableEO = SgiTableEO;
	exports.default = SgiTableEO;

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiTabsEO = function SgiTabsEO() {
	    return {
	        atvTab: "",
	        ctlH: '100%',
	        ctlW: '100%',
	        desId: "EP_EO_UI_4102",
	        tabPst: "top",
	        type: "card",
	        // tabLsn: "tool.sgiLogger.log('tab切换监听，activeKey：',activeKey);",
	        // clpDrt: "top",
	        ctlN: "选项卡"
	        // tbGutter: 0,//标题间隔
	        // clpd : false,
	        // csstyle : "tab-default",
	        // flx : 0,
	        // iconPh : "SD_RP_IR_0001`UI`UI04",
	        // isBdyBrdr : true,
	        // isBrdr : false,
	        // isClp : false,
	        // isClpFst : true,
	        // isCls : false,
	        // isDis : false,
	        // isFrm : false,
	        // isHClpTl : false,
	        // isHdn : false,
	        // isRead : false,
	        // isScl : false,
	        // isTtl : false,
	        // isttlClp : false,
	        // mgn : "0 0 0 0",
	        // n : "选项卡",
	        // pad : "0 0 0 0",
	        // plain : false,
	        // sNo : 0,
	        // sc : "funcTab",        
	        // tabRta : "default",
	        // te : "123",
	        // ttlAlg : "top",
	        // ttlAlgn : "left",
	        // useTim : 0,
	        // visible : true,
	        // x : "0",
	        // y : "0"       
	    };
	};
	exports.SgiTabsEO = SgiTabsEO;
	exports.default = SgiTabsEO;

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiTileEO = function SgiTileEO() {
	    return {
	        te: "我是平铺组件x",
	        // cId: '222',
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "平铺",
	        style: { minHeight: '200px' },
	        desId: "EP_EO_UI_SgiTile",
	        isBrdr: true,
	        isHdn: false,
	        isScl: false,
	        isTtl: true,
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        ttlAlgn: "center"
	    };
	};
	exports.SgiTileEO = SgiTileEO;
	exports.default = SgiTileEO;

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SgiToolbarEO = function SgiToolbarEO() {
	    return _defineProperty({
	        btnAlg: "center", //按钮位置
	        ctlH: 0,
	        ctlN: "工具条",
	        ctlW: '100%',
	        desId: "EP_EO_UI_3010",
	        isDis: false, //禁用
	        tlbAlg: "top" }, "btnAlg", 'right');
	};
	exports.SgiToolbarEO = SgiToolbarEO;
	exports.default = SgiToolbarEO;

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 穿梭框
	 * 
	 */
	
	var SgiTransferEO = function SgiTransferEO() {
	
	    return {
	        insName: "", //绑定实例名
	        _key: "", //key值
	        width: "",
	        height: "",
	        showSearch: "", //是否显示搜索框
	        leftTitle: "Source", //左标题
	        rightTitle: "Target", //右标题
	        leftOperation: "", //左操作文案
	        rightOperation: "", //右操作文案
	        // ctlH: "",
	        // ctlW: "",
	        desId: "EP_EO_UI_3017",
	        c: '', //
	        ctlN: "穿梭框",
	        cId: '', //组件编号
	        // sc:'',//语义代码
	        n: "穿梭框",
	        // t: "text",
	        te: "我是穿梭框组件x"
	
	    };
	};
	
	exports.SgiTransferEO = SgiTransferEO;
	exports.default = SgiTransferEO;

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiTreeEO = function SgiTreeEO() {
	    return {
	        // c: "title", //树显示字段名
	        // cId: "EOCat", //组件标识
	        ctlH: '100%',
	        // ctlW: '100%',
	        desId: "EP_EO_UI_3007",
	        // insName: "EOCat", //绑定实例名
	        isBrdr: false,
	        mgn: "0 0 0 0",
	        ndIsChk: false, //树节点是否可选
	        ndIsDg: false, //树节点是否可拖拽
	        ndisLine: true, //树节点是否连线
	        pad: "0 0 0 0",
	        selFirst: false, //初始化后选择首行
	        // sNo: 0,
	        // sc: "EOCat", //语义码
	        // cpB: 0,
	        // csstyle: "80",
	        ctlN: "树", //组件名
	        // disCustom: false, //只显示自定义菜单
	        // flx: 0,
	        // iconPh: "SD_RP_IR_0001`UI`UI07",
	        // isBatch: false,
	        // isBdyBrdr: true,
	        // isClp: false, // 面板是否可以折叠
	        // isClpFst: true, // 是否面板展开或收缩的顺序
	        // isCls: false, // 面板是否可以关闭
	        // isDis: false,
	        // isFrm: false, // 面板是否填充
	        // isHClpTl: false, // 是否显示折叠按钮
	        // isHdn: false,
	        // isMsMu: false, //使用右键菜单
	        // isRead: false,
	        // isScl: false,
	        // isShRoot: false,
	        // isTbTr: false,
	        // isTlb: false, //显示工具条
	        // isTtl: false,
	        // isttlClp: false, // 是否单击面板头部折叠
	        // te: "标签名", //显示名称
	        // tlbIsTtl: true, //显示标题
	        // ttlAlg: "top", // 面板标题位置
	        // ttlAlgn: "left", // 面板标题对齐方式
	        // useTim: 0,
	        // visible: true,
	        // animate:true, //树展开收起展示动画效果
	        // autoScroll:true, //自动滚动
	        // overflowY:"auto", //自动启动垂直滚动条
	        // rootVisible:false, //树根是否显示
	        // clpDrt: "top", // 面板的折叠方向
	        // clpd: false, // 面板初始时的折叠状态
	        n: "子系统菜单"
	    };
	};
	exports.SgiTreeEO = SgiTreeEO;
	exports.default = SgiTreeEO;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/*
	 * @Descripttion: 
	 * @version: 
	 * @Author: wangz
	 * @Date: 2019-11-21 14:58:04
	 * @LastEditors: hanzb
	 * @LastEditTime: 2020-04-20 09:15:23
	 */
	//追加新的sgiConfig的配置信息
	// let ip = "https://www.egssoft.com.cn";
	var ip = "http://100.1.1.26";
	var zuul = ip + ":8088";
	var sgiConfigDefault = {
		currentAP: 'rtsd',
		pf: zuul + "/pf",
		// pf: "https://www.egssoft.com.cn:8895/pf",
		service: zuul,
	
		fileAction: zuul + "/fileserver/uploadFile", //文件服务器
		fileActionB64: zuul + "/fileserver/uploadFileB64",
		bussType: "rtsd", //项目路径
	
		popMessageMaxCount: 1, //popMessage方法弹出消息最大数量
		prmRelease: false,
	
		// 默认日志级别降低，方便测试；各项目配置自己合适的日志级别
		logger: {
			level: -1,
			stack: true
		},
	
		prmEditor: false
	};
	
	// 初始化
	if (!window.sgiConfig) window.sgiConfig = {};
	// 添加方法
	Object.assign(window.sgiConfig, sgiConfigDefault);
	// 导出
	exports.default = window.sgiConfig;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ComponentManager = undefined;
	
	var _sgiLogger = __webpack_require__(39);
	
	/**
	 * @namespace 组件管理器
	 */
	var ComponentManager = {
		/**
	  * 组件缓存
	  */
		all: {},
		/**
	  * 获取组件实例
	  * @param {string} uid 页面guid
	  * @param {string} id 组件id
	  */
		get: function get(uid, id) {
			if (!uid || !id) {
				return null;
			}
			var uidCompMng = this.all[uid];
			if (!uidCompMng) {
				return null;
			}
			var comp = uidCompMng[id];
			if (!comp) _sgiLogger.sgiLogger.debug("\u7EC4\u4EF6\u7BA1\u7406\u5668\u4E2D\u627E\u4E0D\u5230key\u4E3A" + id + "\u7684\u7EC4\u4EF6\uFF0C\u5728guid\u4E3A" + uid + "\u7684\u9875\u9762\u4E0B\u3002\u5EFA\u8BAE\u68C0\u67E5\u4EE3\u7801\u786E\u8BA4\u8BE5\u60C5\u51B5\u662F\u5426\u6B63\u5E38\uFF01");
			return comp;
		},
		/**
	  * 设置控件实例
	  * @param {string} uid 页面guid
	  * @param {string} id 控件id
	  * @param {instance} component 控件实例
	  */
		set: function set(uid, id, component) {
			if (!uid || !id || !component) {
				return null;
			}
			var uidCompMng = this.all[uid];
			if (!uidCompMng) {
				uidCompMng = {};
				this.all[uid] = uidCompMng;
			}
			uidCompMng[id] = component;
		},
		/**
	  * 删除指定页面下所有控件实例缓存
	  * @param {string} uid 页面guid
	  */
		deleteByUid: function deleteByUid(uid) {
			if (!uid) return;
			delete this.all[uid];
		},
		/**
	  * 删除指定页面下指定控件缓存
	  * @param {string} uid 页面guid
	  * @param {string} id 控件id
	  */
		deleteById: function deleteById(uid, id) {
			if (!uid || !id) return;
	
			var uidCompMng = this.all[uid];
			if (!uidCompMng) return;
	
			delete uidCompMng[id];
		}
	
		// 初始化
	}; /*
	    * @Descripttion: 
	    * @version: 
	    * @Author: somebody
	    * @Date: 2019-11-21 14:58:04
	    * @LastEditors: hanzb
	    * @LastEditTime: 2020-04-02 14:22:24
	    */
	if (!window.ComponentManager) window.ComponentManager = ComponentManager;
	// 添加方法
	else Object.assign(window.ComponentManager, ComponentManager);
	// 导出
	var wComponentManager = window.ComponentManager;
	exports.ComponentManager = wComponentManager;
	exports.default = wComponentManager;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MediaResourceCode = undefined;
	
	var _PrmFactory = __webpack_require__(63);
	
	var SCMap; /*     标准代码提供者
	            归属：企通前端平台-ECP V5.1
	            版权：2014-2020 企通软件技术有限公司
	            --------------------------------------------------------------------------------
	            作者：纪青君                         创建日期：2014/03/13
	            修改：                               修改日期：
	            修改内容
	            --------------------------------------------------------------------------------
	            这里向使用者提供根据代码ID，获得代码的方法getSC(scID)
	            scID 符合XXXX,xx`xx`xx...的定义规则
	            输入参数scID包含的项不同，你得到的结果也不同，例如：
	            getSC（XXXX），你可能得到的是一个代码数组或代码树。
	            getSC(XXXX,xx)，你可能得到的是一个具体的代码值，也可能你得到的还是一个代码
	            数组或代码树，这样依据你的代码结构而定。
	            
	            !!!! 目前采用程序直接量的方式定义各种代码，最终将改为从参数中读取，但对外接口将保持不变
	            --------------------------------------------------------------------------------
	            修改： liux                              修改日期：2014/04/30
	            修改内容
	            getSC方法修改为使用参数工厂从参数库中读取一个代码。
	            指定的scID可以使一个代码参数的GUID，也可以是某个代码参数中的任意子节点的sGUID。
	            但是该方法返回的是参数的json形式对象或json对象的数组,而不是一个model对象。
	            --------------------------------------------------------------------------------
	            //0XXX：控件公共信息
	            //1XXX：容器控件
	            //2XXX：基本控件
	            //3XXX：自定义控件
	            //4XXX：布局属性
	            //5XXX: 图形控件
	            //6XXX—8XXX:保留
	            //9XXX:公共
	            
	            *******************************************************************************/
	
	var MediaResourceCode = {
	
	  getPrmUrl: function getPrmUrl(scID) {
	    if (!scID) {
	      return null;
	    }
	    if (typeof scID != "string") {
	      return null;
	    }
	    var fileUrl;
	    var ms = scID.split("`");
	    var mguid = ms[0];
	    if (!SCMap) {
	      var prm = this.prmInit(mguid, ms);
	      if (prm) {
	        fileUrl = prm.c;
	      }
	    } else {}
	
	    return fileUrl;
	  },
	  prmInit: function prmInit(mguid, ms) {
	    SCMap = {};
	    var json = _PrmFactory.PrmFactory.getPrm(mguid);
	    var length = ms.length;
	    for (var i = 1; i < length; i++) {
	      json = _PrmFactory.PrmFactory.findMenber(json, ms[i]);
	    }
	    SCMap[mguid] = json;
	    return json;
	  }
	
	};
	exports.MediaResourceCode = MediaResourceCode;
	exports.default = MediaResourceCode;

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getScroll;
	
	function getScroll(target, top) {
	  if (typeof window === 'undefined') {
	    return 0;
	  }
	
	  var prop = top ? 'pageYOffset' : 'pageXOffset';
	  var method = top ? 'scrollTop' : 'scrollLeft';
	  var isWindow = target === window;
	  var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode
	
	  if (isWindow && typeof ret !== 'number') {
	    ret = document.documentElement[method];
	  }
	
	  return ret;
	}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = scrollTo;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	var _getScroll = _interopRequireDefault(__webpack_require__(350));
	
	var _easings = __webpack_require__(1160);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function scrollTo(y) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$getContainer = options.getContainer,
	      getContainer = _options$getContainer === void 0 ? function () {
	    return window;
	  } : _options$getContainer,
	      callback = options.callback,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 450 : _options$duration;
	  var container = getContainer();
	  var scrollTop = (0, _getScroll["default"])(container, true);
	  var startTime = Date.now();
	
	  var frameFunc = function frameFunc() {
	    var timestamp = Date.now();
	    var time = timestamp - startTime;
	    var nextScrollTop = (0, _easings.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);
	
	    if (container === window) {
	      window.scrollTo(window.pageXOffset, nextScrollTop);
	    } else {
	      container.scrollTop = nextScrollTop;
	    }
	
	    if (time < duration) {
	      (0, _raf["default"])(frameFunc);
	    } else if (typeof callback === 'function') {
	      callback();
	    }
	  };
	
	  (0, _raf["default"])(frameFunc);
	}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/**
	 * Wrap of sub component which need use as Button capacity (like Icon component).
	 * This helps accessibility reader to tread as a interactive button to operation.
	 */
	
	var inlineStyle = {
	  border: 0,
	  background: 'transparent',
	  padding: 0,
	  lineHeight: 'inherit',
	  display: 'inline-block'
	};
	
	var TransButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(TransButton, _React$Component);
	
	  var _super = _createSuper(TransButton);
	
	  function TransButton() {
	    var _this;
	
	    _classCallCheck(this, TransButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (event) {
	      var keyCode = event.keyCode;
	
	      if (keyCode === _KeyCode["default"].ENTER) {
	        event.preventDefault();
	      }
	    };
	
	    _this.onKeyUp = function (event) {
	      var keyCode = event.keyCode;
	      var onClick = _this.props.onClick;
	
	      if (keyCode === _KeyCode["default"].ENTER && onClick) {
	        onClick();
	      }
	    };
	
	    _this.setRef = function (btn) {
	      _this.div = btn;
	    };
	
	    return _this;
	  }
	
	  _createClass(TransButton, [{
	    key: "focus",
	    value: function focus() {
	      if (this.div) {
	        this.div.focus();
	      }
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      if (this.div) {
	        this.div.blur();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          style = _a.style,
	          noStyle = _a.noStyle,
	          restProps = __rest(_a, ["style", "noStyle"]);
	
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          role: "button",
	          tabIndex: 0,
	          ref: this.setRef
	        }, restProps, {
	          onKeyDown: this.onKeyDown,
	          onKeyUp: this.onKeyUp,
	          style: _extends(_extends({}, !noStyle ? inlineStyle : null), style)
	        }))
	      );
	    }
	  }]);
	
	  return TransButton;
	}(React.Component);
	
	var _default = TransButton;
	exports["default"] = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(16);
	
	var _Event = _interopRequireDefault(__webpack_require__(494));
	
	var _raf = _interopRequireDefault(__webpack_require__(200));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var styleForPesudo; // Where el is the DOM element you'd like to test for visibility
	
	function isHidden(element) {
	  if (false) {
	    return false;
	  }
	
	  return !element || element.offsetParent === null;
	}
	
	function isNotGrey(color) {
	  // eslint-disable-next-line no-useless-escape
	  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
	
	  if (match && match[1] && match[2] && match[3]) {
	    return !(match[1] === match[2] && match[2] === match[3]);
	  }
	
	  return true;
	}
	
	var Wave = /*#__PURE__*/function (_React$Component) {
	  _inherits(Wave, _React$Component);
	
	  var _super = _createSuper(Wave);
	
	  function Wave() {
	    var _this;
	
	    _classCallCheck(this, Wave);
	
	    _this = _super.apply(this, arguments);
	    _this.animationStart = false;
	    _this.destroy = false;
	
	    _this.onClick = function (node, waveColor) {
	      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
	        return;
	      }
	
	      var insertExtraNode = _this.props.insertExtraNode;
	      _this.extraNode = document.createElement('div');
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          extraNode = _assertThisInitialize.extraNode;
	
	      extraNode.className = 'ant-click-animating-node';
	
	      var attributeName = _this.getAttributeName();
	
	      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey
	
	      styleForPesudo = styleForPesudo || document.createElement('style');
	
	      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
	      waveColor !== 'transparent') {
	        // Add nonce if CSP exist
	        if (_this.csp && _this.csp.nonce) {
	          styleForPesudo.nonce = _this.csp.nonce;
	        }
	
	        extraNode.style.borderColor = waveColor;
	        styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");
	
	        if (!document.body.contains(styleForPesudo)) {
	          document.body.appendChild(styleForPesudo);
	        }
	      }
	
	      if (insertExtraNode) {
	        node.appendChild(extraNode);
	      }
	
	      _Event["default"].addStartEventListener(node, _this.onTransitionStart);
	
	      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
	    };
	
	    _this.onTransitionStart = function (e) {
	      if (_this.destroy) return;
	      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));
	
	      if (!e || e.target !== node) {
	        return;
	      }
	
	      if (!_this.animationStart) {
	        _this.resetEffect(node);
	      }
	    };
	
	    _this.onTransitionEnd = function (e) {
	      if (!e || e.animationName !== 'fadeEffect') {
	        return;
	      }
	
	      _this.resetEffect(e.target);
	    };
	
	    _this.bindAnimationEvent = function (node) {
	      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
	        return;
	      }
	
	      var onClick = function onClick(e) {
	        // Fix radio button click twice
	        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
	          return;
	        }
	
	        _this.resetEffect(node); // Get wave color from target
	
	
	        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
	        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
	        _this.clickWaveTimeoutId = window.setTimeout(function () {
	          return _this.onClick(node, waveColor);
	        }, 0);
	
	        _raf["default"].cancel(_this.animationStartId);
	
	        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
	
	        _this.animationStartId = (0, _raf["default"])(function () {
	          _this.animationStart = false;
	        }, 10);
	      };
	
	      node.addEventListener('click', onClick, true);
	      return {
	        cancel: function cancel() {
	          node.removeEventListener('click', onClick, true);
	        }
	      };
	    };
	
	    _this.renderWave = function (_ref) {
	      var csp = _ref.csp;
	      var children = _this.props.children;
	      _this.csp = csp;
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Wave, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var node = (0, _reactDom.findDOMNode)(this);
	
	      if (!node || node.nodeType !== 1) {
	        return;
	      }
	
	      this.instance = this.bindAnimationEvent(node);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.instance) {
	        this.instance.cancel();
	      }
	
	      if (this.clickWaveTimeoutId) {
	        clearTimeout(this.clickWaveTimeoutId);
	      }
	
	      this.destroy = true;
	    }
	  }, {
	    key: "getAttributeName",
	    value: function getAttributeName() {
	      var insertExtraNode = this.props.insertExtraNode;
	      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
	    }
	  }, {
	    key: "resetEffect",
	    value: function resetEffect(node) {
	      if (!node || node === this.extraNode || !(node instanceof Element)) {
	        return;
	      }
	
	      var insertExtraNode = this.props.insertExtraNode;
	      var attributeName = this.getAttributeName();
	      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466
	
	      if (styleForPesudo) {
	        styleForPesudo.innerHTML = '';
	      }
	
	      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
	        node.removeChild(this.extraNode);
	      }
	
	      _Event["default"].removeStartEventListener(node, this.onTransitionStart);
	
	      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWave)
	      );
	    }
	  }]);
	
	  return Wave;
	}(React.Component);
	
	exports["default"] = Wave;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(501));
	
	var _en_US2 = _interopRequireDefault(__webpack_require__(364));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	// Merge into a locale object
	var locale = {
	  lang: _extends({
	    placeholder: 'Select date',
	    rangePlaceholder: ['Start date', 'End date']
	  }, _en_US["default"]),
	  timePickerLocale: _extends({}, _en_US2["default"])
	}; // All settings at:
	// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
	
	var _default = locale;
	exports["default"] = _default;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcDropdown = _interopRequireDefault(__webpack_require__(465));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _type = __webpack_require__(82);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');
	
	var Dropdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  var _super = _createSuper(Dropdown);
	
	  function Dropdown() {
	    var _this;
	
	    _classCallCheck(this, Dropdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderOverlay = function (prefixCls) {
	      // rc-dropdown already can process the function of overlay, but we have check logic here.
	      // So we need render the element to check and pass back to rc-dropdown.
	      var overlay = _this.props.overlay;
	      var overlayNode;
	
	      if (typeof overlay === 'function') {
	        overlayNode = overlay();
	      } else {
	        overlayNode = overlay;
	      }
	
	      overlayNode = React.Children.only(overlayNode);
	      var overlayProps = overlayNode.props; // Warning if use other mode
	
	      (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', 'Dropdown', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
	      // menu should be focusable in dropdown defaultly
	
	      var _overlayProps$selecta = overlayProps.selectable,
	          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
	          _overlayProps$focusab = overlayProps.focusable,
	          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
	      var expandIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-submenu-arrow")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
	      }));
	      var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlay : /*#__PURE__*/React.cloneElement(overlayNode, {
	        mode: 'vertical',
	        selectable: selectable,
	        focusable: focusable,
	        expandIcon: expandIcon
	      });
	      return fixedModeOverlay;
	    };
	
	    _this.renderDropDown = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          children = _this$props.children,
	          trigger = _this$props.trigger,
	          disabled = _this$props.disabled,
	          getPopupContainer = _this$props.getPopupContainer;
	      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
	      var child = React.Children.only(children);
	      var dropdownTrigger = /*#__PURE__*/React.cloneElement(child, {
	        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
	        disabled: disabled
	      });
	      var triggerActions = disabled ? [] : trigger;
	      var alignPoint;
	
	      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
	        alignPoint = true;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcDropdown["default"], _extends({
	          alignPoint: alignPoint
	        }, _this.props, {
	          prefixCls: prefixCls,
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          transitionName: _this.getTransitionName(),
	          trigger: triggerActions,
	          overlay: function overlay() {
	            return _this.renderOverlay(prefixCls);
	          }
	        }), dropdownTrigger)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: "getTransitionName",
	    value: function getTransitionName() {
	      var _this$props2 = this.props,
	          _this$props2$placemen = _this$props2.placement,
	          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen,
	          transitionName = _this$props2.transitionName;
	
	      if (transitionName !== undefined) {
	        return transitionName;
	      }
	
	      if (placement.indexOf('top') >= 0) {
	        return 'slide-down';
	      }
	
	      return 'slide-up';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDropDown)
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(React.Component);
	
	exports["default"] = Dropdown;
	Dropdown.defaultProps = {
	  mouseEnterDelay: 0.15,
	  mouseLeaveDelay: 0.1,
	  placement: 'bottomLeft'
	};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _dropdown = _interopRequireDefault(__webpack_require__(355));
	
	var _dropdownButton = _interopRequireDefault(__webpack_require__(1202));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_dropdown["default"].Button = _dropdownButton["default"];
	var _default = _dropdown["default"];
	exports["default"] = _default;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SiderContext = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _layout = __webpack_require__(651);
	
	var _configProvider = __webpack_require__(14);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _isNumeric = _interopRequireDefault(__webpack_require__(1161));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	}
	
	var dimensionMaxMap = {
	  xs: '479.98px',
	  sm: '575.98px',
	  md: '767.98px',
	  lg: '991.98px',
	  xl: '1199.98px',
	  xxl: '1599.98px'
	};
	var SiderContext = (0, _createReactContext["default"])({});
	exports.SiderContext = SiderContext;
	
	var generateId = function () {
	  var i = 0;
	  return function () {
	    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    i += 1;
	    return "".concat(prefix).concat(i);
	  };
	}();
	
	var InternalSider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalSider, _React$Component);
	
	  var _super = _createSuper(InternalSider);
	
	  function InternalSider(props) {
	    var _this;
	
	    _classCallCheck(this, InternalSider);
	
	    _this = _super.call(this, props);
	
	    _this.responsiveHandler = function (mql) {
	      _this.setState({
	        below: mql.matches
	      });
	
	      var onBreakpoint = _this.props.onBreakpoint;
	
	      if (onBreakpoint) {
	        onBreakpoint(mql.matches);
	      }
	
	      if (_this.state.collapsed !== mql.matches) {
	        _this.setCollapsed(mql.matches, 'responsive');
	      }
	    };
	
	    _this.setCollapsed = function (collapsed, type) {
	      if (!('collapsed' in _this.props)) {
	        _this.setState({
	          collapsed: collapsed
	        });
	      }
	
	      var onCollapse = _this.props.onCollapse;
	
	      if (onCollapse) {
	        onCollapse(collapsed, type);
	      }
	    };
	
	    _this.toggle = function () {
	      var collapsed = !_this.state.collapsed;
	
	      _this.setCollapsed(collapsed, 'clickTrigger');
	    };
	
	    _this.belowShowChange = function () {
	      _this.setState(function (_ref) {
	        var belowShow = _ref.belowShow;
	        return {
	          belowShow: !belowShow
	        };
	      });
	    };
	
	    _this.renderSider = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          theme = _a.theme,
	          collapsible = _a.collapsible,
	          reverseArrow = _a.reverseArrow,
	          trigger = _a.trigger,
	          style = _a.style,
	          width = _a.width,
	          collapsedWidth = _a.collapsedWidth,
	          zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle,
	          others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth", "zeroWidthTriggerStyle"]);
	
	      var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
	      var divProps = (0, _omit["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint', 'siderHook', 'zeroWidthTriggerStyle']);
	      var rawWidth = _this.state.collapsed ? collapsedWidth : width; // use "px" as fallback unit for width
	
	      var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0
	
	      var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/React.createElement("span", {
	        onClick: _this.toggle,
	        className: "".concat(prefixCls, "-zero-width-trigger ").concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left'),
	        style: zeroWidthTriggerStyle
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "bars"
	      })) : null;
	      var iconObj = {
	        expanded: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }),
	        collapsed: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        })
	      };
	      var status = _this.state.collapsed ? 'collapsed' : 'expanded';
	      var defaultTrigger = iconObj[status];
	      var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-trigger"),
	        onClick: _this.toggle,
	        style: {
	          width: siderWidth
	        }
	      }, trigger || defaultTrigger) : null;
	
	      var divStyle = _extends(_extends({}, style), {
	        flex: "0 0 ".concat(siderWidth),
	        maxWidth: siderWidth,
	        minWidth: siderWidth,
	        width: siderWidth
	      });
	
	      var siderCls = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), !!_this.state.collapsed), _defineProperty(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty(_classNames, "".concat(prefixCls, "-below"), !!_this.state.below), _defineProperty(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames));
	      return (/*#__PURE__*/React.createElement("aside", _extends({
	          className: siderCls
	        }, divProps, {
	          style: divStyle
	        }), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-children")
	        }, _this.props.children), collapsible || _this.state.below && zeroWidthTrigger ? triggerDom : null)
	      );
	    };
	
	    _this.uniqueId = generateId('ant-sider-');
	    var matchMedia;
	
	    if (typeof window !== 'undefined') {
	      matchMedia = window.matchMedia;
	    }
	
	    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMaxMap) {
	      _this.mql = matchMedia("(max-width: ".concat(dimensionMaxMap[props.breakpoint], ")"));
	    }
	
	    var collapsed;
	
	    if ('collapsed' in props) {
	      collapsed = props.collapsed;
	    } else {
	      collapsed = props.defaultCollapsed;
	    }
	
	    _this.state = {
	      collapsed: collapsed,
	      below: false
	    };
	    return _this;
	  }
	
	  _createClass(InternalSider, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.mql) {
	        this.mql.addListener(this.responsiveHandler);
	        this.responsiveHandler(this.mql);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.addSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.mql) {
	        this.mql.removeListener(this.responsiveHandler);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.removeSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var collapsed = this.state.collapsed;
	      var collapsedWidth = this.props.collapsedWidth;
	      return (/*#__PURE__*/React.createElement(SiderContext.Provider, {
	          value: {
	            siderCollapsed: collapsed,
	            collapsedWidth: collapsedWidth
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSider))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('collapsed' in nextProps) {
	        return {
	          collapsed: nextProps.collapsed
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return InternalSider;
	}(React.Component);
	
	InternalSider.defaultProps = {
	  collapsible: false,
	  defaultCollapsed: false,
	  reverseArrow: false,
	  width: 200,
	  collapsedWidth: 80,
	  style: {},
	  theme: 'dark'
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalSider); // eslint-disable-next-line react/prefer-stateless-function
	
	var Sider = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Sider, _React$Component2);
	
	  var _super2 = _createSuper(Sider);
	
	  function Sider() {
	    _classCallCheck(this, Sider);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Sider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_layout.LayoutContext.Consumer, null, function (context) {
	          return (/*#__PURE__*/React.createElement(InternalSider, _extends({}, context, _this2.props))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Sider;
	}(React.Component);
	
	exports["default"] = Sider;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var MenuContext = (0, _createReactContext["default"])({
	  inlineCollapsed: false
	});
	var _default = MenuContext;
	exports["default"] = _default;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(93));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(1224));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(1223));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _Sider = __webpack_require__(357);
	
	var _raf = _interopRequireDefault(__webpack_require__(200));
	
	var _motion = _interopRequireDefault(__webpack_require__(630));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(358));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var InternalMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalMenu, _React$Component);
	
	  var _super = _createSuper(InternalMenu);
	
	  function InternalMenu(props) {
	    var _this;
	
	    _classCallCheck(this, InternalMenu);
	
	    _this = _super.call(this, props); // Restore vertical mode when menu is collapsed responsively when mounted
	    // https://github.com/ant-design/ant-design/issues/13104
	    // TODO: not a perfect solution, looking a new way to avoid setting switchingModeFromInline in this situation
	
	    _this.handleMouseEnter = function (e) {
	      _this.restoreModeVerticalFromInline();
	
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(e);
	      }
	    };
	
	    _this.handleTransitionEnd = function (e) {
	      // when inlineCollapsed menu width animation finished
	      // https://github.com/ant-design/ant-design/issues/12864
	      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function
	      // https://github.com/ant-design/ant-design/issues/15699
	
	      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during an animation.
	
	      var classNameValue = Object.prototype.toString.call(className) === '[object SVGAnimatedString]' ? className.animVal : className; // Fix for <Menu style={{ width: '100%' }} />, the width transition won't trigger when menu is collapsed
	      // https://github.com/ant-design/ant-design-pro/issues/2783
	
	      var iconScaled = e.propertyName === 'font-size' && classNameValue.indexOf('anticon') >= 0;
	
	      if (widthCollapsed || iconScaled) {
	        _this.restoreModeVerticalFromInline();
	      }
	    };
	
	    _this.handleClick = function (e) {
	      _this.handleOpenChange([]);
	
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.handleOpenChange = function (openKeys) {
	      _this.setOpenKeys(openKeys);
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(openKeys);
	      }
	    };
	
	    _this.renderMenu = function (_ref) {
	      var getPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          theme = _this$props.theme,
	          collapsedWidth = _this$props.collapsedWidth;
	      var passProps = (0, _omit["default"])(_this.props, ['collapsedWidth', 'siderCollapsed']);
	
	      var menuMode = _this.getRealMenuMode();
	
	      var menuOpenMotion = _this.getOpenMotionProps(menuMode);
	
	      var prefixCls = getPrefixCls('menu', customizePrefixCls);
	      var menuClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()));
	
	      var menuProps = _extends({
	        openKeys: _this.state.openKeys,
	        onOpenChange: _this.handleOpenChange,
	        className: menuClassName,
	        mode: menuMode
	      }, menuOpenMotion);
	
	      if (menuMode !== 'inline') {
	        // closing vertical popup submenu after click it
	        menuProps.onClick = _this.handleClick;
	      } // https://github.com/ant-design/ant-design/issues/8587
	
	
	      var hideMenu = _this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px');
	
	      if (hideMenu) {
	        menuProps.openKeys = [];
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcMenu["default"], _extends({
	          getPopupContainer: getPopupContainer
	        }, passProps, menuProps, {
	          prefixCls: prefixCls,
	          onTransitionEnd: _this.handleTransitionEnd,
	          onMouseEnter: _this.handleMouseEnter
	        }))
	      );
	    };
	
	    (0, _warning["default"])(!('onOpen' in props || 'onClose' in props), 'Menu', '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
	    (0, _warning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
	    (0, _warning["default"])(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
	    var openKeys;
	
	    if ('openKeys' in props) {
	      openKeys = props.openKeys;
	    } else if ('defaultOpenKeys' in props) {
	      openKeys = props.defaultOpenKeys;
	    }
	
	    _this.state = {
	      openKeys: openKeys || [],
	      switchingModeFromInline: false,
	      inlineOpenKeys: [],
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(InternalMenu, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountRafId);
	    }
	  }, {
	    key: "setOpenKeys",
	    value: function setOpenKeys(openKeys) {
	      if (!('openKeys' in this.props)) {
	        this.setState({
	          openKeys: openKeys
	        });
	      }
	    }
	  }, {
	    key: "getRealMenuMode",
	    value: function getRealMenuMode() {
	      var inlineCollapsed = this.getInlineCollapsed();
	
	      if (this.state.switchingModeFromInline && inlineCollapsed) {
	        return 'inline';
	      }
	
	      var mode = this.props.mode;
	      return inlineCollapsed ? 'vertical' : mode;
	    }
	  }, {
	    key: "getInlineCollapsed",
	    value: function getInlineCollapsed() {
	      var inlineCollapsed = this.props.inlineCollapsed;
	
	      if (this.props.siderCollapsed !== undefined) {
	        return this.props.siderCollapsed;
	      }
	
	      return inlineCollapsed;
	    }
	  }, {
	    key: "getOpenMotionProps",
	    value: function getOpenMotionProps(menuMode) {
	      var _this$props2 = this.props,
	          openTransitionName = _this$props2.openTransitionName,
	          openAnimation = _this$props2.openAnimation,
	          motion = _this$props2.motion; // Provides by user
	
	      if (motion) {
	        return {
	          motion: motion
	        };
	      }
	
	      if (openAnimation) {
	        (0, _warning["default"])(typeof openAnimation === 'string', 'Menu', '`openAnimation` do not support object. Please use `motion` instead.');
	        return {
	          openAnimation: openAnimation
	        };
	      }
	
	      if (openTransitionName) {
	        return {
	          openTransitionName: openTransitionName
	        };
	      } // Default logic
	
	
	      if (menuMode === 'horizontal') {
	        return {
	          motion: {
	            motionName: 'slide-up'
	          }
	        };
	      }
	
	      if (menuMode === 'inline') {
	        return {
	          motion: _motion["default"]
	        };
	      } // When mode switch from inline
	      // submenu should hide without animation
	
	
	      return {
	        motion: {
	          motionName: this.state.switchingModeFromInline ? '' : 'zoom-big'
	        }
	      };
	    }
	  }, {
	    key: "restoreModeVerticalFromInline",
	    value: function restoreModeVerticalFromInline() {
	      var switchingModeFromInline = this.state.switchingModeFromInline;
	
	      if (switchingModeFromInline) {
	        this.setState({
	          switchingModeFromInline: false
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Provider, {
	          value: {
	            inlineCollapsed: this.getInlineCollapsed() || false,
	            antdMenuTheme: this.props.theme
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if (prevProps.mode === 'inline' && nextProps.mode !== 'inline') {
	        newState.switchingModeFromInline = true;
	      }
	
	      if ('openKeys' in nextProps) {
	        newState.openKeys = nextProps.openKeys;
	      } else {
	        // [Legacy] Old code will return after `openKeys` changed.
	        // Not sure the reason, we should keep this logic still.
	        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
	          newState.switchingModeFromInline = true;
	          newState.inlineOpenKeys = prevState.openKeys;
	          newState.openKeys = [];
	        }
	
	        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
	          newState.openKeys = prevState.inlineOpenKeys;
	          newState.inlineOpenKeys = [];
	        }
	      }
	
	      return newState;
	    }
	  }]);
	
	  return InternalMenu;
	}(React.Component);
	
	InternalMenu.defaultProps = {
	  className: '',
	  theme: 'light',
	  focusable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalMenu); // We should keep this as ref-able
	
	var Menu = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Menu, _React$Component2);
	
	  var _super2 = _createSuper(Menu);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Menu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, function (context) {
	          return (/*#__PURE__*/React.createElement(InternalMenu, _extends({}, _this2.props, context))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Menu;
	}(React.Component);
	
	exports["default"] = Menu;
	Menu.Divider = _rcMenu.Divider;
	Menu.Item = _MenuItem["default"];
	Menu.SubMenu = _SubMenu["default"];
	Menu.ItemGroup = _rcMenu.ItemGroup;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeConfirmLocale = changeConfirmLocale;
	exports.getConfirmLocale = getConfirmLocale;
	
	var _default = _interopRequireDefault(__webpack_require__(157));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var runtimeLocale = _extends({}, _default["default"].Modal);
	
	function changeConfirmLocale(newLocale) {
	  if (newLocale) {
	    runtimeLocale = _extends(_extends({}, runtimeLocale), newLocale);
	  } else {
	    runtimeLocale = _extends({}, _default["default"].Modal);
	  }
	}
	
	function getConfirmLocale() {
	  return runtimeLocale;
	}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Pagination = _interopRequireDefault(__webpack_require__(1232));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Pagination["default"];
	exports["default"] = _default;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validProgress = validProgress;
	
	// eslint-disable-next-line import/prefer-default-export
	function validProgress(progress) {
	  if (!progress || progress < 0) {
	    return 0;
	  }
	
	  if (progress > 100) {
	    return 100;
	  }
	
	  return progress;
	}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(187));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Radio = /*#__PURE__*/function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  var _super = _createSuper(Radio);
	
	  function Radio() {
	    var _this;
	
	    _classCallCheck(this, Radio);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.onChange = function (e) {
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	
	      if (_this.context.radioGroup && _this.context.radioGroup.onChange) {
	        _this.context.radioGroup.onChange(e);
	      }
	    };
	
	    _this.renderRadio = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          style = props.style,
	          restProps = __rest(props, ["prefixCls", "className", "children", "style"]);
	
	      var radioGroup = context.radioGroup;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	
	      var radioProps = _extends({}, restProps);
	
	      if (radioGroup) {
	        radioProps.name = radioGroup.name;
	        radioProps.onChange = _this.onChange;
	        radioProps.checked = props.value === radioGroup.value;
	        radioProps.disabled = props.disabled || radioGroup.disabled;
	      }
	
	      var wrapperClassString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _classNames));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: wrapperClassString,
	          style: style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, radioProps, {
	          prefixCls: prefixCls,
	          ref: _this.saveCheckbox
	        })), children !== undefined ? /*#__PURE__*/React.createElement("span", null, children) : null)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Radio, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.radioGroup, nextContext.radioGroup);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadio)
	      );
	    }
	  }]);
	
	  return Radio;
	}(React.Component);
	
	exports["default"] = Radio;
	Radio.defaultProps = {
	  type: 'radio'
	};
	Radio.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var locale = {
	  placeholder: 'Select time'
	};
	var _default = locale;
	exports["default"] = _default;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _findDOMNode = _interopRequireDefault(__webpack_require__(493));
	
	var _copyToClipboard = _interopRequireDefault(__webpack_require__(508));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _configProvider = __webpack_require__(14);
	
	var _context = __webpack_require__(242);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _transButton = _interopRequireDefault(__webpack_require__(352));
	
	var _raf = _interopRequireDefault(__webpack_require__(200));
	
	var _styleChecker = _interopRequireDefault(__webpack_require__(633));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(124));
	
	var _Typography = _interopRequireDefault(__webpack_require__(663));
	
	var _Editable = _interopRequireDefault(__webpack_require__(1281));
	
	var _util = _interopRequireDefault(__webpack_require__(1286));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var isLineClampSupport = (0, _styleChecker["default"])('webkitLineClamp');
	var isTextOverflowSupport = (0, _styleChecker["default"])('textOverflow');
	
	function wrapperDecorations(_ref, content) {
	  var mark = _ref.mark,
	      code = _ref.code,
	      underline = _ref.underline,
	      del = _ref["delete"],
	      strong = _ref.strong;
	  var currentContent = content;
	
	  function wrap(needed, tag) {
	    if (!needed) return;
	    currentContent = /*#__PURE__*/React.createElement(tag, {}, currentContent);
	  }
	
	  wrap(strong, 'strong');
	  wrap(underline, 'u');
	  wrap(del, 'del');
	  wrap(code, 'code');
	  wrap(mark, 'mark');
	  return currentContent;
	}
	
	var ELLIPSIS_STR = '...';
	
	var Base = /*#__PURE__*/function (_React$Component) {
	  _inherits(Base, _React$Component);
	
	  var _super = _createSuper(Base);
	
	  function Base() {
	    var _this;
	
	    _classCallCheck(this, Base);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      edit: false,
	      copied: false,
	      ellipsisText: '',
	      ellipsisContent: null,
	      isEllipsis: false,
	      expanded: false,
	      clientRendered: false
	    }; // =============== Expend ===============
	
	    _this.onExpandClick = function () {
	      var _this$getEllipsis = _this.getEllipsis(),
	          onExpand = _this$getEllipsis.onExpand;
	
	      _this.setState({
	        expanded: true
	      });
	
	      if (onExpand) {
	        onExpand();
	      }
	    }; // ================ Edit ================
	
	
	    _this.onEditClick = function () {
	      _this.triggerEdit(true);
	    };
	
	    _this.onEditChange = function (value) {
	      var _this$getEditable = _this.getEditable(),
	          onChange = _this$getEditable.onChange;
	
	      if (onChange) {
	        onChange(value);
	      }
	
	      _this.triggerEdit(false);
	    };
	
	    _this.onEditCancel = function () {
	      _this.triggerEdit(false);
	    }; // ================ Copy ================
	
	
	    _this.onCopyClick = function () {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          copyable = _this$props.copyable;
	
	      var copyConfig = _extends({}, _typeof(copyable) === 'object' ? copyable : null);
	
	      if (copyConfig.text === undefined) {
	        copyConfig.text = String(children);
	      }
	
	      (0, _copyToClipboard["default"])(copyConfig.text || '');
	
	      _this.setState({
	        copied: true
	      }, function () {
	        if (copyConfig.onCopy) {
	          copyConfig.onCopy();
	        }
	
	        _this.copyId = window.setTimeout(function () {
	          _this.setState({
	            copied: false
	          });
	        }, 3000);
	      });
	    };
	
	    _this.setContentRef = function (node) {
	      _this.content = node;
	    };
	
	    _this.setEditRef = function (node) {
	      _this.editIcon = node;
	    };
	
	    _this.triggerEdit = function (edit) {
	      var _this$getEditable2 = _this.getEditable(),
	          onStart = _this$getEditable2.onStart;
	
	      if (edit && onStart) {
	        onStart();
	      }
	
	      _this.setState({
	        edit: edit
	      }, function () {
	        if (!edit && _this.editIcon) {
	          _this.editIcon.focus();
	        }
	      });
	    }; // ============== Ellipsis ==============
	
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.rafId);
	
	      _this.rafId = (0, _raf["default"])(function () {
	        // Do not bind `syncEllipsis`. It need for test usage on prototype
	        _this.syncEllipsis();
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Base, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        clientRendered: true
	      });
	      this.resizeOnNextFrame();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var children = this.props.children;
	      var ellipsis = this.getEllipsis();
	      var prevEllipsis = this.getEllipsis(prevProps);
	
	      if (children !== prevProps.children || ellipsis.rows !== prevEllipsis.rows) {
	        this.resizeOnNextFrame();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.copyId);
	
	      _raf["default"].cancel(this.rafId);
	    }
	  }, {
	    key: "getEditable",
	    value: function getEditable(props) {
	      var edit = this.state.edit;
	
	      var _ref2 = props || this.props,
	          editable = _ref2.editable;
	
	      if (!editable) return {
	        editing: edit
	      };
	      return _extends({
	        editing: edit
	      }, _typeof(editable) === 'object' ? editable : null);
	    }
	  }, {
	    key: "getEllipsis",
	    value: function getEllipsis(props) {
	      var _ref3 = props || this.props,
	          ellipsis = _ref3.ellipsis;
	
	      if (!ellipsis) return {};
	      return _extends({
	        rows: 1,
	        expandable: false
	      }, _typeof(ellipsis) === 'object' ? ellipsis : null);
	    }
	  }, {
	    key: "canUseCSSEllipsis",
	    value: function canUseCSSEllipsis() {
	      var clientRendered = this.state.clientRendered;
	      var _this$props2 = this.props,
	          editable = _this$props2.editable,
	          copyable = _this$props2.copyable;
	
	      var _this$getEllipsis2 = this.getEllipsis(),
	          rows = _this$getEllipsis2.rows,
	          expandable = _this$getEllipsis2.expandable; // Can't use css ellipsis since we need to provide the place for button
	
	
	      if (editable || copyable || expandable || !clientRendered) {
	        return false;
	      }
	
	      if (rows === 1) {
	        return isTextOverflowSupport;
	      }
	
	      return isLineClampSupport;
	    }
	  }, {
	    key: "syncEllipsis",
	    value: function syncEllipsis() {
	      var _this$state = this.state,
	          ellipsisText = _this$state.ellipsisText,
	          isEllipsis = _this$state.isEllipsis,
	          expanded = _this$state.expanded;
	
	      var _this$getEllipsis3 = this.getEllipsis(),
	          rows = _this$getEllipsis3.rows;
	
	      var children = this.props.children;
	      if (!rows || rows < 0 || !this.content || expanded) return; // Do not measure if css already support ellipsis
	
	      if (this.canUseCSSEllipsis()) return;
	      (0, _warning["default"])((0, _toArray["default"])(children).every(function (child) {
	        return typeof child === 'string';
	      }), 'Typography', '`ellipsis` should use string as children only.');
	
	      var _measure = (0, _util["default"])((0, _findDOMNode["default"])(this.content), rows, children, this.renderOperations(true), ELLIPSIS_STR),
	          content = _measure.content,
	          text = _measure.text,
	          ellipsis = _measure.ellipsis;
	
	      if (ellipsisText !== text || isEllipsis !== ellipsis) {
	        this.setState({
	          ellipsisText: text,
	          ellipsisContent: content,
	          isEllipsis: ellipsis
	        });
	      }
	    }
	  }, {
	    key: "renderExpand",
	    value: function renderExpand(forceRender) {
	      var _this$getEllipsis4 = this.getEllipsis(),
	          expandable = _this$getEllipsis4.expandable;
	
	      var prefixCls = this.props.prefixCls;
	      var _this$state2 = this.state,
	          expanded = _this$state2.expanded,
	          isEllipsis = _this$state2.isEllipsis;
	      if (!expandable) return null; // force render expand icon for measure usage or it will cause dead loop
	
	      if (!forceRender && (expanded || !isEllipsis)) return null;
	      return (/*#__PURE__*/React.createElement("a", {
	          key: "expand",
	          className: "".concat(prefixCls, "-expand"),
	          onClick: this.onExpandClick,
	          "aria-label": this.expandStr
	        }, this.expandStr)
	      );
	    }
	  }, {
	    key: "renderEdit",
	    value: function renderEdit() {
	      var _this$props3 = this.props,
	          editable = _this$props3.editable,
	          prefixCls = _this$props3.prefixCls;
	      if (!editable) return;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          key: "edit",
	          title: this.editStr
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          ref: this.setEditRef,
	          className: "".concat(prefixCls, "-edit"),
	          onClick: this.onEditClick,
	          "aria-label": this.editStr
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          role: "button",
	          type: "edit"
	        })))
	      );
	    }
	  }, {
	    key: "renderCopy",
	    value: function renderCopy() {
	      var copied = this.state.copied;
	      var _this$props4 = this.props,
	          copyable = _this$props4.copyable,
	          prefixCls = _this$props4.prefixCls;
	      if (!copyable) return;
	      var title = copied ? this.copiedStr : this.copyStr;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          key: "copy",
	          title: title
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-copy"), copied && "".concat(prefixCls, "-copy-success")),
	          onClick: this.onCopyClick,
	          "aria-label": title
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          role: "button",
	          type: copied ? 'check' : 'copy'
	        })))
	      );
	    }
	  }, {
	    key: "renderEditInput",
	    value: function renderEditInput() {
	      var _this$props5 = this.props,
	          children = _this$props5.children,
	          prefixCls = _this$props5.prefixCls,
	          className = _this$props5.className,
	          style = _this$props5.style;
	      return (/*#__PURE__*/React.createElement(_Editable["default"], {
	          value: typeof children === 'string' ? children : '',
	          onSave: this.onEditChange,
	          onCancel: this.onEditCancel,
	          prefixCls: prefixCls,
	          className: className,
	          style: style
	        })
	      );
	    }
	  }, {
	    key: "renderOperations",
	    value: function renderOperations(forceRenderExpanded) {
	      return [this.renderExpand(forceRenderExpanded), this.renderEdit(), this.renderCopy()].filter(function (node) {
	        return node;
	      });
	    }
	  }, {
	    key: "renderContent",
	    value: function renderContent() {
	      var _this2 = this;
	
	      var _this$state3 = this.state,
	          ellipsisContent = _this$state3.ellipsisContent,
	          isEllipsis = _this$state3.isEllipsis,
	          expanded = _this$state3.expanded;
	
	      var _a = this.props,
	          component = _a.component,
	          children = _a.children,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          style = _a.style,
	          restProps = __rest(_a, ["component", "children", "className", "prefixCls", "type", "disabled", "style"]);
	
	      var _this$getEllipsis5 = this.getEllipsis(),
	          rows = _this$getEllipsis5.rows;
	
	      var textProps = (0, _omit["default"])(restProps, ['prefixCls', 'editable', 'copyable', 'ellipsis', 'mark', 'underline', 'mark', 'code', 'delete', 'underline', 'strong'].concat(_toConsumableArray(_configProvider.configConsumerProps)));
	      var cssEllipsis = this.canUseCSSEllipsis();
	      var cssTextOverflow = rows === 1 && cssEllipsis;
	      var cssLineClamp = rows && rows > 1 && cssEllipsis;
	      var textNode = children;
	      var ariaLabel = null; // Only use js ellipsis when css ellipsis not support
	
	      if (rows && isEllipsis && !expanded && !cssEllipsis) {
	        ariaLabel = String(children); // We move full content to outer element to avoid repeat read the content by accessibility
	
	        textNode = /*#__PURE__*/React.createElement("span", {
	          title: String(children),
	          "aria-hidden": "true"
	        }, ellipsisContent, ELLIPSIS_STR);
	      }
	
	      textNode = wrapperDecorations(this.props, textNode);
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Text"
	        }, function (_ref4) {
	          var _classNames;
	
	          var edit = _ref4.edit,
	              copyStr = _ref4.copy,
	              copied = _ref4.copied,
	              expand = _ref4.expand;
	          _this2.editStr = edit;
	          _this2.copyStr = copyStr;
	          _this2.copiedStr = copied;
	          _this2.expandStr = expand;
	          return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	              onResize: _this2.resizeOnNextFrame,
	              disabled: !rows
	            }, /*#__PURE__*/React.createElement(_Typography["default"], _extends({
	              className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis"), rows), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis-single-line"), cssTextOverflow), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis-multiple-line"), cssLineClamp), _classNames)),
	              style: _extends(_extends({}, style), {
	                WebkitLineClamp: cssLineClamp ? rows : null
	              }),
	              component: component,
	              ref: _this2.setContentRef,
	              "aria-label": ariaLabel
	            }, textProps), textNode, _this2.renderOperations()))
	          );
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$getEditable3 = this.getEditable(),
	          editing = _this$getEditable3.editing;
	
	      if (editing) {
	        return this.renderEditInput();
	      }
	
	      return this.renderContent();
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var children = nextProps.children,
	          editable = nextProps.editable;
	      (0, _warning["default"])(!editable || typeof children === 'string', 'Typography', 'When `editable` is enabled, the `children` should use string.');
	      return {};
	    }
	  }]);
	
	  return Base;
	}(React.Component);
	
	Base.defaultProps = {
	  children: ''
	};
	(0, _reactLifecyclesCompat.polyfill)(Base);
	
	var _default = (0, _context.withConfigConsumer)({
	  prefixCls: 'typography'
	})(Base);
	
	exports["default"] = _default;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}return target;
	};
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
		var target = {};for (var i in obj) {
			if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
		}return target;
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var ComboBox = function (_Component) {
		_inherits(ComboBox, _Component);
	
		function ComboBox(props) {
			_classCallCheck(this, ComboBox);
	
			var _this = _possibleConstructorReturn(this, (ComboBox.__proto__ || Object.getPrototypeOf(ComboBox)).call(this, props));
	
			_this.state = {
				show: false,
				position: {
					x: 0,
					y: 0
				}
			};
			return _this;
		}
	
		_createClass(ComboBox, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				window.addEventListener("click", this.close.bind(this));
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				window.removeEventListener("click", this.close.bind(this));
			}
		}, {
			key: "open",
			value: function open(position) {
				this.setState({
					show: true,
					position: position
				});
			}
		}, {
			key: "close",
			value: function close() {
				if (!this.state.show) return;
				this.setState({
					show: false
				});
			}
		}, {
			key: "toggle",
			value: function toggle(position) {
				this.setState({
					show: !this.state.show,
					position: position
				});
			}
		}, {
			key: "render",
			value: function render() {
				var _props = this.props,
				    className = _props.className,
				    style = _props.style,
				    others = _objectWithoutProperties(_props, ["className", "style"]);
	
				style = style || {};
				if (!this.state.show) {
					style["display"] = "none";
				} else {
					style["display"] = "";
				}
				if (this.state.position) {
					style["left"] = this.state.position.x;
					style["top"] = this.state.position.y;
				}
	
				return _react2.default.createElement("div", _extends({
					style: style,
					className: "combobox" + (className ? " " + className : "")
				}, others), this.props.children);
			}
		}]);
	
		return ComboBox;
	}(_react.Component);
	
	module.exports = ComboBox;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var React = __webpack_require__(1);
	
	/**
	 * @width: 对话框宽度
	 * @height: 对话框高度
	 * @style: 样式
	 * @buttons: 对话框按钮组
	 * @title: 对话框标题
	 * @className: 对话框类名
	 **/
	
	var Dialog = function (_React$Component) {
	  _inherits(Dialog, _React$Component);
	
	  function Dialog(props) {
	    _classCallCheck(this, Dialog);
	
	    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));
	
	    _this.state = {
	      show: false
	    };
	    return _this;
	  }
	
	  _createClass(Dialog, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      window.addEventListener("click", this.close.bind(this));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("click", this.close.bind(this));
	    }
	  }, {
	    key: "open",
	    value: function open() {
	      this.setState({
	        show: true
	      });
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      if (!this.state.show) return;
	      this.setState({
	        show: false
	      });
	    }
	  }, {
	    key: "toggle",
	    value: function toggle() {
	      this.setState({
	        show: !this.state.show
	      });
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(e) {
	      e = e || event;
	      if (e.stopPropagation) {
	        e.stopPropagation();
	      } else {
	        e.cancelBubble = true;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          buttons = _props.buttons,
	          title = _props.title,
	          style = _props.style,
	          width = _props.width,
	          height = _props.height,
	          onClose = _props.onClose,
	          children = _props.children;
	
	      style = style ? style : {};
	      if (width) {
	        style.width = width;
	        style.marginLeft = -width / 2;
	      }
	      if (height) {
	        style.height = height;
	      }
	      style.display = this.state.show ? "" : "none";
	      var _className = "dialog" + (className ? " " + className : "");
	      return React.createElement("div", { className: "dialog-container", ref: "root", onMouseDown: this.handleMouseDown.bind(this) }, React.createElement("div", { className: _className, ref: "dialog", style: style }, React.createElement("div", { className: "dialog-header", ref: "header" }, React.createElement("a", { className: "dialog-close", onClick: onClose }), React.createElement("h3", { className: "dialog-title" }, title)), React.createElement("div", { className: "dialog-body", ref: "body" }, children), React.createElement("div", { className: "dialog-footer", ref: "footer" }, buttons.map(function (ele, pos) {
	        return React.createElement("a", { className: "dialog-button",
	          key: pos,
	          "data-name": ele.name,
	          onClick: ele.onClick }, ele.content);
	      }))), React.createElement("div", { className: "dialog-backdrop", ref: "backdrop", style: { "display": this.state.show ? "" : "none" } }));
	    }
	  }]);
	
	  return Dialog;
	}(React.Component);
	
	module.exports = Dialog;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}return target;
	};
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	function _objectWithoutProperties(obj, keys) {
		var target = {};for (var i in obj) {
			if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
		}return target;
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var React = __webpack_require__(1);
	
	var Dropdown = function (_React$Component) {
		_inherits(Dropdown, _React$Component);
	
		function Dropdown(props) {
			_classCallCheck(this, Dropdown);
	
			var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));
	
			_this.state = {
				show: false,
				position: {
					x: 0,
					y: 0
				}
			};
			return _this;
		}
	
		_createClass(Dropdown, [{
			key: "componentDidMount",
			value: function componentDidMount() {
				window.addEventListener("click", this.close.bind(this));
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				window.removeEventListener("click", this.close.bind(this));
			}
		}, {
			key: "open",
			value: function open(position) {
				this.setState({
					show: true,
					position: position
				});
			}
		}, {
			key: "close",
			value: function close() {
				if (!this.state.show) return;
				this.setState({
					show: false
				});
			}
		}, {
			key: "toggle",
			value: function toggle(position) {
				this.setState({
					show: !this.state.show,
					position: position
				});
			}
		}, {
			key: "render",
			value: function render() {
				var _props = this.props,
				    className = _props.className,
				    style = _props.style,
				    props = _objectWithoutProperties(_props, ["className", "style"]);
	
				style = style || {};
				if (!this.state.show) {
					style["display"] = "none";
				} else {
					style["display"] = "";
				}
				if (this.state.position) {
					style["left"] = this.state.position.x;
					style["top"] = this.state.position.y;
				}
				return React.createElement("div", _extends({ style: style, className: "dropdown" + (className ? " " + className : "") }, props), React.createElement("div", { className: "dropdown-caret" }), this.props.children);
			}
		}]);
	
		return Dropdown;
	}(React.Component);
	
	module.exports = Dropdown;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _EditorDom = __webpack_require__(160);
	
	var _EditorDom2 = _interopRequireDefault(_EditorDom);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	NodeList.prototype.toArray = function () {
		var nodes = [];
		for (var i = 0; i < this.length; i++) {
			nodes.push(this[i]);
		}
		return nodes;
	};
	
	var EditorSelection = {
		range: null,
		selection: null,
		storedRange: false,
		customIcons: [],
		getSelection: function getSelection() {
			if (window.getSelection) return window.getSelection();else if (document.getSelection) return document.getSelection();else if (document.selection) return document.selection.createRange();else return null;
		},
		cloneRange: function cloneRange() {
			// cloneRange
			if (this.storedRange) return;
			this.selection = this.getSelection();
			this.selection.removeAllRanges();
			if (this.selection && this.range) {
				this.selection.addRange(this.range.cloneRange());
				this.range = this.range.cloneRange();
			}
		},
		getTextNodes: function getTextNodes() {
			if (!this.range) return [];
			if (this.range.collapsed) return [];
			var parent = this.range.commonAncestorContainer;
			var startNode = this.range.startContainer;
			var startOffset = this.range.startOffset;
			var endNode = this.range.endContainer;
			var endOffset = this.range.endOffset;
			var textNodes = [];
	
			if (startNode === endNode && _EditorDom2.default.isTextNode(startNode)) {
				textNodes.push({
					childNode: startNode,
					startOffset: startOffset,
					endOffset: endOffset
				});
			} else {
				var childNodes = parent.childNodes.toArray(),
				    startFlag = false;
				var childNode = childNodes.shift();
				while (childNode) {
					if (_EditorDom2.default.isTextNode(childNode)) {
						if (childNode === startNode) {
							textNodes.push({
								childNode: childNode,
								startOffset: startOffset,
								endOffset: childNode.length
							});
							startFlag = true;
						} else if (childNode === endNode) {
							textNodes.push({
								childNode: childNode,
								startOffset: 0,
								endOffset: endOffset
							});
						} else if (textNodes.length > 0) {
							textNodes.push({
								childNode: childNode,
								startOffset: 0,
								endOffset: childNode.length
							});
						}
					}
					if (childNode == endNode) {
						break;
					}
					var newChildNodes = childNode.childNodes.toArray();
	
					childNodes = newChildNodes.concat(childNodes);
					childNode = childNodes.shift();
				}
			}
			return textNodes;
		},
		getSpanNodes: function getSpanNodes() {
			if (!this.range) return [];
			if (this.range.collapsed) return [];
			var parent = this.range.commonAncestorContainer;
			if (parent.nodeType == 3) parent = parent.parentNode;
			var startNode = this.range.startContainer;
			var endNode = this.range.endContainer;
			var spanNodes = [];
	
			if (_EditorDom2.default.isSpanNode(parent)) {
				spanNodes.push(parent);
			}
			if (startNode === endNode && _EditorDom2.default.isSpanNode(startNode)) {
				spanNodes.push(startNode);
			} else {
				var childNodes = parent.childNodes.toArray(),
				    i = 0,
				    startFlag = false;
				var childNode = childNodes.shift();
				while (childNode) {
					if (childNode === startNode) {
						startFlag = true;
						if (_EditorDom2.default.isSpanNode(childNode.parentNode)) {
							spanNodes.push(childNode.parentNode);
						}
					}
					if (_EditorDom2.default.isSpanNode(childNode) && startFlag) {
						spanNodes.push(childNode);
					}
					if (childNode == endNode) {
						break;
					}
					var newChildNodes = childNode.childNodes.toArray();
	
					childNodes = newChildNodes.concat(childNodes);
					childNode = childNodes.shift();
				}
			}
	
			var resultNodes = [];
			for (var i = 0; i < spanNodes.length; i++) {
				if (resultNodes.indexOf(spanNodes[i]) == -1) {
					resultNodes.push(spanNodes[i]);
				}
			}
	
			return resultNodes;
		},
		getParagraphs: function getParagraphs() {
			var textNodes = this.getTextNodes();
			var parents = [];
			for (var i = 0; i < textNodes.length; i++) {
				var currentNode = null;
				var tagName = textNodes[i].childNode.parentNode.tagName || textNodes[i].childNode.parentNode.nodeName;
				switch (tagName.toUpperCase()) {
					case "FONT":
						currentNode = textNodes[i].childNode.parentNode;
						break;
					default:
						currentNode = textNodes[i].childNode;
						break;
				}
	
				if (parents.indexOf(currentNode.parentNode) == -1) parents.push(currentNode.parentNode);
			}
			return parents;
		},
		getCommonAncestor: function getCommonAncestor() {
			if (this.range.collapsed) return null;
			var parent = this.range.commonAncestorContainer;
			return parent;
		},
		addRange: function addRange(startContainer, startOffset, endContainer, endOffset) {
			// addRange
			this.selection = this.getSelection();
			this.selection.removeAllRanges();
			if (this.selection && this.range && startContainer instanceof Node && endContainer instanceof Node) {
				this.range.setStart(startContainer, startOffset);
				this.range.setEnd(endContainer, endOffset);
				this.selection.addRange(this.range.cloneRange());
				this.range = this.range.cloneRange();
			}
		},
		validateSelection: function validateSelection(selection) {
			var selection = selection || this.selection;
			var anchorNode = selection.anchorNode;
			if (!anchorNode) return false;
			var parentNode = anchorNode.parentNode;
			if (!parentNode) return false;
			if (anchorNode.offsetParent && anchorNode.offsetParent.className == "editor-toolbar") return false;
			if (parentNode.offsetParent && parentNode.offsetParent.className == "editor-toolbar") return false;
			return parentNode;
		},
		validateRange: function validateRange(parentNode, range) {
			var rangeParentNode = range.startContainer.parentNode;
			if (rangeParentNode == parentNode) {
				return true;
			} else {
				var findClass = 'find-range-node-' + Math.random().toFixed(10).replace('.', '-');
				rangeParentNode.classList.add(findClass);
				var item = parentNode.querySelector('.' + findClass);
				rangeParentNode.classList.remove(findClass);
				return !!item;
			}
		},
		createRange: function createRange() {
			if (this.storedRange) return;
			this.selection = this.getSelection();
			if (!this.validateSelection()) return;
			if (this.selection && this.selection.rangeCount > 0) {
				this.range = this.selection.getRangeAt(0).cloneRange();
			} else {
				this.range = null;
			}
		},
		clearRange: function clearRange() {
			if (this.storedRange) return;
			this.selection = this.getSelection();
			this.selection.removeAllRanges();
		},
		getRangeState: function getRangeState() {
			var _this = this;
	
			var rangeState = {};
			// init icons state
			var canActiveIcons = "bold italic underline strikethrough fontborder superscript subscript justifycenter justifyleft justifyright";
			var icons = canActiveIcons.split(" ");
			for (var i = 0; i < icons.length; i++) {
				rangeState[icons[i]] = { icon: icons[i], active: false };
			}
			// change  icons state
			if (this.range) {
				// IE 没有parentElement 固修改成parentNode
	
				this.customIcons.forEach(function (cIcon) {
					if (cIcon && cIcon.mapRangeState) {
						rangeState = cIcon.mapRangeState(rangeState, _this);
					}
				});
	
				var parentElement = this.range.startContainer.parentNode;
				while ((parentElement.tagName || parentElement.nodeName).toUpperCase() != "DIV") {
					var tagName = parentElement.tagName || parentElement.nodeName;
					switch (tagName.toUpperCase()) {
						case "I":
							rangeState["italic"] = { active: true, icon: "italic" };
							break;
						case "B":
							rangeState["bold"] = { active: true, icon: "bold" };
							break;
						case "U":
							rangeState["underline"] = { active: true, icon: "underline" };
							break;
						case "STRIKE":
							rangeState["strikethrough"] = { active: true, icon: "strikethrough" };
							break;
						case "SUP":
							rangeState["superscript"] = { active: true, icon: "superscript" };
							break;
						case "SUB":
							rangeState["subscript"] = { active: true, icon: "subscript" };
							break;
						case "FONT":
							rangeState["forecolor"] = { color: parentElement.color, icon: "forecolor" };
							rangeState["backcolor"] = { color: parentElement.style.backgroundColor, icon: "backcolor" };
							rangeState["fontsize"] = { value: parentElement.size, icon: "fontsize" };
							rangeState["fontfamily"] = { value: parentElement.face, icon: "fontfamily" };
							break;
						case "P":
						case "H1":
						case "H2":
						case "H3":
						case "H5":
						case "H6":
							var textAlign = parentElement.style.textAlign ? parentElement.style.textAlign : "left";
							var fontFamily = parentElement.style.fontFamily ? parentElement.style.fontFamily : "宋体,SimSun";
							var fontSize = parentElement.style.fontSize ? parentElement.style.fontSize : "12px";
							rangeState["justifycenter"] = { active: textAlign == "center", icon: "subscript" };
							rangeState["justifyleft"] = { active: textAlign == "left", icon: "subscript" };
							rangeState["justifyright"] = { active: textAlign == "right", icon: "subscript" };
							rangeState["paragraph"] = { value: parentElement.tagName.toLowerCase(), icon: "paragraph" };
							break;
						case "BLOCKQUOTE":
							rangeState["indent"] = { active: true, icon: "indent" };
							rangeState["outdent"] = { active: false, icon: "outdent" };
							break;
						case "SPAN":
							var className = parentElement.className || "";
							if (className.indexOf("font-border") != -1) {
								rangeState["fontborder"] = { active: true, icon: "fontborder" };
							}
							break;
					}
					parentElement = parentElement.parentNode;
				}
			}
	
			if (!rangeState["forecolor"]) rangeState["forecolor"] = { color: 'transparent', icon: "forecolor" };
			if (!rangeState["backcolor"]) rangeState["backcolor"] = { color: 'transparent', icon: "backcolor" };
			if (!rangeState["fontsize"] || !rangeState["fontsize"].value) rangeState["fontsize"] = { value: "3", icon: "fontsize" };
			if (!rangeState["paragraph"] || !rangeState["paragraph"].value) rangeState["paragraph"] = { value: "p", icon: "fontsize" };
			if (!rangeState["fontfamily"] || !rangeState["fontfamily"].value) rangeState["fontfamily"] = { value: "宋体, SimSun", icon: "fontfamily" };
			if (!rangeState["indent"]) {
				rangeState["outdent"] = { active: true, icon: "outdent" };
				rangeState["indent"] = { active: false, icon: "indent" };
			}
			return rangeState;
		},
		storeRange: function storeRange() {
			this.storedRange = this.range ? this.range.cloneRange() : null;
		},
		restoreRange: function restoreRange() {
			this.range = this.storedRange ? this.storedRange.cloneRange() : null;
			this.storedRange = null;
			this.cloneRange();
		},
		insertNode: function insertNode(node) {
	
			if (this.range) {
				EditorSelection.range.insertNode(node);
				var lastNode = node.lastChild || node;
				if (lastNode) {
					// this.range.setEndAfter(lastNode);
					this.range.setStartAfter(lastNode);
					this.range.setEndAfter(lastNode);
				}
				this.selection.removeAllRanges();
				this.selection.addRange(this.range);
			}
		}
	};
	exports.default = EditorSelection;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiDV = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(18);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _SgiCompConstant = __webpack_require__(107);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiDV = function (_React$Component) {
	    _inherits(SgiDV, _React$Component);
	
	    function SgiDV(props) {
	        _classCallCheck(this, SgiDV);
	
	        var _this = _possibleConstructorReturn(this, (SgiDV.__proto__ || Object.getPrototypeOf(SgiDV)).call(this, props));
	
	        _this.fitFormItems = function (moduleDesc, formItems) {
	            var me = _this;
	
	            var _this$props = _this.props,
	                objFct = _this$props.objFct,
	                type = _this$props.type;
	
	            var bdInst = (0, _SgiCommon.getConstByKey)(_this, moduleDesc.bdInst);
	            if (bdInst && objFct && !objFct.get(bdInst)) {
	                objFct.set(bdInst, {});
	            }
	
	            var reLyt = moduleDesc.reLyt;
	            if (reLyt) {
	                // form下的子节点添加到form组件中
	                var cldSet = moduleDesc.cldSet;
	                if (cldSet && cldSet.length && cldSet.length > 0) {
	                    _this.setFormCtlItems(cldSet, formItems, [], [], bdInst);
	                }
	            } else {
	                //查看是否绑定了DV，如果绑定了DV，获取DV信息，DV下的数据绑定到当前form下
	                var dsdDesc = moduleDesc.dsdDesc;
	                if (dsdDesc) {
	                    var descType = (0, _sgiCommon.getType)(dsdDesc);
	                    if (descType === "array") {
	                        dsdDesc.forEach(function (dvJson) {
	                            _this.setDVItems(dvJson, formItems, bdInst);
	                        });
	                    } else if (descType === "object") {
	                        _this.setDVItems(dsdDesc, formItems, bdInst);
	                    }
	                } else {
	                    var bdDvId = moduleDesc.bdDvId;
	                    if (bdDvId) {
	                        _this.state.bdDv = bdDvId;
	                        //暂时先不处理
	                        var dvs = bdDvId.split(",");
	                        dvs.forEach(function (item, index) {
	                            var dvJson = _PrmFactory.PrmFactory.getPrm(item);
	                            _this.setDVItems(dvJson, formItems, bdInst);
	                        });
	                    }
	                }
	            }
	
	            //老开发系统遗留，老系统form作为布局控件，现在临时实现垂直布局，和水平布局
	            //这个方法临时，以后重新开发的新系统可能不用
	            // this.adaptLayout(moduleDesc);
	
	            // //form下的子节点添加到form组件中
	            // let cldSet = moduleDesc.cldSet;
	            // if (cldSet && cldSet.length && cldSet.length > 0) {
	            //     this.setFormCtlItems(cldSet, formItems, toolbarItems, toolbarBottomItems, bdInst);
	            // }
	        };
	
	        _this.setDVItems = function (dvJson, formItems) {
	            if (!dvJson) return;
	            var dvItems = dvJson.dvItems;
	            var _this$props2 = _this.props,
	                objFct = _this$props2.objFct,
	                type = _this$props2.type,
	                _this$props2$moduleDe = _this$props2.moduleDesc,
	                moduleDesc = _this$props2$moduleDe === undefined ? {} : _this$props2$moduleDe;
	
	            var bdInst = (0, _SgiCommon.getConstByKey)(_this, moduleDesc.bdInst);
	            if (!dvItems) {
	                // dsd未自定义行列布局
	                if (!dvJson.cldSet) return;
	
	                var colNum = dvJson.colNum || _this.state.colNum || 2;
	
	                // let span = parseInt(24 / colNum);
	                var spanWidth = 100 / colNum;
	
	                var rows = [];
	                dvJson.cldSet.forEach(function (item, index) {
	                    var rowIndex = Math.floor(index / colNum);
	
	                    var row = rows[rowIndex];
	                    if (!row) {
	                        row = _react2.default.createElement(_antd.Row, null);
	                        rows[rowIndex] = row;
	                    }
	
	                    if (!item.desId) item.desId = "EP_EO_UI_3101";
	                    var copyItem = (0, _sgiCommon.copy)(item, true); //单向，不能修改原描述
	                    Object.assign(copyItem, copyItem.ctlInfo);
	                    var sc = copyItem.sc;
	                    var sonDescOne = _this.data.sonDesc[sc] || {};
	                    for (var key in sonDescOne) {
	                        if (!sonDescOne[key]) delete sonDescOne[key];
	                    }
	                    if (sc) Object.assign(copyItem, sonDescOne);
	                    if (_this.state.isLabel) _this.setAllItemIsLabel(copyItem, true);
	                    _this.setFormProps(copyItem, _this.state.formProps);
	                    var col = _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12, style: { width: spanWidth + "%" } },
	                        (0, _SgiCompComm.convertModuleByGuid)(_this, copyItem, bdInst, objFct, type)
	                    );
	
	                    if (!row.props.children) row.props.children = [];
	                    row.props.children.push(col);
	                });
	
	                formItems.push.apply(formItems, rows);
	            } else {
	                var _itemForEach = function _itemForEach() {
	                    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                    var foreach = arguments[1];
	
	                    if (!foreach || typeof foreach !== "function") return;
	                    items.forEach(function (item, index, arr) {
	                        var cldSet = item.cldSet;
	                        if (cldSet && cldSet.length > 0) {
	                            _itemForEach(cldSet, foreach);
	                        } else foreach(item);
	                    });
	                };
	
	                // dsd有自定义行列布局
	                // 获取DSD全部节点信息
	                var cldSet = dvJson.cldSet || [];
	                var allClds = {};
	                cldSet.forEach(function (item, index, arr) {
	                    allClds[item.sc || item.c] = item;
	                });
	                // 遍历添加节点信息与form统一控制信息
	                var copyItems = (0, _sgiCommon.copy)(dvItems, true);
	                _itemForEach(copyItems, function (item) {
	                    var cldItem = allClds[item.sc] || allClds[item.c];
	                    if (cldItem) Object.assign(item, cldItem);
	                    if (!item.desId) item.desId = "EP_EO_UI_3101";
	                    var sc = item.sc;
	                    var sonDescOne = _this.data.sonDesc[sc] || {};
	                    for (var key in sonDescOne) {
	                        if (!sonDescOne[key]) delete sonDescOne[key];
	                    }
	                    if (sc) Object.assign(item, sonDescOne);
	                    if (_this.state.isLabel) _this.setAllItemIsLabel(item, true);
	                    _this.setFormProps(item, _this.state.formProps);
	                });
	                // 创建节点
	                copyItems.forEach(function (item) {
	                    _this.state.formItems.push((0, _SgiCompComm.convertModuleByGuid)(_this, item, bdInst, objFct));
	                });
	            }
	        };
	
	        _this.setFormCtlItems = function (sonitems, formItems, toolbarItems, toolbarBottomItems, bdInst) {
	            var _this2 = this;
	
	            var _props = this.props,
	                objFct = _props.objFct,
	                type = _props.type;
	
	            //获取子空间的布局row信息
	
	            var rowInfo = this.setFormCtlRowInfo(sonitems);
	
	            //拼装控件
	            var rowItemList = void 0,
	                colList = void 0,
	                span = void 0,
	                offset = void 0;
	            for (var rowkey in rowInfo) {
	                rowItemList = rowInfo[rowkey];
	                colList = [];
	                rowItemList.forEach(function (item, index) {
	                    span = item.span;
	                    offset = item.offset;
	                    if (!span) span = 24;
	                    if (!offset) offset = 0;
	                    //如果是工具条的话，放入到工具条中make，不跟其他控件一起make
	                    if (item.desId === _SgiCompConstant.AllCompGUID.TOOLBAR) {
	                        if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
	                            toolbarItems.push((0, _SgiCompComm.convertModuleByGuid)(_this2, item, bdInst, objFct, type));
	                        } else {
	                            toolbarBottomItems.push((0, _SgiCompComm.convertModuleByGuid)(_this2, item, bdInst, objFct, type));
	                        }
	                    } else {
	                        var copyItem = (0, _sgiCommon.copy)(item, true); //单向，不能修改原描述
	                        Object.assign(copyItem, copyItem.ctlInfo);
	                        if (_this2.state.isLabel) _this2.setAllItemIsLabel(copyItem, true);
	                        // else this.setAllItemIsLabel(copyItem, false);//这里不能添加，作为当form可填写时，组件使用自定义的方式：可填写/仅展示
	                        _this2.setFormProps(copyItem, _this2.state.formProps);
	                        colList.push(_react2.default.createElement(
	                            _antd.Col,
	                            { style: {}, span: span, offset: offset },
	                            (0, _SgiCompComm.convertModuleByGuid)(_this2, copyItem, bdInst, objFct, type)
	                        ));
	                    }
	                });
	                formItems.push(_react2.default.createElement(
	                    _antd.Row,
	                    { style: {} },
	                    colList
	                ));
	            }
	        };
	
	        _this.setFormCtlRowInfo = function (sonitems) {
	            var nullrowList = [];
	            var rowInfo = {};
	            var colList = [];
	            var row = void 0,
	                span = void 0,
	                offset = void 0,
	                currentSonItem = void 0;
	            for (var i = 0; i < sonitems.length; i++) {
	                currentSonItem = sonitems[i];
	                row = currentSonItem.row;
	                span = currentSonItem.span;
	                if (row) {
	                    if (!rowInfo[row]) {
	                        rowInfo[row] = [];
	                    }
	                    rowInfo[row].push(currentSonItem);
	                } else {
	                    nullrowList.push(currentSonItem);
	                }
	            }
	            if (nullrowList.length > 0) {
	                rowInfo.nullrow = nullrowList;
	            }
	            return rowInfo;
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                parentModule = _props2.parentModule,
	                moduleDesc = _props2.moduleDesc,
	                objFct = _props2.objFct,
	                type = _props2.type;
	
	
	            if (!this.loaded || this.props.type == 'dnd') {
	                //组装属性
	                this.form_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            if (this.state.refreshFlg) {
	                var bdDv = this.state.bdDv;
	                if (bdDv) {
	                    var formItems = this.state.formItems = [];
	                    var bdInst = this.props;
	                    if (typeof bdDv === "string") {
	                        //暂时先不处理
	                        var dvs = bdDv.split(",");
	                        dvs.forEach(function (item, index) {
	                            var dvJson = _PrmFactory.PrmFactory.getPrm(item);
	                            _this3.setDVItems(dvJson, formItems, bdInst);
	                        });
	                    } else {
	                        var cldSet = bdDv.cldSet;
	                        if (cldSet && cldSet.length > 0) {
	                            this.setDVItems(bdDv, formItems, bdInst);
	                        }
	                    }
	                }
	                this.state.refreshFlg = false;
	            }
	
	            // 通用渲染前处理，添加自定义样式等
	            this.renderBeforeReturn(this.state.formProps);
	
	            return _react2.default.createElement(
	                _antd.Form,
	                this.state.formProps,
	                this.state.formItems,
	                this.props.children
	            );
	        };
	
	        _this.AddAttribute = function (moduleDesc, formProps, panelTitleProps) {
	            // 整个form是否只作为显示组件
	            var isLabel = moduleDesc.isLabel;
	            this.state.isLabel = !!isLabel;
	
	            var lblAlgn = moduleDesc.lblAlgn; //标签对齐方式
	            if (lblAlgn) formProps.labelAlign = lblAlgn;
	
	            // 冒号
	            formProps.colon = !!moduleDesc.colon;
	
	            // 是否换行
	            var nowrap = moduleDesc.nowrap;
	            if (nowrap) {
	                this.state.formProps.className += " sgiForm-nowrap";
	            }
	
	            // 标签宽度自适应
	            var lblAuto = moduleDesc.lblAuto;
	            if (lblAuto) {
	                this.state.formProps.className += " sgiForm-lblAuto";
	            }
	
	            var colNum = moduleDesc.colNum;
	            if (colNum) this.state.colNum = colNum;
	
	            this.data.sonDesc = moduleDesc.sonDesc || {};
	        };
	
	        _this.state = {
	            formProps: { style: { height: '100%', width: '100%' }, className: "sgiForm" }, //form属性
	            formItems: [], //form下控件数组
	            isLabel: false,
	            colNum: _this.props.colNum || 2
	        };
	        _this.data = {
	            sonDesc: {}
	        };
	        return _this;
	    }
	
	    /**获取form下所有控件 */
	
	
	    _createClass(SgiDV, [{
	        key: 'getFields',
	        value: function getFields() {
	            var resultFields = {};
	            this.getLeafFields(this.refs, resultFields);
	            return resultFields;
	        }
	
	        //遍历寻找下级refs，最底层的是form组件，前面都是布局用的
	
	    }, {
	        key: 'getLeafFields',
	        value: function getLeafFields(fields, resultFields) {
	            var item = void 0;
	            for (var itemKey in fields) {
	                item = fields[itemKey];
	                if ((0, _sgiCommon.getJsonLength)(item.refs) > 0) {
	                    //第一层
	                    this.getLeafFields(item.refs, resultFields);
	                } else {
	                    resultFields[itemKey] = item;
	                }
	            }
	        }
	
	        /**
	         * 设置一组输入控件的值
	         * @param { fieldName: value } FieldsValue
	         */
	
	    }, {
	        key: 'setFieldsValue',
	        value: function setFieldsValue(FieldsValue) {
	            var fields = this.getFields();
	            //循环所有子控件，调用他们的刷新方法
	            var item = void 0;
	
	            var _loop = function _loop() {
	                item = fields[index];
	                var attname = item.state.attname;
	                if (!attname || !item.setValue) {
	                    return 'continue';
	                }
	
	                // 级联组件等多属性组件属性值合并
	                var atts = [],
	                    vals = [];
	                if (attname.indexOf(",") !== -1) {
	                    atts = attname.split(",");
	                    atts.forEach(function (att) {
	                        vals.push(FieldsValue[att]);
	                    });
	                    item.setValue(vals);
	                }
	                // 其他正常组件
	                else {
	                        var value = FieldsValue[attname];
	                        item.setValue(value);
	                    }
	            };
	
	            for (var index in fields) {
	                var _ret = _loop();
	
	                if (_ret === 'continue') continue;
	            }
	        }
	
	        /**
	         * 从对象工厂中取值 刷新
	         */
	
	    }, {
	        key: 'refreshValues',
	        value: function refreshValues() {
	            var _props3 = this.props,
	                objFct = _props3.objFct,
	                moduleDesc = _props3.moduleDesc;
	
	            var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
	            if (bdInst && objFct) {
	                var value = objFct.get(bdInst);
	                this.setFieldsValue(value);
	            }
	        }
	
	        /**
	         * 校验并获取一组输入域的值与 Error
	         * @param {*} Fields
	         */
	
	    }, {
	        key: 'validateFields',
	        value: function validateFields() {
	            var errors = this.getFieldsError();
	            if (errors && errors.length > 0) {
	                return false;
	            } else {
	                return true;
	            }
	        }
	
	        /**获取一组输入控件的 Error  */
	
	    }, {
	        key: 'getFieldsError',
	        value: function getFieldsError() {
	            var fields = this.getFields();
	            var errors = [];
	            var errorMsg = void 0;
	            //循环所有子控件，调用他们的刷新方法
	            var item = void 0;
	            for (var index in fields) {
	                item = fields[index];
	                if (!item.validate) {
	                    continue;
	                }
	                errorMsg = item.validate();
	                if (errorMsg) {
	                    errors.push(errors);
	                }
	            }
	            return errors;
	        }
	
	        /**
	         * 根据描述创建form
	         * @param {父组件} parentModule
	         * @param {描述} moduleDesc
	         * @param {对象工厂} objFct
	         * @param {make类型} type
	         */
	
	    }, {
	        key: 'form_mk',
	        value: function form_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.formItems = []; //再次渲染的时候清空
	
	            //转换form公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.formProps, this.state.formBodyProps);
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.formProps, this.state.panelTitleProps);
	            //组装form表单下的控件信息
	            if (!(type === "dnd" && moduleDesc.reLyt === true)) this.fitFormItems(moduleDesc, this.state.formItems);
	        }
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	    }, {
	        key: 'refreshByBdDv',
	        value: function refreshByBdDv(bdDv) {
	            if (!bdDv) return;
	            this.setState({ refreshFlg: true, bdDv: bdDv });
	        }
	
	        /**
	         * 适应老系统垂直布局和水平布局
	         * @param {*} moduleDesc
	         */
	
	    }, {
	        key: 'adaptLayout',
	        value: function adaptLayout(moduleDesc) {
	            var cldSet = moduleDesc.cldSet;
	            var layout = moduleDesc.t;
	            var sumflx = 0;
	
	            if (!cldSet) {
	                return;
	            }
	
	            cldSet.forEach(function (item, index) {
	                sumflx = sumflx + item.flx;
	            });
	
	            if (layout == 'hbox') {
	                cldSet.forEach(function (item, index) {
	                    item.row = 1;
	                    if (sumflx && item.flx) {
	                        item.span = parseInt(item.flx / sumflx * 24);
	                    }
	                });
	            } else if (layout == 'vbox') {
	                cldSet.forEach(function (item, index) {
	                    item.row = index + 1;
	                    if (sumflx && item.flx) {
	                        item.span = 24;
	                    }
	                });
	            }
	        }
	
	        /**
	         *
	         * @param {*} bdDvId
	         * @param {*} formItems
	         */
	
	
	        /**
	         * 添加子控件
	         */
	
	    }, {
	        key: 'setAllItemIsLabel',
	        value: function setAllItemIsLabel(item, isLabel) {
	            var _this4 = this;
	
	            if (!item) return;
	            item.isLabel = !!isLabel;
	            if (item.cldSet) {
	                item.cldSet.forEach(function (cld) {
	                    _this4.setAllItemIsLabel(cld, isLabel);
	                });
	            }
	        }
	
	        /**
	         * 递归为子组件添加_formProps属性，将form属性传递下去
	         * @param {object} item 子组件描述
	         * @param {object} formProps form属性对象
	         */
	
	    }, {
	        key: 'setFormProps',
	        value: function setFormProps(item, formProps) {
	            var _this5 = this;
	
	            if (!item || !formProps) return;
	            item._formProps = formProps;
	            if (item.cldSet) {
	                item.cldSet.forEach(function (cld) {
	                    _this5.setFormProps(cld, formProps);
	                });
	            }
	        }
	
	        /**
	         * 设置是否仅显示标识(外部方法接口)
	         * @author hanzb
	         * @param {boolean} isLabel 是否仅显示
	         */
	
	    }, {
	        key: 'setIsLabel',
	        value: function setIsLabel(isLabel) {
	            // 重置部分状态
	            this.state.isLabel = !!isLabel;
	            this.setFormIsLabel(this.refs, !!isLabel);
	            // 刷新
	            this.setState({});
	        }
	    }, {
	        key: 'setFormIsLabel',
	        value: function setFormIsLabel(refs, isLabel) {
	            for (var key in refs) {
	                var ref = refs[key];
	                if (ref) {
	                    ref.setState({ formIsLabel: isLabel });
	                    if (ref.refs) {
	                        this.setFormIsLabel(ref.refs, isLabel);
	                    }
	                }
	            }
	        }
	
	        /**
	         * 设置整个表单是否禁用(外部接口)
	         * @param {boolean} disabled 是否禁用
	         */
	
	    }, {
	        key: 'setDisabled',
	        value: function setDisabled(disabled) {
	            this.setFormDisabled(this.refs, disabled);
	        }
	    }, {
	        key: 'setFormDisabled',
	        value: function setFormDisabled(refs, disabled) {
	            for (var key in refs) {
	                var ctl = refs[key];
	                if (!ctl) continue;
	                if (ctl.setFormDisabled) ctl.setFormDisabled(disabled);
	                if (ctl.refs) this.setFormDisabled(ctl.refs, disabled);
	            }
	        }
	
	        /**
	         * 设置布局
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	
	        //渲染并返回一个虚拟DOM
	
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	    }]);
	
	    return SgiDV;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	Object.assign(SgiDV.prototype, _SgiCtnComm.sgiCtnBaseFun);
	exports.SgiDV = SgiDV;
	exports.default = SgiDV;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 表格基础方法，供表格继承
	 * hanzb
	 * 2019年5月10日，从表格组件移出至此
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sgiTableBaseFun = undefined;
	
	var _sgiFormCtlValidator = __webpack_require__(254);
	
	var _sgiLogger = __webpack_require__(39);
	
	var sgiTableBaseFun = {
	
	    /**
	     * 获取表格所有数据
	     * @return {[list]} [description]
	     */
	    getTbData: function getTbData() {
	        return this.state.dataSource;
	    },
	
	    /**
	     * [获取表格已选中/已勾选数据]
	     * @return {[obj/list]} [已选中对象/已勾选行对象数组]
	     */
	    getTbSels: function getTbSels() {
	        return this.state.selectedRows;
	    },
	
	    /**
	     * 表格设置 默认选中数据
	     */
	    setTbSels: function setTbSels(records) {
	        var _this = this;
	
	        this.state.rowSelection.selectedRowKeys = [];
	        if (records instanceof Array) {
	            records.forEach(function (element) {
	                _this.state.rowSelection.selectedRowKeys.push(element._key);
	            });
	        } else {
	            this.state.rowSelection.selectedRowKeys = [records._key];
	        }
	        this.setState({ selectedRows: records });
	    },
	
	    /**
	     * 根据普通数据 和对比属性，返回
	     */
	    getTbDataByKey: function getTbDataByKey(records, key) {
	        var _this2 = this;
	
	        var rsList = [];
	        if (!records || !key) {
	            return rsList;
	        }
	        var inList = void 0;
	        var tmpTreeRecord = void 0;
	
	        if (records instanceof Array) {
	            inList = records;
	        } else {
	            inList = [records];
	        }
	
	        inList.forEach(function (inElement) {
	            if (!inElement) return;
	            for (var i = 0; i < _this2.state.dataSource.length; i++) {
	                tmpTreeRecord = _this2.state.dataSource[i];
	                if (tmpTreeRecord[key] == inElement[key]) {
	                    rsList.push(tmpTreeRecord);
	                    break;
	                }
	            }
	        });
	        return rsList;
	    },
	
	    /**
	     * 向表格中添加新数据
	     * @param {[type]} newData [要添加的数据]
	     */
	    addTbNewData: function addTbNewData(newData) {
	        if (newData) {
	            this.state.dataSource.push(newData);
	            this.refreshTable(this.state.dataSource);
	
	            //如果当前是分批调用表格，重新查询当页数据和总数
	            if (this.state.batchInfo.batchFun) {
	                this.state.pagination.total = 0;
	                this.batchSelect();
	            }
	        }
	    },
	
	    /**
	     * 删除表格选中数据
	     * @return {[type]} [description]
	     */
	    delTableSel: function delTableSel() {
	        var selectedRows = this.getTbSels();
	        var dataSource = this.state.dataSource;
	        if (dataSource && selectedRows) {
	            selectedRows.map(function (item, index) {
	                for (var i = 0; i < dataSource.length; i++) {
	                    if (item == dataSource[i]) {
	                        dataSource.splice(i, 1);
	                    }
	                }
	            });
	            this.refreshTable(dataSource);
	            this.state.selectedRows = []; //既然删除了那就置空喽
	            if (this.state.rowSelection) {
	                this.state.rowSelection.selectedRowKeys = [];
	            }
	            return dataSource;
	        } else {
	            return null;
	        }
	    },
	
	    /**
	     * 删除表格指定行数据
	     * @param  {[type]} delData [description]
	     * @return {[type]}          [description]
	     */
	    delTableObj: function delTableObj(delData) {
	        var dataSource = this.state.dataSource;
	        if (dataSource && delData) {
	            for (var i = 0; i < dataSource.length; i++) {
	                if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
	                    dataSource.splice(i, 1);
	                }
	            }
	            this.refreshTable(dataSource);
	
	            //如果当前是分批调用表格，重新查询当页数据和总数
	            if (this.state.batchInfo.batchFun) {
	                this.state.pagination.total = 0;
	                this.batchSelect();
	            }
	
	            return dataSource;
	        } else {
	            return null;
	        }
	    },
	
	    // 外部调用筛选方法
	    filter: function filter(matStr, notContain) {
	        var _this3 = this;
	
	        if (matStr) {
	            this.state.selValues.mat = matStr;
	            this.state.contain = !notContain;
	            var reg = new RegExp(matStr, 'gi');
	            this.state.store = this.state.dataSource.filter(function (e) {
	                return _this3._match(e, reg);
	            });
	        } else {
	            this.state.store = this.state.dataSource;
	        }
	        this.setState({ loading: false }); //刷新
	    }
	
	};
	exports.sgiTableBaseFun = sgiTableBaseFun;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RoleModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	
	var roleList = [{ roleName: '省行领导', roleId: '1045209085940596736' }, { roleName: '客户经理', roleId: '1045209085940596736' }]; // 调用服务取
	var modalRoleListColumns = [{
	    title: '角色名称', // 列头显示名称
	    dataIndex: 'roleName' // 列数据在数据项中对应的 key
	}];
	
	/**
	 *添加审批角色弹出窗
	 *
	 * @class RoleModal
	 * @extends {React.Component}
	 */
	
	var RoleModal = function (_React$Component) {
	    _inherits(RoleModal, _React$Component);
	
	    function RoleModal(props) {
	        _classCallCheck(this, RoleModal);
	
	        var _this = _possibleConstructorReturn(this, (RoleModal.__proto__ || Object.getPrototypeOf(RoleModal)).call(this, props));
	
	        _this.getTBData = function (tData) {
	            if (!tData) {
	                tData = [];
	                return tData;
	            }
	            tData.forEach(function (element) {
	                if (!element._key) element._key = (0, _CommonFunc.uuid)(8);
	            });
	            return tData;
	        };
	
	        _this.modalHandleOk = function (e) {
	            _this.props.parent.reload(); // 刷新审批角色列表
	            _this.setState({
	                modalShow: false
	            });
	        };
	
	        _this.modalHandleCancel = function (e) {
	            _this.setState({
	                modalShow: false
	            });
	        };
	
	        _this.state = {
	            modalShow: props.modalShow,
	            title: props.title,
	            loading: false
	        };
	        return _this;
	    }
	
	    // 创建表格绑定store（生成数据key）
	
	    // 输入参数modal确认按钮事件
	
	    // 输入参数modal取消按钮事件
	
	
	    _createClass(RoleModal, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var modalRoleList = this.getTBData(roleList);
	            // 勾选事件
	            var rowSelection = {
	                onChange: function onChange(selectedRowKeys, selectedRows) {
	                    console.log('selectedRowKeys: ' + selectedRowKeys, 'selectedRows: ', selectedRows);
	                    _this2.props.approvalRoleList.splice(0, _this2.props.approvalRoleList.length); // 清空数组，不改变引用地址
	                    _this2.props.approvalRoleList.push.apply(_this2.props.approvalRoleList, selectedRows); // 追加数组元素，不改变引用地址
	                }
	            };
	            return _react2.default.createElement(
	                _antd.Modal,
	                {
	                    title: this.state.title,
	                    visible: this.state.modalShow,
	                    onOk: this.modalHandleOk,
	                    onCancel: this.modalHandleCancel,
	                    okText: '\u786E\u8BA4',
	                    cancelText: '\u53D6\u6D88',
	                    destroyOnClose: true
	                },
	                _react2.default.createElement(
	                    _antd.Row,
	                    { gutter: 16 },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 24 },
	                        _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                            rowClassName: function rowClassName() {
	                                return 'roleList-row';
	                            } // 表格行的类名
	                            , bordered: true // 是否展示外边框和列边框
	                            , dataSource: modalRoleList,
	                            columns: modalRoleListColumns,
	                            rowSelection: rowSelection
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RoleModal;
	}(_react2.default.Component);
	
	exports.RoleModal = RoleModal;
	exports.default = RoleModal;

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getScroll;
	
	function getScroll(target, top) {
	  if (typeof window === 'undefined') {
	    return 0;
	  }
	
	  var prop = top ? 'pageYOffset' : 'pageXOffset';
	  var method = top ? 'scrollTop' : 'scrollLeft';
	  var isWindow = target === window;
	  var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode
	
	  if (isWindow && typeof ret !== 'number') {
	    ret = document.documentElement[method];
	  }
	
	  return ret;
	}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = scrollTo;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	var _getScroll = _interopRequireDefault(__webpack_require__(373));
	
	var _easings = __webpack_require__(1350);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function scrollTo(y) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$getContainer = options.getContainer,
	      getContainer = _options$getContainer === void 0 ? function () {
	    return window;
	  } : _options$getContainer,
	      callback = options.callback,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 450 : _options$duration;
	  var container = getContainer();
	  var scrollTop = (0, _getScroll["default"])(container, true);
	  var startTime = Date.now();
	
	  var frameFunc = function frameFunc() {
	    var timestamp = Date.now();
	    var time = timestamp - startTime;
	    var nextScrollTop = (0, _easings.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);
	
	    if (container === window) {
	      window.scrollTo(window.pageXOffset, nextScrollTop);
	    } else {
	      container.scrollTop = nextScrollTop;
	    }
	
	    if (time < duration) {
	      (0, _raf["default"])(frameFunc);
	    } else if (typeof callback === 'function') {
	      callback();
	    }
	  };
	
	  (0, _raf["default"])(frameFunc);
	}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/**
	 * Wrap of sub component which need use as Button capacity (like Icon component).
	 * This helps accessibility reader to tread as a interactive button to operation.
	 */
	
	var inlineStyle = {
	  border: 0,
	  background: 'transparent',
	  padding: 0,
	  lineHeight: 'inherit',
	  display: 'inline-block'
	};
	
	var TransButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(TransButton, _React$Component);
	
	  var _super = _createSuper(TransButton);
	
	  function TransButton() {
	    var _this;
	
	    _classCallCheck(this, TransButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (event) {
	      var keyCode = event.keyCode;
	
	      if (keyCode === _KeyCode["default"].ENTER) {
	        event.preventDefault();
	      }
	    };
	
	    _this.onKeyUp = function (event) {
	      var keyCode = event.keyCode;
	      var onClick = _this.props.onClick;
	
	      if (keyCode === _KeyCode["default"].ENTER && onClick) {
	        onClick();
	      }
	    };
	
	    _this.setRef = function (btn) {
	      _this.div = btn;
	    };
	
	    return _this;
	  }
	
	  _createClass(TransButton, [{
	    key: "focus",
	    value: function focus() {
	      if (this.div) {
	        this.div.focus();
	      }
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      if (this.div) {
	        this.div.blur();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          style = _a.style,
	          noStyle = _a.noStyle,
	          restProps = __rest(_a, ["style", "noStyle"]);
	
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          role: "button",
	          tabIndex: 0,
	          ref: this.setRef
	        }, restProps, {
	          onKeyDown: this.onKeyDown,
	          onKeyUp: this.onKeyUp,
	          style: _extends(_extends({}, !noStyle ? inlineStyle : null), style)
	        }))
	      );
	    }
	  }]);
	
	  return TransButton;
	}(React.Component);
	
	var _default = TransButton;
	exports["default"] = _default;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactDom = __webpack_require__(84);
	
	var _Event = _interopRequireDefault(__webpack_require__(494));
	
	var _raf = _interopRequireDefault(__webpack_require__(205));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var styleForPesudo; // Where el is the DOM element you'd like to test for visibility
	
	function isHidden(element) {
	  if (false) {
	    return false;
	  }
	
	  return !element || element.offsetParent === null;
	}
	
	function isNotGrey(color) {
	  // eslint-disable-next-line no-useless-escape
	  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
	
	  if (match && match[1] && match[2] && match[3]) {
	    return !(match[1] === match[2] && match[2] === match[3]);
	  }
	
	  return true;
	}
	
	var Wave = /*#__PURE__*/function (_React$Component) {
	  _inherits(Wave, _React$Component);
	
	  var _super = _createSuper(Wave);
	
	  function Wave() {
	    var _this;
	
	    _classCallCheck(this, Wave);
	
	    _this = _super.apply(this, arguments);
	    _this.animationStart = false;
	    _this.destroy = false;
	
	    _this.onClick = function (node, waveColor) {
	      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
	        return;
	      }
	
	      var insertExtraNode = _this.props.insertExtraNode;
	      _this.extraNode = document.createElement('div');
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          extraNode = _assertThisInitialize.extraNode;
	
	      extraNode.className = 'ant-click-animating-node';
	
	      var attributeName = _this.getAttributeName();
	
	      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey
	
	      styleForPesudo = styleForPesudo || document.createElement('style');
	
	      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
	      waveColor !== 'transparent') {
	        // Add nonce if CSP exist
	        if (_this.csp && _this.csp.nonce) {
	          styleForPesudo.nonce = _this.csp.nonce;
	        }
	
	        extraNode.style.borderColor = waveColor;
	        styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");
	
	        if (!document.body.contains(styleForPesudo)) {
	          document.body.appendChild(styleForPesudo);
	        }
	      }
	
	      if (insertExtraNode) {
	        node.appendChild(extraNode);
	      }
	
	      _Event["default"].addStartEventListener(node, _this.onTransitionStart);
	
	      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
	    };
	
	    _this.onTransitionStart = function (e) {
	      if (_this.destroy) return;
	      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));
	
	      if (!e || e.target !== node) {
	        return;
	      }
	
	      if (!_this.animationStart) {
	        _this.resetEffect(node);
	      }
	    };
	
	    _this.onTransitionEnd = function (e) {
	      if (!e || e.animationName !== 'fadeEffect') {
	        return;
	      }
	
	      _this.resetEffect(e.target);
	    };
	
	    _this.bindAnimationEvent = function (node) {
	      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
	        return;
	      }
	
	      var onClick = function onClick(e) {
	        // Fix radio button click twice
	        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
	          return;
	        }
	
	        _this.resetEffect(node); // Get wave color from target
	
	
	        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
	        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
	        _this.clickWaveTimeoutId = window.setTimeout(function () {
	          return _this.onClick(node, waveColor);
	        }, 0);
	
	        _raf["default"].cancel(_this.animationStartId);
	
	        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
	
	        _this.animationStartId = (0, _raf["default"])(function () {
	          _this.animationStart = false;
	        }, 10);
	      };
	
	      node.addEventListener('click', onClick, true);
	      return {
	        cancel: function cancel() {
	          node.removeEventListener('click', onClick, true);
	        }
	      };
	    };
	
	    _this.renderWave = function (_ref) {
	      var csp = _ref.csp;
	      var children = _this.props.children;
	      _this.csp = csp;
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Wave, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var node = (0, _reactDom.findDOMNode)(this);
	
	      if (!node || node.nodeType !== 1) {
	        return;
	      }
	
	      this.instance = this.bindAnimationEvent(node);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.instance) {
	        this.instance.cancel();
	      }
	
	      if (this.clickWaveTimeoutId) {
	        clearTimeout(this.clickWaveTimeoutId);
	      }
	
	      this.destroy = true;
	    }
	  }, {
	    key: "getAttributeName",
	    value: function getAttributeName() {
	      var insertExtraNode = this.props.insertExtraNode;
	      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
	    }
	  }, {
	    key: "resetEffect",
	    value: function resetEffect(node) {
	      if (!node || node === this.extraNode || !(node instanceof Element)) {
	        return;
	      }
	
	      var insertExtraNode = this.props.insertExtraNode;
	      var attributeName = this.getAttributeName();
	      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466
	
	      if (styleForPesudo) {
	        styleForPesudo.innerHTML = '';
	      }
	
	      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
	        node.removeChild(this.extraNode);
	      }
	
	      _Event["default"].removeStartEventListener(node, this.onTransitionStart);
	
	      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWave)
	      );
	    }
	  }]);
	
	  return Wave;
	}(React.Component);
	
	exports["default"] = Wave;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(501));
	
	var _en_US2 = _interopRequireDefault(__webpack_require__(387));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	// Merge into a locale object
	var locale = {
	  lang: _extends({
	    placeholder: 'Select date',
	    rangePlaceholder: ['Start date', 'End date']
	  }, _en_US["default"]),
	  timePickerLocale: _extends({}, _en_US2["default"])
	}; // All settings at:
	// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
	
	var _default = locale;
	exports["default"] = _default;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcDropdown = _interopRequireDefault(__webpack_require__(465));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _type = __webpack_require__(83);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');
	
	var Dropdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  var _super = _createSuper(Dropdown);
	
	  function Dropdown() {
	    var _this;
	
	    _classCallCheck(this, Dropdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderOverlay = function (prefixCls) {
	      // rc-dropdown already can process the function of overlay, but we have check logic here.
	      // So we need render the element to check and pass back to rc-dropdown.
	      var overlay = _this.props.overlay;
	      var overlayNode;
	
	      if (typeof overlay === 'function') {
	        overlayNode = overlay();
	      } else {
	        overlayNode = overlay;
	      }
	
	      overlayNode = React.Children.only(overlayNode);
	      var overlayProps = overlayNode.props; // Warning if use other mode
	
	      (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', 'Dropdown', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
	      // menu should be focusable in dropdown defaultly
	
	      var _overlayProps$selecta = overlayProps.selectable,
	          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
	          _overlayProps$focusab = overlayProps.focusable,
	          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
	      var expandIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-submenu-arrow")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
	      }));
	      var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlay : /*#__PURE__*/React.cloneElement(overlayNode, {
	        mode: 'vertical',
	        selectable: selectable,
	        focusable: focusable,
	        expandIcon: expandIcon
	      });
	      return fixedModeOverlay;
	    };
	
	    _this.renderDropDown = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          children = _this$props.children,
	          trigger = _this$props.trigger,
	          disabled = _this$props.disabled,
	          getPopupContainer = _this$props.getPopupContainer;
	      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
	      var child = React.Children.only(children);
	      var dropdownTrigger = /*#__PURE__*/React.cloneElement(child, {
	        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
	        disabled: disabled
	      });
	      var triggerActions = disabled ? [] : trigger;
	      var alignPoint;
	
	      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
	        alignPoint = true;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcDropdown["default"], _extends({
	          alignPoint: alignPoint
	        }, _this.props, {
	          prefixCls: prefixCls,
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          transitionName: _this.getTransitionName(),
	          trigger: triggerActions,
	          overlay: function overlay() {
	            return _this.renderOverlay(prefixCls);
	          }
	        }), dropdownTrigger)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: "getTransitionName",
	    value: function getTransitionName() {
	      var _this$props2 = this.props,
	          _this$props2$placemen = _this$props2.placement,
	          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen,
	          transitionName = _this$props2.transitionName;
	
	      if (transitionName !== undefined) {
	        return transitionName;
	      }
	
	      if (placement.indexOf('top') >= 0) {
	        return 'slide-down';
	      }
	
	      return 'slide-up';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDropDown)
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(React.Component);
	
	exports["default"] = Dropdown;
	Dropdown.defaultProps = {
	  mouseEnterDelay: 0.15,
	  mouseLeaveDelay: 0.1,
	  placement: 'bottomLeft'
	};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _dropdown = _interopRequireDefault(__webpack_require__(378));
	
	var _dropdownButton = _interopRequireDefault(__webpack_require__(1392));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_dropdown["default"].Button = _dropdownButton["default"];
	var _default = _dropdown["default"];
	exports["default"] = _default;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SiderContext = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _layout = __webpack_require__(753);
	
	var _configProvider = __webpack_require__(15);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _isNumeric = _interopRequireDefault(__webpack_require__(1351));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	}
	
	var dimensionMaxMap = {
	  xs: '479.98px',
	  sm: '575.98px',
	  md: '767.98px',
	  lg: '991.98px',
	  xl: '1199.98px',
	  xxl: '1599.98px'
	};
	var SiderContext = (0, _createReactContext["default"])({});
	exports.SiderContext = SiderContext;
	
	var generateId = function () {
	  var i = 0;
	  return function () {
	    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    i += 1;
	    return "".concat(prefix).concat(i);
	  };
	}();
	
	var InternalSider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalSider, _React$Component);
	
	  var _super = _createSuper(InternalSider);
	
	  function InternalSider(props) {
	    var _this;
	
	    _classCallCheck(this, InternalSider);
	
	    _this = _super.call(this, props);
	
	    _this.responsiveHandler = function (mql) {
	      _this.setState({
	        below: mql.matches
	      });
	
	      var onBreakpoint = _this.props.onBreakpoint;
	
	      if (onBreakpoint) {
	        onBreakpoint(mql.matches);
	      }
	
	      if (_this.state.collapsed !== mql.matches) {
	        _this.setCollapsed(mql.matches, 'responsive');
	      }
	    };
	
	    _this.setCollapsed = function (collapsed, type) {
	      if (!('collapsed' in _this.props)) {
	        _this.setState({
	          collapsed: collapsed
	        });
	      }
	
	      var onCollapse = _this.props.onCollapse;
	
	      if (onCollapse) {
	        onCollapse(collapsed, type);
	      }
	    };
	
	    _this.toggle = function () {
	      var collapsed = !_this.state.collapsed;
	
	      _this.setCollapsed(collapsed, 'clickTrigger');
	    };
	
	    _this.belowShowChange = function () {
	      _this.setState(function (_ref) {
	        var belowShow = _ref.belowShow;
	        return {
	          belowShow: !belowShow
	        };
	      });
	    };
	
	    _this.renderSider = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          theme = _a.theme,
	          collapsible = _a.collapsible,
	          reverseArrow = _a.reverseArrow,
	          trigger = _a.trigger,
	          style = _a.style,
	          width = _a.width,
	          collapsedWidth = _a.collapsedWidth,
	          zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle,
	          others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth", "zeroWidthTriggerStyle"]);
	
	      var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
	      var divProps = (0, _omit["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint', 'siderHook', 'zeroWidthTriggerStyle']);
	      var rawWidth = _this.state.collapsed ? collapsedWidth : width; // use "px" as fallback unit for width
	
	      var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0
	
	      var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/React.createElement("span", {
	        onClick: _this.toggle,
	        className: "".concat(prefixCls, "-zero-width-trigger ").concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left'),
	        style: zeroWidthTriggerStyle
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "bars"
	      })) : null;
	      var iconObj = {
	        expanded: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }),
	        collapsed: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        })
	      };
	      var status = _this.state.collapsed ? 'collapsed' : 'expanded';
	      var defaultTrigger = iconObj[status];
	      var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-trigger"),
	        onClick: _this.toggle,
	        style: {
	          width: siderWidth
	        }
	      }, trigger || defaultTrigger) : null;
	
	      var divStyle = _extends(_extends({}, style), {
	        flex: "0 0 ".concat(siderWidth),
	        maxWidth: siderWidth,
	        minWidth: siderWidth,
	        width: siderWidth
	      });
	
	      var siderCls = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), !!_this.state.collapsed), _defineProperty(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty(_classNames, "".concat(prefixCls, "-below"), !!_this.state.below), _defineProperty(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames));
	      return (/*#__PURE__*/React.createElement("aside", _extends({
	          className: siderCls
	        }, divProps, {
	          style: divStyle
	        }), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-children")
	        }, _this.props.children), collapsible || _this.state.below && zeroWidthTrigger ? triggerDom : null)
	      );
	    };
	
	    _this.uniqueId = generateId('ant-sider-');
	    var matchMedia;
	
	    if (typeof window !== 'undefined') {
	      matchMedia = window.matchMedia;
	    }
	
	    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMaxMap) {
	      _this.mql = matchMedia("(max-width: ".concat(dimensionMaxMap[props.breakpoint], ")"));
	    }
	
	    var collapsed;
	
	    if ('collapsed' in props) {
	      collapsed = props.collapsed;
	    } else {
	      collapsed = props.defaultCollapsed;
	    }
	
	    _this.state = {
	      collapsed: collapsed,
	      below: false
	    };
	    return _this;
	  }
	
	  _createClass(InternalSider, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.mql) {
	        this.mql.addListener(this.responsiveHandler);
	        this.responsiveHandler(this.mql);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.addSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.mql) {
	        this.mql.removeListener(this.responsiveHandler);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.removeSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var collapsed = this.state.collapsed;
	      var collapsedWidth = this.props.collapsedWidth;
	      return (/*#__PURE__*/React.createElement(SiderContext.Provider, {
	          value: {
	            siderCollapsed: collapsed,
	            collapsedWidth: collapsedWidth
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSider))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('collapsed' in nextProps) {
	        return {
	          collapsed: nextProps.collapsed
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return InternalSider;
	}(React.Component);
	
	InternalSider.defaultProps = {
	  collapsible: false,
	  defaultCollapsed: false,
	  reverseArrow: false,
	  width: 200,
	  collapsedWidth: 80,
	  style: {},
	  theme: 'dark'
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalSider); // eslint-disable-next-line react/prefer-stateless-function
	
	var Sider = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Sider, _React$Component2);
	
	  var _super2 = _createSuper(Sider);
	
	  function Sider() {
	    _classCallCheck(this, Sider);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Sider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_layout.LayoutContext.Consumer, null, function (context) {
	          return (/*#__PURE__*/React.createElement(InternalSider, _extends({}, context, _this2.props))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Sider;
	}(React.Component);
	
	exports["default"] = Sider;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var MenuContext = (0, _createReactContext["default"])({
	  inlineCollapsed: false
	});
	var _default = MenuContext;
	exports["default"] = _default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(93));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(1414));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(1413));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _Sider = __webpack_require__(380);
	
	var _raf = _interopRequireDefault(__webpack_require__(205));
	
	var _motion = _interopRequireDefault(__webpack_require__(732));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(381));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var InternalMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalMenu, _React$Component);
	
	  var _super = _createSuper(InternalMenu);
	
	  function InternalMenu(props) {
	    var _this;
	
	    _classCallCheck(this, InternalMenu);
	
	    _this = _super.call(this, props); // Restore vertical mode when menu is collapsed responsively when mounted
	    // https://github.com/ant-design/ant-design/issues/13104
	    // TODO: not a perfect solution, looking a new way to avoid setting switchingModeFromInline in this situation
	
	    _this.handleMouseEnter = function (e) {
	      _this.restoreModeVerticalFromInline();
	
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(e);
	      }
	    };
	
	    _this.handleTransitionEnd = function (e) {
	      // when inlineCollapsed menu width animation finished
	      // https://github.com/ant-design/ant-design/issues/12864
	      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function
	      // https://github.com/ant-design/ant-design/issues/15699
	
	      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during an animation.
	
	      var classNameValue = Object.prototype.toString.call(className) === '[object SVGAnimatedString]' ? className.animVal : className; // Fix for <Menu style={{ width: '100%' }} />, the width transition won't trigger when menu is collapsed
	      // https://github.com/ant-design/ant-design-pro/issues/2783
	
	      var iconScaled = e.propertyName === 'font-size' && classNameValue.indexOf('anticon') >= 0;
	
	      if (widthCollapsed || iconScaled) {
	        _this.restoreModeVerticalFromInline();
	      }
	    };
	
	    _this.handleClick = function (e) {
	      _this.handleOpenChange([]);
	
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.handleOpenChange = function (openKeys) {
	      _this.setOpenKeys(openKeys);
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(openKeys);
	      }
	    };
	
	    _this.renderMenu = function (_ref) {
	      var getPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          theme = _this$props.theme,
	          collapsedWidth = _this$props.collapsedWidth;
	      var passProps = (0, _omit["default"])(_this.props, ['collapsedWidth', 'siderCollapsed']);
	
	      var menuMode = _this.getRealMenuMode();
	
	      var menuOpenMotion = _this.getOpenMotionProps(menuMode);
	
	      var prefixCls = getPrefixCls('menu', customizePrefixCls);
	      var menuClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()));
	
	      var menuProps = _extends({
	        openKeys: _this.state.openKeys,
	        onOpenChange: _this.handleOpenChange,
	        className: menuClassName,
	        mode: menuMode
	      }, menuOpenMotion);
	
	      if (menuMode !== 'inline') {
	        // closing vertical popup submenu after click it
	        menuProps.onClick = _this.handleClick;
	      } // https://github.com/ant-design/ant-design/issues/8587
	
	
	      var hideMenu = _this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px');
	
	      if (hideMenu) {
	        menuProps.openKeys = [];
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcMenu["default"], _extends({
	          getPopupContainer: getPopupContainer
	        }, passProps, menuProps, {
	          prefixCls: prefixCls,
	          onTransitionEnd: _this.handleTransitionEnd,
	          onMouseEnter: _this.handleMouseEnter
	        }))
	      );
	    };
	
	    (0, _warning["default"])(!('onOpen' in props || 'onClose' in props), 'Menu', '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
	    (0, _warning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
	    (0, _warning["default"])(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
	    var openKeys;
	
	    if ('openKeys' in props) {
	      openKeys = props.openKeys;
	    } else if ('defaultOpenKeys' in props) {
	      openKeys = props.defaultOpenKeys;
	    }
	
	    _this.state = {
	      openKeys: openKeys || [],
	      switchingModeFromInline: false,
	      inlineOpenKeys: [],
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(InternalMenu, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountRafId);
	    }
	  }, {
	    key: "setOpenKeys",
	    value: function setOpenKeys(openKeys) {
	      if (!('openKeys' in this.props)) {
	        this.setState({
	          openKeys: openKeys
	        });
	      }
	    }
	  }, {
	    key: "getRealMenuMode",
	    value: function getRealMenuMode() {
	      var inlineCollapsed = this.getInlineCollapsed();
	
	      if (this.state.switchingModeFromInline && inlineCollapsed) {
	        return 'inline';
	      }
	
	      var mode = this.props.mode;
	      return inlineCollapsed ? 'vertical' : mode;
	    }
	  }, {
	    key: "getInlineCollapsed",
	    value: function getInlineCollapsed() {
	      var inlineCollapsed = this.props.inlineCollapsed;
	
	      if (this.props.siderCollapsed !== undefined) {
	        return this.props.siderCollapsed;
	      }
	
	      return inlineCollapsed;
	    }
	  }, {
	    key: "getOpenMotionProps",
	    value: function getOpenMotionProps(menuMode) {
	      var _this$props2 = this.props,
	          openTransitionName = _this$props2.openTransitionName,
	          openAnimation = _this$props2.openAnimation,
	          motion = _this$props2.motion; // Provides by user
	
	      if (motion) {
	        return {
	          motion: motion
	        };
	      }
	
	      if (openAnimation) {
	        (0, _warning["default"])(typeof openAnimation === 'string', 'Menu', '`openAnimation` do not support object. Please use `motion` instead.');
	        return {
	          openAnimation: openAnimation
	        };
	      }
	
	      if (openTransitionName) {
	        return {
	          openTransitionName: openTransitionName
	        };
	      } // Default logic
	
	
	      if (menuMode === 'horizontal') {
	        return {
	          motion: {
	            motionName: 'slide-up'
	          }
	        };
	      }
	
	      if (menuMode === 'inline') {
	        return {
	          motion: _motion["default"]
	        };
	      } // When mode switch from inline
	      // submenu should hide without animation
	
	
	      return {
	        motion: {
	          motionName: this.state.switchingModeFromInline ? '' : 'zoom-big'
	        }
	      };
	    }
	  }, {
	    key: "restoreModeVerticalFromInline",
	    value: function restoreModeVerticalFromInline() {
	      var switchingModeFromInline = this.state.switchingModeFromInline;
	
	      if (switchingModeFromInline) {
	        this.setState({
	          switchingModeFromInline: false
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Provider, {
	          value: {
	            inlineCollapsed: this.getInlineCollapsed() || false,
	            antdMenuTheme: this.props.theme
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if (prevProps.mode === 'inline' && nextProps.mode !== 'inline') {
	        newState.switchingModeFromInline = true;
	      }
	
	      if ('openKeys' in nextProps) {
	        newState.openKeys = nextProps.openKeys;
	      } else {
	        // [Legacy] Old code will return after `openKeys` changed.
	        // Not sure the reason, we should keep this logic still.
	        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
	          newState.switchingModeFromInline = true;
	          newState.inlineOpenKeys = prevState.openKeys;
	          newState.openKeys = [];
	        }
	
	        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
	          newState.openKeys = prevState.inlineOpenKeys;
	          newState.inlineOpenKeys = [];
	        }
	      }
	
	      return newState;
	    }
	  }]);
	
	  return InternalMenu;
	}(React.Component);
	
	InternalMenu.defaultProps = {
	  className: '',
	  theme: 'light',
	  focusable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalMenu); // We should keep this as ref-able
	
	var Menu = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Menu, _React$Component2);
	
	  var _super2 = _createSuper(Menu);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Menu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, function (context) {
	          return (/*#__PURE__*/React.createElement(InternalMenu, _extends({}, _this2.props, context))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Menu;
	}(React.Component);
	
	exports["default"] = Menu;
	Menu.Divider = _rcMenu.Divider;
	Menu.Item = _MenuItem["default"];
	Menu.SubMenu = _SubMenu["default"];
	Menu.ItemGroup = _rcMenu.ItemGroup;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeConfirmLocale = changeConfirmLocale;
	exports.getConfirmLocale = getConfirmLocale;
	
	var _default = _interopRequireDefault(__webpack_require__(164));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var runtimeLocale = _extends({}, _default["default"].Modal);
	
	function changeConfirmLocale(newLocale) {
	  if (newLocale) {
	    runtimeLocale = _extends(_extends({}, runtimeLocale), newLocale);
	  } else {
	    runtimeLocale = _extends({}, _default["default"].Modal);
	  }
	}
	
	function getConfirmLocale() {
	  return runtimeLocale;
	}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Pagination = _interopRequireDefault(__webpack_require__(1422));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Pagination["default"];
	exports["default"] = _default;

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validProgress = validProgress;
	
	// eslint-disable-next-line import/prefer-default-export
	function validProgress(progress) {
	  if (!progress || progress < 0) {
	    return 0;
	  }
	
	  if (progress > 100) {
	    return 100;
	  }
	
	  return progress;
	}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(187));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Radio = /*#__PURE__*/function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  var _super = _createSuper(Radio);
	
	  function Radio() {
	    var _this;
	
	    _classCallCheck(this, Radio);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.onChange = function (e) {
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	
	      if (_this.context.radioGroup && _this.context.radioGroup.onChange) {
	        _this.context.radioGroup.onChange(e);
	      }
	    };
	
	    _this.renderRadio = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          style = props.style,
	          restProps = __rest(props, ["prefixCls", "className", "children", "style"]);
	
	      var radioGroup = context.radioGroup;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	
	      var radioProps = _extends({}, restProps);
	
	      if (radioGroup) {
	        radioProps.name = radioGroup.name;
	        radioProps.onChange = _this.onChange;
	        radioProps.checked = props.value === radioGroup.value;
	        radioProps.disabled = props.disabled || radioGroup.disabled;
	      }
	
	      var wrapperClassString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _classNames));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: wrapperClassString,
	          style: style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, radioProps, {
	          prefixCls: prefixCls,
	          ref: _this.saveCheckbox
	        })), children !== undefined ? /*#__PURE__*/React.createElement("span", null, children) : null)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Radio, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.radioGroup, nextContext.radioGroup);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadio)
	      );
	    }
	  }]);
	
	  return Radio;
	}(React.Component);
	
	exports["default"] = Radio;
	Radio.defaultProps = {
	  type: 'radio'
	};
	Radio.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var locale = {
	  placeholder: 'Select time'
	};
	var _default = locale;
	exports["default"] = _default;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _findDOMNode = _interopRequireDefault(__webpack_require__(493));
	
	var _copyToClipboard = _interopRequireDefault(__webpack_require__(508));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _configProvider = __webpack_require__(15);
	
	var _context = __webpack_require__(255);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _transButton = _interopRequireDefault(__webpack_require__(375));
	
	var _raf = _interopRequireDefault(__webpack_require__(205));
	
	var _styleChecker = _interopRequireDefault(__webpack_require__(735));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(126));
	
	var _Typography = _interopRequireDefault(__webpack_require__(765));
	
	var _Editable = _interopRequireDefault(__webpack_require__(1471));
	
	var _util = _interopRequireDefault(__webpack_require__(1476));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var isLineClampSupport = (0, _styleChecker["default"])('webkitLineClamp');
	var isTextOverflowSupport = (0, _styleChecker["default"])('textOverflow');
	
	function wrapperDecorations(_ref, content) {
	  var mark = _ref.mark,
	      code = _ref.code,
	      underline = _ref.underline,
	      del = _ref["delete"],
	      strong = _ref.strong;
	  var currentContent = content;
	
	  function wrap(needed, tag) {
	    if (!needed) return;
	    currentContent = /*#__PURE__*/React.createElement(tag, {}, currentContent);
	  }
	
	  wrap(strong, 'strong');
	  wrap(underline, 'u');
	  wrap(del, 'del');
	  wrap(code, 'code');
	  wrap(mark, 'mark');
	  return currentContent;
	}
	
	var ELLIPSIS_STR = '...';
	
	var Base = /*#__PURE__*/function (_React$Component) {
	  _inherits(Base, _React$Component);
	
	  var _super = _createSuper(Base);
	
	  function Base() {
	    var _this;
	
	    _classCallCheck(this, Base);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      edit: false,
	      copied: false,
	      ellipsisText: '',
	      ellipsisContent: null,
	      isEllipsis: false,
	      expanded: false,
	      clientRendered: false
	    }; // =============== Expend ===============
	
	    _this.onExpandClick = function () {
	      var _this$getEllipsis = _this.getEllipsis(),
	          onExpand = _this$getEllipsis.onExpand;
	
	      _this.setState({
	        expanded: true
	      });
	
	      if (onExpand) {
	        onExpand();
	      }
	    }; // ================ Edit ================
	
	
	    _this.onEditClick = function () {
	      _this.triggerEdit(true);
	    };
	
	    _this.onEditChange = function (value) {
	      var _this$getEditable = _this.getEditable(),
	          onChange = _this$getEditable.onChange;
	
	      if (onChange) {
	        onChange(value);
	      }
	
	      _this.triggerEdit(false);
	    };
	
	    _this.onEditCancel = function () {
	      _this.triggerEdit(false);
	    }; // ================ Copy ================
	
	
	    _this.onCopyClick = function () {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          copyable = _this$props.copyable;
	
	      var copyConfig = _extends({}, _typeof(copyable) === 'object' ? copyable : null);
	
	      if (copyConfig.text === undefined) {
	        copyConfig.text = String(children);
	      }
	
	      (0, _copyToClipboard["default"])(copyConfig.text || '');
	
	      _this.setState({
	        copied: true
	      }, function () {
	        if (copyConfig.onCopy) {
	          copyConfig.onCopy();
	        }
	
	        _this.copyId = window.setTimeout(function () {
	          _this.setState({
	            copied: false
	          });
	        }, 3000);
	      });
	    };
	
	    _this.setContentRef = function (node) {
	      _this.content = node;
	    };
	
	    _this.setEditRef = function (node) {
	      _this.editIcon = node;
	    };
	
	    _this.triggerEdit = function (edit) {
	      var _this$getEditable2 = _this.getEditable(),
	          onStart = _this$getEditable2.onStart;
	
	      if (edit && onStart) {
	        onStart();
	      }
	
	      _this.setState({
	        edit: edit
	      }, function () {
	        if (!edit && _this.editIcon) {
	          _this.editIcon.focus();
	        }
	      });
	    }; // ============== Ellipsis ==============
	
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.rafId);
	
	      _this.rafId = (0, _raf["default"])(function () {
	        // Do not bind `syncEllipsis`. It need for test usage on prototype
	        _this.syncEllipsis();
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Base, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        clientRendered: true
	      });
	      this.resizeOnNextFrame();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var children = this.props.children;
	      var ellipsis = this.getEllipsis();
	      var prevEllipsis = this.getEllipsis(prevProps);
	
	      if (children !== prevProps.children || ellipsis.rows !== prevEllipsis.rows) {
	        this.resizeOnNextFrame();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.copyId);
	
	      _raf["default"].cancel(this.rafId);
	    }
	  }, {
	    key: "getEditable",
	    value: function getEditable(props) {
	      var edit = this.state.edit;
	
	      var _ref2 = props || this.props,
	          editable = _ref2.editable;
	
	      if (!editable) return {
	        editing: edit
	      };
	      return _extends({
	        editing: edit
	      }, _typeof(editable) === 'object' ? editable : null);
	    }
	  }, {
	    key: "getEllipsis",
	    value: function getEllipsis(props) {
	      var _ref3 = props || this.props,
	          ellipsis = _ref3.ellipsis;
	
	      if (!ellipsis) return {};
	      return _extends({
	        rows: 1,
	        expandable: false
	      }, _typeof(ellipsis) === 'object' ? ellipsis : null);
	    }
	  }, {
	    key: "canUseCSSEllipsis",
	    value: function canUseCSSEllipsis() {
	      var clientRendered = this.state.clientRendered;
	      var _this$props2 = this.props,
	          editable = _this$props2.editable,
	          copyable = _this$props2.copyable;
	
	      var _this$getEllipsis2 = this.getEllipsis(),
	          rows = _this$getEllipsis2.rows,
	          expandable = _this$getEllipsis2.expandable; // Can't use css ellipsis since we need to provide the place for button
	
	
	      if (editable || copyable || expandable || !clientRendered) {
	        return false;
	      }
	
	      if (rows === 1) {
	        return isTextOverflowSupport;
	      }
	
	      return isLineClampSupport;
	    }
	  }, {
	    key: "syncEllipsis",
	    value: function syncEllipsis() {
	      var _this$state = this.state,
	          ellipsisText = _this$state.ellipsisText,
	          isEllipsis = _this$state.isEllipsis,
	          expanded = _this$state.expanded;
	
	      var _this$getEllipsis3 = this.getEllipsis(),
	          rows = _this$getEllipsis3.rows;
	
	      var children = this.props.children;
	      if (!rows || rows < 0 || !this.content || expanded) return; // Do not measure if css already support ellipsis
	
	      if (this.canUseCSSEllipsis()) return;
	      (0, _warning["default"])((0, _toArray["default"])(children).every(function (child) {
	        return typeof child === 'string';
	      }), 'Typography', '`ellipsis` should use string as children only.');
	
	      var _measure = (0, _util["default"])((0, _findDOMNode["default"])(this.content), rows, children, this.renderOperations(true), ELLIPSIS_STR),
	          content = _measure.content,
	          text = _measure.text,
	          ellipsis = _measure.ellipsis;
	
	      if (ellipsisText !== text || isEllipsis !== ellipsis) {
	        this.setState({
	          ellipsisText: text,
	          ellipsisContent: content,
	          isEllipsis: ellipsis
	        });
	      }
	    }
	  }, {
	    key: "renderExpand",
	    value: function renderExpand(forceRender) {
	      var _this$getEllipsis4 = this.getEllipsis(),
	          expandable = _this$getEllipsis4.expandable;
	
	      var prefixCls = this.props.prefixCls;
	      var _this$state2 = this.state,
	          expanded = _this$state2.expanded,
	          isEllipsis = _this$state2.isEllipsis;
	      if (!expandable) return null; // force render expand icon for measure usage or it will cause dead loop
	
	      if (!forceRender && (expanded || !isEllipsis)) return null;
	      return (/*#__PURE__*/React.createElement("a", {
	          key: "expand",
	          className: "".concat(prefixCls, "-expand"),
	          onClick: this.onExpandClick,
	          "aria-label": this.expandStr
	        }, this.expandStr)
	      );
	    }
	  }, {
	    key: "renderEdit",
	    value: function renderEdit() {
	      var _this$props3 = this.props,
	          editable = _this$props3.editable,
	          prefixCls = _this$props3.prefixCls;
	      if (!editable) return;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          key: "edit",
	          title: this.editStr
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          ref: this.setEditRef,
	          className: "".concat(prefixCls, "-edit"),
	          onClick: this.onEditClick,
	          "aria-label": this.editStr
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          role: "button",
	          type: "edit"
	        })))
	      );
	    }
	  }, {
	    key: "renderCopy",
	    value: function renderCopy() {
	      var copied = this.state.copied;
	      var _this$props4 = this.props,
	          copyable = _this$props4.copyable,
	          prefixCls = _this$props4.prefixCls;
	      if (!copyable) return;
	      var title = copied ? this.copiedStr : this.copyStr;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          key: "copy",
	          title: title
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-copy"), copied && "".concat(prefixCls, "-copy-success")),
	          onClick: this.onCopyClick,
	          "aria-label": title
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          role: "button",
	          type: copied ? 'check' : 'copy'
	        })))
	      );
	    }
	  }, {
	    key: "renderEditInput",
	    value: function renderEditInput() {
	      var _this$props5 = this.props,
	          children = _this$props5.children,
	          prefixCls = _this$props5.prefixCls,
	          className = _this$props5.className,
	          style = _this$props5.style;
	      return (/*#__PURE__*/React.createElement(_Editable["default"], {
	          value: typeof children === 'string' ? children : '',
	          onSave: this.onEditChange,
	          onCancel: this.onEditCancel,
	          prefixCls: prefixCls,
	          className: className,
	          style: style
	        })
	      );
	    }
	  }, {
	    key: "renderOperations",
	    value: function renderOperations(forceRenderExpanded) {
	      return [this.renderExpand(forceRenderExpanded), this.renderEdit(), this.renderCopy()].filter(function (node) {
	        return node;
	      });
	    }
	  }, {
	    key: "renderContent",
	    value: function renderContent() {
	      var _this2 = this;
	
	      var _this$state3 = this.state,
	          ellipsisContent = _this$state3.ellipsisContent,
	          isEllipsis = _this$state3.isEllipsis,
	          expanded = _this$state3.expanded;
	
	      var _a = this.props,
	          component = _a.component,
	          children = _a.children,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          style = _a.style,
	          restProps = __rest(_a, ["component", "children", "className", "prefixCls", "type", "disabled", "style"]);
	
	      var _this$getEllipsis5 = this.getEllipsis(),
	          rows = _this$getEllipsis5.rows;
	
	      var textProps = (0, _omit["default"])(restProps, ['prefixCls', 'editable', 'copyable', 'ellipsis', 'mark', 'underline', 'mark', 'code', 'delete', 'underline', 'strong'].concat(_toConsumableArray(_configProvider.configConsumerProps)));
	      var cssEllipsis = this.canUseCSSEllipsis();
	      var cssTextOverflow = rows === 1 && cssEllipsis;
	      var cssLineClamp = rows && rows > 1 && cssEllipsis;
	      var textNode = children;
	      var ariaLabel = null; // Only use js ellipsis when css ellipsis not support
	
	      if (rows && isEllipsis && !expanded && !cssEllipsis) {
	        ariaLabel = String(children); // We move full content to outer element to avoid repeat read the content by accessibility
	
	        textNode = /*#__PURE__*/React.createElement("span", {
	          title: String(children),
	          "aria-hidden": "true"
	        }, ellipsisContent, ELLIPSIS_STR);
	      }
	
	      textNode = wrapperDecorations(this.props, textNode);
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Text"
	        }, function (_ref4) {
	          var _classNames;
	
	          var edit = _ref4.edit,
	              copyStr = _ref4.copy,
	              copied = _ref4.copied,
	              expand = _ref4.expand;
	          _this2.editStr = edit;
	          _this2.copyStr = copyStr;
	          _this2.copiedStr = copied;
	          _this2.expandStr = expand;
	          return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	              onResize: _this2.resizeOnNextFrame,
	              disabled: !rows
	            }, /*#__PURE__*/React.createElement(_Typography["default"], _extends({
	              className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis"), rows), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis-single-line"), cssTextOverflow), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis-multiple-line"), cssLineClamp), _classNames)),
	              style: _extends(_extends({}, style), {
	                WebkitLineClamp: cssLineClamp ? rows : null
	              }),
	              component: component,
	              ref: _this2.setContentRef,
	              "aria-label": ariaLabel
	            }, textProps), textNode, _this2.renderOperations()))
	          );
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$getEditable3 = this.getEditable(),
	          editing = _this$getEditable3.editing;
	
	      if (editing) {
	        return this.renderEditInput();
	      }
	
	      return this.renderContent();
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var children = nextProps.children,
	          editable = nextProps.editable;
	      (0, _warning["default"])(!editable || typeof children === 'string', 'Typography', 'When `editable` is enabled, the `children` should use string.');
	      return {};
	    }
	  }]);
	
	  return Base;
	}(React.Component);
	
	Base.defaultProps = {
	  children: ''
	};
	(0, _reactLifecyclesCompat.polyfill)(Base);
	
	var _default = (0, _context.withConfigConsumer)({
	  prefixCls: 'typography'
	})(Base);
	
	exports["default"] = _default;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  function doFold(cm, pos, options, force) {
	    if (options && options.call) {
	      var finder = options;
	      options = null;
	    } else {
	      var finder = getOption(cm, options, "rangeFinder");
	    }
	    if (typeof pos == "number") pos = CodeMirror.Pos(pos, 0);
	    var minSize = getOption(cm, options, "minFoldSize");
	
	    function getRange(allowFolded) {
	      var range = finder(cm, pos);
	      if (!range || range.to.line - range.from.line < minSize) return null;
	      if (force === "fold") return range;
	
	      var marks = cm.findMarksAt(range.from);
	      for (var i = 0; i < marks.length; ++i) {
	        if (marks[i].__isFold) {
	          if (!allowFolded) return null;
	          range.cleared = true;
	          marks[i].clear();
	        }
	      }
	      return range;
	    }
	
	    var range = getRange(true);
	    if (getOption(cm, options, "scanUp")) while (!range && pos.line > cm.firstLine()) {
	      pos = CodeMirror.Pos(pos.line - 1, 0);
	      range = getRange(false);
	    }
	    if (!range || range.cleared || force === "unfold") return;
	
	    var myWidget = makeWidget(cm, options, range);
	    CodeMirror.on(myWidget, "mousedown", function (e) {
	      myRange.clear();
	      CodeMirror.e_preventDefault(e);
	    });
	    var myRange = cm.markText(range.from, range.to, {
	      replacedWith: myWidget,
	      clearOnEnter: getOption(cm, options, "clearOnEnter"),
	      __isFold: true
	    });
	    myRange.on("clear", function (from, to) {
	      CodeMirror.signal(cm, "unfold", cm, from, to);
	    });
	    CodeMirror.signal(cm, "fold", cm, range.from, range.to);
	  }
	
	  function makeWidget(cm, options, range) {
	    var widget = getOption(cm, options, "widget");
	
	    if (typeof widget == "function") {
	      widget = widget(range.from, range.to);
	    }
	
	    if (typeof widget == "string") {
	      var text = document.createTextNode(widget);
	      widget = document.createElement("span");
	      widget.appendChild(text);
	      widget.className = "CodeMirror-foldmarker";
	    } else if (widget) {
	      widget = widget.cloneNode(true);
	    }
	    return widget;
	  }
	
	  // Clumsy backwards-compatible interface
	  CodeMirror.newFoldFunction = function (rangeFinder, widget) {
	    return function (cm, pos) {
	      doFold(cm, pos, { rangeFinder: rangeFinder, widget: widget });
	    };
	  };
	
	  // New-style interface
	  CodeMirror.defineExtension("foldCode", function (pos, options, force) {
	    doFold(this, pos, options, force);
	  });
	
	  CodeMirror.defineExtension("isFolded", function (pos) {
	    var marks = this.findMarksAt(pos);
	    for (var i = 0; i < marks.length; ++i) {
	      if (marks[i].__isFold) return true;
	    }
	  });
	
	  CodeMirror.commands.toggleFold = function (cm) {
	    cm.foldCode(cm.getCursor());
	  };
	  CodeMirror.commands.fold = function (cm) {
	    cm.foldCode(cm.getCursor(), null, "fold");
	  };
	  CodeMirror.commands.unfold = function (cm) {
	    cm.foldCode(cm.getCursor(), { scanUp: false }, "unfold");
	  };
	  CodeMirror.commands.foldAll = function (cm) {
	    cm.operation(function () {
	      for (var i = cm.firstLine(), e = cm.lastLine(); i <= e; i++) {
	        cm.foldCode(CodeMirror.Pos(i, 0), { scanUp: false }, "fold");
	      }
	    });
	  };
	  CodeMirror.commands.unfoldAll = function (cm) {
	    cm.operation(function () {
	      for (var i = cm.firstLine(), e = cm.lastLine(); i <= e; i++) {
	        cm.foldCode(CodeMirror.Pos(i, 0), { scanUp: false }, "unfold");
	      }
	    });
	  };
	
	  CodeMirror.registerHelper("fold", "combine", function () {
	    var funcs = Array.prototype.slice.call(arguments, 0);
	    return function (cm, start) {
	      for (var i = 0; i < funcs.length; ++i) {
	        var found = funcs[i](cm, start);
	        if (found) return found;
	      }
	    };
	  });
	
	  CodeMirror.registerHelper("fold", "auto", function (cm, start) {
	    var helpers = cm.getHelpers(start, "fold");
	    for (var i = 0; i < helpers.length; i++) {
	      var cur = helpers[i](cm, start);
	      if (cur) return cur;
	    }
	  });
	
	  var defaultOptions = {
	    rangeFinder: CodeMirror.fold.auto,
	    widget: "\u2194",
	    minFoldSize: 0,
	    scanUp: false,
	    clearOnEnter: true
	  };
	
	  CodeMirror.defineOption("foldOptions", null);
	
	  function getOption(cm, options, name) {
	    if (options && options[name] !== undefined) return options[name];
	    var editorOptions = cm.options.foldOptions;
	    if (editorOptions && editorOptions[name] !== undefined) return editorOptions[name];
	    return defaultOptions[name];
	  }
	
	  CodeMirror.defineExtension("foldOption", function (options, name) {
	    return getOption(this, options, name);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineExtension("annotateScrollbar", function (options) {
	    if (typeof options == "string") options = { className: options };
	    return new Annotation(this, options);
	  });
	
	  CodeMirror.defineOption("scrollButtonHeight", 0);
	
	  function Annotation(cm, options) {
	    this.cm = cm;
	    this.options = options;
	    this.buttonHeight = options.scrollButtonHeight || cm.getOption("scrollButtonHeight");
	    this.annotations = [];
	    this.doRedraw = this.doUpdate = null;
	    this.div = cm.getWrapperElement().appendChild(document.createElement("div"));
	    this.div.style.cssText = "position: absolute; right: 0; top: 0; z-index: 7; pointer-events: none";
	    this.computeScale();
	
	    function scheduleRedraw(delay) {
	      clearTimeout(self.doRedraw);
	      self.doRedraw = setTimeout(function () {
	        self.redraw();
	      }, delay);
	    }
	
	    var self = this;
	    cm.on("refresh", this.resizeHandler = function () {
	      clearTimeout(self.doUpdate);
	      self.doUpdate = setTimeout(function () {
	        if (self.computeScale()) scheduleRedraw(20);
	      }, 100);
	    });
	    cm.on("markerAdded", this.resizeHandler);
	    cm.on("markerCleared", this.resizeHandler);
	    if (options.listenForChanges !== false) cm.on("changes", this.changeHandler = function () {
	      scheduleRedraw(250);
	    });
	  }
	
	  Annotation.prototype.computeScale = function () {
	    var cm = this.cm;
	    var hScale = (cm.getWrapperElement().clientHeight - cm.display.barHeight - this.buttonHeight * 2) / cm.getScrollerElement().scrollHeight;
	    if (hScale != this.hScale) {
	      this.hScale = hScale;
	      return true;
	    }
	  };
	
	  Annotation.prototype.update = function (annotations) {
	    this.annotations = annotations;
	    this.redraw();
	  };
	
	  Annotation.prototype.redraw = function (compute) {
	    if (compute !== false) this.computeScale();
	    var cm = this.cm,
	        hScale = this.hScale;
	
	    var frag = document.createDocumentFragment(),
	        anns = this.annotations;
	
	    var wrapping = cm.getOption("lineWrapping");
	    var singleLineH = wrapping && cm.defaultTextHeight() * 1.5;
	    var curLine = null,
	        curLineObj = null;
	
	    function getY(pos, top) {
	      if (curLine != pos.line) {
	        curLine = pos.line;
	        curLineObj = cm.getLineHandle(pos.line);
	        var visual = cm.getLineHandleVisualStart(curLineObj);
	        if (visual != curLineObj) {
	          curLine = cm.getLineNumber(visual);
	          curLineObj = visual;
	        }
	      }
	      if (curLineObj.widgets && curLineObj.widgets.length || wrapping && curLineObj.height > singleLineH) return cm.charCoords(pos, "local")[top ? "top" : "bottom"];
	      var topY = cm.heightAtLine(curLineObj, "local");
	      return topY + (top ? 0 : curLineObj.height);
	    }
	
	    var lastLine = cm.lastLine();
	    if (cm.display.barWidth) for (var i = 0, nextTop; i < anns.length; i++) {
	      var ann = anns[i];
	      if (ann.to.line > lastLine) continue;
	      var top = nextTop || getY(ann.from, true) * hScale;
	      var bottom = getY(ann.to, false) * hScale;
	      while (i < anns.length - 1) {
	        if (anns[i + 1].to.line > lastLine) break;
	        nextTop = getY(anns[i + 1].from, true) * hScale;
	        if (nextTop > bottom + .9) break;
	        ann = anns[++i];
	        bottom = getY(ann.to, false) * hScale;
	      }
	      if (bottom == top) continue;
	      var height = Math.max(bottom - top, 3);
	
	      var elt = frag.appendChild(document.createElement("div"));
	      elt.style.cssText = "position: absolute; right: 0px; width: " + Math.max(cm.display.barWidth - 1, 2) + "px; top: " + (top + this.buttonHeight) + "px; height: " + height + "px";
	      elt.className = this.options.className;
	      if (ann.id) {
	        elt.setAttribute("annotation-id", ann.id);
	      }
	    }
	    this.div.textContent = "";
	    this.div.appendChild(frag);
	  };
	
	  Annotation.prototype.clear = function () {
	    this.cm.off("refresh", this.resizeHandler);
	    this.cm.off("markerAdded", this.resizeHandler);
	    this.cm.off("markerCleared", this.resizeHandler);
	    if (this.changeHandler) this.cm.off("changes", this.changeHandler);
	    this.div.parentNode.removeChild(this.div);
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41), __webpack_require__(392), __webpack_require__(390));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41), __webpack_require__(392), __webpack_require__(390)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineExtension("showMatchesOnScrollbar", function (query, caseFold, options) {
	    if (typeof options == "string") options = { className: options };
	    if (!options) options = {};
	    return new SearchAnnotation(this, query, caseFold, options);
	  });
	
	  function SearchAnnotation(cm, query, caseFold, options) {
	    this.cm = cm;
	    this.options = options;
	    var annotateOptions = { listenForChanges: false };
	    for (var prop in options) {
	      annotateOptions[prop] = options[prop];
	    }if (!annotateOptions.className) annotateOptions.className = "CodeMirror-search-match";
	    this.annotation = cm.annotateScrollbar(annotateOptions);
	    this.query = query;
	    this.caseFold = caseFold;
	    this.gap = { from: cm.firstLine(), to: cm.lastLine() + 1 };
	    this.matches = [];
	    this.update = null;
	
	    this.findMatches();
	    this.annotation.update(this.matches);
	
	    var self = this;
	    cm.on("change", this.changeHandler = function (_cm, change) {
	      self.onChange(change);
	    });
	  }
	
	  var MAX_MATCHES = 1000;
	
	  SearchAnnotation.prototype.findMatches = function () {
	    if (!this.gap) return;
	    for (var i = 0; i < this.matches.length; i++) {
	      var match = this.matches[i];
	      if (match.from.line >= this.gap.to) break;
	      if (match.to.line >= this.gap.from) this.matches.splice(i--, 1);
	    }
	    var cursor = this.cm.getSearchCursor(this.query, CodeMirror.Pos(this.gap.from, 0), { caseFold: this.caseFold, multiline: this.options.multiline });
	    var maxMatches = this.options && this.options.maxMatches || MAX_MATCHES;
	    while (cursor.findNext()) {
	      var match = { from: cursor.from(), to: cursor.to() };
	      if (match.from.line >= this.gap.to) break;
	      this.matches.splice(i++, 0, match);
	      if (this.matches.length > maxMatches) break;
	    }
	    this.gap = null;
	  };
	
	  function offsetLine(line, changeStart, sizeChange) {
	    if (line <= changeStart) return line;
	    return Math.max(changeStart, line + sizeChange);
	  }
	
	  SearchAnnotation.prototype.onChange = function (change) {
	    var startLine = change.from.line;
	    var endLine = CodeMirror.changeEnd(change).line;
	    var sizeChange = endLine - change.to.line;
	    if (this.gap) {
	      this.gap.from = Math.min(offsetLine(this.gap.from, startLine, sizeChange), change.from.line);
	      this.gap.to = Math.max(offsetLine(this.gap.to, startLine, sizeChange), change.from.line);
	    } else {
	      this.gap = { from: change.from.line, to: endLine + 1 };
	    }
	
	    if (sizeChange) for (var i = 0; i < this.matches.length; i++) {
	      var match = this.matches[i];
	      var newFrom = offsetLine(match.from.line, startLine, sizeChange);
	      if (newFrom != match.from.line) match.from = CodeMirror.Pos(newFrom, match.from.ch);
	      var newTo = offsetLine(match.to.line, startLine, sizeChange);
	      if (newTo != match.to.line) match.to = CodeMirror.Pos(newTo, match.to.ch);
	    }
	    clearTimeout(this.update);
	    var self = this;
	    this.update = setTimeout(function () {
	      self.updateAfterChange();
	    }, 250);
	  };
	
	  SearchAnnotation.prototype.updateAfterChange = function () {
	    this.findMatches();
	    this.annotation.update(this.matches);
	  };
	
	  SearchAnnotation.prototype.clear = function () {
	    this.cm.off("change", this.changeHandler);
	    this.annotation.clear();
	  };
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var Pos = CodeMirror.Pos;
	
	  function regexpFlags(regexp) {
	    var flags = regexp.flags;
	    return flags != null ? flags : (regexp.ignoreCase ? "i" : "") + (regexp.global ? "g" : "") + (regexp.multiline ? "m" : "");
	  }
	
	  function ensureFlags(regexp, flags) {
	    var current = regexpFlags(regexp),
	        target = current;
	    for (var i = 0; i < flags.length; i++) {
	      if (target.indexOf(flags.charAt(i)) == -1) target += flags.charAt(i);
	    }return current == target ? regexp : new RegExp(regexp.source, target);
	  }
	
	  function maybeMultiline(regexp) {
	    return (/\\s|\\n|\n|\\W|\\D|\[\^/.test(regexp.source)
	    );
	  }
	
	  function searchRegexpForward(doc, regexp, start) {
	    regexp = ensureFlags(regexp, "g");
	    for (var line = start.line, ch = start.ch, last = doc.lastLine(); line <= last; line++, ch = 0) {
	      regexp.lastIndex = ch;
	      var string = doc.getLine(line),
	          match = regexp.exec(string);
	      if (match) return { from: Pos(line, match.index),
	        to: Pos(line, match.index + match[0].length),
	        match: match };
	    }
	  }
	
	  function searchRegexpForwardMultiline(doc, regexp, start) {
	    if (!maybeMultiline(regexp)) return searchRegexpForward(doc, regexp, start);
	
	    regexp = ensureFlags(regexp, "gm");
	    var string,
	        chunk = 1;
	    for (var line = start.line, last = doc.lastLine(); line <= last;) {
	      // This grows the search buffer in exponentially-sized chunks
	      // between matches, so that nearby matches are fast and don't
	      // require concatenating the whole document (in case we're
	      // searching for something that has tons of matches), but at the
	      // same time, the amount of retries is limited.
	      for (var i = 0; i < chunk; i++) {
	        if (line > last) break;
	        var curLine = doc.getLine(line++);
	        string = string == null ? curLine : string + "\n" + curLine;
	      }
	      chunk = chunk * 2;
	      regexp.lastIndex = start.ch;
	      var match = regexp.exec(string);
	      if (match) {
	        var before = string.slice(0, match.index).split("\n"),
	            inside = match[0].split("\n");
	        var startLine = start.line + before.length - 1,
	            startCh = before[before.length - 1].length;
	        return { from: Pos(startLine, startCh),
	          to: Pos(startLine + inside.length - 1, inside.length == 1 ? startCh + inside[0].length : inside[inside.length - 1].length),
	          match: match };
	      }
	    }
	  }
	
	  function lastMatchIn(string, regexp, endMargin) {
	    var match,
	        from = 0;
	    while (from <= string.length) {
	      regexp.lastIndex = from;
	      var newMatch = regexp.exec(string);
	      if (!newMatch) break;
	      var end = newMatch.index + newMatch[0].length;
	      if (end > string.length - endMargin) break;
	      if (!match || end > match.index + match[0].length) match = newMatch;
	      from = newMatch.index + 1;
	    }
	    return match;
	  }
	
	  function searchRegexpBackward(doc, regexp, start) {
	    regexp = ensureFlags(regexp, "g");
	    for (var line = start.line, ch = start.ch, first = doc.firstLine(); line >= first; line--, ch = -1) {
	      var string = doc.getLine(line);
	      var match = lastMatchIn(string, regexp, ch < 0 ? 0 : string.length - ch);
	      if (match) return { from: Pos(line, match.index),
	        to: Pos(line, match.index + match[0].length),
	        match: match };
	    }
	  }
	
	  function searchRegexpBackwardMultiline(doc, regexp, start) {
	    if (!maybeMultiline(regexp)) return searchRegexpBackward(doc, regexp, start);
	    regexp = ensureFlags(regexp, "gm");
	    var string,
	        chunkSize = 1,
	        endMargin = doc.getLine(start.line).length - start.ch;
	    for (var line = start.line, first = doc.firstLine(); line >= first;) {
	      for (var i = 0; i < chunkSize && line >= first; i++) {
	        var curLine = doc.getLine(line--);
	        string = string == null ? curLine : curLine + "\n" + string;
	      }
	      chunkSize *= 2;
	
	      var match = lastMatchIn(string, regexp, endMargin);
	      if (match) {
	        var before = string.slice(0, match.index).split("\n"),
	            inside = match[0].split("\n");
	        var startLine = line + before.length,
	            startCh = before[before.length - 1].length;
	        return { from: Pos(startLine, startCh),
	          to: Pos(startLine + inside.length - 1, inside.length == 1 ? startCh + inside[0].length : inside[inside.length - 1].length),
	          match: match };
	      }
	    }
	  }
	
	  var doFold, noFold;
	  if (String.prototype.normalize) {
	    doFold = function doFold(str) {
	      return str.normalize("NFD").toLowerCase();
	    };
	    noFold = function noFold(str) {
	      return str.normalize("NFD");
	    };
	  } else {
	    doFold = function doFold(str) {
	      return str.toLowerCase();
	    };
	    noFold = function noFold(str) {
	      return str;
	    };
	  }
	
	  // Maps a position in a case-folded line back to a position in the original line
	  // (compensating for codepoints increasing in number during folding)
	  function adjustPos(orig, folded, pos, foldFunc) {
	    if (orig.length == folded.length) return pos;
	    for (var min = 0, max = pos + Math.max(0, orig.length - folded.length);;) {
	      if (min == max) return min;
	      var mid = min + max >> 1;
	      var len = foldFunc(orig.slice(0, mid)).length;
	      if (len == pos) return mid;else if (len > pos) max = mid;else min = mid + 1;
	    }
	  }
	
	  function searchStringForward(doc, query, start, caseFold) {
	    // Empty string would match anything and never progress, so we
	    // define it to match nothing instead.
	    if (!query.length) return null;
	    var fold = caseFold ? doFold : noFold;
	    var lines = fold(query).split(/\r|\n\r?/);
	
	    search: for (var line = start.line, ch = start.ch, last = doc.lastLine() + 1 - lines.length; line <= last; line++, ch = 0) {
	      var orig = doc.getLine(line).slice(ch),
	          string = fold(orig);
	      if (lines.length == 1) {
	        var found = string.indexOf(lines[0]);
	        if (found == -1) continue search;
	        var start = adjustPos(orig, string, found, fold) + ch;
	        return { from: Pos(line, adjustPos(orig, string, found, fold) + ch),
	          to: Pos(line, adjustPos(orig, string, found + lines[0].length, fold) + ch) };
	      } else {
	        var cutFrom = string.length - lines[0].length;
	        if (string.slice(cutFrom) != lines[0]) continue search;
	        for (var i = 1; i < lines.length - 1; i++) {
	          if (fold(doc.getLine(line + i)) != lines[i]) continue search;
	        }var end = doc.getLine(line + lines.length - 1),
	            endString = fold(end),
	            lastLine = lines[lines.length - 1];
	        if (endString.slice(0, lastLine.length) != lastLine) continue search;
	        return { from: Pos(line, adjustPos(orig, string, cutFrom, fold) + ch),
	          to: Pos(line + lines.length - 1, adjustPos(end, endString, lastLine.length, fold)) };
	      }
	    }
	  }
	
	  function searchStringBackward(doc, query, start, caseFold) {
	    if (!query.length) return null;
	    var fold = caseFold ? doFold : noFold;
	    var lines = fold(query).split(/\r|\n\r?/);
	
	    search: for (var line = start.line, ch = start.ch, first = doc.firstLine() - 1 + lines.length; line >= first; line--, ch = -1) {
	      var orig = doc.getLine(line);
	      if (ch > -1) orig = orig.slice(0, ch);
	      var string = fold(orig);
	      if (lines.length == 1) {
	        var found = string.lastIndexOf(lines[0]);
	        if (found == -1) continue search;
	        return { from: Pos(line, adjustPos(orig, string, found, fold)),
	          to: Pos(line, adjustPos(orig, string, found + lines[0].length, fold)) };
	      } else {
	        var lastLine = lines[lines.length - 1];
	        if (string.slice(0, lastLine.length) != lastLine) continue search;
	        for (var i = 1, start = line - lines.length + 1; i < lines.length - 1; i++) {
	          if (fold(doc.getLine(start + i)) != lines[i]) continue search;
	        }var top = doc.getLine(line + 1 - lines.length),
	            topString = fold(top);
	        if (topString.slice(topString.length - lines[0].length) != lines[0]) continue search;
	        return { from: Pos(line + 1 - lines.length, adjustPos(top, topString, top.length - lines[0].length, fold)),
	          to: Pos(line, adjustPos(orig, string, lastLine.length, fold)) };
	      }
	    }
	  }
	
	  function SearchCursor(doc, query, pos, options) {
	    this.atOccurrence = false;
	    this.afterEmptyMatch = false;
	    this.doc = doc;
	    pos = pos ? doc.clipPos(pos) : Pos(0, 0);
	    this.pos = { from: pos, to: pos };
	
	    var caseFold;
	    if ((typeof options === "undefined" ? "undefined" : _typeof(options)) == "object") {
	      caseFold = options.caseFold;
	    } else {
	      // Backwards compat for when caseFold was the 4th argument
	      caseFold = options;
	      options = null;
	    }
	
	    if (typeof query == "string") {
	      if (caseFold == null) caseFold = false;
	      this.matches = function (reverse, pos) {
	        return (reverse ? searchStringBackward : searchStringForward)(doc, query, pos, caseFold);
	      };
	    } else {
	      query = ensureFlags(query, "gm");
	      if (!options || options.multiline !== false) this.matches = function (reverse, pos) {
	        return (reverse ? searchRegexpBackwardMultiline : searchRegexpForwardMultiline)(doc, query, pos);
	      };else this.matches = function (reverse, pos) {
	        return (reverse ? searchRegexpBackward : searchRegexpForward)(doc, query, pos);
	      };
	    }
	  }
	
	  SearchCursor.prototype = {
	    findNext: function findNext() {
	      return this.find(false);
	    },
	    findPrevious: function findPrevious() {
	      return this.find(true);
	    },
	
	    find: function find(reverse) {
	      var head = this.doc.clipPos(reverse ? this.pos.from : this.pos.to);
	      if (this.afterEmptyMatch && this.atOccurrence) {
	        // do not return the same 0 width match twice
	        head = Pos(head.line, head.ch);
	        if (reverse) {
	          head.ch--;
	          if (head.ch < 0) {
	            head.line--;
	            head.ch = (this.doc.getLine(head.line) || "").length;
	          }
	        } else {
	          head.ch++;
	          if (head.ch > (this.doc.getLine(head.line) || "").length) {
	            head.ch = 0;
	            head.line++;
	          }
	        }
	        if (CodeMirror.cmpPos(head, this.doc.clipPos(head)) != 0) {
	          return this.atOccurrence = false;
	        }
	      }
	      var result = this.matches(reverse, head);
	      this.afterEmptyMatch = result && CodeMirror.cmpPos(result.from, result.to) == 0;
	
	      if (result) {
	        this.pos = result;
	        this.atOccurrence = true;
	        return this.pos.match || true;
	      } else {
	        var end = Pos(reverse ? this.doc.firstLine() : this.doc.lastLine() + 1, 0);
	        this.pos = { from: end, to: end };
	        return this.atOccurrence = false;
	      }
	    },
	
	    from: function from() {
	      if (this.atOccurrence) return this.pos.from;
	    },
	    to: function to() {
	      if (this.atOccurrence) return this.pos.to;
	    },
	
	    replace: function replace(newText, origin) {
	      if (!this.atOccurrence) return;
	      var lines = CodeMirror.splitLines(newText);
	      this.doc.replaceRange(lines, this.pos.from, this.pos.to, origin);
	      this.pos.to = Pos(this.pos.from.line + lines.length - 1, lines[lines.length - 1].length + (lines.length == 1 ? this.pos.from.ch : 0));
	    }
	  };
	
	  CodeMirror.defineExtension("getSearchCursor", function (query, pos, caseFold) {
	    return new SearchCursor(this.doc, query, pos, caseFold);
	  });
	  CodeMirror.defineDocExtension("getSearchCursor", function (query, pos, caseFold) {
	    return new SearchCursor(this, query, pos, caseFold);
	  });
	
	  CodeMirror.defineExtension("selectMatches", function (query, caseFold) {
	    var ranges = [];
	    var cur = this.getSearchCursor(query, this.getCursor("from"), caseFold);
	    while (cur.findNext()) {
	      if (CodeMirror.cmpPos(cur.to(), this.getCursor("to")) > 0) break;
	      ranges.push({ anchor: cur.from(), head: cur.to() });
	    }
	    if (ranges.length) this.setSelections(ranges, 0);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(165);
	var Danger = __webpack_require__(1499);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactInstrumentation = __webpack_require__(94);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(402);
	var setInnerHTML = __webpack_require__(264);
	var setTextContent = __webpack_require__(787);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function dangerouslyReplaceNodeWithMarkup(oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function processUpdates(parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function injectEventPluginOrder(injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function injectEventPluginsByName(injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function getPluginModuleForEvent(event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function _resetEventPlugins() {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactErrorUtils = __webpack_require__(400);
	
	var invariant = __webpack_require__(32);
	var warning = __webpack_require__(44);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function injectComponentTree(Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function injectTreeTraversal(Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function validateEventDispatches(event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function getInstanceFromNode(node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function getNodeFromInstance(node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function isAncestor(a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function getLowestCommonAncestor(a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function getParentInstance(inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function traverseTwoPhase(target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactPropTypesSecret = __webpack_require__(1528);
	var propTypesFactory = __webpack_require__(500);
	
	var React = __webpack_require__(168);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(32);
	var warning = __webpack_require__(44);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function value(props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function checked(props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function checkPropTypes(tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function getValue(inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function getChecked(inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function executeOnChange(inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function injectEnvironment(environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function rethrowCaughtError() {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function boundFunc() {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactCurrentOwner = __webpack_require__(112);
	var ReactInstanceMap = __webpack_require__(211);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactUpdates = __webpack_require__(101);
	
	var invariant = __webpack_require__(32);
	var warning = __webpack_require__(44);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function isMounted(publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function enqueueCallback(publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function enqueueCallbackInternal(internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function enqueueForceUpdate(publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function enqueueSetState(publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function enqueueElementInternal(internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function validateCallback(callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(90);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement === 'undefined' ? 'undefined' : _typeof(prevElement);
	  var nextType = typeof nextElement === 'undefined' ? 'undefined' : _typeof(nextElement);
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var emptyFunction = __webpack_require__(120);
	var warning = __webpack_require__(44);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function updatedAncestorInfo(oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function findOwnerStack(instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function validateDOMNesting(childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.datePickerOnChange = exports.teOnBlur = exports.updateCode = exports.checkOnChange = exports.selectOnChange = exports.numberOnChange = exports.textOnChange = exports.formItemLayout = exports.getDSDEditor = exports.getDSDModal = exports.getSelectOptions = exports.getRPModal = exports.getRPEditor = exports.getSCModal = exports.getSCEditor = exports.getShowEditor = exports.getFunEditor = exports.getCommAttEditor = exports.getFormCommAttEditor = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _antd = __webpack_require__(206);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dnd_SgiAllEditorCommon = __webpack_require__(1569);
	
	var _Dnd_SgiFormEditorCommonUtils = __webpack_require__(794);
	
	var _Dnd_SgiFormEditorRPSelect = __webpack_require__(1571);
	
	var _Dnd_SgiFormEditorRPSelect2 = _interopRequireDefault(_Dnd_SgiFormEditorRPSelect);
	
	var _Dnd_SgiFormEditorSCSelect = __webpack_require__(1572);
	
	var _Dnd_SgiFormEditorSCSelect2 = _interopRequireDefault(_Dnd_SgiFormEditorSCSelect);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _ObjFactory2 = _interopRequireDefault(_ObjFactory);
	
	var _SgiMainComp = __webpack_require__(125);
	
	var _SgiMainComp2 = _interopRequireDefault(_SgiMainComp);
	
	var _smProjDndConfig = __webpack_require__(240);
	
	var _smProjDndConfig2 = _interopRequireDefault(_smProjDndConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var TabPane = _antd.Tabs.TabPane;
	var Search = _antd.Input.Search;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	
	var getFormCommAttEditor = function getFormCommAttEditor(currentModule, type) {
	    return (0, _Dnd_SgiFormEditorCommonUtils.getEditor)(currentModule, type);
	};
	var getCommAttEditor = function getCommAttEditor(currentModule, type) {
	    return (0, _Dnd_SgiFormEditorCommonUtils.getEditor)(currentModule, type);
	};
	
	var getSCEditor = function getSCEditor(currentModule, label, attname) {
	    //标准代码
	    label = label || "标准代码";
	    attname = attname || "scId";
	    return _react2.default.createElement(
	        _antd.Col,
	        { span: 8 },
	        _react2.default.createElement(
	            FormItem,
	            _extends({}, _Dnd_SgiFormEditorCommonUtils.formItemLayout, { label: label }),
	            _react2.default.createElement(Search, { value: currentModule.state.values[attname],
	                placeholder: "请选择" + label,
	                onChange: _Dnd_SgiFormEditorCommonUtils.textOnChange.bind(undefined, currentModule, attname),
	                onSearch: function onSearch() {
	                    return currentModule.setState({ SCModalVisible: true });
	                } })
	        )
	    );
	};
	var getDSDEditor = function getDSDEditor(currentModule, label, attname) {
	    //标准代码
	    label = label || "绑定DSD";
	    attname = attname || "dsdId";
	    var value = currentModule.state.values[attname];
	    // let onSearch = (e) => {
	    //     let guid = sgiConfig.DSDChooseUI || "rtsd_UI_DSD_2001";
	    //     tool.popUI(guid, new ObjFactory(guid, { currentModule }));
	    // };
	    var onClick = function onClick(guid, e) {
	        window.setProOnlyUuid();
	        window.open((sgiConfig.DSDUI2 || "/main/DSDUI2") + "?dsdId=" + guid);
	    };
	    return _react2.default.createElement(
	        _antd.Col,
	        { span: 8 },
	        _react2.default.createElement(
	            FormItem,
	            _extends({}, _Dnd_SgiFormEditorCommonUtils.formItemLayout, { label: label, style: { display: "flex" } }),
	            _react2.default.createElement(
	                'div',
	                { style: { display: "flex" } },
	                _react2.default.createElement(Search, { value: value,
	                    placeholder: "-请选择-",
	                    onChange: _Dnd_SgiFormEditorCommonUtils.textOnChange.bind(undefined, currentModule, attname),
	                    onSearch: function onSearch() {
	                        return currentModule.setState({ DSDModalVisible: true });
	                    }
	                    // onSearch={onSearch}
	                }),
	                _react2.default.createElement(
	                    _antd.Tooltip,
	                    { title: '\u70B9\u51FB\u8DF3\u8F6C\u81F3DSD\u7F16\u8F91\u9875\u9762' },
	                    _react2.default.createElement(_antd.Button, { icon: 'link', style: { marginLeft: 5 }, onClick: onClick.bind(undefined, value) })
	                )
	            )
	        )
	    );
	};
	
	var getSCModal = function getSCModal(currentModule, attname) {
	    attname = attname || "scId";
	    return _react2.default.createElement(
	        _antd.Modal,
	        {
	            title: '\u9009\u62E9\u6807\u51C6\u4EE3\u7801\uFF08\u53CC\u51FB\u9009\u62E9\uFF09',
	            visible: currentModule.state.SCModalVisible,
	            onCancel: function onCancel() {
	                return currentModule.setState({ SCModalVisible: false });
	            },
	            width: '1000px',
	            height: '800px',
	            footer: null
	        },
	        _react2.default.createElement(_Dnd_SgiFormEditorSCSelect2.default, { parentModule: currentModule, attname: attname })
	    );
	};
	var getDSDModal = function getDSDModal(currentModule, attname) {
	    // let guid = sgiConfig.DSDChooseUI || "rtsd_UI_DSD_2001";
	    var guid = sgiConfig.DSDChooseUI || _smProjDndConfig2.default.getDSDSelectGuid();
	    var moduleDesc = PrmFactory.getPrm(guid);
	    attname = attname || "bdDvId";
	    return _react2.default.createElement(
	        _antd.Modal,
	        {
	            title: moduleDesc ? moduleDesc.te || '选择DSD（双击选择）' : '选择DSD（双击选择）',
	            visible: currentModule.state.DSDModalVisible,
	            onCancel: function onCancel() {
	                return currentModule.setState({ DSDModalVisible: false });
	            },
	            width: '80%',
	            height: 800,
	            footer: null
	        },
	        moduleDesc && moduleDesc.guid ? _react2.default.createElement(_SgiMainComp2.default
	        // ref={'Dnd_SgiMainComp_SgiMainComp'}
	        , { objFct: new _ObjFactory2.default(guid, { currentModule: currentModule, attname: attname, tt: "DSD", visibleKey: "DSDModalVisible" }),
	            type: currentModule.props.type,
	            dndDispatchObject: currentModule.props.dndDispatchObject,
	            moduleDesc: moduleDesc }) : _react2.default.createElement(_Dnd_SgiFormEditorSCSelect2.default, { parentModule: currentModule, attname: attname, tt: 'DSD', visibleKey: 'DSDModalVisible' })
	    );
	};
	
	var getRPEditor = function getRPEditor(currentModule, label, attname) {
	    //资源代码
	    label = label || "资源代码";
	    return _react2.default.createElement(
	        _antd.Col,
	        { span: 8 },
	        _react2.default.createElement(
	            FormItem,
	            _extends({}, _Dnd_SgiFormEditorCommonUtils.formItemLayout, { label: label }),
	            _react2.default.createElement(Search, { value: currentModule.state.values[attname], onChange: _Dnd_SgiFormEditorCommonUtils.textOnChange.bind(undefined, currentModule, attname),
	                onSearch: function onSearch() {
	                    return currentModule.setState({ RPModalVisible: true });
	                } })
	        )
	    );
	};
	
	var getRPModal = function getRPModal(currentModule, type, attname) {
	    return _react2.default.createElement(
	        _antd.Modal,
	        {
	            title: '\u9009\u62E9\u8D44\u6E90\u4EE3\u7801\uFF08\u53CC\u51FB\u9009\u62E9\uFF09',
	            visible: currentModule.state.RPModalVisible,
	            onCancel: function onCancel() {
	                return currentModule.setState({ RPModalVisible: false });
	            },
	            width: '1000px',
	            height: '800px',
	            footer: null
	        },
	        _react2.default.createElement(_Dnd_SgiFormEditorRPSelect2.default, { parentModule: currentModule, type: type, attname: attname })
	    );
	};
	
	var getStyleEditor = function getStyleEditor(currentModule) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            'function("module", "objFct")'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            'form\u5B50\u7EC4\u4EF6\u793A\u4F8B\uFF1Areturn ',
	            "{ formItemStyle: { background: \"#eeeeee\" }, inputStyle: { border: \"2px solid red\" } }"
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            '\u666E\u901A\u7EC4\u4EF6\u793A\u4F8B\uFF1Areturn ',
	            "{ background: \"#eeeeee\" }"
	        ),
	        (0, _Dnd_SgiAllEditorCommon.getCodeMirror)(currentModule.state.values.cstmStyle, _Dnd_SgiFormEditorCommonUtils.updateCode.bind(undefined, currentModule, 'cstmStyle'), currentModule.props.values.dnd_id)
	    );
	};
	
	var getRenderEditor = function getRenderEditor(currentModule) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            'function(module,inputprops,value,objFct)'
	        ),
	        _react2.default.createElement(
	            'span',
	            null,
	            '\u8BF7\u8FD4\u56DE\u81EA\u5B9A\u4E49\u7EC4\u4EF6\uFF0C\u4F8B\uFF1Areturn tool.createElement("a", props, children, customModuleFlg);'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            'props\uFF1A\u7EC4\u4EF6\u5C5E\u6027\uFF1Bchildren\uFF1A\u5B50\u7EC4\u4EF6\u6570\u7EC4\uFF1BcustomModuleFlg\uFF1A\u662F\u5426\u662F\u81EA\u5B9A\u4E49\u7EC4\u4EF6\uFF0C\u5982\u679C\u662Fhtml\u7EC4\u4EF6\u8BE5\u53C2\u6570\u4E0D\u586B'
	        ),
	        (0, _Dnd_SgiAllEditorCommon.getCodeMirror)(currentModule.state.values.cstmRender, _Dnd_SgiFormEditorCommonUtils.updateCode.bind(currentModule, currentModule, 'cstmRender'), currentModule.state.values.dnd_id + "cstmRender")
	    );
	};
	
	var getValidEditor = function getValidEditor(currentModule) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _antd.Checkbox,
	            { style: { marginLeft: 60, marginBottom: 10 },
	                checked: currentModule.state.values["showCheck"], onChange: _Dnd_SgiFormEditorCommonUtils.checkOnChange.bind(currentModule, currentModule, "showCheck") },
	            '\u6821\u9A8C\u6210\u529F\u663E\u793A\u5BF9\u53F7'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            'function(module,objFct,value)'
	        ),
	        _react2.default.createElement(
	            'span',
	            null,
	            '\u57FA\u7840\u7528\u6CD5\uFF1A\u5982\u6821\u9A8C\u5931\u8D25\uFF0C\u8BF7\u8FD4\u56DE\u5931\u8D25\u4FE1\u606F\uFF1B\u6821\u9A8C\u6210\u529F\u8BF7\u8FD4\u56DE\u7A7A\u3002\u4F8B\uFF1A\'if (value === "12") return "\u4E0D\u80FD\u8F93\u516512"\''
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { color: "peru" } },
	            '\u9AD8\u7EA7\u7528\u6CD5\uFF1A\u53EF\u8FD4\u56DE\u81EA\u5B9A\u4E49\u6821\u9A8C\u5BF9\u8C61\uFF0C\u4F8B\uFF1A\'return ',
	            '{help:"请输入数字和字母的组合", validateStatus:"warning", hasFeedback:true}',
	            '\''
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { color: "peru" } },
	            '\u6CE8\uFF1Ahelp\u4E3A\u63D0\u793A\u4FE1\u606F\uFF0CvalidateStatus\u4E3A\u6821\u9A8C\u72B6\u6001(\u53EF\u9009 \'success\', \'warning\', \'error\', \'validating\')\uFF0ChasFeedback\u4E3A\u662F\u5426\u663E\u793A\u6821\u9A8C\u7ED3\u679C\u56FE\u6807\uFF0C',
	            _react2.default.createElement(
	                'a',
	                { href: 'https://ant.design/components/form-cn/#components-form-demo-validate-static', target: '_blank',
	                    style: { textDecoration: "underline", fontStyle: "italic" } },
	                '\u8BE6\u60C5>'
	            )
	        ),
	        (0, _Dnd_SgiAllEditorCommon.getCodeMirror)(currentModule.state.values.cstmValid, _Dnd_SgiFormEditorCommonUtils.updateCode.bind(currentModule, currentModule, 'cstmValid'), currentModule.state.values.dnd_id + "cstmValid")
	    );
	};
	
	var getFunEditor = function getFunEditor(currentModule, others) {
	    var moduleType = currentModule.props._name || currentModule.props.currentCtl.props.modal_context;
	    var chngTip = void 0;
	    switch (moduleType) {
	        case "Dnd_SgiFormFileEditor":
	            // 文件上传
	            chngTip = _react2.default.createElement(
	                'div',
	                null,
	                'function("module", "objFct", "record", "nv", "file", "response", "fileList")'
	            );
	            break;
	        case "Dnd_SgiFormCodeMirrorEditor":
	            // codemirror
	            chngTip = _react2.default.createElement(
	                'div',
	                null,
	                'function("module", "objFct", "record", "nv", "data", "editor")'
	            );
	            break;
	        default:
	            chngTip = _react2.default.createElement(
	                'div',
	                null,
	                'function("module", "objFct", "record", "nv", "nt", "itemData", "extra")'
	            );
	            break;
	    }
	    return _react2.default.createElement(
	        _antd.Collapse,
	        { defaultActiveKey: ['2'], accordion: true },
	        _react2.default.createElement(
	            Panel,
	            { header: '\u8FDB\u5165\u4E8B\u4EF6', key: '1' },
	            _react2.default.createElement(
	                'div',
	                null,
	                'function("module", "objFct")'
	            ),
	            (0, _Dnd_SgiAllEditorCommon.getCodeMirror)(currentModule.state.values.inLsn, _Dnd_SgiFormEditorCommonUtils.updateCode.bind(undefined, currentModule, 'inLsn'), currentModule.props.values.dnd_id)
	        ),
	        _react2.default.createElement(
	            Panel,
	            { header: '\u4FEE\u6539\u4E8B\u4EF6', key: '2' },
	            chngTip,
	            (0, _Dnd_SgiAllEditorCommon.getCodeMirror)(currentModule.state.values.chgLsn, _Dnd_SgiFormEditorCommonUtils.updateCode.bind(undefined, currentModule, 'chgLsn'), currentModule.props.values.dnd_id)
	        ),
	        _react2.default.createElement(
	            Panel,
	            { header: '\u79BB\u5F00\u4E8B\u4EF6', key: '3' },
	            _react2.default.createElement(
	                'div',
	                null,
	                'function("module", "objFct")'
	            ),
	            (0, _Dnd_SgiAllEditorCommon.getCodeMirror)(currentModule.state.values.lveLsn, _Dnd_SgiFormEditorCommonUtils.updateCode.bind(undefined, currentModule, 'lveLsn'), currentModule.props.values.dnd_id)
	        ),
	        others
	    );
	};
	
	var getShowEditor = function getShowEditor(currentModule, attEditor, funEditor, others) {
	    var showType = currentModule.props.showType;
	    var tabPaneStyle = { height: "100%", overflow: "auto" };
	    if (checkShowType("1")) attEditor = attEditor || getCommAttEditor(currentModule, currentModule.props._name || currentModule.props.currentCtl.props.modal_context);
	    if (checkShowType("2")) funEditor = funEditor || getFunEditor(currentModule);
	    return _react2.default.createElement(
	        _antd.Tabs,
	        { defaultActiveKey: '1', tabBarGutter: 0, style: { height: "100%" } },
	        checkShowType("1") ? _react2.default.createElement(
	            TabPane,
	            { style: tabPaneStyle, tab: '\u5C5E\u6027\u7F16\u8F91', key: '1' },
	            attEditor
	        ) : null,
	        checkShowType("2") ? _react2.default.createElement(
	            TabPane,
	            { style: tabPaneStyle, tab: '\u7ED1\u5B9A\u4E8B\u4EF6', key: '2' },
	            funEditor
	        ) : null,
	        checkShowType("3") ? _react2.default.createElement(
	            TabPane,
	            { style: tabPaneStyle, tab: '\u81EA\u5B9A\u4E49\u663E\u793A\u6837\u5F0F', key: '3' },
	            getStyleEditor(currentModule)
	        ) : null,
	        checkShowType("4") ? _react2.default.createElement(
	            TabPane,
	            { style: tabPaneStyle, tab: '\u81EA\u5B9A\u4E49\u6E32\u67D3\u7EC4\u4EF6', key: '4' },
	            getRenderEditor(currentModule)
	        ) : null,
	        checkShowType("5") ? _react2.default.createElement(
	            TabPane,
	            { style: tabPaneStyle, tab: '\u81EA\u5B9A\u4E49\u6821\u9A8C\u89C4\u5219', key: '5' },
	            getValidEditor(currentModule)
	        ) : null,
	        checkShowType("0") ? others : null
	    );
	    function checkShowType(num) {
	        return !showType || showType.indexOf(num) > -1 || showType.indexOf(parseInt(num)) > -1;
	    }
	};
	
	var getSelectOptions = function getSelectOptions(scId) {
	    if (!scId) return [];
	    var scs = StandardCode.getSC(scId) || [];
	    return scs.map(function (sc) {
	        return _react2.default.createElement(
	            Option,
	            { value: sc.c },
	            sc.te
	        );
	    });
	};
	
	exports.getFormCommAttEditor = getFormCommAttEditor;
	exports.getCommAttEditor = getCommAttEditor;
	exports.getFunEditor = getFunEditor;
	exports.getShowEditor = getShowEditor;
	exports.getSCEditor = getSCEditor;
	exports.getSCModal = getSCModal;
	exports.getRPEditor = getRPEditor;
	exports.getRPModal = getRPModal;
	exports.getSelectOptions = getSelectOptions;
	exports.getDSDModal = getDSDModal;
	exports.getDSDEditor = getDSDEditor;
	exports.formItemLayout = _Dnd_SgiFormEditorCommonUtils.formItemLayout;
	exports.textOnChange = _Dnd_SgiFormEditorCommonUtils.textOnChange;
	exports.numberOnChange = _Dnd_SgiFormEditorCommonUtils.numberOnChange;
	exports.selectOnChange = _Dnd_SgiFormEditorCommonUtils.selectOnChange;
	exports.checkOnChange = _Dnd_SgiFormEditorCommonUtils.checkOnChange;
	exports.updateCode = _Dnd_SgiFormEditorCommonUtils.updateCode;
	exports.teOnBlur = _Dnd_SgiFormEditorCommonUtils.teOnBlur;
	exports.datePickerOnChange = _Dnd_SgiFormEditorCommonUtils.datePickerOnChange;

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/coord/View} view
	 * @param {Object} payload
	 * @param {Object} [zoomLimit]
	 */
	function updateCenterAndZoom(view, payload, zoomLimit) {
	  var previousZoom = view.getZoom();
	  var center = view.getCenter();
	  var zoom = payload.zoom;
	  var point = view.dataToPoint(center);
	
	  if (payload.dx != null && payload.dy != null) {
	    point[0] -= payload.dx;
	    point[1] -= payload.dy;
	    var center = view.pointToData(point);
	    view.setCenter(center);
	  }
	
	  if (zoom != null) {
	    if (zoomLimit) {
	      var zoomMin = zoomLimit.min || 0;
	      var zoomMax = zoomLimit.max || Infinity;
	      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
	    } // Zoom on given point(originX, originY)
	
	
	    view.scale[0] *= zoom;
	    view.scale[1] *= zoom;
	    var position = view.position;
	    var fixX = (payload.originX - position[0]) * (zoom - 1);
	    var fixY = (payload.originY - position[1]) * (zoom - 1);
	    position[0] -= fixX;
	    position[1] -= fixY;
	    view.updateTransform(); // Get the new center
	
	    var center = view.pointToData(point);
	    view.setCenter(center);
	    view.setZoom(zoom * previousZoom);
	  }
	
	  return {
	    center: view.getCenter(),
	    zoom: view.getZoom()
	  };
	}
	
	exports.updateCenterAndZoom = updateCenterAndZoom;

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getNodeGlobalScale(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys.type !== 'view') {
	    return 1;
	  }
	
	  var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
	  var groupScale = coordSys.scale;
	  var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	  var roamZoom = coordSys.getZoom();
	  var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	  return nodeScale / groupZoom;
	}
	
	function getSymbolSize(node) {
	  var symbolSize = node.getVisual('symbolSize');
	
	  if (symbolSize instanceof Array) {
	    symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
	  }
	
	  return +symbolSize;
	}
	
	exports.getNodeGlobalScale = getNodeGlobalScale;
	exports.getSymbolSize = getSymbolSize;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var vector = __webpack_require__(49);
	
	var symbolUtil = __webpack_require__(89);
	
	var LinePath = __webpack_require__(1663);
	
	var graphic = __webpack_require__(17);
	
	var _number = __webpack_require__(24);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];
	
	function makeSymbolTypeKey(symbolCategory) {
	  return '_' + symbolCategory + 'Type';
	}
	/**
	 * @inner
	 */
	
	
	function createSymbol(name, lineData, idx) {
	  var symbolType = lineData.getItemVisual(idx, name);
	
	  if (!symbolType || symbolType === 'none') {
	    return;
	  }
	
	  var color = lineData.getItemVisual(idx, 'color');
	  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
	  var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
	
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [symbolSize, symbolSize];
	  }
	
	  var symbolPath = symbolUtil.createSymbol(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color); // rotate by default if symbolRotate is not specified or NaN
	
	  symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
	  symbolPath.name = name;
	  return symbolPath;
	}
	
	function createLine(points) {
	  var line = new LinePath({
	    name: 'line',
	    subPixelOptimize: true
	  });
	  setLinePoints(line.shape, points);
	  return line;
	}
	
	function setLinePoints(targetShape, points) {
	  targetShape.x1 = points[0][0];
	  targetShape.y1 = points[0][1];
	  targetShape.x2 = points[1][0];
	  targetShape.y2 = points[1][1];
	  targetShape.percent = 1;
	  var cp1 = points[2];
	
	  if (cp1) {
	    targetShape.cpx1 = cp1[0];
	    targetShape.cpy1 = cp1[1];
	  } else {
	    targetShape.cpx1 = NaN;
	    targetShape.cpy1 = NaN;
	  }
	}
	
	function updateSymbolAndLabelBeforeLineUpdate() {
	  var lineGroup = this;
	  var symbolFrom = lineGroup.childOfName('fromSymbol');
	  var symbolTo = lineGroup.childOfName('toSymbol');
	  var label = lineGroup.childOfName('label'); // Quick reject
	
	  if (!symbolFrom && !symbolTo && label.ignore) {
	    return;
	  }
	
	  var invScale = 1;
	  var parentNode = this.parent;
	
	  while (parentNode) {
	    if (parentNode.scale) {
	      invScale /= parentNode.scale[0];
	    }
	
	    parentNode = parentNode.parent;
	  }
	
	  var line = lineGroup.childOfName('line'); // If line not changed
	  // FIXME Parent scale changed
	
	  if (!this.__dirty && !line.__dirty) {
	    return;
	  }
	
	  var percent = line.shape.percent;
	  var fromPos = line.pointAt(0);
	  var toPos = line.pointAt(percent);
	  var d = vector.sub([], toPos, fromPos);
	  vector.normalize(d, d);
	
	  if (symbolFrom) {
	    symbolFrom.attr('position', fromPos); // Fix #12388
	    // when symbol is set to be 'arrow' in markLine,
	    // symbolRotate value will be ignored, and compulsively use tangent angle.
	    // rotate by default if symbol rotation is not specified
	
	    var specifiedRotation = symbolFrom.__specifiedRotation;
	
	    if (specifiedRotation == null) {
	      var tangent = line.tangentAt(0);
	      symbolFrom.attr('rotation', Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    } else {
	      symbolFrom.attr('rotation', specifiedRotation);
	    }
	
	    symbolFrom.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (symbolTo) {
	    symbolTo.attr('position', toPos); // Fix #12388
	    // when symbol is set to be 'arrow' in markLine,
	    // symbolRotate value will be ignored, and compulsively use tangent angle.
	    // rotate by default if symbol rotation is not specified
	
	    var specifiedRotation = symbolTo.__specifiedRotation;
	
	    if (specifiedRotation == null) {
	      var tangent = line.tangentAt(1);
	      symbolTo.attr('rotation', -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    } else {
	      symbolTo.attr('rotation', specifiedRotation);
	    }
	
	    symbolTo.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (!label.ignore) {
	    label.attr('position', toPos);
	    var textPosition;
	    var textAlign;
	    var textVerticalAlign;
	    var textOrigin;
	    var distance = label.__labelDistance;
	    var distanceX = distance[0] * invScale;
	    var distanceY = distance[1] * invScale;
	    var halfPercent = percent / 2;
	    var tangent = line.tangentAt(halfPercent);
	    var n = [tangent[1], -tangent[0]];
	    var cp = line.pointAt(halfPercent);
	
	    if (n[1] > 0) {
	      n[0] = -n[0];
	      n[1] = -n[1];
	    }
	
	    var dir = tangent[0] < 0 ? -1 : 1;
	
	    if (label.__position !== 'start' && label.__position !== 'end') {
	      var rotation = -Math.atan2(tangent[1], tangent[0]);
	
	      if (toPos[0] < fromPos[0]) {
	        rotation = Math.PI + rotation;
	      }
	
	      label.attr('rotation', rotation);
	    }
	
	    var dy;
	
	    switch (label.__position) {
	      case 'insideStartTop':
	      case 'insideMiddleTop':
	      case 'insideEndTop':
	      case 'middle':
	        dy = -distanceY;
	        textVerticalAlign = 'bottom';
	        break;
	
	      case 'insideStartBottom':
	      case 'insideMiddleBottom':
	      case 'insideEndBottom':
	        dy = distanceY;
	        textVerticalAlign = 'top';
	        break;
	
	      default:
	        dy = 0;
	        textVerticalAlign = 'middle';
	    }
	
	    switch (label.__position) {
	      case 'end':
	        textPosition = [d[0] * distanceX + toPos[0], d[1] * distanceY + toPos[1]];
	        textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
	        textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
	        break;
	
	      case 'start':
	        textPosition = [-d[0] * distanceX + fromPos[0], -d[1] * distanceY + fromPos[1]];
	        textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
	        textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
	        break;
	
	      case 'insideStartTop':
	      case 'insideStart':
	      case 'insideStartBottom':
	        textPosition = [distanceX * dir + fromPos[0], fromPos[1] + dy];
	        textAlign = tangent[0] < 0 ? 'right' : 'left';
	        textOrigin = [-distanceX * dir, -dy];
	        break;
	
	      case 'insideMiddleTop':
	      case 'insideMiddle':
	      case 'insideMiddleBottom':
	      case 'middle':
	        textPosition = [cp[0], cp[1] + dy];
	        textAlign = 'center';
	        textOrigin = [0, -dy];
	        break;
	
	      case 'insideEndTop':
	      case 'insideEnd':
	      case 'insideEndBottom':
	        textPosition = [-distanceX * dir + toPos[0], toPos[1] + dy];
	        textAlign = tangent[0] >= 0 ? 'right' : 'left';
	        textOrigin = [distanceX * dir, -dy];
	        break;
	    }
	
	    label.attr({
	      style: {
	        // Use the user specified text align and baseline first
	        textVerticalAlign: label.__verticalAlign || textVerticalAlign,
	        textAlign: label.__textAlign || textAlign
	      },
	      position: textPosition,
	      scale: [invScale, invScale],
	      origin: textOrigin
	    });
	  }
	}
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	
	
	function Line(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createLine(lineData, idx, seriesScope);
	}
	
	var lineProto = Line.prototype; // Update symbol position and rotation
	
	lineProto.beforeUpdate = updateSymbolAndLabelBeforeLineUpdate;
	
	lineProto._createLine = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var linePoints = lineData.getItemLayout(idx);
	  var line = createLine(linePoints);
	  line.shape.percent = 0;
	  graphic.initProps(line, {
	    shape: {
	      percent: 1
	    }
	  }, seriesModel, idx);
	  this.add(line);
	  var label = new graphic.Text({
	    name: 'label',
	    // FIXME
	    // Temporary solution for `focusNodeAdjacency`.
	    // line label do not use the opacity of lineStyle.
	    lineLabelOriginalOpacity: 1
	  });
	  this.add(label);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
	    // it will be updated after line#update.
	    // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
	
	    this.add(symbol);
	    this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var linePoints = lineData.getItemLayout(idx);
	  var target = {
	    shape: {}
	  };
	  setLinePoints(target.shape, linePoints);
	  graphic.updateProps(line, target, seriesModel, idx);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbolType = lineData.getItemVisual(idx, symbolCategory);
	    var key = makeSymbolTypeKey(symbolCategory); // Symbol changed
	
	    if (this[key] !== symbolType) {
	      this.remove(this.childOfName(symbolCategory));
	      var symbol = createSymbol(symbolCategory, lineData, idx);
	      this.add(symbol);
	    }
	
	    this[key] = symbolType;
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset
	
	  if (!seriesScope || lineData.hasItemOption) {
	    var itemModel = lineData.getItemModel(idx);
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	    labelModel = itemModel.getModel('label');
	    hoverLabelModel = itemModel.getModel('emphasis.label');
	  }
	
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var visualOpacity = zrUtil.retrieve3(lineData.getItemVisual(idx, 'opacity'), lineStyle.opacity, 1);
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor,
	    opacity: visualOpacity
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle; // Update symbol
	
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = this.childOfName(symbolCategory);
	
	    if (symbol) {
	      symbol.setColor(visualColor);
	      symbol.setStyle({
	        opacity: visualOpacity
	      });
	    }
	  }, this);
	  var showLabel = labelModel.getShallow('show');
	  var hoverShowLabel = hoverLabelModel.getShallow('show');
	  var label = this.childOfName('label');
	  var defaultLabelColor;
	  var baseText; // FIXME: the logic below probably should be merged to `graphic.setLabelStyle`.
	
	  if (showLabel || hoverShowLabel) {
	    defaultLabelColor = visualColor || '#000';
	    baseText = seriesModel.getFormattedLabel(idx, 'normal', lineData.dataType);
	
	    if (baseText == null) {
	      var rawVal = seriesModel.getRawValue(idx);
	      baseText = rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal;
	    }
	  }
	
	  var normalText = showLabel ? baseText : null;
	  var emphasisText = hoverShowLabel ? zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'emphasis', lineData.dataType), baseText) : null;
	  var labelStyle = label.style; // Always set `textStyle` even if `normalStyle.text` is null, because default
	  // values have to be set on `normalStyle`.
	
	  if (normalText != null || emphasisText != null) {
	    graphic.setTextStyle(label.style, labelModel, {
	      text: normalText
	    }, {
	      autoColor: defaultLabelColor
	    });
	    label.__textAlign = labelStyle.textAlign;
	    label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'
	
	    label.__position = labelModel.get('position') || 'middle';
	    var distance = labelModel.get('distance');
	
	    if (!zrUtil.isArray(distance)) {
	      distance = [distance, distance];
	    }
	
	    label.__labelDistance = distance;
	  }
	
	  if (emphasisText != null) {
	    // Only these properties supported in this emphasis style here.
	    label.hoverStyle = {
	      text: emphasisText,
	      textFill: hoverLabelModel.getTextColor(true),
	      // For merging hover style to normal style, do not use
	      // `hoverLabelModel.getFont()` here.
	      fontStyle: hoverLabelModel.getShallow('fontStyle'),
	      fontWeight: hoverLabelModel.getShallow('fontWeight'),
	      fontSize: hoverLabelModel.getShallow('fontSize'),
	      fontFamily: hoverLabelModel.getShallow('fontFamily')
	    };
	  } else {
	    label.hoverStyle = {
	      text: null
	    };
	  }
	
	  label.ignore = !showLabel && !hoverShowLabel;
	  graphic.setHoverStyle(this);
	};
	
	lineProto.highlight = function () {
	  this.trigger('emphasis');
	};
	
	lineProto.downplay = function () {
	  this.trigger('normal');
	};
	
	lineProto.updateLayout = function (lineData, idx) {
	  this.setLinePoints(lineData.getItemLayout(idx));
	};
	
	lineProto.setLinePoints = function (points) {
	  var linePath = this.childOfName('line');
	  setLinePoints(linePath.shape, points);
	  linePath.dirty();
	};
	
	zrUtil.inherits(Line, graphic.Group);
	var _default = Line;
	module.exports = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var LineGroup = __webpack_require__(412);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/LineDraw
	 */
	// import IncrementalDisplayable from 'zrender/src/graphic/IncrementalDisplayable';
	
	/**
	 * @alias module:echarts/component/marker/LineDraw
	 * @constructor
	 */
	function LineDraw(ctor) {
	  this._ctor = ctor || LineGroup;
	  this.group = new graphic.Group();
	}
	
	var lineDrawProto = LineDraw.prototype;
	
	lineDrawProto.isPersistent = function () {
	  return true;
	};
	/**
	 * @param {module:echarts/data/List} lineData
	 */
	
	
	lineDrawProto.updateData = function (lineData) {
	  var lineDraw = this;
	  var group = lineDraw.group;
	  var oldLineData = lineDraw._lineData;
	  lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldLineData) {
	    group.removeAll();
	  }
	
	  var seriesScope = makeSeriesScope(lineData);
	  lineData.diff(oldLineData).add(function (idx) {
	    doAdd(lineDraw, lineData, idx, seriesScope);
	  }).update(function (newIdx, oldIdx) {
	    doUpdate(lineDraw, oldLineData, lineData, oldIdx, newIdx, seriesScope);
	  }).remove(function (idx) {
	    group.remove(oldLineData.getItemGraphicEl(idx));
	  }).execute();
	};
	
	function doAdd(lineDraw, lineData, idx, seriesScope) {
	  var itemLayout = lineData.getItemLayout(idx);
	
	  if (!lineNeedsDraw(itemLayout)) {
	    return;
	  }
	
	  var el = new lineDraw._ctor(lineData, idx, seriesScope);
	  lineData.setItemGraphicEl(idx, el);
	  lineDraw.group.add(el);
	}
	
	function doUpdate(lineDraw, oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
	  var itemEl = oldLineData.getItemGraphicEl(oldIdx);
	
	  if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
	    lineDraw.group.remove(itemEl);
	    return;
	  }
	
	  if (!itemEl) {
	    itemEl = new lineDraw._ctor(newLineData, newIdx, seriesScope);
	  } else {
	    itemEl.updateData(newLineData, newIdx, seriesScope);
	  }
	
	  newLineData.setItemGraphicEl(newIdx, itemEl);
	  lineDraw.group.add(itemEl);
	}
	
	lineDrawProto.updateLayout = function () {
	  var lineData = this._lineData; // Do not support update layout in incremental mode.
	
	  if (!lineData) {
	    return;
	  }
	
	  lineData.eachItemGraphicEl(function (el, idx) {
	    el.updateLayout(lineData, idx);
	  }, this);
	};
	
	lineDrawProto.incrementalPrepareUpdate = function (lineData) {
	  this._seriesScope = makeSeriesScope(lineData);
	  this._lineData = null;
	  this.group.removeAll();
	};
	
	function isEffectObject(el) {
	  return el.animators && el.animators.length > 0;
	}
	
	lineDrawProto.incrementalUpdate = function (taskParams, lineData) {
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup && !isEffectObject(el)) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var itemLayout = lineData.getItemLayout(idx);
	
	    if (lineNeedsDraw(itemLayout)) {
	      var el = new this._ctor(lineData, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      this.group.add(el);
	      lineData.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function makeSeriesScope(lineData) {
	  var hostModel = lineData.hostModel;
	  return {
	    lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
	    hoverLineStyle: hostModel.getModel('emphasis.lineStyle').getLineStyle(),
	    labelModel: hostModel.getModel('label'),
	    hoverLabelModel: hostModel.getModel('emphasis.label')
	  };
	}
	
	lineDrawProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	lineDrawProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	function isPointNaN(pt) {
	  return isNaN(pt[0]) || isNaN(pt[1]);
	}
	
	function lineNeedsDraw(pts) {
	  return !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
	}
	
	var _default = LineDraw;
	module.exports = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(143);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {string} label string. Not null/undefined
	 */
	function getDefaultLabel(data, dataIndex) {
	  var labelDims = data.mapDimension('defaultedLabel', true);
	  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
	
	  if (len === 1) {
	    return retrieveRawValue(data, dataIndex, labelDims[0]);
	  } else if (len) {
	    var vals = [];
	
	    for (var i = 0; i < labelDims.length; i++) {
	      var val = retrieveRawValue(data, dataIndex, labelDims[i]);
	      vals.push(val);
	    }
	
	    return vals.join(' ');
	  }
	}
	
	exports.getDefaultLabel = getDefaultLabel;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var clazzUtil = __webpack_require__(115);
	
	var graphic = __webpack_require__(17);
	
	var axisPointerModelHelper = __webpack_require__(267);
	
	var eventTool = __webpack_require__(104);
	
	var throttleUtil = __webpack_require__(131);
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var clone = zrUtil.clone;
	var bind = zrUtil.bind;
	/**
	 * Base axis pointer class in 2D.
	 * Implemenents {module:echarts/component/axis/IAxisPointer}.
	 */
	
	function BaseAxisPointer() {}
	
	BaseAxisPointer.prototype = {
	  /**
	   * @private
	   */
	  _group: null,
	
	  /**
	   * @private
	   */
	  _lastGraphicKey: null,
	
	  /**
	   * @private
	   */
	  _handle: null,
	
	  /**
	   * @private
	   */
	  _dragging: false,
	
	  /**
	   * @private
	   */
	  _lastValue: null,
	
	  /**
	   * @private
	   */
	  _lastStatus: null,
	
	  /**
	   * @private
	   */
	  _payloadInfo: null,
	
	  /**
	   * In px, arbitrary value. Do not set too small,
	   * no animation is ok for most cases.
	   * @protected
	   */
	  animationThreshold: 15,
	
	  /**
	   * @implement
	   */
	  render: function (axisModel, axisPointerModel, api, forceRender) {
	    var value = axisPointerModel.get('value');
	    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
	    // be replaced when user calling setOption in not merge mode.
	
	    this._axisModel = axisModel;
	    this._axisPointerModel = axisPointerModel;
	    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
	    // So it is power consuming if performing `render` each time,
	    // especially on mobile device.
	
	    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
	      return;
	    }
	
	    this._lastValue = value;
	    this._lastStatus = status;
	    var group = this._group;
	    var handle = this._handle;
	
	    if (!status || status === 'hide') {
	      // Do not clear here, for animation better.
	      group && group.hide();
	      handle && handle.hide();
	      return;
	    }
	
	    group && group.show();
	    handle && handle.show(); // Otherwise status is 'show'
	
	    var elOption = {};
	    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
	
	    var graphicKey = elOption.graphicKey;
	
	    if (graphicKey !== this._lastGraphicKey) {
	      this.clear(api);
	    }
	
	    this._lastGraphicKey = graphicKey;
	    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
	
	    if (!group) {
	      group = this._group = new graphic.Group();
	      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
	      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
	      api.getZr().add(group);
	    } else {
	      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
	      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
	      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
	    }
	
	    updateMandatoryProps(group, axisPointerModel, true);
	
	    this._renderHandle(value);
	  },
	
	  /**
	   * @implement
	   */
	  remove: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @implement
	   */
	  dispose: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @protected
	   */
	  determineAnimation: function (axisModel, axisPointerModel) {
	    var animation = axisPointerModel.get('animation');
	    var axis = axisModel.axis;
	    var isCategoryAxis = axis.type === 'category';
	    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
	
	    if (!useSnap && !isCategoryAxis) {
	      return false;
	    }
	
	    if (animation === 'auto' || animation == null) {
	      var animationThreshold = this.animationThreshold;
	
	      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
	        return true;
	      } // It is important to auto animation when snap used. Consider if there is
	      // a dataZoom, animation will be disabled when too many points exist, while
	      // it will be enabled for better visual effect when little points exist.
	
	
	      if (useSnap) {
	        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
	        var axisExtent = axis.getExtent(); // Approximate band width
	
	        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
	      }
	
	      return false;
	    }
	
	    return animation === true;
	  },
	
	  /**
	   * add {pointer, label, graphicKey} to elOption
	   * @protected
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
	  },
	
	  /**
	   * @protected
	   */
	  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
	    var pointerOption = elOption.pointer;
	
	    if (pointerOption) {
	      var pointerEl = inner(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
	      group.add(pointerEl);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
	    if (elOption.label) {
	      var labelEl = inner(group).labelEl = new graphic.Rect(clone(elOption.label));
	      group.add(labelEl);
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updatePointerEl: function (group, elOption, updateProps) {
	    var pointerEl = inner(group).pointerEl;
	
	    if (pointerEl && elOption.pointer) {
	      pointerEl.setStyle(elOption.pointer.style);
	      updateProps(pointerEl, {
	        shape: elOption.pointer.shape
	      });
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
	    var labelEl = inner(group).labelEl;
	
	    if (labelEl) {
	      labelEl.setStyle(elOption.label.style);
	      updateProps(labelEl, {
	        // Consider text length change in vertical axis, animation should
	        // be used on shape, otherwise the effect will be weird.
	        shape: elOption.label.shape,
	        position: elOption.label.position
	      });
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderHandle: function (value) {
	    if (this._dragging || !this.updateHandleTransform) {
	      return;
	    }
	
	    var axisPointerModel = this._axisPointerModel;
	
	    var zr = this._api.getZr();
	
	    var handle = this._handle;
	    var handleModel = axisPointerModel.getModel('handle');
	    var status = axisPointerModel.get('status');
	
	    if (!handleModel.get('show') || !status || status === 'hide') {
	      handle && zr.remove(handle);
	      this._handle = null;
	      return;
	    }
	
	    var isInit;
	
	    if (!this._handle) {
	      isInit = true;
	      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
	        cursor: 'move',
	        draggable: true,
	        onmousemove: function (e) {
	          // Fot mobile devicem, prevent screen slider on the button.
	          eventTool.stop(e.event);
	        },
	        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
	        drift: bind(this._onHandleDragMove, this),
	        ondragend: bind(this._onHandleDragEnd, this)
	      });
	      zr.add(handle);
	    }
	
	    updateMandatoryProps(handle, axisPointerModel, false); // update style
	
	    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
	    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position
	
	    var handleSize = handleModel.get('size');
	
	    if (!zrUtil.isArray(handleSize)) {
	      handleSize = [handleSize, handleSize];
	    }
	
	    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
	    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
	
	    this._moveHandleToValue(value, isInit);
	  },
	
	  /**
	   * @private
	   */
	  _moveHandleToValue: function (value, isInit) {
	    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragMove: function (dx, dy) {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    this._dragging = true; // Persistent for throttle.
	
	    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
	    this._payloadInfo = trans;
	    handle.stopAnimation();
	    handle.attr(getHandleTransProps(trans));
	    inner(handle).lastProp = null;
	
	    this._doDispatchAxisPointer();
	  },
	
	  /**
	   * Throttled method.
	   * @private
	   */
	  _doDispatchAxisPointer: function () {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var payloadInfo = this._payloadInfo;
	    var axisModel = this._axisModel;
	
	    this._api.dispatchAction({
	      type: 'updateAxisPointer',
	      x: payloadInfo.cursorPoint[0],
	      y: payloadInfo.cursorPoint[1],
	      tooltipOption: payloadInfo.tooltipOption,
	      axesInfo: [{
	        axisDim: axisModel.axis.dim,
	        axisIndex: axisModel.componentIndex
	      }]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragEnd: function (moveAnimation) {
	    this._dragging = false;
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
	    // axisPointer. So move handle to align the exact value position when
	    // drag ended.
	
	
	    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
	    // button, and will be hidden after finger left handle button.
	
	
	    this._api.dispatchAction({
	      type: 'hideTip'
	    });
	  },
	
	  /**
	   * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {number} value
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0}
	   */
	  getHandleTransform: null,
	
	  /**
	   * * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {Object} transform {position, rotation}
	   * @param {Array.<number>} delta [dx, dy]
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
	   */
	  updateHandleTransform: null,
	
	  /**
	   * @private
	   */
	  clear: function (api) {
	    this._lastValue = null;
	    this._lastStatus = null;
	    var zr = api.getZr();
	    var group = this._group;
	    var handle = this._handle;
	
	    if (zr && group) {
	      this._lastGraphicKey = null;
	      group && zr.remove(group);
	      handle && zr.remove(handle);
	      this._group = null;
	      this._handle = null;
	      this._payloadInfo = null;
	    }
	  },
	
	  /**
	   * @protected
	   */
	  doClear: function () {// Implemented by sub-class if necessary.
	  },
	
	  /**
	   * @protected
	   * @param {Array.<number>} xy
	   * @param {Array.<number>} wh
	   * @param {number} [xDimIndex=0] or 1
	   */
	  buildLabel: function (xy, wh, xDimIndex) {
	    xDimIndex = xDimIndex || 0;
	    return {
	      x: xy[xDimIndex],
	      y: xy[1 - xDimIndex],
	      width: wh[xDimIndex],
	      height: wh[1 - xDimIndex]
	    };
	  }
	};
	BaseAxisPointer.prototype.constructor = BaseAxisPointer;
	
	function updateProps(animationModel, moveAnimation, el, props) {
	  // Animation optimize.
	  if (!propsEqual(inner(el).lastProp, props)) {
	    inner(el).lastProp = props;
	    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
	  }
	}
	
	function propsEqual(lastProps, newProps) {
	  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
	    var equals = true;
	    zrUtil.each(newProps, function (item, key) {
	      equals = equals && propsEqual(lastProps[key], item);
	    });
	    return !!equals;
	  } else {
	    return lastProps === newProps;
	  }
	}
	
	function updateLabelShowHide(labelEl, axisPointerModel) {
	  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
	}
	
	function getHandleTransProps(trans) {
	  return {
	    position: trans.position.slice(),
	    rotation: trans.rotation || 0
	  };
	}
	
	function updateMandatoryProps(group, axisPointerModel, silent) {
	  var z = axisPointerModel.get('z');
	  var zlevel = axisPointerModel.get('zlevel');
	  group && group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	      el.silent = silent;
	    }
	  });
	}
	
	clazzUtil.enableClassExtend(BaseAxisPointer);
	var _default = BaseAxisPointer;
	module.exports = _default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var helper = __webpack_require__(418);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction('dataZoom', function (payload, ecModel) {
	  var linkedNodesFinder = helper.createLinkedNodesFinder(zrUtil.bind(ecModel.eachComponent, ecModel, 'dataZoom'), helper.eachAxisDim, function (model, dimNames) {
	    return model.get(dimNames.axisIndex);
	  });
	  var effectedModels = [];
	  ecModel.eachComponent({
	    mainType: 'dataZoom',
	    query: payload
	  }, function (model, index) {
	    effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
	  });
	  zrUtil.each(effectedModels, function (dataZoomModel, index) {
	    dataZoomModel.setRawRange({
	      start: payload.start,
	      end: payload.end,
	      startValue: payload.startValue,
	      endValue: payload.endValue
	    });
	  });
	});

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor({
	  // `dataZoomProcessor` will only be performed in needed series. Consider if
	  // there is a line series and a pie series, it is better not to update the
	  // line series if only pie series is needed to be updated.
	  getTargetSeries: function (ecModel) {
	    var seriesModelMap = createHashMap();
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        var axisProxy = dataZoomModel.getAxisProxy(dimNames.name, axisIndex);
	        each(axisProxy.getTargetSeriesModels(), function (seriesModel) {
	          seriesModelMap.set(seriesModel.uid, seriesModel);
	        });
	      });
	    });
	    return seriesModelMap;
	  },
	  modifyOutputEnd: true,
	  // Consider appendData, where filter should be performed. Because data process is
	  // in block mode currently, it is not need to worry about that the overallProgress
	  // execute every frame.
	  overallReset: function (ecModel, api) {
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // We calculate window and reset axis here but not in model
	      // init stage and not after action dispatch handler, because
	      // reset should be called after seriesData.restoreData.
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel, api);
	      }); // Caution: data zoom filtering is order sensitive when using
	      // percent range and no min/max/scale set on axis.
	      // For example, we have dataZoom definition:
	      // [
	      //      {xAxisIndex: 0, start: 30, end: 70},
	      //      {yAxisIndex: 0, start: 20, end: 80}
	      // ]
	      // In this case, [20, 80] of y-dataZoom should be based on data
	      // that have filtered by x-dataZoom using range of [30, 70],
	      // but should not be based on full raw data. Thus sliding
	      // x-dataZoom will change both ranges of xAxis and yAxis,
	      // while sliding y-dataZoom will only change the range of yAxis.
	      // So we should filter x-axis after reset x-axis immediately,
	      // and then reset y-axis and filter y-axis.
	
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel, api);
	      });
	    });
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // Fullfill all of the range props so that user
	      // is able to get them from chart.getOption().
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	      var percentRange = axisProxy.getDataPercentWindow();
	      var valueRange = axisProxy.getDataValueWindow();
	      dataZoomModel.setCalculatedRange({
	        start: percentRange[0],
	        end: percentRange[1],
	        startValue: valueRange[0],
	        endValue: valueRange[1]
	      });
	    });
	  }
	});

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var formatUtil = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AXIS_DIMS = ['x', 'y', 'z', 'radius', 'angle', 'single']; // Supported coords.
	
	var COORDS = ['cartesian2d', 'polar', 'singleAxis'];
	/**
	 * @param {string} coordType
	 * @return {boolean}
	 */
	
	function isCoordSupported(coordType) {
	  return zrUtil.indexOf(COORDS, coordType) >= 0;
	}
	/**
	 * Create "each" method to iterate names.
	 *
	 * @pubilc
	 * @param  {Array.<string>} names
	 * @param  {Array.<string>=} attrs
	 * @return {Function}
	 */
	
	
	function createNameEach(names, attrs) {
	  names = names.slice();
	  var capitalNames = zrUtil.map(names, formatUtil.capitalFirst);
	  attrs = (attrs || []).slice();
	  var capitalAttrs = zrUtil.map(attrs, formatUtil.capitalFirst);
	  return function (callback, context) {
	    zrUtil.each(names, function (name, index) {
	      var nameObj = {
	        name: name,
	        capital: capitalNames[index]
	      };
	
	      for (var j = 0; j < attrs.length; j++) {
	        nameObj[attrs[j]] = name + capitalAttrs[j];
	      }
	
	      callback.call(context, nameObj);
	    });
	  };
	}
	/**
	 * Iterate each dimension name.
	 *
	 * @public
	 * @param {Function} callback The parameter is like:
	 *                            {
	 *                                name: 'angle',
	 *                                capital: 'Angle',
	 *                                axis: 'angleAxis',
	 *                                axisIndex: 'angleAixs',
	 *                                index: 'angleIndex'
	 *                            }
	 * @param {Object} context
	 */
	
	
	var eachAxisDim = createNameEach(AXIS_DIMS, ['axisIndex', 'axis', 'index', 'id']);
	/**
	 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
	 * dataZoomModels and 'links' make up one or more graphics.
	 * This function finds the graphic where the source dataZoomModel is in.
	 *
	 * @public
	 * @param {Function} forEachNode Node iterator.
	 * @param {Function} forEachEdgeType edgeType iterator
	 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
	 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
	 */
	
	function createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
	  return function (sourceNode) {
	    var result = {
	      nodes: [],
	      records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).
	
	    };
	    forEachEdgeType(function (edgeType) {
	      result.records[edgeType.name] = {};
	    });
	
	    if (!sourceNode) {
	      return result;
	    }
	
	    absorb(sourceNode, result);
	    var existsLink;
	
	    do {
	      existsLink = false;
	      forEachNode(processSingleNode);
	    } while (existsLink);
	
	    function processSingleNode(node) {
	      if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
	        absorb(node, result);
	        existsLink = true;
	      }
	    }
	
	    return result;
	  };
	
	  function isNodeAbsorded(node, result) {
	    return zrUtil.indexOf(result.nodes, node) >= 0;
	  }
	
	  function isLinked(node, result) {
	    var hasLink = false;
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] && (hasLink = true);
	      });
	    });
	    return hasLink;
	  }
	
	  function absorb(node, result) {
	    result.nodes.push(node);
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] = true;
	      });
	    });
	  }
	}
	
	exports.isCoordSupported = isCoordSupported;
	exports.createNameEach = createNameEach;
	exports.eachAxisDim = eachAxisDim;
	exports.createLinkedNodesFinder = createLinkedNodesFinder;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(65);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('dataZoom', function () {
	  // Default 'slider' when no type specified.
	  return 'slider';
	});

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var Eventful = __webpack_require__(148);
	
	var graphic = __webpack_require__(17);
	
	var interactionMutex = __webpack_require__(825);
	
	var DataDiffer = __webpack_require__(142);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var map = zrUtil.map;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathPow = Math.pow;
	var COVER_Z = 10000;
	var UNSELECT_THRESHOLD = 6;
	var MIN_RESIZE_LINE_WIDTH = 6;
	var MUTEX_RESOURCE_KEY = 'globalPan';
	var DIRECTION_MAP = {
	  w: [0, 0],
	  e: [0, 1],
	  n: [1, 0],
	  s: [1, 1]
	};
	var CURSOR_MAP = {
	  w: 'ew',
	  e: 'ew',
	  n: 'ns',
	  s: 'ns',
	  ne: 'nesw',
	  sw: 'nesw',
	  nw: 'nwse',
	  se: 'nwse'
	};
	var DEFAULT_BRUSH_OPT = {
	  brushStyle: {
	    lineWidth: 2,
	    stroke: 'rgba(0,0,0,0.3)',
	    fill: 'rgba(0,0,0,0.1)'
	  },
	  transformable: true,
	  brushMode: 'single',
	  removeOnClick: false
	};
	var baseUID = 0;
	/**
	 * @alias module:echarts/component/helper/BrushController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 * @event module:echarts/component/helper/BrushController#brush
	 *        params:
	 *            areas: Array.<Array>, coord relates to container group,
	 *                                    If no container specified, to global.
	 *            opt {
	 *                isEnd: boolean,
	 *                removeOnClick: boolean
	 *            }
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	
	function BrushController(zr) {
	  Eventful.call(this);
	  /**
	   * @type {module:zrender/zrender~ZRender}
	   * @private
	   */
	
	  this._zr = zr;
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = new graphic.Group();
	  /**
	   * Only for drawing (after enabledBrush).
	   *     'line', 'rect', 'polygon' or false
	   *     If passing false/null/undefined, disable brush.
	   *     If passing 'auto', determined by panel.defaultBrushType
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * Only for drawing (after enabledBrush).
	   *
	   * @private
	   * @type {Object}
	   */
	
	  this._brushOption;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._panels;
	  /**
	   * @private
	   * @type {Array.<nubmer>}
	   */
	
	  this._track = [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._dragging;
	  /**
	   * @private
	   * @type {Array}
	   */
	
	  this._covers = [];
	  /**
	   * @private
	   * @type {moudule:zrender/container/Group}
	   */
	
	  this._creatingCover;
	  /**
	   * `true` means global panel
	   * @private
	   * @type {module:zrender/container/Group|boolean}
	   */
	
	  this._creatingPanel;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._enableGlobalPan;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  /**
	   * @private
	   * @type {string}
	   */
	  this._uid = 'brushController_' + baseUID++;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._handlers = {};
	  each(pointerHandlers, function (handler, eventName) {
	    this._handlers[eventName] = zrUtil.bind(handler, this);
	  }, this);
	}
	
	BrushController.prototype = {
	  constructor: BrushController,
	
	  /**
	   * If set to null/undefined/false, select disabled.
	   * @param {Object} brushOption
	   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
	   *                          If passing false/null/undefined, disable brush.
	   *                          If passing 'auto', determined by panel.defaultBrushType.
	   *                              ('auto' can not be used in global panel)
	   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
	   * @param {boolean} [brushOption.transformable=true]
	   * @param {boolean} [brushOption.removeOnClick=false]
	   * @param {Object} [brushOption.brushStyle]
	   * @param {number} [brushOption.brushStyle.width]
	   * @param {number} [brushOption.brushStyle.lineWidth]
	   * @param {string} [brushOption.brushStyle.stroke]
	   * @param {string} [brushOption.brushStyle.fill]
	   * @param {number} [brushOption.z]
	   */
	  enableBrush: function (brushOption) {
	    this._brushType && doDisableBrush(this);
	    brushOption.brushType && doEnableBrush(this, brushOption);
	    return this;
	  },
	
	  /**
	   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
	   *        Each items: {
	   *            panelId, // mandatory.
	   *            clipPath, // mandatory. function.
	   *            isTargetByCursor, // mandatory. function.
	   *            defaultBrushType, // optional, only used when brushType is 'auto'.
	   *            getLinearBrushOtherExtent, // optional. function.
	   *        }
	   */
	  setPanels: function (panelOpts) {
	    if (panelOpts && panelOpts.length) {
	      var panels = this._panels = {};
	      zrUtil.each(panelOpts, function (panelOpts) {
	        panels[panelOpts.panelId] = zrUtil.clone(panelOpts);
	      });
	    } else {
	      this._panels = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param {Object} [opt]
	   * @return {boolean} [opt.enableGlobalPan=false]
	   */
	  mount: function (opt) {
	    opt = opt || {};
	    this._enableGlobalPan = opt.enableGlobalPan;
	    var thisGroup = this.group;
	
	    this._zr.add(thisGroup);
	
	    thisGroup.attr({
	      position: opt.position || [0, 0],
	      rotation: opt.rotation || 0,
	      scale: opt.scale || [1, 1]
	    });
	    this._transform = thisGroup.getLocalTransform();
	    return this;
	  },
	  eachCover: function (cb, context) {
	    each(this._covers, cb, context);
	  },
	
	  /**
	   * Update covers.
	   * @param {Array.<Object>} brushOptionList Like:
	   *        [
	   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
	   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
	   *            ...
	   *        ]
	   *        `brushType` is required in each cover info. (can not be 'auto')
	   *        `id` is not mandatory.
	   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
	   *        If brushOptionList is null/undefined, all covers removed.
	   */
	  updateCovers: function (brushOptionList) {
	    brushOptionList = zrUtil.map(brushOptionList, function (brushOption) {
	      return zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	    });
	    var tmpIdPrefix = '\0-brush-index-';
	    var oldCovers = this._covers;
	    var newCovers = this._covers = [];
	    var controller = this;
	    var creatingCover = this._creatingCover;
	    new DataDiffer(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
	    return this;
	
	    function getKey(brushOption, index) {
	      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
	    }
	
	    function oldGetKey(cover, index) {
	      return getKey(cover.__brushOption, index);
	    }
	
	    function addOrUpdate(newIndex, oldIndex) {
	      var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
	      // where updating cover when creating should be forbiden.
	
	      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
	        newCovers[newIndex] = oldCovers[oldIndex];
	      } else {
	        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushOption));
	        updateCoverAfterCreation(controller, cover);
	      }
	    }
	
	    function remove(oldIndex) {
	      if (oldCovers[oldIndex] !== creatingCover) {
	        controller.group.remove(oldCovers[oldIndex]);
	      }
	    }
	  },
	  unmount: function () {
	    this.enableBrush(false); // container may 'removeAll' outside.
	
	    clearCovers(this);
	
	    this._zr.remove(this.group);
	
	    return this;
	  },
	  dispose: function () {
	    this.unmount();
	    this.off();
	  }
	};
	zrUtil.mixin(BrushController, Eventful);
	
	function doEnableBrush(controller, brushOption) {
	  var zr = controller._zr; // Consider roam, which takes globalPan too.
	
	  if (!controller._enableGlobalPan) {
	    interactionMutex.take(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  }
	
	  mountHandlers(zr, controller._handlers);
	  controller._brushType = brushOption.brushType;
	  controller._brushOption = zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	}
	
	function doDisableBrush(controller) {
	  var zr = controller._zr;
	  interactionMutex.release(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  unmountHandlers(zr, controller._handlers);
	  controller._brushType = controller._brushOption = null;
	}
	
	function mountHandlers(zr, handlers) {
	  each(handlers, function (handler, eventName) {
	    zr.on(eventName, handler);
	  });
	}
	
	function unmountHandlers(zr, handlers) {
	  each(handlers, function (handler, eventName) {
	    zr.off(eventName, handler);
	  });
	}
	
	function createCover(controller, brushOption) {
	  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
	  cover.__brushOption = brushOption;
	  updateZ(cover, brushOption);
	  controller.group.add(cover);
	  return cover;
	}
	
	function endCreating(controller, creatingCover) {
	  var coverRenderer = getCoverRenderer(creatingCover);
	
	  if (coverRenderer.endCreating) {
	    coverRenderer.endCreating(controller, creatingCover);
	    updateZ(creatingCover, creatingCover.__brushOption);
	  }
	
	  return creatingCover;
	}
	
	function updateCoverShape(controller, cover) {
	  var brushOption = cover.__brushOption;
	  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
	}
	
	function updateZ(cover, brushOption) {
	  var z = brushOption.z;
	  z == null && (z = COVER_Z);
	  cover.traverse(function (el) {
	    el.z = z;
	    el.z2 = z; // Consider in given container.
	  });
	}
	
	function updateCoverAfterCreation(controller, cover) {
	  getCoverRenderer(cover).updateCommon(controller, cover);
	  updateCoverShape(controller, cover);
	}
	
	function getCoverRenderer(cover) {
	  return coverRenderers[cover.__brushOption.brushType];
	} // return target panel or `true` (means global panel)
	
	
	function getPanelByPoint(controller, e, localCursorPoint) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panel;
	  var transform = controller._transform;
	  each(panels, function (pn) {
	    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
	  });
	  return panel;
	} // Return a panel or true
	
	
	function getPanelByCover(controller, cover) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
	  // which is then treated as global panel.
	
	  return panelId != null ? panels[panelId] : true;
	}
	
	function clearCovers(controller) {
	  var covers = controller._covers;
	  var originalLength = covers.length;
	  each(covers, function (cover) {
	    controller.group.remove(cover);
	  }, controller);
	  covers.length = 0;
	  return !!originalLength;
	}
	
	function trigger(controller, opt) {
	  var areas = map(controller._covers, function (cover) {
	    var brushOption = cover.__brushOption;
	    var range = zrUtil.clone(brushOption.range);
	    return {
	      brushType: brushOption.brushType,
	      panelId: brushOption.panelId,
	      range: range
	    };
	  });
	  controller.trigger('brush', areas, {
	    isEnd: !!opt.isEnd,
	    removeOnClick: !!opt.removeOnClick
	  });
	}
	
	function shouldShowCover(controller) {
	  var track = controller._track;
	
	  if (!track.length) {
	    return false;
	  }
	
	  var p2 = track[track.length - 1];
	  var p1 = track[0];
	  var dx = p2[0] - p1[0];
	  var dy = p2[1] - p1[1];
	  var dist = mathPow(dx * dx + dy * dy, 0.5);
	  return dist > UNSELECT_THRESHOLD;
	}
	
	function getTrackEnds(track) {
	  var tail = track.length - 1;
	  tail < 0 && (tail = 0);
	  return [track[0], track[tail]];
	}
	
	function createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
	  var cover = new graphic.Group();
	  cover.add(new graphic.Rect({
	    name: 'main',
	    style: makeStyle(brushOption),
	    silent: true,
	    draggable: true,
	    cursor: 'move',
	    drift: curry(doDrift, controller, cover, 'nswe'),
	    ondragend: curry(trigger, controller, {
	      isEnd: true
	    })
	  }));
	  each(edgeNames, function (name) {
	    cover.add(new graphic.Rect({
	      name: name,
	      style: {
	        opacity: 0
	      },
	      draggable: true,
	      silent: true,
	      invisible: true,
	      drift: curry(doDrift, controller, cover, name),
	      ondragend: curry(trigger, controller, {
	        isEnd: true
	      })
	    }));
	  });
	  return cover;
	}
	
	function updateBaseRect(controller, cover, localRange, brushOption) {
	  var lineWidth = brushOption.brushStyle.lineWidth || 0;
	  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
	  var x = localRange[0][0];
	  var y = localRange[1][0];
	  var xa = x - lineWidth / 2;
	  var ya = y - lineWidth / 2;
	  var x2 = localRange[0][1];
	  var y2 = localRange[1][1];
	  var x2a = x2 - handleSize + lineWidth / 2;
	  var y2a = y2 - handleSize + lineWidth / 2;
	  var width = x2 - x;
	  var height = y2 - y;
	  var widtha = width + lineWidth;
	  var heighta = height + lineWidth;
	  updateRectShape(controller, cover, 'main', x, y, width, height);
	
	  if (brushOption.transformable) {
	    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
	    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
	    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
	    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
	  }
	}
	
	function updateCommon(controller, cover) {
	  var brushOption = cover.__brushOption;
	  var transformable = brushOption.transformable;
	  var mainEl = cover.childAt(0);
	  mainEl.useStyle(makeStyle(brushOption));
	  mainEl.attr({
	    silent: !transformable,
	    cursor: transformable ? 'move' : 'default'
	  });
	  each(['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw'], function (name) {
	    var el = cover.childOfName(name);
	    var globalDir = getGlobalDirection(controller, name);
	    el && el.attr({
	      silent: !transformable,
	      invisible: !transformable,
	      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
	    });
	  });
	}
	
	function updateRectShape(controller, cover, name, x, y, w, h) {
	  var el = cover.childOfName(name);
	  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
	}
	
	function makeStyle(brushOption) {
	  return zrUtil.defaults({
	    strokeNoScale: true
	  }, brushOption.brushStyle);
	}
	
	function formatRectRange(x, y, x2, y2) {
	  var min = [mathMin(x, x2), mathMin(y, y2)];
	  var max = [mathMax(x, x2), mathMax(y, y2)];
	  return [[min[0], max[0]], // x range
	  [min[1], max[1]] // y range
	  ];
	}
	
	function getTransform(controller) {
	  return graphic.getTransform(controller.group);
	}
	
	function getGlobalDirection(controller, localDirection) {
	  if (localDirection.length > 1) {
	    localDirection = localDirection.split('');
	    var globalDir = [getGlobalDirection(controller, localDirection[0]), getGlobalDirection(controller, localDirection[1])];
	    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
	    return globalDir.join('');
	  } else {
	    var map = {
	      w: 'left',
	      e: 'right',
	      n: 'top',
	      s: 'bottom'
	    };
	    var inverseMap = {
	      left: 'w',
	      right: 'e',
	      top: 'n',
	      bottom: 's'
	    };
	    var globalDir = graphic.transformDirection(map[localDirection], getTransform(controller));
	    return inverseMap[globalDir];
	  }
	}
	
	function driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
	  var brushOption = cover.__brushOption;
	  var rectRange = toRectRange(brushOption.range);
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(name.split(''), function (namePart) {
	    var ind = DIRECTION_MAP[namePart];
	    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
	  });
	  brushOption.range = fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function driftPolygon(controller, cover, dx, dy, e) {
	  var range = cover.__brushOption.range;
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(range, function (point) {
	    point[0] += localDelta[0];
	    point[1] += localDelta[1];
	  });
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function toLocalDelta(controller, dx, dy) {
	  var thisGroup = controller.group;
	  var localD = thisGroup.transformCoordToLocal(dx, dy);
	  var localZero = thisGroup.transformCoordToLocal(0, 0);
	  return [localD[0] - localZero[0], localD[1] - localZero[1]];
	}
	
	function clipByPanel(controller, cover, data) {
	  var panel = getPanelByCover(controller, cover);
	  return panel && panel !== true ? panel.clipPath(data, controller._transform) : zrUtil.clone(data);
	}
	
	function pointsToRect(points) {
	  var xmin = mathMin(points[0][0], points[1][0]);
	  var ymin = mathMin(points[0][1], points[1][1]);
	  var xmax = mathMax(points[0][0], points[1][0]);
	  var ymax = mathMax(points[0][1], points[1][1]);
	  return {
	    x: xmin,
	    y: ymin,
	    width: xmax - xmin,
	    height: ymax - ymin
	  };
	}
	
	function resetCursor(controller, e, localCursorPoint) {
	  if ( // Check active
	  !controller._brushType // resetCursor should be always called when mouse is in zr area,
	  // but not called when mouse is out of zr area to avoid bad influence
	  // if `mousemove`, `mouseup` are triggered from `document` event.
	  || isOutsideZrArea(controller, e)) {
	    return;
	  }
	
	  var zr = controller._zr;
	  var covers = controller._covers;
	  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.
	
	  if (!controller._dragging) {
	    for (var i = 0; i < covers.length; i++) {
	      var brushOption = covers[i].__brushOption;
	
	      if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
	        // Use cursor style set on cover.
	        return;
	      }
	    }
	  }
	
	  currPanel && zr.setCursorStyle('crosshair');
	}
	
	function preventDefault(e) {
	  var rawE = e.event;
	  rawE.preventDefault && rawE.preventDefault();
	}
	
	function mainShapeContain(cover, x, y) {
	  return cover.childOfName('main').contain(x, y);
	}
	
	function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
	  var creatingCover = controller._creatingCover;
	  var panel = controller._creatingPanel;
	  var thisBrushOption = controller._brushOption;
	  var eventParams;
	
	  controller._track.push(localCursorPoint.slice());
	
	  if (shouldShowCover(controller) || creatingCover) {
	    if (panel && !creatingCover) {
	      thisBrushOption.brushMode === 'single' && clearCovers(controller);
	      var brushOption = zrUtil.clone(thisBrushOption);
	      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
	      brushOption.panelId = panel === true ? null : panel.panelId;
	      creatingCover = controller._creatingCover = createCover(controller, brushOption);
	
	      controller._covers.push(creatingCover);
	    }
	
	    if (creatingCover) {
	      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
	      var coverBrushOption = creatingCover.__brushOption;
	      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));
	
	      if (isEnd) {
	        endCreating(controller, creatingCover);
	        coverRenderer.updateCommon(controller, creatingCover);
	      }
	
	      updateCoverShape(controller, creatingCover);
	      eventParams = {
	        isEnd: isEnd
	      };
	    }
	  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
	    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
	    // But a single click do not clear covers, because user may have casual
	    // clicks (for example, click on other component and do not expect covers
	    // disappear).
	    // Only some cover removed, trigger action, but not every click trigger action.
	    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
	      eventParams = {
	        isEnd: isEnd,
	        removeOnClick: true
	      };
	    }
	  }
	
	  return eventParams;
	}
	
	function determineBrushType(brushType, panel) {
	  if (brushType === 'auto') {
	    return panel.defaultBrushType;
	  }
	
	  return brushType;
	}
	
	var pointerHandlers = {
	  mousedown: function (e) {
	    if (this._dragging) {
	      // In case some browser do not support globalOut,
	      // and release mose out side the browser.
	      handleDragEnd(this, e);
	    } else if (!e.target || !e.target.draggable) {
	      preventDefault(e);
	      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	      this._creatingCover = null;
	      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);
	
	      if (panel) {
	        this._dragging = true;
	        this._track = [localCursorPoint.slice()];
	      }
	    }
	  },
	  mousemove: function (e) {
	    var x = e.offsetX;
	    var y = e.offsetY;
	    var localCursorPoint = this.group.transformCoordToLocal(x, y);
	    resetCursor(this, e, localCursorPoint);
	
	    if (this._dragging) {
	      preventDefault(e);
	      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
	      eventParams && trigger(this, eventParams);
	    }
	  },
	  mouseup: function (e) {
	    handleDragEnd(this, e);
	  }
	};
	
	function handleDragEnd(controller, e) {
	  if (controller._dragging) {
	    preventDefault(e);
	    var x = e.offsetX;
	    var y = e.offsetY;
	    var localCursorPoint = controller.group.transformCoordToLocal(x, y);
	    var eventParams = updateCoverByMouse(controller, e, localCursorPoint, true);
	    controller._dragging = false;
	    controller._track = [];
	    controller._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.
	
	    eventParams && trigger(controller, eventParams);
	  }
	}
	
	function isOutsideZrArea(controller, x, y) {
	  var zr = controller._zr;
	  return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
	}
	/**
	 * key: brushType
	 * @type {Object}
	 */
	
	
	var coverRenderers = {
	  lineX: getLineRenderer(0),
	  lineY: getLineRenderer(1),
	  rect: {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        return range;
	      }, function (range) {
	        return range;
	      }), controller, brushOption, ['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw']);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      updateBaseRect(controller, cover, localRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  },
	  polygon: {
	    createCover: function (controller, brushOption) {
	      var cover = new graphic.Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
	      // border of the shape when drawing, which is a better experience for user.
	
	      cover.add(new graphic.Polyline({
	        name: 'main',
	        style: makeStyle(brushOption),
	        silent: true
	      }));
	      return cover;
	    },
	    getCreatingRange: function (localTrack) {
	      return localTrack;
	    },
	    endCreating: function (controller, cover) {
	      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.
	
	      cover.add(new graphic.Polygon({
	        name: 'main',
	        draggable: true,
	        drift: curry(driftPolygon, controller, cover),
	        ondragend: curry(trigger, controller, {
	          isEnd: true
	        })
	      }));
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      cover.childAt(0).setShape({
	        points: clipByPanel(controller, cover, localRange)
	      });
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  }
	};
	
	function getLineRenderer(xyIndex) {
	  return {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        var rectRange = [range, [0, 100]];
	        xyIndex && rectRange.reverse();
	        return rectRange;
	      }, function (rectRange) {
	        return rectRange[xyIndex];
	      }), controller, brushOption, [['w', 'e'], ['n', 's']][xyIndex]);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
	      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
	      return [min, max];
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      var otherExtent; // If brushWidth not specified, fit the panel.
	
	      var panel = getPanelByCover(controller, cover);
	
	      if (panel !== true && panel.getLinearBrushOtherExtent) {
	        otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
	      } else {
	        var zr = controller._zr;
	        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
	      }
	
	      var rectRange = [localRange, otherExtent];
	      xyIndex && rectRange.reverse();
	      updateBaseRect(controller, cover, rectRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  };
	}
	
	var _default = BrushController;
	module.exports = _default;

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 */
	function updateViewOnPan(controllerHost, dx, dy) {
	  var target = controllerHost.target;
	  var pos = target.position;
	  pos[0] += dx;
	  pos[1] += dy;
	  target.dirty();
	}
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 * @param {number} controllerHost.zoom
	 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
	 */
	
	
	function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
	  var target = controllerHost.target;
	  var zoomLimit = controllerHost.zoomLimit;
	  var pos = target.position;
	  var scale = target.scale;
	  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
	  newZoom *= zoomDelta;
	
	  if (zoomLimit) {
	    var zoomMin = zoomLimit.min || 0;
	    var zoomMax = zoomLimit.max || Infinity;
	    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
	  }
	
	  var zoomScale = newZoom / controllerHost.zoom;
	  controllerHost.zoom = newZoom; // Keep the mouse center when scaling
	
	  pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
	  pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
	  scale[0] *= zoomScale;
	  scale[1] *= zoomScale;
	  target.dirty();
	}
	
	exports.updateViewOnPan = updateViewOnPan;
	exports.updateViewOnZoom = updateViewOnZoom;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Data selectable mixin for chart series.
	 * To eanble data select, option of series must have `selectedMode`.
	 * And each data item will use `selected` to toggle itself selected status
	 */
	var _default = {
	  /**
	   * @param {Array.<Object>} targetList [{name, value, selected}, ...]
	   *        If targetList is an array, it should like [{name: ..., value: ...}, ...].
	   *        If targetList is a "List", it must have coordDim: 'value' dimension and name.
	   */
	  updateSelectedMap: function (targetList) {
	    this._targetList = zrUtil.isArray(targetList) ? targetList.slice() : [];
	    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
	      targetMap.set(target.name, target);
	      return targetMap;
	    }, zrUtil.createHashMap());
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  // PENGING If selectedMode is null ?
	  select: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      this._selectTargetMap.each(function (target) {
	        target.selected = false;
	      });
	    }
	
	    target && (target.selected = true);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  unSelect: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
	    // selectedMode !== 'single' && target && (target.selected = false);
	
	    target && (target.selected = false);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  toggleSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	
	    if (target != null) {
	      this[target.selected ? 'unSelect' : 'select'](name, id);
	      return target.selected;
	    }
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  isSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    return target && target.selected;
	  }
	};
	module.exports = _default;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	var modelUtil = __webpack_require__(27);
	
	var formatUtil = __webpack_require__(48);
	
	var dataFormatMixin = __webpack_require__(432);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var addCommas = formatUtil.addCommas;
	var encodeHTML = formatUtil.encodeHTML;
	
	function fillLabel(opt) {
	  modelUtil.defaultEmphasis(opt, 'label', ['show']);
	}
	
	var MarkerModel = echarts.extendComponentModel({
	  type: 'marker',
	  dependencies: ['series', 'grid', 'polar', 'geo'],
	
	  /**
	   * @overrite
	   */
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._mergeOption(option, ecModel, false, true);
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var hostSeries = this.__hostSeries;
	    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
	  },
	
	  /**
	   * @overrite
	   */
	  mergeOption: function (newOpt, ecModel) {
	    this._mergeOption(newOpt, ecModel, false, false);
	  },
	  _mergeOption: function (newOpt, ecModel, createdBySelf, isInit) {
	    var MarkerModel = this.constructor;
	    var modelPropName = this.mainType + 'Model';
	
	    if (!createdBySelf) {
	      ecModel.eachSeries(function (seriesModel) {
	        var markerOpt = seriesModel.get(this.mainType, true);
	        var markerModel = seriesModel[modelPropName];
	
	        if (!markerOpt || !markerOpt.data) {
	          seriesModel[modelPropName] = null;
	          return;
	        }
	
	        if (!markerModel) {
	          if (isInit) {
	            // Default label emphasis `position` and `show`
	            fillLabel(markerOpt);
	          }
	
	          zrUtil.each(markerOpt.data, function (item) {
	            // FIXME Overwrite fillLabel method ?
	            if (item instanceof Array) {
	              fillLabel(item[0]);
	              fillLabel(item[1]);
	            } else {
	              fillLabel(item);
	            }
	          });
	          markerModel = new MarkerModel(markerOpt, this, ecModel);
	          zrUtil.extend(markerModel, {
	            mainType: this.mainType,
	            // Use the same series index and name
	            seriesIndex: seriesModel.seriesIndex,
	            name: seriesModel.name,
	            createdBySelf: true
	          });
	          markerModel.__hostSeries = seriesModel;
	        } else {
	          markerModel._mergeOption(markerOpt, ecModel, true);
	        }
	
	        seriesModel[modelPropName] = markerModel;
	      }, this);
	    }
	  },
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? zrUtil.map(value, addCommas).join(', ') : addCommas(value);
	    var name = data.getName(dataIndex);
	    var html = encodeHTML(this.name);
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	
	    if (value != null || name) {
	      html += newLine;
	    }
	
	    if (name) {
	      html += encodeHTML(name);
	
	      if (value != null) {
	        html += ' : ';
	      }
	    }
	
	    if (value != null) {
	      html += encodeHTML(formattedValue);
	    }
	
	    return html;
	  },
	  getData: function () {
	    return this._data;
	  },
	  setData: function (data) {
	    this._data = data;
	  }
	});
	zrUtil.mixin(MarkerModel, dataFormatMixin);
	var _default = MarkerModel;
	module.exports = _default;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'marker',
	  init: function () {
	    /**
	     * Markline grouped by series
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this.markerGroupMap = zrUtil.createHashMap();
	  },
	  render: function (markerModel, ecModel, api) {
	    var markerGroupMap = this.markerGroupMap;
	    markerGroupMap.each(function (item) {
	      item.__keep = false;
	    });
	    var markerModelKey = this.type + 'Model';
	    ecModel.eachSeries(function (seriesModel) {
	      var markerModel = seriesModel[markerModelKey];
	      markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
	    }, this);
	    markerGroupMap.each(function (item) {
	      !item.__keep && this.group.remove(item.group);
	    }, this);
	  },
	  renderSeries: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var numberUtil = __webpack_require__(24);
	
	var _dataStackHelper = __webpack_require__(102);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var indexOf = zrUtil.indexOf;
	
	function hasXOrY(item) {
	  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
	}
	
	function hasXAndY(item) {
	  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
	} // Make it simple, do not visit all stacked value to count precision.
	// function getPrecision(data, valueAxisDim, dataIndex) {
	//     var precision = -1;
	//     var stackedDim = data.mapDimension(valueAxisDim);
	//     do {
	//         precision = Math.max(
	//             numberUtil.getPrecision(data.get(stackedDim, dataIndex)),
	//             precision
	//         );
	//         var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	//         if (stackedOnSeries) {
	//             var byValue = data.get(data.getCalculationInfo('stackedByDimension'), dataIndex);
	//             data = stackedOnSeries.getData();
	//             dataIndex = data.indexOf(data.getCalculationInfo('stackedByDimension'), byValue);
	//             stackedDim = data.getCalculationInfo('stackedDimension');
	//         }
	//         else {
	//             data = null;
	//         }
	//     } while (data);
	//     return precision;
	// }
	
	
	function markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
	  var coordArr = [];
	  var stacked = isDimensionStacked(data, targetDataDim
	  /*, otherDataDim*/
	  );
	  var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
	  var value = numCalculate(data, calcDataDim, mlType);
	  var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
	  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
	  coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
	  var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
	
	  var precision = numberUtil.getPrecision(data.get(targetDataDim, dataIndex));
	  precision = Math.min(precision, 20);
	
	  if (precision >= 0) {
	    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
	  }
	
	  return [coordArr, coordArrValue];
	}
	
	var curry = zrUtil.curry; // TODO Specified percent
	
	var markerTypeCalculator = {
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  min: curry(markerTypeCalculatorWithExtent, 'min'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  max: curry(markerTypeCalculatorWithExtent, 'max'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  average: curry(markerTypeCalculatorWithExtent, 'average')
	};
	/**
	 * Transform markPoint data item to format used in List by do the following
	 * 1. Calculate statistic like `max`, `min`, `average`
	 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
	 * @param  {module:echarts/model/Series} seriesModel
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {Object}
	 */
	
	function dataTransform(seriesModel, item) {
	  var data = seriesModel.getData();
	  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
	  // 2. If `coord` is not a data array. Which uses `xAxis`,
	  // `yAxis` to specify the coord on each dimension
	  // parseFloat first because item.x and item.y can be percent string like '20%'
	
	  if (item && !hasXAndY(item) && !zrUtil.isArray(item.coord) && coordSys) {
	    var dims = coordSys.dimensions;
	    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
	    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
	
	    item = zrUtil.clone(item);
	
	    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
	      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
	      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
	      var coordInfo = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
	      item.coord = coordInfo[0]; // Force to use the value of calculated value.
	      // let item use the value without stack.
	
	      item.value = coordInfo[1];
	    } else {
	      // FIXME Only has one of xAxis and yAxis.
	      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average
	
	      for (var i = 0; i < 2; i++) {
	        if (markerTypeCalculator[coord[i]]) {
	          coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
	        }
	      }
	
	      item.coord = coord;
	    }
	  }
	
	  return item;
	}
	
	function getAxisInfo(item, data, coordSys, seriesModel) {
	  var ret = {};
	
	  if (item.valueIndex != null || item.valueDim != null) {
	    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
	    ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
	    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	  } else {
	    ret.baseAxis = seriesModel.getBaseAxis();
	    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	    ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
	  }
	
	  return ret;
	}
	
	function dataDimToCoordDim(seriesModel, dataDim) {
	  var data = seriesModel.getData();
	  var dimensions = data.dimensions;
	  dataDim = data.getDimension(dataDim);
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimItem = data.getDimensionInfo(dimensions[i]);
	
	    if (dimItem.name === dataDim) {
	      return dimItem.coordDim;
	    }
	  }
	}
	/**
	 * Filter data which is out of coordinateSystem range
	 * [dataFilter description]
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {boolean}
	 */
	
	
	function dataFilter(coordSys, item) {
	  // Alwalys return true if there is no coordSys
	  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
	}
	
	function dimValueGetter(item, dimName, dataIndex, dimIndex) {
	  // x, y, radius, angle
	  if (dimIndex < 2) {
	    return item.coord && item.coord[dimIndex];
	  }
	
	  return item.value;
	}
	
	function numCalculate(data, valueDataDim, type) {
	  if (type === 'average') {
	    var sum = 0;
	    var count = 0;
	    data.each(valueDataDim, function (val, idx) {
	      if (!isNaN(val)) {
	        sum += val;
	        count++;
	      }
	    });
	    return sum / count;
	  } else if (type === 'median') {
	    return data.getMedian(valueDataDim);
	  } else {
	    // max & min
	    return data.getDataExtent(valueDataDim, true)[type === 'max' ? 1 : 0];
	  }
	}
	
	exports.dataTransform = dataTransform;
	exports.getAxisInfo = getAxisInfo;
	exports.dataFilter = dataFilter;
	exports.dimValueGetter = dimValueGetter;
	exports.numCalculate = numCalculate;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var vector = __webpack_require__(49);
	
	var matrix = __webpack_require__(75);
	
	var BoundingRect = __webpack_require__(51);
	
	var Transformable = __webpack_require__(284);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Simple view coordinate system
	 * Mapping given x, y to transformd view x, y
	 */
	var v2ApplyTransform = vector.applyTransform; // Dummy transform node
	
	function TransformDummy() {
	  Transformable.call(this);
	}
	
	zrUtil.mixin(TransformDummy, Transformable);
	
	function View(name) {
	  /**
	   * @type {string}
	   */
	  this.name = name;
	  /**
	   * @type {Object}
	   */
	
	  this.zoomLimit;
	  Transformable.call(this);
	  this._roamTransformable = new TransformDummy();
	  this._rawTransformable = new TransformDummy();
	  this._center;
	  this._zoom;
	}
	
	View.prototype = {
	  constructor: View,
	  type: 'view',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Set bounding rect
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  // PENDING to getRect
	  setBoundingRect: function (x, y, width, height) {
	    this._rect = new BoundingRect(x, y, width, height);
	    return this._rect;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // PENDING to getRect
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  setViewRect: function (x, y, width, height) {
	    this.transformTo(x, y, width, height);
	    this._viewRect = new BoundingRect(x, y, width, height);
	  },
	
	  /**
	   * Transformed to particular position and size
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var rawTransform = this._rawTransformable;
	    rawTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransform.decomposeTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * Set center of view
	   * @param {Array.<number>} [centerCoord]
	   */
	  setCenter: function (centerCoord) {
	    if (!centerCoord) {
	      return;
	    }
	
	    this._center = centerCoord;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * @param {number} zoom
	   */
	  setZoom: function (zoom) {
	    zoom = zoom || 1;
	    var zoomLimit = this.zoomLimit;
	
	    if (zoomLimit) {
	      if (zoomLimit.max != null) {
	        zoom = Math.min(zoomLimit.max, zoom);
	      }
	
	      if (zoomLimit.min != null) {
	        zoom = Math.max(zoomLimit.min, zoom);
	      }
	    }
	
	    this._zoom = zoom;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * Get default center without roam
	   */
	  getDefaultCenter: function () {
	    // Rect before any transform
	    var rawRect = this.getBoundingRect();
	    var cx = rawRect.x + rawRect.width / 2;
	    var cy = rawRect.y + rawRect.height / 2;
	    return [cx, cy];
	  },
	  getCenter: function () {
	    return this._center || this.getDefaultCenter();
	  },
	  getZoom: function () {
	    return this._zoom || 1;
	  },
	
	  /**
	   * @return {Array.<number}
	   */
	  getRoamTransform: function () {
	    return this._roamTransformable.getLocalTransform();
	  },
	
	  /**
	   * Remove roam
	   */
	  _updateCenterAndZoom: function () {
	    // Must update after view transform updated
	    var rawTransformMatrix = this._rawTransformable.getLocalTransform();
	
	    var roamTransform = this._roamTransformable;
	    var defaultCenter = this.getDefaultCenter();
	    var center = this.getCenter();
	    var zoom = this.getZoom();
	    center = vector.applyTransform([], center, rawTransformMatrix);
	    defaultCenter = vector.applyTransform([], defaultCenter, rawTransformMatrix);
	    roamTransform.origin = center;
	    roamTransform.position = [defaultCenter[0] - center[0], defaultCenter[1] - center[1]];
	    roamTransform.scale = [zoom, zoom];
	
	    this._updateTransform();
	  },
	
	  /**
	   * Update transform from roam and mapLocation
	   * @private
	   */
	  _updateTransform: function () {
	    var roamTransformable = this._roamTransformable;
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.parent = roamTransformable;
	    roamTransformable.updateTransform();
	    rawTransformable.updateTransform();
	    matrix.copy(this.transform || (this.transform = []), rawTransformable.transform || matrix.create());
	    this._rawTransform = rawTransformable.getLocalTransform();
	    this.invTransform = this.invTransform || [];
	    matrix.invert(this.invTransform, this.transform);
	    this.decomposeTransform();
	  },
	  getTransformInfo: function () {
	    var roamTransform = this._roamTransformable.transform;
	    var rawTransformable = this._rawTransformable;
	    return {
	      roamTransform: roamTransform ? zrUtil.slice(roamTransform) : matrix.create(),
	      rawScale: zrUtil.slice(rawTransformable.scale),
	      rawPosition: zrUtil.slice(rawTransformable.position)
	    };
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRect: function () {
	    return this._viewRect;
	  },
	
	  /**
	   * Get view rect after roam transform
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRectAfterRoam: function () {
	    var rect = this.getBoundingRect().clone();
	    rect.applyTransform(this.transform);
	    return rect;
	  },
	
	  /**
	   * Convert a single (lon, lat) data item to (x, y) point.
	   * @param {Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    var transform = noRoam ? this._rawTransform : this.transform;
	    out = out || [];
	    return transform ? v2ApplyTransform(out, data, transform) : vector.copy(out, data);
	  },
	
	  /**
	   * Convert a (x, y) point to (lon, lat) data
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var invTransform = this.invTransform;
	    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
	  },
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  containPoint: function (point) {
	    return this.getViewRectAfterRoam().contain(point[0], point[1]);
	  }
	  /**
	   * @return {number}
	   */
	  // getScalarScale: function () {
	  //     // Use determinant square root of transform to mutiply scalar
	  //     var m = this.transform;
	  //     var det = Math.sqrt(Math.abs(m[0] * m[3] - m[2] * m[1]));
	  //     return det;
	  // }
	
	};
	zrUtil.mixin(View, Transformable);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var seriesModel = finder.seriesModel;
	  var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
	
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = View;
	module.exports = _default;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(2);
	
	var isObject = _util.isObject;
	var each = _util.each;
	var map = _util.map;
	var indexOf = _util.indexOf;
	var retrieve = _util.retrieve;
	
	var _layout = __webpack_require__(47);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _axisHelper = __webpack_require__(96);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var ifAxisCrossZero = _axisHelper.ifAxisCrossZero;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	var estimateLabelUnionRect = _axisHelper.estimateLabelUnionRect;
	
	var Cartesian2D = __webpack_require__(1817);
	
	var Axis2D = __webpack_require__(1815);
	
	var CoordinateSystem = __webpack_require__(95);
	
	var _dataStackHelper = __webpack_require__(102);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(1818);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Grid is a region which contains at most 4 cartesian systems
	 *
	 * TODO Default cartesian
	 */
	// Depends on GridModel, AxisModel, which performs preprocess.
	
	/**
	 * Check if the axis is used in the specified grid
	 * @inner
	 */
	function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
	  return axisModel.getCoordSysModel() === gridModel;
	}
	
	function Grid(gridModel, ecModel, api) {
	  /**
	   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
	   * @private
	   */
	  this._coordsMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
	   * @private
	   */
	
	  this._coordsList = [];
	  /**
	   * @type {Object.<string, Array.<module:echarts/coord/cartesian/Axis2D>>}
	   * @private
	   */
	
	  this._axesMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
	   * @private
	   */
	
	  this._axesList = [];
	
	  this._initCartesian(gridModel, ecModel, api);
	
	  this.model = gridModel;
	}
	
	var gridProto = Grid.prototype;
	gridProto.type = 'grid';
	gridProto.axisPointerEnabled = true;
	
	gridProto.getRect = function () {
	  return this._rect;
	};
	
	gridProto.update = function (ecModel, api) {
	  var axesMap = this._axesMap;
	
	  this._updateScale(ecModel, this.model);
	
	  each(axesMap.x, function (xAxis) {
	    niceScaleExtent(xAxis.scale, xAxis.model);
	  });
	  each(axesMap.y, function (yAxis) {
	    niceScaleExtent(yAxis.scale, yAxis.model);
	  }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
	
	  var onZeroRecords = {};
	  each(axesMap.x, function (xAxis) {
	    fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
	  });
	  each(axesMap.y, function (yAxis) {
	    fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
	  }); // Resize again if containLabel is enabled
	  // FIXME It may cause getting wrong grid size in data processing stage
	
	  this.resize(this.model, api);
	};
	
	function fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
	  axis.getAxesOnZeroOf = function () {
	    // TODO: onZero of multiple axes.
	    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
	  }; // onZero can not be enabled in these two situations:
	  // 1. When any other axis is a category axis.
	  // 2. When no axis is cross 0 point.
	
	
	  var otherAxes = axesMap[otherAxisDim];
	  var otherAxisOnZeroOf;
	  var axisModel = axis.model;
	  var onZero = axisModel.get('axisLine.onZero');
	  var onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex');
	
	  if (!onZero) {
	    return;
	  } // If target axis is specified.
	
	
	  if (onZeroAxisIndex != null) {
	    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
	      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
	    }
	  } else {
	    // Find the first available other axis.
	    for (var idx in otherAxes) {
	      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
	      // if both onZero, the two Y axes overlap.
	      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
	        otherAxisOnZeroOf = otherAxes[idx];
	        break;
	      }
	    }
	  }
	
	  if (otherAxisOnZeroOf) {
	    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
	  }
	
	  function getOnZeroRecordKey(axis) {
	    return axis.dim + '_' + axis.index;
	  }
	}
	
	function canOnZeroToAxis(axis) {
	  return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
	}
	/**
	 * Resize the grid
	 * @param {module:echarts/coord/cartesian/GridModel} gridModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	gridProto.resize = function (gridModel, api, ignoreContainLabel) {
	  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	  this._rect = gridRect;
	  var axesList = this._axesList;
	  adjustAxes(); // Minus label size
	
	  if (!ignoreContainLabel && gridModel.get('containLabel')) {
	    each(axesList, function (axis) {
	      if (!axis.model.get('axisLabel.inside')) {
	        var labelUnionRect = estimateLabelUnionRect(axis);
	
	        if (labelUnionRect) {
	          var dim = axis.isHorizontal() ? 'height' : 'width';
	          var margin = axis.model.get('axisLabel.margin');
	          gridRect[dim] -= labelUnionRect[dim] + margin;
	
	          if (axis.position === 'top') {
	            gridRect.y += labelUnionRect.height + margin;
	          } else if (axis.position === 'left') {
	            gridRect.x += labelUnionRect.width + margin;
	          }
	        }
	      }
	    });
	    adjustAxes();
	  }
	
	  function adjustAxes() {
	    each(axesList, function (axis) {
	      var isHorizontal = axis.isHorizontal();
	      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(extent[idx], extent[1 - idx]);
	      updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
	    });
	  }
	};
	/**
	 * @param {string} axisType
	 * @param {number} [axisIndex]
	 */
	
	
	gridProto.getAxis = function (axisType, axisIndex) {
	  var axesMapOnDim = this._axesMap[axisType];
	
	  if (axesMapOnDim != null) {
	    if (axisIndex == null) {
	      // Find first axis
	      for (var name in axesMapOnDim) {
	        if (axesMapOnDim.hasOwnProperty(name)) {
	          return axesMapOnDim[name];
	        }
	      }
	    }
	
	    return axesMapOnDim[axisIndex];
	  }
	};
	/**
	 * @return {Array.<module:echarts/coord/Axis>}
	 */
	
	
	gridProto.getAxes = function () {
	  return this._axesList.slice();
	};
	/**
	 * Usage:
	 *      grid.getCartesian(xAxisIndex, yAxisIndex);
	 *      grid.getCartesian(xAxisIndex);
	 *      grid.getCartesian(null, yAxisIndex);
	 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
	 *
	 * @param {number|Object} [xAxisIndex]
	 * @param {number} [yAxisIndex]
	 */
	
	
	gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
	  if (xAxisIndex != null && yAxisIndex != null) {
	    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	    return this._coordsMap[key];
	  }
	
	  if (isObject(xAxisIndex)) {
	    yAxisIndex = xAxisIndex.yAxisIndex;
	    xAxisIndex = xAxisIndex.xAxisIndex;
	  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.
	
	
	  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
	    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
	      return coordList[i];
	    }
	  }
	};
	
	gridProto.getCartesians = function () {
	  return this._coordsList.slice();
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertToPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertFromPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
	};
	/**
	 * @inner
	 */
	
	
	gridProto._findConvertTarget = function (ecModel, finder) {
	  var seriesModel = finder.seriesModel;
	  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
	  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
	  var gridModel = finder.gridModel;
	  var coordsList = this._coordsList;
	  var cartesian;
	  var axis;
	
	  if (seriesModel) {
	    cartesian = seriesModel.coordinateSystem;
	    indexOf(coordsList, cartesian) < 0 && (cartesian = null);
	  } else if (xAxisModel && yAxisModel) {
	    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  } else if (xAxisModel) {
	    axis = this.getAxis('x', xAxisModel.componentIndex);
	  } else if (yAxisModel) {
	    axis = this.getAxis('y', yAxisModel.componentIndex);
	  } // Lowest priority.
	  else if (gridModel) {
	      var grid = gridModel.coordinateSystem;
	
	      if (grid === this) {
	        cartesian = this._coordsList[0];
	      }
	    }
	
	  return {
	    cartesian: cartesian,
	    axis: axis
	  };
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.containPoint = function (point) {
	  var coord = this._coordsList[0];
	
	  if (coord) {
	    return coord.containPoint(point);
	  }
	};
	/**
	 * Initialize cartesian coordinate systems
	 * @private
	 */
	
	
	gridProto._initCartesian = function (gridModel, ecModel, api) {
	  var axisPositionUsed = {
	    left: false,
	    right: false,
	    top: false,
	    bottom: false
	  };
	  var axesMap = {
	    x: {},
	    y: {}
	  };
	  var axesCount = {
	    x: 0,
	    y: 0
	  }; /// Create axis
	
	  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
	  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
	
	  if (!axesCount.x || !axesCount.y) {
	    // Roll back when there no either x or y axis
	    this._axesMap = {};
	    this._axesList = [];
	    return;
	  }
	
	  this._axesMap = axesMap; /// Create cartesian2d
	
	  each(axesMap.x, function (xAxis, xAxisIndex) {
	    each(axesMap.y, function (yAxis, yAxisIndex) {
	      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	      var cartesian = new Cartesian2D(key);
	      cartesian.grid = this;
	      cartesian.model = gridModel;
	      this._coordsMap[key] = cartesian;
	
	      this._coordsList.push(cartesian);
	
	      cartesian.addAxis(xAxis);
	      cartesian.addAxis(yAxis);
	    }, this);
	  }, this);
	
	  function createAxisCreator(axisType) {
	    return function (axisModel, idx) {
	      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var axisPosition = axisModel.get('position');
	
	      if (axisType === 'x') {
	        // Fix position
	        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
	          // Default bottom of X
	          axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
	        }
	      } else {
	        // Fix position
	        if (axisPosition !== 'left' && axisPosition !== 'right') {
	          // Default left of Y
	          axisPosition = axisPositionUsed.left ? 'right' : 'left';
	        }
	      }
	
	      axisPositionUsed[axisPosition] = true;
	      var axis = new Axis2D(axisType, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
	
	      axisModel.axis = axis; // Inject axisModel into axis
	
	      axis.model = axisModel; // Inject grid info axis
	
	      axis.grid = this; // Index of axis, can be used as key
	
	      axis.index = idx;
	
	      this._axesList.push(axis);
	
	      axesMap[axisType][idx] = axis;
	      axesCount[axisType]++;
	    };
	  }
	};
	/**
	 * Update cartesian properties from series
	 * @param  {module:echarts/model/Option} option
	 * @private
	 */
	
	
	gridProto._updateScale = function (ecModel, gridModel) {
	  // Reset scale
	  each(this._axesList, function (axis) {
	    axis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (isCartesian2D(seriesModel)) {
	      var axesModels = findAxesModels(seriesModel, ecModel);
	      var xAxisModel = axesModels[0];
	      var yAxisModel = axesModels[1];
	
	      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	      var data = seriesModel.getData();
	      var xAxis = cartesian.getAxis('x');
	      var yAxis = cartesian.getAxis('y');
	
	      if (data.type === 'list') {
	        unionExtent(data, xAxis, seriesModel);
	        unionExtent(data, yAxis, seriesModel);
	      }
	    }
	  }, this);
	
	  function unionExtent(data, axis, seriesModel) {
	    each(data.mapDimension(axis.dim, true), function (dim) {
	      axis.scale.unionExtentFromData( // For example, the extent of the orginal dimension
	      // is [0.1, 0.5], the extent of the `stackResultDimension`
	      // is [7, 9], the final extent should not include [0.1, 0.5].
	      data, getStackedDimension(data, dim));
	    });
	  }
	};
	/**
	 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
	 * @return {Object} {baseAxes: [], otherAxes: []}
	 */
	
	
	gridProto.getTooltipAxes = function (dim) {
	  var baseAxes = [];
	  var otherAxes = [];
	  each(this.getCartesians(), function (cartesian) {
	    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
	    var otherAxis = cartesian.getOtherAxis(baseAxis);
	    indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
	    indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
	  });
	  return {
	    baseAxes: baseAxes,
	    otherAxes: otherAxes
	  };
	};
	/**
	 * @inner
	 */
	
	
	function updateAxisTransform(axis, coordBase) {
	  var axisExtent = axis.getExtent();
	  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
	
	  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
	    return coord + coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
	    return coord - coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	}
	
	var axesTypes = ['xAxis', 'yAxis'];
	/**
	 * @inner
	 */
	
	function findAxesModels(seriesModel, ecModel) {
	  return map(axesTypes, function (axisType) {
	    var axisModel = seriesModel.getReferringComponents(axisType)[0];
	    return axisModel;
	  });
	}
	/**
	 * @inner
	 */
	
	
	function isCartesian2D(seriesModel) {
	  return seriesModel.get('coordinateSystem') === 'cartesian2d';
	}
	
	Grid.create = function (ecModel, api) {
	  var grids = [];
	  ecModel.eachComponent('grid', function (gridModel, idx) {
	    var grid = new Grid(gridModel, ecModel, api);
	    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
	    // should be performed in create stage.
	
	    grid.resize(gridModel, api, true);
	    gridModel.coordinateSystem = grid;
	    grids.push(grid);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (!isCartesian2D(seriesModel)) {
	      return;
	    }
	
	    var axesModels = findAxesModels(seriesModel, ecModel);
	    var xAxisModel = axesModels[0];
	    var yAxisModel = axesModels[1];
	    var gridModel = xAxisModel.getCoordSysModel();
	    var grid = gridModel.coordinateSystem;
	    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  });
	  return grids;
	}; // For deciding which dimensions to use when creating list data
	
	
	Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
	CoordinateSystem.register('cartesian2d', Grid);
	var _default = Grid;
	module.exports = _default;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var Geo = __webpack_require__(1820);
	
	var layout = __webpack_require__(47);
	
	var numberUtil = __webpack_require__(24);
	
	var geoSourceManager = __webpack_require__(271);
	
	var mapDataStorage = __webpack_require__(429);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Resize method bound to the geo
	 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizeGeo(geoModel, api) {
	  var boundingCoords = geoModel.get('boundingCoords');
	
	  if (boundingCoords != null) {
	    var leftTop = boundingCoords[0];
	    var rightBottom = boundingCoords[1];
	
	    if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) {} else {
	      this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
	    }
	  }
	
	  var rect = this.getBoundingRect();
	  var boxLayoutOption;
	  var center = geoModel.get('layoutCenter');
	  var size = geoModel.get('layoutSize');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var aspect = rect.width / rect.height * this.aspectScale;
	  var useCenterAndSize = false;
	
	  if (center && size) {
	    center = [numberUtil.parsePercent(center[0], viewWidth), numberUtil.parsePercent(center[1], viewHeight)];
	    size = numberUtil.parsePercent(size, Math.min(viewWidth, viewHeight));
	
	    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
	      useCenterAndSize = true;
	    } else {}
	  }
	
	  var viewRect;
	
	  if (useCenterAndSize) {
	    var viewRect = {};
	
	    if (aspect > 1) {
	      // Width is same with size
	      viewRect.width = size;
	      viewRect.height = size / aspect;
	    } else {
	      viewRect.height = size;
	      viewRect.width = size * aspect;
	    }
	
	    viewRect.y = center[1] - viewRect.height / 2;
	    viewRect.x = center[0] - viewRect.width / 2;
	  } else {
	    // Use left/top/width/height
	    boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate
	
	    boxLayoutOption.aspect = aspect;
	    viewRect = layout.getLayoutRect(boxLayoutOption, {
	      width: viewWidth,
	      height: viewHeight
	    });
	  }
	
	  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
	  this.setCenter(geoModel.get('center'));
	  this.setZoom(geoModel.get('zoom'));
	}
	/**
	 * @param {module:echarts/coord/Geo} geo
	 * @param {module:echarts/model/Model} model
	 * @inner
	 */
	
	
	function setGeoCoords(geo, model) {
	  zrUtil.each(model.get('geoCoord'), function (geoCoord, name) {
	    geo.addGeoCoord(name, geoCoord);
	  });
	}
	
	var geoCreator = {
	  // For deciding which dimensions to use when creating list data
	  dimensions: Geo.prototype.dimensions,
	  create: function (ecModel, api) {
	    var geoList = []; // FIXME Create each time may be slow
	
	    ecModel.eachComponent('geo', function (geoModel, idx) {
	      var name = geoModel.get('map');
	      var aspectScale = geoModel.get('aspectScale');
	      var invertLongitute = true;
	      var mapRecords = mapDataStorage.retrieveMap(name);
	
	      if (mapRecords && mapRecords[0] && mapRecords[0].type === 'svg') {
	        aspectScale == null && (aspectScale = 1);
	        invertLongitute = false;
	      } else {
	        aspectScale == null && (aspectScale = 0.75);
	      }
	
	      var geo = new Geo(name + idx, name, geoModel.get('nameMap'), invertLongitute);
	      geo.aspectScale = aspectScale;
	      geo.zoomLimit = geoModel.get('scaleLimit');
	      geoList.push(geo);
	      setGeoCoords(geo, geoModel);
	      geoModel.coordinateSystem = geo;
	      geo.model = geoModel; // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.resize(geoModel, api);
	    });
	    ecModel.eachSeries(function (seriesModel) {
	      var coordSys = seriesModel.get('coordinateSystem');
	
	      if (coordSys === 'geo') {
	        var geoIndex = seriesModel.get('geoIndex') || 0;
	        seriesModel.coordinateSystem = geoList[geoIndex];
	      }
	    }); // If has map series
	
	    var mapModelGroupBySeries = {};
	    ecModel.eachSeriesByType('map', function (seriesModel) {
	      if (!seriesModel.getHostGeoModel()) {
	        var mapType = seriesModel.getMapType();
	        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
	        mapModelGroupBySeries[mapType].push(seriesModel);
	      }
	    });
	    zrUtil.each(mapModelGroupBySeries, function (mapSeries, mapType) {
	      var nameMapList = zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('nameMap');
	      });
	      var geo = new Geo(mapType, mapType, zrUtil.mergeAll(nameMapList));
	      geo.zoomLimit = zrUtil.retrieve.apply(null, zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('scaleLimit');
	      }));
	      geoList.push(geo); // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.aspectScale = mapSeries[0].get('aspectScale');
	      geo.resize(mapSeries[0], api);
	      zrUtil.each(mapSeries, function (singleMapSeries) {
	        singleMapSeries.coordinateSystem = geo;
	        setGeoCoords(geo, singleMapSeries);
	      });
	    });
	    return geoList;
	  },
	
	  /**
	   * Fill given regions array
	   * @param  {Array.<Object>} originRegionArr
	   * @param  {string} mapName
	   * @param  {Object} [nameMap]
	   * @return {Array}
	   */
	  getFilledRegions: function (originRegionArr, mapName, nameMap) {
	    // Not use the original
	    var regionsArr = (originRegionArr || []).slice();
	    var dataNameMap = zrUtil.createHashMap();
	
	    for (var i = 0; i < regionsArr.length; i++) {
	      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
	    }
	
	    var source = geoSourceManager.load(mapName, nameMap);
	    zrUtil.each(source.regions, function (region) {
	      var name = region.name;
	      !dataNameMap.get(name) && regionsArr.push({
	        name: name
	      });
	    });
	    return regionsArr;
	  }
	};
	echarts.registerCoordinateSystem('geo', geoCreator);
	var _default = geoCreator;
	module.exports = _default;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	var isString = _util.isString;
	var isArray = _util.isArray;
	var each = _util.each;
	var assert = _util.assert;
	
	var _parseSVG = __webpack_require__(915);
	
	var parseXML = _parseSVG.parseXML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var storage = createHashMap(); // For minimize the code size of common echarts package,
	// do not put too much logic in this module.
	
	var _default = {
	  // The format of record: see `echarts.registerMap`.
	  // Compatible with previous `echarts.registerMap`.
	  registerMap: function (mapName, rawGeoJson, rawSpecialAreas) {
	    var records;
	
	    if (isArray(rawGeoJson)) {
	      records = rawGeoJson;
	    } else if (rawGeoJson.svg) {
	      records = [{
	        type: 'svg',
	        source: rawGeoJson.svg,
	        specialAreas: rawGeoJson.specialAreas
	      }];
	    } else {
	      // Backward compatibility.
	      if (rawGeoJson.geoJson && !rawGeoJson.features) {
	        rawSpecialAreas = rawGeoJson.specialAreas;
	        rawGeoJson = rawGeoJson.geoJson;
	      }
	
	      records = [{
	        type: 'geoJSON',
	        source: rawGeoJson,
	        specialAreas: rawSpecialAreas
	      }];
	    }
	
	    each(records, function (record) {
	      var type = record.type;
	      type === 'geoJson' && (type = record.type = 'geoJSON');
	      var parse = parsers[type];
	      parse(record);
	    });
	    return storage.set(mapName, records);
	  },
	  retrieveMap: function (mapName) {
	    return storage.get(mapName);
	  }
	};
	var parsers = {
	  geoJSON: function (record) {
	    var source = record.source;
	    record.geoJSON = !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
	  },
	  // Only perform parse to XML object here, which might be time
	  // consiming for large SVG.
	  // Although convert XML to zrender element is also time consiming,
	  // if we do it here, the clone of zrender elements has to be
	  // required. So we do it once for each geo instance, util real
	  // performance issues call for optimizing it.
	  svg: function (record) {
	    record.svgXML = parseXML(record.source);
	  }
	};
	module.exports = _default;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var Polar = __webpack_require__(1836);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	var _axisHelper = __webpack_require__(96);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(95);
	
	var _dataStackHelper = __webpack_require__(102);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(1837);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Axis scale
	
	/**
	 * Resize method bound to the polar
	 * @param {module:echarts/coord/polar/PolarModel} polarModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizePolar(polar, polarModel, api) {
	  var center = polarModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  polar.cx = parsePercent(center[0], width);
	  polar.cy = parsePercent(center[1], height);
	  var radiusAxis = polar.getRadiusAxis();
	  var size = Math.min(width, height) / 2;
	  var radius = polarModel.get('radius');
	
	  if (radius == null) {
	    radius = [0, '100%'];
	  } else if (!zrUtil.isArray(radius)) {
	    // r0 = 0
	    radius = [0, radius];
	  }
	
	  radius = [parsePercent(radius[0], size), parsePercent(radius[1], size)];
	  radiusAxis.inverse ? radiusAxis.setExtent(radius[1], radius[0]) : radiusAxis.setExtent(radius[0], radius[1]);
	}
	/**
	 * Update polar
	 */
	
	
	function updatePolarScale(ecModel, api) {
	  var polar = this;
	  var angleAxis = polar.getAngleAxis();
	  var radiusAxis = polar.getRadiusAxis(); // Reset scale
	
	  angleAxis.scale.setExtent(Infinity, -Infinity);
	  radiusAxis.scale.setExtent(Infinity, -Infinity);
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.coordinateSystem === polar) {
	      var data = seriesModel.getData();
	      zrUtil.each(data.mapDimension('radius', true), function (dim) {
	        radiusAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	      zrUtil.each(data.mapDimension('angle', true), function (dim) {
	        angleAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	    }
	  });
	  niceScaleExtent(angleAxis.scale, angleAxis.model);
	  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis
	
	  if (angleAxis.type === 'category' && !angleAxis.onBand) {
	    var extent = angleAxis.getExtent();
	    var diff = 360 / angleAxis.scale.count();
	    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
	    angleAxis.setExtent(extent[0], extent[1]);
	  }
	}
	/**
	 * Set common axis properties
	 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	 * @param {module:echarts/coord/polar/AxisModel}
	 * @inner
	 */
	
	
	function setAxis(axis, axisModel) {
	  axis.type = axisModel.get('type');
	  axis.scale = createScaleByModel(axisModel);
	  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
	  axis.inverse = axisModel.get('inverse');
	
	  if (axisModel.mainType === 'angleAxis') {
	    axis.inverse ^= axisModel.get('clockwise');
	    var startAngle = axisModel.get('startAngle');
	    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
	  } // Inject axis instance
	
	
	  axisModel.axis = axis;
	  axis.model = axisModel;
	}
	
	var polarCreator = {
	  dimensions: Polar.prototype.dimensions,
	  create: function (ecModel, api) {
	    var polarList = [];
	    ecModel.eachComponent('polar', function (polarModel, idx) {
	      var polar = new Polar(idx); // Inject resize and update method
	
	      polar.update = updatePolarScale;
	      var radiusAxis = polar.getRadiusAxis();
	      var angleAxis = polar.getAngleAxis();
	      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	      var angleAxisModel = polarModel.findAxisModel('angleAxis');
	      setAxis(radiusAxis, radiusAxisModel);
	      setAxis(angleAxis, angleAxisModel);
	      resizePolar(polar, polarModel, api);
	      polarList.push(polar);
	      polarModel.coordinateSystem = polar;
	      polar.model = polarModel;
	    }); // Inject coordinateSystem to series
	
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.get('coordinateSystem') === 'polar') {
	        var polarModel = ecModel.queryComponents({
	          mainType: 'polar',
	          index: seriesModel.get('polarIndex'),
	          id: seriesModel.get('polarId')
	        })[0];
	        seriesModel.coordinateSystem = polarModel.coordinateSystem;
	      }
	    });
	    return polarList;
	  }
	};
	CoordinateSystem.register('polar', polarCreator);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var linkList = __webpack_require__(851);
	
	var List = __webpack_require__(88);
	
	var createDimensions = __webpack_require__(176);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Tree data structure
	 *
	 * @module echarts/data/Tree
	 */
	
	/**
	 * @constructor module:echarts/data/Tree~TreeNode
	 * @param {string} name
	 * @param {module:echarts/data/Tree} hostTree
	 */
	var TreeNode = function (name, hostTree) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * Depth of node
	   *
	   * @type {number}
	   * @readOnly
	   */
	
	  this.depth = 0;
	  /**
	   * Height of the subtree rooted at this node.
	   * @type {number}
	   * @readOnly
	   */
	
	  this.height = 0;
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	
	  this.parentNode = null;
	  /**
	   * Reference to list item.
	   * Do not persistent dataIndex outside,
	   * besause it may be changed by list.
	   * If dataIndex -1,
	   * this node is logical deleted (filtered) in list.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.dataIndex = -1;
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @readOnly
	   */
	
	  this.children = [];
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @pubilc
	   */
	
	  this.viewChildren = [];
	  /**
	   * @type {moduel:echarts/data/Tree}
	   * @readOnly
	   */
	
	  this.hostTree = hostTree;
	};
	
	TreeNode.prototype = {
	  constructor: TreeNode,
	
	  /**
	   * The node is removed.
	   * @return {boolean} is removed.
	   */
	  isRemoved: function () {
	    return this.dataIndex < 0;
	  },
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb If in preorder and return false,
	   *                      its subtree will not be visited.
	   * @param {Object} [context]
	   */
	  eachNode: function (options, cb, context) {
	    if (typeof options === 'function') {
	      context = cb;
	      cb = options;
	      options = null;
	    }
	
	    options = options || {};
	
	    if (zrUtil.isString(options)) {
	      options = {
	        order: options
	      };
	    }
	
	    var order = options.order || 'preorder';
	    var children = this[options.attr || 'children'];
	    var suppressVisitSub;
	    order === 'preorder' && (suppressVisitSub = cb.call(context, this));
	
	    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
	      children[i].eachNode(options, cb, context);
	    }
	
	    order === 'postorder' && cb.call(context, this);
	  },
	
	  /**
	   * Update depth and height of this subtree.
	   *
	   * @param  {number} depth
	   */
	  updateDepthAndHeight: function (depth) {
	    var height = 0;
	    this.depth = depth;
	
	    for (var i = 0; i < this.children.length; i++) {
	      var child = this.children[i];
	      child.updateDepthAndHeight(depth + 1);
	
	      if (child.height > height) {
	        height = child.height;
	      }
	    }
	
	    this.height = height + 1;
	  },
	
	  /**
	   * @param  {string} id
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeById: function (id) {
	    if (this.getId() === id) {
	      return this;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].getNodeById(id);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~TreeNode} node
	   * @return {boolean}
	   */
	  contains: function (node) {
	    if (node === this) {
	      return true;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].contains(node);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {boolean} includeSelf Default false.
	   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
	   */
	  getAncestors: function (includeSelf) {
	    var ancestors = [];
	    var node = includeSelf ? this : this.parentNode;
	
	    while (node) {
	      ancestors.push(node);
	      node = node.parentNode;
	    }
	
	    ancestors.reverse();
	    return ancestors;
	  },
	
	  /**
	   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
	   * @return {number} Value.
	   */
	  getValue: function (dimension) {
	    var data = this.hostTree.data;
	    return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	  },
	
	  /**
	   * @param {Object} layout
	   * @param {boolean=} [merge=false]
	   */
	  setLayout: function (layout, merge) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
	  },
	
	  /**
	   * @return {Object} layout
	   */
	  getLayout: function () {
	    return this.hostTree.data.getItemLayout(this.dataIndex);
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var hostTree = this.hostTree;
	    var itemModel = hostTree.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  },
	
	  /**
	   * @example
	   *  setItemVisual('color', color);
	   *  setItemVisual({
	   *      'color': color
	   *  });
	   */
	  setVisual: function (key, value) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
	  },
	
	  /**
	   * Get item visual
	   */
	  getVisual: function (key, ignoreParent) {
	    return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
	  },
	
	  /**
	   * @public
	   * @return {number}
	   */
	  getRawIndex: function () {
	    return this.hostTree.data.getRawIndex(this.dataIndex);
	  },
	
	  /**
	   * @public
	   * @return {string}
	   */
	  getId: function () {
	    return this.hostTree.data.getId(this.dataIndex);
	  },
	
	  /**
	   * if this is an ancestor of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is ancestor
	   */
	  isAncestorOf: function (node) {
	    var parent = node.parentNode;
	
	    while (parent) {
	      if (parent === this) {
	        return true;
	      }
	
	      parent = parent.parentNode;
	    }
	
	    return false;
	  },
	
	  /**
	   * if this is an descendant of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is descendant
	   */
	  isDescendantOf: function (node) {
	    return node !== this && node.isAncestorOf(this);
	  }
	};
	/**
	 * @constructor
	 * @alias module:echarts/data/Tree
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	function Tree(hostModel) {
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	  this.root;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * Index of each item is the same as the raw index of coresponding list item.
	   * @private
	   * @type {Array.<module:echarts/data/Tree~TreeNode}
	   */
	
	  this._nodes = [];
	  /**
	   * @private
	   * @readOnly
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	}
	
	Tree.prototype = {
	  constructor: Tree,
	  type: 'tree',
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb
	   * @param {Object}   [context]
	   */
	  eachNode: function (options, cb, context) {
	    this.root.eachNode(options, cb, context);
	  },
	
	  /**
	   * @param {number} dataIndex
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByDataIndex: function (dataIndex) {
	    var rawIndex = this.data.getRawIndex(dataIndex);
	    return this._nodes[rawIndex];
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByName: function (name) {
	    return this.root.getNodeByName(name);
	  },
	
	  /**
	   * Update item available by list,
	   * when list has been performed options like 'filterSelf' or 'map'.
	   */
	  update: function () {
	    var data = this.data;
	    var nodes = this._nodes;
	
	    for (var i = 0, len = nodes.length; i < len; i++) {
	      nodes[i].dataIndex = -1;
	    }
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      nodes[data.getRawIndex(i)].dataIndex = i;
	    }
	  },
	
	  /**
	   * Clear all layouts
	   */
	  clearLayouts: function () {
	    this.data.clearItemLayouts();
	  }
	};
	/**
	 * data node format:
	 * {
	 *     name: ...
	 *     value: ...
	 *     children: [
	 *         {
	 *             name: ...
	 *             value: ...
	 *             children: ...
	 *         },
	 *         ...
	 *     ]
	 * }
	 *
	 * @static
	 * @param {Object} dataRoot Root node.
	 * @param {module:echarts/model/Model} hostModel
	 * @return module:echarts/data/Tree
	 */
	
	Tree.createTree = function (dataRoot, hostModel, beforeLink) {
	  var tree = new Tree(hostModel);
	  var listData = [];
	  var dimMax = 1;
	  buildHierarchy(dataRoot);
	
	  function buildHierarchy(dataNode, parentNode) {
	    var value = dataNode.value;
	    dimMax = Math.max(dimMax, zrUtil.isArray(value) ? value.length : 1);
	    listData.push(dataNode);
	    var node = new TreeNode(dataNode.name, tree);
	    parentNode ? addChild(node, parentNode) : tree.root = node;
	
	    tree._nodes.push(node);
	
	    var children = dataNode.children;
	
	    if (children) {
	      for (var i = 0; i < children.length; i++) {
	        buildHierarchy(children[i], node);
	      }
	    }
	  }
	
	  tree.root.updateDepthAndHeight(0);
	  var dimensionsInfo = createDimensions(listData, {
	    coordDimensions: ['value'],
	    dimensionsCount: dimMax
	  });
	  var list = new List(dimensionsInfo, hostModel);
	  list.initData(listData);
	  beforeLink && beforeLink(list);
	  linkList({
	    mainData: list,
	    struct: tree,
	    structAttr: 'tree'
	  });
	  tree.update();
	  return tree;
	};
	/**
	 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
	 * so this function is not ready and not necessary to be public.
	 *
	 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
	 */
	
	
	function addChild(child, node) {
	  var children = node.children;
	
	  if (child.parentNode === node) {
	    return;
	  }
	
	  children.push(child);
	  child.parentNode = node;
	}
	
	var _default = Tree;
	module.exports = _default;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(143);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	var _format = __webpack_require__(48);
	
	var getTooltipMarker = _format.getTooltipMarker;
	var formatTpl = _format.formatTpl;
	
	var _model = __webpack_require__(27);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DIMENSION_LABEL_REG = /\{@(.+?)\}/g; // PENDING A little ugly
	
	var _default = {
	  /**
	   * Get params for formatter
	   * @param {number} dataIndex
	   * @param {string} [dataType]
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex, dataType) {
	    var data = this.getData(dataType);
	    var rawValue = this.getRawValue(dataIndex, dataType);
	    var rawDataIndex = data.getRawIndex(dataIndex);
	    var name = data.getName(dataIndex);
	    var itemOpt = data.getRawDataItem(dataIndex);
	    var color = data.getItemVisual(dataIndex, 'color');
	    var borderColor = data.getItemVisual(dataIndex, 'borderColor');
	    var tooltipModel = this.ecModel.getComponent('tooltip');
	    var renderModeOption = tooltipModel && tooltipModel.get('renderMode');
	    var renderMode = getTooltipRenderMode(renderModeOption);
	    var mainType = this.mainType;
	    var isSeries = mainType === 'series';
	    var userOutput = data.userOutput;
	    return {
	      componentType: mainType,
	      componentSubType: this.subType,
	      componentIndex: this.componentIndex,
	      seriesType: isSeries ? this.subType : null,
	      seriesIndex: this.seriesIndex,
	      seriesId: isSeries ? this.id : null,
	      seriesName: isSeries ? this.name : null,
	      name: name,
	      dataIndex: rawDataIndex,
	      data: itemOpt,
	      dataType: dataType,
	      value: rawValue,
	      color: color,
	      borderColor: borderColor,
	      dimensionNames: userOutput ? userOutput.dimensionNames : null,
	      encode: userOutput ? userOutput.encode : null,
	      marker: getTooltipMarker({
	        color: color,
	        renderMode: renderMode
	      }),
	      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
	      $vars: ['seriesName', 'name', 'value']
	    };
	  },
	
	  /**
	   * Format label
	   * @param {number} dataIndex
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @param {string} [dataType]
	   * @param {number} [dimIndex] Only used in some chart that
	   *        use formatter in different dimensions, like radar.
	   * @param {string} [labelProp='label']
	   * @return {string} If not formatter, return null/undefined
	   */
	  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
	    status = status || 'normal';
	    var data = this.getData(dataType);
	    var itemModel = data.getItemModel(dataIndex);
	    var params = this.getDataParams(dataIndex, dataType);
	
	    if (dimIndex != null && params.value instanceof Array) {
	      params.value = params.value[dimIndex];
	    }
	
	    var formatter = itemModel.get(status === 'normal' ? [labelProp || 'label', 'formatter'] : [status, labelProp || 'label', 'formatter']);
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      params.dimensionIndex = dimIndex;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
	      // Do not support '}' in dim name util have to.
	
	      return str.replace(DIMENSION_LABEL_REG, function (origin, dim) {
	        var len = dim.length;
	
	        if (dim.charAt(0) === '[' && dim.charAt(len - 1) === ']') {
	          dim = +dim.slice(1, len - 1); // Also: '[]' => 0
	        }
	
	        return retrieveRawValue(data, dataIndex, dim);
	      });
	    }
	  },
	
	  /**
	   * Get raw value in option
	   * @param {number} idx
	   * @param {string} [dataType]
	   * @return {Array|number|string}
	   */
	  getRawValue: function (idx, dataType) {
	    return retrieveRawValue(this.getData(dataType), idx);
	  },
	
	  /**
	   * Should be implemented.
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @return {string} tooltip string
	   */
	  formatTooltip: function () {// Empty function
	  }
	};
	module.exports = _default;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var assert = _util.assert;
	var isArray = _util.isArray;
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} define
	 * @return See the return of `createTask`.
	 */
	function createTask(define) {
	  return new Task(define);
	}
	/**
	 * @constructor
	 * @param {Object} define
	 * @param {Function} define.reset Custom reset
	 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
	 * @param {Function} [define.count] count is used to determin data task.
	 * @param {Function} [define.onDirty] count is used to determin data task.
	 */
	
	
	function Task(define) {
	  define = define || {};
	  this._reset = define.reset;
	  this._plan = define.plan;
	  this._count = define.count;
	  this._onDirty = define.onDirty;
	  this._dirty = true; // Context must be specified implicitly, to
	  // avoid miss update context when model changed.
	
	  this.context;
	}
	
	var taskProto = Task.prototype;
	/**
	 * @param {Object} performArgs
	 * @param {number} [performArgs.step] Specified step.
	 * @param {number} [performArgs.skip] Skip customer perform call.
	 * @param {number} [performArgs.modBy] Sampling window size.
	 * @param {number} [performArgs.modDataCount] Sampling count.
	 */
	
	taskProto.perform = function (performArgs) {
	  var upTask = this._upstream;
	  var skip = performArgs && performArgs.skip; // TODO some refactor.
	  // Pull data. Must pull data each time, because context.data
	  // may be updated by Series.setData.
	
	  if (this._dirty && upTask) {
	    var context = this.context;
	    context.data = context.outputData = upTask.context.outputData;
	  }
	
	  if (this.__pipeline) {
	    this.__pipeline.currentTask = this;
	  }
	
	  var planResult;
	
	  if (this._plan && !skip) {
	    planResult = this._plan(this.context);
	  } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
	  // elements uniformed distributed when progress, especially when moving or zooming.
	
	
	  var lastModBy = normalizeModBy(this._modBy);
	  var lastModDataCount = this._modDataCount || 0;
	  var modBy = normalizeModBy(performArgs && performArgs.modBy);
	  var modDataCount = performArgs && performArgs.modDataCount || 0;
	
	  if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
	    planResult = 'reset';
	  }
	
	  function normalizeModBy(val) {
	    !(val >= 1) && (val = 1); // jshint ignore:line
	
	    return val;
	  }
	
	  var forceFirstProgress;
	
	  if (this._dirty || planResult === 'reset') {
	    this._dirty = false;
	    forceFirstProgress = reset(this, skip);
	  }
	
	  this._modBy = modBy;
	  this._modDataCount = modDataCount;
	  var step = performArgs && performArgs.step;
	
	  if (upTask) {
	    this._dueEnd = upTask._outputDueEnd;
	  } // DataTask or overallTask
	  else {
	      this._dueEnd = this._count ? this._count(this.context) : Infinity;
	    } // Note: Stubs, that its host overall task let it has progress, has progress.
	  // If no progress, pass index from upstream to downstream each time plan called.
	
	
	  if (this._progress) {
	    var start = this._dueIndex;
	    var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
	
	    if (!skip && (forceFirstProgress || start < end)) {
	      var progress = this._progress;
	
	      if (isArray(progress)) {
	        for (var i = 0; i < progress.length; i++) {
	          doProgress(this, progress[i], start, end, modBy, modDataCount);
	        }
	      } else {
	        doProgress(this, progress, start, end, modBy, modDataCount);
	      }
	    }
	
	    this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
	    // input data is the same, so use `dueIndex` as `outputDueEnd`.
	
	    var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
	    this._outputDueEnd = outputDueEnd;
	  } else {
	    // (1) Some overall task has no progress.
	    // (2) Stubs, that its host overall task do not let it has progress, has no progress.
	    // This should always be performed so it can be passed to downstream.
	    this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
	  }
	
	  return this.unfinished();
	};
	
	var iterator = function () {
	  var end;
	  var current;
	  var modBy;
	  var modDataCount;
	  var winCount;
	  var it = {
	    reset: function (s, e, sStep, sCount) {
	      current = s;
	      end = e;
	      modBy = sStep;
	      modDataCount = sCount;
	      winCount = Math.ceil(modDataCount / modBy);
	      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
	    }
	  };
	  return it;
	
	  function sequentialNext() {
	    return current < end ? current++ : null;
	  }
	
	  function modNext() {
	    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
	    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
	    // Use normal linear rendering mode.
	    : current;
	    current++;
	    return result;
	  }
	}();
	
	taskProto.dirty = function () {
	  this._dirty = true;
	  this._onDirty && this._onDirty(this.context);
	};
	
	function doProgress(taskIns, progress, start, end, modBy, modDataCount) {
	  iterator.reset(start, end, modBy, modDataCount);
	  taskIns._callingProgress = progress;
	
	  taskIns._callingProgress({
	    start: start,
	    end: end,
	    count: end - start,
	    next: iterator.next
	  }, taskIns.context);
	}
	
	function reset(taskIns, skip) {
	  taskIns._dueIndex = taskIns._outputDueEnd = taskIns._dueEnd = 0;
	  taskIns._settedOutputEnd = null;
	  var progress;
	  var forceFirstProgress;
	
	  if (!skip && taskIns._reset) {
	    progress = taskIns._reset(taskIns.context);
	
	    if (progress && progress.progress) {
	      forceFirstProgress = progress.forceFirstProgress;
	      progress = progress.progress;
	    } // To simplify no progress checking, array must has item.
	
	
	    if (isArray(progress) && !progress.length) {
	      progress = null;
	    }
	  }
	
	  taskIns._progress = progress;
	  taskIns._modBy = taskIns._modDataCount = null;
	  var downstream = taskIns._downstream;
	  downstream && downstream.dirty();
	  return forceFirstProgress;
	}
	/**
	 * @return {boolean}
	 */
	
	
	taskProto.unfinished = function () {
	  return this._progress && this._dueIndex < this._dueEnd;
	};
	/**
	 * @param {Object} downTask The downstream task.
	 * @return {Object} The downstream task.
	 */
	
	
	taskProto.pipe = function (downTask) {
	  // If already downstream, do not dirty downTask.
	  if (this._downstream !== downTask || this._dirty) {
	    this._downstream = downTask;
	    downTask._upstream = this;
	    downTask.dirty();
	  }
	};
	
	taskProto.dispose = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  this._upstream && (this._upstream._downstream = null);
	  this._downstream && (this._downstream._upstream = null);
	  this._dirty = false;
	  this._disposed = true;
	};
	
	taskProto.getUpstream = function () {
	  return this._upstream;
	};
	
	taskProto.getDownstream = function () {
	  return this._downstream;
	};
	
	taskProto.setOutputEnd = function (end) {
	  // This only happend in dataTask, dataZoom, map, currently.
	  // where dataZoom do not set end each time, but only set
	  // when reset. So we should record the setted end, in case
	  // that the stub of dataZoom perform again and earse the
	  // setted end by upstream.
	  this._outputDueEnd = this._settedOutputEnd = end;
	}; ///////////////////////////////////////////////////////////
	// For stream debug (Should be commented out after used!)
	// Usage: printTask(this, 'begin');
	// Usage: printTask(this, null, {someExtraProp});
	// function printTask(task, prefix, extra) {
	//     window.ecTaskUID == null && (window.ecTaskUID = 0);
	//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
	//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
	//     var props = [];
	//     if (task.__pipeline) {
	//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
	//         props.push({text: 'idx', value: val});
	//     } else {
	//         var stubCount = 0;
	//         task.agentStubMap.each(() => stubCount++);
	//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
	//     }
	//     props.push({text: 'uid', value: task.uidDebug});
	//     if (task.__pipeline) {
	//         props.push({text: 'pid', value: task.__pipeline.id});
	//         task.agent && props.push(
	//             {text: 'stubFor', value: task.agent.uidDebug}
	//         );
	//     }
	//     props.push(
	//         {text: 'dirty', value: task._dirty},
	//         {text: 'dueIndex', value: task._dueIndex},
	//         {text: 'dueEnd', value: task._dueEnd},
	//         {text: 'outputDueEnd', value: task._outputDueEnd}
	//     );
	//     if (extra) {
	//         Object.keys(extra).forEach(key => {
	//             props.push({text: key, value: extra[key]});
	//         });
	//     }
	//     var args = ['color: blue'];
	//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
	//         args.push('color: black', 'color: red'),
	//         `${item.text}: %c${item.value}`
	//     )).join('%c, ');
	//     console.log.apply(console, [msg].concat(args));
	//     // console.log(this);
	// }
	
	
	exports.createTask = createTask;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	
	    }
	
	    return output;
	};
	
	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }
	
	    }
	
	    return output;
	
	};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content, compressionOptions) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = __webpack_require__(1878);


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	module.exports = function(data, encoding){
	    return new Buffer(data, encoding);
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(795).Buffer))

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(178);
	var utils = __webpack_require__(97);
	var crc32 = __webpack_require__(1876);
	var signature = __webpack_require__(863);
	var defaults = __webpack_require__(862);
	var base64 = __webpack_require__(434);
	var compressions = __webpack_require__(435);
	var CompressedObject = __webpack_require__(860);
	var nodeBuffer = __webpack_require__(436);
	var utf8 = __webpack_require__(866);
	var StringWriter = __webpack_require__(1882);
	var Uint8ArrayWriter = __webpack_require__(1883);
	
	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;
	
	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};
	
	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};
	
	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }
	
	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	    this.unixPermissions = options.unixPermissions;
	    this.dosPermissions = options.dosPermissions;
	
	    this._data = data;
	    this.options = options;
	
	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = utils.extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();
	
	    return o;
	};
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	    o = prepareFileAttrs(o);
	
	    if (typeof o.unixPermissions === "string") {
	        o.unixPermissions = parseInt(o.unixPermissions, 8);
	    }
	
	    // UNX_IFDIR  0040000 see zipinfo.c
	    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
	        o.dir = true;
	    }
	    // Bit 4    Directory
	    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
	        o.dir = true;
	    }
	
	    if (o.dir) {
	        name = forceTrailingSlash(name);
	    }
	
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	        dataType = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;
	
	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }
	
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }
	
	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	
	/**
	 * Returns the path with a slash at the end.
	 * @private
	 * @param {String} path the path to check.
	 * @return {String} the path with a trailing slash.
	 */
	var forceTrailingSlash = function(path) {
	    // Check the name ends with a /
	    if (path.slice(-1) != "/") {
	        path += "/"; // IE doesn't like substr(-1)
	    }
	    return path;
	};
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;
	
	    name = forceTrailingSlash(name);
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @param {Object} compressionOptions the options to use when compressing.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression, compressionOptions) {
	    var result = new CompressedObject(),
	        content;
	
	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;
	
	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
	    }
	
	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;
	
	    return result;
	};
	
	
	
	
	/**
	 * Generate the UNIX part of the external file attributes.
	 * @param {Object} unixPermissions the unix permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
	 *
	 * TTTTsstrwxrwxrwx0000000000ADVSHR
	 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
	 *     ^^^_________________________ setuid, setgid, sticky
	 *        ^^^^^^^^^________________ permissions
	 *                 ^^^^^^^^^^______ not used ?
	 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
	 */
	var generateUnixExternalFileAttr = function (unixPermissions, isDir) {
	
	    var result = unixPermissions;
	    if (!unixPermissions) {
	        // I can't use octal values in strict mode, hence the hexa.
	        //  040775 => 0x41fd
	        // 0100664 => 0x81b4
	        result = isDir ? 0x41fd : 0x81b4;
	    }
	
	    return (result & 0xFFFF) << 16;
	};
	
	/**
	 * Generate the DOS part of the external file attributes.
	 * @param {Object} dosPermissions the dos permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * Bit 0     Read-Only
	 * Bit 1     Hidden
	 * Bit 2     System
	 * Bit 3     Volume Label
	 * Bit 4     Directory
	 * Bit 5     Archive
	 */
	var generateDosExternalFileAttr = function (dosPermissions, isDir) {
	
	    // the dir flag is already set for compatibility
	
	    return (dosPermissions || 0)  & 0x3F;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
	 * @param {Function} encodeFileName the function to encode the file name / comment.
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset, platform, encodeFileName) {
	    var data = compressedObject.compressedContent,
	        useCustomEncoding = encodeFileName !== utf8.utf8encode,
	        encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        encodedComment = utils.transformTo("string", encodeFileName(comment)),
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;
	
	
	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }
	
	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }
	
	    var extFileAttr = 0;
	    var versionMadeBy = 0;
	    if (dir) {
	        // dos or unix, we set the dos dir flag
	        extFileAttr |= 0x00010;
	    }
	    if(platform === "UNIX") {
	        versionMadeBy = 0x031E; // UNIX, version 3.0
	        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
	    } else { // DOS or other, fallback to DOS
	        versionMadeBy = 0x0014; // DOS, version 2.0
	        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;
	
	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(encodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(encodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += !useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(encodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    decToHex(versionMadeBy, 2) +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(encodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    // internal file attributes TODO
	    "\x00\x00" +
	    // external file attributes
	    decToHex(extFileAttr, 4) +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    encodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    encodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};
	
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, utils.extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = utils.extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            compressionOptions : null,
	            type: "base64",
	            platform: "DOS",
	            comment: null,
	            mimeType: 'application/zip',
	            encodeFileName: utf8.utf8encode
	        });
	
	        utils.checkSupport(options.type);
	
	        // accept nodejs `process.platform`
	        if(
	          options.platform === 'darwin' ||
	          options.platform === 'freebsd' ||
	          options.platform === 'linux' ||
	          options.platform === 'sunos'
	        ) {
	          options.platform = "UNIX";
	        }
	        if (options.platform === 'win32') {
	          options.platform = "DOS";
	        }
	
	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            encodedComment = utils.transformTo("string", options.encodeFileName(options.comment || this.comment || ""));
	
	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            var file = this.files[name];
	
	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
	
	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression, compressionOptions);
	
	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength, options.platform, options.encodeFileName);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }
	
	        var dirEnd = "";
	
	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(encodedComment.length, 2) +
	        // .ZIP file comment
	        encodedComment;
	
	
	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }
	
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }
	
	        writer.append(dirEnd);
	
	        var zip = writer.finalize();
	
	
	
	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip), options.mimeType);
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }
	
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(869),
	    castFunction = __webpack_require__(870);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _checkboard = __webpack_require__(1966);
	
	var checkboard = _interopRequireWildcard(_checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkboard = exports.Checkboard = function Checkboard(_ref) {
	  var white = _ref.white,
	      grey = _ref.grey,
	      size = _ref.size,
	      renderers = _ref.renderers,
	      borderRadius = _ref.borderRadius,
	      boxShadow = _ref.boxShadow,
	      children = _ref.children;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      grid: {
	        borderRadius: borderRadius,
	        boxShadow: boxShadow,
	        absolute: '0px 0px 0px 0px',
	        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
	      }
	    }
	  });
	  return (0, _react.isValidElement)(children) ? _react2.default.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : _react2.default.createElement('div', { style: styles.grid });
	};
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: 'transparent',
	  grey: 'rgba(0,0,0,.08)',
	  renderers: {}
	};
	
	exports.default = Checkboard;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addClassName = addClassName;
	exports.addEvent = addEvent;
	exports.addUserSelectStyles = addUserSelectStyles;
	exports.createCSSTransform = createCSSTransform;
	exports.createSVGTransform = createSVGTransform;
	exports.getTouch = getTouch;
	exports.getTouchIdentifier = getTouchIdentifier;
	exports.getTranslation = getTranslation;
	exports.innerHeight = innerHeight;
	exports.innerWidth = innerWidth;
	exports.matchesSelector = matchesSelector;
	exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
	exports.offsetXYFromParent = offsetXYFromParent;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.removeClassName = removeClassName;
	exports.removeEvent = removeEvent;
	exports.removeUserSelectStyles = removeUserSelectStyles;
	
	var _shims = __webpack_require__(278);
	
	var _getPrefix = _interopRequireWildcard(__webpack_require__(1973));
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var matchesSelectorFunc = '';
	
	function matchesSelector(el
	/*: Node*/
	, selector
	/*: string*/
	)
	/*: boolean*/
	{
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return (0, _shims.isFunction)(el[method]);
	    });
	  } // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	
	
	  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable
	
	  return el[matchesSelectorFunc](selector);
	} // Works up the tree to the draggable itself attempting to match selector.
	
	
	function matchesSelectorAndParentsTo(el
	/*: Node*/
	, selector
	/*: string*/
	, baseNode
	/*: Node*/
	)
	/*: boolean*/
	{
	  var node = el;
	
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);
	
	  return false;
	}
	
	function addEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.addEventListener) {
	    el.addEventListener(event, handler, options);
	  } else if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}
	
	function removeEvent(el
	/*: ?Node*/
	, event
	/*: string*/
	, handler
	/*: Function*/
	, inputOptions
	/*: Object*/
	)
	/*: void*/
	{
	  if (!el) return;
	
	  var options = _objectSpread({
	    capture: true
	  }, inputOptions); // $FlowIgnore[method-unbinding]
	
	
	  if (el.removeEventListener) {
	    el.removeEventListener(event, handler, options);
	  } else if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}
	
	function outerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += (0, _shims.int)(computedStyle.borderTopWidth);
	  height += (0, _shims.int)(computedStyle.borderBottomWidth);
	  return height;
	}
	
	function outerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += (0, _shims.int)(computedStyle.borderLeftWidth);
	  width += (0, _shims.int)(computedStyle.borderRightWidth);
	  return width;
	}
	
	function innerHeight(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= (0, _shims.int)(computedStyle.paddingTop);
	  height -= (0, _shims.int)(computedStyle.paddingBottom);
	  return height;
	}
	
	function innerWidth(node
	/*: HTMLElement*/
	)
	/*: number*/
	{
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= (0, _shims.int)(computedStyle.paddingLeft);
	  width -= (0, _shims.int)(computedStyle.paddingRight);
	  return width;
	}
	/*:: interface EventWithOffset {
	  clientX: number, clientY: number
	}*/
	
	
	// Get from offsetParent
	function offsetXYFromParent(evt
	/*: EventWithOffset*/
	, offsetParent
	/*: HTMLElement*/
	, scale
	/*: number*/
	)
	/*: ControlPosition*/
	{
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? {
	    left: 0,
	    top: 0
	  } : offsetParent.getBoundingClientRect();
	  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
	  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
	  return {
	    x: x,
	    y: y
	  };
	}
	
	function createCSSTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: Object*/
	{
	  var translation = getTranslation(controlPos, positionOffset, 'px');
	  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
	}
	
	function createSVGTransform(controlPos
	/*: ControlPosition*/
	, positionOffset
	/*: PositionOffsetControlPosition*/
	)
	/*: string*/
	{
	  var translation = getTranslation(controlPos, positionOffset, '');
	  return translation;
	}
	
	function getTranslation(_ref2, positionOffset
	/*: PositionOffsetControlPosition*/
	, unitSuffix
	/*: string*/
	)
	/*: string*/
	{
	  var x = _ref2.x,
	      y = _ref2.y;
	  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
	
	  if (positionOffset) {
	    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
	    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
	    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
	  }
	
	  return translation;
	}
	
	function getTouch(e
	/*: MouseTouchEvent*/
	, identifier
	/*: number*/
	)
	/*: ?{clientX: number, clientY: number}*/
	{
	  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}
	
	function getTouchIdentifier(e
	/*: MouseTouchEvent*/
	)
	/*: ?number*/
	{
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	} // User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.
	// Note we're passing `document` b/c we could be iframed
	
	
	function addUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}
	
	function removeUserSelectStyles(doc
	/*: ?Document*/
	) {
	  if (!doc) return;
	
	  try {
	    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE
	
	    if (doc.selection) {
	      // $FlowIgnore: IE
	      doc.selection.empty();
	    } else {
	      // Remove selection caused by scroll, unless it's a focused input
	      // (we use doc.defaultView in case we're in an iframe)
	      var selection = (doc.defaultView || window).getSelection();
	
	      if (selection && selection.type !== 'Caret') {
	        selection.removeAllRanges();
	      }
	    }
	  } catch (e) {// probably IE
	  }
	}
	
	function addClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
	      el.className += " ".concat(className);
	    }
	  }
	}
	
	function removeClassName(el
	/*: HTMLElement*/
	, className
	/*: string*/
	) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
	  }
	}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = function() {
	  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
	};
	
	module.exports.Resizable = __webpack_require__(883).default;
	module.exports.ResizableBox = __webpack_require__(1974).default;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeSensorId = exports.SensorTabIndex = exports.SensorClassName = void 0;
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	
	var SizeSensorId = 'size-sensor-id';
	exports.SizeSensorId = SizeSensorId;
	var SensorClassName = 'size-sensor-object';
	exports.SensorClassName = SensorClassName;
	var SensorTabIndex = '-1';
	exports.SensorTabIndex = SensorTabIndex;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1609);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js?modules!./SgiPanel.css", function() {
				var newContent = require("!!../../css-loader/index.js?modules!./SgiPanel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	// https://github.com/mziccard/node-timsort
	var DEFAULT_MIN_MERGE = 32;
	var DEFAULT_MIN_GALLOPING = 7;
	var DEFAULT_TMP_STORAGE_LENGTH = 256;
	
	function minRunLength(n) {
	  var r = 0;
	
	  while (n >= DEFAULT_MIN_MERGE) {
	    r |= n & 1;
	    n >>= 1;
	  }
	
	  return n + r;
	}
	
	function makeAscendingRun(array, lo, hi, compare) {
	  var runHi = lo + 1;
	
	  if (runHi === hi) {
	    return 1;
	  }
	
	  if (compare(array[runHi++], array[lo]) < 0) {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
	      runHi++;
	    }
	
	    reverseRun(array, lo, runHi);
	  } else {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
	      runHi++;
	    }
	  }
	
	  return runHi - lo;
	}
	
	function reverseRun(array, lo, hi) {
	  hi--;
	
	  while (lo < hi) {
	    var t = array[lo];
	    array[lo++] = array[hi];
	    array[hi--] = t;
	  }
	}
	
	function binaryInsertionSort(array, lo, hi, start, compare) {
	  if (start === lo) {
	    start++;
	  }
	
	  for (; start < hi; start++) {
	    var pivot = array[start];
	    var left = lo;
	    var right = start;
	    var mid;
	
	    while (left < right) {
	      mid = left + right >>> 1;
	
	      if (compare(pivot, array[mid]) < 0) {
	        right = mid;
	      } else {
	        left = mid + 1;
	      }
	    }
	
	    var n = start - left;
	
	    switch (n) {
	      case 3:
	        array[left + 3] = array[left + 2];
	
	      case 2:
	        array[left + 2] = array[left + 1];
	
	      case 1:
	        array[left + 1] = array[left];
	        break;
	
	      default:
	        while (n > 0) {
	          array[left + n] = array[left + n - 1];
	          n--;
	        }
	
	    }
	
	    array[left] = pivot;
	  }
	}
	
	function gallopLeft(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) > 0) {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  } else {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) > 0) {
	      lastOffset = m + 1;
	    } else {
	      offset = m;
	    }
	  }
	
	  return offset;
	}
	
	function gallopRight(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) < 0) {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  } else {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) < 0) {
	      offset = m;
	    } else {
	      lastOffset = m + 1;
	    }
	  }
	
	  return offset;
	}
	
	function TimSort(array, compare) {
	  var minGallop = DEFAULT_MIN_GALLOPING;
	  var length = 0;
	  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
	  var stackLength = 0;
	  var runStart;
	  var runLength;
	  var stackSize = 0;
	  length = array.length;
	
	  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
	    tmpStorageLength = length >>> 1;
	  }
	
	  var tmp = [];
	  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
	  runStart = [];
	  runLength = [];
	
	  function pushRun(_runStart, _runLength) {
	    runStart[stackSize] = _runStart;
	    runLength[stackSize] = _runLength;
	    stackSize += 1;
	  }
	
	  function mergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
	        if (runLength[n - 1] < runLength[n + 1]) {
	          n--;
	        }
	      } else if (runLength[n] > runLength[n + 1]) {
	        break;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function forceMergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
	        n--;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function mergeAt(i) {
	    var start1 = runStart[i];
	    var length1 = runLength[i];
	    var start2 = runStart[i + 1];
	    var length2 = runLength[i + 1];
	    runLength[i] = length1 + length2;
	
	    if (i === stackSize - 3) {
	      runStart[i + 1] = runStart[i + 2];
	      runLength[i + 1] = runLength[i + 2];
	    }
	
	    stackSize--;
	    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
	    start1 += k;
	    length1 -= k;
	
	    if (length1 === 0) {
	      return;
	    }
	
	    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
	
	    if (length2 === 0) {
	      return;
	    }
	
	    if (length1 <= length2) {
	      mergeLow(start1, length1, start2, length2);
	    } else {
	      mergeHigh(start1, length1, start2, length2);
	    }
	  }
	
	  function mergeLow(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length1; i++) {
	      tmp[i] = array[start1 + i];
	    }
	
	    var cursor1 = 0;
	    var cursor2 = start2;
	    var dest = start1;
	    array[dest++] = array[cursor2++];
	
	    if (--length2 === 0) {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	
	      return;
	    }
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	      return;
	    }
	
	    var _minGallop = minGallop;
	    var count1;
	    var count2;
	    var exit;
	
	    while (1) {
	      count1 = 0;
	      count2 = 0;
	      exit = false;
	
	      do {
	        if (compare(array[cursor2], tmp[cursor1]) < 0) {
	          array[dest++] = array[cursor2++];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest++] = tmp[cursor1++];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
	
	        if (count1 !== 0) {
	          for (i = 0; i < count1; i++) {
	            array[dest + i] = tmp[cursor1 + i];
	          }
	
	          dest += count1;
	          cursor1 += count1;
	          length1 -= count1;
	
	          if (length1 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = array[cursor2++];
	
	        if (--length2 === 0) {
	          exit = true;
	          break;
	        }
	
	        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
	
	        if (count2 !== 0) {
	          for (i = 0; i < count2; i++) {
	            array[dest + i] = array[cursor2 + i];
	          }
	
	          dest += count2;
	          cursor2 += count2;
	          length2 -= count2;
	
	          if (length2 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = tmp[cursor1++];
	
	        if (--length1 === 1) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	    minGallop < 1 && (minGallop = 1);
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	    } else if (length1 === 0) {
	      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
	    } else {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	    }
	  }
	
	  function mergeHigh(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length2; i++) {
	      tmp[i] = array[start2 + i];
	    }
	
	    var cursor1 = start1 + length1 - 1;
	    var cursor2 = length2 - 1;
	    var dest = start2 + length2 - 1;
	    var customCursor = 0;
	    var customDest = 0;
	    array[dest--] = array[cursor1--];
	
	    if (--length1 === 0) {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	
	      return;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	      return;
	    }
	
	    var _minGallop = minGallop;
	
	    while (true) {
	      var count1 = 0;
	      var count2 = 0;
	      var exit = false;
	
	      do {
	        if (compare(tmp[cursor2], array[cursor1]) < 0) {
	          array[dest--] = array[cursor1--];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest--] = tmp[cursor2--];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
	
	        if (count1 !== 0) {
	          dest -= count1;
	          cursor1 -= count1;
	          length1 -= count1;
	          customDest = dest + 1;
	          customCursor = cursor1 + 1;
	
	          for (i = count1 - 1; i >= 0; i--) {
	            array[customDest + i] = array[customCursor + i];
	          }
	
	          if (length1 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = tmp[cursor2--];
	
	        if (--length2 === 1) {
	          exit = true;
	          break;
	        }
	
	        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
	
	        if (count2 !== 0) {
	          dest -= count2;
	          cursor2 -= count2;
	          length2 -= count2;
	          customDest = dest + 1;
	          customCursor = cursor2 + 1;
	
	          for (i = 0; i < count2; i++) {
	            array[customDest + i] = tmp[customCursor + i];
	          }
	
	          if (length2 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = array[cursor1--];
	
	        if (--length1 === 0) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	
	    if (minGallop < 1) {
	      minGallop = 1;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	    } else if (length2 === 0) {
	      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
	    } else {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	    }
	  }
	
	  this.mergeRuns = mergeRuns;
	  this.forceMergeRuns = forceMergeRuns;
	  this.pushRun = pushRun;
	}
	
	function sort(array, compare, lo, hi) {
	  if (!lo) {
	    lo = 0;
	  }
	
	  if (!hi) {
	    hi = array.length;
	  }
	
	  var remaining = hi - lo;
	
	  if (remaining < 2) {
	    return;
	  }
	
	  var runLength = 0;
	
	  if (remaining < DEFAULT_MIN_MERGE) {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
	    return;
	  }
	
	  var ts = new TimSort(array, compare);
	  var minRun = minRunLength(remaining);
	
	  do {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	
	    if (runLength < minRun) {
	      var force = remaining;
	
	      if (force > minRun) {
	        force = minRun;
	      }
	
	      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
	      runLength = force;
	    }
	
	    ts.pushRun(lo, runLength);
	    ts.mergeRuns();
	    remaining -= runLength;
	    lo += runLength;
	  } while (remaining !== 0);
	
	  ts.forceMergeRuns();
	}
	
	module.exports = sort;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(2);
	
	var inherits = _util.inherits;
	
	var Displayble = __webpack_require__(228);
	
	var BoundingRect = __webpack_require__(51);
	
	/**
	 * Displayable for incremental rendering. It will be rendered in a separate layer
	 * IncrementalDisplay have two main methods. `clearDisplayables` and `addDisplayables`
	 * addDisplayables will render the added displayables incremetally.
	 *
	 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
	 */
	// TODO Style override ?
	function IncrementalDisplayble(opts) {
	  Displayble.call(this, opts);
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.notClear = true;
	}
	
	IncrementalDisplayble.prototype.incremental = true;
	
	IncrementalDisplayble.prototype.clearDisplaybles = function () {
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.dirty();
	  this.notClear = false;
	};
	
	IncrementalDisplayble.prototype.addDisplayable = function (displayable, notPersistent) {
	  if (notPersistent) {
	    this._temporaryDisplayables.push(displayable);
	  } else {
	    this._displayables.push(displayable);
	  }
	
	  this.dirty();
	};
	
	IncrementalDisplayble.prototype.addDisplayables = function (displayables, notPersistent) {
	  notPersistent = notPersistent || false;
	
	  for (var i = 0; i < displayables.length; i++) {
	    this.addDisplayable(displayables[i], notPersistent);
	  }
	};
	
	IncrementalDisplayble.prototype.eachPendingDisplayable = function (cb) {
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    cb && cb(this._displayables[i]);
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    cb && cb(this._temporaryDisplayables[i]);
	  }
	};
	
	IncrementalDisplayble.prototype.update = function () {
	  this.updateTransform();
	
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	};
	
	IncrementalDisplayble.prototype.brush = function (ctx, prevEl) {
	  // Render persistant displayables.
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === this._cursor ? null : this._displayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._cursor = i; // Render temporary displayables.
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === 0 ? null : this._temporaryDisplayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._temporaryDisplayables = [];
	  this.notClear = true;
	};
	
	var m = [];
	
	IncrementalDisplayble.prototype.getBoundingRect = function () {
	  if (!this._rect) {
	    var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);
	
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	      var childRect = displayable.getBoundingRect().clone();
	
	      if (displayable.needLocalTransform()) {
	        childRect.applyTransform(displayable.getLocalTransform(m));
	      }
	
	      rect.union(childRect);
	    }
	
	    this._rect = rect;
	  }
	
	  return this._rect;
	};
	
	IncrementalDisplayble.prototype.contain = function (x, y) {
	  var localPos = this.transformCoordToLocal(x, y);
	  var rect = this.getBoundingRect();
	
	  if (rect.contain(localPos[0], localPos[1])) {
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	
	      if (displayable.contain(x, y)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	inherits(IncrementalDisplayble, Displayble);
	var _default = IncrementalDisplayble;
	module.exports = _default;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(2);
	
	var Gradient = __webpack_require__(281);
	
	/**
	 * x, y, x2, y2 are all percent from 0 to 1
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @param {number} [x2=1]
	 * @param {number} [y2=0]
	 * @param {Array.<Object>} colorStops
	 * @param {boolean} [globalCoord=false]
	 */
	var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'linear', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0 : x;
	  this.y = y == null ? 0 : y;
	  this.x2 = x2 == null ? 1 : x2;
	  this.y2 = y2 == null ? 0 : y2; // Can be cloned
	
	  this.type = 'linear'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	LinearGradient.prototype = {
	  constructor: LinearGradient
	};
	zrUtil.inherits(LinearGradient, Gradient);
	var _default = LinearGradient;
	module.exports = _default;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var fixShadow = __webpack_require__(907);
	
	var _constant = __webpack_require__(282);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
	// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);
	
	var Style = function (opts) {
	  this.extendFrom(opts, false);
	};
	
	function createLinearGradient(ctx, obj, rect) {
	  var x = obj.x == null ? 0 : obj.x;
	  var x2 = obj.x2 == null ? 1 : obj.x2;
	  var y = obj.y == null ? 0 : obj.y;
	  var y2 = obj.y2 == null ? 0 : obj.y2;
	
	  if (!obj.global) {
	    x = x * rect.width + rect.x;
	    x2 = x2 * rect.width + rect.x;
	    y = y * rect.height + rect.y;
	    y2 = y2 * rect.height + rect.y;
	  } // Fix NaN when rect is Infinity
	
	
	  x = isNaN(x) ? 0 : x;
	  x2 = isNaN(x2) ? 1 : x2;
	  y = isNaN(y) ? 0 : y;
	  y2 = isNaN(y2) ? 0 : y2;
	  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
	  return canvasGradient;
	}
	
	function createRadialGradient(ctx, obj, rect) {
	  var width = rect.width;
	  var height = rect.height;
	  var min = Math.min(width, height);
	  var x = obj.x == null ? 0.5 : obj.x;
	  var y = obj.y == null ? 0.5 : obj.y;
	  var r = obj.r == null ? 0.5 : obj.r;
	
	  if (!obj.global) {
	    x = x * width + rect.x;
	    y = y * height + rect.y;
	    r = r * min;
	  }
	
	  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
	  return canvasGradient;
	}
	
	Style.prototype = {
	  constructor: Style,
	
	  /**
	   * @type {string}
	   */
	  fill: '#000',
	
	  /**
	   * @type {string}
	   */
	  stroke: null,
	
	  /**
	   * @type {number}
	   */
	  opacity: 1,
	
	  /**
	   * @type {number}
	   */
	  fillOpacity: null,
	
	  /**
	   * @type {number}
	   */
	  strokeOpacity: null,
	
	  /**
	   * `true` is not supported.
	   * `false`/`null`/`undefined` are the same.
	   * `false` is used to remove lineDash in some
	   * case that `null`/`undefined` can not be set.
	   * (e.g., emphasis.lineStyle in echarts)
	   * @type {Array.<number>|boolean}
	   */
	  lineDash: null,
	
	  /**
	   * @type {number}
	   */
	  lineDashOffset: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetY: 0,
	
	  /**
	   * @type {number}
	   */
	  lineWidth: 1,
	
	  /**
	   * If stroke ignore scale
	   * @type {Boolean}
	   */
	  strokeNoScale: false,
	  // Bounding rect text configuration
	  // Not affected by element transform
	
	  /**
	   * @type {string}
	   */
	  text: null,
	
	  /**
	   * If `fontSize` or `fontFamily` exists, `font` will be reset by
	   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
	   * So do not visit it directly in upper application (like echarts),
	   * but use `contain/text#makeFont` instead.
	   * @type {string}
	   */
	  font: null,
	
	  /**
	   * The same as font. Use font please.
	   * @deprecated
	   * @type {string}
	   */
	  textFont: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontStyle: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontWeight: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * Should be 12 but not '12px'.
	   * @type {number}
	   */
	  fontSize: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontFamily: null,
	
	  /**
	   * Reserved for special functinality, like 'hr'.
	   * @type {string}
	   */
	  textTag: null,
	
	  /**
	   * @type {string}
	   */
	  textFill: '#000',
	
	  /**
	   * @type {string}
	   */
	  textStroke: null,
	
	  /**
	   * @type {number}
	   */
	  textWidth: null,
	
	  /**
	   * Only for textBackground.
	   * @type {number}
	   */
	  textHeight: null,
	
	  /**
	   * textStroke may be set as some color as a default
	   * value in upper applicaion, where the default value
	   * of textStrokeWidth should be 0 to make sure that
	   * user can choose to do not use text stroke.
	   * @type {number}
	   */
	  textStrokeWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textLineHeight: null,
	
	  /**
	   * 'inside', 'left', 'right', 'top', 'bottom'
	   * [x, y]
	   * Based on x, y of rect.
	   * @type {string|Array.<number>}
	   * @default 'inside'
	   */
	  textPosition: 'inside',
	
	  /**
	   * If not specified, use the boundingRect of a `displayable`.
	   * @type {Object}
	   */
	  textRect: null,
	
	  /**
	   * [x, y]
	   * @type {Array.<number>}
	   */
	  textOffset: null,
	
	  /**
	   * @type {string}
	   */
	  textAlign: null,
	
	  /**
	   * @type {string}
	   */
	  textVerticalAlign: null,
	
	  /**
	   * @type {number}
	   */
	  textDistance: 5,
	
	  /**
	   * @type {string}
	   */
	  textShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetY: 0,
	
	  /**
	   * @type {string}
	   */
	  textBoxShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetY: 0,
	
	  /**
	   * Whether transform text.
	   * Only available in Path and Image element,
	   * where the text is called as `RectText`.
	   * @type {boolean}
	   */
	  transformText: false,
	
	  /**
	   * Text rotate around position of Path or Image.
	   * The origin of the rotation can be specified by `textOrigin`.
	   * Only available in Path and Image element,
	   * where the text is called as `RectText`.
	   */
	  textRotation: 0,
	
	  /**
	   * Text origin of text rotation.
	   * Useful in the case like label rotation of circular symbol.
	   * Only available in Path and Image element, where the text is called
	   * as `RectText` and the element is called as "host element".
	   * The value can be:
	   * + If specified as a coordinate like `[10, 40]`, it is the `[x, y]`
	   * base on the left-top corner of the rect of its host element.
	   * + If specified as a string `center`, it is the center of the rect of
	   * its host element.
	   * + By default, this origin is the `textPosition`.
	   * @type {string|Array.<number>}
	   */
	  textOrigin: null,
	
	  /**
	   * @type {string}
	   */
	  textBackgroundColor: null,
	
	  /**
	   * @type {string}
	   */
	  textBorderColor: null,
	
	  /**
	   * @type {number}
	   */
	  textBorderWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textBorderRadius: 0,
	
	  /**
	   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
	   * @type {number|Array.<number>}
	   */
	  textPadding: null,
	
	  /**
	   * Text styles for rich text.
	   * @type {Object}
	   */
	  rich: null,
	
	  /**
	   * {outerWidth, outerHeight, ellipsis, placeholder}
	   * @type {Object}
	   */
	  truncate: null,
	
	  /**
	   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	   * @type {string}
	   */
	  blend: null,
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  bind: function (ctx, el, prevEl) {
	    var style = this;
	    var prevStyle = prevEl && prevEl.style; // If no prevStyle, it means first draw.
	    // Only apply cache if the last time cachced by this function.
	
	    var notCheckCache = !prevStyle || ctx.__attrCachedBy !== ContextCachedBy.STYLE_BIND;
	    ctx.__attrCachedBy = ContextCachedBy.STYLE_BIND;
	
	    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	      var prop = STYLE_COMMON_PROPS[i];
	      var styleName = prop[0];
	
	      if (notCheckCache || style[styleName] !== prevStyle[styleName]) {
	        // FIXME Invalid property value will cause style leak from previous element.
	        ctx[styleName] = fixShadow(ctx, styleName, style[styleName] || prop[1]);
	      }
	    }
	
	    if (notCheckCache || style.fill !== prevStyle.fill) {
	      ctx.fillStyle = style.fill;
	    }
	
	    if (notCheckCache || style.stroke !== prevStyle.stroke) {
	      ctx.strokeStyle = style.stroke;
	    }
	
	    if (notCheckCache || style.opacity !== prevStyle.opacity) {
	      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
	    }
	
	    if (notCheckCache || style.blend !== prevStyle.blend) {
	      ctx.globalCompositeOperation = style.blend || 'source-over';
	    }
	
	    if (this.hasStroke()) {
	      var lineWidth = style.lineWidth;
	      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
	    }
	  },
	  hasFill: function () {
	    var fill = this.fill;
	    return fill != null && fill !== 'none';
	  },
	  hasStroke: function () {
	    var stroke = this.stroke;
	    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
	  },
	
	  /**
	   * Extend from other style
	   * @param {zrender/graphic/Style} otherStyle
	   * @param {boolean} overwrite true: overwrirte any way.
	   *                            false: overwrite only when !target.hasOwnProperty
	   *                            others: overwrite when property is not null/undefined.
	   */
	  extendFrom: function (otherStyle, overwrite) {
	    if (otherStyle) {
	      for (var name in otherStyle) {
	        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
	          this[name] = otherStyle[name];
	        }
	      }
	    }
	  },
	
	  /**
	   * Batch setting style with a given object
	   * @param {Object|string} obj
	   * @param {*} [obj]
	   */
	  set: function (obj, value) {
	    if (typeof obj === 'string') {
	      this[obj] = value;
	    } else {
	      this.extendFrom(obj, true);
	    }
	  },
	
	  /**
	   * Clone
	   * @return {zrender/graphic/Style} [description]
	   */
	  clone: function () {
	    var newStyle = new this.constructor();
	    newStyle.extendFrom(this, true);
	    return newStyle;
	  },
	  getGradient: function (ctx, obj, rect) {
	    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
	    var canvasGradient = method(ctx, obj, rect);
	    var colorStops = obj.colorStops;
	
	    for (var i = 0; i < colorStops.length; i++) {
	      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
	    }
	
	    return canvasGradient;
	  }
	};
	var styleProto = Style.prototype;
	
	for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	  var prop = STYLE_COMMON_PROPS[i];
	
	  if (!(prop[0] in styleProto)) {
	    styleProto[prop[0]] = prop[1];
	  }
	} // Provide for others
	
	
	Style.getGradient = styleProto.getGradient;
	var _default = Style;
	module.exports = _default;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(902);
	
	var globalImageCache = new LRU(50);
	/**
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	function findExistImage(newImageOrSrc) {
	  if (typeof newImageOrSrc === 'string') {
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    return cachedImgObj && cachedImgObj.image;
	  } else {
	    return newImageOrSrc;
	  }
	}
	/**
	 * Caution: User should cache loaded images, but not just count on LRU.
	 * Consider if required images more than LRU size, will dead loop occur?
	 *
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
	 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
	 * @param {Function} [cb] params: (image, cbPayload)
	 * @param {Object} [cbPayload] Payload on cb calling.
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	
	function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
	  if (!newImageOrSrc) {
	    return image;
	  } else if (typeof newImageOrSrc === 'string') {
	    // Image should not be loaded repeatly.
	    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
	      return image;
	    } // Only when there is no existent image or existent image src
	    // is different, this method is responsible for load.
	
	
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    var pendingWrap = {
	      hostEl: hostEl,
	      cb: cb,
	      cbPayload: cbPayload
	    };
	
	    if (cachedImgObj) {
	      image = cachedImgObj.image;
	      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
	    } else {
	      image = new Image();
	      image.onload = image.onerror = imageOnLoad;
	      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
	        image: image,
	        pending: [pendingWrap]
	      });
	      image.src = image.__zrImageSrc = newImageOrSrc;
	    }
	
	    return image;
	  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
	  else {
	      return newImageOrSrc;
	    }
	}
	
	function imageOnLoad() {
	  var cachedImgObj = this.__cachedImgObj;
	  this.onload = this.onerror = this.__cachedImgObj = null;
	
	  for (var i = 0; i < cachedImgObj.pending.length; i++) {
	    var pendingWrap = cachedImgObj.pending[i];
	    var cb = pendingWrap.cb;
	    cb && cb(this, pendingWrap.cbPayload);
	    pendingWrap.hostEl.dirty();
	  }
	
	  cachedImgObj.pending.length = 0;
	}
	
	function isImageReady(image) {
	  return image && image.width && image.height;
	}
	
	exports.findExistImage = findExistImage;
	exports.createOrUpdateImage = createOrUpdateImage;
	exports.isImageReady = isImageReady;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	/**
	 * Sub-pixel optimize for canvas rendering, prevent from blur
	 * when rendering a thin vertical/horizontal line.
	 */
	var round = Math.round;
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x1`, `x2`, `y1`, `y2` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x1]
	 * @param {number} [inputShape.y1]
	 * @param {number} [inputShape.x2]
	 * @param {number} [inputShape.y2]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
	 */
	
	function subPixelOptimizeLine(outputShape, inputShape, style) {
	  if (!inputShape) {
	    return;
	  }
	
	  var x1 = inputShape.x1;
	  var x2 = inputShape.x2;
	  var y1 = inputShape.y1;
	  var y2 = inputShape.y2;
	  outputShape.x1 = x1;
	  outputShape.x2 = x2;
	  outputShape.y1 = y1;
	  outputShape.y2 = y2;
	  var lineWidth = style && style.lineWidth;
	
	  if (!lineWidth) {
	    return;
	  }
	
	  if (round(x1 * 2) === round(x2 * 2)) {
	    outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
	  }
	
	  if (round(y1 * 2) === round(y2 * 2)) {
	    outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
	  }
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x`, `y`, `width`, `height` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x]
	 * @param {number} [inputShape.y]
	 * @param {number} [inputShape.width]
	 * @param {number} [inputShape.height]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
	 */
	
	
	function subPixelOptimizeRect(outputShape, inputShape, style) {
	  if (!inputShape) {
	    return;
	  }
	
	  var originX = inputShape.x;
	  var originY = inputShape.y;
	  var originWidth = inputShape.width;
	  var originHeight = inputShape.height;
	  outputShape.x = originX;
	  outputShape.y = originY;
	  outputShape.width = originWidth;
	  outputShape.height = originHeight;
	  var lineWidth = style && style.lineWidth;
	
	  if (!lineWidth) {
	    return;
	  }
	
	  outputShape.x = subPixelOptimize(originX, lineWidth, true);
	  outputShape.y = subPixelOptimize(originY, lineWidth, true);
	  outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
	  outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth If `null`/`undefined`/`0`, do not optimize.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	function subPixelOptimize(position, lineWidth, positiveOrNegative) {
	  if (!lineWidth) {
	    return position;
	  } // Assure that (position + lineWidth / 2) is near integer edge,
	  // otherwise line will be fuzzy in canvas.
	
	
	  var doubledPosition = round(position * 2);
	  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
	}
	
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	var roundRectHelper = __webpack_require__(909);
	
	var _subPixelOptimize = __webpack_require__(451);
	
	var subPixelOptimizeRect = _subPixelOptimize.subPixelOptimizeRect;
	
	/**
	 * 矩形
	 * @module zrender/graphic/shape/Rect
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'rect',
	  shape: {
	    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
	    // r缩写为1         相当于 [1, 1, 1, 1]
	    // r缩写为[1]       相当于 [1, 1, 1, 1]
	    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
	    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
	    r: 0,
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
	      x = subPixelOptimizeOutputShape.x;
	      y = subPixelOptimizeOutputShape.y;
	      width = subPixelOptimizeOutputShape.width;
	      height = subPixelOptimizeOutputShape.height;
	      subPixelOptimizeOutputShape.r = shape.r;
	      shape = subPixelOptimizeOutputShape;
	    } else {
	      x = shape.x;
	      y = shape.y;
	      width = shape.width;
	      height = shape.height;
	    }
	
	    if (!shape.r) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, shape);
	    }
	
	    ctx.closePath();
	    return;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	var svgURI = 'http://www.w3.org/2000/svg';
	
	function createElement(name) {
	  return document.createElementNS(svgURI, name);
	}
	
	exports.createElement = createElement;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(453);
	
	var createElement = _core.createElement;
	
	var PathProxy = __webpack_require__(180);
	
	var BoundingRect = __webpack_require__(51);
	
	var matrix = __webpack_require__(75);
	
	var textContain = __webpack_require__(86);
	
	var textHelper = __webpack_require__(283);
	
	var Text = __webpack_require__(147);
	
	// TODO
	// 1. shadow
	// 2. Image: sx, sy, sw, sh
	var CMD = PathProxy.CMD;
	var arrayJoin = Array.prototype.join;
	var NONE = 'none';
	var mathRound = Math.round;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	var PI2 = Math.PI * 2;
	var degree = 180 / PI;
	var EPSILON = 1e-4;
	
	function round4(val) {
	  return mathRound(val * 1e4) / 1e4;
	}
	
	function isAroundZero(val) {
	  return val < EPSILON && val > -EPSILON;
	}
	
	function pathHasFill(style, isText) {
	  var fill = isText ? style.textFill : style.fill;
	  return fill != null && fill !== NONE;
	}
	
	function pathHasStroke(style, isText) {
	  var stroke = isText ? style.textStroke : style.stroke;
	  return stroke != null && stroke !== NONE;
	}
	
	function setTransform(svgEl, m) {
	  if (m) {
	    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
	  }
	}
	
	function attr(el, key, val) {
	  if (!val || val.type !== 'linear' && val.type !== 'radial') {
	    // Don't set attribute for gradient, since it need new dom nodes
	    el.setAttribute(key, val);
	  }
	}
	
	function attrXLink(el, key, val) {
	  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
	}
	
	function bindStyle(svgEl, style, isText, el) {
	  if (pathHasFill(style, isText)) {
	    var fill = isText ? style.textFill : style.fill;
	    fill = fill === 'transparent' ? NONE : fill;
	    attr(svgEl, 'fill', fill);
	    attr(svgEl, 'fill-opacity', style.fillOpacity != null ? style.fillOpacity * style.opacity : style.opacity);
	  } else {
	    attr(svgEl, 'fill', NONE);
	  }
	
	  if (pathHasStroke(style, isText)) {
	    var stroke = isText ? style.textStroke : style.stroke;
	    stroke = stroke === 'transparent' ? NONE : stroke;
	    attr(svgEl, 'stroke', stroke);
	    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
	    var strokeScale = !isText && style.strokeNoScale ? el.getLineScale() : 1;
	    attr(svgEl, 'stroke-width', strokeWidth / strokeScale); // stroke then fill for text; fill then stroke for others
	
	    attr(svgEl, 'paint-order', isText ? 'stroke' : 'fill');
	    attr(svgEl, 'stroke-opacity', style.strokeOpacity != null ? style.strokeOpacity : style.opacity);
	    var lineDash = style.lineDash;
	
	    if (lineDash) {
	      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
	      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
	    } else {
	      attr(svgEl, 'stroke-dasharray', '');
	    } // PENDING
	
	
	    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
	    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
	    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
	  } else {
	    attr(svgEl, 'stroke', NONE);
	  }
	}
	/***************************************************
	 * PATH
	 **************************************************/
	
	
	function pathDataToString(path) {
	  var str = [];
	  var data = path.data;
	  var dataLength = path.len();
	
	  for (var i = 0; i < dataLength;) {
	    var cmd = data[i++];
	    var cmdStr = '';
	    var nData = 0;
	
	    switch (cmd) {
	      case CMD.M:
	        cmdStr = 'M';
	        nData = 2;
	        break;
	
	      case CMD.L:
	        cmdStr = 'L';
	        nData = 2;
	        break;
	
	      case CMD.Q:
	        cmdStr = 'Q';
	        nData = 4;
	        break;
	
	      case CMD.C:
	        cmdStr = 'C';
	        nData = 6;
	        break;
	
	      case CMD.A:
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++];
	        var psi = data[i++];
	        var clockwise = data[i++];
	        var dThetaPositive = Math.abs(dTheta);
	        var isCircle = isAroundZero(dThetaPositive - PI2) || (clockwise ? dTheta >= PI2 : -dTheta >= PI2); // Mapping to 0~2PI
	
	        var unifiedTheta = dTheta > 0 ? dTheta % PI2 : dTheta % PI2 + PI2;
	        var large = false;
	
	        if (isCircle) {
	          large = true;
	        } else if (isAroundZero(dThetaPositive)) {
	          large = false;
	        } else {
	          large = unifiedTheta >= PI === !!clockwise;
	        }
	
	        var x0 = round4(cx + rx * mathCos(theta));
	        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
	        // We need to shift the end point with a small value
	        // FIXME A better way to draw circle ?
	
	        if (isCircle) {
	          if (clockwise) {
	            dTheta = PI2 - 1e-4;
	          } else {
	            dTheta = -PI2 + 1e-4;
	          }
	
	          large = true;
	
	          if (i === 9) {
	            // Move to (x0, y0) only when CMD.A comes at the
	            // first position of a shape.
	            // For instance, when drawing a ring, CMD.A comes
	            // after CMD.M, so it's unnecessary to move to
	            // (x0, y0).
	            str.push('M', x0, y0);
	          }
	        }
	
	        var x = round4(cx + rx * mathCos(theta + dTheta));
	        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse
	
	        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
	        break;
	
	      case CMD.Z:
	        cmdStr = 'Z';
	        break;
	
	      case CMD.R:
	        var x = round4(data[i++]);
	        var y = round4(data[i++]);
	        var w = round4(data[i++]);
	        var h = round4(data[i++]);
	        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
	        break;
	    }
	
	    cmdStr && str.push(cmdStr);
	
	    for (var j = 0; j < nData; j++) {
	      // PENDING With scale
	      str.push(round4(data[i++]));
	    }
	  }
	
	  return str.join(' ');
	}
	
	var svgPath = {};
	
	svgPath.brush = function (el) {
	  var style = el.style;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('path');
	    el.__svgEl = svgEl;
	  }
	
	  if (!el.path) {
	    el.createPathProxy();
	  }
	
	  var path = el.path;
	
	  if (el.__dirtyPath) {
	    path.beginPath();
	    path.subPixelOptimize = false;
	    el.buildPath(path, el.shape);
	    el.__dirtyPath = false;
	    var pathStr = pathDataToString(path);
	
	    if (pathStr.indexOf('NaN') < 0) {
	      // Ignore illegal path, which may happen such in out-of-range
	      // data in Calendar series.
	      attr(svgEl, 'd', pathStr);
	    }
	  }
	
	  bindStyle(svgEl, style, false, el);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  } else {
	    removeOldTextNode(el);
	  }
	};
	/***************************************************
	 * IMAGE
	 **************************************************/
	
	
	var svgImage = {};
	
	svgImage.brush = function (el) {
	  var style = el.style;
	  var image = style.image;
	
	  if (image instanceof HTMLImageElement) {
	    var src = image.src;
	    image = src;
	  }
	
	  if (!image) {
	    return;
	  }
	
	  var x = style.x || 0;
	  var y = style.y || 0;
	  var dw = style.width;
	  var dh = style.height;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('image');
	    el.__svgEl = svgEl;
	  }
	
	  if (image !== el.__imageSrc) {
	    attrXLink(svgEl, 'href', image); // Caching image src
	
	    el.__imageSrc = image;
	  }
	
	  attr(svgEl, 'width', dw);
	  attr(svgEl, 'height', dh);
	  attr(svgEl, 'x', x);
	  attr(svgEl, 'y', y);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  } else {
	    removeOldTextNode(el);
	  }
	};
	/***************************************************
	 * TEXT
	 **************************************************/
	
	
	var svgText = {};
	
	var _tmpTextHostRect = new BoundingRect();
	
	var _tmpTextBoxPos = {};
	var _tmpTextTransform = [];
	var TEXT_ALIGN_TO_ANCHRO = {
	  left: 'start',
	  right: 'end',
	  center: 'middle',
	  middle: 'middle'
	};
	/**
	 * @param {module:zrender/Element} el
	 * @param {Object|boolean} [hostRect] {x, y, width, height}
	 *        If set false, rect text is not used.
	 */
	
	var svgTextDrawRectText = function (el, hostRect) {
	  var style = el.style;
	  var elTransform = el.transform;
	  var needTransformTextByHostEl = el instanceof Text || style.transformText;
	  el.__dirty && textHelper.normalizeTextStyle(style, true);
	  var text = style.text; // Convert to string
	
	  text != null && (text += '');
	
	  if (!textHelper.needDrawText(text, style)) {
	    return;
	  } // render empty text for svg if no text but need draw text.
	
	
	  text == null && (text = ''); // Follow the setting in the canvas renderer, if not transform the
	  // text, transform the hostRect, by which the text is located.
	
	  if (!needTransformTextByHostEl && elTransform) {
	    _tmpTextHostRect.copy(hostRect);
	
	    _tmpTextHostRect.applyTransform(elTransform);
	
	    hostRect = _tmpTextHostRect;
	  }
	
	  var textSvgEl = el.__textSvgEl;
	
	  if (!textSvgEl) {
	    textSvgEl = createElement('text');
	    el.__textSvgEl = textSvgEl;
	  } // style.font has been normalized by `normalizeTextStyle`.
	
	
	  var textSvgElStyle = textSvgEl.style;
	  var font = style.font || textContain.DEFAULT_FONT;
	  var computedFont = textSvgEl.__computedFont;
	
	  if (font !== textSvgEl.__styleFont) {
	    textSvgElStyle.font = textSvgEl.__styleFont = font; // The computedFont might not be the orginal font if it is illegal font.
	
	    computedFont = textSvgEl.__computedFont = textSvgElStyle.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = el.__textCotentBlock;
	
	  if (!contentBlock || el.__dirtyText) {
	    contentBlock = el.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var lineHeight = contentBlock.lineHeight;
	  textHelper.getBoxPosition(_tmpTextBoxPos, el, style, hostRect);
	  var baseX = _tmpTextBoxPos.baseX;
	  var baseY = _tmpTextBoxPos.baseY;
	  var textAlign = _tmpTextBoxPos.textAlign || 'left';
	  var textVerticalAlign = _tmpTextBoxPos.textVerticalAlign;
	  setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY; // TODO needDrawBg
	
	  if (textPadding) {
	    textX = getTextXForPadding(baseX, textAlign, textPadding);
	    textY += textPadding[0];
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  bindStyle(textSvgEl, style, true, el); // FIXME
	  // Add a <style> to reset all of the text font as inherit?
	  // otherwise the outer <style> may set the unexpected style.
	  // Font may affect position of each tspan elements
	
	  var canCacheByTextString = contentBlock.canCacheByTextString;
	  var tspanList = el.__tspanList || (el.__tspanList = []);
	  var tspanOriginLen = tspanList.length; // Optimize for most cases, just compare text string to determine change.
	
	  if (canCacheByTextString && el.__canCacheByTextString && el.__text === text) {
	    if (el.__dirtyText && tspanOriginLen) {
	      for (var idx = 0; idx < tspanOriginLen; ++idx) {
	        updateTextLocation(tspanList[idx], textAlign, textX, textY + idx * lineHeight);
	      }
	    }
	  } else {
	    el.__text = text;
	    el.__canCacheByTextString = canCacheByTextString;
	    var textLines = contentBlock.lines;
	    var nTextLines = textLines.length;
	    var idx = 0;
	
	    for (; idx < nTextLines; idx++) {
	      // Using cached tspan elements
	      var tspan = tspanList[idx];
	      var singleLineText = textLines[idx];
	
	      if (!tspan) {
	        tspan = tspanList[idx] = createElement('tspan');
	        textSvgEl.appendChild(tspan);
	        tspan.appendChild(document.createTextNode(singleLineText));
	      } else if (tspan.__zrText !== singleLineText) {
	        tspan.innerHTML = '';
	        tspan.appendChild(document.createTextNode(singleLineText));
	      }
	
	      updateTextLocation(tspan, textAlign, textX, textY + idx * lineHeight);
	    } // Remove unused tspan elements
	
	
	    if (tspanOriginLen > nTextLines) {
	      for (; idx < tspanOriginLen; idx++) {
	        textSvgEl.removeChild(tspanList[idx]);
	      }
	
	      tspanList.length = nTextLines;
	    }
	  }
	};
	
	function setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY) {
	  matrix.identity(_tmpTextTransform);
	
	  if (needTransformTextByHostEl && elTransform) {
	    matrix.copy(_tmpTextTransform, elTransform);
	  } // textRotation only apply in RectText.
	
	
	  var textRotation = style.textRotation;
	
	  if (hostRect && textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      baseX = hostRect.width / 2 + hostRect.x;
	      baseY = hostRect.height / 2 + hostRect.y;
	    } else if (origin) {
	      baseX = origin[0] + hostRect.x;
	      baseY = origin[1] + hostRect.y;
	    }
	
	    _tmpTextTransform[4] -= baseX;
	    _tmpTextTransform[5] -= baseY; // Positive: anticlockwise
	
	    matrix.rotate(_tmpTextTransform, _tmpTextTransform, textRotation);
	    _tmpTextTransform[4] += baseX;
	    _tmpTextTransform[5] += baseY;
	  } // See the definition in `Style.js#textOrigin`, the default
	  // origin is from the result of `getBoxPosition`.
	
	
	  setTransform(textSvgEl, _tmpTextTransform);
	} // FIXME merge the same code with `helper/text.js#getTextXForPadding`;
	
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	
	function updateTextLocation(tspan, textAlign, x, y) {
	  // Consider different font display differently in vertial align, we always
	  // set vertialAlign as 'middle', and use 'y' to locate text vertically.
	  attr(tspan, 'dominant-baseline', 'middle');
	  attr(tspan, 'text-anchor', TEXT_ALIGN_TO_ANCHRO[textAlign]);
	  attr(tspan, 'x', x);
	  attr(tspan, 'y', y);
	}
	
	function removeOldTextNode(el) {
	  if (el && el.__textSvgEl) {
	    // textSvgEl may has no parentNode if el has been removed temporary.
	    if (el.__textSvgEl.parentNode) {
	      el.__textSvgEl.parentNode.removeChild(el.__textSvgEl);
	    }
	
	    el.__textSvgEl = null;
	    el.__tspanList = [];
	    el.__text = null;
	  }
	}
	
	svgText.drawRectText = svgTextDrawRectText;
	
	svgText.brush = function (el) {
	  var style = el.style;
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, false);
	  } else {
	    removeOldTextNode(el);
	  }
	};
	
	exports.path = svgPath;
	exports.image = svgImage;
	exports.text = svgText;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(453);
	
	var createElement = _core.createElement;
	
	var zrUtil = __webpack_require__(2);
	
	var Path = __webpack_require__(55);
	
	var ZImage = __webpack_require__(181);
	
	var ZText = __webpack_require__(147);
	
	var _graphic = __webpack_require__(454);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * @file Manages elements that can be defined in <defs> in SVG,
	 *       e.g., gradients, clip path, etc.
	 * @author Zhang Wenli
	 */
	var MARK_UNUSED = '0';
	var MARK_USED = '1';
	/**
	 * Manages elements that can be defined in <defs> in SVG,
	 * e.g., gradients, clip path, etc.
	 *
	 * @class
	 * @param {number}          zrId      zrender instance id
	 * @param {SVGElement}      svgRoot   root of SVG document
	 * @param {string|string[]} tagNames  possible tag names
	 * @param {string}          markLabel label name to make if the element
	 *                                    is used
	 */
	
	function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
	  this._zrId = zrId;
	  this._svgRoot = svgRoot;
	  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
	  this._markLabel = markLabel;
	  this._domName = domName || '_dom';
	  this.nextId = 0;
	}
	
	Definable.prototype.createElement = createElement;
	/**
	 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
	 *
	 * @param {boolean} isForceCreating if need to create when not exists
	 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
	 * exist and isForceCreating is false
	 */
	
	Definable.prototype.getDefs = function (isForceCreating) {
	  var svgRoot = this._svgRoot;
	
	  var defs = this._svgRoot.getElementsByTagName('defs');
	
	  if (defs.length === 0) {
	    // Not exist
	    if (isForceCreating) {
	      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
	      svgRoot.firstChild // Insert in the front of svg
	      );
	
	      if (!defs.contains) {
	        // IE doesn't support contains method
	        defs.contains = function (el) {
	          var children = defs.children;
	
	          if (!children) {
	            return false;
	          }
	
	          for (var i = children.length - 1; i >= 0; --i) {
	            if (children[i] === el) {
	              return true;
	            }
	          }
	
	          return false;
	        };
	      }
	
	      return defs;
	    } else {
	      return null;
	    }
	  } else {
	    return defs[0];
	  }
	};
	/**
	 * Update DOM element if necessary.
	 *
	 * @param {Object|string} element style element. e.g., for gradient,
	 *                                it may be '#ccc' or {type: 'linear', ...}
	 * @param {Function|undefined} onUpdate update callback
	 */
	
	
	Definable.prototype.update = function (element, onUpdate) {
	  if (!element) {
	    return;
	  }
	
	  var defs = this.getDefs(false);
	
	  if (element[this._domName] && defs.contains(element[this._domName])) {
	    // Update DOM
	    if (typeof onUpdate === 'function') {
	      onUpdate(element);
	    }
	  } else {
	    // No previous dom, create new
	    var dom = this.add(element);
	
	    if (dom) {
	      element[this._domName] = dom;
	    }
	  }
	};
	/**
	 * Add gradient dom to defs
	 *
	 * @param {SVGElement} dom DOM to be added to <defs>
	 */
	
	
	Definable.prototype.addDom = function (dom) {
	  var defs = this.getDefs(true);
	  defs.appendChild(dom);
	};
	/**
	 * Remove DOM of a given element.
	 *
	 * @param {SVGElement} element element to remove dom
	 */
	
	
	Definable.prototype.removeDom = function (element) {
	  var defs = this.getDefs(false);
	
	  if (defs && element[this._domName]) {
	    defs.removeChild(element[this._domName]);
	    element[this._domName] = null;
	  }
	};
	/**
	 * Get DOMs of this element.
	 *
	 * @return {HTMLDomElement} doms of this defineable elements in <defs>
	 */
	
	
	Definable.prototype.getDoms = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // No dom when defs is not defined
	    return [];
	  }
	
	  var doms = [];
	  zrUtil.each(this._tagNames, function (tagName) {
	    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
	    // rather than real array.
	    // So `doms.concat(tags)` add tags as one object.
	
	    doms = doms.concat([].slice.call(tags));
	  });
	  return doms;
	};
	/**
	 * Mark DOMs to be unused before painting, and clear unused ones at the end
	 * of the painting.
	 */
	
	
	Definable.prototype.markAllUnused = function () {
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    dom[that._markLabel] = MARK_UNUSED;
	  });
	};
	/**
	 * Mark a single DOM to be used.
	 *
	 * @param {SVGElement} dom DOM to mark
	 */
	
	
	Definable.prototype.markUsed = function (dom) {
	  if (dom) {
	    dom[this._markLabel] = MARK_USED;
	  }
	};
	/**
	 * Remove unused DOMs defined in <defs>
	 */
	
	
	Definable.prototype.removeUnused = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // Nothing to remove
	    return;
	  }
	
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    if (dom[that._markLabel] !== MARK_USED) {
	      // Remove gradient
	      defs.removeChild(dom);
	    }
	  });
	};
	/**
	 * Get SVG proxy.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {Path|Image|Text} svg proxy of given element
	 */
	
	
	Definable.prototype.getSvgProxy = function (displayable) {
	  if (displayable instanceof Path) {
	    return svgPath;
	  } else if (displayable instanceof ZImage) {
	    return svgImage;
	  } else if (displayable instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	};
	/**
	 * Get text SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element of text
	 */
	
	
	Definable.prototype.getTextSvgElement = function (displayable) {
	  return displayable.__textSvgEl;
	};
	/**
	 * Get SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element
	 */
	
	
	Definable.prototype.getSvgElement = function (displayable) {
	  return displayable.__svgEl;
	};
	
	var _default = Definable;
	module.exports = _default;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1090);

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1100);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1101);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1108);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1136);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1137);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1148);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1156);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1160);

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1164);

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1183);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1190);

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1194);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1200);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(121);

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1216);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1220);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1223);

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1231);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1232);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1237);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1240);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(125);

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1253);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1257);

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1262);

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1266);

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1270);

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1279);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1294);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1368);

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1405);

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(187);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(205);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(218);

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(235);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(254);

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(256);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(338);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(35);

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(364);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(396);

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(405);

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(50);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(546);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(559);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(570);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(585);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(594);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(596);

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(597);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(663);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(834);

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(882);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(985);

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setMode = exports.isInDoc = exports.isBeforeInputEventAvailable = exports.mergePlugins = exports.isTextareaOrInput = exports.uuid = exports.configHandlers = exports.configHandlers2 = exports.isFunction = void 0;
	var EditorPropTypes_1 = __webpack_require__(512);
	var isFunction = function (x) { return typeof x === 'function'; };
	exports.isFunction = isFunction;
	var isEventProp = function (name) { return name in EditorPropTypes_1.eventPropTypes; };
	var eventAttrToEventName = function (attrName) { return attrName.substr(2); };
	var configHandlers2 = function (handlerLookup, on, off, adapter, prevProps, props, boundHandlers) {
	    var prevEventKeys = Object.keys(prevProps).filter(isEventProp);
	    var currEventKeys = Object.keys(props).filter(isEventProp);
	    var removedKeys = prevEventKeys.filter(function (key) { return props[key] === undefined; });
	    var addedKeys = currEventKeys.filter(function (key) { return prevProps[key] === undefined; });
	    removedKeys.forEach(function (key) {
	        // remove event handler
	        var eventName = eventAttrToEventName(key);
	        var wrappedHandler = boundHandlers[eventName];
	        off(eventName, wrappedHandler);
	        delete boundHandlers[eventName];
	    });
	    addedKeys.forEach(function (key) {
	        var wrappedHandler = adapter(handlerLookup, key);
	        var eventName = eventAttrToEventName(key);
	        boundHandlers[eventName] = wrappedHandler;
	        on(eventName, wrappedHandler);
	    });
	};
	exports.configHandlers2 = configHandlers2;
	var configHandlers = function (editor, prevProps, props, boundHandlers, lookup) {
	    return (0, exports.configHandlers2)(lookup, editor.on.bind(editor), editor.off.bind(editor), 
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
	    function (handlerLookup, key) { return function (e) { var _a; return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor); }; }, prevProps, props, boundHandlers);
	};
	exports.configHandlers = configHandlers;
	var unique = 0;
	var uuid = function (prefix) {
	    var time = Date.now();
	    var random = Math.floor(Math.random() * 1000000000);
	    unique++;
	    return prefix + '_' + random + unique + String(time);
	};
	exports.uuid = uuid;
	var isTextareaOrInput = function (element) {
	    return element !== null && (element.tagName.toLowerCase() === 'textarea' || element.tagName.toLowerCase() === 'input');
	};
	exports.isTextareaOrInput = isTextareaOrInput;
	var normalizePluginArray = function (plugins) {
	    if (typeof plugins === 'undefined' || plugins === '') {
	        return [];
	    }
	    return Array.isArray(plugins) ? plugins : plugins.split(' ');
	};
	// eslint-disable-next-line max-len
	var mergePlugins = function (initPlugins, inputPlugins) { return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins)); };
	exports.mergePlugins = mergePlugins;
	var isBeforeInputEventAvailable = function () { return window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function'; };
	exports.isBeforeInputEventAvailable = isBeforeInputEventAvailable;
	var isInDoc = function (elem) {
	    if (!('isConnected' in Node.prototype)) {
	        // Fallback for IE and old Edge
	        var current = elem;
	        var parent_1 = elem.parentNode;
	        while (parent_1 != null) {
	            current = parent_1;
	            parent_1 = current.parentNode;
	        }
	        return current === elem.ownerDocument;
	    }
	    return elem.isConnected;
	};
	exports.isInDoc = isInDoc;
	var setMode = function (editor, mode) {
	    if (editor !== undefined) {
	        if (editor.mode != null && typeof editor.mode === 'object' && typeof editor.mode.set === 'function') {
	            editor.mode.set(mode);
	        }
	        else { // support TinyMCE 4
	            editor.setMode(mode);
	        }
	    }
	};
	exports.setMode = setMode;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EditorPropTypes = exports.eventPropTypes = void 0;
	var PropTypes = __webpack_require__(6);
	exports.eventPropTypes = {
	    onActivate: PropTypes.func,
	    onAddUndo: PropTypes.func,
	    onBeforeAddUndo: PropTypes.func,
	    onBeforeExecCommand: PropTypes.func,
	    onBeforeGetContent: PropTypes.func,
	    onBeforeRenderUI: PropTypes.func,
	    onBeforeSetContent: PropTypes.func,
	    onBeforePaste: PropTypes.func,
	    onBlur: PropTypes.func,
	    onChange: PropTypes.func,
	    onClearUndos: PropTypes.func,
	    onClick: PropTypes.func,
	    onContextMenu: PropTypes.func,
	    onCopy: PropTypes.func,
	    onCut: PropTypes.func,
	    onDblclick: PropTypes.func,
	    onDeactivate: PropTypes.func,
	    onDirty: PropTypes.func,
	    onDrag: PropTypes.func,
	    onDragDrop: PropTypes.func,
	    onDragEnd: PropTypes.func,
	    onDragGesture: PropTypes.func,
	    onDragOver: PropTypes.func,
	    onDrop: PropTypes.func,
	    onExecCommand: PropTypes.func,
	    onFocus: PropTypes.func,
	    onFocusIn: PropTypes.func,
	    onFocusOut: PropTypes.func,
	    onGetContent: PropTypes.func,
	    onHide: PropTypes.func,
	    onInit: PropTypes.func,
	    onKeyDown: PropTypes.func,
	    onKeyPress: PropTypes.func,
	    onKeyUp: PropTypes.func,
	    onLoadContent: PropTypes.func,
	    onMouseDown: PropTypes.func,
	    onMouseEnter: PropTypes.func,
	    onMouseLeave: PropTypes.func,
	    onMouseMove: PropTypes.func,
	    onMouseOut: PropTypes.func,
	    onMouseOver: PropTypes.func,
	    onMouseUp: PropTypes.func,
	    onNodeChange: PropTypes.func,
	    onObjectResizeStart: PropTypes.func,
	    onObjectResized: PropTypes.func,
	    onObjectSelected: PropTypes.func,
	    onPaste: PropTypes.func,
	    onPostProcess: PropTypes.func,
	    onPostRender: PropTypes.func,
	    onPreProcess: PropTypes.func,
	    onProgressState: PropTypes.func,
	    onRedo: PropTypes.func,
	    onRemove: PropTypes.func,
	    onReset: PropTypes.func,
	    onSaveContent: PropTypes.func,
	    onSelectionChange: PropTypes.func,
	    onSetAttrib: PropTypes.func,
	    onSetContent: PropTypes.func,
	    onShow: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onUndo: PropTypes.func,
	    onVisualAid: PropTypes.func
	};
	exports.EditorPropTypes = __assign({ apiKey: PropTypes.string, id: PropTypes.string, inline: PropTypes.bool, init: PropTypes.object, initialValue: PropTypes.string, onEditorChange: PropTypes.func, outputFormat: PropTypes.oneOf(['html', 'text']), value: PropTypes.string, tagName: PropTypes.string, cloudChannel: PropTypes.string, plugins: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), toolbar: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), disabled: PropTypes.bool, textareaName: PropTypes.string, tinymceScriptSrc: PropTypes.string, rollback: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([false])]), scriptLoading: PropTypes.shape({
	        async: PropTypes.bool,
	        defer: PropTypes.bool,
	        delay: PropTypes.number
	    }) }, exports.eventPropTypes);


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _zh_CN = _interopRequireDefault(__webpack_require__(1919));
	
	var _zh_CN2 = _interopRequireDefault(__webpack_require__(514));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var locale = {
	  lang: _extends({
	    placeholder: '请选择日期',
	    rangePlaceholder: ['开始日期', '结束日期']
	  }, _zh_CN["default"]),
	  timePickerLocale: _extends({}, _zh_CN2["default"])
	}; // should add whitespace between char in Button
	
	locale.lang.ok = '确 定'; // All settings at:
	// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
	
	var _default = locale;
	exports["default"] = _default;

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var locale = {
	  placeholder: '请选择时间'
	};
	var _default = locale;
	exports["default"] = _default;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.verifyCertificate = undefined;
	
	var _api = __webpack_require__(941);
	
	var _api2 = __webpack_require__(939);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var http = function http(url, req) {
	  return new Promise(function (resolve, reject) {
	    commonClient.simplecall(url, req, function (res) {
	      if (res && res.head && res.head.code === "0000") {
	        var resObj = {
	          errorcode: '0',
	          result: res.head.msg
	        };
	        resolve(resObj);
	      } else {
	        var _resObj = {
	          errorcode: '-1',
	          result: res.head.msg
	        };
	        reject(_resObj);
	      }
	    });
	  });
	};
	// 弹出 获取口令 获取key信息
	var verifyCertificate = exports.verifyCertificate = function verifyCertificate() {
	  return (0, _api.connect)().then(function () {
	    return (0, _api.selectCertificate)();
	  }).then(function (result) {
	    return (0, _api.signMsgPKCS7)();
	  }).then(function (res) {
	    return (0, _api.getSignCertInfo)("SubjectDN");
	  })
	  // 验证当前数据
	  .then(function () {
	    var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    console.log(d);
	    var str = d.result;
	    var custCardNo = _rtSdCommon.tool.getCookie('creditCode');
	    console.log(custCardNo);
	    return str.split("@").includes('8' + custCardNo);
	  }).then(function (isPassed) {
	    var res = {
	      errorcode: '1',
	      result: '当前用户所属机构与所选证书不匹配'
	    };
	
	    return isPassed ? (0, _api.getSignCertInfo)("SerialNumber") : Promise.reject(res);
	  })
	  // 请求后台
	  .then(function (d) {
	    console.log('\u5F53\u524D\u8BC1\u4E66\u5E8F\u5217\u53F7\uFF1A' + d.result);
	    // let nikNam = tool.getCookie('nikNam');
	    // console.log(`当前userName：${nikNam}`);
	    var userId = _rtSdCommon.tool.getCookie('userId');
	    console.log('\u5F53\u524DuserId\uFF1A' + userId);
	    var serialNo = d.result;
	    _rtSdCommon.tool.setCookie("currentSerialNo", serialNo);
	
	    var url = sgiConfig.service_file + '/cfca/checkCert';
	    return http(url, { serialNo: serialNo, userId: userId });
	  });
	};
	
	// 封装action
	var actionList = [_api.connect, _api2.cofco_connect,
	// InsertCcie,
	// verifyCertificate,
	_api2.PKCS10Requisition_SingleCert, _api2.CFCA_GetContainer, _api2.getContainer];
	var cfcaActions = {};
	actionList.map(function (el) {
	  cfcaActions[el.name] = function (cb) {
	    el().then(function (res) {
	      cb(res);
	    }).catch(function (err) {
	      cb(err);
	    });
	  };
	});
	
	// key验证
	cfcaActions.verifyCertificate = function (cb) {
	  verifyCertificate().then(function (res) {
	    cb(res);
	  }).catch(function (err) {
	    cb(err);
	  });
	};
	// 带参方法
	cfcaActions.InstallCert = function (signCert, cb) {
	  (0, _api2.InstallCert)(1, signCert).then(function (res) {
	    cb(res);
	  }).catch(function (err) {
	    cb(err);
	  });
	};
	
	exports.default = cfcaActions;

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var standardBrowser = exports.standardBrowser = {
	    IE: "Internet Explorer",
	    Edge: "Edge",
	    Chrome: "Chrome",
	    Safari: "Safari",
	    Firefox: "Firefox"
	};
	
	var getBrowserInfo = function getBrowserInfo() {
	    var res = {
	        name: "",
	        version: ""
	    };
	    var reg;
	    var userAgent = self.navigator.userAgent;
	
	    if (reg = /edge\/([\d\.]+)/i.exec(userAgent)) {
	        res.name = "Edge";
	        res.version = reg[1];
	    } else if (/msie/i.test(userAgent)) {
	        res.name = "Internet Explorer";
	        res.version = /msie ([\d\.]+)/i.exec(userAgent)[1];
	    } else if (/Trident/i.test(userAgent)) {
	        res.name = "Internet Explorer";
	        res.version = /rv:([\d\.]+)/i.exec(userAgent)[1];
	    } else if (/chrome/i.test(userAgent)) {
	        res.name = "Chrome";
	        res.version = /chrome\/([\d\.]+)/i.exec(userAgent)[1];
	    } else if (/safari/i.test(userAgent)) {
	        res.name = "Safari";
	        res.version = /version\/([\d\.]+)/i.exec(userAgent)[1];
	    } else if (/firefox/i.test(userAgent)) {
	        res.name = "Firefox";
	        res.version = /firefox\/([\d\.]+)/i.exec(userAgent)[1];
	    }
	    return res;
	};
	
	var BrowserInfo = exports.BrowserInfo = getBrowserInfo();
	
	var Browser = standardBrowser;
	var browser = BrowserInfo.name;
	
	// 验证浏览器对扩展程序的支持， Only support Chrome/Edge/Firefox!
	var checkExtension = exports.checkExtension = function checkExtension() {
	    return new Promise(function (resolve, reject) {
	        if (browser === Browser.Chrome) {
	            resolve(browser);
	        } else if (browser === Browser.Edge || browser === Browser.Firefox) {
	            if (document.getElementById(extensionName)) {
	                resolve(browser);
	            } else {
	                reject({ errorcode: 1, result: 'Extension does not exist!' });
	            }
	        } else {
	            reject({ errorcode: 1, result: 'Only support Chrome/Edge/Firefox!' });
	        }
	    });
	};

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var chromeExtension = exports.chromeExtension = "ioajglkpoiippgegmbnickbpknbahigp";
	var productID = exports.productID = "com.cfca.certenrollment.cofco";
	
	var extensionName = exports.extensionName = productID + ".extension";
	var reqEventName = exports.reqEventName = productID + ".request";
	var respEventName = exports.respEventName = productID + ".response";
	
	var GenerateRandomId = exports.GenerateRandomId = function GenerateRandomId() {
	  var charstring = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
	  var maxPos = charstring.length;
	  var randomId = '';
	  for (var i = 0; i < 10; i++) {
	    randomId += charstring.charAt(Math.floor(Math.random() * maxPos));
	  }
	  return randomId;
	};

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var standardBrowser = exports.standardBrowser = {
	    IE: "Internet Explorer",
	    Edge: "Edge",
	    Chrome: "Chrome",
	    Safari: "Safari",
	    Firefox: "Firefox"
	};
	
	var getBrowserInfo = function getBrowserInfo() {
	    var res = {
	        name: "",
	        version: ""
	    };
	    var reg;
	    var userAgent = self.navigator.userAgent;
	
	    if (reg = /edge\/([\d\.]+)/i.exec(userAgent)) {
	        res.name = "Edge";
	        res.version = reg[1];
	    } else if (/msie/i.test(userAgent)) {
	        res.name = "Internet Explorer";
	        res.version = /msie ([\d\.]+)/i.exec(userAgent)[1];
	    } else if (/Trident/i.test(userAgent)) {
	        res.name = "Internet Explorer";
	        res.version = /rv:([\d\.]+)/i.exec(userAgent)[1];
	    } else if (/chrome/i.test(userAgent)) {
	        res.name = "Chrome";
	        res.version = /chrome\/([\d\.]+)/i.exec(userAgent)[1];
	    } else if (/safari/i.test(userAgent)) {
	        res.name = "Safari";
	        res.version = /version\/([\d\.]+)/i.exec(userAgent)[1];
	    } else if (/firefox/i.test(userAgent)) {
	        res.name = "Firefox";
	        res.version = /firefox\/([\d\.]+)/i.exec(userAgent)[1];
	    }
	    return res;
	};
	
	var BrowserInfo = exports.BrowserInfo = getBrowserInfo();
	
	var Browser = standardBrowser;
	var browser = BrowserInfo.name;
	
	// 验证浏览器对扩展程序的支持， Only support Chrome/Edge/Firefox!
	var checkExtension = exports.checkExtension = function checkExtension() {
	    return new Promise(function (resolve, reject) {
	        if (browser === Browser.Chrome) {
	            resolve(browser);
	        } else if (browser === Browser.Edge || browser === Browser.Firefox) {
	            if (document.getElementById(extensionName)) {
	                resolve(browser);
	            } else {
	                reject({ errorcode: 1, result: 'Extension does not exist!' });
	            }
	        } else {
	            reject({ errorcode: 1, result: 'Only support Chrome/Edge/Firefox!' });
	        }
	    });
	};

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var chromeExtension = exports.chromeExtension = "lpbbgiejcehpljjbealmlaenekkldbgc";
	var productID = exports.productID = "com.cfca.cryptokit.cofco";
	
	var extensionName = exports.extensionName = productID + ".extension";
	var reqEventName = exports.reqEventName = productID + ".request";
	var respEventName = exports.respEventName = productID + ".response";
	
	var GenerateRandomId = exports.GenerateRandomId = function GenerateRandomId() {
	  var charstring = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
	  var maxPos = charstring.length;
	  var randomId = '';
	  for (var i = 0; i < 10; i++) {
	    randomId += charstring.charAt(Math.floor(Math.random() * maxPos));
	  }
	  return randomId;
	};

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var errorMap = {
	  '0x80070037': '指定的网络资源或设备不再可用',
	  '0xa0071001': '验证失败，请确保ukey已插入',
	  '0x800704c7': '用户取消选择证书',
	  '0xa0071003': '查询类型不支持',
	  '0xa0071004': 'Base64加密失败',
	  '0xa0071005': 'Base64解密失败',
	  '0xa0071006': '恶意的目标路径或文件名',
	  '0xa0071007': '文件为空',
	  '0xa0071020': '指定证书不含有密钥用途属性',
	  '0xa0071021': '指定证书不含有使用者密钥标识符属性',
	  '0xa0071031': '证书链中某个证书时间无效',
	  '0xa0071032': '证书在离线的CRL列表中',
	  '0xa0071033': '证书链不完整',
	  '0xa0071034': '证书链中某个证书签名无效',
	  '0xa0071041': 'aSN.1解码失败',
	  '0xa0071042': 'PKCS#7签名解码失败',
	  '0xa0071400': '无效的私钥信息',
	  '0xa0071401': '无效的私钥',
	  '0xa0071402': 'XML文件解析失败',
	  '0xa0071403': '加密证书安装失败',
	  '0xa0071404': '无效的加密证书密钥生成设备类型',
	  '0xa0071405': '加密证书私钥的加密类型错误',
	  '0xa0071406': '用来加密加密证书私钥的对称密钥类型错误',
	  '0xa0072001': '证书没有准备好',
	  '0xa0072002': '语言不支持',
	  '0xa0072003': '指定主题DN的证书不唯一',
	  '0xa0072004': '没有找到指定证书',
	  '0xa0072020': '无效的哈希算法',
	  '0xa0072021': '无效的证书用法',
	  '0xa0072022': '无效的签名类型',
	  '0xa0072023': '无效的数字信封类型',
	  '0xa0072400': '密钥长度不支持',
	  '0xa0072401': '无效的密钥算法'
	};
	exports.default = errorMap;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LogoutHandler = undefined;
	exports.default = Logout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _bussInit = __webpack_require__(524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogoutHandler = exports.LogoutHandler = function LogoutHandler() {
	  console.log('登出');
	  var success = function success(res) {
	    tool.sgiLogger.info(res, 'indexPclogout');
	    if (res && res.head.code == '0000') {
	      var allCookieKey = tool.getCookie('allCookieKey');
	      if (allCookieKey) {
	        var arr = allCookieKey.split(',');
	        arr.forEach(function (key) {
	          tool.deleteCookie(key);
	        });
	        tool.deleteCookie('allCookieKey');
	      } else {
	        tool.deleteCookie('token');
	      }
	      // 清理业务标准代码缓存
	      (0, _bussInit.deleteLoadFlag)();
	      var openSso = tool.getCookie('openSso');
	      var service = window.location.protocol + '//' + window.location.host + '/';
	      if (openSso) {
	        var url = sgiConfig.casBaseUrl + '/logout?service=' + encodeURIComponent(service);
	        console.log('useSso.ts  ssoLoginOut  url: ', url);
	        window.location.href = url;
	        return;
	      }
	      // tool.popSingleUI('/');
	      // tool.popSingleUI('/?openSso=false');
	      var path = openSso ? '/' : '/?openSso=false';
	      console.log('path', path);
	      tool.popSingleUI(path);
	    }
	  };
	  commonClient.simplecall(sgiConfig.allUrl.logoutUri, '', success, true);
	};
	
	function Logout(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.className, onClick: LogoutHandler },
	    _react2.default.createElement(_antd.Icon, { type: 'logout' })
	  );
	}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getEidtorFun = exports.getComboxTreeEidtor = exports.getCheckboxEidtor = exports.getCheckboxGroupEidtor = exports.getComboxEidtor = exports.getDateEidtor = exports.getTimeEidtor = exports.getNumberEidtor = exports.getTextEidtor = exports.getValidForm = exports.getValidRow = exports.renderSelectOptions = exports.valueTypes = exports.ctlTypes = exports.formItemLayout3 = exports.formItemLayout2 = exports.formItemLayout = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _antd = __webpack_require__(25);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dnd_SgiFormEditorCommonUtils = __webpack_require__(794);
	
	var _common = __webpack_require__(194);
	
	var _editorConstants = __webpack_require__(990);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var Search = _antd.Input.Search;
	var Option = _antd.Select.Option;
	
	var formItemLayout = {
	    labelCol: { span: 8 },
	    wrapperCol: { span: 16 },
	    style: { margin: 0 }
	};
	
	var formItemLayout2 = {
	    labelCol: { span: 4 },
	    wrapperCol: { span: 20 },
	    style: { margin: 0 }
	};
	
	var formItemLayout3 = {
	    labelCol: { span: 12 },
	    wrapperCol: { span: 12 },
	    style: { margin: 0 }
	};
	
	var ctlTypes = [{
	    "te": "文本框",
	    "c": "EP_EO_UI_3101"
	}, {
	    "te": "文本域",
	    "c": "EP_EO_UI_3102"
	}, {
	    "te": "数字",
	    "c": "EP_EO_UI_3104"
	}, {
	    "te": "时间",
	    "c": "EP_EO_UI_3105"
	}, {
	    "te": "日期",
	    "c": "EP_EO_UI_3106"
	}, {
	    "te": "下拉窗",
	    "c": "EP_EO_UI_3107"
	}, {
	    "te": "复选框组",
	    "c": "EP_EO_UI_3108"
	}, {
	    "te": "单选框组",
	    "c": "EP_EO_UI_3109"
	}, {
	    "te": "复选框",
	    "c": "EP_EO_UI_3110"
	}, {
	    "te": "下拉树",
	    "c": "EP_EO_NUI_0001"
	}];
	//let valueTypePrm = PrmFactory.getPrm(custGroupConfig.valueTypePrm) || {};
	var types = [{
	    "te": "字符串",
	    "c": "01"
	}, {
	    "te": "字符串数组",
	    "c": "02"
	}, {
	    "te": "数字",
	    "c": "03"
	}, {
	    "te": "数字数组",
	    "c": "04"
	}, {
	    "te": "小数",
	    "c": "05"
	}, {
	    "te": "小数数组",
	    "c": "06"
	}, {
	    "te": "日期",
	    "c": "07"
	}];
	var valueTypes = types.map(function (type) {
	    return type;
	});
	
	var textOnChange = function textOnChange(currentModule, attname, e, e2) {
	    var value = e.target.value;
	    currentModule.refresh(attname, value);
	};
	
	var selectOnChange = function selectOnChange(currentModule, attname, value) {
	    //change传入对象为value
	    currentModule.refresh(attname, value);
	};
	
	var numberOnChange = function numberOnChange(currentModule, attname, e) {
	    var value = e;
	    currentModule.refresh(attname, value);
	};
	
	var checkOnChange = function checkOnChange(currentModule, attname, e) {
	    var value = e.target.checked;
	    currentModule.refresh(attname, value);
	};
	
	var renderSelectOptions = function renderSelectOptions(data, codeCode, textCode) {
	    codeCode = codeCode || "c";
	    textCode = textCode || "te";
	    return data.map(function (item) {
	        return _react2.default.createElement(
	            Option,
	            { value: item[codeCode] },
	            item[textCode]
	        );
	    });
	};
	
	var getSCEditor = function getSCEditor(currentModule, label, attname) {
	    //标准代码
	    label = label || "标准代码";
	    attname = attname || "scId";
	    return _react2.default.createElement(
	        _antd.Col,
	        { span: 8 },
	        _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, { label: label }),
	            _react2.default.createElement(Search, { value: currentModule.state.values[attname], onChange: textOnChange.bind(currentModule, currentModule, attname),
	                onSearch: function onSearch() {
	                    return currentModule.setState({ SCModalVisible: true });
	                } })
	        )
	    );
	};
	
	var getValidCol = function getValidCol(currentModule) {
	    if (!currentModule.state.values.vldC) {
	        currentModule.state.values.vldC = "";
	    }
	    (0, _Dnd_SgiFormEditorCommonUtils.vldCCtrlHidFlg)(currentModule, currentModule.state.values.vldC);
	    return _react2.default.createElement(
	        _antd.Col,
	        { span: 8 },
	        _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, { label: "校验类型" }),
	            _react2.default.createElement(
	                _antd.Select,
	                { value: currentModule.state.values.vldC, onChange: _Dnd_SgiFormEditorCommonUtils.vldCOnChangeAndCtrlHidFlg.bind(currentModule, currentModule, 'vldC') },
	                _react2.default.createElement(
	                    Option,
	                    { value: '' },
	                    '\u65E0'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'int' },
	                    '\u6574\u6570'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'double' },
	                    'Double'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'money' },
	                    '\u91D1\u989D'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'email' },
	                    'email'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'idcard18' },
	                    '\u8EAB\u4EFD\u8BC1'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'phone' },
	                    '\u7535\u8BDD\u53F7'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'mobile' },
	                    '\u624B\u673A\u53F7'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'zip' },
	                    '\u90AE\u653F'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'url' },
	                    'HTTP\u5730\u5740'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'qq' },
	                    'QQ\u53F7'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: 'number' },
	                    '\u6570\u5B57'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: '\u6C49\u5B57' },
	                    '\u6C49\u5B57'
	                ),
	                _react2.default.createElement(
	                    Option,
	                    { value: '\u5B57\u6BCD' },
	                    '\u5B57\u6BCD'
	                )
	            )
	        )
	    );
	};
	var getValidRow = function getValidRow(currentModule) {
	    if (!currentModule.state.values.defaultMatchType) {
	        currentModule.state.values.defaultMatchType = "EqualTo";
	    }
	    return _react2.default.createElement(
	        _antd.Row,
	        null,
	        getValidCol(currentModule),
	        _react2.default.createElement(
	            _antd.Col,
	            { span: 8 },
	            _react2.default.createElement(
	                FormItem,
	                _extends({}, formItemLayout, { label: "默认匹配" }),
	                _react2.default.createElement(
	                    _antd.Select,
	                    { value: currentModule.state.values.defaultMatchType, onChange: selectOnChange.bind(currentModule, currentModule, 'defaultMatchType') },
	                    (0, _common.getExpressOptions)()
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	                FormItem,
	                { style: { margin: 0 }, labelCol: { span: 18 }, label: "匹配选择禁用" },
	                _react2.default.createElement(_antd.Checkbox, { checked: currentModule.state.values.matchDis, onChange: checkOnChange.bind(undefined, currentModule, 'matchDis') })
	            )
	        )
	    );
	};
	var getValidForm = function getValidForm(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule)
	    );
	};
	var getTextEidtor = function getTextEidtor(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "文本后信息" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.bdText, onChange: textOnChange.bind(currentModule, currentModule, 'bdText') })
	                )
	            )
	        )
	    );
	};
	var getEidtorFun = function getEidtorFun(currentModule, ctlType) {
	    var ctlDescs = _editorConstants.EditorDesc[ctlType];
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        ctlDescs ? getRowEidtorByDesc(ctlDescs, currentModule) : null
	    );
	};
	var getRowEidtorByDesc = function getRowEidtorByDesc(rowDescs, currentModule) {
	    return rowDescs.map(function (row) {
	        return _react2.default.createElement(
	            _antd.Row,
	            null,
	            row.map(function (ctlDesc) {
	                return ctlDesc.code === "scId" ? getSCEditor(currentModule) : (0, _Dnd_SgiFormEditorCommonUtils.getColUnitByDesc)(ctlDesc, currentModule);
	            })
	        );
	    });
	};
	var getNumberEidtor = function getNumberEidtor(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "最小长度" }),
	                    _react2.default.createElement(_antd.InputNumber, { defaultValue: 0, value: currentModule.state.values.minL, onChange: numberOnChange.bind(currentModule, currentModule, 'minL') })
	                )
	            ),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "最大长度" }),
	                    _react2.default.createElement(_antd.InputNumber, { defaultValue: 0, value: currentModule.state.values.maxL, onChange: numberOnChange.bind(currentModule, currentModule, 'maxL') })
	                )
	            )
	        )
	    );
	};
	var getTimeEidtor = function getTimeEidtor(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "时间格式" }),
	                    _react2.default.createElement(_antd.Input, { placeholder: 'HH:mm:ss', value: currentModule.state.values.timeFmt, onChange: textOnChange.bind(currentModule, currentModule, 'timeFmt') })
	                )
	            )
	        )
	    );
	};
	var getDateEidtor = function getDateEidtor(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "日期格式" }),
	                    _react2.default.createElement(_antd.Input, { placeholder: 'YYYY-MM-DD', value: currentModule.state.values.dateFmt, onChange: textOnChange.bind(currentModule, currentModule, 'dateFmt') })
	                )
	            ),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "组件模式" }),
	                    _react2.default.createElement(
	                        _antd.Select,
	                        { value: currentModule.state.values.ctlMode || "date", onChange: selectOnChange.bind(currentModule, currentModule, 'ctlMode') },
	                        _react2.default.createElement(
	                            Option,
	                            { value: 'date' },
	                            '\u65E5\u671F\u6A21\u5F0F'
	                        ),
	                        _react2.default.createElement(
	                            Option,
	                            { value: 'dateTime' },
	                            '\u65E5\u671F\u65F6\u95F4\u6A21\u5F0F'
	                        ),
	                        _react2.default.createElement(
	                            Option,
	                            { value: 'month' },
	                            '\u6708\u6A21\u5F0F'
	                        ),
	                        _react2.default.createElement(
	                            Option,
	                            { value: 'week' },
	                            '\u5468\u6A21\u5F0F'
	                        ),
	                        _react2.default.createElement(
	                            Option,
	                            { value: 'dateRange' },
	                            '\u65E5\u671F\u8303\u56F4\u6A21\u5F0F'
	                        ),
	                        _react2.default.createElement(
	                            Option,
	                            { value: 'dateTimeRange' },
	                            '\u65E5\u671F\u65F6\u95F4\u8303\u56F4\u6A21\u5F0F'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "起始日期" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.optBDt, onChange: textOnChange.bind(currentModule, currentModule, 'optBDt') })
	                )
	            ),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "结束日期" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.optEDt, onChange: textOnChange.bind(currentModule, currentModule, 'optEDt') })
	                )
	            )
	        )
	    );
	};
	var getComboxEidtor = function getComboxEidtor(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            getSCEditor(currentModule),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "默认值" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.defVal10, onChange: textOnChange.bind(currentModule, currentModule, 'defVal10') })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 4 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout3, { label: "多选" }),
	                    _react2.default.createElement(_antd.Checkbox, { checked: currentModule.state.values.mulSel, onChange: checkOnChange.bind(currentModule, currentModule, 'mulSel') })
	                )
	            ),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 4 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout3, { label: "搜索框" }),
	                    _react2.default.createElement(_antd.Checkbox, { checked: currentModule.state.values.search, onChange: checkOnChange.bind(currentModule, currentModule, 'search') })
	                )
	            )
	        )
	    );
	};
	var getCheckboxGroupEidtor = function getCheckboxGroupEidtor(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            getSCEditor(currentModule),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "默认选中项" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.checked, onChange: textOnChange.bind(currentModule, currentModule, 'checked') })
	                )
	            )
	        )
	    );
	};
	var getCheckboxEidtor = function getCheckboxEidtor(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "初始值" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.defVal10, onChange: textOnChange.bind(currentModule, currentModule, 'defVal10') })
	                )
	            )
	        )
	    );
	};
	var getComboxTreeEidtor = function getComboxTreeEidtor(currentModule) {
	    return _react2.default.createElement(
	        _antd.Form,
	        null,
	        getValidRow(currentModule),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            getSCEditor(currentModule),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "绑定实例名" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.insName, onChange: textOnChange.bind(currentModule, currentModule, 'insName') })
	                )
	            ),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 4 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "多选" }),
	                    _react2.default.createElement(_antd.Checkbox, { checked: currentModule.state.values.mulSel, onChange: checkOnChange.bind(currentModule, currentModule, 'mulSel') })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "显示属性名" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.showKey, onChange: textOnChange.bind(currentModule, currentModule, 'showKey') })
	                )
	            ),
	            _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                    FormItem,
	                    _extends({}, formItemLayout, { label: "保存属性名" }),
	                    _react2.default.createElement(_antd.Input, { value: currentModule.state.values.saveKey, onChange: textOnChange.bind(currentModule, currentModule, 'saveKey') })
	                )
	            )
	        )
	    );
	};
	
	exports.formItemLayout = formItemLayout;
	exports.formItemLayout2 = formItemLayout2;
	exports.formItemLayout3 = formItemLayout3;
	exports.ctlTypes = ctlTypes;
	exports.valueTypes = valueTypes;
	exports.renderSelectOptions = renderSelectOptions;
	exports.getValidRow = getValidRow;
	exports.getValidForm = getValidForm;
	exports.getTextEidtor = getTextEidtor;
	exports.getNumberEidtor = getNumberEidtor;
	exports.getTimeEidtor = getTimeEidtor;
	exports.getDateEidtor = getDateEidtor;
	exports.getComboxEidtor = getComboxEidtor;
	exports.getCheckboxGroupEidtor = getCheckboxGroupEidtor;
	exports.getCheckboxEidtor = getCheckboxEidtor;
	exports.getComboxTreeEidtor = getComboxTreeEidtor;
	exports.getEidtorFun = getEidtorFun;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(25);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _rtSdComp = __webpack_require__(199);
	
	var _common = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParamMngDef = function (_React$Component) {
	    _inherits(ParamMngDef, _React$Component);
	
	    function ParamMngDef(props) {
	        _classCallCheck(this, ParamMngDef);
	
	        var _this = _possibleConstructorReturn(this, (ParamMngDef.__proto__ || Object.getPrototypeOf(ParamMngDef)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var guid = _this.props.guid;
	
	        var objFct = new _rtSdCommon.ObjFactory(guid);
	
	        var treeData = [];
	        var prm = _rtSdCommon.PrmFactory.getPrm(guid);
	        if (prm.cldSet) {
	            treeData = prm.cldSet;
	        }
	
	        _this.state = {
	            forms: {}, //客群定义显示form，一个属性一个form,{key:form,key2:form2}
	            columns: {}, //客群定义显示form，一个属性一个form,{key:form,key2:form2}
	            formsValue: {},
	            showCtls: {}, //存储所有显示控件
	            objFct: _this.props.objFct || objFct,
	            loading: false,
	            checkedAtts: {},
	            checkedAtts_table: {}, //新加表格勾选节点
	            treeData: treeData,
	            checkedKeys: [],
	            expandedKeys: [],
	            data: _this.props.data || []
	        };
	        return _this;
	    }
	
	    _createClass(ParamMngDef, [{
	        key: 'handleChange',
	        value: function handleChange(attc, match_type, dataRef, value) {
	
	            if (value == "Between" || value == "NotBetween") {
	                this.state.formsValue[attc]["ctl2Display"] = undefined;
	            } else {
	                this.state.formsValue[attc]["ctl2Display"] = 'none';
	            }
	            this.state.formsValue[attc][match_type] = value;
	            (0, _common.createFormInfo)(this, dataRef, value); //重新创建
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'refModalFunction',
	        value: function refModalFunction(ctl) {
	            if (!ctl) {
	                return;
	            }
	            var _ctl$props = ctl.props,
	                moduleDesc = _ctl$props.moduleDesc,
	                objFct = _ctl$props.objFct;
	
	            this.state.showCtls[moduleDesc.cRef + moduleDesc.c] = ctl;
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            if (this.props.data && this.props.data.length > 0) {
	                this.refreshData(this.props.data);
	            } else if (this.props.allData) {
	                var treeData = this.state.treeData || [];
	                treeData.forEach(function (d) {
	                    return _this2.onCheck([], { checked: true, node: { props: { dataRef: d } } });
	                });
	            }
	            // this.refreshData(this.state.data);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var hide = this.state.hide;
	            if (hide) hide();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var showList = this.renderCardNodes(this.state.treeData, this.state.forms, this.state.columns);
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '100%', width: '100%', overflow: "auto" } },
	                this.props.noTree ? _react2.default.createElement(
	                    'div',
	                    { style: { height: '100%', overflow: "auto" } },
	                    showList
	                ) : _react2.default.createElement(
	                    _antd.Row,
	                    { style: { height: '100%', width: '100%' } },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { style: { overflow: 'auto' }, span: 5 },
	                        _react2.default.createElement(
	                            _antd.Tree,
	                            {
	                                checkable: true,
	                                onExpand: _common.onExpand.bind(this),
	                                expandedKeys: this.state.expandedKeys
	                                // autoExpandParent={this.state.autoExpandParent}
	                                , onCheck: this.onCheck,
	                                checkedKeys: this.state.checkedKeys,
	                                onSelect: _common.onSelect.bind(this)
	                                // selectedKeys={this.state.selectedKeys}
	                            },
	                            (0, _common.renderTreeNodes)(this.state.treeData)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { style: { height: '100%' }, span: 19 },
	                        showList
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ParamMngDef;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.convertData = function (e) {
	        //校验 组装数据
	        var errors = [];
	        var errorMsg = void 0;
	        for (var tmpKey in _this3.state.showCtls) {
	            var tmpCtl = _this3.state.showCtls[tmpKey];
	            var ctlDisplay = _this3.state.formsValue[tmpCtl.props.moduleDesc.cRef]["ctl2Display"];
	            if (ctlDisplay != 'none') {
	                errorMsg = tmpCtl.validate();
	                if (errorMsg) {
	                    errors.push(errorMsg);
	                }
	            }
	        }
	
	        if (errors.length > 0) {
	            //组装数据
	            _this3.setState({ loading: false });
	            // alert('校验失败');//这里不用提示，组件自身提示
	            return null;
	        }
	
	        var data = [];
	        for (var tmpKey in _this3.state.checkedAtts) {
	            var tmpSaveRecord = _this3.state.objFct.get(tmpKey + "_tmp");
	            var matchType = tmpSaveRecord.match_type;
	            var value = tmpSaveRecord.value1;
	            if (matchType == "Between" || matchType == "NotBetween") {
	                value += "," + tmpSaveRecord.value2;
	            }
	            var obj = {
	                tagId: tmpSaveRecord.id,
	                tagName: tmpSaveRecord.te,
	                matchType: matchType,
	                valueType: tmpSaveRecord.valueType || "01",
	                featureValue: value,
	                tagCode: tmpSaveRecord.c
	            };
	            data.push(obj);
	        }
	
	        // 处理表方式展示的数据
	        var tableData = [];
	        for (var _tmpKey in _this3.state.checkedAtts_table) {
	            var tmpData = _this3.state.checkedAtts_table[_tmpKey];
	            if (tableData.indexOf(tmpData) < 0) tableData.push(tmpData);
	        }
	        var tableDataCopy = (0, _rtSdCommon.copy)(tableData, true);
	        _this3.deleteOverKeys(tableDataCopy, _this3.state.checkedAtts_table);
	
	        data.push.apply(data, _toConsumableArray(tableDataCopy));
	
	        var objFct = _this3.props.objFct;
	        var dataInst = _this3.props.dataInst;
	        if (dataInst && objFct) {
	            objFct.set(dataInst, data);
	        }
	
	        return data;
	    };
	
	    this.deleteOverKeys = function () {
	        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        items.forEach(function (item) {
	            if (item.ds) {
	                // 继续向下
	                _this3.deleteOverKeys(item.ds, keys);
	            } else {
	                for (var key in item) {
	                    if (!keys[key]) delete item[key];
	                }
	            }
	        });
	    };
	
	    this.refreshData = function (data, loading) {
	
	        if (loading) {
	            _this3.state.hide = tool.popMessage("加载中，请稍后", "loading", null, 0);
	        }
	
	        if (!data) return;
	
	        //重置
	        _this3.state.forms = {};
	        _this3.state.formsValue = {};
	        if (!_this3.props.allData) _this3.state.checkedAtts = {};
	        _this3.state.showCtls = {};
	        if (!_this3.props.allData) _this3.state.checkedAtts_table = {};
	
	        var checkedKeys = [];var expandedKeys = [];
	        var treeData = _this3.state.treeData;
	        data.forEach(function (item) {
	            if (item.rel && item.sc) {
	                // 表格展示数据
	                var gr = _this3.findGroup(treeData, item);
	                if (gr) {
	                    // gr.data = item;
	                    if (gr.data) merge(gr.data, item);else gr.data = item;
	                    var keys = _this3.getColumnKeys(item.ds);
	
	                    var _loop = function _loop(rec) {
	                        var c = rec.c;
	                        if (c && keys.indexOf(c) > -1) {
	                            var id = rec.id;
	                            _this3.state.checkedAtts_table[id] = item;
	                            _this3.state.columns[id] = {
	                                // style: { minWidth: 100 },
	                                width: rec.width || undefined,
	                                title: rec.te, dataIndex: rec.c, key: rec.c,
	                                render: function render(text, record, index) {
	                                    var ctl = (0, _rtSdComp.convertModuleByGuid)(_this3, _extends({}, rec, { isLbl: true }), record, _this3.state.objFct, "N");
	                                    delete ctl.ref;
	                                    return ctl;
	                                }
	                            };
	                            checkedKeys.push(rec._key);
	                            if (expandedKeys.indexOf(gr._key) < 0) expandedKeys.push(gr._key);
	                        }
	                    };
	
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = gr.cldSet[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var rec = _step.value;
	
	                            _loop(rec);
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	                }
	            } else {
	                // form展示数据
	                item.tagId = item.tagId || item.featureTagId;
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = treeData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var _gr = _step2.value;
	
	                        if (!_gr.cldSet) continue;
	                        var _iteratorNormalCompletion3 = true;
	                        var _didIteratorError3 = false;
	                        var _iteratorError3 = undefined;
	
	                        try {
	                            for (var _iterator3 = _gr.cldSet[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                                var _rec = _step3.value;
	
	                                if (item.tagId == _rec.id) {
	                                    checkedKeys.push(_rec._key);
	                                    if (expandedKeys.indexOf(_gr._key) == -1) {
	                                        expandedKeys.push(_gr._key);
	                                    }
	                                    var matchType = item.matchType;
	                                    var ctl2Display = "none";
	                                    var value = item.featureValue;
	                                    var value1 = value,
	                                        value2 = void 0;
	                                    if (matchType == "Between" || matchType == "NotBetween") {
	                                        ctl2Display = undefined;
	                                        var values = value.split(",");
	                                        value1 = values[0];
	                                        value2 = values[1];
	                                    }
	                                    _this3.state.formsValue[_rec.c] = _extends({}, _rec, { match_type: matchType, ctl2Display: ctl2Display, value1: value1, value2: value2 });
	                                    (0, _common.createFormInfo)(_this3, _rec, matchType, value1, value2);
	                                    break;
	                                }
	                            }
	                        } catch (err) {
	                            _didIteratorError3 = true;
	                            _iteratorError3 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                    _iterator3.return();
	                                }
	                            } finally {
	                                if (_didIteratorError3) {
	                                    throw _iteratorError3;
	                                }
	                            }
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	            }
	        });
	        _this3.setState({ checkedKeys: checkedKeys });
	        _this3.setState({ expandedKeys: expandedKeys });
	    };
	
	    this.findGroup = function () {
	        var treeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var relGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var treeGroup = {};
	        if (treeData.some(function (node) {
	            if (node.sc === relGroup.sc) {
	                treeGroup = node;
	                return true;
	            } else if (node.cldSet && node.cldSet.length > 0) {
	                treeGroup = _this3.findGroup(node.cldSet, relGroup);
	                return treeGroup;
	            }
	        })) {
	            return treeGroup;
	        };
	    };
	
	    this.getColumnKeys = function () {
	        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var keys = [];
	        items.forEach(function (item) {
	            if (item.ds && item.ds.length > 0) {
	                var sonKeys = _this3.getColumnKeys(item.ds) || [];
	                sonKeys.forEach(function (key) {
	                    return keys.indexOf(key) < 0 && keys.push(key);
	                });
	            } else {
	                for (var key in item) {
	                    if (keys.indexOf(key) < 0) keys.push(key);
	                }
	            }
	        });
	        return keys;
	    };
	
	    this.onCheck = function (checkedKeys, e) {
	        _this3.state.checkedKeys = checkedKeys;
	
	        var checkFlag = e.checked;
	        var node = e.node;
	        var dataRef = node.props.dataRef;
	        var parentDataRef = node.props.parentDataRef;
	
	        if (dataRef.nodeType == "group") {
	            var cldSet = dataRef.cldSet || [];
	            cldSet.forEach(function (cld) {
	                _this3.checkOne(cld, checkFlag, dataRef);
	            });
	        } else {
	            _this3.checkOne(dataRef, checkFlag, parentDataRef);
	        }
	
	        _this3.setState({ loading: false });
	    };
	
	    this.checkOne = function (one, checkFlag, parentDataRef) {
	        if (one.nodeType === "group") {
	            var cldSet = one.cldSet || [];
	            cldSet.forEach(function (cld) {
	                _this3.checkOne(cld, checkFlag, one);
	            });
	            return;
	        }
	        var c = one.c;
	        if (!c) return;
	
	        if (parentDataRef && parentDataRef.isList) {
	            // 表格形式
	            var id = one.id;
	            if (checkFlag) {
	                if (!one.desId) one.desId = "EP_EO_UI_3101"; //添加默认值-文本框
	
	                // 记录勾选了哪些节点
	                _this3.state.checkedAtts_table[id] = Object.assign(parentDataRef.data, {
	                    te: parentDataRef.te,
	                    sc: parentDataRef.sc,
	                    ann: parentDataRef.ann
	                });
	                // 隐藏标签
	                one.isLbl = true;
	
	                _this3.state.columns[id] = {
	                    width: one.width || undefined,
	                    title: one.te, dataIndex: one.c, key: one.c,
	                    render: function render(text, record, index) {
	                        var ctl = (0, _rtSdComp.convertModuleByGuid)(_this3, one, record, _this3.state.objFct, "N");
	                        delete ctl.ref;
	                        return ctl;
	                    }
	                };
	            } else {
	                delete _this3.state.columns[id];
	                // delete this.state.formsValue[c];
	                delete _this3.state.checkedAtts_table[id];
	            }
	        } else {
	            // form形式
	            var match_type = one.match_type || one.defaultMatchType || "EqualTo";
	            var ctl2Display = "none";
	            if (match_type == "Between" || match_type == "NotBetween") {
	                ctl2Display = undefined;
	            }
	
	            if (checkFlag) {
	                _this3.state.formsValue[c] = _extends({}, one, { match_type: match_type, ctl2Display: ctl2Display });
	                (0, _common.createFormInfo)(_this3, one, match_type);
	            } else {
	                delete _this3.state.forms[c];
	                delete _this3.state.formsValue[c];
	                delete _this3.state.checkedAtts[c];
	                delete _this3.state.showCtls[c + "value1"];
	                delete _this3.state.showCtls[c + "value2"];
	            }
	        }
	    };
	
	    this.renderCardNodes = function () {
	        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var forms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        var columns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	        return data.map(function (item) {
	            if (item.cldSet) {
	                return _react2.default.createElement(
	                    _antd.Card,
	                    { size: 'small', title: item.te, style: { display: _this3.checkChecked(item.cldSet) ? undefined : "none", margin: "10px" } },
	                    item.isList ? _this3.renderTable(item, columns) : _this3.renderCardNodes(item.cldSet, forms, columns)
	                );
	            }
	            // return forms[item.c];
	            return _this3.props.noTree ? _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                forms[item.c]
	            ) : forms[item.c];
	        });
	    };
	
	    this.checkChecked = function () {
	        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        return items.some(function (item) {
	            return _this3.state.forms[item.c] || _this3.state.columns[item.id] || _this3.checkChecked(item.cldSet);
	        });
	    };
	
	    this.renderTable = function () {
	        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var cldSet = item.cldSet || [];
	        var rlData = item.data;
	        if (!rlData) rlData = item.data = { rel: "or", ds: [] };
	        var dataSource = rlData.ds;
	        var tbColumns = [{
	            dataIndex: 'rel',
	            render: function render(text, record, index) {
	                return dataSource.indexOf(record) === 0 ? null : "或";
	            }
	        }, {
	            dataIndex: 'content',
	            render: function render(text, record, index) {
	                return '\u5185\u90E8\u5173\u7CFB\u6570\u91CF\uFF1A' + (record.ds || []).length;
	            }
	        }, {
	            title: _react2.default.createElement(
	                'a',
	                { style: { whiteSpace: "nowrap" },
	                    onClick: function onClick() {
	                        return dataSource.push({ rel: "and", ds: [] }) && _this3.setState({});
	                    }
	                },
	                ' ',
	                '+\u6DFB\u52A0' + (dataSource.length > 0 ? '"\u6216"' : "") + '\u6761\u4EF6\u7EC4'
	            ),
	            width: 50,
	            align: "right",
	            render: function render(text, record, index) {
	                return _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                            return dataSource.splice(dataSource.indexOf(record), 1) && _this3.setState({});
	                        } },
	                    '\u5220\u9664\u6761\u4EF6\u7EC4'
	                );
	            }
	        }];
	        var nestedColumns = [{ dataIndex: 'rel', width: 20 }];
	        cldSet.forEach(function (cld) {
	            if (columns[cld.id]) {
	                nestedColumns.push(columns[cld.id]);
	            }
	        });
	        nestedColumns.push({ width: 50, align: "right" });
	        var expandedRowRender = function expandedRowRender(rowRecord) {
	            // let nested_rlData = rowRecord.ds;
	            // if (!nested_rlData) nested_rlData = rowRecord.ds = { rel: "and", ds: [] };
	            var nestedDataSource = rowRecord.ds;
	            nestedColumns[0].render = function (text, record, index) {
	                return nestedDataSource.indexOf(record) === 0 ? null : "且";
	            };
	            nestedColumns[nestedColumns.length - 1].title = _react2.default.createElement(
	                'a',
	                { style: { whiteSpace: "nowrap" },
	                    onClick: function onClick() {
	                        return nestedDataSource.push({}) && _this3.setState({});
	                    }
	                },
	                '+\u6DFB\u52A0' + (nestedDataSource.length > 0 ? '"\u4E14"' : "") + '\u6761\u4EF6'
	            );
	            nestedColumns[nestedColumns.length - 1].render = function (text, record, index) {
	                return _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                            return nestedDataSource.splice(nestedDataSource.indexOf(record), 1) && _this3.setState({});
	                        } },
	                    '\u5220\u9664\u6761\u4EF6'
	                );
	            };
	            return _react2.default.createElement(_antd.Table, {
	                size: 'small',
	                columns: nestedColumns,
	                dataSource: nestedDataSource,
	                pagination: false
	            });
	        };
	        return _react2.default.createElement(_antd.Table, {
	            size: 'small',
	            columns: tbColumns,
	            expandedRowRender: expandedRowRender,
	            dataSource: dataSource,
	            pagination: false
	        });
	    };
	};
	
	exports.default = ParamMngDef;
	
	/**
	 * 属性合并
	 * @param {object} target 目标对象
	 * @param {object} source 源对象
	 */
	
	function merge(target, source) {
	    // 目标和源相同，直接返回
	    if (target === source) return target;
	    // 分情况处理
	    if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
	        for (var key in source) {
	            if (target[key] === source[key]) continue; //相同，跳过
	            if (!target[key]) target[key] = source[key]; //target属性不存在，直接赋值
	            else target[key] = merge(target[key], source[key]); //target属性存在，合并
	        }
	    } else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
	        for (var i = 0; i < source.length; i++) {
	            if (target[i] === source[i]) continue; //相同，跳过
	            if (!target[i]) target.push(source[i]); //target元素不存在，直接添加
	            else target[i] = merge(target[i], source[i]); //target元素存在，合并
	        }
	    } else {
	        //其他情况，直接赋值
	        target = source;
	    }
	    // 返回target
	    return target;
	}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var apJSLoadFlag = {};
	
	// 清除加载标识
	function deleteLoadFlag() {
	    for (var key in apJSLoadFlag) {
	        delete apJSLoadFlag[key];
	    }
	}
	
	function bussLoading() {}
	
	//初始化 部门标准代码
	// initDeptSC();
	
	//初始化 我的部门标准代码
	// initMyDeptSC();
	
	//初始化 用户标准代码
	// initUserSC();
	
	//初始化 岗位标准代码
	// initPostSC();
	
	//初始化 角色标准代码
	// initRoleSC();
	
	// //初始化 产品列表
	// initProdSC();
	
	// //初始化 产品类型树
	// initProdTypeSC();
	
	// //初始化 客群
	// initCustGroup();
	
	// //初始化 客户标签
	// initCustTag();
	
	
	// function initProdTypeSC() {
	
	//     if (apJSLoadFlag["pmos_SC_comm.chng_00003020"]) {
	//         return;
	//     } else {
	//         apJSLoadFlag["pmos_SC_comm.chng_00003020"] = true;
	//     }
	
	//     var req2 = { /*classifyType: "2"*/ };
	//     var url = sgiConfig.service + "pmosprod/classify/queryClassifyList"; // 产品类型
	//     commonClient.simplecall(url, req2, function (res) {
	//         if (res && res.head && res.head.code == "0000") {
	//             tool.sgiLogger.info('查部产品类型成功 res:', res);
	//             let datas = res.body || [], id = "prodClassifyId", pid = "parentClassifyId", treeId = "", virtual = null;
	//             ctTrStrByDatacustomMade(datas, id, pid, "classifyName", "pmos_SC_comm.chng_00003020");
	//         } else {
	//             tool.sgiLogger.error("查产品类型失败 res:", res);
	//         }
	//     });
	// }
	
	// function initProdSC() {
	
	
	//     if (apJSLoadFlag["pmos_SC_comm.chng_00003021"]) {
	//         return;
	//     } else {
	//         apJSLoadFlag["pmos_SC_comm.chng_00003021"] = true;
	//     }
	
	//     var req2 = {};
	//     var url = sgiConfig.service + "pomsprod/complete/list3"; // 查询产品列表
	//     commonClient.simplecall(url, req2, function (res) {
	//         if (res && res.head && res.head.code == "0000") {
	//             tool.sgiLogger.info('查产品列表成功 res:', res);
	//             let datas = res.body || [];
	//             var scCode = "pmos_SC_comm.chng_00003021", list = datas, codeCode = "prodId", textCode = "prodName", noclearFlag = false;
	//             tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
	//         } else {
	//             tool.sgiLogger.error("查产品列表失败 res:", res);
	//         }
	//     });
	// }
	
	function initMyDeptSC() {
	
	    if (apJSLoadFlag["pmos_SC_comm.chng_00003022"]) {
	        return;
	    } else {
	        apJSLoadFlag["pmos_SC_comm.chng_00003022"] = true;
	    }
	
	    var req2 = { id: tool.getCookie('deptId') };
	    var path2 = sgiConfig.service_baseuam + "/dept/getAllDeptUnderDept"; // 查询用户列表
	    commonClient.simplecall(path2, req2, function (res) {
	        if (res && res.head && res.head.code == "0000") {
	            tool.sgiLogger.info('查部门列表成功 res:', res);
	            var scCode = "pmos_SC_comm.chng_00003022",
	                list = res.body || [],
	                codeCode = "id",
	                textCode = "deptName",
	                noclearFlag = false;
	            tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
	            // let datas = res.body || [], id = "id", pid = "parentId", treeId = "", virtual = null;
	            // ctTrStrByDatacustomMade(datas, id, pid, "deptName", "pmos_SC_comm.chng_00003022");
	        } else {
	            tool.sgiLogger.error("查部门列表失败 res:", res);
	        }
	    });
	}
	
	function initDeptSC() {
	
	    if (apJSLoadFlag["pmos_SC_comm.chng_00001002"]) {
	        return;
	    } else {
	        apJSLoadFlag["pmos_SC_comm.chng_00001002"] = true;
	    }
	
	    var req2 = { enterpriseId: tool.getCookie('enterpriseId') };
	    var path2 = sgiConfig.service_baseuam + "/dept/getOrganization"; // 查询用户列表
	    commonClient.simplecall(path2, req2, function (res) {
	        if (res && res.head && res.head.code == "0000") {
	            tool.sgiLogger.info('查部门列表成功 res:', res);
	            var datas = res.body || [],
	                id = "id",
	                pid = "parentId",
	                treeId = "",
	                virtual = null;
	            ctTrStrByDatacustomMade(datas, id, pid, "deptName", "pmos_SC_comm.chng_00001002");
	        } else {
	            tool.sgiLogger.error("查部门列表失败 res:", res);
	        }
	    });
	}
	
	function initUserSC() {
	
	    if (apJSLoadFlag["pmos_SC_comm.chng_00001001"]) {
	        return;
	    } else {
	        apJSLoadFlag["pmos_SC_comm.chng_00001001"] = true;
	    }
	
	    var req2 = { enterpriseId: tool.getCookie('enterpriseId') };
	    var path2 = sgiConfig.service_baseuam + "/UamUserInfo/query"; // 查询用户列表
	    commonClient.simplecall(path2, req2, function (res) {
	        if (res && res.head && res.head.code == "0000") {
	            tool.sgiLogger.info('查用户列表成功 res:', res);
	            var datas = res.body || [];
	            var scCode = "pmos_SC_comm.chng_00001001",
	                list = datas,
	                codeCode = "userId",
	                textCode = "userNickname",
	                noclearFlag = true;
	            tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
	        } else {
	            tool.sgiLogger.error("查用户列表失败 res:", res);
	        }
	    });
	}
	
	function initPostSC() {
	
	    if (apJSLoadFlag["pmos_SC_comm.chng_00001003"]) {
	        return;
	    } else {
	        apJSLoadFlag["pmos_SC_comm.chng_00001003"] = true;
	    }
	
	    var req2 = { enterpriseId: tool.getCookie('enterpriseId') };
	    var path2 = sgiConfig.service_baseuam + "/post/getPostOfEnterprise"; // 查询岗位id
	    commonClient.simplecall(path2, req2, function (res) {
	        if (res && res.head && res.head.code == "0000") {
	            tool.sgiLogger.info('查用户列表成功 res:', res);
	            var datas = res.body || [];
	            var scCode = "pmos_SC_comm.chng_00001003",
	                list = datas,
	                codeCode = "postId",
	                textCode = "postName",
	                noclearFlag = false;
	            tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
	        } else {
	            tool.sgiLogger.error("查用户列表失败 res:", res);
	        }
	    });
	}
	
	function initRoleSC() {
	
	    if (apJSLoadFlag["pmos_SC_comm.chng_00003019"]) {
	        return;
	    } else {
	        apJSLoadFlag["pmos_SC_comm.chng_00003019"] = true;
	    }
	
	    var req2 = { values: { enterpriseId: tool.getCookie('enterpriseId') }, batch: false };
	    var path2 = sgiConfig.service_baseuam + "/role/list"; // 查询角色列表
	    commonClient.simplecall(path2, req2, function (res) {
	        if (res && res.head && res.head.code == "0000") {
	            tool.sgiLogger.info('查用户列表成功 res:', res);
	            var datas = res.body || [];
	            var scCode = "pmos_SC_comm.chng_00003019",
	                list = datas,
	                codeCode = "roleId",
	                textCode = "roleName",
	                noclearFlag = false;
	            tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
	        } else {
	            tool.sgiLogger.error("查用户列表失败 res:", res);
	        }
	    });
	}
	
	function ctTrStrByDatacustomMade(datas, id, pid, idName, scguid) {
	    //eoid, 
	    if (!datas) {
	        return [];
	    }
	    var tempNodes = datas.concat();
	
	    function createChild(node) {
	
	        //属性赋值给  标准代码
	        node.te = node[idName];
	        node.c = node[id];
	
	        var curid = node && node[id];
	        if (!curid) curid = "";
	        var childrenName = "cldSet";
	        if (!node[childrenName]) {
	            // 当前node下子节点为空
	            node[childrenName] = [];
	        }
	        for (var i = 0; i < tempNodes.length; i++) {
	            var record = tempNodes[i];
	            if (!record) continue;
	            var parentid = record[pid];
	            if (!parentid) {
	                parentid = "";
	            }
	            if (parentid == curid) {
	                // 是当前节点的子节点，添加到当前节点下。
	                node[childrenName].push(record);
	                tempNodes.splice(i, 1);
	                i--;
	            }
	        }
	        if (tempNodes.length > 0) {
	            var childnodes = node[childrenName];
	            if (childnodes) {
	                var len = childnodes.length;
	                for (var i = 0; i < len; i++) {
	                    // 对当前节点的子节点循环添加孙子节点。
	                    if (tempNodes.length <= 0) break;
	                    createChild(childnodes[i]);
	                }
	            }
	        }
	    }
	    var treeData = {};
	    createChild(treeData);
	    // treeData = treeData["cldSet"];
	
	
	    var scList = StandardCode.getSC(scguid);
	
	    // scList.splice(0, scList.length);
	
	    treeData["cldSet"].forEach(function (element) {
	        scList.push(element);
	    });
	
	    return treeData;
	}
	
	exports.bussLoading = bussLoading;
	exports.deleteLoadFlag = deleteLoadFlag;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			// Lookup tables
			var SBOX = [];
			var INV_SBOX = [];
			var SUB_MIX_0 = [];
			var SUB_MIX_1 = [];
			var SUB_MIX_2 = [];
			var SUB_MIX_3 = [];
			var INV_SUB_MIX_0 = [];
			var INV_SUB_MIX_1 = [];
			var INV_SUB_MIX_2 = [];
			var INV_SUB_MIX_3 = [];
	
			// Compute lookup tables
			(function () {
				// Compute double table
				var d = [];
				for (var i = 0; i < 256; i++) {
					if (i < 128) {
						d[i] = i << 1;
					} else {
						d[i] = i << 1 ^ 0x11b;
					}
				}
	
				// Walk GF(2^8)
				var x = 0;
				var xi = 0;
				for (var i = 0; i < 256; i++) {
					// Compute sbox
					var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
					sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
					SBOX[x] = sx;
					INV_SBOX[sx] = x;
	
					// Compute multiplication
					var x2 = d[x];
					var x4 = d[x2];
					var x8 = d[x4];
	
					// Compute sub bytes, mix columns tables
					var t = d[sx] * 0x101 ^ sx * 0x1010100;
					SUB_MIX_0[x] = t << 24 | t >>> 8;
					SUB_MIX_1[x] = t << 16 | t >>> 16;
					SUB_MIX_2[x] = t << 8 | t >>> 24;
					SUB_MIX_3[x] = t;
	
					// Compute inv sub bytes, inv mix columns tables
					var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
					INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
					INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
					INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
					INV_SUB_MIX_3[sx] = t;
	
					// Compute next counter
					if (!x) {
						x = xi = 1;
					} else {
						x = x2 ^ d[d[d[x8 ^ x2]]];
						xi ^= d[d[xi]];
					}
				}
			})();
	
			// Precomputed Rcon lookup
			var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
			/**
	   * AES block cipher algorithm.
	   */
			var AES = C_algo.AES = BlockCipher.extend({
				_doReset: function _doReset() {
					var t;
	
					// Skip reset of nRounds has been set before and key did not change
					if (this._nRounds && this._keyPriorReset === this._key) {
						return;
					}
	
					// Shortcuts
					var key = this._keyPriorReset = this._key;
					var keyWords = key.words;
					var keySize = key.sigBytes / 4;
	
					// Compute number of rounds
					var nRounds = this._nRounds = keySize + 6;
	
					// Compute number of key schedule rows
					var ksRows = (nRounds + 1) * 4;
	
					// Compute key schedule
					var keySchedule = this._keySchedule = [];
					for (var ksRow = 0; ksRow < ksRows; ksRow++) {
						if (ksRow < keySize) {
							keySchedule[ksRow] = keyWords[ksRow];
						} else {
							t = keySchedule[ksRow - 1];
	
							if (!(ksRow % keySize)) {
								// Rot word
								t = t << 8 | t >>> 24;
	
								// Sub word
								t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
	
								// Mix Rcon
								t ^= RCON[ksRow / keySize | 0] << 24;
							} else if (keySize > 6 && ksRow % keySize == 4) {
								// Sub word
								t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
							}
	
							keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
						}
					}
	
					// Compute inv key schedule
					var invKeySchedule = this._invKeySchedule = [];
					for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
						var ksRow = ksRows - invKsRow;
	
						if (invKsRow % 4) {
							var t = keySchedule[ksRow];
						} else {
							var t = keySchedule[ksRow - 4];
						}
	
						if (invKsRow < 4 || ksRow <= 4) {
							invKeySchedule[invKsRow] = t;
						} else {
							invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
						}
					}
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					// Swap 2nd and 4th rows
					var t = M[offset + 1];
					M[offset + 1] = M[offset + 3];
					M[offset + 3] = t;
	
					this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
					// Inv swap 2nd and 4th rows
					var t = M[offset + 1];
					M[offset + 1] = M[offset + 3];
					M[offset + 3] = t;
				},
	
				_doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
					// Shortcut
					var nRounds = this._nRounds;
	
					// Get input, add round key
					var s0 = M[offset] ^ keySchedule[0];
					var s1 = M[offset + 1] ^ keySchedule[1];
					var s2 = M[offset + 2] ^ keySchedule[2];
					var s3 = M[offset + 3] ^ keySchedule[3];
	
					// Key schedule row counter
					var ksRow = 4;
	
					// Rounds
					for (var round = 1; round < nRounds; round++) {
						// Shift rows, sub bytes, mix columns, add round key
						var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
						var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
						var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
						var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
						// Update state
						s0 = t0;
						s1 = t1;
						s2 = t2;
						s3 = t3;
					}
	
					// Shift rows, sub bytes, add round key
					var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
					var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
					var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
					var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
					// Set output
					M[offset] = t0;
					M[offset + 1] = t1;
					M[offset + 2] = t2;
					M[offset + 3] = t3;
				},
	
				keySize: 256 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	   */
			C.AES = BlockCipher._createHelper(AES);
		})();
	
		return CryptoJS.AES;
	});

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			var N = 16;
	
			//Origin pbox and sbox, derived from PI
			var ORIG_P = [0x243F6A88, 0x85A308D3, 0x13198A2E, 0x03707344, 0xA4093822, 0x299F31D0, 0x082EFA98, 0xEC4E6C89, 0x452821E6, 0x38D01377, 0xBE5466CF, 0x34E90C6C, 0xC0AC29B7, 0xC97C50DD, 0x3F84D5B5, 0xB5470917, 0x9216D5D9, 0x8979FB1B];
	
			var ORIG_S = [[0xD1310BA6, 0x98DFB5AC, 0x2FFD72DB, 0xD01ADFB7, 0xB8E1AFED, 0x6A267E96, 0xBA7C9045, 0xF12C7F99, 0x24A19947, 0xB3916CF7, 0x0801F2E2, 0x858EFC16, 0x636920D8, 0x71574E69, 0xA458FEA3, 0xF4933D7E, 0x0D95748F, 0x728EB658, 0x718BCD58, 0x82154AEE, 0x7B54A41D, 0xC25A59B5, 0x9C30D539, 0x2AF26013, 0xC5D1B023, 0x286085F0, 0xCA417918, 0xB8DB38EF, 0x8E79DCB0, 0x603A180E, 0x6C9E0E8B, 0xB01E8A3E, 0xD71577C1, 0xBD314B27, 0x78AF2FDA, 0x55605C60, 0xE65525F3, 0xAA55AB94, 0x57489862, 0x63E81440, 0x55CA396A, 0x2AAB10B6, 0xB4CC5C34, 0x1141E8CE, 0xA15486AF, 0x7C72E993, 0xB3EE1411, 0x636FBC2A, 0x2BA9C55D, 0x741831F6, 0xCE5C3E16, 0x9B87931E, 0xAFD6BA33, 0x6C24CF5C, 0x7A325381, 0x28958677, 0x3B8F4898, 0x6B4BB9AF, 0xC4BFE81B, 0x66282193, 0x61D809CC, 0xFB21A991, 0x487CAC60, 0x5DEC8032, 0xEF845D5D, 0xE98575B1, 0xDC262302, 0xEB651B88, 0x23893E81, 0xD396ACC5, 0x0F6D6FF3, 0x83F44239, 0x2E0B4482, 0xA4842004, 0x69C8F04A, 0x9E1F9B5E, 0x21C66842, 0xF6E96C9A, 0x670C9C61, 0xABD388F0, 0x6A51A0D2, 0xD8542F68, 0x960FA728, 0xAB5133A3, 0x6EEF0B6C, 0x137A3BE4, 0xBA3BF050, 0x7EFB2A98, 0xA1F1651D, 0x39AF0176, 0x66CA593E, 0x82430E88, 0x8CEE8619, 0x456F9FB4, 0x7D84A5C3, 0x3B8B5EBE, 0xE06F75D8, 0x85C12073, 0x401A449F, 0x56C16AA6, 0x4ED3AA62, 0x363F7706, 0x1BFEDF72, 0x429B023D, 0x37D0D724, 0xD00A1248, 0xDB0FEAD3, 0x49F1C09B, 0x075372C9, 0x80991B7B, 0x25D479D8, 0xF6E8DEF7, 0xE3FE501A, 0xB6794C3B, 0x976CE0BD, 0x04C006BA, 0xC1A94FB6, 0x409F60C4, 0x5E5C9EC2, 0x196A2463, 0x68FB6FAF, 0x3E6C53B5, 0x1339B2EB, 0x3B52EC6F, 0x6DFC511F, 0x9B30952C, 0xCC814544, 0xAF5EBD09, 0xBEE3D004, 0xDE334AFD, 0x660F2807, 0x192E4BB3, 0xC0CBA857, 0x45C8740F, 0xD20B5F39, 0xB9D3FBDB, 0x5579C0BD, 0x1A60320A, 0xD6A100C6, 0x402C7279, 0x679F25FE, 0xFB1FA3CC, 0x8EA5E9F8, 0xDB3222F8, 0x3C7516DF, 0xFD616B15, 0x2F501EC8, 0xAD0552AB, 0x323DB5FA, 0xFD238760, 0x53317B48, 0x3E00DF82, 0x9E5C57BB, 0xCA6F8CA0, 0x1A87562E, 0xDF1769DB, 0xD542A8F6, 0x287EFFC3, 0xAC6732C6, 0x8C4F5573, 0x695B27B0, 0xBBCA58C8, 0xE1FFA35D, 0xB8F011A0, 0x10FA3D98, 0xFD2183B8, 0x4AFCB56C, 0x2DD1D35B, 0x9A53E479, 0xB6F84565, 0xD28E49BC, 0x4BFB9790, 0xE1DDF2DA, 0xA4CB7E33, 0x62FB1341, 0xCEE4C6E8, 0xEF20CADA, 0x36774C01, 0xD07E9EFE, 0x2BF11FB4, 0x95DBDA4D, 0xAE909198, 0xEAAD8E71, 0x6B93D5A0, 0xD08ED1D0, 0xAFC725E0, 0x8E3C5B2F, 0x8E7594B7, 0x8FF6E2FB, 0xF2122B64, 0x8888B812, 0x900DF01C, 0x4FAD5EA0, 0x688FC31C, 0xD1CFF191, 0xB3A8C1AD, 0x2F2F2218, 0xBE0E1777, 0xEA752DFE, 0x8B021FA1, 0xE5A0CC0F, 0xB56F74E8, 0x18ACF3D6, 0xCE89E299, 0xB4A84FE0, 0xFD13E0B7, 0x7CC43B81, 0xD2ADA8D9, 0x165FA266, 0x80957705, 0x93CC7314, 0x211A1477, 0xE6AD2065, 0x77B5FA86, 0xC75442F5, 0xFB9D35CF, 0xEBCDAF0C, 0x7B3E89A0, 0xD6411BD3, 0xAE1E7E49, 0x00250E2D, 0x2071B35E, 0x226800BB, 0x57B8E0AF, 0x2464369B, 0xF009B91E, 0x5563911D, 0x59DFA6AA, 0x78C14389, 0xD95A537F, 0x207D5BA2, 0x02E5B9C5, 0x83260376, 0x6295CFA9, 0x11C81968, 0x4E734A41, 0xB3472DCA, 0x7B14A94A, 0x1B510052, 0x9A532915, 0xD60F573F, 0xBC9BC6E4, 0x2B60A476, 0x81E67400, 0x08BA6FB5, 0x571BE91F, 0xF296EC6B, 0x2A0DD915, 0xB6636521, 0xE7B9F9B6, 0xFF34052E, 0xC5855664, 0x53B02D5D, 0xA99F8FA1, 0x08BA4799, 0x6E85076A], [0x4B7A70E9, 0xB5B32944, 0xDB75092E, 0xC4192623, 0xAD6EA6B0, 0x49A7DF7D, 0x9CEE60B8, 0x8FEDB266, 0xECAA8C71, 0x699A17FF, 0x5664526C, 0xC2B19EE1, 0x193602A5, 0x75094C29, 0xA0591340, 0xE4183A3E, 0x3F54989A, 0x5B429D65, 0x6B8FE4D6, 0x99F73FD6, 0xA1D29C07, 0xEFE830F5, 0x4D2D38E6, 0xF0255DC1, 0x4CDD2086, 0x8470EB26, 0x6382E9C6, 0x021ECC5E, 0x09686B3F, 0x3EBAEFC9, 0x3C971814, 0x6B6A70A1, 0x687F3584, 0x52A0E286, 0xB79C5305, 0xAA500737, 0x3E07841C, 0x7FDEAE5C, 0x8E7D44EC, 0x5716F2B8, 0xB03ADA37, 0xF0500C0D, 0xF01C1F04, 0x0200B3FF, 0xAE0CF51A, 0x3CB574B2, 0x25837A58, 0xDC0921BD, 0xD19113F9, 0x7CA92FF6, 0x94324773, 0x22F54701, 0x3AE5E581, 0x37C2DADC, 0xC8B57634, 0x9AF3DDA7, 0xA9446146, 0x0FD0030E, 0xECC8C73E, 0xA4751E41, 0xE238CD99, 0x3BEA0E2F, 0x3280BBA1, 0x183EB331, 0x4E548B38, 0x4F6DB908, 0x6F420D03, 0xF60A04BF, 0x2CB81290, 0x24977C79, 0x5679B072, 0xBCAF89AF, 0xDE9A771F, 0xD9930810, 0xB38BAE12, 0xDCCF3F2E, 0x5512721F, 0x2E6B7124, 0x501ADDE6, 0x9F84CD87, 0x7A584718, 0x7408DA17, 0xBC9F9ABC, 0xE94B7D8C, 0xEC7AEC3A, 0xDB851DFA, 0x63094366, 0xC464C3D2, 0xEF1C1847, 0x3215D908, 0xDD433B37, 0x24C2BA16, 0x12A14D43, 0x2A65C451, 0x50940002, 0x133AE4DD, 0x71DFF89E, 0x10314E55, 0x81AC77D6, 0x5F11199B, 0x043556F1, 0xD7A3C76B, 0x3C11183B, 0x5924A509, 0xF28FE6ED, 0x97F1FBFA, 0x9EBABF2C, 0x1E153C6E, 0x86E34570, 0xEAE96FB1, 0x860E5E0A, 0x5A3E2AB3, 0x771FE71C, 0x4E3D06FA, 0x2965DCB9, 0x99E71D0F, 0x803E89D6, 0x5266C825, 0x2E4CC978, 0x9C10B36A, 0xC6150EBA, 0x94E2EA78, 0xA5FC3C53, 0x1E0A2DF4, 0xF2F74EA7, 0x361D2B3D, 0x1939260F, 0x19C27960, 0x5223A708, 0xF71312B6, 0xEBADFE6E, 0xEAC31F66, 0xE3BC4595, 0xA67BC883, 0xB17F37D1, 0x018CFF28, 0xC332DDEF, 0xBE6C5AA5, 0x65582185, 0x68AB9802, 0xEECEA50F, 0xDB2F953B, 0x2AEF7DAD, 0x5B6E2F84, 0x1521B628, 0x29076170, 0xECDD4775, 0x619F1510, 0x13CCA830, 0xEB61BD96, 0x0334FE1E, 0xAA0363CF, 0xB5735C90, 0x4C70A239, 0xD59E9E0B, 0xCBAADE14, 0xEECC86BC, 0x60622CA7, 0x9CAB5CAB, 0xB2F3846E, 0x648B1EAF, 0x19BDF0CA, 0xA02369B9, 0x655ABB50, 0x40685A32, 0x3C2AB4B3, 0x319EE9D5, 0xC021B8F7, 0x9B540B19, 0x875FA099, 0x95F7997E, 0x623D7DA8, 0xF837889A, 0x97E32D77, 0x11ED935F, 0x16681281, 0x0E358829, 0xC7E61FD6, 0x96DEDFA1, 0x7858BA99, 0x57F584A5, 0x1B227263, 0x9B83C3FF, 0x1AC24696, 0xCDB30AEB, 0x532E3054, 0x8FD948E4, 0x6DBC3128, 0x58EBF2EF, 0x34C6FFEA, 0xFE28ED61, 0xEE7C3C73, 0x5D4A14D9, 0xE864B7E3, 0x42105D14, 0x203E13E0, 0x45EEE2B6, 0xA3AAABEA, 0xDB6C4F15, 0xFACB4FD0, 0xC742F442, 0xEF6ABBB5, 0x654F3B1D, 0x41CD2105, 0xD81E799E, 0x86854DC7, 0xE44B476A, 0x3D816250, 0xCF62A1F2, 0x5B8D2646, 0xFC8883A0, 0xC1C7B6A3, 0x7F1524C3, 0x69CB7492, 0x47848A0B, 0x5692B285, 0x095BBF00, 0xAD19489D, 0x1462B174, 0x23820E00, 0x58428D2A, 0x0C55F5EA, 0x1DADF43E, 0x233F7061, 0x3372F092, 0x8D937E41, 0xD65FECF1, 0x6C223BDB, 0x7CDE3759, 0xCBEE7460, 0x4085F2A7, 0xCE77326E, 0xA6078084, 0x19F8509E, 0xE8EFD855, 0x61D99735, 0xA969A7AA, 0xC50C06C2, 0x5A04ABFC, 0x800BCADC, 0x9E447A2E, 0xC3453484, 0xFDD56705, 0x0E1E9EC9, 0xDB73DBD3, 0x105588CD, 0x675FDA79, 0xE3674340, 0xC5C43465, 0x713E38D8, 0x3D28F89E, 0xF16DFF20, 0x153E21E7, 0x8FB03D4A, 0xE6E39F2B, 0xDB83ADF7], [0xE93D5A68, 0x948140F7, 0xF64C261C, 0x94692934, 0x411520F7, 0x7602D4F7, 0xBCF46B2E, 0xD4A20068, 0xD4082471, 0x3320F46A, 0x43B7D4B7, 0x500061AF, 0x1E39F62E, 0x97244546, 0x14214F74, 0xBF8B8840, 0x4D95FC1D, 0x96B591AF, 0x70F4DDD3, 0x66A02F45, 0xBFBC09EC, 0x03BD9785, 0x7FAC6DD0, 0x31CB8504, 0x96EB27B3, 0x55FD3941, 0xDA2547E6, 0xABCA0A9A, 0x28507825, 0x530429F4, 0x0A2C86DA, 0xE9B66DFB, 0x68DC1462, 0xD7486900, 0x680EC0A4, 0x27A18DEE, 0x4F3FFEA2, 0xE887AD8C, 0xB58CE006, 0x7AF4D6B6, 0xAACE1E7C, 0xD3375FEC, 0xCE78A399, 0x406B2A42, 0x20FE9E35, 0xD9F385B9, 0xEE39D7AB, 0x3B124E8B, 0x1DC9FAF7, 0x4B6D1856, 0x26A36631, 0xEAE397B2, 0x3A6EFA74, 0xDD5B4332, 0x6841E7F7, 0xCA7820FB, 0xFB0AF54E, 0xD8FEB397, 0x454056AC, 0xBA489527, 0x55533A3A, 0x20838D87, 0xFE6BA9B7, 0xD096954B, 0x55A867BC, 0xA1159A58, 0xCCA92963, 0x99E1DB33, 0xA62A4A56, 0x3F3125F9, 0x5EF47E1C, 0x9029317C, 0xFDF8E802, 0x04272F70, 0x80BB155C, 0x05282CE3, 0x95C11548, 0xE4C66D22, 0x48C1133F, 0xC70F86DC, 0x07F9C9EE, 0x41041F0F, 0x404779A4, 0x5D886E17, 0x325F51EB, 0xD59BC0D1, 0xF2BCC18F, 0x41113564, 0x257B7834, 0x602A9C60, 0xDFF8E8A3, 0x1F636C1B, 0x0E12B4C2, 0x02E1329E, 0xAF664FD1, 0xCAD18115, 0x6B2395E0, 0x333E92E1, 0x3B240B62, 0xEEBEB922, 0x85B2A20E, 0xE6BA0D99, 0xDE720C8C, 0x2DA2F728, 0xD0127845, 0x95B794FD, 0x647D0862, 0xE7CCF5F0, 0x5449A36F, 0x877D48FA, 0xC39DFD27, 0xF33E8D1E, 0x0A476341, 0x992EFF74, 0x3A6F6EAB, 0xF4F8FD37, 0xA812DC60, 0xA1EBDDF8, 0x991BE14C, 0xDB6E6B0D, 0xC67B5510, 0x6D672C37, 0x2765D43B, 0xDCD0E804, 0xF1290DC7, 0xCC00FFA3, 0xB5390F92, 0x690FED0B, 0x667B9FFB, 0xCEDB7D9C, 0xA091CF0B, 0xD9155EA3, 0xBB132F88, 0x515BAD24, 0x7B9479BF, 0x763BD6EB, 0x37392EB3, 0xCC115979, 0x8026E297, 0xF42E312D, 0x6842ADA7, 0xC66A2B3B, 0x12754CCC, 0x782EF11C, 0x6A124237, 0xB79251E7, 0x06A1BBE6, 0x4BFB6350, 0x1A6B1018, 0x11CAEDFA, 0x3D25BDD8, 0xE2E1C3C9, 0x44421659, 0x0A121386, 0xD90CEC6E, 0xD5ABEA2A, 0x64AF674E, 0xDA86A85F, 0xBEBFE988, 0x64E4C3FE, 0x9DBC8057, 0xF0F7C086, 0x60787BF8, 0x6003604D, 0xD1FD8346, 0xF6381FB0, 0x7745AE04, 0xD736FCCC, 0x83426B33, 0xF01EAB71, 0xB0804187, 0x3C005E5F, 0x77A057BE, 0xBDE8AE24, 0x55464299, 0xBF582E61, 0x4E58F48F, 0xF2DDFDA2, 0xF474EF38, 0x8789BDC2, 0x5366F9C3, 0xC8B38E74, 0xB475F255, 0x46FCD9B9, 0x7AEB2661, 0x8B1DDF84, 0x846A0E79, 0x915F95E2, 0x466E598E, 0x20B45770, 0x8CD55591, 0xC902DE4C, 0xB90BACE1, 0xBB8205D0, 0x11A86248, 0x7574A99E, 0xB77F19B6, 0xE0A9DC09, 0x662D09A1, 0xC4324633, 0xE85A1F02, 0x09F0BE8C, 0x4A99A025, 0x1D6EFE10, 0x1AB93D1D, 0x0BA5A4DF, 0xA186F20F, 0x2868F169, 0xDCB7DA83, 0x573906FE, 0xA1E2CE9B, 0x4FCD7F52, 0x50115E01, 0xA70683FA, 0xA002B5C4, 0x0DE6D027, 0x9AF88C27, 0x773F8641, 0xC3604C06, 0x61A806B5, 0xF0177A28, 0xC0F586E0, 0x006058AA, 0x30DC7D62, 0x11E69ED7, 0x2338EA63, 0x53C2DD94, 0xC2C21634, 0xBBCBEE56, 0x90BCB6DE, 0xEBFC7DA1, 0xCE591D76, 0x6F05E409, 0x4B7C0188, 0x39720A3D, 0x7C927C24, 0x86E3725F, 0x724D9DB9, 0x1AC15BB4, 0xD39EB8FC, 0xED545578, 0x08FCA5B5, 0xD83D7CD3, 0x4DAD0FC4, 0x1E50EF5E, 0xB161E6F8, 0xA28514D9, 0x6C51133C, 0x6FD5C7E7, 0x56E14EC4, 0x362ABFCE, 0xDDC6C837, 0xD79A3234, 0x92638212, 0x670EFA8E, 0x406000E0], [0x3A39CE37, 0xD3FAF5CF, 0xABC27737, 0x5AC52D1B, 0x5CB0679E, 0x4FA33742, 0xD3822740, 0x99BC9BBE, 0xD5118E9D, 0xBF0F7315, 0xD62D1C7E, 0xC700C47B, 0xB78C1B6B, 0x21A19045, 0xB26EB1BE, 0x6A366EB4, 0x5748AB2F, 0xBC946E79, 0xC6A376D2, 0x6549C2C8, 0x530FF8EE, 0x468DDE7D, 0xD5730A1D, 0x4CD04DC6, 0x2939BBDB, 0xA9BA4650, 0xAC9526E8, 0xBE5EE304, 0xA1FAD5F0, 0x6A2D519A, 0x63EF8CE2, 0x9A86EE22, 0xC089C2B8, 0x43242EF6, 0xA51E03AA, 0x9CF2D0A4, 0x83C061BA, 0x9BE96A4D, 0x8FE51550, 0xBA645BD6, 0x2826A2F9, 0xA73A3AE1, 0x4BA99586, 0xEF5562E9, 0xC72FEFD3, 0xF752F7DA, 0x3F046F69, 0x77FA0A59, 0x80E4A915, 0x87B08601, 0x9B09E6AD, 0x3B3EE593, 0xE990FD5A, 0x9E34D797, 0x2CF0B7D9, 0x022B8B51, 0x96D5AC3A, 0x017DA67D, 0xD1CF3ED6, 0x7C7D2D28, 0x1F9F25CF, 0xADF2B89B, 0x5AD6B472, 0x5A88F54C, 0xE029AC71, 0xE019A5E6, 0x47B0ACFD, 0xED93FA9B, 0xE8D3C48D, 0x283B57CC, 0xF8D56629, 0x79132E28, 0x785F0191, 0xED756055, 0xF7960E44, 0xE3D35E8C, 0x15056DD4, 0x88F46DBA, 0x03A16125, 0x0564F0BD, 0xC3EB9E15, 0x3C9057A2, 0x97271AEC, 0xA93A072A, 0x1B3F6D9B, 0x1E6321F5, 0xF59C66FB, 0x26DCF319, 0x7533D928, 0xB155FDF5, 0x03563482, 0x8ABA3CBB, 0x28517711, 0xC20AD9F8, 0xABCC5167, 0xCCAD925F, 0x4DE81751, 0x3830DC8E, 0x379D5862, 0x9320F991, 0xEA7A90C2, 0xFB3E7BCE, 0x5121CE64, 0x774FBE32, 0xA8B6E37E, 0xC3293D46, 0x48DE5369, 0x6413E680, 0xA2AE0810, 0xDD6DB224, 0x69852DFD, 0x09072166, 0xB39A460A, 0x6445C0DD, 0x586CDECF, 0x1C20C8AE, 0x5BBEF7DD, 0x1B588D40, 0xCCD2017F, 0x6BB4E3BB, 0xDDA26A7E, 0x3A59FF45, 0x3E350A44, 0xBCB4CDD5, 0x72EACEA8, 0xFA6484BB, 0x8D6612AE, 0xBF3C6F47, 0xD29BE463, 0x542F5D9E, 0xAEC2771B, 0xF64E6370, 0x740E0D8D, 0xE75B1357, 0xF8721671, 0xAF537D5D, 0x4040CB08, 0x4EB4E2CC, 0x34D2466A, 0x0115AF84, 0xE1B00428, 0x95983A1D, 0x06B89FB4, 0xCE6EA048, 0x6F3F3B82, 0x3520AB82, 0x011A1D4B, 0x277227F8, 0x611560B1, 0xE7933FDC, 0xBB3A792B, 0x344525BD, 0xA08839E1, 0x51CE794B, 0x2F32C9B7, 0xA01FBAC9, 0xE01CC87E, 0xBCC7D1F6, 0xCF0111C3, 0xA1E8AAC7, 0x1A908749, 0xD44FBD9A, 0xD0DADECB, 0xD50ADA38, 0x0339C32A, 0xC6913667, 0x8DF9317C, 0xE0B12B4F, 0xF79E59B7, 0x43F5BB3A, 0xF2D519FF, 0x27D9459C, 0xBF97222C, 0x15E6FC2A, 0x0F91FC71, 0x9B941525, 0xFAE59361, 0xCEB69CEB, 0xC2A86459, 0x12BAA8D1, 0xB6C1075E, 0xE3056A0C, 0x10D25065, 0xCB03A442, 0xE0EC6E0E, 0x1698DB3B, 0x4C98A0BE, 0x3278E964, 0x9F1F9532, 0xE0D392DF, 0xD3A0342B, 0x8971F21E, 0x1B0A7441, 0x4BA3348C, 0xC5BE7120, 0xC37632D8, 0xDF359F8D, 0x9B992F2E, 0xE60B6F47, 0x0FE3F11D, 0xE54CDA54, 0x1EDAD891, 0xCE6279CF, 0xCD3E7E6F, 0x1618B166, 0xFD2C1D05, 0x848FD2C5, 0xF6FB2299, 0xF523F357, 0xA6327623, 0x93A83531, 0x56CCCD02, 0xACF08162, 0x5A75EBB5, 0x6E163697, 0x88D273CC, 0xDE966292, 0x81B949D0, 0x4C50901B, 0x71C65614, 0xE6C6C7BD, 0x327A140A, 0x45E1D006, 0xC3F27B9A, 0xC9AA53FD, 0x62A80F00, 0xBB25BFE2, 0x35BDD2F6, 0x71126905, 0xB2040222, 0xB6CBCF7C, 0xCD769C2B, 0x53113EC0, 0x1640E3D3, 0x38ABBD60, 0x2547ADF0, 0xBA38209C, 0xF746CE76, 0x77AFA1C5, 0x20756060, 0x85CBFE4E, 0x8AE88DD8, 0x7AAAF9B0, 0x4CF9AA7E, 0x1948C25C, 0x02FB8A8C, 0x01C36AE4, 0xD6EBE1F9, 0x90D4F869, 0xA65CDEA0, 0x3F09252D, 0xC208E69F, 0xB74E6132, 0xCE77E25B, 0x578FDFE3, 0x3AC372E6]];
	
			var BLOWFISH_CTX = {
				pbox: [],
				sbox: []
			};
	
			function F(ctx, x) {
				var a = x >> 24 & 0xFF;
				var b = x >> 16 & 0xFF;
				var c = x >> 8 & 0xFF;
				var d = x & 0xFF;
	
				var y = ctx.sbox[0][a] + ctx.sbox[1][b];
				y = y ^ ctx.sbox[2][c];
				y = y + ctx.sbox[3][d];
	
				return y;
			}
	
			function BlowFish_Encrypt(ctx, left, right) {
				var Xl = left;
				var Xr = right;
				var temp = void 0;
	
				for (var i = 0; i < N; ++i) {
					Xl = Xl ^ ctx.pbox[i];
					Xr = F(ctx, Xl) ^ Xr;
	
					temp = Xl;
					Xl = Xr;
					Xr = temp;
				}
	
				temp = Xl;
				Xl = Xr;
				Xr = temp;
	
				Xr = Xr ^ ctx.pbox[N];
				Xl = Xl ^ ctx.pbox[N + 1];
	
				return { left: Xl, right: Xr };
			}
	
			function BlowFish_Decrypt(ctx, left, right) {
				var Xl = left;
				var Xr = right;
				var temp = void 0;
	
				for (var i = N + 1; i > 1; --i) {
					Xl = Xl ^ ctx.pbox[i];
					Xr = F(ctx, Xl) ^ Xr;
	
					temp = Xl;
					Xl = Xr;
					Xr = temp;
				}
	
				temp = Xl;
				Xl = Xr;
				Xr = temp;
	
				Xr = Xr ^ ctx.pbox[1];
				Xl = Xl ^ ctx.pbox[0];
	
				return { left: Xl, right: Xr };
			}
	
			/**
	   * Initialization ctx's pbox and sbox.
	   *
	   * @param {Object} ctx The object has pbox and sbox.
	   * @param {Array} key An array of 32-bit words.
	   * @param {int} keysize The length of the key.
	   *
	   * @example
	   *
	   *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	   */
			function BlowFishInit(ctx, key, keysize) {
				for (var Row = 0; Row < 4; Row++) {
					ctx.sbox[Row] = [];
					for (var Col = 0; Col < 256; Col++) {
						ctx.sbox[Row][Col] = ORIG_S[Row][Col];
					}
				}
	
				var keyIndex = 0;
				for (var index = 0; index < N + 2; index++) {
					ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
					keyIndex++;
					if (keyIndex >= keysize) {
						keyIndex = 0;
					}
				}
	
				var Data1 = 0;
				var Data2 = 0;
				var res = 0;
				for (var i = 0; i < N + 2; i += 2) {
					res = BlowFish_Encrypt(ctx, Data1, Data2);
					Data1 = res.left;
					Data2 = res.right;
					ctx.pbox[i] = Data1;
					ctx.pbox[i + 1] = Data2;
				}
	
				for (var _i = 0; _i < 4; _i++) {
					for (var j = 0; j < 256; j += 2) {
						res = BlowFish_Encrypt(ctx, Data1, Data2);
						Data1 = res.left;
						Data2 = res.right;
						ctx.sbox[_i][j] = Data1;
						ctx.sbox[_i][j + 1] = Data2;
					}
				}
	
				return true;
			}
	
			/**
	   * Blowfish block cipher algorithm.
	   */
			var Blowfish = C_algo.Blowfish = BlockCipher.extend({
				_doReset: function _doReset() {
					// Skip reset of nRounds has been set before and key did not change
					if (this._keyPriorReset === this._key) {
						return;
					}
	
					// Shortcuts
					var key = this._keyPriorReset = this._key;
					var keyWords = key.words;
					var keySize = key.sigBytes / 4;
	
					//Initialization pbox and sbox
					BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
					M[offset] = res.left;
					M[offset + 1] = res.right;
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
					M[offset] = res.left;
					M[offset + 1] = res.right;
				},
	
				blockSize: 64 / 32,
	
				keySize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	   */
			C.Blowfish = BlockCipher._createHelper(Blowfish);
		})();
	
		return CryptoJS.Blowfish;
	});

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * Base64url encoding strategy.
	   */
			var Base64url = C_enc.Base64url = {
				/**
	    * Converts a word array to a Base64url string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @param {boolean} urlSafe Whether to use url safe
	    *
	    * @return {string} The Base64url string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	    */
				stringify: function stringify(wordArray, urlSafe) {
					if (urlSafe === undefined) {
						urlSafe = true;
					}
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
					var map = urlSafe ? this._safe_map : this._map;
	
					// Clamp excess bits
					wordArray.clamp();
	
					// Convert
					var base64Chars = [];
					for (var i = 0; i < sigBytes; i += 3) {
						var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
						var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
	
						var triplet = byte1 << 16 | byte2 << 8 | byte3;
	
						for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
							base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
						}
					}
	
					// Add padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						while (base64Chars.length % 4) {
							base64Chars.push(paddingChar);
						}
					}
	
					return base64Chars.join('');
				},
	
				/**
	    * Converts a Base64url string to a word array.
	    *
	    * @param {string} base64Str The Base64url string.
	    *
	    * @param {boolean} urlSafe Whether to use url safe
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	    */
				parse: function parse(base64Str, urlSafe) {
					if (urlSafe === undefined) {
						urlSafe = true;
					}
	
					// Shortcuts
					var base64StrLength = base64Str.length;
					var map = urlSafe ? this._safe_map : this._map;
					var reverseMap = this._reverseMap;
	
					if (!reverseMap) {
						reverseMap = this._reverseMap = [];
						for (var j = 0; j < map.length; j++) {
							reverseMap[map.charCodeAt(j)] = j;
						}
					}
	
					// Ignore padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						var paddingIndex = base64Str.indexOf(paddingChar);
						if (paddingIndex !== -1) {
							base64StrLength = paddingIndex;
						}
					}
	
					// Convert
					return parseLoop(base64Str, base64StrLength, reverseMap);
				},
	
				_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
				_safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
			};
	
			function parseLoop(base64Str, base64StrLength, reverseMap) {
				var words = [];
				var nBytes = 0;
				for (var i = 0; i < base64StrLength; i++) {
					if (i % 4) {
						var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
						var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
						var bitsCombined = bits1 | bits2;
						words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
						nBytes++;
					}
				}
				return WordArray.create(words, nBytes);
			}
		})();
	
		return CryptoJS.enc.Base64url;
	});

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * UTF-16 BE encoding strategy.
	   */
			var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
				/**
	    * Converts a word array to a UTF-16 BE string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-16 BE string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var utf16Chars = [];
					for (var i = 0; i < sigBytes; i += 2) {
						var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
						utf16Chars.push(String.fromCharCode(codePoint));
					}
	
					return utf16Chars.join('');
				},
	
				/**
	    * Converts a UTF-16 BE string to a word array.
	    *
	    * @param {string} utf16Str The UTF-16 BE string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	    */
				parse: function parse(utf16Str) {
					// Shortcut
					var utf16StrLength = utf16Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < utf16StrLength; i++) {
						words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
					}
	
					return WordArray.create(words, utf16StrLength * 2);
				}
			};
	
			/**
	   * UTF-16 LE encoding strategy.
	   */
			C_enc.Utf16LE = {
				/**
	    * Converts a word array to a UTF-16 LE string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-16 LE string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var utf16Chars = [];
					for (var i = 0; i < sigBytes; i += 2) {
						var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
						utf16Chars.push(String.fromCharCode(codePoint));
					}
	
					return utf16Chars.join('');
				},
	
				/**
	    * Converts a UTF-16 LE string to a word array.
	    *
	    * @param {string} utf16Str The UTF-16 LE string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	    */
				parse: function parse(utf16Str) {
					// Shortcut
					var utf16StrLength = utf16Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < utf16StrLength; i++) {
						words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
					}
	
					return WordArray.create(words, utf16StrLength * 2);
				}
			};
	
			function swapEndian(word) {
				return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
			}
		})();
	
		return CryptoJS.enc.Utf16;
	});

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var CipherParams = C_lib.CipherParams;
			var C_enc = C.enc;
			var Hex = C_enc.Hex;
			var C_format = C.format;
	
			var HexFormatter = C_format.Hex = {
				/**
	    * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	    *
	    * @param {CipherParams} cipherParams The cipher params object.
	    *
	    * @return {string} The hexadecimally encoded string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	    */
				stringify: function stringify(cipherParams) {
					return cipherParams.ciphertext.toString(Hex);
				},
	
				/**
	    * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	    *
	    * @param {string} input The hexadecimally encoded string.
	    *
	    * @return {CipherParams} The cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	    */
				parse: function parse(input) {
					var ciphertext = Hex.parse(input);
					return CipherParams.create({ ciphertext: ciphertext });
				}
			};
		})();
	
		return CryptoJS.format.Hex;
	});

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Check if typed arrays are supported
			if (typeof ArrayBuffer != 'function') {
				return;
			}
	
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
	
			// Reference original init
			var superInit = WordArray.init;
	
			// Augment WordArray.init to handle typed arrays
			var subInit = WordArray.init = function (typedArray) {
				// Convert buffers to uint8
				if (typedArray instanceof ArrayBuffer) {
					typedArray = new Uint8Array(typedArray);
				}
	
				// Convert other array views to uint8
				if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
					typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
				}
	
				// Handle Uint8Array
				if (typedArray instanceof Uint8Array) {
					// Shortcut
					var typedArrayByteLength = typedArray.byteLength;
	
					// Extract bytes
					var words = [];
					for (var i = 0; i < typedArrayByteLength; i++) {
						words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
					}
	
					// Initialize this word array
					superInit.call(this, words, typedArrayByteLength);
				} else {
					// Else call normal init
					superInit.apply(this, arguments);
				}
			};
	
			subInit.prototype = WordArray;
		})();
	
		return CryptoJS.lib.WordArray;
	});

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Cipher Feedback block mode.
	  */
		CryptoJS.mode.CFB = function () {
			var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
			CFB.Encryptor = CFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
	
					generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
					// Remember this block to use with next block
					this._prevBlock = words.slice(offset, offset + blockSize);
				}
			});
	
			CFB.Decryptor = CFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
	
					// Remember this block to use with next block
					var thisBlock = words.slice(offset, offset + blockSize);
	
					generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
					// This block becomes the previous block
					this._prevBlock = thisBlock;
				}
			});
	
			function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
				var keystream;
	
				// Shortcut
				var iv = this._iv;
	
				// Generate keystream
				if (iv) {
					keystream = iv.slice(0);
	
					// Remove IV for subsequent blocks
					this._iv = undefined;
				} else {
					keystream = this._prevBlock;
				}
				cipher.encryptBlock(keystream, 0);
	
				// Encrypt
				for (var i = 0; i < blockSize; i++) {
					words[offset + i] ^= keystream[i];
				}
			}
	
			return CFB;
		}();
	
		return CryptoJS.mode.CFB;
	});

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/** @preserve
	  * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	  * derived from CryptoJS.mode.CTR
	  * Jan Hruby jhruby.web@gmail.com
	  */
		CryptoJS.mode.CTRGladman = function () {
			var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word) {
				if ((word >> 24 & 0xff) === 0xff) {
					//overflow
					var b1 = word >> 16 & 0xff;
					var b2 = word >> 8 & 0xff;
					var b3 = word & 0xff;
	
					if (b1 === 0xff) // overflow b1
						{
							b1 = 0;
							if (b2 === 0xff) {
								b2 = 0;
								if (b3 === 0xff) {
									b3 = 0;
								} else {
									++b3;
								}
							} else {
								++b2;
							}
						} else {
						++b1;
					}
	
					word = 0;
					word += b1 << 16;
					word += b2 << 8;
					word += b3;
				} else {
					word += 0x01 << 24;
				}
				return word;
			}
	
			function incCounter(counter) {
				if ((counter[0] = incWord(counter[0])) === 0) {
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
			var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var counter = this._counter;
	
					// Generate keystream
					if (iv) {
						counter = this._counter = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
					cipher.encryptBlock(keystream, 0);
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			CTRGladman.Decryptor = Encryptor;
	
			return CTRGladman;
		}();
	
		return CryptoJS.mode.CTRGladman;
	});

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Counter block mode.
	  */
		CryptoJS.mode.CTR = function () {
			var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
			var Encryptor = CTR.Encryptor = CTR.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var counter = this._counter;
	
					// Generate keystream
					if (iv) {
						counter = this._counter = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
					var keystream = counter.slice(0);
					cipher.encryptBlock(keystream, 0);
	
					// Increment counter
					counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			CTR.Decryptor = Encryptor;
	
			return CTR;
		}();
	
		return CryptoJS.mode.CTR;
	});

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Electronic Codebook block mode.
	  */
		CryptoJS.mode.ECB = function () {
			var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
			ECB.Encryptor = ECB.extend({
				processBlock: function processBlock(words, offset) {
					this._cipher.encryptBlock(words, offset);
				}
			});
	
			ECB.Decryptor = ECB.extend({
				processBlock: function processBlock(words, offset) {
					this._cipher.decryptBlock(words, offset);
				}
			});
	
			return ECB;
		}();
	
		return CryptoJS.mode.ECB;
	});

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Output Feedback block mode.
	  */
		CryptoJS.mode.OFB = function () {
			var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
			var Encryptor = OFB.Encryptor = OFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var keystream = this._keystream;
	
					// Generate keystream
					if (iv) {
						keystream = this._keystream = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
					cipher.encryptBlock(keystream, 0);
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			OFB.Decryptor = Encryptor;
	
			return OFB;
		}();
	
		return CryptoJS.mode.OFB;
	});

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ANSI X.923 padding strategy.
	  */
		CryptoJS.pad.AnsiX923 = {
			pad: function pad(data, blockSize) {
				// Shortcuts
				var dataSigBytes = data.sigBytes;
				var blockSizeBytes = blockSize * 4;
	
				// Count padding bytes
				var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
				// Compute last byte position
				var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
				// Pad
				data.clamp();
				data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
				data.sigBytes += nPaddingBytes;
			},
	
			unpad: function unpad(data) {
				// Get number of padding bytes from last byte
				var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
				// Remove padding
				data.sigBytes -= nPaddingBytes;
			}
		};
	
		return CryptoJS.pad.Ansix923;
	});

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ISO 10126 padding strategy.
	  */
		CryptoJS.pad.Iso10126 = {
			pad: function pad(data, blockSize) {
				// Shortcut
				var blockSizeBytes = blockSize * 4;
	
				// Count padding bytes
				var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
				// Pad
				data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
			},
	
			unpad: function unpad(data) {
				// Get number of padding bytes from last byte
				var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
				// Remove padding
				data.sigBytes -= nPaddingBytes;
			}
		};
	
		return CryptoJS.pad.Iso10126;
	});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ISO/IEC 9797-1 Padding Method 2.
	  */
		CryptoJS.pad.Iso97971 = {
			pad: function pad(data, blockSize) {
				// Add 0x80 byte
				data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
				// Zero pad the rest
				CryptoJS.pad.ZeroPadding.pad(data, blockSize);
			},
	
			unpad: function unpad(data) {
				// Remove zero padding
				CryptoJS.pad.ZeroPadding.unpad(data);
	
				// Remove one more byte -- the 0x80 byte
				data.sigBytes--;
			}
		};
	
		return CryptoJS.pad.Iso97971;
	});

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * A noop padding strategy.
	  */
		CryptoJS.pad.NoPadding = {
			pad: function pad() {},
	
			unpad: function unpad() {}
		};
	
		return CryptoJS.pad.NoPadding;
	});

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Zero padding strategy.
	  */
		CryptoJS.pad.ZeroPadding = {
			pad: function pad(data, blockSize) {
				// Shortcut
				var blockSizeBytes = blockSize * 4;
	
				// Pad
				data.clamp();
				data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
			},
	
			unpad: function unpad(data) {
				// Shortcut
				var dataWords = data.words;
	
				// Unpad
				var i = data.sigBytes - 1;
				for (var i = data.sigBytes - 1; i >= 0; i--) {
					if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
						data.sigBytes = i + 1;
						break;
					}
				}
			}
		};
	
		return CryptoJS.pad.ZeroPadding;
	});

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(150), __webpack_require__(149));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(150), __webpack_require__(149)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var SHA256 = C_algo.SHA256;
			var HMAC = C_algo.HMAC;
	
			/**
	   * Password-Based Key Derivation Function 2 algorithm.
	   */
			var PBKDF2 = C_algo.PBKDF2 = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	    * @property {Hasher} hasher The hasher to use. Default: SHA256
	    * @property {number} iterations The number of iterations to perform. Default: 250000
	    */
				cfg: Base.extend({
					keySize: 128 / 32,
					hasher: SHA256,
					iterations: 250000
				}),
	
				/**
	    * Initializes a newly created key derivation function.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	    *
	    * @example
	    *
	    *     var kdf = CryptoJS.algo.PBKDF2.create();
	    *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	    *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	    */
				init: function init(cfg) {
					this.cfg = this.cfg.extend(cfg);
				},
	
				/**
	    * Computes the Password-Based Key Derivation Function 2.
	    *
	    * @param {WordArray|string} password The password.
	    * @param {WordArray|string} salt A salt.
	    *
	    * @return {WordArray} The derived key.
	    *
	    * @example
	    *
	    *     var key = kdf.compute(password, salt);
	    */
				compute: function compute(password, salt) {
					// Shortcut
					var cfg = this.cfg;
	
					// Init HMAC
					var hmac = HMAC.create(cfg.hasher, password);
	
					// Initial values
					var derivedKey = WordArray.create();
					var blockIndex = WordArray.create([0x00000001]);
	
					// Shortcuts
					var derivedKeyWords = derivedKey.words;
					var blockIndexWords = blockIndex.words;
					var keySize = cfg.keySize;
					var iterations = cfg.iterations;
	
					// Generate key
					while (derivedKeyWords.length < keySize) {
						var block = hmac.update(salt).finalize(blockIndex);
						hmac.reset();
	
						// Shortcuts
						var blockWords = block.words;
						var blockWordsLength = blockWords.length;
	
						// Iterations
						var intermediate = block;
						for (var i = 1; i < iterations; i++) {
							intermediate = hmac.finalize(intermediate);
							hmac.reset();
	
							// Shortcut
							var intermediateWords = intermediate.words;
	
							// XOR intermediate with block
							for (var j = 0; j < blockWordsLength; j++) {
								blockWords[j] ^= intermediateWords[j];
							}
						}
	
						derivedKey.concat(block);
						blockIndexWords[0]++;
					}
					derivedKey.sigBytes = keySize * 4;
	
					return derivedKey;
				}
			});
	
			/**
	   * Computes the Password-Based Key Derivation Function 2.
	   *
	   * @param {WordArray|string} password The password.
	   * @param {WordArray|string} salt A salt.
	   * @param {Object} cfg (Optional) The configuration options to use for this computation.
	   *
	   * @return {WordArray} The derived key.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var key = CryptoJS.PBKDF2(password, salt);
	   *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	   *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	   */
			C.PBKDF2 = function (password, salt, cfg) {
				return PBKDF2.create(cfg).compute(password, salt);
			};
		})();
	
		return CryptoJS.PBKDF2;
	});

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			// Reusable objects
			var S = [];
			var C_ = [];
			var G = [];
	
			/**
	   * Rabbit stream cipher algorithm.
	   *
	   * This is a legacy version that neglected to convert the key to little-endian.
	   * This error doesn't affect the cipher's security,
	   * but it does affect its compatibility with other implementations.
	   */
			var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var K = this._key.words;
					var iv = this.cfg.iv;
	
					// Generate initial state values
					var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16];
	
					// Generate initial counter values
					var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff];
	
					// Carry bit
					this._b = 0;
	
					// Iterate the system four times
					for (var i = 0; i < 4; i++) {
						nextState.call(this);
					}
	
					// Modify the counters
					for (var i = 0; i < 8; i++) {
						C[i] ^= X[i + 4 & 7];
					}
	
					// IV setup
					if (iv) {
						// Shortcuts
						var IV = iv.words;
						var IV_0 = IV[0];
						var IV_1 = IV[1];
	
						// Generate four subvectors
						var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
						var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
						var i1 = i0 >>> 16 | i2 & 0xffff0000;
						var i3 = i2 << 16 | i0 & 0x0000ffff;
	
						// Modify counter values
						C[0] ^= i0;
						C[1] ^= i1;
						C[2] ^= i2;
						C[3] ^= i3;
						C[4] ^= i0;
						C[5] ^= i1;
						C[6] ^= i2;
						C[7] ^= i3;
	
						// Iterate the system four times
						for (var i = 0; i < 4; i++) {
							nextState.call(this);
						}
					}
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var X = this._X;
	
					// Iterate the system
					nextState.call(this);
	
					// Generate four keystream words
					S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
					S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
					S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
					S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
	
					for (var i = 0; i < 4; i++) {
						// Swap endian
						S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
	
						// Encrypt
						M[offset + i] ^= S[i];
					}
				},
	
				blockSize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			function nextState() {
				// Shortcuts
				var X = this._X;
				var C = this._C;
	
				// Save old counter values
				for (var i = 0; i < 8; i++) {
					C_[i] = C[i];
				}
	
				// Calculate new counter values
				C[0] = C[0] + 0x4d34d34d + this._b | 0;
				C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
				C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
				C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
				C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
				C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
				C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
				C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
				this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
	
				// Calculate the g-values
				for (var i = 0; i < 8; i++) {
					var gx = X[i] + C[i];
	
					// Construct high and low argument for squaring
					var ga = gx & 0xffff;
					var gb = gx >>> 16;
	
					// Calculate high and low result of squaring
					var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
					var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
	
					// High XOR low
					G[i] = gh ^ gl;
				}
	
				// Calculate new state values
				X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
				X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
				X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
				X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
				X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
				X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
				X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
				X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	   */
			C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		})();
	
		return CryptoJS.RabbitLegacy;
	});

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			// Reusable objects
			var S = [];
			var C_ = [];
			var G = [];
	
			/**
	   * Rabbit stream cipher algorithm
	   */
			var Rabbit = C_algo.Rabbit = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var K = this._key.words;
					var iv = this.cfg.iv;
	
					// Swap endian
					for (var i = 0; i < 4; i++) {
						K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
					}
	
					// Generate initial state values
					var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16];
	
					// Generate initial counter values
					var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff];
	
					// Carry bit
					this._b = 0;
	
					// Iterate the system four times
					for (var i = 0; i < 4; i++) {
						nextState.call(this);
					}
	
					// Modify the counters
					for (var i = 0; i < 8; i++) {
						C[i] ^= X[i + 4 & 7];
					}
	
					// IV setup
					if (iv) {
						// Shortcuts
						var IV = iv.words;
						var IV_0 = IV[0];
						var IV_1 = IV[1];
	
						// Generate four subvectors
						var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
						var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
						var i1 = i0 >>> 16 | i2 & 0xffff0000;
						var i3 = i2 << 16 | i0 & 0x0000ffff;
	
						// Modify counter values
						C[0] ^= i0;
						C[1] ^= i1;
						C[2] ^= i2;
						C[3] ^= i3;
						C[4] ^= i0;
						C[5] ^= i1;
						C[6] ^= i2;
						C[7] ^= i3;
	
						// Iterate the system four times
						for (var i = 0; i < 4; i++) {
							nextState.call(this);
						}
					}
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var X = this._X;
	
					// Iterate the system
					nextState.call(this);
	
					// Generate four keystream words
					S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
					S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
					S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
					S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
	
					for (var i = 0; i < 4; i++) {
						// Swap endian
						S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
	
						// Encrypt
						M[offset + i] ^= S[i];
					}
				},
	
				blockSize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			function nextState() {
				// Shortcuts
				var X = this._X;
				var C = this._C;
	
				// Save old counter values
				for (var i = 0; i < 8; i++) {
					C_[i] = C[i];
				}
	
				// Calculate new counter values
				C[0] = C[0] + 0x4d34d34d + this._b | 0;
				C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
				C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
				C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
				C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
				C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
				C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
				C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
				this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
	
				// Calculate the g-values
				for (var i = 0; i < 8; i++) {
					var gx = X[i] + C[i];
	
					// Construct high and low argument for squaring
					var ga = gx & 0xffff;
					var gb = gx >>> 16;
	
					// Calculate high and low result of squaring
					var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
					var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
	
					// High XOR low
					G[i] = gh ^ gl;
				}
	
				// Calculate new state values
				X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
				X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
				X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
				X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
				X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
				X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
				X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
				X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	   */
			C.Rabbit = StreamCipher._createHelper(Rabbit);
		})();
	
		return CryptoJS.Rabbit;
	});

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			/**
	   * RC4 stream cipher algorithm.
	   */
			var RC4 = C_algo.RC4 = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
					var keySigBytes = key.sigBytes;
	
					// Init sbox
					var S = this._S = [];
					for (var i = 0; i < 256; i++) {
						S[i] = i;
					}
	
					// Key setup
					for (var i = 0, j = 0; i < 256; i++) {
						var keyByteIndex = i % keySigBytes;
						var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
	
						j = (j + S[i] + keyByte) % 256;
	
						// Swap
						var t = S[i];
						S[i] = S[j];
						S[j] = t;
					}
	
					// Counters
					this._i = this._j = 0;
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					M[offset] ^= generateKeystreamWord.call(this);
				},
	
				keySize: 256 / 32,
	
				ivSize: 0
			});
	
			function generateKeystreamWord() {
				// Shortcuts
				var S = this._S;
				var i = this._i;
				var j = this._j;
	
				// Generate keystream word
				var keystreamWord = 0;
				for (var n = 0; n < 4; n++) {
					i = (i + 1) % 256;
					j = (j + S[i]) % 256;
	
					// Swap
					var t = S[i];
					S[i] = S[j];
					S[j] = t;
	
					keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
				}
	
				// Update counters
				this._i = i;
				this._j = j;
	
				return keystreamWord;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	   */
			C.RC4 = StreamCipher._createHelper(RC4);
	
			/**
	   * Modified RC4 stream cipher algorithm.
	   */
			var RC4Drop = C_algo.RC4Drop = RC4.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} drop The number of keystream words to drop. Default 192
	    */
				cfg: RC4.cfg.extend({
					drop: 192
				}),
	
				_doReset: function _doReset() {
					RC4._doReset.call(this);
	
					// Drop
					for (var i = this.cfg.drop; i > 0; i--) {
						generateKeystreamWord.call(this);
					}
				}
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	   */
			C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		})();
	
		return CryptoJS.RC4;
	});

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/** @preserve
	 (c) 2012 by Cédric Mesnil. All rights reserved.
	 	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	 	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	     - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	 	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Constants table
			var _zl = WordArray.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]);
			var _zr = WordArray.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]);
			var _sl = WordArray.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]);
			var _sr = WordArray.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]);
	
			var _hl = WordArray.create([0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
			var _hr = WordArray.create([0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
			/**
	   * RIPEMD160 hash algorithm.
	   */
			var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
	
					// Swap endian
					for (var i = 0; i < 16; i++) {
						// Shortcuts
						var offset_i = offset + i;
						var M_offset_i = M[offset_i];
	
						// Swap
						M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
					}
					// Shortcut
					var H = this._hash.words;
					var hl = _hl.words;
					var hr = _hr.words;
					var zl = _zl.words;
					var zr = _zr.words;
					var sl = _sl.words;
					var sr = _sr.words;
	
					// Working variables
					var al, bl, cl, dl, el;
					var ar, br, cr, dr, er;
	
					ar = al = H[0];
					br = bl = H[1];
					cr = cl = H[2];
					dr = dl = H[3];
					er = el = H[4];
					// Computation
					var t;
					for (var i = 0; i < 80; i += 1) {
						t = al + M[offset + zl[i]] | 0;
						if (i < 16) {
							t += f1(bl, cl, dl) + hl[0];
						} else if (i < 32) {
							t += f2(bl, cl, dl) + hl[1];
						} else if (i < 48) {
							t += f3(bl, cl, dl) + hl[2];
						} else if (i < 64) {
							t += f4(bl, cl, dl) + hl[3];
						} else {
							// if (i<80) {
							t += f5(bl, cl, dl) + hl[4];
						}
						t = t | 0;
						t = rotl(t, sl[i]);
						t = t + el | 0;
						al = el;
						el = dl;
						dl = rotl(cl, 10);
						cl = bl;
						bl = t;
	
						t = ar + M[offset + zr[i]] | 0;
						if (i < 16) {
							t += f5(br, cr, dr) + hr[0];
						} else if (i < 32) {
							t += f4(br, cr, dr) + hr[1];
						} else if (i < 48) {
							t += f3(br, cr, dr) + hr[2];
						} else if (i < 64) {
							t += f2(br, cr, dr) + hr[3];
						} else {
							// if (i<80) {
							t += f1(br, cr, dr) + hr[4];
						}
						t = t | 0;
						t = rotl(t, sr[i]);
						t = t + er | 0;
						ar = er;
						er = dr;
						dr = rotl(cr, 10);
						cr = br;
						br = t;
					}
					// Intermediate hash value
					t = H[1] + cl + dr | 0;
					H[1] = H[2] + dl + er | 0;
					H[2] = H[3] + el + ar | 0;
					H[3] = H[4] + al + br | 0;
					H[4] = H[0] + bl + cr | 0;
					H[0] = t;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
					data.sigBytes = (dataWords.length + 1) * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var hash = this._hash;
					var H = hash.words;
	
					// Swap endian
					for (var i = 0; i < 5; i++) {
						// Shortcut
						var H_i = H[i];
	
						// Swap
						H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
					}
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			function f1(x, y, z) {
				return x ^ y ^ z;
			}
	
			function f2(x, y, z) {
				return x & y | ~x & z;
			}
	
			function f3(x, y, z) {
				return (x | ~y) ^ z;
			}
	
			function f4(x, y, z) {
				return x & z | y & ~z;
			}
	
			function f5(x, y, z) {
				return x ^ (y | ~z);
			}
	
			function rotl(x, n) {
				return x << n | x >>> 32 - n;
			}
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.RIPEMD160('message');
	   *     var hash = CryptoJS.RIPEMD160(wordArray);
	   */
			C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	   */
			C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		})(Math);
	
		return CryptoJS.RIPEMD160;
	});

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(150));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(150)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var SHA256 = C_algo.SHA256;
	
			/**
	   * SHA-224 hash algorithm.
	   */
			var SHA224 = C_algo.SHA224 = SHA256.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4]);
				},
	
				_doFinalize: function _doFinalize() {
					var hash = SHA256._doFinalize.call(this);
	
					hash.sigBytes -= 4;
	
					return hash;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA224('message');
	   *     var hash = CryptoJS.SHA224(wordArray);
	   */
			C.SHA224 = SHA256._createHelper(SHA224);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA224(message, key);
	   */
			C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		})();
	
		return CryptoJS.SHA224;
	});

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(121));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(121)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var C_algo = C.algo;
	
			// Constants tables
			var RHO_OFFSETS = [];
			var PI_INDEXES = [];
			var ROUND_CONSTANTS = [];
	
			// Compute Constants
			(function () {
				// Compute rho offset constants
				var x = 1,
				    y = 0;
				for (var t = 0; t < 24; t++) {
					RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
	
					var newX = y % 5;
					var newY = (2 * x + 3 * y) % 5;
					x = newX;
					y = newY;
				}
	
				// Compute pi index constants
				for (var x = 0; x < 5; x++) {
					for (var y = 0; y < 5; y++) {
						PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
					}
				}
	
				// Compute round constants
				var LFSR = 0x01;
				for (var i = 0; i < 24; i++) {
					var roundConstantMsw = 0;
					var roundConstantLsw = 0;
	
					for (var j = 0; j < 7; j++) {
						if (LFSR & 0x01) {
							var bitPosition = (1 << j) - 1;
							if (bitPosition < 32) {
								roundConstantLsw ^= 1 << bitPosition;
							} else /* if (bitPosition >= 32) */{
									roundConstantMsw ^= 1 << bitPosition - 32;
								}
						}
	
						// Compute next LFSR
						if (LFSR & 0x80) {
							// Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
							LFSR = LFSR << 1 ^ 0x71;
						} else {
							LFSR <<= 1;
						}
					}
	
					ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
				}
			})();
	
			// Reusable objects for temporary values
			var T = [];
			(function () {
				for (var i = 0; i < 25; i++) {
					T[i] = X64Word.create();
				}
			})();
	
			/**
	   * SHA-3 hash algorithm.
	   */
			var SHA3 = C_algo.SHA3 = Hasher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} outputLength
	    *   The desired number of bits in the output hash.
	    *   Only values permitted are: 224, 256, 384, 512.
	    *   Default: 512
	    */
				cfg: Hasher.cfg.extend({
					outputLength: 512
				}),
	
				_doReset: function _doReset() {
					var state = this._state = [];
					for (var i = 0; i < 25; i++) {
						state[i] = new X64Word.init();
					}
	
					this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcuts
					var state = this._state;
					var nBlockSizeLanes = this.blockSize / 2;
	
					// Absorb
					for (var i = 0; i < nBlockSizeLanes; i++) {
						// Shortcuts
						var M2i = M[offset + 2 * i];
						var M2i1 = M[offset + 2 * i + 1];
	
						// Swap endian
						M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
						M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
	
						// Absorb message into state
						var lane = state[i];
						lane.high ^= M2i1;
						lane.low ^= M2i;
					}
	
					// Rounds
					for (var round = 0; round < 24; round++) {
						// Theta
						for (var x = 0; x < 5; x++) {
							// Mix column lanes
							var tMsw = 0,
							    tLsw = 0;
							for (var y = 0; y < 5; y++) {
								var lane = state[x + 5 * y];
								tMsw ^= lane.high;
								tLsw ^= lane.low;
							}
	
							// Temporary values
							var Tx = T[x];
							Tx.high = tMsw;
							Tx.low = tLsw;
						}
						for (var x = 0; x < 5; x++) {
							// Shortcuts
							var Tx4 = T[(x + 4) % 5];
							var Tx1 = T[(x + 1) % 5];
							var Tx1Msw = Tx1.high;
							var Tx1Lsw = Tx1.low;
	
							// Mix surrounding columns
							var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
							var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
							for (var y = 0; y < 5; y++) {
								var lane = state[x + 5 * y];
								lane.high ^= tMsw;
								lane.low ^= tLsw;
							}
						}
	
						// Rho Pi
						for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
							var tMsw;
							var tLsw;
	
							// Shortcuts
							var lane = state[laneIndex];
							var laneMsw = lane.high;
							var laneLsw = lane.low;
							var rhoOffset = RHO_OFFSETS[laneIndex];
	
							// Rotate lanes
							if (rhoOffset < 32) {
								tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
								tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
							} else /* if (rhoOffset >= 32) */{
									tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
									tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
								}
	
							// Transpose lanes
							var TPiLane = T[PI_INDEXES[laneIndex]];
							TPiLane.high = tMsw;
							TPiLane.low = tLsw;
						}
	
						// Rho pi at x = y = 0
						var T0 = T[0];
						var state0 = state[0];
						T0.high = state0.high;
						T0.low = state0.low;
	
						// Chi
						for (var x = 0; x < 5; x++) {
							for (var y = 0; y < 5; y++) {
								// Shortcuts
								var laneIndex = x + 5 * y;
								var lane = state[laneIndex];
								var TLane = T[laneIndex];
								var Tx1Lane = T[(x + 1) % 5 + 5 * y];
								var Tx2Lane = T[(x + 2) % 5 + 5 * y];
	
								// Mix rows
								lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
								lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
							}
						}
	
						// Iota
						var lane = state[0];
						var roundConstant = ROUND_CONSTANTS[round];
						lane.high ^= roundConstant.high;
						lane.low ^= roundConstant.low;
					}
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
					var blockSizeBits = this.blockSize * 32;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
					dataWords[(Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var state = this._state;
					var outputLengthBytes = this.cfg.outputLength / 8;
					var outputLengthLanes = outputLengthBytes / 8;
	
					// Squeeze
					var hashWords = [];
					for (var i = 0; i < outputLengthLanes; i++) {
						// Shortcuts
						var lane = state[i];
						var laneMsw = lane.high;
						var laneLsw = lane.low;
	
						// Swap endian
						laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
						laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
	
						// Squeeze state to retrieve hash
						hashWords.push(laneLsw);
						hashWords.push(laneMsw);
					}
	
					// Return final computed hash
					return new WordArray.init(hashWords, outputLengthBytes);
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
	
					var state = clone._state = this._state.slice(0);
					for (var i = 0; i < 25; i++) {
						state[i] = state[i].clone();
					}
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA3('message');
	   *     var hash = CryptoJS.SHA3(wordArray);
	   */
			C.SHA3 = Hasher._createHelper(SHA3);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA3(message, key);
	   */
			C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		})(Math);
	
		return CryptoJS.SHA3;
	});

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(121), __webpack_require__(230));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(121), __webpack_require__(230)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var X64WordArray = C_x64.WordArray;
			var C_algo = C.algo;
			var SHA512 = C_algo.SHA512;
	
			/**
	   * SHA-384 hash algorithm.
	   */
			var SHA384 = C_algo.SHA384 = SHA512.extend({
				_doReset: function _doReset() {
					this._hash = new X64WordArray.init([new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507), new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939), new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511), new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)]);
				},
	
				_doFinalize: function _doFinalize() {
					var hash = SHA512._doFinalize.call(this);
	
					hash.sigBytes -= 16;
	
					return hash;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA384('message');
	   *     var hash = CryptoJS.SHA384(wordArray);
	   */
			C.SHA384 = SHA512._createHelper(SHA384);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA384(message, key);
	   */
			C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		})();
	
		return CryptoJS.SHA384;
	});

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(76), __webpack_require__(77), __webpack_require__(70), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			// Permuted Choice 1 constants
			var PC1 = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4];
	
			// Permuted Choice 2 constants
			var PC2 = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32];
	
			// Cumulative bit shift constants
			var BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
			// SBOXes and round permutation constants
			var SBOX_P = [{
				0x0: 0x808200,
				0x10000000: 0x8000,
				0x20000000: 0x808002,
				0x30000000: 0x2,
				0x40000000: 0x200,
				0x50000000: 0x808202,
				0x60000000: 0x800202,
				0x70000000: 0x800000,
				0x80000000: 0x202,
				0x90000000: 0x800200,
				0xa0000000: 0x8200,
				0xb0000000: 0x808000,
				0xc0000000: 0x8002,
				0xd0000000: 0x800002,
				0xe0000000: 0x0,
				0xf0000000: 0x8202,
				0x8000000: 0x0,
				0x18000000: 0x808202,
				0x28000000: 0x8202,
				0x38000000: 0x8000,
				0x48000000: 0x808200,
				0x58000000: 0x200,
				0x68000000: 0x808002,
				0x78000000: 0x2,
				0x88000000: 0x800200,
				0x98000000: 0x8200,
				0xa8000000: 0x808000,
				0xb8000000: 0x800202,
				0xc8000000: 0x800002,
				0xd8000000: 0x8002,
				0xe8000000: 0x202,
				0xf8000000: 0x800000,
				0x1: 0x8000,
				0x10000001: 0x2,
				0x20000001: 0x808200,
				0x30000001: 0x800000,
				0x40000001: 0x808002,
				0x50000001: 0x8200,
				0x60000001: 0x200,
				0x70000001: 0x800202,
				0x80000001: 0x808202,
				0x90000001: 0x808000,
				0xa0000001: 0x800002,
				0xb0000001: 0x8202,
				0xc0000001: 0x202,
				0xd0000001: 0x800200,
				0xe0000001: 0x8002,
				0xf0000001: 0x0,
				0x8000001: 0x808202,
				0x18000001: 0x808000,
				0x28000001: 0x800000,
				0x38000001: 0x200,
				0x48000001: 0x8000,
				0x58000001: 0x800002,
				0x68000001: 0x2,
				0x78000001: 0x8202,
				0x88000001: 0x8002,
				0x98000001: 0x800202,
				0xa8000001: 0x202,
				0xb8000001: 0x808200,
				0xc8000001: 0x800200,
				0xd8000001: 0x0,
				0xe8000001: 0x8200,
				0xf8000001: 0x808002
			}, {
				0x0: 0x40084010,
				0x1000000: 0x4000,
				0x2000000: 0x80000,
				0x3000000: 0x40080010,
				0x4000000: 0x40000010,
				0x5000000: 0x40084000,
				0x6000000: 0x40004000,
				0x7000000: 0x10,
				0x8000000: 0x84000,
				0x9000000: 0x40004010,
				0xa000000: 0x40000000,
				0xb000000: 0x84010,
				0xc000000: 0x80010,
				0xd000000: 0x0,
				0xe000000: 0x4010,
				0xf000000: 0x40080000,
				0x800000: 0x40004000,
				0x1800000: 0x84010,
				0x2800000: 0x10,
				0x3800000: 0x40004010,
				0x4800000: 0x40084010,
				0x5800000: 0x40000000,
				0x6800000: 0x80000,
				0x7800000: 0x40080010,
				0x8800000: 0x80010,
				0x9800000: 0x0,
				0xa800000: 0x4000,
				0xb800000: 0x40080000,
				0xc800000: 0x40000010,
				0xd800000: 0x84000,
				0xe800000: 0x40084000,
				0xf800000: 0x4010,
				0x10000000: 0x0,
				0x11000000: 0x40080010,
				0x12000000: 0x40004010,
				0x13000000: 0x40084000,
				0x14000000: 0x40080000,
				0x15000000: 0x10,
				0x16000000: 0x84010,
				0x17000000: 0x4000,
				0x18000000: 0x4010,
				0x19000000: 0x80000,
				0x1a000000: 0x80010,
				0x1b000000: 0x40000010,
				0x1c000000: 0x84000,
				0x1d000000: 0x40004000,
				0x1e000000: 0x40000000,
				0x1f000000: 0x40084010,
				0x10800000: 0x84010,
				0x11800000: 0x80000,
				0x12800000: 0x40080000,
				0x13800000: 0x4000,
				0x14800000: 0x40004000,
				0x15800000: 0x40084010,
				0x16800000: 0x10,
				0x17800000: 0x40000000,
				0x18800000: 0x40084000,
				0x19800000: 0x40000010,
				0x1a800000: 0x40004010,
				0x1b800000: 0x80010,
				0x1c800000: 0x0,
				0x1d800000: 0x4010,
				0x1e800000: 0x40080010,
				0x1f800000: 0x84000
			}, {
				0x0: 0x104,
				0x100000: 0x0,
				0x200000: 0x4000100,
				0x300000: 0x10104,
				0x400000: 0x10004,
				0x500000: 0x4000004,
				0x600000: 0x4010104,
				0x700000: 0x4010000,
				0x800000: 0x4000000,
				0x900000: 0x4010100,
				0xa00000: 0x10100,
				0xb00000: 0x4010004,
				0xc00000: 0x4000104,
				0xd00000: 0x10000,
				0xe00000: 0x4,
				0xf00000: 0x100,
				0x80000: 0x4010100,
				0x180000: 0x4010004,
				0x280000: 0x0,
				0x380000: 0x4000100,
				0x480000: 0x4000004,
				0x580000: 0x10000,
				0x680000: 0x10004,
				0x780000: 0x104,
				0x880000: 0x4,
				0x980000: 0x100,
				0xa80000: 0x4010000,
				0xb80000: 0x10104,
				0xc80000: 0x10100,
				0xd80000: 0x4000104,
				0xe80000: 0x4010104,
				0xf80000: 0x4000000,
				0x1000000: 0x4010100,
				0x1100000: 0x10004,
				0x1200000: 0x10000,
				0x1300000: 0x4000100,
				0x1400000: 0x100,
				0x1500000: 0x4010104,
				0x1600000: 0x4000004,
				0x1700000: 0x0,
				0x1800000: 0x4000104,
				0x1900000: 0x4000000,
				0x1a00000: 0x4,
				0x1b00000: 0x10100,
				0x1c00000: 0x4010000,
				0x1d00000: 0x104,
				0x1e00000: 0x10104,
				0x1f00000: 0x4010004,
				0x1080000: 0x4000000,
				0x1180000: 0x104,
				0x1280000: 0x4010100,
				0x1380000: 0x0,
				0x1480000: 0x10004,
				0x1580000: 0x4000100,
				0x1680000: 0x100,
				0x1780000: 0x4010004,
				0x1880000: 0x10000,
				0x1980000: 0x4010104,
				0x1a80000: 0x10104,
				0x1b80000: 0x4000004,
				0x1c80000: 0x4000104,
				0x1d80000: 0x4010000,
				0x1e80000: 0x4,
				0x1f80000: 0x10100
			}, {
				0x0: 0x80401000,
				0x10000: 0x80001040,
				0x20000: 0x401040,
				0x30000: 0x80400000,
				0x40000: 0x0,
				0x50000: 0x401000,
				0x60000: 0x80000040,
				0x70000: 0x400040,
				0x80000: 0x80000000,
				0x90000: 0x400000,
				0xa0000: 0x40,
				0xb0000: 0x80001000,
				0xc0000: 0x80400040,
				0xd0000: 0x1040,
				0xe0000: 0x1000,
				0xf0000: 0x80401040,
				0x8000: 0x80001040,
				0x18000: 0x40,
				0x28000: 0x80400040,
				0x38000: 0x80001000,
				0x48000: 0x401000,
				0x58000: 0x80401040,
				0x68000: 0x0,
				0x78000: 0x80400000,
				0x88000: 0x1000,
				0x98000: 0x80401000,
				0xa8000: 0x400000,
				0xb8000: 0x1040,
				0xc8000: 0x80000000,
				0xd8000: 0x400040,
				0xe8000: 0x401040,
				0xf8000: 0x80000040,
				0x100000: 0x400040,
				0x110000: 0x401000,
				0x120000: 0x80000040,
				0x130000: 0x0,
				0x140000: 0x1040,
				0x150000: 0x80400040,
				0x160000: 0x80401000,
				0x170000: 0x80001040,
				0x180000: 0x80401040,
				0x190000: 0x80000000,
				0x1a0000: 0x80400000,
				0x1b0000: 0x401040,
				0x1c0000: 0x80001000,
				0x1d0000: 0x400000,
				0x1e0000: 0x40,
				0x1f0000: 0x1000,
				0x108000: 0x80400000,
				0x118000: 0x80401040,
				0x128000: 0x0,
				0x138000: 0x401000,
				0x148000: 0x400040,
				0x158000: 0x80000000,
				0x168000: 0x80001040,
				0x178000: 0x40,
				0x188000: 0x80000040,
				0x198000: 0x1000,
				0x1a8000: 0x80001000,
				0x1b8000: 0x80400040,
				0x1c8000: 0x1040,
				0x1d8000: 0x80401000,
				0x1e8000: 0x400000,
				0x1f8000: 0x401040
			}, {
				0x0: 0x80,
				0x1000: 0x1040000,
				0x2000: 0x40000,
				0x3000: 0x20000000,
				0x4000: 0x20040080,
				0x5000: 0x1000080,
				0x6000: 0x21000080,
				0x7000: 0x40080,
				0x8000: 0x1000000,
				0x9000: 0x20040000,
				0xa000: 0x20000080,
				0xb000: 0x21040080,
				0xc000: 0x21040000,
				0xd000: 0x0,
				0xe000: 0x1040080,
				0xf000: 0x21000000,
				0x800: 0x1040080,
				0x1800: 0x21000080,
				0x2800: 0x80,
				0x3800: 0x1040000,
				0x4800: 0x40000,
				0x5800: 0x20040080,
				0x6800: 0x21040000,
				0x7800: 0x20000000,
				0x8800: 0x20040000,
				0x9800: 0x0,
				0xa800: 0x21040080,
				0xb800: 0x1000080,
				0xc800: 0x20000080,
				0xd800: 0x21000000,
				0xe800: 0x1000000,
				0xf800: 0x40080,
				0x10000: 0x40000,
				0x11000: 0x80,
				0x12000: 0x20000000,
				0x13000: 0x21000080,
				0x14000: 0x1000080,
				0x15000: 0x21040000,
				0x16000: 0x20040080,
				0x17000: 0x1000000,
				0x18000: 0x21040080,
				0x19000: 0x21000000,
				0x1a000: 0x1040000,
				0x1b000: 0x20040000,
				0x1c000: 0x40080,
				0x1d000: 0x20000080,
				0x1e000: 0x0,
				0x1f000: 0x1040080,
				0x10800: 0x21000080,
				0x11800: 0x1000000,
				0x12800: 0x1040000,
				0x13800: 0x20040080,
				0x14800: 0x20000000,
				0x15800: 0x1040080,
				0x16800: 0x80,
				0x17800: 0x21040000,
				0x18800: 0x40080,
				0x19800: 0x21040080,
				0x1a800: 0x0,
				0x1b800: 0x21000000,
				0x1c800: 0x1000080,
				0x1d800: 0x40000,
				0x1e800: 0x20040000,
				0x1f800: 0x20000080
			}, {
				0x0: 0x10000008,
				0x100: 0x2000,
				0x200: 0x10200000,
				0x300: 0x10202008,
				0x400: 0x10002000,
				0x500: 0x200000,
				0x600: 0x200008,
				0x700: 0x10000000,
				0x800: 0x0,
				0x900: 0x10002008,
				0xa00: 0x202000,
				0xb00: 0x8,
				0xc00: 0x10200008,
				0xd00: 0x202008,
				0xe00: 0x2008,
				0xf00: 0x10202000,
				0x80: 0x10200000,
				0x180: 0x10202008,
				0x280: 0x8,
				0x380: 0x200000,
				0x480: 0x202008,
				0x580: 0x10000008,
				0x680: 0x10002000,
				0x780: 0x2008,
				0x880: 0x200008,
				0x980: 0x2000,
				0xa80: 0x10002008,
				0xb80: 0x10200008,
				0xc80: 0x0,
				0xd80: 0x10202000,
				0xe80: 0x202000,
				0xf80: 0x10000000,
				0x1000: 0x10002000,
				0x1100: 0x10200008,
				0x1200: 0x10202008,
				0x1300: 0x2008,
				0x1400: 0x200000,
				0x1500: 0x10000000,
				0x1600: 0x10000008,
				0x1700: 0x202000,
				0x1800: 0x202008,
				0x1900: 0x0,
				0x1a00: 0x8,
				0x1b00: 0x10200000,
				0x1c00: 0x2000,
				0x1d00: 0x10002008,
				0x1e00: 0x10202000,
				0x1f00: 0x200008,
				0x1080: 0x8,
				0x1180: 0x202000,
				0x1280: 0x200000,
				0x1380: 0x10000008,
				0x1480: 0x10002000,
				0x1580: 0x2008,
				0x1680: 0x10202008,
				0x1780: 0x10200000,
				0x1880: 0x10202000,
				0x1980: 0x10200008,
				0x1a80: 0x2000,
				0x1b80: 0x202008,
				0x1c80: 0x200008,
				0x1d80: 0x0,
				0x1e80: 0x10000000,
				0x1f80: 0x10002008
			}, {
				0x0: 0x100000,
				0x10: 0x2000401,
				0x20: 0x400,
				0x30: 0x100401,
				0x40: 0x2100401,
				0x50: 0x0,
				0x60: 0x1,
				0x70: 0x2100001,
				0x80: 0x2000400,
				0x90: 0x100001,
				0xa0: 0x2000001,
				0xb0: 0x2100400,
				0xc0: 0x2100000,
				0xd0: 0x401,
				0xe0: 0x100400,
				0xf0: 0x2000000,
				0x8: 0x2100001,
				0x18: 0x0,
				0x28: 0x2000401,
				0x38: 0x2100400,
				0x48: 0x100000,
				0x58: 0x2000001,
				0x68: 0x2000000,
				0x78: 0x401,
				0x88: 0x100401,
				0x98: 0x2000400,
				0xa8: 0x2100000,
				0xb8: 0x100001,
				0xc8: 0x400,
				0xd8: 0x2100401,
				0xe8: 0x1,
				0xf8: 0x100400,
				0x100: 0x2000000,
				0x110: 0x100000,
				0x120: 0x2000401,
				0x130: 0x2100001,
				0x140: 0x100001,
				0x150: 0x2000400,
				0x160: 0x2100400,
				0x170: 0x100401,
				0x180: 0x401,
				0x190: 0x2100401,
				0x1a0: 0x100400,
				0x1b0: 0x1,
				0x1c0: 0x0,
				0x1d0: 0x2100000,
				0x1e0: 0x2000001,
				0x1f0: 0x400,
				0x108: 0x100400,
				0x118: 0x2000401,
				0x128: 0x2100001,
				0x138: 0x1,
				0x148: 0x2000000,
				0x158: 0x100000,
				0x168: 0x401,
				0x178: 0x2100400,
				0x188: 0x2000001,
				0x198: 0x2100000,
				0x1a8: 0x0,
				0x1b8: 0x2100401,
				0x1c8: 0x100401,
				0x1d8: 0x400,
				0x1e8: 0x2000400,
				0x1f8: 0x100001
			}, {
				0x0: 0x8000820,
				0x1: 0x20000,
				0x2: 0x8000000,
				0x3: 0x20,
				0x4: 0x20020,
				0x5: 0x8020820,
				0x6: 0x8020800,
				0x7: 0x800,
				0x8: 0x8020000,
				0x9: 0x8000800,
				0xa: 0x20800,
				0xb: 0x8020020,
				0xc: 0x820,
				0xd: 0x0,
				0xe: 0x8000020,
				0xf: 0x20820,
				0x80000000: 0x800,
				0x80000001: 0x8020820,
				0x80000002: 0x8000820,
				0x80000003: 0x8000000,
				0x80000004: 0x8020000,
				0x80000005: 0x20800,
				0x80000006: 0x20820,
				0x80000007: 0x20,
				0x80000008: 0x8000020,
				0x80000009: 0x820,
				0x8000000a: 0x20020,
				0x8000000b: 0x8020800,
				0x8000000c: 0x0,
				0x8000000d: 0x8020020,
				0x8000000e: 0x8000800,
				0x8000000f: 0x20000,
				0x10: 0x20820,
				0x11: 0x8020800,
				0x12: 0x20,
				0x13: 0x800,
				0x14: 0x8000800,
				0x15: 0x8000020,
				0x16: 0x8020020,
				0x17: 0x20000,
				0x18: 0x0,
				0x19: 0x20020,
				0x1a: 0x8020000,
				0x1b: 0x8000820,
				0x1c: 0x8020820,
				0x1d: 0x20800,
				0x1e: 0x820,
				0x1f: 0x8000000,
				0x80000010: 0x20000,
				0x80000011: 0x800,
				0x80000012: 0x8020020,
				0x80000013: 0x20820,
				0x80000014: 0x20,
				0x80000015: 0x8020000,
				0x80000016: 0x8000000,
				0x80000017: 0x8000820,
				0x80000018: 0x8020820,
				0x80000019: 0x8000020,
				0x8000001a: 0x8000800,
				0x8000001b: 0x0,
				0x8000001c: 0x20800,
				0x8000001d: 0x820,
				0x8000001e: 0x20020,
				0x8000001f: 0x8020800
			}];
	
			// Masks that select the SBOX input
			var SBOX_MASK = [0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000, 0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f];
	
			/**
	   * DES block cipher algorithm.
	   */
			var DES = C_algo.DES = BlockCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
	
					// Select 56 bits according to PC1
					var keyBits = [];
					for (var i = 0; i < 56; i++) {
						var keyBitPos = PC1[i] - 1;
						keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
					}
	
					// Assemble 16 subkeys
					var subKeys = this._subKeys = [];
					for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
						// Create subkey
						var subKey = subKeys[nSubKey] = [];
	
						// Shortcut
						var bitShift = BIT_SHIFTS[nSubKey];
	
						// Select 48 bits according to PC2
						for (var i = 0; i < 24; i++) {
							// Select from the left 28 key bits
							subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
	
							// Select from the right 28 key bits
							subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
						}
	
						// Since each subkey is applied to an expanded 32-bit input,
						// the subkey can be broken into 8 values scaled to 32-bits,
						// which allows the key to be used without expansion
						subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
						for (var i = 1; i < 7; i++) {
							subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
						}
						subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
					}
	
					// Compute inverse subkeys
					var invSubKeys = this._invSubKeys = [];
					for (var i = 0; i < 16; i++) {
						invSubKeys[i] = subKeys[15 - i];
					}
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._subKeys);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._invSubKeys);
				},
	
				_doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
					// Get input
					this._lBlock = M[offset];
					this._rBlock = M[offset + 1];
	
					// Initial permutation
					exchangeLR.call(this, 4, 0x0f0f0f0f);
					exchangeLR.call(this, 16, 0x0000ffff);
					exchangeRL.call(this, 2, 0x33333333);
					exchangeRL.call(this, 8, 0x00ff00ff);
					exchangeLR.call(this, 1, 0x55555555);
	
					// Rounds
					for (var round = 0; round < 16; round++) {
						// Shortcuts
						var subKey = subKeys[round];
						var lBlock = this._lBlock;
						var rBlock = this._rBlock;
	
						// Feistel function
						var f = 0;
						for (var i = 0; i < 8; i++) {
							f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
						}
						this._lBlock = rBlock;
						this._rBlock = lBlock ^ f;
					}
	
					// Undo swap from last round
					var t = this._lBlock;
					this._lBlock = this._rBlock;
					this._rBlock = t;
	
					// Final permutation
					exchangeLR.call(this, 1, 0x55555555);
					exchangeRL.call(this, 8, 0x00ff00ff);
					exchangeRL.call(this, 2, 0x33333333);
					exchangeLR.call(this, 16, 0x0000ffff);
					exchangeLR.call(this, 4, 0x0f0f0f0f);
	
					// Set output
					M[offset] = this._lBlock;
					M[offset + 1] = this._rBlock;
				},
	
				keySize: 64 / 32,
	
				ivSize: 64 / 32,
	
				blockSize: 64 / 32
			});
	
			// Swap bits across the left and right words
			function exchangeLR(offset, mask) {
				var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
				this._rBlock ^= t;
				this._lBlock ^= t << offset;
			}
	
			function exchangeRL(offset, mask) {
				var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
				this._lBlock ^= t;
				this._rBlock ^= t << offset;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	   */
			C.DES = BlockCipher._createHelper(DES);
	
			/**
	   * Triple-DES block cipher algorithm.
	   */
			var TripleDES = C_algo.TripleDES = BlockCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
					// Make sure the key length is valid (64, 128 or >= 192 bit)
					if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
						throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
					}
	
					// Extend the key according to the keying options defined in 3DES standard
					var key1 = keyWords.slice(0, 2);
					var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
					var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
	
					// Create DES instances
					this._des1 = DES.createEncryptor(WordArray.create(key1));
					this._des2 = DES.createEncryptor(WordArray.create(key2));
					this._des3 = DES.createEncryptor(WordArray.create(key3));
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._des1.encryptBlock(M, offset);
					this._des2.decryptBlock(M, offset);
					this._des3.encryptBlock(M, offset);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					this._des3.decryptBlock(M, offset);
					this._des2.encryptBlock(M, offset);
					this._des1.decryptBlock(M, offset);
				},
	
				keySize: 192 / 32,
	
				ivSize: 64 / 32,
	
				blockSize: 64 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	   */
			C.TripleDES = BlockCipher._createHelper(TripleDES);
		})();
	
		return CryptoJS.TripleDES;
	});

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PresetColorTypes = void 0;
	
	var _type = __webpack_require__(78);
	
	// eslint-disable-next-line import/prefer-default-export
	var PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
	exports.PresetColorTypes = PresetColorTypes;

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getDataOrAriaProps;
	
	function getDataOrAriaProps(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
	      prev[key] = props[key];
	    }
	
	    return prev;
	  }, {});
	}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	// ================== Collapse Motion ==================
	var getCollapsedHeight = function getCollapsedHeight() {
	  return {
	    height: 0,
	    opacity: 0
	  };
	};
	
	var getRealHeight = function getRealHeight(node) {
	  return {
	    height: node.scrollHeight,
	    opacity: 1
	  };
	};
	
	var getCurrentHeight = function getCurrentHeight(node) {
	  return {
	    height: node.offsetHeight
	  };
	};
	
	var collapseMotion = {
	  motionName: 'ant-motion-collapse',
	  onAppearStart: getCollapsedHeight,
	  onEnterStart: getCollapsedHeight,
	  onAppearActive: getRealHeight,
	  onEnterActive: getRealHeight,
	  onLeaveStart: getCurrentHeight,
	  onLeaveActive: getCollapsedHeight
	};
	var _default = collapseMotion;
	exports["default"] = _default;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cloneElement = cloneElement;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	// eslint-disable-next-line import/prefer-default-export
	function cloneElement(element) {
	  if (! /*#__PURE__*/React.isValidElement(element)) return element;
	
	  for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    restArgs[_key - 1] = arguments[_key];
	  }
	
	  return React.cloneElement.apply(React, [element].concat(restArgs));
	}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.responsiveMap = exports.responsiveArray = void 0;
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	var enquire; // TODO: Will be removed in antd 4.0 because we will no longer support ie9
	
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill; // eslint-disable-next-line global-require
	
	  enquire = __webpack_require__(496);
	}
	
	var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
	exports.responsiveArray = responsiveArray;
	var responsiveMap = {
	  xs: '(max-width: 575px)',
	  sm: '(min-width: 576px)',
	  md: '(min-width: 768px)',
	  lg: '(min-width: 992px)',
	  xl: '(min-width: 1200px)',
	  xxl: '(min-width: 1600px)'
	};
	exports.responsiveMap = responsiveMap;
	var subscribers = [];
	var subUid = -1;
	var screens = {};
	var responsiveObserve = {
	  dispatch: function dispatch(pointMap) {
	    screens = pointMap;
	
	    if (subscribers.length < 1) {
	      return false;
	    }
	
	    subscribers.forEach(function (item) {
	      item.func(screens);
	    });
	    return true;
	  },
	  subscribe: function subscribe(func) {
	    if (subscribers.length === 0) {
	      this.register();
	    }
	
	    var token = (++subUid).toString();
	    subscribers.push({
	      token: token,
	      func: func
	    });
	    func(screens);
	    return token;
	  },
	  unsubscribe: function unsubscribe(token) {
	    subscribers = subscribers.filter(function (item) {
	      return item.token !== token;
	    });
	
	    if (subscribers.length === 0) {
	      this.unregister();
	    }
	  },
	  unregister: function unregister() {
	    Object.keys(responsiveMap).map(function (screen) {
	      return enquire.unregister(responsiveMap[screen]);
	    });
	  },
	  register: function register() {
	    var _this = this;
	
	    Object.keys(responsiveMap).map(function (screen) {
	      return enquire.register(responsiveMap[screen], {
	        match: function match() {
	          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, true));
	
	          _this.dispatch(pointMap);
	        },
	        unmatch: function unmatch() {
	          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, false));
	
	          _this.dispatch(pointMap);
	        },
	        // Keep a empty destory to avoid triggering unmatch when unregister
	        destroy: function destroy() {}
	      });
	    });
	  }
	};
	var _default = responsiveObserve;
	exports["default"] = _default;

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.isFlexSupported = void 0;
	
	var isStyleSupport = function isStyleSupport(styleName) {
	  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
	    var documentElement = window.document.documentElement;
	    return styleNameList.some(function (name) {
	      return name in documentElement.style;
	    });
	  }
	
	  return false;
	};
	
	var isFlexSupported = isStyleSupport(['flex', 'webkitFlex', 'Flex', 'msFlex']);
	exports.isFlexSupported = isFlexSupported;
	var _default = isStyleSupport;
	exports["default"] = _default;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _configProvider = __webpack_require__(13);
	
	var _throttleByAnimationFrame = __webpack_require__(1006);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _utils = __webpack_require__(1008);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
	  var c = arguments.length,
	      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	      d;
	  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	  }
	  return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	function getDefaultTarget() {
	  return typeof window !== 'undefined' ? window : null;
	}
	
	var AffixStatus;
	
	(function (AffixStatus) {
	  AffixStatus[AffixStatus["None"] = 0] = "None";
	  AffixStatus[AffixStatus["Prepare"] = 1] = "Prepare";
	})(AffixStatus || (AffixStatus = {}));
	
	var Affix = /*#__PURE__*/function (_React$Component) {
	  _inherits(Affix, _React$Component);
	
	  var _super = _createSuper(Affix);
	
	  function Affix() {
	    var _this;
	
	    _classCallCheck(this, Affix);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      status: AffixStatus.None,
	      lastAffix: false,
	      prevTarget: null
	    };
	
	    _this.getOffsetTop = function () {
	      var _this$props = _this.props,
	          offset = _this$props.offset,
	          offsetBottom = _this$props.offsetBottom;
	      var offsetTop = _this.props.offsetTop;
	
	      if (typeof offsetTop === 'undefined') {
	        offsetTop = offset;
	        (0, _warning["default"])(typeof offset === 'undefined', 'Affix', '`offset` is deprecated. Please use `offsetTop` instead.');
	      }
	
	      if (offsetBottom === undefined && offsetTop === undefined) {
	        offsetTop = 0;
	      }
	
	      return offsetTop;
	    };
	
	    _this.getOffsetBottom = function () {
	      return _this.props.offsetBottom;
	    };
	
	    _this.savePlaceholderNode = function (node) {
	      _this.placeholderNode = node;
	    };
	
	    _this.saveFixedNode = function (node) {
	      _this.fixedNode = node;
	    }; // =================== Measure ===================
	
	
	    _this.measure = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          lastAffix = _this$state.lastAffix;
	      var _this$props2 = _this.props,
	          target = _this$props2.target,
	          onChange = _this$props2.onChange;
	
	      if (status !== AffixStatus.Prepare || !_this.fixedNode || !_this.placeholderNode || !target) {
	        return;
	      }
	
	      var offsetTop = _this.getOffsetTop();
	
	      var offsetBottom = _this.getOffsetBottom();
	
	      var targetNode = target();
	
	      if (!targetNode) {
	        return;
	      }
	
	      var newState = {
	        status: AffixStatus.None
	      };
	      var targetRect = (0, _utils.getTargetRect)(targetNode);
	      var placeholderReact = (0, _utils.getTargetRect)(_this.placeholderNode);
	      var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
	      var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);
	
	      if (fixedTop !== undefined) {
	        newState.affixStyle = {
	          position: 'fixed',
	          top: fixedTop,
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	        newState.placeholderStyle = {
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	      } else if (fixedBottom !== undefined) {
	        newState.affixStyle = {
	          position: 'fixed',
	          bottom: fixedBottom,
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	        newState.placeholderStyle = {
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	      }
	
	      newState.lastAffix = !!newState.affixStyle;
	
	      if (onChange && lastAffix !== newState.lastAffix) {
	        onChange(newState.lastAffix);
	      }
	
	      _this.setState(newState);
	    }; // @ts-ignore TS6133
	
	
	    _this.prepareMeasure = function () {
	      // event param is used before. Keep compatible ts define here.
	      _this.setState({
	        status: AffixStatus.Prepare,
	        affixStyle: undefined,
	        placeholderStyle: undefined
	      }); // Test if `updatePosition` called
	
	
	      if (false) {
	        var onTestUpdatePosition = _this.props.onTestUpdatePosition;
	
	        if (onTestUpdatePosition) {
	          onTestUpdatePosition();
	        }
	      }
	    }; // =================== Render ===================
	
	
	    _this.renderAffix = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$state2 = _this.state,
	          affixStyle = _this$state2.affixStyle,
	          placeholderStyle = _this$state2.placeholderStyle;
	      var _this$props3 = _this.props,
	          prefixCls = _this$props3.prefixCls,
	          children = _this$props3.children;
	      var className = (0, _classnames["default"])(_defineProperty({}, getPrefixCls('affix', prefixCls), affixStyle));
	      var props = (0, _omit["default"])(_this.props, ['prefixCls', 'offsetTop', 'offsetBottom', 'target', 'onChange']); // Omit this since `onTestUpdatePosition` only works on test.
	
	      if (false) {
	        props = (0, _omit["default"])(props, ['onTestUpdatePosition']);
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: function onResize() {
	            _this.updatePosition();
	          }
	        }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
	          ref: _this.savePlaceholderNode
	        }), affixStyle && /*#__PURE__*/React.createElement("div", {
	          style: placeholderStyle,
	          "aria-hidden": "true"
	        }), /*#__PURE__*/React.createElement("div", {
	          className: className,
	          ref: _this.saveFixedNode,
	          style: affixStyle
	        }, /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: function onResize() {
	            _this.updatePosition();
	          }
	        }, children))))
	      );
	    };
	
	    return _this;
	  } // Event handler
	
	
	  _createClass(Affix, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var target = this.props.target;
	
	      if (target) {
	        // [Legacy] Wait for parent component ref has its value.
	        // We should use target as directly element instead of function which makes element check hard.
	        this.timeout = setTimeout(function () {
	          (0, _utils.addObserveTarget)(target(), _this2); // Mock Event object.
	
	          _this2.updatePosition();
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var prevTarget = this.state.prevTarget;
	      var target = this.props.target;
	      var newTarget = null;
	
	      if (target) {
	        newTarget = target() || null;
	      }
	
	      if (prevTarget !== newTarget) {
	        (0, _utils.removeObserveTarget)(this);
	
	        if (newTarget) {
	          (0, _utils.addObserveTarget)(newTarget, this); // Mock Event object.
	
	          this.updatePosition();
	        }
	
	        this.setState({
	          prevTarget: newTarget
	        });
	      }
	
	      if (prevProps.offsetTop !== this.props.offsetTop || prevProps.offsetBottom !== this.props.offsetBottom) {
	        this.updatePosition();
	      }
	
	      this.measure();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	      (0, _utils.removeObserveTarget)(this);
	      this.updatePosition.cancel(); // https://github.com/ant-design/ant-design/issues/22683
	
	      this.lazyUpdatePosition.cancel();
	    } // Handle realign logic
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      this.prepareMeasure();
	    }
	  }, {
	    key: "lazyUpdatePosition",
	    value: function lazyUpdatePosition() {
	      var target = this.props.target;
	      var affixStyle = this.state.affixStyle; // Check position change before measure to make Safari smooth
	
	      if (target && affixStyle) {
	        var offsetTop = this.getOffsetTop();
	        var offsetBottom = this.getOffsetBottom();
	        var targetNode = target();
	
	        if (targetNode && this.placeholderNode) {
	          var targetRect = (0, _utils.getTargetRect)(targetNode);
	          var placeholderReact = (0, _utils.getTargetRect)(this.placeholderNode);
	          var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
	          var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);
	
	          if (fixedTop !== undefined && affixStyle.top === fixedTop || fixedBottom !== undefined && affixStyle.bottom === fixedBottom) {
	            return;
	          }
	        }
	      } // Directly call prepare measure since it's already throttled.
	
	
	      this.prepareMeasure();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAffix)
	      );
	    }
	  }]);
	
	  return Affix;
	}(React.Component);
	
	Affix.defaultProps = {
	  target: getDefaultTarget
	};
	
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "updatePosition", null);
	
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "lazyUpdatePosition", null);
	
	(0, _reactLifecyclesCompat.polyfill)(Affix);
	var _default = Affix;
	exports["default"] = _default;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Avatar = /*#__PURE__*/function (_React$Component) {
	  _inherits(Avatar, _React$Component);
	
	  var _super = _createSuper(Avatar);
	
	  function Avatar() {
	    var _this;
	
	    _classCallCheck(this, Avatar);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      scale: 1,
	      mounted: false,
	      isImgExist: true
	    };
	
	    _this.setScale = function () {
	      if (!_this.avatarChildren || !_this.avatarNode) {
	        return;
	      }
	
	      var childrenWidth = _this.avatarChildren.offsetWidth; // offsetWidth avoid affecting be transform scale
	
	      var nodeWidth = _this.avatarNode.offsetWidth; // denominator is 0 is no meaning
	
	      if (childrenWidth === 0 || nodeWidth === 0 || _this.lastChildrenWidth === childrenWidth && _this.lastNodeWidth === nodeWidth) {
	        return;
	      }
	
	      _this.lastChildrenWidth = childrenWidth;
	      _this.lastNodeWidth = nodeWidth; // add 4px gap for each side to get better performance
	
	      _this.setState({
	        scale: nodeWidth - 8 < childrenWidth ? (nodeWidth - 8) / childrenWidth : 1
	      });
	    };
	
	    _this.handleImgLoadError = function () {
	      var onError = _this.props.onError;
	      var errorFlag = onError ? onError() : undefined;
	
	      if (errorFlag !== false) {
	        _this.setState({
	          isImgExist: false
	        });
	      }
	    };
	
	    _this.renderAvatar = function (_ref) {
	      var _classNames, _classNames2;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          shape = _a.shape,
	          size = _a.size,
	          src = _a.src,
	          srcSet = _a.srcSet,
	          icon = _a.icon,
	          className = _a.className,
	          alt = _a.alt,
	          others = __rest(_a, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "alt"]);
	
	      var _this$state = _this.state,
	          isImgExist = _this$state.isImgExist,
	          scale = _this$state.scale,
	          mounted = _this$state.mounted;
	      var prefixCls = getPrefixCls('avatar', customizePrefixCls);
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
	      var classString = (0, _classnames["default"])(prefixCls, className, sizeCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames2, "".concat(prefixCls, "-image"), src && isImgExist), _defineProperty(_classNames2, "".concat(prefixCls, "-icon"), icon), _classNames2));
	      var sizeStyle = typeof size === 'number' ? {
	        width: size,
	        height: size,
	        lineHeight: "".concat(size, "px"),
	        fontSize: icon ? size / 2 : 18
	      } : {};
	      var children = _this.props.children;
	
	      if (src && isImgExist) {
	        children = /*#__PURE__*/React.createElement("img", {
	          src: src,
	          srcSet: srcSet,
	          onError: _this.handleImgLoadError,
	          alt: alt
	        });
	      } else if (icon) {
	        if (typeof icon === 'string') {
	          children = /*#__PURE__*/React.createElement(_icon["default"], {
	            type: icon
	          });
	        } else {
	          children = icon;
	        }
	      } else {
	        var childrenNode = _this.avatarChildren;
	
	        if (childrenNode || scale !== 1) {
	          var transformString = "scale(".concat(scale, ") translateX(-50%)");
	          var childrenStyle = {
	            msTransform: transformString,
	            WebkitTransform: transformString,
	            transform: transformString
	          };
	          var sizeChildrenStyle = typeof size === 'number' ? {
	            lineHeight: "".concat(size, "px")
	          } : {};
	          children = /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-string"),
	            ref: function ref(node) {
	              return _this.avatarChildren = node;
	            },
	            style: _extends(_extends({}, sizeChildrenStyle), childrenStyle)
	          }, children);
	        } else {
	          var _childrenStyle = {};
	
	          if (!mounted) {
	            _childrenStyle.opacity = 0;
	          }
	
	          children = /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-string"),
	            style: {
	              opacity: 0
	            },
	            ref: function ref(node) {
	              return _this.avatarChildren = node;
	            }
	          }, children);
	        }
	      }
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, others, {
	          style: _extends(_extends({}, sizeStyle), others.style),
	          className: classString,
	          ref: function ref(node) {
	            return _this.avatarNode = node;
	          }
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Avatar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setScale();
	      this.setState({
	        mounted: true
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.setScale();
	
	      if (prevProps.src !== this.props.src) {
	        this.setState({
	          isImgExist: true,
	          scale: 1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAvatar)
	      );
	    }
	  }]);
	
	  return Avatar;
	}(React.Component);
	
	exports["default"] = Avatar;
	Avatar.defaultProps = {
	  shape: 'circle',
	  size: 'default'
	};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(294));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var BreadcrumbItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(BreadcrumbItem, _React$Component);
	
	  var _super = _createSuper(BreadcrumbItem);
	
	  function BreadcrumbItem() {
	    var _this;
	
	    _classCallCheck(this, BreadcrumbItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderBreadcrumbItem = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          separator = _a.separator,
	          children = _a.children,
	          restProps = __rest(_a, ["prefixCls", "separator", "children"]);
	
	      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
	      var link;
	
	      if ('href' in _this.props) {
	        link = /*#__PURE__*/React.createElement("a", _extends({
	          className: "".concat(prefixCls, "-link")
	        }, (0, _omit["default"])(restProps, ['overlay'])), children);
	      } else {
	        link = /*#__PURE__*/React.createElement("span", _extends({
	          className: "".concat(prefixCls, "-link")
	        }, (0, _omit["default"])(restProps, ['overlay'])), children);
	      } // wrap to dropDown
	
	
	      link = _this.renderBreadcrumbNode(link, prefixCls);
	
	      if (children) {
	        return (/*#__PURE__*/React.createElement("span", null, link, separator && separator !== '' && /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-separator")
	          }, separator))
	        );
	      }
	
	      return null;
	    };
	    /**
	     * if overlay is have
	     * Wrap a DropDown
	     */
	
	    _this.renderBreadcrumbNode = function (breadcrumbItem, prefixCls) {
	      var overlay = _this.props.overlay;
	
	      if (overlay) {
	        return (/*#__PURE__*/React.createElement(_dropdown["default"], {
	            overlay: overlay,
	            placement: "bottomCenter"
	          }, /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-overlay-link")
	          }, breadcrumbItem, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "down"
	          })))
	        );
	      }
	
	      return breadcrumbItem;
	    };
	
	    return _this;
	  }
	
	  _createClass(BreadcrumbItem, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumbItem)
	      );
	    }
	  }]);
	
	  return BreadcrumbItem;
	}(React.Component);
	
	exports["default"] = BreadcrumbItem;
	BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
	BreadcrumbItem.defaultProps = {
	  separator: '/'
	};
	BreadcrumbItem.propTypes = {
	  prefixCls: PropTypes.string,
	  separator: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	  href: PropTypes.string
	};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Breadcrumb = _interopRequireDefault(__webpack_require__(1018));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(558));
	
	var _BreadcrumbSeparator = _interopRequireDefault(__webpack_require__(1019));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Breadcrumb["default"].Item = _BreadcrumbItem["default"];
	_Breadcrumb["default"].Separator = _BreadcrumbSeparator["default"];
	var _default = _Breadcrumb["default"];
	exports["default"] = _default;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(293));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _en_US["default"];
	exports["default"] = _default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(187));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Checkbox = /*#__PURE__*/function (_React$Component) {
	  _inherits(Checkbox, _React$Component);
	
	  var _super = _createSuper(Checkbox);
	
	  function Checkbox() {
	    var _this;
	
	    _classCallCheck(this, Checkbox);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.renderCheckbox = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          indeterminate = props.indeterminate,
	          style = props.style,
	          onMouseEnter = props.onMouseEnter,
	          onMouseLeave = props.onMouseLeave,
	          restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);
	
	      var checkboxGroup = context.checkboxGroup;
	      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
	
	      var checkboxProps = _extends({}, restProps);
	
	      if (checkboxGroup) {
	        checkboxProps.onChange = function () {
	          if (restProps.onChange) {
	            restProps.onChange.apply(restProps, arguments);
	          }
	
	          checkboxGroup.toggleOption({
	            label: children,
	            value: props.value
	          });
	        };
	
	        checkboxProps.name = checkboxGroup.name;
	        checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
	        checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
	      }
	
	      var classString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames));
	      var checkboxClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: classString,
	          style: style,
	          onMouseEnter: onMouseEnter,
	          onMouseLeave: onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, checkboxProps, {
	          prefixCls: prefixCls,
	          className: checkboxClass,
	          ref: _this.saveCheckbox
	        })), children !== undefined && /*#__PURE__*/React.createElement("span", null, children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Checkbox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var value = this.props.value;
	
	      var _ref2 = this.context || {},
	          _ref2$checkboxGroup = _ref2.checkboxGroup,
	          checkboxGroup = _ref2$checkboxGroup === void 0 ? {} : _ref2$checkboxGroup;
	
	      if (checkboxGroup.registerValue) {
	        checkboxGroup.registerValue(value);
	      }
	
	      (0, _warning["default"])('checked' in this.props || (this.context || {}).checkboxGroup || !('value' in this.props), 'Checkbox', '`value` is not validate prop, do you mean `checked`?');
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.checkboxGroup, nextContext.checkboxGroup);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref3) {
	      var prevValue = _ref3.value;
	      var value = this.props.value;
	
	      var _ref4 = this.context || {},
	          _ref4$checkboxGroup = _ref4.checkboxGroup,
	          checkboxGroup = _ref4$checkboxGroup === void 0 ? {} : _ref4$checkboxGroup;
	
	      if (value !== prevValue && checkboxGroup.registerValue && checkboxGroup.cancelValue) {
	        checkboxGroup.cancelValue(prevValue);
	        checkboxGroup.registerValue(value);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var value = this.props.value;
	
	      var _ref5 = this.context || {},
	          _ref5$checkboxGroup = _ref5.checkboxGroup,
	          checkboxGroup = _ref5$checkboxGroup === void 0 ? {} : _ref5$checkboxGroup;
	
	      if (checkboxGroup.cancelValue) {
	        checkboxGroup.cancelValue(value);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckbox)
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(React.Component);
	
	Checkbox.__ANT_CHECKBOX = true;
	Checkbox.defaultProps = {
	  indeterminate: false
	};
	Checkbox.contextTypes = {
	  checkboxGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(Checkbox);
	var _default = Checkbox;
	exports["default"] = _default;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _grid = __webpack_require__(232);
	
	var _default = _grid.Col;
	exports["default"] = _default;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = InputIcon;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function InputIcon(props) {
	  var _classNames;
	
	  var suffixIcon = props.suffixIcon,
	      prefixCls = props.prefixCls;
	  return suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	    className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames, "".concat(prefixCls, "-picker-icon"), true), _classNames))
	  }) : /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-picker-icon")
	  }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "calendar",
	    className: "".concat(prefixCls, "-picker-icon")
	  });
	}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDate = formatDate;
	
	// eslint-disable-next-line import/prefer-default-export
	function formatDate(value, format) {
	  if (!value) {
	    return '';
	  }
	
	  if (Array.isArray(format)) {
	    format = format[0];
	  }
	
	  return value.format(format);
	}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _empty = _interopRequireDefault(__webpack_require__(1045));
	
	var _simple = _interopRequireDefault(__webpack_require__(1046));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var defaultEmptyImg = /*#__PURE__*/React.createElement(_empty["default"], null);
	var simpleEmptyImg = /*#__PURE__*/React.createElement(_simple["default"], null);
	
	var Empty = function Empty(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var className = props.className,
	          customizePrefixCls = props.prefixCls,
	          _props$image = props.image,
	          image = _props$image === void 0 ? defaultEmptyImg : _props$image,
	          description = props.description,
	          children = props.children,
	          imageStyle = props.imageStyle,
	          restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);
	
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Empty"
	        }, function (locale) {
	          var prefixCls = getPrefixCls('empty', customizePrefixCls);
	          var des = typeof description !== 'undefined' ? description : locale.description;
	          var alt = typeof des === 'string' ? des : 'empty';
	          var imageNode = null;
	
	          if (typeof image === 'string') {
	            imageNode = /*#__PURE__*/React.createElement("img", {
	              alt: alt,
	              src: image
	            });
	          } else {
	            imageNode = image;
	          }
	
	          return (/*#__PURE__*/React.createElement("div", _extends({
	              className: (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), className)
	            }, restProps), /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-image"),
	              style: imageStyle
	            }, imageNode), des && /*#__PURE__*/React.createElement("p", {
	              className: "".concat(prefixCls, "-description")
	            }, des), children && /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-footer")
	            }, children))
	          );
	        })
	      );
	    })
	  );
	};
	
	Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
	Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
	var _default = Empty;
	exports["default"] = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FIELD_DATA_PROP = exports.FIELD_META_PROP = void 0;
	var FIELD_META_PROP = 'data-__meta';
	exports.FIELD_META_PROP = FIELD_META_PROP;
	var FIELD_DATA_PROP = 'data-__field';
	exports.FIELD_DATA_PROP = FIELD_DATA_PROP;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var FormContext = (0, _createReactContext["default"])({
	  labelAlign: 'right',
	  vertical: false
	});
	var _default = FormContext;
	exports["default"] = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var RowContext = (0, _createReactContext["default"])({});
	var _default = RowContext;
	exports["default"] = _default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _RowContext = _interopRequireDefault(__webpack_require__(568));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);
	
	var Col = /*#__PURE__*/function (_React$Component) {
	  _inherits(Col, _React$Component);
	
	  var _super = _createSuper(Col);
	
	  function Col() {
	    var _this;
	
	    _classCallCheck(this, Col);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderCol = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          span = props.span,
	          order = props.order,
	          offset = props.offset,
	          push = props.push,
	          pull = props.pull,
	          className = props.className,
	          children = props.children,
	          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);
	
	      var prefixCls = getPrefixCls('col', customizePrefixCls);
	      var sizeClassObj = {};
	      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
	        var _extends2;
	
	        var sizeProps = {};
	        var propSize = props[size];
	
	        if (typeof propSize === 'number') {
	          sizeProps.span = propSize;
	        } else if (_typeof(propSize) === 'object') {
	          sizeProps = propSize || {};
	        }
	
	        delete others[size];
	        sizeClassObj = _extends(_extends({}, sizeClassObj), (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
	      });
	      var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
	      return (/*#__PURE__*/React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
	          var gutter = _ref2.gutter;
	          var style = others.style;
	
	          if (gutter) {
	            style = _extends(_extends(_extends({}, gutter[0] > 0 ? {
	              paddingLeft: gutter[0] / 2,
	              paddingRight: gutter[0] / 2
	            } : {}), gutter[1] > 0 ? {
	              paddingTop: gutter[1] / 2,
	              paddingBottom: gutter[1] / 2
	            } : {}), style);
	          }
	
	          return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	              style: style,
	              className: classes
	            }), children)
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Col, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCol)
	      );
	    }
	  }]);
	
	  return Col;
	}(React.Component);
	
	exports["default"] = Col;
	Col.propTypes = {
	  span: PropTypes.number,
	  order: PropTypes.number,
	  offset: PropTypes.number,
	  push: PropTypes.number,
	  pull: PropTypes.number,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  xs: objectOrNumber,
	  sm: objectOrNumber,
	  md: objectOrNumber,
	  lg: objectOrNumber,
	  xl: objectOrNumber,
	  xxl: objectOrNumber
	};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _configProvider = __webpack_require__(13);
	
	var _RowContext = _interopRequireDefault(__webpack_require__(568));
	
	var _type = __webpack_require__(78);
	
	var _responsiveObserve = _interopRequireWildcard(__webpack_require__(554));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom', 'stretch');
	var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');
	
	var Row = /*#__PURE__*/function (_React$Component) {
	  _inherits(Row, _React$Component);
	
	  var _super = _createSuper(Row);
	
	  function Row() {
	    var _this;
	
	    _classCallCheck(this, Row);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      screens: {}
	    };
	
	    _this.renderRow = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          justify = _a.justify,
	          align = _a.align,
	          className = _a.className,
	          style = _a.style,
	          children = _a.children,
	          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);
	
	      var prefixCls = getPrefixCls('row', customizePrefixCls);
	
	      var gutter = _this.getGutter();
	
	      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);
	
	      var rowStyle = _extends(_extends(_extends({}, gutter[0] > 0 ? {
	        marginLeft: gutter[0] / -2,
	        marginRight: gutter[0] / -2
	      } : {}), gutter[1] > 0 ? {
	        marginTop: gutter[1] / -2,
	        marginBottom: gutter[1] / -2
	      } : {}), style);
	
	      var otherProps = _extends({}, others);
	
	      delete otherProps.gutter;
	      return (/*#__PURE__*/React.createElement(_RowContext["default"].Provider, {
	          value: {
	            gutter: gutter
	          }
	        }, /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
	          className: classes,
	          style: rowStyle
	        }), children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Row, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.token = _responsiveObserve["default"].subscribe(function (screens) {
	        var gutter = _this2.props.gutter;
	
	        if (_typeof(gutter) === 'object' || Array.isArray(gutter) && (_typeof(gutter[0]) === 'object' || _typeof(gutter[1]) === 'object')) {
	          _this2.setState({
	            screens: screens
	          });
	        }
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _responsiveObserve["default"].unsubscribe(this.token);
	    }
	  }, {
	    key: "getGutter",
	    value: function getGutter() {
	      var results = [0, 0];
	      var gutter = this.props.gutter;
	      var screens = this.state.screens;
	      var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
	      normalizedGutter.forEach(function (g, index) {
	        if (_typeof(g) === 'object') {
	          for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
	            var breakpoint = _responsiveObserve.responsiveArray[i];
	
	            if (screens[breakpoint] && g[breakpoint] !== undefined) {
	              results[index] = g[breakpoint];
	              break;
	            }
	          }
	        } else {
	          results[index] = g || 0;
	        }
	      });
	      return results;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRow)
	      );
	    }
	  }]);
	
	  return Row;
	}(React.Component);
	
	exports["default"] = Row;
	Row.defaultProps = {
	  gutter: 0
	};
	Row.propTypes = {
	  type: PropTypes.oneOf(['flex']),
	  align: PropTypes.oneOf(RowAligns),
	  justify: PropTypes.oneOf(RowJustify),
	  className: PropTypes.string,
	  children: PropTypes.node,
	  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
	  prefixCls: PropTypes.string
	};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasPrefixSuffix = hasPrefixSuffix;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _type = __webpack_require__(78);
	
	var _Input = __webpack_require__(196);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ClearableInputType = (0, _type.tuple)('text', 'input');
	
	function hasPrefixSuffix(props) {
	  return !!(props.prefix || props.suffix || props.allowClear);
	}
	
	var ClearableLabeledInput = /*#__PURE__*/function (_React$Component) {
	  _inherits(ClearableLabeledInput, _React$Component);
	
	  var _super = _createSuper(ClearableLabeledInput);
	
	  function ClearableLabeledInput() {
	    _classCallCheck(this, ClearableLabeledInput);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ClearableLabeledInput, [{
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var _this$props = this.props,
	          allowClear = _this$props.allowClear,
	          value = _this$props.value,
	          disabled = _this$props.disabled,
	          readOnly = _this$props.readOnly,
	          inputType = _this$props.inputType,
	          handleReset = _this$props.handleReset;
	
	      if (!allowClear || disabled || readOnly || value === undefined || value === null || value === '') {
	        return null;
	      }
	
	      var className = inputType === ClearableInputType[0] ? "".concat(prefixCls, "-textarea-clear-icon") : "".concat(prefixCls, "-clear-icon");
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          theme: "filled",
	          onClick: handleReset,
	          className: className,
	          role: "button"
	        })
	      );
	    }
	  }, {
	    key: "renderSuffix",
	    value: function renderSuffix(prefixCls) {
	      var _this$props2 = this.props,
	          suffix = _this$props2.suffix,
	          allowClear = _this$props2.allowClear;
	
	      if (suffix || allowClear) {
	        return (/*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-suffix")
	          }, this.renderClearIcon(prefixCls), suffix)
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderLabeledIcon",
	    value: function renderLabeledIcon(prefixCls, element) {
	      var _classNames;
	
	      var props = this.props;
	      var suffix = this.renderSuffix(prefixCls);
	
	      if (!hasPrefixSuffix(props)) {
	        return (/*#__PURE__*/React.cloneElement(element, {
	            value: props.value
	          })
	        );
	      }
	
	      var prefix = props.prefix ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-prefix")
	      }, props.prefix) : null;
	      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), props.suffix && props.allowClear && this.props.value), _classNames));
	      return (/*#__PURE__*/React.createElement("span", {
	          className: affixWrapperCls,
	          style: props.style
	        }, prefix, /*#__PURE__*/React.cloneElement(element, {
	          style: null,
	          value: props.value,
	          className: (0, _Input.getInputClassName)(prefixCls, props.size, props.disabled)
	        }), suffix)
	      );
	    }
	  }, {
	    key: "renderInputWithLabel",
	    value: function renderInputWithLabel(prefixCls, labeledElement) {
	      var _classNames3;
	
	      var _this$props3 = this.props,
	          addonBefore = _this$props3.addonBefore,
	          addonAfter = _this$props3.addonAfter,
	          style = _this$props3.style,
	          size = _this$props3.size,
	          className = _this$props3.className; // Not wrap when there is not addons
	
	      if (!addonBefore && !addonAfter) {
	        return labeledElement;
	      }
	
	      var wrapperClassName = "".concat(prefixCls, "-group");
	      var addonClassName = "".concat(wrapperClassName, "-addon");
	      var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonBefore) : null;
	      var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonAfter) : null;
	      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
	      var mergedGroupClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
	      // and put style prop in wrapper
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: mergedGroupClassName,
	          style: style
	        }, /*#__PURE__*/React.createElement("span", {
	          className: mergedWrapperClassName
	        }, addonBeforeNode, /*#__PURE__*/React.cloneElement(labeledElement, {
	          style: null
	        }), addonAfterNode))
	      );
	    }
	  }, {
	    key: "renderTextAreaWithClearIcon",
	    value: function renderTextAreaWithClearIcon(prefixCls, element) {
	      var _this$props4 = this.props,
	          value = _this$props4.value,
	          allowClear = _this$props4.allowClear,
	          className = _this$props4.className,
	          style = _this$props4.style;
	
	      if (!allowClear) {
	        return (/*#__PURE__*/React.cloneElement(element, {
	            value: value
	          })
	        );
	      }
	
	      var affixWrapperCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"));
	      return (/*#__PURE__*/React.createElement("span", {
	          className: affixWrapperCls,
	          style: style
	        }, /*#__PURE__*/React.cloneElement(element, {
	          style: null,
	          value: value
	        }), this.renderClearIcon(prefixCls))
	      );
	    }
	  }, {
	    key: "renderClearableLabeledInput",
	    value: function renderClearableLabeledInput() {
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          inputType = _this$props5.inputType,
	          element = _this$props5.element;
	
	      if (inputType === ClearableInputType[0]) {
	        return this.renderTextAreaWithClearIcon(prefixCls, element);
	      }
	
	      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderClearableLabeledInput();
	    }
	  }]);
	
	  return ClearableLabeledInput;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ClearableLabeledInput);
	var _default = ClearableLabeledInput;
	exports["default"] = _default;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(571));
	
	var _ResizableTextArea = _interopRequireDefault(__webpack_require__(1056));
	
	var _configProvider = __webpack_require__(13);
	
	var _Input = __webpack_require__(196);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var TextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(TextArea, _React$Component);
	
	  var _super = _createSuper(TextArea);
	
	  function TextArea(props) {
	    var _this;
	
	    _classCallCheck(this, TextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (resizableTextArea) {
	      _this.resizableTextArea = resizableTextArea;
	    };
	
	    _this.saveClearableInput = function (clearableInput) {
	      _this.clearableInput = clearableInput;
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, function () {
	        _this.resizableTextArea.resizeTextarea();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          onPressEnter = _this$props.onPressEnter,
	          onKeyDown = _this$props.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.resizableTextArea.renderTextArea();
	
	        _this.focus();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.renderTextArea = function (prefixCls) {
	      return (/*#__PURE__*/React.createElement(_ResizableTextArea["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          onKeyDown: _this.handleKeyDown,
	          onChange: _this.handleChange,
	          ref: _this.saveTextArea
	        }))
	      );
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          inputType: "text",
	          value: (0, _Input.fixControlledValue)(value),
	          element: _this.renderTextArea(prefixCls),
	          handleReset: _this.handleReset,
	          ref: _this.saveClearableInput
	        }))
	      );
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(TextArea, [{
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.resizableTextArea.textArea.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.resizableTextArea.textArea.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(TextArea);
	var _default = TextArea;
	exports["default"] = _default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.LayoutContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || (typeof obj === "undefined" ? "undefined" : _typeof2(obj)) !== "object" && typeof obj !== "function") {
	    return { default: obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj.default = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var LayoutContext = (0, _createReactContext["default"])({
	  siderHook: {
	    addSider: function addSider() {
	      return null;
	    },
	    removeSider: function removeSider() {
	      return null;
	    }
	  }
	});
	exports.LayoutContext = LayoutContext;
	
	function generator(_ref) {
	  var suffixCls = _ref.suffixCls,
	      tagName = _ref.tagName,
	      displayName = _ref.displayName;
	  return function (BasicComponent) {
	    var _a;
	
	    return _a = /*#__PURE__*/function (_React$Component) {
	      _inherits(Adapter, _React$Component);
	
	      var _super = _createSuper(Adapter);
	
	      function Adapter() {
	        var _this;
	
	        _classCallCheck(this, Adapter);
	
	        _this = _super.apply(this, arguments);
	
	        _this.renderComponent = function (_ref2) {
	          var getPrefixCls = _ref2.getPrefixCls;
	          var customizePrefixCls = _this.props.prefixCls;
	          var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
	          return (/*#__PURE__*/React.createElement(BasicComponent, _extends({
	              prefixCls: prefixCls,
	              tagName: tagName
	            }, _this.props))
	          );
	        };
	
	        return _this;
	      }
	
	      _createClass(Adapter, [{
	        key: "render",
	        value: function render() {
	          return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	          );
	        }
	      }]);
	
	      return Adapter;
	    }(React.Component), _a.displayName = displayName, _a;
	  };
	}
	
	var Basic = function Basic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      children = props.children,
	      tagName = props.tagName,
	      others = __rest(props, ["prefixCls", "className", "children", "tagName"]);
	
	  var classString = (0, _classnames["default"])(className, prefixCls);
	  return (/*#__PURE__*/React.createElement(tagName, _extends({
	      className: classString
	    }, others), children)
	  );
	};
	
	var BasicLayout = /*#__PURE__*/function (_React$Component2) {
	  _inherits(BasicLayout, _React$Component2);
	
	  var _super2 = _createSuper(BasicLayout);
	
	  function BasicLayout() {
	    var _this2;
	
	    _classCallCheck(this, BasicLayout);
	
	    _this2 = _super2.apply(this, arguments);
	    _this2.state = {
	      siders: []
	    };
	    return _this2;
	  }
	
	  _createClass(BasicLayout, [{
	    key: "getSiderHook",
	    value: function getSiderHook() {
	      var _this3 = this;
	
	      return {
	        addSider: function addSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: [].concat(_toConsumableArray(state.siders), [id])
	            };
	          });
	        },
	        removeSider: function removeSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: state.siders.filter(function (currentId) {
	                return currentId !== id;
	              })
	            };
	          });
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          prefixCls = _a.prefixCls,
	          className = _a.className,
	          children = _a.children,
	          hasSider = _a.hasSider,
	          Tag = _a.tagName,
	          others = __rest(_a, ["prefixCls", "className", "children", "hasSider", "tagName"]);
	
	      var classString = (0, _classnames["default"])(className, prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : this.state.siders.length > 0));
	      return (/*#__PURE__*/React.createElement(LayoutContext.Provider, {
	          value: {
	            siderHook: this.getSiderHook()
	          }
	        }, /*#__PURE__*/React.createElement(Tag, _extends({
	          className: classString
	        }, others), children))
	      );
	    }
	  }]);
	
	  return BasicLayout;
	}(React.Component);
	
	var Layout = generator({
	  suffixCls: 'layout',
	  tagName: 'section',
	  displayName: 'Layout'
	})(BasicLayout);
	var Header = generator({
	  suffixCls: 'layout-header',
	  tagName: 'header',
	  displayName: 'Header'
	})(Basic);
	var Footer = generator({
	  suffixCls: 'layout-footer',
	  tagName: 'footer',
	  displayName: 'Footer'
	})(Basic);
	var Content = generator({
	  suffixCls: 'layout-content',
	  tagName: 'main',
	  displayName: 'Content'
	})(Basic);
	Layout.Header = Header;
	Layout.Footer = Footer;
	Layout.Content = Content;
	var _default = Layout;
	exports["default"] = _default;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ANT_MARK = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	var _locale = __webpack_require__(300);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ANT_MARK = 'internalMark';
	exports.ANT_MARK = ANT_MARK;
	
	function setMomentLocale(locale) {
	  if (locale && locale.locale) {
	    (0, _interopDefault["default"])(moment).locale(locale.locale);
	  } else {
	    (0, _interopDefault["default"])(moment).locale('en');
	  }
	}
	
	var LocaleProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(LocaleProvider, _React$Component);
	
	  var _super = _createSuper(LocaleProvider);
	
	  function LocaleProvider(props) {
	    var _this;
	
	    _classCallCheck(this, LocaleProvider);
	
	    _this = _super.call(this, props);
	    setMomentLocale(props.locale);
	    (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
	    (0, _warning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
	    return _this;
	  }
	
	  _createClass(LocaleProvider, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        antLocale: _extends(_extends({}, this.props.locale), {
	          exist: true
	        })
	      };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var locale = this.props.locale;
	
	      if (prevProps.locale !== locale) {
	        setMomentLocale(locale);
	        (0, _locale.changeConfirmLocale)(locale && locale.Modal);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _locale.changeConfirmLocale)();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return LocaleProvider;
	}(React.Component);
	
	exports["default"] = LocaleProvider;
	LocaleProvider.propTypes = {
	  locale: PropTypes.object
	};
	LocaleProvider.defaultProps = {
	  locale: {}
	};
	LocaleProvider.childContextTypes = {
	  antLocale: PropTypes.object
	};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.destroyFns = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcDialog = _interopRequireDefault(__webpack_require__(463));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _locale = __webpack_require__(300);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _button = _interopRequireDefault(__webpack_require__(135));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var mousePosition;
	var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795
	
	exports.destroyFns = destroyFns;
	
	var getClickPosition = function getClickPosition(e) {
	  mousePosition = {
	    x: e.pageX,
	    y: e.pageY
	  }; // 100ms 内发生过点击事件，则从点击位置动画展示
	  // 否则直接 zoom 展示
	  // 这样可以兼容非点击方式展开
	
	  setTimeout(function () {
	    return mousePosition = null;
	  }, 100);
	}; // 只有点击事件支持从鼠标位置动画展开
	
	
	if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	  (0, _addEventListener["default"])(document.documentElement, 'click', getClickPosition);
	}
	
	var Modal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  var _super = _createSuper(Modal);
	
	  function Modal() {
	    var _this;
	
	    _classCallCheck(this, Modal);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleCancel = function (e) {
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel(e);
	      }
	    };
	
	    _this.handleOk = function (e) {
	      var onOk = _this.props.onOk;
	
	      if (onOk) {
	        onOk(e);
	      }
	    };
	
	    _this.renderFooter = function (locale) {
	      var _this$props = _this.props,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          cancelText = _this$props.cancelText,
	          confirmLoading = _this$props.confirmLoading;
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.handleCancel
	        }, _this.props.cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	          type: okType,
	          loading: confirmLoading,
	          onClick: _this.handleOk
	        }, _this.props.okButtonProps), okText || locale.okText))
	      );
	    };
	
	    _this.renderModal = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          footer = _a.footer,
	          visible = _a.visible,
	          wrapClassName = _a.wrapClassName,
	          centered = _a.centered,
	          getContainer = _a.getContainer,
	          closeIcon = _a.closeIcon,
	          restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon"]);
	
	      var prefixCls = getPrefixCls('modal', customizePrefixCls);
	      var defaultFooter = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Modal",
	        defaultLocale: (0, _locale.getConfirmLocale)()
	      }, _this.renderFooter);
	      var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-x")
	      }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-close-icon"),
	        type: "close"
	      }));
	      return (/*#__PURE__*/React.createElement(_rcDialog["default"], _extends({}, restProps, {
	          getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
	          prefixCls: prefixCls,
	          wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
	          footer: footer === undefined ? defaultFooter : footer,
	          visible: visible,
	          mousePosition: mousePosition,
	          onClose: _this.handleCancel,
	          closeIcon: closeIconToRender
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderModal)
	      );
	    }
	  }]);
	
	  return Modal;
	}(React.Component);
	
	exports["default"] = Modal;
	Modal.defaultProps = {
	  width: 520,
	  transitionName: 'zoom',
	  maskTransitionName: 'fade',
	  confirmLoading: false,
	  visible: false,
	  okType: 'primary'
	};
	Modal.propTypes = {
	  prefixCls: PropTypes.string,
	  onOk: PropTypes.func,
	  onCancel: PropTypes.func,
	  okText: PropTypes.node,
	  cancelText: PropTypes.node,
	  centered: PropTypes.bool,
	  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  confirmLoading: PropTypes.bool,
	  visible: PropTypes.bool,
	  footer: PropTypes.node,
	  title: PropTypes.node,
	  closable: PropTypes.bool,
	  closeIcon: PropTypes.node
	};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _progress = _interopRequireDefault(__webpack_require__(1079));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _progress["default"];
	exports["default"] = _default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _grid = __webpack_require__(232);
	
	var _default = _grid.Row;
	exports["default"] = _default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _context = __webpack_require__(231);
	
	var _Number = _interopRequireDefault(__webpack_require__(1093));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Statistic = function Statistic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      style = props.style,
	      valueStyle = props.valueStyle,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      title = props.title,
	      valueRender = props.valueRender,
	      prefix = props.prefix,
	      suffix = props.suffix;
	  var valueNode = /*#__PURE__*/React.createElement(_Number["default"], _extends({}, props, {
	    value: value
	  }));
	
	  if (valueRender) {
	    valueNode = valueRender(valueNode);
	  }
	
	  return (/*#__PURE__*/React.createElement("div", {
	      className: (0, _classnames["default"])(prefixCls, className),
	      style: style
	    }, title && /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-title")
	    }, title), /*#__PURE__*/React.createElement("div", {
	      style: valueStyle,
	      className: "".concat(prefixCls, "-content")
	    }, prefix && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-prefix")
	    }, prefix), valueNode, suffix && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-suffix")
	    }, suffix)))
	  );
	};
	
	Statistic.defaultProps = {
	  decimalSeparator: '.',
	  groupSeparator: ','
	};
	var WrapperStatistic = (0, _context.withConfigConsumer)({
	  prefixCls: 'statistic'
	})(Statistic);
	var _default = WrapperStatistic;
	exports["default"] = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flatArray = flatArray;
	exports.treeMap = treeMap;
	exports.flatFilter = flatFilter;
	exports.normalizeColumns = normalizeColumns;
	exports.generateValueMaps = generateValueMaps;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function flatArray() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
	  var result = [];
	
	  var loop = function loop(array) {
	    array.forEach(function (item) {
	      if (item[childrenName]) {
	        var newItem = _extends({}, item);
	
	        delete newItem[childrenName];
	        result.push(newItem);
	
	        if (item[childrenName].length > 0) {
	          loop(item[childrenName]);
	        }
	      } else {
	        result.push(item);
	      }
	    });
	  };
	
	  loop(data);
	  return result;
	}
	
	function treeMap(tree, mapper) {
	  var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	  return tree.map(function (node, index) {
	    var extra = {};
	
	    if (node[childrenName]) {
	      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
	    }
	
	    return _extends(_extends({}, mapper(node, index)), extra);
	  });
	}
	
	function flatFilter(tree, callback) {
	  return tree.reduce(function (acc, node) {
	    if (callback(node)) {
	      acc.push(node);
	    }
	
	    if (node.children) {
	      var children = flatFilter(node.children, callback);
	      acc.push.apply(acc, _toConsumableArray(children));
	    }
	
	    return acc;
	  }, []);
	}
	
	function normalizeColumns(elements) {
	  var columns = [];
	  React.Children.forEach(elements, function (element) {
	    if (! /*#__PURE__*/React.isValidElement(element)) {
	      return;
	    }
	
	    var column = _extends({}, element.props);
	
	    if (element.key) {
	      column.key = element.key;
	    }
	
	    if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
	      column.children = normalizeColumns(column.children);
	    }
	
	    columns.push(column);
	  });
	  return columns;
	}
	
	function generateValueMaps(items) {
	  var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (items || []).forEach(function (_ref) {
	    var value = _ref.value,
	        children = _ref.children;
	    maps[value.toString()] = value;
	    generateValueMaps(children, maps);
	  });
	  return maps;
	}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _rcTabs = _interopRequireWildcard(__webpack_require__(481));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(504));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _TabBar = _interopRequireDefault(__webpack_require__(1108));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _styleChecker = __webpack_require__(555);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Tabs = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  var _super = _createSuper(Tabs);
	
	  function Tabs() {
	    var _this;
	
	    _classCallCheck(this, Tabs);
	
	    _this = _super.apply(this, arguments);
	
	    _this.removeTab = function (targetKey, e) {
	      e.stopPropagation();
	
	      if (!targetKey) {
	        return;
	      }
	
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'remove');
	      }
	    };
	
	    _this.handleChange = function (activeKey) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(activeKey);
	      }
	    };
	
	    _this.createNewTab = function (targetKey) {
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'add');
	      }
	    };
	
	    _this.renderTabs = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          size = _this$props.size,
	          _this$props$type = _this$props.type,
	          type = _this$props$type === void 0 ? 'line' : _this$props$type,
	          tabPosition = _this$props.tabPosition,
	          children = _this$props.children,
	          _this$props$animated = _this$props.animated,
	          animated = _this$props$animated === void 0 ? true : _this$props$animated,
	          hideAdd = _this$props.hideAdd;
	      var tabBarExtraContent = _this.props.tabBarExtraContent;
	      var tabPaneAnimated = _typeof(animated) === 'object' ? animated.tabPane : animated; // card tabs should not have animation
	
	      if (type !== 'line') {
	        tabPaneAnimated = 'animated' in _this.props ? tabPaneAnimated : false;
	      }
	
	      (0, _warning["default"])(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), 'Tabs', "`type=card|editable-card` doesn't have small or large size, it's by design.");
	      var prefixCls = getPrefixCls('tabs', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), tabPosition === 'left' || tabPosition === 'right'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card"), type.indexOf('card') >= 0), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), true), _defineProperty(_classNames, "".concat(prefixCls, "-no-animation"), !tabPaneAnimated), _classNames)); // only card type tabs can be added and closed
	
	      var childrenWithClose = [];
	
	      if (type === 'editable-card') {
	        childrenWithClose = [];
	        React.Children.forEach(children, function (child, index) {
	          if (! /*#__PURE__*/React.isValidElement(child)) return child;
	          var closable = child.props.closable;
	          closable = typeof closable === 'undefined' ? true : closable;
	          var closeIcon = closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "close",
	            className: "".concat(prefixCls, "-close-x"),
	            onClick: function onClick(e) {
	              return _this.removeTab(child.key, e);
	            }
	          }) : null;
	          childrenWithClose.push( /*#__PURE__*/React.cloneElement(child, {
	            tab: /*#__PURE__*/React.createElement("div", {
	              className: closable ? undefined : "".concat(prefixCls, "-tab-unclosable")
	            }, child.props.tab, closeIcon),
	            key: child.key || index
	          }));
	        }); // Add new tab handler
	
	        if (!hideAdd) {
	          tabBarExtraContent = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "plus",
	            className: "".concat(prefixCls, "-new-tab"),
	            onClick: _this.createNewTab
	          }), tabBarExtraContent);
	        }
	      }
	
	      tabBarExtraContent = tabBarExtraContent ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra-content")
	      }, tabBarExtraContent) : null;
	
	      var tabBarProps = __rest(_this.props, []);
	
	      var contentCls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-content"), type.indexOf('card') >= 0 && "".concat(prefixCls, "-card-content"));
	      return (/*#__PURE__*/React.createElement(_rcTabs["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: cls,
	          tabBarPosition: tabPosition,
	          renderTabBar: function renderTabBar() {
	            return (/*#__PURE__*/React.createElement(_TabBar["default"], _extends({}, (0, _omit["default"])(tabBarProps, ['className']), {
	                tabBarExtraContent: tabBarExtraContent
	              }))
	            );
	          },
	          renderTabContent: function renderTabContent() {
	            return (/*#__PURE__*/React.createElement(_TabContent["default"], {
	                className: contentCls,
	                animated: tabPaneAnimated,
	                animatedWithMargin: true
	              })
	            );
	          },
	          onChange: _this.handleChange
	        }), childrenWithClose.length > 0 ? childrenWithClose : children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var NO_FLEX = ' no-flex';
	      var tabNode = ReactDOM.findDOMNode(this);
	
	      if (tabNode && !_styleChecker.isFlexSupported && tabNode.className.indexOf(NO_FLEX) === -1) {
	        tabNode.className += NO_FLEX;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTabs)
	      );
	    }
	  }]);
	
	  return Tabs;
	}(React.Component);
	
	exports["default"] = Tabs;
	Tabs.TabPane = _rcTabs.TabPane;
	Tabs.defaultProps = {
	  hideAdd: false,
	  tabPosition: 'top'
	};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _CheckableTag = _interopRequireDefault(__webpack_require__(1109));
	
	var _configProvider = __webpack_require__(13);
	
	var _colors = __webpack_require__(550);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _wave = _interopRequireDefault(__webpack_require__(292));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var PresetColorRegex = new RegExp("^(".concat(_colors.PresetColorTypes.join('|'), ")(-inverse)?$"));
	
	var Tag = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tag, _React$Component);
	
	  var _super = _createSuper(Tag);
	
	  function Tag(props) {
	    var _this;
	
	    _classCallCheck(this, Tag);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      visible: true
	    };
	
	    _this.handleIconClick = function (e) {
	      e.stopPropagation();
	
	      _this.setVisible(false, e);
	    };
	
	    _this.renderTag = function (configProps) {
	      var _a = _this.props,
	          children = _a.children,
	          otherProps = __rest(_a, ["children"]);
	
	      var isNeedWave = 'onClick' in otherProps || children && children.type === 'a';
	      var tagProps = (0, _omit["default"])(otherProps, ['onClose', 'afterClose', 'color', 'visible', 'closable', 'prefixCls']);
	      return isNeedWave ? /*#__PURE__*/React.createElement(_wave["default"], null, /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
	        className: _this.getTagClassName(configProps),
	        style: _this.getTagStyle()
	      }), children, _this.renderCloseIcon())) : /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
	        className: _this.getTagClassName(configProps),
	        style: _this.getTagStyle()
	      }), children, _this.renderCloseIcon());
	    };
	
	    (0, _warning["default"])(!('afterClose' in props), 'Tag', "'afterClose' will be deprecated, please use 'onClose', we will remove this in the next version.");
	    return _this;
	  }
	
	  _createClass(Tag, [{
	    key: "getTagStyle",
	    value: function getTagStyle() {
	      var _this$props = this.props,
	          color = _this$props.color,
	          style = _this$props.style;
	      var isPresetColor = this.isPresetColor();
	      return _extends({
	        backgroundColor: color && !isPresetColor ? color : undefined
	      }, style);
	    }
	  }, {
	    key: "getTagClassName",
	    value: function getTagClassName(_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          color = _this$props2.color;
	      var visible = this.state.visible;
	      var isPresetColor = this.isPresetColor();
	      var prefixCls = getPrefixCls('tag', customizePrefixCls);
	      return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-has-color"), color && !isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-hidden"), !visible), _classNames), className);
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible, e) {
	      var _this$props3 = this.props,
	          onClose = _this$props3.onClose,
	          afterClose = _this$props3.afterClose;
	
	      if (onClose) {
	        onClose(e);
	      }
	
	      if (afterClose && !onClose) {
	        // next version remove.
	        afterClose();
	      }
	
	      if (e.defaultPrevented) {
	        return;
	      }
	
	      if (!('visible' in this.props)) {
	        this.setState({
	          visible: visible
	        });
	      }
	    }
	  }, {
	    key: "isPresetColor",
	    value: function isPresetColor() {
	      var color = this.props.color;
	
	      if (!color) {
	        return false;
	      }
	
	      return PresetColorRegex.test(color);
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var closable = this.props.closable;
	      return closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        onClick: this.handleIconClick
	      }) : null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTag)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tag;
	}(React.Component);
	
	Tag.CheckableTag = _CheckableTag["default"];
	Tag.defaultProps = {
	  closable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Tag);
	var _default = Tag;
	exports["default"] = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(482));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _configProvider = __webpack_require__(13);
	
	var _en_US = _interopRequireDefault(__webpack_require__(304));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function generateShowHourMinuteSecond(format) {
	  // Ref: http://momentjs.com/docs/#/parsing/string-format/
	  return {
	    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
	    showMinute: format.indexOf('m') > -1,
	    showSecond: format.indexOf('s') > -1
	  };
	}
	
	var TimePicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(TimePicker, _React$Component);
	
	  var _super = _createSuper(TimePicker);
	
	  function TimePicker(props) {
	    var _this;
	
	    _classCallCheck(this, TimePicker);
	
	    _this = _super.call(this, props);
	
	    _this.getDefaultLocale = function () {
	      var defaultLocale = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	      return defaultLocale;
	    };
	
	    _this.handleOpenClose = function (_ref) {
	      var open = _ref.open;
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.saveTimePicker = function (timePickerRef) {
	      _this.timePickerRef = timePickerRef;
	    };
	
	    _this.handleChange = function (value) {
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          _this$props$format = _this$props.format,
	          format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;
	
	      if (onChange) {
	        onChange(value, value && value.format(format) || '');
	      }
	    };
	
	    _this.renderTimePicker = function (locale) {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	          var getContextPopupContainer = _ref2.getPopupContainer,
	              getPrefixCls = _ref2.getPrefixCls;
	
	          var _a = _this.props,
	              getPopupContainer = _a.getPopupContainer,
	              customizePrefixCls = _a.prefixCls,
	              className = _a.className,
	              addon = _a.addon,
	              placeholder = _a.placeholder,
	              props = __rest(_a, ["getPopupContainer", "prefixCls", "className", "addon", "placeholder"]);
	
	          var size = props.size;
	          var pickerProps = (0, _omit["default"])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);
	
	          var format = _this.getDefaultFormat();
	
	          var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
	          var pickerClassName = (0, _classnames["default"])(className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	
	          var pickerAddon = function pickerAddon(panel) {
	            return addon ? /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-panel-addon")
	            }, addon(panel)) : null;
	          };
	
	          return (/*#__PURE__*/React.createElement(_TimePicker["default"], _extends({}, generateShowHourMinuteSecond(format), pickerProps, {
	              allowEmpty: _this.getAllowClear(),
	              prefixCls: prefixCls,
	              getPopupContainer: getPopupContainer || getContextPopupContainer,
	              ref: _this.saveTimePicker,
	              format: format,
	              className: pickerClassName,
	              value: _this.state.value,
	              placeholder: placeholder === undefined ? locale.placeholder : placeholder,
	              onChange: _this.handleChange,
	              onOpen: _this.handleOpenClose,
	              onClose: _this.handleOpenClose,
	              addon: pickerAddon,
	              inputIcon: _this.renderInputIcon(prefixCls),
	              clearIcon: _this.renderClearIcon(prefixCls)
	            }))
	          );
	        })
	      );
	    };
	
	    var value = props.value || props.defaultValue;
	
	    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
	    }
	
	    _this.state = {
	      value: value
	    };
	    (0, _warning["default"])(!('allowEmpty' in props), 'TimePicker', '`allowEmpty` is deprecated. Please use `allowClear` instead.');
	    return _this;
	  }
	
	  _createClass(TimePicker, [{
	    key: "getDefaultFormat",
	    value: function getDefaultFormat() {
	      var _this$props2 = this.props,
	          format = _this$props2.format,
	          use12Hours = _this$props2.use12Hours;
	
	      if (format) {
	        return format;
	      }
	
	      if (use12Hours) {
	        return 'h:mm:ss a';
	      }
	
	      return 'HH:mm:ss';
	    }
	  }, {
	    key: "getAllowClear",
	    value: function getAllowClear() {
	      var _this$props3 = this.props,
	          allowClear = _this$props3.allowClear,
	          allowEmpty = _this$props3.allowEmpty;
	
	      if ('allowClear' in this.props) {
	        return allowClear;
	      }
	
	      return allowEmpty;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.timePickerRef.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.timePickerRef.blur();
	    }
	  }, {
	    key: "renderInputIcon",
	    value: function renderInputIcon(prefixCls) {
	      var suffixIcon = this.props.suffixIcon;
	      var clockIcon = suffixIcon && /*#__PURE__*/React.isValidElement(suffixIcon) && /*#__PURE__*/React.cloneElement(suffixIcon, {
	        className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-clock-icon"))
	      }) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "clock-circle",
	        className: "".concat(prefixCls, "-clock-icon")
	      });
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-icon")
	        }, clockIcon)
	      );
	    }
	  }, {
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var clearIcon = this.props.clearIcon;
	      var clearIconPrefixCls = "".concat(prefixCls, "-clear");
	
	      if (clearIcon && /*#__PURE__*/React.isValidElement(clearIcon)) {
	        return (/*#__PURE__*/React.cloneElement(clearIcon, {
	            className: (0, _classnames["default"])(clearIcon.props.className, clearIconPrefixCls)
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          className: clearIconPrefixCls,
	          theme: "filled"
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "TimePicker",
	          defaultLocale: this.getDefaultLocale()
	        }, this.renderTimePicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TimePicker;
	}(React.Component);
	
	TimePicker.defaultProps = {
	  align: {
	    offset: [0, -2]
	  },
	  disabledHours: undefined,
	  disabledMinutes: undefined,
	  disabledSeconds: undefined,
	  hideDisabledOptions: false,
	  placement: 'bottomLeft',
	  transitionName: 'slide-up',
	  focusOnOpen: true
	};
	(0, _reactLifecyclesCompat.polyfill)(TimePicker);
	var _default = TimePicker;
	exports["default"] = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _input = _interopRequireDefault(__webpack_require__(233));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleChange = function (e) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.handleClear = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          handleClear = _this$props.handleClear,
	          disabled = _this$props.disabled;
	
	      if (!disabled && handleClear) {
	        handleClear(e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          placeholder = _this$props2.placeholder,
	          value = _this$props2.value,
	          prefixCls = _this$props2.prefixCls,
	          disabled = _this$props2.disabled;
	      var icon = value && value.length > 0 ? /*#__PURE__*/React.createElement("a", {
	        href: "#",
	        className: "".concat(prefixCls, "-action"),
	        onClick: this.handleClear
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled"
	      })) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-action")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "search"
	      }));
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_input["default"], {
	          placeholder: placeholder,
	          className: prefixCls,
	          value: value,
	          onChange: this.handleChange,
	          disabled: disabled
	        }), icon)
	      );
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  placeholder: ''
	};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcTree = _interopRequireWildcard(__webpack_require__(492));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _DirectoryTree = _interopRequireDefault(__webpack_require__(1120));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _motion = _interopRequireDefault(__webpack_require__(552));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Tree = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tree, _React$Component);
	
	  var _super = _createSuper(Tree);
	
	  function Tree() {
	    var _this;
	
	    _classCallCheck(this, Tree);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSwitcherIcon = function (prefixCls, switcherIcon, _ref) {
	      var isLeaf = _ref.isLeaf,
	          expanded = _ref.expanded,
	          loading = _ref.loading;
	      var showLine = _this.props.showLine;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading",
	            className: "".concat(prefixCls, "-switcher-loading-icon")
	          })
	        );
	      }
	
	      if (isLeaf) {
	        return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "file",
	          className: "".concat(prefixCls, "-switcher-line-icon")
	        }) : null;
	      }
	
	      var switcherCls = "".concat(prefixCls, "-switcher-icon");
	
	      if (switcherIcon) {
	        return (/*#__PURE__*/React.cloneElement(switcherIcon, {
	            className: (0, _classnames["default"])(switcherIcon.props.className || '', switcherCls)
	          })
	        );
	      }
	
	      return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: expanded ? 'minus-square' : 'plus-square',
	        className: "".concat(prefixCls, "-switcher-line-icon"),
	        theme: "outlined"
	      }) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "caret-down",
	        className: switcherCls,
	        theme: "filled"
	      });
	    };
	
	    _this.setTreeRef = function (node) {
	      _this.tree = node;
	    };
	
	    _this.renderTree = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          showIcon = props.showIcon,
	          _switcherIcon = props.switcherIcon,
	          blockNode = props.blockNode,
	          children = props.children;
	      var checkable = props.checkable;
	      var prefixCls = getPrefixCls('tree', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_rcTree["default"], _extends({
	          ref: _this.setTreeRef
	        }, props, {
	          prefixCls: prefixCls,
	          className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-icon-hide"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-block-node"), blockNode), _classNames)),
	          checkable: checkable ? /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-checkbox-inner")
	          }) : checkable,
	          switcherIcon: function switcherIcon(nodeProps) {
	            return _this.renderSwitcherIcon(prefixCls, _switcherIcon, nodeProps);
	          }
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Tree, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTree)
	      );
	    }
	  }]);
	
	  return Tree;
	}(React.Component);
	
	exports["default"] = Tree;
	Tree.TreeNode = _rcTree.TreeNode;
	Tree.DirectoryTree = _DirectoryTree["default"];
	Tree.defaultProps = {
	  checkable: false,
	  showIcon: false,
	  motion: _extends(_extends({}, _motion["default"]), {
	    motionAppear: false
	  }),
	  blockNode: false
	};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _ref2 = __webpack_require__(1005);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Typography = function Typography(_a, ref) {
	  var customizePrefixCls = _a.prefixCls,
	      _a$component = _a.component,
	      component = _a$component === void 0 ? 'article' : _a$component,
	      className = _a.className,
	      ariaLabel = _a['aria-label'],
	      setContentRef = _a.setContentRef,
	      children = _a.children,
	      restProps = __rest(_a, ["prefixCls", "component", "className", 'aria-label', "setContentRef", "children"]);
	
	  var mergedRef = ref;
	
	  if (setContentRef) {
	    (0, _warning["default"])(false, 'Typography', '`setContentRef` is deprecated. Please use `ref` instead.');
	    mergedRef = (0, _ref2.composeRef)(ref, setContentRef);
	  }
	
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var Component = component;
	      var prefixCls = getPrefixCls('typography', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(Component, _extends({
	          className: (0, _classnames["default"])(prefixCls, className),
	          "aria-label": ariaLabel,
	          ref: mergedRef
	        }, restProps), children)
	      );
	    })
	  );
	};
	
	var RefTypography;
	
	if (React.forwardRef) {
	  RefTypography = /*#__PURE__*/React.forwardRef(Typography);
	  RefTypography.displayName = 'Typography';
	} else {
	  var TypographyWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(TypographyWrapper, _React$Component);
	
	    var _super = _createSuper(TypographyWrapper);
	
	    function TypographyWrapper() {
	      var _this;
	
	      _classCallCheck(this, TypographyWrapper);
	
	      _this = _super.apply(this, arguments);
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(TypographyWrapper, [{
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(Typography, this.props)
	        );
	      }
	    }]);
	
	    return TypographyWrapper;
	  }(React.Component);
	
	  RefTypography = TypographyWrapper;
	} // es default export should use const instead of let
	
	
	var ExportTypography = RefTypography;
	var _default = ExportTypography;
	exports["default"] = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcUpload = _interopRequireDefault(__webpack_require__(485));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _uniqBy = _interopRequireDefault(__webpack_require__(459));
	
	var _findIndex = _interopRequireDefault(__webpack_require__(456));
	
	var _UploadList = _interopRequireDefault(__webpack_require__(1130));
	
	var _utils = __webpack_require__(587);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _default2 = _interopRequireDefault(__webpack_require__(152));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Upload = /*#__PURE__*/function (_React$Component) {
	  _inherits(Upload, _React$Component);
	
	  var _super = _createSuper(Upload);
	
	  function Upload(props) {
	    var _this;
	
	    _classCallCheck(this, Upload);
	
	    _this = _super.call(this, props);
	
	    _this.saveUpload = function (node) {
	      _this.upload = node;
	    };
	
	    _this.onStart = function (file) {
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.fileToObject)(file);
	      targetItem.status = 'uploading';
	      var nextFileList = fileList.concat();
	      var fileIndex = (0, _findIndex["default"])(nextFileList, function (_ref) {
	        var uid = _ref.uid;
	        return uid === targetItem.uid;
	      });
	
	      if (fileIndex === -1) {
	        nextFileList.push(targetItem);
	      } else {
	        nextFileList[fileIndex] = targetItem;
	      }
	
	      _this.onChange({
	        file: targetItem,
	        fileList: nextFileList
	      }); // fix ie progress
	
	
	      if (!window.File || ({"NODE_ENV":"production"}).TEST_IE) {
	        _this.autoUpdateProgress(0, targetItem);
	      }
	    };
	
	    _this.onSuccess = function (response, file, xhr) {
	      _this.clearProgressTimer();
	
	      try {
	        if (typeof response === 'string') {
	          response = JSON.parse(response);
	        }
	      } catch (e) {
	        /* do nothing */
	      }
	
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.status = 'done';
	      targetItem.response = response;
	      targetItem.xhr = xhr;
	
	      _this.onChange({
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.onProgress = function (e, file) {
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.percent = e.percent;
	
	      _this.onChange({
	        event: e,
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.onError = function (error, response, file) {
	      _this.clearProgressTimer();
	
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.error = error;
	      targetItem.response = response;
	      targetItem.status = 'error';
	
	      _this.onChange({
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.handleRemove = function (file) {
	      var onRemove = _this.props.onRemove;
	      var fileList = _this.state.fileList;
	      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
	        // Prevent removing file
	        if (ret === false) {
	          return;
	        }
	
	        var removedFileList = (0, _utils.removeFileItem)(file, fileList);
	
	        if (removedFileList) {
	          file.status = 'removed'; // eslint-disable-line
	
	          if (_this.upload) {
	            _this.upload.abort(file);
	          }
	
	          _this.onChange({
	            file: file,
	            fileList: removedFileList
	          });
	        }
	      });
	    };
	
	    _this.onChange = function (info) {
	      if (!('fileList' in _this.props)) {
	        _this.setState({
	          fileList: info.fileList
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(info);
	      }
	    };
	
	    _this.onFileDrop = function (e) {
	      _this.setState({
	        dragState: e.type
	      });
	    };
	
	    _this.beforeUpload = function (file, fileList) {
	      var beforeUpload = _this.props.beforeUpload;
	      var stateFileList = _this.state.fileList;
	
	      if (!beforeUpload) {
	        return true;
	      }
	
	      var result = beforeUpload(file, fileList);
	
	      if (result === false) {
	        _this.onChange({
	          file: file,
	          fileList: (0, _uniqBy["default"])(stateFileList.concat(fileList.map(_utils.fileToObject)), function (item) {
	            return item.uid;
	          })
	        });
	
	        return false;
	      }
	
	      if (result && result.then) {
	        return result;
	      }
	
	      return true;
	    };
	
	    _this.renderUploadList = function (locale) {
	      var _this$props = _this.props,
	          showUploadList = _this$props.showUploadList,
	          listType = _this$props.listType,
	          onPreview = _this$props.onPreview,
	          onDownload = _this$props.onDownload,
	          previewFile = _this$props.previewFile,
	          disabled = _this$props.disabled,
	          propLocale = _this$props.locale;
	      var showRemoveIcon = showUploadList.showRemoveIcon,
	          showPreviewIcon = showUploadList.showPreviewIcon,
	          showDownloadIcon = showUploadList.showDownloadIcon;
	      var fileList = _this.state.fileList;
	      return (/*#__PURE__*/React.createElement(_UploadList["default"], {
	          listType: listType,
	          items: fileList,
	          previewFile: previewFile,
	          onPreview: onPreview,
	          onDownload: onDownload,
	          onRemove: _this.handleRemove,
	          showRemoveIcon: !disabled && showRemoveIcon,
	          showPreviewIcon: showPreviewIcon,
	          showDownloadIcon: showDownloadIcon,
	          locale: _extends(_extends({}, locale), propLocale)
	        })
	      );
	    };
	
	    _this.renderUpload = function (_ref2) {
	      var _classNames2;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          showUploadList = _this$props2.showUploadList,
	          listType = _this$props2.listType,
	          type = _this$props2.type,
	          disabled = _this$props2.disabled,
	          children = _this$props2.children,
	          style = _this$props2.style;
	      var _this$state = _this.state,
	          fileList = _this$state.fileList,
	          dragState = _this$state.dragState;
	      var prefixCls = getPrefixCls('upload', customizePrefixCls);
	
	      var rcUploadProps = _extends(_extends({
	        onStart: _this.onStart,
	        onError: _this.onError,
	        onProgress: _this.onProgress,
	        onSuccess: _this.onSuccess
	      }, _this.props), {
	        prefixCls: prefixCls,
	        beforeUpload: _this.beforeUpload
	      });
	
	      delete rcUploadProps.className;
	      delete rcUploadProps.style; // Remove id to avoid open by label when trigger is hidden
	      // !children: https://github.com/ant-design/ant-design/issues/14298
	      // disabled: https://github.com/ant-design/ant-design/issues/16478
	      //           https://github.com/ant-design/ant-design/issues/24197
	
	      if (!children || disabled) {
	        delete rcUploadProps.id;
	      }
	
	      var uploadList = showUploadList ? /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Upload",
	        defaultLocale: _default2["default"].Upload
	      }, _this.renderUploadList) : null;
	
	      if (type === 'drag') {
	        var _classNames;
	
	        var dragCls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-drag"), true), _defineProperty(_classNames, "".concat(prefixCls, "-drag-uploading"), fileList.some(function (file) {
	          return file.status === 'uploading';
	        })), _defineProperty(_classNames, "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames), className);
	        return (/*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
	            className: dragCls,
	            onDrop: _this.onFileDrop,
	            onDragOver: _this.onFileDrop,
	            onDragLeave: _this.onFileDrop,
	            style: style
	          }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
	            ref: _this.saveUpload,
	            className: "".concat(prefixCls, "-btn")
	          }), /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-drag-container")
	          }, children))), uploadList)
	        );
	      }
	
	      var uploadButtonCls = (0, _classnames["default"])(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _classNames2));
	      var uploadButton = /*#__PURE__*/React.createElement("div", {
	        className: uploadButtonCls,
	        style: children ? undefined : {
	          display: 'none'
	        }
	      }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
	        ref: _this.saveUpload
	      })));
	
	      if (listType === 'picture-card') {
	        return (/*#__PURE__*/React.createElement("span", {
	            className: (0, _classnames["default"])(className, "".concat(prefixCls, "-picture-card-wrapper"))
	          }, uploadList, uploadButton)
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: className
	        }, uploadButton, uploadList)
	      );
	    };
	
	    _this.state = {
	      fileList: props.fileList || props.defaultFileList || [],
	      dragState: 'drop'
	    };
	    (0, _warning["default"])('fileList' in props || !('value' in props), 'Upload', '`value` is not validate prop, do you mean `fileList`?');
	    return _this;
	  }
	
	  _createClass(Upload, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearProgressTimer();
	    }
	  }, {
	    key: "clearProgressTimer",
	    value: function clearProgressTimer() {
	      clearInterval(this.progressTimer);
	    }
	  }, {
	    key: "autoUpdateProgress",
	    value: function autoUpdateProgress(_, file) {
	      var _this2 = this;
	
	      var getPercent = (0, _utils.genPercentAdd)();
	      var curPercent = 0;
	      this.clearProgressTimer();
	      this.progressTimer = setInterval(function () {
	        curPercent = getPercent(curPercent);
	
	        _this2.onProgress({
	          percent: curPercent * 100
	        }, file);
	      }, 200);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUpload)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('fileList' in nextProps) {
	        return {
	          fileList: nextProps.fileList || []
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Upload;
	}(React.Component);
	
	Upload.defaultProps = {
	  type: 'select',
	  multiple: false,
	  action: '',
	  data: {},
	  accept: '',
	  beforeUpload: _utils.T,
	  showUploadList: true,
	  listType: 'text',
	  className: '',
	  disabled: false,
	  supportServerRender: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Upload);
	var _default = Upload;
	exports["default"] = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.T = T;
	exports.fileToObject = fileToObject;
	exports.genPercentAdd = genPercentAdd;
	exports.getFileItem = getFileItem;
	exports.removeFileItem = removeFileItem;
	exports.previewImage = previewImage;
	exports.isImageUrl = void 0;
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function T() {
	  return true;
	} // Fix IE file.status problem
	// via coping a new Object
	
	
	function fileToObject(file) {
	  return _extends(_extends({}, file), {
	    lastModified: file.lastModified,
	    lastModifiedDate: file.lastModifiedDate,
	    name: file.name,
	    size: file.size,
	    type: file.type,
	    uid: file.uid,
	    percent: 0,
	    originFileObj: file
	  });
	}
	/**
	 * 生成Progress percent: 0.1 -> 0.98
	 *   - for ie
	 */
	
	function genPercentAdd() {
	  var k = 0.1;
	  var i = 0.01;
	  var end = 0.98;
	  return function (s) {
	    var start = s;
	
	    if (start >= end) {
	      return start;
	    }
	
	    start += k;
	    k -= i;
	
	    if (k < 0.001) {
	      k = 0.001;
	    }
	
	    return start;
	  };
	}
	
	function getFileItem(file, fileList) {
	  var matchKey = file.uid !== undefined ? 'uid' : 'name';
	  return fileList.filter(function (item) {
	    return item[matchKey] === file[matchKey];
	  })[0];
	}
	
	function removeFileItem(file, fileList) {
	  var matchKey = file.uid !== undefined ? 'uid' : 'name';
	  var removed = fileList.filter(function (item) {
	    return item[matchKey] !== file[matchKey];
	  });
	
	  if (removed.length === fileList.length) {
	    return null;
	  }
	
	  return removed;
	} // ==================== Default Image Preview ====================
	
	
	var extname = function extname() {
	  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var temp = url.split('/');
	  var filename = temp[temp.length - 1];
	  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
	  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
	};
	
	var isImageFileType = function isImageFileType(type) {
	  return !!type && type.indexOf('image/') === 0;
	};
	
	var isImageUrl = function isImageUrl(file) {
	  if (isImageFileType(file.type)) {
	    return true;
	  }
	
	  var url = file.thumbUrl || file.url;
	  var extension = extname(url);
	
	  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
	    return true;
	  }
	
	  if (/^data:/.test(url)) {
	    // other file types of base64
	    return false;
	  }
	
	  if (extension) {
	    // other file types which have extension
	    return false;
	  }
	
	  return true;
	};
	
	exports.isImageUrl = isImageUrl;
	var MEASURE_SIZE = 200;
	
	function previewImage(file) {
	  return new Promise(function (resolve) {
	    if (!isImageFileType(file.type)) {
	      resolve('');
	      return;
	    }
	
	    var canvas = document.createElement('canvas');
	    canvas.width = MEASURE_SIZE;
	    canvas.height = MEASURE_SIZE;
	    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
	    document.body.appendChild(canvas);
	    var ctx = canvas.getContext('2d');
	    var img = new Image();
	
	    img.onload = function () {
	      var width = img.width,
	          height = img.height;
	      var drawWidth = MEASURE_SIZE;
	      var drawHeight = MEASURE_SIZE;
	      var offsetX = 0;
	      var offsetY = 0;
	
	      if (width < height) {
	        drawHeight = height * (MEASURE_SIZE / width);
	        offsetY = -(drawHeight - drawWidth) / 2;
	      } else {
	        drawWidth = width * (MEASURE_SIZE / height);
	        offsetX = -(drawWidth - drawHeight) / 2;
	      }
	
	      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
	      var dataURL = canvas.toDataURL();
	      document.body.removeChild(canvas);
	      resolve(dataURL);
	    };
	
	    img.src = window.URL.createObjectURL(file);
	  });
	}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			// Lookup tables
			var SBOX = [];
			var INV_SBOX = [];
			var SUB_MIX_0 = [];
			var SUB_MIX_1 = [];
			var SUB_MIX_2 = [];
			var SUB_MIX_3 = [];
			var INV_SUB_MIX_0 = [];
			var INV_SUB_MIX_1 = [];
			var INV_SUB_MIX_2 = [];
			var INV_SUB_MIX_3 = [];
	
			// Compute lookup tables
			(function () {
				// Compute double table
				var d = [];
				for (var i = 0; i < 256; i++) {
					if (i < 128) {
						d[i] = i << 1;
					} else {
						d[i] = i << 1 ^ 0x11b;
					}
				}
	
				// Walk GF(2^8)
				var x = 0;
				var xi = 0;
				for (var i = 0; i < 256; i++) {
					// Compute sbox
					var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
					sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
					SBOX[x] = sx;
					INV_SBOX[sx] = x;
	
					// Compute multiplication
					var x2 = d[x];
					var x4 = d[x2];
					var x8 = d[x4];
	
					// Compute sub bytes, mix columns tables
					var t = d[sx] * 0x101 ^ sx * 0x1010100;
					SUB_MIX_0[x] = t << 24 | t >>> 8;
					SUB_MIX_1[x] = t << 16 | t >>> 16;
					SUB_MIX_2[x] = t << 8 | t >>> 24;
					SUB_MIX_3[x] = t;
	
					// Compute inv sub bytes, inv mix columns tables
					var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
					INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
					INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
					INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
					INV_SUB_MIX_3[sx] = t;
	
					// Compute next counter
					if (!x) {
						x = xi = 1;
					} else {
						x = x2 ^ d[d[d[x8 ^ x2]]];
						xi ^= d[d[xi]];
					}
				}
			})();
	
			// Precomputed Rcon lookup
			var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
			/**
	   * AES block cipher algorithm.
	   */
			var AES = C_algo.AES = BlockCipher.extend({
				_doReset: function _doReset() {
					var t;
	
					// Skip reset of nRounds has been set before and key did not change
					if (this._nRounds && this._keyPriorReset === this._key) {
						return;
					}
	
					// Shortcuts
					var key = this._keyPriorReset = this._key;
					var keyWords = key.words;
					var keySize = key.sigBytes / 4;
	
					// Compute number of rounds
					var nRounds = this._nRounds = keySize + 6;
	
					// Compute number of key schedule rows
					var ksRows = (nRounds + 1) * 4;
	
					// Compute key schedule
					var keySchedule = this._keySchedule = [];
					for (var ksRow = 0; ksRow < ksRows; ksRow++) {
						if (ksRow < keySize) {
							keySchedule[ksRow] = keyWords[ksRow];
						} else {
							t = keySchedule[ksRow - 1];
	
							if (!(ksRow % keySize)) {
								// Rot word
								t = t << 8 | t >>> 24;
	
								// Sub word
								t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
	
								// Mix Rcon
								t ^= RCON[ksRow / keySize | 0] << 24;
							} else if (keySize > 6 && ksRow % keySize == 4) {
								// Sub word
								t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
							}
	
							keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
						}
					}
	
					// Compute inv key schedule
					var invKeySchedule = this._invKeySchedule = [];
					for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
						var ksRow = ksRows - invKsRow;
	
						if (invKsRow % 4) {
							var t = keySchedule[ksRow];
						} else {
							var t = keySchedule[ksRow - 4];
						}
	
						if (invKsRow < 4 || ksRow <= 4) {
							invKeySchedule[invKsRow] = t;
						} else {
							invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
						}
					}
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					// Swap 2nd and 4th rows
					var t = M[offset + 1];
					M[offset + 1] = M[offset + 3];
					M[offset + 3] = t;
	
					this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
					// Inv swap 2nd and 4th rows
					var t = M[offset + 1];
					M[offset + 1] = M[offset + 3];
					M[offset + 3] = t;
				},
	
				_doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
					// Shortcut
					var nRounds = this._nRounds;
	
					// Get input, add round key
					var s0 = M[offset] ^ keySchedule[0];
					var s1 = M[offset + 1] ^ keySchedule[1];
					var s2 = M[offset + 2] ^ keySchedule[2];
					var s3 = M[offset + 3] ^ keySchedule[3];
	
					// Key schedule row counter
					var ksRow = 4;
	
					// Rounds
					for (var round = 1; round < nRounds; round++) {
						// Shift rows, sub bytes, mix columns, add round key
						var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
						var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
						var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
						var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
						// Update state
						s0 = t0;
						s1 = t1;
						s2 = t2;
						s3 = t3;
					}
	
					// Shift rows, sub bytes, add round key
					var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
					var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
					var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
					var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
					// Set output
					M[offset] = t0;
					M[offset + 1] = t1;
					M[offset + 2] = t2;
					M[offset + 3] = t3;
				},
	
				keySize: 256 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	   */
			C.AES = BlockCipher._createHelper(AES);
		})();
	
		return CryptoJS.AES;
	});

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			var N = 16;
	
			//Origin pbox and sbox, derived from PI
			var ORIG_P = [0x243F6A88, 0x85A308D3, 0x13198A2E, 0x03707344, 0xA4093822, 0x299F31D0, 0x082EFA98, 0xEC4E6C89, 0x452821E6, 0x38D01377, 0xBE5466CF, 0x34E90C6C, 0xC0AC29B7, 0xC97C50DD, 0x3F84D5B5, 0xB5470917, 0x9216D5D9, 0x8979FB1B];
	
			var ORIG_S = [[0xD1310BA6, 0x98DFB5AC, 0x2FFD72DB, 0xD01ADFB7, 0xB8E1AFED, 0x6A267E96, 0xBA7C9045, 0xF12C7F99, 0x24A19947, 0xB3916CF7, 0x0801F2E2, 0x858EFC16, 0x636920D8, 0x71574E69, 0xA458FEA3, 0xF4933D7E, 0x0D95748F, 0x728EB658, 0x718BCD58, 0x82154AEE, 0x7B54A41D, 0xC25A59B5, 0x9C30D539, 0x2AF26013, 0xC5D1B023, 0x286085F0, 0xCA417918, 0xB8DB38EF, 0x8E79DCB0, 0x603A180E, 0x6C9E0E8B, 0xB01E8A3E, 0xD71577C1, 0xBD314B27, 0x78AF2FDA, 0x55605C60, 0xE65525F3, 0xAA55AB94, 0x57489862, 0x63E81440, 0x55CA396A, 0x2AAB10B6, 0xB4CC5C34, 0x1141E8CE, 0xA15486AF, 0x7C72E993, 0xB3EE1411, 0x636FBC2A, 0x2BA9C55D, 0x741831F6, 0xCE5C3E16, 0x9B87931E, 0xAFD6BA33, 0x6C24CF5C, 0x7A325381, 0x28958677, 0x3B8F4898, 0x6B4BB9AF, 0xC4BFE81B, 0x66282193, 0x61D809CC, 0xFB21A991, 0x487CAC60, 0x5DEC8032, 0xEF845D5D, 0xE98575B1, 0xDC262302, 0xEB651B88, 0x23893E81, 0xD396ACC5, 0x0F6D6FF3, 0x83F44239, 0x2E0B4482, 0xA4842004, 0x69C8F04A, 0x9E1F9B5E, 0x21C66842, 0xF6E96C9A, 0x670C9C61, 0xABD388F0, 0x6A51A0D2, 0xD8542F68, 0x960FA728, 0xAB5133A3, 0x6EEF0B6C, 0x137A3BE4, 0xBA3BF050, 0x7EFB2A98, 0xA1F1651D, 0x39AF0176, 0x66CA593E, 0x82430E88, 0x8CEE8619, 0x456F9FB4, 0x7D84A5C3, 0x3B8B5EBE, 0xE06F75D8, 0x85C12073, 0x401A449F, 0x56C16AA6, 0x4ED3AA62, 0x363F7706, 0x1BFEDF72, 0x429B023D, 0x37D0D724, 0xD00A1248, 0xDB0FEAD3, 0x49F1C09B, 0x075372C9, 0x80991B7B, 0x25D479D8, 0xF6E8DEF7, 0xE3FE501A, 0xB6794C3B, 0x976CE0BD, 0x04C006BA, 0xC1A94FB6, 0x409F60C4, 0x5E5C9EC2, 0x196A2463, 0x68FB6FAF, 0x3E6C53B5, 0x1339B2EB, 0x3B52EC6F, 0x6DFC511F, 0x9B30952C, 0xCC814544, 0xAF5EBD09, 0xBEE3D004, 0xDE334AFD, 0x660F2807, 0x192E4BB3, 0xC0CBA857, 0x45C8740F, 0xD20B5F39, 0xB9D3FBDB, 0x5579C0BD, 0x1A60320A, 0xD6A100C6, 0x402C7279, 0x679F25FE, 0xFB1FA3CC, 0x8EA5E9F8, 0xDB3222F8, 0x3C7516DF, 0xFD616B15, 0x2F501EC8, 0xAD0552AB, 0x323DB5FA, 0xFD238760, 0x53317B48, 0x3E00DF82, 0x9E5C57BB, 0xCA6F8CA0, 0x1A87562E, 0xDF1769DB, 0xD542A8F6, 0x287EFFC3, 0xAC6732C6, 0x8C4F5573, 0x695B27B0, 0xBBCA58C8, 0xE1FFA35D, 0xB8F011A0, 0x10FA3D98, 0xFD2183B8, 0x4AFCB56C, 0x2DD1D35B, 0x9A53E479, 0xB6F84565, 0xD28E49BC, 0x4BFB9790, 0xE1DDF2DA, 0xA4CB7E33, 0x62FB1341, 0xCEE4C6E8, 0xEF20CADA, 0x36774C01, 0xD07E9EFE, 0x2BF11FB4, 0x95DBDA4D, 0xAE909198, 0xEAAD8E71, 0x6B93D5A0, 0xD08ED1D0, 0xAFC725E0, 0x8E3C5B2F, 0x8E7594B7, 0x8FF6E2FB, 0xF2122B64, 0x8888B812, 0x900DF01C, 0x4FAD5EA0, 0x688FC31C, 0xD1CFF191, 0xB3A8C1AD, 0x2F2F2218, 0xBE0E1777, 0xEA752DFE, 0x8B021FA1, 0xE5A0CC0F, 0xB56F74E8, 0x18ACF3D6, 0xCE89E299, 0xB4A84FE0, 0xFD13E0B7, 0x7CC43B81, 0xD2ADA8D9, 0x165FA266, 0x80957705, 0x93CC7314, 0x211A1477, 0xE6AD2065, 0x77B5FA86, 0xC75442F5, 0xFB9D35CF, 0xEBCDAF0C, 0x7B3E89A0, 0xD6411BD3, 0xAE1E7E49, 0x00250E2D, 0x2071B35E, 0x226800BB, 0x57B8E0AF, 0x2464369B, 0xF009B91E, 0x5563911D, 0x59DFA6AA, 0x78C14389, 0xD95A537F, 0x207D5BA2, 0x02E5B9C5, 0x83260376, 0x6295CFA9, 0x11C81968, 0x4E734A41, 0xB3472DCA, 0x7B14A94A, 0x1B510052, 0x9A532915, 0xD60F573F, 0xBC9BC6E4, 0x2B60A476, 0x81E67400, 0x08BA6FB5, 0x571BE91F, 0xF296EC6B, 0x2A0DD915, 0xB6636521, 0xE7B9F9B6, 0xFF34052E, 0xC5855664, 0x53B02D5D, 0xA99F8FA1, 0x08BA4799, 0x6E85076A], [0x4B7A70E9, 0xB5B32944, 0xDB75092E, 0xC4192623, 0xAD6EA6B0, 0x49A7DF7D, 0x9CEE60B8, 0x8FEDB266, 0xECAA8C71, 0x699A17FF, 0x5664526C, 0xC2B19EE1, 0x193602A5, 0x75094C29, 0xA0591340, 0xE4183A3E, 0x3F54989A, 0x5B429D65, 0x6B8FE4D6, 0x99F73FD6, 0xA1D29C07, 0xEFE830F5, 0x4D2D38E6, 0xF0255DC1, 0x4CDD2086, 0x8470EB26, 0x6382E9C6, 0x021ECC5E, 0x09686B3F, 0x3EBAEFC9, 0x3C971814, 0x6B6A70A1, 0x687F3584, 0x52A0E286, 0xB79C5305, 0xAA500737, 0x3E07841C, 0x7FDEAE5C, 0x8E7D44EC, 0x5716F2B8, 0xB03ADA37, 0xF0500C0D, 0xF01C1F04, 0x0200B3FF, 0xAE0CF51A, 0x3CB574B2, 0x25837A58, 0xDC0921BD, 0xD19113F9, 0x7CA92FF6, 0x94324773, 0x22F54701, 0x3AE5E581, 0x37C2DADC, 0xC8B57634, 0x9AF3DDA7, 0xA9446146, 0x0FD0030E, 0xECC8C73E, 0xA4751E41, 0xE238CD99, 0x3BEA0E2F, 0x3280BBA1, 0x183EB331, 0x4E548B38, 0x4F6DB908, 0x6F420D03, 0xF60A04BF, 0x2CB81290, 0x24977C79, 0x5679B072, 0xBCAF89AF, 0xDE9A771F, 0xD9930810, 0xB38BAE12, 0xDCCF3F2E, 0x5512721F, 0x2E6B7124, 0x501ADDE6, 0x9F84CD87, 0x7A584718, 0x7408DA17, 0xBC9F9ABC, 0xE94B7D8C, 0xEC7AEC3A, 0xDB851DFA, 0x63094366, 0xC464C3D2, 0xEF1C1847, 0x3215D908, 0xDD433B37, 0x24C2BA16, 0x12A14D43, 0x2A65C451, 0x50940002, 0x133AE4DD, 0x71DFF89E, 0x10314E55, 0x81AC77D6, 0x5F11199B, 0x043556F1, 0xD7A3C76B, 0x3C11183B, 0x5924A509, 0xF28FE6ED, 0x97F1FBFA, 0x9EBABF2C, 0x1E153C6E, 0x86E34570, 0xEAE96FB1, 0x860E5E0A, 0x5A3E2AB3, 0x771FE71C, 0x4E3D06FA, 0x2965DCB9, 0x99E71D0F, 0x803E89D6, 0x5266C825, 0x2E4CC978, 0x9C10B36A, 0xC6150EBA, 0x94E2EA78, 0xA5FC3C53, 0x1E0A2DF4, 0xF2F74EA7, 0x361D2B3D, 0x1939260F, 0x19C27960, 0x5223A708, 0xF71312B6, 0xEBADFE6E, 0xEAC31F66, 0xE3BC4595, 0xA67BC883, 0xB17F37D1, 0x018CFF28, 0xC332DDEF, 0xBE6C5AA5, 0x65582185, 0x68AB9802, 0xEECEA50F, 0xDB2F953B, 0x2AEF7DAD, 0x5B6E2F84, 0x1521B628, 0x29076170, 0xECDD4775, 0x619F1510, 0x13CCA830, 0xEB61BD96, 0x0334FE1E, 0xAA0363CF, 0xB5735C90, 0x4C70A239, 0xD59E9E0B, 0xCBAADE14, 0xEECC86BC, 0x60622CA7, 0x9CAB5CAB, 0xB2F3846E, 0x648B1EAF, 0x19BDF0CA, 0xA02369B9, 0x655ABB50, 0x40685A32, 0x3C2AB4B3, 0x319EE9D5, 0xC021B8F7, 0x9B540B19, 0x875FA099, 0x95F7997E, 0x623D7DA8, 0xF837889A, 0x97E32D77, 0x11ED935F, 0x16681281, 0x0E358829, 0xC7E61FD6, 0x96DEDFA1, 0x7858BA99, 0x57F584A5, 0x1B227263, 0x9B83C3FF, 0x1AC24696, 0xCDB30AEB, 0x532E3054, 0x8FD948E4, 0x6DBC3128, 0x58EBF2EF, 0x34C6FFEA, 0xFE28ED61, 0xEE7C3C73, 0x5D4A14D9, 0xE864B7E3, 0x42105D14, 0x203E13E0, 0x45EEE2B6, 0xA3AAABEA, 0xDB6C4F15, 0xFACB4FD0, 0xC742F442, 0xEF6ABBB5, 0x654F3B1D, 0x41CD2105, 0xD81E799E, 0x86854DC7, 0xE44B476A, 0x3D816250, 0xCF62A1F2, 0x5B8D2646, 0xFC8883A0, 0xC1C7B6A3, 0x7F1524C3, 0x69CB7492, 0x47848A0B, 0x5692B285, 0x095BBF00, 0xAD19489D, 0x1462B174, 0x23820E00, 0x58428D2A, 0x0C55F5EA, 0x1DADF43E, 0x233F7061, 0x3372F092, 0x8D937E41, 0xD65FECF1, 0x6C223BDB, 0x7CDE3759, 0xCBEE7460, 0x4085F2A7, 0xCE77326E, 0xA6078084, 0x19F8509E, 0xE8EFD855, 0x61D99735, 0xA969A7AA, 0xC50C06C2, 0x5A04ABFC, 0x800BCADC, 0x9E447A2E, 0xC3453484, 0xFDD56705, 0x0E1E9EC9, 0xDB73DBD3, 0x105588CD, 0x675FDA79, 0xE3674340, 0xC5C43465, 0x713E38D8, 0x3D28F89E, 0xF16DFF20, 0x153E21E7, 0x8FB03D4A, 0xE6E39F2B, 0xDB83ADF7], [0xE93D5A68, 0x948140F7, 0xF64C261C, 0x94692934, 0x411520F7, 0x7602D4F7, 0xBCF46B2E, 0xD4A20068, 0xD4082471, 0x3320F46A, 0x43B7D4B7, 0x500061AF, 0x1E39F62E, 0x97244546, 0x14214F74, 0xBF8B8840, 0x4D95FC1D, 0x96B591AF, 0x70F4DDD3, 0x66A02F45, 0xBFBC09EC, 0x03BD9785, 0x7FAC6DD0, 0x31CB8504, 0x96EB27B3, 0x55FD3941, 0xDA2547E6, 0xABCA0A9A, 0x28507825, 0x530429F4, 0x0A2C86DA, 0xE9B66DFB, 0x68DC1462, 0xD7486900, 0x680EC0A4, 0x27A18DEE, 0x4F3FFEA2, 0xE887AD8C, 0xB58CE006, 0x7AF4D6B6, 0xAACE1E7C, 0xD3375FEC, 0xCE78A399, 0x406B2A42, 0x20FE9E35, 0xD9F385B9, 0xEE39D7AB, 0x3B124E8B, 0x1DC9FAF7, 0x4B6D1856, 0x26A36631, 0xEAE397B2, 0x3A6EFA74, 0xDD5B4332, 0x6841E7F7, 0xCA7820FB, 0xFB0AF54E, 0xD8FEB397, 0x454056AC, 0xBA489527, 0x55533A3A, 0x20838D87, 0xFE6BA9B7, 0xD096954B, 0x55A867BC, 0xA1159A58, 0xCCA92963, 0x99E1DB33, 0xA62A4A56, 0x3F3125F9, 0x5EF47E1C, 0x9029317C, 0xFDF8E802, 0x04272F70, 0x80BB155C, 0x05282CE3, 0x95C11548, 0xE4C66D22, 0x48C1133F, 0xC70F86DC, 0x07F9C9EE, 0x41041F0F, 0x404779A4, 0x5D886E17, 0x325F51EB, 0xD59BC0D1, 0xF2BCC18F, 0x41113564, 0x257B7834, 0x602A9C60, 0xDFF8E8A3, 0x1F636C1B, 0x0E12B4C2, 0x02E1329E, 0xAF664FD1, 0xCAD18115, 0x6B2395E0, 0x333E92E1, 0x3B240B62, 0xEEBEB922, 0x85B2A20E, 0xE6BA0D99, 0xDE720C8C, 0x2DA2F728, 0xD0127845, 0x95B794FD, 0x647D0862, 0xE7CCF5F0, 0x5449A36F, 0x877D48FA, 0xC39DFD27, 0xF33E8D1E, 0x0A476341, 0x992EFF74, 0x3A6F6EAB, 0xF4F8FD37, 0xA812DC60, 0xA1EBDDF8, 0x991BE14C, 0xDB6E6B0D, 0xC67B5510, 0x6D672C37, 0x2765D43B, 0xDCD0E804, 0xF1290DC7, 0xCC00FFA3, 0xB5390F92, 0x690FED0B, 0x667B9FFB, 0xCEDB7D9C, 0xA091CF0B, 0xD9155EA3, 0xBB132F88, 0x515BAD24, 0x7B9479BF, 0x763BD6EB, 0x37392EB3, 0xCC115979, 0x8026E297, 0xF42E312D, 0x6842ADA7, 0xC66A2B3B, 0x12754CCC, 0x782EF11C, 0x6A124237, 0xB79251E7, 0x06A1BBE6, 0x4BFB6350, 0x1A6B1018, 0x11CAEDFA, 0x3D25BDD8, 0xE2E1C3C9, 0x44421659, 0x0A121386, 0xD90CEC6E, 0xD5ABEA2A, 0x64AF674E, 0xDA86A85F, 0xBEBFE988, 0x64E4C3FE, 0x9DBC8057, 0xF0F7C086, 0x60787BF8, 0x6003604D, 0xD1FD8346, 0xF6381FB0, 0x7745AE04, 0xD736FCCC, 0x83426B33, 0xF01EAB71, 0xB0804187, 0x3C005E5F, 0x77A057BE, 0xBDE8AE24, 0x55464299, 0xBF582E61, 0x4E58F48F, 0xF2DDFDA2, 0xF474EF38, 0x8789BDC2, 0x5366F9C3, 0xC8B38E74, 0xB475F255, 0x46FCD9B9, 0x7AEB2661, 0x8B1DDF84, 0x846A0E79, 0x915F95E2, 0x466E598E, 0x20B45770, 0x8CD55591, 0xC902DE4C, 0xB90BACE1, 0xBB8205D0, 0x11A86248, 0x7574A99E, 0xB77F19B6, 0xE0A9DC09, 0x662D09A1, 0xC4324633, 0xE85A1F02, 0x09F0BE8C, 0x4A99A025, 0x1D6EFE10, 0x1AB93D1D, 0x0BA5A4DF, 0xA186F20F, 0x2868F169, 0xDCB7DA83, 0x573906FE, 0xA1E2CE9B, 0x4FCD7F52, 0x50115E01, 0xA70683FA, 0xA002B5C4, 0x0DE6D027, 0x9AF88C27, 0x773F8641, 0xC3604C06, 0x61A806B5, 0xF0177A28, 0xC0F586E0, 0x006058AA, 0x30DC7D62, 0x11E69ED7, 0x2338EA63, 0x53C2DD94, 0xC2C21634, 0xBBCBEE56, 0x90BCB6DE, 0xEBFC7DA1, 0xCE591D76, 0x6F05E409, 0x4B7C0188, 0x39720A3D, 0x7C927C24, 0x86E3725F, 0x724D9DB9, 0x1AC15BB4, 0xD39EB8FC, 0xED545578, 0x08FCA5B5, 0xD83D7CD3, 0x4DAD0FC4, 0x1E50EF5E, 0xB161E6F8, 0xA28514D9, 0x6C51133C, 0x6FD5C7E7, 0x56E14EC4, 0x362ABFCE, 0xDDC6C837, 0xD79A3234, 0x92638212, 0x670EFA8E, 0x406000E0], [0x3A39CE37, 0xD3FAF5CF, 0xABC27737, 0x5AC52D1B, 0x5CB0679E, 0x4FA33742, 0xD3822740, 0x99BC9BBE, 0xD5118E9D, 0xBF0F7315, 0xD62D1C7E, 0xC700C47B, 0xB78C1B6B, 0x21A19045, 0xB26EB1BE, 0x6A366EB4, 0x5748AB2F, 0xBC946E79, 0xC6A376D2, 0x6549C2C8, 0x530FF8EE, 0x468DDE7D, 0xD5730A1D, 0x4CD04DC6, 0x2939BBDB, 0xA9BA4650, 0xAC9526E8, 0xBE5EE304, 0xA1FAD5F0, 0x6A2D519A, 0x63EF8CE2, 0x9A86EE22, 0xC089C2B8, 0x43242EF6, 0xA51E03AA, 0x9CF2D0A4, 0x83C061BA, 0x9BE96A4D, 0x8FE51550, 0xBA645BD6, 0x2826A2F9, 0xA73A3AE1, 0x4BA99586, 0xEF5562E9, 0xC72FEFD3, 0xF752F7DA, 0x3F046F69, 0x77FA0A59, 0x80E4A915, 0x87B08601, 0x9B09E6AD, 0x3B3EE593, 0xE990FD5A, 0x9E34D797, 0x2CF0B7D9, 0x022B8B51, 0x96D5AC3A, 0x017DA67D, 0xD1CF3ED6, 0x7C7D2D28, 0x1F9F25CF, 0xADF2B89B, 0x5AD6B472, 0x5A88F54C, 0xE029AC71, 0xE019A5E6, 0x47B0ACFD, 0xED93FA9B, 0xE8D3C48D, 0x283B57CC, 0xF8D56629, 0x79132E28, 0x785F0191, 0xED756055, 0xF7960E44, 0xE3D35E8C, 0x15056DD4, 0x88F46DBA, 0x03A16125, 0x0564F0BD, 0xC3EB9E15, 0x3C9057A2, 0x97271AEC, 0xA93A072A, 0x1B3F6D9B, 0x1E6321F5, 0xF59C66FB, 0x26DCF319, 0x7533D928, 0xB155FDF5, 0x03563482, 0x8ABA3CBB, 0x28517711, 0xC20AD9F8, 0xABCC5167, 0xCCAD925F, 0x4DE81751, 0x3830DC8E, 0x379D5862, 0x9320F991, 0xEA7A90C2, 0xFB3E7BCE, 0x5121CE64, 0x774FBE32, 0xA8B6E37E, 0xC3293D46, 0x48DE5369, 0x6413E680, 0xA2AE0810, 0xDD6DB224, 0x69852DFD, 0x09072166, 0xB39A460A, 0x6445C0DD, 0x586CDECF, 0x1C20C8AE, 0x5BBEF7DD, 0x1B588D40, 0xCCD2017F, 0x6BB4E3BB, 0xDDA26A7E, 0x3A59FF45, 0x3E350A44, 0xBCB4CDD5, 0x72EACEA8, 0xFA6484BB, 0x8D6612AE, 0xBF3C6F47, 0xD29BE463, 0x542F5D9E, 0xAEC2771B, 0xF64E6370, 0x740E0D8D, 0xE75B1357, 0xF8721671, 0xAF537D5D, 0x4040CB08, 0x4EB4E2CC, 0x34D2466A, 0x0115AF84, 0xE1B00428, 0x95983A1D, 0x06B89FB4, 0xCE6EA048, 0x6F3F3B82, 0x3520AB82, 0x011A1D4B, 0x277227F8, 0x611560B1, 0xE7933FDC, 0xBB3A792B, 0x344525BD, 0xA08839E1, 0x51CE794B, 0x2F32C9B7, 0xA01FBAC9, 0xE01CC87E, 0xBCC7D1F6, 0xCF0111C3, 0xA1E8AAC7, 0x1A908749, 0xD44FBD9A, 0xD0DADECB, 0xD50ADA38, 0x0339C32A, 0xC6913667, 0x8DF9317C, 0xE0B12B4F, 0xF79E59B7, 0x43F5BB3A, 0xF2D519FF, 0x27D9459C, 0xBF97222C, 0x15E6FC2A, 0x0F91FC71, 0x9B941525, 0xFAE59361, 0xCEB69CEB, 0xC2A86459, 0x12BAA8D1, 0xB6C1075E, 0xE3056A0C, 0x10D25065, 0xCB03A442, 0xE0EC6E0E, 0x1698DB3B, 0x4C98A0BE, 0x3278E964, 0x9F1F9532, 0xE0D392DF, 0xD3A0342B, 0x8971F21E, 0x1B0A7441, 0x4BA3348C, 0xC5BE7120, 0xC37632D8, 0xDF359F8D, 0x9B992F2E, 0xE60B6F47, 0x0FE3F11D, 0xE54CDA54, 0x1EDAD891, 0xCE6279CF, 0xCD3E7E6F, 0x1618B166, 0xFD2C1D05, 0x848FD2C5, 0xF6FB2299, 0xF523F357, 0xA6327623, 0x93A83531, 0x56CCCD02, 0xACF08162, 0x5A75EBB5, 0x6E163697, 0x88D273CC, 0xDE966292, 0x81B949D0, 0x4C50901B, 0x71C65614, 0xE6C6C7BD, 0x327A140A, 0x45E1D006, 0xC3F27B9A, 0xC9AA53FD, 0x62A80F00, 0xBB25BFE2, 0x35BDD2F6, 0x71126905, 0xB2040222, 0xB6CBCF7C, 0xCD769C2B, 0x53113EC0, 0x1640E3D3, 0x38ABBD60, 0x2547ADF0, 0xBA38209C, 0xF746CE76, 0x77AFA1C5, 0x20756060, 0x85CBFE4E, 0x8AE88DD8, 0x7AAAF9B0, 0x4CF9AA7E, 0x1948C25C, 0x02FB8A8C, 0x01C36AE4, 0xD6EBE1F9, 0x90D4F869, 0xA65CDEA0, 0x3F09252D, 0xC208E69F, 0xB74E6132, 0xCE77E25B, 0x578FDFE3, 0x3AC372E6]];
	
			var BLOWFISH_CTX = {
				pbox: [],
				sbox: []
			};
	
			function F(ctx, x) {
				var a = x >> 24 & 0xFF;
				var b = x >> 16 & 0xFF;
				var c = x >> 8 & 0xFF;
				var d = x & 0xFF;
	
				var y = ctx.sbox[0][a] + ctx.sbox[1][b];
				y = y ^ ctx.sbox[2][c];
				y = y + ctx.sbox[3][d];
	
				return y;
			}
	
			function BlowFish_Encrypt(ctx, left, right) {
				var Xl = left;
				var Xr = right;
				var temp = void 0;
	
				for (var i = 0; i < N; ++i) {
					Xl = Xl ^ ctx.pbox[i];
					Xr = F(ctx, Xl) ^ Xr;
	
					temp = Xl;
					Xl = Xr;
					Xr = temp;
				}
	
				temp = Xl;
				Xl = Xr;
				Xr = temp;
	
				Xr = Xr ^ ctx.pbox[N];
				Xl = Xl ^ ctx.pbox[N + 1];
	
				return { left: Xl, right: Xr };
			}
	
			function BlowFish_Decrypt(ctx, left, right) {
				var Xl = left;
				var Xr = right;
				var temp = void 0;
	
				for (var i = N + 1; i > 1; --i) {
					Xl = Xl ^ ctx.pbox[i];
					Xr = F(ctx, Xl) ^ Xr;
	
					temp = Xl;
					Xl = Xr;
					Xr = temp;
				}
	
				temp = Xl;
				Xl = Xr;
				Xr = temp;
	
				Xr = Xr ^ ctx.pbox[1];
				Xl = Xl ^ ctx.pbox[0];
	
				return { left: Xl, right: Xr };
			}
	
			/**
	   * Initialization ctx's pbox and sbox.
	   *
	   * @param {Object} ctx The object has pbox and sbox.
	   * @param {Array} key An array of 32-bit words.
	   * @param {int} keysize The length of the key.
	   *
	   * @example
	   *
	   *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	   */
			function BlowFishInit(ctx, key, keysize) {
				for (var Row = 0; Row < 4; Row++) {
					ctx.sbox[Row] = [];
					for (var Col = 0; Col < 256; Col++) {
						ctx.sbox[Row][Col] = ORIG_S[Row][Col];
					}
				}
	
				var keyIndex = 0;
				for (var index = 0; index < N + 2; index++) {
					ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
					keyIndex++;
					if (keyIndex >= keysize) {
						keyIndex = 0;
					}
				}
	
				var Data1 = 0;
				var Data2 = 0;
				var res = 0;
				for (var i = 0; i < N + 2; i += 2) {
					res = BlowFish_Encrypt(ctx, Data1, Data2);
					Data1 = res.left;
					Data2 = res.right;
					ctx.pbox[i] = Data1;
					ctx.pbox[i + 1] = Data2;
				}
	
				for (var _i = 0; _i < 4; _i++) {
					for (var j = 0; j < 256; j += 2) {
						res = BlowFish_Encrypt(ctx, Data1, Data2);
						Data1 = res.left;
						Data2 = res.right;
						ctx.sbox[_i][j] = Data1;
						ctx.sbox[_i][j + 1] = Data2;
					}
				}
	
				return true;
			}
	
			/**
	   * Blowfish block cipher algorithm.
	   */
			var Blowfish = C_algo.Blowfish = BlockCipher.extend({
				_doReset: function _doReset() {
					// Skip reset of nRounds has been set before and key did not change
					if (this._keyPriorReset === this._key) {
						return;
					}
	
					// Shortcuts
					var key = this._keyPriorReset = this._key;
					var keyWords = key.words;
					var keySize = key.sigBytes / 4;
	
					//Initialization pbox and sbox
					BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
					M[offset] = res.left;
					M[offset + 1] = res.right;
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
					M[offset] = res.left;
					M[offset + 1] = res.right;
				},
	
				blockSize: 64 / 32,
	
				keySize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	   */
			C.Blowfish = BlockCipher._createHelper(Blowfish);
		})();
	
		return CryptoJS.Blowfish;
	});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * Base64url encoding strategy.
	   */
			var Base64url = C_enc.Base64url = {
				/**
	    * Converts a word array to a Base64url string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @param {boolean} urlSafe Whether to use url safe
	    *
	    * @return {string} The Base64url string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	    */
				stringify: function stringify(wordArray, urlSafe) {
					if (urlSafe === undefined) {
						urlSafe = true;
					}
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
					var map = urlSafe ? this._safe_map : this._map;
	
					// Clamp excess bits
					wordArray.clamp();
	
					// Convert
					var base64Chars = [];
					for (var i = 0; i < sigBytes; i += 3) {
						var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
						var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
	
						var triplet = byte1 << 16 | byte2 << 8 | byte3;
	
						for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
							base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
						}
					}
	
					// Add padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						while (base64Chars.length % 4) {
							base64Chars.push(paddingChar);
						}
					}
	
					return base64Chars.join('');
				},
	
				/**
	    * Converts a Base64url string to a word array.
	    *
	    * @param {string} base64Str The Base64url string.
	    *
	    * @param {boolean} urlSafe Whether to use url safe
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	    */
				parse: function parse(base64Str, urlSafe) {
					if (urlSafe === undefined) {
						urlSafe = true;
					}
	
					// Shortcuts
					var base64StrLength = base64Str.length;
					var map = urlSafe ? this._safe_map : this._map;
					var reverseMap = this._reverseMap;
	
					if (!reverseMap) {
						reverseMap = this._reverseMap = [];
						for (var j = 0; j < map.length; j++) {
							reverseMap[map.charCodeAt(j)] = j;
						}
					}
	
					// Ignore padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						var paddingIndex = base64Str.indexOf(paddingChar);
						if (paddingIndex !== -1) {
							base64StrLength = paddingIndex;
						}
					}
	
					// Convert
					return parseLoop(base64Str, base64StrLength, reverseMap);
				},
	
				_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
				_safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
			};
	
			function parseLoop(base64Str, base64StrLength, reverseMap) {
				var words = [];
				var nBytes = 0;
				for (var i = 0; i < base64StrLength; i++) {
					if (i % 4) {
						var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
						var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
						var bitsCombined = bits1 | bits2;
						words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
						nBytes++;
					}
				}
				return WordArray.create(words, nBytes);
			}
		})();
	
		return CryptoJS.enc.Base64url;
	});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * UTF-16 BE encoding strategy.
	   */
			var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
				/**
	    * Converts a word array to a UTF-16 BE string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-16 BE string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var utf16Chars = [];
					for (var i = 0; i < sigBytes; i += 2) {
						var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
						utf16Chars.push(String.fromCharCode(codePoint));
					}
	
					return utf16Chars.join('');
				},
	
				/**
	    * Converts a UTF-16 BE string to a word array.
	    *
	    * @param {string} utf16Str The UTF-16 BE string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	    */
				parse: function parse(utf16Str) {
					// Shortcut
					var utf16StrLength = utf16Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < utf16StrLength; i++) {
						words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
					}
	
					return WordArray.create(words, utf16StrLength * 2);
				}
			};
	
			/**
	   * UTF-16 LE encoding strategy.
	   */
			C_enc.Utf16LE = {
				/**
	    * Converts a word array to a UTF-16 LE string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-16 LE string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var utf16Chars = [];
					for (var i = 0; i < sigBytes; i += 2) {
						var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
						utf16Chars.push(String.fromCharCode(codePoint));
					}
	
					return utf16Chars.join('');
				},
	
				/**
	    * Converts a UTF-16 LE string to a word array.
	    *
	    * @param {string} utf16Str The UTF-16 LE string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	    */
				parse: function parse(utf16Str) {
					// Shortcut
					var utf16StrLength = utf16Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < utf16StrLength; i++) {
						words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
					}
	
					return WordArray.create(words, utf16StrLength * 2);
				}
			};
	
			function swapEndian(word) {
				return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
			}
		})();
	
		return CryptoJS.enc.Utf16;
	});

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var CipherParams = C_lib.CipherParams;
			var C_enc = C.enc;
			var Hex = C_enc.Hex;
			var C_format = C.format;
	
			var HexFormatter = C_format.Hex = {
				/**
	    * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	    *
	    * @param {CipherParams} cipherParams The cipher params object.
	    *
	    * @return {string} The hexadecimally encoded string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	    */
				stringify: function stringify(cipherParams) {
					return cipherParams.ciphertext.toString(Hex);
				},
	
				/**
	    * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	    *
	    * @param {string} input The hexadecimally encoded string.
	    *
	    * @return {CipherParams} The cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	    */
				parse: function parse(input) {
					var ciphertext = Hex.parse(input);
					return CipherParams.create({ ciphertext: ciphertext });
				}
			};
		})();
	
		return CryptoJS.format.Hex;
	});

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Check if typed arrays are supported
			if (typeof ArrayBuffer != 'function') {
				return;
			}
	
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
	
			// Reference original init
			var superInit = WordArray.init;
	
			// Augment WordArray.init to handle typed arrays
			var subInit = WordArray.init = function (typedArray) {
				// Convert buffers to uint8
				if (typedArray instanceof ArrayBuffer) {
					typedArray = new Uint8Array(typedArray);
				}
	
				// Convert other array views to uint8
				if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
					typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
				}
	
				// Handle Uint8Array
				if (typedArray instanceof Uint8Array) {
					// Shortcut
					var typedArrayByteLength = typedArray.byteLength;
	
					// Extract bytes
					var words = [];
					for (var i = 0; i < typedArrayByteLength; i++) {
						words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
					}
	
					// Initialize this word array
					superInit.call(this, words, typedArrayByteLength);
				} else {
					// Else call normal init
					superInit.apply(this, arguments);
				}
			};
	
			subInit.prototype = WordArray;
		})();
	
		return CryptoJS.lib.WordArray;
	});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Cipher Feedback block mode.
	  */
		CryptoJS.mode.CFB = function () {
			var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
			CFB.Encryptor = CFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
	
					generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
					// Remember this block to use with next block
					this._prevBlock = words.slice(offset, offset + blockSize);
				}
			});
	
			CFB.Decryptor = CFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
	
					// Remember this block to use with next block
					var thisBlock = words.slice(offset, offset + blockSize);
	
					generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
					// This block becomes the previous block
					this._prevBlock = thisBlock;
				}
			});
	
			function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
				var keystream;
	
				// Shortcut
				var iv = this._iv;
	
				// Generate keystream
				if (iv) {
					keystream = iv.slice(0);
	
					// Remove IV for subsequent blocks
					this._iv = undefined;
				} else {
					keystream = this._prevBlock;
				}
				cipher.encryptBlock(keystream, 0);
	
				// Encrypt
				for (var i = 0; i < blockSize; i++) {
					words[offset + i] ^= keystream[i];
				}
			}
	
			return CFB;
		}();
	
		return CryptoJS.mode.CFB;
	});

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/** @preserve
	  * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	  * derived from CryptoJS.mode.CTR
	  * Jan Hruby jhruby.web@gmail.com
	  */
		CryptoJS.mode.CTRGladman = function () {
			var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word) {
				if ((word >> 24 & 0xff) === 0xff) {
					//overflow
					var b1 = word >> 16 & 0xff;
					var b2 = word >> 8 & 0xff;
					var b3 = word & 0xff;
	
					if (b1 === 0xff) // overflow b1
						{
							b1 = 0;
							if (b2 === 0xff) {
								b2 = 0;
								if (b3 === 0xff) {
									b3 = 0;
								} else {
									++b3;
								}
							} else {
								++b2;
							}
						} else {
						++b1;
					}
	
					word = 0;
					word += b1 << 16;
					word += b2 << 8;
					word += b3;
				} else {
					word += 0x01 << 24;
				}
				return word;
			}
	
			function incCounter(counter) {
				if ((counter[0] = incWord(counter[0])) === 0) {
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
			var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var counter = this._counter;
	
					// Generate keystream
					if (iv) {
						counter = this._counter = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
					cipher.encryptBlock(keystream, 0);
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			CTRGladman.Decryptor = Encryptor;
	
			return CTRGladman;
		}();
	
		return CryptoJS.mode.CTRGladman;
	});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Counter block mode.
	  */
		CryptoJS.mode.CTR = function () {
			var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
			var Encryptor = CTR.Encryptor = CTR.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var counter = this._counter;
	
					// Generate keystream
					if (iv) {
						counter = this._counter = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
					var keystream = counter.slice(0);
					cipher.encryptBlock(keystream, 0);
	
					// Increment counter
					counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			CTR.Decryptor = Encryptor;
	
			return CTR;
		}();
	
		return CryptoJS.mode.CTR;
	});

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Electronic Codebook block mode.
	  */
		CryptoJS.mode.ECB = function () {
			var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
			ECB.Encryptor = ECB.extend({
				processBlock: function processBlock(words, offset) {
					this._cipher.encryptBlock(words, offset);
				}
			});
	
			ECB.Decryptor = ECB.extend({
				processBlock: function processBlock(words, offset) {
					this._cipher.decryptBlock(words, offset);
				}
			});
	
			return ECB;
		}();
	
		return CryptoJS.mode.ECB;
	});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Output Feedback block mode.
	  */
		CryptoJS.mode.OFB = function () {
			var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
			var Encryptor = OFB.Encryptor = OFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var keystream = this._keystream;
	
					// Generate keystream
					if (iv) {
						keystream = this._keystream = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
					cipher.encryptBlock(keystream, 0);
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			OFB.Decryptor = Encryptor;
	
			return OFB;
		}();
	
		return CryptoJS.mode.OFB;
	});

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ANSI X.923 padding strategy.
	  */
		CryptoJS.pad.AnsiX923 = {
			pad: function pad(data, blockSize) {
				// Shortcuts
				var dataSigBytes = data.sigBytes;
				var blockSizeBytes = blockSize * 4;
	
				// Count padding bytes
				var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
				// Compute last byte position
				var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
				// Pad
				data.clamp();
				data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
				data.sigBytes += nPaddingBytes;
			},
	
			unpad: function unpad(data) {
				// Get number of padding bytes from last byte
				var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
				// Remove padding
				data.sigBytes -= nPaddingBytes;
			}
		};
	
		return CryptoJS.pad.Ansix923;
	});

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ISO 10126 padding strategy.
	  */
		CryptoJS.pad.Iso10126 = {
			pad: function pad(data, blockSize) {
				// Shortcut
				var blockSizeBytes = blockSize * 4;
	
				// Count padding bytes
				var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
				// Pad
				data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
			},
	
			unpad: function unpad(data) {
				// Get number of padding bytes from last byte
				var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
				// Remove padding
				data.sigBytes -= nPaddingBytes;
			}
		};
	
		return CryptoJS.pad.Iso10126;
	});

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ISO/IEC 9797-1 Padding Method 2.
	  */
		CryptoJS.pad.Iso97971 = {
			pad: function pad(data, blockSize) {
				// Add 0x80 byte
				data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
				// Zero pad the rest
				CryptoJS.pad.ZeroPadding.pad(data, blockSize);
			},
	
			unpad: function unpad(data) {
				// Remove zero padding
				CryptoJS.pad.ZeroPadding.unpad(data);
	
				// Remove one more byte -- the 0x80 byte
				data.sigBytes--;
			}
		};
	
		return CryptoJS.pad.Iso97971;
	});

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * A noop padding strategy.
	  */
		CryptoJS.pad.NoPadding = {
			pad: function pad() {},
	
			unpad: function unpad() {}
		};
	
		return CryptoJS.pad.NoPadding;
	});

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Zero padding strategy.
	  */
		CryptoJS.pad.ZeroPadding = {
			pad: function pad(data, blockSize) {
				// Shortcut
				var blockSizeBytes = blockSize * 4;
	
				// Pad
				data.clamp();
				data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
			},
	
			unpad: function unpad(data) {
				// Shortcut
				var dataWords = data.words;
	
				// Unpad
				var i = data.sigBytes - 1;
				for (var i = data.sigBytes - 1; i >= 0; i--) {
					if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
						data.sigBytes = i + 1;
						break;
					}
				}
			}
		};
	
		return CryptoJS.pad.ZeroPadding;
	});

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(154), __webpack_require__(153));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(154), __webpack_require__(153)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var SHA256 = C_algo.SHA256;
			var HMAC = C_algo.HMAC;
	
			/**
	   * Password-Based Key Derivation Function 2 algorithm.
	   */
			var PBKDF2 = C_algo.PBKDF2 = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	    * @property {Hasher} hasher The hasher to use. Default: SHA256
	    * @property {number} iterations The number of iterations to perform. Default: 250000
	    */
				cfg: Base.extend({
					keySize: 128 / 32,
					hasher: SHA256,
					iterations: 250000
				}),
	
				/**
	    * Initializes a newly created key derivation function.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	    *
	    * @example
	    *
	    *     var kdf = CryptoJS.algo.PBKDF2.create();
	    *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	    *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	    */
				init: function init(cfg) {
					this.cfg = this.cfg.extend(cfg);
				},
	
				/**
	    * Computes the Password-Based Key Derivation Function 2.
	    *
	    * @param {WordArray|string} password The password.
	    * @param {WordArray|string} salt A salt.
	    *
	    * @return {WordArray} The derived key.
	    *
	    * @example
	    *
	    *     var key = kdf.compute(password, salt);
	    */
				compute: function compute(password, salt) {
					// Shortcut
					var cfg = this.cfg;
	
					// Init HMAC
					var hmac = HMAC.create(cfg.hasher, password);
	
					// Initial values
					var derivedKey = WordArray.create();
					var blockIndex = WordArray.create([0x00000001]);
	
					// Shortcuts
					var derivedKeyWords = derivedKey.words;
					var blockIndexWords = blockIndex.words;
					var keySize = cfg.keySize;
					var iterations = cfg.iterations;
	
					// Generate key
					while (derivedKeyWords.length < keySize) {
						var block = hmac.update(salt).finalize(blockIndex);
						hmac.reset();
	
						// Shortcuts
						var blockWords = block.words;
						var blockWordsLength = blockWords.length;
	
						// Iterations
						var intermediate = block;
						for (var i = 1; i < iterations; i++) {
							intermediate = hmac.finalize(intermediate);
							hmac.reset();
	
							// Shortcut
							var intermediateWords = intermediate.words;
	
							// XOR intermediate with block
							for (var j = 0; j < blockWordsLength; j++) {
								blockWords[j] ^= intermediateWords[j];
							}
						}
	
						derivedKey.concat(block);
						blockIndexWords[0]++;
					}
					derivedKey.sigBytes = keySize * 4;
	
					return derivedKey;
				}
			});
	
			/**
	   * Computes the Password-Based Key Derivation Function 2.
	   *
	   * @param {WordArray|string} password The password.
	   * @param {WordArray|string} salt A salt.
	   * @param {Object} cfg (Optional) The configuration options to use for this computation.
	   *
	   * @return {WordArray} The derived key.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var key = CryptoJS.PBKDF2(password, salt);
	   *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	   *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	   */
			C.PBKDF2 = function (password, salt, cfg) {
				return PBKDF2.create(cfg).compute(password, salt);
			};
		})();
	
		return CryptoJS.PBKDF2;
	});

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			// Reusable objects
			var S = [];
			var C_ = [];
			var G = [];
	
			/**
	   * Rabbit stream cipher algorithm.
	   *
	   * This is a legacy version that neglected to convert the key to little-endian.
	   * This error doesn't affect the cipher's security,
	   * but it does affect its compatibility with other implementations.
	   */
			var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var K = this._key.words;
					var iv = this.cfg.iv;
	
					// Generate initial state values
					var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16];
	
					// Generate initial counter values
					var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff];
	
					// Carry bit
					this._b = 0;
	
					// Iterate the system four times
					for (var i = 0; i < 4; i++) {
						nextState.call(this);
					}
	
					// Modify the counters
					for (var i = 0; i < 8; i++) {
						C[i] ^= X[i + 4 & 7];
					}
	
					// IV setup
					if (iv) {
						// Shortcuts
						var IV = iv.words;
						var IV_0 = IV[0];
						var IV_1 = IV[1];
	
						// Generate four subvectors
						var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
						var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
						var i1 = i0 >>> 16 | i2 & 0xffff0000;
						var i3 = i2 << 16 | i0 & 0x0000ffff;
	
						// Modify counter values
						C[0] ^= i0;
						C[1] ^= i1;
						C[2] ^= i2;
						C[3] ^= i3;
						C[4] ^= i0;
						C[5] ^= i1;
						C[6] ^= i2;
						C[7] ^= i3;
	
						// Iterate the system four times
						for (var i = 0; i < 4; i++) {
							nextState.call(this);
						}
					}
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var X = this._X;
	
					// Iterate the system
					nextState.call(this);
	
					// Generate four keystream words
					S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
					S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
					S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
					S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
	
					for (var i = 0; i < 4; i++) {
						// Swap endian
						S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
	
						// Encrypt
						M[offset + i] ^= S[i];
					}
				},
	
				blockSize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			function nextState() {
				// Shortcuts
				var X = this._X;
				var C = this._C;
	
				// Save old counter values
				for (var i = 0; i < 8; i++) {
					C_[i] = C[i];
				}
	
				// Calculate new counter values
				C[0] = C[0] + 0x4d34d34d + this._b | 0;
				C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
				C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
				C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
				C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
				C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
				C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
				C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
				this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
	
				// Calculate the g-values
				for (var i = 0; i < 8; i++) {
					var gx = X[i] + C[i];
	
					// Construct high and low argument for squaring
					var ga = gx & 0xffff;
					var gb = gx >>> 16;
	
					// Calculate high and low result of squaring
					var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
					var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
	
					// High XOR low
					G[i] = gh ^ gl;
				}
	
				// Calculate new state values
				X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
				X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
				X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
				X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
				X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
				X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
				X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
				X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	   */
			C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		})();
	
		return CryptoJS.RabbitLegacy;
	});

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			// Reusable objects
			var S = [];
			var C_ = [];
			var G = [];
	
			/**
	   * Rabbit stream cipher algorithm
	   */
			var Rabbit = C_algo.Rabbit = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var K = this._key.words;
					var iv = this.cfg.iv;
	
					// Swap endian
					for (var i = 0; i < 4; i++) {
						K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
					}
	
					// Generate initial state values
					var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16];
	
					// Generate initial counter values
					var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff];
	
					// Carry bit
					this._b = 0;
	
					// Iterate the system four times
					for (var i = 0; i < 4; i++) {
						nextState.call(this);
					}
	
					// Modify the counters
					for (var i = 0; i < 8; i++) {
						C[i] ^= X[i + 4 & 7];
					}
	
					// IV setup
					if (iv) {
						// Shortcuts
						var IV = iv.words;
						var IV_0 = IV[0];
						var IV_1 = IV[1];
	
						// Generate four subvectors
						var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
						var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
						var i1 = i0 >>> 16 | i2 & 0xffff0000;
						var i3 = i2 << 16 | i0 & 0x0000ffff;
	
						// Modify counter values
						C[0] ^= i0;
						C[1] ^= i1;
						C[2] ^= i2;
						C[3] ^= i3;
						C[4] ^= i0;
						C[5] ^= i1;
						C[6] ^= i2;
						C[7] ^= i3;
	
						// Iterate the system four times
						for (var i = 0; i < 4; i++) {
							nextState.call(this);
						}
					}
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var X = this._X;
	
					// Iterate the system
					nextState.call(this);
	
					// Generate four keystream words
					S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
					S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
					S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
					S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
	
					for (var i = 0; i < 4; i++) {
						// Swap endian
						S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
	
						// Encrypt
						M[offset + i] ^= S[i];
					}
				},
	
				blockSize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			function nextState() {
				// Shortcuts
				var X = this._X;
				var C = this._C;
	
				// Save old counter values
				for (var i = 0; i < 8; i++) {
					C_[i] = C[i];
				}
	
				// Calculate new counter values
				C[0] = C[0] + 0x4d34d34d + this._b | 0;
				C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
				C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
				C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
				C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
				C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
				C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
				C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
				this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
	
				// Calculate the g-values
				for (var i = 0; i < 8; i++) {
					var gx = X[i] + C[i];
	
					// Construct high and low argument for squaring
					var ga = gx & 0xffff;
					var gb = gx >>> 16;
	
					// Calculate high and low result of squaring
					var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
					var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
	
					// High XOR low
					G[i] = gh ^ gl;
				}
	
				// Calculate new state values
				X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
				X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
				X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
				X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
				X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
				X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
				X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
				X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	   */
			C.Rabbit = StreamCipher._createHelper(Rabbit);
		})();
	
		return CryptoJS.Rabbit;
	});

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			/**
	   * RC4 stream cipher algorithm.
	   */
			var RC4 = C_algo.RC4 = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
					var keySigBytes = key.sigBytes;
	
					// Init sbox
					var S = this._S = [];
					for (var i = 0; i < 256; i++) {
						S[i] = i;
					}
	
					// Key setup
					for (var i = 0, j = 0; i < 256; i++) {
						var keyByteIndex = i % keySigBytes;
						var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
	
						j = (j + S[i] + keyByte) % 256;
	
						// Swap
						var t = S[i];
						S[i] = S[j];
						S[j] = t;
					}
	
					// Counters
					this._i = this._j = 0;
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					M[offset] ^= generateKeystreamWord.call(this);
				},
	
				keySize: 256 / 32,
	
				ivSize: 0
			});
	
			function generateKeystreamWord() {
				// Shortcuts
				var S = this._S;
				var i = this._i;
				var j = this._j;
	
				// Generate keystream word
				var keystreamWord = 0;
				for (var n = 0; n < 4; n++) {
					i = (i + 1) % 256;
					j = (j + S[i]) % 256;
	
					// Swap
					var t = S[i];
					S[i] = S[j];
					S[j] = t;
	
					keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
				}
	
				// Update counters
				this._i = i;
				this._j = j;
	
				return keystreamWord;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	   */
			C.RC4 = StreamCipher._createHelper(RC4);
	
			/**
	   * Modified RC4 stream cipher algorithm.
	   */
			var RC4Drop = C_algo.RC4Drop = RC4.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} drop The number of keystream words to drop. Default 192
	    */
				cfg: RC4.cfg.extend({
					drop: 192
				}),
	
				_doReset: function _doReset() {
					RC4._doReset.call(this);
	
					// Drop
					for (var i = this.cfg.drop; i > 0; i--) {
						generateKeystreamWord.call(this);
					}
				}
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	   */
			C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		})();
	
		return CryptoJS.RC4;
	});

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/** @preserve
	 (c) 2012 by Cédric Mesnil. All rights reserved.
	 	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	 	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	     - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	 	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Constants table
			var _zl = WordArray.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]);
			var _zr = WordArray.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]);
			var _sl = WordArray.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]);
			var _sr = WordArray.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]);
	
			var _hl = WordArray.create([0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
			var _hr = WordArray.create([0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
			/**
	   * RIPEMD160 hash algorithm.
	   */
			var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
	
					// Swap endian
					for (var i = 0; i < 16; i++) {
						// Shortcuts
						var offset_i = offset + i;
						var M_offset_i = M[offset_i];
	
						// Swap
						M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
					}
					// Shortcut
					var H = this._hash.words;
					var hl = _hl.words;
					var hr = _hr.words;
					var zl = _zl.words;
					var zr = _zr.words;
					var sl = _sl.words;
					var sr = _sr.words;
	
					// Working variables
					var al, bl, cl, dl, el;
					var ar, br, cr, dr, er;
	
					ar = al = H[0];
					br = bl = H[1];
					cr = cl = H[2];
					dr = dl = H[3];
					er = el = H[4];
					// Computation
					var t;
					for (var i = 0; i < 80; i += 1) {
						t = al + M[offset + zl[i]] | 0;
						if (i < 16) {
							t += f1(bl, cl, dl) + hl[0];
						} else if (i < 32) {
							t += f2(bl, cl, dl) + hl[1];
						} else if (i < 48) {
							t += f3(bl, cl, dl) + hl[2];
						} else if (i < 64) {
							t += f4(bl, cl, dl) + hl[3];
						} else {
							// if (i<80) {
							t += f5(bl, cl, dl) + hl[4];
						}
						t = t | 0;
						t = rotl(t, sl[i]);
						t = t + el | 0;
						al = el;
						el = dl;
						dl = rotl(cl, 10);
						cl = bl;
						bl = t;
	
						t = ar + M[offset + zr[i]] | 0;
						if (i < 16) {
							t += f5(br, cr, dr) + hr[0];
						} else if (i < 32) {
							t += f4(br, cr, dr) + hr[1];
						} else if (i < 48) {
							t += f3(br, cr, dr) + hr[2];
						} else if (i < 64) {
							t += f2(br, cr, dr) + hr[3];
						} else {
							// if (i<80) {
							t += f1(br, cr, dr) + hr[4];
						}
						t = t | 0;
						t = rotl(t, sr[i]);
						t = t + er | 0;
						ar = er;
						er = dr;
						dr = rotl(cr, 10);
						cr = br;
						br = t;
					}
					// Intermediate hash value
					t = H[1] + cl + dr | 0;
					H[1] = H[2] + dl + er | 0;
					H[2] = H[3] + el + ar | 0;
					H[3] = H[4] + al + br | 0;
					H[4] = H[0] + bl + cr | 0;
					H[0] = t;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
					data.sigBytes = (dataWords.length + 1) * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var hash = this._hash;
					var H = hash.words;
	
					// Swap endian
					for (var i = 0; i < 5; i++) {
						// Shortcut
						var H_i = H[i];
	
						// Swap
						H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
					}
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			function f1(x, y, z) {
				return x ^ y ^ z;
			}
	
			function f2(x, y, z) {
				return x & y | ~x & z;
			}
	
			function f3(x, y, z) {
				return (x | ~y) ^ z;
			}
	
			function f4(x, y, z) {
				return x & z | y & ~z;
			}
	
			function f5(x, y, z) {
				return x ^ (y | ~z);
			}
	
			function rotl(x, n) {
				return x << n | x >>> 32 - n;
			}
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.RIPEMD160('message');
	   *     var hash = CryptoJS.RIPEMD160(wordArray);
	   */
			C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	   */
			C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		})(Math);
	
		return CryptoJS.RIPEMD160;
	});

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(154));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(154)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var SHA256 = C_algo.SHA256;
	
			/**
	   * SHA-224 hash algorithm.
	   */
			var SHA224 = C_algo.SHA224 = SHA256.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4]);
				},
	
				_doFinalize: function _doFinalize() {
					var hash = SHA256._doFinalize.call(this);
	
					hash.sigBytes -= 4;
	
					return hash;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA224('message');
	   *     var hash = CryptoJS.SHA224(wordArray);
	   */
			C.SHA224 = SHA256._createHelper(SHA224);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA224(message, key);
	   */
			C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		})();
	
		return CryptoJS.SHA224;
	});

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(123));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(123)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var C_algo = C.algo;
	
			// Constants tables
			var RHO_OFFSETS = [];
			var PI_INDEXES = [];
			var ROUND_CONSTANTS = [];
	
			// Compute Constants
			(function () {
				// Compute rho offset constants
				var x = 1,
				    y = 0;
				for (var t = 0; t < 24; t++) {
					RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
	
					var newX = y % 5;
					var newY = (2 * x + 3 * y) % 5;
					x = newX;
					y = newY;
				}
	
				// Compute pi index constants
				for (var x = 0; x < 5; x++) {
					for (var y = 0; y < 5; y++) {
						PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
					}
				}
	
				// Compute round constants
				var LFSR = 0x01;
				for (var i = 0; i < 24; i++) {
					var roundConstantMsw = 0;
					var roundConstantLsw = 0;
	
					for (var j = 0; j < 7; j++) {
						if (LFSR & 0x01) {
							var bitPosition = (1 << j) - 1;
							if (bitPosition < 32) {
								roundConstantLsw ^= 1 << bitPosition;
							} else /* if (bitPosition >= 32) */{
									roundConstantMsw ^= 1 << bitPosition - 32;
								}
						}
	
						// Compute next LFSR
						if (LFSR & 0x80) {
							// Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
							LFSR = LFSR << 1 ^ 0x71;
						} else {
							LFSR <<= 1;
						}
					}
	
					ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
				}
			})();
	
			// Reusable objects for temporary values
			var T = [];
			(function () {
				for (var i = 0; i < 25; i++) {
					T[i] = X64Word.create();
				}
			})();
	
			/**
	   * SHA-3 hash algorithm.
	   */
			var SHA3 = C_algo.SHA3 = Hasher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} outputLength
	    *   The desired number of bits in the output hash.
	    *   Only values permitted are: 224, 256, 384, 512.
	    *   Default: 512
	    */
				cfg: Hasher.cfg.extend({
					outputLength: 512
				}),
	
				_doReset: function _doReset() {
					var state = this._state = [];
					for (var i = 0; i < 25; i++) {
						state[i] = new X64Word.init();
					}
	
					this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcuts
					var state = this._state;
					var nBlockSizeLanes = this.blockSize / 2;
	
					// Absorb
					for (var i = 0; i < nBlockSizeLanes; i++) {
						// Shortcuts
						var M2i = M[offset + 2 * i];
						var M2i1 = M[offset + 2 * i + 1];
	
						// Swap endian
						M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
						M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
	
						// Absorb message into state
						var lane = state[i];
						lane.high ^= M2i1;
						lane.low ^= M2i;
					}
	
					// Rounds
					for (var round = 0; round < 24; round++) {
						// Theta
						for (var x = 0; x < 5; x++) {
							// Mix column lanes
							var tMsw = 0,
							    tLsw = 0;
							for (var y = 0; y < 5; y++) {
								var lane = state[x + 5 * y];
								tMsw ^= lane.high;
								tLsw ^= lane.low;
							}
	
							// Temporary values
							var Tx = T[x];
							Tx.high = tMsw;
							Tx.low = tLsw;
						}
						for (var x = 0; x < 5; x++) {
							// Shortcuts
							var Tx4 = T[(x + 4) % 5];
							var Tx1 = T[(x + 1) % 5];
							var Tx1Msw = Tx1.high;
							var Tx1Lsw = Tx1.low;
	
							// Mix surrounding columns
							var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
							var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
							for (var y = 0; y < 5; y++) {
								var lane = state[x + 5 * y];
								lane.high ^= tMsw;
								lane.low ^= tLsw;
							}
						}
	
						// Rho Pi
						for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
							var tMsw;
							var tLsw;
	
							// Shortcuts
							var lane = state[laneIndex];
							var laneMsw = lane.high;
							var laneLsw = lane.low;
							var rhoOffset = RHO_OFFSETS[laneIndex];
	
							// Rotate lanes
							if (rhoOffset < 32) {
								tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
								tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
							} else /* if (rhoOffset >= 32) */{
									tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
									tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
								}
	
							// Transpose lanes
							var TPiLane = T[PI_INDEXES[laneIndex]];
							TPiLane.high = tMsw;
							TPiLane.low = tLsw;
						}
	
						// Rho pi at x = y = 0
						var T0 = T[0];
						var state0 = state[0];
						T0.high = state0.high;
						T0.low = state0.low;
	
						// Chi
						for (var x = 0; x < 5; x++) {
							for (var y = 0; y < 5; y++) {
								// Shortcuts
								var laneIndex = x + 5 * y;
								var lane = state[laneIndex];
								var TLane = T[laneIndex];
								var Tx1Lane = T[(x + 1) % 5 + 5 * y];
								var Tx2Lane = T[(x + 2) % 5 + 5 * y];
	
								// Mix rows
								lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
								lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
							}
						}
	
						// Iota
						var lane = state[0];
						var roundConstant = ROUND_CONSTANTS[round];
						lane.high ^= roundConstant.high;
						lane.low ^= roundConstant.low;
					}
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
					var blockSizeBits = this.blockSize * 32;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
					dataWords[(Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var state = this._state;
					var outputLengthBytes = this.cfg.outputLength / 8;
					var outputLengthLanes = outputLengthBytes / 8;
	
					// Squeeze
					var hashWords = [];
					for (var i = 0; i < outputLengthLanes; i++) {
						// Shortcuts
						var lane = state[i];
						var laneMsw = lane.high;
						var laneLsw = lane.low;
	
						// Swap endian
						laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
						laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
	
						// Squeeze state to retrieve hash
						hashWords.push(laneLsw);
						hashWords.push(laneMsw);
					}
	
					// Return final computed hash
					return new WordArray.init(hashWords, outputLengthBytes);
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
	
					var state = clone._state = this._state.slice(0);
					for (var i = 0; i < 25; i++) {
						state[i] = state[i].clone();
					}
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA3('message');
	   *     var hash = CryptoJS.SHA3(wordArray);
	   */
			C.SHA3 = Hasher._createHelper(SHA3);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA3(message, key);
	   */
			C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		})(Math);
	
		return CryptoJS.SHA3;
	});

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(123), __webpack_require__(237));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(123), __webpack_require__(237)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var X64WordArray = C_x64.WordArray;
			var C_algo = C.algo;
			var SHA512 = C_algo.SHA512;
	
			/**
	   * SHA-384 hash algorithm.
	   */
			var SHA384 = C_algo.SHA384 = SHA512.extend({
				_doReset: function _doReset() {
					this._hash = new X64WordArray.init([new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507), new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939), new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511), new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)]);
				},
	
				_doFinalize: function _doFinalize() {
					var hash = SHA512._doFinalize.call(this);
	
					hash.sigBytes -= 16;
	
					return hash;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA384('message');
	   *     var hash = CryptoJS.SHA384(wordArray);
	   */
			C.SHA384 = SHA512._createHelper(SHA384);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA384(message, key);
	   */
			C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		})();
	
		return CryptoJS.SHA384;
	});

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(79), __webpack_require__(80), __webpack_require__(71), __webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			// Permuted Choice 1 constants
			var PC1 = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4];
	
			// Permuted Choice 2 constants
			var PC2 = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32];
	
			// Cumulative bit shift constants
			var BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
			// SBOXes and round permutation constants
			var SBOX_P = [{
				0x0: 0x808200,
				0x10000000: 0x8000,
				0x20000000: 0x808002,
				0x30000000: 0x2,
				0x40000000: 0x200,
				0x50000000: 0x808202,
				0x60000000: 0x800202,
				0x70000000: 0x800000,
				0x80000000: 0x202,
				0x90000000: 0x800200,
				0xa0000000: 0x8200,
				0xb0000000: 0x808000,
				0xc0000000: 0x8002,
				0xd0000000: 0x800002,
				0xe0000000: 0x0,
				0xf0000000: 0x8202,
				0x8000000: 0x0,
				0x18000000: 0x808202,
				0x28000000: 0x8202,
				0x38000000: 0x8000,
				0x48000000: 0x808200,
				0x58000000: 0x200,
				0x68000000: 0x808002,
				0x78000000: 0x2,
				0x88000000: 0x800200,
				0x98000000: 0x8200,
				0xa8000000: 0x808000,
				0xb8000000: 0x800202,
				0xc8000000: 0x800002,
				0xd8000000: 0x8002,
				0xe8000000: 0x202,
				0xf8000000: 0x800000,
				0x1: 0x8000,
				0x10000001: 0x2,
				0x20000001: 0x808200,
				0x30000001: 0x800000,
				0x40000001: 0x808002,
				0x50000001: 0x8200,
				0x60000001: 0x200,
				0x70000001: 0x800202,
				0x80000001: 0x808202,
				0x90000001: 0x808000,
				0xa0000001: 0x800002,
				0xb0000001: 0x8202,
				0xc0000001: 0x202,
				0xd0000001: 0x800200,
				0xe0000001: 0x8002,
				0xf0000001: 0x0,
				0x8000001: 0x808202,
				0x18000001: 0x808000,
				0x28000001: 0x800000,
				0x38000001: 0x200,
				0x48000001: 0x8000,
				0x58000001: 0x800002,
				0x68000001: 0x2,
				0x78000001: 0x8202,
				0x88000001: 0x8002,
				0x98000001: 0x800202,
				0xa8000001: 0x202,
				0xb8000001: 0x808200,
				0xc8000001: 0x800200,
				0xd8000001: 0x0,
				0xe8000001: 0x8200,
				0xf8000001: 0x808002
			}, {
				0x0: 0x40084010,
				0x1000000: 0x4000,
				0x2000000: 0x80000,
				0x3000000: 0x40080010,
				0x4000000: 0x40000010,
				0x5000000: 0x40084000,
				0x6000000: 0x40004000,
				0x7000000: 0x10,
				0x8000000: 0x84000,
				0x9000000: 0x40004010,
				0xa000000: 0x40000000,
				0xb000000: 0x84010,
				0xc000000: 0x80010,
				0xd000000: 0x0,
				0xe000000: 0x4010,
				0xf000000: 0x40080000,
				0x800000: 0x40004000,
				0x1800000: 0x84010,
				0x2800000: 0x10,
				0x3800000: 0x40004010,
				0x4800000: 0x40084010,
				0x5800000: 0x40000000,
				0x6800000: 0x80000,
				0x7800000: 0x40080010,
				0x8800000: 0x80010,
				0x9800000: 0x0,
				0xa800000: 0x4000,
				0xb800000: 0x40080000,
				0xc800000: 0x40000010,
				0xd800000: 0x84000,
				0xe800000: 0x40084000,
				0xf800000: 0x4010,
				0x10000000: 0x0,
				0x11000000: 0x40080010,
				0x12000000: 0x40004010,
				0x13000000: 0x40084000,
				0x14000000: 0x40080000,
				0x15000000: 0x10,
				0x16000000: 0x84010,
				0x17000000: 0x4000,
				0x18000000: 0x4010,
				0x19000000: 0x80000,
				0x1a000000: 0x80010,
				0x1b000000: 0x40000010,
				0x1c000000: 0x84000,
				0x1d000000: 0x40004000,
				0x1e000000: 0x40000000,
				0x1f000000: 0x40084010,
				0x10800000: 0x84010,
				0x11800000: 0x80000,
				0x12800000: 0x40080000,
				0x13800000: 0x4000,
				0x14800000: 0x40004000,
				0x15800000: 0x40084010,
				0x16800000: 0x10,
				0x17800000: 0x40000000,
				0x18800000: 0x40084000,
				0x19800000: 0x40000010,
				0x1a800000: 0x40004010,
				0x1b800000: 0x80010,
				0x1c800000: 0x0,
				0x1d800000: 0x4010,
				0x1e800000: 0x40080010,
				0x1f800000: 0x84000
			}, {
				0x0: 0x104,
				0x100000: 0x0,
				0x200000: 0x4000100,
				0x300000: 0x10104,
				0x400000: 0x10004,
				0x500000: 0x4000004,
				0x600000: 0x4010104,
				0x700000: 0x4010000,
				0x800000: 0x4000000,
				0x900000: 0x4010100,
				0xa00000: 0x10100,
				0xb00000: 0x4010004,
				0xc00000: 0x4000104,
				0xd00000: 0x10000,
				0xe00000: 0x4,
				0xf00000: 0x100,
				0x80000: 0x4010100,
				0x180000: 0x4010004,
				0x280000: 0x0,
				0x380000: 0x4000100,
				0x480000: 0x4000004,
				0x580000: 0x10000,
				0x680000: 0x10004,
				0x780000: 0x104,
				0x880000: 0x4,
				0x980000: 0x100,
				0xa80000: 0x4010000,
				0xb80000: 0x10104,
				0xc80000: 0x10100,
				0xd80000: 0x4000104,
				0xe80000: 0x4010104,
				0xf80000: 0x4000000,
				0x1000000: 0x4010100,
				0x1100000: 0x10004,
				0x1200000: 0x10000,
				0x1300000: 0x4000100,
				0x1400000: 0x100,
				0x1500000: 0x4010104,
				0x1600000: 0x4000004,
				0x1700000: 0x0,
				0x1800000: 0x4000104,
				0x1900000: 0x4000000,
				0x1a00000: 0x4,
				0x1b00000: 0x10100,
				0x1c00000: 0x4010000,
				0x1d00000: 0x104,
				0x1e00000: 0x10104,
				0x1f00000: 0x4010004,
				0x1080000: 0x4000000,
				0x1180000: 0x104,
				0x1280000: 0x4010100,
				0x1380000: 0x0,
				0x1480000: 0x10004,
				0x1580000: 0x4000100,
				0x1680000: 0x100,
				0x1780000: 0x4010004,
				0x1880000: 0x10000,
				0x1980000: 0x4010104,
				0x1a80000: 0x10104,
				0x1b80000: 0x4000004,
				0x1c80000: 0x4000104,
				0x1d80000: 0x4010000,
				0x1e80000: 0x4,
				0x1f80000: 0x10100
			}, {
				0x0: 0x80401000,
				0x10000: 0x80001040,
				0x20000: 0x401040,
				0x30000: 0x80400000,
				0x40000: 0x0,
				0x50000: 0x401000,
				0x60000: 0x80000040,
				0x70000: 0x400040,
				0x80000: 0x80000000,
				0x90000: 0x400000,
				0xa0000: 0x40,
				0xb0000: 0x80001000,
				0xc0000: 0x80400040,
				0xd0000: 0x1040,
				0xe0000: 0x1000,
				0xf0000: 0x80401040,
				0x8000: 0x80001040,
				0x18000: 0x40,
				0x28000: 0x80400040,
				0x38000: 0x80001000,
				0x48000: 0x401000,
				0x58000: 0x80401040,
				0x68000: 0x0,
				0x78000: 0x80400000,
				0x88000: 0x1000,
				0x98000: 0x80401000,
				0xa8000: 0x400000,
				0xb8000: 0x1040,
				0xc8000: 0x80000000,
				0xd8000: 0x400040,
				0xe8000: 0x401040,
				0xf8000: 0x80000040,
				0x100000: 0x400040,
				0x110000: 0x401000,
				0x120000: 0x80000040,
				0x130000: 0x0,
				0x140000: 0x1040,
				0x150000: 0x80400040,
				0x160000: 0x80401000,
				0x170000: 0x80001040,
				0x180000: 0x80401040,
				0x190000: 0x80000000,
				0x1a0000: 0x80400000,
				0x1b0000: 0x401040,
				0x1c0000: 0x80001000,
				0x1d0000: 0x400000,
				0x1e0000: 0x40,
				0x1f0000: 0x1000,
				0x108000: 0x80400000,
				0x118000: 0x80401040,
				0x128000: 0x0,
				0x138000: 0x401000,
				0x148000: 0x400040,
				0x158000: 0x80000000,
				0x168000: 0x80001040,
				0x178000: 0x40,
				0x188000: 0x80000040,
				0x198000: 0x1000,
				0x1a8000: 0x80001000,
				0x1b8000: 0x80400040,
				0x1c8000: 0x1040,
				0x1d8000: 0x80401000,
				0x1e8000: 0x400000,
				0x1f8000: 0x401040
			}, {
				0x0: 0x80,
				0x1000: 0x1040000,
				0x2000: 0x40000,
				0x3000: 0x20000000,
				0x4000: 0x20040080,
				0x5000: 0x1000080,
				0x6000: 0x21000080,
				0x7000: 0x40080,
				0x8000: 0x1000000,
				0x9000: 0x20040000,
				0xa000: 0x20000080,
				0xb000: 0x21040080,
				0xc000: 0x21040000,
				0xd000: 0x0,
				0xe000: 0x1040080,
				0xf000: 0x21000000,
				0x800: 0x1040080,
				0x1800: 0x21000080,
				0x2800: 0x80,
				0x3800: 0x1040000,
				0x4800: 0x40000,
				0x5800: 0x20040080,
				0x6800: 0x21040000,
				0x7800: 0x20000000,
				0x8800: 0x20040000,
				0x9800: 0x0,
				0xa800: 0x21040080,
				0xb800: 0x1000080,
				0xc800: 0x20000080,
				0xd800: 0x21000000,
				0xe800: 0x1000000,
				0xf800: 0x40080,
				0x10000: 0x40000,
				0x11000: 0x80,
				0x12000: 0x20000000,
				0x13000: 0x21000080,
				0x14000: 0x1000080,
				0x15000: 0x21040000,
				0x16000: 0x20040080,
				0x17000: 0x1000000,
				0x18000: 0x21040080,
				0x19000: 0x21000000,
				0x1a000: 0x1040000,
				0x1b000: 0x20040000,
				0x1c000: 0x40080,
				0x1d000: 0x20000080,
				0x1e000: 0x0,
				0x1f000: 0x1040080,
				0x10800: 0x21000080,
				0x11800: 0x1000000,
				0x12800: 0x1040000,
				0x13800: 0x20040080,
				0x14800: 0x20000000,
				0x15800: 0x1040080,
				0x16800: 0x80,
				0x17800: 0x21040000,
				0x18800: 0x40080,
				0x19800: 0x21040080,
				0x1a800: 0x0,
				0x1b800: 0x21000000,
				0x1c800: 0x1000080,
				0x1d800: 0x40000,
				0x1e800: 0x20040000,
				0x1f800: 0x20000080
			}, {
				0x0: 0x10000008,
				0x100: 0x2000,
				0x200: 0x10200000,
				0x300: 0x10202008,
				0x400: 0x10002000,
				0x500: 0x200000,
				0x600: 0x200008,
				0x700: 0x10000000,
				0x800: 0x0,
				0x900: 0x10002008,
				0xa00: 0x202000,
				0xb00: 0x8,
				0xc00: 0x10200008,
				0xd00: 0x202008,
				0xe00: 0x2008,
				0xf00: 0x10202000,
				0x80: 0x10200000,
				0x180: 0x10202008,
				0x280: 0x8,
				0x380: 0x200000,
				0x480: 0x202008,
				0x580: 0x10000008,
				0x680: 0x10002000,
				0x780: 0x2008,
				0x880: 0x200008,
				0x980: 0x2000,
				0xa80: 0x10002008,
				0xb80: 0x10200008,
				0xc80: 0x0,
				0xd80: 0x10202000,
				0xe80: 0x202000,
				0xf80: 0x10000000,
				0x1000: 0x10002000,
				0x1100: 0x10200008,
				0x1200: 0x10202008,
				0x1300: 0x2008,
				0x1400: 0x200000,
				0x1500: 0x10000000,
				0x1600: 0x10000008,
				0x1700: 0x202000,
				0x1800: 0x202008,
				0x1900: 0x0,
				0x1a00: 0x8,
				0x1b00: 0x10200000,
				0x1c00: 0x2000,
				0x1d00: 0x10002008,
				0x1e00: 0x10202000,
				0x1f00: 0x200008,
				0x1080: 0x8,
				0x1180: 0x202000,
				0x1280: 0x200000,
				0x1380: 0x10000008,
				0x1480: 0x10002000,
				0x1580: 0x2008,
				0x1680: 0x10202008,
				0x1780: 0x10200000,
				0x1880: 0x10202000,
				0x1980: 0x10200008,
				0x1a80: 0x2000,
				0x1b80: 0x202008,
				0x1c80: 0x200008,
				0x1d80: 0x0,
				0x1e80: 0x10000000,
				0x1f80: 0x10002008
			}, {
				0x0: 0x100000,
				0x10: 0x2000401,
				0x20: 0x400,
				0x30: 0x100401,
				0x40: 0x2100401,
				0x50: 0x0,
				0x60: 0x1,
				0x70: 0x2100001,
				0x80: 0x2000400,
				0x90: 0x100001,
				0xa0: 0x2000001,
				0xb0: 0x2100400,
				0xc0: 0x2100000,
				0xd0: 0x401,
				0xe0: 0x100400,
				0xf0: 0x2000000,
				0x8: 0x2100001,
				0x18: 0x0,
				0x28: 0x2000401,
				0x38: 0x2100400,
				0x48: 0x100000,
				0x58: 0x2000001,
				0x68: 0x2000000,
				0x78: 0x401,
				0x88: 0x100401,
				0x98: 0x2000400,
				0xa8: 0x2100000,
				0xb8: 0x100001,
				0xc8: 0x400,
				0xd8: 0x2100401,
				0xe8: 0x1,
				0xf8: 0x100400,
				0x100: 0x2000000,
				0x110: 0x100000,
				0x120: 0x2000401,
				0x130: 0x2100001,
				0x140: 0x100001,
				0x150: 0x2000400,
				0x160: 0x2100400,
				0x170: 0x100401,
				0x180: 0x401,
				0x190: 0x2100401,
				0x1a0: 0x100400,
				0x1b0: 0x1,
				0x1c0: 0x0,
				0x1d0: 0x2100000,
				0x1e0: 0x2000001,
				0x1f0: 0x400,
				0x108: 0x100400,
				0x118: 0x2000401,
				0x128: 0x2100001,
				0x138: 0x1,
				0x148: 0x2000000,
				0x158: 0x100000,
				0x168: 0x401,
				0x178: 0x2100400,
				0x188: 0x2000001,
				0x198: 0x2100000,
				0x1a8: 0x0,
				0x1b8: 0x2100401,
				0x1c8: 0x100401,
				0x1d8: 0x400,
				0x1e8: 0x2000400,
				0x1f8: 0x100001
			}, {
				0x0: 0x8000820,
				0x1: 0x20000,
				0x2: 0x8000000,
				0x3: 0x20,
				0x4: 0x20020,
				0x5: 0x8020820,
				0x6: 0x8020800,
				0x7: 0x800,
				0x8: 0x8020000,
				0x9: 0x8000800,
				0xa: 0x20800,
				0xb: 0x8020020,
				0xc: 0x820,
				0xd: 0x0,
				0xe: 0x8000020,
				0xf: 0x20820,
				0x80000000: 0x800,
				0x80000001: 0x8020820,
				0x80000002: 0x8000820,
				0x80000003: 0x8000000,
				0x80000004: 0x8020000,
				0x80000005: 0x20800,
				0x80000006: 0x20820,
				0x80000007: 0x20,
				0x80000008: 0x8000020,
				0x80000009: 0x820,
				0x8000000a: 0x20020,
				0x8000000b: 0x8020800,
				0x8000000c: 0x0,
				0x8000000d: 0x8020020,
				0x8000000e: 0x8000800,
				0x8000000f: 0x20000,
				0x10: 0x20820,
				0x11: 0x8020800,
				0x12: 0x20,
				0x13: 0x800,
				0x14: 0x8000800,
				0x15: 0x8000020,
				0x16: 0x8020020,
				0x17: 0x20000,
				0x18: 0x0,
				0x19: 0x20020,
				0x1a: 0x8020000,
				0x1b: 0x8000820,
				0x1c: 0x8020820,
				0x1d: 0x20800,
				0x1e: 0x820,
				0x1f: 0x8000000,
				0x80000010: 0x20000,
				0x80000011: 0x800,
				0x80000012: 0x8020020,
				0x80000013: 0x20820,
				0x80000014: 0x20,
				0x80000015: 0x8020000,
				0x80000016: 0x8000000,
				0x80000017: 0x8000820,
				0x80000018: 0x8020820,
				0x80000019: 0x8000020,
				0x8000001a: 0x8000800,
				0x8000001b: 0x0,
				0x8000001c: 0x20800,
				0x8000001d: 0x820,
				0x8000001e: 0x20020,
				0x8000001f: 0x8020800
			}];
	
			// Masks that select the SBOX input
			var SBOX_MASK = [0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000, 0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f];
	
			/**
	   * DES block cipher algorithm.
	   */
			var DES = C_algo.DES = BlockCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
	
					// Select 56 bits according to PC1
					var keyBits = [];
					for (var i = 0; i < 56; i++) {
						var keyBitPos = PC1[i] - 1;
						keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
					}
	
					// Assemble 16 subkeys
					var subKeys = this._subKeys = [];
					for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
						// Create subkey
						var subKey = subKeys[nSubKey] = [];
	
						// Shortcut
						var bitShift = BIT_SHIFTS[nSubKey];
	
						// Select 48 bits according to PC2
						for (var i = 0; i < 24; i++) {
							// Select from the left 28 key bits
							subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
	
							// Select from the right 28 key bits
							subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
						}
	
						// Since each subkey is applied to an expanded 32-bit input,
						// the subkey can be broken into 8 values scaled to 32-bits,
						// which allows the key to be used without expansion
						subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
						for (var i = 1; i < 7; i++) {
							subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
						}
						subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
					}
	
					// Compute inverse subkeys
					var invSubKeys = this._invSubKeys = [];
					for (var i = 0; i < 16; i++) {
						invSubKeys[i] = subKeys[15 - i];
					}
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._subKeys);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._invSubKeys);
				},
	
				_doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
					// Get input
					this._lBlock = M[offset];
					this._rBlock = M[offset + 1];
	
					// Initial permutation
					exchangeLR.call(this, 4, 0x0f0f0f0f);
					exchangeLR.call(this, 16, 0x0000ffff);
					exchangeRL.call(this, 2, 0x33333333);
					exchangeRL.call(this, 8, 0x00ff00ff);
					exchangeLR.call(this, 1, 0x55555555);
	
					// Rounds
					for (var round = 0; round < 16; round++) {
						// Shortcuts
						var subKey = subKeys[round];
						var lBlock = this._lBlock;
						var rBlock = this._rBlock;
	
						// Feistel function
						var f = 0;
						for (var i = 0; i < 8; i++) {
							f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
						}
						this._lBlock = rBlock;
						this._rBlock = lBlock ^ f;
					}
	
					// Undo swap from last round
					var t = this._lBlock;
					this._lBlock = this._rBlock;
					this._rBlock = t;
	
					// Final permutation
					exchangeLR.call(this, 1, 0x55555555);
					exchangeRL.call(this, 8, 0x00ff00ff);
					exchangeRL.call(this, 2, 0x33333333);
					exchangeLR.call(this, 16, 0x0000ffff);
					exchangeLR.call(this, 4, 0x0f0f0f0f);
	
					// Set output
					M[offset] = this._lBlock;
					M[offset + 1] = this._rBlock;
				},
	
				keySize: 64 / 32,
	
				ivSize: 64 / 32,
	
				blockSize: 64 / 32
			});
	
			// Swap bits across the left and right words
			function exchangeLR(offset, mask) {
				var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
				this._rBlock ^= t;
				this._lBlock ^= t << offset;
			}
	
			function exchangeRL(offset, mask) {
				var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
				this._lBlock ^= t;
				this._rBlock ^= t << offset;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	   */
			C.DES = BlockCipher._createHelper(DES);
	
			/**
	   * Triple-DES block cipher algorithm.
	   */
			var TripleDES = C_algo.TripleDES = BlockCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
					// Make sure the key length is valid (64, 128 or >= 192 bit)
					if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
						throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
					}
	
					// Extend the key according to the keying options defined in 3DES standard
					var key1 = keyWords.slice(0, 2);
					var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
					var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
	
					// Create DES instances
					this._des1 = DES.createEncryptor(WordArray.create(key1));
					this._des2 = DES.createEncryptor(WordArray.create(key2));
					this._des3 = DES.createEncryptor(WordArray.create(key3));
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._des1.encryptBlock(M, offset);
					this._des2.decryptBlock(M, offset);
					this._des3.encryptBlock(M, offset);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					this._des3.decryptBlock(M, offset);
					this._des2.encryptBlock(M, offset);
					this._des1.decryptBlock(M, offset);
				},
	
				keySize: 192 / 32,
	
				ivSize: 64 / 32,
	
				blockSize: 64 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	   */
			C.TripleDES = BlockCipher._createHelper(TripleDES);
		})();
	
		return CryptoJS.TripleDES;
	});

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(238),
	    _assign = __webpack_require__(53);
	
	var ReactNoopUpdateQueue = __webpack_require__(616);
	
	var canDefineProperty = __webpack_require__(617);
	var emptyObject = __webpack_require__(287);
	var invariant = __webpack_require__(32);
	var lowPriorityWarning = __webpack_require__(1144);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !((typeof partialState === 'undefined' ? 'undefined' : _typeof(partialState)) === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function get() {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(44);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function isMounted(publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function enqueueCallback(publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function enqueueForceUpdate(publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function enqueueSetState(publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function get() {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var SgiBadgeEO = function SgiBadgeEO() {
		return {
			desId: "EP_EO_UI_4009"
		};
	};
	
	exports.SgiBadgeEO = SgiBadgeEO;
	exports.default = SgiBadgeEO;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiCardEO = function SgiCardEO() {
	    return {
	        cId: "",
	        ctlN: "层叠面板",
	        ctlH: '100%',
	        ctlW: '100%',
	        desId: "EP_EO_UI_4103",
	        te: "",
	        pad: "0 0 0 0",
	        mgn: "0 0 0 0",
	        // ctlN: "层叠面板",
	        // isHdn: false,
	        isBrdr: true
	        // flx: 6,
	        // iconPh: "SD_RP_IR_0001`UI`UI05",
	        // isBdyBrdr: true,
	        // isBrdr: false,
	        // isClp: false,
	        // isClpFst: true,
	        // isCls: false,
	        // isDis: false,
	        // isFrm: false,
	        // isHClpTl: false,
	        // clpDrt: "top",
	        // clpd: false,
	        // csstyle: "80",
	        // isRead: false,
	        // isScl: false,
	        // isTtl: false,
	        // isttlClp: false,
	        // n: "视图类型层叠",
	        // new_flag: true,
	        // prmVsn: "0",
	        // sNo: 2,
	        // sc: "20171225090149727136",
	        // ttlAlg: "top",
	        // ttlAlgn: "left",
	        // useTim: 0,
	        // visible: true,
	        // x: "0",
	        // y: "0"
	    };
	};
	exports.SgiCardEO = SgiCardEO;
	exports.default = SgiCardEO;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Row布局
	 * wzhe
	 */
	var SgiQuoteEO = function SgiQuoteEO() {
	    return {
	        desId: "EP_EO_UI_4005",
	        type: 'copy',
	        isInRoot: 'yes',
	        quoteUID: '',
	        ctlN: "引用组件"
	    };
	};
	exports.SgiQuoteEO = SgiQuoteEO;
	exports.default = SgiQuoteEO;

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiSpinEO = function SgiSpinEO() {
	    return {
	        ctlH: '100%',
	        ctlW: '100%',
	        style: { minHeight: '200px' },
	        desId: "EP_EO_UI_4006",
	        loading: false //初始加载中
	    };
	};
	
	exports.SgiSpinEO = SgiSpinEO;
	exports.default = SgiSpinEO;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 图片
	 * 
	 */
	
	var SgiTagEO = function SgiTagEO() {
	
	    return {
	        disply: "", //图片地址
	        // alt: "图片加载失败",//规定图像的替代文本
	        ctlH: "",
	        ctlW: "",
	        // ctlH: "",
	        // ctlW: "",
	        desId: "EP_EO_UI_3018",
	        c: '', //
	        ctlN: "Tag",
	        cId: '', //组件编号
	        // sc:'',//语义代码
	        n: "Tag",
	        // t: "text",
	        te: "Tag"
	
	    };
	};
	
	exports.SgiTagEO = SgiTagEO;
	exports.default = SgiTagEO;

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiTinyMCEEO = function SgiTinyMCEEO() {
	    return {
	        alwBlk: true,
	        ctlH: 0,
	        ctlW: 24,
	        lblW: 6,
	        desId: "EP_EO_UI_SgiTinyMCE",
	        isDis: false,
	        isHdn: false,
	        isLbl: false,
	        lblAlg: "right",
	        bdText: '',
	        maxL: 0,
	        minL: 0,
	        te: "tinymce富文本",
	        teAl: "left",
	        vldC: "",
	        inpPopTe: "请编辑",
	        ctlN: "tinymce富文本"
	    };
	};
	
	exports.SgiTinyMCEEO = SgiTinyMCEEO;
	exports.default = SgiTinyMCEEO;

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiTooltipEO = function SgiTooltipEO() {
	    return {
	        te: "提示",
	        desId: "EP_EO_UI_4008"
	    };
	};
	
	exports.SgiTooltipEO = SgiTooltipEO;
	exports.default = SgiTooltipEO;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _antd = __webpack_require__(296);
	
	var Step = _antd.Steps.Step; /*
	                              * @Descripttion: 
	                              * @version: 
	                              * @Author: hanzb
	                              * @Date: 2019-11-21 14:58:04
	                              * @LastEditors: hanzb
	                              * @LastEditTime: 2020-04-23 14:22:54
	                              */
	
	var sgiAntdModule = {
		"Button": _antd.Button,
		"Icon": _antd.Icon,
		"Row": _antd.Row,
		"Col": _antd.Col,
		"Menu": _antd.Menu,
		"Pagination": _antd.Pagination,
		"Steps": _antd.Steps,
		"Step": Step,
		"Checkbox": _antd.Checkbox,
		"Cascader": _antd.Cascader,
		"DatePicker": _antd.DatePicker,
		"Form": _antd.Form,
		"Input": _antd.Input,
		"InputNumber": _antd.InputNumber,
		"Mention": _antd.Mention,
		"Rate": _antd.Rate,
		"Radio": _antd.Radio,
		"Switch": _antd.Switch,
		"Slider": _antd.Slider,
		"Select": _antd.Select,
		"TreeSelect": _antd.TreeSelect,
		"Transfer": _antd.Transfer,
		"TimePicker": _antd.TimePicker,
		"Upload": _antd.Upload,
		"Avatar": _antd.Avatar,
		"Badge": _antd.Badge,
		"Comment": _antd.Comment,
		"Collapse": _antd.Collapse,
		"Carousel": _antd.Carousel,
		"Card": _antd.Card,
		"Calendar": _antd.Calendar,
		"Empty": _antd.Empty,
		"List": _antd.List,
		"Popover": _antd.Popover,
		// "Statistic": Statistic,
		"Tree": _antd.Tree,
		"Tooltip": _antd.Tooltip,
		"Timeline": _antd.Timeline,
		"Tag": _antd.Tag,
		"Tabs": _antd.Tabs,
		"Table": _antd.Table,
		"Alert": _antd.Alert,
		"Drawer": _antd.Drawer,
		"Modal": _antd.Modal,
		"message": _antd.message,
		"notification": _antd.notification,
		"Progress": _antd.Progress,
		"Popconfirm": _antd.Popconfirm,
		"Spin": _antd.Spin,
		"skeSkeleton": _antd.Skeleton,
		"Anchor": _antd.Anchor,
		"BackTop": _antd.BackTop,
		"ConfigProvider": _antd.ConfigProvider,
		"Divider": _antd.Divider,
		"LocaleProvider": _antd.LocaleProvider,
		"AutoComplete": _antd.AutoComplete,
		"Dropdown": _antd.Dropdown
	
		// 初始化
	};if (!window.sgiAntdModule) window.sgiAntdModule = {};
	// 添加方法
	Object.assign(window.sgiAntdModule, sgiAntdModule);
	// 导出
	exports.default = window.sgiAntdModule;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElement = undefined;
	
	var _DataType = __webpack_require__(627);
	
	var _PrmFactory = __webpack_require__(63);
	
	/*  数据元提供者
	 归属：企通前端平台-ECP V5.1
	 版权：2014-2020 企通软件技术有限公司
	 --------------------------------------------------------------------------------
	 作者：吴凤楠                         创建日期：2014/05/04
	 修改：                               修改日期：
	 修改内容
	 --------------------------------------------------------------------------------
	 
	 
	 
	 *******************************************************************************/
	var DataElement = window.DataElement = {
	    /**
	     * 对外接口，根据sguid取得数据元信息
	     * @param {String} key
	     * @returns 数据元对象
	     */
	    getDE: function getDE(key) {
	        var de;
	        // var ap = sgiCommon.getAP(key);
	        var ap = tool.Global.currentAP;
	        if (!ap) {
	            de = {};
	            return de;
	        }
	        var deMap = DataElement[ap + "DeMap"];
	        if (!deMap) {
	            deMap = this.loadDE(ap);
	        }
	        de = deMap[key];
	        if (!de) {
	            de = {};
	            return de;
	        }
	        return de;
	    },
	    /**
	     * 加载数据元到缓存对象
	     * @param {String} ap
	     * @return {map} deMap
	     */
	    loadDE: function loadDE(ap) {
	        var deMap = {};
	        DataElement[ap + "DeMap"] = deMap;
	
	        // var deMap = DataElement[ap + "DeMap"];
	        //数据元缓存对象
	        var guid = ap + '_MD_DE_0001';
	        var ddTree = _PrmFactory.PrmFactory.getPrm(guid);
	        ddTree.cldSet.forEach(function (record) {
	            var dt = _DataType.DataType.getDT(record.t);
	            record.jst = dt.c;
	            record.dbt = dt.dbt; //数据类型
	            record.jt = dt.t; //程序类型
	            deMap[record.sc] = record;
	        });
	        return deMap;
	    }
	};
	exports.DataElement = DataElement;
	exports.default = DataElement;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataType = undefined;
	
	var _PrmFactory = __webpack_require__(63);
	
	var DataType = window.DataType = {
	    /**
	     * 对外接口，根据sguid取得数据类型信息
	     * @param {String} sguid
	     * @returns 数据类型对象
	     */
	    getDT: function getDT(sguid) {
	        var dt;
	        // var ap = sgiCommon.getAP(sguid);
	        var ap = tool.Global.currentAP;
	        if (!ap) {
	            dt = {};
	            return dt;
	        }
	        var dtMap = DataType[ap + "DtMap"];
	        if (!dtMap) {
	
	            dtMap = this.loadDT(ap);
	        }
	        dt = dtMap[sguid];
	        if (!dt) {
	            dt = {};
	            return dt;
	        }
	        return dt;
	    },
	    /**
	      * 加载数据类型缓存对象
	      * @param {String} ap
	      * @return {map} dtMap
	      */
	    loadDT: function loadDT(ap) {
	        var dtMap = {};
	        DataType[ap + "DtMap"] = dtMap;
	        // var dtMap = Ep[ap + "DtMap"];
	        //数据类型缓存对象
	        var guid = ap + '_MD_DT_0001';
	        var dtTree = _PrmFactory.PrmFactory.getPrm(guid);
	        dtTree.cldSet.forEach(function (record) {
	            dtMap[record.sc] = record;
	        });
	        return dtMap;
	    }
	}; /*  数据类型提供者
	    归属：企通前端平台-ECP V5.1
	    版权：2014-2020 企通软件技术有限公司
	    --------------------------------------------------------------------------------
	    作者：吴凤楠                         创建日期：2014/05/04
	    修改：wangj                               修改日期：2018/6/11
	    修改内容
	    --------------------------------------------------------------------------------
	    
	    
	    
	    *******************************************************************************/
	exports.DataType = DataType;
	exports.default = DataType;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PresetColorTypes = void 0;
	
	var _type = __webpack_require__(82);
	
	// eslint-disable-next-line import/prefer-default-export
	var PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
	exports.PresetColorTypes = PresetColorTypes;

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getDataOrAriaProps;
	
	function getDataOrAriaProps(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
	      prev[key] = props[key];
	    }
	
	    return prev;
	  }, {});
	}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	// ================== Collapse Motion ==================
	var getCollapsedHeight = function getCollapsedHeight() {
	  return {
	    height: 0,
	    opacity: 0
	  };
	};
	
	var getRealHeight = function getRealHeight(node) {
	  return {
	    height: node.scrollHeight,
	    opacity: 1
	  };
	};
	
	var getCurrentHeight = function getCurrentHeight(node) {
	  return {
	    height: node.offsetHeight
	  };
	};
	
	var collapseMotion = {
	  motionName: 'ant-motion-collapse',
	  onAppearStart: getCollapsedHeight,
	  onEnterStart: getCollapsedHeight,
	  onAppearActive: getRealHeight,
	  onEnterActive: getRealHeight,
	  onLeaveStart: getCurrentHeight,
	  onLeaveActive: getCollapsedHeight
	};
	var _default = collapseMotion;
	exports["default"] = _default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cloneElement = cloneElement;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	// eslint-disable-next-line import/prefer-default-export
	function cloneElement(element) {
	  if (! /*#__PURE__*/React.isValidElement(element)) return element;
	
	  for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    restArgs[_key - 1] = arguments[_key];
	  }
	
	  return React.cloneElement.apply(React, [element].concat(restArgs));
	}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.responsiveMap = exports.responsiveArray = void 0;
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	var enquire; // TODO: Will be removed in antd 4.0 because we will no longer support ie9
	
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill; // eslint-disable-next-line global-require
	
	  enquire = __webpack_require__(496);
	}
	
	var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
	exports.responsiveArray = responsiveArray;
	var responsiveMap = {
	  xs: '(max-width: 575px)',
	  sm: '(min-width: 576px)',
	  md: '(min-width: 768px)',
	  lg: '(min-width: 992px)',
	  xl: '(min-width: 1200px)',
	  xxl: '(min-width: 1600px)'
	};
	exports.responsiveMap = responsiveMap;
	var subscribers = [];
	var subUid = -1;
	var screens = {};
	var responsiveObserve = {
	  dispatch: function dispatch(pointMap) {
	    screens = pointMap;
	
	    if (subscribers.length < 1) {
	      return false;
	    }
	
	    subscribers.forEach(function (item) {
	      item.func(screens);
	    });
	    return true;
	  },
	  subscribe: function subscribe(func) {
	    if (subscribers.length === 0) {
	      this.register();
	    }
	
	    var token = (++subUid).toString();
	    subscribers.push({
	      token: token,
	      func: func
	    });
	    func(screens);
	    return token;
	  },
	  unsubscribe: function unsubscribe(token) {
	    subscribers = subscribers.filter(function (item) {
	      return item.token !== token;
	    });
	
	    if (subscribers.length === 0) {
	      this.unregister();
	    }
	  },
	  unregister: function unregister() {
	    Object.keys(responsiveMap).map(function (screen) {
	      return enquire.unregister(responsiveMap[screen]);
	    });
	  },
	  register: function register() {
	    var _this = this;
	
	    Object.keys(responsiveMap).map(function (screen) {
	      return enquire.register(responsiveMap[screen], {
	        match: function match() {
	          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, true));
	
	          _this.dispatch(pointMap);
	        },
	        unmatch: function unmatch() {
	          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, false));
	
	          _this.dispatch(pointMap);
	        },
	        // Keep a empty destory to avoid triggering unmatch when unregister
	        destroy: function destroy() {}
	      });
	    });
	  }
	};
	var _default = responsiveObserve;
	exports["default"] = _default;

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.isFlexSupported = void 0;
	
	var isStyleSupport = function isStyleSupport(styleName) {
	  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
	    var documentElement = window.document.documentElement;
	    return styleNameList.some(function (name) {
	      return name in documentElement.style;
	    });
	  }
	
	  return false;
	};
	
	var isFlexSupported = isStyleSupport(['flex', 'webkitFlex', 'Flex', 'msFlex']);
	exports.isFlexSupported = isFlexSupported;
	var _default = isStyleSupport;
	exports["default"] = _default;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _configProvider = __webpack_require__(14);
	
	var _throttleByAnimationFrame = __webpack_require__(1164);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(1166);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
	  var c = arguments.length,
	      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	      d;
	  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	  }
	  return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	function getDefaultTarget() {
	  return typeof window !== 'undefined' ? window : null;
	}
	
	var AffixStatus;
	
	(function (AffixStatus) {
	  AffixStatus[AffixStatus["None"] = 0] = "None";
	  AffixStatus[AffixStatus["Prepare"] = 1] = "Prepare";
	})(AffixStatus || (AffixStatus = {}));
	
	var Affix = /*#__PURE__*/function (_React$Component) {
	  _inherits(Affix, _React$Component);
	
	  var _super = _createSuper(Affix);
	
	  function Affix() {
	    var _this;
	
	    _classCallCheck(this, Affix);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      status: AffixStatus.None,
	      lastAffix: false,
	      prevTarget: null
	    };
	
	    _this.getOffsetTop = function () {
	      var _this$props = _this.props,
	          offset = _this$props.offset,
	          offsetBottom = _this$props.offsetBottom;
	      var offsetTop = _this.props.offsetTop;
	
	      if (typeof offsetTop === 'undefined') {
	        offsetTop = offset;
	        (0, _warning["default"])(typeof offset === 'undefined', 'Affix', '`offset` is deprecated. Please use `offsetTop` instead.');
	      }
	
	      if (offsetBottom === undefined && offsetTop === undefined) {
	        offsetTop = 0;
	      }
	
	      return offsetTop;
	    };
	
	    _this.getOffsetBottom = function () {
	      return _this.props.offsetBottom;
	    };
	
	    _this.savePlaceholderNode = function (node) {
	      _this.placeholderNode = node;
	    };
	
	    _this.saveFixedNode = function (node) {
	      _this.fixedNode = node;
	    }; // =================== Measure ===================
	
	
	    _this.measure = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          lastAffix = _this$state.lastAffix;
	      var _this$props2 = _this.props,
	          target = _this$props2.target,
	          onChange = _this$props2.onChange;
	
	      if (status !== AffixStatus.Prepare || !_this.fixedNode || !_this.placeholderNode || !target) {
	        return;
	      }
	
	      var offsetTop = _this.getOffsetTop();
	
	      var offsetBottom = _this.getOffsetBottom();
	
	      var targetNode = target();
	
	      if (!targetNode) {
	        return;
	      }
	
	      var newState = {
	        status: AffixStatus.None
	      };
	      var targetRect = (0, _utils.getTargetRect)(targetNode);
	      var placeholderReact = (0, _utils.getTargetRect)(_this.placeholderNode);
	      var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
	      var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);
	
	      if (fixedTop !== undefined) {
	        newState.affixStyle = {
	          position: 'fixed',
	          top: fixedTop,
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	        newState.placeholderStyle = {
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	      } else if (fixedBottom !== undefined) {
	        newState.affixStyle = {
	          position: 'fixed',
	          bottom: fixedBottom,
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	        newState.placeholderStyle = {
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	      }
	
	      newState.lastAffix = !!newState.affixStyle;
	
	      if (onChange && lastAffix !== newState.lastAffix) {
	        onChange(newState.lastAffix);
	      }
	
	      _this.setState(newState);
	    }; // @ts-ignore TS6133
	
	
	    _this.prepareMeasure = function () {
	      // event param is used before. Keep compatible ts define here.
	      _this.setState({
	        status: AffixStatus.Prepare,
	        affixStyle: undefined,
	        placeholderStyle: undefined
	      }); // Test if `updatePosition` called
	
	
	      if (false) {
	        var onTestUpdatePosition = _this.props.onTestUpdatePosition;
	
	        if (onTestUpdatePosition) {
	          onTestUpdatePosition();
	        }
	      }
	    }; // =================== Render ===================
	
	
	    _this.renderAffix = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$state2 = _this.state,
	          affixStyle = _this$state2.affixStyle,
	          placeholderStyle = _this$state2.placeholderStyle;
	      var _this$props3 = _this.props,
	          prefixCls = _this$props3.prefixCls,
	          children = _this$props3.children;
	      var className = (0, _classnames["default"])(_defineProperty({}, getPrefixCls('affix', prefixCls), affixStyle));
	      var props = (0, _omit["default"])(_this.props, ['prefixCls', 'offsetTop', 'offsetBottom', 'target', 'onChange']); // Omit this since `onTestUpdatePosition` only works on test.
	
	      if (false) {
	        props = (0, _omit["default"])(props, ['onTestUpdatePosition']);
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: function onResize() {
	            _this.updatePosition();
	          }
	        }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
	          ref: _this.savePlaceholderNode
	        }), affixStyle && /*#__PURE__*/React.createElement("div", {
	          style: placeholderStyle,
	          "aria-hidden": "true"
	        }), /*#__PURE__*/React.createElement("div", {
	          className: className,
	          ref: _this.saveFixedNode,
	          style: affixStyle
	        }, /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: function onResize() {
	            _this.updatePosition();
	          }
	        }, children))))
	      );
	    };
	
	    return _this;
	  } // Event handler
	
	
	  _createClass(Affix, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var target = this.props.target;
	
	      if (target) {
	        // [Legacy] Wait for parent component ref has its value.
	        // We should use target as directly element instead of function which makes element check hard.
	        this.timeout = setTimeout(function () {
	          (0, _utils.addObserveTarget)(target(), _this2); // Mock Event object.
	
	          _this2.updatePosition();
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var prevTarget = this.state.prevTarget;
	      var target = this.props.target;
	      var newTarget = null;
	
	      if (target) {
	        newTarget = target() || null;
	      }
	
	      if (prevTarget !== newTarget) {
	        (0, _utils.removeObserveTarget)(this);
	
	        if (newTarget) {
	          (0, _utils.addObserveTarget)(newTarget, this); // Mock Event object.
	
	          this.updatePosition();
	        }
	
	        this.setState({
	          prevTarget: newTarget
	        });
	      }
	
	      if (prevProps.offsetTop !== this.props.offsetTop || prevProps.offsetBottom !== this.props.offsetBottom) {
	        this.updatePosition();
	      }
	
	      this.measure();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	      (0, _utils.removeObserveTarget)(this);
	      this.updatePosition.cancel(); // https://github.com/ant-design/ant-design/issues/22683
	
	      this.lazyUpdatePosition.cancel();
	    } // Handle realign logic
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      this.prepareMeasure();
	    }
	  }, {
	    key: "lazyUpdatePosition",
	    value: function lazyUpdatePosition() {
	      var target = this.props.target;
	      var affixStyle = this.state.affixStyle; // Check position change before measure to make Safari smooth
	
	      if (target && affixStyle) {
	        var offsetTop = this.getOffsetTop();
	        var offsetBottom = this.getOffsetBottom();
	        var targetNode = target();
	
	        if (targetNode && this.placeholderNode) {
	          var targetRect = (0, _utils.getTargetRect)(targetNode);
	          var placeholderReact = (0, _utils.getTargetRect)(this.placeholderNode);
	          var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
	          var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);
	
	          if (fixedTop !== undefined && affixStyle.top === fixedTop || fixedBottom !== undefined && affixStyle.bottom === fixedBottom) {
	            return;
	          }
	        }
	      } // Directly call prepare measure since it's already throttled.
	
	
	      this.prepareMeasure();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAffix)
	      );
	    }
	  }]);
	
	  return Affix;
	}(React.Component);
	
	Affix.defaultProps = {
	  target: getDefaultTarget
	};
	
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "updatePosition", null);
	
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "lazyUpdatePosition", null);
	
	(0, _reactLifecyclesCompat.polyfill)(Affix);
	var _default = Affix;
	exports["default"] = _default;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Avatar = /*#__PURE__*/function (_React$Component) {
	  _inherits(Avatar, _React$Component);
	
	  var _super = _createSuper(Avatar);
	
	  function Avatar() {
	    var _this;
	
	    _classCallCheck(this, Avatar);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      scale: 1,
	      mounted: false,
	      isImgExist: true
	    };
	
	    _this.setScale = function () {
	      if (!_this.avatarChildren || !_this.avatarNode) {
	        return;
	      }
	
	      var childrenWidth = _this.avatarChildren.offsetWidth; // offsetWidth avoid affecting be transform scale
	
	      var nodeWidth = _this.avatarNode.offsetWidth; // denominator is 0 is no meaning
	
	      if (childrenWidth === 0 || nodeWidth === 0 || _this.lastChildrenWidth === childrenWidth && _this.lastNodeWidth === nodeWidth) {
	        return;
	      }
	
	      _this.lastChildrenWidth = childrenWidth;
	      _this.lastNodeWidth = nodeWidth; // add 4px gap for each side to get better performance
	
	      _this.setState({
	        scale: nodeWidth - 8 < childrenWidth ? (nodeWidth - 8) / childrenWidth : 1
	      });
	    };
	
	    _this.handleImgLoadError = function () {
	      var onError = _this.props.onError;
	      var errorFlag = onError ? onError() : undefined;
	
	      if (errorFlag !== false) {
	        _this.setState({
	          isImgExist: false
	        });
	      }
	    };
	
	    _this.renderAvatar = function (_ref) {
	      var _classNames, _classNames2;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          shape = _a.shape,
	          size = _a.size,
	          src = _a.src,
	          srcSet = _a.srcSet,
	          icon = _a.icon,
	          className = _a.className,
	          alt = _a.alt,
	          others = __rest(_a, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "alt"]);
	
	      var _this$state = _this.state,
	          isImgExist = _this$state.isImgExist,
	          scale = _this$state.scale,
	          mounted = _this$state.mounted;
	      var prefixCls = getPrefixCls('avatar', customizePrefixCls);
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
	      var classString = (0, _classnames["default"])(prefixCls, className, sizeCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames2, "".concat(prefixCls, "-image"), src && isImgExist), _defineProperty(_classNames2, "".concat(prefixCls, "-icon"), icon), _classNames2));
	      var sizeStyle = typeof size === 'number' ? {
	        width: size,
	        height: size,
	        lineHeight: "".concat(size, "px"),
	        fontSize: icon ? size / 2 : 18
	      } : {};
	      var children = _this.props.children;
	
	      if (src && isImgExist) {
	        children = /*#__PURE__*/React.createElement("img", {
	          src: src,
	          srcSet: srcSet,
	          onError: _this.handleImgLoadError,
	          alt: alt
	        });
	      } else if (icon) {
	        if (typeof icon === 'string') {
	          children = /*#__PURE__*/React.createElement(_icon["default"], {
	            type: icon
	          });
	        } else {
	          children = icon;
	        }
	      } else {
	        var childrenNode = _this.avatarChildren;
	
	        if (childrenNode || scale !== 1) {
	          var transformString = "scale(".concat(scale, ") translateX(-50%)");
	          var childrenStyle = {
	            msTransform: transformString,
	            WebkitTransform: transformString,
	            transform: transformString
	          };
	          var sizeChildrenStyle = typeof size === 'number' ? {
	            lineHeight: "".concat(size, "px")
	          } : {};
	          children = /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-string"),
	            ref: function ref(node) {
	              return _this.avatarChildren = node;
	            },
	            style: _extends(_extends({}, sizeChildrenStyle), childrenStyle)
	          }, children);
	        } else {
	          var _childrenStyle = {};
	
	          if (!mounted) {
	            _childrenStyle.opacity = 0;
	          }
	
	          children = /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-string"),
	            style: {
	              opacity: 0
	            },
	            ref: function ref(node) {
	              return _this.avatarChildren = node;
	            }
	          }, children);
	        }
	      }
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, others, {
	          style: _extends(_extends({}, sizeStyle), others.style),
	          className: classString,
	          ref: function ref(node) {
	            return _this.avatarNode = node;
	          }
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Avatar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setScale();
	      this.setState({
	        mounted: true
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.setScale();
	
	      if (prevProps.src !== this.props.src) {
	        this.setState({
	          isImgExist: true,
	          scale: 1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAvatar)
	      );
	    }
	  }]);
	
	  return Avatar;
	}(React.Component);
	
	exports["default"] = Avatar;
	Avatar.defaultProps = {
	  shape: 'circle',
	  size: 'default'
	};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(355));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var BreadcrumbItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(BreadcrumbItem, _React$Component);
	
	  var _super = _createSuper(BreadcrumbItem);
	
	  function BreadcrumbItem() {
	    var _this;
	
	    _classCallCheck(this, BreadcrumbItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderBreadcrumbItem = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          separator = _a.separator,
	          children = _a.children,
	          restProps = __rest(_a, ["prefixCls", "separator", "children"]);
	
	      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
	      var link;
	
	      if ('href' in _this.props) {
	        link = /*#__PURE__*/React.createElement("a", _extends({
	          className: "".concat(prefixCls, "-link")
	        }, (0, _omit["default"])(restProps, ['overlay'])), children);
	      } else {
	        link = /*#__PURE__*/React.createElement("span", _extends({
	          className: "".concat(prefixCls, "-link")
	        }, (0, _omit["default"])(restProps, ['overlay'])), children);
	      } // wrap to dropDown
	
	
	      link = _this.renderBreadcrumbNode(link, prefixCls);
	
	      if (children) {
	        return (/*#__PURE__*/React.createElement("span", null, link, separator && separator !== '' && /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-separator")
	          }, separator))
	        );
	      }
	
	      return null;
	    };
	    /**
	     * if overlay is have
	     * Wrap a DropDown
	     */
	
	    _this.renderBreadcrumbNode = function (breadcrumbItem, prefixCls) {
	      var overlay = _this.props.overlay;
	
	      if (overlay) {
	        return (/*#__PURE__*/React.createElement(_dropdown["default"], {
	            overlay: overlay,
	            placement: "bottomCenter"
	          }, /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-overlay-link")
	          }, breadcrumbItem, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "down"
	          })))
	        );
	      }
	
	      return breadcrumbItem;
	    };
	
	    return _this;
	  }
	
	  _createClass(BreadcrumbItem, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumbItem)
	      );
	    }
	  }]);
	
	  return BreadcrumbItem;
	}(React.Component);
	
	exports["default"] = BreadcrumbItem;
	BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
	BreadcrumbItem.defaultProps = {
	  separator: '/'
	};
	BreadcrumbItem.propTypes = {
	  prefixCls: PropTypes.string,
	  separator: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	  href: PropTypes.string
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Breadcrumb = _interopRequireDefault(__webpack_require__(1176));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(636));
	
	var _BreadcrumbSeparator = _interopRequireDefault(__webpack_require__(1177));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Breadcrumb["default"].Item = _BreadcrumbItem["default"];
	_Breadcrumb["default"].Separator = _BreadcrumbSeparator["default"];
	var _default = _Breadcrumb["default"];
	exports["default"] = _default;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(354));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _en_US["default"];
	exports["default"] = _default;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(187));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Checkbox = /*#__PURE__*/function (_React$Component) {
	  _inherits(Checkbox, _React$Component);
	
	  var _super = _createSuper(Checkbox);
	
	  function Checkbox() {
	    var _this;
	
	    _classCallCheck(this, Checkbox);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.renderCheckbox = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          indeterminate = props.indeterminate,
	          style = props.style,
	          onMouseEnter = props.onMouseEnter,
	          onMouseLeave = props.onMouseLeave,
	          restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);
	
	      var checkboxGroup = context.checkboxGroup;
	      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
	
	      var checkboxProps = _extends({}, restProps);
	
	      if (checkboxGroup) {
	        checkboxProps.onChange = function () {
	          if (restProps.onChange) {
	            restProps.onChange.apply(restProps, arguments);
	          }
	
	          checkboxGroup.toggleOption({
	            label: children,
	            value: props.value
	          });
	        };
	
	        checkboxProps.name = checkboxGroup.name;
	        checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
	        checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
	      }
	
	      var classString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames));
	      var checkboxClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: classString,
	          style: style,
	          onMouseEnter: onMouseEnter,
	          onMouseLeave: onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, checkboxProps, {
	          prefixCls: prefixCls,
	          className: checkboxClass,
	          ref: _this.saveCheckbox
	        })), children !== undefined && /*#__PURE__*/React.createElement("span", null, children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Checkbox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var value = this.props.value;
	
	      var _ref2 = this.context || {},
	          _ref2$checkboxGroup = _ref2.checkboxGroup,
	          checkboxGroup = _ref2$checkboxGroup === void 0 ? {} : _ref2$checkboxGroup;
	
	      if (checkboxGroup.registerValue) {
	        checkboxGroup.registerValue(value);
	      }
	
	      (0, _warning["default"])('checked' in this.props || (this.context || {}).checkboxGroup || !('value' in this.props), 'Checkbox', '`value` is not validate prop, do you mean `checked`?');
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.checkboxGroup, nextContext.checkboxGroup);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref3) {
	      var prevValue = _ref3.value;
	      var value = this.props.value;
	
	      var _ref4 = this.context || {},
	          _ref4$checkboxGroup = _ref4.checkboxGroup,
	          checkboxGroup = _ref4$checkboxGroup === void 0 ? {} : _ref4$checkboxGroup;
	
	      if (value !== prevValue && checkboxGroup.registerValue && checkboxGroup.cancelValue) {
	        checkboxGroup.cancelValue(prevValue);
	        checkboxGroup.registerValue(value);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var value = this.props.value;
	
	      var _ref5 = this.context || {},
	          _ref5$checkboxGroup = _ref5.checkboxGroup,
	          checkboxGroup = _ref5$checkboxGroup === void 0 ? {} : _ref5$checkboxGroup;
	
	      if (checkboxGroup.cancelValue) {
	        checkboxGroup.cancelValue(value);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckbox)
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(React.Component);
	
	Checkbox.__ANT_CHECKBOX = true;
	Checkbox.defaultProps = {
	  indeterminate: false
	};
	Checkbox.contextTypes = {
	  checkboxGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(Checkbox);
	var _default = Checkbox;
	exports["default"] = _default;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _grid = __webpack_require__(243);
	
	var _default = _grid.Col;
	exports["default"] = _default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = InputIcon;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function InputIcon(props) {
	  var _classNames;
	
	  var suffixIcon = props.suffixIcon,
	      prefixCls = props.prefixCls;
	  return suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	    className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames, "".concat(prefixCls, "-picker-icon"), true), _classNames))
	  }) : /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-picker-icon")
	  }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "calendar",
	    className: "".concat(prefixCls, "-picker-icon")
	  });
	}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDate = formatDate;
	
	// eslint-disable-next-line import/prefer-default-export
	function formatDate(value, format) {
	  if (!value) {
	    return '';
	  }
	
	  if (Array.isArray(format)) {
	    format = format[0];
	  }
	
	  return value.format(format);
	}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _empty = _interopRequireDefault(__webpack_require__(1203));
	
	var _simple = _interopRequireDefault(__webpack_require__(1204));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var defaultEmptyImg = /*#__PURE__*/React.createElement(_empty["default"], null);
	var simpleEmptyImg = /*#__PURE__*/React.createElement(_simple["default"], null);
	
	var Empty = function Empty(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var className = props.className,
	          customizePrefixCls = props.prefixCls,
	          _props$image = props.image,
	          image = _props$image === void 0 ? defaultEmptyImg : _props$image,
	          description = props.description,
	          children = props.children,
	          imageStyle = props.imageStyle,
	          restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);
	
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Empty"
	        }, function (locale) {
	          var prefixCls = getPrefixCls('empty', customizePrefixCls);
	          var des = typeof description !== 'undefined' ? description : locale.description;
	          var alt = typeof des === 'string' ? des : 'empty';
	          var imageNode = null;
	
	          if (typeof image === 'string') {
	            imageNode = /*#__PURE__*/React.createElement("img", {
	              alt: alt,
	              src: image
	            });
	          } else {
	            imageNode = image;
	          }
	
	          return (/*#__PURE__*/React.createElement("div", _extends({
	              className: (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), className)
	            }, restProps), /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-image"),
	              style: imageStyle
	            }, imageNode), des && /*#__PURE__*/React.createElement("p", {
	              className: "".concat(prefixCls, "-description")
	            }, des), children && /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-footer")
	            }, children))
	          );
	        })
	      );
	    })
	  );
	};
	
	Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
	Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
	var _default = Empty;
	exports["default"] = _default;

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FIELD_DATA_PROP = exports.FIELD_META_PROP = void 0;
	var FIELD_META_PROP = 'data-__meta';
	exports.FIELD_META_PROP = FIELD_META_PROP;
	var FIELD_DATA_PROP = 'data-__field';
	exports.FIELD_DATA_PROP = FIELD_DATA_PROP;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var FormContext = (0, _createReactContext["default"])({
	  labelAlign: 'right',
	  vertical: false
	});
	var _default = FormContext;
	exports["default"] = _default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var RowContext = (0, _createReactContext["default"])({});
	var _default = RowContext;
	exports["default"] = _default;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _RowContext = _interopRequireDefault(__webpack_require__(646));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);
	
	var Col = /*#__PURE__*/function (_React$Component) {
	  _inherits(Col, _React$Component);
	
	  var _super = _createSuper(Col);
	
	  function Col() {
	    var _this;
	
	    _classCallCheck(this, Col);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderCol = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          span = props.span,
	          order = props.order,
	          offset = props.offset,
	          push = props.push,
	          pull = props.pull,
	          className = props.className,
	          children = props.children,
	          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);
	
	      var prefixCls = getPrefixCls('col', customizePrefixCls);
	      var sizeClassObj = {};
	      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
	        var _extends2;
	
	        var sizeProps = {};
	        var propSize = props[size];
	
	        if (typeof propSize === 'number') {
	          sizeProps.span = propSize;
	        } else if (_typeof(propSize) === 'object') {
	          sizeProps = propSize || {};
	        }
	
	        delete others[size];
	        sizeClassObj = _extends(_extends({}, sizeClassObj), (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
	      });
	      var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
	      return (/*#__PURE__*/React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
	          var gutter = _ref2.gutter;
	          var style = others.style;
	
	          if (gutter) {
	            style = _extends(_extends(_extends({}, gutter[0] > 0 ? {
	              paddingLeft: gutter[0] / 2,
	              paddingRight: gutter[0] / 2
	            } : {}), gutter[1] > 0 ? {
	              paddingTop: gutter[1] / 2,
	              paddingBottom: gutter[1] / 2
	            } : {}), style);
	          }
	
	          return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	              style: style,
	              className: classes
	            }), children)
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Col, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCol)
	      );
	    }
	  }]);
	
	  return Col;
	}(React.Component);
	
	exports["default"] = Col;
	Col.propTypes = {
	  span: PropTypes.number,
	  order: PropTypes.number,
	  offset: PropTypes.number,
	  push: PropTypes.number,
	  pull: PropTypes.number,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  xs: objectOrNumber,
	  sm: objectOrNumber,
	  md: objectOrNumber,
	  lg: objectOrNumber,
	  xl: objectOrNumber,
	  xxl: objectOrNumber
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _configProvider = __webpack_require__(14);
	
	var _RowContext = _interopRequireDefault(__webpack_require__(646));
	
	var _type = __webpack_require__(82);
	
	var _responsiveObserve = _interopRequireWildcard(__webpack_require__(632));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom', 'stretch');
	var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');
	
	var Row = /*#__PURE__*/function (_React$Component) {
	  _inherits(Row, _React$Component);
	
	  var _super = _createSuper(Row);
	
	  function Row() {
	    var _this;
	
	    _classCallCheck(this, Row);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      screens: {}
	    };
	
	    _this.renderRow = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          justify = _a.justify,
	          align = _a.align,
	          className = _a.className,
	          style = _a.style,
	          children = _a.children,
	          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);
	
	      var prefixCls = getPrefixCls('row', customizePrefixCls);
	
	      var gutter = _this.getGutter();
	
	      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);
	
	      var rowStyle = _extends(_extends(_extends({}, gutter[0] > 0 ? {
	        marginLeft: gutter[0] / -2,
	        marginRight: gutter[0] / -2
	      } : {}), gutter[1] > 0 ? {
	        marginTop: gutter[1] / -2,
	        marginBottom: gutter[1] / -2
	      } : {}), style);
	
	      var otherProps = _extends({}, others);
	
	      delete otherProps.gutter;
	      return (/*#__PURE__*/React.createElement(_RowContext["default"].Provider, {
	          value: {
	            gutter: gutter
	          }
	        }, /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
	          className: classes,
	          style: rowStyle
	        }), children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Row, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.token = _responsiveObserve["default"].subscribe(function (screens) {
	        var gutter = _this2.props.gutter;
	
	        if (_typeof(gutter) === 'object' || Array.isArray(gutter) && (_typeof(gutter[0]) === 'object' || _typeof(gutter[1]) === 'object')) {
	          _this2.setState({
	            screens: screens
	          });
	        }
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _responsiveObserve["default"].unsubscribe(this.token);
	    }
	  }, {
	    key: "getGutter",
	    value: function getGutter() {
	      var results = [0, 0];
	      var gutter = this.props.gutter;
	      var screens = this.state.screens;
	      var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
	      normalizedGutter.forEach(function (g, index) {
	        if (_typeof(g) === 'object') {
	          for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
	            var breakpoint = _responsiveObserve.responsiveArray[i];
	
	            if (screens[breakpoint] && g[breakpoint] !== undefined) {
	              results[index] = g[breakpoint];
	              break;
	            }
	          }
	        } else {
	          results[index] = g || 0;
	        }
	      });
	      return results;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRow)
	      );
	    }
	  }]);
	
	  return Row;
	}(React.Component);
	
	exports["default"] = Row;
	Row.defaultProps = {
	  gutter: 0
	};
	Row.propTypes = {
	  type: PropTypes.oneOf(['flex']),
	  align: PropTypes.oneOf(RowAligns),
	  justify: PropTypes.oneOf(RowJustify),
	  className: PropTypes.string,
	  children: PropTypes.node,
	  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
	  prefixCls: PropTypes.string
	};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasPrefixSuffix = hasPrefixSuffix;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _type = __webpack_require__(82);
	
	var _Input = __webpack_require__(201);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ClearableInputType = (0, _type.tuple)('text', 'input');
	
	function hasPrefixSuffix(props) {
	  return !!(props.prefix || props.suffix || props.allowClear);
	}
	
	var ClearableLabeledInput = /*#__PURE__*/function (_React$Component) {
	  _inherits(ClearableLabeledInput, _React$Component);
	
	  var _super = _createSuper(ClearableLabeledInput);
	
	  function ClearableLabeledInput() {
	    _classCallCheck(this, ClearableLabeledInput);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ClearableLabeledInput, [{
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var _this$props = this.props,
	          allowClear = _this$props.allowClear,
	          value = _this$props.value,
	          disabled = _this$props.disabled,
	          readOnly = _this$props.readOnly,
	          inputType = _this$props.inputType,
	          handleReset = _this$props.handleReset;
	
	      if (!allowClear || disabled || readOnly || value === undefined || value === null || value === '') {
	        return null;
	      }
	
	      var className = inputType === ClearableInputType[0] ? "".concat(prefixCls, "-textarea-clear-icon") : "".concat(prefixCls, "-clear-icon");
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          theme: "filled",
	          onClick: handleReset,
	          className: className,
	          role: "button"
	        })
	      );
	    }
	  }, {
	    key: "renderSuffix",
	    value: function renderSuffix(prefixCls) {
	      var _this$props2 = this.props,
	          suffix = _this$props2.suffix,
	          allowClear = _this$props2.allowClear;
	
	      if (suffix || allowClear) {
	        return (/*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-suffix")
	          }, this.renderClearIcon(prefixCls), suffix)
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderLabeledIcon",
	    value: function renderLabeledIcon(prefixCls, element) {
	      var _classNames;
	
	      var props = this.props;
	      var suffix = this.renderSuffix(prefixCls);
	
	      if (!hasPrefixSuffix(props)) {
	        return (/*#__PURE__*/React.cloneElement(element, {
	            value: props.value
	          })
	        );
	      }
	
	      var prefix = props.prefix ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-prefix")
	      }, props.prefix) : null;
	      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), props.suffix && props.allowClear && this.props.value), _classNames));
	      return (/*#__PURE__*/React.createElement("span", {
	          className: affixWrapperCls,
	          style: props.style
	        }, prefix, /*#__PURE__*/React.cloneElement(element, {
	          style: null,
	          value: props.value,
	          className: (0, _Input.getInputClassName)(prefixCls, props.size, props.disabled)
	        }), suffix)
	      );
	    }
	  }, {
	    key: "renderInputWithLabel",
	    value: function renderInputWithLabel(prefixCls, labeledElement) {
	      var _classNames3;
	
	      var _this$props3 = this.props,
	          addonBefore = _this$props3.addonBefore,
	          addonAfter = _this$props3.addonAfter,
	          style = _this$props3.style,
	          size = _this$props3.size,
	          className = _this$props3.className; // Not wrap when there is not addons
	
	      if (!addonBefore && !addonAfter) {
	        return labeledElement;
	      }
	
	      var wrapperClassName = "".concat(prefixCls, "-group");
	      var addonClassName = "".concat(wrapperClassName, "-addon");
	      var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonBefore) : null;
	      var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonAfter) : null;
	      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
	      var mergedGroupClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
	      // and put style prop in wrapper
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: mergedGroupClassName,
	          style: style
	        }, /*#__PURE__*/React.createElement("span", {
	          className: mergedWrapperClassName
	        }, addonBeforeNode, /*#__PURE__*/React.cloneElement(labeledElement, {
	          style: null
	        }), addonAfterNode))
	      );
	    }
	  }, {
	    key: "renderTextAreaWithClearIcon",
	    value: function renderTextAreaWithClearIcon(prefixCls, element) {
	      var _this$props4 = this.props,
	          value = _this$props4.value,
	          allowClear = _this$props4.allowClear,
	          className = _this$props4.className,
	          style = _this$props4.style;
	
	      if (!allowClear) {
	        return (/*#__PURE__*/React.cloneElement(element, {
	            value: value
	          })
	        );
	      }
	
	      var affixWrapperCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"));
	      return (/*#__PURE__*/React.createElement("span", {
	          className: affixWrapperCls,
	          style: style
	        }, /*#__PURE__*/React.cloneElement(element, {
	          style: null,
	          value: value
	        }), this.renderClearIcon(prefixCls))
	      );
	    }
	  }, {
	    key: "renderClearableLabeledInput",
	    value: function renderClearableLabeledInput() {
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          inputType = _this$props5.inputType,
	          element = _this$props5.element;
	
	      if (inputType === ClearableInputType[0]) {
	        return this.renderTextAreaWithClearIcon(prefixCls, element);
	      }
	
	      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderClearableLabeledInput();
	    }
	  }]);
	
	  return ClearableLabeledInput;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ClearableLabeledInput);
	var _default = ClearableLabeledInput;
	exports["default"] = _default;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(649));
	
	var _ResizableTextArea = _interopRequireDefault(__webpack_require__(1214));
	
	var _configProvider = __webpack_require__(14);
	
	var _Input = __webpack_require__(201);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var TextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(TextArea, _React$Component);
	
	  var _super = _createSuper(TextArea);
	
	  function TextArea(props) {
	    var _this;
	
	    _classCallCheck(this, TextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (resizableTextArea) {
	      _this.resizableTextArea = resizableTextArea;
	    };
	
	    _this.saveClearableInput = function (clearableInput) {
	      _this.clearableInput = clearableInput;
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, function () {
	        _this.resizableTextArea.resizeTextarea();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          onPressEnter = _this$props.onPressEnter,
	          onKeyDown = _this$props.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.resizableTextArea.renderTextArea();
	
	        _this.focus();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.renderTextArea = function (prefixCls) {
	      return (/*#__PURE__*/React.createElement(_ResizableTextArea["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          onKeyDown: _this.handleKeyDown,
	          onChange: _this.handleChange,
	          ref: _this.saveTextArea
	        }))
	      );
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          inputType: "text",
	          value: (0, _Input.fixControlledValue)(value),
	          element: _this.renderTextArea(prefixCls),
	          handleReset: _this.handleReset,
	          ref: _this.saveClearableInput
	        }))
	      );
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(TextArea, [{
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.resizableTextArea.textArea.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.resizableTextArea.textArea.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(TextArea);
	var _default = TextArea;
	exports["default"] = _default;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.LayoutContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || (typeof obj === "undefined" ? "undefined" : _typeof2(obj)) !== "object" && typeof obj !== "function") {
	    return { default: obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj.default = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var LayoutContext = (0, _createReactContext["default"])({
	  siderHook: {
	    addSider: function addSider() {
	      return null;
	    },
	    removeSider: function removeSider() {
	      return null;
	    }
	  }
	});
	exports.LayoutContext = LayoutContext;
	
	function generator(_ref) {
	  var suffixCls = _ref.suffixCls,
	      tagName = _ref.tagName,
	      displayName = _ref.displayName;
	  return function (BasicComponent) {
	    var _a;
	
	    return _a = /*#__PURE__*/function (_React$Component) {
	      _inherits(Adapter, _React$Component);
	
	      var _super = _createSuper(Adapter);
	
	      function Adapter() {
	        var _this;
	
	        _classCallCheck(this, Adapter);
	
	        _this = _super.apply(this, arguments);
	
	        _this.renderComponent = function (_ref2) {
	          var getPrefixCls = _ref2.getPrefixCls;
	          var customizePrefixCls = _this.props.prefixCls;
	          var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
	          return (/*#__PURE__*/React.createElement(BasicComponent, _extends({
	              prefixCls: prefixCls,
	              tagName: tagName
	            }, _this.props))
	          );
	        };
	
	        return _this;
	      }
	
	      _createClass(Adapter, [{
	        key: "render",
	        value: function render() {
	          return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	          );
	        }
	      }]);
	
	      return Adapter;
	    }(React.Component), _a.displayName = displayName, _a;
	  };
	}
	
	var Basic = function Basic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      children = props.children,
	      tagName = props.tagName,
	      others = __rest(props, ["prefixCls", "className", "children", "tagName"]);
	
	  var classString = (0, _classnames["default"])(className, prefixCls);
	  return (/*#__PURE__*/React.createElement(tagName, _extends({
	      className: classString
	    }, others), children)
	  );
	};
	
	var BasicLayout = /*#__PURE__*/function (_React$Component2) {
	  _inherits(BasicLayout, _React$Component2);
	
	  var _super2 = _createSuper(BasicLayout);
	
	  function BasicLayout() {
	    var _this2;
	
	    _classCallCheck(this, BasicLayout);
	
	    _this2 = _super2.apply(this, arguments);
	    _this2.state = {
	      siders: []
	    };
	    return _this2;
	  }
	
	  _createClass(BasicLayout, [{
	    key: "getSiderHook",
	    value: function getSiderHook() {
	      var _this3 = this;
	
	      return {
	        addSider: function addSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: [].concat(_toConsumableArray(state.siders), [id])
	            };
	          });
	        },
	        removeSider: function removeSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: state.siders.filter(function (currentId) {
	                return currentId !== id;
	              })
	            };
	          });
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          prefixCls = _a.prefixCls,
	          className = _a.className,
	          children = _a.children,
	          hasSider = _a.hasSider,
	          Tag = _a.tagName,
	          others = __rest(_a, ["prefixCls", "className", "children", "hasSider", "tagName"]);
	
	      var classString = (0, _classnames["default"])(className, prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : this.state.siders.length > 0));
	      return (/*#__PURE__*/React.createElement(LayoutContext.Provider, {
	          value: {
	            siderHook: this.getSiderHook()
	          }
	        }, /*#__PURE__*/React.createElement(Tag, _extends({
	          className: classString
	        }, others), children))
	      );
	    }
	  }]);
	
	  return BasicLayout;
	}(React.Component);
	
	var Layout = generator({
	  suffixCls: 'layout',
	  tagName: 'section',
	  displayName: 'Layout'
	})(BasicLayout);
	var Header = generator({
	  suffixCls: 'layout-header',
	  tagName: 'header',
	  displayName: 'Header'
	})(Basic);
	var Footer = generator({
	  suffixCls: 'layout-footer',
	  tagName: 'footer',
	  displayName: 'Footer'
	})(Basic);
	var Content = generator({
	  suffixCls: 'layout-content',
	  tagName: 'main',
	  displayName: 'Content'
	})(Basic);
	Layout.Header = Header;
	Layout.Footer = Footer;
	Layout.Content = Content;
	var _default = Layout;
	exports["default"] = _default;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ANT_MARK = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	var _locale = __webpack_require__(360);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ANT_MARK = 'internalMark';
	exports.ANT_MARK = ANT_MARK;
	
	function setMomentLocale(locale) {
	  if (locale && locale.locale) {
	    (0, _interopDefault["default"])(moment).locale(locale.locale);
	  } else {
	    (0, _interopDefault["default"])(moment).locale('en');
	  }
	}
	
	var LocaleProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(LocaleProvider, _React$Component);
	
	  var _super = _createSuper(LocaleProvider);
	
	  function LocaleProvider(props) {
	    var _this;
	
	    _classCallCheck(this, LocaleProvider);
	
	    _this = _super.call(this, props);
	    setMomentLocale(props.locale);
	    (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
	    (0, _warning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
	    return _this;
	  }
	
	  _createClass(LocaleProvider, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        antLocale: _extends(_extends({}, this.props.locale), {
	          exist: true
	        })
	      };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var locale = this.props.locale;
	
	      if (prevProps.locale !== locale) {
	        setMomentLocale(locale);
	        (0, _locale.changeConfirmLocale)(locale && locale.Modal);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _locale.changeConfirmLocale)();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return LocaleProvider;
	}(React.Component);
	
	exports["default"] = LocaleProvider;
	LocaleProvider.propTypes = {
	  locale: PropTypes.object
	};
	LocaleProvider.defaultProps = {
	  locale: {}
	};
	LocaleProvider.childContextTypes = {
	  antLocale: PropTypes.object
	};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.destroyFns = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcDialog = _interopRequireDefault(__webpack_require__(463));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _locale = __webpack_require__(360);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _button = _interopRequireDefault(__webpack_require__(136));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var mousePosition;
	var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795
	
	exports.destroyFns = destroyFns;
	
	var getClickPosition = function getClickPosition(e) {
	  mousePosition = {
	    x: e.pageX,
	    y: e.pageY
	  }; // 100ms 内发生过点击事件，则从点击位置动画展示
	  // 否则直接 zoom 展示
	  // 这样可以兼容非点击方式展开
	
	  setTimeout(function () {
	    return mousePosition = null;
	  }, 100);
	}; // 只有点击事件支持从鼠标位置动画展开
	
	
	if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	  (0, _addEventListener["default"])(document.documentElement, 'click', getClickPosition);
	}
	
	var Modal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  var _super = _createSuper(Modal);
	
	  function Modal() {
	    var _this;
	
	    _classCallCheck(this, Modal);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleCancel = function (e) {
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel(e);
	      }
	    };
	
	    _this.handleOk = function (e) {
	      var onOk = _this.props.onOk;
	
	      if (onOk) {
	        onOk(e);
	      }
	    };
	
	    _this.renderFooter = function (locale) {
	      var _this$props = _this.props,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          cancelText = _this$props.cancelText,
	          confirmLoading = _this$props.confirmLoading;
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.handleCancel
	        }, _this.props.cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	          type: okType,
	          loading: confirmLoading,
	          onClick: _this.handleOk
	        }, _this.props.okButtonProps), okText || locale.okText))
	      );
	    };
	
	    _this.renderModal = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          footer = _a.footer,
	          visible = _a.visible,
	          wrapClassName = _a.wrapClassName,
	          centered = _a.centered,
	          getContainer = _a.getContainer,
	          closeIcon = _a.closeIcon,
	          restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon"]);
	
	      var prefixCls = getPrefixCls('modal', customizePrefixCls);
	      var defaultFooter = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Modal",
	        defaultLocale: (0, _locale.getConfirmLocale)()
	      }, _this.renderFooter);
	      var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-x")
	      }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-close-icon"),
	        type: "close"
	      }));
	      return (/*#__PURE__*/React.createElement(_rcDialog["default"], _extends({}, restProps, {
	          getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
	          prefixCls: prefixCls,
	          wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
	          footer: footer === undefined ? defaultFooter : footer,
	          visible: visible,
	          mousePosition: mousePosition,
	          onClose: _this.handleCancel,
	          closeIcon: closeIconToRender
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderModal)
	      );
	    }
	  }]);
	
	  return Modal;
	}(React.Component);
	
	exports["default"] = Modal;
	Modal.defaultProps = {
	  width: 520,
	  transitionName: 'zoom',
	  maskTransitionName: 'fade',
	  confirmLoading: false,
	  visible: false,
	  okType: 'primary'
	};
	Modal.propTypes = {
	  prefixCls: PropTypes.string,
	  onOk: PropTypes.func,
	  onCancel: PropTypes.func,
	  okText: PropTypes.node,
	  cancelText: PropTypes.node,
	  centered: PropTypes.bool,
	  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  confirmLoading: PropTypes.bool,
	  visible: PropTypes.bool,
	  footer: PropTypes.node,
	  title: PropTypes.node,
	  closable: PropTypes.bool,
	  closeIcon: PropTypes.node
	};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _progress = _interopRequireDefault(__webpack_require__(1237));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _progress["default"];
	exports["default"] = _default;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _grid = __webpack_require__(243);
	
	var _default = _grid.Row;
	exports["default"] = _default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _context = __webpack_require__(242);
	
	var _Number = _interopRequireDefault(__webpack_require__(1251));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Statistic = function Statistic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      style = props.style,
	      valueStyle = props.valueStyle,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      title = props.title,
	      valueRender = props.valueRender,
	      prefix = props.prefix,
	      suffix = props.suffix;
	  var valueNode = /*#__PURE__*/React.createElement(_Number["default"], _extends({}, props, {
	    value: value
	  }));
	
	  if (valueRender) {
	    valueNode = valueRender(valueNode);
	  }
	
	  return (/*#__PURE__*/React.createElement("div", {
	      className: (0, _classnames["default"])(prefixCls, className),
	      style: style
	    }, title && /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-title")
	    }, title), /*#__PURE__*/React.createElement("div", {
	      style: valueStyle,
	      className: "".concat(prefixCls, "-content")
	    }, prefix && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-prefix")
	    }, prefix), valueNode, suffix && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-suffix")
	    }, suffix)))
	  );
	};
	
	Statistic.defaultProps = {
	  decimalSeparator: '.',
	  groupSeparator: ','
	};
	var WrapperStatistic = (0, _context.withConfigConsumer)({
	  prefixCls: 'statistic'
	})(Statistic);
	var _default = WrapperStatistic;
	exports["default"] = _default;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flatArray = flatArray;
	exports.treeMap = treeMap;
	exports.flatFilter = flatFilter;
	exports.normalizeColumns = normalizeColumns;
	exports.generateValueMaps = generateValueMaps;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function flatArray() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
	  var result = [];
	
	  var loop = function loop(array) {
	    array.forEach(function (item) {
	      if (item[childrenName]) {
	        var newItem = _extends({}, item);
	
	        delete newItem[childrenName];
	        result.push(newItem);
	
	        if (item[childrenName].length > 0) {
	          loop(item[childrenName]);
	        }
	      } else {
	        result.push(item);
	      }
	    });
	  };
	
	  loop(data);
	  return result;
	}
	
	function treeMap(tree, mapper) {
	  var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	  return tree.map(function (node, index) {
	    var extra = {};
	
	    if (node[childrenName]) {
	      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
	    }
	
	    return _extends(_extends({}, mapper(node, index)), extra);
	  });
	}
	
	function flatFilter(tree, callback) {
	  return tree.reduce(function (acc, node) {
	    if (callback(node)) {
	      acc.push(node);
	    }
	
	    if (node.children) {
	      var children = flatFilter(node.children, callback);
	      acc.push.apply(acc, _toConsumableArray(children));
	    }
	
	    return acc;
	  }, []);
	}
	
	function normalizeColumns(elements) {
	  var columns = [];
	  React.Children.forEach(elements, function (element) {
	    if (! /*#__PURE__*/React.isValidElement(element)) {
	      return;
	    }
	
	    var column = _extends({}, element.props);
	
	    if (element.key) {
	      column.key = element.key;
	    }
	
	    if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
	      column.children = normalizeColumns(column.children);
	    }
	
	    columns.push(column);
	  });
	  return columns;
	}
	
	function generateValueMaps(items) {
	  var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (items || []).forEach(function (_ref) {
	    var value = _ref.value,
	        children = _ref.children;
	    maps[value.toString()] = value;
	    generateValueMaps(children, maps);
	  });
	  return maps;
	}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _rcTabs = _interopRequireWildcard(__webpack_require__(481));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(504));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _TabBar = _interopRequireDefault(__webpack_require__(1266));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _styleChecker = __webpack_require__(633);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Tabs = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  var _super = _createSuper(Tabs);
	
	  function Tabs() {
	    var _this;
	
	    _classCallCheck(this, Tabs);
	
	    _this = _super.apply(this, arguments);
	
	    _this.removeTab = function (targetKey, e) {
	      e.stopPropagation();
	
	      if (!targetKey) {
	        return;
	      }
	
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'remove');
	      }
	    };
	
	    _this.handleChange = function (activeKey) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(activeKey);
	      }
	    };
	
	    _this.createNewTab = function (targetKey) {
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'add');
	      }
	    };
	
	    _this.renderTabs = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          size = _this$props.size,
	          _this$props$type = _this$props.type,
	          type = _this$props$type === void 0 ? 'line' : _this$props$type,
	          tabPosition = _this$props.tabPosition,
	          children = _this$props.children,
	          _this$props$animated = _this$props.animated,
	          animated = _this$props$animated === void 0 ? true : _this$props$animated,
	          hideAdd = _this$props.hideAdd;
	      var tabBarExtraContent = _this.props.tabBarExtraContent;
	      var tabPaneAnimated = _typeof(animated) === 'object' ? animated.tabPane : animated; // card tabs should not have animation
	
	      if (type !== 'line') {
	        tabPaneAnimated = 'animated' in _this.props ? tabPaneAnimated : false;
	      }
	
	      (0, _warning["default"])(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), 'Tabs', "`type=card|editable-card` doesn't have small or large size, it's by design.");
	      var prefixCls = getPrefixCls('tabs', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), tabPosition === 'left' || tabPosition === 'right'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card"), type.indexOf('card') >= 0), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), true), _defineProperty(_classNames, "".concat(prefixCls, "-no-animation"), !tabPaneAnimated), _classNames)); // only card type tabs can be added and closed
	
	      var childrenWithClose = [];
	
	      if (type === 'editable-card') {
	        childrenWithClose = [];
	        React.Children.forEach(children, function (child, index) {
	          if (! /*#__PURE__*/React.isValidElement(child)) return child;
	          var closable = child.props.closable;
	          closable = typeof closable === 'undefined' ? true : closable;
	          var closeIcon = closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "close",
	            className: "".concat(prefixCls, "-close-x"),
	            onClick: function onClick(e) {
	              return _this.removeTab(child.key, e);
	            }
	          }) : null;
	          childrenWithClose.push( /*#__PURE__*/React.cloneElement(child, {
	            tab: /*#__PURE__*/React.createElement("div", {
	              className: closable ? undefined : "".concat(prefixCls, "-tab-unclosable")
	            }, child.props.tab, closeIcon),
	            key: child.key || index
	          }));
	        }); // Add new tab handler
	
	        if (!hideAdd) {
	          tabBarExtraContent = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "plus",
	            className: "".concat(prefixCls, "-new-tab"),
	            onClick: _this.createNewTab
	          }), tabBarExtraContent);
	        }
	      }
	
	      tabBarExtraContent = tabBarExtraContent ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra-content")
	      }, tabBarExtraContent) : null;
	
	      var tabBarProps = __rest(_this.props, []);
	
	      var contentCls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-content"), type.indexOf('card') >= 0 && "".concat(prefixCls, "-card-content"));
	      return (/*#__PURE__*/React.createElement(_rcTabs["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: cls,
	          tabBarPosition: tabPosition,
	          renderTabBar: function renderTabBar() {
	            return (/*#__PURE__*/React.createElement(_TabBar["default"], _extends({}, (0, _omit["default"])(tabBarProps, ['className']), {
	                tabBarExtraContent: tabBarExtraContent
	              }))
	            );
	          },
	          renderTabContent: function renderTabContent() {
	            return (/*#__PURE__*/React.createElement(_TabContent["default"], {
	                className: contentCls,
	                animated: tabPaneAnimated,
	                animatedWithMargin: true
	              })
	            );
	          },
	          onChange: _this.handleChange
	        }), childrenWithClose.length > 0 ? childrenWithClose : children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var NO_FLEX = ' no-flex';
	      var tabNode = ReactDOM.findDOMNode(this);
	
	      if (tabNode && !_styleChecker.isFlexSupported && tabNode.className.indexOf(NO_FLEX) === -1) {
	        tabNode.className += NO_FLEX;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTabs)
	      );
	    }
	  }]);
	
	  return Tabs;
	}(React.Component);
	
	exports["default"] = Tabs;
	Tabs.TabPane = _rcTabs.TabPane;
	Tabs.defaultProps = {
	  hideAdd: false,
	  tabPosition: 'top'
	};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _CheckableTag = _interopRequireDefault(__webpack_require__(1267));
	
	var _configProvider = __webpack_require__(14);
	
	var _colors = __webpack_require__(628);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _wave = _interopRequireDefault(__webpack_require__(353));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var PresetColorRegex = new RegExp("^(".concat(_colors.PresetColorTypes.join('|'), ")(-inverse)?$"));
	
	var Tag = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tag, _React$Component);
	
	  var _super = _createSuper(Tag);
	
	  function Tag(props) {
	    var _this;
	
	    _classCallCheck(this, Tag);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      visible: true
	    };
	
	    _this.handleIconClick = function (e) {
	      e.stopPropagation();
	
	      _this.setVisible(false, e);
	    };
	
	    _this.renderTag = function (configProps) {
	      var _a = _this.props,
	          children = _a.children,
	          otherProps = __rest(_a, ["children"]);
	
	      var isNeedWave = 'onClick' in otherProps || children && children.type === 'a';
	      var tagProps = (0, _omit["default"])(otherProps, ['onClose', 'afterClose', 'color', 'visible', 'closable', 'prefixCls']);
	      return isNeedWave ? /*#__PURE__*/React.createElement(_wave["default"], null, /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
	        className: _this.getTagClassName(configProps),
	        style: _this.getTagStyle()
	      }), children, _this.renderCloseIcon())) : /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
	        className: _this.getTagClassName(configProps),
	        style: _this.getTagStyle()
	      }), children, _this.renderCloseIcon());
	    };
	
	    (0, _warning["default"])(!('afterClose' in props), 'Tag', "'afterClose' will be deprecated, please use 'onClose', we will remove this in the next version.");
	    return _this;
	  }
	
	  _createClass(Tag, [{
	    key: "getTagStyle",
	    value: function getTagStyle() {
	      var _this$props = this.props,
	          color = _this$props.color,
	          style = _this$props.style;
	      var isPresetColor = this.isPresetColor();
	      return _extends({
	        backgroundColor: color && !isPresetColor ? color : undefined
	      }, style);
	    }
	  }, {
	    key: "getTagClassName",
	    value: function getTagClassName(_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          color = _this$props2.color;
	      var visible = this.state.visible;
	      var isPresetColor = this.isPresetColor();
	      var prefixCls = getPrefixCls('tag', customizePrefixCls);
	      return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-has-color"), color && !isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-hidden"), !visible), _classNames), className);
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible, e) {
	      var _this$props3 = this.props,
	          onClose = _this$props3.onClose,
	          afterClose = _this$props3.afterClose;
	
	      if (onClose) {
	        onClose(e);
	      }
	
	      if (afterClose && !onClose) {
	        // next version remove.
	        afterClose();
	      }
	
	      if (e.defaultPrevented) {
	        return;
	      }
	
	      if (!('visible' in this.props)) {
	        this.setState({
	          visible: visible
	        });
	      }
	    }
	  }, {
	    key: "isPresetColor",
	    value: function isPresetColor() {
	      var color = this.props.color;
	
	      if (!color) {
	        return false;
	      }
	
	      return PresetColorRegex.test(color);
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var closable = this.props.closable;
	      return closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        onClick: this.handleIconClick
	      }) : null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTag)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tag;
	}(React.Component);
	
	Tag.CheckableTag = _CheckableTag["default"];
	Tag.defaultProps = {
	  closable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Tag);
	var _default = Tag;
	exports["default"] = _default;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(482));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _configProvider = __webpack_require__(14);
	
	var _en_US = _interopRequireDefault(__webpack_require__(364));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function generateShowHourMinuteSecond(format) {
	  // Ref: http://momentjs.com/docs/#/parsing/string-format/
	  return {
	    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
	    showMinute: format.indexOf('m') > -1,
	    showSecond: format.indexOf('s') > -1
	  };
	}
	
	var TimePicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(TimePicker, _React$Component);
	
	  var _super = _createSuper(TimePicker);
	
	  function TimePicker(props) {
	    var _this;
	
	    _classCallCheck(this, TimePicker);
	
	    _this = _super.call(this, props);
	
	    _this.getDefaultLocale = function () {
	      var defaultLocale = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	      return defaultLocale;
	    };
	
	    _this.handleOpenClose = function (_ref) {
	      var open = _ref.open;
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.saveTimePicker = function (timePickerRef) {
	      _this.timePickerRef = timePickerRef;
	    };
	
	    _this.handleChange = function (value) {
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          _this$props$format = _this$props.format,
	          format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;
	
	      if (onChange) {
	        onChange(value, value && value.format(format) || '');
	      }
	    };
	
	    _this.renderTimePicker = function (locale) {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	          var getContextPopupContainer = _ref2.getPopupContainer,
	              getPrefixCls = _ref2.getPrefixCls;
	
	          var _a = _this.props,
	              getPopupContainer = _a.getPopupContainer,
	              customizePrefixCls = _a.prefixCls,
	              className = _a.className,
	              addon = _a.addon,
	              placeholder = _a.placeholder,
	              props = __rest(_a, ["getPopupContainer", "prefixCls", "className", "addon", "placeholder"]);
	
	          var size = props.size;
	          var pickerProps = (0, _omit["default"])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);
	
	          var format = _this.getDefaultFormat();
	
	          var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
	          var pickerClassName = (0, _classnames["default"])(className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	
	          var pickerAddon = function pickerAddon(panel) {
	            return addon ? /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-panel-addon")
	            }, addon(panel)) : null;
	          };
	
	          return (/*#__PURE__*/React.createElement(_TimePicker["default"], _extends({}, generateShowHourMinuteSecond(format), pickerProps, {
	              allowEmpty: _this.getAllowClear(),
	              prefixCls: prefixCls,
	              getPopupContainer: getPopupContainer || getContextPopupContainer,
	              ref: _this.saveTimePicker,
	              format: format,
	              className: pickerClassName,
	              value: _this.state.value,
	              placeholder: placeholder === undefined ? locale.placeholder : placeholder,
	              onChange: _this.handleChange,
	              onOpen: _this.handleOpenClose,
	              onClose: _this.handleOpenClose,
	              addon: pickerAddon,
	              inputIcon: _this.renderInputIcon(prefixCls),
	              clearIcon: _this.renderClearIcon(prefixCls)
	            }))
	          );
	        })
	      );
	    };
	
	    var value = props.value || props.defaultValue;
	
	    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
	    }
	
	    _this.state = {
	      value: value
	    };
	    (0, _warning["default"])(!('allowEmpty' in props), 'TimePicker', '`allowEmpty` is deprecated. Please use `allowClear` instead.');
	    return _this;
	  }
	
	  _createClass(TimePicker, [{
	    key: "getDefaultFormat",
	    value: function getDefaultFormat() {
	      var _this$props2 = this.props,
	          format = _this$props2.format,
	          use12Hours = _this$props2.use12Hours;
	
	      if (format) {
	        return format;
	      }
	
	      if (use12Hours) {
	        return 'h:mm:ss a';
	      }
	
	      return 'HH:mm:ss';
	    }
	  }, {
	    key: "getAllowClear",
	    value: function getAllowClear() {
	      var _this$props3 = this.props,
	          allowClear = _this$props3.allowClear,
	          allowEmpty = _this$props3.allowEmpty;
	
	      if ('allowClear' in this.props) {
	        return allowClear;
	      }
	
	      return allowEmpty;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.timePickerRef.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.timePickerRef.blur();
	    }
	  }, {
	    key: "renderInputIcon",
	    value: function renderInputIcon(prefixCls) {
	      var suffixIcon = this.props.suffixIcon;
	      var clockIcon = suffixIcon && /*#__PURE__*/React.isValidElement(suffixIcon) && /*#__PURE__*/React.cloneElement(suffixIcon, {
	        className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-clock-icon"))
	      }) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "clock-circle",
	        className: "".concat(prefixCls, "-clock-icon")
	      });
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-icon")
	        }, clockIcon)
	      );
	    }
	  }, {
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var clearIcon = this.props.clearIcon;
	      var clearIconPrefixCls = "".concat(prefixCls, "-clear");
	
	      if (clearIcon && /*#__PURE__*/React.isValidElement(clearIcon)) {
	        return (/*#__PURE__*/React.cloneElement(clearIcon, {
	            className: (0, _classnames["default"])(clearIcon.props.className, clearIconPrefixCls)
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          className: clearIconPrefixCls,
	          theme: "filled"
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "TimePicker",
	          defaultLocale: this.getDefaultLocale()
	        }, this.renderTimePicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TimePicker;
	}(React.Component);
	
	TimePicker.defaultProps = {
	  align: {
	    offset: [0, -2]
	  },
	  disabledHours: undefined,
	  disabledMinutes: undefined,
	  disabledSeconds: undefined,
	  hideDisabledOptions: false,
	  placement: 'bottomLeft',
	  transitionName: 'slide-up',
	  focusOnOpen: true
	};
	(0, _reactLifecyclesCompat.polyfill)(TimePicker);
	var _default = TimePicker;
	exports["default"] = _default;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _input = _interopRequireDefault(__webpack_require__(244));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleChange = function (e) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.handleClear = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          handleClear = _this$props.handleClear,
	          disabled = _this$props.disabled;
	
	      if (!disabled && handleClear) {
	        handleClear(e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          placeholder = _this$props2.placeholder,
	          value = _this$props2.value,
	          prefixCls = _this$props2.prefixCls,
	          disabled = _this$props2.disabled;
	      var icon = value && value.length > 0 ? /*#__PURE__*/React.createElement("a", {
	        href: "#",
	        className: "".concat(prefixCls, "-action"),
	        onClick: this.handleClear
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled"
	      })) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-action")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "search"
	      }));
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_input["default"], {
	          placeholder: placeholder,
	          className: prefixCls,
	          value: value,
	          onChange: this.handleChange,
	          disabled: disabled
	        }), icon)
	      );
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  placeholder: ''
	};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcTree = _interopRequireWildcard(__webpack_require__(492));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _DirectoryTree = _interopRequireDefault(__webpack_require__(1278));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _motion = _interopRequireDefault(__webpack_require__(630));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Tree = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tree, _React$Component);
	
	  var _super = _createSuper(Tree);
	
	  function Tree() {
	    var _this;
	
	    _classCallCheck(this, Tree);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSwitcherIcon = function (prefixCls, switcherIcon, _ref) {
	      var isLeaf = _ref.isLeaf,
	          expanded = _ref.expanded,
	          loading = _ref.loading;
	      var showLine = _this.props.showLine;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading",
	            className: "".concat(prefixCls, "-switcher-loading-icon")
	          })
	        );
	      }
	
	      if (isLeaf) {
	        return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "file",
	          className: "".concat(prefixCls, "-switcher-line-icon")
	        }) : null;
	      }
	
	      var switcherCls = "".concat(prefixCls, "-switcher-icon");
	
	      if (switcherIcon) {
	        return (/*#__PURE__*/React.cloneElement(switcherIcon, {
	            className: (0, _classnames["default"])(switcherIcon.props.className || '', switcherCls)
	          })
	        );
	      }
	
	      return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: expanded ? 'minus-square' : 'plus-square',
	        className: "".concat(prefixCls, "-switcher-line-icon"),
	        theme: "outlined"
	      }) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "caret-down",
	        className: switcherCls,
	        theme: "filled"
	      });
	    };
	
	    _this.setTreeRef = function (node) {
	      _this.tree = node;
	    };
	
	    _this.renderTree = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          showIcon = props.showIcon,
	          _switcherIcon = props.switcherIcon,
	          blockNode = props.blockNode,
	          children = props.children;
	      var checkable = props.checkable;
	      var prefixCls = getPrefixCls('tree', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_rcTree["default"], _extends({
	          ref: _this.setTreeRef
	        }, props, {
	          prefixCls: prefixCls,
	          className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-icon-hide"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-block-node"), blockNode), _classNames)),
	          checkable: checkable ? /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-checkbox-inner")
	          }) : checkable,
	          switcherIcon: function switcherIcon(nodeProps) {
	            return _this.renderSwitcherIcon(prefixCls, _switcherIcon, nodeProps);
	          }
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Tree, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTree)
	      );
	    }
	  }]);
	
	  return Tree;
	}(React.Component);
	
	exports["default"] = Tree;
	Tree.TreeNode = _rcTree.TreeNode;
	Tree.DirectoryTree = _DirectoryTree["default"];
	Tree.defaultProps = {
	  checkable: false,
	  showIcon: false,
	  motion: _extends(_extends({}, _motion["default"]), {
	    motionAppear: false
	  }),
	  blockNode: false
	};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _ref2 = __webpack_require__(1163);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Typography = function Typography(_a, ref) {
	  var customizePrefixCls = _a.prefixCls,
	      _a$component = _a.component,
	      component = _a$component === void 0 ? 'article' : _a$component,
	      className = _a.className,
	      ariaLabel = _a['aria-label'],
	      setContentRef = _a.setContentRef,
	      children = _a.children,
	      restProps = __rest(_a, ["prefixCls", "component", "className", 'aria-label', "setContentRef", "children"]);
	
	  var mergedRef = ref;
	
	  if (setContentRef) {
	    (0, _warning["default"])(false, 'Typography', '`setContentRef` is deprecated. Please use `ref` instead.');
	    mergedRef = (0, _ref2.composeRef)(ref, setContentRef);
	  }
	
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var Component = component;
	      var prefixCls = getPrefixCls('typography', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(Component, _extends({
	          className: (0, _classnames["default"])(prefixCls, className),
	          "aria-label": ariaLabel,
	          ref: mergedRef
	        }, restProps), children)
	      );
	    })
	  );
	};
	
	var RefTypography;
	
	if (React.forwardRef) {
	  RefTypography = /*#__PURE__*/React.forwardRef(Typography);
	  RefTypography.displayName = 'Typography';
	} else {
	  var TypographyWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(TypographyWrapper, _React$Component);
	
	    var _super = _createSuper(TypographyWrapper);
	
	    function TypographyWrapper() {
	      var _this;
	
	      _classCallCheck(this, TypographyWrapper);
	
	      _this = _super.apply(this, arguments);
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(TypographyWrapper, [{
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(Typography, this.props)
	        );
	      }
	    }]);
	
	    return TypographyWrapper;
	  }(React.Component);
	
	  RefTypography = TypographyWrapper;
	} // es default export should use const instead of let
	
	
	var ExportTypography = RefTypography;
	var _default = ExportTypography;
	exports["default"] = _default;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcUpload = _interopRequireDefault(__webpack_require__(485));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _uniqBy = _interopRequireDefault(__webpack_require__(459));
	
	var _findIndex = _interopRequireDefault(__webpack_require__(456));
	
	var _UploadList = _interopRequireDefault(__webpack_require__(1288));
	
	var _utils = __webpack_require__(665);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _default2 = _interopRequireDefault(__webpack_require__(157));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Upload = /*#__PURE__*/function (_React$Component) {
	  _inherits(Upload, _React$Component);
	
	  var _super = _createSuper(Upload);
	
	  function Upload(props) {
	    var _this;
	
	    _classCallCheck(this, Upload);
	
	    _this = _super.call(this, props);
	
	    _this.saveUpload = function (node) {
	      _this.upload = node;
	    };
	
	    _this.onStart = function (file) {
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.fileToObject)(file);
	      targetItem.status = 'uploading';
	      var nextFileList = fileList.concat();
	      var fileIndex = (0, _findIndex["default"])(nextFileList, function (_ref) {
	        var uid = _ref.uid;
	        return uid === targetItem.uid;
	      });
	
	      if (fileIndex === -1) {
	        nextFileList.push(targetItem);
	      } else {
	        nextFileList[fileIndex] = targetItem;
	      }
	
	      _this.onChange({
	        file: targetItem,
	        fileList: nextFileList
	      }); // fix ie progress
	
	
	      if (!window.File || ({"NODE_ENV":"production"}).TEST_IE) {
	        _this.autoUpdateProgress(0, targetItem);
	      }
	    };
	
	    _this.onSuccess = function (response, file, xhr) {
	      _this.clearProgressTimer();
	
	      try {
	        if (typeof response === 'string') {
	          response = JSON.parse(response);
	        }
	      } catch (e) {
	        /* do nothing */
	      }
	
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.status = 'done';
	      targetItem.response = response;
	      targetItem.xhr = xhr;
	
	      _this.onChange({
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.onProgress = function (e, file) {
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.percent = e.percent;
	
	      _this.onChange({
	        event: e,
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.onError = function (error, response, file) {
	      _this.clearProgressTimer();
	
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.error = error;
	      targetItem.response = response;
	      targetItem.status = 'error';
	
	      _this.onChange({
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.handleRemove = function (file) {
	      var onRemove = _this.props.onRemove;
	      var fileList = _this.state.fileList;
	      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
	        // Prevent removing file
	        if (ret === false) {
	          return;
	        }
	
	        var removedFileList = (0, _utils.removeFileItem)(file, fileList);
	
	        if (removedFileList) {
	          file.status = 'removed'; // eslint-disable-line
	
	          if (_this.upload) {
	            _this.upload.abort(file);
	          }
	
	          _this.onChange({
	            file: file,
	            fileList: removedFileList
	          });
	        }
	      });
	    };
	
	    _this.onChange = function (info) {
	      if (!('fileList' in _this.props)) {
	        _this.setState({
	          fileList: info.fileList
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(info);
	      }
	    };
	
	    _this.onFileDrop = function (e) {
	      _this.setState({
	        dragState: e.type
	      });
	    };
	
	    _this.beforeUpload = function (file, fileList) {
	      var beforeUpload = _this.props.beforeUpload;
	      var stateFileList = _this.state.fileList;
	
	      if (!beforeUpload) {
	        return true;
	      }
	
	      var result = beforeUpload(file, fileList);
	
	      if (result === false) {
	        _this.onChange({
	          file: file,
	          fileList: (0, _uniqBy["default"])(stateFileList.concat(fileList.map(_utils.fileToObject)), function (item) {
	            return item.uid;
	          })
	        });
	
	        return false;
	      }
	
	      if (result && result.then) {
	        return result;
	      }
	
	      return true;
	    };
	
	    _this.renderUploadList = function (locale) {
	      var _this$props = _this.props,
	          showUploadList = _this$props.showUploadList,
	          listType = _this$props.listType,
	          onPreview = _this$props.onPreview,
	          onDownload = _this$props.onDownload,
	          previewFile = _this$props.previewFile,
	          disabled = _this$props.disabled,
	          propLocale = _this$props.locale;
	      var showRemoveIcon = showUploadList.showRemoveIcon,
	          showPreviewIcon = showUploadList.showPreviewIcon,
	          showDownloadIcon = showUploadList.showDownloadIcon;
	      var fileList = _this.state.fileList;
	      return (/*#__PURE__*/React.createElement(_UploadList["default"], {
	          listType: listType,
	          items: fileList,
	          previewFile: previewFile,
	          onPreview: onPreview,
	          onDownload: onDownload,
	          onRemove: _this.handleRemove,
	          showRemoveIcon: !disabled && showRemoveIcon,
	          showPreviewIcon: showPreviewIcon,
	          showDownloadIcon: showDownloadIcon,
	          locale: _extends(_extends({}, locale), propLocale)
	        })
	      );
	    };
	
	    _this.renderUpload = function (_ref2) {
	      var _classNames2;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          showUploadList = _this$props2.showUploadList,
	          listType = _this$props2.listType,
	          type = _this$props2.type,
	          disabled = _this$props2.disabled,
	          children = _this$props2.children,
	          style = _this$props2.style;
	      var _this$state = _this.state,
	          fileList = _this$state.fileList,
	          dragState = _this$state.dragState;
	      var prefixCls = getPrefixCls('upload', customizePrefixCls);
	
	      var rcUploadProps = _extends(_extends({
	        onStart: _this.onStart,
	        onError: _this.onError,
	        onProgress: _this.onProgress,
	        onSuccess: _this.onSuccess
	      }, _this.props), {
	        prefixCls: prefixCls,
	        beforeUpload: _this.beforeUpload
	      });
	
	      delete rcUploadProps.className;
	      delete rcUploadProps.style; // Remove id to avoid open by label when trigger is hidden
	      // !children: https://github.com/ant-design/ant-design/issues/14298
	      // disabled: https://github.com/ant-design/ant-design/issues/16478
	      //           https://github.com/ant-design/ant-design/issues/24197
	
	      if (!children || disabled) {
	        delete rcUploadProps.id;
	      }
	
	      var uploadList = showUploadList ? /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Upload",
	        defaultLocale: _default2["default"].Upload
	      }, _this.renderUploadList) : null;
	
	      if (type === 'drag') {
	        var _classNames;
	
	        var dragCls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-drag"), true), _defineProperty(_classNames, "".concat(prefixCls, "-drag-uploading"), fileList.some(function (file) {
	          return file.status === 'uploading';
	        })), _defineProperty(_classNames, "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames), className);
	        return (/*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
	            className: dragCls,
	            onDrop: _this.onFileDrop,
	            onDragOver: _this.onFileDrop,
	            onDragLeave: _this.onFileDrop,
	            style: style
	          }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
	            ref: _this.saveUpload,
	            className: "".concat(prefixCls, "-btn")
	          }), /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-drag-container")
	          }, children))), uploadList)
	        );
	      }
	
	      var uploadButtonCls = (0, _classnames["default"])(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _classNames2));
	      var uploadButton = /*#__PURE__*/React.createElement("div", {
	        className: uploadButtonCls,
	        style: children ? undefined : {
	          display: 'none'
	        }
	      }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
	        ref: _this.saveUpload
	      })));
	
	      if (listType === 'picture-card') {
	        return (/*#__PURE__*/React.createElement("span", {
	            className: (0, _classnames["default"])(className, "".concat(prefixCls, "-picture-card-wrapper"))
	          }, uploadList, uploadButton)
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: className
	        }, uploadButton, uploadList)
	      );
	    };
	
	    _this.state = {
	      fileList: props.fileList || props.defaultFileList || [],
	      dragState: 'drop'
	    };
	    (0, _warning["default"])('fileList' in props || !('value' in props), 'Upload', '`value` is not validate prop, do you mean `fileList`?');
	    return _this;
	  }
	
	  _createClass(Upload, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearProgressTimer();
	    }
	  }, {
	    key: "clearProgressTimer",
	    value: function clearProgressTimer() {
	      clearInterval(this.progressTimer);
	    }
	  }, {
	    key: "autoUpdateProgress",
	    value: function autoUpdateProgress(_, file) {
	      var _this2 = this;
	
	      var getPercent = (0, _utils.genPercentAdd)();
	      var curPercent = 0;
	      this.clearProgressTimer();
	      this.progressTimer = setInterval(function () {
	        curPercent = getPercent(curPercent);
	
	        _this2.onProgress({
	          percent: curPercent * 100
	        }, file);
	      }, 200);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUpload)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('fileList' in nextProps) {
	        return {
	          fileList: nextProps.fileList || []
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Upload;
	}(React.Component);
	
	Upload.defaultProps = {
	  type: 'select',
	  multiple: false,
	  action: '',
	  data: {},
	  accept: '',
	  beforeUpload: _utils.T,
	  showUploadList: true,
	  listType: 'text',
	  className: '',
	  disabled: false,
	  supportServerRender: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Upload);
	var _default = Upload;
	exports["default"] = _default;

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.T = T;
	exports.fileToObject = fileToObject;
	exports.genPercentAdd = genPercentAdd;
	exports.getFileItem = getFileItem;
	exports.removeFileItem = removeFileItem;
	exports.previewImage = previewImage;
	exports.isImageUrl = void 0;
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function T() {
	  return true;
	} // Fix IE file.status problem
	// via coping a new Object
	
	
	function fileToObject(file) {
	  return _extends(_extends({}, file), {
	    lastModified: file.lastModified,
	    lastModifiedDate: file.lastModifiedDate,
	    name: file.name,
	    size: file.size,
	    type: file.type,
	    uid: file.uid,
	    percent: 0,
	    originFileObj: file
	  });
	}
	/**
	 * 生成Progress percent: 0.1 -> 0.98
	 *   - for ie
	 */
	
	function genPercentAdd() {
	  var k = 0.1;
	  var i = 0.01;
	  var end = 0.98;
	  return function (s) {
	    var start = s;
	
	    if (start >= end) {
	      return start;
	    }
	
	    start += k;
	    k -= i;
	
	    if (k < 0.001) {
	      k = 0.001;
	    }
	
	    return start;
	  };
	}
	
	function getFileItem(file, fileList) {
	  var matchKey = file.uid !== undefined ? 'uid' : 'name';
	  return fileList.filter(function (item) {
	    return item[matchKey] === file[matchKey];
	  })[0];
	}
	
	function removeFileItem(file, fileList) {
	  var matchKey = file.uid !== undefined ? 'uid' : 'name';
	  var removed = fileList.filter(function (item) {
	    return item[matchKey] !== file[matchKey];
	  });
	
	  if (removed.length === fileList.length) {
	    return null;
	  }
	
	  return removed;
	} // ==================== Default Image Preview ====================
	
	
	var extname = function extname() {
	  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var temp = url.split('/');
	  var filename = temp[temp.length - 1];
	  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
	  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
	};
	
	var isImageFileType = function isImageFileType(type) {
	  return !!type && type.indexOf('image/') === 0;
	};
	
	var isImageUrl = function isImageUrl(file) {
	  if (isImageFileType(file.type)) {
	    return true;
	  }
	
	  var url = file.thumbUrl || file.url;
	  var extension = extname(url);
	
	  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
	    return true;
	  }
	
	  if (/^data:/.test(url)) {
	    // other file types of base64
	    return false;
	  }
	
	  if (extension) {
	    // other file types which have extension
	    return false;
	  }
	
	  return true;
	};
	
	exports.isImageUrl = isImageUrl;
	var MEASURE_SIZE = 200;
	
	function previewImage(file) {
	  return new Promise(function (resolve) {
	    if (!isImageFileType(file.type)) {
	      resolve('');
	      return;
	    }
	
	    var canvas = document.createElement('canvas');
	    canvas.width = MEASURE_SIZE;
	    canvas.height = MEASURE_SIZE;
	    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
	    document.body.appendChild(canvas);
	    var ctx = canvas.getContext('2d');
	    var img = new Image();
	
	    img.onload = function () {
	      var width = img.width,
	          height = img.height;
	      var drawWidth = MEASURE_SIZE;
	      var drawHeight = MEASURE_SIZE;
	      var offsetX = 0;
	      var offsetY = 0;
	
	      if (width < height) {
	        drawHeight = height * (MEASURE_SIZE / width);
	        offsetY = -(drawHeight - drawWidth) / 2;
	      } else {
	        drawWidth = width * (MEASURE_SIZE / height);
	        offsetX = -(drawWidth - drawHeight) / 2;
	      }
	
	      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
	      var dataURL = canvas.toDataURL();
	      document.body.removeChild(canvas);
	      resolve(dataURL);
	    };
	
	    img.src = window.URL.createObjectURL(file);
	  });
	}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var noOptions = {};
	  var nonWS = /[^\s\u00a0]/;
	  var Pos = CodeMirror.Pos,
	      cmp = CodeMirror.cmpPos;
	
	  function firstNonWS(str) {
	    var found = str.search(nonWS);
	    return found == -1 ? 0 : found;
	  }
	
	  CodeMirror.commands.toggleComment = function (cm) {
	    cm.toggleComment();
	  };
	
	  CodeMirror.defineExtension("toggleComment", function (options) {
	    if (!options) options = noOptions;
	    var cm = this;
	    var minLine = Infinity,
	        ranges = this.listSelections(),
	        mode = null;
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var from = ranges[i].from(),
	          to = ranges[i].to();
	      if (from.line >= minLine) continue;
	      if (to.line >= minLine) to = Pos(minLine, 0);
	      minLine = from.line;
	      if (mode == null) {
	        if (cm.uncomment(from, to, options)) mode = "un";else {
	          cm.lineComment(from, to, options);mode = "line";
	        }
	      } else if (mode == "un") {
	        cm.uncomment(from, to, options);
	      } else {
	        cm.lineComment(from, to, options);
	      }
	    }
	  });
	
	  // Rough heuristic to try and detect lines that are part of multi-line string
	  function probablyInsideString(cm, pos, line) {
	    return (/\bstring\b/.test(cm.getTokenTypeAt(Pos(pos.line, 0))) && !/^[\'\"\`]/.test(line)
	    );
	  }
	
	  function getMode(cm, pos) {
	    var mode = cm.getMode();
	    return mode.useInnerComments === false || !mode.innerMode ? mode : cm.getModeAt(pos);
	  }
	
	  CodeMirror.defineExtension("lineComment", function (from, to, options) {
	    if (!options) options = noOptions;
	    var self = this,
	        mode = getMode(self, from);
	    var firstLine = self.getLine(from.line);
	    if (firstLine == null || probablyInsideString(self, from, firstLine)) return;
	
	    var commentString = options.lineComment || mode.lineComment;
	    if (!commentString) {
	      if (options.blockCommentStart || mode.blockCommentStart) {
	        options.fullLines = true;
	        self.blockComment(from, to, options);
	      }
	      return;
	    }
	
	    var end = Math.min(to.ch != 0 || to.line == from.line ? to.line + 1 : to.line, self.lastLine() + 1);
	    var pad = options.padding == null ? " " : options.padding;
	    var blankLines = options.commentBlankLines || from.line == to.line;
	
	    self.operation(function () {
	      if (options.indent) {
	        var baseString = null;
	        for (var i = from.line; i < end; ++i) {
	          var line = self.getLine(i);
	          var whitespace = line.search(nonWS) === -1 ? line : line.slice(0, firstNonWS(line));
	          if (baseString == null || baseString.length > whitespace.length) {
	            baseString = whitespace;
	          }
	        }
	        for (var i = from.line; i < end; ++i) {
	          var line = self.getLine(i),
	              cut = baseString.length;
	          if (!blankLines && !nonWS.test(line)) continue;
	          if (line.slice(0, cut) != baseString) cut = firstNonWS(line);
	          self.replaceRange(baseString + commentString + pad, Pos(i, 0), Pos(i, cut));
	        }
	      } else {
	        for (var i = from.line; i < end; ++i) {
	          if (blankLines || nonWS.test(self.getLine(i))) self.replaceRange(commentString + pad, Pos(i, 0));
	        }
	      }
	    });
	  });
	
	  CodeMirror.defineExtension("blockComment", function (from, to, options) {
	    if (!options) options = noOptions;
	    var self = this,
	        mode = getMode(self, from);
	    var startString = options.blockCommentStart || mode.blockCommentStart;
	    var endString = options.blockCommentEnd || mode.blockCommentEnd;
	    if (!startString || !endString) {
	      if ((options.lineComment || mode.lineComment) && options.fullLines != false) self.lineComment(from, to, options);
	      return;
	    }
	    if (/\bcomment\b/.test(self.getTokenTypeAt(Pos(from.line, 0)))) return;
	
	    var end = Math.min(to.line, self.lastLine());
	    if (end != from.line && to.ch == 0 && nonWS.test(self.getLine(end))) --end;
	
	    var pad = options.padding == null ? " " : options.padding;
	    if (from.line > end) return;
	
	    self.operation(function () {
	      if (options.fullLines != false) {
	        var lastLineHasText = nonWS.test(self.getLine(end));
	        self.replaceRange(pad + endString, Pos(end));
	        self.replaceRange(startString + pad, Pos(from.line, 0));
	        var lead = options.blockCommentLead || mode.blockCommentLead;
	        if (lead != null) for (var i = from.line + 1; i <= end; ++i) {
	          if (i != end || lastLineHasText) self.replaceRange(lead + pad, Pos(i, 0));
	        }
	      } else {
	        var atCursor = cmp(self.getCursor("to"), to) == 0,
	            empty = !self.somethingSelected();
	        self.replaceRange(endString, to);
	        if (atCursor) self.setSelection(empty ? to : self.getCursor("from"), to);
	        self.replaceRange(startString, from);
	      }
	    });
	  });
	
	  CodeMirror.defineExtension("uncomment", function (from, to, options) {
	    if (!options) options = noOptions;
	    var self = this,
	        mode = getMode(self, from);
	    var end = Math.min(to.ch != 0 || to.line == from.line ? to.line : to.line - 1, self.lastLine()),
	        start = Math.min(from.line, end);
	
	    // Try finding line comments
	    var lineString = options.lineComment || mode.lineComment,
	        lines = [];
	    var pad = options.padding == null ? " " : options.padding,
	        didSomething;
	    lineComment: {
	      if (!lineString) break lineComment;
	      for (var i = start; i <= end; ++i) {
	        var line = self.getLine(i);
	        var found = line.indexOf(lineString);
	        if (found > -1 && !/comment/.test(self.getTokenTypeAt(Pos(i, found + 1)))) found = -1;
	        if (found == -1 && nonWS.test(line)) break lineComment;
	        if (found > -1 && nonWS.test(line.slice(0, found))) break lineComment;
	        lines.push(line);
	      }
	      self.operation(function () {
	        for (var i = start; i <= end; ++i) {
	          var line = lines[i - start];
	          var pos = line.indexOf(lineString),
	              endPos = pos + lineString.length;
	          if (pos < 0) continue;
	          if (line.slice(endPos, endPos + pad.length) == pad) endPos += pad.length;
	          didSomething = true;
	          self.replaceRange("", Pos(i, pos), Pos(i, endPos));
	        }
	      });
	      if (didSomething) return true;
	    }
	
	    // Try block comments
	    var startString = options.blockCommentStart || mode.blockCommentStart;
	    var endString = options.blockCommentEnd || mode.blockCommentEnd;
	    if (!startString || !endString) return false;
	    var lead = options.blockCommentLead || mode.blockCommentLead;
	    var startLine = self.getLine(start),
	        open = startLine.indexOf(startString);
	    if (open == -1) return false;
	    var endLine = end == start ? startLine : self.getLine(end);
	    var close = endLine.indexOf(endString, end == start ? open + startString.length : 0);
	    var insideStart = Pos(start, open + 1),
	        insideEnd = Pos(end, close + 1);
	    if (close == -1 || !/comment/.test(self.getTokenTypeAt(insideStart)) || !/comment/.test(self.getTokenTypeAt(insideEnd)) || self.getRange(insideStart, insideEnd, "\n").indexOf(endString) > -1) return false;
	
	    // Avoid killing block comments completely outside the selection.
	    // Positions of the last startString before the start of the selection, and the first endString after it.
	    var lastStart = startLine.lastIndexOf(startString, from.ch);
	    var firstEnd = lastStart == -1 ? -1 : startLine.slice(0, from.ch).indexOf(endString, lastStart + startString.length);
	    if (lastStart != -1 && firstEnd != -1 && firstEnd + endString.length != from.ch) return false;
	    // Positions of the first endString after the end of the selection, and the last startString before it.
	    firstEnd = endLine.indexOf(endString, to.ch);
	    var almostLastStart = endLine.slice(to.ch).lastIndexOf(startString, firstEnd - to.ch);
	    lastStart = firstEnd == -1 || almostLastStart == -1 ? -1 : to.ch + almostLastStart;
	    if (firstEnd != -1 && lastStart != -1 && lastStart != to.ch) return false;
	
	    self.operation(function () {
	      self.replaceRange("", Pos(end, close - (pad && endLine.slice(close - pad.length, close) == pad ? pad.length : 0)), Pos(end, close + endString.length));
	      var openEnd = open + startString.length;
	      if (pad && startLine.slice(openEnd, openEnd + pad.length) == pad) openEnd += pad.length;
	      self.replaceRange("", Pos(start, open), Pos(start, openEnd));
	      if (lead) for (var i = start + 1; i <= end; ++i) {
	        var line = self.getLine(i),
	            found = line.indexOf(lead);
	        if (found == -1 || nonWS.test(line.slice(0, found))) continue;
	        var foundEnd = found + lead.length;
	        if (pad && line.slice(foundEnd, foundEnd + pad.length) == pad) foundEnd += pad.length;
	        self.replaceRange("", Pos(i, found), Pos(i, foundEnd));
	      }
	    });
	    return true;
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineOption("autoRefresh", false, function (cm, val) {
	    if (cm.state.autoRefresh) {
	      stopListening(cm, cm.state.autoRefresh);
	      cm.state.autoRefresh = null;
	    }
	    if (val && cm.display.wrapper.offsetHeight == 0) startListening(cm, cm.state.autoRefresh = { delay: val.delay || 250 });
	  });
	
	  function startListening(cm, state) {
	    function check() {
	      if (cm.display.wrapper.offsetHeight) {
	        stopListening(cm, state);
	        if (cm.display.lastWrapHeight != cm.display.wrapper.clientHeight) cm.refresh();
	      } else {
	        state.timeout = setTimeout(check, state.delay);
	      }
	    }
	    state.timeout = setTimeout(check, state.delay);
	    state.hurry = function () {
	      clearTimeout(state.timeout);
	      state.timeout = setTimeout(check, 50);
	    };
	    CodeMirror.on(window, "mouseup", state.hurry);
	    CodeMirror.on(window, "keyup", state.hurry);
	  }
	
	  function stopListening(_cm, state) {
	    clearTimeout(state.timeout);
	    CodeMirror.off(window, "mouseup", state.hurry);
	    CodeMirror.off(window, "keyup", state.hurry);
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var defaults = {
	    pairs: "()[]{}''\"\"",
	    closeBefore: ")]}'\":;>",
	    triples: "",
	    explode: "[]{}"
	  };
	
	  var Pos = CodeMirror.Pos;
	
	  CodeMirror.defineOption("autoCloseBrackets", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.removeKeyMap(keyMap);
	      cm.state.closeBrackets = null;
	    }
	    if (val) {
	      ensureBound(getOption(val, "pairs"));
	      cm.state.closeBrackets = val;
	      cm.addKeyMap(keyMap);
	    }
	  });
	
	  function getOption(conf, name) {
	    if (name == "pairs" && typeof conf == "string") return conf;
	    if ((typeof conf === "undefined" ? "undefined" : _typeof(conf)) == "object" && conf[name] != null) return conf[name];
	    return defaults[name];
	  }
	
	  var keyMap = { Backspace: handleBackspace, Enter: handleEnter };
	  function ensureBound(chars) {
	    for (var i = 0; i < chars.length; i++) {
	      var ch = chars.charAt(i),
	          key = "'" + ch + "'";
	      if (!keyMap[key]) keyMap[key] = handler(ch);
	    }
	  }
	  ensureBound(defaults.pairs + "`");
	
	  function handler(ch) {
	    return function (cm) {
	      return handleChar(cm, ch);
	    };
	  }
	
	  function getConfig(cm) {
	    var deflt = cm.state.closeBrackets;
	    if (!deflt || deflt.override) return deflt;
	    var mode = cm.getModeAt(cm.getCursor());
	    return mode.closeBrackets || deflt;
	  }
	
	  function handleBackspace(cm) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || pairs.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var cur = ranges[i].head;
	      cm.replaceRange("", Pos(cur.line, cur.ch - 1), Pos(cur.line, cur.ch + 1), "+delete");
	    }
	  }
	
	  function handleEnter(cm) {
	    var conf = getConfig(cm);
	    var explode = conf && getOption(conf, "explode");
	    if (!explode || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || explode.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    cm.operation(function () {
	      var linesep = cm.lineSeparator() || "\n";
	      cm.replaceSelection(linesep + linesep, null);
	      moveSel(cm, -1);
	      ranges = cm.listSelections();
	      for (var i = 0; i < ranges.length; i++) {
	        var line = ranges[i].head.line;
	        cm.indentLine(line, null, true);
	        cm.indentLine(line + 1, null, true);
	      }
	    });
	  }
	
	  function moveSel(cm, dir) {
	    var newRanges = [],
	        ranges = cm.listSelections(),
	        primary = 0;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      if (range.head == cm.getCursor()) primary = i;
	      var pos = range.head.ch || dir > 0 ? { line: range.head.line, ch: range.head.ch + dir } : { line: range.head.line - 1 };
	      newRanges.push({ anchor: pos, head: pos });
	    }
	    cm.setSelections(newRanges, primary);
	  }
	
	  function contractSelection(sel) {
	    var inverted = CodeMirror.cmpPos(sel.anchor, sel.head) > 0;
	    return { anchor: new Pos(sel.anchor.line, sel.anchor.ch + (inverted ? -1 : 1)),
	      head: new Pos(sel.head.line, sel.head.ch + (inverted ? 1 : -1)) };
	  }
	
	  function handleChar(cm, ch) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var pos = pairs.indexOf(ch);
	    if (pos == -1) return CodeMirror.Pass;
	
	    var closeBefore = getOption(conf, "closeBefore");
	
	    var triples = getOption(conf, "triples");
	
	    var identical = pairs.charAt(pos + 1) == ch;
	    var ranges = cm.listSelections();
	    var opening = pos % 2 == 0;
	
	    var type;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i],
	          cur = range.head,
	          curType;
	      var next = cm.getRange(cur, Pos(cur.line, cur.ch + 1));
	      if (opening && !range.empty()) {
	        curType = "surround";
	      } else if ((identical || !opening) && next == ch) {
	        if (identical && stringStartsAfter(cm, cur)) curType = "both";else if (triples.indexOf(ch) >= 0 && cm.getRange(cur, Pos(cur.line, cur.ch + 3)) == ch + ch + ch) curType = "skipThree";else curType = "skip";
	      } else if (identical && cur.ch > 1 && triples.indexOf(ch) >= 0 && cm.getRange(Pos(cur.line, cur.ch - 2), cur) == ch + ch) {
	        if (cur.ch > 2 && /\bstring/.test(cm.getTokenTypeAt(Pos(cur.line, cur.ch - 2)))) return CodeMirror.Pass;
	        curType = "addFour";
	      } else if (identical) {
	        var prev = cur.ch == 0 ? " " : cm.getRange(Pos(cur.line, cur.ch - 1), cur);
	        if (!CodeMirror.isWordChar(next) && prev != ch && !CodeMirror.isWordChar(prev)) curType = "both";else return CodeMirror.Pass;
	      } else if (opening && (next.length === 0 || /\s/.test(next) || closeBefore.indexOf(next) > -1)) {
	        curType = "both";
	      } else {
	        return CodeMirror.Pass;
	      }
	      if (!type) type = curType;else if (type != curType) return CodeMirror.Pass;
	    }
	
	    var left = pos % 2 ? pairs.charAt(pos - 1) : ch;
	    var right = pos % 2 ? ch : pairs.charAt(pos + 1);
	    cm.operation(function () {
	      if (type == "skip") {
	        moveSel(cm, 1);
	      } else if (type == "skipThree") {
	        moveSel(cm, 3);
	      } else if (type == "surround") {
	        var sels = cm.getSelections();
	        for (var i = 0; i < sels.length; i++) {
	          sels[i] = left + sels[i] + right;
	        }cm.replaceSelections(sels, "around");
	        sels = cm.listSelections().slice();
	        for (var i = 0; i < sels.length; i++) {
	          sels[i] = contractSelection(sels[i]);
	        }cm.setSelections(sels);
	      } else if (type == "both") {
	        cm.replaceSelection(left + right, null);
	        cm.triggerElectric(left + right);
	        moveSel(cm, -1);
	      } else if (type == "addFour") {
	        cm.replaceSelection(left + left + left + left, "before");
	        moveSel(cm, 1);
	      }
	    });
	  }
	
	  function charsAround(cm, pos) {
	    var str = cm.getRange(Pos(pos.line, pos.ch - 1), Pos(pos.line, pos.ch + 1));
	    return str.length == 2 ? str : null;
	  }
	
	  function stringStartsAfter(cm, pos) {
	    var token = cm.getTokenAt(Pos(pos.line, pos.ch + 1));
	    return (/\bstring/.test(token.type) && token.start == pos.ch && (pos.ch == 0 || !/\bstring/.test(cm.getTokenTypeAt(pos)))
	    );
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  function bracketFolding(pairs) {
	    return function (cm, start) {
	      var line = start.line,
	          lineText = cm.getLine(line);
	
	      function findOpening(pair) {
	        var tokenType;
	        for (var at = start.ch, pass = 0;;) {
	          var found = at <= 0 ? -1 : lineText.lastIndexOf(pair[0], at - 1);
	          if (found == -1) {
	            if (pass == 1) break;
	            pass = 1;
	            at = lineText.length;
	            continue;
	          }
	          if (pass == 1 && found < start.ch) break;
	          tokenType = cm.getTokenTypeAt(CodeMirror.Pos(line, found + 1));
	          if (!/^(comment|string)/.test(tokenType)) return { ch: found + 1, tokenType: tokenType, pair: pair };
	          at = found - 1;
	        }
	      }
	
	      function findRange(found) {
	        var count = 1,
	            lastLine = cm.lastLine(),
	            end,
	            startCh = found.ch,
	            endCh;
	        outer: for (var i = line; i <= lastLine; ++i) {
	          var text = cm.getLine(i),
	              pos = i == line ? startCh : 0;
	          for (;;) {
	            var nextOpen = text.indexOf(found.pair[0], pos),
	                nextClose = text.indexOf(found.pair[1], pos);
	            if (nextOpen < 0) nextOpen = text.length;
	            if (nextClose < 0) nextClose = text.length;
	            pos = Math.min(nextOpen, nextClose);
	            if (pos == text.length) break;
	            if (cm.getTokenTypeAt(CodeMirror.Pos(i, pos + 1)) == found.tokenType) {
	              if (pos == nextOpen) ++count;else if (! --count) {
	                end = i;endCh = pos;break outer;
	              }
	            }
	            ++pos;
	          }
	        }
	
	        if (end == null || line == end) return null;
	        return { from: CodeMirror.Pos(line, startCh),
	          to: CodeMirror.Pos(end, endCh) };
	      }
	
	      var found = [];
	      for (var i = 0; i < pairs.length; i++) {
	        var open = findOpening(pairs[i]);
	        if (open) found.push(open);
	      }
	      found.sort(function (a, b) {
	        return a.ch - b.ch;
	      });
	      for (var i = 0; i < found.length; i++) {
	        var range = findRange(found[i]);
	        if (range) return range;
	      }
	      return null;
	    };
	  }
	
	  CodeMirror.registerHelper("fold", "brace", bracketFolding([["{", "}"], ["[", "]"]]));
	
	  CodeMirror.registerHelper("fold", "brace-paren", bracketFolding([["{", "}"], ["[", "]"], ["(", ")"]]));
	
	  CodeMirror.registerHelper("fold", "import", function (cm, start) {
	    function hasImport(line) {
	      if (line < cm.firstLine() || line > cm.lastLine()) return null;
	      var start = cm.getTokenAt(CodeMirror.Pos(line, 1));
	      if (!/\S/.test(start.string)) start = cm.getTokenAt(CodeMirror.Pos(line, start.end + 1));
	      if (start.type != "keyword" || start.string != "import") return null;
	      // Now find closing semicolon, return its position
	      for (var i = line, e = Math.min(cm.lastLine(), line + 10); i <= e; ++i) {
	        var text = cm.getLine(i),
	            semi = text.indexOf(";");
	        if (semi != -1) return { startCh: start.end, end: CodeMirror.Pos(i, semi) };
	      }
	    }
	
	    var startLine = start.line,
	        has = hasImport(startLine),
	        prev;
	    if (!has || hasImport(startLine - 1) || (prev = hasImport(startLine - 2)) && prev.end.line == startLine - 1) return null;
	    for (var end = has.end;;) {
	      var next = hasImport(end.line + 1);
	      if (next == null) break;
	      end = next.end;
	    }
	    return { from: cm.clipPos(CodeMirror.Pos(startLine, has.startCh + 1)), to: end };
	  });
	
	  CodeMirror.registerHelper("fold", "include", function (cm, start) {
	    function hasInclude(line) {
	      if (line < cm.firstLine() || line > cm.lastLine()) return null;
	      var start = cm.getTokenAt(CodeMirror.Pos(line, 1));
	      if (!/\S/.test(start.string)) start = cm.getTokenAt(CodeMirror.Pos(line, start.end + 1));
	      if (start.type == "meta" && start.string.slice(0, 8) == "#include") return start.start + 8;
	    }
	
	    var startLine = start.line,
	        has = hasInclude(startLine);
	    if (has == null || hasInclude(startLine - 1) != null) return null;
	    for (var end = startLine;;) {
	      var next = hasInclude(end + 1);
	      if (next == null) break;
	      ++end;
	    }
	    return { from: CodeMirror.Pos(startLine, has + 1),
	      to: cm.clipPos(CodeMirror.Pos(end)) };
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.registerGlobalHelper("fold", "comment", function (mode) {
	    return mode.blockCommentStart && mode.blockCommentEnd;
	  }, function (cm, start) {
	    var mode = cm.getModeAt(start),
	        startToken = mode.blockCommentStart,
	        endToken = mode.blockCommentEnd;
	    if (!startToken || !endToken) return;
	    var line = start.line,
	        lineText = cm.getLine(line);
	
	    var startCh;
	    for (var at = start.ch, pass = 0;;) {
	      var found = at <= 0 ? -1 : lineText.lastIndexOf(startToken, at - 1);
	      if (found == -1) {
	        if (pass == 1) return;
	        pass = 1;
	        at = lineText.length;
	        continue;
	      }
	      if (pass == 1 && found < start.ch) return;
	      if (/comment/.test(cm.getTokenTypeAt(CodeMirror.Pos(line, found + 1))) && (found == 0 || lineText.slice(found - endToken.length, found) == endToken || !/comment/.test(cm.getTokenTypeAt(CodeMirror.Pos(line, found))))) {
	        startCh = found + startToken.length;
	        break;
	      }
	      at = found - 1;
	    }
	
	    var depth = 1,
	        lastLine = cm.lastLine(),
	        end,
	        endCh;
	    outer: for (var i = line; i <= lastLine; ++i) {
	      var text = cm.getLine(i),
	          pos = i == line ? startCh : 0;
	      for (;;) {
	        var nextOpen = text.indexOf(startToken, pos),
	            nextClose = text.indexOf(endToken, pos);
	        if (nextOpen < 0) nextOpen = text.length;
	        if (nextClose < 0) nextClose = text.length;
	        pos = Math.min(nextOpen, nextClose);
	        if (pos == text.length) break;
	        if (pos == nextOpen) ++depth;else if (! --depth) {
	          end = i;endCh = pos;break outer;
	        }
	        ++pos;
	      }
	    }
	    if (end == null || line == end && endCh == startCh) return;
	    return { from: CodeMirror.Pos(line, startCh),
	      to: CodeMirror.Pos(end, endCh) };
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31), __webpack_require__(247));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(247)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineOption("foldGutter", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.clearGutter(cm.state.foldGutter.options.gutter);
	      cm.state.foldGutter = null;
	      cm.off("gutterClick", onGutterClick);
	      cm.off("changes", onChange);
	      cm.off("viewportChange", onViewportChange);
	      cm.off("fold", onFold);
	      cm.off("unfold", onFold);
	      cm.off("swapDoc", onChange);
	      cm.off("optionChange", optionChange);
	    }
	    if (val) {
	      cm.state.foldGutter = new State(parseOptions(val));
	      updateInViewport(cm);
	      cm.on("gutterClick", onGutterClick);
	      cm.on("changes", onChange);
	      cm.on("viewportChange", onViewportChange);
	      cm.on("fold", onFold);
	      cm.on("unfold", onFold);
	      cm.on("swapDoc", onChange);
	      cm.on("optionChange", optionChange);
	    }
	  });
	
	  var Pos = CodeMirror.Pos;
	
	  function State(options) {
	    this.options = options;
	    this.from = this.to = 0;
	  }
	
	  function parseOptions(opts) {
	    if (opts === true) opts = {};
	    if (opts.gutter == null) opts.gutter = "CodeMirror-foldgutter";
	    if (opts.indicatorOpen == null) opts.indicatorOpen = "CodeMirror-foldgutter-open";
	    if (opts.indicatorFolded == null) opts.indicatorFolded = "CodeMirror-foldgutter-folded";
	    return opts;
	  }
	
	  function isFolded(cm, line) {
	    var marks = cm.findMarks(Pos(line, 0), Pos(line + 1, 0));
	    for (var i = 0; i < marks.length; ++i) {
	      if (marks[i].__isFold) {
	        var fromPos = marks[i].find(-1);
	        if (fromPos && fromPos.line === line) return marks[i];
	      }
	    }
	  }
	
	  function marker(spec) {
	    if (typeof spec == "string") {
	      var elt = document.createElement("div");
	      elt.className = spec + " CodeMirror-guttermarker-subtle";
	      return elt;
	    } else {
	      return spec.cloneNode(true);
	    }
	  }
	
	  function updateFoldInfo(cm, from, to) {
	    var opts = cm.state.foldGutter.options,
	        cur = from - 1;
	    var minSize = cm.foldOption(opts, "minFoldSize");
	    var func = cm.foldOption(opts, "rangeFinder");
	    // we can reuse the built-in indicator element if its className matches the new state
	    var clsFolded = typeof opts.indicatorFolded == "string" && classTest(opts.indicatorFolded);
	    var clsOpen = typeof opts.indicatorOpen == "string" && classTest(opts.indicatorOpen);
	    cm.eachLine(from, to, function (line) {
	      ++cur;
	      var mark = null;
	      var old = line.gutterMarkers;
	      if (old) old = old[opts.gutter];
	      if (isFolded(cm, cur)) {
	        if (clsFolded && old && clsFolded.test(old.className)) return;
	        mark = marker(opts.indicatorFolded);
	      } else {
	        var pos = Pos(cur, 0);
	        var range = func && func(cm, pos);
	        if (range && range.to.line - range.from.line >= minSize) {
	          if (clsOpen && old && clsOpen.test(old.className)) return;
	          mark = marker(opts.indicatorOpen);
	        }
	      }
	      if (!mark && !old) return;
	      cm.setGutterMarker(line, opts.gutter, mark);
	    });
	  }
	
	  // copied from CodeMirror/src/util/dom.js
	  function classTest(cls) {
	    return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
	  }
	
	  function updateInViewport(cm) {
	    var vp = cm.getViewport(),
	        state = cm.state.foldGutter;
	    if (!state) return;
	    cm.operation(function () {
	      updateFoldInfo(cm, vp.from, vp.to);
	    });
	    state.from = vp.from;state.to = vp.to;
	  }
	
	  function onGutterClick(cm, line, gutter) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    if (gutter != opts.gutter) return;
	    var folded = isFolded(cm, line);
	    if (folded) folded.clear();else cm.foldCode(Pos(line, 0), opts);
	  }
	
	  function optionChange(cm, option) {
	    if (option == "mode") onChange(cm);
	  }
	
	  function onChange(cm) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    state.from = state.to = 0;
	    clearTimeout(state.changeUpdate);
	    state.changeUpdate = setTimeout(function () {
	      updateInViewport(cm);
	    }, opts.foldOnChangeTimeSpan || 600);
	  }
	
	  function onViewportChange(cm) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    clearTimeout(state.changeUpdate);
	    state.changeUpdate = setTimeout(function () {
	      var vp = cm.getViewport();
	      if (state.from == state.to || vp.from - state.to > 20 || state.from - vp.to > 20) {
	        updateInViewport(cm);
	      } else {
	        cm.operation(function () {
	          if (vp.from < state.from) {
	            updateFoldInfo(cm, vp.from, state.from);
	            state.from = vp.from;
	          }
	          if (vp.to > state.to) {
	            updateFoldInfo(cm, state.to, vp.to);
	            state.to = vp.to;
	          }
	        });
	      }
	    }, opts.updateViewportTimeSpan || 400);
	  }
	
	  function onFold(cm, from) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var line = from.line;
	    if (line >= state.from && line < state.to) updateFoldInfo(cm, line, line + 1);
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var Pos = CodeMirror.Pos;
	
	  function forEach(arr, f) {
	    for (var i = 0, e = arr.length; i < e; ++i) {
	      f(arr[i]);
	    }
	  }
	
	  function arrayContains(arr, item) {
	    if (!Array.prototype.indexOf) {
	      var i = arr.length;
	      while (i--) {
	        if (arr[i] === item) {
	          return true;
	        }
	      }
	      return false;
	    }
	    return arr.indexOf(item) != -1;
	  }
	
	  function scriptHint(editor, keywords, getToken, options) {
	    // Find the token at the cursor
	    var cur = editor.getCursor(),
	        token = getToken(editor, cur);
	    if (/\b(?:string|comment)\b/.test(token.type)) return;
	    var innerMode = CodeMirror.innerMode(editor.getMode(), token.state);
	    if (innerMode.mode.helperType === "json") return;
	    token.state = innerMode.state;
	
	    // If it's not a 'word-style' token, ignore the token.
	    if (!/^[\w$_]*$/.test(token.string)) {
	      token = { start: cur.ch, end: cur.ch, string: "", state: token.state,
	        type: token.string == "." ? "property" : null };
	    } else if (token.end > cur.ch) {
	      token.end = cur.ch;
	      token.string = token.string.slice(0, cur.ch - token.start);
	    }
	
	    var tprop = token;
	    // If it is a property, find out what it is a property of.
	    while (tprop.type == "property") {
	      tprop = getToken(editor, Pos(cur.line, tprop.start));
	      if (tprop.string != ".") return;
	      tprop = getToken(editor, Pos(cur.line, tprop.start));
	      if (!context) var context = [];
	      context.push(tprop);
	    }
	    return { list: getCompletions(token, context, keywords, options),
	      from: Pos(cur.line, token.start),
	      to: Pos(cur.line, token.end) };
	  }
	
	  function javascriptHint(editor, options) {
	    return scriptHint(editor, javascriptKeywords, function (e, cur) {
	      return e.getTokenAt(cur);
	    }, options);
	  };
	  CodeMirror.registerHelper("hint", "javascript", javascriptHint);
	
	  function getCoffeeScriptToken(editor, cur) {
	    // This getToken, it is for coffeescript, imitates the behavior of
	    // getTokenAt method in javascript.js, that is, returning "property"
	    // type and treat "." as independent token.
	    var token = editor.getTokenAt(cur);
	    if (cur.ch == token.start + 1 && token.string.charAt(0) == '.') {
	      token.end = token.start;
	      token.string = '.';
	      token.type = "property";
	    } else if (/^\.[\w$_]*$/.test(token.string)) {
	      token.type = "property";
	      token.start++;
	      token.string = token.string.replace(/\./, '');
	    }
	    return token;
	  }
	
	  function coffeescriptHint(editor, options) {
	    return scriptHint(editor, coffeescriptKeywords, getCoffeeScriptToken, options);
	  }
	  CodeMirror.registerHelper("hint", "coffeescript", coffeescriptHint);
	
	  var stringProps = ("charAt charCodeAt indexOf lastIndexOf substring substr slice trim trimLeft trimRight " + "toUpperCase toLowerCase split concat match replace search").split(" ");
	  var arrayProps = ("length concat join splice push pop shift unshift slice reverse sort indexOf " + "lastIndexOf every some filter forEach map reduce reduceRight ").split(" ");
	  var funcProps = "prototype apply call bind".split(" ");
	  var javascriptKeywords = ("break case catch class const continue debugger default delete do else export extends false finally for function " + "if in import instanceof new null return super switch this throw true try typeof var void while with yield").split(" ");
	  var coffeescriptKeywords = ("and break catch class continue delete do else extends false finally for " + "if in instanceof isnt new no not null of off on or return switch then throw true try typeof until void while with yes").split(" ");
	
	  function forAllProps(obj, callback) {
	    if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
	      for (var name in obj) {
	        callback(name);
	      }
	    } else {
	      for (var o = obj; o; o = Object.getPrototypeOf(o)) {
	        Object.getOwnPropertyNames(o).forEach(callback);
	      }
	    }
	  }
	
	  function getCompletions(token, context, keywords, options) {
	    var found = [],
	        start = token.string,
	        global = options && options.globalScope || window;
	    function maybeAdd(str) {
	      if (str.lastIndexOf(start, 0) == 0 && !arrayContains(found, str)) found.push(str);
	    }
	    function gatherCompletions(obj) {
	      if (typeof obj == "string") forEach(stringProps, maybeAdd);else if (obj instanceof Array) forEach(arrayProps, maybeAdd);else if (obj instanceof Function) forEach(funcProps, maybeAdd);
	      forAllProps(obj, maybeAdd);
	    }
	
	    if (context && context.length) {
	      // If this is a property, see if it belongs to some object we can
	      // find in the current environment.
	      var obj = context.pop(),
	          base;
	      if (obj.type && obj.type.indexOf("variable") === 0) {
	        if (options && options.additionalContext) base = options.additionalContext[obj.string];
	        if (!options || options.useGlobalScope !== false) base = base || global[obj.string];
	      } else if (obj.type == "string") {
	        base = "";
	      } else if (obj.type == "atom") {
	        base = 1;
	      } else if (obj.type == "function") {
	        if (global.jQuery != null && (obj.string == '$' || obj.string == 'jQuery') && typeof global.jQuery == 'function') base = global.jQuery();else if (global._ != null && obj.string == '_' && typeof global._ == 'function') base = global._();
	      }
	      while (base != null && context.length) {
	        base = base[context.pop().string];
	      }if (base != null) gatherCompletions(base);
	    } else {
	      // If not, just look in the global object, any local scope, and optional additional-context
	      // (reading into JS mode internals to get at the local and global variables)
	      for (var v = token.state.localVars; v; v = v.next) {
	        maybeAdd(v.name);
	      }for (var c = token.state.context; c; c = c.prev) {
	        for (var v = c.vars; v; v = v.next) {
	          maybeAdd(v.name);
	        }
	      }for (var v = token.state.globalVars; v; v = v.next) {
	        maybeAdd(v.name);
	      }if (options && options.additionalContext != null) for (var key in options.additionalContext) {
	        maybeAdd(key);
	      }if (!options || options.useGlobalScope !== false) gatherCompletions(global);
	      forEach(keywords, maybeAdd);
	    }
	    return found;
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// declare global: DOMRect
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var HINT_ELEMENT_CLASS = "CodeMirror-hint";
	  var ACTIVE_HINT_ELEMENT_CLASS = "CodeMirror-hint-active";
	
	  // This is the old interface, kept around for now to stay
	  // backwards-compatible.
	  CodeMirror.showHint = function (cm, getHints, options) {
	    if (!getHints) return cm.showHint(options);
	    if (options && options.async) getHints.async = true;
	    var newOpts = { hint: getHints };
	    if (options) for (var prop in options) {
	      newOpts[prop] = options[prop];
	    }return cm.showHint(newOpts);
	  };
	
	  CodeMirror.defineExtension("showHint", function (options) {
	    options = parseOptions(this, this.getCursor("start"), options);
	    var selections = this.listSelections();
	    if (selections.length > 1) return;
	    // By default, don't allow completion when something is selected.
	    // A hint function can have a `supportsSelection` property to
	    // indicate that it can handle selections.
	    if (this.somethingSelected()) {
	      if (!options.hint.supportsSelection) return;
	      // Don't try with cross-line selections
	      for (var i = 0; i < selections.length; i++) {
	        if (selections[i].head.line != selections[i].anchor.line) return;
	      }
	    }
	
	    if (this.state.completionActive) this.state.completionActive.close();
	    var completion = this.state.completionActive = new Completion(this, options);
	    if (!completion.options.hint) return;
	
	    CodeMirror.signal(this, "startCompletion", this);
	    completion.update(true);
	  });
	
	  CodeMirror.defineExtension("closeHint", function () {
	    if (this.state.completionActive) this.state.completionActive.close();
	  });
	
	  function Completion(cm, options) {
	    this.cm = cm;
	    this.options = options;
	    this.widget = null;
	    this.debounce = 0;
	    this.tick = 0;
	    this.startPos = this.cm.getCursor("start");
	    this.startLen = this.cm.getLine(this.startPos.line).length - this.cm.getSelection().length;
	
	    if (this.options.updateOnCursorActivity) {
	      var self = this;
	      cm.on("cursorActivity", this.activityFunc = function () {
	        self.cursorActivity();
	      });
	    }
	  }
	
	  var requestAnimationFrame = window.requestAnimationFrame || function (fn) {
	    return setTimeout(fn, 1000 / 60);
	  };
	  var cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
	
	  Completion.prototype = {
	    close: function close() {
	      if (!this.active()) return;
	      this.cm.state.completionActive = null;
	      this.tick = null;
	      if (this.options.updateOnCursorActivity) {
	        this.cm.off("cursorActivity", this.activityFunc);
	      }
	
	      if (this.widget && this.data) CodeMirror.signal(this.data, "close");
	      if (this.widget) this.widget.close();
	      CodeMirror.signal(this.cm, "endCompletion", this.cm);
	    },
	
	    active: function active() {
	      return this.cm.state.completionActive == this;
	    },
	
	    pick: function pick(data, i) {
	      var completion = data.list[i],
	          self = this;
	      this.cm.operation(function () {
	        if (completion.hint) completion.hint(self.cm, data, completion);else self.cm.replaceRange(getText(completion), completion.from || data.from, completion.to || data.to, "complete");
	        CodeMirror.signal(data, "pick", completion);
	        self.cm.scrollIntoView();
	      });
	      if (this.options.closeOnPick) {
	        this.close();
	      }
	    },
	
	    cursorActivity: function cursorActivity() {
	      if (this.debounce) {
	        cancelAnimationFrame(this.debounce);
	        this.debounce = 0;
	      }
	
	      var identStart = this.startPos;
	      if (this.data) {
	        identStart = this.data.from;
	      }
	
	      var pos = this.cm.getCursor(),
	          line = this.cm.getLine(pos.line);
	      if (pos.line != this.startPos.line || line.length - pos.ch != this.startLen - this.startPos.ch || pos.ch < identStart.ch || this.cm.somethingSelected() || !pos.ch || this.options.closeCharacters.test(line.charAt(pos.ch - 1))) {
	        this.close();
	      } else {
	        var self = this;
	        this.debounce = requestAnimationFrame(function () {
	          self.update();
	        });
	        if (this.widget) this.widget.disable();
	      }
	    },
	
	    update: function update(first) {
	      if (this.tick == null) return;
	      var self = this,
	          myTick = ++this.tick;
	      fetchHints(this.options.hint, this.cm, this.options, function (data) {
	        if (self.tick == myTick) self.finishUpdate(data, first);
	      });
	    },
	
	    finishUpdate: function finishUpdate(data, first) {
	      if (this.data) CodeMirror.signal(this.data, "update");
	
	      var picked = this.widget && this.widget.picked || first && this.options.completeSingle;
	      if (this.widget) this.widget.close();
	
	      this.data = data;
	
	      if (data && data.list.length) {
	        if (picked && data.list.length == 1) {
	          this.pick(data, 0);
	        } else {
	          this.widget = new Widget(this, data);
	          CodeMirror.signal(data, "shown");
	        }
	      }
	    }
	  };
	
	  function parseOptions(cm, pos, options) {
	    var editor = cm.options.hintOptions;
	    var out = {};
	    for (var prop in defaultOptions) {
	      out[prop] = defaultOptions[prop];
	    }if (editor) for (var prop in editor) {
	      if (editor[prop] !== undefined) out[prop] = editor[prop];
	    }if (options) for (var prop in options) {
	      if (options[prop] !== undefined) out[prop] = options[prop];
	    }if (out.hint.resolve) out.hint = out.hint.resolve(cm, pos);
	    return out;
	  }
	
	  function getText(completion) {
	    if (typeof completion == "string") return completion;else return completion.text;
	  }
	
	  function buildKeyMap(completion, handle) {
	    var baseMap = {
	      Up: function Up() {
	        handle.moveFocus(-1);
	      },
	      Down: function Down() {
	        handle.moveFocus(1);
	      },
	      PageUp: function PageUp() {
	        handle.moveFocus(-handle.menuSize() + 1, true);
	      },
	      PageDown: function PageDown() {
	        handle.moveFocus(handle.menuSize() - 1, true);
	      },
	      Home: function Home() {
	        handle.setFocus(0);
	      },
	      End: function End() {
	        handle.setFocus(handle.length - 1);
	      },
	      Enter: handle.pick,
	      Tab: handle.pick,
	      Esc: handle.close
	    };
	
	    var mac = /Mac/.test(navigator.platform);
	
	    if (mac) {
	      baseMap["Ctrl-P"] = function () {
	        handle.moveFocus(-1);
	      };
	      baseMap["Ctrl-N"] = function () {
	        handle.moveFocus(1);
	      };
	    }
	
	    var custom = completion.options.customKeys;
	    var ourMap = custom ? {} : baseMap;
	    function addBinding(key, val) {
	      var bound;
	      if (typeof val != "string") bound = function bound(cm) {
	        return val(cm, handle);
	      };
	      // This mechanism is deprecated
	      else if (baseMap.hasOwnProperty(val)) bound = baseMap[val];else bound = val;
	      ourMap[key] = bound;
	    }
	    if (custom) for (var key in custom) {
	      if (custom.hasOwnProperty(key)) addBinding(key, custom[key]);
	    }var extra = completion.options.extraKeys;
	    if (extra) for (var key in extra) {
	      if (extra.hasOwnProperty(key)) addBinding(key, extra[key]);
	    }return ourMap;
	  }
	
	  function getHintElement(hintsElement, el) {
	    while (el && el != hintsElement) {
	      if (el.nodeName.toUpperCase() === "LI" && el.parentNode == hintsElement) return el;
	      el = el.parentNode;
	    }
	  }
	
	  function Widget(completion, data) {
	    this.id = "cm-complete-" + Math.floor(Math.random(1e6));
	    this.completion = completion;
	    this.data = data;
	    this.picked = false;
	    var widget = this,
	        cm = completion.cm;
	    var ownerDocument = cm.getInputField().ownerDocument;
	    var parentWindow = ownerDocument.defaultView || ownerDocument.parentWindow;
	
	    var hints = this.hints = ownerDocument.createElement("ul");
	    hints.setAttribute("role", "listbox");
	    hints.setAttribute("aria-expanded", "true");
	    hints.id = this.id;
	    var theme = completion.cm.options.theme;
	    hints.className = "CodeMirror-hints " + theme;
	    this.selectedHint = data.selectedHint || 0;
	
	    var completions = data.list;
	    for (var i = 0; i < completions.length; ++i) {
	      var elt = hints.appendChild(ownerDocument.createElement("li")),
	          cur = completions[i];
	      var className = HINT_ELEMENT_CLASS + (i != this.selectedHint ? "" : " " + ACTIVE_HINT_ELEMENT_CLASS);
	      if (cur.className != null) className = cur.className + " " + className;
	      elt.className = className;
	      if (i == this.selectedHint) elt.setAttribute("aria-selected", "true");
	      elt.id = this.id + "-" + i;
	      elt.setAttribute("role", "option");
	      if (cur.render) cur.render(elt, data, cur);else elt.appendChild(ownerDocument.createTextNode(cur.displayText || getText(cur)));
	      elt.hintId = i;
	    }
	
	    var container = completion.options.container || ownerDocument.body;
	    var pos = cm.cursorCoords(completion.options.alignWithWord ? data.from : null);
	    var left = pos.left,
	        top = pos.bottom,
	        below = true;
	    var offsetLeft = 0,
	        offsetTop = 0;
	    if (container !== ownerDocument.body) {
	      // We offset the cursor position because left and top are relative to the offsetParent's top left corner.
	      var isContainerPositioned = ['absolute', 'relative', 'fixed'].indexOf(parentWindow.getComputedStyle(container).position) !== -1;
	      var offsetParent = isContainerPositioned ? container : container.offsetParent;
	      var offsetParentPosition = offsetParent.getBoundingClientRect();
	      var bodyPosition = ownerDocument.body.getBoundingClientRect();
	      offsetLeft = offsetParentPosition.left - bodyPosition.left - offsetParent.scrollLeft;
	      offsetTop = offsetParentPosition.top - bodyPosition.top - offsetParent.scrollTop;
	    }
	    hints.style.left = left - offsetLeft + "px";
	    hints.style.top = top - offsetTop + "px";
	
	    // If we're at the edge of the screen, then we want the menu to appear on the left of the cursor.
	    var winW = parentWindow.innerWidth || Math.max(ownerDocument.body.offsetWidth, ownerDocument.documentElement.offsetWidth);
	    var winH = parentWindow.innerHeight || Math.max(ownerDocument.body.offsetHeight, ownerDocument.documentElement.offsetHeight);
	    container.appendChild(hints);
	    cm.getInputField().setAttribute("aria-autocomplete", "list");
	    cm.getInputField().setAttribute("aria-owns", this.id);
	    cm.getInputField().setAttribute("aria-activedescendant", this.id + "-" + this.selectedHint);
	
	    var box = completion.options.moveOnOverlap ? hints.getBoundingClientRect() : new DOMRect();
	    var scrolls = completion.options.paddingForScrollbar ? hints.scrollHeight > hints.clientHeight + 1 : false;
	
	    // Compute in the timeout to avoid reflow on init
	    var startScroll;
	    setTimeout(function () {
	      startScroll = cm.getScrollInfo();
	    });
	
	    var overlapY = box.bottom - winH;
	    if (overlapY > 0) {
	      // Does not fit below
	      var height = box.bottom - box.top,
	          spaceAbove = box.top - (pos.bottom - pos.top) - 2;
	      if (winH - box.top < spaceAbove) {
	        // More room at the top
	        if (height > spaceAbove) hints.style.height = (height = spaceAbove) + "px";
	        hints.style.top = (top = pos.top - height) + offsetTop + "px";
	        below = false;
	      } else {
	        hints.style.height = winH - box.top - 2 + "px";
	      }
	    }
	    var overlapX = box.right - winW;
	    if (scrolls) overlapX += cm.display.nativeBarWidth;
	    if (overlapX > 0) {
	      if (box.right - box.left > winW) {
	        hints.style.width = winW - 5 + "px";
	        overlapX -= box.right - box.left - winW;
	      }
	      hints.style.left = (left = Math.max(pos.left - overlapX - offsetLeft, 0)) + "px";
	    }
	    if (scrolls) for (var node = hints.firstChild; node; node = node.nextSibling) {
	      node.style.paddingRight = cm.display.nativeBarWidth + "px";
	    }cm.addKeyMap(this.keyMap = buildKeyMap(completion, {
	      moveFocus: function moveFocus(n, avoidWrap) {
	        widget.changeActive(widget.selectedHint + n, avoidWrap);
	      },
	      setFocus: function setFocus(n) {
	        widget.changeActive(n);
	      },
	      menuSize: function menuSize() {
	        return widget.screenAmount();
	      },
	      length: completions.length,
	      close: function close() {
	        completion.close();
	      },
	      pick: function pick() {
	        widget.pick();
	      },
	      data: data
	    }));
	
	    if (completion.options.closeOnUnfocus) {
	      var closingOnBlur;
	      cm.on("blur", this.onBlur = function () {
	        closingOnBlur = setTimeout(function () {
	          completion.close();
	        }, 100);
	      });
	      cm.on("focus", this.onFocus = function () {
	        clearTimeout(closingOnBlur);
	      });
	    }
	
	    cm.on("scroll", this.onScroll = function () {
	      var curScroll = cm.getScrollInfo(),
	          editor = cm.getWrapperElement().getBoundingClientRect();
	      if (!startScroll) startScroll = cm.getScrollInfo();
	      var newTop = top + startScroll.top - curScroll.top;
	      var point = newTop - (parentWindow.pageYOffset || (ownerDocument.documentElement || ownerDocument.body).scrollTop);
	      if (!below) point += hints.offsetHeight;
	      if (point <= editor.top || point >= editor.bottom) return completion.close();
	      hints.style.top = newTop + "px";
	      hints.style.left = left + startScroll.left - curScroll.left + "px";
	    });
	
	    CodeMirror.on(hints, "dblclick", function (e) {
	      var t = getHintElement(hints, e.target || e.srcElement);
	      if (t && t.hintId != null) {
	        widget.changeActive(t.hintId);widget.pick();
	      }
	    });
	
	    CodeMirror.on(hints, "click", function (e) {
	      var t = getHintElement(hints, e.target || e.srcElement);
	      if (t && t.hintId != null) {
	        widget.changeActive(t.hintId);
	        if (completion.options.completeOnSingleClick) widget.pick();
	      }
	    });
	
	    CodeMirror.on(hints, "mousedown", function () {
	      setTimeout(function () {
	        cm.focus();
	      }, 20);
	    });
	
	    // The first hint doesn't need to be scrolled to on init
	    var selectedHintRange = this.getSelectedHintRange();
	    if (selectedHintRange.from !== 0 || selectedHintRange.to !== 0) {
	      this.scrollToActive();
	    }
	
	    CodeMirror.signal(data, "select", completions[this.selectedHint], hints.childNodes[this.selectedHint]);
	    return true;
	  }
	
	  Widget.prototype = {
	    close: function close() {
	      if (this.completion.widget != this) return;
	      this.completion.widget = null;
	      if (this.hints.parentNode) this.hints.parentNode.removeChild(this.hints);
	      this.completion.cm.removeKeyMap(this.keyMap);
	      var input = this.completion.cm.getInputField();
	      input.removeAttribute("aria-activedescendant");
	      input.removeAttribute("aria-owns");
	
	      var cm = this.completion.cm;
	      if (this.completion.options.closeOnUnfocus) {
	        cm.off("blur", this.onBlur);
	        cm.off("focus", this.onFocus);
	      }
	      cm.off("scroll", this.onScroll);
	    },
	
	    disable: function disable() {
	      this.completion.cm.removeKeyMap(this.keyMap);
	      var widget = this;
	      this.keyMap = { Enter: function Enter() {
	          widget.picked = true;
	        } };
	      this.completion.cm.addKeyMap(this.keyMap);
	    },
	
	    pick: function pick() {
	      this.completion.pick(this.data, this.selectedHint);
	    },
	
	    changeActive: function changeActive(i, avoidWrap) {
	      if (i >= this.data.list.length) i = avoidWrap ? this.data.list.length - 1 : 0;else if (i < 0) i = avoidWrap ? 0 : this.data.list.length - 1;
	      if (this.selectedHint == i) return;
	      var node = this.hints.childNodes[this.selectedHint];
	      if (node) {
	        node.className = node.className.replace(" " + ACTIVE_HINT_ELEMENT_CLASS, "");
	        node.removeAttribute("aria-selected");
	      }
	      node = this.hints.childNodes[this.selectedHint = i];
	      node.className += " " + ACTIVE_HINT_ELEMENT_CLASS;
	      node.setAttribute("aria-selected", "true");
	      this.completion.cm.getInputField().setAttribute("aria-activedescendant", node.id);
	      this.scrollToActive();
	      CodeMirror.signal(this.data, "select", this.data.list[this.selectedHint], node);
	    },
	
	    scrollToActive: function scrollToActive() {
	      var selectedHintRange = this.getSelectedHintRange();
	      var node1 = this.hints.childNodes[selectedHintRange.from];
	      var node2 = this.hints.childNodes[selectedHintRange.to];
	      var firstNode = this.hints.firstChild;
	      if (node1.offsetTop < this.hints.scrollTop) this.hints.scrollTop = node1.offsetTop - firstNode.offsetTop;else if (node2.offsetTop + node2.offsetHeight > this.hints.scrollTop + this.hints.clientHeight) this.hints.scrollTop = node2.offsetTop + node2.offsetHeight - this.hints.clientHeight + firstNode.offsetTop;
	    },
	
	    screenAmount: function screenAmount() {
	      return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1;
	    },
	
	    getSelectedHintRange: function getSelectedHintRange() {
	      var margin = this.completion.options.scrollMargin || 0;
	      return {
	        from: Math.max(0, this.selectedHint - margin),
	        to: Math.min(this.data.list.length - 1, this.selectedHint + margin)
	      };
	    }
	  };
	
	  function applicableHelpers(cm, helpers) {
	    if (!cm.somethingSelected()) return helpers;
	    var result = [];
	    for (var i = 0; i < helpers.length; i++) {
	      if (helpers[i].supportsSelection) result.push(helpers[i]);
	    }return result;
	  }
	
	  function fetchHints(hint, cm, options, callback) {
	    if (hint.async) {
	      hint(cm, callback, options);
	    } else {
	      var result = hint(cm, options);
	      if (result && result.then) result.then(callback);else callback(result);
	    }
	  }
	
	  function resolveAutoHints(cm, pos) {
	    var helpers = cm.getHelpers(pos, "hint"),
	        words;
	    if (helpers.length) {
	      var resolved = function resolved(cm, callback, options) {
	        var app = applicableHelpers(cm, helpers);
	        function run(i) {
	          if (i == app.length) return callback(null);
	          fetchHints(app[i], cm, options, function (result) {
	            if (result && result.list.length > 0) callback(result);else run(i + 1);
	          });
	        }
	        run(0);
	      };
	      resolved.async = true;
	      resolved.supportsSelection = true;
	      return resolved;
	    } else if (words = cm.getHelper(cm.getCursor(), "hintWords")) {
	      return function (cm) {
	        return CodeMirror.hint.fromList(cm, { words: words });
	      };
	    } else if (CodeMirror.hint.anyword) {
	      return function (cm, options) {
	        return CodeMirror.hint.anyword(cm, options);
	      };
	    } else {
	      return function () {};
	    }
	  }
	
	  CodeMirror.registerHelper("hint", "auto", {
	    resolve: resolveAutoHints
	  });
	
	  CodeMirror.registerHelper("hint", "fromList", function (cm, options) {
	    var cur = cm.getCursor(),
	        token = cm.getTokenAt(cur);
	    var term,
	        from = CodeMirror.Pos(cur.line, token.start),
	        to = cur;
	    if (token.start < cur.ch && /\w/.test(token.string.charAt(cur.ch - token.start - 1))) {
	      term = token.string.substr(0, cur.ch - token.start);
	    } else {
	      term = "";
	      from = cur;
	    }
	    var found = [];
	    for (var i = 0; i < options.words.length; i++) {
	      var word = options.words[i];
	      if (word.slice(0, term.length) == term) found.push(word);
	    }
	
	    if (found.length) return { list: found, from: from, to: to };
	  });
	
	  CodeMirror.commands.autocomplete = CodeMirror.showHint;
	
	  var defaultOptions = {
	    hint: CodeMirror.hint.auto,
	    completeSingle: true,
	    alignWithWord: true,
	    closeCharacters: /[\s()\[\]{};:>,]/,
	    closeOnPick: true,
	    closeOnUnfocus: true,
	    updateOnCursorActivity: true,
	    completeOnSingleClick: true,
	    container: null,
	    customKeys: null,
	    extraKeys: null,
	    paddingForScrollbar: true,
	    moveOnOverlap: true
	  };
	
	  CodeMirror.defineOption("hintOptions", null);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// Depends on jshint.js from https://github.com/jshint/jshint
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	  // declare global: JSHINT
	
	  function validator(text, options) {
	    if (!window.JSHINT) {
	      if (window.console) {
	        window.console.error("Error: window.JSHINT not defined, CodeMirror JavaScript linting cannot run.");
	      }
	      return [];
	    }
	    if (!options.indent) // JSHint error.character actually is a column index, this fixes underlining on lines using tabs for indentation
	      options.indent = 1; // JSHint default value is 4
	    JSHINT(text, options, options.globals);
	    var errors = JSHINT.data().errors,
	        result = [];
	    if (errors) parseErrors(errors, result);
	    return result;
	  }
	
	  CodeMirror.registerHelper("lint", "javascript", validator);
	
	  function parseErrors(errors, output) {
	    for (var i = 0; i < errors.length; i++) {
	      var error = errors[i];
	      if (error) {
	        if (error.line <= 0) {
	          if (window.console) {
	            window.console.warn("Cannot display JSHint error (invalid line " + error.line + ")", error);
	          }
	          continue;
	        }
	
	        var start = error.character - 1,
	            end = start + 1;
	        if (error.evidence) {
	          var index = error.evidence.substring(start).search(/.\b/);
	          if (index > -1) {
	            end += index;
	          }
	        }
	
	        // Convert to format expected by validation service
	        var hint = {
	          message: error.reason,
	          severity: error.code ? error.code.startsWith('W') ? "warning" : "error" : "error",
	          from: CodeMirror.Pos(error.line - 1, start),
	          to: CodeMirror.Pos(error.line - 1, end)
	        };
	
	        output.push(hint);
	      }
	    }
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var GUTTER_ID = "CodeMirror-lint-markers";
	  var LINT_LINE_ID = "CodeMirror-lint-line-";
	
	  function showTooltip(cm, e, content) {
	    var tt = document.createElement("div");
	    tt.className = "CodeMirror-lint-tooltip cm-s-" + cm.options.theme;
	    tt.appendChild(content.cloneNode(true));
	    if (cm.state.lint.options.selfContain) cm.getWrapperElement().appendChild(tt);else document.body.appendChild(tt);
	
	    function position(e) {
	      if (!tt.parentNode) return CodeMirror.off(document, "mousemove", position);
	      var top = Math.max(0, e.clientY - tt.offsetHeight - 5);
	      var left = Math.max(0, Math.min(e.clientX + 5, tt.ownerDocument.defaultView.innerWidth - tt.offsetWidth));
	      tt.style.top = top + "px";
	      tt.style.left = left + "px";
	    }
	    CodeMirror.on(document, "mousemove", position);
	    position(e);
	    if (tt.style.opacity != null) tt.style.opacity = 1;
	    return tt;
	  }
	  function rm(elt) {
	    if (elt.parentNode) elt.parentNode.removeChild(elt);
	  }
	  function hideTooltip(tt) {
	    if (!tt.parentNode) return;
	    if (tt.style.opacity == null) rm(tt);
	    tt.style.opacity = 0;
	    setTimeout(function () {
	      rm(tt);
	    }, 600);
	  }
	
	  function showTooltipFor(cm, e, content, node) {
	    var tooltip = showTooltip(cm, e, content);
	    function hide() {
	      CodeMirror.off(node, "mouseout", hide);
	      if (tooltip) {
	        hideTooltip(tooltip);tooltip = null;
	      }
	    }
	    var poll = setInterval(function () {
	      if (tooltip) for (var n = node;; n = n.parentNode) {
	        if (n && n.nodeType == 11) n = n.host;
	        if (n == document.body) return;
	        if (!n) {
	          hide();break;
	        }
	      }
	      if (!tooltip) return clearInterval(poll);
	    }, 400);
	    CodeMirror.on(node, "mouseout", hide);
	  }
	
	  function LintState(cm, conf, hasGutter) {
	    this.marked = [];
	    if (conf instanceof Function) conf = { getAnnotations: conf };
	    if (!conf || conf === true) conf = {};
	    this.options = {};
	    this.linterOptions = conf.options || {};
	    for (var prop in defaults) {
	      this.options[prop] = defaults[prop];
	    }for (var prop in conf) {
	      if (defaults.hasOwnProperty(prop)) {
	        if (conf[prop] != null) this.options[prop] = conf[prop];
	      } else if (!conf.options) {
	        this.linterOptions[prop] = conf[prop];
	      }
	    }
	    this.timeout = null;
	    this.hasGutter = hasGutter;
	    this.onMouseOver = function (e) {
	      onMouseOver(cm, e);
	    };
	    this.waitingFor = 0;
	  }
	
	  var defaults = {
	    highlightLines: false,
	    tooltips: true,
	    delay: 500,
	    lintOnChange: true,
	    getAnnotations: null,
	    async: false,
	    selfContain: null,
	    formatAnnotation: null,
	    onUpdateLinting: null
	  };
	
	  function clearMarks(cm) {
	    var state = cm.state.lint;
	    if (state.hasGutter) cm.clearGutter(GUTTER_ID);
	    if (state.options.highlightLines) clearErrorLines(cm);
	    for (var i = 0; i < state.marked.length; ++i) {
	      state.marked[i].clear();
	    }state.marked.length = 0;
	  }
	
	  function clearErrorLines(cm) {
	    cm.eachLine(function (line) {
	      var has = line.wrapClass && /\bCodeMirror-lint-line-\w+\b/.exec(line.wrapClass);
	      if (has) cm.removeLineClass(line, "wrap", has[0]);
	    });
	  }
	
	  function makeMarker(cm, labels, severity, multiple, tooltips) {
	    var marker = document.createElement("div"),
	        inner = marker;
	    marker.className = "CodeMirror-lint-marker CodeMirror-lint-marker-" + severity;
	    if (multiple) {
	      inner = marker.appendChild(document.createElement("div"));
	      inner.className = "CodeMirror-lint-marker CodeMirror-lint-marker-multiple";
	    }
	
	    if (tooltips != false) CodeMirror.on(inner, "mouseover", function (e) {
	      showTooltipFor(cm, e, labels, inner);
	    });
	
	    return marker;
	  }
	
	  function getMaxSeverity(a, b) {
	    if (a == "error") return a;else return b;
	  }
	
	  function groupByLine(annotations) {
	    var lines = [];
	    for (var i = 0; i < annotations.length; ++i) {
	      var ann = annotations[i],
	          line = ann.from.line;
	      (lines[line] || (lines[line] = [])).push(ann);
	    }
	    return lines;
	  }
	
	  function annotationTooltip(ann) {
	    var severity = ann.severity;
	    if (!severity) severity = "error";
	    var tip = document.createElement("div");
	    tip.className = "CodeMirror-lint-message CodeMirror-lint-message-" + severity;
	    if (typeof ann.messageHTML != 'undefined') {
	      tip.innerHTML = ann.messageHTML;
	    } else {
	      tip.appendChild(document.createTextNode(ann.message));
	    }
	    return tip;
	  }
	
	  function lintAsync(cm, getAnnotations) {
	    var state = cm.state.lint;
	    var id = ++state.waitingFor;
	    function abort() {
	      id = -1;
	      cm.off("change", abort);
	    }
	    cm.on("change", abort);
	    getAnnotations(cm.getValue(), function (annotations, arg2) {
	      cm.off("change", abort);
	      if (state.waitingFor != id) return;
	      if (arg2 && annotations instanceof CodeMirror) annotations = arg2;
	      cm.operation(function () {
	        updateLinting(cm, annotations);
	      });
	    }, state.linterOptions, cm);
	  }
	
	  function startLinting(cm) {
	    var state = cm.state.lint;
	    if (!state) return;
	    var options = state.options;
	    /*
	     * Passing rules in `options` property prevents JSHint (and other linters) from complaining
	     * about unrecognized rules like `onUpdateLinting`, `delay`, `lintOnChange`, etc.
	     */
	    var getAnnotations = options.getAnnotations || cm.getHelper(CodeMirror.Pos(0, 0), "lint");
	    if (!getAnnotations) return;
	    if (options.async || getAnnotations.async) {
	      lintAsync(cm, getAnnotations);
	    } else {
	      var annotations = getAnnotations(cm.getValue(), state.linterOptions, cm);
	      if (!annotations) return;
	      if (annotations.then) annotations.then(function (issues) {
	        cm.operation(function () {
	          updateLinting(cm, issues);
	        });
	      });else cm.operation(function () {
	        updateLinting(cm, annotations);
	      });
	    }
	  }
	
	  function updateLinting(cm, annotationsNotSorted) {
	    var state = cm.state.lint;
	    if (!state) return;
	    var options = state.options;
	    clearMarks(cm);
	
	    var annotations = groupByLine(annotationsNotSorted);
	
	    for (var line = 0; line < annotations.length; ++line) {
	      var anns = annotations[line];
	      if (!anns) continue;
	
	      var maxSeverity = null;
	      var tipLabel = state.hasGutter && document.createDocumentFragment();
	
	      for (var i = 0; i < anns.length; ++i) {
	        var ann = anns[i];
	        var severity = ann.severity;
	        if (!severity) severity = "error";
	        maxSeverity = getMaxSeverity(maxSeverity, severity);
	
	        if (options.formatAnnotation) ann = options.formatAnnotation(ann);
	        if (state.hasGutter) tipLabel.appendChild(annotationTooltip(ann));
	
	        if (ann.to) state.marked.push(cm.markText(ann.from, ann.to, {
	          className: "CodeMirror-lint-mark CodeMirror-lint-mark-" + severity,
	          __annotation: ann
	        }));
	      }
	      if (state.hasGutter) cm.setGutterMarker(line, GUTTER_ID, makeMarker(cm, tipLabel, maxSeverity, anns.length > 1, options.tooltips));
	
	      if (options.highlightLines) cm.addLineClass(line, "wrap", LINT_LINE_ID + maxSeverity);
	    }
	    if (options.onUpdateLinting) options.onUpdateLinting(annotationsNotSorted, annotations, cm);
	  }
	
	  function onChange(cm) {
	    var state = cm.state.lint;
	    if (!state) return;
	    clearTimeout(state.timeout);
	    state.timeout = setTimeout(function () {
	      startLinting(cm);
	    }, state.options.delay);
	  }
	
	  function popupTooltips(cm, annotations, e) {
	    var target = e.target || e.srcElement;
	    var tooltip = document.createDocumentFragment();
	    for (var i = 0; i < annotations.length; i++) {
	      var ann = annotations[i];
	      tooltip.appendChild(annotationTooltip(ann));
	    }
	    showTooltipFor(cm, e, tooltip, target);
	  }
	
	  function onMouseOver(cm, e) {
	    var target = e.target || e.srcElement;
	    if (!/\bCodeMirror-lint-mark-/.test(target.className)) return;
	    var box = target.getBoundingClientRect(),
	        x = (box.left + box.right) / 2,
	        y = (box.top + box.bottom) / 2;
	    var spans = cm.findMarksAt(cm.coordsChar({ left: x, top: y }, "client"));
	
	    var annotations = [];
	    for (var i = 0; i < spans.length; ++i) {
	      var ann = spans[i].__annotation;
	      if (ann) annotations.push(ann);
	    }
	    if (annotations.length) popupTooltips(cm, annotations, e);
	  }
	
	  CodeMirror.defineOption("lint", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      clearMarks(cm);
	      if (cm.state.lint.options.lintOnChange !== false) cm.off("change", onChange);
	      CodeMirror.off(cm.getWrapperElement(), "mouseover", cm.state.lint.onMouseOver);
	      clearTimeout(cm.state.lint.timeout);
	      delete cm.state.lint;
	    }
	
	    if (val) {
	      var gutters = cm.getOption("gutters"),
	          hasLintGutter = false;
	      for (var i = 0; i < gutters.length; ++i) {
	        if (gutters[i] == GUTTER_ID) hasLintGutter = true;
	      }var state = cm.state.lint = new LintState(cm, val, hasLintGutter);
	      if (state.options.lintOnChange) cm.on("change", onChange);
	      if (state.options.tooltips != false && state.options.tooltips != "gutter") CodeMirror.on(cm.getWrapperElement(), "mouseover", state.onMouseOver);
	
	      startLinting(cm);
	    }
	  });
	
	  CodeMirror.defineExtension("performLint", function () {
	    startLinting(this);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// Highlighting text that matches the selection
	//
	// Defines an option highlightSelectionMatches, which, when enabled,
	// will style strings that match the selection throughout the
	// document.
	//
	// The option can be set to true to simply enable it, or to a
	// {minChars, style, wordsOnly, showToken, delay} object to explicitly
	// configure it. minChars is the minimum amount of characters that should be
	// selected for the behavior to occur, and style is the token style to
	// apply to the matches. This will be prefixed by "cm-" to create an
	// actual CSS class name. If wordsOnly is enabled, the matches will be
	// highlighted only if the selected text is a word. showToken, when enabled,
	// will cause the current token to be highlighted when nothing is selected.
	// delay is used to specify how much time to wait, in milliseconds, before
	// highlighting the matches. If annotateScrollbar is enabled, the occurrences
	// will be highlighted on the scrollbar via the matchesonscrollbar addon.
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31), __webpack_require__(249));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(249)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var defaults = {
	    style: "matchhighlight",
	    minChars: 2,
	    delay: 100,
	    wordsOnly: false,
	    annotateScrollbar: false,
	    showToken: false,
	    trim: true
	  };
	
	  function State(options) {
	    this.options = {};
	    for (var name in defaults) {
	      this.options[name] = (options && options.hasOwnProperty(name) ? options : defaults)[name];
	    }this.overlay = this.timeout = null;
	    this.matchesonscroll = null;
	    this.active = false;
	  }
	
	  CodeMirror.defineOption("highlightSelectionMatches", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      removeOverlay(cm);
	      clearTimeout(cm.state.matchHighlighter.timeout);
	      cm.state.matchHighlighter = null;
	      cm.off("cursorActivity", cursorActivity);
	      cm.off("focus", onFocus);
	    }
	    if (val) {
	      var state = cm.state.matchHighlighter = new State(val);
	      if (cm.hasFocus()) {
	        state.active = true;
	        highlightMatches(cm);
	      } else {
	        cm.on("focus", onFocus);
	      }
	      cm.on("cursorActivity", cursorActivity);
	    }
	  });
	
	  function cursorActivity(cm) {
	    var state = cm.state.matchHighlighter;
	    if (state.active || cm.hasFocus()) scheduleHighlight(cm, state);
	  }
	
	  function onFocus(cm) {
	    var state = cm.state.matchHighlighter;
	    if (!state.active) {
	      state.active = true;
	      scheduleHighlight(cm, state);
	    }
	  }
	
	  function scheduleHighlight(cm, state) {
	    clearTimeout(state.timeout);
	    state.timeout = setTimeout(function () {
	      highlightMatches(cm);
	    }, state.options.delay);
	  }
	
	  function addOverlay(cm, query, hasBoundary, style) {
	    var state = cm.state.matchHighlighter;
	    cm.addOverlay(state.overlay = makeOverlay(query, hasBoundary, style));
	    if (state.options.annotateScrollbar && cm.showMatchesOnScrollbar) {
	      var searchFor = hasBoundary ? new RegExp((/\w/.test(query.charAt(0)) ? "\\b" : "") + query.replace(/[\\\[.+*?(){|^$]/g, "\\$&") + (/\w/.test(query.charAt(query.length - 1)) ? "\\b" : "")) : query;
	      state.matchesonscroll = cm.showMatchesOnScrollbar(searchFor, false, { className: "CodeMirror-selection-highlight-scrollbar" });
	    }
	  }
	
	  function removeOverlay(cm) {
	    var state = cm.state.matchHighlighter;
	    if (state.overlay) {
	      cm.removeOverlay(state.overlay);
	      state.overlay = null;
	      if (state.matchesonscroll) {
	        state.matchesonscroll.clear();
	        state.matchesonscroll = null;
	      }
	    }
	  }
	
	  function highlightMatches(cm) {
	    cm.operation(function () {
	      var state = cm.state.matchHighlighter;
	      removeOverlay(cm);
	      if (!cm.somethingSelected() && state.options.showToken) {
	        var re = state.options.showToken === true ? /[\w$]/ : state.options.showToken;
	        var cur = cm.getCursor(),
	            line = cm.getLine(cur.line),
	            start = cur.ch,
	            end = start;
	        while (start && re.test(line.charAt(start - 1))) {
	          --start;
	        }while (end < line.length && re.test(line.charAt(end))) {
	          ++end;
	        }if (start < end) addOverlay(cm, line.slice(start, end), re, state.options.style);
	        return;
	      }
	      var from = cm.getCursor("from"),
	          to = cm.getCursor("to");
	      if (from.line != to.line) return;
	      if (state.options.wordsOnly && !isWord(cm, from, to)) return;
	      var selection = cm.getRange(from, to);
	      if (state.options.trim) selection = selection.replace(/^\s+|\s+$/g, "");
	      if (selection.length >= state.options.minChars) addOverlay(cm, selection, false, state.options.style);
	    });
	  }
	
	  function isWord(cm, from, to) {
	    var str = cm.getRange(from, to);
	    if (str.match(/^\w+$/) !== null) {
	      if (from.ch > 0) {
	        var pos = { line: from.line, ch: from.ch - 1 };
	        var chr = cm.getRange(pos, from);
	        if (chr.match(/\W/) === null) return false;
	      }
	      if (to.ch < cm.getLine(from.line).length) {
	        var pos = { line: to.line, ch: to.ch + 1 };
	        var chr = cm.getRange(to, pos);
	        if (chr.match(/\W/) === null) return false;
	      }
	      return true;
	    } else return false;
	  }
	
	  function boundariesAround(stream, re) {
	    return (!stream.start || !re.test(stream.string.charAt(stream.start - 1))) && (stream.pos == stream.string.length || !re.test(stream.string.charAt(stream.pos)));
	  }
	
	  function makeOverlay(query, hasBoundary, style) {
	    return { token: function token(stream) {
	        if (stream.match(query) && (!hasBoundary || boundariesAround(stream, hasBoundary))) return style;
	        stream.next();
	        stream.skipTo(query.charAt(0)) || stream.skipToEnd();
	      } };
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// A rough approximation of Sublime Text's keybindings
	// Depends on addon/search/searchcursor.js and optionally addon/dialog/dialogs.js
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31), __webpack_require__(159), __webpack_require__(158));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31), __webpack_require__(159), __webpack_require__(158)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var cmds = CodeMirror.commands;
	  var Pos = CodeMirror.Pos;
	
	  // This is not exactly Sublime's algorithm. I couldn't make heads or tails of that.
	  function findPosSubword(doc, start, dir) {
	    if (dir < 0 && start.ch == 0) return doc.clipPos(Pos(start.line - 1));
	    var line = doc.getLine(start.line);
	    if (dir > 0 && start.ch >= line.length) return doc.clipPos(Pos(start.line + 1, 0));
	    var state = "start",
	        type,
	        startPos = start.ch;
	    for (var pos = startPos, e = dir < 0 ? 0 : line.length, i = 0; pos != e; pos += dir, i++) {
	      var next = line.charAt(dir < 0 ? pos - 1 : pos);
	      var cat = next != "_" && CodeMirror.isWordChar(next) ? "w" : "o";
	      if (cat == "w" && next.toUpperCase() == next) cat = "W";
	      if (state == "start") {
	        if (cat != "o") {
	          state = "in";type = cat;
	        } else startPos = pos + dir;
	      } else if (state == "in") {
	        if (type != cat) {
	          if (type == "w" && cat == "W" && dir < 0) pos--;
	          if (type == "W" && cat == "w" && dir > 0) {
	            // From uppercase to lowercase
	            if (pos == startPos + 1) {
	              type = "w";continue;
	            } else pos--;
	          }
	          break;
	        }
	      }
	    }
	    return Pos(start.line, pos);
	  }
	
	  function moveSubword(cm, dir) {
	    cm.extendSelectionsBy(function (range) {
	      if (cm.display.shift || cm.doc.extend || range.empty()) return findPosSubword(cm.doc, range.head, dir);else return dir < 0 ? range.from() : range.to();
	    });
	  }
	
	  cmds.goSubwordLeft = function (cm) {
	    moveSubword(cm, -1);
	  };
	  cmds.goSubwordRight = function (cm) {
	    moveSubword(cm, 1);
	  };
	
	  cmds.scrollLineUp = function (cm) {
	    var info = cm.getScrollInfo();
	    if (!cm.somethingSelected()) {
	      var visibleBottomLine = cm.lineAtHeight(info.top + info.clientHeight, "local");
	      if (cm.getCursor().line >= visibleBottomLine) cm.execCommand("goLineUp");
	    }
	    cm.scrollTo(null, info.top - cm.defaultTextHeight());
	  };
	  cmds.scrollLineDown = function (cm) {
	    var info = cm.getScrollInfo();
	    if (!cm.somethingSelected()) {
	      var visibleTopLine = cm.lineAtHeight(info.top, "local") + 1;
	      if (cm.getCursor().line <= visibleTopLine) cm.execCommand("goLineDown");
	    }
	    cm.scrollTo(null, info.top + cm.defaultTextHeight());
	  };
	
	  cmds.splitSelectionByLine = function (cm) {
	    var ranges = cm.listSelections(),
	        lineRanges = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var from = ranges[i].from(),
	          to = ranges[i].to();
	      for (var line = from.line; line <= to.line; ++line) {
	        if (!(to.line > from.line && line == to.line && to.ch == 0)) lineRanges.push({ anchor: line == from.line ? from : Pos(line, 0),
	          head: line == to.line ? to : Pos(line) });
	      }
	    }
	    cm.setSelections(lineRanges, 0);
	  };
	
	  cmds.singleSelectionTop = function (cm) {
	    var range = cm.listSelections()[0];
	    cm.setSelection(range.anchor, range.head, { scroll: false });
	  };
	
	  cmds.selectLine = function (cm) {
	    var ranges = cm.listSelections(),
	        extended = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      extended.push({ anchor: Pos(range.from().line, 0),
	        head: Pos(range.to().line + 1, 0) });
	    }
	    cm.setSelections(extended);
	  };
	
	  function insertLine(cm, above) {
	    if (cm.isReadOnly()) return CodeMirror.Pass;
	    cm.operation(function () {
	      var len = cm.listSelections().length,
	          newSelection = [],
	          last = -1;
	      for (var i = 0; i < len; i++) {
	        var head = cm.listSelections()[i].head;
	        if (head.line <= last) continue;
	        var at = Pos(head.line + (above ? 0 : 1), 0);
	        cm.replaceRange("\n", at, null, "+insertLine");
	        cm.indentLine(at.line, null, true);
	        newSelection.push({ head: at, anchor: at });
	        last = head.line + 1;
	      }
	      cm.setSelections(newSelection);
	    });
	    cm.execCommand("indentAuto");
	  }
	
	  cmds.insertLineAfter = function (cm) {
	    return insertLine(cm, false);
	  };
	
	  cmds.insertLineBefore = function (cm) {
	    return insertLine(cm, true);
	  };
	
	  function wordAt(cm, pos) {
	    var start = pos.ch,
	        end = start,
	        line = cm.getLine(pos.line);
	    while (start && CodeMirror.isWordChar(line.charAt(start - 1))) {
	      --start;
	    }while (end < line.length && CodeMirror.isWordChar(line.charAt(end))) {
	      ++end;
	    }return { from: Pos(pos.line, start), to: Pos(pos.line, end), word: line.slice(start, end) };
	  }
	
	  cmds.selectNextOccurrence = function (cm) {
	    var from = cm.getCursor("from"),
	        to = cm.getCursor("to");
	    var fullWord = cm.state.sublimeFindFullWord == cm.doc.sel;
	    if (CodeMirror.cmpPos(from, to) == 0) {
	      var word = wordAt(cm, from);
	      if (!word.word) return;
	      cm.setSelection(word.from, word.to);
	      fullWord = true;
	    } else {
	      var text = cm.getRange(from, to);
	      var query = fullWord ? new RegExp("\\b" + text + "\\b") : text;
	      var cur = cm.getSearchCursor(query, to);
	      var found = cur.findNext();
	      if (!found) {
	        cur = cm.getSearchCursor(query, Pos(cm.firstLine(), 0));
	        found = cur.findNext();
	      }
	      if (!found || isSelectedRange(cm.listSelections(), cur.from(), cur.to())) return;
	      cm.addSelection(cur.from(), cur.to());
	    }
	    if (fullWord) cm.state.sublimeFindFullWord = cm.doc.sel;
	  };
	
	  cmds.skipAndSelectNextOccurrence = function (cm) {
	    var prevAnchor = cm.getCursor("anchor"),
	        prevHead = cm.getCursor("head");
	    cmds.selectNextOccurrence(cm);
	    if (CodeMirror.cmpPos(prevAnchor, prevHead) != 0) {
	      cm.doc.setSelections(cm.doc.listSelections().filter(function (sel) {
	        return sel.anchor != prevAnchor || sel.head != prevHead;
	      }));
	    }
	  };
	
	  function addCursorToSelection(cm, dir) {
	    var ranges = cm.listSelections(),
	        newRanges = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      var newAnchor = cm.findPosV(range.anchor, dir, "line", range.anchor.goalColumn);
	      var newHead = cm.findPosV(range.head, dir, "line", range.head.goalColumn);
	      newAnchor.goalColumn = range.anchor.goalColumn != null ? range.anchor.goalColumn : cm.cursorCoords(range.anchor, "div").left;
	      newHead.goalColumn = range.head.goalColumn != null ? range.head.goalColumn : cm.cursorCoords(range.head, "div").left;
	      var newRange = { anchor: newAnchor, head: newHead };
	      newRanges.push(range);
	      newRanges.push(newRange);
	    }
	    cm.setSelections(newRanges);
	  }
	  cmds.addCursorToPrevLine = function (cm) {
	    addCursorToSelection(cm, -1);
	  };
	  cmds.addCursorToNextLine = function (cm) {
	    addCursorToSelection(cm, 1);
	  };
	
	  function isSelectedRange(ranges, from, to) {
	    for (var i = 0; i < ranges.length; i++) {
	      if (CodeMirror.cmpPos(ranges[i].from(), from) == 0 && CodeMirror.cmpPos(ranges[i].to(), to) == 0) return true;
	    }return false;
	  }
	
	  var mirror = "(){}[]";
	  function selectBetweenBrackets(cm) {
	    var ranges = cm.listSelections(),
	        newRanges = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i],
	          pos = range.head,
	          opening = cm.scanForBracket(pos, -1);
	      if (!opening) return false;
	      for (;;) {
	        var closing = cm.scanForBracket(pos, 1);
	        if (!closing) return false;
	        if (closing.ch == mirror.charAt(mirror.indexOf(opening.ch) + 1)) {
	          var startPos = Pos(opening.pos.line, opening.pos.ch + 1);
	          if (CodeMirror.cmpPos(startPos, range.from()) == 0 && CodeMirror.cmpPos(closing.pos, range.to()) == 0) {
	            opening = cm.scanForBracket(opening.pos, -1);
	            if (!opening) return false;
	          } else {
	            newRanges.push({ anchor: startPos, head: closing.pos });
	            break;
	          }
	        }
	        pos = Pos(closing.pos.line, closing.pos.ch + 1);
	      }
	    }
	    cm.setSelections(newRanges);
	    return true;
	  }
	
	  cmds.selectScope = function (cm) {
	    selectBetweenBrackets(cm) || cm.execCommand("selectAll");
	  };
	  cmds.selectBetweenBrackets = function (cm) {
	    if (!selectBetweenBrackets(cm)) return CodeMirror.Pass;
	  };
	
	  function puncType(type) {
	    return !type ? null : /\bpunctuation\b/.test(type) ? type : undefined;
	  }
	
	  cmds.goToBracket = function (cm) {
	    cm.extendSelectionsBy(function (range) {
	      var next = cm.scanForBracket(range.head, 1, puncType(cm.getTokenTypeAt(range.head)));
	      if (next && CodeMirror.cmpPos(next.pos, range.head) != 0) return next.pos;
	      var prev = cm.scanForBracket(range.head, -1, puncType(cm.getTokenTypeAt(Pos(range.head.line, range.head.ch + 1))));
	      return prev && Pos(prev.pos.line, prev.pos.ch + 1) || range.head;
	    });
	  };
	
	  cmds.swapLineUp = function (cm) {
	    if (cm.isReadOnly()) return CodeMirror.Pass;
	    var ranges = cm.listSelections(),
	        linesToMove = [],
	        at = cm.firstLine() - 1,
	        newSels = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i],
	          from = range.from().line - 1,
	          to = range.to().line;
	      newSels.push({ anchor: Pos(range.anchor.line - 1, range.anchor.ch),
	        head: Pos(range.head.line - 1, range.head.ch) });
	      if (range.to().ch == 0 && !range.empty()) --to;
	      if (from > at) linesToMove.push(from, to);else if (linesToMove.length) linesToMove[linesToMove.length - 1] = to;
	      at = to;
	    }
	    cm.operation(function () {
	      for (var i = 0; i < linesToMove.length; i += 2) {
	        var from = linesToMove[i],
	            to = linesToMove[i + 1];
	        var line = cm.getLine(from);
	        cm.replaceRange("", Pos(from, 0), Pos(from + 1, 0), "+swapLine");
	        if (to > cm.lastLine()) cm.replaceRange("\n" + line, Pos(cm.lastLine()), null, "+swapLine");else cm.replaceRange(line + "\n", Pos(to, 0), null, "+swapLine");
	      }
	      cm.setSelections(newSels);
	      cm.scrollIntoView();
	    });
	  };
	
	  cmds.swapLineDown = function (cm) {
	    if (cm.isReadOnly()) return CodeMirror.Pass;
	    var ranges = cm.listSelections(),
	        linesToMove = [],
	        at = cm.lastLine() + 1;
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var range = ranges[i],
	          from = range.to().line + 1,
	          to = range.from().line;
	      if (range.to().ch == 0 && !range.empty()) from--;
	      if (from < at) linesToMove.push(from, to);else if (linesToMove.length) linesToMove[linesToMove.length - 1] = to;
	      at = to;
	    }
	    cm.operation(function () {
	      for (var i = linesToMove.length - 2; i >= 0; i -= 2) {
	        var from = linesToMove[i],
	            to = linesToMove[i + 1];
	        var line = cm.getLine(from);
	        if (from == cm.lastLine()) cm.replaceRange("", Pos(from - 1), Pos(from), "+swapLine");else cm.replaceRange("", Pos(from, 0), Pos(from + 1, 0), "+swapLine");
	        cm.replaceRange(line + "\n", Pos(to, 0), null, "+swapLine");
	      }
	      cm.scrollIntoView();
	    });
	  };
	
	  cmds.toggleCommentIndented = function (cm) {
	    cm.toggleComment({ indent: true });
	  };
	
	  cmds.joinLines = function (cm) {
	    var ranges = cm.listSelections(),
	        joined = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i],
	          from = range.from();
	      var start = from.line,
	          end = range.to().line;
	      while (i < ranges.length - 1 && ranges[i + 1].from().line == end) {
	        end = ranges[++i].to().line;
	      }joined.push({ start: start, end: end, anchor: !range.empty() && from });
	    }
	    cm.operation(function () {
	      var offset = 0,
	          ranges = [];
	      for (var i = 0; i < joined.length; i++) {
	        var obj = joined[i];
	        var anchor = obj.anchor && Pos(obj.anchor.line - offset, obj.anchor.ch),
	            head;
	        for (var line = obj.start; line <= obj.end; line++) {
	          var actual = line - offset;
	          if (line == obj.end) head = Pos(actual, cm.getLine(actual).length + 1);
	          if (actual < cm.lastLine()) {
	            cm.replaceRange(" ", Pos(actual), Pos(actual + 1, /^\s*/.exec(cm.getLine(actual + 1))[0].length));
	            ++offset;
	          }
	        }
	        ranges.push({ anchor: anchor || head, head: head });
	      }
	      cm.setSelections(ranges, 0);
	    });
	  };
	
	  cmds.duplicateLine = function (cm) {
	    cm.operation(function () {
	      var rangeCount = cm.listSelections().length;
	      for (var i = 0; i < rangeCount; i++) {
	        var range = cm.listSelections()[i];
	        if (range.empty()) cm.replaceRange(cm.getLine(range.head.line) + "\n", Pos(range.head.line, 0));else cm.replaceRange(cm.getRange(range.from(), range.to()), range.from());
	      }
	      cm.scrollIntoView();
	    });
	  };
	
	  function sortLines(cm, caseSensitive, direction) {
	    if (cm.isReadOnly()) return CodeMirror.Pass;
	    var ranges = cm.listSelections(),
	        toSort = [],
	        selected;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      if (range.empty()) continue;
	      var from = range.from().line,
	          to = range.to().line;
	      while (i < ranges.length - 1 && ranges[i + 1].from().line == to) {
	        to = ranges[++i].to().line;
	      }if (!ranges[i].to().ch) to--;
	      toSort.push(from, to);
	    }
	    if (toSort.length) selected = true;else toSort.push(cm.firstLine(), cm.lastLine());
	
	    cm.operation(function () {
	      var ranges = [];
	      for (var i = 0; i < toSort.length; i += 2) {
	        var from = toSort[i],
	            to = toSort[i + 1];
	        var start = Pos(from, 0),
	            end = Pos(to);
	        var lines = cm.getRange(start, end, false);
	        if (caseSensitive) lines.sort(function (a, b) {
	          return a < b ? -direction : a == b ? 0 : direction;
	        });else lines.sort(function (a, b) {
	          var au = a.toUpperCase(),
	              bu = b.toUpperCase();
	          if (au != bu) {
	            a = au;b = bu;
	          }
	          return a < b ? -direction : a == b ? 0 : direction;
	        });
	        cm.replaceRange(lines, start, end);
	        if (selected) ranges.push({ anchor: start, head: Pos(to + 1, 0) });
	      }
	      if (selected) cm.setSelections(ranges, 0);
	    });
	  }
	
	  cmds.sortLines = function (cm) {
	    sortLines(cm, true, 1);
	  };
	  cmds.reverseSortLines = function (cm) {
	    sortLines(cm, true, -1);
	  };
	  cmds.sortLinesInsensitive = function (cm) {
	    sortLines(cm, false, 1);
	  };
	  cmds.reverseSortLinesInsensitive = function (cm) {
	    sortLines(cm, false, -1);
	  };
	
	  cmds.nextBookmark = function (cm) {
	    var marks = cm.state.sublimeBookmarks;
	    if (marks) while (marks.length) {
	      var current = marks.shift();
	      var found = current.find();
	      if (found) {
	        marks.push(current);
	        return cm.setSelection(found.from, found.to);
	      }
	    }
	  };
	
	  cmds.prevBookmark = function (cm) {
	    var marks = cm.state.sublimeBookmarks;
	    if (marks) while (marks.length) {
	      marks.unshift(marks.pop());
	      var found = marks[marks.length - 1].find();
	      if (!found) marks.pop();else return cm.setSelection(found.from, found.to);
	    }
	  };
	
	  cmds.toggleBookmark = function (cm) {
	    var ranges = cm.listSelections();
	    var marks = cm.state.sublimeBookmarks || (cm.state.sublimeBookmarks = []);
	    for (var i = 0; i < ranges.length; i++) {
	      var from = ranges[i].from(),
	          to = ranges[i].to();
	      var found = ranges[i].empty() ? cm.findMarksAt(from) : cm.findMarks(from, to);
	      for (var j = 0; j < found.length; j++) {
	        if (found[j].sublimeBookmark) {
	          found[j].clear();
	          for (var k = 0; k < marks.length; k++) {
	            if (marks[k] == found[j]) marks.splice(k--, 1);
	          }break;
	        }
	      }
	      if (j == found.length) marks.push(cm.markText(from, to, { sublimeBookmark: true, clearWhenEmpty: false }));
	    }
	  };
	
	  cmds.clearBookmarks = function (cm) {
	    var marks = cm.state.sublimeBookmarks;
	    if (marks) for (var i = 0; i < marks.length; i++) {
	      marks[i].clear();
	    }marks.length = 0;
	  };
	
	  cmds.selectBookmarks = function (cm) {
	    var marks = cm.state.sublimeBookmarks,
	        ranges = [];
	    if (marks) for (var i = 0; i < marks.length; i++) {
	      var found = marks[i].find();
	      if (!found) marks.splice(i--, 0);else ranges.push({ anchor: found.from, head: found.to });
	    }
	    if (ranges.length) cm.setSelections(ranges, 0);
	  };
	
	  function modifyWordOrSelection(cm, mod) {
	    cm.operation(function () {
	      var ranges = cm.listSelections(),
	          indices = [],
	          replacements = [];
	      for (var i = 0; i < ranges.length; i++) {
	        var range = ranges[i];
	        if (range.empty()) {
	          indices.push(i);replacements.push("");
	        } else replacements.push(mod(cm.getRange(range.from(), range.to())));
	      }
	      cm.replaceSelections(replacements, "around", "case");
	      for (var i = indices.length - 1, at; i >= 0; i--) {
	        var range = ranges[indices[i]];
	        if (at && CodeMirror.cmpPos(range.head, at) > 0) continue;
	        var word = wordAt(cm, range.head);
	        at = word.from;
	        cm.replaceRange(mod(word.word), word.from, word.to);
	      }
	    });
	  }
	
	  cmds.smartBackspace = function (cm) {
	    if (cm.somethingSelected()) return CodeMirror.Pass;
	
	    cm.operation(function () {
	      var cursors = cm.listSelections();
	      var indentUnit = cm.getOption("indentUnit");
	
	      for (var i = cursors.length - 1; i >= 0; i--) {
	        var cursor = cursors[i].head;
	        var toStartOfLine = cm.getRange({ line: cursor.line, ch: 0 }, cursor);
	        var column = CodeMirror.countColumn(toStartOfLine, null, cm.getOption("tabSize"));
	
	        // Delete by one character by default
	        var deletePos = cm.findPosH(cursor, -1, "char", false);
	
	        if (toStartOfLine && !/\S/.test(toStartOfLine) && column % indentUnit == 0) {
	          var prevIndent = new Pos(cursor.line, CodeMirror.findColumn(toStartOfLine, column - indentUnit, indentUnit));
	
	          // Smart delete only if we found a valid prevIndent location
	          if (prevIndent.ch != cursor.ch) deletePos = prevIndent;
	        }
	
	        cm.replaceRange("", deletePos, cursor, "+delete");
	      }
	    });
	  };
	
	  cmds.delLineRight = function (cm) {
	    cm.operation(function () {
	      var ranges = cm.listSelections();
	      for (var i = ranges.length - 1; i >= 0; i--) {
	        cm.replaceRange("", ranges[i].anchor, Pos(ranges[i].to().line), "+delete");
	      }cm.scrollIntoView();
	    });
	  };
	
	  cmds.upcaseAtCursor = function (cm) {
	    modifyWordOrSelection(cm, function (str) {
	      return str.toUpperCase();
	    });
	  };
	  cmds.downcaseAtCursor = function (cm) {
	    modifyWordOrSelection(cm, function (str) {
	      return str.toLowerCase();
	    });
	  };
	
	  cmds.setSublimeMark = function (cm) {
	    if (cm.state.sublimeMark) cm.state.sublimeMark.clear();
	    cm.state.sublimeMark = cm.setBookmark(cm.getCursor());
	  };
	  cmds.selectToSublimeMark = function (cm) {
	    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
	    if (found) cm.setSelection(cm.getCursor(), found);
	  };
	  cmds.deleteToSublimeMark = function (cm) {
	    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
	    if (found) {
	      var from = cm.getCursor(),
	          to = found;
	      if (CodeMirror.cmpPos(from, to) > 0) {
	        var tmp = to;to = from;from = tmp;
	      }
	      cm.state.sublimeKilled = cm.getRange(from, to);
	      cm.replaceRange("", from, to);
	    }
	  };
	  cmds.swapWithSublimeMark = function (cm) {
	    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
	    if (found) {
	      cm.state.sublimeMark.clear();
	      cm.state.sublimeMark = cm.setBookmark(cm.getCursor());
	      cm.setCursor(found);
	    }
	  };
	  cmds.sublimeYank = function (cm) {
	    if (cm.state.sublimeKilled != null) cm.replaceSelection(cm.state.sublimeKilled, null, "paste");
	  };
	
	  cmds.showInCenter = function (cm) {
	    var pos = cm.cursorCoords(null, "local");
	    cm.scrollTo(null, (pos.top + pos.bottom) / 2 - cm.getScrollInfo().clientHeight / 2);
	  };
	
	  function getTarget(cm) {
	    var from = cm.getCursor("from"),
	        to = cm.getCursor("to");
	    if (CodeMirror.cmpPos(from, to) == 0) {
	      var word = wordAt(cm, from);
	      if (!word.word) return;
	      from = word.from;
	      to = word.to;
	    }
	    return { from: from, to: to, query: cm.getRange(from, to), word: word };
	  }
	
	  function findAndGoTo(cm, forward) {
	    var target = getTarget(cm);
	    if (!target) return;
	    var query = target.query;
	    var cur = cm.getSearchCursor(query, forward ? target.to : target.from);
	
	    if (forward ? cur.findNext() : cur.findPrevious()) {
	      cm.setSelection(cur.from(), cur.to());
	    } else {
	      cur = cm.getSearchCursor(query, forward ? Pos(cm.firstLine(), 0) : cm.clipPos(Pos(cm.lastLine())));
	      if (forward ? cur.findNext() : cur.findPrevious()) cm.setSelection(cur.from(), cur.to());else if (target.word) cm.setSelection(target.from, target.to);
	    }
	  };
	  cmds.findUnder = function (cm) {
	    findAndGoTo(cm, true);
	  };
	  cmds.findUnderPrevious = function (cm) {
	    findAndGoTo(cm, false);
	  };
	  cmds.findAllUnder = function (cm) {
	    var target = getTarget(cm);
	    if (!target) return;
	    var cur = cm.getSearchCursor(target.query);
	    var matches = [];
	    var primaryIndex = -1;
	    while (cur.findNext()) {
	      matches.push({ anchor: cur.from(), head: cur.to() });
	      if (cur.from().line <= target.from.line && cur.from().ch <= target.from.ch) primaryIndex++;
	    }
	    cm.setSelections(matches, primaryIndex);
	  };
	
	  var keyMap = CodeMirror.keyMap;
	  keyMap.macSublime = {
	    "Cmd-Left": "goLineStartSmart",
	    "Shift-Tab": "indentLess",
	    "Shift-Ctrl-K": "deleteLine",
	    "Alt-Q": "wrapLines",
	    "Ctrl-Left": "goSubwordLeft",
	    "Ctrl-Right": "goSubwordRight",
	    "Ctrl-Alt-Up": "scrollLineUp",
	    "Ctrl-Alt-Down": "scrollLineDown",
	    "Cmd-L": "selectLine",
	    "Shift-Cmd-L": "splitSelectionByLine",
	    "Esc": "singleSelectionTop",
	    "Cmd-Enter": "insertLineAfter",
	    "Shift-Cmd-Enter": "insertLineBefore",
	    "Cmd-D": "selectNextOccurrence",
	    "Shift-Cmd-Space": "selectScope",
	    "Shift-Cmd-M": "selectBetweenBrackets",
	    "Cmd-M": "goToBracket",
	    "Cmd-Ctrl-Up": "swapLineUp",
	    "Cmd-Ctrl-Down": "swapLineDown",
	    "Cmd-/": "toggleCommentIndented",
	    "Cmd-J": "joinLines",
	    "Shift-Cmd-D": "duplicateLine",
	    "F5": "sortLines",
	    "Shift-F5": "reverseSortLines",
	    "Cmd-F5": "sortLinesInsensitive",
	    "Shift-Cmd-F5": "reverseSortLinesInsensitive",
	    "F2": "nextBookmark",
	    "Shift-F2": "prevBookmark",
	    "Cmd-F2": "toggleBookmark",
	    "Shift-Cmd-F2": "clearBookmarks",
	    "Alt-F2": "selectBookmarks",
	    "Backspace": "smartBackspace",
	    "Cmd-K Cmd-D": "skipAndSelectNextOccurrence",
	    "Cmd-K Cmd-K": "delLineRight",
	    "Cmd-K Cmd-U": "upcaseAtCursor",
	    "Cmd-K Cmd-L": "downcaseAtCursor",
	    "Cmd-K Cmd-Space": "setSublimeMark",
	    "Cmd-K Cmd-A": "selectToSublimeMark",
	    "Cmd-K Cmd-W": "deleteToSublimeMark",
	    "Cmd-K Cmd-X": "swapWithSublimeMark",
	    "Cmd-K Cmd-Y": "sublimeYank",
	    "Cmd-K Cmd-C": "showInCenter",
	    "Cmd-K Cmd-G": "clearBookmarks",
	    "Cmd-K Cmd-Backspace": "delLineLeft",
	    "Cmd-K Cmd-1": "foldAll",
	    "Cmd-K Cmd-0": "unfoldAll",
	    "Cmd-K Cmd-J": "unfoldAll",
	    "Ctrl-Shift-Up": "addCursorToPrevLine",
	    "Ctrl-Shift-Down": "addCursorToNextLine",
	    "Cmd-F3": "findUnder",
	    "Shift-Cmd-F3": "findUnderPrevious",
	    "Alt-F3": "findAllUnder",
	    "Shift-Cmd-[": "fold",
	    "Shift-Cmd-]": "unfold",
	    "Cmd-I": "findIncremental",
	    "Shift-Cmd-I": "findIncrementalReverse",
	    "Cmd-H": "replace",
	    "F3": "findNext",
	    "Shift-F3": "findPrev",
	    "fallthrough": "macDefault"
	  };
	  CodeMirror.normalizeKeyMap(keyMap.macSublime);
	
	  keyMap.pcSublime = {
	    "Shift-Tab": "indentLess",
	    "Shift-Ctrl-K": "deleteLine",
	    "Alt-Q": "wrapLines",
	    "Ctrl-T": "transposeChars",
	    "Alt-Left": "goSubwordLeft",
	    "Alt-Right": "goSubwordRight",
	    "Ctrl-Up": "scrollLineUp",
	    "Ctrl-Down": "scrollLineDown",
	    "Ctrl-L": "selectLine",
	    "Shift-Ctrl-L": "splitSelectionByLine",
	    "Esc": "singleSelectionTop",
	    "Ctrl-Enter": "insertLineAfter",
	    "Shift-Ctrl-Enter": "insertLineBefore",
	    "Ctrl-D": "selectNextOccurrence",
	    "Shift-Ctrl-Space": "selectScope",
	    "Shift-Ctrl-M": "selectBetweenBrackets",
	    "Ctrl-M": "goToBracket",
	    "Shift-Ctrl-Up": "swapLineUp",
	    "Shift-Ctrl-Down": "swapLineDown",
	    "Ctrl-/": "toggleCommentIndented",
	    "Ctrl-J": "joinLines",
	    "Shift-Ctrl-D": "duplicateLine",
	    "F9": "sortLines",
	    "Shift-F9": "reverseSortLines",
	    "Ctrl-F9": "sortLinesInsensitive",
	    "Shift-Ctrl-F9": "reverseSortLinesInsensitive",
	    "F2": "nextBookmark",
	    "Shift-F2": "prevBookmark",
	    "Ctrl-F2": "toggleBookmark",
	    "Shift-Ctrl-F2": "clearBookmarks",
	    "Alt-F2": "selectBookmarks",
	    "Backspace": "smartBackspace",
	    "Ctrl-K Ctrl-D": "skipAndSelectNextOccurrence",
	    "Ctrl-K Ctrl-K": "delLineRight",
	    "Ctrl-K Ctrl-U": "upcaseAtCursor",
	    "Ctrl-K Ctrl-L": "downcaseAtCursor",
	    "Ctrl-K Ctrl-Space": "setSublimeMark",
	    "Ctrl-K Ctrl-A": "selectToSublimeMark",
	    "Ctrl-K Ctrl-W": "deleteToSublimeMark",
	    "Ctrl-K Ctrl-X": "swapWithSublimeMark",
	    "Ctrl-K Ctrl-Y": "sublimeYank",
	    "Ctrl-K Ctrl-C": "showInCenter",
	    "Ctrl-K Ctrl-G": "clearBookmarks",
	    "Ctrl-K Ctrl-Backspace": "delLineLeft",
	    "Ctrl-K Ctrl-1": "foldAll",
	    "Ctrl-K Ctrl-0": "unfoldAll",
	    "Ctrl-K Ctrl-J": "unfoldAll",
	    "Ctrl-Alt-Up": "addCursorToPrevLine",
	    "Ctrl-Alt-Down": "addCursorToNextLine",
	    "Ctrl-F3": "findUnder",
	    "Shift-Ctrl-F3": "findUnderPrevious",
	    "Alt-F3": "findAllUnder",
	    "Shift-Ctrl-[": "fold",
	    "Shift-Ctrl-]": "unfold",
	    "Ctrl-I": "findIncremental",
	    "Shift-Ctrl-I": "findIncrementalReverse",
	    "Ctrl-H": "replace",
	    "F3": "findNext",
	    "Shift-F3": "findPrev",
	    "fallthrough": "pcDefault"
	  };
	  CodeMirror.normalizeKeyMap(keyMap.pcSublime);
	
	  var mac = keyMap.default == keyMap.macDefault;
	  keyMap.sublime = mac ? keyMap.macSublime : keyMap.pcSublime;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("css", function (config, parserConfig) {
	    var inline = parserConfig.inline;
	    if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
	
	    var indentUnit = config.indentUnit,
	        tokenHooks = parserConfig.tokenHooks,
	        documentTypes = parserConfig.documentTypes || {},
	        mediaTypes = parserConfig.mediaTypes || {},
	        mediaFeatures = parserConfig.mediaFeatures || {},
	        mediaValueKeywords = parserConfig.mediaValueKeywords || {},
	        propertyKeywords = parserConfig.propertyKeywords || {},
	        nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
	        fontProperties = parserConfig.fontProperties || {},
	        counterDescriptors = parserConfig.counterDescriptors || {},
	        colorKeywords = parserConfig.colorKeywords || {},
	        valueKeywords = parserConfig.valueKeywords || {},
	        allowNested = parserConfig.allowNested,
	        lineComment = parserConfig.lineComment,
	        supportsAtComponent = parserConfig.supportsAtComponent === true,
	        highlightNonStandardPropertyKeywords = config.highlightNonStandardPropertyKeywords !== false;
	
	    var type, override;
	    function ret(style, tp) {
	      type = tp;return style;
	    }
	
	    // Tokenizers
	
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	      if (tokenHooks[ch]) {
	        var result = tokenHooks[ch](stream, state);
	        if (result !== false) return result;
	      }
	      if (ch == "@") {
	        stream.eatWhile(/[\w\\\-]/);
	        return ret("def", stream.current());
	      } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
	        return ret(null, "compare");
	      } else if (ch == "\"" || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      } else if (ch == "#") {
	        stream.eatWhile(/[\w\\\-]/);
	        return ret("atom", "hash");
	      } else if (ch == "!") {
	        stream.match(/^\s*\w*/);
	        return ret("keyword", "important");
	      } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
	        stream.eatWhile(/[\w.%]/);
	        return ret("number", "unit");
	      } else if (ch === "-") {
	        if (/[\d.]/.test(stream.peek())) {
	          stream.eatWhile(/[\w.%]/);
	          return ret("number", "unit");
	        } else if (stream.match(/^-[\w\\\-]*/)) {
	          stream.eatWhile(/[\w\\\-]/);
	          if (stream.match(/^\s*:/, false)) return ret("variable-2", "variable-definition");
	          return ret("variable-2", "variable");
	        } else if (stream.match(/^\w+-/)) {
	          return ret("meta", "meta");
	        }
	      } else if (/[,+>*\/]/.test(ch)) {
	        return ret(null, "select-op");
	      } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
	        return ret("qualifier", "qualifier");
	      } else if (/[:;{}\[\]\(\)]/.test(ch)) {
	        return ret(null, ch);
	      } else if (stream.match(/^[\w-.]+(?=\()/)) {
	        if (/^(url(-prefix)?|domain|regexp)$/i.test(stream.current())) {
	          state.tokenize = tokenParenthesized;
	        }
	        return ret("variable callee", "variable");
	      } else if (/[\w\\\-]/.test(ch)) {
	        stream.eatWhile(/[\w\\\-]/);
	        return ret("property", "word");
	      } else {
	        return ret(null, null);
	      }
	    }
	
	    function tokenString(quote) {
	      return function (stream, state) {
	        var escaped = false,
	            ch;
	        while ((ch = stream.next()) != null) {
	          if (ch == quote && !escaped) {
	            if (quote == ")") stream.backUp(1);
	            break;
	          }
	          escaped = !escaped && ch == "\\";
	        }
	        if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	        return ret("string", "string");
	      };
	    }
	
	    function tokenParenthesized(stream, state) {
	      stream.next(); // Must be '('
	      if (!stream.match(/^\s*[\"\')]/, false)) state.tokenize = tokenString(")");else state.tokenize = null;
	      return ret(null, "(");
	    }
	
	    // Context management
	
	    function Context(type, indent, prev) {
	      this.type = type;
	      this.indent = indent;
	      this.prev = prev;
	    }
	
	    function pushContext(state, stream, type, indent) {
	      state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
	      return type;
	    }
	
	    function popContext(state) {
	      if (state.context.prev) state.context = state.context.prev;
	      return state.context.type;
	    }
	
	    function pass(type, stream, state) {
	      return states[state.context.type](type, stream, state);
	    }
	    function popAndPass(type, stream, state, n) {
	      for (var i = n || 1; i > 0; i--) {
	        state.context = state.context.prev;
	      }return pass(type, stream, state);
	    }
	
	    // Parser
	
	    function wordAsValue(stream) {
	      var word = stream.current().toLowerCase();
	      if (valueKeywords.hasOwnProperty(word)) override = "atom";else if (colorKeywords.hasOwnProperty(word)) override = "keyword";else override = "variable";
	    }
	
	    var states = {};
	
	    states.top = function (type, stream, state) {
	      if (type == "{") {
	        return pushContext(state, stream, "block");
	      } else if (type == "}" && state.context.prev) {
	        return popContext(state);
	      } else if (supportsAtComponent && /@component/i.test(type)) {
	        return pushContext(state, stream, "atComponentBlock");
	      } else if (/^@(-moz-)?document$/i.test(type)) {
	        return pushContext(state, stream, "documentTypes");
	      } else if (/^@(media|supports|(-moz-)?document|import)$/i.test(type)) {
	        return pushContext(state, stream, "atBlock");
	      } else if (/^@(font-face|counter-style)/i.test(type)) {
	        state.stateArg = type;
	        return "restricted_atBlock_before";
	      } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(type)) {
	        return "keyframes";
	      } else if (type && type.charAt(0) == "@") {
	        return pushContext(state, stream, "at");
	      } else if (type == "hash") {
	        override = "builtin";
	      } else if (type == "word") {
	        override = "tag";
	      } else if (type == "variable-definition") {
	        return "maybeprop";
	      } else if (type == "interpolation") {
	        return pushContext(state, stream, "interpolation");
	      } else if (type == ":") {
	        return "pseudo";
	      } else if (allowNested && type == "(") {
	        return pushContext(state, stream, "parens");
	      }
	      return state.context.type;
	    };
	
	    states.block = function (type, stream, state) {
	      if (type == "word") {
	        var word = stream.current().toLowerCase();
	        if (propertyKeywords.hasOwnProperty(word)) {
	          override = "property";
	          return "maybeprop";
	        } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
	          override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
	          return "maybeprop";
	        } else if (allowNested) {
	          override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
	          return "block";
	        } else {
	          override += " error";
	          return "maybeprop";
	        }
	      } else if (type == "meta") {
	        return "block";
	      } else if (!allowNested && (type == "hash" || type == "qualifier")) {
	        override = "error";
	        return "block";
	      } else {
	        return states.top(type, stream, state);
	      }
	    };
	
	    states.maybeprop = function (type, stream, state) {
	      if (type == ":") return pushContext(state, stream, "prop");
	      return pass(type, stream, state);
	    };
	
	    states.prop = function (type, stream, state) {
	      if (type == ";") return popContext(state);
	      if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
	      if (type == "}" || type == "{") return popAndPass(type, stream, state);
	      if (type == "(") return pushContext(state, stream, "parens");
	
	      if (type == "hash" && !/^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(stream.current())) {
	        override += " error";
	      } else if (type == "word") {
	        wordAsValue(stream);
	      } else if (type == "interpolation") {
	        return pushContext(state, stream, "interpolation");
	      }
	      return "prop";
	    };
	
	    states.propBlock = function (type, _stream, state) {
	      if (type == "}") return popContext(state);
	      if (type == "word") {
	        override = "property";return "maybeprop";
	      }
	      return state.context.type;
	    };
	
	    states.parens = function (type, stream, state) {
	      if (type == "{" || type == "}") return popAndPass(type, stream, state);
	      if (type == ")") return popContext(state);
	      if (type == "(") return pushContext(state, stream, "parens");
	      if (type == "interpolation") return pushContext(state, stream, "interpolation");
	      if (type == "word") wordAsValue(stream);
	      return "parens";
	    };
	
	    states.pseudo = function (type, stream, state) {
	      if (type == "meta") return "pseudo";
	
	      if (type == "word") {
	        override = "variable-3";
	        return state.context.type;
	      }
	      return pass(type, stream, state);
	    };
	
	    states.documentTypes = function (type, stream, state) {
	      if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
	        override = "tag";
	        return state.context.type;
	      } else {
	        return states.atBlock(type, stream, state);
	      }
	    };
	
	    states.atBlock = function (type, stream, state) {
	      if (type == "(") return pushContext(state, stream, "atBlock_parens");
	      if (type == "}" || type == ";") return popAndPass(type, stream, state);
	      if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
	
	      if (type == "interpolation") return pushContext(state, stream, "interpolation");
	
	      if (type == "word") {
	        var word = stream.current().toLowerCase();
	        if (word == "only" || word == "not" || word == "and" || word == "or") override = "keyword";else if (mediaTypes.hasOwnProperty(word)) override = "attribute";else if (mediaFeatures.hasOwnProperty(word)) override = "property";else if (mediaValueKeywords.hasOwnProperty(word)) override = "keyword";else if (propertyKeywords.hasOwnProperty(word)) override = "property";else if (nonStandardPropertyKeywords.hasOwnProperty(word)) override = highlightNonStandardPropertyKeywords ? "string-2" : "property";else if (valueKeywords.hasOwnProperty(word)) override = "atom";else if (colorKeywords.hasOwnProperty(word)) override = "keyword";else override = "error";
	      }
	      return state.context.type;
	    };
	
	    states.atComponentBlock = function (type, stream, state) {
	      if (type == "}") return popAndPass(type, stream, state);
	      if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
	      if (type == "word") override = "error";
	      return state.context.type;
	    };
	
	    states.atBlock_parens = function (type, stream, state) {
	      if (type == ")") return popContext(state);
	      if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
	      return states.atBlock(type, stream, state);
	    };
	
	    states.restricted_atBlock_before = function (type, stream, state) {
	      if (type == "{") return pushContext(state, stream, "restricted_atBlock");
	      if (type == "word" && state.stateArg == "@counter-style") {
	        override = "variable";
	        return "restricted_atBlock_before";
	      }
	      return pass(type, stream, state);
	    };
	
	    states.restricted_atBlock = function (type, stream, state) {
	      if (type == "}") {
	        state.stateArg = null;
	        return popContext(state);
	      }
	      if (type == "word") {
	        if (state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase()) || state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())) override = "error";else override = "property";
	        return "maybeprop";
	      }
	      return "restricted_atBlock";
	    };
	
	    states.keyframes = function (type, stream, state) {
	      if (type == "word") {
	        override = "variable";return "keyframes";
	      }
	      if (type == "{") return pushContext(state, stream, "top");
	      return pass(type, stream, state);
	    };
	
	    states.at = function (type, stream, state) {
	      if (type == ";") return popContext(state);
	      if (type == "{" || type == "}") return popAndPass(type, stream, state);
	      if (type == "word") override = "tag";else if (type == "hash") override = "builtin";
	      return "at";
	    };
	
	    states.interpolation = function (type, stream, state) {
	      if (type == "}") return popContext(state);
	      if (type == "{" || type == ";") return popAndPass(type, stream, state);
	      if (type == "word") override = "variable";else if (type != "variable" && type != "(" && type != ")") override = "error";
	      return "interpolation";
	    };
	
	    return {
	      startState: function startState(base) {
	        return { tokenize: null,
	          state: inline ? "block" : "top",
	          stateArg: null,
	          context: new Context(inline ? "block" : "top", base || 0, null) };
	      },
	
	      token: function token(stream, state) {
	        if (!state.tokenize && stream.eatSpace()) return null;
	        var style = (state.tokenize || tokenBase)(stream, state);
	        if (style && (typeof style === "undefined" ? "undefined" : _typeof(style)) == "object") {
	          type = style[1];
	          style = style[0];
	        }
	        override = style;
	        if (type != "comment") state.state = states[state.state](type, stream, state);
	        return override;
	      },
	
	      indent: function indent(state, textAfter) {
	        var cx = state.context,
	            ch = textAfter && textAfter.charAt(0);
	        var indent = cx.indent;
	        if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
	        if (cx.prev) {
	          if (ch == "}" && (cx.type == "block" || cx.type == "top" || cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
	            // Resume indentation from parent context.
	            cx = cx.prev;
	            indent = cx.indent;
	          } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") || ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
	            // Dedent relative to current context.
	            indent = Math.max(0, cx.indent - indentUnit);
	          }
	        }
	        return indent;
	      },
	
	      electricChars: "}",
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      blockCommentContinue: " * ",
	      lineComment: lineComment,
	      fold: "brace"
	    };
	  });
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) {
	      keys[array[i].toLowerCase()] = true;
	    }
	    return keys;
	  }
	
	  var documentTypes_ = ["domain", "regexp", "url", "url-prefix"],
	      documentTypes = keySet(documentTypes_);
	
	  var mediaTypes_ = ["all", "aural", "braille", "handheld", "print", "projection", "screen", "tty", "tv", "embossed"],
	      mediaTypes = keySet(mediaTypes_);
	
	  var mediaFeatures_ = ["width", "min-width", "max-width", "height", "min-height", "max-height", "device-width", "min-device-width", "max-device-width", "device-height", "min-device-height", "max-device-height", "aspect-ratio", "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio", "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color", "max-color", "color-index", "min-color-index", "max-color-index", "monochrome", "min-monochrome", "max-monochrome", "resolution", "min-resolution", "max-resolution", "scan", "grid", "orientation", "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio", "pointer", "any-pointer", "hover", "any-hover", "prefers-color-scheme", "dynamic-range", "video-dynamic-range"],
	      mediaFeatures = keySet(mediaFeatures_);
	
	  var mediaValueKeywords_ = ["landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover", "interlace", "progressive", "dark", "light", "standard", "high"],
	      mediaValueKeywords = keySet(mediaValueKeywords_);
	
	  var propertyKeywords_ = ["align-content", "align-items", "align-self", "alignment-adjust", "alignment-baseline", "all", "anchor-point", "animation", "animation-delay", "animation-direction", "animation-duration", "animation-fill-mode", "animation-iteration-count", "animation-name", "animation-play-state", "animation-timing-function", "appearance", "azimuth", "backdrop-filter", "backface-visibility", "background", "background-attachment", "background-blend-mode", "background-clip", "background-color", "background-image", "background-origin", "background-position", "background-position-x", "background-position-y", "background-repeat", "background-size", "baseline-shift", "binding", "bleed", "block-size", "bookmark-label", "bookmark-level", "bookmark-state", "bookmark-target", "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius", "border-bottom-right-radius", "border-bottom-style", "border-bottom-width", "border-collapse", "border-color", "border-image", "border-image-outset", "border-image-repeat", "border-image-slice", "border-image-source", "border-image-width", "border-left", "border-left-color", "border-left-style", "border-left-width", "border-radius", "border-right", "border-right-color", "border-right-style", "border-right-width", "border-spacing", "border-style", "border-top", "border-top-color", "border-top-left-radius", "border-top-right-radius", "border-top-style", "border-top-width", "border-width", "bottom", "box-decoration-break", "box-shadow", "box-sizing", "break-after", "break-before", "break-inside", "caption-side", "caret-color", "clear", "clip", "color", "color-profile", "column-count", "column-fill", "column-gap", "column-rule", "column-rule-color", "column-rule-style", "column-rule-width", "column-span", "column-width", "columns", "contain", "content", "counter-increment", "counter-reset", "crop", "cue", "cue-after", "cue-before", "cursor", "direction", "display", "dominant-baseline", "drop-initial-after-adjust", "drop-initial-after-align", "drop-initial-before-adjust", "drop-initial-before-align", "drop-initial-size", "drop-initial-value", "elevation", "empty-cells", "fit", "fit-content", "fit-position", "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap", "float", "float-offset", "flow-from", "flow-into", "font", "font-family", "font-feature-settings", "font-kerning", "font-language-override", "font-optical-sizing", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-synthesis", "font-variant", "font-variant-alternates", "font-variant-caps", "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric", "font-variant-position", "font-variation-settings", "font-weight", "gap", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow", "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap", "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap", "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns", "grid-template-rows", "hanging-punctuation", "height", "hyphens", "icon", "image-orientation", "image-rendering", "image-resolution", "inline-box-align", "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline", "inset-inline-end", "inset-inline-start", "isolation", "justify-content", "justify-items", "justify-self", "left", "letter-spacing", "line-break", "line-height", "line-height-step", "line-stacking", "line-stacking-ruby", "line-stacking-shift", "line-stacking-strategy", "list-style", "list-style-image", "list-style-position", "list-style-type", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "marks", "marquee-direction", "marquee-loop", "marquee-play-count", "marquee-speed", "marquee-style", "mask-clip", "mask-composite", "mask-image", "mask-mode", "mask-origin", "mask-position", "mask-repeat", "mask-size", "mask-type", "max-block-size", "max-height", "max-inline-size", "max-width", "min-block-size", "min-height", "min-inline-size", "min-width", "mix-blend-mode", "move-to", "nav-down", "nav-index", "nav-left", "nav-right", "nav-up", "object-fit", "object-position", "offset", "offset-anchor", "offset-distance", "offset-path", "offset-position", "offset-rotate", "opacity", "order", "orphans", "outline", "outline-color", "outline-offset", "outline-style", "outline-width", "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y", "padding", "padding-bottom", "padding-left", "padding-right", "padding-top", "page", "page-break-after", "page-break-before", "page-break-inside", "page-policy", "pause", "pause-after", "pause-before", "perspective", "perspective-origin", "pitch", "pitch-range", "place-content", "place-items", "place-self", "play-during", "position", "presentation-level", "punctuation-trim", "quotes", "region-break-after", "region-break-before", "region-break-inside", "region-fragment", "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness", "right", "rotate", "rotation", "rotation-point", "row-gap", "ruby-align", "ruby-overhang", "ruby-position", "ruby-span", "scale", "scroll-behavior", "scroll-margin", "scroll-margin-block", "scroll-margin-block-end", "scroll-margin-block-start", "scroll-margin-bottom", "scroll-margin-inline", "scroll-margin-inline-end", "scroll-margin-inline-start", "scroll-margin-left", "scroll-margin-right", "scroll-margin-top", "scroll-padding", "scroll-padding-block", "scroll-padding-block-end", "scroll-padding-block-start", "scroll-padding-bottom", "scroll-padding-inline", "scroll-padding-inline-end", "scroll-padding-inline-start", "scroll-padding-left", "scroll-padding-right", "scroll-padding-top", "scroll-snap-align", "scroll-snap-type", "shape-image-threshold", "shape-inside", "shape-margin", "shape-outside", "size", "speak", "speak-as", "speak-header", "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set", "tab-size", "table-layout", "target", "target-name", "target-new", "target-position", "text-align", "text-align-last", "text-combine-upright", "text-decoration", "text-decoration-color", "text-decoration-line", "text-decoration-skip", "text-decoration-skip-ink", "text-decoration-style", "text-emphasis", "text-emphasis-color", "text-emphasis-position", "text-emphasis-style", "text-height", "text-indent", "text-justify", "text-orientation", "text-outline", "text-overflow", "text-rendering", "text-shadow", "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position", "text-wrap", "top", "touch-action", "transform", "transform-origin", "transform-style", "transition", "transition-delay", "transition-duration", "transition-property", "transition-timing-function", "translate", "unicode-bidi", "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration", "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress", "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break", "word-spacing", "word-wrap", "writing-mode", "z-index",
	  // SVG-specific
	  "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color", "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events", "color-interpolation", "color-interpolation-filters", "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering", "marker", "marker-end", "marker-mid", "marker-start", "paint-order", "shape-rendering", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering", "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal", "glyph-orientation-vertical", "text-anchor", "writing-mode"],
	      propertyKeywords = keySet(propertyKeywords_);
	
	  var nonStandardPropertyKeywords_ = ["accent-color", "aspect-ratio", "border-block", "border-block-color", "border-block-end", "border-block-end-color", "border-block-end-style", "border-block-end-width", "border-block-start", "border-block-start-color", "border-block-start-style", "border-block-start-width", "border-block-style", "border-block-width", "border-inline", "border-inline-color", "border-inline-end", "border-inline-end-color", "border-inline-end-style", "border-inline-end-width", "border-inline-start", "border-inline-start-color", "border-inline-start-style", "border-inline-start-width", "border-inline-style", "border-inline-width", "content-visibility", "margin-block", "margin-block-end", "margin-block-start", "margin-inline", "margin-inline-end", "margin-inline-start", "overflow-anchor", "overscroll-behavior", "padding-block", "padding-block-end", "padding-block-start", "padding-inline", "padding-inline-end", "padding-inline-start", "scroll-snap-stop", "scrollbar-3d-light-color", "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color", "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color", "scrollbar-track-color", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "shape-inside", "zoom"],
	      nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
	
	  var fontProperties_ = ["font-display", "font-family", "src", "unicode-range", "font-variant", "font-feature-settings", "font-stretch", "font-weight", "font-style"],
	      fontProperties = keySet(fontProperties_);
	
	  var counterDescriptors_ = ["additive-symbols", "fallback", "negative", "pad", "prefix", "range", "speak-as", "suffix", "symbols", "system"],
	      counterDescriptors = keySet(counterDescriptors_);
	
	  var colorKeywords_ = ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
	      colorKeywords = keySet(colorKeywords_);
	
	  var valueKeywords_ = ["above", "absolute", "activeborder", "additive", "activecaption", "afar", "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate", "always", "amharic", "amharic-abegede", "antialiased", "appworkspace", "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page", "avoid-region", "axis-pan", "background", "backwards", "baseline", "below", "bidi-override", "binary", "bengali", "blink", "block", "block-axis", "blur", "bold", "bolder", "border", "border-box", "both", "bottom", "break", "break-all", "break-word", "brightness", "bullets", "button", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian", "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret", "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch", "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote", "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse", "compact", "condensed", "conic-gradient", "contain", "content", "contents", "content-box", "context-menu", "continuous", "contrast", "copy", "counter", "counters", "cover", "crop", "cross", "crosshair", "cubic-bezier", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal", "decimal-leading-zero", "default", "default-button", "dense", "destination-atop", "destination-in", "destination-out", "destination-over", "devanagari", "difference", "disc", "discard", "disclosure-closed", "disclosure-open", "document", "dot-dash", "dot-dot-dash", "dotted", "double", "down", "drop-shadow", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out", "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede", "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er", "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er", "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et", "ethiopic-halehame-gez", "ethiopic-halehame-om-et", "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et", "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig", "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed", "extra-expanded", "fantasy", "fast", "fill", "fill-box", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes", "forwards", "from", "geometricPrecision", "georgian", "grayscale", "graytext", "grid", "groove", "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew", "help", "hidden", "hide", "higher", "highlight", "highlighttext", "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "hue-rotate", "icon", "ignore", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite", "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis", "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert", "italic", "japanese-formal", "japanese-informal", "justify", "kannada", "katakana", "katakana-iroha", "keep-all", "khmer", "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal", "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten", "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem", "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian", "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian", "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "manipulation", "match", "matrix", "matrix3d", "media-play-button", "media-slider", "media-sliderthumb", "media-volume-slider", "media-volume-sliderthumb", "medium", "menu", "menulist", "menulist-button", "menutext", "message-box", "middle", "min-intrinsic", "mix", "mongolian", "monospace", "move", "multiple", "multiple_mask_images", "multiply", "myanmar", "n-resize", "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop", "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap", "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote", "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset", "outside", "outside-shape", "overlay", "overline", "padding", "padding-box", "painted", "page", "paused", "persian", "perspective", "pinch-zoom", "plus-darker", "plus-lighter", "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d", "progress", "push-button", "radial-gradient", "radio", "read-only", "read-write", "read-write-plaintext-only", "rectangle", "region", "relative", "repeat", "repeating-linear-gradient", "repeating-radial-gradient", "repeating-conic-gradient", "repeat-x", "repeat-y", "reset", "reverse", "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY", "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running", "s-resize", "sans-serif", "saturate", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen", "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end", "semi-condensed", "semi-expanded", "separate", "sepia", "serif", "show", "sidama", "simp-chinese-formal", "simp-chinese-informal", "single", "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal", "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow", "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali", "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square", "square-button", "start", "static", "status-bar", "stretch", "stroke", "stroke-box", "sub", "subpixel-antialiased", "svg_masks", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row", "table-row-group", "tamil", "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai", "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er", "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top", "trad-chinese-formal", "trad-chinese-informal", "transform", "translate", "translate3d", "translateX", "translateY", "translateZ", "transparent", "ultra-condensed", "ultra-expanded", "underline", "unidirectional-pan", "unset", "up", "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal", "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url", "var", "vertical", "vertical-text", "view-box", "visible", "visibleFill", "visiblePainted", "visibleStroke", "visual", "w-resize", "wait", "wave", "wider", "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor", "xx-large", "xx-small"],
	      valueKeywords = keySet(valueKeywords_);
	
	  var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_).concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_).concat(valueKeywords_);
	  CodeMirror.registerHelper("hintWords", "css", allWords);
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false,
	        ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = ch == "*";
	    }
	    return ["comment", "comment"];
	  }
	
	  CodeMirror.defineMIME("text/css", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    tokenHooks: {
	      "/": function _(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css"
	  });
	
	  CodeMirror.defineMIME("text/x-scss", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    lineComment: "//",
	    tokenHooks: {
	      "/": function _(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      ":": function _(stream) {
	        if (stream.match(/^\s*\{/, false)) return [null, null];
	        return false;
	      },
	      "$": function $(stream) {
	        stream.match(/^[\w-]+/);
	        if (stream.match(/^\s*:/, false)) return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "#": function _(stream) {
	        if (!stream.eat("{")) return false;
	        return [null, "interpolation"];
	      }
	    },
	    name: "css",
	    helperType: "scss"
	  });
	
	  CodeMirror.defineMIME("text/x-less", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    lineComment: "//",
	    tokenHooks: {
	      "/": function _(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      "@": function _(stream) {
	        if (stream.eat("{")) return [null, "interpolation"];
	        if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, false)) return false;
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false)) return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "&": function _() {
	        return ["atom", "atom"];
	      }
	    },
	    name: "css",
	    helperType: "less"
	  });
	
	  CodeMirror.defineMIME("text/x-gss", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    supportsAtComponent: true,
	    tokenHooks: {
	      "/": function _(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css",
	    helperType: "gss"
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(31));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("javascript", function (config, parserConfig) {
	    var indentUnit = config.indentUnit;
	    var statementIndent = parserConfig.statementIndent;
	    var jsonldMode = parserConfig.jsonld;
	    var jsonMode = parserConfig.json || jsonldMode;
	    var trackScope = parserConfig.trackScope !== false;
	    var isTS = parserConfig.typescript;
	    var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
	
	    // Tokenizer
	
	    var keywords = function () {
	      function kw(type) {
	        return { type: type, style: "keyword" };
	      }
	      var A = kw("keyword a"),
	          B = kw("keyword b"),
	          C = kw("keyword c"),
	          D = kw("keyword d");
	      var operator = kw("operator"),
	          atom = { type: "atom", style: "atom" };
	
	      return {
	        "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
	        "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
	        "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
	        "function": kw("function"), "catch": kw("catch"),
	        "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	        "in": operator, "typeof": operator, "instanceof": operator,
	        "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
	        "this": kw("this"), "class": kw("class"), "super": kw("atom"),
	        "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
	        "await": C
	      };
	    }();
	
	    var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
	    var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
	
	    function readRegexp(stream) {
	      var escaped = false,
	          next,
	          inSet = false;
	      while ((next = stream.next()) != null) {
	        if (!escaped) {
	          if (next == "/" && !inSet) return;
	          if (next == "[") inSet = true;else if (inSet && next == "]") inSet = false;
	        }
	        escaped = !escaped && next == "\\";
	      }
	    }
	
	    // Used as scratch variables to communicate multiple values without
	    // consing up tons of objects.
	    var type, content;
	    function ret(tp, style, cont) {
	      type = tp;content = cont;
	      return style;
	    }
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	      if (ch == '"' || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) {
	        return ret("number", "number");
	      } else if (ch == "." && stream.match("..")) {
	        return ret("spread", "meta");
	      } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	        return ret(ch);
	      } else if (ch == "=" && stream.eat(">")) {
	        return ret("=>", "operator");
	      } else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
	        return ret("number", "number");
	      } else if (/\d/.test(ch)) {
	        stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
	        return ret("number", "number");
	      } else if (ch == "/") {
	        if (stream.eat("*")) {
	          state.tokenize = tokenComment;
	          return tokenComment(stream, state);
	        } else if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ret("comment", "comment");
	        } else if (expressionAllowed(stream, state, 1)) {
	          readRegexp(stream);
	          stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
	          return ret("regexp", "string-2");
	        } else {
	          stream.eat("=");
	          return ret("operator", "operator", stream.current());
	        }
	      } else if (ch == "`") {
	        state.tokenize = tokenQuasi;
	        return tokenQuasi(stream, state);
	      } else if (ch == "#" && stream.peek() == "!") {
	        stream.skipToEnd();
	        return ret("meta", "meta");
	      } else if (ch == "#" && stream.eatWhile(wordRE)) {
	        return ret("variable", "property");
	      } else if (ch == "<" && stream.match("!--") || ch == "-" && stream.match("->") && !/\S/.test(stream.string.slice(0, stream.start))) {
	        stream.skipToEnd();
	        return ret("comment", "comment");
	      } else if (isOperatorChar.test(ch)) {
	        if (ch != ">" || !state.lexical || state.lexical.type != ">") {
	          if (stream.eat("=")) {
	            if (ch == "!" || ch == "=") stream.eat("=");
	          } else if (/[<>*+\-|&?]/.test(ch)) {
	            stream.eat(ch);
	            if (ch == ">") stream.eat(ch);
	          }
	        }
	        if (ch == "?" && stream.eat(".")) return ret(".");
	        return ret("operator", "operator", stream.current());
	      } else if (wordRE.test(ch)) {
	        stream.eatWhile(wordRE);
	        var word = stream.current();
	        if (state.lastType != ".") {
	          if (keywords.propertyIsEnumerable(word)) {
	            var kw = keywords[word];
	            return ret(kw.type, kw.style, word);
	          }
	          if (word == "async" && stream.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, false)) return ret("async", "keyword", word);
	        }
	        return ret("variable", "variable", word);
	      }
	    }
	
	    function tokenString(quote) {
	      return function (stream, state) {
	        var escaped = false,
	            next;
	        if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)) {
	          state.tokenize = tokenBase;
	          return ret("jsonld-keyword", "meta");
	        }
	        while ((next = stream.next()) != null) {
	          if (next == quote && !escaped) break;
	          escaped = !escaped && next == "\\";
	        }
	        if (!escaped) state.tokenize = tokenBase;
	        return ret("string", "string");
	      };
	    }
	
	    function tokenComment(stream, state) {
	      var maybeEnd = false,
	          ch;
	      while (ch = stream.next()) {
	        if (ch == "/" && maybeEnd) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        maybeEnd = ch == "*";
	      }
	      return ret("comment", "comment");
	    }
	
	    function tokenQuasi(stream, state) {
	      var escaped = false,
	          next;
	      while ((next = stream.next()) != null) {
	        if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      return ret("quasi", "string-2", stream.current());
	    }
	
	    var brackets = "([{}])";
	    // This is a crude lookahead trick to try and notice that we're
	    // parsing the argument patterns for a fat-arrow function before we
	    // actually hit the arrow token. It only works if the arrow is on
	    // the same line as the arguments and there's no strange noise
	    // (comments) in between. Fallback is to only notice when we hit the
	    // arrow, and not declare the arguments as locals for the arrow
	    // body.
	    function findFatArrow(stream, state) {
	      if (state.fatArrowAt) state.fatArrowAt = null;
	      var arrow = stream.string.indexOf("=>", stream.start);
	      if (arrow < 0) return;
	
	      if (isTS) {
	        // Try to skip TypeScript return type declarations after the arguments
	        var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow));
	        if (m) arrow = m.index;
	      }
	
	      var depth = 0,
	          sawSomething = false;
	      for (var pos = arrow - 1; pos >= 0; --pos) {
	        var ch = stream.string.charAt(pos);
	        var bracket = brackets.indexOf(ch);
	        if (bracket >= 0 && bracket < 3) {
	          if (!depth) {
	            ++pos;break;
	          }
	          if (--depth == 0) {
	            if (ch == "(") sawSomething = true;break;
	          }
	        } else if (bracket >= 3 && bracket < 6) {
	          ++depth;
	        } else if (wordRE.test(ch)) {
	          sawSomething = true;
	        } else if (/["'\/`]/.test(ch)) {
	          for (;; --pos) {
	            if (pos == 0) return;
	            var next = stream.string.charAt(pos - 1);
	            if (next == ch && stream.string.charAt(pos - 2) != "\\") {
	              pos--;break;
	            }
	          }
	        } else if (sawSomething && !depth) {
	          ++pos;
	          break;
	        }
	      }
	      if (sawSomething && !depth) state.fatArrowAt = pos;
	    }
	
	    // Parser
	
	    var atomicTypes = { "atom": true, "number": true, "variable": true, "string": true,
	      "regexp": true, "this": true, "import": true, "jsonld-keyword": true };
	
	    function JSLexical(indented, column, type, align, prev, info) {
	      this.indented = indented;
	      this.column = column;
	      this.type = type;
	      this.prev = prev;
	      this.info = info;
	      if (align != null) this.align = align;
	    }
	
	    function inScope(state, varname) {
	      if (!trackScope) return false;
	      for (var v = state.localVars; v; v = v.next) {
	        if (v.name == varname) return true;
	      }for (var cx = state.context; cx; cx = cx.prev) {
	        for (var v = cx.vars; v; v = v.next) {
	          if (v.name == varname) return true;
	        }
	      }
	    }
	
	    function parseJS(state, style, type, content, stream) {
	      var cc = state.cc;
	      // Communicate our context to the combinators.
	      // (Less wasteful than consing up a hundred closures on every call.)
	      cx.state = state;cx.stream = stream;cx.marked = null, cx.cc = cc;cx.style = style;
	
	      if (!state.lexical.hasOwnProperty("align")) state.lexical.align = true;
	
	      while (true) {
	        var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
	        if (combinator(type, content)) {
	          while (cc.length && cc[cc.length - 1].lex) {
	            cc.pop()();
	          }if (cx.marked) return cx.marked;
	          if (type == "variable" && inScope(state, content)) return "variable-2";
	          return style;
	        }
	      }
	    }
	
	    // Combinator utils
	
	    var cx = { state: null, column: null, marked: null, cc: null };
	    function pass() {
	      for (var i = arguments.length - 1; i >= 0; i--) {
	        cx.cc.push(arguments[i]);
	      }
	    }
	    function cont() {
	      pass.apply(null, arguments);
	      return true;
	    }
	    function inList(name, list) {
	      for (var v = list; v; v = v.next) {
	        if (v.name == name) return true;
	      }return false;
	    }
	    function register(varname) {
	      var state = cx.state;
	      cx.marked = "def";
	      if (!trackScope) return;
	      if (state.context) {
	        if (state.lexical.info == "var" && state.context && state.context.block) {
	          // FIXME function decls are also not block scoped
	          var newContext = registerVarScoped(varname, state.context);
	          if (newContext != null) {
	            state.context = newContext;
	            return;
	          }
	        } else if (!inList(varname, state.localVars)) {
	          state.localVars = new Var(varname, state.localVars);
	          return;
	        }
	      }
	      // Fall through means this is global
	      if (parserConfig.globalVars && !inList(varname, state.globalVars)) state.globalVars = new Var(varname, state.globalVars);
	    }
	    function registerVarScoped(varname, context) {
	      if (!context) {
	        return null;
	      } else if (context.block) {
	        var inner = registerVarScoped(varname, context.prev);
	        if (!inner) return null;
	        if (inner == context.prev) return context;
	        return new Context(inner, context.vars, true);
	      } else if (inList(varname, context.vars)) {
	        return context;
	      } else {
	        return new Context(context.prev, new Var(varname, context.vars), false);
	      }
	    }
	
	    function isModifier(name) {
	      return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly";
	    }
	
	    // Combinators
	
	    function Context(prev, vars, block) {
	      this.prev = prev;this.vars = vars;this.block = block;
	    }
	    function Var(name, next) {
	      this.name = name;this.next = next;
	    }
	
	    var defaultVars = new Var("this", new Var("arguments", null));
	    function pushcontext() {
	      cx.state.context = new Context(cx.state.context, cx.state.localVars, false);
	      cx.state.localVars = defaultVars;
	    }
	    function pushblockcontext() {
	      cx.state.context = new Context(cx.state.context, cx.state.localVars, true);
	      cx.state.localVars = null;
	    }
	    pushcontext.lex = pushblockcontext.lex = true;
	    function popcontext() {
	      cx.state.localVars = cx.state.context.vars;
	      cx.state.context = cx.state.context.prev;
	    }
	    popcontext.lex = true;
	    function pushlex(type, info) {
	      var result = function result() {
	        var state = cx.state,
	            indent = state.indented;
	        if (state.lexical.type == "stat") indent = state.lexical.indented;else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev) {
	          indent = outer.indented;
	        }state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
	      };
	      result.lex = true;
	      return result;
	    }
	    function poplex() {
	      var state = cx.state;
	      if (state.lexical.prev) {
	        if (state.lexical.type == ")") state.indented = state.lexical.indented;
	        state.lexical = state.lexical.prev;
	      }
	    }
	    poplex.lex = true;
	
	    function expect(wanted) {
	      function exp(type) {
	        if (type == wanted) return cont();else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();else return cont(exp);
	      };
	      return exp;
	    }
	
	    function statement(type, value) {
	      if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
	      if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
	      if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	      if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
	      if (type == "debugger") return cont(expect(";"));
	      if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
	      if (type == ";") return cont();
	      if (type == "if") {
	        if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex) cx.state.cc.pop()();
	        return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
	      }
	      if (type == "function") return cont(functiondef);
	      if (type == "for") return cont(pushlex("form"), pushblockcontext, forspec, statement, popcontext, poplex);
	      if (type == "class" || isTS && value == "interface") {
	        cx.marked = "keyword";
	        return cont(pushlex("form", type == "class" ? type : value), className, poplex);
	      }
	      if (type == "variable") {
	        if (isTS && value == "declare") {
	          cx.marked = "keyword";
	          return cont(statement);
	        } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
	          cx.marked = "keyword";
	          if (value == "enum") return cont(enumdef);else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex);
	        } else if (isTS && value == "namespace") {
	          cx.marked = "keyword";
	          return cont(pushlex("form"), expression, statement, poplex);
	        } else if (isTS && value == "abstract") {
	          cx.marked = "keyword";
	          return cont(statement);
	        } else {
	          return cont(pushlex("stat"), maybelabel);
	        }
	      }
	      if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext, block, poplex, poplex, popcontext);
	      if (type == "case") return cont(expression, expect(":"));
	      if (type == "default") return cont(expect(":"));
	      if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
	      if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
	      if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
	      if (type == "async") return cont(statement);
	      if (value == "@") return cont(expression, statement);
	      return pass(pushlex("stat"), expression, expect(";"), poplex);
	    }
	    function maybeCatchBinding(type) {
	      if (type == "(") return cont(funarg, expect(")"));
	    }
	    function expression(type, value) {
	      return expressionInner(type, value, false);
	    }
	    function expressionNoComma(type, value) {
	      return expressionInner(type, value, true);
	    }
	    function parenExpr(type) {
	      if (type != "(") return pass();
	      return cont(pushlex(")"), maybeexpression, expect(")"), poplex);
	    }
	    function expressionInner(type, value, noComma) {
	      if (cx.state.fatArrowAt == cx.stream.start) {
	        var body = noComma ? arrowBodyNoComma : arrowBody;
	        if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
	      }
	
	      var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
	      if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
	      if (type == "function") return cont(functiondef, maybeop);
	      if (type == "class" || isTS && value == "interface") {
	        cx.marked = "keyword";return cont(pushlex("form"), classExpression, poplex);
	      }
	      if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
	      if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
	      if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
	      if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
	      if (type == "{") return contCommasep(objprop, "}", null, maybeop);
	      if (type == "quasi") return pass(quasi, maybeop);
	      if (type == "new") return cont(maybeTarget(noComma));
	      return cont();
	    }
	    function maybeexpression(type) {
	      if (type.match(/[;\}\)\],]/)) return pass();
	      return pass(expression);
	    }
	
	    function maybeoperatorComma(type, value) {
	      if (type == ",") return cont(maybeexpression);
	      return maybeoperatorNoComma(type, value, false);
	    }
	    function maybeoperatorNoComma(type, value, noComma) {
	      var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
	      var expr = noComma == false ? expression : expressionNoComma;
	      if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
	      if (type == "operator") {
	        if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
	        if (isTS && value == "<" && cx.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, false)) return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
	        if (value == "?") return cont(expression, expect(":"), expr);
	        return cont(expr);
	      }
	      if (type == "quasi") {
	        return pass(quasi, me);
	      }
	      if (type == ";") return;
	      if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
	      if (type == ".") return cont(property, me);
	      if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
	      if (isTS && value == "as") {
	        cx.marked = "keyword";return cont(typeexpr, me);
	      }
	      if (type == "regexp") {
	        cx.state.lastType = cx.marked = "operator";
	        cx.stream.backUp(cx.stream.pos - cx.stream.start - 1);
	        return cont(expr);
	      }
	    }
	    function quasi(type, value) {
	      if (type != "quasi") return pass();
	      if (value.slice(value.length - 2) != "${") return cont(quasi);
	      return cont(maybeexpression, continueQuasi);
	    }
	    function continueQuasi(type) {
	      if (type == "}") {
	        cx.marked = "string-2";
	        cx.state.tokenize = tokenQuasi;
	        return cont(quasi);
	      }
	    }
	    function arrowBody(type) {
	      findFatArrow(cx.stream, cx.state);
	      return pass(type == "{" ? statement : expression);
	    }
	    function arrowBodyNoComma(type) {
	      findFatArrow(cx.stream, cx.state);
	      return pass(type == "{" ? statement : expressionNoComma);
	    }
	    function maybeTarget(noComma) {
	      return function (type) {
	        if (type == ".") return cont(noComma ? targetNoComma : target);else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma);else return pass(noComma ? expressionNoComma : expression);
	      };
	    }
	    function target(_, value) {
	      if (value == "target") {
	        cx.marked = "keyword";return cont(maybeoperatorComma);
	      }
	    }
	    function targetNoComma(_, value) {
	      if (value == "target") {
	        cx.marked = "keyword";return cont(maybeoperatorNoComma);
	      }
	    }
	    function maybelabel(type) {
	      if (type == ":") return cont(poplex, statement);
	      return pass(maybeoperatorComma, expect(";"), poplex);
	    }
	    function property(type) {
	      if (type == "variable") {
	        cx.marked = "property";return cont();
	      }
	    }
	    function objprop(type, value) {
	      if (type == "async") {
	        cx.marked = "property";
	        return cont(objprop);
	      } else if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        if (value == "get" || value == "set") return cont(getterSetter);
	        var m; // Work around fat-arrow-detection complication for detecting typescript typed arrow params
	        if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false))) cx.state.fatArrowAt = cx.stream.pos + m[0].length;
	        return cont(afterprop);
	      } else if (type == "number" || type == "string") {
	        cx.marked = jsonldMode ? "property" : cx.style + " property";
	        return cont(afterprop);
	      } else if (type == "jsonld-keyword") {
	        return cont(afterprop);
	      } else if (isTS && isModifier(value)) {
	        cx.marked = "keyword";
	        return cont(objprop);
	      } else if (type == "[") {
	        return cont(expression, maybetype, expect("]"), afterprop);
	      } else if (type == "spread") {
	        return cont(expressionNoComma, afterprop);
	      } else if (value == "*") {
	        cx.marked = "keyword";
	        return cont(objprop);
	      } else if (type == ":") {
	        return pass(afterprop);
	      }
	    }
	    function getterSetter(type) {
	      if (type != "variable") return pass(afterprop);
	      cx.marked = "property";
	      return cont(functiondef);
	    }
	    function afterprop(type) {
	      if (type == ":") return cont(expressionNoComma);
	      if (type == "(") return pass(functiondef);
	    }
	    function commasep(what, end, sep) {
	      function proceed(type, value) {
	        if (sep ? sep.indexOf(type) > -1 : type == ",") {
	          var lex = cx.state.lexical;
	          if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
	          return cont(function (type, value) {
	            if (type == end || value == end) return pass();
	            return pass(what);
	          }, proceed);
	        }
	        if (type == end || value == end) return cont();
	        if (sep && sep.indexOf(";") > -1) return pass(what);
	        return cont(expect(end));
	      }
	      return function (type, value) {
	        if (type == end || value == end) return cont();
	        return pass(what, proceed);
	      };
	    }
	    function contCommasep(what, end, info) {
	      for (var i = 3; i < arguments.length; i++) {
	        cx.cc.push(arguments[i]);
	      }return cont(pushlex(end, info), commasep(what, end), poplex);
	    }
	    function block(type) {
	      if (type == "}") return cont();
	      return pass(statement, block);
	    }
	    function maybetype(type, value) {
	      if (isTS) {
	        if (type == ":") return cont(typeexpr);
	        if (value == "?") return cont(maybetype);
	      }
	    }
	    function maybetypeOrIn(type, value) {
	      if (isTS && (type == ":" || value == "in")) return cont(typeexpr);
	    }
	    function mayberettype(type) {
	      if (isTS && type == ":") {
	        if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr);else return cont(typeexpr);
	      }
	    }
	    function isKW(_, value) {
	      if (value == "is") {
	        cx.marked = "keyword";
	        return cont();
	      }
	    }
	    function typeexpr(type, value) {
	      if (value == "keyof" || value == "typeof" || value == "infer" || value == "readonly") {
	        cx.marked = "keyword";
	        return cont(value == "typeof" ? expressionNoComma : typeexpr);
	      }
	      if (type == "variable" || value == "void") {
	        cx.marked = "type";
	        return cont(afterType);
	      }
	      if (value == "|" || value == "&") return cont(typeexpr);
	      if (type == "string" || type == "number" || type == "atom") return cont(afterType);
	      if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType);
	      if (type == "{") return cont(pushlex("}"), typeprops, poplex, afterType);
	      if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType);
	      if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr);
	      if (type == "quasi") {
	        return pass(quasiType, afterType);
	      }
	    }
	    function maybeReturnType(type) {
	      if (type == "=>") return cont(typeexpr);
	    }
	    function typeprops(type) {
	      if (type.match(/[\}\)\]]/)) return cont();
	      if (type == "," || type == ";") return cont(typeprops);
	      return pass(typeprop, typeprops);
	    }
	    function typeprop(type, value) {
	      if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        return cont(typeprop);
	      } else if (value == "?" || type == "number" || type == "string") {
	        return cont(typeprop);
	      } else if (type == ":") {
	        return cont(typeexpr);
	      } else if (type == "[") {
	        return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop);
	      } else if (type == "(") {
	        return pass(functiondecl, typeprop);
	      } else if (!type.match(/[;\}\)\],]/)) {
	        return cont();
	      }
	    }
	    function quasiType(type, value) {
	      if (type != "quasi") return pass();
	      if (value.slice(value.length - 2) != "${") return cont(quasiType);
	      return cont(typeexpr, continueQuasiType);
	    }
	    function continueQuasiType(type) {
	      if (type == "}") {
	        cx.marked = "string-2";
	        cx.state.tokenize = tokenQuasi;
	        return cont(quasiType);
	      }
	    }
	    function typearg(type, value) {
	      if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg);
	      if (type == ":") return cont(typeexpr);
	      if (type == "spread") return cont(typearg);
	      return pass(typeexpr);
	    }
	    function afterType(type, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
	      if (value == "|" || type == "." || value == "&") return cont(typeexpr);
	      if (type == "[") return cont(typeexpr, expect("]"), afterType);
	      if (value == "extends" || value == "implements") {
	        cx.marked = "keyword";return cont(typeexpr);
	      }
	      if (value == "?") return cont(typeexpr, expect(":"), typeexpr);
	    }
	    function maybeTypeArgs(_, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
	    }
	    function typeparam() {
	      return pass(typeexpr, maybeTypeDefault);
	    }
	    function maybeTypeDefault(_, value) {
	      if (value == "=") return cont(typeexpr);
	    }
	    function vardef(_, value) {
	      if (value == "enum") {
	        cx.marked = "keyword";return cont(enumdef);
	      }
	      return pass(pattern, maybetype, maybeAssign, vardefCont);
	    }
	    function pattern(type, value) {
	      if (isTS && isModifier(value)) {
	        cx.marked = "keyword";return cont(pattern);
	      }
	      if (type == "variable") {
	        register(value);return cont();
	      }
	      if (type == "spread") return cont(pattern);
	      if (type == "[") return contCommasep(eltpattern, "]");
	      if (type == "{") return contCommasep(proppattern, "}");
	    }
	    function proppattern(type, value) {
	      if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
	        register(value);
	        return cont(maybeAssign);
	      }
	      if (type == "variable") cx.marked = "property";
	      if (type == "spread") return cont(pattern);
	      if (type == "}") return pass();
	      if (type == "[") return cont(expression, expect(']'), expect(':'), proppattern);
	      return cont(expect(":"), pattern, maybeAssign);
	    }
	    function eltpattern() {
	      return pass(pattern, maybeAssign);
	    }
	    function maybeAssign(_type, value) {
	      if (value == "=") return cont(expressionNoComma);
	    }
	    function vardefCont(type) {
	      if (type == ",") return cont(vardef);
	    }
	    function maybeelse(type, value) {
	      if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
	    }
	    function forspec(type, value) {
	      if (value == "await") return cont(forspec);
	      if (type == "(") return cont(pushlex(")"), forspec1, poplex);
	    }
	    function forspec1(type) {
	      if (type == "var") return cont(vardef, forspec2);
	      if (type == "variable") return cont(forspec2);
	      return pass(forspec2);
	    }
	    function forspec2(type, value) {
	      if (type == ")") return cont();
	      if (type == ";") return cont(forspec2);
	      if (value == "in" || value == "of") {
	        cx.marked = "keyword";return cont(expression, forspec2);
	      }
	      return pass(expression, forspec2);
	    }
	    function functiondef(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(functiondef);
	      }
	      if (type == "variable") {
	        register(value);return cont(functiondef);
	      }
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
	      if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef);
	    }
	    function functiondecl(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(functiondecl);
	      }
	      if (type == "variable") {
	        register(value);return cont(functiondecl);
	      }
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
	      if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl);
	    }
	    function typename(type, value) {
	      if (type == "keyword" || type == "variable") {
	        cx.marked = "type";
	        return cont(typename);
	      } else if (value == "<") {
	        return cont(pushlex(">"), commasep(typeparam, ">"), poplex);
	      }
	    }
	    function funarg(type, value) {
	      if (value == "@") cont(expression, funarg);
	      if (type == "spread") return cont(funarg);
	      if (isTS && isModifier(value)) {
	        cx.marked = "keyword";return cont(funarg);
	      }
	      if (isTS && type == "this") return cont(maybetype, maybeAssign);
	      return pass(pattern, maybetype, maybeAssign);
	    }
	    function classExpression(type, value) {
	      // Class expressions may have an optional name.
	      if (type == "variable") return className(type, value);
	      return classNameAfter(type, value);
	    }
	    function className(type, value) {
	      if (type == "variable") {
	        register(value);return cont(classNameAfter);
	      }
	    }
	    function classNameAfter(type, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter);
	      if (value == "extends" || value == "implements" || isTS && type == ",") {
	        if (value == "implements") cx.marked = "keyword";
	        return cont(isTS ? typeexpr : expression, classNameAfter);
	      }
	      if (type == "{") return cont(pushlex("}"), classBody, poplex);
	    }
	    function classBody(type, value) {
	      if (type == "async" || type == "variable" && (value == "static" || value == "get" || value == "set" || isTS && isModifier(value)) && cx.stream.match(/^\s+#?[\w$\xa1-\uffff]/, false)) {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        return cont(classfield, classBody);
	      }
	      if (type == "number" || type == "string") return cont(classfield, classBody);
	      if (type == "[") return cont(expression, maybetype, expect("]"), classfield, classBody);
	      if (value == "*") {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      if (isTS && type == "(") return pass(functiondecl, classBody);
	      if (type == ";" || type == ",") return cont(classBody);
	      if (type == "}") return cont();
	      if (value == "@") return cont(expression, classBody);
	    }
	    function classfield(type, value) {
	      if (value == "!") return cont(classfield);
	      if (value == "?") return cont(classfield);
	      if (type == ":") return cont(typeexpr, maybeAssign);
	      if (value == "=") return cont(expressionNoComma);
	      var context = cx.state.lexical.prev,
	          isInterface = context && context.info == "interface";
	      return pass(isInterface ? functiondecl : functiondef);
	    }
	    function afterExport(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(maybeFrom, expect(";"));
	      }
	      if (value == "default") {
	        cx.marked = "keyword";return cont(expression, expect(";"));
	      }
	      if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
	      return pass(statement);
	    }
	    function exportField(type, value) {
	      if (value == "as") {
	        cx.marked = "keyword";return cont(expect("variable"));
	      }
	      if (type == "variable") return pass(expressionNoComma, exportField);
	    }
	    function afterImport(type) {
	      if (type == "string") return cont();
	      if (type == "(") return pass(expression);
	      if (type == ".") return pass(maybeoperatorComma);
	      return pass(importSpec, maybeMoreImports, maybeFrom);
	    }
	    function importSpec(type, value) {
	      if (type == "{") return contCommasep(importSpec, "}");
	      if (type == "variable") register(value);
	      if (value == "*") cx.marked = "keyword";
	      return cont(maybeAs);
	    }
	    function maybeMoreImports(type) {
	      if (type == ",") return cont(importSpec, maybeMoreImports);
	    }
	    function maybeAs(_type, value) {
	      if (value == "as") {
	        cx.marked = "keyword";return cont(importSpec);
	      }
	    }
	    function maybeFrom(_type, value) {
	      if (value == "from") {
	        cx.marked = "keyword";return cont(expression);
	      }
	    }
	    function arrayLiteral(type) {
	      if (type == "]") return cont();
	      return pass(commasep(expressionNoComma, "]"));
	    }
	    function enumdef() {
	      return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex);
	    }
	    function enummember() {
	      return pass(pattern, maybeAssign);
	    }
	
	    function isContinuedStatement(state, textAfter) {
	      return state.lastType == "operator" || state.lastType == "," || isOperatorChar.test(textAfter.charAt(0)) || /[,.]/.test(textAfter.charAt(0));
	    }
	
	    function expressionAllowed(stream, state, backUp) {
	      return state.tokenize == tokenBase && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) || state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0)));
	    }
	
	    // Interface
	
	    return {
	      startState: function startState(basecolumn) {
	        var state = {
	          tokenize: tokenBase,
	          lastType: "sof",
	          cc: [],
	          lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	          localVars: parserConfig.localVars,
	          context: parserConfig.localVars && new Context(null, null, false),
	          indented: basecolumn || 0
	        };
	        if (parserConfig.globalVars && _typeof(parserConfig.globalVars) == "object") state.globalVars = parserConfig.globalVars;
	        return state;
	      },
	
	      token: function token(stream, state) {
	        if (stream.sol()) {
	          if (!state.lexical.hasOwnProperty("align")) state.lexical.align = false;
	          state.indented = stream.indentation();
	          findFatArrow(stream, state);
	        }
	        if (state.tokenize != tokenComment && stream.eatSpace()) return null;
	        var style = state.tokenize(stream, state);
	        if (type == "comment") return style;
	        state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
	        return parseJS(state, style, type, content, stream);
	      },
	
	      indent: function indent(state, textAfter) {
	        if (state.tokenize == tokenComment || state.tokenize == tokenQuasi) return CodeMirror.Pass;
	        if (state.tokenize != tokenBase) return 0;
	        var firstChar = textAfter && textAfter.charAt(0),
	            lexical = state.lexical,
	            top;
	        // Kludge to prevent 'maybelse' from blocking lexical scope pops
	        if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
	          var c = state.cc[i];
	          if (c == poplex) lexical = lexical.prev;else if (c != maybeelse && c != popcontext) break;
	        }
	        while ((lexical.type == "stat" || lexical.type == "form") && (firstChar == "}" || (top = state.cc[state.cc.length - 1]) && (top == maybeoperatorComma || top == maybeoperatorNoComma) && !/^[,\.=+\-*:?[\(]/.test(textAfter))) {
	          lexical = lexical.prev;
	        }if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat") lexical = lexical.prev;
	        var type = lexical.type,
	            closing = firstChar == type;
	
	        if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);else if (type == "form" && firstChar == "{") return lexical.indented;else if (type == "form") return lexical.indented + indentUnit;else if (type == "stat") return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false) return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);else if (lexical.align) return lexical.column + (closing ? 0 : 1);else return lexical.indented + (closing ? 0 : indentUnit);
	      },
	
	      electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
	      blockCommentStart: jsonMode ? null : "/*",
	      blockCommentEnd: jsonMode ? null : "*/",
	      blockCommentContinue: jsonMode ? null : " * ",
	      lineComment: jsonMode ? null : "//",
	      fold: "brace",
	      closeBrackets: "()[]{}''\"\"``",
	
	      helperType: jsonMode ? "json" : "javascript",
	      jsonldMode: jsonldMode,
	      jsonMode: jsonMode,
	
	      expressionAllowed: expressionAllowed,
	
	      skipExpression: function skipExpression(state) {
	        parseJS(state, "atom", "atom", "true", new CodeMirror.StringStream("", 2, null));
	      }
	    };
	  });
	
	  CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
	
	  CodeMirror.defineMIME("text/javascript", "javascript");
	  CodeMirror.defineMIME("text/ecmascript", "javascript");
	  CodeMirror.defineMIME("application/javascript", "javascript");
	  CodeMirror.defineMIME("application/x-javascript", "javascript");
	  CodeMirror.defineMIME("application/ecmascript", "javascript");
	  CodeMirror.defineMIME("application/json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/x-json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/manifest+json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/ld+json", { name: "javascript", jsonld: true });
	  CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
	  CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.draftjsToHtml = factory();
	})(this, function () {
	  'use strict';
	
	  /**
	  * Utility function to execute callback for eack key->value pair.
	  */
	
	  function forEach(obj, callback) {
	    if (obj) {
	      for (var key in obj) {
	        // eslint-disable-line no-restricted-syntax
	        if ({}.hasOwnProperty.call(obj, key)) {
	          callback(key, obj[key]);
	        }
	      }
	    }
	  }
	
	  /**
	  * The function returns true if the string passed to it has no content.
	  */
	  function isEmptyString(str) {
	    if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
	      return true;
	    }
	    return false;
	  }
	
	  /**
	  * Mapping block-type to corresponding html tag.
	  */
	  var blockTypesMapping = {
	    unstyled: 'p',
	    'header-one': 'h1',
	    'header-two': 'h2',
	    'header-three': 'h3',
	    'header-four': 'h4',
	    'header-five': 'h5',
	    'header-six': 'h6',
	    'unordered-list-item': 'ul',
	    'ordered-list-item': 'ol',
	    blockquote: 'blockquote',
	    code: 'pre'
	  };
	
	  /**
	  * Function will return HTML tag for a block.
	  */
	  function getBlockTag(type) {
	    return type && blockTypesMapping[type];
	  }
	
	  /**
	  * Function will return style string for a block.
	  */
	  function getBlockStyle(data) {
	    var styles = '';
	    forEach(data, function (key, value) {
	      if (value) {
	        styles += key + ':' + value + ';';
	      }
	    });
	    return styles;
	  }
	
	  /**
	  * The function returns an array of hashtag-sections in blocks.
	  * These will be areas in block which have hashtags applicable to them.
	  */
	  function getHashtagRanges(blockText, hashtagConfig) {
	    var sections = [];
	    if (hashtagConfig) {
	      var counter = 0;
	      var startIndex = 0;
	      var text = blockText;
	      var trigger = hashtagConfig.trigger || '#';
	      var separator = hashtagConfig.separator || ' ';
	      for (; text.length > 0 && startIndex >= 0;) {
	        if (text[0] === trigger) {
	          startIndex = 0;
	          counter = 0;
	          text = text.substr(trigger.length);
	        } else {
	          startIndex = text.indexOf(separator + trigger);
	          if (startIndex >= 0) {
	            text = text.substr(startIndex + (separator + trigger).length);
	            counter += startIndex + separator.length;
	          }
	        }
	        if (startIndex >= 0) {
	          var endIndex = text.indexOf(separator) >= 0 ? text.indexOf(separator) : text.length;
	          var hashtag = text.substr(0, endIndex);
	          if (hashtag && hashtag.length > 0) {
	            sections.push({
	              offset: counter,
	              length: hashtag.length + trigger.length,
	              type: 'HASHTAG'
	            });
	          }
	          counter += trigger.length;
	        }
	      }
	    }
	    return sections;
	  }
	
	  /**
	  * The function returns an array of entity-sections in blocks.
	  * These will be areas in block which have same entity or no entity applicable to them.
	  */
	  function getSections(block, hashtagConfig) {
	    var sections = [];
	    var lastOffset = 0;
	    var sectionRanges = block.entityRanges.map(function (range) {
	      var offset = range.offset,
	          length = range.length,
	          key = range.key;
	
	      return {
	        offset: offset,
	        length: length,
	        key: key,
	        type: 'ENTITY'
	      };
	    });
	    sectionRanges = sectionRanges.concat(getHashtagRanges(block.text, hashtagConfig));
	    sectionRanges = sectionRanges.sort(function (s1, s2) {
	      return s1.offset - s2.offset;
	    });
	    sectionRanges.forEach(function (r) {
	      if (r.offset > lastOffset) {
	        sections.push({
	          start: lastOffset,
	          end: r.offset
	        });
	      }
	      sections.push({
	        start: r.offset,
	        end: r.offset + r.length,
	        entityKey: r.key,
	        type: r.type
	      });
	      lastOffset = r.offset + r.length;
	    });
	    if (lastOffset < block.text.length) {
	      sections.push({
	        start: lastOffset,
	        end: block.text.length
	      });
	    }
	    return sections;
	  }
	
	  /**
	  * Function to check if the block is an atomic entity block.
	  */
	  function isAtomicEntityBlock(block) {
	    if (block.entityRanges.length > 0 && (isEmptyString(block.text) || block.type === 'atomic')) {
	      return true;
	    }
	    return false;
	  }
	
	  /**
	  * The function will return array of inline styles applicable to the block.
	  */
	  function getStyleArrayForBlock(block) {
	    var text = block.text,
	        inlineStyleRanges = block.inlineStyleRanges;
	
	    var inlineStyles = {
	      BOLD: new Array(text.length),
	      ITALIC: new Array(text.length),
	      UNDERLINE: new Array(text.length),
	      STRIKETHROUGH: new Array(text.length),
	      CODE: new Array(text.length),
	      SUPERSCRIPT: new Array(text.length),
	      SUBSCRIPT: new Array(text.length),
	      COLOR: new Array(text.length),
	      BGCOLOR: new Array(text.length),
	      FONTSIZE: new Array(text.length),
	      FONTFAMILY: new Array(text.length),
	      length: text.length
	    };
	    if (inlineStyleRanges && inlineStyleRanges.length > 0) {
	      inlineStyleRanges.forEach(function (range) {
	        var offset = range.offset;
	
	        var length = offset + range.length;
	        for (var i = offset; i < length; i += 1) {
	          if (range.style.indexOf('color-') === 0) {
	            inlineStyles.COLOR[i] = range.style.substring(6);
	          } else if (range.style.indexOf('bgcolor-') === 0) {
	            inlineStyles.BGCOLOR[i] = range.style.substring(8);
	          } else if (range.style.indexOf('fontsize-') === 0) {
	            inlineStyles.FONTSIZE[i] = range.style.substring(9);
	          } else if (range.style.indexOf('fontfamily-') === 0) {
	            inlineStyles.FONTFAMILY[i] = range.style.substring(11);
	          } else if (inlineStyles[range.style]) {
	            inlineStyles[range.style][i] = true;
	          }
	        }
	      });
	    }
	    return inlineStyles;
	  }
	
	  /**
	  * The function will return inline style applicable at some offset within a block.
	  */
	  function getStylesAtOffset(inlineStyles, offset) {
	    var styles = {};
	    if (inlineStyles.COLOR[offset]) {
	      styles.COLOR = inlineStyles.COLOR[offset];
	    }
	    if (inlineStyles.BGCOLOR[offset]) {
	      styles.BGCOLOR = inlineStyles.BGCOLOR[offset];
	    }
	    if (inlineStyles.FONTSIZE[offset]) {
	      styles.FONTSIZE = inlineStyles.FONTSIZE[offset];
	    }
	    if (inlineStyles.FONTFAMILY[offset]) {
	      styles.FONTFAMILY = inlineStyles.FONTFAMILY[offset];
	    }
	    if (inlineStyles.UNDERLINE[offset]) {
	      styles.UNDERLINE = true;
	    }
	    if (inlineStyles.ITALIC[offset]) {
	      styles.ITALIC = true;
	    }
	    if (inlineStyles.BOLD[offset]) {
	      styles.BOLD = true;
	    }
	    if (inlineStyles.STRIKETHROUGH[offset]) {
	      styles.STRIKETHROUGH = true;
	    }
	    if (inlineStyles.CODE[offset]) {
	      styles.CODE = true;
	    }
	    if (inlineStyles.SUBSCRIPT[offset]) {
	      styles.SUBSCRIPT = true;
	    }
	    if (inlineStyles.SUPERSCRIPT[offset]) {
	      styles.SUPERSCRIPT = true;
	    }
	    return styles;
	  }
	
	  /**
	  * Function returns true for a set of styles if the value of these styles at an offset
	  * are same as that on the previous offset.
	  */
	  function sameStyleAsPrevious(inlineStyles, styles, index) {
	    var sameStyled = true;
	    if (index > 0 && index < inlineStyles.length) {
	      styles.forEach(function (style) {
	        sameStyled = sameStyled && inlineStyles[style][index] === inlineStyles[style][index - 1];
	      });
	    } else {
	      sameStyled = false;
	    }
	    return sameStyled;
	  }
	
	  /**
	  * Function returns html for text depending on inline style tags applicable to it.
	  */
	  function addInlineStyleMarkup(style, content) {
	    if (style === 'BOLD') {
	      return '<strong>' + content + '</strong>';
	    } else if (style === 'ITALIC') {
	      return '<em>' + content + '</em>';
	    } else if (style === 'UNDERLINE') {
	      return '<ins>' + content + '</ins>';
	    } else if (style === 'STRIKETHROUGH') {
	      return '<del>' + content + '</del>';
	    } else if (style === 'CODE') {
	      return '<code>' + content + '</code>';
	    } else if (style === 'SUPERSCRIPT') {
	      return '<sup>' + content + '</sup>';
	    } else if (style === 'SUBSCRIPT') {
	      return '<sub>' + content + '</sub>';
	    }
	    return content;
	  }
	
	  /**
	  * The function returns text for given section of block after doing required character replacements.
	  */
	  function getSectionText(text) {
	    if (text && text.length > 0) {
	      var chars = text.map(function (ch) {
	        switch (ch) {
	          case '\n':
	            return '<br>';
	          case '&':
	            return '&amp;';
	          case '<':
	            return '&lt;';
	          case '>':
	            return '&gt;';
	          default:
	            return ch;
	        }
	      });
	      return chars.join('');
	    }
	    return '';
	  }
	
	  /**
	  * Function returns html for text depending on inline style tags applicable to it.
	  */
	  function addStylePropertyMarkup(styles, text) {
	    if (styles && (styles.COLOR || styles.BGCOLOR || styles.FONTSIZE || styles.FONTFAMILY)) {
	      var styleString = 'style="';
	      if (styles.COLOR) {
	        styleString += 'color: ' + styles.COLOR + ';';
	      }
	      if (styles.BGCOLOR) {
	        styleString += 'background-color: ' + styles.BGCOLOR + ';';
	      }
	      if (styles.FONTSIZE) {
	        styleString += 'font-size: ' + styles.FONTSIZE + (/^\d+$/.test(styles.FONTSIZE) ? 'px' : '') + ';';
	      }
	      if (styles.FONTFAMILY) {
	        styleString += 'font-family: ' + styles.FONTFAMILY + ';';
	      }
	      styleString += '"';
	      return '<span ' + styleString + '>' + text + '</span>';
	    }
	    return text;
	  }
	
	  /**
	  * Function will return markup for Entity.
	  */
	  function getEntityMarkup(entityMap, entityKey, text, customEntityTransform) {
	    var entity = entityMap[entityKey];
	    if (typeof customEntityTransform === 'function') {
	      var html = customEntityTransform(entity, text);
	      if (html) {
	        return html;
	      }
	    }
	    if (entity.type === 'MENTION') {
	      return '<a href="' + entity.data.url + '" class="wysiwyg-mention" data-mention data-value="' + entity.data.value + '">' + text + '</a>';
	    }
	    if (entity.type === 'LINK') {
	      var targetOption = entity.data.targetOption || '_self';
	      return '<a href="' + entity.data.url + '" target="' + targetOption + '">' + text + '</a>';
	    }
	    if (entity.type === 'IMAGE') {
	      return '<img src="' + entity.data.src + '" alt="' + entity.data.alt + '" style="float:' + (entity.data.alignment || 'none') + ';height: ' + entity.data.height + ';width: ' + entity.data.width + '"/>';
	    }
	    if (entity.type === 'EMBEDDED_LINK') {
	      return '<iframe width="' + entity.data.width + '" height="' + entity.data.height + '" src="' + entity.data.src + '" frameBorder="0"></iframe>';
	    }
	    return text;
	  }
	
	  /**
	  * For a given section in a block the function will return a further list of sections,
	  * with similar inline styles applicable to them.
	  */
	  function getInlineStyleSections(block, styles, start, end) {
	    var styleSections = [];
	    var text = block.text;
	
	    if (text.length > 0) {
	      var inlineStyles = getStyleArrayForBlock(block);
	      var section = void 0;
	      for (var i = start; i < end; i += 1) {
	        if (i !== start && sameStyleAsPrevious(inlineStyles, styles, i)) {
	          section.text.push(text[i]);
	          section.end = i + 1;
	        } else {
	          section = {
	            styles: getStylesAtOffset(inlineStyles, i),
	            text: [text[i]],
	            start: i,
	            end: i + 1
	          };
	          styleSections.push(section);
	        }
	      }
	    }
	    return styleSections;
	  }
	
	  /**
	  * Replace leading blank spaces by &nbsp;
	  */
	  function trimLeadingZeros(sectionText) {
	    if (sectionText) {
	      var replacedText = sectionText;
	      for (var i = 0; i < replacedText.length; i += 1) {
	        if (sectionText[i] === ' ') {
	          replacedText = replacedText.replace(' ', '&nbsp;');
	        } else {
	          break;
	        }
	      }
	      return replacedText;
	    }
	    return sectionText;
	  }
	
	  /**
	  * Replace trailing blank spaces by &nbsp;
	  */
	  function trimTrailingZeros(sectionText) {
	    if (sectionText) {
	      var replacedText = sectionText;
	      for (var i = replacedText.length - 1; i >= 0; i -= 1) {
	        if (replacedText[i] === ' ') {
	          replacedText = replacedText.substring(0, i) + '&nbsp;' + replacedText.substring(i + 1);
	        } else {
	          break;
	        }
	      }
	      return replacedText;
	    }
	    return sectionText;
	  }
	
	  /**
	  * The method returns markup for section to which inline styles
	  * like BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE, SUPERSCRIPT, SUBSCRIPT are applicable.
	  */
	  function getStyleTagSectionMarkup(styleSection) {
	    var styles = styleSection.styles,
	        text = styleSection.text;
	
	    var content = getSectionText(text);
	    forEach(styles, function (style, value) {
	      content = addInlineStyleMarkup(style, content, value);
	    });
	    return content;
	  }
	
	  /**
	  * The method returns markup for section to which inline styles
	  like color, background-color, font-size are applicable.
	  */
	  function getInlineStyleSectionMarkup(block, styleSection) {
	    var styleTagSections = getInlineStyleSections(block, ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'], styleSection.start, styleSection.end);
	    var styleSectionText = '';
	    styleTagSections.forEach(function (stylePropertySection) {
	      styleSectionText += getStyleTagSectionMarkup(stylePropertySection);
	    });
	    styleSectionText = addStylePropertyMarkup(styleSection.styles, styleSectionText);
	    return styleSectionText;
	  }
	
	  /*
	  * The method returns markup for an entity section.
	  * An entity section is a continuous section in a block
	  * to which same entity or no entity is applicable.
	  */
	  function getSectionMarkup(block, entityMap, section, customEntityTransform) {
	    var entityInlineMarkup = [];
	    var inlineStyleSections = getInlineStyleSections(block, ['COLOR', 'BGCOLOR', 'FONTSIZE', 'FONTFAMILY'], section.start, section.end);
	    inlineStyleSections.forEach(function (styleSection) {
	      entityInlineMarkup.push(getInlineStyleSectionMarkup(block, styleSection));
	    });
	    var sectionText = entityInlineMarkup.join('');
	    if (section.type === 'ENTITY') {
	      if (section.entityKey !== undefined && section.entityKey !== null) {
	        sectionText = getEntityMarkup(entityMap, section.entityKey, sectionText, customEntityTransform); // eslint-disable-line max-len
	      }
	    } else if (section.type === 'HASHTAG') {
	      sectionText = '<a href="' + sectionText + '" class="wysiwyg-hashtag">' + sectionText + '</a>';
	    }
	    return sectionText;
	  }
	
	  /**
	  * Function will return the markup for block preserving the inline styles and
	  * special characters like newlines or blank spaces.
	  */
	  function getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform) {
	    var blockMarkup = [];
	    var sections = getSections(block, hashtagConfig);
	    sections.forEach(function (section, index) {
	      var sectionText = getSectionMarkup(block, entityMap, section, customEntityTransform);
	      if (index === 0) {
	        sectionText = trimLeadingZeros(sectionText);
	      }
	      if (index === sections.length - 1) {
	        sectionText = trimTrailingZeros(sectionText);
	      }
	      blockMarkup.push(sectionText);
	    });
	    return blockMarkup.join('');
	  }
	
	  /**
	  * Function will return html for the block.
	  */
	  function getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform) {
	    var blockHtml = [];
	    if (isAtomicEntityBlock(block)) {
	      blockHtml.push(getEntityMarkup(entityMap, block.entityRanges[0].key, undefined, customEntityTransform));
	    } else {
	      var blockTag = getBlockTag(block.type);
	      if (blockTag) {
	        blockHtml.push('<' + blockTag);
	        var blockStyle = getBlockStyle(block.data);
	        if (blockStyle) {
	          blockHtml.push(' style="' + blockStyle + '"');
	        }
	        if (directional) {
	          blockHtml.push(' dir = "auto"');
	        }
	        blockHtml.push('>');
	        blockHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
	        blockHtml.push('</' + blockTag + '>');
	      }
	    }
	    blockHtml.push('\n');
	    return blockHtml.join('');
	  }
	
	  /**
	  * Function to check if a block is of type list.
	  */
	  function isList(blockType) {
	    return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
	  }
	
	  /**
	  * Function will return html markup for a list block.
	  */
	  function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
	    var listHtml = [];
	    var nestedListBlock = [];
	    var previousBlock = void 0;
	    listBlocks.forEach(function (block) {
	      var nestedBlock = false;
	      if (!previousBlock) {
	        listHtml.push('<' + getBlockTag(block.type) + '>\n');
	      } else if (previousBlock.type !== block.type) {
	        listHtml.push('</' + getBlockTag(previousBlock.type) + '>\n');
	        listHtml.push('<' + getBlockTag(block.type) + '>\n');
	      } else if (previousBlock.depth === block.depth) {
	        if (nestedListBlock && nestedListBlock.length > 0) {
	          listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
	          nestedListBlock = [];
	        }
	      } else {
	        nestedBlock = true;
	        nestedListBlock.push(block);
	      }
	      if (!nestedBlock) {
	        listHtml.push('<li');
	        var blockStyle = getBlockStyle(block.data);
	        if (blockStyle) {
	          listHtml.push(' style="' + blockStyle + '"');
	        }
	        if (directional) {
	          listHtml.push(' dir = "auto"');
	        }
	        listHtml.push('>');
	        listHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
	        listHtml.push('</li>\n');
	        previousBlock = block;
	      }
	    });
	    if (nestedListBlock && nestedListBlock.length > 0) {
	      listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
	    }
	    listHtml.push('</' + getBlockTag(previousBlock.type) + '>\n');
	    return listHtml.join('');
	  }
	
	  /**
	  * The function will generate html markup for given draftjs editorContent.
	  */
	  function draftToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
	    var html = [];
	    if (editorContent) {
	      var blocks = editorContent.blocks,
	          entityMap = editorContent.entityMap;
	
	      if (blocks && blocks.length > 0) {
	        var listBlocks = [];
	        blocks.forEach(function (block) {
	          if (isList(block.type)) {
	            listBlocks.push(block);
	          } else {
	            if (listBlocks.length > 0) {
	              var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, customEntityTransform); // eslint-disable-line max-len
	              html.push(listHtml);
	              listBlocks = [];
	            }
	            var blockHtml = getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform);
	            html.push(blockHtml);
	          }
	        });
	        if (listBlocks.length > 0) {
	          var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform); // eslint-disable-line max-len
	          html.push(listHtml);
	          listBlocks = [];
	        }
	      }
	    }
	    return html.join('');
	  }
	
	  return draftToHtml;
	});

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!function (e, t) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t(__webpack_require__(858), __webpack_require__(193)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(858), __webpack_require__(193)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.htmlToDraftjs = t(require("immutable"), require("draft-js")) : e.htmlToDraftjs = t(e.immutable, e["draft-js"]);
	}(window, function (n, r) {
	  return o = {}, i.m = a = [function (e, t) {
	    e.exports = n;
	  }, function (e, t) {
	    e.exports = r;
	  }, function (e, t, n) {
	    e.exports = n(3);
	  }, function (e, t, n) {
	    "use strict";
	    n.r(t);var v = n(1),
	        u = n(0),
	        s = function s(e) {
	      var t,
	          n = null;return document.implementation && document.implementation.createHTMLDocument && ((t = document.implementation.createHTMLDocument("foo")).documentElement.innerHTML = e, n = t.getElementsByTagName("body")[0]), n;
	    },
	        x = function x(e, t, n) {
	      var r,
	          i = e.textContent;return "" === i.trim() ? { chunk: (r = n, { text: " ", inlines: [new u.OrderedSet()], entities: [r], blocks: [] }) } : { chunk: { text: i, inlines: Array(i.length).fill(t), entities: Array(i.length).fill(n), blocks: [] } };
	    },
	        M = function M() {
	      return { text: "\n", inlines: [new u.OrderedSet()], entities: new Array(1), blocks: [] };
	    },
	        k = function k() {
	      return { text: "", inlines: [], entities: [], blocks: [] };
	    },
	        E = function E(e, t) {
	      return { text: "", inlines: [], entities: [], blocks: [{ type: e, depth: 0, data: t || new u.Map({}) }] };
	    },
	        w = function w(e, t, n) {
	      return { text: "\r", inlines: [], entities: [], blocks: [{ type: e, depth: Math.max(0, Math.min(4, t)), data: n || new u.Map({}) }] };
	    },
	        T = function T(e) {
	      return { text: "\r ", inlines: [new u.OrderedSet()], entities: [e], blocks: [{ type: "atomic", depth: 0, data: new u.Map({}) }] };
	    },
	        L = function L(e, t) {
	      return { text: e.text + t.text, inlines: e.inlines.concat(t.inlines), entities: e.entities.concat(t.entities), blocks: e.blocks.concat(t.blocks) };
	    },
	        A = new u.Map({ "header-one": { element: "h1" }, "header-two": { element: "h2" }, "header-three": { element: "h3" }, "header-four": { element: "h4" }, "header-five": { element: "h5" }, "header-six": { element: "h6" }, "unordered-list-item": { element: "li", wrapper: "ul" }, "ordered-list-item": { element: "li", wrapper: "ol" }, blockquote: { element: "blockquote" }, code: { element: "pre" }, atomic: { element: "figure" }, unstyled: { element: "p", aliasedElements: ["div"] } });var O = { code: "CODE", del: "STRIKETHROUGH", em: "ITALIC", strong: "BOLD", ins: "UNDERLINE", sub: "SUBSCRIPT", sup: "SUPERSCRIPT" };function S(e) {
	      return e.style.textAlign ? new u.Map({ "text-align": e.style.textAlign }) : e.style.marginLeft ? new u.Map({ "margin-left": e.style.marginLeft }) : void 0;
	    }var _ = function _(e) {
	      var t = void 0;if (e instanceof HTMLAnchorElement) {
	        var n = {};t = e.dataset && void 0 !== e.dataset.mention ? (n.url = e.href, n.text = e.innerHTML, n.value = e.dataset.value, v.Entity.__create("MENTION", "IMMUTABLE", n)) : (n.url = e.getAttribute && e.getAttribute("href") || e.href, n.title = e.innerHTML, n.targetOption = e.target, v.Entity.__create("LINK", "MUTABLE", n));
	      }return t;
	    };n.d(t, "default", function () {
	      return r;
	    });var d = " ",
	        f = new RegExp("&nbsp;", "g"),
	        j = !0;function I(e, t, n, r, i, a) {
	      var o = e.nodeName.toLowerCase();if (a) {
	        var l = a(o, e);if (l) {
	          var c = v.Entity.__create(l.type, l.mutability, l.data || {});return { chunk: T(c) };
	        }
	      }if ("#text" === o && "\n" !== e.textContent) return x(e, t, i);if ("br" === o) return { chunk: M() };if ("img" === o && e instanceof HTMLImageElement) {
	        var u = {};u.src = e.getAttribute && e.getAttribute("src") || e.src, u.alt = e.alt, u.height = e.style.height, u.width = e.style.width, e.style.float && (u.alignment = e.style.float);var s = v.Entity.__create("IMAGE", "MUTABLE", u);return { chunk: T(s) };
	      }if ("video" === o && e instanceof HTMLVideoElement) {
	        var d = {};d.src = e.getAttribute && e.getAttribute("src") || e.src, d.alt = e.alt, d.height = e.style.height, d.width = e.style.width, e.style.float && (d.alignment = e.style.float);var f = v.Entity.__create("VIDEO", "MUTABLE", d);return { chunk: T(f) };
	      }if ("iframe" === o && e instanceof HTMLIFrameElement) {
	        var m = {};m.src = e.getAttribute && e.getAttribute("src") || e.src, m.height = e.height, m.width = e.width;var p = v.Entity.__create("EMBEDDED_LINK", "MUTABLE", m);return { chunk: T(p) };
	      }var h,
	          y = function (t, n) {
	        var e = A.filter(function (e) {
	          return e.element === t && (!e.wrapper || e.wrapper === n) || e.wrapper === t || e.aliasedElements && -1 < e.aliasedElements.indexOf(t);
	        }).keySeq().toSet().toArray();if (1 === e.length) return e[0];
	      }(o, r);y && ("ul" === o || "ol" === o ? (r = o, n += 1) : ("unordered-list-item" !== y && "ordered-list-item" !== y && (r = "", n = -1), j ? (h = E(y, S(e)), j = !1) : h = w(y, n, S(e)))), h = h || k(), t = function (e, t, n) {
	        var r,
	            i = O[e];if (i) r = n.add(i).toOrderedSet();else if (t instanceof HTMLElement) {
	          var c = t;r = (r = n).withMutations(function (e) {
	            var t = c.style.color,
	                n = c.style.backgroundColor,
	                r = c.style.fontSize,
	                i = c.style.fontFamily.replace(/^"|"$/g, ""),
	                a = c.style.fontWeight,
	                o = c.style.textDecoration,
	                l = c.style.fontStyle;t && e.add("color-".concat(t.replace(/ /g, ""))), n && e.add("bgcolor-".concat(n.replace(/ /g, ""))), r && e.add("fontsize-".concat(r.replace(/px$/g, ""))), i && e.add("fontfamily-".concat(i)), "bold" === a && e.add(O.strong), "underline" === o && e.add(O.ins), "italic" === l && e.add(O.em);
	          }).toOrderedSet();
	        }return r;
	      }(o, e, t);for (var b = e.firstChild; b;) {
	        var g = I(b, t, n, r, _(b) || i, a).chunk;h = L(h, g), b = b.nextSibling;
	      }return { chunk: h };
	    }function r(e, t) {
	      var n,
	          r,
	          i,
	          a = (n = t, r = e.trim().replace(f, d), (i = s(r)) ? (j = !0, { chunk: I(i, new u.OrderedSet(), -1, "", void 0, n).chunk }) : null);if (a) {
	        var o = a.chunk,
	            l = new u.OrderedMap({});o.entities && o.entities.forEach(function (e) {
	          e && (l = l.set(e, v.Entity.__get(e)));
	        });var c = 0;return { contentBlocks: o.text.split("\r").map(function (e, t) {
	            var n = c + e.length,
	                r = o && o.inlines.slice(c, n),
	                i = o && o.entities.slice(c, n),
	                a = new u.List(r.map(function (e, t) {
	              var n = { style: e, entity: null };return i[t] && (n.entity = i[t]), v.CharacterMetadata.create(n);
	            }));return c = n, new v.ContentBlock({ key: Object(v.genKey)(), type: o && o.blocks[t] && o.blocks[t].type || "unstyled", depth: o && o.blocks[t] && o.blocks[t].depth, data: o && o.blocks[t] && o.blocks[t].data || new u.Map({}), text: e, characterList: a });
	          }), entityMap: l };
	      }return null;
	    }
	  }], i.c = o, i.d = function (e, t, n) {
	    i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
	  }, i.r = function (e) {
	    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
	  }, i.t = function (t, e) {
	    if (1 & e && (t = i(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var n = Object.create(null);if (i.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var r in t) {
	      i.d(n, r, function (e) {
	        return t[e];
	      }.bind(null, r));
	    }return n;
	  }, i.n = function (e) {
	    var t = e && e.__esModule ? function () {
	      return e.default;
	    } : function () {
	      return e;
	    };return i.d(t, "a", t), t;
	  }, i.o = function (e, t) {
	    return Object.prototype.hasOwnProperty.call(e, t);
	  }, i.p = "", i(i.s = 2);function i(e) {
	    if (o[e]) return o[e].exports;var t = o[e] = { i: e, l: !1, exports: {} };return a[e].call(t.exports, t, t.exports, i), t.l = !0, t.exports;
	  }var a, o;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _EditorSelection = __webpack_require__(369);
	
	var _EditorSelection2 = _interopRequireDefault(_EditorSelection);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var EditorHistory = {
		curCommand: null,
		commandStack: [],
		commandIndex: -1,
		canUndo: function canUndo() {
			return this.commandStack.length > 0 && this.commandIndex != -1;
		},
		canRedo: function canRedo() {
			return this.commandStack.length > 0 && this.commandIndex != this.commandStack.length - 1;
		},
		undo: function undo() {
			if (this.canUndo()) {
				this.commandIndex = this.commandIndex - 1;
				this.curCommand = this.commandStack[this.commandIndex];
				document.execCommand("undo");
			}
			return this.canUndo();
		},
		redo: function redo() {
			if (this.canRedo()) {
				this.commandIndex = this.commandIndex + 1;
				this.curCommand = this.commandStack[this.commandIndex];
				document.execCommand("redo");
			}
			return this.canRedo();
		},
		execCommand: function execCommand(command, flag, args) {
			switch (command) {
				case "inserthtml":
					var selection = _EditorSelection2.default.getSelection();
					if (selection.pasteHTML) selection.pasteHTML(args);else document.execCommand(command, flag, args);
					break;
				default:
					document.execCommand(command, flag, args);
					break;
			}
	
			if (command == "selectall") return;
			this.commandIndex = this.commandIndex + 1;
			this.curCommand = { command: command, flag: flag, args: args };
			// 必需移除index后的command
			this.commandStack.splice(this.commandIndex, this.commandStack.length - this.commandIndex);
			this.commandStack[this.commandIndex] = { command: command, flag: flag, args: args };
		},
		getCurCommand: function getCurCommand() {
			return this.curCommand;
		},
		getCommandStack: function getCommandStack() {
			return this.commandStack;
		},
		getCommandIndex: function getCommandIndex() {
			return this.commandIndex;
		},
		clear: function clear() {
			this.curCommand = null;
			this.commandStack = [];
			this.commandIndex = -1;
		}
	};
	
	exports.default = EditorHistory;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiButton = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCommon = __webpack_require__(29);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _SgiCompComm = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	// import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
	// import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
	
	var SgiButton = function (_React$Component) {
	    _inherits(SgiButton, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiButton(props) {
	        _classCallCheck(this, SgiButton);
	
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiButton.__proto__ || Object.getPrototypeOf(SgiButton)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性
	
	                this.button_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            var btn = void 0;
	            if (this.state.isHref) {
	                btn = _react2.default.createElement(
	                    'a',
	                    this.state.inputprops,
	                    this.state.text
	                );
	            } else if (this.props.moduleDesc.isOnlyImg && this.state.inputprops.icon) {
	                btn = _react2.default.createElement(_antd.Icon, _extends({}, this.state.inputprops, { type: this.state.inputprops.icon }));
	            } else {
	                btn = _react2.default.createElement(
	                    _antd.Button,
	                    this.state.inputprops,
	                    this.state.text
	                );
	            }
	
	            return _react2.default.createElement(
	                _antd.Tooltip,
	                this.state.tooltiProps,
	                this.state.badgeProps.isExist ? _react2.default.createElement(
	                    _antd.Badge,
	                    this.state.badgeProps,
	                    btn
	                ) : btn
	            );
	        };
	
	        _this.state = {
	            tooltiProps: {},
	            text: undefined,
	            inputprops: {
	                style: { marginRight: '5px' },
	                disabled: false //是否可用
	            },
	            badgeProps: {
	                isExist: false,
	                style: {}
	            },
	            functions: {},
	            loading: false,
	            isHref: false
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {对象工厂} objFct
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiButton, [{
	        key: 'button_mk',
	        value: function button_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	            // var formItemProps = { style: {} }; //input外层属性
	            // var inputprops = { style: {} }; //转换后属性
	            //添加公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.inputprops);
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.inputprops, this.state.tooltiProps, this.state.badgeProps);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.inputprops, this.state.functions, type, objFct);
	        }
	    }, {
	        key: 'quertEvent',
	        value: function quertEvent(moduleDesc, objFct) {
	
	            var compIdArr = moduleDesc.compId ? moduleDesc.compId.split(',') : []; //刷新组件id
	            var serviceUrl = moduleDesc.serviceUrl; //服务地址变量字符穿
	            var resObjArr = moduleDesc.resObj ? moduleDesc.resObj.split(',') : []; //返回结果实例名
	
	
	            var req = {}; //查询条件
	            var clkBefLsn = moduleDesc.clkBefLsn; // 用户自定义点击前处理事件
	            if (clkBefLsn) {
	                var $clkBefLsn = new Function("module", "objFct", clkBefLsn);
	                var clkBefLsnRes = $clkBefLsn(moduleDesc, objFct);
	
	                if (Object.prototype.toString.call(clkBefLsnRes) === '[object Object]') {
	                    Object.assign(req, clkBefLsnRes);
	                }
	            }
	
	            if (moduleDesc.isPartial) {
	                //是否分批
	                tool.tableBatchSelect(compId, objFct, eval(serviceUrl), req, function (res) {
	                    if (res && res.head && res.head.code === "0000") {
	                        tool.sgiLogger.info("查询成功 res :", res);
	
	                        var clkMidLsn = moduleDesc.clkMidLsn; // 用户自定义点击中处理事件
	                        if (clkMidLsn) {
	                            var $clkMidLsn = new Function("module", "objFct", "response", clkMidLsn);
	                            $clkMidLsn(moduleDesc, objFct, res);
	                            compIdArr.forEach(function (element) {
	                                tool.refreshTable(element, objFct);
	                            });
	                        } else {
	                            resObjArr.forEach(function (element) {
	                                objFct.set(element, res.body);
	                            });
	                            compIdArr.forEach(function (element) {
	                                tool.refreshTable(element, objFct);
	                            });
	                        }
	                    } else {
	                        tool.sgiLogger.error("查询失败 res :", res);
	                    }
	                }, moduleDesc.isAsyn ? true : false);
	            } else {
	                commonClient.simplecall(eval(serviceUrl), req, function (res) {
	                    if (res && res.head && res.head.code === "0000") {
	                        tool.sgiLogger.info("操作成功 res :", res);
	
	                        var clkMidLsn = moduleDesc.clkMidLsn; // 用户自定义点击中处理事件
	                        if (clkMidLsn) {
	                            var $clkMidLsn = new Function("module", "objFct", "response", clkMidLsn);
	                            $clkMidLsn(moduleDesc, objFct, res);
	                            compIdArr.forEach(function (element) {
	                                tool.refreshTable(element, objFct);
	                                tool.refreshWV(element, objFct);
	                            });
	                        } else {
	                            resObjArr.forEach(function (element) {
	                                objFct.set(element, res.body);
	                            });
	                            compIdArr.forEach(function (element) {
	                                tool.refreshTable(element, objFct);
	                                tool.refreshWV(element, objFct);
	                            });
	                        }
	                    } else {
	                        tool.sgiLogger.error("操作失败 res :", res);
	                    }
	                }, moduleDesc.isAsyn ? true : false);
	            }
	        }
	        /**
	         * 按钮默认查询事件
	         * @param {*} moduleDesc 
	         * @param {*} objFct 
	         */
	
	    }, {
	        key: 'btnDefaultEvent',
	        value: function btnDefaultEvent(moduleDesc, objFct) {
	            if (!moduleDesc) {
	                return;
	            }
	
	            var serviceUrl = moduleDesc.serviceUrl; //查询服务地址
	            if (serviceUrl) {
	                this.quertEvent(moduleDesc, objFct);
	            }
	
	            var clkLsn = moduleDesc.clkLsn; // 用户自定义点击后处理事件/点击事件
	            if (clkLsn) {
	                var $clkLsn = new Function("module", "objFct", clkLsn);
	                $clkLsn(moduleDesc, objFct);
	            }
	        }
	
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc 
	         * @param {*} formProps 
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, formProps, functions, type, objFct) {
	            //拖拽模式 不生成事件
	            if (type == 'dnd') {
	                return;
	            }
	
	            // functions.onClick = this.btnDefaultEvent.bind(this, moduleDesc, objFct);
	            var btnType = moduleDesc.btnType;
	            if (btnType && btnType == "callSI") {
	                // 服务调用
	                functions.onClick = this.btnOnClick.bind(this, moduleDesc, objFct);
	            } else {
	                // 普通按钮-自定义点击事件
	                var clkLsn = moduleDesc.clkLsn;
	                if (clkLsn) {
	                    var $clkLsn = new Function("module", "objFct", clkLsn);
	                    functions.onClick = $clkLsn;
	                }
	            }
	            formProps.onClick = _SgiEventHandler.SgiEventHandler.onClick.bind(this);
	        }
	    }, {
	        key: 'btnOnClick',
	        value: function btnOnClick(moduleDesc, objFct) {
	            (0, _SgiCompComm.toCallSi)(moduleDesc, objFct);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, inputprops, tooltiProps, badgeProps) {
	            //csstyle 样式文件这个我还不知道怎么用
	            var csstyle = moduleDesc.csstyle;
	            if (csstyle == 'button-primary') {
	                inputprops.type = 'primary';
	            } else if (csstyle == 'button-auxiliary') {
	                inputprops.type = 'dashed';
	            } else if (csstyle == 'button-danger') {
	                inputprops.type = 'danger';
	            }
	
	            //右上角标 ??未完全实现
	            var badgeText = moduleDesc.badgeText;
	            if (badgeText) {
	                badgeProps.isExist = true;
	                badgeProps.count = badgeText;
	            }
	
	            // 是否链接样式
	            var isHref = moduleDesc.isHref;
	            this.state.isHref = !!isHref;
	            if (isHref) {
	                //对链接样式进行一定修改
	                inputprops.style.color = "#1890ff";
	                inputprops.style.marginRight = "10px";
	            }
	
	            //显示边框 ??
	            var isBrdr = moduleDesc.isBrdr;
	            //边框宽度 ??未实现
	            var bdrW = moduleDesc.bdrW;
	
	            //背景图片 ??未实现
	            var bkImgPh = moduleDesc.bkImgPh;
	
	            //背景图重复方式 ??未实现
	            var bkImgRptType = moduleDesc.bkImgPbkImgRptTypeh;
	
	            var btnIconPh = moduleDesc.btnIconPh; //按钮图标
	            if (btnIconPh) inputprops.icon = btnIconPh;
	
	            //按钮图片位置 ??未实现,如果想控制 Icon 具体的位置，只能直接使用 Icon 组件，而非 icon 属性
	            var iconAlg = moduleDesc.iconAlg;
	
	            //按钮的提示信息
	            var hvInfo = moduleDesc.hvInfo;
	            if (hvInfo) {
	                tooltiProps.title = hvInfo;
	                // tooltiProps.defaultVisible = false;//默认就是false
	            } else {}
	                // tooltiProps.defaultVisible = true;//这是什么操作???
	
	
	                //文本位置 ??
	            var teAl = moduleDesc.teAl;
	
	            //显示名称
	            var te = inputprops.te; //公共属性中从资源文件获取
	            /**if (te)*/this.state.text = te;
	
	            var isDis = moduleDesc.isDis; //是否可用
	            if (isDis) {
	                inputprops.disabled = true;
	            } else {
	                inputprops.disabled = false;
	            }
	        }
	
	        /**
	        * 设置是否隐藏
	        */
	
	    }, {
	        key: 'setHidden',
	        value: function setHidden(value) {
	            // this.state.inputprops.hidden = value; //2018.04.25-yly,修改弹窗无法隐藏问题
	            // this.setState(this.state.inputprops);
	            if (value) {
	                this.state.tooltiProps.style = { display: "none" };
	                this.state.inputprops.style.display = "none";
	                this.state.badgeProps.style.display = "none";
	            } else {
	                this.state.tooltiProps.style = { display: undefined };
	                this.state.inputprops.style.display = undefined;
	                this.state.badgeProps.style.display = undefined;
	            }
	            if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	                // 更新引用
	                this.state.inputprops.style = _extends({}, this.state.inputprops.style);
	                this.state.badgeProps.style = _extends({}, this.state.badgeProps.style);
	                this.state.inputprops.key = (0, _rtSdCommon.uuid)(8);
	            }
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'setDisabled',
	        value: function setDisabled(value) {
	            if (this.state.inputprops.disabled === value) {
	                return;
	            }
	            this.state.inputprops.disabled = value;
	            this.setState(this.state.inputprops);
	        }
	    }, {
	        key: 'setText',
	        value: function setText(value) {
	            if (this.state.text === value) {
	                return;
	            }
	            this.state.text = value;
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'setBadge',
	        value: function setBadge(badge) {
	            if ((typeof badge === 'undefined' ? 'undefined' : _typeof(badge)) === "object") {
	                Object.assign(this.state.badgeProps, badge);
	            } else {
	                this.state.badgeProps.isExist = true;
	                this.state.badgeProps.count = badge;
	            }
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'setType',
	        value: function setType(value) {
	            if (this.state.inputprops.type === value) {
	                return;
	            }
	            this.state.inputprops.type = value;
	            this.setState({ loading: false });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiButton;
	}(_react2.default.Component);
	
	//给类添加公共方法
	// Object.assign(SgiFormButton.prototype, sgiFormCtlBaseFun);
	
	SgiButton.defaultProps = {};
	SgiButton.propTypes = {};
	exports.SgiButton = SgiButton;
	exports.default = SgiButton;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiCalendar = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _antd = __webpack_require__(18);
	
	var _moment = __webpack_require__(40);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 注意：Calendar 部分 locale 是从 value 中读取，所以请先正确设置 moment 的 locale。
	// 默认语言为 en-US，所以如果需要使用其他语言，推荐在入口文件全局设置 locale
	// import moment from 'moment';
	// import 'moment/locale/zh-cn';
	// moment.locale('zh-cn');
	
	
	var SgiCalendar = function (_React$Component) {
	    _inherits(SgiCalendar, _React$Component);
	
	    // 注意这里有分号
	
	    //这个暂时不好用 以后在处理
	    function SgiCalendar(props) {
	        _classCallCheck(this, SgiCalendar);
	
	        var _this = _possibleConstructorReturn(this, (SgiCalendar.__proto__ || Object.getPrototypeOf(SgiCalendar)).call(this, props));
	
	        _this.AddAttribute = function (moduleDesc, calendarProps, functions, parentModule, type) {
	
	            // 显示模式，月/年
	            calendarProps.mode = moduleDesc.mode;
	
	            // 全屏显示
	            calendarProps.fullscreen = !!moduleDesc.isFllScrn;
	
	            // 开发模式不走以下渲染事件
	            if (this.props.type === "dnd") return;
	
	            // 自定义日期渲染--追加渲染
	            var dtCllRndr = moduleDesc.dtCllRndr;
	            if (dtCllRndr) {
	                var $dtCllRndr;
	                try {
	                    $dtCllRndr = new Function("module", "objFct", 'value', 'moment', dtCllRndr);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.dateCellRender = $dtCllRndr;
	            }
	
	            // 自定义日期渲染--完全渲染
	            var dtFllCllRndr = moduleDesc.dtFllCllRndr;
	            if (dtFllCllRndr) {
	                var $dtFllCllRndr;
	                try {
	                    $dtFllCllRndr = new Function("module", "objFct", 'value', 'moment', dtFllCllRndr);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.dateFullCellRender = $dtFllCllRndr;
	            }
	
	            // 自定义月份渲染--追加渲染
	            var mnthCllRndr = moduleDesc.mnthCllRndr;
	            if (mnthCllRndr) {
	                var $mnthCllRndr;
	                try {
	                    $mnthCllRndr = new Function("module", "objFct", 'value', 'moment', mnthCllRndr);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.monthCellRender = $mnthCllRndr;
	            }
	
	            // 自定义月份渲染--完全渲染
	            var mnthFllCllRndr = moduleDesc.mnthFllCllRndr;
	            if (mnthFllCllRndr) {
	                var $mnthFllCllRndr;
	                try {
	                    $mnthFllCllRndr = new Function("module", "objFct", 'value', 'moment', mnthFllCllRndr);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.monthFullCellRender = $mnthFllCllRndr;
	            }
	
	            // 自定义不可选
	            var dsbldDt = moduleDesc.dsbldDt;
	            if (dsbldDt) {
	                var $dsbldDt;
	                try {
	                    $dsbldDt = new Function("module", "objFct", 'value', 'moment', dsbldDt);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.disabledDate = $dsbldDt;
	            }
	
	            // dateCellRender	自定义渲染日期单元格，返回内容会被追加到单元格	function(date: moment): ReactNode	无
	            // dateFullCellRender	自定义渲染日期单元格，返回内容覆盖单元格	function(date: moment): ReactNode	无
	            // defaultValue	默认展示的日期	moment	默认日期
	            // disabledDate	不可选择的日期(currentDate: moment) => boolean	无
	            // fullscreen	是否全屏显示	boolean	true
	            // locale	国际化配置	object	默认配置
	            // mode	初始模式，month / year	string	month
	            // monthCellRender	自定义渲染月单元格，返回内容会被追加到单元格	function(date: moment): ReactNode	无
	            // monthFullCellRender	自定义渲染月单元格，返回内容覆盖单元格	function(date: moment): ReactNode	无
	            // validRange	设置可以显示的日期[moment, moment]	无
	            // value	展示日期	moment	当前日期
	            // onPanelChange	日期面板变化回调	function(date: moment, mode: string)	无
	            // onSelect	点击选择日期回调	function(date: moment）	无
	            // onChange	日期变化回调	function(date: moment）	无
	        };
	
	        _this.refresh = function () {
	            _this.setState({});
	        };
	
	        _this.render = function () {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded) {
	                //组装属性
	                this.calendar_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            var _state = this.state,
	                value = _state.value,
	                selectedValue = _state.selectedValue,
	                calendarProps = _state.calendarProps,
	                functions = _state.functions;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_antd.Calendar, _extends({
	                    className: 'sgiCalendar'
	                }, calendarProps, {
	                    value: value,
	                    disabledDate: this.getCellRender.call(this, "disabledDate"),
	                    dateCellRender: this.getCellRender.call(this, "dateCellRender") //自定义追加渲染事件--日期
	                    , dateFullCellRender: this.getCellRender.call(this, "dateFullCellRender") //自定义完全渲染事件--日期
	                    , monthCellRender: this.getCellRender.call(this, "monthCellRender") //自定义追加渲染事件--月份
	                    , monthFullCellRender: this.getCellRender.call(this, "monthFullCellRender") //自定义完全渲染事件--月份
	                }))
	            );
	        };
	
	        _this.state = {
	            //ctnProps: { style: {} },//form属性
	            calendarProps: { style: { heigth: '100%', width: '100%' } }, //calendar全局属性
	            loading: false,
	            toolbarTopItems: [],
	            toolbarBottomItems: [],
	            calendarUUID: undefined,
	
	            functions: {}, //存放functions
	
	            value: (0, _moment2.default)()
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建form
	     * @param {父组件} parentModule 
	     * @param {描述} moduleDesc       
	     * @param {对象工厂} objFct 
	     * @param {make类型} type 
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiCalendar, [{
	        key: 'calendar_mk',
	        value: function calendar_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.calendarItems = []; //再次渲染的时候清空
	
	            //转换form公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.calendarProps);
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.calendarProps, this.state.functions, parentModule, type);
	            //设置布局
	            //this.setFormCtlLayout(moduleDesc, formProps);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.calendarProps, this.state.functions);
	            //组装form表单下的控件信息
	            // this.fitCalendarItems(moduleDesc, this.state.calendarItems, objFct, type);
	        }
	
	        /**
	         * 属性转换
	         * @param {object} moduleDesc 属性描述
	         * @param {object} calendarProps 组件属性
	         * @param {object} parentModule 父组件
	         * @param {object} type 类型
	         */
	
	    }, {
	        key: 'bindEvent',
	
	
	        /**
	         * 绑定事件
	         * @param {object} moduleDesc 属性描述
	         * @param {object} calendarProps 组件属性
	         */
	        value: function bindEvent(moduleDesc, calendarProps, functions) {
	
	            // 自定义选择事件
	            var slctLsn = moduleDesc.slctLsn;
	            if (slctLsn) {
	                var $slctLsn;
	                try {
	                    $slctLsn = new Function("module", "objFct", 'value', 'moment', slctLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.onSelect = $slctLsn;
	            }
	            calendarProps.onSelect = _SgiEventHandler.SgiEventHandler.calendarOnSelect.bind(this);
	
	            // 自定义面板切换事件
	            var pnlChgLsn = moduleDesc.pnlChgLsn;
	            if (pnlChgLsn) {
	                var $pnlChgLsn;
	                try {
	                    $pnlChgLsn = new Function("module", "objFct", 'value', 'moment', "mode", pnlChgLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.onPanelChange = $pnlChgLsn;
	            }
	            calendarProps.onPanelChange = _SgiEventHandler.SgiEventHandler.calendarOnPanelChange.bind(this);
	
	            // 自定义日期变化事件
	            var chgLsn = moduleDesc.chgLsn;
	            if (chgLsn) {
	                var $chgLsn;
	                try {
	                    $chgLsn = new Function("module", "objFct", 'value', 'moment', chgLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.onChange = $chgLsn;
	            }
	            calendarProps.onChange = _SgiEventHandler.SgiEventHandler.calendarOnChange.bind(this);
	        }
	    }, {
	        key: 'commonCellRender',
	
	
	        // onPanelChange(value, mode) {
	        //     tool.sgiLogger.log('value :', value);
	        //     tool.sgiLogger.log('mode :', mode);
	        // }
	
	        // getListData(value) {
	        //     let listData;
	        //     switch (value.date()) {
	        //         case 8:
	        //             listData = [
	        //                 { type: 'warning', content: 'This is warning event.' },
	        //                 { type: 'success', content: 'This is usual event.' },
	        //             ]; break;
	        //         case 10:
	        //             listData = [
	        //                 { type: 'warning', content: 'This is warning event.' },
	        //                 { type: 'success', content: 'This is usual event.' },
	        //                 { type: 'error', content: 'This is error event.' },
	        //             ]; break;
	        //         case 15:
	        //             listData = [
	        //                 { type: 'warning', content: 'This is warning event' },
	        //                 { type: 'success', content: 'This is very long usual event。。....' },
	        //                 { type: 'error', content: 'This is error event 1.' },
	        //                 { type: 'error', content: 'This is error event 2.' },
	        //                 { type: 'error', content: 'This is error event 3.' },
	        //                 { type: 'error', content: 'This is error event 4.' },
	        //             ]; break;
	        //         default:
	        //     }
	        //     return listData || [];
	        // }
	
	        // dateCellRender(value) {
	        //     const listData = this.getListData(value);
	        //     return (
	        //         <ul className="events">
	        //             {
	        //                 listData.map(item => (
	        //                     <li key={item.content}>
	        //                         <Badge status={item.type} text={item.content} />
	        //                     </li>
	        //                 ))
	        //             }
	        //         </ul>
	        //     );
	        // }
	
	        // getMonthData(value) {
	        //     if (value.month() === 8) {
	        //         return 1394;
	        //     }
	        // }
	
	        // monthCellRender(value) {
	        //     const num = this.getMonthData(value);
	        //     return num ? (
	        //         <div className="notes-month">
	        //             <section>{num}</section>
	        //             <span>Backlog number</span>
	        //         </div>
	        //     ) : null;
	        // }
	
	        value: function commonCellRender(type, date) {
	            if (!type || !date) return;
	
	            var functions = this.state.functions;
	
	            if (functions && functions[type]) {
	                var objFct = this.props.objFct;
	
	                var value = date.format("YYYY-MM-DD");
	                return functions[type](this, objFct, value, date);
	            }
	        }
	    }, {
	        key: 'getCellRender',
	        value: function getCellRender(type) {
	
	            if (this.props.type === "dnd") return;
	
	            var functions = this.state.functions;
	
	            if (functions && functions[type]) {
	                return this.commonCellRender.bind(this, type);
	            }
	        }
	    }, {
	        key: 'getValue',
	        value: function getValue(parameters) {
	            if (!parameters || !(typeof parameters === 'undefined' ? 'undefined' : _typeof(parameters)) === "object" || Array.isArray(parameters)) {
	                return this.state.value.format("YYYY-MM-DD");
	            } else if (parameters.type === "moment") {
	                return this.state.value;
	            } else if (parameters.format) {
	                return this.state.value.format(parameters.format);
	            } else {
	                return this.state.value.format("YYYY-MM-DD");
	            }
	        }
	    }, {
	        key: 'getMoment',
	        value: function getMoment() {
	            return this.state.value;
	        }
	    }, {
	        key: 'setValue',
	        value: function setValue(value, parameters) {
	            if (parameters && parameters.type === "moment") {
	                this.setState({ value: value });
	            } else {
	                this.setState({ value: (0, _moment2.default)(value) });
	            }
	        }
	    }, {
	        key: 'setMoment',
	        value: function setMoment(moment) {
	            this.setState({ value: moment });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiCalendar;
	}(_react2.default.Component);
	//给类添加公共方法
	// Object.assign(SgiCalendar.prototype, sgiCtnBaseFun);
	
	
	SgiCalendar.defaultProps = {};
	SgiCalendar.propTypes = {};
	exports.SgiCalendar = SgiCalendar;
	exports.default = SgiCalendar;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiCard = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import style from './Sgicard.css'
	
	
	var SgiCard = function (_React$Component) {
	    _inherits(SgiCard, _React$Component);
	
	    //这个暂时不好用 以后在处理
	    function SgiCard(props) {
	        _classCallCheck(this, SgiCard);
	
	        var _this = _possibleConstructorReturn(this, (SgiCard.__proto__ || Object.getPrototypeOf(SgiCard)).call(this, props));
	
	        _this.fitTabExtraContent = function (moduleDesc, CardItems, objFct, type) {
	            var me = this;
	            // tabBarExtraContent
	        };
	
	        _this.fitCardItems = function (moduleDesc, CardItems, CardItemsIndex, objFct, type) {
	            var _this2 = this;
	
	            var me = this;
	
	            var cldSet = moduleDesc.cldSet;
	            if (cldSet && cldSet.length && cldSet.length > 0) {
	                var isAsyn = moduleDesc.isAsyn;
	                if (isAsyn) {
	                    // 异步加载其他面板，仅加载初始/第一个面板
	                    var activeCardKey = this.state.activeCardKey;
	
	                    if (activeCardKey) {
	                        // 加载指定面板
	                        cldSet.some(function (item, index) {
	                            var cId = (0, _SgiCommon.getConstByKey)(_this2, item.cId);
	                            if (cId === activeCardKey) {
	                                CardItems.push((0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type, { setActiveWV: _this2.setActiveItem }));
	                                CardItemsIndex[cId] = CardItems.length - 1;
	                                return true;
	                            }
	                        });
	                    } else {
	                        // 加载第一个面板 //不指定页面则不再进行初始加载，因为没有用
	                        // const first = cldSet[0];
	                        // CardItems.push(convertModuleByGuid(me, first, null, objFct, type, { setActiveWV: this.setActiveItem }));
	                        // CardItemsIndex["0"] = 0;
	                    }
	                } else {
	                    // 同步加载所有面板
	                    cldSet.forEach(function (item, index) {
	                        // let { cId } = item;
	                        var cId = (0, _SgiCommon.getConstByKey)(_this2, item.cId);
	                        if (index == 0 && !_this2.state.activeCardKey) {
	                            _this2.state.activeCardKey = cId ? cId : index;
	                        }
	                        // item.isCardPanel = true; //如果是重叠下的panel特殊处理
	                        if (cId) {
	                            CardItemsIndex[cId] = index;
	                        } else {
	                            CardItemsIndex[index + ""] = index;
	                        }
	                        CardItems.push((0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type, { setActiveWV: _this2.setActiveItem }));
	                    });
	                }
	            }
	        };
	
	        _this.setActiveItem = function (activeCardKey, didMountCallback) {
	            _this.state.activeCardKey = activeCardKey;
	            _this.state.allDidMountCallback[activeCardKey] = didMountCallback;
	            _this.setState({});
	        };
	
	        _this.getActiveItem = function () {
	            return _this.state.activeCardKey;
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var _this3 = this;
	
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded || this.props.type == 'dnd') {
	                //组装属性
	                this.Card_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            var _state = this.state,
	                isAsyn = _state.isAsyn,
	                CardItems = _state.CardItems,
	                CardItemsIndex = _state.CardItemsIndex,
	                activeCardKey = _state.activeCardKey,
	                allDidMountCallback = _state.allDidMountCallback;
	
	            // 是否需要异步加载页面
	
	            if (isAsyn && isNaN(CardItemsIndex[activeCardKey])) {
	                // 异步加载面板
	                var cldSet = moduleDesc.cldSet || [];
	                var me = this;
	                cldSet.some(function (item, index) {
	                    var cId = (0, _SgiCommon.getConstByKey)(_this3, item.cId);
	                    if (cId === activeCardKey) {
	                        // 创建组件
	                        var son = (0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type, { setActiveWV: _this3.setActiveItem, didMountCallback: allDidMountCallback[activeCardKey] });
	                        CardItems.push(son);
	                        CardItemsIndex[cId] = CardItems.length - 1;
	                        // 注册组件
	                        ComponentManager.set(objFct.getUID(), cId, son);
	                        // 返回
	                        return true;
	                    }
	                });
	            }
	
	            //根据当前激活的面板，将另外2个面板设置不可见
	            var showItems = [];
	            var activeIndex = CardItemsIndex[activeCardKey];
	            CardItems.forEach(function (item, index) {
	                if (index === activeIndex) {
	                    showItems.push(_react2.default.createElement(
	                        'div',
	                        { style: { height: "100%", width: '100%' } },
	                        item
	                    ));
	                } else {
	                    showItems.push(_react2.default.createElement(
	                        'div',
	                        { style: { height: "100%", width: '100%', display: "none" } },
	                        item
	                    ));
	                }
	            });
	
	            // 通用渲染前处理，添加自定义样式等
	            this.renderBeforeReturn(this.state.CardProps);
	
	            return _react2.default.createElement(
	                _antd.Card,
	                this.state.CardProps,
	                showItems
	            );
	        };
	
	        _this.AddAttribute = function (moduleDesc, CardProps) {
	            //初始化激活的面板
	            var atvTab = (0, _SgiCommon.getConstByKey)(this, moduleDesc.atvTab);
	            if (atvTab) {
	                this.state.activeCardKey = atvTab;
	            }
	
	            var isBrdr = moduleDesc.isBrdr; //是否有边框
	            if (isBrdr) {
	                CardProps.bordered = true;
	            } else {
	                CardProps.bordered = false;
	            }
	
	            if (moduleDesc.te || moduleDesc.teid) {
	                //避免不必要的执行getTRByPrm()方法
	                var title = _Resource.Resource.getTRByPrm(moduleDesc).te; //是否有标题
	                if (title) CardProps.title = title;
	            }
	
	            var cId = moduleDesc.cId; //cid 唯一标示
	            if (cId) CardProps.id = (0, _SgiCommon.getConstByKey)(this, cId);
	
	            var ctlW = moduleDesc.ctlW; //form宽度
	            if (ctlW) CardProps.style.width = ctlW;
	
	            var ctlH = moduleDesc.ctlH; //form高度
	            if (ctlH) CardProps.style.height = ctlH;
	
	            var mgn = moduleDesc.mgn; //form外边距
	            if (mgn) CardProps.bodyStyle.margin = mgn;
	            var pad = moduleDesc.pad; //form内边距
	            if (pad) CardProps.bodyStyle.padding = pad;
	
	            var isHdn = moduleDesc.isHdn; //form是否隐藏
	            if (isHdn) CardProps.style.display = "none";
	
	            CardProps.hoverable = false; //鼠标滑过 是否浮动，默认现在不浮动
	
	            var isScl = moduleDesc.isScl; //滚动
	            if (isScl) {
	                CardProps.style.overflow = "auto";
	            } else {
	                CardProps.style.overflow = undefined;
	            }
	
	            // 是否异步加载其余页面
	            this.state.isAsyn = !!moduleDesc.isAsyn;
	        };
	
	        _this.state = {
	            itemPanelType: "Card", //区分是tab还是折叠面板的 普通面板整合tabpane和折叠panel
	            CardProps: { style: { height: "100%", width: "100%" }, bodyStyle: { height: "100%", width: "100%" } }, //form属性
	            CardItems: [], //card下控件数组
	            CardItemsIndex: {},
	            tabBarExtraContent: {},
	            activeCardKey: '',
	            allDidMountCallback: {} //用于存放子组件自定义渲染后事件
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建form
	     * @param {父组件} parentModule
	     * @param {描述} moduleDesc
	     * @param {对象工厂} objFct
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiCard, [{
	        key: 'Card_mk',
	        value: function Card_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.CardItems = []; //再次渲染的时候清空
	            this.state.CardItemsIndex = {};
	
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.CardProps);
	            //转换form公共属性
	            //addCtnCommonAttribute(this, moduleDesc, this.state.CardProps);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.formProps, type);
	            //组装form表单下的控件信息
	            if (type !== "dnd") this.fitCardItems(moduleDesc, this.state.CardItems, this.state.CardItemsIndex, objFct, type);
	            //组装tabBarExtraContent下的控件
	            this.fitTabExtraContent(moduleDesc, this.state.tabBarExtraContent, objFct, type);
	        }
	
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc
	         * @param {*} formProps
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, formProps, type) {
	            //拖拽模式 不生成事件
	            if (type == 'dnd') {
	                return;
	            }
	        }
	
	        /**
	         * 根据描述组装子 操作按钮
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	
	        /**
	        * 根据描述组装子对象
	        * @param {描述信息} moduleDesc
	        * @param {属性} formProps
	        */
	
	        /**
	         * 获取当前激活面板的组件标识
	         * @return {[type]} [description]
	         */
	
	
	        //渲染并返回一个虚拟DOM
	
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	    }]);
	
	    return SgiCard;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiCard.defaultProps = {};
	SgiCard.propTypes = {};
	Object.assign(SgiCard.prototype, _SgiCtnComm.sgiCtnBaseFun);
	exports.SgiCard = SgiCard;
	exports.default = SgiCard;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCodemirror = __webpack_require__(878);
	
	__webpack_require__(890);
	
	__webpack_require__(679);
	
	__webpack_require__(678);
	
	__webpack_require__(887);
	
	__webpack_require__(673);
	
	__webpack_require__(672);
	
	__webpack_require__(891);
	
	__webpack_require__(677);
	
	__webpack_require__(667);
	
	__webpack_require__(666);
	
	__webpack_require__(158);
	
	__webpack_require__(886);
	
	__webpack_require__(247);
	
	__webpack_require__(671);
	
	__webpack_require__(669);
	
	__webpack_require__(670);
	
	__webpack_require__(158);
	
	__webpack_require__(668);
	
	__webpack_require__(675);
	
	__webpack_require__(888);
	
	__webpack_require__(674);
	
	__webpack_require__(248);
	
	__webpack_require__(249);
	
	__webpack_require__(889);
	
	__webpack_require__(159);
	
	__webpack_require__(676);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiCtlComponent2 = __webpack_require__(161);
	
	var _SgiCtlComponent3 = _interopRequireDefault(_SgiCtlComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// 导入样式
	
	// 导入语言
	
	// 导入ctrl+空格提示
	
	// 导入提示语言类型
	
	// 导入theme主题
	// import 'codemirror/theme/ambiance.css';
	
	
	var SgiCodeMirror = function (_SgiCtlComponent) {
		_inherits(SgiCodeMirror, _SgiCtlComponent);
	
		function SgiCodeMirror(props) {
			_classCallCheck(this, SgiCodeMirror);
	
			var _this = _possibleConstructorReturn(this, (SgiCodeMirror.__proto__ || Object.getPrototypeOf(SgiCodeMirror)).call(this, props));
	
			_this.__render = function () {
				return _react2.default.createElement(_reactCodemirror.Controlled, _this.state._props);
			};
	
			_this.state = _extends({}, _this.state, {
				_class: ["sgi-codemirror"],
				functions: {}
			});
			return _this;
		}
	
		_createClass(SgiCodeMirror, [{
			key: '__AddAttribute',
			value: function __AddAttribute() {
				var _props2 = this.props,
				    parentModule = _props2.parentModule,
				    moduleDesc = _props2.moduleDesc,
				    bdInst = _props2.bdInst,
				    objFct = _props2.objFct,
				    type = _props2.type;
				var _state = this.state,
				    _props = _state._props,
				    _class = _state._class;
	
	
				var options = _props.options = {
					mode: 'javascript', //语言
					theme: 'monokai', //主题
					keyMap: 'sublime',
					lineNumbers: true, //显示行号  
					extraKeys: { "Ctrl": "autocomplete" }, //自动提示配置  
					lineWrapping: true, //代码折叠
					foldGutter: true,
					// showHint: true,
					// highlightSelectionMatches: true,
					highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
					// extraKeys: { "Ctrl-/": "autocomplete" },
					hintOptions: { schemaInfo: [] },
					lint: true,
					gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", 'CodeMirror.hint.javascript', 'CodeMirror.hint.coffeescript', 'CodeMirror-lint-markers'],
					matchBrackets: true, //括号匹配
					autoCloseBrackets: true, //关闭
					tabSize: 4
				};
	
				if (!moduleDesc) return;
				if (moduleDesc.cstmOptions) {
					var cstmOptions = eval('(' + moduleDesc.cstmOptions + ')');
					if (cstmOptions) {
						Object.assign(options, cstmOptions);
					}
				}
				// if (moduleDesc.mode) options.mode = moduleDesc.mode;
				// if (moduleDesc.lineSeparator) options.lineSeparator = moduleDesc.lineSeparator;
				// if (moduleDesc.theme) options.theme = moduleDesc.theme;
				// if (moduleDesc.indentUnit) options.indentUnit = moduleDesc.indentUnit;
				// if (moduleDesc.smartIndent) options.smartIndent = moduleDesc.smartIndent;
				// if (moduleDesc.tabSize) options.tabSize = moduleDesc.tabSize;
				// if (moduleDesc.indentWithTabs) options.indentWithTabs = moduleDesc.indentWithTabs;
				// if (moduleDesc.electricChars) options.electricChars = moduleDesc.electricChars;
				// if (moduleDesc.specialChars) options.specialChars = moduleDesc.specialChars;
				// if (moduleDesc.specialCharPlaceholder) options.specialCharPlaceholder = moduleDesc.specialCharPlaceholder;
				// if (moduleDesc.direction) options.direction = moduleDesc.direction;
				// if (moduleDesc.rtlMoveVisually) options.rtlMoveVisually = moduleDesc.rtlMoveVisually;
				// if (moduleDesc.keyMap) options.keyMap = moduleDesc.keyMap;
				// if (moduleDesc.extraKeys) options.extraKeys = moduleDesc.extraKeys;
				// .
				// .
				// .
				// 太多了，写不过来了
			}
		}, {
			key: '__bindEvent',
			value: function __bindEvent() {
				var _this2 = this;
	
				var _props3 = this.props,
				    parentModule = _props3.parentModule,
				    _props3$moduleDesc = _props3.moduleDesc,
				    moduleDesc = _props3$moduleDesc === undefined ? {} : _props3$moduleDesc,
				    bdInst = _props3.bdInst,
				    objFct = _props3.objFct,
				    type = _props3.type;
				var _state2 = this.state,
				    _props = _state2._props,
				    _class = _state2._class;
				var functions = this.data.functions;
	
	
				_props.onBeforeChange = function (editor, data, value) {
					_props.value = value;
					_this2.setState({});
				};
	
				//onchange
				var chgLsn = moduleDesc.chgLsn;
				if (chgLsn) {
					var $chgLsn;
					try {
						$chgLsn = new Function("module", "objFct", "value", "data", "editor", chgLsn);
						// $chgLsn = new Function("module", "objFct", "record", "nv", "nt", "itemData", "extra", chgLsn);
						// $chgLsn = new Function("module", "objFct", "record", "nv", "data", "editor", chgLsn);
					} catch (error) {
						_sgiLogger.sgiLogger.eventErr(error);
					}
					functions.onChange = $chgLsn;
					// _props.onChange = (editor, data, value) => {
					// 	if ($chgLsn) $chgLsn(this, objFct, value, data, editor);
					// };
				}
				_props.onChange = _SgiEventHandler.SgiEventHandler.onCodeMirrorChange.bind(this);
				// _props.onChange = SgiEventHandler.onChange.bind(this, this);
			}
		}]);
	
		return SgiCodeMirror;
	}(_SgiCtlComponent3.default);
	
	exports.default = SgiCodeMirror;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiCol = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCompComm = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const FormItem = Form.Item;
	
	var SgiCol = function (_React$Component) {
	    _inherits(SgiCol, _React$Component);
	
	    function SgiCol(props) {
	        _classCallCheck(this, SgiCol);
	
	        var _this = _possibleConstructorReturn(this, (SgiCol.__proto__ || Object.getPrototypeOf(SgiCol)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var _this$props$moduleDes = _this.props.moduleDesc,
	            offset = _this$props$moduleDes.offset,
	            order = _this$props$moduleDes.order,
	            span = _this$props$moduleDes.span,
	            ctlW = _this$props$moduleDes.ctlW,
	            ctlH = _this$props$moduleDes.ctlH,
	            style = _this$props$moduleDes.style;
	
	        _this.state = {
	            // style: style,
	            // offset: offset,
	            // order: order,
	            // span: span,
	            colProps: {},
	            loading: false
	        };
	        /**
	         * offset	栅格左侧的间隔格数，间隔内不可以有栅格
	         * order	栅格顺序，flex 布局模式下有效
	         * span	栅格占位格数，为 0 时相当于 display: none
	         */
	        return _this;
	    }
	
	    /**
	    * 根据描述创建form
	    * @param {父组件} parentModule 
	    * @param {描述} moduleDesc       
	    * @param {对象工厂} objFct 
	    * @param {make类型} type 
	    */
	
	
	    _createClass(SgiCol, [{
	        key: 'row_mk',
	        value: function row_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	            var sonUIItems = []; //form下控件数组
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.colProps);
	            //组装form表单下的控件信息
	            if (type !== "dnd") this.fitSonUIItems(moduleDesc, sonUIItems, bdInst, objFct, type);
	
	            this.sonUIItems = sonUIItems;
	        }
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formProps 
	         */
	
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiCol;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.AddAttribute = function (moduleDesc, colProps) {
	        var offset = moduleDesc.offset,
	            order = moduleDesc.order,
	            span = moduleDesc.span,
	            ctlW = moduleDesc.ctlW,
	            ctlH = moduleDesc.ctlH,
	            style = moduleDesc.style;
	
	        colProps.style = Object.assign({}, style); //不动描述里的style
	        colProps.offset = offset;
	        colProps.order = order;
	        colProps.span = span;
	
	        // style优先级高
	        if (!style || style.width === undefined) {
	            if (ctlW) {
	                colProps.style.width = ctlW;
	            } else {
	                colProps.style.width = undefined;
	            }
	        }
	        // style优先级高
	        if (!style || style.height === undefined) {
	            if (ctlH) {
	                colProps.style.height = ctlH;
	            } else {
	                colProps.style.height = undefined;
	            }
	        }
	    };
	
	    this.fitSonUIItems = function (moduleDesc, sonUIItems, bdInst, objFct, type) {
	        var me = this;
	        //form下的子节点添加到form组件中
	        var cldSet = moduleDesc.cldSet;
	        if (cldSet && cldSet.length && cldSet.length > 0) {
	            cldSet.forEach(function (item, index) {
	                sonUIItems.push((0, _SgiCompComm.convertModuleByGuid)(me, item, bdInst, objFct, type));
	            });
	        }
	    };
	
	    this.refresh = function () {
	        _this2.loaded = false;
	        _this2.setState({ loading: false });
	    };
	
	    this.render = function () {
	        if (!this.loaded) {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                bdInst = _props.bdInst,
	                objFct = _props.objFct,
	                type = _props.type;
	            //组装属性
	
	            this.row_mk(parentModule, moduleDesc, bdInst, objFct, type);
	            this.loaded = true;
	        }
	        return _react2.default.createElement(
	            _antd.Col,
	            this.state.colProps,
	            this.sonUIItems,
	            this.props.children
	        );
	    };
	};
	
	exports.SgiCol = SgiCol;
	exports.default = SgiCol;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SgiCollapse = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	var Panel = _antd.Collapse.Panel;
	
	// import { addCollapseCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun'
	
	var SgiCollapse = function (_React$Component) {
		_inherits(SgiCollapse, _React$Component);
	
		//这个暂时不好用 以后在处理
		function SgiCollapse(props) {
			_classCallCheck(this, SgiCollapse);
	
			var _this = _possibleConstructorReturn(this, (SgiCollapse.__proto__ || Object.getPrototypeOf(SgiCollapse)).call(this, props));
	
			_this.fitTabsItems = function (moduleDesc, tabsItems, objFct, type) {
				var _this2 = this;
	
				var me = this;
	
				var cldSet = moduleDesc.cldSet;
				if (cldSet && cldSet.length && cldSet.length > 0) {
					var cosPane = void 0;
					cldSet.forEach(function (item, index) {
						var te = item.te,
						    isDis = item.isDis;
	
						var cId = (0, _SgiCommon.getConstByKey)(_this2, item.cId);
						cosPane = { forceRender: true }; //默认全部加载
						if (!cId) {
							cId = (0, _sgiCommon.uuid)(8);
							item.cId = cId;
						}
						if (te) cosPane.header = te;
						if (cId) cosPane.key = cId;
						if (isDis) cosPane.disabled = isDis;
						tabsItems.push(_react2.default.createElement(
							Panel,
							cosPane,
							(0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type, { setActiveWV: _this2.setActiveItem })
						));
					});
				}
			};
	
			_this.setActiveItem = function (key) {
				_this.setState({ activeKey: key });
			};
	
			_this.getActiveItem = function () {
				return _this.state.activeKey;
			};
	
			_this.refresh = function () {
				_this.loaded = false;
				_this.setState({ loading: false });
			};
	
			_this.render = function () {
				if (!this.loaded || this.props.type == 'dnd') {
					var _props = this.props,
					    parentModule = _props.parentModule,
					    moduleDesc = _props.moduleDesc,
					    objFct = _props.objFct,
					    type = _props.type;
					//组装属性
	
					this.collapse_mk(parentModule, moduleDesc, objFct, type);
					this.loaded = true;
				}
	
				// 通用渲染前处理，添加自定义样式等
				this.renderBeforeReturn(this.state.collapseProps);
	
				return _react2.default.createElement(
					_antd.Collapse,
					_extends({}, this.state.collapseProps, { activeKey: this.state.activeKey }),
					this.state.collapseItems
				);
			};
	
			_this.AddAttribute = function (moduleDesc, tabsProps, collp) {
				//初始化激活的面板
				var atvTab = (0, _SgiCommon.getConstByKey)(this, moduleDesc.atvTab);
				if (atvTab) {
					tabsProps.defaultActiveKey = atvTab;
					if (!collp.state.activeKey) {
						collp.state.activeKey = atvTab;
					}
				}
	
				tabsProps.accordion = true; //先默认这个 以后再去实现其他的属性
			};
	
			_this.state = {
				itemPanelType: "cos", //区分是tab还是折叠面板的 普通面板整合tabpane和折叠panel
				collapseProps: { style: { height: "100%", width: "100%" } }, //form属性
				collapseItems: [], //form下控件数组
				functions: {},
				loading: false,
				activeKey: undefined
			};
			return _this;
		}
	
		/**
	  * 根据描述创建form
	  * @param {父组件} parentModule
	  * @param {描述} moduleDesc
	  * @param {对象工厂} objFct
	  * @param {make类型} type
	  */
		// 注意这里有分号
	
	
		_createClass(SgiCollapse, [{
			key: 'collapse_mk',
			value: function collapse_mk(parentModule, moduleDesc, objFct, type) {
				//获取需要展示的数据信息
				if (!moduleDesc) {
					return;
				}
				this.state.collapseProps = { style: {} }; //form属性
				this.state.collapseItems = []; //form下控件数组
	
				//转换基础属性
				this.AddAttribute(moduleDesc, this.state.collapseProps, this);
				//转换form公共属性
				(0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.collapseProps);
				//设置布局
				//this.setFormCtlLayout(moduleDesc, formProps);
				//绑定事件
				this.bindEvent(parentModule, moduleDesc, this.state.collapseProps, this.state.functions, type);
				//组装form表单下的控件信息
				if (type !== "dnd") this.fitTabsItems(moduleDesc, this.state.collapseItems, objFct, type);
				//添加拖拽布局信息 根据type类型
				// addCollapseCtlDndInfo(this, this.state.collapseItems, this.state.collapseProps, type);
				var addCollapseCtlDndInfo = this.props.addCollapseCtlDndInfo; //显示/开发分离，这部分拖拽开发功能使用props传入
				if (addCollapseCtlDndInfo && typeof addCollapseCtlDndInfo === "function") {
					addCollapseCtlDndInfo(this, this.state.collapseItems, this.state.collapseProps, this.props.type);
				}
			}
	
			/**
	   * 绑定事件
	   * @param {*} moduleDesc
	   * @param {*} formProps
	   */
	
		}, {
			key: 'bindEvent',
			value: function bindEvent(parentModule, moduleDesc, collapseProps, functions, type) {
				//拖拽模式 不生成事件
				tool.sgiLogger.log("parentModule", parentModule);
				var expandLsn = moduleDesc.epdLsn; // 面板的展开监听器
				// var collapseLsn = wvJson.clpLsn;// 面板的折叠监听器
				if (expandLsn && type != 'dnd') {
					var $expandLsn = new Function("module", "objFct", "key", expandLsn);
					functions.expandLsn = $expandLsn;
				}
				collapseProps.onChange = _SgiEventHandler.SgiEventHandler.expd.bind(this);
				// if (collapseLsn) {
				//     var $expandLsn = new Function("objFct", "ctn", collapseLsn);
				//     functions.collapseLsn = $collapseLsn;
				//     formProps.onChange = SgiEventHandler.clp.bind(this);
				// }
			}
	
			/**
	   * 根据描述组装子对象
	   * @param {描述信息} moduleDesc
	   * @param {属性} formProps
	   */
	
			/**
	   * 获取当前激活面板的组件标识
	   * @return {[type]} [description]
	   */
	
	
			//渲染并返回一个虚拟DOM
	
	
			/**
	   * 属性转换
	   * @param {描述信息} moduleDesc
	   * @param {属性} formProps
	   */
	
		}]);
	
		return SgiCollapse;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiCollapse.defaultProps = {};
	SgiCollapse.propTypes = {};
	Object.assign(SgiCollapse.prototype, _SgiCtnComm.sgiCtnBaseFun);
	
	exports.SgiCollapse = SgiCollapse;
	exports.default = SgiCollapse;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _echartsForReact = __webpack_require__(796);
	
	var _echartsForReact2 = _interopRequireDefault(_echartsForReact);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultGetOption = function defaultGetOption() {
	    return {
	        title: {
	            text: 'xxx图表',
	            x: 'center'
	        },
	        tooltip: {
	            trigger: 'axis'
	        },
	        grid: {
	            left: 10,
	            right: 100,
	            top: 10,
	            bottom: 10,
	            // height:"50%",
	            containLabel: true
	        },
	        legend: {
	            // orient: 'horizontal',
	            // align: 'right',
	            right: 'right',
	            top: 30,
	            data: [].map(function (d) {
	                return d.name;
	            })
	        },
	        calculable: true,
	        xAxis: [{
	            type: 'category',
	            data: ['1', '2', '3', '4', '5'],
	            splitLine: {
	                show: true
	            }
	        }],
	        yAxis: [{
	            type: 'value'
	        }],
	        series: []
	    };
	};
	
	var SgiCommEcharts = function (_React$Component) {
	    _inherits(SgiCommEcharts, _React$Component);
	
	    // 注意这里有分号
	
	    //这个暂时不好用 以后在处理
	    function SgiCommEcharts(props) {
	        _classCallCheck(this, SgiCommEcharts);
	
	        var _this = _possibleConstructorReturn(this, (SgiCommEcharts.__proto__ || Object.getPrototypeOf(SgiCommEcharts)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.state.uuid = (0, _sgiCommon.uuid)(8);
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded) {
	                //组装属性
	                this.echarts_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            return _react2.default.createElement(_echartsForReact2.default, _extends({
	                key: this.state.uuid
	            }, this.state.echartsProps, {
	                option: type === "dnd" ? defaultGetOption() : this.state.getOption(this, this.state.data, objFct)
	            }));
	        };
	
	        _this.state = {
	            loading: false,
	            uuid: (0, _sgiCommon.uuid)(8),
	            data: _this.props.data || [],
	            echartsProps: { style: { width: "100%", height: "100%" } },
	            option: {},
	            getOption: defaultGetOption
	        };
	        return _this;
	    }
	
	    /**
	     * maker构建
	     * @param {object} parentModule 
	     * @param {object} moduleDesc       
	     * @param {ObjFactory} objFct 
	     * @param {string} type 
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiCommEcharts, [{
	        key: 'echarts_mk',
	        value: function echarts_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            // 转换公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.echartsProps);
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.echartsProps, this.state.option, parentModule, objFct, type);
	        }
	
	        /**
	         * 属性转换
	         * @param {object} moduleDesc 
	         * @param {object} echartsProps 
	         * @param {object} option 
	         * @param {object} parentModule 
	         * @param {ObjFactory} objFct 
	         * @param {string} type 
	         */
	
	    }, {
	        key: 'AddAttribute',
	        value: function AddAttribute(moduleDesc, echartsProps, option, parentModule, objFct, type) {
	
	            // var text = moduleDesc.te;//公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
	            // if (text) echartsTitleProps.title = text;
	
	            // var ttlAlgn = moduleDesc.ttlAlgn; //form标题对齐方式
	            // if (ttlAlgn) echartsTitleProps.style['text-align'] = ttlAlgn;
	
	            // var isTtl = moduleDesc.isTtl; //form是否显示标题
	            // if (!isTtl) {
	            //     echartsTitleProps.style.display = "none";
	            // } else {
	            //     echartsTitleProps.style.display = undefined;
	            // }
	            // this.state.isTtl = !!isTtl;
	
	            // // 是否card样式
	            // const isCard = moduleDesc.isCard;
	            // this.state.isCard = !!isCard;
	
	            // var isScl = moduleDesc.isScl; //form是否可以滚动??没实现
	            // //if(isScl) echartsBodyProps.style.display
	
	            // if (type === 'tabs' || type == 'cos') {
	            //     echartsTitleProps.style.display = "none";
	            // }
	
	            // 取data
	            var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
	            this.state.insName = bdInst;
	            if (bdInst && objFct) {
	                this.state.data = objFct.get(bdInst) || [];
	            }
	
	            // 自定义option
	            var getOption = moduleDesc.option;
	            var $getOption = void 0;
	            if (getOption) {
	                try {
	                    $getOption = new Function("module", "data", "objFct", getOption);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                this.state.getOption = $getOption;
	            }
	        }
	    }, {
	        key: 'refreshByData',
	        value: function refreshByData(data) {
	            data = data || [];
	            this.setState({ data: data, uuid: (0, _sgiCommon.uuid)(8) });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiCommEcharts;
	}(_react2.default.Component);
	
	SgiCommEcharts.defaultProps = {};
	SgiCommEcharts.propTypes = {};
	exports.default = SgiCommEcharts;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiEditor = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _reactUmeditor = __webpack_require__(1308);
	
	var _reactUmeditor2 = _interopRequireDefault(_reactUmeditor);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	__webpack_require__(1996);
	
	var SgiEditor = function (_React$Component) {
	    _inherits(SgiEditor, _React$Component);
	
	    // 注意这里有分号
	
	
	    function SgiEditor(props) {
	        _classCallCheck(this, SgiEditor);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiEditor.__proto__ || Object.getPrototypeOf(SgiEditor)).call(this, props));
	
	        _this.initState();
	        return _this;
	    }
	
	    /**
	    * 根据描述创建文本框
	    * @param {父组件} parentModule 
	    * @param {组件描述} moduleDesc 
	    * @param {绑定实例ID} bdInst 
	    * @param {对象工厂} objFct 
	    * @param {make类型} type 
	    */
	    // 注意这里有分号
	
	
	    _createClass(SgiEditor, [{
	        key: 'fieldCtl_mk',
	        value: function fieldCtl_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息       
	            if (!moduleDesc) {
	                return;
	            }
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	            //添加拖拽布局信息 根据type类型
	            // addFormCtlDndInfo(this, this.state.formItemProps, this.state.inputprops, type);
	        }
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItemProps, inputprops) {
	            // // 组件宽度
	            // var width = moduleDesc.ctlW;
	            // if (width) {
	            //     this.state.wrapperStyle = { ...this.state.wrapperStyle, width: (width * 100 / 24 + '%') };
	            // } else if (width == "") {
	            //     this.state.wrapperStyle = { ...this.state.wrapperStyle, width: '100%' };
	            // }
	
	            // // 组件高度
	            // var height = moduleDesc.ctlH;
	            // if (height) {
	            //     this.state.wrapperStyle = { ...this.state.wrapperStyle, height: height + 'px' };
	            // } else if (height == "") {
	            //     this.state.wrapperStyle = { ...this.state.wrapperStyle, height: '100%' };
	            // }
	
	            // id
	            var wrapperId = (0, _SgiCommon.getConstByKey)(this, moduleDesc.cId);
	            if (wrapperId) this.state.wrapperId = wrapperId;
	
	            // // 修改事件
	            // var onContentStateChange = moduleDesc.chgLsn;
	            // if (onContentStateChange) {
	            //     var $chg = new Function("module", "objFct", "record", "index", onContentStateChange);
	            //     this.state.onContentStateChange = $chg;
	            // }
	
	            // // 进入事件
	            // var onFocus = moduleDesc.inLsn;
	            // if (onFocus) {
	            //     var $in = new Function("module", "objFct", "record", "index", onFocus);
	            //     this.state.onFocus = $in;
	            // }
	
	            // // 离开事件
	            // var onBlur = moduleDesc.lveLsn;
	            // if (onBlur) {
	            //     var $lve = new Function("module", "objFct", "record", "index", onBlur);
	            //     this.state.onBlur = $lve;
	            // }
	
	            // 文件上传地址
	            var fileUploadUrl = moduleDesc.fileUploadUrl;
	            if (fileUploadUrl) this.state.fileUploadUrl = fileUploadUrl;
	
	            // 隐藏工具栏
	            var toolbarHidden = moduleDesc.toolbarHidden;
	            if (toolbarHidden) this.state.toolbarHidden = toolbarHidden;
	        }
	    }, {
	        key: 'getIcons',
	        value: function getIcons() {
	            if (this.state.toolbarHidden) {
	                return [];
	            }
	            return ["source | undo redo | bold italic underline strikethrough fontborder | ", "paragraph fontfamily fontsize | superscript subscript | ", "forecolor backcolor | removeformat | insertorderedlist insertunorderedlist | selectall | ", "cleardoc  | indent outdent | justifyleft justifycenter justifyright | touppercase tolowercase | ", "horizontal date time  | image formula spechars | inserttable"];
	        }
	    }, {
	        key: 'getPlugins',
	        value: function getPlugins() {
	            var plugins = {
	                image: {
	                    uploader: {
	                        url: this.state.fileUploadUrl || sgiConfig.fileAction,
	                        // url: "https://www.egssoft.com.cn:8895/fileserver/uploadFile",
	                        name: "file",
	                        filter: function filter(res) {
	                            return res.fileDownloadUri;
	                        }
	                    }
	                }
	            };
	            return plugins;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.fieldCtl_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            var icons = this.getIcons();
	            var plugins = this.getPlugins();
	
	            //formitem会变editor的样式，导致显示错乱，特修改会原属性
	            this.state.inputprops.style["line-height"] = "22px";
	
	            return _react2.default.createElement(
	                FormItem,
	                this.state.formItemProps,
	                _react2.default.createElement(_reactUmeditor2.default, _extends({ icons: icons, plugins: plugins }, this.state.inputprops, { readOnly: true }))
	            );
	        }
	    }]);
	
	    return SgiEditor;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiEditor.defaultProps = {};
	SgiEditor.propTypes = {};
	Object.assign(SgiEditor.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	exports.SgiEditor = SgiEditor;
	exports.default = SgiEditor;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiForm = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _Resource = __webpack_require__(67);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiPanel = __webpack_require__(444);
	
	var _SgiPanel2 = _interopRequireDefault(_SgiPanel);
	
	var _SgiCompConstant = __webpack_require__(107);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { text_mk } from './formCtlMK/SgiTextMaker';
	
	
	var FormItem = _antd.Form.Item;
	
	var SgiForm = function (_React$Component) {
	    _inherits(SgiForm, _React$Component);
	
	    // 注意这里有分号
	
	    //这个暂时不好用 以后在处理
	    function SgiForm(props) {
	        _classCallCheck(this, SgiForm);
	
	        var _this = _possibleConstructorReturn(this, (SgiForm.__proto__ || Object.getPrototypeOf(SgiForm)).call(this, props));
	
	        _this.fitFormItems = function (moduleDesc, formItems, toolbarItems, toolbarBottomItems) {
	            var _this2 = this;
	
	            var me = this;
	
	            var _props = this.props,
	                objFct = _props.objFct,
	                type = _props.type;
	
	            var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
	            if (bdInst && objFct && !objFct.get(bdInst)) {
	                objFct.set(bdInst, {});
	            }
	
	            //查看是否绑定了DV，如果绑定了DV，获取DV信息，DV下的数据绑定到当前form下
	            var bdDvId = moduleDesc.bdDvId;
	            if (bdDvId) {
	                //暂时先不处理
	                var dvs = bdDvId.split(",");
	                dvs.forEach(function (item, index) {
	                    var dvJson = _PrmFactory.PrmFactory.getPrm(item);
	                    _this2.setDVItems(dvJson, formItems, bdInst);
	                });
	            }
	
	            //老开发系统遗留，老系统form作为布局控件，现在临时实现垂直布局，和水平布局
	            //这个方法临时，以后重新开发的新系统可能不用
	            this.adaptLayout(moduleDesc);
	
	            //form下的子节点添加到form组件中
	            var cldSet = moduleDesc.cldSet;
	            if (cldSet && cldSet.length && cldSet.length > 0) {
	                this.setFormCtlItems(cldSet, formItems, toolbarItems, toolbarBottomItems, bdInst);
	            }
	        };
	
	        _this.setFormCtlItems = function (sonitems, formItems, toolbarItems, toolbarBottomItems, bdInst) {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                objFct = _props2.objFct,
	                type = _props2.type;
	
	            //获取子空间的布局row信息
	
	            var rowInfo = this.setFormCtlRowInfo(sonitems);
	
	            //拼装控件
	            var rowItemList = void 0,
	                colList = void 0,
	                span = void 0,
	                offset = void 0;
	            for (var rowkey in rowInfo) {
	                rowItemList = rowInfo[rowkey];
	                colList = [];
	                rowItemList.forEach(function (item, index) {
	                    span = item.span;
	                    offset = item.offset;
	                    if (!span) span = 24;
	                    if (!offset) offset = 0;
	                    //如果是工具条的话，放入到工具条中make，不跟其他控件一起make
	                    if (item.desId === _SgiCompConstant.AllCompGUID.TOOLBAR) {
	                        if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
	                            toolbarItems.push((0, _SgiCompComm.convertModuleByGuid)(_this3, item, bdInst, objFct, type));
	                        } else {
	                            toolbarBottomItems.push((0, _SgiCompComm.convertModuleByGuid)(_this3, item, bdInst, objFct, type));
	                        }
	                    } else {
	                        var copyItem = (0, _sgiCommon.copy)(item, true); //单向，不能修改原描述
	                        if (_this3.state.isLabel) _this3.setAllItemIsLabel(copyItem, true);
	                        // else this.setAllItemIsLabel(copyItem, false);//这里不能添加，作为当form可填写时，组件使用自定义的方式：可填写/仅展示
	                        _this3.setFormProps(copyItem, _this3.state.formProps);
	                        colList.push(_react2.default.createElement(
	                            _antd.Col,
	                            { style: {}, span: span, offset: offset },
	                            (0, _SgiCompComm.convertModuleByGuid)(_this3, copyItem, bdInst, objFct, type)
	                        ));
	                    }
	                });
	                formItems.push(_react2.default.createElement(
	                    _antd.Row,
	                    { style: {} },
	                    colList
	                ));
	            }
	        };
	
	        _this.setFormCtlRowInfo = function (sonitems) {
	            var nullrowList = [];
	            var rowInfo = {};
	            var colList = [];
	            var row = void 0,
	                span = void 0,
	                offset = void 0,
	                currentSonItem = void 0;
	            for (var i = 0; i < sonitems.length; i++) {
	                currentSonItem = sonitems[i];
	                row = currentSonItem.row;
	                span = currentSonItem.span;
	                if (row) {
	                    if (!rowInfo[row]) {
	                        rowInfo[row] = [];
	                    }
	                    rowInfo[row].push(currentSonItem);
	                } else {
	                    nullrowList.push(currentSonItem);
	                }
	            }
	            if (nullrowList.length > 0) {
	                rowInfo.nullrow = nullrowList;
	            }
	            return rowInfo;
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var _props3 = this.props,
	                parentModule = _props3.parentModule,
	                moduleDesc = _props3.moduleDesc,
	                objFct = _props3.objFct,
	                type = _props3.type;
	
	
	            if (!this.loaded || this.props.type == 'dnd') {
	                //组装属性
	                this.form_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            // 通用渲染前处理，添加自定义样式等
	            this.renderBeforeReturn(this.state.formProps);
	
	            var showToolbarTopItems = [].concat(_toConsumableArray(this.state.toolbarTopItems));
	            var showToolbarBottomItems = [].concat(_toConsumableArray(this.state.toolbarBottomItems));
	            var showFormItems = [].concat(_toConsumableArray(this.state.formItems));
	            var _state = this.state,
	                cstmFullItemFlg = _state.cstmFullItemFlg,
	                cstmFullItem = _state.cstmFullItem,
	                cstmItemFlg = _state.cstmItemFlg,
	                cstmItem = _state.cstmItem;
	            // 完全自定义子组件处理
	
	            if (cstmFullItemFlg && typeof cstmFullItem === "function" && type !== "dnd") {
	                var cldSet = cstmFullItem(this, objFct);
	                if (cldSet) this.setFormCtlItems(cldSet, showFormItems, showToolbarTopItems, showToolbarBottomItems, (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst));
	            }
	            // 行列布局自定义子组件处理
	            if (cstmItemFlg && typeof cstmItem === "function" && type !== "dnd") {
	                var cstmDesc = cstmItem(this, objFct);
	                if (cstmDesc) {
	                    var col = cstmDesc.col || 3;
	                    var _cldSet = cstmDesc.cldSet || [];
	                    var width = 100 / col + "%";
	                    var newCldSet = [{ "ctlN": "行", "desId": "EP_EO_UI_5101" }];
	                    var rowCldSet = newCldSet[0].cldSet = [];
	                    _cldSet.forEach(function (cld) {
	                        rowCldSet.push({ "ctlN": "列", "desId": "EP_EO_UI_5102", "style": { width: width }, cldSet: [cld] });
	                    });
	                    this.setFormCtlItems(newCldSet, showFormItems, showToolbarTopItems, showToolbarBottomItems, (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst));
	                }
	            }
	
	            return _react2.default.createElement(
	                _antd.Form,
	                this.state.formProps,
	                _react2.default.createElement(
	                    'div',
	                    { style: { height: '100%', width: '100%', display: 'flex', 'flex-direction': 'column' } },
	                    showToolbarTopItems ? showToolbarTopItems : null,
	                    _react2.default.createElement(
	                        'div',
	                        _extends({ className: _SgiPanel2.default.title }, this.state.panelTitleProps),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.state.panelTitleProps.title
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        this.state.formBodyProps,
	                        showFormItems,
	                        this.props.children
	                    ),
	                    showToolbarBottomItems ? showToolbarBottomItems : null
	                )
	            );
	        };
	
	        _this.AddAttribute = function (moduleDesc, formProps, panelTitleProps) {
	            // 整个form是否只作为显示组件
	            var isLabel = moduleDesc.isLabel;
	            this.state.isLabel = !!isLabel;
	
	            var text = formProps.te; //公共方法里已从资源获取了//Resource.getTRByPrm(moduleDesc).te; //form标题
	            if (text) panelTitleProps.title = text;
	
	            var lblAlgn = moduleDesc.lblAlgn; //标签对齐方式
	            if (lblAlgn) formProps.labelAlign = lblAlgn;
	
	            var ttlAlgn = moduleDesc.ttlAlgn; //form标题对齐方式
	            if (ttlAlgn) panelTitleProps.style['text-align'] = ttlAlgn;
	
	            var isTtl = moduleDesc.isTtl; //form是否显示标题
	            if (!isTtl) {
	                panelTitleProps.style.display = "none";
	            } else {
	                panelTitleProps.style.display = undefined;
	            }
	
	            // 冒号
	            formProps.colon = !!moduleDesc.colon;
	
	            // 是否换行
	            var nowrap = moduleDesc.nowrap;
	            if (nowrap) {
	                this.state.formProps.className += " sgiForm-nowrap";
	            }
	
	            // 标签宽度自适应
	            var lblAuto = moduleDesc.lblAuto;
	            if (lblAuto) {
	                this.state.formProps.className += " sgiForm-lblAuto";
	            }
	
	            // 完全自定义formItems
	            var cstmFullItem = moduleDesc.cstmFullItem;
	            if (cstmFullItem) {
	                var $cstmFullItem = void 0;
	                try {
	                    $cstmFullItem = new Function("module", "objFct", cstmFullItem);
	                } catch (error) {
	                    sgiLogger.eventErr(error);
	                }
	                if ($cstmFullItem) {
	                    this.state.cstmFullItem = $cstmFullItem;
	                }
	                this.state.cstmFullItemFlg = true;
	            }
	
	            // 行列自定义formItems
	            var cstmItem = moduleDesc.cstmItem;
	            if (cstmItem) {
	                var $cstmItem = void 0;
	                try {
	                    $cstmItem = new Function("module", "objFct", cstmItem);
	                } catch (error) {
	                    sgiLogger.eventErr(error);
	                }
	                if ($cstmItem) {
	                    this.state.cstmItem = $cstmItem;
	                }
	                this.state.cstmItemFlg = true;
	            }
	
	            var icon = moduleDesc.icon; //form背景图片??没实现
	            var bdsty = moduleDesc.bdsty; //form背景颜色??没实现
	            var isCls = moduleDesc.isCls; //form是否可以关闭??没实现
	            var isFrm = moduleDesc.isFrm; //form是否填充??没实现-----del
	            // var isScl = moduleDesc.isScl; //form是否可以滚动??没实现
	            var html = moduleDesc.html; //form显示html元素??没实现
	            var isDis = moduleDesc.isDis; //form是否禁用??没实现
	            var csstyle = moduleDesc.csstyle; //form样式??没实现
	            var flx = moduleDesc.flx; //form占比??没实
	        };
	
	        _this.state = {
	            formProps: { style: { height: '100%', width: '100%' }, className: "sgiForm" }, //form属性
	            formItems: [], //form下控件数组
	            panelTitleProps: { style: {} }, //panel的title属性
	            formBodyProps: { style: { flex: 1 } }, //form的body属性
	            toolbarTopItems: [],
	            toolbarBottomItems: [],
	            loading: false,
	            isLabel: false,
	            cstmFullItemFlg: false, //默认非完全自定义items
	            cstmItemFlg: false //默认非行列自定义items
	        };
	
	        // let { parentModule, moduleDesc, objFct, type } = this.props;
	        // //组装属性
	        // this.form_mk(parentModule, moduleDesc, objFct, type);
	        return _this;
	    }
	
	    /**
	     * 获取Form下的所有控件的Values
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiForm, [{
	        key: 'getFieldsValue',
	        value: function getFieldsValue() {}
	
	        /**重置所有组件 */
	
	    }, {
	        key: 'resetFields',
	        value: function resetFields() {}
	
	        /**获取form下所有控件 */
	
	    }, {
	        key: 'getFields',
	        value: function getFields() {
	            var resultFields = {};
	            this.getLeafFields(this.refs, resultFields);
	            return resultFields;
	        }
	
	        //遍历寻找下级refs，最底层的是form组件，前面都是布局用的
	
	    }, {
	        key: 'getLeafFields',
	        value: function getLeafFields(fields, resultFields) {
	            var item = void 0;
	            for (var itemKey in fields) {
	                item = fields[itemKey];
	                if ((0, _sgiCommon.getJsonLength)(item.refs) > 0) {
	                    //第一层
	                    this.getLeafFields(item.refs, resultFields);
	                } else {
	                    resultFields[itemKey] = item;
	                }
	            }
	        }
	
	        /**
	         * 设置一组输入控件的值
	         * @param { fieldName: value } FieldsValue
	         */
	
	    }, {
	        key: 'setFieldsValue',
	        value: function setFieldsValue(FieldsValue) {
	            var fields = this.getFields();
	            //循环所有子控件，调用他们的刷新方法
	            var item = void 0;
	
	            var _loop = function _loop() {
	                item = fields[index];
	                var attname = item.state.attname;
	                if (!attname || !item.setValue) {
	                    return 'continue';
	                }
	
	                // 级联组件等多属性组件属性值合并
	                var atts = [],
	                    vals = [];
	                if (attname.indexOf(",") !== -1) {
	                    atts = attname.split(",");
	                    atts.forEach(function (att) {
	                        vals.push(FieldsValue[att]);
	                    });
	                    item.setValue(vals);
	                }
	                // 其他正常组件
	                else {
	                        var value = FieldsValue[attname];
	                        item.setValue(value);
	                    }
	            };
	
	            for (var index in fields) {
	                var _ret = _loop();
	
	                if (_ret === 'continue') continue;
	            }
	        }
	
	        /**
	         * 从对象工厂中取值 刷新
	         */
	
	    }, {
	        key: 'refreshValues',
	        value: function refreshValues() {
	            var _props4 = this.props,
	                objFct = _props4.objFct,
	                moduleDesc = _props4.moduleDesc;
	
	            var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
	            if (bdInst && objFct) {
	                var value = objFct.get(bdInst);
	                this.setFieldsValue(value);
	            }
	        }
	
	        /**
	         * 校验并获取一组输入域的值与 Error
	         * @param {*} Fields
	         */
	
	    }, {
	        key: 'validateFields',
	        value: function validateFields() {
	            var errors = this.getFieldsError();
	            if (errors && errors.length > 0) {
	                return false;
	            } else {
	                return true;
	            }
	        }
	
	        /**获取一组输入控件的 Error  */
	
	    }, {
	        key: 'getFieldsError',
	        value: function getFieldsError() {
	            var fields = this.getFields();
	            var errors = [];
	            var errorMsg = void 0;
	            //循环所有子控件，调用他们的刷新方法
	            var item = void 0;
	            for (var index in fields) {
	                item = fields[index];
	                if (!item.validate) {
	                    continue;
	                }
	                errorMsg = item.validate();
	                if (errorMsg) {
	                    errors.push(errors);
	                }
	            }
	            return errors;
	        }
	
	        /**
	         * 根据描述创建form
	         * @param {父组件} parentModule
	         * @param {描述} moduleDesc
	         * @param {对象工厂} objFct
	         * @param {make类型} type
	         */
	
	    }, {
	        key: 'form_mk',
	        value: function form_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.formItems = []; //再次渲染的时候清空
	
	            //转换form公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.formProps, this.state.formBodyProps);
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.formProps, this.state.panelTitleProps);
	            //组装form表单下的控件信息
	            if (type !== "dnd") this.fitFormItems(moduleDesc, this.state.formItems, this.state.toolbarTopItems, this.state.toolbarBottomItems);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.formProps);
	        }
	
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc
	         * @param {*} formProps
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, formProps) {}
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	    }, {
	        key: 'adaptLayout',
	
	
	        /**
	         * 适应老系统垂直布局和水平布局
	         * @param {*} moduleDesc
	         */
	        value: function adaptLayout(moduleDesc) {
	            var cldSet = moduleDesc.cldSet;
	            var layout = moduleDesc.t;
	            var sumflx = 0;
	
	            if (!cldSet) {
	                return;
	            }
	
	            cldSet.forEach(function (item, index) {
	                sumflx = sumflx + item.flx;
	            });
	
	            if (layout == 'hbox') {
	                cldSet.forEach(function (item, index) {
	                    item.row = 1;
	                    if (sumflx && item.flx) {
	                        item.span = parseInt(item.flx / sumflx * 24);
	                    }
	                });
	            } else if (layout == 'vbox') {
	                cldSet.forEach(function (item, index) {
	                    item.row = index + 1;
	                    if (sumflx && item.flx) {
	                        item.span = 24;
	                    }
	                });
	            }
	        }
	
	        /**
	         *
	         * @param {*} bdDvId
	         * @param {*} formItems
	         */
	
	    }, {
	        key: 'setDVItems',
	        value: function setDVItems(dvJson, formItems, bdInst) {
	            var _this4 = this;
	
	            var _props5 = this.props,
	                objFct = _props5.objFct,
	                type = _props5.type;
	
	            if (!dvJson) {
	                return;
	            }
	            if (!dvJson.cldSet) {
	                return;
	            }
	            //获取子空间的布局row信息
	            var rowInfo = this.setFormCtlRowInfo(dvJson.cldSet);
	            // tool.sgiLogger.log(111111111111111111)
	
	            //拼装控件
	            var rowItemList = void 0,
	                colList = void 0,
	                span = void 0,
	                offset = void 0;
	            for (var rowkey in rowInfo) {
	                rowItemList = rowInfo[rowkey];
	                colList = [];
	                rowItemList.forEach(function (item, index) {
	                    span = item.span;
	                    offset = item.offset;
	                    if (!span) span = 12;
	                    if (!offset) offset = 0;
	                    colList.push(_react2.default.createElement(
	                        _antd.Col,
	                        { span: span, offset: offset },
	                        (0, _SgiCompComm.convertModuleByGuid)(_this4, item.cldSet[0], bdInst, objFct, type)
	                    ));
	                });
	                formItems.push(_react2.default.createElement(
	                    _antd.Row,
	                    null,
	                    colList
	                ));
	            }
	        }
	
	        /**
	         * 添加子控件
	         */
	
	    }, {
	        key: 'setAllItemIsLabel',
	        value: function setAllItemIsLabel(item, isLabel) {
	            var _this5 = this;
	
	            if (!item) return;
	            item.isLabel = !!isLabel;
	            if (item.cldSet) {
	                item.cldSet.forEach(function (cld) {
	                    _this5.setAllItemIsLabel(cld, isLabel);
	                });
	            }
	        }
	
	        /**
	         * 递归为子组件添加_formProps属性，将form属性传递下去
	         * @param {object} item 子组件描述
	         * @param {object} formProps form属性对象
	         */
	
	    }, {
	        key: 'setFormProps',
	        value: function setFormProps(item, formProps) {
	            var _this6 = this;
	
	            if (!item || !formProps) return;
	            item._formProps = formProps;
	            if (item.cldSet) {
	                item.cldSet.forEach(function (cld) {
	                    _this6.setFormProps(cld, formProps);
	                });
	            }
	        }
	
	        /**
	         * 设置是否仅显示标识(外部方法接口)
	         * @author hanzb
	         * @param {boolean} isLabel 是否仅显示
	         */
	
	    }, {
	        key: 'setIsLabel',
	        value: function setIsLabel(isLabel) {
	            // 重置部分状态
	            this.state.isLabel = !!isLabel;
	            this.setFormIsLabel(this.refs, !!isLabel);
	            // 刷新
	            this.setState({});
	        }
	    }, {
	        key: 'setFormIsLabel',
	        value: function setFormIsLabel(refs, isLabel) {
	            for (var key in refs) {
	                var ref = refs[key];
	                if (ref) {
	                    ref.setState({ formIsLabel: isLabel });
	                    if (ref.refs) {
	                        this.setFormIsLabel(ref.refs, isLabel);
	                    }
	                }
	            }
	        }
	
	        /**
	         * 设置整个表单是否禁用(外部接口)
	         * @param {boolean} disabled 是否禁用
	         */
	
	    }, {
	        key: 'setDisabled',
	        value: function setDisabled(disabled) {
	            this.setFormDisabled(this.refs, disabled);
	        }
	    }, {
	        key: 'setFormDisabled',
	        value: function setFormDisabled(refs, disabled) {
	            for (var key in refs) {
	                var ctl = refs[key];
	                if (!ctl) continue;
	                if (ctl.setFormDisabled) ctl.setFormDisabled(disabled);
	                if (ctl.refs) this.setFormDisabled(ctl.refs, disabled);
	            }
	        }
	
	        /**
	         * 设置布局
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	
	        //渲染并返回一个虚拟DOM
	
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	    }]);
	
	    return SgiForm;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiForm.defaultProps = {};
	SgiForm.propTypes = {};
	Object.assign(SgiForm.prototype, _SgiCtnComm.sgiCtnBaseFun);
	exports.SgiForm = SgiForm;
	exports.default = SgiForm;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormCascader = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _StandardCode = __webpack_require__(81);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var SgiFormCascader = function (_React$Component) {
	    _inherits(SgiFormCascader, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormCascader(props) {
	        _classCallCheck(this, SgiFormCascader);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormCascader.__proto__ || Object.getPrototypeOf(SgiFormCascader)).call(this, props));
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性
	
	                this.cascader_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            // let value = this.state.inputprops.value;
	            // var newcomboBoxData = [];
	            // if (value) {
	            //     var valueList = value.split(",");//拆分
	            //     for (var i = 0; i < valueList.length; i++) {
	            //         var uceC = valueList[i];
	            //         newcomboBoxData.push(uceC);
	            //     }
	            //     this.state.showValue = newcomboBoxData;
	
	            // } else {
	            //     this.state.showValue = value;
	            // }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var showValue = this.getShowValue();
	
	            var value = this.state.inputprops.value;
	            if (value && typeof value === "string") {
	                // 某种神奇的力量会把它改成字符串，处理一下这种情况
	                this.state.inputprops.value = value.split(",");
	            }
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps, { title: showValue }),
	                showValue
	            ) : _react2.default.createElement(_antd.Cascader, _extends({}, this.state.inputprops, _inputProps, {
	                value: this.state.inputprops.value,
	                options: this.fitCasNodes1(this.state.casData), changeOnSelect: true }));
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        _this.state.multiattribute = true;
	        _this.state.displayField = '';
	        _this.state.saveField = '';
	        _this.state.casData = []; //下拉框内容
	        _this.state.childrenName = "cldSet";
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule 
	     * @param {组件描述} moduleDesc 
	     * @param {绑定实例ID} bdInst 
	     * @param {当前工作区} ws 
	     * @param {make类型} type 
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormCascader, [{
	        key: 'cascader_mk',
	        value: function cascader_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	            //组装下拉框内容
	            var casStore = this.fitSelectOption(moduleDesc);
	            this.state.casData = casStore;
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	            //绑定值
	            this.bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	        }
	
	        /**
	        * 组装下拉框内容
	        * @param {描述} moduleDesc 
	        */
	
	    }, {
	        key: 'fitSelectOption',
	        value: function fitSelectOption(moduleDesc) {
	
	            // this.state.store = [];
	            var tData;
	            var scId = moduleDesc.scId; //绑定实例名
	            if (scId) {
	                // 下拉窗列表值在标准代码中的id
	                tData = _StandardCode.StandardCode.getSC(scId);
	                this.state.displayField = 'te';
	                this.state.saveField = 'c';
	            } else {
	                var insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName); //绑定实例名
	
	                //取得绑定类名`  var tData = [];
	                if (insName) {
	                    tData = objFct.get(insName);
	                }
	                this.state.displayField = moduleDesc.showKey;
	                this.state.saveField = moduleDesc.saveKey;
	            }
	            if (!tData) {
	                return [];
	            }
	            return tData;
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formItem 
	         * @param {属性} inputprops 
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItemProps, inputprops) {
	            //当下拉列表为空时显示的内容    
	            if (this.state.casData.length < 1) {
	                var emptyText = moduleDesc.emptyText;
	                inputprops.placeholder = emptyText;
	            }
	            //次级菜单的展开方式，可选 'click' 和 'hover'
	            var expend = moduleDesc.expandTrigger;
	            inputprops.expandTrigger = expend;
	            //是否支持清除
	            inputprops.allowClear = moduleDesc.allowClear;
	
	            //选择即改变
	            var chgOnsel = moduleDesc.chgOnsel;
	            if (chgOnsel) inputprops.changeOnSelect = 'changeOnSelect';
	            //是否显示搜索框
	            var search = moduleDesc.showSearch;
	            if (search) inputprops.showSearch = search;
	        }
	    }, {
	        key: 'fitCasNodes1',
	        value: function fitCasNodes1(comboBoxData) {
	            var items;
	            var scList = [];
	            var childrenName = this.state.childrenName;
	            var size = comboBoxData.length;
	            for (var i = 0; i < size; i++) {
	                var item = comboBoxData[i];
	                if (item[childrenName] && item[childrenName].length) {
	                    items = this.fitCasNodes2(item[childrenName]);
	                    scList.push({ label: item[this.state.displayField], value: item[this.state.saveField], children: items });
	                }
	                scList.push({ label: item[this.state.displayField], value: item[this.state.saveField] });
	            }
	            return scList;
	        }
	    }, {
	        key: 'fitCasNodes2',
	        value: function fitCasNodes2(comboBoxData) {
	            var items;
	            var scList = [];
	            var childrenName = this.state.childrenName;
	            var size = comboBoxData.length;
	            for (var i = 0; i < size; i++) {
	                var item = comboBoxData[i];
	                if (item[childrenName] && item[childrenName].length) {
	                    items = this.fitCasNodes2(item[childrenName]);
	                    scList.push({ label: item[this.state.displayField], value: item[this.state.saveField], children: items });
	                }
	                scList.push({ label: item[this.state.displayField], value: item[this.state.saveField] });
	            }
	            return scList;
	        }
	    }, {
	        key: 'getShowValue',
	        value: function getShowValue() {
	            var _this2 = this;
	
	            var comboBoxData = this.state.casData;
	            if (!comboBoxData) {
	                return;
	            }
	            var value = this.state.inputprops.value;
	            var newcomboBoxData = [];
	            if (value && !(value instanceof Array)) {
	                var valueList = value.split(","); //拆分
	                for (var i = 0; i < valueList.length; i++) {
	                    var uceC = valueList[i];
	                    newcomboBoxData.push(uceC);
	                }
	            } else if (value) {
	                newcomboBoxData = value;
	            }
	            var showValue = newcomboBoxData.map(function (key) {
	                return _this2.getShowValueByKey(key);
	            });
	            return showValue.join("/");
	        }
	    }, {
	        key: 'getShowValueByKey',
	        value: function getShowValueByKey(key, comboBoxData) {
	            if (!key) return null;
	            comboBoxData = comboBoxData || this.state.casData;
	            if (!comboBoxData) return null;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = comboBoxData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var item = _step.value;
	
	                    if (item["c"] === key) {
	                        return item["te"];
	                    } else if (item[this.state.childrenName]) {
	                        var sonRet = this.getShowValueByKey(key, item[this.state.childrenName]);
	                        if (sonRet) return sonRet;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }, {
	        key: 'bindValue',
	
	
	        /**
	         * 绑定显示值
	         * @param {描述信息} currentModule
	         * @param {描述信息} moduleDesc
	         * @param {数据} bdInst
	         * @param {对象工厂} objFct
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	        value: function bindValue(currentModule, moduleDesc, bdInst, objFct, formItem, inputprops, checked) {
	
	            if (!moduleDesc.c) {
	                return;
	            }
	
	            //currentModule.bdInst = bdInst;
	            var attname = moduleDesc.c;
	            currentModule.state.attname = attname;
	
	            if (!bdInst || !objFct) {
	                return;
	            }
	
	            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	            var bdInstValue;
	            if (typeof bdInst === "string") {
	                bdInstValue = objFct.get(bdInst);
	            } else {
	                bdInstValue = bdInst;
	            }
	
	            if (bdInstValue) {
	                //2018.04.27-yly,有value会导致默认值无法赋值
	                //给checkbox 使用
	                inputprops.value = bdInstGetValue(bdInstValue, attname);
	            }
	            // } else {//20180704 wzhe 默认值 给当前value
	            //     if (!inputprops.defaultValue) {
	            //         return;
	            //     }
	            //     let defaultValueList = inputprops.defaultValue.split[',']
	            //     inputprops.value = defaultValueList;
	            //     if (bdInstValue) {
	            //         // bdInstValue[attname] = inputprops.defaultValue;
	            //         bdInstSetValue(bdInstValue, attname, defaultValueList);
	            //     }
	            // }
	        }
	    }]);
	
	    return SgiFormCascader;
	}(_react2.default.Component);
	
	SgiFormCascader.defaultProps = {};
	SgiFormCascader.propTypes = {};
	
	
	var bdInstGetValue = function bdInstGetValue(bdInstValue, attname) {
	    var attList = attname.split(',');
	    if (attList.length == 1) {
	        return bdInstValue[attname] ? bdInstValue[attname].split(',') : null;
	    } else {
	        var isEmpty = true;
	        var values = [];
	        attList.forEach(function (element) {
	            values.push(bdInstValue[element]);
	            if (bdInstValue[element]) isEmpty = false;
	        });
	        if (isEmpty) values = null; //如果都为空，返回null
	        return values;
	    }
	};
	
	var bdInstSetValue = function bdInstSetValue(bdInstValue, attname, value) {
	    var attList = attname.split(',');
	    if (attList.length == 1) {
	        return bdInstValue[attname] = value.join(',');
	    } else {
	        // let attList = attname.split(',');
	        // let valueList = value.split(',');
	        attList.forEach(function (element, index) {
	            bdInstValue[element] = value[index];
	        });
	    }
	};
	
	//给类添加公共方法
	Object.assign(SgiFormCascader.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	//重写setValue 给refreahwv用
	SgiFormCascader.prototype.setValue = function (value) {
	    //更新state
	    if (!value) {
	        return;
	    }
	    this.state.inputprops.value = value;
	    //页面校验
	    this.validate(value);
	};
	//重写ctlRefresh  给change事件用
	SgiFormCascader.prototype.ctlRefresh = function (attname, bdInst, objFct, value) {
	    //对象工厂的值刷新
	    if (bdInst && attname) {
	        var bdInstData = void 0;
	        if (typeof bdInst === "string") bdInstData = objFct.get(bdInst);else bdInstData = bdInst;
	        // bdInstData[attname] = value;
	        bdInstSetValue(bdInstData, attname, value);
	    }
	    //更新state
	    this.state.inputprops.value = value;
	    //页面校验
	    this.validate(value);
	};
	
	exports.SgiFormCascader = SgiFormCascader;
	exports.default = SgiFormCascader;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SgiFormCheckbox = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var SgiFormCheckbox = function (_React$Component) {
		_inherits(SgiFormCheckbox, _React$Component);
	
		// 注意这里有分号
	
		function SgiFormCheckbox(props) {
			_classCallCheck(this, SgiFormCheckbox);
	
			//初始化state属性
			var _this = _possibleConstructorReturn(this, (SgiFormCheckbox.__proto__ || Object.getPrototypeOf(SgiFormCheckbox)).call(this, props));
	
			_this.render = function () {
	
				if (!this.loaded) {
					var _props = this.props,
					    parentModule = _props.parentModule,
					    moduleDesc = _props.moduleDesc,
					    bdInst = _props.bdInst,
					    objFct = _props.objFct,
					    type = _props.type;
					//组装属性 初始化属性到this.state
	
					this.checkbox_mk(parentModule, moduleDesc, bdInst, objFct, type);
					this.loaded = true;
				}
	
				// 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
				var _getReviseProps = this.getReviseProps(),
				    _inputProps = _getReviseProps._inputProps,
				    _formItemProps = _getReviseProps._formItemProps;
	
				var isLabel = _inputProps.isLabel;
	
				// 渲染前通用处理，如自定义样式等
	
				this.renderBeforeReturn();
	
				var ctl = isLabel ? _react2.default.createElement(
					'span',
					_extends({}, this.state.inputprops, _inputProps),
					_react2.default.createElement(_antd.Icon, {
						type: this.state.inputprops.checked ? "check" : "close",
						style: { color: this.state.inputprops.checked ? "#007bff" : "#dc3545" } })
				) : _react2.default.createElement(_antd.Checkbox, _extends({}, this.state.inputprops, _inputProps));
	
				return this.state.noFI ? ctl : _react2.default.createElement(
					FormItem,
					_extends({}, this.state.formItemProps, _formItemProps),
					ctl
				);
			};
	
			_this.initState();
			// this.state.checked = "";
			return _this;
		}
	
		/**
	  * 根据描述创建文本框
	  * @param {父组件} parentModule
	  * @param {组件描述} moduleDesc
	  * @param {绑定实例ID} bdInst
	  * @param {当前工作区} ws
	  * @param {make类型} type
	  */
		// 注意这里有分号
	
	
		_createClass(SgiFormCheckbox, [{
			key: 'checkbox_mk',
			value: function checkbox_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
				//获取需要展示的数据信息
				var moduleDesc = this.props.moduleDesc;
				if (!moduleDesc) {
					return;
				}
				//转换基础属性
				this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
				//转换form公共属性
				(0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
				//设置布局
				(0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
				//绑定值
				(0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops, true);
				//绑定事件
				(0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
			}
	
			/**
	   * 属性转换
	   * @param {描述信息} moduleDesc
	   * @param {属性} formItem
	   * @param {属性} inputprops
	   */
	
		}, {
			key: 'AddInputAttribute',
			value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
				//设置默认选中
				var checked = moduleDesc.defVal10;
				if (checked) inputprops.defaultChecked = checked;
	
				// 是否转义
				this.state.escape = moduleDesc.escape;
			}
	
			//渲染并返回一个虚拟DOM
	
		}]);
	
		return SgiFormCheckbox;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiFormCheckbox.defaultProps = {};
	SgiFormCheckbox.propTypes = {};
	Object.assign(SgiFormCheckbox.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	//方法特殊  重写setValue方法
	SgiFormCheckbox.prototype.setValue = function (value) {
		//更新state
		// if (value && value === this.state.inputprops.value) {
		//     return;
		// }
		var checked = value ? true : false;
		var escape = this.state.escape;
		if (escape) {
			//转义
			var escs = escape.split("/");
			checked = value === escs[0];
		}
		this.state.inputprops.checked = checked;
		this.state.inputprops.value = value;
		//页面校验
		this.validate(value);
	};
	SgiFormCheckbox.prototype.ctlRefresh = function (attname, bdInst, objFct, value) {
		//对象工厂的值刷新
		this.setBindValue(attname, bdInst, objFct, value);
	
		//更新state
		var checked = value ? true : false;
		var escape = this.state.escape;
		if (escape) {
			//转义
			var escs = escape.split("/");
			checked = value === escs[0];
		}
		this.state.inputprops.checked = checked;
		//页面校验
		this.validate(value);
	};
	exports.SgiFormCheckbox = SgiFormCheckbox;
	exports.default = SgiFormCheckbox;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormCheckboxGroup = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _StandardCode = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var CheckboxGroup = _antd.Checkbox.Group;
	
	var SgiFormCheckboxGroup = function (_React$Component) {
	    _inherits(SgiFormCheckboxGroup, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormCheckboxGroup(props) {
	        _classCallCheck(this, SgiFormCheckboxGroup);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormCheckboxGroup.__proto__ || Object.getPrototypeOf(SgiFormCheckboxGroup)).call(this, props));
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.checkbox_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            var value = this.state.inputprops.value;
	            var newcomboBoxData = [];
	            if (value) {
	                var valueList = value.split(","); //拆分value就是个数组
	                for (var i = 0; i < valueList.length; i++) {
	                    var uceC = valueList[i];
	                    newcomboBoxData.push(uceC);
	                }
	                this.state.showValue = newcomboBoxData;
	            } else {
	                this.state.showValue = value;
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var showValue = this.getShowValue();
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps, { title: showValue }),
	                showValue
	            ) : _react2.default.createElement(
	                CheckboxGroup,
	                _extends({}, this.state.inputprops, _inputProps, {
	                    value: this.state.showValue }),
	                _react2.default.createElement(
	                    _antd.Row,
	                    null,
	                    this.state.store
	                )
	            );
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        _this.state.store = [];
	        _this.state.checked = "";
	        _this.state.scList = [];
	        _this.state.allScList = [];
	        _this.state.shows = null; //下拉窗显示项，不为空则表示启用，只能显示指定项
	        _this.state.occupied = "6";
	        _this.state.isOccupied = false;
	
	        // 订阅标准代码更新
	        var scId = (_this.props.moduleDesc || {}).scId;
	        if (scId) _this.state.unsubscribe_sc = _StandardCode.StandardCode.subscribe(scId, function (newSCList) {
	            if (!newSCList) return;
	            _this.fitStore(newSCList);
	            _this.setState({});
	        });
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormCheckboxGroup, [{
	        key: 'checkbox_mk',
	        value: function checkbox_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	
	            var browserWidth = void 0,
	                occupiedBig = "6",
	                occupiedSmall = "6",
	                occupied = void 0;
	            if (moduleDesc.browserWidth) {
	                browserWidth = parseInt(moduleDesc.browserWidth);
	                this.state.isOccupied = true;
	            } else {
	                this.state.isOccupied = false;
	            };
	
	            if (moduleDesc.occupiedBig) {
	                occupiedBig = moduleDesc.occupiedBig;
	            }
	
	            if (moduleDesc.occupiedSmall) {
	                occupiedSmall = moduleDesc.occupiedSmall;
	            }
	
	            if (browserWidth < document.body.offsetWidth) {
	                occupied = occupiedBig;
	            } else {
	                occupied = occupiedSmall;
	            }
	
	            this.state.occupied = occupied;
	
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //组装下拉框内容
	            this.fitSelectOption(moduleDesc);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	            this.state.chkAll = moduleDesc.chkAll;
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'fitSelectOption',
	        value: function fitSelectOption(moduleDesc) {
	
	            this.state.store = [];
	
	            var scId = moduleDesc.scId,
	                useCodes = moduleDesc.useCodes;
	
	            if (!scId) {
	                return;
	            }
	            // 下拉窗列表值在标准代码中的id
	            var comboBoxData = _StandardCode.StandardCode.getSC(moduleDesc.scId);
	            if (!comboBoxData) {
	                return;
	            }
	            this.fitStore(comboBoxData);
	
	            //参数工厂获取标准代码 暂时当获取到了 属性为'sc', 'te', 'c'
	            //下面是临时数据
	            // let scList = [];
	            // for (let i = 1; i < 5; i++) {
	            //     scList.push({ te: (i.toString(2)), c: (i.toString(2)) });
	            // }
	
	            // if (!scList || scList.length < 1) {
	            //     return;
	            // }
	
	            // scList.forEach((item, index) => {
	            //     this.state.store.push(<Checkbox value={item.c}>{item.te}</Checkbox>);
	            // })
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'fitStore',
	        value: function fitStore(comboBoxData, attKey, attName) {
	            var _this2 = this;
	
	            attKey = attKey || 'c';
	            attName = attName || 'te';
	
	            this.state.store = [];
	
	            var allScList = [];
	            var scList = [];
	            var size = comboBoxData.length;
	            if (!size == 0) {
	                for (var i = 0; i < size; i++) {
	                    var item = comboBoxData[i];
	                    allScList.push({ te: item[attName], c: item[attKey] });
	                }
	                this.state.allScList = allScList;
	
	                // 控制显示项
	                scList = allScList;
	                if (this.state.shows) {
	                    scList = allScList.filter(function (sc) {
	                        return _this2.state.shows.indexOf(sc.c) > -1;
	                    });
	                }
	                this.state.scList = scList;
	
	                scList.forEach(function (item, index) {
	                    _this2.state.isOccupied ? _this2.state.store.push(_react2.default.createElement(
	                        _antd.Col,
	                        { span: _this2.state.occupied },
	                        _react2.default.createElement(
	                            _antd.Checkbox,
	                            { value: item.c },
	                            item.te
	                        )
	                    )) : _this2.state.store.push(_react2.default.createElement(
	                        _antd.Checkbox,
	                        { value: item.c },
	                        item.te
	                    ));
	                });
	            }
	        }
	    }, {
	        key: 'dynamicRefreshCombox',
	        value: function dynamicRefreshCombox(comboBoxData, attKey, attName) {
	            if (!comboBoxData) {
	                return;
	            }
	            this.fitStore(comboBoxData, attKey, attName);
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'setDisabledItems',
	        value: function setDisabledItems(disabledList, attKey) {
	            var _this3 = this;
	
	            disabledList = disabledList || [];
	            attKey = attKey || 'c';
	
	            var scList = this.state.scList;
	            this.state.store = [];
	
	            scList.forEach(function (item, index) {
	                var disabled = false;
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = disabledList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var disItem = _step.value;
	
	                        if (item.c === disItem[attKey]) {
	                            disabled = true;
	                            break;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                _this3.state.isOccupied ? _this3.state.store.push(_react2.default.createElement(
	                    _antd.Col,
	                    { span: _this3.state.occupied },
	                    _react2.default.createElement(
	                        _antd.Checkbox,
	                        { disabled: disabled, value: item.c },
	                        item.te
	                    )
	                )) : _this3.state.store.push(_react2.default.createElement(
	                    _antd.Checkbox,
	                    { disabled: disabled, value: item.c },
	                    item.te
	                ));
	            });
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'getShowValue',
	        value: function getShowValue() {
	
	            var comboBoxData = _StandardCode.StandardCode.getSC(this.props.moduleDesc.scId);
	            if (!comboBoxData) {
	                return;
	            }
	            var value = this.state.inputprops.value;
	            var newcomboBoxData = [];
	            if (value && !(value instanceof Array)) {
	                var valueList = value.split(","); //拆分
	                for (var i = 0; i < valueList.length; i++) {
	                    var uceC = valueList[i];
	                    newcomboBoxData.push(uceC);
	                }
	            } else if (value) {
	                newcomboBoxData = value;
	            }
	
	            var showValue = [];
	
	            for (var j = 0; j < newcomboBoxData.length; j++) {
	                for (var _i = 0; _i < comboBoxData.length; _i++) {
	                    var item = comboBoxData[_i];
	                    if (newcomboBoxData[j] == item["c"]) {
	                        showValue.push(item["te"]);
	                        break;
	                    } else if (_i === comboBoxData.length - 1) {
	                        // 最后一个仍然不匹配
	                        showValue.push(newcomboBoxData[j]);
	                    }
	                }
	            }
	
	            return showValue.join(",");
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            //	初始是否选中
	            //var deChekd = moduleDesc.deChekd;
	            //if(deChekd)inputprops.defaultChecked = deChekd;
	            //是否显示按钮样式
	            //设置默认选中
	            var checked = moduleDesc.checked;
	            if (checked) {
	                inputprops.value = checked;
	                inputprops.defaultValue = checked;
	            }
	
	            // 显示项
	            var shows = moduleDesc.shows;
	            if (shows && shows.length > 0) this.state.shows = shows;else this.state.shows = null;
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // 取消标准代码订阅
	            var unsubscribe = this.state.unsubscribe_sc;
	            if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
	        }
	    }]);
	
	    return SgiFormCheckboxGroup;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiFormCheckboxGroup.defaultProps = {};
	SgiFormCheckboxGroup.propTypes = {};
	Object.assign(SgiFormCheckboxGroup.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	exports.SgiFormCheckboxGroup = SgiFormCheckboxGroup;
	exports.default = SgiFormCheckboxGroup;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormDatePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _moment = __webpack_require__(40);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiCommon = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var MonthPicker = _antd.DatePicker.MonthPicker,
	    RangePicker = _antd.DatePicker.RangePicker,
	    WeekPicker = _antd.DatePicker.WeekPicker;
	
	var SgiFormDatePicker = function (_React$Component) {
	    _inherits(SgiFormDatePicker, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormDatePicker(props) {
	        _classCallCheck(this, SgiFormDatePicker);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormDatePicker.__proto__ || Object.getPrototypeOf(SgiFormDatePicker)).call(this, props));
	
	        _this.getShowPicker = function (mode, inputprops, showValue, format, optBDt, optEDt) {
	            switch (mode) {
	                case "dateTime":
	                    return _react2.default.createElement(_antd.DatePicker, _extends({}, inputprops, { value: showValue, showTime: true,
	                        format: inputprops.format || "YYYY-MM-DD HH:mm:ss",
	                        disabledDate: _this.disabledDate.bind(_this, format, optBDt, optEDt) }));
	                case "month":
	                    return _react2.default.createElement(MonthPicker, _extends({}, inputprops, { value: showValue,
	                        disabledDate: _this.disabledDate.bind(_this, format, optBDt, optEDt) }));
	                case "week":
	                    return _react2.default.createElement(WeekPicker, _extends({}, inputprops, { value: showValue,
	                        disabledDate: _this.disabledDate.bind(_this, format, optBDt, optEDt) }));
	                case "dateRange":
	                    return _react2.default.createElement(RangePicker, _extends({}, inputprops, { value: showValue,
	                        disabledDate: _this.disabledDate.bind(_this, format, optBDt, optEDt) }));
	                case "dateTimeRange":
	                    return _react2.default.createElement(RangePicker, _extends({}, inputprops, { value: showValue, showTime: true,
	                        format: inputprops.format || "YYYY-MM-DD HH:mm:ss",
	                        disabledDate: _this.disabledDate.bind(_this, format, optBDt, optEDt) }));
	                default:
	                    return _react2.default.createElement(_antd.DatePicker, _extends({}, inputprops, { value: showValue,
	                        disabledDate: _this.disabledDate.bind(_this, format, optBDt, optEDt) }));
	            }
	        };
	
	        _this.render = function () {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                bdInst = _props.bdInst,
	                objFct = _props.objFct,
	                type = _props.type;
	
	            if (!this.loaded) {
	                // var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
	                //组装属性 初始化属性到this.state
	                this.datePicker_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            //日期格式转换  value值转换成日期格式数据
	            var value = this.state.inputprops.value;
	            var format = this.state.inputprops.format;
	            var labelValue = value;
	            if (!value) {
	                // delete this.state.showValue;
	                this.state.showValue = null;
	            } else if (Array.isArray(value)) {
	                labelValue = value.join("~");
	                if (!value[0] && !value[1]) {
	                    this.state.showValue = null;
	                } else {
	                    this.state.showValue = [(0, _moment2.default)(value[0] ? value[0] : new Date(-62167219200000), format), (0, _moment2.default)(value[1] ? value[1] : new Date("9999/12/31 23:59:59.999"), format)];
	                    // this.state.showValue = [(value[0]) ? moment(value[0], format) : null
	                    //     , (value[1]) ? moment(value[1], format) : null];
	                }
	            } else {
	                this.state.showValue = (0, _moment2.default)(value, format);
	            }
	
	            var defaultValue = this.state.inputprops.defaultValue;
	            if (!defaultValue) {
	                this.state.inputprops.defaultValue = null;
	            } else if (Array.isArray(defaultValue)) {
	                this.state.inputprops.defaultValue = [(0, _moment2.default)(defaultValue[0], format), (0, _moment2.default)(defaultValue[1], format)];
	            } else {
	                this.state.inputprops.defaultValue = (0, _moment2.default)(defaultValue, format);
	            }
	            // 可选的始末日期
	            // var optBDt = moduleDesc.optBDt; // 可选的起始日期
	            // var optEDt = moduleDesc.optEDt; // 可选的结束日期
	            var optBDt = this.state.optBDt; // 可选的起始日期
	            var optEDt = this.state.optEDt; // 可选的结束日期
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps, { title: labelValue }),
	                labelValue
	            ) : this.getShowPicker(this.state.ctlMode, _extends({}, this.state.inputprops, _inputProps), this.state.showValue, format, optBDt, optEDt);
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        _this.state = _extends({}, _this.state, {
	            showValue: undefined, //展示的值
	            ctlMode: "date", //默认日期模式
	            optBDt: props.moduleDesc.optBDt,
	            optEDt: props.moduleDesc.optEDt
	        });
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormDatePicker, [{
	        key: 'datePicker_mk',
	        value: function datePicker_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            this.bindValue(moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	        }
	    }, {
	        key: 'bindValue',
	        value: function bindValue(moduleDesc, bdInst, objFct, formItem, inputprops) {
	
	            if (!moduleDesc.c) {
	                return;
	            }
	
	            var attname = moduleDesc.c;
	            this.state.attname = attname;
	
	            if (!bdInst || !objFct) {
	                return;
	            }
	
	            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	            var bdInstValue;
	            if (typeof bdInst === "string") {
	                if (this.props.type === 'tb') {
	                    var bdInstKeyList = bdInst.split('`');
	                    var bdInstList = objFct.get(bdInstKeyList[0]);
	                    if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                        bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
	                    }
	                } else {
	                    bdInstValue = objFct.get(bdInst);
	                }
	            } else {
	                bdInstValue = bdInst;
	            }
	
	            if (bdInstValue) {
	                inputprops.value = bdInstGetValue(bdInstValue, attname);
	            }
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            this.state.ctlMode = moduleDesc.ctlMode || "date"; //组件模式
	
	            var dateFmt = moduleDesc.dateFmt; //日期格式
	            // let dateTimeFlag = moduleDesc.dateTimeFlag; //是否显示时间//不要了
	            tool.sgiLogger.log("dateFmt", dateFmt);
	            if (!dateFmt) {
	                var format = void 0;
	                switch (this.state.ctlMode) {
	                    case "year":
	                        format = "YYYY";
	                        break;
	                    case "date":
	                        format = "YYYY-MM-DD";
	                        break;
	                    case "dateTime":
	                        format = "YYYY-MM-DD HH:mm:ss";
	                        break;
	                    case "month":
	                        format = "YYYY-MM";
	                        break;
	                    case "week":
	                        format = "YYYY-W周";
	                        break;
	                    case "dateRange":
	                        format = "YYYY-MM-DD";
	                        break;
	                    case "dateTimeRange":
	                        format = "YYYY-MM-DD HH:mm:ss";
	                        break;
	                    default:
	                        break;
	                }
	                inputprops.format = format;
	            } else {
	                inputprops.format = dateFmt;
	            }
	
	            //禁止选择星期 ??未实现
	            var disDays = moduleDesc.disDays; //禁止选择星期
	
	            //校验类型 ??未实现
	            var vldC = moduleDesc.vldC;
	
	            //csstyle 样式文件?这个我还不知道怎么用
	            var csstyle = moduleDesc.csstyle;
	        }
	        /**
	         * 设置不可选择的日期
	         * @param  {[String]} format  [日期格式]
	         * @param  {[String]} optBDt  [可选的起始日期]
	         * @param  {[String]} optEDt  [可选的结束日期]
	         * @param  {[type]} current [description]
	         * @return {[type]}         [不可选择的日期]
	         */
	
	    }, {
	        key: 'disabledDate',
	        value: function disabledDate(format, optBDt, optEDt, current) {
	            if (optBDt && !optEDt) {
	                return current < (0, _moment2.default)(optBDt, format);
	            } else if (!optBDt && optEDt) {
	                return current > (0, _moment2.default)(optEDt, format).endOf('day');
	            } else if (optBDt && optEDt) {
	                return current < (0, _moment2.default)(optBDt, format) || current > (0, _moment2.default)(optEDt, format).endOf('day');
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: 'setOptBDt',
	        value: function setOptBDt(optBDt) {
	            this.setState({ optBDt: optBDt });
	        }
	    }, {
	        key: 'setOptEDt',
	        value: function setOptEDt(optEDt) {
	            this.setState({ optEDt: optEDt });
	        }
	    }, {
	        key: 'setOptDt',
	        value: function setOptDt(optBDt, optEDt) {
	            this.setOptBDt(optBDt);
	            this.setOptEDt(optEDt);
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiFormDatePicker;
	}(_react2.default.Component);
	
	SgiFormDatePicker.defaultProps = {};
	SgiFormDatePicker.propTypes = {};
	
	
	var bdInstGetValue = function bdInstGetValue(bdInstValue, attname) {
	    var attList = attname.split(',');
	    if (attList.length == 1) {
	        return bdInstValue[attname];
	    } else {
	        return attList.map(function (item, index) {
	            return bdInstValue[item];
	        });
	    }
	};
	
	var bdInstSetValue = function bdInstSetValue(bdInstValue, attname, value) {
	    var attList = attname.split(',');
	    if (Array.isArray(value)) {
	        attList.forEach(function (element, index) {
	            bdInstValue[element] = value[index];
	        });
	    } else {
	        bdInstValue[attname] = value;
	    }
	};
	
	//给类添加公共方法
	Object.assign(SgiFormDatePicker.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	//重写ctlRefresh  给change事件用
	SgiFormDatePicker.prototype.ctlRefresh = function (attname, bdInst, objFct, value) {
	    //对象工厂的值刷新
	    if (bdInst && attname) {
	        //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	        //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	        var bdInstData = void 0;
	        if (typeof bdInst === "string") {
	            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	            if (this.props.type === 'tb') {
	                var bdInstKeyList = bdInst.split('`');
	                var bdInstList = objFct.get(bdInstKeyList[0]);
	                if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                    bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
	                }
	            } else {
	                bdInstData = objFct.get(bdInst);
	            }
	        } else {
	            bdInstData = bdInst;
	        }
	        bdInstSetValue(bdInstData, attname, value);
	    }
	    //更新state
	    this.state.inputprops.value = value;
	    //页面校验
	    this.validate(value);
	};
	
	exports.SgiFormDatePicker = SgiFormDatePicker;
	exports.default = SgiFormDatePicker;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormInputNumber = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var SgiFormInputNumber = function (_React$Component) {
	    _inherits(SgiFormInputNumber, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormInputNumber(props) {
	        _classCallCheck(this, SgiFormInputNumber);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormInputNumber.__proto__ || Object.getPrototypeOf(SgiFormInputNumber)).call(this, props));
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.inputNumber_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            var addonAfter = undefined;
	            if (this.state.inputprops.addonAfter) {
	                this.state.inputprops.style.width = '80%';
	                addonAfter = _react2.default.createElement(
	                    'div',
	                    { style: { display: 'block', height: '32px' } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: "ant-input-group-addon" },
	                        this.state.inputprops.addonAfter
	                    )
	                );
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps),
	                this.state.inputprops.value
	            ) : _react2.default.createElement(_antd.InputNumber, _extends({}, this.state.inputprops, _inputProps));
	            addonAfter;
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormInputNumber, [{
	        key: 'inputNumber_mk',
	        value: function inputNumber_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            var selectType = moduleDesc.selectType; //是否符号 01金钱 02百分比
	            if (selectType == "00") {
	                inputprops.formatter = function (value) {
	                    return value;
	                };
	                inputprops.parser = function (value) {
	                    return value;
	                };
	            }
	
	            if (selectType == "01") {
	                inputprops.formatter = function (value) {
	                    return ('$ ' + value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	                };
	                inputprops.parser = function (value) {
	                    return value.replace(/\$\s?|(,*)/g, '');
	                };
	            }
	            if (selectType == "02") {
	                inputprops.formatter = function (value) {
	                    return value + '%';
	                };
	                inputprops.parser = function (value) {
	                    return value.replace('%', '');
	                };
	            }
	
	            var maxV = moduleDesc.maxV; //输入最大值
	            if (maxV || maxV === 0) inputprops.max = maxV;
	
	            var minV = moduleDesc.minV; //输入最小值
	            if (minV || minV === 0) inputprops.min = minV;
	
	            var step = moduleDesc.step; //微调的数字间距，value 的精度由 step 的小数位数决定。
	            if (step || step === 0) inputprops.step = step;
	
	            var dcmDgt = moduleDesc.dcmDgt; // 小数位>step
	            if (dcmDgt || dcmDgt === 0) inputprops.precision = dcmDgt;
	
	            var intDgt = moduleDesc.intDgt; //整数位
	
	            // 是否隐藏微调，控件本身微调就是隐藏的，鼠标悬浮时微调显示
	            var isHdnTg = moduleDesc.isHdnTg;
	
	            //csstyle 样式文件?这个我还不知道怎么用
	            var csstyle = moduleDesc.csstyle;
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiFormInputNumber;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiFormInputNumber.defaultProps = {};
	SgiFormInputNumber.propTypes = {};
	Object.assign(SgiFormInputNumber.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	exports.SgiFormInputNumber = SgiFormInputNumber;
	exports.default = SgiFormInputNumber;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormInputSearch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Search = _antd.Input.Search;
	
	var SgiFormInputSearch = function (_React$Component) {
	    _inherits(SgiFormInputSearch, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormInputSearch(props) {
	        _classCallCheck(this, SgiFormInputSearch);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormInputSearch.__proto__ || Object.getPrototypeOf(SgiFormInputSearch)).call(this, props));
	
	        _this.render = function () {
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.inputSearch_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.state.inputprops.showValue = this.state.inputprops.value;
	                this.loaded = true;
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            //设置删除功能，如果value存在，显示删除按钮
	            if (this.state.inputprops.value) {
	                this.state.inputprops.suffix = _react2.default.createElement(_antd.Button, { size: "small", onClick: this.clearValue.bind(this), style: { border: 'none' }, icon: "delete" });
	            } else {
	                this.state.inputprops.suffix = undefined;
	            }
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps, { title: this.state.inputprops.showValue }),
	                this.state.inputprops.showValue
	            ) : _react2.default.createElement(Search, _extends({}, this.state.inputprops, _inputProps, { value: this.state.inputprops.showValue }));
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {对象工厂} objFct
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormInputSearch, [{
	        key: 'inputSearch_mk',
	        value: function inputSearch_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops, objFct);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            // this.bindValue(moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, objFct, type);
	        }
	
	        // bindValue(moduleDesc, bdInst, objFct, formItem, inputprops) {
	        //     if (!bdInst || !moduleDesc.c || !objFct) {
	        //         return;
	        //     }
	        //     //currentModule.bdInst = bdInst;
	        //     var attname = moduleDesc.c;
	        //     this.state.attname = attname;
	        //
	        //     // var bdInstValue = objFct.get(bdInst);
	        //     // inputprops.value = "显示值";//bdInstValue[attname];
	        // }
	
	        /**
	         * 绑定事件
	         * @param  {[type]} moduleDesc    [description]
	         * @param  {[type]} formItemProps [description]
	         * @param  {[type]} inputprops    [description]
	         * @param  {[type]} functions     [description]
	         * @param  {[type]} objFct        [description]
	         * @return {[type]}               [description]
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, formItemProps, inputprops, functions, objFct, type) {
	            //加入通用的进入、修改、离开事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, formItemProps, inputprops, functions, type);
	
	            var isCustom = moduleDesc.isCustom; //true:自定义
	            var uid = moduleDesc.uid;
	            if (!isCustom) {
	                //非自定义
	                moduleDesc.clkLsn = 'tool.popUI("' + uid + '", objFct);';
	            }
	            var iCLsn = moduleDesc.clkLsn; // 用户自定义点击事件
	            if (iCLsn) {
	                var $iCLsn = new Function("module", "objFct", "value", iCLsn);
	                functions.onSearch = $iCLsn;
	            }
	            inputprops.onSearch = _SgiEventHandler.SgiEventHandler.onSearch.bind(this);
	        }
	    }, {
	        key: 'clearValue',
	        value: function clearValue() {
	            this.state.bindData = undefined;
	            this.setValue('', '');
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops, objFct) {}
	        // var isCustom = moduleDesc.isCustom;//true:自定义
	        // var clkLsn = moduleDesc.clkLsn;//点击事件
	        // var uid = moduleDesc.uid;
	        // if(isCustom && clkLsn){
	        //   inputprops.onSearch = (value) => {
	        //     eval(clkLsn);
	        //   }
	        // }else if (!isCustom) {
	        //   inputprops.onSearch = (value) => {
	        //     window.tool.popUIByUid(uid, objFct);
	        //   }
	        // }
	
	
	        //渲染并返回一个虚拟
	
	    }]);
	
	    return SgiFormInputSearch;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiFormInputSearch.defaultProps = {};
	SgiFormInputSearch.propTypes = {};
	Object.assign(SgiFormInputSearch.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	SgiFormInputSearch.prototype.setValueByBindData = function (bindData, valueKey, showKey) {
	    if (!bindData || !valueKey || !showKey) return;
	    this.state.bindData = bindData;
	
	    var value = void 0;
	    var showValue = void 0;
	    if (bindData instanceof Array) {
	        bindData.forEach(function (element, index) {
	
	            if (index === 0) {
	                value = element[valueKey];
	                showValue = element[showKey];
	            } else {
	                value = value + "," + element[valueKey];
	                showValue = showValue + "," + element[showKey];
	            }
	        });
	    } else {
	        value = bindData[valueKey];
	        showValue = bindData[showKey];
	    }
	    this.setValue(value, showValue);
	};
	
	SgiFormInputSearch.prototype.getBindData = function () {
	    return this.state.bindData;
	};
	
	//方法特殊  重写setValue方法
	SgiFormInputSearch.prototype.setValue = function (value, showValue) {
	    // tool.sgiLogger.log(arguments.length);
	    if (arguments.length === 2) {
	        // showValue = this.state.inputprops.showValue || value;
	        this.state.inputprops.showValue = showValue;
	    } else {
	        this.state.inputprops.showValue = this.state.inputprops.showValue || value;
	    }
	    this.state.inputprops.value = value;
	
	    //页面校验
	    // this.validate(value);//刷新时不进行校验
	    this.setState({});
	
	    var _props2 = this.props,
	        moduleDesc = _props2.moduleDesc,
	        bdInst = _props2.bdInst,
	        objFct = _props2.objFct,
	        type = _props2.type;
	
	    var attname = moduleDesc.c;
	
	    //刷新对象工厂值
	    //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	    //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	    var bdInstValue;
	    if (bdInst && attname) {
	        if (typeof bdInst === "string") {
	            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	            if (type === 'tb') {
	                var bdInstKeyList = bdInst.split('`');
	                var bdInstList = objFct.get(bdInstKeyList[0]);
	                if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                    bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
	                }
	            } else {
	                bdInstValue = objFct.get(bdInst);
	            }
	        } else {
	            bdInstValue = bdInst;
	        }
	    }
	
	    if (bdInstValue) {
	        bdInstValue[attname] = value;
	    }
	};
	
	exports.SgiFormInputSearch = SgiFormInputSearch;
	exports.default = SgiFormInputSearch;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormRadio = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _StandardCode = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RadioGroup = _antd.Radio.Group;
	var RadioButton = _antd.Radio.Button;
	
	var SgiFormRadio = function (_React$Component) {
	    _inherits(SgiFormRadio, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormRadio(props) {
	        _classCallCheck(this, SgiFormRadio);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormRadio.__proto__ || Object.getPrototypeOf(SgiFormRadio)).call(this, props));
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.radio_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var showValue = this.getShowValue();
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps, { title: showValue }),
	                showValue
	            ) : _react2.default.createElement(
	                RadioGroup,
	                _extends({}, this.state.inputprops, _inputProps),
	                this.state.store
	            );
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        _this.state.store = [];
	        _this.state.scList = [];
	        _this.state.allScList = [];
	        _this.state.shows = null; //下拉窗显示项，不为空则表示启用，只能显示指定项
	
	        // 订阅标准代码更新
	        var scId = (_this.props.moduleDesc || {}).scId;
	        if (scId) _this.state.unsubscribe_sc = _StandardCode.StandardCode.subscribe(scId, function (newSCList) {
	            if (!newSCList) return;
	            _this.fitStore(newSCList);
	            _this.setState({});
	        });
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule 
	     * @param {组件描述} moduleDesc 
	     * @param {绑定实例ID} bdInst 
	     * @param {当前工作区} ws 
	     * @param {make类型} type 
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormRadio, [{
	        key: 'radio_mk',
	        value: function radio_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //组装数据
	            this.fitSelectOption(moduleDesc);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	
	            this.state.isbtn = moduleDesc.isBtn;
	        }
	
	        /**
	        * 组装下拉框内容
	        * @param {描述} moduleDesc 
	        */
	
	    }, {
	        key: 'fitSelectOption',
	        value: function fitSelectOption(moduleDesc) {
	
	            this.state.store = [];
	
	            var scId = moduleDesc.scId;
	
	            if (!scId) {
	                return;
	            }
	
	            // 下拉窗列表值在标准代码中的id
	            var comboBoxData = _StandardCode.StandardCode.getSC(moduleDesc.scId);
	            if (!comboBoxData) {
	                return;
	            }
	            this.fitStore(comboBoxData);
	
	            //参数工厂获取标准代码 暂时当获取到了 属性为'sc', 'te', 'c'
	            //下面是临时数据
	            // let scList = [];
	            // for (let i = 1; i < 5; i++) {
	            //     scList.push({ te: (i.toString(2)), c: (i.toString(2)) });
	            // }
	
	            // if (!scList || scList.length < 1) {
	            //     return;
	            // }
	
	            // scList.forEach((item, index) => {
	            //     if (this.state.isbtn) {
	            //         this.state.store.push(<RadioButton value={item.c} > {item.te} </RadioButton>);
	            //     } else {
	            //         this.state.store.push(<Radio value={item.c}> {item.te} </Radio>);
	            //     }
	            // })
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'fitStore',
	        value: function fitStore(comboBoxData, attKey, attName) {
	            var _this2 = this;
	
	            attKey = attKey || 'c';
	            attName = attName || 'te';
	
	            this.state.store = [];
	
	            var allScList = [];
	            var scList = [];
	            var size = comboBoxData.length;
	            if (!size == 0) {
	                for (var i = 0; i < size; i++) {
	                    var item = comboBoxData[i];
	                    allScList.push({ te: item[attName], c: item[attKey] });
	                }
	                this.state.allScList = allScList; //存起来
	
	                // 控制显示项
	                scList = allScList;
	                if (this.state.shows) {
	                    scList = allScList.filter(function (sc) {
	                        return _this2.state.shows.indexOf(sc.c) > -1;
	                    });
	                }
	                this.state.scList = scList;
	
	                scList.forEach(function (item, index) {
	                    if (_this2.state.isbtn) {
	                        _this2.state.store.push(_react2.default.createElement(
	                            RadioButton,
	                            { value: item.c },
	                            ' ',
	                            item.te,
	                            ' '
	                        ));
	                    } else {
	                        _this2.state.store.push(_react2.default.createElement(
	                            _antd.Radio,
	                            { value: item.c },
	                            ' ',
	                            item.te,
	                            ' '
	                        ));
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'dynamicRefreshCombox',
	        value: function dynamicRefreshCombox(comboBoxData, attKey, attName) {
	            if (!comboBoxData) {
	                return;
	            }
	            this.fitStore(comboBoxData, attKey, attName);
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'setDisabledItems',
	        value: function setDisabledItems(disabledList, attKey) {
	            var _this3 = this;
	
	            disabledList = disabledList || [];
	            attKey = attKey || 'c';
	
	            var scList = this.state.scList;
	            this.state.store = [];
	
	            scList.forEach(function (item, index) {
	                var disabled = false;
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = disabledList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var disItem = _step.value;
	
	                        if (item.c === disItem[attKey]) {
	                            disabled = true;
	                            break;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                if (_this3.state.isbtn) {
	                    _this3.state.store.push(_react2.default.createElement(
	                        RadioButton,
	                        { disabled: disabled, value: item.c },
	                        ' ',
	                        item.te,
	                        ' '
	                    ));
	                } else {
	                    _this3.state.store.push(_react2.default.createElement(
	                        _antd.Radio,
	                        { disabled: disabled, value: item.c },
	                        ' ',
	                        item.te,
	                        ' '
	                    ));
	                }
	            });
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'getShowValue',
	        value: function getShowValue() {
	            var comboBoxData = _StandardCode.StandardCode.getSC(this.props.moduleDesc.scId) || [];
	            var value = this.state.inputprops.value;
	            for (var i = 0; i < comboBoxData.length; i++) {
	                var item = comboBoxData[i];
	                if (value == item["c"]) {
	                    return item["te"];
	                }
	            }
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formItem 
	         * @param {属性} inputprops 
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            //	初始是否选中
	            //var deChekd = moduleDesc.deChekd;
	            //if(deChekd)inputprops.defaultChecked = deChekd;
	            //是否显示按钮样式
	            //设置默认选中
	            var checked = moduleDesc.checked;
	            if (checked) inputprops.defaultValue = checked;
	
	            // 显示项
	            var shows = moduleDesc.shows;
	            if (shows && shows.length > 0) this.state.shows = shows;else this.state.shows = null;
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // 取消标准代码订阅
	            var unsubscribe = this.state.unsubscribe_sc;
	            if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
	        }
	    }]);
	
	    return SgiFormRadio;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiFormRadio.defaultProps = {};
	SgiFormRadio.propTypes = {};
	Object.assign(SgiFormRadio.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	exports.SgiFormRadio = SgiFormRadio;
	exports.default = SgiFormRadio;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormSelect = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _StandardCode = __webpack_require__(81);
	
	var _SgiCompComm = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	// const store = [];
	// for (let i = 10; i < 36; i++) {
	//     store.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
	// }
	
	var SgiFormSelect = function (_React$Component) {
	    _inherits(SgiFormSelect, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormSelect(props) {
	        _classCallCheck(this, SgiFormSelect);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormSelect.__proto__ || Object.getPrototypeOf(SgiFormSelect)).call(this, props));
	
	        _this._onFocus = function () {
	            _this.state.searchVal = "";
	            _this.searchValue();
	        };
	
	        _this.onSearch = function (val) {
	            if (!_this.timer) {
	                var that = _this;
	                _this.timer = setTimeout(function () {
	                    that.searchValue();
	                    that.timer = null;
	                }, 300);
	            }
	            _this.setState({ searchVal: val });
	        };
	
	        _this.searchValue = function () {
	            var value = _this.state.searchVal;
	            // if (!value) return;
	            var data = _this.state.allScList || _StandardCode.StandardCode.getSC(_this.props.moduleDesc.scId) || [];
	            // 筛选
	            var data_ = data.filter(function (item) {
	                return item.te && item.te.indexOf(value) > -1 && (_this.state.shows && _this.state.shows.length > 0 ? _this.state.shows.indexOf(item.c) > -1 : true);
	            });
	            // 数量限制
	            if (_this.state.numLimit && (data_.length > _this.state.numLimit || value === "")) {
	                data_ = data_.slice(0, _this.state.numLimit);
	            }
	            _this.state.store = [];
	            data_.forEach(function (item, index) {
	                var pitem = _extends({}, item);
	                delete pitem.c;
	                delete pitem.te;
	                _this.state.store.push(_react2.default.createElement(
	                    Option,
	                    _extends({ value: item.c }, pitem),
	                    item.te
	                ));
	            });
	            _this.setState({});
	        };
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.select_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            var value = this.state.inputprops.value;
	            var newcomboBoxData = [];
	            if (value && !(value instanceof Array)) {
	                var valueList = value.split(","); //拆分
	                for (var i = 0; i < valueList.length; i++) {
	                    var uceC = valueList[i];
	                    newcomboBoxData.push(uceC);
	                }
	                this.state.inputprops.value = newcomboBoxData;
	            } else {
	                this.state.inputprops.value = value;
	            }
	
	            var placeholder = this.state.placeholder;
	            if (!this.state.store || this.state.store.length === 0) {
	                placeholder = this.state.emptyText;
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var showValue = this.getShowValue();
	            if (showValue === undefined) showValue = this.state.inputprops.value;
	
	            // 多选时，null会展示空标签
	            if (this.state.inputprops.value === null) this.state.inputprops.value = undefined;
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps, { title: showValue }),
	                showValue
	            ) : _react2.default.createElement(
	                _antd.Select,
	                _extends({}, this.state.inputprops, _inputProps, { placeholder: placeholder,
	                    onSearch: this.state.numLimit ? this.onSearch : undefined
	                    // onFocus={this.onFocus}
	                    // onBlur={this.onBlur}
	                }),
	                this.state.store
	            );
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        _this.state.store = []; //下拉框内容
	        _this.state.showValue = undefined; //展示的值
	        _this.state.placeholder = _this.props.moduleDesc.inpPopTe; //提示信息
	        _this.state.emptyText = _this.props.moduleDesc.emptyText; //下拉数组为空提示信息
	        _this.state.scList = [];
	        _this.state.allScList = [];
	        _this.state.shows = null; //下拉窗显示项，不为空则表示启用，只能显示指定项
	
	        // 订阅标准代码更新
	        var scId = (_this.props.moduleDesc || {}).scId;
	        if (scId) _this.state.unsubscribe_sc = _StandardCode.StandardCode.subscribe(scId, function (newSCList) {
	            if (!newSCList) return;
	            _this.fitStore(newSCList);
	            _this.setState({});
	        });
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormSelect, [{
	        key: 'select_mk',
	        value: function select_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //组装下拉框内容
	            this.fitSelectOption(moduleDesc);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'fitSelectOption',
	        value: function fitSelectOption(moduleDesc) {
	
	            this.state.store = [];
	
	            // 下拉窗列表值在标准代码中的id
	            var comboBoxData = _StandardCode.StandardCode.getSC(moduleDesc.scId);
	            if (!comboBoxData) {
	                return;
	            }
	            this.fitStore(comboBoxData);
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'fitStore',
	        value: function fitStore(comboBoxData, attKey, attName) {
	            var _this2 = this;
	
	            if (!attKey) attKey = 'c';
	            if (!attName) attName = 'te';
	
	            this.state.store = [];
	
	            var allScList = [];
	            var scList = [];
	            var size = comboBoxData.length;
	            if (!size == 0) {
	                for (var i = 0; i < size; i++) {
	                    var item = comboBoxData[i];
	                    allScList.push(_extends({ te: item[attName], c: item[attKey], itemData: item }, (0, _SgiCompComm.getPropsFromItem)(item)));
	                }
	                this.state.allScList = allScList;
	
	                // 控制显示项
	                scList = allScList;
	                if (this.state.shows && this.state.shows.length > 0) {
	                    scList = allScList.filter(function (sc) {
	                        return _this2.state.shows.indexOf(sc.c) > -1;
	                    });
	                }
	                this.state.scList = scList;
	
	                // 限制数量
	                // if (this.state.numLimit && scList.length > this.state.numLimit) {
	                //     scList = scList.slice(0, this.state.numLimit);
	                // }
	
	                scList.forEach(function (item, index) {
	                    var pitem = _extends({}, item);
	                    delete pitem.c;
	                    delete pitem.te;
	                    _this2.state.store.push(_react2.default.createElement(
	                        Option,
	                        _extends({ value: item.c }, pitem),
	                        item.te
	                    ));
	                });
	            }
	        }
	    }, {
	        key: 'dynamicRefreshCombox',
	        value: function dynamicRefreshCombox(comboBoxData, attKey, attName) {
	            if (!comboBoxData) return;
	
	            this.fitStore(comboBoxData, attKey, attName);
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'setDisabledItems',
	        value: function setDisabledItems(disabledList, attKey) {
	            var _this3 = this;
	
	            disabledList = disabledList || [];
	            attKey = attKey || 'c';
	
	            var scList = this.state.scList;
	            this.state.store = [];
	
	            scList.forEach(function (item, index) {
	                var disabled = false;
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = disabledList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var disItem = _step.value;
	
	                        if (item.c === disItem[attKey]) {
	                            disabled = true;
	                            break;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                _this3.state.store.push(_react2.default.createElement(
	                    Option,
	                    _extends({ disabled: disabled, value: item.c }, item),
	                    item.te
	                ));
	            });
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'getShowValue',
	        value: function getShowValue() {
	
	            var comboBoxData = this.state.allScList || _StandardCode.StandardCode.getSC(this.props.moduleDesc.scId) || [];
	
	            var value = this.state.inputprops.value;
	            var newcomboBoxData = [];
	            if (value && !(value instanceof Array)) {
	                var valueList = value.split(","); //拆分
	                for (var i = 0; i < valueList.length; i++) {
	                    var uceC = valueList[i];
	                    newcomboBoxData.push(uceC);
	                }
	            } else if (value) {
	                newcomboBoxData = value;
	            }
	
	            var showValue = [];
	
	            for (var j = 0; j < newcomboBoxData.length; j++) {
	                for (var _i = 0; _i < comboBoxData.length; _i++) {
	                    var item = comboBoxData[_i];
	                    if (newcomboBoxData[j] == item["c"]) {
	                        showValue.push(item["te"]);
	                        break;
	                    } else if (_i === comboBoxData.length - 1) {
	                        // 最后一个仍然不匹配
	                        showValue.push(newcomboBoxData[j]);
	                    }
	                }
	            }
	
	            return showValue.join(",");
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            //csstyle 样式文件?这个我还不知道怎么用
	            // var csstyle = moduleDesc.csstyle;
	
	            //多选
	            var mulSel = moduleDesc.mulSel;
	            if (mulSel) {
	                inputprops.mode = "multiple";
	                // inputprops.tokenSeparators = ",";
	            }
	            //mode为tags
	            var tags = moduleDesc.tags;
	            if (tags) {
	                inputprops.mode = "tags";
	            }
	            //设置是否自动选择第一个列表值，默认是true
	            var autoSel = moduleDesc.autoSel;
	            if (autoSel && this.state.store.length > 0) {
	                inputprops.defaultValue = this.state.store[0].key;
	            }
	
	            // 显示项
	            var shows = moduleDesc.shows;
	            if (shows && shows.length > 0) this.state.shows = shows;else this.state.shows = null;
	
	            //当下拉列表为空时显示的内容
	            // if (this.state.store.length < 1) {
	            //     this.state.placeholder = moduleDesc.emptyText;
	            // } else {
	            //     this.state.placeholder = moduleDesc.inpPopTe;
	            // }
	            // 设置输入值是否严格为待选列表中的存在的值，默认值为false 未解决
	            var forceSelection = moduleDesc.forceSelection;
	            //不知道干嘛用的
	            var anyMatch = moduleDesc.anyMatch;
	            //delimiter : ",", // 多选数据分隔符
	            //filterPickList : 'true',// 多选隐藏从下拉列表中的当前选定的值
	            //selType: 'checkboxmodel', //多选样式
	            //valueField : "c", // 组合框的值字段
	
	            //queryMode : 'local', // 本地模式
	
	            //typeAhead : true  //不知道什么意思
	            //是否使用搜索框
	            var showSearch = moduleDesc.showSearch;
	            inputprops.showSearch = showSearch;
	            inputprops.optionFilterProp = 'children';
	            // inputprops.allowClear = true; //支持清除
	            inputprops.allowClear = moduleDesc.allowClear; //支持清除
	            // if (showSearch) {
	            //     inputprops.showSearch = 'showSearch';
	            // }
	
	            // 下拉项数量控制
	            this.state.numLimit = moduleDesc.numLimit;
	        }
	
	        // onBlur = () => {
	        // let data = this.state.allScList || StandardCode.getSC(this.props.moduleDesc.scId) || [];
	        // this.state.store = [];
	        // data.forEach((item, index) => {
	        //     let pitem = { ...item };
	        //     delete pitem.c;
	        //     delete pitem.te;
	        //     this.state.store.push(<Option value={item.c} {...pitem}>{item.te}</Option>);
	        // })
	        // this.setState({});
	        // };
	
	        //渲染并返回一个虚拟DOM
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // 取消标准代码订阅
	            var unsubscribe = this.state.unsubscribe_sc;
	            if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
	        }
	    }]);
	
	    return SgiFormSelect;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiFormSelect.defaultProps = {};
	SgiFormSelect.propTypes = {};
	Object.assign(SgiFormSelect.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	exports.SgiFormSelect = SgiFormSelect;
	exports.default = SgiFormSelect;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormText = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiCommon = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	// import { addFormCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun'
	
	
	var SgiFormText = function (_React$Component) {
	    _inherits(SgiFormText, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormText(props) {
	        _classCallCheck(this, SgiFormText);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormText.__proto__ || Object.getPrototypeOf(SgiFormText)).call(this, props));
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.fieldCtl_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            // this.fixBdTextOnePxBug();//修复antd后置文本导致偏移bug
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            // 渲染前通用处理，如自定义样式等
	
	
	            this.renderBeforeReturn();
	
	            var ctl = this.getShowCtl(_inputProps);
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule 
	     * @param {组件描述} moduleDesc 
	     * @param {绑定实例ID} bdInst 
	     * @param {对象工厂} objFct 
	     * @param {make类型} type 
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormText, [{
	        key: 'fieldCtl_mk',
	        value: function fieldCtl_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息       
	            if (!moduleDesc) {
	                return;
	            }
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	            //添加拖拽布局信息 根据type类型
	            // addFormCtlDndInfo(this, this.state.formItemProps, this.state.inputprops, type);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formItem 
	         * @param {属性} inputprops 
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            //csstyle 样式文件?这个我还不知道怎么用
	            var csstyle = moduleDesc.csstyle;
	
	            //是否是密码控件
	            var isPwd = moduleDesc.isPwd;
	            if (isPwd) {
	                inputprops.type = "password";
	            }
	        }
	
	        /**
	         * antd的Input组件bug，当存在后置文本时，组件会上偏1px，这里要进行偏移补偿
	         */
	
	    }, {
	        key: 'fixBdTextOnePxBug',
	        value: function fixBdTextOnePxBug() {
	            var inputprops = this.state.inputprops;
	            var formItemProps = this.state.formItemProps;
	            var addonAfter = inputprops.addonAfter;
	            if (addonAfter) {
	                var style = formItemProps.style;
	                if (!style) {
	                    formItemProps.style = { marginTop: 4, marginBottom: -4 };
	                } else if (style.marginTop) {
	                    style.marginTop += 4;
	                } else if (style.marginBottom) {
	                    style.marginBottom -= 4;
	                } else {
	                    style.marginTop += 4;
	                    style.marginBottom -= 4;
	                }
	            }
	        }
	    }, {
	        key: 'getShowCtl',
	        value: function getShowCtl(_inputProps) {
	            // 优先--用户自定义渲染组件
	            var cstmRender = this.state.functions.cstmRender;
	            if (cstmRender) {
	                var _props2 = this.props,
	                    parentModule = _props2.parentModule,
	                    moduleDesc = _props2.moduleDesc,
	                    bdInst = _props2.bdInst,
	                    objFct = _props2.objFct,
	                    type = _props2.type;
	
	                return cstmRender(this, _extends({}, this.state.inputprops, _inputProps), this.state.inputprops.value, objFct);
	            }
	
	            if (_inputProps.isLabel) {
	                return _react2.default.createElement(
	                    'span',
	                    _extends({ className: 'sgiFormItemSpan' }, this.state.inputprops, _inputProps),
	                    this.state.inputprops.value,
	                    _react2.default.createElement(
	                        'span',
	                        { style: { marginLeft: "10px" } },
	                        this.state.inputprops.addonAfter
	                    )
	                );
	            } else {
	                return _react2.default.createElement(_antd.Input, _extends({}, this.state.inputprops, _inputProps));
	            }
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiFormText;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiFormText.defaultProps = {};
	SgiFormText.propTypes = {};
	Object.assign(SgiFormText.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	exports.SgiFormText = SgiFormText;
	exports.default = SgiFormText;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormTextArea = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	
	var SgiFormTextArea = function (_React$Component) {
	    _inherits(SgiFormTextArea, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormTextArea(props) {
	        _classCallCheck(this, SgiFormTextArea);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormTextArea.__proto__ || Object.getPrototypeOf(SgiFormTextArea)).call(this, props));
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.textArea_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps),
	                this.state.inputprops.value
	            ) : _react2.default.createElement(TextArea, _extends({}, this.state.inputprops, _inputProps));
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormTextArea, [{
	        key: 'textArea_mk',
	        value: function textArea_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            var ctlRow = moduleDesc.ctlRow; //行数
	            if (ctlRow) inputprops.rows = ctlRow;
	            // autosize自适应内容高度，可设置为 true|false 或对象：{ minRows: 2, maxRows: 6 }，默认false
	            // true：没有滚动条且rows不好用，false：有滚动条
	            var isScl = moduleDesc.isScl; //滚动条
	            if (!isScl) inputprops.autosize = !isScl;
	
	            //校验类型 ??未实现
	            var vldC = moduleDesc.vldC;
	
	            //csstyle 样式文件?这个我还不知道怎么用
	            var csstyle = moduleDesc.csstyle;
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiFormTextArea;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiFormTextArea.defaultProps = {};
	SgiFormTextArea.propTypes = {};
	Object.assign(SgiFormTextArea.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	exports.SgiFormTextArea = SgiFormTextArea;
	exports.default = SgiFormTextArea;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormTimePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _moment = __webpack_require__(40);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var SgiFormTimePicker = function (_React$Component) {
	    _inherits(SgiFormTimePicker, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormTimePicker(props) {
	        _classCallCheck(this, SgiFormTimePicker);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormTimePicker.__proto__ || Object.getPrototypeOf(SgiFormTimePicker)).call(this, props));
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.timePicker_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            //日期格式转换  value值转换成日期格式数据
	            var value = this.state.inputprops.value;
	            var format = this.state.inputprops.format || "HH:mm:ss";
	            if (value) {
	                this.state.showValue = (0, _moment2.default)(value, format);
	            } else {
	                this.state.showValue = null;
	            }
	
	            var defaultValue = this.state.inputprops.defaultValue;
	            if (defaultValue) {
	                this.state.inputprops.defaultValue = (0, _moment2.default)(defaultValue, format);
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps),
	                this.state.inputprops.value
	            ) : _react2.default.createElement(_antd.TimePicker, _extends({}, this.state.inputprops, _inputProps, { value: this.state.showValue }));
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormTimePicker, [{
	        key: 'timePicker_mk',
	        value: function timePicker_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            // 步长都没有应用上
	            var hourStep = moduleDesc.hourStep; //小时选项间隔
	            if (hourStep) inputprops.hourStep = hourStep;
	
	            var minuteStep = moduleDesc.minuteStep; //分钟选项间隔
	            if (minuteStep) inputprops.minuteStep = minuteStep;
	
	            var secondStep = moduleDesc.secondStep; //秒选项间隔
	            if (secondStep) inputprops.secondStep = secondStep;
	
	            //csstyle 样式文件?这个我还不知道怎么用
	            var csstyle = moduleDesc.csstyle;
	
	            var timeFmt = moduleDesc.timeFmt; //日期格式
	            if (timeFmt) {
	                inputprops.format = timeFmt;
	            }
	
	            var placeholder = moduleDesc.inpPopTe; //提示框
	            if (placeholder) {
	                inputprops.placeholder = placeholder;
	            }
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiFormTimePicker;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiFormTimePicker.defaultProps = {};
	SgiFormTimePicker.propTypes = {};
	Object.assign(SgiFormTimePicker.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	exports.SgiFormTimePicker = SgiFormTimePicker;
	exports.default = SgiFormTimePicker;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormTreeSelect = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _StandardCode = __webpack_require__(81);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.TreeSelect.TreeNode;
	var FormItem = _antd.Form.Item;
	
	var SHOW_PARENT = _antd.TreeSelect.SHOW_PARENT;
	var treeConfConstant = {
	    childrenName: 'cldSet'
	    /**
	     * 下拉树-wangj
	     */
	};
	var SgiFormTreeSelect = function (_React$Component) {
	    _inherits(SgiFormTreeSelect, _React$Component);
	
	    // 注意这里有分号
	
	
	    function SgiFormTreeSelect(props) {
	        _classCallCheck(this, SgiFormTreeSelect);
	
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiFormTreeSelect.__proto__ || Object.getPrototypeOf(SgiFormTreeSelect)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this.initState();
	        _this.state.displayField = '';
	        _this.state.saveField = '';
	        _this.state.childrenName = treeConfConstant.childrenName;
	        _this.state.treeData = [];
	        // this.state.value = undefined;
	
	        // 订阅标准代码更新
	        var scId = (_this.props.moduleDesc || {}).scId;
	        if (scId) _this.state.unsubscribe_sc = _StandardCode.StandardCode.subscribe(scId, function (newSCList) {
	            if (!newSCList) return;
	            _this.setState({ treeData: newSCList });
	        });
	
	        var _this$props = _this.props,
	            parentModule = _this$props.parentModule,
	            moduleDesc = _this$props.moduleDesc,
	            bdInst = _this$props.bdInst,
	            objFct = _this$props.objFct,
	            type = _this$props.type;
	        //组装属性
	
	        _this.treeSelect_mk(parentModule, moduleDesc, bdInst, objFct, type);
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {对象工厂} objFct
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormTreeSelect, [{
	        key: 'treeSelect_mk',
	        value: function treeSelect_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	            //绑定数据，创建表格store 搜索条、翻页控件需要使用该信息，所以先创建
	            var tableStore = this.getTreeData(moduleDesc, objFct);
	            this.state.treeData = tableStore;
	            //显示信息
	            //    this.state.displayField = moduleDesc.c ? moduleDesc.c : 'te';
	            //转换基础属性
	            this.AddTreeAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	        }
	    }, {
	        key: 'dynamicRefreshCombox',
	        value: function dynamicRefreshCombox(newlist, codeCode, textCode, childCode) {
	            this.state.displayField = textCode;
	            this.state.saveField = codeCode;
	            this.state.treeData = newlist;
	            if (childCode) {
	                this.state.childrenName = childCode;
	            }
	            this.setState({ loading: false });
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'getTreeData',
	        value: function getTreeData(moduleDesc, objFct) {
	
	            // this.state.store = []
	            //参数工厂获取标准代码 暂时当获取到了 属性为'sc', 'te', 'c'
	            //下面是临时数据
	            var scId = moduleDesc.scId; //绑定实例名
	            var tData;
	            if (scId) {
	                // 下拉窗列表值在标准代码中的id
	                tData = _StandardCode.StandardCode.getSC(scId);
	                // this.state.displayField = 'te';
	                // this.state.saveField = 'c';
	            } else {
	                var insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName); //绑定实例名
	
	                //取得绑定类名`  var tData = [];
	                if (insName && objFct) {
	                    tData = objFct.get(insName);
	                }
	            }
	            this.state.displayField = moduleDesc.showKey || 'te';
	            this.state.saveField = moduleDesc.saveKey || 'c';
	            if (!tData) {
	                return [];
	            }
	            return tData;
	        }
	        /**
	         * 创建树视图
	         */
	
	    }, {
	        key: 'AddTreeAttribute',
	        value: function AddTreeAttribute(moduleDesc, formItem, inputprops) {
	
	            //多选
	            if (moduleDesc.mulSel) {
	                // inputprops.multiple = moduleDesc.mulSel;
	                inputprops.treeCheckable = true; //选择框
	                // inputprops.showCheckedStrategy = SHOW_PARENT;
	            } else {
	                inputprops.multiple = moduleDesc.mulSel;
	                inputprops.showSearch = "showSearch"; //在下拉中显示搜索框(仅在单选模式下生效)
	            }
	            // inputprops.value = this.state.treeData;
	            // inputprops.placeholder = "请选择";//选择框默认文字
	            inputprops.treeDefaultExpandAll = true; //展开所有
	            inputprops.allowClear = "inputprops"; //允许删除按钮
	            inputprops.treeNodeFilterProp = "title"; //搜索框设置为标题
	            // inputprops.treeCheckStrictly = true;//父子节点受控
	            //显示名称
	            var showKey = moduleDesc.showKey;
	            // if (showKey) inputprops.treeNodeLabelProp = showKey; //treeNodeLabelProp保持默认属性"title"，不能修改，否则名称无法回显
	            inputprops.dropdownStyle = { maxHeight: 500, overflow: 'auto' };
	
	            // clpDrt:"top", // 面板的折叠方向
	            // clpd:false, // 面板初始时的折叠状态
	            // disCustom:false, //只显示自定义菜单
	            // isClp:false, // 面板是否可以折叠
	            // isClpFst:true, // 是否面板展开或收缩的顺序
	            // isCls:false, // 面板是否可以关闭
	            // isFrm:false, // 面板是否填充
	            // isHClpTl:false, // 是否显示折叠按钮
	            // isMsMu:false, //使用右键菜单
	            // isTlb:false, //显示工具条
	            // isttlClp:false, // 是否单击面板头部折叠
	            // tlbIsTtl:true, //显示标题
	            // ttlAlg:"top", // 面板标题位置
	            // ttlAlgn:"left", // 面板标题对齐方式
	            // selFirst:false, //初始化后选择首行
	            // 可设置默认选中的树节点：defaultSelectedKeys，（受控）设置选中的树节点：selectedKeys
	        }
	
	        // 生成下拉树 treeNodes 数据，
	
	    }, {
	        key: 'getShowValue',
	        value: function getShowValue() {
	            var _this2 = this;
	
	            var comboBoxData = this.state.treeData;
	            if (!comboBoxData) {
	                return;
	            }
	            var value = this.state.inputprops.value;
	            var newcomboBoxData = [];
	            if (value && !(value instanceof Array)) {
	                var valueList = value.split(","); //拆分
	                for (var i = 0; i < valueList.length; i++) {
	                    var uceC = valueList[i];
	                    newcomboBoxData.push(uceC);
	                }
	            } else if (value) {
	                newcomboBoxData = value;
	            }
	            var showValue = newcomboBoxData.map(function (key) {
	                return _this2.getShowValueByKey(key);
	            });
	            return showValue.join(",");
	        }
	    }, {
	        key: 'getShowValueByKey',
	        value: function getShowValueByKey(key, comboBoxData) {
	            if (!key) return null;
	            comboBoxData = comboBoxData || this.state.treeData;
	            if (!comboBoxData) return null;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = comboBoxData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var item = _step.value;
	
	                    if (item[this.state.saveField || "c"] === key) {
	                        return item[this.state.displayField || "te"];
	                    } else if (item[this.state.childrenName]) {
	                        var sonRet = this.getShowValueByKey(key, item[this.state.childrenName]);
	                        if (sonRet) return sonRet;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // 取消标准代码订阅
	            var unsubscribe = this.state.unsubscribe_sc;
	            if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
	        }
	    }]);
	
	    return SgiFormTreeSelect;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiFormTreeSelect.defaultProps = {};
	SgiFormTreeSelect.propTypes = {};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.fitTreeSels = function (data) {
	        return data.map(function (item) {
	            var childrenName = _this3.state.childrenName;
	
	            if (item[childrenName] && item[childrenName].length) {
	                return _extends({
	                    label: item[_this3.state.displayField],
	                    key: item[_this3.state.saveField] || item["_key"] || (0, _sgiCommon.uuid)(8),
	                    value: item[_this3.state.saveField],
	                    itemData: item
	                }, (0, _SgiCompComm.getPropsFromItem)(item), {
	                    // disabled: (typeof item._disabled === "boolean") ? item._disabled : undefined,
	                    // selectable: (typeof item._selectable === "boolean") ? item._selectable : undefined,
	                    // checkable: (typeof item._checkable === "boolean") ? item._checkable : undefined,
	                    // disableCheckbox: (typeof item._disableCheckbox === "boolean") ? item._disableCheckbox : undefined,
	                    children: _this3.fitTreeSels(item[childrenName])
	                });
	            }
	            return _extends({
	                label: item[_this3.state.displayField],
	                key: item[_this3.state.saveField] || item["_key"] || (0, _sgiCommon.uuid)(8),
	                value: item[_this3.state.saveField],
	                itemData: item
	            }, (0, _SgiCompComm.getPropsFromItem)(item));
	        }
	        // disabled: (typeof item._disabled === "boolean") ? item._disabled : undefined,
	        // selectable: (typeof item._selectable === "boolean") ? item._selectable : undefined,
	        // checkable: (typeof item._checkable === "boolean") ? item._checkable : undefined,
	        // disableCheckbox: (typeof item._disableCheckbox === "boolean") ? item._disableCheckbox : undefined,
	        );
	    };
	
	    this.refresh = function () {
	        _this3.loaded = false;
	        _this3.setState({ loading: false });
	    };
	
	    this.render = function () {
	        if (!this.loaded) {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                bdInst = _props.bdInst,
	                objFct = _props.objFct,
	                type = _props.type;
	            //组装属性 初始化属性到this.state
	
	            this.treeSelect_mk(parentModule, moduleDesc, bdInst, objFct, type);
	            this.loaded = true;
	        }
	
	        var value = this.state.inputprops.value;
	        var newcomboBoxData = [];
	        if (value && value.indexOf(",") > -1) {
	            var valueList = value.split(","); //拆分
	            for (var i = 0; i < valueList.length; i++) {
	                var uceC = valueList[i];
	                newcomboBoxData.push(uceC);
	            }
	            this.state.inputprops.value = newcomboBoxData;
	        } else {
	            this.state.inputprops.value = value;
	        }
	
	        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	        var _getReviseProps = this.getReviseProps(),
	            _inputProps = _getReviseProps._inputProps,
	            _formItemProps = _getReviseProps._formItemProps;
	
	        var isLabel = _inputProps.isLabel;
	
	        // 渲染前通用处理，如自定义样式等
	
	        this.renderBeforeReturn();
	
	        var showValue = this.getShowValue();
	        if (showValue === undefined) showValue = this.state.inputprops.value;
	
	        var ctl = isLabel ? _react2.default.createElement(
	            'span',
	            _extends({}, this.state.inputprops, _inputProps, { title: showValue }),
	            showValue
	        ) : _react2.default.createElement(_antd.TreeSelect, _extends({}, this.state.inputprops, _inputProps, {
	            treeData: this.fitTreeSels(this.state.treeData) }));
	
	        return this.state.noFI ? ctl : _react2.default.createElement(
	            FormItem,
	            _extends({}, this.state.formItemProps, _formItemProps),
	            ctl
	        );
	    };
	};
	
	Object.assign(SgiFormTreeSelect.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	exports.SgiFormTreeSelect = SgiFormTreeSelect;
	exports.default = SgiFormTreeSelect;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiFormUpload = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	
	var Dragger = _antd.Upload.Dragger;
	
	var SgiFormUpload = function (_React$Component) {
	    _inherits(SgiFormUpload, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiFormUpload(props) {
	        _classCallCheck(this, SgiFormUpload);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiFormUpload.__proto__ || Object.getPrototypeOf(SgiFormUpload)).call(this, props));
	
	        _this.handleCancel = function () {
	            return _this.setState({ previewVisible: false });
	        };
	
	        _this.handlePreview = function (file) {
	            _this.setState({
	                previewImage: file.url || file.thumbUrl,
	                previewVisible: true,
	                previewAlt: file.name
	            });
	        };
	
	        _this.handleChange = function (_ref) {
	            var file = _ref.file,
	                fileList = _ref.fileList;
	
	            var status = file.status;
	
	            //数量限制
	            var n = _this.state.inputprops.nLimit;
	            if (n) {
	                fileList = fileList.slice(-n);
	            }
	
	            _this.state.inputprops.fileList = fileList;
	
	            _this.setState({ loading: false });
	        };
	
	        _this.cvtShowList = function () {
	            var value = _this.state.inputprops.value;
	            var files = [];
	            if (value && typeof value === "string") {
	                var fs = value.split(",");
	                fs.forEach(function (f, index) {
	                    var fileName = void 0;
	                    if (f.indexOf("/") > 0) fileName = f.substring(f.lastIndexOf("/") + 1, f.length);else fileName = f;
	                    var file = {
	                        uid: index, //必须要有uid
	                        url: f,
	                        name: fileName,
	                        status: "done"
	                    };
	                    files.push(file);
	                });
	            }
	
	            //数量限制
	            var n = _this.state.inputprops.nLimit;
	            if (n) {
	                files = files.slice(-n);
	            }
	
	            _this.state.inputprops.fileList = files;
	        };
	
	        _this.getFileList = function () {
	            //重组fileList数组，只返回有用信息
	            var fileList = [];
	            var stateFileList = _this.state.inputprops.fileList;
	            stateFileList.forEach(function (f) {
	                var response = f.response || {};
	                var file = {
	                    url: response.fileDownloadUri || f.url,
	                    fileName: response.fileName || f.name,
	                    fileType: response.fileType || f.type,
	                    status: f.status
	                };
	                fileList.push(file);
	            });
	            return fileList;
	        };
	
	        _this.setFileList = function (fileList) {
	            if (fileList && fileList.length >= 0) {
	                _this.state.inputprops.fileList = fileList;
	                _this.setState({ loading: true });
	            }
	        };
	
	        _this.render = function () {
	            var _state = this.state,
	                previewVisible = _state.previewVisible,
	                previewImage = _state.previewImage,
	                previewAlt = _state.previewAlt;
	
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.upload_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	
	                //回显value
	                this.cvtShowList();
	            }
	
	            //修改button的禁用属性  跟随主控件
	            if (this.state.isButton) {
	                var button = this.state.types[0];
	                button.key = (0, _sgiCommon.uuid)(8);
	                button.props.disabled = this.state.inputprops.disabled;
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            // 是否隐藏上传
	            var n = this.state.inputprops.nLimit;
	            var fileList = this.state.inputprops.fileList;
	            var hidFlg = false;
	            if (n && fileList && fileList.length >= n) {
	                hidFlg = true;
	            }
	
	            var modal = _react2.default.createElement(
	                _antd.Modal,
	                { visible: previewVisible, footer: null, onCancel: this.handleCancel },
	                _react2.default.createElement('img', { alt: previewAlt, style: { width: '100%' }, src: previewImage })
	            );
	
	            var ctl = isLabel ? _react2.default.createElement(
	                'span',
	                _extends({}, this.state.inputprops, _inputProps),
	                this.state.inputprops.value
	            ) : this.state.inputprops.isDrag ? _react2.default.createElement(
	                Dragger,
	                _extends({}, this.state.inputprops, _inputProps, { className: hidFlg ? "sgi-upload-dragger-hidden" : null }),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'ant-upload-drag-icon' },
	                    _react2.default.createElement(_antd.Icon, { type: 'inbox' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'ant-upload-text' },
	                    '\u5355\u51FB\u6216\u62D6\u52A8\u6587\u4EF6\u5230\u6B64\u533A\u57DF\u8FDB\u884C\u4E0A\u4F20'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'ant-upload-hint' },
	                    '\u652F\u6301\u5355\u4E2A\u6216\u6279\u91CF\u4E0A\u4F20'
	                )
	            ) : _react2.default.createElement(
	                _antd.Upload,
	                _extends({}, this.state.inputprops, _inputProps),
	                hidFlg || this.state.formItemProps.style.display === "none" ? null : this.state.types
	            );
	
	            var fCtl = this.state.noFI ? _react2.default.createElement(
	                'div',
	                null,
	                ctl,
	                modal
	            ) : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl,
	                modal
	            );
	
	            return this.state.isButton ? _react2.default.createElement(
	                _antd.Upload,
	                _extends({}, this.state.formItemProps, this.state.inputprops, _inputProps),
	                hidFlg || this.state.formItemProps.style.display === "none" ? null : this.state.types
	            ) : fCtl;
	        };
	
	        _this.initState();
	        _this.state.buttonProps = { //自定义的
	            style: { width: "100%" }
	        };
	        _this.state.types = [];
	        _this.state.previewVisible = false; //预览可见标志
	        _this.state.previewImage = ""; //预览图片路径
	        _this.state.previewAlt = "example"; //预览图片提示
	        _this.state.isButton = false;
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {对象工厂} objFct
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiFormUpload, [{
	        key: 'upload_mk',
	        value: function upload_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.buttonProps);
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            this.bindEvent(moduleDesc, objFct, this.state.inputprops, this.state.functions, type);
	        }
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, objFct, inputprops, functions, type) {
	            var _this2 = this;
	
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, objFct, inputprops, functions, type);
	            //重写修改事件
	            var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
	            if (chgLsn) {
	                var $chgLsn;
	                try {
	                    $chgLsn = new Function("module", "objFct", "record", "nv", 'file', 'response', 'fileList', chgLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.onChange = $chgLsn;
	            }
	            inputprops.onChange = function (info) {
	                _this2.handleChange(info); //处理内部change事件
	                var file = info.file,
	                    fileList = info.fileList;
	
	                var status = file.status; //uploading done error removed
	
	                if (status === "done" || status === "removed" || status === "error") {
	                    //上传成功、删除、失败
	                    _SgiEventHandler.SgiEventHandler.onChange.call(_this2, _this2, info);
	                }
	                // var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
	                // if (chgLsn) {
	                //     var $chgLsn;
	                //     try {
	                //         $chgLsn = new Function("module", "objFct", 'file', 'fileList', 'response', "nv", chgLsn);
	                //     } catch (error) {
	                //         sgiLogger.eventErr(error);
	                //     }
	                //     // functions.onChange = $chgLsn;
	                //     if (status === "done" || status === "removed" || status === "error") {//上传成功、删除成功
	                //         $chgLsn(this, objFct, file, fileList, file.response, (file.response) ? (file.response.fileDownloadUri) : null);//处理自定义修改事件
	                //     }
	                // }
	            };
	
	            //上传前事件
	            var bfrUpld = moduleDesc.bfrUpld; // 用户自定义上传前事件
	            if (bfrUpld) {
	                var $bfrUpld;
	                try {
	                    $bfrUpld = new Function("module", "objFct", 'file', 'fileList', bfrUpld);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.beforeUpload = $bfrUpld;
	
	                inputprops.beforeUpload = function (file, fileList) {
	                    // if (_beforeUpload && typeof _beforeUpload === "function") {
	                    var _props2 = _this2.props,
	                        moduleDesc = _props2.moduleDesc,
	                        bdInst = _props2.bdInst,
	                        objFct = _props2.objFct,
	                        type = _props2.type;
	
	                    var rBoolen = $bfrUpld(_this2, objFct, file, fileList);
	                    if (typeof rBoolen === "boolean") {
	                        return rBoolen;
	                    }
	                    return true;
	                    // }
	                };
	            }
	
	            // fileClick 上传后的文件列表点击事件
	            var fileClick = moduleDesc.fileClick; // 用户自定义上传前事件
	            if (fileClick) {
	                var $fileClick;
	                try {
	                    $fileClick = new Function("module", "objFct", 'file', fileClick);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.onPreview = $fileClick;
	
	                inputprops.onPreview = function (file) {
	                    // if (_fileClick && typeof _fileClick === "function") {
	                    var _props3 = _this2.props,
	                        moduleDesc = _props3.moduleDesc,
	                        bdInst = _props3.bdInst,
	                        objFct = _props3.objFct,
	                        type = _props3.type;
	
	                    var rBoolen = $fileClick(_this2, objFct, file);
	                    if (typeof rBoolen === "boolen") {
	                        return rBoolen;
	                    }
	                    return true;
	                    // }
	                };
	            }
	            // let _beforeUpload = functions.beforeUpload;
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops, buttonProps) {
	
	            this.state.types = [];
	            var _state2 = this.state,
	                previewVisible = _state2.previewVisible,
	                previewImage = _state2.previewImage,
	                fileList = _state2.fileList;
	
	
	            var btnN = moduleDesc.btnN; // 按钮名称
	            if (btnN) inputprops.btnN = btnN;
	
	            // 关闭按钮图标 ?? 什么意思
	            var closeI = moduleDesc.closeI;
	
	            var cluW = moduleDesc.cluW; // 按钮宽度
	            if (cluW) buttonProps.style.width = cluW;
	
	            // 文件图标
	            var fileNameI = moduleDesc.fileNameI;
	
	            var iconPh = moduleDesc.iconPh; // 按钮图标
	            if (iconPh) inputprops.iconPh = iconPh;
	
	            var mulSel = moduleDesc.mulSel; // 设置是否允许多选
	            if (mulSel) inputprops.multiple = mulSel;
	
	            //只读，通过禁用就可以形式实现
	            var isRead = moduleDesc.isRead;
	
	            inputprops.action = sgiConfig.fileAction; //使用统一文件上传服务器，由配置文件决定
	            // 支持自定义文件地址
	            var action = moduleDesc.action; //上传文件地址
	            if (action) inputprops.action = action;
	
	            inputprops.headers = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	
	            if (!inputprops.headers) inputprops.headers = {};
	            // var bussType = moduleDesc.bussType;//所属项目路径
	            // if (bussType) inputprops.headers.bussType = bussType;
	            inputprops.headers.bussType = sgiConfig.bussType; //使用统一项目路径，由配置文件决定
	
	            var accept = moduleDesc.accept; //接受文件类型
	            if (accept) inputprops.accept = accept;else inputprops.accept = undefined;
	
	            var isDrag = moduleDesc.isDrag; // 是否拖拽样式
	            inputprops.isDrag = !!isDrag;
	
	            var nLimit = moduleDesc.nLimit; // 数量限制
	            inputprops.nLimit = nLimit;
	
	            var isHdnLst = moduleDesc.isHdnLst; // 是否隐藏上传列表
	            inputprops.showUploadList = !isHdnLst;
	
	            var isButton = moduleDesc.isBttn; // 是否作为普通按钮
	            this.state.isButton = !!isButton;
	            if (!inputprops.style) inputprops.style = {};
	            if (!!isButton) {
	                //补充缺少的宽度
	                inputprops.style.width = moduleDesc.ctlW;
	            } else {
	                inputprops.style.width = undefined;
	            }
	
	            // 达到数量上限是否隐藏上传
	            this.state.hdUpld = !!moduleDesc.hdUpld;
	
	            //显示类型
	            var disType = moduleDesc.disType;
	            if (!disType) {
	                this.state.types.push(_react2.default.createElement(
	                    _antd.Button,
	                    this.state.buttonProps,
	                    _react2.default.createElement(_antd.Icon, { type: iconPh }),
	                    this.state.inputprops.btnN
	                ));
	            } else if ("picture-card" == disType) {
	
	                inputprops.listType = disType;
	                inputprops.onPreview = this.handlePreview;
	                this.state.types.push(_react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_antd.Icon, { type: "plus" }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'ant-upload-text' },
	                        this.state.inputprops.btnN
	                    )
	                ));
	            } else {
	                inputprops.listType = disType;
	                this.state.types.push(_react2.default.createElement(
	                    _antd.Button,
	                    this.state.buttonProps,
	                    _react2.default.createElement(_antd.Icon, { type: iconPh }),
	                    this.state.inputprops.btnN
	                ));
	            }
	        }
	    }, {
	        key: 'setAction',
	        value: function setAction(url) {
	            if (url) {
	                this.state.inputprops.action = url;
	            }
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'setHeader',
	        value: function setHeader(headers) {
	            if (headers) {
	                for (var key in headers) {
	                    this.state.inputprops.headers[key] = headers[key];
	                }
	            }
	            this.setState({ loading: false });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiFormUpload;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiFormUpload.defaultProps = {};
	SgiFormUpload.propTypes = {};
	Object.assign(SgiFormUpload.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	//重写setValue方法 加入转换
	SgiFormUpload.prototype.setValue = function (value) {
	    //更新state
	    if (value === this.state.inputprops.value) {
	        return;
	    }
	    this.state.inputprops.value = value;
	
	    //回显value
	    this.cvtShowList();
	
	    //页面校验
	    this.validate(value);
	
	    // var { moduleDesc, bdInst, objFct, type } = this.props;
	    // let attname = moduleDesc.c
	    // //刷新对象工厂值
	    // if (bdInst && attname) {
	    //     let bdInstData = objFct.get(bdInst);
	    //     bdInstData[attname] = value;
	    // }
	};
	
	exports.SgiFormUpload = SgiFormUpload;
	exports.default = SgiFormUpload;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiIcon = function (_React$Component) {
	    _inherits(SgiIcon, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiIcon(props) {
	        _classCallCheck(this, SgiIcon);
	
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiIcon.__proto__ || Object.getPrototypeOf(SgiIcon)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性
	
	                this.icon_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            return _react2.default.createElement(_antd.Icon, this.state.inputprops);
	        };
	
	        _this.state = _extends({}, _this.state, {
	            inputprops: {
	                type: "", // 图标类型
	                spin: "", //是否有旋转动画
	                style: {}
	            },
	            loading: false
	        });
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {对象工厂} objFct
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiIcon, [{
	        key: 'icon_mk',
	        value: function icon_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.inputprops, this.state.tooltiProps, this.state.badgeProps);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, inputprops, tooltiProps, badgeProps) {
	            var type = moduleDesc.type; // 图标类型
	            if (type) inputprops.type = type;
	
	            var spin = moduleDesc.spin; //是否有旋转动画
	            if (spin) inputprops.spin = spin;
	
	            var fontSize = moduleDesc.fontSize; // 大小
	            if (fontSize) inputprops.style.fontSize = fontSize;
	
	            var color = moduleDesc.color; // 颜色
	            if (color) inputprops.style.color = color;
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiIcon;
	}(_react2.default.Component);
	
	SgiIcon.defaultProps = {};
	SgiIcon.propTypes = {};
	exports.SgiIcon = SgiIcon;
	exports.default = SgiIcon;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiImg = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _MediaResourceCode = __webpack_require__(349);
	
	var _SgiImg = __webpack_require__(2012);
	
	var _SgiImg2 = _interopRequireDefault(_SgiImg);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiImg = function (_React$Component) {
	    _inherits(SgiImg, _React$Component);
	
	    function SgiImg(props) {
	        _classCallCheck(this, SgiImg);
	
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiImg.__proto__ || Object.getPrototypeOf(SgiImg)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	
	                this.img_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '100%', width: '100%' } },
	                _react2.default.createElement('img', _extends({ className: _SgiImg2.default.pic }, this.state.imgprops))
	            );
	        };
	
	        _this.state = {
	            imgprops: {
	                style: {}
	            },
	            functions: {}
	        };
	        return _this;
	    }
	
	    /**
	    * @param {父组件} parentModule
	    * @param {组件描述} moduleDesc
	    * @param {绑定实例ID} bdInst
	    * @param {对象工厂} objFct
	    * @param {make类型} type
	    */
	
	
	    _createClass(SgiImg, [{
	        key: 'img_mk',
	        value: function img_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	            if (!moduleDesc) {
	                return;
	            }
	            this.AddImgAttribute(moduleDesc, this.state.imgprops);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.imgprops, this.state.functions, type);
	        }
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc
	         * @param {*} treeProps
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, imgprops, functions, type) {
	            //拖拽模式 不生成事件
	            if (type == 'dnd') {
	                return;
	            }
	            var eck = moduleDesc.clkLsn; // 用户自定义点击事件
	            if (eck) {
	                var $eck = new Function("module", "objFct", eck);
	                functions.onClick = $eck;
	                imgprops.onClick = _SgiEventHandler.SgiEventHandler.onClick.bind(this);
	            }
	        }
	    }, {
	        key: 'AddImgAttribute',
	        value: function AddImgAttribute(moduleDesc, imgprops) {
	            //显示图片
	            var scId = moduleDesc.scId;
	            if (scId) {
	                var url = _MediaResourceCode.MediaResourceCode.getPrmUrl(scId);
	                if (url) {
	                    imgprops.src = url;
	                }
	            } else {
	                var disply = moduleDesc.disply;
	                if (disply) {
	                    imgprops.src = disply;
	                }
	            }
	
	            var show = moduleDesc.alt;
	            if (show) {
	                imgprops.alt = show;
	            }
	            //图片的大小设置
	            var ctlH = moduleDesc.ctlH;
	            if (ctlH) {
	                imgprops.style.height = ctlH;
	            }
	            var ctlW = moduleDesc.ctlW;
	            if (ctlW) {
	                imgprops.style.width = ctlW;
	            }
	
	            var isHdn = moduleDesc.isHdn; //是否隐藏
	            if (isHdn) {
	                imgprops.style.display = "none";
	            } else {
	                imgprops.style.display = undefined;
	            }
	        }
	    }, {
	        key: 'setUrl',
	        value: function setUrl(url) {
	            this.state.imgprops.src = url;
	            this.setState(this.state.imgprops);
	        }
	    }, {
	        key: 'setHidden',
	        value: function setHidden(hdn) {
	            if (hdn) {
	                this.state.imgprops.style.display = "none";
	            } else {
	                this.state.imgprops.style.display = undefined;
	            }
	            if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	                // react16需要更新引用
	                this.state.imgprops.style = _extends({}, this.state.imgprops.style);
	            }
	            this.setState(this.state.imgprops);
	        }
	    }]);
	
	    return SgiImg;
	}(_react2.default.Component);
	
	SgiImg.defaultProps = {};
	SgiImg.props = {};
	exports.SgiImg = SgiImg;
	exports.default = SgiImg;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiLabel = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiLabel = function (_React$Component) {
	    _inherits(SgiLabel, _React$Component);
	
	    function SgiLabel(props) {
	        _classCallCheck(this, SgiLabel);
	
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiLabel.__proto__ || Object.getPrototypeOf(SgiLabel)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	
	                this.label_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            // 渲染前通用处理，如自定义样式等
	            this.renderBeforeReturn(this.state.labelprops);
	
	            return _react2.default.createElement(
	                'div',
	                this.state.labelprops,
	                this.state.labelprops.value
	            );
	        };
	
	        _this.state = {
	            labelprops: { style: {} },
	            loading: false
	        };
	        return _this;
	    }
	
	    /**
	    * @param {父组件} parentModule
	    * @param {组件描述} moduleDesc
	    * @param {绑定实例ID} bdInst
	    * @param {对象工厂} objFct
	    * @param {make类型} type
	    */
	
	
	    _createClass(SgiLabel, [{
	        key: 'label_mk',
	        value: function label_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	            // if (!moduleDesc) {
	            //     return;
	            // }
	            this.AddLabelAttribute(moduleDesc, this.state.labelprops);
	        }
	    }, {
	        key: 'AddLabelAttribute',
	        value: function AddLabelAttribute(moduleDesc, labelprops) {
	
	            if (moduleDesc.te || moduleDesc.teid) {
	                //避免不必要的执行getTRByPrm()方法
	                var text = Resource.getTRByPrm(moduleDesc).te; //设置标签
	                if (text) labelprops.value = text;
	            }
	
	            var height = moduleDesc.ctlH;
	            if (height) labelprops.style.height = height;
	            var width = moduleDesc.ctlW;
	            if (width) labelprops.style.width = width;
	
	            //显示图片
	            // var disply = moduleDesc.disply;
	            // if(disply){ 
	            //     labelprops.src = disply;    
	            // }
	            // var show = moduleDesc.alt;
	            // if(show){
	            //     labelprops.alt = show;
	            // }
	            // //图片的大小设置
	            // 
	
	            // 自定义样式
	            var cstmStyle = moduleDesc.cstmStyle;
	            var $cstmStyle = void 0;
	            if (cstmStyle) {
	                try {
	                    $cstmStyle = new Function("module", "objFct", cstmStyle);
	                } catch (error) {
	                    sgiLogger.eventErr(error);
	                }
	                // this.state.cstmStyle = $cstmStyle;
	                (0, _SgiCommon.setFunction)(this, "cstmStyle", $cstmStyle);
	            }
	        }
	    }, {
	        key: 'setValue',
	        value: function setValue(value) {
	            if (value === this.state.labelprops.value) return;
	
	            this.state.labelprops.value = value;
	
	            this.setState({});
	        }
	    }]);
	
	    return SgiLabel;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiLabel.defaultProps = {};
	SgiLabel.props = {};
	Object.assign(SgiLabel.prototype, _SgiCtnComm.sgiCtnBaseFun);
	
	exports.SgiLabel = SgiLabel;
	exports.default = SgiLabel;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconText = function IconText(_ref) {
	    var type = _ref.type,
	        text = _ref.text,
	        onClick = _ref.onClick;
	    return _react2.default.createElement(
	        'span',
	        { onClick: typeof onClick == "function" ? onClick : null },
	        _react2.default.createElement(_antd.Icon, { type: type, style: { marginRight: 8 } }),
	        text
	    );
	};
	
	var SgiList = function (_React$Component) {
	    _inherits(SgiList, _React$Component);
	
	    // //这个暂时不好用 以后在处理
	    // static defaultProps = {
	    // };  // 注意这里有分号
	    // static propTypes = {
	    // };  // 注意这里有分号
	
	    function SgiList(props) {
	        _classCallCheck(this, SgiList);
	
	        var _this = _possibleConstructorReturn(this, (SgiList.__proto__ || Object.getPrototypeOf(SgiList)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.getIconTexts = function (data) {
	            if (!data) return null;
	            return data.map(function (item) {
	                return _react2.default.createElement(IconText, item);
	            });
	        };
	
	        _this.getAs = function (data) {
	            if (!data) return null;
	            return data.map(function (item) {
	                return _react2.default.createElement(
	                    'a',
	                    item,
	                    item.text
	                );
	            });
	        };
	
	        _this.state = {
	            listProps: { style: { heigth: '100%', width: '100%', padding: "0 20px" } }, //list全局属性
	            listItemProps: { style: { heigth: '100%', width: '100%' } }, //item属性
	            listItems: [], //子组件数组
	            dataSource: _this.props.dataSource || [] //{data},
	
	            // renderItem : undefined,//{item => (<List.Item>{item}</List.Item>)},
	            // bordered : true,//是否展示边框	boolean	false
	            // footer : undefined,//列表底部	string|ReactNode	-
	            // grid : undefined,//列表栅格配置	object	-
	            // header : undefined,//列表头部	string|ReactNode	-
	            // itemLayout : undefined,//设置 List.Item 布局, 设置成 vertical 则竖直样式显示, 默认横排	string	-
	            // loading : undefined,//当卡片内容还在加载中时，可以用 loading 展示一个占位	boolean|object (更多)	false
	            // locale : undefined,//默认文案设置，目前包括空数据文案	object	emptyText: '暂无数据'
	            // loadMore : undefined,//加载更多	string|ReactNode	-
	            // pagination : undefined,//对应的 pagination 配置, 设置 false 不显示	boolean|object	false
	            // size : undefined,//list 的尺寸	default | middle | small	default
	            // split : undefined,//是否展示分割线	boolean	true
	
	            // ctnProps: { style: {} },//form属性
	            // listProps: { style: { heigth: '100%', width: '100%' } },//list全局属性
	            // listTitleProps: { style: {} },//list的title属性
	            // listBodyProps: { style: {} },//list的body属性
	            // listItems: [], //面板下控件数组loading
	            // loading: false,
	            // toolbarTopItems: [],
	            // toolbarBottomItems: []
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建list
	     * @param {父组件} parentModule 
	     * @param {描述} moduleDesc       
	     * @param {对象工厂} objFct 
	     * @param {make类型} type 
	     */
	
	
	    _createClass(SgiList, [{
	        key: 'list_mk',
	        value: function list_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.listItems = []; //再次渲染的时候清空
	
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.listProps, this.state.listItemProps, parentModule, objFct);
	            //绑定事件
	            // this.bindEvent(moduleDesc, this.state.listProps);
	            //组装form表单下的控件信息
	            // if (type !== "dnd") this.fitListItems(moduleDesc, this.state.listItems, objFct, type);
	        }
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formProps 
	         */
	
	    }, {
	        key: 'fitListItems',
	        value: function fitListItems(moduleDesc, listItems, objFct, type) {}
	        // var me = this;
	
	        // let bdInst = moduleDesc.bdInst;
	        // if(!bdInst) return;
	        // let datas = objFct.get(bdInst);
	        // if(!Array.isArray(datas)) return;
	        // datas.forEach(data => {
	
	        // });
	
	        // listData.forEach(data => {
	
	        //     // listItems.push(<List.Item key={item.title} extra={item.description}/>);
	        //     listItems.push(convertModuleByGuid(this, moduleDesc, null, objFct, type));
	        // });
	
	        // let cldSet = moduleDesc.cldSet;
	        // if (cldSet && cldSet.length && cldSet.length > 0) {
	        //     cldSet.forEach((item, index) => {
	        //         if (item.desId === AllCompGUID.TOOLBAR) {
	        //             if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
	        //                 this.state.toolbarTopItems.push(convertModuleByGuid(this, item, null, objFct, type));
	        //             } else {
	        //                 this.state.toolbarBottomItems.push(convertModuleByGuid(this, item, null, objFct, type));
	        //             }
	        //         } else {
	        //             listItems.push(convertModuleByGuid(me, item, null, objFct, type));
	        //         }
	        //     });
	        // }
	
	
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc
	         * @param {*} tabsProps
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, tabsProps, functions, type) {
	            // //拖拽模式 不生成事件
	            // var lsn = moduleDesc.tabLsn;// 选项卡监听器
	            // // var lsn = "tool.sgiLogger.log('11111111111111111',ComponentManager)"
	            // if (lsn && type != 'dnd') {
	            //     try {
	            //         var $tcl = new Function("module", "objFct", "activeKey", lsn);
	            //         functions.tab = $tcl;
	            //     } catch (e) {
	            //         sgiLogger.eventErr(e);
	            //     }
	            // }
	            // tabsProps.onChange = SgiEventHandler.tcl.bind(this);
	        }
	    }, {
	        key: 'render',
	
	
	        //渲染并返回一个虚拟DOM
	        value: function render() {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性
	
	                this.list_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            tool.sgiLogger.log("dataSource", this.state.listProps.dataSource);
	
	            return _react2.default.createElement(_antd.List, this.state.listProps);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc 
	         * @param {属性} listProps 
	         */
	
	    }, {
	        key: 'AddAttribute',
	        value: function AddAttribute(moduleDesc, listProps, listItemProps, parentModule, objFct) {
	            var _this2 = this;
	
	            // var type;
	            // if (parentModule && parentModule.state && parentModule.state.itemListType) {
	            //     type = parentModule.state.itemListType;
	            // }
	
	            // listProps.itemLayout = moduleDesc.itemLayout || "vertical";
	            // listProps.size = "large";
	            // listProps.pagination = {
	            //     onChange: (page) => {
	            //         tool.sgiLogger.log(page);
	            //     },
	            //     pageSize: 3,
	            // };
	            var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
	            if (bdInst && objFct) listProps.dataSource = objFct.get(bdInst);
	            // listProps.dataSource = listData;
	
	            // listProps.footer = (<div><b>ant design</b> footer part</div>);
	            var listStyle = moduleDesc.listStyle;
	            if (listStyle == "image") {
	                listProps.itemLayout = "vertical";
	                listProps.renderItem = function (item) {
	                    return _react2.default.createElement(
	                        _antd.List.Item,
	                        {
	                            key: item.title,
	                            actions: _this2.getIconTexts(item.actions),
	                            extra: _react2.default.createElement('img', item.extra) },
	                        _react2.default.createElement(_antd.List.Item.Meta, {
	                            // avatar={<Avatar src={item.avatar} />}
	                            title: _react2.default.createElement(
	                                'a',
	                                { href: item.href },
	                                item.title
	                            ),
	                            description: _this2.doSthForStr(item.description)
	                        }),
	                        _this2.doSthForStr(item.content)
	                    );
	                };
	            } else if (listStyle == "avatar") {
	                listProps.itemLayout = "horizontal";
	                listProps.renderItem = function (item) {
	                    return _react2.default.createElement(
	                        _antd.List.Item,
	                        {
	                            actions: _this2.getAs(item.actions) },
	                        _react2.default.createElement(_antd.List.Item.Meta, {
	                            avatar: _react2.default.createElement(_antd.Avatar, { src: item.avatar }),
	                            title: _react2.default.createElement(
	                                'a',
	                                { href: item.href },
	                                item.title
	                            ),
	                            description: item.description
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            item.content
	                        )
	                    );
	                };
	            }
	
	            // var text = listProps.te;//公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
	            // if (text) listProps.header = text;
	
	            // var isTtl = moduleDesc.isTtl; //form是否显示标题
	            // if (!isTtl) {
	            //     listTitleProps.style.display = "none";
	            // } else {
	            //     listTitleProps.style.display = undefined;
	            // }
	        }
	    }, {
	        key: 'doSthForStr',
	        value: function doSthForStr(str) {
	            if (!str) return str;
	            var strArr = str.split("\r\n");
	            return strArr.map(function (s) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    s
	                );
	            });
	        }
	    }]);
	
	    return SgiList;
	}(_react2.default.Component);
	
	exports.SgiList = SgiList;
	exports.default = SgiList;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiMenu = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _StandardCode = __webpack_require__(81);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubMenu = _antd.Menu.SubMenu;
	var MenuItemGroup = _antd.Menu.ItemGroup;
	
	// let data = [
	//     {
	//         mode:'sub',
	//         menuId: 1,
	//         name: '员工管理',
	//         children: [
	//             {
	//                 mode:'item',
	//                 menuId: 3,
	//                 name: '添加员工',
	//                 children: []
	//             },
	//             {
	//                 mode:'sub',
	//                 menuId: 4,
	//                 name: '删除员工',
	//                 children: [
	//                     {
	//                         mode:'item',
	//                         menuId: 6,
	//                         name: '按姓名删除',
	//                         children: []
	//                     },
	//                     {
	//                         mode:'sub',
	//                         menuId: 7,
	//                         name: '按工号删除',
	//                         children: [
	//
	//                             {
	//                                 mode:'item',
	//                                 menuId: 8,
	//                                 name: '按工号删除1',
	//                                 children: []}
	//                         ]
	//                     }
	//                 ]
	//             }
	//         ],
	//     },
	//     {
	//         mode:'sub',
	//         menuId: 2,
	//         name: '工资管理',
	//         children: [
	//             {
	//                 mode:'item',
	//                 menuId: 5,
	//                 name: '修改工资',
	//                 children: []
	//             }
	//         ],
	//     },
	//     {
	//         mode:'item',
	//         menuId: 9,
	//         name: '财务管理',
	//         children: [
	//         ],
	//     },
	// ];
	
	
	var SgiMenu = function (_React$Component) {
	    _inherits(SgiMenu, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiMenu(props) {
	        _classCallCheck(this, SgiMenu);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiMenu.__proto__ || Object.getPrototypeOf(SgiMenu)).call(this, props));
	
	        _this.fitMenuItems = function (data) {
	            return data.map(function (item) {
	                var childrenName = _this.state.childrenName;
	
	                var icon = item["_icon"] || "appstore";
	                var title = _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_antd.Icon, { type: icon }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        item[_this.state.displayField]
	                    )
	                );
	
	                if (item[childrenName] && item[childrenName].length) {
	                    return _react2.default.createElement(SubMenu, { itemData: item, title: title, key: (0, _sgiCommon.uuid)(8), children: _this.fitMenuItems(item[childrenName]) });
	                }
	                return _react2.default.createElement(
	                    _antd.Menu.Item,
	                    { itemData: item, key: (0, _sgiCommon.uuid)(8) },
	                    title
	                );
	            });
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.menu_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            return _react2.default.createElement(
	                _antd.Menu,
	                this.state.inputprops,
	                this.fitMenuItems(this.state.menuData)
	            );
	        };
	
	        _this.initState();
	        _this.state.displayField = '';
	        _this.state.saveField = '';
	        _this.state.childrenName = 'cldSet';
	        _this.state.menuData = [];
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiMenu, [{
	        key: 'menu_mk',
	        value: function menu_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	            //绑定数据，创建表格store 搜索条、翻页控件需要使用该信息，所以先创建
	            var menuStore = this.getMenuData(moduleDesc, objFct);
	            this.state.menuData = menuStore;
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换form公共属性
	            // AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps,this.state.inputprops );
	            //设置布局
	            // setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.inputprops, this.state.functions);
	            //绑定值
	            // bindValue(this, moduleDesc, bdInst, objFct,this.state.formItemProps, this.state.inputprops);
	        }
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, inputprops, functions, type) {
	            //拖拽模式 不生成事件
	            if (type == 'dnd') {
	                return;
	            }
	            var iCLsn = moduleDesc.iCLsn; // 用户自定义点击事件
	            if (iCLsn) {
	                var $iCLsn = new Function("module", "objFct", "itemData", "item", iCLsn);
	                functions.onClick = $iCLsn;
	                inputprops.onClick = _SgiEventHandler.SgiEventHandler.menuClick.bind(this);
	            }
	        }
	
	        /**
	        * 组装下拉框内容
	        * @param {描述} moduleDesc
	        */
	
	    }, {
	        key: 'getMenuData',
	        value: function getMenuData(moduleDesc, objFct) {
	
	            // this.state.store = []
	            //参数工厂获取标准代码 暂时当获取到了 属性为'sc', 'te', 'c'
	            //下面是临时数据
	            var scId = moduleDesc.rSC; //绑定实例名
	            var tData;
	            if (scId) {
	                // 下拉窗列表值在标准代码中的id
	                tData = _StandardCode.StandardCode.getSC(scId);
	                this.state.displayField = 'te';
	                this.state.saveField = 'c';
	            } else {
	                var insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName); //绑定实例名
	
	                //取得绑定类名`  var tData = [];
	                if (insName && objFct) {
	                    tData = objFct.get(insName);
	                }
	                this.state.displayField = moduleDesc.showKey;
	                this.state.saveField = moduleDesc.saveKey;
	            }
	            if (!tData) {
	                return [];
	            }
	            return tData;
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItemProps, inputprops) {
	            //菜单位置
	            var mode = moduleDesc.mode;
	            if (mode && mode == "horizontal") {
	                //水平
	                inputprops.mode = "horizontal";
	            } else if (mode && mode == "inline") {
	                //垂直菜单
	                inputprops.mode = "inline";
	                // inputprops.inlineCollapsed = false;
	                // inputprops.style= {width:235};
	            } else if (mode && mode == "vertical") {
	                //垂直弹出
	                inputprops.mode = "vertical";
	            } else if (mode && mode == "vertical-right") {
	                //垂直向下弹出
	                inputprops.mode = "vertical-right";
	            }
	
	            // 主题颜色
	            var theme = moduleDesc.theme;
	            if (theme) inputprops.theme = theme;
	
	            // inline 时菜单是否收起状态
	            // var inlineCollapsed = moduleDesc.inlineCollapsed;
	            // if (inlineCollapsed) inputprops.inlineCollapsed = inlineCollapsed;
	
	            // 宽，高
	            var width = moduleDesc.ctlW;
	            if (width) inputprops.style.width = width;
	            var height = moduleDesc.ctlH;
	            if (height) inputprops.style.height = height;
	        }
	
	        /**
	        * 递归生成菜单
	        * @param menuObj
	        * @returns {Array}
	        */
	        // generateMenu(menuObj) {
	        //     var items;
	        //     var vdom = [];
	        //     var  childSize = menuObj.length;
	        //     for (var i = 0; i < childSize; i++) {
	        //         var wvJson = menuObj[i];
	        //         if(wvJson.mode == "sub"){
	        //             items = this.generateMenu1(wvJson.children);
	        //             vdom.push(<SubMenu title={<span><Icon type="setting" />{wvJson.name}</span>}>
	        //             {items}
	        //             </SubMenu>);
	        //
	        //         }else if(wvJson.mode == "item"){
	        //             vdom.push(<Menu.Item key ={wvJson.key}>{wvJson.name}</Menu.Item>);
	        //         }
	        //     }
	        //     return vdom;
	        //
	        // }
	        // generateMenu1(menuObj) {
	        //     var items;
	        //     var vdom = [];
	        //     var  childSize = menuObj.length;
	        //     for (var i = 0; i < childSize; i++) {
	        //         var wvJson = menuObj[i];
	        //         if(wvJson.mode == "sub"){
	        //             items = this.generateMenu1(wvJson.children);
	        //             vdom.push(<SubMenu title={<span><Icon type="setting" />{wvJson.name}</span>}>
	        //             {items}
	        //             </SubMenu>);
	        //
	        //         }else if(wvJson.mode == "item"){
	        //             vdom.push(<Menu.Item key ={wvJson.key}>{wvJson.name}</Menu.Item>);
	        //         }
	        //     }
	        //
	        //     return vdom;
	        //
	        // }
	        // fitTreeNodes1(comboBoxData) {
	        //     var items;
	        //     let scList = [];
	        //     let childrenName = this.state.childrenName;
	        //     var size = comboBoxData.length;
	        //     for (let i = 0; i < size; i++) {
	        //         var item = comboBoxData[i];
	        //         if(item[childrenName]&& item[childrenName].length){
	        //             items = this.fitTreeNodes2(item[childrenName]);
	        //             scList.push(<SubMenu title={item[this.state.displayField]} key={item[this.state.saveField]} children={items}/>);
	        //         }
	        //          scList.push(<Menu.Item key ={item[this.state.saveField]}>{item[this.state.displayField]}</Menu.Item>);
	        //     }
	        //     return scList;
	        // };
	        //
	        // fitTreeNodes2(comboBoxData) {
	        //     var items;
	        //     let scList = [];
	        //     let childrenName = this.state.childrenName;
	        //     var size = comboBoxData.length;
	        //     for (let i = 0; i < size; i++) {
	        //         var item = comboBoxData[i];
	        //         if(item[childrenName]&& item[childrenName].length){
	        //             items = this.fitTreeNodes2(item[childrenName]);
	        //              scList.push(<SubMenu title={item[this.state.displayField]} key={item[this.state.saveField]} children={items}/>);
	        //         }
	        //          scList.push(<Menu.Item key ={item[this.state.saveField]}>{item[this.state.displayField]}</Menu.Item>);
	        //     }
	        //     return scList;
	        // };
	
	        // 生成菜单子项，不写key不报错
	
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiMenu;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiMenu.defaultProps = {};
	SgiMenu.propTypes = {};
	Object.assign(SgiMenu.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	exports.SgiMenu = SgiMenu;
	exports.default = SgiMenu;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiMainComp = __webpack_require__(125);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var SgiModal = function (_React$Component) {
	    _inherits(SgiModal, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiModal(props) {
	        _classCallCheck(this, SgiModal);
	
	        //初始化state属性
	        // this.initState();
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiModal.__proto__ || Object.getPrototypeOf(SgiModal)).call(this, props));
	
	        _this.render = function () {
	            return _react2.default.createElement(
	                _antd.Modal,
	                _extends({ centered: true }, this.state.popProps, { visible: this.state.visible, wrapClassName: this.state.wrapClassName }),
	                this.state.popItems
	            );
	        };
	
	        _this.state = {
	            popProps: { style: {} }, // 弹出窗自身属性
	            popItems: [], // 弹出窗内容
	            visible: _this.props.visible, // 弹出窗对话框是否可见
	            functions: {}
	        };
	
	        var _this$props = _this.props,
	            uid = _this$props.uid,
	            objFct = _this$props.objFct,
	            curtitle = _this$props.curtitle,
	            onCancel = _this$props.onCancel;
	        //组装属性 初始化属性到this.state
	
	        _this.modal_mk(uid, objFct, curtitle, onCancel);
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {弹出页面guid} uid
	     * @param {对象工厂} objFct
	     * @param {弹出窗标题} curtitle
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiModal, [{
	        key: 'modal_mk',
	        value: function modal_mk(uid, objFct, curtitle, onCancel) {
	            //获取需要展示的数据信息
	            if (!uid) {
	                return;
	            }
	            var uiJson = _PrmFactory.PrmFactory.getPrm(uid);
	            if (!uiJson) {
	                return;
	            }
	            //转换基础属性
	            this.AddInputAttribute(uiJson, this.state.popProps, curtitle, onCancel);
	            //绑定事件
	            this.bindEvent(uiJson, this.state.popProps, this.state.functions);
	            // 添加弹出内容
	            this.state.popItems.push(_react2.default.createElement(_SgiMainComp.SgiMainComp, { objFct: objFct, moduleDesc: uiJson }));
	        }
	
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc
	         * @param {*} treeProps
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(uiJson, popProps, functions) {
	            var clsLsn = uiJson.clsLsn; // 用户自定义关闭事件
	            if (clsLsn) {
	                var $clsLsn = new Function("module", "objFct", "e", clsLsn);
	                functions.afterClose = $clsLsn;
	            }
	            popProps.afterClose = _SgiEventHandler.SgiEventHandler.ctnCls.bind(this);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} popProps
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, popProps, curtitle, onCancel) {
	            var _this2 = this;
	
	            if (curtitle) {
	                popProps.title = curtitle;
	            } else {
	                if (moduleDesc.te || moduleDesc.teid) {
	                    //避免不必要的执行getTRByPrm()方法
	                    var title = _Resource.Resource.getTRByPrm(moduleDesc).te; //标题
	                    if (title) popProps.title = title;
	                }
	            }
	            popProps.closable = true; //显示右上角的关闭按钮
	            popProps.maskClosable = false; //点击蒙层是否允许关闭
	            popProps.onCancel = function () {
	                //点击遮罩层或右上角叉或取消按钮的回调
	                _this2.setState({
	                    visible: false
	                });
	                onCancel();
	            };
	
	            var ctlW = moduleDesc.ctlW;
	            var fixedW = ctlW && (typeof ctlW === "number" || typeof ctlW === "string" && ctlW.indexOf("%") === -1) ? ctlW : "80%";
	            popProps.width = this.props.width || fixedW;
	            // var width = this.props.width;//moduleDesc.ctlW; // 宽度，string|number	520
	            // if (width) {
	            //     popProps.width = width;
	            // } else {
	            //     popProps.width = "80%";
	            // }
	
	            var ctlH = moduleDesc.ctlH;
	            var fixedH = ctlH && (typeof ctlH === "number" || typeof ctlH === "string" && ctlH.indexOf("%") === -1) ? ctlH : "80%";
	            var height = this.props.height; //moduleDesc.ctlH;
	            if (height) {
	                popProps.height = height;
	                this.state.wrapClassName = "sgiModal";
	            } else {
	                popProps.height = fixedH;
	                this.state.wrapClassName = undefined;
	            }
	
	            // if (!popProps.style) popProps.style = {};
	            // popProps.style.overflow = "hidden"; // 强制子组件不得超出父组件
	
	            // 底部内容，当不需要默认底部按钮时，可以设为 footer={null}
	            popProps.footer = null; //不需要确认取消按钮
	            // var footer = moduleDesc.footer;
	            // if (footer == null) {
	            //   inputprops.footer = footer;
	            // }else if (footer.length != 0) {
	            //   inputprops.footer = footer;
	            // }
	        }
	        /**
	         * 关闭，直接调用afterClose就可以关闭
	         * @return {[type]} [description]
	         */
	
	    }, {
	        key: 'onCancel',
	        value: function onCancel() {
	            this.state.popProps.afterClose();
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiModal;
	}(_react2.default.Component);
	
	SgiModal.defaultProps = {};
	SgiModal.propTypes = {};
	exports.SgiModal = SgiModal;
	exports.default = SgiModal;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiNest = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiMainComp = __webpack_require__(125);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiPanel = __webpack_require__(251);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var SgiNest = function (_React$Component) {
	    _inherits(SgiNest, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiNest(props) {
	        _classCallCheck(this, SgiNest);
	
	        var _this = _possibleConstructorReturn(this, (SgiNest.__proto__ || Object.getPrototypeOf(SgiNest)).call(this, props));
	
	        _this.AddAttribute = function (moduleDesc, formProps) {}
	        //嵌入UID
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formProps 
	         */
	        ;
	
	        _this.fitPanelItems = function (moduleDesc, panelItems, objFct, type) {
	            var me = this;
	
	            var uijson = moduleDesc.nestDesc;
	            var uid = moduleDesc.uid;
	
	            if (!uijson) {
	                if (!uid) {
	                    // 显示缺省信息
	                    this.showDefault(panelItems, moduleDesc);
	                    return;
	                }
	
	                uijson = _PrmFactory.PrmFactory.getPrm(uid);
	                if (!uijson) {
	                    // 显示缺省信息
	                    this.showDefault(panelItems, moduleDesc);
	                    return;
	                }
	                if (!uijson.desId) {
	                    uijson.desId = "EP_EO_UI_0001";
	                }
	            }
	
	            if (!objFct) {
	                if (!uid) return;
	
	                objFct = new _ObjFactory.ObjFactory();
	                objFct.set('@currentObjFctUID', uid);
	            }
	            panelItems.push((0, _SgiCompComm.convertModuleByGuid)(this, uijson, null, objFct, type));
	        };
	
	        _this.showDefault = function (panelItems, moduleDesc) {
	            var showStr = moduleDesc.te || moduleDesc.n || moduleDesc.key || (0, _SgiCommon.getConstByKey)(_this, moduleDesc.cId);
	            if (!showStr) return;
	            var showText = _react2.default.createElement(
	                'div',
	                null,
	                showStr
	            );
	            panelItems.push(_react2.default.createElement(
	                'div',
	                { style: {
	                        width: "100%", height: "100%", border: "1px dashed gray",
	                        display: "flex", justifyContent: "center", alignItems: "center"
	                    } },
	                showText
	            ));
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.refreshByUI = function (ui) {
	            if (!ui) return;
	            if (typeof ui === "string") _this.props.moduleDesc.uid = ui;else _this.props.moduleDesc.nestDesc = ui;
	            _this.loaded = false;
	            _this.setState({});
	        };
	
	        _this.render = function () {
	            var objFct = this.props.objFct;
	
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.nest_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            // 通用渲染前处理，添加自定义样式等
	            this.renderBeforeReturn(this.state.formProps);
	
	            return _react2.default.createElement(
	                'div',
	                this.state.formProps,
	                this.state.panelItems
	            );
	        };
	
	        _this.state = {
	            formProps: { style: { height: '100%', width: '100%' } },
	            loading: false,
	            panelItems: []
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {弹出页面guid} uid
	     * @param {对象工厂} objFct
	     * @param {弹出窗标题} curtitle
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiNest, [{
	        key: 'nest_mk',
	        value: function nest_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.panelItems = []; //再次渲染的时候清空
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.formProps);
	            //转换form公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.formProps);
	            //组装form表单下的控件信息
	            if (type !== "dnd") {
	                this.fitPanelItems(moduleDesc, this.state.panelItems, objFct, type);
	            } else {
	                this.fitPanelItems(moduleDesc, this.state.panelItems, objFct, "dnd-nest");
	            }
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiNest;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiNest.defaultProps = {};
	SgiNest.propTypes = {};
	Object.assign(SgiNest.prototype, _SgiCtnComm.sgiCtnBaseFun);
	exports.SgiNest = SgiNest;
	exports.default = SgiNest;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _Resource = __webpack_require__(67);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiConstants = __webpack_require__(198);
	
	var _sgiConstants2 = _interopRequireDefault(_sgiConstants);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiOverlap = function (_React$Component) {
	    _inherits(SgiOverlap, _React$Component);
	
	    function SgiOverlap(props) {
	        _classCallCheck(this, SgiOverlap);
	
	        var _this = _possibleConstructorReturn(this, (SgiOverlap.__proto__ || Object.getPrototypeOf(SgiOverlap)).call(this, props));
	
	        _this.setActiveItem = function (activeKey, didMountCallback) {
	            _this.state.activeKey = activeKey;
	            var module = _this.state.PanelItems[activeKey];
	            if (module) module.props.didMountCallback = didMountCallback;
	            _this.setState({});
	        };
	
	        _this.getActiveItem = function () {
	            return _this.state.activeKey;
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded || this.props.type == 'dnd') {
	                //组装属性
	                this.Overlap_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            var _state = this.state,
	                PanelItems = _state.PanelItems,
	                activeKey = _state.activeKey,
	                allDidMountCallback = _state.allDidMountCallback;
	
	            // let activeItem = PanelItems[activeKey];
	            // if (!activeItem) {
	            //     const cldSet = moduleDesc.cldSet || [];
	            //     const me = this;
	            //     cldSet.some((item, index) => {
	            //         const cId = item.cId;
	            //         if (cId === activeKey) {
	            //             activeItem = convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem, didMountCallback: allDidMountCallback[activeKey] });
	            //             activeItem.key = activeItem.ref || activeItem.props.moduleDesc.cId || uuid(10);
	            //             PanelItems[activeKey] = activeItem;
	            //             this.saveItemDesc(cId, { module: activeItem, parentModule: this, moduleDesc: item }, objFct);
	            //             ComponentManager.set(objFct.getUID(), cId, activeItem);
	            //             return true;
	            //         }
	            //     });
	            // }
	
	            // 通用渲染前处理，添加自定义样式等
	
	            this.renderBeforeReturn(this.state.WrapProps);
	
	            return _react2.default.createElement(
	                _antd.Card,
	                this.state.WrapProps,
	                PanelItems[activeKey]
	            );
	        };
	
	        _this.AddAttribute = function (moduleDesc, WrapProps) {
	            //初始化激活的面板
	            var atvTab = (0, _SgiCommon.getConstByKey)(this, moduleDesc.atvTab);
	            if (atvTab) this.state.activeKey = atvTab;
	
	            var isBrdr = moduleDesc.isBrdr; //是否有边框
	            if (isBrdr) {
	                WrapProps.bordered = true;
	            } else {
	                WrapProps.bordered = false;
	            }
	
	            if (moduleDesc.te || moduleDesc.teid) {
	                //避免不必要的执行getTRByPrm()方法
	                var title = _Resource.Resource.getTRByPrm(moduleDesc).te; //是否有标题
	                if (title) WrapProps.title = title;
	            }
	
	            var cId = moduleDesc.cId; //cid 唯一标示
	            if (cId) WrapProps.id = (0, _SgiCommon.getConstByKey)(this, cId);
	
	            var ctlW = moduleDesc.ctlW; //form宽度
	            if (ctlW) WrapProps.style.width = ctlW;
	
	            var ctlH = moduleDesc.ctlH; //form高度
	            if (ctlH) WrapProps.style.height = ctlH;
	
	            var mgn = moduleDesc.mgn; //form外边距
	            if (mgn) WrapProps.bodyStyle.margin = mgn;
	            var pad = moduleDesc.pad; //form内边距
	            if (pad) WrapProps.bodyStyle.padding = pad;
	
	            var isHdn = moduleDesc.isHdn; //form是否隐藏
	            if (isHdn) WrapProps.style.display = "none";
	
	            WrapProps.hoverable = false; //鼠标滑过 是否浮动，默认现在不浮动
	
	            var isScl = moduleDesc.isScl; //滚动
	            if (isScl) {
	                WrapProps.style.overflow = "auto";
	            } else {
	                WrapProps.style.overflow = undefined;
	            }
	        };
	
	        _this.state = {
	            uuid: (0, _sgiCommon.uuidDate)(6, "yyyyMMddhhmmssSSS"),
	            WrapProps: { style: { height: "100%", width: "100%" }, bodyStyle: { height: "100%", width: "100%" } },
	            PanelItems: {},
	            childItems: [], //子组件数组
	            activeKey: ''
	            // allDidMountCallback: {}//用于存放子组件自定义渲染后事件
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建form
	     * @param {父组件} parentModule
	     * @param {描述} moduleDesc
	     * @param {对象工厂} objFct
	     * @param {make类型} type
	     */
	
	
	    _createClass(SgiOverlap, [{
	        key: 'Overlap_mk',
	        value: function Overlap_mk(parentModule, moduleDesc, objFct, type) {
	            var _this2 = this;
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.PanelItems = {}; //再次渲染的时候清空
	
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.WrapProps);
	
	            var me = this;
	            var cldSet = moduleDesc.cldSet;
	            if (cldSet && cldSet.length && cldSet.length > 0) {
	                cldSet.forEach(function (item, index) {
	                    // let { cId } = item;
	                    var cId = (0, _SgiCommon.getConstByKey)(_this2, item.cId);
	                    cId = cId || _this2.state.uuid + "_" + index;
	                    if (index == 0 && !_this2.state.activeKey) _this2.state.activeKey = cId;
	                    var module = (0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type, { setActiveWV: _this2.setActiveItem });
	                    // let module = convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem, didMountCallback: allDidMountCallback[activeKey] });
	                    module.key = cId;
	                    _this2.state.PanelItems[cId] = module;
	                    _this2.saveItemDesc(cId, { module: module, parentModule: _this2, moduleDesc: item }, objFct);
	                    ComponentManager.set(objFct.getUID(), cId, module);
	                });
	            }
	        }
	    }, {
	        key: 'saveItemDesc',
	        value: function saveItemDesc(key, item, objFct) {
	            if (!key || !objFct) return;
	
	            var allWVItems = objFct.get(_sgiConstants2.default.allWVItemKey);
	            if (!allWVItems) {
	                allWVItems = {};
	                objFct.set(_sgiConstants2.default.allWVItemKey, allWVItems);
	            }
	            allWVItems[key] = item;
	        }
	        /**
	         * 获取当前激活面板的组件标识
	         * @return {[type]} [description]
	         */
	
	
	        //渲染并返回一个虚拟DOM
	
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formProps
	         */
	
	    }]);
	
	    return SgiOverlap;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	exports.default = SgiOverlap;
	Object.assign(SgiOverlap.prototype, _SgiCtnComm.sgiCtnBaseFun);

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiQuote = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiMainComp = __webpack_require__(125);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiPanel = __webpack_require__(251);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var SgiQuote = function (_React$Component) {
	    _inherits(SgiQuote, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiQuote(props) {
	        _classCallCheck(this, SgiQuote);
	
	        var _this = _possibleConstructorReturn(this, (SgiQuote.__proto__ || Object.getPrototypeOf(SgiQuote)).call(this, props));
	
	        _this.AddAttribute = function (moduleDesc, formProps) {}
	        //嵌入UID
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formProps 
	         */
	        ;
	
	        _this.fitPanelItems = function (moduleDesc, panelItems, objFct, type) {
	            var _this2 = this;
	
	            var me = this;
	
	            var uid = moduleDesc.quoteUID;
	            if (!uid) {
	                return;
	            }
	            var uijson = _PrmFactory.PrmFactory.getPrm(uid);
	            if (!uijson) {
	                return;
	            }
	            if (!objFct) {
	                objFct = new _ObjFactory.ObjFactory();
	                objFct.set('@currentObjFctUID', uid);
	            }
	            if (moduleDesc.isInRoot == 'yes') {
	                panelItems.push((0, _SgiCompComm.convertModuleByGuid)(this, uijson.cldSet[0], null, objFct, type));
	            } else {
	                uijson.cldSet[0].cldSet.forEach(function (element) {
	                    panelItems.push((0, _SgiCompComm.convertModuleByGuid)(_this2, element, null, objFct, type));
	                });
	            }
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var objFct = this.props.objFct;
	
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.nest_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                this.state.formProps,
	                this.state.panelItems
	            );
	        };
	
	        _this.state = {
	            formProps: { style: { height: '100%', width: '100%' } },
	            loading: false,
	            panelItems: []
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {弹出页面guid} uid
	     * @param {对象工厂} objFct
	     * @param {弹出窗标题} curtitle
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiQuote, [{
	        key: 'nest_mk',
	        value: function nest_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.panelItems = []; //再次渲染的时候清空
	            //转换基础属性
	            // this.AddAttribute(moduleDesc, this.state.formProps);
	            //转换form公共属性
	            // addCtnCommonAttribute(this, moduleDesc, this.state.formProps);
	            //组装form表单下的控件信息
	            if (type !== "dnd") this.fitPanelItems(moduleDesc, this.state.panelItems, objFct, type);
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiQuote;
	}(_react2.default.Component);
	
	SgiQuote.defaultProps = {};
	SgiQuote.propTypes = {};
	exports.SgiQuote = SgiQuote;
	exports.default = SgiQuote;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiRow = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCompComm = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const FormItem = Form.Item;
	
	var SgiRow = function (_React$Component) {
	    _inherits(SgiRow, _React$Component);
	
	    function SgiRow(props) {
	        _classCallCheck(this, SgiRow);
	
	        var _this = _possibleConstructorReturn(this, (SgiRow.__proto__ || Object.getPrototypeOf(SgiRow)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this.state = {};
	        var _this$props$moduleDes = _this.props.moduleDesc,
	            align = _this$props$moduleDes.align,
	            justify = _this$props$moduleDes.justify,
	            type = _this$props$moduleDes.type,
	            ctlW = _this$props$moduleDes.ctlW,
	            ctlH = _this$props$moduleDes.ctlH;
	        /**
	         * align	flex 布局下的垂直对齐方式：top middle bottom
	         * justify	flex 布局下的水平排列方式：start end center space-around space-between
	         * type	布局模式，可选 flex，现代浏览器 下有效
	         */
	
	        _this.state = {
	            rowProps: {},
	            loading: false
	        };
	        return _this;
	    }
	
	    /**
	    * 根据描述创建form
	    * @param {父组件} parentModule 
	    * @param {描述} moduleDesc       
	    * @param {对象工厂} objFct 
	    * @param {make类型} type 
	    */
	
	
	    _createClass(SgiRow, [{
	        key: 'row_mk',
	        value: function row_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	            var sonUIItems = []; //form下控件数组
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.rowProps);
	            //组装form表单下的控件信息
	            if (type !== "dnd") this.fitSonUIItems(moduleDesc, sonUIItems, bdInst, objFct, type);
	
	            this.sonUIItems = sonUIItems;
	        }
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formProps 
	         */
	
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiRow;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.AddAttribute = function (moduleDesc, rowProps) {
	        var _props$moduleDesc = this.props.moduleDesc,
	            align = _props$moduleDesc.align,
	            justify = _props$moduleDesc.justify,
	            style = _props$moduleDesc.style,
	            type = _props$moduleDesc.type,
	            ctlW = _props$moduleDesc.ctlW,
	            ctlH = _props$moduleDesc.ctlH;
	
	        rowProps.style = style;
	        rowProps.align = align;
	        rowProps.justify = justify;
	        rowProps.type = 'flex';
	
	        //嵌入UID
	        if (!style) {
	            rowProps.style = {};
	        }
	        if (ctlW) rowProps.style.width = ctlW;
	        if (ctlH) rowProps.style.height = ctlH;
	    };
	
	    this.fitSonUIItems = function (moduleDesc, sonUIItems, bdInst, objFct, type) {
	        var me = this;
	        //form下的子节点添加到form组件中
	        var cldSet = moduleDesc.cldSet;
	        if (cldSet && cldSet.length && cldSet.length > 0) {
	            cldSet.forEach(function (item, index) {
	                sonUIItems.push((0, _SgiCompComm.convertModuleByGuid)(me, item, bdInst, objFct, type));
	            });
	        }
	    };
	
	    this.refresh = function () {
	        _this2.loaded = false;
	        _this2.setState({ loading: false });
	    };
	
	    this.render = function () {
	        if (!this.loaded) {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                bdInst = _props.bdInst,
	                objFct = _props.objFct,
	                type = _props.type;
	            //组装属性
	
	            this.row_mk(parentModule, moduleDesc, bdInst, objFct, type);
	            this.loaded = true;
	        }
	        return _react2.default.createElement(
	            _antd.Row,
	            this.state.rowProps,
	            this.sonUIItems,
	            this.props.children
	        );
	    };
	};
	
	exports.SgiRow = SgiRow;
	exports.default = SgiRow;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SgiSplitter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _reactResizable = __webpack_require__(442);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	// import { addSgiSplitterCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun';
	
	
	// import '../node_modules/react-resizable/css/styles.css';
	
	var ResizeablePanel = function ResizeablePanel(props) {
		var onResize = props.onResize,
		    width = props.width,
		    height = props.height,
		    isLast = props.isLast,
		    sons = props.sons,
		    restProps = _objectWithoutProperties(props, ['onResize', 'width', 'height', 'isLast', 'sons']);
	
		if (!restProps.style) restProps.style = {};
		restProps.style.width = width;
		restProps.style.height = height;
		return isLast ? _react2.default.createElement(
			'div',
			restProps,
			sons
		) : _react2.default.createElement(
			_reactResizable.Resizable,
			{ width: width, height: height, onResize: onResize },
			_react2.default.createElement(
				'div',
				restProps,
				sons
			)
		);
	};
	
	var SgiSplitter = function (_React$Component) {
		_inherits(SgiSplitter, _React$Component);
	
		// 注意这里有分号
	
		function SgiSplitter(props) {
			_classCallCheck(this, SgiSplitter);
	
			//初始化state属性
			//初始化state
			var _this = _possibleConstructorReturn(this, (SgiSplitter.__proto__ || Object.getPrototypeOf(SgiSplitter)).call(this, props));
	
			_this.AddAttribute = function (moduleDesc, splitProps, type) {
				// 可拖动
				this.state.resizable = type === "dnd" ? false : !!moduleDesc.resz;
			};
	
			_this.setSonItems = function (moduleDesc, sonComps, sonItems) {
				if (this.state.resizable) {
					this.setResizeItems(moduleDesc, sonComps, sonItems);
				} else {
					this.setRowColItems(moduleDesc, sonComps);
				}
			};
	
			_this.setRowColItems = function (moduleDesc, sonComps) {
				var _props = this.props,
				    bdInst = _props.bdInst,
				    objFct = _props.objFct,
				    type = _props.type;
	
				var colList = void 0;
				//分割比例
				var p = moduleDesc.sptSca;
				var ps = p.split(",");
	
				//计数
				var sumPs = 0;
				for (var i = 0; i < ps.length; i++) {
					sumPs += parseInt(ps[i]);
				}
				var isEdwSpt = moduleDesc.isEdwSpt; //纵向分割
	
				colList = [];
				var children = moduleDesc.cldSet;
				if (children) {
					var childSize = children.length;
					if (childSize != 0) {
						for (var i = 0; i < childSize; i++) {
							if (!ps[i]) {
								ps[i] = 0;
							}
							var span = Math.round(parseInt(ps[i]) / sumPs * 24);
							var height1 = parseInt(ps[i]) / sumPs * 100 + "%";
	
							if (isEdwSpt) {
								colList.push(_react2.default.createElement(
									_antd.Row,
									{ style: { height: height1, width: '100%' } },
									(0, _SgiCompComm.convertModuleByGuid)(this, children[i], bdInst, objFct, type)
								));
							} else {
								colList.push(_react2.default.createElement(
									_antd.Col,
									{ span: span, style: { height: '100%' } },
									(0, _SgiCompComm.convertModuleByGuid)(this, children[i], bdInst, objFct, type)
								));
							}
						}
						if (isEdwSpt) {
							sonComps.push(colList);
						} else {
							sonComps.push(_react2.default.createElement(
								_antd.Row,
								{ style: { height: '100%', width: '100%' } },
								' ',
								colList
							));
						}
					}
				}
			};
	
			_this.setResizeItems = function (moduleDesc, sonComps, sonItems) {
				var _props2 = this.props,
				    bdInst = _props2.bdInst,
				    objFct = _props2.objFct,
				    type = _props2.type;
	
				var colList = void 0;
				//分割比例
				var p = moduleDesc.sptSca;
				var ps = p.split(",");
	
				//计数
				var sumPs = 0;
				for (var i = 0; i < ps.length; i++) {
					sumPs += parseInt(ps[i]);
				}
				var isEdwSpt = moduleDesc.isEdwSpt; //纵向分割
	
				// let splitWidth = document.getElementById(this.state.splitId).offsetWidth;
				var splitWidth = this.state.splitWidth;
	
				colList = [];
				var children = moduleDesc.cldSet;
				if (children) {
					var childSize = children.length;
					if (childSize != 0) {
						for (var i = 0; i < childSize; i++) {
							if (!ps[i]) {
								ps[i] = 0;
							}
							var prc = parseInt(ps[i]) / sumPs;
							var height1 = parseInt(ps[i]) / sumPs * 100 + "%";
	
							if (isEdwSpt) {
								colList.push(_react2.default.createElement(
									_antd.Row,
									{ style: { height: height1, width: '100%' } },
									(0, _SgiCompComm.convertModuleByGuid)(this, children[i], bdInst, objFct, type)
								));
							} else {
								sonItems.push({ prc: prc, initPrc: prc, height: "100%", sons: (0, _SgiCompComm.convertModuleByGuid)(this, children[i], bdInst, objFct, type) });
							}
						}
						if (isEdwSpt) {
							sonComps.push(colList);
						} else {
							sonComps.push(_react2.default.createElement(
								_antd.Row,
								{ style: { height: '100%', width: '100%' } },
								' ',
								colList
							));
						}
					}
				}
			};
	
			_this.refresh = function () {
				_this.loaded = false;
				_this.setState({ loading: false });
			};
	
			_this.handleResize = function (index, event, _ref) {
				var element = _ref.element,
				    size = _ref.size;
	
				var w1 = _this.state.sonItems[index].width;
				var w2 = _this.state.sonItems[index + 1].width;
				var sw = w1 + w2;
				_this.state.sonItems[index].width = size.width;
				_this.state.sonItems[index].prc = size.width / _this.state.splitWidth;
				_this.state.sonItems[index + 1].width = sw - size.width;
				_this.state.sonItems[index + 1].prc = (sw - size.width) / _this.state.splitWidth;
				if ((0, _SgiCommon.testReactVsn)(_this, 16)) {
					// react16需要更新引用
					_this.state.sonItems = [].concat(_toConsumableArray(_this.state.sonItems));
				}
				_this.setState({});
	
				// 刷新子分割面板
				_this.refreshSonSplit(_this.refs);
			};
	
			_this.render = function () {
				var _this2 = this;
	
				var _props3 = this.props,
				    parentModule = _props3.parentModule,
				    moduleDesc = _props3.moduleDesc,
				    bdInst = _props3.bdInst,
				    objFct = _props3.objFct,
				    type = _props3.type;
	
	
				if (!this.loaded || this.props.type == 'dnd') {
					//组装属性 初始化属性到this.state
					this.splitter_mk(parentModule, moduleDesc, objFct, type);
					this.loaded = true;
				}
	
				// 通用渲染前处理，添加自定义样式等
				this.renderBeforeReturn(this.state.splitProps);
	
				if (this.state.resizable) {
					this.state.sonComps = this.state.sonItems.map(function (item, index, arr) {
						if (!item.width) item.width = item.prc * _this2.state.splitWidth;
						return _react2.default.createElement(ResizeablePanel, _extends({}, item, { isLast: arr.length === index + 1, onResize: _this2.handleResize.bind(_this2, index) }));
					});
					// 姑且仅支持横向布局
					this.state.splitProps.style.display = "flex";
				}
	
				return _react2.default.createElement(
					'div',
					_extends({ className: 'sgiSplitter', id: this.state.splitId }, this.state.splitProps),
					this.state.sonComps
				);
			};
	
			_this.state = {
				json: undefined,
				splitProps: { style: { height: '100%', width: '100%' } },
				sonItems: [], //split下数据数组
				sonComps: [], //split下组件数组
				loading: false,
				resizable: false,
				splitId: "splitter_" + (0, _sgiCommon.uuid)(8),
				splitWidth: 1000
			};
			return _this;
		}
	
		/**
	  * 根据描述创建文本框
	  * @param {弹出页面guid} uid
	  * @param {对象工厂} objFct
	  * @param {弹出窗标题} curtitle
	  */
		// 注意这里有分号
	
	
		_createClass(SgiSplitter, [{
			key: 'splitter_mk',
			value: function splitter_mk(parentModule, moduleDesc, objFct, type) {
				//获取需要展示的数据信息
				if (!moduleDesc) {
					return;
				}
				this.state.sonComps = []; //再次渲染的时候清空
				//转换split公共属性
				(0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.splitProps);
				//转换基础属性
				this.AddAttribute(moduleDesc, this.state.splitProps, type);
				//组装分割面板数据
				if (type !== "dnd") this.setSonItems(moduleDesc, this.state.sonComps, this.state.sonItems);
				//添加拖拽布局信息 根据type类型
				// addSgiSplitterCtlDndInfo(this, this.state.sonComps, this.state.splitProps, type);
				var addSgiSplitterCtlDndInfo = this.props.addSgiSplitterCtlDndInfo; //显示/开发分离，这部分拖拽开发功能使用props传入
				if (addSgiSplitterCtlDndInfo && typeof addSgiSplitterCtlDndInfo === "function") {
					addSgiSplitterCtlDndInfo(this, this.state.sonComps, this.state.splitProps, this.props.type);
				}
			}
	
			/**
	   * 添加子控件
	   */
	
	
			/**
	   * 添加子控件
	   */
	
			/**
	   * 添加子控件
	   */
	
	
			//渲染并返回一个虚拟DOM
	
		}, {
			key: 'resizeWidth',
	
	
			// 调整可拖动宽度
			value: function resizeWidth() {
				try {
					var splitWidth = document.getElementById(this.state.splitId).offsetWidth;
					var oldWidth = this.state.splitWidth;
					if (splitWidth !== oldWidth) {
						// 更新组件宽度
						this.state.splitWidth = splitWidth;
						(this.state.sonItems || []).forEach(function (s) {
							s.width = s.prc * splitWidth;
						});
						if ((0, _SgiCommon.testReactVsn)(this, 16)) {
							// react16需要更新引用
							this.state.sonItems = [].concat(_toConsumableArray(this.state.sonItems));
						}
						this.setState({});
					}
				} catch (error) {}
			}
	
			// 刷新子分割面板
	
		}, {
			key: 'refreshSonSplit',
			value: function refreshSonSplit(refs) {
				for (var key in refs) {
					var ref = refs[key];
					if (ref instanceof SgiSplitter) {
						tool.sgiLogger.log('ref :', ref);
						ref.setState({});
					}
					if (ref.refs) {
						this.refreshSonSplit(ref.refs);
					}
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.state.resizable && this.resizeWidth()) ;
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.state.resizable && this.resizeWidth()) ;
			}
		}]);
	
		return SgiSplitter;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiSplitter.defaultProps = {};
	SgiSplitter.propTypes = {};
	Object.assign(SgiSplitter.prototype, _SgiCtnComm.sgiCtnBaseFun);
	exports.SgiSplitter = SgiSplitter;
	exports.default = SgiSplitter;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiSteps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _StandardCode = __webpack_require__(81);
	
	var _sgiLogger = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Step = _antd.Steps.Step;
	
	var SgiSteps = function (_React$Component) {
	    _inherits(SgiSteps, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiSteps(props) {
	        _classCallCheck(this, SgiSteps);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiSteps.__proto__ || Object.getPrototypeOf(SgiSteps)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.steps_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            var current = this.state.current;
	
	            return _react2.default.createElement(
	                _antd.Steps,
	                _extends({}, this.state.inputprops, { current: current }),
	                this.state.store
	            );
	        };
	
	        _this.initState();
	        _this.state = _extends({}, _this.state, {
	            store: [], //下拉框内容
	            current: 0,
	            storeKey: {},
	            functions: {}, //存储已转义好的上下步函数
	            prvNxtEventFlg: false, //是否启用上下步事件
	            stepEvents: [], //事件数组
	            scList: [], //存储标准代码对应节点列表
	            orderToKey: {} //通过current值找到对应的
	        });
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiSteps, [{
	        key: 'steps_mk',
	        value: function steps_mk(parentModule, moduleDesc, bdInst, workspace, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //组装下拉框内容
	            this.fitSelectOption(moduleDesc);
	            //转换form公共属性
	            // AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            // setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            // bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            // bindValue(this, moduleDesc, bdInst, this.state.formItemProps, this.state.inputprops);
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'fitSelectOption',
	        value: function fitSelectOption(moduleDesc) {
	            var _this2 = this;
	
	            this.state.store = [];
	            this.state.storeKey = {};
	            var scId = moduleDesc.rSC; //绑定实例名
	            if (!scId) {
	                return;
	            }
	            // 下拉窗列表值在标准代码中的id
	            var comboBoxData = _StandardCode.StandardCode.getSC(scId);
	            if (!comboBoxData) {
	                return;
	            }
	
	            var scList = [];
	            var orderToKey = {};
	            var size = comboBoxData.length;
	            if (!size == 0) {
	                for (var i = 0; i < size; i++) {
	                    var item = comboBoxData[i];
	                    scList.push({ te: item.te, c: item.c, desc: this.state.showAnn ? item.ann : null });
	                }
	
	                scList.forEach(function (item, index) {
	                    _this2.state.store.push(_react2.default.createElement(Step, { key: item.c, title: item.te, description: item.desc }));
	                    _this2.state.storeKey[item.c] = index;
	                    orderToKey[index] = item.c;
	                });
	
	                this.state.orderToKey = orderToKey;
	                this.state.scList = scList;
	            }
	        }
	    }, {
	        key: 'setShowKeys',
	        value: function setShowKeys(showKeys) {
	            var _this3 = this;
	
	            showKeys = showKeys || [];
	
	            this.state.store = [];
	
	            var showList = [];
	            var allList = this.state.scList || [];
	            var orderToKey = {};
	
	            allList.forEach(function (all) {
	                showKeys.forEach(function (showKey) {
	                    if (all["c"] === showKey) {
	                        showList.push(all);
	                    }
	                });
	            });
	
	            showList.forEach(function (item, index) {
	                _this3.state.store.push(_react2.default.createElement(Step, { key: item.c, title: item.te, description: item.desc }));
	                orderToKey[index] = item.c;
	            });
	
	            this.state.orderToKey = orderToKey;
	            this.loadCurrentPanel(0);
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'loadCurrentPanel',
	        value: function loadCurrentPanel(current) {
	            current = current || this.state.current;
	            var orderToKey = this.state.orderToKey || {};
	            // 执行进入事件
	            if (this.state.prvNxtEventFlg) {
	                var $nextInLsn = this.state.functions["nextInLsn_" + orderToKey[current]];
	                if (!$nextInLsn) {
	                    var currStepDesc = this.getItemByCode(orderToKey[current]) || {};
	                    var nextInLsn = currStepDesc.nextInLsn;
	                    if (nextInLsn) {
	                        try {
	                            $nextInLsn = new Function("module", "objFct", "current", nextInLsn);
	                        } catch (error) {
	                            _sgiLogger.sgiLogger.eventErr(error);
	                        }
	                        this.state.functions["nextInLsn_" + orderToKey[current]] = $nextInLsn;
	                    }
	                }
	                if ($nextInLsn) {
	                    var _props2 = this.props,
	                        parentModule = _props2.parentModule,
	                        moduleDesc = _props2.moduleDesc,
	                        bdInst = _props2.bdInst,
	                        objFct = _props2.objFct,
	                        type = _props2.type;
	
	                    tool.sgiLogger.log("下一步进入事件");
	                    if ($nextInLsn(this, objFct, current) === false) {
	                        return false;
	                    }
	                }
	            }
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            var _this4 = this;
	
	            //csstyle 样式文件?这个我还不知道怎么用
	            // var csstyle = moduleDesc.csstyle;
	
	            // 指定当前步骤，从 0 开始记数。
	            var current = moduleDesc.current;
	            if (current) this.state.current = current;
	
	            //点状步骤条
	            var progressDot = moduleDesc.progressDot;
	            if (progressDot) inputprops.progressDot = progressDot;
	
	            //步骤条方向
	            var direction = moduleDesc.direction;
	            if (direction) inputprops.direction = direction;
	
	            // 是否启用上下步事件
	            var cstmEvent = moduleDesc.cstmEvent;
	            this.state.prvNxtEventFlg = !!cstmEvent;
	
	            // 事件数组
	            var stepEvents = moduleDesc.stepEvents;
	            this.state.stepEvents = stepEvents || [];
	
	            // 显示注释内容
	            this.state.showAnn = !!moduleDesc.showAnn;
	
	            // 让步骤条可点击
	            var stepIsClick = moduleDesc.stepIsClick;
	            inputprops.onChange = function (current) {
	                // let max = this.state.store.length - 1;
	                // if (this.state.current < max) {
	                // 执行事件
	                if (_this4.state.prvNxtEventFlg) {
	                    if (_this4._nextOutEvent() === false) return false;
	                    // if (this._nextInEvent(current) === false) return false;
	                }
	                // 下一步
	                _this4._nextStep(current);
	                // 执行事件
	                if (_this4.state.prvNxtEventFlg) {
	                    // if (this._nextOutEvent() === false) return false;
	                    if (_this4._nextInEvent(current) === false) return false;
	                }
	                return true;
	                // }
	            };
	        }
	    }, {
	        key: 'getItemByCode',
	        value: function getItemByCode(code) {
	            if (!code) return null;
	            var stepEvents = this.state.stepEvents || [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = stepEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var item = _step.value;
	
	                    if (item["c"] === code) {
	                        return item;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	
	        // 下一步--先执行事件、再切换页面
	
	    }, {
	        key: 'next',
	        value: function next() {
	            var max = this.state.store.length - 1;
	            if (this.state.current < max) {
	                // 执行事件
	                if (this.state.prvNxtEventFlg) {
	                    if (this._nextOutEvent() === false) return false;
	                    // if (this._nextInEvent() === false) return false;
	                }
	                // 下一步
	                this._nextStep();
	                // 执行事件
	                if (this.state.prvNxtEventFlg) {
	                    // if (this._nextOutEvent() === false) return false;
	                    if (this._nextInEvent() === false) return false;
	                }
	                return true;
	            }
	        }
	        // 下一步--只执行事件
	
	    }, {
	        key: 'nextEvent',
	        value: function nextEvent() {
	            var max = this.state.store.length - 1;
	            if (this.state.current < max) {
	                if (this.state.prvNxtEventFlg) {
	                    if (this._nextOutEvent() === false) return false;
	                    if (this._nextInEvent() === false) return false;
	                }
	                return true;
	            }
	        }
	        // 当前步离开事件
	
	    }, {
	        key: 'nextOutEvent',
	        value: function nextOutEvent() {
	            var max = this.state.store.length - 1;
	            if (this.state.current < max) {
	                if (this.state.prvNxtEventFlg) return this._nextOutEvent();
	                return true;
	            }
	        }
	        // 下一步进入事件
	
	    }, {
	        key: 'nextInEvent',
	        value: function nextInEvent() {
	            var max = this.state.store.length - 1;
	            if (this.state.current < max) {
	                if (this.state.prvNxtEventFlg) return this._nextInEvent();
	                return true;
	            }
	        }
	        // 下一步--只执行页面切换
	
	    }, {
	        key: 'nextStep',
	        value: function nextStep() {
	            var max = this.state.store.length - 1;
	            if (this.state.current < max) {
	                return this._nextStep();
	            }
	        }
	        // 上一步--先执行事件，在执行页面切换
	
	    }, {
	        key: 'prev',
	        value: function prev() {
	            if (this.state.current > 0) {
	                // 切换页面
	                this._prevStep();
	                // 执行事件
	                if (this.state.prvNxtEventFlg) {
	                    if (this._prevEvent() === false) return false;
	                }
	                return true;
	            }
	        }
	        // 上一步--只执行事件
	
	    }, {
	        key: 'prevEvent',
	        value: function prevEvent() {
	            if (this.state.current > 0) {
	                if (this.state.prvNxtEventFlg) {
	                    if (this._prevEvent() === false) return false;
	                }
	                return true;
	            }
	        }
	        // 上一步--只切换页面
	
	    }, {
	        key: 'prevStep',
	        value: function prevStep() {
	            if (this.state.current > 0) {
	                this._prevStep();
	                return true;
	            }
	        }
	    }, {
	        key: 'setStep',
	        value: function setStep(code) {
	            if (!code) {
	                return;
	            }
	            var current = this.state.storeKey[code];
	            if (current == undefined || current == null) {
	                return;
	            }
	            this.setState({ current: current });
	        }
	    }, {
	        key: 'getCurrent',
	        value: function getCurrent() {
	            var _this5 = this;
	
	            var current = this.state.current;
	            var max = this.state.store.length - 1;
	            var type = current === 0 ? "first" : current === max ? "last" : current === max - 1 ? "nextToLast" : "middle";
	            var uis = (this.state.store || []).map(function (item, index) {
	                return (_this5.getItemByCode(_this5.state.orderToKey[index]) || {}).uid;
	            });
	            return {
	                current: current,
	                max: max,
	                type: type,
	                uis: uis
	            };
	        }
	
	        // 下一步进入事件
	
	    }, {
	        key: '_nextInEvent',
	        value: function _nextInEvent(nextCurrent) {
	
	            var _nextCurrent = this.state.current + 1;
	            if (nextCurrent || nextCurrent == 0) {
	                _nextCurrent = nextCurrent;
	            }
	
	            var orderToKey = this.state.orderToKey || {};
	            var $nextInLsn = this.state.functions["nextInLsn_" + orderToKey[_nextCurrent]];
	            if (!$nextInLsn) {
	                var nextStepDesc = this.getItemByCode(orderToKey[_nextCurrent]) || {};
	                var nextInLsn = nextStepDesc.nextInLsn;
	                if (nextInLsn) {
	                    try {
	                        $nextInLsn = new Function("module", "objFct", "current", nextInLsn);
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                    this.state.functions["nextInLsn_" + orderToKey[_nextCurrent]] = $nextInLsn;
	                }
	            }
	            if ($nextInLsn) {
	                var _props3 = this.props,
	                    parentModule = _props3.parentModule,
	                    moduleDesc = _props3.moduleDesc,
	                    bdInst = _props3.bdInst,
	                    objFct = _props3.objFct,
	                    type = _props3.type;
	
	                tool.sgiLogger.log("下一步进入事件");
	                if ($nextInLsn(this, objFct, _nextCurrent) === false) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        // 当前步离开事件
	
	    }, {
	        key: '_nextOutEvent',
	        value: function _nextOutEvent() {
	            var orderToKey = this.state.orderToKey || {};
	            var $nextOutLsn = this.state.functions["nextOutLsn_" + orderToKey[this.state.current]];
	            if (!$nextOutLsn) {
	                var thisStepDesc = this.getItemByCode(orderToKey[this.state.current]) || {};
	                var nextOutLsn = thisStepDesc.nextOutLsn;
	                if (nextOutLsn) {
	                    try {
	                        $nextOutLsn = new Function("module", "objFct", "current", nextOutLsn);
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                    this.state.functions["nextOutLsn_" + orderToKey[this.state.current]] = $nextOutLsn;
	                }
	            }
	            if ($nextOutLsn) {
	                var _props4 = this.props,
	                    parentModule = _props4.parentModule,
	                    moduleDesc = _props4.moduleDesc,
	                    bdInst = _props4.bdInst,
	                    objFct = _props4.objFct,
	                    type = _props4.type;
	
	                tool.sgiLogger.log("当前步离开事件");
	                if ($nextOutLsn(this, objFct, this.state.current) === false) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        // 下一步
	
	    }, {
	        key: '_nextStep',
	        value: function _nextStep(nextCurrent) {
	
	            var _nextCurrent = this.state.current + 1;
	            if (nextCurrent || nextCurrent == 0) {
	                _nextCurrent = nextCurrent;
	            }
	
	            // 页面跳转
	            var orderToKey = this.state.orderToKey || {};
	            var nextStepDesc = this.getItemByCode(orderToKey[_nextCurrent]) || {};
	            var nextUid = nextStepDesc.uid;
	            if (nextUid) {
	                tool.setActiveWV(nextUid, this.props.objFct);
	            }
	            // 下一步
	            this.setState({ current: _nextCurrent });
	        }
	
	        // 上一步事件
	
	    }, {
	        key: '_prevEvent',
	        value: function _prevEvent() {
	            var orderToKey = this.state.orderToKey || {};
	            var $prevLsn = this.state.functions["prevLsn_" + orderToKey[this.state.current]];
	            if (!$prevLsn) {
	                var thisStepDesc = this.getItemByCode(orderToKey[this.state.current]) || {};
	                var prevLsn = thisStepDesc.prevLsn;
	                if (prevLsn) {
	                    try {
	                        $prevLsn = new Function("module", "objFct", "current", prevLsn);
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                    this.state.functions["prevLsn_" + orderToKey[this.state.current]] = $prevLsn;
	                }
	            }
	            if ($prevLsn) {
	                var _props5 = this.props,
	                    parentModule = _props5.parentModule,
	                    moduleDesc = _props5.moduleDesc,
	                    bdInst = _props5.bdInst,
	                    objFct = _props5.objFct,
	                    type = _props5.type;
	
	                tool.sgiLogger.log("上一步事件");
	                if ($prevLsn(this, objFct, this.state.current) === false) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        // 上一步
	
	    }, {
	        key: '_prevStep',
	        value: function _prevStep() {
	            // 页面跳转
	            var orderToKey = this.state.orderToKey || {};
	            var prevStepDesc = this.getItemByCode(orderToKey[this.state.current - 1]) || {};
	            var prevUid = prevStepDesc.uid;
	            if (prevUid) {
	                tool.setActiveWV(prevUid, this.props.objFct);
	            }
	            // 上一步
	            this.setState({ current: this.state.current - 1 });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiSteps;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiSteps.defaultProps = {};
	SgiSteps.propTypes = {};
	Object.assign(SgiSteps.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	exports.SgiSteps = SgiSteps;
	exports.default = SgiSteps;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiTV = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _Resource = __webpack_require__(67);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _StandardCode = __webpack_require__(81);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiTableEditorCell = __webpack_require__(252);
	
	var _SgiTableEditorCell2 = _interopRequireDefault(_SgiTableEditorCell);
	
	var _SgiTableBaseFun = __webpack_require__(371);
	
	var _reactResizable = __webpack_require__(442);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _SgiTableCommon = __webpack_require__(720);
	
	var _SgiTableCommon2 = _interopRequireDefault(_SgiTableCommon);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// import '../node_modules/react-resizable/css/styles.css';
	
	var RadioGroup = _antd.Radio.Group;
	
	var antd_column_prop_keys = ["align", "ellipsis", "className", "colSpan", "dataIndex", "defaultFilteredValue", "defaultSortOrder", "filterDropdown", "filterDropdownVisible", "filtered", "filteredValue", "filterIcon", "filterMultiple", "filters", "fixed", "key", "render", "sorter", "sortOrder", "sortDirections", "title", "width", "onCell", "onFilter", "onFilterDropdownVisibleChange", "onHeaderCell"];
	
	var ResizeableTitle = function ResizeableTitle(props) {
	    var onResize = props.onResize,
	        width = props.width,
	        isLast = props.isLast,
	        restProps = _objectWithoutProperties(props, ['onResize', 'width', 'isLast']);
	
	    if (isLast) {
	        return _react2.default.createElement('th', restProps);
	    }
	
	    return _react2.default.createElement(
	        _reactResizable.Resizable,
	        { width: parseInt(width), height: 0, onResize: onResize },
	        _react2.default.createElement('th', restProps)
	    );
	};
	var components = {
	    header: { cell: ResizeableTitle }
	};
	
	var SgiTV = function (_React$Component) {
	    _inherits(SgiTV, _React$Component);
	
	    function SgiTV(props) {
	        _classCallCheck(this, SgiTV);
	
	        var _this = _possibleConstructorReturn(this, (SgiTV.__proto__ || Object.getPrototypeOf(SgiTV)).call(this, props));
	
	        _this.render = function () {
	            var _this2 = this;
	
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                bdInst = _props.bdInst,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded) {
	                //组装属性 初始化属性到this.state
	                this.table_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            if (this.state.selFlg) this.onSel(); //筛选
	            else this.state.store = this.state.dataSource; //不筛选
	
	            var _state = this.state,
	                cstmClmnFlg = _state.cstmClmnFlg,
	                cstmClmn = _state.cstmClmn,
	                store = _state.store,
	                resizable = _state.resizable;
	
	
	            var columns = this.state.columns;
	
	            if (this.state.refreshFlg) {
	                columns = this.state.columns = [];
	                var bdTv = this.state.bdTv;
	                if (bdTv) {
	                    if (typeof bdTv === "string") {
	                        //暂时先不处理
	                        var tvs = bdTv.split(",");
	                        tvs.forEach(function (item, index) {
	                            var _columns;
	
	                            var tvJson = _PrmFactory.PrmFactory.getPrm(item);
	                            var clms = _this2.crtClmHead(moduleDesc, tvJson, objFct, type);
	                            (_columns = columns).push.apply(_columns, _toConsumableArray(clms));
	                        });
	                    } else {
	                        var cldSet = bdTv.cldSet;
	                        if (cldSet && cldSet.length > 0) {
	                            var _columns2;
	
	                            var clms = this.crtClmHead(moduleDesc, bdTv, objFct, type);
	                            (_columns2 = columns).push.apply(_columns2, _toConsumableArray(clms));
	                        }
	                    }
	                }
	                this.state.refreshFlg = false;
	            }
	
	            // 可伸缩列
	            if (resizable) {
	                this.state.tableProps.components = components;
	                columns = this.state.columns.map(function (col, index, arr) {
	                    return _extends({}, col, {
	                        onHeaderCell: function onHeaderCell(column) {
	                            return {
	                                width: column.width,
	                                onResize: _this2.handleResize(index),
	                                isLast: index === arr.length - 1
	                            };
	                        }
	                    });
	                });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: 5, width: "70%", minWidth: 400, maxWidth: 800, display: this.state.selFlg ? undefined : "none" } },
	                    _react2.default.createElement(
	                        _antd.Row,
	                        null,
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: 14 },
	                            _react2.default.createElement(_antd.Input, { addonBefore: '\u7B5B\u9009\u6761\u4EF6', value: this.state.selValues.mat, onChange: this.selOnChange.bind(this, 'mat') })
	                        ),
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: 10 },
	                            _react2.default.createElement(
	                                RadioGroup,
	                                { style: { marginTop: 3, marginLeft: 10 }, value: this.state.contain, onChange: this.containOnChange.bind(this) },
	                                _react2.default.createElement(
	                                    _antd.Radio,
	                                    { value: true, style: { marginRight: 0 } },
	                                    '\u5305\u542B'
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Radio,
	                                    { value: false },
	                                    '\u6392\u9664'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_antd.Table, _extends({ className: 'sgiTable' }, this.state.tableProps, {
	                    rowKey: "_key",
	                    loading: this.state.loading,
	                    pagination: this.state.showPageFlg ? this.state.pagination : false,
	                    rowSelection: this.state.rowSelection,
	                    columns: columns,
	                    dataSource: this.state.store,
	                    onChange: this.tableOnChange.bind(this),
	                    expandedRowRender: this.state.expandedColumns.length > 0 ? this.expandedRowRender.bind(this) : undefined }))
	            );
	        };
	
	        _this.state = {
	            showPageFlg: true, //是否显示翻页信息
	            pagination: {}, //分页信息
	            batchInfo: {}, //分批查询信息
	            size: 'default',
	            expandedRowRender: [], //展开列
	            footer: {},
	            rowSelection: null, //选择属性
	            columns: [], //列信息
	            expandedColumns: [], //列信息
	            tableProps: { style: {} }, //表格属性
	            dataSource: [], //显示数据==>原始数据
	            store: [], //表格的显示数据(原始数据筛选后)
	            insName: '', //绑定实例名
	            loading: false, //刷新属性 //是否加载中
	            // selectedRowKeys: [] //选择的列信息 //放入到了rowSelection中
	            functions: {},
	            selectedRows: [], //已选择/勾选的行对象数组
	            selFlg: false,
	            selValues: {}, //筛选对象
	            contain: true, //筛选选择(包含/不包含)，默认包含
	            cstmClmnFlg: false, //自定义表格列描述
	            resizable: false //列头可伸缩
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建表格
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	
	
	    _createClass(SgiTV, [{
	        key: 'table_mk',
	        value: function table_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	
	            // 获取绑定tv参数
	            var ClmDes = this.getClmDes(moduleDesc);
	            // 从对象工厂中获取表格绑定数据（创建表格store 搜索条、翻页控件需要使用该信息，所以先创建）
	            var tableStore = this.getTBData(moduleDesc, objFct);
	            this.state.dataSource = tableStore;
	            this.state.insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName); //绑定实例名
	            // 创建TV表头
	            var clms = this.crtClmHead(moduleDesc, ClmDes, objFct, type);
	            this.state.columns = clms ? clms : [];
	
	            // 添加表格列,拖拽页面自定义的表格列
	            this.crtClmHeadDnd(moduleDesc, moduleDesc.dnd_columns, this.state.columns, this.state.expandedColumns, objFct, type);
	
	            // 创建this.state.pagination分页信息
	            this.crtPgeBbar(moduleDesc, tableStore, objFct);
	            // 转换公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.tableProps);
	            // 转换表格属性
	            this.AddTBAttribute(moduleDesc, this.state.tableProps, type);
	            // 添加表格的选择模式
	            this.crtTblSltModel(moduleDesc);
	            // 绑定事件
	            this.bindEvent(moduleDesc, this.state.tableProps, this.state.rowSelection, this.state.functions, type);
	        }
	
	        /**
	         * 表格基本属性
	         * @param {*} moduleDesc
	         * @param {*} tableColumn
	         */
	
	    }, {
	        key: 'AddTBAttribute',
	        value: function AddTBAttribute(moduleDesc, tableProps, type) {
	
	            if (moduleDesc.isHeaders) tableProps.showHeader = !moduleDesc.isHeaders; //隐藏列头
	            if (moduleDesc.isTbSpt) tableProps.bordered = moduleDesc.isTbSpt; //列线
	
	            this.state.selFlg = !!moduleDesc.isSel; //是否筛选
	            this.state.showPageFlg = moduleDesc.isPage === false ? false : true; //是否显示翻页器,默认显示
	
	            // 表格大小
	            tableProps.size = moduleDesc.size || "small";
	
	            // 初始loading
	            this.state.loading = type === "dnd" ? false : !!moduleDesc.loading;
	
	            // 横向滚动
	            if (!tableProps.scroll) tableProps.scroll = {};
	            if (moduleDesc.scrollX) tableProps.scroll.x = moduleDesc.scrollX;else delete tableProps.scroll;
	
	            // 列可伸缩
	            this.state.resizable = !!moduleDesc.resizable;
	
	            tableProps.tableLayout = moduleDesc.tbLayout;
	        }
	
	        /**
	         * 创建表格 列头信息
	         * @param {*} moduleDesc
	         * @param {*} ClmDes
	         * @param {*} objFct
	         * @param {*} type
	         */
	
	    }, {
	        key: 'crtClmHead',
	        value: function crtClmHead(moduleDesc, ClmDes, objFct, type) {
	            //wangz追加 如果表格配置信息错误  自定义表头
	            if (!ClmDes) {
	                return;
	            }
	            var tableColumns = ClmDes.tvTitles;
	            var cldSet = ClmDes.cldSet;
	            if (tableColumns && tableColumns.length > 0) {
	                var _itemForEach = function _itemForEach() {
	                    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                    var foreach = arguments[1];
	
	                    if (!foreach || typeof foreach !== "function") return;
	                    items.forEach(function (item) {
	                        var cldSet = item.cldSet;
	                        if (cldSet && cldSet.length > 0) _itemForEach(cldSet, foreach);else if (item.sc || item.c) foreach(item);
	                    });
	                };
	
	                // 存在tvTitles
	                if (cldSet && cldSet.length > 0) {
	                    // 同步描述
	                    var allClds = {};
	                    cldSet.forEach(function (cld) {
	                        var key = cld.sc || cld.c;
	                        if (key) allClds[key] = cld;
	                    });
	                    _itemForEach(tableColumns, function (item) {
	                        var key = item.sc || item.c;
	                        var cld = allClds[key];
	                        if (cld) Object.assign(item, cld);
	                    });
	                }
	            } else {
	                // 不存在tvTitles
	                tableColumns = cldSet || [];
	            }
	            // var tableColumns = ClmDes.tvTitles || ClmDes.cldSet;
	            var alwEdit = moduleDesc.isEd;
	            var clm = this.crtTblClm(alwEdit, tableColumns, (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName), objFct, type, moduleDesc);
	            return clm;
	        }
	
	        /**
	         * 获取表格 列头信息，如果列头是根树，则迭代遍历
	         * 表格头数据
	         */
	
	    }, {
	        key: 'crtTblClm',
	        value: function crtTblClm(alwEdit) {
	            var tblClms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	            var bdInst = arguments[2];
	            var objFct = arguments[3];
	
	            var _this3 = this;
	
	            var type = arguments[4];
	            var moduleDesc = arguments[5];
	
	            var clms = [];
	            tblClms.forEach(function (item) {
	                var clmDes = _extends({}, item, item.ctlInfo);
	                if (!alwEdit && !item.isEd) clmDes.isLabel = true;
	                var text = _Resource.Resource.getTRByPrm(clmDes).te; //clmDes.te;
	                delete clmDes.ctlW;
	                // 优先--用户自定义渲染组件
	                var cstmRender = clmDes.cstmRender;
	                var $cstmRender = void 0;
	                if ((0, _sgiCommon.funStrCheck)(cstmRender)) {
	                    try {
	                        $cstmRender = new Function("text", "record", "index", "objFct", "pagination", cstmRender);
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                }
	                // 转换antd的列属性
	                var antd_props = {};
	                antd_column_prop_keys.forEach(function (key) {
	                    if (clmDes[key]) antd_props[key] = clmDes[key];
	                });
	                var clm = _extends({}, antd_props, {
	                    title: text,
	                    width: clmDes.cluW || undefined,
	                    dataIndex: clmDes.c,
	                    align: clmDes.align,
	                    render: $cstmRender ? function (text, record, index) {
	                        return $cstmRender(text, record, index, objFct, _this3.state.pagination);
	                    } : function (text, record, index) {
	                        return (0, _SgiCompComm.convertModuleByGuid)(_this3, clmDes, record, objFct, type, { noFI: true });
	                    }
	                });
	                if (clmDes.cldSet && clmDes.cldSet.length > 0) {
	                    clm.children = _this3.crtTblClm(alwEdit, clmDes.cldSet, bdInst, objFct, type) || [];
	                }
	                // 排序
	                if (clmDes.isSt || moduleDesc.allSt && (!clmDes.cldSet || clmDes.cldSet.length === 0)) {
	                    try {
	                        if (_this3.state.batchInfo.batchFun) {
	                            // 分批
	                            element.sorter = true;
	                        } else {
	                            // 不分批
	                            var key = clm.dataIndex;
	                            clm.sorter = function (a, b) {
	                                return (0, _sgiCommon.getType)(a[key]) === "string" ? a[key].localeCompare(b[key], 'zh-CN') : a[key] - b[key];
	                            };
	                        }
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.error("添加排序函数失败");
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                }
	                // if (clmDes.isSt) {//该列是否可排序
	                //     clm.sorter = (a, b) => {
	                //         return a.name.length - b.name.length;
	                //     }
	                // }
	                clms.push(clm);
	            });
	            return clms;
	        }
	
	        /**
	         * 获取表格列描述信息
	         * @param {描述信息} moduleDesc
	         */
	
	    }, {
	        key: 'getClmDes',
	        value: function getClmDes(moduleDesc) {
	            //是否绑定表头了，绑定了继续
	            var dsdDesc = moduleDesc.dsdDesc;
	            if (dsdDesc) {
	                return dsdDesc;
	            } else {
	                var guid = moduleDesc.bdTvId;
	                if (!guid) return;
	                //取得表头guid
	                var ClmDes = _PrmFactory.PrmFactory.getPrm(guid);
	                return ClmDes;
	            }
	        }
	    }, {
	        key: 'refreshByBdTv',
	        value: function refreshByBdTv(bdTv) {
	            if (!bdTv) return;
	            this.setState({ refreshFlg: true, bdTv: bdTv });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiTV;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	Object.assign(SgiTV.prototype, _SgiTableBaseFun.sgiTableBaseFun);
	Object.assign(SgiTV.prototype, _SgiTableCommon2.default);
	exports.SgiTV = SgiTV;
	exports.default = SgiTV;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiTable = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _Resource = __webpack_require__(67);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _StandardCode = __webpack_require__(81);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiTableEditorCell = __webpack_require__(252);
	
	var _SgiTableEditorCell2 = _interopRequireDefault(_SgiTableEditorCell);
	
	var _SgiTableBaseFun = __webpack_require__(371);
	
	var _reactResizable = __webpack_require__(442);
	
	var _SgiTableCommon = __webpack_require__(720);
	
	var _SgiTableCommon2 = _interopRequireDefault(_SgiTableCommon);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// import '../node_modules/react-resizable/css/styles.css';
	
	var RadioGroup = _antd.Radio.Group;
	
	var ResizeableTitle = function ResizeableTitle(props) {
	    var onResize = props.onResize,
	        width = props.width,
	        isLast = props.isLast,
	        restProps = _objectWithoutProperties(props, ['onResize', 'width', 'isLast']);
	
	    if (isLast) {
	        return _react2.default.createElement('th', restProps);
	    }
	
	    return _react2.default.createElement(
	        _reactResizable.Resizable,
	        { width: parseInt(width), height: 0, onResize: onResize },
	        _react2.default.createElement('th', restProps)
	    );
	};
	var components = {
	    header: { cell: ResizeableTitle }
	};
	
	var SgiTable = function (_React$Component) {
	    _inherits(SgiTable, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiTable(props) {
	        _classCallCheck(this, SgiTable);
	
	        var _this = _possibleConstructorReturn(this, (SgiTable.__proto__ || Object.getPrototypeOf(SgiTable)).call(this, props));
	
	        _this.render = function () {
	            var _this2 = this;
	
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                bdInst = _props.bdInst,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded) {
	                //组装属性 初始化属性到this.state
	                this.table_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            if (this.state.selFlg) this.onSel(); //筛选
	            else this.state.store = this.state.dataSource; //不筛选
	
	            var _state = this.state,
	                cstmClmnFlg = _state.cstmClmnFlg,
	                cstmClmn = _state.cstmClmn,
	                store = _state.store,
	                resizable = _state.resizable;
	
	            // 自定义列描述
	
	            if (cstmClmnFlg) {
	                try {
	                    this.state.columns = cstmClmn(this, objFct, store) || [];
	                } catch (error) {
	                    tool.sgiLogger.log(error);
	                }
	            }
	
	            var columns = this.state.columns;
	            // 可伸缩列
	            if (resizable) {
	                this.state.tableProps.components = components;
	                columns = this.state.columns.map(function (col, index, arr) {
	                    return _extends({}, col, {
	                        onHeaderCell: function onHeaderCell(column) {
	                            return {
	                                width: column.width,
	                                onResize: _this2.handleResize(index),
	                                isLast: index === arr.length - 1
	                            };
	                        }
	                    });
	                });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: 5, width: "70%", minWidth: 400, maxWidth: 800, display: this.state.selFlg ? undefined : "none" } },
	                    _react2.default.createElement(
	                        _antd.Row,
	                        null,
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: 14 },
	                            _react2.default.createElement(_antd.Input, { addonBefore: '\u7B5B\u9009\u6761\u4EF6', value: this.state.selValues.mat, onChange: this.selOnChange.bind(this, 'mat') })
	                        ),
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: 10 },
	                            _react2.default.createElement(
	                                RadioGroup,
	                                { style: { marginTop: 3, marginLeft: 10 }, value: this.state.contain, onChange: this.containOnChange.bind(this) },
	                                _react2.default.createElement(
	                                    _antd.Radio,
	                                    { value: true, style: { marginRight: 0 } },
	                                    '\u5305\u542B'
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Radio,
	                                    { value: false },
	                                    '\u6392\u9664'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_antd.Table, _extends({ className: 'sgiTable' }, this.state.tableProps, {
	                    rowKey: "_key",
	                    loading: this.state.loading,
	                    pagination: this.state.showPageFlg ? this.state.pagination : false,
	                    rowSelection: this.state.rowSelection,
	                    columns: columns,
	                    dataSource: this.state.store,
	                    onChange: this.tableOnChange.bind(this),
	                    expandedRowRender: this.state.expandedColumns.length > 0 ? this.expandedRowRender.bind(this) : undefined }))
	            );
	        };
	
	        _this.state = {
	            showPageFlg: true, //是否显示翻页信息
	            pagination: {}, //分页信息
	            batchInfo: {}, //分批查询信息
	            size: 'default',
	            expandedRowRender: [], //展开列
	            footer: {},
	            rowSelection: null, //选择属性
	            columns: [], //列信息
	            expandedColumns: [], //列信息
	            tableProps: { style: {} }, //表格属性
	            dataSource: [], //显示数据==>原始数据
	            store: [], //表格的显示数据(原始数据筛选后)
	            insName: '', //绑定实例名
	            loading: false, //刷新属性 //是否加载中
	            // selectedRowKeys: [] //选择的列信息 //放入到了rowSelection中
	            functions: {},
	            selectedRows: [], //已选择/勾选的行对象数组
	            selFlg: false,
	            selValues: {}, //筛选对象
	            contain: true, //筛选选择(包含/不包含)，默认包含
	            cstmClmnFlg: false, //自定义表格列描述
	            resizable: false //列头可伸缩
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建表格
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiTable, [{
	        key: 'table_mk',
	        value: function table_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	
	            //取得绑定列描述信息
	            var ClmDes = this.getClmDes(moduleDesc, ClmDes);
	            //绑定数据，创建表格store 搜索条、翻页控件需要使用该信息，所以先创建
	            var tableStore = this.getTBData(moduleDesc, objFct);
	            this.state.dataSource = tableStore;
	            this.state.insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName); //绑定实例名
	            //创建表头
	            var clms = this.crtClmHead(moduleDesc, ClmDes, objFct, type);
	            this.state.columns = clms ? clms : [];
	
	            //添加表格列,拖拽页面自定义的表格列
	            this.crtClmHeadDnd(moduleDesc, moduleDesc.dnd_columns, this.state.columns, this.state.expandedColumns, objFct, type);
	
	            //分页信息
	            this.crtPgeBbar(moduleDesc, tableStore, objFct);
	            //转换公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.tableProps);
	            //创建表格属性
	            this.AddTBAttribute(moduleDesc, this.state.tableProps, type);
	            //添加表格的选择模式
	            this.crtTblSltModel(moduleDesc);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.tableProps, this.state.rowSelection, this.state.functions, type);
	        }
	
	        /**
	         * 表格基本属性
	         * @param {*} moduleDesc
	         * @param {*} tableColumn
	         */
	
	    }, {
	        key: 'AddTBAttribute',
	        value: function AddTBAttribute(moduleDesc, tableProps, type) {
	
	            // tableProps.scroll = {};
	            // var ctlW = moduleDesc.ctlW; //form宽度
	            // if (ctlW) tableProps.scroll.x = ctlW;
	            // var ctlH = moduleDesc.ctlH; //form高度
	            // if (ctlH) tableProps.scroll.y = ctlH;
	            if (moduleDesc.isHeaders) tableProps.showHeader = !moduleDesc.isHeaders; //隐藏列头
	            if (moduleDesc.isTbSpt) tableProps.bordered = moduleDesc.isTbSpt; //列线
	            // if (moduleDesc.te) tableProps.title = tableProps.te;//公共转换中已从资源获取//Resource.getTRByPrm(moduleDesc).te; //表头
	            // if (moduleDesc.isTtl) tableProps.showHeader = moduleDesc.isTtl; //是否显示表头
	
	            this.state.selFlg = !!moduleDesc.isSel; //是否筛选
	            this.state.showPageFlg = moduleDesc.isPage === false ? false : true; //是否显示翻页器,默认显示
	
	            // 表格大小
	            tableProps.size = moduleDesc.size || "small";
	
	            // 初始loading
	            this.state.loading = type === "dnd" ? false : !!moduleDesc.loading;
	
	            // 横向滚动
	            if (!tableProps.scroll) tableProps.scroll = {};
	            if (moduleDesc.scrollX) tableProps.scroll.x = moduleDesc.scrollX;else delete tableProps.scroll;
	
	            // 列可伸缩
	            this.state.resizable = !!moduleDesc.resizable;
	
	            // 默认全部展开
	            tableProps.defaultExpandAllRows = moduleDesc.defaultExpandAllRows;
	            // 指定树形结构的列名
	            tableProps.childrenColumnName = moduleDesc.childrenColumnName || "children";
	        }
	
	        /**
	         * 创建表格 列头信息
	         * @param {*} moduleDesc
	         * @param {*} ClmDes
	         * @param {*} objFct
	         * @param {*} type
	         */
	
	    }, {
	        key: 'crtClmHead',
	        value: function crtClmHead(moduleDesc, ClmDes, objFct, type) {
	            //wangz追加 如果表格配置信息错误  自定义表头
	            if (!ClmDes) {
	                return;
	            }
	            var tableColumns = ClmDes.cldSet;
	            var alwEdit = moduleDesc.isEd;
	            var clm = this.crtTblClm(alwEdit, tableColumns, (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName), objFct, type);
	            return clm;
	        }
	
	        /**
	         * 获取表格 列头信息，如果列头是根树，则迭代遍历
	         * 表格头数据
	         */
	
	    }, {
	        key: 'crtTblClm',
	        value: function crtTblClm(alwEdit, tblClms, bdData, objFct, type) {
	            var clms = [];
	            tool.sgiLogger.log(tblClms);
	            for (var i in tblClms) {
	                var clm = {};
	                var clmDes = tblClms[i];
	                var cluW = clmDes.cluW;
	                if (!cluW) {
	                    cluW = undefined; //默认大小
	                }
	                var text = _Resource.Resource.getTRByPrm(clmDes).te; //clmDes.te;
	                clm.title = text;
	                clm.width = cluW; //设置列宽
	                if (clmDes.isSt) {
	                    //该列是否可排序
	                    clm.sorter = function (a, b) {
	                        return a.name.length - b.name.length;
	                    };
	                }
	                // clm.align = Ep.Utl.getClmAlg(clmDes.teAl); //设置列标题和数据的对其方式 0 :left 1:center 2;right
	                // clm.hidden = clmDes.isHdn; //对应Ext是“是否隐藏”属性
	                // clm.hideable = clmDes.HdAbl; //对应Ext是“是否隐藏”属性
	                // clm.menuDisabled = clmDes.isCluMu; //是否显示列头菜单
	                // clm.draggable = clmDes.isDgClu; //设置列头是否可以拖动，默认为true
	                // clm.locked = clmDes.isLkClu; //表格是否可以锁定
	                // clm.lockable = clmDes.isUnlkClu; //是否可通过列menu进行解锁
	                // clm.groupable = clmDes.isGp; //设置在使用groupping分组特性的情况下是否禁止该列在标题菜单中等的分组功能
	                // clm.flex = clmDes.cluSca; //列宽的比例
	                // if (clmDes.fmter) {
	                //     clm.formatter = clmDes.fmter;
	                // }
	                // //合计种类 summaryType sum
	                // clm.summaryType = clmDes.smayType;
	                // //合计函数 summaryRenderer
	                // if (clmDes.smayFun) {
	                //     var getTextStyle = new Function("value", "summaryData", "dataIndex", clmDes.smayFun);
	                //     clm.summaryRenderer = getTextStyle;
	                // }
	                // clm.disIndex = clmDes.isdisIndex;//显示列  20170522增加-wangj
	                // Ep.Utl.crtTblClmFmt(clm, clmDes, bdData, objFct, ws, type); //表格数据格式化展示
	                // var isEditor = clmDes.isEd; //表格列是否可编辑
	                // if (isEditor) {
	                //     var ctlDes = clmDes.cldSet;
	                //     if (ctlDes) {
	                //         clm.editor = this.crtTblClmEditor(clmDes, bdData, objFct, ws, type);
	                //     }
	
	                // }
	                // var childs = clmDes.cldSet;
	                // if (clmDes.isGp && !this.isEmpty(childs) && childs.length > 0 && childs[0].desId === "EP_EO_TV_Node") {
	                //     clm.columns = this.crtTblClm(alwEdit, childs, bdData, objFct, ws, type, true);
	                // } else {
	                //     clm.dataIndex = clmDes.c; //设置列与数据集中数据的对应关系值为数据模型中的字段名称
	                // }
	                clm.dataIndex = clmDes.c;
	                clm.align = clmDes.align;
	                clms[i] = clm;
	            }
	            return clms;
	        }
	
	        /**
	         * 获取表格列描述信息
	         * @param {描述信息} moduleDesc
	         */
	
	    }, {
	        key: 'getClmDes',
	        value: function getClmDes(moduleDesc) {
	            //是否绑定表头了，绑定了继续
	            var guid = moduleDesc.cluDes;
	            if (!guid) {
	                return;
	            }
	            //取得表头guid
	            var ClmDes = _PrmFactory.PrmFactory.getPrm(guid);
	            return ClmDes;
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiTable;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiTable.defaultProps = {
	    // type: 'N',
	};
	SgiTable.propTypes = {};
	Object.assign(SgiTable.prototype, _SgiTableBaseFun.sgiTableBaseFun);
	Object.assign(SgiTable.prototype, _SgiTableCommon2.default);
	exports.SgiTable = SgiTable;
	exports.default = SgiTable;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SgiTableCommon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _antd = __webpack_require__(18);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _Resource = __webpack_require__(67);
	
	var _StandardCode = __webpack_require__(81);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiTableEditorCell = __webpack_require__(252);
	
	var _SgiTableEditorCell2 = _interopRequireDefault(_SgiTableEditorCell);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var SgiTableCommon = {
		/**
	     * 如果是分批 给表格设置分批函数
	     * @param {*} batchFun 
	     */
		setBatchInfo: function setBatchInfo(path, data, callback, reqType, flag) {
			this.state.batchInfo = {
				batchFun: callback,
				path: path,
				data: data,
				reqType: reqType,
				flag: flag
			};
			this.state.pagination.total = 0; //重置条件需重新查询总数
		},
		callBatch: function callBatch(path, data, reqType, flag, params, filters, sorter) {
			if (!path) {
				return;
			}
	
			//wzhe 2020-3-10
			//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
			var url = void 0;
			var siGuid = void 0;
			if (path.constructor === Object) {
				url = path.siUrl;
				siGuid = path.rlsGuid;
			} else {
				url = path;
			}
	
			var request = { head: tool.getLoginInfo ? tool.getLoginInfo() : {} };
			//wzhe 2020-3-10
			//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
			request.head.serviceId = siGuid;
			// if (!request.head) request.head = {};
	
			if (params.pageSize) {
				request.head.pageSize = parseInt(params.pageSize);
			} else {
				request.head.pageSize = 10;
			}
			if (params.current) {
				request.head.offset = params.current;
			} else {
				request.head.offset = 1;
			}
			// sortBasis放排序属性名、sort放排序方式（ASC/DESC）
			if (sorter && sorter.order) {
				request.head.sortBasis = sorter.field;
				request.head.sort = sorter.order === "descend" ? "DESC" : "ASC";
			}
	
			// 是否查总数
			var totalFlg = this.state.pagination.total > 0;
			if (!totalFlg) {
				request.head.queryTotal = "1";
			}
	
			if (data) {
				request.body = data;
			}
	
			request = tool.jsonToStr(request);
	
			var response = { head: {}, body: {} };
			var sucfunc = function sucfunc(res) {
				response = res;
	
				//session超时校验
				if (response && response.head && (response.head.code == '0405' || response.head.code == '0401')) {
					//失效 重新登录
					if (tool && tool.logout) {
						// message.warning('登录超时，请重新登录');
						tool.popMessage("登录超时，请重新登录", "warning");
						tool.logout();
					}
					return;
				}
	
				if (this.state.batchInfo.batchFun) {
					this.state.batchInfo.batchFun(res);
	
					if (!response.head) response.head = {};
					// let pageCount = response.head.pageCount;
					var recordCount = response.head.recordCount;
	
					if (!totalFlg) this.state.pagination.total = response.head.pageCount;
					this.setState({ loading: false });
				}
			};
			var failfunc = function failfunc(xhr, textStatus, errorThrown) {
				tool.sgiLogger.log("状态码" + xhr.status + " - " + xhr.readyState + ",错误信息" + textStatus);
				response.head.code = xhr.status;
				response.head.msg = textStatus;
				if (this.state.batchInfo.batchFun) {
					this.state.batchInfo.batchFun(response);
				}
			};
			// let url = path;
	
			var header = tool.getHeaderInfo ? tool.getHeaderInfo() : {};
			if (!reqType) {
				reqType = 'post';
				header['Content-Type'] = "application/json; charset=utf-8";
			}
			//wzhe 2020-3-10
			//为满足 新的要求  path增加对象模式 从中解析出url地址和接口id
			header.serviceId = siGuid;
	
			sgiClient.restcall(url, reqType, request, header, flag, sucfunc.bind(this), failfunc.bind(this));
	
			return response;
		},
	
	
		/**
	  * 分批从这里触发
	  * @param {*} current 
	  */
		batchSelect: function batchSelect(current, filters, sorter) {
			if (current) this.state.pagination.current = current;
			if (this.state.batchInfo.batchFun) {
				this.setState({ loading: true });
				this.callBatch(this.state.batchInfo.path, this.state.batchInfo.data, this.state.batchInfo.reqType, this.state.batchInfo.flag, _extends({}, this.state.pagination), filters, sorter);
				// this.state.batchFun({ ...this.state.pagination }, this.batchCallBack.bind(this));
			}
		},
	
	
		/**
	  * 分批的回调函数，刷新页面
	  * @param {*} total 
	  * @param {*} data 
	  */
		batchCallBack: function batchCallBack(total, data) {
			this.state.pagination.total = total;
			this.state.dataSource = data;
			this.setState({ loading: false });
		},
	
	
		/**
	  * 表格的分页触发  刷新事件
	  * @param {*} pagination 
	  * @param {*} filters 
	  * @param {*} sorter 
	  */
		tableOnChange: function tableOnChange(pagination, filters, sorter) {
			if (this.state.batchInfo.batchFun) {
				this.batchSelect(pagination.current, filters, sorter);
			}
		},
		crtClmOptDnd: function crtClmOptDnd(element, record, index) {
			var btnName = element.btnName,
			    btnIcon = element.btnIcon,
			    optType = element.optType,
			    iCLsn = element.iCLsn,
			    btnTip = element.btnTip,
			    isPopconfirm = element.isPopconfirm,
			    PopconfirmText = element.PopconfirmText,
			    customProps = element.customProps;
	
			var clickLsn = void 0;
			var clickLsnCover = void 0;
			if (!customProps) customProps = {};
			if (!customProps.style) customProps.style = {};
			if (!customProps.style.margin) customProps.style.margin = "0px 10px 0px 0px";
			// customProps.style.height = "22px";
			var optProp = _extends({}, customProps);
			var onClick = void 0;
			if (iCLsn) {
				clickLsn = new Function("module", "objFct", "record", "index", iCLsn);
				clickLsnCover = function clickLsnCover(module, objFct, record, index) {
					tool.sgiLogger.log('表格按钮点击事件');
					clickLsn(module, objFct, record, index);
				};
				onClick = clickLsnCover.bind(this, this, this.props.objFct, record, index);
			}
			if (!isPopconfirm) {
				//显示气泡确认框的是时候  事件转移给弹出框
				optProp.onClick = onClick;
			}
			var rtnOptInfo = void 0;
			if (!optType || optType == 'btn') {
				rtnOptInfo = _react2.default.createElement(
					_antd.Tooltip,
					{ title: btnTip, placement: 'right', mouseEnterDelay: 1 },
					_react2.default.createElement(
						_antd.Button,
						_extends({}, optProp, { icon: btnIcon }),
						btnName
					)
				);
			} else if (optType == 'href') {
				rtnOptInfo = _react2.default.createElement(
					_antd.Tooltip,
					{ title: btnTip, placement: 'right', mouseEnterDelay: 1 },
					_react2.default.createElement(
						'a',
						optProp,
						btnName,
						btnIcon ? _react2.default.createElement(_antd.Icon, { type: btnIcon, style: { fontSize: 16, color: '#08c' } }) : null
					)
				);
			}
			if (isPopconfirm) {
				return _react2.default.createElement(
					_antd.Popconfirm,
					{ title: PopconfirmText, onConfirm: onClick },
					rtnOptInfo
				);
			}
			return rtnOptInfo;
		},
	
	
		/**
	  * 添加表格列
	  * @param {*} moduleDesc
	  * @param {*} columns
	  */
		crtClmHeadDnd: function crtClmHeadDnd(moduleDesc, dnd_columns, columns, expandedColumns, objFct, type) {
			var _this = this;
	
			// 自定义列描述优先
			var cstmClmn = moduleDesc.cstmClmn;
			if (cstmClmn) {
				var $cstmClmn = void 0;
				try {
					$cstmClmn = new Function("module", "objFct", "data", cstmClmn);
				} catch (error) {
					_sgiLogger.sgiLogger.eventErr(error);
				}
				if ($cstmClmn) {
					this.state.cstmClmn = $cstmClmn;
				}
				this.state.cstmClmnFlg = true;
				return;
			}
	
			if (dnd_columns && dnd_columns.length > 0) {
				//拖拽的时候  拷贝一份数据，导致篡改了，拖拽的数组
				if (type == 'dnd') {
					dnd_columns = (0, _sgiCommon.copyArr)(dnd_columns, true);
				}
				dnd_columns.forEach(function (element) {
					//列名key为title，但存储时采用te\teid形式，这里统一转换
					element.title = _Resource.Resource.getTRByPrm(element).te || element.title;
	
					// 优先--用户自定义渲染组件
					var cstmRender = element.cstmRender;
					var $cstmRender = void 0;
					if ((0, _sgiCommon.funStrCheck)(cstmRender)) {
						try {
							$cstmRender = new Function("text", "record", "index", "objFct", "pagination", cstmRender);
						} catch (error) {
							_sgiLogger.sgiLogger.eventErr(error);
						}
						var cstmCtl = void 0;
						if ($cstmRender) {
							cstmCtl = element.render = function (text, record, index) {
								return $cstmRender(text, record, index, objFct, _this.state.pagination);
							};
							columns.push(element);
							return; //foreach的continue;
						}
					}
	
					// 用户自定义显示样式
					var befRender = element.befRender;
					var $befRender = void 0;
					if (befRender) {
						try {
							$befRender = new Function("text", "record", "index", "objFct", befRender);
						} catch (error) {
							_sgiLogger.sgiLogger.eventErr(error);
						}
					}
	
					//扩展列不在这里展示
					if (element.mdType == 'expanded') {
						expandedColumns.push(element);
						return;
					}
	
					if (element.clmType == 'optGroup') {
						var children = element.children;
	
						if (!children || children.length < 1) {
							return;
						}
						element.render = function (text, record, index) {
							var optList = [];
							children.forEach(function (sonElement) {
								// 优先--用户自定义渲染组件
								var sCstmRender = sonElement.cstmRender;
								var $sCstmRender = void 0;
								if ((0, _sgiCommon.funStrCheck)(sCstmRender)) {
									try {
										$sCstmRender = new Function("text", "record", "index", "objFct", sCstmRender);
									} catch (error) {
										_sgiLogger.sgiLogger.eventErr(error);
									}
									var _cstmCtl = void 0;
									if ($sCstmRender) _cstmCtl = $sCstmRender(text, record, index, objFct);
									optList.push(_cstmCtl);
									return;
								}
								// 其次--用户自定义显示样式
								var sBefRender = sonElement.befRender;
								var $sBefRender = void 0;
								if (sBefRender) {
									try {
										$sBefRender = new Function("text", "record", "index", "objFct", sBefRender);
									} catch (error) {
										_sgiLogger.sgiLogger.eventErr(error);
									}
								}
								var customProps = void 0;
								if ($sBefRender) customProps = $sBefRender(text, record, index, objFct);
								sonElement.customProps = customProps || {};
								optList.push(_this.crtClmOptDnd(sonElement, record, index, objFct));
							});
							return _react2.default.createElement(
								'span',
								null,
								optList
							);
						};
						// delete element.children;//没办法进行第二次创建了，少东西
						columns.push(Object.assign({}, element, { children: undefined }));
						return;
					} else if (element.clmType == 'opt') {
						element.render = function (text, record, index) {
							var customProps = void 0;
							if ($befRender) customProps = $befRender(text, record, index, objFct);
							element.customProps = customProps || {};
							return _react2.default.createElement(
								'span',
								null,
								_this.crtClmOptDnd(element, record, index, objFct)
							);
						};
					} else {
						var _children = element.children,
						    mdType = element.mdType,
						    scId = element.scId,
						    width = element.width;
	
	
						if (moduleDesc.isEd && (!_children || _children.length < 1)) {
							element.render = function (edMdDesc, objFct, type, bdInst, text, record, index) {
								return _react2.default.createElement(_SgiTableEditorCell2.default, {
									record: record,
									moduleDesc: edMdDesc,
									tableBDInst: bdInst + '`' + index,
									objFct: objFct,
									type: type
								});
							}.bind(_this, element, objFct, type, (0, _SgiCommon.getConstByKey)(_this, moduleDesc.insName));
						} else {
							if (mdType === 'combox' && scId) {
								element.render = function (scId, text, record, index) {
									var customProps = void 0;
									if ($befRender) customProps = $befRender(text, record, index, objFct);
									// 下拉窗列表值在标准代码中的id
									var comboBoxData = _StandardCode.StandardCode.getSC(scId);
									if (comboBoxData && comboBoxData.length > 0) {
										var size = comboBoxData.length;
										if (!size == 0) {
											for (var i = 0; i < size; i++) {
												var item = comboBoxData[i];
												if (item.c == text) {
													if (customProps) {
														return _react2.default.createElement(
															'span',
															customProps,
															item.te
														);
													} else {
														return item.te;
													}
												}
											}
										}
									} else {
										if (customProps) {
											return _react2.default.createElement(
												'span',
												customProps,
												text
											);
										} else {
											return text;
										}
									}
								}.bind(_this, scId);
							} else if (mdType === 'area') {
								//富文本
								element.render = function (text, record, index) {
									var customProps = {};
									if ($befRender) customProps = $befRender(text, record, index, objFct);
									if (!customProps) {
										customProps = { style: {} };
									}
									if (!customProps.style) {
										customProps.style = {};
									}
									customProps.style.textOverflow = 'ellipsis';
									customProps.style.whiteSpace = 'nowrap';
									customProps.style.overflow = 'hidden';
									customProps.style.width = width ? width + 'px' : '200px';
									return _react2.default.createElement(
										'div',
										customProps,
										text
									);
								};
							} else if (mdType === 'amount') {
								//金额
								var dcmDgt = element.dcmDgt;
								element.render = function (text, record, index) {
									var customProps = {};
									if ($befRender) customProps = $befRender(text, record, index, objFct);
									text = _sgiCommon.Format.amount(text, dcmDgt);
									if (customProps) {
										return _react2.default.createElement(
											'span',
											customProps,
											text
										);
									}
									return text;
								};
							} else if (mdType === 'percent') {
								//金额
								var num = element.num,
								    total = element.total,
								    _dcmDgt = element.dcmDgt,
								    isPerSign = element.isPerSign;
	
								element.render = function (text, record, index) {
									var customProps = {};
									if ($befRender) customProps = $befRender(text, record, index, objFct);
									text = _sgiCommon.Format.percent(isNaN(num) ? record[num] : num, isNaN(total) ? record[total] : total, _dcmDgt, !isPerSign);
									if (customProps) {
										return _react2.default.createElement(
											'span',
											customProps,
											text
										);
									}
									return text;
								};
							} else {
								//普通列
								element.render = function (text, record, index) {
									var customProps = void 0;
									if ($befRender) customProps = $befRender(text, record, index, objFct);
									if (customProps || customProps == 0) {
										//普通列
										// var temp = document.createElement("div"); 
										// temp.innerHTML = customProps;
										return _react2.default.createElement(
											'div',
											null,
											customProps
										);
									} else {
										return text;
									}
								};
							}
							if (_children && _children.length > 0) {
								var sonColumns = [];
								_this.crtClmHeadDnd(moduleDesc, _children, sonColumns, type, objFct);
								element.children = sonColumns; //转换一下
							}
						}
					}
					// 排序
					if (element.isSt || moduleDesc.allSt && element.clmType === 'clm' && (!element.children || element.children.length === 0)) {
						try {
							if (_this.state.batchInfo.batchFun) {
								// 分批
								element.sorter = true;
							} else {
								// 不分批
								var key = element.dataIndex;
								element.sorter = function (a, b) {
									return (0, _sgiCommon.getType)(a[key]) === "string" ? a[key].localeCompare(b[key], 'zh-CN') : a[key] - b[key];
								};
							}
						} catch (error) {
							_sgiLogger.sgiLogger.error("添加排序函数失败");
							_sgiLogger.sgiLogger.eventErr(error);
						}
					}
					columns.push(element);
				});
			}
		},
	
	
		/**
	  * 绑定事件
	  * @param {*} moduleDesc
	  * @param {*} treeProps
	  */
		bindEvent: function bindEvent(moduleDesc, tableProps, rowSelection, functions, type) {
			var _this2 = this;
	
			//拖拽模式 不生成事件
			//表格单击事件
			var iCLsn = moduleDesc.iCLsn; // 用户自定义点击事件
			if (iCLsn && type != 'dnd') {
				var $iCLsn;
				try {
					$iCLsn = new Function("module", "objFct", "record", "index", iCLsn);
				} catch (error) {
					_sgiLogger.sgiLogger.eventErr(error);
				}
	
				functions.onRowClick = $iCLsn;
			}
			tableProps.onRowClick = _SgiEventHandler.SgiEventHandler.tableClick.bind(this);
	
			var dbCLsn = moduleDesc.dbCLsn; // 用户自定义双击事件
			if (dbCLsn && type != 'dnd') {
				var $dbCLsn;
				try {
					$dbCLsn = new Function("module", "objFct", "record", "index", dbCLsn);
				} catch (error) {
					_sgiLogger.sgiLogger.eventErr(error);
				}
				functions.onRowDoubleClick = $dbCLsn;
			}
			tableProps.onRowDoubleClick = _SgiEventHandler.SgiEventHandler.itemdblclick.bind(this);
	
			var ckLsn = moduleDesc.ckLsn; // 用户自定义勾选事件
			if (ckLsn && type != 'dnd') {
				var $ckLsn;
				try {
					$ckLsn = new Function("module", "objFct", "selectType", "record", "selected", "selectedRows", ckLsn);
				} catch (error) {
					_sgiLogger.sgiLogger.eventErr(error);
				}
				functions.onRowCheck = $ckLsn;
			}
	
			if (!rowSelection) {
				return;
			}
			//onChange(selectedRowKeys, selectedRows):已勾选key数组，已勾选行对象数组
			//手动(取消)勾选/点击(取消)全选时触发，通过方法(取消)勾选不会触发
			rowSelection.onChange = function (selectedRowKeys, selectedRows) {
				_this2.setState({ selectedRows: selectedRows });
				_this2.state.rowSelection.selectedRowKeys = selectedRowKeys;
				_this2.setState({ loading: false });
				tool.sgiLogger.log('selectedRowKeys changed: ' + selectedRowKeys);
			};
			//onSelect(record, selected, selectedRows, nativeEvent):当前操作对象，勾选状态，已勾选行对象数组，
			//手动(取消)勾选时触发，点击(取消)全选时不会触发
			rowSelection.onSelect = function (record, selected, selectedRows) {
				// this.setState({ selectedRows: selectedRows });
				tool.sgiLogger.log("table rowSelection onSelect, record:", record, "selected:", selected, "selectedRows:", selectedRows);
	
				// 执行自定义勾选事件
				_SgiEventHandler.SgiEventHandler.tableCheck.call(_this2, "selectRecord", record, selected, selectedRows);
			};
			//onSelectAll(selected, selectedRows, changeRows):勾选状态，已勾选行对象数组，勾选状态发生变化的对象数组（即全部数据）
			//点击(取消)全选时触发，手动一个一个勾选至(非)全选时不触发
			rowSelection.onSelectAll = function (selected, selectedRows) {
				// this.setState({ selectedRows: selectedRows });
				tool.sgiLogger.log("table rowSelection onSelectAll, selected:", selected, "selectedRows:", selectedRows);
	
				// 执行自定义勾选事件
				_SgiEventHandler.SgiEventHandler.tableCheck.call(_this2, "selectAll", null, selected, selectedRows);
			};
		},
	
	
		/**
	     * 创建表格的选择模式
	     * @param {TD} 表格描述
	     * 创建表格选择模式使用表格以下属性
	     * SltMdTyp：表格选择模式（0:选择行、1:选择格、2:带CheckBox的选择行）
	     * sltMd：表格的行选择模式，0 单选 1 ：点击行进行多选  2：多选 按住ctrl或者shift多选
	     */
		crtTblSltModel: function crtTblSltModel(moduleDesc) {
			var rowSelection = {};
			//单选多选
			var rowSMd = moduleDesc.rowSMd;
			if (!rowSMd || rowSMd == "9") {} else if (!rowSMd || rowSMd == "0") {
				this.state.rowSelection = {};
				this.state.rowSelection.type = 'radio'; //放弃不放
				this.state.rowSelection.columnWidth = '35px';
			} else if (rowSMd == 1 || rowSMd == 2) {
				this.state.rowSelection = {};
				this.state.rowSelection.type = 'checkbox';
				this.state.rowSelection.selectedRowKeys = [];
				this.state.rowSelection.columnWidth = '35px';
			}
		},
		setTbSelType: function setTbSelType(type) {
			var moduleDesc = this.props.moduleDesc;
			var consType = this.props.type;
			//单选多选
			var rowSMd = type;
			if (!rowSMd || rowSMd == "none") {
				this.state.rowSelection = undefined;
			} else if (rowSMd == "radio") {
				this.state.rowSelection = {};
				this.state.rowSelection.type = 'radio'; //放弃不放
				this.state.rowSelection.columnWidth = '35px';
				//绑定事件
				this.bindEvent(moduleDesc, this.state.tableProps, this.state.rowSelection, this.state.functions, consType);
			} else if (rowSMd == "checkbox") {
				this.state.rowSelection = {};
				this.state.rowSelection.type = 'checkbox';
				this.state.rowSelection.selectedRowKeys = [];
				this.state.rowSelection.columnWidth = '35px';
				//绑定事件
				this.bindEvent(moduleDesc, this.state.tableProps, this.state.rowSelection, this.state.functions, consType);
			}
			this.setState({ loading: false });
		},
		showTotal: function showTotal(total) {
			return '\u603B\u6570 ' + (this.state.pagination.total || total);
		},
	
	
		/**
	  * 创建表格下部翻页工具条
	  * @param {*} moduleDesc
	  * @param {*} tableStore
	  * @param {*} ws
	  * @param {*} objFct
	  */
		crtPgeBbar: function crtPgeBbar(moduleDesc, tableStore, objFct) {
			var _this3 = this;
	
			if (moduleDesc.isPg) {
				//是否带翻页控件
				var pgRows = moduleDesc.pgRows;
				var pageSizeOptions = ["10", "20", "30", "40", "50", "60", "70", "80", "90", "100"];
				if (!pgRows) pgRows = 10;else pageSizeOptions.unshift(pgRows + "");
				var pagination = {
					total: tableStore.length,
					// current: 1,
					showSizeChanger: true,
					// showQuickJumper :true,
					size: 'small',
					pageSize: pgRows,
					showTotal: this.showTotal.bind(this),
					// simple:true,
					onShowSizeChange: function onShowSizeChange(current, pageSize) {
						_this3.state.pagination.pageSize = pageSize;
					},
					pageSizeOptions: pageSizeOptions
				};
				this.state.pagination = pagination;
			}
		},
	
	
		/**
	  * 创建表格绑定store
	  * @param {*} moduleDesc
	  * @param {*} objFct
	  * @param {*} ClmDes
	  */
		getTBData: function getTBData(moduleDesc, objFct) {
			//取得绑定实例名
			var insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName); //绑定实例名
			var tData;
			//取得绑定类名`  var tData = [];
			if (insName && objFct) {
				tData = objFct.get(insName);
			}
			if (!tData) {
				tData = [];
				if (objFct) objFct.set(insName, tData); //默认放入空数组  删除添加时，同步数据bug问题
				return tData;
			}
			// tData.forEach(element => {
			// 	if (!element._key) element._key = uuid(8)
			// })
			this._setKey(tData, moduleDesc.childrenColumnName);
			return tData;
		},
	
	
		/**
	  * 递归给_key赋值
	  * 树表结构时子节点也需设置_key,否则渲染不出来子节点
	  * childrenColumnName:子节点属性key
	  */
		_setKey: function _setKey(tData) {
			var _this4 = this;
	
			var childrenColumnName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "children";
	
			if (!Array.isArray(tData)) return;
			tData.forEach(function (element) {
				if (!element._key) {
					element._key = (0, _sgiCommon.uuid)(8);
				}
				if (Array.isArray(element[childrenColumnName])) {
					_this4._setKey(element[childrenColumnName], childrenColumnName);
				}
			});
		},
	
	
		/**
	     * [刷新表格控件]
	     * @param  {[type]} tableData [表格数据对象数组]
	     * @return {[type]}           [description]
	     */
		refreshTable: function refreshTable(tableData) {
			if (tableData) {
				this.state.dataSource = tableData;
				if ((0, _SgiCommon.testReactVsn)(this, 16)) this.state.tableProps.key = (0, _sgiCommon.uuidDate)(6); //react16引用不变无法刷新，这里强制重新渲染
	
				this.state.dataSource.forEach(function (element) {
					if (!element._key) element._key = (0, _sgiCommon.uuid)(8);
				});
	
				// 如果不是分批表格，直接同步总数=表格数据总数
				if (!this.state.batchInfo.batchFun) {
					this.state.pagination.total = tableData.length;
				}
	
				this.setState({ loading: false });
			}
		},
		refresh: function refresh() {
			this.loaded = false;
			this.setState({ loading: false });
		},
	
	
		//即时筛选
		selOnChange: function selOnChange(attname, e, e2) {
			var value = e.target.value;
			this.state.selValues[attname] = value;
			this.onSel();
			this.setState({ loading: false });
		},
	
	
		//筛选方法
		onSel: function onSel() {
			var _this5 = this;
	
			var mat = this.state.selValues.mat;
	
			if (mat) {
				var reg = new RegExp(mat, 'gi');
				this.state.store = this.state.dataSource.filter(function (e, i, a) {
					// return e.n.match(reg) || e.te.match(reg) || e.guid.match(reg);
					return _this5._match(e, reg);
				});
			} else {
				this.state.store = this.state.dataSource;
			}
			this._synPagination();
		},
	
	
		//遍历属性是否含有匹配值，返回boolen
		_match: function _match(e, reg) {
			var columns = this.state.columns;
			var indexs = columns.map(function (col) {
				return col.dataIndex;
			}).filter(function (d) {
				return d;
			}); //filter去除空值/假值
			if (this.state.contain) {
				//包含
				for (var i = 0; i < indexs.length; i++) {
					if (e[indexs[i]] && e[indexs[i]].toString().match(reg)) return true; //数字等值需要使用toString进行转换
				}
				return false;
			} else {
				//排除
				for (var _i = 0; _i < indexs.length; _i++) {
					if (e[indexs[_i]] && e[indexs[_i]].toString().match(reg)) return false; //数字等值需要使用toString进行转换
				}
				return true;
			}
		},
	
	
		// 根据表格数据同步表格总数
		_synPagination: function _synPagination() {
			var store = this.state.store || [];
			this.state.pagination.total = store.length;
		},
	
	
		// 包含/不包含筛选选项切换事件
		containOnChange: function containOnChange(e) {
			var value = e.target.value;
			// this.state.contain = !!value;
			this.setState({ contain: !!value });
		},
		expandedRowRender: function expandedRowRender(record) {
			var expandedList = [];
			this.state.expandedColumns.forEach(function (element) {
				// if (record[element.dataIndex]) {
				var errFlg = false;
				var value = void 0;
				try {
					value = eval('record.' + element.dataIndex);
				} catch (error) {
					tool.sgiLogger.log("eval获取嵌套属性失败：", error);
					errFlg = true;
				}
				expandedList.push(_react2.default.createElement(
					'p',
					{ style: { margin: 0 } },
					errFlg ? record[element.dataIndex] : value
				));
				// }
			});
			// tool.sgiLogger.log("expandedList:", expandedList);
			return _react2.default.createElement(
				'div',
				null,
				expandedList
			);
		},
		setLoading: function setLoading(loading) {
			this.setState({ loading: loading });
		},
		handleResize: function handleResize(index) {
			var _this6 = this;
	
			return function (e, _ref) {
				var size = _ref.size;
	
				// this.setState(({ columns }) => {
				//     const nextColumns = [...columns];
				//     nextColumns[index] = {
				//         ...nextColumns[index],
				//         width: size.width,
				//     };
				//     return { columns: nextColumns };
				// });
				_this6.state.columns[index].width = size.width;
				if ((0, _SgiCommon.testReactVsn)(_this6, 16)) {
					// react16需要更新引用
					_this6.state.columns = [].concat(_toConsumableArray(_this6.state.columns));
				}
				_this6.setState({});
			};
		}
	};
	
	exports.SgiTableCommon = SgiTableCommon;
	exports.default = SgiTableCommon;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SgiTabs = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// import { addTabCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun'
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _Resource = __webpack_require__(67);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiCompConstant = __webpack_require__(107);
	
	var _reactSticky = __webpack_require__(1978);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	// const Panel = Collapse.Panel;
	
	var tabPanePrefix = "tp_";
	
	var renderStickyTabBar = function renderStickyTabBar(props, DefaultTabBar) {
		return _react2.default.createElement(
			_reactSticky.Sticky,
			{ bottomOffset: 80 },
			function (_ref) {
				var style = _ref.style;
				return _react2.default.createElement(DefaultTabBar, _extends({}, props, { style: _extends({}, style, { zIndex: 1 }) }));
			}
		);
	};
	
	var SgiTabs = function (_React$Component) {
		_inherits(SgiTabs, _React$Component);
	
		//这个暂时不好用 以后在处理
		function SgiTabs(props) {
			_classCallCheck(this, SgiTabs);
	
			var _this = _possibleConstructorReturn(this, (SgiTabs.__proto__ || Object.getPrototypeOf(SgiTabs)).call(this, props));
	
			_this.fitTabExtraContent = function (moduleDesc, tabsItems, objFct, type) {
	
				var me = this;
	
				// 拖拽模式特殊处理
				if (type === "dnd") {
					// 构建tabBarExtraContent
					var sonItems = me.props.children;
					if (sonItems && sonItems.length && sonItems.length > 0) {
						sonItems.forEach(function (child, index) {
							var desId = child.props.moduleDesc.desId;
							// 处理工具条
							if (desId === _SgiCompConstant.AllCompGUID.TOOLBAR) {
								me.state.tabBarExtraContent.push(child);
							}
						});
					}
					return;
				}
	
				//form下的子节点添加到form组件中
				// me.itemPanelType = 'tabs';
				// tool.sgiLogger.log("tabs");
				var cldSet = moduleDesc.cldSet;
				if (cldSet && cldSet.length && cldSet.length > 0) {
					cldSet.forEach(function (item, index) {
						// 处理工具条
						if (item.desId === _SgiCompConstant.AllCompGUID.TOOLBAR) {
							me.state.tabBarExtraContent.push((0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type));
						}
					});
				}
			};
	
			_this.fitTabsItems = function (moduleDesc, tabsItems, objFct, type) {
				var _this2 = this;
	
				var me = this;
				//form下的子节点添加到form组件中
				// me.itemPanelType = 'tabs';
				// tool.sgiLogger.log("tabs");
	
				var cldSet = moduleDesc.cldSet;
				if (cldSet && cldSet.length && cldSet.length > 0) {
					var tabPane = void 0;
					cldSet.forEach(function (item, index) {
	
						// 跳过工具条构建
						if (item.desId === _SgiCompConstant.AllCompGUID.TOOLBAR) return;
	
						var te = item.te,
						    isDis = item.isDis;
	
						var cId = (0, _SgiCommon.getConstByKey)(_this2, item.cId);
						tabPane = { forceRender: true }; //默认渲染
						if (!cId) {
							cId = (0, _sgiCommon.uuid)(8);
							item.cId = cId;
						}
						if (te) tabPane.tab = _Resource.Resource.getTRByPrm(item).te;
						if (cId) tabPane.key = cId;
						if (isDis) tabPane.disabled = isDis;
						// if (cId) tabPane.ref = tabPanePrefix + cId;
						var tabPaneModule = void 0;
						var son = (0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type, { setActiveWV: _this2.setActiveItem });
						var atvTab = (0, _SgiCommon.getConstByKey)(_this2, moduleDesc.atvTab);
						if (_this2.state.isAsyn && (atvTab && atvTab !== cId || !atvTab && index !== 0)) {
							// tabsItems.push(<TabPane className="sgiTabPane" {...tabPane} />);
							tabPaneModule = _react2.default.createElement(TabPane, _extends({ className: 'sgiTabPane' }, tabPane));
						} else {
							// tabsItems.push(<TabPane className="sgiTabPane" {...tabPane}>{convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem })}</TabPane>);
							tabPaneModule = _react2.default.createElement(
								TabPane,
								_extends({ className: 'sgiTabPane' }, tabPane),
								son
							);
							_this2.state.loadedKeys.push(cId);
						}
						tabsItems.push(tabPaneModule);
						_this2.state.allTabPaneAndSon[cId] = { tabPane: tabPaneModule, son: son };
					});
				}
			};
	
			_this.setActiveItem = function (activeKey) {
				if (_this.state.activeKey === activeKey) {
					return;
				}
				_this.state.activeKey = activeKey; //防止死循环，在tab中刷新wv，wv中再刷新 tab
				_this.state.tabsProps.onChange(activeKey);
				_this.setState({ loading: false });
			};
	
			_this.getActiveItem = function () {
				return _this.state.activeKey;
			};
	
			_this.refresh = function () {
				_this.loaded = false;
				_this.setState({ loading: false });
			};
	
			_this.render = function () {
	
				if (!this.loaded || this.props.type == 'dnd') {
					var _props = this.props,
					    parentModule = _props.parentModule,
					    moduleDesc = _props.moduleDesc,
					    objFct = _props.objFct,
					    type = _props.type;
					//组装属性
	
					this.tabs_mk(parentModule, moduleDesc, objFct, type);
					this.loaded = true;
				}
	
				// 自定义选项卡项
				var cstmzTabsItems = this.state.cstmzTabsItems;
	
				if (cstmzTabsItems && typeof cstmzTabsItems === "function") {
					cstmzTabsItems();
					this.state.cstmzTabsItems = undefined;
				}
	
				// 通用渲染前处理，添加自定义样式等
				this.renderBeforeReturn(this.state.tabsProps);
	
				return this.state.sticky ? _react2.default.createElement(
					_reactSticky.StickyContainer,
					{ className: 'sgiStickyContainer-tabs' },
					_react2.default.createElement(
						_antd.Tabs,
						_extends({ className: 'sgiTabs' }, this.state.tabsProps, {
							renderTabBar: renderStickyTabBar,
							tabBarExtraContent: this.state.tabBarExtraContent,
							activeKey: this.state.activeKey }),
						this.state.tabsItems
					)
				) : _react2.default.createElement(
					_antd.Tabs,
					_extends({ className: 'sgiTabs' }, this.state.tabsProps, {
						tabBarExtraContent: this.state.tabBarExtraContent,
						activeKey: this.state.activeKey }),
					this.state.tabsItems
				);
			};
	
			_this.AddAttribute = function (moduleDesc, tabsProps, tabs) {
	
				tabsProps.style.overflow = 'unset';
	
				//选项卡位置 left、top、right、bottom
				var tabPst = moduleDesc.tabPst; //tab面板位置
				if (tabPst) tabsProps.tabPosition = moduleDesc.tabPst;
				//选项卡按钮
				// 选项卡类型
				tabsProps.type = moduleDesc.type || "card"; //先默认这个 以后再去实现其他的属性
				// tabsProps.hideAdd =true;
				//初始化激活的面板
				var atvTab = (0, _SgiCommon.getConstByKey)(this, moduleDesc.atvTab);
				if (atvTab) {
					if (!tabs.state.activeKey) {
						tabs.state.activeKey = atvTab;
					}
					tabsProps.defaultActiveKey = atvTab;
				}
	
				// 切换动画
				tabsProps.animated = !!moduleDesc.animated;
	
				// 标题间隔
				var tbGutter = moduleDesc.tbGutter;
				tabsProps.tabBarGutter = tbGutter || tbGutter === 0 ? parseInt(moduleDesc.tbGutter) : undefined;
	
				// 标题吸顶
				this.state.sticky = !!moduleDesc.sticky;
	
				// 是否异步加载其余页面
				this.state.isAsyn = moduleDesc.isAsyn;
			};
	
			_this.state = {
				itemPanelType: "tabs", //区分是tab还是折叠面板的 普通面板整合tabpane和折叠panel
				tabsProps: { style: { height: "100%", width: "100%" } }, //form属性
				tabsItems: [], //form下控件数组
				tabBarExtraContent: [],
				functions: {},
				activeKey: undefined,
				loading: false,
				cstmzTabsItems: undefined, //自定义获取选项卡项的方法
	
				// 异步加载
				isAsyn: false, //异步加载其余面板
				loadedKeys: [], //记录已加载项,异步加载查找未加载项使用
				allTabPaneAndSon: {} //根据key，记录所有tabpane和未加载的子module
			};
			return _this;
		}
	
		/**
	  * 根据描述创建form
	  * @param {父组件} parentModule
	  * @param {描述} moduleDesc
	  * @param {对象工厂} objFct
	  * @param {make类型} type
	  */
		// 注意这里有分号
	
	
		_createClass(SgiTabs, [{
			key: 'tabs_mk',
			value: function tabs_mk(parentModule, moduleDesc, objFct, type) {
				//获取需要展示的数据信息
				if (!moduleDesc) {
					return;
				}
	
				this.state.tabsItems = []; //再次渲染的时候清空
				this.state.tabBarExtraContent = []; //再次渲染的时候清空
				//转换form公共属性
				(0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.tabsProps);
				//转换基础属性
				this.AddAttribute(moduleDesc, this.state.tabsProps, this);
	
				//绑定事件
				this.bindEvent(moduleDesc, this.state.tabsProps, this.state.functions, type);
				//组装form表单下的控件信息
				if (type !== "dnd") this.fitTabsItems(moduleDesc, this.state.tabsItems, objFct, type);
				//组装tabBarExtraContent下的控件
				this.fitTabExtraContent(moduleDesc, this.state.tabBarExtraContent, objFct, type);
				//添加拖拽布局信息 根据type类型
				// addTabCtlDndInfo(this, this.state.tabsItems, this.state.tabsProps, type);
				var addTabCtlDndInfo = this.props.addTabCtlDndInfo; //显示/开发分离，这部分拖拽开发功能使用props传入
				if (addTabCtlDndInfo && typeof addTabCtlDndInfo === "function") {
					addTabCtlDndInfo(this, this.state.tabsItems, this.state.tabsProps, type);
				}
			}
	
			/**
	   * 绑定事件
	   * @param {*} moduleDesc
	   * @param {*} tabsProps
	   */
	
		}, {
			key: 'bindEvent',
			value: function bindEvent(moduleDesc, tabsProps, functions, type) {
				var _this3 = this;
	
				//拖拽模式 不生成事件
				var lsn = moduleDesc.tabLsn; // 选项卡监听器
				// var lsn = "tool.sgiLogger.log('11111111111111111',ComponentManager)"
				if (lsn && type != 'dnd') {
					try {
						var $tcl = new Function("module", "objFct", "activeKey", lsn);
						functions.tab = $tcl;
					} catch (e) {
						_sgiLogger.sgiLogger.eventErr(e);
					}
				}
				// tabsProps.onChange = SgiEventHandler.tcl.bind(this);
				tabsProps.onChange = function (activeKey) {
					if (_this3.state.isAsyn && _this3.state.loadedKeys.indexOf(activeKey) < 0) {
						var allTabPaneAndSon = _this3.state.allTabPaneAndSon || {};
						var activeTabInfo = allTabPaneAndSon[activeKey] || {};
						var activeTabPane = activeTabInfo.tabPane;
						var son = activeTabInfo.son;
						if (!activeTabPane || !son) {
							_sgiLogger.sgiLogger.error('tabs \u627E\u4E0D\u5230key\u4E3A' + activeKey + '\u7684\u9762\u677F\u4FE1\u606F\uFF01');
						} else {
							activeTabPane.props.children = son;
						}
					}
					_SgiEventHandler.SgiEventHandler.tcl.call(_this3, activeKey);
				};
			}
	
			/**
	   * 根据描述组装子 操作按钮
	   * @param {描述信息} moduleDesc
	   * @param {属性} formProps
	   */
	
	
			/**
	  * 根据描述组装子对象
	  * @param {描述信息} moduleDesc
	  * @param {属性} formProps
	  */
	
		}, {
			key: 'setTabsItemsByDescs',
	
	
			/**
	   * 动态设置选项卡项(根据子组件描述)--外部接口
	   * @param {Array} moduleDescs 子组件描述数组
	   */
			value: function setTabsItemsByDescs(moduleDescs, activeKey) {
				if (!moduleDescs) return;
	
				var objFct = this.props.objFct;
	
				var tabsItems = this.state.tabsItems = [];
				var me = this;
	
				this.state.cstmzTabsItems = function () {
					var _this4 = this;
	
					moduleDescs.forEach(function (desc, index) {
						var tabPane = { forceRender: true }; //默认渲染;
						var te = desc.te,
						    isDis = desc.isDis;
	
						var cId = (0, _SgiCommon.getConstByKey)(_this4, desc.cId);
						if (!cId) {
							desc.cId = cId = (0, _sgiCommon.uuid)(8);
						}
						if (te) tabPane.tab = _Resource.Resource.getTRByPrm(desc).te;
						if (cId) tabPane.key = cId;
						if (isDis) tabPane.disabled = isDis;
						if (index === 0) if (!activeKey) me.state.activeKey = cId;
						// if (cId) tabPane.ref = tabPanePrefix + cId;
						tabsItems.push(_react2.default.createElement(
							TabPane,
							_extends({ className: 'sgiTabPane' }, tabPane),
							(0, _SgiCompComm.convertModuleByGuid)(me, desc, null, objFct, null, { setActiveWV: me.setActiveItem })
						));
					});
				};
	
				// 刷新
				this.setState({ activeKey: activeKey });
			}
			/**
	   * 动态设置选项卡项(根据TabPane属性)--外部接口
	   * @param {array} propss 
	   */
	
		}, {
			key: 'setTabsItemsByTabPaneProps',
			value: function setTabsItemsByTabPaneProps(propss, activeKey) {
				if (!propss) return;
	
				var tabsItems = this.state.tabsItems = [];
				var me = this;
	
				this.state.cstmzTabsItems = function () {
					propss.forEach(function (props, index) {
						if (index === 0) if (!activeKey) me.state.activeKey = props.key;
						tabsItems.push(_react2.default.createElement(TabPane, _extends({ className: 'sgiTabPane' }, props)));
					});
				};
	
				// 刷新
				this.setState({ activeKey: activeKey });
			}
			/**
	   * 动态设置选项卡项(传入创建好的子组件数组)--外部接口
	   * @param {array} elements 
	   */
			// setTabsItemsByElements(elements) {
			//     if (!elements) return;
	
			//     let tabsItems = this.state.tabsItems = [];
			//     tabsItems.push(...elements);
	
			//     // 刷新
			//     this.setState({});
			// }
	
			/**
	   * 获取当前激活面板的组件标识
	   * @return {[type]} [description]
	   */
	
		}, {
			key: 'setTabTitle',
	
	
			/**
	   * 动态设置tab面板标题
	   * @param {string} cId 对应面板组件标识
	   * @param {string|Element} title 
	   */
			value: function setTabTitle(cId, title) {
				var _this5 = this;
	
				if (!cId || !title) return;
				this.state.tabsItems.some(function (item) {
					if (item.key === cId) {
						item.props.tab = title;
						if ((0, _SgiCommon.testReactVsn)(_this5, 16)) {
							// react16需要更新引用
							_this5.state.tabsItems = [].concat(_toConsumableArray(_this5.state.tabsItems));
						}
						_this5.setState({});
						return true;
					}
				});
			}
	
			//渲染并返回一个虚拟DOM
	
	
			/**
	   * 属性转换
	   * @param {描述信息} moduleDesc
	   * @param {属性} formProps
	   */
	
		}]);
	
		return SgiTabs;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiTabs.defaultProps = {};
	SgiTabs.propTypes = {};
	Object.assign(SgiTabs.prototype, _SgiCtnComm.sgiCtnBaseFun);
	
	exports.SgiTabs = SgiTabs;
	exports.default = SgiTabs;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiTile = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiPanel = __webpack_require__(444);
	
	var _SgiPanel2 = _interopRequireDefault(_SgiPanel);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiCompConstant = __webpack_require__(107);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const TabPane = Tabs.TabPane;
	// const Tile = Collapse.Tile;
	
	var noRender = function noRender() {
	    return _react2.default.createElement(
	        'span',
	        { style: { paddingRight: "20px", fontSize: "18px", display: "inline-block", width: "160px" } },
	        _react2.default.createElement(_antd.Icon, { type: "close", style: { color: "red" } }),
	        "  no-render"
	    );
	};
	
	var SgiTile = function (_React$Component) {
	    _inherits(SgiTile, _React$Component);
	
	    // 注意这里有分号
	
	    //这个暂时不好用 以后在处理
	    function SgiTile(props) {
	        _classCallCheck(this, SgiTile);
	
	        var _this = _possibleConstructorReturn(this, (SgiTile.__proto__ || Object.getPrototypeOf(SgiTile)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.state.tileUUID = (0, _sgiCommon.uuid)(8);
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded) {
	                //组装属性
	                this.tile_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            // 通用渲染前处理，添加自定义样式等
	            this.renderBeforeReturn(this.state.tileProps);
	
	            return _react2.default.createElement(
	                'div',
	                this.state.tileProps,
	                this.state.toolbarTopItems ? this.state.toolbarTopItems : null,
	                this.state.isCard ? _react2.default.createElement(
	                    _antd.Card,
	                    { title: this.getTitle()
	                        // bordered={!!this.state.tileProps.style.border}
	                        , bordered: false,
	                        size: 'small',
	                        extra: this.state.btnAlg === "left" ? null : this.state.extras },
	                    this.renderAll()
	                ) : _react2.default.createElement(
	                    'div',
	                    { style: { flex: 1, height: '100%', width: '100%' } },
	                    _react2.default.createElement(
	                        'div',
	                        _extends({ className: _SgiPanel2.default.title }, this.state.tileTitleProps),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            this.state.tileTitleProps.title
	                        )
	                    ),
	                    this.renderAll()
	                ),
	                this.state.toolbarBottomItems ? this.state.toolbarBottomItems : null
	            );
	        };
	
	        _this.AddAttribute = function (moduleDesc, tileProps, tileTitleProps, tileBodyProps, parentModule) {
	            var type;
	            if (parentModule && parentModule.state && parentModule.state.itemTileType) {
	                type = parentModule.state.itemTileType;
	            }
	
	            var text = tileProps.te; //公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
	            if (text) tileTitleProps.title = text;
	
	            var ttlAlgn = moduleDesc.ttlAlgn; //form标题对齐方式
	            if (ttlAlgn) tileTitleProps.style['text-align'] = ttlAlgn;
	
	            var isTtl = moduleDesc.isTtl; //form是否显示标题
	            if (!isTtl) {
	                tileTitleProps.style.display = "none";
	            } else {
	                tileTitleProps.style.display = undefined;
	            }
	            this.state.isTtl = !!isTtl;
	
	            // 是否card样式
	            var isCard = moduleDesc.isCard;
	            this.state.isCard = !!isCard;
	
	            var isScl = moduleDesc.isScl; //form是否可以滚动??没实现
	            //if(isScl) tileBodyProps.style.display
	
	            if (type === 'tabs' || type == 'cos') {
	                tileTitleProps.style.display = "none";
	            }
	
	            // 取data
	            var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
	            this.state.insName = bdInst;
	            var objFct = this.props.objFct;
	
	            if (bdInst && objFct) {
	                this.state.data = objFct.get(bdInst) || [];
	            }
	
	            // 自定义子组件渲染方法
	            var sonRender = moduleDesc.sonRender;
	            var $sonRender = void 0;
	            if (sonRender) {
	                try {
	                    $sonRender = new Function("module", "record", "index", "array", "objFct", sonRender);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                this.state.sonRender = $sonRender;
	            }
	        };
	
	        _this.state = {
	            //ctnProps: { style: {} },//form属性
	            tileProps: { style: { heigth: '100%', width: '100%' } }, //tile全局属性
	            tileTitleProps: { style: {} }, //tile的title属性
	            tileBodyProps: { style: {} }, //tile的body属性
	            tileItems: [], //面板下控件数组loading
	            loading: false,
	            toolbarTopItems: [],
	            toolbarBottomItems: [],
	            tileUUID: undefined,
	            isCard: false,
	            sonRender: noRender
	        };
	        return _this;
	    }
	
	    /**
	     * 根据描述创建form
	     * @param {父组件} parentModule 
	     * @param {描述} moduleDesc       
	     * @param {对象工厂} objFct 
	     * @param {make类型} type 
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiTile, [{
	        key: 'tile_mk',
	        value: function tile_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            this.state.tileItems = []; //再次渲染的时候清空
	
	            //转换form公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.tileProps);
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.tileProps, this.state.tileTitleProps, this.state.tileBodyProps, parentModule);
	            //设置布局
	            //this.setFormCtlLayout(moduleDesc, formProps);
	            //绑定事件
	            // this.bindEvent(moduleDesc, this.state.tileProps);
	            //组装form表单下的控件信息
	            // this.fitTileItems(moduleDesc, this.state.tileItems, objFct, type);
	        }
	
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc 
	         * @param {*} formProps 
	         */
	        // bindEvent(moduleDesc, formProps) {
	
	        // }
	
	        /**
	         * 根据描述组装子对象
	         * @param {描述信息} moduleDesc 
	         * @param {属性} formProps 
	         */
	        // fitTileItems = function (moduleDesc, tileItems, objFct, type) {
	        //     this.state.extras = [];
	        //     var me = this;
	        //     //form下的子节点添加到form组件中
	        //     let cldSet = moduleDesc.cldSet;
	        //     if (cldSet && cldSet.length && cldSet.length > 0) {
	        //         cldSet.forEach((item, index) => {
	        //             if (item.desId === AllCompGUID.TOOLBAR) {
	        //                 if (item.inTitle) {
	        //                     this.state.btnAlg = item.btnAlg || "right";//记录按钮位置
	        //                     const itemSons = item.cldSet;
	        //                     if (itemSons) {
	        //                         itemSons.forEach(son => {
	        //                             this.state.extras.push(convertModuleByGuid(this, son, null, objFct, type));
	        //                         });
	        //                     }
	        //                 } else {
	        //                     if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
	        //                         this.state.toolbarTopItems.push(convertModuleByGuid(this, item, null, objFct, type));
	        //                     } else {
	        //                         this.state.toolbarBottomItems.push(convertModuleByGuid(this, item, null, objFct, type));
	        //                     }
	        //                 }
	        //             } else {
	        //                 tileItems.push(convertModuleByGuid(me, item, null, objFct, type));
	        //             }
	        //         });
	        //     }
	        // }
	
	    }, {
	        key: 'getTitle',
	
	
	        // getChildContent() {
	        //     return (
	        //         <div key={this.state.tileUUID} className={style.body} {...this.state.tileBodyProps}>
	        //             {this.state.tileItems}
	        //             {this.props.children}
	        //         </div>
	        //     );
	        // }
	
	        value: function getTitle() {
	            var isTtl = this.state.isTtl;
	            var titleText = this.state.tileTitleProps.title;
	            var btnAlg = this.state.btnAlg;
	            if (btnAlg === "left") {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    isTtl ? _react2.default.createElement(
	                        'span',
	                        { style: { marginRight: "10px" } },
	                        titleText
	                    ) : null,
	                    this.state.extras
	                );
	            } else {
	                return isTtl ? titleText : null;
	            }
	        }
	    }, {
	        key: 'renderOne',
	        value: function renderOne(record, index, arr) {
	            // 自定义子组件渲染
	            var sonRender = this.state.sonRender;
	            var _props2 = this.props,
	                parentModule = _props2.parentModule,
	                moduleDesc = _props2.moduleDesc,
	                objFct = _props2.objFct,
	                type = _props2.type;
	
	            if (sonRender) {
	                return sonRender(this, record, index, arr, objFct);
	            } else {
	                return noRender();
	            }
	        }
	    }, {
	        key: 'renderAll',
	        value: function renderAll(data) {
	            var _this2 = this;
	
	            data = data || this.state.data || [];
	            return data.map(function (item, index, arr) {
	                return _this2.renderOne(item, index, arr);
	            });
	        }
	    }, {
	        key: 'refreshByData',
	        value: function refreshByData(data) {
	            data = data || [];
	            this.setState({ data: data });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc 
	         * @param {属性} tileProps 
	         */
	
	    }]);
	
	    return SgiTile;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiTile.defaultProps = {};
	SgiTile.propTypes = {};
	Object.assign(SgiTile.prototype, _SgiCtnComm.sgiCtnBaseFun);
	exports.SgiTile = SgiTile;
	exports.default = SgiTile;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SgiToolbar = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	// import { addToolbarCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun'
	
	var SgiToolbar = function (_React$Component) {
		_inherits(SgiToolbar, _React$Component);
	
		// 注意这里有分号
	
		function SgiToolbar(props) {
			_classCallCheck(this, SgiToolbar);
	
			//初始化state属性
			// this.initState();
			var _this = _possibleConstructorReturn(this, (SgiToolbar.__proto__ || Object.getPrototypeOf(SgiToolbar)).call(this, props));
	
			_this.fitToolbarItems = function (moduleDesc, toolbarItems, objFct, type) {
				var tlbAlg = moduleDesc.tlbAlg; //工具条位置  
	
				var me = this;
				//form下的子节点添加到toolbar组件中
				var cldSet = moduleDesc.cldSet;
				if (cldSet && cldSet.length && cldSet.length > 0) {
					if (!tlbAlg || tlbAlg == "top" || tlbAlg == "bottom") {
						cldSet.forEach(function (item, index) {
							toolbarItems.push((0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type));
						});
					} else if (tlbAlg == "left" || tlbAlg == "right") {
						var rowlist = [];
						cldSet.forEach(function (item, index) {
							rowlist.push(_react2.default.createElement(
								_antd.Row,
								null,
								(0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type)
							));
						});
						toolbarItems.push(_react2.default.createElement(
							_antd.Col,
							null,
							rowlist
						));
					} else {
						cldSet.forEach(function (item, index) {
							toolbarItems.push((0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type));
						});
					}
				}
			};
	
			_this.refresh = function () {
				_this.loaded = false;
				_this.setState({ loading: false });
			};
	
			_this.render = function () {
				if (!this.loaded) {
					var _props = this.props,
					    parentModule = _props.parentModule,
					    moduleDesc = _props.moduleDesc,
					    bdInst = _props.bdInst,
					    objFct = _props.objFct,
					    type = _props.type;
					//组装属性 初始化属性到this.state
	
					this.toolBar_mk(parentModule, moduleDesc, bdInst, objFct, type);
					this.loaded = true;
				}
	
				return _react2.default.createElement(
					'div',
					this.state.toolbarProps,
					this.state.toolbarItems
				);
			};
	
			_this.state = {
				// inputprops: { style: { heigth: '100%', width: '100%' } },//存放input属性
				toolbarProps: { style: { padding: '6px 6px 6px 6px' } },
				toolbarItems: [] //工具条下控件数组
			};
			return _this;
		}
	
		/**
	  * 根据描述创建文本框
	  * @param {父组件} parentModule
	  * @param {组件描述} moduleDesc
	  * @param {绑定实例ID} bdInst
	  * @param {对象工厂} objFct
	  * @param {make类型} type
	  */
		// 注意这里有分号
	
	
		_createClass(SgiToolbar, [{
			key: 'toolBar_mk',
			value: function toolBar_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
				//获取需要展示的数据信息
				if (!moduleDesc) {
					return;
				}
	
				this.state.toolbarItems = []; //再次渲染的时候清空
	
				//转换公共属性
				(0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.toolbarProps);
				//转换基础属性
				this.AddInputAttribute(moduleDesc, this.state.toolbarProps);
				//组装form表单下的控件信息
				if (type !== "dnd") this.fitToolbarItems(moduleDesc, this.state.toolbarItems, objFct, type);
				//添加拖拽布局信息 根据type类型
				// addToolbarCtlDndInfo(this, this.state.toolbarItems, this.state.toolbarProps, type);
				var addToolbarCtlDndInfo = this.props.addToolbarCtlDndInfo; //显示/开发分离，这部分拖拽开发功能使用props传入
				if (addToolbarCtlDndInfo && typeof addToolbarCtlDndInfo === "function") {
					addToolbarCtlDndInfo(this, this.state.toolbarItems, this.state.toolbarProps, this.props.type);
				}
			}
	
			/**
	   * 根据描述组装子对象
	   * @param {描述信息} moduleDesc
	   * @param {属性} formProps
	   */
	
		}, {
			key: 'setHidden',
	
	
			/**
	   * 设置是否隐藏
	   */
			value: function setHidden(value) {
				if (value) {
					this.state.toolbarProps.style.display = "none";
				} else {
					this.state.toolbarProps.style.display = undefined;
				}
				// if (testReactVsn(this, 16)) {
				// 	// react16需要更新引用
				// 	this.state.formItemProps.style = { ...this.state.formItemProps.style };
				// }
				this.setState(this.state.toolbarProps);
			}
	
			/**
	   * 属性转换
	   * @param {描述信息} moduleDesc
	   * @param {属性} formItem
	   * @param {属性} inputprops
	   */
	
		}, {
			key: 'AddInputAttribute',
			value: function AddInputAttribute(moduleDesc, toolbarProps) {
				var btnAlg = moduleDesc.btnAlg; //按钮位置，左中右
				if (btnAlg) toolbarProps.style['text-align'] = btnAlg;
	
				var isDis = moduleDesc.isDis; //禁用   
	
				// var tlbAlg = moduleDesc.tlbAlg;//工具条位置 暂时不事先上下
				// if (tlbAlg == 'left') {
				//     toolbarProps.style.float = "left";
				//     toolbarProps.style.heigth = '100%';
				// } else if (tlbAlg == 'right') {
				//     toolbarProps.style.float = "right";
				//     toolbarProps.style.heigth = '100%';
				// } else {
				//     toolbarProps.style.width = '100%';
				// }
				toolbarProps.style.width = toolbarProps.style.width || '100%';
			}
	
			//渲染并返回一个虚拟DOM
	
		}]);
	
		return SgiToolbar;
	}(_react2.default.Component);
	
	SgiToolbar.defaultProps = {};
	SgiToolbar.propTypes = {};
	exports.SgiToolbar = SgiToolbar;
	exports.default = SgiToolbar;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiTree = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiTreeBaseFun = __webpack_require__(725);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _StandardCode = __webpack_require__(81);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _sgiConstants = __webpack_require__(198);
	
	var _sgiConstants2 = _interopRequireDefault(_sgiConstants);
	
	var _SgiCommon = __webpack_require__(29);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	var Search = _antd.Input.Search;
	var MenuItem = _antd.Menu.Item;
	var SubMenu = _antd.Menu.SubMenu;
	
	var treeConfConstant = {
	    childrenName: 'cldSet',
	    indexKey: "_index",
	    key: '_key'
	    // pKey: '_pKey'
	};
	
	var menuStyle = {
	    position: 'relative',
	    margin: 0,
	    padding: '4px 0',
	    textAlign: 'left',
	    listStyleType: 'none',
	    backgroundColor: '#fff',
	    backgroundClip: 'padding-box',
	    borderRadius: '4px',
	    outline: 'none',
	    boxShadow: '0 2px 8px rgba(0,0,0,.15)',
	    'title:hover': {
	        backgroudColor: '#e6f7ff'
	        // 'title:hover':'backgroud-color : #e6f7ff'
	    } };
	
	var SubMenuStyle = {
	    clear: 'both',
	    margin: 0,
	    padding: '5px 12px',
	    color: 'rgba(0,0,0,.65)',
	    fontWeight: '400',
	    fontSize: '14px',
	    lineHeight: '22px',
	    whiteSpace: 'nowrap',
	    cursor: 'pointer',
	    height: 'auto',
	    transition: 'all .3s'
	};
	
	var SgiTree = function (_React$Component) {
	    _inherits(SgiTree, _React$Component);
	
	    // 注意这里有分号
	
	
	    function SgiTree(props) {
	        _classCallCheck(this, SgiTree);
	
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiTree.__proto__ || Object.getPrototypeOf(SgiTree)).call(this, props));
	
	        _this.findNodeByKey = function (rootChildren, key) {
	            if (!rootChildren) {
	                rootChildren = this.state.treeData;
	            }
	            if (!key) {
	                return;
	            }
	            for (var i = 0; i < rootChildren.length; i++) {
	                var tmpNode = rootChildren[i];
	                var tmp_dnd_id = tmpNode[this.state.key];
	                if (key === tmp_dnd_id) {
	                    return tmpNode;
	                }
	                if (tmpNode[this.state.childrenName] && tmpNode[this.state.childrenName].length > 0) {
	                    var result = this.findNodeByKey(tmpNode[this.state.childrenName], key);
	                    if (result) return result;
	                }
	            }
	        };
	
	        _this.onCheck = function (checkedKeys, e) {
	            // tool.sgiLogger.log('onCheck checkedKeys:', checkedKeys);
	            // tool.sgiLogger.log('onCheck e:', e);
	            _this.state.checkedNodes = [];
	            e.checkedNodes.forEach(function (element) {
	                _this.state.checkedNodes.push(element.props.itemData);
	                element.props.itemData[_sgiConstants2.default.checked] = true; //同步到数据
	            });
	            if (!e.checked) {
	                //取消勾选
	                unCheckAll(e.node.props.itemData);
	            }
	            // this.state.selectedKeys = checkedKeys;
	            _this.state.checkedKeys = checkedKeys;
	            // this.state.treeProps.onSelect(checkedKeys, e);
	            _this.setState({ loading: false });
	
	            _SgiEventHandler.SgiEventHandler.itemCheck.call(_this, checkedKeys, e);
	
	            // 取消所有子节点勾选（数据）
	            function unCheckAll(item) {
	                if (!item) return;
	                item[_sgiConstants2.default.checked] = false;
	                if (item.cldSet && item.cldSet.length > 0) {
	                    item.cldSet.forEach(function (cld, index, arr) {
	                        unCheckAll(cld);
	                    });
	                }
	            }
	        };
	
	        _this.fitTreeNodes = function () {
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            if (!data || !(data instanceof Array)) {
	                return;
	            }
	            return data.map(function (item, index) {
	                if (!item || (typeof item === 'undefined' ? 'undefined' : _typeof(item)) != "object") return;
	                var _this$state = _this.state,
	                    searchValue = _this$state.searchValue,
	                    childrenName = _this$state.childrenName,
	                    displayField = _this$state.displayField,
	                    key = _this$state.key,
	                    indexKey = _this$state.indexKey,
	                    menuItems = _this$state.menuItems;
	                //因为树的key很重要，不能重复，数据中可能会有重复的key，所以检查是否有重复的key如果有，重新生成一个
	
	                if (!item[key]) {
	                    item[key] = (0, _sgiCommon.uuid)(6);
	                }
	                item[indexKey] = index + 1;
	
	                // if (this.state.keysTreeNode[item[key]]) { //存在重新生成一个 不存在添加进去 理论不会存在
	                //     item[key] = uuid(6);
	                // }
	
	                //根据数据中 checked属性为true，默认选中
	                if ((item.checked || item[_sgiConstants2.default.checked]) && _this.state.checkedKeys.indexOf(item[key]) < 0) {
	                    _this.state.checkedKeys.push(item[key]);
	                    _this.state.checkedNodes.push(item);
	                    delete item.checked;
	                }
	
	                // 表达式解析，约定表达式格式【exp:表达式】，表达式接收参数item，例如："exp:item.te||item.n"或者"exp:item.ctlN+'_'+item.te"
	                var showTitle = void 0;
	                if (displayField.indexOf("exp:") > -1) {
	                    showTitle = eval('(' + displayField.replace("exp:", "") + ')');
	                } else {
	                    showTitle = item[displayField];
	                }
	
	                // const showTitle = item[displayField];
	                var searchIndex = void 0,
	                    beforeStr = void 0,
	                    afterStr = void 0;
	                if (showTitle) {
	                    searchIndex = showTitle.indexOf(searchValue);
	                    beforeStr = showTitle.substr(0, searchIndex);
	                    afterStr = showTitle.substr(searchIndex + searchValue.length);
	                } else {
	                    searchIndex = -1;
	                }
	                var title = searchIndex > -1 ? _react2.default.createElement(
	                    'span',
	                    null,
	                    beforeStr,
	                    _react2.default.createElement(
	                        'span',
	                        { style: { color: '#f50' } },
	                        searchValue
	                    ),
	                    afterStr
	                ) : _react2.default.createElement(
	                    'span',
	                    null,
	                    showTitle
	                );
	
	                // // // 右键菜单
	                // if (menuItems && menuItems.length) {
	                //     title = <Dropdown
	                //         overlay={<Menu onClick={SgiEventHandler.menuOnClick.bind(this, item)}>{this.state.menuItems}</Menu>}
	                //         trigger={['contextMenu']} itemData={item} visible={this.state.ContextMenuVisible} onVisibleChange={this.onVisibleChange}>
	                //         {title}
	                //     </Dropdown>;
	                // }
	
	                var currentNode = void 0;
	                if (item[childrenName] && item[childrenName].length) {
	                    currentNode = _react2.default.createElement(
	                        TreeNode,
	                        _extends({ itemData: item, tree: _this, key: item[key] }, _SgiTreeBaseFun.sgiTreeNodeFun, { title: title }, (0, _SgiCompComm.getPropsFromItem)(item, _this.state.cstmConst)),
	                        _this.fitTreeNodes(item[childrenName])
	                    );
	                    currentNode.props.children.forEach(function (element) {
	                        element.props.parentNode = currentNode;
	                    });
	                    _this.state.keysTreeNode[item[key]] = currentNode; //统一存起来
	                    return currentNode;
	                }
	                var LeafTreeNode = _react2.default.createElement(TreeNode, _extends({ itemData: item, tree: _this, key: item[key] }, _SgiTreeBaseFun.sgiTreeNodeFun, { title: title, isLeaf: true }, (0, _SgiCompComm.getPropsFromItem)(item, _this.state.cstmConst)));
	                _this.state.keysTreeNode[item[key]] = LeafTreeNode; //统一存起来
	                return LeafTreeNode;
	            }).filter(function (element) {
	                return element;
	            });
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.onDragEnter = function (info) {
	            tool.sgiLogger.log("onDragEnter info:", info);
	            // expandedKeys 需要受控时设置
	            _this.setState({
	                expandedKeys: info.expandedKeys
	            });
	        };
	
	        _this.onDrop = function (info) {
	            tool.sgiLogger.log("onDrop info:", info);
	            var dropKey = info.node.props.eventKey;
	            var dragKey = info.dragNode.props.eventKey;
	            var dropPos = info.node.props.pos.split('-');
	            var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
	            // tool.sgiLogger.log('dropKey :', dropKey);
	            // tool.sgiLogger.log('dragKey :', dragKey);
	            // tool.sgiLogger.log('dropPos :', dropPos);
	            // tool.sgiLogger.log('dropPosition :', dropPosition);
	
	            var loop = function loop(data, key, callback) {
	                data.forEach(function (item, index, arr) {
	                    if (item[treeConfConstant.key] === key) {
	                        return callback(item, index, arr);
	                    }
	                    if (item[treeConfConstant.childrenName]) {
	                        return loop(item[treeConfConstant.childrenName], key, callback);
	                    }
	                });
	            };
	            // const data = [...this.state.treeData];
	            var data = _this.state.treeData;
	
	            // Find dragObject
	            var dragObj = void 0;
	            loop(data, dragKey, function (item, index, arr) {
	                arr.splice(index, 1);
	                dragObj = item;
	            });
	
	            if (!info.dropToGap) {
	                // Drop on the content
	                loop(data, dropKey, function (item) {
	                    item[treeConfConstant.childrenName] = item[treeConfConstant.childrenName] || [];
	                    // where to insert 示例添加到尾部，可以是随意位置
	                    item[treeConfConstant.childrenName].push(dragObj);
	                });
	            } else if ((info.node.props.children || []).length > 0 // Has children
	            && info.node.props.expanded // Is expanded
	            && dropPosition === 1 // On the bottom gap
	            ) {
	                    loop(data, dropKey, function (item) {
	                        item[treeConfConstant.childrenName] = item[treeConfConstant.childrenName] || [];
	                        // where to insert 示例添加到尾部，可以是随意位置
	                        item[treeConfConstant.childrenName].unshift(dragObj);
	                    });
	                } else {
	                var ar = void 0;
	                var i = void 0;
	                loop(data, dropKey, function (item, index, arr) {
	                    ar = arr;
	                    i = index;
	                });
	                if (dropPosition === -1) {
	                    ar.splice(i, 0, dragObj);
	                } else {
	                    ar.splice(i + 1, 0, dragObj);
	                }
	            }
	
	            // this.state.treeData = data;
	            _this.createTreeStore();
	            _this.setState({});
	
	            // 修改数据
	            var _this$props = _this.props,
	                parentModule = _this$props.parentModule,
	                moduleDesc = _this$props.moduleDesc,
	                bdInst = _this$props.bdInst,
	                objFct = _this$props.objFct,
	                type = _this$props.type;
	
	            var insName = (0, _SgiCommon.getConstByKey)(_this, moduleDesc.insName); //绑定实例名
	            if (insName && objFct) {
	                objFct.set(insName, data);
	            }
	
	            // 自定义释放事件
	            var cstmOnDrop = _this.state.functions.onDrop;
	            if (cstmOnDrop && typeof cstmOnDrop === "function") cstmOnDrop(_this, objFct, dragObj, info.dragNode);
	        };
	
	        _this.getParentKey = function (key, tree) {
	            tree = tree || _this.state.treeData || [];
	            var childrenName = _this.state.childrenName;
	
	            var parentKey = void 0;
	            for (var i = 0; i < tree.length; i++) {
	                var node = tree[i];
	                if (node[childrenName]) {
	                    if (node[childrenName].some(function (item) {
	                        return item[_this.state.key] === key;
	                    })) {
	                        parentKey = node[_this.state.key];
	                    } else if (_this.getParentKey(key, node[childrenName])) {
	                        parentKey = _this.getParentKey(key, node[childrenName]);
	                    }
	                }
	            }
	            return parentKey;
	        };
	
	        _this.cvtTreeDataToList = function (treeData) {
	            var list = [];
	            list.push.apply(list, _toConsumableArray(treeData));
	            treeData.forEach(function (item) {
	                if (item[_this.state.childrenName]) {
	                    list.push.apply(list, _toConsumableArray(_this.cvtTreeDataToList(item[_this.state.childrenName])));
	                }
	            });
	            return list;
	        };
	
	        _this.searchOnChange = function (e) {
	            var value = e.target.value;
	            var expandedKeys = _this.cvtTreeDataToList(_this.state.treeData).map(function (item) {
	                if (item[_this.state.displayField].indexOf(value) > -1) {
	                    return _this.getParentKey(item[_this.state.key]);
	                }
	                return null;
	            }).filter(function (item, i, self) {
	                return item && self.indexOf(item) === i;
	            });
	
	            _this.state.expandedKeys = expandedKeys;
	            _this.state.searchValue = value;
	            _this.state.autoExpandParent = true;
	            _this.createTreeStore();
	            _this.setState({});
	        };
	
	        _this.onLoaded = function (loadedKeys, _ref) {
	            var event = _ref.event,
	                node = _ref.node;
	        }
	        // tool.sgiLogger.log("onLoaded");
	        // tool.sgiLogger.log('loadedKeys :', loadedKeys);
	        // tool.sgiLogger.log('event :', event);
	        // tool.sgiLogger.log('node :', node);
	
	
	        // 自定义右键菜单内容
	        ;
	
	        _this.getNodeTreeRightClickMenu = function () {
	            var objFct = _this.props.objFct;
	
	            //右键是否显示 标示 
	
	            if (_this.state.ContextMenuVisible) {
	                return;
	            }
	
	            var allMenuItems = (_this.state.menuItems || []).concat(_this.state.customMenuItems);
	            // this.state.menuItems.push(...this.state.customMenuItems);
	
	            //菜单项是否存在
	            // this.state.menuItems = this.convertMenus(rghtMenus);
	            if (!allMenuItems || allMenuItems.length < 1) {
	                return;
	            }
	
	            var _this$state$rightClic = _extends({}, _this.state.rightClickNodeTreeItem),
	                pageX = _this$state$rightClic.pageX,
	                pageY = _this$state$rightClic.pageY,
	                record = _this$state$rightClic.record,
	                treeNode = _this$state$rightClic.treeNode;
	
	            var tmpStyle = _extends({}, menuStyle, {
	                position: "fixed",
	                left: pageX + 'px',
	                top: pageY + 'px'
	                // margin: 0
	            });
	            var menu = _react2.default.createElement(
	                _antd.Menu,
	                { style: _extends({}, tmpStyle, { display: _this.state.ContextMenuVisible }), onMouseLeave: function onMouseLeave() {
	                        _this.setState({ ContextMenuVisible: "none" });
	                    }, onClick: _SgiEventHandler.SgiEventHandler.menuOnClick.bind(_this, record) },
	                _this.convertMenus(allMenuItems, objFct, record, treeNode)
	            );
	            return _this.state.rightClickNodeTreeItem == null ? "" : menu;
	        };
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性
	
	                this.tree_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	                this.createTreeStore();
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.state.isSearch && this.state.store.length > 0 ? _react2.default.createElement(Search, { style: { width: this.state.treeProps.style.width }, placeholder: 'Search', onChange: this.searchOnChange }) : null,
	                _react2.default.createElement(
	                    _antd.Tree,
	                    _extends({}, this.state.treeProps, {
	                        checkable: this.state.checkable,
	                        multiple: this.state.multiple,
	                        selectedKeys: this.state.selectedKeys,
	                        onCheck: this.onCheck,
	                        checkedKeys: this.state.checkedKeys,
	                        defaultCheckedKeys: this.state.checkedKeys,
	                        expandedKeys: this.state.expandedKeys,
	                        autoExpandParent: this.state.autoExpandParent,
	                        onDragEnter: this.onDragEnter,
	                        onDrop: this.onDrop,
	                        onLoaded: this.onLoaded,
	                        showIcon: true }),
	                    this.state.store
	                ),
	                this.getNodeTreeRightClickMenu()
	            );
	        };
	
	        _this.state = {
	            checkable: false,
	            multiple: false,
	            loading: false, //加载属性
	            expandedKeys: [], //展开keys
	            selectedKeys: [], //选中keys
	            checkedKeys: [],
	            displayField: '',
	            autoExpandParent: false, //自动展开父节点
	            childrenName: treeConfConstant.childrenName,
	            indexKey: treeConfConstant.indexKey,
	            key: treeConfConstant.key,
	            // pKey: treeConfConstant.pKey,
	
	            // treeProps: { style: { height: '100%' } }, //树基础属性
	            treeProps: { style: {} }, //树基础属性
	            treeData: [], //树的显示数据
	            // treeCheckData: [], //勾选版树结构json数据
	            store: [],
	            insName: '',
	            functions: {},
	            selectedNodes: [], //已选中/勾选节点list
	            checkedNodes: [], //已选中/check节点list
	            keysTreeNode: {}, //存储所有的treenode信息
	
	            isSearch: false,
	            searchValue: '',
	            // autoExpandParent: true,
	
	            menuItems: [], // 右键定义菜单使用 菜单组件数组
	            customMenuItems: [], // 右键自定义带单使用
	            menuFuns: {}, //存放菜单点击事件
	
	            rightClickNodeTreeItem: {
	                pageX: "",
	                pageY: "",
	                id: "",
	                categoryName: ""
	            },
	            ContextMenuVisible: "none",
	            cstmConst: {} //自定义解析属性
	
	        };
	        return _this;
	    }
	
	    /**
	     * 动态添加自定义菜单
	     * @param {*} customMenuItems 例子：[{icon:'',mnCLsn:'',te:''}]
	     * @param {*} flag 
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiTree, [{
	        key: 'addCustomMenuItems',
	        value: function addCustomMenuItems(customMenuItems, flag) {
	            // 动态
	            if (!customMenuItems) {
	                return;
	            }
	
	            customMenuItems.forEach(function (element) {
	                element.c = (0, _sgiCommon.uuid)(8);
	            });
	
	            //true
	            if (flag) {
	                var _state$customMenuItem;
	
	                (_state$customMenuItem = this.state.customMenuItems).push.apply(_state$customMenuItem, _toConsumableArray(customMenuItems));
	            } else {
	                this.state.customMenuItems = customMenuItems;
	            }
	
	            this.setState({ loading: false });
	        }
	
	        //根据id获取数据
	        /**
	         * 根据唯一标示，从数据中找到相应的组件数据
	         * @param {*} rootChildren
	         * @param {*} dnd_id
	         */
	
	    }, {
	        key: 'tree_mk',
	
	
	        /**
	         * 根据描述创建文本框
	         * @param {父组件} parentModule
	         * @param {组件描述} moduleDesc
	         * @param {绑定实例ID} bdInst
	         * @param {对象工厂} objFct
	         * @param {make类型} type
	         */
	        value: function tree_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	            //绑定数据，创建表格store 搜索条、翻页控件需要使用该信息，所以先创建
	            var tableStore = this.getTreeData(moduleDesc, objFct);
	            this.state.treeData = tableStore;
	            this.state.insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName); //绑定实例名
	            //显示信息
	            this.state.displayField = moduleDesc.c ? moduleDesc.c : 'te';
	            //转换基础属性
	            this.AddTreeAttribute(moduleDesc, this.state.treeProps);
	            //转换form公共属性
	            (0, _SgiCtnComm.addCtnCommonAttribute)(this, moduleDesc, this.state.treeProps);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.treeProps, this.state.functions, type);
	            // 右键菜单
	            this.createMenuItems(moduleDesc);
	            // 自定义解析属性
	            this.setCstmConst(moduleDesc);
	        }
	    }, {
	        key: 'setCstmConst',
	        value: function setCstmConst(moduleDesc) {
	            if (moduleDesc.iconKey) {
	                this.state.cstmConst[moduleDesc.iconKey] = "icon";
	            }
	            if (moduleDesc.checkKey) {
	                this.state.cstmConst[moduleDesc.checkKey] = "checked";
	            }
	        }
	
	        /**
	         * 构建右键菜单
	         * @param {object} moduleDesc 描述参数
	         */
	
	    }, {
	        key: 'createMenuItems',
	        value: function createMenuItems(moduleDesc) {
	            var rghtMenus = void 0;
	            var mnId = moduleDesc.mnId;
	            if (mnId) {
	                // 优先标准代码
	                rghtMenus = _StandardCode.StandardCode.getSC(mnId);
	            } else {
	                rghtMenus = moduleDesc.rghtMenus;
	            }
	            // 构建菜单数组
	            if (rghtMenus && rghtMenus.length > 0) {
	                // this.state.menuItems = <Menu onClick={this.menuOnClick}>{this.convertMenus(rghtMenus)}</Menu>
	                // this.state.menuItems = this.convertMenus(rghtMenus);
	                this.state.menuItems = rghtMenus;
	            } else {
	                this.state.menuItems = null;
	            }
	        }
	        /**
	         * 递归创建菜单
	         * @param {Array} menuItems 菜单项数组
	         */
	
	    }, {
	        key: 'convertMenus',
	        value: function convertMenus(menuItems, objFct, record, treeNode) {
	            var _this2 = this;
	
	            return menuItems.map(function (item) {
	                var key = item.c;
	                if (!key) key = item.c = (0, _sgiCommon.uuid)(8);
	
	                var mnCLsn = item.mnCLsn;
	                if (mnCLsn) {
	                    var $mnCLsn = void 0;
	                    try {
	                        if (typeof mnCLsn == 'string') {
	                            $mnCLsn = new Function("module", "objFct", "record", "treeNode", mnCLsn);
	                        } else {
	                            $mnCLsn = mnCLsn;
	                        }
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                    _this2.state.menuFuns[key] = $mnCLsn;
	                }
	
	                //隐藏或只读选择
	                var readHideSel = item.readHideSel;
	
	                //隐藏或只读 函数
	                var readHideLsn = item.readHideLsn;
	                var readHideFlag = true;
	                if (readHideLsn) {
	                    var $readHideLsn = void 0;
	                    try {
	                        $readHideLsn = new Function("module", "objFct", "record", "treeNode", readHideLsn);
	                        readHideFlag = $readHideLsn(_this2, objFct, record, treeNode);
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                }
	
	                //是否有图标
	                var icon = item.icon;
	                var itemTe = void 0;
	                if (icon) {
	                    itemTe = _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement(_antd.Icon, { type: icon }),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            item.te
	                        )
	                    );
	                } else {
	                    itemTe = item.te;
	                }
	
	                if (readHideFlag) {
	                    var cldSet = item.cldSet;
	                    if (cldSet && cldSet.length > 0) {
	                        return _react2.default.createElement(
	                            SubMenu,
	                            { style: SubMenuStyle, key: key, itemData: item, title: item.te },
	                            _this2.convertMenus(cldSet)
	                        );
	                    }
	                    return _react2.default.createElement(
	                        MenuItem,
	                        { style: SubMenuStyle, key: key, itemData: item },
	                        itemTe
	                    );
	                } else {
	                    if (readHideSel == "hide") {} else {
	                        return _react2.default.createElement(
	                            MenuItem,
	                            { disabled: true, style: SubMenuStyle, key: key, itemData: item },
	                            itemTe
	                        );;
	                    }
	                }
	                // return <MenuItem style={SubMenuStyle} key={key} itemData={item}>{item.te}</MenuItem>
	                // let cldSet = item.cldSet;
	                // if (cldSet && cldSet.length > 0) {
	                //     return <SubMenu style={SubMenuStyle} key={key} itemData={item} title={item.te}>{this.convertMenus(cldSet)}</SubMenu>
	                // }
	                // return <MenuItem style={SubMenuStyle} key={key} itemData={item}>{item.te}</MenuItem>
	            });
	        }
	
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc
	         * @param {*} treeProps
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, treeProps, functions, type) {
	            var _this3 = this;
	
	            // 用户自定义点击事件
	            var iCLsn = moduleDesc.iCLsn;
	            if (iCLsn && type != 'dnd') {
	                var $iCLsn;
	                try {
	                    $iCLsn = new Function("module", "objFct", "record", "treeNode", "e", iCLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	
	                // functions.onSelect = $iCLsn;
	                functions.onSelect = function (module, objFct, record, treeNode, e) {
	                    $iCLsn(module, objFct, record, treeNode, e);
	                    // 调用服务接口配置
	                    (0, _SgiCompComm.toCallSi)(moduleDesc, _this3.props.objFct);
	                };
	            }
	            treeProps.onSelect = _SgiEventHandler.SgiEventHandler.itemclick.bind(this);
	
	            // 双击事件
	            var dbCLsn = moduleDesc.dbCLsn;
	            if (dbCLsn && type != 'dnd') {
	                var $dbCLsn;
	                try {
	                    $dbCLsn = new Function("module", "objFct", "record", "treeNode", "node", "e", dbCLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.onDoubleClick = $dbCLsn;
	            }
	            treeProps.onDoubleClick = _SgiEventHandler.SgiEventHandler.itemDoubleClick.bind(this);
	
	            // 右键点击事件
	            var rCLsn = moduleDesc.rCLsn;
	            if (rCLsn && type != 'dnd') {
	                var $rCLsn;
	                try {
	                    $rCLsn = new Function("module", "objFct", "record", "treeNode", rCLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.onRightClick = $rCLsn;
	            }
	            treeProps.onRightClick = _SgiEventHandler.SgiEventHandler.itemRightClick.bind(this);
	
	            // 勾选事件(ndIsChk:是否可以多选，ChLsn:check事件)
	            var ndIsChk = moduleDesc.ndIsChk;
	            var ChLsn = moduleDesc.ChLsn;
	            if (ndIsChk && ChLsn) {
	                var $ChLsn = void 0;
	                try {
	                    $ChLsn = new Function("module", "objFct", "record", "treeNode", "checked", "e", ChLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	
	                functions.onCheck = $ChLsn;
	            }
	
	            // 拖拽释放事件
	            var onDrp = moduleDesc.onDrp;
	            if (onDrp) {
	                var $onDrp = void 0;
	                try {
	                    $onDrp = new Function("module", "objFct", "record", "treeNode", onDrp);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	
	                functions.onDrop = $onDrp;
	            }
	
	            treeProps.onExpand = function (expandedKeys) {
	                _this3.state.expandedKeys = expandedKeys;
	                _this3.state.autoExpandParent = false;
	                _this3.setState({ loading: false });
	            };
	        }
	
	        /**
	        * 创建表格绑定store
	        * @param {*} moduleDesc
	        * @param {*} objFct
	        * @param {*} ClmDes
	        */
	
	    }, {
	        key: 'getTreeData',
	        value: function getTreeData(moduleDesc, objFct) {
	            //取得绑定实例名
	            var insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName); //绑定实例名
	            var tData;
	            //取得绑定类名`  var tData = [];
	            if (insName && objFct) {
	                tData = objFct.get(insName);
	            }
	            if (!tData) {
	                return [];
	            }
	            return tData;
	        }
	    }, {
	        key: 'AddTreeAttribute',
	
	
	        /**
	         * 创建树视图
	         */
	        value: function AddTreeAttribute(moduleDesc, treeProps) {
	
	            // treeProps.checkStrictly = true; //父子节点点击分开
	            if (moduleDesc.ndisLine) {
	                treeProps.showLine = true; //树节点是否连线
	            } else {
	                treeProps.showLine = false; //树节点是否连线
	            }
	            if (moduleDesc.ndIsChk) {
	                // treeProps.checkable = true; // 树节点是否可选
	                // treeProps.multiple = true;
	                this.state.checkable = true;
	                // this.state.multiple = true;
	            } else {
	                // treeProps.checkable = false; // 树节点是否可选
	                // treeProps.multiple = false;
	                this.state.checkable = false;
	                // this.state.multiple = false;
	            }
	            if (moduleDesc.ndIsDg) {
	                treeProps.draggable = true; // 树节点是否可拖拽
	            } else {
	                treeProps.draggable = false; // 树节点是否可拖拽
	            }
	
	            // 即时搜索
	            var isSearch = moduleDesc.isSearch;
	            this.state.isSearch = !!isSearch;
	
	            // clpDrt:"top", // 面板的折叠方向
	            // clpd:false, // 面板初始时的折叠状态
	            // disCustom:false, //只显示自定义菜单
	            // isClp:false, // 面板是否可以折叠
	            // isClpFst:true, // 是否面板展开或收缩的顺序
	            // isCls:false, // 面板是否可以关闭
	            // isFrm:false, // 面板是否填充
	            // isHClpTl:false, // 是否显示折叠按钮
	            // isMsMu:false, //使用右键菜单
	            // isTlb:false, //显示工具条
	            // isttlClp:false, // 是否单击面板头部折叠
	            // tlbIsTtl:true, //显示标题
	            // ttlAlg:"top", // 面板标题位置
	            // ttlAlgn:"left", // 面板标题对齐方式
	            // selFirst:false, //初始化后选择首行
	            // 可设置默认选中的树节点：defaultSelectedKeys，（受控）设置选中的树节点：selectedKeys
	        }
	
	        // 定义树节点对象，追加常用方法
	
	    }, {
	        key: 'createTreeStore',
	        value: function createTreeStore() {
	            //弄这个 keystreeNode 主要记录层级关系
	            this.state.keysTreeNode = {};
	            this.state.store = this.fitTreeNodes(this.state.treeData, null);
	        }
	    }, {
	        key: 'testEvent',
	        value: function testEvent(e, e2) {
	            tool.sgiLogger.log('testEvent e:', e);
	            tool.sgiLogger.log('testEvent e2:', e2);
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiTree;
	}(_react2.default.Component);
	
	//给类添加公共方法
	
	
	SgiTree.defaultProps = {};
	SgiTree.propTypes = {};
	Object.assign(SgiTree.prototype, _SgiTreeBaseFun.sgiTreeBaseFun);
	
	exports.SgiTree = SgiTree;
	exports.default = SgiTree;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.sgiTreeNodeFun = exports.sgiTreeBaseFun = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * 树控件的基础方法，供树控件继承
	 * wangz
	 * 2018.3.12
	 */
	
	"use strict";
	/**
	 * 树实例方法集
	 * @namespace 树实例方法集
	 * @alias tree
	 * @inst
	 */
	var sgiTreeBaseFun = {
	
		/**
	  * 刷新树方法
	  * @param {Array} treeData 树上的数据数组
	  */
		refreshTree: function refreshTree(treeData) {
			if (treeData) {
				this.state.treeData = treeData;
				this.createTreeStore();
				this.setState({ loading: true });
			}
		},
	
		/**
	  * 设置树是否可勾选接口
	  * @param {boolean} checkable 是否可勾选
	  */
		setCheckable: function setCheckable(checkable) {
			this.state.checkable = checkable;
			// this.state.multiple = checkable;
			this.setState({});
		},
	
		/**
	 * 获取已选中/勾选节点
	 */
		getSelection: function getSelection() {
			if (this.props.moduleDesc.ndIsChk) {
				return this.state.checkedNodes;
			} else {
				return this.state.selectedNodes;
			}
		},
		/**
	  * 根据数据 设置选中
	  */
		setTreeChecked: function setTreeChecked(records) {
			var _this = this;
	
			if (!records) {
				return;
			}
			if (records instanceof Array) {
				this.state.checkedKeys = [];
				records.forEach(function (element) {
					_this.state.checkedKeys.push(element[_this.state.key]);
				});
			} else {
				this.state.checkedKeys = [records[this.state.key]];
			}
	
			//check的信息放入到 checknodes中
			this.state.checkedNodes = [];
			this.state.checkedKeys.forEach(function (element) {
				_this.state.checkedNodes.push(_this.state.keysTreeNode[element].props.itemData);
			});
			this.setState({ loading: false });
		},
	
		/**
	  * 获取树的勾选数据(树结构json数据)
	  */
		getCheckData: function getCheckData() {
			var key = this.state.key;
			var cldKey = this.state.childrenName;
			var checkedNodes = this.state.checkedNodes || [];
			var checkKeys = checkedNodes.map(function (item) {
				return item[key];
			});
			var treeData = this.state.treeData || [];
			var getCheckItem = function getCheckItem(item) {
				if (!item) return null;
				if (checkKeys.indexOf(item[key]) !== -1) {
					return (0, _sgiCommon.deepCopyAll)(item, true);
				} else if (item[cldKey]) {
					var checkClds = [];
					item[cldKey].forEach(function (cld) {
						var checkCld = getCheckItem(cld);
						if (checkCld && checkCld[key]) {
							checkClds.push(checkCld);
						}
					});
					if (checkClds.length > 0) {
						var newItem = _extends({}, item);
						newItem[cldKey] = checkClds;
						return newItem;
					}
				}
			};
			return treeData.map(function (data) {
				return getCheckItem(data);
			}).filter(function (d) {
				return d;
			});
		},
	
		/**
	  * 设置树的勾选数据(树结构json数据)
	  * @param {*} checkData 树结构勾选数据
	  * @param {*} key 
	  * @param {*} treeData 
	  */
		setCheckData: function setCheckData(checkData, key, treeData) {
			if (!Array.isArray(checkData)) return;
			treeData = this.state.treeData = treeData || this.state.treeData || [];
			key = key || this.state.key;
			var cldKey = this.state.childrenName;
			var setCheckItem = function setCheckItem(item, treeItem) {
				if (!item || !treeItem || item[key] !== treeItem[key]) return null;
				if (!item[cldKey]) {
					treeItem.checked = true;
				} else {
					item[cldKey].forEach(function (cld) {
						var treeCld = void 0;
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;
	
						try {
							for (var _iterator = treeItem[cldKey][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var trCld = _step.value;
	
								if (cld[key] === trCld[key]) {
									treeCld = trCld;
									break;
								}
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}
	
						if (treeCld) {
							setCheckItem(cld, treeCld);
						}
					});
				}
			};
			checkData.forEach(function (check) {
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = treeData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var data = _step2.value;
	
						if (!check[key]) _sgiLogger.sgiLogger.warn('\u8BBE\u7F6E\u6811\u52FE\u9009\uFF0C\u5F53\u524D\u52FE\u9009\u8282\u70B9\u7684key=' + key + '\u7684\u5C5E\u6027\u4E0D\u5B58\u5728\uFF0C\u5F53\u524D\u8282\u70B9\uFF1A', check);
						if (check[key] === data[key]) {
							setCheckItem(check, data);
							break;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			});
			this.state.checkedKeys = [];
			this.createTreeStore();
			this.setState({});
		},
	
		/**
	  * 根据普通数据 和对比属性，返回
	  */
		getTreeRecord: function getTreeRecord(records, key) {
			var _this2 = this;
	
			var rsList = [];
			if (!records || !key) {
				return rsList;
			}
			var inList = void 0;
			var tmpTreeRecord = void 0;
	
			if (records instanceof Array) {
				inList = records;
			} else {
				inList = [records];
			}
	
			inList.forEach(function (inElement) {
				if (!inElement) return;
				for (var index in _this2.state.keysTreeNode) {
					tmpTreeRecord = _this2.state.keysTreeNode[index].props.itemData;
					if (tmpTreeRecord[key] == inElement[key]) {
						rsList.push(tmpTreeRecord);
						break;
					}
				}
			});
			return rsList;
		},
		/**
	  * 将树节点数据转换为结构
	  * @param {*} info  树节点数据
	  * @returns  树节点结构
	  */
		cvtNode: function cvtNode(info) {
			if (!info) {
				return;
			}
			var node = this.state.keysTreeNode[info[this.state.key]];
			if (node) {
				return node.props;
			}
		},
	
		/**
	 * 选中树的某个节点
	 * @param {info} info要选中的节点数据信息，含有key值
	 */
		select: function select(info) {
			if (!info || !info[this.state.key]) {
				return;
			}
			var e = {
				event: "select",
				selected: true,
				node: this.state.keysTreeNode[info[this.state.key]],
				selectedNodes: [this.state.keysTreeNode[info[this.state.key]]]
			};
			//自动展开父节点
			this.expand(info);
	
			this.state.treeProps.onSelect([info[this.state.key]], e);
		},
	
		/**
	 * 展开树的某个节点
	 * @param {object} record 要展开的树节点数据信息，含有key值
	 */
		expand: function expand(record) {
			if (!record || !record[this.state.key]) {
				return;
			}
			this.state.expandedKeys = [].concat(_toConsumableArray(this.state.expandedKeys), [record[this.state.key]]).filter(function (d, index, arr) {
				return arr.indexOf(d) === index;
			});
			//获取父节点 自动展开父节点
			var recordNode = this.cvtNode(record);
			while (recordNode.gainParent()) {
				recordNode = recordNode.gainParent();
				this.state.expandedKeys.push(recordNode.getData()[this.state.key]);
			}
			// this.setState({ loading: false });
			this.setState({});
		},
		/**
	 * 节点全部展开
	 * @param {treeNode} this要展开的节点
	 */
		expandAll: function expandAll() {
			var keys = [];
			for (var key in this.state.keysTreeNode) {
				keys.push(key);
			}
			// this.tree.state.expandedKeys = keys;
			this.setState({ expandedKeys: keys });
		},
		/**
	 * 选中首行
	 */
		selFirst: function selFirst() {
			var treeData = this.state.treeData;
			if (treeData) {
				this.select(treeData[0]);
			}
		},
	
		/**
	 * 删除树的选中数据
	 */
		delTreeSel: function delTreeSel() {
			var _this3 = this;
	
			// var selectedNodes = this.state.selectedNodes;
			var selectedNodes = this.props.moduleDesc.ndIsChk ? this.state.checkedNodes : this.state.selectedNodes;
			var treeData = this.state.treeData;
			if (treeData && selectedNodes) {
				selectedNodes.map(function (item, index) {
					//获取当前节点的父节点
					_this3.delTreeNode(item);
				});
				this.state.selectedKeys = []; //既然删除了那就置空喽
				this.state.selectedNodes = [];
				this.createTreeStore();
				this.setState({ loading: false });
			} else {
				return null;
			}
		},
		/**
	  * 删除树的一个节点
	  * @param  {[object]} node [节点数据信息]
	  * @return {[type]}      [description]
	  */
		delTreeNode: function delTreeNode(record) {
	
			//获取父pkey
			//先获取父treenode
			var NodeObj = this.state.keysTreeNode[record[this.state.key]];
			var parentNodeObj = NodeObj.props.parentNode;
			var parentNodeKey = parentNodeObj ? parentNodeObj.props.itemData[this.state.key] : undefined;
			var parentNode = this.findNodeByKey(null, parentNodeKey);
			var children = void 0;
			if (parentNode) {
				children = parentNode[this.state.childrenName];
			} else {
				children = this.state.treeData;
			}
			_sgiCommon.sgiArray.remove(children, record);
		}
		// eq: function (a, b) {
		//     //获取a和b的属性长度
		//     var propsA = Object.getOwnPropertyNames(a),
		//         propsB = Object.getOwnPropertyNames(b);
		//     if (propsA.length != propsB.length) {
		//         return false;
		//     }
		//     for (var i = 0; i < propsA.length; i++) {
		//         var propName = propsA[i];
		//         //如果对应属性对应值不相等，则返回false
		//         if (a[propName] !== b[propName]) {
		//             return false;
		//         }
		//     }
		//     return true;
		// },
		// /**
		//  * 删除树的一个节点
		//  * @param  {[object]} node [节点数据信息]
		//  * @return {[Array]}      [删除后的treeData]
		//  */
		// delTreeNode: function (node) {
		//     var treeData = this.state.treeData;
		//     var func1 = function (treeData, node, me) {
		//         var have = null;
		//         var i = 0;
		//         for (; i < treeData.length; i++) {
		//             have = (treeData[i] == node) || me.eq(treeData[i], node);
		//             if (have == true) {//找到此节点，然后删除
		//                 treeData.splice(i, 1);
		//                 break;
		//             } else if (have == false) {
		//                 continue;
		//             }
		//         }
	
		//         if (have == true) {
		//             return have;
		//         } else if (have == false) {//未找到，遍历查找子节点
		//             for (var j = 0; j < treeData.length; j++) {
		//                 var item = treeData[j];
		//                 if (item.cldSet && item.cldSet.length > 0) {
		//                     have = func1(item.cldSet, node, me);
		//                 }
		//                 if (have == true) {
		//                     break;
		//                 }
		//             }
		//             return have;
		//         }
		//     }
	
		//     if (treeData && node) {
		//         func1(treeData, node, this);
		//         this.refreshTree(treeData);
		//         return treeData;
		//     } else {
		//         return null;
		//     }
		// },
	
		/**
	  * treeNode树节点操作方法
	  * @namespace treeNode方法集【注意：该方法集非全局方法集，须在树事件中使用】
	  * @alias treeNode
	  * @inst
	  */
	};var sgiTreeNodeFun = {
	
		/**
	 * 判断节点是否是根节点
	 * @returns {boolean} 是否是根节点
	 */
		isRoot: function isRoot() {
			if (this && this.parentNode) {
				return false;
			} else {
				return true;
			}
		},
		/**
	  * 获取得父节点treeNode
	  * @return {treeNode} 父节点treeNode对象
	  */
		gainParent: function gainParent() {
			if (!this.parentNode) {
				return undefined;
			}
			return this.parentNode.props;
		},
		/**
	  * 获取treeNode上数据对象
	  * @returns {object} treeNode对应数据
	  */
		getData: function getData() {
			return this.itemData;
		},
		/**
	 * 获取树的子节点treeNode数组
	 * @return {treeNode[]} 子节点treeNode数组
	 */
		gainChild: function gainChild() {
			var _this4 = this;
	
			if (this.itemData[this.tree.state.childrenName] && this.itemData[this.tree.state.childrenName].length) {
				// return this.itemData[this.tree.state.childrenName];
				var children = this.itemData[this.tree.state.childrenName];
				var childrenNode = [];
				if (children && children.length > 0) {
					children.forEach(function (element) {
						childrenNode.push(_this4.tree.state.keysTreeNode[element[_this4.tree.state.key]]);
					});
				}
				return childrenNode;
			} else {
				return null;
			}
		},
		/**
	 * 获取树的子节点数据数组
	 * @return {object[]} 子节点数据数组
	 */
		gainChildData: function gainChildData() {
			if (this.itemData[this.tree.state.childrenName] && this.itemData[this.tree.state.childrenName].length) {
				return this.itemData[this.tree.state.childrenName];
			} else {
				return null;
			}
		},
	
		/**
	 * 取得根节点treeNode对象
	 * @returns {treeNode} 根节点treeNode对象
	 */
		gainRoot: function gainRoot() {
			var p;
			var p2 = this;
			var findRoot = function findRoot() {
				p = p2.parentNode;
				if (p != null) {
					while (p.props != null) {
						p2 = p.props;
						return findRoot();
					}
				} else {
					//p=null
					return p2;
				}
			};
			p2 = findRoot();
			// let NodeObj = this.tree.state.keysTreeNode[p2[this.tree.state.key]];
			return p2;
		},
		/**
	 * 节点是否有下级节点
	 * @returns {boolean} 是否有下级
	 */
		hasChild: function hasChild() {
			if (this.itemData[this.tree.state.childrenName] && this.itemData[this.tree.state.childrenName].length) {
				return true;
			} else {
				return false;
			}
		},
		/**
	  * 判断是否是叶子节点
	  * @return {boolean} true:是叶子节点，false:不是叶子节点
	  */
		leaf: function leaf() {
			if (this.isLeaf == true) {
				return true;
			} else {
				return false;
			}
		},
	
		/**
	  * 在当前节点下添加子节点
	  * @param  {object} record 要添加的节点数据
	  */
		appendChild: function appendChild(record) {
			if (!record) {
				return;
			}
			delete record._key;
			delete record._pkey;
			if (this.itemData[this.tree.state.childrenName]) {
				this.itemData[this.tree.state.childrenName].push(record);
			} else {
				this.itemData[this.tree.state.childrenName] = [];
				this.itemData[this.tree.state.childrenName].push(record);
			}
			// this.tree.refresh();
			this.tree.createTreeStore();
			this.tree.setState({ loading: true });
		},
		/**
	  * 移除当前树节点（非根节点）
	  */
		remove: function remove() {
			var me = this.itemData;
			var children;
			if (this && this.parentNode && this.parentNode.props.itemData) {
				children = this.parentNode.props.itemData[this.tree.state.childrenName];
			} else {
				children = this.tree.state.treeData;
			}
			_sgiCommon.sgiArray.remove(children, me);
			// this.tree.refresh();
			this.tree.createTreeStore();
			this.tree.setState({ loading: true });
		},
		/**
	  * 删除此节点下全部子节点
	  */
		removeAllChild: function removeAllChild() {
			this.itemData[this.tree.state.childrenName] = [];
			// this.tree.refresh();
			this.tree.createTreeStore();
			this.tree.setState({ loading: true });
		},
		/**
	  * 查找属性等于指定值的第一个子项
	  * @param  {String} attribute 属性key
	  * @param  {Object} value 匹配的属性值
	  * @param  {Boolean} [deep=false] 是否递归遍历，true表示遍历所有子节点，false表示只遍历下一级
	  * @return {treeNode} 匹配的子项
	  */
		findChild: function findChild(attribute, value, deep) {
			var newCurrent = this.tree.state.keysTreeNode[this.itemData[this.tree.state.key]];
			var me = this;
			if (newCurrent) {
				me = newCurrent.props;
			}
			return me.findChildBy(function () {
				return this[attribute] == value;
			}, null, deep);
		},
		/**
	  * 通过自定义函数查找第一个子项。 如果传递的函数返回true，则该子项匹配。
	  * @param  {Function} fn    [如果通过的节点是所需的节点，fn一个必须返回true的函数。]
	  * @param  {[Object]}   scope [执行该函数的作用域（此引用）。 默认为正在测试的节点。]
	  * @param  {[Boolean]}   deep = false  [true：搜索比直接子节点更深的节点]
	  * @return {[type]}         [找到的子元素，如果没有找到，则返回null]
	 * 
	 * @private
	  */
		findChildBy: function findChildBy(fn, scope, deep) {
			var cs = [];
			if (this.children) {
				cs = this.children;
			}
			var len = cs.length,
			    i = 0,
			    n,
			    res;
			for (; i < len; i++) {
				n = cs[i].props;
				if (fn.call(scope || n.itemData, n.itemData) === true) {
					return n;
				} else if (deep) {
					res = n.findChildBy(fn, scope, deep);
					if (res !== null) {
						return res;
					}
				}
			}
			return null;
		},
		/**
	 * 展开当前节点
	 */
		expand: function expand() {
			if (!this || !this.itemData[this.tree.state.key]) return;
			// this.tree.state.expandedKeys.push(this.itemData[this.tree.state.key]);
			// this.tree.setState({ loading: true });
			var key = this.itemData[this.tree.state.key];
			var expandedKeys = [].concat(_toConsumableArray(this.tree.state.expandedKeys));
			if (expandedKeys.indexOf(key) < 0) {
				expandedKeys.push(key);
				this.tree.setState({ expandedKeys: expandedKeys });
			}
		},
		/**
	  * 取得节点的GUID，从根节点开始的节点编码拼接
	 * @returns {string} guid
	  */
		getGUID: function getGUID() {
			if (this.isRoot()) {
				return this.gainGUID();
			}
			var root = this.gainRoot();
			var mid = this.getMID();
			var guid = void 0;
			if (mid) {
				guid = root.gainGUID() + "`" + mid;
			} else {
				guid = root.gainGUID();
			}
			return guid;
		},
		/**
	  * 取得获得成员编号,它是由除了根节点之外,各层节点SC的组装串
	 * @returns {string} mid字符串
	 * 
	 * @private
	  */
		getMID: function getMID() {
			var rec = this.getData() || {};
			var mid = rec.sc || "";
	
			var p = this.gainParent();
			if (!p || p.isRoot()) return mid; //父节点存在且不是根，才会往下走
	
			var pmid = p.getMID();
			if (pmid) mid = pmid + "`" + mid;
	
			return mid;
		},
		/**
	  * 获取当前节点的GUID
	 * @returns {string} guid字符串
	  */
		gainGUID: function gainGUID() {
			var rec = this.getData() || {};
			var guid = rec.ap + "_" + rec.tt + "_" + rec.ss + "_" + rec.sc;
			return guid;
		}
	};
	
	exports.sgiTreeBaseFun = sgiTreeBaseFun;
	exports.sgiTreeNodeFun = sgiTreeNodeFun;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 表单控件的maker的公共方法
	 * wangz 
	 * 2018.3.9
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddFormCtlCommonAttribute = exports.setFormCtlLayout = exports.bindEvent = exports.bindValue = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 绑定显示值
	 * @param {描述信息} panelModule 
	 * @param {描述信息} moduleDesc 
	 * @param {数据} bdInst
	 * @param {属性} formItem 
	 * @param {属性} inputprops 
	 */
	var bindValue = function bindValue(panelModule, moduleDesc, bdInst, formItem, inputprops) {
	    if (!bdInst) {
	        return;
	    }
	    var c = moduleDesc.c;
	    if (c) inputprops.defaultValue = "12112";
	    // if (c) inputprops.defaultValue = panelModule.state[bdInst][c];
	};
	
	/**
	 * 属性转换
	 * @param {描述信息} moduleDesc 
	 * @param {属性} formItem 
	 * @param {属性} inputprops 
	 */
	var AddFormCtlCommonAttribute = function AddFormCtlCommonAttribute(moduleDesc, formItem, inputprops) {
	
	    var cId = moduleDesc.cId; //cid 唯一标示
	    if (cId) inputprops.id = (0, _SgiCommon.getConstByKey)(this, cId);
	
	    var isDis = moduleDesc.isDis; //是否可用
	    if (isDis) inputprops.disabled = isDis;
	
	    var text = moduleDesc.te; //设置标签
	    if (text) formItem.label = text;
	
	    var ctlW = moduleDesc.ctlW; //控件宽度
	    if (ctlW) formItem.style.width = ctlW;
	
	    var ctlH = moduleDesc.ctlH; //控件高度
	    if (ctlH) formItem.style.height = ctlH;
	
	    var lblW = moduleDesc.lblW; //设置标签宽度  
	    if (ctlW && lblW) {
	        var lblWSpan = parseInt(lblW / ctlW * 24);
	        var wrapperSpan = 24 - lblWSpan;
	        formItem.labelCol = { span: lblWSpan };
	        formItem.wrapperCol = { span: wrapperSpan };
	    } else {
	        formItem.labelCol = { span: 6 };
	        formItem.wrapperCol = { span: 18 };
	    }
	
	    var inpPopTe = moduleDesc.inpPopTe; //提示内容
	    if (inpPopTe) inputprops.placeholder = inpPopTe;
	
	    var defVal10 = moduleDesc.defVal10; //默认内容
	    if (defVal10) inputprops.defaultValue = defVal10;
	
	    var bdText = moduleDesc.bdText; //后置内容
	    if (bdText) inputprops.addonAfter = bdText;
	
	    var alwBlk = moduleDesc.alwBlk; //是否允许为空
	    if (alwBlk) formItem.required = alwBlk;
	
	    var isHdn = moduleDesc.isHdn; //是否隐藏??没实现
	    var maxL = moduleDesc.maxL; //设置字段输入的最大长度??没实现
	    var minL = moduleDesc.minL; //设置字段输入的最小长度??没实
	
	    var isLbl = moduleDesc.isLbl; //设置是否隐藏标签??没实现
	    var lblAlg = moduleDesc.lblAlg; //设置标签对齐方式??没实现
	    var isClp = moduleDesc.isClp; //设置是否根据内容字段进行伸展和收缩??没实现
	    var msfTgt = moduleDesc.msfTgt; //设置错误信息提示位置??没实现
	
	    // var prefix = moduleDesc.prefix;//前缀图
	    // if (prefix) inputprops.prefix = prefix;
	};
	
	/**
	 * 设置布局
	 * @param {描述信息} moduleDesc 
	 * @param {属性} formItem 
	 * @param {属性} inputprops 
	 */
	var setFormCtlLayout = function setFormCtlLayout(moduleDesc, formItem, inputprops) {};
	
	/**
	 * 事件转换
	 * @param {描述信息} moduleDesc 
	 * @param {属性} formItem 
	 * @param {属性} inputprops 
	 */
	var bindEvent = function bindEvent(moduleDesc, formItem, inputprops) {
	    //点击事件
	    // var click = moduleDesc.$click;
	    // if (click){
	    inputprops.onClick = function () {
	        _antd.message.info('点击事件');
	    };
	    // }
	
	    //双击事件
	    inputprops.onDoubleClick = function () {
	        _antd.message.info('双击事件');
	    };
	
	    //onchange
	    inputprops.onChange = function () {
	        _antd.message.info('修改事件');
	    };
	
	    //onInput
	    inputprops.onInput = function () {
	        _antd.message.info('输入事件');
	    };
	
	    //onFocus
	    inputprops.onFocus = function () {
	        _antd.message.info('获取焦点事件');
	    };
	
	    //onBlur
	    inputprops.onBlur = function () {
	        _antd.message.info('焦点离开事件');
	    };
	
	    //onCopy
	    inputprops.onCopy = function () {
	        _antd.message.info('复制事件');
	    };
	
	    //onCut
	    inputprops.onCut = function () {
	        _antd.message.info('剪切事件');
	    };
	
	    //onPaste
	    inputprops.onPaste = function () {
	        _antd.message.info('粘贴事件');
	    };
	};
	
	exports.bindValue = bindValue;
	exports.bindEvent = bindEvent;
	exports.setFormCtlLayout = setFormCtlLayout;
	exports.AddFormCtlCommonAttribute = AddFormCtlCommonAttribute;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _sgiFormCtlValidator = __webpack_require__(254);
	
	var _SgiCtlComponent2 = __webpack_require__(161);
	
	var _SgiCtlComponent3 = _interopRequireDefault(_SgiCtlComponent2);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiFormCtlComponent = function (_SgiCtlComponent) {
	    _inherits(SgiFormCtlComponent, _SgiCtlComponent);
	
	    function SgiFormCtlComponent(props) {
	        _classCallCheck(this, SgiFormCtlComponent);
	
	        var _this = _possibleConstructorReturn(this, (SgiFormCtlComponent.__proto__ || Object.getPrototypeOf(SgiFormCtlComponent)).call(this, props));
	
	        _this.state = _extends({}, _this.state, { //由super构造器产生
	            //初始化state
	            validRules: {},
	            validState: true,
	            required: false,
	            loading: false,
	            isLabel: false,
	            formItemProps: {
	                style: { 'margin-bottom': "1px", 'margin-top': "1px" },
	                hasFeedback: false,
	                help: undefined,
	                validateStatus: 'success'
	                // colon: false //不显示：
	            }, //存放formItem属性
	            inputProps: {
	                style: { width: "100%" },
	                // value: undefined,  //文本框显示值 //2018.04.27-yly,有value会导致默认值无法赋值
	                disabled: false //是否可用
	            }, //存放input属性
	            _formProps: {}, //存放form属性
	            formItemClass: []
	        });
	        return _this;
	    }
	
	    _createClass(SgiFormCtlComponent, [{
	        key: "_maker",
	        value: function _maker() {
	            _get(SgiFormCtlComponent.prototype.__proto__ || Object.getPrototypeOf(SgiFormCtlComponent.prototype), "_maker", this).call(this);
	
	            var _props2 = this.props,
	                parentModule = _props2.parentModule,
	                moduleDesc = _props2.moduleDesc,
	                bdInst = _props2.bdInst,
	                objFct = _props2.objFct,
	                type = _props2.type;
	            var _state = this.state,
	                formItemProps = _state.formItemProps,
	                inputProps = _state.inputProps,
	                _props = _state._props,
	                _class = _state._class,
	                _style = _state._style,
	                formItemClass = _state.formItemClass;
	
	
	            if (!moduleDesc) return;
	
	            // 属性和类名合并
	            delete _style.margin;
	            (0, _rtSdCommon.assignProps)(formItemProps, _props);
	            (0, _rtSdCommon.assignArrayStr)(formItemClass, _class);
	
	            /**************** 转换公共属性 ****************/
	            // label样式回显
	            var isLabel = moduleDesc.isLabel;
	            this.state.isLabel = !!isLabel;
	            if (isLabel) formItemProps.colon = true; // 显示冒号
	
	            var isDis = moduleDesc.isDis; //是否可用
	            inputProps.disabled = isDis;
	
	            var isRead = moduleDesc.isRead; //是否只读
	            // inputProps.style.readonly = 'expression(this.readonly = true)';
	            inputProps.readOnly = !!isRead;
	
	            if (moduleDesc.te || moduleDesc.teid) {
	                //避免不必要的执行getTRByPrm()方法
	                var text = _rtSdCommon.Resource.getTRByPrm(moduleDesc).te; //设置标签
	                if (text) formItemProps.label = text;
	            }
	
	            var ctlW = moduleDesc.ctlW; //控件宽度
	            var ctlH = moduleDesc.ctlH; //控件高度
	            if (ctlH) {
	                formItemProps.style.height = ctlH;
	                inputProps.style.height = ctlH; //输入框也随着高度变动
	            } else {
	                formItemProps.style.height = undefined; //编辑的时候即时刷新，也可以不加
	                inputProps.style.height = undefined; //编辑的时候即时刷新，也可以不加
	            }
	
	            delete formItemProps.style.width; //由sgiComponent创建，影响比例布局
	
	            var lblW = moduleDesc.lblW; //设置标签宽度
	
	            if (ctlW && lblW) {
	                var lblWSpan = parseInt(lblW / ctlW * 24);
	                var wrapperSpan = 24 - lblWSpan;
	                formItemProps.labelCol = { span: lblWSpan };
	                formItemProps.wrapperCol = { span: wrapperSpan };
	            } else {
	                formItemProps.labelCol = { span: 6 };
	                formItemProps.wrapperCol = { span: 18 };
	            }
	
	            var isLbl = moduleDesc.isLbl; //设置是否隐藏标签
	            if (isLbl) {
	                formItemProps.label = undefined;
	                formItemProps.labelCol = { span: 0 };
	                formItemProps.wrapperCol = { span: 24 };
	            }
	
	            var inpPopTe = moduleDesc.inpPopTe; //提示内容
	            if (inpPopTe) inputProps.placeholder = inpPopTe;
	
	            var defVal10 = moduleDesc.defVal10; //默认内容
	            if (defVal10 !== undefined) inputProps.defaultValue = defVal10; //数字控件是可以有0的，所以别用!判定
	
	            var bdText = moduleDesc.bdText; //后置内容
	            if (bdText) inputProps.addonAfter = bdText;
	
	            var alwBlk = moduleDesc.alwBlk; //是否允许为空
	            formItemProps.required = !alwBlk;
	            this.state.validRules.required = !alwBlk;
	            this.state.required = !alwBlk;
	            if (isLabel) {
	                //仅回显状态不校验
	                formItemProps.required = false;
	                this.state.validRules.required = false;
	                this.state.required = false;
	            }
	            // if (!alwBlk) {
	            //     formItemProps.required = !alwBlk;
	            //     this.state.validRules.required = !alwBlk;
	            // } else {
	            //     formItemProps.required = !alwBlk;
	            //     this.state.validRules.required = !alwBlk;
	            // }
	
	            if (moduleDesc.vldC) this.state.validRules.dataType = moduleDesc.vldC;
	
	            var maxL = moduleDesc.maxL; //设置字段输入的最大长度
	            if (maxL) this.state.validRules.maxL = maxL;else this.state.validRules.maxL = undefined;
	            var minL = moduleDesc.minL; //设置字段输入的最小长度
	            if (minL) this.state.validRules.minL = minL;else this.state.validRules.minL = undefined;
	
	            var vldC = moduleDesc.vldC;
	            if (vldC && (vldC === "int" || vldC === "double" || vldC === "money" || vldC === "number")) {
	                var maxV = moduleDesc.maxV; //设置字段输入的最大值
	                if (maxV) this.state.validRules.maxV = maxV;else this.state.validRules.maxV = undefined;
	                var minV = moduleDesc.minV; //设置字段输入的最小值
	                if (minV) this.state.validRules.minV = minV;else this.state.validRules.minV = undefined;
	            }
	
	            var isHdn = moduleDesc.isHdn; //是否隐藏
	            if (isHdn) {
	                formItemProps.style.display = "none";
	            } else {
	                formItemProps.style.display = undefined;
	            }
	
	            inputProps.nowrap = !!moduleDesc.nowrap;
	
	            // form属性
	            this.state._formProps = moduleDesc._formProps || {};
	
	            var lblAlg = moduleDesc.lblAlg; //设置标签对齐方式??没实现
	            var isClp = moduleDesc.isClp; //设置是否根据内容字段进行伸展和收缩??没实现
	            var msfTgt = moduleDesc.msfTgt; //设置错误信息提示位置??没实现
	
	            // var prefix = moduleDesc.prefix;//前缀图
	            // if (prefix) inputProps.prefix = prefix;
	
	            this.state.showCheck = moduleDesc.showCheck;
	
	            // 自定义校验规则
	            var cstmValid = moduleDesc.cstmValid;
	            var $cstmValid = void 0;
	            if (cstmValid) {
	                try {
	                    $cstmValid = new Function("module", "objFct", "value", cstmValid);
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.eventErr(error);
	                }
	                this.state.validRules.cstmValid = $cstmValid;
	            }
	
	            /**************** 控件自身属性 ****************/
	            this.__AddInputAttribute();
	            /**************** 设置布局 ****************/
	            // setFormCtlLayout(moduleDesc, formItemProps, inputProps);
	            /**************** 绑定值 ****************/
	            this.__bindValue();
	            /**************** 绑定事件 ****************/
	            this.__bindEvent();
	        }
	
	        // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
	
	    }, {
	        key: "_renderBeforeReturn",
	        value: function _renderBeforeReturn() {
	            var _props3 = this.props,
	                parentModule = _props3.parentModule,
	                moduleDesc = _props3.moduleDesc,
	                objFct = _props3.objFct,
	                type = _props3.type;
	            var _state2 = this.state,
	                formItemProps = _state2.formItemProps,
	                inputProps = _state2.inputProps,
	                required = _state2.required;
	            var functions = this.data.functions;
	
	            // 自定义样式处理
	            // const getCstmStyle = functions.cstmStyle;
	
	            var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(this, "cstmStyle");
	            var cstmStyle = {};
	            if (getCstmStyle) {
	                try {
	                    cstmStyle = getCstmStyle(this, objFct) || {};
	                } catch (error) {
	                    tool.sgiLogger.log(error);
	                }
	            }
	            for (var key in cstmStyle) {
	                if (key.toLowerCase() === "formItemStyle".toLowerCase() || key.toLowerCase() === "formItemProps".toLowerCase()) {
	                    Object.assign(formItemProps.style, cstmStyle[key] || {}); //formTtem样式
	                } else if (key.toLowerCase() === "inputStyle".toLowerCase() || key.toLowerCase() === "inputProps".toLowerCase()) {
	                    Object.assign(inputProps.style, cstmStyle[key] || {}); //input样式
	                } else {
	                    this.state[key] = cstmStyle[key]; //其他样式，富文本等的其他样式
	                }
	            }
	
	            // 必填属性处理
	            formItemProps.required = required;
	            this.state.validRules.required = required;
	        }
	
	        // 控件实现
	
	    }, {
	        key: "__AddInputAttribute",
	        value: function __AddInputAttribute(moduleDesc, formItemProps, inputProps) {}
	    }, {
	        key: "__bindValue",
	        value: function __bindValue() {
	            var _props4 = this.props,
	                parentModule = _props4.parentModule,
	                moduleDesc = _props4.moduleDesc,
	                bdInst = _props4.bdInst,
	                objFct = _props4.objFct,
	                type = _props4.type;
	            var _state3 = this.state,
	                formItemProps = _state3.formItemProps,
	                inputProps = _state3.inputProps,
	                _props = _state3._props,
	                _class = _state3._class,
	                formItemClass = _state3.formItemClass;
	
	
	            if (!moduleDesc.c) return;
	
	            //this.bdInst = bdInst;
	            var attname = moduleDesc.c;
	            this.state.attname = attname;
	
	            if (!bdInst || !objFct) return;
	
	            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	            var bdInstValue;
	            if (this.props.type === 'tb') {
	                var bdInstKeyList = bdInst.split('`');
	                var bdInstList = objFct.get(bdInstKeyList[0]);
	                if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                    bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
	                }
	            } else {
	                bdInstValue = objFct.get(bdInst);
	            }
	
	            // 带点./[/]解析
	            var evalFlg = RegExp(/[.|\[|\]]+/).test(attname);
	            var valueFlg = evalFlg && eval("(bdInstValue." + attname + ")") !== undefined;
	
	            if (bdInstValue && (bdInstValue[attname] !== undefined || valueFlg)) {
	                //2018.04.27-yly,有value会导致默认值无法赋值
	                //给checkbox 使用
	                // if (checked) {
	                var value = void 0;
	                if (evalFlg) {
	                    // 带层级解析，catch防止中断
	                    try {
	                        value = eval("(bdInstValue." + attname + ")");
	                    } catch (error) {
	                        _rtSdCommon.sgiLogger.error("\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D" + attname);
	                        _rtSdCommon.sgiLogger.eventErr(error);
	                    }
	                } else value = bdInstValue[attname];
	                if (this.props._name === "SgiFormCheckbox") {
	                    inputProps.checked = value ? true : false;
	                } else {
	                    inputProps.value = value;
	                }
	            } else {
	                //20180704 wzhe 默认值 给当前value
	                inputProps.value = inputProps.defaultValue;
	                if (bdInstValue) {
	                    if (evalFlg) {
	                        // 带层级解析，catch防止中断
	                        try {
	                            eval("(bdInstValue." + attname + " = inputProps.defaultValue)");
	                        } catch (error) {
	                            _rtSdCommon.sgiLogger.error("\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D" + attname);
	                            _rtSdCommon.sgiLogger.eventErr(error);
	                        }
	                    } else bdInstValue[attname] = inputProps.defaultValue;
	                }
	            }
	        }
	    }, {
	        key: "__bindEvent",
	        value: function __bindEvent() {
	            var _props5 = this.props,
	                parentModule = _props5.parentModule,
	                moduleDesc = _props5.moduleDesc,
	                bdInst = _props5.bdInst,
	                objFct = _props5.objFct,
	                type = _props5.type;
	            var _state4 = this.state,
	                formItemProps = _state4.formItemProps,
	                inputProps = _state4.inputProps,
	                _props = _state4._props,
	                _class = _state4._class,
	                formItemClass = _state4.formItemClass;
	            var functions = this.data.functions;
	
	            //拖拽模式 不生成事件
	
	            if (type == 'dnd') return;
	
	            //onchange
	            var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
	            if (chgLsn) {
	                var $chgLsn;
	                try {
	                    $chgLsn = new Function("module", "objFct", 'nv', 'record', 'extra', chgLsn);
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.eventErr(error);
	                }
	                functions.onChange = $chgLsn;
	            }
	            inputProps.onChange = _SgiEventHandler.SgiEventHandler.onChange.bind(this, this);
	
	            //onFocus
	            var inLsn = moduleDesc.inLsn; // 用户自定义点击事件
	            if (inLsn) {
	                var $inLsn;
	                try {
	                    $inLsn = new Function("module", "objFct", inLsn);
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.eventErr(error);
	                }
	                functions.onFocus = $inLsn;
	                inputProps.onFocus = _SgiEventHandler.SgiEventHandler.onFocus.bind(this, this);
	            }
	
	            //onBlur
	            var lveLsn = moduleDesc.lveLsn; // 用户自定义点击事件
	            if (lveLsn) {
	
	                var $lveLsn;
	                try {
	                    $lveLsn = new Function("module", "objFct", lveLsn);
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.eventErr(error);
	                }
	                functions.onBlur = $lveLsn;
	                inputProps.onBlur = _SgiEventHandler.SgiEventHandler.onBlur.bind(this, this);
	            }
	
	            // 自定义渲染组件
	            var cstmRender = moduleDesc.cstmRender;
	            if ((0, _rtSdCommon.funStrCheck)(cstmRender)) {
	                var $cstmRender = void 0;
	                try {
	                    $cstmRender = new Function("module", "inputProps", "value", "objFct", cstmRender);
	                } catch (error) {
	                    _rtSdCommon.sgiLogger.eventErr(error);
	                }
	                functions.cstmRender = $cstmRender;
	            }
	
	            // //onInput
	            // inputProps.onInput = function() {
	            //     message.info('获取焦点事件');
	            // }
	            // //点击事件
	            // inputProps.onClick = function () {
	            //     message.info('点击事件');
	            // }
	            // //双击事件
	            // inputProps.onDoubleClick = function () {
	            //     message.info('双击事件');
	            // }
	            // //onCopy
	            // inputProps.onCopy = function () {
	            //     message.info('复制事件');
	            // }
	            // //onCut
	            // inputProps.onCut = function () {
	            //     message.info('剪切事件');
	            // }
	            // //onPaste
	            // inputProps.onPaste = function () {
	            //     message.info('粘贴事件');
	            // }
	        }
	
	        /**
	        * 设置value值
	        * 刷新控件时候，调用的方法
	        */
	
	    }, {
	        key: "setValue",
	        value: function setValue(value) {
	            if (value === this.state.inputProps.value) return;
	
	            this.state.inputProps.value = value;
	
	            // 页面校验 刷新不校验
	            // this.validate(value);
	            this.setState({});
	        }
	
	        /**
	        * 获取value值
	        */
	
	    }, {
	        key: "getValue",
	        value: function getValue() {
	            return this.state.inputProps.value;
	        }
	
	        /**
	         * 设置是否禁用
	         */
	
	    }, {
	        key: "setDisabled",
	        value: function setDisabled(value) {
	            this.state.inputProps.disabled = value;
	            this.setState(this.state.inputProps);
	        }
	
	        /**
	         * 设置form禁用标识
	         * @param {boolean} formDisabled form禁用标识
	         */
	
	    }, {
	        key: "setFormDisabled",
	        value: function setFormDisabled(formDisabled) {
	            this.state.inputProps.formDisabled = formDisabled;
	            this.setState(this.state.inputProps);
	        }
	
	        /**
	        * 设置是否隐藏
	        */
	
	    }, {
	        key: "setHidden",
	        value: function setHidden(value) {
	            this.state.formItemProps.style.display = value ? "none" : undefined;
	            if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	                // react16需要更新引用
	                this.state.formItemProps.style = _extends({}, this.state.formItemProps.style);
	            }
	            this.setState(this.state.formItemProps);
	        }
	
	        /**
	         * 设置是否必填
	         * @param {boolean} required 是否必填
	         */
	
	    }, {
	        key: "setRequired",
	        value: function setRequired(required) {
	            this.setState({ required: !!required });
	        }
	        /**
	        * 设置是否只读
	        */
	
	    }, {
	        key: "setReadonly",
	        value: function setReadonly(value) {
	            this.state.inputProps.readonly = value;
	            this.setState(this.state.inputProps);
	        }
	        /**
	         * 页面修改时，刷新工厂绑定的值
	         */
	
	    }, {
	        key: "ctlRefresh",
	        value: function ctlRefresh(attname, bdInst, objFct, value) {
	
	            //对象工厂的值刷新
	            this.setBindValue(attname, bdInst, objFct, value);
	
	            //更新state
	            this.state.inputProps.value = value;
	
	            //页面校验
	            this.validate(value);
	        }
	
	        /**
	         * 仅更新工厂绑定值
	         * @param {string} attname 属性名
	         * @param {string} bdInst 绑定实例名
	         * @param {ObjFactory} objFct 对象工厂
	         * @param {object} value 值
	         */
	
	    }, {
	        key: "setBindValue",
	        value: function setBindValue(attname, bdInst, objFct, value) {
	            if (bdInst && attname) {
	                var bdInstData = void 0;
	                //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	                //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	                if (typeof bdInst === "string") {
	                    //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	                    //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	                    if (this.props.type === 'tb') {
	                        var bdInstKeyList = bdInst.split('`');
	                        var bdInstList = objFct.get(bdInstKeyList[0]);
	                        if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                            bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
	                        }
	                    } else {
	                        bdInstData = objFct.get(bdInst);
	                    }
	                } else {
	                    bdInstData = bdInst;
	                }
	
	                if (bdInstData) {
	                    if (RegExp(/[.|\[|\]]+/).test(attname)) {
	                        // 带层级赋值，catch避免中断
	                        try {
	                            eval("(bdInstData." + attname + " = value)");
	                        } catch (error) {
	                            _rtSdCommon.sgiLogger.error("\u4FEE\u6539\u7ED1\u5B9A\u5BF9\u8C61\u65F6\uFF0C\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D[" + attname + "]");
	                            _rtSdCommon.sgiLogger.eventErr(error);
	                        }
	                    } else {
	                        bdInstData[attname] = value;
	                    }
	                }
	            }
	        }
	
	        // 检查数据合法性
	
	    }, {
	        key: "validate",
	        value: function validate(value) {
	            if (!value) {
	                value = this.state.inputProps.value;
	            }
	            if (this.state.formItemProps.style.display == "none") {
	                this.setSuccess();
	                return false;
	            }
	            var validRules = this.state.validRules;
	            if (validRules.length === 0) {
	                this.setSuccess();
	                return false;
	            }
	
	            //var flag = true;
	            var msg = (0, _sgiFormCtlValidator.sgiFormCtlCheck)(validRules, value, { module: this, objFct: this.props.objFct });
	            if (Object.prototype.toString.call(msg) === "[object Object]") {
	                this.setValidate(msg.help, msg.validateStatus, msg.hasFeedback);
	            } else if (msg) {
	                this.setError(msg);
	            } else {
	                this.setSuccess();
	            }
	            return msg;
	        }
	    }, {
	        key: "setError",
	        value: function setError(msg) {
	            this.state.formItemProps.hasFeedback = true;
	            this.state.formItemProps.help = msg;
	            this.state.formItemProps.validateStatus = 'error';
	            this.setState(this.state.formItemProps);
	        }
	    }, {
	        key: "setSuccess",
	        value: function setSuccess() {
	            this.state.formItemProps.hasFeedback = false;
	            this.state.formItemProps.help = undefined;
	            this.state.formItemProps.validateStatus = 'success';
	            this.setState(this.state.formItemProps);
	        }
	        // 设置组件校验(对外接口)
	
	    }, {
	        key: "setValidate",
	        value: function setValidate(message, status, hasFeedback) {
	            this.state.formItemProps.help = message;
	            this.state.formItemProps.validateStatus = status;
	            this.state.formItemProps.hasFeedback = !!hasFeedback;
	            this.setState({});
	        }
	    }, {
	        key: "refresh",
	        value: function refresh() {
	            this.loaded = false;
	            this.setState({ loading: false });
	        }
	    }, {
	        key: "getIsLabel",
	        value: function getIsLabel() {
	            // isLabel
	            var isLabel = this.state.isLabel || this.state.formIsLabel;
	
	            // 标签和非标签特殊处理
	            var _state5 = this.state,
	                formItemProps = _state5.formItemProps,
	                validRules = _state5.validRules;
	            var _props$moduleDesc = this.props.moduleDesc,
	                moduleDesc = _props$moduleDesc === undefined ? {} : _props$moduleDesc;
	
	            if (isLabel) {
	                formItemProps.required = false;
	                validRules.required = false;
	            } else {
	                var alwBlk = moduleDesc.alwBlk; //是否允许为空
	                formItemProps.required = !alwBlk;
	                validRules.required = !alwBlk;
	            }
	
	            // 返回
	            return isLabel;
	        }
	    }, {
	        key: "getReviseProps",
	        value: function getReviseProps() {
	            var _state6 = this.state,
	                inputProps = _state6.inputProps,
	                formItemProps = _state6.formItemProps,
	                _formProps = _state6._formProps;
	
	            var isLabel = this.getIsLabel();
	            var reviseProps = {
	                _inputProps: {
	                    isLabel: isLabel,
	                    disabled: inputProps.disabled || inputProps.formDisabled,
	                    title: inputProps.value,
	                    className: inputProps.nowrap ? "sgiFormItemSpan" : undefined
	                },
	                _formItemProps: {
	                    colon: isLabel || _formProps.colon //冒号
	                }
	            };
	            return reviseProps;
	        }
	    }]);
	
	    return SgiFormCtlComponent;
	}(_SgiCtlComponent3.default);
	
	exports.default = SgiFormCtlComponent;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgiEChartsComponent2 = __webpack_require__(729);
	
	var _SgiEChartsComponent3 = _interopRequireDefault(_SgiEChartsComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiEChartsCommon = function (_SgiEChartsComponent) {
	  _inherits(SgiEChartsCommon, _SgiEChartsComponent);
	
	  function SgiEChartsCommon() {
	    _classCallCheck(this, SgiEChartsCommon);
	
	    return _possibleConstructorReturn(this, (SgiEChartsCommon.__proto__ || Object.getPrototypeOf(SgiEChartsCommon)).apply(this, arguments));
	  }
	
	  return SgiEChartsCommon;
	}(_SgiEChartsComponent3.default);
	
	exports.default = SgiEChartsCommon;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _echarts = __webpack_require__(8);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiComponent2 = __webpack_require__(204);
	
	var _SgiComponent3 = _interopRequireDefault(_SgiComponent2);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiEChartsComponent = function (_SgiComponent) {
	    _inherits(SgiEChartsComponent, _SgiComponent);
	
	    function SgiEChartsComponent(props) {
	        _classCallCheck(this, SgiEChartsComponent);
	
	        var _this = _possibleConstructorReturn(this, (SgiEChartsComponent.__proto__ || Object.getPrototypeOf(SgiEChartsComponent)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded) {
	                //组装属性
	                this._maker(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            this.reGetOption(objFct, type);
	
	            return _react2.default.createElement('div', _extends({ id: this.state.uuid }, this.state.echartsProps));
	        };
	
	        _this.state = _extends({}, _this.state, {
	            uuid: (0, _sgiCommon.uuidDate)(6, "yyyyMMddhhmmssSSS"),
	            data: _this.props.data || [],
	            echartsProps: { style: { width: "100%", height: "100%" } },
	            option: {},
	            originalOption: {},
	            getOption: function getOption() {
	                return { title: "" };
	            },
	            eventName: "", // 事件名称，全小写，例如'click'，'mousemove', 'legendselected'
	            query: "", // 可选的过滤条件，能够只在指定的组件或者元素上进行响应。可为 string 或者 Object。
	            // getOn: () => ({}),
	            functions: {},
	            chart: null,
	            reload: false
	        });
	        return _this;
	    }
	
	    _createClass(SgiEChartsComponent, [{
	        key: '_maker',
	        value: function _maker(parentModule, moduleDesc, objFct, type) {
	            _get(SgiEChartsComponent.prototype.__proto__ || Object.getPrototypeOf(SgiEChartsComponent.prototype), '_maker', this).call(this, parentModule, moduleDesc, objFct, type);
	
	            // 校验描述
	            if (!moduleDesc) {
	                return;
	            }
	
	            // 转换ctn公共属性
	            addCtnCommonAttribute(this, moduleDesc, this.state.echartsProps);
	            // 转换公共属性
	            this.addEchartsCommonAttribute(moduleDesc, this.state.echartsProps, this.state.option, parentModule, objFct, type);
	            // 转换各图表基础属性
	            this.AddAttribute(moduleDesc, this.state.echartsProps, this.state.option, parentModule, objFct, type);
	        }
	
	        /**
	         * 属性转换
	         * @param {object} moduleDesc 
	         * @param {object} echartsProps 
	         * @param {object} option 
	         * @param {object} parentModule 
	         * @param {ObjFactory} objFct 
	         * @param {string} type 
	         */
	
	    }, {
	        key: 'addEchartsCommonAttribute',
	        value: function addEchartsCommonAttribute(moduleDesc, echartsProps, option, parentModule, objFct, type) {
	            // 取data
	            var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
	            this.state.insName = bdInst;
	            if (bdInst && objFct) {
	                this.state.data = objFct.get(bdInst) || [];
	            }
	
	            // 自定义option
	            var getOption = moduleDesc.option;
	            var $getOption = void 0;
	            if (getOption) {
	                try {
	                    $getOption = new Function("module", "data", "objFct", getOption);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                this.state.getOption = $getOption;
	            }
	
	            // 鼠标事件相关
	            var eventName = moduleDesc.eventName;
	            this.state.eventName = eventName ? eventName : "click";
	            var query = moduleDesc.query;
	            if (query) {
	                try {
	                    this.state.query = JSON.parse(query);
	                } catch (error) {
	                    this.state.query = query;
	                }
	            }
	        }
	    }, {
	        key: 'refreshByData',
	        value: function refreshByData(data, reload) {
	            data = data || [];
	            this.setState({ data: data, reload: reload });
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }, {
	        key: 'reGetOption',
	        value: function reGetOption(objFct, type) {
	            var originalOption = this.state.originalOption || {};
	            this.state.option = originalOption;
	            if (type !== "dnd") {
	                var cstmOption = this.state.getOption(this, this.state.data, objFct);
	                this.state.option = merge((0, _sgiCommon.copy)(originalOption, true), cstmOption);
	            }
	        }
	    }, {
	        key: 'reSetOption',
	        value: function reSetOption() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                var chart = _echarts2.default.init(document.getElementById(_this2.state.uuid), _this2.props.moduleDesc.theme || "light");
	                var notMerge = false;
	                if (_this2.state.reload) {
	                    chart.clear();
	                    _this2.state.reload = false;
	                    notMerge = true;
	                }
	                chart.setOption(_this2.state.option, notMerge);
	                _this2.state.chart = chart;
	
	                //绑定事件
	                _this2.bindEvent(_this2.props.moduleDesc, chart, _this2.state.getOn, _this2.state.functions, _this2.props.type);
	            }, 0);
	        }
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, chart, getOn, functions, type) {
	            //拖拽模式 不生成事件
	            var getOn = moduleDesc.on; // 用户自定义点击事件
	            if (getOn && type != 'dnd') {
	                var $on;
	                try {
	                    $on = new Function("module", "data", "seriesName", "objFct", "params", getOn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	
	                functions.getOn = $on;
	            }
	            if (this.state.query) {
	                chart.on(this.state.eventName, this.state.query, _SgiEventHandler.SgiEventHandler.eChartsEvent.bind(this));
	            } else {
	                chart.on(this.state.eventName, _SgiEventHandler.SgiEventHandler.eChartsEvent.bind(this));
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.reSetOption();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.reSetOption();
	        }
	
	        // 子类实现各处理方法
	        // 添加各自属性
	
	    }, {
	        key: 'AddAttribute',
	        value: function AddAttribute() {}
	    }]);
	
	    return SgiEChartsComponent;
	}(_SgiComponent3.default);
	
	/**
	 * 属性合并
	 * @param {object} target 目标对象
	 * @param {object} source 源对象
	 */
	
	
	exports.default = SgiEChartsComponent;
	function merge(target, source) {
	    // 目标和源相同，直接返回
	    if (target === source) return target;
	    // 分情况处理
	    if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
	        for (var key in source) {
	            if (target[key] === source[key]) continue; //相同，跳过
	            if (!target[key]) target[key] = source[key]; //target属性不存在，直接赋值
	            else target[key] = merge(target[key], source[key]); //target属性存在，合并
	        }
	    } else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
	        for (var i = 0; i < source.length; i++) {
	            if (target[i] === source[i]) continue; //相同，跳过
	            if (!target[i]) target.push(source[i]); //target元素不存在，直接添加
	            else target[i] = merge(target[i], source[i]); //target元素存在，合并
	        }
	    } else {
	        //其他情况，直接赋值
	        target = source;
	    }
	    // 返回target
	    return target;
	}
	
	/**
	 * 转换ctn公共属性（不参与继承，所以放外面）
	 * @param {object} currentModule 当前module
	 * @param {object} moduleDesc json描述
	 * @param {object} ctnWrapProps ctn容器属性
	 * @param {object} ctnHeadProps ctnhead属性
	 * @param {object} ctnBodyProps ctnbody属性
	 */
	function addCtnCommonAttribute(currentModule, moduleDesc, ctnWrapProps, ctnHeadProps, ctnBodyProps) {
	    var cId = (0, _SgiCommon.getConstByKey)(currentModule, moduleDesc.cId); //cid 唯一标示
	    if (cId) {
	        ctnWrapProps.id = cId;
	        currentModule.state.uuid = cId;
	    }
	
	    var ctlW = moduleDesc.ctlW; //容器宽度
	    ctnWrapProps.style.width = ctlW;
	    if (ctlW == 0 || ctlW == '0px') {
	        ctnWrapProps.style.width = undefined;
	    }
	
	    var ctlH = moduleDesc.ctlH; //容器高度
	    ctnWrapProps.style.height = ctlH;
	    if (ctlH == 0 || ctlH == '0px') {
	        ctnWrapProps.style.height = undefined;
	    }
	
	    var isBrdr = moduleDesc.isBrdr; //容器是否有边框??没实现
	    if (isBrdr) {
	        ctnWrapProps.style.border = "1px solid rgb(217, 217, 217)"; /*边线宽度 类型 颜色*/;
	    } else {
	        ctnWrapProps.style.border = undefined;
	    }
	
	    var mgn = moduleDesc.mgn; //容器外边距
	    if (mgn) ctnWrapProps.style.margin = mgn;
	    var pad = moduleDesc.pad; //容器内边距
	    if (pad) ctnWrapProps.style.padding = pad;
	
	    var isHdn = moduleDesc.isHdn; //容器是否隐藏
	    if (isHdn) {
	        ctnWrapProps.style.display = "none";
	    } else {
	        ctnWrapProps.style.display = undefined;
	    }
	
	    var isScl = moduleDesc.isScl; //容器是否可以滚动
	    if (isScl) {
	        if (!ctnBodyProps) ctnWrapProps.style.overflow = "auto";
	        if (ctnBodyProps) ctnBodyProps.style.overflow = "auto";
	    } else {
	        if (!ctnBodyProps) ctnWrapProps.style.overflow = undefined;
	        if (ctnBodyProps) ctnBodyProps.style.overflow = undefined;
	    }
	
	    //公共属性里统一进行文本资源转换，各个控件可直接从ctnProps.te中取出结果，不再需要单独转换
	    // if (moduleDesc.te || moduleDesc.teid) {//如果te和teid都不存在则不查找资源
	    //     var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
	    //     if (te) ctnProps.te = te;
	    // }
	    var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
	    ctnWrapProps.te = te;
	
	    // 初始加载中
	    currentModule.state.loading = !!moduleDesc.loading;
	
	    // 自定义样式
	    var cstmStyle = moduleDesc.cstmStyle;
	    var $cstmStyle = void 0;
	    if (cstmStyle) {
	        try {
	            $cstmStyle = new Function("module", "objFct", cstmStyle);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        // currentModule.state.cstmStyle = $cstmStyle;
	        (0, _SgiCommon.setFunction)(currentModule, "cstmStyle", $cstmStyle);
	    }
	}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PresetColorTypes = void 0;
	
	var _type = __webpack_require__(83);
	
	// eslint-disable-next-line import/prefer-default-export
	var PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
	exports.PresetColorTypes = PresetColorTypes;

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getDataOrAriaProps;
	
	function getDataOrAriaProps(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
	      prev[key] = props[key];
	    }
	
	    return prev;
	  }, {});
	}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	// ================== Collapse Motion ==================
	var getCollapsedHeight = function getCollapsedHeight() {
	  return {
	    height: 0,
	    opacity: 0
	  };
	};
	
	var getRealHeight = function getRealHeight(node) {
	  return {
	    height: node.scrollHeight,
	    opacity: 1
	  };
	};
	
	var getCurrentHeight = function getCurrentHeight(node) {
	  return {
	    height: node.offsetHeight
	  };
	};
	
	var collapseMotion = {
	  motionName: 'ant-motion-collapse',
	  onAppearStart: getCollapsedHeight,
	  onEnterStart: getCollapsedHeight,
	  onAppearActive: getRealHeight,
	  onEnterActive: getRealHeight,
	  onLeaveStart: getCurrentHeight,
	  onLeaveActive: getCollapsedHeight
	};
	var _default = collapseMotion;
	exports["default"] = _default;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cloneElement = cloneElement;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	// eslint-disable-next-line import/prefer-default-export
	function cloneElement(element) {
	  if (! /*#__PURE__*/React.isValidElement(element)) return element;
	
	  for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    restArgs[_key - 1] = arguments[_key];
	  }
	
	  return React.cloneElement.apply(React, [element].concat(restArgs));
	}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.responsiveMap = exports.responsiveArray = void 0;
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	var enquire; // TODO: Will be removed in antd 4.0 because we will no longer support ie9
	
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill; // eslint-disable-next-line global-require
	
	  enquire = __webpack_require__(496);
	}
	
	var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
	exports.responsiveArray = responsiveArray;
	var responsiveMap = {
	  xs: '(max-width: 575px)',
	  sm: '(min-width: 576px)',
	  md: '(min-width: 768px)',
	  lg: '(min-width: 992px)',
	  xl: '(min-width: 1200px)',
	  xxl: '(min-width: 1600px)'
	};
	exports.responsiveMap = responsiveMap;
	var subscribers = [];
	var subUid = -1;
	var screens = {};
	var responsiveObserve = {
	  dispatch: function dispatch(pointMap) {
	    screens = pointMap;
	
	    if (subscribers.length < 1) {
	      return false;
	    }
	
	    subscribers.forEach(function (item) {
	      item.func(screens);
	    });
	    return true;
	  },
	  subscribe: function subscribe(func) {
	    if (subscribers.length === 0) {
	      this.register();
	    }
	
	    var token = (++subUid).toString();
	    subscribers.push({
	      token: token,
	      func: func
	    });
	    func(screens);
	    return token;
	  },
	  unsubscribe: function unsubscribe(token) {
	    subscribers = subscribers.filter(function (item) {
	      return item.token !== token;
	    });
	
	    if (subscribers.length === 0) {
	      this.unregister();
	    }
	  },
	  unregister: function unregister() {
	    Object.keys(responsiveMap).map(function (screen) {
	      return enquire.unregister(responsiveMap[screen]);
	    });
	  },
	  register: function register() {
	    var _this = this;
	
	    Object.keys(responsiveMap).map(function (screen) {
	      return enquire.register(responsiveMap[screen], {
	        match: function match() {
	          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, true));
	
	          _this.dispatch(pointMap);
	        },
	        unmatch: function unmatch() {
	          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, false));
	
	          _this.dispatch(pointMap);
	        },
	        // Keep a empty destory to avoid triggering unmatch when unregister
	        destroy: function destroy() {}
	      });
	    });
	  }
	};
	var _default = responsiveObserve;
	exports["default"] = _default;

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.isFlexSupported = void 0;
	
	var isStyleSupport = function isStyleSupport(styleName) {
	  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
	    var documentElement = window.document.documentElement;
	    return styleNameList.some(function (name) {
	      return name in documentElement.style;
	    });
	  }
	
	  return false;
	};
	
	var isFlexSupported = isStyleSupport(['flex', 'webkitFlex', 'Flex', 'msFlex']);
	exports.isFlexSupported = isFlexSupported;
	var _default = isStyleSupport;
	exports["default"] = _default;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _configProvider = __webpack_require__(15);
	
	var _throttleByAnimationFrame = __webpack_require__(1354);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _utils = __webpack_require__(1356);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
	  var c = arguments.length,
	      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	      d;
	  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	  }
	  return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	function getDefaultTarget() {
	  return typeof window !== 'undefined' ? window : null;
	}
	
	var AffixStatus;
	
	(function (AffixStatus) {
	  AffixStatus[AffixStatus["None"] = 0] = "None";
	  AffixStatus[AffixStatus["Prepare"] = 1] = "Prepare";
	})(AffixStatus || (AffixStatus = {}));
	
	var Affix = /*#__PURE__*/function (_React$Component) {
	  _inherits(Affix, _React$Component);
	
	  var _super = _createSuper(Affix);
	
	  function Affix() {
	    var _this;
	
	    _classCallCheck(this, Affix);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      status: AffixStatus.None,
	      lastAffix: false,
	      prevTarget: null
	    };
	
	    _this.getOffsetTop = function () {
	      var _this$props = _this.props,
	          offset = _this$props.offset,
	          offsetBottom = _this$props.offsetBottom;
	      var offsetTop = _this.props.offsetTop;
	
	      if (typeof offsetTop === 'undefined') {
	        offsetTop = offset;
	        (0, _warning["default"])(typeof offset === 'undefined', 'Affix', '`offset` is deprecated. Please use `offsetTop` instead.');
	      }
	
	      if (offsetBottom === undefined && offsetTop === undefined) {
	        offsetTop = 0;
	      }
	
	      return offsetTop;
	    };
	
	    _this.getOffsetBottom = function () {
	      return _this.props.offsetBottom;
	    };
	
	    _this.savePlaceholderNode = function (node) {
	      _this.placeholderNode = node;
	    };
	
	    _this.saveFixedNode = function (node) {
	      _this.fixedNode = node;
	    }; // =================== Measure ===================
	
	
	    _this.measure = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          lastAffix = _this$state.lastAffix;
	      var _this$props2 = _this.props,
	          target = _this$props2.target,
	          onChange = _this$props2.onChange;
	
	      if (status !== AffixStatus.Prepare || !_this.fixedNode || !_this.placeholderNode || !target) {
	        return;
	      }
	
	      var offsetTop = _this.getOffsetTop();
	
	      var offsetBottom = _this.getOffsetBottom();
	
	      var targetNode = target();
	
	      if (!targetNode) {
	        return;
	      }
	
	      var newState = {
	        status: AffixStatus.None
	      };
	      var targetRect = (0, _utils.getTargetRect)(targetNode);
	      var placeholderReact = (0, _utils.getTargetRect)(_this.placeholderNode);
	      var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
	      var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);
	
	      if (fixedTop !== undefined) {
	        newState.affixStyle = {
	          position: 'fixed',
	          top: fixedTop,
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	        newState.placeholderStyle = {
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	      } else if (fixedBottom !== undefined) {
	        newState.affixStyle = {
	          position: 'fixed',
	          bottom: fixedBottom,
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	        newState.placeholderStyle = {
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	      }
	
	      newState.lastAffix = !!newState.affixStyle;
	
	      if (onChange && lastAffix !== newState.lastAffix) {
	        onChange(newState.lastAffix);
	      }
	
	      _this.setState(newState);
	    }; // @ts-ignore TS6133
	
	
	    _this.prepareMeasure = function () {
	      // event param is used before. Keep compatible ts define here.
	      _this.setState({
	        status: AffixStatus.Prepare,
	        affixStyle: undefined,
	        placeholderStyle: undefined
	      }); // Test if `updatePosition` called
	
	
	      if (false) {
	        var onTestUpdatePosition = _this.props.onTestUpdatePosition;
	
	        if (onTestUpdatePosition) {
	          onTestUpdatePosition();
	        }
	      }
	    }; // =================== Render ===================
	
	
	    _this.renderAffix = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$state2 = _this.state,
	          affixStyle = _this$state2.affixStyle,
	          placeholderStyle = _this$state2.placeholderStyle;
	      var _this$props3 = _this.props,
	          prefixCls = _this$props3.prefixCls,
	          children = _this$props3.children;
	      var className = (0, _classnames["default"])(_defineProperty({}, getPrefixCls('affix', prefixCls), affixStyle));
	      var props = (0, _omit["default"])(_this.props, ['prefixCls', 'offsetTop', 'offsetBottom', 'target', 'onChange']); // Omit this since `onTestUpdatePosition` only works on test.
	
	      if (false) {
	        props = (0, _omit["default"])(props, ['onTestUpdatePosition']);
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: function onResize() {
	            _this.updatePosition();
	          }
	        }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
	          ref: _this.savePlaceholderNode
	        }), affixStyle && /*#__PURE__*/React.createElement("div", {
	          style: placeholderStyle,
	          "aria-hidden": "true"
	        }), /*#__PURE__*/React.createElement("div", {
	          className: className,
	          ref: _this.saveFixedNode,
	          style: affixStyle
	        }, /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: function onResize() {
	            _this.updatePosition();
	          }
	        }, children))))
	      );
	    };
	
	    return _this;
	  } // Event handler
	
	
	  _createClass(Affix, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var target = this.props.target;
	
	      if (target) {
	        // [Legacy] Wait for parent component ref has its value.
	        // We should use target as directly element instead of function which makes element check hard.
	        this.timeout = setTimeout(function () {
	          (0, _utils.addObserveTarget)(target(), _this2); // Mock Event object.
	
	          _this2.updatePosition();
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var prevTarget = this.state.prevTarget;
	      var target = this.props.target;
	      var newTarget = null;
	
	      if (target) {
	        newTarget = target() || null;
	      }
	
	      if (prevTarget !== newTarget) {
	        (0, _utils.removeObserveTarget)(this);
	
	        if (newTarget) {
	          (0, _utils.addObserveTarget)(newTarget, this); // Mock Event object.
	
	          this.updatePosition();
	        }
	
	        this.setState({
	          prevTarget: newTarget
	        });
	      }
	
	      if (prevProps.offsetTop !== this.props.offsetTop || prevProps.offsetBottom !== this.props.offsetBottom) {
	        this.updatePosition();
	      }
	
	      this.measure();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	      (0, _utils.removeObserveTarget)(this);
	      this.updatePosition.cancel(); // https://github.com/ant-design/ant-design/issues/22683
	
	      this.lazyUpdatePosition.cancel();
	    } // Handle realign logic
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      this.prepareMeasure();
	    }
	  }, {
	    key: "lazyUpdatePosition",
	    value: function lazyUpdatePosition() {
	      var target = this.props.target;
	      var affixStyle = this.state.affixStyle; // Check position change before measure to make Safari smooth
	
	      if (target && affixStyle) {
	        var offsetTop = this.getOffsetTop();
	        var offsetBottom = this.getOffsetBottom();
	        var targetNode = target();
	
	        if (targetNode && this.placeholderNode) {
	          var targetRect = (0, _utils.getTargetRect)(targetNode);
	          var placeholderReact = (0, _utils.getTargetRect)(this.placeholderNode);
	          var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
	          var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);
	
	          if (fixedTop !== undefined && affixStyle.top === fixedTop || fixedBottom !== undefined && affixStyle.bottom === fixedBottom) {
	            return;
	          }
	        }
	      } // Directly call prepare measure since it's already throttled.
	
	
	      this.prepareMeasure();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAffix)
	      );
	    }
	  }]);
	
	  return Affix;
	}(React.Component);
	
	Affix.defaultProps = {
	  target: getDefaultTarget
	};
	
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "updatePosition", null);
	
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "lazyUpdatePosition", null);
	
	(0, _reactLifecyclesCompat.polyfill)(Affix);
	var _default = Affix;
	exports["default"] = _default;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Avatar = /*#__PURE__*/function (_React$Component) {
	  _inherits(Avatar, _React$Component);
	
	  var _super = _createSuper(Avatar);
	
	  function Avatar() {
	    var _this;
	
	    _classCallCheck(this, Avatar);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      scale: 1,
	      mounted: false,
	      isImgExist: true
	    };
	
	    _this.setScale = function () {
	      if (!_this.avatarChildren || !_this.avatarNode) {
	        return;
	      }
	
	      var childrenWidth = _this.avatarChildren.offsetWidth; // offsetWidth avoid affecting be transform scale
	
	      var nodeWidth = _this.avatarNode.offsetWidth; // denominator is 0 is no meaning
	
	      if (childrenWidth === 0 || nodeWidth === 0 || _this.lastChildrenWidth === childrenWidth && _this.lastNodeWidth === nodeWidth) {
	        return;
	      }
	
	      _this.lastChildrenWidth = childrenWidth;
	      _this.lastNodeWidth = nodeWidth; // add 4px gap for each side to get better performance
	
	      _this.setState({
	        scale: nodeWidth - 8 < childrenWidth ? (nodeWidth - 8) / childrenWidth : 1
	      });
	    };
	
	    _this.handleImgLoadError = function () {
	      var onError = _this.props.onError;
	      var errorFlag = onError ? onError() : undefined;
	
	      if (errorFlag !== false) {
	        _this.setState({
	          isImgExist: false
	        });
	      }
	    };
	
	    _this.renderAvatar = function (_ref) {
	      var _classNames, _classNames2;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          shape = _a.shape,
	          size = _a.size,
	          src = _a.src,
	          srcSet = _a.srcSet,
	          icon = _a.icon,
	          className = _a.className,
	          alt = _a.alt,
	          others = __rest(_a, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "alt"]);
	
	      var _this$state = _this.state,
	          isImgExist = _this$state.isImgExist,
	          scale = _this$state.scale,
	          mounted = _this$state.mounted;
	      var prefixCls = getPrefixCls('avatar', customizePrefixCls);
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
	      var classString = (0, _classnames["default"])(prefixCls, className, sizeCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames2, "".concat(prefixCls, "-image"), src && isImgExist), _defineProperty(_classNames2, "".concat(prefixCls, "-icon"), icon), _classNames2));
	      var sizeStyle = typeof size === 'number' ? {
	        width: size,
	        height: size,
	        lineHeight: "".concat(size, "px"),
	        fontSize: icon ? size / 2 : 18
	      } : {};
	      var children = _this.props.children;
	
	      if (src && isImgExist) {
	        children = /*#__PURE__*/React.createElement("img", {
	          src: src,
	          srcSet: srcSet,
	          onError: _this.handleImgLoadError,
	          alt: alt
	        });
	      } else if (icon) {
	        if (typeof icon === 'string') {
	          children = /*#__PURE__*/React.createElement(_icon["default"], {
	            type: icon
	          });
	        } else {
	          children = icon;
	        }
	      } else {
	        var childrenNode = _this.avatarChildren;
	
	        if (childrenNode || scale !== 1) {
	          var transformString = "scale(".concat(scale, ") translateX(-50%)");
	          var childrenStyle = {
	            msTransform: transformString,
	            WebkitTransform: transformString,
	            transform: transformString
	          };
	          var sizeChildrenStyle = typeof size === 'number' ? {
	            lineHeight: "".concat(size, "px")
	          } : {};
	          children = /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-string"),
	            ref: function ref(node) {
	              return _this.avatarChildren = node;
	            },
	            style: _extends(_extends({}, sizeChildrenStyle), childrenStyle)
	          }, children);
	        } else {
	          var _childrenStyle = {};
	
	          if (!mounted) {
	            _childrenStyle.opacity = 0;
	          }
	
	          children = /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-string"),
	            style: {
	              opacity: 0
	            },
	            ref: function ref(node) {
	              return _this.avatarChildren = node;
	            }
	          }, children);
	        }
	      }
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, others, {
	          style: _extends(_extends({}, sizeStyle), others.style),
	          className: classString,
	          ref: function ref(node) {
	            return _this.avatarNode = node;
	          }
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Avatar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setScale();
	      this.setState({
	        mounted: true
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.setScale();
	
	      if (prevProps.src !== this.props.src) {
	        this.setState({
	          isImgExist: true,
	          scale: 1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAvatar)
	      );
	    }
	  }]);
	
	  return Avatar;
	}(React.Component);
	
	exports["default"] = Avatar;
	Avatar.defaultProps = {
	  shape: 'circle',
	  size: 'default'
	};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(378));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var BreadcrumbItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(BreadcrumbItem, _React$Component);
	
	  var _super = _createSuper(BreadcrumbItem);
	
	  function BreadcrumbItem() {
	    var _this;
	
	    _classCallCheck(this, BreadcrumbItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderBreadcrumbItem = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          separator = _a.separator,
	          children = _a.children,
	          restProps = __rest(_a, ["prefixCls", "separator", "children"]);
	
	      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
	      var link;
	
	      if ('href' in _this.props) {
	        link = /*#__PURE__*/React.createElement("a", _extends({
	          className: "".concat(prefixCls, "-link")
	        }, (0, _omit["default"])(restProps, ['overlay'])), children);
	      } else {
	        link = /*#__PURE__*/React.createElement("span", _extends({
	          className: "".concat(prefixCls, "-link")
	        }, (0, _omit["default"])(restProps, ['overlay'])), children);
	      } // wrap to dropDown
	
	
	      link = _this.renderBreadcrumbNode(link, prefixCls);
	
	      if (children) {
	        return (/*#__PURE__*/React.createElement("span", null, link, separator && separator !== '' && /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-separator")
	          }, separator))
	        );
	      }
	
	      return null;
	    };
	    /**
	     * if overlay is have
	     * Wrap a DropDown
	     */
	
	    _this.renderBreadcrumbNode = function (breadcrumbItem, prefixCls) {
	      var overlay = _this.props.overlay;
	
	      if (overlay) {
	        return (/*#__PURE__*/React.createElement(_dropdown["default"], {
	            overlay: overlay,
	            placement: "bottomCenter"
	          }, /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-overlay-link")
	          }, breadcrumbItem, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "down"
	          })))
	        );
	      }
	
	      return breadcrumbItem;
	    };
	
	    return _this;
	  }
	
	  _createClass(BreadcrumbItem, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumbItem)
	      );
	    }
	  }]);
	
	  return BreadcrumbItem;
	}(React.Component);
	
	exports["default"] = BreadcrumbItem;
	BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
	BreadcrumbItem.defaultProps = {
	  separator: '/'
	};
	BreadcrumbItem.propTypes = {
	  prefixCls: PropTypes.string,
	  separator: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	  href: PropTypes.string
	};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Breadcrumb = _interopRequireDefault(__webpack_require__(1366));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(738));
	
	var _BreadcrumbSeparator = _interopRequireDefault(__webpack_require__(1367));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Breadcrumb["default"].Item = _BreadcrumbItem["default"];
	_Breadcrumb["default"].Separator = _BreadcrumbSeparator["default"];
	var _default = _Breadcrumb["default"];
	exports["default"] = _default;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(377));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _en_US["default"];
	exports["default"] = _default;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(187));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Checkbox = /*#__PURE__*/function (_React$Component) {
	  _inherits(Checkbox, _React$Component);
	
	  var _super = _createSuper(Checkbox);
	
	  function Checkbox() {
	    var _this;
	
	    _classCallCheck(this, Checkbox);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.renderCheckbox = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          indeterminate = props.indeterminate,
	          style = props.style,
	          onMouseEnter = props.onMouseEnter,
	          onMouseLeave = props.onMouseLeave,
	          restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);
	
	      var checkboxGroup = context.checkboxGroup;
	      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
	
	      var checkboxProps = _extends({}, restProps);
	
	      if (checkboxGroup) {
	        checkboxProps.onChange = function () {
	          if (restProps.onChange) {
	            restProps.onChange.apply(restProps, arguments);
	          }
	
	          checkboxGroup.toggleOption({
	            label: children,
	            value: props.value
	          });
	        };
	
	        checkboxProps.name = checkboxGroup.name;
	        checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
	        checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
	      }
	
	      var classString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames));
	      var checkboxClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: classString,
	          style: style,
	          onMouseEnter: onMouseEnter,
	          onMouseLeave: onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, checkboxProps, {
	          prefixCls: prefixCls,
	          className: checkboxClass,
	          ref: _this.saveCheckbox
	        })), children !== undefined && /*#__PURE__*/React.createElement("span", null, children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Checkbox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var value = this.props.value;
	
	      var _ref2 = this.context || {},
	          _ref2$checkboxGroup = _ref2.checkboxGroup,
	          checkboxGroup = _ref2$checkboxGroup === void 0 ? {} : _ref2$checkboxGroup;
	
	      if (checkboxGroup.registerValue) {
	        checkboxGroup.registerValue(value);
	      }
	
	      (0, _warning["default"])('checked' in this.props || (this.context || {}).checkboxGroup || !('value' in this.props), 'Checkbox', '`value` is not validate prop, do you mean `checked`?');
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.checkboxGroup, nextContext.checkboxGroup);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref3) {
	      var prevValue = _ref3.value;
	      var value = this.props.value;
	
	      var _ref4 = this.context || {},
	          _ref4$checkboxGroup = _ref4.checkboxGroup,
	          checkboxGroup = _ref4$checkboxGroup === void 0 ? {} : _ref4$checkboxGroup;
	
	      if (value !== prevValue && checkboxGroup.registerValue && checkboxGroup.cancelValue) {
	        checkboxGroup.cancelValue(prevValue);
	        checkboxGroup.registerValue(value);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var value = this.props.value;
	
	      var _ref5 = this.context || {},
	          _ref5$checkboxGroup = _ref5.checkboxGroup,
	          checkboxGroup = _ref5$checkboxGroup === void 0 ? {} : _ref5$checkboxGroup;
	
	      if (checkboxGroup.cancelValue) {
	        checkboxGroup.cancelValue(value);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckbox)
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(React.Component);
	
	Checkbox.__ANT_CHECKBOX = true;
	Checkbox.defaultProps = {
	  indeterminate: false
	};
	Checkbox.contextTypes = {
	  checkboxGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(Checkbox);
	var _default = Checkbox;
	exports["default"] = _default;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _grid = __webpack_require__(256);
	
	var _default = _grid.Col;
	exports["default"] = _default;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = InputIcon;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function InputIcon(props) {
	  var _classNames;
	
	  var suffixIcon = props.suffixIcon,
	      prefixCls = props.prefixCls;
	  return suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	    className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames, "".concat(prefixCls, "-picker-icon"), true), _classNames))
	  }) : /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-picker-icon")
	  }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "calendar",
	    className: "".concat(prefixCls, "-picker-icon")
	  });
	}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDate = formatDate;
	
	// eslint-disable-next-line import/prefer-default-export
	function formatDate(value, format) {
	  if (!value) {
	    return '';
	  }
	
	  if (Array.isArray(format)) {
	    format = format[0];
	  }
	
	  return value.format(format);
	}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _empty = _interopRequireDefault(__webpack_require__(1393));
	
	var _simple = _interopRequireDefault(__webpack_require__(1394));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var defaultEmptyImg = /*#__PURE__*/React.createElement(_empty["default"], null);
	var simpleEmptyImg = /*#__PURE__*/React.createElement(_simple["default"], null);
	
	var Empty = function Empty(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var className = props.className,
	          customizePrefixCls = props.prefixCls,
	          _props$image = props.image,
	          image = _props$image === void 0 ? defaultEmptyImg : _props$image,
	          description = props.description,
	          children = props.children,
	          imageStyle = props.imageStyle,
	          restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);
	
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Empty"
	        }, function (locale) {
	          var prefixCls = getPrefixCls('empty', customizePrefixCls);
	          var des = typeof description !== 'undefined' ? description : locale.description;
	          var alt = typeof des === 'string' ? des : 'empty';
	          var imageNode = null;
	
	          if (typeof image === 'string') {
	            imageNode = /*#__PURE__*/React.createElement("img", {
	              alt: alt,
	              src: image
	            });
	          } else {
	            imageNode = image;
	          }
	
	          return (/*#__PURE__*/React.createElement("div", _extends({
	              className: (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), className)
	            }, restProps), /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-image"),
	              style: imageStyle
	            }, imageNode), des && /*#__PURE__*/React.createElement("p", {
	              className: "".concat(prefixCls, "-description")
	            }, des), children && /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-footer")
	            }, children))
	          );
	        })
	      );
	    })
	  );
	};
	
	Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
	Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
	var _default = Empty;
	exports["default"] = _default;

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FIELD_DATA_PROP = exports.FIELD_META_PROP = void 0;
	var FIELD_META_PROP = 'data-__meta';
	exports.FIELD_META_PROP = FIELD_META_PROP;
	var FIELD_DATA_PROP = 'data-__field';
	exports.FIELD_DATA_PROP = FIELD_DATA_PROP;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var FormContext = (0, _createReactContext["default"])({
	  labelAlign: 'right',
	  vertical: false
	});
	var _default = FormContext;
	exports["default"] = _default;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var RowContext = (0, _createReactContext["default"])({});
	var _default = RowContext;
	exports["default"] = _default;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _RowContext = _interopRequireDefault(__webpack_require__(748));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);
	
	var Col = /*#__PURE__*/function (_React$Component) {
	  _inherits(Col, _React$Component);
	
	  var _super = _createSuper(Col);
	
	  function Col() {
	    var _this;
	
	    _classCallCheck(this, Col);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderCol = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          span = props.span,
	          order = props.order,
	          offset = props.offset,
	          push = props.push,
	          pull = props.pull,
	          className = props.className,
	          children = props.children,
	          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);
	
	      var prefixCls = getPrefixCls('col', customizePrefixCls);
	      var sizeClassObj = {};
	      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
	        var _extends2;
	
	        var sizeProps = {};
	        var propSize = props[size];
	
	        if (typeof propSize === 'number') {
	          sizeProps.span = propSize;
	        } else if (_typeof(propSize) === 'object') {
	          sizeProps = propSize || {};
	        }
	
	        delete others[size];
	        sizeClassObj = _extends(_extends({}, sizeClassObj), (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
	      });
	      var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
	      return (/*#__PURE__*/React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
	          var gutter = _ref2.gutter;
	          var style = others.style;
	
	          if (gutter) {
	            style = _extends(_extends(_extends({}, gutter[0] > 0 ? {
	              paddingLeft: gutter[0] / 2,
	              paddingRight: gutter[0] / 2
	            } : {}), gutter[1] > 0 ? {
	              paddingTop: gutter[1] / 2,
	              paddingBottom: gutter[1] / 2
	            } : {}), style);
	          }
	
	          return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	              style: style,
	              className: classes
	            }), children)
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Col, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCol)
	      );
	    }
	  }]);
	
	  return Col;
	}(React.Component);
	
	exports["default"] = Col;
	Col.propTypes = {
	  span: PropTypes.number,
	  order: PropTypes.number,
	  offset: PropTypes.number,
	  push: PropTypes.number,
	  pull: PropTypes.number,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  xs: objectOrNumber,
	  sm: objectOrNumber,
	  md: objectOrNumber,
	  lg: objectOrNumber,
	  xl: objectOrNumber,
	  xxl: objectOrNumber
	};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _configProvider = __webpack_require__(15);
	
	var _RowContext = _interopRequireDefault(__webpack_require__(748));
	
	var _type = __webpack_require__(83);
	
	var _responsiveObserve = _interopRequireWildcard(__webpack_require__(734));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom', 'stretch');
	var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');
	
	var Row = /*#__PURE__*/function (_React$Component) {
	  _inherits(Row, _React$Component);
	
	  var _super = _createSuper(Row);
	
	  function Row() {
	    var _this;
	
	    _classCallCheck(this, Row);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      screens: {}
	    };
	
	    _this.renderRow = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          justify = _a.justify,
	          align = _a.align,
	          className = _a.className,
	          style = _a.style,
	          children = _a.children,
	          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);
	
	      var prefixCls = getPrefixCls('row', customizePrefixCls);
	
	      var gutter = _this.getGutter();
	
	      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);
	
	      var rowStyle = _extends(_extends(_extends({}, gutter[0] > 0 ? {
	        marginLeft: gutter[0] / -2,
	        marginRight: gutter[0] / -2
	      } : {}), gutter[1] > 0 ? {
	        marginTop: gutter[1] / -2,
	        marginBottom: gutter[1] / -2
	      } : {}), style);
	
	      var otherProps = _extends({}, others);
	
	      delete otherProps.gutter;
	      return (/*#__PURE__*/React.createElement(_RowContext["default"].Provider, {
	          value: {
	            gutter: gutter
	          }
	        }, /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
	          className: classes,
	          style: rowStyle
	        }), children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Row, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.token = _responsiveObserve["default"].subscribe(function (screens) {
	        var gutter = _this2.props.gutter;
	
	        if (_typeof(gutter) === 'object' || Array.isArray(gutter) && (_typeof(gutter[0]) === 'object' || _typeof(gutter[1]) === 'object')) {
	          _this2.setState({
	            screens: screens
	          });
	        }
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _responsiveObserve["default"].unsubscribe(this.token);
	    }
	  }, {
	    key: "getGutter",
	    value: function getGutter() {
	      var results = [0, 0];
	      var gutter = this.props.gutter;
	      var screens = this.state.screens;
	      var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
	      normalizedGutter.forEach(function (g, index) {
	        if (_typeof(g) === 'object') {
	          for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
	            var breakpoint = _responsiveObserve.responsiveArray[i];
	
	            if (screens[breakpoint] && g[breakpoint] !== undefined) {
	              results[index] = g[breakpoint];
	              break;
	            }
	          }
	        } else {
	          results[index] = g || 0;
	        }
	      });
	      return results;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRow)
	      );
	    }
	  }]);
	
	  return Row;
	}(React.Component);
	
	exports["default"] = Row;
	Row.defaultProps = {
	  gutter: 0
	};
	Row.propTypes = {
	  type: PropTypes.oneOf(['flex']),
	  align: PropTypes.oneOf(RowAligns),
	  justify: PropTypes.oneOf(RowJustify),
	  className: PropTypes.string,
	  children: PropTypes.node,
	  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
	  prefixCls: PropTypes.string
	};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasPrefixSuffix = hasPrefixSuffix;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _type = __webpack_require__(83);
	
	var _Input = __webpack_require__(207);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ClearableInputType = (0, _type.tuple)('text', 'input');
	
	function hasPrefixSuffix(props) {
	  return !!(props.prefix || props.suffix || props.allowClear);
	}
	
	var ClearableLabeledInput = /*#__PURE__*/function (_React$Component) {
	  _inherits(ClearableLabeledInput, _React$Component);
	
	  var _super = _createSuper(ClearableLabeledInput);
	
	  function ClearableLabeledInput() {
	    _classCallCheck(this, ClearableLabeledInput);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ClearableLabeledInput, [{
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var _this$props = this.props,
	          allowClear = _this$props.allowClear,
	          value = _this$props.value,
	          disabled = _this$props.disabled,
	          readOnly = _this$props.readOnly,
	          inputType = _this$props.inputType,
	          handleReset = _this$props.handleReset;
	
	      if (!allowClear || disabled || readOnly || value === undefined || value === null || value === '') {
	        return null;
	      }
	
	      var className = inputType === ClearableInputType[0] ? "".concat(prefixCls, "-textarea-clear-icon") : "".concat(prefixCls, "-clear-icon");
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          theme: "filled",
	          onClick: handleReset,
	          className: className,
	          role: "button"
	        })
	      );
	    }
	  }, {
	    key: "renderSuffix",
	    value: function renderSuffix(prefixCls) {
	      var _this$props2 = this.props,
	          suffix = _this$props2.suffix,
	          allowClear = _this$props2.allowClear;
	
	      if (suffix || allowClear) {
	        return (/*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-suffix")
	          }, this.renderClearIcon(prefixCls), suffix)
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderLabeledIcon",
	    value: function renderLabeledIcon(prefixCls, element) {
	      var _classNames;
	
	      var props = this.props;
	      var suffix = this.renderSuffix(prefixCls);
	
	      if (!hasPrefixSuffix(props)) {
	        return (/*#__PURE__*/React.cloneElement(element, {
	            value: props.value
	          })
	        );
	      }
	
	      var prefix = props.prefix ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-prefix")
	      }, props.prefix) : null;
	      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), props.suffix && props.allowClear && this.props.value), _classNames));
	      return (/*#__PURE__*/React.createElement("span", {
	          className: affixWrapperCls,
	          style: props.style
	        }, prefix, /*#__PURE__*/React.cloneElement(element, {
	          style: null,
	          value: props.value,
	          className: (0, _Input.getInputClassName)(prefixCls, props.size, props.disabled)
	        }), suffix)
	      );
	    }
	  }, {
	    key: "renderInputWithLabel",
	    value: function renderInputWithLabel(prefixCls, labeledElement) {
	      var _classNames3;
	
	      var _this$props3 = this.props,
	          addonBefore = _this$props3.addonBefore,
	          addonAfter = _this$props3.addonAfter,
	          style = _this$props3.style,
	          size = _this$props3.size,
	          className = _this$props3.className; // Not wrap when there is not addons
	
	      if (!addonBefore && !addonAfter) {
	        return labeledElement;
	      }
	
	      var wrapperClassName = "".concat(prefixCls, "-group");
	      var addonClassName = "".concat(wrapperClassName, "-addon");
	      var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonBefore) : null;
	      var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonAfter) : null;
	      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
	      var mergedGroupClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
	      // and put style prop in wrapper
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: mergedGroupClassName,
	          style: style
	        }, /*#__PURE__*/React.createElement("span", {
	          className: mergedWrapperClassName
	        }, addonBeforeNode, /*#__PURE__*/React.cloneElement(labeledElement, {
	          style: null
	        }), addonAfterNode))
	      );
	    }
	  }, {
	    key: "renderTextAreaWithClearIcon",
	    value: function renderTextAreaWithClearIcon(prefixCls, element) {
	      var _this$props4 = this.props,
	          value = _this$props4.value,
	          allowClear = _this$props4.allowClear,
	          className = _this$props4.className,
	          style = _this$props4.style;
	
	      if (!allowClear) {
	        return (/*#__PURE__*/React.cloneElement(element, {
	            value: value
	          })
	        );
	      }
	
	      var affixWrapperCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"));
	      return (/*#__PURE__*/React.createElement("span", {
	          className: affixWrapperCls,
	          style: style
	        }, /*#__PURE__*/React.cloneElement(element, {
	          style: null,
	          value: value
	        }), this.renderClearIcon(prefixCls))
	      );
	    }
	  }, {
	    key: "renderClearableLabeledInput",
	    value: function renderClearableLabeledInput() {
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          inputType = _this$props5.inputType,
	          element = _this$props5.element;
	
	      if (inputType === ClearableInputType[0]) {
	        return this.renderTextAreaWithClearIcon(prefixCls, element);
	      }
	
	      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderClearableLabeledInput();
	    }
	  }]);
	
	  return ClearableLabeledInput;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ClearableLabeledInput);
	var _default = ClearableLabeledInput;
	exports["default"] = _default;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(751));
	
	var _ResizableTextArea = _interopRequireDefault(__webpack_require__(1404));
	
	var _configProvider = __webpack_require__(15);
	
	var _Input = __webpack_require__(207);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var TextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(TextArea, _React$Component);
	
	  var _super = _createSuper(TextArea);
	
	  function TextArea(props) {
	    var _this;
	
	    _classCallCheck(this, TextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (resizableTextArea) {
	      _this.resizableTextArea = resizableTextArea;
	    };
	
	    _this.saveClearableInput = function (clearableInput) {
	      _this.clearableInput = clearableInput;
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, function () {
	        _this.resizableTextArea.resizeTextarea();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          onPressEnter = _this$props.onPressEnter,
	          onKeyDown = _this$props.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.resizableTextArea.renderTextArea();
	
	        _this.focus();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.renderTextArea = function (prefixCls) {
	      return (/*#__PURE__*/React.createElement(_ResizableTextArea["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          onKeyDown: _this.handleKeyDown,
	          onChange: _this.handleChange,
	          ref: _this.saveTextArea
	        }))
	      );
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          inputType: "text",
	          value: (0, _Input.fixControlledValue)(value),
	          element: _this.renderTextArea(prefixCls),
	          handleReset: _this.handleReset,
	          ref: _this.saveClearableInput
	        }))
	      );
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(TextArea, [{
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.resizableTextArea.textArea.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.resizableTextArea.textArea.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(TextArea);
	var _default = TextArea;
	exports["default"] = _default;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.LayoutContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || (typeof obj === "undefined" ? "undefined" : _typeof2(obj)) !== "object" && typeof obj !== "function") {
	    return { default: obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj.default = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var LayoutContext = (0, _createReactContext["default"])({
	  siderHook: {
	    addSider: function addSider() {
	      return null;
	    },
	    removeSider: function removeSider() {
	      return null;
	    }
	  }
	});
	exports.LayoutContext = LayoutContext;
	
	function generator(_ref) {
	  var suffixCls = _ref.suffixCls,
	      tagName = _ref.tagName,
	      displayName = _ref.displayName;
	  return function (BasicComponent) {
	    var _a;
	
	    return _a = /*#__PURE__*/function (_React$Component) {
	      _inherits(Adapter, _React$Component);
	
	      var _super = _createSuper(Adapter);
	
	      function Adapter() {
	        var _this;
	
	        _classCallCheck(this, Adapter);
	
	        _this = _super.apply(this, arguments);
	
	        _this.renderComponent = function (_ref2) {
	          var getPrefixCls = _ref2.getPrefixCls;
	          var customizePrefixCls = _this.props.prefixCls;
	          var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
	          return (/*#__PURE__*/React.createElement(BasicComponent, _extends({
	              prefixCls: prefixCls,
	              tagName: tagName
	            }, _this.props))
	          );
	        };
	
	        return _this;
	      }
	
	      _createClass(Adapter, [{
	        key: "render",
	        value: function render() {
	          return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	          );
	        }
	      }]);
	
	      return Adapter;
	    }(React.Component), _a.displayName = displayName, _a;
	  };
	}
	
	var Basic = function Basic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      children = props.children,
	      tagName = props.tagName,
	      others = __rest(props, ["prefixCls", "className", "children", "tagName"]);
	
	  var classString = (0, _classnames["default"])(className, prefixCls);
	  return (/*#__PURE__*/React.createElement(tagName, _extends({
	      className: classString
	    }, others), children)
	  );
	};
	
	var BasicLayout = /*#__PURE__*/function (_React$Component2) {
	  _inherits(BasicLayout, _React$Component2);
	
	  var _super2 = _createSuper(BasicLayout);
	
	  function BasicLayout() {
	    var _this2;
	
	    _classCallCheck(this, BasicLayout);
	
	    _this2 = _super2.apply(this, arguments);
	    _this2.state = {
	      siders: []
	    };
	    return _this2;
	  }
	
	  _createClass(BasicLayout, [{
	    key: "getSiderHook",
	    value: function getSiderHook() {
	      var _this3 = this;
	
	      return {
	        addSider: function addSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: [].concat(_toConsumableArray(state.siders), [id])
	            };
	          });
	        },
	        removeSider: function removeSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: state.siders.filter(function (currentId) {
	                return currentId !== id;
	              })
	            };
	          });
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          prefixCls = _a.prefixCls,
	          className = _a.className,
	          children = _a.children,
	          hasSider = _a.hasSider,
	          Tag = _a.tagName,
	          others = __rest(_a, ["prefixCls", "className", "children", "hasSider", "tagName"]);
	
	      var classString = (0, _classnames["default"])(className, prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : this.state.siders.length > 0));
	      return (/*#__PURE__*/React.createElement(LayoutContext.Provider, {
	          value: {
	            siderHook: this.getSiderHook()
	          }
	        }, /*#__PURE__*/React.createElement(Tag, _extends({
	          className: classString
	        }, others), children))
	      );
	    }
	  }]);
	
	  return BasicLayout;
	}(React.Component);
	
	var Layout = generator({
	  suffixCls: 'layout',
	  tagName: 'section',
	  displayName: 'Layout'
	})(BasicLayout);
	var Header = generator({
	  suffixCls: 'layout-header',
	  tagName: 'header',
	  displayName: 'Header'
	})(Basic);
	var Footer = generator({
	  suffixCls: 'layout-footer',
	  tagName: 'footer',
	  displayName: 'Footer'
	})(Basic);
	var Content = generator({
	  suffixCls: 'layout-content',
	  tagName: 'main',
	  displayName: 'Content'
	})(Basic);
	Layout.Header = Header;
	Layout.Footer = Footer;
	Layout.Content = Content;
	var _default = Layout;
	exports["default"] = _default;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ANT_MARK = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	var _locale = __webpack_require__(383);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ANT_MARK = 'internalMark';
	exports.ANT_MARK = ANT_MARK;
	
	function setMomentLocale(locale) {
	  if (locale && locale.locale) {
	    (0, _interopDefault["default"])(moment).locale(locale.locale);
	  } else {
	    (0, _interopDefault["default"])(moment).locale('en');
	  }
	}
	
	var LocaleProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(LocaleProvider, _React$Component);
	
	  var _super = _createSuper(LocaleProvider);
	
	  function LocaleProvider(props) {
	    var _this;
	
	    _classCallCheck(this, LocaleProvider);
	
	    _this = _super.call(this, props);
	    setMomentLocale(props.locale);
	    (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
	    (0, _warning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
	    return _this;
	  }
	
	  _createClass(LocaleProvider, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        antLocale: _extends(_extends({}, this.props.locale), {
	          exist: true
	        })
	      };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var locale = this.props.locale;
	
	      if (prevProps.locale !== locale) {
	        setMomentLocale(locale);
	        (0, _locale.changeConfirmLocale)(locale && locale.Modal);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _locale.changeConfirmLocale)();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return LocaleProvider;
	}(React.Component);
	
	exports["default"] = LocaleProvider;
	LocaleProvider.propTypes = {
	  locale: PropTypes.object
	};
	LocaleProvider.defaultProps = {
	  locale: {}
	};
	LocaleProvider.childContextTypes = {
	  antLocale: PropTypes.object
	};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.destroyFns = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcDialog = _interopRequireDefault(__webpack_require__(463));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _locale = __webpack_require__(383);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _button = _interopRequireDefault(__webpack_require__(138));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var mousePosition;
	var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795
	
	exports.destroyFns = destroyFns;
	
	var getClickPosition = function getClickPosition(e) {
	  mousePosition = {
	    x: e.pageX,
	    y: e.pageY
	  }; // 100ms 内发生过点击事件，则从点击位置动画展示
	  // 否则直接 zoom 展示
	  // 这样可以兼容非点击方式展开
	
	  setTimeout(function () {
	    return mousePosition = null;
	  }, 100);
	}; // 只有点击事件支持从鼠标位置动画展开
	
	
	if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	  (0, _addEventListener["default"])(document.documentElement, 'click', getClickPosition);
	}
	
	var Modal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  var _super = _createSuper(Modal);
	
	  function Modal() {
	    var _this;
	
	    _classCallCheck(this, Modal);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleCancel = function (e) {
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel(e);
	      }
	    };
	
	    _this.handleOk = function (e) {
	      var onOk = _this.props.onOk;
	
	      if (onOk) {
	        onOk(e);
	      }
	    };
	
	    _this.renderFooter = function (locale) {
	      var _this$props = _this.props,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          cancelText = _this$props.cancelText,
	          confirmLoading = _this$props.confirmLoading;
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.handleCancel
	        }, _this.props.cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	          type: okType,
	          loading: confirmLoading,
	          onClick: _this.handleOk
	        }, _this.props.okButtonProps), okText || locale.okText))
	      );
	    };
	
	    _this.renderModal = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          footer = _a.footer,
	          visible = _a.visible,
	          wrapClassName = _a.wrapClassName,
	          centered = _a.centered,
	          getContainer = _a.getContainer,
	          closeIcon = _a.closeIcon,
	          restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon"]);
	
	      var prefixCls = getPrefixCls('modal', customizePrefixCls);
	      var defaultFooter = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Modal",
	        defaultLocale: (0, _locale.getConfirmLocale)()
	      }, _this.renderFooter);
	      var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-x")
	      }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-close-icon"),
	        type: "close"
	      }));
	      return (/*#__PURE__*/React.createElement(_rcDialog["default"], _extends({}, restProps, {
	          getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
	          prefixCls: prefixCls,
	          wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
	          footer: footer === undefined ? defaultFooter : footer,
	          visible: visible,
	          mousePosition: mousePosition,
	          onClose: _this.handleCancel,
	          closeIcon: closeIconToRender
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderModal)
	      );
	    }
	  }]);
	
	  return Modal;
	}(React.Component);
	
	exports["default"] = Modal;
	Modal.defaultProps = {
	  width: 520,
	  transitionName: 'zoom',
	  maskTransitionName: 'fade',
	  confirmLoading: false,
	  visible: false,
	  okType: 'primary'
	};
	Modal.propTypes = {
	  prefixCls: PropTypes.string,
	  onOk: PropTypes.func,
	  onCancel: PropTypes.func,
	  okText: PropTypes.node,
	  cancelText: PropTypes.node,
	  centered: PropTypes.bool,
	  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  confirmLoading: PropTypes.bool,
	  visible: PropTypes.bool,
	  footer: PropTypes.node,
	  title: PropTypes.node,
	  closable: PropTypes.bool,
	  closeIcon: PropTypes.node
	};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _progress = _interopRequireDefault(__webpack_require__(1427));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _progress["default"];
	exports["default"] = _default;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _grid = __webpack_require__(256);
	
	var _default = _grid.Row;
	exports["default"] = _default;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _context = __webpack_require__(255);
	
	var _Number = _interopRequireDefault(__webpack_require__(1441));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Statistic = function Statistic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      style = props.style,
	      valueStyle = props.valueStyle,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      title = props.title,
	      valueRender = props.valueRender,
	      prefix = props.prefix,
	      suffix = props.suffix;
	  var valueNode = /*#__PURE__*/React.createElement(_Number["default"], _extends({}, props, {
	    value: value
	  }));
	
	  if (valueRender) {
	    valueNode = valueRender(valueNode);
	  }
	
	  return (/*#__PURE__*/React.createElement("div", {
	      className: (0, _classnames["default"])(prefixCls, className),
	      style: style
	    }, title && /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-title")
	    }, title), /*#__PURE__*/React.createElement("div", {
	      style: valueStyle,
	      className: "".concat(prefixCls, "-content")
	    }, prefix && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-prefix")
	    }, prefix), valueNode, suffix && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-suffix")
	    }, suffix)))
	  );
	};
	
	Statistic.defaultProps = {
	  decimalSeparator: '.',
	  groupSeparator: ','
	};
	var WrapperStatistic = (0, _context.withConfigConsumer)({
	  prefixCls: 'statistic'
	})(Statistic);
	var _default = WrapperStatistic;
	exports["default"] = _default;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flatArray = flatArray;
	exports.treeMap = treeMap;
	exports.flatFilter = flatFilter;
	exports.normalizeColumns = normalizeColumns;
	exports.generateValueMaps = generateValueMaps;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function flatArray() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
	  var result = [];
	
	  var loop = function loop(array) {
	    array.forEach(function (item) {
	      if (item[childrenName]) {
	        var newItem = _extends({}, item);
	
	        delete newItem[childrenName];
	        result.push(newItem);
	
	        if (item[childrenName].length > 0) {
	          loop(item[childrenName]);
	        }
	      } else {
	        result.push(item);
	      }
	    });
	  };
	
	  loop(data);
	  return result;
	}
	
	function treeMap(tree, mapper) {
	  var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	  return tree.map(function (node, index) {
	    var extra = {};
	
	    if (node[childrenName]) {
	      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
	    }
	
	    return _extends(_extends({}, mapper(node, index)), extra);
	  });
	}
	
	function flatFilter(tree, callback) {
	  return tree.reduce(function (acc, node) {
	    if (callback(node)) {
	      acc.push(node);
	    }
	
	    if (node.children) {
	      var children = flatFilter(node.children, callback);
	      acc.push.apply(acc, _toConsumableArray(children));
	    }
	
	    return acc;
	  }, []);
	}
	
	function normalizeColumns(elements) {
	  var columns = [];
	  React.Children.forEach(elements, function (element) {
	    if (! /*#__PURE__*/React.isValidElement(element)) {
	      return;
	    }
	
	    var column = _extends({}, element.props);
	
	    if (element.key) {
	      column.key = element.key;
	    }
	
	    if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
	      column.children = normalizeColumns(column.children);
	    }
	
	    columns.push(column);
	  });
	  return columns;
	}
	
	function generateValueMaps(items) {
	  var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (items || []).forEach(function (_ref) {
	    var value = _ref.value,
	        children = _ref.children;
	    maps[value.toString()] = value;
	    generateValueMaps(children, maps);
	  });
	  return maps;
	}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(84));
	
	var _rcTabs = _interopRequireWildcard(__webpack_require__(481));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(504));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _TabBar = _interopRequireDefault(__webpack_require__(1456));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _styleChecker = __webpack_require__(735);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Tabs = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  var _super = _createSuper(Tabs);
	
	  function Tabs() {
	    var _this;
	
	    _classCallCheck(this, Tabs);
	
	    _this = _super.apply(this, arguments);
	
	    _this.removeTab = function (targetKey, e) {
	      e.stopPropagation();
	
	      if (!targetKey) {
	        return;
	      }
	
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'remove');
	      }
	    };
	
	    _this.handleChange = function (activeKey) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(activeKey);
	      }
	    };
	
	    _this.createNewTab = function (targetKey) {
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'add');
	      }
	    };
	
	    _this.renderTabs = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          size = _this$props.size,
	          _this$props$type = _this$props.type,
	          type = _this$props$type === void 0 ? 'line' : _this$props$type,
	          tabPosition = _this$props.tabPosition,
	          children = _this$props.children,
	          _this$props$animated = _this$props.animated,
	          animated = _this$props$animated === void 0 ? true : _this$props$animated,
	          hideAdd = _this$props.hideAdd;
	      var tabBarExtraContent = _this.props.tabBarExtraContent;
	      var tabPaneAnimated = _typeof(animated) === 'object' ? animated.tabPane : animated; // card tabs should not have animation
	
	      if (type !== 'line') {
	        tabPaneAnimated = 'animated' in _this.props ? tabPaneAnimated : false;
	      }
	
	      (0, _warning["default"])(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), 'Tabs', "`type=card|editable-card` doesn't have small or large size, it's by design.");
	      var prefixCls = getPrefixCls('tabs', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), tabPosition === 'left' || tabPosition === 'right'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card"), type.indexOf('card') >= 0), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), true), _defineProperty(_classNames, "".concat(prefixCls, "-no-animation"), !tabPaneAnimated), _classNames)); // only card type tabs can be added and closed
	
	      var childrenWithClose = [];
	
	      if (type === 'editable-card') {
	        childrenWithClose = [];
	        React.Children.forEach(children, function (child, index) {
	          if (! /*#__PURE__*/React.isValidElement(child)) return child;
	          var closable = child.props.closable;
	          closable = typeof closable === 'undefined' ? true : closable;
	          var closeIcon = closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "close",
	            className: "".concat(prefixCls, "-close-x"),
	            onClick: function onClick(e) {
	              return _this.removeTab(child.key, e);
	            }
	          }) : null;
	          childrenWithClose.push( /*#__PURE__*/React.cloneElement(child, {
	            tab: /*#__PURE__*/React.createElement("div", {
	              className: closable ? undefined : "".concat(prefixCls, "-tab-unclosable")
	            }, child.props.tab, closeIcon),
	            key: child.key || index
	          }));
	        }); // Add new tab handler
	
	        if (!hideAdd) {
	          tabBarExtraContent = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "plus",
	            className: "".concat(prefixCls, "-new-tab"),
	            onClick: _this.createNewTab
	          }), tabBarExtraContent);
	        }
	      }
	
	      tabBarExtraContent = tabBarExtraContent ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra-content")
	      }, tabBarExtraContent) : null;
	
	      var tabBarProps = __rest(_this.props, []);
	
	      var contentCls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-content"), type.indexOf('card') >= 0 && "".concat(prefixCls, "-card-content"));
	      return (/*#__PURE__*/React.createElement(_rcTabs["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: cls,
	          tabBarPosition: tabPosition,
	          renderTabBar: function renderTabBar() {
	            return (/*#__PURE__*/React.createElement(_TabBar["default"], _extends({}, (0, _omit["default"])(tabBarProps, ['className']), {
	                tabBarExtraContent: tabBarExtraContent
	              }))
	            );
	          },
	          renderTabContent: function renderTabContent() {
	            return (/*#__PURE__*/React.createElement(_TabContent["default"], {
	                className: contentCls,
	                animated: tabPaneAnimated,
	                animatedWithMargin: true
	              })
	            );
	          },
	          onChange: _this.handleChange
	        }), childrenWithClose.length > 0 ? childrenWithClose : children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var NO_FLEX = ' no-flex';
	      var tabNode = ReactDOM.findDOMNode(this);
	
	      if (tabNode && !_styleChecker.isFlexSupported && tabNode.className.indexOf(NO_FLEX) === -1) {
	        tabNode.className += NO_FLEX;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTabs)
	      );
	    }
	  }]);
	
	  return Tabs;
	}(React.Component);
	
	exports["default"] = Tabs;
	Tabs.TabPane = _rcTabs.TabPane;
	Tabs.defaultProps = {
	  hideAdd: false,
	  tabPosition: 'top'
	};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _CheckableTag = _interopRequireDefault(__webpack_require__(1457));
	
	var _configProvider = __webpack_require__(15);
	
	var _colors = __webpack_require__(730);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _wave = _interopRequireDefault(__webpack_require__(376));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var PresetColorRegex = new RegExp("^(".concat(_colors.PresetColorTypes.join('|'), ")(-inverse)?$"));
	
	var Tag = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tag, _React$Component);
	
	  var _super = _createSuper(Tag);
	
	  function Tag(props) {
	    var _this;
	
	    _classCallCheck(this, Tag);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      visible: true
	    };
	
	    _this.handleIconClick = function (e) {
	      e.stopPropagation();
	
	      _this.setVisible(false, e);
	    };
	
	    _this.renderTag = function (configProps) {
	      var _a = _this.props,
	          children = _a.children,
	          otherProps = __rest(_a, ["children"]);
	
	      var isNeedWave = 'onClick' in otherProps || children && children.type === 'a';
	      var tagProps = (0, _omit["default"])(otherProps, ['onClose', 'afterClose', 'color', 'visible', 'closable', 'prefixCls']);
	      return isNeedWave ? /*#__PURE__*/React.createElement(_wave["default"], null, /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
	        className: _this.getTagClassName(configProps),
	        style: _this.getTagStyle()
	      }), children, _this.renderCloseIcon())) : /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
	        className: _this.getTagClassName(configProps),
	        style: _this.getTagStyle()
	      }), children, _this.renderCloseIcon());
	    };
	
	    (0, _warning["default"])(!('afterClose' in props), 'Tag', "'afterClose' will be deprecated, please use 'onClose', we will remove this in the next version.");
	    return _this;
	  }
	
	  _createClass(Tag, [{
	    key: "getTagStyle",
	    value: function getTagStyle() {
	      var _this$props = this.props,
	          color = _this$props.color,
	          style = _this$props.style;
	      var isPresetColor = this.isPresetColor();
	      return _extends({
	        backgroundColor: color && !isPresetColor ? color : undefined
	      }, style);
	    }
	  }, {
	    key: "getTagClassName",
	    value: function getTagClassName(_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          color = _this$props2.color;
	      var visible = this.state.visible;
	      var isPresetColor = this.isPresetColor();
	      var prefixCls = getPrefixCls('tag', customizePrefixCls);
	      return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-has-color"), color && !isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-hidden"), !visible), _classNames), className);
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible, e) {
	      var _this$props3 = this.props,
	          onClose = _this$props3.onClose,
	          afterClose = _this$props3.afterClose;
	
	      if (onClose) {
	        onClose(e);
	      }
	
	      if (afterClose && !onClose) {
	        // next version remove.
	        afterClose();
	      }
	
	      if (e.defaultPrevented) {
	        return;
	      }
	
	      if (!('visible' in this.props)) {
	        this.setState({
	          visible: visible
	        });
	      }
	    }
	  }, {
	    key: "isPresetColor",
	    value: function isPresetColor() {
	      var color = this.props.color;
	
	      if (!color) {
	        return false;
	      }
	
	      return PresetColorRegex.test(color);
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var closable = this.props.closable;
	      return closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        onClick: this.handleIconClick
	      }) : null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTag)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tag;
	}(React.Component);
	
	Tag.CheckableTag = _CheckableTag["default"];
	Tag.defaultProps = {
	  closable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Tag);
	var _default = Tag;
	exports["default"] = _default;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(482));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _configProvider = __webpack_require__(15);
	
	var _en_US = _interopRequireDefault(__webpack_require__(387));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function generateShowHourMinuteSecond(format) {
	  // Ref: http://momentjs.com/docs/#/parsing/string-format/
	  return {
	    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
	    showMinute: format.indexOf('m') > -1,
	    showSecond: format.indexOf('s') > -1
	  };
	}
	
	var TimePicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(TimePicker, _React$Component);
	
	  var _super = _createSuper(TimePicker);
	
	  function TimePicker(props) {
	    var _this;
	
	    _classCallCheck(this, TimePicker);
	
	    _this = _super.call(this, props);
	
	    _this.getDefaultLocale = function () {
	      var defaultLocale = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	      return defaultLocale;
	    };
	
	    _this.handleOpenClose = function (_ref) {
	      var open = _ref.open;
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.saveTimePicker = function (timePickerRef) {
	      _this.timePickerRef = timePickerRef;
	    };
	
	    _this.handleChange = function (value) {
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          _this$props$format = _this$props.format,
	          format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;
	
	      if (onChange) {
	        onChange(value, value && value.format(format) || '');
	      }
	    };
	
	    _this.renderTimePicker = function (locale) {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	          var getContextPopupContainer = _ref2.getPopupContainer,
	              getPrefixCls = _ref2.getPrefixCls;
	
	          var _a = _this.props,
	              getPopupContainer = _a.getPopupContainer,
	              customizePrefixCls = _a.prefixCls,
	              className = _a.className,
	              addon = _a.addon,
	              placeholder = _a.placeholder,
	              props = __rest(_a, ["getPopupContainer", "prefixCls", "className", "addon", "placeholder"]);
	
	          var size = props.size;
	          var pickerProps = (0, _omit["default"])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);
	
	          var format = _this.getDefaultFormat();
	
	          var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
	          var pickerClassName = (0, _classnames["default"])(className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	
	          var pickerAddon = function pickerAddon(panel) {
	            return addon ? /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-panel-addon")
	            }, addon(panel)) : null;
	          };
	
	          return (/*#__PURE__*/React.createElement(_TimePicker["default"], _extends({}, generateShowHourMinuteSecond(format), pickerProps, {
	              allowEmpty: _this.getAllowClear(),
	              prefixCls: prefixCls,
	              getPopupContainer: getPopupContainer || getContextPopupContainer,
	              ref: _this.saveTimePicker,
	              format: format,
	              className: pickerClassName,
	              value: _this.state.value,
	              placeholder: placeholder === undefined ? locale.placeholder : placeholder,
	              onChange: _this.handleChange,
	              onOpen: _this.handleOpenClose,
	              onClose: _this.handleOpenClose,
	              addon: pickerAddon,
	              inputIcon: _this.renderInputIcon(prefixCls),
	              clearIcon: _this.renderClearIcon(prefixCls)
	            }))
	          );
	        })
	      );
	    };
	
	    var value = props.value || props.defaultValue;
	
	    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
	    }
	
	    _this.state = {
	      value: value
	    };
	    (0, _warning["default"])(!('allowEmpty' in props), 'TimePicker', '`allowEmpty` is deprecated. Please use `allowClear` instead.');
	    return _this;
	  }
	
	  _createClass(TimePicker, [{
	    key: "getDefaultFormat",
	    value: function getDefaultFormat() {
	      var _this$props2 = this.props,
	          format = _this$props2.format,
	          use12Hours = _this$props2.use12Hours;
	
	      if (format) {
	        return format;
	      }
	
	      if (use12Hours) {
	        return 'h:mm:ss a';
	      }
	
	      return 'HH:mm:ss';
	    }
	  }, {
	    key: "getAllowClear",
	    value: function getAllowClear() {
	      var _this$props3 = this.props,
	          allowClear = _this$props3.allowClear,
	          allowEmpty = _this$props3.allowEmpty;
	
	      if ('allowClear' in this.props) {
	        return allowClear;
	      }
	
	      return allowEmpty;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.timePickerRef.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.timePickerRef.blur();
	    }
	  }, {
	    key: "renderInputIcon",
	    value: function renderInputIcon(prefixCls) {
	      var suffixIcon = this.props.suffixIcon;
	      var clockIcon = suffixIcon && /*#__PURE__*/React.isValidElement(suffixIcon) && /*#__PURE__*/React.cloneElement(suffixIcon, {
	        className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-clock-icon"))
	      }) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "clock-circle",
	        className: "".concat(prefixCls, "-clock-icon")
	      });
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-icon")
	        }, clockIcon)
	      );
	    }
	  }, {
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var clearIcon = this.props.clearIcon;
	      var clearIconPrefixCls = "".concat(prefixCls, "-clear");
	
	      if (clearIcon && /*#__PURE__*/React.isValidElement(clearIcon)) {
	        return (/*#__PURE__*/React.cloneElement(clearIcon, {
	            className: (0, _classnames["default"])(clearIcon.props.className, clearIconPrefixCls)
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          className: clearIconPrefixCls,
	          theme: "filled"
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "TimePicker",
	          defaultLocale: this.getDefaultLocale()
	        }, this.renderTimePicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TimePicker;
	}(React.Component);
	
	TimePicker.defaultProps = {
	  align: {
	    offset: [0, -2]
	  },
	  disabledHours: undefined,
	  disabledMinutes: undefined,
	  disabledSeconds: undefined,
	  hideDisabledOptions: false,
	  placement: 'bottomLeft',
	  transitionName: 'slide-up',
	  focusOnOpen: true
	};
	(0, _reactLifecyclesCompat.polyfill)(TimePicker);
	var _default = TimePicker;
	exports["default"] = _default;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _input = _interopRequireDefault(__webpack_require__(257));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleChange = function (e) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.handleClear = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          handleClear = _this$props.handleClear,
	          disabled = _this$props.disabled;
	
	      if (!disabled && handleClear) {
	        handleClear(e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          placeholder = _this$props2.placeholder,
	          value = _this$props2.value,
	          prefixCls = _this$props2.prefixCls,
	          disabled = _this$props2.disabled;
	      var icon = value && value.length > 0 ? /*#__PURE__*/React.createElement("a", {
	        href: "#",
	        className: "".concat(prefixCls, "-action"),
	        onClick: this.handleClear
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled"
	      })) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-action")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "search"
	      }));
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_input["default"], {
	          placeholder: placeholder,
	          className: prefixCls,
	          value: value,
	          onChange: this.handleChange,
	          disabled: disabled
	        }), icon)
	      );
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  placeholder: ''
	};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcTree = _interopRequireWildcard(__webpack_require__(492));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _DirectoryTree = _interopRequireDefault(__webpack_require__(1468));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _motion = _interopRequireDefault(__webpack_require__(732));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Tree = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tree, _React$Component);
	
	  var _super = _createSuper(Tree);
	
	  function Tree() {
	    var _this;
	
	    _classCallCheck(this, Tree);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSwitcherIcon = function (prefixCls, switcherIcon, _ref) {
	      var isLeaf = _ref.isLeaf,
	          expanded = _ref.expanded,
	          loading = _ref.loading;
	      var showLine = _this.props.showLine;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading",
	            className: "".concat(prefixCls, "-switcher-loading-icon")
	          })
	        );
	      }
	
	      if (isLeaf) {
	        return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "file",
	          className: "".concat(prefixCls, "-switcher-line-icon")
	        }) : null;
	      }
	
	      var switcherCls = "".concat(prefixCls, "-switcher-icon");
	
	      if (switcherIcon) {
	        return (/*#__PURE__*/React.cloneElement(switcherIcon, {
	            className: (0, _classnames["default"])(switcherIcon.props.className || '', switcherCls)
	          })
	        );
	      }
	
	      return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: expanded ? 'minus-square' : 'plus-square',
	        className: "".concat(prefixCls, "-switcher-line-icon"),
	        theme: "outlined"
	      }) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "caret-down",
	        className: switcherCls,
	        theme: "filled"
	      });
	    };
	
	    _this.setTreeRef = function (node) {
	      _this.tree = node;
	    };
	
	    _this.renderTree = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          showIcon = props.showIcon,
	          _switcherIcon = props.switcherIcon,
	          blockNode = props.blockNode,
	          children = props.children;
	      var checkable = props.checkable;
	      var prefixCls = getPrefixCls('tree', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_rcTree["default"], _extends({
	          ref: _this.setTreeRef
	        }, props, {
	          prefixCls: prefixCls,
	          className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-icon-hide"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-block-node"), blockNode), _classNames)),
	          checkable: checkable ? /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-checkbox-inner")
	          }) : checkable,
	          switcherIcon: function switcherIcon(nodeProps) {
	            return _this.renderSwitcherIcon(prefixCls, _switcherIcon, nodeProps);
	          }
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Tree, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTree)
	      );
	    }
	  }]);
	
	  return Tree;
	}(React.Component);
	
	exports["default"] = Tree;
	Tree.TreeNode = _rcTree.TreeNode;
	Tree.DirectoryTree = _DirectoryTree["default"];
	Tree.defaultProps = {
	  checkable: false,
	  showIcon: false,
	  motion: _extends(_extends({}, _motion["default"]), {
	    motionAppear: false
	  }),
	  blockNode: false
	};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _ref2 = __webpack_require__(1353);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Typography = function Typography(_a, ref) {
	  var customizePrefixCls = _a.prefixCls,
	      _a$component = _a.component,
	      component = _a$component === void 0 ? 'article' : _a$component,
	      className = _a.className,
	      ariaLabel = _a['aria-label'],
	      setContentRef = _a.setContentRef,
	      children = _a.children,
	      restProps = __rest(_a, ["prefixCls", "component", "className", 'aria-label', "setContentRef", "children"]);
	
	  var mergedRef = ref;
	
	  if (setContentRef) {
	    (0, _warning["default"])(false, 'Typography', '`setContentRef` is deprecated. Please use `ref` instead.');
	    mergedRef = (0, _ref2.composeRef)(ref, setContentRef);
	  }
	
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var Component = component;
	      var prefixCls = getPrefixCls('typography', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(Component, _extends({
	          className: (0, _classnames["default"])(prefixCls, className),
	          "aria-label": ariaLabel,
	          ref: mergedRef
	        }, restProps), children)
	      );
	    })
	  );
	};
	
	var RefTypography;
	
	if (React.forwardRef) {
	  RefTypography = /*#__PURE__*/React.forwardRef(Typography);
	  RefTypography.displayName = 'Typography';
	} else {
	  var TypographyWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(TypographyWrapper, _React$Component);
	
	    var _super = _createSuper(TypographyWrapper);
	
	    function TypographyWrapper() {
	      var _this;
	
	      _classCallCheck(this, TypographyWrapper);
	
	      _this = _super.apply(this, arguments);
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(TypographyWrapper, [{
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(Typography, this.props)
	        );
	      }
	    }]);
	
	    return TypographyWrapper;
	  }(React.Component);
	
	  RefTypography = TypographyWrapper;
	} // es default export should use const instead of let
	
	
	var ExportTypography = RefTypography;
	var _default = ExportTypography;
	exports["default"] = _default;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcUpload = _interopRequireDefault(__webpack_require__(485));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _uniqBy = _interopRequireDefault(__webpack_require__(459));
	
	var _findIndex = _interopRequireDefault(__webpack_require__(456));
	
	var _UploadList = _interopRequireDefault(__webpack_require__(1478));
	
	var _utils = __webpack_require__(767);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _default2 = _interopRequireDefault(__webpack_require__(164));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Upload = /*#__PURE__*/function (_React$Component) {
	  _inherits(Upload, _React$Component);
	
	  var _super = _createSuper(Upload);
	
	  function Upload(props) {
	    var _this;
	
	    _classCallCheck(this, Upload);
	
	    _this = _super.call(this, props);
	
	    _this.saveUpload = function (node) {
	      _this.upload = node;
	    };
	
	    _this.onStart = function (file) {
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.fileToObject)(file);
	      targetItem.status = 'uploading';
	      var nextFileList = fileList.concat();
	      var fileIndex = (0, _findIndex["default"])(nextFileList, function (_ref) {
	        var uid = _ref.uid;
	        return uid === targetItem.uid;
	      });
	
	      if (fileIndex === -1) {
	        nextFileList.push(targetItem);
	      } else {
	        nextFileList[fileIndex] = targetItem;
	      }
	
	      _this.onChange({
	        file: targetItem,
	        fileList: nextFileList
	      }); // fix ie progress
	
	
	      if (!window.File || ({"NODE_ENV":"production"}).TEST_IE) {
	        _this.autoUpdateProgress(0, targetItem);
	      }
	    };
	
	    _this.onSuccess = function (response, file, xhr) {
	      _this.clearProgressTimer();
	
	      try {
	        if (typeof response === 'string') {
	          response = JSON.parse(response);
	        }
	      } catch (e) {
	        /* do nothing */
	      }
	
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.status = 'done';
	      targetItem.response = response;
	      targetItem.xhr = xhr;
	
	      _this.onChange({
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.onProgress = function (e, file) {
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.percent = e.percent;
	
	      _this.onChange({
	        event: e,
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.onError = function (error, response, file) {
	      _this.clearProgressTimer();
	
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.error = error;
	      targetItem.response = response;
	      targetItem.status = 'error';
	
	      _this.onChange({
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.handleRemove = function (file) {
	      var onRemove = _this.props.onRemove;
	      var fileList = _this.state.fileList;
	      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
	        // Prevent removing file
	        if (ret === false) {
	          return;
	        }
	
	        var removedFileList = (0, _utils.removeFileItem)(file, fileList);
	
	        if (removedFileList) {
	          file.status = 'removed'; // eslint-disable-line
	
	          if (_this.upload) {
	            _this.upload.abort(file);
	          }
	
	          _this.onChange({
	            file: file,
	            fileList: removedFileList
	          });
	        }
	      });
	    };
	
	    _this.onChange = function (info) {
	      if (!('fileList' in _this.props)) {
	        _this.setState({
	          fileList: info.fileList
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(info);
	      }
	    };
	
	    _this.onFileDrop = function (e) {
	      _this.setState({
	        dragState: e.type
	      });
	    };
	
	    _this.beforeUpload = function (file, fileList) {
	      var beforeUpload = _this.props.beforeUpload;
	      var stateFileList = _this.state.fileList;
	
	      if (!beforeUpload) {
	        return true;
	      }
	
	      var result = beforeUpload(file, fileList);
	
	      if (result === false) {
	        _this.onChange({
	          file: file,
	          fileList: (0, _uniqBy["default"])(stateFileList.concat(fileList.map(_utils.fileToObject)), function (item) {
	            return item.uid;
	          })
	        });
	
	        return false;
	      }
	
	      if (result && result.then) {
	        return result;
	      }
	
	      return true;
	    };
	
	    _this.renderUploadList = function (locale) {
	      var _this$props = _this.props,
	          showUploadList = _this$props.showUploadList,
	          listType = _this$props.listType,
	          onPreview = _this$props.onPreview,
	          onDownload = _this$props.onDownload,
	          previewFile = _this$props.previewFile,
	          disabled = _this$props.disabled,
	          propLocale = _this$props.locale;
	      var showRemoveIcon = showUploadList.showRemoveIcon,
	          showPreviewIcon = showUploadList.showPreviewIcon,
	          showDownloadIcon = showUploadList.showDownloadIcon;
	      var fileList = _this.state.fileList;
	      return (/*#__PURE__*/React.createElement(_UploadList["default"], {
	          listType: listType,
	          items: fileList,
	          previewFile: previewFile,
	          onPreview: onPreview,
	          onDownload: onDownload,
	          onRemove: _this.handleRemove,
	          showRemoveIcon: !disabled && showRemoveIcon,
	          showPreviewIcon: showPreviewIcon,
	          showDownloadIcon: showDownloadIcon,
	          locale: _extends(_extends({}, locale), propLocale)
	        })
	      );
	    };
	
	    _this.renderUpload = function (_ref2) {
	      var _classNames2;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          showUploadList = _this$props2.showUploadList,
	          listType = _this$props2.listType,
	          type = _this$props2.type,
	          disabled = _this$props2.disabled,
	          children = _this$props2.children,
	          style = _this$props2.style;
	      var _this$state = _this.state,
	          fileList = _this$state.fileList,
	          dragState = _this$state.dragState;
	      var prefixCls = getPrefixCls('upload', customizePrefixCls);
	
	      var rcUploadProps = _extends(_extends({
	        onStart: _this.onStart,
	        onError: _this.onError,
	        onProgress: _this.onProgress,
	        onSuccess: _this.onSuccess
	      }, _this.props), {
	        prefixCls: prefixCls,
	        beforeUpload: _this.beforeUpload
	      });
	
	      delete rcUploadProps.className;
	      delete rcUploadProps.style; // Remove id to avoid open by label when trigger is hidden
	      // !children: https://github.com/ant-design/ant-design/issues/14298
	      // disabled: https://github.com/ant-design/ant-design/issues/16478
	      //           https://github.com/ant-design/ant-design/issues/24197
	
	      if (!children || disabled) {
	        delete rcUploadProps.id;
	      }
	
	      var uploadList = showUploadList ? /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Upload",
	        defaultLocale: _default2["default"].Upload
	      }, _this.renderUploadList) : null;
	
	      if (type === 'drag') {
	        var _classNames;
	
	        var dragCls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-drag"), true), _defineProperty(_classNames, "".concat(prefixCls, "-drag-uploading"), fileList.some(function (file) {
	          return file.status === 'uploading';
	        })), _defineProperty(_classNames, "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames), className);
	        return (/*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
	            className: dragCls,
	            onDrop: _this.onFileDrop,
	            onDragOver: _this.onFileDrop,
	            onDragLeave: _this.onFileDrop,
	            style: style
	          }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
	            ref: _this.saveUpload,
	            className: "".concat(prefixCls, "-btn")
	          }), /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-drag-container")
	          }, children))), uploadList)
	        );
	      }
	
	      var uploadButtonCls = (0, _classnames["default"])(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _classNames2));
	      var uploadButton = /*#__PURE__*/React.createElement("div", {
	        className: uploadButtonCls,
	        style: children ? undefined : {
	          display: 'none'
	        }
	      }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
	        ref: _this.saveUpload
	      })));
	
	      if (listType === 'picture-card') {
	        return (/*#__PURE__*/React.createElement("span", {
	            className: (0, _classnames["default"])(className, "".concat(prefixCls, "-picture-card-wrapper"))
	          }, uploadList, uploadButton)
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: className
	        }, uploadButton, uploadList)
	      );
	    };
	
	    _this.state = {
	      fileList: props.fileList || props.defaultFileList || [],
	      dragState: 'drop'
	    };
	    (0, _warning["default"])('fileList' in props || !('value' in props), 'Upload', '`value` is not validate prop, do you mean `fileList`?');
	    return _this;
	  }
	
	  _createClass(Upload, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearProgressTimer();
	    }
	  }, {
	    key: "clearProgressTimer",
	    value: function clearProgressTimer() {
	      clearInterval(this.progressTimer);
	    }
	  }, {
	    key: "autoUpdateProgress",
	    value: function autoUpdateProgress(_, file) {
	      var _this2 = this;
	
	      var getPercent = (0, _utils.genPercentAdd)();
	      var curPercent = 0;
	      this.clearProgressTimer();
	      this.progressTimer = setInterval(function () {
	        curPercent = getPercent(curPercent);
	
	        _this2.onProgress({
	          percent: curPercent * 100
	        }, file);
	      }, 200);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUpload)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('fileList' in nextProps) {
	        return {
	          fileList: nextProps.fileList || []
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Upload;
	}(React.Component);
	
	Upload.defaultProps = {
	  type: 'select',
	  multiple: false,
	  action: '',
	  data: {},
	  accept: '',
	  beforeUpload: _utils.T,
	  showUploadList: true,
	  listType: 'text',
	  className: '',
	  disabled: false,
	  supportServerRender: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Upload);
	var _default = Upload;
	exports["default"] = _default;

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.T = T;
	exports.fileToObject = fileToObject;
	exports.genPercentAdd = genPercentAdd;
	exports.getFileItem = getFileItem;
	exports.removeFileItem = removeFileItem;
	exports.previewImage = previewImage;
	exports.isImageUrl = void 0;
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function T() {
	  return true;
	} // Fix IE file.status problem
	// via coping a new Object
	
	
	function fileToObject(file) {
	  return _extends(_extends({}, file), {
	    lastModified: file.lastModified,
	    lastModifiedDate: file.lastModifiedDate,
	    name: file.name,
	    size: file.size,
	    type: file.type,
	    uid: file.uid,
	    percent: 0,
	    originFileObj: file
	  });
	}
	/**
	 * 生成Progress percent: 0.1 -> 0.98
	 *   - for ie
	 */
	
	function genPercentAdd() {
	  var k = 0.1;
	  var i = 0.01;
	  var end = 0.98;
	  return function (s) {
	    var start = s;
	
	    if (start >= end) {
	      return start;
	    }
	
	    start += k;
	    k -= i;
	
	    if (k < 0.001) {
	      k = 0.001;
	    }
	
	    return start;
	  };
	}
	
	function getFileItem(file, fileList) {
	  var matchKey = file.uid !== undefined ? 'uid' : 'name';
	  return fileList.filter(function (item) {
	    return item[matchKey] === file[matchKey];
	  })[0];
	}
	
	function removeFileItem(file, fileList) {
	  var matchKey = file.uid !== undefined ? 'uid' : 'name';
	  var removed = fileList.filter(function (item) {
	    return item[matchKey] !== file[matchKey];
	  });
	
	  if (removed.length === fileList.length) {
	    return null;
	  }
	
	  return removed;
	} // ==================== Default Image Preview ====================
	
	
	var extname = function extname() {
	  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var temp = url.split('/');
	  var filename = temp[temp.length - 1];
	  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
	  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
	};
	
	var isImageFileType = function isImageFileType(type) {
	  return !!type && type.indexOf('image/') === 0;
	};
	
	var isImageUrl = function isImageUrl(file) {
	  if (isImageFileType(file.type)) {
	    return true;
	  }
	
	  var url = file.thumbUrl || file.url;
	  var extension = extname(url);
	
	  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
	    return true;
	  }
	
	  if (/^data:/.test(url)) {
	    // other file types of base64
	    return false;
	  }
	
	  if (extension) {
	    // other file types which have extension
	    return false;
	  }
	
	  return true;
	};
	
	exports.isImageUrl = isImageUrl;
	var MEASURE_SIZE = 200;
	
	function previewImage(file) {
	  return new Promise(function (resolve) {
	    if (!isImageFileType(file.type)) {
	      resolve('');
	      return;
	    }
	
	    var canvas = document.createElement('canvas');
	    canvas.width = MEASURE_SIZE;
	    canvas.height = MEASURE_SIZE;
	    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
	    document.body.appendChild(canvas);
	    var ctx = canvas.getContext('2d');
	    var img = new Image();
	
	    img.onload = function () {
	      var width = img.width,
	          height = img.height;
	      var drawWidth = MEASURE_SIZE;
	      var drawHeight = MEASURE_SIZE;
	      var offsetX = 0;
	      var offsetY = 0;
	
	      if (width < height) {
	        drawHeight = height * (MEASURE_SIZE / width);
	        offsetY = -(drawHeight - drawWidth) / 2;
	      } else {
	        drawWidth = width * (MEASURE_SIZE / height);
	        offsetX = -(drawWidth - drawHeight) / 2;
	      }
	
	      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
	      var dataURL = canvas.toDataURL();
	      document.body.removeChild(canvas);
	      resolve(dataURL);
	    };
	
	    img.src = window.URL.createObjectURL(file);
	  });
	}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var PooledClass = __webpack_require__(139);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(166);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactInstrumentation = __webpack_require__(94);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1555);
	var warning = __webpack_require__(44);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function createMarkupForID(id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function setAttributeForID(node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function createMarkupForRoot() {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function setAttributeForRoot(node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function createMarkupForProperty(name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function createMarkupForCustomAttribute(name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function setValueForProperty(node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function setValueForAttribute(node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function deleteValueForAttribute(node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function deleteValueForProperty(node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var LinkedValueUtils = __webpack_require__(398);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactUpdates = __webpack_require__(101);
	
	var warning = __webpack_require__(44);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function getHostProps(inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function mountWrapper(inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function getSelectValueContext(inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function postUpdateWrapper(inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function injectEmptyComponentFactory(factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function create(instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function injectGenericComponentClass(componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function injectTextComponentClass(componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1515);
	
	var containsNode = __webpack_require__(2102);
	var focusNode = __webpack_require__(926);
	var getActiveElement = __webpack_require__(923);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function hasSelectionCapabilities(elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function getSelectionInformation() {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function restoreSelection(priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function getSelection(input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function setSelection(input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var DOMLazyTree = __webpack_require__(165);
	var DOMProperty = __webpack_require__(166);
	var React = __webpack_require__(168);
	var ReactBrowserEventEmitter = __webpack_require__(260);
	var ReactCurrentOwner = __webpack_require__(112);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactDOMContainerInfo = __webpack_require__(1509);
	var ReactDOMFeatureFlags = __webpack_require__(1511);
	var ReactFeatureFlags = __webpack_require__(774);
	var ReactInstanceMap = __webpack_require__(211);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactMarkupChecksum = __webpack_require__(1525);
	var ReactReconciler = __webpack_require__(167);
	var ReactUpdateQueue = __webpack_require__(401);
	var ReactUpdates = __webpack_require__(101);
	
	var emptyObject = __webpack_require__(287);
	var instantiateReactComponent = __webpack_require__(785);
	var invariant = __webpack_require__(32);
	var setInnerHTML = __webpack_require__(264);
	var shouldUpdateReactComponent = __webpack_require__(407);
	var warning = __webpack_require__(44);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function TopLevelWrapper() {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function scrollMonitor(container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function _updateRootComponent(prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function _renderNewRootComponent(nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function renderSubtreeIntoContainer(parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function _renderSubtreeIntoContainer(parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function render(nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function unmountComponentAtNode(container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function _mountImageIntoNode(markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var React = __webpack_require__(168);
	
	var invariant = __webpack_require__(32);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function getType(node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function refreshScrollValues(scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(778);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(90);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(56);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function _getTrackerFromNode(node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	  track: function track(inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function get() {
	        return descriptor.get.call(this);
	      },
	      set: function set(value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function getValue() {
	        return currentValue;
	      },
	      setValue: function setValue(value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function stopTracking() {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function updateValueIfChanged(inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function stopTracking(inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(53);
	
	var ReactCompositeComponent = __webpack_require__(1506);
	var ReactEmptyComponent = __webpack_require__(773);
	var ReactHostComponent = __webpack_require__(775);
	
	var getNextDebugID = __webpack_require__(1565);
	var invariant = __webpack_require__(32);
	var warning = __webpack_require__(44);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function ReactCompositeComponentWrapper(element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type === 'undefined' ? 'undefined' : _typeof(type), info) : _prodInvariant('130', type == null ? type : typeof type === 'undefined' ? 'undefined' : _typeof(type), info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node === 'undefined' ? 'undefined' : _typeof(node)) : _prodInvariant('131', typeof node === 'undefined' ? 'undefined' : _typeof(node)) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(90);
	var escapeTextContentForBrowser = __webpack_require__(263);
	var setInnerHTML = __webpack_require__(264);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function setTextContent(node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function setTextContent(node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactCurrentOwner = __webpack_require__(112);
	var REACT_ELEMENT_TYPE = __webpack_require__(1521);
	
	var getIteratorFn = __webpack_require__(1552);
	var invariant = __webpack_require__(32);
	var KeyEscapeUtils = __webpack_require__(397);
	var warning = __webpack_require__(44);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(213),
	    _assign = __webpack_require__(53);
	
	var ReactNoopUpdateQueue = __webpack_require__(792);
	
	var canDefineProperty = __webpack_require__(793);
	var emptyObject = __webpack_require__(287);
	var invariant = __webpack_require__(32);
	var lowPriorityWarning = __webpack_require__(1566);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !((typeof partialState === 'undefined' ? 'undefined' : _typeof(partialState)) === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function get() {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(213);
	
	var ReactCurrentOwner = __webpack_require__(112);
	
	var invariant = __webpack_require__(32);
	var warning = __webpack_require__(44);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function setItem(id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function getItem(id) {
	    return itemMap.get(id);
	  };
	  removeItem = function removeItem(id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function getItemIDs() {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function addRoot(id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function removeRoot(id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function getRootIDs() {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function getKeyFromID(id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function getIDFromKey(key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function setItem(id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function getItem(id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function removeItem(id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function getItemIDs() {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function addRoot(id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function removeRoot(id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function getRootIDs() {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function _getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function onSetChildren(id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || _typeof(nextChild.element) !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function onBeforeMountComponent(id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function onBeforeUpdateComponent(id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function onMountComponent(id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function onUpdateComponent(id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function onUnmountComponent(id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function purgeUnmountedComponents() {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function isMounted(id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function getCurrentStackAddendum(topElement) {
	    var info = '';
	    if (topElement) {
	      var name = _getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function getStackAddendumByID(id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function getChildIDs(id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function getDisplayName(id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return _getDisplayName(element);
	  },
	  getElement: function getElement(id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function getOwnerID(id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function getParentID(id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function getSource(id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function getText(id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function getUpdateCount(id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function pushNonStandardWarningStack(isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function popNonStandardWarningStack() {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(44);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function isMounted(publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function enqueueCallback(publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function enqueueForceUpdate(publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function enqueueSetState(publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function get() {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.vldCOnChangeAndCtrlHidFlg = exports.vldCCtrlHidFlg = exports.ctrlHidFlg = exports.getHidFlg = exports.getColUnitByDesc = exports.getEditor = exports.getColUnit = exports.datePickerOnChange = exports.teOnBlur = exports.onSearch = exports.checkOnChange = exports.selectOnChange = exports.updateCode = exports.numberOnChange = exports.textOnChange = exports.formItemLayout = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _antd = __webpack_require__(206);
	
	var _moment = __webpack_require__(40);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dnd_SgiFormEditorCommon = __webpack_require__(409);
	
	var _Dnd_SgiFormEditorCommonConstants = __webpack_require__(1570);
	
	var _sgiDndDevComFun = __webpack_require__(1573);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiMainComp = __webpack_require__(125);
	
	var _smProjDndConfig = __webpack_require__(240);
	
	var _smProjDndConfig2 = _interopRequireDefault(_smProjDndConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	var SHOW_PARENT = _antd.TreeSelect.SHOW_PARENT;
	
	var formItemLayout = {
	    labelCol: {
	        xs: { span: 24 },
	        sm: { span: 8 }
	    },
	    wrapperCol: {
	        xs: { span: 24 },
	        sm: { span: 16 }
	    }
	};
	
	var formCtlTypesDesid = ["EP_EO_UI_3101", "EP_EO_UI_3102", "EP_EO_UI_3106", "EP_EO_UI_3105", "EP_EO_UI_3104", "EP_EO_UI_3122", "EP_EO_UI_3123", "EP_EO_UI_3107", "EP_EO_NUI_0001", "EP_EO_UI_3110", "EP_EO_UI_3108", "EP_EO_UI_3109", "EP_EO_UI_3011", "EP_EO_UI_3118", "EP_EO_UI_3114", "EP_EO_UI_3012"];
	
	var ctlTypeOption = [_react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3101' },
	    '\u6587\u672C\u6846'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3102' },
	    '\u6587\u672C\u57DF'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3106' },
	    '\u65E5\u671F\u63A7\u4EF6'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3105' },
	    '\u65F6\u95F4\u63A7\u4EF6'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3104' },
	    '\u6570\u5B57\u63A7\u4EF6'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3122' },
	    '\u7EA7\u8054\u63A7\u4EF6'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3123' },
	    'CodeMirror'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3107' },
	    '\u4E0B\u62C9\u6846'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_NUI_0001' },
	    '\u4E0B\u62C9\u6811'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3110' },
	    '\u590D\u9009\u6846'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3108' },
	    '\u590D\u9009\u6846\u7EC4'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3109' },
	    '\u5355\u9009\u6846\u7EC4'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3011' },
	    '\u5F39\u51FA\u7A97'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3118' },
	    '\u6587\u4EF6\u63A7\u4EF6'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3018' },
	    'tag'
	), _react2.default.createElement(
	    Option,
	    { value: 'EP_EO_UI_3012' },
	    '\u5BCC\u6587\u672C'
	)];
	
	var getModuleDesc2valuesHandler = function getModuleDesc2valuesHandler(dndDispatchObject, dnd_id) {
	    return {
	        set: function set(target, key, value, receiver) {
	            if (key === "_currentDndCtl") {
	                return Reflect.set(this, key, value);
	            } else if (key === "_prefix") {
	                return Reflect.set(this, key, value);
	            } else if (this._currentDndCtl) {
	                // if (key === "desId") this._currentDndCtl.changeComp();
	                // else this._currentDndCtl.refresh(key, value);
	                try {
	                    this._currentDndCtl.refresh(key, value);
	                } catch (error) {
	                    // console.log("第二次 回显的时候 ref丢失问题，暂时未解决，先注掉，别影响后续操作");
	                }
	            }
	            if (Object.prototype.toString.call(value) === "[object Object]") {
	                var proxyVal = new Proxy(value, getModuleDesc2valuesHandler(dndDispatchObject, dnd_id));
	                proxyVal._prefix = (this._prefix || "") + key + ".";
	                proxyVal._currentDndCtl = this._currentDndCtl;
	                return Reflect.set(target, key, proxyVal);
	            } else {
	                dndDispatchObject.updateUIJson(dnd_id, (this._prefix || "") + key, value);
	                return Reflect.set(target, key, value);
	            }
	        }
	    };
	};
	
	var textOnChange = function textOnChange(currentModule, attname, e, e2) {
	    var value = e.target.value;
	    currentModule.refresh(attname, value);
	};
	
	var datePickerOnChange = function datePickerOnChange(currentModule, attname, e, e2) {
	    var value = e2;
	    currentModule.refresh(attname, value);
	};
	
	var numberOnChange = function numberOnChange(currentModule, attname, e) {
	    var value = e;
	    currentModule.refresh(attname, value);
	};
	var updateCode = function updateCode(currentModule, attname, newCode) {
	    var value = newCode;
	    currentModule.refresh(attname, value);
	};
	
	var selectOnChange = function selectOnChange(currentModule, attname, value) {
	    //change传入对象为value
	    currentModule.refresh(attname, value);
	
	    //获取拖拽全局对象
	    var dndDispatchObject = currentModule.props.dndDispatchObject || currentModule.props.currentCtl.props.dndDispatchObject;
	
	    //如果属性是desId
	    //重置页面 重置编辑页面
	    if (attname == "desId") {
	        //更新编辑页面
	        (0, _sgiDndDevComFun.fitModalInfo)(currentModule.props.currentCtl);
	        // sgiDndDevComFun
	        //更新展示页面
	        var mainUI = dndDispatchObject.getMainUI();
	        mainUI.refresh();
	    }
	};
	
	var checkOnChange = function checkOnChange(currentModule, attname, e) {
	    var value = e.target.checked;
	    currentModule.refresh(attname, value);
	};
	
	var onSearch = function onSearch(currentModule, attname, e) {
	    var value = e.target.checked;
	    currentModule.refresh(attname, value);
	};
	
	var teOnBlur = function teOnBlur(currentModule, attname, attname2, e, e2) {
	    var ap = tool.Global.currentAP;
	    var tt = "RP";
	    var ss = "TR";
	    var val = e.target.value;
	    if (!val) return;
	
	    //调用校验保存方法
	    var result = PrmFactory.existResource(ap, tt, ss, val);
	    if (result) {
	        //如果存在则把表中数据放入该参数中
	        var sc = result.sc;
	        currentModule.refresh(attname, val);
	        currentModule.refresh(attname2, sc);
	        return;
	    }
	    //不存在该资源
	    var id = tool.uuidDate();
	    var newObj = { 'ap': ap, 'tt': tt, 'ss': ss, 'te': val, 'sc': id };
	    result = PrmFactory.saveResources(newObj);
	    if (result == 0) {
	        currentModule.refresh(attname, val);
	        currentModule.refresh(attname2, id);
	        console.log("文本资源保存成功");
	        // tool.popMsgDialog("提示", "文本资源保存成功！");
	    }
	};
	
	var ctrlHidFlg = function ctrlHidFlg(currentModule, attname, flg) {
	    currentModule.state["editorPropHiddenFlg_" + attname] = flg;
	};
	var getHidFlg = function getHidFlg(currentModule, attname) {
	    return currentModule.state["editorPropHiddenFlg_" + attname];
	};
	var vldCCtrlHidFlg = function vldCCtrlHidFlg(currentModule, value) {
	    // 如果是数字类型的值，可以进行最大值最小值限制
	    if (value && (value === "int" || value === "double" || value === "money" || value === "number")) {
	        ctrlHidFlg(currentModule, "minV", undefined);
	        ctrlHidFlg(currentModule, "maxV", undefined);
	    } else {
	        ctrlHidFlg(currentModule, "minV", true);
	        ctrlHidFlg(currentModule, "maxV", true);
	    }
	};
	
	var vldCOnChangeAndCtrlHidFlg = function vldCOnChangeAndCtrlHidFlg(currentModule, attname, e, e2) {
	    selectOnChange(currentModule, attname, e, e2);
	    vldCCtrlHidFlg(currentModule, e);
	};
	
	var getColUnit = function getColUnit(code, currentModule) {
	    switch (code) {
	        // 通用基本属性
	        case "te":
	            return getColFun(currentModule, "Input", "显示名称", code, 8, null, { onBlur: teOnBlur.bind(undefined, currentModule, "te", "teid"), placeholder: "组件的显示名称" });
	        case "alwBlk":
	            return getColFun(currentModule, "Checkbox", "允许为空", code, 3, { labelCol: { span: 20 } });
	        case "isDis":
	            return getColFun(currentModule, "Checkbox", "禁用", code, 2, { labelCol: { span: 18 } });
	        case "isRead":
	            return getColFun(currentModule, "Checkbox", "只读", code, 2, { labelCol: { span: 18 } });
	        case "isHdn":
	            return getColFun(currentModule, "Checkbox", "隐藏", code, 2, { labelCol: { span: 18 } });
	        case "isLbl":
	            return getColFun(currentModule, "Checkbox", "隐藏标签", code, 3, { labelCol: { span: 18 } });
	        case "isLabel":
	            return getColFun(currentModule, "Checkbox", "仅显示", code, 2, { labelCol: { span: 16 } });
	        case "nowrap":
	            return getColFun(currentModule, "Checkbox", "不换行", code, 2, { labelCol: { span: 16 } });
	        case "isPwd":
	            return getColFun(currentModule, "Checkbox", "密码控件", code, 3, { labelCol: { span: 14 } });
	        case "c":
	            return getColFun(currentModule, "Input", "属性名", code, 8, null, { placeholder: 'form绑定实例名中对应对象的属性key' });
	        case "c_mult":
	            return getColFun(currentModule, "Input", "属性名", "c", 8, null, { placeholder: '如对应多个属性key请使用","分割' });
	        case "cId":
	            return getColFun(currentModule, "Input", "控件id", code, 8, null, { placeholder: '组件的唯一标识' });
	        case "lblAlg":
	            return getColFun(currentModule, "Select", "标签位置", code, 8, null, null, [_react2.default.createElement(
	                Option,
	                { value: 'left' },
	                '\u9760\u5DE6'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'center' },
	                '\u5C45\u4E2D'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'right' },
	                '\u9760\u53F3'
	            )]);
	        case "lblW":
	            return getColFun(currentModule, "InputNumber", "标签宽度", code, 6, null, { defaultValue: 0 });
	        case "ctlW":
	            return getColFun(currentModule, "InputNumber", "组件宽度", code, 5, null, { defaultValue: 0 });
	        case "ctlH":
	            return getColFun(currentModule, "InputNumber", "组件高度", code, 5, null, { defaultValue: 0 });
	        case "desId":
	            return getColFun(currentModule, "Select", "组件类型", code, 8, null, { defaultValue: 'EP_EO_UI_3101' }, ctlTypeOption);
	
	        // 其他属性
	        case "vldC":
	            var value = currentModule.state.values[code];
	            vldCCtrlHidFlg(currentModule, value); //初始控制最大值、最小值显示
	            return getColFun(currentModule, "Select", "校验类型", code, 8, null, { onChange: vldCOnChangeAndCtrlHidFlg.bind(undefined, currentModule, code), placeholder: '--请选择--' }, [_react2.default.createElement(
	                Option,
	                { value: '' },
	                '\u65E0'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'int' },
	                '\u6574\u6570'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'double' },
	                'double'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'money' },
	                '\u91D1\u989D'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'email' },
	                'email'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'idcard18' },
	                '\u8EAB\u4EFD\u8BC1'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'phone' },
	                '\u7535\u8BDD\u53F7'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'mobile' },
	                '\u624B\u673A\u53F7'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'zip' },
	                '\u90AE\u653F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'url' },
	                'url'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'qq' },
	                'QQ\u53F7'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'number' },
	                '\u6570\u5B57'
	            ), _react2.default.createElement(
	                Option,
	                { value: '\u6C49\u5B57' },
	                '\u6C49\u5B57'
	            ), _react2.default.createElement(
	                Option,
	                { value: '\u5B57\u6BCD' },
	                '\u5B57\u6BCD'
	            )]);
	        case "defVal10":
	            return getColFun(currentModule, "Input", "初始值", code, 8, null, { placeholder: "初始值" });
	        case "escape":
	            return getColFun(currentModule, "Input", "转义", code, 8, null, { placeholder: "默认true/false，可输入1/0等" });
	        case "bdText":
	            return getColFun(currentModule, "Input", "文本后信息", code, 8, null, { placeholder: "文本后显示内容，常用作单位" });
	        case "minL":
	            return getColFun(currentModule, "InputNumber", "最小长度", code, 8, null, { defaultValue: 0 });
	        case "maxL":
	            return getColFun(currentModule, "InputNumber", "最大长度", code, 8, null, { defaultValue: 0 });
	        case "inpPopTe":
	            return getColFun(currentModule, "Input", "输入提示文本", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } });
	        case "emptyText":
	            return getColFun(currentModule, "Input", "下拉项为空提示", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } });
	        case "minV":
	            return getColFun(currentModule, "InputNumber", "最小值", code, 8, null, { defaultValue: 0 });
	        case "maxV":
	            return getColFun(currentModule, "InputNumber", "最大值", code, 8, null, { defaultValue: 0 });
	        case "step":
	            return getColFun(currentModule, "InputNumber", "微调间距", code, 8);
	        case "intDgt":
	            return getColFun(currentModule, "InputNumber", "整数位", code, 8);
	        case "dcmDgt":
	            return getColFun(currentModule, "InputNumber", "小数位", code, 8);
	        case "ctlRow":
	            return getColFun(currentModule, "InputNumber", "行数", code, 8, null, { defaultValue: 0 });
	        case "isScl":
	            return getColFun(currentModule, "Checkbox", "可滚动", code, 8);
	        case "dateFmt":
	            return getColFun(currentModule, "Input", "日期格式", code, 8, null, { placeholder: currentModule.state.fmtPlaceholder });
	        case "optBDt":
	            return getColFun(currentModule, "DatePicker", "可选的起始日期", code, 8, null, { format: currentModule.state.values.dateFmt || currentModule.state.fmtPlaceholder });
	        case "optEDt":
	            return getColFun(currentModule, "DatePicker", "可选的结束日期", code, 8, null, { format: currentModule.state.values.dateFmt || currentModule.state.fmtPlaceholder });
	        case "dateTimeFlag":
	            return getColFun(currentModule, "Checkbox", "是否显示时间", code, 8);
	        case "ctlMode":
	            return getColFun(currentModule, "Select", "组件模式", code, 8, null, { defaultValue: "date" }, [_react2.default.createElement(
	                Option,
	                { value: 'date' },
	                '\u65E5\u671F\u6A21\u5F0F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'dateTime' },
	                '\u65E5\u671F\u65F6\u95F4\u6A21\u5F0F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'month' },
	                '\u6708\u6A21\u5F0F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'week' },
	                '\u5468\u6A21\u5F0F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'year' },
	                '\u5E74\u6A21\u5F0F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'dateRange' },
	                '\u65E5\u671F\u8303\u56F4\u6A21\u5F0F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'dateTimeRange' },
	                '\u65E5\u671F\u65F6\u95F4\u8303\u56F4\u6A21\u5F0F'
	            )]);
	        case "hourStep":
	            return getColFun(currentModule, "InputNumber", "小时选项间隔", code, 8);
	        case "minuteStep":
	            return getColFun(currentModule, "InputNumber", "分钟选项间隔", code, 8);
	        case "secondStep":
	            return getColFun(currentModule, "InputNumber", "秒选项间隔", code, 8);
	        case "timeFmt":
	            return getColFun(currentModule, "Input", "时间格式", code, 8, null, { placeholder: "HH:mm:ss" });
	        case "btnN":
	            return getColFun(currentModule, "Input", "按钮名称", code, 8);
	        case "cluW":
	            return getColFun(currentModule, "InputNumber", "按钮宽度", code, 8);
	        case "iconPh":
	            return getColFun(currentModule, "Input", "按钮图标", code, 8);
	        case "disType":
	            return getColFun(currentModule, "Select", "上传列表样式", code, 8, null, { defaultValue: "text" }, [_react2.default.createElement(
	                Option,
	                { value: 'text' },
	                '\u57FA\u7840\u6837\u5F0F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'picture' },
	                '\u56FE\u7247\u5217\u8868\u6837\u5F0F'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'picture-card' },
	                '\u7167\u7247\u5899\u6837\u5F0F'
	            )]);
	        // case "accept": return getColFun(currentModule, "Input", "接受文件类型", code, 8);
	        case "accept":
	            return getColFun(currentModule, "Select", "接受文件类型", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } }, { placeholder: "所有文件", mode: "tags" }, [_react2.default.createElement(
	                Option,
	                { value: 'image/*' },
	                '\u56FE\u7247\u6587\u4EF6'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'audio/*' },
	                '\u97F3\u9891\u6587\u4EF6'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'video/*' },
	                '\u89C6\u9891\u6587\u4EF6'
	            ), _react2.default.createElement(
	                Option,
	                { value: '.jpg' },
	                'jpg\u6587\u4EF6'
	            ), _react2.default.createElement(
	                Option,
	                { value: '.png' },
	                'png\u6587\u4EF6'
	            ), _react2.default.createElement(
	                Option,
	                { value: '.doc' },
	                'doc\u6587\u4EF6'
	            ), _react2.default.createElement(
	                Option,
	                { value: '.', disabled: true },
	                '\u5176\u4ED6\u7C7B\u578B\u8BF7\u76F4\u63A5\u8F93\u5165\u540E\u7F00\uFF0C\u5982".docx"\u7B49\uFF0C\u7136\u540E\u6309\u56DE\u8F66\u952E\u5373\u53EF'
	            )]);
	        case "action":
	            return getColFun(currentModule, "Input", "上传地址", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } });
	        case "mulSel":
	            return getColFun(currentModule, "Checkbox", "多选", code, 2, { labelCol: { span: 18 } });
	        case "allowClear":
	            return getColFun(currentModule, "Checkbox", "支持清除", code, 3, { labelCol: { span: 18 } });
	        case "isDrag":
	            return getColFun(currentModule, "Checkbox", "拖拽样式", code, 3, { labelCol: { span: 18 } });
	        case "hdUpld":
	            return getColFun(currentModule, "Checkbox", "数量上限隐藏上传", code, 4, { labelCol: { span: 18 } });
	        case "nLimit":
	            return getColFun(currentModule, "InputNumber", "上传数量限制", code, 8);
	        case "isBttn":
	            return getColFun(currentModule, "Checkbox", "普通按钮", code, 3, { labelCol: { span: 18 } });
	        case "isHdnLst":
	            return getColFun(currentModule, "Checkbox", "隐藏文件列表", code, 4, { labelCol: { span: 18 } });
	        case "scId":
	            return (0, _Dnd_SgiFormEditorCommon.getSCEditor)(currentModule);
	        case "shows":
	            var treeData = currentModule.state.values.showsTreeData = (StandardCode.getSC(currentModule.state.values.scId) || []).map(function (sc) {
	                return { title: sc.te, value: sc.c };
	            });
	            return getColFun(currentModule, "TreeSelect", "显示项", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } }, {
	                placeholder: "默认全部",
	                treeData: treeData,
	                treeCheckable: true,
	                showCheckedStrategy: SHOW_PARENT
	            });
	        case "autoSel":
	            return getColFun(currentModule, "Checkbox", "自动选择", code, 3, { labelCol: { span: 18 } });
	        case "search":
	            return getColFun(currentModule, "Checkbox", "搜索框", code, 3, { labelCol: { span: 18 } });
	        case "checked":
	            return getColFun(currentModule, "Input", "默认选中项", code, 8, null, { placeholder: "默认选中项编码" });
	        case "isCustom":
	            return getColFun(currentModule, "Checkbox", "自定义", code, 8);
	        case "uid":
	            return getColFun(currentModule, "Input", "页面GUID", code, 8, null, { placeholder: "弹出页面的GUID标识" });
	        case "fileUploadUrl":
	            return getColFun(currentModule, "Input", "文件上传地址", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } }, { placeholder: "文件上传地址" });
	        case "toolbarHidden":
	            return getColFun(currentModule, "Checkbox", "隐藏工具条", code, 8);
	        case "current":
	            return getColFun(currentModule, "Input", "current？？？", code, 8);
	        case "progressDot":
	            return getColFun(currentModule, "Input", "点状步骤条", code, 8);
	        case "direction":
	            return getColFun(currentModule, "Select", "步骤条方向", code, 8, null, null, [_react2.default.createElement(
	                Option,
	                { value: 'top' },
	                '\u4E0A'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'bottom' },
	                '\u4E0B'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'left' },
	                '\u5DE6'
	            ), _react2.default.createElement(
	                Option,
	                { value: 'right' },
	                '\u53F3'
	            )]);
	        case "insName":
	            return getColFun(currentModule, "Input", "绑定实例名", code, 8, null, { placeholder: "绑定实例名" });
	        case "showKey":
	            return getColFun(currentModule, "Input", "显示属性名", code, 8, null, { placeholder: "用于显示的属性编码" });
	        case "saveKey":
	            return getColFun(currentModule, "Input", "保存属性名", code, 8, null, { placeholder: "实际存储的属性编码" });
	        case "numLimit":
	            return getColFun(currentModule, "InputNumber", "下拉数", code, 5);
	
	        case "selectType":
	            return getColFun(currentModule, "Select", "添加符号", code, 8, null, { placeholder: "默认无" }, [_react2.default.createElement(
	                Option,
	                { value: '00' },
	                '\u65E0'
	            ), _react2.default.createElement(
	                Option,
	                { value: '01' },
	                '\u91D1\u94B1\u7B26\u53F7'
	            ), _react2.default.createElement(
	                Option,
	                { value: '02' },
	                '\u767E\u5206\u6BD4\u7B26\u53F7'
	            )]);
	
	        case "occupiedSmall":
	            return getColFun(currentModule, "Input", "列数-小(比例24格)", code, 8, { labelCol: { span: 12 }, wrapperCol: { span: 12 } }, { placeholder: "默认6" });
	        case "occupiedBig":
	            return getColFun(currentModule, "Input", "列数-大(比例24格)", code, 8, { labelCol: { span: 12 }, wrapperCol: { span: 12 } }, { placeholder: "默认6" });
	        case "browserWidth":
	            return getColFun(currentModule, "Input", "浏览器对比宽度", code, 8, { labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { placeholder: "使用则必填，大于用大列" });
	        case "occupied":
	            return getColFun(currentModule, "Input", "单项占比", code, 8, { labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { placeholder: "24格划分" });
	        case "astrict":
	            return getColFun(currentModule, "Input", "显示最大数量", code, 8, { labelCol: { span: 8 }, wrapperCol: { span: 16 } });
	
	        default:
	            return _react2.default.createElement(
	                'div',
	                null,
	                '\u672A\u627E\u5230code\u4E3A\uFF1A',
	                code,
	                '\u7684\u7EC4\u4EF6'
	            );
	    }
	};
	
	var getColUnitByDesc = function getColUnitByDesc(ctlDesc, currentModule) {
	    return getColFun(currentModule, ctlDesc.ctlName, ctlDesc.te, ctlDesc.code, ctlDesc.span, ctlDesc.layout, ctlDesc.props, ctlDesc.children);
	};
	
	var getColFun = function getColFun(currentModule, itemType, label, keyCode, span, layout, props, children) {
	    //如果是隐藏状态，直接返回
	    if (getHidFlg(currentModule, keyCode)) return;
	
	    props = props || {};
	    // props.style = props.style || {};
	    layout = layout || formItemLayout;
	
	    // 前处理
	    // switch (itemType) {
	    //     case "InputNumber":
	    //         props.style.width = "100%"; //解决数字组件不充满问题
	    //         break;
	    //     default:
	    //         break;
	    // }
	
	    return _react2.default.createElement(
	        _antd.Col,
	        { span: span },
	        _react2.default.createElement(
	            FormItem,
	            _extends({}, layout, { label: label }),
	            getItemFun(currentModule, itemType, keyCode, props, children)
	        )
	    );
	};
	var getItemFun = function getItemFun(currentModule, itemType, keyCode, props, children) {
	    switch (itemType) {
	        case "Input":
	            return _react2.default.createElement(_antd.Input, _extends({}, props, { value: currentModule.state.values[keyCode], onChange: textOnChange.bind(undefined, currentModule, keyCode) }));
	        case "InputNumber":
	            return _react2.default.createElement(_antd.InputNumber, _extends({}, props, { value: currentModule.state.values[keyCode], onChange: numberOnChange.bind(undefined, currentModule, keyCode) }));
	        case "Checkbox":
	            return _react2.default.createElement(_antd.Checkbox, _extends({}, props, { checked: currentModule.state.values[keyCode], onChange: checkOnChange.bind(undefined, currentModule, keyCode) }));
	        case "Select":
	            return _react2.default.createElement(
	                _antd.Select,
	                _extends({ value: currentModule.state.values[keyCode], onChange: selectOnChange.bind(undefined, currentModule, keyCode) }, props),
	                children
	            );
	        case "TreeSelect":
	            return _react2.default.createElement(
	                _antd.TreeSelect,
	                _extends({ value: currentModule.state.values[keyCode], onChange: selectOnChange.bind(undefined, currentModule, keyCode) }, props),
	                children
	            );
	        case "DatePicker":
	            var dValue = currentModule.state.values[keyCode];var dFormat = props.format;
	            return _react2.default.createElement(_antd.DatePicker, _extends({}, props, { value: dValue ? (0, _moment2.default)(dValue, dFormat) : null, onChange: datePickerOnChange.bind(undefined, currentModule, keyCode) }));
	        default:
	            return _react2.default.createElement(
	                'div',
	                null,
	                '\u672A\u627E\u5230\u7C7B\u578B\u4E3A\uFF1A',
	                itemType,
	                '\u7684\u7EC4\u4EF6'
	            );
	    }
	};
	
	var getEditor = function getEditor(currentModule, type) {
	    type = type || "Common";
	    var editorCodes = _Dnd_SgiFormEditorCommonConstants.EditorTypes[type];
	    var _currentModule$props$ = currentModule.props.currentCtl.props,
	        dndDispatchObject = _currentModule$props$.dndDispatchObject,
	        moduleDesc = _currentModule$props$.moduleDesc;
	
	    if (window._popFormCtlEditorDesid == moduleDesc.dnd_id && Object.keys(window._popFormCtlEditor.props.children.props.moduleDesc).length > 0) {
	        return window._popFormCtlEditor;
	    } else {
	        window._popFormCtlEditorDesid = moduleDesc.dnd_id;
	    }
	    var currentNode = dndDispatchObject.findNodeByDndID(dndDispatchObject.getRootChildren(), moduleDesc.dnd_id);
	    if (formCtlTypesDesid.indexOf(currentNode.desId) >= 0) {
	        //创建开发平台开发的属性编辑页面 rtsd_UI_DSD_0004
	        // guid参数
	        // let guid = "rtsd_UI_DSD_0005";
	        var guid = _smProjDndConfig2.default.getDSDPreviewSelectGuid();
	        var ucvData = PrmFactory.getPrm(guid);
	        if (!ucvData) return null;
	        var objFct = new _ObjFactory.ObjFactory(guid);
	
	        var record = new Proxy(currentNode, getModuleDesc2valuesHandler(dndDispatchObject, moduleDesc.dnd_id));
	        record._currentDndCtl = currentModule;
	
	        objFct.set("dvRecord", record);
	        objFct.set("db_dv_item_info", record);
	        objFct.set("dnd_flag", true);
	        window._popFormCtlEditor = _react2.default.createElement(
	            'div',
	            { style: { width: '100%', height: '100%', overflow: 'auto' } },
	            _react2.default.createElement(_SgiMainComp.SgiMainComp, { key: tool.uuid(8), objFct: objFct, moduleDesc: ucvData })
	        );
	        return window._popFormCtlEditor;
	    } else {
	        window._popFormCtlEditor = _react2.default.createElement(
	            _antd.Form,
	            null,
	            editorCodes.map(function (rows) {
	                return _react2.default.createElement(
	                    _antd.Row,
	                    null,
	                    rows.map(function (col) {
	                        return getColUnit(col, currentModule);
	                    })
	                );
	            })
	        );
	        return window._popFormCtlEditor;
	    }
	};
	
	exports.formItemLayout = formItemLayout;
	exports.textOnChange = textOnChange;
	exports.numberOnChange = numberOnChange;
	exports.updateCode = updateCode;
	exports.selectOnChange = selectOnChange;
	exports.checkOnChange = checkOnChange;
	exports.onSearch = onSearch;
	exports.teOnBlur = teOnBlur;
	exports.datePickerOnChange = datePickerOnChange;
	exports.getColUnit = getColUnit;
	exports.getEditor = getEditor;
	exports.getColUnitByDesc = getColUnitByDesc;
	exports.getHidFlg = getHidFlg;
	exports.ctrlHidFlg = ctrlHidFlg;
	exports.vldCCtrlHidFlg = vldCCtrlHidFlg;
	exports.vldCOnChangeAndCtrlHidFlg = vldCOnChangeAndCtrlHidFlg;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1574)
	var ieee754 = __webpack_require__(1875)
	var isArray = __webpack_require__(1576)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = undefined;
	
	var _echarts = __webpack_require__(1612);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _core = __webpack_require__(1610);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// export the Component the echarts Object.
	var EchartsReact = function (_EchartsReactCore) {
	  _inherits(EchartsReact, _EchartsReactCore);
	
	  function EchartsReact(props) {
	    _classCallCheck(this, EchartsReact);
	
	    var _this = _possibleConstructorReturn(this, (EchartsReact.__proto__ || Object.getPrototypeOf(EchartsReact)).call(this, props));
	
	    _this.echartsLib = _echarts2['default'];
	    return _this;
	  }
	
	  return EchartsReact;
	}(_core2['default']);
	
	exports['default'] = EchartsReact;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js
	
	function ExtensionAPI(chartInstance) {
	  zrUtil.each(echartsAPIList, function (name) {
	    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
	  }, this);
	}
	
	var _default = ExtensionAPI;
	module.exports = _default;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, actionInfos) {
	  zrUtil.each(actionInfos, function (actionInfo) {
	    actionInfo.update = 'updateView';
	    /**
	     * @payload
	     * @property {string} seriesName
	     * @property {string} name
	     */
	
	    echarts.registerAction(actionInfo, function (payload, ecModel) {
	      var selected = {};
	      ecModel.eachComponent({
	        mainType: 'series',
	        subType: seriesType,
	        query: payload
	      }, function (seriesModel) {
	        if (seriesModel[actionInfo.method]) {
	          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
	        }
	
	        var data = seriesModel.getData(); // Create selected map
	
	        data.each(function (idx) {
	          var name = data.getName(idx);
	          selected[name] = seriesModel.isSelected(name) || false;
	        });
	      });
	      return {
	        name: payload.name,
	        selected: selected,
	        seriesId: payload.seriesId
	      };
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var _roamHelper = __webpack_require__(410);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} [componentType=series]
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	echarts.registerAction({
	  type: 'geoRoam',
	  event: 'geoRoam',
	  update: 'updateTransform'
	}, function (payload, ecModel) {
	  var componentType = payload.componentType || 'series';
	  ecModel.eachComponent({
	    mainType: componentType,
	    query: payload
	  }, function (componentModel) {
	    var geo = componentModel.coordinateSystem;
	
	    if (geo.type !== 'geo') {
	      return;
	    }
	
	    var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'));
	    componentModel.setCenter && componentModel.setCenter(res.center);
	    componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
	    // So the center and zoom must be in sync. Include the series not selected by legend
	
	    if (componentType === 'series') {
	      zrUtil.each(componentModel.seriesGroup, function (seriesModel) {
	        seriesModel.setCenter(res.center);
	        seriesModel.setZoom(res.zoom);
	      });
	    }
	  });
	});

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(66);
	
	var createListFromArray = __webpack_require__(113);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.__base_bar__',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  getMarkerPosition: function (value) {
	    var coordSys = this.coordinateSystem;
	
	    if (coordSys) {
	      // PENDING if clamp ?
	      var pt = coordSys.dataToPoint(coordSys.clampData(value));
	      var data = this.getData();
	      var offset = data.getLayout('offset');
	      var size = data.getLayout('size');
	      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
	      pt[offsetIndex] += offset + size / 2;
	      return pt;
	    }
	
	    return [NaN, NaN];
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    // stack: null
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // 最小高度改为0
	    barMinHeight: 0,
	    // 最小角度为0，仅对极坐标系下的柱状图有效
	    barMinAngle: 0,
	    // cursor: null,
	    large: false,
	    largeThreshold: 400,
	    progressive: 3e3,
	    progressiveChunkMode: 'mod',
	    // barMaxWidth: null,
	    // In cartesian, the default value is 1. Otherwise null.
	    // barMinWidth: null,
	    // 默认自适应
	    // barWidth: null,
	    // 柱间距离，默认为柱形宽度的30%，可设固定值
	    // barGap: '30%',
	    // 类目间柱形距离，默认为类目间距的20%，可设固定值
	    // barCategoryGap: '20%',
	    // label: {
	    //      show: false
	    // },
	    itemStyle: {},
	    emphasis: {}
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var _labelHelper = __webpack_require__(414);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
	  var labelModel = itemModel.getModel('label');
	  var hoverLabelModel = itemModel.getModel('emphasis.label');
	  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: dataIndex,
	    defaultText: getDefaultLabel(seriesModel.getData(), dataIndex),
	    isRectText: true,
	    autoColor: color
	  });
	  fixPosition(normalStyle);
	  fixPosition(hoverStyle);
	}
	
	function fixPosition(style, labelPositionOutside) {
	  if (style.textPosition === 'outside') {
	    style.textPosition = labelPositionOutside;
	  }
	}
	
	exports.setLabel = setLabel;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(49);
	
	var _graphHelper = __webpack_require__(411);
	
	var getSymbolSize = _graphHelper.getSymbolSize;
	var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;
	
	var zrUtil = __webpack_require__(2);
	
	var _multipleGraphEdgeHelper = __webpack_require__(266);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	var _symbolRadiansHalf = [];
	/**
	 * `basedOn` can be:
	 * 'value':
	 *     This layout is not accurate and have same bad case. For example,
	 *     if the min value is very smaller than the max value, the nodes
	 *     with the min value probably overlap even though there is enough
	 *     space to layout them. So we only use this approach in the as the
	 *     init layout of the force layout.
	 *     FIXME
	 *     Probably we do not need this method any more but use
	 *     `basedOn: 'symbolSize'` in force layout if
	 *     delay its init operations to GraphView.
	 * 'symbolSize':
	 *     This approach work only if all of the symbol size calculated.
	 *     That is, the progressive rendering is not applied to graph.
	 *     FIXME
	 *     If progressive rendering is applied to graph some day,
	 *     probably we have to use `basedOn: 'value'`.
	 *
	 * @param {module:echarts/src/model/Series} seriesModel
	 * @param {string} basedOn 'value' or 'symbolSize'
	 */
	
	function circularLayout(seriesModel, basedOn) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var rect = coordSys.getBoundingRect();
	  var nodeData = seriesModel.getData();
	  var graph = nodeData.graph;
	  var cx = rect.width / 2 + rect.x;
	  var cy = rect.height / 2 + rect.y;
	  var r = Math.min(rect.width, rect.height) / 2;
	  var count = nodeData.count();
	  nodeData.setLayout({
	    cx: cx,
	    cy: cy
	  });
	
	  if (!count) {
	    return;
	  }
	
	  _layoutNodesBasedOn[basedOn](seriesModel, coordSys, graph, nodeData, r, cx, cy, count);
	
	  graph.eachEdge(function (edge, index) {
	    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), getCurvenessForEdge(edge, seriesModel, index), 0);
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var cp1;
	    var x12 = (p1[0] + p2[0]) / 2;
	    var y12 = (p1[1] + p2[1]) / 2;
	
	    if (+curveness) {
	      curveness *= 3;
	      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
	    }
	
	    edge.setLayout([p1, p2, cp1]);
	  });
	}
	
	var _layoutNodesBasedOn = {
	  value: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
	    var angle = 0;
	    var sum = nodeData.getSum('value');
	    var unitAngle = Math.PI * 2 / (sum || count);
	    graph.eachNode(function (node) {
	      var value = node.getValue('value');
	      var radianHalf = unitAngle * (sum ? value : 1) / 2;
	      angle += radianHalf;
	      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	      angle += radianHalf;
	    });
	  },
	  symbolSize: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
	    var sumRadian = 0;
	    _symbolRadiansHalf.length = count;
	    var nodeScale = getNodeGlobalScale(seriesModel);
	    graph.eachNode(function (node) {
	      var symbolSize = getSymbolSize(node); // Normally this case will not happen, but we still add
	      // some the defensive code (2px is an arbitrary value).
	
	      isNaN(symbolSize) && (symbolSize = 2);
	      symbolSize < 0 && (symbolSize = 0);
	      symbolSize *= nodeScale;
	      var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.
	
	      isNaN(symbolRadianHalf) && (symbolRadianHalf = PI / 2);
	      _symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
	      sumRadian += symbolRadianHalf * 2;
	    });
	    var halfRemainRadian = (2 * PI - sumRadian) / count / 2;
	    var angle = 0;
	    graph.eachNode(function (node) {
	      var radianHalf = halfRemainRadian + _symbolRadiansHalf[node.dataIndex];
	      angle += radianHalf;
	      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	      angle += radianHalf;
	    });
	  }
	};
	exports.circularLayout = circularLayout;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(49);
	
	var zrUtil = __webpack_require__(2);
	
	var _multipleGraphEdgeHelper = __webpack_require__(266);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function simpleLayout(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var graph = seriesModel.getGraph();
	  graph.eachNode(function (node) {
	    var model = node.getModel();
	    node.setLayout([+model.get('x'), +model.get('y')]);
	  });
	  simpleLayoutEdge(graph, seriesModel);
	}
	
	function simpleLayoutEdge(graph, seriesModel) {
	  graph.eachEdge(function (edge, index) {
	    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), -getCurvenessForEdge(edge, seriesModel, index, true), 0);
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var points = [p1, p2];
	
	    if (+curveness) {
	      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
	    }
	
	    edge.setLayout(points);
	  });
	}
	
	exports.simpleLayout = simpleLayout;
	exports.simpleLayoutEdge = simpleLayoutEdge;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var Line = __webpack_require__(412);
	
	var zrUtil = __webpack_require__(2);
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var vec2 = __webpack_require__(49);
	
	var curveUtil = __webpack_require__(134);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	function EffectLine(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.add(this.createLine(lineData, idx, seriesScope));
	
	  this._updateEffectSymbol(lineData, idx);
	}
	
	var effectLineProto = EffectLine.prototype;
	
	effectLineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Line(lineData, idx, seriesScope);
	};
	
	effectLineProto._updateEffectSymbol = function (lineData, idx) {
	  var itemModel = lineData.getItemModel(idx);
	  var effectModel = itemModel.getModel('effect');
	  var size = effectModel.get('symbolSize');
	  var symbolType = effectModel.get('symbol');
	
	  if (!zrUtil.isArray(size)) {
	    size = [size, size];
	  }
	
	  var color = effectModel.get('color') || lineData.getItemVisual(idx, 'color');
	  var symbol = this.childAt(1);
	
	  if (this._symbolType !== symbolType) {
	    // Remove previous
	    this.remove(symbol);
	    symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
	    symbol.z2 = 100;
	    symbol.culling = true;
	    this.add(symbol);
	  } // Symbol may be removed if loop is false
	
	
	  if (!symbol) {
	    return;
	  } // Shadow color is same with color in default
	
	
	  symbol.setStyle('shadowColor', color);
	  symbol.setStyle(effectModel.getItemStyle(['color']));
	  symbol.attr('scale', size);
	  symbol.setColor(color);
	  symbol.attr('scale', size);
	  this._symbolType = symbolType;
	  this._symbolScale = size;
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	effectLineProto._updateEffectAnimation = function (lineData, effectModel, idx) {
	  var symbol = this.childAt(1);
	
	  if (!symbol) {
	    return;
	  }
	
	  var self = this;
	  var points = lineData.getItemLayout(idx);
	  var period = effectModel.get('period') * 1000;
	  var loop = effectModel.get('loop');
	  var constantSpeed = effectModel.get('constantSpeed');
	  var delayExpr = zrUtil.retrieve(effectModel.get('delay'), function (idx) {
	    return idx / lineData.count() * period / 3;
	  });
	  var isDelayFunc = typeof delayExpr === 'function'; // Ignore when updating
	
	  symbol.ignore = true;
	  this.updateAnimationPoints(symbol, points);
	
	  if (constantSpeed > 0) {
	    period = this.getLineLength(symbol) / constantSpeed * 1000;
	  }
	
	  if (period !== this._period || loop !== this._loop) {
	    symbol.stopAnimation();
	    var delay = delayExpr;
	
	    if (isDelayFunc) {
	      delay = delayExpr(idx);
	    }
	
	    if (symbol.__t > 0) {
	      delay = -period * symbol.__t;
	    }
	
	    symbol.__t = 0;
	    var animator = symbol.animate('', loop).when(period, {
	      __t: 1
	    }).delay(delay).during(function () {
	      self.updateSymbolPosition(symbol);
	    });
	
	    if (!loop) {
	      animator.done(function () {
	        self.remove(symbol);
	      });
	    }
	
	    animator.start();
	  }
	
	  this._period = period;
	  this._loop = loop;
	};
	
	effectLineProto.getLineLength = function (symbol) {
	  // Not so accurate
	  return vec2.dist(symbol.__p1, symbol.__cp1) + vec2.dist(symbol.__cp1, symbol.__p2);
	};
	
	effectLineProto.updateAnimationPoints = function (symbol, points) {
	  symbol.__p1 = points[0];
	  symbol.__p2 = points[1];
	  symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
	};
	
	effectLineProto.updateData = function (lineData, idx, seriesScope) {
	  this.childAt(0).updateData(lineData, idx, seriesScope);
	
	  this._updateEffectSymbol(lineData, idx);
	};
	
	effectLineProto.updateSymbolPosition = function (symbol) {
	  var p1 = symbol.__p1;
	  var p2 = symbol.__p2;
	  var cp1 = symbol.__cp1;
	  var t = symbol.__t;
	  var pos = symbol.position;
	  var lastPos = [pos[0], pos[1]];
	  var quadraticAt = curveUtil.quadraticAt;
	  var quadraticDerivativeAt = curveUtil.quadraticDerivativeAt;
	  pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
	  pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent
	
	  var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
	  var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
	
	  if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
	    if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
	      var scaleY = vec2.dist(lastPos, pos) * 1.05;
	      symbol.attr('scale', [symbol.scale[0], scaleY]); // make sure the last segment render within endPoint
	
	      if (t === 1) {
	        pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
	        pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
	      }
	    } else if (symbol.__lastT === 1) {
	      // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
	      var scaleY = 2 * vec2.dist(p1, pos);
	      symbol.attr('scale', [symbol.scale[0], scaleY]);
	    } else {
	      symbol.attr('scale', this._symbolScale);
	    }
	  }
	
	  symbol.__lastT = symbol.__t;
	  symbol.ignore = false;
	};
	
	effectLineProto.updateLayout = function (lineData, idx) {
	  this.childAt(0).updateLayout(lineData, idx);
	  var effectModel = lineData.getItemModel(idx).getModel('effect');
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	zrUtil.inherits(EffectLine, graphic.Group);
	var _default = EffectLine;
	module.exports = _default;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function Polyline(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createPolyline(lineData, idx, seriesScope);
	}
	
	var polylineProto = Polyline.prototype;
	
	polylineProto._createPolyline = function (lineData, idx, seriesScope) {
	  // var seriesModel = lineData.hostModel;
	  var points = lineData.getItemLayout(idx);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    }
	  });
	  this.add(line);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childAt(0);
	  var target = {
	    shape: {
	      points: lineData.getItemLayout(idx)
	    }
	  };
	  graphic.updateProps(line, target, seriesModel, idx);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var line = this.childAt(0);
	  var itemModel = lineData.getItemModel(idx);
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	
	  if (!seriesScope || lineData.hasItemOption) {
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	  }
	
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle;
	  graphic.setHoverStyle(this);
	};
	
	polylineProto.updateLayout = function (lineData, idx) {
	  var polyline = this.childAt(0);
	  polyline.setShape('points', lineData.getItemLayout(idx));
	};
	
	zrUtil.inherits(Polyline, graphic.Group);
	var _default = Polyline;
	module.exports = _default;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var List = __webpack_require__(88);
	
	var Graph = __webpack_require__(1848);
	
	var linkList = __webpack_require__(851);
	
	var createDimensions = __webpack_require__(176);
	
	var CoordinateSystem = __webpack_require__(95);
	
	var createListFromArray = __webpack_require__(113);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(nodes, edges, seriesModel, directed, beforeLink) {
	  // ??? TODO
	  // support dataset?
	  var graph = new Graph(directed);
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(zrUtil.retrieve( // Id, name, dataIndex
	    nodes[i].id, nodes[i].name, i), i);
	  }
	
	  var linkNameList = [];
	  var validEdges = [];
	  var linkCount = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    var link = edges[i];
	    var source = link.source;
	    var target = link.target; // addEdge may fail when source or target not exists
	
	    if (graph.addEdge(source, target, linkCount)) {
	      validEdges.push(link);
	      linkNameList.push(zrUtil.retrieve(link.id, source + ' > ' + target));
	      linkCount++;
	    }
	  }
	
	  var coordSys = seriesModel.get('coordinateSystem');
	  var nodeData;
	
	  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
	    nodeData = createListFromArray(nodes, seriesModel);
	  } else {
	    var coordSysCtor = CoordinateSystem.get(coordSys);
	    var coordDimensions = coordSysCtor && coordSysCtor.type !== 'view' ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
	    // `value` dimension, but graph need `value` dimension. It's better to
	    // uniform this behavior.
	
	    if (zrUtil.indexOf(coordDimensions, 'value') < 0) {
	      coordDimensions.concat(['value']);
	    }
	
	    var dimensionNames = createDimensions(nodes, {
	      coordDimensions: coordDimensions
	    });
	    nodeData = new List(dimensionNames, seriesModel);
	    nodeData.initData(nodes);
	  }
	
	  var edgeData = new List(['value'], seriesModel);
	  edgeData.initData(validEdges, linkNameList);
	  beforeLink && beforeLink(nodeData, edgeData);
	  linkList({
	    mainData: nodeData,
	    struct: graph,
	    structAttr: 'graph',
	    datas: {
	      node: nodeData,
	      edge: edgeData
	    },
	    datasAttr: {
	      node: 'data',
	      edge: 'edgeData'
	    }
	  }); // Update dataIndex of nodes and edges because invalid edge may be removed
	
	  graph.update();
	  return graph;
	}
	
	module.exports = _default;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 * @property {number} [dataIndex]
	 */
	echarts.registerAction({
	  type: 'focusNodeAdjacency',
	  event: 'focusNodeAdjacency',
	  update: 'series:focusNodeAdjacency'
	}, function () {});
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 */
	
	echarts.registerAction({
	  type: 'unfocusNodeAdjacency',
	  event: 'unfocusNodeAdjacency',
	  update: 'series:unfocusNodeAdjacency'
	}, function () {});

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(170);
	
	var zrUtil = __webpack_require__(2);
	
	var _dimensionHelper = __webpack_require__(220);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _sourceHelper = __webpack_require__(114);
	
	var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var seriesModelMixin = {
	  /**
	   * @private
	   * @type {string}
	   */
	  _baseAxisDim: null,
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // When both types of xAxis and yAxis are 'value', layout is
	    // needed to be specified by user. Otherwise, layout can be
	    // judged by which axis is category.
	    var ordinalMeta;
	    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
	    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
	    var xAxisType = xAxisModel.get('type');
	    var yAxisType = yAxisModel.get('type');
	    var addOrdinal; // FIXME
	    // Consider time axis.
	
	    if (xAxisType === 'category') {
	      option.layout = 'horizontal';
	      ordinalMeta = xAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else if (yAxisType === 'category') {
	      option.layout = 'vertical';
	      ordinalMeta = yAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else {
	      option.layout = option.layout || 'horizontal';
	    }
	
	    var coordDims = ['x', 'y'];
	    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
	    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
	    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
	    var axisModels = [xAxisModel, yAxisModel];
	    var baseAxisType = axisModels[baseAxisDimIndex].get('type');
	    var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
	    var data = option.data; // ??? FIXME make a stage to perform data transfrom.
	    // MUST create a new data, consider setOption({}) again.
	
	    if (data && addOrdinal) {
	      var newOptionData = [];
	      zrUtil.each(data, function (item, index) {
	        var newItem;
	
	        if (item.value && zrUtil.isArray(item.value)) {
	          newItem = item.value.slice();
	          item.value.unshift(index);
	        } else if (zrUtil.isArray(item)) {
	          newItem = item.slice();
	          item.unshift(index);
	        } else {
	          newItem = item;
	        }
	
	        newOptionData.push(newItem);
	      });
	      option.data = newOptionData;
	    }
	
	    var defaultValueDimensions = this.defaultValueDimensions;
	    var coordDimensions = [{
	      name: baseAxisDim,
	      type: getDimensionTypeByAxis(baseAxisType),
	      ordinalMeta: ordinalMeta,
	      otherDims: {
	        tooltip: false,
	        itemName: 0
	      },
	      dimsDef: ['base']
	    }, {
	      name: otherAxisDim,
	      type: getDimensionTypeByAxis(otherAxisType),
	      dimsDef: defaultValueDimensions.slice()
	    }];
	    return createListSimply(this, {
	      coordDimensions: coordDimensions,
	      dimensionsCount: defaultValueDimensions.length + 1,
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordDimensions, this)
	    });
	  },
	
	  /**
	   * If horizontal, base axis is x, otherwise y.
	   * @override
	   */
	  getBaseAxis: function () {
	    var dim = this._baseAxisDim;
	    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
	  }
	};
	exports.seriesModelMixin = seriesModelMixin;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataStackHelper = __webpack_require__(102);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var _util = __webpack_require__(2);
	
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
	 */
	function prepareDataCoordInfo(coordSys, data, valueOrigin) {
	  var baseAxis = coordSys.getBaseAxis();
	  var valueAxis = coordSys.getOtherAxis(baseAxis);
	  var valueStart = getValueStart(valueAxis, valueOrigin);
	  var baseAxisDim = baseAxis.dim;
	  var valueAxisDim = valueAxis.dim;
	  var valueDim = data.mapDimension(valueAxisDim);
	  var baseDim = data.mapDimension(baseAxisDim);
	  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
	  var dims = map(coordSys.dimensions, function (coordDim) {
	    return data.mapDimension(coordDim);
	  });
	  var stacked;
	  var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	  if (stacked |= isDimensionStacked(data, dims[0]
	  /*, dims[1]*/
	  )) {
	    // jshint ignore:line
	    dims[0] = stackResultDim;
	  }
	
	  if (stacked |= isDimensionStacked(data, dims[1]
	  /*, dims[0]*/
	  )) {
	    // jshint ignore:line
	    dims[1] = stackResultDim;
	  }
	
	  return {
	    dataDimsForPoint: dims,
	    valueStart: valueStart,
	    valueAxisDim: valueAxisDim,
	    baseAxisDim: baseAxisDim,
	    stacked: !!stacked,
	    valueDim: valueDim,
	    baseDim: baseDim,
	    baseDataOffset: baseDataOffset,
	    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
	  };
	}
	
	function getValueStart(valueAxis, valueOrigin) {
	  var valueStart = 0;
	  var extent = valueAxis.scale.getExtent();
	
	  if (valueOrigin === 'start') {
	    valueStart = extent[0];
	  } else if (valueOrigin === 'end') {
	    valueStart = extent[1];
	  } // auto
	  else {
	      // Both positive
	      if (extent[0] > 0) {
	        valueStart = extent[0];
	      } // Both negative
	      else if (extent[1] < 0) {
	          valueStart = extent[1];
	        } // If is one positive, and one negative, onZero shall be true
	
	    }
	
	  return valueStart;
	}
	
	function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
	  var value = NaN;
	
	  if (dataCoordInfo.stacked) {
	    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
	  }
	
	  if (isNaN(value)) {
	    value = dataCoordInfo.valueStart;
	  }
	
	  var baseDataOffset = dataCoordInfo.baseDataOffset;
	  var stackedData = [];
	  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
	  stackedData[1 - baseDataOffset] = value;
	  return coordSys.dataToPoint(stackedData);
	}
	
	exports.prepareDataCoordInfo = prepareDataCoordInfo;
	exports.getStackedOnPoint = getStackedOnPoint;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(55);
	
	var vec2 = __webpack_require__(49);
	
	var fixClipWithShadow = __webpack_require__(906);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Poly path support NaN point
	var vec2Min = vec2.min;
	var vec2Max = vec2.max;
	var scaleAndAdd = vec2.scaleAndAdd;
	var v2Copy = vec2.copy; // Temporary variable
	
	var v = [];
	var cp0 = [];
	var cp1 = [];
	
	function isPointNull(p) {
	  return isNaN(p[0]) || isNaN(p[1]);
	}
	
	function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  // if (smoothMonotone == null) {
	  //     if (isMono(points, 'x')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
	  //     }
	  //     else if (isMono(points, 'y')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
	  //     }
	  //     else {
	  //         return drawNonMono.apply(this, arguments);
	  //     }
	  // }
	  // else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
	  //     return drawMono.apply(this, arguments);
	  // }
	  // else {
	  //     return drawNonMono.apply(this, arguments);
	  // }
	  if (smoothMonotone === 'none' || !smoothMonotone) {
	    return drawNonMono.apply(this, arguments);
	  } else {
	    return drawMono.apply(this, arguments);
	  }
	}
	/**
	 * Check if points is in monotone.
	 *
	 * @param {number[][]} points         Array of points which is in [x, y] form
	 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
	 *                                    dimension that is checking.
	 *                                    If is 'none', `drawNonMono` should be
	 *                                    called.
	 *                                    If is undefined, either being monotone
	 *                                    in 'x' or 'y' will call `drawMono`.
	 */
	// function isMono(points, smoothMonotone) {
	//     if (points.length <= 1) {
	//         return true;
	//     }
	//     var dim = smoothMonotone === 'x' ? 0 : 1;
	//     var last = points[0][dim];
	//     var lastDiff = 0;
	//     for (var i = 1; i < points.length; ++i) {
	//         var diff = points[i][dim] - last;
	//         if (!isNaN(diff) && !isNaN(lastDiff)
	//             && diff !== 0 && lastDiff !== 0
	//             && ((diff >= 0) !== (lastDiff >= 0))
	//         ) {
	//             return false;
	//         }
	//         if (!isNaN(diff) && diff !== 0) {
	//             lastDiff = diff;
	//             last = points[i][dim];
	//         }
	//     }
	//     return true;
	// }
	
	/**
	 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
	 * control points will be used. This should be used when points are monotone
	 * either in x or y dimension.
	 */
	
	
	function drawMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	    } else {
	      if (smooth > 0) {
	        var prevP = points[prevIdx];
	        var dim = smoothMonotone === 'y' ? 1 : 0; // Length of control point to p, either in x or y, but not both
	
	        var ctrlLen = (p[dim] - prevP[dim]) * smooth;
	        v2Copy(cp0, prevP);
	        cp0[dim] = prevP[dim] + ctrlLen;
	        v2Copy(cp1, p);
	        cp1[dim] = p[dim] - ctrlLen;
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	/**
	 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
	 * situations. This should be used when points are non-monotone neither in x or
	 * y dimension.
	 */
	
	
	function drawNonMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	      v2Copy(cp0, p);
	    } else {
	      if (smooth > 0) {
	        var nextIdx = idx + dir;
	        var nextP = points[nextIdx];
	
	        if (connectNulls) {
	          // Find next point not null
	          while (nextP && isPointNull(points[nextIdx])) {
	            nextIdx += dir;
	            nextP = points[nextIdx];
	          }
	        }
	
	        var ratioNextSeg = 0.5;
	        var prevP = points[prevIdx];
	        var nextP = points[nextIdx]; // Last point
	
	        if (!nextP || isPointNull(nextP)) {
	          v2Copy(cp1, p);
	        } else {
	          // If next data is null in not connect case
	          if (isPointNull(nextP) && !connectNulls) {
	            nextP = p;
	          }
	
	          vec2.sub(v, nextP, prevP);
	          var lenPrevSeg;
	          var lenNextSeg;
	
	          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
	            var dim = smoothMonotone === 'x' ? 0 : 1;
	            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
	            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
	          } else {
	            lenPrevSeg = vec2.dist(p, prevP);
	            lenNextSeg = vec2.dist(p, nextP);
	          } // Use ratio of seg length
	
	
	          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
	          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
	        } // Smooth constraint
	
	
	        vec2Min(cp0, cp0, smoothMax);
	        vec2Max(cp0, cp0, smoothMin);
	        vec2Min(cp1, cp1, smoothMax);
	        vec2Max(cp1, cp1, smoothMin);
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment
	
	        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	
	function getBoundingBox(points, smoothConstraint) {
	  var ptMin = [Infinity, Infinity];
	  var ptMax = [-Infinity, -Infinity];
	
	  if (smoothConstraint) {
	    for (var i = 0; i < points.length; i++) {
	      var pt = points[i];
	
	      if (pt[0] < ptMin[0]) {
	        ptMin[0] = pt[0];
	      }
	
	      if (pt[1] < ptMin[1]) {
	        ptMin[1] = pt[1];
	      }
	
	      if (pt[0] > ptMax[0]) {
	        ptMax[0] = pt[0];
	      }
	
	      if (pt[1] > ptMax[1]) {
	        ptMax[1] = pt[1];
	      }
	    }
	  }
	
	  return {
	    min: smoothConstraint ? ptMin : ptMax,
	    max: smoothConstraint ? ptMax : ptMin
	  };
	}
	
	var Polyline = Path.extend({
	  type: 'ec-polyline',
	  shape: {
	    points: [],
	    smooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  style: {
	    fill: null,
	    stroke: '#000'
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var i = 0;
	    var len = points.length;
	    var result = getBoundingBox(points, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
	    }
	  }
	});
	var Polygon = Path.extend({
	  type: 'ec-polygon',
	  shape: {
	    points: [],
	    // Offset between stacked base points and points
	    stackedOnPoints: [],
	    smooth: 0,
	    stackedOnSmooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var stackedOnPoints = shape.stackedOnPoints;
	    var i = 0;
	    var len = points.length;
	    var smoothMonotone = shape.smoothMonotone;
	    var bbox = getBoundingBox(points, shape.smoothConstraint);
	    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
	      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
	      i += k + 1;
	      ctx.closePath();
	    }
	  }
	});
	exports.Polyline = Polyline;
	exports.Polygon = Polygon;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(171);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var _default = {
	  seriesType: 'lines',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var isPolyline = seriesModel.get('polyline');
	    var isLarge = seriesModel.pipelineContext.large;
	
	    function progress(params, lineData) {
	      var lineCoords = [];
	
	      if (isLarge) {
	        var points;
	        var segCount = params.end - params.start;
	
	        if (isPolyline) {
	          var totalCoordsCount = 0;
	
	          for (var i = params.start; i < params.end; i++) {
	            totalCoordsCount += seriesModel.getLineCoordsCount(i);
	          }
	
	          points = new Float32Array(segCount + totalCoordsCount * 2);
	        } else {
	          points = new Float32Array(segCount * 4);
	        }
	
	        var offset = 0;
	        var pt = [];
	
	        for (var i = params.start; i < params.end; i++) {
	          var len = seriesModel.getLineCoords(i, lineCoords);
	
	          if (isPolyline) {
	            points[offset++] = len;
	          }
	
	          for (var k = 0; k < len; k++) {
	            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
	            points[offset++] = pt[0];
	            points[offset++] = pt[1];
	          }
	        }
	
	        lineData.setLayout('linesPoints', points);
	      } else {
	        for (var i = params.start; i < params.end; i++) {
	          var itemModel = lineData.getItemModel(i);
	          var len = seriesModel.getLineCoords(i, lineCoords);
	          var pts = [];
	
	          if (isPolyline) {
	            for (var j = 0; j < len; j++) {
	              pts.push(coordSys.dataToPoint(lineCoords[j]));
	            }
	          } else {
	            pts[0] = coordSys.dataToPoint(lineCoords[0]);
	            pts[1] = coordSys.dataToPoint(lineCoords[1]);
	            var curveness = itemModel.get('lineStyle.curveness');
	
	            if (+curveness) {
	              pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
	            }
	          }
	
	          lineData.setItemLayout(i, pts);
	        }
	      }
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(47);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The tree layoutHelper implementation was originally copied from
	* "d3.js"(https://github.com/d3/d3-hierarchy) with
	* some modifications made for this project.
	* (see more details in the comment of the specific method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the licence of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	
	/**
	 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
	 *       the tree.
	 */
	
	/**
	 * Initialize all computational message for following algorithm.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree.
	 */
	function init(root) {
	  root.hierNode = {
	    defaultAncestor: null,
	    ancestor: root,
	    prelim: 0,
	    modifier: 0,
	    change: 0,
	    shift: 0,
	    i: 0,
	    thread: null
	  };
	  var nodes = [root];
	  var node;
	  var children;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    children = node.children;
	
	    if (node.isExpand && children.length) {
	      var n = children.length;
	
	      for (var i = n - 1; i >= 0; i--) {
	        var child = children[i];
	        child.hierNode = {
	          defaultAncestor: null,
	          ancestor: child,
	          prelim: 0,
	          modifier: 0,
	          change: 0,
	          shift: 0,
	          i: i,
	          thread: null
	        };
	        nodes.push(child);
	      }
	    }
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes a preliminary x coordinate for node. Before that, this function is
	 * applied recursively to the children of node, as well as the function
	 * apportion(). After spacing out the children by calling executeShifts(), the
	 * node is placed to the midpoint of its outermost children.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param {Function} separation
	 */
	
	
	function firstWalk(node, separation) {
	  var children = node.isExpand ? node.children : [];
	  var siblings = node.parentNode.children;
	  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
	
	  if (children.length) {
	    executeShifts(node);
	    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
	
	    if (subtreeW) {
	      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	      node.hierNode.modifier = node.hierNode.prelim - midPoint;
	    } else {
	      node.hierNode.prelim = midPoint;
	    }
	  } else if (subtreeW) {
	    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	  }
	
	  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes all real x-coordinates by summing up the modifiers recursively.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function secondWalk(node) {
	  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
	  node.setLayout({
	    x: nodeX
	  }, true);
	  node.hierNode.modifier += node.parentNode.hierNode.modifier;
	}
	
	function separation(cb) {
	  return arguments.length ? cb : defaultSeparation;
	}
	/**
	 * Transform the common coordinate to radial coordinate.
	 *
	 * @param  {number} x
	 * @param  {number} y
	 * @return {Object}
	 */
	
	
	function radialCoordinate(x, y) {
	  var radialCoor = {};
	  x -= Math.PI / 2;
	  radialCoor.x = y * Math.cos(x);
	  radialCoor.y = y * Math.sin(x);
	  return radialCoor;
	}
	/**
	 * Get the layout position of the whole view.
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	/**
	 * All other shifts, applied to the smaller subtrees between w- and w+, are
	 * performed by this function.
	 *
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function executeShifts(node) {
	  var children = node.children;
	  var n = children.length;
	  var shift = 0;
	  var change = 0;
	
	  while (--n >= 0) {
	    var child = children[n];
	    child.hierNode.prelim += shift;
	    child.hierNode.modifier += shift;
	    change += child.hierNode.change;
	    shift += child.hierNode.shift + change;
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * The core of the algorithm. Here, a new subtree is combined with the
	 * previous subtrees. Threads are used to traverse the inside and outside
	 * contours of the left and right subtree up to the highest common level.
	 * Whenever two nodes of the inside contours conflict, we compute the left
	 * one of the greatest uncommon ancestors using the function nextAncestor()
	 * and call moveSubtree() to shift the subtree and prepare the shifts of
	 * smaller subtrees. Finally, we add a new thread (if necessary).
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @param  {Function} separation
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function apportion(subtreeV, subtreeW, ancestor, separation) {
	  if (subtreeW) {
	    var nodeOutRight = subtreeV;
	    var nodeInRight = subtreeV;
	    var nodeOutLeft = nodeInRight.parentNode.children[0];
	    var nodeInLeft = subtreeW;
	    var sumOutRight = nodeOutRight.hierNode.modifier;
	    var sumInRight = nodeInRight.hierNode.modifier;
	    var sumOutLeft = nodeOutLeft.hierNode.modifier;
	    var sumInLeft = nodeInLeft.hierNode.modifier;
	
	    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
	      nodeOutRight = nextRight(nodeOutRight);
	      nodeOutLeft = nextLeft(nodeOutLeft);
	      nodeOutRight.hierNode.ancestor = subtreeV;
	      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
	
	      if (shift > 0) {
	        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
	        sumInRight += shift;
	        sumOutRight += shift;
	      }
	
	      sumInLeft += nodeInLeft.hierNode.modifier;
	      sumInRight += nodeInRight.hierNode.modifier;
	      sumOutRight += nodeOutRight.hierNode.modifier;
	      sumOutLeft += nodeOutLeft.hierNode.modifier;
	    }
	
	    if (nodeInLeft && !nextRight(nodeOutRight)) {
	      nodeOutRight.hierNode.thread = nodeInLeft;
	      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
	    }
	
	    if (nodeInRight && !nextLeft(nodeOutLeft)) {
	      nodeOutLeft.hierNode.thread = nodeInRight;
	      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
	      ancestor = subtreeV;
	    }
	  }
	
	  return ancestor;
	}
	/**
	 * This function is used to traverse the right contour of a subtree.
	 * It returns the rightmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextRight(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
	}
	/**
	 * This function is used to traverse the left contour of a subtree (or a subforest).
	 * It returns the leftmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextLeft(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
	}
	/**
	 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
	 * Otherwise, returns the specified ancestor.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextAncestor(nodeInLeft, node, ancestor) {
	  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Shifts the current subtree rooted at wr.
	 * This is done by increasing prelim(w+) and modifier(w+) by shift.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} wl
	 * @param  {module:echarts/data/Tree~TreeNode} wr
	 * @param  {number} shift [description]
	 */
	
	
	function moveSubtree(wl, wr, shift) {
	  var change = shift / (wr.hierNode.i - wl.hierNode.i);
	  wr.hierNode.change -= change;
	  wr.hierNode.shift += shift;
	  wr.hierNode.modifier += shift;
	  wr.hierNode.prelim += shift;
	  wl.hierNode.change += change;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	
	function defaultSeparation(node1, node2) {
	  return node1.parentNode === node2.parentNode ? 1 : 2;
	}
	
	exports.init = init;
	exports.firstWalk = firstWalk;
	exports.secondWalk = secondWalk;
	exports.separation = separation;
	exports.radialCoordinate = radialCoordinate;
	exports.getViewRect = getViewRect;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseAxisPointer = __webpack_require__(415);
	
	var viewHelper = __webpack_require__(268);
	
	var cartesianAxisHelper = __webpack_require__(843);
	
	var AxisView = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CartesianAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisPointerType = axisPointerModel.get('type');
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisExtent = axis.getGlobalExtent(true);
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var dimIndex = axis.dim === 'x' ? 0 : 1;
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
	
	    var tooltipOptions = [{
	      verticalAlign: 'middle'
	    }, {
	      align: 'center'
	    }];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: tooltipOptions[dimIndex]
	    };
	  }
	});
	
	function getCartesian(grid, axis) {
	  var opt = {};
	  opt[axis.dim + 'AxisIndex'] = axis.index;
	  return grid.getCartesian(opt);
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
	    return {
	      type: 'Line',
	      subPixelOptimize: true,
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
	    };
	  }
	};
	
	function getAxisDimIndex(axis) {
	  return axis.dim === 'x' ? 0 : 1;
	}
	
	AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
	var _default = CartesianAxisPointer;
	module.exports = _default;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var modelUtil = __webpack_require__(27);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} {point: [x, y], el: ...} point Will not be null.
	 */
	function _default(finder, ecModel) {
	  var point = [];
	  var seriesIndex = finder.seriesIndex;
	  var seriesModel;
	
	  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
	    return {
	      point: []
	    };
	  }
	
	  var data = seriesModel.getData();
	  var dataIndex = modelUtil.queryDataIndex(data, finder);
	
	  if (dataIndex == null || dataIndex < 0 || zrUtil.isArray(dataIndex)) {
	    return {
	      point: []
	    };
	  }
	
	  var el = data.getItemGraphicEl(dataIndex);
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (seriesModel.getTooltipPosition) {
	    point = seriesModel.getTooltipPosition(dataIndex) || [];
	  } else if (coordSys && coordSys.dataToPoint) {
	    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	      return data.mapDimension(dim);
	    }), dataIndex, true)) || [];
	  } else if (el) {
	    // Use graphic bounding rect
	    var rect = el.getBoundingRect().clone();
	    rect.applyTransform(el.transform);
	    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  }
	
	  return {
	    point: point,
	    el: el
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var each = zrUtil.each;
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Function} handler
	 *      param: {string} currTrigger
	 *      param: {Array.<number>} point
	 */
	
	function register(key, api, handler) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  inner(zr).records || (inner(zr).records = {});
	  initGlobalListeners(zr, api);
	  var record = inner(zr).records[key] || (inner(zr).records[key] = {});
	  record.handler = handler;
	}
	
	function initGlobalListeners(zr, api) {
	  if (inner(zr).initialized) {
	    return;
	  }
	
	  inner(zr).initialized = true;
	  useHandler('click', zrUtil.curry(doEnter, 'click'));
	  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
	
	  useHandler('globalout', onLeave);
	
	  function useHandler(eventType, cb) {
	    zr.on(eventType, function (e) {
	      var dis = makeDispatchAction(api);
	      each(inner(zr).records, function (record) {
	        record && cb(record, e, dis.dispatchAction);
	      });
	      dispatchTooltipFinally(dis.pendings, api);
	    });
	  }
	}
	
	function dispatchTooltipFinally(pendings, api) {
	  var showLen = pendings.showTip.length;
	  var hideLen = pendings.hideTip.length;
	  var actuallyPayload;
	
	  if (showLen) {
	    actuallyPayload = pendings.showTip[showLen - 1];
	  } else if (hideLen) {
	    actuallyPayload = pendings.hideTip[hideLen - 1];
	  }
	
	  if (actuallyPayload) {
	    actuallyPayload.dispatchAction = null;
	    api.dispatchAction(actuallyPayload);
	  }
	}
	
	function onLeave(record, e, dispatchAction) {
	  record.handler('leave', null, dispatchAction);
	}
	
	function doEnter(currTrigger, record, e, dispatchAction) {
	  record.handler(currTrigger, e, dispatchAction);
	}
	
	function makeDispatchAction(api) {
	  var pendings = {
	    showTip: [],
	    hideTip: []
	  }; // FIXME
	  // better approach?
	  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
	  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
	  // So we have to add "final stage" to merge those dispatched actions.
	
	  var dispatchAction = function (payload) {
	    var pendingList = pendings[payload.type];
	
	    if (pendingList) {
	      pendingList.push(payload);
	    } else {
	      payload.dispatchAction = dispatchAction;
	      api.dispatchAction(payload);
	    }
	  };
	
	  return {
	    dispatchAction: dispatchAction,
	    pendings: pendings
	  };
	}
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function unregister(key, api) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  var record = (inner(zr).records || {})[key];
	
	  if (record) {
	    inner(zr).records[key] = null;
	  }
	}
	
	exports.register = register;
	exports.unregister = unregister;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
	  var axis = axisModel.axis;
	
	  if (axis.scale.isBlank()) {
	    return;
	  }
	
	  var splitAreaModel = axisModel.getModel('splitArea');
	  var areaStyleModel = splitAreaModel.getModel('areaStyle');
	  var areaColors = areaStyleModel.get('color');
	  var gridRect = gridModel.coordinateSystem.getRect();
	  var ticksCoords = axis.getTicksCoords({
	    tickModel: splitAreaModel,
	    clamp: true
	  });
	
	  if (!ticksCoords.length) {
	    return;
	  } // For Making appropriate splitArea animation, the color and anid
	  // should be corresponding to previous one if possible.
	
	
	  var areaColorsLen = areaColors.length;
	  var lastSplitAreaColors = axisView.__splitAreaColors;
	  var newSplitAreaColors = zrUtil.createHashMap();
	  var colorIndex = 0;
	
	  if (lastSplitAreaColors) {
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
	
	      if (cIndex != null) {
	        colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
	        break;
	      }
	    }
	  }
	
	  var prev = axis.toGlobalCoord(ticksCoords[0].coord);
	  var areaStyle = areaStyleModel.getAreaStyle();
	  areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];
	
	  for (var i = 1; i < ticksCoords.length; i++) {
	    var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (axis.isHorizontal()) {
	      x = prev;
	      y = gridRect.y;
	      width = tickCoord - x;
	      height = gridRect.height;
	      prev = x + width;
	    } else {
	      x = gridRect.x;
	      y = prev;
	      width = gridRect.width;
	      height = tickCoord - y;
	      prev = y + height;
	    }
	
	    var tickValue = ticksCoords[i - 1].tickValue;
	    tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
	    axisGroup.add(new graphic.Rect({
	      anid: tickValue != null ? 'area_' + tickValue : null,
	      shape: {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      },
	      style: zrUtil.defaults({
	        fill: areaColors[colorIndex]
	      }, areaStyle),
	      silent: true
	    }));
	    colorIndex = (colorIndex + 1) % areaColorsLen;
	  }
	
	  axisView.__splitAreaColors = newSplitAreaColors;
	}
	
	function rectCoordAxisHandleRemove(axisView) {
	  axisView.__splitAreaColors = null;
	}
	
	exports.rectCoordAxisBuildSplitArea = rectCoordAxisBuildSplitArea;
	exports.rectCoordAxisHandleRemove = rectCoordAxisHandleRemove;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var BoundingRect = __webpack_require__(51);
	
	var visualSolution = __webpack_require__(277);
	
	var selector = __webpack_require__(1745);
	
	var throttleUtil = __webpack_require__(131);
	
	var BrushTargetManager = __webpack_require__(822);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var STATE_LIST = ['inBrush', 'outOfBrush'];
	var DISPATCH_METHOD = '__ecBrushSelect';
	var DISPATCH_FLAG = '__ecInBrushSelectEvent';
	var PRIORITY_BRUSH = echarts.PRIORITY.VISUAL.BRUSH;
	/**
	 * Layout for visual, the priority higher than other layout, and before brush visual.
	 */
	
	echarts.registerLayout(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
	      brushType: false
	    });
	  });
	  layoutCovers(ecModel);
	});
	
	function layoutCovers(ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
	    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
	  });
	}
	/**
	 * Register the visual encoding if this modules required.
	 */
	
	
	echarts.registerVisual(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  var brushSelected = [];
	  var throttleType;
	  var throttleDelay;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel, brushIndex) {
	    var thisBrushSelected = {
	      brushId: brushModel.id,
	      brushIndex: brushIndex,
	      brushName: brushModel.name,
	      areas: zrUtil.clone(brushModel.areas),
	      selected: []
	    }; // Every brush component exists in event params, convenient
	    // for user to find by index.
	
	    brushSelected.push(thisBrushSelected);
	    var brushOption = brushModel.option;
	    var brushLink = brushOption.brushLink;
	    var linkedSeriesMap = [];
	    var selectedDataIndexForLink = [];
	    var rangeInfoBySeries = [];
	    var hasBrushExists = 0;
	
	    if (!brushIndex) {
	      // Only the first throttle setting works.
	      throttleType = brushOption.throttleType;
	      throttleDelay = brushOption.throttleDelay;
	    } // Add boundingRect and selectors to range.
	
	
	    var areas = zrUtil.map(brushModel.areas, function (area) {
	      return bindSelector(zrUtil.defaults({
	        boundingRect: boundingRectBuilders[area.brushType](area)
	      }, area));
	    });
	    var visualMappings = visualSolution.createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
	      mappingOption.mappingMethod = 'fixed';
	    });
	    zrUtil.isArray(brushLink) && zrUtil.each(brushLink, function (seriesIndex) {
	      linkedSeriesMap[seriesIndex] = 1;
	    });
	
	    function linkOthers(seriesIndex) {
	      return brushLink === 'all' || linkedSeriesMap[seriesIndex];
	    } // If no supported brush or no brush on the series,
	    // all visuals should be in original state.
	
	
	    function brushed(rangeInfoList) {
	      return !!rangeInfoList.length;
	    }
	    /**
	     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
	     *
	     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
	     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
	     *   !brushed┘                                                                  └nothing.
	     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
	     */
	    // Step A
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
	      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
	    });
	
	    function stepAParallel(seriesModel, seriesIndex) {
	      var coordSys = seriesModel.coordinateSystem;
	      hasBrushExists |= coordSys.hasAxisBrushed();
	      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
	        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
	      });
	    }
	
	    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	
	      if (!selectorsByBrushType || brushModelNotControll(brushModel, seriesIndex)) {
	        return;
	      }
	
	      zrUtil.each(areas, function (area) {
	        selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
	        hasBrushExists |= brushed(rangeInfoList);
	      });
	
	      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
	        var data = seriesModel.getData();
	        data.each(function (dataIndex) {
	          if (checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) {
	            selectedDataIndexForLink[dataIndex] = 1;
	          }
	        });
	      }
	    } // Step B
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var seriesBrushSelected = {
	        seriesId: seriesModel.id,
	        seriesIndex: seriesIndex,
	        seriesName: seriesModel.name,
	        dataIndex: []
	      }; // Every series exists in event params, convenient
	      // for user to find series by seriesIndex.
	
	      thisBrushSelected.selected.push(seriesBrushSelected);
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	      var rangeInfoList = rangeInfoBySeries[seriesIndex];
	      var data = seriesModel.getData();
	      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
	        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      } : function (dataIndex) {
	        return checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      }; // If no supported brush or no brush, all visuals are in original state.
	
	      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && visualSolution.applyVisual(STATE_LIST, visualMappings, data, getValueState);
	    });
	  });
	  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
	});
	
	function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
	  // This event will not be triggered when `setOpion`, otherwise dead lock may
	  // triggered when do `setOption` in event listener, which we do not find
	  // satisfactory way to solve yet. Some considered resolutions:
	  // (a) Diff with prevoius selected data ant only trigger event when changed.
	  // But store previous data and diff precisely (i.e., not only by dataIndex, but
	  // also detect value changes in selected data) might bring complexity or fragility.
	  // (b) Use spectial param like `silent` to suppress event triggering.
	  // But such kind of volatile param may be weird in `setOption`.
	  if (!payload) {
	    return;
	  }
	
	  var zr = api.getZr();
	
	  if (zr[DISPATCH_FLAG]) {
	    return;
	  }
	
	  if (!zr[DISPATCH_METHOD]) {
	    zr[DISPATCH_METHOD] = doDispatch;
	  }
	
	  var fn = throttleUtil.createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
	  fn(api, brushSelected);
	}
	
	function doDispatch(api, brushSelected) {
	  if (!api.isDisposed()) {
	    var zr = api.getZr();
	    zr[DISPATCH_FLAG] = true;
	    api.dispatchAction({
	      type: 'brushSelect',
	      batch: brushSelected
	    });
	    zr[DISPATCH_FLAG] = false;
	  }
	}
	
	function checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
	  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
	    var area = rangeInfoList[i];
	
	    if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) {
	      return true;
	    }
	  }
	}
	
	function getSelectorsByBrushType(seriesModel) {
	  var brushSelector = seriesModel.brushSelector;
	
	  if (zrUtil.isString(brushSelector)) {
	    var sels = [];
	    zrUtil.each(selector, function (selectorsByElementType, brushType) {
	      sels[brushType] = function (dataIndex, data, selectors, area) {
	        var itemLayout = data.getItemLayout(dataIndex);
	        return selectorsByElementType[brushSelector](itemLayout, selectors, area);
	      };
	    });
	    return sels;
	  } else if (zrUtil.isFunction(brushSelector)) {
	    var bSelector = {};
	    zrUtil.each(selector, function (sel, brushType) {
	      bSelector[brushType] = brushSelector;
	    });
	    return bSelector;
	  }
	
	  return brushSelector;
	}
	
	function brushModelNotControll(brushModel, seriesIndex) {
	  var seriesIndices = brushModel.option.seriesIndex;
	  return seriesIndices != null && seriesIndices !== 'all' && (zrUtil.isArray(seriesIndices) ? zrUtil.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
	}
	
	function bindSelector(area) {
	  var selectors = area.selectors = {};
	  zrUtil.each(selector[area.brushType], function (selFn, elType) {
	    // Do not use function binding or curry for performance.
	    selectors[elType] = function (itemLayout) {
	      return selFn(itemLayout, selectors, area);
	    };
	  });
	  return area;
	}
	
	var boundingRectBuilders = {
	  lineX: zrUtil.noop,
	  lineY: zrUtil.noop,
	  rect: function (area) {
	    return getBoundingRectFromMinMax(area.range);
	  },
	  polygon: function (area) {
	    var minMax;
	    var range = area.range;
	
	    for (var i = 0, len = range.length; i < len; i++) {
	      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
	      var rg = range[i];
	      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
	      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
	      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
	      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
	    }
	
	    return minMax && getBoundingRectFromMinMax(minMax);
	  }
	};
	
	function getBoundingRectFromMinMax(minMax) {
	  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
	}
	
	exports.layoutCovers = layoutCovers;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(419);
	
	__webpack_require__(172);
	
	__webpack_require__(173);
	
	__webpack_require__(1751);
	
	__webpack_require__(1752);
	
	__webpack_require__(417);
	
	__webpack_require__(416);

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(419);
	
	__webpack_require__(172);
	
	__webpack_require__(173);
	
	__webpack_require__(1755);
	
	__webpack_require__(1756);
	
	__webpack_require__(417);
	
	__webpack_require__(416);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var ATTR = '\0_ec_hist_store';
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
	 */
	
	function push(ecModel, newSnapshot) {
	  var store = giveStore(ecModel); // If previous dataZoom can not be found,
	  // complete an range with current range.
	
	  each(newSnapshot, function (batchItem, dataZoomId) {
	    var i = store.length - 1;
	
	    for (; i >= 0; i--) {
	      var snapshot = store[i];
	
	      if (snapshot[dataZoomId]) {
	        break;
	      }
	    }
	
	    if (i < 0) {
	      // No origin range set, create one by current range.
	      var dataZoomModel = ecModel.queryComponents({
	        mainType: 'dataZoom',
	        subType: 'select',
	        id: dataZoomId
	      })[0];
	
	      if (dataZoomModel) {
	        var percentRange = dataZoomModel.getPercentRange();
	        store[0][dataZoomId] = {
	          dataZoomId: dataZoomId,
	          start: percentRange[0],
	          end: percentRange[1]
	        };
	      }
	    }
	  });
	  store.push(newSnapshot);
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} snapshot
	 */
	
	
	function pop(ecModel) {
	  var store = giveStore(ecModel);
	  var head = store[store.length - 1];
	  store.length > 1 && store.pop(); // Find top for all dataZoom.
	
	  var snapshot = {};
	  each(head, function (batchItem, dataZoomId) {
	    for (var i = store.length - 1; i >= 0; i--) {
	      var batchItem = store[i][dataZoomId];
	
	      if (batchItem) {
	        snapshot[dataZoomId] = batchItem;
	        break;
	      }
	    }
	  });
	  return snapshot;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function clear(ecModel) {
	  ecModel[ATTR] = null;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {number} records. always >= 1.
	 */
	
	
	function count(ecModel) {
	  return giveStore(ecModel).length;
	}
	/**
	 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
	 * History length of each dataZoom may be different.
	 * this._history[0] is used to store origin range.
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(ecModel) {
	  var store = ecModel[ATTR];
	
	  if (!store) {
	    store = ecModel[ATTR] = [{}];
	  }
	
	  return store;
	}
	
	exports.push = push;
	exports.pop = pop;
	exports.clear = clear;
	exports.count = count;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentModel = __webpack_require__(65);
	
	var ComponentView = __webpack_require__(275);
	
	var _sourceHelper = __webpack_require__(114);
	
	var detectSourceFormat = _sourceHelper.detectSourceFormat;
	
	var _sourceType = __webpack_require__(221);
	
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * This module is imported by echarts directly.
	 *
	 * Notice:
	 * Always keep this file exists for backward compatibility.
	 * Because before 4.1.0, dataset is an optional component,
	 * some users may import this module manually.
	 */
	ComponentModel.extend({
	  type: 'dataset',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // 'row', 'column'
	    seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
	    // null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
	    sourceHeader: null,
	    dimensions: null,
	    source: null
	  },
	  optionUpdated: function () {
	    detectSourceFormat(this);
	  }
	});
	ComponentView.extend({
	  type: 'dataset'
	});

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var modelUtil = __webpack_require__(27);
	
	var brushHelper = __webpack_require__(824);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var indexOf = zrUtil.indexOf;
	var curry = zrUtil.curry;
	var COORD_CONVERTS = ['dataToPoint', 'pointToData']; // FIXME
	// how to genarialize to more coordinate systems.
	
	var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
	/**
	 * [option in constructor]:
	 * {
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 * }
	 *
	 *
	 * [targetInfo]:
	 *
	 * There can be multiple axes in a single targetInfo. Consider the case
	 * of `grid` component, a targetInfo represents a grid which contains one or more
	 * cartesian and one or more axes. And consider the case of parallel system,
	 * which has multiple axes in a coordinate system.
	 * Can be {
	 *     panelId: ...,
	 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
	 *     coordSyses: all cartesians.
	 *     gridModel: <grid component>
	 *     xAxes: correspond to coordSyses on index
	 *     yAxes: correspond to coordSyses on index
	 * }
	 * or {
	 *     panelId: ...,
	 *     coordSys: <geo coord sys>
	 *     coordSyses: [<geo coord sys>]
	 *     geoModel: <geo component>
	 * }
	 *
	 *
	 * [panelOpt]:
	 *
	 * Make from targetInfo. Input to BrushController.
	 * {
	 *     panelId: ...,
	 *     rect: ...
	 * }
	 *
	 *
	 * [area]:
	 *
	 * Generated by BrushController or user input.
	 * {
	 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
	 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 *     range: pixel range.
	 *     coordRange: representitive coord range (the first one of coordRanges).
	 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
	 * }
	 */
	
	/**
	 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
	 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} [opt]
	 * @param {Array.<string>} [opt.include] include coordinate system types.
	 */
	
	function BrushTargetManager(option, ecModel, opt) {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  var targetInfoList = this._targetInfoList = [];
	  var info = {};
	  var foundCpts = parseFinder(ecModel, option);
	  each(targetInfoBuilders, function (builder, type) {
	    if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
	      builder(foundCpts, targetInfoList, info);
	    }
	  });
	}
	
	var proto = BrushTargetManager.prototype;
	
	proto.setOutputRanges = function (areas, ecModel) {
	  this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges
	
	    if (!area.coordRange) {
	      area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
	      // rebuild range by coordRange accrately, which may bring trouble when
	      // brushing only one item. So we use __rangeOffset to rebuilding range
	      // by coordRange. And this it only used in brush component so it is no
	      // need to be adapted to coordRanges.
	
	      var result = coordConvert[area.brushType](0, coordSys, coordRange);
	      area.__rangeOffset = {
	        offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
	        xyMinMax: result.xyMinMax
	      };
	    }
	  });
	};
	
	proto.matchOutputRanges = function (areas, ecModel, cb) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	
	    if (targetInfo && targetInfo !== true) {
	      zrUtil.each(targetInfo.coordSyses, function (coordSys) {
	        var result = coordConvert[area.brushType](1, coordSys, area.range);
	        cb(area, result.values, coordSys, ecModel);
	      });
	    }
	  }, this);
	};
	
	proto.setInputRanges = function (areas, ecModel) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	    area.range = area.range || []; // convert coordRange to global range and set panelId.
	
	    if (targetInfo && targetInfo !== true) {
	      area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
	      // not keep its original value, for the sake of the dataZoom scenario,
	      // where area.coordRange remains unchanged but area.range may be changed.
	      // (2) Only support converting one coordRange to pixel range in brush
	      // component. So do not consider `coordRanges`.
	      // (3) About __rangeOffset, see comment above.
	
	      var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
	      var rangeOffset = area.__rangeOffset;
	      area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
	    }
	  }, this);
	};
	
	proto.makePanelOpts = function (api, getDefaultBrushType) {
	  return zrUtil.map(this._targetInfoList, function (targetInfo) {
	    var rect = targetInfo.getPanelRect();
	    return {
	      panelId: targetInfo.panelId,
	      defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect)
	    };
	  });
	};
	
	proto.controlSeries = function (area, seriesModel, ecModel) {
	  // Check whether area is bound in coord, and series do not belong to that coord.
	  // If do not do this check, some brush (like lineX) will controll all axes.
	  var targetInfo = this.findTargetInfo(area, ecModel);
	  return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
	};
	/**
	 * If return Object, a coord found.
	 * If reutrn true, global found.
	 * Otherwise nothing found.
	 *
	 * @param {Object} area
	 * @param {Array} targetInfoList
	 * @return {Object|boolean}
	 */
	
	
	proto.findTargetInfo = function (area, ecModel) {
	  var targetInfoList = this._targetInfoList;
	  var foundCpts = parseFinder(ecModel, area);
	
	  for (var i = 0; i < targetInfoList.length; i++) {
	    var targetInfo = targetInfoList[i];
	    var areaPanelId = area.panelId;
	
	    if (areaPanelId) {
	      if (targetInfo.panelId === areaPanelId) {
	        return targetInfo;
	      }
	    } else {
	      for (var i = 0; i < targetInfoMatchers.length; i++) {
	        if (targetInfoMatchers[i](foundCpts, targetInfo)) {
	          return targetInfo;
	        }
	      }
	    }
	  }
	
	  return true;
	};
	
	function formatMinMax(minMax) {
	  minMax[0] > minMax[1] && minMax.reverse();
	  return minMax;
	}
	
	function parseFinder(ecModel, option) {
	  return modelUtil.parseFinder(ecModel, option, {
	    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
	  });
	}
	
	var targetInfoBuilders = {
	  grid: function (foundCpts, targetInfoList) {
	    var xAxisModels = foundCpts.xAxisModels;
	    var yAxisModels = foundCpts.yAxisModels;
	    var gridModels = foundCpts.gridModels; // Remove duplicated.
	
	    var gridModelMap = zrUtil.createHashMap();
	    var xAxesHas = {};
	    var yAxesHas = {};
	
	    if (!xAxisModels && !yAxisModels && !gridModels) {
	      return;
	    }
	
	    each(xAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	    });
	    each(yAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      yAxesHas[gridModel.id] = true;
	    });
	    each(gridModels, function (gridModel) {
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	      yAxesHas[gridModel.id] = true;
	    });
	    gridModelMap.each(function (gridModel) {
	      var grid = gridModel.coordinateSystem;
	      var cartesians = [];
	      each(grid.getCartesians(), function (cartesian, index) {
	        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
	          cartesians.push(cartesian);
	        }
	      });
	      targetInfoList.push({
	        panelId: 'grid--' + gridModel.id,
	        gridModel: gridModel,
	        coordSysModel: gridModel,
	        // Use the first one as the representitive coordSys.
	        coordSys: cartesians[0],
	        coordSyses: cartesians,
	        getPanelRect: panelRectBuilder.grid,
	        xAxisDeclared: xAxesHas[gridModel.id],
	        yAxisDeclared: yAxesHas[gridModel.id]
	      });
	    });
	  },
	  geo: function (foundCpts, targetInfoList) {
	    each(foundCpts.geoModels, function (geoModel) {
	      var coordSys = geoModel.coordinateSystem;
	      targetInfoList.push({
	        panelId: 'geo--' + geoModel.id,
	        geoModel: geoModel,
	        coordSysModel: geoModel,
	        coordSys: coordSys,
	        coordSyses: [coordSys],
	        getPanelRect: panelRectBuilder.geo
	      });
	    });
	  }
	};
	var targetInfoMatchers = [// grid
	function (foundCpts, targetInfo) {
	  var xAxisModel = foundCpts.xAxisModel;
	  var yAxisModel = foundCpts.yAxisModel;
	  var gridModel = foundCpts.gridModel;
	  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
	  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
	  return gridModel && gridModel === targetInfo.gridModel;
	}, // geo
	function (foundCpts, targetInfo) {
	  var geoModel = foundCpts.geoModel;
	  return geoModel && geoModel === targetInfo.geoModel;
	}];
	var panelRectBuilder = {
	  grid: function () {
	    // grid is not Transformable.
	    return this.coordSys.grid.getRect().clone();
	  },
	  geo: function () {
	    var coordSys = this.coordSys;
	    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform
	
	    rect.applyTransform(graphic.getTransform(coordSys));
	    return rect;
	  }
	};
	var coordConvert = {
	  lineX: curry(axisConvert, 0),
	  lineY: curry(axisConvert, 1),
	  rect: function (to, coordSys, rangeOrCoordRange) {
	    var xminymin = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]]);
	    var xmaxymax = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]]);
	    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
	    return {
	      values: values,
	      xyMinMax: values
	    };
	  },
	  polygon: function (to, coordSys, rangeOrCoordRange) {
	    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
	    var values = zrUtil.map(rangeOrCoordRange, function (item) {
	      var p = coordSys[COORD_CONVERTS[to]](item);
	      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
	      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
	      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
	      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
	      return p;
	    });
	    return {
	      values: values,
	      xyMinMax: xyMinMax
	    };
	  }
	};
	
	function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
	  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
	  var values = formatMinMax(zrUtil.map([0, 1], function (i) {
	    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
	  }));
	  var xyMinMax = [];
	  xyMinMax[axisNameIndex] = values;
	  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
	  return {
	    values: values,
	    xyMinMax: xyMinMax
	  };
	}
	
	var diffProcessor = {
	  lineX: curry(axisDiffProcessor, 0),
	  lineY: curry(axisDiffProcessor, 1),
	  rect: function (values, refer, scales) {
	    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
	  },
	  polygon: function (values, refer, scales) {
	    return zrUtil.map(values, function (item, idx) {
	      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
	    });
	  }
	};
	
	function axisDiffProcessor(axisNameIndex, values, refer, scales) {
	  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
	} // We have to process scale caused by dataZoom manually,
	// although it might be not accurate.
	
	
	function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
	  var sizeCurr = getSize(xyMinMaxCurr);
	  var sizeOrigin = getSize(xyMinMaxOrigin);
	  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
	  isNaN(scales[0]) && (scales[0] = 1);
	  isNaN(scales[1]) && (scales[1] = 1);
	  return scales;
	}
	
	function getSize(xyMinMax) {
	  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
	}
	
	var _default = BrushTargetManager;
	module.exports = _default;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var RoamController = __webpack_require__(218);
	
	var roamHelper = __webpack_require__(421);
	
	var _cursorHelper = __webpack_require__(269);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(17);
	
	var geoSourceManager = __webpack_require__(271);
	
	var _component = __webpack_require__(224);
	
	var getUID = _component.getUID;
	
	var Transformable = __webpack_require__(284);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getFixedItemStyle(model) {
	  var itemStyle = model.getItemStyle();
	  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
	  // they should both set areaColor and color to be null.
	
	  if (areaColor != null) {
	    itemStyle.fill = areaColor;
	  }
	
	  return itemStyle;
	}
	
	function updateMapSelectHandler(mapDraw, mapOrGeoModel, regionsGroup, api, fromView) {
	  regionsGroup.off('click');
	  regionsGroup.off('mousedown');
	
	  if (mapOrGeoModel.get('selectedMode')) {
	    regionsGroup.on('mousedown', function () {
	      mapDraw._mouseDownFlag = true;
	    });
	    regionsGroup.on('click', function (e) {
	      if (!mapDraw._mouseDownFlag) {
	        return;
	      }
	
	      mapDraw._mouseDownFlag = false;
	      var el = e.target;
	
	      while (!el.__regions) {
	        el = el.parent;
	      }
	
	      if (!el) {
	        return;
	      }
	
	      var action = {
	        type: (mapOrGeoModel.mainType === 'geo' ? 'geo' : 'map') + 'ToggleSelect',
	        batch: zrUtil.map(el.__regions, function (region) {
	          return {
	            name: region.name,
	            from: fromView.uid
	          };
	        })
	      };
	      action[mapOrGeoModel.mainType + 'Id'] = mapOrGeoModel.id;
	      api.dispatchAction(action);
	      updateMapSelected(mapOrGeoModel, regionsGroup);
	    });
	  }
	}
	
	function updateMapSelected(mapOrGeoModel, regionsGroup) {
	  // FIXME
	  regionsGroup.eachChild(function (otherRegionEl) {
	    zrUtil.each(otherRegionEl.__regions, function (region) {
	      otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? 'emphasis' : 'normal');
	    });
	  });
	}
	/**
	 * @alias module:echarts/component/helper/MapDraw
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {boolean} updateGroup
	 */
	
	
	function MapDraw(api, updateGroup) {
	  var group = new graphic.Group();
	  /**
	   * @type {string}
	   * @private
	   */
	
	  this.uid = getUID('ec_map_draw');
	  /**
	   * @type {module:echarts/component/helper/RoamController}
	   * @private
	   */
	
	  this._controller = new RoamController(api.getZr());
	  /**
	   * @type {Object} {target, zoom, zoomLimit}
	   * @private
	   */
	
	  this._controllerHost = {
	    target: updateGroup ? group : null
	  };
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = group;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._updateGroup = updateGroup;
	  /**
	   * This flag is used to make sure that only one among
	   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
	   * action may be triggered when `pan`, which is unexpected.
	   * @type {booelan}
	   */
	
	  this._mouseDownFlag;
	  /**
	   * @type {string}
	   */
	
	  this._mapName;
	  /**
	   * @type {boolean}
	   */
	
	  this._initialized;
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._regionsGroup = new graphic.Group());
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._backgroundGroup = new graphic.Group());
	}
	
	MapDraw.prototype = {
	  constructor: MapDraw,
	  draw: function (mapOrGeoModel, ecModel, api, fromView, payload) {
	    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
	    // will be assigned with map data. Other GEO model has no data.
	
	    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
	    isGeo && ecModel.eachComponent({
	      mainType: 'series',
	      subType: 'map'
	    }, function (mapSeries) {
	      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
	        data = mapSeries.getData();
	      }
	    });
	    var geo = mapOrGeoModel.coordinateSystem;
	
	    this._updateBackground(geo);
	
	    var regionsGroup = this._regionsGroup;
	    var group = this.group;
	    var transformInfo = geo.getTransformInfo(); // No animation when first draw or in action
	
	    var isFirstDraw = !regionsGroup.childAt(0) || payload;
	    var targetScale;
	
	    if (isFirstDraw) {
	      group.transform = transformInfo.roamTransform;
	      group.decomposeTransform();
	      group.dirty();
	    } else {
	      var target = new Transformable();
	      target.transform = transformInfo.roamTransform;
	      target.decomposeTransform();
	      var props = {
	        scale: target.scale,
	        position: target.position
	      };
	      targetScale = target.scale;
	      graphic.updateProps(group, props, mapOrGeoModel);
	    }
	
	    var scale = transformInfo.rawScale;
	    var position = transformInfo.rawPosition;
	    regionsGroup.removeAll();
	    var itemStyleAccessPath = ['itemStyle'];
	    var hoverItemStyleAccessPath = ['emphasis', 'itemStyle'];
	    var labelAccessPath = ['label'];
	    var hoverLabelAccessPath = ['emphasis', 'label'];
	    var nameMap = zrUtil.createHashMap();
	    zrUtil.each(geo.regions, function (region) {
	      // Consider in GeoJson properties.name may be duplicated, for example,
	      // there is multiple region named "United Kindom" or "France" (so many
	      // colonies). And it is not appropriate to merge them in geo, which
	      // will make them share the same label and bring trouble in label
	      // location calculation.
	      var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new graphic.Group());
	      var compoundPath = new graphic.CompoundPath({
	        segmentIgnoreThreshold: 1,
	        shape: {
	          paths: []
	        }
	      });
	      regionGroup.add(compoundPath);
	      var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
	      var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
	      var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
	      var itemStyle = getFixedItemStyle(itemStyleModel);
	      var hoverItemStyle = getFixedItemStyle(hoverItemStyleModel);
	      var labelModel = regionModel.getModel(labelAccessPath);
	      var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
	      var dataIdx; // Use the itemStyle in data if has data
	
	      if (data) {
	        dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
	        // But visual color of series is used in symbol drawing
	        //
	        // Visual color for each series is for the symbol draw
	
	        var visualColor = data.getItemVisual(dataIdx, 'color', true);
	
	        if (visualColor) {
	          itemStyle.fill = visualColor;
	        }
	      }
	
	      var transformPoint = function (point) {
	        return [point[0] * scale[0] + position[0], point[1] * scale[1] + position[1]];
	      };
	
	      zrUtil.each(region.geometries, function (geometry) {
	        if (geometry.type !== 'polygon') {
	          return;
	        }
	
	        var points = [];
	
	        for (var i = 0; i < geometry.exterior.length; ++i) {
	          points.push(transformPoint(geometry.exterior[i]));
	        }
	
	        compoundPath.shape.paths.push(new graphic.Polygon({
	          segmentIgnoreThreshold: 1,
	          shape: {
	            points: points
	          }
	        }));
	
	        for (var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); ++i) {
	          var interior = geometry.interiors[i];
	          var points = [];
	
	          for (var j = 0; j < interior.length; ++j) {
	            points.push(transformPoint(interior[j]));
	          }
	
	          compoundPath.shape.paths.push(new graphic.Polygon({
	            segmentIgnoreThreshold: 1,
	            shape: {
	              points: points
	            }
	          }));
	        }
	      });
	      compoundPath.setStyle(itemStyle);
	      compoundPath.style.strokeNoScale = true;
	      compoundPath.culling = true; // Label
	
	      var showLabel = labelModel.get('show');
	      var hoverShowLabel = hoverLabelModel.get('show');
	      var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
	      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
	      // 1. In map series and data value is NaN
	      // 2. In geo component
	      // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout
	
	      if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
	        var query = !isGeo ? dataIdx : region.name;
	        var labelFetcher; // Consider dataIdx not found.
	
	        if (!data || dataIdx >= 0) {
	          labelFetcher = mapOrGeoModel;
	        }
	
	        var textEl = new graphic.Text({
	          position: transformPoint(region.center.slice()),
	          // FIXME
	          // label rotation is not support yet in geo or regions of series-map
	          // that has no data. The rotation will be effected by this `scale`.
	          // So needed to change to RectText?
	          scale: [1 / group.scale[0], 1 / group.scale[1]],
	          z2: 10,
	          silent: true
	        });
	        graphic.setLabelStyle(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
	          labelFetcher: labelFetcher,
	          labelDataIndex: query,
	          defaultText: region.name,
	          useInsideStyle: false
	        }, {
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        });
	
	        if (!isFirstDraw) {
	          // Text animation
	          var textScale = [1 / targetScale[0], 1 / targetScale[1]];
	          graphic.updateProps(textEl, {
	            scale: textScale
	          }, mapOrGeoModel);
	        }
	
	        regionGroup.add(textEl);
	      } // setItemGraphicEl, setHoverStyle after all polygons and labels
	      // are added to the rigionGroup
	
	
	      if (data) {
	        data.setItemGraphicEl(dataIdx, regionGroup);
	      } else {
	        var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component
	
	        compoundPath.eventData = {
	          componentType: 'geo',
	          componentIndex: mapOrGeoModel.componentIndex,
	          geoIndex: mapOrGeoModel.componentIndex,
	          name: region.name,
	          region: regionModel && regionModel.option || {}
	        };
	      }
	
	      var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
	      groupRegions.push(region);
	      regionGroup.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode');
	      graphic.setHoverStyle(regionGroup, hoverItemStyle);
	      regionsGroup.add(regionGroup);
	    });
	
	    this._updateController(mapOrGeoModel, ecModel, api);
	
	    updateMapSelectHandler(this, mapOrGeoModel, regionsGroup, api, fromView);
	    updateMapSelected(mapOrGeoModel, regionsGroup);
	  },
	  remove: function () {
	    this._regionsGroup.removeAll();
	
	    this._backgroundGroup.removeAll();
	
	    this._controller.dispose();
	
	    this._mapName && geoSourceManager.removeGraphic(this._mapName, this.uid);
	    this._mapName = null;
	    this._controllerHost = {};
	  },
	  _updateBackground: function (geo) {
	    var mapName = geo.map;
	
	    if (this._mapName !== mapName) {
	      zrUtil.each(geoSourceManager.makeGraphic(mapName, this.uid), function (root) {
	        this._backgroundGroup.add(root);
	      }, this);
	    }
	
	    this._mapName = mapName;
	  },
	  _updateController: function (mapOrGeoModel, ecModel, api) {
	    var geo = mapOrGeoModel.coordinateSystem;
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
	    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
	
	    controller.enable(mapOrGeoModel.get('roam') || false);
	    var mainType = mapOrGeoModel.mainType;
	
	    function makeActionBase() {
	      var action = {
	        type: 'geoRoam',
	        componentType: mainType
	      };
	      action[mainType + 'Id'] = mapOrGeoModel.id;
	      return action;
	    }
	
	    controller.off('pan').on('pan', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        dx: e.dx,
	        dy: e.dy
	      }));
	    }, this);
	    controller.off('zoom').on('zoom', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      }));
	
	      if (this._updateGroup) {
	        var scale = this.group.scale;
	
	        this._regionsGroup.traverse(function (el) {
	          if (el.type === 'text') {
	            el.attr('scale', [1 / scale[0], 1 / scale[1]]);
	          }
	        });
	      }
	    }, this);
	    controller.setPointerChecker(function (e, x, y) {
	      return geo.getViewRectAfterRoam().contain(x, y) && !onIrrelevantElement(e, api, mapOrGeoModel);
	    });
	  }
	};
	var _default = MapDraw;
	module.exports = _default;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(51);
	
	var _cursorHelper = __webpack_require__(269);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphicUtil = __webpack_require__(17);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeRectPanelClipPath(rect) {
	  rect = normalizeRect(rect);
	  return function (localPoints, transform) {
	    return graphicUtil.clipPointsByRect(localPoints, rect);
	  };
	}
	
	function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
	  rect = normalizeRect(rect);
	  return function (xyIndex) {
	    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
	    var brushWidth = idx ? rect.width : rect.height;
	    var base = idx ? rect.x : rect.y;
	    return [base, base + (brushWidth || 0)];
	  };
	}
	
	function makeRectIsTargetByCursor(rect, api, targetModel) {
	  rect = normalizeRect(rect);
	  return function (e, localCursorPoint, transform) {
	    return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
	  };
	} // Consider width/height is negative.
	
	
	function normalizeRect(rect) {
	  return BoundingRect.create(rect);
	}
	
	exports.makeRectPanelClipPath = makeRectPanelClipPath;
	exports.makeLinearBrushOtherExtent = makeLinearBrushOtherExtent;
	exports.makeRectIsTargetByCursor = makeRectIsTargetByCursor;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ATTR = '\0_ec_interaction_mutex';
	
	function take(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  store[resourceKey] = userKey;
	}
	
	function release(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  var uKey = store[resourceKey];
	
	  if (uKey === userKey) {
	    store[resourceKey] = null;
	  }
	}
	
	function isTaken(zr, resourceKey) {
	  return !!getStore(zr)[resourceKey];
	}
	
	function getStore(zr) {
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	/**
	 * payload: {
	 *     type: 'takeGlobalCursor',
	 *     key: 'dataZoomSelect', or 'brush', or ...,
	 *         If no userKey, release global cursor.
	 * }
	 */
	
	
	echarts.registerAction({
	  type: 'takeGlobalCursor',
	  event: 'globalCursorTaken',
	  update: 'update'
	}, function () {});
	exports.take = take;
	exports.release = release;
	exports.isTaken = isTaken;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _layout = __webpack_require__(47);
	
	var getLayoutRect = _layout.getLayoutRect;
	var layoutBox = _layout.box;
	var positionElement = _layout.positionElement;
	
	var formatUtil = __webpack_require__(48);
	
	var graphic = __webpack_require__(17);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Layout list like component.
	 * It will box layout each items in group of component and then position the whole group in the viewport
	 * @param {module:zrender/group/Group} group
	 * @param {module:echarts/model/Component} componentModel
	 * @param {module:echarts/ExtensionAPI}
	 */
	function layout(group, componentModel, api) {
	  var boxLayoutParams = componentModel.getBoxLayoutParams();
	  var padding = componentModel.get('padding');
	  var viewportSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
	  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
	  positionElement(group, boxLayoutParams, viewportSize, padding);
	}
	
	function makeBackground(rect, componentModel) {
	  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
	  var style = componentModel.getItemStyle(['color', 'opacity']);
	  style.fill = componentModel.get('backgroundColor');
	  var rect = new graphic.Rect({
	    shape: {
	      x: rect.x - padding[3],
	      y: rect.y - padding[0],
	      width: rect.width + padding[1] + padding[3],
	      height: rect.height + padding[0] + padding[2],
	      r: componentModel.get('borderRadius')
	    },
	    style: style,
	    silent: true,
	    z2: -1
	  }); // FIXME
	  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
	  // and background rect when setting like `left: 0`, `top: 0`.
	  // graphic.subPixelOptimizeRect(rect);
	
	  return rect;
	}
	
	exports.layout = layout;
	exports.makeBackground = makeBackground;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(828);
	
	__webpack_require__(1765);
	
	__webpack_require__(829);
	
	var legendFilter = __webpack_require__(1766);
	
	var Component = __webpack_require__(65);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Do not contain scrollable legend, for sake of file size.
	// Series Filter
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.SERIES_FILTER, legendFilter);
	Component.registerSubTypeDefaulter('legend', function () {
	  // Default 'plain' when no type specified.
	  return 'plain';
	});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var Model = __webpack_require__(57);
	
	var _model = __webpack_require__(27);
	
	var isNameSpecified = _model.isNameSpecified;
	
	var lang = __webpack_require__(130);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var langSelector = lang.legend.selector;
	var defaultSelectorOption = {
	  all: {
	    type: 'all',
	    title: zrUtil.clone(langSelector.all)
	  },
	  inverse: {
	    type: 'inverse',
	    title: zrUtil.clone(langSelector.inverse)
	  }
	};
	var LegendModel = echarts.extendComponentModel({
	  type: 'legend.plain',
	  dependencies: ['series'],
	  layoutMode: {
	    type: 'box',
	    // legend.width/height are maxWidth/maxHeight actually,
	    // whereas realy width/height is calculated by its content.
	    // (Setting {left: 10, right: 10} does not make sense).
	    // So consider the case:
	    // `setOption({legend: {left: 10});`
	    // then `setOption({legend: {right: 10});`
	    // The previous `left` should be cleared by setting `ignoreSize`.
	    ignoreSize: true
	  },
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	    option.selected = option.selected || {};
	
	    this._updateSelector(option);
	  },
	  mergeOption: function (option) {
	    LegendModel.superCall(this, 'mergeOption', option);
	
	    this._updateSelector(option);
	  },
	  _updateSelector: function (option) {
	    var selector = option.selector;
	
	    if (selector === true) {
	      selector = option.selector = ['all', 'inverse'];
	    }
	
	    if (zrUtil.isArray(selector)) {
	      zrUtil.each(selector, function (item, index) {
	        zrUtil.isString(item) && (item = {
	          type: item
	        });
	        selector[index] = zrUtil.merge(item, defaultSelectorOption[item.type]);
	      });
	    }
	  },
	  optionUpdated: function () {
	    this._updateData(this.ecModel);
	
	    var legendData = this._data; // If selectedMode is single, try to select one
	
	    if (legendData[0] && this.get('selectedMode') === 'single') {
	      var hasSelected = false; // If has any selected in option.selected
	
	      for (var i = 0; i < legendData.length; i++) {
	        var name = legendData[i].get('name');
	
	        if (this.isSelected(name)) {
	          // Force to unselect others
	          this.select(name);
	          hasSelected = true;
	          break;
	        }
	      } // Try select the first if selectedMode is single
	
	
	      !hasSelected && this.select(legendData[0].get('name'));
	    }
	  },
	  _updateData: function (ecModel) {
	    var potentialData = [];
	    var availableNames = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      var seriesName = seriesModel.name;
	      availableNames.push(seriesName);
	      var isPotential;
	
	      if (seriesModel.legendVisualProvider) {
	        var provider = seriesModel.legendVisualProvider;
	        var names = provider.getAllNames();
	
	        if (!ecModel.isSeriesFiltered(seriesModel)) {
	          availableNames = availableNames.concat(names);
	        }
	
	        if (names.length) {
	          potentialData = potentialData.concat(names);
	        } else {
	          isPotential = true;
	        }
	      } else {
	        isPotential = true;
	      }
	
	      if (isPotential && isNameSpecified(seriesModel)) {
	        potentialData.push(seriesModel.name);
	      }
	    });
	    /**
	     * @type {Array.<string>}
	     * @private
	     */
	
	    this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
	    // which is convinient for user preparing option.
	
	    var rawData = this.get('data') || potentialData;
	    var legendData = zrUtil.map(rawData, function (dataItem) {
	      // Can be string or number
	      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
	        dataItem = {
	          name: dataItem
	        };
	      }
	
	      return new Model(dataItem, this, this.ecModel);
	    }, this);
	    /**
	     * @type {Array.<module:echarts/model/Model>}
	     * @private
	     */
	
	    this._data = legendData;
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Model>}
	   */
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @param {string} name
	   */
	  select: function (name) {
	    var selected = this.option.selected;
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      var data = this._data;
	      zrUtil.each(data, function (dataItem) {
	        selected[dataItem.get('name')] = false;
	      });
	    }
	
	    selected[name] = true;
	  },
	
	  /**
	   * @param {string} name
	   */
	  unSelect: function (name) {
	    if (this.get('selectedMode') !== 'single') {
	      this.option.selected[name] = false;
	    }
	  },
	
	  /**
	   * @param {string} name
	   */
	  toggleSelected: function (name) {
	    var selected = this.option.selected; // Default is true
	
	    if (!selected.hasOwnProperty(name)) {
	      selected[name] = true;
	    }
	
	    this[selected[name] ? 'unSelect' : 'select'](name);
	  },
	  allSelect: function () {
	    var data = this._data;
	    var selected = this.option.selected;
	    zrUtil.each(data, function (dataItem) {
	      selected[dataItem.get('name', true)] = true;
	    });
	  },
	  inverseSelect: function () {
	    var data = this._data;
	    var selected = this.option.selected;
	    zrUtil.each(data, function (dataItem) {
	      var name = dataItem.get('name', true); // Initially, default value is true
	
	      if (!selected.hasOwnProperty(name)) {
	        selected[name] = true;
	      }
	
	      selected[name] = !selected[name];
	    });
	  },
	
	  /**
	   * @param {string} name
	   */
	  isSelected: function (name) {
	    var selected = this.option.selected;
	    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
	  },
	  getOrient: function () {
	    return this.get('orient') === 'vertical' ? {
	      index: 1,
	      name: 'vertical'
	    } : {
	      index: 0,
	      name: 'horizontal'
	    };
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 4,
	    show: true,
	    // 布局方式，默认为水平布局，可选为：
	    // 'horizontal' | 'vertical'
	    orient: 'horizontal',
	    left: 'center',
	    // right: 'center',
	    top: 0,
	    // bottom: null,
	    // 水平对齐
	    // 'auto' | 'left' | 'right'
	    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
	    align: 'auto',
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 图例边框颜色
	    borderColor: '#ccc',
	    borderRadius: 0,
	    // 图例边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 图例内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 各个item之间的间隔，单位px，默认为10，
	    // 横向布局时为水平间隔，纵向布局时为纵向间隔
	    itemGap: 10,
	    // the width of legend symbol
	    itemWidth: 25,
	    // the height of legend symbol
	    itemHeight: 14,
	    // the color of unselected legend symbol
	    inactiveColor: '#ccc',
	    // the borderColor of unselected legend symbol
	    inactiveBorderColor: '#ccc',
	    itemStyle: {
	      // the default borderWidth of legend symbol
	      borderWidth: 0
	    },
	    textStyle: {
	      // 图例文字颜色
	      color: '#333'
	    },
	    // formatter: '',
	    // 选择模式，默认开启图例开关
	    selectedMode: true,
	    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
	    // selected: null,
	    // 图例内容（详见legend.data，数组中每一项代表一个item
	    // data: [],
	    // Usage:
	    // selector: [{type: 'all or inverse', title: xxx}]
	    // or
	    // selector: true
	    // or
	    // selector: ['all', 'inverse']
	    selector: false,
	    selectorLabel: {
	      show: true,
	      borderRadius: 10,
	      padding: [3, 5, 3, 5],
	      fontSize: 12,
	      fontFamily: ' sans-serif',
	      color: '#666',
	      borderWidth: 1,
	      borderColor: '#666'
	    },
	    emphasis: {
	      selectorLabel: {
	        show: true,
	        color: '#eee',
	        backgroundColor: '#666'
	      }
	    },
	    // Value can be 'start' or 'end'
	    selectorPosition: 'auto',
	    selectorItemGap: 7,
	    selectorButtonGap: 10,
	    // Tooltip 相关配置
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = LegendModel;
	module.exports = _default;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(17);
	
	var _listComponent = __webpack_require__(826);
	
	var makeBackground = _listComponent.makeBackground;
	
	var layoutUtil = __webpack_require__(47);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var Group = graphic.Group;
	
	var _default = echarts.extendComponentView({
	  type: 'legend.plain',
	  newlineDisabled: false,
	
	  /**
	   * @override
	   */
	  init: function () {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this.group.add(this._contentGroup = new Group());
	    /**
	     * @private
	     * @type {module:zrender/Element}
	     */
	
	    this._backgroundEl;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._selectorGroup = new Group());
	    /**
	     * If first rendering, `contentGroup.position` is [0, 0], which
	     * does not make sense and may cause unexepcted animation if adopted.
	     * @private
	     * @type {boolean}
	     */
	
	    this._isFirstRender = true;
	  },
	
	  /**
	   * @protected
	   */
	  getContentGroup: function () {
	    return this._contentGroup;
	  },
	
	  /**
	   * @protected
	   */
	  getSelectorGroup: function () {
	    return this._selectorGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (legendModel, ecModel, api) {
	    var isFirstRender = this._isFirstRender;
	    this._isFirstRender = false;
	    this.resetInner();
	
	    if (!legendModel.get('show', true)) {
	      return;
	    }
	
	    var itemAlign = legendModel.get('align');
	    var orient = legendModel.get('orient');
	
	    if (!itemAlign || itemAlign === 'auto') {
	      itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
	    }
	
	    var selector = legendModel.get('selector', true);
	    var selectorPosition = legendModel.get('selectorPosition', true);
	
	    if (selector && (!selectorPosition || selectorPosition === 'auto')) {
	      selectorPosition = orient === 'horizontal' ? 'end' : 'start';
	    }
	
	    this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.
	
	    var positionInfo = legendModel.getBoxLayoutParams();
	    var viewportSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var padding = legendModel.get('padding');
	    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
	    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.
	
	    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
	      width: mainRect.width,
	      height: mainRect.height
	    }, positionInfo), viewportSize, padding);
	    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.
	
	    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
	  },
	
	  /**
	   * @protected
	   */
	  resetInner: function () {
	    this.getContentGroup().removeAll();
	    this._backgroundEl && this.group.remove(this._backgroundEl);
	    this.getSelectorGroup().removeAll();
	  },
	
	  /**
	   * @protected
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	    var contentGroup = this.getContentGroup();
	    var legendDrawnMap = zrUtil.createHashMap();
	    var selectMode = legendModel.get('selectedMode');
	    var excludeSeriesId = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
	    });
	    each(legendModel.getData(), function (itemModel, dataIndex) {
	      var name = itemModel.get('name'); // Use empty string or \n as a newline string
	
	      if (!this.newlineDisabled && (name === '' || name === '\n')) {
	        contentGroup.add(new Group({
	          newline: true
	        }));
	        return;
	      } // Representitive series.
	
	
	      var seriesModel = ecModel.getSeriesByName(name)[0];
	
	      if (legendDrawnMap.get(name)) {
	        // Have been drawed
	        return;
	      } // Legend to control series.
	
	
	      if (seriesModel) {
	        var data = seriesModel.getData();
	        var color = data.getVisual('color');
	        var borderColor = data.getVisual('borderColor'); // If color is a callback function
	
	        if (typeof color === 'function') {
	          // Use the first data
	          color = color(seriesModel.getDataParams(0));
	        } // If borderColor is a callback function
	
	
	        if (typeof borderColor === 'function') {
	          // Use the first data
	          borderColor = borderColor(seriesModel.getDataParams(0));
	        } // Using rect symbol defaultly
	
	
	        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
	        var symbolType = data.getVisual('symbol');
	
	        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode);
	
	        itemGroup.on('click', curry(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
	        legendDrawnMap.set(name, true);
	      } else {
	        // Legend to control data. In pie and funnel.
	        ecModel.eachRawSeries(function (seriesModel) {
	          // In case multiple series has same data name
	          if (legendDrawnMap.get(name)) {
	            return;
	          }
	
	          if (seriesModel.legendVisualProvider) {
	            var provider = seriesModel.legendVisualProvider;
	
	            if (!provider.containName(name)) {
	              return;
	            }
	
	            var idx = provider.indexOfName(name);
	            var color = provider.getItemVisual(idx, 'color');
	            var borderColor = provider.getItemVisual(idx, 'borderColor');
	            var legendSymbolType = 'roundRect';
	
	            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, borderColor, selectMode); // FIXME: consider different series has items with the same name.
	
	
	            itemGroup.on('click', curry(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
	            // more than one pie series.
	            .on('mouseover', curry(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, null, name, api, excludeSeriesId));
	            legendDrawnMap.set(name, true);
	          }
	        }, this);
	      }
	    }, this);
	
	    if (selector) {
	      this._createSelector(selector, legendModel, api, orient, selectorPosition);
	    }
	  },
	  _createSelector: function (selector, legendModel, api, orient, selectorPosition) {
	    var selectorGroup = this.getSelectorGroup();
	    each(selector, function (selectorItem) {
	      createSelectorButton(selectorItem);
	    });
	
	    function createSelectorButton(selectorItem) {
	      var type = selectorItem.type;
	      var labelText = new graphic.Text({
	        style: {
	          x: 0,
	          y: 0,
	          align: 'center',
	          verticalAlign: 'middle'
	        },
	        onclick: function () {
	          api.dispatchAction({
	            type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
	          });
	        }
	      });
	      selectorGroup.add(labelText);
	      var labelModel = legendModel.getModel('selectorLabel');
	      var emphasisLabelModel = legendModel.getModel('emphasis.selectorLabel');
	      graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, emphasisLabelModel, {
	        defaultText: selectorItem.title,
	        isRectText: false
	      });
	      graphic.setHoverStyle(labelText);
	    }
	  },
	  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode) {
	    var itemWidth = legendModel.get('itemWidth');
	    var itemHeight = legendModel.get('itemHeight');
	    var inactiveColor = legendModel.get('inactiveColor');
	    var inactiveBorderColor = legendModel.get('inactiveBorderColor');
	    var symbolKeepAspect = legendModel.get('symbolKeepAspect');
	    var legendModelItemStyle = legendModel.getModel('itemStyle');
	    var isSelected = legendModel.isSelected(name);
	    var itemGroup = new Group();
	    var textStyleModel = itemModel.getModel('textStyle');
	    var itemIcon = itemModel.get('icon');
	    var tooltipModel = itemModel.getModel('tooltip');
	    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first
	
	    legendSymbolType = itemIcon || legendSymbolType;
	    var legendSymbol = createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	    symbolKeepAspect == null ? true : symbolKeepAspect);
	    itemGroup.add(setSymbolStyle(legendSymbol, legendSymbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected)); // Compose symbols
	    // PENDING
	
	    if (!itemIcon && symbolType // At least show one symbol, can't be all none
	    && (symbolType !== legendSymbolType || symbolType === 'none')) {
	      var size = itemHeight * 0.8;
	
	      if (symbolType === 'none') {
	        symbolType = 'circle';
	      }
	
	      var legendSymbolCenter = createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	      symbolKeepAspect == null ? true : symbolKeepAspect); // Put symbol in the center
	
	      itemGroup.add(setSymbolStyle(legendSymbolCenter, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected));
	    }
	
	    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
	    var textAlign = itemAlign;
	    var formatter = legendModel.get('formatter');
	    var content = name;
	
	    if (typeof formatter === 'string' && formatter) {
	      content = formatter.replace('{name}', name != null ? name : '');
	    } else if (typeof formatter === 'function') {
	      content = formatter(name);
	    }
	
	    itemGroup.add(new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: content,
	        x: textX,
	        y: itemHeight / 2,
	        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
	        textAlign: textAlign,
	        textVerticalAlign: 'middle'
	      })
	    })); // Add a invisible rect to increase the area of mouse hover
	
	    var hitRect = new graphic.Rect({
	      shape: itemGroup.getBoundingRect(),
	      invisible: true,
	      tooltip: tooltipModel.get('show') ? zrUtil.extend({
	        content: name,
	        // Defaul formatter
	        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
	          return name;
	        },
	        formatterParams: {
	          componentType: 'legend',
	          legendIndex: legendModel.componentIndex,
	          name: name,
	          $vars: ['name']
	        }
	      }, tooltipModel.option) : null
	    });
	    itemGroup.add(hitRect);
	    itemGroup.eachChild(function (child) {
	      child.silent = true;
	    });
	    hitRect.silent = !selectMode;
	    this.getContentGroup().add(itemGroup);
	    graphic.setHoverStyle(itemGroup);
	    itemGroup.__legendDataIndex = dataIndex;
	    return itemGroup;
	  },
	
	  /**
	   * @protected
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	    var contentGroup = this.getContentGroup();
	    var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
	    var contentRect = contentGroup.getBoundingRect();
	    var contentPos = [-contentRect.x, -contentRect.y];
	
	    if (selector) {
	      // Place buttons in selectorGroup
	      layoutUtil.box( // Buttons in selectorGroup always layout horizontally
	      'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	      var selectorRect = selectorGroup.getBoundingRect();
	      var selectorPos = [-selectorRect.x, -selectorRect.y];
	      var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	      var orientIdx = legendModel.getOrient().index;
	      var wh = orientIdx === 0 ? 'width' : 'height';
	      var hw = orientIdx === 0 ? 'height' : 'width';
	      var yx = orientIdx === 0 ? 'y' : 'x';
	
	      if (selectorPosition === 'end') {
	        selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
	      } else {
	        contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
	      } //Always align selector to content as 'middle'
	
	
	      selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
	      selectorGroup.attr('position', selectorPos);
	      contentGroup.attr('position', contentPos);
	      var mainRect = {
	        x: 0,
	        y: 0
	      };
	      mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
	      mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
	      mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
	      return mainRect;
	    } else {
	      contentGroup.attr('position', contentPos);
	      return this.group.getBoundingRect();
	    }
	  },
	
	  /**
	   * @protected
	   */
	  remove: function () {
	    this.getContentGroup().removeAll();
	    this._isFirstRender = true;
	  }
	});
	
	function setSymbolStyle(symbol, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected) {
	  var itemStyle;
	
	  if (symbolType !== 'line' && symbolType.indexOf('empty') < 0) {
	    itemStyle = legendModelItemStyle.getItemStyle();
	    symbol.style.stroke = borderColor;
	
	    if (!isSelected) {
	      itemStyle.stroke = inactiveBorderColor;
	    }
	  } else {
	    itemStyle = legendModelItemStyle.getItemStyle(['borderWidth', 'borderColor']);
	  }
	
	  return symbol.setStyle(itemStyle);
	}
	
	function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
	  // downplay before unselect
	  dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
	  api.dispatchAction({
	    type: 'legendToggleSelect',
	    name: seriesName != null ? seriesName : dataName
	  }); // highlight after select
	
	  dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
	}
	
	function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'highlight',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'downplay',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var throttleUtil = __webpack_require__(131);
	
	var parallelPreprocessor = __webpack_require__(1833);
	
	__webpack_require__(846);
	
	__webpack_require__(1832);
	
	__webpack_require__(1777);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CLICK_THRESHOLD = 5; // > 4
	// Parallel view
	
	echarts.extendComponentView({
	  type: 'parallel',
	  render: function (parallelModel, ecModel, api) {
	    this._model = parallelModel;
	    this._api = api;
	
	    if (!this._handlers) {
	      this._handlers = {};
	      zrUtil.each(handlers, function (handler, eventName) {
	        api.getZr().on(eventName, this._handlers[eventName] = zrUtil.bind(handler, this));
	      }, this);
	    }
	
	    throttleUtil.createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._handlers, function (handler, eventName) {
	      api.getZr().off(eventName, handler);
	    });
	    this._handlers = null;
	  },
	
	  /**
	   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
	   */
	  _throttledDispatchExpand: function (opt) {
	    this._dispatchExpand(opt);
	  },
	  _dispatchExpand: function (opt) {
	    opt && this._api.dispatchAction(zrUtil.extend({
	      type: 'parallelAxisExpand'
	    }, opt));
	  }
	});
	var handlers = {
	  mousedown: function (e) {
	    if (checkTrigger(this, 'click')) {
	      this._mouseDownPoint = [e.offsetX, e.offsetY];
	    }
	  },
	  mouseup: function (e) {
	    var mouseDownPoint = this._mouseDownPoint;
	
	    if (checkTrigger(this, 'click') && mouseDownPoint) {
	      var point = [e.offsetX, e.offsetY];
	      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
	
	      if (dist > CLICK_THRESHOLD) {
	        return;
	      }
	
	      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	
	      result.behavior !== 'none' && this._dispatchExpand({
	        axisExpandWindow: result.axisExpandWindow
	      });
	    }
	
	    this._mouseDownPoint = null;
	  },
	  mousemove: function (e) {
	    // Should do nothing when brushing.
	    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
	      return;
	    }
	
	    var model = this._model;
	    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	    var behavior = result.behavior;
	    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
	
	    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
	    : {
	      axisExpandWindow: result.axisExpandWindow,
	      // Jumping uses animation, and sliding suppresses animation.
	      animation: behavior === 'jump' ? null : false
	    });
	  }
	};
	
	function checkTrigger(view, triggerOn) {
	  var model = view._model;
	  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
	}
	
	echarts.registerPreprocessor(parallelPreprocessor);

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1847);
	
	__webpack_require__(1738);
	
	__webpack_require__(1843);
	
	__webpack_require__(216);
	
	__webpack_require__(1732);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendComponentView({
	  type: 'single'
	});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var preprocessor = __webpack_require__(837);
	
	__webpack_require__(838);
	
	__webpack_require__(839);
	
	__webpack_require__(1807);
	
	__webpack_require__(1808);
	
	__webpack_require__(840);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var preprocessor = __webpack_require__(837);
	
	__webpack_require__(838);
	
	__webpack_require__(839);
	
	__webpack_require__(1809);
	
	__webpack_require__(1810);
	
	__webpack_require__(840);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	var visualDefault = __webpack_require__(857);
	
	var VisualMapping = __webpack_require__(144);
	
	var visualSolution = __webpack_require__(277);
	
	var modelUtil = __webpack_require__(27);
	
	var numberUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mapVisual = VisualMapping.mapVisual;
	var eachVisual = VisualMapping.eachVisual;
	var isArray = zrUtil.isArray;
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	var linearMap = numberUtil.linearMap;
	var noop = zrUtil.noop;
	var VisualMapModel = echarts.extendComponentModel({
	  type: 'visualMap',
	  dependencies: ['series'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  stateList: ['inRange', 'outOfRange'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  replacableOptionKeys: ['inRange', 'outOfRange', 'target', 'controller', 'color'],
	
	  /**
	   * [lowerBound, upperBound]
	   *
	   * @readOnly
	   * @type {Array.<number>}
	   */
	  dataBound: [-Infinity, Infinity],
	
	  /**
	   * @readOnly
	   * @type {string|Object}
	   */
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    zlevel: 0,
	    z: 4,
	    seriesIndex: 'all',
	    // 'all' or null/undefined: all series.
	    // A number or an array of number: the specified series.
	    // set min: 0, max: 200, only for campatible with ec2.
	    // In fact min max should not have default value.
	    min: 0,
	    // min value, must specified if pieces is not specified.
	    max: 200,
	    // max value, must specified if pieces is not specified.
	    dimension: null,
	    inRange: null,
	    // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    outOfRange: null,
	    // 'color', 'colorHue', 'colorSaturation',
	    // 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    left: 0,
	    // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
	    right: null,
	    // The same as left.
	    top: null,
	    // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
	    bottom: 0,
	    // The same as top.
	    itemWidth: null,
	    itemHeight: null,
	    inverse: false,
	    orient: 'vertical',
	    // 'horizontal' ¦ 'vertical'
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderColor: '#ccc',
	    // 值域边框颜色
	    contentColor: '#5793f3',
	    inactiveColor: '#aaa',
	    borderWidth: 0,
	    // 值域边框线宽，单位px，默认为0（无边框）
	    padding: 5,
	    // 值域内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    textGap: 10,
	    //
	    precision: 0,
	    // 小数精度，默认为0，无小数点
	    color: null,
	    //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
	    formatter: null,
	    text: null,
	    // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
	    textStyle: {
	      color: '#333' // 值域文字颜色
	
	    }
	  },
	
	  /**
	   * @protected
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {Array.<number>}
	     */
	    this._dataExtent;
	    /**
	     * @readOnly
	     */
	
	    this.targetVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.controllerVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * [width, height]
	     * @readOnly
	     * @type {Array.<number>}
	     */
	
	    this.itemSize;
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	
	  /**
	   * @protected
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option; // FIXME
	    // necessary?
	    // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
	    this.textStyleModel = this.getModel('textStyle');
	    this.resetItemSize();
	    this.completeVisualOption();
	  },
	
	  /**
	   * @protected
	   */
	  resetVisual: function (supplementVisualOption) {
	    var stateList = this.stateList;
	    supplementVisualOption = zrUtil.bind(supplementVisualOption, this);
	    this.controllerVisuals = visualSolution.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
	    this.targetVisuals = visualSolution.createVisualMappings(this.option.target, stateList, supplementVisualOption);
	  },
	
	  /**
	   * @protected
	   * @return {Array.<number>} An array of series indices.
	   */
	  getTargetSeriesIndices: function () {
	    var optionSeriesIndex = this.option.seriesIndex;
	    var seriesIndices = [];
	
	    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
	      this.ecModel.eachSeries(function (seriesModel, index) {
	        seriesIndices.push(index);
	      });
	    } else {
	      seriesIndices = modelUtil.normalizeToArray(optionSeriesIndex);
	    }
	
	    return seriesIndices;
	  },
	
	  /**
	   * @public
	   */
	  eachTargetSeries: function (callback, context) {
	    zrUtil.each(this.getTargetSeriesIndices(), function (seriesIndex) {
	      callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
	    }, this);
	  },
	
	  /**
	   * @pubilc
	   */
	  isTargetSeries: function (seriesModel) {
	    var is = false;
	    this.eachTargetSeries(function (model) {
	      model === seriesModel && (is = true);
	    });
	    return is;
	  },
	
	  /**
	   * @example
	   * this.formatValueText(someVal); // format single numeric value to text.
	   * this.formatValueText(someVal, true); // format single category value to text.
	   * this.formatValueText([min, max]); // format numeric min-max to text.
	   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
	   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
	   *
	   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
	   * @param {boolean} [isCategory=false] Only available when value is number.
	   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
	   * @return {string}
	   * @protected
	   */
	  formatValueText: function (value, isCategory, edgeSymbols) {
	    var option = this.option;
	    var precision = option.precision;
	    var dataBound = this.dataBound;
	    var formatter = option.formatter;
	    var isMinMax;
	    var textValue;
	    edgeSymbols = edgeSymbols || ['<', '>'];
	
	    if (zrUtil.isArray(value)) {
	      value = value.slice();
	      isMinMax = true;
	    }
	
	    textValue = isCategory ? value : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);
	
	    if (zrUtil.isString(formatter)) {
	      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
	    } else if (zrUtil.isFunction(formatter)) {
	      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
	    }
	
	    if (isMinMax) {
	      if (value[0] === dataBound[0]) {
	        return edgeSymbols[0] + ' ' + textValue[1];
	      } else if (value[1] === dataBound[1]) {
	        return edgeSymbols[1] + ' ' + textValue[0];
	      } else {
	        return textValue[0] + ' - ' + textValue[1];
	      }
	    } else {
	      // Format single value (includes category case).
	      return textValue;
	    }
	
	    function toFixed(val) {
	      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetExtent: function () {
	    var thisOption = this.option; // Can not calculate data extent by data here.
	    // Because series and data may be modified in processing stage.
	    // So we do not support the feature "auto min/max".
	
	    var extent = asc([thisOption.min, thisOption.max]);
	    this._dataExtent = extent;
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/data/List} list
	   * @return {string} Concrete dimention. If return null/undefined,
	   *                  no dimension used.
	   */
	  getDataDimension: function (list) {
	    var optDim = this.option.dimension;
	    var listDimensions = list.dimensions;
	
	    if (optDim == null && !listDimensions.length) {
	      return;
	    }
	
	    if (optDim != null) {
	      return list.getDimension(optDim);
	    }
	
	    var dimNames = list.dimensions;
	
	    for (var i = dimNames.length - 1; i >= 0; i--) {
	      var dimName = dimNames[i];
	      var dimInfo = list.getDimensionInfo(dimName);
	
	      if (!dimInfo.isCalculationCoord) {
	        return dimName;
	      }
	    }
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getExtent: function () {
	    return this._dataExtent.slice();
	  },
	
	  /**
	   * @protected
	   */
	  completeVisualOption: function () {
	    var ecModel = this.ecModel;
	    var thisOption = this.option;
	    var base = {
	      inRange: thisOption.inRange,
	      outOfRange: thisOption.outOfRange
	    };
	    var target = thisOption.target || (thisOption.target = {});
	    var controller = thisOption.controller || (thisOption.controller = {});
	    zrUtil.merge(target, base); // Do not override
	
	    zrUtil.merge(controller, base); // Do not override
	
	    var isCategory = this.isCategory();
	    completeSingle.call(this, target);
	    completeSingle.call(this, controller);
	    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');
	
	    completeController.call(this, controller);
	
	    function completeSingle(base) {
	      // Compatible with ec2 dataRange.color.
	      // The mapping order of dataRange.color is: [high value, ..., low value]
	      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
	      // Notice: ec2 has no inverse.
	      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
	      // So adding color only when no inRange defined.
	      && !base.inRange) {
	        base.inRange = {
	          color: thisOption.color.slice().reverse()
	        };
	      } // Compatible with previous logic, always give a defautl color, otherwise
	      // simple config with no inRange and outOfRange will not work.
	      // Originally we use visualMap.color as the default color, but setOption at
	      // the second time the default color will be erased. So we change to use
	      // constant DEFAULT_COLOR.
	      // If user do not want the default color, set inRange: {color: null}.
	
	
	      base.inRange = base.inRange || {
	        color: ecModel.get('gradientColor')
	      }; // If using shortcut like: {inRange: 'symbol'}, complete default value.
	
	      each(this.stateList, function (state) {
	        var visualType = base[state];
	
	        if (zrUtil.isString(visualType)) {
	          var defa = visualDefault.get(visualType, 'active', isCategory);
	
	          if (defa) {
	            base[state] = {};
	            base[state][visualType] = defa;
	          } else {
	            // Mark as not specified.
	            delete base[state];
	          }
	        }
	      }, this);
	    }
	
	    function completeInactive(base, stateExist, stateAbsent) {
	      var optExist = base[stateExist];
	      var optAbsent = base[stateAbsent];
	
	      if (optExist && !optAbsent) {
	        optAbsent = base[stateAbsent] = {};
	        each(optExist, function (visualData, visualType) {
	          if (!VisualMapping.isValidType(visualType)) {
	            return;
	          }
	
	          var defa = visualDefault.get(visualType, 'inactive', isCategory);
	
	          if (defa != null) {
	            optAbsent[visualType] = defa; // Compatibable with ec2:
	            // Only inactive color to rgba(0,0,0,0) can not
	            // make label transparent, so use opacity also.
	
	            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
	              optAbsent.opacity = [0, 0];
	            }
	          }
	        });
	      }
	    }
	
	    function completeController(controller) {
	      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
	      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
	      var inactiveColor = this.get('inactiveColor');
	      each(this.stateList, function (state) {
	        var itemSize = this.itemSize;
	        var visuals = controller[state]; // Set inactive color for controller if no other color
	        // attr (like colorAlpha) specified.
	
	        if (!visuals) {
	          visuals = controller[state] = {
	            color: isCategory ? inactiveColor : [inactiveColor]
	          };
	        } // Consistent symbol and symbolSize if not specified.
	
	
	        if (visuals.symbol == null) {
	          visuals.symbol = symbolExists && zrUtil.clone(symbolExists) || (isCategory ? 'roundRect' : ['roundRect']);
	        }
	
	        if (visuals.symbolSize == null) {
	          visuals.symbolSize = symbolSizeExists && zrUtil.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
	        } // Filter square and none.
	
	
	        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
	          return symbol === 'none' || symbol === 'square' ? 'roundRect' : symbol;
	        }); // Normalize symbolSize
	
	        var symbolSize = visuals.symbolSize;
	
	        if (symbolSize != null) {
	          var max = -Infinity; // symbolSize can be object when categories defined.
	
	          eachVisual(symbolSize, function (value) {
	            value > max && (max = value);
	          });
	          visuals.symbolSize = mapVisual(symbolSize, function (value) {
	            return linearMap(value, [0, max], [0, itemSize[0]], true);
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetItemSize: function () {
	    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
	  },
	
	  /**
	   * @public
	   */
	  isCategory: function () {
	    return !!this.option.categories;
	  },
	
	  /**
	   * @public
	   * @abstract
	   */
	  setSelected: noop,
	
	  /**
	   * @public
	   * @abstract
	   * @param {*|module:echarts/data/List} valueOrData
	   * @param {number} dataIndex
	   * @return {string} state See this.stateList
	   */
	  getValueState: noop,
	
	  /**
	   * FIXME
	   * Do not publish to thirt-part-dev temporarily
	   * util the interface is stable. (Should it return
	   * a function but not visual meta?)
	   *
	   * @pubilc
	   * @abstract
	   * @param {Function} getColorVisual
	   *        params: value, valueState
	   *        return: color
	   * @return {Object} visualMeta
	   *        should includes {stops, outerColors}
	   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
	   */
	  getVisualMeta: noop
	});
	var _default = VisualMapModel;
	module.exports = _default;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var formatUtil = __webpack_require__(48);
	
	var layout = __webpack_require__(47);
	
	var VisualMapping = __webpack_require__(144);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'visualMap',
	
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	  autoPositionValues: {
	    left: 1,
	    right: 1,
	    top: 1,
	    bottom: 1
	  },
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/visualMap/visualMapModel}
	     */
	
	    this.visualMapModel;
	  },
	
	  /**
	   * @protected
	   */
	  render: function (visualMapModel, ecModel, api, payload) {
	    this.visualMapModel = visualMapModel;
	
	    if (visualMapModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    }
	
	    this.doRender.apply(this, arguments);
	  },
	
	  /**
	   * @protected
	   */
	  renderBackground: function (group) {
	    var visualMapModel = this.visualMapModel;
	    var padding = formatUtil.normalizeCssArray(visualMapModel.get('padding') || 0);
	    var rect = group.getBoundingRect();
	    group.add(new graphic.Rect({
	      z2: -1,
	      // Lay background rect on the lowest layer.
	      silent: true,
	      shape: {
	        x: rect.x - padding[3],
	        y: rect.y - padding[0],
	        width: rect.width + padding[3] + padding[1],
	        height: rect.height + padding[0] + padding[2]
	      },
	      style: {
	        fill: visualMapModel.get('backgroundColor'),
	        stroke: visualMapModel.get('borderColor'),
	        lineWidth: visualMapModel.get('borderWidth')
	      }
	    }));
	  },
	
	  /**
	   * @protected
	   * @param {number} targetValue can be Infinity or -Infinity
	   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
	   * @param {Object} [opts]
	   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
	   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
	   * @return {*} Visual value.
	   */
	  getControllerVisual: function (targetValue, visualCluster, opts) {
	    opts = opts || {};
	    var forceState = opts.forceState;
	    var visualMapModel = this.visualMapModel;
	    var visualObj = {}; // Default values.
	
	    if (visualCluster === 'symbol') {
	      visualObj.symbol = visualMapModel.get('itemSymbol');
	    }
	
	    if (visualCluster === 'color') {
	      var defaultColor = visualMapModel.get('contentColor');
	      visualObj.color = defaultColor;
	    }
	
	    function getter(key) {
	      return visualObj[key];
	    }
	
	    function setter(key, value) {
	      visualObj[key] = value;
	    }
	
	    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
	    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	    zrUtil.each(visualTypes, function (type) {
	      var visualMapping = mappings[type];
	
	      if (opts.convertOpacityToAlpha && type === 'opacity') {
	        type = 'colorAlpha';
	        visualMapping = mappings.__alphaForOpacity;
	      }
	
	      if (VisualMapping.dependsOn(type, visualCluster)) {
	        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
	      }
	    });
	    return visualObj[visualCluster];
	  },
	
	  /**
	   * @protected
	   */
	  positionGroup: function (group) {
	    var model = this.visualMapModel;
	    var api = this.api;
	    layout.positionElement(group, model.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  },
	
	  /**
	   * @protected
	   * @abstract
	   */
	  doRender: zrUtil.noop
	});
	
	module.exports = _default;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var _layout = __webpack_require__(47);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Array.<number>} itemSize always [short, long]
	 * @return {string} 'left' or 'right' or 'top' or 'bottom'
	 */
	function getItemAlign(visualMapModel, api, itemSize) {
	  var modelOption = visualMapModel.option;
	  var itemAlign = modelOption.align;
	
	  if (itemAlign != null && itemAlign !== 'auto') {
	    return itemAlign;
	  } // Auto decision align.
	
	
	  var ecSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
	  var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
	  var reals = paramsSet[realIndex];
	  var fakeValue = [0, null, 10];
	  var layoutInput = {};
	
	  for (var i = 0; i < 3; i++) {
	    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
	    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
	  }
	
	  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
	  var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
	  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
	}
	/**
	 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
	 * dataIndexInside means filtered index.
	 */
	
	
	function makeHighDownBatch(batch, visualMapModel) {
	  zrUtil.each(batch || [], function (batchItem) {
	    if (batchItem.dataIndex != null) {
	      batchItem.dataIndexInside = batchItem.dataIndex;
	      batchItem.dataIndex = null;
	    }
	
	    batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
	  });
	  return batch;
	}
	
	exports.getItemAlign = getItemAlign;
	exports.makeHighDownBatch = makeHighDownBatch;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(option) {
	  var visualMap = option && option.visualMap;
	
	  if (!zrUtil.isArray(visualMap)) {
	    visualMap = visualMap ? [visualMap] : [];
	  }
	
	  each(visualMap, function (opt) {
	    if (!opt) {
	      return;
	    } // rename splitList to pieces
	
	
	    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
	      opt.pieces = opt.splitList;
	      delete opt.splitList;
	    }
	
	    var pieces = opt.pieces;
	
	    if (pieces && zrUtil.isArray(pieces)) {
	      each(pieces, function (piece) {
	        if (zrUtil.isObject(piece)) {
	          if (has(piece, 'start') && !has(piece, 'min')) {
	            piece.min = piece.start;
	          }
	
	          if (has(piece, 'end') && !has(piece, 'max')) {
	            piece.max = piece.end;
	          }
	        }
	      });
	    }
	  });
	}
	
	function has(obj, name) {
	  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
	}
	
	module.exports = _default;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(65);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('visualMap', function (option) {
	  // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
	  return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
	});

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var visualSolution = __webpack_require__(277);
	
	var VisualMapping = __webpack_require__(144);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var VISUAL_PRIORITY = echarts.PRIORITY.VISUAL.COMPONENT;
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var resetDefines = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      var pipelineContext = seriesModel.pipelineContext;
	
	      if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
	        return;
	      }
	
	      resetDefines.push(visualSolution.incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, zrUtil.bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimension(seriesModel.getData())));
	    });
	    return resetDefines;
	  }
	}); // Only support color.
	
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var visualMetaList = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      if (visualMapModel.isTargetSeries(seriesModel)) {
	        var visualMeta = visualMapModel.getVisualMeta(zrUtil.bind(getColorVisual, null, seriesModel, visualMapModel)) || {
	          stops: [],
	          outerColors: []
	        };
	        var concreteDim = visualMapModel.getDataDimension(data);
	        var dimInfo = data.getDimensionInfo(concreteDim);
	
	        if (dimInfo != null) {
	          // visualMeta.dimension should be dimension index, but not concrete dimension.
	          visualMeta.dimension = dimInfo.index;
	          visualMetaList.push(visualMeta);
	        }
	      }
	    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
	
	    seriesModel.getData().setVisual('visualMeta', visualMetaList);
	  }
	}); // FIXME
	// performance and export for heatmap?
	// value can be Infinity or -Infinity
	
	function getColorVisual(seriesModel, visualMapModel, value, valueState) {
	  var mappings = visualMapModel.targetVisuals[valueState];
	  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	  var resultVisual = {
	    color: seriesModel.getData().getVisual('color') // default color.
	
	  };
	
	  for (var i = 0, len = visualTypes.length; i < len; i++) {
	    var type = visualTypes[i];
	    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
	    mapping && mapping.applyVisual(value, getVisual, setVisual);
	  }
	
	  return resultVisual.color;
	
	  function getVisual(key) {
	    return resultVisual[key];
	  }
	
	  function setVisual(key, value) {
	    resultVisual[key] = value;
	  }
	}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'selectDataRange',
	  event: 'dataRangeSelected',
	  // FIXME use updateView appears wrong
	  update: 'update'
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'visualMap',
	    query: payload
	  }, function (model) {
	    model.setSelected(payload.selected);
	  });
	});

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var defaultOption = {
	  show: true,
	  zlevel: 0,
	  z: 0,
	  // Inverse the axis.
	  inverse: false,
	  // Axis name displayed.
	  name: '',
	  // 'start' | 'middle' | 'end'
	  nameLocation: 'end',
	  // By degree. By default auto rotate by nameLocation.
	  nameRotate: null,
	  nameTruncate: {
	    maxWidth: null,
	    ellipsis: '...',
	    placeholder: '.'
	  },
	  // Use global text style by default.
	  nameTextStyle: {},
	  // The gap between axisName and axisLine.
	  nameGap: 15,
	  // Default `false` to support tooltip.
	  silent: false,
	  // Default `false` to avoid legacy user event listener fail.
	  triggerEvent: false,
	  tooltip: {
	    show: false
	  },
	  axisPointer: {},
	  axisLine: {
	    show: true,
	    onZero: true,
	    onZeroAxisIndex: null,
	    lineStyle: {
	      color: '#333',
	      width: 1,
	      type: 'solid'
	    },
	    // The arrow at both ends the the axis.
	    symbol: ['none', 'none'],
	    symbolSize: [10, 15]
	  },
	  axisTick: {
	    show: true,
	    // Whether axisTick is inside the grid or outside the grid.
	    inside: false,
	    // The length of axisTick.
	    length: 5,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    // Whether axisLabel is inside the grid or outside the grid.
	    inside: false,
	    rotate: 0,
	    // true | false | null/undefined (auto)
	    showMinLabel: null,
	    // true | false | null/undefined (auto)
	    showMaxLabel: null,
	    margin: 8,
	    // formatter: null,
	    fontSize: 12
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      color: ['#ccc'],
	      width: 1,
	      type: 'solid'
	    }
	  },
	  splitArea: {
	    show: false,
	    areaStyle: {
	      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
	    }
	  }
	};
	var axisDefault = {};
	axisDefault.categoryAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For categoryAxis, boolean.
	  boundaryGap: true,
	  // Set false to faster category collection.
	  // Only usefull in the case like: category is
	  // ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // null means "auto":
	  // if axis.data provided, do not deduplication,
	  // else do deduplication.
	  deduplication: null,
	  // splitArea: {
	  // show: false
	  // },
	  splitLine: {
	    show: false
	  },
	  axisTick: {
	    // If tick is align with label when boundaryGap is true
	    alignWithLabel: false,
	    interval: 'auto'
	  },
	  axisLabel: {
	    interval: 'auto'
	  }
	}, defaultOption);
	axisDefault.valueAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For value axis, [GAP, GAP], where
	  // `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
	  boundaryGap: [0, 0],
	  // TODO
	  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
	  // Min value of the axis. can be:
	  // + a number
	  // + 'dataMin': use the min value in data.
	  // + null/undefined: auto decide min value (consider pretty look and boundaryGap).
	  // min: null,
	  // Max value of the axis. can be:
	  // + a number
	  // + 'dataMax': use the max value in data.
	  // + null/undefined: auto decide max value (consider pretty look and boundaryGap).
	  // max: null,
	  // Readonly prop, specifies start value of the range when using data zoom.
	  // rangeStart: null
	  // Readonly prop, specifies end value of the range when using data zoom.
	  // rangeEnd: null
	  // Optional value can be:
	  // + `false`: always include value 0.
	  // + `true`: the extent do not consider value 0.
	  // scale: false,
	  // AxisTick and axisLabel and splitLine are caculated based on splitNumber.
	  splitNumber: 5,
	  // Interval specifies the span of the ticks is mandatorily.
	  // interval: null
	  // Specify min interval when auto calculate tick interval.
	  // minInterval: null
	  // Specify max interval when auto calculate tick interval.
	  // maxInterval: null
	  minorTick: {
	    // Minor tick, not available for cateogry axis.
	    show: false,
	    // Split number of minor ticks. The value should be in range of (0, 100)
	    splitNumber: 5,
	    // Lenght of minor tick
	    length: 3,
	    // Same inside with axisTick
	    // Line style
	    lineStyle: {// Default to be same with axisTick
	    }
	  },
	  minorSplitLine: {
	    show: false,
	    lineStyle: {
	      color: '#eee',
	      width: 1
	    }
	  }
	}, defaultOption);
	axisDefault.timeAxis = zrUtil.defaults({
	  scale: true,
	  min: 'dataMin',
	  max: 'dataMax'
	}, axisDefault.valueAxis);
	axisDefault.logAxis = zrUtil.defaults({
	  scale: true,
	  logBase: 10
	}, axisDefault.valueAxis);
	var _default = axisDefault;
	module.exports = _default;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ComponentModel = __webpack_require__(65);
	
	var axisModelCreator = __webpack_require__(270);
	
	var axisModelCommonMixin = __webpack_require__(175);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'cartesian2dAxis',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Axis2D}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  init: function () {
	    AxisModel.superApply(this, 'init', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function () {
	    AxisModel.superApply(this, 'mergeOption', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  restoreData: function () {
	    AxisModel.superApply(this, 'restoreData', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   * @return {module:echarts/model/Component}
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'grid',
	      index: this.option.gridIndex,
	      id: this.option.gridId
	    })[0];
	  }
	});
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	var extraOption = {
	  // gridIndex: 0,
	  // gridId: '',
	  // Offset is for multiple axis on the same position
	  offset: 0
	};
	axisModelCreator('x', AxisModel, getAxisType, extraOption);
	axisModelCreator('y', AxisModel, getAxisType, extraOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Can only be called after coordinate system creation stage.
	 * (Can be called before coordinate system update stage).
	 *
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(gridModel, axisModel, opt) {
	  opt = opt || {};
	  var grid = gridModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
	  var rawAxisPosition = axis.position;
	  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
	  var axisDim = axis.dim;
	  var rect = grid.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var idx = {
	    left: 0,
	    right: 1,
	    top: 0,
	    bottom: 1,
	    onZero: 2
	  };
	  var axisOffset = axisModel.get('offset') || 0;
	  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];
	
	  if (otherAxisOnZeroOf) {
	    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
	    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
	  } // Axis position
	
	
	  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation
	
	  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
	
	  var dirMap = {
	    top: -1,
	    bottom: 1,
	    left: -1,
	    right: 1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
	  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  } // Special label rotation
	
	
	  var labelRotate = axisModel.get('axisLabel.rotate');
	  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
	
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(51);
	
	var bbox = __webpack_require__(226);
	
	var vec2 = __webpack_require__(49);
	
	var polygonContain = __webpack_require__(898);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/geo/Region
	 */
	
	/**
	 * @param {string|Region} name
	 * @param {Array} geometries
	 * @param {Array.<number>} cp
	 */
	function Region(name, geometries, cp) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.name = name;
	  /**
	   * @type {Array.<Array>}
	   * @readOnly
	   */
	
	  this.geometries = geometries;
	
	  if (!cp) {
	    var rect = this.getBoundingRect();
	    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  } else {
	    cp = [cp[0], cp[1]];
	  }
	  /**
	   * @type {Array.<number>}
	   */
	
	
	  this.center = cp;
	}
	
	Region.prototype = {
	  constructor: Region,
	  properties: null,
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    var rect = this._rect;
	
	    if (rect) {
	      return rect;
	    }
	
	    var MAX_NUMBER = Number.MAX_VALUE;
	    var min = [MAX_NUMBER, MAX_NUMBER];
	    var max = [-MAX_NUMBER, -MAX_NUMBER];
	    var min2 = [];
	    var max2 = [];
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      } // Doesn't consider hole
	
	
	      var exterior = geometries[i].exterior;
	      bbox.fromPoints(exterior, min2, max2);
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * @param {<Array.<number>} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var rect = this.getBoundingRect();
	    var geometries = this.geometries;
	
	    if (!rect.contain(coord[0], coord[1])) {
	      return false;
	    }
	
	    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      if (polygonContain.contain(exterior, coord[0], coord[1])) {
	        // Not in the region if point is in the hole.
	        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
	          if (polygonContain.contain(interiors[k])) {
	            continue loopGeo;
	          }
	        }
	
	        return true;
	      }
	    }
	
	    return false;
	  },
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var aspect = rect.width / rect.height;
	
	    if (!width) {
	      width = aspect * height;
	    } else if (!height) {
	      height = width / aspect;
	    }
	
	    var target = new BoundingRect(x, y, width, height);
	    var transform = rect.calculateTransform(target);
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      for (var p = 0; p < exterior.length; p++) {
	        vec2.applyTransform(exterior[p], exterior[p], transform);
	      }
	
	      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
	        for (var p = 0; p < interiors[h].length; p++) {
	          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
	        }
	      }
	    }
	
	    rect = this._rect;
	    rect.copy(target); // Update center
	
	    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  },
	  cloneShallow: function (name) {
	    name == null && (name = this.name);
	    var newRegion = new Region(name, this.geometries, this.center);
	    newRegion._rect = this._rect;
	    newRegion.transformTo = null; // Simply avoid to be called.
	
	    return newRegion;
	  }
	};
	var _default = Region;
	module.exports = _default;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Region = __webpack_require__(844);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parse and decode geo json
	 * @module echarts/coord/geo/parseGeoJson
	 */
	function decode(json) {
	  if (!json.UTF8Encoding) {
	    return json;
	  }
	
	  var encodeScale = json.UTF8Scale;
	
	  if (encodeScale == null) {
	    encodeScale = 1024;
	  }
	
	  var features = json.features;
	
	  for (var f = 0; f < features.length; f++) {
	    var feature = features[f];
	    var geometry = feature.geometry;
	    var coordinates = geometry.coordinates;
	    var encodeOffsets = geometry.encodeOffsets;
	
	    for (var c = 0; c < coordinates.length; c++) {
	      var coordinate = coordinates[c];
	
	      if (geometry.type === 'Polygon') {
	        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
	      } else if (geometry.type === 'MultiPolygon') {
	        for (var c2 = 0; c2 < coordinate.length; c2++) {
	          var polygon = coordinate[c2];
	          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
	        }
	      }
	    }
	  } // Has been decoded
	
	
	  json.UTF8Encoding = false;
	  return json;
	}
	
	function decodePolygon(coordinate, encodeOffsets, encodeScale) {
	  var result = [];
	  var prevX = encodeOffsets[0];
	  var prevY = encodeOffsets[1];
	
	  for (var i = 0; i < coordinate.length; i += 2) {
	    var x = coordinate.charCodeAt(i) - 64;
	    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
	
	    x = x >> 1 ^ -(x & 1);
	    y = y >> 1 ^ -(y & 1); // Delta deocding
	
	    x += prevX;
	    y += prevY;
	    prevX = x;
	    prevY = y; // Dequantize
	
	    result.push([x / encodeScale, y / encodeScale]);
	  }
	
	  return result;
	}
	/**
	 * @alias module:echarts/coord/geo/parseGeoJson
	 * @param {Object} geoJson
	 * @param {string} nameProperty
	 * @return {module:zrender/container/Group}
	 */
	
	
	function _default(geoJson, nameProperty) {
	  decode(geoJson);
	  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
	    // Output of mapshaper may have geometry null
	    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
	  }), function (featureObj) {
	    var properties = featureObj.properties;
	    var geo = featureObj.geometry;
	    var coordinates = geo.coordinates;
	    var geometries = [];
	
	    if (geo.type === 'Polygon') {
	      geometries.push({
	        type: 'polygon',
	        // According to the GeoJSON specification.
	        // First must be exterior, and the rest are all interior(holes).
	        exterior: coordinates[0],
	        interiors: coordinates.slice(1)
	      });
	    }
	
	    if (geo.type === 'MultiPolygon') {
	      zrUtil.each(coordinates, function (item) {
	        if (item[0]) {
	          geometries.push({
	            type: 'polygon',
	            exterior: item[0],
	            interiors: item.slice(1)
	          });
	        }
	      });
	    }
	
	    var region = new Region(properties[nameProperty || 'name'], geometries, properties.cp);
	    region.properties = properties;
	    return region;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Parallel = __webpack_require__(1830);
	
	var CoordinateSystem = __webpack_require__(95);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel coordinate system creater.
	 */
	function create(ecModel, api) {
	  var coordSysList = [];
	  ecModel.eachComponent('parallel', function (parallelModel, idx) {
	    var coordSys = new Parallel(parallelModel, ecModel, api);
	    coordSys.name = 'parallel_' + idx;
	    coordSys.resize(parallelModel, api);
	    parallelModel.coordinateSystem = coordSys;
	    coordSys.model = parallelModel;
	    coordSysList.push(coordSys);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'parallel') {
	      var parallelModel = ecModel.queryComponents({
	        mainType: 'parallel',
	        index: seriesModel.get('parallelIndex'),
	        id: seriesModel.get('parallelId')
	      })[0];
	      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
	    }
	  });
	  return coordSysList;
	}
	
	CoordinateSystem.register('parallel', {
	  create: create
	});

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(axisModel, opt) {
	  opt = opt || {};
	  var single = axisModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var axisPosition = axis.position;
	  var orient = axis.orient;
	  var rect = single.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var positionMap = {
	    horizontal: {
	      top: rectBound[2],
	      bottom: rectBound[3]
	    },
	    vertical: {
	      left: rectBound[0],
	      right: rectBound[1]
	    }
	  };
	  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
	  var r = {
	    horizontal: 0,
	    vertical: 1
	  };
	  layout.rotation = Math.PI / 2 * r[orient];
	  var directionMap = {
	    top: -1,
	    bottom: 1,
	    right: 1,
	    left: -1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  }
	
	  var labelRotation = opt.rotate;
	  labelRotation == null && (labelRotation = axisModel.get('axisLabel.rotate'));
	  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @class
	 * @param {Object|DataDimensionInfo} [opt] All of the fields will be shallow copied.
	 */
	function DataDimensionInfo(opt) {
	  if (opt != null) {
	    zrUtil.extend(this, opt);
	  }
	  /**
	   * Dimension name.
	   * Mandatory.
	   * @type {string}
	   */
	  // this.name;
	
	  /**
	   * The origin name in dimsDef, see source helper.
	   * If displayName given, the tooltip will displayed vertically.
	   * Optional.
	   * @type {string}
	   */
	  // this.displayName;
	
	  /**
	   * Which coordSys dimension this dimension mapped to.
	   * A `coordDim` can be a "coordSysDim" that the coordSys required
	   * (for example, an item in `coordSysDims` of `model/referHelper#CoordSysInfo`),
	   * or an generated "extra coord name" if does not mapped to any "coordSysDim"
	   * (That is determined by whether `isExtraCoord` is `true`).
	   * Mandatory.
	   * @type {string}
	   */
	  // this.coordDim;
	
	  /**
	   * The index of this dimension in `series.encode[coordDim]`.
	   * Mandatory.
	   * @type {number}
	   */
	  // this.coordDimIndex;
	
	  /**
	   * Dimension type. The enumerable values are the key of
	   * `dataCtors` of `data/List`.
	   * Optional.
	   * @type {string}
	   */
	  // this.type;
	
	  /**
	   * This index of this dimension info in `data/List#_dimensionInfos`.
	   * Mandatory after added to `data/List`.
	   * @type {number}
	   */
	  // this.index;
	
	  /**
	   * The format of `otherDims` is:
	   * ```js
	   * {
	   *     tooltip: number optional,
	   *     label: number optional,
	   *     itemName: number optional,
	   *     seriesName: number optional,
	   * }
	   * ```
	   *
	   * A `series.encode` can specified these fields:
	   * ```js
	   * encode: {
	   *     // "3, 1, 5" is the index of data dimension.
	   *     tooltip: [3, 1, 5],
	   *     label: [0, 3],
	   *     ...
	   * }
	   * ```
	   * `otherDims` is the parse result of the `series.encode` above, like:
	   * ```js
	   * // Suppose the index of this data dimension is `3`.
	   * this.otherDims = {
	   *     // `3` is at the index `0` of the `encode.tooltip`
	   *     tooltip: 0,
	   *     // `3` is at the index `1` of the `encode.tooltip`
	   *     label: 1
	   * };
	   * ```
	   *
	   * This prop should never be `null`/`undefined` after initialized.
	   * @type {Object}
	   */
	
	
	  this.otherDims = {};
	  /**
	   * Be `true` if this dimension is not mapped to any "coordSysDim" that the
	   * "coordSys" required.
	   * Mandatory.
	   * @type {boolean}
	   */
	  // this.isExtraCoord;
	
	  /**
	   * @type {module:data/OrdinalMeta}
	   */
	  // this.ordinalMeta;
	
	  /**
	   * Whether to create inverted indices.
	   * @type {boolean}
	   */
	  // this.createInvertedIndices;
	}
	
	;
	var _default = DataDimensionInfo;
	module.exports = _default;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	var isObject = _util.isObject;
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor
	 * @param {Object} [opt]
	 * @param {Object} [opt.categories=[]]
	 * @param {Object} [opt.needCollect=false]
	 * @param {Object} [opt.deduplication=false]
	 */
	function OrdinalMeta(opt) {
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  this.categories = opt.categories || [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._needCollect = opt.needCollect;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._deduplication = opt.deduplication;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._map;
	}
	/**
	 * @param {module:echarts/model/Model} axisModel
	 * @return {module:echarts/data/OrdinalMeta}
	 */
	
	
	OrdinalMeta.createByAxisModel = function (axisModel) {
	  var option = axisModel.option;
	  var data = option.data;
	  var categories = data && map(data, getName);
	  return new OrdinalMeta({
	    categories: categories,
	    needCollect: !categories,
	    // deduplication is default in axis.
	    deduplication: option.dedplication !== false
	  });
	};
	
	var proto = OrdinalMeta.prototype;
	/**
	 * @param {string} category
	 * @return {number} ordinal
	 */
	
	proto.getOrdinal = function (category) {
	  return getOrCreateMap(this).get(category);
	};
	/**
	 * @param {*} category
	 * @return {number} The ordinal. If not found, return NaN.
	 */
	
	
	proto.parseAndCollect = function (category) {
	  var index;
	  var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
	  // This feature is only supported when !needCollect, because we should
	  // consider a common case: a value is 2017, which is a number but is
	  // expected to be tread as a category. This case usually happen in dataset,
	  // where it happent to be no need of the index feature.
	
	  if (typeof category !== 'string' && !needCollect) {
	    return category;
	  } // Optimize for the scenario:
	  // category is ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // Notice, if a dataset dimension provide categroies, usually echarts
	  // should remove duplication except user tell echarts dont do that
	  // (set axis.deduplication = false), because echarts do not know whether
	  // the values in the category dimension has duplication (consider the
	  // parallel-aqi example)
	
	
	  if (needCollect && !this._deduplication) {
	    index = this.categories.length;
	    this.categories[index] = category;
	    return index;
	  }
	
	  var map = getOrCreateMap(this);
	  index = map.get(category);
	
	  if (index == null) {
	    if (needCollect) {
	      index = this.categories.length;
	      this.categories[index] = category;
	      map.set(category, index);
	    } else {
	      index = NaN;
	    }
	  }
	
	  return index;
	}; // Consider big data, do not create map until needed.
	
	
	function getOrCreateMap(ordinalMeta) {
	  return ordinalMeta._map || (ordinalMeta._map = createHashMap(ordinalMeta.categories));
	}
	
	function getName(obj) {
	  if (isObject(obj) && obj.value != null) {
	    return obj.value;
	  } else {
	    return obj + '';
	  }
	}
	
	var _default = OrdinalMeta;
	module.exports = _default;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var isString = _util.isString;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var isObject = _util.isObject;
	var clone = _util.clone;
	
	var _model = __webpack_require__(27);
	
	var normalizeToArray = _model.normalizeToArray;
	
	var _sourceHelper = __webpack_require__(114);
	
	var guessOrdinal = _sourceHelper.guessOrdinal;
	var BE_ORDINAL = _sourceHelper.BE_ORDINAL;
	
	var Source = __webpack_require__(219);
	
	var _dimensionHelper = __webpack_require__(220);
	
	var OTHER_DIMENSIONS = _dimensionHelper.OTHER_DIMENSIONS;
	
	var DataDimensionInfo = __webpack_require__(848);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @deprecated
	 * Use `echarts/data/helper/createDimensions` instead.
	 */
	
	/**
	 * @see {module:echarts/test/ut/spec/data/completeDimensions}
	 *
	 * This method builds the relationship between:
	 * + "what the coord sys or series requires (see `sysDims`)",
	 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimsDef` and `opt.encodeDef`)"
	 * + "what the data source provids (see `source`)".
	 *
	 * Some guess strategy will be adapted if user does not define something.
	 * If no 'value' dimension specified, the first no-named dimension will be
	 * named as 'value'.
	 *
	 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
	 *      provides not only dim template, but also default order.
	 *      properties: 'name', 'type', 'displayName'.
	 *      `name` of each item provides default coord name.
	 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
	 *                                    provide dims count that the sysDim required.
	 *      [{ordinalMeta}] can be specified.
	 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
	 * @param {Object} [opt]
	 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
	 *      For example: ['asdf', {name, type}, ...].
	 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
	 * @param {Function} [opt.encodeDefaulter] Called if no `opt.encodeDef` exists.
	 *      If not specified, auto find the next available data dim.
	 *      param source {module:data/Source}
	 *      param dimCount {number}
	 *      return {Object} encode Never be `null/undefined`.
	 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
	 *      If not specified, extra dim names will be:
	 *      'value', 'value0', 'value1', ...
	 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
	 *      If `generateCoordCount` specified, the generated dim names will be:
	 *      `generateCoord` + 0, `generateCoord` + 1, ...
	 *      can be Infinity, indicate that use all of the remain columns.
	 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
	 * @return {Array.<module:data/DataDimensionInfo>}
	 */
	function completeDimensions(sysDims, source, opt) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  opt = opt || {};
	  sysDims = (sysDims || []).slice();
	  var dimsDef = (opt.dimsDef || []).slice();
	  var dataDimNameMap = createHashMap();
	  var coordDimNameMap = createHashMap(); // var valueCandidate;
	
	  var result = [];
	  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimCount); // Apply user defined dims (`name` and `type`) and init result.
	
	  for (var i = 0; i < dimCount; i++) {
	    var dimDefItem = dimsDef[i] = extend({}, isObject(dimsDef[i]) ? dimsDef[i] : {
	      name: dimsDef[i]
	    });
	    var userDimName = dimDefItem.name;
	    var resultItem = result[i] = new DataDimensionInfo(); // Name will be applied later for avoiding duplication.
	
	    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
	      // Only if `series.dimensions` is defined in option
	      // displayName, will be set, and dimension will be diplayed vertically in
	      // tooltip by default.
	      resultItem.name = resultItem.displayName = userDimName;
	      dataDimNameMap.set(userDimName, i);
	    }
	
	    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
	    dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
	  }
	
	  var encodeDef = opt.encodeDef;
	
	  if (!encodeDef && opt.encodeDefaulter) {
	    encodeDef = opt.encodeDefaulter(source, dimCount);
	  }
	
	  encodeDef = createHashMap(encodeDef); // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.
	
	  encodeDef.each(function (dataDims, coordDim) {
	    dataDims = normalizeToArray(dataDims).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
	    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
	    // this case.
	
	    if (dataDims.length === 1 && !isString(dataDims[0]) && dataDims[0] < 0) {
	      encodeDef.set(coordDim, false);
	      return;
	    }
	
	    var validDataDims = encodeDef.set(coordDim, []);
	    each(dataDims, function (resultDimIdx, idx) {
	      // The input resultDimIdx can be dim name or index.
	      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));
	
	      if (resultDimIdx != null && resultDimIdx < dimCount) {
	        validDataDims[idx] = resultDimIdx;
	        applyDim(result[resultDimIdx], coordDim, idx);
	      }
	    });
	  }); // Apply templetes and default order from `sysDims`.
	
	  var availDimIdx = 0;
	  each(sysDims, function (sysDimItem, sysDimIndex) {
	    var coordDim;
	    var sysDimItem;
	    var sysDimItemDimsDef;
	    var sysDimItemOtherDims;
	
	    if (isString(sysDimItem)) {
	      coordDim = sysDimItem;
	      sysDimItem = {};
	    } else {
	      coordDim = sysDimItem.name;
	      var ordinalMeta = sysDimItem.ordinalMeta;
	      sysDimItem.ordinalMeta = null;
	      sysDimItem = clone(sysDimItem);
	      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
	
	      sysDimItemDimsDef = sysDimItem.dimsDef;
	      sysDimItemOtherDims = sysDimItem.otherDims;
	      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
	    }
	
	    var dataDims = encodeDef.get(coordDim); // negative resultDimIdx means no need to mapping.
	
	    if (dataDims === false) {
	      return;
	    }
	
	    var dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.
	
	    if (!dataDims.length) {
	      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
	        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
	          availDimIdx++;
	        }
	
	        availDimIdx < result.length && dataDims.push(availDimIdx++);
	      }
	    } // Apply templates.
	
	
	    each(dataDims, function (resultDimIdx, coordDimIndex) {
	      var resultItem = result[resultDimIdx];
	      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);
	
	      if (resultItem.name == null && sysDimItemDimsDef) {
	        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
	        !isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
	          name: sysDimItemDimsDefItem
	        });
	        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
	        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
	      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
	
	
	      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
	    });
	  });
	
	  function applyDim(resultItem, coordDim, coordDimIndex) {
	    if (OTHER_DIMENSIONS.get(coordDim) != null) {
	      resultItem.otherDims[coordDim] = coordDimIndex;
	    } else {
	      resultItem.coordDim = coordDim;
	      resultItem.coordDimIndex = coordDimIndex;
	      coordDimNameMap.set(coordDim, true);
	    }
	  } // Make sure the first extra dim is 'value'.
	
	
	  var generateCoord = opt.generateCoord;
	  var generateCoordCount = opt.generateCoordCount;
	  var fromZero = generateCoordCount != null;
	  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
	  var extra = generateCoord || 'value'; // Set dim `name` and other `coordDim` and other props.
	
	  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
	    var resultItem = result[resultDimIdx] = result[resultDimIdx] || new DataDimensionInfo();
	    var coordDim = resultItem.coordDim;
	
	    if (coordDim == null) {
	      resultItem.coordDim = genName(extra, coordDimNameMap, fromZero);
	      resultItem.coordDimIndex = 0;
	
	      if (!generateCoord || generateCoordCount <= 0) {
	        resultItem.isExtraCoord = true;
	      }
	
	      generateCoordCount--;
	    }
	
	    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));
	
	    if (resultItem.type == null && (guessOrdinal(source, resultDimIdx, resultItem.name) === BE_ORDINAL.Must // Consider the case:
	    // {
	    //    dataset: {source: [
	    //        ['2001', 123],
	    //        ['2002', 456],
	    //        ...
	    //        ['The others', 987],
	    //    ]},
	    //    series: {type: 'pie'}
	    // }
	    // The first colum should better be treated as a "ordinal" although it
	    // might not able to be detected as an "ordinal" by `guessOrdinal`.
	    || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
	      resultItem.type = 'ordinal';
	    }
	  }
	
	  return result;
	} // ??? TODO
	// Originally detect dimCount by data[0]. Should we
	// optimize it to only by sysDims and dimensions and encode.
	// So only necessary dims will be initialized.
	// But
	// (1) custom series should be considered. where other dims
	// may be visited.
	// (2) sometimes user need to calcualte bubble size or use visualMap
	// on other dimensions besides coordSys needed.
	// So, dims that is not used by system, should be shared in storage?
	
	
	function getDimCount(source, sysDims, dimsDef, optDimCount) {
	  // Note that the result dimCount should not small than columns count
	  // of data, otherwise `dataDimNameMap` checking will be incorrect.
	  var dimCount = Math.max(source.dimensionsDetectCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
	  each(sysDims, function (sysDimItem) {
	    var sysDimItemDimsDef = sysDimItem.dimsDef;
	    sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
	  });
	  return dimCount;
	}
	
	function genName(name, map, fromZero) {
	  if (fromZero || map.get(name) != null) {
	    var i = 0;
	
	    while (map.get(name + i) != null) {
	      i++;
	    }
	
	    name += i;
	  }
	
	  map.set(name, true);
	  return name;
	}
	
	var _default = completeDimensions;
	module.exports = _default;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Link lists and struct (graph or tree)
	 */
	var each = zrUtil.each;
	var DATAS = '\0__link_datas';
	var MAIN_DATA = '\0__link_mainData'; // Caution:
	// In most case, either list or its shallow clones (see list.cloneShallow)
	// is active in echarts process. So considering heap memory consumption,
	// we do not clone tree or graph, but share them among list and its shallow clones.
	// But in some rare case, we have to keep old list (like do animation in chart). So
	// please take care that both the old list and the new list share the same tree/graph.
	
	/**
	 * @param {Object} opt
	 * @param {module:echarts/data/List} opt.mainData
	 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
	 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
	 * @param {Object} [opt.datas] {dataType: data},
	 *                 like: {node: nodeList, edge: edgeList}.
	 *                 Should contain mainData.
	 * @param {Object} [opt.datasAttr] {dataType: attr},
	 *                 designation: struct[datasAttr[dataType]] = list;
	 */
	
	function linkList(opt) {
	  var mainData = opt.mainData;
	  var datas = opt.datas;
	
	  if (!datas) {
	    datas = {
	      main: mainData
	    };
	    opt.datasAttr = {
	      main: 'data'
	    };
	  }
	
	  opt.datas = opt.mainData = null;
	  linkAll(mainData, datas, opt); // Porxy data original methods.
	
	  each(datas, function (data) {
	    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
	      data.wrapMethod(methodName, zrUtil.curry(transferInjection, opt));
	    });
	  }); // Beyond transfer, additional features should be added to `cloneShallow`.
	
	  mainData.wrapMethod('cloneShallow', zrUtil.curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
	  // another changable methods, which may bring about dead lock.
	
	  each(mainData.CHANGABLE_METHODS, function (methodName) {
	    mainData.wrapMethod(methodName, zrUtil.curry(changeInjection, opt));
	  }); // Make sure datas contains mainData.
	
	  zrUtil.assert(datas[mainData.dataType] === mainData);
	}
	
	function transferInjection(opt, res) {
	  if (isMainData(this)) {
	    // Transfer datas to new main data.
	    var datas = zrUtil.extend({}, this[DATAS]);
	    datas[this.dataType] = res;
	    linkAll(res, datas, opt);
	  } else {
	    // Modify the reference in main data to point newData.
	    linkSingle(res, this.dataType, this[MAIN_DATA], opt);
	  }
	
	  return res;
	}
	
	function changeInjection(opt, res) {
	  opt.struct && opt.struct.update(this);
	  return res;
	}
	
	function cloneShallowInjection(opt, res) {
	  // cloneShallow, which brings about some fragilities, may be inappropriate
	  // to be exposed as an API. So for implementation simplicity we can make
	  // the restriction that cloneShallow of not-mainData should not be invoked
	  // outside, but only be invoked here.
	  each(res[DATAS], function (data, dataType) {
	    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
	  });
	  return res;
	}
	/**
	 * Supplement method to List.
	 *
	 * @public
	 * @param {string} [dataType] If not specified, return mainData.
	 * @return {module:echarts/data/List}
	 */
	
	
	function getLinkedData(dataType) {
	  var mainData = this[MAIN_DATA];
	  return dataType == null || mainData == null ? mainData : mainData[DATAS][dataType];
	}
	
	function isMainData(data) {
	  return data[MAIN_DATA] === data;
	}
	
	function linkAll(mainData, datas, opt) {
	  mainData[DATAS] = {};
	  each(datas, function (data, dataType) {
	    linkSingle(data, dataType, mainData, opt);
	  });
	}
	
	function linkSingle(data, dataType, mainData, opt) {
	  mainData[DATAS][dataType] = data;
	  data[MAIN_DATA] = mainData;
	  data.dataType = dataType;
	
	  if (opt.struct) {
	    data[opt.structAttr] = opt.struct;
	    opt.struct[opt.datasAttr[dataType]] = data;
	  } // Supplement method.
	
	
	  data.getLinkedData = getLinkedData;
	}
	
	var _default = linkList;
	module.exports = _default;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrender = __webpack_require__(285);
	
	exports.zrender = zrender;
	
	var matrix = __webpack_require__(75);
	
	exports.matrix = matrix;
	
	var vector = __webpack_require__(49);
	
	exports.vector = vector;
	
	var zrUtil = __webpack_require__(2);
	
	var colorTool = __webpack_require__(105);
	
	exports.color = colorTool;
	
	var graphicUtil = __webpack_require__(17);
	
	var numberUtil = __webpack_require__(24);
	
	exports.number = numberUtil;
	
	var formatUtil = __webpack_require__(48);
	
	exports.format = formatUtil;
	
	var _throttle = __webpack_require__(131);
	
	var throttle = _throttle.throttle;
	exports.throttle = _throttle.throttle;
	
	var ecHelper = __webpack_require__(1849);
	
	exports.helper = ecHelper;
	
	var parseGeoJSON = __webpack_require__(845);
	
	exports.parseGeoJSON = parseGeoJSON;
	
	var _List = __webpack_require__(88);
	
	exports.List = _List;
	
	var _Model = __webpack_require__(57);
	
	exports.Model = _Model;
	
	var _Axis = __webpack_require__(129);
	
	exports.Axis = _Axis;
	
	var _env = __webpack_require__(58);
	
	exports.env = _env;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Do not mount those modules on 'src/echarts' for better tree shaking.
	 */
	var parseGeoJson = parseGeoJSON;
	var ecUtil = {};
	zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
	  ecUtil[name] = zrUtil[name];
	});
	var graphic = {};
	zrUtil.each(['extendShape', 'extendPath', 'makePath', 'makeImage', 'mergePath', 'resizePath', 'createIcon', 'setHoverStyle', 'setLabelStyle', 'setTextStyle', 'setText', 'getFont', 'updateProps', 'initProps', 'getTransform', 'clipPointsByRect', 'clipRectByRect', 'registerShape', 'getShapeClass', 'Group', 'Image', 'Text', 'Circle', 'Sector', 'Ring', 'Polygon', 'Polyline', 'Rect', 'Line', 'BezierCurve', 'Arc', 'IncrementalDisplayable', 'CompoundPath', 'LinearGradient', 'RadialGradient', 'BoundingRect'], function (name) {
	  graphic[name] = graphicUtil[name];
	});
	exports.parseGeoJson = parseGeoJson;
	exports.util = ecUtil;
	exports.graphic = graphic;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	var filter = _util.filter;
	var map = _util.map;
	var isArray = _util.isArray;
	var indexOf = _util.indexOf;
	var isObject = _util.isObject;
	var isString = _util.isString;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	var clone = _util.clone;
	var merge = _util.merge;
	var extend = _util.extend;
	var mixin = _util.mixin;
	
	var modelUtil = __webpack_require__(27);
	
	var Model = __webpack_require__(57);
	
	var ComponentModel = __webpack_require__(65);
	
	var globalDefault = __webpack_require__(1853);
	
	var colorPaletteMixin = __webpack_require__(854);
	
	var _sourceHelper = __webpack_require__(114);
	
	var resetSourceDefaulter = _sourceHelper.resetSourceDefaulter;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts global model
	 *
	 * @module {echarts/model/Global}
	 */
	
	/**
	 * Caution: If the mechanism should be changed some day, these cases
	 * should be considered:
	 *
	 * (1) In `merge option` mode, if using the same option to call `setOption`
	 * many times, the result should be the same (try our best to ensure that).
	 * (2) In `merge option` mode, if a component has no id/name specified, it
	 * will be merged by index, and the result sequence of the components is
	 * consistent to the original sequence.
	 * (3) `reset` feature (in toolbox). Find detailed info in comments about
	 * `mergeOption` in module:echarts/model/OptionManager.
	 */
	var OPTION_INNER_KEY = '\0_ec_inner';
	/**
	 * @alias module:echarts/model/Global
	 *
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {Object} theme
	 */
	
	var GlobalModel = Model.extend({
	  init: function (option, parentModel, theme, optionManager) {
	    theme = theme || {};
	    this.option = null; // Mark as not initialized.
	
	    /**
	     * @type {module:echarts/model/Model}
	     * @private
	     */
	
	    this._theme = new Model(theme);
	    /**
	     * @type {module:echarts/model/OptionManager}
	     */
	
	    this._optionManager = optionManager;
	  },
	  setOption: function (option, optionPreprocessorFuncs) {
	    assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');
	
	    this._optionManager.setOption(option, optionPreprocessorFuncs);
	
	    this.resetOption(null);
	  },
	
	  /**
	   * @param {string} type null/undefined: reset all.
	   *                      'recreate': force recreate all.
	   *                      'timeline': only reset timeline option
	   *                      'media': only reset media query option
	   * @return {boolean} Whether option changed.
	   */
	  resetOption: function (type) {
	    var optionChanged = false;
	    var optionManager = this._optionManager;
	
	    if (!type || type === 'recreate') {
	      var baseOption = optionManager.mountOption(type === 'recreate');
	
	      if (!this.option || type === 'recreate') {
	        initBase.call(this, baseOption);
	      } else {
	        this.restoreData();
	        this.mergeOption(baseOption);
	      }
	
	      optionChanged = true;
	    }
	
	    if (type === 'timeline' || type === 'media') {
	      this.restoreData();
	    }
	
	    if (!type || type === 'recreate' || type === 'timeline') {
	      var timelineOption = optionManager.getTimelineOption(this);
	      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
	    }
	
	    if (!type || type === 'recreate' || type === 'media') {
	      var mediaOptions = optionManager.getMediaOption(this, this._api);
	
	      if (mediaOptions.length) {
	        each(mediaOptions, function (mediaOption) {
	          this.mergeOption(mediaOption, optionChanged = true);
	        }, this);
	      }
	    }
	
	    return optionChanged;
	  },
	
	  /**
	   * @protected
	   */
	  mergeOption: function (newOption) {
	    var option = this.option;
	    var componentsMap = this._componentsMap;
	    var newCptTypes = [];
	    resetSourceDefaulter(this); // If no component class, merge directly.
	    // For example: color, animaiton options, etc.
	
	    each(newOption, function (componentOption, mainType) {
	      if (componentOption == null) {
	        return;
	      }
	
	      if (!ComponentModel.hasClass(mainType)) {
	        // globalSettingTask.dirty();
	        option[mainType] = option[mainType] == null ? clone(componentOption) : merge(option[mainType], componentOption, true);
	      } else if (mainType) {
	        newCptTypes.push(mainType);
	      }
	    });
	    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
	
	    function visitComponent(mainType, dependencies) {
	      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
	      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
	      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.
	
	      each(mapResult, function (item, index) {
	        var opt = item.option;
	
	        if (isObject(opt)) {
	          item.keyInfo.mainType = mainType;
	          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
	        }
	      });
	      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
	      option[mainType] = [];
	      componentsMap.set(mainType, []);
	      each(mapResult, function (resultItem, index) {
	        var componentModel = resultItem.exist;
	        var newCptOption = resultItem.option;
	        assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
	        // see removeEdgeAndAdd in topologicalTravel and
	        // ComponentModel.getAllClassMainTypes.
	
	        if (!newCptOption) {
	          componentModel.mergeOption({}, this);
	          componentModel.optionUpdated({}, false);
	        } else {
	          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);
	
	          if (componentModel && componentModel.constructor === ComponentModelClass) {
	            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
	
	            componentModel.mergeOption(newCptOption, this);
	            componentModel.optionUpdated(newCptOption, false);
	          } else {
	            // PENDING Global as parent ?
	            var extraOpt = extend({
	              dependentModels: dependentModels,
	              componentIndex: index
	            }, resultItem.keyInfo);
	            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
	            extend(componentModel, extraOpt);
	            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
	            // newCptOption has been used as componentModel.option
	            // and may be merged with theme and default, so pass null
	            // to avoid confusion.
	
	            componentModel.optionUpdated(null, true);
	          }
	        }
	
	        componentsMap.get(mainType)[index] = componentModel;
	        option[mainType][index] = componentModel.option;
	      }, this); // Backup series for filtering.
	
	      if (mainType === 'series') {
	        createSeriesIndices(this, componentsMap.get('series'));
	      }
	    }
	
	    this._seriesIndicesMap = createHashMap(this._seriesIndices = this._seriesIndices || []);
	  },
	
	  /**
	   * Get option for output (cloned option and inner info removed)
	   * @public
	   * @return {Object}
	   */
	  getOption: function () {
	    var option = clone(this.option);
	    each(option, function (opts, mainType) {
	      if (ComponentModel.hasClass(mainType)) {
	        var opts = modelUtil.normalizeToArray(opts);
	
	        for (var i = opts.length - 1; i >= 0; i--) {
	          // Remove options with inner id.
	          if (modelUtil.isIdInner(opts[i])) {
	            opts.splice(i, 1);
	          }
	        }
	
	        option[mainType] = opts;
	      }
	    });
	    delete option[OPTION_INNER_KEY];
	    return option;
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getTheme: function () {
	    return this._theme;
	  },
	
	  /**
	   * @param {string} mainType
	   * @param {number} [idx=0]
	   * @return {module:echarts/model/Component}
	   */
	  getComponent: function (mainType, idx) {
	    var list = this._componentsMap.get(mainType);
	
	    if (list) {
	      return list[idx || 0];
	    }
	  },
	
	  /**
	   * If none of index and id and name used, return all components with mainType.
	   * @param {Object} condition
	   * @param {string} condition.mainType
	   * @param {string} [condition.subType] If ignore, only query by mainType
	   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  queryComponents: function (condition) {
	    var mainType = condition.mainType;
	
	    if (!mainType) {
	      return [];
	    }
	
	    var index = condition.index;
	    var id = condition.id;
	    var name = condition.name;
	
	    var cpts = this._componentsMap.get(mainType);
	
	    if (!cpts || !cpts.length) {
	      return [];
	    }
	
	    var result;
	
	    if (index != null) {
	      if (!isArray(index)) {
	        index = [index];
	      }
	
	      result = filter(map(index, function (idx) {
	        return cpts[idx];
	      }), function (val) {
	        return !!val;
	      });
	    } else if (id != null) {
	      var isIdArray = isArray(id);
	      result = filter(cpts, function (cpt) {
	        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
	      });
	    } else if (name != null) {
	      var isNameArray = isArray(name);
	      result = filter(cpts, function (cpt) {
	        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
	      });
	    } else {
	      // Return all components with mainType
	      result = cpts.slice();
	    }
	
	    return filterBySubType(result, condition);
	  },
	
	  /**
	   * The interface is different from queryComponents,
	   * which is convenient for inner usage.
	   *
	   * @usage
	   * var result = findComponents(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series',
	   *     filter: function (model, index) {...}}
	   * );
	   * // result like [component0, componnet1, ...]
	   *
	   * @param {Object} condition
	   * @param {string} condition.mainType Mandatory.
	   * @param {string} [condition.subType] Optional.
	   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
	   *        where xxx is mainType.
	   *        If query attribute is null/undefined or has no index/id/name,
	   *        do not filtering by query conditions, which is convenient for
	   *        no-payload situations or when target of action is global.
	   * @param {Function} [condition.filter] parameter: component, return boolean.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  findComponents: function (condition) {
	    var query = condition.query;
	    var mainType = condition.mainType;
	    var queryCond = getQueryCond(query);
	    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
	    return doFilter(filterBySubType(result, condition));
	
	    function getQueryCond(q) {
	      var indexAttr = mainType + 'Index';
	      var idAttr = mainType + 'Id';
	      var nameAttr = mainType + 'Name';
	      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
	        mainType: mainType,
	        // subType will be filtered finally.
	        index: q[indexAttr],
	        id: q[idAttr],
	        name: q[nameAttr]
	      } : null;
	    }
	
	    function doFilter(res) {
	      return condition.filter ? filter(res, condition.filter) : res;
	    }
	  },
	
	  /**
	   * @usage
	   * eachComponent('legend', function (legendModel, index) {
	   *     ...
	   * });
	   * eachComponent(function (componentType, model, index) {
	   *     // componentType does not include subType
	   *     // (componentType is 'xxx' but not 'xxx.aa')
	   * });
	   * eachComponent(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
	   *     function (model, index) {...}
	   * );
	   * eachComponent(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
	   *     function (model, index) {...}
	   * );
	   *
	   * @param {string|Object=} mainType When mainType is object, the definition
	   *                                  is the same as the method 'findComponents'.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachComponent: function (mainType, cb, context) {
	    var componentsMap = this._componentsMap;
	
	    if (typeof mainType === 'function') {
	      context = cb;
	      cb = mainType;
	      componentsMap.each(function (components, componentType) {
	        each(components, function (component, index) {
	          cb.call(context, componentType, component, index);
	        });
	      });
	    } else if (isString(mainType)) {
	      each(componentsMap.get(mainType), cb, context);
	    } else if (isObject(mainType)) {
	      var queryResult = this.findComponents(mainType);
	      each(queryResult, cb, context);
	    }
	  },
	
	  /**
	   * @param {string} name
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByName: function (name) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.name === name;
	    });
	  },
	
	  /**
	   * @param {number} seriesIndex
	   * @return {module:echarts/model/Series}
	   */
	  getSeriesByIndex: function (seriesIndex) {
	    return this._componentsMap.get('series')[seriesIndex];
	  },
	
	  /**
	   * Get series list before filtered by type.
	   * FIXME: rename to getRawSeriesByType?
	   *
	   * @param {string} subType
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByType: function (subType) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.subType === subType;
	    });
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeries: function () {
	    return this._componentsMap.get('series').slice();
	  },
	
	  /**
	   * @return {number}
	   */
	  getSeriesCount: function () {
	    return this._componentsMap.get('series').length;
	  },
	
	  /**
	   * After filtering, series may be different
	   * frome raw series.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      cb.call(context, series, rawSeriesIndex);
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeries: function (cb, context) {
	    each(this._componentsMap.get('series'), cb, context);
	  },
	
	  /**
	   * After filtering, series may be different.
	   * frome raw series.
	   *
	   * @param {string} subType.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeriesByType: function (subType, cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      if (series.subType === subType) {
	        cb.call(context, series, rawSeriesIndex);
	      }
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered of given type.
	   *
	   * @parma {string} subType
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeriesByType: function (subType, cb, context) {
	    return each(this.getSeriesByType(subType), cb, context);
	  },
	
	  /**
	   * @param {module:echarts/model/Series} seriesModel
	   */
	  isSeriesFiltered: function (seriesModel) {
	    assertSeriesInitialized(this);
	    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getCurrentSeriesIndices: function () {
	    return (this._seriesIndices || []).slice();
	  },
	
	  /**
	   * @param {Function} cb
	   * @param {*} context
	   */
	  filterSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
	    createSeriesIndices(this, filteredSeries);
	  },
	  restoreData: function (payload) {
	    var componentsMap = this._componentsMap;
	    createSeriesIndices(this, componentsMap.get('series'));
	    var componentTypes = [];
	    componentsMap.each(function (components, componentType) {
	      componentTypes.push(componentType);
	    });
	    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
	      each(componentsMap.get(componentType), function (component) {
	        (componentType !== 'series' || !isNotTargetSeries(component, payload)) && component.restoreData();
	      });
	    });
	  }
	});
	
	function isNotTargetSeries(seriesModel, payload) {
	  if (payload) {
	    var index = payload.seiresIndex;
	    var id = payload.seriesId;
	    var name = payload.seriesName;
	    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name != null && seriesModel.name !== name;
	  }
	}
	/**
	 * @inner
	 */
	
	
	function mergeTheme(option, theme) {
	  // PENDING
	  // NOT use `colorLayer` in theme if option has `color`
	  var notMergeColorLayer = option.color && !option.colorLayer;
	  each(theme, function (themeItem, name) {
	    if (name === 'colorLayer' && notMergeColorLayer) {
	      return;
	    } // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
	
	
	    if (!ComponentModel.hasClass(name)) {
	      if (typeof themeItem === 'object') {
	        option[name] = !option[name] ? clone(themeItem) : merge(option[name], themeItem, false);
	      } else {
	        if (option[name] == null) {
	          option[name] = themeItem;
	        }
	      }
	    }
	  });
	}
	
	function initBase(baseOption) {
	  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
	  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
	
	  this.option = {};
	  this.option[OPTION_INNER_KEY] = 1;
	  /**
	   * Init with series: [], in case of calling findSeries method
	   * before series initialized.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @private
	   */
	
	  this._componentsMap = createHashMap({
	    series: []
	  });
	  /**
	   * Mapping between filtered series list and raw series list.
	   * key: filtered series indices, value: raw series indices.
	   * @type {Array.<nubmer>}
	   * @private
	   */
	
	  this._seriesIndices;
	  this._seriesIndicesMap;
	  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property
	
	  merge(baseOption, globalDefault, false);
	  this.mergeOption(baseOption);
	}
	/**
	 * @inner
	 * @param {Array.<string>|string} types model types
	 * @return {Object} key: {string} type, value: {Array.<Object>} models
	 */
	
	
	function getComponentsByTypes(componentsMap, types) {
	  if (!isArray(types)) {
	    types = types ? [types] : [];
	  }
	
	  var ret = {};
	  each(types, function (type) {
	    ret[type] = (componentsMap.get(type) || []).slice();
	  });
	  return ret;
	}
	/**
	 * @inner
	 */
	
	
	function determineSubType(mainType, newCptOption, existComponent) {
	  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
	  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType
	
	  return subType;
	}
	/**
	 * @inner
	 */
	
	
	function createSeriesIndices(ecModel, seriesModels) {
	  ecModel._seriesIndicesMap = createHashMap(ecModel._seriesIndices = map(seriesModels, function (series) {
	    return series.componentIndex;
	  }) || []);
	}
	/**
	 * @inner
	 */
	
	
	function filterBySubType(components, condition) {
	  // Using hasOwnProperty for restrict. Consider
	  // subType is undefined in user payload.
	  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
	    return cpt.subType === condition.subType;
	  }) : components;
	}
	/**
	 * @inner
	 */
	
	
	function assertSeriesInitialized(ecModel) {}
	
	mixin(GlobalModel, colorPaletteMixin);
	var _default = GlobalModel;
	module.exports = _default;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function getNearestColorPalette(colors, requestColorNum) {
	  var paletteNum = colors.length; // TODO colors must be in order
	
	  for (var i = 0; i < paletteNum; i++) {
	    if (colors[i].length > requestColorNum) {
	      return colors[i];
	    }
	  }
	
	  return colors[paletteNum - 1];
	}
	
	var _default = {
	  clearColorPalette: function () {
	    inner(this).colorIdx = 0;
	    inner(this).colorNameMap = {};
	  },
	
	  /**
	   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
	   *                 twise with the same parameters will get different result.
	   * @param {Object} [scope=this]
	   * @param {Object} [requestColorNum]
	   * @return {string} color string.
	   */
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    scope = scope || this;
	    var scopeFields = inner(scope);
	    var colorIdx = scopeFields.colorIdx || 0;
	    var colorNameMap = scopeFields.colorNameMap = scopeFields.colorNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
	
	    if (colorNameMap.hasOwnProperty(name)) {
	      return colorNameMap[name];
	    }
	
	    var defaultColorPalette = normalizeToArray(this.get('color', true));
	    var layeredColorPalette = this.get('colorLayer', true);
	    var colorPalette = requestColorNum == null || !layeredColorPalette ? defaultColorPalette : getNearestColorPalette(layeredColorPalette, requestColorNum); // In case can't find in layered color palette.
	
	    colorPalette = colorPalette || defaultColorPalette;
	
	    if (!colorPalette || !colorPalette.length) {
	      return;
	    }
	
	    var color = colorPalette[colorIdx];
	
	    if (name) {
	      colorNameMap[name] = color;
	    }
	
	    scopeFields.colorIdx = (colorIdx + 1) % colorPalette.length;
	    return color;
	  }
	};
	module.exports = _default;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Scale = __webpack_require__(274);
	
	var numberUtil = __webpack_require__(24);
	
	var IntervalScale = __webpack_require__(273);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Log scale
	 * @module echarts/scale/Log
	 */
	// Use some method of IntervalScale
	var scaleProto = Scale.prototype;
	var intervalScaleProto = IntervalScale.prototype;
	var getPrecisionSafe = numberUtil.getPrecisionSafe;
	var roundingErrorFix = numberUtil.round;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var mathPow = Math.pow;
	var mathLog = Math.log;
	var LogScale = Scale.extend({
	  type: 'log',
	  base: 10,
	  $constructor: function () {
	    Scale.apply(this, arguments);
	    this._originalScale = new IntervalScale();
	  },
	
	  /**
	   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
	   * @return {Array.<number>}
	   */
	  getTicks: function (expandToNicedExtent) {
	    var originalScale = this._originalScale;
	    var extent = this._extent;
	    var originalExtent = originalScale.getExtent();
	    return zrUtil.map(intervalScaleProto.getTicks.call(this, expandToNicedExtent), function (val) {
	      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158
	
	      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
	      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
	      return powVal;
	    }, this);
	  },
	
	  /**
	   * @param {number} splitNumber
	   * @return {Array.<Array.<number>>}
	   */
	  getMinorTicks: intervalScaleProto.getMinorTicks,
	
	  /**
	   * @param {number} val
	   * @return {string}
	   */
	  getLabel: intervalScaleProto.getLabel,
	
	  /**
	   * @param  {number} val
	   * @return {number}
	   */
	  scale: function (val) {
	    val = scaleProto.scale.call(this, val);
	    return mathPow(this.base, val);
	  },
	
	  /**
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var base = this.base;
	    start = mathLog(start) / mathLog(base);
	    end = mathLog(end) / mathLog(base);
	    intervalScaleProto.setExtent.call(this, start, end);
	  },
	
	  /**
	   * @return {number} end
	   */
	  getExtent: function () {
	    var base = this.base;
	    var extent = scaleProto.getExtent.call(this);
	    extent[0] = mathPow(base, extent[0]);
	    extent[1] = mathPow(base, extent[1]); // Fix #4158
	
	    var originalScale = this._originalScale;
	    var originalExtent = originalScale.getExtent();
	    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
	    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
	    return extent;
	  },
	
	  /**
	   * @param  {Array.<number>} extent
	   */
	  unionExtent: function (extent) {
	    this._originalScale.unionExtent(extent);
	
	    var base = this.base;
	    extent[0] = mathLog(extent[0]) / mathLog(base);
	    extent[1] = mathLog(extent[1]) / mathLog(base);
	    scaleProto.unionExtent.call(this, extent);
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    // TODO
	    // filter value that <= 0
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   * @param  {number} [approxTickNum = 10] Given approx tick number
	   */
	  niceTicks: function (approxTickNum) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (span === Infinity || span <= 0) {
	      return;
	    }
	
	    var interval = numberUtil.quantity(span);
	    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
	
	    if (err <= 0.5) {
	      interval *= 10;
	    } // Interval should be integer
	
	
	    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
	      interval *= 10;
	    }
	
	    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @override
	   */
	  niceExtent: function (opt) {
	    intervalScaleProto.niceExtent.call(this, opt);
	    var originalScale = this._originalScale;
	    originalScale.__fixMin = opt.fixMin;
	    originalScale.__fixMax = opt.fixMax;
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  LogScale.prototype[methodName] = function (val) {
	    val = mathLog(val) / mathLog(this.base);
	    return scaleProto[methodName].call(this, val);
	  };
	});
	
	LogScale.create = function () {
	  return new LogScale();
	};
	
	function fixRoundingError(val, originalVal) {
	  return roundingErrorFix(val, getPrecisionSafe(originalVal));
	}
	
	var _default = LogScale;
	module.exports = _default;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For testable.
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
	 *                                Should be extent[0] < extent[1].
	 * @param {number} splitNumber splitNumber should be >= 1.
	 * @param {number} [minInterval]
	 * @param {number} [maxInterval]
	 * @return {Object} {interval, intervalPrecision, niceTickExtent}
	 */
	
	function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
	  var result = {};
	  var span = extent[1] - extent[0];
	  var interval = result.interval = numberUtil.nice(span / splitNumber, true);
	
	  if (minInterval != null && interval < minInterval) {
	    interval = result.interval = minInterval;
	  }
	
	  if (maxInterval != null && interval > maxInterval) {
	    interval = result.interval = maxInterval;
	  } // Tow more digital for tick.
	
	
	  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent
	
	  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
	  fixExtent(niceTickExtent, extent);
	  return result;
	}
	/**
	 * @param {number} interval
	 * @return {number} interval precision
	 */
	
	
	function getIntervalPrecision(interval) {
	  // Tow more digital for tick.
	  return numberUtil.getPrecisionSafe(interval) + 2;
	}
	
	function clamp(niceTickExtent, idx, extent) {
	  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
	} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
	
	
	function fixExtent(niceTickExtent, extent) {
	  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
	  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
	  clamp(niceTickExtent, 0, extent);
	  clamp(niceTickExtent, 1, extent);
	
	  if (niceTickExtent[0] > niceTickExtent[1]) {
	    niceTickExtent[0] = niceTickExtent[1];
	  }
	}
	
	exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
	exports.getIntervalPrecision = getIntervalPrecision;
	exports.fixExtent = fixExtent;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual mapping.
	 */
	var visualDefault = {
	  /**
	   * @public
	   */
	  get: function (visualType, key, isCategory) {
	    var value = zrUtil.clone((defaultOption[visualType] || {})[key]);
	    return isCategory ? zrUtil.isArray(value) ? value[value.length - 1] : value : value;
	  }
	};
	var defaultOption = {
	  color: {
	    active: ['#006edd', '#e0ffff'],
	    inactive: ['rgba(0,0,0,0)']
	  },
	  colorHue: {
	    active: [0, 360],
	    inactive: [0, 0]
	  },
	  colorSaturation: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  colorLightness: {
	    active: [0.9, 0.5],
	    inactive: [0, 0]
	  },
	  colorAlpha: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  opacity: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  symbol: {
	    active: ['circle', 'roundRect', 'diamond'],
	    inactive: ['none']
	  },
	  symbolSize: {
	    active: [10, 50],
	    inactive: [0, 0]
	  }
	};
	var _default = visualDefault;
	module.exports = _default;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(861);
	
	function ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	        this.zero = 0;
	
	        for(var i = 0; i < this.data.length; i++) {
	            data[i] = data[i] & 0xFF;
	        }
	    }
	}
	ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	ArrayReader.prototype.byteAt = function(i) {
	    return this.data[this.zero + i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i - this.zero;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        return [];
	    }
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = ArrayReader;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(97);
	
	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	    this.zero = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < this.zero + newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;


/***/ }),
/* 862 */
/***/ (function(module, exports) {

	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.compressionOptions = null;
	exports.comment = null;
	exports.unixPermissions = null;
	exports.dosPermissions = null;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(861);
	var utils = __webpack_require__(97);
	
	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(this.zero + i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig) - this.zero;
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayReader = __webpack_require__(859);
	
	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	        this.zero = 0;
	    }
	}
	Uint8ArrayReader.prototype = new ArrayReader();
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(97);
	var support = __webpack_require__(178);
	var nodeBuffer = __webpack_require__(436);
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");
	
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 867 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(869),
	    createBaseEach = __webpack_require__(1898);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(2091),
	    keys = __webpack_require__(491);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(2105);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(2090),
	    getPrototype = __webpack_require__(2114),
	    getSymbols = __webpack_require__(920),
	    stubArray = __webpack_require__(2099);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
	});


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';
	
	
	var utils = __webpack_require__(133);
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safari
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // On Chrome, the arguments in a function call that are allowed is `65534`.
	  // If the length of the buffer is smaller than that, we can use this optimization,
	  // otherwise we will take a slower path.
	  if (len < 65534) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means buffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ }),
/* 874 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),
/* 875 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 876 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),
/* 877 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	function _extends() {
	  _extends = Object.assign || function(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  };
	  return _extends.apply(this, arguments);
	}
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	  return _typeof(obj);
	}
	
	var __extends = void 0 && (void 0).__extends || function() {
	  var _extendStatics = function extendStatics(d, b) {
	    _extendStatics = Object.setPrototypeOf || {
	      __proto__: []
	    }
	    instanceof Array && function(d, b) {
	      d.__proto__ = b;
	    } || function(d, b) {
	      for (var p in b) {
	        if (b.hasOwnProperty(p)) d[p] = b[p];
	      }
	    };
	
	    return _extendStatics(d, b);
	  };
	
	  return function(d, b) {
	    _extendStatics(d, b);
	
	    function __() {
	      this.constructor = d;
	    }
	
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	  };
	}();
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var React = __webpack_require__(1);
	
	var SERVER_RENDERED = typeof navigator === 'undefined' || global['PREVENT_CODEMIRROR_RENDER'] === true;
	var cm;
	
	if (!SERVER_RENDERED) {
	  cm = __webpack_require__(1578);
	}
	
	var Helper = function() {
	  function Helper() {}
	
	  Helper.equals = function(x, y) {
	    var _this = this;
	
	    var ok = Object.keys,
	      tx = _typeof(x),
	      ty = _typeof(y);
	
	    return x && y && tx === 'object' && tx === ty ? ok(x).length === ok(y).length && ok(x).every(function(key) {
	      return _this.equals(x[key], y[key]);
	    }) : x === y;
	  };
	
	  return Helper;
	}();
	
	var Shared = function() {
	  function Shared(editor, props) {
	    this.editor = editor;
	    this.props = props;
	  }
	
	  Shared.prototype.delegateCursor = function(position, scroll, focus) {
	    var doc = this.editor.getDoc();
	
	    if (focus) {
	      this.editor.focus();
	    }
	
	    scroll ? doc.setCursor(position) : doc.setCursor(position, null, {
	      scroll: false
	    });
	  };
	
	  Shared.prototype.delegateScroll = function(coordinates) {
	    this.editor.scrollTo(coordinates.x, coordinates.y);
	  };
	
	  Shared.prototype.delegateSelection = function(ranges, focus) {
	    var doc = this.editor.getDoc();
	    doc.setSelections(ranges);
	
	    if (focus) {
	      this.editor.focus();
	    }
	  };
	
	  Shared.prototype.apply = function(props) {
	    if (props && props.selection && props.selection.ranges) {
	      this.delegateSelection(props.selection.ranges, props.selection.focus || false);
	    }
	
	    if (props && props.cursor) {
	      this.delegateCursor(props.cursor, props.autoScroll || false, this.editor.getOption('autofocus') || false);
	    }
	
	    if (props && props.scroll) {
	      this.delegateScroll(props.scroll);
	    }
	  };
	
	  Shared.prototype.applyNext = function(props, next, preserved) {
	    if (props && props.selection && props.selection.ranges) {
	      if (next && next.selection && next.selection.ranges && !Helper.equals(props.selection.ranges, next.selection.ranges)) {
	        this.delegateSelection(next.selection.ranges, next.selection.focus || false);
	      }
	    }
	
	    if (props && props.cursor) {
	      if (next && next.cursor && !Helper.equals(props.cursor, next.cursor)) {
	        this.delegateCursor(preserved.cursor || next.cursor, next.autoScroll || false, next.autoCursor || false);
	      }
	    }
	
	    if (props && props.scroll) {
	      if (next && next.scroll && !Helper.equals(props.scroll, next.scroll)) {
	        this.delegateScroll(next.scroll);
	      }
	    }
	  };
	
	  Shared.prototype.applyUserDefined = function(props, preserved) {
	    if (preserved && preserved.cursor) {
	      this.delegateCursor(preserved.cursor, props.autoScroll || false, this.editor.getOption('autofocus') || false);
	    }
	  };
	
	  Shared.prototype.wire = function(props) {
	    var _this = this;
	
	    Object.keys(props || {}).filter(function(p) {
	      return /^on/.test(p);
	    }).forEach(function(prop) {
	      switch (prop) {
	        case 'onBlur':
	          {
	            _this.editor.on('blur', function(cm, event) {
	              _this.props.onBlur(_this.editor, event);
	            });
	          }
	          break;
	
	        case 'onContextMenu':
	          {
	            _this.editor.on('contextmenu', function(cm, event) {
	              _this.props.onContextMenu(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onCopy':
	          {
	            _this.editor.on('copy', function(cm, event) {
	              _this.props.onCopy(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onCursor':
	          {
	            _this.editor.on('cursorActivity', function(cm) {
	              _this.props.onCursor(_this.editor, _this.editor.getDoc().getCursor());
	            });
	          }
	          break;
	
	        case 'onCursorActivity':
	          {
	            _this.editor.on('cursorActivity', function(cm) {
	              _this.props.onCursorActivity(_this.editor);
	            });
	          }
	          break;
	
	        case 'onCut':
	          {
	            _this.editor.on('cut', function(cm, event) {
	              _this.props.onCut(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onDblClick':
	          {
	            _this.editor.on('dblclick', function(cm, event) {
	              _this.props.onDblClick(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onDragEnter':
	          {
	            _this.editor.on('dragenter', function(cm, event) {
	              _this.props.onDragEnter(_this.editor, event);
	            });
	          }
	          break;
	
	        case 'onDragLeave':
	          {
	            _this.editor.on('dragleave', function(cm, event) {
	              _this.props.onDragLeave(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onDragOver':
	          {
	            _this.editor.on('dragover', function(cm, event) {
	              _this.props.onDragOver(_this.editor, event);
	            });
	          }
	          break;
	
	        case 'onDragStart':
	          {
	            _this.editor.on('dragstart', function(cm, event) {
	              _this.props.onDragStart(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onDrop':
	          {
	            _this.editor.on('drop', function(cm, event) {
	              _this.props.onDrop(_this.editor, event);
	            });
	          }
	          break;
	
	        case 'onFocus':
	          {
	            _this.editor.on('focus', function(cm, event) {
	              _this.props.onFocus(_this.editor, event);
	            });
	          }
	          break;
	
	        case 'onGutterClick':
	          {
	            _this.editor.on('gutterClick', function(cm, lineNumber, gutter, event) {
	              _this.props.onGutterClick(_this.editor, lineNumber, gutter, event);
	            });
	          }
	          break;
	
	        case 'onKeyDown':
	          {
	            _this.editor.on('keydown', function(cm, event) {
	              _this.props.onKeyDown(_this.editor, event);
	            });
	          }
	          break;
	
	        case 'onKeyPress':
	          {
	            _this.editor.on('keypress', function(cm, event) {
	              _this.props.onKeyPress(_this.editor, event);
	            });
	          }
	          break;
	
	        case 'onKeyUp':
	          {
	            _this.editor.on('keyup', function(cm, event) {
	              _this.props.onKeyUp(_this.editor, event);
	            });
	          }
	          break;
	
	        case 'onMouseDown':
	          {
	            _this.editor.on('mousedown', function(cm, event) {
	              _this.props.onMouseDown(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onPaste':
	          {
	            _this.editor.on('paste', function(cm, event) {
	              _this.props.onPaste(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onRenderLine':
	          {
	            _this.editor.on('renderLine', function(cm, line, element) {
	              _this.props.onRenderLine(_this.editor, line, element);
	            });
	
	            break;
	          }
	
	        case 'onScroll':
	          {
	            _this.editor.on('scroll', function(cm) {
	              _this.props.onScroll(_this.editor, _this.editor.getScrollInfo());
	            });
	          }
	          break;
	
	        case 'onSelection':
	          {
	            _this.editor.on('beforeSelectionChange', function(cm, data) {
	              _this.props.onSelection(_this.editor, data);
	            });
	          }
	          break;
	
	        case 'onTouchStart':
	          {
	            _this.editor.on('touchstart', function(cm, event) {
	              _this.props.onTouchStart(_this.editor, event);
	            });
	
	            break;
	          }
	
	        case 'onUpdate':
	          {
	            _this.editor.on('update', function(cm) {
	              _this.props.onUpdate(_this.editor);
	            });
	          }
	          break;
	
	        case 'onViewportChange':
	          {
	            _this.editor.on('viewportChange', function(cm, from, to) {
	              _this.props.onViewportChange(_this.editor, from, to);
	            });
	          }
	          break;
	      }
	    });
	  };
	
	  return Shared;
	}();
	
	var Controlled = function(_super) {
	  __extends(Controlled, _super);
	
	  function Controlled(props) {
	    var _this = _super.call(this, props) || this;
	
	    if (SERVER_RENDERED) return _this;
	    _this.applied = false;
	    _this.appliedNext = false;
	    _this.appliedUserDefined = false;
	    _this.deferred = null;
	    _this.emulating = false;
	    _this.hydrated = false;
	
	    _this.initCb = function() {
	      if (_this.props.editorDidConfigure) {
	        _this.props.editorDidConfigure(_this.editor);
	      }
	    };
	
	    _this.mounted = false;
	    return _this;
	  }
	
	  Controlled.prototype.hydrate = function(props) {
	    var _this = this;
	
	    var _options = props && props.options ? props.options : {};
	
	    var userDefinedOptions = _extends({}, cm.defaults, this.editor.options, _options);
	
	    var optionDelta = Object.keys(userDefinedOptions).some(function(key) {
	      return _this.editor.getOption(key) !== userDefinedOptions[key];
	    });
	
	    if (optionDelta) {
	      Object.keys(userDefinedOptions).forEach(function(key) {
	        if (_options.hasOwnProperty(key)) {
	          if (_this.editor.getOption(key) !== userDefinedOptions[key]) {
	            _this.editor.setOption(key, userDefinedOptions[key]);
	
	            _this.mirror.setOption(key, userDefinedOptions[key]);
	          }
	        }
	      });
	    }
	
	    if (!this.hydrated) {
	      this.deferred ? this.resolveChange() : this.initChange(props.value || '');
	    }
	
	    this.hydrated = true;
	  };
	
	  Controlled.prototype.initChange = function(value) {
	    this.emulating = true;
	    var doc = this.editor.getDoc();
	    var lastLine = doc.lastLine();
	    var lastChar = doc.getLine(doc.lastLine()).length;
	    doc.replaceRange(value || '', {
	      line: 0,
	      ch: 0
	    }, {
	      line: lastLine,
	      ch: lastChar
	    });
	    this.mirror.setValue(value);
	    doc.clearHistory();
	    this.mirror.clearHistory();
	    this.emulating = false;
	  };
	
	  Controlled.prototype.resolveChange = function() {
	    this.emulating = true;
	    var doc = this.editor.getDoc();
	
	    if (this.deferred.origin === 'undo') {
	      doc.undo();
	    } else if (this.deferred.origin === 'redo') {
	      doc.redo();
	    } else {
	      doc.replaceRange(this.deferred.text, this.deferred.from, this.deferred.to, this.deferred.origin);
	    }
	
	    this.emulating = false;
	    this.deferred = null;
	  };
	
	  Controlled.prototype.mirrorChange = function(deferred) {
	    var doc = this.editor.getDoc();
	
	    if (deferred.origin === 'undo') {
	      doc.setHistory(this.mirror.getHistory());
	      this.mirror.undo();
	    } else if (deferred.origin === 'redo') {
	      doc.setHistory(this.mirror.getHistory());
	      this.mirror.redo();
	    } else {
	      this.mirror.replaceRange(deferred.text, deferred.from, deferred.to, deferred.origin);
	    }
	
	    return this.mirror.getValue();
	  };
	
	  Controlled.prototype.componentDidMount = function() {
	    var _this = this;
	
	    if (SERVER_RENDERED) return;
	
	    if (this.props.defineMode) {
	      if (this.props.defineMode.name && this.props.defineMode.fn) {
	        cm.defineMode(this.props.defineMode.name, this.props.defineMode.fn);
	      }
	    }
	
	    this.editor = cm(this.ref);
	    this.shared = new Shared(this.editor, this.props);
	    this.mirror = cm(function() {});
	    this.editor.on('electricInput', function() {
	      _this.mirror.setHistory(_this.editor.getDoc().getHistory());
	    });
	    this.editor.on('cursorActivity', function() {
	      _this.mirror.setCursor(_this.editor.getDoc().getCursor());
	    });
	    this.editor.on('beforeChange', function(cm, data) {
	      if (_this.emulating) {
	        return;
	      }
	
	      data.cancel();
	      _this.deferred = data;
	
	      var phantomChange = _this.mirrorChange(_this.deferred);
	
	      if (_this.props.onBeforeChange) _this.props.onBeforeChange(_this.editor, _this.deferred, phantomChange);
	    });
	    this.editor.on('change', function(cm, data) {
	      if (!_this.mounted) {
	        return;
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(_this.editor, data, _this.editor.getValue());
	      }
	    });
	    this.hydrate(this.props);
	    this.shared.apply(this.props);
	    this.applied = true;
	    this.mounted = true;
	    this.shared.wire(this.props);
	
	    if (this.editor.getOption('autofocus')) {
	      this.editor.focus();
	    }
	
	    if (this.props.editorDidMount) {
	      this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb);
	    }
	  };
	
	  Controlled.prototype.componentDidUpdate = function(prevProps) {
	    if (SERVER_RENDERED) return;
	    var preserved = {
	      cursor: null
	    };
	
	    if (this.props.value !== prevProps.value) {
	      this.hydrated = false;
	    }
	
	    if (!this.props.autoCursor && this.props.autoCursor !== undefined) {
	      preserved.cursor = this.editor.getDoc().getCursor();
	    }
	
	    this.hydrate(this.props);
	
	    if (!this.appliedNext) {
	      this.shared.applyNext(prevProps, this.props, preserved);
	      this.appliedNext = true;
	    }
	
	    this.shared.applyUserDefined(prevProps, preserved);
	    this.appliedUserDefined = true;
	  };
	
	  Controlled.prototype.componentWillUnmount = function() {
	    if (SERVER_RENDERED) return;
	
	    if (this.props.editorWillUnmount) {
	      this.props.editorWillUnmount(cm);
	    }
	  };
	
	  Controlled.prototype.shouldComponentUpdate = function(nextProps, nextState) {
	    return !SERVER_RENDERED;
	  };
	
	  Controlled.prototype.render = function() {
	    var _this = this;
	
	    if (SERVER_RENDERED) return null;
	    var className = this.props.className ? 'react-codemirror2 ' + this.props.className : 'react-codemirror2';
	    return React.createElement('div', {
	      className: className,
	      ref: function ref(self) {
	        return _this.ref = self;
	      }
	    });
	  };
	
	  return Controlled;
	}(React.Component);
	
	exports.Controlled = Controlled;
	
	var UnControlled = function(_super) {
	  __extends(UnControlled, _super);
	
	  function UnControlled(props) {
	    var _this = _super.call(this, props) || this;
	
	    if (SERVER_RENDERED) return _this;
	    _this.applied = false;
	    _this.appliedUserDefined = false;
	    _this.continueChange = false;
	    _this.detached = false;
	    _this.hydrated = false;
	
	    _this.initCb = function() {
	      if (_this.props.editorDidConfigure) {
	        _this.props.editorDidConfigure(_this.editor);
	      }
	    };
	
	    _this.mounted = false;
	
	    _this.onBeforeChangeCb = function() {
	      _this.continueChange = true;
	    };
	
	    return _this;
	  }
	
	  UnControlled.prototype.hydrate = function(props) {
	    var _this = this;
	
	    var _options = props && props.options ? props.options : {};
	
	    var userDefinedOptions = _extends({}, cm.defaults, this.editor.options, _options);
	
	    var optionDelta = Object.keys(userDefinedOptions).some(function(key) {
	      return _this.editor.getOption(key) !== userDefinedOptions[key];
	    });
	
	    if (optionDelta) {
	      Object.keys(userDefinedOptions).forEach(function(key) {
	        if (_options.hasOwnProperty(key)) {
	          if (_this.editor.getOption(key) !== userDefinedOptions[key]) {
	            _this.editor.setOption(key, userDefinedOptions[key]);
	          }
	        }
	      });
	    }
	
	    if (!this.hydrated) {
	      var doc = this.editor.getDoc();
	      var lastLine = doc.lastLine();
	      var lastChar = doc.getLine(doc.lastLine()).length;
	      doc.replaceRange(props.value || '', {
	        line: 0,
	        ch: 0
	      }, {
	        line: lastLine,
	        ch: lastChar
	      });
	    }
	
	    this.hydrated = true;
	  };
	
	  UnControlled.prototype.componentDidMount = function() {
	    var _this = this;
	
	    if (SERVER_RENDERED) return;
	    this.detached = this.props.detach === true;
	
	    if (this.props.defineMode) {
	      if (this.props.defineMode.name && this.props.defineMode.fn) {
	        cm.defineMode(this.props.defineMode.name, this.props.defineMode.fn);
	      }
	    }
	
	    this.editor = cm(this.ref);
	    this.shared = new Shared(this.editor, this.props);
	    this.editor.on('beforeChange', function(cm, data) {
	      if (_this.props.onBeforeChange) {
	        _this.props.onBeforeChange(_this.editor, data, _this.editor.getValue(), _this.onBeforeChangeCb);
	      }
	    });
	    this.editor.on('change', function(cm, data) {
	      if (!_this.mounted || !_this.props.onChange) {
	        return;
	      }
	
	      if (_this.props.onBeforeChange) {
	        if (_this.continueChange) {
	          _this.props.onChange(_this.editor, data, _this.editor.getValue());
	        }
	      } else {
	        _this.props.onChange(_this.editor, data, _this.editor.getValue());
	      }
	    });
	    this.hydrate(this.props);
	    this.shared.apply(this.props);
	    this.applied = true;
	    this.mounted = true;
	    this.shared.wire(this.props);
	    this.editor.getDoc().clearHistory();
	
	    if (this.props.editorDidMount) {
	      this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb);
	    }
	  };
	
	  UnControlled.prototype.componentDidUpdate = function(prevProps) {
	    if (this.detached && this.props.detach === false) {
	      this.detached = false;
	
	      if (prevProps.editorDidAttach) {
	        prevProps.editorDidAttach(this.editor);
	      }
	    }
	
	    if (!this.detached && this.props.detach === true) {
	      this.detached = true;
	
	      if (prevProps.editorDidDetach) {
	        prevProps.editorDidDetach(this.editor);
	      }
	    }
	
	    if (SERVER_RENDERED || this.detached) return;
	    var preserved = {
	      cursor: null
	    };
	
	    if (this.props.value !== prevProps.value) {
	      this.hydrated = false;
	      this.applied = false;
	      this.appliedUserDefined = false;
	    }
	
	    if (!prevProps.autoCursor && prevProps.autoCursor !== undefined) {
	      preserved.cursor = this.editor.getDoc().getCursor();
	    }
	
	    this.hydrate(this.props);
	
	    if (!this.applied) {
	      this.shared.apply(prevProps);
	      this.applied = true;
	    }
	
	    if (!this.appliedUserDefined) {
	      this.shared.applyUserDefined(prevProps, preserved);
	      this.appliedUserDefined = true;
	    }
	  };
	
	  UnControlled.prototype.componentWillUnmount = function() {
	    if (SERVER_RENDERED) return;
	
	    if (this.props.editorWillUnmount) {
	      this.props.editorWillUnmount(cm);
	    }
	  };
	
	  UnControlled.prototype.shouldComponentUpdate = function(nextProps, nextState) {
	    var update = true;
	    if (SERVER_RENDERED) update = false;
	    if (this.detached && nextProps.detach) update = false;
	    return update;
	  };
	
	  UnControlled.prototype.render = function() {
	    var _this = this;
	
	    if (SERVER_RENDERED) return null;
	    var className = this.props.className ? 'react-codemirror2 ' + this.props.className : 'react-codemirror2';
	    return React.createElement('div', {
	      className: className,
	      ref: function ref(self) {
	        return _this.ref = self;
	      }
	    });
	  };
	
	  return UnControlled;
	}(React.Component);
	
	exports.UnControlled = UnControlled;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(100);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_ref) {
	    _inherits(ColorPicker, _ref);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
	
	      _this.handleChange = function (data, event) {
	        var isValidColor = color.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = color.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
	          _this.props.onChange && _this.props.onChange(colors, event);
	        }
	      };
	
	      _this.handleSwatchHover = function (data, event) {
	        var isValidColor = color.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = color.toState(data, data.h || _this.state.oldHue);
	          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
	        }
	      };
	
	      _this.state = _extends({}, color.toState(props.color, 0));
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
	        fn(data, event);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'render',
	      value: function render() {
	        var optionalEvents = {};
	        if (this.props.onSwatchHover) {
	          optionalEvents.onSwatchHover = this.handleSwatchHover;
	        }
	
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
	          onChange: this.handleChange
	        }, optionalEvents));
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(nextProps, state) {
	        return _extends({}, color.toState(nextProps.color, state.oldHue));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react.PureComponent || _react.Component);
	
	  ColorPicker.propTypes = _extends({}, Picker.propTypes);
	
	  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
	    color: {
	      h: 250,
	      s: 0.50,
	      l: 0.20,
	      a: 1
	    }
	  });
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _require = __webpack_require__(1971),
	    Draggable = _require.default,
	    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
	// See https://github.com/mzabriskie/react-draggable/pull/254
	// and https://github.com/mzabriskie/react-draggable/issues/266
	
	
	module.exports = Draggable;
	module.exports.default = Draggable;
	module.exports.DraggableCore = DraggableCore;

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	/*eslint no-console:0*/
	function log() {
	  var _console;
	
	  if (undefined) (_console = console).log.apply(_console, arguments);
	}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canDragX = canDragX;
	exports.canDragY = canDragY;
	exports.createCoreData = createCoreData;
	exports.createDraggableData = createDraggableData;
	exports.getBoundPosition = getBoundPosition;
	exports.getControlPosition = getControlPosition;
	exports.snapToGrid = snapToGrid;
	
	var _shims = __webpack_require__(278);
	
	var _domFns = __webpack_require__(441);
	
	function getBoundPosition(draggable
	/*: Draggable*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: [number, number]*/
	{
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y]; // Clone new bounds
	
	  var bounds = draggable.props.bounds;
	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);
	
	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;
	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode;
	
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	
	    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	
	    var boundNodeEl
	    /*: HTMLElement*/
	    = boundNode; // for Flow, can't seem to refine correctly
	
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	
	    bounds = {
	      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
	      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
	      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
	      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
	    };
	  } // Keep x and y below right and bottom limits...
	
	
	  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
	  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.
	
	  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
	  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
	  return [x, y];
	}
	
	function snapToGrid(grid
	/*: [number, number]*/
	, pendingX
	/*: number*/
	, pendingY
	/*: number*/
	)
	/*: [number, number]*/
	{
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}
	
	function canDragX(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}
	
	function canDragY(draggable
	/*: Draggable*/
	)
	/*: boolean*/
	{
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	} // Get {x, y} positions from event.
	
	
	function getControlPosition(e
	/*: MouseTouchEvent*/
	, touchIdentifier
	/*: ?number*/
	, draggableCore
	/*: DraggableCore*/
	)
	/*: ?ControlPosition*/
	{
	  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	
	  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.
	
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
	} // Create an data object exposed by <DraggableCore>'s events
	
	
	function createCoreData(draggable
	/*: DraggableCore*/
	, x
	/*: number*/
	, y
	/*: number*/
	)
	/*: DraggableData*/
	{
	  var state = draggable.state;
	  var isStart = !(0, _shims.isNum)(state.lastX);
	  var node = findDOMNode(draggable);
	
	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0,
	      deltaY: 0,
	      lastX: x,
	      lastY: y,
	      x: x,
	      y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX,
	      deltaY: y - state.lastY,
	      lastX: state.lastX,
	      lastY: state.lastY,
	      x: x,
	      y: y
	    };
	  }
	} // Create an data exposed by <Draggable>'s events
	
	
	function createDraggableData(draggable
	/*: Draggable*/
	, coreData
	/*: DraggableData*/
	)
	/*: DraggableData*/
	{
	  var scale = draggable.props.scale;
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX / scale,
	    y: draggable.state.y + coreData.deltaY / scale,
	    deltaX: coreData.deltaX / scale,
	    deltaY: coreData.deltaY / scale,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	} // A lot faster than stringify/parse
	
	
	function cloneBounds(bounds
	/*: Bounds*/
	)
	/*: Bounds*/
	{
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}
	
	function findDOMNode(draggable
	/*: Draggable | DraggableCore*/
	)
	/*: HTMLElement*/
	{
	  var node = draggable.findDOMNode();
	
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	
	
	  return node;
	}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDraggable = __webpack_require__(880);
	
	var _utils = __webpack_require__(1975);
	
	var _propTypes = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Resizable = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Resizable, _React$Component);
	
	  function Resizable() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "state", undefined);
	
	    _defineProperty(_assertThisInitialized(_this), "lastHandleRect", null);
	
	    _defineProperty(_assertThisInitialized(_this), "slack", null);
	
	    return _this;
	  }
	
	  var _proto = Resizable.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.resetData();
	  };
	
	  _proto.lockAspectRatio = function lockAspectRatio(width, height, aspectRatio) {
	    height = width / aspectRatio;
	    width = height * aspectRatio;
	    return [width, height];
	  };
	
	  _proto.resetData = function resetData() {
	    this.lastHandleRect = this.slack = null;
	  } // Clamp width and height within provided constraints
	  ;
	
	  _proto.runConstraints = function runConstraints(width, height) {
	    var _ref = [this.props.minConstraints, this.props.maxConstraints],
	        min = _ref[0],
	        max = _ref[1];
	    if (!min && !max) return [width, height]; // If constraining to min and max, we need to also fit width and height to aspect ratio.
	
	    if (this.props.lockAspectRatio) {
	      var resizingHorizontally = height === this.props.height;
	
	      if (resizingHorizontally) {
	        var ratio = this.props.width / this.props.height;
	        height = width / ratio;
	        width = height * ratio;
	      } else {
	        // Take into account vertical resize with N/S handles on locked aspect
	        // ratio. Calculate the change height-first, instead of width-first
	        var _ratio = this.props.height / this.props.width;
	
	        width = height / _ratio;
	        height = width * _ratio;
	      }
	    }
	
	    var oldW = width,
	        oldH = height; // Add slack to the values used to calculate bound position. This will ensure that if
	    // we start removing slack, the element won't react to it right away until it's been
	    // completely removed.
	
	    var _ref2 = this.slack || [0, 0],
	        slackW = _ref2[0],
	        slackH = _ref2[1];
	
	    width += slackW;
	    height += slackH;
	
	    if (min) {
	      width = Math.max(min[0], width);
	      height = Math.max(min[1], height);
	    }
	
	    if (max) {
	      width = Math.min(max[0], width);
	      height = Math.min(max[1], height);
	    } // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
	
	
	    this.slack = [slackW + (oldW - width), slackH + (oldH - height)];
	    return [width, height];
	  }
	  /**
	   * Wrapper around drag events to provide more useful data.
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	  ;
	
	  _proto.resizeHandler = function resizeHandler(handlerName, axis) {
	    var _this2 = this;
	
	    return function (e, _ref3) {
	      var node = _ref3.node,
	          deltaX = _ref3.deltaX,
	          deltaY = _ref3.deltaY;
	      // Reset data in case it was left over somehow (should not be possible)
	      if (handlerName === 'onResizeStart') _this2.resetData(); // Axis restrictions
	
	      var canDragX = (_this2.props.axis === 'both' || _this2.props.axis === 'x') && axis !== 'n' && axis !== 's';
	      var canDragY = (_this2.props.axis === 'both' || _this2.props.axis === 'y') && axis !== 'e' && axis !== 'w'; // No dragging possible.
	
	      if (!canDragX && !canDragY) return; // Decompose axis for later use
	
	      var axisV = axis[0];
	      var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
	      // Track the element being dragged to account for changes in position.
	      // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
	      // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
	
	      var handleRect = node.getBoundingClientRect();
	
	      if (_this2.lastHandleRect != null) {
	        // If the handle has repositioned on either axis since last render,
	        // we need to increase our callback values by this much.
	        // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
	        if (axisH === 'w') {
	          var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
	          deltaX += deltaLeftSinceLast;
	        }
	
	        if (axisV === 'n') {
	          var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
	          deltaY += deltaTopSinceLast;
	        }
	      } // Storage of last rect so we know how much it has really moved.
	
	
	      _this2.lastHandleRect = handleRect; // Reverse delta if using top or left drag handles.
	
	      if (axisH === 'w') deltaX = -deltaX;
	      if (axisV === 'n') deltaY = -deltaY; // Update w/h by the deltas. Also factor in transformScale.
	
	      var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
	      var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0); // Run user-provided constraints.
	
	      var _this2$runConstraints = _this2.runConstraints(width, height);
	
	      width = _this2$runConstraints[0];
	      height = _this2$runConstraints[1];
	      var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height; // Call user-supplied callback if present.
	
	      var cb = typeof _this2.props[handlerName] === 'function' ? _this2.props[handlerName] : null; // Don't call 'onResize' if dimensions haven't changed.
	
	      var shouldSkipCb = handlerName === 'onResize' && !dimensionsChanged;
	
	      if (cb && !shouldSkipCb) {
	        if (typeof e.persist === 'function') e.persist();
	        cb(e, {
	          node: node,
	          size: {
	            width: width,
	            height: height
	          },
	          handle: axis
	        });
	      } // Reset internal data
	
	
	      if (handlerName === 'onResizeStop') _this2.resetData();
	    };
	  };
	
	  _proto.renderResizeHandle = function renderResizeHandle(resizeHandleAxis) {
	    var handle = this.props.handle;
	
	    if (handle) {
	      if (typeof handle === 'function') {
	        return handle(resizeHandleAxis);
	      }
	
	      return handle;
	    }
	
	    return /*#__PURE__*/_react.default.createElement("span", {
	      className: "react-resizable-handle react-resizable-handle-" + resizeHandleAxis
	    });
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    // Pass along only props not meant for the `<Resizable>`.`
	    // eslint-disable-next-line no-unused-vars
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        draggableOpts = _this$props.draggableOpts,
	        width = _this$props.width,
	        height = _this$props.height,
	        handle = _this$props.handle,
	        handleSize = _this$props.handleSize,
	        lockAspectRatio = _this$props.lockAspectRatio,
	        axis = _this$props.axis,
	        minConstraints = _this$props.minConstraints,
	        maxConstraints = _this$props.maxConstraints,
	        onResize = _this$props.onResize,
	        onResizeStop = _this$props.onResizeStop,
	        onResizeStart = _this$props.onResizeStart,
	        resizeHandles = _this$props.resizeHandles,
	        transformScale = _this$props.transformScale,
	        p = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"]); // What we're doing here is getting the child of this element, and cloning it with this element's props.
	    // We are then defining its children as:
	    // Its original children (resizable's child's children), and
	    // One or more draggable handles.
	
	
	    return (0, _utils.cloneElement)(children, _objectSpread(_objectSpread({}, p), {}, {
	      className: (className ? className + " " : '') + "react-resizable",
	      children: [].concat(children.props.children, resizeHandles.map(function (handleAxis) {
	        return /*#__PURE__*/_react.default.createElement(_reactDraggable.DraggableCore, _extends({}, draggableOpts, {
	          key: "resizableHandle-" + handleAxis,
	          onStop: _this3.resizeHandler('onResizeStop', handleAxis),
	          onStart: _this3.resizeHandler('onResizeStart', handleAxis),
	          onDrag: _this3.resizeHandler('onResize', handleAxis)
	        }), _this3.renderResizeHandle(handleAxis));
	      }))
	    }));
	  };
	
	  return Resizable;
	}(_react.default.Component);
	
	exports.default = Resizable;
	
	_defineProperty(Resizable, "propTypes", _propTypes.resizableProps);
	
	_defineProperty(Resizable, "defaultProps", {
	  handleSize: [20, 20],
	  lockAspectRatio: false,
	  axis: 'both',
	  minConstraints: [20, 20],
	  maxConstraints: [Infinity, Infinity],
	  resizeHandles: ['se'],
	  transformScale: 1
	});

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.resizableProps = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactDraggable = __webpack_require__(880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resizableProps = {
	  /*
	  * Restricts resizing to a particular axis (default: 'both')
	  * 'both' - allows resizing by width or height
	  * 'x' - only allows the width to be changed
	  * 'y' - only allows the height to be changed
	  * 'none' - disables resizing altogether
	  * */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	  className: _propTypes.default.string,
	
	  /*
	  * Require that one and only one child be present.
	  * */
	  children: _propTypes.default.element.isRequired,
	
	  /*
	  * These will be passed wholesale to react-draggable's DraggableCore
	  * */
	  draggableOpts: _propTypes.default.shape({
	    allowAnyClick: _propTypes.default.bool,
	    cancel: _propTypes.default.string,
	    children: _propTypes.default.node,
	    disabled: _propTypes.default.bool,
	    enableUserSelectHack: _propTypes.default.bool,
	    offsetParent: _propTypes.default.node,
	    grid: _propTypes.default.arrayOf(_propTypes.default.number),
	    handle: _propTypes.default.string,
	    nodeRef: _propTypes.default.object,
	    onStart: _propTypes.default.func,
	    onDrag: _propTypes.default.func,
	    onStop: _propTypes.default.func,
	    onMouseDown: _propTypes.default.func,
	    scale: _propTypes.default.number
	  }),
	
	  /*
	  * Initial height
	  * */
	  height: _propTypes.default.number.isRequired,
	
	  /*
	  * Customize cursor resize handle
	  * */
	  handle: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	  /*
	  * If you change this, be sure to update your css
	  * */
	  handleSize: _propTypes.default.arrayOf(_propTypes.default.number),
	  lockAspectRatio: _propTypes.default.bool,
	
	  /*
	  * Max X & Y measure
	  * */
	  maxConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /*
	  * Min X & Y measure
	  * */
	  minConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /*
	  * Called on stop resize event
	  * */
	  onResizeStop: _propTypes.default.func,
	
	  /*
	  * Called on start resize event
	  * */
	  onResizeStart: _propTypes.default.func,
	
	  /*
	  * Called on resize event
	  * */
	  onResize: _propTypes.default.func,
	
	  /*
	  * Defines which resize handles should be rendered (default: 'se')
	  * 's' - South handle (bottom-center)
	  * 'w' - West handle (left-center)
	  * 'e' - East handle (right-center)
	  * 'n' - North handle (top-center)
	  * 'sw' - Southwest handle (bottom-left)
	  * 'nw' - Northwest handle (top-left)
	  * 'se' - Southeast handle (bottom-right)
	  * 'ne' - Northeast handle (top-center)
	  * */
	  resizeHandles: _propTypes.default.arrayOf(_propTypes.default.oneOf(['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'])),
	
	  /*
	  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
	  * */
	  transformScale: _propTypes.default.number,
	
	  /*
	   * Initial width
	   */
	  width: _propTypes.default.number.isRequired
	};
	exports.resizableProps = resizableProps;

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	var _default = function _default(fn) {
	  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
	  var timer = null;
	  return function () {
	    var _this = this;
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    clearTimeout(timer);
	    timer = setTimeout(function () {
	      fn.apply(_this, args);
	    }, delay);
	  };
	};
	exports["default"] = _default;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1585);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!./foldgutter.css", function() {
				var newContent = require("!!../../../../../css-loader/index.js!./foldgutter.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1586);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!./show-hint.css", function() {
				var newContent = require("!!../../../../../css-loader/index.js!./show-hint.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1587);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!./lint.css", function() {
				var newContent = require("!!../../../../../css-loader/index.js!./lint.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1588);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!./matchesonscrollbar.css", function() {
				var newContent = require("!!../../../../../css-loader/index.js!./matchesonscrollbar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1589);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!./codemirror.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!./codemirror.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1590);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!./monokai.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!./monokai.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1600);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules!./Login.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules!./Login.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(904);
	
	var Eventful = __webpack_require__(148);
	
	var Transformable = __webpack_require__(284);
	
	var Animatable = __webpack_require__(2079);
	
	var zrUtil = __webpack_require__(2);
	
	/**
	 * @alias module:zrender/Element
	 * @constructor
	 * @extends {module:zrender/mixin/Animatable}
	 * @extends {module:zrender/mixin/Transformable}
	 * @extends {module:zrender/mixin/Eventful}
	 */
	var Element = function (opts) {
	  // jshint ignore:line
	  Transformable.call(this, opts);
	  Eventful.call(this, opts);
	  Animatable.call(this, opts);
	  /**
	   * 画布元素ID
	   * @type {string}
	   */
	
	  this.id = opts.id || guid();
	};
	
	Element.prototype = {
	  /**
	   * 元素类型
	   * Element type
	   * @type {string}
	   */
	  type: 'element',
	
	  /**
	   * 元素名字
	   * Element name
	   * @type {string}
	   */
	  name: '',
	
	  /**
	   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
	   * ZRender instance will be assigned when element is associated with zrender
	   * @name module:/zrender/Element#__zr
	   * @type {module:zrender/ZRender}
	   */
	  __zr: null,
	
	  /**
	   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
	   * If ignore drawing and events of the element object
	   * @name module:/zrender/Element#ignore
	   * @type {boolean}
	   * @default false
	   */
	  ignore: false,
	
	  /**
	   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
	   * 该路径会继承被裁减对象的变换
	   * @type {module:zrender/graphic/Path}
	   * @see http://www.w3.org/TR/2dcontext/#clipping-region
	   * @readOnly
	   */
	  clipPath: null,
	
	  /**
	   * 是否是 Group
	   * @type {boolean}
	   */
	  isGroup: false,
	
	  /**
	   * Drift element
	   * @param  {number} dx dx on the global space
	   * @param  {number} dy dy on the global space
	   */
	  drift: function (dx, dy) {
	    switch (this.draggable) {
	      case 'horizontal':
	        dy = 0;
	        break;
	
	      case 'vertical':
	        dx = 0;
	        break;
	    }
	
	    var m = this.transform;
	
	    if (!m) {
	      m = this.transform = [1, 0, 0, 1, 0, 0];
	    }
	
	    m[4] += dx;
	    m[5] += dy;
	    this.decomposeTransform();
	    this.dirty(false);
	  },
	
	  /**
	   * Hook before update
	   */
	  beforeUpdate: function () {},
	
	  /**
	   * Hook after update
	   */
	  afterUpdate: function () {},
	
	  /**
	   * Update each frame
	   */
	  update: function () {
	    this.updateTransform();
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {},
	
	  /**
	   * @protected
	   */
	  attrKV: function (key, value) {
	    if (key === 'position' || key === 'scale' || key === 'origin') {
	      // Copy the array
	      if (value) {
	        var target = this[key];
	
	        if (!target) {
	          target = this[key] = [];
	        }
	
	        target[0] = value[0];
	        target[1] = value[1];
	      }
	    } else {
	      this[key] = value;
	    }
	  },
	
	  /**
	   * Hide the element
	   */
	  hide: function () {
	    this.ignore = true;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * Show the element
	   */
	  show: function () {
	    this.ignore = false;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * @param {string|Object} key
	   * @param {*} value
	   */
	  attr: function (key, value) {
	    if (typeof key === 'string') {
	      this.attrKV(key, value);
	    } else if (zrUtil.isObject(key)) {
	      for (var name in key) {
	        if (key.hasOwnProperty(name)) {
	          this.attrKV(name, key[name]);
	        }
	      }
	    }
	
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * @param {module:zrender/graphic/Path} clipPath
	   */
	  setClipPath: function (clipPath) {
	    var zr = this.__zr;
	
	    if (zr) {
	      clipPath.addSelfToZr(zr);
	    } // Remove previous clip path
	
	
	    if (this.clipPath && this.clipPath !== clipPath) {
	      this.removeClipPath();
	    }
	
	    this.clipPath = clipPath;
	    clipPath.__zr = zr;
	    clipPath.__clipTarget = this;
	    this.dirty(false);
	  },
	
	  /**
	   */
	  removeClipPath: function () {
	    var clipPath = this.clipPath;
	
	    if (clipPath) {
	      if (clipPath.__zr) {
	        clipPath.removeSelfFromZr(clipPath.__zr);
	      }
	
	      clipPath.__zr = null;
	      clipPath.__clipTarget = null;
	      this.clipPath = null;
	      this.dirty(false);
	    }
	  },
	
	  /**
	   * Add self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  addSelfToZr: function (zr) {
	    this.__zr = zr; // 添加动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.addAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.addSelfToZr(zr);
	    }
	  },
	
	  /**
	   * Remove self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  removeSelfFromZr: function (zr) {
	    this.__zr = null; // 移除动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.removeAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.removeSelfFromZr(zr);
	    }
	  }
	};
	zrUtil.mixin(Element, Animatable);
	zrUtil.mixin(Element, Transformable);
	zrUtil.mixin(Element, Eventful);
	var _default = Element;
	module.exports = _default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	var Clip = __webpack_require__(2061);
	
	var color = __webpack_require__(105);
	
	var _util = __webpack_require__(2);
	
	var isArrayLike = _util.isArrayLike;
	
	/**
	 * @module echarts/animation/Animator
	 */
	var arraySlice = Array.prototype.slice;
	
	function defaultGetter(target, key) {
	  return target[key];
	}
	
	function defaultSetter(target, key, value) {
	  target[key] = value;
	}
	/**
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} percent
	 * @return {number}
	 */
	
	
	function interpolateNumber(p0, p1, percent) {
	  return (p1 - p0) * percent + p0;
	}
	/**
	 * @param  {string} p0
	 * @param  {string} p1
	 * @param  {number} percent
	 * @return {string}
	 */
	
	
	function interpolateString(p0, p1, percent) {
	  return percent > 0.5 ? p1 : p0;
	}
	/**
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {number} percent
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function interpolateArray(p0, p1, percent, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = interpolateNumber(p0[i], p1[i], percent);
	    }
	  } else {
	    var len2 = len && p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
	      }
	    }
	  }
	} // arr0 is source array, arr1 is target array.
	// Do some preprocess to avoid error happened when interpolating from arr0 to arr1
	
	
	function fillArr(arr0, arr1, arrDim) {
	  var arr0Len = arr0.length;
	  var arr1Len = arr1.length;
	
	  if (arr0Len !== arr1Len) {
	    // FIXME Not work for TypedArray
	    var isPreviousLarger = arr0Len > arr1Len;
	
	    if (isPreviousLarger) {
	      // Cut the previous
	      arr0.length = arr1Len;
	    } else {
	      // Fill the previous
	      for (var i = arr0Len; i < arr1Len; i++) {
	        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
	      }
	    }
	  } // Handling NaN value
	
	
	  var len2 = arr0[0] && arr0[0].length;
	
	  for (var i = 0; i < arr0.length; i++) {
	    if (arrDim === 1) {
	      if (isNaN(arr0[i])) {
	        arr0[i] = arr1[i];
	      }
	    } else {
	      for (var j = 0; j < len2; j++) {
	        if (isNaN(arr0[i][j])) {
	          arr0[i][j] = arr1[i][j];
	        }
	      }
	    }
	  }
	}
	/**
	 * @param  {Array} arr0
	 * @param  {Array} arr1
	 * @param  {number} arrDim
	 * @return {boolean}
	 */
	
	
	function isArraySame(arr0, arr1, arrDim) {
	  if (arr0 === arr1) {
	    return true;
	  }
	
	  var len = arr0.length;
	
	  if (len !== arr1.length) {
	    return false;
	  }
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      if (arr0[i] !== arr1[i]) {
	        return false;
	      }
	    }
	  } else {
	    var len2 = arr0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        if (arr0[i][j] !== arr1[i][j]) {
	          return false;
	        }
	      }
	    }
	  }
	
	  return true;
	}
	/**
	 * Catmull Rom interpolate array
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {Array} p2
	 * @param  {Array} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
	    }
	  } else {
	    var len2 = p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
	      }
	    }
	  }
	}
	/**
	 * Catmull Rom interpolate number
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @return {number}
	 */
	
	
	function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	
	function cloneValue(value) {
	  if (isArrayLike(value)) {
	    var len = value.length;
	
	    if (isArrayLike(value[0])) {
	      var ret = [];
	
	      for (var i = 0; i < len; i++) {
	        ret.push(arraySlice.call(value[i]));
	      }
	
	      return ret;
	    }
	
	    return arraySlice.call(value);
	  }
	
	  return value;
	}
	
	function rgba2String(rgba) {
	  rgba[0] = Math.floor(rgba[0]);
	  rgba[1] = Math.floor(rgba[1]);
	  rgba[2] = Math.floor(rgba[2]);
	  return 'rgba(' + rgba.join(',') + ')';
	}
	
	function getArrayDim(keyframes) {
	  var lastValue = keyframes[keyframes.length - 1].value;
	  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
	}
	
	function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
	  var getter = animator._getter;
	  var setter = animator._setter;
	  var useSpline = easing === 'spline';
	  var trackLen = keyframes.length;
	
	  if (!trackLen) {
	    return;
	  } // Guess data type
	
	
	  var firstVal = keyframes[0].value;
	  var isValueArray = isArrayLike(firstVal);
	  var isValueColor = false;
	  var isValueString = false; // For vertices morphing
	
	  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
	  var trackMaxTime; // Sort keyframe as ascending
	
	  keyframes.sort(function (a, b) {
	    return a.time - b.time;
	  });
	  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe
	
	  var kfPercents = []; // Value of each keyframe
	
	  var kfValues = [];
	  var prevValue = keyframes[0].value;
	  var isAllValueEqual = true;
	
	  for (var i = 0; i < trackLen; i++) {
	    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string
	
	    var value = keyframes[i].value; // Check if value is equal, deep check if value is array
	
	    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
	      isAllValueEqual = false;
	    }
	
	    prevValue = value; // Try converting a string to a color array
	
	    if (typeof value === 'string') {
	      var colorArray = color.parse(value);
	
	      if (colorArray) {
	        value = colorArray;
	        isValueColor = true;
	      } else {
	        isValueString = true;
	      }
	    }
	
	    kfValues.push(value);
	  }
	
	  if (!forceAnimate && isAllValueEqual) {
	    return;
	  }
	
	  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value
	
	  for (var i = 0; i < trackLen - 1; i++) {
	    if (isValueArray) {
	      fillArr(kfValues[i], lastValue, arrDim);
	    } else {
	      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
	        kfValues[i] = lastValue;
	      }
	    }
	  }
	
	  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
	  // animation playback is sequency
	
	  var lastFrame = 0;
	  var lastFramePercent = 0;
	  var start;
	  var w;
	  var p0;
	  var p1;
	  var p2;
	  var p3;
	
	  if (isValueColor) {
	    var rgba = [0, 0, 0, 0];
	  }
	
	  var onframe = function (target, percent) {
	    // Find the range keyframes
	    // kf1-----kf2---------current--------kf3
	    // find kf2 and kf3 and do interpolation
	    var frame; // In the easing function like elasticOut, percent may less than 0
	
	    if (percent < 0) {
	      frame = 0;
	    } else if (percent < lastFramePercent) {
	      // Start from next key
	      // PENDING start from lastFrame ?
	      start = Math.min(lastFrame + 1, trackLen - 1);
	
	      for (frame = start; frame >= 0; frame--) {
	        if (kfPercents[frame] <= percent) {
	          break;
	        }
	      } // PENDING really need to do this ?
	
	
	      frame = Math.min(frame, trackLen - 2);
	    } else {
	      for (frame = lastFrame; frame < trackLen; frame++) {
	        if (kfPercents[frame] > percent) {
	          break;
	        }
	      }
	
	      frame = Math.min(frame - 1, trackLen - 2);
	    }
	
	    lastFrame = frame;
	    lastFramePercent = percent;
	    var range = kfPercents[frame + 1] - kfPercents[frame];
	
	    if (range === 0) {
	      return;
	    } else {
	      w = (percent - kfPercents[frame]) / range;
	    }
	
	    if (useSpline) {
	      p1 = kfValues[frame];
	      p0 = kfValues[frame === 0 ? frame : frame - 1];
	      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
	      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];
	
	      if (isValueArray) {
	        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(p1, p2, w);
	        } else {
	          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
	        }
	
	        setter(target, propName, value);
	      }
	    } else {
	      if (isValueArray) {
	        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
	        } else {
	          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
	        }
	
	        setter(target, propName, value);
	      }
	    }
	  };
	
	  var clip = new Clip({
	    target: animator._target,
	    life: trackMaxTime,
	    loop: animator._loop,
	    delay: animator._delay,
	    onframe: onframe,
	    ondestroy: oneTrackDone
	  });
	
	  if (easing && easing !== 'spline') {
	    clip.easing = easing;
	  }
	
	  return clip;
	}
	/**
	 * @alias module:zrender/animation/Animator
	 * @constructor
	 * @param {Object} target
	 * @param {boolean} loop
	 * @param {Function} getter
	 * @param {Function} setter
	 */
	
	
	var Animator = function (target, loop, getter, setter) {
	  this._tracks = {};
	  this._target = target;
	  this._loop = loop || false;
	  this._getter = getter || defaultGetter;
	  this._setter = setter || defaultSetter;
	  this._clipCount = 0;
	  this._delay = 0;
	  this._doneList = [];
	  this._onframeList = [];
	  this._clipList = [];
	};
	
	Animator.prototype = {
	  /**
	   * Set Animation keyframe
	   * @param  {number} time 关键帧时间，单位是ms
	   * @param  {Object} props 关键帧的属性值，key-value表示
	   * @return {module:zrender/animation/Animator}
	   */
	  when: function (time
	  /* ms */
	  , props) {
	    var tracks = this._tracks;
	
	    for (var propName in props) {
	      if (!props.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      if (!tracks[propName]) {
	        tracks[propName] = []; // Invalid value
	
	        var value = this._getter(this._target, propName);
	
	        if (value == null) {
	          // zrLog('Invalid property ' + propName);
	          continue;
	        } // If time is 0
	        //  Then props is given initialize value
	        // Else
	        //  Initialize value from current prop value
	
	
	        if (time !== 0) {
	          tracks[propName].push({
	            time: 0,
	            value: cloneValue(value)
	          });
	        }
	      }
	
	      tracks[propName].push({
	        time: time,
	        value: props[propName]
	      });
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加动画每一帧的回调函数
	   * @param  {Function} callback
	   * @return {module:zrender/animation/Animator}
	   */
	  during: function (callback) {
	    this._onframeList.push(callback);
	
	    return this;
	  },
	  pause: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].pause();
	    }
	
	    this._paused = true;
	  },
	  resume: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].resume();
	    }
	
	    this._paused = false;
	  },
	  isPaused: function () {
	    return !!this._paused;
	  },
	  _doneCallback: function () {
	    // Clear all tracks
	    this._tracks = {}; // Clear all clips
	
	    this._clipList.length = 0;
	    var doneList = this._doneList;
	    var len = doneList.length;
	
	    for (var i = 0; i < len; i++) {
	      doneList[i].call(this);
	    }
	  },
	
	  /**
	   * Start the animation
	   * @param  {string|Function} [easing]
	   *         动画缓动函数，详见{@link module:zrender/animation/easing}
	   * @param  {boolean} forceAnimate
	   * @return {module:zrender/animation/Animator}
	   */
	  start: function (easing, forceAnimate) {
	    var self = this;
	    var clipCount = 0;
	
	    var oneTrackDone = function () {
	      clipCount--;
	
	      if (!clipCount) {
	        self._doneCallback();
	      }
	    };
	
	    var lastClip;
	
	    for (var propName in this._tracks) {
	      if (!this._tracks.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);
	
	      if (clip) {
	        this._clipList.push(clip);
	
	        clipCount++; // If start after added to animation
	
	        if (this.animation) {
	          this.animation.addClip(clip);
	        }
	
	        lastClip = clip;
	      }
	    } // Add during callback on the last clip
	
	
	    if (lastClip) {
	      var oldOnFrame = lastClip.onframe;
	
	      lastClip.onframe = function (target, percent) {
	        oldOnFrame(target, percent);
	
	        for (var i = 0; i < self._onframeList.length; i++) {
	          self._onframeList[i](target, percent);
	        }
	      };
	    } // This optimization will help the case that in the upper application
	    // the view may be refreshed frequently, where animation will be
	    // called repeatly but nothing changed.
	
	
	    if (!clipCount) {
	      this._doneCallback();
	    }
	
	    return this;
	  },
	
	  /**
	   * Stop animation
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stop: function (forwardToLast) {
	    var clipList = this._clipList;
	    var animation = this.animation;
	
	    for (var i = 0; i < clipList.length; i++) {
	      var clip = clipList[i];
	
	      if (forwardToLast) {
	        // Move to last frame before stop
	        clip.onframe(this._target, 1);
	      }
	
	      animation && animation.removeClip(clip);
	    }
	
	    clipList.length = 0;
	  },
	
	  /**
	   * Set when animation delay starts
	   * @param  {number} time 单位ms
	   * @return {module:zrender/animation/Animator}
	   */
	  delay: function (time) {
	    this._delay = time;
	    return this;
	  },
	
	  /**
	   * Add callback for animation end
	   * @param  {Function} cb
	   * @return {module:zrender/animation/Animator}
	   */
	  done: function (cb) {
	    if (cb) {
	      this._doneList.push(cb);
	    }
	
	    return this;
	  },
	
	  /**
	   * @return {Array.<module:zrender/animation/Clip>}
	   */
	  getClips: function () {
	    return this._clipList;
	  }
	};
	var _default = Animator;
	module.exports = _default;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
	window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
	  setTimeout(func, 16);
	};
	
	module.exports = _default;

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	/**
	 * 线段包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  var _a = 0;
	  var _b = x0; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
	    return false;
	  }
	
	  if (x0 !== x1) {
	    _a = (y0 - y1) / (x0 - x1);
	    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
	  } else {
	    return Math.abs(x - x0) <= _l / 2;
	  }
	
	  var tmp = _a * x - y + _b;
	
	  var _s = tmp * tmp / (_a * _a + 1);
	
	  return _s <= _l / 2 * _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	var windingLine = __webpack_require__(901);
	
	var EPSILON = 1e-8;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	}
	
	function contain(points, x, y) {
	  var w = 0;
	  var p = points[0];
	
	  if (!p) {
	    return false;
	  }
	
	  for (var i = 1; i < points.length; i++) {
	    var p2 = points[i];
	    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
	    p = p2;
	  } // Close polygon
	
	
	  var p0 = points[0];
	
	  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
	    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
	  }
	
	  return w !== 0;
	}
	
	exports.contain = contain;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	var _curve = __webpack_require__(134);
	
	var quadraticProjectPoint = _curve.quadraticProjectPoint;
	
	/**
	 * 二次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
	    return false;
	  }
	
	  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	var PI2 = Math.PI * 2;
	
	function normalizeRadian(angle) {
	  angle %= PI2;
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle;
	}
	
	exports.normalizeRadian = normalizeRadian;

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	function windingLine(x0, y0, x1, y1, x, y) {
	  if (y > y0 && y > y1 || y < y0 && y < y1) {
	    return 0;
	  } // Ignore horizontal line
	
	
	  if (y1 === y0) {
	    return 0;
	  }
	
	  var dir = y1 < y0 ? 1 : -1;
	  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon
	
	  if (t === 1 || t === 0) {
	    dir = y1 < y0 ? 0.5 : -0.5;
	  }
	
	  var x_ = t * (x1 - x0) + x0; // If (x, y) on the line, considered as "contain".
	
	  return x_ === x ? Infinity : x_ > x ? dir : 0;
	}
	
	module.exports = windingLine;

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	// Simple LRU cache use doubly linked list
	// @module zrender/core/LRU
	
	/**
	 * Simple double linked list. Compared with array, it has O(1) remove operation.
	 * @constructor
	 */
	var LinkedList = function () {
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	  this.head = null;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.tail = null;
	  this._len = 0;
	};
	
	var linkedListProto = LinkedList.prototype;
	/**
	 * Insert a new value at the tail
	 * @param  {} val
	 * @return {module:zrender/core/LRU~Entry}
	 */
	
	linkedListProto.insert = function (val) {
	  var entry = new Entry(val);
	  this.insertEntry(entry);
	  return entry;
	};
	/**
	 * Insert an entry at the tail
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.insertEntry = function (entry) {
	  if (!this.head) {
	    this.head = this.tail = entry;
	  } else {
	    this.tail.next = entry;
	    entry.prev = this.tail;
	    entry.next = null;
	    this.tail = entry;
	  }
	
	  this._len++;
	};
	/**
	 * Remove entry.
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.remove = function (entry) {
	  var prev = entry.prev;
	  var next = entry.next;
	
	  if (prev) {
	    prev.next = next;
	  } else {
	    // Is head
	    this.head = next;
	  }
	
	  if (next) {
	    next.prev = prev;
	  } else {
	    // Is tail
	    this.tail = prev;
	  }
	
	  entry.next = entry.prev = null;
	  this._len--;
	};
	/**
	 * @return {number}
	 */
	
	
	linkedListProto.len = function () {
	  return this._len;
	};
	/**
	 * Clear list
	 */
	
	
	linkedListProto.clear = function () {
	  this.head = this.tail = null;
	  this._len = 0;
	};
	/**
	 * @constructor
	 * @param {} val
	 */
	
	
	var Entry = function (val) {
	  /**
	   * @type {}
	   */
	  this.value = val;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.next;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.prev;
	};
	/**
	 * LRU Cache
	 * @constructor
	 * @alias module:zrender/core/LRU
	 */
	
	
	var LRU = function (maxSize) {
	  this._list = new LinkedList();
	  this._map = {};
	  this._maxSize = maxSize || 10;
	  this._lastRemovedEntry = null;
	};
	
	var LRUProto = LRU.prototype;
	/**
	 * @param  {string} key
	 * @param  {} value
	 * @return {} Removed value
	 */
	
	LRUProto.put = function (key, value) {
	  var list = this._list;
	  var map = this._map;
	  var removed = null;
	
	  if (map[key] == null) {
	    var len = list.len(); // Reuse last removed entry
	
	    var entry = this._lastRemovedEntry;
	
	    if (len >= this._maxSize && len > 0) {
	      // Remove the least recently used
	      var leastUsedEntry = list.head;
	      list.remove(leastUsedEntry);
	      delete map[leastUsedEntry.key];
	      removed = leastUsedEntry.value;
	      this._lastRemovedEntry = leastUsedEntry;
	    }
	
	    if (entry) {
	      entry.value = value;
	    } else {
	      entry = new Entry(value);
	    }
	
	    entry.key = key;
	    list.insertEntry(entry);
	    map[key] = entry;
	  }
	
	  return removed;
	};
	/**
	 * @param  {string} key
	 * @return {}
	 */
	
	
	LRUProto.get = function (key) {
	  var entry = this._map[key];
	  var list = this._list;
	
	  if (entry != null) {
	    // Put the latest used entry in the tail
	    if (entry !== list.tail) {
	      list.remove(entry);
	      list.insertEntry(entry);
	    }
	
	    return entry.value;
	  }
	};
	/**
	 * Clear the cache
	 */
	
	
	LRUProto.clear = function () {
	  this._list.clear();
	
	  this._map = {};
	};
	
	var _default = LRU;
	module.exports = _default;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(58);
	
	var _fourPointsTransform = __webpack_require__(2068);
	
	var buildTransformer = _fourPointsTransform.buildTransformer;
	var EVENT_SAVED_PROP = '___zrEVENTSAVED';
	var _calcOut = [];
	/**
	 * Transform "local coord" from `elFrom` to `elTarget`.
	 * "local coord": the coord based on the input `el`. The origin point is at
	 *     the position of "left: 0; top: 0;" in the `el`.
	 *
	 * Support when CSS transform is used.
	 *
	 * Having the `out` (that is, `[outX, outY]`), we can create an DOM element
	 * and set the CSS style as "left: outX; top: outY;" and append it to `elTarge`
	 * to locate the element.
	 *
	 * For example, this code below positions a child of `document.body` on the event
	 * point, no matter whether `body` has `margin`/`paddin`/`transfrom`/... :
	 * ```js
	 * transformLocalCoord(out, container, document.body, event.offsetX, event.offsetY);
	 * if (!eqNaN(out[0])) {
	 *     // Then locate the tip element on the event point.
	 *     var tipEl = document.createElement('div');
	 *     tipEl.style.cssText = 'position: absolute; left:' + out[0] + ';top:' + out[1] + ';';
	 *     document.body.appendChild(tipEl);
	 * }
	 * ```
	 *
	 * Notice: In some env this method is not supported. If called, `out` will be `[NaN, NaN]`.
	 *
	 * @param {Array.<number>} out [inX: number, inY: number] The output..
	 *        If can not transform, `out` will not be modified but return `false`.
	 * @param {HTMLElement} elFrom The `[inX, inY]` is based on elFrom.
	 * @param {HTMLElement} elTarget The `out` is based on elTarget.
	 * @param {number} inX
	 * @param {number} inY
	 * @return {boolean} Whether transform successfully.
	 */
	
	function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
	  return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true) && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
	}
	/**
	 * Transform between a "viewport coord" and a "local coord".
	 * "viewport coord": the coord based on the left-top corner of the viewport
	 *     of the browser.
	 * "local coord": the coord based on the input `el`. The origin point is at
	 *     the position of "left: 0; top: 0;" in the `el`.
	 *
	 * Support the case when CSS transform is used on el.
	 *
	 * @param {Array.<number>} out [inX: number, inY: number] The output. If `inverse: false`,
	 *        it represents "local coord", otherwise "vireport coord".
	 *        If can not transform, `out` will not be modified but return `false`.
	 * @param {HTMLElement} el The "local coord" is based on the `el`, see comment above.
	 * @param {number} inX If `inverse: false`,
	 *        it represents "vireport coord", otherwise "local coord".
	 * @param {number} inY If `inverse: false`,
	 *        it represents "vireport coord", otherwise "local coord".
	 * @param {boolean} [inverse=false]
	 *        `true`: from "viewport coord" to "local coord".
	 *        `false`: from "local coord" to "viewport coord".
	 * @return {boolean} Whether transform successfully.
	 */
	
	
	function transformCoordWithViewport(out, el, inX, inY, inverse) {
	  if (el.getBoundingClientRect && env.domSupported && !isCanvasEl(el)) {
	    var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
	    var markers = prepareCoordMarkers(el, saved);
	    var transformer = preparePointerTransformer(markers, saved, inverse);
	
	    if (transformer) {
	      transformer(out, inX, inY);
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function prepareCoordMarkers(el, saved) {
	  var markers = saved.markers;
	
	  if (markers) {
	    return markers;
	  }
	
	  markers = saved.markers = [];
	  var propLR = ['left', 'right'];
	  var propTB = ['top', 'bottom'];
	
	  for (var i = 0; i < 4; i++) {
	    var marker = document.createElement('div');
	    var stl = marker.style;
	    var idxLR = i % 2;
	    var idxTB = (i >> 1) % 2;
	    stl.cssText = ['position: absolute', 'visibility: hidden', 'padding: 0', 'margin: 0', 'border-width: 0', 'user-select: none', 'width:0', 'height:0', // 'width: 5px',
	    // 'height: 5px',
	    propLR[idxLR] + ':0', propTB[idxTB] + ':0', propLR[1 - idxLR] + ':auto', propTB[1 - idxTB] + ':auto', ''].join('!important;');
	    el.appendChild(marker);
	    markers.push(marker);
	  }
	
	  return markers;
	}
	
	function preparePointerTransformer(markers, saved, inverse) {
	  var transformerName = inverse ? 'invTrans' : 'trans';
	  var transformer = saved[transformerName];
	  var oldSrcCoords = saved.srcCoords;
	  var oldCoordTheSame = true;
	  var srcCoords = [];
	  var destCoords = [];
	
	  for (var i = 0; i < 4; i++) {
	    var rect = markers[i].getBoundingClientRect();
	    var ii = 2 * i;
	    var x = rect.left;
	    var y = rect.top;
	    srcCoords.push(x, y);
	    oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
	    destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
	  } // Cache to avoid time consuming of `buildTransformer`.
	
	
	  return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? buildTransformer(destCoords, srcCoords) : buildTransformer(srcCoords, destCoords));
	}
	
	function isCanvasEl(el) {
	  return el.nodeName.toUpperCase() === 'CANVAS';
	}
	
	exports.transformLocalCoord = transformLocalCoord;
	exports.transformCoordWithViewport = transformCoordWithViewport;
	exports.isCanvasEl = isCanvasEl;

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	/**
	 * zrender: 生成唯一id
	 *
	 * @author errorrik (errorrik@gmail.com)
	 */
	var idStart = 0x0907;
	
	function _default() {
	  return idStart++;
	}
	
	module.exports = _default;

/***/ }),
/* 905 */
/***/ (function(module, exports) {

	var Pattern = function (image, repeat) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {image: ...}`, where this constructor will not be called.
	  this.image = image;
	  this.repeat = repeat; // Can be cloned
	
	  this.type = 'pattern';
	};
	
	Pattern.prototype.getCanvasPattern = function (ctx) {
	  return ctx.createPattern(this.image, this.repeat || 'repeat');
	};
	
	var _default = Pattern;
	module.exports = _default;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(58);
	
	// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
	// where exception "unexpected call to method or property access"
	// might be thrown when calling ctx.fill or ctx.stroke after a path
	// whose area size is zero is drawn and ctx.clip() is called and
	// shadowBlur is set. See #4572, #3112, #5777.
	// (e.g.,
	//  ctx.moveTo(10, 10);
	//  ctx.lineTo(20, 10);
	//  ctx.closePath();
	//  ctx.clip();
	//  ctx.shadowBlur = 10;
	//  ...
	//  ctx.fill();
	// )
	var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];
	
	function _default(orignalBrush) {
	  // version string can be: '11.0'
	  return env.browser.ie && env.browser.version >= 11 ? function () {
	    var clipPaths = this.__clipPaths;
	    var style = this.style;
	    var modified;
	
	    if (clipPaths) {
	      for (var i = 0; i < clipPaths.length; i++) {
	        var clipPath = clipPaths[i];
	        var shape = clipPath && clipPath.shape;
	        var type = clipPath && clipPath.type;
	
	        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
	          for (var j = 0; j < shadowTemp.length; j++) {
	            // It is save to put shadowTemp static, because shadowTemp
	            // will be all modified each item brush called.
	            shadowTemp[j][2] = style[shadowTemp[j][0]];
	            style[shadowTemp[j][0]] = shadowTemp[j][1];
	          }
	
	          modified = true;
	          break;
	        }
	      }
	    }
	
	    orignalBrush.apply(this, arguments);
	
	    if (modified) {
	      for (var j = 0; j < shadowTemp.length; j++) {
	        style[shadowTemp[j][0]] = shadowTemp[j][2];
	      }
	    }
	  } : orignalBrush;
	}
	
	module.exports = _default;

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	var SHADOW_PROPS = {
	  'shadowBlur': 1,
	  'shadowOffsetX': 1,
	  'shadowOffsetY': 1,
	  'textShadowBlur': 1,
	  'textShadowOffsetX': 1,
	  'textShadowOffsetY': 1,
	  'textBoxShadowBlur': 1,
	  'textBoxShadowOffsetX': 1,
	  'textBoxShadowOffsetY': 1
	};
	
	function _default(ctx, propName, value) {
	  if (SHADOW_PROPS.hasOwnProperty(propName)) {
	    return value *= ctx.dpr;
	  }
	
	  return value;
	}
	
	module.exports = _default;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var smoothSpline = __webpack_require__(2073);
	
	var smoothBezier = __webpack_require__(2072);
	
	function buildPath(ctx, shape, closePath) {
	  var points = shape.points;
	  var smooth = shape.smooth;
	
	  if (points && points.length >= 2) {
	    if (smooth && smooth !== 'spline') {
	      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
	      ctx.moveTo(points[0][0], points[0][1]);
	      var len = points.length;
	
	      for (var i = 0; i < (closePath ? len : len - 1); i++) {
	        var cp1 = controlPoints[i * 2];
	        var cp2 = controlPoints[i * 2 + 1];
	        var p = points[(i + 1) % len];
	        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
	      }
	    } else {
	      if (smooth === 'spline') {
	        points = smoothSpline(points, closePath);
	      }
	
	      ctx.moveTo(points[0][0], points[0][1]);
	
	      for (var i = 1, l = points.length; i < l; i++) {
	        ctx.lineTo(points[i][0], points[i][1]);
	      }
	    }
	
	    closePath && ctx.closePath();
	  }
	}
	
	exports.buildPath = buildPath;

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	/**
	 * @param {Object} ctx
	 * @param {Object} shape
	 * @param {number} shape.x
	 * @param {number} shape.y
	 * @param {number} shape.width
	 * @param {number} shape.height
	 * @param {number} shape.r
	 */
	function buildPath(ctx, shape) {
	  var x = shape.x;
	  var y = shape.y;
	  var width = shape.width;
	  var height = shape.height;
	  var r = shape.r;
	  var r1;
	  var r2;
	  var r3;
	  var r4; // Convert width and height to positive for better borderRadius
	
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	
	  if (typeof r === 'number') {
	    r1 = r2 = r3 = r4 = r;
	  } else if (r instanceof Array) {
	    if (r.length === 1) {
	      r1 = r2 = r3 = r4 = r[0];
	    } else if (r.length === 2) {
	      r1 = r3 = r[0];
	      r2 = r4 = r[1];
	    } else if (r.length === 3) {
	      r1 = r[0];
	      r2 = r4 = r[1];
	      r3 = r[2];
	    } else {
	      r1 = r[0];
	      r2 = r[1];
	      r3 = r[2];
	      r4 = r[3];
	    }
	  } else {
	    r1 = r2 = r3 = r4 = 0;
	  }
	
	  var total;
	
	  if (r1 + r2 > width) {
	    total = r1 + r2;
	    r1 *= width / total;
	    r2 *= width / total;
	  }
	
	  if (r3 + r4 > width) {
	    total = r3 + r4;
	    r3 *= width / total;
	    r4 *= width / total;
	  }
	
	  if (r2 + r3 > height) {
	    total = r2 + r3;
	    r2 *= height / total;
	    r3 *= height / total;
	  }
	
	  if (r1 + r4 > height) {
	    total = r1 + r4;
	    r1 *= height / total;
	    r4 *= height / total;
	  }
	
	  ctx.moveTo(x + r1, y);
	  ctx.lineTo(x + width - r2, y);
	  r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
	  ctx.lineTo(x + width, y + height - r3);
	  r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
	  ctx.lineTo(x + r4, y + height);
	  r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
	  ctx.lineTo(x, y + r1);
	  r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
	}
	
	exports.buildPath = buildPath;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	var textHelper = __webpack_require__(283);
	
	var BoundingRect = __webpack_require__(51);
	
	var _constant = __webpack_require__(282);
	
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	
	/**
	 * Mixin for drawing text in a element bounding rect
	 * @module zrender/mixin/RectText
	 */
	var tmpRect = new BoundingRect();
	
	var RectText = function () {};
	
	RectText.prototype = {
	  constructor: RectText,
	
	  /**
	   * Draw text in a rect with specified position.
	   * @param  {CanvasRenderingContext2D} ctx
	   * @param  {Object} rect Displayable rect
	   */
	  drawRectText: function (ctx, rect) {
	    var style = this.style;
	    rect = style.textRect || rect; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!textHelper.needDrawText(text, style)) {
	      return;
	    } // FIXME
	    // Do not provide prevEl to `textHelper.renderText` for ctx prop cache,
	    // but use `ctx.save()` and `ctx.restore()`. Because the cache for rect
	    // text propably break the cache for its host elements.
	
	
	    ctx.save(); // Transform rect to view space
	
	    var transform = this.transform;
	
	    if (!style.transformText) {
	      if (transform) {
	        tmpRect.copy(rect);
	        tmpRect.applyTransform(transform);
	        rect = tmpRect;
	      }
	    } else {
	      this.setTransform(ctx);
	    } // transformText and textRotation can not be used at the same time.
	
	
	    textHelper.renderText(this, ctx, text, style, rect, WILL_BE_RESTORED);
	    ctx.restore();
	  }
	};
	var _default = RectText;
	module.exports = _default;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	/**
	 * 圆形
	 * @module zrender/shape/Circle
	 */
	var _default = Path.extend({
	  type: 'circle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    // Better stroking in ShapeBundle
	    // Always do it may have performence issue ( fill may be 2x more cost)
	    if (inBundle) {
	      ctx.moveTo(shape.cx + shape.r, shape.cy);
	    } // else {
	    //     if (ctx.allocate && !ctx.data.length) {
	    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
	    //     }
	    // }
	    // Better stroking in ShapeBundle
	    // ctx.moveTo(shape.cx + shape.r, shape.cy);
	
	
	    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	var _subPixelOptimize = __webpack_require__(451);
	
	var subPixelOptimizeLine = _subPixelOptimize.subPixelOptimizeLine;
	
	/**
	 * 直线
	 * @module zrender/graphic/shape/Line
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'line',
	  shape: {
	    // Start point
	    x1: 0,
	    y1: 0,
	    // End point
	    x2: 0,
	    y2: 0,
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1;
	    var y1;
	    var x2;
	    var y2;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeLine(subPixelOptimizeOutputShape, shape, this.style);
	      x1 = subPixelOptimizeOutputShape.x1;
	      y1 = subPixelOptimizeOutputShape.y1;
	      x2 = subPixelOptimizeOutputShape.x2;
	      y2 = subPixelOptimizeOutputShape.y2;
	    } else {
	      x1 = shape.x1;
	      y1 = shape.y1;
	      x2 = shape.x2;
	      y2 = shape.y2;
	    }
	
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (percent < 1) {
	      x2 = x1 * (1 - percent) + x2 * percent;
	      y2 = y1 * (1 - percent) + y2 * percent;
	    }
	
	    ctx.lineTo(x2, y2);
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} percent
	   * @return {Array.<number>}
	   */
	  pointAt: function (p) {
	    var shape = this.shape;
	    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	var polyHelper = __webpack_require__(908);
	
	/**
	 * 多边形
	 * @module zrender/shape/Polygon
	 */
	var _default = Path.extend({
	  type: 'polygon',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	var polyHelper = __webpack_require__(908);
	
	/**
	 * @module zrender/graphic/shape/Polyline
	 */
	var _default = Path.extend({
	  type: 'polyline',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, false);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	var Group = __webpack_require__(146);
	
	var ZImage = __webpack_require__(181);
	
	var Text = __webpack_require__(147);
	
	var Circle = __webpack_require__(911);
	
	var Rect = __webpack_require__(452);
	
	var Ellipse = __webpack_require__(2076);
	
	var Line = __webpack_require__(912);
	
	var Path = __webpack_require__(55);
	
	var Polygon = __webpack_require__(913);
	
	var Polyline = __webpack_require__(914);
	
	var LinearGradient = __webpack_require__(448);
	
	var Style = __webpack_require__(449);
	
	var matrix = __webpack_require__(75);
	
	var _path = __webpack_require__(916);
	
	var createFromString = _path.createFromString;
	
	var _util = __webpack_require__(2);
	
	var isString = _util.isString;
	var extend = _util.extend;
	var defaults = _util.defaults;
	var trim = _util.trim;
	var each = _util.each;
	// import RadialGradient from '../graphic/RadialGradient';
	// import Pattern from '../graphic/Pattern';
	// import * as vector from '../core/vector';
	// Most of the values can be separated by comma and/or white space.
	var DILIMITER_REG = /[\s,]+/;
	/**
	 * For big svg string, this method might be time consuming.
	 *
	 * @param {string} svg xml string
	 * @return {Object} xml root.
	 */
	
	function parseXML(svg) {
	  if (isString(svg)) {
	    var parser = new DOMParser();
	    svg = parser.parseFromString(svg, 'text/xml');
	  } // Document node. If using $.get, doc node may be input.
	
	
	  if (svg.nodeType === 9) {
	    svg = svg.firstChild;
	  } // nodeName of <!DOCTYPE svg> is also 'svg'.
	
	
	  while (svg.nodeName.toLowerCase() !== 'svg' || svg.nodeType !== 1) {
	    svg = svg.nextSibling;
	  }
	
	  return svg;
	}
	
	function SVGParser() {
	  this._defs = {};
	  this._root = null;
	  this._isDefine = false;
	  this._isText = false;
	}
	
	SVGParser.prototype.parse = function (xml, opt) {
	  opt = opt || {};
	  var svg = parseXML(xml);
	
	  if (!svg) {
	    throw new Error('Illegal svg');
	  }
	
	  var root = new Group();
	  this._root = root; // parse view port
	
	  var viewBox = svg.getAttribute('viewBox') || ''; // If width/height not specified, means "100%" of `opt.width/height`.
	  // TODO: Other percent value not supported yet.
	
	  var width = parseFloat(svg.getAttribute('width') || opt.width);
	  var height = parseFloat(svg.getAttribute('height') || opt.height); // If width/height not specified, set as null for output.
	
	  isNaN(width) && (width = null);
	  isNaN(height) && (height = null); // Apply inline style on svg element.
	
	  parseAttributes(svg, root, null, true);
	  var child = svg.firstChild;
	
	  while (child) {
	    this._parseNode(child, root);
	
	    child = child.nextSibling;
	  }
	
	  var viewBoxRect;
	  var viewBoxTransform;
	
	  if (viewBox) {
	    var viewBoxArr = trim(viewBox).split(DILIMITER_REG); // Some invalid case like viewBox: 'none'.
	
	    if (viewBoxArr.length >= 4) {
	      viewBoxRect = {
	        x: parseFloat(viewBoxArr[0] || 0),
	        y: parseFloat(viewBoxArr[1] || 0),
	        width: parseFloat(viewBoxArr[2]),
	        height: parseFloat(viewBoxArr[3])
	      };
	    }
	  }
	
	  if (viewBoxRect && width != null && height != null) {
	    viewBoxTransform = makeViewBoxTransform(viewBoxRect, width, height);
	
	    if (!opt.ignoreViewBox) {
	      // If set transform on the output group, it probably bring trouble when
	      // some users only intend to show the clipped content inside the viewBox,
	      // but not intend to transform the output group. So we keep the output
	      // group no transform. If the user intend to use the viewBox as a
	      // camera, just set `opt.ignoreViewBox` as `true` and set transfrom
	      // manually according to the viewBox info in the output of this method.
	      var elRoot = root;
	      root = new Group();
	      root.add(elRoot);
	      elRoot.scale = viewBoxTransform.scale.slice();
	      elRoot.position = viewBoxTransform.position.slice();
	    }
	  } // Some shapes might be overflow the viewport, which should be
	  // clipped despite whether the viewBox is used, as the SVG does.
	
	
	  if (!opt.ignoreRootClip && width != null && height != null) {
	    root.setClipPath(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      }
	    }));
	  } // Set width/height on group just for output the viewport size.
	
	
	  return {
	    root: root,
	    width: width,
	    height: height,
	    viewBoxRect: viewBoxRect,
	    viewBoxTransform: viewBoxTransform
	  };
	};
	
	SVGParser.prototype._parseNode = function (xmlNode, parentGroup) {
	  var nodeName = xmlNode.nodeName.toLowerCase(); // TODO
	  // support <style>...</style> in svg, where nodeName is 'style',
	  // CSS classes is defined globally wherever the style tags are declared.
	
	  if (nodeName === 'defs') {
	    // define flag
	    this._isDefine = true;
	  } else if (nodeName === 'text') {
	    this._isText = true;
	  }
	
	  var el;
	
	  if (this._isDefine) {
	    var parser = defineParsers[nodeName];
	
	    if (parser) {
	      var def = parser.call(this, xmlNode);
	      var id = xmlNode.getAttribute('id');
	
	      if (id) {
	        this._defs[id] = def;
	      }
	    }
	  } else {
	    var parser = nodeParsers[nodeName];
	
	    if (parser) {
	      el = parser.call(this, xmlNode, parentGroup);
	      parentGroup.add(el);
	    }
	  }
	
	  var child = xmlNode.firstChild;
	
	  while (child) {
	    if (child.nodeType === 1) {
	      this._parseNode(child, el);
	    } // Is text
	
	
	    if (child.nodeType === 3 && this._isText) {
	      this._parseText(child, el);
	    }
	
	    child = child.nextSibling;
	  } // Quit define
	
	
	  if (nodeName === 'defs') {
	    this._isDefine = false;
	  } else if (nodeName === 'text') {
	    this._isText = false;
	  }
	};
	
	SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
	  if (xmlNode.nodeType === 1) {
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX += parseFloat(dx);
	    this._textY += parseFloat(dy);
	  }
	
	  var text = new Text({
	    style: {
	      text: xmlNode.textContent,
	      transformText: true
	    },
	    position: [this._textX || 0, this._textY || 0]
	  });
	  inheritStyle(parentGroup, text);
	  parseAttributes(xmlNode, text, this._defs);
	  var fontSize = text.style.fontSize;
	
	  if (fontSize && fontSize < 9) {
	    // PENDING
	    text.style.fontSize = 9;
	    text.scale = text.scale || [1, 1];
	    text.scale[0] *= fontSize / 9;
	    text.scale[1] *= fontSize / 9;
	  }
	
	  var rect = text.getBoundingRect();
	  this._textX += rect.width;
	  parentGroup.add(text);
	  return text;
	};
	
	var nodeParsers = {
	  'g': function (xmlNode, parentGroup) {
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'rect': function (xmlNode, parentGroup) {
	    var rect = new Rect();
	    inheritStyle(parentGroup, rect);
	    parseAttributes(xmlNode, rect, this._defs);
	    rect.setShape({
	      x: parseFloat(xmlNode.getAttribute('x') || 0),
	      y: parseFloat(xmlNode.getAttribute('y') || 0),
	      width: parseFloat(xmlNode.getAttribute('width') || 0),
	      height: parseFloat(xmlNode.getAttribute('height') || 0)
	    }); // console.log(xmlNode.getAttribute('transform'));
	    // console.log(rect.transform);
	
	    return rect;
	  },
	  'circle': function (xmlNode, parentGroup) {
	    var circle = new Circle();
	    inheritStyle(parentGroup, circle);
	    parseAttributes(xmlNode, circle, this._defs);
	    circle.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      r: parseFloat(xmlNode.getAttribute('r') || 0)
	    });
	    return circle;
	  },
	  'line': function (xmlNode, parentGroup) {
	    var line = new Line();
	    inheritStyle(parentGroup, line);
	    parseAttributes(xmlNode, line, this._defs);
	    line.setShape({
	      x1: parseFloat(xmlNode.getAttribute('x1') || 0),
	      y1: parseFloat(xmlNode.getAttribute('y1') || 0),
	      x2: parseFloat(xmlNode.getAttribute('x2') || 0),
	      y2: parseFloat(xmlNode.getAttribute('y2') || 0)
	    });
	    return line;
	  },
	  'ellipse': function (xmlNode, parentGroup) {
	    var ellipse = new Ellipse();
	    inheritStyle(parentGroup, ellipse);
	    parseAttributes(xmlNode, ellipse, this._defs);
	    ellipse.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      rx: parseFloat(xmlNode.getAttribute('rx') || 0),
	      ry: parseFloat(xmlNode.getAttribute('ry') || 0)
	    });
	    return ellipse;
	  },
	  'polygon': function (xmlNode, parentGroup) {
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polygon = new Polygon({
	      shape: {
	        points: points || []
	      }
	    });
	    inheritStyle(parentGroup, polygon);
	    parseAttributes(xmlNode, polygon, this._defs);
	    return polygon;
	  },
	  'polyline': function (xmlNode, parentGroup) {
	    var path = new Path();
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polyline = new Polyline({
	      shape: {
	        points: points || []
	      }
	    });
	    return polyline;
	  },
	  'image': function (xmlNode, parentGroup) {
	    var img = new ZImage();
	    inheritStyle(parentGroup, img);
	    parseAttributes(xmlNode, img, this._defs);
	    img.setStyle({
	      image: xmlNode.getAttribute('xlink:href'),
	      x: xmlNode.getAttribute('x'),
	      y: xmlNode.getAttribute('y'),
	      width: xmlNode.getAttribute('width'),
	      height: xmlNode.getAttribute('height')
	    });
	    return img;
	  },
	  'text': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x') || 0;
	    var y = xmlNode.getAttribute('y') || 0;
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX = parseFloat(x) + parseFloat(dx);
	    this._textY = parseFloat(y) + parseFloat(dy);
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'tspan': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x');
	    var y = xmlNode.getAttribute('y');
	
	    if (x != null) {
	      // new offset x
	      this._textX = parseFloat(x);
	    }
	
	    if (y != null) {
	      // new offset y
	      this._textY = parseFloat(y);
	    }
	
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    this._textX += dx;
	    this._textY += dy;
	    return g;
	  },
	  'path': function (xmlNode, parentGroup) {
	    // TODO svg fill rule
	    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-rule
	    // path.style.globalCompositeOperation = 'xor';
	    var d = xmlNode.getAttribute('d') || ''; // Performance sensitive.
	
	    var path = createFromString(d);
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    return path;
	  }
	};
	var defineParsers = {
	  'lineargradient': function (xmlNode) {
	    var x1 = parseInt(xmlNode.getAttribute('x1') || 0, 10);
	    var y1 = parseInt(xmlNode.getAttribute('y1') || 0, 10);
	    var x2 = parseInt(xmlNode.getAttribute('x2') || 10, 10);
	    var y2 = parseInt(xmlNode.getAttribute('y2') || 0, 10);
	    var gradient = new LinearGradient(x1, y1, x2, y2);
	
	    _parseGradientColorStops(xmlNode, gradient);
	
	    return gradient;
	  },
	  'radialgradient': function (xmlNode) {}
	};
	
	function _parseGradientColorStops(xmlNode, gradient) {
	  var stop = xmlNode.firstChild;
	
	  while (stop) {
	    if (stop.nodeType === 1) {
	      var offset = stop.getAttribute('offset');
	
	      if (offset.indexOf('%') > 0) {
	        // percentage
	        offset = parseInt(offset, 10) / 100;
	      } else if (offset) {
	        // number from 0 to 1
	        offset = parseFloat(offset);
	      } else {
	        offset = 0;
	      }
	
	      var stopColor = stop.getAttribute('stop-color') || '#000000';
	      gradient.addColorStop(offset, stopColor);
	    }
	
	    stop = stop.nextSibling;
	  }
	}
	
	function inheritStyle(parent, child) {
	  if (parent && parent.__inheritedStyle) {
	    if (!child.__inheritedStyle) {
	      child.__inheritedStyle = {};
	    }
	
	    defaults(child.__inheritedStyle, parent.__inheritedStyle);
	  }
	}
	
	function parsePoints(pointsString) {
	  var list = trim(pointsString).split(DILIMITER_REG);
	  var points = [];
	
	  for (var i = 0; i < list.length; i += 2) {
	    var x = parseFloat(list[i]);
	    var y = parseFloat(list[i + 1]);
	    points.push([x, y]);
	  }
	
	  return points;
	}
	
	var attributesMap = {
	  'fill': 'fill',
	  'stroke': 'stroke',
	  'stroke-width': 'lineWidth',
	  'opacity': 'opacity',
	  'fill-opacity': 'fillOpacity',
	  'stroke-opacity': 'strokeOpacity',
	  'stroke-dasharray': 'lineDash',
	  'stroke-dashoffset': 'lineDashOffset',
	  'stroke-linecap': 'lineCap',
	  'stroke-linejoin': 'lineJoin',
	  'stroke-miterlimit': 'miterLimit',
	  'font-family': 'fontFamily',
	  'font-size': 'fontSize',
	  'font-style': 'fontStyle',
	  'font-weight': 'fontWeight',
	  'text-align': 'textAlign',
	  'alignment-baseline': 'textBaseline'
	};
	
	function parseAttributes(xmlNode, el, defs, onlyInlineStyle) {
	  var zrStyle = el.__inheritedStyle || {};
	  var isTextEl = el.type === 'text'; // TODO Shadow
	
	  if (xmlNode.nodeType === 1) {
	    parseTransformAttribute(xmlNode, el);
	    extend(zrStyle, parseStyleAttribute(xmlNode));
	
	    if (!onlyInlineStyle) {
	      for (var svgAttrName in attributesMap) {
	        if (attributesMap.hasOwnProperty(svgAttrName)) {
	          var attrValue = xmlNode.getAttribute(svgAttrName);
	
	          if (attrValue != null) {
	            zrStyle[attributesMap[svgAttrName]] = attrValue;
	          }
	        }
	      }
	    }
	  }
	
	  var elFillProp = isTextEl ? 'textFill' : 'fill';
	  var elStrokeProp = isTextEl ? 'textStroke' : 'stroke';
	  el.style = el.style || new Style();
	  var elStyle = el.style;
	  zrStyle.fill != null && elStyle.set(elFillProp, getPaint(zrStyle.fill, defs));
	  zrStyle.stroke != null && elStyle.set(elStrokeProp, getPaint(zrStyle.stroke, defs));
	  each(['lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'], function (propName) {
	    var elPropName = propName === 'lineWidth' && isTextEl ? 'textStrokeWidth' : propName;
	    zrStyle[propName] != null && elStyle.set(elPropName, parseFloat(zrStyle[propName]));
	  });
	
	  if (!zrStyle.textBaseline || zrStyle.textBaseline === 'auto') {
	    zrStyle.textBaseline = 'alphabetic';
	  }
	
	  if (zrStyle.textBaseline === 'alphabetic') {
	    zrStyle.textBaseline = 'bottom';
	  }
	
	  if (zrStyle.textAlign === 'start') {
	    zrStyle.textAlign = 'left';
	  }
	
	  if (zrStyle.textAlign === 'end') {
	    zrStyle.textAlign = 'right';
	  }
	
	  each(['lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign', 'textBaseline'], function (propName) {
	    zrStyle[propName] != null && elStyle.set(propName, zrStyle[propName]);
	  });
	
	  if (zrStyle.lineDash) {
	    el.style.lineDash = trim(zrStyle.lineDash).split(DILIMITER_REG);
	  }
	
	  if (elStyle[elStrokeProp] && elStyle[elStrokeProp] !== 'none') {
	    // enable stroke
	    el[elStrokeProp] = true;
	  }
	
	  el.__inheritedStyle = zrStyle;
	}
	
	var urlRegex = /url\(\s*#(.*?)\)/;
	
	function getPaint(str, defs) {
	  // if (str === 'none') {
	  //     return;
	  // }
	  var urlMatch = defs && str && str.match(urlRegex);
	
	  if (urlMatch) {
	    var url = trim(urlMatch[1]);
	    var def = defs[url];
	    return def;
	  }
	
	  return str;
	}
	
	var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;
	
	function parseTransformAttribute(xmlNode, node) {
	  var transform = xmlNode.getAttribute('transform');
	
	  if (transform) {
	    transform = transform.replace(/,/g, ' ');
	    var m = null;
	    var transformOps = [];
	    transform.replace(transformRegex, function (str, type, value) {
	      transformOps.push(type, value);
	    });
	
	    for (var i = transformOps.length - 1; i > 0; i -= 2) {
	      var value = transformOps[i];
	      var type = transformOps[i - 1];
	      m = m || matrix.create();
	
	      switch (type) {
	        case 'translate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.translate(m, m, [parseFloat(value[0]), parseFloat(value[1] || 0)]);
	          break;
	
	        case 'scale':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.scale(m, m, [parseFloat(value[0]), parseFloat(value[1] || value[0])]);
	          break;
	
	        case 'rotate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.rotate(m, m, parseFloat(value[0]));
	          break;
	
	        case 'skew':
	          value = trim(value).split(DILIMITER_REG);
	          console.warn('Skew transform is not supported yet');
	          break;
	
	        case 'matrix':
	          var value = trim(value).split(DILIMITER_REG);
	          m[0] = parseFloat(value[0]);
	          m[1] = parseFloat(value[1]);
	          m[2] = parseFloat(value[2]);
	          m[3] = parseFloat(value[3]);
	          m[4] = parseFloat(value[4]);
	          m[5] = parseFloat(value[5]);
	          break;
	      }
	    }
	
	    node.setLocalTransform(m);
	  }
	} // Value may contain space.
	
	
	var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
	
	function parseStyleAttribute(xmlNode) {
	  var style = xmlNode.getAttribute('style');
	  var result = {};
	
	  if (!style) {
	    return result;
	  }
	
	  var styleList = {};
	  styleRegex.lastIndex = 0;
	  var styleRegResult;
	
	  while ((styleRegResult = styleRegex.exec(style)) != null) {
	    styleList[styleRegResult[1]] = styleRegResult[2];
	  }
	
	  for (var svgAttrName in attributesMap) {
	    if (attributesMap.hasOwnProperty(svgAttrName) && styleList[svgAttrName] != null) {
	      result[attributesMap[svgAttrName]] = styleList[svgAttrName];
	    }
	  }
	
	  return result;
	}
	/**
	 * @param {Array.<number>} viewBoxRect
	 * @param {number} width
	 * @param {number} height
	 * @return {Object} {scale, position}
	 */
	
	
	function makeViewBoxTransform(viewBoxRect, width, height) {
	  var scaleX = width / viewBoxRect.width;
	  var scaleY = height / viewBoxRect.height;
	  var scale = Math.min(scaleX, scaleY); // preserveAspectRatio 'xMidYMid'
	
	  var viewBoxScale = [scale, scale];
	  var viewBoxPosition = [-(viewBoxRect.x + viewBoxRect.width / 2) * scale + width / 2, -(viewBoxRect.y + viewBoxRect.height / 2) * scale + height / 2];
	  return {
	    scale: viewBoxScale,
	    position: viewBoxPosition
	  };
	}
	/**
	 * @param {string|XMLElement} xml
	 * @param {Object} [opt]
	 * @param {number} [opt.width] Default width if svg width not specified or is a percent value.
	 * @param {number} [opt.height] Default height if svg height not specified or is a percent value.
	 * @param {boolean} [opt.ignoreViewBox]
	 * @param {boolean} [opt.ignoreRootClip]
	 * @return {Object} result:
	 * {
	 *     root: Group, The root of the the result tree of zrender shapes,
	 *     width: number, the viewport width of the SVG,
	 *     height: number, the viewport height of the SVG,
	 *     viewBoxRect: {x, y, width, height}, the declared viewBox rect of the SVG, if exists,
	 *     viewBoxTransform: the {scale, position} calculated by viewBox and viewport, is exists.
	 * }
	 */
	
	
	function parseSVG(xml, opt) {
	  var parser = new SVGParser();
	  return parser.parse(xml, opt);
	}
	
	exports.parseXML = parseXML;
	exports.makeViewBoxTransform = makeViewBoxTransform;
	exports.parseSVG = parseSVG;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	var PathProxy = __webpack_require__(180);
	
	var transformPath = __webpack_require__(2086);
	
	// command chars
	// var cc = [
	//     'm', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z',
	//     'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'
	// ];
	var mathSqrt = Math.sqrt;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	
	var vMag = function (v) {
	  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	};
	
	var vRatio = function (u, v) {
	  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	};
	
	var vAngle = function (u, v) {
	  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
	};
	
	function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
	  var psi = psiDeg * (PI / 180.0);
	  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
	  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
	  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
	
	  if (lambda > 1) {
	    rx *= mathSqrt(lambda);
	    ry *= mathSqrt(lambda);
	  }
	
	  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
	  var cxp = f * rx * yp / ry;
	  var cyp = f * -ry * xp / rx;
	  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
	  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
	  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	  var dTheta = vAngle(u, v);
	
	  if (vRatio(u, v) <= -1) {
	    dTheta = PI;
	  }
	
	  if (vRatio(u, v) >= 1) {
	    dTheta = 0;
	  }
	
	  if (fs === 0 && dTheta > 0) {
	    dTheta = dTheta - 2 * PI;
	  }
	
	  if (fs === 1 && dTheta < 0) {
	    dTheta = dTheta + 2 * PI;
	  }
	
	  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
	}
	
	var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig; // Consider case:
	// (1) delimiter can be comma or space, where continuous commas
	// or spaces should be seen as one comma.
	// (2) value can be like:
	// '2e-4', 'l.5.9' (ignore 0), 'M-10-10', 'l-2.43e-1,34.9983',
	// 'l-.5E1,54', '121-23-44-11' (no delimiter)
	
	var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g; // var valueSplitReg = /[\s,]+/;
	
	function createPathProxyFromString(data) {
	  if (!data) {
	    return new PathProxy();
	  } // var data = data.replace(/-/g, ' -')
	  //     .replace(/  /g, ' ')
	  //     .replace(/ /g, ',')
	  //     .replace(/,,/g, ',');
	  // var n;
	  // create pipes so that we can split the data
	  // for (n = 0; n < cc.length; n++) {
	  //     cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
	  // }
	  // data = data.replace(/-/g, ',-');
	  // create array
	  // var arr = cs.split('|');
	  // init context point
	
	
	  var cpx = 0;
	  var cpy = 0;
	  var subpathX = cpx;
	  var subpathY = cpy;
	  var prevCmd;
	  var path = new PathProxy();
	  var CMD = PathProxy.CMD; // commandReg.lastIndex = 0;
	  // var cmdResult;
	  // while ((cmdResult = commandReg.exec(data)) != null) {
	  //     var cmdStr = cmdResult[1];
	  //     var cmdContent = cmdResult[2];
	
	  var cmdList = data.match(commandReg);
	
	  for (var l = 0; l < cmdList.length; l++) {
	    var cmdText = cmdList[l];
	    var cmdStr = cmdText.charAt(0);
	    var cmd; // String#split is faster a little bit than String#replace or RegExp#exec.
	    // var p = cmdContent.split(valueSplitReg);
	    // var pLen = 0;
	    // for (var i = 0; i < p.length; i++) {
	    //     // '' and other invalid str => NaN
	    //     var val = parseFloat(p[i]);
	    //     !isNaN(val) && (p[pLen++] = val);
	    // }
	
	    var p = cmdText.match(numberReg) || [];
	    var pLen = p.length;
	
	    for (var i = 0; i < pLen; i++) {
	      p[i] = parseFloat(p[i]);
	    }
	
	    var off = 0;
	
	    while (off < pLen) {
	      var ctlPtx;
	      var ctlPty;
	      var rx;
	      var ry;
	      var psi;
	      var fa;
	      var fs;
	      var x1 = cpx;
	      var y1 = cpy; // convert l, H, h, V, and v to L
	
	      switch (cmdStr) {
	        case 'l':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'L':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'm':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'l';
	          break;
	
	        case 'M':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'L';
	          break;
	
	        case 'h':
	          cpx += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'H':
	          cpx = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'v':
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'V':
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'C':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
	          cpx = p[off - 2];
	          cpy = p[off - 1];
	          break;
	
	        case 'c':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
	          cpx += p[off - 2];
	          cpy += p[off - 1];
	          break;
	
	        case 'S':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 's':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = cpx + p[off++];
	          y1 = cpy + p[off++];
	          cpx += p[off++];
	          cpy += p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 'Q':
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'q':
	          x1 = p[off++] + cpx;
	          y1 = p[off++] + cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'T':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 't':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 'A':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	
	        case 'a':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	      }
	    }
	
	    if (cmdStr === 'z' || cmdStr === 'Z') {
	      cmd = CMD.Z;
	      path.addData(cmd); // z may be in the middle of the path.
	
	      cpx = subpathX;
	      cpy = subpathY;
	    }
	
	    prevCmd = cmd;
	  }
	
	  path.toStatic();
	  return path;
	} // TODO Optimize double memory cost problem
	
	
	function createPathOptions(str, opts) {
	  var pathProxy = createPathProxyFromString(str);
	  opts = opts || {};
	
	  opts.buildPath = function (path) {
	    if (path.setData) {
	      path.setData(pathProxy.data); // Svg and vml renderer don't have context
	
	      var ctx = path.getContext();
	
	      if (ctx) {
	        path.rebuildPath(ctx);
	      }
	    } else {
	      var ctx = path;
	      pathProxy.rebuildPath(ctx);
	    }
	  };
	
	  opts.applyTransform = function (m) {
	    transformPath(pathProxy, m);
	    this.dirty(true);
	  };
	
	  return opts;
	}
	/**
	 * Create a Path object from path string data
	 * http://www.w3.org/TR/SVG/paths.html#PathData
	 * @param  {Object} opts Other options
	 */
	
	
	function createFromString(str, opts) {
	  return new Path(createPathOptions(str, opts));
	}
	/**
	 * Create a Path class from path string data
	 * @param  {string} str
	 * @param  {Object} opts Other options
	 */
	
	
	function extendFromString(str, opts) {
	  return Path.extend(createPathOptions(str, opts));
	}
	/**
	 * Merge multiple paths
	 */
	// TODO Apply transform
	// TODO stroke dash
	// TODO Optimize double memory cost problem
	
	
	function mergePath(pathEls, opts) {
	  var pathList = [];
	  var len = pathEls.length;
	
	  for (var i = 0; i < len; i++) {
	    var pathEl = pathEls[i];
	
	    if (!pathEl.path) {
	      pathEl.createPathProxy();
	    }
	
	    if (pathEl.__dirtyPath) {
	      pathEl.buildPath(pathEl.path, pathEl.shape, true);
	    }
	
	    pathList.push(pathEl.path);
	  }
	
	  var pathBundle = new Path(opts); // Need path proxy.
	
	  pathBundle.createPathProxy();
	
	  pathBundle.buildPath = function (path) {
	    path.appendPath(pathList); // Svg and vml renderer don't have context
	
	    var ctx = path.getContext();
	
	    if (ctx) {
	      path.rebuildPath(ctx);
	    }
	  };
	
	  return pathBundle;
	}
	
	exports.createFromString = createFromString;
	exports.extendFromString = extendFromString;
	exports.mergePath = mergePath;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(58);
	
	var urn = 'urn:schemas-microsoft-com:vml';
	var win = typeof window === 'undefined' ? null : window;
	var vmlInited = false;
	var doc = win && win.document;
	
	function createNode(tagName) {
	  return doCreateNode(tagName);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	var doCreateNode;
	
	if (doc && !env.canvasSupported) {
	  try {
	    !doc.namespaces.zrvml && doc.namespaces.add('zrvml', urn);
	
	    doCreateNode = function (tagName) {
	      return doc.createElement('<zrvml:' + tagName + ' class="zrvml">');
	    };
	  } catch (e) {
	    doCreateNode = function (tagName) {
	      return doc.createElement('<' + tagName + ' xmlns="' + urn + '" class="zrvml">');
	    };
	  }
	} // From raphael
	
	
	function initVML() {
	  if (vmlInited || !doc) {
	    return;
	  }
	
	  vmlInited = true;
	  var styleSheets = doc.styleSheets;
	
	  if (styleSheets.length < 31) {
	    doc.createStyleSheet().addRule('.zrvml', 'behavior:url(#default#VML)');
	  } else {
	    // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
	    styleSheets[0].addRule('.zrvml', 'behavior:url(#default#VML)');
	  }
	}
	
	exports.doc = doc;
	exports.createNode = createNode;
	exports.initVML = initVML;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1030);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1034);

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1047);

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1072);

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(120);

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(144);

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(337);

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(366);

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(371);

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(44);

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(68);

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(986);

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEFAULT_SIZE = 24;
	
	exports.default = function (_ref) {
	  var _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
	      style: _extends({ fill: fill, width: width, height: height }, style)
	    }, props),
	    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	  );
	};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEFAULT_SIZE = 24;
	
	exports.default = function (_ref) {
	  var _ref$fill = _ref.fill,
	      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
	      style: _extends({ fill: fill, width: width, height: height }, style)
	    }, props),
	    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
	  );
	};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ScriptLoader = void 0;
	var Utils_1 = __webpack_require__(511);
	var createState = function () { return ({
	    listeners: [],
	    scriptId: (0, Utils_1.uuid)('tiny-script'),
	    scriptLoading: false,
	    scriptLoaded: false
	}); };
	var CreateScriptLoader = function () {
	    var state = createState();
	    var injectScriptTag = function (scriptId, doc, url, async, defer, callback) {
	        var scriptTag = doc.createElement('script');
	        scriptTag.referrerPolicy = 'origin';
	        scriptTag.type = 'application/javascript';
	        scriptTag.id = scriptId;
	        scriptTag.src = url;
	        scriptTag.async = async;
	        scriptTag.defer = defer;
	        var handler = function () {
	            scriptTag.removeEventListener('load', handler);
	            callback();
	        };
	        scriptTag.addEventListener('load', handler);
	        if (doc.head) {
	            doc.head.appendChild(scriptTag);
	        }
	    };
	    var load = function (doc, url, async, defer, delay, callback) {
	        var scriptTagInjection = function () { return injectScriptTag(state.scriptId, doc, url, async, defer, function () {
	            state.listeners.forEach(function (fn) { return fn(); });
	            state.scriptLoaded = true;
	        }); };
	        if (state.scriptLoaded) {
	            callback();
	        }
	        else {
	            state.listeners.push(callback);
	            if (!state.scriptLoading) {
	                state.scriptLoading = true;
	                if (delay > 0) {
	                    setTimeout(scriptTagInjection, delay);
	                }
	                else {
	                    scriptTagInjection();
	                }
	            }
	        }
	    };
	    // Only to be used by tests.
	    var reinitialize = function () {
	        state = createState();
	    };
	    return {
	        load: load,
	        reinitialize: reinitialize
	    };
	};
	var ScriptLoader = CreateScriptLoader();
	exports.ScriptLoader = ScriptLoader;


/***/ }),
/* 933 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getTinymce = void 0;
	var getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
	var getTinymce = function () {
	    var global = getGlobal();
	    return global && global.tinymce ? global.tinymce : null;
	};
	exports.getTinymce = getTinymce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Editor = void 0;
	var React = __webpack_require__(1);
	var ScriptLoader_1 = __webpack_require__(932);
	var TinyMCE_1 = __webpack_require__(933);
	var Utils_1 = __webpack_require__(511);
	var EditorPropTypes_1 = __webpack_require__(512);
	var changeEvents = function () { var _a, _b, _c; return ((_c = (_b = (_a = (0, TinyMCE_1.getTinymce)()) === null || _a === void 0 ? void 0 : _a.Env) === null || _b === void 0 ? void 0 : _b.browser) === null || _c === void 0 ? void 0 : _c.isIE()) ? 'change keyup compositionend setcontent' : 'change input compositionend setcontent'; };
	var beforeInputEvent = function () { return (0, Utils_1.isBeforeInputEventAvailable)() ? 'beforeinput SelectionChange' : 'SelectionChange'; };
	var Editor = /** @class */ (function (_super) {
	    __extends(Editor, _super);
	    function Editor(props) {
	        var _this = this;
	        var _a, _b, _c;
	        _this = _super.call(this, props) || this;
	        _this.rollbackTimer = undefined;
	        _this.valueCursor = undefined;
	        _this.rollbackChange = function () {
	            var editor = _this.editor;
	            var value = _this.props.value;
	            if (editor && value && value !== _this.currentContent) {
	                editor.undoManager.ignore(function () {
	                    editor.setContent(value);
	                    // only restore cursor on inline editors when they are focused
	                    // as otherwise it will cause a focus grab
	                    if (_this.valueCursor && (!_this.inline || editor.hasFocus())) {
	                        try {
	                            editor.selection.moveToBookmark(_this.valueCursor);
	                        }
	                        catch (e) { /* ignore */ }
	                    }
	                });
	            }
	            _this.rollbackTimer = undefined;
	        };
	        _this.handleBeforeInput = function (_evt) {
	            if (_this.props.value !== undefined && _this.props.value === _this.currentContent && _this.editor) {
	                if (!_this.inline || _this.editor.hasFocus) {
	                    try {
	                        // getBookmark throws exceptions when the editor has not been focused
	                        // possibly only in inline mode but I'm not taking chances
	                        _this.valueCursor = _this.editor.selection.getBookmark(3);
	                    }
	                    catch (e) { /* ignore */ }
	                }
	            }
	        };
	        _this.handleBeforeInputSpecial = function (evt) {
	            if (evt.key === 'Enter' || evt.key === 'Backspace' || evt.key === 'Delete') {
	                _this.handleBeforeInput(evt);
	            }
	        };
	        _this.handleEditorChange = function (_evt) {
	            var editor = _this.editor;
	            if (editor && editor.initialized) {
	                var newContent = editor.getContent();
	                if (_this.props.value !== undefined && _this.props.value !== newContent && _this.props.rollback !== false) {
	                    // start a timer and revert to the value if not applied in time
	                    if (!_this.rollbackTimer) {
	                        _this.rollbackTimer = window.setTimeout(_this.rollbackChange, typeof _this.props.rollback === 'number' ? _this.props.rollback : 200);
	                    }
	                }
	                if (newContent !== _this.currentContent) {
	                    _this.currentContent = newContent;
	                    if ((0, Utils_1.isFunction)(_this.props.onEditorChange)) {
	                        var format = _this.props.outputFormat;
	                        var out = format === 'html' ? newContent : editor.getContent({ format: format });
	                        _this.props.onEditorChange(out, editor);
	                    }
	                }
	            }
	        };
	        _this.handleEditorChangeSpecial = function (evt) {
	            if (evt.key === 'Backspace' || evt.key === 'Delete') {
	                _this.handleEditorChange(evt);
	            }
	        };
	        _this.initialise = function (attempts) {
	            var _a, _b, _c;
	            if (attempts === void 0) { attempts = 0; }
	            var target = _this.elementRef.current;
	            if (!target) {
	                return; // Editor has been unmounted
	            }
	            if (!(0, Utils_1.isInDoc)(target)) {
	                // this is probably someone trying to help by rendering us offscreen
	                // but we can't do that because the editor iframe must be in the document
	                // in order to have state
	                if (attempts === 0) {
	                    // we probably just need to wait for the current events to be processed
	                    setTimeout(function () { return _this.initialise(1); }, 1);
	                }
	                else if (attempts < 100) {
	                    // wait for ten seconds, polling every tenth of a second
	                    setTimeout(function () { return _this.initialise(attempts + 1); }, 100);
	                }
	                else {
	                    // give up, at this point it seems that more polling is unlikely to help
	                    throw new Error('tinymce can only be initialised when in a document');
	                }
	                return;
	            }
	            var tinymce = (0, TinyMCE_1.getTinymce)();
	            if (!tinymce) {
	                throw new Error('tinymce should have been loaded into global scope');
	            }
	            var finalInit = __assign(__assign({}, _this.props.init), { selector: undefined, target: target, readonly: _this.props.disabled, inline: _this.inline, plugins: (0, Utils_1.mergePlugins)((_a = _this.props.init) === null || _a === void 0 ? void 0 : _a.plugins, _this.props.plugins), toolbar: (_b = _this.props.toolbar) !== null && _b !== void 0 ? _b : (_c = _this.props.init) === null || _c === void 0 ? void 0 : _c.toolbar, setup: function (editor) {
	                    _this.editor = editor;
	                    _this.bindHandlers({});
	                    // When running in inline mode the editor gets the initial value
	                    // from the innerHTML of the element it is initialized on.
	                    // However we don't want to take on the responsibility of sanitizing
	                    // to remove XSS in the react integration so we have a chicken and egg
	                    // problem... We avoid it by sneaking in a set content before the first
	                    // "official" setContent and using TinyMCE to do the sanitization.
	                    if (_this.inline && !(0, Utils_1.isTextareaOrInput)(target)) {
	                        editor.once('PostRender', function (_evt) {
	                            editor.setContent(_this.getInitialValue(), { no_events: true });
	                        });
	                    }
	                    if (_this.props.init && (0, Utils_1.isFunction)(_this.props.init.setup)) {
	                        _this.props.init.setup(editor);
	                    }
	                }, init_instance_callback: function (editor) {
	                    var _a, _b;
	                    // check for changes that happened since tinymce.init() was called
	                    var initialValue = _this.getInitialValue();
	                    _this.currentContent = (_a = _this.currentContent) !== null && _a !== void 0 ? _a : editor.getContent();
	                    if (_this.currentContent !== initialValue) {
	                        _this.currentContent = initialValue;
	                        // same as resetContent in TinyMCE 5
	                        editor.setContent(initialValue);
	                        editor.undoManager.clear();
	                        editor.undoManager.add();
	                        editor.setDirty(false);
	                    }
	                    var disabled = (_b = _this.props.disabled) !== null && _b !== void 0 ? _b : false;
	                    (0, Utils_1.setMode)(_this.editor, disabled ? 'readonly' : 'design');
	                    // ensure existing init_instance_callback is called
	                    if (_this.props.init && (0, Utils_1.isFunction)(_this.props.init.init_instance_callback)) {
	                        _this.props.init.init_instance_callback(editor);
	                    }
	                } });
	            if (!_this.inline) {
	                target.style.visibility = '';
	            }
	            if ((0, Utils_1.isTextareaOrInput)(target)) {
	                target.value = _this.getInitialValue();
	            }
	            tinymce.init(finalInit);
	        };
	        _this.id = _this.props.id || (0, Utils_1.uuid)('tiny-react');
	        _this.elementRef = React.createRef();
	        _this.inline = (_c = (_a = _this.props.inline) !== null && _a !== void 0 ? _a : (_b = _this.props.init) === null || _b === void 0 ? void 0 : _b.inline) !== null && _c !== void 0 ? _c : false;
	        _this.boundHandlers = {};
	        return _this;
	    }
	    Editor.prototype.componentDidUpdate = function (prevProps) {
	        var _this = this;
	        var _a, _b;
	        if (this.rollbackTimer) {
	            clearTimeout(this.rollbackTimer);
	            this.rollbackTimer = undefined;
	        }
	        if (this.editor) {
	            this.bindHandlers(prevProps);
	            if (this.editor.initialized) {
	                this.currentContent = (_a = this.currentContent) !== null && _a !== void 0 ? _a : this.editor.getContent();
	                if (typeof this.props.initialValue === 'string' && this.props.initialValue !== prevProps.initialValue) {
	                    // same as resetContent in TinyMCE 5
	                    this.editor.setContent(this.props.initialValue);
	                    this.editor.undoManager.clear();
	                    this.editor.undoManager.add();
	                    this.editor.setDirty(false);
	                }
	                else if (typeof this.props.value === 'string' && this.props.value !== this.currentContent) {
	                    var localEditor_1 = this.editor;
	                    localEditor_1.undoManager.transact(function () {
	                        // inline editors grab focus when restoring selection
	                        // so we don't try to keep their selection unless they are currently focused
	                        var cursor;
	                        if (!_this.inline || localEditor_1.hasFocus()) {
	                            try {
	                                // getBookmark throws exceptions when the editor has not been focused
	                                // possibly only in inline mode but I'm not taking chances
	                                cursor = localEditor_1.selection.getBookmark(3);
	                            }
	                            catch (e) { /* ignore */ }
	                        }
	                        var valueCursor = _this.valueCursor;
	                        localEditor_1.setContent(_this.props.value);
	                        if (!_this.inline || localEditor_1.hasFocus()) {
	                            for (var _i = 0, _a = [cursor, valueCursor]; _i < _a.length; _i++) {
	                                var bookmark = _a[_i];
	                                if (bookmark) {
	                                    try {
	                                        localEditor_1.selection.moveToBookmark(bookmark);
	                                        _this.valueCursor = bookmark;
	                                        break;
	                                    }
	                                    catch (e) { /* ignore */ }
	                                }
	                            }
	                        }
	                    });
	                }
	                if (this.props.disabled !== prevProps.disabled) {
	                    var disabled = (_b = this.props.disabled) !== null && _b !== void 0 ? _b : false;
	                    (0, Utils_1.setMode)(this.editor, disabled ? 'readonly' : 'design');
	                }
	            }
	        }
	    };
	    Editor.prototype.componentDidMount = function () {
	        var _a, _b, _c, _d, _e, _f;
	        if ((0, TinyMCE_1.getTinymce)() !== null) {
	            this.initialise();
	        }
	        else if (this.elementRef.current && this.elementRef.current.ownerDocument) {
	            ScriptLoader_1.ScriptLoader.load(this.elementRef.current.ownerDocument, this.getScriptSrc(), (_b = (_a = this.props.scriptLoading) === null || _a === void 0 ? void 0 : _a.async) !== null && _b !== void 0 ? _b : false, (_d = (_c = this.props.scriptLoading) === null || _c === void 0 ? void 0 : _c.defer) !== null && _d !== void 0 ? _d : false, (_f = (_e = this.props.scriptLoading) === null || _e === void 0 ? void 0 : _e.delay) !== null && _f !== void 0 ? _f : 0, this.initialise);
	        }
	    };
	    Editor.prototype.componentWillUnmount = function () {
	        var _this = this;
	        var editor = this.editor;
	        if (editor) {
	            editor.off(changeEvents(), this.handleEditorChange);
	            editor.off(beforeInputEvent(), this.handleBeforeInput);
	            editor.off('keypress', this.handleEditorChangeSpecial);
	            editor.off('keydown', this.handleBeforeInputSpecial);
	            editor.off('NewBlock', this.handleEditorChange);
	            Object.keys(this.boundHandlers).forEach(function (eventName) {
	                editor.off(eventName, _this.boundHandlers[eventName]);
	            });
	            this.boundHandlers = {};
	            editor.remove();
	            this.editor = undefined;
	        }
	    };
	    Editor.prototype.render = function () {
	        return this.inline ? this.renderInline() : this.renderIframe();
	    };
	    Editor.prototype.renderInline = function () {
	        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
	        return React.createElement(tagName, {
	            ref: this.elementRef,
	            id: this.id
	        });
	    };
	    Editor.prototype.renderIframe = function () {
	        return React.createElement('textarea', {
	            ref: this.elementRef,
	            style: { visibility: 'hidden' },
	            name: this.props.textareaName,
	            id: this.id
	        });
	    };
	    Editor.prototype.getScriptSrc = function () {
	        if (typeof this.props.tinymceScriptSrc === 'string') {
	            return this.props.tinymceScriptSrc;
	        }
	        else {
	            var channel = this.props.cloudChannel;
	            var apiKey = this.props.apiKey ? this.props.apiKey : 'no-api-key';
	            return "https://cdn.tiny.cloud/1/".concat(apiKey, "/tinymce/").concat(channel, "/tinymce.min.js");
	        }
	    };
	    Editor.prototype.getInitialValue = function () {
	        if (typeof this.props.initialValue === 'string') {
	            return this.props.initialValue;
	        }
	        else if (typeof this.props.value === 'string') {
	            return this.props.value;
	        }
	        else {
	            return '';
	        }
	    };
	    Editor.prototype.bindHandlers = function (prevProps) {
	        var _this = this;
	        if (this.editor !== undefined) {
	            // typescript chokes trying to understand the type of the lookup function
	            (0, Utils_1.configHandlers)(this.editor, prevProps, this.props, this.boundHandlers, function (key) { return _this.props[key]; });
	            // check if we should monitor editor changes
	            var isValueControlled = function (p) { return p.onEditorChange !== undefined || p.value !== undefined; };
	            var wasControlled = isValueControlled(prevProps);
	            var nowControlled = isValueControlled(this.props);
	            if (!wasControlled && nowControlled) {
	                this.editor.on(changeEvents(), this.handleEditorChange);
	                this.editor.on(beforeInputEvent(), this.handleBeforeInput);
	                this.editor.on('keydown', this.handleBeforeInputSpecial);
	                this.editor.on('keyup', this.handleEditorChangeSpecial);
	                this.editor.on('NewBlock', this.handleEditorChange);
	            }
	            else if (wasControlled && !nowControlled) {
	                this.editor.off(changeEvents(), this.handleEditorChange);
	                this.editor.off(beforeInputEvent(), this.handleBeforeInput);
	                this.editor.off('keydown', this.handleBeforeInputSpecial);
	                this.editor.off('keyup', this.handleEditorChangeSpecial);
	                this.editor.off('NewBlock', this.handleEditorChange);
	            }
	        }
	    };
	    Editor.propTypes = EditorPropTypes_1.EditorPropTypes;
	    Editor.defaultProps = {
	        cloudChannel: '5'
	    };
	    return Editor;
	}(React.Component));
	exports.Editor = Editor;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Editor = void 0;
	var Editor_1 = __webpack_require__(934);
	Object.defineProperty(exports, "Editor", { enumerable: true, get: function () { return Editor_1.Editor; } });


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _zh_CN = _interopRequireDefault(__webpack_require__(513));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _zh_CN["default"];
	exports["default"] = _default;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _zh_CN = _interopRequireDefault(__webpack_require__(938));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _zh_CN["default"];
	exports["default"] = _default;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _zh_CN = _interopRequireDefault(__webpack_require__(2101));
	
	var _zh_CN2 = _interopRequireDefault(__webpack_require__(513));
	
	var _zh_CN3 = _interopRequireDefault(__webpack_require__(514));
	
	var _zh_CN4 = _interopRequireDefault(__webpack_require__(936));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = {
	  locale: 'zh-cn',
	  Pagination: _zh_CN["default"],
	  DatePicker: _zh_CN2["default"],
	  TimePicker: _zh_CN3["default"],
	  Calendar: _zh_CN4["default"],
	  // locales for all comoponents
	  global: {
	    placeholder: '请选择'
	  },
	  Table: {
	    filterTitle: '筛选',
	    filterConfirm: '确定',
	    filterReset: '重置',
	    selectAll: '全选当页',
	    selectInvert: '反选当页',
	    sortTitle: '排序',
	    expand: '展开行',
	    collapse: '关闭行'
	  },
	  Modal: {
	    okText: '确定',
	    cancelText: '取消',
	    justOkText: '知道了'
	  },
	  Popconfirm: {
	    cancelText: '取消',
	    okText: '确定'
	  },
	  Transfer: {
	    searchPlaceholder: '请输入搜索内容',
	    itemUnit: '项',
	    itemsUnit: '项'
	  },
	  Upload: {
	    uploading: '文件上传中',
	    removeFile: '删除文件',
	    uploadError: '上传错误',
	    previewFile: '预览文件',
	    downloadFile: '下载文件'
	  },
	  Empty: {
	    description: '暂无数据'
	  },
	  Icon: {
	    icon: '图标'
	  },
	  Text: {
	    edit: '编辑',
	    copy: '复制',
	    copied: '复制成功',
	    expand: '展开'
	  },
	  PageHeader: {
	    back: '返回'
	  }
	};
	exports["default"] = _default;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InstallCert = exports.PKCS10Requisition_SingleCert = exports.getContainer = exports.CFCA_GetVersion = exports.CFCA_GetAllCertInfo = exports.CFCA_PKCS10CertRequisition = exports.CFCA_ImportSignCert = exports.CFCA_GetContainer = exports.CFCA_ImportEncryptCert = exports.CFCA_SetKeyAlgorithm = exports.CFCA_SetCSPInfo = exports.CFCA_GetCSPInfo = exports.connect = exports.cofco_connect = undefined;
	
	var _certenrollment = __webpack_require__(517);
	
	var _browser = __webpack_require__(516);
	
	var _index = __webpack_require__(940);
	
	var cofco_connect = exports.cofco_connect = function cofco_connect() {
	  return (0, _browser.checkExtension)().then(function (res) {
	    return (0, _index.SendMsg)({ action: "connect", host: _certenrollment.productID });
	  }).then(function (res) {
	    return (0, _index.SendMsg)({ action: "checkHost" });
	  });
	};
	
	// 连接扩展
	var connect = exports.connect = function connect() {
	  return (0, _browser.checkExtension)().then(function (res) {
	    return (0, _index.SendMsg)({ action: "connect", host: _certenrollment.productID });
	  }).then(function (res) {
	    return (0, _index.SendMsg)({ action: "checkHost" });
	  });
	};
	
	var CFCA_GetCSPInfo = exports.CFCA_GetCSPInfo = function CFCA_GetCSPInfo() {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_GetCSPInfo',
	      params: [],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_SetCSPInfo = exports.CFCA_SetCSPInfo = function CFCA_SetCSPInfo(lKeyLength, bstrCSPName) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_SetCSPInfo',
	      params: [lKeyLength, bstrCSPName],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_SetKeyAlgorithm = exports.CFCA_SetKeyAlgorithm = function CFCA_SetKeyAlgorithm(bstrKeyAlgorithm) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_SetKeyAlgorithm',
	      params: [bstrKeyAlgorithm],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_ImportEncryptCert = exports.CFCA_ImportEncryptCert = function CFCA_ImportEncryptCert(bstrEncryptedPrivateKey, bstrP7Cert, bstrContainerName, lEncryptCertPrivateKeyFlags) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_ImportEncryptCert',
	      params: [bstrEncryptedPrivateKey, bstrP7Cert, bstrContainerName, lEncryptCertPrivateKeyFlags],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_GetContainer = exports.CFCA_GetContainer = function CFCA_GetContainer() {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_GetContainer',
	      params: [],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_ImportSignCert = exports.CFCA_ImportSignCert = function CFCA_ImportSignCert(lCertType, bstrSignCert, keyName) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_ImportSignCert',
	      params: [lCertType, bstrSignCert, keyName],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_PKCS10CertRequisition = exports.CFCA_PKCS10CertRequisition = function CFCA_PKCS10CertRequisition(bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_PKCS10CertRequisition',
	      params: [bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_GetAllCertInfo = exports.CFCA_GetAllCertInfo = function CFCA_GetAllCertInfo() {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_GetAllCertInfo',
	      params: [],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_GetVersion = exports.CFCA_GetVersion = function CFCA_GetVersion() {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_GetVersion',
	      params: [],
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var C_keyAlgorithm = "RSA";
	var C_keyLength = 2048;
	
	// 获取取得当前密钥对的密钥容器名称
	var getContainer = exports.getContainer = function getContainer() {
	  return connect().then(function (result) {
	    return CFCA_GetContainer();
	  });
	};
	
	var PKCS10Requisition_SingleCert = exports.PKCS10Requisition_SingleCert = function PKCS10Requisition_SingleCert() {
	  var strSubjectDN = "CN=certRequisition,O=CFCA TEST CA,C=CN";
	  return connect().then(function (res) {
	    return CFCA_GetCSPInfo();
	  }).then(function (response) {
	    console.log('1-----CFCA_GetCSPInfo', response);
	    var result = response.result;
	    var csps = result.split('||');
	    var current = csps.filter(function (f) {
	      return f.indexOf('Microsoft') == -1;
	    });
	    console.log(current);
	    return CFCA_SetCSPInfo(C_keyLength, current[0]);
	  }).then(function (response) {
	    console.log('2-----CFCA_SetCSPInfo', response);
	    return CFCA_SetKeyAlgorithm(C_keyAlgorithm);
	  }).then(function (response) {
	    console.log('3-----CFCA_SetKeyAlgorithm', response);
	    return CFCA_PKCS10CertRequisition(strSubjectDN, 1, 0);
	  }).then(function (response) {
	    console.log('4-----CFCA_PKCS10CertRequisition', response);
	    // return CFCA_GetContainer()
	    // return Promise.resolve(response.result.replace(/[\r\n]/g, ""))
	  });
	};
	
	var InstallCert = exports.InstallCert = function InstallCert() {
	  var certType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var signCert = arguments[1];
	  var keyName = arguments[2];
	
	  return connect().then(function (res) {
	    return CFCA_GetCSPInfo();
	  }).then(function (response) {
	    console.log('1-----CFCA_GetCSPInfo', response);
	    var result = response.result;
	    var csps = result.split('||');
	    var current = csps.filter(function (f) {
	      return f.indexOf('Microsoft') == -1;
	    });
	    return CFCA_SetCSPInfo(C_keyLength, current[0]);
	  }).then(function (response) {
	    console.log('2-----CFCA_SetCSPInfo', response);
	
	    return CFCA_SetKeyAlgorithm(C_keyAlgorithm);
	  }).then(function (response) {
	    console.log('3-----CFCA_SetKeyAlgorithm', response);
	    return CFCA_ImportSignCert(certType, signCert, keyName);
	  }).then(function (response) {
	    console.log('4-----CFCA_ImportSignCert', response);
	  });
	};

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastErrorDesc = exports.SendMsg = undefined;
	
	var _certenrollment = __webpack_require__(517);
	
	var _browser = __webpack_require__(516);
	
	var isChrome = _browser.BrowserInfo.name === _browser.standardBrowser.Chrome;
	// 统一错误处理规则
	// 返回为null， Extension has been remove
	
	var SendMsgforChrome = function SendMsgforChrome(request) {
	  // console.info(request.funcInfo.function + '--------' + request.funcInfo.params)
	  return new Promise(function (resolve, reject) {
	    chrome.runtime.sendMessage(_certenrollment.chromeExtension, request, function (response) {
	      // console.log('中心错误------------' , response)
	      if (response) {
	        if (response.errorcode == 0) {
	          resolve(response);
	        } else {
	          console.log(response);
	          if (response.errorcode == 1) {
	            reject(response);
	          } else {
	            return getLastErrorDesc().then(function (res) {
	              reject(res);
	            });
	          }
	        }
	      } else {
	        reject({ errorcode: 1, result: chrome.runtime.lastError.message });
	      }
	    });
	  });
	};
	
	var SendMsgByEvent = function SendMsgByEvent(request) {
	  var event = new CustomEvent(_certenrollment.reqEventName, { detail: request });
	  document.dispatchEvent(event);
	
	  return new Promise(function (resolve, reject) {
	    var responseEventName = _certenrollment.respEventName;
	    if (request.funcInfo != undefined && request.funcInfo.randomId != undefined) {
	      responseEventName += "." + request.funcInfo.randomId;
	    }
	    document.addEventListener(responseEventName, CallBack = function (_CallBack) {
	      function CallBack(_x) {
	        return _CallBack.apply(this, arguments);
	      }
	
	      CallBack.toString = function () {
	        return _CallBack.toString();
	      };
	
	      return CallBack;
	    }(function (e) {
	      document.removeEventListener(e.type, CallBack);
	      var eJson = JSON.parse(e.detail);
	      if (eJson && eJson.errorcode == 0) {
	        resolve(eJson);
	      } else {
	        reject(eJson);
	      }
	    }), false);
	  });
	};
	
	var SendMsg = exports.SendMsg = function SendMsg(requestJSON) {
	  if (isChrome) {
	    return SendMsgforChrome(requestJSON);
	  } else {
	    return SendMsgByEvent(requestJSON);
	  }
	};
	
	var getLastErrorDesc = exports.getLastErrorDesc = function getLastErrorDesc() {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'GetLastErrorDesc',
	      params: null,
	      randomId: (0, _certenrollment.GenerateRandomId)()
	    }
	  };
	  return SendMsg(request);
	};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CFCA_PKCS10CertRequisition = exports.CFCA_GetContainer = exports.CFCA_ImportSignCert = exports.CFCA_SetKeyAlgorithm = exports.CFCA_SetCSPInfo = exports.getSignCertInfo = exports.signHashMsgPKCS7Detached = exports.signMsgPKCS7 = exports.getVersion = exports.selectCertificate = exports.disConnect = exports.connect = undefined;
	
	var _cryptokit = __webpack_require__(519);
	
	var _browser = __webpack_require__(518);
	
	var _index = __webpack_require__(942);
	
	// 连接扩展
	var connect = exports.connect = function connect() {
	  return (0, _browser.checkExtension)().then(function (res) {
	    return (0, _index.SendMsg)({ action: "connect", host: _cryptokit.productID });
	  }).then(function (res) {
	    return (0, _index.SendMsg)({ action: "checkHost" });
	  });
	};
	
	// 断开连接
	var disConnect = exports.disConnect = function disConnect() {
	  return (0, _index.SendMsg)({ action: 'disconnect', host: _cryptokit.productID });
	};
	
	var selectCertificate = exports.selectCertificate = function selectCertificate() {
	  var strSubjectDNFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var strIssuerDNFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var strSerialNo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var strCSPList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  var request = {
	    action: "invoke",
	    funcInfo: {
	      function: 'SelectCertificate',
	      params: [strSubjectDNFilter, strIssuerDNFilter, strSerialNo, strCSPList],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var getVersion = exports.getVersion = function getVersion() {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'GetVersion',
	      params: [],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	// 获取 口令 "123", "SHA-1" ,true
	var signMsgPKCS7 = exports.signMsgPKCS7 = function signMsgPKCS7() {
	  var strSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '123';
	  var strSelectedAlg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SHA-1';
	  var bAttached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'SignMsgPKCS7',
	      params: [strSource, strSelectedAlg, bAttached],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var signHashMsgPKCS7Detached = exports.signHashMsgPKCS7Detached = function signHashMsgPKCS7Detached(strSource, strSelectedAlg) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'signHashMsgPKCS7Detached',
	      params: [strSource, strSelectedAlg],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var getSignCertInfo = exports.getSignCertInfo = function getSignCertInfo(strInfoType) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'GetSignCertInfo',
	      params: [strInfoType],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_SetCSPInfo = exports.CFCA_SetCSPInfo = function CFCA_SetCSPInfo(lKeyLength, bstrCSPName) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_SetCSPInfo',
	      params: [lKeyLength, bstrCSPName],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_SetKeyAlgorithm = exports.CFCA_SetKeyAlgorithm = function CFCA_SetKeyAlgorithm(bstrKeyAlgorithm) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_SetKeyAlgorithm',
	      params: [bstrKeyAlgorithm],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	var CFCA_ImportSignCert = exports.CFCA_ImportSignCert = function CFCA_ImportSignCert(lCertType, bstrSignCert, bstrContainerName) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_ImportSignCert',
	      params: [lCertType, bstrSignCert, bstrContainerName],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	// 获取取得当前密钥对的密钥容器名称
	var CFCA_GetContainer = exports.CFCA_GetContainer = function CFCA_GetContainer() {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_GetContainer',
	      params: [],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};
	
	// 生成证书申请消息（符合PKCS#10标准），用于申请签名证书或双证
	var CFCA_PKCS10CertRequisition = exports.CFCA_PKCS10CertRequisition = function CFCA_PKCS10CertRequisition(bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags) {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'CFCA_PKCS10CertRequisition',
	      params: [bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags],
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return (0, _index.SendMsg)(request);
	};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastErrorDesc = exports.SendMsg = undefined;
	
	var _cryptokit = __webpack_require__(519);
	
	var _errorMap = __webpack_require__(520);
	
	var _errorMap2 = _interopRequireDefault(_errorMap);
	
	var _browser = __webpack_require__(518);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function errorHandler(err) {
	  var result = err.result;
	
	  if (!result) return;
	  for (var key in _errorMap2.default) {
	    var msg = _errorMap2.default[key];
	    var isIn = result.includes(key);
	    if (isIn) {
	      err.result = msg;
	    }
	  }
	}
	var isChrome = _browser.BrowserInfo.name === _browser.standardBrowser.Chrome;
	// 统一错误处理规则
	// 返回为null， Extension has been remove
	
	var SendMsgforChrome = function SendMsgforChrome(request) {
	  return new Promise(function (resolve, reject) {
	    chrome.runtime.sendMessage(_cryptokit.chromeExtension, request, function (response) {
	      if (response) {
	        if (response.errorcode == 0) {
	          resolve(response);
	        } else {
	          if (response.errorcode == 1) {
	            errorHandler(response);
	            reject(response);
	          } else {
	            return getLastErrorDesc().then(function (res) {
	              errorHandler(res);
	              reject(res);
	            });
	          }
	        }
	      } else {
	        reject({ errorcode: 1, result: '验证失败，请确保插件已安装并打开' });
	      }
	    });
	  });
	};
	
	var SendMsgByEvent = function SendMsgByEvent(request) {
	  var event = new CustomEvent(_cryptokit.reqEventName, { detail: request });
	  document.dispatchEvent(event);
	
	  return new Promise(function (resolve, reject) {
	    var responseEventName = _cryptokit.respEventName;
	    if (request.funcInfo != undefined && request.funcInfo.randomId != undefined) {
	      responseEventName += "." + request.funcInfo.randomId;
	    }
	    document.addEventListener(responseEventName, CallBack = function (_CallBack) {
	      function CallBack(_x) {
	        return _CallBack.apply(this, arguments);
	      }
	
	      CallBack.toString = function () {
	        return _CallBack.toString();
	      };
	
	      return CallBack;
	    }(function (e) {
	      document.removeEventListener(e.type, CallBack);
	      var eJson = JSON.parse(e.detail);
	      if (eJson && eJson.errorcode == 0) {
	        resolve(eJson);
	      } else {
	        reject(eJson);
	      }
	    }), false);
	  });
	};
	
	var SendMsg = exports.SendMsg = function SendMsg(requestJSON) {
	  if (isChrome) {
	    return SendMsgforChrome(requestJSON);
	  } else {
	    return SendMsgByEvent(requestJSON);
	  }
	};
	
	var getLastErrorDesc = exports.getLastErrorDesc = function getLastErrorDesc() {
	  var request = {
	    action: 'invoke',
	    funcInfo: {
	      function: 'GetLastErrorDesc',
	      params: null,
	      randomId: (0, _cryptokit.GenerateRandomId)()
	    }
	  };
	  return SendMsg(request);
	};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(515);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.cfca = {
	  // 底层api
	  // cryptokit,
	  // cofco,
	  // 封装 动作
	  action: _index2.default
	}; // import cryptokit from './cryptokit/index'
	// import cofco from './cofco/index'

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GetCspInfo = GetCspInfo;
	exports.OnLoad = OnLoad;
	exports.GetContainer = GetContainer;
	exports.PKCS10Requisition_SingleCert = PKCS10Requisition_SingleCert;
	exports.InstallCert = InstallCert;
	exports.InstallCert2 = InstallCert2;
	exports.GetVersion = GetVersion;
	
	var _nmCertEnrollment = __webpack_require__(945);
	
	function BrowserInfo() {
	  var res = {
	    name: '',
	    version: ''
	  };
	  var reg = void 0;
	  var userAgent = self.navigator.userAgent;
	
	  if (reg = /edge\/([\d\.]+)/i.exec(userAgent)) {
	    res.name = 'Edge';
	    res.version = reg[1];
	  } else if (/msie/i.test(userAgent)) {
	    res.name = 'Internet Explorer';
	    res.version = /msie ([\d\.]+)/i.exec(userAgent)[1];
	  } else if (/Trident/i.test(userAgent)) {
	    res.name = 'Internet Explorer';
	    res.version = /rv:([\d\.]+)/i.exec(userAgent)[1];
	  } else if (/chrome/i.test(userAgent)) {
	    res.name = 'Chrome';
	    res.version = /chrome\/([\d\.]+)/i.exec(userAgent)[1];
	  } else if (/safari/i.test(userAgent)) {
	    res.name = 'Safari';
	    res.version = /version\/([\d\.]+)/i.exec(userAgent)[1];
	  } else if (/firefox/i.test(userAgent)) {
	    res.name = 'Firefox';
	    res.version = /firefox\/([\d\.]+)/i.exec(userAgent)[1];
	  }
	  return res;
	}
	
	var CryptoKit = void 0;
	
	function GetCspInfo() {
	  return CryptoKit.CFCA_GetCSPInfo();
	}
	
	function LoadObj() {
	  try {
	    var browser = BrowserInfo();
	    if (browser.name == 'Chrome' && parseInt(browser.version) > 41) {
	      // ||
	      //     ("Firefox" == browser.name && parseInt(browser.version) > 52)) {
	
	      CryptoKit = new _nmCertEnrollment.nmCryptokit(browser.name);
	
	      CryptoKit.init().then(function () {
	        console.log('插件已启用！');
	      }).catch(function (response) {
	        // alert(response.result);
	        installExtension();
	      });
	    } else {
	      alert('Unsupported browser!');
	    }
	  } catch (e) {
	    // alert(e);
	    return;
	  }
	}
	
	function installExtension() {
	  var browser = BrowserInfo();
	  if (browser.name == 'Firefox') {
	    var extensionURL = '';
	    var xpi = { 'CryptoKit for Firefox': extensionURL };
	
	    InstallTrigger.install(xpi);
	  } else if (browser.name == 'Chrome') {
	    // alert("Please install extension for Chrome!");
	  } else {
	    alert('Unsupported browser!');
	  }
	}
	
	function OnLoad() {
	  // Waiting for extension loading
	  // document.getElementById("CryptoKitExtension").style.display = "none";
	  // setTimeout(LoadObj(), 500);
	  LoadObj();
	}
	
	function OnUnLoad() {
	  try {
	    CryptoKit.uninit().then(function () {
	      EnableButton(false);
	    });
	  } catch (e) {
	    alert(e);
	    return;
	  }
	}
	
	function GetSelectedItemIndex(itemName) {
	  var ele = document.getElementsByName(itemName);
	  for (i = 0; i < ele.length; i++) {
	    if (ele[i].checked) {
	      return i;
	    }
	  }
	}
	
	function GetCSPInfo() {
	  CryptoKit.CFCA_GetCSPInfo().then(function (response) {
	    document.getElementById('textareaCSPInfo').value = response.result;
	  }).catch(function (response) {
	    ShowErrorInfo(response);
	  });
	}
	
	function GetAllCertInfo() {
	  var cspName = document.getElementById('CSPNameList').value;
	  CryptoKit.CFCA_GetAllCertInfo(cspName).then(function (response) {
	    document.getElementById('TextAllCertInfo').value = response.result;
	  }).catch(function (response) {
	    ShowErrorInfo(response);
	  });
	}
	
	function GetContainer() {
	  return CryptoKit.CFCA_GetContainer();
	}
	
	var C_keyAlgorithm = 'RSA';
	var C_keyLength = 2048;
	
	function PKCS10Requisition_SingleCert() {
	  var strSubjectDN = 'CN=certRequisition,O=CFCA TEST CA,C=CN';
	
	  return CryptoKit.CFCA_GetCSPInfo().then(function (response) {
	    var result = response.result;
	    var csps = result.split('||');
	    // let current = csps.filter(f => f.indexOf('Microsoft') == -1);
	
	    // return CryptoKit.CFCA_SetCSPInfo(C_keyLength, current[0]);
	    var current = csps.filter(function (f) {
	      return f.indexOf('Microsoft') == -1 && ['Uyee CSP v6.0 (Enterprise)', 'CFCA FOR UKEY CSP v1.1.0'].includes(f);
	    });
	
	    console.log('current', current);
	    if (current.includes('Uyee CSP v6.0 (Enterprise)')) {
	      return CryptoKit.CFCA_SetCSPInfo(C_keyLength, 'Uyee CSP v6.0 (Enterprise)');
	    }
	    if (current.includes('CFCA FOR UKEY CSP v1.1.0')) {
	      return CryptoKit.CFCA_SetCSPInfo(C_keyLength, 'CFCA FOR UKEY CSP v1.1.0');
	    }
	
	    return CryptoKit.CFCA_SetCSPInfo(C_keyLength, current[0]);
	  }).then(function (response) {
	    return CryptoKit.CFCA_SetKeyAlgorithm(C_keyAlgorithm);
	  }).then(function (response) {
	    return CryptoKit.CFCA_PKCS10CertRequisition(strSubjectDN, 1, 0);
	  }).then(function (response) {
	    return Promise.resolve(response.result.replace(/[\r\n]/g, ''));
	  });
	  // .catch(function (response) {
	
	  //     return CryptoKit.GetLastErrorDesc().then(function (response) {
	  //         // console.log(response.result)
	  //         throw Error(response.result);
	  //     });
	  //     voShowErrorInfo(response);
	  //     // console.log(response);
	  //     // return Promise.reject(response)
	  // })
	}
	
	function PKCS10Requisition_DoubleCert() {
	  var keyAlgorithm = document.getElementById('KenAlgorithm').value;
	  var selectValue = document.getElementById('KenLength').value;
	  var keyLength = 0;
	  if (selectValue == '1024') {
	    keyLength = 1024;
	  } else if (selectValue == '2048') {
	    keyLength = 2048;
	  } else if (selectValue == '4096') {
	    keyLength = 4096;
	  } else {
	    keyLength = 256;
	  }
	  var cspName = document.getElementById('TextCSPName').value;
	  if (cspName == '') {
	    alert('请选择“生成密钥的CSP名称”');
	    FindProvider();
	    return;
	  }
	  var strSubjectDN = document.getElementById('TextSubjectDN').value;
	
	  CryptoKit.CFCA_SetCSPInfo(keyLength, cspName).then(function (response) {
	    return CryptoKit.CFCA_SetKeyAlgorithm(keyAlgorithm);
	  }).then(function (response) {
	    return CryptoKit.CFCA_PKCS10CertRequisition(strSubjectDN, 2, 0);
	  }).then(function (response) {
	    document.getElementById('textareaP10RSASingleCert').value = response.result;
	    return CryptoKit.CFCA_GetContainer();
	  }).then(function (response) {
	    document.getElementById('TextContianerName').value = response.result;
	  });
	  // .catch(function (response) {
	  //     ShowErrorInfo(response);
	  // });
	}
	
	function KeyAlgorithm_onchange(selectedItemIndex) {
	  try {
	    var kenLength_select = document.getElementById('KenLength');
	    var optionNum = document.getElementById('KenLength').length;
	    // remove select's options
	    for (var _i = optionNum; _i >= 0; _i--) {
	      kenLength_select.remove(_i);
	    }
	
	    if (selectedItemIndex == 0) {
	      // RSA
	      // show digest algorithm
	      document.getElementById('tr_DigestAlgorithm').style.display = '';
	
	      // key length
	      var optionTag = document.createElement('option');
	      optionTag.text = '1024';
	      optionTag.value = '1024';
	      kenLength_select.options.add(optionTag);
	      optionTag = document.createElement('option');
	      optionTag.text = '2048';
	      optionTag.value = '2048';
	      kenLength_select.options.add(optionTag);
	      optionTag = document.createElement('option');
	      optionTag.text = '4096';
	      optionTag.value = '4096';
	      kenLength_select.options.add(optionTag);
	      document.getElementById('TextCSPName').value = 'Microsoft Enhanced Cryptographic Provider v1.0';
	    } else {
	      // SM2
	      // hide digest algorithm
	      document.getElementById('tr_DigestAlgorithm').style.display = 'none';
	
	      var optionTag = document.createElement('option');
	      optionTag.text = '256';
	      optionTag.value = '256';
	      kenLength_select.options.add(optionTag);
	      // document.getElementById("TextCSPName").value = "CIDC Cryptographic Service Provider v3.0.0";
	    }
	  } catch (e) {
	    alert(e.number + e.message);
	  }
	}
	
	function InstallCert(certType, params) {
	  // if (params.signCert == "") {
	  //     alert("签名公钥证书内容为空");
	  //     return;
	  // }
	
	  // if (params.containerName == "") {
	  //     alert("密钥容器名称内容为空");
	  //     return;
	  // }
	
	  var signCert = params.signCert,
	      containerName = params.containerName;
	
	
	  return CryptoKit.CFCA_GetCSPInfo().then(function (response) {
	    var result = response.result;
	    var csps = result.split('||');
	    console.log('csps', csps);
	    var current = csps.filter(function (f) {
	      return f.indexOf('Microsoft') == -1 && ['Uyee CSP v6.0 (Enterprise)', 'CFCA FOR UKEY CSP v1.1.0'].includes(f);
	    });
	
	    console.log('current', current);
	    if (current.includes('Uyee CSP v6.0 (Enterprise)')) {
	      return CryptoKit.CFCA_SetCSPInfo(C_keyLength, 'Uyee CSP v6.0 (Enterprise)');
	    }
	    if (current.includes('CFCA FOR UKEY CSP v1.1.0')) {
	      return CryptoKit.CFCA_SetCSPInfo(C_keyLength, 'CFCA FOR UKEY CSP v1.1.0');
	    }
	    return CryptoKit.CFCA_SetCSPInfo(C_keyLength, current[0]);
	  }).then(function (response) {
	    return CryptoKit.CFCA_SetKeyAlgorithm(C_keyAlgorithm);
	  })
	  // .then(function (response){
	  //     return CryptoKit.CFCA_GetContainer()
	  // })
	  .then(function (response) {
	    return CryptoKit.CFCA_ImportSignCert(certType, signCert, containerName);
	  });
	  // .then(function (response) {
	  //     return CryptoKit.GetLastErrorDesc().then(function (response) {
	  //         return (response);
	  //     });
	  // })
	  // .catch(function (response) {
	  //     // ShowErrorInfo(response);
	  //     return CryptoKit.GetLastErrorDesc().then(function (response) {
	  //         throw Error(response);
	  //     });
	  // })
	}
	
	function InstallCert2(certType, params) {
	  var cspName = document.getElementById('TextCSPName').value;
	  if (cspName == '') {
	    alert('CSP名称为空');
	    return;
	  }
	  var keyAlgorithm = document.getElementById('KenAlgorithm').value;
	  if (keyAlgorithm == '') {
	    alert('密钥生成算法为空');
	    return;
	  }
	  var selectValue = document.getElementById('KenLength').value;
	  var keyLength = 0;
	  if (selectValue == '1024') {
	    keyLength = 1024;
	  } else if (selectValue == '2048') {
	    keyLength = 2048;
	  } else if (selectValue == '4096') {
	    keyLength = 4096;
	  } else if (selectValue == '256') {
	    keyLength = 256;
	  } else {
	    alert('密钥长度错误：' + keyLength);
	    return;
	  }
	
	  if (params.signCert == '') {
	    alert('签名公钥证书内容为空');
	    return;
	  }
	
	  if (params.containerName == '') {
	    alert('密钥容器名称内容为空');
	    return;
	  }
	
	  CryptoKit.CFCA_SetCSPInfo(keyLength, cspName).then(function (response) {
	    return CryptoKit.CFCA_SetKeyAlgorithm(keyAlgorithm);
	  }).then(function (response) {
	    return CryptoKit.CFCA_ImportSignCert(certType, signCert, containerName);
	  }).then(function (response) {
	    if (certType == 2) {
	      // double cert
	      var encryptCert_PublickeyCert = document.getElementById('textareaEncryptCert_PublickeyCert').value;
	      if (encryptCert_PublickeyCert == '') {
	        alert('加密证书公钥证书内容为空');
	        return;
	      }
	      var encryptCert_PrivateData = document.getElementById('textareaEncryptCert_PrivatekeyCert').value;
	      if (encryptCert_PrivateData == '') {
	        alert('加密证书私钥数据为空');
	        return;
	      }
	
	      return CryptoKit.CFCA_ImportEncryptCert(encryptCert_PrivateData, encryptCert_PublickeyCert, containerName, 0x1 | 0x2);
	    }
	  }).then(function (response) {
	    if (certType == 1) {
	      alert('单证书安装成功');
	    } else {
	      alert('双证书安装成功');
	    }
	  }).catch(function (response) {
	    ShowErrorInfo(response);
	  });
	}
	
	function GetVersion() {
	  return CryptoKit.CFCA_GetVersion().then(function (response) {
	    return Promise.resolve(response.result);
	  }).catch(function (response) {
	    return Promise.reject();
	  });
	}
	
	function ShowErrorInfo(response) {
	  if (response == null) {
	    alert('Extension has been remove!');
	  } else if (response.errorcode == 1) {
	    // connection error
	    alert(response.result);
	  } else {
	    // host error
	    console.log(response);
	    CryptoKit.GetLastErrorDesc().then(function (response) {
	      alert(response.result);
	    });
	  }
	}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.nmCryptokit = nmCryptokit;
	
	var _errorMap = __webpack_require__(520);
	
	var _errorMap2 = _interopRequireDefault(_errorMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chromeExtension = "ioajglkpoiippgegmbnickbpknbahigp";
	var productID = "com.cfca.certenrollment.cofco";
	
	var extensionName = productID + ".extension";
	var reqEventName = productID + ".request";
	var respEventName = productID + ".response";
	
	var Browser = {
	    IE: "Internet Explorer",
	    Edge: "Edge",
	    Chrome: "Chrome",
	    Safari: "Safari",
	    Firefox: "Firefox"
	};
	
	function errorHandler(err) {
	    var result = err.result;
	
	    console.log(result);
	    if (!result) return;
	    for (var key in _errorMap2.default) {
	        var msg = _errorMap2.default[key];
	        var isIn = result.includes(key);
	        if (isIn) {
	            err.result = msg;
	        }
	    }
	}
	var getLastErrorDesc = function getLastErrorDesc() {
	    var request = new Object();
	    var funcInfo = new Object();
	    var randomId = GenerateRandomId();
	
	    funcInfo.function = "GetLastErrorDesc";
	    funcInfo.params = null;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage('Chrome', request);
	};
	
	// Encapsulate Chrome sendMessage callback to Promise
	function SendMessageforChrome(request) {
	    return new Promise(function (resolve, reject) {
	        if (chrome.runtime && chrome.runtime.sendMessage) {
	            chrome.runtime.sendMessage(chromeExtension, request, function (response) {
	                if (response) {
	                    if (0 == response.errorcode) {
	                        resolve(response);
	                    } else {
	                        // errorHandler(response)
	                        // console.log(response)
	                        // reject(response)
	                        if (response.errorcode == 1) {
	                            errorHandler(response);
	                            reject(response);
	                        } else {
	                            return getLastErrorDesc().then(function (res) {
	                                errorHandler(res);
	                                reject(res);
	                            });
	                        }
	                    }
	                } else {
	                    reject({ errorcode: 1, result: '验证失败，请确保插件已安装并打开' });
	                }
	            });
	        } else {
	            reject({ errorcode: 1, result: '验证失败，请确保插件已安装并打开' });
	        }
	    });
	}
	
	// Encapsulate Edge&Firefox event to Promise
	function SendMessagebyEvent(request) {
	    var event = new CustomEvent(reqEventName, { detail: request });
	    document.dispatchEvent(event);
	
	    return new Promise(function (resolve, reject) {
	
	        var responseEventName = respEventName;
	        if (request.funcInfo != undefined && request.funcInfo.randomId != undefined) responseEventName += "." + request.funcInfo.randomId;
	
	        document.addEventListener(responseEventName, function CallBack(e) {
	            document.removeEventListener(e.type, CallBack);
	            var eJson = JSON.parse(e.detail);
	            if (null != eJson && 0 == eJson.errorcode) {
	                resolve(eJson);
	            } else {
	                reject(eJson);
	            }
	        }, false);
	    });
	}
	
	function SendMessage(browser, requestJSON) {
	    if (Browser.Chrome == browser) {
	        return SendMessageforChrome(requestJSON);
	    } else {
	        return SendMessagebyEvent(requestJSON);
	    }
	}
	
	function checkExtension(browser) {
	    return new Promise(function (resolve, reject) {
	        var result = new Object();
	        if (Browser.Chrome == browser) {
	            resolve(browser);
	        } else if (Browser.Edge == browser || Browser.Firefox == browser) {
	            if (document.getElementById(extensionName)) {
	                resolve(browser);
	            } else {
	                result.errorcode = 1;
	                result.result = "Extension does not exist!";
	                reject(result);
	            }
	        } else {
	            result.errorcode = 1;
	            result.result = "Only support Chrome/Edge/Firefox";
	            reject(result);
	        }
	    });
	}
	
	function nmCryptokit(browser) {
	
	    this.browser = browser;
	};
	
	function GenerateRandomId() {
	    var charstring = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
	    var maxPos = charstring.length;
	    var randomId = '';
	    for (var i = 0; i < 10; i++) {
	        randomId += charstring.charAt(Math.floor(Math.random() * maxPos));
	    }
	    return randomId;
	}
	
	nmCryptokit.prototype.init = function () {
	
	    var browser = this.browser;
	
	    return checkExtension(browser).then(function (browser) {
	        var request = new Object();
	        request.action = "connect";
	        request.host = productID;
	        return SendMessage(browser, request);
	    }).then(function () {
	        var request = new Object();
	        request.action = "checkHost";
	        return SendMessage(browser, request);
	    });
	};
	
	nmCryptokit.prototype.uninit = function () {
	
	    var request = new Object();
	    request.action = "disconnect";
	    request.host = productID;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_GetCSPInfo = function () {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    funcInfo.function = "CFCA_GetCSPInfo";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_SetCSPInfo = function (lKeyLength, bstrCSPName) {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    paramArr.push(lKeyLength);
	    paramArr.push(bstrCSPName);
	
	    funcInfo.function = "CFCA_SetCSPInfo";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_SetKeyAlgorithm = function (bstrKeyAlgorithm) {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    paramArr.push(bstrKeyAlgorithm);
	
	    funcInfo.function = "CFCA_SetKeyAlgorithm";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_ImportEncryptCert = function (bstrEncryptedPrivateKey, bstrP7Cert, bstrContainerName, lEncryptCertPrivateKeyFlags) {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    paramArr.push(bstrEncryptedPrivateKey);
	    paramArr.push(bstrP7Cert);
	    paramArr.push(bstrContainerName);
	    paramArr.push(lEncryptCertPrivateKeyFlags);
	
	    funcInfo.function = "CFCA_ImportEncryptCert";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_GetContainer = function () {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    funcInfo.function = "CFCA_GetContainer";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_ImportSignCert = function (lCertType, bstrSignCert, bstrContainerName) {
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    paramArr.push(lCertType);
	    paramArr.push(bstrSignCert);
	    paramArr.push(bstrContainerName);
	
	    funcInfo.function = "CFCA_ImportSignCert";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_PKCS10CertRequisition = function (bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags) {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    paramArr.push(bstrSubjectDN);
	    paramArr.push(lCertType);
	    paramArr.push(lSignPrivateKeyGenerateFlags);
	
	    funcInfo.function = "CFCA_PKCS10CertRequisition";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_GetAllCertInfo = function () {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    funcInfo.function = "CFCA_GetAllCertInfo";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.CFCA_GetVersion = function () {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var paramArr = new Array();
	    var randomId = GenerateRandomId();
	
	    funcInfo.function = "CFCA_GetVersion";
	    funcInfo.params = paramArr;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};
	
	nmCryptokit.prototype.GetLastErrorDesc = function () {
	
	    var request = new Object();
	    var funcInfo = new Object();
	    var randomId = GenerateRandomId();
	
	    funcInfo.function = "GetLastErrorDesc";
	    funcInfo.params = null;
	    funcInfo.randomId = randomId;
	
	    request.action = "invoke";
	    request.funcInfo = funcInfo;
	
	    return SendMessage(this.browser, request);
	};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rtSdCommon = __webpack_require__(61);
	
	Object.assign(_rtSdCommon.sgiConfig, window.sgiSrvUrl);
	
	// sgiConfig.popMessageMaxCount = 1;//popMessage方法弹出消息最大数量
	_rtSdCommon.sgiConfig.prmRelease = false; //参数工厂获取参数时是否优先发布版本
	_rtSdCommon.sgiConfig.keyPre_app = (0, _rtSdCommon.uuid)(6); //项目每次加载生成一个独立标识
	_rtSdCommon.sgiConfig.keyPre_uuid = _rtSdCommon.sgiConfig.keyPre_app + "-UUID-"; //storage存放uuid的前缀
	_rtSdCommon.sgiConfig.keyPre_echo = _rtSdCommon.sgiConfig.keyPre_app + "-ECHO-"; //storage存放回显缓存的前缀
	if (!_rtSdCommon.sgiConfig.abb_project) _rtSdCommon.sgiConfig.abb_project = "MDC"; //项目缩写名称，用于cookie前缀标识等
	
	//给类添加公共方法
	window.sgiConfig = _rtSdCommon.sgiConfig;
	
	//客群配置
	var custGroupConfig = custGroupConfig || {};
	window.custGroupConfig = _extends({}, custGroupConfig, {
	    valueTypePrm: "workbench_param_sc_0002"
	});

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ParamMngDef = __webpack_require__(523);
	
	var _ParamMngDef2 = _interopRequireDefault(_ParamMngDef);
	
	var _echarts = __webpack_require__(8);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _OperationLogMonitor = __webpack_require__(994);
	
	var _OperationLogMonitor2 = _interopRequireDefault(_OperationLogMonitor);
	
	var _OperationLogStatistics = __webpack_require__(995);
	
	var _OperationLogStatistics2 = _interopRequireDefault(_OperationLogStatistics);
	
	var _BatchTimeConfig = __webpack_require__(993);
	
	var _BatchTimeConfig2 = _interopRequireDefault(_BatchTimeConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 需要导出哪些自定义组件，写在这里，可以通过tool.createElement("key", props, children, true)来获取组件
	var sgiCustomModule = {
		ParamMngDef: _ParamMngDef2.default,
		//echarts
		sgiEcharts: _echarts2.default,
		//工作台
	
		OperationLogMonitor: _OperationLogMonitor2.default,
		OperationLogStatistics: _OperationLogStatistics2.default,
	
		BatchTimeConfig: _BatchTimeConfig2.default
	
		//给类添加公共方法
	};Object.assign(window.sgiCustomModule, sgiCustomModule);

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRouter = __webpack_require__(116);
	
	var _routes = __webpack_require__(288);
	
	var _FilePreview = __webpack_require__(952);
	
	var _big = __webpack_require__(1575);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _utils = __webpack_require__(949);
	
	var _CrpytoKit = __webpack_require__(944);
	
	var CrpytoKit = _interopRequireWildcard(_CrpytoKit);
	
	var _index = __webpack_require__(954);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.CrpytoKit = CrpytoKit;
	tool.UpdateCertificate = function (cb) {
	  var data = { p10: '', userId: '', clientId: '' };
	  CrpytoKit.PKCS10Requisition_SingleCert().then(function (p10) {
	    data.p10 = p10;
	    return CrpytoKit.GetContainer();
	  }).then(function (d) {
	    data.clientId = d.result;
	    console.log(data);
	    var res = {
	      errorcode: '0000',
	      data: data
	    };
	    cb(res);
	  }).catch(function (err) {
	    var resObj = {
	      errorcode: '1111',
	      result: err.result
	    };
	    cb(resObj);
	  });
	};
	tool.DownloadCert = function (params, cb) {
	  CrpytoKit.InstallCert(1, params).then(function (res) {
	    var resObj = {
	      errorcode: '0000',
	      result: res.toString()
	    };
	    console.log(res);
	    cb(resObj);
	  }).catch(function (err) {
	    console.log(err);
	    var resObj = {
	      errorcode: '1111',
	      result: err.result
	    };
	    cb(resObj);
	  });
	};
	tool.getCfcaParmas = function (cb) {
	  function success(res) {
	    console.log(res);
	  }
	  var data = { p10: '', userId: '', clientId: '' };
	  // 获取p10
	  CrpytoKit.PKCS10Requisition_SingleCert().then(function (d) {
	    data.p10 = d;
	    return CrpytoKit.GetContainer(); // 获取keyname
	  }).then(function (d) {
	    data.clientId = d.result;
	    var res = {
	      code: '0000',
	      data: data
	    };
	    cb(res);
	  }).catch(function (err) {
	    console.log(err);
	    var res = {
	      errorcode: '1111',
	      result: err.result
	    };
	    cb(res);
	  });
	};
	// 格式化方法
	tool.cnyFormat = _utils.cnyFormat;
	tool.intToZH = _utils.intToZH;
	tool.getDays = _utils.getDays;
	tool.Big = _big2.default;
	// 自定请求临时预览
	tool.dynamicPreview = _FilePreview.dynamicPreview;
	tool.loading = _index.loading;
	// id预览
	tool.PreviewFileAysnc = _FilePreview.PreviewFileAysnc;
	// 直接地址预览
	tool.PreviewFile = _FilePreview.PreviewFile;
	// 跨域下载图片
	function downloadIamge(imgsrc, name) {
	  // 下载图片地址和图片名
	  var image = new Image();
	  // 解决跨域 Canvas 污染问题
	  image.setAttribute('crossOrigin', 'anonymous');
	  image.onload = function () {
	    var canvas = document.createElement('canvas');
	    canvas.width = image.width;
	    canvas.height = image.height;
	    var context = canvas.getContext('2d');
	    context.drawImage(image, 0, 0, image.width, image.height);
	    var url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
	
	    var a = document.createElement('a'); // 生成一个a元素
	    var event = new MouseEvent('click'); // 创建一个单击事件
	    a.download = name || 'photo'; // 设置图片名称
	    a.href = url; // 将生成的URL设置为a.href属性
	    a.dispatchEvent(event); // 触发a的单击事件
	  };
	  image.src = imgsrc;
	}
	tool.downloadIamgeByUrl = downloadIamge;
	// 预览cfca协议
	tool.PreviewCfca = function () {
	  (0, _FilePreview.PreviewFileAysnc)('1498906563264122880', 'application/pdf');
	};
	// 密码加密
	tool.encrypt = function (val) {
	  var encrypt = new JSEncrypt();
	  encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----\n    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrqKuQ6jaDcJbOnLGBP6RG7rcR6FcS67HR88h+\n    OURF9KpQ5CEaapxgMkFP/z1hrQ2bMGC3x5jEAdX/YruPjsw+2PiXaoisRUGbGAFf4fnD+aoccY22\n    wHBXxCqk/+4faxOF3lT2Xa7HDoE4wPTjL7eV00VfmRKQBpl3JEpwDYGx3wIDAQAB\n    -----END PUBLIC KEY-----');
	  return encrypt.encrypt(val);
	};
	
	// 密码加密
	tool.getUTF8Bytes = function (str, radix, offset) {
	  var bytes = [];
	  var len = str.length;
	  for (var i = 0; i < len; ++i) {
	    var code = str.charCodeAt(i);
	    if (code >= 0x10000 && code <= 0x10ffff) {
	      bytes.push(code >> 18 | 0xf0); // 第一个字节
	      bytes.push(code >> 12 & 0x3f | 0x80);
	      bytes.push(code >> 6 & 0x3f | 0x80);
	      bytes.push(code & 0x3f | 0x80);
	    } else if (code >= 0x800 && code <= 0xffff) {
	      bytes.push(code >> 12 | 0xe0);
	      bytes.push(code >> 6 & 0x3f | 0x80);
	      bytes.push(code & 0x3f | 0x80);
	    } else if (code >= 0x80 && code <= 0x7ff) {
	      bytes.push(code >> 6 | 0xc0);
	      bytes.push(code & 0x3f | 0x80);
	    } else {
	      bytes.push(code);
	    }
	  }
	
	  return bytes.map(function (item) {
	    var displacement = item ^ 5;
	    return displacement.toString(radix || 2);
	  }).join(',');
	};
	
	tool.jumpNewView = function (path, prams) {
	  var pramsStr = '';
	  for (var key in prams) {
	    pramsStr += key + '=' + prams[key] + '&';
	  }
	  var win = window.open(path + '?' + pramsStr, '_blank');
	  win.focus();
	};
	
	/**
	 * 平台commonClient.simplecall方法
	 * @param req 服务输入
	 * @param url 调用地址
	 * @param logMsg 控制台日志
	 */
	tool.simpleCall = function (req, url, logMsg) {
	  var datas = void 0;
	  if (!url) {
	    tool.sgiLogger.error('服务调用地址为空！');return;
	  }
	  var success = function success(res) {
	    if (res && res.head && res.head.code == '0000') {
	      tool.sgiLogger.info(logMsg || '服务调用成功 res :', res);
	      datas = res.body || true;
	    } else {
	      tool.sgiLogger.error(logMsg || '服务调用失败！', res.head ? res.head.msg : null);
	      tool.popMessage(res && res.head && res.head.msg ? res.head.msg : '服务器繁忙，请稍后！', 'warn');
	      datas = false;
	    }
	  };
	  commonClient.simplecall(url, req, success);
	  return datas;
	};
	
	/** *
	*  简版的分批查询
	* @param req 服务请求对象
	* @param url 服务调用地址
	* @param tb_id 列表绑定的控件id
	* @param tb_db 列表绑定的实例名
	* @param objFct 当前对象工厂
	*
	***/
	tool.simpBatchCall = function (req, url, tb_id, tb_db, objFct) {
	  var respFunc = function respFunc(res) {
	    if (res && res.head && res.head.code === '0000') {
	      tool.sgiLogger.info('数据查询成功 res :', res);
	      objFct.set(tb_db, res.body || []);
	      tool.refreshTable(tb_id, objFct, true);
	    } else {
	      tool.sgiLogger.error('数据查询失败 res :', res);
	      tool.popMessage('数据查询失败，请稍后重试！', 'warning');
	    }
	  };
	  tool.tableBatchSelect(tb_id, objFct, url, req, respFunc, true);
	};
	
	var extra = {};
	
	tool.setLoginInfoExtra = function (info) {
	  Object.assign(extra, info);
	};
	
	tool.getLoginInfo = function () {
	  return _extends({
	    appId: 'miap',
	    token: tool.getCookie('token'),
	    chnlId: '01'
	  }, extra);
	};
	
	tool.getHeaderInfo = function () {
	  return {
	    appId: 'miap',
	    token: tool.getCookie('token'),
	    chnlId: '01'
	  };
	};
	
	tool.popUIByUcv = function (uid, transferData, curtitle) {
	  // uid配置到你的那个路由方法
	
	  // uid
	  if (!uid) {
	    return;
	  }
	
	  // json判断，如果不是json，回去
	  if (!transferData) {
	    transferData = {};
	  }
	  // if (!transferData.isJSON()) {
	  //     transferData = {};
	  // }
	  transferData.uid = uid;
	  transferData.name = curtitle;
	  var path = '/main/' + uid;
	  // path,UIPreview
	  (0, _routes.addNewPath)(path);
	
	  tool.jumpByBrowserHistory(path, transferData);
	  // window.MainBreadcrumb.pushItem({ path: path, uid: uid, name: curtitle });
	};
	// 修改 不启用了
	// tool.popUIByUcv = function (uid, objFct, curtitle) {
	//     //uid配置到你的那个路由方法
	
	//     let path = "/main/" + uid;
	//     //path,UIPreview
	//     addNewPath(path);
	
	//     //由相应的平台自主实现,无法做公共的
	//     browserHistory.push({
	//         pathname: path,
	//         state: {
	//             uid: uid, objFct: objFct,
	//             title: curtitle,
	//             popUIByUcv: true
	//         }
	//     });
	
	//     window.MainBreadcrumb.pushItem({ path: path, uid: uid, title: curtitle });
	
	// };
	
	tool.goBack = function (n) {
	  if (n) {
	    _reactRouter.browserHistory.go(n);
	    MainBreadcrumb.goBack(n);
	  } else {
	    _reactRouter.browserHistory.goBack();
	    MainBreadcrumb.goBack();
	  }
	};
	
	tool.go = function (n) {
	  _reactRouter.browserHistory.go(n);
	  MainBreadcrumb.goBack(n);
	};
	
	tool.logout = function () {
	  tool.deleteCookie('id');
	  tool.deleteCookie('name');
	  tool.deleteCookie('mbl');
	  tool.deleteCookie('userType');
	  tool.deleteCookie('nickname');
	  tool.deleteCookie('token');
	  tool.deleteCookie('enterpriseId');
	  tool.deleteCookie('enterpriseName');
	  tool.deleteCookie('loginInfo');
	  tool.deleteCookie('workbenchId');
	  console.log('tool.logout============');
	
	  var openSso = tool.getCookie('openSso');
	  var service = window.location.protocol + '//' + window.location.host + '/';
	  if (openSso) {
	    var url = sgiConfig.casBaseUrl + '/logout?service=' + encodeURIComponent(service);
	    console.log('useSso.ts  ssoLoginOut  url: ', url);
	    window.location.href = url;
	    return;
	  }
	  // tool.popSingleUI('/');
	  // tool.popSingleUI('/?openSso=false');
	  var path = openSso ? '/' : '/?openSso=false';
	  console.log('path', path);
	  tool.popSingleUI(path);
	  // tool.popSingleUI('/');
	};
	
	tool.goError = function (ErrContent) {
	  ErrContent.name = '错误信息';
	  tool.jumpByBrowserHistory('/main/cmmnError', { ErrContent: ErrContent });
	};
	
	tool.popSingleUI = function (path, values, curtitle) {
	  // browserHistory.push({
	  //     pathname: path,
	  //     state: values
	  // });
	  // window.MainBreadcrumb.pushItem({ path: path, uid: '', title: curtitle });
	  if (!values) {
	    values = {};
	  }
	  values.uid = null;
	  values.name = curtitle;
	  tool.jumpByBrowserHistory(path, values);
	  // if (window.MainBreadcrumb) {
	  //     window.MainBreadcrumb.pushItem({ path: path, uid: undefined, name: curtitle });
	  // }
	};
	
	// tool.setCookie = function (key, val, time) {//设置cookie方法
	//     if (!val) {
	//         val = "";
	//     }
	//     var time = arguments[2] ? arguments[2] : 30;
	//     var date = new Date(); //获取当前时间
	//     var expiresDays = time;  //将date设置为n天以后的时间
	//     date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); //格式化为cookie识别的时间
	//     document.cookie = sgiConfig.abb_project + "-" + key + "=" + val + ";expires=" + date.toGMTString() + ";path=/";  //设置cookie
	// }
	
	// tool.getCookie = function (key) {//获取cookie方法
	//     /*获取cookie参数*/
	//     var getCookie = document.cookie.replace(/[ ]/g, "");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
	//     var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
	//     var tips;  //声明变量tips
	//     for (var i = 0; i < arrCookie.length; i++) {   //使用for循环查找cookie中的tips变量
	//         var arr = arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
	//         if (sgiConfig.abb_project + "-" + key == arr[0]) {  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
	//             tips = arr[1];   //将cookie的值赋给变量tips
	//             break;   //终止for循环遍历
	//         }
	//     }
	//     return tips;
	// }
	
	tool.deleteAllCookie = function () {
	  var getCookie = document.cookie.replace(/[ ]/g, '');
	  var arrCookie = getCookie.split(';'); // 将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
	  for (var i = 0; i < arrCookie.length; i++) {
	    // 使用for循环查找cookie中的tips变量
	    var arr = arrCookie[i].split('='); // 将单条cookie用"等号"为标识，将单条cookie保存为arr数组
	    tool.deleteCookie(arr[0]);
	  }
	};
	
	// tool.deleteCookie = function (key) { //删除cookie方法
	//     var date = new Date(); //获取当前时间
	//     date.setTime(date.getTime() - 10000); //将date设置为过去的时间
	//     tool.sgiLogger.info(date.toGMTString())
	//     let path = ";path=/";
	//     document.cookie = sgiConfig.abb_project + "-" + key + "=v; expires =" + date.toGMTString() + path;//设置cookie
	
	// }
	// // 批量删除cookie-根据前缀
	// tool.removeCookieByPrefix = function (prefix) {
	//     if (!prefix) return;
	//     let preLength = prefix.length;
	//     var getCookie = document.cookie.replace(/[ ]/g, "");
	//     var arrCookie = getCookie.split(";");
	//     for (var i = 0; i < arrCookie.length; i++) {
	//         var arr = arrCookie[i].split("=");
	//         let key = arr[0];
	//         let pre = key.substr(0, preLength);
	//         if (prefix === pre) {
	//             document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
	//             break;
	//         }
	//     }
	// }
	
	
	tool.getCurrentDate = function () {
	  var date = new Date();
	  var seperator1 = '-';
	  var seperator2 = ':';
	  var month = date.getMonth() + 1;
	  var strDate = date.getDate();
	  if (month >= 1 && month <= 9) {
	    month = '0' + month;
	  }
	  if (strDate >= 0 && strDate <= 9) {
	    strDate = '0' + strDate;
	  }
	  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + date.getHours() + seperator2 + date.getMinutes() + seperator2 + date.getSeconds();
	  return currentdate;
	};
	
	var getLastRoute = function getLastRoute(data, path) {
	  var lastRoute = {};
	  for (var i = 0; i < data.length; i++) {
	    if (data[i].children) {
	      lastRoute = _extends({}, lastRoute, getLastRoute(data[i].children, path));
	    } else if (data[i].describe == path) {
	      lastRoute = _extends({}, lastRoute, data[i]);
	    }
	  }
	  return lastRoute;
	};
	
	// tool.BreadcrumbArr = [
	//     {
	//         path: "/main",
	//         name: "首页",
	//         uid: null
	//     }
	// ];
	tool.initBreadcrumbArr = function () {
	  window.MainBreadcrumb.refresh([]);
	};
	tool.addBreadcrumbArr = function (path, data) {
	  if (window.MainBreadcrumb) {
	    window.MainBreadcrumb.pushItem({ path: path, uid: data.uid, name: data.name });
	  }
	};
	tool.getRouterQuery = function (uuid) {
	  var data = JSON.parse(unescape(tool.sgiStorage.get(sgiConfig.keyPre_uuid + uuid)));
	  return data;
	};
	tool.jumpByBrowserHistory = function (path, data) {
	  if (!path) {
	    return;
	  }
	
	  tool.sgiLogger.info(path, data);
	  tool.addBreadcrumbArr(path, data);
	
	  if (window.menuByServer) {
	    tool.sgiLogger.info(menuByServer);
	    var res = getLastRoute(menuByServer, path);
	    (0, _routes.saveLastVisitRoute)(res);
	  }
	
	  if (!data) {
	    _reactRouter.browserHistory.push({
	      pathname: path,
	      query: {}
	    });
	    return;
	  }
	
	  var key = tool.uuid();
	  var value = escape(JSON.stringify(data));
	  tool.sgiStorage.set(sgiConfig.keyPre_uuid + key, value);
	  _reactRouter.browserHistory.push({
	    pathname: path,
	    query: { uuid: key }
	  });
	};
	
	tool.parseForBrowserHistory = function (props) {
	  tool.sgiLogger.info(props);
	
	  var location = props.location;
	
	  if (!location) {
	    return {};
	  }
	
	  var url = location.search; // 获取url中"?"符后的字串
	  var theRequest = new Object();
	  if (url.indexOf('?') != -1) {
	    var str = url.substr(1);
	    var strs = str.split('&');
	    for (var i = 0; i < strs.length; i++) {
	      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
	    }
	  }
	
	  return JSON.parse(unescape(tool.sgiStorage.get(sgiConfig.keyPre_uuid + theRequest.uuid)));
	};
	
	var callbackPool = {
	  allCallbackPool: {
	    offlineMsg: {
	      msg: [],
	      open: false
	    },
	    noticeMsg: {
	      msg: [],
	      open: false
	    },
	    onlineMsg: {
	      chatView: false,
	      open: false
	    }
	  },
	  setCallbackInPool: function setCallbackInPool(type, callback, openFlg) {
	    if (type == 'bellNum') {
	      callbackPool.allCallbackPool.bellCallBack = callback; // 铃铛的回调函数
	    } else if (type == 'onlineMsg') {
	      // 打开消息对话窗的回调事件
	      callbackPool.allCallbackPool.onlineMsg.open = openFlg;
	      if (callback) {
	        callbackPool.allCallbackPool.onlineMsg.callback = callback; // 对话窗的回调事件
	      }
	    } else if (type == 'offlineMsg') {
	      // 非对话窗口的消息
	      callbackPool.allCallbackPool.offlineMsg.open = openFlg;
	      if (callback) {
	        callbackPool.allCallbackPool.offlineMsg.callback = callback; // 对话窗的回调事件
	      }
	    } else if (type == 'noticeMsg') {
	      // 通知类消息
	      callbackPool.allCallbackPool.noticeMsg.open = openFlg;
	      if (callback) {
	        callbackPool.allCallbackPool.noticeMsg.callback = callback; // 对话窗的回调事件
	      }
	    }
	  },
	  getCallbackFromPool: function getCallbackFromPool(type, msg) {
	    tool.sgiLogger.info('执行回调函数--------------------------', callbackPool.allCallbackPool);
	    // 如果消息类型是P2P、广播、通知则增加铃铛显示
	    if (type == '02' || type == '03' || type == '04') {
	      callbackPool.allCallbackPool.bellCallBack(); // 铃铛的回调函数
	    }
	    if (type == '02' || type == '03') {
	      // 将消息追加到列表头部
	
	      callbackPool.allCallbackPool.offlineMsg.msg.unshift(msg);
	      if (callbackPool.allCallbackPool.offlineMsg.callback) {
	        callbackPool.allCallbackPool.offlineMsg.callback(callbackPool.allCallbackPool.offlineMsg.msg);
	      }
	      // if(!callbackPool.allCallbackPool.offlineMsg.open){
	      //     callbackPool.allCallbackPool.offlineMsg.msg.unshift(msg);
	      // }else{
	      // callbackPool.allCallbackPool.offlineMsg.callback(msg);
	      // }
	    } else if (type == '04') {
	      // 将消息追加到列表头部
	      callbackPool.allCallbackPool.noticeMsg.msg.unshift(msg);
	      if (callbackPool.allCallbackPool.noticeMsg.callback) {
	        callbackPool.allCallbackPool.noticeMsg.callback(callbackPool.allCallbackPool.noticeMsg.msg);
	      }
	      // if(!callbackPool.allCallbackPool.noticeMsg.open){
	
	      // }else{
	      //     callbackPool.allCallbackPool.noticeMsg.callback(msg);
	      // }
	    }
	  },
	
	  addCallback: function addCallback(type, contentType, callback) {
	    if (!type || !contentType) return;
	    if (!callbackPool.allCallbackPool[type]) callbackPool.allCallbackPool[type] = {};
	    callbackPool.allCallbackPool[type][contentType] = callback;
	  },
	  getCallback: function getCallback(type, contentType) {
	    if (!type || !contentType) return null;
	    if (!callbackPool.allCallbackPool[type]) return null;
	    return callbackPool.allCallbackPool[type][contentType];
	  }
	};
	
	/**
	 * 客户化参数信息保存
	 *  @param {object} root 需要保存的参数对象
	 * 	@param {boolean} [async=false]	是否是同步
	 *  @param {funciton} [callback=fun]	异步的回调函数
	 *  @return {number} 0-成功，-1-失败
	 */
	tool.saveCustParams = function (root, async, callback, reqType) {
	  if (!root) {
	    return null;
	  }
	  if (!root && (typeof root === 'undefined' ? 'undefined' : _typeof(root)) !== 'object') {
	    return null;
	  }
	
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	
	  if (root) {
	    request.body = root;
	  }
	  var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	  if (!reqType) {
	    reqType = 'POST';
	    header['Content-Type'] = 'application/json; charset=utf-8';
	  }
	  request = tool.jsonToStr(request);
	
	  sgiPfClient.restcall(sgiConfig.pf + '/cust/param/save', reqType, request, header, async || false, sucfunc);
	  function sucfunc(res) {
	    if (res && res.head && res.head.code == '0000') {
	      root = res.body;
	      tool.sgiLogger.info('保存成功', res.body);
	      tool.popMessage('保存成功', 'success');
	
	      Object.assign(root, newprm);
	    } else {
	      root = null;
	      tool.sgiLogger.info('保存失败！', res.head ? res.head.msg : null);
	      tool.popMessage(res.head.msg, 'error');
	    }
	
	    if (callback) {
	      callback(root);
	    }
	  }
	  return root;
	};
	/**
	* 通过sc客户化参数信息获取
	* @param {string} ap
	* @param {string} [sc]
	* @param {string} [batch] 是否分批
	* @param {boolean} [async=false]	是否是同步
	* @param {funciton} [callback=fun]	异步的回调函数
	* @returns {object[]} 返回符合条件的参数数组
	*/
	tool.postCustParamBySc = function (ap, sc, async, reqType, callback) {
	  if (!ap && !sc) {
	    return null;
	  }
	
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	
	  if (true) {
	    request.body = {};
	  }
	
	  var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	  if (!reqType) {
	    reqType = 'POST';
	    header['Content-Type'] = 'application/json; charset=utf-8';
	  }
	  request = tool.jsonToStr(request);
	
	  var prms = [];
	  sgiPfClient.restcall(sgiConfig.pf + ('/cust/param/ap/' + ap + '/sc/' + sc), reqType, request, header, async || false, sucfunc);
	  function sucfunc(res) {
	    if (res && res.head && res.head.code == '0000') {
	      prms = res.body || [];
	    } else {
	      tool.sgiLogger.info('查询失败', res.head ? res.head.msg : null);
	      tool.popMessage(res.head.msg, 'error');
	    }
	
	    if (callback) {
	      callback(prms);
	    }
	  }
	  return prms;
	};
	/**
	* 通过id客户化参数信息获取
	* @param {string} [id]
	* @param {string} [batch] 是否分批
	* @param {boolean} [async=false]	是否是同步
	* @param {funciton} [callback=fun]	异步的回调函数
	* @returns {object[]} 返回符合条件的参数数组
	*/
	tool.getCustParamById = function (id, async, reqType, callback) {
	  if (!id) {
	    return null;
	  }
	
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	
	  if (true) {
	    request.body = {};
	  }
	
	  var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	  if (!reqType) {
	    reqType = 'POST';
	    header['Content-Type'] = 'application/json; charset=utf-8';
	  }
	  request = tool.jsonToStr(request);
	
	  var prms = [];
	  sgiPfClient.restcall(sgiConfig.pf + ('/cust/param/id/' + id), reqType, request, header, async || false, sucfunc);
	  function sucfunc(res) {
	    if (res && res.head && res.head.code == '0000') {
	      prms = res.body;
	    } else {
	      tool.sgiLogger.info('查询失败', res.head ? res.head.msg : null);
	      tool.popMessage(res.head.msg, 'error');
	    }
	
	    if (callback) {
	      callback(prms);
	    }
	  }
	  return prms;
	};
	
	/**
	* 客户化参数信息列表获取
	* @param {object} ap
	* @param {string} [batch] 是否分批
	* @param {boolean} [async=false]	是否是同步
	* @param {funciton} [callback=fun]	异步的回调函数
	* @returns {object[]} 返回符合条件的参数数组
	*/
	tool.getCustParamsByCndt = function (ap, async, reqType, callback) {
	  if (!ap) {
	    return;
	  }
	
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	
	  if (ap) {
	    request.body = {
	      values: {
	        ap: ap
	      }
	    };
	  }
	  var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	  if (!reqType) {
	    reqType = 'POST';
	    header['Content-Type'] = 'application/json; charset=utf-8';
	  }
	  request = tool.jsonToStr(request);
	
	  var prms = [];
	  sgiPfClient.restcall(sgiConfig.pf + '/cust/param/list', reqType, request, header, async || false, sucfunc);
	  function sucfunc(res) {
	    if (res && res.head && res.head.code == '0000') {
	      prms = res.body;
	    } else {
	      tool.sgiLogger.info('查询失败', res.head ? res.head.msg : null);
	      tool.popMessage(res.head.msg, 'error');
	    }
	
	    if (callback) {
	      callback(prms);
	    }
	  }
	  return prms;
	};
	
	/**
	* 客户化参数信息列表,通过id集合删除
	* @param {array} data
	* @param {boolean} [async=false]	是否是同步
	* @param {funciton} [callback=fun]	异步的回调函数
	* @returns {object[]} 返回符合条件的参数数组
	*/
	tool.deleteCustParamByIds = function (data, async, reqType, callback) {
	  if (!data) {
	    return;
	  }
	
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	
	  if (data) {
	    request.body = data;
	  }
	  var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	  if (!reqType) {
	    reqType = 'POST';
	    header['Content-Type'] = 'application/json; charset=utf-8';
	  }
	  request = tool.jsonToStr(request);
	
	  var prms = [];
	  sgiPfClient.restcall(sgiConfig.pf + '/cust/param/del/ids', reqType, request, header, async || false, sucfunc);
	  function sucfunc(res) {
	    if (res && res.head && res.head.code == '0000') {
	      prms = res.body;
	      tool.sgiLogger.info('删除成功', res.body);
	      tool.popMessage('删除成功', 'success');
	    } else {
	      tool.sgiLogger.info('删除失败', res.head ? res.head.msg : null);
	      tool.popMessage(res.head.msg, 'error');
	    }
	
	    if (callback) {
	      callback(prms);
	    }
	  }
	
	  return prms;
	};
	
	/**
	* 客户化参数信息列表,根据SC删除
	* @param {string} ap
	* @param {string} sc
	* @param {boolean} [async=false]	是否是同步
	* @param {funciton} [callback=fun]	异步的回调函数
	* @returns {object[]} 返回符合条件的参数数组
	*/
	tool.deleteCustParamBySc = function (ap, sc, async, reqType, callback) {
	  if (!ap || !sc) {
	    return null;
	  }
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	
	  if (true) {
	    request.body = {};
	  }
	
	  var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	  if (!reqType) {
	    reqType = 'POST';
	    header['Content-Type'] = 'application/json; charset=utf-8';
	  }
	  request = tool.jsonToStr(request);
	
	  var prms = [];
	  sgiPfClient.restcall(sgiConfig.pf + ('/cust/param/del/ap/' + ap + '/sc/' + sc), reqType, request, header, async || false, sucfunc);
	  function sucfunc(res) {
	    if (res && res.head && res.head.code == '0000') {
	      prms = res.body;
	      tool.sgiLogger.info('删除成功', res.body);
	      tool.popMessage('删除成功', 'success');
	    } else {
	      tool.sgiLogger.info('删除失败', res.head ? res.head.msg : null);
	      tool.popMessage(res.head.msg, 'error');
	    }
	
	    if (callback) {
	      callback(prms);
	    }
	  }
	  return prms;
	};
	
	/**
	* 客户化参数信息列表,根据id删除
	* @param {string} id
	* @param {boolean} [async=false]	是否是同步
	* @param {funciton} [callback=fun]	异步的回调函数
	* @returns {object[]} 返回符合条件的参数数组
	*/
	tool.deleteCustParamById = function (id, async, reqType, callback) {
	  if (!id) {
	    return null;
	  }
	
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	
	  if (true) {
	    request.body = {};
	  }
	
	  var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	  if (!reqType) {
	    reqType = 'POST';
	    header['Content-Type'] = 'application/json; charset=utf-8';
	  }
	  request = tool.jsonToStr(request);
	
	  var prms = [];
	  sgiPfClient.restcall(sgiConfig.pf + ('/cust/param/del/id/' + id), reqType, request, header, async || false, sucfunc);
	  function sucfunc(res) {
	    if (res && res.head && res.head.code == '0000') {
	      prms = res.body;
	      tool.sgiLogger.info('删除成功', res.body);
	      tool.popMessage('删除成功', 'success');
	    } else {
	      tool.sgiLogger.info('删除失败', res.head ? res.head.msg : null);
	      tool.popMessage(res.head.msg, 'error');
	    }
	
	    if (callback) {
	      callback(prms);
	    }
	  }
	  return prms;
	};
	
	/**
	* 客户化参数信息列表添加
	* @param {string} ap
	* @param {array} data
	* @param {boolean} [async=false]	是否是同步
	* @param {funciton} [callback=fun]	异步的回调函数
	* @returns {object[]} 返回符合条件的参数数组
	*/
	tool.batchAddCustParams = function (ap, data, async, reqType, callback) {
	  if (!data || !ap) {
	    return;
	  }
	
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	
	  if (data) {
	    request.body = data;
	  }
	  var header = tool && tool.getHeaderInfo ? tool.getHeaderInfo() : {};
	  if (!reqType) {
	    reqType = 'POST';
	    header['Content-Type'] = 'application/json; charset=utf-8';
	  }
	  request = tool.jsonToStr(request);
	
	  var prms = [];
	  sgiPfClient.restcall(sgiConfig.pf + ('/cust/param/batch/ap/' + ap), reqType, request, header, async || false, sucfunc);
	  function sucfunc(res) {
	    if (res && res.head && res.head.code == '0000') {
	      prms = res.body;
	      tool.sgiLogger.info('添加成功', res.body);
	      tool.popMessage('添加成功', 'success');
	    } else {
	      tool.sgiLogger.info('添加失败', res.head ? res.head.msg : null);
	      tool.popMessage(res.head.msg, 'error');
	    }
	
	    if (callback) {
	      callback(prms);
	    }
	
	    return prms;
	  }
	};
	/** *
	* 消息类型 type
	* p2p消息 02/ 广播 03  / 通知类 04
	*/
	/** *
	* 内容类型 contentType
	*  01普通消息 / 业务类 02（业务类消息，需要根据消息内容中的uid属性，跳转到对应的页面上去）/
	*/
	
	tool.callbackPool = callbackPool;

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cnyFormat = cnyFormat;
	exports.intToZH = intToZH;
	exports.getDays = getDays;
	// 设置表单状态，并且刷新表单
	function setState(_ref, state) {
	    var id = _ref.id,
	        db = _ref.db;
	
	    var d = objFct.get(db);
	    objFct.set(db, Object.assign({}, d, state));
	    tool.refreshWV(id, objFct);
	}
	
	function cnyFormat(num, len, prefix) {
	    if (!num) return 0;
	    num = num * 1;
	    var c = num.toFixed(len).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	    if (prefix) {
	        c = prefix + ' ' + c;
	    }
	    //toFixed属于四舍五入，如果不需要，想直接舍去，可以使用Math.floor(5)先向下取整，再用toFixed。
	    return tool.createElement("span", null, c);
	}
	
	// 钱数转大写
	function intToZH(money) {
	    //汉字的数字
	    var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
	    //基本单位
	    var cnIntRadice = new Array('', '拾', '佰', '仟');
	    //对应整数部分扩展单位
	    var cnIntUnits = new Array('', '万', '亿', '兆');
	    //对应小数部分单位
	    var cnDecUnits = new Array('角', '分', '毫', '厘');
	    //整数金额时后面跟的字符
	    var cnInteger = '整';
	    //整型完以后的单位
	    var cnIntLast = '元';
	    //最大处理的数字
	    var maxNum = 999999999999999.9999;
	    //金额整数部分
	    var integerNum;
	    //金额小数部分
	    var decimalNum;
	    //输出的中文金额字符串
	    var chineseStr = '';
	    //分离金额后用的数组，预定义
	    var parts;
	    if (money === '') {
	        //不能用==
	        return '';
	    }
	    money = parseFloat(money);
	    if (money >= maxNum) {
	        //超出最大处理数字
	        return '';
	    }
	    if (money == 0) {
	        chineseStr = cnNums[0] + cnIntLast + cnInteger;
	        return chineseStr;
	    }
	    //转换为字符串
	    money = money.toString();
	    if (money.indexOf('.') == -1) {
	        integerNum = money;
	        decimalNum = '';
	    } else {
	        parts = money.split('.');
	        integerNum = parts[0];
	        decimalNum = parts[1].substr(0, 4);
	    }
	    //获取整型部分转换
	    if (parseInt(integerNum, 10) > 0) {
	        var zeroCount = 0;
	        var IntLen = integerNum.length;
	        for (var i = 0; i < IntLen; i++) {
	            var n = integerNum.substr(i, 1);
	            var p = IntLen - i - 1;
	            var q = p / 4;
	            var m = p % 4;
	            if (n == '0') {
	                zeroCount++;
	            } else {
	                if (zeroCount > 0) {
	                    chineseStr += cnNums[0];
	                }
	                //归零
	                zeroCount = 0;
	                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
	            }
	            if (m == 0 && zeroCount < 4) {
	                chineseStr += cnIntUnits[q];
	            }
	        }
	        chineseStr += cnIntLast;
	    }
	    //小数部分
	    if (decimalNum != '') {
	        var decLen = decimalNum.length;
	        for (var i = 0; i < decLen; i++) {
	            var n = decimalNum.substr(i, 1);
	            if (n != '0') {
	                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
	            }
	        }
	    }
	    if (chineseStr == '') {
	        chineseStr += cnNums[0] + cnIntLast + cnInteger;
	    } else if (decimalNum == '') {
	        chineseStr += cnInteger;
	    }
	    return chineseStr;
	}
	// 计算账期
	function getDays(startDate, endDate) {
	    if (!startDate || !endDate) return null;
	    var time = new Date(endDate) - new Date(startDate);
	    var oneDay = 24 * 60 * 60 * 1000;
	    var accountPeriod = time / oneDay;
	    return accountPeriod;
	}

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ChangePasswordC = function (_React$Component) {
	  _inherits(ChangePasswordC, _React$Component);
	
	  function ChangePasswordC() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChangePasswordC);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChangePasswordC.__proto__ || Object.getPrototypeOf(ChangePasswordC)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleSubmit = function (e) {
	      var me = _this;
	      e.preventDefault();
	      _this.props.form.validateFieldsAndScroll(function (err, values) {
	        if (!err) {
	          tool.sgiLogger.info('Received values of form: ', values);
	          _this.UamUserInfoQuery(values);
	        }
	      });
	    }, _this.handleConfirmPassword = function (rule, value, callback) {
	      var getFieldValue = _this.props.form.getFieldValue;
	
	      if (value && value !== getFieldValue('newPassword')) {
	        callback('两次输入不一致！');
	      }
	
	      // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
	      callback();
	    }, _this.jumpUrl = function (params) {
	      // tool.popSingleUI('/')
	      tool.goBack(-1);
	      // browserHistory.push({
	      //   pathname: '/'
	      // });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChangePasswordC, [{
	    key: 'encrypt',
	    value: function encrypt(val) {
	      if (!sgiConfig.PublicKey) return val;
	      var encrypt = new JSEncrypt();
	      encrypt.setPublicKey(sgiConfig.PublicKey);
	      return encrypt.encrypt(val);
	    }
	  }, {
	    key: 'UamUserInfoQuery',
	    value: function UamUserInfoQuery(values) {
	      console.log(values);
	      var req = {
	        "loginPwd": this.encrypt(values.oldPassword),
	        "newPwd": this.encrypt(values.newPassword),
	        // userId: tool.getCookie('userId')
	        "userNam": values.userNam
	      };
	      console.log(req);
	      var success = function success(res) {
	        console.log(res);
	        tool.sgiLogger.info(res, 'UamUserInfoQuery');
	        if (res && res.head.code == "0000") {
	          // 退出  重新登录
	          tool.popMessage('操作成功，请重新登录', "success");
	          tool.popSingleUI('/');
	        } else {
	          tool.popMessage(res.head.msg, "warning");
	          return;
	        }
	      };
	      var url = sgiSrvUrl.service_uam + "/user/chngpwd/not/login";
	      console.log('url', url);
	      commonClient.simplecall(url, req, success);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: {
	          xs: { span: 24 },
	          sm: { span: 6 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 18 }
	        }
	      };
	      var tailFormItemLayout = {
	        wrapperCol: {
	          xs: {
	            span: 24,
	            offset: 0
	          },
	          sm: {
	            span: 16,
	            offset: 8
	          }
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '420px', margin: '100px auto 0' } },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, {
	              label: '\u7528\u6237\u540D'
	            }),
	            getFieldDecorator('userNam', {
	              rules: [{
	                required: true, message: '请填写用户名'
	              }]
	            })(_react2.default.createElement(_antd.Input, null))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, {
	              label: '\u65E7\u5BC6\u7801'
	            }),
	            getFieldDecorator('oldPassword', {
	              rules: [{
	                required: true, message: '请填写旧密码!'
	              }]
	            })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, {
	              label: '\u65B0\u5BC6\u7801'
	            }),
	            getFieldDecorator('newPassword', {
	              rules: [{
	                required: true, message: '请填写新密码!' }, {
	                pattern: /^(?![A-Za-z0-9]+$)(?![a-z0-9\W]+$)(?![A-Za-z\W]+$)(?![A-Z0-9\W]+$)^.{8,16}$/,
	                message: '长度8-16位，必须包含数字、大写字母、小写字母、特殊字符'
	              }]
	            })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, {
	              label: '\u786E\u8BA4\u65B0\u5BC6\u7801'
	            }),
	            getFieldDecorator('confirmNewPassword', {
	              rules: [{
	                required: true, message: '请填写确认密码!'
	              }, {
	                validator: this.handleConfirmPassword
	              }]
	            })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            tailFormItemLayout,
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', htmlType: 'submit' },
	              '\u63D0 \u4EA4'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: this.jumpUrl, style: { marginLeft: '20px' } },
	              '\u53D6 \u6D88'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChangePasswordC;
	}(_react2.default.Component);
	
	var ChangePassword = _antd.Form.create()(ChangePasswordC);
	exports.default = ChangePassword;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _Login = __webpack_require__(2003);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _x = __webpack_require__(445);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _ChangePassword = __webpack_require__(950);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = _antd.Layout.Header,
	    Footer = _antd.Layout.Footer,
	    Content = _antd.Layout.Content;
	
	var index = function (_Component) {
	  _inherits(index, _Component);
	
	  function index() {
	    _classCallCheck(this, index);
	
	    return _possibleConstructorReturn(this, (index.__proto__ || Object.getPrototypeOf(index)).apply(this, arguments));
	  }
	
	  _createClass(index, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Layout,
	        { className: _Login2.default.loginLayout },
	        _react2.default.createElement(
	          Header,
	          { className: _Login2.default.loginHeader },
	          _react2.default.createElement(
	            'div',
	            { className: _Login2.default.loginTitle },
	            _react2.default.createElement('img', { className: _Login2.default.loginTitleImg, src: _x2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { onClick: function onClick() {
	                tool.popSingleUI('/');
	              }, className: _Login2.default.toLogin },
	            '\u8FD4\u56DE\u767B\u5F55'
	          )
	        ),
	        _react2.default.createElement(
	          Content,
	          { className: _Login2.default.loginContent },
	          _react2.default.createElement(_ChangePassword2.default, { formstate: 'asdasd' })
	        )
	      );
	    }
	  }]);
	
	  return index;
	}(_react.Component);
	
	exports.default = index;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dynamicPreview = exports.PreviewFileAysnc = exports.PreviewFile = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Previw = function (_Component) {
	  _inherits(Previw, _Component);
	
	  function Previw() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Previw);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Previw.__proto__ || Object.getPrototypeOf(Previw)).call.apply(_ref, [this].concat(args))), _this), _this.state = { visible: true }, _this.handleCancel = function (e) {
	      _this.setState({
	        visible: false
	      });
	    }, _this.handleOk = function () {
	      _this.setState({
	        visible: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Previw, [{
	    key: 'render',
	    value: function render() {
	      var visible = this.state.visible;
	      var _props = this.props,
	          filePath = _props.filePath,
	          type = _props.type;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          width: '900px',
	          bodyStyle: { padding: '10px 20px 30px' },
	          visible: visible,
	          onCancel: this.handleCancel,
	          onOk: this.handleOk,
	          footer: null,
	          title: '\u9884\u89C8',
	          centered: true },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '450px' } },
	          _react2.default.createElement('embed', { src: filePath, type: type, width: '100%', height: '100%' })
	        )
	      );
	    }
	  }]);
	
	  return Previw;
	}(_react.Component);
	
	var httpfn = function httpfn(option, cb) {
	  // let { url, data, method } = option
	  // const callback = (res) => {
	  //   console.log(res)
	  // }
	  // commonClient.simplecall(url, data, callback)
	
	
	  var url = option.url,
	      data = option.data,
	      method = option.method;
	
	  var request = { head: tool && tool.getLoginInfo ? tool.getLoginInfo() : {} };
	  if (data) {
	    request.body = data;
	  }
	  var xhr = new XMLHttpRequest();
	  xhr.open(method, url, true);
	  xhr.setRequestHeader('Content-Type', 'application/json');
	  xhr.responseType = "blob";
	  xhr.onload = function () {
	    if (this.status == 200) {
	      cb(this.response);
	    } else if (this.status == 404) {
	      tool.popMessage('无可预览文件', "error");
	    }
	  };
	  xhr.send(JSON.stringify(request));
	};
	
	var PreviewFile = exports.PreviewFile = function PreviewFile(filePath, type, callback) {
	  var div = document.createElement('div');
	  document.body.appendChild(div);
	
	  var cancelCallback = function cancelCallback() {
	    var result = _reactDom2.default.unmountComponentAtNode(div);
	    if (result && div.parentNode) {
	      div.parentNode.removeChild(div);
	    }
	    callback && callback();
	  };
	
	  _reactDom2.default.render(_react2.default.createElement(Previw, {
	    filePath: filePath,
	    type: type,
	    cancelCallback: cancelCallback
	  }), div);
	};
	
	function base64ToBlob(code) {
	  code = code.replace(/[\n\r]/g, '');
	  var raw = window.atob(code);
	  var rawLength = raw.length;
	  var uInt8Array = new Uint8Array(rawLength);
	  for (var i = 0; i < rawLength; ++i) {
	    uInt8Array[i] = raw.charCodeAt(i);
	  }
	  return new Blob([uInt8Array], { type: 'application/pdf' });
	}
	
	var PreviewFileAysnc = exports.PreviewFileAysnc = function PreviewFileAysnc(id) {
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "application/pdf";
	
	  // 判断是地址
	  var isUrl = id.indexOf('http') !== -1;
	  if (isUrl) {
	    return PreviewFile(id);
	  }
	
	  if (type === 'base64') {
	    var blob = base64ToBlob(id);
	    var blobURL = window.URL.createObjectURL(blob);
	    PreviewFile(blobURL);
	    return;
	  }
	  // 判断是文件流
	  console.log(id);
	  var callback = function callback(res) {
	    if (res) {
	      var filePath = URL.createObjectURL(new Blob([res], { type: "application/pdf" }));
	      PreviewFile(filePath, type);
	    }
	  };
	  httpfn({
	    url: sgiConfig.allUrl.filePreview + '/' + id,
	    data: null,
	    method: 'get'
	  }, callback);
	};
	
	var dynamicPreview = exports.dynamicPreview = function dynamicPreview(option) {
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "application/pdf";
	
	  console.log(option);
	  httpfn(option, function (res) {
	    if (res) {
	      var filePath = URL.createObjectURL(new Blob([res], { type: "application/pdf" }));
	      PreviewFile(filePath, type);
	    }
	  });
	};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cardConfig = {
	  width: 250,
	  title: {},
	  text: {
	    color: 'gray'
	  }
	};
	
	var textJsx = function textJsx(cfg) {
	  var map = {
	    '00': '草稿',
	    '01': '开信中',
	    '02': '转出中',
	    '10': '已生效',
	    '50': '到期待轧账',
	    '51': '已轧账/待清算',
	    '59': '轧账失败',
	    '60': '已清算',
	    '80': '到期',
	    '99': '作废'
	  };
	  var stutas = map[cfg.crdtStatus];
	  return '\n  <group>\n    <rect>\n      <rect style={{\n        width: ' + cardConfig.width + ',\n        height: 20,\n        fill: #00b34f,\n        radius: [6, 6, 0, 0],\n        cursor: \'move\',\n        stroke: #00b34f\n      }} draggable="true">\n        <text style={{\n          marginTop: 2,\n          marginLeft: 75,\n          textAlign: \'center\',\n          fontWeight: \'bold\',\n          fill: \'#fff\' }}>' + cfg.crdtCode + '</text>\n      </rect>\n      <rect style={{\n        width: ' + cardConfig.width + ',\n        stroke: #00b34f,\n        fill: \'rgba(24,144,255,0.15)\',\n        radius: [0, 0, 6, 6],\n      }}>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u6301\u6709\u4EBA: ' + cfg.creditorNam + '</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u725B\u4FE1\u9762\u989D: ' + cfg.crdtAmt + '</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u6301\u6709\u91D1\u989D: ' + cfg.usableAmt + '</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u878D\u8D44\u91D1\u989D: ' + cfg.fincAmt + '</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u8F6C\u51FA\u7D2F\u8BA1\u91D1\u989D: ' + cfg.tranAmt + '</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: ' + (cfg.crdtStatus == '99' ? 'red' : 'gray') + ', fontSize: 10}}>\u725B\u4FE1\u72B6\u6001: ' + stutas + '</text>\n      </rect>\n    </rect>\n  </group>\n  ';
	};
	
	var Supplier = function (_Component) {
	  _inherits(Supplier, _Component);
	
	  function Supplier() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Supplier);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Supplier.__proto__ || Object.getPrototypeOf(Supplier)).call.apply(_ref, [this].concat(args))), _this), _this.treeDataHandler = function (treeData) {
	      var data = {
	        nodes: [],
	        edges: []
	      };
	      data.nodes.push(_extends({}, treeData, {
	        id: treeData.crdtId
	      }));
	      function loopHandler(tree) {
	        if (!tree.children || tree.children.length == 0) return;
	        tree.children.map(function (el) {
	          data.nodes.push(_extends({}, el, {
	            id: el.crdtId
	          }));
	          data.edges.push({ source: el.parentId, target: el.crdtId });
	          loopHandler(el);
	        });
	      }
	      loopHandler(treeData);
	      console.log(data);
	      return data;
	    }, _this.createG6 = function (data) {
	
	      G6.registerNode('rect-jsx', {
	        jsx: textJsx
	      });
	
	      var container = document.getElementById('container');
	      var width = container.scrollWidth;
	      var height = container.scrollHeight || 500;
	      var graph = new G6.Graph({
	        container: 'container',
	        width: width,
	        height: height,
	        // fitCenter: true,
	        modes: {
	          default: [{
	            // 定义展开/收缩行为
	            type: 'collapse-expand'
	          }, 'drag-canvas', 'zoom-canvas']
	        },
	        defaultNode: {
	          type: 'rect-jsx',
	          labelCfg: {
	            style: {
	              fill: '#000000A6',
	              fontSize: 10
	            }
	          },
	          style: {
	            stroke: '#72CC4A',
	            width: 150
	          }
	        },
	        defaultEdge: {
	          // ...                 // 边的其他配置
	          type: 'polyline',
	          // 边样式配置
	          style: {
	            opacity: 0.6, // 边透明度
	            stroke: '#00b34f', // 边描边颜色
	            endArrow: true
	          }
	        },
	        layout: {
	          type: 'dagre', // 布局类型
	          rankdir: 'LR', // 自左至右布局，可选的有 H / V / LR / RL / TB / BT
	          nodesep: 60,
	          ranksep: 100,
	          sortByCombo: true
	          // direction: 'TB', // 自左至右布局，可选的有 H / V / LR / RL / TB / BT
	          // nodeSep: 50, // 节点之间间距
	          // rankSep: 100, // 每个层级之间的间距
	        }
	      });
	      graph.on('click', function (evt) {
	        var record = evt.item._cfg.model;
	        console.log(record);
	        tool.popUIByUcv('scfp_UI_053001', { record: record }, '信详情');
	      });
	      graph.data(data);
	      graph.render();
	
	      if (typeof window !== 'undefined') window.onresize = function () {
	        if (!graph || graph.get('destroyed')) return;
	        if (!container || !container.scrollWidth || !container.scrollHeight) return;
	        graph.changeSize(container.scrollWidth, container.scrollHeight);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Supplier, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.location.query.uuid;
	      var query = tool.getRouterQuery(uuid);
	      console.log(query.treeData);
	      var data = this.treeDataHandler(query.treeData);
	      this.createG6(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { onClick: function onClick() {
	              return tool.go(-1);
	            }, style: { cursor: 'pointer' } },
	          _react2.default.createElement(_antd.Icon, { type: 'arrow-left' }),
	          '\u8FD4\u56DE'
	        ),
	        _react2.default.createElement('div', { id: 'container' })
	      );
	    }
	  }]);
	
	  return Supplier;
	}(_react.Component);
	
	exports.default = Supplier;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loading = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(25);
	
	var _index = __webpack_require__(2004);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var timer = null;
	var container = 'spanerModal_outer';
	var wraper = 'spanerModal';
	// 关闭方法
	var close = function close() {
	  var outer = document.getElementById(container);
	  var inner = document.getElementById(wraper);
	  outer.removeChild(inner);
	  timer = null;
	};
	// 循环定时器
	var delay = function delay() {
	  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	  var beforeClose = arguments[1];
	
	  setTimeout(function () {
	    if (beforeClose) {
	      var done = function done() {
	        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (type) return close();
	        // 执行下个循环
	        return delay(time, beforeClose);
	      };
	      beforeClose(done);
	    } else {
	      close();
	    }
	  }, time * 1000);
	};
	
	var antIcon = _react2.default.createElement(_antd.Icon, { type: 'sync', style: { fontSize: 24 }, spin: true });
	
	var LoadingDom = function (_Component) {
	  _inherits(LoadingDom, _Component);
	
	  function LoadingDom() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LoadingDom);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoadingDom.__proto__ || Object.getPrototypeOf(LoadingDom)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      count: 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LoadingDom, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      timer = setInterval(function () {
	        var count = _this2.state.count;
	
	        if (count === 100) {
	          _this2.setState({
	            count: 0
	          });
	        } else {
	          _this2.setState(function (state) {
	            return {
	              count: state.count + 1
	            };
	          });
	        }
	      }, 330);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tip = _props.tip,
	          percent = _props.percent;
	      var count = this.state.count;
	
	      var computedTip = percent ? tip + count + ' %' : tip;
	      return _react2.default.createElement(
	        'div',
	        { id: wraper, className: 'ant-modal-mask' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ant-modal-wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.spaner_outer },
	            _react2.default.createElement(_antd.Spin, { tip: computedTip, className: _index2.default.spaner, spin: true, indicator: antIcon, size: 'large' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LoadingDom;
	}(_react.Component);
	
	var loading = exports.loading = function loading(_ref2, beforeClose) {
	  var visible = _ref2.visible,
	      time = _ref2.time,
	      _ref2$tip = _ref2.tip,
	      tip = _ref2$tip === undefined ? '数据正在同步中 ' : _ref2$tip,
	      _ref2$percent = _ref2.percent,
	      percent = _ref2$percent === undefined ? false : _ref2$percent;
	
	  // 关闭
	  if (!visible) {
	    if (!beforeClose) return close();
	    var done = function done() {
	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (type) return close();
	    };
	    return beforeClose(done);
	  }
	  // 判断loading节点是否存在，没有则创建节点
	  var div = null;
	  if (!document.getElementById(container)) {
	    div = document.createElement('div');
	    div.id = container;
	  } else {
	    div = document.getElementById(container);
	  }
	  document.body.appendChild(div);
	  // 延迟执行回调
	  if (time) {
	    delay(time, beforeClose);
	  }
	  _reactDom2.default.render(_react2.default.createElement(LoadingDom, { tip: tip, percent: percent }), div);
	};

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _index = __webpack_require__(2005);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LockPage = function (_Component) {
	  _inherits(LockPage, _Component);
	
	  function LockPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LockPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LockPage.__proto__ || Object.getPrototypeOf(LockPage)).call.apply(_ref, [this].concat(args))), _this), _this.unlock = function () {
	      // sessionStorage.setItem('islock','0')
	      // browserHistory.goBack()
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LockPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // sessionStorage.setItem('islock','1')
	      // this.props.history.listenBeforeLeavingRoute()
	      // console.log(this.props)
	      // this.props.router.setRouteLeaveHook(this.props.route, (nextLocation) => {
	      //   console.log('不让走-----------------')
	      //   // if (nextLocation.pathname.indexOf('wxConcernSuccess') >= 0) {
	      //   //   console.log('我离开了')
	      //   // }
	      //   // return false
	      // })
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log(this.props)
	      return _react2.default.createElement(
	        'div',
	        { className: _index2.default.outer },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'LockPage'
	        ),
	        _react2.default.createElement(
	          _antd.Button,
	          { onClick: this.unlock, type: 'primary' },
	          '\u89E3 \u9501'
	        )
	      );
	    }
	  }]);
	
	  return LockPage;
	}(_react.Component);
	
	exports.default = LockPage;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _rtSdCommon = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FirstLoginChgPwdC = function (_React$Component) {
	    _inherits(FirstLoginChgPwdC, _React$Component);
	
	    function FirstLoginChgPwdC(props) {
	        _classCallCheck(this, FirstLoginChgPwdC);
	
	        var _this = _possibleConstructorReturn(this, (FirstLoginChgPwdC.__proto__ || Object.getPrototypeOf(FirstLoginChgPwdC)).call(this, props));
	
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            _this.props.form.validateFields(function (err, values) {
	                if (!err) {
	                    // tool.sgiLogger.info('Received values of form: ', values);
	                    if (values.userPassword === values.confirmUserPassword) {
	                        values.userPassword = _rtSdCommon.tool.encrypt(values.userPassword);
	                        var req = {
	                            userPassword: values.userPassword
	                        };
	
	                        var success = function success(res) {
	                            // tool.sgiLogger.info(res, 'firstUpdatePassword')
	                            if (res && res.head.code == "0000") {
	                                _rtSdCommon.tool.setCookie("passwordStatus", "0", .5);
	                                _rtSdCommon.tool.popSingleUI('/main');
	                            } else {
	                                _antd.message.error(res.head.msg);
	                            }
	                        };
	                        commonClient.simplecall(sgiConfig.allUrl.firstUpdatePassword, req, success);
	                    } else {
	                        _antd.message.error("确认密码与新密码不一致！");
	                    }
	                }
	            });
	        };
	
	        return _this;
	    }
	
	    _createClass(FirstLoginChgPwdC, [{
	        key: "render",
	        value: function render() {
	            var getFieldDecorator = this.props.form.getFieldDecorator;
	
	            var formItemLayout = {
	                labelCol: {
	                    xs: { span: 24 },
	                    sm: { span: 6 }
	                },
	                wrapperCol: {
	                    xs: { span: 24 },
	                    sm: { span: 18 }
	                }
	            };
	
	            return _react2.default.createElement(
	                "div",
	                { style: { height: "100%", width: "100%" } },
	                _react2.default.createElement(
	                    "div",
	                    { style: {
	                            width: "400px",
	                            margin: "0 auto ",
	                            transform: "translateY(-60%)",
	                            position: "relative",
	                            top: "50%"
	                        } },
	                    _react2.default.createElement(
	                        "div",
	                        { style: { marginBottom: "20px", fontSize: "20px", textAlign: 'center' } },
	                        "\u9996\u6B21\u767B\u5F55\u8BBE\u7F6E\u65B0\u5BC6\u7801"
	                    ),
	                    _react2.default.createElement(
	                        _antd.Form,
	                        _extends({}, formItemLayout, { onSubmit: this.handleSubmit }),
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: "\u65B0\u5BC6\u7801" },
	                            getFieldDecorator('userPassword', {
	                                rules: [{ required: true, message: '请输入新密码!' }]
	                            })(_react2.default.createElement(_antd.Input, {
	                                prefix: _react2.default.createElement(_antd.Icon, { type: "lock", style: { color: 'rgba(0,0,0,.25)' } }),
	                                type: "password",
	                                placeholder: "\u65B0\u5BC6\u7801"
	                            }))
	                        ),
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { label: "\u786E\u8BA4\u65B0\u5BC6\u7801" },
	                            getFieldDecorator('confirmUserPassword', {
	                                rules: [{ required: true, message: '请输入确认密码!' }]
	                            })(_react2.default.createElement(_antd.Input, {
	                                prefix: _react2.default.createElement(_antd.Icon, { type: "lock", style: { color: 'rgba(0,0,0,.25)' } }),
	                                type: "password",
	                                placeholder: "\u786E\u8BA4\u5BC6\u7801"
	                            }))
	                        ),
	                        _react2.default.createElement(
	                            _antd.Form.Item,
	                            { style: { textAlign: "center" } },
	                            _react2.default.createElement(
	                                _antd.Button,
	                                { type: "primary", htmlType: "submit" },
	                                "\u786E\u5B9A"
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FirstLoginChgPwdC;
	}(_react2.default.Component);
	
	var FirstLoginChgPwd = _antd.Form.create({ name: 'login' })(FirstLoginChgPwdC);
	exports.default = FirstLoginChgPwd;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _jquery = __webpack_require__(929);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ForgotPasswordC = function (_React$Component) {
	    _inherits(ForgotPasswordC, _React$Component);
	
	    function ForgotPasswordC(props) {
	        _classCallCheck(this, ForgotPasswordC);
	
	        var _this = _possibleConstructorReturn(this, (ForgotPasswordC.__proto__ || Object.getPrototypeOf(ForgotPasswordC)).call(this, props));
	
	        _this.handleConfirmPassword = function (rule, value, callback) {
	            var getFieldValue = _this.props.form.getFieldValue;
	
	            if (value && value !== getFieldValue('newPassword')) {
	                callback('两次输入不一致！');
	            }
	
	            // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
	            callback();
	        };
	
	        _this.state = {
	            phoneCaptcha: null,
	            phoneCaptchaText: '发送短信验证码',
	            companyData: [],
	            nextStep: false,
	            currentPhone: '',
	            token: ''
	        };
	        return _this;
	    }
	
	    _createClass(ForgotPasswordC, [{
	        key: 'handleSubmit',
	        value: function handleSubmit(e) {
	            var me = this;
	            e.preventDefault();
	            this.props.form.validateFieldsAndScroll(function (err, values) {
	                if (!err) {
	                    tool.sgiLogger.info('Received values of dynamicForm: ', values);
	
	                    var Data = JSON.stringify({ "body": { 'token': me.state.token, "mbl": values.phoneNmb, 'Captcha': values.phoneCaptcha }, 'head': {} });
	                    _jquery2.default.ajax({
	                        url: sgiConfig.registerLogin + '/sms/verify',
	                        data: Data,
	                        contentType: "application/json;charset=utf-8",
	                        type: "post",
	                        dataType: "json",
	                        success: function success(data, state) {
	                            tool.sgiLogger.info(data, state);
	                            if (data.head.code == "00000000") {
	                                me.setState({
	                                    nextStep: true,
	                                    currentPhone: values.phoneNmb
	                                });
	
	                                var Data = JSON.stringify({ body: { mbl: values.phoneNmb }, head: {} });
	                                _jquery2.default.ajax({
	                                    url: sgiConfig.registerLogin + '/user/findEpsByMbl',
	                                    data: Data,
	                                    contentType: "application/json;charset=utf-8",
	                                    type: "post",
	                                    dataType: "json",
	                                    success: function success(data, state) {
	                                        tool.sgiLogger.info(data, state);
	                                        if (data.body.dataset1) {
	                                            me.setState({
	                                                companyData: data.body.dataset1
	                                            });
	                                        } else {
	                                            alert(data.head.msg);
	                                        }
	                                    },
	                                    error: function error(data, state) {
	                                        tool.sgiLogger.info(data, state);
	                                        alert('错误！请重新申请');
	                                    }
	                                });
	                            } else {
	                                alert('错误！请重新申请');
	                            }
	                        },
	                        error: function error(data, state) {
	                            tool.sgiLogger.info(data, state);
	                            alert('错误！请重新申请');
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'changePassword',
	        value: function changePassword(e) {
	            var _this2 = this;
	
	            var me = this;
	            this.props.form.validateFieldsAndScroll(function (err, values) {
	                if (!err) {
	                    tool.sgiLogger.info('Received values of dynamicForm: ', values);
	
	                    var Data = JSON.stringify({
	                        "body": {
	                            "userInfo": {
	                                "mbl": _this2.state.currentPhone,
	                                "password": values.newPassword
	                            },
	
	                            "enterpriseRegisterInfo": {
	                                "enterpriseId": values.enterpriseId
	
	                            }
	                        },
	                        "head": {}
	                    });
	                    tool.sgiLogger.info(Data);
	                    _jquery2.default.ajax({
	                        url: sgiConfig.registerLogin + '/password/update ',
	                        data: Data,
	                        contentType: "application/json;charset=utf-8",
	                        type: "post",
	                        dataType: "json",
	                        success: function success(data, state) {
	                            tool.sgiLogger.info(data, state);
	                            if (data.head.code == "00000000") {
	                                alert('密码修改成功');
	                                me.props.onCancel();
	                            } else {
	                                alert('错误！请重新申请');
	                            }
	                        },
	                        error: function error(data, state) {
	                            tool.sgiLogger.info(data, state);
	                            alert('错误！请重新申请');
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'sendPhoneCaptcha',
	        value: function sendPhoneCaptcha() {
	            var phoneNmb = this.props.form.getFieldValue(['phoneNmb'])['oneNmb'];
	            tool.sgiLogger.info(phoneNmb);
	            if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(phoneNmb)) {
	                alert("不是完整的11位手机号或者正确的手机号");
	                return;
	            }
	            var me = this;
	            me.setState({
	                phoneCaptcha: 'disabled',
	                phoneCaptchaText: '60秒后可以重发'
	            });
	
	            var Data = JSON.stringify({ "body": { "mbl": phoneNmb }, 'head': {} });
	
	            _jquery2.default.ajax({
	                url: sgiConfig.registerLogin + '/sms/captcha',
	                data: Data,
	                contentType: "application/json;charset=utf-8",
	                type: "post",
	                dataType: "json",
	                success: function success(data, state) {
	                    tool.sgiLogger.info(data, state);
	                    if (data.head.code == "00000000") {
	                        me.setState({
	                            token: data.body.token
	                        });
	                    }
	                },
	                error: function error(data, state) {
	                    tool.sgiLogger.info(data, state);
	                }
	            });
	
	            var time = 60;
	            var timeInterval = setInterval(function () {
	                time--;
	                me.setState({
	                    phoneCaptchaText: time + '秒后可以重发'
	                });
	                if (time <= 0) {
	                    clearInterval(timeInterval);
	                    me.setState({
	                        phoneCaptcha: null,
	                        phoneCaptchaText: '发送短信验证码'
	                    });
	                }
	            }, 1000);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var getFieldDecorator = this.props.form.getFieldDecorator;
	
	            var formItemLayout = {
	                labelCol: {
	                    xs: { span: 24 },
	                    sm: { span: 6 }
	                },
	                wrapperCol: {
	                    xs: { span: 24 },
	                    sm: { span: 18 }
	                }
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.state.nextStep ? _react2.default.createElement(
	                    _antd.Form,
	                    { onSubmit: this.changePassword.bind(this) },
	                    _react2.default.createElement(
	                        FormItem,
	                        _extends({}, formItemLayout, {
	                            label: '\u8BF7\u9009\u62E9\u516C\u53F8'
	                        }),
	                        _react2.default.createElement(
	                            _antd.Row,
	                            { gutter: 8 },
	                            _react2.default.createElement(
	                                _antd.Col,
	                                { span: 14 },
	                                getFieldDecorator('enterpriseId', {
	                                    rules: [{ required: true, message: '请选择公司!' }]
	                                })(_react2.default.createElement(
	                                    _antd.Select,
	                                    null,
	                                    this.state.companyData.map(function (item) {
	                                        return _react2.default.createElement(
	                                            Option,
	                                            { value: item.enterpriseId },
	                                            item.enterpriseName
	                                        );
	                                    })
	                                ))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        FormItem,
	                        _extends({}, formItemLayout, {
	                            label: '\u65B0\u5BC6\u7801',
	                            extra: '\u6700\u5C116\u4F4D\uFF0C\u5305\u62EC\u81F3\u5C111\u4E2A\u5927\u5199\u5B57\u6BCD\u30011\u4E2A\u5C0F\u5199\u5B57\u6BCD\u30011\u4E2A\u6570\u5B57\u30011\u4E2A\u7279\u6B8A\u5B57\u7B26(!@#$%^&*)'
	                        }),
	                        _react2.default.createElement(
	                            _antd.Row,
	                            { gutter: 8 },
	                            _react2.default.createElement(
	                                _antd.Col,
	                                { span: 14 },
	                                getFieldDecorator('newPassword', {
	                                    rules: [{ required: true, message: '新密码不能为空!' }, { pattern: /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/, message: '密码强度过底!' }]
	                                })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        FormItem,
	                        _extends({}, formItemLayout, {
	                            label: '\u786E\u8BA4\u65B0\u5BC6\u7801'
	                        }),
	                        _react2.default.createElement(
	                            _antd.Row,
	                            { gutter: 8 },
	                            _react2.default.createElement(
	                                _antd.Col,
	                                { span: 14 },
	                                getFieldDecorator('confirmNewPassword', {
	                                    rules: [{ required: true, message: '确认新密码不能为空!' }, { validator: this.handleConfirmPassword, message: '确认密码错误!' }]
	                                })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _antd.Button,
	                            { style: { marginLeft: '118px' }, type: 'primary', htmlType: 'submit' },
	                            '\u786E\u5B9A'
	                        )
	                    )
	                ) : _react2.default.createElement(
	                    _antd.Form,
	                    { onSubmit: this.handleSubmit.bind(this) },
	                    _react2.default.createElement(
	                        FormItem,
	                        _extends({}, formItemLayout, {
	                            label: '\u624B\u673A\u53F7\u7801'
	                        }),
	                        _react2.default.createElement(
	                            _antd.Row,
	                            { gutter: 8 },
	                            _react2.default.createElement(
	                                _antd.Col,
	                                { span: 14 },
	                                getFieldDecorator('phoneNmb', {
	                                    rules: [{ required: true, message: '手机号码不能为空!' }, { pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '请输入正确的电话号码!' }]
	                                })(_react2.default.createElement(_antd.Input, null))
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        FormItem,
	                        _extends({}, formItemLayout, {
	                            label: '\u77ED\u4FE1\u9A8C\u8BC1\u7801'
	                        }),
	                        _react2.default.createElement(
	                            _antd.Row,
	                            { gutter: 8 },
	                            _react2.default.createElement(
	                                _antd.Col,
	                                { span: 14 },
	                                getFieldDecorator('phoneCaptcha', {
	                                    rules: [{ required: true, message: '请填写手机验证码!' }]
	                                })(_react2.default.createElement(_antd.Input, null))
	                            ),
	                            _react2.default.createElement(
	                                _antd.Col,
	                                { span: 10 },
	                                _react2.default.createElement(
	                                    _antd.Button,
	                                    { type: 'primary', disabled: this.state.phoneCaptcha, onClick: this.sendPhoneCaptcha.bind(this) },
	                                    this.state.phoneCaptchaText
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            _antd.Button,
	                            { style: { marginLeft: '118px' }, type: 'primary', htmlType: 'submit' },
	                            '\u786E\u5B9A'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ForgotPasswordC;
	}(_react2.default.Component);
	
	var ForgotPassword = _antd.Form.create()(ForgotPasswordC);
	exports.default = ForgotPassword;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _Login = __webpack_require__(892);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _LoginForm = __webpack_require__(959);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _reactRouter = __webpack_require__(116);
	
	var _x = __webpack_require__(2020);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _code = __webpack_require__(2021);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import logo from './mnLogo.png'
	
	
	// 测试cfca
	// import cfca from '../../cfca/ccie/index'
	
	var Header = _antd.Layout.Header,
	    Footer = _antd.Layout.Footer,
	    Content = _antd.Layout.Content;
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Login = function (_React$Component) {
	    _inherits(Login, _React$Component);
	
	    // registerBtn(){
	    //     tool.sgiLogger.info('registerBtn');
	    //     browserHistory.push({
	    //         pathname: '/register',
	    //         state: { from: 'login' }
	    //     });
	    // }
	    function Login(props) {
	        _classCallCheck(this, Login);
	
	        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	        _this.state = { toggle: false };
	        return _this;
	    }
	
	    _createClass(Login, [{
	        key: 'testcfca',
	        value: function testcfca() {
	            cfca.verifyCertificate(function (res) {
	                console.log(res);
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // console.log('ooooooooooo')
	            this.warning();
	        }
	    }, {
	        key: 'QRCodeRefresh',
	        value: function QRCodeRefresh() {
	            tool.sgiLogger.info('QRCodeRefresh');
	        }
	    }, {
	        key: 'tabsChange',
	        value: function tabsChange() {
	            tool.sgiLogger.info(this.props.router);
	            tool.sgiLogger.info('tabsChange');
	        }
	    }, {
	        key: 'toggleClick',
	        value: function toggleClick(bool) {
	            this.setState({ toggle: !bool });
	        }
	    }, {
	        key: 'warning',
	        value: function warning(text) {
	            _antd.Modal.warning({
	                className: _Login2.default.checkInfoModal_index,
	                title: '迁移通知',
	                okButtonProps: {
	                    style: { display: 'none' }
	                },
	                content: _react2.default.createElement(
	                    'div',
	                    { className: _Login2.default.overflowHidden_index, style: { webkitBoxOrient: 'vertical' } },
	                    '\u5C0A\u656C\u7684\u5E73\u53F0\u7528\u6237\uFF1A',
	                    _react2.default.createElement('br', null),
	                    '\u4E3A\u63D0\u5347\u7CFB\u7EDF\u6027\u80FD\u53CA\u52A0\u5F3A\u5B89\u5168\u6027\uFF0C\u8BA1\u5212\u4E8E\u200C2025\u5E747\u670811\u65E5\uFF08\u5468\u4E94\uFF0917:00\u81F32025\u5E747\u670812\u65E5\uFF08\u5468\u516D\uFF0909:00\u200C\u8FDB\u884C\u7CFB\u7EDF\u8FC1\u79FB\u5DE5\u4F5C\u3002\u5728\u6B64\u671F\u95F4\u4FDD\u7406\u7CFB\u7EDF\u6240\u6709\u529F\u80FD\u5C06\u6682\u505C\u670D\u52A1\u200C\u3002\u5F85\u8FC1\u79FB\u5B8C\u6210\u540E\uFF0C\u4FDD\u7406\u7CFB\u7EDF\u5C06\u542F\u7528\u200C\u65B0\u7684\u8BBF\u95EE\u5730\u5740\u200C\uFF1A',
	                    _react2.default.createElement(
	                        'a',
	                        { style: { fontSize: '18px' }, href: 'https://nxr.mengniu.cn:7443' },
	                        'https://nxr.mengniu.cn:7443'
	                    ),
	                    '\u3002',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '\u8BF7\u60A8\u63D0\u524D\u505A\u597D\u76F8\u5173\u5B89\u6392\uFF0C\u5BF9\u4E8E\u6B64\u6B21\u7EF4\u62A4\u7ED9\u60A8\u5E26\u6765\u7684\u4E0D\u4FBF\uFF0C\u6211\u4EEC\u6DF1\u8868\u6B49\u610F\uFF0C\u5E76\u611F\u8C22\u60A8\u7684\u7406\u89E3\u4E0E\u652F\u6301\u3002'
	                )
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var toggle = this.state.toggle;
	            return _react2.default.createElement(
	                _antd.Layout,
	                { className: _Login2.default.loginLayout },
	                _react2.default.createElement(
	                    Header,
	                    { className: _Login2.default.loginHeader },
	                    _react2.default.createElement('div', { className: _Login2.default.loginTitle })
	                ),
	                _react2.default.createElement(
	                    Content,
	                    { className: _Login2.default.loginContent },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Login2.default.loginArea },
	                        _react2.default.createElement(
	                            'div',
	                            { onClick: function onClick() {
	                                    return _this2.toggleClick(toggle);
	                                }, className: _Login2.default.toggleBtn },
	                            _react2.default.createElement(_antd.Icon, { className: _Login2.default.toggleIcon, type: toggle ? "right" : 'left' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _Login2.default[toggle ? 'loginAreaLeft' : 'loginAreaLeft_hidden'] },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                ' ',
	                                _react2.default.createElement('span', { className: _Login2.default.zllogo }),
	                                '\u6E29\u99A8\u63D0\u793A'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { padding: '20px 13px' } },
	                                '\u60A8\u5F53\u524D\u7684\u7CFB\u7EDF\u73AF\u5883'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _Login2.default.proposal },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '1\u3001\u6D4F\u89C8\u5668\uFF1A\u5F3A\u70C8\u63A8\u8350',
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { color: '#c04323', fontSize: '13px' } },
	                                        'Chrome'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _Login2.default.check },
	                                        '\u221A'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '2\u3001\u64CD\u4F5C\u7CFB\u7EDF\uFF1A ',
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { color: '#c04323', fontSize: '13px' } },
	                                        'Windows \u7CFB\u7EDF'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _Login2.default.check },
	                                        '\u221A'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '3\u3001CFCA Chrome\u63D2\u4EF6\uFF1A',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '/assets/CryptoKit.COFCO.zip', download: 'CryptoKit.COFCO.zip' },
	                                        'CryptoKit.COFCO.zip(\u70B9\u51FB\u4E0B\u8F7D)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: _Login2.default.check },
	                                        '\u221A'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: _Login2.default.tip },
	                                '\u8BF7\u5BF9\u73AF\u5883\u8FDB\u884C\u5347\u7EA7\u540E\uFF0C\u91CD\u65B0\u6253\u5F00\u6D4F\u89C8\u5668\u8FDB\u884C\u8BBF\u95EE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: _Login2.default.loginAreaRight },
	                            _react2.default.createElement(
	                                'div',
	                                { className: _Login2.default.formTitle },
	                                '\u8499\u5143\u4FDD\u7406\u8D44\u4EA7\u7BA1\u7406\u5E73\u53F0'
	                            ),
	                            _react2.default.createElement(_LoginForm2.default, null)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    Footer,
	                    { className: _Login2.default.loginFooter },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Login2.default.Footer_content },
	                        _react2.default.createElement('img', { src: _code2.default }),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010102001167', target: '_blank' },
	                            '\u6D25\u516C\u7F51\u5B89\u590712010102001167\u53F7'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://beian.miit.gov.cn/#/Integrated/index', target: '_blank' },
	                            '\u6D25ICP\u59072023004811\u53F7-7'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Login;
	}(_react2.default.Component);
	
	exports.default = Login;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _ForgotPassword = __webpack_require__(957);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _Login = __webpack_require__(892);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _reactRouter = __webpack_require__(116);
	
	var _jquery = __webpack_require__(929);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rtSdCommon = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = _antd.Input.Search;
	
	var FormItem = _antd.Form.Item;
	
	
	var SearchBtn = function SearchBtn(props) {
	    var disabled = props.disabled,
	        count = props.count,
	        defaultName = props.defaultName;
	
	    return _react2.default.createElement(
	        _antd.Button,
	        {
	            style: { width: '120px', background: '#00b34f' },
	            type: 'primary' },
	        disabled ? count : defaultName
	    );
	};
	
	var NormalLoginForm = function (_React$Component) {
	    _inherits(NormalLoginForm, _React$Component);
	
	    function NormalLoginForm(props) {
	        _classCallCheck(this, NormalLoginForm);
	
	        var _this = _possibleConstructorReturn(this, (NormalLoginForm.__proto__ || Object.getPrototypeOf(NormalLoginForm)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this.state = {
	            openSso: ''
	        };
	        function getUrlParam(paraName) {
	            var url = document.location.toString();
	            var arrObj = url.split('?');
	
	            if (arrObj.length > 1) {
	                var arrPara = arrObj[1].split('&');
	                var arr = void 0;
	
	                for (var i = 0; i < arrPara.length; i++) {
	                    arr = arrPara[i].split('=');
	
	                    if (arr != null && arr[0] == paraName) {
	                        return arr[1];
	                    }
	                }
	                return '';
	            } else {
	                return '';
	            }
	        }
	
	        var hasToken = false;
	        _this.openSso = _rtSdCommon.sgiConfig.openSso;
	
	        var loginErrorFlag = false;
	
	        // 获取url参数openSso，覆盖sgiConfig中的默认值。允许外部用户登录，而不经过统一认证平台。
	        var urlParamOpenSso = getUrlParam('openSso');
	        console.log('sy -----  loginForm.js  constructor 1 urlParamOpenSso: ', urlParamOpenSso);
	        if (urlParamOpenSso === 'false') {
	            _this.openSso = false;
	        }
	        _rtSdCommon.tool.setCookie('openSso', _this.openSso);
	        console.log('sy -----  loginForm.js  constructor 1. openSso: ', _this.openSso);
	        var cookieToken = _rtSdCommon.tool.getCookie("token");
	        var cookieMbl = _rtSdCommon.tool.getCookie("mbl");
	        // http://127.0.0.1:8490/?ticket=ST-21-bYsscPA1f51Hi2kD2yuzklgDKz0iMpz2bCN&service=http://127.0.0.1:8490/
	        console.log('sy -----  loginForm.js  constructor 2 cookieToken: ', cookieToken);
	        console.log('sy -----  loginForm.js  constructor 2 cookieMbl: ', cookieMbl);
	        var ticket = getUrlParam('ticket');
	        // let service = getUrlParam('service');
	        var service = window.location.protocol + '//' + window.location.host + '/';
	        console.log('sy -----  loginForm.js  constructor 3 ticket: ', ticket);
	        console.log('sy -----  loginForm.js  constructor 3 service: ', service);
	
	        if (_rtSdCommon.tool.getCookie("token") && _rtSdCommon.tool.getCookie("mbl")) {
	            hasToken = true;
	            // browserHistory.push({
	            //     pathname: '/main',
	            //     state: {}
	            // });
	            console.log('sy -----  loginForm.js  constructor 4 tool.popSingleUI mail');
	            _rtSdCommon.tool.popSingleUI('/main');
	        }
	        if (_this.openSso && ticket) {
	
	            console.log('sy -----  loginForm.js  constructor 5 validateLogin');
	            var mySuccessCallback = _this.successCallback;
	            var onOkClick = _this.onOkClick;
	            var success = function success(res) {
	                // debugger
	                if (res && res.head && res.head.code == "0000") {
	                    console.log('sy -----  loginForm.js  constructor 6 res: ', res);
	                    _rtSdCommon.tool.setCookie('token', res.body.token);
	                    _rtSdCommon.tool.setCookie('mbl', res.body.mbl);
	                    hasToken = true;
	                    // tool.popSingleUI('/main');
	                    console.log('sy -----  loginForm.js  constructor 6 call mySuccessCallback');
	                    mySuccessCallback(res);
	                } else {
	                    console.log('login error', res);
	                    loginErrorFlag = true;
	                    _rtSdCommon.tool.popMessage(res.head.msg || '账号登录异常,请联系运维人员', "error");
	                    // tool.popMsgDialog(res.head.msg || '账号登录异常,请联系运维人员', "文本资源保存成功！");
	                    _rtSdCommon.tool.popMsgDialog("账号登录异常,请联系运维人员", res.head.msg || '账号登录异常,请联系运维人员', onOkClick, "error", null);
	                }
	            };
	            var requestUrl = _rtSdCommon.sgiConfig.service_uam + "/index/cas/client/validateLogin?ticket=" + ticket + '&service=' + service;
	            console.log('sy -----  loginForm.js  constructor 6 validateLogin requestUrl: ', requestUrl);
	            commonClient.simplecall(requestUrl, undefined, success, false, 'get');
	        }
	        _this.state = {
	            userPhone: null,
	            suijiId: 1,
	            userId: null,
	            passwordIsPassed: false,
	            passwordForget: false,
	            hasTip: false,
	            errMsg: '',
	            validateStatus: '',
	
	            countLoading: false,
	            count: 59
	        };
	        console.log('sy -----  loginForm.js  constructor 5 state: ', _this.state);
	        console.log('sy -----  loginForm.js  constructor 6 hasToken: ', hasToken);
	
	        if (_this.openSso && !hasToken && !loginErrorFlag) {
	            var locationUrl = document.location.protocol + "//" + window.location.host + '/';
	            console.log('ssoLogin  locationUrl: ', locationUrl);
	            // debugger
	            window.location.href = _rtSdCommon.sgiConfig.casBaseUrl + '/login?service=' + encodeURIComponent(locationUrl);
	        }
	
	        return _this;
	    }
	
	    _createClass(NormalLoginForm, [{
	        key: 'onOkClick',
	        value: function onOkClick() {
	            var locationUrl = document.location.protocol + "//" + window.location.host + '/';
	            console.log('账号登录异常 确认click: ', locationUrl, _rtSdCommon.sgiConfig.casBaseUrl + '/login?service=' + encodeURIComponent(locationUrl));
	            // debugger
	            window.location.href = _rtSdCommon.sgiConfig.casBaseUrl + '/login?service=' + encodeURIComponent(locationUrl);
	        }
	    }, {
	        key: 'encrypt',
	        value: function encrypt(val) {
	            if (!_rtSdCommon.sgiConfig.PublicKey) return val;
	            var encrypt = new JSEncrypt();
	            encrypt.setPublicKey(_rtSdCommon.sgiConfig.PublicKey);
	            return encrypt.encrypt(val);
	        }
	        // 获取企业详细信息，并将社会信用代码存到cookie
	
	    }, {
	        key: 'queryOrgInfos',
	        value: function queryOrgInfos() {
	            var success = function success(res) {
	                if (res && res.head && res.head.code == "0000") {
	                    console.log(res.body.socialCreditCode);
	                    _rtSdCommon.tool.setCookie('socialCreditCode', res.body.socialCreditCode);
	                }
	            };
	            commonClient.simplecall(_rtSdCommon.sgiConfig.service_cust + "supMan/getSupInfo", { entId: _rtSdCommon.tool.getCookie('orgId') }, success);
	        }
	    }, {
	        key: 'successCallback',
	        value: function successCallback(res) {
	            var resList = res.body;
	            console.log('LoginForm successCallback. resList: ', resList);
	            resList.enterpriseId = resList.orgId;
	            resList.enterpriseNam = resList.orgNam;
	            resList.passwordStatus = resList.passwordStatus;
	            resList.roleIdStr = resList.roleIds;
	
	            var allCookieKey = [];
	            for (var key in resList) {
	                _rtSdCommon.tool.setCookie(key, resList[key], .5);
	                allCookieKey.push(key);
	            }
	
	            _rtSdCommon.tool.setCookie("allCookieKey", allCookieKey.join(","), .5);
	
	            //连接websocket
	            // wsLogin(loginInfo);
	            _rtSdCommon.tool.setCookie("LS", "1"); //锁屏
	
	            if (resList.passwordStatus == "1") {
	                _rtSdCommon.tool.popSingleUI("/FirstLoginChgPwd");
	            } else {
	                _rtSdCommon.tool.popSingleUI('/main');
	            }
	            // this.queryOrgInfos()
	
	            console.log('LoginForm successCallback. simplecall getSupInfo');
	            var success = function success(res) {
	                if (res && res.head && res.head.code == "0000") {
	                    console.log(res.body.socialCreditCode);
	                    _rtSdCommon.tool.setCookie('socialCreditCode', res.body.socialCreditCode);
	                }
	            };
	            commonClient.simplecall(_rtSdCommon.sgiConfig.service_cust + "supMan/getSupInfo", { entId: _rtSdCommon.tool.getCookie('orgId') }, success);
	        }
	    }, {
	        key: 'userLogin',
	        value: function userLogin(data) {
	            var _this2 = this;
	
	            var req = data;
	            data.loginPwd = this.encrypt(data.loginPwd);
	            //登录追加前端PC端渠道号 registerChnl 01
	            req.registerChnl = "01";
	
	            console.log('LoginForm userLogin. req: ', req);
	
	            var success = function success(res) {
	                if (res && res.head.code === "0000") {
	                    if (res.body.token) {
	                        _this2.successCallback(res);
	                    } else {
	                        _this2.setState({
	                            passwordIsPassed: true,
	                            userPhone: res.body.mbl,
	                            userId: res.body.userId
	                        });
	                    }
	                } else {
	                    if (res && res.head.code === "0406") {
	                        var _req = {
	                            riskType: "50", // 风险类型 50：用户风险
	                            riskLevel: "01", // 风险等级 01：高 02：中 03：低
	                            riskContent: data.userMobile + '\u591A\u6B21\u767B\u5F55\u5931\u8D25\uFF0C\u8D26\u53F7\u5DF2\u88AB\u9501\u5B9A' // 风险内容
	                        };
	                        commonClient.simplecall(_rtSdCommon.sgiConfig.allUrl.RiskRegInfoAdd, _req, function () {}, null, null, null, function (req) {
	                            // req.head={};
	                        });
	                    }
	                    if (res && res.head.code === "9991") {
	                        _rtSdCommon.tool.popSingleUI('/ChangePassword');
	                    }
	
	                    if (res.head.msg === '内部员工请通过IAM登录') {
	                        // 跳转IAM
	                        var locationUrl = document.location.protocol + "//" + window.location.host + '/';
	                        console.log('ssoLogin  locationUrl: ', locationUrl);
	                        // debugger
	                        var url = _rtSdCommon.sgiConfig.casBaseUrl + '/login?service=' + encodeURIComponent(locationUrl);
	                        console.log('sy -----  loginForm.js 内部员工 自动跳转IAM: ', url);
	                        window.location.href = url;
	                    }
	                    _antd.message.error(res.head.msg);
	                }
	            };
	            //    simplecall: function (path, data, callback, flag, reqType, aftercall, beforecall) {
	            commonClient.simplecall(_rtSdCommon.sgiConfig.allUrl.loginUri, req, success, null, null, null, function (req) {});
	        }
	    }, {
	        key: 'getUUID',
	        value: function getUUID() {
	            function S4() {
	                return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
	            }
	            return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
	        }
	    }, {
	        key: 'CaptchaPictureClick',
	        value: function CaptchaPictureClick() {
	            this.setState({
	                suijiId: this.getUUID()
	            });
	        }
	    }, {
	        key: 'valdtsmsHandler',
	        value: function valdtsmsHandler(data) {
	            var _this3 = this;
	
	            console.log(data);
	            var success = function success(res) {
	                if (res && res.head.code === "0000") {
	                    _this3.successCallback(res);
	                } else {
	                    // tool.sgiLogger.info(res.head.msg);
	                    _rtSdCommon.tool.popMessage(res.head.msg, 'error');
	                }
	            };
	            commonClient.simplecall(_rtSdCommon.sgiConfig.allUrl.valdtsmsUri, {
	                smsCode: data.smsCode,
	                userId: this.state.userId
	            }, success);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var getFieldDecorator = this.props.form.getFieldDecorator;
	
	            console.log('sy -----  loginForm.js  render 1');
	            console.log('sy -----  loginForm.js  openSso', this.openSso);
	            // if(this.openSso) return ;
	            if (this.state.passwordForget) {
	                return _react2.default.createElement(
	                    _antd.Form,
	                    _defineProperty({ onSubmit: this.resetPassword, className: _Login2.default['login-dynamicForm'] }, 'className', 'loginform'),
	                    _react2.default.createElement(
	                        FormItem,
	                        null,
	                        getFieldDecorator('userNam', {
	                            rules: [{ required: true, message: '请输入用户名!' }]
	                        })(_react2.default.createElement(_antd.Input, { size: 'large'
	                            // prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} 
	                            , placeholder: '\u8BF7\u8F93\u5165\u7528\u6237\u540D' }))
	                    ),
	                    _react2.default.createElement(
	                        FormItem,
	                        null,
	                        getFieldDecorator('email', {
	                            rules: [{ required: true, message: '请输入账号绑定的邮箱!' }]
	                        })(_react2.default.createElement(_antd.Input, { size: 'large'
	                            // prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} 
	                            , placeholder: '\u8BF7\u8F93\u5165\u8D26\u53F7\u7ED1\u5B9A\u7684\u90AE\u7BB1' }))
	                    ),
	                    _react2.default.createElement(
	                        FormItem,
	                        { style: { marginBottom: '10px' } },
	                        _react2.default.createElement(
	                            _antd.Row,
	                            { style: { fontSize: '12px' } },
	                            _react2.default.createElement(_antd.Col, { span: 12 }),
	                            _react2.default.createElement(
	                                _antd.Col,
	                                { span: 12, style: { textAlign: 'right' } },
	                                _react2.default.createElement(
	                                    'a',
	                                    { onClick: function onClick() {
	                                            return _this4.forgetPasswordHandler(false);
	                                        }, style: { color: '#00b34f' } },
	                                    '\u8FD4\u56DE\u767B\u5F55'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        FormItem,
	                        { style: { marginBottom: 0 } },
	                        _react2.default.createElement(
	                            _antd.Button,
	                            { size: 'large', type: 'primary', htmlType: 'submit', className: _Login2.default['login-form-button'] },
	                            '\u786E\u5B9A'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Login2.default.errMsg },
	                        ' ',
	                        this.state.errMsg
	                    )
	                );
	            }
	            return !this.state.passwordIsPassed ? _react2.default.createElement(
	                _antd.Form,
	                _defineProperty({ onSubmit: this.handleSubmit.bind(this), className: _Login2.default['login-dynamicForm'] }, 'className', 'loginform'),
	                _react2.default.createElement(
	                    FormItem,
	                    { style: { marginBottom: '18px' } },
	                    getFieldDecorator('loginNam', {
	                        rules: [{ required: true, message: '请输入用户名!' }]
	                    })(this.state.hasTip ? _react2.default.createElement(
	                        'span',
	                        { style: { position: 'relative' } },
	                        _react2.default.createElement(
	                            'span',
	                            { style: { fontSize: '12px', position: 'absolute', left: '0', top: '-45px' } },
	                            '\u60A8\u5F88\u5FEB\u4F1A\u6536\u5230\u4E00\u5C01\u5173\u4E8E\u63A5\u4E0B\u6765\u64CD\u4F5C\u7684\u90AE\u4EF6\u3002'
	                        ),
	                        _react2.default.createElement(_antd.Input, { size: 'large', prefix: _react2.default.createElement(_antd.Icon, { type: 'mobile', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: '\u7528\u6237\u540D' })
	                    ) : _react2.default.createElement(_antd.Input, { size: 'large', prefix: _react2.default.createElement(_antd.Icon, { type: 'mobile', style: { color: 'rgba(0,0,0,.25)' } }), placeholder: '\u7528\u6237\u540D' }))
	                ),
	                _react2.default.createElement(
	                    FormItem,
	                    { style: { marginBottom: '18px' } },
	                    getFieldDecorator('loginPwd', {
	                        rules: [{ required: true, message: '密码不能为空！' }]
	                    })(_react2.default.createElement(_antd.Input, { size: 'large', prefix: _react2.default.createElement(_antd.Icon, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }), type: 'password', placeholder: '\u5BC6\u7801' }))
	                ),
	                _react2.default.createElement(
	                    _antd.Row,
	                    null,
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(
	                            FormItem,
	                            { hasFeedback: true, validateStatus: this.state.validateStatus },
	                            getFieldDecorator('kaptchaCode', {
	                                validateFirst: false,
	                                validateTrigger: 'onBlur',
	                                rules: [{
	                                    validator: this.kaptchaCodeValidator
	                                }]
	                            })(_react2.default.createElement(_antd.Input, { size: 'large', placeholder: '\u9A8C\u8BC1\u7801' }))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12 },
	                        _react2.default.createElement(
	                            FormItem,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { onClick: this.CaptchaPictureClick.bind(this), className: _Login2.default.changeOne, style: { lineHeight: '33px' } },
	                                _react2.default.createElement('img', {
	                                    style: {
	                                        height: '39px',
	                                        width: '100px',
	                                        borderRadius: '5px'
	                                    },
	                                    id: 'CaptchaPicture',
	                                    src: _rtSdCommon.sgiConfig.allUrl.kaptchaUri + '?wd=' + this.state.suijiId,
	                                    alt: '' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: { color: '#00b34f' } },
	                                    ' \u6362\u4E00\u5F20'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    FormItem,
	                    { style: { marginBottom: '10px' } },
	                    _react2.default.createElement(
	                        _antd.Row,
	                        { style: { fontSize: '12px' } },
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: 8 },
	                            getFieldDecorator('isRemember', {
	                                // rules: [{ required: true, message: '请输入用户名!' }],
	                            })(_react2.default.createElement(
	                                _antd.Checkbox,
	                                { style: { fontSize: '12px', color: '#00b34f' } },
	                                '\u8BB0\u4F4F\u4F01\u4E1A\u4FE1\u606F'
	                            ))
	                        ),
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: 16, style: { textAlign: 'right' } },
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: function onClick() {
	                                        _rtSdCommon.tool.popSingleUI('/ChangePassword', {}, '修改密码');
	                                        // return this.changePasswordHandler()
	                                    }, style: { color: '#00b34f' } },
	                                '\u4FEE\u6539\u5BC6\u7801'
	                            ),
	                            _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: function onClick() {
	                                        return _this4.forgetPasswordHandler(true);
	                                    }, style: { color: '#00b34f' } },
	                                '\u91CD\u7F6E\u5BC6\u7801'
	                            ),
	                            _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                            _react2.default.createElement(
	                                'a',
	                                { onClick: function onClick() {
	                                        _rtSdCommon.tool.popSingleUI('/Register');console.log('去注册');
	                                    }, style: { color: '#00b34f' } },
	                                '\u9A6C\u4E0A\u6CE8\u518C'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    FormItem,
	                    { style: { marginBottom: 0 } },
	                    _react2.default.createElement(
	                        _antd.Button,
	                        { size: 'large', type: 'primary', htmlType: 'submit', style: { fontSize: '13px' }, className: _Login2.default['login-form-button'] },
	                        '\u767B\u5F55'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _Login2.default.errMsg },
	                    ' ',
	                    this.state.errMsg
	                )
	            ) : _react2.default.createElement(
	                _antd.Form,
	                _defineProperty({ onSubmit: this.togglepassed, className: _Login2.default['login-dynamicForm'] }, 'className', 'loginform'),
	                _react2.default.createElement(
	                    FormItem,
	                    { style: { margin: '38px 0' } },
	                    _react2.default.createElement(_antd.Input, { size: 'large', prefix: _react2.default.createElement(_antd.Icon, { type: 'mobile',
	                            style: { color: 'rgba(0,0,0,.25)' }
	                        }), placeholder: '\u7528\u6237\u540D', disabled: true, defaultValue: this.state.userPhone })
	                ),
	                _react2.default.createElement(
	                    FormItem,
	                    { style: { marginBottom: '38px' } },
	                    getFieldDecorator('smsCode', {
	                        rules: [{ required: true, message: '短信验证码' }]
	                    })(
	                    // <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="短信验证码" />
	
	                    _react2.default.createElement(Search, {
	                        size: 'large',
	                        prefix: _react2.default.createElement(_antd.Icon, { type: 'lock', style: { color: 'rgba(0,0,0,.25)' } }),
	                        placeholder: '\u77ED\u4FE1\u9A8C\u8BC1\u7801'
	                        // enterButton={this.state.countLoading ? this.state.count + '秒' : '发送短信验证码'}
	                        , enterButton: SearchBtn({ disabled: this.state.countLoading, count: this.state.count + ' 秒', defaultName: '发送验证码' }),
	                        onSearch: this.sendNote
	                    }))
	                ),
	                _react2.default.createElement(
	                    FormItem,
	                    { style: { marginBottom: 0 } },
	                    _react2.default.createElement(
	                        _antd.Button,
	                        { size: 'large', type: 'primary', htmlType: 'submit', className: _Login2.default['login-form-button'] },
	                        '\u786E\u5B9A'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _Login2.default.errMsg },
	                    ' ',
	                    this.state.errMsg
	                )
	            );
	        }
	    }]);
	
	    return NormalLoginForm;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this5 = this;
	
	    this.countDown = function () {
	        var count = _this5.state.count;
	
	        var timer = setInterval(function () {
	            _this5.setState({ count: count-- }, function () {
	                if (count <= -1) {
	                    clearInterval(timer);
	                    _this5.setState({
	                        count: 59,
	                        countLoading: false
	                    });
	                }
	            });
	        }, 1000);
	    };
	
	    this.handleSubmit = function (e) {
	        var me = _this5;
	        e.preventDefault();
	        _this5.props.form.validateFields(function (err, values) {
	            if (!err) {
	                _rtSdCommon.tool.sgiLogger.info('Received values of dynamicForm: ', values);
	                _this5.userLogin(values);
	            }
	        });
	    };
	
	    this.togglepassed = function (e) {
	        e.preventDefault();
	        _this5.props.form.validateFields(function (err, values) {
	            if (!err) {
	                _rtSdCommon.tool.sgiLogger.info('Received values of dynamicForm: ', values);
	                _this5.valdtsmsHandler(values);
	            }
	        });
	    };
	
	    this.kaptchaCodeValidator = function (rule, value, callback) {
	        if (!value) {
	            _this5.state.validateStatus = 'error';
	            return callback(new Error('请填写图片验证码!'));
	        }
	        _this5.state.validateStatus = 'validating';
	        var success = function success(res) {
	            if (res && res.head.code === "0000") {
	                callback();
	                _this5.state.validateStatus = 'success';
	            } else {
	
	                if (res.head.code === 0) {
	                    callback(new Error('网络错误！'));
	                } else {
	                    callback(new Error(res.head.msg));
	                }
	                _this5.state.validateStatus = 'error';
	            }
	        };
	        commonClient.simplecall(_rtSdCommon.sgiConfig.allUrl.vldtKaptchaUri, value, success);
	    };
	
	    this.sendNote = function (params) {
	        if (_this5.state.countLoading) return;
	        var success = function success(res) {
	            console.log('开始倒计时');
	            _this5.setState({
	                countLoading: true
	            });
	            if (!_this5.state.count == 0) {
	                _this5.countDown();
	            }
	            if (res && res.head.code === "0000") {} else {}
	            console.log(res);
	        };
	        commonClient.simplecall(_rtSdCommon.sgiConfig.allUrl.sendNoteUri, { userId: _this5.state.userId }, success);
	    };
	
	    this.changePasswordHandler = function () {
	        _rtSdCommon.tool.popSingleUI('/main/ChangePassword', {}, '修改密码');
	    };
	
	    this.forgetPasswordHandler = function (passwordForget) {
	        _this5.setState({
	            passwordForget: passwordForget
	        });
	    };
	
	    this.resetPassword = function (e) {
	        console.log('重置密码');
	        e.preventDefault();
	        _this5.props.form.validateFields(function (err, values) {
	            if (err) return;
	            _this5.resetPasswordHandler(values);
	        });
	    };
	
	    this.resetPasswordHandler = function (values) {
	        console.log(values);
	        var req = {
	            values: _extends({
	                ap: 'mn'
	            }, values)
	        };
	        var success = function success(res) {
	            if (res && res.head.code === "0000") {
	                _this5.forgetPasswordHandler(false);
	                _this5.setState({
	                    hasTip: true
	                });
	            } else {
	                _rtSdCommon.tool.popMessage(res.head.msg, "error");
	            }
	        };
	        commonClient.simplecall(_rtSdCommon.sgiConfig.service_uam + '/user/checkUserResetpwd', req, success);
	        // commonClient.simplecall(sgiConfig.service_uam + '/user/resetpwd', values, success)
	    };
	};
	
	var LoginForm = _antd.Form.create()(NormalLoginForm);
	
	exports.default = LoginForm;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubMenu = _antd.Menu.SubMenu;
	var Header = _antd.Layout.Header,
	    Content = _antd.Layout.Content,
	    Sider = _antd.Layout.Sider;
	
	var HelpDoc = function (_React$Component) {
	    _inherits(HelpDoc, _React$Component);
	
	    function HelpDoc(props) {
	        _classCallCheck(this, HelpDoc);
	
	        var _this = _possibleConstructorReturn(this, (HelpDoc.__proto__ || Object.getPrototypeOf(HelpDoc)).call(this, props));
	
	        _this.state = {
	            //navMenus:  [],
	            uid: props.location.query.uid,
	            loaded: false
	            //this.getMenuByServer();
	        };return _this;
	    }
	
	    _createClass(HelpDoc, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var script = document.createElement('script');
	            script.type = 'text/javascript';
	            script.src = "./HelpDoc.js";
	            var me = this;
	            //IE    
	            if (script.readyState) {
	                script.onreadystatechange = function () {
	                    if (script.readyState == 'loaded' || script.readyState == 'complete') {
	                        script.onreadystatechange = null;
	                        me.setState({
	                            loaded: true
	                        });
	                    }
	                };
	            } else {
	                //其他浏览器    
	                script.onload = function () {
	                    me.setState({
	                        loaded: true
	                    });
	                };
	            }
	            document.getElementsByTagName('head')[0].appendChild(script);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var me = this;
	            if (me.state.uid) {
	                setTimeout(function () {
	                    me.jump(me.state.uid);
	                }, 300);
	            }
	        }
	        // 获取菜单
	        // getMenuByServer() {
	        //     var me = this;
	
	        //     var req = {
	        //         "userId": tool.getCookie('id'),
	        //         "channelId": "0"
	        //     };
	        //     tool.sgiLogger.info(req, 'getMenuByServer')
	        //     var success = function (res) {
	        //         tool.sgiLogger.info(res, 'getMenuByServer')
	        //         if (res && res.head.code == "0000") {
	        //             me.setState({
	        //                 navMenus: res.body
	        //             })
	        //         }
	        //     };
	        //     commonClient.simplecall(sgiConfig.allUrl.userGetUserMenus, req, success, true)
	        // }
	        // createMenus(arr) {
	        //     if (!arr) { return }
	        //     let that = this;
	        //     return arr.map((item, index) => {
	        //         switch (item.type) {
	        //             case "2":
	        //                 return <Menu.Item onClick={this.menusClick.bind(this, item)} key={item.menuId} ><Icon type={item.img || "arrow-right"} /><span>{item.name}</span></Menu.Item>
	        //                 break;
	        //             default:
	        //                 return <SubMenu key={item.menuId} title={<span><Icon type={item.img || "appstore"} /><span>{item.name}</span></span>}>{that.createMenus(item.children)}</SubMenu>
	        //         }
	        //     })
	        // }
	
	    }, {
	        key: 'createMenus',
	        value: function createMenus(arr) {
	            var _this2 = this;
	
	            if (!arr) {
	                return;
	            }
	            return arr.map(function (item, index) {
	                return _react2.default.createElement(
	                    _antd.Menu.Item,
	                    { onClick: _this2.menusClick.bind(_this2, item), key: item.uid },
	                    _react2.default.createElement(_antd.Icon, { type: "arrow-right" }),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        item.name
	                    )
	                );
	            });
	        }
	    }, {
	        key: 'createCard',
	        value: function createCard(arr) {
	            if (!arr) {
	                return;
	            }
	            return arr.map(function (item, index) {
	                var xmlDoc = _react2.default.createElement(
	                    'p',
	                    null,
	                    item.name + "帮助手册正在完善中..."
	                );
	                if (sgiSrvUrl.HelpDoc[item.uid]) {
	                    var html = { __html: sgiSrvUrl.HelpDoc[item.uid] };
	                    xmlDoc = _react2.default.createElement('div', { dangerouslySetInnerHTML: html });
	                }
	                return _react2.default.createElement(
	                    _antd.Card,
	                    { title: item.name, extra: _react2.default.createElement('a', { style: { position: "relative", top: "-30" }, name: item.uid }), style: { width: "100%", marginBottom: "5px" } },
	                    xmlDoc
	                );
	            });
	        }
	        // createCard(arr) {
	        //     if (!arr) { return }
	        //     let that = this;
	
	        //     return arr.map((item, index) => {
	        //         switch (item.type) {
	        //             case "2":
	        //                 let xmlDoc = <p>{item.funcName + "帮助手册正在完善中..."}</p>
	        //                 if (sgiSrvUrl.HelpDoc[item.uid]) {
	        //                     var html = { __html: sgiSrvUrl.HelpDoc[item.uid] };
	        //                     xmlDoc = <div dangerouslySetInnerHTML={html}></div>
	        //                 }
	
	        //                 return <Card title={item.funcName} extra={<a style={{ position: "relative", top: "-30" }} name={item.uid}></a>} style={{ width: "100%", marginBottom: "5px" }}>
	        //                     {xmlDoc}
	        //                 </Card>
	        //                 break;
	        //             default:
	        //                 return that.createCard(item.children);
	        //         }
	        //     })
	        // }
	        // 点击菜单
	
	    }, {
	        key: 'menusClick',
	        value: function menusClick(e) {
	            this.jump(e.uid);
	        }
	    }, {
	        key: 'jump',
	        value: function jump(id) {
	            var a = document.createElement("a");
	            a.setAttribute("href", "#" + id);
	            a.click();
	        }
	    }, {
	        key: 'btnClick',
	        value: function btnClick() {
	            _reactRouter.browserHistory.push({
	                pathname: "/",
	                query: {}
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var navMenus = sgiSrvUrl.HelpDocMenu || [];
	            var re = [];
	            if (sgiSrvUrl.HelpDoc) {
	                re = this.createCard(navMenus);
	                var xmlDoc = _react2.default.createElement(
	                    'p',
	                    null,
	                    "工作台帮助手册正在完善中..."
	                );
	                if (sgiSrvUrl.HelpDoc["workbench"]) {
	                    var html = { __html: sgiSrvUrl.HelpDoc["workbench"] };
	                    xmlDoc = _react2.default.createElement('div', { dangerouslySetInnerHTML: html });
	                }
	                re.unshift(_react2.default.createElement(
	                    _antd.Card,
	                    { title: "工作台", extra: _react2.default.createElement('a', { style: { position: "relative", top: "-30" }, name: "workbench" }), style: { width: "100%", marginBottom: "5px" } },
	                    xmlDoc
	                ));
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: "100%", width: "100%", overflow: "hidden" } },
	                _react2.default.createElement(
	                    _antd.Layout,
	                    { style: { height: "100%" } },
	                    _react2.default.createElement(
	                        Sider,
	                        { style: { width: "auto" } },
	                        _react2.default.createElement(
	                            _antd.Menu,
	                            {
	                                defaultOpenKeys: [this.state.uid],
	                                defaultSelectedKeys: [this.state.uid],
	                                style: { height: "100%", width: "100%", overflowY: "auto", overflowX: "hidden" },
	                                mode: 'inline'
	                            },
	                            this.createMenus(navMenus)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        Content,
	                        { style: { boxSizing: "border-box", padding: "5px" } },
	                        re
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HelpDoc;
	}(_react2.default.Component);
	
	exports.default = HelpDoc;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(977);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(975);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(985);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Supplier from './workbench/Factor/supplier'
	
	
	var MainIndex = function (_Component) {
	  _inherits(MainIndex, _Component);
	
	  function MainIndex() {
	    _classCallCheck(this, MainIndex);
	
	    return _possibleConstructorReturn(this, (MainIndex.__proto__ || Object.getPrototypeOf(MainIndex)).apply(this, arguments));
	  }
	
	  _createClass(MainIndex, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_index2.default, null)
	      // <CoreFirm></CoreFirm>
	      // <Supplier></Supplier>
	      ;
	    }
	  }]);
	
	  return MainIndex;
	}(_react.Component);
	
	exports.default = MainIndex;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _Logout = __webpack_require__(521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ModifyPasswordC = function (_React$Component) {
	  _inherits(ModifyPasswordC, _React$Component);
	
	  function ModifyPasswordC() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ModifyPasswordC);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModifyPasswordC.__proto__ || Object.getPrototypeOf(ModifyPasswordC)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleSubmit = function (e) {
	      var me = _this;
	      e.preventDefault();
	      _this.props.form.validateFieldsAndScroll(function (err, values) {
	        if (!err) {
	          tool.sgiLogger.info('Received values of form: ', values);
	          _this.UamUserInfoQuery(values);
	        }
	      });
	    }, _this.handleConfirmPassword = function (rule, value, callback) {
	      var getFieldValue = _this.props.form.getFieldValue;
	
	      if (value && value !== getFieldValue('newPassword')) {
	        callback('两次输入不一致！');
	      }
	
	      // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
	      callback();
	    }, _this.jumpUrl = function (params) {
	      // tool.popSingleUI('/')
	      tool.goBack(-1);
	      // browserHistory.push({
	      //   pathname: '/'
	      // });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ModifyPasswordC, [{
	    key: 'encrypt',
	    value: function encrypt(val) {
	      if (!sgiConfig.PublicKey) return val;
	      var encrypt = new JSEncrypt();
	      encrypt.setPublicKey(sgiConfig.PublicKey);
	      return encrypt.encrypt(val);
	    }
	  }, {
	    key: 'UamUserInfoQuery',
	    value: function UamUserInfoQuery(values) {
	      console.log(values);
	      var req = {
	        "loginPwd": this.encrypt(values.oldPassword),
	        "newPwd": this.encrypt(values.newPassword),
	        userId: tool.getCookie('userId')
	      };
	      console.log(req);
	      var success = function success(res) {
	        console.log(res);
	        tool.sgiLogger.info(res, 'UamUserInfoQuery');
	        if (res && res.head.code == "0000") {
	          // 退出  重新登录
	          (0, _Logout.LogoutHandler)();
	          tool.popMessage('操作成功，请重新登录', "success");
	        } else {
	          tool.popMessage(res.head.msg, "warning");
	          return;
	        }
	      };
	      console.log(sgiConfig.allUrl.UamUserInfoQuery);
	      commonClient.simplecall(sgiConfig.allUrl.UamUserInfoQuery, req, success);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: {
	          xs: { span: 24 },
	          sm: { span: 6 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 18 }
	        }
	      };
	      var tailFormItemLayout = {
	        wrapperCol: {
	          xs: {
	            span: 24,
	            offset: 0
	          },
	          sm: {
	            span: 16,
	            offset: 8
	          }
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '420px', margin: '100px auto 0' } },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, {
	              label: '\u65E7\u5BC6\u7801'
	            }),
	            getFieldDecorator('oldPassword', {
	              rules: [{
	                required: true, message: '请填写旧密码!'
	              }]
	            })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, {
	              label: '\u65B0\u5BC6\u7801'
	            }),
	            getFieldDecorator('newPassword', {
	              rules: [{
	                required: true, message: '请填写新密码!' }, {
	                // pattern: /^.*(?=.*[A-Z]{1,})(?=.*[a-z]{1,})[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{6,16}$/,
	                pattern: /^(?![A-Za-z0-9]+$)(?![a-z0-9\W]+$)(?![A-Za-z\W]+$)(?![A-Z0-9\W]+$)^.{8,16}$/,
	                message: '长度8-16位，必须包含数字、大写字母、小写字母、特殊字符'
	              }]
	            })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            _extends({}, formItemLayout, {
	              label: '\u786E\u8BA4\u65B0\u5BC6\u7801'
	            }),
	            getFieldDecorator('confirmNewPassword', {
	              rules: [{
	                required: true, message: '请填写确认密码!'
	              }, {
	                validator: this.handleConfirmPassword
	              }]
	            })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            tailFormItemLayout,
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', htmlType: 'submit' },
	              '\u63D0 \u4EA4'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: this.jumpUrl, style: { marginLeft: '20px' } },
	              '\u53D6 \u6D88'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModifyPasswordC;
	}(_react2.default.Component);
	
	var ModifyPassword = _antd.Form.create()(ModifyPasswordC);
	exports.default = ModifyPassword;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIPreviewComp = __webpack_require__(999);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModifyUserInfo = function (_React$Component) {
	    _inherits(ModifyUserInfo, _React$Component);
	
	    function ModifyUserInfo(props) {
	        _classCallCheck(this, ModifyUserInfo);
	
	        var _this = _possibleConstructorReturn(this, (ModifyUserInfo.__proto__ || Object.getPrototypeOf(ModifyUserInfo)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ModifyUserInfo, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_UIPreviewComp.UIPreviewComp, { guid: 'gw_UI_user_0001',
	                transferData: {
	                    "@userId": tool.getCookie("id"),
	                    "@module": this
	                } });
	        }
	    }]);
	
	    return ModifyUserInfo;
	}(_react2.default.Component);
	
	exports.default = ModifyUserInfo;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(116);
	
	var _Main = __webpack_require__(2006);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _rtSdCommon = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainBreadcrumb = function (_Component) {
	    _inherits(MainBreadcrumb, _Component);
	
	    function MainBreadcrumb(props) {
	        _classCallCheck(this, MainBreadcrumb);
	
	        var _this = _possibleConstructorReturn(this, (MainBreadcrumb.__proto__ || Object.getPrototypeOf(MainBreadcrumb)).call(this, props));
	
	        _this.getMsg = function () {
	            // console.log('nikNam', tool.getCookie("nikNam"))
	            var req = {
	                values: {
	                    receiverNam: tool.getCookie("nikNam") + ',' + tool.getCookie("userId")
	                }
	            };
	            var success = function success(res) {
	                if (res && res.head.code === "0000") {
	                    console.log('list', res.body);
	                    _this.state.msgList = res.body ? res.body : [];
	                } else {
	                    _antd.message.warning(res.head.msg);
	                }
	            };
	            commonClient.simplecall(_rtSdCommon.sgiConfig.service_msg + "/inmail/my/noread/list", req, success);
	        };
	
	        _this.goWarning = function (info) {
	            var _JSON$parse = JSON.parse(info.sendRcd.extendParam),
	                warnInfoCode = _JSON$parse.warnInfoCode;
	
	            console.log('warnInfoCode', warnInfoCode);
	            var req = {
	                warnInfoCode: warnInfoCode
	            };
	            var success = function success(res) {
	                if (res && res.head.code === "0000") {
	                    console.log('msgList', res.body);
	                    tool.popUIByUcv('scfp_UI_0102006', { 'db_form_editdata': res.body }, "预警信息处理详情");
	                    _this.senReaded(info);
	                } else {
	                    _antd.message.warning(res.head.msg);
	                }
	            };
	            commonClient.simplecall(_rtSdCommon.sgiConfig.service_finc + "/risk/warn/info/detail", req, success);
	        };
	
	        _this.senReaded = function (info) {
	            var pk = info.pk,
	                vsn = info.vsn;
	
	            var req = {
	                pk: pk, vsn: vsn
	            };
	            var success = function success(res) {
	                if (res && res.head.code === "0000") {
	                    console.log('res', res);
	                    _this.getMsg();
	                } else {
	                    _antd.message.warning(res.head.msg);
	                }
	            };
	            commonClient.simplecall(_rtSdCommon.sgiConfig.service_msg + "/inmail/read", req, success);
	        };
	
	        _this.state = {
	            msgList: []
	        };
	        return _this;
	    }
	
	    _createClass(MainBreadcrumb, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.getMsg();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var msgList = this.state.msgList;
	
	            if (msgList.length > 0) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: _Main2.default.breadTips },
	                    _react2.default.createElement(
	                        _antd.Carousel,
	                        { autoplay: true, dots: 'false' },
	                        msgList.map(function (x) {
	                            // return <Link to={'/scfp_UI_0102006?uuid=1E8D22AA-650A-462C-A151-CC5EFF1EFE21'}> { x.msgContent } </Link>;
	                            // return <Button type="link" size="small" className={style.breadTipsWords} onClick={() => this.goWarning(x)}> { x.msgContent } </Button>
	                            return _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: _Main2.default.breadTipsBox },
	                                    _react2.default.createElement(_antd.Icon, { type: 'sound', theme: 'filled', className: _Main2.default.breadTipsIcon }),
	                                    _react2.default.createElement(
	                                        _antd.Button,
	                                        { type: 'link', size: 'small', className: _Main2.default.breadTipsBtn + ' ' + _Main2.default.breadTipsWords, onClick: function onClick() {
	                                                return _this2.goWarning(x);
	                                            } },
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: _Main2.default.breadTipsWords },
	                                            x.msgContent
	                                        )
	                                    )
	                                )
	                            );
	                        })
	                    )
	                );
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return MainBreadcrumb;
	}(_react.Component);
	
	exports.default = MainBreadcrumb;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	__webpack_require__(1992);
	
	var _empty = __webpack_require__(2007);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubMenu = _antd.Menu.SubMenu;
	
	
	var Empty = function Empty() {
	  return _react2.default.createElement(
	    "div",
	    { className: _empty2.default.empty },
	    "\u60A8\u65E0\u7CFB\u7EDF\u83DC\u5355\u6743\u9650\uFF0C",
	    _react2.default.createElement("br", null),
	    "\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u8FDB\u884C\u8BBE\u7F6E"
	  );
	};
	
	var DlMenu = function (_Component) {
	  _inherits(DlMenu, _Component);
	
	  function DlMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DlMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DlMenu.__proto__ || Object.getPrototypeOf(DlMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      CurrtentUid: "", //当前菜单id
	      openKeys: []
	    }, _this.itemClick = function (item) {
	      _this.setState({
	        CurrtentUid: item.uid
	      });
	      tool.sgiLogger.time("storage清理");
	      // 清除页面uuid的storage缓存
	      tool.sgiStorage.removeByPrefix(sgiConfig.keyPre_uuid);
	      // 清除回显storage缓存
	      tool.sgiStorage.removeByPrefix(sgiConfig.keyPre_echo);
	      tool.sgiLogger.timeEnd("storage清理");
	      tool.sgiLogger.time("正常跳转");
	      tool.sgiLogger.info(item);
	      tool.initBreadcrumbArr();
	      tool.jumpByBrowserHistory(item.routeParam, {
	        uid: item.uid,
	        "@optParam": item.optParam,
	        "@excuteInfo": item.excuteInfo,
	        name: item.menuNam
	      });
	      tool.sgiLogger.timeEnd("正常跳转");
	      tool.sgiLogger.time("setTimeout清理");
	      // 渲染完成后，再次清理回显storage缓存
	      setTimeout(function () {
	        tool.sgiStorage.removeByPrefix(sgiConfig.keyPre_echo);
	      }, 0);
	      tool.sgiLogger.timeEnd("setTimeout清理");
	      document.body.click();
	    }, _this.loopMenu = function (menus) {
	      var defaultProps = {
	        code: "menuId",
	        name: "menuNam"
	      };
	      return menus.map(function (item) {
	        if (item.children && item.children.length) {
	          return _react2.default.createElement(
	            SubMenu,
	            {
	              key: item[defaultProps.code],
	              title: _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(_antd.Icon, { type: "appstore" }),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  item[defaultProps.name]
	                )
	              )
	            },
	            _this.loopMenu(item.children)
	          );
	        }
	        return _react2.default.createElement(
	          _antd.Menu.Item,
	          {
	            onClick: function onClick() {
	              return _this.itemClick(item);
	            },
	            key: item[defaultProps.code],
	            title: item[defaultProps.name]
	          },
	          item[defaultProps.name]
	        );
	      });
	    }, _this.onOpenChange = function (keys) {
	      var rootSubmenuKeys = _this.props.navMenus.map(function (el) {
	        return el['menuId'];
	      }) || [];
	      var latestOpenKey = keys.find(function (key) {
	        return _this.state.openKeys.indexOf(key) === -1;
	      });
	      if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
	        _this.setState({ openKeys: keys });
	      } else {
	        _this.setState({
	          openKeys: latestOpenKey ? [latestOpenKey] : []
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DlMenu, [{
	    key: "render",
	    value: function render() {
	      var isEmpty = this.props.navMenus.length === 0;
	      return !isEmpty ? _react2.default.createElement(
	        _antd.Menu,
	        {
	          className: "DlMenu",
	          mode: "inline",
	          openKeys: this.state.openKeys,
	          onOpenChange: this.onOpenChange,
	          style: { width: 200 }
	        },
	        this.loopMenu(this.props.navMenus)
	      ) : _react2.default.createElement(Empty, null);
	    }
	  }]);
	
	  return DlMenu;
	}(_react.Component);
	
	exports.default = DlMenu;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _reactRouter = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import routes from '../routes';
	
	var Header = _antd.Layout.Header;
	
	var MainBreadcrumb = function (_Component) {
	    _inherits(MainBreadcrumb, _Component);
	
	    function MainBreadcrumb(props) {
	        _classCallCheck(this, MainBreadcrumb);
	
	        var _this = _possibleConstructorReturn(this, (MainBreadcrumb.__proto__ || Object.getPrototypeOf(MainBreadcrumb)).call(this, props));
	
	        _this.state = {
	            breadcrumbDataList: [],
	            loading: false
	        };
	        return _this;
	    }
	
	    _createClass(MainBreadcrumb, [{
	        key: 'refresh',
	        value: function refresh(breadcrumbList) {
	            this.state.breadcrumbDataList = breadcrumbList || [];
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'pushItem',
	        value: function pushItem(data) {
	
	            if (!data) {
	                return;
	            }
	
	            var existIndex = -1;
	            var maxIndex = this.state.breadcrumbDataList.length - 1;
	            this.state.breadcrumbDataList.forEach(function (element, index) {
	                if (element.path == data.path) {
	                    existIndex = index;
	                }
	            });
	
	            if (existIndex >= 0) {
	                this.state.breadcrumbDataList.splice(existIndex, maxIndex - existIndex);
	            } else {
	
	                this.state.breadcrumbDataList.push(data);
	            }
	
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(path) {
	
	            var existIndex = -1;
	            var maxIndex = this.state.breadcrumbDataList.length - 1;
	            this.state.breadcrumbDataList.forEach(function (element, index) {
	                if ((element.path || element.describe) == path) {
	                    existIndex = index;
	                }
	            });
	
	            if (existIndex >= 0) {
	                this.state.breadcrumbDataList.splice(existIndex + 1, maxIndex - existIndex);
	                this.setState({ loading: false });
	                _reactRouter.browserHistory.go(existIndex - maxIndex);
	            }
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack(n) {
	            // this.state.breadcrumbDataList.pop();
	            // this.setState();
	
	            if (n) {
	                tool.sgiLogger.info(n);
	                if (n < 0) {
	                    for (var index = 0; index > n; index--) {
	                        this.state.breadcrumbDataList.pop();
	                    }
	                }
	            } else {
	                this.state.breadcrumbDataList.pop();
	            }
	            this.setState();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var BreadcrumbItemList = [];
	            if (this.state.breadcrumbDataList && this.state.breadcrumbDataList.length > 0) {
	                this.state.breadcrumbDataList.forEach(function (element) {
	                    if (element.path || element.describe) {
	                        BreadcrumbItemList.push(_react2.default.createElement(
	                            _antd.Breadcrumb.Item,
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { onClick: _this2.onClick.bind(_this2, element.path || element.describe) },
	                                element.name
	                            )
	                        ));
	                        // BreadcrumbItemList.push(<Breadcrumb.Item><Link onClick={this.onClick.bind(this)} to={element.path + '?uid=' + element.uid}>{element.title}</Link></Breadcrumb.Item>)
	                    } else {
	                        BreadcrumbItemList.push(_react2.default.createElement(
	                            _antd.Breadcrumb.Item,
	                            null,
	                            element.name
	                        ));
	                    }
	                });
	            }
	
	            return _react2.default.createElement(
	                _antd.Breadcrumb,
	                null,
	                _react2.default.createElement(
	                    _antd.Breadcrumb.Item,
	                    null,
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/main', onClick: function onClick() {
	                                _this2.setState({ breadcrumbDataList: [] });
	                            } },
	                        ' \u9996\u9875'
	                    )
	                ),
	                BreadcrumbItemList
	            );
	        }
	    }]);
	
	    return MainBreadcrumb;
	}(_react.Component);
	
	exports.default = MainBreadcrumb;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(25);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainBreadcrumb = __webpack_require__(966);
	
	var _MainBreadcrumb2 = _interopRequireDefault(_MainBreadcrumb);
	
	var _Tips = __webpack_require__(964);
	
	var _Tips2 = _interopRequireDefault(_Tips);
	
	__webpack_require__(1993);
	
	var _rtSdCommon = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notice = function (_Component) {
	  _inherits(Notice, _Component);
	
	  function Notice() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Notice);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.getUserInfo = function (userId) {
	      var req = { userId: userId };
	      var success = function success(res) {
	        if (res && res.head.code === "0000") {
	          console.log('getUserInfo', res.body);
	          var userNam = res.body.userNam;
	          // this.state.msgList = res.body ? res.body : [];
	        } else {
	            // message.warning(res.head.msg);
	          }
	      };
	      commonClient.simplecall(sgiConfig.service_uam + '/user/getUserInfoByUserId', req, success);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Notice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.MainBreadcrumb = this.refs.MainBreadcrumb;
	      //let userId = tool.getCookie('userId');
	      //console.log(`当前userId：${userId}`);
	      //this.getUserInfo(userId)
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Card,
	        { className: 'Notice' },
	        _react2.default.createElement(_MainBreadcrumb2.default, { ref: 'MainBreadcrumb' }),
	        _react2.default.createElement(_Tips2.default, null)
	      );
	    }
	  }]);
	
	  return Notice;
	}(_react.Component);
	
	exports.default = Notice;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var columns1 = [{
	  title: '序号',
	  dataIndex: 'name',
	  key: 'name'
	}, {
	  title: '流程名称',
	  dataIndex: 'age',
	  key: 'age'
	}, {
	  title: '任务摘要',
	  dataIndex: 'address',
	  key: 'address'
	}, {
	  title: '送达时间',
	  dataIndex: 'date',
	  key: 'date'
	}];
	var dataSource = [{
	  key: '1',
	  name: '胡彦斌',
	  age: 32,
	  address: '西湖区湖底公园1号'
	}, {
	  key: '2',
	  name: '胡彦祖',
	  age: 42,
	  address: '西湖区湖底公园1号'
	}];
	
	var SysInfos = function (_Component) {
	  _inherits(SysInfos, _Component);
	
	  function SysInfos() {
	    _classCallCheck(this, SysInfos);
	
	    return _possibleConstructorReturn(this, (SysInfos.__proto__ || Object.getPrototypeOf(SysInfos)).apply(this, arguments));
	  }
	
	  _createClass(SysInfos, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Tabs,
	        { defaultActiveKey: '1' },
	        _react2.default.createElement(
	          TabPane,
	          { tab: '\u6211\u7684\u5F85\u529E', key: '1' },
	          _react2.default.createElement(_antd.Table, { columns: columns1, dataSource: dataSource, pagination: false })
	        ),
	        _react2.default.createElement(
	          TabPane,
	          { tab: '\u6211\u7684\u6D88\u606F', key: '2' },
	          _react2.default.createElement(_antd.Table, { columns: columns1, dataSource: dataSource, pagination: false })
	        ),
	        _react2.default.createElement(
	          TabPane,
	          { tab: '\u6211\u5F00\u7ACB\u7684\u7CAE\u4FE1', key: '3' },
	          _react2.default.createElement(_antd.Table, { columns: columns1, dataSource: dataSource, pagination: false })
	        ),
	        _react2.default.createElement(
	          TabPane,
	          { tab: '\u5373\u5C06\u5230\u671F\u4ED8\u6B3E(\u7CAE\u4FE1)', key: '4' },
	          _react2.default.createElement(_antd.Table, { columns: columns1, dataSource: dataSource, pagination: false })
	        ),
	        _react2.default.createElement(
	          TabPane,
	          { tab: '\u5373\u5C06\u5230\u671F\u4ED8\u6B3E(\u975E\u7CAE\u4FE1)', key: '5' },
	          _react2.default.createElement(_antd.Table, { columns: columns1, dataSource: dataSource, pagination: false })
	        )
	      );
	    }
	  }]);
	
	  return SysInfos;
	}(_react.Component);
	
	exports.default = SysInfos;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	__webpack_require__(1991);
	
	var _icon_db = __webpack_require__(2025);
	
	var _icon_db2 = _interopRequireDefault(_icon_db);
	
	var _icon_zczc = __webpack_require__(2029);
	
	var _icon_zczc2 = _interopRequireDefault(_icon_zczc);
	
	var _icon_dqzc = __webpack_require__(2026);
	
	var _icon_dqzc2 = _interopRequireDefault(_icon_dqzc);
	
	var _icon_xx = __webpack_require__(2028);
	
	var _icon_xx2 = _interopRequireDefault(_icon_xx);
	
	var _icon_qs = __webpack_require__(2027);
	
	var _icon_qs2 = _interopRequireDefault(_icon_qs);
	
	var _icon_zr = __webpack_require__(2030);
	
	var _icon_zr2 = _interopRequireDefault(_icon_zr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function DlCard(props) {
	  var imgUrl = props.imgUrl,
	      title = props.title,
	      content = props.content;
	
	  return _react2.default.createElement(
	    _antd.Card,
	    { className: 'DlCard' },
	    _react2.default.createElement(
	      'div',
	      { className: 'left' },
	      _react2.default.createElement('img', { src: imgUrl })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'right' },
	      _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        content
	      )
	    )
	  );
	}
	
	var TodoList = function (_Component) {
	  _inherits(TodoList, _Component);
	
	  function TodoList() {
	    _classCallCheck(this, TodoList);
	
	    return _possibleConstructorReturn(this, (TodoList.__proto__ || Object.getPrototypeOf(TodoList)).apply(this, arguments));
	  }
	
	  _createClass(TodoList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Row,
	        { gutter: [16, 16], style: { marginBottom: '10px' } },
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 8 },
	          _react2.default.createElement(DlCard, { imgUrl: _icon_db2.default, title: '我的待办', content: 0 })
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 8 },
	          _react2.default.createElement(DlCard, { imgUrl: _icon_zczc2.default, title: '我开立的粮信', content: '\uFFE5' + 0 .toFixed(2) })
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 8 },
	          _react2.default.createElement(DlCard, { imgUrl: _icon_dqzc2.default, title: '即将到期付款(粮信)', content: '\uFFE5' + 0 .toFixed(2) })
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 8 },
	          _react2.default.createElement(DlCard, { imgUrl: _icon_xx2.default, title: '我的消息', content: 0 })
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 8 },
	          _react2.default.createElement(DlCard, { imgUrl: _icon_qs2.default, title: '即将到期付款(非粮信)', content: '\uFFE5' + 0 .toFixed(2) })
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 8 },
	          _react2.default.createElement(DlCard, { imgUrl: _icon_zr2.default, title: '可用授信额度', content: '\uFFE5' + 0 .toFixed(2) })
	        )
	      );
	    }
	  }]);
	
	  return TodoList;
	}(_react.Component);
	
	exports.default = TodoList;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pubsubJs = __webpack_require__(1918);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _reactRouter = __webpack_require__(116);
	
	__webpack_require__(1994);
	
	var _antd = __webpack_require__(25);
	
	var _Notice = __webpack_require__(967);
	
	var _Notice2 = _interopRequireDefault(_Notice);
	
	var _TodoList = __webpack_require__(969);
	
	var _TodoList2 = _interopRequireDefault(_TodoList);
	
	var _SysInfos = __webpack_require__(968);
	
	var _SysInfos2 = _interopRequireDefault(_SysInfos);
	
	var _DlMenu = __webpack_require__(965);
	
	var _DlMenu2 = _interopRequireDefault(_DlMenu);
	
	var _code = __webpack_require__(2024);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _x = __webpack_require__(445);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _routes = __webpack_require__(288);
	
	var _ModifyPassword = __webpack_require__(971);
	
	var _ModifyPassword2 = _interopRequireDefault(_ModifyPassword);
	
	var _UserInfos = __webpack_require__(973);
	
	var _UserInfos2 = _interopRequireDefault(_UserInfos);
	
	var _Logout = __webpack_require__(521);
	
	var _Logout2 = _interopRequireDefault(_Logout);
	
	var _index = __webpack_require__(972);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _rtSdCommon = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import mainLogo from "./icon/mk_logo-bl.png";
	
	// 引入功能组件
	
	// import Lock from "./operation/Lock";
	
	
	var Header = _antd.Layout.Header,
	    Sider = _antd.Layout.Sider,
	    Content = _antd.Layout.Content,
	    Footer = _antd.Layout.Footer;
	
	
	var menu =
	// <div></div>
	_react2.default.createElement(
	  _antd.Menu,
	  null,
	  _react2.default.createElement(
	    _antd.Menu.Item,
	    null,
	    _react2.default.createElement(_ModifyPassword2.default, null)
	  )
	);
	
	var indexPage = function (_Component) {
	  _inherits(indexPage, _Component);
	
	  function indexPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, indexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = indexPage.__proto__ || Object.getPrototypeOf(indexPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      navMenus: [] //菜单
	    }, _this.testpub = function () {
	      _rtSdCommon.tool.initBreadcrumbArr();
	      _rtSdCommon.tool.popSingleUI("/main");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(indexPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.getMenuByServer();
	    }
	  }, {
	    key: "getMenuByStorage",
	    value: function getMenuByStorage() {
	      var navMenus = JSON.parse(sessionStorage.getItem("asyncRoutes"));
	      if (!navMenus) return this.getMenuByServer();
	      this.setState({
	        navMenus: navMenus
	      });
	      window.menuByServer = navMenus;
	      //创建路由
	      (0, _routes.menusForEach)(navMenus);
	      console.log(navMenus);
	      _pubsubJs2.default.publish("setRoutes", navMenus);
	    }
	    // 获取菜单树
	
	  }, {
	    key: "getMenuByServer",
	    value: function getMenuByServer() {
	      var me = this;
	      var success = function success(res) {
	        if (res && res.head.code == "0000") {
	          var navMenus = res.body || [];
	          // 缓存menu
	          var asyncRoutes = JSON.stringify(navMenus);
	          sessionStorage.setItem("asyncRoutes", asyncRoutes);
	
	          me.setState({
	            navMenus: navMenus
	          });
	          window.menuByServer = navMenus;
	          //创建路由
	          (0, _routes.menusForEach)(navMenus);
	          _pubsubJs2.default.publish("setRoutes", navMenus);
	        }
	      };
	      commonClient.simplecall(sgiConfig.allUrl.userMenus, { channelId: "0" }, success, true);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var userName = _rtSdCommon.tool.getCookie("nikNam");
	      var hasToken = _rtSdCommon.tool.getCookie("token");
	      if (!hasToken) return null;
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _antd.Layout,
	          { className: "layout" },
	          _react2.default.createElement(
	            Sider,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "mainLogo" },
	              _react2.default.createElement("img", { onClick: this.testpub, src: _x2.default })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "menu_outer" },
	              _react2.default.createElement(_DlMenu2.default, { navMenus: this.state.navMenus })
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Layout,
	            { className: "layou_container" },
	            _react2.default.createElement(
	              Header,
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "header_title" },
	                _react2.default.createElement(_Logout2.default, { className: "userTitle" }),
	                _react2.default.createElement(
	                  _antd.Dropdown,
	                  { overlay: menu, placement: "bottomLeft" },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "userTitle" },
	                    _react2.default.createElement(_antd.Icon, { type: "user" }),
	                    "\xA0 ",
	                    userName
	                  )
	                )
	              ),
	              _react2.default.createElement(_Notice2.default, null)
	            ),
	            _react2.default.createElement(
	              Content,
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "ContentMain" },
	                this.props.children
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return indexPage;
	}(_react.Component);
	
	exports.default = indexPage;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ModifyPassword;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _rtSdCommon = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modifyPassword = function modifyPassword() {
	  // tool.popUIByUcv("rtuam_UI_setting.sub_00600001-01", {}, "修改密码");
	  _rtSdCommon.tool.popSingleUI('/main/ModifyUserInfo', {}, '修改密码');
	};
	
	function ModifyPassword(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: props.className, onClick: modifyPassword },
	    _react2.default.createElement(_antd.Icon, { type: "setting" }),
	    "\xA0\xA0\xA0",
	    _react2.default.createElement(
	      "span",
	      null,
	      "\u4FEE\u6539\u5BC6\u7801"
	    )
	  );
	}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var msglist = [1, 2, 3, 4, 5, 6];
	var itemStyle = {
	  width: '200px',
	  height: '40px',
	  lineHeight: '40px',
	  boxSizing: 'border-box',
	  padding: '0 10px',
	  display: 'flex',
	  justifyContent: 'space-between',
	  fontSize: '12px'
	  // borderBottom: '1px solid '
	};
	var menu = _react2.default.createElement(
	  _antd.Menu,
	  null,
	  msglist.map(function (el) {
	    return _react2.default.createElement(
	      _antd.Menu.Item,
	      { key: el },
	      _react2.default.createElement(
	        'div',
	        { style: itemStyle },
	        _react2.default.createElement(
	          'div',
	          null,
	          '\u6D88\u606F\u7684title\u3002\u3002'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          '2022-12-23'
	        )
	      )
	    );
	  })
	);
	
	var MsgList = function (_Component) {
	  _inherits(MsgList, _Component);
	
	  function MsgList() {
	    _classCallCheck(this, MsgList);
	
	    return _possibleConstructorReturn(this, (MsgList.__proto__ || Object.getPrototypeOf(MsgList)).apply(this, arguments));
	  }
	
	  _createClass(MsgList, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Dropdown,
	        { overlay: menu, placement: 'bottomCenter' },
	        _react2.default.createElement(
	          'div',
	          { className: this.props.className },
	          _react2.default.createElement(_antd.Icon, { type: 'smile' })
	        )
	      );
	    }
	  }]);
	
	  return MsgList;
	}(_react.Component);
	
	exports.default = MsgList;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UserInfos;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modifyUserInfo = function modifyUserInfo() {
	  tool.popSingleUI("/ModifyUserInfo");
	};
	function UserInfos(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.className, onClick: modifyUserInfo },
	    _react2.default.createElement(_antd.Icon, { type: 'appstore' }),
	    '\xA0\xA0\xA0',
	    _react2.default.createElement(
	      'span',
	      null,
	      '\u67E5\u770B\u7528\u6237\u4FE1\u606F'
	    )
	  );
	}

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = UseProduct;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Opraiton = function Opraiton(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _antd.Button,
	      { type: 'primary', size: 'small', style: { margin: '0 5px', fontSize: '12px' } },
	      '\u5173\u95ED\u4FE1\u7528'
	    ),
	    _react2.default.createElement(
	      _antd.Button,
	      { type: 'primary', size: 'small', style: { margin: '0 5px', fontSize: '12px' } },
	      '\u7533\u8BF7\u63D0\u5347\u989D\u5EA6'
	    ),
	    _react2.default.createElement(
	      _antd.Button,
	      { type: 'primary', size: 'small', style: { margin: '0 5px', fontSize: '12px' } },
	      '\u878D\u8D44'
	    ),
	    _react2.default.createElement(
	      _antd.Button,
	      { type: 'primary', size: 'small', style: { margin: '0 5px', fontSize: '12px' } },
	      '\u5173\u95ED'
	    )
	  );
	};
	
	var columns = [{ title: '金融机构', dataIndex: 'name', key: 'name' }, { title: '融资产品代号', dataIndex: 'age', key: 'age' }, { title: '融资产品名称呢过', dataIndex: 'address', key: 'address' }, { title: '授信状态', dataIndex: 'address1', key: 'address1' }, { title: '授信额度', dataIndex: 'address2', key: 'address2' }, { title: '总放款', dataIndex: 'address3', key: 'address3' }, { title: '融资余额', dataIndex: 'address4', key: 'address4' }, { title: '融资产品名称呢过', dataIndex: 'address5', key: 'address5' }, {
	  title: '操作',
	  dataIndex: '',
	  width: 300,
	  fixed: 'right',
	  key: 'x',
	  render: function render() {
	    return _react2.default.createElement(Opraiton, null);
	  }
	}].map(function (el) {
	  return _extends({}, el, {
	    ellipsis: true,
	    align: 'center'
	  });
	});
	
	var data = [{
	  key: 1,
	  name: 'John Brown',
	  age: 32,
	  address: 'New York No. 1 Lake Park',
	  description: 'My name is John Brown, I am 32 years old, living in New York No. 1 Lake Park.'
	}, {
	  key: 2,
	  name: 'Jim Green',
	  age: 42,
	  address: 'London No. 1 Lake Park',
	  description: 'My name is Jim Green, I am 42 years old, living in London No. 1 Lake Park.'
	}, {
	  key: 3,
	  name: 'Joe Black',
	  age: 32,
	  address: 'Sidney No. 1 Lake Park',
	  description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.'
	}, {
	  key: 4,
	  name: 'Joe Black',
	  age: 32,
	  address: 'Sidney No. 1 Lake Park',
	  description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.'
	}, {
	  key: 5,
	  name: 'Joe Black',
	  age: 32,
	  address: 'Sidney No. 1 Lake Park',
	  description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.'
	}, {
	  key: 6,
	  name: 'Joe Black',
	  age: 32,
	  address: 'Sidney No. 1 Lake Park',
	  description: 'My name is Joe Black, I am 32 years old, living in Sidney No. 1 Lake Park.'
	}];
	
	function UseProduct() {
	  return _react2.default.createElement(_antd.Table, {
	    columns: columns,
	    expandedRowRender: function expandedRowRender(record) {
	      return _react2.default.createElement(
	        'p',
	        { style: { margin: 0 } },
	        record.description
	      );
	    },
	    dataSource: data,
	    bordered: true
	  });
	}

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	__webpack_require__(2008);
	
	var _UseProduct = __webpack_require__(974);
	
	var _UseProduct2 = _interopRequireDefault(_UseProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Panel = _antd.Collapse.Panel;
	
	var CoreFirm = function (_Component) {
	  _inherits(CoreFirm, _Component);
	
	  function CoreFirm() {
	    _classCallCheck(this, CoreFirm);
	
	    return _possibleConstructorReturn(this, (CoreFirm.__proto__ || Object.getPrototypeOf(CoreFirm)).apply(this, arguments));
	  }
	
	  _createClass(CoreFirm, [{
	    key: 'render',
	    value: function render() {
	      var noticelist = [1, 2, 3, 4, 5];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          {
	            title: _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(_antd.Icon, { type: 'windows' }),
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#666', fontSize: '12px', marginLeft: '20px' } },
	                '\u5728\u7528\u4EA7\u54C1'
	              )
	            ),
	            bordered: false,
	            style: { boxShadow: '0 0 4px 0 rgb(57 103 153 / 20%)', marginBottom: '20px' } },
	          _react2.default.createElement(_UseProduct2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return CoreFirm;
	}(_react.Component);
	
	exports.default = CoreFirm;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexList = function (_Component) {
	  _inherits(IndexList, _Component);
	
	  function IndexList() {
	    _classCallCheck(this, IndexList);
	
	    return _possibleConstructorReturn(this, (IndexList.__proto__ || Object.getPrototypeOf(IndexList)).apply(this, arguments));
	  }
	
	  _createClass(IndexList, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var isAdmin = tool.getCookie('roleCodes').includes('ROLE20211207005');
	      var list = [];
	      if (isAdmin) {
	        list = this.props.list.filter(function (el) {
	          return !['待还款', '已融资', '统计报表'].includes(el.type);
	        });
	      } else {
	        list = this.props.list.filter(function (el) {
	          return !['统计报表'].includes(el.type);
	        });
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: 16 },
	          list.map(function (el) {
	            var count = el.count;
	
	            if (el.format) {
	              count = el.format(count, 2);
	            }
	            return _react2.default.createElement(
	              _antd.Col,
	              { span: _this2.props.span, style: { marginBottom: '15px' } },
	              _react2.default.createElement(
	                _antd.Card,
	                { bordered: false, style: { boxShadow: '0 0 4px 0 rgb(57 103 153 / 20%)' } },
	                _react2.default.createElement(
	                  "div",
	                  { style: { display: 'flex', height: '70px' } },
	                  _react2.default.createElement(
	                    "div",
	                    { style: { width: '70px' } },
	                    _react2.default.createElement("img", { src: el.img, style: { width: '70px', height: '70px' } })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "left", style: { flex: 1, boxSizing: 'border-box', paddingLeft: '15px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { style: { height: '35px', lineHeight: '35px', fontSize: '16px' } },
	                      el.type
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { style: { height: '35px', lineHeight: '35px', fontSize: '24px', fontWeight: '400' } },
	                      el.prefix ? el.prefix + count : count
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return IndexList;
	}(_react.Component);
	
	exports.default = IndexList;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IndexList = __webpack_require__(976);
	
	var _IndexList2 = _interopRequireDefault(_IndexList);
	
	var _TabList = __webpack_require__(983);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _icon_db = __webpack_require__(2014);
	
	var _icon_db2 = _interopRequireDefault(_icon_db);
	
	var _icon_zczc = __webpack_require__(2018);
	
	var _icon_zczc2 = _interopRequireDefault(_icon_zczc);
	
	var _icon_dqzc = __webpack_require__(2015);
	
	var _icon_dqzc2 = _interopRequireDefault(_icon_dqzc);
	
	var _icon_xx = __webpack_require__(2017);
	
	var _icon_xx2 = _interopRequireDefault(_icon_xx);
	
	var _icon_qs = __webpack_require__(2016);
	
	var _icon_qs2 = _interopRequireDefault(_icon_qs);
	
	var _icon_zr = __webpack_require__(2019);
	
	var _icon_zr2 = _interopRequireDefault(_icon_zr);
	
	var _TodoList = __webpack_require__(984);
	
	var _TodoList2 = _interopRequireDefault(_TodoList);
	
	var _NoRepayment = __webpack_require__(979);
	
	var _NoRepayment2 = _interopRequireDefault(_NoRepayment);
	
	var _LiangXin = __webpack_require__(978);
	
	var _LiangXin2 = _interopRequireDefault(_LiangXin);
	
	var _PaymentXin = __webpack_require__(981);
	
	var _PaymentXin2 = _interopRequireDefault(_PaymentXin);
	
	var _PayMent = __webpack_require__(980);
	
	var _PayMent2 = _interopRequireDefault(_PayMent);
	
	var _StaticReport = __webpack_require__(982);
	
	var _StaticReport2 = _interopRequireDefault(_StaticReport);
	
	var _antd = __webpack_require__(25);
	
	var _index = __webpack_require__(2009);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cnyFormat = function cnyFormat(num, len) {
	  if (!num) return '0.00';
	  if (num == '0.00') return '0.00';
	  num = num * 1;
	  var c = num.toFixed(len).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	  return c;
	};
	
	var Factor = function (_Component) {
	  _inherits(Factor, _Component);
	
	  function Factor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Factor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Factor.__proto__ || Object.getPrototypeOf(Factor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      root: [{
	        name: '供应商',
	        code: '03'
	      }, {
	        name: '核心企业',
	        code: '01'
	      }, {
	        name: '蒙元保理商',
	        code: '04'
	      }, {
	        name: '核心企业子公司',
	        code: '02'
	      }, {
	        name: '蒙牛集团',
	        code: '05'
	      }],
	      list: [
	      // {
	      //   id:4,
	      //   img:xx,
	      //   type:'我的消息',
	      //   count: '2',
	      //   root:['01','02','03','04','05'],
	      //   component: <MsgList></MsgList>
	      // },
	      {
	        id: 1,
	        img: _icon_db2.default,
	        type: '我的待办',
	        count: '0',
	        format: false,
	        root: ['01', '02', '03', '04', '05'],
	        component: _react2.default.createElement(_TodoList2.default, { getCount: function getCount(count) {
	            _this.getCount(count, '我的待办');
	          } })
	      }, {
	        id: 9,
	        img: _icon_zr2.default,
	        type: '总授信额度',
	        field: 'creditAmt',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['01', '02'],
	        component: null
	      }, {
	        id: 10,
	        img: _icon_zr2.default,
	        type: '授信使用额度',
	        field: 'usedAmt',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['01', '02'],
	        component: null
	      }, {
	        id: 11,
	        img: _icon_zr2.default,
	        type: '授信余额',
	        field: 'usabledAmt',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['01', '02'],
	        component: null
	      }, {
	        id: 2,
	        img: _icon_zczc2.default,
	        type: '待还款',
	        field: 'toFactoringAmt',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['01', '02'],
	        component: _react2.default.createElement(_NoRepayment2.default, null)
	      }, {
	        id: 2,
	        img: _icon_zczc2.default,
	        type: '未回款金额',
	        TabPaneName: '待还款',
	        field: 'toRepayAmt',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['04'],
	        component: _react2.default.createElement(_NoRepayment2.default, null)
	      }, {
	        id: 3,
	        img: _icon_dqzc2.default,
	        type: '已融资',
	        field: 'raisedAmt',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['03'],
	        component: null
	      }, {
	        id: 5,
	        img: _icon_qs2.default,
	        type: '已融资笔数',
	        field: 'fincCount',
	        format: false,
	        count: '0',
	        root: ['04'],
	        component: null
	      }, {
	        id: 6,
	        img: _icon_zr2.default,
	        type: '已还款',
	        field: 'repayAmt',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['04'],
	        component: _react2.default.createElement(_PayMent2.default, null)
	      }, {
	        id: 7,
	        img: _icon_zr2.default,
	        type: '放款总金额',
	        field: 'factoringAmt',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['04'],
	        component: null
	      }, {
	        id: 8,
	        img: _icon_qs2.default,
	        type: '统计报表',
	        field: 'staticReport',
	        format: cnyFormat,
	        prefix: '￥',
	        count: '0',
	        root: ['04'],
	        component: _react2.default.createElement(_StaticReport2.default, null)
	      }]
	    }, _this.checkInfo = function () {
	      var list = tool.getCookie('roleCodes').split(',');
	      if (!list.includes('ROLE20220124002') && !list.includes('ROLE20230621001')) {
	        return;
	      }
	      var param = {
	        "values": {
	          "ap": "mn",
	          "source": "imp",
	          "roleCodes": tool.getCookie('roleCodes'),
	          "prodCode": "mn0000",
	          "fincStatus": 59
	        },
	        "matchs": {
	          "source": "NotEqualTo"
	        }
	      };
	      commonClient.simplecall(sgiConfig.service_finc + "/finc/list", param, function (res) {
	        if (res.head.code === '0000') {
	          if (res.body && res.body.length > 0) {
	            var arr = res.body.map(function (el) {
	              return el.batchCode;
	            });
	            _this.warning(arr.join('，'));
	          }
	        } else {
	          _antd.message.error(res.head.msg);
	        }
	      }, false, null, null, function (request) {
	        request.head.pageSize = 50;
	        request.head.offset = 1;
	        request.head.queryTotal = "1";
	      });
	    }, _this.warning = function (text) {
	      _antd.Modal.warning({
	        className: _index2.default.checkInfoModal,
	        title: '保理融资调账成功付款失败，需阻止调账单据与工厂回款单据',
	        content: _react2.default.createElement(
	          "div",
	          { className: _index2.default.overflowHidden, style: { webkitBoxOrient: "vertical" } },
	          "\u878D\u8D44\u5355\u53F7\uFF1A",
	          text
	        )
	      });
	    }, _this.getCollect = function () {
	      commonClient.simplecall(sgiConfig.service_finc + '/finc/statistics/fincsums', {}, function (res) {
	        console.log(res.body);
	        _this.setState(function (preState, props) {
	          var l = preState.list.map(function (el) {
	            if (el.field) {
	              return _extends({}, el, {
	                count: res.body[el.field]
	              });
	            } else {
	              return el;
	            }
	          });
	          return {
	            list: l
	          };
	        });
	      });
	    }, _this.getHasRaised = function () {
	      var req = {
	        ap: "mn",
	        entId: tool.getCookie('orgId')
	      };
	      commonClient.simplecall(sgiConfig.service_finc + 'finc/statistics/entsums', req, function (res) {
	        console.log(res.body);
	        var fieldMap = {
	          raisedAmt: 'factoringAmt',
	          toFactoringAmt: 'toFactoringAmt'
	        };
	        _this.setState(function (preState, props) {
	          var l = preState.list.map(function (el) {
	            if (fieldMap[el.field]) {
	              return _extends({}, el, {
	                count: res.body[fieldMap[el.field]]
	              });
	            } else {
	              return el;
	            }
	          });
	          return {
	            list: l
	          };
	        });
	      });
	    }, _this.getCount = function (count, type) {
	      console.log('count', count);
	      _this.setState(function (preState, props) {
	        var l = preState.list.map(function (el) {
	          if (el.type === type) {
	            return _extends({}, el, {
	              count: count
	            });
	          } else {
	            return el;
	          }
	        });
	        return {
	          list: l
	        };
	      });
	    }, _this.getCollectAdd = function () {
	      commonClient.simplecall(sgiConfig.service_crdt + "/credit/list", {
	        values: {
	          ap: 'mn',
	          expireDate: new Date().format("yyyy-MM-dd"),
	          entId: tool.getCookie("enterpriseId")
	        },
	        matchs: {
	          entNam: "CenterLike",
	          expireDate: "GreaterThanOrEqualTo"
	        }
	      }, function (res) {
	        console.log(res.body);
	        if (!res.body || res.body.length === 0) return;
	        var fieldMap = {
	          creditAmt: 'creditAmt',
	          usedAmt: 'usedAmt',
	          usabledAmt: 'usabledAmt'
	        };
	        _this.setState(function (preState, props) {
	          var l = preState.list.map(function (el) {
	            if (fieldMap[el.field]) {
	              return _extends({}, el, {
	                count: res.body[0][fieldMap[el.field]]
	              });
	            } else {
	              return el;
	            }
	          });
	          return {
	            list: l
	          };
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Factor, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var qualTyps = tool.getCookie('qualTyps');
	      console.log('1', qualTyps);
	      // 判断登录用户是否为准入用户
	      var hasRoles = tool.getCookie('roleCodes');
	      if (!hasRoles) {
	        return tool.popUIByUcv('scfp_UI_012015', null, '企业信息');
	      }
	      this.getCollect();
	      this.getCollectAdd();
	      this.getHasRaised();
	      this.checkInfo();
	    }
	
	    // 校验角色打开融资失败单号弹窗(客户经理/业务主管)
	
	    // 融资汇总
	
	  }, {
	    key: "render",
	    value: function render() {
	      var list = this.state.list;
	
	      var isAdmin = tool.getCookie('roleCodes').includes('ROLE20211207005');
	      if (isAdmin) {
	        list = list.filter(function (el) {
	          return !['待还款', '已融资', '我的待办', '统计报表', '总授信额度', '授信使用额度', '授信余额'].includes(el.type);
	          // return el.type!=='我的待办'
	        });
	      }
	      var mockroots = tool.getCookie('qualTyps'); //获取资格codelist
	
	      console.log('mockroots', mockroots, list);
	      if (mockroots && mockroots.length) {
	        list = list.filter(function (el) {
	          return el.root.some(function (ele) {
	            return mockroots.includes(ele);
	          });
	        });
	      }
	
	      var lenMap = {
	        1: 24,
	        2: 12,
	        3: 8,
	        4: 6,
	        5: 8,
	        6: 8,
	        7: 8
	      };
	      var span = lenMap[list.length];
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_IndexList2.default, { list: list, span: span }),
	        _react2.default.createElement(_TabList2.default, { list: list })
	      );
	    }
	  }]);
	
	  return Factor;
	}(_react.Component);
	
	exports.default = Factor;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 序号	
	// 流程名称	
	// 任务摘要	
	// 送达时间
	var columns = [{
	  title: '序号',
	  dataIndex: 'name',
	  key: 'name'
	  // render: text => <a>{text}</a>,
	}, {
	  title: '流程名称',
	  dataIndex: 'age',
	  key: 'age'
	}, {
	  title: '任务摘要',
	  dataIndex: 'address',
	  key: 'address'
	}, {
	  title: '送达时间',
	  key: 'tags',
	  dataIndex: 'tags'
	}];
	
	var data = [
	  // {
	  //   key: '1',
	  //   name: 'John Brown',
	  //   age: 32,
	  //   address: 'New York No. 1 Lake Park',
	  //   tags: ['nice', 'developer'],
	  // },
	  // {
	  //   key: '2',
	  //   name: 'Jim Green',
	  //   age: 42,
	  //   address: 'London No. 1 Lake Park',
	  //   tags: ['loser'],
	  // },
	  // {
	  //   key: '3',
	  //   name: 'Joe Black',
	  //   age: 32,
	  //   address: 'Sidney No. 1 Lake Park',
	  //   tags: ['cool', 'teacher'],
	  // },
	];
	
	var LiangXin = function (_Component) {
	  _inherits(LiangXin, _Component);
	
	  function LiangXin() {
	    _classCallCheck(this, LiangXin);
	
	    return _possibleConstructorReturn(this, (LiangXin.__proto__ || Object.getPrototypeOf(LiangXin)).apply(this, arguments));
	  }
	
	  _createClass(LiangXin, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_antd.Table, { columns: columns, dataSource: data });
	    }
	  }]);
	
	  return LiangXin;
	}(_react.Component);
	
	exports.default = LiangXin;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 序号	
	// 流程名称	
	// 任务摘要	
	// 送达时间
	var NoRepayment = function (_Component) {
	  _inherits(NoRepayment, _Component);
	
	  function NoRepayment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NoRepayment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NoRepayment.__proto__ || Object.getPrototypeOf(NoRepayment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      todoList: [],
	      columns: [{
	        title: '供应商名称',
	        dataIndex: 'applorNam',
	        key: 'applorNam'
	      }, {
	        title: '融资单号',
	        dataIndex: 'batchCode',
	        key: 'batchCode'
	      }, {
	        title: '核心企业名称',
	        key: 'purchaserNam',
	        dataIndex: 'purchaserNam'
	      },
	      // {
	      //   title: '待还金额',
	      //   key: 'toRepayAmt',
	      //   dataIndex: 'toRepayAmt',
	      // },
	      {
	        title: '放款金额',
	        key: 'factoringAmt',
	        dataIndex: 'factoringAmt'
	      }, {
	        title: '到期日期',
	        key: 'expireDate',
	        dataIndex: 'expireDate'
	      }],
	
	      pagination: {
	        total: 0,
	        pageSize: 10,
	        current: 1
	      }
	    }, _this.todo = function (record) {
	      tool.popUIByUcv(record.uid, { "currentData": record }, record.taskTitle);
	    }, _this.handleTableChange = function (pagination, filters, sorter) {
	      var pager = _extends({}, _this.state.pagination);
	      pager.current = pagination.current;
	      pager.pageSize = pagination.pageSize;
	      _this.setState({
	        pagination: pager
	      }, function () {
	        _this.getToDoList();
	      });
	    }, _this.getToDoList = function () {
	      var pendingUrl = sgiConfig.service_finc + '/finc/statistics/fincdetail'; //待办接口
	      var req = {
	        values: {
	          fincStatus: ["50", "70"]
	        },
	        batch: true,
	        matchs: { fincStatus: "In" }
	      };
	      var mockroots = tool.getCookie('qualTyps');
	      if (mockroots.includes('03')) {
	        req.values.applor = tool.getCookie('orgId');
	      } else if (mockroots.includes('01')) {
	        req.values.purchaser = tool.getCookie('orgId');
	      } else if (mockroots.includes('02')) {
	        req.values.purchaser = tool.getCookie('orgId');
	      }
	      commonClient.simplecall(pendingUrl, req, function (res) {
	        var pagination = _extends({}, _this.state.pagination);
	        pagination.total = res.head.pageCount;
	        // this.props.getCount(res.head.pageCount)
	        _this.setState({
	          todoList: res.body,
	          pagination: pagination
	        });
	      }, false, null, null, function (request) {
	        var _this$state$paginatio = _this.state.pagination,
	            pageSize = _this$state$paginatio.pageSize,
	            current = _this$state$paginatio.current;
	
	        request.head.pageSize = pageSize;
	        request.head.offset = current;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NoRepayment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getToDoList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          columns = _state.columns,
	          todoList = _state.todoList,
	          pagination = _state.pagination;
	
	      var paginationOps = _extends({}, pagination, {
	        size: "small",
	        showTotal: function showTotal(num) {
	          return '\u603B\u6570' + num;
	        },
	        showSizeChanger: true,
	        pageSizeOptions: ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100']
	      });
	
	      return _react2.default.createElement(_antd.Table, { columns: columns,
	        dataSource: todoList,
	        size: 'small',
	        pagination: paginationOps,
	        bordered: true,
	        onChange: this.handleTableChange
	      });
	    }
	  }]);
	
	  return NoRepayment;
	}(_react.Component);
	
	exports.default = NoRepayment;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 序号	
	// 流程名称	
	// 任务摘要	
	// 送达时间
	var NoRepayment = function (_Component) {
	  _inherits(NoRepayment, _Component);
	
	  function NoRepayment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NoRepayment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NoRepayment.__proto__ || Object.getPrototypeOf(NoRepayment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      todoList: [],
	      columns: [{
	        title: '供应商名称',
	        dataIndex: 'applorNam',
	        key: 'applorNam'
	      }, {
	        title: '融资单号',
	        dataIndex: 'batchCode',
	        key: 'batchCode'
	      }, {
	        title: '核心企业名称',
	        key: 'purchaserNam',
	        dataIndex: 'purchaserNam'
	      },
	      // {
	      //   title: '待还金额',
	      //   key: 'toRepayAmt',
	      //   dataIndex: 'toRepayAmt',
	      // },
	      {
	        title: '放款金额',
	        key: 'factoringAmt',
	        dataIndex: 'factoringAmt'
	      }, {
	        title: '到期日期',
	        key: 'expireDate',
	        dataIndex: 'expireDate'
	      }],
	
	      pagination: {
	        total: 0,
	        pageSize: 10,
	        current: 1
	      }
	    }, _this.todo = function (record) {
	      tool.popUIByUcv(record.uid, { "currentData": record }, record.taskTitle);
	    }, _this.handleTableChange = function (pagination, filters, sorter) {
	      var pager = _extends({}, _this.state.pagination);
	      pager.current = pagination.current;
	      pager.pageSize = pagination.pageSize;
	      _this.setState({
	        pagination: pager
	      }, function () {
	        _this.getToDoList();
	      });
	    }, _this.getToDoList = function () {
	      var pendingUrl = sgiConfig.service_finc + '/finc/statistics/fincdetail'; //待办接口
	      var req = {
	        values: {
	          fincStatus: '75'
	        },
	        batch: true
	      };
	      var mockroots = tool.getCookie('qualTyps');
	      if (mockroots.includes('03')) {
	        req.values.applor = tool.getCookie('orgId');
	      } else if (mockroots.includes('01')) {
	        req.values.purchaser = tool.getCookie('orgId');
	      } else if (mockroots.includes('02')) {
	        req.values.purchaser = tool.getCookie('orgId');
	      }
	      commonClient.simplecall(pendingUrl, req, function (res) {
	        var pagination = _extends({}, _this.state.pagination);
	        pagination.total = res.head.pageCount;
	        // this.props.getCount(res.head.pageCount)
	        _this.setState({
	          todoList: res.body,
	          pagination: pagination
	        });
	      }, false, null, null, function (request) {
	        var _this$state$paginatio = _this.state.pagination,
	            pageSize = _this$state$paginatio.pageSize,
	            current = _this$state$paginatio.current;
	
	        request.head.pageSize = pageSize;
	        request.head.offset = current;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NoRepayment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getToDoList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          columns = _state.columns,
	          todoList = _state.todoList,
	          pagination = _state.pagination;
	
	      var paginationOps = _extends({}, pagination, {
	        size: "small",
	        showTotal: function showTotal(num) {
	          return '\u603B\u6570' + num;
	        },
	        showSizeChanger: true,
	        pageSizeOptions: ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100']
	      });
	
	      return _react2.default.createElement(_antd.Table, { columns: columns,
	        dataSource: todoList,
	        size: 'small',
	        pagination: paginationOps,
	        bordered: true,
	        onChange: this.handleTableChange
	      });
	    }
	  }]);
	
	  return NoRepayment;
	}(_react.Component);
	
	exports.default = NoRepayment;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 序号	
	// 流程名称	
	// 任务摘要	
	// 送达时间
	var columns = [{
	  title: '序号',
	  dataIndex: 'name',
	  key: 'name'
	  // render: text => <a>{text}</a>,
	}, {
	  title: '流程名称',
	  dataIndex: 'age',
	  key: 'age'
	}, {
	  title: '任务摘要',
	  dataIndex: 'address',
	  key: 'address'
	}, {
	  title: '送达时间',
	  key: 'tags',
	  dataIndex: 'tags'
	}];
	
	var data = [
	  // {
	  //   key: '1',
	  //   name: 'John Brown',
	  //   age: 32,
	  //   address: 'New York No. 1 Lake Park',
	  //   tags: ['nice', 'developer'],
	  // },
	  // {
	  //   key: '2',
	  //   name: 'Jim Green',
	  //   age: 42,
	  //   address: 'London No. 1 Lake Park',
	  //   tags: ['loser'],
	  // },
	  // {
	  //   key: '3',
	  //   name: 'Joe Black',
	  //   age: 32,
	  //   address: 'Sidney No. 1 Lake Park',
	  //   tags: ['cool', 'teacher'],
	  // },
	];
	
	var PaymentXin = function (_Component) {
	  _inherits(PaymentXin, _Component);
	
	  function PaymentXin() {
	    _classCallCheck(this, PaymentXin);
	
	    return _possibleConstructorReturn(this, (PaymentXin.__proto__ || Object.getPrototypeOf(PaymentXin)).apply(this, arguments));
	  }
	
	  _createClass(PaymentXin, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_antd.Table, { columns: columns, dataSource: data });
	    }
	  }]);
	
	  return PaymentXin;
	}(_react.Component);
	
	exports.default = PaymentXin;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 序号	
	// 流程名称	
	// 任务摘要	
	// 送达时间
	var StaticReport = function (_Component) {
	  _inherits(StaticReport, _Component);
	
	  function StaticReport() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticReport);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StaticReport.__proto__ || Object.getPrototypeOf(StaticReport)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      todoList: [],
	      columns: [{
	        title: '序号',
	        dataIndex: 'xh',
	        key: 'xh'
	      }, {
	        title: '放款类别',
	        dataIndex: 'type',
	        key: 'type'
	      }, {
	        title: '累计余额',
	        key: 'totalAmt',
	        dataIndex: 'totalAmt'
	      }, {
	        title: '当年放款',
	        key: 'yearAmt',
	        dataIndex: 'yearAmt'
	      }, {
	        title: '当月放款',
	        key: 'monthAmt',
	        dataIndex: 'monthAmt'
	      }, {
	        title: '当日放款',
	        key: 'dayAmt',
	        dataIndex: 'dayAmt'
	      }, {
	        title: '历史累计发放额',
	        key: 'historyAmt',
	        dataIndex: 'historyAmt'
	        // {
	        //   title: '操作',
	        //   key: 'action',
	        //   render: (text, record) => (
	        //     <Button type="link" size="small" onClick={() => this.todo(record)}>审批</Button>
	        //   ),
	        // },
	      }],
	
	      pagination: {
	        total: 0,
	        pageSize: 10,
	        current: 1
	      }
	    }, _this.todo = function (record) {
	      tool.popUIByUcv(record.uid, { "currentData": record }, record.taskTitle);
	    }, _this.handleTableChange = function (pagination, filters, sorter) {
	      var pager = _extends({}, _this.state.pagination);
	      pager.current = pagination.current;
	      pager.pageSize = pagination.pageSize;
	      _this.setState({
	        pagination: pager
	      }, function () {
	        _this.getToDoList();
	      });
	    }, _this.getToDoList = function () {
	      var pendingUrl = sgiConfig.service_finc + '/finc/statistics/report'; //报表统计接口
	      var req = {
	        values: {
	          fincStatus: '75'
	        },
	        batch: true
	        // let mockroots = tool.getCookie('qualTyps')
	        // if(mockroots.includes('03')){
	        //   req.values.applor = tool.getCookie('orgId')
	        // }else if(mockroots.includes('01')){
	        //   req.values.purchaser = tool.getCookie('orgId')
	        // }else if(mockroots.includes('02')){
	        //   req.values.purchaser = tool.getCookie('orgId')
	        // }
	      };commonClient.simplecall(pendingUrl, req, function (res) {
	        var pagination = _extends({}, _this.state.pagination);
	        pagination.total = res.head.pageCount;
	        // this.props.getCount(res.head.pageCount)
	        _this.setState({
	          todoList: res.body,
	          pagination: pagination
	        });
	      }, false, null, null, function (request) {
	        var _this$state$paginatio = _this.state.pagination,
	            pageSize = _this$state$paginatio.pageSize,
	            current = _this$state$paginatio.current;
	
	        request.head.pageSize = pageSize;
	        request.head.offset = current;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StaticReport, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getToDoList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          columns = _state.columns,
	          todoList = _state.todoList,
	          pagination = _state.pagination;
	
	      var paginationOps = _extends({}, pagination, {
	        size: "small",
	        showTotal: function showTotal(num) {
	          return '\u603B\u6570' + num;
	        },
	        showSizeChanger: true,
	        pageSizeOptions: ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100']
	      });
	
	      return _react2.default.createElement(_antd.Table, { columns: columns,
	        dataSource: todoList,
	        size: 'small',
	        pagination: paginationOps,
	        bordered: true,
	        onChange: this.handleTableChange
	      });
	    }
	  }]);
	
	  return StaticReport;
	}(_react.Component);
	
	exports.default = StaticReport;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var TabList = function (_Component) {
	  _inherits(TabList, _Component);
	
	  function TabList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TabList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabList.__proto__ || Object.getPrototypeOf(TabList)).call.apply(_ref, [this].concat(args))), _this), _this.callback = function (params) {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TabList, [{
	    key: "render",
	    value: function render() {
	      var list = this.props.list;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            backgroundColor: "#ffffff",
	            boxSizing: "border-box",
	            padding: "15px"
	          }
	        },
	        _react2.default.createElement(
	          _antd.Tabs,
	          { defaultActiveKey: "1", onChange: this.callback },
	          list.filter(function (el) {
	            return el.component;
	          }).map(function (el) {
	            return _react2.default.createElement(
	              TabPane,
	              { tab: el.TabPaneName || el.type, key: el.id, forceRender: true },
	              el.component
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return TabList;
	}(_react.Component);
	
	exports.default = TabList;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// 序号	
	// 流程名称	
	// 任务摘要	
	// 送达时间
	var TodoList = function (_Component) {
	  _inherits(TodoList, _Component);
	
	  function TodoList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TodoList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TodoList.__proto__ || Object.getPrototypeOf(TodoList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      todoList: [],
	      columns: [{
	        title: '序号',
	        dataIndex: 'taskTitle',
	        key: 'taskTitle'
	      }, {
	        title: '任务摘要',
	        dataIndex: 'taskNam',
	        key: 'taskNam'
	      }, {
	        title: '送达时间',
	        key: 'allctTim',
	        dataIndex: 'allctTim'
	      }, {
	        title: '操作',
	        key: 'action',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _antd.Button,
	            { type: 'link', size: 'small', onClick: function onClick() {
	                return _this.todo(record);
	              } },
	            '\u5BA1\u6279'
	          );
	        }
	      }],
	
	      pagination: {
	        total: 0,
	        pageSize: 10,
	        current: 1
	      }
	    }, _this.todo = function (record) {
	      if (record.uid.includes("client-pc")) {
	        // 获取 参数
	        var token = tool.getCookie('token');
	        var bussId = record.bussId;
	        var taskId = record.taskId;
	        var instId = record.instId;
	        var nodeId = record.nodeId;
	        // 获取当前页面的域名
	        var domain = window.location.origin;
	        // 拼接跳转的 URL
	        var basePath = record.uid;
	        var params = new URLSearchParams({
	          token: token,
	          bussId: bussId,
	          taskId: taskId,
	          instId: instId,
	          nodeId: nodeId
	          // 可以根据需要添加更多参数
	        });
	        var url = '' + domain + basePath + '?' + params.toString();
	        // 在新标签页中打开拼接好的 URL
	        window.open(url, '_blank');
	      } else {
	        tool.popUIByUcv(record.uid, { "currentData": record }, record.taskTitle);
	      }
	    }, _this.handleTableChange = function (pagination, filters, sorter) {
	      var pager = _extends({}, _this.state.pagination);
	      pager.current = pagination.current;
	      pager.pageSize = pagination.pageSize;
	      _this.setState({
	        pagination: pager
	      }, function () {
	        _this.getToDoList();
	      });
	    }, _this.getToDoList = function () {
	      var pendingUrl = sgiConfig.service_csp + '/task/my/pending'; //待办接口
	      var req = {
	        "values": {
	          "executor": tool.getCookie('userId')
	        }
	      };
	      commonClient.simplecall(pendingUrl, req, function (res) {
	        var pagination = _extends({}, _this.state.pagination);
	        pagination.total = res.head.pageCount;
	        _this.props.getCount(res.head.pageCount);
	        _this.setState({
	          todoList: res.body,
	          pagination: pagination
	        });
	      }, false, null, null, function (request) {
	        var _this$state$paginatio = _this.state.pagination,
	            pageSize = _this$state$paginatio.pageSize,
	            current = _this$state$paginatio.current;
	
	        request.head.pageSize = pageSize;
	        request.head.offset = current;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TodoList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getToDoList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          columns = _state.columns,
	          todoList = _state.todoList,
	          pagination = _state.pagination;
	
	      var paginationOps = _extends({}, pagination, {
	        size: "small",
	        showTotal: function showTotal(num) {
	          return '\u603B\u6570' + num;
	        },
	        showSizeChanger: true,
	        pageSizeOptions: ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100']
	      });
	
	      return _react2.default.createElement(_antd.Table, { columns: columns,
	        dataSource: todoList,
	        size: 'small',
	        pagination: paginationOps,
	        bordered: true,
	        onChange: this.handleTableChange
	      });
	    }
	  }]);
	
	  return TodoList;
	}(_react.Component);
	
	exports.default = TodoList;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cardConfig = {
	  width: 250,
	  title: {},
	  text: {
	    color: 'gray'
	  }
	};
	var textJsx = function textJsx(cfg) {
	  return '\n  <group>\n    <rect>\n      <rect style={{\n        width: ' + cardConfig.width + ',\n        height: 20,\n        fill: #00b34f,\n        radius: [6, 6, 0, 0],\n        cursor: \'move\',\n        stroke: #00b34f\n      }} draggable="true">\n        <text style={{\n          marginTop: 2,\n          marginLeft: 75,\n          textAlign: \'center\',\n          fontWeight: \'bold\',\n          fill: \'#fff\' }}>{{label}}</text>\n      </rect>\n      <rect style={{\n        width: ' + cardConfig.width + ',\n        stroke: #00b34f,\n        fill: \'rgba(24,144,255,0.15)\',\n        radius: [0, 0, 6, 6],\n      }}>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u6301\u6709\u4EBA: {{description}}</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u7CAE\u4FE1\u9762\u989D: {{meta.creatorName}}</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u6301\u6709\u91D1\u989D: {{meta.creatorName}}</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u878D\u8D44\u91D1\u989D: {{meta.creatorName}}</text>\n        <text style={{ marginTop: 10, marginLeft: 4, fill: \'gray\', fontSize: 10}}>\u8F6C\u8BA9\u91D1\u989D: {{meta.creatorName}}</text>\n      </rect>\n    </rect>\n  </group>\n  ';
	};
	// tool.popUIByUcv(record.uid, {"currentData":record}, record.taskTitle)
	
	var Supplier = function (_Component) {
	  _inherits(Supplier, _Component);
	
	  function Supplier() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Supplier);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Supplier.__proto__ || Object.getPrototypeOf(Supplier)).call.apply(_ref, [this].concat(args))), _this), _this.createG6 = function () {
	
	      G6.registerNode('rect-jsx', {
	        jsx: textJsx
	      });
	
	      var data = {
	        nodes: [{
	          description: 'LX202111030015',
	          label: 'node1',
	          color: '#eadcdc',
	          meta: {
	            creatorName: 'a_creator'
	          },
	          id: 'node1'
	        }, {
	          description: 'LX202111030015',
	          label: 'node2',
	          color: '#eadcdc',
	          meta: {
	            creatorName: 'a_creator'
	          },
	          id: 'node2'
	        }, {
	          description: 'LX202111030015',
	          label: 'node3',
	          color: '#eadcdc',
	          meta: {
	            creatorName: 'a_creator'
	          },
	          id: 'node3'
	        }, {
	          description: 'LX202111030015',
	          label: 'node4',
	          color: '#eadcdc',
	          meta: {
	            creatorName: 'a_creator'
	          },
	          id: 'node4'
	        }, {
	          description: 'LX202111030015',
	          label: 'node5',
	          color: '#eadcdc',
	          meta: {
	            creatorName: 'a_creator'
	          },
	          id: 'node5'
	        }, {
	          description: 'LX202111030015',
	          label: 'node6',
	          color: '#eadcdc',
	          meta: {
	            creatorName: 'a_creator'
	          },
	          id: 'node6'
	        }, {
	          description: 'LX202111030015',
	          label: 'node7',
	          color: '#eadcdc',
	          meta: {
	            creatorName: 'a_creator'
	          },
	          id: 'node7'
	        }],
	        edges: [{ source: 'node1', target: 'node2' }, { source: 'node1', target: 'node3' }, { source: 'node2', target: 'node4' }, { source: 'node2', target: 'node5' }, { source: 'node3', target: 'node6' }, { source: 'node3', target: 'node7' }]
	      };
	
	      var container = document.getElementById('container');
	      var width = container.scrollWidth;
	      var height = container.scrollHeight || 500;
	      var graph = new G6.Graph({
	        container: 'container',
	        width: width,
	        height: height,
	        // fitCenter: true,
	        modes: {
	          default: [{
	            // 定义展开/收缩行为
	            type: 'collapse-expand'
	          }, 'drag-canvas', 'zoom-canvas']
	        },
	        defaultNode: {
	          type: 'rect-jsx',
	          labelCfg: {
	            style: {
	              fill: '#000000A6',
	              fontSize: 10
	            }
	          },
	          style: {
	            stroke: '#72CC4A',
	            width: 150
	          }
	        },
	        defaultEdge: {
	          // ...                 // 边的其他配置
	          type: 'polyline',
	          // 边样式配置
	          style: {
	            opacity: 0.6, // 边透明度
	            stroke: '#00b34f', // 边描边颜色
	            endArrow: true
	          }
	        },
	        layout: {
	          type: 'dagre', // 布局类型
	          rankdir: 'LR', // 自左至右布局，可选的有 H / V / LR / RL / TB / BT
	          nodesep: 60,
	          ranksep: 100,
	          sortByCombo: true
	          // direction: 'TB', // 自左至右布局，可选的有 H / V / LR / RL / TB / BT
	          // nodeSep: 50, // 节点之间间距
	          // rankSep: 100, // 每个层级之间的间距
	        }
	      });
	
	      graph.data(data);
	      graph.render();
	
	      if (typeof window !== 'undefined') window.onresize = function () {
	        if (!graph || graph.get('destroyed')) return;
	        if (!container || !container.scrollWidth || !container.scrollHeight) return;
	        graph.changeSize(container.scrollWidth, container.scrollHeight);
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Supplier, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createG6();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { id: 'container' })
	      );
	    }
	  }]);
	
	  return Supplier;
	}(_react.Component);
	
	exports.default = Supplier;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _Dnd_SgiFormEditorCommon = __webpack_require__(409);
	
	var _Constant = __webpack_require__(522);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _common = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TreeNode = _antd.Tree.TreeNode;
	var Option = _antd.Select.Option;
	
	
	var testStyle = {
	    padding: 5
	};
	
	function copyObj(target, source) {
	    if (Array.isArray(source)) {
	        target = target || [];
	        source.forEach(function (sou) {
	            if (!target.some(function (tar) {
	                if (tar.nodeType === "group") {
	                    var scFlg = tar.sc === sou.sc;
	                    var sameFlg = scFlg || tar.cldSet && sou.cldSet && tar.cldSet[0] && sou.cldSet[0] && tar.cldSet[0].id === sou.cldSet[0].id;
	                    if (sameFlg) {
	                        copyObj(tar, sou);
	                        return true;
	                    }
	                } else {
	                    if (tar.id === sou.id) {
	                        copyObj(tar, sou);
	                        return true;
	                    }
	                }
	            })) {
	                target.push(sou);
	            };
	        });
	    } else {
	        source = source || {};
	        for (var sKey in source) {
	            if (_typeof(source[sKey]) === "object") {
	                if (!target[sKey]) {
	                    target[sKey] = source[sKey];
	                } else {
	                    copyObj(target[sKey], source[sKey]);
	                }
	            } else {
	                target[sKey] = source[sKey];
	            }
	        }
	    }
	    return target;
	}
	
	var CustAdvanceQuery = function (_React$Component) {
	    _inherits(CustAdvanceQuery, _React$Component);
	
	    function CustAdvanceQuery(props) {
	        _classCallCheck(this, CustAdvanceQuery);
	
	        var _this = _possibleConstructorReturn(this, (CustAdvanceQuery.__proto__ || Object.getPrototypeOf(CustAdvanceQuery)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var treeData = [];
	        var guid = void 0;
	        var prm = void 0;
	        // let guids = guid.split("_");
	        // let prm = PrmFactory.getPrm(guid);
	        var _key = (0, _sgiCommon.uuid)(8);
	        var detail = tool.parseForBrowserHistory(_this.props) || { record: {} };
	        if (!detail.addFlag) {
	            guid = detail.record.guid;
	            prm = detail.record;
	            _key = detail.record[_key] || _key;
	        }
	        if (!prm) prm = {};
	
	        // 查询特征标签参数
	        var custTag = _PrmFactory.PrmFactory.getPrm("param_param_custTag_0001");
	        if (!custTag) {
	            tool.sgiLogger.error("特征标签[param_param_custTag_0001]参数不存在");
	        } else {
	            prm = copyObj(custTag, prm);
	            tool.sgiLogger.info('prm :', prm);
	        }
	
	        treeData.push(prm);
	
	        _this.state = {
	            values: prm,
	            selectedKeys: [_key],
	            treeData: treeData,
	            sysStore: [],
	            nodeType: "prm", //节点类型
	            SCModalVisible: false,
	            checkedKeys: []
	        };
	        return _this;
	    }
	
	    _createClass(CustAdvanceQuery, [{
	        key: 'refresh',
	        value: function refresh(attname, value) {
	            this.state.values[attname] = value;
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'renderSelectOptions',
	        value: function renderSelectOptions(data) {
	            return data.map(function (item) {
	                return _react2.default.createElement(
	                    Option,
	                    { value: item.c },
	                    item.te
	                );
	            });
	        }
	    }, {
	        key: 'getCtlProps',
	        value: function getCtlProps() {
	            return (0, _Constant.getEidtorFun)(this, this.state.values.desId);
	        }
	    }, {
	        key: 'fitSysCombox',
	        value: function fitSysCombox() {
	
	            // 下拉窗列表值在标准代码中的id
	            var comboBoxData = StandardCode.getSC("param_SC_param_0001");
	            if (!comboBoxData) {
	                return;
	            }
	
	            var attKey = 'c',
	                attName = 'te';
	
	            this.state.sysStore = [];
	
	            var size = comboBoxData.length;
	            if (!size == 0) {
	                for (var i = 0; i < size; i++) {
	                    var item = comboBoxData[i];
	                    this.state.sysStore.push(_react2.default.createElement(
	                        Option,
	                        { value: item[attKey] },
	                        item[attName]
	                    ));
	                }
	            }
	        }
	    }, {
	        key: 'checkData',
	
	
	        // 递归赋值checked
	        value: function checkData(data, checked) {
	            var _this2 = this;
	
	            if (data.cldSet) {
	                data.cldSet.forEach(function (cld) {
	                    _this2.checkData(cld, checked);
	                });
	                delete data._checked;
	            } else {
	                data._checked = checked;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '99%', width: '99%', padding: 5 } },
	                _react2.default.createElement(
	                    _antd.Row,
	                    { style: { margin: '5px 0px 5px 0px', height: "100%" } },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 5, style: { height: "100%" } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { height: "100%", overflow: "auto" } },
	                            _react2.default.createElement(
	                                _antd.Tree,
	                                {
	                                    draggable: true,
	                                    checkable: true,
	                                    defaultExpandAll: true,
	                                    onSelect: this.onSelect,
	                                    selectedKeys: this.state.selectedKeys,
	                                    onCheck: this.onCheck,
	                                    checkedKeys: this.state.checkedKeys
	                                },
	                                this.renderTreeNodes(this.state.treeData)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 19 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: testStyle },
	                            _react2.default.createElement(
	                                _antd.Button,
	                                { type: 'primary', onClick: this.save, style: { margin: 5 } },
	                                '\u4FDD\u5B58'
	                            )
	                        ),
	                        this.getShowCard()
	                    )
	                ),
	                (0, _Dnd_SgiFormEditorCommon.getSCModal)(this)
	            );
	        }
	    }]);
	
	    return CustAdvanceQuery;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.addSub = function (nodeType) {
	        var record = _this3.state.values;
	        if (!record) {
	            alert("请选择节点");
	        }
	        _this3.addCldSet(record, nodeType);
	    };
	
	    this.save = function () {
	        var prm = _this3.state.treeData[0];
	        tool.sgiLogger.info("save prm:", prm);
	        var result = _PrmFactory.PrmFactory.save(prm);
	        if (result == 0) {
	            alert("保存成功");
	        } else {
	            alert("保存失败，result：" + result);
	        }
	    };
	
	    this.onSelect = function (selectedKeys, info) {
	        _this3.setState({ selectedKeys: selectedKeys });
	        var record = info.node.props.dataRef;
	        _this3.setState({ values: record });
	        var nodeType = info.node.props.dataRef.nodeType;
	        _this3.setState({ nodeType: nodeType });
	    };
	
	    this.addCldSet = function (record, nodeType) {
	        var cldSet = record.cldSet;
	        if (!cldSet) {
	            cldSet = record.cldSet = [];
	        }
	        var item = {
	            te: "xxx",
	            _key: (0, _sgiCommon.uuid)(8),
	            nodeType: nodeType
	        };
	        if (nodeType == "tag") {
	            item.id = (0, _sgiCommon.uuid)(64);
	            item.desId = "EP_EO_UI_3101"; //默认文本框
	        }
	        cldSet.push(item);
	        _this3.setState({ loading: false });
	    };
	
	    this.getShowCard = function () {
	
	        _this3.fitSysCombox();
	
	        switch (_this3.state.nodeType) {
	            case "prm":
	                return _react2.default.createElement(
	                    _antd.Card,
	                    { size: 'small', title: '\u53C2\u6570\u5B9A\u4E49', style: { marginLeft: "5px" } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: testStyle },
	                        _react2.default.createElement(
	                            _antd.Form,
	                            null,
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "子系统编码" }),
	                                        _react2.default.createElement(
	                                            _antd.Select,
	                                            { disabled: true, value: _this3.state.values.ss, onChange: _Dnd_SgiFormEditorCommon.selectOnChange.bind(_this3, _this3, 'ss') },
	                                            _this3.state.sysStore
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "语义码" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.sc, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'sc') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "名称" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this3.state.values.n, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'n') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "显示名称" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this3.state.values.te, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'te') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "创建人" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.auth })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "创建时间" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.crtTm })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "修改人" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.edAuth })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "修改时间" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.edTm })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "参数版本" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.prmVsn })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "GUID" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.guid })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 16 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout2, { style: { margin: "1px 0px" }, label: "注释" }),
	                                        _react2.default.createElement(_antd.Input.TextArea, { value: _this3.state.values.ann, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'ann') })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            case "group":
	                return _react2.default.createElement(
	                    _antd.Card,
	                    { size: 'small', title: '\u5206\u7EC4\u5B9A\u4E49', style: { marginLeft: "5px" } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: testStyle },
	                        _react2.default.createElement(
	                            _antd.Form,
	                            null,
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "组名" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this3.state.values.te, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'te') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "编码" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.sc ? _this3.state.values.sc : _this3.state.values.sc = tool.uuid(8) })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 16 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout2, { style: { margin: "1px 0px" }, label: "描述" }),
	                                        _react2.default.createElement(_antd.Input.TextArea, { value: _this3.state.values.ann, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'ann') })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            default:
	                var desId = _this3.state.values.desId;
	                if (!desId) desId = _this3.state.values.desId = "EP_EO_UI_3101";
	                return _react2.default.createElement(
	                    _antd.Card,
	                    { size: 'small', title: '\u5C5E\u6027\u5B9A\u4E49', style: { marginLeft: "5px" } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: _extends({}, testStyle, { display: _this3.state.display }) },
	                        _react2.default.createElement(
	                            _antd.Form,
	                            null,
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 16 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout2, { style: { margin: "1px 0px" }, label: "标签ID" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this3.state.values.id })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 3 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        { labelCol: { span: 18 }, style: { margin: "1px 0px" }, label: "允许为空" },
	                                        _react2.default.createElement(_antd.Checkbox, { checked: _this3.state.values.alwBlk, onChange: _Dnd_SgiFormEditorCommon.checkOnChange.bind(_this3, _this3, 'alwBlk') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "名称" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this3.state.values.te, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'te') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "编码" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this3.state.values.c, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'c') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 16 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout2, { style: { margin: "1px 0px" }, label: "描述" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this3.state.values.ann, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this3, _this3, 'ann') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "组件类型" }),
	                                        _react2.default.createElement(
	                                            _antd.Select,
	                                            {
	                                                value: desId,
	                                                onChange: _Dnd_SgiFormEditorCommon.selectOnChange.bind(_this3, _this3, "desId") },
	                                            _this3.renderSelectOptions(_Constant.ctlTypes)
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { style: { margin: "1px 0px" }, label: "值类型" }),
	                                        _react2.default.createElement(
	                                            _antd.Select,
	                                            {
	                                                value: _this3.state.values.valueType || "01",
	                                                onChange: _Dnd_SgiFormEditorCommon.selectOnChange.bind(_this3, _this3, "valueType") },
	                                            _this3.renderSelectOptions(_Constant.valueTypes)
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: testStyle },
	                        _this3.getCtlProps()
	                    )
	                );
	        }
	    };
	
	    this.onCheck = function (checkedKeys, e) {
	        tool.sgiLogger.info('e :', e);
	        var checked = e.checked,
	            checkedNodes = e.checkedNodes,
	            node = e.node,
	            event = e.event;
	
	        _this3.checkData(node.props.dataRef, checked);
	        // if (!checked) {
	        //     // 取消勾选，要将父节点置为false
	        //     const pos = node.props.pos;
	        //     const poss = pos.split("-");
	        //     let parentData = this.state.treeData[parseInt(poss[1])]
	        // }
	        _this3.setState({ checkedKeys: checkedKeys });
	    };
	
	    this.renderTreeNodes = function (data) {
	        return data.map(function (item) {
	            item._key = item._key || tool.uuid();
	            if (item._checked) _this3.state.checkedKeys.push(item._key);
	            if (item.cldSet) {
	                return _react2.default.createElement(
	                    TreeNode,
	                    { title: item.te, key: item._key, dataRef: item },
	                    _this3.renderTreeNodes(item.cldSet)
	                );
	            }
	            return _react2.default.createElement(TreeNode, { title: item.te, key: item._key, dataRef: item });
	        });
	    };
	};
	
	exports.default = CustAdvanceQuery;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(25);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _rtSdComp = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var formItemLayout2 = {
		labelCol: { span: 23 },
		style: {
			width: "100%",
			margin: "1px -7px 1px auto"
		}
	};
	var formItemLayout3 = {
		labelCol: { span: 14 },
		wrapperCol: { span: 10 }
	};
	
	function getCheckedItems(prm) {
		var checkeds = [];
		var cldSet = prm.cldSet || [];
		cldSet.forEach(function (cld) {
			if (cld.nodeType === "item" || cld.nodeType === "tag") {
				if (cld._checked) {
					// checkeds.push({
					//     tagId: cld.id,
					//     matchType: cld.defaultMatchType,
					//     // featureValue: cld.id,
					// });
					checkeds.push(cld);
				}
			} else if (cld.cldSet) {
				checkeds.push.apply(checkeds, _toConsumableArray(getCheckedItems(cld)));
			}
		});
		return checkeds;
	}
	
	function getExpressOptions() {
	
		var expressSC = StandardCode.getSC(custGroupConfig.matchTypePrm);
	
		if (!expressSC) {
			return _react2.default.createElement(
				Option,
				{ value: '' },
				'\u4E0D\u5B58\u5728'
			);
		}
	
		var expressOptions = [];
		expressSC.forEach(function (element) {
			expressOptions.push(_react2.default.createElement(
				Option,
				{ value: element.c },
				element.ann
			));
		});
	
		return expressOptions;
	}
	
	function getExpressText(c) {
		var expressSC = StandardCode.getSC(custGroupConfig.matchTypePrm);
	
		if (!expressSC) return c;
	
		var text = c;
		expressSC.some(function (item) {
			if (item.c === c) {
				text = item.ann;
				return true;
			}
		});
	
		return text;
	}
	
	var CustQueryCondition = function (_React$Component) {
		_inherits(CustQueryCondition, _React$Component);
	
		function CustQueryCondition(props) {
			_classCallCheck(this, CustQueryCondition);
	
			var _this = _possibleConstructorReturn(this, (CustQueryCondition.__proto__ || Object.getPrototypeOf(CustQueryCondition)).call(this, props));
	
			_initialiseProps.call(_this);
	
			var objFct = new _rtSdCommon.ObjFactory("CustQueryCondition");
	
			// let prm = PrmFactory.getPrm(custGroupConfig.custQueryPrmDef);
			var prm = _rtSdCommon.PrmFactory.getPrm("Emos_param_custAdvQuery_0001");
			var allData = prm.cldSet || [];
	
			var checkeds = getCheckedItems(prm);
	
			_this.state = {
				forms: {}, //客群定义显示form，一个属性一个form,{key:form,key2:form2}
				formsValue: {},
				showCtls: {}, //存储所有显示控件
				objFct: objFct,
				loading: false,
				checkedAtts: {},
				allData: allData,
				data: _this.props.data || checkeds || []
			};
	
			// 创建所有forms
			_this.createForms(checkeds);
			return _this;
		}
	
		_createClass(CustQueryCondition, [{
			key: 'handleChange',
			value: function handleChange(attc, match_type, dataRef, value) {
				tool.sgiLogger.info('selected ' + attc);
				tool.sgiLogger.info('selected ' + match_type);
				tool.sgiLogger.info('selected ' + value);
	
				if (value == "Between" || value == "NotBetween") {
					this.state.formsValue[attc]["ctl2Display"] = undefined;
				} else {
					this.state.formsValue[attc]["ctl2Display"] = 'none';
				}
				this.state.formsValue[attc][match_type] = value;
				this.createFormInfo(dataRef, value); //重新创建
				this.setState({ loading: false });
			}
		}, {
			key: 'createFormInfo',
			value: function createFormInfo(dataRef, matchType, value1, value2) {
	
				dataRef.desId = dataRef.desId || "EP_EO_UI_3101"; //添加默认值-文本框
				var moveStyle = {};
				if (dataRef.desId === "EP_EO_UI_3101" && dataRef.bdText) {
					// 文本组件存在后置文本时需要进行偏移，这是antd的bug，修复后这里可以取消
					moveStyle.marginTop = 4;
					moveStyle.marginBottom = -4;
				}
	
				var attc = dataRef.c;
				var text = dataRef.te;
	
				var bdInst = attc + "_tmp";
	
				var ctl2ShowFlg = false;
	
				//显示的所有属性的集合
				this.state.checkedAtts[attc] = true;
	
				this.state.objFct.set(bdInst, this.state.formsValue[attc]);
	
				//修改c值，给每组值起同样的key
				dataRef.cRef = attc;
				var dataRef1 = (0, _rtSdCommon.copy)(dataRef);
				dataRef1.c = "value1";
				dataRef1.isLbl = true;
				if (value1) dataRef1.value = value1;
				var ctl1 = (0, _rtSdComp.convertModuleByGuid)(this, dataRef1, bdInst, this.state.objFct, "N");
				ctl1.ref = this.refModalFunction.bind(this);
				var dataRef2 = (0, _rtSdCommon.copy)(dataRef);
				dataRef2.c = "value2";
				// dataRef2.isLbl = false;
				// dataRef2.te = '-';
				dataRef2.isLbl = true;
				dataRef2.ctlW = 24;
				dataRef2.lblW = 2;
				// dataRef2.alwBlk = true;
				if (value2) dataRef2.value = value2;
				var ctl2 = (0, _rtSdComp.convertModuleByGuid)(this, dataRef2, bdInst, this.state.objFct, "N");
				if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
					ctl2.ref = this.refModalFunction.bind(this);
					ctl2ShowFlg = true;
				} else {
					delete ctl2.ref;
					ctl2ShowFlg = false;
				}
	
				var ctl1Span = 5;
				if (matchType && (matchType == "In" || matchType == "NotIn")) {
					ctl1Span = 11;
				}
				if (!ctl2ShowFlg) {
					ctl1Span = 11;
				}
	
				this.state.forms[attc] = _react2.default.createElement(
					_antd.Row,
					{ key: (0, _rtSdCommon.uuid)(8) },
					_react2.default.createElement(
						_antd.Col,
						{ span: dataRef.matchDis ? 7 : 12 },
						_react2.default.createElement(
							FormItem,
							_extends({ style: { 'margin-bottom': "1px", 'margin-top': "1px" } }, dataRef.matchDis ? formItemLayout2 : formItemLayout3, { hasFeedback: false, label: text }),
							dataRef.matchDis ? null // getExpressText(this.state.formsValue[attc]["match_type"])
							: _react2.default.createElement(
								_antd.Select,
								{ disabled: dataRef.matchDis, value: this.state.formsValue[attc]["match_type"], style: { width: '100%' }, onChange: this.handleChange.bind(this, attc, "match_type", dataRef) },
								getExpressOptions()
							)
						)
					),
					dataRef.matchDis ? null : _react2.default.createElement(_antd.Col, { span: 1 }),
					_react2.default.createElement(
						_antd.Col,
						{ span: ctl1Span },
						_react2.default.createElement(
							'div',
							{ style: _extends({}, moveStyle, { float: "left", width: "100%" }) },
							ctl1
						)
					),
					ctl2ShowFlg ? _react2.default.createElement(
						_antd.Col,
						{ span: 1 },
						_react2.default.createElement(
							'div',
							{ style: { textAlign: "center", marginTop: 9 } },
							'~'
						)
					) : null,
					ctl2ShowFlg ? _react2.default.createElement(
						_antd.Col,
						{ span: 5, style: { display: this.state.formsValue[attc]["ctl2Display"] } },
						_react2.default.createElement(
							'div',
							{ style: _extends({}, moveStyle, { float: "left", width: "100%" }) },
							ctl2
						)
					) : null
				);
			}
		}, {
			key: 'refModalFunction',
			value: function refModalFunction(ctl) {
				if (!ctl) {
					return;
				}
				var _ctl$props = ctl.props,
				    moduleDesc = _ctl$props.moduleDesc,
				    objFct = _ctl$props.objFct;
	
				this.state.showCtls[moduleDesc.cRef + moduleDesc.c] = ctl;
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state,
				    allData = _state.allData,
				    forms = _state.forms;
	
	
				return _react2.default.createElement(
					'div',
					{ style: { height: '100%', width: '100%' } },
					_react2.default.createElement(
						_antd.Row,
						{ style: { height: '100%', width: '100%' } },
						_react2.default.createElement(
							_antd.Col,
							{ style: { height: '100%' }, span: 24 },
							this.renderCardNodes(allData, forms)
						)
					)
				);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _state2 = this.state,
				    data = _state2.data,
				    allData = _state2.allData;
	
				if (data && data.length > 0) {
					this.refreshData(data);
				}
			}
		}]);
	
		return CustQueryCondition;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
		var _this2 = this;
	
		this.convertData = function (e) {
			//校验 组装数据
			var errors = [];
			var errorMsg = void 0;
			for (var tmpKey in _this2.state.showCtls) {
				var tmpCtl = _this2.state.showCtls[tmpKey];
				var ctlDisplay = _this2.state.formsValue[tmpCtl.props.moduleDesc.cRef]["ctl2Display"];
				if (ctlDisplay != 'none') {
					errorMsg = tmpCtl.validate();
					if (errorMsg) {
						errors.push(errorMsg);
					}
				}
			}
	
			if (errors.length > 0) {
				//组装数据
				_this2.setState({ loading: false });
				// alert('校验失败');//这里不用提示，组件自身提示
				return null;
			}
	
			var data = [];
			for (var tmpKey in _this2.state.checkedAtts) {
				var tmpSaveRecord = _this2.state.objFct.get(tmpKey + "_tmp");
				if (!tmpSaveRecord.value1 && !tmpSaveRecord.value1) continue;
				var matchType = tmpSaveRecord.match_type;
				var value = tmpSaveRecord.value1;
				if (matchType == "Between" || matchType == "NotBetween") {
					value += "," + tmpSaveRecord.value2;
				}
				var obj = {
					tagId: tmpSaveRecord.id,
					tagName: tmpSaveRecord.te,
					matchType: matchType,
					valueType: tmpSaveRecord.valueType || "01",
					featureValue: value,
					tagCode: tmpSaveRecord.c
				};
				data.push(obj);
			}
			tool.sgiLogger.info(data);
	
			return data;
		};
	
		this.refreshData = function (data) {
	
			if (!data) return;
			var allData = _this2.state.allData;
	
			//重置
			// this.state.forms = { ...this.state.forms };
	
			_this2.state.forms = {};
			// this.state.formsValue = {};
			// this.state.showCtls = {};
	
			data.forEach(function (item) {
				item.tagId = item.tagId || item.featureTagId || item.id;
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = allData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var gr = _step.value;
	
						if (!gr.cldSet) continue;
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;
	
						try {
							for (var _iterator2 = gr.cldSet[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var rec = _step2.value;
	
								if (item.tagId == rec.id) {
									var matchType = item.matchType || item.defaultMatchType;
									var ctl2Display = "none";
									var value = item.featureValue || item.defVal10;
									var value1 = value,
									    value2 = void 0;
									if (matchType == "Between" || matchType == "NotBetween") {
										ctl2Display = undefined;
										var values = (value || "").split(",");
										value1 = values[0];
										value2 = values[1];
									}
									_this2.state.formsValue[rec.c] = _extends({}, rec, { match_type: matchType, ctl2Display: ctl2Display, value1: value1, value2: value2 });
									_this2.createFormInfo(rec, matchType, value1, value2);
									break;
								}
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			});
			_this2.setState({ data: data });
		};
	
		this.createForms = function (data) {
			data.forEach(function (item) {
				var c = item.c;
				if (!c) return;
				var match_type = item.defaultMatchType || "EqualTo";
				var ctl2Display = match_type == "Between" || match_type == "NotBetween" ? undefined : "none";
				_this2.state.formsValue[c] = _extends({}, item, { match_type: match_type, ctl2Display: ctl2Display });
				_this2.createFormInfo(item, item.defaultMatchType);
			});
		};
	
		this.renderCardNodes = function (data, forms) {
	
			return data.map(function (item, index, arr) {
				if (item.cldSet) {
					var cardDisplay = 'none';
					var tmpItem = void 0;
					for (var i = 0; i < item.cldSet.length; i++) {
						tmpItem = item.cldSet[i];
						if (forms[tmpItem.c]) {
							cardDisplay = undefined;
							break;
						}
					}
					return _react2.default.createElement(
						_antd.Card,
						{ size: 'small', title: item.te, style: { display: cardDisplay, border: 0 } },
						_this2.renderCardNodes(item.cldSet, forms)
					);
				} else {
					return forms[item.c] ? _react2.default.createElement(
						_antd.Col,
						{ span: 12 },
						forms[item.c]
					) : null;
				}
			});
		};
	};
	
	exports.default = CustQueryCondition;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _common = __webpack_require__(194);
	
	var _sgiCommon = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var TreeNode = _antd.Tree.TreeNode;
	// import MainBreadcrumb from '../../main/MainBreadcrumb'
	
	
	var formItemLayout = {
	    labelCol: { span: 4 },
	    wrapperCol: { span: 20 }
	};
	
	var formItemLayout2 = {
	    labelCol: { span: 6 },
	    wrapperCol: { span: 18 }
	};
	
	var ParamMngDefDisplay = function (_React$Component) {
	    _inherits(ParamMngDefDisplay, _React$Component);
	
	    function ParamMngDefDisplay(props) {
	        _classCallCheck(this, ParamMngDefDisplay);
	
	        var _this = _possibleConstructorReturn(this, (ParamMngDefDisplay.__proto__ || Object.getPrototypeOf(ParamMngDefDisplay)).call(this, props));
	
	        _this.convertData = function (e) {
	            //校验 组装数据
	            var errors = [];
	            var errorMsg = void 0;
	            for (var tmpKey in _this.state.showCtls) {
	                var tmpCtl = _this.state.showCtls[tmpKey];
	                var ctlDisplay = _this.state.formsValue[tmpCtl.props.moduleDesc.cRef]["ctl2Display"];
	                if (ctlDisplay != 'none') {
	                    errorMsg = tmpCtl.validate();
	                    if (errorMsg) {
	                        errors.push(errorMsg);
	                    }
	                }
	            }
	
	            if (errors.length > 0) {
	                //组装数据
	                _this.setState({ loading: false });
	                // alert('校验失败');
	                return null;
	            }
	
	            var data = {};
	            for (var tmpKey in _this.state.checkedAtts) {
	                var tmpSaveRecord = _this.state.objFct.get(tmpKey + "_tmp");
	                var matchType = tmpSaveRecord.match_type;
	                var value = tmpSaveRecord[tmpKey];
	                if (matchType == "Between" || matchType == "NotBetween") {
	                    value += "," + tmpSaveRecord.value2;
	                }
	                data[tmpKey] = value;
	            }
	            return data;
	        };
	
	        _this.refreshCtlsAndData = function (data, showSelCtls) {
	            //重置
	            _this.state.forms = {};
	            _this.state.formsValue = {};
	            _this.state.checkedAtts = {};
	            _this.state.showCtls = {};
	
	            showSelCtls.forEach(function (item) {
	                // let findRecord = this.findChild('id', item.id, true);
	                var findRecord = item;
	                if (findRecord) {
	                    var matchType = findRecord.matchType;
	                    // let ctl2Display = "none";
	                    var value = data ? data[findRecord.c || findRecord.skvyiCode] : "";
	                    var value1 = value,
	                        value2 = void 0;
	                    if (matchType == "Between" || matchType == "NotBetween") {
	                        ctl2Display = undefined;
	                        var values = value.split(",");
	                        value1 = values[0];
	                        value2 = values[1];
	                    }
	                    _this.state.formsValue[findRecord.c || findRecord.skvyiCode] = data || {};
	                    _this.createSimpleFormInfo(_this, findRecord, matchType, value1, value2);
	                }
	            });
	
	            _this.setState({ loading: false });
	        };
	
	        _this.refreshData = function (data) {
	            //重置
	            _this.state.forms = {};
	            _this.state.formsValue = {};
	            _this.state.checkedAtts = {};
	            _this.state.showCtls = {};
	
	            _this.state.showSelCtls.forEach(function (item) {
	                var findRecord = _this.findChild('id', item.id, true);
	                if (findRecord) {
	                    var matchType = findRecord.matchType;
	                    // let ctl2Display = "none";
	                    var value = data ? data[findRecord.c] : "";
	                    var value1 = value,
	                        value2 = void 0;
	                    if (matchType == "Between" || matchType == "NotBetween") {
	                        ctl2Display = undefined;
	                        var values = value.split(",");
	                        value1 = values[0];
	                        value2 = values[1];
	                    }
	                    _this.state.formsValue[findRecord.c] = data;
	                    _this.createSimpleFormInfo(_this, findRecord, matchType, value1, value2);
	                }
	            });
	
	            _this.setState({ loading: false });
	        };
	
	        _this.renderCardNodes = function (forms) {
	
	            var formsCtl = [];
	            var i = 0;
	            var ctlList = void 0;
	            for (var key in forms) {
	                if (i % 1 == 0) {
	                    ctlList = [_react2.default.createElement(
	                        _antd.Col,
	                        { span: 24 },
	                        forms[key]
	                    )];
	                    formsCtl.push(_react2.default.createElement(
	                        _antd.Row,
	                        { style: { width: '100%' } },
	                        ctlList
	                    ));
	                } else {
	                    ctlList.push(_react2.default.createElement(
	                        _antd.Col,
	                        { span: 24 },
	                        forms[key]
	                    ));
	                }
	                i++;
	            }
	            return formsCtl;
	        };
	
	        _this.hasFlg = function (obj) {
	            if (!obj) return false;
	            if (obj instanceof Array) {
	                for (var i = 0; i < obj.length; i++) {
	                    if (obj[i]) return true;
	                }
	                return false;
	            }
	        };
	
	        if (!_this.props.guid) {
	            return _possibleConstructorReturn(_this);
	        }
	
	        // let objFct = new ObjFactory(this.props.guid);
	
	        var treeData = [];
	        // let prm = PrmFactory.getPrm(this.props.guid);
	        var prm = _PrmFactory.PrmFactory.getPrm("Emos_param_custAdvQuery_0001");
	        if (prm.cldSet) {
	            treeData = prm.cldSet;
	        }
	
	        _this.state = {
	            forms: {}, //客群定义显示form，一个属性一个form,{key:form,key2:form2}
	            formsValue: {},
	            showCtls: {}, //存储所有显示控件
	            objFct: _this.props.objFct,
	            loading: false,
	            checkedAtts: {},
	            treeData: treeData,
	            checkedKeys: [],
	            expandedKeys: [],
	            showSelCtls: _this.props.showSelCtls || [],
	            data: _this.props.data || {},
	            isShowAll: _this.props.isShowAll,
	            showCol: _this.props.showCol || 1
	        };
	
	        if (_this.state.isShowAll) {
	            _this.state.showSelCtls = treeData;
	        }
	        return _this;
	    }
	
	    _createClass(ParamMngDefDisplay, [{
	        key: 'findChild',
	
	
	        /**
	         * 查找属性等于指定值的第一个子项
	         * @param  {[String]} attribute [属性名称]
	         * @param  {[Object]} value     [要搜索的值]
	         * @param  {[Boolean]} deep = false      [true表示遍历所有子节点，false表示只遍历下一级]
	         * @return {[type]}           [找到的子元素，如果没有找到，则返回null]
	         */
	        value: function findChild(attribute, value, deep) {
	            var me = this;
	            return me.findChildBy(function () {
	                return this[attribute] == value;
	            }, null, deep, this.state.treeData);
	        }
	        /**
	         * 通过自定义函数查找第一个子项。 如果传递的函数返回true，则该子项匹配。
	         * @param  {Function} fn    [如果通过的节点是所需的节点，fn一个必须返回true的函数。]
	         * @param  {[Object]}   scope [执行该函数的作用域（此引用）。 默认为正在测试的节点。]
	         * @param  {[Boolean]}   deep = false  [true：搜索比直接子节点更深的节点]
	         * @return {[type]}         [找到的子元素，如果没有找到，则返回null]
	         */
	
	    }, {
	        key: 'findChildBy',
	        value: function findChildBy(fn, scope, deep, cs) {
	            // var cs = [];
	            // if (this.state.treeData) {
	            //     cs = this.state.treeData;
	            // }
	            var len = cs.length,
	                i = 0,
	                n,
	                res;
	            for (; i < len; i++) {
	                n = cs[i];
	                if (fn.call(scope || n, n) === true) {
	                    return n;
	                } else if (deep && n.cldSet) {
	                    res = this.findChildBy(fn, scope, deep, n.cldSet);
	                    if (res !== null) {
	                        return res;
	                    }
	                }
	            }
	            return null;
	        }
	
	        /**
	         * 接受显示控件属性
	         * @param {*} showSelCtls 
	         */
	
	    }, {
	        key: 'refreshShowCtlsInfo',
	        value: function refreshShowCtlsInfo(showSelCtls) {
	            if (!showSelCtls) {
	                return;
	            }
	            // this.state.showSelCtls = showSelCtls;
	            this.refreshCtlsAndData(this.state.data, showSelCtls);
	        }
	
	        /**
	         * 接受显示控件属性key
	         * @param {*} showSelCtls 
	         */
	
	    }, {
	        key: 'refreshShowCtls',
	        value: function refreshShowCtls(showSelCtls) {
	            if (!showSelCtls) {
	                return;
	            }
	            this.state.showSelCtls = showSelCtls;
	            this.refreshData(this.state.data);
	        }
	    }, {
	        key: 'createSimpleFormInfo',
	        value: function createSimpleFormInfo(thisObj, dataRef, matchType, value1, value2) {
	
	            dataRef.desId = dataRef.desId || "EP_EO_UI_3101"; //添加默认值-文本框
	
	            var attc = dataRef.c || dataRef.skvyiCode;
	            var text = dataRef.te || dataRef.name;
	
	            var bdInst = attc + "_tmp";
	
	            //显示的所有属性的集合
	            thisObj.state.checkedAtts[attc] = true;
	
	            thisObj.state.objFct.set(bdInst, thisObj.state.formsValue[attc]);
	
	            //修改c值，给每组值起同样的key
	            dataRef.cRef = attc;
	            var dataRef1 = (0, _sgiCommon.copy)(dataRef);
	            dataRef1.c = attc;
	            dataRef1.isLbl = true;
	            if (value1) dataRef1.value = value1;
	            var ctl1 = (0, _SgiCompComm.convertModuleByGuid)(thisObj, dataRef1, bdInst, thisObj.state.objFct, "N");
	            ctl1.ref = thisObj.refModalFunction.bind(thisObj);
	            var dataRef2 = (0, _sgiCommon.copy)(dataRef);
	            dataRef2.c = "value2";
	            dataRef2.isLbl = false;
	            dataRef2.te = '-';
	            dataRef2.ctlW = 24;
	            dataRef2.lblW = 2;
	            dataRef2.alwBlk = true;
	            if (value2) dataRef2.value = value2;
	            var ctl2 = (0, _SgiCompComm.convertModuleByGuid)(thisObj, dataRef2, bdInst, thisObj.state.objFct, "N");
	            if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
	                ctl2.ref = thisObj.refModalFunction.bind(thisObj);
	            } else {
	                delete ctl2.ref;
	            }
	
	            thisObj.state.forms[attc] = _react2.default.createElement(
	                FormItem,
	                _extends({ colon: false, key: (0, _sgiCommon.uuid)(8) }, formItemLayout2, { style: { 'margin-bottom': "1px", 'margin-top': "-3px" }, hasFeedback: false, label: text }),
	                ctl1
	            );
	        }
	    }, {
	        key: 'refModalFunction',
	        value: function refModalFunction(ctl) {
	            if (!ctl) {
	                return;
	            }
	            var _ctl$props = ctl.props,
	                moduleDesc = _ctl$props.moduleDesc,
	                objFct = _ctl$props.objFct;
	
	            this.state.showCtls[moduleDesc.cRef + moduleDesc.c] = ctl;
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(attc, match_type, dataRef, value) {
	            tool.sgiLogger.info('selected ' + attc);
	            tool.sgiLogger.info('selected ' + match_type);
	            tool.sgiLogger.info('selected ' + value);
	
	            if (value == "Between" || value == "NotBetween") {
	                this.state.formsValue[attc]["ctl2Display"] = undefined;
	            } else {
	                this.state.formsValue[attc]["ctl2Display"] = 'none';
	            }
	            this.state.formsValue[attc][match_type] = value;
	            createFormInfo(this, dataRef, value); //重新创建
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (!this.props.guid) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'guid\u4E0D\u5B58\u5728'
	                );
	            }
	
	            var showList = this.renderCardNodes(this.state.forms);
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '100%', width: '100%' } },
	                showList
	            );
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.refreshData(this.state.data);
	        }
	    }]);
	
	    return ParamMngDefDisplay;
	}(_react2.default.Component);
	
	exports.default = ParamMngDefDisplay;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(25);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _Dnd_SgiFormEditorCommon = __webpack_require__(409);
	
	var _common = __webpack_require__(194);
	
	var _Constant = __webpack_require__(522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TreeNode = _antd.Tree.TreeNode;
	var Option = _antd.Select.Option;
	
	var testStyle = {
	    padding: 5
	    // border: '1px solid grey'
	};
	
	var ParamMngPrmDef = function (_React$Component) {
	    _inherits(ParamMngPrmDef, _React$Component);
	
	    function ParamMngPrmDef(props) {
	        _classCallCheck(this, ParamMngPrmDef);
	
	        var _this = _possibleConstructorReturn(this, (ParamMngPrmDef.__proto__ || Object.getPrototypeOf(ParamMngPrmDef)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var treeData = [];
	        var guid = void 0;
	        var prm = void 0;
	        // let guids = guid.split("_");
	        // let prm = PrmFactory.getPrm(guid);
	        var _key = (0, _rtSdCommon.uuid)(8);
	        var detail = tool.parseForBrowserHistory(_this.props);
	        if (!detail.addFlag) {
	            guid = detail.record.guid;
	            prm = detail.record;
	            _key = detail.record[_key] || _key;
	        }
	        if (!prm || !prm.te) {
	            //getPrm会返回空对象，所以判断一下te
	            prm = {
	                n: "系统参数xxx",
	                te: "系统参数xxx",
	                _key: _key,
	                ap: "Emos",
	                tt: "param",
	                ss: "",
	                sc: "",
	                nodeType: "prm"
	            };
	        }
	        treeData.push(prm);
	
	        _this.state = {
	            values: prm,
	            selectedKeys: [_key],
	            treeData: treeData,
	            sysStore: [],
	            nodeType: "prm", //节点类型
	            SCModalVisible: false
	        };
	        return _this;
	    }
	
	    _createClass(ParamMngPrmDef, [{
	        key: 'refresh',
	        value: function refresh(attname, value) {
	            this.state.values[attname] = value;
	            this.setState({ loading: false });
	        }
	    }, {
	        key: 'renderSelectOptions',
	
	
	        // renderTreeNodes = (data) => {
	        //     return data.map((item) => {
	        //         if (item.cldSet) {
	        //             return (
	        //                 <TreeNode title={item.te} key={item._key} dataRef={item}>
	        //                     {this.renderTreeNodes(item.cldSet)}
	        //                 </TreeNode>
	        //             );
	        //         }
	        //         return <TreeNode title={item.te} key={item._key} dataRef={item} />;
	        //     });
	        // }
	        value: function renderSelectOptions(data) {
	            return data.map(function (item) {
	                return _react2.default.createElement(
	                    Option,
	                    { value: item.c },
	                    item.te
	                );
	            });
	        }
	    }, {
	        key: 'getCtlProps',
	        value: function getCtlProps() {
	            // switch (this.state.values.desId) {
	            //     case "EP_EO_UI_3101"://文本框
	            //         return (getTextEidtor(this));
	            //     case "EP_EO_UI_3104"://数字控件
	            //         return (getNumberEidtor(this));
	            //     case "EP_EO_UI_3105"://时间控件
	            //         return (getTimeEidtor(this));
	            //     case "EP_EO_UI_3106"://日期控件
	            //         return (getDateEidtor(this));
	            //     case "EP_EO_UI_3107"://下拉窗控件
	            //         return (getComboxEidtor(this));
	            //     case "EP_EO_UI_3108"://复选框组件
	            //     case "EP_EO_UI_3109"://单选框组件
	            //         return (getCheckboxGroupEidtor(this));
	            //     case "EP_EO_UI_3110"://复选框控件
	            //         return (getCheckboxEidtor(this));
	            //     case "EP_EO_NUI_0001"://下拉树控件
	            //         return (getComboxTreeEidtor(this));
	            //     default:
	            //         return (getValidForm(this));
	            // }
	            // switch (this.state.values.desId) {
	            //     case "EP_EO_UI_3101": return getEidtorFun(this, "TextEidtor");//文本框
	            //     case "EP_EO_UI_3104": return getEidtorFun(this, "NumberEidtor");//数字控件
	            //     case "EP_EO_UI_3105": return getEidtorFun(this, "TimeEidtor");//时间控件
	            //     case "EP_EO_UI_3106": return getEidtorFun(this, "DateEidtor");//日期控件
	            //     case "EP_EO_UI_3107": return getEidtorFun(this, "ComboxEidtor");//下拉窗控件
	            //     case "EP_EO_UI_3108": //复选框组件
	            //     case "EP_EO_UI_3109": return getEidtorFun(this, "CheckboxGroupEidtor");//单选框组件
	            //     case "EP_EO_UI_3110": return getEidtorFun(this, "CheckboxEidtor");//复选框控件
	            //     case "EP_EO_NUI_0001": return getEidtorFun(this, "ComboxTreeEidtor");//下拉树控件
	            //     default: return getValidForm(this);
	            // }
	            return (0, _Constant.getEidtorFun)(this, this.state.values.desId);
	        }
	    }, {
	        key: 'fitSysCombox',
	        value: function fitSysCombox() {
	
	            // 下拉窗列表值在标准代码中的id
	            var comboBoxData = StandardCode.getSC(custGroupConfig.prmSystemPrm);
	            if (!comboBoxData) {
	                return;
	            }
	
	            var attKey = 'c',
	                attName = 'te';
	
	            this.state.sysStore = [];
	
	            var size = comboBoxData.length;
	            if (!size == 0) {
	                for (var i = 0; i < size; i++) {
	                    var item = comboBoxData[i];
	                    this.state.sysStore.push(_react2.default.createElement(
	                        Option,
	                        { value: item[attKey] },
	                        item[attName]
	                    ));
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var nodeType = this.state.nodeType;
	            var groupFlg = nodeType === "prm" || nodeType === "group" || nodeType === "";
	            var tagFlg = nodeType === "group";
	            var copyFlg = nodeType !== "prm";
	            var deleteFlg = nodeType === "group" || nodeType === "tag" || nodeType === "item";
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '100%', width: '100%', padding: 5 } },
	                _react2.default.createElement(
	                    _antd.Row,
	                    { style: { margin: '5px 0px 5px 0px', height: "100%" } },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 5, style: { height: "100%", overflow: "auto" } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: _extends({}, testStyle) },
	                            _react2.default.createElement(
	                                _antd.Tree,
	                                {
	                                    draggable: true,
	                                    defaultExpandAll: true,
	                                    onSelect: this.onSelect,
	                                    selectedKeys: this.state.selectedKeys,
	                                    blockNode: true,
	                                    onDrop: this.onDrop
	                                },
	                                (0, _common.renderTreeNodes)(this.state.treeData)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 19, style: { height: "100%", overflow: "auto", display: "flex", flexDirection: "column" } },
	                        _react2.default.createElement(
	                            'div',
	                            { style: _extends({}, testStyle) },
	                            _react2.default.createElement(
	                                _antd.Button,
	                                { type: 'primary', onClick: this.save, style: { margin: 5 } },
	                                '\u4FDD\u5B58'
	                            ),
	                            _react2.default.createElement(
	                                _antd.Button,
	                                { disabled: !groupFlg, onClick: this.addSub.bind(this, "group"), style: { margin: "5px 5px 5px 0" } },
	                                '\u6DFB\u52A0\u5206\u7EC4'
	                            ),
	                            _react2.default.createElement(
	                                _antd.Button,
	                                { disabled: !tagFlg, onClick: this.addSub.bind(this, "tag"), style: { margin: "5px 5px 5px 0" } },
	                                '\u6DFB\u52A0\u6307\u6807'
	                            ),
	                            _react2.default.createElement(
	                                _antd.Button,
	                                { disabled: !copyFlg, onClick: this.copyNode, style: { margin: "5px 5px 5px 0" } },
	                                '\u590D\u5236\u8282\u70B9'
	                            ),
	                            _react2.default.createElement(
	                                _antd.Button,
	                                { disabled: !deleteFlg, onClick: this.delNode, style: { margin: "5px 5px 5px 0" } },
	                                '\u5220\u9664' + (nodeType === "group" ? "分组" : "指标")
	                            )
	                        ),
	                        this.getShowCard()
	                    )
	                ),
	                (0, _Dnd_SgiFormEditorCommon.getSCModal)(this)
	            );
	        }
	    }]);
	
	    return ParamMngPrmDef;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.addSub = function (nodeType) {
	        var record = _this2.state.values;
	        if (!record) {
	            alert("请选择节点");
	        }
	        _this2.addCldSet(record, nodeType);
	    };
	
	    this.delNode = function () {
	        var treeNode = _this2.state.treeNode || {};
	        var dataRef = treeNode.props.dataRef;
	        var parentDataRef = treeNode.props.parentDataRef;
	        if (parentDataRef && dataRef) {
	            var cldSet = parentDataRef.cldSet || [];
	            cldSet.splice(cldSet.indexOf(dataRef), 1);
	            _this2.setState({});
	        }
	    };
	
	    this.copyNode = function () {
	        var treeNode = _this2.state.treeNode || {};
	        var dataRef = treeNode.props.dataRef;
	        var parentDataRef = treeNode.props.parentDataRef;
	        if (parentDataRef && dataRef) {
	            var cldSet = parentDataRef.cldSet || [];
	            var copyData = (0, _rtSdCommon.copy)(dataRef, true);
	            _this2.changeKeys(copyData);
	            cldSet.splice(cldSet.indexOf(dataRef) + 1, 0, copyData);
	            _this2.setState({});
	        }
	    };
	
	    this.changeKeys = function (item) {
	        item.te += "-copy";
	        item._key = (0, _rtSdCommon.uuid)(8);
	        if (item.nodeType === "group") {
	            item.sc = (0, _rtSdCommon.uuid)(8);
	        } else {
	            item.id = (0, _rtSdCommon.uuid)(64);
	        }
	        if (item.cldSet && item.cldSet.length > 0) item.cldSet.forEach(function (r) {
	            return _this2.changeKeys(r);
	        });
	    };
	
	    this.save = function () {
	        var prm = _this2.state.treeData[0];
	        tool.sgiLogger.log("save prm:", prm);
	        var result = _rtSdCommon.PrmFactory.save(prm);
	        if (result == 0) {
	            tool.popMessage("保存成功！", "success");
	        } else {
	            tool.popMessage("保存失败，result：" + result, "warning");
	        }
	    };
	
	    this.onDrop = function (info) {
	        var dropKey = info.node.props.eventKey;
	        var dragKey = info.dragNode.props.eventKey;
	        var dropPos = info.node.props.pos.split('-');
	        var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
	
	        var loop = function loop(data, key, callback) {
	            data.forEach(function (item, index, arr) {
	                if (item._key === key) {
	                    return callback(item, index, arr);
	                }
	                if (item.cldSet) {
	                    return loop(item.cldSet, key, callback);
	                }
	            });
	        };
	        // const data = [...this.state.gData];
	        var data = _this2.state.treeData;
	
	        // Find dragObject
	        var dragObj = void 0;
	        loop(data, dragKey, function (item, index, arr) {
	            arr.splice(index, 1);
	            dragObj = item;
	        });
	
	        if (!info.dropToGap) {
	            // Drop on the content
	            loop(data, dropKey, function (item) {
	                item.cldSet = item.cldSet || [];
	                // where to insert 示例添加到尾部，可以是随意位置
	                item.cldSet.push(dragObj);
	            });
	        } else if ((info.node.props.cldSet || []).length > 0 && // Has children
	        info.node.props.expanded && // Is expanded
	        dropPosition === 1 // On the bottom gap
	        ) {
	                loop(data, dropKey, function (item) {
	                    item.cldSet = item.cldSet || [];
	                    // where to insert 示例添加到头部，可以是随意位置
	                    item.cldSet.unshift(dragObj);
	                });
	            } else {
	            var ar = void 0;
	            var i = void 0;
	            loop(data, dropKey, function (item, index, arr) {
	                ar = arr;
	                i = index;
	            });
	            if (dropPosition === -1) {
	                ar.splice(i, 0, dragObj);
	            } else {
	                ar.splice(i + 1, 0, dragObj);
	            }
	        }
	
	        _this2.setState({});
	    };
	
	    this.onSelect = function (selectedKeys, info) {
	        _this2.setState({ selectedKeys: selectedKeys });
	        var record = info.node.props.dataRef;
	        _this2.setState({ values: record });
	        var nodeType = record.nodeType;
	        _this2.setState({ nodeType: nodeType });
	
	        _this2.setState({ treeNode: info.node });
	    };
	
	    this.addCldSet = function (record, nodeType) {
	        var cldSet = record.cldSet;
	        if (!cldSet) {
	            cldSet = record.cldSet = [];
	        }
	        var item = {
	            te: "xxx",
	            _key: (0, _rtSdCommon.uuid)(8),
	            nodeType: nodeType,
	            sc: (0, _rtSdCommon.uuid)(8)
	        };
	        if (nodeType == "tag") {
	            item.id = (0, _rtSdCommon.uuid)(64);
	            item.desId = "EP_EO_UI_3101"; //默认文本框
	            delete item.sc;
	        }
	        cldSet.push(item);
	        _this2.setState({ loading: false });
	    };
	
	    this.getShowCard = function () {
	
	        _this2.fitSysCombox();
	
	        switch (_this2.state.nodeType) {
	            case "prm":
	                return _react2.default.createElement(
	                    _antd.Card,
	                    { size: 'small', title: '\u53C2\u6570\u5B9A\u4E49' },
	                    _react2.default.createElement(
	                        'div',
	                        { style: testStyle },
	                        _react2.default.createElement(
	                            _antd.Form,
	                            null,
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "子系统编码" }),
	                                        _react2.default.createElement(
	                                            _antd.Select,
	                                            { value: _this2.state.values.ss, onChange: _Dnd_SgiFormEditorCommon.selectOnChange.bind(_this2, _this2, 'ss') },
	                                            _this2.state.sysStore
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "语义码" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this2.state.values.sc, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'sc') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "名称" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this2.state.values.n, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'n') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "显示名称" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this2.state.values.te, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'te') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "创建人" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this2.state.values.auth })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "创建时间" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this2.state.values.crtTm })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "修改人" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this2.state.values.edAuth })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "修改时间" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this2.state.values.edTm })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "参数版本" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this2.state.values.prmVsn })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "GUID" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this2.state.values.guid })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 16 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout2, { label: "注释" }),
	                                        _react2.default.createElement(_antd.Input.TextArea, { value: _this2.state.values.ann, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'ann') })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            case "group":
	                return _react2.default.createElement(
	                    _antd.Card,
	                    { size: 'small', title: '\u5206\u7EC4\u5B9A\u4E49' },
	                    _react2.default.createElement(
	                        'div',
	                        { style: testStyle },
	                        _react2.default.createElement(
	                            _antd.Form,
	                            null,
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "组名" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this2.state.values.te, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'te') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "编码" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this2.state.values.sc ? _this2.state.values.sc : _this2.state.values.sc = tool.uuid(8) })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "列表展示" }),
	                                        _react2.default.createElement(_antd.Checkbox, { checked: _this2.state.values.isList, onChange: _Dnd_SgiFormEditorCommon.checkOnChange.bind(_this2, _this2, 'isList') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 16 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout2, { label: "描述" }),
	                                        _react2.default.createElement(_antd.Input.TextArea, { value: _this2.state.values.ann, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'ann') })
	                                    )
	                                ),
	                                _this2.state.values.isList ? _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 7, offset: 1 },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { color: "#faad14" } },
	                                        '\u6CE8\uFF1A\u5217\u8868\u5F62\u5F0F\u5339\u914D\u7C7B\u578B\u53EA\u80FD\u662F\u201C\u7B49\u4E8E\u201D'
	                                    )
	                                ) : null
	                            )
	                        )
	                    )
	                );
	            default:
	                var desId = _this2.state.values.desId;
	                if (!desId) desId = _this2.state.values.desId = "EP_EO_UI_3101";
	                return _react2.default.createElement(
	                    _antd.Card,
	                    { size: 'small', title: '\u5C5E\u6027\u5B9A\u4E49' },
	                    _react2.default.createElement(
	                        'div',
	                        { style: _extends({}, testStyle, { display: _this2.state.display }) },
	                        _react2.default.createElement(
	                            _antd.Form,
	                            null,
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 16 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout2, { label: "标签ID" }),
	                                        _react2.default.createElement(_antd.Input, { disabled: true, value: _this2.state.values.id })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 3 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        { style: { margin: 0 }, labelCol: { span: 18 }, label: "允许为空" },
	                                        _react2.default.createElement(_antd.Checkbox, { checked: _this2.state.values.alwBlk, onChange: _Dnd_SgiFormEditorCommon.checkOnChange.bind(_this2, _this2, 'alwBlk') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "名称" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this2.state.values.te, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'te') })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "编码" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this2.state.values.c, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'c') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 16 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout2, { label: "描述" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this2.state.values.ann, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'ann') })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "组件类型" }),
	                                        _react2.default.createElement(
	                                            _antd.Select,
	                                            {
	                                                value: desId,
	                                                onChange: _Dnd_SgiFormEditorCommon.selectOnChange.bind(_this2, _this2, "desId") },
	                                            _this2.renderSelectOptions(_Constant.ctlTypes)
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "值类型" }),
	                                        _react2.default.createElement(
	                                            _antd.Select,
	                                            {
	                                                value: _this2.state.values.valueType || "01",
	                                                onChange: _Dnd_SgiFormEditorCommon.selectOnChange.bind(_this2, _this2, "valueType") },
	                                            _this2.renderSelectOptions(_Constant.valueTypes)
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: testStyle },
	                        _this2.getCtlProps()
	                    ),
	                    _react2.default.createElement(
	                        _antd.Card,
	                        { size: 'small', title: '\u5217\u8868\u5C5E\u6027(\u5F53\u5206\u7EC4\u8282\u70B9\u4E3A\u5217\u8868\u5C55\u793A\u65F6\uFF0C\u4EE5\u4E0B\u5C5E\u6027\u6709\u6548)', bordered: false },
	                        _react2.default.createElement(
	                            _antd.Form,
	                            null,
	                            _react2.default.createElement(
	                                _antd.Row,
	                                null,
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 8 },
	                                    _react2.default.createElement(
	                                        FormItem,
	                                        _extends({}, _Constant.formItemLayout, { label: "列宽" }),
	                                        _react2.default.createElement(_antd.Input, { value: _this2.state.values.width, onChange: _Dnd_SgiFormEditorCommon.textOnChange.bind(_this2, _this2, 'width') })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	        }
	    };
	};
	
	exports.default = ParamMngPrmDef;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EditorDesc = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Option = _antd.Select.Option;
	
	var defaultLayout = { style: { margin: 0 }, labelCol: { xs: { span: 24 }, sm: { span: 8 } }, wrapperCol: { xs: { span: 24 }, sm: { span: 16 } } };
	
	var Common = [[{ code: "te", span: 8 }, { code: "alwBlk", span: 3 }, { code: "isDis", span: 3 }, { code: "isRead", span: 3 }, { code: "isHdn", span: 3 }, { code: "isLbl", span: 3 }], [{ code: "c", span: 8 }, { code: "cId", span: 8 }, { code: "lblAlg", span: 8 }], [{ code: "lblW", span: 8 }, { code: "ctlW", span: 8 }, { code: "ctlH", span: 8 }]];
	var EditorDesc = {
	    // 通用控件描述
	    Common: Common,
	    // 文本控件描述
	    TextEidtor: [[{ ctlName: "Input", te: "文本后信息", code: "bdText", span: 8, layout: defaultLayout }, { ctlName: "Input", te: "初始值", code: "defVal10", span: 8, layout: defaultLayout }], [{ ctlName: "InputNumber", te: "最小长度", code: "minL", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }, { ctlName: "InputNumber", te: "最大长度", code: "maxL", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }], [{ ctlName: "InputNumber", te: "最小值", code: "minV", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }, { ctlName: "InputNumber", te: "最大值", code: "maxV", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }], [{ ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }]],
	    // 数字控件描述
	    NumberEidtor: [[{ ctlName: "InputNumber", te: "最小值", code: "minV", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }, { ctlName: "InputNumber", te: "最大值", code: "maxV", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }], [{ ctlName: "InputNumber", te: "最小长度", code: "minL", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }, { ctlName: "InputNumber", te: "最大长度", code: "maxL", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }], [{ ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }]],
	    // 时间控件描述
	    TimeEidtor: [[{ ctlName: "InputNumber", te: "小时选项间隔", code: "hourStep", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }, { ctlName: "InputNumber", te: "分钟选项间隔", code: "minuteStep", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }], [{ ctlName: "InputNumber", te: "秒选项间隔", code: "secondStep", span: 8, layout: defaultLayout, props: { style: { width: "100%" } } }, { ctlName: "Input", te: "时间格式", code: "timeFmt", span: 8, layout: defaultLayout, props: { placeholder: "HH:mm:ss" } }], [{ ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }]],
	    // 日期控件描述
	    DateEidtor: [[{
	        ctlName: "Select", te: "组件模式", code: "ctlMode", span: 8, layout: defaultLayout, props: { placeholder: "YYYY-MM-DD", defaultValue: "date" }, children: [_react2.default.createElement(
	            Option,
	            { value: 'date' },
	            '\u65E5\u671F\u6A21\u5F0F'
	        ), _react2.default.createElement(
	            Option,
	            { value: 'dateTime' },
	            '\u65E5\u671F\u65F6\u95F4\u6A21\u5F0F'
	        ), _react2.default.createElement(
	            Option,
	            { value: 'month' },
	            '\u6708\u6A21\u5F0F'
	        ), _react2.default.createElement(
	            Option,
	            { value: 'week' },
	            '\u5468\u6A21\u5F0F'
	        ), _react2.default.createElement(
	            Option,
	            { value: 'dateRange' },
	            '\u65E5\u671F\u8303\u56F4\u6A21\u5F0F'
	        ), _react2.default.createElement(
	            Option,
	            { value: 'dateTimeRange' },
	            '\u65E5\u671F\u65F6\u95F4\u8303\u56F4\u6A21\u5F0F'
	        )]
	    }, { ctlName: "Input", te: "日期格式", code: "dateFmt", span: 8, layout: defaultLayout }], [{ ctlName: "DatePicker", te: "可选的起始日期", code: "optBDt", span: 8, layout: defaultLayout }, { ctlName: "DatePicker", te: "可选的结束日期", code: "optEDt", span: 8, layout: defaultLayout }], [{ ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }]],
	    // 下拉窗控件描述
	    ComboxEidtor: [[{ ctlName: "Input", te: "标准代码", code: "scId", span: 8, layout: defaultLayout }, { ctlName: "Checkbox", te: "多选", code: "mulSel", span: 8, layout: defaultLayout }], [{ ctlName: "Checkbox", te: "自动选择", code: "autoSel", span: 8, layout: defaultLayout }, { ctlName: "Checkbox", te: "搜索框", code: "search", span: 8, layout: defaultLayout }], [{ ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }]],
	    // 复选框组件描述
	    CheckboxGroupEidtor: [[{ ctlName: "Input", te: "标准代码", code: "scId", span: 8, layout: defaultLayout }, { ctlName: "Input", te: "默认选中项", code: "checked", span: 8, layout: defaultLayout }]],
	    // 复选框控件描述
	    CheckboxEidtor: [[{ ctlName: "Input", te: "初始值", code: "defVal10", span: 8, layout: defaultLayout }]],
	    // 下拉树控件描述
	    ComboxTreeEidtor: [[{ ctlName: "Input", te: "标准代码", code: "scId", span: 8, layout: defaultLayout }, { ctlName: "Checkbox", te: "多选", code: "mulSel", span: 8, layout: defaultLayout }], [{ ctlName: "Input", te: "显示属性名", code: "showKey", span: 8, layout: defaultLayout }, { ctlName: "Input", te: "保存属性名", code: "saveKey", span: 8, layout: defaultLayout }], [{ ctlName: "Input", te: "输入提示文本", code: "inpPopTe", span: 16, layout: { labelCol: { span: 4 }, wrapperCol: { span: 20 }, style: { margin: 0 } } }]]
	};
	// 兼容老版本类型
	EditorDesc.EP_EO_UI_3101 = EditorDesc.TextEidtor;
	EditorDesc.EP_EO_UI_3104 = EditorDesc.NumberEidtor;
	EditorDesc.EP_EO_UI_3105 = EditorDesc.TimeEidtor;
	EditorDesc.EP_EO_UI_3106 = EditorDesc.DateEidtor;
	EditorDesc.EP_EO_UI_3107 = EditorDesc.ComboxEidtor;
	EditorDesc.EP_EO_UI_3108 = EditorDesc.CheckboxGroupEidtor;
	EditorDesc.EP_EO_UI_3109 = EditorDesc.CheckboxGroupEidtor;
	EditorDesc.EP_EO_UI_3110 = EditorDesc.CheckboxEidtor;
	EditorDesc.EP_EO_NUI_0001 = EditorDesc.ComboxTreeEidtor;
	
	exports.EditorDesc = EditorDesc;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = _antd.Input.Search;
	
	
	var SearchBtn = function SearchBtn(props) {
	  var disabled = props.disabled,
	      count = props.count,
	      defaultName = props.defaultName;
	
	  return _react2.default.createElement(
	    _antd.Button,
	    { style: { width: "120px" }, type: "primary" },
	    disabled ? count : defaultName
	  );
	};
	
	var formItemLayout = {
	  labelCol: {
	    xs: { span: 24 },
	    sm: { span: 3 }
	  },
	  wrapperCol: {
	    xs: { span: 24 },
	    sm: { span: 21 }
	  },
	  labelAlign: 'right'
	};
	
	var Register = function (_Component) {
	  _inherits(Register, _Component);
	
	  function Register() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Register);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Register.__proto__ || Object.getPrototypeOf(Register)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isSuccess: false,
	      countLoading: false,
	      count: 59,
	      mngInfo: {
	        userId: null
	      }
	    }, _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        values.entAgentInfo = {
	          agentNam: values.agentNam,
	          agentMbl: values.agentMbl,
	          agentEmail: values.agentEmail
	        };
	        values.roleInfos = _this.state.roleInfos;
	        values.mngInfo = _this.state.mngInfo;
	        console.log(values);
	        if (!err) {
	          var success = function success(res) {
	            if (res && res.head && res.head.code === '0000') {
	              // this.setState({
	              //   isSuccess: true
	              // })
	              tool.popSingleUI('/');
	              tool.popMessage(res.head.msg, "success");
	            } else {
	              tool.popMessage(res.head.msg, "error");
	            }
	          };
	
	          var url = sgiConfig.service_cust + '/ent/register';
	          commonClient.simplecall(url, values, success);
	        }
	      });
	    }, _this.countDown = function () {
	      var count = _this.state.count;
	
	      var timer = setInterval(function () {
	        _this.setState({ count: count-- }, function () {
	          if (count <= -1) {
	            clearInterval(timer);
	            _this.setState({
	              count: 59,
	              countLoading: false
	            });
	          }
	        });
	      }, 1000);
	    }, _this.validatePhone = function (loginNam, cb) {
	      var success = function success(res) {
	        if (res && res.body) {
	          tool.popMessage("手机号已注册,请更换手机号！", 'error');
	        } else {
	          cb();
	        }
	      };
	      var req = {
	        loginNam: loginNam
	      };
	      commonClient.simplecall(sgiConfig.service_uam + "/index/mbl", req, success);
	    }, _this.beforeSendNote = function () {
	      var validateFields = _this.props.form.validateFields;
	
	      validateFields(['agentMbl'], function (err, value) {
	        if (err) return;
	        _this.sendNote();
	        // this.validatePhone(value.agentMbl, this.sendNote)
	      });
	    }, _this.sendNote = function () {
	      var getFieldValue = _this.props.form.getFieldValue;
	
	      if (_this.state.countLoading) return console.log('倒数中。。。。');
	      var success = function success(res) {
	        if (res.head.code === '0000') {
	          _this.setState({
	            countLoading: true
	          });
	          if (!_this.state.count == 0) {
	            _this.countDown();
	          }
	        } else {
	          tool.popMessage(res.head.msg, "error");
	        }
	      };
	      commonClient.simplecall(sgiConfig.allUrl.sendNoteByPhone, { linkmanMbl: getFieldValue('agentMbl') }, success);
	    }, _this.getCustByCode = function (setFieldsValue, e) {
	      if (!e.target.value) return;
	      var success = function success(res) {
	        if (res && res.head && res.head.code === "0000") {
	          setFieldsValue({ 'entNam': res.body.entNam });
	          setFieldsValue({ 'socialCreditCode': res.body.socialCreditCode });
	          setFieldsValue({ 'agentMbl': res.body.agentMbl || null });
	          setFieldsValue({ 'email': res.body.email || null });
	          _this.setState({
	            mngInfo: {
	              userId: res.body.mngInfo.userId || null
	            },
	            roleInfos: res.body.roleInfos || []
	          });
	        } else {
	          tool.popMessage(res.head.msg, "error");
	        }
	      };
	      var url = sgiConfig.service_cust + '/supMan/getEntNam';
	      console.log(url);
	      commonClient.simplecall(url, { inviteCode: e.target.value }, success);
	    }, _this.Change = function (e) {
	      _this.setState(_defineProperty({}, e.target.name, e.target.value));
	    }, _this.compareToFirstPassword = function (rule, value, callback) {
	      var form = _this.props.form;
	
	      if (value && value !== form.getFieldValue('password')) {
	        callback('密码输入不一致');
	      } else {
	        callback();
	      }
	    }, _this.toLogin = function () {
	      tool.popSingleUI('/');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // 验证手机号是否注册
	
	
	  _createClass(Register, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props$form = this.props.form,
	          getFieldDecorator = _props$form.getFieldDecorator,
	          getFieldValue = _props$form.getFieldValue,
	          setFieldsValue = _props$form.setFieldsValue,
	          validateFields = _props$form.validateFields;
	      var isSuccess = this.state.isSuccess;
	
	      return !isSuccess ? _react2.default.createElement(
	        _antd.Form,
	        _extends({ onSubmit: this.handleSubmit }, formItemLayout, { size: "small" }),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u9080\u8BF7\u7801" },
	          getFieldDecorator("inviteCode", {
	            rules: [{ required: true, message: "请输入邀请码" }]
	            // initialValue:'Q33W4N'
	          })(_react2.default.createElement(_antd.Input, {
	            onBlur: function onBlur(e) {
	              return _this2.getCustByCode(setFieldsValue, e);
	            }
	            // prefix={<Icon type="user"  />}
	            , placeholder: "\u9080\u8BF7\u7801",
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u4F01\u4E1A\u540D\u79F0" },
	          getFieldDecorator("entNam", {
	            rules: [{ required: true, message: "验证码校验错误" }]
	          })(_react2.default.createElement(_antd.Input
	          // prefix={<Icon type="lock"  />}
	          , { disabled: true,
	            placeholder: "\u4F01\u4E1A\u540D\u79F0",
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801" },
	          getFieldDecorator("socialCreditCode", {
	            rules: [{ required: true, message: "请输入社会信用代码" }]
	          })(_react2.default.createElement(_antd.Input
	          // prefix={<Icon type="lock"  />}
	          , { disabled: true,
	            placeholder: "\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801",
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u4F01\u4E1A\u7F16\u7801" },
	          getFieldDecorator("entCode", {
	            rules: [{ required: true, message: "请输入企业编码" }]
	          })(_react2.default.createElement(_antd.Input
	          // prefix={<Icon type="lock"  />}
	          , { placeholder: "\u4F01\u4E1A\u7F16\u7801",
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u7528\u6237\u540D" },
	          getFieldDecorator("userNam", {
	            rules: [{ required: true, message: "请设置用户名" }, { min: 6, message: "用户名至少6位" }]
	          })(_react2.default.createElement(_antd.Input
	          // prefix={<Icon type="lock"  />}
	          , { placeholder: "\u8BF7\u8BBE\u7528\u6237\u540D",
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u59D3\u540D" },
	          getFieldDecorator("agentNam", {
	            rules: [{ required: true, message: "请输入姓名" }]
	          })(_react2.default.createElement(_antd.Input
	          // prefix={<Icon type="lock"  />}
	          , { placeholder: "\u59D3\u540D",
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u90AE\u7BB1" },
	          getFieldDecorator("agentEmail", {
	            rules: [{ required: true, message: "请输入邮箱" }, {
	              type: 'email',
	              message: '邮箱格式不正确'
	            }]
	          })(_react2.default.createElement(_antd.Input
	          // prefix={<Icon type="lock"  />}
	          , { placeholder: "\u90AE\u7BB1",
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u624B\u673A\u53F7\u7801" },
	          getFieldDecorator("agentMbl", {
	            rules: [{ required: true, message: "请输入手机号码" }, { pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/, message: "手机号码格式不对" }]
	          })(_react2.default.createElement(_antd.Input
	          // prefix={<Icon type="lock"  />}
	          , { placeholder: "\u624B\u673A\u53F7\u7801",
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: "\u77ED\u4FE1\u9A8C\u8BC1\u7801" },
	          getFieldDecorator("code", {
	            rules: [{ required: true, message: "短信验证码" }]
	          })(_react2.default.createElement(Search
	          // prefix={<Icon type="lock"  />}
	          , { placeholder: "\u77ED\u4FE1\u9A8C\u8BC1\u7801",
	            enterButton: SearchBtn({
	              disabled: this.state.countLoading,
	              count: this.state.count + " 秒",
	              defaultName: "发送验证码"
	            }),
	            onSearch: function onSearch() {
	              return _this2.beforeSendNote();
	            },
	            style: { maxWidth: '300px' }
	          }))
	        ),
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { label: " ", colon: false },
	          _react2.default.createElement(
	            _antd.Button,
	            { style: { maxWidth: '300px', width: '100%' }, type: "primary", htmlType: "submit" },
	            "\u6CE8\u518C"
	          )
	        )
	      ) : _react2.default.createElement(
	        "div",
	        { style: { textAlign: 'center' } },
	        _react2.default.createElement(
	          "span",
	          { style: { color: '#67C23A', fontSize: '30px' } },
	          _react2.default.createElement(_antd.Icon, { type: "check" }),
	          "\u6CE8\u518C\u6210\u529F"
	        ),
	        _react2.default.createElement(
	          _antd.Button,
	          { onClick: this.toLogin, type: "link", block: true },
	          "\u53BB\u767B\u5F55"
	        )
	      );
	    }
	  }]);
	
	  return Register;
	}(_react.Component);
	
	var RegisterForm = _antd.Form.create()(Register);
	exports.default = RegisterForm;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	var _Login = __webpack_require__(2010);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _x = __webpack_require__(445);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _code = __webpack_require__(2031);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _RegisterForm = __webpack_require__(991);
	
	var _RegisterForm2 = _interopRequireDefault(_RegisterForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = _antd.Layout.Header,
	    Footer = _antd.Layout.Footer,
	    Content = _antd.Layout.Content;
	
	var index = function (_Component) {
	    _inherits(index, _Component);
	
	    function index() {
	        _classCallCheck(this, index);
	
	        return _possibleConstructorReturn(this, (index.__proto__ || Object.getPrototypeOf(index)).apply(this, arguments));
	    }
	
	    _createClass(index, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _antd.Layout,
	                { className: _Login2.default.loginLayout },
	                _react2.default.createElement(
	                    Header,
	                    { className: _Login2.default.loginHeader },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _Login2.default.loginTitle },
	                        _react2.default.createElement('img', { className: _Login2.default.loginTitleImg,
	                            src: _x2.default,
	                            alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { onClick: function onClick() {
	                                tool.popSingleUI('/');
	                            }, className: _Login2.default.toLogin },
	                        '\u5DF2\u6709\u8D26\u53F7\uFF0C\u7ACB\u5373\u767B\u5F55'
	                    )
	                ),
	                _react2.default.createElement(
	                    Content,
	                    { className: _Login2.default.loginContent },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: _Login2.default.formTitle, style: { color: '#00b34f' } },
	                        '\u7528\u6237\u6CE8\u518C'
	                    ),
	                    _react2.default.createElement(_antd.Divider, { className: _Login2.default.Divider1 }),
	                    _react2.default.createElement(_RegisterForm2.default, { formstate: 'asdasd' })
	                )
	            );
	        }
	    }]);
	
	    return index;
	}(_react.Component);
	
	exports.default = index;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchTimeConfig = function (_React$Component) {
	    _inherits(BatchTimeConfig, _React$Component);
	
	    function BatchTimeConfig() {
	        _classCallCheck(this, BatchTimeConfig);
	
	        var _this = _possibleConstructorReturn(this, (BatchTimeConfig.__proto__ || Object.getPrototypeOf(BatchTimeConfig)).call(this));
	
	        _this.state = {};
	
	        return _this;
	    }
	
	    _createClass(BatchTimeConfig, [{
	        key: "getValue",
	        value: function getValue() {
	            var ifr = document.getElementById("ifr");
	            var w = ifr.contentWindow;
	            if (!w) {
	                return;
	            }
	
	            var v = w.getValue();
	            return v;
	            // if (!window.frames[0]){
	            //     return;
	            // }
	            // let value = window.frames[0].getValue();
	            // tool.sgiLogger.info(value);
	            // return value;
	        }
	    }, {
	        key: "setValue",
	        value: function setValue(value) {
	            var ifr = document.getElementById("ifr");
	            var w = ifr.contentWindow;
	            if (!w) {
	                return;
	            }
	            setTimeout(function () {
	                w.setValue(value);
	            }, 0);
	
	            // if (!window.frames[0]) {
	            //     return;
	            // }
	            // window.frames[0].setValue(value);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	
	            window.iframeObjFct = this.props.objFct;
	
	            return _react2.default.createElement("iframe", { id: "ifr", src: '/bacthTimeConf/batchTimeConfig.html', width: "100%", height: "98%" });
	        }
	
	        // componentDidMount(){
	        //     this.setValue("0 0 0 * 1 ? *");
	        // }
	
	
	    }]);
	
	    return BatchTimeConfig;
	}(_react2.default.Component);
	
	exports.default = BatchTimeConfig;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var OperationLogMonitor = function (_React$Component) {
	    _inherits(OperationLogMonitor, _React$Component);
	
	    function OperationLogMonitor() {
	        _classCallCheck(this, OperationLogMonitor);
	
	        var _this = _possibleConstructorReturn(this, (OperationLogMonitor.__proto__ || Object.getPrototypeOf(OperationLogMonitor)).call(this));
	
	        tool.setLoginInfoExtra({
	            "pageSize": 10,
	            "offset": 1
	        });
	        _this.SrvMonitorQuery(); //调用查询操作日志监控数据服务
	
	        _this.state = {
	            listData: [], //表数据
	            srvSrlno: "",
	            appName: "",
	            optName: "",
	            startTime: "",
	            endTime: "",
	            resCode: "",
	            pagination: {
	                total: 0,
	                pageSize: 0
	            }
	        };
	        return _this;
	    }
	    //查询操作日志监控数据服务
	
	
	    _createClass(OperationLogMonitor, [{
	        key: 'SrvMonitorQuery',
	        value: function SrvMonitorQuery(body) {
	            var req = body || {};
	            var success = function success(res) {
	                if (res && res.head.code == "0000") {
	                    tool.sgiLogger.info(res);
	
	                    this.setState({
	                        listData: res.body,
	                        pagination: {
	                            total: res.head.pageCount,
	                            pageSize: res.head.recordCount
	                        }
	                    });
	                } else {
	                    _antd.message.error(res.head.msg);
	                }
	            };
	            commonClient.simplecall(sgiConfig.allUrl.SrvMonitorQuery, req, success.bind(this), true);
	        }
	        //查询条件-服务标示
	
	    }, {
	        key: 'srvSrlnoChange',
	        value: function srvSrlnoChange(e) {
	            this.setState({
	                srvSrlno: e.target.value
	            });
	        }
	        //查询条件-应用
	
	    }, {
	        key: 'appNameChange',
	        value: function appNameChange(e) {
	            this.setState({
	                appName: e.target.value
	            });
	        }
	        //查询条件-操作人名称
	
	    }, {
	        key: 'optNameChange',
	        value: function optNameChange(e) {
	            this.setState({
	                optName: e.target.value
	            });
	        }
	        //查询条件-响应结果
	
	    }, {
	        key: 'resCodeChange',
	        value: function resCodeChange(value) {
	            this.setState({
	                resCode: value
	            });
	        }
	        //查询条件-开始时间
	
	    }, {
	        key: 'startTimeChange',
	        value: function startTimeChange(value, dateString) {
	            tool.sgiLogger.info('Selected Time: ', value);
	            tool.sgiLogger.info('Formatted Selected Time: ', dateString);
	            this.setState({
	                startTime: dateString,
	                startTimeValue: value
	            });
	        }
	        //查询条件-结束时间
	
	    }, {
	        key: 'endTimeChange',
	        value: function endTimeChange(value, dateString) {
	            tool.sgiLogger.info('Selected Time: ', value);
	            tool.sgiLogger.info('Formatted Selected Time: ', dateString);
	            this.setState({
	                endTime: dateString,
	                endTimeValue: value
	            });
	        }
	        //点击条件查询按钮
	
	    }, {
	        key: 'searchClick',
	        value: function searchClick() {
	            if (this.state.startTime && this.state.endTime && this.state.startTime > this.state.endTime) {
	                _antd.message.error("结束时间不能早于开始时间！");
	                return;
	            }
	
	            var req = {
	                srvSrlno: this.state.srvSrlno,
	                appName: this.state.appName,
	                optName: this.state.optName,
	                startTime: this.state.startTime,
	                endTime: this.state.endTime,
	                resCode: this.state.resCode
	            };
	            tool.sgiLogger.info(req);
	            this.SrvMonitorQuery(req);
	        }
	    }, {
	        key: 'redoClick',
	        value: function redoClick() {
	            this.setState({
	                srvSrlno: null,
	                appName: null,
	                optName: null,
	                startTime: null,
	                endTime: null,
	                resCode: null,
	                startTimeValue: null,
	                endTimeValue: null
	            });
	        }
	        //表格换页
	
	    }, {
	        key: 'handleTableChange',
	        value: function handleTableChange(pagination, filters, sorter) {
	            tool.sgiLogger.info(pagination, filters, sorter);
	            tool.setLoginInfoExtra({
	                "pageSize": 10,
	                "offset": pagination.current
	            });
	            var req = {
	                srvSrlno: this.state.srvSrlno,
	                appName: this.state.appName,
	                optName: this.state.optName,
	                startTime: this.state.startTime,
	                endTime: this.state.endTime,
	                resCode: this.state.resCode
	            };
	            tool.sgiLogger.info(req);
	            this.SrvMonitorQuery(req);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var columns = [{
	                title: "服务标示",
	                dataIndex: "srvSrlno"
	            }, {
	                title: "请求ip",
	                dataIndex: "csmId"
	            }, {
	                title: "应用",
	                dataIndex: "appName"
	            }, {
	                title: "响应结果",
	                dataIndex: "resCode"
	            }, {
	                title: "错误信息",
	                dataIndex: "resErrInfo"
	            }, {
	                title: "耗时",
	                dataIndex: "allTimcnsm"
	            }, {
	                title: "操作时间",
	                dataIndex: "monitorTim"
	            }, {
	                title: "操作人名称",
	                dataIndex: "optName"
	            }];
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: '20px' } },
	                    _react2.default.createElement(_antd.Input, { value: this.state.srvSrlno, style: { width: 200, marginLeft: "10px", marginBottom: "10px" }, placeholder: '\u670D\u52A1\u6807\u793A', onChange: this.srvSrlnoChange.bind(this) }),
	                    _react2.default.createElement(_antd.Input, { value: this.state.appName, style: { width: 200, marginLeft: "10px", marginBottom: "10px" }, placeholder: '\u5E94\u7528', onChange: this.appNameChange.bind(this) }),
	                    _react2.default.createElement(_antd.Input, { value: this.state.optName, style: { width: 200, marginLeft: "10px", marginBottom: "10px" }, placeholder: '\u64CD\u4F5C\u4EBA\u540D\u79F0', onChange: this.optNameChange.bind(this) }),
	                    _react2.default.createElement(
	                        _antd.Select,
	                        { value: this.state.resCode, allowClear: true, style: { width: 200, marginLeft: "10px", marginBottom: "10px" }, placeholder: '\u54CD\u5E94\u7ED3\u679C', onChange: this.resCodeChange.bind(this) },
	                        _react2.default.createElement(
	                            Option,
	                            { value: '01' },
	                            '\u6210\u529F'
	                        ),
	                        _react2.default.createElement(
	                            Option,
	                            { value: '02' },
	                            '\u5931\u8D25'
	                        )
	                    ),
	                    _react2.default.createElement(_antd.DatePicker, {
	                        value: this.state.startTimeValue,
	                        style: { width: 200, marginLeft: "10px", marginBottom: "10px" },
	                        showTime: true,
	                        format: 'YYYY-MM-DD HH:mm:ss',
	                        placeholder: '\u5F00\u59CB\u65F6\u95F4',
	                        onChange: this.startTimeChange.bind(this)
	                    }),
	                    _react2.default.createElement(_antd.DatePicker, {
	                        value: this.state.endTimeValue,
	                        style: { width: 200, marginLeft: "10px", marginBottom: "10px" },
	                        showTime: true,
	                        format: 'YYYY-MM-DD HH:mm:ss',
	                        placeholder: '\u7ED3\u675F\u65F6\u95F4',
	                        onChange: this.endTimeChange.bind(this)
	                    }),
	                    _react2.default.createElement(
	                        _antd.Button,
	                        { type: "primary", icon: "search", style: { width: 80, marginLeft: "10px", marginBottom: "10px" }, onClick: this.searchClick.bind(this) },
	                        '\u67E5\u8BE2'
	                    ),
	                    _react2.default.createElement(
	                        _antd.Button,
	                        { type: "primary", icon: "redo", style: { width: 80, marginLeft: "10px", marginBottom: "10px" }, onClick: this.redoClick.bind(this) },
	                        '\u91CD\u7F6E'
	                    )
	                ),
	                _react2.default.createElement(_antd.Table, { pagination: this.state.pagination, columns: columns, onChange: this.handleTableChange.bind(this), dataSource: this.state.listData })
	            );
	        }
	    }]);
	
	    return OperationLogMonitor;
	}(_react2.default.Component);
	
	exports.default = OperationLogMonitor;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OperationLogStatistics = function (_React$Component) {
	    _inherits(OperationLogStatistics, _React$Component);
	
	    function OperationLogStatistics() {
	        _classCallCheck(this, OperationLogStatistics);
	
	        var _this = _possibleConstructorReturn(this, (OperationLogStatistics.__proto__ || Object.getPrototypeOf(OperationLogStatistics)).call(this));
	
	        tool.setLoginInfoExtra({
	            "pageSize": 10,
	            "offset": 1
	        });
	        _this.SrvMonitorSrvStatQuery(); //调用查询操作日志统计数据服务
	
	        _this.state = {
	            listData: [], //表数据
	            srvSrlno: "", //查询条件-服务标示
	            pagination: {
	                total: 0,
	                pageSize: 0
	            }
	        };
	        return _this;
	    }
	    //查询操作日志统计数据服务
	
	
	    _createClass(OperationLogStatistics, [{
	        key: 'SrvMonitorSrvStatQuery',
	        value: function SrvMonitorSrvStatQuery(body) {
	            var req = body || {};
	            var success = function success(res) {
	                if (res && res.head.code == "0000") {
	                    tool.sgiLogger.info(res);
	
	                    this.setState({
	                        listData: res.body,
	                        pagination: {
	                            total: res.head.pageCount,
	                            pageSize: res.head.recordCount
	                        }
	                    });
	                } else {
	                    _antd.message.error(res.head.msg);
	                }
	            };
	            commonClient.simplecall(sgiConfig.allUrl.SrvMonitorSrvStatQuery, req, success.bind(this), true);
	        }
	        //查询条件-开始时间
	
	    }, {
	        key: 'startTimeChange',
	        value: function startTimeChange(value, dateString) {
	            tool.sgiLogger.info('Selected Time: ', value);
	            tool.sgiLogger.info('Formatted Selected Time: ', dateString);
	            this.setState({
	                startTime: dateString
	            });
	        }
	        //查询条件-结束时间
	
	    }, {
	        key: 'endTimeChange',
	        value: function endTimeChange(value, dateString) {
	            tool.sgiLogger.info('Selected Time: ', value);
	            tool.sgiLogger.info('Formatted Selected Time: ', dateString);
	            this.setState({
	                endTime: dateString
	            });
	        }
	        //点击条件查询按钮
	
	    }, {
	        key: 'searchClick',
	        value: function searchClick() {
	            if (this.state.startTime && this.state.endTime && this.state.startTime > this.state.endTime) {
	                _antd.message.error("结束时间不能早于开始时间！");
	                return;
	            }
	
	            var req = {
	                startTime: this.state.startTime,
	                endTime: this.state.endTime
	            };
	            tool.sgiLogger.info(req);
	            this.SrvMonitorSrvStatQuery(req);
	        }
	
	        //表格换页
	
	    }, {
	        key: 'handleTableChange',
	        value: function handleTableChange(pagination, filters, sorter) {
	            tool.sgiLogger.info(pagination, filters, sorter);
	            tool.setLoginInfoExtra({
	                "pageSize": 10,
	                "offset": pagination.current
	            });
	            var req = {
	                startTime: this.state.startTime,
	                endTime: this.state.endTime
	            };
	            tool.sgiLogger.info(req);
	            this.SrvMonitorSrvStatQuery(req);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var columns = [{
	                title: "服务标示",
	                dataIndex: "srvSrlno"
	            }, {
	                title: "平均耗时",
	                dataIndex: "avgTimcnsm"
	            }, {
	                title: "最大耗时",
	                dataIndex: "maxTimcnsm"
	            }, {
	                title: "最小耗时",
	                dataIndex: "minTimcnsm"
	            }, {
	                title: "操作总数",
	                dataIndex: "sum"
	            }, {
	                title: "成功数",
	                dataIndex: "sucNum"
	            }, {
	                title: "失败数",
	                dataIndex: "errNum"
	            }];
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { margin: '20px' } },
	                    _react2.default.createElement(_antd.DatePicker, {
	                        style: { width: 200, marginLeft: "10px", marginBottom: "10px" },
	                        showTime: true,
	                        format: 'YYYY-MM-DD HH:mm:ss',
	                        placeholder: '\u5F00\u59CB\u65F6\u95F4',
	                        onChange: this.startTimeChange.bind(this)
	                    }),
	                    _react2.default.createElement(_antd.DatePicker, {
	                        style: { width: 200, marginLeft: "10px", marginBottom: "10px" },
	                        showTime: true,
	                        format: 'YYYY-MM-DD HH:mm:ss',
	                        placeholder: '\u7ED3\u675F\u65F6\u95F4',
	                        onChange: this.endTimeChange.bind(this)
	                    }),
	                    _react2.default.createElement(
	                        _antd.Button,
	                        { type: "primary", icon: "search", style: { width: 80, marginLeft: "10px", marginBottom: "10px" }, onClick: this.searchClick.bind(this) },
	                        '\u67E5\u8BE2'
	                    )
	                ),
	                _react2.default.createElement(_antd.Table, { pagination: this.state.pagination, columns: columns, onChange: this.handleTableChange.bind(this), dataSource: this.state.listData })
	            );
	        }
	    }]);
	
	    return OperationLogStatistics;
	}(_react2.default.Component);
	
	exports.default = OperationLogStatistics;

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var apJSLoadFlag = {};
	
	function apJSLoading() {
	    // var ap = tool.Global.currentAP;
	
	    // initJSFun('rtsd'); //对于开发平台来说，每次都要初始化rtsd
	    // initJSFun('wos'); //初始化wos
	    // initJSFun('opportunity'); //初始化商机
	    // initJSFun('batch'); //初始化批处理
	    // initJSFun('program'); //初始化方案
	    // initJSFun('statistics'); //初始化统计
	    // initJSFun('param'); //初始化参数
	    // initJSFun('rtuam'); //初始化rtuam
	
	    // initJSFun2tool("wmp"); //初始化wmp全局方法，放入tool.fun[ap]中
	
	    var others = sgiConfig.jsFunAps || [];
	    others.forEach(function (ap) {
	        initJSFun(ap);
	    });
	}
	
	function initJSFun(ap) {
	
	    if (apJSLoadFlag[ap]) {
	        return;
	    } else {
	        apJSLoadFlag[ap] = true;
	    }
	
	    var tt = "GJS";
	    var prms = PrmFactory.getPrmByTT(ap, tt);
	    if (!prms || prms.length === 0) {
	        prms = []; //空列表，不再放入初始化对象
	    }
	
	    var initPrms = [];
	
	    window[ap] = window[ap] || {};
	    prms.forEach(function (element) {
	
	        var funanme = element.c;
	        var fun = element.jsfun;
	        var params = element.params;
	        var isInitRun = element.isInitRun;
	        var paramsArray = [];
	        if (params) {
	            paramsArray = params.split(',');
	        }
	        if (funanme) {
	            window[ap][funanme] = new (Function.prototype.bind.apply(Function, [null].concat(_toConsumableArray(paramsArray), [fun])))();
	            //是否初始化 执行
	            if (isInitRun == '1') {
	                try {
	                    initPrms.push(window[ap][funanme]);
	                } catch (error) {
	                    tool.sgiLogger.info(error);
	                }
	            }
	        }
	    });
	
	    //加载后 执行初始化 执行函数
	    initPrms.forEach(function (element) {
	        element();
	    });
	}
	
	function initJSFun2tool(ap) {
	
	    if (apJSLoadFlag[ap]) {
	        return;
	    } else {
	        apJSLoadFlag[ap] = true;
	    }
	
	    var tt = "GJS";
	    var prms = PrmFactory.getPrmByTT(ap, tt);
	    if (!prms || prms.length === 0) {
	        prms = []; //空列表，不再放入初始化对象
	    }
	
	    if (!tool) {
	        tool.sgiLogger.error('tool\u5DE5\u5177\u5C1A\u672A\u521D\u59CB\u5316\uFF01\u5168\u5C40\u65B9\u6CD5\u65E0\u6CD5\u52A0\u8F7D\uFF01ap=' + ap);
	        apJSLoadFlag[ap] = false;
	        return;
	    }
	
	    // window[ap] = window[ap] || {};
	    tool.fun = tool.fun || {};
	    tool.fun[ap] = tool.fun[ap] || {};
	    prms.forEach(function (element) {
	
	        var funanme = element.c;
	        var fun = element.jsfun;
	        var params = element.params;
	        var paramsArray = [];
	        if (params) {
	            paramsArray = params.split(',');
	        }
	        if (funanme) {
	            tool.fun[ap][funanme] = new (Function.prototype.bind.apply(Function, [null].concat(_toConsumableArray(paramsArray), [fun])))();
	        }
	    });
	}
	
	exports.apJSLoading = apJSLoading;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UIEditor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rtSdCommon = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import DndDevMain from 'rt-sd-dnd/sgiDndDev/DndDevMain';
	
	var UIEditor = function (_React$Component) {
	    _inherits(UIEditor, _React$Component);
	
	    // shouldComponentUpdate() {
	    //     // POP 浏览器前进后退， PUSH 点击Link
	    //     tool.sgiLogger.info("this.props.location.action:" + this.props.location.action);
	    //     return this.props.location.action === "PUSH"
	    // }
	    function UIEditor(props) {
	        _classCallCheck(this, UIEditor);
	
	        //获取浏览器地址
	        // var params = this.GetRequest();
	        // var params = this.props.location.state;
	        var _this = _possibleConstructorReturn(this, (UIEditor.__proto__ || Object.getPrototypeOf(UIEditor)).call(this, props));
	
	        _this.render = function () {
	
	            var query = this.props.location.query;
	            var transferData;
	            if (query) {
	                var uuid = query.uuid;
	                transferData = JSON.parse(unescape(tool.sgiStorage.get(sgiConfig.keyPre_uuid + uuid)));
	            }
	            if (!transferData) transferData = {};
	
	            var uid = transferData.uid;
	            if (!uid) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    'uid\u4E3A\u7A7A'
	                );
	            }
	            // let ucvData = PrmFactory.getPrm(uid);
	            // if (!ucvData) return null;
	            var objFct = new _rtSdCommon.ObjFactory(uid);
	            objFct.set('@currentObjFctUID', uid);
	
	            return (
	                // <DndDevMain guid={uid} {...transferData} objFct={objFct} />
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    '\u4F60\u5728\u5C1D\u8BD5\u8C03\u7528dnd\u9875\u9762'
	                )
	            );
	        };
	
	        _this.state = {
	            // uid: params.uid
	        };
	        // tool.sgiLogger.info(this.state.uid);
	        return _this;
	    }
	
	    // GetRequest = function () {
	    //     var url = location.search; //获取url中"?"符后的字串   
	    //     var theRequest = new Object();
	    //     if (url.indexOf("?") != -1) {
	    //         var str = url.substr(1);
	    //         var strs = str.split("&");
	    //         for (var i = 0; i < strs.length; i++) {
	    //             theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
	    //         }
	    //     }
	    //     return theRequest;
	    // }
	
	    return UIEditor;
	}(_react2.default.Component);
	
	exports.UIEditor = UIEditor;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UIPreview = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _rtSdComp = __webpack_require__(199);
	
	var _appInit = __webpack_require__(996);
	
	var _bussInit = __webpack_require__(524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var startWith = function startWith(str, start) {
	    var reg = new RegExp("^" + start);
	    return reg.test(str);
	};
	
	var UIPreview = function (_React$Component) {
	    _inherits(UIPreview, _React$Component);
	
	    function UIPreview(props) {
	        _classCallCheck(this, UIPreview);
	
	        var _this = _possibleConstructorReturn(this, (UIPreview.__proto__ || Object.getPrototypeOf(UIPreview)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        var params = _this.props.location.query;
	
	        _this.state = {
	            uuid: ""
	        };
	
	        (0, _appInit.apJSLoading)(); //第二次刷新的时候用
	        (0, _bussInit.bussLoading)();
	        return _this;
	    }
	
	    _createClass(UIPreview, [{
	        key: 'getUI',
	        value: function getUI(uid, transferData) {
	            if (!uid) {
	                return null;
	            } else if (startWith(uid, "/") || startWith(uid, "http://") || startWith(uid, "https://")) {
	                // url或http地址
	                return _react2.default.createElement('iframe', { src: uid, height: '100%', width: '100%', style: { verticalAlign: "top" }, frameBorder: '' });
	            } else {
	                // guid参数
	                var ucvData = _rtSdCommon.PrmFactory.getPrm(uid);
	                if (!ucvData) return null;
	                var objFct = new _rtSdCommon.ObjFactory(uid, transferData);
	                return _react2.default.createElement(
	                    'div',
	                    { style: { width: '100%', height: '100%', overflow: 'auto' } },
	                    _react2.default.createElement(_rtSdComp.SgiMainComp, { key: tool.uuid(8), objFct: objFct, moduleDesc: ucvData })
	                );
	            }
	        }
	    }, {
	        key: 'saveEcho',
	        value: function saveEcho() {
	            var objFct = this.state.objFct;
	            if (objFct && objFct.get("#echo")) {
	                var saveKeyList = objFct.get("#echo");
	                if (typeof saveKeyList === "string") saveKeyList = saveKeyList.split(",");
	                var transferData = {};
	                saveKeyList.forEach(function (key) {
	                    transferData[key] = objFct.get(key);
	                });
	                var value = escape(JSON.stringify(transferData));
	                tool.sgiStorage.set(sgiConfig.keyPre_uuid + this.state.uuid, value);
	            }
	        }
	
	        //防止 走2遍
	        // shouldComponentUpdate() {
	        // var params = this.props.location.query;
	        // // POP 浏览器前进后退， PUSH 点击Link
	        // tool.sgiLogger.info("this.props.location.action:" + this.props.location.action);
	        // return this.props.location.action === "PUSH" || this.state.uuid == params.uuid;
	        // return  this.state.uuid != params.uuid
	        // }
	
	    }]);
	
	    return UIPreview;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	    this.GetRequest = function () {
	        var url = location.search; //获取url中"?"符后的字串   
	        var theRequest = new Object();
	        if (url.indexOf("?") != -1) {
	            var str = url.substr(1);
	            var strs = str.split("&");
	            for (var i = 0; i < strs.length; i++) {
	                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
	            }
	        }
	        return theRequest;
	    };
	
	    this.render = function () {
	
	        var params = this.props.location.query;
	
	        var transferData;
	        var uid;
	        if (params) {
	            var uuid = params.uuid;
	            // if (uuid !== this.state.uuid) this.saveEcho();//uuid变更，存储回显数据
	            this.state.uuid = uuid;
	            transferData = JSON.parse(unescape(tool.sgiStorage.get(sgiConfig.keyPre_uuid + uuid)));
	            if (!transferData) {
	                // tool.popMessage("页面已过期！", "warning");
	                tool.popSingleUI("/");
	            } else {
	                uid = transferData.uid;
	            }
	        }
	
	        return this.getUI(uid, transferData);
	    };
	};
	
	exports.UIPreview = UIPreview;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UIPreviewComp = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rtSdCommon = __webpack_require__(61);
	
	var _rtSdComp = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UIPreviewComp = function (_React$Component) {
	    _inherits(UIPreviewComp, _React$Component);
	
	    function UIPreviewComp(props) {
	        _classCallCheck(this, UIPreviewComp);
	
	        var _this = _possibleConstructorReturn(this, (UIPreviewComp.__proto__ || Object.getPrototypeOf(UIPreviewComp)).call(this, props));
	
	        _this.render = function () {
	
	            var transferData = this.props.transferData;;
	            var uid = this.props.guid;
	
	            var ucvData = _rtSdCommon.PrmFactory.getPrm(uid);
	            if (!ucvData) return null;
	            var objFct = new _rtSdCommon.ObjFactory(uid);
	
	            objFct.set('@currentObjFctUID', uid);
	
	            for (var key in transferData) {
	                objFct.set(key, transferData[key]);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { style: { width: '100%', height: '100%', overflow: 'hidden' } },
	                _react2.default.createElement(_rtSdComp.SgiMainComp, { key: tool.uuid(8), objFct: objFct, moduleDesc: ucvData })
	            );
	        };
	
	        _this.state = {
	            uid: _this.props.guid
	        };
	        return _this;
	    }
	
	    _createClass(UIPreviewComp, [{
	        key: 'shouldComponentUpdate',
	
	
	        //防止 走2遍
	        value: function shouldComponentUpdate() {
	            // var params = this.props.location.query;
	            // // POP 浏览器前进后退， PUSH 点击Link
	            // tool.sgiLogger.info("this.props.location.action:" + this.props.location.action);
	            // return this.props.location.action === "PUSH" || this.state.uuid == params.uuid;
	            return this.state.uid != this.props.guid;
	        }
	    }]);
	
	    return UIPreviewComp;
	}(_react2.default.Component);
	
	exports.UIPreviewComp = UIPreviewComp;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _cryptoJs = __webpack_require__(1001);
	
	var aseConfig = window.aseConfig + '';
	
	function aesDecryptParams(encryptedWord) {
	  var keyUTF8 = _cryptoJs.enc.Utf8.parse('15441489487797985281544144278404');
	  var offsetUTF8 = _cryptoJs.enc.Utf8.parse('dsfdsgffyyy');
	  var bytes = _cryptoJs.AES.decrypt(encryptedWord, keyUTF8, {
	    iv: offsetUTF8,
	    mode: _cryptoJs.mode.CBC,
	    padding: _cryptoJs.pad.Pkcs7
	  });
	
	  return bytes.toString(_cryptoJs.enc.Utf8);
	}
	var sgiSrvUrl = JSON.parse(aesDecryptParams(aseConfig));
	// 解密挂载
	window.sgiSrvUrl = sgiSrvUrl;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(19), __webpack_require__(121), __webpack_require__(530), __webpack_require__(528), __webpack_require__(76), __webpack_require__(527), __webpack_require__(77), __webpack_require__(229), __webpack_require__(150), __webpack_require__(546), __webpack_require__(230), __webpack_require__(548), __webpack_require__(547), __webpack_require__(545), __webpack_require__(149), __webpack_require__(541), __webpack_require__(70), __webpack_require__(34), __webpack_require__(531), __webpack_require__(533), __webpack_require__(532), __webpack_require__(535), __webpack_require__(534), __webpack_require__(536), __webpack_require__(537), __webpack_require__(538), __webpack_require__(540), __webpack_require__(539), __webpack_require__(529), __webpack_require__(525), __webpack_require__(549), __webpack_require__(544), __webpack_require__(543), __webpack_require__(542), __webpack_require__(526));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(121), __webpack_require__(530), __webpack_require__(528), __webpack_require__(76), __webpack_require__(527), __webpack_require__(77), __webpack_require__(229), __webpack_require__(150), __webpack_require__(546), __webpack_require__(230), __webpack_require__(548), __webpack_require__(547), __webpack_require__(545), __webpack_require__(149), __webpack_require__(541), __webpack_require__(70), __webpack_require__(34), __webpack_require__(531), __webpack_require__(533), __webpack_require__(532), __webpack_require__(535), __webpack_require__(534), __webpack_require__(536), __webpack_require__(537), __webpack_require__(538), __webpack_require__(540), __webpack_require__(539), __webpack_require__(529), __webpack_require__(525), __webpack_require__(549), __webpack_require__(544), __webpack_require__(543), __webpack_require__(542), __webpack_require__(526)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		return CryptoJS;
	});

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.easeInOutCubic = easeInOutCubic;
	
	// eslint-disable-next-line import/prefer-default-export
	function easeInOutCubic(t, b, c, d) {
	  var cc = c - b;
	  t /= d / 2;
	
	  if (t < 1) {
	    return cc / 2 * t * t * t + b;
	  }
	
	  return cc / 2 * ((t -= 2) * t * t + 2) + b;
	}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var isNumeric = function isNumeric(value) {
	  return !isNaN(parseFloat(value)) && isFinite(value);
	};
	
	var _default = isNumeric;
	exports["default"] = _default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _cssAnimation = _interopRequireDefault(__webpack_require__(489));
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	/**
	 * Deprecated. We should replace the animation with pure react motion instead of modify style directly.
	 * If you are creating new component with animation, please use `./motion`.
	 */
	function animate(node, show, done) {
	  var height;
	  var requestAnimationFrameId;
	  return (0, _cssAnimation["default"])(node, 'ant-motion-collapse-legacy', {
	    start: function start() {
	      if (!show) {
	        node.style.height = "".concat(node.offsetHeight, "px");
	        node.style.opacity = '1';
	      } else {
	        height = node.offsetHeight;
	        node.style.height = '0px';
	        node.style.opacity = '0';
	      }
	    },
	    active: function active() {
	      if (requestAnimationFrameId) {
	        _raf["default"].cancel(requestAnimationFrameId);
	      }
	
	      requestAnimationFrameId = (0, _raf["default"])(function () {
	        node.style.height = "".concat(show ? height : 0, "px");
	        node.style.opacity = show ? '1' : '0';
	      });
	    },
	    end: function end() {
	      if (requestAnimationFrameId) {
	        _raf["default"].cancel(requestAnimationFrameId);
	      }
	
	      node.style.height = '';
	      node.style.opacity = '';
	      done();
	    }
	  });
	}
	
	var animation = {
	  enter: function enter(node, done) {
	    return animate(node, true, done);
	  },
	  leave: function leave(node, done) {
	    return animate(node, false, done);
	  },
	  appear: function appear(node, done) {
	    return animate(node, true, done);
	  }
	};
	var _default = animation;
	exports["default"] = _default;

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fillRef = fillRef;
	exports.composeRef = composeRef;
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function fillRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
	    ref.current = node;
	  }
	}
	
	function composeRef() {
	  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
	    refs[_key] = arguments[_key];
	  }
	
	  return function (node) {
	    refs.forEach(function (ref) {
	      fillRef(ref, node);
	    });
	  };
	}

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = throttleByAnimationFrame;
	exports.throttleByAnimationFrameDecorator = throttleByAnimationFrameDecorator;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function throttleByAnimationFrame(fn) {
	  var requestId;
	
	  var later = function later(args) {
	    return function () {
	      requestId = null;
	      fn.apply(void 0, _toConsumableArray(args));
	    };
	  };
	
	  var throttled = function throttled() {
	    if (requestId == null) {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      requestId = (0, _raf["default"])(later(args));
	    }
	  };
	
	  throttled.cancel = function () {
	    return _raf["default"].cancel(requestId);
	  };
	
	  return throttled;
	}
	
	function throttleByAnimationFrameDecorator() {
	  // eslint-disable-next-line func-names
	  return function (target, key, descriptor) {
	    var fn = descriptor.value;
	    var definingProperty = false;
	    return {
	      configurable: true,
	      get: function get() {
	        // eslint-disable-next-line no-prototype-builtins
	        if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	          return fn;
	        }
	
	        var boundFn = throttleByAnimationFrame(fn.bind(this));
	        definingProperty = true;
	        Object.defineProperty(this, key, {
	          value: boundFn,
	          configurable: true,
	          writable: true
	        });
	        definingProperty = false;
	        return boundFn;
	      }
	    };
	  };
	}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = triggerEvent;
	
	function triggerEvent(el, type) {
	  if ('createEvent' in document) {
	    // modern browsers, IE9+
	    var e = document.createEvent('HTMLEvents');
	    e.initEvent(type, false, true);
	    el.dispatchEvent(e);
	  }
	}

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTargetRect = getTargetRect;
	exports.getFixedTop = getFixedTop;
	exports.getFixedBottom = getFixedBottom;
	exports.getObserverEntities = getObserverEntities;
	exports.addObserveTarget = addObserveTarget;
	exports.removeObserveTarget = removeObserveTarget;
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function getTargetRect(target) {
	  return target !== window ? target.getBoundingClientRect() : {
	    top: 0,
	    bottom: window.innerHeight
	  };
	}
	
	function getFixedTop(placeholderReact, targetRect, offsetTop) {
	  if (offsetTop !== undefined && targetRect.top > placeholderReact.top - offsetTop) {
	    return offsetTop + targetRect.top;
	  }
	
	  return undefined;
	}
	
	function getFixedBottom(placeholderReact, targetRect, offsetBottom) {
	  if (offsetBottom !== undefined && targetRect.bottom < placeholderReact.bottom + offsetBottom) {
	    var targetBottomOffset = window.innerHeight - targetRect.bottom;
	    return offsetBottom + targetBottomOffset;
	  }
	
	  return undefined;
	} // ======================== Observer ========================
	
	
	var TRIGGER_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
	var observerEntities = [];
	
	function getObserverEntities() {
	  // Only used in test env. Can be removed if refactor.
	  return observerEntities;
	}
	
	function addObserveTarget(target, affix) {
	  if (!target) return;
	  var entity = observerEntities.find(function (item) {
	    return item.target === target;
	  });
	
	  if (entity) {
	    entity.affixList.push(affix);
	  } else {
	    entity = {
	      target: target,
	      affixList: [affix],
	      eventHandlers: {}
	    };
	    observerEntities.push(entity); // Add listener
	
	    TRIGGER_EVENTS.forEach(function (eventName) {
	      entity.eventHandlers[eventName] = (0, _addEventListener["default"])(target, eventName, function () {
	        entity.affixList.forEach(function (targetAffix) {
	          targetAffix.lazyUpdatePosition();
	        });
	      });
	    });
	  }
	}
	
	function removeObserveTarget(affix) {
	  var observerEntity = observerEntities.find(function (oriObserverEntity) {
	    var hasAffix = oriObserverEntity.affixList.some(function (item) {
	      return item === affix;
	    });
	
	    if (hasAffix) {
	      oriObserverEntity.affixList = oriObserverEntity.affixList.filter(function (item) {
	        return item !== affix;
	      });
	    }
	
	    return hasAffix;
	  });
	
	  if (observerEntity && observerEntity.affixList.length === 0) {
	    observerEntities = observerEntities.filter(function (item) {
	      return item !== observerEntity;
	    }); // Remove listener
	
	    TRIGGER_EVENTS.forEach(function (eventName) {
	      var handler = observerEntity.eventHandlers[eventName];
	
	      if (handler && handler.remove) {
	        handler.remove();
	      }
	    });
	  }
	}

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(551));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function noop() {}
	
	var Alert = /*#__PURE__*/function (_React$Component) {
	  _inherits(Alert, _React$Component);
	
	  var _super = _createSuper(Alert);
	
	  function Alert(props) {
	    var _this;
	
	    _classCallCheck(this, Alert);
	
	    _this = _super.call(this, props);
	
	    _this.handleClose = function (e) {
	      e.preventDefault();
	      var dom = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      dom.style.height = "".concat(dom.offsetHeight, "px"); // Magic code
	      // 重复一次后才能正确设置 height
	
	      dom.style.height = "".concat(dom.offsetHeight, "px");
	
	      _this.setState({
	        closing: true
	      });
	
	      (_this.props.onClose || noop)(e);
	    };
	
	    _this.animationEnd = function () {
	      _this.setState({
	        closing: false,
	        closed: true
	      });
	
	      (_this.props.afterClose || noop)();
	    };
	
	    _this.renderAlert = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          description = _this$props.description,
	          customizePrefixCls = _this$props.prefixCls,
	          message = _this$props.message,
	          closeText = _this$props.closeText,
	          banner = _this$props.banner,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          style = _this$props.style,
	          icon = _this$props.icon;
	      var _this$props2 = _this.props,
	          closable = _this$props2.closable,
	          type = _this$props2.type,
	          showIcon = _this$props2.showIcon,
	          iconType = _this$props2.iconType;
	      var _this$state = _this.state,
	          closing = _this$state.closing,
	          closed = _this$state.closed;
	      var prefixCls = getPrefixCls('alert', customizePrefixCls); // banner模式默认有 Icon
	
	      showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告
	
	      type = banner && type === undefined ? 'warning' : type || 'info';
	      var iconTheme = 'filled';
	
	      if (!iconType) {
	        switch (type) {
	          case 'success':
	            iconType = 'check-circle';
	            break;
	
	          case 'info':
	            iconType = 'info-circle';
	            break;
	
	          case 'error':
	            iconType = 'close-circle';
	            break;
	
	          case 'warning':
	            iconType = 'exclamation-circle';
	            break;
	
	          default:
	            iconType = 'default';
	        } // use outline icon in alert with description
	
	
	        if (description) {
	          iconTheme = 'outlined';
	        }
	      } // closeable when closeText is assigned
	
	
	      if (closeText) {
	        closable = true;
	      }
	
	      var alertCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-closing"), closing), _defineProperty(_classNames, "".concat(prefixCls, "-with-description"), !!description), _defineProperty(_classNames, "".concat(prefixCls, "-no-icon"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-banner"), !!banner), _defineProperty(_classNames, "".concat(prefixCls, "-closable"), closable), _classNames), className);
	      var closeIcon = closable ? /*#__PURE__*/React.createElement("button", {
	        type: "button",
	        onClick: _this.handleClose,
	        className: "".concat(prefixCls, "-close-icon"),
	        tabIndex: 0
	      }, closeText ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-text")
	      }, closeText) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close"
	      })) : null;
	      var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(_this.props);
	      var iconNode = icon && ( /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), _defineProperty({}, icon.props.className, icon.props.className))
	      }) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-icon")
	      }, icon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: iconType,
	        theme: iconTheme
	      });
	      return closed ? null : /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        component: "",
	        showProp: "data-show",
	        transitionName: "".concat(prefixCls, "-slide-up"),
	        onEnd: _this.animationEnd
	      }, /*#__PURE__*/React.createElement("div", _extends({
	        "data-show": !closing,
	        className: alertCls,
	        style: style
	      }, dataOrAriaProps), showIcon ? iconNode : null, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-message")
	      }, message), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-description")
	      }, description), closeIcon));
	    };
	
	    (0, _warning["default"])(!('iconType' in props), 'Alert', '`iconType` is deprecated. Please use `icon` instead.');
	    _this.state = {
	      closing: false,
	      closed: false
	    };
	    return _this;
	  }
	
	  _createClass(Alert, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAlert)
	      );
	    }
	  }]);
	
	  return Alert;
	}(React.Component);
	
	exports["default"] = Alert;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _affix = _interopRequireDefault(__webpack_require__(556));
	
	var _configProvider = __webpack_require__(13);
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(290));
	
	var _getScroll = _interopRequireDefault(__webpack_require__(289));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getDefaultContainer() {
	  return window;
	}
	
	function getOffsetTop(element, container) {
	  if (!element) {
	    return 0;
	  }
	
	  if (!element.getClientRects().length) {
	    return 0;
	  }
	
	  var rect = element.getBoundingClientRect();
	
	  if (rect.width || rect.height) {
	    if (container === window) {
	      container = element.ownerDocument.documentElement;
	      return rect.top - container.clientTop;
	    }
	
	    return rect.top - container.getBoundingClientRect().top;
	  }
	
	  return rect.top;
	}
	
	var sharpMatcherRegx = /#([^#]+)$/;
	
	var Anchor = /*#__PURE__*/function (_React$Component) {
	  _inherits(Anchor, _React$Component);
	
	  var _super = _createSuper(Anchor);
	
	  function Anchor() {
	    var _this;
	
	    _classCallCheck(this, Anchor);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      activeLink: null
	    };
	    _this.links = [];
	
	    _this.handleScrollTo = function (link) {
	      var _this$props = _this.props,
	          offsetTop = _this$props.offsetTop,
	          getContainer = _this$props.getContainer,
	          targetOffset = _this$props.targetOffset;
	
	      _this.setCurrentActiveLink(link);
	
	      var container = getContainer();
	      var scrollTop = (0, _getScroll["default"])(container, true);
	      var sharpLinkMatch = sharpMatcherRegx.exec(link);
	
	      if (!sharpLinkMatch) {
	        return;
	      }
	
	      var targetElement = document.getElementById(sharpLinkMatch[1]);
	
	      if (!targetElement) {
	        return;
	      }
	
	      var eleOffsetTop = getOffsetTop(targetElement, container);
	      var y = scrollTop + eleOffsetTop;
	      y -= targetOffset !== undefined ? targetOffset : offsetTop || 0;
	      _this.animating = true;
	      (0, _scrollTo["default"])(y, {
	        callback: function callback() {
	          _this.animating = false;
	        },
	        getContainer: getContainer
	      });
	    };
	
	    _this.saveInkNode = function (node) {
	      _this.inkNode = node;
	    };
	
	    _this.setCurrentActiveLink = function (link) {
	      var activeLink = _this.state.activeLink;
	      var onChange = _this.props.onChange;
	
	      if (activeLink !== link) {
	        _this.setState({
	          activeLink: link
	        });
	
	        if (onChange) {
	          onChange(link);
	        }
	      }
	    };
	
	    _this.handleScroll = function () {
	      if (_this.animating) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          offsetTop = _this$props2.offsetTop,
	          bounds = _this$props2.bounds,
	          targetOffset = _this$props2.targetOffset;
	
	      var currentActiveLink = _this.getCurrentAnchor(targetOffset !== undefined ? targetOffset : offsetTop || 0, bounds);
	
	      _this.setCurrentActiveLink(currentActiveLink);
	    };
	
	    _this.updateInk = function () {
	      if (typeof document === 'undefined') {
	        return;
	      }
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      var anchorNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var linkNode = anchorNode.getElementsByClassName("".concat(prefixCls, "-link-title-active"))[0];
	
	      if (linkNode) {
	        _this.inkNode.style.top = "".concat(linkNode.offsetTop + linkNode.clientHeight / 2 - 4.5, "px");
	      }
	    };
	
	    _this.renderAnchor = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props3 = _this.props,
	          customizePrefixCls = _this$props3.prefixCls,
	          _this$props3$classNam = _this$props3.className,
	          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
	          style = _this$props3.style,
	          offsetTop = _this$props3.offsetTop,
	          affix = _this$props3.affix,
	          showInkInFixed = _this$props3.showInkInFixed,
	          children = _this$props3.children,
	          getContainer = _this$props3.getContainer;
	      var activeLink = _this.state.activeLink;
	      var prefixCls = getPrefixCls('anchor', customizePrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      var inkClass = (0, _classnames["default"])("".concat(prefixCls, "-ink-ball"), {
	        visible: activeLink
	      });
	      var wrapperClass = (0, _classnames["default"])(className, "".concat(prefixCls, "-wrapper"));
	      var anchorClass = (0, _classnames["default"])(prefixCls, {
	        fixed: !affix && !showInkInFixed
	      });
	
	      var wrapperStyle = _extends({
	        maxHeight: offsetTop ? "calc(100vh - ".concat(offsetTop, "px)") : '100vh'
	      }, style);
	
	      var anchorContent = /*#__PURE__*/React.createElement("div", {
	        className: wrapperClass,
	        style: wrapperStyle
	      }, /*#__PURE__*/React.createElement("div", {
	        className: anchorClass
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-ink")
	      }, /*#__PURE__*/React.createElement("span", {
	        className: inkClass,
	        ref: _this.saveInkNode
	      })), children));
	      return !affix ? anchorContent : /*#__PURE__*/React.createElement(_affix["default"], {
	        offsetTop: offsetTop,
	        target: getContainer
	      }, anchorContent);
	    };
	
	    return _this;
	  }
	
	  _createClass(Anchor, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _this2 = this;
	
	      var antAnchor = {
	        registerLink: function registerLink(link) {
	          if (!_this2.links.includes(link)) {
	            _this2.links.push(link);
	          }
	        },
	        unregisterLink: function unregisterLink(link) {
	          var index = _this2.links.indexOf(link);
	
	          if (index !== -1) {
	            _this2.links.splice(index, 1);
	          }
	        },
	        activeLink: this.state.activeLink,
	        scrollTo: this.handleScrollTo,
	        onClick: this.props.onClick
	      };
	      return {
	        antAnchor: antAnchor
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var getContainer = this.props.getContainer;
	      this.scrollContainer = getContainer();
	      this.scrollEvent = (0, _addEventListener["default"])(this.scrollContainer, 'scroll', this.handleScroll);
	      this.handleScroll();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.scrollEvent) {
	        var getContainer = this.props.getContainer;
	        var currentContainer = getContainer();
	
	        if (this.scrollContainer !== currentContainer) {
	          this.scrollContainer = currentContainer;
	          this.scrollEvent.remove();
	          this.scrollEvent = (0, _addEventListener["default"])(this.scrollContainer, 'scroll', this.handleScroll);
	          this.handleScroll();
	        }
	      }
	
	      this.updateInk();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEvent) {
	        this.scrollEvent.remove();
	      }
	    }
	  }, {
	    key: "getCurrentAnchor",
	    value: function getCurrentAnchor() {
	      var offsetTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var bounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	      var getCurrentAnchor = this.props.getCurrentAnchor;
	
	      if (typeof getCurrentAnchor === 'function') {
	        return getCurrentAnchor();
	      }
	
	      var activeLink = '';
	
	      if (typeof document === 'undefined') {
	        return activeLink;
	      }
	
	      var linkSections = [];
	      var getContainer = this.props.getContainer;
	      var container = getContainer();
	      this.links.forEach(function (link) {
	        var sharpLinkMatch = sharpMatcherRegx.exec(link.toString());
	
	        if (!sharpLinkMatch) {
	          return;
	        }
	
	        var target = document.getElementById(sharpLinkMatch[1]);
	
	        if (target) {
	          var top = getOffsetTop(target, container);
	
	          if (top < offsetTop + bounds) {
	            linkSections.push({
	              link: link,
	              top: top
	            });
	          }
	        }
	      });
	
	      if (linkSections.length) {
	        var maxSection = linkSections.reduce(function (prev, curr) {
	          return curr.top > prev.top ? curr : prev;
	        });
	        return maxSection.link;
	      }
	
	      return '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAnchor)
	      );
	    }
	  }]);
	
	  return Anchor;
	}(React.Component);
	
	exports["default"] = Anchor;
	Anchor.defaultProps = {
	  affix: true,
	  showInkInFixed: false,
	  getContainer: getDefaultContainer
	};
	Anchor.childContextTypes = {
	  antAnchor: PropTypes.object
	};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var AnchorLink = /*#__PURE__*/function (_React$Component) {
	  _inherits(AnchorLink, _React$Component);
	
	  var _super = _createSuper(AnchorLink);
	
	  function AnchorLink() {
	    var _this;
	
	    _classCallCheck(this, AnchorLink);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function (e) {
	      var _this$context$antAnch = _this.context.antAnchor,
	          scrollTo = _this$context$antAnch.scrollTo,
	          onClick = _this$context$antAnch.onClick;
	      var _this$props = _this.props,
	          href = _this$props.href,
	          title = _this$props.title;
	
	      if (onClick) {
	        onClick(e, {
	          title: title,
	          href: href
	        });
	      }
	
	      scrollTo(href);
	    };
	
	    _this.renderAnchorLink = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          href = _this$props2.href,
	          title = _this$props2.title,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          target = _this$props2.target;
	      var prefixCls = getPrefixCls('anchor', customizePrefixCls);
	      var active = _this.context.antAnchor.activeLink === href;
	      var wrapperClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-link"), _defineProperty({}, "".concat(prefixCls, "-link-active"), active));
	      var titleClassName = (0, _classnames["default"])("".concat(prefixCls, "-link-title"), _defineProperty({}, "".concat(prefixCls, "-link-title-active"), active));
	      return (/*#__PURE__*/React.createElement("div", {
	          className: wrapperClassName
	        }, /*#__PURE__*/React.createElement("a", {
	          className: titleClassName,
	          href: href,
	          title: typeof title === 'string' ? title : '',
	          target: target,
	          onClick: _this.handleClick
	        }, title), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(AnchorLink, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.context.antAnchor.registerLink(this.props.href);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref2) {
	      var prevHref = _ref2.href;
	      var href = this.props.href;
	
	      if (prevHref !== href) {
	        this.context.antAnchor.unregisterLink(prevHref);
	        this.context.antAnchor.registerLink(href);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.context.antAnchor.unregisterLink(this.props.href);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAnchorLink)
	      );
	    }
	  }]);
	
	  return AnchorLink;
	}(React.Component);
	
	AnchorLink.defaultProps = {
	  href: '#'
	};
	AnchorLink.contextTypes = {
	  antAnchor: PropTypes.object
	};
	(0, _reactLifecyclesCompat.polyfill)(AnchorLink);
	var _default = AnchorLink;
	exports["default"] = _default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Anchor = _interopRequireDefault(__webpack_require__(1010));
	
	var _AnchorLink = _interopRequireDefault(__webpack_require__(1011));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Anchor["default"].Link = _AnchorLink["default"];
	var _default = _Anchor["default"];
	exports["default"] = _default;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var InputElement = /*#__PURE__*/function (_React$Component) {
	  _inherits(InputElement, _React$Component);
	
	  var _super = _createSuper(InputElement);
	
	  function InputElement() {
	    var _this;
	
	    _classCallCheck(this, InputElement);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveRef = function (ele) {
	      var childRef = _this.props.children.ref;
	
	      if (typeof childRef === 'function') {
	        childRef(ele);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(InputElement, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.cloneElement(this.props.children, _extends(_extends({}, this.props), {
	          ref: this.saveRef
	        }), null)
	      );
	    }
	  }]);
	
	  return InputElement;
	}(React.Component);
	
	exports["default"] = InputElement;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcSelect = __webpack_require__(191);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _InputElement = _interopRequireDefault(__webpack_require__(1013));
	
	var _input = _interopRequireDefault(__webpack_require__(233));
	
	var _select = _interopRequireDefault(__webpack_require__(197));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function isSelectOptionOrSelectOptGroup(child) {
	  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
	}
	
	var AutoComplete = /*#__PURE__*/function (_React$Component) {
	  _inherits(AutoComplete, _React$Component);
	
	  var _super = _createSuper(AutoComplete);
	
	  function AutoComplete() {
	    var _this;
	
	    _classCallCheck(this, AutoComplete);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveSelect = function (node) {
	      _this.select = node;
	    };
	
	    _this.getInputElement = function () {
	      var children = _this.props.children;
	      var element = children && /*#__PURE__*/React.isValidElement(children) && children.type !== _rcSelect.Option ? React.Children.only(_this.props.children) : /*#__PURE__*/React.createElement(_input["default"], null);
	
	      var elementProps = _extends({}, element.props); // https://github.com/ant-design/ant-design/pull/7742
	
	
	      delete elementProps.children;
	      return (/*#__PURE__*/React.createElement(_InputElement["default"], elementProps, element)
	      );
	    };
	
	    _this.renderAutoComplete = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          size = _this$props.size,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          notFoundContent = _this$props.notFoundContent,
	          optionLabelProp = _this$props.optionLabelProp,
	          dataSource = _this$props.dataSource,
	          children = _this$props.children;
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "".concat(prefixCls, "-show-search"), true), _defineProperty(_classNames, "".concat(prefixCls, "-auto-complete"), true), _classNames));
	      var options;
	      var childArray = React.Children.toArray(children);
	
	      if (childArray.length && isSelectOptionOrSelectOptGroup(childArray[0])) {
	        options = children;
	      } else {
	        options = dataSource ? dataSource.map(function (item) {
	          if ( /*#__PURE__*/React.isValidElement(item)) {
	            return item;
	          }
	
	          switch (_typeof(item)) {
	            case 'string':
	              return (/*#__PURE__*/React.createElement(_rcSelect.Option, {
	                  key: item
	                }, item)
	              );
	
	            case 'object':
	              return (/*#__PURE__*/React.createElement(_rcSelect.Option, {
	                  key: item.value
	                }, item.text)
	              );
	
	            default:
	              throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
	          }
	        }) : [];
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], _extends({}, _this.props, {
	          className: cls,
	          mode: _select["default"].SECRET_COMBOBOX_MODE_DO_NOT_USE,
	          optionLabelProp: optionLabelProp,
	          getInputElement: _this.getInputElement,
	          notFoundContent: notFoundContent,
	          ref: _this.saveSelect
	        }), options)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(AutoComplete, [{
	    key: "focus",
	    value: function focus() {
	      this.select.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.select.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAutoComplete)
	      );
	    }
	  }]);
	
	  return AutoComplete;
	}(React.Component);
	
	exports["default"] = AutoComplete;
	AutoComplete.Option = _rcSelect.Option;
	AutoComplete.OptGroup = _rcSelect.OptGroup;
	AutoComplete.defaultProps = {
	  transitionName: 'slide-up',
	  optionLabelProp: 'children',
	  choiceTransitionName: 'zoom',
	  showSearch: false,
	  filterOption: false
	};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(13);
	
	var _getScroll = _interopRequireDefault(__webpack_require__(289));
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(290));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getDefaultTarget() {
	  return window;
	}
	
	var BackTop = /*#__PURE__*/function (_React$Component) {
	  _inherits(BackTop, _React$Component);
	
	  var _super = _createSuper(BackTop);
	
	  function BackTop(props) {
	    var _this;
	
	    _classCallCheck(this, BackTop);
	
	    _this = _super.call(this, props);
	
	    _this.scrollToTop = function (e) {
	      var _this$props = _this.props,
	          _this$props$target = _this$props.target,
	          target = _this$props$target === void 0 ? getDefaultTarget : _this$props$target,
	          onClick = _this$props.onClick;
	      (0, _scrollTo["default"])(0, {
	        getContainer: target
	      });
	
	      if (typeof onClick === 'function') {
	        onClick(e);
	      }
	    };
	
	    _this.handleScroll = function () {
	      var _this$props2 = _this.props,
	          visibilityHeight = _this$props2.visibilityHeight,
	          _this$props2$target = _this$props2.target,
	          target = _this$props2$target === void 0 ? getDefaultTarget : _this$props2$target;
	      var scrollTop = (0, _getScroll["default"])(target(), true);
	
	      _this.setState({
	        visible: scrollTop > visibilityHeight
	      });
	    };
	
	    _this.renderBackTop = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props3 = _this.props,
	          customizePrefixCls = _this$props3.prefixCls,
	          _this$props3$classNam = _this$props3.className,
	          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
	          children = _this$props3.children;
	      var prefixCls = getPrefixCls('back-top', customizePrefixCls);
	      var classString = (0, _classnames["default"])(prefixCls, className);
	      var defaultElement = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-icon")
	      })); // fix https://fb.me/react-unknown-prop
	
	      var divProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'children', 'visibilityHeight', 'target', 'visible']);
	      var visible = 'visible' in _this.props ? _this.props.visible : _this.state.visible;
	      var backTopBtn = visible ? /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        className: classString,
	        onClick: _this.scrollToTop
	      }), children || defaultElement) : null;
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "",
	          transitionName: "fade"
	        }, backTopBtn)
	      );
	    };
	
	    _this.state = {
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(BackTop, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var getTarget = this.props.target || getDefaultTarget;
	      this.scrollEvent = (0, _addEventListener["default"])(getTarget(), 'scroll', this.handleScroll);
	      this.handleScroll();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEvent) {
	        this.scrollEvent.remove();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBackTop)
	      );
	    }
	  }]);
	
	  return BackTop;
	}(React.Component);
	
	exports["default"] = BackTop;
	BackTop.defaultProps = {
	  visibilityHeight: 400
	};

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getNumberArray(num) {
	  return num ? num.toString().split('').reverse().map(function (i) {
	    var current = Number(i);
	    return isNaN(current) ? i : current;
	  }) : [];
	}
	
	function renderNumberList(position, className) {
	  var childrenToReturn = [];
	
	  for (var i = 0; i < 30; i++) {
	    childrenToReturn.push( /*#__PURE__*/React.createElement("p", {
	      key: i.toString(),
	      className: (0, _classnames["default"])(className, {
	        current: position === i
	      })
	    }, i % 10));
	  }
	
	  return childrenToReturn;
	}
	
	var ScrollNumber = /*#__PURE__*/function (_React$Component) {
	  _inherits(ScrollNumber, _React$Component);
	
	  var _super = _createSuper(ScrollNumber);
	
	  function ScrollNumber(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollNumber);
	
	    _this = _super.call(this, props);
	
	    _this.onAnimated = function () {
	      var onAnimated = _this.props.onAnimated;
	
	      if (onAnimated) {
	        onAnimated();
	      }
	    };
	
	    _this.renderScrollNumber = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          style = _this$props.style,
	          title = _this$props.title,
	          _this$props$component = _this$props.component,
	          component = _this$props$component === void 0 ? 'sup' : _this$props$component,
	          displayComponent = _this$props.displayComponent; // fix https://fb.me/react-unknown-prop
	
	      var restProps = (0, _omit["default"])(_this.props, ['count', 'onAnimated', 'component', 'prefixCls', 'displayComponent']);
	      var prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
	
	      var newProps = _extends(_extends({}, restProps), {
	        className: (0, _classnames["default"])(prefixCls, className),
	        title: title
	      }); // allow specify the border
	      // mock border-color by box-shadow for compatible with old usage:
	      // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
	
	
	      if (style && style.borderColor) {
	        newProps.style = _extends(_extends({}, style), {
	          boxShadow: "0 0 0 1px ".concat(style.borderColor, " inset")
	        });
	      }
	
	      if (displayComponent) {
	        return (/*#__PURE__*/React.cloneElement(displayComponent, {
	            className: (0, _classnames["default"])("".concat(prefixCls, "-custom-component"), displayComponent.props && displayComponent.props.className)
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(component, newProps, _this.renderNumberElement(prefixCls))
	      );
	    };
	
	    _this.state = {
	      animateStarted: true,
	      count: props.count
	    };
	    return _this;
	  }
	
	  _createClass(ScrollNumber, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      var _this2 = this;
	
	      this.lastCount = prevState.count;
	      var animateStarted = this.state.animateStarted;
	
	      if (animateStarted) {
	        this.clearTimeout(); // Let browser has time to reset the scroller before actually
	        // performing the transition.
	
	        this.timeout = setTimeout(function () {
	          // eslint-disable-next-line react/no-did-update-set-state
	          _this2.setState(function (__, props) {
	            return {
	              animateStarted: false,
	              count: props.count
	            };
	          }, _this2.onAnimated);
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearTimeout();
	    }
	  }, {
	    key: "getPositionByNum",
	    value: function getPositionByNum(num, i) {
	      var count = this.state.count;
	      var currentCount = Math.abs(Number(count));
	      var lastCount = Math.abs(Number(this.lastCount));
	      var currentDigit = Math.abs(getNumberArray(this.state.count)[i]);
	      var lastDigit = Math.abs(getNumberArray(this.lastCount)[i]);
	
	      if (this.state.animateStarted) {
	        return 10 + num;
	      } // 同方向则在同一侧切换数字
	
	
	      if (currentCount > lastCount) {
	        if (currentDigit >= lastDigit) {
	          return 10 + num;
	        }
	
	        return 20 + num;
	      }
	
	      if (currentDigit <= lastDigit) {
	        return 10 + num;
	      }
	
	      return num;
	    }
	  }, {
	    key: "renderCurrentNumber",
	    value: function renderCurrentNumber(prefixCls, num, i) {
	      if (typeof num === 'number') {
	        var position = this.getPositionByNum(num, i);
	        var removeTransition = this.state.animateStarted || getNumberArray(this.lastCount)[i] === undefined;
	        return (/*#__PURE__*/React.createElement('span', {
	            className: "".concat(prefixCls, "-only"),
	            style: {
	              transition: removeTransition ? 'none' : undefined,
	              msTransform: "translateY(".concat(-position * 100, "%)"),
	              WebkitTransform: "translateY(".concat(-position * 100, "%)"),
	              transform: "translateY(".concat(-position * 100, "%)")
	            },
	            key: i
	          }, renderNumberList(position, "".concat(prefixCls, "-only-unit")))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          key: "symbol",
	          className: "".concat(prefixCls, "-symbol")
	        }, num)
	      );
	    }
	  }, {
	    key: "renderNumberElement",
	    value: function renderNumberElement(prefixCls) {
	      var _this3 = this;
	
	      var count = this.state.count;
	
	      if (count && Number(count) % 1 === 0) {
	        return getNumberArray(count).map(function (num, i) {
	          return _this3.renderCurrentNumber(prefixCls, num, i);
	        }).reverse();
	      }
	
	      return count;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderScrollNumber)
	      );
	    }
	  }, {
	    key: "clearTimeout",
	    value: function (_clearTimeout) {
	      function clearTimeout() {
	        return _clearTimeout.apply(this, arguments);
	      }
	
	      clearTimeout.toString = function () {
	        return _clearTimeout.toString();
	      };
	
	      return clearTimeout;
	    }(function () {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = undefined;
	      }
	    })
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, nextState) {
	      if ('count' in nextProps) {
	        if (nextState.count === nextProps.count) {
	          return null;
	        }
	
	        return {
	          animateStarted: true
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScrollNumber;
	}(React.Component);
	
	ScrollNumber.defaultProps = {
	  count: null,
	  onAnimated: function onAnimated() {}
	};
	(0, _reactLifecyclesCompat.polyfill)(ScrollNumber);
	var _default = ScrollNumber;
	exports["default"] = _default;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _ScrollNumber = _interopRequireDefault(__webpack_require__(1016));
	
	var _colors = __webpack_require__(550);
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function isPresetColor(color) {
	  return _colors.PresetColorTypes.indexOf(color) !== -1;
	}
	
	var Badge = /*#__PURE__*/function (_React$Component) {
	  _inherits(Badge, _React$Component);
	
	  var _super = _createSuper(Badge);
	
	  function Badge() {
	    var _this;
	
	    _classCallCheck(this, Badge);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderBadge = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeScrollNumberPrefixCls = _a.scrollNumberPrefixCls,
	          children = _a.children,
	          status = _a.status,
	          text = _a.text,
	          color = _a.color,
	          restProps = __rest(_a, ["prefixCls", "scrollNumberPrefixCls", "children", "status", "text", "color"]);
	
	      var omitArr = ['count', 'showZero', 'overflowCount', 'className', 'style', 'dot', 'offset', 'title'];
	      var prefixCls = getPrefixCls('badge', customizePrefixCls);
	      var scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);
	
	      var scrollNumber = _this.renderBadgeNumber(prefixCls, scrollNumberPrefixCls);
	
	      var statusText = _this.renderStatusText(prefixCls);
	
	      var statusCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-status-dot"), _this.hasStatus()), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames));
	      var statusStyle = {};
	
	      if (color && !isPresetColor(color)) {
	        statusStyle.background = color;
	      } // <Badge status="success" />
	
	
	      if (!children && _this.hasStatus()) {
	        var styleWithOffset = _this.getStyleWithOffset();
	
	        var statusTextColor = styleWithOffset && styleWithOffset.color;
	        return (/*#__PURE__*/React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
	            className: _this.getBadgeClassName(prefixCls),
	            style: styleWithOffset
	          }), /*#__PURE__*/React.createElement("span", {
	            className: statusCls,
	            style: statusStyle
	          }), /*#__PURE__*/React.createElement("span", {
	            style: {
	              color: statusTextColor
	            },
	            className: "".concat(prefixCls, "-status-text")
	          }, text))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
	          className: _this.getBadgeClassName(prefixCls)
	        }), children, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "",
	          showProp: "data-show",
	          transitionName: children ? "".concat(prefixCls, "-zoom") : '',
	          transitionAppear: true
	        }, scrollNumber), statusText)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Badge, [{
	    key: "getNumberedDispayCount",
	    value: function getNumberedDispayCount() {
	      var _this$props = this.props,
	          count = _this$props.count,
	          overflowCount = _this$props.overflowCount;
	      var displayCount = count > overflowCount ? "".concat(overflowCount, "+") : count;
	      return displayCount;
	    }
	  }, {
	    key: "getDispayCount",
	    value: function getDispayCount() {
	      var isDot = this.isDot(); // dot mode don't need count
	
	      if (isDot) {
	        return '';
	      }
	
	      return this.getNumberedDispayCount();
	    }
	  }, {
	    key: "getScrollNumberTitle",
	    value: function getScrollNumberTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          count = _this$props2.count;
	
	      if (title) {
	        return title;
	      }
	
	      return typeof count === 'string' || typeof count === 'number' ? count : undefined;
	    }
	  }, {
	    key: "getStyleWithOffset",
	    value: function getStyleWithOffset() {
	      var _this$props3 = this.props,
	          offset = _this$props3.offset,
	          style = _this$props3.style;
	      return offset ? _extends({
	        right: -parseInt(offset[0], 10),
	        marginTop: offset[1]
	      }, style) : style;
	    }
	  }, {
	    key: "getBadgeClassName",
	    value: function getBadgeClassName(prefixCls) {
	      var _classNames2;
	
	      var _this$props4 = this.props,
	          className = _this$props4.className,
	          children = _this$props4.children;
	      return (0, _classnames["default"])(className, prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-status"), this.hasStatus()), _defineProperty(_classNames2, "".concat(prefixCls, "-not-a-wrapper"), !children), _classNames2));
	    }
	  }, {
	    key: "hasStatus",
	    value: function hasStatus() {
	      var _this$props5 = this.props,
	          status = _this$props5.status,
	          color = _this$props5.color;
	      return !!status || !!color;
	    }
	  }, {
	    key: "isZero",
	    value: function isZero() {
	      var numberedDispayCount = this.getNumberedDispayCount();
	      return numberedDispayCount === '0' || numberedDispayCount === 0;
	    }
	  }, {
	    key: "isDot",
	    value: function isDot() {
	      var dot = this.props.dot;
	      var isZero = this.isZero();
	      return dot && !isZero || this.hasStatus();
	    }
	  }, {
	    key: "isHidden",
	    value: function isHidden() {
	      var showZero = this.props.showZero;
	      var displayCount = this.getDispayCount();
	      var isZero = this.isZero();
	      var isDot = this.isDot();
	      var isEmpty = displayCount === null || displayCount === undefined || displayCount === '';
	      return (isEmpty || isZero && !showZero) && !isDot;
	    }
	  }, {
	    key: "renderStatusText",
	    value: function renderStatusText(prefixCls) {
	      var text = this.props.text;
	      var hidden = this.isHidden();
	      return hidden || !text ? null : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-status-text")
	      }, text);
	    }
	  }, {
	    key: "renderDispayComponent",
	    value: function renderDispayComponent() {
	      var count = this.props.count;
	      var customNode = count;
	
	      if (!customNode || _typeof(customNode) !== 'object') {
	        return undefined;
	      }
	
	      return (/*#__PURE__*/React.cloneElement(customNode, {
	          style: _extends(_extends({}, this.getStyleWithOffset()), customNode.props && customNode.props.style)
	        })
	      );
	    }
	  }, {
	    key: "renderBadgeNumber",
	    value: function renderBadgeNumber(prefixCls, scrollNumberPrefixCls) {
	      var _classNames3;
	
	      var _this$props6 = this.props,
	          status = _this$props6.status,
	          count = _this$props6.count,
	          color = _this$props6.color;
	      var displayCount = this.getDispayCount();
	      var isDot = this.isDot();
	      var hidden = this.isHidden();
	      var scrollNumberCls = (0, _classnames["default"])((_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-dot"), isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-count"), !isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-multiple-words"), !isDot && count && count.toString && count.toString().length > 1), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames3));
	      var statusStyle = this.getStyleWithOffset();
	
	      if (color && !isPresetColor(color)) {
	        statusStyle = statusStyle || {};
	        statusStyle.background = color;
	      }
	
	      return hidden ? null : /*#__PURE__*/React.createElement(_ScrollNumber["default"], {
	        prefixCls: scrollNumberPrefixCls,
	        "data-show": !hidden,
	        className: scrollNumberCls,
	        count: displayCount,
	        displayComponent: this.renderDispayComponent() // <Badge status="success" count={<Icon type="xxx" />}></Badge>
	
	        , title: this.getScrollNumberTitle(),
	        style: statusStyle,
	        key: "scrollNumber"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBadge)
	      );
	    }
	  }]);
	
	  return Badge;
	}(React.Component);
	
	exports["default"] = Badge;
	Badge.defaultProps = {
	  count: null,
	  showZero: false,
	  dot: false,
	  overflowCount: 99
	};
	Badge.propTypes = {
	  count: PropTypes.node,
	  showZero: PropTypes.bool,
	  dot: PropTypes.bool,
	  overflowCount: PropTypes.number
	};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(558));
	
	var _menu = _interopRequireDefault(__webpack_require__(299));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getBreadcrumbName(route, params) {
	  if (!route.breadcrumbName) {
	    return null;
	  }
	
	  var paramsKeys = Object.keys(params).join('|');
	  var name = route.breadcrumbName.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function (replacement, key) {
	    return params[key] || replacement;
	  });
	  return name;
	}
	
	function defaultItemRender(route, params, routes, paths) {
	  var isLastItem = routes.indexOf(route) === routes.length - 1;
	  var name = getBreadcrumbName(route, params);
	  return isLastItem ? /*#__PURE__*/React.createElement("span", null, name) : /*#__PURE__*/React.createElement("a", {
	    href: "#/".concat(paths.join('/'))
	  }, name);
	}
	
	function filterFragment(children) {
	  return (0, _toArray["default"])(children).map(function (element) {
	    if ( /*#__PURE__*/React.isValidElement(element) && element.type === React.Fragment) {
	      var props = element.props;
	      return props.children;
	    }
	
	    return element;
	  });
	}
	
	var Breadcrumb = /*#__PURE__*/function (_React$Component) {
	  _inherits(Breadcrumb, _React$Component);
	
	  var _super = _createSuper(Breadcrumb);
	
	  function Breadcrumb() {
	    var _this;
	
	    _classCallCheck(this, Breadcrumb);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getPath = function (path, params) {
	      path = (path || '').replace(/^\//, '');
	      Object.keys(params).forEach(function (key) {
	        path = path.replace(":".concat(key), params[key]);
	      });
	      return path;
	    };
	
	    _this.addChildPath = function (paths) {
	      var childPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var params = arguments.length > 2 ? arguments[2] : undefined;
	
	      var originalPaths = _toConsumableArray(paths);
	
	      var path = _this.getPath(childPath, params);
	
	      if (path) {
	        originalPaths.push(path);
	      }
	
	      return originalPaths;
	    };
	
	    _this.genForRoutes = function (_ref) {
	      var _ref$routes = _ref.routes,
	          routes = _ref$routes === void 0 ? [] : _ref$routes,
	          _ref$params = _ref.params,
	          params = _ref$params === void 0 ? {} : _ref$params,
	          separator = _ref.separator,
	          _ref$itemRender = _ref.itemRender,
	          itemRender = _ref$itemRender === void 0 ? defaultItemRender : _ref$itemRender;
	      var paths = [];
	      return routes.map(function (route) {
	        var path = _this.getPath(route.path, params);
	
	        if (path) {
	          paths.push(path);
	        } // generated overlay by route.children
	
	
	        var overlay = null;
	
	        if (route.children && route.children.length) {
	          overlay = /*#__PURE__*/React.createElement(_menu["default"], null, route.children.map(function (child) {
	            return (/*#__PURE__*/React.createElement(_menu["default"].Item, {
	                key: child.breadcrumbName || child.path
	              }, itemRender(child, params, routes, _this.addChildPath(paths, child.path, params)))
	            );
	          }));
	        }
	
	        return (/*#__PURE__*/React.createElement(_BreadcrumbItem["default"], {
	            overlay: overlay,
	            separator: separator,
	            key: route.breadcrumbName || path
	          }, itemRender(route, params, routes, paths))
	        );
	      });
	    };
	
	    _this.renderBreadcrumb = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	      var crumbs;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          separator = _a.separator,
	          style = _a.style,
	          className = _a.className,
	          routes = _a.routes,
	          children = _a.children,
	          restProps = __rest(_a, ["prefixCls", "separator", "style", "className", "routes", "children"]);
	
	      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
	
	      if (routes && routes.length > 0) {
	        // generated by route
	        crumbs = _this.genForRoutes(_this.props);
	      } else if (children) {
	        crumbs = React.Children.map(filterFragment(children), function (element, index) {
	          if (!element) {
	            return element;
	          }
	
	          (0, _warning["default"])(element.type && (element.type.__ANT_BREADCRUMB_ITEM === true || element.type.__ANT_BREADCRUMB_SEPARATOR === true), 'Breadcrumb', "Only accepts Breadcrumb.Item and Breadcrumb.Separator as it's children");
	          return (/*#__PURE__*/React.cloneElement(element, {
	              separator: separator,
	              key: index
	            })
	          );
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: (0, _classnames["default"])(className, prefixCls),
	          style: style
	        }, (0, _omit["default"])(restProps, ['itemRender', 'params'])), crumbs)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Breadcrumb, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var props = this.props;
	      (0, _warning["default"])(!('linkRender' in props || 'nameRender' in props), 'Breadcrumb', '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumb)
	      );
	    }
	  }]);
	
	  return Breadcrumb;
	}(React.Component);
	
	exports["default"] = Breadcrumb;
	Breadcrumb.defaultProps = {
	  separator: '/'
	};
	Breadcrumb.propTypes = {
	  prefixCls: PropTypes.string,
	  separator: PropTypes.node,
	  routes: PropTypes.array
	};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _configProvider = __webpack_require__(13);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var BreadcrumbSeparator = /*#__PURE__*/function (_React$Component) {
	  _inherits(BreadcrumbSeparator, _React$Component);
	
	  var _super = _createSuper(BreadcrumbSeparator);
	
	  function BreadcrumbSeparator() {
	    var _this;
	
	    _classCallCheck(this, BreadcrumbSeparator);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSeparator = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var children = _this.props.children;
	      var prefixCls = getPrefixCls('breadcrumb');
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-separator")
	        }, children || '/')
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(BreadcrumbSeparator, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSeparator)
	      );
	    }
	  }]);
	
	  return BreadcrumbSeparator;
	}(React.Component);
	
	exports["default"] = BreadcrumbSeparator;
	BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          size = props.size,
	          className = props.className,
	          others = __rest(props, ["prefixCls", "size", "className"]);
	
	      var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classes
	        }))
	      );
	    })
	  );
	};
	
	var _default = ButtonGroup;
	exports["default"] = _default;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _wave = _interopRequireDefault(__webpack_require__(292));
	
	var _type = __webpack_require__(78);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable react/button-has-type */
	
	var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
	var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
	
	function isString(str) {
	  return typeof str === 'string';
	} // Insert one space between two chinese characters automatically.
	
	
	function insertSpace(child, needInserted) {
	  // Check the child if is undefined or null.
	  if (child == null) {
	    return;
	  }
	
	  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.
	
	  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
	    return (/*#__PURE__*/React.cloneElement(child, {}, child.props.children.split('').join(SPACE))
	    );
	  }
	
	  if (typeof child === 'string') {
	    if (isTwoCNChar(child)) {
	      child = child.split('').join(SPACE);
	    }
	
	    return (/*#__PURE__*/React.createElement("span", null, child)
	    );
	  }
	
	  return child;
	}
	
	function spaceChildren(children, needInserted) {
	  var isPrevChildPure = false;
	  var childList = [];
	  React.Children.forEach(children, function (child) {
	    var type = _typeof(child);
	
	    var isCurrentChildPure = type === 'string' || type === 'number';
	
	    if (isPrevChildPure && isCurrentChildPure) {
	      var lastIndex = childList.length - 1;
	      var lastChild = childList[lastIndex];
	      childList[lastIndex] = "".concat(lastChild).concat(child);
	    } else {
	      childList.push(child);
	    }
	
	    isPrevChildPure = isCurrentChildPure;
	  }); // Pass to React.Children.map to auto fill key
	
	  return React.Children.map(childList, function (child) {
	    return insertSpace(child, needInserted);
	  });
	}
	
	var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
	var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline', 'round');
	var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
	var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');
	
	var Button = /*#__PURE__*/function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  var _super = _createSuper(Button);
	
	  function Button(props) {
	    var _this;
	
	    _classCallCheck(this, Button);
	
	    _this = _super.call(this, props);
	
	    _this.saveButtonRef = function (node) {
	      _this.buttonNode = node;
	    };
	
	    _this.handleClick = function (e) {
	      var loading = _this.state.loading;
	      var onClick = _this.props.onClick;
	
	      if (loading) {
	        return;
	      }
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.renderButton = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          shape = _a.shape,
	          size = _a.size,
	          className = _a.className,
	          children = _a.children,
	          icon = _a.icon,
	          ghost = _a.ghost,
	          block = _a.block,
	          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "block"]);
	
	      var _this$state = _this.state,
	          loading = _this$state.loading,
	          hasTwoCNChar = _this$state.hasTwoCNChar;
	      var prefixCls = getPrefixCls('btn', customizePrefixCls);
	      var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var iconType = loading ? 'loading' : icon;
	      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), !!loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
	      var iconNode = iconType ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType
	      }) : null;
	      var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
	      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType', 'loading']);
	
	      if (linkButtonRestProps.href !== undefined) {
	        return (/*#__PURE__*/React.createElement("a", _extends({}, linkButtonRestProps, {
	            className: classes,
	            onClick: _this.handleClick,
	            ref: _this.saveButtonRef
	          }), iconNode, kids)
	        );
	      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
	
	
	      var _b = rest,
	          htmlType = _b.htmlType,
	          otherProps = __rest(_b, ["htmlType"]);
	
	      var buttonNode = /*#__PURE__*/React.createElement("button", _extends({}, (0, _omit["default"])(otherProps, ['loading']), {
	        type: htmlType,
	        className: classes,
	        onClick: _this.handleClick,
	        ref: _this.saveButtonRef
	      }), iconNode, kids);
	
	      if (type === 'link') {
	        return buttonNode;
	      }
	
	      return (/*#__PURE__*/React.createElement(_wave["default"], null, buttonNode)
	      );
	    };
	
	    _this.state = {
	      loading: props.loading,
	      hasTwoCNChar: false
	    };
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fixTwoCNChar();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      this.fixTwoCNChar();
	
	      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
	        clearTimeout(this.delayTimeout);
	      }
	
	      var loading = this.props.loading;
	
	      if (loading && typeof loading !== 'boolean' && loading.delay) {
	        this.delayTimeout = window.setTimeout(function () {
	          _this2.setState({
	            loading: loading
	          });
	        }, loading.delay);
	      } else if (prevProps.loading !== loading) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          loading: loading
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.delayTimeout) {
	        clearTimeout(this.delayTimeout);
	      }
	    }
	  }, {
	    key: "fixTwoCNChar",
	    value: function fixTwoCNChar() {
	      // Fix for HOC usage like <FormatMessage />
	      if (!this.buttonNode) {
	        return;
	      }
	
	      var buttonText = this.buttonNode.textContent;
	
	      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
	        if (!this.state.hasTwoCNChar) {
	          this.setState({
	            hasTwoCNChar: true
	          });
	        }
	      } else if (this.state.hasTwoCNChar) {
	        this.setState({
	          hasTwoCNChar: false
	        });
	      }
	    }
	  }, {
	    key: "isNeedInserted",
	    value: function isNeedInserted() {
	      var _this$props = this.props,
	          icon = _this$props.icon,
	          children = _this$props.children,
	          type = _this$props.type;
	      return React.Children.count(children) === 1 && !icon && type !== 'link';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton)
	      );
	    }
	  }]);
	
	  return Button;
	}(React.Component);
	
	Button.__ANT_BUTTON = true;
	Button.defaultProps = {
	  loading: false,
	  ghost: false,
	  block: false,
	  htmlType: 'button'
	};
	Button.propTypes = {
	  type: PropTypes.string,
	  shape: PropTypes.oneOf(ButtonShapes),
	  size: PropTypes.oneOf(ButtonSizes),
	  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
	  onClick: PropTypes.func,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  className: PropTypes.string,
	  icon: PropTypes.string,
	  block: PropTypes.bool,
	  title: PropTypes.string
	};
	(0, _reactLifecyclesCompat.polyfill)(Button);
	var _default = Button;
	exports["default"] = _default;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _select = _interopRequireDefault(__webpack_require__(197));
	
	var _radio = __webpack_require__(234);
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Option = _select["default"].Option;
	
	function getMonthsLocale(value) {
	  var current = value.clone();
	  var localeData = value.localeData();
	  var months = [];
	
	  for (var i = 0; i < 12; i++) {
	    current.month(i);
	    months.push(localeData.monthsShort(current));
	  }
	
	  return months;
	}
	
	var Header = /*#__PURE__*/function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  var _super = _createSuper(Header);
	
	  function Header() {
	    var _this;
	
	    _classCallCheck(this, Header);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onYearChange = function (year) {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          validRange = _this$props.validRange;
	      var newValue = value.clone();
	      newValue.year(parseInt(year, 10)); // switch the month so that it remains within range when year changes
	
	      if (validRange) {
	        var _validRange = _slicedToArray(validRange, 2),
	            start = _validRange[0],
	            end = _validRange[1];
	
	        var newYear = newValue.get('year');
	        var newMonth = newValue.get('month');
	
	        if (newYear === end.get('year') && newMonth > end.get('month')) {
	          newValue.month(end.get('month'));
	        }
	
	        if (newYear === start.get('year') && newMonth < start.get('month')) {
	          newValue.month(start.get('month'));
	        }
	      }
	
	      var onValueChange = _this.props.onValueChange;
	
	      if (onValueChange) {
	        onValueChange(newValue);
	      }
	    };
	
	    _this.onMonthChange = function (month) {
	      var newValue = _this.props.value.clone();
	
	      newValue.month(parseInt(month, 10));
	      var onValueChange = _this.props.onValueChange;
	
	      if (onValueChange) {
	        onValueChange(newValue);
	      }
	    };
	
	    _this.onInternalTypeChange = function (e) {
	      _this.onTypeChange(e.target.value);
	    };
	
	    _this.onTypeChange = function (type) {
	      var onTypeChange = _this.props.onTypeChange;
	
	      if (onTypeChange) {
	        onTypeChange(type);
	      }
	    };
	
	    _this.getCalenderHeaderNode = function (node) {
	      _this.calenderHeaderNode = node;
	    };
	
	    _this.getMonthYearSelections = function (getPrefixCls) {
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          type = _this$props2.type,
	          value = _this$props2.value;
	      var prefixCls = getPrefixCls('fullcalendar', customizePrefixCls);
	
	      var yearReactNode = _this.getYearSelectElement(prefixCls, value.year());
	
	      var monthReactNode = type === 'month' ? _this.getMonthSelectElement(prefixCls, value.month(), getMonthsLocale(value)) : null;
	      return {
	        yearReactNode: yearReactNode,
	        monthReactNode: monthReactNode
	      };
	    };
	
	    _this.getTypeSwitch = function () {
	      var _this$props3 = _this.props,
	          _this$props3$locale = _this$props3.locale,
	          locale = _this$props3$locale === void 0 ? {} : _this$props3$locale,
	          type = _this$props3.type,
	          fullscreen = _this$props3.fullscreen;
	      var size = fullscreen ? 'default' : 'small';
	      return (/*#__PURE__*/React.createElement(_radio.Group, {
	          onChange: _this.onInternalTypeChange,
	          value: type,
	          size: size
	        }, /*#__PURE__*/React.createElement(_radio.Button, {
	          value: "month"
	        }, locale.month), /*#__PURE__*/React.createElement(_radio.Button, {
	          value: "year"
	        }, locale.year))
	      );
	    };
	
	    _this.headerRenderCustom = function (headerRender) {
	      var _this$props4 = _this.props,
	          type = _this$props4.type,
	          onValueChange = _this$props4.onValueChange,
	          value = _this$props4.value;
	      return headerRender({
	        value: value,
	        type: type || 'month',
	        onChange: onValueChange,
	        onTypeChange: _this.onTypeChange
	      });
	    };
	
	    _this.renderHeader = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props5 = _this.props,
	          prefixCls = _this$props5.prefixCls,
	          headerRender = _this$props5.headerRender;
	
	      var typeSwitch = _this.getTypeSwitch();
	
	      var _this$getMonthYearSel = _this.getMonthYearSelections(getPrefixCls),
	          yearReactNode = _this$getMonthYearSel.yearReactNode,
	          monthReactNode = _this$getMonthYearSel.monthReactNode;
	
	      return headerRender ? _this.headerRenderCustom(headerRender) : /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-header"),
	        ref: _this.getCalenderHeaderNode
	      }, yearReactNode, monthReactNode, typeSwitch);
	    };
	
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "getYearSelectElement",
	    value: function getYearSelectElement(prefixCls, year) {
	      var _this2 = this;
	
	      var _this$props6 = this.props,
	          yearSelectOffset = _this$props6.yearSelectOffset,
	          yearSelectTotal = _this$props6.yearSelectTotal,
	          _this$props6$locale = _this$props6.locale,
	          locale = _this$props6$locale === void 0 ? {} : _this$props6$locale,
	          fullscreen = _this$props6.fullscreen,
	          validRange = _this$props6.validRange;
	      var start = year - yearSelectOffset;
	      var end = start + yearSelectTotal;
	
	      if (validRange) {
	        start = validRange[0].get('year');
	        end = validRange[1].get('year') + 1;
	      }
	
	      var suffix = locale.year === '年' ? '年' : '';
	      var options = [];
	
	      for (var index = start; index < end; index++) {
	        options.push( /*#__PURE__*/React.createElement(Option, {
	          key: "".concat(index)
	        }, index + suffix));
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], {
	          size: fullscreen ? 'default' : 'small',
	          dropdownMatchSelectWidth: false,
	          className: "".concat(prefixCls, "-year-select"),
	          onChange: this.onYearChange,
	          value: String(year),
	          getPopupContainer: function getPopupContainer() {
	            return _this2.calenderHeaderNode;
	          }
	        }, options)
	      );
	    }
	  }, {
	    key: "getMonthSelectElement",
	    value: function getMonthSelectElement(prefixCls, month, months) {
	      var _this3 = this;
	
	      var _this$props7 = this.props,
	          fullscreen = _this$props7.fullscreen,
	          validRange = _this$props7.validRange,
	          value = _this$props7.value;
	      var options = [];
	      var start = 0;
	      var end = 12;
	
	      if (validRange) {
	        var _validRange2 = _slicedToArray(validRange, 2),
	            rangeStart = _validRange2[0],
	            rangeEnd = _validRange2[1];
	
	        var currentYear = value.get('year');
	
	        if (rangeEnd.get('year') === currentYear) {
	          end = rangeEnd.get('month') + 1;
	        }
	
	        if (rangeStart.get('year') === currentYear) {
	          start = rangeStart.get('month');
	        }
	      }
	
	      for (var index = start; index < end; index++) {
	        options.push( /*#__PURE__*/React.createElement(Option, {
	          key: "".concat(index)
	        }, months[index]));
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], {
	          size: fullscreen ? 'default' : 'small',
	          dropdownMatchSelectWidth: false,
	          className: "".concat(prefixCls, "-month-select"),
	          value: String(month),
	          onChange: this.onMonthChange,
	          getPopupContainer: function getPopupContainer() {
	            return _this3.calenderHeaderNode;
	          }
	        }, options)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderHeader)
	      );
	    }
	  }]);
	
	  return Header;
	}(React.Component);
	
	exports["default"] = Header;
	Header.defaultProps = {
	  yearSelectOffset: 10,
	  yearSelectTotal: 20
	};

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _FullCalendar = _interopRequireDefault(__webpack_require__(460));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _Header = _interopRequireDefault(__webpack_require__(1022));
	
	var _en_US = _interopRequireDefault(__webpack_require__(560));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _configProvider = __webpack_require__(13);
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function noop() {
	  return null;
	}
	
	function zerofixed(v) {
	  if (v < 10) {
	    return "0".concat(v);
	  }
	
	  return "".concat(v);
	}
	
	var Calendar = /*#__PURE__*/function (_React$Component) {
	  _inherits(Calendar, _React$Component);
	
	  var _super = _createSuper(Calendar);
	
	  function Calendar(props) {
	    var _this;
	
	    _classCallCheck(this, Calendar);
	
	    _this = _super.call(this, props);
	
	    _this.onHeaderValueChange = function (value) {
	      _this.setValue(value, 'changePanel');
	    };
	
	    _this.onHeaderTypeChange = function (mode) {
	      _this.setState({
	        mode: mode
	      });
	
	      _this.onPanelChange(_this.state.value, mode);
	    };
	
	    _this.onSelect = function (value) {
	      _this.setValue(value, 'select');
	    };
	
	    _this.setValue = function (value, way) {
	      var prevValue = _this.props.value || _this.state.value;
	      var mode = _this.state.mode;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      if (way === 'select') {
	        if (prevValue && prevValue.month() !== value.month()) {
	          _this.onPanelChange(value, mode);
	        }
	
	        if (_this.props.onSelect) {
	          _this.props.onSelect(value);
	        }
	      } else if (way === 'changePanel') {
	        _this.onPanelChange(value, mode);
	      }
	    };
	
	    _this.getDateRange = function (validRange, disabledDate) {
	      return function (current) {
	        if (!current) {
	          return false;
	        }
	
	        var _validRange = _slicedToArray(validRange, 2),
	            startDate = _validRange[0],
	            endDate = _validRange[1];
	
	        var inRange = !current.isBetween(startDate, endDate, 'days', '[]');
	
	        if (disabledDate) {
	          return disabledDate(current) || inRange;
	        }
	
	        return inRange;
	      };
	    };
	
	    _this.getDefaultLocale = function () {
	      var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	      result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
	      return result;
	    };
	
	    _this.monthCellRender = function (value) {
	      var _this$props$monthCell = _this.props.monthCellRender,
	          monthCellRender = _this$props$monthCell === void 0 ? noop : _this$props$monthCell;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-month")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-value")
	        }, value.localeData().monthsShort(value)), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, monthCellRender(value)))
	      );
	    };
	
	    _this.dateCellRender = function (value) {
	      var _this$props$dateCellR = _this.props.dateCellRender,
	          dateCellRender = _this$props$dateCellR === void 0 ? noop : _this$props$dateCellR;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize2.prefixCls;
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-date")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-value")
	        }, zerofixed(value.date())), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, dateCellRender(value)))
	      );
	    };
	
	    _this.renderCalendar = function (locale, localeCode) {
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          state = _assertThisInitialize3.state,
	          props = _assertThisInitialize3.props;
	
	      var value = state.value,
	          mode = state.mode;
	
	      if (value && localeCode) {
	        value.locale(localeCode);
	      }
	
	      var customizePrefixCls = props.prefixCls,
	          style = props.style,
	          className = props.className,
	          fullscreen = props.fullscreen,
	          headerRender = props.headerRender,
	          dateFullCellRender = props.dateFullCellRender,
	          monthFullCellRender = props.monthFullCellRender;
	      var monthCellRender = monthFullCellRender || _this.monthCellRender;
	      var dateCellRender = dateFullCellRender || _this.dateCellRender;
	      var disabledDate = props.disabledDate;
	
	      if (props.validRange) {
	        disabledDate = _this.getDateRange(props.validRange, disabledDate);
	      }
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	          var getPrefixCls = _ref.getPrefixCls;
	          var prefixCls = getPrefixCls('fullcalendar', customizePrefixCls); // To support old version react.
	          // Have to add prefixCls on the instance.
	          // https://github.com/facebook/react/issues/12397
	
	          _this.prefixCls = prefixCls;
	          var cls = className || '';
	
	          if (fullscreen) {
	            cls += " ".concat(prefixCls, "-fullscreen");
	          }
	
	          return (/*#__PURE__*/React.createElement("div", {
	              className: cls,
	              style: style
	            }, /*#__PURE__*/React.createElement(_Header["default"], {
	              fullscreen: fullscreen,
	              type: mode,
	              headerRender: headerRender,
	              value: value,
	              locale: locale.lang,
	              prefixCls: prefixCls,
	              onTypeChange: _this.onHeaderTypeChange,
	              onValueChange: _this.onHeaderValueChange,
	              validRange: props.validRange
	            }), /*#__PURE__*/React.createElement(_FullCalendar["default"], _extends({}, props, {
	              disabledDate: disabledDate,
	              Select: noop,
	              locale: locale.lang,
	              type: mode === 'year' ? 'month' : 'date',
	              prefixCls: prefixCls,
	              showHeader: false,
	              value: value,
	              monthCellRender: monthCellRender,
	              dateCellRender: dateCellRender,
	              onSelect: _this.onSelect
	            })))
	          );
	        })
	      );
	    };
	
	    var value = props.value || props.defaultValue || (0, _interopDefault["default"])(moment)();
	
	    if (!(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of Calendar must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/calendar-value');
	    }
	
	    _this.state = {
	      value: value,
	      mode: props.mode || 'month'
	    };
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: "onPanelChange",
	    value: function onPanelChange(value, mode) {
	      var _this$props = this.props,
	          onPanelChange = _this$props.onPanelChange,
	          onChange = _this$props.onChange;
	
	      if (onPanelChange) {
	        onPanelChange(value, mode);
	      }
	
	      if (onChange && value !== this.state.value) {
	        onChange(value);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Calendar",
	          defaultLocale: this.getDefaultLocale
	        }, this.renderCalendar)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	
	      if ('value' in nextProps) {
	        newState.value = nextProps.value;
	      }
	
	      if ('mode' in nextProps) {
	        newState.mode = nextProps.mode;
	      }
	
	      return Object.keys(newState).length > 0 ? newState : null;
	    }
	  }]);
	
	  return Calendar;
	}(React.Component);
	
	Calendar.defaultProps = {
	  locale: {},
	  fullscreen: true,
	  onSelect: noop,
	  onPanelChange: noop,
	  onChange: noop
	};
	Calendar.propTypes = {
	  monthCellRender: PropTypes.func,
	  dateCellRender: PropTypes.func,
	  monthFullCellRender: PropTypes.func,
	  dateFullCellRender: PropTypes.func,
	  fullscreen: PropTypes.bool,
	  locale: PropTypes.object,
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  style: PropTypes.object,
	  onPanelChange: PropTypes.func,
	  value: PropTypes.object,
	  onSelect: PropTypes.func,
	  onChange: PropTypes.func,
	  headerRender: PropTypes.func
	};
	(0, _reactLifecyclesCompat.polyfill)(Calendar);
	var _default = Calendar;
	exports["default"] = _default;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Grid = function Grid(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          _props$hoverable = props.hoverable,
	          hoverable = _props$hoverable === void 0 ? true : _props$hoverable,
	          others = __rest(props, ["prefixCls", "className", "hoverable"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-grid"), className, _defineProperty({}, "".concat(prefixCls, "-grid-hoverable"), hoverable));
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }))
	      );
	    })
	  );
	};
	
	var _default = Grid;
	exports["default"] = _default;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Meta = function Meta(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          avatar = props.avatar,
	          title = props.title,
	          description = props.description,
	          others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-meta"), className);
	      var avatarDom = avatar ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-avatar")
	      }, avatar) : null;
	      var titleDom = title ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-title")
	      }, title) : null;
	      var descriptionDom = description ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-description")
	      }, description) : null;
	      var MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-detail")
	      }, titleDom, descriptionDom) : null;
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }), avatarDom, MetaDetail)
	      );
	    })
	  );
	};
	
	var _default = Meta;
	exports["default"] = _default;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Grid = _interopRequireDefault(__webpack_require__(1024));
	
	var _Meta = _interopRequireDefault(__webpack_require__(1025));
	
	var _tabs = _interopRequireDefault(__webpack_require__(580));
	
	var _row = _interopRequireDefault(__webpack_require__(577));
	
	var _col = _interopRequireDefault(__webpack_require__(562));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getAction(actions) {
	  var actionList = actions.map(function (action, index) {
	    return (
	      /*#__PURE__*/
	      // eslint-disable-next-line react/no-array-index-key
	      React.createElement("li", {
	        style: {
	          width: "".concat(100 / actions.length, "%")
	        },
	        key: "action-".concat(index)
	      }, /*#__PURE__*/React.createElement("span", null, action))
	    );
	  });
	  return actionList;
	}
	
	var Card = /*#__PURE__*/function (_React$Component) {
	  _inherits(Card, _React$Component);
	
	  var _super = _createSuper(Card);
	
	  function Card() {
	    var _this;
	
	    _classCallCheck(this, Card);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onTabChange = function (key) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(key);
	      }
	    };
	
	    _this.renderCard = function (_ref) {
	      var _classNames, _extraProps;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          extra = _a.extra,
	          _a$headStyle = _a.headStyle,
	          headStyle = _a$headStyle === void 0 ? {} : _a$headStyle,
	          _a$bodyStyle = _a.bodyStyle,
	          bodyStyle = _a$bodyStyle === void 0 ? {} : _a$bodyStyle,
	          title = _a.title,
	          loading = _a.loading,
	          _a$bordered = _a.bordered,
	          bordered = _a$bordered === void 0 ? true : _a$bordered,
	          _a$size = _a.size,
	          size = _a$size === void 0 ? 'default' : _a$size,
	          type = _a.type,
	          cover = _a.cover,
	          actions = _a.actions,
	          tabList = _a.tabList,
	          children = _a.children,
	          activeTabKey = _a.activeTabKey,
	          defaultActiveTabKey = _a.defaultActiveTabKey,
	          tabBarExtraContent = _a.tabBarExtraContent,
	          others = __rest(_a, ["prefixCls", "className", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-hoverable"), _this.getCompatibleHoverable()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-grid"), _this.isContainGrid()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-type-").concat(type), !!type), _classNames));
	      var loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? {
	        padding: 24
	      } : undefined;
	      var loadingBlock = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-content"),
	        style: loadingBlockStyle
	      }, /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 22
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 8
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 15
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 6
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 18
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 13
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 9
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 4
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 3
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 16
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))));
	      var hasActiveTabKey = activeTabKey !== undefined;
	      var extraProps = (_extraProps = {}, _defineProperty(_extraProps, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey), _defineProperty(_extraProps, "tabBarExtraContent", tabBarExtraContent), _extraProps);
	      var head;
	      var tabs = tabList && tabList.length ? /*#__PURE__*/React.createElement(_tabs["default"], _extends({}, extraProps, {
	        className: "".concat(prefixCls, "-head-tabs"),
	        size: "large",
	        onChange: _this.onTabChange
	      }), tabList.map(function (item) {
	        return (/*#__PURE__*/React.createElement(_tabs["default"].TabPane, {
	            tab: item.tab,
	            disabled: item.disabled,
	            key: item.key
	          })
	        );
	      })) : null;
	
	      if (title || extra || tabs) {
	        head = /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head"),
	          style: headStyle
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head-wrapper")
	        }, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head-title")
	        }, title), extra && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-extra")
	        }, extra)), tabs);
	      }
	
	      var coverDom = cover ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-cover")
	      }, cover) : null;
	      var body = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body"),
	        style: bodyStyle
	      }, loading ? loadingBlock : children);
	      var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-actions")
	      }, getAction(actions)) : null;
	      var divProps = (0, _omit["default"])(others, ['onTabChange', 'noHovering', 'hoverable']);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	          className: classString
	        }), head, coverDom, body, actionDom)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if ('noHovering' in this.props) {
	        (0, _warning["default"])(!this.props.noHovering, 'Card', '`noHovering` is deprecated, you can remove it safely or use `hoverable` instead.');
	        (0, _warning["default"])(!!this.props.noHovering, 'Card', '`noHovering={false}` is deprecated, use `hoverable` instead.');
	      }
	    } // For 2.x compatible
	
	  }, {
	    key: "getCompatibleHoverable",
	    value: function getCompatibleHoverable() {
	      var _this$props = this.props,
	          noHovering = _this$props.noHovering,
	          hoverable = _this$props.hoverable;
	
	      if ('noHovering' in this.props) {
	        return !noHovering || hoverable;
	      }
	
	      return !!hoverable;
	    }
	  }, {
	    key: "isContainGrid",
	    value: function isContainGrid() {
	      var containGrid;
	      React.Children.forEach(this.props.children, function (element) {
	        if (element && element.type && element.type === _Grid["default"]) {
	          containGrid = true;
	        }
	      });
	      return containGrid;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCard)
	      );
	    }
	  }]);
	
	  return Card;
	}(React.Component);
	
	exports["default"] = Card;
	Card.Grid = _Grid["default"];
	Card.Meta = _Meta["default"];

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	} // Use require over import (will be lifted up)
	// make sure matchMedia polyfill run before require('react-slick')
	// Fix https://github.com/ant-design/ant-design/issues/6560
	// Fix https://github.com/ant-design/ant-design/issues/3308
	
	
	var SlickCarousel = __webpack_require__(487)["default"];
	
	var Carousel = /*#__PURE__*/function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  var _super = _createSuper(Carousel);
	
	  function Carousel(props) {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _super.call(this, props);
	
	    _this.saveSlick = function (node) {
	      _this.slick = node;
	    };
	
	    _this.onWindowResized = function () {
	      // Fix https://github.com/ant-design/ant-design/issues/2550
	      var autoplay = _this.props.autoplay;
	
	      if (autoplay && _this.slick && _this.slick.innerSlider && _this.slick.innerSlider.autoPlay) {
	        _this.slick.innerSlider.autoPlay();
	      }
	    };
	
	    _this.renderCarousel = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var props = _extends({}, _this.props);
	
	      if (props.effect === 'fade') {
	        props.fade = true;
	      }
	
	      var className = getPrefixCls('carousel', props.prefixCls);
	      var dotsClass = 'slick-dots';
	
	      var dotPosition = _this.getDotPosition();
	
	      props.vertical = dotPosition === 'left' || dotPosition === 'right';
	      props.dotsClass = "".concat(dotsClass, " ").concat(dotsClass, "-").concat(dotPosition || 'bottom');
	
	      if (props.vertical) {
	        className = "".concat(className, " ").concat(className, "-vertical");
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className
	        }, /*#__PURE__*/React.createElement(SlickCarousel, _extends({
	          ref: _this.saveSlick
	        }, props)))
	      );
	    };
	
	    _this.onWindowResized = (0, _debounce["default"])(_this.onWindowResized, 500, {
	      leading: false
	    });
	
	    if ('vertical' in _this.props) {
	      (0, _warning["default"])(!_this.props.vertical, 'Carousel', '`vertical` is deprecated, please use `dotPosition` instead.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var autoplay = this.props.autoplay;
	
	      if (autoplay) {
	        window.addEventListener('resize', this.onWindowResized);
	      } // https://github.com/ant-design/ant-design/issues/7191
	
	
	      this.innerSlider = this.slick && this.slick.innerSlider;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (React.Children.count(this.props.children) !== React.Children.count(prevProps.children)) {
	        this.goTo(this.props.initialSlide || 0, false);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var autoplay = this.props.autoplay;
	
	      if (autoplay) {
	        window.removeEventListener('resize', this.onWindowResized);
	        this.onWindowResized.cancel();
	      }
	    }
	  }, {
	    key: "getDotPosition",
	    value: function getDotPosition() {
	      if (this.props.dotPosition) {
	        return this.props.dotPosition;
	      }
	
	      if ('vertical' in this.props) {
	        return this.props.vertical ? 'right' : 'bottom';
	      }
	
	      return 'bottom';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      this.slick.slickNext();
	    }
	  }, {
	    key: "prev",
	    value: function prev() {
	      this.slick.slickPrev();
	    }
	  }, {
	    key: "goTo",
	    value: function goTo(slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      this.slick.slickGoTo(slide, dontAnimate);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCarousel)
	      );
	    }
	  }]);
	
	  return Carousel;
	}(React.Component);
	
	exports["default"] = Carousel;
	Carousel.defaultProps = {
	  dots: true,
	  arrows: false,
	  draggable: false
	};

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcCascader = _interopRequireDefault(__webpack_require__(462));
	
	var _arrayTreeFilter = _interopRequireDefault(__webpack_require__(488));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _input = _interopRequireDefault(__webpack_require__(233));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// We limit the filtered item count by default
	var defaultLimit = 50;
	
	function highlightKeyword(str, keyword, prefixCls) {
	  return str.split(keyword).map(function (node, index) {
	    return index === 0 ? node : [/*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-menu-item-keyword"),
	      key: "seperator"
	    }, keyword), node];
	  });
	}
	
	function defaultFilterOption(inputValue, path, names) {
	  return path.some(function (option) {
	    return option[names.label].indexOf(inputValue) > -1;
	  });
	}
	
	function defaultRenderFilteredOption(inputValue, path, prefixCls, names) {
	  return path.map(function (option, index) {
	    var label = option[names.label];
	    var node = label.indexOf(inputValue) > -1 ? highlightKeyword(label, inputValue, prefixCls) : label;
	    return index === 0 ? node : [' / ', node];
	  });
	}
	
	function defaultSortFilteredOption(a, b, inputValue, names) {
	  function callback(elem) {
	    return elem[names.label].indexOf(inputValue) > -1;
	  }
	
	  return a.findIndex(callback) - b.findIndex(callback);
	}
	
	function getFieldNames(props) {
	  var fieldNames = props.fieldNames,
	      filedNames = props.filedNames;
	
	  if ('filedNames' in props) {
	    return filedNames; // For old compatibility
	  }
	
	  return fieldNames;
	}
	
	function getFilledFieldNames(props) {
	  var fieldNames = getFieldNames(props) || {};
	  var names = {
	    children: fieldNames.children || 'children',
	    label: fieldNames.label || 'label',
	    value: fieldNames.value || 'value'
	  };
	  return names;
	}
	
	function flattenTree(options, props) {
	  var ancestor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var names = getFilledFieldNames(props);
	  var flattenOptions = [];
	  var childrenName = names.children;
	  options.forEach(function (option) {
	    var path = ancestor.concat(option);
	
	    if (props.changeOnSelect || !option[childrenName] || !option[childrenName].length) {
	      flattenOptions.push(path);
	    }
	
	    if (option[childrenName]) {
	      flattenOptions = flattenOptions.concat(flattenTree(option[childrenName], props, path));
	    }
	  });
	  return flattenOptions;
	}
	
	var defaultDisplayRender = function defaultDisplayRender(label) {
	  return label.join(' / ');
	};
	
	function warningValueNotExist(list) {
	  var fieldNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (list || []).forEach(function (item) {
	    var valueFieldName = fieldNames.value || 'value';
	    (0, _warning["default"])(valueFieldName in item, 'Cascader', 'Not found `value` in `options`.');
	    warningValueNotExist(item[fieldNames.children || 'children'], fieldNames);
	  });
	}
	
	var Cascader = /*#__PURE__*/function (_React$Component) {
	  _inherits(Cascader, _React$Component);
	
	  var _super = _createSuper(Cascader);
	
	  function Cascader(props) {
	    var _this;
	
	    _classCallCheck(this, Cascader);
	
	    _this = _super.call(this, props);
	    _this.cachedOptions = [];
	
	    _this.setValue = function (value) {
	      var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(value, selectedOptions);
	      }
	    };
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.handleChange = function (value, selectedOptions) {
	      _this.setState({
	        inputValue: ''
	      });
	
	      if (selectedOptions[0].__IS_FILTERED_OPTION) {
	        var unwrappedValue = value[0];
	        var unwrappedSelectedOptions = selectedOptions[0].path;
	
	        _this.setValue(unwrappedValue, unwrappedSelectedOptions);
	
	        return;
	      }
	
	      _this.setValue(value, selectedOptions);
	    };
	
	    _this.handlePopupVisibleChange = function (popupVisible) {
	      if (!('popupVisible' in _this.props)) {
	        _this.setState(function (state) {
	          return {
	            popupVisible: popupVisible,
	            inputFocused: popupVisible,
	            inputValue: popupVisible ? state.inputValue : ''
	          };
	        });
	      }
	
	      var onPopupVisibleChange = _this.props.onPopupVisibleChange;
	
	      if (onPopupVisibleChange) {
	        onPopupVisibleChange(popupVisible);
	      }
	    };
	
	    _this.handleInputBlur = function () {
	      _this.setState({
	        inputFocused: false
	      });
	    };
	
	    _this.handleInputClick = function (e) {
	      var _this$state = _this.state,
	          inputFocused = _this$state.inputFocused,
	          popupVisible = _this$state.popupVisible; // Prevent `Trigger` behaviour.
	
	      if (inputFocused || popupVisible) {
	        e.stopPropagation();
	
	        if (e.nativeEvent.stopImmediatePropagation) {
	          e.nativeEvent.stopImmediatePropagation();
	        }
	      }
	    };
	
	    _this.handleKeyDown = function (e) {
	      // SPACE => https://github.com/ant-design/ant-design/issues/16871
	      if (e.keyCode === _KeyCode["default"].BACKSPACE || e.keyCode === _KeyCode["default"].SPACE) {
	        e.stopPropagation();
	      }
	    };
	
	    _this.handleInputChange = function (e) {
	      var inputValue = e.target.value;
	
	      _this.setState({
	        inputValue: inputValue
	      });
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (!_this.state.inputValue) {
	        _this.setValue([]);
	
	        _this.handlePopupVisibleChange(false);
	      } else {
	        _this.setState({
	          inputValue: ''
	        });
	      }
	    };
	
	    _this.renderCascader = function (_ref, locale) {
	      var _classNames, _classNames2, _classNames3, _classNames4;
	
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          customizeInputPrefixCls = props.inputPrefixCls,
	          children = props.children,
	          _props$placeholder = props.placeholder,
	          placeholder = _props$placeholder === void 0 ? locale.placeholder || 'Please select' : _props$placeholder,
	          size = props.size,
	          disabled = props.disabled,
	          className = props.className,
	          style = props.style,
	          allowClear = props.allowClear,
	          _props$showSearch = props.showSearch,
	          showSearch = _props$showSearch === void 0 ? false : _props$showSearch,
	          suffixIcon = props.suffixIcon,
	          notFoundContent = props.notFoundContent,
	          otherProps = __rest(props, ["prefixCls", "inputPrefixCls", "children", "placeholder", "size", "disabled", "className", "style", "allowClear", "showSearch", "suffixIcon", "notFoundContent"]);
	
	      var value = state.value,
	          inputFocused = state.inputFocused;
	      var prefixCls = getPrefixCls('cascader', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-sm"), size === 'small'), _classNames));
	      var clearIcon = allowClear && !disabled && value.length > 0 || state.inputValue ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection
	      }) : null;
	      var arrowCls = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-picker-arrow"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-arrow-expand"), state.popupVisible), _classNames2));
	      var pickerCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-picker"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-picker-with-value"), state.inputValue), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-disabled"), disabled), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-").concat(size), !!size), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-show-search"), !!showSearch), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-focused"), inputFocused), _classNames3)); // Fix bug of https://github.com/facebook/react/pull/5004
	      // and https://fb.me/react-unknown-prop
	
	      var inputProps = (0, _omit["default"])(otherProps, ['onChange', 'options', 'popupPlacement', 'transitionName', 'displayRender', 'onPopupVisibleChange', 'changeOnSelect', 'expandTrigger', 'popupVisible', 'getPopupContainer', 'loadData', 'popupClassName', 'filterOption', 'renderFilteredOption', 'sortFilteredOption', 'notFoundContent', 'fieldNames', 'filedNames']);
	      var options = props.options;
	      var names = getFilledFieldNames(_this.props);
	
	      if (options && options.length > 0) {
	        if (state.inputValue) {
	          options = _this.generateFilteredOptions(prefixCls, renderEmpty);
	        }
	      } else {
	        var _ref2;
	
	        options = [(_ref2 = {}, _defineProperty(_ref2, names.value, 'ANT_CASCADER_NOT_FOUND'), _defineProperty(_ref2, names.label, notFoundContent || renderEmpty('Cascader')), _defineProperty(_ref2, "disabled", true), _defineProperty(_ref2, "isEmptyNode", true), _ref2)];
	      } // Dropdown menu should keep previous status until it is fully closed.
	
	
	      if (!state.popupVisible) {
	        options = _this.cachedOptions;
	      } else {
	        _this.cachedOptions = options;
	      }
	
	      var dropdownMenuColumnStyle = {};
	      var isNotFound = (options || []).length === 1 && options[0].isEmptyNode;
	
	      if (isNotFound) {
	        dropdownMenuColumnStyle.height = 'auto'; // Height of one row.
	      } // The default value of `matchInputWidth` is `true`
	
	
	      var resultListMatchInputWidth = showSearch.matchInputWidth !== false;
	
	      if (resultListMatchInputWidth && (state.inputValue || isNotFound) && _this.input) {
	        dropdownMenuColumnStyle.width = _this.input.input.offsetWidth;
	      }
	
	      var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	        className: (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames4, "".concat(prefixCls, "-picker-arrow"), true), _classNames4))
	      }) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-picker-arrow")
	      }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: arrowCls
	      });
	      var input = children || /*#__PURE__*/React.createElement("span", {
	        style: style,
	        className: pickerCls
	      }, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-picker-label")
	      }, _this.getLabel()), /*#__PURE__*/React.createElement(_input["default"], _extends({}, inputProps, {
	        tabIndex: "-1",
	        ref: _this.saveInput,
	        prefixCls: inputPrefixCls,
	        placeholder: value && value.length > 0 ? undefined : placeholder,
	        className: "".concat(prefixCls, "-input ").concat(sizeCls),
	        value: state.inputValue,
	        disabled: disabled,
	        readOnly: !showSearch,
	        autoComplete: inputProps.autoComplete || 'off',
	        onClick: showSearch ? _this.handleInputClick : undefined,
	        onBlur: showSearch ? _this.handleInputBlur : undefined,
	        onKeyDown: _this.handleKeyDown,
	        onChange: showSearch ? _this.handleInputChange : undefined
	      })), clearIcon, inputIcon);
	      var expandIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right"
	      });
	      var loadingIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-item-loading-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "redo",
	        spin: true
	      }));
	      var getPopupContainer = props.getPopupContainer || getContextPopupContainer;
	      var rest = (0, _omit["default"])(props, ['inputIcon', 'expandIcon', 'loadingIcon']);
	      return (/*#__PURE__*/React.createElement(_rcCascader["default"], _extends({}, rest, {
	          prefixCls: prefixCls,
	          getPopupContainer: getPopupContainer,
	          options: options,
	          value: value,
	          popupVisible: state.popupVisible,
	          onPopupVisibleChange: _this.handlePopupVisibleChange,
	          onChange: _this.handleChange,
	          dropdownMenuColumnStyle: dropdownMenuColumnStyle,
	          expandIcon: expandIcon,
	          loadingIcon: loadingIcon
	        }), input)
	      );
	    };
	
	    _this.state = {
	      value: props.value || props.defaultValue || [],
	      inputValue: '',
	      inputFocused: false,
	      popupVisible: props.popupVisible,
	      flattenOptions: props.showSearch ? flattenTree(props.options, props) : undefined,
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(Cascader, [{
	    key: "getLabel",
	    value: function getLabel() {
	      var _this$props = this.props,
	          options = _this$props.options,
	          _this$props$displayRe = _this$props.displayRender,
	          displayRender = _this$props$displayRe === void 0 ? defaultDisplayRender : _this$props$displayRe;
	      var names = getFilledFieldNames(this.props);
	      var value = this.state.value;
	      var unwrappedValue = Array.isArray(value[0]) ? value[0] : value;
	      var selectedOptions = (0, _arrayTreeFilter["default"])(options, function (o, level) {
	        return o[names.value] === unwrappedValue[level];
	      }, {
	        childrenKeyName: names.children
	      });
	      var label = selectedOptions.map(function (o) {
	        return o[names.label];
	      });
	      return displayRender(label, selectedOptions);
	    }
	  }, {
	    key: "generateFilteredOptions",
	    value: function generateFilteredOptions(prefixCls, renderEmpty) {
	      var _this2 = this,
	          _ref4;
	
	      var _this$props2 = this.props,
	          showSearch = _this$props2.showSearch,
	          notFoundContent = _this$props2.notFoundContent;
	      var names = getFilledFieldNames(this.props);
	      var _showSearch$filter = showSearch.filter,
	          filter = _showSearch$filter === void 0 ? defaultFilterOption : _showSearch$filter,
	          _showSearch$render = showSearch.render,
	          render = _showSearch$render === void 0 ? defaultRenderFilteredOption : _showSearch$render,
	          _showSearch$sort = showSearch.sort,
	          sort = _showSearch$sort === void 0 ? defaultSortFilteredOption : _showSearch$sort,
	          _showSearch$limit = showSearch.limit,
	          limit = _showSearch$limit === void 0 ? defaultLimit : _showSearch$limit;
	      var _this$state2 = this.state,
	          _this$state2$flattenO = _this$state2.flattenOptions,
	          flattenOptions = _this$state2$flattenO === void 0 ? [] : _this$state2$flattenO,
	          inputValue = _this$state2.inputValue; // Limit the filter if needed
	
	      var filtered;
	
	      if (limit > 0) {
	        filtered = [];
	        var matchCount = 0; // Perf optimization to filter items only below the limit
	
	        flattenOptions.some(function (path) {
	          var match = filter(_this2.state.inputValue, path, names);
	
	          if (match) {
	            filtered.push(path);
	            matchCount += 1;
	          }
	
	          return matchCount >= limit;
	        });
	      } else {
	        (0, _warning["default"])(typeof limit !== 'number', 'Cascader', "'limit' of showSearch should be positive number or false.");
	        filtered = flattenOptions.filter(function (path) {
	          return filter(_this2.state.inputValue, path, names);
	        });
	      }
	
	      filtered.sort(function (a, b) {
	        return sort(a, b, inputValue, names);
	      });
	
	      if (filtered.length > 0) {
	        return filtered.map(function (path) {
	          var _ref3;
	
	          return _ref3 = {
	            __IS_FILTERED_OPTION: true,
	            path: path
	          }, _defineProperty(_ref3, names.value, path.map(function (o) {
	            return o[names.value];
	          })), _defineProperty(_ref3, names.label, render(inputValue, path, prefixCls, names)), _defineProperty(_ref3, "disabled", path.some(function (o) {
	            return !!o.disabled;
	          })), _defineProperty(_ref3, "isEmptyNode", true), _ref3;
	        });
	      }
	
	      return [(_ref4 = {}, _defineProperty(_ref4, names.value, 'ANT_CASCADER_NOT_FOUND'), _defineProperty(_ref4, names.label, notFoundContent || renderEmpty('Cascader')), _defineProperty(_ref4, "disabled", true), _defineProperty(_ref4, "isEmptyNode", true), _ref4)];
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (configArgument) {
	          return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (locale) {
	              return _this3.renderCascader(configArgument, locale);
	            })
	          );
	        })
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, _ref5) {
	      var prevProps = _ref5.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if ('value' in nextProps) {
	        newState.value = nextProps.value || [];
	      }
	
	      if ('popupVisible' in nextProps) {
	        newState.popupVisible = nextProps.popupVisible;
	      }
	
	      if (nextProps.showSearch && prevProps.options !== nextProps.options) {
	        newState.flattenOptions = flattenTree(nextProps.options, nextProps);
	      }
	
	      if (false) {
	        warningValueNotExist(nextProps.options, getFieldNames(nextProps));
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Cascader;
	}(React.Component);
	
	Cascader.defaultProps = {
	  transitionName: 'slide-up',
	  popupPlacement: 'bottomLeft',
	  options: [],
	  disabled: false,
	  allowClear: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Cascader);
	var _default = Cascader;
	exports["default"] = _default;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(561));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(CheckboxGroup, _React$Component);
	
	  var _super = _createSuper(CheckboxGroup);
	
	  function CheckboxGroup(props) {
	    var _this;
	
	    _classCallCheck(this, CheckboxGroup);
	
	    _this = _super.call(this, props);
	
	    _this.cancelValue = function (value) {
	      _this.setState(function (_ref) {
	        var registeredValues = _ref.registeredValues;
	        return {
	          registeredValues: registeredValues.filter(function (val) {
	            return val !== value;
	          })
	        };
	      });
	    };
	
	    _this.registerValue = function (value) {
	      _this.setState(function (_ref2) {
	        var registeredValues = _ref2.registeredValues;
	        return {
	          registeredValues: [].concat(_toConsumableArray(registeredValues), [value])
	        };
	      });
	    };
	
	    _this.toggleOption = function (option) {
	      var registeredValues = _this.state.registeredValues;
	
	      var optionIndex = _this.state.value.indexOf(option.value);
	
	      var value = _toConsumableArray(_this.state.value);
	
	      if (optionIndex === -1) {
	        value.push(option.value);
	      } else {
	        value.splice(optionIndex, 1);
	      }
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        var options = _this.getOptions();
	
	        onChange(value.filter(function (val) {
	          return registeredValues.indexOf(val) !== -1;
	        }).sort(function (a, b) {
	          var indexA = options.findIndex(function (opt) {
	            return opt.value === a;
	          });
	          var indexB = options.findIndex(function (opt) {
	            return opt.value === b;
	          });
	          return indexA - indexB;
	        }));
	      }
	    };
	
	    _this.renderGroup = function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          style = props.style,
	          options = props.options,
	          restProps = __rest(props, ["prefixCls", "className", "style", "options"]);
	
	      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var domProps = (0, _omit["default"])(restProps, ['children', 'defaultValue', 'value', 'onChange', 'disabled']);
	      var children = props.children;
	
	      if (options && options.length > 0) {
	        children = _this.getOptions().map(function (option) {
	          return (/*#__PURE__*/React.createElement(_Checkbox["default"], {
	              prefixCls: prefixCls,
	              key: option.value.toString(),
	              disabled: 'disabled' in option ? option.disabled : props.disabled,
	              value: option.value,
	              checked: state.value.indexOf(option.value) !== -1,
	              onChange: option.onChange,
	              className: "".concat(groupPrefixCls, "-item")
	            }, option.label)
	          );
	        });
	      }
	
	      var classString = (0, _classnames["default"])(groupPrefixCls, className);
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString,
	          style: style
	        }, domProps), children)
	      );
	    };
	
	    _this.state = {
	      value: props.value || props.defaultValue || [],
	      registeredValues: []
	    };
	    return _this;
	  }
	
	  _createClass(CheckboxGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        checkboxGroup: {
	          toggleOption: this.toggleOption,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name,
	          // https://github.com/ant-design/ant-design/issues/16376
	          registerValue: this.registerValue,
	          cancelValue: this.cancelValue
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var options = this.props.options; // https://github.com/Microsoft/TypeScript/issues/7960
	
	      return options.map(function (option) {
	        if (typeof option === 'string') {
	          return {
	            label: option,
	            value: option
	          };
	        }
	
	        return option;
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value || []
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return CheckboxGroup;
	}(React.Component);
	
	CheckboxGroup.defaultProps = {
	  options: []
	};
	CheckboxGroup.propTypes = {
	  defaultValue: PropTypes.array,
	  value: PropTypes.array,
	  options: PropTypes.array.isRequired,
	  onChange: PropTypes.func
	};
	CheckboxGroup.childContextTypes = {
	  checkboxGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(CheckboxGroup);
	var _default = CheckboxGroup;
	exports["default"] = _default;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcCollapse = _interopRequireDefault(__webpack_require__(188));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _CollapsePanel = _interopRequireDefault(__webpack_require__(1031));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _openAnimation = _interopRequireDefault(__webpack_require__(1004));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Collapse = /*#__PURE__*/function (_React$Component) {
	  _inherits(Collapse, _React$Component);
	
	  var _super = _createSuper(Collapse);
	
	  function Collapse() {
	    var _this;
	
	    _classCallCheck(this, Collapse);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderExpandIcon = function () {
	      var panelProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var prefixCls = arguments.length > 1 ? arguments[1] : undefined;
	      var expandIcon = _this.props.expandIcon;
	      var icon = expandIcon ? expandIcon(panelProps) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        rotate: panelProps.isActive ? 90 : undefined
	      });
	      return (/*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
	          className: (0, _classnames["default"])(icon.props.className, "".concat(prefixCls, "-arrow"))
	        }) : icon
	      );
	    };
	
	    _this.renderCollapse = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          bordered = _this$props.bordered,
	          expandIconPosition = _this$props.expandIconPosition;
	      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
	      var collapseClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _defineProperty(_classNames, "".concat(prefixCls, "-icon-position-").concat(expandIconPosition), true), _classNames), className);
	      return (/*#__PURE__*/React.createElement(_rcCollapse["default"], _extends({}, _this.props, {
	          expandIcon: function expandIcon(panelProps) {
	            return _this.renderExpandIcon(panelProps, prefixCls);
	          },
	          prefixCls: prefixCls,
	          className: collapseClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapse)
	      );
	    }
	  }]);
	
	  return Collapse;
	}(React.Component);
	
	exports["default"] = Collapse;
	Collapse.Panel = _CollapsePanel["default"];
	Collapse.defaultProps = {
	  bordered: true,
	  openAnimation: _extends(_extends({}, _openAnimation["default"]), {
	    appear: function appear() {}
	  }),
	  expandIconPosition: 'left'
	};

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcCollapse = _interopRequireDefault(__webpack_require__(188));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var CollapsePanel = /*#__PURE__*/function (_React$Component) {
	  _inherits(CollapsePanel, _React$Component);
	
	  var _super = _createSuper(CollapsePanel);
	
	  function CollapsePanel() {
	    var _this;
	
	    _classCallCheck(this, CollapsePanel);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderCollapsePanel = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          _this$props$showArrow = _this$props.showArrow,
	          showArrow = _this$props$showArrow === void 0 ? true : _this$props$showArrow;
	      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
	      var collapsePanelClassName = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-no-arrow"), !showArrow), className);
	      return (/*#__PURE__*/React.createElement(_rcCollapse["default"].Panel, _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: collapsePanelClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(CollapsePanel, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapsePanel)
	      );
	    }
	  }]);
	
	  return CollapsePanel;
	}(React.Component);
	
	exports["default"] = CollapsePanel;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Collapse = _interopRequireDefault(__webpack_require__(1030));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Collapse["default"];
	exports["default"] = _default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getAction(actions) {
	  if (!actions || !actions.length) {
	    return null;
	  } // eslint-disable-next-line react/no-array-index-key
	
	
	  var actionList = actions.map(function (action, index) {
	    return (/*#__PURE__*/React.createElement("li", {
	        key: "action-".concat(index)
	      }, action)
	    );
	  });
	  return actionList;
	}
	
	var Comment = /*#__PURE__*/function (_React$Component) {
	  _inherits(Comment, _React$Component);
	
	  var _super = _createSuper(Comment);
	
	  function Comment() {
	    var _this;
	
	    _classCallCheck(this, Comment);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderNested = function (prefixCls, children) {
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-nested"))
	        }, children)
	      );
	    };
	
	    _this.renderComment = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          actions = _a.actions,
	          author = _a.author,
	          avatar = _a.avatar,
	          children = _a.children,
	          className = _a.className,
	          content = _a.content,
	          customizePrefixCls = _a.prefixCls,
	          style = _a.style,
	          datetime = _a.datetime,
	          otherProps = __rest(_a, ["actions", "author", "avatar", "children", "className", "content", "prefixCls", "style", "datetime"]);
	
	      var prefixCls = getPrefixCls('comment', customizePrefixCls);
	      var avatarDom = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-avatar")
	      }, typeof avatar === 'string' ? /*#__PURE__*/React.createElement("img", {
	        src: avatar,
	        alt: "comment-avatar"
	      }) : avatar);
	      var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-actions")
	      }, getAction(actions)) : null;
	      var authorContent = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content-author")
	      }, author && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-author-name")
	      }, author), datetime && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-author-time")
	      }, datetime));
	      var contentDom = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, authorContent, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content-detail")
	      }, content), actionDom);
	      var comment = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-inner")
	      }, avatarDom, contentDom);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
	          className: (0, _classnames["default"])(prefixCls, className),
	          style: style
	        }), comment, children ? _this.renderNested(prefixCls, children) : null)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Comment, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComment)
	      );
	    }
	  }]);
	
	  return Comment;
	}(React.Component);
	
	exports["default"] = Comment;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _empty = _interopRequireDefault(__webpack_require__(565));
	
	var _ = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var renderEmpty = function renderEmpty(componentName) {
	  return (/*#__PURE__*/React.createElement(_.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var prefix = getPrefixCls('empty');
	
	      switch (componentName) {
	        case 'Table':
	        case 'List':
	          return (/*#__PURE__*/React.createElement(_empty["default"], {
	              image: _empty["default"].PRESENTED_IMAGE_SIMPLE
	            })
	          );
	
	        case 'Select':
	        case 'TreeSelect':
	        case 'Cascader':
	        case 'Transfer':
	        case 'Mentions':
	          return (/*#__PURE__*/React.createElement(_empty["default"], {
	              image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
	              className: "".concat(prefix, "-small")
	            })
	          );
	
	        default:
	          return (/*#__PURE__*/React.createElement(_empty["default"], null)
	          );
	      }
	    })
	  );
	};
	
	var _default = renderEmpty;
	exports["default"] = _default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _RangeCalendar = _interopRequireDefault(__webpack_require__(461));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _tag = _interopRequireDefault(__webpack_require__(581));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	var _utils = __webpack_require__(564);
	
	var _InputIcon = _interopRequireDefault(__webpack_require__(563));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function getShowDateFromValue(value, mode) {
	  var _value = _slicedToArray(value, 2),
	      start = _value[0],
	      end = _value[1]; // value could be an empty array, then we should not reset showDate
	
	
	  if (!start && !end) {
	    return;
	  }
	
	  if (mode && mode[0] === 'month') {
	    return [start, end];
	  }
	
	  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
	  return [start, newEnd];
	}
	
	function pickerValueAdapter(value) {
	  if (!value) {
	    return;
	  }
	
	  if (Array.isArray(value)) {
	    return value;
	  }
	
	  return [value, value.clone().add(1, 'month')];
	}
	
	function isEmptyArray(arr) {
	  if (Array.isArray(arr)) {
	    return arr.length === 0 || arr.every(function (i) {
	      return !i;
	    });
	  }
	
	  return false;
	}
	
	function fixLocale(value, localeCode) {
	  if (!localeCode) {
	    return;
	  }
	
	  if (!value || value.length === 0) {
	    return;
	  }
	
	  var _value2 = _slicedToArray(value, 2),
	      start = _value2[0],
	      end = _value2[1];
	
	  if (start) {
	    start.locale(localeCode);
	  }
	
	  if (end) {
	    end.locale(localeCode);
	  }
	}
	
	var RangePicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(RangePicker, _React$Component);
	
	  var _super = _createSuper(RangePicker);
	
	  function RangePicker(props) {
	    var _this;
	
	    _classCallCheck(this, RangePicker);
	
	    _this = _super.call(this, props);
	
	    _this.savePicker = function (node) {
	      _this.picker = node;
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.setState({
	        value: []
	      });
	
	      _this.handleChange([]);
	    };
	
	    _this.clearHoverValue = function () {
	      return _this.setState({
	        hoverValue: []
	      });
	    };
	
	    _this.handleChange = function (value) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      if (!('value' in props)) {
	        _this.setState(function (_ref) {
	          var showDate = _ref.showDate;
	          return {
	            value: value,
	            showDate: getShowDateFromValue(value) || showDate
	          };
	        });
	      }
	
	      if (value[0] && value[1] && value[0].diff(value[1]) > 0) {
	        value[1] = undefined;
	      }
	
	      var _value3 = _slicedToArray(value, 2),
	          start = _value3[0],
	          end = _value3[1];
	
	      if (typeof props.onChange === 'function') {
	        props.onChange(value, [(0, _utils.formatDate)(start, props.format), (0, _utils.formatDate)(end, props.format)]);
	      }
	    };
	
	    _this.handleOpenChange = function (open) {
	      if (!('open' in _this.props)) {
	        _this.setState({
	          open: open
	        });
	      }
	
	      if (open === false) {
	        _this.clearHoverValue();
	      }
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.handleShowDateChange = function (showDate) {
	      return _this.setState({
	        showDate: showDate
	      });
	    };
	
	    _this.handleHoverChange = function (hoverValue) {
	      return _this.setState({
	        hoverValue: hoverValue
	      });
	    };
	
	    _this.handleRangeMouseLeave = function () {
	      if (_this.state.open) {
	        _this.clearHoverValue();
	      }
	    };
	
	    _this.handleCalendarInputSelect = function (value) {
	      var _value4 = _slicedToArray(value, 1),
	          start = _value4[0];
	
	      if (!start) {
	        return;
	      }
	
	      _this.setState(function (_ref2) {
	        var showDate = _ref2.showDate;
	        return {
	          value: value,
	          showDate: getShowDateFromValue(value) || showDate
	        };
	      });
	    };
	
	    _this.handleRangeClick = function (value) {
	      if (typeof value === 'function') {
	        value = value();
	      }
	
	      _this.setValue(value, true);
	
	      var _this$props = _this.props,
	          onOk = _this$props.onOk,
	          onOpenChange = _this$props.onOpenChange;
	
	      if (onOk) {
	        onOk(value);
	      }
	
	      if (onOpenChange) {
	        onOpenChange(false);
	      }
	    };
	
	    _this.renderFooter = function () {
	      var _this$props2 = _this.props,
	          ranges = _this$props2.ranges,
	          renderExtraFooter = _this$props2.renderExtraFooter;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize2.prefixCls,
	          tagPrefixCls = _assertThisInitialize2.tagPrefixCls;
	
	      if (!ranges && !renderExtraFooter) {
	        return null;
	      }
	
	      var customFooter = renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra"),
	        key: "extra"
	      }, renderExtraFooter()) : null;
	      var operations = ranges && Object.keys(ranges).map(function (range) {
	        var value = ranges[range];
	        var hoverValue = typeof value === 'function' ? value.call(_assertThisInitialized(_this)) : value;
	        return (/*#__PURE__*/React.createElement(_tag["default"], {
	            key: range,
	            prefixCls: tagPrefixCls,
	            color: "blue",
	            onClick: function onClick() {
	              return _this.handleRangeClick(value);
	            },
	            onMouseEnter: function onMouseEnter() {
	              return _this.setState({
	                hoverValue: hoverValue
	              });
	            },
	            onMouseLeave: _this.handleRangeMouseLeave
	          }, range)
	        );
	      });
	      var rangeNode = operations && operations.length > 0 ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra ").concat(prefixCls, "-range-quick-selector"),
	        key: "range"
	      }, operations) : null;
	      return [rangeNode, customFooter];
	    };
	
	    _this.renderRangePicker = function (_ref3) {
	      var _classNames;
	
	      var getPrefixCls = _ref3.getPrefixCls;
	
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          state = _assertThisInitialize3.state,
	          props = _assertThisInitialize3.props;
	
	      var value = state.value,
	          showDate = state.showDate,
	          hoverValue = state.hoverValue,
	          open = state.open;
	      var customizePrefixCls = props.prefixCls,
	          customizeTagPrefixCls = props.tagPrefixCls,
	          popupStyle = props.popupStyle,
	          style = props.style,
	          disabledDate = props.disabledDate,
	          disabledTime = props.disabledTime,
	          showTime = props.showTime,
	          showToday = props.showToday,
	          ranges = props.ranges,
	          onOk = props.onOk,
	          locale = props.locale,
	          localeCode = props.localeCode,
	          format = props.format,
	          dateRender = props.dateRender,
	          onCalendarChange = props.onCalendarChange,
	          suffixIcon = props.suffixIcon,
	          separator = props.separator;
	      var prefixCls = getPrefixCls('calendar', customizePrefixCls);
	      var tagPrefixCls = getPrefixCls('tag', customizeTagPrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      _this.tagPrefixCls = tagPrefixCls;
	      fixLocale(value, localeCode);
	      fixLocale(showDate, localeCode);
	      (0, _warning["default"])(!('onOK' in props), 'RangePicker', 'It should be `RangePicker[onOk]`, instead of `onOK`!');
	      var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), showTime), _defineProperty(_classNames, "".concat(prefixCls, "-range-with-ranges"), ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange
	
	      var pickerChangeHandler = {
	        onChange: _this.handleChange
	      };
	      var calendarProps = {
	        onOk: _this.handleChange
	      };
	
	      if (props.timePicker) {
	        pickerChangeHandler.onChange = function (changedValue) {
	          return _this.handleChange(changedValue);
	        };
	      } else {
	        calendarProps = {};
	      }
	
	      if ('mode' in props) {
	        calendarProps.mode = props.mode;
	      }
	
	      var startPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
	      var endPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
	      var calendar = /*#__PURE__*/React.createElement(_RangeCalendar["default"], _extends({}, calendarProps, {
	        seperator: separator,
	        onChange: onCalendarChange,
	        format: format,
	        prefixCls: prefixCls,
	        className: calendarClassName,
	        renderFooter: _this.renderFooter,
	        timePicker: props.timePicker,
	        disabledDate: disabledDate,
	        disabledTime: disabledTime,
	        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
	        locale: locale.lang,
	        onOk: onOk,
	        dateRender: dateRender,
	        value: showDate,
	        onValueChange: _this.handleShowDateChange,
	        hoverValue: hoverValue,
	        onHoverChange: _this.handleHoverChange,
	        onPanelChange: props.onPanelChange,
	        showToday: showToday,
	        onInputSelect: _this.handleCalendarInputSelect
	      })); // default width for showTime
	
	      var pickerStyle = {};
	
	      if (props.showTime) {
	        pickerStyle.width = style && style.width || 350;
	      }
	
	      var _value5 = _slicedToArray(value, 2),
	          startValue = _value5[0],
	          endValue = _value5[1];
	
	      var clearIcon = !props.disabled && props.allowClear && value && (startValue || endValue) ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection,
	        theme: "filled"
	      }) : null;
	      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
	        suffixIcon: suffixIcon,
	        prefixCls: prefixCls
	      });
	
	      var input = function input(_ref4) {
	        var inputValue = _ref4.value;
	
	        var _inputValue = _slicedToArray(inputValue, 2),
	            start = _inputValue[0],
	            end = _inputValue[1];
	
	        return (/*#__PURE__*/React.createElement("span", {
	            className: props.pickerInputClass
	          }, /*#__PURE__*/React.createElement("input", {
	            disabled: props.disabled,
	            readOnly: true,
	            value: (0, _utils.formatDate)(start, props.format),
	            placeholder: startPlaceholder,
	            className: "".concat(prefixCls, "-range-picker-input"),
	            tabIndex: -1
	          }), /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-range-picker-separator")
	          }, " ", separator, " "), /*#__PURE__*/React.createElement("input", {
	            disabled: props.disabled,
	            readOnly: true,
	            value: (0, _utils.formatDate)(end, props.format),
	            placeholder: endPlaceholder,
	            className: "".concat(prefixCls, "-range-picker-input"),
	            tabIndex: -1
	          }), clearIcon, inputIcon)
	        );
	      };
	
	      return (/*#__PURE__*/React.createElement("span", {
	          ref: _this.savePicker,
	          id: typeof props.id === 'number' ? props.id.toString() : props.id,
	          className: (0, _classnames["default"])(props.className, props.pickerClass),
	          style: _extends(_extends({}, style), pickerStyle),
	          tabIndex: props.disabled ? -1 : 0,
	          onFocus: props.onFocus,
	          onBlur: props.onBlur,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerChangeHandler, {
	          calendar: calendar,
	          value: value,
	          open: open,
	          onOpenChange: _this.handleOpenChange,
	          prefixCls: "".concat(prefixCls, "-picker-container"),
	          style: popupStyle
	        }), input))
	      );
	    };
	
	    var value = props.value || props.defaultValue || [];
	
	    var _value6 = _slicedToArray(value, 2),
	        start = _value6[0],
	        end = _value6[1];
	
	    if (start && !(0, _interopDefault["default"])(moment).isMoment(start) || end && !(0, _interopDefault["default"])(moment).isMoment(end)) {
	      throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
	    }
	
	    var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
	    _this.state = {
	      value: value,
	      showDate: pickerValueAdapter(pickerValue || (0, _interopDefault["default"])(moment)()),
	      open: props.open,
	      hoverValue: []
	    };
	    return _this;
	  }
	
	  _createClass(RangePicker, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      if (!('open' in this.props) && prevState.open && !this.state.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, hidePanel) {
	      this.handleChange(value);
	
	      if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.picker.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.picker.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRangePicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var state = null;
	
	      if ('value' in nextProps) {
	        var value = nextProps.value || [];
	        state = {
	          value: value
	        };
	
	        if (!(0, _shallowequal["default"])(nextProps.value, prevState.value)) {
	          state = _extends(_extends({}, state), {
	            showDate: getShowDateFromValue(value, nextProps.mode) || prevState.showDate
	          });
	        }
	      }
	
	      if ('open' in nextProps && prevState.open !== nextProps.open) {
	        state = _extends(_extends({}, state), {
	          open: nextProps.open
	        });
	      }
	
	      return state;
	    }
	  }]);
	
	  return RangePicker;
	}(React.Component);
	
	RangePicker.defaultProps = {
	  allowClear: true,
	  showToday: false,
	  separator: '~'
	};
	(0, _reactLifecyclesCompat.polyfill)(RangePicker);
	var _default = RangePicker;
	exports["default"] = _default;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcCalendar = _interopRequireDefault(__webpack_require__(186));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	var _InputIcon = _interopRequireDefault(__webpack_require__(563));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function formatValue(value, format) {
	  return value && value.format(format) || '';
	}
	
	var WeekPicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(WeekPicker, _React$Component);
	
	  var _super = _createSuper(WeekPicker);
	
	  function WeekPicker(props) {
	    var _this;
	
	    _classCallCheck(this, WeekPicker);
	
	    _this = _super.call(this, props);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.weekDateRender = function (current) {
	      var selectedValue = _this.state.value;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      var dateRender = _this.props.dateRender;
	      var dateNode = dateRender ? dateRender(current) : current.date();
	
	      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
	        return (/*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-selected-day")
	          }, /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-date")
	          }, dateNode))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-date")
	        }, dateNode)
	      );
	    };
	
	    _this.handleChange = function (value) {
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      _this.props.onChange(value, formatValue(value, _this.props.format));
	    };
	
	    _this.handleOpenChange = function (open) {
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (!('open' in _this.props)) {
	        _this.setState({
	          open: open
	        });
	      }
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.handleChange(null);
	    };
	
	    _this.renderFooter = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          renderExtraFooter = _this$props.renderExtraFooter;
	      return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra")
	      }, renderExtraFooter.apply(void 0, arguments)) : null;
	    };
	
	    _this.renderWeekPicker = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          disabled = _this$props2.disabled,
	          pickerClass = _this$props2.pickerClass,
	          popupStyle = _this$props2.popupStyle,
	          pickerInputClass = _this$props2.pickerInputClass,
	          format = _this$props2.format,
	          allowClear = _this$props2.allowClear,
	          locale = _this$props2.locale,
	          localeCode = _this$props2.localeCode,
	          disabledDate = _this$props2.disabledDate,
	          style = _this$props2.style,
	          onFocus = _this$props2.onFocus,
	          onBlur = _this$props2.onBlur,
	          id = _this$props2.id,
	          suffixIcon = _this$props2.suffixIcon,
	          defaultPickerValue = _this$props2.defaultPickerValue;
	      var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      var _this$state = _this.state,
	          open = _this$state.open,
	          pickerValue = _this$state.value;
	
	      if (pickerValue && localeCode) {
	        pickerValue.locale(localeCode);
	      }
	
	      var placeholder = 'placeholder' in _this.props ? _this.props.placeholder : locale.lang.placeholder;
	      var calendar = /*#__PURE__*/React.createElement(_rcCalendar["default"], {
	        showWeekNumber: true,
	        dateRender: _this.weekDateRender,
	        prefixCls: prefixCls,
	        format: format,
	        locale: locale.lang,
	        showDateInput: false,
	        showToday: false,
	        disabledDate: disabledDate,
	        renderFooter: _this.renderFooter,
	        defaultValue: defaultPickerValue
	      });
	      var clearIcon = !disabled && allowClear && _this.state.value ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection,
	        theme: "filled"
	      }) : null;
	      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
	        suffixIcon: suffixIcon,
	        prefixCls: prefixCls
	      });
	
	      var input = function input(_ref2) {
	        var value = _ref2.value;
	        return (/*#__PURE__*/React.createElement("span", {
	            style: {
	              display: 'inline-block',
	              width: '100%'
	            }
	          }, /*#__PURE__*/React.createElement("input", {
	            ref: _this.saveInput,
	            disabled: disabled,
	            readOnly: true,
	            value: value && value.format(format) || '',
	            placeholder: placeholder,
	            className: pickerInputClass,
	            onFocus: onFocus,
	            onBlur: onBlur
	          }), clearIcon, inputIcon)
	        );
	      };
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])(className, pickerClass),
	          style: style,
	          id: id
	        }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, _this.props, {
	          calendar: calendar,
	          prefixCls: "".concat(prefixCls, "-picker-container"),
	          value: pickerValue,
	          onChange: _this.handleChange,
	          open: open,
	          onOpenChange: _this.handleOpenChange,
	          style: popupStyle
	        }), input))
	      );
	    };
	
	    var value = props.value || props.defaultValue;
	
	    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of WeekPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	    }
	
	    _this.state = {
	      value: value,
	      open: props.open
	    };
	    return _this;
	  }
	
	  _createClass(WeekPicker, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      if (!('open' in this.props) && prevState.open && !this.state.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWeekPicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps || 'open' in nextProps) {
	        var state = {};
	
	        if ('value' in nextProps) {
	          state.value = nextProps.value;
	        }
	
	        if ('open' in nextProps) {
	          state.open = nextProps.open;
	        }
	
	        return state;
	      }
	
	      return null;
	    }
	  }]);
	
	  return WeekPicker;
	}(React.Component);
	
	WeekPicker.defaultProps = {
	  format: 'gggg-wo',
	  allowClear: true
	};
	(0, _reactLifecyclesCompat.polyfill)(WeekPicker);
	var _default = WeekPicker;
	exports["default"] = _default;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createPicker;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _MonthCalendar = _interopRequireDefault(__webpack_require__(185));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(551));
	
	var _utils = __webpack_require__(564);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function createPicker(TheCalendar) {
	  var CalenderWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(CalenderWrapper, _React$Component);
	
	    var _super = _createSuper(CalenderWrapper);
	
	    function CalenderWrapper(props) {
	      var _this;
	
	      _classCallCheck(this, CalenderWrapper);
	
	      _this = _super.call(this, props);
	
	      _this.saveInput = function (node) {
	        _this.input = node;
	      };
	
	      _this.clearSelection = function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        _this.handleChange(null);
	      };
	
	      _this.handleChange = function (value) {
	        var _assertThisInitialize = _assertThisInitialized(_this),
	            props = _assertThisInitialize.props;
	
	        if (!('value' in props)) {
	          _this.setState({
	            value: value,
	            showDate: value
	          });
	        }
	
	        props.onChange(value, (0, _utils.formatDate)(value, props.format));
	      };
	
	      _this.handleCalendarChange = function (value) {
	        _this.setState({
	          showDate: value
	        });
	      };
	
	      _this.handleOpenChange = function (open) {
	        var onOpenChange = _this.props.onOpenChange;
	
	        if (!('open' in _this.props)) {
	          _this.setState({
	            open: open
	          });
	        }
	
	        if (onOpenChange) {
	          onOpenChange(open);
	        }
	      };
	
	      _this.renderFooter = function () {
	        var renderExtraFooter = _this.props.renderExtraFooter;
	
	        var _assertThisInitialize2 = _assertThisInitialized(_this),
	            prefixCls = _assertThisInitialize2.prefixCls;
	
	        return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-footer-extra")
	        }, renderExtraFooter.apply(void 0, arguments)) : null;
	      };
	
	      _this.renderPicker = function (_ref) {
	        var _classNames, _classNames2;
	
	        var getPrefixCls = _ref.getPrefixCls;
	        var _this$state = _this.state,
	            value = _this$state.value,
	            showDate = _this$state.showDate,
	            open = _this$state.open;
	        var props = (0, _omit["default"])(_this.props, ['onChange']);
	        var customizePrefixCls = props.prefixCls,
	            locale = props.locale,
	            localeCode = props.localeCode,
	            suffixIcon = props.suffixIcon;
	        var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
	        // Have to add prefixCls on the instance.
	        // https://github.com/facebook/react/issues/12397
	
	        _this.prefixCls = prefixCls;
	        var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
	        var disabledTime = props.showTime ? props.disabledTime : null;
	        var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), props.showTime), _defineProperty(_classNames, "".concat(prefixCls, "-month"), _MonthCalendar["default"] === TheCalendar), _classNames));
	
	        if (value && localeCode) {
	          value.locale(localeCode);
	        }
	
	        var pickerProps = {};
	        var calendarProps = {};
	        var pickerStyle = {};
	
	        if (props.showTime) {
	          calendarProps = {
	            // fix https://github.com/ant-design/ant-design/issues/1902
	            onSelect: _this.handleChange
	          };
	          pickerStyle.minWidth = 195;
	        } else {
	          pickerProps = {
	            onChange: _this.handleChange
	          };
	        }
	
	        if ('mode' in props) {
	          calendarProps.mode = props.mode;
	        }
	
	        (0, _warning["default"])(!('onOK' in props), 'DatePicker', 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
	        var calendar = /*#__PURE__*/React.createElement(TheCalendar, _extends({}, calendarProps, {
	          disabledDate: props.disabledDate,
	          disabledTime: disabledTime,
	          locale: locale.lang,
	          timePicker: props.timePicker,
	          defaultValue: props.defaultPickerValue || (0, _interopDefault["default"])(moment)(),
	          dateInputPlaceholder: placeholder,
	          prefixCls: prefixCls,
	          className: calendarClassName,
	          onOk: props.onOk,
	          dateRender: props.dateRender,
	          format: props.format,
	          showToday: props.showToday,
	          monthCellContentRender: props.monthCellContentRender,
	          renderFooter: _this.renderFooter,
	          onPanelChange: props.onPanelChange,
	          onChange: _this.handleCalendarChange,
	          value: showDate
	        }));
	        var clearIcon = !props.disabled && props.allowClear && value ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          className: "".concat(prefixCls, "-picker-clear"),
	          onClick: _this.clearSelection,
	          theme: "filled"
	        }) : null;
	        var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-icon"), true), _classNames2))
	        }) : /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-picker-icon")
	        }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "calendar",
	          className: "".concat(prefixCls, "-picker-icon")
	        });
	        var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(props);
	
	        var input = function input(_ref2) {
	          var inputValue = _ref2.value;
	          return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
	              ref: _this.saveInput,
	              disabled: props.disabled,
	              readOnly: true,
	              value: (0, _utils.formatDate)(inputValue, props.format),
	              placeholder: placeholder,
	              className: props.pickerInputClass,
	              tabIndex: props.tabIndex,
	              name: props.name
	            }, dataOrAriaProps)), clearIcon, inputIcon)
	          );
	        };
	
	        return (/*#__PURE__*/React.createElement("span", {
	            id: props.id,
	            className: (0, _classnames["default"])(props.className, props.pickerClass),
	            style: _extends(_extends({}, pickerStyle), props.style),
	            onFocus: props.onFocus,
	            onBlur: props.onBlur,
	            onMouseEnter: props.onMouseEnter,
	            onMouseLeave: props.onMouseLeave
	          }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerProps, {
	            calendar: calendar,
	            value: value,
	            prefixCls: "".concat(prefixCls, "-picker-container"),
	            style: props.popupStyle,
	            open: open,
	            onOpenChange: _this.handleOpenChange
	          }), input))
	        );
	      };
	
	      var value = props.value || props.defaultValue;
	
	      if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	        throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	      }
	
	      _this.state = {
	        value: value,
	        showDate: value,
	        open: false
	      };
	      return _this;
	    }
	
	    _createClass(CalenderWrapper, [{
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(_, prevState) {
	        if (!('open' in this.props) && prevState.open && !this.state.open) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.input.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.input.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPicker)
	        );
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(nextProps, prevState) {
	        var state = {};
	        var open = prevState.open;
	
	        if ('open' in nextProps) {
	          state.open = nextProps.open;
	          open = nextProps.open || false;
	        }
	
	        if ('value' in nextProps) {
	          state.value = nextProps.value;
	
	          if (nextProps.value !== prevState.value || !open && nextProps.value !== prevState.showDate) {
	            state.showDate = nextProps.value;
	          }
	        }
	
	        return Object.keys(state).length > 0 ? state : null;
	      }
	    }]);
	
	    return CalenderWrapper;
	  }(React.Component);
	
	  CalenderWrapper.defaultProps = {
	    allowClear: true,
	    showToday: true
	  };
	  (0, _reactLifecyclesCompat.polyfill)(CalenderWrapper);
	  return CalenderWrapper;
	}

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _rcCalendar = _interopRequireDefault(__webpack_require__(186));
	
	var _MonthCalendar = _interopRequireDefault(__webpack_require__(185));
	
	var _createPicker = _interopRequireDefault(__webpack_require__(1037));
	
	var _wrapPicker = _interopRequireDefault(__webpack_require__(1039));
	
	var _RangePicker = _interopRequireDefault(__webpack_require__(1035));
	
	var _WeekPicker = _interopRequireDefault(__webpack_require__(1036));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var DatePicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_rcCalendar["default"]), 'date');
	var MonthPicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_MonthCalendar["default"]), 'month');
	
	_extends(DatePicker, {
	  RangePicker: (0, _wrapPicker["default"])(_RangePicker["default"], 'date'),
	  MonthPicker: MonthPicker,
	  WeekPicker: (0, _wrapPicker["default"])(_WeekPicker["default"], 'week')
	});
	
	var _default = DatePicker;
	exports["default"] = _default;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapPicker;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _Panel = _interopRequireDefault(__webpack_require__(505));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _en_US = _interopRequireDefault(__webpack_require__(293));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _timePicker = __webpack_require__(582);
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var DEFAULT_FORMAT = {
	  date: 'YYYY-MM-DD',
	  dateTime: 'YYYY-MM-DD HH:mm:ss',
	  week: 'gggg-wo',
	  month: 'YYYY-MM'
	};
	var LOCALE_FORMAT_MAPPING = {
	  date: 'dateFormat',
	  dateTime: 'dateTimeFormat',
	  week: 'weekFormat',
	  month: 'monthFormat'
	};
	
	function getColumns(_ref) {
	  var showHour = _ref.showHour,
	      showMinute = _ref.showMinute,
	      showSecond = _ref.showSecond,
	      use12Hours = _ref.use12Hours;
	  var column = 0;
	
	  if (showHour) {
	    column += 1;
	  }
	
	  if (showMinute) {
	    column += 1;
	  }
	
	  if (showSecond) {
	    column += 1;
	  }
	
	  if (use12Hours) {
	    column += 1;
	  }
	
	  return column;
	}
	
	function checkValidate(value, propName) {
	  var values = Array.isArray(value) ? value : [value];
	  values.forEach(function (val) {
	    if (!val) return;
	    (0, _warning["default"])(!(0, _interopDefault["default"])(moment).isMoment(val) || val.isValid(), 'DatePicker', "`".concat(propName, "` provides invalidate moment time. If you want to set empty value, use `null` instead."));
	  });
	}
	
	function wrapPicker(Picker, pickerType) {
	  var PickerWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(PickerWrapper, _React$Component);
	
	    var _super = _createSuper(PickerWrapper);
	
	    function PickerWrapper() {
	      var _this;
	
	      _classCallCheck(this, PickerWrapper);
	
	      _this = _super.apply(this, arguments); // Since we need call `getDerivedStateFromProps` for check. Need leave an empty `state` here.
	
	      _this.state = {};
	
	      _this.savePicker = function (node) {
	        _this.picker = node;
	      };
	
	      _this.getDefaultLocale = function () {
	        var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	        result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
	        return result;
	      };
	
	      _this.handleOpenChange = function (open) {
	        var onOpenChange = _this.props.onOpenChange;
	        onOpenChange(open);
	      };
	
	      _this.handleFocus = function (e) {
	        var onFocus = _this.props.onFocus;
	
	        if (onFocus) {
	          onFocus(e);
	        }
	      };
	
	      _this.handleBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        if (onMouseEnter) {
	          onMouseEnter(e);
	        }
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	
	        if (onMouseLeave) {
	          onMouseLeave(e);
	        }
	      };
	
	      _this.renderPicker = function (locale, localeCode) {
	        var _this$props = _this.props,
	            format = _this$props.format,
	            showTime = _this$props.showTime;
	        var mergedPickerType = showTime ? "".concat(pickerType, "Time") : pickerType;
	        var mergedFormat = format || locale[LOCALE_FORMAT_MAPPING[mergedPickerType]] || DEFAULT_FORMAT[mergedPickerType];
	        return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	            var _classNames2;
	
	            var getPrefixCls = _ref2.getPrefixCls,
	                getContextPopupContainer = _ref2.getPopupContainer;
	            var _this$props2 = _this.props,
	                customizePrefixCls = _this$props2.prefixCls,
	                customizeInputPrefixCls = _this$props2.inputPrefixCls,
	                getCalendarContainer = _this$props2.getCalendarContainer,
	                size = _this$props2.size,
	                disabled = _this$props2.disabled;
	            var getPopupContainer = getCalendarContainer || getContextPopupContainer;
	            var prefixCls = getPrefixCls('calendar', customizePrefixCls);
	            var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	            var pickerClass = (0, _classnames["default"])("".concat(prefixCls, "-picker"), _defineProperty({}, "".concat(prefixCls, "-picker-").concat(size), !!size));
	            var pickerInputClass = (0, _classnames["default"])("".concat(prefixCls, "-picker-input"), inputPrefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-sm"), size === 'small'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames2));
	            var timeFormat = showTime && showTime.format || 'HH:mm:ss';
	
	            var rcTimePickerProps = _extends(_extends({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat)), {
	              format: timeFormat,
	              use12Hours: showTime && showTime.use12Hours
	            });
	
	            var columns = getColumns(rcTimePickerProps);
	            var timePickerCls = "".concat(prefixCls, "-time-picker-column-").concat(columns);
	            var timePicker = showTime ? /*#__PURE__*/React.createElement(_Panel["default"], _extends({}, rcTimePickerProps, showTime, {
	              prefixCls: "".concat(prefixCls, "-time-picker"),
	              className: timePickerCls,
	              placeholder: locale.timePickerLocale.placeholder,
	              transitionName: "slide-up",
	              onEsc: function onEsc() {}
	            })) : null;
	            return (/*#__PURE__*/React.createElement(Picker, _extends({}, _this.props, {
	                getCalendarContainer: getPopupContainer,
	                format: mergedFormat,
	                ref: _this.savePicker,
	                pickerClass: pickerClass,
	                pickerInputClass: pickerInputClass,
	                locale: locale,
	                localeCode: localeCode,
	                timePicker: timePicker,
	                onOpenChange: _this.handleOpenChange,
	                onFocus: _this.handleFocus,
	                onBlur: _this.handleBlur,
	                onMouseEnter: _this.handleMouseEnter,
	                onMouseLeave: _this.handleMouseLeave
	              }))
	            );
	          })
	        );
	      };
	
	      return _this;
	    }
	
	    _createClass(PickerWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this$props3 = this.props,
	            autoFocus = _this$props3.autoFocus,
	            disabled = _this$props3.disabled;
	
	        if (autoFocus && !disabled) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.picker.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.picker.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	            componentName: "DatePicker",
	            defaultLocale: this.getDefaultLocale
	          }, this.renderPicker)
	        );
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(_ref3) {
	        var value = _ref3.value,
	            defaultValue = _ref3.defaultValue;
	        checkValidate(defaultValue, 'defaultValue');
	        checkValidate(value, 'value');
	        return {};
	      }
	    }]);
	
	    return PickerWrapper;
	  }(React.Component);
	
	  PickerWrapper.defaultProps = {
	    transitionName: 'slide-up',
	    popupStyle: {},
	    onChange: function onChange() {},
	    onOk: function onOk() {},
	    onOpenChange: function onOpenChange() {},
	    locale: {}
	  };
	  (0, _reactLifecyclesCompat.polyfill)(PickerWrapper);
	  return PickerWrapper;
	}

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var Col = function Col(props) {
	  var _classNames;
	
	  var child = props.child,
	      bordered = props.bordered,
	      colon = props.colon,
	      type = props.type,
	      layout = props.layout;
	  var _child$props = child.props,
	      prefixCls = _child$props.prefixCls,
	      label = _child$props.label,
	      className = _child$props.className,
	      children = _child$props.children,
	      _child$props$span = _child$props.span,
	      span = _child$props$span === void 0 ? 1 : _child$props$span;
	  var labelProps = {
	    className: (0, _classnames["default"])("".concat(prefixCls, "-item-label"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-colon"), colon), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-label"), !label), _classNames)),
	    key: 'label'
	  };
	
	  if (layout === 'vertical') {
	    labelProps.colSpan = span * 2 - 1;
	  }
	
	  if (bordered) {
	    if (type === 'label') {
	      return (/*#__PURE__*/React.createElement("th", labelProps, label)
	      );
	    }
	
	    return (/*#__PURE__*/React.createElement("td", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item-content"), className),
	        key: "content",
	        colSpan: span * 2 - 1
	      }, children)
	    );
	  }
	
	  if (layout === 'vertical') {
	    if (type === 'content') {
	      return (/*#__PURE__*/React.createElement("td", {
	          colSpan: span,
	          className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	        }, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-item-content"),
	          key: "content"
	        }, children))
	      );
	    }
	
	    return (/*#__PURE__*/React.createElement("td", {
	        colSpan: span,
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	      }, /*#__PURE__*/React.createElement("span", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item-label"), _defineProperty({}, "".concat(prefixCls, "-item-colon"), colon)),
	        key: "label"
	      }, label))
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement("td", {
	      colSpan: span,
	      className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	    }, /*#__PURE__*/React.createElement("span", labelProps, label), /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-item-content"),
	      key: "content"
	    }, children))
	  );
	};
	
	var _default = Col;
	exports["default"] = _default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _responsiveObserve = _interopRequireWildcard(__webpack_require__(554));
	
	var _configProvider = __webpack_require__(13);
	
	var _Col = _interopRequireDefault(__webpack_require__(1040));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// https://github.com/smooth-code/react-flatten-children/
	function flattenChildren(children) {
	  if (!children) {
	    return [];
	  }
	
	  return (0, _toArray["default"])(children).reduce(function (flatChildren, child) {
	    if (child && child.type === React.Fragment) {
	      return flatChildren.concat(flattenChildren(child.props.children));
	    }
	
	    flatChildren.push(child);
	    return flatChildren;
	  }, []);
	}
	
	var DescriptionsItem = function DescriptionsItem(_ref) {
	  var children = _ref.children;
	  return children;
	};
	/**
	 * Convert children into `column` groups.
	 * @param children: DescriptionsItem
	 * @param column: number
	 */
	
	var generateChildrenRows = function generateChildrenRows(children, column) {
	  var rows = [];
	  var columns = null;
	  var leftSpans;
	  var itemNodes = flattenChildren(children);
	  itemNodes.forEach(function (node, index) {
	    var itemNode = node;
	
	    if (!columns) {
	      leftSpans = column;
	      columns = [];
	      rows.push(columns);
	    } // Always set last span to align the end of Descriptions
	
	
	    var lastItem = index === itemNodes.length - 1;
	    var lastSpanSame = true;
	
	    if (lastItem) {
	      lastSpanSame = !itemNode.props.span || itemNode.props.span === leftSpans;
	      itemNode = /*#__PURE__*/React.cloneElement(itemNode, {
	        span: leftSpans
	      });
	    } // Calculate left fill span
	
	
	    var _itemNode$props$span = itemNode.props.span,
	        span = _itemNode$props$span === void 0 ? 1 : _itemNode$props$span;
	    columns.push(itemNode);
	    leftSpans -= span;
	
	    if (leftSpans <= 0) {
	      columns = null;
	      (0, _warning["default"])(leftSpans === 0 && lastSpanSame, 'Descriptions', 'Sum of column `span` in a line exceeds `column` of Descriptions.');
	    }
	  });
	  return rows;
	};
	
	var renderRow = function renderRow(children, index, _ref2, bordered, layout, colon) {
	  var prefixCls = _ref2.prefixCls;
	
	  var renderCol = function renderCol(colItem, type, idx) {
	    return (/*#__PURE__*/React.createElement(_Col["default"], {
	        child: colItem,
	        bordered: bordered,
	        colon: colon,
	        type: type,
	        key: "".concat(type, "-").concat(colItem.key || idx),
	        layout: layout
	      })
	    );
	  };
	
	  var cloneChildren = [];
	  var cloneContentChildren = [];
	  flattenChildren(children).forEach(function (childrenItem, idx) {
	    cloneChildren.push(renderCol(childrenItem, 'label', idx));
	
	    if (layout === 'vertical') {
	      cloneContentChildren.push(renderCol(childrenItem, 'content', idx));
	    } else if (bordered) {
	      cloneChildren.push(renderCol(childrenItem, 'content', idx));
	    }
	  });
	
	  if (layout === 'vertical') {
	    return [/*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: "label-".concat(index)
	    }, cloneChildren), /*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: "content-".concat(index)
	    }, cloneContentChildren)];
	  }
	
	  return (/*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: index
	    }, cloneChildren)
	  );
	};
	
	var defaultColumnMap = {
	  xxl: 3,
	  xl: 3,
	  lg: 3,
	  md: 3,
	  sm: 2,
	  xs: 1
	};
	
	var Descriptions = /*#__PURE__*/function (_React$Component) {
	  _inherits(Descriptions, _React$Component);
	
	  var _super = _createSuper(Descriptions);
	
	  function Descriptions() {
	    var _this;
	
	    _classCallCheck(this, Descriptions);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      screens: {}
	    };
	    return _this;
	  }
	
	  _createClass(Descriptions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var column = this.props.column;
	      this.token = _responsiveObserve["default"].subscribe(function (screens) {
	        if (_typeof(column) !== 'object') {
	          return;
	        }
	
	        _this2.setState({
	          screens: screens
	        });
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _responsiveObserve["default"].unsubscribe(this.token);
	    }
	  }, {
	    key: "getColumn",
	    value: function getColumn() {
	      var column = this.props.column;
	
	      if (_typeof(column) === 'object') {
	        for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
	          var breakpoint = _responsiveObserve.responsiveArray[i];
	
	          if (this.state.screens[breakpoint] && column[breakpoint] !== undefined) {
	            return column[breakpoint] || defaultColumnMap[breakpoint];
	          }
	        }
	      } // If the configuration is not an object, it is a number, return number
	
	
	      if (typeof column === 'number') {
	        return column;
	      } // If it is an object, but no response is found, this happens only in the test.
	      // Maybe there are some strange environments
	
	
	      return 3;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
	          var _classNames;
	
	          var getPrefixCls = _ref3.getPrefixCls;
	          var _this3$props = _this3.props,
	              className = _this3$props.className,
	              customizePrefixCls = _this3$props.prefixCls,
	              title = _this3$props.title,
	              size = _this3$props.size,
	              children = _this3$props.children,
	              _this3$props$bordered = _this3$props.bordered,
	              bordered = _this3$props$bordered === void 0 ? false : _this3$props$bordered,
	              _this3$props$layout = _this3$props.layout,
	              layout = _this3$props$layout === void 0 ? 'horizontal' : _this3$props$layout,
	              _this3$props$colon = _this3$props.colon,
	              colon = _this3$props$colon === void 0 ? true : _this3$props$colon,
	              style = _this3$props.style;
	          var prefixCls = getPrefixCls('descriptions', customizePrefixCls);
	
	          var column = _this3.getColumn();
	
	          var cloneChildren = flattenChildren(children).map(function (child) {
	            if ( /*#__PURE__*/React.isValidElement(child)) {
	              return (/*#__PURE__*/React.cloneElement(child, {
	                  prefixCls: prefixCls
	                })
	              );
	            }
	
	            return null;
	          }).filter(function (node) {
	            return node;
	          });
	          var childrenArray = generateChildrenRows(cloneChildren, column);
	          return (/*#__PURE__*/React.createElement("div", {
	              className: (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), !!bordered), _classNames)),
	              style: style
	            }, title && /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-title")
	            }, title), /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-view")
	            }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, childrenArray.map(function (child, index) {
	              return renderRow(child, index, {
	                prefixCls: prefixCls
	              }, bordered, layout, colon);
	            })))))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Descriptions;
	}(React.Component);
	
	Descriptions.defaultProps = {
	  size: 'default',
	  column: defaultColumnMap
	};
	Descriptions.Item = DescriptionsItem;
	var _default = Descriptions;
	exports["default"] = _default;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Divider = function Divider(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          _props$type = props.type,
	          type = _props$type === void 0 ? 'horizontal' : _props$type,
	          _props$orientation = props.orientation,
	          orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
	          className = props.className,
	          children = props.children,
	          dashed = props.dashed,
	          restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed"]);
	
	      var prefixCls = getPrefixCls('divider', customizePrefixCls);
	      var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
	      var classString = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), children), _defineProperty(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), _classNames));
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString
	        }, restProps, {
	          role: "separator"
	        }), children && /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-inner-text")
	        }, children))
	      );
	    })
	  );
	};
	
	var _default = Divider;
	exports["default"] = _default;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcDrawer = _interopRequireDefault(__webpack_require__(464));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _context = __webpack_require__(231);
	
	var _type = __webpack_require__(78);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var DrawerContext = (0, _createReactContext["default"])(null);
	var PlacementTypes = (0, _type.tuple)('top', 'right', 'bottom', 'left');
	
	var Drawer = /*#__PURE__*/function (_React$Component) {
	  _inherits(Drawer, _React$Component);
	
	  var _super = _createSuper(Drawer);
	
	  function Drawer() {
	    var _this;
	
	    _classCallCheck(this, Drawer);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      push: false
	    };
	
	    _this.push = function () {
	      _this.setState({
	        push: true
	      });
	    };
	
	    _this.pull = function () {
	      _this.setState({
	        push: false
	      });
	    };
	
	    _this.onDestroyTransitionEnd = function () {
	      var isDestroyOnClose = _this.getDestroyOnClose();
	
	      if (!isDestroyOnClose) {
	        return;
	      }
	
	      if (!_this.props.visible) {
	        _this.destroyClose = true;
	
	        _this.forceUpdate();
	      }
	    };
	
	    _this.getDestroyOnClose = function () {
	      return _this.props.destroyOnClose && !_this.props.visible;
	    }; // get drawer push width or height
	
	
	    _this.getPushTransform = function (placement) {
	      if (placement === 'left' || placement === 'right') {
	        return "translateX(".concat(placement === 'left' ? 180 : -180, "px)");
	      }
	
	      if (placement === 'top' || placement === 'bottom') {
	        return "translateY(".concat(placement === 'top' ? 180 : -180, "px)");
	      }
	    };
	
	    _this.getRcDrawerStyle = function () {
	      var _this$props = _this.props,
	          zIndex = _this$props.zIndex,
	          placement = _this$props.placement,
	          style = _this$props.style;
	      var push = _this.state.push;
	      return _extends({
	        zIndex: zIndex,
	        transform: push ? _this.getPushTransform(placement) : undefined
	      }, style);
	    }; // render drawer body dom
	
	
	    _this.renderBody = function () {
	      var _this$props2 = _this.props,
	          bodyStyle = _this$props2.bodyStyle,
	          drawerStyle = _this$props2.drawerStyle,
	          prefixCls = _this$props2.prefixCls,
	          visible = _this$props2.visible;
	
	      if (_this.destroyClose && !visible) {
	        return null;
	      }
	
	      _this.destroyClose = false;
	      var containerStyle = {};
	
	      var isDestroyOnClose = _this.getDestroyOnClose();
	
	      if (isDestroyOnClose) {
	        // Increase the opacity transition, delete children after closing.
	        containerStyle.opacity = 0;
	        containerStyle.transition = 'opacity .3s';
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-wrapper-body"),
	          style: _extends(_extends({}, containerStyle), drawerStyle),
	          onTransitionEnd: _this.onDestroyTransitionEnd
	        }, _this.renderHeader(), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-body"),
	          style: bodyStyle
	        }, _this.props.children))
	      );
	    }; // render Provider for Multi-level drawer
	
	
	    _this.renderProvider = function (value) {
	      var _a = _this.props,
	          prefixCls = _a.prefixCls,
	          placement = _a.placement,
	          className = _a.className,
	          wrapClassName = _a.wrapClassName,
	          width = _a.width,
	          height = _a.height,
	          mask = _a.mask,
	          rest = __rest(_a, ["prefixCls", "placement", "className", "wrapClassName", "width", "height", "mask"]);
	
	      (0, _warning["default"])(wrapClassName === undefined, 'Drawer', 'wrapClassName is deprecated, please use className instead.');
	      var haveMask = mask ? '' : 'no-mask';
	      _this.parentDrawer = value;
	      var offsetStyle = {};
	
	      if (placement === 'left' || placement === 'right') {
	        offsetStyle.width = width;
	      } else {
	        offsetStyle.height = height;
	      }
	
	      return (/*#__PURE__*/React.createElement(DrawerContext.Provider, {
	          value: _assertThisInitialized(_this)
	        }, /*#__PURE__*/React.createElement(_rcDrawer["default"], _extends({
	          handler: false
	        }, (0, _omit["default"])(rest, ['zIndex', 'style', 'closable', 'destroyOnClose', 'drawerStyle', 'headerStyle', 'bodyStyle', 'title', 'push', 'visible', 'getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'pageHeader', 'autoInsertSpaceInButton']), offsetStyle, {
	          prefixCls: prefixCls,
	          open: _this.props.visible,
	          showMask: mask,
	          placement: placement,
	          style: _this.getRcDrawerStyle(),
	          className: (0, _classnames["default"])(wrapClassName, className, haveMask)
	        }), _this.renderBody()))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Drawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // fix: delete drawer in child and re-render, no push started.
	      // <Drawer>{show && <Drawer />}</Drawer>
	      var visible = this.props.visible;
	
	      if (visible && this.parentDrawer) {
	        this.parentDrawer.push();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(preProps) {
	      var visible = this.props.visible;
	
	      if (preProps.visible !== visible && this.parentDrawer) {
	        if (visible) {
	          this.parentDrawer.push();
	        } else {
	          this.parentDrawer.pull();
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // unmount drawer in child, clear push.
	      if (this.parentDrawer) {
	        this.parentDrawer.pull();
	        this.parentDrawer = null;
	      }
	    }
	  }, {
	    key: "renderHeader",
	    value: function renderHeader() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          prefixCls = _this$props3.prefixCls,
	          closable = _this$props3.closable,
	          headerStyle = _this$props3.headerStyle;
	
	      if (!title && !closable) {
	        return null;
	      }
	
	      var headerClassName = title ? "".concat(prefixCls, "-header") : "".concat(prefixCls, "-header-no-title");
	      return (/*#__PURE__*/React.createElement("div", {
	          className: headerClassName,
	          style: headerStyle
	        }, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), closable && this.renderCloseIcon())
	      );
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var _this$props4 = this.props,
	          closable = _this$props4.closable,
	          prefixCls = _this$props4.prefixCls,
	          onClose = _this$props4.onClose;
	      return closable &&
	      /*#__PURE__*/
	      // eslint-disable-next-line react/button-has-type
	      React.createElement("button", {
	        onClick: onClose,
	        "aria-label": "Close",
	        className: "".concat(prefixCls, "-close")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close"
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(DrawerContext.Consumer, null, this.renderProvider)
	      );
	    }
	  }]);
	
	  return Drawer;
	}(React.Component);
	
	Drawer.defaultProps = {
	  width: 256,
	  height: 256,
	  closable: true,
	  placement: 'right',
	  maskClosable: true,
	  mask: true,
	  level: null,
	  keyboard: true
	};
	
	var _default = (0, _context.withConfigConsumer)({
	  prefixCls: 'drawer'
	})(Drawer);
	
	exports["default"] = _default;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _button = _interopRequireDefault(__webpack_require__(135));
	
	var _configProvider = __webpack_require__(13);
	
	var _dropdown = _interopRequireDefault(__webpack_require__(294));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = _button["default"].Group;
	
	var DropdownButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(DropdownButton, _React$Component);
	
	  var _super = _createSuper(DropdownButton);
	
	  function DropdownButton() {
	    var _this;
	
	    _classCallCheck(this, DropdownButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderButton = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          onClick = _a.onClick,
	          htmlType = _a.htmlType,
	          children = _a.children,
	          className = _a.className,
	          overlay = _a.overlay,
	          trigger = _a.trigger,
	          align = _a.align,
	          visible = _a.visible,
	          onVisibleChange = _a.onVisibleChange,
	          placement = _a.placement,
	          getPopupContainer = _a.getPopupContainer,
	          href = _a.href,
	          _a$icon = _a.icon,
	          icon = _a$icon === void 0 ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "ellipsis"
	      }) : _a$icon,
	          title = _a.title,
	          restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title"]);
	
	      var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
	      var dropdownProps = {
	        align: align,
	        overlay: overlay,
	        disabled: disabled,
	        trigger: disabled ? [] : trigger,
	        onVisibleChange: onVisibleChange,
	        placement: placement,
	        getPopupContainer: getPopupContainer || getContextPopupContainer
	      };
	
	      if ('visible' in _this.props) {
	        dropdownProps.visible = visible;
	      }
	
	      return (/*#__PURE__*/React.createElement(ButtonGroup, _extends({}, restProps, {
	          className: (0, _classnames["default"])(prefixCls, className)
	        }), /*#__PURE__*/React.createElement(_button["default"], {
	          type: type,
	          disabled: disabled,
	          onClick: onClick,
	          htmlType: htmlType,
	          href: href,
	          title: title
	        }, children), /*#__PURE__*/React.createElement(_dropdown["default"], dropdownProps, /*#__PURE__*/React.createElement(_button["default"], {
	          type: type
	        }, icon)))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(DropdownButton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton)
	      );
	    }
	  }]);
	
	  return DropdownButton;
	}(React.Component);
	
	exports["default"] = DropdownButton;
	DropdownButton.defaultProps = {
	  placement: 'bottomRight',
	  type: 'default'
	};

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Empty = function Empty() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "184",
	      height: "152",
	      viewBox: "0 0 184 152",
	      xmlns: "http://www.w3.org/2000/svg"
	    }, /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(24 31.67)"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      fillOpacity: ".8",
	      fill: "#F5F5F7",
	      cx: "67.797",
	      cy: "106.89",
	      rx: "67.797",
	      ry: "12.668"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
	      fill: "#AEB8C2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
	      fill: "url(#linearGradient-1)",
	      transform: "translate(13.56)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
	      fill: "#F5F5F7"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
	      fill: "#DCE0E6"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
	      fill: "#DCE0E6"
	    }), /*#__PURE__*/React.createElement("g", {
	      transform: "translate(149.65 15.383)",
	      fill: "#FFF"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      cx: "20.654",
	      cy: "3.167",
	      rx: "2.849",
	      ry: "2.815"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
	    }))))
	  );
	};
	
	var _default = Empty;
	exports["default"] = _default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Simple = function Simple() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "64",
	      height: "41",
	      viewBox: "0 0 64 41",
	      xmlns: "http://www.w3.org/2000/svg"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 1)",
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      fill: "#F5F5F5",
	      cx: "32",
	      cy: "33",
	      rx: "32",
	      ry: "7"
	    }), /*#__PURE__*/React.createElement("g", {
	      fillRule: "nonzero",
	      stroke: "#D9D9D9"
	    }, /*#__PURE__*/React.createElement("path", {
	      d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
	      fill: "#FAFAFA"
	    }))))
	  );
	};
	
	var _default = Simple;
	exports["default"] = _default;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _createDOMForm = _interopRequireDefault(__webpack_require__(467));
	
	var _createFormField = _interopRequireDefault(__webpack_require__(502));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(13);
	
	var _type = __webpack_require__(78);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _FormItem = _interopRequireDefault(__webpack_require__(1048));
	
	var _constants = __webpack_require__(566);
	
	var _context = _interopRequireDefault(__webpack_require__(567));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var FormLayouts = (0, _type.tuple)('horizontal', 'inline', 'vertical');
	
	var Form = /*#__PURE__*/function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  var _super = _createSuper(Form);
	
	  function Form(props) {
	    var _this;
	
	    _classCallCheck(this, Form);
	
	    _this = _super.call(this, props);
	
	    _this.renderForm = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          hideRequiredMark = _this$props.hideRequiredMark,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          layout = _this$props.layout;
	      var prefixCls = getPrefixCls('form', customizePrefixCls);
	      var formClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-horizontal"), layout === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), layout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-inline"), layout === 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _classNames), className);
	      var formProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark', 'wrapperCol', 'labelAlign', 'labelCol', 'colon']);
	      return (/*#__PURE__*/React.createElement("form", _extends({}, formProps, {
	          className: formClassName
	        }))
	      );
	    };
	
	    (0, _warning["default"])(!props.form, 'Form', 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperCol = _this$props2.wrapperCol,
	          labelAlign = _this$props2.labelAlign,
	          labelCol = _this$props2.labelCol,
	          layout = _this$props2.layout,
	          colon = _this$props2.colon;
	      return (/*#__PURE__*/React.createElement(_context["default"].Provider, {
	          value: {
	            wrapperCol: wrapperCol,
	            labelAlign: labelAlign,
	            labelCol: labelCol,
	            vertical: layout === 'vertical',
	            colon: colon
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderForm))
	      );
	    }
	  }]);
	
	  return Form;
	}(React.Component);
	
	exports["default"] = Form;
	Form.defaultProps = {
	  colon: true,
	  layout: 'horizontal',
	  hideRequiredMark: false,
	  onSubmit: function onSubmit(e) {
	    e.preventDefault();
	  }
	};
	Form.propTypes = {
	  prefixCls: PropTypes.string,
	  layout: PropTypes.oneOf(FormLayouts),
	  children: PropTypes.any,
	  onSubmit: PropTypes.func,
	  hideRequiredMark: PropTypes.bool,
	  colon: PropTypes.bool
	};
	Form.Item = _FormItem["default"];
	Form.createFormField = _createFormField["default"];
	
	Form.create = function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return (0, _createDOMForm["default"])(_extends(_extends({
	    fieldNameProp: 'id'
	  }, options), {
	    fieldMetaProp: _constants.FIELD_META_PROP,
	    fieldDataProp: _constants.FIELD_DATA_PROP
	  }));
	};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _row = _interopRequireDefault(__webpack_require__(570));
	
	var _col = _interopRequireDefault(__webpack_require__(569));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _type = __webpack_require__(78);
	
	var _constants = __webpack_require__(566);
	
	var _context = _interopRequireDefault(__webpack_require__(567));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ValidateStatuses = (0, _type.tuple)('success', 'warning', 'error', 'validating', '');
	var FormLabelAligns = (0, _type.tuple)('left', 'right');
	
	function intersperseSpace(list) {
	  return list.reduce(function (current, item) {
	    return [].concat(_toConsumableArray(current), [' ', item]);
	  }, []).slice(1);
	}
	
	var FormItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(FormItem, _React$Component);
	
	  var _super = _createSuper(FormItem);
	
	  function FormItem() {
	    var _this;
	
	    _classCallCheck(this, FormItem);
	
	    _this = _super.apply(this, arguments);
	    _this.helpShow = false; // Resolve duplicated ids bug between different forms
	    // https://github.com/ant-design/ant-design/issues/7351
	
	    _this.onLabelClick = function () {
	      var id = _this.props.id || _this.getId();
	
	      if (!id) {
	        return;
	      }
	
	      var formItemNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var control = formItemNode.querySelector("[id=\"".concat(id, "\"]"));
	
	      if (control && control.focus) {
	        control.focus();
	      }
	    };
	
	    _this.onHelpAnimEnd = function (_key, helpShow) {
	      _this.helpShow = helpShow;
	
	      if (!helpShow) {
	        _this.setState({});
	      }
	    };
	
	    _this.renderFormItem = function (_ref) {
	      var _itemClassName;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          style = _a.style,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "style", "className"]);
	
	      var prefixCls = getPrefixCls('form', customizePrefixCls);
	
	      var children = _this.renderChildren(prefixCls);
	
	      var itemClassName = (_itemClassName = {}, _defineProperty(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-with-help"), _this.helpShow), _defineProperty(_itemClassName, "".concat(className), !!className), _itemClassName);
	      return (/*#__PURE__*/React.createElement(_row["default"], _extends({
	          className: (0, _classnames["default"])(itemClassName),
	          style: style
	        }, (0, _omit["default"])(restProps, ['id', 'htmlFor', 'label', 'labelAlign', 'labelCol', 'wrapperCol', 'help', 'extra', 'validateStatus', 'hasFeedback', 'required', 'colon']), {
	          key: "row"
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(FormItem, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          help = _this$props.help,
	          validateStatus = _this$props.validateStatus,
	          id = _this$props.id;
	      (0, _warning["default"])(this.getControls(children, true).length <= 1 || help !== undefined || validateStatus !== undefined, 'Form.Item', 'Cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
	      (0, _warning["default"])(!id, 'Form.Item', '`id` is deprecated for its label `htmlFor`. Please use `htmlFor` directly.');
	    }
	  }, {
	    key: "getHelpMessage",
	    value: function getHelpMessage() {
	      var help = this.props.help;
	
	      if (help === undefined && this.getOnlyControl()) {
	        var _this$getField = this.getField(),
	            errors = _this$getField.errors;
	
	        if (errors) {
	          return intersperseSpace(errors.map(function (e, index) {
	            var node = null;
	
	            if ( /*#__PURE__*/React.isValidElement(e)) {
	              node = e;
	            } else if ( /*#__PURE__*/React.isValidElement(e.message)) {
	              node = e.message;
	            } // eslint-disable-next-line react/no-array-index-key
	
	
	            return node ? /*#__PURE__*/React.cloneElement(node, {
	              key: index
	            }) : e.message;
	          }));
	        }
	
	        return '';
	      }
	
	      return help;
	    }
	  }, {
	    key: "getControls",
	    value: function getControls(children, recursively) {
	      var controls = [];
	      var childrenArray = React.Children.toArray(children);
	
	      for (var i = 0; i < childrenArray.length; i++) {
	        if (!recursively && controls.length > 0) {
	          break;
	        }
	
	        var child = childrenArray[i];
	
	        if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
	          continue;
	        }
	
	        if (!child.props) {
	          continue;
	        }
	
	        if (_constants.FIELD_META_PROP in child.props) {
	          // And means FIELD_DATA_PROP in child.props, too.
	          controls.push(child);
	        } else if (child.props.children) {
	          controls = controls.concat(this.getControls(child.props.children, recursively));
	        }
	      }
	
	      return controls;
	    }
	  }, {
	    key: "getOnlyControl",
	    value: function getOnlyControl() {
	      var child = this.getControls(this.props.children, false)[0];
	      return child !== undefined ? child : null;
	    }
	  }, {
	    key: "getChildProp",
	    value: function getChildProp(prop) {
	      var child = this.getOnlyControl();
	      return child && child.props && child.props[prop];
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.getChildProp('id');
	    }
	  }, {
	    key: "getMeta",
	    value: function getMeta() {
	      return this.getChildProp(_constants.FIELD_META_PROP);
	    }
	  }, {
	    key: "getField",
	    value: function getField() {
	      return this.getChildProp(_constants.FIELD_DATA_PROP);
	    }
	  }, {
	    key: "getValidateStatus",
	    value: function getValidateStatus() {
	      var onlyControl = this.getOnlyControl();
	
	      if (!onlyControl) {
	        return '';
	      }
	
	      var field = this.getField();
	
	      if (field.validating) {
	        return 'validating';
	      }
	
	      if (field.errors) {
	        return 'error';
	      }
	
	      var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;
	
	      if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
	        return 'success';
	      }
	
	      return '';
	    }
	  }, {
	    key: "isRequired",
	    value: function isRequired() {
	      var required = this.props.required;
	
	      if (required !== undefined) {
	        return required;
	      }
	
	      if (this.getOnlyControl()) {
	        var meta = this.getMeta() || {};
	        var validate = meta.validate || [];
	        return validate.filter(function (item) {
	          return !!item.rules;
	        }).some(function (item) {
	          return item.rules.some(function (rule) {
	            return rule.required;
	          });
	        });
	      }
	
	      return false;
	    }
	  }, {
	    key: "renderHelp",
	    value: function renderHelp(prefixCls) {
	      var help = this.getHelpMessage();
	      var children = help ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-explain"),
	        key: "help"
	      }, help) : null;
	
	      if (children) {
	        this.helpShow = !!children;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "show-help",
	          component: "",
	          transitionAppear: true,
	          key: "help",
	          onEnd: this.onHelpAnimEnd
	        }, children)
	      );
	    }
	  }, {
	    key: "renderExtra",
	    value: function renderExtra(prefixCls) {
	      var extra = this.props.extra;
	      return extra ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra")
	      }, extra) : null;
	    }
	  }, {
	    key: "renderValidateWrapper",
	    value: function renderValidateWrapper(prefixCls, c1, c2, c3) {
	      var props = this.props;
	      var onlyControl = this.getOnlyControl;
	      var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
	      var classes = "".concat(prefixCls, "-item-control");
	
	      if (validateStatus) {
	        classes = (0, _classnames["default"])("".concat(prefixCls, "-item-control"), {
	          'has-feedback': validateStatus && props.hasFeedback,
	          'has-success': validateStatus === 'success',
	          'has-warning': validateStatus === 'warning',
	          'has-error': validateStatus === 'error',
	          'is-validating': validateStatus === 'validating'
	        });
	      }
	
	      var iconType = '';
	
	      switch (validateStatus) {
	        case 'success':
	          iconType = 'check-circle';
	          break;
	
	        case 'warning':
	          iconType = 'exclamation-circle';
	          break;
	
	        case 'error':
	          iconType = 'close-circle';
	          break;
	
	        case 'validating':
	          iconType = 'loading';
	          break;
	
	        default:
	          iconType = '';
	          break;
	      }
	
	      var icon = props.hasFeedback && iconType ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-children-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType,
	        theme: iconType === 'loading' ? 'outlined' : 'filled'
	      })) : null;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: classes
	        }, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-item-children")
	        }, c1, icon), c2, c3)
	      );
	    }
	  }, {
	    key: "renderWrapper",
	    value: function renderWrapper(prefixCls, children) {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_context["default"].Consumer, {
	          key: "wrapper"
	        }, function (_ref2) {
	          var contextWrapperCol = _ref2.wrapperCol,
	              vertical = _ref2.vertical;
	          var wrapperCol = _this2.props.wrapperCol;
	          var mergedWrapperCol = ('wrapperCol' in _this2.props ? wrapperCol : contextWrapperCol) || {};
	          var className = (0, _classnames["default"])("".concat(prefixCls, "-item-control-wrapper"), mergedWrapperCol.className); // No pass FormContext since it's useless
	
	          return (/*#__PURE__*/React.createElement(_context["default"].Provider, {
	              value: {
	                vertical: vertical
	              }
	            }, /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedWrapperCol, {
	              className: className
	            }), children))
	          );
	        })
	      );
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel(prefixCls) {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_context["default"].Consumer, {
	          key: "label"
	        }, function (_ref3) {
	          var _classNames;
	
	          var vertical = _ref3.vertical,
	              contextLabelAlign = _ref3.labelAlign,
	              contextLabelCol = _ref3.labelCol,
	              contextColon = _ref3.colon;
	          var _this3$props = _this3.props,
	              label = _this3$props.label,
	              labelCol = _this3$props.labelCol,
	              labelAlign = _this3$props.labelAlign,
	              colon = _this3$props.colon,
	              id = _this3$props.id,
	              htmlFor = _this3$props.htmlFor;
	
	          var required = _this3.isRequired();
	
	          var mergedLabelCol = ('labelCol' in _this3.props ? labelCol : contextLabelCol) || {};
	          var mergedLabelAlign = 'labelAlign' in _this3.props ? labelAlign : contextLabelAlign;
	          var labelClsBasic = "".concat(prefixCls, "-item-label");
	          var labelColClassName = (0, _classnames["default"])(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className);
	          var labelChildren = label; // Keep label is original where there should have no colon
	
	          var computedColon = colon === true || contextColon !== false && colon !== false;
	          var haveColon = computedColon && !vertical; // Remove duplicated user input colon
	
	          if (haveColon && typeof label === 'string' && label.trim() !== '') {
	            labelChildren = label.replace(/[：:]\s*$/, '');
	          }
	
	          var labelClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-required"), required), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
	          return label ? /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedLabelCol, {
	            className: labelColClassName
	          }), /*#__PURE__*/React.createElement("label", {
	            htmlFor: htmlFor || id || _this3.getId(),
	            className: labelClassName,
	            title: typeof label === 'string' ? label : '',
	            onClick: _this3.onLabelClick
	          }, labelChildren)) : null;
	        })
	      );
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(prefixCls) {
	      var children = this.props.children;
	      return [this.renderLabel(prefixCls), this.renderWrapper(prefixCls, this.renderValidateWrapper(prefixCls, children, this.renderHelp(prefixCls), this.renderExtra(prefixCls)))];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderFormItem)
	      );
	    }
	  }]);
	
	  return FormItem;
	}(React.Component);
	
	exports["default"] = FormItem;
	FormItem.defaultProps = {
	  hasFeedback: false
	};
	FormItem.propTypes = {
	  prefixCls: PropTypes.string,
	  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	  labelCol: PropTypes.object,
	  help: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
	  validateStatus: PropTypes.oneOf(ValidateStatuses),
	  hasFeedback: PropTypes.bool,
	  wrapperCol: PropTypes.object,
	  className: PropTypes.string,
	  id: PropTypes.string,
	  children: PropTypes.node,
	  colon: PropTypes.bool
	};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Form = _interopRequireDefault(__webpack_require__(1047));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Form["default"];
	exports["default"] = _default;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = create;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _index = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var customCache = new Set();
	
	function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var scriptUrl = options.scriptUrl,
	      _options$extraCommonP = options.extraCommonProps,
	      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
	  /**
	   * DOM API required.
	   * Make sure in browser environment.
	   * The Custom Icon will create a <script/>
	   * that loads SVG symbols and insert the SVG Element into the document body.
	   */
	
	  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
	    var script = document.createElement('script');
	    script.setAttribute('src', scriptUrl);
	    script.setAttribute('data-namespace', scriptUrl);
	    customCache.add(scriptUrl);
	    document.body.appendChild(script);
	  }
	
	  var Iconfont = function Iconfont(props) {
	    var type = props.type,
	        children = props.children,
	        restProps = __rest(props, ["type", "children"]); // component > children > type
	
	
	    var content = null;
	
	    if (props.type) {
	      content = /*#__PURE__*/React.createElement("use", {
	        xlinkHref: "#".concat(type)
	      });
	    }
	
	    if (children) {
	      content = children;
	    }
	
	    return (/*#__PURE__*/React.createElement(_index["default"], _extends({}, extraCommonProps, restProps), content)
	    );
	  };
	
	  Iconfont.displayName = 'Iconfont';
	  return Iconfont;
	}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTwoToneColor = setTwoToneColor;
	exports.getTwoToneColor = getTwoToneColor;
	
	var _iconsReact = _interopRequireDefault(__webpack_require__(184));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function setTwoToneColor(primaryColor) {
	  return _iconsReact["default"].setTwoToneColors({
	    primaryColor: primaryColor
	  });
	}
	
	function getTwoToneColor() {
	  var colors = _iconsReact["default"].getTwoToneColors();
	
	  return colors.primaryColor;
	}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getThemeFromTypeName = getThemeFromTypeName;
	exports.removeTypeTheme = removeTypeTheme;
	exports.withThemeSuffix = withThemeSuffix;
	exports.alias = alias;
	exports.svgBaseProps = void 0;
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	// These props make sure that the SVG behaviours like general text.
	// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
	var svgBaseProps = {
	  width: '1em',
	  height: '1em',
	  fill: 'currentColor',
	  'aria-hidden': true,
	  focusable: 'false'
	};
	exports.svgBaseProps = svgBaseProps;
	var fillTester = /-fill$/;
	var outlineTester = /-o$/;
	var twoToneTester = /-twotone$/;
	
	function getThemeFromTypeName(type) {
	  var result = null;
	
	  if (fillTester.test(type)) {
	    result = 'filled';
	  } else if (outlineTester.test(type)) {
	    result = 'outlined';
	  } else if (twoToneTester.test(type)) {
	    result = 'twoTone';
	  }
	
	  return result;
	}
	
	function removeTypeTheme(type) {
	  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
	}
	
	function withThemeSuffix(type, theme) {
	  var result = type;
	
	  if (theme === 'filled') {
	    result += '-fill';
	  } else if (theme === 'outlined') {
	    result += '-o';
	  } else if (theme === 'twoTone') {
	    result += '-twotone';
	  } else {
	    (0, _warning["default"])(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
	  }
	
	  return result;
	} // For alias or compatibility
	
	
	function alias(type) {
	  var newType = type;
	
	  switch (type) {
	    case 'cross':
	      newType = 'close';
	      break;
	    // https://github.com/ant-design/ant-design/issues/13007
	
	    case 'interation':
	      newType = 'interaction';
	      break;
	    // https://github.com/ant-design/ant-design/issues/16810
	
	    case 'canlendar':
	      newType = 'calendar';
	      break;
	    // https://github.com/ant-design/ant-design/issues/17448
	
	    case 'colum-height':
	      newType = 'column-height';
	      break;
	
	    default:
	  }
	
	  (0, _warning["default"])(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
	  return newType;
	}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _rcInputNumber = _interopRequireDefault(__webpack_require__(468));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var InputNumber = /*#__PURE__*/function (_React$Component) {
	  _inherits(InputNumber, _React$Component);
	
	  var _super = _createSuper(InputNumber);
	
	  function InputNumber() {
	    var _this;
	
	    _classCallCheck(this, InputNumber);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInputNumber = function (inputNumberRef) {
	      _this.inputNumberRef = inputNumberRef;
	    };
	
	    _this.renderInputNumber = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          className = _a.className,
	          size = _a.size,
	          customizePrefixCls = _a.prefixCls,
	          others = __rest(_a, ["className", "size", "prefixCls"]);
	
	      var prefixCls = getPrefixCls('input-number', customizePrefixCls);
	      var inputNumberClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className);
	      var upIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "up",
	        className: "".concat(prefixCls, "-handler-up-inner")
	      });
	      var downIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-handler-down-inner")
	      });
	      return (/*#__PURE__*/React.createElement(_rcInputNumber["default"], _extends({
	          ref: _this.saveInputNumber,
	          className: inputNumberClass,
	          upHandler: upIcon,
	          downHandler: downIcon,
	          prefixCls: prefixCls
	        }, others))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(InputNumber, [{
	    key: "focus",
	    value: function focus() {
	      this.inputNumberRef.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.inputNumberRef.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderInputNumber)
	      );
	    }
	  }]);
	
	  return InputNumber;
	}(React.Component);
	
	exports["default"] = InputNumber;
	InputNumber.defaultProps = {
	  step: 1
	};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var Group = function Group(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var customizePrefixCls = props.prefixCls,
	          _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className;
	      var prefixCls = getPrefixCls('input-group', customizePrefixCls);
	      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
	      return (/*#__PURE__*/React.createElement("span", {
	          className: cls,
	          style: props.style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave,
	          onFocus: props.onFocus,
	          onBlur: props.onBlur
	        }, props.children)
	      );
	    })
	  );
	};
	
	var _default = Group;
	exports["default"] = _default;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Input = _interopRequireDefault(__webpack_require__(196));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ActionMap = {
	  click: 'onClick',
	  hover: 'onMouseOver'
	};
	
	var Password = /*#__PURE__*/function (_React$Component) {
	  _inherits(Password, _React$Component);
	
	  var _super = _createSuper(Password);
	
	  function Password() {
	    var _this;
	
	    _classCallCheck(this, Password);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      visible: false
	    };
	
	    _this.onVisibleChange = function () {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setState(function (_ref) {
	        var visible = _ref.visible;
	        return {
	          visible: !visible
	        };
	      });
	    };
	
	    _this.saveInput = function (instance) {
	      if (instance && instance.input) {
	        _this.input = instance.input;
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Password, [{
	    key: "getIcon",
	    value: function getIcon() {
	      var _iconProps;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          action = _this$props.action;
	      var iconTrigger = ActionMap[action] || '';
	      var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, this.onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "type", this.state.visible ? 'eye' : 'eye-invisible'), _defineProperty(_iconProps, "key", 'passwordIcon'), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
	        // Prevent focused state lost
	        // https://github.com/ant-design/ant-design/issues/15173
	        e.preventDefault();
	      }), _iconProps);
	      return (/*#__PURE__*/React.createElement(_icon["default"], iconProps)
	      );
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          inputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          visibilityToggle = _a.visibilityToggle,
	          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);
	
	      var suffixIcon = visibilityToggle && this.getIcon();
	      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	      return (/*#__PURE__*/React.createElement(_Input["default"], _extends({}, (0, _omit["default"])(restProps, ['suffix']), {
	          type: this.state.visible ? 'text' : 'password',
	          size: size,
	          className: inputClassName,
	          prefixCls: inputPrefixCls,
	          suffix: suffixIcon,
	          ref: this.saveInput
	        }))
	      );
	    }
	  }]);
	
	  return Password;
	}(React.Component);
	
	exports["default"] = Password;
	Password.defaultProps = {
	  inputPrefixCls: 'ant-input',
	  prefixCls: 'ant-input-password',
	  action: 'click',
	  visibilityToggle: true
	};

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(1058));
	
	var _raf = _interopRequireDefault(__webpack_require__(195));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ResizableTextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(ResizableTextArea, _React$Component);
	
	  var _super = _createSuper(ResizableTextArea);
	
	  function ResizableTextArea(props) {
	    var _this;
	
	    _classCallCheck(this, ResizableTextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (textArea) {
	      _this.textArea = textArea;
	    };
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.nextFrameActionId);
	
	      _this.nextFrameActionId = (0, _raf["default"])(_this.resizeTextarea);
	    };
	
	    _this.resizeTextarea = function () {
	      var autoSize = _this.props.autoSize || _this.props.autosize;
	
	      if (!autoSize || !_this.textArea) {
	        return;
	      }
	
	      var minRows = autoSize.minRows,
	          maxRows = autoSize.maxRows;
	      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textArea, false, minRows, maxRows);
	
	      _this.setState({
	        textareaStyles: textareaStyles,
	        resizing: true
	      }, function () {
	        _raf["default"].cancel(_this.resizeFrameId);
	
	        _this.resizeFrameId = (0, _raf["default"])(function () {
	          _this.setState({
	            resizing: false
	          });
	
	          _this.fixFirefoxAutoScroll();
	        });
	      });
	    };
	
	    _this.renderTextArea = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          autoSize = _this$props.autoSize,
	          autosize = _this$props.autosize,
	          className = _this$props.className,
	          disabled = _this$props.disabled;
	      var _this$state = _this.state,
	          textareaStyles = _this$state.textareaStyles,
	          resizing = _this$state.resizing;
	      (0, _warning["default"])(autosize === undefined, 'Input.TextArea', 'autosize is deprecated, please use autoSize instead.');
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'autosize', 'defaultValue', 'allowClear']);
	      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
	      // Make sure it could be reset when using form.getFieldDecorator
	
	      if ('value' in otherProps) {
	        otherProps.value = otherProps.value || '';
	      }
	
	      var style = _extends(_extends(_extends({}, _this.props.style), textareaStyles), resizing ? {
	        overflowX: 'hidden',
	        overflowY: 'hidden'
	      } : null);
	
	      return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: _this.resizeOnNextFrame,
	          disabled: !(autoSize || autosize)
	        }, /*#__PURE__*/React.createElement("textarea", _extends({}, otherProps, {
	          className: cls,
	          style: style,
	          ref: _this.saveTextArea
	        })))
	      );
	    };
	
	    _this.state = {
	      textareaStyles: {},
	      resizing: false
	    };
	    return _this;
	  }
	
	  _createClass(ResizableTextArea, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resizeTextarea();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // Re-render with the new content then recalculate the height as required.
	      if (prevProps.value !== this.props.value) {
	        this.resizeTextarea();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.nextFrameActionId);
	
	      _raf["default"].cancel(this.resizeFrameId);
	    } // https://github.com/ant-design/ant-design/issues/21870
	
	  }, {
	    key: "fixFirefoxAutoScroll",
	    value: function fixFirefoxAutoScroll() {
	      try {
	        if (document.activeElement === this.textArea) {
	          var currentStart = this.textArea.selectionStart;
	          var currentEnd = this.textArea.selectionEnd;
	          this.textArea.setSelectionRange(currentStart, currentEnd);
	        }
	      } catch (e) {// Fix error in Chrome:
	        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
	        // http://stackoverflow.com/q/21177489/3040605
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderTextArea();
	    }
	  }]);
	
	  return ResizableTextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ResizableTextArea);
	var _default = ResizableTextArea;
	exports["default"] = _default;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _isMobile = __webpack_require__(510);
	
	var _Input = _interopRequireDefault(__webpack_require__(196));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _button = _interopRequireDefault(__webpack_require__(135));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.onChange = function (e) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onSearch = _this$props.onSearch;
	
	      if (e && e.target && e.type === 'click' && onSearch) {
	        onSearch(e.target.value, e);
	      }
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.onSearch = function (e) {
	      var _this$props2 = _this.props,
	          onSearch = _this$props2.onSearch,
	          loading = _this$props2.loading,
	          disabled = _this$props2.disabled;
	
	      if (loading || disabled) {
	        return;
	      }
	
	      if (onSearch) {
	        onSearch(_this.input.input.value, e);
	      }
	
	      if (!(0, _isMobile.isMobile)({
	        tablet: true
	      })) {
	        _this.input.focus();
	      }
	    };
	
	    _this.renderLoading = function (prefixCls) {
	      var _this$props3 = _this.props,
	          enterButton = _this$props3.enterButton,
	          size = _this$props3.size;
	
	      if (enterButton) {
	        return (/*#__PURE__*/React.createElement(_button["default"], {
	            className: "".concat(prefixCls, "-button"),
	            type: "primary",
	            size: size,
	            key: "enterButton"
	          }, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading"
	          }))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          className: "".concat(prefixCls, "-icon"),
	          type: "loading",
	          key: "loadingIcon"
	        })
	      );
	    };
	
	    _this.renderSuffix = function (prefixCls) {
	      var _this$props4 = _this.props,
	          suffix = _this$props4.suffix,
	          enterButton = _this$props4.enterButton,
	          loading = _this$props4.loading;
	
	      if (loading && !enterButton) {
	        return [suffix, _this.renderLoading(prefixCls)];
	      }
	
	      if (enterButton) return suffix;
	      var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: "search",
	        key: "searchIcon",
	        onClick: _this.onSearch
	      });
	
	      if (suffix) {
	        return [/*#__PURE__*/React.isValidElement(suffix) ? /*#__PURE__*/React.cloneElement(suffix, {
	          key: 'suffix'
	        }) : null, icon];
	      }
	
	      return icon;
	    };
	
	    _this.renderAddonAfter = function (prefixCls) {
	      var _this$props5 = _this.props,
	          enterButton = _this$props5.enterButton,
	          size = _this$props5.size,
	          disabled = _this$props5.disabled,
	          addonAfter = _this$props5.addonAfter,
	          loading = _this$props5.loading;
	      var btnClassName = "".concat(prefixCls, "-button");
	
	      if (loading && enterButton) {
	        return [_this.renderLoading(prefixCls), addonAfter];
	      }
	
	      if (!enterButton) return addonAfter;
	      var button;
	      var enterButtonAsElement = enterButton;
	      var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
	
	      if (isAntdButton || enterButtonAsElement.type === 'button') {
	        button = /*#__PURE__*/React.cloneElement(enterButtonAsElement, _extends({
	          onClick: _this.onSearch,
	          key: 'enterButton'
	        }, isAntdButton ? {
	          className: btnClassName,
	          size: size
	        } : {}));
	      } else {
	        button = /*#__PURE__*/React.createElement(_button["default"], {
	          className: btnClassName,
	          type: "primary",
	          size: size,
	          disabled: disabled,
	          key: "enterButton",
	          onClick: _this.onSearch
	        }, enterButton === true ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "search"
	        }) : enterButton);
	      }
	
	      if (addonAfter) {
	        return [button, /*#__PURE__*/React.isValidElement(addonAfter) ? /*#__PURE__*/React.cloneElement(addonAfter, {
	          key: 'addonAfter'
	        }) : null];
	      }
	
	      return button;
	    };
	
	    _this.renderSearch = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeInputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          enterButton = _a.enterButton,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "inputPrefixCls", "size", "enterButton", "className"]);
	
	      delete restProps.onSearch;
	      delete restProps.loading;
	      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var inputClassName;
	
	      if (enterButton) {
	        var _classNames;
	
	        inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
	      } else {
	        inputClassName = (0, _classnames["default"])(prefixCls, className);
	      }
	
	      return (/*#__PURE__*/React.createElement(_Input["default"], _extends({
	          onPressEnter: _this.onSearch
	        }, restProps, {
	          size: size,
	          prefixCls: inputPrefixCls,
	          addonAfter: _this.renderAddonAfter(prefixCls),
	          suffix: _this.renderSuffix(prefixCls),
	          onChange: _this.onChange,
	          ref: _this.saveInput,
	          className: inputClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch)
	      );
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  enterButton: false
	};

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateNodeStyling = calculateNodeStyling;
	exports["default"] = calculateNodeHeight;
	// Thanks to https://github.com/andreypopp/react-textarea-autosize/
	
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	var computedStyleCache = {};
	var hiddenTextarea;
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	  var sizingStyle = SIZING_STYLE.map(function (name) {
	    return "".concat(name, ":").concat(style.getPropertyValue(name));
	  }).join(';');
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  } // Fix wrap="off" issue
	  // https://github.com/ant-design/ant-design/issues/6577
	
	
	  if (uiTextNode.getAttribute('wrap')) {
	    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
	  } else {
	    hiddenTextarea.removeAttribute('wrap');
	  } // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	
	  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
	  var minHeight = Number.MIN_SAFE_INTEGER;
	  var maxHeight = Number.MAX_SAFE_INTEGER;
	  var height = hiddenTextarea.scrollHeight;
	  var overflowY;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height += borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height -= paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = ' ';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	
	      height = Math.max(minHeight, height);
	    }
	
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	
	      overflowY = height > maxHeight ? '' : 'hidden';
	      height = Math.min(maxHeight, height);
	    }
	  }
	
	  return {
	    height: height,
	    minHeight: minHeight,
	    maxHeight: maxHeight,
	    overflowY: overflowY
	  };
	}

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _layout = _interopRequireDefault(__webpack_require__(573));
	
	var _Sider = _interopRequireDefault(__webpack_require__(297));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_layout["default"].Sider = _Sider["default"];
	var _default = _layout["default"];
	exports["default"] = _default;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Meta = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _grid = __webpack_require__(232);
	
	var _configProvider = __webpack_require__(13);
	
	var _reactNode = __webpack_require__(553);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Meta = function Meta(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          avatar = props.avatar,
	          title = props.title,
	          description = props.description,
	          others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-item-meta"), className);
	      var content = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-meta-content")
	      }, title && /*#__PURE__*/React.createElement("h4", {
	        className: "".concat(prefixCls, "-item-meta-title")
	      }, title), description && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-meta-description")
	      }, description));
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }), avatar && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-meta-avatar")
	        }, avatar), (title || description) && content)
	      );
	    })
	  );
	};
	
	exports.Meta = Meta;
	
	function getGrid(grid, t) {
	  return grid[t] && Math.floor(24 / grid[t]);
	}
	
	var Item = /*#__PURE__*/function (_React$Component) {
	  _inherits(Item, _React$Component);
	
	  var _super = _createSuper(Item);
	
	  function Item() {
	    var _this;
	
	    _classCallCheck(this, Item);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderItem = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	      var _this$context = _this.context,
	          grid = _this$context.grid,
	          itemLayout = _this$context.itemLayout;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          children = _a.children,
	          actions = _a.actions,
	          extra = _a.extra,
	          className = _a.className,
	          others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var actionsContent = actions && actions.length > 0 && /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-item-action"),
	        key: "actions"
	      }, actions.map(function (action, i) {
	        return (
	          /*#__PURE__*/
	          // eslint-disable-next-line react/no-array-index-key
	          React.createElement("li", {
	            key: "".concat(prefixCls, "-item-action-").concat(i)
	          }, action, i !== actions.length - 1 && /*#__PURE__*/React.createElement("em", {
	            className: "".concat(prefixCls, "-item-action-split")
	          }))
	        );
	      }));
	      var Tag = grid ? 'div' : 'li';
	      var itemChildren = /*#__PURE__*/React.createElement(Tag, _extends({}, others, {
	        // `li` element `onCopy` prop args is not same as `div`
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className, _defineProperty({}, "".concat(prefixCls, "-item-no-flex"), !_this.isFlexMode()))
	      }), itemLayout === 'vertical' && extra ? [/*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-main"),
	        key: "content"
	      }, children, actionsContent), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-extra"),
	        key: "extra"
	      }, extra)] : [children, actionsContent, (0, _reactNode.cloneElement)(extra, {
	        key: 'extra'
	      })]);
	      return grid ? /*#__PURE__*/React.createElement(_grid.Col, {
	        span: getGrid(grid, 'column'),
	        xs: getGrid(grid, 'xs'),
	        sm: getGrid(grid, 'sm'),
	        md: getGrid(grid, 'md'),
	        lg: getGrid(grid, 'lg'),
	        xl: getGrid(grid, 'xl'),
	        xxl: getGrid(grid, 'xxl')
	      }, itemChildren) : itemChildren;
	    };
	
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: "isItemContainsTextNodeAndNotSingular",
	    value: function isItemContainsTextNodeAndNotSingular() {
	      var children = this.props.children;
	      var result;
	      React.Children.forEach(children, function (element) {
	        if (typeof element === 'string') {
	          result = true;
	        }
	      });
	      return result && React.Children.count(children) > 1;
	    }
	  }, {
	    key: "isFlexMode",
	    value: function isFlexMode() {
	      var extra = this.props.extra;
	      var itemLayout = this.context.itemLayout;
	
	      if (itemLayout === 'vertical') {
	        return !!extra;
	      }
	
	      return !this.isItemContainsTextNodeAndNotSingular();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderItem)
	      );
	    }
	  }]);
	
	  return Item;
	}(React.Component);
	
	exports["default"] = Item;
	Item.Meta = Meta;
	Item.contextTypes = {
	  grid: PropTypes.any,
	  itemLayout: PropTypes.string
	};

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _spin = _interopRequireDefault(__webpack_require__(235));
	
	var _configProvider = __webpack_require__(13);
	
	var _pagination = _interopRequireDefault(__webpack_require__(301));
	
	var _grid = __webpack_require__(232);
	
	var _Item = _interopRequireDefault(__webpack_require__(1060));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var List = /*#__PURE__*/function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  var _super = _createSuper(List);
	
	  function List(props) {
	    var _this;
	
	    _classCallCheck(this, List);
	
	    _this = _super.call(this, props);
	    _this.defaultPaginationProps = {
	      current: 1,
	      total: 0
	    };
	    _this.keys = {};
	    _this.onPaginationChange = _this.triggerPaginationEvent('onChange');
	    _this.onPaginationShowSizeChange = _this.triggerPaginationEvent('onShowSizeChange');
	
	    _this.renderItem = function (item, index) {
	      var _this$props = _this.props,
	          renderItem = _this$props.renderItem,
	          rowKey = _this$props.rowKey;
	      if (!renderItem) return null;
	      var key;
	
	      if (typeof rowKey === 'function') {
	        key = rowKey(item);
	      } else if (typeof rowKey === 'string') {
	        key = item[rowKey];
	      } else {
	        key = item.key;
	      }
	
	      if (!key) {
	        key = "list-item-".concat(index);
	      }
	
	      _this.keys[index] = key;
	      return renderItem(item, index);
	    };
	
	    _this.renderEmpty = function (prefixCls, renderEmpty) {
	      var locale = _this.props.locale;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-empty-text")
	        }, locale && locale.emptyText || renderEmpty('List'))
	      );
	    };
	
	    _this.renderList = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	      var _this$state = _this.state,
	          paginationCurrent = _this$state.paginationCurrent,
	          paginationSize = _this$state.paginationSize;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          bordered = _a.bordered,
	          split = _a.split,
	          className = _a.className,
	          children = _a.children,
	          itemLayout = _a.itemLayout,
	          loadMore = _a.loadMore,
	          pagination = _a.pagination,
	          grid = _a.grid,
	          _a$dataSource = _a.dataSource,
	          dataSource = _a$dataSource === void 0 ? [] : _a$dataSource,
	          size = _a.size,
	          header = _a.header,
	          footer = _a.footer,
	          loading = _a.loading,
	          rest = __rest(_a, ["prefixCls", "bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "grid", "dataSource", "size", "header", "footer", "loading"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var loadingProp = loading;
	
	      if (typeof loadingProp === 'boolean') {
	        loadingProp = {
	          spinning: loadingProp
	        };
	      }
	
	      var isLoading = loadingProp && loadingProp.spinning; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-split"), split), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), isLoading), _defineProperty(_classNames, "".concat(prefixCls, "-grid"), grid), _defineProperty(_classNames, "".concat(prefixCls, "-something-after-last-item"), _this.isSomethingAfterLastItem()), _classNames));
	
	      var paginationProps = _extends(_extends(_extends({}, _this.defaultPaginationProps), {
	        total: dataSource.length,
	        current: paginationCurrent,
	        pageSize: paginationSize
	      }), pagination || {});
	
	      var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
	
	      if (paginationProps.current > largestPage) {
	        paginationProps.current = largestPage;
	      }
	
	      var paginationContent = pagination ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-pagination")
	      }, /*#__PURE__*/React.createElement(_pagination["default"], _extends({}, paginationProps, {
	        onChange: _this.onPaginationChange,
	        onShowSizeChange: _this.onPaginationShowSizeChange
	      }))) : null;
	
	      var splitDataSource = _toConsumableArray(dataSource);
	
	      if (pagination) {
	        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
	          splitDataSource = _toConsumableArray(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
	        }
	      }
	
	      var childrenContent;
	      childrenContent = isLoading && /*#__PURE__*/React.createElement("div", {
	        style: {
	          minHeight: 53
	        }
	      });
	
	      if (splitDataSource.length > 0) {
	        var items = splitDataSource.map(function (item, index) {
	          return _this.renderItem(item, index);
	        });
	        var childrenList = [];
	        React.Children.forEach(items, function (child, index) {
	          childrenList.push( /*#__PURE__*/React.cloneElement(child, {
	            key: _this.keys[index]
	          }));
	        });
	        childrenContent = grid ? /*#__PURE__*/React.createElement(_grid.Row, {
	          gutter: grid.gutter
	        }, childrenList) : /*#__PURE__*/React.createElement("ul", {
	          className: "".concat(prefixCls, "-items")
	        }, childrenList);
	      } else if (!children && !isLoading) {
	        childrenContent = _this.renderEmpty(prefixCls, renderEmpty);
	      }
	
	      var paginationPosition = paginationProps.position || 'bottom';
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString
	        }, (0, _omit["default"])(rest, ['rowKey', 'renderItem', 'locale'])), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-header")
	        }, header), /*#__PURE__*/React.createElement(_spin["default"], loadingProp, childrenContent, children), footer && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-footer")
	        }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent)
	      );
	    };
	
	    var pagination = props.pagination;
	    var paginationObj = pagination && _typeof(pagination) === 'object' ? pagination : {};
	    _this.state = {
	      paginationCurrent: paginationObj.defaultCurrent || 1,
	      paginationSize: paginationObj.defaultPageSize || 10
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        grid: this.props.grid,
	        itemLayout: this.props.itemLayout
	      };
	    }
	  }, {
	    key: "triggerPaginationEvent",
	    value: function triggerPaginationEvent(eventName) {
	      var _this2 = this;
	
	      return function (page, pageSize) {
	        var pagination = _this2.props.pagination;
	
	        _this2.setState({
	          paginationCurrent: page,
	          paginationSize: pageSize
	        });
	
	        if (pagination && pagination[eventName]) {
	          pagination[eventName](page, pageSize);
	        }
	      };
	    }
	  }, {
	    key: "isSomethingAfterLastItem",
	    value: function isSomethingAfterLastItem() {
	      var _this$props2 = this.props,
	          loadMore = _this$props2.loadMore,
	          pagination = _this$props2.pagination,
	          footer = _this$props2.footer;
	      return !!(loadMore || pagination || footer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderList)
	      );
	    }
	  }]);
	
	  return List;
	}(React.Component);
	
	exports["default"] = List;
	List.Item = _Item["default"];
	List.childContextTypes = {
	  grid: PropTypes.any,
	  itemLayout: PropTypes.string
	};
	List.defaultProps = {
	  dataSource: [],
	  bordered: false,
	  split: true,
	  loading: false,
	  pagination: false
	};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _default2 = _interopRequireDefault(__webpack_require__(152));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _default2["default"];
	exports["default"] = _default;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcEditorMention = _interopRequireWildcard(__webpack_require__(466));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Mention = /*#__PURE__*/function (_React$Component) {
	  _inherits(Mention, _React$Component);
	
	  var _super = _createSuper(Mention);
	
	  function Mention(props) {
	    var _this;
	
	    _classCallCheck(this, Mention);
	
	    _this = _super.call(this, props);
	
	    _this.mentionRef = function (ele) {
	      _this.mentionEle = ele;
	    };
	
	    _this.onSearchChange = function (value, prefix) {
	      if (_this.props.onSearchChange) {
	        return _this.props.onSearchChange(value, prefix);
	      }
	
	      return _this.defaultSearchChange(value);
	    };
	
	    _this.onChange = function (editorState) {
	      if (_this.props.onChange) {
	        _this.props.onChange(editorState);
	      }
	    };
	
	    _this.onFocus = function (ev) {
	      _this.setState({
	        focus: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(ev);
	      }
	    };
	
	    _this.onBlur = function (ev) {
	      _this.setState({
	        focus: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(ev);
	      }
	    };
	
	    _this.focus = function () {
	      _this.mentionEle._editor.focusEditor();
	    };
	
	    _this.renderMention = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          loading = _this$props.loading,
	          placement = _this$props.placement,
	          suggestions = _this$props.suggestions;
	      var _this$state = _this.state,
	          filteredSuggestions = _this$state.filteredSuggestions,
	          focus = _this$state.focus;
	      var prefixCls = getPrefixCls('mention', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-active"), focus), _defineProperty(_classNames, "".concat(prefixCls, "-placement-top"), placement === 'top'), _classNames));
	      var notFoundContent = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "loading"
	      }) : _this.props.notFoundContent;
	      return (/*#__PURE__*/React.createElement(_rcEditorMention["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: cls,
	          ref: _this.mentionRef,
	          onSearchChange: _this.onSearchChange,
	          onChange: _this.onChange,
	          onFocus: _this.onFocus,
	          onBlur: _this.onBlur,
	          suggestions: suggestions || filteredSuggestions,
	          notFoundContent: notFoundContent
	        }))
	      );
	    };
	
	    _this.state = {
	      filteredSuggestions: props.defaultSuggestions,
	      focus: false
	    };
	    (0, _warning["default"])(false, 'Mention', 'Mention component is deprecated. Please use Mentions component instead.');
	    return _this;
	  }
	
	  _createClass(Mention, [{
	    key: "defaultSearchChange",
	    value: function defaultSearchChange(value) {
	      var searchValue = value.toLowerCase();
	      var filteredSuggestions = (this.props.defaultSuggestions || []).filter(function (suggestion) {
	        if (typeof suggestion === 'string') {
	          return suggestion.toLowerCase().indexOf(searchValue) !== -1;
	        }
	
	        if (suggestion.type && suggestion.type === _rcEditorMention.Nav) {
	          return suggestion.props.value ? suggestion.props.value.toLowerCase().indexOf(searchValue) !== -1 : true;
	        }
	
	        return false;
	      });
	      this.setState({
	        filteredSuggestions: filteredSuggestions
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMention)
	      );
	    }
	  }]);
	
	  return Mention;
	}(React.Component);
	
	Mention.getMentions = _rcEditorMention.getMentions;
	Mention.defaultProps = {
	  notFoundContent: 'No matches found',
	  loading: false,
	  multiLines: false,
	  placement: 'bottom'
	};
	Mention.Nav = _rcEditorMention.Nav;
	Mention.toString = _rcEditorMention.toString;
	Mention.toContentState = _rcEditorMention.toEditorState;
	(0, _reactLifecyclesCompat.polyfill)(Mention);
	var _default = Mention;
	exports["default"] = _default;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcMentions = _interopRequireDefault(__webpack_require__(469));
	
	var _spin = _interopRequireDefault(__webpack_require__(235));
	
	var _configProvider = __webpack_require__(13);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Option = _rcMentions["default"].Option;
	
	function loadingFilterOption() {
	  return true;
	}
	
	var Mentions = /*#__PURE__*/function (_React$Component) {
	  _inherits(Mentions, _React$Component);
	
	  var _super = _createSuper(Mentions);
	
	  function Mentions() {
	    var _this;
	
	    _classCallCheck(this, Mentions);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      focused: false
	    };
	
	    _this.onFocus = function () {
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) {
	        onFocus.apply(void 0, arguments);
	      }
	
	      _this.setState({
	        focused: true
	      });
	    };
	
	    _this.onBlur = function () {
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) {
	        onBlur.apply(void 0, arguments);
	      }
	
	      _this.setState({
	        focused: false
	      });
	    };
	
	    _this.getOptions = function () {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          loading = _this$props.loading;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(Option, {
	            value: "ANTD_SEARCHING",
	            disabled: true
	          }, /*#__PURE__*/React.createElement(_spin["default"], {
	            size: "small"
	          }))
	        );
	      }
	
	      return children;
	    };
	
	    _this.getFilterOption = function () {
	      var _this$props2 = _this.props,
	          filterOption = _this$props2.filterOption,
	          loading = _this$props2.loading;
	
	      if (loading) {
	        return loadingFilterOption;
	      }
	
	      return filterOption;
	    };
	
	    _this.saveMentions = function (node) {
	      _this.rcMentions = node;
	    };
	
	    _this.renderMentions = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	      var focused = _this.state.focused;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          disabled = _a.disabled,
	          restProps = __rest(_a, ["prefixCls", "className", "disabled"]);
	
	      var prefixCls = getPrefixCls('mentions', customizePrefixCls);
	      var mentionsProps = (0, _omit["default"])(restProps, ['loading']);
	      var mergedClassName = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-focused"), focused), _classNames));
	      return (/*#__PURE__*/React.createElement(_rcMentions["default"], _extends({
	          prefixCls: prefixCls,
	          notFoundContent: _this.getNotFoundContent(renderEmpty),
	          className: mergedClassName,
	          disabled: disabled
	        }, mentionsProps, {
	          filterOption: _this.getFilterOption(),
	          onFocus: _this.onFocus,
	          onBlur: _this.onBlur,
	          ref: _this.saveMentions
	        }), _this.getOptions())
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Mentions, [{
	    key: "getNotFoundContent",
	    value: function getNotFoundContent(renderEmpty) {
	      var notFoundContent = this.props.notFoundContent;
	
	      if (notFoundContent !== undefined) {
	        return notFoundContent;
	      }
	
	      return renderEmpty('Select');
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcMentions.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcMentions.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMentions)
	      );
	    }
	  }]);
	
	  return Mentions;
	}(React.Component);
	
	Mentions.Option = Option;
	
	Mentions.getMentions = function () {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var config = arguments.length > 1 ? arguments[1] : undefined;
	
	  var _ref2 = config || {},
	      _ref2$prefix = _ref2.prefix,
	      prefix = _ref2$prefix === void 0 ? '@' : _ref2$prefix,
	      _ref2$split = _ref2.split,
	      split = _ref2$split === void 0 ? ' ' : _ref2$split;
	
	  var prefixList = Array.isArray(prefix) ? prefix : [prefix];
	  return value.split(split).map(function () {
	    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var hitPrefix = null;
	    prefixList.some(function (prefixStr) {
	      var startStr = str.slice(0, prefixStr.length);
	
	      if (startStr === prefixStr) {
	        hitPrefix = prefixStr;
	        return true;
	      }
	
	      return false;
	    });
	
	    if (hitPrefix !== null) {
	      return {
	        prefix: hitPrefix,
	        value: str.slice(hitPrefix.length)
	      };
	    }
	
	    return null;
	  }).filter(function (entity) {
	    return !!entity && !!entity.value;
	  });
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Mentions);
	var _default = Mentions;
	exports["default"] = _default;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcMenu = __webpack_require__(93);
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(298));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(122));
	
	var _Sider = __webpack_require__(297);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var MenuItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  var _super = _createSuper(MenuItem);
	
	  function MenuItem() {
	    var _this;
	
	    _classCallCheck(this, MenuItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.menuItem.onKeyDown(e);
	    };
	
	    _this.saveMenuItem = function (menuItem) {
	      _this.menuItem = menuItem;
	    };
	
	    _this.renderItem = function (_ref) {
	      var siderCollapsed = _ref.siderCollapsed;
	      var _this$props = _this.props,
	          level = _this$props.level,
	          children = _this$props.children,
	          rootPrefixCls = _this$props.rootPrefixCls;
	
	      var _a = _this.props,
	          title = _a.title,
	          rest = __rest(_a, ["title"]);
	
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref2) {
	          var inlineCollapsed = _ref2.inlineCollapsed;
	          var tooltipProps = {
	            title: title || (level === 1 ? children : '')
	          };
	
	          if (!siderCollapsed && !inlineCollapsed) {
	            tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct
	            // ref: https://github.com/ant-design/ant-design/issues/16742
	
	            tooltipProps.visible = false;
	          }
	
	          return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, tooltipProps, {
	              placement: "right",
	              overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
	            }), /*#__PURE__*/React.createElement(_rcMenu.Item, _extends({}, rest, {
	              title: title,
	              ref: _this.saveMenuItem
	            })))
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, this.renderItem)
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(React.Component);
	
	exports["default"] = MenuItem;
	MenuItem.isMenuItem = true;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcMenu = __webpack_require__(93);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(298));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var SubMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(SubMenu, _React$Component);
	
	  var _super = _createSuper(SubMenu);
	
	  function SubMenu() {
	    var _this;
	
	    _classCallCheck(this, SubMenu);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.subMenu.onKeyDown(e);
	    };
	
	    _this.saveSubMenu = function (subMenu) {
	      _this.subMenu = subMenu;
	    };
	
	    return _this;
	  }
	
	  _createClass(SubMenu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          rootPrefixCls = _this$props.rootPrefixCls,
	          popupClassName = _this$props.popupClassName;
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref) {
	          var antdMenuTheme = _ref.antdMenuTheme;
	          return (/*#__PURE__*/React.createElement(_rcMenu.SubMenu, _extends({}, _this2.props, {
	              ref: _this2.saveSubMenu,
	              popupClassName: (0, _classnames["default"])("".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
	            }))
	          );
	        })
	      );
	    }
	  }]);
	
	  return SubMenu;
	}(React.Component);
	
	SubMenu.contextTypes = {
	  antdMenuTheme: PropTypes.string
	}; // fix issue:https://github.com/ant-design/ant-design/issues/8666
	
	SubMenu.isSubMenu = 1;
	var _default = SubMenu;
	exports["default"] = _default;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcNotification = _interopRequireDefault(__webpack_require__(189));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var defaultDuration = 3;
	var defaultTop;
	var messageInstance;
	var key = 1;
	var prefixCls = 'ant-message';
	var transitionName = 'move-up';
	var getContainer;
	var maxCount;
	
	function getMessageInstance(callback) {
	  if (messageInstance) {
	    callback(messageInstance);
	    return;
	  }
	
	  _rcNotification["default"].newInstance({
	    prefixCls: prefixCls,
	    transitionName: transitionName,
	    style: {
	      top: defaultTop
	    },
	    getContainer: getContainer,
	    maxCount: maxCount
	  }, function (instance) {
	    if (messageInstance) {
	      callback(messageInstance);
	      return;
	    }
	
	    messageInstance = instance;
	    callback(instance);
	  });
	}
	
	function notice(args) {
	  var duration = args.duration !== undefined ? args.duration : defaultDuration;
	  var iconType = {
	    info: 'info-circle',
	    success: 'check-circle',
	    error: 'close-circle',
	    warning: 'exclamation-circle',
	    loading: 'loading'
	  }[args.type];
	  var target = args.key || key++;
	  var closePromise = new Promise(function (resolve) {
	    var callback = function callback() {
	      if (typeof args.onClose === 'function') {
	        args.onClose();
	      }
	
	      return resolve(true);
	    };
	
	    getMessageInstance(function (instance) {
	      var iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType,
	        theme: iconType === 'loading' ? 'outlined' : 'filled'
	      });
	      var switchIconNode = iconType ? iconNode : '';
	      instance.notice({
	        key: target,
	        duration: duration,
	        style: {},
	        content: /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-custom-content").concat(args.type ? " ".concat(prefixCls, "-").concat(args.type) : '')
	        }, args.icon ? args.icon : switchIconNode, /*#__PURE__*/React.createElement("span", null, args.content)),
	        onClose: callback
	      });
	    });
	  });
	
	  var result = function result() {
	    if (messageInstance) {
	      messageInstance.removeNotice(target);
	    }
	  };
	
	  result.then = function (filled, rejected) {
	    return closePromise.then(filled, rejected);
	  };
	
	  result.promise = closePromise;
	  return result;
	}
	
	function isArgsProps(content) {
	  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
	}
	
	var api = {
	  open: notice,
	  config: function config(options) {
	    if (options.top !== undefined) {
	      defaultTop = options.top;
	      messageInstance = null; // delete messageInstance for new defaultTop
	    }
	
	    if (options.duration !== undefined) {
	      defaultDuration = options.duration;
	    }
	
	    if (options.prefixCls !== undefined) {
	      prefixCls = options.prefixCls;
	    }
	
	    if (options.getContainer !== undefined) {
	      getContainer = options.getContainer;
	    }
	
	    if (options.transitionName !== undefined) {
	      transitionName = options.transitionName;
	      messageInstance = null; // delete messageInstance for new transitionName
	    }
	
	    if (options.maxCount !== undefined) {
	      maxCount = options.maxCount;
	      messageInstance = null;
	    }
	  },
	  destroy: function destroy() {
	    if (messageInstance) {
	      messageInstance.destroy();
	      messageInstance = null;
	    }
	  }
	};
	['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
	  api[type] = function (content, duration, onClose) {
	    if (isArgsProps(content)) {
	      return api.open(_extends(_extends({}, content), {
	        type: type
	      }));
	    }
	
	    if (typeof duration === 'function') {
	      onClose = duration;
	      duration = undefined;
	    }
	
	    return api.open({
	      content: content,
	      duration: duration,
	      type: type,
	      onClose: onClose
	    });
	  };
	});
	api.warn = api.warning;
	var _default = api;
	exports["default"] = _default;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _button = _interopRequireDefault(__webpack_require__(135));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ActionButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(ActionButton, _React$Component);
	
	  var _super = _createSuper(ActionButton);
	
	  function ActionButton(props) {
	    var _this;
	
	    _classCallCheck(this, ActionButton);
	
	    _this = _super.call(this, props);
	
	    _this.onClick = function () {
	      var _this$props = _this.props,
	          actionFn = _this$props.actionFn,
	          closeModal = _this$props.closeModal;
	
	      if (actionFn) {
	        var ret;
	
	        if (actionFn.length) {
	          ret = actionFn(closeModal);
	        } else {
	          ret = actionFn();
	
	          if (!ret) {
	            closeModal();
	          }
	        }
	
	        if (ret && ret.then) {
	          _this.setState({
	            loading: true
	          });
	
	          ret.then(function () {
	            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
	            // this.setState({ loading: false });
	            closeModal.apply(void 0, arguments);
	          }, function (e) {
	            // Emit error when catch promise reject
	            // eslint-disable-next-line no-console
	            console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183
	
	            _this.setState({
	              loading: false
	            });
	          });
	        }
	      } else {
	        closeModal();
	      }
	    };
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(ActionButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoFocus) {
	        var $this = ReactDOM.findDOMNode(this);
	        this.timeoutId = setTimeout(function () {
	          return $this.focus();
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          type = _this$props2.type,
	          children = _this$props2.children,
	          buttonProps = _this$props2.buttonProps;
	      var loading = this.state.loading;
	      return (/*#__PURE__*/React.createElement(_button["default"], _extends({
	          type: type,
	          onClick: this.onClick,
	          loading: loading
	        }, buttonProps), children)
	      );
	    }
	  }]);
	
	  return ActionButton;
	}(React.Component);
	
	exports["default"] = ActionButton;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = confirm;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(575));
	
	var _ActionButton = _interopRequireDefault(__webpack_require__(1068));
	
	var _locale = __webpack_require__(300);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var IS_REACT_16 = !!ReactDOM.createPortal;
	
	var ConfirmDialog = function ConfirmDialog(props) {
	  var onCancel = props.onCancel,
	      onOk = props.onOk,
	      close = props.close,
	      zIndex = props.zIndex,
	      afterClose = props.afterClose,
	      visible = props.visible,
	      keyboard = props.keyboard,
	      centered = props.centered,
	      getContainer = props.getContainer,
	      maskStyle = props.maskStyle,
	      okButtonProps = props.okButtonProps,
	      cancelButtonProps = props.cancelButtonProps,
	      _props$iconType = props.iconType,
	      iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
	  (0, _warning["default"])(!('iconType' in props), 'Modal', "The property 'iconType' is deprecated. Use the property 'icon' instead."); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
	
	  var icon = props.icon === undefined ? iconType : props.icon;
	  var okType = props.okType || 'primary';
	  var prefixCls = props.prefixCls || 'ant-modal';
	  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容
	
	  var okCancel = 'okCancel' in props ? props.okCancel : true;
	  var width = props.width || 416;
	  var style = props.style || {};
	  var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为
	
	  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
	  var runtimeLocale = (0, _locale.getConfirmLocale)();
	  var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
	  var cancelText = props.cancelText || runtimeLocale.cancelText;
	  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
	  var transitionName = props.transitionName || 'zoom';
	  var maskTransitionName = props.maskTransitionName || 'fade';
	  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
	  var cancelButton = okCancel && /*#__PURE__*/React.createElement(_ActionButton["default"], {
	    actionFn: onCancel,
	    closeModal: close,
	    autoFocus: autoFocusButton === 'cancel',
	    buttonProps: cancelButtonProps
	  }, cancelText);
	  var iconNode = typeof icon === 'string' ? /*#__PURE__*/React.createElement(_icon["default"], {
	    type: icon
	  }) : icon;
	  return (/*#__PURE__*/React.createElement(_Modal["default"], {
	      prefixCls: prefixCls,
	      className: classString,
	      wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
	      onCancel: function onCancel() {
	        return close({
	          triggerCancel: true
	        });
	      },
	      visible: visible,
	      title: "",
	      transitionName: transitionName,
	      footer: "",
	      maskTransitionName: maskTransitionName,
	      mask: mask,
	      maskClosable: maskClosable,
	      maskStyle: maskStyle,
	      style: style,
	      width: width,
	      zIndex: zIndex,
	      afterClose: afterClose,
	      keyboard: keyboard,
	      centered: centered,
	      getContainer: getContainer
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-body-wrapper")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-body")
	    }, iconNode, props.title === undefined ? null : /*#__PURE__*/React.createElement("span", {
	      className: "".concat(contentPrefixCls, "-title")
	    }, props.title), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-content")
	    }, props.content)), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-btns")
	    }, cancelButton, /*#__PURE__*/React.createElement(_ActionButton["default"], {
	      type: okType,
	      actionFn: onOk,
	      closeModal: close,
	      autoFocus: autoFocusButton === 'ok',
	      buttonProps: okButtonProps
	    }, okText))))
	  );
	};
	
	function confirm(config) {
	  var div = document.createElement('div');
	  document.body.appendChild(div); // eslint-disable-next-line no-use-before-define
	
	  var currentConfig = _extends(_extends({}, config), {
	    close: close,
	    visible: true
	  });
	
	  function destroy() {
	    var unmountResult = ReactDOM.unmountComponentAtNode(div);
	
	    if (unmountResult && div.parentNode) {
	      div.parentNode.removeChild(div);
	    }
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var triggerCancel = args.some(function (param) {
	      return param && param.triggerCancel;
	    });
	
	    if (config.onCancel && triggerCancel) {
	      config.onCancel.apply(config, args);
	    }
	
	    for (var i = 0; i < _Modal.destroyFns.length; i++) {
	      var fn = _Modal.destroyFns[i]; // eslint-disable-next-line no-use-before-define
	
	      if (fn === close) {
	        _Modal.destroyFns.splice(i, 1);
	
	        break;
	      }
	    }
	  }
	
	  function render(props) {
	    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmDialog, props), div);
	  }
	
	  function close() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    currentConfig = _extends(_extends({}, currentConfig), {
	      visible: false,
	      afterClose: destroy.bind.apply(destroy, [this].concat(args))
	    });
	
	    if (IS_REACT_16) {
	      render(currentConfig);
	    } else {
	      destroy.apply(void 0, args);
	    }
	  }
	
	  function update(newConfig) {
	    currentConfig = _extends(_extends({}, currentConfig), newConfig);
	    render(currentConfig);
	  }
	
	  render(currentConfig);
	
	  _Modal.destroyFns.push(close);
	
	  return {
	    destroy: close,
	    update: update
	  };
	}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(575));
	
	var _confirm = _interopRequireDefault(__webpack_require__(1069));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function modalWarn(props) {
	  var config = _extends({
	    type: 'warning',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "exclamation-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	}
	
	_Modal["default"].info = function infoFn(props) {
	  var config = _extends({
	    type: 'info',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "info-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].success = function successFn(props) {
	  var config = _extends({
	    type: 'success',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "check-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].error = function errorFn(props) {
	  var config = _extends({
	    type: 'error',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "close-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].warning = modalWarn;
	_Modal["default"].warn = modalWarn;
	
	_Modal["default"].confirm = function confirmFn(props) {
	  var config = _extends({
	    type: 'confirm',
	    okCancel: true
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].destroyAll = function destroyAllFn() {
	  while (_Modal.destroyFns.length) {
	    var close = _Modal.destroyFns.pop();
	
	    if (close) {
	      close();
	    }
	  }
	};
	
	var _default = _Modal["default"];
	exports["default"] = _default;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcNotification = _interopRequireDefault(__webpack_require__(189));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var notificationInstance = {};
	var defaultDuration = 4.5;
	var defaultTop = 24;
	var defaultBottom = 24;
	var defaultPlacement = 'topRight';
	var defaultGetContainer;
	var defaultCloseIcon;
	
	function setNotificationConfig(options) {
	  var duration = options.duration,
	      placement = options.placement,
	      bottom = options.bottom,
	      top = options.top,
	      getContainer = options.getContainer,
	      closeIcon = options.closeIcon;
	
	  if (duration !== undefined) {
	    defaultDuration = duration;
	  }
	
	  if (placement !== undefined) {
	    defaultPlacement = placement;
	  }
	
	  if (bottom !== undefined) {
	    defaultBottom = bottom;
	  }
	
	  if (top !== undefined) {
	    defaultTop = top;
	  }
	
	  if (getContainer !== undefined) {
	    defaultGetContainer = getContainer;
	  }
	
	  if (closeIcon !== undefined) {
	    defaultCloseIcon = closeIcon;
	  }
	}
	
	function getPlacementStyle(placement) {
	  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTop;
	  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBottom;
	  var style;
	
	  switch (placement) {
	    case 'topLeft':
	      style = {
	        left: 0,
	        top: top,
	        bottom: 'auto'
	      };
	      break;
	
	    case 'topRight':
	      style = {
	        right: 0,
	        top: top,
	        bottom: 'auto'
	      };
	      break;
	
	    case 'bottomLeft':
	      style = {
	        left: 0,
	        top: 'auto',
	        bottom: bottom
	      };
	      break;
	
	    default:
	      style = {
	        right: 0,
	        top: 'auto',
	        bottom: bottom
	      };
	      break;
	  }
	
	  return style;
	}
	
	function getNotificationInstance(_ref, callback) {
	  var prefixCls = _ref.prefixCls,
	      _ref$placement = _ref.placement,
	      placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
	      _ref$getContainer = _ref.getContainer,
	      getContainer = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer,
	      top = _ref.top,
	      bottom = _ref.bottom,
	      _ref$closeIcon = _ref.closeIcon,
	      closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon;
	  var cacheKey = "".concat(prefixCls, "-").concat(placement);
	
	  if (notificationInstance[cacheKey]) {
	    callback(notificationInstance[cacheKey]);
	    return;
	  }
	
	  var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-close-x")
	  }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	    className: "".concat(prefixCls, "-close-icon"),
	    type: "close"
	  }));
	
	  _rcNotification["default"].newInstance({
	    prefixCls: prefixCls,
	    className: "".concat(prefixCls, "-").concat(placement),
	    style: getPlacementStyle(placement, top, bottom),
	    getContainer: getContainer,
	    closeIcon: closeIconToRender
	  }, function (notification) {
	    notificationInstance[cacheKey] = notification;
	    callback(notification);
	  });
	}
	
	var typeToIcon = {
	  success: 'check-circle-o',
	  info: 'info-circle-o',
	  error: 'close-circle-o',
	  warning: 'exclamation-circle-o'
	};
	
	function notice(args) {
	  var outerPrefixCls = args.prefixCls || 'ant-notification';
	  var prefixCls = "".concat(outerPrefixCls, "-notice");
	  var duration = args.duration === undefined ? defaultDuration : args.duration;
	  var iconNode = null;
	
	  if (args.icon) {
	    iconNode = /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-icon")
	    }, args.icon);
	  } else if (args.type) {
	    var iconType = typeToIcon[args.type];
	    iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
	      className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(args.type),
	      type: iconType
	    });
	  }
	
	  var autoMarginTag = !args.description && iconNode ? /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-message-single-line-auto-margin")
	  }) : null;
	  var placement = args.placement,
	      top = args.top,
	      bottom = args.bottom,
	      getContainer = args.getContainer,
	      closeIcon = args.closeIcon;
	  getNotificationInstance({
	    prefixCls: outerPrefixCls,
	    placement: placement,
	    top: top,
	    bottom: bottom,
	    getContainer: getContainer,
	    closeIcon: closeIcon
	  }, function (notification) {
	    notification.notice({
	      content: /*#__PURE__*/React.createElement("div", {
	        className: iconNode ? "".concat(prefixCls, "-with-icon") : ''
	      }, iconNode, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-message")
	      }, autoMarginTag, args.message), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-description")
	      }, args.description), args.btn ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-btn")
	      }, args.btn) : null),
	      duration: duration,
	      closable: true,
	      onClose: args.onClose,
	      onClick: args.onClick,
	      key: args.key,
	      style: args.style || {},
	      className: args.className
	    });
	  });
	}
	
	var api = {
	  open: notice,
	  close: function close(key) {
	    Object.keys(notificationInstance).forEach(function (cacheKey) {
	      return notificationInstance[cacheKey].removeNotice(key);
	    });
	  },
	  config: setNotificationConfig,
	  destroy: function destroy() {
	    Object.keys(notificationInstance).forEach(function (cacheKey) {
	      notificationInstance[cacheKey].destroy();
	      delete notificationInstance[cacheKey];
	    });
	  }
	};
	['success', 'info', 'warning', 'error'].forEach(function (type) {
	  api[type] = function (args) {
	    return api.open(_extends(_extends({}, args), {
	      type: type
	    }));
	  };
	});
	api.warn = api.warning;
	var _default = api;
	exports["default"] = _default;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _breadcrumb = _interopRequireDefault(__webpack_require__(559));
	
	var _avatar = _interopRequireDefault(__webpack_require__(557));
	
	var _transButton = _interopRequireDefault(__webpack_require__(291));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var renderBack = function renderBack(prefixCls, backIcon, onBack) {
	  if (!backIcon || !onBack) {
	    return null;
	  }
	
	  return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	      componentName: "PageHeader"
	    }, function (_ref) {
	      var back = _ref.back;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-back")
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          onClick: function onClick(e) {
	            if (onBack) {
	              onBack(e);
	            }
	          },
	          className: "".concat(prefixCls, "-back-button"),
	          "aria-label": back
	        }, backIcon))
	      );
	    })
	  );
	};
	
	var renderBreadcrumb = function renderBreadcrumb(breadcrumb) {
	  return (/*#__PURE__*/React.createElement(_breadcrumb["default"], breadcrumb)
	  );
	};
	
	var renderTitle = function renderTitle(prefixCls, props) {
	  var title = props.title,
	      avatar = props.avatar,
	      subTitle = props.subTitle,
	      tags = props.tags,
	      extra = props.extra,
	      backIcon = props.backIcon,
	      onBack = props.onBack;
	  var headingPrefixCls = "".concat(prefixCls, "-heading");
	
	  if (title || subTitle || tags || extra) {
	    var backIconDom = renderBack(prefixCls, backIcon, onBack);
	    return (/*#__PURE__*/React.createElement("div", {
	        className: headingPrefixCls
	      }, backIconDom, avatar && /*#__PURE__*/React.createElement(_avatar["default"], avatar), title && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-title")
	      }, title), subTitle && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-sub-title")
	      }, subTitle), tags && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-tags")
	      }, tags), extra && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-extra")
	      }, extra))
	    );
	  }
	
	  return null;
	};
	
	var renderFooter = function renderFooter(prefixCls, footer) {
	  if (footer) {
	    return (/*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, footer)
	    );
	  }
	
	  return null;
	};
	
	var renderChildren = function renderChildren(prefixCls, children) {
	  return (/*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-content")
	    }, children)
	  );
	};
	
	var PageHeader = function PageHeader(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls,
	          pageHeader = _ref2.pageHeader;
	      var customizePrefixCls = props.prefixCls,
	          style = props.style,
	          footer = props.footer,
	          children = props.children,
	          breadcrumb = props.breadcrumb,
	          customizeClassName = props.className;
	      var ghost = true; // Use `ghost` from `props` or from `ConfigProvider` instead.
	
	      if ('ghost' in props) {
	        ghost = props.ghost;
	      } else if (pageHeader && 'ghost' in pageHeader) {
	        ghost = pageHeader.ghost;
	      }
	
	      var prefixCls = getPrefixCls('page-header', customizePrefixCls);
	      var breadcrumbDom = breadcrumb && breadcrumb.routes ? renderBreadcrumb(breadcrumb) : null;
	      var className = (0, _classnames2["default"])(prefixCls, customizeClassName, _defineProperty({
	        'has-breadcrumb': breadcrumbDom,
	        'has-footer': footer
	      }, "".concat(prefixCls, "-ghost"), ghost));
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className,
	          style: style
	        }, breadcrumbDom, renderTitle(prefixCls, props), children && renderChildren(prefixCls, children), renderFooter(prefixCls, footer))
	      );
	    })
	  );
	};
	
	PageHeader.defaultProps = {
	  backIcon: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "arrow-left"
	  })
	};
	var _default = PageHeader;
	exports["default"] = _default;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _select = _interopRequireDefault(__webpack_require__(197));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var MiniSelect = /*#__PURE__*/function (_React$Component) {
	  _inherits(MiniSelect, _React$Component);
	
	  var _super = _createSuper(MiniSelect);
	
	  function MiniSelect() {
	    _classCallCheck(this, MiniSelect);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(MiniSelect, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_select["default"], _extends({
	          size: "small"
	        }, this.props))
	      );
	    }
	  }]);
	
	  return MiniSelect;
	}(React.Component);
	
	exports["default"] = MiniSelect;
	MiniSelect.Option = _select["default"].Option;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcPagination = _interopRequireDefault(__webpack_require__(471));
	
	var _en_US = _interopRequireDefault(__webpack_require__(190));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _MiniSelect = _interopRequireDefault(__webpack_require__(1073));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _select = _interopRequireDefault(__webpack_require__(197));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Pagination = /*#__PURE__*/function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  var _super = _createSuper(Pagination);
	
	  function Pagination() {
	    var _this;
	
	    _classCallCheck(this, Pagination);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getIconsProps = function (prefixCls) {
	      var prevIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "left"
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right"
	      }));
	      var jumpPrevIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-container")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-item-link-icon"),
	        type: "double-left"
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-ellipsis")
	      }, "\u2022\u2022\u2022")));
	      var jumpNextIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-container")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-item-link-icon"),
	        type: "double-right"
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-ellipsis")
	      }, "\u2022\u2022\u2022")));
	      return {
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        jumpPrevIcon: jumpPrevIcon,
	        jumpNextIcon: jumpNextIcon
	      };
	    };
	
	    _this.renderPagination = function (contextLocale) {
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeSelectPrefixCls = _a.selectPrefixCls,
	          className = _a.className,
	          size = _a.size,
	          customLocale = _a.locale,
	          restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);
	
	      var locale = _extends(_extends({}, contextLocale), customLocale);
	
	      var isSmall = size === 'small';
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	          var getPrefixCls = _ref.getPrefixCls;
	          var prefixCls = getPrefixCls('pagination', customizePrefixCls);
	          var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
	          return (/*#__PURE__*/React.createElement(_rcPagination["default"], _extends({}, restProps, {
	              prefixCls: prefixCls,
	              selectPrefixCls: selectPrefixCls
	            }, _this.getIconsProps(prefixCls), {
	              className: (0, _classnames["default"])(className, {
	                mini: isSmall
	              }),
	              selectComponentClass: isSmall ? _MiniSelect["default"] : _select["default"],
	              locale: locale
	            }))
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Pagination, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Pagination",
	          defaultLocale: _en_US["default"]
	        }, this.renderPagination)
	      );
	    }
	  }]);
	
	  return Pagination;
	}(React.Component);
	
	exports["default"] = Pagination;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _tooltip = _interopRequireDefault(__webpack_require__(122));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _button = _interopRequireDefault(__webpack_require__(135));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _default2 = _interopRequireDefault(__webpack_require__(152));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popconfirm = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popconfirm, _React$Component);
	
	  var _super = _createSuper(Popconfirm);
	
	  function Popconfirm(props) {
	    var _this;
	
	    _classCallCheck(this, Popconfirm);
	
	    _this = _super.call(this, props);
	
	    _this.onConfirm = function (e) {
	      _this.setVisible(false, e);
	
	      var onConfirm = _this.props.onConfirm;
	
	      if (onConfirm) {
	        onConfirm.call(_assertThisInitialized(_this), e);
	      }
	    };
	
	    _this.onCancel = function (e) {
	      _this.setVisible(false, e);
	
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel.call(_assertThisInitialized(_this), e);
	      }
	    };
	
	    _this.onVisibleChange = function (visible) {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setVisible(visible);
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderOverlay = function (prefixCls, popconfirmLocale) {
	      var _this$props = _this.props,
	          okButtonProps = _this$props.okButtonProps,
	          cancelButtonProps = _this$props.cancelButtonProps,
	          title = _this$props.title,
	          cancelText = _this$props.cancelText,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          icon = _this$props.icon;
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-inner-content")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-message")
	        }, icon, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-message-title")
	        }, title)), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-buttons")
	        }, /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.onCancel,
	          size: "small"
	        }, cancelButtonProps), cancelText || popconfirmLocale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.onConfirm,
	          type: okType,
	          size: "small"
	        }, okButtonProps), okText || popconfirmLocale.okText))))
	      );
	    };
	
	    _this.renderConfirm = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          placement = _a.placement,
	          restProps = __rest(_a, ["prefixCls", "placement"]);
	
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      var overlay = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Popconfirm",
	        defaultLocale: _default2["default"].Popconfirm
	      }, function (popconfirmLocale) {
	        return _this.renderOverlay(prefixCls, popconfirmLocale);
	      });
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, restProps, {
	          prefixCls: prefixCls,
	          placement: placement,
	          onVisibleChange: _this.onVisibleChange,
	          visible: _this.state.visible,
	          overlay: overlay,
	          ref: _this.saveTooltip
	        }))
	      );
	    };
	
	    _this.state = {
	      visible: props.visible
	    };
	    return _this;
	  }
	
	  _createClass(Popconfirm, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible, e) {
	      var props = this.props;
	
	      if (!('visible' in props)) {
	        this.setState({
	          visible: visible
	        });
	      }
	
	      var onVisibleChange = props.onVisibleChange;
	
	      if (onVisibleChange) {
	        onVisibleChange(visible, e);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderConfirm)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      if ('defaultVisible' in nextProps) {
	        return {
	          visible: nextProps.defaultVisible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Popconfirm;
	}(React.Component);
	
	Popconfirm.defaultProps = {
	  transitionName: 'zoom-big',
	  placement: 'top',
	  trigger: 'click',
	  okType: 'primary',
	  icon: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "exclamation-circle",
	    theme: "filled"
	  }),
	  disabled: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Popconfirm);
	var _default = Popconfirm;
	exports["default"] = _default;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(122));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popover = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popover, _React$Component);
	
	  var _super = _createSuper(Popover);
	
	  function Popover() {
	    var _this;
	
	    _classCallCheck(this, Popover);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderPopover = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          props = __rest(_a, ["prefixCls"]);
	
	      delete props.title;
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, props, {
	          prefixCls: prefixCls,
	          ref: _this.saveTooltip,
	          overlay: _this.getOverlay(prefixCls)
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Popover, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay(prefixCls) {
	      var _this$props = this.props,
	          title = _this$props.title,
	          content = _this$props.content;
	      (0, _warning["default"])(!('overlay' in this.props), 'Popover', '`overlay` is removed, please use `content` instead, ' + 'see: https://u.ant.design/popover-content');
	      return (/*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-inner-content")
	        }, content))
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPopover)
	      );
	    }
	  }]);
	
	  return Popover;
	}(React.Component);
	
	exports["default"] = Popover;
	Popover.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big',
	  trigger: 'hover',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  overlayStyle: {}
	};

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcProgress = __webpack_require__(472);
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(302);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var statusColorMap = {
	  normal: '#108ee9',
	  exception: '#ff5500',
	  success: '#87d068'
	};
	
	function getPercentage(_ref) {
	  var percent = _ref.percent,
	      successPercent = _ref.successPercent;
	  var ptg = (0, _utils.validProgress)(percent);
	
	  if (!successPercent) {
	    return ptg;
	  }
	
	  var successPtg = (0, _utils.validProgress)(successPercent);
	  return [successPercent, (0, _utils.validProgress)(ptg - successPtg)];
	}
	
	function getStrokeColor(_ref2) {
	  var progressStatus = _ref2.progressStatus,
	      successPercent = _ref2.successPercent,
	      strokeColor = _ref2.strokeColor;
	  var color = strokeColor || statusColorMap[progressStatus];
	
	  if (!successPercent) {
	    return color;
	  }
	
	  return [statusColorMap.success, color];
	}
	
	var Circle = function Circle(props) {
	  var prefixCls = props.prefixCls,
	      width = props.width,
	      strokeWidth = props.strokeWidth,
	      trailColor = props.trailColor,
	      strokeLinecap = props.strokeLinecap,
	      gapPosition = props.gapPosition,
	      gapDegree = props.gapDegree,
	      type = props.type,
	      children = props.children;
	  var circleSize = width || 120;
	  var circleStyle = {
	    width: circleSize,
	    height: circleSize,
	    fontSize: circleSize * 0.15 + 6
	  };
	  var circleWidth = strokeWidth || 6;
	  var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
	  var gapDeg = gapDegree || (type === 'dashboard' ? 75 : undefined);
	  var strokeColor = getStrokeColor(props);
	  var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
	  var wrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-inner"), _defineProperty({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
	  return (/*#__PURE__*/React.createElement("div", {
	      className: wrapperClassName,
	      style: circleStyle
	    }, /*#__PURE__*/React.createElement(_rcProgress.Circle, {
	      percent: getPercentage(props),
	      strokeWidth: circleWidth,
	      trailWidth: circleWidth,
	      strokeColor: strokeColor,
	      strokeLinecap: strokeLinecap,
	      trailColor: trailColor,
	      prefixCls: prefixCls,
	      gapDegree: gapDeg,
	      gapPosition: gapPos
	    }), children)
	  );
	};
	
	var _default = Circle;
	exports["default"] = _default;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.handleGradient = exports.sortGradient = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _utils = __webpack_require__(302);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	/**
	 * {
	 *   '0%': '#afc163',
	 *   '75%': '#009900',
	 *   '50%': 'green',     ====>     '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
	 *   '25%': '#66FF00',
	 *   '100%': '#ffffff'
	 * }
	 */
	var sortGradient = function sortGradient(gradients) {
	  var tempArr = []; // eslint-disable-next-line no-restricted-syntax
	
	  for (var _i = 0, _Object$entries = Object.entries(gradients); _i < _Object$entries.length; _i++) {
	    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
	        key = _Object$entries$_i[0],
	        value = _Object$entries$_i[1];
	
	    var formatKey = parseFloat(key.replace(/%/g, ''));
	
	    if (isNaN(formatKey)) {
	      return {};
	    }
	
	    tempArr.push({
	      key: formatKey,
	      value: value
	    });
	  }
	
	  tempArr = tempArr.sort(function (a, b) {
	    return a.key - b.key;
	  });
	  return tempArr.map(function (_ref) {
	    var key = _ref.key,
	        value = _ref.value;
	    return "".concat(value, " ").concat(key, "%");
	  }).join(', ');
	};
	/**
	 * {
	 *   '0%': '#afc163',
	 *   '25%': '#66FF00',
	 *   '50%': '#00CC00',     ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
	 *   '75%': '#009900',              #00CC00 50%, #009900 75%, #ffffff 100%)
	 *   '100%': '#ffffff'
	 * }
	 *
	 * Then this man came to realize the truth:
	 * Besides six pence, there is the moon.
	 * Besides bread and butter, there is the bug.
	 * And...
	 * Besides women, there is the code.
	 */
	
	exports.sortGradient = sortGradient;
	
	var handleGradient = function handleGradient(strokeColor) {
	  var _strokeColor$from = strokeColor.from,
	      from = _strokeColor$from === void 0 ? '#1890ff' : _strokeColor$from,
	      _strokeColor$to = strokeColor.to,
	      to = _strokeColor$to === void 0 ? '#1890ff' : _strokeColor$to,
	      _strokeColor$directio = strokeColor.direction,
	      direction = _strokeColor$directio === void 0 ? 'to right' : _strokeColor$directio,
	      rest = __rest(strokeColor, ["from", "to", "direction"]);
	
	  if (Object.keys(rest).length !== 0) {
	    var sortedGradients = sortGradient(rest);
	    return {
	      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
	    };
	  }
	
	  return {
	    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
	  };
	};
	
	exports.handleGradient = handleGradient;
	
	var Line = function Line(props) {
	  var prefixCls = props.prefixCls,
	      percent = props.percent,
	      successPercent = props.successPercent,
	      strokeWidth = props.strokeWidth,
	      size = props.size,
	      strokeColor = props.strokeColor,
	      strokeLinecap = props.strokeLinecap,
	      children = props.children;
	  var backgroundProps;
	
	  if (strokeColor && typeof strokeColor !== 'string') {
	    backgroundProps = handleGradient(strokeColor);
	  } else {
	    backgroundProps = {
	      background: strokeColor
	    };
	  }
	
	  var percentStyle = _extends({
	    width: "".concat((0, _utils.validProgress)(percent), "%"),
	    height: strokeWidth || (size === 'small' ? 6 : 8),
	    borderRadius: strokeLinecap === 'square' ? 0 : ''
	  }, backgroundProps);
	
	  var successPercentStyle = {
	    width: "".concat((0, _utils.validProgress)(successPercent), "%"),
	    height: strokeWidth || (size === 'small' ? 6 : 8),
	    borderRadius: strokeLinecap === 'square' ? 0 : ''
	  };
	  var successSegment = successPercent !== undefined ? /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-success-bg"),
	    style: successPercentStyle
	  }) : null;
	  return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-outer")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-inner")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-bg"),
	      style: percentStyle
	    }), successSegment)), children)
	  );
	};
	
	var _default = Line;
	exports["default"] = _default;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _type = __webpack_require__(78);
	
	var _Line = _interopRequireDefault(__webpack_require__(1078));
	
	var _Circle = _interopRequireDefault(__webpack_require__(1077));
	
	var _utils = __webpack_require__(302);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ProgressTypes = (0, _type.tuple)('line', 'circle', 'dashboard');
	var ProgressStatuses = (0, _type.tuple)('normal', 'exception', 'active', 'success');
	
	var Progress = /*#__PURE__*/function (_React$Component) {
	  _inherits(Progress, _React$Component);
	
	  var _super = _createSuper(Progress);
	
	  function Progress() {
	    var _this;
	
	    _classCallCheck(this, Progress);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderProgress = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          size = props.size,
	          type = props.type,
	          showInfo = props.showInfo,
	          restProps = __rest(props, ["prefixCls", "className", "size", "type", "showInfo"]);
	
	      var prefixCls = getPrefixCls('progress', customizePrefixCls);
	
	      var progressStatus = _this.getProgressStatus();
	
	      var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);
	
	      var progress; // Render progress shape
	
	      if (type === 'line') {
	        progress = /*#__PURE__*/React.createElement(_Line["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls
	        }), progressInfo);
	      } else if (type === 'circle' || type === 'dashboard') {
	        progress = /*#__PURE__*/React.createElement(_Circle["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          progressStatus: progressStatus
	        }), progressInfo);
	      }
	
	      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, (0, _omit["default"])(restProps, ['status', 'format', 'trailColor', 'successPercent', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeColor', 'strokeLinecap', 'percent']), {
	          className: classString
	        }), progress)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Progress, [{
	    key: "getPercentNumber",
	    value: function getPercentNumber() {
	      var _this$props = this.props,
	          successPercent = _this$props.successPercent,
	          _this$props$percent = _this$props.percent,
	          percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
	      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
	    }
	  }, {
	    key: "getProgressStatus",
	    value: function getProgressStatus() {
	      var status = this.props.status;
	
	      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
	        return 'success';
	      }
	
	      return status || 'normal';
	    }
	  }, {
	    key: "renderProcessInfo",
	    value: function renderProcessInfo(prefixCls, progressStatus) {
	      var _this$props2 = this.props,
	          showInfo = _this$props2.showInfo,
	          format = _this$props2.format,
	          type = _this$props2.type,
	          percent = _this$props2.percent,
	          successPercent = _this$props2.successPercent;
	      if (!showInfo) return null;
	      var text;
	
	      var textFormatter = format || function (percentNumber) {
	        return "".concat(percentNumber, "%");
	      };
	
	      var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';
	
	      if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
	        text = textFormatter((0, _utils.validProgress)(percent), (0, _utils.validProgress)(successPercent));
	      } else if (progressStatus === 'exception') {
	        text = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close".concat(iconType),
	          theme: type === 'line' ? 'filled' : 'outlined'
	        });
	      } else if (progressStatus === 'success') {
	        text = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "check".concat(iconType),
	          theme: type === 'line' ? 'filled' : 'outlined'
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-text"),
	          title: typeof text === 'string' ? text : undefined
	        }, text)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderProgress)
	      );
	    }
	  }]);
	
	  return Progress;
	}(React.Component);
	
	exports["default"] = Progress;
	Progress.defaultProps = {
	  type: 'line',
	  percent: 0,
	  showInfo: true,
	  trailColor: '#f3f3f3',
	  size: 'default',
	  gapDegree: 0,
	  strokeLinecap: 'round'
	};
	Progress.propTypes = {
	  status: PropTypes.oneOf(ProgressStatuses),
	  type: PropTypes.oneOf(ProgressTypes),
	  showInfo: PropTypes.bool,
	  percent: PropTypes.number,
	  width: PropTypes.number,
	  strokeWidth: PropTypes.number,
	  strokeLinecap: PropTypes.oneOf(['round', 'square']),
	  strokeColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  trailColor: PropTypes.string,
	  format: PropTypes.func,
	  gapDegree: PropTypes.number
	};

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _radio = _interopRequireDefault(__webpack_require__(303));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getCheckedValue(children) {
	  var value = null;
	  var matched = false;
	  React.Children.forEach(children, function (radio) {
	    if (radio && radio.props && radio.props.checked) {
	      value = radio.props.value;
	      matched = true;
	    }
	  });
	  return matched ? {
	    value: value
	  } : undefined;
	}
	
	var RadioGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioGroup, _React$Component);
	
	  var _super = _createSuper(RadioGroup);
	
	  function RadioGroup(props) {
	    var _this;
	
	    _classCallCheck(this, RadioGroup);
	
	    _this = _super.call(this, props);
	
	    _this.onRadioChange = function (ev) {
	      var lastValue = _this.state.value;
	      var value = ev.target.value;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange && value !== lastValue) {
	        onChange(ev);
	      }
	    };
	
	    _this.renderGroup = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className,
	          options = props.options,
	          buttonStyle = props.buttonStyle;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), _defineProperty({}, "".concat(groupPrefixCls, "-").concat(props.size), props.size), className);
	      var children = props.children; // 如果存在 options, 优先使用
	
	      if (options && options.length > 0) {
	        children = options.map(function (option) {
	          if (typeof option === 'string') {
	            // 此处类型自动推导为 string
	            return (/*#__PURE__*/React.createElement(_radio["default"], {
	                key: option,
	                prefixCls: prefixCls,
	                disabled: _this.props.disabled,
	                value: option,
	                checked: _this.state.value === option
	              }, option)
	            );
	          } // 此处类型自动推导为 { label: string value: string }
	
	
	          return (/*#__PURE__*/React.createElement(_radio["default"], {
	              key: "radio-group-value-options-".concat(option.value),
	              prefixCls: prefixCls,
	              disabled: option.disabled || _this.props.disabled,
	              value: option.value,
	              checked: _this.state.value === option.value
	            }, option.label)
	          );
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: classString,
	          style: props.style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave,
	          id: props.id
	        }, children)
	      );
	    };
	
	    var value;
	
	    if ('value' in props) {
	      value = props.value;
	    } else if ('defaultValue' in props) {
	      value = props.defaultValue;
	    } else {
	      var checkedValue = getCheckedValue(props.children);
	      value = checkedValue && checkedValue.value;
	    }
	
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(RadioGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        radioGroup: {
	          onChange: this.onRadioChange,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      var checkedValue = getCheckedValue(nextProps.children);
	
	      if (checkedValue) {
	        return {
	          value: checkedValue.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return RadioGroup;
	}(React.Component);
	
	RadioGroup.defaultProps = {
	  buttonStyle: 'outline'
	};
	RadioGroup.childContextTypes = {
	  radioGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(RadioGroup);
	var _default = RadioGroup;
	exports["default"] = _default;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _radio = _interopRequireDefault(__webpack_require__(303));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RadioButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioButton, _React$Component);
	
	  var _super = _createSuper(RadioButton);
	
	  function RadioButton() {
	    var _this;
	
	    _classCallCheck(this, RadioButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderRadioButton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          radioProps = __rest(_a, ["prefixCls"]);
	
	      var prefixCls = getPrefixCls('radio-button', customizePrefixCls);
	
	      if (_this.context.radioGroup) {
	        radioProps.checked = _this.props.value === _this.context.radioGroup.value;
	        radioProps.disabled = _this.props.disabled || _this.context.radioGroup.disabled;
	      }
	
	      return (/*#__PURE__*/React.createElement(_radio["default"], _extends({
	          prefixCls: prefixCls
	        }, radioProps))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(RadioButton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadioButton)
	      );
	    }
	  }]);
	
	  return RadioButton;
	}(React.Component);
	
	exports["default"] = RadioButton;
	RadioButton.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcRate = _interopRequireDefault(__webpack_require__(473));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(122));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Rate = /*#__PURE__*/function (_React$Component) {
	  _inherits(Rate, _React$Component);
	
	  var _super = _createSuper(Rate);
	
	  function Rate() {
	    var _this;
	
	    _classCallCheck(this, Rate);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveRate = function (node) {
	      _this.rcRate = node;
	    };
	
	    _this.characterRender = function (node, _ref) {
	      var index = _ref.index;
	      var tooltips = _this.props.tooltips;
	      if (!tooltips) return node;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          title: tooltips[index]
	        }, node)
	      );
	    };
	
	    _this.renderRate = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          prefixCls = _a.prefixCls,
	          restProps = __rest(_a, ["prefixCls"]);
	
	      var rateProps = (0, _omit["default"])(restProps, ['tooltips']);
	      return (/*#__PURE__*/React.createElement(_rcRate["default"], _extends({
	          ref: _this.saveRate,
	          characterRender: _this.characterRender
	        }, rateProps, {
	          prefixCls: getPrefixCls('rate', prefixCls)
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Rate, [{
	    key: "focus",
	    value: function focus() {
	      this.rcRate.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcRate.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRate)
	      );
	    }
	  }]);
	
	  return Rate;
	}(React.Component);
	
	exports["default"] = Rate;
	Rate.propTypes = {
	  prefixCls: PropTypes.string,
	  character: PropTypes.node
	};
	Rate.defaultProps = {
	  character: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "star",
	    theme: "filled"
	  })
	};

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ExceptionMap = exports.IconMap = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _noFound = _interopRequireDefault(__webpack_require__(1084));
	
	var _serverError = _interopRequireDefault(__webpack_require__(1085));
	
	var _unauthorized = _interopRequireDefault(__webpack_require__(1086));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var IconMap = {
	  success: 'check-circle',
	  error: 'close-circle',
	  info: 'exclamation-circle',
	  warning: 'warning'
	};
	exports.IconMap = IconMap;
	var ExceptionMap = {
	  '404': _noFound["default"],
	  '500': _serverError["default"],
	  '403': _unauthorized["default"]
	}; // ExceptionImageMap keys
	
	exports.ExceptionMap = ExceptionMap;
	var ExceptionStatus = Object.keys(ExceptionMap);
	/**
	 * render icon
	 * if ExceptionStatus includes ,render svg image
	 * else render iconNode
	 * @param prefixCls
	 * @param {status, icon}
	 */
	
	var renderIcon = function renderIcon(prefixCls, _ref) {
	  var status = _ref.status,
	      icon = _ref.icon;
	  var className = (0, _classnames["default"])("".concat(prefixCls, "-icon"));
	
	  if (ExceptionStatus.includes("".concat(status))) {
	    var SVGComponent = ExceptionMap[status];
	    return (/*#__PURE__*/React.createElement("div", {
	        className: "".concat(className, " ").concat(prefixCls, "-image")
	      }, /*#__PURE__*/React.createElement(SVGComponent, null))
	    );
	  }
	
	  var iconString = IconMap[status];
	  var iconNode = icon || /*#__PURE__*/React.createElement(_icon["default"], {
	    type: iconString,
	    theme: "filled"
	  });
	  return (/*#__PURE__*/React.createElement("div", {
	      className: className
	    }, iconNode)
	  );
	};
	
	var renderExtra = function renderExtra(prefixCls, _ref2) {
	  var extra = _ref2.extra;
	  return extra && /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-extra")
	  }, extra);
	};
	
	var Result = function Result(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls;
	      var customizePrefixCls = props.prefixCls,
	          customizeClassName = props.className,
	          subTitle = props.subTitle,
	          title = props.title,
	          style = props.style,
	          children = props.children,
	          status = props.status;
	      var prefixCls = getPrefixCls('result', customizePrefixCls);
	      var className = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(status), customizeClassName);
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className,
	          style: style
	        }, renderIcon(prefixCls, props), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), subTitle && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-subtitle")
	        }, subTitle), children && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, children), renderExtra(prefixCls, props))
	      );
	    })
	  );
	};
	
	Result.defaultProps = {
	  status: 'info'
	};
	Result.PRESENTED_IMAGE_403 = ExceptionMap[403];
	Result.PRESENTED_IMAGE_404 = ExceptionMap[404];
	Result.PRESENTED_IMAGE_500 = ExceptionMap[500];
	var _default = Result;
	exports["default"] = _default;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var NoFound = function NoFound() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "252",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
	      d: "M0 .387h251.772v251.772H0z"
	    })), /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 .012)"
	    }, /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
	      fill: "#E4EBF7",
	      mask: "url(#b)"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#FFF",
	      strokeWidth: "2",
	      d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
	      fill: "#1890FF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.275 222.1s2.773-1.11 6.102-3.884",
	      stroke: "#648BD8",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
	      fill: "#520038"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M110.846 74.481s1.79-.716 2.506.537",
	      stroke: "#5C2552",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M103.287 72.93s1.83 1.113 4.137.954",
	      stroke: "#5C2552",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M119.306 107.329s.452 4.366-2.127 32.062",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
	      fill: "#F4D19D"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
	      fill: "#F4D19D"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
	      fill: "#5BA02E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
	      fill: "#92C110"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M88.979 89.48s7.776 5.384 16.6 2.842",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    })))
	  );
	};
	
	var _default = NoFound;
	exports["default"] = _default;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var ServerError = function ServerError() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "254",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
	      d: "M0 .335h253.49v253.49H0z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 293.665h253.49V.401H0z"
	    })), /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 .067)"
	    }, /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
	      fill: "#E4EBF7",
	      mask: "url(#b)"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
	      fill: "#FF603B"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
	      fill: "#520038"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.063",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.926 73.284s1.8-.72 2.52.54",
	      stroke: "#5C2552",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
	      stroke: "#DB836E",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.326 71.724s1.84 1.12 4.16.96",
	      stroke: "#5C2552",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
	      stroke: "#DB836E",
	      strokeWidth: "1.063",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.136",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M96.973 219.373s2.882-1.153 6.34-4.034",
	      stroke: "#648BD8",
	      strokeWidth: "1.032",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
	      stroke: "#DB836E",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M109.278 112.533s3.38-3.613 7.575-4.662",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.375 123.006s9.697-2.745 11.445-.88",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
	      stroke: "#BFCDDD",
	      strokeWidth: "2",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
	      fill: "#A3B4C6"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
	      fill: "#A3B4C6"
	    }), /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#A3B4C6",
	      mask: "url(#d)",
	      d: "M154.098 190.096h70.513v-84.617h-70.513z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
	      fill: "#FFF",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
	      stroke: "#7C90A5",
	      strokeWidth: "1.124",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
	      fill: "#FFF",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M177.259 207.217v11.52M201.05 207.217v11.52",
	      stroke: "#A3B4C6",
	      strokeWidth: "1.124",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
	      fill: "#5BA02E",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
	      fill: "#92C110",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
	      fill: "#F2D7AD",
	      mask: "url(#d)"
	    })))
	  );
	};
	
	var _default = ServerError;
	exports["default"] = _default;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Unauthorized = function Unauthorized() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "251",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("path", {
	      d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
	      fill: "#E4EBF7"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#FFF",
	      strokeWidth: "2",
	      d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
	      fill: "#A26EF4"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
	      fill: "#5BA02E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
	      fill: "#92C110"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M78.18 94.656s.911 7.41-4.914 13.078",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
	      stroke: "#E4EBF7",
	      strokeWidth: ".932",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
	      fill: "#5C2552"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M91.132 86.786s5.269 4.957 12.679 2.327",
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
	      fill: "#DB836E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
	      stroke: "#5C2552",
	      strokeWidth: "1.526",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.114",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M128.31 87.934s3.013 4.121 4.06 11.785",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
	      stroke: "#DB836E",
	      strokeWidth: ".795",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M130.532 85.488s4.588 5.757 11.619 6.214",
	      stroke: "#DB836E",
	      strokeWidth: ".75",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M121.708 105.73s-.393 8.564-1.34 13.612",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.459 220.905s2.759-1.104 6.07-3.863",
	      stroke: "#648BD8",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    })))
	  );
	};
	
	var _default = Unauthorized;
	exports["default"] = _default;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// eslint-disable-next-line react/prefer-stateless-function
	var SkeletonAvatar = /*#__PURE__*/function (_React$Component) {
	  _inherits(SkeletonAvatar, _React$Component);
	
	  var _super = _createSuper(SkeletonAvatar);
	
	  function SkeletonAvatar() {
	    _classCallCheck(this, SkeletonAvatar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(SkeletonAvatar, [{
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          style = _this$props.style,
	          size = _this$props.size,
	          shape = _this$props.shape;
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
	      var shapeCls = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-circle"), shape === 'circle'), _defineProperty(_classNames2, "".concat(prefixCls, "-square"), shape === 'square'), _classNames2));
	      var sizeStyle = typeof size === 'number' ? {
	        width: size,
	        height: size,
	        lineHeight: "".concat(size, "px")
	      } : {};
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])(prefixCls, className, sizeCls, shapeCls),
	          style: _extends(_extends({}, sizeStyle), style)
	        })
	      );
	    }
	  }]);
	
	  return SkeletonAvatar;
	}(React.Component);
	
	SkeletonAvatar.defaultProps = {
	  size: 'large'
	};
	var _default = SkeletonAvatar;
	exports["default"] = _default;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Paragraph = /*#__PURE__*/function (_React$Component) {
	  _inherits(Paragraph, _React$Component);
	
	  var _super = _createSuper(Paragraph);
	
	  function Paragraph() {
	    _classCallCheck(this, Paragraph);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Paragraph, [{
	    key: "getWidth",
	    value: function getWidth(index) {
	      var _this$props = this.props,
	          width = _this$props.width,
	          _this$props$rows = _this$props.rows,
	          rows = _this$props$rows === void 0 ? 2 : _this$props$rows;
	
	      if (Array.isArray(width)) {
	        return width[index];
	      } // last paragraph
	
	
	      if (rows - 1 === index) {
	        return width;
	      }
	
	      return undefined;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          style = _this$props2.style,
	          rows = _this$props2.rows;
	
	      var rowList = _toConsumableArray(Array(rows)).map(function (_, index) {
	        return (
	          /*#__PURE__*/
	          // eslint-disable-next-line react/no-array-index-key
	          React.createElement("li", {
	            key: index,
	            style: {
	              width: _this.getWidth(index)
	            }
	          })
	        );
	      });
	
	      return (/*#__PURE__*/React.createElement("ul", {
	          className: (0, _classnames["default"])(prefixCls, className),
	          style: style
	        }, rowList)
	      );
	    }
	  }]);
	
	  return Paragraph;
	}(React.Component);
	
	var _default = Paragraph;
	exports["default"] = _default;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Title = function Title(_ref) {
	  var prefixCls = _ref.prefixCls,
	      className = _ref.className,
	      width = _ref.width,
	      style = _ref.style;
	  return (/*#__PURE__*/React.createElement("h3", {
	      className: (0, _classnames["default"])(prefixCls, className),
	      style: _extends({
	        width: width
	      }, style)
	    })
	  );
	};
	
	var _default = Title;
	exports["default"] = _default;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Avatar = _interopRequireDefault(__webpack_require__(1087));
	
	var _Title = _interopRequireDefault(__webpack_require__(1089));
	
	var _Paragraph = _interopRequireDefault(__webpack_require__(1088));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function getComponentProps(prop) {
	  if (prop && _typeof(prop) === 'object') {
	    return prop;
	  }
	
	  return {};
	}
	
	function getAvatarBasicProps(hasTitle, hasParagraph) {
	  if (hasTitle && !hasParagraph) {
	    return {
	      shape: 'square'
	    };
	  }
	
	  return {
	    shape: 'circle'
	  };
	}
	
	function getTitleBasicProps(hasAvatar, hasParagraph) {
	  if (!hasAvatar && hasParagraph) {
	    return {
	      width: '38%'
	    };
	  }
	
	  if (hasAvatar && hasParagraph) {
	    return {
	      width: '50%'
	    };
	  }
	
	  return {};
	}
	
	function getParagraphBasicProps(hasAvatar, hasTitle) {
	  var basicProps = {}; // Width
	
	  if (!hasAvatar || !hasTitle) {
	    basicProps.width = '61%';
	  } // Rows
	
	
	  if (!hasAvatar && hasTitle) {
	    basicProps.rows = 3;
	  } else {
	    basicProps.rows = 2;
	  }
	
	  return basicProps;
	}
	
	var Skeleton = /*#__PURE__*/function (_React$Component) {
	  _inherits(Skeleton, _React$Component);
	
	  var _super = _createSuper(Skeleton);
	
	  function Skeleton() {
	    var _this;
	
	    _classCallCheck(this, Skeleton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSkeleton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          loading = _this$props.loading,
	          className = _this$props.className,
	          children = _this$props.children,
	          avatar = _this$props.avatar,
	          title = _this$props.title,
	          paragraph = _this$props.paragraph,
	          active = _this$props.active;
	      var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
	
	      if (loading || !('loading' in _this.props)) {
	        var _classNames;
	
	        var hasAvatar = !!avatar;
	        var hasTitle = !!title;
	        var hasParagraph = !!paragraph; // Avatar
	
	        var avatarNode;
	
	        if (hasAvatar) {
	          var avatarProps = _extends(_extends({
	            prefixCls: "".concat(prefixCls, "-avatar")
	          }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));
	
	          avatarNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-header")
	          }, /*#__PURE__*/React.createElement(_Avatar["default"], avatarProps));
	        }
	
	        var contentNode;
	
	        if (hasTitle || hasParagraph) {
	          // Title
	          var $title;
	
	          if (hasTitle) {
	            var titleProps = _extends(_extends({
	              prefixCls: "".concat(prefixCls, "-title")
	            }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
	
	            $title = /*#__PURE__*/React.createElement(_Title["default"], titleProps);
	          } // Paragraph
	
	
	          var paragraphNode;
	
	          if (hasParagraph) {
	            var paragraphProps = _extends(_extends({
	              prefixCls: "".concat(prefixCls, "-paragraph")
	            }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
	
	            paragraphNode = /*#__PURE__*/React.createElement(_Paragraph["default"], paragraphProps);
	          }
	
	          contentNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-content")
	          }, $title, paragraphNode);
	        }
	
	        var cls = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-avatar"), hasAvatar), _defineProperty(_classNames, "".concat(prefixCls, "-active"), active), _classNames));
	        return (/*#__PURE__*/React.createElement("div", {
	            className: cls
	          }, avatarNode, contentNode)
	        );
	      }
	
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Skeleton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSkeleton)
	      );
	    }
	  }]);
	
	  return Skeleton;
	}(React.Component);
	
	Skeleton.defaultProps = {
	  avatar: false,
	  title: true,
	  paragraph: true
	};
	var _default = Skeleton;
	exports["default"] = _default;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _Slider = _interopRequireDefault(__webpack_require__(475));
	
	var _Range = _interopRequireDefault(__webpack_require__(474));
	
	var _Handle = _interopRequireDefault(__webpack_require__(503));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(122));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _this.toggleTooltipVisible = function (index, visible) {
	      _this.setState(function (_ref) {
	        var visibles = _ref.visibles;
	        return {
	          visibles: _extends(_extends({}, visibles), _defineProperty({}, index, visible))
	        };
	      });
	    };
	
	    _this.handleWithTooltip = function (_a) {
	      var tooltipPrefixCls = _a.tooltipPrefixCls,
	          prefixCls = _a.prefixCls,
	          _b = _a.info,
	          value = _b.value,
	          dragging = _b.dragging,
	          index = _b.index,
	          restProps = __rest(_b, ["value", "dragging", "index"]);
	
	      var _this$props = _this.props,
	          tipFormatter = _this$props.tipFormatter,
	          tooltipVisible = _this$props.tooltipVisible,
	          tooltipPlacement = _this$props.tooltipPlacement,
	          getTooltipPopupContainer = _this$props.getTooltipPopupContainer;
	      var visibles = _this.state.visibles;
	      var isTipFormatter = tipFormatter ? visibles[index] || dragging : false;
	      var visible = tooltipVisible || tooltipVisible === undefined && isTipFormatter;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          prefixCls: tooltipPrefixCls,
	          title: tipFormatter ? tipFormatter(value) : '',
	          visible: visible,
	          placement: tooltipPlacement || 'top',
	          transitionName: "zoom-down",
	          key: index,
	          overlayClassName: "".concat(prefixCls, "-tooltip"),
	          getPopupContainer: getTooltipPopupContainer || function () {
	            return document.body;
	          }
	        }, /*#__PURE__*/React.createElement(_Handle["default"], _extends({}, restProps, {
	          value: value,
	          onMouseEnter: function onMouseEnter() {
	            return _this.toggleTooltipVisible(index, true);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this.toggleTooltipVisible(index, false);
	          }
	        })))
	      );
	    };
	
	    _this.saveSlider = function (node) {
	      _this.rcSlider = node;
	    };
	
	    _this.renderSlider = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeTooltipPrefixCls = _a.tooltipPrefixCls,
	          range = _a.range,
	          restProps = __rest(_a, ["prefixCls", "tooltipPrefixCls", "range"]);
	
	      var prefixCls = getPrefixCls('slider', customizePrefixCls);
	      var tooltipPrefixCls = getPrefixCls('tooltip', customizeTooltipPrefixCls);
	
	      if (range) {
	        return (/*#__PURE__*/React.createElement(_Range["default"], _extends({}, restProps, {
	            ref: _this.saveSlider,
	            handle: function handle(info) {
	              return _this.handleWithTooltip({
	                tooltipPrefixCls: tooltipPrefixCls,
	                prefixCls: prefixCls,
	                info: info
	              });
	            },
	            prefixCls: prefixCls,
	            tooltipPrefixCls: tooltipPrefixCls
	          }))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_Slider["default"], _extends({}, restProps, {
	          ref: _this.saveSlider,
	          handle: function handle(info) {
	            return _this.handleWithTooltip({
	              tooltipPrefixCls: tooltipPrefixCls,
	              prefixCls: prefixCls,
	              info: info
	            });
	          },
	          prefixCls: prefixCls,
	          tooltipPrefixCls: tooltipPrefixCls
	        }))
	      );
	    };
	
	    _this.state = {
	      visibles: {}
	    };
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "focus",
	    value: function focus() {
	      this.rcSlider.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSlider.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSlider)
	      );
	    }
	  }]);
	
	  return Slider;
	}(React.Component);
	
	exports["default"] = Slider;
	Slider.defaultProps = {
	  tipFormatter: function tipFormatter(value) {
	    return value.toString();
	  }
	};

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	var _Statistic = _interopRequireDefault(__webpack_require__(578));
	
	var _utils = __webpack_require__(1095);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var REFRESH_INTERVAL = 1000 / 30;
	
	function getTime(value) {
	  return (0, _interopDefault["default"])(moment)(value).valueOf();
	}
	
	var Countdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Countdown, _React$Component);
	
	  var _super = _createSuper(Countdown);
	
	  function Countdown() {
	    var _this;
	
	    _classCallCheck(this, Countdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.syncTimer = function () {
	      var value = _this.props.value;
	      var timestamp = getTime(value);
	
	      if (timestamp >= Date.now()) {
	        _this.startTimer();
	      } else {
	        _this.stopTimer();
	      }
	    };
	
	    _this.startTimer = function () {
	      if (_this.countdownId) return;
	      _this.countdownId = window.setInterval(function () {
	        _this.forceUpdate();
	      }, REFRESH_INTERVAL);
	    };
	
	    _this.stopTimer = function () {
	      var _this$props = _this.props,
	          onFinish = _this$props.onFinish,
	          value = _this$props.value;
	
	      if (_this.countdownId) {
	        clearInterval(_this.countdownId);
	        _this.countdownId = undefined;
	        var timestamp = getTime(value);
	
	        if (onFinish && timestamp < Date.now()) {
	          onFinish();
	        }
	      }
	    };
	
	    _this.formatCountdown = function (value, config) {
	      var format = _this.props.format;
	      return (0, _utils.formatCountdown)(value, _extends(_extends({}, config), {
	        format: format
	      }));
	    }; // Countdown do not need display the timestamp
	
	
	    _this.valueRender = function (node) {
	      return (/*#__PURE__*/React.cloneElement(node, {
	          title: undefined
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Countdown, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.syncTimer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.syncTimer();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopTimer();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_Statistic["default"], _extends({
	          valueRender: this.valueRender
	        }, this.props, {
	          formatter: this.formatCountdown
	        }))
	      );
	    }
	  }]);
	
	  return Countdown;
	}(React.Component);
	
	Countdown.defaultProps = {
	  format: 'HH:mm:ss'
	};
	(0, _reactLifecyclesCompat.polyfill)(Countdown);
	var _default = Countdown;
	exports["default"] = _default;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _padEnd = _interopRequireDefault(__webpack_require__(457));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var StatisticNumber = function StatisticNumber(props) {
	  var value = props.value,
	      formatter = props.formatter,
	      precision = props.precision,
	      decimalSeparator = props.decimalSeparator,
	      _props$groupSeparator = props.groupSeparator,
	      groupSeparator = _props$groupSeparator === void 0 ? '' : _props$groupSeparator,
	      prefixCls = props.prefixCls;
	  var valueNode;
	
	  if (typeof formatter === 'function') {
	    // Customize formatter
	    valueNode = formatter(value);
	  } else {
	    // Internal formatter
	    var val = String(value);
	    var cells = val.match(/^(-?)(\d*)(\.(\d+))?$/); // Process if illegal number
	
	    if (!cells) {
	      valueNode = val;
	    } else {
	      var negative = cells[1];
	
	      var _int = cells[2] || '0';
	
	      var decimal = cells[4] || '';
	      _int = _int.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
	
	      if (typeof precision === 'number') {
	        decimal = (0, _padEnd["default"])(decimal, precision, '0').slice(0, precision);
	      }
	
	      if (decimal) {
	        decimal = "".concat(decimalSeparator).concat(decimal);
	      }
	
	      valueNode = [/*#__PURE__*/React.createElement("span", {
	        key: "int",
	        className: "".concat(prefixCls, "-content-value-int")
	      }, negative, _int), decimal && /*#__PURE__*/React.createElement("span", {
	        key: "decimal",
	        className: "".concat(prefixCls, "-content-value-decimal")
	      }, decimal)];
	    }
	  }
	
	  return (/*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-value")
	    }, valueNode)
	  );
	};
	
	var _default = StatisticNumber;
	exports["default"] = _default;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Statistic = _interopRequireDefault(__webpack_require__(578));
	
	var _Countdown = _interopRequireDefault(__webpack_require__(1092));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Statistic["default"].Countdown = _Countdown["default"];
	var _default = _Statistic["default"];
	exports["default"] = _default;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTimeStr = formatTimeStr;
	exports.formatCountdown = formatCountdown;
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _padStart = _interopRequireDefault(__webpack_require__(458));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(106));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	// Countdown
	var timeUnits = [['Y', 1000 * 60 * 60 * 24 * 365], ['M', 1000 * 60 * 60 * 24 * 30], ['D', 1000 * 60 * 60 * 24], ['H', 1000 * 60 * 60], ['m', 1000 * 60], ['s', 1000], ['S', 1]];
	
	function formatTimeStr(duration, format) {
	  var leftDuration = duration;
	  var escapeRegex = /\[[^\]]*\]/g;
	  var keepList = (format.match(escapeRegex) || []).map(function (str) {
	    return str.slice(1, -1);
	  });
	  var templateText = format.replace(escapeRegex, '[]');
	  var replacedText = timeUnits.reduce(function (current, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        name = _ref2[0],
	        unit = _ref2[1];
	
	    if (current.indexOf(name) !== -1) {
	      var value = Math.floor(leftDuration / unit);
	      leftDuration -= value * unit;
	      return current.replace(new RegExp("".concat(name, "+"), 'g'), function (match) {
	        var len = match.length;
	        return (0, _padStart["default"])(value.toString(), len, '0');
	      });
	    }
	
	    return current;
	  }, templateText);
	  var index = 0;
	  return replacedText.replace(escapeRegex, function () {
	    var match = keepList[index];
	    index += 1;
	    return match;
	  });
	}
	
	function formatCountdown(value, config) {
	  var _config$format = config.format,
	      format = _config$format === void 0 ? '' : _config$format;
	  var target = (0, _interopDefault["default"])(moment)(value).valueOf();
	  var current = (0, _interopDefault["default"])(moment)().valueOf();
	  var diff = Math.max(target - current, 0);
	  return formatTimeStr(diff, format);
	}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSteps = _interopRequireDefault(__webpack_require__(476));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Steps = /*#__PURE__*/function (_React$Component) {
	  _inherits(Steps, _React$Component);
	
	  var _super = _createSuper(Steps);
	
	  function Steps() {
	    var _this;
	
	    _classCallCheck(this, Steps);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSteps = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var prefixCls = getPrefixCls('steps', _this.props.prefixCls);
	      var iconPrefix = getPrefixCls('', _this.props.iconPrefix);
	      var icons = {
	        finish: /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "check",
	          className: "".concat(prefixCls, "-finish-icon")
	        }),
	        error: /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close",
	          className: "".concat(prefixCls, "-error-icon")
	        })
	      };
	      return (/*#__PURE__*/React.createElement(_rcSteps["default"], _extends({
	          icons: icons
	        }, _this.props, {
	          prefixCls: prefixCls,
	          iconPrefix: iconPrefix
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Steps, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSteps)
	      );
	    }
	  }]);
	
	  return Steps;
	}(React.Component);
	
	exports["default"] = Steps;
	Steps.Step = _rcSteps["default"].Step;
	Steps.defaultProps = {
	  current: 0
	};
	Steps.propTypes = {
	  prefixCls: PropTypes.string,
	  iconPrefix: PropTypes.string,
	  current: PropTypes.number
	};

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSwitch = _interopRequireDefault(__webpack_require__(477));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _wave = _interopRequireDefault(__webpack_require__(292));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Switch = /*#__PURE__*/function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  var _super = _createSuper(Switch);
	
	  function Switch(props) {
	    var _this;
	
	    _classCallCheck(this, Switch);
	
	    _this = _super.call(this, props);
	
	    _this.saveSwitch = function (node) {
	      _this.rcSwitch = node;
	    };
	
	    _this.renderSwitch = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          size = _this$props.size,
	          loading = _this$props.loading,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          disabled = _this$props.disabled;
	      var prefixCls = getPrefixCls('switch', customizePrefixCls);
	      var classes = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-small"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _classNames));
	      var loadingIcon = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "loading",
	        className: "".concat(prefixCls, "-loading-icon")
	      }) : null;
	      return (/*#__PURE__*/React.createElement(_wave["default"], {
	          insertExtraNode: true
	        }, /*#__PURE__*/React.createElement(_rcSwitch["default"], _extends({}, (0, _omit["default"])(_this.props, ['loading']), {
	          prefixCls: prefixCls,
	          className: classes,
	          disabled: disabled || loading,
	          ref: _this.saveSwitch,
	          loadingIcon: loadingIcon
	        })))
	      );
	    };
	
	    (0, _warning["default"])('checked' in props || !('value' in props), 'Switch', '`value` is not validate prop, do you mean `checked`?');
	    return _this;
	  }
	
	  _createClass(Switch, [{
	    key: "focus",
	    value: function focus() {
	      this.rcSwitch.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSwitch.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSwitch)
	      );
	    }
	  }]);
	
	  return Switch;
	}(React.Component);
	
	exports["default"] = Switch;
	Switch.__ANT_SWITCH = true;
	Switch.propTypes = {
	  prefixCls: PropTypes.string,
	  // HACK: https://github.com/ant-design/ant-design/issues/5368
	  // size=default and size=large are the same
	  size: PropTypes.oneOf(['small', 'default', 'large']),
	  className: PropTypes.string
	};

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	/* eslint-disable react/prefer-stateless-function */
	var Column = /*#__PURE__*/function (_React$Component) {
	  _inherits(Column, _React$Component);
	
	  var _super = _createSuper(Column);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _super.apply(this, arguments);
	  }
	
	  return Column;
	}(React.Component);
	
	exports["default"] = Column;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ColumnGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(ColumnGroup, _React$Component);
	
	  var _super = _createSuper(ColumnGroup);
	
	  function ColumnGroup() {
	    _classCallCheck(this, ColumnGroup);
	
	    return _super.apply(this, arguments);
	  }
	
	  return ColumnGroup;
	}(React.Component);
	
	exports["default"] = ColumnGroup;
	ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
	  return (/*#__PURE__*/React.createElement("div", {
	      className: props.className,
	      onClick: function onClick(e) {
	        return e.stopPropagation();
	      }
	    }, props.children)
	  );
	};
	
	var _default = FilterDropdownMenuWrapper;
	exports["default"] = _default;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(151));
	
	var _radio = _interopRequireDefault(__webpack_require__(234));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SelectionBox = /*#__PURE__*/function (_React$Component) {
	  _inherits(SelectionBox, _React$Component);
	
	  var _super = _createSuper(SelectionBox);
	
	  function SelectionBox(props) {
	    var _this;
	
	    _classCallCheck(this, SelectionBox);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      checked: _this.getCheckState(props)
	    };
	    return _this;
	  }
	
	  _createClass(SelectionBox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.subscribe();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribe) {
	        this.unsubscribe();
	      }
	    } // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: "getCheckState",
	    value: function getCheckState(props) {
	      var store = props.store,
	          defaultSelection = props.defaultSelection,
	          rowIndex = props.rowIndex;
	      var checked = false;
	
	      if (store.getState().selectionDirty) {
	        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
	      } else {
	        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
	      }
	
	      return checked;
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe() {
	      var _this2 = this;
	
	      var store = this.props.store;
	      this.unsubscribe = store.subscribe(function () {
	        var checked = _this2.getCheckState(_this2.props);
	
	        _this2.setState({
	          checked: checked
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          type = _a.type,
	          rowIndex = _a.rowIndex,
	          rest = __rest(_a, ["type", "rowIndex"]);
	
	      var checked = this.state.checked;
	
	      if (type === 'radio') {
	        return (/*#__PURE__*/React.createElement(_radio["default"], _extends({
	            checked: checked,
	            value: rowIndex
	          }, rest))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_checkbox["default"], _extends({
	          checked: checked
	        }, rest))
	      );
	    }
	  }]);
	
	  return SelectionBox;
	}(React.Component);
	
	exports["default"] = SelectionBox;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _checkbox = _interopRequireDefault(__webpack_require__(151));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(295));
	
	var _menu = _interopRequireDefault(__webpack_require__(299));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function checkSelection(_ref) {
	  var store = _ref.store,
	      getCheckboxPropsByItem = _ref.getCheckboxPropsByItem,
	      getRecordKey = _ref.getRecordKey,
	      data = _ref.data,
	      type = _ref.type,
	      byDefaultChecked = _ref.byDefaultChecked;
	  return byDefaultChecked ? data[type](function (item, i) {
	    return getCheckboxPropsByItem(item, i).defaultChecked;
	  }) : data[type](function (item, i) {
	    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
	  });
	}
	
	function getIndeterminateState(props) {
	  var store = props.store,
	      data = props.data;
	
	  if (!data.length) {
	    return false;
	  }
	
	  var someCheckedNotByDefaultChecked = checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'some',
	    byDefaultChecked: false
	  })) && !checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: false
	  }));
	  var someCheckedByDefaultChecked = checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'some',
	    byDefaultChecked: true
	  })) && !checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: true
	  }));
	
	  if (store.getState().selectionDirty) {
	    return someCheckedNotByDefaultChecked;
	  }
	
	  return someCheckedNotByDefaultChecked || someCheckedByDefaultChecked;
	}
	
	function getCheckState(props) {
	  var store = props.store,
	      data = props.data;
	
	  if (!data.length) {
	    return false;
	  }
	
	  if (store.getState().selectionDirty) {
	    return checkSelection(_extends(_extends({}, props), {
	      data: data,
	      type: 'every',
	      byDefaultChecked: false
	    }));
	  }
	
	  return checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: false
	  })) || checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: true
	  }));
	}
	
	var SelectionCheckboxAll = /*#__PURE__*/function (_React$Component) {
	  _inherits(SelectionCheckboxAll, _React$Component);
	
	  var _super = _createSuper(SelectionCheckboxAll);
	
	  function SelectionCheckboxAll(props) {
	    var _this;
	
	    _classCallCheck(this, SelectionCheckboxAll);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      checked: false,
	      indeterminate: false
	    };
	
	    _this.handleSelectAllChange = function (e) {
	      var checked = e.target.checked;
	
	      _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
	    };
	
	    _this.defaultSelections = props.hideDefaultSelections ? [] : [{
	      key: 'all',
	      text: props.locale.selectAll
	    }, {
	      key: 'invert',
	      text: props.locale.selectInvert
	    }];
	    return _this;
	  }
	
	  _createClass(SelectionCheckboxAll, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.subscribe();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribe) {
	        this.unsubscribe();
	      }
	    }
	  }, {
	    key: "setCheckState",
	    value: function setCheckState(props) {
	      var checked = getCheckState(props);
	      var indeterminate = getIndeterminateState(props);
	      this.setState(function (prevState) {
	        var newState = {};
	
	        if (indeterminate !== prevState.indeterminate) {
	          newState.indeterminate = indeterminate;
	        }
	
	        if (checked !== prevState.checked) {
	          newState.checked = checked;
	        }
	
	        return newState;
	      });
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe() {
	      var _this2 = this;
	
	      var store = this.props.store;
	      this.unsubscribe = store.subscribe(function () {
	        _this2.setCheckState(_this2.props);
	      });
	    }
	  }, {
	    key: "renderMenus",
	    value: function renderMenus(selections) {
	      var _this3 = this;
	
	      return selections.map(function (selection, index) {
	        return (/*#__PURE__*/React.createElement(_menu["default"].Item, {
	            key: selection.key || index
	          }, /*#__PURE__*/React.createElement("div", {
	            onClick: function onClick() {
	              _this3.props.onSelect(selection.key, index, selection.onSelect);
	            }
	          }, selection.text))
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          disabled = _this$props.disabled,
	          prefixCls = _this$props.prefixCls,
	          selections = _this$props.selections,
	          getPopupContainer = _this$props.getPopupContainer;
	      var _this$state = this.state,
	          checked = _this$state.checked,
	          indeterminate = _this$state.indeterminate;
	      var selectionPrefixCls = "".concat(prefixCls, "-selection");
	      var customSelections = null;
	
	      if (selections) {
	        var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
	        var menu = /*#__PURE__*/React.createElement(_menu["default"], {
	          className: "".concat(selectionPrefixCls, "-menu"),
	          selectedKeys: []
	        }, this.renderMenus(newSelections));
	        customSelections = newSelections.length > 0 ? /*#__PURE__*/React.createElement(_dropdown["default"], {
	          overlay: menu,
	          getPopupContainer: getPopupContainer
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(selectionPrefixCls, "-down")
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "down"
	        }))) : null;
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: selectionPrefixCls
	        }, /*#__PURE__*/React.createElement(_checkbox["default"], {
	          className: (0, _classnames["default"])(_defineProperty({}, "".concat(selectionPrefixCls, "-select-all-custom"), customSelections)),
	          checked: checked,
	          indeterminate: indeterminate,
	          disabled: disabled,
	          onChange: this.handleSelectAllChange
	        }), customSelections)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      var checked = getCheckState(props);
	      var indeterminate = getIndeterminateState(props);
	      var newState = {};
	
	      if (indeterminate !== state.indeterminate) {
	        newState.indeterminate = indeterminate;
	      }
	
	      if (checked !== state.checked) {
	        newState.checked = checked;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return SelectionCheckboxAll;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(SelectionCheckboxAll);
	var _default = SelectionCheckboxAll;
	exports["default"] = _default;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcTable = _interopRequireWildcard(__webpack_require__(479));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _filterDropdown = _interopRequireDefault(__webpack_require__(1106));
	
	var _createStore = _interopRequireDefault(__webpack_require__(1105));
	
	var _SelectionBox = _interopRequireDefault(__webpack_require__(1101));
	
	var _SelectionCheckboxAll = _interopRequireDefault(__webpack_require__(1102));
	
	var _Column = _interopRequireDefault(__webpack_require__(1098));
	
	var _ColumnGroup = _interopRequireDefault(__webpack_require__(1099));
	
	var _createBodyRow = _interopRequireDefault(__webpack_require__(1104));
	
	var _util = __webpack_require__(579);
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(290));
	
	var _pagination = _interopRequireDefault(__webpack_require__(301));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _spin = _interopRequireDefault(__webpack_require__(235));
	
	var _transButton = _interopRequireDefault(__webpack_require__(291));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _default2 = _interopRequireDefault(__webpack_require__(152));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable prefer-spread */
	
	function noop() {}
	
	function stopPropagation(e) {
	  e.stopPropagation();
	}
	
	function getRowSelection(props) {
	  return props.rowSelection || {};
	}
	
	function getColumnKey(column, index) {
	  return column.key || column.dataIndex || index;
	}
	
	function isSameColumn(a, b) {
	  if (a && b && a.key && a.key === b.key) {
	    return true;
	  }
	
	  return a === b || (0, _shallowequal["default"])(a, b, function (value, other) {
	    // https://github.com/ant-design/ant-design/issues/12737
	    if (typeof value === 'function' && typeof other === 'function') {
	      return value === other || value.toString() === other.toString();
	    } // https://github.com/ant-design/ant-design/issues/19398
	
	
	    if (Array.isArray(value) && Array.isArray(other)) {
	      return value === other || (0, _shallowequal["default"])(value, other);
	    }
	  });
	}
	
	var defaultPagination = {
	  onChange: noop,
	  onShowSizeChange: noop
	};
	/**
	 * Avoid creating new object, so that parent component's shouldComponentUpdate
	 * can works appropriately。
	 */
	
	var emptyObject = {};
	
	var createComponents = function createComponents() {
	  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var bodyRow = components && components.body && components.body.row;
	  return _extends(_extends({}, components), {
	    body: _extends(_extends({}, components.body), {
	      row: (0, _createBodyRow["default"])(bodyRow)
	    })
	  });
	};
	
	function isTheSameComponents() {
	  var components1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var components2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return components1 === components2 || ['table', 'header', 'body'].every(function (key) {
	    return (0, _shallowequal["default"])(components1[key], components2[key]);
	  });
	}
	
	function getFilteredValueColumns(state, columns) {
	  return (0, _util.flatFilter)(columns || (state || {}).columns || [], function (column) {
	    return typeof column.filteredValue !== 'undefined';
	  });
	}
	
	function getFiltersFromColumns() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var columns = arguments.length > 1 ? arguments[1] : undefined;
	  var filters = {};
	  getFilteredValueColumns(state, columns).forEach(function (col) {
	    var colKey = getColumnKey(col);
	    filters[colKey] = col.filteredValue;
	  });
	  return filters;
	}
	
	function isFiltersChanged(state, filters) {
	  if (Object.keys(filters).length !== Object.keys(state.filters).length) {
	    return true;
	  }
	
	  return Object.keys(filters).some(function (columnKey) {
	    return filters[columnKey] !== state.filters[columnKey];
	  });
	}
	
	var Table = /*#__PURE__*/function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  var _super = _createSuper(Table);
	
	  function Table(props) {
	    var _this;
	
	    _classCallCheck(this, Table);
	
	    _this = _super.call(this, props);
	
	    _this.setTableRef = function (table) {
	      _this.rcTable = table;
	    };
	
	    _this.getCheckboxPropsByItem = function (item, index) {
	      var rowSelection = getRowSelection(_this.props);
	
	      if (!rowSelection.getCheckboxProps) {
	        return {};
	      }
	
	      var key = _this.getRecordKey(item, index); // Cache checkboxProps
	
	
	      if (!_this.props.checkboxPropsCache[key]) {
	        _this.props.checkboxPropsCache[key] = rowSelection.getCheckboxProps(item) || {};
	        var checkboxProps = _this.props.checkboxPropsCache[key];
	        (0, _warning["default"])(!('checked' in checkboxProps) && !('defaultChecked' in checkboxProps), 'Table', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
	      }
	
	      return _this.props.checkboxPropsCache[key];
	    };
	
	    _this.getRecordKey = function (record, index) {
	      var rowKey = _this.props.rowKey;
	      var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
	      (0, _warning["default"])(recordKey !== undefined, 'Table', 'Each record in dataSource of table should have a unique `key` prop, ' + 'or set `rowKey` of Table to an unique primary key, ' + 'see https://u.ant.design/table-row-key');
	      return recordKey === undefined ? index : recordKey;
	    };
	
	    _this.onRow = function (prefixCls, record, index) {
	      var onRow = _this.props.onRow;
	      var custom = onRow ? onRow(record, index) : {};
	      return _extends(_extends({}, custom), {
	        prefixCls: prefixCls,
	        store: _this.props.store,
	        rowKey: _this.getRecordKey(record, index)
	      });
	    };
	
	    _this.generatePopupContainerFunc = function (getPopupContainer) {
	      var scroll = _this.props.scroll;
	      var table = _this.rcTable;
	
	      if (getPopupContainer) {
	        return getPopupContainer;
	      } // Use undefined to let rc component use default logic.
	
	
	      return scroll && table ? function () {
	        return table.tableNode;
	      } : undefined;
	    };
	
	    _this.scrollToFirstRow = function () {
	      var scroll = _this.props.scroll;
	
	      if (scroll && scroll.scrollToFirstRowOnChange !== false) {
	        (0, _scrollTo["default"])(0, {
	          getContainer: function getContainer() {
	            return _this.rcTable.bodyTable;
	          }
	        });
	      }
	    };
	
	    _this.handleFilter = function (column, nextFilters) {
	      var props = _this.props;
	
	      var pagination = _extends({}, _this.state.pagination);
	
	      var filters = _extends(_extends({}, _this.state.filters), _defineProperty({}, getColumnKey(column), nextFilters)); // Remove filters not in current columns
	
	
	      var currentColumnKeys = [];
	      (0, _util.treeMap)(_this.state.columns, function (c) {
	        if (!c.children) {
	          currentColumnKeys.push(getColumnKey(c));
	        }
	      });
	      Object.keys(filters).forEach(function (columnKey) {
	        if (currentColumnKeys.indexOf(columnKey) < 0) {
	          delete filters[columnKey];
	        }
	      });
	
	      if (props.pagination) {
	        // Reset current prop
	        pagination.current = 1;
	        pagination.onChange(pagination.current);
	      }
	
	      var newState = {
	        pagination: pagination,
	        filters: {}
	      };
	
	      var filtersToSetState = _extends({}, filters); // Remove filters which is controlled
	
	
	      getFilteredValueColumns(_this.state).forEach(function (col) {
	        var columnKey = getColumnKey(col);
	
	        if (columnKey) {
	          delete filtersToSetState[columnKey];
	        }
	      });
	
	      if (Object.keys(filtersToSetState).length > 0) {
	        newState.filters = filtersToSetState;
	      } // Controlled current prop will not respond user interaction
	
	
	      if (_typeof(props.pagination) === 'object' && 'current' in props.pagination) {
	        newState.pagination = _extends(_extends({}, pagination), {
	          current: _this.state.pagination.current
	        });
	      }
	
	      _this.setState(newState, function () {
	        _this.scrollToFirstRow();
	
	        _this.props.store.setState({
	          selectionDirty: false
	        });
	
	        var onChange = _this.props.onChange;
	
	        if (onChange) {
	          onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	            selectionDirty: false,
	            filters: filters,
	            pagination: pagination
	          })));
	        }
	      });
	    };
	
	    _this.handleSelect = function (record, rowIndex, e) {
	      var checked = e.target.checked;
	      var nativeEvent = e.nativeEvent;
	      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	
	      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);
	
	      var key = _this.getRecordKey(record, rowIndex);
	
	      var pivot = _this.state.pivot;
	
	      var rows = _this.getFlatCurrentPageData();
	
	      var realIndex = rowIndex;
	
	      if (_this.props.expandedRowRender) {
	        realIndex = rows.findIndex(function (row) {
	          return _this.getRecordKey(row, rowIndex) === key;
	        });
	      }
	
	      if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
	        var changeRowKeys = [];
	        var direction = Math.sign(pivot - realIndex);
	        var dist = Math.abs(pivot - realIndex);
	        var step = 0;
	
	        var _loop = function _loop() {
	          var i = realIndex + step * direction;
	          step += 1;
	          var row = rows[i];
	
	          var rowKey = _this.getRecordKey(row, i);
	
	          var checkboxProps = _this.getCheckboxPropsByItem(row, i);
	
	          if (!checkboxProps.disabled) {
	            if (selectedRowKeys.includes(rowKey)) {
	              if (!checked) {
	                selectedRowKeys = selectedRowKeys.filter(function (j) {
	                  return rowKey !== j;
	                });
	                changeRowKeys.push(rowKey);
	              }
	            } else if (checked) {
	              selectedRowKeys.push(rowKey);
	              changeRowKeys.push(rowKey);
	            }
	          }
	        };
	
	        while (step <= dist) {
	          _loop();
	        }
	
	        _this.setState({
	          pivot: realIndex
	        });
	
	        _this.props.store.setState({
	          selectionDirty: true
	        });
	
	        _this.setSelectedRowKeys(selectedRowKeys, {
	          selectWay: 'onSelectMultiple',
	          record: record,
	          checked: checked,
	          changeRowKeys: changeRowKeys,
	          nativeEvent: nativeEvent
	        });
	      } else {
	        if (checked) {
	          selectedRowKeys.push(_this.getRecordKey(record, realIndex));
	        } else {
	          selectedRowKeys = selectedRowKeys.filter(function (i) {
	            return key !== i;
	          });
	        }
	
	        _this.setState({
	          pivot: realIndex
	        });
	
	        _this.props.store.setState({
	          selectionDirty: true
	        });
	
	        _this.setSelectedRowKeys(selectedRowKeys, {
	          selectWay: 'onSelect',
	          record: record,
	          checked: checked,
	          changeRowKeys: undefined,
	          nativeEvent: nativeEvent
	        });
	      }
	    };
	
	    _this.handleRadioSelect = function (record, rowIndex, e) {
	      var checked = e.target.checked;
	      var nativeEvent = e.nativeEvent;
	
	      var key = _this.getRecordKey(record, rowIndex);
	
	      var selectedRowKeys = [key];
	
	      _this.props.store.setState({
	        selectionDirty: true
	      });
	
	      _this.setSelectedRowKeys(selectedRowKeys, {
	        selectWay: 'onSelect',
	        record: record,
	        checked: checked,
	        changeRowKeys: undefined,
	        nativeEvent: nativeEvent
	      });
	    };
	
	    _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
	      var data = _this.getFlatCurrentPageData();
	
	      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	
	      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);
	
	      var changeableRowKeys = data.filter(function (item, i) {
	        return !_this.getCheckboxPropsByItem(item, i).disabled;
	      }).map(function (item, i) {
	        return _this.getRecordKey(item, i);
	      });
	      var changeRowKeys = [];
	      var selectWay = 'onSelectAll';
	      var checked; // handle default selection
	
	      switch (selectionKey) {
	        case 'all':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) < 0) {
	              selectedRowKeys.push(key);
	              changeRowKeys.push(key);
	            }
	          });
	          selectWay = 'onSelectAll';
	          checked = true;
	          break;
	
	        case 'removeAll':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) >= 0) {
	              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	              changeRowKeys.push(key);
	            }
	          });
	          selectWay = 'onSelectAll';
	          checked = false;
	          break;
	
	        case 'invert':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) < 0) {
	              selectedRowKeys.push(key);
	            } else {
	              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	            }
	
	            changeRowKeys.push(key);
	            selectWay = 'onSelectInvert';
	          });
	          break;
	
	        default:
	          break;
	      }
	
	      _this.props.store.setState({
	        selectionDirty: true
	      }); // when select custom selection, callback selections[n].onSelect
	
	
	      var rowSelection = _this.props.rowSelection;
	      var customSelectionStartIndex = 2;
	
	      if (rowSelection && rowSelection.hideDefaultSelections) {
	        customSelectionStartIndex = 0;
	      }
	
	      if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
	        return onSelectFunc(changeableRowKeys);
	      }
	
	      _this.setSelectedRowKeys(selectedRowKeys, {
	        selectWay: selectWay,
	        checked: checked,
	        changeRowKeys: changeRowKeys
	      });
	    };
	
	    _this.handlePageChange = function (current) {
	      var props = _this.props;
	
	      var pagination = _extends({}, _this.state.pagination);
	
	      if (current) {
	        pagination.current = current;
	      } else {
	        pagination.current = pagination.current || 1;
	      }
	
	      for (var _len = arguments.length, otherArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        otherArguments[_key - 1] = arguments[_key];
	      }
	
	      pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
	      var newState = {
	        pagination: pagination
	      }; // Controlled current prop will not respond user interaction
	
	      if (props.pagination && _typeof(props.pagination) === 'object' && 'current' in props.pagination) {
	        newState.pagination = _extends(_extends({}, pagination), {
	          current: _this.state.pagination.current
	        });
	      }
	
	      _this.setState(newState, _this.scrollToFirstRow);
	
	      _this.props.store.setState({
	        selectionDirty: false
	      });
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	          selectionDirty: false,
	          pagination: pagination
	        })));
	      }
	    };
	
	    _this.handleShowSizeChange = function (current, pageSize) {
	      var pagination = _this.state.pagination;
	      pagination.onShowSizeChange(current, pageSize);
	
	      var nextPagination = _extends(_extends({}, pagination), {
	        pageSize: pageSize,
	        current: current
	      });
	
	      _this.setState({
	        pagination: nextPagination
	      }, _this.scrollToFirstRow);
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	          pagination: nextPagination
	        })));
	      }
	    };
	
	    _this.renderExpandIcon = function (prefixCls) {
	      return function (_ref) {
	        var expandable = _ref.expandable,
	            expanded = _ref.expanded,
	            needIndentSpaced = _ref.needIndentSpaced,
	            record = _ref.record,
	            onExpand = _ref.onExpand;
	
	        if (expandable) {
	          return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	              componentName: "Table",
	              defaultLocale: _default2["default"].Table
	            }, function (locale) {
	              var _classNames;
	
	              return (/*#__PURE__*/React.createElement(_transButton["default"], {
	                  className: (0, _classnames["default"])("".concat(prefixCls, "-row-expand-icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _defineProperty(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), _classNames)),
	                  onClick: function onClick(event) {
	                    onExpand(record, event);
	                  },
	                  "aria-label": expanded ? locale.collapse : locale.expand,
	                  noStyle: true
	                })
	              );
	            })
	          );
	        }
	
	        if (needIndentSpaced) {
	          return (/*#__PURE__*/React.createElement("span", {
	              className: "".concat(prefixCls, "-row-expand-icon ").concat(prefixCls, "-row-spaced")
	            })
	          );
	        }
	
	        return null;
	      };
	    };
	
	    _this.renderSelectionBox = function (type) {
	      return function (_, record, index) {
	        var rowKey = _this.getRecordKey(record, index);
	
	        var props = _this.getCheckboxPropsByItem(record, index);
	
	        var handleChange = function handleChange(e) {
	          return type === 'radio' ? _this.handleRadioSelect(record, index, e) : _this.handleSelect(record, index, e);
	        };
	
	        return (/*#__PURE__*/React.createElement("span", {
	            onClick: stopPropagation
	          }, /*#__PURE__*/React.createElement(_SelectionBox["default"], _extends({
	            type: type,
	            store: _this.props.store,
	            rowIndex: rowKey,
	            onChange: handleChange,
	            defaultSelection: _this.getDefaultSelection()
	          }, props)))
	        );
	      };
	    };
	
	    _this.renderTable = function (_ref2) {
	      var _classNames2;
	
	      var prefixCls = _ref2.prefixCls,
	          renderEmpty = _ref2.renderEmpty,
	          dropdownPrefixCls = _ref2.dropdownPrefixCls,
	          contextLocale = _ref2.contextLocale,
	          contextGetPopupContainer = _ref2.getPopupContainer;
	
	      var _a = _this.props,
	          showHeader = _a.showHeader,
	          locale = _a.locale,
	          getPopupContainer = _a.getPopupContainer,
	          restTableProps = __rest(_a, ["showHeader", "locale", "getPopupContainer"]); // do not pass prop.style to rc-table, since already apply it to container div
	
	
	      var restProps = (0, _omit["default"])(restTableProps, ['style']);
	
	      var data = _this.getCurrentPageData();
	
	      var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false; // use props.getPopupContainer first
	
	      var realGetPopupContainer = getPopupContainer || contextGetPopupContainer; // Merge too locales
	
	      var mergedLocale = _extends(_extends({}, contextLocale), locale);
	
	      if (!locale || !locale.emptyText) {
	        mergedLocale.emptyText = renderEmpty('Table');
	      }
	
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-").concat(_this.props.size), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-bordered"), _this.props.bordered), _defineProperty(_classNames2, "".concat(prefixCls, "-empty"), !data.length), _defineProperty(_classNames2, "".concat(prefixCls, "-without-column-header"), !showHeader), _classNames2));
	
	      var columnsWithRowSelection = _this.renderRowSelection({
	        prefixCls: prefixCls,
	        locale: mergedLocale,
	        getPopupContainer: realGetPopupContainer
	      });
	
	      var columns = _this.renderColumnsDropdown({
	        columns: columnsWithRowSelection,
	        prefixCls: prefixCls,
	        dropdownPrefixCls: dropdownPrefixCls,
	        locale: mergedLocale,
	        getPopupContainer: realGetPopupContainer
	      }).map(function (column, i) {
	        var newColumn = _extends({}, column);
	
	        newColumn.key = getColumnKey(newColumn, i);
	        return newColumn;
	      });
	
	      var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;
	
	      if ('expandIconColumnIndex' in restProps) {
	        expandIconColumnIndex = restProps.expandIconColumnIndex;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcTable["default"], _extends({
	          ref: _this.setTableRef,
	          key: "table",
	          expandIcon: _this.renderExpandIcon(prefixCls)
	        }, restProps, {
	          onRow: function onRow(record, index) {
	            return _this.onRow(prefixCls, record, index);
	          },
	          components: _this.state.components,
	          prefixCls: prefixCls,
	          data: data,
	          columns: columns,
	          showHeader: showHeader,
	          className: classString,
	          expandIconColumnIndex: expandIconColumnIndex,
	          expandIconAsCell: expandIconAsCell,
	          emptyText: mergedLocale.emptyText
	        }))
	      );
	    };
	
	    _this.renderComponent = function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls,
	          renderEmpty = _ref3.renderEmpty,
	          getPopupContainer = _ref3.getPopupContainer;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          customizeDropdownPrefixCls = _this$props.dropdownPrefixCls,
	          style = _this$props.style,
	          className = _this$props.className;
	
	      var data = _this.getCurrentPageData();
	
	      var loading = _this.props.loading;
	
	      if (typeof loading === 'boolean') {
	        loading = {
	          spinning: loading
	        };
	      }
	
	      var prefixCls = getPrefixCls('table', customizePrefixCls);
	      var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
	      var table = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Table",
	        defaultLocale: _default2["default"].Table
	      }, function (locale) {
	        return _this.renderTable({
	          prefixCls: prefixCls,
	          renderEmpty: renderEmpty,
	          dropdownPrefixCls: dropdownPrefixCls,
	          contextLocale: locale,
	          getPopupContainer: getPopupContainer
	        });
	      }); // if there is no pagination or no data,
	      // the height of spin should decrease by half of pagination
	
	      var paginationPatchClass = _this.hasPagination() && data && data.length !== 0 ? "".concat(prefixCls, "-with-pagination") : "".concat(prefixCls, "-without-pagination");
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), className),
	          style: style
	        }, /*#__PURE__*/React.createElement(_spin["default"], _extends({}, loading, {
	          className: loading.spinning ? "".concat(paginationPatchClass, " ").concat(prefixCls, "-spin-holder") : ''
	        }), _this.renderPagination(prefixCls, 'top'), table, _this.renderPagination(prefixCls, 'bottom')))
	      );
	    };
	
	    var expandedRowRender = props.expandedRowRender,
	        columnsProp = props.columns;
	    (0, _warning["default"])(!('columnsPageRange' in props || 'columnsPageSize' in props), 'Table', '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');
	
	    if (expandedRowRender && (columnsProp || []).some(function (_ref4) {
	      var fixed = _ref4.fixed;
	      return !!fixed;
	    })) {
	      (0, _warning["default"])(false, 'Table', '`expandedRowRender` and `Column.fixed` are not compatible. Please use one of them at one time.');
	    }
	
	    var columns = columnsProp || (0, _util.normalizeColumns)(props.children);
	    _this.state = _extends(_extends({}, _this.getDefaultSortOrder(columns || [])), {
	      // 减少状态
	      filters: _this.getDefaultFilters(columns),
	      pagination: _this.getDefaultPagination(props),
	      pivot: undefined,
	      prevProps: props,
	      components: createComponents(props.components),
	      columns: columns
	    });
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this$state = this.state,
	          columns = _this$state.columns,
	          sortColumn = _this$state.sortColumn,
	          sortOrder = _this$state.sortOrder;
	
	      if (this.getSortOrderColumns(columns).length > 0) {
	        var sortState = this.getSortStateFromColumns(columns);
	
	        if (!isSameColumn(sortState.sortColumn, sortColumn) || sortState.sortOrder !== sortOrder) {
	          this.setState(sortState);
	        }
	      }
	    }
	  }, {
	    key: "getDefaultSelection",
	    value: function getDefaultSelection() {
	      var _this2 = this;
	
	      var rowSelection = getRowSelection(this.props);
	
	      if (!rowSelection.getCheckboxProps) {
	        return [];
	      }
	
	      return this.getFlatData().filter(function (item, rowIndex) {
	        return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
	      }).map(function (record, rowIndex) {
	        return _this2.getRecordKey(record, rowIndex);
	      });
	    }
	  }, {
	    key: "getDefaultPagination",
	    value: function getDefaultPagination(props) {
	      var pagination = _typeof(props.pagination) === 'object' ? props.pagination : {};
	      var current;
	
	      if ('current' in pagination) {
	        current = pagination.current;
	      } else if ('defaultCurrent' in pagination) {
	        current = pagination.defaultCurrent;
	      }
	
	      var pageSize;
	
	      if ('pageSize' in pagination) {
	        pageSize = pagination.pageSize;
	      } else if ('defaultPageSize' in pagination) {
	        pageSize = pagination.defaultPageSize;
	      }
	
	      return this.hasPagination(props) ? _extends(_extends(_extends({}, defaultPagination), pagination), {
	        current: current || 1,
	        pageSize: pageSize || 10
	      }) : {};
	    }
	  }, {
	    key: "getSortOrderColumns",
	    value: function getSortOrderColumns(columns) {
	      return (0, _util.flatFilter)(columns || (this.state || {}).columns || [], function (column) {
	        return 'sortOrder' in column;
	      });
	    }
	  }, {
	    key: "getDefaultFilters",
	    value: function getDefaultFilters(columns) {
	      var definedFilters = getFiltersFromColumns(this.state, columns);
	      var defaultFilteredValueColumns = (0, _util.flatFilter)(columns || [], function (column) {
	        return typeof column.defaultFilteredValue !== 'undefined';
	      });
	      var defaultFilters = defaultFilteredValueColumns.reduce(function (soFar, col) {
	        var colKey = getColumnKey(col);
	        soFar[colKey] = col.defaultFilteredValue;
	        return soFar;
	      }, {});
	      return _extends(_extends({}, defaultFilters), definedFilters);
	    }
	  }, {
	    key: "getDefaultSortOrder",
	    value: function getDefaultSortOrder(columns) {
	      var definedSortState = this.getSortStateFromColumns(columns);
	      var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
	        return column.defaultSortOrder != null;
	      })[0];
	
	      if (defaultSortedColumn && !definedSortState.sortColumn) {
	        return {
	          sortColumn: defaultSortedColumn,
	          sortOrder: defaultSortedColumn.defaultSortOrder
	        };
	      }
	
	      return definedSortState;
	    }
	  }, {
	    key: "getSortStateFromColumns",
	    value: function getSortStateFromColumns(columns) {
	      // return first column which sortOrder is not falsy
	      var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
	        return col.sortOrder;
	      })[0];
	
	      if (sortedColumn) {
	        return {
	          sortColumn: sortedColumn,
	          sortOrder: sortedColumn.sortOrder
	        };
	      }
	
	      return {
	        sortColumn: null,
	        sortOrder: null
	      };
	    }
	  }, {
	    key: "getMaxCurrent",
	    value: function getMaxCurrent(total) {
	      var _this$state$paginatio = this.state.pagination,
	          current = _this$state$paginatio.current,
	          pageSize = _this$state$paginatio.pageSize;
	
	      if ((current - 1) * pageSize >= total) {
	        return Math.floor((total - 1) / pageSize) + 1;
	      }
	
	      return current;
	    }
	  }, {
	    key: "getSorterFn",
	    value: function getSorterFn(state) {
	      var _ref5 = state || this.state,
	          sortOrder = _ref5.sortOrder,
	          sortColumn = _ref5.sortColumn;
	
	      if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
	        return;
	      }
	
	      return function (a, b) {
	        var result = sortColumn.sorter(a, b, sortOrder);
	
	        if (result !== 0) {
	          return sortOrder === 'descend' ? -result : result;
	        }
	
	        return 0;
	      };
	    }
	  }, {
	    key: "getCurrentPageData",
	    value: function getCurrentPageData() {
	      var data = this.getLocalData();
	      var current;
	      var pageSize;
	      var state = this.state; // 如果没有分页的话，默认全部展示
	
	      if (!this.hasPagination()) {
	        pageSize = Number.MAX_VALUE;
	        current = 1;
	      } else {
	        pageSize = state.pagination.pageSize;
	        current = this.getMaxCurrent(state.pagination.total || data.length);
	      } // 分页
	      // ---
	      // 当数据量少于等于每页数量时，直接设置数据
	      // 否则进行读取分页数据
	
	
	      if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
	        data = data.slice((current - 1) * pageSize, current * pageSize);
	      }
	
	      return data;
	    }
	  }, {
	    key: "getFlatData",
	    value: function getFlatData() {
	      var childrenColumnName = this.props.childrenColumnName;
	      return (0, _util.flatArray)(this.getLocalData(null, false), childrenColumnName);
	    }
	  }, {
	    key: "getFlatCurrentPageData",
	    value: function getFlatCurrentPageData() {
	      var childrenColumnName = this.props.childrenColumnName;
	      return (0, _util.flatArray)(this.getCurrentPageData(), childrenColumnName);
	    }
	  }, {
	    key: "getLocalData",
	    value: function getLocalData(state) {
	      var _this3 = this;
	
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var currentState = state || this.state;
	      var dataSource = this.props.dataSource;
	      var data = dataSource || []; // 优化本地排序
	
	      data = data.slice(0);
	      var sorterFn = this.getSorterFn(currentState);
	
	      if (sorterFn) {
	        data = this.recursiveSort(data, sorterFn);
	      } // 筛选
	
	
	      if (filter && currentState.filters) {
	        Object.keys(currentState.filters).forEach(function (columnKey) {
	          var col = _this3.findColumn(columnKey);
	
	          if (!col) {
	            return;
	          }
	
	          var values = currentState.filters[columnKey] || [];
	
	          if (values.length === 0) {
	            return;
	          }
	
	          var onFilter = col.onFilter;
	          data = onFilter ? data.filter(function (record) {
	            return values.some(function (v) {
	              return onFilter(v, record);
	            });
	          }) : data;
	        });
	      }
	
	      return data;
	    }
	  }, {
	    key: "setSelectedRowKeys",
	    value: function setSelectedRowKeys(selectedRowKeys, selectionInfo) {
	      var _this4 = this;
	
	      var selectWay = selectionInfo.selectWay,
	          record = selectionInfo.record,
	          checked = selectionInfo.checked,
	          changeRowKeys = selectionInfo.changeRowKeys,
	          nativeEvent = selectionInfo.nativeEvent;
	      var rowSelection = getRowSelection(this.props);
	
	      if (rowSelection && !('selectedRowKeys' in rowSelection)) {
	        this.props.store.setState({
	          selectedRowKeys: selectedRowKeys
	        });
	      }
	
	      var data = this.getFlatData();
	
	      if (!rowSelection.onChange && !rowSelection[selectWay]) {
	        return;
	      }
	
	      var selectedRows = data.filter(function (row, i) {
	        return selectedRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	      });
	
	      if (rowSelection.onChange) {
	        rowSelection.onChange(selectedRowKeys, selectedRows);
	      }
	
	      if (selectWay === 'onSelect' && rowSelection.onSelect) {
	        rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
	      } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
	        var changeRows = data.filter(function (row, i) {
	          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	        });
	        rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
	      } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
	        var _changeRows = data.filter(function (row, i) {
	          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	        });
	
	        rowSelection.onSelectAll(checked, selectedRows, _changeRows);
	      } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
	        rowSelection.onSelectInvert(selectedRowKeys);
	      }
	    }
	  }, {
	    key: "toggleSortOrder",
	    value: function toggleSortOrder(column) {
	      var sortDirections = column.sortDirections || this.props.sortDirections;
	      var _this$state2 = this.state,
	          sortOrder = _this$state2.sortOrder,
	          sortColumn = _this$state2.sortColumn; // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题
	
	      var newSortOrder; // 切换另一列时，丢弃 sortOrder 的状态
	
	      if (isSameColumn(sortColumn, column) && sortOrder !== undefined) {
	        // 按照sortDirections的内容依次切换排序状态
	        var methodIndex = sortDirections.indexOf(sortOrder) + 1;
	        newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
	      } else {
	        newSortOrder = sortDirections[0];
	      }
	
	      var newState = {
	        sortOrder: newSortOrder,
	        sortColumn: newSortOrder ? column : null
	      }; // Controlled
	
	      if (this.getSortOrderColumns().length === 0) {
	        this.setState(newState, this.scrollToFirstRow);
	      }
	
	      var onChange = this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, this.prepareParamsArguments(_extends(_extends({}, this.state), newState), column));
	      }
	    }
	  }, {
	    key: "hasPagination",
	    value: function hasPagination(props) {
	      return (props || this.props).pagination !== false;
	    }
	  }, {
	    key: "isSortColumn",
	    value: function isSortColumn(column) {
	      var sortColumn = this.state.sortColumn;
	
	      if (!column || !sortColumn) {
	        return false;
	      }
	
	      return getColumnKey(sortColumn) === getColumnKey(column);
	    } // Get pagination, filters, sorter
	
	  }, {
	    key: "prepareParamsArguments",
	    value: function prepareParamsArguments(state, column) {
	      var pagination = _extends({}, state.pagination); // remove useless handle function in Table.onChange
	
	
	      delete pagination.onChange;
	      delete pagination.onShowSizeChange;
	      var filters = state.filters;
	      var sorter = {};
	      var currentColumn = column;
	
	      if (state.sortColumn && state.sortOrder) {
	        currentColumn = state.sortColumn;
	        sorter.column = state.sortColumn;
	        sorter.order = state.sortOrder;
	      }
	
	      if (currentColumn) {
	        sorter.field = currentColumn.dataIndex;
	        sorter.columnKey = getColumnKey(currentColumn);
	      }
	
	      var extra = {
	        currentDataSource: this.getLocalData(state)
	      };
	      return [pagination, filters, sorter, extra];
	    }
	  }, {
	    key: "findColumn",
	    value: function findColumn(myKey) {
	      var column;
	      (0, _util.treeMap)(this.state.columns, function (c) {
	        if (getColumnKey(c) === myKey) {
	          column = c;
	        }
	      });
	      return column;
	    }
	  }, {
	    key: "recursiveSort",
	    value: function recursiveSort(data, sorterFn) {
	      var _this5 = this;
	
	      var _this$props$childrenC = this.props.childrenColumnName,
	          childrenColumnName = _this$props$childrenC === void 0 ? 'children' : _this$props$childrenC;
	      return data.sort(sorterFn).map(function (item) {
	        return item[childrenColumnName] ? _extends(_extends({}, item), _defineProperty({}, childrenColumnName, _this5.recursiveSort(item[childrenColumnName], sorterFn))) : item;
	      });
	    }
	  }, {
	    key: "renderPagination",
	    value: function renderPagination(prefixCls, paginationPosition) {
	      // 强制不需要分页
	      if (!this.hasPagination()) {
	        return null;
	      }
	
	      var size = 'default';
	      var pagination = this.state.pagination;
	
	      if (pagination.size) {
	        size = pagination.size;
	      } else if (this.props.size === 'middle' || this.props.size === 'small') {
	        size = 'small';
	      }
	
	      var position = pagination.position || 'bottom';
	      var total = pagination.total || this.getLocalData().length;
	      return total > 0 && (position === paginationPosition || position === 'both') ? /*#__PURE__*/React.createElement(_pagination["default"], _extends({
	        key: "pagination-".concat(paginationPosition)
	      }, pagination, {
	        className: (0, _classnames["default"])(pagination.className, "".concat(prefixCls, "-pagination")),
	        onChange: this.handlePageChange,
	        total: total,
	        size: size,
	        current: this.getMaxCurrent(total),
	        onShowSizeChange: this.handleShowSizeChange
	      })) : null;
	    }
	  }, {
	    key: "renderRowSelection",
	    value: function renderRowSelection(_ref6) {
	      var _this6 = this;
	
	      var prefixCls = _ref6.prefixCls,
	          locale = _ref6.locale,
	          getPopupContainer = _ref6.getPopupContainer;
	      var rowSelection = this.props.rowSelection;
	      var columns = this.state.columns.concat();
	
	      if (rowSelection) {
	        var data = this.getFlatCurrentPageData().filter(function (item, index) {
	          if (rowSelection.getCheckboxProps) {
	            return !_this6.getCheckboxPropsByItem(item, index).disabled;
	          }
	
	          return true;
	        });
	        var selectionColumnClass = (0, _classnames["default"])("".concat(prefixCls, "-selection-column"), _defineProperty({}, "".concat(prefixCls, "-selection-column-custom"), rowSelection.selections));
	
	        var selectionColumn = _defineProperty({
	          key: 'selection-column',
	          render: this.renderSelectionBox(rowSelection.type),
	          className: selectionColumnClass,
	          fixed: rowSelection.fixed,
	          width: rowSelection.columnWidth,
	          title: rowSelection.columnTitle
	        }, _rcTable.INTERNAL_COL_DEFINE, {
	          className: "".concat(prefixCls, "-selection-col")
	        });
	
	        if (rowSelection.type !== 'radio') {
	          var checkboxAllDisabled = data.every(function (item, index) {
	            return _this6.getCheckboxPropsByItem(item, index).disabled;
	          });
	          selectionColumn.title = selectionColumn.title || /*#__PURE__*/React.createElement(_SelectionCheckboxAll["default"], {
	            store: this.props.store,
	            locale: locale,
	            data: data,
	            getCheckboxPropsByItem: this.getCheckboxPropsByItem,
	            getRecordKey: this.getRecordKey,
	            disabled: checkboxAllDisabled,
	            prefixCls: prefixCls,
	            onSelect: this.handleSelectRow,
	            selections: rowSelection.selections,
	            hideDefaultSelections: rowSelection.hideDefaultSelections,
	            getPopupContainer: this.generatePopupContainerFunc(getPopupContainer)
	          });
	        }
	
	        if ('fixed' in rowSelection) {
	          selectionColumn.fixed = rowSelection.fixed;
	        } else if (columns.some(function (column) {
	          return column.fixed === 'left' || column.fixed === true;
	        })) {
	          selectionColumn.fixed = 'left';
	        }
	
	        if (columns[0] && columns[0].key === 'selection-column') {
	          columns[0] = selectionColumn;
	        } else {
	          columns.unshift(selectionColumn);
	        }
	      }
	
	      return columns;
	    }
	  }, {
	    key: "renderColumnsDropdown",
	    value: function renderColumnsDropdown(_ref7) {
	      var _this7 = this;
	
	      var prefixCls = _ref7.prefixCls,
	          dropdownPrefixCls = _ref7.dropdownPrefixCls,
	          columns = _ref7.columns,
	          locale = _ref7.locale,
	          getPopupContainer = _ref7.getPopupContainer;
	      var _this$state3 = this.state,
	          sortOrder = _this$state3.sortOrder,
	          filters = _this$state3.filters;
	      return (0, _util.treeMap)(columns, function (column, i) {
	        var _classNames4;
	
	        var key = getColumnKey(column, i);
	        var filterDropdown;
	        var sortButton;
	        var onHeaderCell = column.onHeaderCell;
	
	        var isSortColumn = _this7.isSortColumn(column);
	
	        if (column.filters && column.filters.length > 0 || column.filterDropdown) {
	          var colFilters = key in filters ? filters[key] : [];
	          filterDropdown = /*#__PURE__*/React.createElement(_filterDropdown["default"], {
	            locale: locale,
	            column: column,
	            selectedKeys: colFilters,
	            confirmFilter: _this7.handleFilter,
	            prefixCls: "".concat(prefixCls, "-filter"),
	            dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown',
	            getPopupContainer: _this7.generatePopupContainerFunc(getPopupContainer),
	            key: "filter-dropdown"
	          });
	        }
	
	        if (column.sorter) {
	          var sortDirections = column.sortDirections || _this7.props.sortDirections;
	          var isAscend = isSortColumn && sortOrder === 'ascend';
	          var isDescend = isSortColumn && sortOrder === 'descend';
	          var ascend = sortDirections.indexOf('ascend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
	            className: "".concat(prefixCls, "-column-sorter-up ").concat(isAscend ? 'on' : 'off'),
	            type: "caret-up",
	            theme: "filled"
	          });
	          var descend = sortDirections.indexOf('descend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
	            className: "".concat(prefixCls, "-column-sorter-down ").concat(isDescend ? 'on' : 'off'),
	            type: "caret-down",
	            theme: "filled"
	          });
	          sortButton = /*#__PURE__*/React.createElement("div", {
	            title: locale.sortTitle,
	            className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter-inner"), ascend && descend && "".concat(prefixCls, "-column-sorter-inner-full")),
	            key: "sorter"
	          }, ascend, descend);
	
	          onHeaderCell = function onHeaderCell(col) {
	            var colProps = {}; // Get original first
	
	            if (column.onHeaderCell) {
	              colProps = _extends({}, column.onHeaderCell(col));
	            } // Add sorter logic
	
	
	            var onHeaderCellClick = colProps.onClick;
	
	            colProps.onClick = function () {
	              _this7.toggleSortOrder(column);
	
	              if (onHeaderCellClick) {
	                onHeaderCellClick.apply(void 0, arguments);
	              }
	            };
	
	            return colProps;
	          };
	        }
	
	        return _extends(_extends({}, column), {
	          className: (0, _classnames["default"])(column.className, (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-actions"), sortButton || filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-filters"), filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-sorters"), sortButton), _defineProperty(_classNames4, "".concat(prefixCls, "-column-sort"), isSortColumn && sortOrder), _classNames4)),
	          title: [/*#__PURE__*/React.createElement("span", {
	            key: "title",
	            className: "".concat(prefixCls, "-header-column")
	          }, /*#__PURE__*/React.createElement("div", {
	            className: sortButton ? "".concat(prefixCls, "-column-sorters") : undefined
	          }, /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-column-title")
	          }, _this7.renderColumnTitle(column.title)), /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-column-sorter")
	          }, sortButton))), filterDropdown],
	          onHeaderCell: onHeaderCell
	        });
	      });
	    }
	  }, {
	    key: "renderColumnTitle",
	    value: function renderColumnTitle(title) {
	      var _this$state4 = this.state,
	          filters = _this$state4.filters,
	          sortOrder = _this$state4.sortOrder,
	          sortColumn = _this$state4.sortColumn; // https://github.com/ant-design/ant-design/issues/11246#issuecomment-405009167
	
	      if (title instanceof Function) {
	        return title({
	          filters: filters,
	          sortOrder: sortOrder,
	          sortColumn: sortColumn
	        });
	      }
	
	      return title;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);
	
	      var nextState = _extends(_extends({}, prevState), {
	        prevProps: nextProps,
	        columns: columns
	      });
	
	      if ('pagination' in nextProps || 'pagination' in prevProps) {
	        var newPagination = _extends(_extends(_extends({}, defaultPagination), prevState.pagination), nextProps.pagination);
	
	        newPagination.current = newPagination.current || 1;
	        newPagination.pageSize = newPagination.pageSize || 10;
	        nextState = _extends(_extends({}, nextState), {
	          pagination: nextProps.pagination !== false ? newPagination : emptyObject
	        });
	      }
	
	      if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
	        nextProps.store.setState({
	          selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
	        });
	      } else if (prevProps.rowSelection && !nextProps.rowSelection) {
	        nextProps.store.setState({
	          selectedRowKeys: []
	        });
	      }
	
	      if ('dataSource' in nextProps && nextProps.dataSource !== prevProps.dataSource) {
	        nextProps.store.setState({
	          selectionDirty: false
	        });
	      } // https://github.com/ant-design/ant-design/issues/10133
	
	
	      nextProps.setCheckboxPropsCache({}); // Update filters
	
	      var filteredValueColumns = getFilteredValueColumns(nextState, nextState.columns);
	
	      if (filteredValueColumns.length > 0) {
	        var filtersFromColumns = getFiltersFromColumns(nextState, nextState.columns);
	
	        var newFilters = _extends({}, nextState.filters);
	
	        Object.keys(filtersFromColumns).forEach(function (key) {
	          newFilters[key] = filtersFromColumns[key];
	        });
	
	        if (isFiltersChanged(nextState, newFilters)) {
	          nextState = _extends(_extends({}, nextState), {
	            filters: newFilters
	          });
	        }
	      }
	
	      if (!isTheSameComponents(nextProps.components, prevProps.components)) {
	        var components = createComponents(nextProps.components);
	        nextState = _extends(_extends({}, nextState), {
	          components: components
	        });
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return Table;
	}(React.Component);
	
	Table.propTypes = {
	  dataSource: PropTypes.array,
	  columns: PropTypes.array,
	  prefixCls: PropTypes.string,
	  useFixedHeader: PropTypes.bool,
	  rowSelection: PropTypes.object,
	  className: PropTypes.string,
	  size: PropTypes.string,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  bordered: PropTypes.bool,
	  onChange: PropTypes.func,
	  locale: PropTypes.object,
	  dropdownPrefixCls: PropTypes.string,
	  sortDirections: PropTypes.array,
	  getPopupContainer: PropTypes.func
	};
	Table.defaultProps = {
	  dataSource: [],
	  useFixedHeader: false,
	  className: '',
	  size: 'default',
	  loading: false,
	  bordered: false,
	  indentSize: 20,
	  locale: {},
	  rowKey: 'key',
	  showHeader: true,
	  sortDirections: ['ascend', 'descend'],
	  childrenColumnName: 'children'
	};
	(0, _reactLifecyclesCompat.polyfill)(Table);
	
	var StoreTable = /*#__PURE__*/function (_React$Component2) {
	  _inherits(StoreTable, _React$Component2);
	
	  var _super2 = _createSuper(StoreTable);
	
	  function StoreTable(props) {
	    var _this8;
	
	    _classCallCheck(this, StoreTable);
	
	    _this8 = _super2.call(this, props);
	
	    _this8.setCheckboxPropsCache = function (cache) {
	      return _this8.CheckboxPropsCache = cache;
	    };
	
	    _this8.CheckboxPropsCache = {};
	    _this8.store = (0, _createStore["default"])({
	      selectedRowKeys: getRowSelection(props).selectedRowKeys || [],
	      selectionDirty: false
	    });
	    return _this8;
	  }
	
	  _createClass(StoreTable, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
	          store: this.store,
	          checkboxPropsCache: this.CheckboxPropsCache,
	          setCheckboxPropsCache: this.setCheckboxPropsCache
	        }))
	      );
	    }
	  }]);
	
	  return StoreTable;
	}(React.Component);
	
	StoreTable.displayName = 'withStore(Table)';
	StoreTable.Column = _Column["default"];
	StoreTable.ColumnGroup = _ColumnGroup["default"];
	var _default = StoreTable;
	exports["default"] = _default;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createBodyRow;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function createBodyRow() {
	  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';
	
	  var BodyRow = /*#__PURE__*/function (_React$Component) {
	    _inherits(BodyRow, _React$Component);
	
	    var _super = _createSuper(BodyRow);
	
	    function BodyRow(props) {
	      var _this;
	
	      _classCallCheck(this, BodyRow);
	
	      _this = _super.call(this, props);
	      _this.store = props.store;
	
	      var _this$store$getState = _this.store.getState(),
	          selectedRowKeys = _this$store$getState.selectedRowKeys;
	
	      _this.state = {
	        selected: selectedRowKeys.indexOf(props.rowKey) >= 0
	      };
	      return _this;
	    }
	
	    _createClass(BodyRow, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.subscribe();
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	        }
	      }
	    }, {
	      key: "subscribe",
	      value: function subscribe() {
	        var _this2 = this;
	
	        var _this$props = this.props,
	            store = _this$props.store,
	            rowKey = _this$props.rowKey;
	        this.unsubscribe = store.subscribe(function () {
	          var _this2$store$getState = _this2.store.getState(),
	              selectedRowKeys = _this2$store$getState.selectedRowKeys;
	
	          var selected = selectedRowKeys.indexOf(rowKey) >= 0;
	
	          if (selected !== _this2.state.selected) {
	            _this2.setState({
	              selected: selected
	            });
	          }
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var rowProps = (0, _omit["default"])(this.props, ['prefixCls', 'rowKey', 'store']);
	        var className = (0, _classnames2["default"])(this.props.className, _defineProperty({}, "".concat(this.props.prefixCls, "-row-selected"), this.state.selected));
	        return (/*#__PURE__*/React.createElement(Component, _extends(_extends({}, rowProps), {
	            className: className
	          }), this.props.children)
	        );
	      }
	    }]);
	
	    return BodyRow;
	  }(React.Component);
	
	  return BodyRow;
	}

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createStore;
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function createStore(initialState) {
	  var state = initialState;
	  var listeners = [];
	
	  function setState(partial) {
	    state = _extends(_extends({}, state), partial);
	
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	  }
	
	  function getState() {
	    return state;
	  }
	
	  function subscribe(listener) {
	    listeners.push(listener);
	    return function unsubscribe() {
	      var index = listeners.indexOf(listener);
	      listeners.splice(index, 1);
	    };
	  }
	
	  return {
	    setState: setState,
	    getState: getState,
	    subscribe: subscribe
	  };
	}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(93));
	
	var _domClosest = _interopRequireDefault(__webpack_require__(509));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(295));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(151));
	
	var _radio = _interopRequireDefault(__webpack_require__(234));
	
	var _FilterDropdownMenuWrapper = _interopRequireDefault(__webpack_require__(1100));
	
	var _util = __webpack_require__(579);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function stopPropagation(e) {
	  e.stopPropagation();
	
	  if (e.nativeEvent.stopImmediatePropagation) {
	    e.nativeEvent.stopImmediatePropagation();
	  }
	}
	
	var FilterMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(FilterMenu, _React$Component);
	
	  var _super = _createSuper(FilterMenu);
	
	  function FilterMenu(props) {
	    var _this;
	
	    _classCallCheck(this, FilterMenu);
	
	    _this = _super.call(this, props);
	
	    _this.setNeverShown = function (column) {
	      var rootNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var filterBelongToScrollBody = !!(0, _domClosest["default"])(rootNode, ".ant-table-scroll");
	
	      if (filterBelongToScrollBody) {
	        // When fixed column have filters, there will be two dropdown menus
	        // Filter dropdown menu inside scroll body should never be shown
	        // To fix https://github.com/ant-design/ant-design/issues/5010 and
	        // https://github.com/ant-design/ant-design/issues/7909
	        _this.neverShown = !!column.fixed;
	      }
	    };
	
	    _this.setSelectedKeys = function (_ref) {
	      var selectedKeys = _ref.selectedKeys;
	
	      _this.setState({
	        selectedKeys: selectedKeys
	      });
	    };
	
	    _this.handleClearFilters = function () {
	      _this.setState({
	        selectedKeys: []
	      }, _this.handleConfirm);
	    };
	
	    _this.handleConfirm = function () {
	      _this.setVisible(false); // Call `setSelectedKeys` & `confirm` in the same time will make filter data not up to date
	      // https://github.com/ant-design/ant-design/issues/12284
	
	
	      _this.setState({}, _this.confirmFilter);
	    };
	
	    _this.onVisibleChange = function (visible) {
	      _this.setVisible(visible);
	
	      var column = _this.props.column; // https://github.com/ant-design/ant-design/issues/17833
	
	      if (!visible && !(column.filterDropdown instanceof Function)) {
	        _this.confirmFilter();
	      }
	    };
	
	    _this.handleMenuItemClick = function (info) {
	      var selectedKeys = _this.state.selectedKeys;
	
	      if (!info.keyPath || info.keyPath.length <= 1) {
	        return;
	      }
	
	      var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;
	
	      if (selectedKeys && selectedKeys.indexOf(info.key) >= 0) {
	        // deselect SubMenu child
	        delete keyPathOfSelectedItem[info.key];
	      } else {
	        // select SubMenu child
	        keyPathOfSelectedItem[info.key] = info.keyPath;
	      }
	
	      _this.setState({
	        keyPathOfSelectedItem: keyPathOfSelectedItem
	      });
	    };
	
	    _this.renderFilterIcon = function () {
	      var _classNames;
	
	      var _this$props = _this.props,
	          column = _this$props.column,
	          locale = _this$props.locale,
	          prefixCls = _this$props.prefixCls,
	          selectedKeys = _this$props.selectedKeys;
	      var filtered = selectedKeys && selectedKeys.length > 0;
	      var filterIcon = column.filterIcon;
	
	      if (typeof filterIcon === 'function') {
	        filterIcon = filterIcon(filtered);
	      }
	
	      var dropdownIconClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-selected"), 'filtered' in column ? column.filtered : filtered), _defineProperty(_classNames, "".concat(prefixCls, "-open"), _this.getDropdownVisible()), _classNames));
	
	      if (!filterIcon) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            title: locale.filterTitle,
	            type: "filter",
	            theme: "filled",
	            className: dropdownIconClass,
	            onClick: stopPropagation
	          })
	        );
	      }
	
	      if ( /*#__PURE__*/React.isValidElement(filterIcon)) {
	        return (/*#__PURE__*/React.cloneElement(filterIcon, {
	            title: filterIcon.props.title || locale.filterTitle,
	            className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass, filterIcon.props.className),
	            onClick: stopPropagation
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass)
	        }, filterIcon)
	      );
	    };
	
	    var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
	    _this.state = {
	      selectedKeys: props.selectedKeys,
	      valueKeys: (0, _util.generateValueMaps)(props.column.filters),
	      keyPathOfSelectedItem: {},
	      visible: visible,
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(FilterMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var column = this.props.column;
	      this.setNeverShown(column);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var column = this.props.column;
	      this.setNeverShown(column);
	    }
	  }, {
	    key: "getDropdownVisible",
	    value: function getDropdownVisible() {
	      return this.neverShown ? false : this.state.visible;
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible) {
	      var column = this.props.column;
	
	      if (!('filterDropdownVisible' in column)) {
	        this.setState({
	          visible: visible
	        });
	      }
	
	      if (column.onFilterDropdownVisibleChange) {
	        column.onFilterDropdownVisibleChange(visible);
	      }
	    }
	  }, {
	    key: "hasSubMenu",
	    value: function hasSubMenu() {
	      var _this$props$column$fi = this.props.column.filters,
	          filters = _this$props$column$fi === void 0 ? [] : _this$props$column$fi;
	      return filters.some(function (item) {
	        return !!(item.children && item.children.length > 0);
	      });
	    }
	  }, {
	    key: "confirmFilter",
	    value: function confirmFilter() {
	      var _this$props2 = this.props,
	          column = _this$props2.column,
	          propSelectedKeys = _this$props2.selectedKeys,
	          confirmFilter = _this$props2.confirmFilter;
	      var _this$state = this.state,
	          selectedKeys = _this$state.selectedKeys,
	          valueKeys = _this$state.valueKeys;
	      var filterDropdown = column.filterDropdown;
	
	      if (!(0, _shallowequal["default"])(selectedKeys, propSelectedKeys)) {
	        confirmFilter(column, filterDropdown ? selectedKeys : selectedKeys.map(function (key) {
	          return valueKeys[key];
	        }).filter(function (key) {
	          return key !== undefined;
	        }));
	      }
	    }
	  }, {
	    key: "renderMenus",
	    value: function renderMenus(items) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          dropdownPrefixCls = _this$props3.dropdownPrefixCls,
	          prefixCls = _this$props3.prefixCls;
	      return items.map(function (item) {
	        if (item.children && item.children.length > 0) {
	          var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
	          var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
	            return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
	          });
	          var subMenuCls = (0, _classnames["default"])("".concat(prefixCls, "-dropdown-submenu"), _defineProperty({}, "".concat(dropdownPrefixCls, "-submenu-contain-selected"), containSelected));
	          return (/*#__PURE__*/React.createElement(_rcMenu.SubMenu, {
	              title: item.text,
	              popupClassName: subMenuCls,
	              key: item.value.toString()
	            }, _this2.renderMenus(item.children))
	          );
	        }
	
	        return _this2.renderMenuItem(item);
	      });
	    }
	  }, {
	    key: "renderMenuItem",
	    value: function renderMenuItem(item) {
	      var column = this.props.column;
	      var selectedKeys = this.state.selectedKeys;
	      var multiple = 'filterMultiple' in column ? column.filterMultiple : true; // We still need trade key as string since Menu render need string
	
	      var internalSelectedKeys = (selectedKeys || []).map(function (key) {
	        return key.toString();
	      });
	      var input = multiple ? /*#__PURE__*/React.createElement(_checkbox["default"], {
	        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
	      }) : /*#__PURE__*/React.createElement(_radio["default"], {
	        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
	      });
	      return (/*#__PURE__*/React.createElement(_rcMenu.Item, {
	          key: item.value
	        }, input, /*#__PURE__*/React.createElement("span", null, item.text))
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var originSelectedKeys = this.state.selectedKeys;
	      var _this$props4 = this.props,
	          column = _this$props4.column,
	          locale = _this$props4.locale,
	          prefixCls = _this$props4.prefixCls,
	          dropdownPrefixCls = _this$props4.dropdownPrefixCls,
	          getPopupContainer = _this$props4.getPopupContainer; // default multiple selection in filter dropdown
	
	      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
	      var dropdownMenuClass = (0, _classnames["default"])(_defineProperty({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !this.hasSubMenu()));
	      var filterDropdown = column.filterDropdown;
	
	      if (filterDropdown instanceof Function) {
	        filterDropdown = filterDropdown({
	          prefixCls: "".concat(dropdownPrefixCls, "-custom"),
	          setSelectedKeys: function setSelectedKeys(selectedKeys) {
	            return _this3.setSelectedKeys({
	              selectedKeys: selectedKeys
	            });
	          },
	          selectedKeys: originSelectedKeys,
	          confirm: this.handleConfirm,
	          clearFilters: this.handleClearFilters,
	          filters: column.filters,
	          visible: this.getDropdownVisible()
	        });
	      }
	
	      var menus = filterDropdown ? /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
	        className: "".concat(prefixCls, "-dropdown")
	      }, filterDropdown) : /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
	        className: "".concat(prefixCls, "-dropdown")
	      }, /*#__PURE__*/React.createElement(_rcMenu["default"], {
	        multiple: multiple,
	        onClick: this.handleMenuItemClick,
	        prefixCls: "".concat(dropdownPrefixCls, "-menu"),
	        className: dropdownMenuClass,
	        onSelect: this.setSelectedKeys,
	        onDeselect: this.setSelectedKeys,
	        selectedKeys: originSelectedKeys && originSelectedKeys.map(function (val) {
	          return val.toString();
	        }),
	        getPopupContainer: getPopupContainer
	      }, this.renderMenus(column.filters)), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-dropdown-btns")
	      }, /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-dropdown-link confirm"),
	        onClick: this.handleConfirm
	      }, locale.filterConfirm), /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-dropdown-link clear"),
	        onClick: this.handleClearFilters
	      }, locale.filterReset)));
	      return (/*#__PURE__*/React.createElement(_dropdown["default"], {
	          trigger: ['click'],
	          placement: "bottomRight",
	          overlay: menus,
	          visible: this.getDropdownVisible(),
	          onVisibleChange: this.onVisibleChange,
	          getPopupContainer: getPopupContainer,
	          forceRender: true
	        }, this.renderFilterIcon())
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var column = nextProps.column;
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	      /**
	       * if the state is visible the component should ignore updates on selectedKeys prop to avoid
	       * that the user selection is lost
	       * this happens frequently when a table is connected on some sort of realtime data
	       * Fixes https://github.com/ant-design/ant-design/issues/10289 and
	       * https://github.com/ant-design/ant-design/issues/10209
	       */
	
	      if ('selectedKeys' in nextProps && !(0, _shallowequal["default"])(prevProps.selectedKeys, nextProps.selectedKeys)) {
	        newState.selectedKeys = nextProps.selectedKeys;
	      }
	
	      if (!(0, _shallowequal["default"])((prevProps.column || {}).filters, (nextProps.column || {}).filters)) {
	        newState.valueKeys = (0, _util.generateValueMaps)(nextProps.column.filters);
	      }
	
	      if ('filterDropdownVisible' in column) {
	        newState.visible = column.filterDropdownVisible;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return FilterMenu;
	}(React.Component);
	
	FilterMenu.defaultProps = {
	  column: {}
	};
	(0, _reactLifecyclesCompat.polyfill)(FilterMenu);
	var _default = FilterMenu;
	exports["default"] = _default;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Table = _interopRequireDefault(__webpack_require__(1103));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Table["default"];
	exports["default"] = _default;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _ScrollableInkTabBar = _interopRequireDefault(__webpack_require__(480));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var TabBar = /*#__PURE__*/function (_React$Component) {
	  _inherits(TabBar, _React$Component);
	
	  var _super = _createSuper(TabBar);
	
	  function TabBar() {
	    _classCallCheck(this, TabBar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(TabBar, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          tabBarStyle = _this$props.tabBarStyle,
	          animated = _this$props.animated,
	          renderTabBar = _this$props.renderTabBar,
	          tabBarExtraContent = _this$props.tabBarExtraContent,
	          tabPosition = _this$props.tabPosition,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          size = _this$props.size,
	          type = _this$props.type;
	      var inkBarAnimated = _typeof(animated) === 'object' ? animated.inkBar : animated;
	      var isVertical = tabPosition === 'left' || tabPosition === 'right';
	      var prevIconType = isVertical ? 'up' : 'left';
	      var nextIconType = isVertical ? 'down' : 'right';
	      var prevIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-prev-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: prevIconType,
	        className: "".concat(prefixCls, "-tab-prev-icon-target")
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-next-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: nextIconType,
	        className: "".concat(prefixCls, "-tab-next-icon-target")
	      })); // Additional className for style usage
	
	      var cls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-bar"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size, "-bar"), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card-bar"), type && type.indexOf('card') >= 0), _classNames), className);
	
	      var renderProps = _extends(_extends({}, this.props), {
	        children: null,
	        inkBarAnimated: inkBarAnimated,
	        extraContent: tabBarExtraContent,
	        style: tabBarStyle,
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        className: cls
	      });
	
	      var RenderTabBar;
	
	      if (renderTabBar) {
	        RenderTabBar = renderTabBar(renderProps, _ScrollableInkTabBar["default"]);
	      } else {
	        RenderTabBar = /*#__PURE__*/React.createElement(_ScrollableInkTabBar["default"], renderProps);
	      }
	
	      return (/*#__PURE__*/React.cloneElement(RenderTabBar)
	      );
	    }
	  }]);
	
	  return TabBar;
	}(React.Component);
	
	exports["default"] = TabBar;
	TabBar.defaultProps = {
	  animated: true,
	  type: 'line'
	};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var CheckableTag = /*#__PURE__*/function (_React$Component) {
	  _inherits(CheckableTag, _React$Component);
	
	  var _super = _createSuper(CheckableTag);
	
	  function CheckableTag() {
	    var _this;
	
	    _classCallCheck(this, CheckableTag);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function () {
	      var _this$props = _this.props,
	          checked = _this$props.checked,
	          onChange = _this$props.onChange;
	
	      if (onChange) {
	        onChange(!checked);
	      }
	    };
	
	    _this.renderCheckableTag = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          checked = _a.checked,
	          restProps = __rest(_a, ["prefixCls", "className", "checked"]);
	
	      var prefixCls = getPrefixCls('tag', customizePrefixCls);
	      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checkable"), true), _defineProperty(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
	      delete restProps.onChange; // TypeScript cannot check delete now.
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, restProps, {
	          className: cls,
	          onClick: _this.handleClick
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(CheckableTag, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckableTag)
	      );
	    }
	  }]);
	
	  return CheckableTag;
	}(React.Component);
	
	exports["default"] = CheckableTag;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _TimelineItem = _interopRequireDefault(__webpack_require__(1111));
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Timeline = /*#__PURE__*/function (_React$Component) {
	  _inherits(Timeline, _React$Component);
	
	  var _super = _createSuper(Timeline);
	
	  function Timeline() {
	    var _this;
	
	    _classCallCheck(this, Timeline);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderTimeline = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          _a$pending = _a.pending,
	          pending = _a$pending === void 0 ? null : _a$pending,
	          pendingDot = _a.pendingDot,
	          children = _a.children,
	          className = _a.className,
	          reverse = _a.reverse,
	          mode = _a.mode,
	          restProps = __rest(_a, ["prefixCls", "pending", "pendingDot", "children", "className", "reverse", "mode"]);
	
	      var prefixCls = getPrefixCls('timeline', customizePrefixCls);
	      var pendingNode = typeof pending === 'boolean' ? null : pending;
	      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-pending"), !!pending), _defineProperty(_classNames, "".concat(prefixCls, "-reverse"), !!reverse), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(mode), !!mode), _classNames), className);
	      var pendingItem = pending ? /*#__PURE__*/React.createElement(_TimelineItem["default"], {
	        pending: !!pending,
	        dot: pendingDot || /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading"
	        })
	      }, pendingNode) : null;
	      var timeLineItems = reverse ? [pendingItem].concat(_toConsumableArray(React.Children.toArray(children).reverse())) : [].concat(_toConsumableArray(React.Children.toArray(children)), [pendingItem]);
	
	      var getPositionCls = function getPositionCls(ele, idx) {
	        if (mode === 'alternate') {
	          if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
	          if (ele.props.position === 'left') return "".concat(prefixCls, "-item-left");
	          return idx % 2 === 0 ? "".concat(prefixCls, "-item-left") : "".concat(prefixCls, "-item-right");
	        }
	
	        if (mode === 'left') return "".concat(prefixCls, "-item-left");
	        if (mode === 'right') return "".concat(prefixCls, "-item-right");
	        if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
	        return '';
	      }; // Remove falsy items
	
	
	      var truthyItems = timeLineItems.filter(function (item) {
	        return !!item;
	      });
	      var itemsCount = React.Children.count(truthyItems);
	      var lastCls = "".concat(prefixCls, "-item-last");
	      var items = React.Children.map(truthyItems, function (ele, idx) {
	        var pendingClass = idx === itemsCount - 2 ? lastCls : '';
	        var readyClass = idx === itemsCount - 1 ? lastCls : '';
	        return (/*#__PURE__*/React.cloneElement(ele, {
	            className: (0, _classnames["default"])([ele.props.className, !reverse && !!pending ? pendingClass : readyClass, getPositionCls(ele, idx)])
	          })
	        );
	      });
	      return (/*#__PURE__*/React.createElement("ul", _extends({}, restProps, {
	          className: classString
	        }), items)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Timeline, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTimeline)
	      );
	    }
	  }]);
	
	  return Timeline;
	}(React.Component);
	
	exports["default"] = Timeline;
	Timeline.Item = _TimelineItem["default"];
	Timeline.defaultProps = {
	  reverse: false,
	  mode: ''
	};

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TimelineItem = function TimelineItem(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames, _classNames2;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          _props$color = props.color,
	          color = _props$color === void 0 ? '' : _props$color,
	          children = props.children,
	          pending = props.pending,
	          dot = props.dot,
	          restProps = __rest(props, ["prefixCls", "className", "color", "children", "pending", "dot"]);
	
	      var prefixCls = getPrefixCls('timeline', customizePrefixCls);
	      var itemClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-item-pending"), pending), _classNames), className);
	      var dotClassName = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-item-head"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-custom"), dot), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-").concat(color), true), _classNames2));
	      return (/*#__PURE__*/React.createElement("li", _extends({}, (0, _omit["default"])(restProps, ['position']), {
	          className: itemClassName
	        }), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-tail")
	        }), /*#__PURE__*/React.createElement("div", {
	          className: dotClassName,
	          style: {
	            borderColor: /blue|red|green|gray/.test(color) ? undefined : color
	          }
	        }, dot), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-content")
	        }, children))
	      );
	    })
	  );
	};
	
	TimelineItem.defaultProps = {
	  color: 'blue',
	  pending: false,
	  position: ''
	};
	var _default = TimelineItem;
	exports["default"] = _default;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Timeline = _interopRequireDefault(__webpack_require__(1110));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Timeline["default"];
	exports["default"] = _default;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOverflowOptions = getOverflowOptions;
	exports["default"] = getPlacements;
	
	var _placements = __webpack_require__(506);
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var autoAdjustOverflowEnabled = {
	  adjustX: 1,
	  adjustY: 1
	};
	var autoAdjustOverflowDisabled = {
	  adjustX: 0,
	  adjustY: 0
	};
	var targetOffset = [0, 0];
	
	function getOverflowOptions(autoAdjustOverflow) {
	  if (typeof autoAdjustOverflow === 'boolean') {
	    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
	  }
	
	  return _extends(_extends({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
	}
	
	function getPlacements() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$arrowWidth = config.arrowWidth,
	      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
	      _config$horizontalArr = config.horizontalArrowShift,
	      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
	      _config$verticalArrow = config.verticalArrowShift,
	      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
	      _config$autoAdjustOve = config.autoAdjustOverflow,
	      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
	  var placementMap = {
	    left: {
	      points: ['cr', 'cl'],
	      offset: [-4, 0]
	    },
	    right: {
	      points: ['cl', 'cr'],
	      offset: [4, 0]
	    },
	    top: {
	      points: ['bc', 'tc'],
	      offset: [0, -4]
	    },
	    bottom: {
	      points: ['tc', 'bc'],
	      offset: [0, 4]
	    },
	    topLeft: {
	      points: ['bl', 'tc'],
	      offset: [-(horizontalArrowShift + arrowWidth), -4]
	    },
	    leftTop: {
	      points: ['tr', 'cl'],
	      offset: [-4, -(verticalArrowShift + arrowWidth)]
	    },
	    topRight: {
	      points: ['br', 'tc'],
	      offset: [horizontalArrowShift + arrowWidth, -4]
	    },
	    rightTop: {
	      points: ['tl', 'cr'],
	      offset: [4, -(verticalArrowShift + arrowWidth)]
	    },
	    bottomRight: {
	      points: ['tr', 'bc'],
	      offset: [horizontalArrowShift + arrowWidth, 4]
	    },
	    rightBottom: {
	      points: ['bl', 'cr'],
	      offset: [4, verticalArrowShift + arrowWidth]
	    },
	    bottomLeft: {
	      points: ['tl', 'bc'],
	      offset: [-(horizontalArrowShift + arrowWidth), 4]
	    },
	    leftBottom: {
	      points: ['br', 'cl'],
	      offset: [-4, verticalArrowShift + arrowWidth]
	    }
	  };
	  Object.keys(placementMap).forEach(function (key) {
	    placementMap[key] = config.arrowPointAtCenter ? _extends(_extends({}, placementMap[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow),
	      targetOffset: targetOffset
	    }) : _extends(_extends({}, _placements.placements[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow)
	    });
	    placementMap[key].ignoreShake = true;
	  });
	  return placementMap;
	}

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _PureRenderMixin = _interopRequireDefault(__webpack_require__(192));
	
	var _reactLazyLoad = _interopRequireDefault(__webpack_require__(486));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(151));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ListItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(ListItem, _React$Component);
	
	  var _super = _createSuper(ListItem);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ListItem, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          renderedText = _this$props.renderedText,
	          renderedEl = _this$props.renderedEl,
	          item = _this$props.item,
	          lazy = _this$props.lazy,
	          checked = _this$props.checked,
	          disabled = _this$props.disabled,
	          prefixCls = _this$props.prefixCls,
	          onClick = _this$props.onClick;
	      var className = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-content-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-disabled"), disabled || item.disabled), _classNames));
	      var title;
	
	      if (typeof renderedText === 'string' || typeof renderedText === 'number') {
	        title = String(renderedText);
	      }
	
	      var listItem = /*#__PURE__*/React.createElement("li", {
	        className: className,
	        title: title,
	        onClick: disabled || item.disabled ? undefined : function () {
	          return onClick(item);
	        }
	      }, /*#__PURE__*/React.createElement(_checkbox["default"], {
	        checked: checked,
	        disabled: disabled || item.disabled
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-item-text")
	      }, renderedEl));
	      var children = null;
	
	      if (lazy) {
	        var lazyProps = _extends({
	          height: 32,
	          offset: 500,
	          throttle: 0,
	          debounce: false
	        }, lazy);
	
	        children = /*#__PURE__*/React.createElement(_reactLazyLoad["default"], lazyProps, listItem);
	      } else {
	        children = listItem;
	      }
	
	      return children;
	    }
	  }]);
	
	  return ListItem;
	}(React.Component);
	
	exports["default"] = ListItem;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _list = _interopRequireDefault(__webpack_require__(1116));
	
	var _operation = _interopRequireDefault(__webpack_require__(1117));
	
	var _search = _interopRequireDefault(__webpack_require__(583));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(72));
	
	var _default2 = _interopRequireDefault(__webpack_require__(152));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Transfer = /*#__PURE__*/function (_React$Component) {
	  _inherits(Transfer, _React$Component);
	
	  var _super = _createSuper(Transfer);
	
	  function Transfer(props) {
	    var _this;
	
	    _classCallCheck(this, Transfer);
	
	    _this = _super.call(this, props);
	    _this.separatedDataSource = null;
	
	    _this.getLocale = function (transferLocale, renderEmpty) {
	      // Keep old locale props still working.
	      var oldLocale = {
	        notFoundContent: renderEmpty('Transfer')
	      };
	
	      if ('notFoundContent' in _this.props) {
	        oldLocale.notFoundContent = _this.props.notFoundContent;
	      }
	
	      if ('searchPlaceholder' in _this.props) {
	        oldLocale.searchPlaceholder = _this.props.searchPlaceholder;
	      }
	
	      return _extends(_extends(_extends({}, transferLocale), oldLocale), _this.props.locale);
	    };
	
	    _this.moveTo = function (direction) {
	      var _this$props = _this.props,
	          _this$props$targetKey = _this$props.targetKeys,
	          targetKeys = _this$props$targetKey === void 0 ? [] : _this$props$targetKey,
	          _this$props$dataSourc = _this$props.dataSource,
	          dataSource = _this$props$dataSourc === void 0 ? [] : _this$props$dataSourc,
	          onChange = _this$props.onChange;
	      var _this$state = _this.state,
	          sourceSelectedKeys = _this$state.sourceSelectedKeys,
	          targetSelectedKeys = _this$state.targetSelectedKeys;
	      var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys; // filter the disabled options
	
	      var newMoveKeys = moveKeys.filter(function (key) {
	        return !dataSource.some(function (data) {
	          return !!(key === data.key && data.disabled);
	        });
	      }); // move items to target box
	
	      var newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(function (targetKey) {
	        return newMoveKeys.indexOf(targetKey) === -1;
	      }); // empty checked keys
	
	      var oppositeDirection = direction === 'right' ? 'left' : 'right';
	
	      _this.setState(_defineProperty({}, _this.getSelectedKeysName(oppositeDirection), []));
	
	      _this.handleSelectChange(oppositeDirection, []);
	
	      if (onChange) {
	        onChange(newTargetKeys, direction, newMoveKeys);
	      }
	    };
	
	    _this.moveToLeft = function () {
	      return _this.moveTo('left');
	    };
	
	    _this.moveToRight = function () {
	      return _this.moveTo('right');
	    };
	
	    _this.onItemSelectAll = function (direction, selectedKeys, checkAll) {
	      var originalSelectedKeys = _this.state[_this.getSelectedKeysName(direction)] || [];
	      var mergedCheckedKeys = [];
	
	      if (checkAll) {
	        // Merge current keys with origin key
	        mergedCheckedKeys = Array.from(new Set([].concat(_toConsumableArray(originalSelectedKeys), _toConsumableArray(selectedKeys))));
	      } else {
	        // Remove current keys from origin keys
	        mergedCheckedKeys = originalSelectedKeys.filter(function (key) {
	          return selectedKeys.indexOf(key) === -1;
	        });
	      }
	
	      _this.handleSelectChange(direction, mergedCheckedKeys);
	
	      if (!_this.props.selectedKeys) {
	        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), mergedCheckedKeys));
	      }
	    };
	
	    _this.handleSelectAll = function (direction, filteredDataSource, checkAll) {
	      (0, _warning["default"])(false, 'Transfer', '`handleSelectAll` will be removed, please use `onSelectAll` instead.');
	
	      _this.onItemSelectAll(direction, filteredDataSource.map(function (_ref) {
	        var key = _ref.key;
	        return key;
	      }), !checkAll);
	    }; // [Legacy] Old prop `body` pass origin check as arg. It's confusing.
	    // TODO: Remove this in next version.
	
	
	    _this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
	      return _this.handleSelectAll('left', filteredDataSource, !checkAll);
	    };
	
	    _this.handleRightSelectAll = function (filteredDataSource, checkAll) {
	      return _this.handleSelectAll('right', filteredDataSource, !checkAll);
	    };
	
	    _this.onLeftItemSelectAll = function (selectedKeys, checkAll) {
	      return _this.onItemSelectAll('left', selectedKeys, checkAll);
	    };
	
	    _this.onRightItemSelectAll = function (selectedKeys, checkAll) {
	      return _this.onItemSelectAll('right', selectedKeys, checkAll);
	    };
	
	    _this.handleFilter = function (direction, e) {
	      var _this$props2 = _this.props,
	          onSearchChange = _this$props2.onSearchChange,
	          onSearch = _this$props2.onSearch;
	      var value = e.target.value;
	
	      if (onSearchChange) {
	        (0, _warning["default"])(false, 'Transfer', '`onSearchChange` is deprecated. Please use `onSearch` instead.');
	        onSearchChange(direction, e);
	      }
	
	      if (onSearch) {
	        onSearch(direction, value);
	      }
	    };
	
	    _this.handleLeftFilter = function (e) {
	      return _this.handleFilter('left', e);
	    };
	
	    _this.handleRightFilter = function (e) {
	      return _this.handleFilter('right', e);
	    };
	
	    _this.handleClear = function (direction) {
	      var onSearch = _this.props.onSearch;
	
	      if (onSearch) {
	        onSearch(direction, '');
	      }
	    };
	
	    _this.handleLeftClear = function () {
	      return _this.handleClear('left');
	    };
	
	    _this.handleRightClear = function () {
	      return _this.handleClear('right');
	    };
	
	    _this.onItemSelect = function (direction, selectedKey, checked) {
	      var _this$state2 = _this.state,
	          sourceSelectedKeys = _this$state2.sourceSelectedKeys,
	          targetSelectedKeys = _this$state2.targetSelectedKeys;
	      var holder = direction === 'left' ? _toConsumableArray(sourceSelectedKeys) : _toConsumableArray(targetSelectedKeys);
	      var index = holder.indexOf(selectedKey);
	
	      if (index > -1) {
	        holder.splice(index, 1);
	      }
	
	      if (checked) {
	        holder.push(selectedKey);
	      }
	
	      _this.handleSelectChange(direction, holder);
	
	      if (!_this.props.selectedKeys) {
	        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), holder));
	      }
	    };
	
	    _this.handleSelect = function (direction, selectedItem, checked) {
	      (0, _warning["default"])(false, 'Transfer', '`handleSelect` will be removed, please use `onSelect` instead.');
	
	      _this.onItemSelect(direction, selectedItem.key, checked);
	    };
	
	    _this.handleLeftSelect = function (selectedItem, checked) {
	      return _this.handleSelect('left', selectedItem, checked);
	    };
	
	    _this.handleRightSelect = function (selectedItem, checked) {
	      return _this.handleSelect('right', selectedItem, checked);
	    };
	
	    _this.onLeftItemSelect = function (selectedKey, checked) {
	      return _this.onItemSelect('left', selectedKey, checked);
	    };
	
	    _this.onRightItemSelect = function (selectedKey, checked) {
	      return _this.onItemSelect('right', selectedKey, checked);
	    };
	
	    _this.handleScroll = function (direction, e) {
	      var onScroll = _this.props.onScroll;
	
	      if (onScroll) {
	        onScroll(direction, e);
	      }
	    };
	
	    _this.handleLeftScroll = function (e) {
	      return _this.handleScroll('left', e);
	    };
	
	    _this.handleRightScroll = function (e) {
	      return _this.handleScroll('right', e);
	    };
	
	    _this.handleListStyle = function (listStyle, direction) {
	      if (typeof listStyle === 'function') {
	        return listStyle({
	          direction: direction
	        });
	      }
	
	      return listStyle;
	    };
	
	    _this.renderTransfer = function (transferLocale) {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	          var _classNames;
	
	          var getPrefixCls = _ref2.getPrefixCls,
	              renderEmpty = _ref2.renderEmpty;
	          var _this$props3 = _this.props,
	              customizePrefixCls = _this$props3.prefixCls,
	              className = _this$props3.className,
	              disabled = _this$props3.disabled,
	              _this$props3$operatio = _this$props3.operations,
	              operations = _this$props3$operatio === void 0 ? [] : _this$props3$operatio,
	              showSearch = _this$props3.showSearch,
	              body = _this$props3.body,
	              footer = _this$props3.footer,
	              style = _this$props3.style,
	              listStyle = _this$props3.listStyle,
	              operationStyle = _this$props3.operationStyle,
	              filterOption = _this$props3.filterOption,
	              render = _this$props3.render,
	              lazy = _this$props3.lazy,
	              children = _this$props3.children,
	              showSelectAll = _this$props3.showSelectAll;
	          var prefixCls = getPrefixCls('transfer', customizePrefixCls);
	
	          var locale = _this.getLocale(transferLocale, renderEmpty);
	
	          var _this$state3 = _this.state,
	              sourceSelectedKeys = _this$state3.sourceSelectedKeys,
	              targetSelectedKeys = _this$state3.targetSelectedKeys;
	
	          var _this$separateDataSou = _this.separateDataSource(),
	              leftDataSource = _this$separateDataSou.leftDataSource,
	              rightDataSource = _this$separateDataSou.rightDataSource;
	
	          var leftActive = targetSelectedKeys.length > 0;
	          var rightActive = sourceSelectedKeys.length > 0;
	          var cls = (0, _classnames["default"])(className, prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-customize-list"), !!children), _classNames));
	
	          var titles = _this.getTitles(locale);
	
	          return (/*#__PURE__*/React.createElement("div", {
	              className: cls,
	              style: style
	            }, /*#__PURE__*/React.createElement(_list["default"], _extends({
	              prefixCls: "".concat(prefixCls, "-list"),
	              titleText: titles[0],
	              dataSource: leftDataSource,
	              filterOption: filterOption,
	              style: _this.handleListStyle(listStyle, 'left'),
	              checkedKeys: sourceSelectedKeys,
	              handleFilter: _this.handleLeftFilter,
	              handleClear: _this.handleLeftClear,
	              handleSelect: _this.handleLeftSelect,
	              handleSelectAll: _this.handleLeftSelectAll,
	              onItemSelect: _this.onLeftItemSelect,
	              onItemSelectAll: _this.onLeftItemSelectAll,
	              render: render,
	              showSearch: showSearch,
	              body: body,
	              renderList: children,
	              footer: footer,
	              lazy: lazy,
	              onScroll: _this.handleLeftScroll,
	              disabled: disabled,
	              direction: "left",
	              showSelectAll: showSelectAll
	            }, locale)), /*#__PURE__*/React.createElement(_operation["default"], {
	              className: "".concat(prefixCls, "-operation"),
	              rightActive: rightActive,
	              rightArrowText: operations[0],
	              moveToRight: _this.moveToRight,
	              leftActive: leftActive,
	              leftArrowText: operations[1],
	              moveToLeft: _this.moveToLeft,
	              style: operationStyle,
	              disabled: disabled
	            }), /*#__PURE__*/React.createElement(_list["default"], _extends({
	              prefixCls: "".concat(prefixCls, "-list"),
	              titleText: titles[1],
	              dataSource: rightDataSource,
	              filterOption: filterOption,
	              style: _this.handleListStyle(listStyle, 'right'),
	              checkedKeys: targetSelectedKeys,
	              handleFilter: _this.handleRightFilter,
	              handleClear: _this.handleRightClear,
	              handleSelect: _this.handleRightSelect,
	              handleSelectAll: _this.handleRightSelectAll,
	              onItemSelect: _this.onRightItemSelect,
	              onItemSelectAll: _this.onRightItemSelectAll,
	              render: render,
	              showSearch: showSearch,
	              body: body,
	              renderList: children,
	              footer: footer,
	              lazy: lazy,
	              onScroll: _this.handleRightScroll,
	              disabled: disabled,
	              direction: "right",
	              showSelectAll: showSelectAll
	            }, locale)))
	          );
	        })
	      );
	    };
	
	    (0, _warning["default"])(!('notFoundContent' in props || 'searchPlaceholder' in props), 'Transfer', '`notFoundContent` and `searchPlaceholder` will be removed, ' + 'please use `locale` instead.');
	    (0, _warning["default"])(!('body' in props), 'Transfer', '`body` is internal usage and will bre removed, please use `children` instead.');
	    var _props$selectedKeys = props.selectedKeys,
	        selectedKeys = _props$selectedKeys === void 0 ? [] : _props$selectedKeys,
	        _props$targetKeys = props.targetKeys,
	        targetKeys = _props$targetKeys === void 0 ? [] : _props$targetKeys;
	    _this.state = {
	      sourceSelectedKeys: selectedKeys.filter(function (key) {
	        return targetKeys.indexOf(key) === -1;
	      }),
	      targetSelectedKeys: selectedKeys.filter(function (key) {
	        return targetKeys.indexOf(key) > -1;
	      })
	    };
	    return _this;
	  }
	
	  _createClass(Transfer, [{
	    key: "getSelectedKeysName",
	    // eslint-disable-next-line
	    value: function getSelectedKeysName(direction) {
	      return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
	    }
	  }, {
	    key: "getTitles",
	    value: function getTitles(transferLocale) {
	      var props = this.props;
	
	      if (props.titles) {
	        return props.titles;
	      }
	
	      return transferLocale.titles;
	    }
	  }, {
	    key: "handleSelectChange",
	    value: function handleSelectChange(direction, holder) {
	      var _this$state4 = this.state,
	          sourceSelectedKeys = _this$state4.sourceSelectedKeys,
	          targetSelectedKeys = _this$state4.targetSelectedKeys;
	      var onSelectChange = this.props.onSelectChange;
	
	      if (!onSelectChange) {
	        return;
	      }
	
	      if (direction === 'left') {
	        onSelectChange(holder, targetSelectedKeys);
	      } else {
	        onSelectChange(sourceSelectedKeys, holder);
	      }
	    }
	  }, {
	    key: "separateDataSource",
	    value: function separateDataSource() {
	      var _this$props4 = this.props,
	          dataSource = _this$props4.dataSource,
	          rowKey = _this$props4.rowKey,
	          _this$props4$targetKe = _this$props4.targetKeys,
	          targetKeys = _this$props4$targetKe === void 0 ? [] : _this$props4$targetKe;
	      var leftDataSource = [];
	      var rightDataSource = new Array(targetKeys.length);
	      dataSource.forEach(function (record) {
	        if (rowKey) {
	          record.key = rowKey(record);
	        } // rightDataSource should be ordered by targetKeys
	        // leftDataSource should be ordered by dataSource
	
	
	        var indexOfKey = targetKeys.indexOf(record.key);
	
	        if (indexOfKey !== -1) {
	          rightDataSource[indexOfKey] = record;
	        } else {
	          leftDataSource.push(record);
	        }
	      });
	      return {
	        leftDataSource: leftDataSource,
	        rightDataSource: rightDataSource
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Transfer",
	          defaultLocale: _default2["default"].Transfer
	        }, this.renderTransfer)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if (nextProps.selectedKeys) {
	        var targetKeys = nextProps.targetKeys || [];
	        return {
	          sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	            return !targetKeys.includes(key);
	          }),
	          targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	            return targetKeys.includes(key);
	          })
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Transfer;
	}(React.Component); // For high-level customized Transfer @dqaria
	
	
	Transfer.List = _list["default"];
	Transfer.Operation = _operation["default"];
	Transfer.Search = _search["default"];
	Transfer.defaultProps = {
	  dataSource: [],
	  locale: {},
	  showSearch: false,
	  listStyle: function listStyle() {}
	};
	Transfer.propTypes = {
	  prefixCls: PropTypes.string,
	  disabled: PropTypes.bool,
	  dataSource: PropTypes.array,
	  render: PropTypes.func,
	  targetKeys: PropTypes.array,
	  onChange: PropTypes.func,
	  height: PropTypes.number,
	  style: PropTypes.object,
	  listStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
	  operationStyle: PropTypes.object,
	  className: PropTypes.string,
	  titles: PropTypes.array,
	  operations: PropTypes.array,
	  showSearch: PropTypes.bool,
	  filterOption: PropTypes.func,
	  searchPlaceholder: PropTypes.string,
	  notFoundContent: PropTypes.node,
	  locale: PropTypes.object,
	  body: PropTypes.func,
	  footer: PropTypes.func,
	  rowKey: PropTypes.func,
	  lazy: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
	};
	(0, _reactLifecyclesCompat.polyfill)(Transfer);
	var _default = Transfer;
	exports["default"] = _default;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _PureRenderMixin = _interopRequireDefault(__webpack_require__(192));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(151));
	
	var _search = _interopRequireDefault(__webpack_require__(583));
	
	var _renderListBody = _interopRequireWildcard(__webpack_require__(1118));
	
	var _triggerEvent = _interopRequireDefault(__webpack_require__(1007));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var defaultRender = function defaultRender() {
	  return null;
	};
	
	function isRenderResultPlainObject(result) {
	  return result && ! /*#__PURE__*/React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
	}
	
	function renderListNode(renderList, props) {
	  var bodyContent = renderList ? renderList(props) : null;
	  var customize = !!bodyContent;
	
	  if (!customize) {
	    bodyContent = (0, _renderListBody["default"])(props);
	  }
	
	  return {
	    customize: customize,
	    bodyContent: bodyContent
	  };
	}
	
	var TransferList = /*#__PURE__*/function (_React$Component) {
	  _inherits(TransferList, _React$Component);
	
	  var _super = _createSuper(TransferList);
	
	  function TransferList(props) {
	    var _this;
	
	    _classCallCheck(this, TransferList);
	
	    _this = _super.call(this, props);
	
	    _this.handleFilter = function (e) {
	      var handleFilter = _this.props.handleFilter;
	      var filterValue = e.target.value;
	
	      _this.setState({
	        filterValue: filterValue
	      });
	
	      handleFilter(e);
	
	      if (!filterValue) {
	        return;
	      } // Manually trigger scroll event for lazy search bug
	      // https://github.com/ant-design/ant-design/issues/5631
	
	
	      _this.triggerScrollTimer = window.setTimeout(function () {
	        var transferNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	        var listNode = transferNode.querySelectorAll('.ant-transfer-list-content')[0];
	
	        if (listNode) {
	          (0, _triggerEvent["default"])(listNode, 'scroll');
	        }
	      }, 0);
	    };
	
	    _this.handleClear = function () {
	      var handleClear = _this.props.handleClear;
	
	      _this.setState({
	        filterValue: ''
	      });
	
	      handleClear();
	    };
	
	    _this.matchFilter = function (text, item) {
	      var filterValue = _this.state.filterValue;
	      var filterOption = _this.props.filterOption;
	
	      if (filterOption) {
	        return filterOption(filterValue, item);
	      }
	
	      return text.indexOf(filterValue) >= 0;
	    };
	
	    _this.renderItem = function (item) {
	      var _this$props$render = _this.props.render,
	          render = _this$props$render === void 0 ? defaultRender : _this$props$render;
	      var renderResult = render(item);
	      var isRenderResultPlain = isRenderResultPlainObject(renderResult);
	      return {
	        renderedText: isRenderResultPlain ? renderResult.value : renderResult,
	        renderedEl: isRenderResultPlain ? renderResult.label : renderResult,
	        item: item
	      };
	    };
	
	    _this.state = {
	      filterValue: ''
	    };
	    return _this;
	  }
	
	  _createClass(TransferList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.triggerScrollTimer);
	    }
	  }, {
	    key: "getCheckStatus",
	    value: function getCheckStatus(filteredItems) {
	      var checkedKeys = this.props.checkedKeys;
	
	      if (checkedKeys.length === 0) {
	        return 'none';
	      }
	
	      if (filteredItems.every(function (item) {
	        return checkedKeys.indexOf(item.key) >= 0 || !!item.disabled;
	      })) {
	        return 'all';
	      }
	
	      return 'part';
	    }
	  }, {
	    key: "getFilteredItems",
	    value: function getFilteredItems(dataSource, filterValue) {
	      var _this2 = this;
	
	      var filteredItems = [];
	      var filteredRenderItems = [];
	      dataSource.forEach(function (item) {
	        var renderedItem = _this2.renderItem(item);
	
	        var renderedText = renderedItem.renderedText; // Filter skip
	
	        if (filterValue && filterValue.trim() && !_this2.matchFilter(renderedText, item)) {
	          return null;
	        }
	
	        filteredItems.push(item);
	        filteredRenderItems.push(renderedItem);
	      });
	      return {
	        filteredItems: filteredItems,
	        filteredRenderItems: filteredRenderItems
	      };
	    }
	  }, {
	    key: "getListBody",
	    value: function getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled) {
	      var search = showSearch ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body-search-wrapper")
	      }, /*#__PURE__*/React.createElement(_search["default"], {
	        prefixCls: "".concat(prefixCls, "-search"),
	        onChange: this.handleFilter,
	        handleClear: this.handleClear,
	        placeholder: searchPlaceholder,
	        value: filterValue,
	        disabled: disabled
	      })) : null;
	      var listBody = bodyDom;
	
	      if (!listBody) {
	        var bodyNode;
	
	        var _renderListNode = renderListNode(renderList, _extends(_extends({}, (0, _omit["default"])(this.props, _renderListBody.OmitProps)), {
	          filteredItems: filteredItems,
	          filteredRenderItems: filteredRenderItems,
	          selectedKeys: checkedKeys
	        })),
	            bodyContent = _renderListNode.bodyContent,
	            customize = _renderListNode.customize; // We should wrap customize list body in a classNamed div to use flex layout.
	
	
	        if (customize) {
	          bodyNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-body-customize-wrapper")
	          }, bodyContent);
	        } else {
	          bodyNode = filteredItems.length ? bodyContent : /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-body-not-found")
	          }, notFoundContent);
	        }
	
	        listBody = /*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])(showSearch ? "".concat(prefixCls, "-body ").concat(prefixCls, "-body-with-search") : "".concat(prefixCls, "-body"))
	        }, search, bodyNode);
	      }
	
	      return listBody;
	    }
	  }, {
	    key: "getCheckBox",
	    value: function getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled) {
	      var checkStatus = this.getCheckStatus(filteredItems);
	      var checkedAll = checkStatus === 'all';
	      var checkAllCheckbox = showSelectAll !== false && /*#__PURE__*/React.createElement(_checkbox["default"], {
	        disabled: disabled,
	        checked: checkedAll,
	        indeterminate: checkStatus === 'part',
	        onChange: function onChange() {
	          // Only select enabled items
	          onItemSelectAll(filteredItems.filter(function (item) {
	            return !item.disabled;
	          }).map(function (_ref) {
	            var key = _ref.key;
	            return key;
	          }), !checkedAll);
	        }
	      });
	      return checkAllCheckbox;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var filterValue = this.state.filterValue;
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          dataSource = _this$props.dataSource,
	          titleText = _this$props.titleText,
	          checkedKeys = _this$props.checkedKeys,
	          disabled = _this$props.disabled,
	          body = _this$props.body,
	          footer = _this$props.footer,
	          showSearch = _this$props.showSearch,
	          style = _this$props.style,
	          searchPlaceholder = _this$props.searchPlaceholder,
	          notFoundContent = _this$props.notFoundContent,
	          itemUnit = _this$props.itemUnit,
	          itemsUnit = _this$props.itemsUnit,
	          renderList = _this$props.renderList,
	          onItemSelectAll = _this$props.onItemSelectAll,
	          showSelectAll = _this$props.showSelectAll; // Custom Layout
	
	      var footerDom = footer && footer(this.props);
	      var bodyDom = body && body(this.props);
	      var listCls = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-with-footer"), !!footerDom)); // ====================== Get filtered, checked item list ======================
	
	      var _this$getFilteredItem = this.getFilteredItems(dataSource, filterValue),
	          filteredItems = _this$getFilteredItem.filteredItems,
	          filteredRenderItems = _this$getFilteredItem.filteredRenderItems; // ================================= List Body =================================
	
	
	      var unit = dataSource.length > 1 ? itemsUnit : itemUnit;
	      var listBody = this.getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled); // ================================ List Footer ================================
	
	      var listFooter = footerDom ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, footerDom) : null;
	      var checkAllCheckbox = this.getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled); // ================================== Render ===================================
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: listCls,
	          style: style
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-header")
	        }, checkAllCheckbox, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-header-selected")
	        }, /*#__PURE__*/React.createElement("span", null, (checkedKeys.length > 0 ? "".concat(checkedKeys.length, "/") : '') + filteredItems.length, ' ', unit), /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-header-title")
	        }, titleText))), listBody, listFooter)
	      );
	    }
	  }]);
	
	  return TransferList;
	}(React.Component);
	
	exports["default"] = TransferList;
	TransferList.defaultProps = {
	  dataSource: [],
	  titleText: '',
	  showSearch: false,
	  lazy: {}
	};

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _button = _interopRequireDefault(__webpack_require__(135));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Operation = function Operation(_ref) {
	  var disabled = _ref.disabled,
	      moveToLeft = _ref.moveToLeft,
	      moveToRight = _ref.moveToRight,
	      _ref$leftArrowText = _ref.leftArrowText,
	      leftArrowText = _ref$leftArrowText === void 0 ? '' : _ref$leftArrowText,
	      _ref$rightArrowText = _ref.rightArrowText,
	      rightArrowText = _ref$rightArrowText === void 0 ? '' : _ref$rightArrowText,
	      leftActive = _ref.leftActive,
	      rightActive = _ref.rightActive,
	      className = _ref.className,
	      style = _ref.style;
	  return (/*#__PURE__*/React.createElement("div", {
	      className: className,
	      style: style
	    }, /*#__PURE__*/React.createElement(_button["default"], {
	      type: "primary",
	      size: "small",
	      disabled: disabled || !rightActive,
	      onClick: moveToRight,
	      icon: "right"
	    }, rightArrowText), /*#__PURE__*/React.createElement(_button["default"], {
	      type: "primary",
	      size: "small",
	      disabled: disabled || !leftActive,
	      onClick: moveToLeft,
	      icon: "left"
	    }, leftArrowText))
	  );
	};
	
	var _default = Operation;
	exports["default"] = _default;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OmitProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _reactDom = __webpack_require__(16);
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _raf = _interopRequireDefault(__webpack_require__(195));
	
	var _type = __webpack_require__(78);
	
	var _ListItem = _interopRequireDefault(__webpack_require__(1114));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var OmitProps = (0, _type.tuple)('handleFilter', 'handleSelect', 'handleSelectAll', 'handleClear', 'body', 'checkedKeys');
	exports.OmitProps = OmitProps;
	
	var ListBody = /*#__PURE__*/function (_React$Component) {
	  _inherits(ListBody, _React$Component);
	
	  var _super = _createSuper(ListBody);
	
	  function ListBody() {
	    var _this;
	
	    _classCallCheck(this, ListBody);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      mounted: false
	    };
	
	    _this.onItemSelect = function (item) {
	      var _this$props = _this.props,
	          onItemSelect = _this$props.onItemSelect,
	          selectedKeys = _this$props.selectedKeys;
	      var checked = selectedKeys.indexOf(item.key) >= 0;
	      onItemSelect(item.key, !checked);
	    };
	
	    return _this;
	  }
	
	  _createClass(ListBody, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mountId = (0, _raf["default"])(function () {
	        _this2.setState({
	          mounted: true
	        });
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props2 = this.props,
	          filteredRenderItems = _this$props2.filteredRenderItems,
	          lazy = _this$props2.lazy;
	
	      if (prevProps.filteredRenderItems.length !== filteredRenderItems.length && lazy !== false) {
	        // TODO: Replace this with ref when react 15 support removed.
	        var container = (0, _reactDom.findDOMNode)(this);
	
	        _raf["default"].cancel(this.lazyId);
	
	        this.lazyId = (0, _raf["default"])(function () {
	          if (container) {
	            var scrollEvent = new Event('scroll', {
	              bubbles: true
	            });
	            container.dispatchEvent(scrollEvent);
	          }
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountId);
	
	      _raf["default"].cancel(this.lazyId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var mounted = this.state.mounted;
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          onScroll = _this$props3.onScroll,
	          filteredRenderItems = _this$props3.filteredRenderItems,
	          lazy = _this$props3.lazy,
	          selectedKeys = _this$props3.selectedKeys,
	          globalDisabled = _this$props3.disabled;
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "ul",
	          componentProps: {
	            onScroll: onScroll
	          },
	          className: "".concat(prefixCls, "-content"),
	          transitionName: mounted ? "".concat(prefixCls, "-content-item-highlight") : '',
	          transitionLeave: false
	        }, filteredRenderItems.map(function (_ref) {
	          var renderedEl = _ref.renderedEl,
	              renderedText = _ref.renderedText,
	              item = _ref.item;
	          var disabled = item.disabled;
	          var checked = selectedKeys.indexOf(item.key) >= 0;
	          return (/*#__PURE__*/React.createElement(_ListItem["default"], {
	              disabled: globalDisabled || disabled,
	              key: item.key,
	              item: item,
	              lazy: lazy,
	              renderedText: renderedText,
	              renderedEl: renderedEl,
	              checked: checked,
	              prefixCls: prefixCls,
	              onClick: _this3.onItemSelect
	            })
	          );
	        }))
	      );
	    }
	  }]);
	
	  return ListBody;
	}(React.Component);
	
	var ListBodyWrapper = function ListBodyWrapper(props) {
	  return (/*#__PURE__*/React.createElement(ListBody, props)
	  );
	};
	
	var _default = ListBodyWrapper;
	exports["default"] = _default;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcTreeSelect = _interopRequireWildcard(__webpack_require__(484));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(13);
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _reactNode = __webpack_require__(553);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TreeSelect = /*#__PURE__*/function (_React$Component) {
	  _inherits(TreeSelect, _React$Component);
	
	  var _super = _createSuper(TreeSelect);
	
	  function TreeSelect(props) {
	    var _this;
	
	    _classCallCheck(this, TreeSelect);
	
	    _this = _super.call(this, props);
	
	    _this.saveTreeSelect = function (node) {
	      _this.rcTreeSelect = node;
	    };
	
	    _this.renderSwitcherIcon = function (prefixCls, _ref) {
	      var isLeaf = _ref.isLeaf,
	          loading = _ref.loading;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading",
	            className: "".concat(prefixCls, "-switcher-loading-icon")
	          })
	        );
	      }
	
	      if (isLeaf) {
	        return null;
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "caret-down",
	          className: "".concat(prefixCls, "-switcher-icon")
	        })
	      );
	    };
	
	    _this.renderTreeSelect = function (_ref2) {
	      var _classNames;
	
	      var getContextPopupContainer = _ref2.getPopupContainer,
	          getPrefixCls = _ref2.getPrefixCls,
	          renderEmpty = _ref2.renderEmpty;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          size = _a.size,
	          notFoundContent = _a.notFoundContent,
	          dropdownStyle = _a.dropdownStyle,
	          dropdownClassName = _a.dropdownClassName,
	          suffixIcon = _a.suffixIcon,
	          removeIcon = _a.removeIcon,
	          clearIcon = _a.clearIcon,
	          getPopupContainer = _a.getPopupContainer,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "notFoundContent", "dropdownStyle", "dropdownClassName", "suffixIcon", "removeIcon", "clearIcon", "getPopupContainer"]);
	
	      var rest = (0, _omit["default"])(restProps, ['inputIcon', 'removeIcon', 'clearIcon', 'switcherIcon']);
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className); // showSearch: single - false, multiple - true
	
	      var showSearch = restProps.showSearch;
	
	      if (!('showSearch' in restProps)) {
	        showSearch = !!(restProps.multiple || restProps.treeCheckable);
	      }
	
	      var checkable = rest.treeCheckable;
	
	      if (checkable) {
	        checkable = /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-tree-checkbox-inner")
	        });
	      }
	
	      var inputIcon = suffixIcon ? (0, _reactNode.cloneElement)(suffixIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-arrow-icon")
	      });
	      var finalRemoveIcon = removeIcon ? (0, _reactNode.cloneElement)(removeIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        className: "".concat(prefixCls, "-remove-icon")
	      });
	      var finalClearIcon = clearIcon ? (0, _reactNode.cloneElement)(clearIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-clear-icon")
	      });
	      return (/*#__PURE__*/React.createElement(_rcTreeSelect["default"], _extends({
	          switcherIcon: function switcherIcon(nodeProps) {
	            return _this.renderSwitcherIcon(prefixCls, nodeProps);
	          },
	          inputIcon: inputIcon,
	          removeIcon: finalRemoveIcon,
	          clearIcon: finalClearIcon
	        }, rest, {
	          showSearch: showSearch,
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          dropdownClassName: (0, _classnames["default"])(dropdownClassName, "".concat(prefixCls, "-tree-dropdown")),
	          prefixCls: prefixCls,
	          className: cls,
	          dropdownStyle: _extends({
	            maxHeight: '100vh',
	            overflow: 'auto'
	          }, dropdownStyle),
	          treeCheckable: checkable,
	          notFoundContent: notFoundContent || renderEmpty('Select'),
	          ref: _this.saveTreeSelect
	        }))
	      );
	    };
	
	    (0, _warning["default"])(props.multiple !== false || !props.treeCheckable, 'TreeSelect', '`multiple` will alway be `true` when `treeCheckable` is true');
	    return _this;
	  }
	
	  _createClass(TreeSelect, [{
	    key: "focus",
	    value: function focus() {
	      this.rcTreeSelect.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcTreeSelect.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTreeSelect)
	      );
	    }
	  }]);
	
	  return TreeSelect;
	}(React.Component);
	
	exports["default"] = TreeSelect;
	TreeSelect.TreeNode = _rcTreeSelect.TreeNode;
	TreeSelect.SHOW_ALL = _rcTreeSelect.SHOW_ALL;
	TreeSelect.SHOW_PARENT = _rcTreeSelect.SHOW_PARENT;
	TreeSelect.SHOW_CHILD = _rcTreeSelect.SHOW_CHILD;
	TreeSelect.defaultProps = {
	  transitionName: 'slide-up',
	  choiceTransitionName: 'zoom'
	};

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _util = __webpack_require__(182);
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _configProvider = __webpack_require__(13);
	
	var _Tree = _interopRequireDefault(__webpack_require__(584));
	
	var _util2 = __webpack_require__(1122);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getIcon(props) {
	  var isLeaf = props.isLeaf,
	      expanded = props.expanded;
	
	  if (isLeaf) {
	    return (/*#__PURE__*/React.createElement(_icon["default"], {
	        type: "file"
	      })
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement(_icon["default"], {
	      type: expanded ? 'folder-open' : 'folder'
	    })
	  );
	}
	
	var DirectoryTree = /*#__PURE__*/function (_React$Component) {
	  _inherits(DirectoryTree, _React$Component);
	
	  var _super = _createSuper(DirectoryTree);
	
	  function DirectoryTree(props) {
	    var _this;
	
	    _classCallCheck(this, DirectoryTree);
	
	    _this = _super.call(this, props);
	
	    _this.onExpand = function (expandedKeys, info) {
	      var onExpand = _this.props.onExpand;
	
	      _this.setUncontrolledState({
	        expandedKeys: expandedKeys
	      }); // Call origin function
	
	
	      if (onExpand) {
	        return onExpand(expandedKeys, info);
	      }
	
	      return undefined;
	    };
	
	    _this.onClick = function (event, node) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          expandAction = _this$props.expandAction; // Expand the tree
	
	      if (expandAction === 'click') {
	        _this.onDebounceExpand(event, node);
	      }
	
	      if (onClick) {
	        onClick(event, node);
	      }
	    };
	
	    _this.onDoubleClick = function (event, node) {
	      var _this$props2 = _this.props,
	          onDoubleClick = _this$props2.onDoubleClick,
	          expandAction = _this$props2.expandAction; // Expand the tree
	
	      if (expandAction === 'doubleClick') {
	        _this.onDebounceExpand(event, node);
	      }
	
	      if (onDoubleClick) {
	        onDoubleClick(event, node);
	      }
	    };
	
	    _this.onSelect = function (keys, event) {
	      var _this$props3 = _this.props,
	          onSelect = _this$props3.onSelect,
	          multiple = _this$props3.multiple,
	          children = _this$props3.children;
	      var _this$state$expandedK = _this.state.expandedKeys,
	          expandedKeys = _this$state$expandedK === void 0 ? [] : _this$state$expandedK;
	      var node = event.node,
	          nativeEvent = event.nativeEvent;
	      var _node$props$eventKey = node.props.eventKey,
	          eventKey = _node$props$eventKey === void 0 ? '' : _node$props$eventKey;
	      var newState = {}; // We need wrap this event since some value is not same
	
	      var newEvent = _extends(_extends({}, event), {
	        selected: true
	      }); // Windows / Mac single pick
	
	
	      var ctrlPick = nativeEvent.ctrlKey || nativeEvent.metaKey;
	      var shiftPick = nativeEvent.shiftKey; // Generate new selected keys
	
	      var newSelectedKeys;
	
	      if (multiple && ctrlPick) {
	        // Control click
	        newSelectedKeys = keys;
	        _this.lastSelectedKey = eventKey;
	        _this.cachedSelectedKeys = newSelectedKeys;
	        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
	      } else if (multiple && shiftPick) {
	        // Shift click
	        newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(_this.cachedSelectedKeys || []), _toConsumableArray((0, _util2.calcRangeKeys)(children, expandedKeys, eventKey, _this.lastSelectedKey)))));
	        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
	      } else {
	        // Single click
	        newSelectedKeys = [eventKey];
	        _this.lastSelectedKey = eventKey;
	        _this.cachedSelectedKeys = newSelectedKeys;
	        newEvent.selectedNodes = [event.node];
	      }
	
	      newState.selectedKeys = newSelectedKeys;
	
	      if (onSelect) {
	        onSelect(newSelectedKeys, newEvent);
	      }
	
	      _this.setUncontrolledState(newState);
	    };
	
	    _this.setTreeRef = function (node) {
	      _this.tree = node;
	    };
	
	    _this.expandFolderNode = function (event, node) {
	      var isLeaf = node.props.isLeaf;
	
	      if (isLeaf || event.shiftKey || event.metaKey || event.ctrlKey) {
	        return;
	      } // Get internal rc-tree
	
	
	      var internalTree = _this.tree.tree; // Call internal rc-tree expand function
	      // https://github.com/ant-design/ant-design/issues/12567
	
	      internalTree.onNodeExpand(event, node);
	    };
	
	    _this.setUncontrolledState = function (state) {
	      var newState = (0, _omit["default"])(state, Object.keys(_this.props));
	
	      if (Object.keys(newState).length) {
	        _this.setState(newState);
	      }
	    };
	
	    _this.renderDirectoryTree = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          props = __rest(_a, ["prefixCls", "className"]);
	
	      var _this$state = _this.state,
	          expandedKeys = _this$state.expandedKeys,
	          selectedKeys = _this$state.selectedKeys;
	      var prefixCls = getPrefixCls('tree', customizePrefixCls);
	      var connectClassName = (0, _classnames["default"])("".concat(prefixCls, "-directory"), className);
	      return (/*#__PURE__*/React.createElement(_Tree["default"], _extends({
	          icon: getIcon,
	          ref: _this.setTreeRef
	        }, props, {
	          prefixCls: prefixCls,
	          className: connectClassName,
	          expandedKeys: expandedKeys,
	          selectedKeys: selectedKeys,
	          onSelect: _this.onSelect,
	          onClick: _this.onClick,
	          onDoubleClick: _this.onDoubleClick,
	          onExpand: _this.onExpand
	        }))
	      );
	    };
	
	    var defaultExpandAll = props.defaultExpandAll,
	        defaultExpandParent = props.defaultExpandParent,
	        expandedKeys = props.expandedKeys,
	        defaultExpandedKeys = props.defaultExpandedKeys,
	        children = props.children;
	
	    var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
	        keyEntities = _convertTreeToEntitie.keyEntities; // Selected keys
	
	
	    _this.state = {
	      selectedKeys: props.selectedKeys || props.defaultSelectedKeys || []
	    }; // Expanded keys
	
	    if (defaultExpandAll) {
	      if (props.treeData) {
	        _this.state.expandedKeys = (0, _util2.getFullKeyListByTreeData)(props.treeData);
	      } else {
	        _this.state.expandedKeys = (0, _util2.getFullKeyList)(props.children);
	      }
	    } else if (defaultExpandParent) {
	      _this.state.expandedKeys = (0, _util.conductExpandParent)(expandedKeys || defaultExpandedKeys, keyEntities);
	    } else {
	      _this.state.expandedKeys = expandedKeys || defaultExpandedKeys;
	    }
	
	    _this.onDebounceExpand = (0, _debounce["default"])(_this.expandFolderNode, 200, {
	      leading: true
	    });
	    return _this;
	  }
	
	  _createClass(DirectoryTree, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDirectoryTree)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	
	      if ('expandedKeys' in nextProps) {
	        newState.expandedKeys = nextProps.expandedKeys;
	      }
	
	      if ('selectedKeys' in nextProps) {
	        newState.selectedKeys = nextProps.selectedKeys;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return DirectoryTree;
	}(React.Component);
	
	DirectoryTree.defaultProps = {
	  showIcon: true,
	  expandAction: 'click'
	};
	(0, _reactLifecyclesCompat.polyfill)(DirectoryTree);
	var _default = DirectoryTree;
	exports["default"] = _default;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Tree = _interopRequireDefault(__webpack_require__(584));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Tree["default"];
	exports["default"] = _default;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFullKeyList = getFullKeyList;
	exports.calcRangeKeys = calcRangeKeys;
	exports.convertDirectoryKeysToNodes = convertDirectoryKeysToNodes;
	exports.getFullKeyListByTreeData = getFullKeyListByTreeData;
	
	var _util = __webpack_require__(182);
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var Record;
	
	(function (Record) {
	  Record[Record["None"] = 0] = "None";
	  Record[Record["Start"] = 1] = "Start";
	  Record[Record["End"] = 2] = "End";
	})(Record || (Record = {})); // TODO: Move this logic into `rc-tree`
	
	
	function traverseNodesKey(rootChildren, callback) {
	  var nodeList = (0, _util.getNodeChildren)(rootChildren) || [];
	
	  function processNode(node) {
	    var key = node.key,
	        children = node.props.children;
	
	    if (callback(key, node) !== false) {
	      traverseNodesKey(children, callback);
	    }
	  }
	
	  nodeList.forEach(processNode);
	}
	
	function getFullKeyList(children) {
	  var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
	      keyEntities = _convertTreeToEntitie.keyEntities;
	
	  return Object.keys(keyEntities);
	}
	/** 计算选中范围，只考虑expanded情况以优化性能 */
	
	function calcRangeKeys(rootChildren, expandedKeys, startKey, endKey) {
	  var keys = [];
	  var record = Record.None;
	
	  if (startKey && startKey === endKey) {
	    return [startKey];
	  }
	
	  if (!startKey || !endKey) {
	    return [];
	  }
	
	  function matchKey(key) {
	    return key === startKey || key === endKey;
	  }
	
	  traverseNodesKey(rootChildren, function (key) {
	    if (record === Record.End) {
	      return false;
	    }
	
	    if (matchKey(key)) {
	      // Match test
	      keys.push(key);
	
	      if (record === Record.None) {
	        record = Record.Start;
	      } else if (record === Record.Start) {
	        record = Record.End;
	        return false;
	      }
	    } else if (record === Record.Start) {
	      // Append selection
	      keys.push(key);
	    }
	
	    if (expandedKeys.indexOf(key) === -1) {
	      return false;
	    }
	
	    return true;
	  });
	  return keys;
	}
	
	function convertDirectoryKeysToNodes(rootChildren, keys) {
	  var restKeys = _toConsumableArray(keys);
	
	  var nodes = [];
	  traverseNodesKey(rootChildren, function (key, node) {
	    var index = restKeys.indexOf(key);
	
	    if (index !== -1) {
	      nodes.push(node);
	      restKeys.splice(index, 1);
	    }
	
	    return !!restKeys.length;
	  });
	  return nodes;
	}
	
	function getFullKeyListByTreeData(treeData) {
	  var keys = [];
	  (treeData || []).forEach(function (item) {
	    keys.push(item.key);
	
	    if (item.children) {
	      keys = [].concat(_toConsumableArray(keys), _toConsumableArray(getFullKeyListByTreeData(item.children)));
	    }
	  });
	  return keys;
	}

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(572));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Editable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Editable, _React$Component);
	
	  var _super = _createSuper(Editable);
	
	  function Editable() {
	    var _this;
	
	    _classCallCheck(this, Editable);
	
	    _this = _super.apply(this, arguments);
	    _this.inComposition = false;
	    _this.state = {
	      current: ''
	    };
	
	    _this.onChange = function (_ref) {
	      var value = _ref.target.value;
	
	      _this.setState({
	        current: value.replace(/[\r\n]/g, '')
	      });
	    };
	
	    _this.onCompositionStart = function () {
	      _this.inComposition = true;
	    };
	
	    _this.onCompositionEnd = function () {
	      _this.inComposition = false;
	    };
	
	    _this.onKeyDown = function (_ref2) {
	      var keyCode = _ref2.keyCode;
	      // We don't record keyCode when IME is using
	      if (_this.inComposition) return;
	      _this.lastKeyCode = keyCode;
	    };
	
	    _this.onKeyUp = function (_ref3) {
	      var keyCode = _ref3.keyCode,
	          ctrlKey = _ref3.ctrlKey,
	          altKey = _ref3.altKey,
	          metaKey = _ref3.metaKey,
	          shiftKey = _ref3.shiftKey;
	      var onCancel = _this.props.onCancel; // Check if it's a real key
	
	      if (_this.lastKeyCode === keyCode && !_this.inComposition && !ctrlKey && !altKey && !metaKey && !shiftKey) {
	        if (keyCode === _KeyCode["default"].ENTER) {
	          _this.confirmChange();
	        } else if (keyCode === _KeyCode["default"].ESC) {
	          onCancel();
	        }
	      }
	    };
	
	    _this.onBlur = function () {
	      _this.confirmChange();
	    };
	
	    _this.confirmChange = function () {
	      var current = _this.state.current;
	      var onSave = _this.props.onSave;
	      onSave(current.trim());
	    };
	
	    _this.setTextarea = function (textarea) {
	      _this.textarea = textarea;
	    };
	
	    return _this;
	  }
	
	  _createClass(Editable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.textarea && this.textarea.resizableTextArea) {
	        var textArea = this.textarea.resizableTextArea.textArea;
	        textArea.focus();
	        var length = textArea.value.length;
	        textArea.setSelectionRange(length, length);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var current = this.state.current;
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          ariaLabel = _this$props['aria-label'],
	          className = _this$props.className,
	          style = _this$props.style;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-edit-content"), className),
	          style: style
	        }, /*#__PURE__*/React.createElement(_TextArea["default"], {
	          ref: this.setTextarea,
	          value: current,
	          onChange: this.onChange,
	          onKeyDown: this.onKeyDown,
	          onKeyUp: this.onKeyUp,
	          onCompositionStart: this.onCompositionStart,
	          onCompositionEnd: this.onCompositionEnd,
	          onBlur: this.onBlur,
	          "aria-label": ariaLabel,
	          autoSize: true
	        }), /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "enter",
	          className: "".concat(prefixCls, "-edit-content-confirm")
	        }))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevValue = prevState.prevValue;
	      var value = nextProps.value;
	      var newState = {
	        prevValue: value
	      };
	
	      if (prevValue !== value) {
	        newState.current = value;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Editable;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(Editable);
	var _default = Editable;
	exports["default"] = _default;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _Base = _interopRequireDefault(__webpack_require__(305));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Paragraph = function Paragraph(props) {
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, props, {
	      component: "div"
	    }))
	  );
	};
	
	var _default = Paragraph;
	exports["default"] = _default;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _warning = _interopRequireDefault(__webpack_require__(35));
	
	var _Base = _interopRequireDefault(__webpack_require__(305));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Text = function Text(_a) {
	  var ellipsis = _a.ellipsis,
	      restProps = __rest(_a, ["ellipsis"]);
	
	  (0, _warning["default"])(_typeof(ellipsis) !== 'object', 'Typography.Text', '`ellipsis` only supports boolean value.');
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, restProps, {
	      ellipsis: !!ellipsis,
	      component: "span"
	    }))
	  );
	};
	
	var _default = Text;
	exports["default"] = _default;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _warning = _interopRequireDefault(__webpack_require__(495));
	
	var _Base = _interopRequireDefault(__webpack_require__(305));
	
	var _type = __webpack_require__(78);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TITLE_ELE_LIST = (0, _type.tupleNum)(1, 2, 3, 4);
	
	var Title = function Title(props) {
	  var _props$level = props.level,
	      level = _props$level === void 0 ? 1 : _props$level,
	      restProps = __rest(props, ["level"]);
	
	  var component;
	
	  if (TITLE_ELE_LIST.indexOf(level) !== -1) {
	    component = "h".concat(level);
	  } else {
	    (0, _warning["default"])(false, 'Title only accept `1 | 2 | 3 | 4` as `level` value.');
	    component = 'h1';
	  }
	
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, restProps, {
	      component: component
	    }))
	  );
	};
	
	var _default = Title;
	exports["default"] = _default;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Typography = _interopRequireDefault(__webpack_require__(585));
	
	var _Text = _interopRequireDefault(__webpack_require__(1125));
	
	var _Title = _interopRequireDefault(__webpack_require__(1126));
	
	var _Paragraph = _interopRequireDefault(__webpack_require__(1124));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var Typography = _Typography["default"];
	Typography.Text = _Text["default"];
	Typography.Title = _Title["default"];
	Typography.Paragraph = _Paragraph["default"];
	var _default = Typography;
	exports["default"] = _default;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactDom = __webpack_require__(16);
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	// We only handle element & text node.
	var ELEMENT_NODE = 1;
	var TEXT_NODE = 3;
	var COMMENT_NODE = 8;
	var ellipsisContainer;
	var wrapperStyle = {
	  padding: 0,
	  margin: 0,
	  display: 'inline',
	  lineHeight: 'inherit'
	};
	
	function pxToNumber(value) {
	  if (!value) return 0;
	  var match = value.match(/^\d*(\.\d*)?/);
	  return match ? Number(match[0]) : 0;
	}
	
	function styleToString(style) {
	  // There are some different behavior between Firefox & Chrome.
	  // We have to handle this ourself.
	  var styleNames = Array.prototype.slice.apply(style);
	  return styleNames.map(function (name) {
	    return "".concat(name, ": ").concat(style.getPropertyValue(name), ";");
	  }).join('');
	}
	
	function mergeChildren(children) {
	  var childList = [];
	  children.forEach(function (child) {
	    var prevChild = childList[childList.length - 1];
	
	    if (typeof child === 'string' && typeof prevChild === 'string') {
	      childList[childList.length - 1] += child;
	    } else {
	      childList.push(child);
	    }
	  });
	  return childList;
	}
	
	var _default = function _default(originEle, rows, content, fixedContent, ellipsisStr) {
	  if (!ellipsisContainer) {
	    ellipsisContainer = document.createElement('div');
	    ellipsisContainer.setAttribute('aria-hidden', 'true');
	    document.body.appendChild(ellipsisContainer);
	  } // Get origin style
	
	
	  var originStyle = window.getComputedStyle(originEle);
	  var originCSS = styleToString(originStyle);
	  var lineHeight = pxToNumber(originStyle.lineHeight);
	  var maxHeight = lineHeight * (rows + 1) + pxToNumber(originStyle.paddingTop) + pxToNumber(originStyle.paddingBottom); // Set shadow
	
	  ellipsisContainer.setAttribute('style', originCSS);
	  ellipsisContainer.style.position = 'fixed';
	  ellipsisContainer.style.left = '0';
	  ellipsisContainer.style.height = 'auto';
	  ellipsisContainer.style.minHeight = 'auto';
	  ellipsisContainer.style.maxHeight = 'auto';
	  ellipsisContainer.style.top = '-999999px';
	  ellipsisContainer.style.zIndex = '-1000'; // clean up css overflow
	
	  ellipsisContainer.style.textOverflow = 'clip';
	  ellipsisContainer.style.whiteSpace = 'normal';
	  ellipsisContainer.style.webkitLineClamp = 'none'; // Render in the fake container
	
	  var contentList = mergeChildren((0, _toArray["default"])(content));
	  (0, _reactDom.render)( /*#__PURE__*/React.createElement("div", {
	    style: wrapperStyle
	  }, /*#__PURE__*/React.createElement("span", {
	    style: wrapperStyle
	  }, contentList), /*#__PURE__*/React.createElement("span", {
	    style: wrapperStyle
	  }, fixedContent)), ellipsisContainer); // wrap in an div for old version react
	  // Check if ellipsis in measure div is height enough for content
	
	  function inRange() {
	    return ellipsisContainer.offsetHeight < maxHeight;
	  } // Skip ellipsis if already match
	
	
	  if (inRange()) {
	    (0, _reactDom.unmountComponentAtNode)(ellipsisContainer);
	    return {
	      content: content,
	      text: ellipsisContainer.innerHTML,
	      ellipsis: false
	    };
	  } // We should clone the childNode since they're controlled by React and we can't reuse it without warning
	
	
	  var childNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[0].cloneNode(true).childNodes).filter(function (_ref) {
	    var nodeType = _ref.nodeType;
	    return nodeType !== COMMENT_NODE;
	  });
	  var fixedNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[1].cloneNode(true).childNodes);
	  (0, _reactDom.unmountComponentAtNode)(ellipsisContainer); // ========================= Find match ellipsis content =========================
	
	  var ellipsisChildren = [];
	  ellipsisContainer.innerHTML = ''; // Create origin content holder
	
	  var ellipsisContentHolder = document.createElement('span');
	  ellipsisContainer.appendChild(ellipsisContentHolder);
	  var ellipsisTextNode = document.createTextNode(ellipsisStr);
	  ellipsisContentHolder.appendChild(ellipsisTextNode);
	  fixedNodes.forEach(function (childNode) {
	    ellipsisContainer.appendChild(childNode);
	  }); // Append before fixed nodes
	
	  function appendChildNode(node) {
	    ellipsisContentHolder.insertBefore(node, ellipsisTextNode);
	  } // Get maximum text
	
	
	  function measureText(textNode, fullText) {
	    var startLoc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var endLoc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : fullText.length;
	    var lastSuccessLoc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	    var midLoc = Math.floor((startLoc + endLoc) / 2);
	    var currentText = fullText.slice(0, midLoc);
	    textNode.textContent = currentText;
	
	    if (startLoc >= endLoc - 1) {
	      // Loop when step is small
	      for (var step = endLoc; step >= startLoc; step -= 1) {
	        var currentStepText = fullText.slice(0, step);
	        textNode.textContent = currentStepText;
	
	        if (inRange()) {
	          return step === fullText.length ? {
	            finished: false,
	            reactNode: fullText
	          } : {
	            finished: true,
	            reactNode: currentStepText
	          };
	        }
	      }
	    }
	
	    if (inRange()) {
	      return measureText(textNode, fullText, midLoc, endLoc, midLoc);
	    }
	
	    return measureText(textNode, fullText, startLoc, midLoc, lastSuccessLoc);
	  }
	
	  function measureNode(childNode, index) {
	    var type = childNode.nodeType;
	
	    if (type === ELEMENT_NODE) {
	      // We don't split element, it will keep if whole element can be displayed.
	      appendChildNode(childNode);
	
	      if (inRange()) {
	        return {
	          finished: false,
	          reactNode: contentList[index]
	        };
	      } // Clean up if can not pull in
	
	
	      ellipsisContentHolder.removeChild(childNode);
	      return {
	        finished: true,
	        reactNode: null
	      };
	    }
	
	    if (type === TEXT_NODE) {
	      var fullText = childNode.textContent || '';
	      var textNode = document.createTextNode(fullText);
	      appendChildNode(textNode);
	      return measureText(textNode, fullText);
	    } // Not handle other type of content
	    // PS: This code should not be attached after react 16
	
	
	    return {
	      finished: false,
	      reactNode: null
	    };
	  }
	
	  childNodes.some(function (childNode, index) {
	    var _measureNode = measureNode(childNode, index),
	        finished = _measureNode.finished,
	        reactNode = _measureNode.reactNode;
	
	    if (reactNode) {
	      ellipsisChildren.push(reactNode);
	    }
	
	    return finished;
	  });
	  return {
	    content: ellipsisChildren,
	    text: ellipsisContainer.innerHTML,
	    ellipsis: true
	  };
	};
	
	exports["default"] = _default;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _Upload = _interopRequireDefault(__webpack_require__(586));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// stick class comoponent to avoid React ref warning inside Form
	// https://github.com/ant-design/ant-design/issues/18707
	// eslint-disable-next-line react/prefer-stateless-function
	var Dragger = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dragger, _React$Component);
	
	  var _super = _createSuper(Dragger);
	
	  function Dragger() {
	    _classCallCheck(this, Dragger);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dragger, [{
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          style = _a.style,
	          height = _a.height,
	          restProps = __rest(_a, ["style", "height"]);
	
	      return (/*#__PURE__*/React.createElement(_Upload["default"], _extends({}, restProps, {
	          type: "drag",
	          style: _extends(_extends({}, style), {
	            height: height
	          })
	        }))
	      );
	    }
	  }]);
	
	  return Dragger;
	}(React.Component);
	
	exports["default"] = Dragger;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(4));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _utils = __webpack_require__(587);
	
	var _icon = _interopRequireDefault(__webpack_require__(21));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(122));
	
	var _progress = _interopRequireDefault(__webpack_require__(576));
	
	var _configProvider = __webpack_require__(13);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var UploadList = /*#__PURE__*/function (_React$Component) {
	  _inherits(UploadList, _React$Component);
	
	  var _super = _createSuper(UploadList);
	
	  function UploadList() {
	    var _this;
	
	    _classCallCheck(this, UploadList);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handlePreview = function (file, e) {
	      var onPreview = _this.props.onPreview;
	
	      if (!onPreview) {
	        return;
	      }
	
	      e.preventDefault();
	      return onPreview(file);
	    };
	
	    _this.handleDownload = function (file) {
	      var onDownload = _this.props.onDownload;
	
	      if (typeof onDownload === 'function') {
	        onDownload(file);
	      } else if (file.url) {
	        window.open(file.url);
	      }
	    };
	
	    _this.handleClose = function (file) {
	      var onRemove = _this.props.onRemove;
	
	      if (onRemove) {
	        onRemove(file);
	      }
	    };
	
	    _this.renderUploadList = function (_ref) {
	      var _classNames4;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$items = _this$props.items,
	          items = _this$props$items === void 0 ? [] : _this$props$items,
	          listType = _this$props.listType,
	          showPreviewIcon = _this$props.showPreviewIcon,
	          showRemoveIcon = _this$props.showRemoveIcon,
	          showDownloadIcon = _this$props.showDownloadIcon,
	          locale = _this$props.locale,
	          progressAttr = _this$props.progressAttr;
	      var prefixCls = getPrefixCls('upload', customizePrefixCls);
	      var list = items.map(function (file) {
	        var _classNames, _classNames2;
	
	        var progress;
	        var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: file.status === 'uploading' ? 'loading' : 'paper-clip'
	        });
	
	        if (listType === 'picture' || listType === 'picture-card') {
	          if (listType === 'picture-card' && file.status === 'uploading') {
	            icon = /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-list-item-uploading-text")
	            }, locale.uploading);
	          } else if (!file.thumbUrl && !file.url) {
	            icon = /*#__PURE__*/React.createElement(_icon["default"], {
	              className: "".concat(prefixCls, "-list-item-thumbnail"),
	              type: "picture",
	              theme: "twoTone"
	            });
	          } else {
	            var thumbnail = (0, _utils.isImageUrl)(file) ? /*#__PURE__*/React.createElement("img", {
	              src: file.thumbUrl || file.url,
	              alt: file.name,
	              className: "".concat(prefixCls, "-list-item-image")
	            }) : /*#__PURE__*/React.createElement(_icon["default"], {
	              type: "file",
	              className: "".concat(prefixCls, "-list-item-icon"),
	              theme: "twoTone"
	            });
	            icon = /*#__PURE__*/React.createElement("a", {
	              className: "".concat(prefixCls, "-list-item-thumbnail"),
	              onClick: function onClick(e) {
	                return _this.handlePreview(file, e);
	              },
	              href: file.url || file.thumbUrl,
	              target: "_blank",
	              rel: "noopener noreferrer"
	            }, thumbnail);
	          }
	        }
	
	        if (file.status === 'uploading') {
	          // show loading icon if upload progress listener is disabled
	          var loadingProgress = 'percent' in file ? /*#__PURE__*/React.createElement(_progress["default"], _extends({
	            type: "line"
	          }, progressAttr, {
	            percent: file.percent
	          })) : null;
	          progress = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-list-item-progress"),
	            key: "progress"
	          }, loadingProgress);
	        }
	
	        var infoUploadingClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-list-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-").concat(file.status), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames));
	        var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
	        var removeIcon = showRemoveIcon ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "delete",
	          title: locale.removeFile,
	          onClick: function onClick() {
	            return _this.handleClose(file);
	          }
	        }) : null;
	        var downloadIcon = showDownloadIcon && file.status === 'done' ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "download",
	          title: locale.downloadFile,
	          onClick: function onClick() {
	            return _this.handleDownload(file);
	          }
	        }) : null;
	        var downloadOrDelete = listType !== 'picture-card' && /*#__PURE__*/React.createElement("span", {
	          key: "download-delete",
	          className: "".concat(prefixCls, "-list-item-card-actions ").concat(listType === 'picture' ? 'picture' : '')
	        }, downloadIcon && /*#__PURE__*/React.createElement("a", {
	          title: locale.downloadFile
	        }, downloadIcon), removeIcon && /*#__PURE__*/React.createElement("a", {
	          title: locale.removeFile
	        }, removeIcon));
	        var listItemNameClass = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name-icon-count-").concat([downloadIcon, removeIcon].filter(function (x) {
	          return x;
	        }).length), true), _classNames2));
	        var preview = file.url ? [/*#__PURE__*/React.createElement("a", _extends({
	          key: "view",
	          target: "_blank",
	          rel: "noopener noreferrer",
	          className: listItemNameClass,
	          title: file.name
	        }, linkProps, {
	          href: file.url,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          }
	        }), file.name), downloadOrDelete] : [/*#__PURE__*/React.createElement("span", {
	          key: "view",
	          className: listItemNameClass,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          },
	          title: file.name
	        }, file.name), downloadOrDelete];
	        var style = {
	          pointerEvents: 'none',
	          opacity: 0.5
	        };
	        var previewIcon = showPreviewIcon ? /*#__PURE__*/React.createElement("a", {
	          href: file.url || file.thumbUrl,
	          target: "_blank",
	          rel: "noopener noreferrer",
	          style: file.url || file.thumbUrl ? undefined : style,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          },
	          title: locale.previewFile
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "eye-o"
	        })) : null;
	        var actions = listType === 'picture-card' && file.status !== 'uploading' && /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-list-item-actions")
	        }, previewIcon, file.status === 'done' && downloadIcon, removeIcon);
	        var message;
	
	        if (file.response && typeof file.response === 'string') {
	          message = file.response;
	        } else {
	          message = file.error && file.error.statusText || locale.uploadError;
	        }
	
	        var iconAndPreview = /*#__PURE__*/React.createElement("span", null, icon, preview);
	        var dom = /*#__PURE__*/React.createElement("div", {
	          className: infoUploadingClass
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-list-item-info")
	        }, iconAndPreview), actions, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "fade",
	          component: ""
	        }, progress));
	        var listContainerNameClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-list-picture-card-container"), listType === 'picture-card'));
	        return (/*#__PURE__*/React.createElement("div", {
	            key: file.uid,
	            className: listContainerNameClass
	          }, file.status === 'error' ? /*#__PURE__*/React.createElement(_tooltip["default"], {
	            title: message
	          }, dom) : /*#__PURE__*/React.createElement("span", null, dom))
	        );
	      });
	      var listClassNames = (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-list"), true), _defineProperty(_classNames4, "".concat(prefixCls, "-list-").concat(listType), true), _classNames4));
	      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "".concat(prefixCls, "-").concat(animationDirection),
	          component: "div",
	          className: listClassNames
	        }, list)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(UploadList, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          listType = _this$props2.listType,
	          items = _this$props2.items,
	          previewFile = _this$props2.previewFile;
	
	      if (listType !== 'picture' && listType !== 'picture-card') {
	        return;
	      }
	
	      (items || []).forEach(function (file) {
	        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
	          return;
	        }
	
	        file.thumbUrl = '';
	
	        if (previewFile) {
	          previewFile(file.originFileObj).then(function (previewDataUrl) {
	            // Need append '' to avoid dead loop
	            file.thumbUrl = previewDataUrl || '';
	
	            _this2.forceUpdate();
	          });
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUploadList)
	      );
	    }
	  }]);
	
	  return UploadList;
	}(React.Component);
	
	exports["default"] = UploadList;
	UploadList.defaultProps = {
	  listType: 'text',
	  progressAttr: {
	    strokeWidth: 2,
	    showInfo: false
	  },
	  showRemoveIcon: true,
	  showDownloadIcon: false,
	  showPreviewIcon: true,
	  previewFile: _utils.previewImage
	};

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Upload = _interopRequireDefault(__webpack_require__(586));
	
	var _Dragger = _interopRequireDefault(__webpack_require__(1129));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Upload["default"].Dragger = _Dragger["default"];
	var _default = _Upload["default"];
	exports["default"] = _default;

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _package = _interopRequireDefault({ version: '3.26.20' });
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _package["default"].version;
	exports["default"] = _default;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : _typeof(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(20), __webpack_require__(123), __webpack_require__(593), __webpack_require__(591), __webpack_require__(79), __webpack_require__(590), __webpack_require__(80), __webpack_require__(236), __webpack_require__(154), __webpack_require__(609), __webpack_require__(237), __webpack_require__(611), __webpack_require__(610), __webpack_require__(608), __webpack_require__(153), __webpack_require__(604), __webpack_require__(71), __webpack_require__(36), __webpack_require__(594), __webpack_require__(596), __webpack_require__(595), __webpack_require__(598), __webpack_require__(597), __webpack_require__(599), __webpack_require__(600), __webpack_require__(601), __webpack_require__(603), __webpack_require__(602), __webpack_require__(592), __webpack_require__(588), __webpack_require__(612), __webpack_require__(607), __webpack_require__(606), __webpack_require__(605), __webpack_require__(589));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20), __webpack_require__(123), __webpack_require__(593), __webpack_require__(591), __webpack_require__(79), __webpack_require__(590), __webpack_require__(80), __webpack_require__(236), __webpack_require__(154), __webpack_require__(609), __webpack_require__(237), __webpack_require__(611), __webpack_require__(610), __webpack_require__(608), __webpack_require__(153), __webpack_require__(604), __webpack_require__(71), __webpack_require__(36), __webpack_require__(594), __webpack_require__(596), __webpack_require__(595), __webpack_require__(598), __webpack_require__(597), __webpack_require__(599), __webpack_require__(600), __webpack_require__(601), __webpack_require__(603), __webpack_require__(602), __webpack_require__(592), __webpack_require__(588), __webpack_require__(612), __webpack_require__(607), __webpack_require__(606), __webpack_require__(605), __webpack_require__(589)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		return CryptoJS;
	});

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(238);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function oneArgumentPooler(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function threeArgumentPooler(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var ReactBaseClasses = __webpack_require__(613);
	var ReactChildren = __webpack_require__(1138);
	var ReactDOMFactories = __webpack_require__(1139);
	var ReactElement = __webpack_require__(155);
	var ReactPropTypes = __webpack_require__(1140);
	var ReactVersion = __webpack_require__(1141);
	
	var createReactClass = __webpack_require__(1142);
	var onlyChild = __webpack_require__(1145);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1136);
	var ReactElement = __webpack_require__(155);
	
	var emptyFunction = __webpack_require__(120);
	var traverseAllChildren = __webpack_require__(1146);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(155);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(155),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(500);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(613),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(155),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(616);
	var factory = __webpack_require__(924);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function lowPriorityWarning() {};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function lowPriorityWarning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(238);
	
	var ReactElement = __webpack_require__(155);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(238);
	
	var ReactCurrentOwner = __webpack_require__(614);
	var REACT_ELEMENT_TYPE = __webpack_require__(615);
	
	var getIteratorFn = __webpack_require__(1143);
	var invariant = __webpack_require__(32);
	var KeyEscapeUtils = __webpack_require__(1135);
	var warning = __webpack_require__(44);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * 初始化命名空间
	 */
	// 初始化参数工厂
	if (!window.PrmFactory) window.PrmFactory = {};
	// 初始化参数工厂
	if (!window.SAPrmFactory) window.SAPrmFactory = {};
	// 初始化配置
	if (!window.sgiConfig) window.sgiConfig = {};
	// 初始化组件管理器
	if (!window.ComponentManager) window.ComponentManager = {};
	// 初始化antd组件库
	if (!window.sgiAntdModule) window.sgiAntdModule = {};
	// 初始化自定义组件库
	if (!window.sgiCustomModule) window.sgiCustomModule = {};
	// 初始化标准代码管理器
	if (!window.StandardCode) window.StandardCode = {};
	// 初始化工具集
	if (!window.tool) window.tool = {};
	// 初始化资源管理器
	if (!window.Resource) window.Resource = {};
	// 初始化SgiComp和Dnd_SgiComp组件库，通过key获取组件
	if (!window.sgiModule) window.sgiModule = {};

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function md5(string) {
	    var x = Array();
	    var k, AA, BB, CC, DD, a, b, c, d;
	    var S11 = 7,
	        S12 = 12,
	        S13 = 17,
	        S14 = 22;
	    var S21 = 5,
	        S22 = 9,
	        S23 = 14,
	        S24 = 20;
	    var S31 = 4,
	        S32 = 11,
	        S33 = 16,
	        S34 = 23;
	    var S41 = 6,
	        S42 = 10,
	        S43 = 15,
	        S44 = 21;
	    string = Utf8Encode(string);
	    x = ConvertToWordArray(string);
	    a = 0x67452301;
	    b = 0xEFCDAB89;
	    c = 0x98BADCFE;
	    d = 0x10325476;
	    for (k = 0; k < x.length; k += 16) {
	        AA = a;
	        BB = b;
	        CC = c;
	        DD = d;
	        a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
	        d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
	        c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
	        b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
	        a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
	        d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
	        c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
	        b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
	        a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
	        d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
	        c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
	        b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
	        a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
	        d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
	        c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
	        b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
	        a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
	        d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
	        c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
	        b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
	        a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
	        d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
	        c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
	        b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
	        a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
	        d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
	        c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
	        b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
	        a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
	        d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
	        c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
	        b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
	        a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
	        d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
	        c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
	        b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
	        a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
	        d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
	        c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
	        b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
	        a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
	        d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
	        c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
	        b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
	        a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
	        d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
	        c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
	        b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
	        a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
	        d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
	        c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
	        b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
	        a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
	        d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
	        c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
	        b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
	        a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
	        d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
	        c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
	        b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
	        a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
	        d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
	        c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
	        b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
	        a = AddUnsigned(a, AA);
	        b = AddUnsigned(b, BB);
	        c = AddUnsigned(c, CC);
	        d = AddUnsigned(d, DD);
	    }
	    var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);
	    return temp.toLowerCase();
	}
	function RotateLeft(lValue, iShiftBits) {
	    return lValue << iShiftBits | lValue >>> 32 - iShiftBits;
	}
	function AddUnsigned(lX, lY) {
	    var lX4, lY4, lX8, lY8, lResult;
	    lX8 = lX & 0x80000000;
	    lY8 = lY & 0x80000000;
	    lX4 = lX & 0x40000000;
	    lY4 = lY & 0x40000000;
	    lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
	    if (lX4 & lY4) {
	        return lResult ^ 0x80000000 ^ lX8 ^ lY8;
	    }
	    if (lX4 | lY4) {
	        if (lResult & 0x40000000) {
	            return lResult ^ 0xC0000000 ^ lX8 ^ lY8;
	        } else {
	            return lResult ^ 0x40000000 ^ lX8 ^ lY8;
	        }
	    } else {
	        return lResult ^ lX8 ^ lY8;
	    }
	}
	function F(x, y, z) {
	    return x & y | ~x & z;
	}
	function G(x, y, z) {
	    return x & z | y & ~z;
	}
	function H(x, y, z) {
	    return x ^ y ^ z;
	}
	function I(x, y, z) {
	    return y ^ (x | ~z);
	}
	function FF(a, b, c, d, x, s, ac) {
	    a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
	    return AddUnsigned(RotateLeft(a, s), b);
	}
	function GG(a, b, c, d, x, s, ac) {
	    a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
	    return AddUnsigned(RotateLeft(a, s), b);
	}
	function HH(a, b, c, d, x, s, ac) {
	    a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
	    return AddUnsigned(RotateLeft(a, s), b);
	}
	function II(a, b, c, d, x, s, ac) {
	    a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
	    return AddUnsigned(RotateLeft(a, s), b);
	}
	function ConvertToWordArray(string) {
	    var lWordCount;
	    var lMessageLength = string.length;
	    var lNumberOfWords_temp1 = lMessageLength + 8;
	    var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - lNumberOfWords_temp1 % 64) / 64;
	    var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
	    var lWordArray = Array(lNumberOfWords - 1);
	    var lBytePosition = 0;
	    var lByteCount = 0;
	    while (lByteCount < lMessageLength) {
	        lWordCount = (lByteCount - lByteCount % 4) / 4;
	        lBytePosition = lByteCount % 4 * 8;
	        lWordArray[lWordCount] = lWordArray[lWordCount] | string.charCodeAt(lByteCount) << lBytePosition;
	        lByteCount++;
	    }
	    lWordCount = (lByteCount - lByteCount % 4) / 4;
	    lBytePosition = lByteCount % 4 * 8;
	    lWordArray[lWordCount] = lWordArray[lWordCount] | 0x80 << lBytePosition;
	    lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
	    lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
	    return lWordArray;
	}
	function WordToHex(lValue) {
	    var WordToHexValue = "",
	        WordToHexValue_temp = "",
	        lByte,
	        lCount;
	    for (lCount = 0; lCount <= 3; lCount++) {
	        lByte = lValue >>> lCount * 8 & 255;
	        WordToHexValue_temp = "0" + lByte.toString(16);
	        WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
	    }
	    return WordToHexValue;
	}
	function Utf8Encode(string) {
	    var utftext = "";
	    for (var n = 0; n < string.length; n++) {
	        var c = string.charCodeAt(n);
	        if (c < 128) {
	            utftext += String.fromCharCode(c);
	        } else if (c > 127 && c < 2048) {
	            utftext += String.fromCharCode(c >> 6 | 192);
	            utftext += String.fromCharCode(c & 63 | 128);
	        } else {
	            utftext += String.fromCharCode(c >> 12 | 224);
	            utftext += String.fromCharCode(c >> 6 & 63 | 128);
	            utftext += String.fromCharCode(c & 63 | 128);
	        }
	    }
	    return utftext;
	}
	exports.default = md5;

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiButtonEO = function SgiButtonEO() {
	    return {
	        ann: "注释",
	        // badgeText: "5",//右上角标
	        // btnIconPh: "search",//按钮图标
	        // cId: "cid_button",//组件标识
	        // ctlH: 0,
	        ctlN: "按钮",
	        // ctlW: 100,
	        desId: "EP_EO_UI_3003",
	        // hvInfo: "按钮的提示信息",//按钮的提示信息
	        isDis: false,
	        isHdn: false,
	        te: "显示名称"
	        // bdrW: 20,//边框宽度
	        // csstyle: "button-default",
	        // fontIcon: "",//字体图标
	        // iconAlg: "left",//按钮图片位置
	        // iconPh: "SD_RP_IR_0001`UI`UI10",
	        // isBrdr: true,//是否有边框,显示边框
	        // mgn: 10,//外边距
	        // n: "名称",
	        // pad: 10,//内边距
	        // new_flag: true,
	        // sNo: 0,//排序号
	        // bkImgPh: "SD_RP_IR_0001`UI`UI10",//背景图片
	        // bkImgRptType: "",//背景图重复方式
	        // teAl: "center",//文本位置
	        // teid: "20171123172212960752",//显示名称代码
	        // useTim: 0,//使用次数
	        // visible: true,
	        // x: "0",
	        // y: "0",
	    };
	};
	
	exports.SgiButtonEO = SgiButtonEO;
	exports.default = SgiButtonEO;

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * 复选框组控件
	 * wangj
	 */
	
	var SgiCheckBoxEO = function SgiCheckBoxEO() {
	    return {
	        isBtn: true,
	        checked: ['1', ''],
	        c: "col2",
	        ctlH: 0,
	        ctlN: "单选框",
	        ctlW: 600,
	        desId: "EP_EO_UI_3108",
	        isDis: false,
	        isHdn: false,
	        lblAlg: "left",
	        lblW: 200,
	        n: "字段2",
	        sNo: 0,
	        scId: 'SD_SC_PT_0001', //标准代码GUID
	        t: "radio",
	        te: '复选框控件',
	        ctlClu: 1,
	        useCodes: ''
	
	        // alwBlk : true,
	        // isGw : false,
	        // isLbl : true,
	        // isRead : false,
	        // isSrp : true,
	
	        // maxL : 0,
	        // minL : 0,
	        // msfTgt : "qtip",
	        // useTim : 0,
	        // visible : true,
	        // x : "0",
	        // y : "0",
	
	
	    };
	};
	
	exports.SgiCheckBoxEO = SgiCheckBoxEO;
	exports.default = SgiCheckBoxEO;

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiCodeMirrorEO = function SgiCodeMirrorEO() {
	    return {
	        desId: "EP_EO_UI_CODEMIRROR"
	    };
	};
	
	exports.SgiCodeMirrorEO = SgiCodeMirrorEO;
	exports.default = SgiCodeMirrorEO;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sgiCreateEO = undefined;
	
	var _SgiCompConstant = __webpack_require__(107);
	
	var _SgiCalendarEO = __webpack_require__(309);
	
	var _SgiCollapseEO = __webpack_require__(311);
	
	var _SgiCommEchartsEO = __webpack_require__(312);
	
	var _SgiDVEO = __webpack_require__(313);
	
	var _SgiEChartsCommonEO = __webpack_require__(314);
	
	var _SgiFormCascaderEO = __webpack_require__(315);
	
	var _SgiFormCheckboxEO = __webpack_require__(316);
	
	var _SgiFormCheckboxGroupEO = __webpack_require__(317);
	
	var _SgiFormComboboxEO = __webpack_require__(318);
	
	var _SgiFormComboxTreeEO = __webpack_require__(319);
	
	var _SgiFormEditorEO = __webpack_require__(322);
	
	var _SgiFormEO = __webpack_require__(321);
	
	var _SgiFormFileEO = __webpack_require__(323);
	
	var _SgiFormPopUIEO = __webpack_require__(325);
	
	var _SgiFormRadioEO = __webpack_require__(326);
	
	var _SgiImgEO = __webpack_require__(330);
	
	var _SgiLabelEO = __webpack_require__(331);
	
	var _SgiTagEO = __webpack_require__(622);
	
	var _SgiListEO = __webpack_require__(332);
	
	var _SgiMenuEO = __webpack_require__(333);
	
	var _SgiNestEO = __webpack_require__(334);
	
	var _SgiOverlapEO = __webpack_require__(335);
	
	var _SgiPanelEO = __webpack_require__(336);
	
	var _SgiRowEO = __webpack_require__(337);
	
	var _SgiColEO = __webpack_require__(310);
	
	var _SgiSplitterEO = __webpack_require__(338);
	
	var _SgiStepsEO = __webpack_require__(339);
	
	var _SgiTableEO = __webpack_require__(341);
	
	var _SgiTabsEO = __webpack_require__(342);
	
	var _SgiTileEO = __webpack_require__(343);
	
	var _SgiToolbarEO = __webpack_require__(344);
	
	var _SgiTransferEO = __webpack_require__(345);
	
	var _SgiTreeEO = __webpack_require__(346);
	
	var _SgiTVEO = __webpack_require__(340);
	
	var _SgiButtonEO = __webpack_require__(308);
	
	var _SgiCardEO = __webpack_require__(619);
	
	var _SgiFormDateEO = __webpack_require__(320);
	
	var _SgiFormInputNumberEO = __webpack_require__(324);
	
	var _SgiFormTextAreaEO = __webpack_require__(327);
	
	var _SgiFormTextEO = __webpack_require__(328);
	
	var _SgiFormTimeEO = __webpack_require__(329);
	
	var _sgiCommon = __webpack_require__(28);
	
	var sgiCreateEO = function sgiCreateEO(mdType, type) {
	    var sgiCompDesc = void 0;
	    if (mdType && mdType == _SgiCompConstant.AllCompGUID.FIELDTEXT) {
	        sgiCompDesc = (0, _SgiFormTextEO.SgiFormTextEO)(); //文本域    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TEXTAREA) {
	        sgiCompDesc = (0, _SgiFormTextAreaEO.SgiFormTextAreaEO)(); //数字控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.NUMBER) {
	        sgiCompDesc = (0, _SgiFormInputNumberEO.SgiFormInputNumberEO)(); //日期控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.DATE) {
	        sgiCompDesc = (0, _SgiFormDateEO.SgiFormDateEO)(); //时间控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TIME) {
	        sgiCompDesc = (0, _SgiFormTimeEO.SgiFormTimeEO)(); //文件控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.UPLOADFILE) {
	        sgiCompDesc = (0, _SgiFormFileEO.SgiFormFileEO)(); //下拉窗控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.COMBOBOX) {
	        sgiCompDesc = (0, _SgiFormComboboxEO.SgiFormComboboxEO)(); //复选框控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.CHECKBOX) {
	        sgiCompDesc = (0, _SgiFormCheckboxEO.SgiFormCheckboxEO)(); //复选框组件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.CHECKBOXGROUP) {
	        sgiCompDesc = (0, _SgiFormCheckboxGroupEO.SgiFormCheckboxGroupEO)(); //级联控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.CHECKBOXGROUP) {
	        sgiCompDesc = (0, _SgiFormCascaderEO.SgiFormCascaderEO)();
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.CASCADER) {
	        sgiCompDesc = (0, _SgiFormCascaderEO.SgiFormCascaderEO)(); //单选框组件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.RADIOGROUP) {
	        sgiCompDesc = (0, _SgiFormRadioEO.SgiFormRadioEO)(); //弹出窗控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.POPUI) {
	        sgiCompDesc = (0, _SgiFormPopUIEO.SgiFormPopUIEO)(); //富文本控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.EDITOR) {
	        sgiCompDesc = (0, _SgiFormEditorEO.SgiFormEditorEO)(); //下拉树控件    
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.COMBOXTREE) {
	        sgiCompDesc = (0, _SgiFormComboxTreeEO.SgiFormComboxTreeEO)(); //Dnd_SgiToolbar
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TOOLBAR) {
	        sgiCompDesc = (0, _SgiToolbarEO.SgiToolbarEO)(); //Dnd_SgiButton
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.BUTTON) {
	        sgiCompDesc = (0, _SgiButtonEO.SgiButtonEO)(); //Dnd_SgiImg 图片
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.IMG) {
	        sgiCompDesc = (0, _SgiImgEO.SgiImgEO)(); //Dnd_SgiList 列表
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.LIST) {
	        sgiCompDesc = (0, _SgiListEO.SgiListEO)(); //Dnd_SgiLabel 标签
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.LABEL) {
	        sgiCompDesc = (0, _SgiLabelEO.SgiLabelEO)(); //tag
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TAG) {
	        sgiCompDesc = (0, _SgiTagEO.SgiTagEO)(); //树面板
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TREE) {
	        sgiCompDesc = (0, _SgiTreeEO.SgiTreeEO)(); //表格面板
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TABLE) {
	        sgiCompDesc = (0, _SgiTableEO.SgiTableEO)(); //tv
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TV) {
	        sgiCompDesc = (0, _SgiTVEO.SgiTVEO)(); //穿梭框
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TRANSFER) {
	        sgiCompDesc = (0, _SgiTransferEO.SgiTransferEO)(); //嵌入面板
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.NEST) {
	        sgiCompDesc = (0, _SgiNestEO.SgiNestEO)(); //form
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.WV) {
	        sgiCompDesc = (0, _SgiFormEO.SgiFormEO)(); //panel
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.PANEL) {
	        sgiCompDesc = (0, _SgiPanelEO.SgiPanelEO)(); //重叠面板
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.CARD) {
	        sgiCompDesc = (0, _SgiCardEO.SgiCardEO)(); //新重叠面板
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.OVERLAP) {
	        sgiCompDesc = (0, _SgiOverlapEO.SgiOverlapEO)(); //折叠面板
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.ACCORDION) {
	        sgiCompDesc = (0, _SgiCollapseEO.SgiCollapseEO)(); //tab
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.TAB) {
	        sgiCompDesc = (0, _SgiTabsEO.SgiTabsEO)(); //分割面板
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.SPLITTER) {
	        sgiCompDesc = (0, _SgiSplitterEO.SgiSplitterEO)(); //菜单组件
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.MENU) {
	        sgiCompDesc = (0, _SgiMenuEO.SgiMenuEO)(); //步骤组件
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.STEP) {
	        sgiCompDesc = (0, _SgiStepsEO.SgiStepsEO)(); // ECharts图表-自定义图表
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.EC_COMMON) {
	        sgiCompDesc = (0, _SgiEChartsCommonEO.SgiEChartsCommonEO)(); // 平铺组件
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.Tile) {
	        sgiCompDesc = (0, _SgiTileEO.SgiTileEO)(); // 通用图表
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.CommEcharts) {
	        sgiCompDesc = (0, _SgiCommEchartsEO.SgiCommEchartsEO)(); // 日历
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.Calendar) {
	        sgiCompDesc = (0, _SgiCalendarEO.SgiCalendarEO)();
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.DV) {
	        sgiCompDesc = (0, _SgiDVEO.SgiDVEO)();
	        //布局这个比较特殊，单独处理json结构
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.LT_ROW) {
	        if (type && type === 'row24') {
	            sgiCompDesc = (0, _SgiRowEO.SgiRowEO)();
	            var sgicolDesc = (0, _SgiColEO.SgiColEO)();
	            sgicolDesc.span = 24;
	            sgicolDesc.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgiCompDesc.cldSet = [sgicolDesc];
	        } else if (type && type === 'row12+12') {
	            sgiCompDesc = (0, _SgiRowEO.SgiRowEO)();
	            var sgicolDesc1 = (0, _SgiColEO.SgiColEO)();
	            var sgicolDesc2 = (0, _SgiColEO.SgiColEO)();
	            sgicolDesc1.span = 12;
	            sgicolDesc2.span = 12;
	            sgicolDesc1.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgicolDesc2.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgiCompDesc.cldSet = [sgicolDesc1, sgicolDesc2];
	        } else if (type && type === 'row16+8') {
	            sgiCompDesc = (0, _SgiRowEO.SgiRowEO)();
	            var _sgicolDesc = (0, _SgiColEO.SgiColEO)();
	            var _sgicolDesc2 = (0, _SgiColEO.SgiColEO)();
	            _sgicolDesc.span = 16;
	            _sgicolDesc2.span = 8;
	            _sgicolDesc.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            _sgicolDesc2.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgiCompDesc.cldSet = [_sgicolDesc, _sgicolDesc2];
	        } else if (type && type === 'row8+8+8') {
	            sgiCompDesc = (0, _SgiRowEO.SgiRowEO)();
	            var _sgicolDesc3 = (0, _SgiColEO.SgiColEO)();
	            var _sgicolDesc4 = (0, _SgiColEO.SgiColEO)();
	            var sgicolDesc3 = (0, _SgiColEO.SgiColEO)();
	            _sgicolDesc3.span = 8;
	            _sgicolDesc4.span = 8;
	            sgicolDesc3.span = 8;
	            _sgicolDesc3.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            _sgicolDesc4.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgicolDesc3.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgiCompDesc.cldSet = [_sgicolDesc3, _sgicolDesc4, sgicolDesc3];
	        } else if (type && type === 'row4+12+8') {
	            sgiCompDesc = (0, _SgiRowEO.SgiRowEO)();
	            var _sgicolDesc5 = (0, _SgiColEO.SgiColEO)();
	            var _sgicolDesc6 = (0, _SgiColEO.SgiColEO)();
	            var _sgicolDesc7 = (0, _SgiColEO.SgiColEO)();
	            _sgicolDesc5.span = 4;
	            _sgicolDesc6.span = 12;
	            _sgicolDesc7.span = 8;
	            _sgicolDesc5.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            _sgicolDesc6.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            _sgicolDesc7.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgiCompDesc.cldSet = [_sgicolDesc5, _sgicolDesc6, _sgicolDesc7];
	        } else if (type && type === 'row6+6+6+6') {
	            sgiCompDesc = (0, _SgiRowEO.SgiRowEO)();
	            var _sgicolDesc8 = (0, _SgiColEO.SgiColEO)();
	            var _sgicolDesc9 = (0, _SgiColEO.SgiColEO)();
	            var _sgicolDesc10 = (0, _SgiColEO.SgiColEO)();
	            var sgicolDesc4 = (0, _SgiColEO.SgiColEO)();
	            _sgicolDesc8.span = 6;
	            _sgicolDesc9.span = 6;
	            _sgicolDesc10.span = 6;
	            sgicolDesc4.span = 6;
	            _sgicolDesc8.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            _sgicolDesc9.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            _sgicolDesc10.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgicolDesc4.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	            sgiCompDesc.cldSet = [_sgicolDesc8, _sgicolDesc9, _sgicolDesc10, sgicolDesc4];
	        } else {
	            sgiCompDesc = (0, _SgiRowEO.SgiRowEO)();
	        }
	    } else if (mdType && mdType == _SgiCompConstant.AllCompGUID.LT_COL) {
	        //列组件  
	        sgiCompDesc = (0, _SgiColEO.SgiColEO)();
	    }
	    sgiCompDesc.dnd_id = 'id_' + (0, _sgiCommon.uuid)(8);
	    return sgiCompDesc;
	};
	
	exports.sgiCreateEO = sgiCreateEO;
	exports.default = sgiCreateEO;

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiG6CommonEO = function SgiG6CommonEO() {
	    return {
	        ctlH: '100%',
	        ctlW: '100%',
	        style: { minHeight: '200px' },
	        desId: "EP_EO_UI_G60001"
	    };
	};
	
	exports.SgiG6CommonEO = SgiG6CommonEO;
	exports.default = SgiG6CommonEO;

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiJsoneditorEO = function SgiJsoneditorEO() {
	    return {
	        te: "jsoneditor组件",
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "jsoneditor组件",
	        desId: "EP_EO_UI_JSONEDITOR",
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0"
	    };
	};
	exports.SgiJsoneditorEO = SgiJsoneditorEO;
	exports.default = SgiJsoneditorEO;

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiOverPanelEO = function SgiOverPanelEO() {
	    return {
	        cId: "",
	        ctlN: "层叠面板",
	        ctlH: '100%',
	        ctlW: '100%',
	        desId: "EP_EO_UI_4103",
	        te: "",
	        pad: "0 0 0 0",
	        mgn: "0 0 0 0",
	        // ctlN: "层叠面板",
	        // isHdn: false,
	        isBrdr: true
	        // flx: 6,
	        // iconPh: "SD_RP_IR_0001`UI`UI05",
	        // isBdyBrdr: true,
	        // isBrdr: false,
	        // isClp: false,
	        // isClpFst: true,
	        // isCls: false,
	        // isDis: false,
	        // isFrm: false,
	        // isHClpTl: false,
	        // clpDrt: "top",
	        // clpd: false,
	        // csstyle: "80",
	        // isRead: false,
	        // isScl: false,
	        // isTtl: false,
	        // isttlClp: false,
	        // n: "视图类型层叠",
	        // new_flag: true,
	        // prmVsn: "0",
	        // sNo: 2,
	        // sc: "20171225090149727136",
	        // ttlAlg: "top",
	        // ttlAlgn: "left",
	        // useTim: 0,
	        // visible: true,
	        // x: "0",
	        // y: "0"
	    };
	};
	
	exports.SgiOverPanelEO = SgiOverPanelEO;
	exports.default = SgiOverPanelEO;

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SgiPanelOldEO = function SgiPanelOldEO() {
	    return {
	        te: "我是面板x",
	        // cId: '222',
	        ctlH: '100%',
	        ctlW: '100%',
	        ctlN: "普通面板",
	        style: { minHeight: '200px' },
	        desId: "EP_EO_UI_4001",
	        isBrdr: true,
	        isHdn: false,
	        isScl: false,
	        isTtl: true,
	        mgn: "0 0 0 0",
	        pad: "0 0 0 0",
	        ttlAlgn: "center",
	        loading: false //初始加载中
	    };
	};
	
	exports.SgiPanelOldEO = SgiPanelOldEO;
	exports.default = SgiPanelOldEO;

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Row布局
	 * wzhe
	 */
	var SgiUCVEO = function SgiUCVEO() {
	    return {
	        cldSet: [],
	        ap: "SD",
	        auth: "王哲",
	        cId: "SD_UI_UI_0001",
	        crtTm: "2017-11-24 09:40:24",
	        ctlH: "100%",
	        ctlW: "100%",
	        desId: "EP_EO_UI_0001",
	        edAuth: "王哲",
	        edTm: "2018-01-09 09:58:10",
	        guid: "SD_UI_UI_0001new",
	        mgn: "0 0 0 0",
	        n: "UI管理页面new@",
	        pad: "0 0 0 0",
	        prmVsn: 176,
	        sc: "0001new",
	        ss: "UI",
	        t: "fit",
	        te: "SD_RP_TR_0001`Y`Y001",
	        tt: "UI",
	        ctlN: "UCV"
	        // ttlAlg: "top",
	        // useTim: 0,
	        // visible: true
	        // iconPh: "SD_RP_IR_0001`UI`UI01",
	        // isBrdr: false,
	        // isCls: false,
	        // isFrm: false,
	        // isHdn: false,
	        // isScl: false,
	        // isTtl: false,
	        // lastParentId: "Ext.data.TreeModel-3",
	        // lt: {
	        //     c: "fit",
	        //     desId: "EP_EO_UI_5002"
	        // },
	        // new_flag: true,
	        // prmT: "C",
	    };
	};
	exports.SgiUCVEO = SgiUCVEO;
	exports.default = SgiUCVEO;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DataDict = undefined;
	
	var _sgiCommon = __webpack_require__(28);
	
	var sgiCommon = _interopRequireWildcard(_sgiCommon);
	
	var _DataElement = __webpack_require__(626);
	
	var _PrmFactory = __webpack_require__(63);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var DataDict = window.DataDict = {
		/**
	  * 对外接口，根据是sguid取得数据字典信息
	  * @param {String} key
	  * @returns 数据字典对象
	  */
		getDD: function getDD(key) {
			var dd;
			// var ap = sgiCommon.getAP(key);
			var ap = tool.Global.currentAP;
			if (!ap) {
				dd = {};
				return dd;
			}
			//图片资源缓存对象
			var ddMap = DataDict[ap + "DdMap"];
			if (!ddMap) {
				ddMap = this.loadDD(ap);
			}
			dd = ddMap[key];
			if (!dd) {
				dd = {};
				return dd;
			}
			return dd;
		},
		/**
	  * 加载数据字典缓存对象
	  * @param {String} ap
	  * @return {map} ddMap
	  */
		loadDD: function loadDD(ap) {
			var ddMap = {};
			DataDict[ap + "DdMap"] = ddMap;
			// var ddMap = DataDict[ap + "DdMap"];
			//数据字典缓存对象
			var guid = ap + '_MD_DD_0001';
			var ddTree = _PrmFactory.PrmFactory.getPrm(guid);
			if (ddTree) {
				var ddList = sgiCommon.getLeafByPrm(ddTree);
				ddList.forEach(function (record) {
					var de = _DataElement.DataElement.getDE(record.t);
					record.dbt = de.dbt; //数据类型
					record.jt = de.jt; //程序类型
					record.jst = de.jst; //js类型
					record.dL = de.dL; //长度
					record.dcmDgt = de.dcmDgt; //小数位
					ddMap[record.sc] = record;
				});
			}
			return ddMap;
		}
	}; /*  数据字典提供者
	    归属：企通前端平台-ECP V5.1
	    版权：2014-2020 企通软件技术有限公司
	    --------------------------------------------------------------------------------
	    作者：吴凤楠                         创建日期：2014/05/04
	    修改：王哲                           修改日期：2014/05/09
	    修改内容:
	    --------------------------------------------------------------------------------
	    key值sc中追加guid信息 guid`sc
	    
	    
	    *******************************************************************************/
	exports.DataDict = DataDict;
	exports.default = DataDict;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.SAPrmFactory = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*   参数工厂
	                                                                                                                                                                                                                                                                               --------------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                               作者：王哲                           创建日期：2018/03/12
	                                                                                                                                                                                                                                                                               --------------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                               提供方法列表：
	                                                                                                                                                                                                                                                                               ★对象保存
	                                                                                                                                                                                                                                                                               ★对象读取
	                                                                                                                                                                                                                                                                               ★根据参数guid创建对象
	                                                                                                                                                                                                                                                                               ★对象删除
	                                                                                                                                                                                                                                                                               --------------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                               修改：                               修改日期：
	                                                                                                                                                                                                                                                                               修改内容:
	                                                                                                                                                                                                                                                                              
	                                                                                                                                                                                                                                                                               --------------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                              
	                                                                                                                                                                                                                                                                               *******************************************************************************/
	
	var _sgiCommonConstant = __webpack_require__(241);
	
	var _localStorage = __webpack_require__(239);
	
	var _sgiConfig = __webpack_require__(347);
	
	var _sgiConfig2 = _interopRequireDefault(_sgiConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cacheFlag = false;
	
	/**
	 * 去掉参数中的特定无用字段，默认去掉_key字段
	 * @param {*} obj 
	 * @param {*} keyCode 
	 * @author hanzb 2018年11月13日
	 * @private
	 */
	var _keyFilter = function _keyFilter(obj, keyCode) {
		if (!obj) return;
		keyCode = keyCode || "_key";
		delete obj[keyCode];
		var cldSet = obj.cldSet;
		if (cldSet && cldSet.length > 0) {
			cldSet.forEach(function (cld) {
				delete cld[keyCode];
				_keyFilter(cld, keyCode);
			});
		}
	};
	
	/**
	 * 参数工厂操作方法
	 * @namespace 参数工厂方法集
	 */
	var SAPrmFactory = {
	
		/**
	  * 获取参数
	  *  @param {string} guid 参数唯一key
	  *  @param {boolean} [fromserver=false]	(暂不可用)强制从服务端获取参数标志，true表示强制从服务端获取
	  *  @return {object} 返回参数
	  */
		getPrm: function getPrm(guid) {
			console.log('getPrm', guid);
			if (!guid) {
				return null;
			}
			if (guid.includes('zblLink') || guid.includes('scfLink')) {
				console.log('includes', guid);
				var url = '';
				var configUrl = {
					zblLink: window.sgiSrvUrl.zblLink,
					scfLink: window.sgiSrvUrl.scfLink
					// http://localhost:3100/tokenLogin?loginToken=eyJ0eXAkvGMY&info=%7B%22isMybl%22:%201,%20%22path%22:%20%22/system/user%22,%20%22page%22:%201%7D
	
				};var routerLink = guid.substring(7);
				// /tokenLogin?info=%7B%22isMybl%22:%201,%20%22path%22:%20%22/system/user%22,%20%22page%22:%201%7D
				// url = guid.includes('zblLink') ? configUrl.zblLink : configUrl.scfLink + routerLink  + tool.getCookie('token');
	
				var token = tool.getCookie('token');
				if (guid.includes('zblLink')) {
					console.log('zblLink token: ' + token + 'window.sgiSrvUrl: ' + window.sgiSrvUrl);
					url = window.sgiSrvUrl.zblLink + routerLink + '?token=' + token;
				}
				if (guid.includes('scfLink')) {
					var ssoToken = tool.getCookie('ssoToken');
					console.log('scfLink ssoToken: ' + ssoToken + 'window.sgiSrvUrl: ' + window.sgiSrvUrl);
					// token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MTMwOTg3NDksInVzZXJuYW1lIjoiYWRtaW4ifQ.k0nwBJx98twZ0oNWzo3y9m_xw78u8B91d8lJqzdThuE'
					url = window.sgiSrvUrl.scfLink + routerLink + '&loginToken=' + ssoToken + '&myblToken=' + token;
				}
	
				window.open(url);
				// window.location.href = url;
				return;
			}
			if (typeof guid != 'string' || guid.constructor != String) {
				return null;
			}
			var ms = guid.split("`");
			var mguid = ms[0];
			// var res = sgiPfClient.restcall(sgiConfig.sapf + "/pf/" + mguid, "GET");
			var res = commonClient.simplecall(_sgiConfig2.default.sapf + "/params/guid/" + mguid, undefined, undefined, undefined, "GET");
			if (res && res.head && res.head.code == "0000") {
				var json = res.body;
				var length = ms.length;
				for (var i = 1; i < length; i++) {
					json = this.findMenber(json, ms[i]);
				}
				return json;
			} else {
				console.log("查询失败！", res.head ? res.head.msg : null);
				tool.popMessage(res.head.msg, "error");
				return null;
			}
		},
		/**
	  * 保存参数方法
	  *  @param {object} root 需要保存的参数对象
	  *  @return {number} 0-成功，-1-失败
	  */
		save: function save(root) {
			if (!root) {
				return null;
			}
			if (!root && (typeof root === 'undefined' ? 'undefined' : _typeof(root)) !== "object") {
				return null;
			}
			var guid = this.makeGUID(root);
			root.guid = guid; //参数赋值/重写guid  hanzb 2018-5-11
	
			// var data = {};
			var copyRoot = tool.copy(root, true);
			// 去掉_key属性
			_keyFilter(copyRoot);
			// data.root = sgiCommon.jsonToStr(copyRoot);
			// var res = sgiPfClient.restcall( + guid, "POST", data);
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/save", copyRoot, callback);
			function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					if (res.body) {
						var newprm = res.body;
						delete newprm.cldSet; //提出子节点 子节点比较重要 不能复制
					}
					// root.prmVsn = newprm.prmVsn;
					// root.auth = newprm.auth;
					// root.crtTm = newprm.crtTm;
					// root.edAuth = newprm.edAuth;
					// root.edTm = newprm.edTm;
					// root.updNum = newprm.updNum;
					Object.assign(root, newprm);
				} else {
					root = null;
					console.log("保存失败！", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
				// return root;
			}
			return root;
		},
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmById: function getPrmById(ap, id) {
			if (!id || !ap) {
				return null;
			}
			var commonVo = { values: { ap: ap, id: id } };
			var prms = {};
			commonClient.simplecall(_sgiConfig2.default.sapf + "/params/id", commonVo, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
			return prms;
		},
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmByAP: function getPrmByAP(ap, batch) {
			if (!ap) {
				return null;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/list", { values: { ap: ap }, batch: batch }, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
			return prms;
		},
		/**
	 	* 获取指定系统下的参数
	 	* @param {string} ap 
	 	* @param {string} [tt] 
	 	* @returns {object[]} 返回符合条件的参数数组
	 	*/
		getPrmByTT: function getPrmByTT(ap, tt, batch) {
			if (!ap && !tt) {
				return null;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/list", { values: { ap: ap, tt: tt }, batch: batch }, callback);
			function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			}
			return prms;
		},
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmBySS: function getPrmBySS(ap, tt, ss, batch) {
			if (!ap && !tt && !ss) {
				return null;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/list", { values: { ap: ap, tt: tt, ss: ss }, batch: batch }, callback);
			function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			}
			return prms;
		},
	
		/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
		getPrmDetailByTT: function getPrmDetailByTT(ap, tt, batch) {
			if (!ap && !tt) {
				return null;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/params/cndt", { values: { ap: ap, tt: tt }, batch: batch }, callback);
			function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			}
			return prms;
		},
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmDetailBySS: function getPrmDetailBySS(ap, tt, ss, batch) {
			if (!ap && !tt && !ss) {
				return null;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/params/cndt", { values: { ap: ap, tt: tt, ss: ss }, batch: batch }, callback);
			function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			}
			return prms;
		},
	
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmByTE: function getPrmByTE(ap, tt, ss, te, batch) {
			if (!ap && !tt && !ss) {
				return null;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/params/cndt", { values: { ap: ap, tt: tt, ss: ss, te: te }, batch: batch }, callback);
			function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			}
			return prms;
		},
	
		/**
	  * 根据guid删除指定参数
	  * @param {string} guid 制定guid
	  */
		remove: function remove(guid) {
			if (!guid) {
				return 0;
			}
			if (typeof guid != 'string' || guid.constructor != String) {
				return 0;
			}
			var ms = guid.split("`");
			var mguid = ms[0];
			var prms = void 0;
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/del", { guid: mguid }, callback);
			function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = 1;
				} else {
					console.log("删除失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			}
			return prms;
		},
	
		/**
	  * 根据guid删除指定参数
	  * @param {string} guid 制定guid
	  */
		removeById: function removeById(ap, id) {
			if (!ap || !id) {
				return 0;
			}
			var prms = void 0;
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/del", { ap: ap, id: id }, callback);
			function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = 1;
				} else {
					console.log("删除失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			}
			return prms;
		},
	
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmByCondt: function getPrmByCondt(commonVo) {
			if (!commonVo) {
				return null;
			}
			if (!commonVo.values || !commonVo.values.ap) {
				return null;
			}
			if (!commonVo.batch) {
				commonVo.batch = false;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/list", commonVo, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
			return prms;
		},
		/**
	  * 获取指定系统下的参数
	  * @param {string} ap 
	  * @param {string} [tt] 
	  * @param {string} [ss] 
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		getPrmDetailByCondt: function getPrmDetailByCondt(commonVo) {
			if (!commonVo) {
				return null;
			}
			if (!commonVo.values || !commonVo.values.ap) {
				return null;
			}
			if (!commonVo.batch) {
				commonVo.batch = false;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/params/cndt", commonVo, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("查询失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
			return prms;
		},
		/**
	  * 保存参数关联信息
	  * @param {string} paramId 
	  * @param {string} rlsParamId
	  * @param {string} rlsTyp
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		saveRls: function saveRls(paramId, rlsParamId, rlsTyp) {
			if (!paramId || !rlsParamId || !rlsTyp) {
				return null;
			}
			var prms = {};
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/rls/save", { ap: tool.Global.currentAP, paramId: paramId, rlsParamId: rlsParamId, rlsTyp: rlsTyp }, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("保存失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
			return prms;
		},
	
		/**
	  * 删除参数关联信息
	  * @param {string} paramId 
	  * @param {string} rlsParamId
	  * @param {string} rlsTyp
	  * @returns {object[]} 返回符合条件的参数数组
	  */
		delRls: function delRls(paramId, rlsParamId, rlsTyp) {
			if (!paramId || !rlsParamId || !rlsTyp) {
				return null;
			}
			var prms = {};
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/rls/delete", { ap: tool.Global.currentAP, paramId: paramId, rlsParamId: rlsParamId, rlsTyp: rlsTyp }, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("删除失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
			return prms;
		},
		/**
	 * 删除参数关联信息
	 * @param {string} paramId 
	 * @param {string} rlsParamId
	 * @param {string} rlsTyp
	 * @returns {object[]} 返回符合条件的参数数组
	 */
		getRlsPrms: function getRlsPrms(paramId, rlsParamId, rlsTyp) {
			if (!paramId && !rlsParamId && !rlsTyp) {
				return null;
			}
			var commonVo = { values: { ap: tool.Global.currentAP }, batch: false };
			if (paramId) {
				commonVo.values.paramId = paramId;
			}
			if (rlsParamId) {
				commonVo.values.rlsParamId = rlsParamId;
			}
			if (rlsTyp) {
				commonVo.values.rlsTyp = rlsTyp;
			}
			var prms = [];
			commonClient.simplecall(_sgiConfig2.default.sapf + "/prm/rls/params", commonVo, function callback(res) {
				if (res && res.head && res.head.code == "0000") {
					prms = res.body;
				} else {
					console.log("删除失败", res.head ? res.head.msg : null);
					tool.popMessage(res.head.msg, "error");
				}
			});
			return prms;
		},
		/**
	  * 从本地缓存获取参数
	  * @param {string} guid 参数guid
	  * @returns {object} 返回缓存参数
	  * 
	  * @ignore
	  */
		getPrmCache: function getPrmCache(guid) {
			return _localStorage.sgiLocalStorage.get(guid);
		},
		/**
	  * 将参数缓存至本地缓存中
	  * @param {string} guid 参数guid
	  * @param {object} json 参数对象
	  * 
	  * @ignore
	  */
		saveLocal: function saveLocal(guid, json) {
			_localStorage.sgiLocalStorage.set(guid, json);
		},
		/**
	  * 从本地缓存中删除参数
	  * @param {string} guid 参数guid
	  * 
	  * @ignore
	  */
		deleteLocal: function deleteLocal(guid) {
			_localStorage.sgiLocalStorage.remove(guid);
		},
	
		/**
	  * 组装guid
	  * @param {object} root 参数对象
	  * @returns {string} 返回的guid
	  * 
	  * @ignore
	  */
		makeGUID: function makeGUID(root) {
			var ap, tt, ss, sc;
			ap = root.ap;
			tt = root.tt;
			ss = root.ss;
			sc = root.sc;
			if (!(ap && tt && ss && sc)) {
				return null;
			}
			var guid = ap + _sgiCommonConstant.GUID.SP + tt + _sgiCommonConstant.GUID.SP + ss + _sgiCommonConstant.GUID.SP + sc;
			return guid;
		},
		/**
	  * 在参数对象子节点中寻找sc匹配的子节点对象
	  * @param {object} json 参数对象
	  * @param {string} sc sc
	  * @returns {object} 匹配的子节点参数对象
	  * 
	  * @ignore
	  */
		findMenber: function findMenber(json, sc) {
			if (!json) {
				return null;
			}
			var children = json.cldSet;
			if (!children) return null;
			var count = children.length;
			for (var i = 0; i < count; i++) {
				if (children[i].sc === sc) {
					json = children[i];
					break;
				}
			}
			return json;
		}
	
		// 初始化
	};if (!window.SAPrmFactory) window.SAPrmFactory = SAPrmFactory;
	// 添加方法
	else Object.assign(window.SAPrmFactory, SAPrmFactory);
	// 导出
	var wSAPrmFactory = window.SAPrmFactory;
	exports.SAPrmFactory = wSAPrmFactory;
	exports.default = wSAPrmFactory;

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.easeInOutCubic = easeInOutCubic;
	
	// eslint-disable-next-line import/prefer-default-export
	function easeInOutCubic(t, b, c, d) {
	  var cc = c - b;
	  t /= d / 2;
	
	  if (t < 1) {
	    return cc / 2 * t * t * t + b;
	  }
	
	  return cc / 2 * ((t -= 2) * t * t + 2) + b;
	}

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var isNumeric = function isNumeric(value) {
	  return !isNaN(parseFloat(value)) && isFinite(value);
	};
	
	var _default = isNumeric;
	exports["default"] = _default;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _cssAnimation = _interopRequireDefault(__webpack_require__(489));
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	/**
	 * Deprecated. We should replace the animation with pure react motion instead of modify style directly.
	 * If you are creating new component with animation, please use `./motion`.
	 */
	function animate(node, show, done) {
	  var height;
	  var requestAnimationFrameId;
	  return (0, _cssAnimation["default"])(node, 'ant-motion-collapse-legacy', {
	    start: function start() {
	      if (!show) {
	        node.style.height = "".concat(node.offsetHeight, "px");
	        node.style.opacity = '1';
	      } else {
	        height = node.offsetHeight;
	        node.style.height = '0px';
	        node.style.opacity = '0';
	      }
	    },
	    active: function active() {
	      if (requestAnimationFrameId) {
	        _raf["default"].cancel(requestAnimationFrameId);
	      }
	
	      requestAnimationFrameId = (0, _raf["default"])(function () {
	        node.style.height = "".concat(show ? height : 0, "px");
	        node.style.opacity = show ? '1' : '0';
	      });
	    },
	    end: function end() {
	      if (requestAnimationFrameId) {
	        _raf["default"].cancel(requestAnimationFrameId);
	      }
	
	      node.style.height = '';
	      node.style.opacity = '';
	      done();
	    }
	  });
	}
	
	var animation = {
	  enter: function enter(node, done) {
	    return animate(node, true, done);
	  },
	  leave: function leave(node, done) {
	    return animate(node, false, done);
	  },
	  appear: function appear(node, done) {
	    return animate(node, true, done);
	  }
	};
	var _default = animation;
	exports["default"] = _default;

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fillRef = fillRef;
	exports.composeRef = composeRef;
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function fillRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
	    ref.current = node;
	  }
	}
	
	function composeRef() {
	  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
	    refs[_key] = arguments[_key];
	  }
	
	  return function (node) {
	    refs.forEach(function (ref) {
	      fillRef(ref, node);
	    });
	  };
	}

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = throttleByAnimationFrame;
	exports.throttleByAnimationFrameDecorator = throttleByAnimationFrameDecorator;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function throttleByAnimationFrame(fn) {
	  var requestId;
	
	  var later = function later(args) {
	    return function () {
	      requestId = null;
	      fn.apply(void 0, _toConsumableArray(args));
	    };
	  };
	
	  var throttled = function throttled() {
	    if (requestId == null) {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      requestId = (0, _raf["default"])(later(args));
	    }
	  };
	
	  throttled.cancel = function () {
	    return _raf["default"].cancel(requestId);
	  };
	
	  return throttled;
	}
	
	function throttleByAnimationFrameDecorator() {
	  // eslint-disable-next-line func-names
	  return function (target, key, descriptor) {
	    var fn = descriptor.value;
	    var definingProperty = false;
	    return {
	      configurable: true,
	      get: function get() {
	        // eslint-disable-next-line no-prototype-builtins
	        if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	          return fn;
	        }
	
	        var boundFn = throttleByAnimationFrame(fn.bind(this));
	        definingProperty = true;
	        Object.defineProperty(this, key, {
	          value: boundFn,
	          configurable: true,
	          writable: true
	        });
	        definingProperty = false;
	        return boundFn;
	      }
	    };
	  };
	}

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = triggerEvent;
	
	function triggerEvent(el, type) {
	  if ('createEvent' in document) {
	    // modern browsers, IE9+
	    var e = document.createEvent('HTMLEvents');
	    e.initEvent(type, false, true);
	    el.dispatchEvent(e);
	  }
	}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTargetRect = getTargetRect;
	exports.getFixedTop = getFixedTop;
	exports.getFixedBottom = getFixedBottom;
	exports.getObserverEntities = getObserverEntities;
	exports.addObserveTarget = addObserveTarget;
	exports.removeObserveTarget = removeObserveTarget;
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function getTargetRect(target) {
	  return target !== window ? target.getBoundingClientRect() : {
	    top: 0,
	    bottom: window.innerHeight
	  };
	}
	
	function getFixedTop(placeholderReact, targetRect, offsetTop) {
	  if (offsetTop !== undefined && targetRect.top > placeholderReact.top - offsetTop) {
	    return offsetTop + targetRect.top;
	  }
	
	  return undefined;
	}
	
	function getFixedBottom(placeholderReact, targetRect, offsetBottom) {
	  if (offsetBottom !== undefined && targetRect.bottom < placeholderReact.bottom + offsetBottom) {
	    var targetBottomOffset = window.innerHeight - targetRect.bottom;
	    return offsetBottom + targetBottomOffset;
	  }
	
	  return undefined;
	} // ======================== Observer ========================
	
	
	var TRIGGER_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
	var observerEntities = [];
	
	function getObserverEntities() {
	  // Only used in test env. Can be removed if refactor.
	  return observerEntities;
	}
	
	function addObserveTarget(target, affix) {
	  if (!target) return;
	  var entity = observerEntities.find(function (item) {
	    return item.target === target;
	  });
	
	  if (entity) {
	    entity.affixList.push(affix);
	  } else {
	    entity = {
	      target: target,
	      affixList: [affix],
	      eventHandlers: {}
	    };
	    observerEntities.push(entity); // Add listener
	
	    TRIGGER_EVENTS.forEach(function (eventName) {
	      entity.eventHandlers[eventName] = (0, _addEventListener["default"])(target, eventName, function () {
	        entity.affixList.forEach(function (targetAffix) {
	          targetAffix.lazyUpdatePosition();
	        });
	      });
	    });
	  }
	}
	
	function removeObserveTarget(affix) {
	  var observerEntity = observerEntities.find(function (oriObserverEntity) {
	    var hasAffix = oriObserverEntity.affixList.some(function (item) {
	      return item === affix;
	    });
	
	    if (hasAffix) {
	      oriObserverEntity.affixList = oriObserverEntity.affixList.filter(function (item) {
	        return item !== affix;
	      });
	    }
	
	    return hasAffix;
	  });
	
	  if (observerEntity && observerEntity.affixList.length === 0) {
	    observerEntities = observerEntities.filter(function (item) {
	      return item !== observerEntity;
	    }); // Remove listener
	
	    TRIGGER_EVENTS.forEach(function (eventName) {
	      var handler = observerEntity.eventHandlers[eventName];
	
	      if (handler && handler.remove) {
	        handler.remove();
	      }
	    });
	  }
	}

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(629));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function noop() {}
	
	var Alert = /*#__PURE__*/function (_React$Component) {
	  _inherits(Alert, _React$Component);
	
	  var _super = _createSuper(Alert);
	
	  function Alert(props) {
	    var _this;
	
	    _classCallCheck(this, Alert);
	
	    _this = _super.call(this, props);
	
	    _this.handleClose = function (e) {
	      e.preventDefault();
	      var dom = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      dom.style.height = "".concat(dom.offsetHeight, "px"); // Magic code
	      // 重复一次后才能正确设置 height
	
	      dom.style.height = "".concat(dom.offsetHeight, "px");
	
	      _this.setState({
	        closing: true
	      });
	
	      (_this.props.onClose || noop)(e);
	    };
	
	    _this.animationEnd = function () {
	      _this.setState({
	        closing: false,
	        closed: true
	      });
	
	      (_this.props.afterClose || noop)();
	    };
	
	    _this.renderAlert = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          description = _this$props.description,
	          customizePrefixCls = _this$props.prefixCls,
	          message = _this$props.message,
	          closeText = _this$props.closeText,
	          banner = _this$props.banner,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          style = _this$props.style,
	          icon = _this$props.icon;
	      var _this$props2 = _this.props,
	          closable = _this$props2.closable,
	          type = _this$props2.type,
	          showIcon = _this$props2.showIcon,
	          iconType = _this$props2.iconType;
	      var _this$state = _this.state,
	          closing = _this$state.closing,
	          closed = _this$state.closed;
	      var prefixCls = getPrefixCls('alert', customizePrefixCls); // banner模式默认有 Icon
	
	      showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告
	
	      type = banner && type === undefined ? 'warning' : type || 'info';
	      var iconTheme = 'filled';
	
	      if (!iconType) {
	        switch (type) {
	          case 'success':
	            iconType = 'check-circle';
	            break;
	
	          case 'info':
	            iconType = 'info-circle';
	            break;
	
	          case 'error':
	            iconType = 'close-circle';
	            break;
	
	          case 'warning':
	            iconType = 'exclamation-circle';
	            break;
	
	          default:
	            iconType = 'default';
	        } // use outline icon in alert with description
	
	
	        if (description) {
	          iconTheme = 'outlined';
	        }
	      } // closeable when closeText is assigned
	
	
	      if (closeText) {
	        closable = true;
	      }
	
	      var alertCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-closing"), closing), _defineProperty(_classNames, "".concat(prefixCls, "-with-description"), !!description), _defineProperty(_classNames, "".concat(prefixCls, "-no-icon"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-banner"), !!banner), _defineProperty(_classNames, "".concat(prefixCls, "-closable"), closable), _classNames), className);
	      var closeIcon = closable ? /*#__PURE__*/React.createElement("button", {
	        type: "button",
	        onClick: _this.handleClose,
	        className: "".concat(prefixCls, "-close-icon"),
	        tabIndex: 0
	      }, closeText ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-text")
	      }, closeText) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close"
	      })) : null;
	      var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(_this.props);
	      var iconNode = icon && ( /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), _defineProperty({}, icon.props.className, icon.props.className))
	      }) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-icon")
	      }, icon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: iconType,
	        theme: iconTheme
	      });
	      return closed ? null : /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        component: "",
	        showProp: "data-show",
	        transitionName: "".concat(prefixCls, "-slide-up"),
	        onEnd: _this.animationEnd
	      }, /*#__PURE__*/React.createElement("div", _extends({
	        "data-show": !closing,
	        className: alertCls,
	        style: style
	      }, dataOrAriaProps), showIcon ? iconNode : null, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-message")
	      }, message), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-description")
	      }, description), closeIcon));
	    };
	
	    (0, _warning["default"])(!('iconType' in props), 'Alert', '`iconType` is deprecated. Please use `icon` instead.');
	    _this.state = {
	      closing: false,
	      closed: false
	    };
	    return _this;
	  }
	
	  _createClass(Alert, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAlert)
	      );
	    }
	  }]);
	
	  return Alert;
	}(React.Component);
	
	exports["default"] = Alert;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _affix = _interopRequireDefault(__webpack_require__(634));
	
	var _configProvider = __webpack_require__(14);
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(351));
	
	var _getScroll = _interopRequireDefault(__webpack_require__(350));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getDefaultContainer() {
	  return window;
	}
	
	function getOffsetTop(element, container) {
	  if (!element) {
	    return 0;
	  }
	
	  if (!element.getClientRects().length) {
	    return 0;
	  }
	
	  var rect = element.getBoundingClientRect();
	
	  if (rect.width || rect.height) {
	    if (container === window) {
	      container = element.ownerDocument.documentElement;
	      return rect.top - container.clientTop;
	    }
	
	    return rect.top - container.getBoundingClientRect().top;
	  }
	
	  return rect.top;
	}
	
	var sharpMatcherRegx = /#([^#]+)$/;
	
	var Anchor = /*#__PURE__*/function (_React$Component) {
	  _inherits(Anchor, _React$Component);
	
	  var _super = _createSuper(Anchor);
	
	  function Anchor() {
	    var _this;
	
	    _classCallCheck(this, Anchor);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      activeLink: null
	    };
	    _this.links = [];
	
	    _this.handleScrollTo = function (link) {
	      var _this$props = _this.props,
	          offsetTop = _this$props.offsetTop,
	          getContainer = _this$props.getContainer,
	          targetOffset = _this$props.targetOffset;
	
	      _this.setCurrentActiveLink(link);
	
	      var container = getContainer();
	      var scrollTop = (0, _getScroll["default"])(container, true);
	      var sharpLinkMatch = sharpMatcherRegx.exec(link);
	
	      if (!sharpLinkMatch) {
	        return;
	      }
	
	      var targetElement = document.getElementById(sharpLinkMatch[1]);
	
	      if (!targetElement) {
	        return;
	      }
	
	      var eleOffsetTop = getOffsetTop(targetElement, container);
	      var y = scrollTop + eleOffsetTop;
	      y -= targetOffset !== undefined ? targetOffset : offsetTop || 0;
	      _this.animating = true;
	      (0, _scrollTo["default"])(y, {
	        callback: function callback() {
	          _this.animating = false;
	        },
	        getContainer: getContainer
	      });
	    };
	
	    _this.saveInkNode = function (node) {
	      _this.inkNode = node;
	    };
	
	    _this.setCurrentActiveLink = function (link) {
	      var activeLink = _this.state.activeLink;
	      var onChange = _this.props.onChange;
	
	      if (activeLink !== link) {
	        _this.setState({
	          activeLink: link
	        });
	
	        if (onChange) {
	          onChange(link);
	        }
	      }
	    };
	
	    _this.handleScroll = function () {
	      if (_this.animating) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          offsetTop = _this$props2.offsetTop,
	          bounds = _this$props2.bounds,
	          targetOffset = _this$props2.targetOffset;
	
	      var currentActiveLink = _this.getCurrentAnchor(targetOffset !== undefined ? targetOffset : offsetTop || 0, bounds);
	
	      _this.setCurrentActiveLink(currentActiveLink);
	    };
	
	    _this.updateInk = function () {
	      if (typeof document === 'undefined') {
	        return;
	      }
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      var anchorNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var linkNode = anchorNode.getElementsByClassName("".concat(prefixCls, "-link-title-active"))[0];
	
	      if (linkNode) {
	        _this.inkNode.style.top = "".concat(linkNode.offsetTop + linkNode.clientHeight / 2 - 4.5, "px");
	      }
	    };
	
	    _this.renderAnchor = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props3 = _this.props,
	          customizePrefixCls = _this$props3.prefixCls,
	          _this$props3$classNam = _this$props3.className,
	          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
	          style = _this$props3.style,
	          offsetTop = _this$props3.offsetTop,
	          affix = _this$props3.affix,
	          showInkInFixed = _this$props3.showInkInFixed,
	          children = _this$props3.children,
	          getContainer = _this$props3.getContainer;
	      var activeLink = _this.state.activeLink;
	      var prefixCls = getPrefixCls('anchor', customizePrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      var inkClass = (0, _classnames["default"])("".concat(prefixCls, "-ink-ball"), {
	        visible: activeLink
	      });
	      var wrapperClass = (0, _classnames["default"])(className, "".concat(prefixCls, "-wrapper"));
	      var anchorClass = (0, _classnames["default"])(prefixCls, {
	        fixed: !affix && !showInkInFixed
	      });
	
	      var wrapperStyle = _extends({
	        maxHeight: offsetTop ? "calc(100vh - ".concat(offsetTop, "px)") : '100vh'
	      }, style);
	
	      var anchorContent = /*#__PURE__*/React.createElement("div", {
	        className: wrapperClass,
	        style: wrapperStyle
	      }, /*#__PURE__*/React.createElement("div", {
	        className: anchorClass
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-ink")
	      }, /*#__PURE__*/React.createElement("span", {
	        className: inkClass,
	        ref: _this.saveInkNode
	      })), children));
	      return !affix ? anchorContent : /*#__PURE__*/React.createElement(_affix["default"], {
	        offsetTop: offsetTop,
	        target: getContainer
	      }, anchorContent);
	    };
	
	    return _this;
	  }
	
	  _createClass(Anchor, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _this2 = this;
	
	      var antAnchor = {
	        registerLink: function registerLink(link) {
	          if (!_this2.links.includes(link)) {
	            _this2.links.push(link);
	          }
	        },
	        unregisterLink: function unregisterLink(link) {
	          var index = _this2.links.indexOf(link);
	
	          if (index !== -1) {
	            _this2.links.splice(index, 1);
	          }
	        },
	        activeLink: this.state.activeLink,
	        scrollTo: this.handleScrollTo,
	        onClick: this.props.onClick
	      };
	      return {
	        antAnchor: antAnchor
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var getContainer = this.props.getContainer;
	      this.scrollContainer = getContainer();
	      this.scrollEvent = (0, _addEventListener["default"])(this.scrollContainer, 'scroll', this.handleScroll);
	      this.handleScroll();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.scrollEvent) {
	        var getContainer = this.props.getContainer;
	        var currentContainer = getContainer();
	
	        if (this.scrollContainer !== currentContainer) {
	          this.scrollContainer = currentContainer;
	          this.scrollEvent.remove();
	          this.scrollEvent = (0, _addEventListener["default"])(this.scrollContainer, 'scroll', this.handleScroll);
	          this.handleScroll();
	        }
	      }
	
	      this.updateInk();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEvent) {
	        this.scrollEvent.remove();
	      }
	    }
	  }, {
	    key: "getCurrentAnchor",
	    value: function getCurrentAnchor() {
	      var offsetTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var bounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	      var getCurrentAnchor = this.props.getCurrentAnchor;
	
	      if (typeof getCurrentAnchor === 'function') {
	        return getCurrentAnchor();
	      }
	
	      var activeLink = '';
	
	      if (typeof document === 'undefined') {
	        return activeLink;
	      }
	
	      var linkSections = [];
	      var getContainer = this.props.getContainer;
	      var container = getContainer();
	      this.links.forEach(function (link) {
	        var sharpLinkMatch = sharpMatcherRegx.exec(link.toString());
	
	        if (!sharpLinkMatch) {
	          return;
	        }
	
	        var target = document.getElementById(sharpLinkMatch[1]);
	
	        if (target) {
	          var top = getOffsetTop(target, container);
	
	          if (top < offsetTop + bounds) {
	            linkSections.push({
	              link: link,
	              top: top
	            });
	          }
	        }
	      });
	
	      if (linkSections.length) {
	        var maxSection = linkSections.reduce(function (prev, curr) {
	          return curr.top > prev.top ? curr : prev;
	        });
	        return maxSection.link;
	      }
	
	      return '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAnchor)
	      );
	    }
	  }]);
	
	  return Anchor;
	}(React.Component);
	
	exports["default"] = Anchor;
	Anchor.defaultProps = {
	  affix: true,
	  showInkInFixed: false,
	  getContainer: getDefaultContainer
	};
	Anchor.childContextTypes = {
	  antAnchor: PropTypes.object
	};

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var AnchorLink = /*#__PURE__*/function (_React$Component) {
	  _inherits(AnchorLink, _React$Component);
	
	  var _super = _createSuper(AnchorLink);
	
	  function AnchorLink() {
	    var _this;
	
	    _classCallCheck(this, AnchorLink);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function (e) {
	      var _this$context$antAnch = _this.context.antAnchor,
	          scrollTo = _this$context$antAnch.scrollTo,
	          onClick = _this$context$antAnch.onClick;
	      var _this$props = _this.props,
	          href = _this$props.href,
	          title = _this$props.title;
	
	      if (onClick) {
	        onClick(e, {
	          title: title,
	          href: href
	        });
	      }
	
	      scrollTo(href);
	    };
	
	    _this.renderAnchorLink = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          href = _this$props2.href,
	          title = _this$props2.title,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          target = _this$props2.target;
	      var prefixCls = getPrefixCls('anchor', customizePrefixCls);
	      var active = _this.context.antAnchor.activeLink === href;
	      var wrapperClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-link"), _defineProperty({}, "".concat(prefixCls, "-link-active"), active));
	      var titleClassName = (0, _classnames["default"])("".concat(prefixCls, "-link-title"), _defineProperty({}, "".concat(prefixCls, "-link-title-active"), active));
	      return (/*#__PURE__*/React.createElement("div", {
	          className: wrapperClassName
	        }, /*#__PURE__*/React.createElement("a", {
	          className: titleClassName,
	          href: href,
	          title: typeof title === 'string' ? title : '',
	          target: target,
	          onClick: _this.handleClick
	        }, title), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(AnchorLink, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.context.antAnchor.registerLink(this.props.href);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref2) {
	      var prevHref = _ref2.href;
	      var href = this.props.href;
	
	      if (prevHref !== href) {
	        this.context.antAnchor.unregisterLink(prevHref);
	        this.context.antAnchor.registerLink(href);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.context.antAnchor.unregisterLink(this.props.href);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAnchorLink)
	      );
	    }
	  }]);
	
	  return AnchorLink;
	}(React.Component);
	
	AnchorLink.defaultProps = {
	  href: '#'
	};
	AnchorLink.contextTypes = {
	  antAnchor: PropTypes.object
	};
	(0, _reactLifecyclesCompat.polyfill)(AnchorLink);
	var _default = AnchorLink;
	exports["default"] = _default;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Anchor = _interopRequireDefault(__webpack_require__(1168));
	
	var _AnchorLink = _interopRequireDefault(__webpack_require__(1169));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Anchor["default"].Link = _AnchorLink["default"];
	var _default = _Anchor["default"];
	exports["default"] = _default;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var InputElement = /*#__PURE__*/function (_React$Component) {
	  _inherits(InputElement, _React$Component);
	
	  var _super = _createSuper(InputElement);
	
	  function InputElement() {
	    var _this;
	
	    _classCallCheck(this, InputElement);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveRef = function (ele) {
	      var childRef = _this.props.children.ref;
	
	      if (typeof childRef === 'function') {
	        childRef(ele);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(InputElement, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.cloneElement(this.props.children, _extends(_extends({}, this.props), {
	          ref: this.saveRef
	        }), null)
	      );
	    }
	  }]);
	
	  return InputElement;
	}(React.Component);
	
	exports["default"] = InputElement;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcSelect = __webpack_require__(191);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _InputElement = _interopRequireDefault(__webpack_require__(1171));
	
	var _input = _interopRequireDefault(__webpack_require__(244));
	
	var _select = _interopRequireDefault(__webpack_require__(202));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function isSelectOptionOrSelectOptGroup(child) {
	  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
	}
	
	var AutoComplete = /*#__PURE__*/function (_React$Component) {
	  _inherits(AutoComplete, _React$Component);
	
	  var _super = _createSuper(AutoComplete);
	
	  function AutoComplete() {
	    var _this;
	
	    _classCallCheck(this, AutoComplete);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveSelect = function (node) {
	      _this.select = node;
	    };
	
	    _this.getInputElement = function () {
	      var children = _this.props.children;
	      var element = children && /*#__PURE__*/React.isValidElement(children) && children.type !== _rcSelect.Option ? React.Children.only(_this.props.children) : /*#__PURE__*/React.createElement(_input["default"], null);
	
	      var elementProps = _extends({}, element.props); // https://github.com/ant-design/ant-design/pull/7742
	
	
	      delete elementProps.children;
	      return (/*#__PURE__*/React.createElement(_InputElement["default"], elementProps, element)
	      );
	    };
	
	    _this.renderAutoComplete = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          size = _this$props.size,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          notFoundContent = _this$props.notFoundContent,
	          optionLabelProp = _this$props.optionLabelProp,
	          dataSource = _this$props.dataSource,
	          children = _this$props.children;
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "".concat(prefixCls, "-show-search"), true), _defineProperty(_classNames, "".concat(prefixCls, "-auto-complete"), true), _classNames));
	      var options;
	      var childArray = React.Children.toArray(children);
	
	      if (childArray.length && isSelectOptionOrSelectOptGroup(childArray[0])) {
	        options = children;
	      } else {
	        options = dataSource ? dataSource.map(function (item) {
	          if ( /*#__PURE__*/React.isValidElement(item)) {
	            return item;
	          }
	
	          switch (_typeof(item)) {
	            case 'string':
	              return (/*#__PURE__*/React.createElement(_rcSelect.Option, {
	                  key: item
	                }, item)
	              );
	
	            case 'object':
	              return (/*#__PURE__*/React.createElement(_rcSelect.Option, {
	                  key: item.value
	                }, item.text)
	              );
	
	            default:
	              throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
	          }
	        }) : [];
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], _extends({}, _this.props, {
	          className: cls,
	          mode: _select["default"].SECRET_COMBOBOX_MODE_DO_NOT_USE,
	          optionLabelProp: optionLabelProp,
	          getInputElement: _this.getInputElement,
	          notFoundContent: notFoundContent,
	          ref: _this.saveSelect
	        }), options)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(AutoComplete, [{
	    key: "focus",
	    value: function focus() {
	      this.select.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.select.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAutoComplete)
	      );
	    }
	  }]);
	
	  return AutoComplete;
	}(React.Component);
	
	exports["default"] = AutoComplete;
	AutoComplete.Option = _rcSelect.Option;
	AutoComplete.OptGroup = _rcSelect.OptGroup;
	AutoComplete.defaultProps = {
	  transitionName: 'slide-up',
	  optionLabelProp: 'children',
	  choiceTransitionName: 'zoom',
	  showSearch: false,
	  filterOption: false
	};

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(14);
	
	var _getScroll = _interopRequireDefault(__webpack_require__(350));
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(351));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getDefaultTarget() {
	  return window;
	}
	
	var BackTop = /*#__PURE__*/function (_React$Component) {
	  _inherits(BackTop, _React$Component);
	
	  var _super = _createSuper(BackTop);
	
	  function BackTop(props) {
	    var _this;
	
	    _classCallCheck(this, BackTop);
	
	    _this = _super.call(this, props);
	
	    _this.scrollToTop = function (e) {
	      var _this$props = _this.props,
	          _this$props$target = _this$props.target,
	          target = _this$props$target === void 0 ? getDefaultTarget : _this$props$target,
	          onClick = _this$props.onClick;
	      (0, _scrollTo["default"])(0, {
	        getContainer: target
	      });
	
	      if (typeof onClick === 'function') {
	        onClick(e);
	      }
	    };
	
	    _this.handleScroll = function () {
	      var _this$props2 = _this.props,
	          visibilityHeight = _this$props2.visibilityHeight,
	          _this$props2$target = _this$props2.target,
	          target = _this$props2$target === void 0 ? getDefaultTarget : _this$props2$target;
	      var scrollTop = (0, _getScroll["default"])(target(), true);
	
	      _this.setState({
	        visible: scrollTop > visibilityHeight
	      });
	    };
	
	    _this.renderBackTop = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props3 = _this.props,
	          customizePrefixCls = _this$props3.prefixCls,
	          _this$props3$classNam = _this$props3.className,
	          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
	          children = _this$props3.children;
	      var prefixCls = getPrefixCls('back-top', customizePrefixCls);
	      var classString = (0, _classnames["default"])(prefixCls, className);
	      var defaultElement = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-icon")
	      })); // fix https://fb.me/react-unknown-prop
	
	      var divProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'children', 'visibilityHeight', 'target', 'visible']);
	      var visible = 'visible' in _this.props ? _this.props.visible : _this.state.visible;
	      var backTopBtn = visible ? /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        className: classString,
	        onClick: _this.scrollToTop
	      }), children || defaultElement) : null;
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "",
	          transitionName: "fade"
	        }, backTopBtn)
	      );
	    };
	
	    _this.state = {
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(BackTop, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var getTarget = this.props.target || getDefaultTarget;
	      this.scrollEvent = (0, _addEventListener["default"])(getTarget(), 'scroll', this.handleScroll);
	      this.handleScroll();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEvent) {
	        this.scrollEvent.remove();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBackTop)
	      );
	    }
	  }]);
	
	  return BackTop;
	}(React.Component);
	
	exports["default"] = BackTop;
	BackTop.defaultProps = {
	  visibilityHeight: 400
	};

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getNumberArray(num) {
	  return num ? num.toString().split('').reverse().map(function (i) {
	    var current = Number(i);
	    return isNaN(current) ? i : current;
	  }) : [];
	}
	
	function renderNumberList(position, className) {
	  var childrenToReturn = [];
	
	  for (var i = 0; i < 30; i++) {
	    childrenToReturn.push( /*#__PURE__*/React.createElement("p", {
	      key: i.toString(),
	      className: (0, _classnames["default"])(className, {
	        current: position === i
	      })
	    }, i % 10));
	  }
	
	  return childrenToReturn;
	}
	
	var ScrollNumber = /*#__PURE__*/function (_React$Component) {
	  _inherits(ScrollNumber, _React$Component);
	
	  var _super = _createSuper(ScrollNumber);
	
	  function ScrollNumber(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollNumber);
	
	    _this = _super.call(this, props);
	
	    _this.onAnimated = function () {
	      var onAnimated = _this.props.onAnimated;
	
	      if (onAnimated) {
	        onAnimated();
	      }
	    };
	
	    _this.renderScrollNumber = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          style = _this$props.style,
	          title = _this$props.title,
	          _this$props$component = _this$props.component,
	          component = _this$props$component === void 0 ? 'sup' : _this$props$component,
	          displayComponent = _this$props.displayComponent; // fix https://fb.me/react-unknown-prop
	
	      var restProps = (0, _omit["default"])(_this.props, ['count', 'onAnimated', 'component', 'prefixCls', 'displayComponent']);
	      var prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
	
	      var newProps = _extends(_extends({}, restProps), {
	        className: (0, _classnames["default"])(prefixCls, className),
	        title: title
	      }); // allow specify the border
	      // mock border-color by box-shadow for compatible with old usage:
	      // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
	
	
	      if (style && style.borderColor) {
	        newProps.style = _extends(_extends({}, style), {
	          boxShadow: "0 0 0 1px ".concat(style.borderColor, " inset")
	        });
	      }
	
	      if (displayComponent) {
	        return (/*#__PURE__*/React.cloneElement(displayComponent, {
	            className: (0, _classnames["default"])("".concat(prefixCls, "-custom-component"), displayComponent.props && displayComponent.props.className)
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(component, newProps, _this.renderNumberElement(prefixCls))
	      );
	    };
	
	    _this.state = {
	      animateStarted: true,
	      count: props.count
	    };
	    return _this;
	  }
	
	  _createClass(ScrollNumber, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      var _this2 = this;
	
	      this.lastCount = prevState.count;
	      var animateStarted = this.state.animateStarted;
	
	      if (animateStarted) {
	        this.clearTimeout(); // Let browser has time to reset the scroller before actually
	        // performing the transition.
	
	        this.timeout = setTimeout(function () {
	          // eslint-disable-next-line react/no-did-update-set-state
	          _this2.setState(function (__, props) {
	            return {
	              animateStarted: false,
	              count: props.count
	            };
	          }, _this2.onAnimated);
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearTimeout();
	    }
	  }, {
	    key: "getPositionByNum",
	    value: function getPositionByNum(num, i) {
	      var count = this.state.count;
	      var currentCount = Math.abs(Number(count));
	      var lastCount = Math.abs(Number(this.lastCount));
	      var currentDigit = Math.abs(getNumberArray(this.state.count)[i]);
	      var lastDigit = Math.abs(getNumberArray(this.lastCount)[i]);
	
	      if (this.state.animateStarted) {
	        return 10 + num;
	      } // 同方向则在同一侧切换数字
	
	
	      if (currentCount > lastCount) {
	        if (currentDigit >= lastDigit) {
	          return 10 + num;
	        }
	
	        return 20 + num;
	      }
	
	      if (currentDigit <= lastDigit) {
	        return 10 + num;
	      }
	
	      return num;
	    }
	  }, {
	    key: "renderCurrentNumber",
	    value: function renderCurrentNumber(prefixCls, num, i) {
	      if (typeof num === 'number') {
	        var position = this.getPositionByNum(num, i);
	        var removeTransition = this.state.animateStarted || getNumberArray(this.lastCount)[i] === undefined;
	        return (/*#__PURE__*/React.createElement('span', {
	            className: "".concat(prefixCls, "-only"),
	            style: {
	              transition: removeTransition ? 'none' : undefined,
	              msTransform: "translateY(".concat(-position * 100, "%)"),
	              WebkitTransform: "translateY(".concat(-position * 100, "%)"),
	              transform: "translateY(".concat(-position * 100, "%)")
	            },
	            key: i
	          }, renderNumberList(position, "".concat(prefixCls, "-only-unit")))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          key: "symbol",
	          className: "".concat(prefixCls, "-symbol")
	        }, num)
	      );
	    }
	  }, {
	    key: "renderNumberElement",
	    value: function renderNumberElement(prefixCls) {
	      var _this3 = this;
	
	      var count = this.state.count;
	
	      if (count && Number(count) % 1 === 0) {
	        return getNumberArray(count).map(function (num, i) {
	          return _this3.renderCurrentNumber(prefixCls, num, i);
	        }).reverse();
	      }
	
	      return count;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderScrollNumber)
	      );
	    }
	  }, {
	    key: "clearTimeout",
	    value: function (_clearTimeout) {
	      function clearTimeout() {
	        return _clearTimeout.apply(this, arguments);
	      }
	
	      clearTimeout.toString = function () {
	        return _clearTimeout.toString();
	      };
	
	      return clearTimeout;
	    }(function () {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = undefined;
	      }
	    })
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, nextState) {
	      if ('count' in nextProps) {
	        if (nextState.count === nextProps.count) {
	          return null;
	        }
	
	        return {
	          animateStarted: true
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScrollNumber;
	}(React.Component);
	
	ScrollNumber.defaultProps = {
	  count: null,
	  onAnimated: function onAnimated() {}
	};
	(0, _reactLifecyclesCompat.polyfill)(ScrollNumber);
	var _default = ScrollNumber;
	exports["default"] = _default;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _ScrollNumber = _interopRequireDefault(__webpack_require__(1174));
	
	var _colors = __webpack_require__(628);
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function isPresetColor(color) {
	  return _colors.PresetColorTypes.indexOf(color) !== -1;
	}
	
	var Badge = /*#__PURE__*/function (_React$Component) {
	  _inherits(Badge, _React$Component);
	
	  var _super = _createSuper(Badge);
	
	  function Badge() {
	    var _this;
	
	    _classCallCheck(this, Badge);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderBadge = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeScrollNumberPrefixCls = _a.scrollNumberPrefixCls,
	          children = _a.children,
	          status = _a.status,
	          text = _a.text,
	          color = _a.color,
	          restProps = __rest(_a, ["prefixCls", "scrollNumberPrefixCls", "children", "status", "text", "color"]);
	
	      var omitArr = ['count', 'showZero', 'overflowCount', 'className', 'style', 'dot', 'offset', 'title'];
	      var prefixCls = getPrefixCls('badge', customizePrefixCls);
	      var scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);
	
	      var scrollNumber = _this.renderBadgeNumber(prefixCls, scrollNumberPrefixCls);
	
	      var statusText = _this.renderStatusText(prefixCls);
	
	      var statusCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-status-dot"), _this.hasStatus()), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames));
	      var statusStyle = {};
	
	      if (color && !isPresetColor(color)) {
	        statusStyle.background = color;
	      } // <Badge status="success" />
	
	
	      if (!children && _this.hasStatus()) {
	        var styleWithOffset = _this.getStyleWithOffset();
	
	        var statusTextColor = styleWithOffset && styleWithOffset.color;
	        return (/*#__PURE__*/React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
	            className: _this.getBadgeClassName(prefixCls),
	            style: styleWithOffset
	          }), /*#__PURE__*/React.createElement("span", {
	            className: statusCls,
	            style: statusStyle
	          }), /*#__PURE__*/React.createElement("span", {
	            style: {
	              color: statusTextColor
	            },
	            className: "".concat(prefixCls, "-status-text")
	          }, text))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
	          className: _this.getBadgeClassName(prefixCls)
	        }), children, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "",
	          showProp: "data-show",
	          transitionName: children ? "".concat(prefixCls, "-zoom") : '',
	          transitionAppear: true
	        }, scrollNumber), statusText)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Badge, [{
	    key: "getNumberedDispayCount",
	    value: function getNumberedDispayCount() {
	      var _this$props = this.props,
	          count = _this$props.count,
	          overflowCount = _this$props.overflowCount;
	      var displayCount = count > overflowCount ? "".concat(overflowCount, "+") : count;
	      return displayCount;
	    }
	  }, {
	    key: "getDispayCount",
	    value: function getDispayCount() {
	      var isDot = this.isDot(); // dot mode don't need count
	
	      if (isDot) {
	        return '';
	      }
	
	      return this.getNumberedDispayCount();
	    }
	  }, {
	    key: "getScrollNumberTitle",
	    value: function getScrollNumberTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          count = _this$props2.count;
	
	      if (title) {
	        return title;
	      }
	
	      return typeof count === 'string' || typeof count === 'number' ? count : undefined;
	    }
	  }, {
	    key: "getStyleWithOffset",
	    value: function getStyleWithOffset() {
	      var _this$props3 = this.props,
	          offset = _this$props3.offset,
	          style = _this$props3.style;
	      return offset ? _extends({
	        right: -parseInt(offset[0], 10),
	        marginTop: offset[1]
	      }, style) : style;
	    }
	  }, {
	    key: "getBadgeClassName",
	    value: function getBadgeClassName(prefixCls) {
	      var _classNames2;
	
	      var _this$props4 = this.props,
	          className = _this$props4.className,
	          children = _this$props4.children;
	      return (0, _classnames["default"])(className, prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-status"), this.hasStatus()), _defineProperty(_classNames2, "".concat(prefixCls, "-not-a-wrapper"), !children), _classNames2));
	    }
	  }, {
	    key: "hasStatus",
	    value: function hasStatus() {
	      var _this$props5 = this.props,
	          status = _this$props5.status,
	          color = _this$props5.color;
	      return !!status || !!color;
	    }
	  }, {
	    key: "isZero",
	    value: function isZero() {
	      var numberedDispayCount = this.getNumberedDispayCount();
	      return numberedDispayCount === '0' || numberedDispayCount === 0;
	    }
	  }, {
	    key: "isDot",
	    value: function isDot() {
	      var dot = this.props.dot;
	      var isZero = this.isZero();
	      return dot && !isZero || this.hasStatus();
	    }
	  }, {
	    key: "isHidden",
	    value: function isHidden() {
	      var showZero = this.props.showZero;
	      var displayCount = this.getDispayCount();
	      var isZero = this.isZero();
	      var isDot = this.isDot();
	      var isEmpty = displayCount === null || displayCount === undefined || displayCount === '';
	      return (isEmpty || isZero && !showZero) && !isDot;
	    }
	  }, {
	    key: "renderStatusText",
	    value: function renderStatusText(prefixCls) {
	      var text = this.props.text;
	      var hidden = this.isHidden();
	      return hidden || !text ? null : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-status-text")
	      }, text);
	    }
	  }, {
	    key: "renderDispayComponent",
	    value: function renderDispayComponent() {
	      var count = this.props.count;
	      var customNode = count;
	
	      if (!customNode || _typeof(customNode) !== 'object') {
	        return undefined;
	      }
	
	      return (/*#__PURE__*/React.cloneElement(customNode, {
	          style: _extends(_extends({}, this.getStyleWithOffset()), customNode.props && customNode.props.style)
	        })
	      );
	    }
	  }, {
	    key: "renderBadgeNumber",
	    value: function renderBadgeNumber(prefixCls, scrollNumberPrefixCls) {
	      var _classNames3;
	
	      var _this$props6 = this.props,
	          status = _this$props6.status,
	          count = _this$props6.count,
	          color = _this$props6.color;
	      var displayCount = this.getDispayCount();
	      var isDot = this.isDot();
	      var hidden = this.isHidden();
	      var scrollNumberCls = (0, _classnames["default"])((_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-dot"), isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-count"), !isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-multiple-words"), !isDot && count && count.toString && count.toString().length > 1), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames3));
	      var statusStyle = this.getStyleWithOffset();
	
	      if (color && !isPresetColor(color)) {
	        statusStyle = statusStyle || {};
	        statusStyle.background = color;
	      }
	
	      return hidden ? null : /*#__PURE__*/React.createElement(_ScrollNumber["default"], {
	        prefixCls: scrollNumberPrefixCls,
	        "data-show": !hidden,
	        className: scrollNumberCls,
	        count: displayCount,
	        displayComponent: this.renderDispayComponent() // <Badge status="success" count={<Icon type="xxx" />}></Badge>
	
	        , title: this.getScrollNumberTitle(),
	        style: statusStyle,
	        key: "scrollNumber"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBadge)
	      );
	    }
	  }]);
	
	  return Badge;
	}(React.Component);
	
	exports["default"] = Badge;
	Badge.defaultProps = {
	  count: null,
	  showZero: false,
	  dot: false,
	  overflowCount: 99
	};
	Badge.propTypes = {
	  count: PropTypes.node,
	  showZero: PropTypes.bool,
	  dot: PropTypes.bool,
	  overflowCount: PropTypes.number
	};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(636));
	
	var _menu = _interopRequireDefault(__webpack_require__(359));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getBreadcrumbName(route, params) {
	  if (!route.breadcrumbName) {
	    return null;
	  }
	
	  var paramsKeys = Object.keys(params).join('|');
	  var name = route.breadcrumbName.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function (replacement, key) {
	    return params[key] || replacement;
	  });
	  return name;
	}
	
	function defaultItemRender(route, params, routes, paths) {
	  var isLastItem = routes.indexOf(route) === routes.length - 1;
	  var name = getBreadcrumbName(route, params);
	  return isLastItem ? /*#__PURE__*/React.createElement("span", null, name) : /*#__PURE__*/React.createElement("a", {
	    href: "#/".concat(paths.join('/'))
	  }, name);
	}
	
	function filterFragment(children) {
	  return (0, _toArray["default"])(children).map(function (element) {
	    if ( /*#__PURE__*/React.isValidElement(element) && element.type === React.Fragment) {
	      var props = element.props;
	      return props.children;
	    }
	
	    return element;
	  });
	}
	
	var Breadcrumb = /*#__PURE__*/function (_React$Component) {
	  _inherits(Breadcrumb, _React$Component);
	
	  var _super = _createSuper(Breadcrumb);
	
	  function Breadcrumb() {
	    var _this;
	
	    _classCallCheck(this, Breadcrumb);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getPath = function (path, params) {
	      path = (path || '').replace(/^\//, '');
	      Object.keys(params).forEach(function (key) {
	        path = path.replace(":".concat(key), params[key]);
	      });
	      return path;
	    };
	
	    _this.addChildPath = function (paths) {
	      var childPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var params = arguments.length > 2 ? arguments[2] : undefined;
	
	      var originalPaths = _toConsumableArray(paths);
	
	      var path = _this.getPath(childPath, params);
	
	      if (path) {
	        originalPaths.push(path);
	      }
	
	      return originalPaths;
	    };
	
	    _this.genForRoutes = function (_ref) {
	      var _ref$routes = _ref.routes,
	          routes = _ref$routes === void 0 ? [] : _ref$routes,
	          _ref$params = _ref.params,
	          params = _ref$params === void 0 ? {} : _ref$params,
	          separator = _ref.separator,
	          _ref$itemRender = _ref.itemRender,
	          itemRender = _ref$itemRender === void 0 ? defaultItemRender : _ref$itemRender;
	      var paths = [];
	      return routes.map(function (route) {
	        var path = _this.getPath(route.path, params);
	
	        if (path) {
	          paths.push(path);
	        } // generated overlay by route.children
	
	
	        var overlay = null;
	
	        if (route.children && route.children.length) {
	          overlay = /*#__PURE__*/React.createElement(_menu["default"], null, route.children.map(function (child) {
	            return (/*#__PURE__*/React.createElement(_menu["default"].Item, {
	                key: child.breadcrumbName || child.path
	              }, itemRender(child, params, routes, _this.addChildPath(paths, child.path, params)))
	            );
	          }));
	        }
	
	        return (/*#__PURE__*/React.createElement(_BreadcrumbItem["default"], {
	            overlay: overlay,
	            separator: separator,
	            key: route.breadcrumbName || path
	          }, itemRender(route, params, routes, paths))
	        );
	      });
	    };
	
	    _this.renderBreadcrumb = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	      var crumbs;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          separator = _a.separator,
	          style = _a.style,
	          className = _a.className,
	          routes = _a.routes,
	          children = _a.children,
	          restProps = __rest(_a, ["prefixCls", "separator", "style", "className", "routes", "children"]);
	
	      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
	
	      if (routes && routes.length > 0) {
	        // generated by route
	        crumbs = _this.genForRoutes(_this.props);
	      } else if (children) {
	        crumbs = React.Children.map(filterFragment(children), function (element, index) {
	          if (!element) {
	            return element;
	          }
	
	          (0, _warning["default"])(element.type && (element.type.__ANT_BREADCRUMB_ITEM === true || element.type.__ANT_BREADCRUMB_SEPARATOR === true), 'Breadcrumb', "Only accepts Breadcrumb.Item and Breadcrumb.Separator as it's children");
	          return (/*#__PURE__*/React.cloneElement(element, {
	              separator: separator,
	              key: index
	            })
	          );
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: (0, _classnames["default"])(className, prefixCls),
	          style: style
	        }, (0, _omit["default"])(restProps, ['itemRender', 'params'])), crumbs)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Breadcrumb, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var props = this.props;
	      (0, _warning["default"])(!('linkRender' in props || 'nameRender' in props), 'Breadcrumb', '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumb)
	      );
	    }
	  }]);
	
	  return Breadcrumb;
	}(React.Component);
	
	exports["default"] = Breadcrumb;
	Breadcrumb.defaultProps = {
	  separator: '/'
	};
	Breadcrumb.propTypes = {
	  prefixCls: PropTypes.string,
	  separator: PropTypes.node,
	  routes: PropTypes.array
	};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _configProvider = __webpack_require__(14);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var BreadcrumbSeparator = /*#__PURE__*/function (_React$Component) {
	  _inherits(BreadcrumbSeparator, _React$Component);
	
	  var _super = _createSuper(BreadcrumbSeparator);
	
	  function BreadcrumbSeparator() {
	    var _this;
	
	    _classCallCheck(this, BreadcrumbSeparator);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSeparator = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var children = _this.props.children;
	      var prefixCls = getPrefixCls('breadcrumb');
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-separator")
	        }, children || '/')
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(BreadcrumbSeparator, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSeparator)
	      );
	    }
	  }]);
	
	  return BreadcrumbSeparator;
	}(React.Component);
	
	exports["default"] = BreadcrumbSeparator;
	BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          size = props.size,
	          className = props.className,
	          others = __rest(props, ["prefixCls", "size", "className"]);
	
	      var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classes
	        }))
	      );
	    })
	  );
	};
	
	var _default = ButtonGroup;
	exports["default"] = _default;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _wave = _interopRequireDefault(__webpack_require__(353));
	
	var _type = __webpack_require__(82);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable react/button-has-type */
	
	var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
	var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
	
	function isString(str) {
	  return typeof str === 'string';
	} // Insert one space between two chinese characters automatically.
	
	
	function insertSpace(child, needInserted) {
	  // Check the child if is undefined or null.
	  if (child == null) {
	    return;
	  }
	
	  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.
	
	  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
	    return (/*#__PURE__*/React.cloneElement(child, {}, child.props.children.split('').join(SPACE))
	    );
	  }
	
	  if (typeof child === 'string') {
	    if (isTwoCNChar(child)) {
	      child = child.split('').join(SPACE);
	    }
	
	    return (/*#__PURE__*/React.createElement("span", null, child)
	    );
	  }
	
	  return child;
	}
	
	function spaceChildren(children, needInserted) {
	  var isPrevChildPure = false;
	  var childList = [];
	  React.Children.forEach(children, function (child) {
	    var type = _typeof(child);
	
	    var isCurrentChildPure = type === 'string' || type === 'number';
	
	    if (isPrevChildPure && isCurrentChildPure) {
	      var lastIndex = childList.length - 1;
	      var lastChild = childList[lastIndex];
	      childList[lastIndex] = "".concat(lastChild).concat(child);
	    } else {
	      childList.push(child);
	    }
	
	    isPrevChildPure = isCurrentChildPure;
	  }); // Pass to React.Children.map to auto fill key
	
	  return React.Children.map(childList, function (child) {
	    return insertSpace(child, needInserted);
	  });
	}
	
	var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
	var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline', 'round');
	var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
	var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');
	
	var Button = /*#__PURE__*/function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  var _super = _createSuper(Button);
	
	  function Button(props) {
	    var _this;
	
	    _classCallCheck(this, Button);
	
	    _this = _super.call(this, props);
	
	    _this.saveButtonRef = function (node) {
	      _this.buttonNode = node;
	    };
	
	    _this.handleClick = function (e) {
	      var loading = _this.state.loading;
	      var onClick = _this.props.onClick;
	
	      if (loading) {
	        return;
	      }
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.renderButton = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          shape = _a.shape,
	          size = _a.size,
	          className = _a.className,
	          children = _a.children,
	          icon = _a.icon,
	          ghost = _a.ghost,
	          block = _a.block,
	          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "block"]);
	
	      var _this$state = _this.state,
	          loading = _this$state.loading,
	          hasTwoCNChar = _this$state.hasTwoCNChar;
	      var prefixCls = getPrefixCls('btn', customizePrefixCls);
	      var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var iconType = loading ? 'loading' : icon;
	      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), !!loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
	      var iconNode = iconType ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType
	      }) : null;
	      var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
	      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType', 'loading']);
	
	      if (linkButtonRestProps.href !== undefined) {
	        return (/*#__PURE__*/React.createElement("a", _extends({}, linkButtonRestProps, {
	            className: classes,
	            onClick: _this.handleClick,
	            ref: _this.saveButtonRef
	          }), iconNode, kids)
	        );
	      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
	
	
	      var _b = rest,
	          htmlType = _b.htmlType,
	          otherProps = __rest(_b, ["htmlType"]);
	
	      var buttonNode = /*#__PURE__*/React.createElement("button", _extends({}, (0, _omit["default"])(otherProps, ['loading']), {
	        type: htmlType,
	        className: classes,
	        onClick: _this.handleClick,
	        ref: _this.saveButtonRef
	      }), iconNode, kids);
	
	      if (type === 'link') {
	        return buttonNode;
	      }
	
	      return (/*#__PURE__*/React.createElement(_wave["default"], null, buttonNode)
	      );
	    };
	
	    _this.state = {
	      loading: props.loading,
	      hasTwoCNChar: false
	    };
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fixTwoCNChar();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      this.fixTwoCNChar();
	
	      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
	        clearTimeout(this.delayTimeout);
	      }
	
	      var loading = this.props.loading;
	
	      if (loading && typeof loading !== 'boolean' && loading.delay) {
	        this.delayTimeout = window.setTimeout(function () {
	          _this2.setState({
	            loading: loading
	          });
	        }, loading.delay);
	      } else if (prevProps.loading !== loading) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          loading: loading
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.delayTimeout) {
	        clearTimeout(this.delayTimeout);
	      }
	    }
	  }, {
	    key: "fixTwoCNChar",
	    value: function fixTwoCNChar() {
	      // Fix for HOC usage like <FormatMessage />
	      if (!this.buttonNode) {
	        return;
	      }
	
	      var buttonText = this.buttonNode.textContent;
	
	      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
	        if (!this.state.hasTwoCNChar) {
	          this.setState({
	            hasTwoCNChar: true
	          });
	        }
	      } else if (this.state.hasTwoCNChar) {
	        this.setState({
	          hasTwoCNChar: false
	        });
	      }
	    }
	  }, {
	    key: "isNeedInserted",
	    value: function isNeedInserted() {
	      var _this$props = this.props,
	          icon = _this$props.icon,
	          children = _this$props.children,
	          type = _this$props.type;
	      return React.Children.count(children) === 1 && !icon && type !== 'link';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton)
	      );
	    }
	  }]);
	
	  return Button;
	}(React.Component);
	
	Button.__ANT_BUTTON = true;
	Button.defaultProps = {
	  loading: false,
	  ghost: false,
	  block: false,
	  htmlType: 'button'
	};
	Button.propTypes = {
	  type: PropTypes.string,
	  shape: PropTypes.oneOf(ButtonShapes),
	  size: PropTypes.oneOf(ButtonSizes),
	  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
	  onClick: PropTypes.func,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  className: PropTypes.string,
	  icon: PropTypes.string,
	  block: PropTypes.bool,
	  title: PropTypes.string
	};
	(0, _reactLifecyclesCompat.polyfill)(Button);
	var _default = Button;
	exports["default"] = _default;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _select = _interopRequireDefault(__webpack_require__(202));
	
	var _radio = __webpack_require__(245);
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Option = _select["default"].Option;
	
	function getMonthsLocale(value) {
	  var current = value.clone();
	  var localeData = value.localeData();
	  var months = [];
	
	  for (var i = 0; i < 12; i++) {
	    current.month(i);
	    months.push(localeData.monthsShort(current));
	  }
	
	  return months;
	}
	
	var Header = /*#__PURE__*/function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  var _super = _createSuper(Header);
	
	  function Header() {
	    var _this;
	
	    _classCallCheck(this, Header);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onYearChange = function (year) {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          validRange = _this$props.validRange;
	      var newValue = value.clone();
	      newValue.year(parseInt(year, 10)); // switch the month so that it remains within range when year changes
	
	      if (validRange) {
	        var _validRange = _slicedToArray(validRange, 2),
	            start = _validRange[0],
	            end = _validRange[1];
	
	        var newYear = newValue.get('year');
	        var newMonth = newValue.get('month');
	
	        if (newYear === end.get('year') && newMonth > end.get('month')) {
	          newValue.month(end.get('month'));
	        }
	
	        if (newYear === start.get('year') && newMonth < start.get('month')) {
	          newValue.month(start.get('month'));
	        }
	      }
	
	      var onValueChange = _this.props.onValueChange;
	
	      if (onValueChange) {
	        onValueChange(newValue);
	      }
	    };
	
	    _this.onMonthChange = function (month) {
	      var newValue = _this.props.value.clone();
	
	      newValue.month(parseInt(month, 10));
	      var onValueChange = _this.props.onValueChange;
	
	      if (onValueChange) {
	        onValueChange(newValue);
	      }
	    };
	
	    _this.onInternalTypeChange = function (e) {
	      _this.onTypeChange(e.target.value);
	    };
	
	    _this.onTypeChange = function (type) {
	      var onTypeChange = _this.props.onTypeChange;
	
	      if (onTypeChange) {
	        onTypeChange(type);
	      }
	    };
	
	    _this.getCalenderHeaderNode = function (node) {
	      _this.calenderHeaderNode = node;
	    };
	
	    _this.getMonthYearSelections = function (getPrefixCls) {
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          type = _this$props2.type,
	          value = _this$props2.value;
	      var prefixCls = getPrefixCls('fullcalendar', customizePrefixCls);
	
	      var yearReactNode = _this.getYearSelectElement(prefixCls, value.year());
	
	      var monthReactNode = type === 'month' ? _this.getMonthSelectElement(prefixCls, value.month(), getMonthsLocale(value)) : null;
	      return {
	        yearReactNode: yearReactNode,
	        monthReactNode: monthReactNode
	      };
	    };
	
	    _this.getTypeSwitch = function () {
	      var _this$props3 = _this.props,
	          _this$props3$locale = _this$props3.locale,
	          locale = _this$props3$locale === void 0 ? {} : _this$props3$locale,
	          type = _this$props3.type,
	          fullscreen = _this$props3.fullscreen;
	      var size = fullscreen ? 'default' : 'small';
	      return (/*#__PURE__*/React.createElement(_radio.Group, {
	          onChange: _this.onInternalTypeChange,
	          value: type,
	          size: size
	        }, /*#__PURE__*/React.createElement(_radio.Button, {
	          value: "month"
	        }, locale.month), /*#__PURE__*/React.createElement(_radio.Button, {
	          value: "year"
	        }, locale.year))
	      );
	    };
	
	    _this.headerRenderCustom = function (headerRender) {
	      var _this$props4 = _this.props,
	          type = _this$props4.type,
	          onValueChange = _this$props4.onValueChange,
	          value = _this$props4.value;
	      return headerRender({
	        value: value,
	        type: type || 'month',
	        onChange: onValueChange,
	        onTypeChange: _this.onTypeChange
	      });
	    };
	
	    _this.renderHeader = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props5 = _this.props,
	          prefixCls = _this$props5.prefixCls,
	          headerRender = _this$props5.headerRender;
	
	      var typeSwitch = _this.getTypeSwitch();
	
	      var _this$getMonthYearSel = _this.getMonthYearSelections(getPrefixCls),
	          yearReactNode = _this$getMonthYearSel.yearReactNode,
	          monthReactNode = _this$getMonthYearSel.monthReactNode;
	
	      return headerRender ? _this.headerRenderCustom(headerRender) : /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-header"),
	        ref: _this.getCalenderHeaderNode
	      }, yearReactNode, monthReactNode, typeSwitch);
	    };
	
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "getYearSelectElement",
	    value: function getYearSelectElement(prefixCls, year) {
	      var _this2 = this;
	
	      var _this$props6 = this.props,
	          yearSelectOffset = _this$props6.yearSelectOffset,
	          yearSelectTotal = _this$props6.yearSelectTotal,
	          _this$props6$locale = _this$props6.locale,
	          locale = _this$props6$locale === void 0 ? {} : _this$props6$locale,
	          fullscreen = _this$props6.fullscreen,
	          validRange = _this$props6.validRange;
	      var start = year - yearSelectOffset;
	      var end = start + yearSelectTotal;
	
	      if (validRange) {
	        start = validRange[0].get('year');
	        end = validRange[1].get('year') + 1;
	      }
	
	      var suffix = locale.year === '年' ? '年' : '';
	      var options = [];
	
	      for (var index = start; index < end; index++) {
	        options.push( /*#__PURE__*/React.createElement(Option, {
	          key: "".concat(index)
	        }, index + suffix));
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], {
	          size: fullscreen ? 'default' : 'small',
	          dropdownMatchSelectWidth: false,
	          className: "".concat(prefixCls, "-year-select"),
	          onChange: this.onYearChange,
	          value: String(year),
	          getPopupContainer: function getPopupContainer() {
	            return _this2.calenderHeaderNode;
	          }
	        }, options)
	      );
	    }
	  }, {
	    key: "getMonthSelectElement",
	    value: function getMonthSelectElement(prefixCls, month, months) {
	      var _this3 = this;
	
	      var _this$props7 = this.props,
	          fullscreen = _this$props7.fullscreen,
	          validRange = _this$props7.validRange,
	          value = _this$props7.value;
	      var options = [];
	      var start = 0;
	      var end = 12;
	
	      if (validRange) {
	        var _validRange2 = _slicedToArray(validRange, 2),
	            rangeStart = _validRange2[0],
	            rangeEnd = _validRange2[1];
	
	        var currentYear = value.get('year');
	
	        if (rangeEnd.get('year') === currentYear) {
	          end = rangeEnd.get('month') + 1;
	        }
	
	        if (rangeStart.get('year') === currentYear) {
	          start = rangeStart.get('month');
	        }
	      }
	
	      for (var index = start; index < end; index++) {
	        options.push( /*#__PURE__*/React.createElement(Option, {
	          key: "".concat(index)
	        }, months[index]));
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], {
	          size: fullscreen ? 'default' : 'small',
	          dropdownMatchSelectWidth: false,
	          className: "".concat(prefixCls, "-month-select"),
	          value: String(month),
	          onChange: this.onMonthChange,
	          getPopupContainer: function getPopupContainer() {
	            return _this3.calenderHeaderNode;
	          }
	        }, options)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderHeader)
	      );
	    }
	  }]);
	
	  return Header;
	}(React.Component);
	
	exports["default"] = Header;
	Header.defaultProps = {
	  yearSelectOffset: 10,
	  yearSelectTotal: 20
	};

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _FullCalendar = _interopRequireDefault(__webpack_require__(460));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _Header = _interopRequireDefault(__webpack_require__(1180));
	
	var _en_US = _interopRequireDefault(__webpack_require__(638));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _configProvider = __webpack_require__(14);
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function noop() {
	  return null;
	}
	
	function zerofixed(v) {
	  if (v < 10) {
	    return "0".concat(v);
	  }
	
	  return "".concat(v);
	}
	
	var Calendar = /*#__PURE__*/function (_React$Component) {
	  _inherits(Calendar, _React$Component);
	
	  var _super = _createSuper(Calendar);
	
	  function Calendar(props) {
	    var _this;
	
	    _classCallCheck(this, Calendar);
	
	    _this = _super.call(this, props);
	
	    _this.onHeaderValueChange = function (value) {
	      _this.setValue(value, 'changePanel');
	    };
	
	    _this.onHeaderTypeChange = function (mode) {
	      _this.setState({
	        mode: mode
	      });
	
	      _this.onPanelChange(_this.state.value, mode);
	    };
	
	    _this.onSelect = function (value) {
	      _this.setValue(value, 'select');
	    };
	
	    _this.setValue = function (value, way) {
	      var prevValue = _this.props.value || _this.state.value;
	      var mode = _this.state.mode;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      if (way === 'select') {
	        if (prevValue && prevValue.month() !== value.month()) {
	          _this.onPanelChange(value, mode);
	        }
	
	        if (_this.props.onSelect) {
	          _this.props.onSelect(value);
	        }
	      } else if (way === 'changePanel') {
	        _this.onPanelChange(value, mode);
	      }
	    };
	
	    _this.getDateRange = function (validRange, disabledDate) {
	      return function (current) {
	        if (!current) {
	          return false;
	        }
	
	        var _validRange = _slicedToArray(validRange, 2),
	            startDate = _validRange[0],
	            endDate = _validRange[1];
	
	        var inRange = !current.isBetween(startDate, endDate, 'days', '[]');
	
	        if (disabledDate) {
	          return disabledDate(current) || inRange;
	        }
	
	        return inRange;
	      };
	    };
	
	    _this.getDefaultLocale = function () {
	      var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	      result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
	      return result;
	    };
	
	    _this.monthCellRender = function (value) {
	      var _this$props$monthCell = _this.props.monthCellRender,
	          monthCellRender = _this$props$monthCell === void 0 ? noop : _this$props$monthCell;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-month")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-value")
	        }, value.localeData().monthsShort(value)), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, monthCellRender(value)))
	      );
	    };
	
	    _this.dateCellRender = function (value) {
	      var _this$props$dateCellR = _this.props.dateCellRender,
	          dateCellRender = _this$props$dateCellR === void 0 ? noop : _this$props$dateCellR;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize2.prefixCls;
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-date")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-value")
	        }, zerofixed(value.date())), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, dateCellRender(value)))
	      );
	    };
	
	    _this.renderCalendar = function (locale, localeCode) {
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          state = _assertThisInitialize3.state,
	          props = _assertThisInitialize3.props;
	
	      var value = state.value,
	          mode = state.mode;
	
	      if (value && localeCode) {
	        value.locale(localeCode);
	      }
	
	      var customizePrefixCls = props.prefixCls,
	          style = props.style,
	          className = props.className,
	          fullscreen = props.fullscreen,
	          headerRender = props.headerRender,
	          dateFullCellRender = props.dateFullCellRender,
	          monthFullCellRender = props.monthFullCellRender;
	      var monthCellRender = monthFullCellRender || _this.monthCellRender;
	      var dateCellRender = dateFullCellRender || _this.dateCellRender;
	      var disabledDate = props.disabledDate;
	
	      if (props.validRange) {
	        disabledDate = _this.getDateRange(props.validRange, disabledDate);
	      }
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	          var getPrefixCls = _ref.getPrefixCls;
	          var prefixCls = getPrefixCls('fullcalendar', customizePrefixCls); // To support old version react.
	          // Have to add prefixCls on the instance.
	          // https://github.com/facebook/react/issues/12397
	
	          _this.prefixCls = prefixCls;
	          var cls = className || '';
	
	          if (fullscreen) {
	            cls += " ".concat(prefixCls, "-fullscreen");
	          }
	
	          return (/*#__PURE__*/React.createElement("div", {
	              className: cls,
	              style: style
	            }, /*#__PURE__*/React.createElement(_Header["default"], {
	              fullscreen: fullscreen,
	              type: mode,
	              headerRender: headerRender,
	              value: value,
	              locale: locale.lang,
	              prefixCls: prefixCls,
	              onTypeChange: _this.onHeaderTypeChange,
	              onValueChange: _this.onHeaderValueChange,
	              validRange: props.validRange
	            }), /*#__PURE__*/React.createElement(_FullCalendar["default"], _extends({}, props, {
	              disabledDate: disabledDate,
	              Select: noop,
	              locale: locale.lang,
	              type: mode === 'year' ? 'month' : 'date',
	              prefixCls: prefixCls,
	              showHeader: false,
	              value: value,
	              monthCellRender: monthCellRender,
	              dateCellRender: dateCellRender,
	              onSelect: _this.onSelect
	            })))
	          );
	        })
	      );
	    };
	
	    var value = props.value || props.defaultValue || (0, _interopDefault["default"])(moment)();
	
	    if (!(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of Calendar must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/calendar-value');
	    }
	
	    _this.state = {
	      value: value,
	      mode: props.mode || 'month'
	    };
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: "onPanelChange",
	    value: function onPanelChange(value, mode) {
	      var _this$props = this.props,
	          onPanelChange = _this$props.onPanelChange,
	          onChange = _this$props.onChange;
	
	      if (onPanelChange) {
	        onPanelChange(value, mode);
	      }
	
	      if (onChange && value !== this.state.value) {
	        onChange(value);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Calendar",
	          defaultLocale: this.getDefaultLocale
	        }, this.renderCalendar)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	
	      if ('value' in nextProps) {
	        newState.value = nextProps.value;
	      }
	
	      if ('mode' in nextProps) {
	        newState.mode = nextProps.mode;
	      }
	
	      return Object.keys(newState).length > 0 ? newState : null;
	    }
	  }]);
	
	  return Calendar;
	}(React.Component);
	
	Calendar.defaultProps = {
	  locale: {},
	  fullscreen: true,
	  onSelect: noop,
	  onPanelChange: noop,
	  onChange: noop
	};
	Calendar.propTypes = {
	  monthCellRender: PropTypes.func,
	  dateCellRender: PropTypes.func,
	  monthFullCellRender: PropTypes.func,
	  dateFullCellRender: PropTypes.func,
	  fullscreen: PropTypes.bool,
	  locale: PropTypes.object,
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  style: PropTypes.object,
	  onPanelChange: PropTypes.func,
	  value: PropTypes.object,
	  onSelect: PropTypes.func,
	  onChange: PropTypes.func,
	  headerRender: PropTypes.func
	};
	(0, _reactLifecyclesCompat.polyfill)(Calendar);
	var _default = Calendar;
	exports["default"] = _default;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Grid = function Grid(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          _props$hoverable = props.hoverable,
	          hoverable = _props$hoverable === void 0 ? true : _props$hoverable,
	          others = __rest(props, ["prefixCls", "className", "hoverable"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-grid"), className, _defineProperty({}, "".concat(prefixCls, "-grid-hoverable"), hoverable));
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }))
	      );
	    })
	  );
	};
	
	var _default = Grid;
	exports["default"] = _default;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Meta = function Meta(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          avatar = props.avatar,
	          title = props.title,
	          description = props.description,
	          others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-meta"), className);
	      var avatarDom = avatar ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-avatar")
	      }, avatar) : null;
	      var titleDom = title ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-title")
	      }, title) : null;
	      var descriptionDom = description ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-description")
	      }, description) : null;
	      var MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-detail")
	      }, titleDom, descriptionDom) : null;
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }), avatarDom, MetaDetail)
	      );
	    })
	  );
	};
	
	var _default = Meta;
	exports["default"] = _default;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Grid = _interopRequireDefault(__webpack_require__(1182));
	
	var _Meta = _interopRequireDefault(__webpack_require__(1183));
	
	var _tabs = _interopRequireDefault(__webpack_require__(658));
	
	var _row = _interopRequireDefault(__webpack_require__(655));
	
	var _col = _interopRequireDefault(__webpack_require__(640));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getAction(actions) {
	  var actionList = actions.map(function (action, index) {
	    return (
	      /*#__PURE__*/
	      // eslint-disable-next-line react/no-array-index-key
	      React.createElement("li", {
	        style: {
	          width: "".concat(100 / actions.length, "%")
	        },
	        key: "action-".concat(index)
	      }, /*#__PURE__*/React.createElement("span", null, action))
	    );
	  });
	  return actionList;
	}
	
	var Card = /*#__PURE__*/function (_React$Component) {
	  _inherits(Card, _React$Component);
	
	  var _super = _createSuper(Card);
	
	  function Card() {
	    var _this;
	
	    _classCallCheck(this, Card);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onTabChange = function (key) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(key);
	      }
	    };
	
	    _this.renderCard = function (_ref) {
	      var _classNames, _extraProps;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          extra = _a.extra,
	          _a$headStyle = _a.headStyle,
	          headStyle = _a$headStyle === void 0 ? {} : _a$headStyle,
	          _a$bodyStyle = _a.bodyStyle,
	          bodyStyle = _a$bodyStyle === void 0 ? {} : _a$bodyStyle,
	          title = _a.title,
	          loading = _a.loading,
	          _a$bordered = _a.bordered,
	          bordered = _a$bordered === void 0 ? true : _a$bordered,
	          _a$size = _a.size,
	          size = _a$size === void 0 ? 'default' : _a$size,
	          type = _a.type,
	          cover = _a.cover,
	          actions = _a.actions,
	          tabList = _a.tabList,
	          children = _a.children,
	          activeTabKey = _a.activeTabKey,
	          defaultActiveTabKey = _a.defaultActiveTabKey,
	          tabBarExtraContent = _a.tabBarExtraContent,
	          others = __rest(_a, ["prefixCls", "className", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-hoverable"), _this.getCompatibleHoverable()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-grid"), _this.isContainGrid()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-type-").concat(type), !!type), _classNames));
	      var loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? {
	        padding: 24
	      } : undefined;
	      var loadingBlock = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-content"),
	        style: loadingBlockStyle
	      }, /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 22
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 8
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 15
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 6
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 18
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 13
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 9
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 4
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 3
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 16
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))));
	      var hasActiveTabKey = activeTabKey !== undefined;
	      var extraProps = (_extraProps = {}, _defineProperty(_extraProps, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey), _defineProperty(_extraProps, "tabBarExtraContent", tabBarExtraContent), _extraProps);
	      var head;
	      var tabs = tabList && tabList.length ? /*#__PURE__*/React.createElement(_tabs["default"], _extends({}, extraProps, {
	        className: "".concat(prefixCls, "-head-tabs"),
	        size: "large",
	        onChange: _this.onTabChange
	      }), tabList.map(function (item) {
	        return (/*#__PURE__*/React.createElement(_tabs["default"].TabPane, {
	            tab: item.tab,
	            disabled: item.disabled,
	            key: item.key
	          })
	        );
	      })) : null;
	
	      if (title || extra || tabs) {
	        head = /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head"),
	          style: headStyle
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head-wrapper")
	        }, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head-title")
	        }, title), extra && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-extra")
	        }, extra)), tabs);
	      }
	
	      var coverDom = cover ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-cover")
	      }, cover) : null;
	      var body = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body"),
	        style: bodyStyle
	      }, loading ? loadingBlock : children);
	      var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-actions")
	      }, getAction(actions)) : null;
	      var divProps = (0, _omit["default"])(others, ['onTabChange', 'noHovering', 'hoverable']);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	          className: classString
	        }), head, coverDom, body, actionDom)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if ('noHovering' in this.props) {
	        (0, _warning["default"])(!this.props.noHovering, 'Card', '`noHovering` is deprecated, you can remove it safely or use `hoverable` instead.');
	        (0, _warning["default"])(!!this.props.noHovering, 'Card', '`noHovering={false}` is deprecated, use `hoverable` instead.');
	      }
	    } // For 2.x compatible
	
	  }, {
	    key: "getCompatibleHoverable",
	    value: function getCompatibleHoverable() {
	      var _this$props = this.props,
	          noHovering = _this$props.noHovering,
	          hoverable = _this$props.hoverable;
	
	      if ('noHovering' in this.props) {
	        return !noHovering || hoverable;
	      }
	
	      return !!hoverable;
	    }
	  }, {
	    key: "isContainGrid",
	    value: function isContainGrid() {
	      var containGrid;
	      React.Children.forEach(this.props.children, function (element) {
	        if (element && element.type && element.type === _Grid["default"]) {
	          containGrid = true;
	        }
	      });
	      return containGrid;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCard)
	      );
	    }
	  }]);
	
	  return Card;
	}(React.Component);
	
	exports["default"] = Card;
	Card.Grid = _Grid["default"];
	Card.Meta = _Meta["default"];

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	} // Use require over import (will be lifted up)
	// make sure matchMedia polyfill run before require('react-slick')
	// Fix https://github.com/ant-design/ant-design/issues/6560
	// Fix https://github.com/ant-design/ant-design/issues/3308
	
	
	var SlickCarousel = __webpack_require__(487)["default"];
	
	var Carousel = /*#__PURE__*/function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  var _super = _createSuper(Carousel);
	
	  function Carousel(props) {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _super.call(this, props);
	
	    _this.saveSlick = function (node) {
	      _this.slick = node;
	    };
	
	    _this.onWindowResized = function () {
	      // Fix https://github.com/ant-design/ant-design/issues/2550
	      var autoplay = _this.props.autoplay;
	
	      if (autoplay && _this.slick && _this.slick.innerSlider && _this.slick.innerSlider.autoPlay) {
	        _this.slick.innerSlider.autoPlay();
	      }
	    };
	
	    _this.renderCarousel = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var props = _extends({}, _this.props);
	
	      if (props.effect === 'fade') {
	        props.fade = true;
	      }
	
	      var className = getPrefixCls('carousel', props.prefixCls);
	      var dotsClass = 'slick-dots';
	
	      var dotPosition = _this.getDotPosition();
	
	      props.vertical = dotPosition === 'left' || dotPosition === 'right';
	      props.dotsClass = "".concat(dotsClass, " ").concat(dotsClass, "-").concat(dotPosition || 'bottom');
	
	      if (props.vertical) {
	        className = "".concat(className, " ").concat(className, "-vertical");
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className
	        }, /*#__PURE__*/React.createElement(SlickCarousel, _extends({
	          ref: _this.saveSlick
	        }, props)))
	      );
	    };
	
	    _this.onWindowResized = (0, _debounce["default"])(_this.onWindowResized, 500, {
	      leading: false
	    });
	
	    if ('vertical' in _this.props) {
	      (0, _warning["default"])(!_this.props.vertical, 'Carousel', '`vertical` is deprecated, please use `dotPosition` instead.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var autoplay = this.props.autoplay;
	
	      if (autoplay) {
	        window.addEventListener('resize', this.onWindowResized);
	      } // https://github.com/ant-design/ant-design/issues/7191
	
	
	      this.innerSlider = this.slick && this.slick.innerSlider;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (React.Children.count(this.props.children) !== React.Children.count(prevProps.children)) {
	        this.goTo(this.props.initialSlide || 0, false);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var autoplay = this.props.autoplay;
	
	      if (autoplay) {
	        window.removeEventListener('resize', this.onWindowResized);
	        this.onWindowResized.cancel();
	      }
	    }
	  }, {
	    key: "getDotPosition",
	    value: function getDotPosition() {
	      if (this.props.dotPosition) {
	        return this.props.dotPosition;
	      }
	
	      if ('vertical' in this.props) {
	        return this.props.vertical ? 'right' : 'bottom';
	      }
	
	      return 'bottom';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      this.slick.slickNext();
	    }
	  }, {
	    key: "prev",
	    value: function prev() {
	      this.slick.slickPrev();
	    }
	  }, {
	    key: "goTo",
	    value: function goTo(slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      this.slick.slickGoTo(slide, dontAnimate);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCarousel)
	      );
	    }
	  }]);
	
	  return Carousel;
	}(React.Component);
	
	exports["default"] = Carousel;
	Carousel.defaultProps = {
	  dots: true,
	  arrows: false,
	  draggable: false
	};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcCascader = _interopRequireDefault(__webpack_require__(462));
	
	var _arrayTreeFilter = _interopRequireDefault(__webpack_require__(488));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _input = _interopRequireDefault(__webpack_require__(244));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// We limit the filtered item count by default
	var defaultLimit = 50;
	
	function highlightKeyword(str, keyword, prefixCls) {
	  return str.split(keyword).map(function (node, index) {
	    return index === 0 ? node : [/*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-menu-item-keyword"),
	      key: "seperator"
	    }, keyword), node];
	  });
	}
	
	function defaultFilterOption(inputValue, path, names) {
	  return path.some(function (option) {
	    return option[names.label].indexOf(inputValue) > -1;
	  });
	}
	
	function defaultRenderFilteredOption(inputValue, path, prefixCls, names) {
	  return path.map(function (option, index) {
	    var label = option[names.label];
	    var node = label.indexOf(inputValue) > -1 ? highlightKeyword(label, inputValue, prefixCls) : label;
	    return index === 0 ? node : [' / ', node];
	  });
	}
	
	function defaultSortFilteredOption(a, b, inputValue, names) {
	  function callback(elem) {
	    return elem[names.label].indexOf(inputValue) > -1;
	  }
	
	  return a.findIndex(callback) - b.findIndex(callback);
	}
	
	function getFieldNames(props) {
	  var fieldNames = props.fieldNames,
	      filedNames = props.filedNames;
	
	  if ('filedNames' in props) {
	    return filedNames; // For old compatibility
	  }
	
	  return fieldNames;
	}
	
	function getFilledFieldNames(props) {
	  var fieldNames = getFieldNames(props) || {};
	  var names = {
	    children: fieldNames.children || 'children',
	    label: fieldNames.label || 'label',
	    value: fieldNames.value || 'value'
	  };
	  return names;
	}
	
	function flattenTree(options, props) {
	  var ancestor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var names = getFilledFieldNames(props);
	  var flattenOptions = [];
	  var childrenName = names.children;
	  options.forEach(function (option) {
	    var path = ancestor.concat(option);
	
	    if (props.changeOnSelect || !option[childrenName] || !option[childrenName].length) {
	      flattenOptions.push(path);
	    }
	
	    if (option[childrenName]) {
	      flattenOptions = flattenOptions.concat(flattenTree(option[childrenName], props, path));
	    }
	  });
	  return flattenOptions;
	}
	
	var defaultDisplayRender = function defaultDisplayRender(label) {
	  return label.join(' / ');
	};
	
	function warningValueNotExist(list) {
	  var fieldNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (list || []).forEach(function (item) {
	    var valueFieldName = fieldNames.value || 'value';
	    (0, _warning["default"])(valueFieldName in item, 'Cascader', 'Not found `value` in `options`.');
	    warningValueNotExist(item[fieldNames.children || 'children'], fieldNames);
	  });
	}
	
	var Cascader = /*#__PURE__*/function (_React$Component) {
	  _inherits(Cascader, _React$Component);
	
	  var _super = _createSuper(Cascader);
	
	  function Cascader(props) {
	    var _this;
	
	    _classCallCheck(this, Cascader);
	
	    _this = _super.call(this, props);
	    _this.cachedOptions = [];
	
	    _this.setValue = function (value) {
	      var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(value, selectedOptions);
	      }
	    };
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.handleChange = function (value, selectedOptions) {
	      _this.setState({
	        inputValue: ''
	      });
	
	      if (selectedOptions[0].__IS_FILTERED_OPTION) {
	        var unwrappedValue = value[0];
	        var unwrappedSelectedOptions = selectedOptions[0].path;
	
	        _this.setValue(unwrappedValue, unwrappedSelectedOptions);
	
	        return;
	      }
	
	      _this.setValue(value, selectedOptions);
	    };
	
	    _this.handlePopupVisibleChange = function (popupVisible) {
	      if (!('popupVisible' in _this.props)) {
	        _this.setState(function (state) {
	          return {
	            popupVisible: popupVisible,
	            inputFocused: popupVisible,
	            inputValue: popupVisible ? state.inputValue : ''
	          };
	        });
	      }
	
	      var onPopupVisibleChange = _this.props.onPopupVisibleChange;
	
	      if (onPopupVisibleChange) {
	        onPopupVisibleChange(popupVisible);
	      }
	    };
	
	    _this.handleInputBlur = function () {
	      _this.setState({
	        inputFocused: false
	      });
	    };
	
	    _this.handleInputClick = function (e) {
	      var _this$state = _this.state,
	          inputFocused = _this$state.inputFocused,
	          popupVisible = _this$state.popupVisible; // Prevent `Trigger` behaviour.
	
	      if (inputFocused || popupVisible) {
	        e.stopPropagation();
	
	        if (e.nativeEvent.stopImmediatePropagation) {
	          e.nativeEvent.stopImmediatePropagation();
	        }
	      }
	    };
	
	    _this.handleKeyDown = function (e) {
	      // SPACE => https://github.com/ant-design/ant-design/issues/16871
	      if (e.keyCode === _KeyCode["default"].BACKSPACE || e.keyCode === _KeyCode["default"].SPACE) {
	        e.stopPropagation();
	      }
	    };
	
	    _this.handleInputChange = function (e) {
	      var inputValue = e.target.value;
	
	      _this.setState({
	        inputValue: inputValue
	      });
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (!_this.state.inputValue) {
	        _this.setValue([]);
	
	        _this.handlePopupVisibleChange(false);
	      } else {
	        _this.setState({
	          inputValue: ''
	        });
	      }
	    };
	
	    _this.renderCascader = function (_ref, locale) {
	      var _classNames, _classNames2, _classNames3, _classNames4;
	
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          customizeInputPrefixCls = props.inputPrefixCls,
	          children = props.children,
	          _props$placeholder = props.placeholder,
	          placeholder = _props$placeholder === void 0 ? locale.placeholder || 'Please select' : _props$placeholder,
	          size = props.size,
	          disabled = props.disabled,
	          className = props.className,
	          style = props.style,
	          allowClear = props.allowClear,
	          _props$showSearch = props.showSearch,
	          showSearch = _props$showSearch === void 0 ? false : _props$showSearch,
	          suffixIcon = props.suffixIcon,
	          notFoundContent = props.notFoundContent,
	          otherProps = __rest(props, ["prefixCls", "inputPrefixCls", "children", "placeholder", "size", "disabled", "className", "style", "allowClear", "showSearch", "suffixIcon", "notFoundContent"]);
	
	      var value = state.value,
	          inputFocused = state.inputFocused;
	      var prefixCls = getPrefixCls('cascader', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-sm"), size === 'small'), _classNames));
	      var clearIcon = allowClear && !disabled && value.length > 0 || state.inputValue ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection
	      }) : null;
	      var arrowCls = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-picker-arrow"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-arrow-expand"), state.popupVisible), _classNames2));
	      var pickerCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-picker"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-picker-with-value"), state.inputValue), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-disabled"), disabled), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-").concat(size), !!size), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-show-search"), !!showSearch), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-focused"), inputFocused), _classNames3)); // Fix bug of https://github.com/facebook/react/pull/5004
	      // and https://fb.me/react-unknown-prop
	
	      var inputProps = (0, _omit["default"])(otherProps, ['onChange', 'options', 'popupPlacement', 'transitionName', 'displayRender', 'onPopupVisibleChange', 'changeOnSelect', 'expandTrigger', 'popupVisible', 'getPopupContainer', 'loadData', 'popupClassName', 'filterOption', 'renderFilteredOption', 'sortFilteredOption', 'notFoundContent', 'fieldNames', 'filedNames']);
	      var options = props.options;
	      var names = getFilledFieldNames(_this.props);
	
	      if (options && options.length > 0) {
	        if (state.inputValue) {
	          options = _this.generateFilteredOptions(prefixCls, renderEmpty);
	        }
	      } else {
	        var _ref2;
	
	        options = [(_ref2 = {}, _defineProperty(_ref2, names.value, 'ANT_CASCADER_NOT_FOUND'), _defineProperty(_ref2, names.label, notFoundContent || renderEmpty('Cascader')), _defineProperty(_ref2, "disabled", true), _defineProperty(_ref2, "isEmptyNode", true), _ref2)];
	      } // Dropdown menu should keep previous status until it is fully closed.
	
	
	      if (!state.popupVisible) {
	        options = _this.cachedOptions;
	      } else {
	        _this.cachedOptions = options;
	      }
	
	      var dropdownMenuColumnStyle = {};
	      var isNotFound = (options || []).length === 1 && options[0].isEmptyNode;
	
	      if (isNotFound) {
	        dropdownMenuColumnStyle.height = 'auto'; // Height of one row.
	      } // The default value of `matchInputWidth` is `true`
	
	
	      var resultListMatchInputWidth = showSearch.matchInputWidth !== false;
	
	      if (resultListMatchInputWidth && (state.inputValue || isNotFound) && _this.input) {
	        dropdownMenuColumnStyle.width = _this.input.input.offsetWidth;
	      }
	
	      var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	        className: (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames4, "".concat(prefixCls, "-picker-arrow"), true), _classNames4))
	      }) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-picker-arrow")
	      }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: arrowCls
	      });
	      var input = children || /*#__PURE__*/React.createElement("span", {
	        style: style,
	        className: pickerCls
	      }, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-picker-label")
	      }, _this.getLabel()), /*#__PURE__*/React.createElement(_input["default"], _extends({}, inputProps, {
	        tabIndex: "-1",
	        ref: _this.saveInput,
	        prefixCls: inputPrefixCls,
	        placeholder: value && value.length > 0 ? undefined : placeholder,
	        className: "".concat(prefixCls, "-input ").concat(sizeCls),
	        value: state.inputValue,
	        disabled: disabled,
	        readOnly: !showSearch,
	        autoComplete: inputProps.autoComplete || 'off',
	        onClick: showSearch ? _this.handleInputClick : undefined,
	        onBlur: showSearch ? _this.handleInputBlur : undefined,
	        onKeyDown: _this.handleKeyDown,
	        onChange: showSearch ? _this.handleInputChange : undefined
	      })), clearIcon, inputIcon);
	      var expandIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right"
	      });
	      var loadingIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-item-loading-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "redo",
	        spin: true
	      }));
	      var getPopupContainer = props.getPopupContainer || getContextPopupContainer;
	      var rest = (0, _omit["default"])(props, ['inputIcon', 'expandIcon', 'loadingIcon']);
	      return (/*#__PURE__*/React.createElement(_rcCascader["default"], _extends({}, rest, {
	          prefixCls: prefixCls,
	          getPopupContainer: getPopupContainer,
	          options: options,
	          value: value,
	          popupVisible: state.popupVisible,
	          onPopupVisibleChange: _this.handlePopupVisibleChange,
	          onChange: _this.handleChange,
	          dropdownMenuColumnStyle: dropdownMenuColumnStyle,
	          expandIcon: expandIcon,
	          loadingIcon: loadingIcon
	        }), input)
	      );
	    };
	
	    _this.state = {
	      value: props.value || props.defaultValue || [],
	      inputValue: '',
	      inputFocused: false,
	      popupVisible: props.popupVisible,
	      flattenOptions: props.showSearch ? flattenTree(props.options, props) : undefined,
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(Cascader, [{
	    key: "getLabel",
	    value: function getLabel() {
	      var _this$props = this.props,
	          options = _this$props.options,
	          _this$props$displayRe = _this$props.displayRender,
	          displayRender = _this$props$displayRe === void 0 ? defaultDisplayRender : _this$props$displayRe;
	      var names = getFilledFieldNames(this.props);
	      var value = this.state.value;
	      var unwrappedValue = Array.isArray(value[0]) ? value[0] : value;
	      var selectedOptions = (0, _arrayTreeFilter["default"])(options, function (o, level) {
	        return o[names.value] === unwrappedValue[level];
	      }, {
	        childrenKeyName: names.children
	      });
	      var label = selectedOptions.map(function (o) {
	        return o[names.label];
	      });
	      return displayRender(label, selectedOptions);
	    }
	  }, {
	    key: "generateFilteredOptions",
	    value: function generateFilteredOptions(prefixCls, renderEmpty) {
	      var _this2 = this,
	          _ref4;
	
	      var _this$props2 = this.props,
	          showSearch = _this$props2.showSearch,
	          notFoundContent = _this$props2.notFoundContent;
	      var names = getFilledFieldNames(this.props);
	      var _showSearch$filter = showSearch.filter,
	          filter = _showSearch$filter === void 0 ? defaultFilterOption : _showSearch$filter,
	          _showSearch$render = showSearch.render,
	          render = _showSearch$render === void 0 ? defaultRenderFilteredOption : _showSearch$render,
	          _showSearch$sort = showSearch.sort,
	          sort = _showSearch$sort === void 0 ? defaultSortFilteredOption : _showSearch$sort,
	          _showSearch$limit = showSearch.limit,
	          limit = _showSearch$limit === void 0 ? defaultLimit : _showSearch$limit;
	      var _this$state2 = this.state,
	          _this$state2$flattenO = _this$state2.flattenOptions,
	          flattenOptions = _this$state2$flattenO === void 0 ? [] : _this$state2$flattenO,
	          inputValue = _this$state2.inputValue; // Limit the filter if needed
	
	      var filtered;
	
	      if (limit > 0) {
	        filtered = [];
	        var matchCount = 0; // Perf optimization to filter items only below the limit
	
	        flattenOptions.some(function (path) {
	          var match = filter(_this2.state.inputValue, path, names);
	
	          if (match) {
	            filtered.push(path);
	            matchCount += 1;
	          }
	
	          return matchCount >= limit;
	        });
	      } else {
	        (0, _warning["default"])(typeof limit !== 'number', 'Cascader', "'limit' of showSearch should be positive number or false.");
	        filtered = flattenOptions.filter(function (path) {
	          return filter(_this2.state.inputValue, path, names);
	        });
	      }
	
	      filtered.sort(function (a, b) {
	        return sort(a, b, inputValue, names);
	      });
	
	      if (filtered.length > 0) {
	        return filtered.map(function (path) {
	          var _ref3;
	
	          return _ref3 = {
	            __IS_FILTERED_OPTION: true,
	            path: path
	          }, _defineProperty(_ref3, names.value, path.map(function (o) {
	            return o[names.value];
	          })), _defineProperty(_ref3, names.label, render(inputValue, path, prefixCls, names)), _defineProperty(_ref3, "disabled", path.some(function (o) {
	            return !!o.disabled;
	          })), _defineProperty(_ref3, "isEmptyNode", true), _ref3;
	        });
	      }
	
	      return [(_ref4 = {}, _defineProperty(_ref4, names.value, 'ANT_CASCADER_NOT_FOUND'), _defineProperty(_ref4, names.label, notFoundContent || renderEmpty('Cascader')), _defineProperty(_ref4, "disabled", true), _defineProperty(_ref4, "isEmptyNode", true), _ref4)];
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (configArgument) {
	          return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (locale) {
	              return _this3.renderCascader(configArgument, locale);
	            })
	          );
	        })
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, _ref5) {
	      var prevProps = _ref5.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if ('value' in nextProps) {
	        newState.value = nextProps.value || [];
	      }
	
	      if ('popupVisible' in nextProps) {
	        newState.popupVisible = nextProps.popupVisible;
	      }
	
	      if (nextProps.showSearch && prevProps.options !== nextProps.options) {
	        newState.flattenOptions = flattenTree(nextProps.options, nextProps);
	      }
	
	      if (false) {
	        warningValueNotExist(nextProps.options, getFieldNames(nextProps));
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Cascader;
	}(React.Component);
	
	Cascader.defaultProps = {
	  transitionName: 'slide-up',
	  popupPlacement: 'bottomLeft',
	  options: [],
	  disabled: false,
	  allowClear: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Cascader);
	var _default = Cascader;
	exports["default"] = _default;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(639));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(CheckboxGroup, _React$Component);
	
	  var _super = _createSuper(CheckboxGroup);
	
	  function CheckboxGroup(props) {
	    var _this;
	
	    _classCallCheck(this, CheckboxGroup);
	
	    _this = _super.call(this, props);
	
	    _this.cancelValue = function (value) {
	      _this.setState(function (_ref) {
	        var registeredValues = _ref.registeredValues;
	        return {
	          registeredValues: registeredValues.filter(function (val) {
	            return val !== value;
	          })
	        };
	      });
	    };
	
	    _this.registerValue = function (value) {
	      _this.setState(function (_ref2) {
	        var registeredValues = _ref2.registeredValues;
	        return {
	          registeredValues: [].concat(_toConsumableArray(registeredValues), [value])
	        };
	      });
	    };
	
	    _this.toggleOption = function (option) {
	      var registeredValues = _this.state.registeredValues;
	
	      var optionIndex = _this.state.value.indexOf(option.value);
	
	      var value = _toConsumableArray(_this.state.value);
	
	      if (optionIndex === -1) {
	        value.push(option.value);
	      } else {
	        value.splice(optionIndex, 1);
	      }
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        var options = _this.getOptions();
	
	        onChange(value.filter(function (val) {
	          return registeredValues.indexOf(val) !== -1;
	        }).sort(function (a, b) {
	          var indexA = options.findIndex(function (opt) {
	            return opt.value === a;
	          });
	          var indexB = options.findIndex(function (opt) {
	            return opt.value === b;
	          });
	          return indexA - indexB;
	        }));
	      }
	    };
	
	    _this.renderGroup = function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          style = props.style,
	          options = props.options,
	          restProps = __rest(props, ["prefixCls", "className", "style", "options"]);
	
	      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var domProps = (0, _omit["default"])(restProps, ['children', 'defaultValue', 'value', 'onChange', 'disabled']);
	      var children = props.children;
	
	      if (options && options.length > 0) {
	        children = _this.getOptions().map(function (option) {
	          return (/*#__PURE__*/React.createElement(_Checkbox["default"], {
	              prefixCls: prefixCls,
	              key: option.value.toString(),
	              disabled: 'disabled' in option ? option.disabled : props.disabled,
	              value: option.value,
	              checked: state.value.indexOf(option.value) !== -1,
	              onChange: option.onChange,
	              className: "".concat(groupPrefixCls, "-item")
	            }, option.label)
	          );
	        });
	      }
	
	      var classString = (0, _classnames["default"])(groupPrefixCls, className);
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString,
	          style: style
	        }, domProps), children)
	      );
	    };
	
	    _this.state = {
	      value: props.value || props.defaultValue || [],
	      registeredValues: []
	    };
	    return _this;
	  }
	
	  _createClass(CheckboxGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        checkboxGroup: {
	          toggleOption: this.toggleOption,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name,
	          // https://github.com/ant-design/ant-design/issues/16376
	          registerValue: this.registerValue,
	          cancelValue: this.cancelValue
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var options = this.props.options; // https://github.com/Microsoft/TypeScript/issues/7960
	
	      return options.map(function (option) {
	        if (typeof option === 'string') {
	          return {
	            label: option,
	            value: option
	          };
	        }
	
	        return option;
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value || []
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return CheckboxGroup;
	}(React.Component);
	
	CheckboxGroup.defaultProps = {
	  options: []
	};
	CheckboxGroup.propTypes = {
	  defaultValue: PropTypes.array,
	  value: PropTypes.array,
	  options: PropTypes.array.isRequired,
	  onChange: PropTypes.func
	};
	CheckboxGroup.childContextTypes = {
	  checkboxGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(CheckboxGroup);
	var _default = CheckboxGroup;
	exports["default"] = _default;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcCollapse = _interopRequireDefault(__webpack_require__(188));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _CollapsePanel = _interopRequireDefault(__webpack_require__(1189));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _openAnimation = _interopRequireDefault(__webpack_require__(1162));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Collapse = /*#__PURE__*/function (_React$Component) {
	  _inherits(Collapse, _React$Component);
	
	  var _super = _createSuper(Collapse);
	
	  function Collapse() {
	    var _this;
	
	    _classCallCheck(this, Collapse);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderExpandIcon = function () {
	      var panelProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var prefixCls = arguments.length > 1 ? arguments[1] : undefined;
	      var expandIcon = _this.props.expandIcon;
	      var icon = expandIcon ? expandIcon(panelProps) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        rotate: panelProps.isActive ? 90 : undefined
	      });
	      return (/*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
	          className: (0, _classnames["default"])(icon.props.className, "".concat(prefixCls, "-arrow"))
	        }) : icon
	      );
	    };
	
	    _this.renderCollapse = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          bordered = _this$props.bordered,
	          expandIconPosition = _this$props.expandIconPosition;
	      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
	      var collapseClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _defineProperty(_classNames, "".concat(prefixCls, "-icon-position-").concat(expandIconPosition), true), _classNames), className);
	      return (/*#__PURE__*/React.createElement(_rcCollapse["default"], _extends({}, _this.props, {
	          expandIcon: function expandIcon(panelProps) {
	            return _this.renderExpandIcon(panelProps, prefixCls);
	          },
	          prefixCls: prefixCls,
	          className: collapseClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapse)
	      );
	    }
	  }]);
	
	  return Collapse;
	}(React.Component);
	
	exports["default"] = Collapse;
	Collapse.Panel = _CollapsePanel["default"];
	Collapse.defaultProps = {
	  bordered: true,
	  openAnimation: _extends(_extends({}, _openAnimation["default"]), {
	    appear: function appear() {}
	  }),
	  expandIconPosition: 'left'
	};

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcCollapse = _interopRequireDefault(__webpack_require__(188));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var CollapsePanel = /*#__PURE__*/function (_React$Component) {
	  _inherits(CollapsePanel, _React$Component);
	
	  var _super = _createSuper(CollapsePanel);
	
	  function CollapsePanel() {
	    var _this;
	
	    _classCallCheck(this, CollapsePanel);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderCollapsePanel = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          _this$props$showArrow = _this$props.showArrow,
	          showArrow = _this$props$showArrow === void 0 ? true : _this$props$showArrow;
	      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
	      var collapsePanelClassName = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-no-arrow"), !showArrow), className);
	      return (/*#__PURE__*/React.createElement(_rcCollapse["default"].Panel, _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: collapsePanelClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(CollapsePanel, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapsePanel)
	      );
	    }
	  }]);
	
	  return CollapsePanel;
	}(React.Component);
	
	exports["default"] = CollapsePanel;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Collapse = _interopRequireDefault(__webpack_require__(1188));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Collapse["default"];
	exports["default"] = _default;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getAction(actions) {
	  if (!actions || !actions.length) {
	    return null;
	  } // eslint-disable-next-line react/no-array-index-key
	
	
	  var actionList = actions.map(function (action, index) {
	    return (/*#__PURE__*/React.createElement("li", {
	        key: "action-".concat(index)
	      }, action)
	    );
	  });
	  return actionList;
	}
	
	var Comment = /*#__PURE__*/function (_React$Component) {
	  _inherits(Comment, _React$Component);
	
	  var _super = _createSuper(Comment);
	
	  function Comment() {
	    var _this;
	
	    _classCallCheck(this, Comment);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderNested = function (prefixCls, children) {
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-nested"))
	        }, children)
	      );
	    };
	
	    _this.renderComment = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          actions = _a.actions,
	          author = _a.author,
	          avatar = _a.avatar,
	          children = _a.children,
	          className = _a.className,
	          content = _a.content,
	          customizePrefixCls = _a.prefixCls,
	          style = _a.style,
	          datetime = _a.datetime,
	          otherProps = __rest(_a, ["actions", "author", "avatar", "children", "className", "content", "prefixCls", "style", "datetime"]);
	
	      var prefixCls = getPrefixCls('comment', customizePrefixCls);
	      var avatarDom = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-avatar")
	      }, typeof avatar === 'string' ? /*#__PURE__*/React.createElement("img", {
	        src: avatar,
	        alt: "comment-avatar"
	      }) : avatar);
	      var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-actions")
	      }, getAction(actions)) : null;
	      var authorContent = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content-author")
	      }, author && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-author-name")
	      }, author), datetime && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-author-time")
	      }, datetime));
	      var contentDom = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, authorContent, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content-detail")
	      }, content), actionDom);
	      var comment = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-inner")
	      }, avatarDom, contentDom);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
	          className: (0, _classnames["default"])(prefixCls, className),
	          style: style
	        }), comment, children ? _this.renderNested(prefixCls, children) : null)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Comment, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComment)
	      );
	    }
	  }]);
	
	  return Comment;
	}(React.Component);
	
	exports["default"] = Comment;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _empty = _interopRequireDefault(__webpack_require__(643));
	
	var _ = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var renderEmpty = function renderEmpty(componentName) {
	  return (/*#__PURE__*/React.createElement(_.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var prefix = getPrefixCls('empty');
	
	      switch (componentName) {
	        case 'Table':
	        case 'List':
	          return (/*#__PURE__*/React.createElement(_empty["default"], {
	              image: _empty["default"].PRESENTED_IMAGE_SIMPLE
	            })
	          );
	
	        case 'Select':
	        case 'TreeSelect':
	        case 'Cascader':
	        case 'Transfer':
	        case 'Mentions':
	          return (/*#__PURE__*/React.createElement(_empty["default"], {
	              image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
	              className: "".concat(prefix, "-small")
	            })
	          );
	
	        default:
	          return (/*#__PURE__*/React.createElement(_empty["default"], null)
	          );
	      }
	    })
	  );
	};
	
	var _default = renderEmpty;
	exports["default"] = _default;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _RangeCalendar = _interopRequireDefault(__webpack_require__(461));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _tag = _interopRequireDefault(__webpack_require__(659));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	var _utils = __webpack_require__(642);
	
	var _InputIcon = _interopRequireDefault(__webpack_require__(641));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function getShowDateFromValue(value, mode) {
	  var _value = _slicedToArray(value, 2),
	      start = _value[0],
	      end = _value[1]; // value could be an empty array, then we should not reset showDate
	
	
	  if (!start && !end) {
	    return;
	  }
	
	  if (mode && mode[0] === 'month') {
	    return [start, end];
	  }
	
	  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
	  return [start, newEnd];
	}
	
	function pickerValueAdapter(value) {
	  if (!value) {
	    return;
	  }
	
	  if (Array.isArray(value)) {
	    return value;
	  }
	
	  return [value, value.clone().add(1, 'month')];
	}
	
	function isEmptyArray(arr) {
	  if (Array.isArray(arr)) {
	    return arr.length === 0 || arr.every(function (i) {
	      return !i;
	    });
	  }
	
	  return false;
	}
	
	function fixLocale(value, localeCode) {
	  if (!localeCode) {
	    return;
	  }
	
	  if (!value || value.length === 0) {
	    return;
	  }
	
	  var _value2 = _slicedToArray(value, 2),
	      start = _value2[0],
	      end = _value2[1];
	
	  if (start) {
	    start.locale(localeCode);
	  }
	
	  if (end) {
	    end.locale(localeCode);
	  }
	}
	
	var RangePicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(RangePicker, _React$Component);
	
	  var _super = _createSuper(RangePicker);
	
	  function RangePicker(props) {
	    var _this;
	
	    _classCallCheck(this, RangePicker);
	
	    _this = _super.call(this, props);
	
	    _this.savePicker = function (node) {
	      _this.picker = node;
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.setState({
	        value: []
	      });
	
	      _this.handleChange([]);
	    };
	
	    _this.clearHoverValue = function () {
	      return _this.setState({
	        hoverValue: []
	      });
	    };
	
	    _this.handleChange = function (value) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      if (!('value' in props)) {
	        _this.setState(function (_ref) {
	          var showDate = _ref.showDate;
	          return {
	            value: value,
	            showDate: getShowDateFromValue(value) || showDate
	          };
	        });
	      }
	
	      if (value[0] && value[1] && value[0].diff(value[1]) > 0) {
	        value[1] = undefined;
	      }
	
	      var _value3 = _slicedToArray(value, 2),
	          start = _value3[0],
	          end = _value3[1];
	
	      if (typeof props.onChange === 'function') {
	        props.onChange(value, [(0, _utils.formatDate)(start, props.format), (0, _utils.formatDate)(end, props.format)]);
	      }
	    };
	
	    _this.handleOpenChange = function (open) {
	      if (!('open' in _this.props)) {
	        _this.setState({
	          open: open
	        });
	      }
	
	      if (open === false) {
	        _this.clearHoverValue();
	      }
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.handleShowDateChange = function (showDate) {
	      return _this.setState({
	        showDate: showDate
	      });
	    };
	
	    _this.handleHoverChange = function (hoverValue) {
	      return _this.setState({
	        hoverValue: hoverValue
	      });
	    };
	
	    _this.handleRangeMouseLeave = function () {
	      if (_this.state.open) {
	        _this.clearHoverValue();
	      }
	    };
	
	    _this.handleCalendarInputSelect = function (value) {
	      var _value4 = _slicedToArray(value, 1),
	          start = _value4[0];
	
	      if (!start) {
	        return;
	      }
	
	      _this.setState(function (_ref2) {
	        var showDate = _ref2.showDate;
	        return {
	          value: value,
	          showDate: getShowDateFromValue(value) || showDate
	        };
	      });
	    };
	
	    _this.handleRangeClick = function (value) {
	      if (typeof value === 'function') {
	        value = value();
	      }
	
	      _this.setValue(value, true);
	
	      var _this$props = _this.props,
	          onOk = _this$props.onOk,
	          onOpenChange = _this$props.onOpenChange;
	
	      if (onOk) {
	        onOk(value);
	      }
	
	      if (onOpenChange) {
	        onOpenChange(false);
	      }
	    };
	
	    _this.renderFooter = function () {
	      var _this$props2 = _this.props,
	          ranges = _this$props2.ranges,
	          renderExtraFooter = _this$props2.renderExtraFooter;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize2.prefixCls,
	          tagPrefixCls = _assertThisInitialize2.tagPrefixCls;
	
	      if (!ranges && !renderExtraFooter) {
	        return null;
	      }
	
	      var customFooter = renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra"),
	        key: "extra"
	      }, renderExtraFooter()) : null;
	      var operations = ranges && Object.keys(ranges).map(function (range) {
	        var value = ranges[range];
	        var hoverValue = typeof value === 'function' ? value.call(_assertThisInitialized(_this)) : value;
	        return (/*#__PURE__*/React.createElement(_tag["default"], {
	            key: range,
	            prefixCls: tagPrefixCls,
	            color: "blue",
	            onClick: function onClick() {
	              return _this.handleRangeClick(value);
	            },
	            onMouseEnter: function onMouseEnter() {
	              return _this.setState({
	                hoverValue: hoverValue
	              });
	            },
	            onMouseLeave: _this.handleRangeMouseLeave
	          }, range)
	        );
	      });
	      var rangeNode = operations && operations.length > 0 ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra ").concat(prefixCls, "-range-quick-selector"),
	        key: "range"
	      }, operations) : null;
	      return [rangeNode, customFooter];
	    };
	
	    _this.renderRangePicker = function (_ref3) {
	      var _classNames;
	
	      var getPrefixCls = _ref3.getPrefixCls;
	
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          state = _assertThisInitialize3.state,
	          props = _assertThisInitialize3.props;
	
	      var value = state.value,
	          showDate = state.showDate,
	          hoverValue = state.hoverValue,
	          open = state.open;
	      var customizePrefixCls = props.prefixCls,
	          customizeTagPrefixCls = props.tagPrefixCls,
	          popupStyle = props.popupStyle,
	          style = props.style,
	          disabledDate = props.disabledDate,
	          disabledTime = props.disabledTime,
	          showTime = props.showTime,
	          showToday = props.showToday,
	          ranges = props.ranges,
	          onOk = props.onOk,
	          locale = props.locale,
	          localeCode = props.localeCode,
	          format = props.format,
	          dateRender = props.dateRender,
	          onCalendarChange = props.onCalendarChange,
	          suffixIcon = props.suffixIcon,
	          separator = props.separator;
	      var prefixCls = getPrefixCls('calendar', customizePrefixCls);
	      var tagPrefixCls = getPrefixCls('tag', customizeTagPrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      _this.tagPrefixCls = tagPrefixCls;
	      fixLocale(value, localeCode);
	      fixLocale(showDate, localeCode);
	      (0, _warning["default"])(!('onOK' in props), 'RangePicker', 'It should be `RangePicker[onOk]`, instead of `onOK`!');
	      var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), showTime), _defineProperty(_classNames, "".concat(prefixCls, "-range-with-ranges"), ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange
	
	      var pickerChangeHandler = {
	        onChange: _this.handleChange
	      };
	      var calendarProps = {
	        onOk: _this.handleChange
	      };
	
	      if (props.timePicker) {
	        pickerChangeHandler.onChange = function (changedValue) {
	          return _this.handleChange(changedValue);
	        };
	      } else {
	        calendarProps = {};
	      }
	
	      if ('mode' in props) {
	        calendarProps.mode = props.mode;
	      }
	
	      var startPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
	      var endPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
	      var calendar = /*#__PURE__*/React.createElement(_RangeCalendar["default"], _extends({}, calendarProps, {
	        seperator: separator,
	        onChange: onCalendarChange,
	        format: format,
	        prefixCls: prefixCls,
	        className: calendarClassName,
	        renderFooter: _this.renderFooter,
	        timePicker: props.timePicker,
	        disabledDate: disabledDate,
	        disabledTime: disabledTime,
	        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
	        locale: locale.lang,
	        onOk: onOk,
	        dateRender: dateRender,
	        value: showDate,
	        onValueChange: _this.handleShowDateChange,
	        hoverValue: hoverValue,
	        onHoverChange: _this.handleHoverChange,
	        onPanelChange: props.onPanelChange,
	        showToday: showToday,
	        onInputSelect: _this.handleCalendarInputSelect
	      })); // default width for showTime
	
	      var pickerStyle = {};
	
	      if (props.showTime) {
	        pickerStyle.width = style && style.width || 350;
	      }
	
	      var _value5 = _slicedToArray(value, 2),
	          startValue = _value5[0],
	          endValue = _value5[1];
	
	      var clearIcon = !props.disabled && props.allowClear && value && (startValue || endValue) ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection,
	        theme: "filled"
	      }) : null;
	      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
	        suffixIcon: suffixIcon,
	        prefixCls: prefixCls
	      });
	
	      var input = function input(_ref4) {
	        var inputValue = _ref4.value;
	
	        var _inputValue = _slicedToArray(inputValue, 2),
	            start = _inputValue[0],
	            end = _inputValue[1];
	
	        return (/*#__PURE__*/React.createElement("span", {
	            className: props.pickerInputClass
	          }, /*#__PURE__*/React.createElement("input", {
	            disabled: props.disabled,
	            readOnly: true,
	            value: (0, _utils.formatDate)(start, props.format),
	            placeholder: startPlaceholder,
	            className: "".concat(prefixCls, "-range-picker-input"),
	            tabIndex: -1
	          }), /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-range-picker-separator")
	          }, " ", separator, " "), /*#__PURE__*/React.createElement("input", {
	            disabled: props.disabled,
	            readOnly: true,
	            value: (0, _utils.formatDate)(end, props.format),
	            placeholder: endPlaceholder,
	            className: "".concat(prefixCls, "-range-picker-input"),
	            tabIndex: -1
	          }), clearIcon, inputIcon)
	        );
	      };
	
	      return (/*#__PURE__*/React.createElement("span", {
	          ref: _this.savePicker,
	          id: typeof props.id === 'number' ? props.id.toString() : props.id,
	          className: (0, _classnames["default"])(props.className, props.pickerClass),
	          style: _extends(_extends({}, style), pickerStyle),
	          tabIndex: props.disabled ? -1 : 0,
	          onFocus: props.onFocus,
	          onBlur: props.onBlur,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerChangeHandler, {
	          calendar: calendar,
	          value: value,
	          open: open,
	          onOpenChange: _this.handleOpenChange,
	          prefixCls: "".concat(prefixCls, "-picker-container"),
	          style: popupStyle
	        }), input))
	      );
	    };
	
	    var value = props.value || props.defaultValue || [];
	
	    var _value6 = _slicedToArray(value, 2),
	        start = _value6[0],
	        end = _value6[1];
	
	    if (start && !(0, _interopDefault["default"])(moment).isMoment(start) || end && !(0, _interopDefault["default"])(moment).isMoment(end)) {
	      throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
	    }
	
	    var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
	    _this.state = {
	      value: value,
	      showDate: pickerValueAdapter(pickerValue || (0, _interopDefault["default"])(moment)()),
	      open: props.open,
	      hoverValue: []
	    };
	    return _this;
	  }
	
	  _createClass(RangePicker, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      if (!('open' in this.props) && prevState.open && !this.state.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, hidePanel) {
	      this.handleChange(value);
	
	      if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.picker.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.picker.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRangePicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var state = null;
	
	      if ('value' in nextProps) {
	        var value = nextProps.value || [];
	        state = {
	          value: value
	        };
	
	        if (!(0, _shallowequal["default"])(nextProps.value, prevState.value)) {
	          state = _extends(_extends({}, state), {
	            showDate: getShowDateFromValue(value, nextProps.mode) || prevState.showDate
	          });
	        }
	      }
	
	      if ('open' in nextProps && prevState.open !== nextProps.open) {
	        state = _extends(_extends({}, state), {
	          open: nextProps.open
	        });
	      }
	
	      return state;
	    }
	  }]);
	
	  return RangePicker;
	}(React.Component);
	
	RangePicker.defaultProps = {
	  allowClear: true,
	  showToday: false,
	  separator: '~'
	};
	(0, _reactLifecyclesCompat.polyfill)(RangePicker);
	var _default = RangePicker;
	exports["default"] = _default;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcCalendar = _interopRequireDefault(__webpack_require__(186));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	var _InputIcon = _interopRequireDefault(__webpack_require__(641));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function formatValue(value, format) {
	  return value && value.format(format) || '';
	}
	
	var WeekPicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(WeekPicker, _React$Component);
	
	  var _super = _createSuper(WeekPicker);
	
	  function WeekPicker(props) {
	    var _this;
	
	    _classCallCheck(this, WeekPicker);
	
	    _this = _super.call(this, props);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.weekDateRender = function (current) {
	      var selectedValue = _this.state.value;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      var dateRender = _this.props.dateRender;
	      var dateNode = dateRender ? dateRender(current) : current.date();
	
	      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
	        return (/*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-selected-day")
	          }, /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-date")
	          }, dateNode))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-date")
	        }, dateNode)
	      );
	    };
	
	    _this.handleChange = function (value) {
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      _this.props.onChange(value, formatValue(value, _this.props.format));
	    };
	
	    _this.handleOpenChange = function (open) {
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (!('open' in _this.props)) {
	        _this.setState({
	          open: open
	        });
	      }
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.handleChange(null);
	    };
	
	    _this.renderFooter = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          renderExtraFooter = _this$props.renderExtraFooter;
	      return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra")
	      }, renderExtraFooter.apply(void 0, arguments)) : null;
	    };
	
	    _this.renderWeekPicker = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          disabled = _this$props2.disabled,
	          pickerClass = _this$props2.pickerClass,
	          popupStyle = _this$props2.popupStyle,
	          pickerInputClass = _this$props2.pickerInputClass,
	          format = _this$props2.format,
	          allowClear = _this$props2.allowClear,
	          locale = _this$props2.locale,
	          localeCode = _this$props2.localeCode,
	          disabledDate = _this$props2.disabledDate,
	          style = _this$props2.style,
	          onFocus = _this$props2.onFocus,
	          onBlur = _this$props2.onBlur,
	          id = _this$props2.id,
	          suffixIcon = _this$props2.suffixIcon,
	          defaultPickerValue = _this$props2.defaultPickerValue;
	      var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      var _this$state = _this.state,
	          open = _this$state.open,
	          pickerValue = _this$state.value;
	
	      if (pickerValue && localeCode) {
	        pickerValue.locale(localeCode);
	      }
	
	      var placeholder = 'placeholder' in _this.props ? _this.props.placeholder : locale.lang.placeholder;
	      var calendar = /*#__PURE__*/React.createElement(_rcCalendar["default"], {
	        showWeekNumber: true,
	        dateRender: _this.weekDateRender,
	        prefixCls: prefixCls,
	        format: format,
	        locale: locale.lang,
	        showDateInput: false,
	        showToday: false,
	        disabledDate: disabledDate,
	        renderFooter: _this.renderFooter,
	        defaultValue: defaultPickerValue
	      });
	      var clearIcon = !disabled && allowClear && _this.state.value ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection,
	        theme: "filled"
	      }) : null;
	      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
	        suffixIcon: suffixIcon,
	        prefixCls: prefixCls
	      });
	
	      var input = function input(_ref2) {
	        var value = _ref2.value;
	        return (/*#__PURE__*/React.createElement("span", {
	            style: {
	              display: 'inline-block',
	              width: '100%'
	            }
	          }, /*#__PURE__*/React.createElement("input", {
	            ref: _this.saveInput,
	            disabled: disabled,
	            readOnly: true,
	            value: value && value.format(format) || '',
	            placeholder: placeholder,
	            className: pickerInputClass,
	            onFocus: onFocus,
	            onBlur: onBlur
	          }), clearIcon, inputIcon)
	        );
	      };
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])(className, pickerClass),
	          style: style,
	          id: id
	        }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, _this.props, {
	          calendar: calendar,
	          prefixCls: "".concat(prefixCls, "-picker-container"),
	          value: pickerValue,
	          onChange: _this.handleChange,
	          open: open,
	          onOpenChange: _this.handleOpenChange,
	          style: popupStyle
	        }), input))
	      );
	    };
	
	    var value = props.value || props.defaultValue;
	
	    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of WeekPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	    }
	
	    _this.state = {
	      value: value,
	      open: props.open
	    };
	    return _this;
	  }
	
	  _createClass(WeekPicker, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      if (!('open' in this.props) && prevState.open && !this.state.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWeekPicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps || 'open' in nextProps) {
	        var state = {};
	
	        if ('value' in nextProps) {
	          state.value = nextProps.value;
	        }
	
	        if ('open' in nextProps) {
	          state.open = nextProps.open;
	        }
	
	        return state;
	      }
	
	      return null;
	    }
	  }]);
	
	  return WeekPicker;
	}(React.Component);
	
	WeekPicker.defaultProps = {
	  format: 'gggg-wo',
	  allowClear: true
	};
	(0, _reactLifecyclesCompat.polyfill)(WeekPicker);
	var _default = WeekPicker;
	exports["default"] = _default;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createPicker;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _MonthCalendar = _interopRequireDefault(__webpack_require__(185));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(629));
	
	var _utils = __webpack_require__(642);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function createPicker(TheCalendar) {
	  var CalenderWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(CalenderWrapper, _React$Component);
	
	    var _super = _createSuper(CalenderWrapper);
	
	    function CalenderWrapper(props) {
	      var _this;
	
	      _classCallCheck(this, CalenderWrapper);
	
	      _this = _super.call(this, props);
	
	      _this.saveInput = function (node) {
	        _this.input = node;
	      };
	
	      _this.clearSelection = function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        _this.handleChange(null);
	      };
	
	      _this.handleChange = function (value) {
	        var _assertThisInitialize = _assertThisInitialized(_this),
	            props = _assertThisInitialize.props;
	
	        if (!('value' in props)) {
	          _this.setState({
	            value: value,
	            showDate: value
	          });
	        }
	
	        props.onChange(value, (0, _utils.formatDate)(value, props.format));
	      };
	
	      _this.handleCalendarChange = function (value) {
	        _this.setState({
	          showDate: value
	        });
	      };
	
	      _this.handleOpenChange = function (open) {
	        var onOpenChange = _this.props.onOpenChange;
	
	        if (!('open' in _this.props)) {
	          _this.setState({
	            open: open
	          });
	        }
	
	        if (onOpenChange) {
	          onOpenChange(open);
	        }
	      };
	
	      _this.renderFooter = function () {
	        var renderExtraFooter = _this.props.renderExtraFooter;
	
	        var _assertThisInitialize2 = _assertThisInitialized(_this),
	            prefixCls = _assertThisInitialize2.prefixCls;
	
	        return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-footer-extra")
	        }, renderExtraFooter.apply(void 0, arguments)) : null;
	      };
	
	      _this.renderPicker = function (_ref) {
	        var _classNames, _classNames2;
	
	        var getPrefixCls = _ref.getPrefixCls;
	        var _this$state = _this.state,
	            value = _this$state.value,
	            showDate = _this$state.showDate,
	            open = _this$state.open;
	        var props = (0, _omit["default"])(_this.props, ['onChange']);
	        var customizePrefixCls = props.prefixCls,
	            locale = props.locale,
	            localeCode = props.localeCode,
	            suffixIcon = props.suffixIcon;
	        var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
	        // Have to add prefixCls on the instance.
	        // https://github.com/facebook/react/issues/12397
	
	        _this.prefixCls = prefixCls;
	        var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
	        var disabledTime = props.showTime ? props.disabledTime : null;
	        var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), props.showTime), _defineProperty(_classNames, "".concat(prefixCls, "-month"), _MonthCalendar["default"] === TheCalendar), _classNames));
	
	        if (value && localeCode) {
	          value.locale(localeCode);
	        }
	
	        var pickerProps = {};
	        var calendarProps = {};
	        var pickerStyle = {};
	
	        if (props.showTime) {
	          calendarProps = {
	            // fix https://github.com/ant-design/ant-design/issues/1902
	            onSelect: _this.handleChange
	          };
	          pickerStyle.minWidth = 195;
	        } else {
	          pickerProps = {
	            onChange: _this.handleChange
	          };
	        }
	
	        if ('mode' in props) {
	          calendarProps.mode = props.mode;
	        }
	
	        (0, _warning["default"])(!('onOK' in props), 'DatePicker', 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
	        var calendar = /*#__PURE__*/React.createElement(TheCalendar, _extends({}, calendarProps, {
	          disabledDate: props.disabledDate,
	          disabledTime: disabledTime,
	          locale: locale.lang,
	          timePicker: props.timePicker,
	          defaultValue: props.defaultPickerValue || (0, _interopDefault["default"])(moment)(),
	          dateInputPlaceholder: placeholder,
	          prefixCls: prefixCls,
	          className: calendarClassName,
	          onOk: props.onOk,
	          dateRender: props.dateRender,
	          format: props.format,
	          showToday: props.showToday,
	          monthCellContentRender: props.monthCellContentRender,
	          renderFooter: _this.renderFooter,
	          onPanelChange: props.onPanelChange,
	          onChange: _this.handleCalendarChange,
	          value: showDate
	        }));
	        var clearIcon = !props.disabled && props.allowClear && value ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          className: "".concat(prefixCls, "-picker-clear"),
	          onClick: _this.clearSelection,
	          theme: "filled"
	        }) : null;
	        var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-icon"), true), _classNames2))
	        }) : /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-picker-icon")
	        }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "calendar",
	          className: "".concat(prefixCls, "-picker-icon")
	        });
	        var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(props);
	
	        var input = function input(_ref2) {
	          var inputValue = _ref2.value;
	          return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
	              ref: _this.saveInput,
	              disabled: props.disabled,
	              readOnly: true,
	              value: (0, _utils.formatDate)(inputValue, props.format),
	              placeholder: placeholder,
	              className: props.pickerInputClass,
	              tabIndex: props.tabIndex,
	              name: props.name
	            }, dataOrAriaProps)), clearIcon, inputIcon)
	          );
	        };
	
	        return (/*#__PURE__*/React.createElement("span", {
	            id: props.id,
	            className: (0, _classnames["default"])(props.className, props.pickerClass),
	            style: _extends(_extends({}, pickerStyle), props.style),
	            onFocus: props.onFocus,
	            onBlur: props.onBlur,
	            onMouseEnter: props.onMouseEnter,
	            onMouseLeave: props.onMouseLeave
	          }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerProps, {
	            calendar: calendar,
	            value: value,
	            prefixCls: "".concat(prefixCls, "-picker-container"),
	            style: props.popupStyle,
	            open: open,
	            onOpenChange: _this.handleOpenChange
	          }), input))
	        );
	      };
	
	      var value = props.value || props.defaultValue;
	
	      if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	        throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	      }
	
	      _this.state = {
	        value: value,
	        showDate: value,
	        open: false
	      };
	      return _this;
	    }
	
	    _createClass(CalenderWrapper, [{
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(_, prevState) {
	        if (!('open' in this.props) && prevState.open && !this.state.open) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.input.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.input.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPicker)
	        );
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(nextProps, prevState) {
	        var state = {};
	        var open = prevState.open;
	
	        if ('open' in nextProps) {
	          state.open = nextProps.open;
	          open = nextProps.open || false;
	        }
	
	        if ('value' in nextProps) {
	          state.value = nextProps.value;
	
	          if (nextProps.value !== prevState.value || !open && nextProps.value !== prevState.showDate) {
	            state.showDate = nextProps.value;
	          }
	        }
	
	        return Object.keys(state).length > 0 ? state : null;
	      }
	    }]);
	
	    return CalenderWrapper;
	  }(React.Component);
	
	  CalenderWrapper.defaultProps = {
	    allowClear: true,
	    showToday: true
	  };
	  (0, _reactLifecyclesCompat.polyfill)(CalenderWrapper);
	  return CalenderWrapper;
	}

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _rcCalendar = _interopRequireDefault(__webpack_require__(186));
	
	var _MonthCalendar = _interopRequireDefault(__webpack_require__(185));
	
	var _createPicker = _interopRequireDefault(__webpack_require__(1195));
	
	var _wrapPicker = _interopRequireDefault(__webpack_require__(1197));
	
	var _RangePicker = _interopRequireDefault(__webpack_require__(1193));
	
	var _WeekPicker = _interopRequireDefault(__webpack_require__(1194));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var DatePicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_rcCalendar["default"]), 'date');
	var MonthPicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_MonthCalendar["default"]), 'month');
	
	_extends(DatePicker, {
	  RangePicker: (0, _wrapPicker["default"])(_RangePicker["default"], 'date'),
	  MonthPicker: MonthPicker,
	  WeekPicker: (0, _wrapPicker["default"])(_WeekPicker["default"], 'week')
	});
	
	var _default = DatePicker;
	exports["default"] = _default;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapPicker;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _Panel = _interopRequireDefault(__webpack_require__(505));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _en_US = _interopRequireDefault(__webpack_require__(354));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _timePicker = __webpack_require__(660);
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var DEFAULT_FORMAT = {
	  date: 'YYYY-MM-DD',
	  dateTime: 'YYYY-MM-DD HH:mm:ss',
	  week: 'gggg-wo',
	  month: 'YYYY-MM'
	};
	var LOCALE_FORMAT_MAPPING = {
	  date: 'dateFormat',
	  dateTime: 'dateTimeFormat',
	  week: 'weekFormat',
	  month: 'monthFormat'
	};
	
	function getColumns(_ref) {
	  var showHour = _ref.showHour,
	      showMinute = _ref.showMinute,
	      showSecond = _ref.showSecond,
	      use12Hours = _ref.use12Hours;
	  var column = 0;
	
	  if (showHour) {
	    column += 1;
	  }
	
	  if (showMinute) {
	    column += 1;
	  }
	
	  if (showSecond) {
	    column += 1;
	  }
	
	  if (use12Hours) {
	    column += 1;
	  }
	
	  return column;
	}
	
	function checkValidate(value, propName) {
	  var values = Array.isArray(value) ? value : [value];
	  values.forEach(function (val) {
	    if (!val) return;
	    (0, _warning["default"])(!(0, _interopDefault["default"])(moment).isMoment(val) || val.isValid(), 'DatePicker', "`".concat(propName, "` provides invalidate moment time. If you want to set empty value, use `null` instead."));
	  });
	}
	
	function wrapPicker(Picker, pickerType) {
	  var PickerWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(PickerWrapper, _React$Component);
	
	    var _super = _createSuper(PickerWrapper);
	
	    function PickerWrapper() {
	      var _this;
	
	      _classCallCheck(this, PickerWrapper);
	
	      _this = _super.apply(this, arguments); // Since we need call `getDerivedStateFromProps` for check. Need leave an empty `state` here.
	
	      _this.state = {};
	
	      _this.savePicker = function (node) {
	        _this.picker = node;
	      };
	
	      _this.getDefaultLocale = function () {
	        var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	        result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
	        return result;
	      };
	
	      _this.handleOpenChange = function (open) {
	        var onOpenChange = _this.props.onOpenChange;
	        onOpenChange(open);
	      };
	
	      _this.handleFocus = function (e) {
	        var onFocus = _this.props.onFocus;
	
	        if (onFocus) {
	          onFocus(e);
	        }
	      };
	
	      _this.handleBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        if (onMouseEnter) {
	          onMouseEnter(e);
	        }
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	
	        if (onMouseLeave) {
	          onMouseLeave(e);
	        }
	      };
	
	      _this.renderPicker = function (locale, localeCode) {
	        var _this$props = _this.props,
	            format = _this$props.format,
	            showTime = _this$props.showTime;
	        var mergedPickerType = showTime ? "".concat(pickerType, "Time") : pickerType;
	        var mergedFormat = format || locale[LOCALE_FORMAT_MAPPING[mergedPickerType]] || DEFAULT_FORMAT[mergedPickerType];
	        return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	            var _classNames2;
	
	            var getPrefixCls = _ref2.getPrefixCls,
	                getContextPopupContainer = _ref2.getPopupContainer;
	            var _this$props2 = _this.props,
	                customizePrefixCls = _this$props2.prefixCls,
	                customizeInputPrefixCls = _this$props2.inputPrefixCls,
	                getCalendarContainer = _this$props2.getCalendarContainer,
	                size = _this$props2.size,
	                disabled = _this$props2.disabled;
	            var getPopupContainer = getCalendarContainer || getContextPopupContainer;
	            var prefixCls = getPrefixCls('calendar', customizePrefixCls);
	            var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	            var pickerClass = (0, _classnames["default"])("".concat(prefixCls, "-picker"), _defineProperty({}, "".concat(prefixCls, "-picker-").concat(size), !!size));
	            var pickerInputClass = (0, _classnames["default"])("".concat(prefixCls, "-picker-input"), inputPrefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-sm"), size === 'small'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames2));
	            var timeFormat = showTime && showTime.format || 'HH:mm:ss';
	
	            var rcTimePickerProps = _extends(_extends({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat)), {
	              format: timeFormat,
	              use12Hours: showTime && showTime.use12Hours
	            });
	
	            var columns = getColumns(rcTimePickerProps);
	            var timePickerCls = "".concat(prefixCls, "-time-picker-column-").concat(columns);
	            var timePicker = showTime ? /*#__PURE__*/React.createElement(_Panel["default"], _extends({}, rcTimePickerProps, showTime, {
	              prefixCls: "".concat(prefixCls, "-time-picker"),
	              className: timePickerCls,
	              placeholder: locale.timePickerLocale.placeholder,
	              transitionName: "slide-up",
	              onEsc: function onEsc() {}
	            })) : null;
	            return (/*#__PURE__*/React.createElement(Picker, _extends({}, _this.props, {
	                getCalendarContainer: getPopupContainer,
	                format: mergedFormat,
	                ref: _this.savePicker,
	                pickerClass: pickerClass,
	                pickerInputClass: pickerInputClass,
	                locale: locale,
	                localeCode: localeCode,
	                timePicker: timePicker,
	                onOpenChange: _this.handleOpenChange,
	                onFocus: _this.handleFocus,
	                onBlur: _this.handleBlur,
	                onMouseEnter: _this.handleMouseEnter,
	                onMouseLeave: _this.handleMouseLeave
	              }))
	            );
	          })
	        );
	      };
	
	      return _this;
	    }
	
	    _createClass(PickerWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this$props3 = this.props,
	            autoFocus = _this$props3.autoFocus,
	            disabled = _this$props3.disabled;
	
	        if (autoFocus && !disabled) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.picker.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.picker.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	            componentName: "DatePicker",
	            defaultLocale: this.getDefaultLocale
	          }, this.renderPicker)
	        );
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(_ref3) {
	        var value = _ref3.value,
	            defaultValue = _ref3.defaultValue;
	        checkValidate(defaultValue, 'defaultValue');
	        checkValidate(value, 'value');
	        return {};
	      }
	    }]);
	
	    return PickerWrapper;
	  }(React.Component);
	
	  PickerWrapper.defaultProps = {
	    transitionName: 'slide-up',
	    popupStyle: {},
	    onChange: function onChange() {},
	    onOk: function onOk() {},
	    onOpenChange: function onOpenChange() {},
	    locale: {}
	  };
	  (0, _reactLifecyclesCompat.polyfill)(PickerWrapper);
	  return PickerWrapper;
	}

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var Col = function Col(props) {
	  var _classNames;
	
	  var child = props.child,
	      bordered = props.bordered,
	      colon = props.colon,
	      type = props.type,
	      layout = props.layout;
	  var _child$props = child.props,
	      prefixCls = _child$props.prefixCls,
	      label = _child$props.label,
	      className = _child$props.className,
	      children = _child$props.children,
	      _child$props$span = _child$props.span,
	      span = _child$props$span === void 0 ? 1 : _child$props$span;
	  var labelProps = {
	    className: (0, _classnames["default"])("".concat(prefixCls, "-item-label"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-colon"), colon), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-label"), !label), _classNames)),
	    key: 'label'
	  };
	
	  if (layout === 'vertical') {
	    labelProps.colSpan = span * 2 - 1;
	  }
	
	  if (bordered) {
	    if (type === 'label') {
	      return (/*#__PURE__*/React.createElement("th", labelProps, label)
	      );
	    }
	
	    return (/*#__PURE__*/React.createElement("td", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item-content"), className),
	        key: "content",
	        colSpan: span * 2 - 1
	      }, children)
	    );
	  }
	
	  if (layout === 'vertical') {
	    if (type === 'content') {
	      return (/*#__PURE__*/React.createElement("td", {
	          colSpan: span,
	          className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	        }, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-item-content"),
	          key: "content"
	        }, children))
	      );
	    }
	
	    return (/*#__PURE__*/React.createElement("td", {
	        colSpan: span,
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	      }, /*#__PURE__*/React.createElement("span", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item-label"), _defineProperty({}, "".concat(prefixCls, "-item-colon"), colon)),
	        key: "label"
	      }, label))
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement("td", {
	      colSpan: span,
	      className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	    }, /*#__PURE__*/React.createElement("span", labelProps, label), /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-item-content"),
	      key: "content"
	    }, children))
	  );
	};
	
	var _default = Col;
	exports["default"] = _default;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _responsiveObserve = _interopRequireWildcard(__webpack_require__(632));
	
	var _configProvider = __webpack_require__(14);
	
	var _Col = _interopRequireDefault(__webpack_require__(1198));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// https://github.com/smooth-code/react-flatten-children/
	function flattenChildren(children) {
	  if (!children) {
	    return [];
	  }
	
	  return (0, _toArray["default"])(children).reduce(function (flatChildren, child) {
	    if (child && child.type === React.Fragment) {
	      return flatChildren.concat(flattenChildren(child.props.children));
	    }
	
	    flatChildren.push(child);
	    return flatChildren;
	  }, []);
	}
	
	var DescriptionsItem = function DescriptionsItem(_ref) {
	  var children = _ref.children;
	  return children;
	};
	/**
	 * Convert children into `column` groups.
	 * @param children: DescriptionsItem
	 * @param column: number
	 */
	
	var generateChildrenRows = function generateChildrenRows(children, column) {
	  var rows = [];
	  var columns = null;
	  var leftSpans;
	  var itemNodes = flattenChildren(children);
	  itemNodes.forEach(function (node, index) {
	    var itemNode = node;
	
	    if (!columns) {
	      leftSpans = column;
	      columns = [];
	      rows.push(columns);
	    } // Always set last span to align the end of Descriptions
	
	
	    var lastItem = index === itemNodes.length - 1;
	    var lastSpanSame = true;
	
	    if (lastItem) {
	      lastSpanSame = !itemNode.props.span || itemNode.props.span === leftSpans;
	      itemNode = /*#__PURE__*/React.cloneElement(itemNode, {
	        span: leftSpans
	      });
	    } // Calculate left fill span
	
	
	    var _itemNode$props$span = itemNode.props.span,
	        span = _itemNode$props$span === void 0 ? 1 : _itemNode$props$span;
	    columns.push(itemNode);
	    leftSpans -= span;
	
	    if (leftSpans <= 0) {
	      columns = null;
	      (0, _warning["default"])(leftSpans === 0 && lastSpanSame, 'Descriptions', 'Sum of column `span` in a line exceeds `column` of Descriptions.');
	    }
	  });
	  return rows;
	};
	
	var renderRow = function renderRow(children, index, _ref2, bordered, layout, colon) {
	  var prefixCls = _ref2.prefixCls;
	
	  var renderCol = function renderCol(colItem, type, idx) {
	    return (/*#__PURE__*/React.createElement(_Col["default"], {
	        child: colItem,
	        bordered: bordered,
	        colon: colon,
	        type: type,
	        key: "".concat(type, "-").concat(colItem.key || idx),
	        layout: layout
	      })
	    );
	  };
	
	  var cloneChildren = [];
	  var cloneContentChildren = [];
	  flattenChildren(children).forEach(function (childrenItem, idx) {
	    cloneChildren.push(renderCol(childrenItem, 'label', idx));
	
	    if (layout === 'vertical') {
	      cloneContentChildren.push(renderCol(childrenItem, 'content', idx));
	    } else if (bordered) {
	      cloneChildren.push(renderCol(childrenItem, 'content', idx));
	    }
	  });
	
	  if (layout === 'vertical') {
	    return [/*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: "label-".concat(index)
	    }, cloneChildren), /*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: "content-".concat(index)
	    }, cloneContentChildren)];
	  }
	
	  return (/*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: index
	    }, cloneChildren)
	  );
	};
	
	var defaultColumnMap = {
	  xxl: 3,
	  xl: 3,
	  lg: 3,
	  md: 3,
	  sm: 2,
	  xs: 1
	};
	
	var Descriptions = /*#__PURE__*/function (_React$Component) {
	  _inherits(Descriptions, _React$Component);
	
	  var _super = _createSuper(Descriptions);
	
	  function Descriptions() {
	    var _this;
	
	    _classCallCheck(this, Descriptions);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      screens: {}
	    };
	    return _this;
	  }
	
	  _createClass(Descriptions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var column = this.props.column;
	      this.token = _responsiveObserve["default"].subscribe(function (screens) {
	        if (_typeof(column) !== 'object') {
	          return;
	        }
	
	        _this2.setState({
	          screens: screens
	        });
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _responsiveObserve["default"].unsubscribe(this.token);
	    }
	  }, {
	    key: "getColumn",
	    value: function getColumn() {
	      var column = this.props.column;
	
	      if (_typeof(column) === 'object') {
	        for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
	          var breakpoint = _responsiveObserve.responsiveArray[i];
	
	          if (this.state.screens[breakpoint] && column[breakpoint] !== undefined) {
	            return column[breakpoint] || defaultColumnMap[breakpoint];
	          }
	        }
	      } // If the configuration is not an object, it is a number, return number
	
	
	      if (typeof column === 'number') {
	        return column;
	      } // If it is an object, but no response is found, this happens only in the test.
	      // Maybe there are some strange environments
	
	
	      return 3;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
	          var _classNames;
	
	          var getPrefixCls = _ref3.getPrefixCls;
	          var _this3$props = _this3.props,
	              className = _this3$props.className,
	              customizePrefixCls = _this3$props.prefixCls,
	              title = _this3$props.title,
	              size = _this3$props.size,
	              children = _this3$props.children,
	              _this3$props$bordered = _this3$props.bordered,
	              bordered = _this3$props$bordered === void 0 ? false : _this3$props$bordered,
	              _this3$props$layout = _this3$props.layout,
	              layout = _this3$props$layout === void 0 ? 'horizontal' : _this3$props$layout,
	              _this3$props$colon = _this3$props.colon,
	              colon = _this3$props$colon === void 0 ? true : _this3$props$colon,
	              style = _this3$props.style;
	          var prefixCls = getPrefixCls('descriptions', customizePrefixCls);
	
	          var column = _this3.getColumn();
	
	          var cloneChildren = flattenChildren(children).map(function (child) {
	            if ( /*#__PURE__*/React.isValidElement(child)) {
	              return (/*#__PURE__*/React.cloneElement(child, {
	                  prefixCls: prefixCls
	                })
	              );
	            }
	
	            return null;
	          }).filter(function (node) {
	            return node;
	          });
	          var childrenArray = generateChildrenRows(cloneChildren, column);
	          return (/*#__PURE__*/React.createElement("div", {
	              className: (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), !!bordered), _classNames)),
	              style: style
	            }, title && /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-title")
	            }, title), /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-view")
	            }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, childrenArray.map(function (child, index) {
	              return renderRow(child, index, {
	                prefixCls: prefixCls
	              }, bordered, layout, colon);
	            })))))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Descriptions;
	}(React.Component);
	
	Descriptions.defaultProps = {
	  size: 'default',
	  column: defaultColumnMap
	};
	Descriptions.Item = DescriptionsItem;
	var _default = Descriptions;
	exports["default"] = _default;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Divider = function Divider(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          _props$type = props.type,
	          type = _props$type === void 0 ? 'horizontal' : _props$type,
	          _props$orientation = props.orientation,
	          orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
	          className = props.className,
	          children = props.children,
	          dashed = props.dashed,
	          restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed"]);
	
	      var prefixCls = getPrefixCls('divider', customizePrefixCls);
	      var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
	      var classString = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), children), _defineProperty(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), _classNames));
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString
	        }, restProps, {
	          role: "separator"
	        }), children && /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-inner-text")
	        }, children))
	      );
	    })
	  );
	};
	
	var _default = Divider;
	exports["default"] = _default;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcDrawer = _interopRequireDefault(__webpack_require__(464));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _context = __webpack_require__(242);
	
	var _type = __webpack_require__(82);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var DrawerContext = (0, _createReactContext["default"])(null);
	var PlacementTypes = (0, _type.tuple)('top', 'right', 'bottom', 'left');
	
	var Drawer = /*#__PURE__*/function (_React$Component) {
	  _inherits(Drawer, _React$Component);
	
	  var _super = _createSuper(Drawer);
	
	  function Drawer() {
	    var _this;
	
	    _classCallCheck(this, Drawer);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      push: false
	    };
	
	    _this.push = function () {
	      _this.setState({
	        push: true
	      });
	    };
	
	    _this.pull = function () {
	      _this.setState({
	        push: false
	      });
	    };
	
	    _this.onDestroyTransitionEnd = function () {
	      var isDestroyOnClose = _this.getDestroyOnClose();
	
	      if (!isDestroyOnClose) {
	        return;
	      }
	
	      if (!_this.props.visible) {
	        _this.destroyClose = true;
	
	        _this.forceUpdate();
	      }
	    };
	
	    _this.getDestroyOnClose = function () {
	      return _this.props.destroyOnClose && !_this.props.visible;
	    }; // get drawer push width or height
	
	
	    _this.getPushTransform = function (placement) {
	      if (placement === 'left' || placement === 'right') {
	        return "translateX(".concat(placement === 'left' ? 180 : -180, "px)");
	      }
	
	      if (placement === 'top' || placement === 'bottom') {
	        return "translateY(".concat(placement === 'top' ? 180 : -180, "px)");
	      }
	    };
	
	    _this.getRcDrawerStyle = function () {
	      var _this$props = _this.props,
	          zIndex = _this$props.zIndex,
	          placement = _this$props.placement,
	          style = _this$props.style;
	      var push = _this.state.push;
	      return _extends({
	        zIndex: zIndex,
	        transform: push ? _this.getPushTransform(placement) : undefined
	      }, style);
	    }; // render drawer body dom
	
	
	    _this.renderBody = function () {
	      var _this$props2 = _this.props,
	          bodyStyle = _this$props2.bodyStyle,
	          drawerStyle = _this$props2.drawerStyle,
	          prefixCls = _this$props2.prefixCls,
	          visible = _this$props2.visible;
	
	      if (_this.destroyClose && !visible) {
	        return null;
	      }
	
	      _this.destroyClose = false;
	      var containerStyle = {};
	
	      var isDestroyOnClose = _this.getDestroyOnClose();
	
	      if (isDestroyOnClose) {
	        // Increase the opacity transition, delete children after closing.
	        containerStyle.opacity = 0;
	        containerStyle.transition = 'opacity .3s';
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-wrapper-body"),
	          style: _extends(_extends({}, containerStyle), drawerStyle),
	          onTransitionEnd: _this.onDestroyTransitionEnd
	        }, _this.renderHeader(), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-body"),
	          style: bodyStyle
	        }, _this.props.children))
	      );
	    }; // render Provider for Multi-level drawer
	
	
	    _this.renderProvider = function (value) {
	      var _a = _this.props,
	          prefixCls = _a.prefixCls,
	          placement = _a.placement,
	          className = _a.className,
	          wrapClassName = _a.wrapClassName,
	          width = _a.width,
	          height = _a.height,
	          mask = _a.mask,
	          rest = __rest(_a, ["prefixCls", "placement", "className", "wrapClassName", "width", "height", "mask"]);
	
	      (0, _warning["default"])(wrapClassName === undefined, 'Drawer', 'wrapClassName is deprecated, please use className instead.');
	      var haveMask = mask ? '' : 'no-mask';
	      _this.parentDrawer = value;
	      var offsetStyle = {};
	
	      if (placement === 'left' || placement === 'right') {
	        offsetStyle.width = width;
	      } else {
	        offsetStyle.height = height;
	      }
	
	      return (/*#__PURE__*/React.createElement(DrawerContext.Provider, {
	          value: _assertThisInitialized(_this)
	        }, /*#__PURE__*/React.createElement(_rcDrawer["default"], _extends({
	          handler: false
	        }, (0, _omit["default"])(rest, ['zIndex', 'style', 'closable', 'destroyOnClose', 'drawerStyle', 'headerStyle', 'bodyStyle', 'title', 'push', 'visible', 'getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'pageHeader', 'autoInsertSpaceInButton']), offsetStyle, {
	          prefixCls: prefixCls,
	          open: _this.props.visible,
	          showMask: mask,
	          placement: placement,
	          style: _this.getRcDrawerStyle(),
	          className: (0, _classnames["default"])(wrapClassName, className, haveMask)
	        }), _this.renderBody()))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Drawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // fix: delete drawer in child and re-render, no push started.
	      // <Drawer>{show && <Drawer />}</Drawer>
	      var visible = this.props.visible;
	
	      if (visible && this.parentDrawer) {
	        this.parentDrawer.push();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(preProps) {
	      var visible = this.props.visible;
	
	      if (preProps.visible !== visible && this.parentDrawer) {
	        if (visible) {
	          this.parentDrawer.push();
	        } else {
	          this.parentDrawer.pull();
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // unmount drawer in child, clear push.
	      if (this.parentDrawer) {
	        this.parentDrawer.pull();
	        this.parentDrawer = null;
	      }
	    }
	  }, {
	    key: "renderHeader",
	    value: function renderHeader() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          prefixCls = _this$props3.prefixCls,
	          closable = _this$props3.closable,
	          headerStyle = _this$props3.headerStyle;
	
	      if (!title && !closable) {
	        return null;
	      }
	
	      var headerClassName = title ? "".concat(prefixCls, "-header") : "".concat(prefixCls, "-header-no-title");
	      return (/*#__PURE__*/React.createElement("div", {
	          className: headerClassName,
	          style: headerStyle
	        }, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), closable && this.renderCloseIcon())
	      );
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var _this$props4 = this.props,
	          closable = _this$props4.closable,
	          prefixCls = _this$props4.prefixCls,
	          onClose = _this$props4.onClose;
	      return closable &&
	      /*#__PURE__*/
	      // eslint-disable-next-line react/button-has-type
	      React.createElement("button", {
	        onClick: onClose,
	        "aria-label": "Close",
	        className: "".concat(prefixCls, "-close")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close"
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(DrawerContext.Consumer, null, this.renderProvider)
	      );
	    }
	  }]);
	
	  return Drawer;
	}(React.Component);
	
	Drawer.defaultProps = {
	  width: 256,
	  height: 256,
	  closable: true,
	  placement: 'right',
	  maskClosable: true,
	  mask: true,
	  level: null,
	  keyboard: true
	};
	
	var _default = (0, _context.withConfigConsumer)({
	  prefixCls: 'drawer'
	})(Drawer);
	
	exports["default"] = _default;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _button = _interopRequireDefault(__webpack_require__(136));
	
	var _configProvider = __webpack_require__(14);
	
	var _dropdown = _interopRequireDefault(__webpack_require__(355));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = _button["default"].Group;
	
	var DropdownButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(DropdownButton, _React$Component);
	
	  var _super = _createSuper(DropdownButton);
	
	  function DropdownButton() {
	    var _this;
	
	    _classCallCheck(this, DropdownButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderButton = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          onClick = _a.onClick,
	          htmlType = _a.htmlType,
	          children = _a.children,
	          className = _a.className,
	          overlay = _a.overlay,
	          trigger = _a.trigger,
	          align = _a.align,
	          visible = _a.visible,
	          onVisibleChange = _a.onVisibleChange,
	          placement = _a.placement,
	          getPopupContainer = _a.getPopupContainer,
	          href = _a.href,
	          _a$icon = _a.icon,
	          icon = _a$icon === void 0 ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "ellipsis"
	      }) : _a$icon,
	          title = _a.title,
	          restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title"]);
	
	      var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
	      var dropdownProps = {
	        align: align,
	        overlay: overlay,
	        disabled: disabled,
	        trigger: disabled ? [] : trigger,
	        onVisibleChange: onVisibleChange,
	        placement: placement,
	        getPopupContainer: getPopupContainer || getContextPopupContainer
	      };
	
	      if ('visible' in _this.props) {
	        dropdownProps.visible = visible;
	      }
	
	      return (/*#__PURE__*/React.createElement(ButtonGroup, _extends({}, restProps, {
	          className: (0, _classnames["default"])(prefixCls, className)
	        }), /*#__PURE__*/React.createElement(_button["default"], {
	          type: type,
	          disabled: disabled,
	          onClick: onClick,
	          htmlType: htmlType,
	          href: href,
	          title: title
	        }, children), /*#__PURE__*/React.createElement(_dropdown["default"], dropdownProps, /*#__PURE__*/React.createElement(_button["default"], {
	          type: type
	        }, icon)))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(DropdownButton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton)
	      );
	    }
	  }]);
	
	  return DropdownButton;
	}(React.Component);
	
	exports["default"] = DropdownButton;
	DropdownButton.defaultProps = {
	  placement: 'bottomRight',
	  type: 'default'
	};

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Empty = function Empty() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "184",
	      height: "152",
	      viewBox: "0 0 184 152",
	      xmlns: "http://www.w3.org/2000/svg"
	    }, /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(24 31.67)"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      fillOpacity: ".8",
	      fill: "#F5F5F7",
	      cx: "67.797",
	      cy: "106.89",
	      rx: "67.797",
	      ry: "12.668"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
	      fill: "#AEB8C2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
	      fill: "url(#linearGradient-1)",
	      transform: "translate(13.56)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
	      fill: "#F5F5F7"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
	      fill: "#DCE0E6"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
	      fill: "#DCE0E6"
	    }), /*#__PURE__*/React.createElement("g", {
	      transform: "translate(149.65 15.383)",
	      fill: "#FFF"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      cx: "20.654",
	      cy: "3.167",
	      rx: "2.849",
	      ry: "2.815"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
	    }))))
	  );
	};
	
	var _default = Empty;
	exports["default"] = _default;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Simple = function Simple() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "64",
	      height: "41",
	      viewBox: "0 0 64 41",
	      xmlns: "http://www.w3.org/2000/svg"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 1)",
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      fill: "#F5F5F5",
	      cx: "32",
	      cy: "33",
	      rx: "32",
	      ry: "7"
	    }), /*#__PURE__*/React.createElement("g", {
	      fillRule: "nonzero",
	      stroke: "#D9D9D9"
	    }, /*#__PURE__*/React.createElement("path", {
	      d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
	      fill: "#FAFAFA"
	    }))))
	  );
	};
	
	var _default = Simple;
	exports["default"] = _default;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _createDOMForm = _interopRequireDefault(__webpack_require__(467));
	
	var _createFormField = _interopRequireDefault(__webpack_require__(502));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(14);
	
	var _type = __webpack_require__(82);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _FormItem = _interopRequireDefault(__webpack_require__(1206));
	
	var _constants = __webpack_require__(644);
	
	var _context = _interopRequireDefault(__webpack_require__(645));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var FormLayouts = (0, _type.tuple)('horizontal', 'inline', 'vertical');
	
	var Form = /*#__PURE__*/function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  var _super = _createSuper(Form);
	
	  function Form(props) {
	    var _this;
	
	    _classCallCheck(this, Form);
	
	    _this = _super.call(this, props);
	
	    _this.renderForm = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          hideRequiredMark = _this$props.hideRequiredMark,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          layout = _this$props.layout;
	      var prefixCls = getPrefixCls('form', customizePrefixCls);
	      var formClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-horizontal"), layout === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), layout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-inline"), layout === 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _classNames), className);
	      var formProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark', 'wrapperCol', 'labelAlign', 'labelCol', 'colon']);
	      return (/*#__PURE__*/React.createElement("form", _extends({}, formProps, {
	          className: formClassName
	        }))
	      );
	    };
	
	    (0, _warning["default"])(!props.form, 'Form', 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperCol = _this$props2.wrapperCol,
	          labelAlign = _this$props2.labelAlign,
	          labelCol = _this$props2.labelCol,
	          layout = _this$props2.layout,
	          colon = _this$props2.colon;
	      return (/*#__PURE__*/React.createElement(_context["default"].Provider, {
	          value: {
	            wrapperCol: wrapperCol,
	            labelAlign: labelAlign,
	            labelCol: labelCol,
	            vertical: layout === 'vertical',
	            colon: colon
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderForm))
	      );
	    }
	  }]);
	
	  return Form;
	}(React.Component);
	
	exports["default"] = Form;
	Form.defaultProps = {
	  colon: true,
	  layout: 'horizontal',
	  hideRequiredMark: false,
	  onSubmit: function onSubmit(e) {
	    e.preventDefault();
	  }
	};
	Form.propTypes = {
	  prefixCls: PropTypes.string,
	  layout: PropTypes.oneOf(FormLayouts),
	  children: PropTypes.any,
	  onSubmit: PropTypes.func,
	  hideRequiredMark: PropTypes.bool,
	  colon: PropTypes.bool
	};
	Form.Item = _FormItem["default"];
	Form.createFormField = _createFormField["default"];
	
	Form.create = function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return (0, _createDOMForm["default"])(_extends(_extends({
	    fieldNameProp: 'id'
	  }, options), {
	    fieldMetaProp: _constants.FIELD_META_PROP,
	    fieldDataProp: _constants.FIELD_DATA_PROP
	  }));
	};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _row = _interopRequireDefault(__webpack_require__(648));
	
	var _col = _interopRequireDefault(__webpack_require__(647));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _type = __webpack_require__(82);
	
	var _constants = __webpack_require__(644);
	
	var _context = _interopRequireDefault(__webpack_require__(645));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ValidateStatuses = (0, _type.tuple)('success', 'warning', 'error', 'validating', '');
	var FormLabelAligns = (0, _type.tuple)('left', 'right');
	
	function intersperseSpace(list) {
	  return list.reduce(function (current, item) {
	    return [].concat(_toConsumableArray(current), [' ', item]);
	  }, []).slice(1);
	}
	
	var FormItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(FormItem, _React$Component);
	
	  var _super = _createSuper(FormItem);
	
	  function FormItem() {
	    var _this;
	
	    _classCallCheck(this, FormItem);
	
	    _this = _super.apply(this, arguments);
	    _this.helpShow = false; // Resolve duplicated ids bug between different forms
	    // https://github.com/ant-design/ant-design/issues/7351
	
	    _this.onLabelClick = function () {
	      var id = _this.props.id || _this.getId();
	
	      if (!id) {
	        return;
	      }
	
	      var formItemNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var control = formItemNode.querySelector("[id=\"".concat(id, "\"]"));
	
	      if (control && control.focus) {
	        control.focus();
	      }
	    };
	
	    _this.onHelpAnimEnd = function (_key, helpShow) {
	      _this.helpShow = helpShow;
	
	      if (!helpShow) {
	        _this.setState({});
	      }
	    };
	
	    _this.renderFormItem = function (_ref) {
	      var _itemClassName;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          style = _a.style,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "style", "className"]);
	
	      var prefixCls = getPrefixCls('form', customizePrefixCls);
	
	      var children = _this.renderChildren(prefixCls);
	
	      var itemClassName = (_itemClassName = {}, _defineProperty(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-with-help"), _this.helpShow), _defineProperty(_itemClassName, "".concat(className), !!className), _itemClassName);
	      return (/*#__PURE__*/React.createElement(_row["default"], _extends({
	          className: (0, _classnames["default"])(itemClassName),
	          style: style
	        }, (0, _omit["default"])(restProps, ['id', 'htmlFor', 'label', 'labelAlign', 'labelCol', 'wrapperCol', 'help', 'extra', 'validateStatus', 'hasFeedback', 'required', 'colon']), {
	          key: "row"
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(FormItem, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          help = _this$props.help,
	          validateStatus = _this$props.validateStatus,
	          id = _this$props.id;
	      (0, _warning["default"])(this.getControls(children, true).length <= 1 || help !== undefined || validateStatus !== undefined, 'Form.Item', 'Cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
	      (0, _warning["default"])(!id, 'Form.Item', '`id` is deprecated for its label `htmlFor`. Please use `htmlFor` directly.');
	    }
	  }, {
	    key: "getHelpMessage",
	    value: function getHelpMessage() {
	      var help = this.props.help;
	
	      if (help === undefined && this.getOnlyControl()) {
	        var _this$getField = this.getField(),
	            errors = _this$getField.errors;
	
	        if (errors) {
	          return intersperseSpace(errors.map(function (e, index) {
	            var node = null;
	
	            if ( /*#__PURE__*/React.isValidElement(e)) {
	              node = e;
	            } else if ( /*#__PURE__*/React.isValidElement(e.message)) {
	              node = e.message;
	            } // eslint-disable-next-line react/no-array-index-key
	
	
	            return node ? /*#__PURE__*/React.cloneElement(node, {
	              key: index
	            }) : e.message;
	          }));
	        }
	
	        return '';
	      }
	
	      return help;
	    }
	  }, {
	    key: "getControls",
	    value: function getControls(children, recursively) {
	      var controls = [];
	      var childrenArray = React.Children.toArray(children);
	
	      for (var i = 0; i < childrenArray.length; i++) {
	        if (!recursively && controls.length > 0) {
	          break;
	        }
	
	        var child = childrenArray[i];
	
	        if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
	          continue;
	        }
	
	        if (!child.props) {
	          continue;
	        }
	
	        if (_constants.FIELD_META_PROP in child.props) {
	          // And means FIELD_DATA_PROP in child.props, too.
	          controls.push(child);
	        } else if (child.props.children) {
	          controls = controls.concat(this.getControls(child.props.children, recursively));
	        }
	      }
	
	      return controls;
	    }
	  }, {
	    key: "getOnlyControl",
	    value: function getOnlyControl() {
	      var child = this.getControls(this.props.children, false)[0];
	      return child !== undefined ? child : null;
	    }
	  }, {
	    key: "getChildProp",
	    value: function getChildProp(prop) {
	      var child = this.getOnlyControl();
	      return child && child.props && child.props[prop];
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.getChildProp('id');
	    }
	  }, {
	    key: "getMeta",
	    value: function getMeta() {
	      return this.getChildProp(_constants.FIELD_META_PROP);
	    }
	  }, {
	    key: "getField",
	    value: function getField() {
	      return this.getChildProp(_constants.FIELD_DATA_PROP);
	    }
	  }, {
	    key: "getValidateStatus",
	    value: function getValidateStatus() {
	      var onlyControl = this.getOnlyControl();
	
	      if (!onlyControl) {
	        return '';
	      }
	
	      var field = this.getField();
	
	      if (field.validating) {
	        return 'validating';
	      }
	
	      if (field.errors) {
	        return 'error';
	      }
	
	      var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;
	
	      if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
	        return 'success';
	      }
	
	      return '';
	    }
	  }, {
	    key: "isRequired",
	    value: function isRequired() {
	      var required = this.props.required;
	
	      if (required !== undefined) {
	        return required;
	      }
	
	      if (this.getOnlyControl()) {
	        var meta = this.getMeta() || {};
	        var validate = meta.validate || [];
	        return validate.filter(function (item) {
	          return !!item.rules;
	        }).some(function (item) {
	          return item.rules.some(function (rule) {
	            return rule.required;
	          });
	        });
	      }
	
	      return false;
	    }
	  }, {
	    key: "renderHelp",
	    value: function renderHelp(prefixCls) {
	      var help = this.getHelpMessage();
	      var children = help ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-explain"),
	        key: "help"
	      }, help) : null;
	
	      if (children) {
	        this.helpShow = !!children;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "show-help",
	          component: "",
	          transitionAppear: true,
	          key: "help",
	          onEnd: this.onHelpAnimEnd
	        }, children)
	      );
	    }
	  }, {
	    key: "renderExtra",
	    value: function renderExtra(prefixCls) {
	      var extra = this.props.extra;
	      return extra ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra")
	      }, extra) : null;
	    }
	  }, {
	    key: "renderValidateWrapper",
	    value: function renderValidateWrapper(prefixCls, c1, c2, c3) {
	      var props = this.props;
	      var onlyControl = this.getOnlyControl;
	      var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
	      var classes = "".concat(prefixCls, "-item-control");
	
	      if (validateStatus) {
	        classes = (0, _classnames["default"])("".concat(prefixCls, "-item-control"), {
	          'has-feedback': validateStatus && props.hasFeedback,
	          'has-success': validateStatus === 'success',
	          'has-warning': validateStatus === 'warning',
	          'has-error': validateStatus === 'error',
	          'is-validating': validateStatus === 'validating'
	        });
	      }
	
	      var iconType = '';
	
	      switch (validateStatus) {
	        case 'success':
	          iconType = 'check-circle';
	          break;
	
	        case 'warning':
	          iconType = 'exclamation-circle';
	          break;
	
	        case 'error':
	          iconType = 'close-circle';
	          break;
	
	        case 'validating':
	          iconType = 'loading';
	          break;
	
	        default:
	          iconType = '';
	          break;
	      }
	
	      var icon = props.hasFeedback && iconType ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-children-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType,
	        theme: iconType === 'loading' ? 'outlined' : 'filled'
	      })) : null;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: classes
	        }, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-item-children")
	        }, c1, icon), c2, c3)
	      );
	    }
	  }, {
	    key: "renderWrapper",
	    value: function renderWrapper(prefixCls, children) {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_context["default"].Consumer, {
	          key: "wrapper"
	        }, function (_ref2) {
	          var contextWrapperCol = _ref2.wrapperCol,
	              vertical = _ref2.vertical;
	          var wrapperCol = _this2.props.wrapperCol;
	          var mergedWrapperCol = ('wrapperCol' in _this2.props ? wrapperCol : contextWrapperCol) || {};
	          var className = (0, _classnames["default"])("".concat(prefixCls, "-item-control-wrapper"), mergedWrapperCol.className); // No pass FormContext since it's useless
	
	          return (/*#__PURE__*/React.createElement(_context["default"].Provider, {
	              value: {
	                vertical: vertical
	              }
	            }, /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedWrapperCol, {
	              className: className
	            }), children))
	          );
	        })
	      );
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel(prefixCls) {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_context["default"].Consumer, {
	          key: "label"
	        }, function (_ref3) {
	          var _classNames;
	
	          var vertical = _ref3.vertical,
	              contextLabelAlign = _ref3.labelAlign,
	              contextLabelCol = _ref3.labelCol,
	              contextColon = _ref3.colon;
	          var _this3$props = _this3.props,
	              label = _this3$props.label,
	              labelCol = _this3$props.labelCol,
	              labelAlign = _this3$props.labelAlign,
	              colon = _this3$props.colon,
	              id = _this3$props.id,
	              htmlFor = _this3$props.htmlFor;
	
	          var required = _this3.isRequired();
	
	          var mergedLabelCol = ('labelCol' in _this3.props ? labelCol : contextLabelCol) || {};
	          var mergedLabelAlign = 'labelAlign' in _this3.props ? labelAlign : contextLabelAlign;
	          var labelClsBasic = "".concat(prefixCls, "-item-label");
	          var labelColClassName = (0, _classnames["default"])(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className);
	          var labelChildren = label; // Keep label is original where there should have no colon
	
	          var computedColon = colon === true || contextColon !== false && colon !== false;
	          var haveColon = computedColon && !vertical; // Remove duplicated user input colon
	
	          if (haveColon && typeof label === 'string' && label.trim() !== '') {
	            labelChildren = label.replace(/[：:]\s*$/, '');
	          }
	
	          var labelClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-required"), required), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
	          return label ? /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedLabelCol, {
	            className: labelColClassName
	          }), /*#__PURE__*/React.createElement("label", {
	            htmlFor: htmlFor || id || _this3.getId(),
	            className: labelClassName,
	            title: typeof label === 'string' ? label : '',
	            onClick: _this3.onLabelClick
	          }, labelChildren)) : null;
	        })
	      );
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(prefixCls) {
	      var children = this.props.children;
	      return [this.renderLabel(prefixCls), this.renderWrapper(prefixCls, this.renderValidateWrapper(prefixCls, children, this.renderHelp(prefixCls), this.renderExtra(prefixCls)))];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderFormItem)
	      );
	    }
	  }]);
	
	  return FormItem;
	}(React.Component);
	
	exports["default"] = FormItem;
	FormItem.defaultProps = {
	  hasFeedback: false
	};
	FormItem.propTypes = {
	  prefixCls: PropTypes.string,
	  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	  labelCol: PropTypes.object,
	  help: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
	  validateStatus: PropTypes.oneOf(ValidateStatuses),
	  hasFeedback: PropTypes.bool,
	  wrapperCol: PropTypes.object,
	  className: PropTypes.string,
	  id: PropTypes.string,
	  children: PropTypes.node,
	  colon: PropTypes.bool
	};

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Form = _interopRequireDefault(__webpack_require__(1205));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Form["default"];
	exports["default"] = _default;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = create;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _index = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var customCache = new Set();
	
	function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var scriptUrl = options.scriptUrl,
	      _options$extraCommonP = options.extraCommonProps,
	      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
	  /**
	   * DOM API required.
	   * Make sure in browser environment.
	   * The Custom Icon will create a <script/>
	   * that loads SVG symbols and insert the SVG Element into the document body.
	   */
	
	  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
	    var script = document.createElement('script');
	    script.setAttribute('src', scriptUrl);
	    script.setAttribute('data-namespace', scriptUrl);
	    customCache.add(scriptUrl);
	    document.body.appendChild(script);
	  }
	
	  var Iconfont = function Iconfont(props) {
	    var type = props.type,
	        children = props.children,
	        restProps = __rest(props, ["type", "children"]); // component > children > type
	
	
	    var content = null;
	
	    if (props.type) {
	      content = /*#__PURE__*/React.createElement("use", {
	        xlinkHref: "#".concat(type)
	      });
	    }
	
	    if (children) {
	      content = children;
	    }
	
	    return (/*#__PURE__*/React.createElement(_index["default"], _extends({}, extraCommonProps, restProps), content)
	    );
	  };
	
	  Iconfont.displayName = 'Iconfont';
	  return Iconfont;
	}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTwoToneColor = setTwoToneColor;
	exports.getTwoToneColor = getTwoToneColor;
	
	var _iconsReact = _interopRequireDefault(__webpack_require__(184));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function setTwoToneColor(primaryColor) {
	  return _iconsReact["default"].setTwoToneColors({
	    primaryColor: primaryColor
	  });
	}
	
	function getTwoToneColor() {
	  var colors = _iconsReact["default"].getTwoToneColors();
	
	  return colors.primaryColor;
	}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getThemeFromTypeName = getThemeFromTypeName;
	exports.removeTypeTheme = removeTypeTheme;
	exports.withThemeSuffix = withThemeSuffix;
	exports.alias = alias;
	exports.svgBaseProps = void 0;
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	// These props make sure that the SVG behaviours like general text.
	// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
	var svgBaseProps = {
	  width: '1em',
	  height: '1em',
	  fill: 'currentColor',
	  'aria-hidden': true,
	  focusable: 'false'
	};
	exports.svgBaseProps = svgBaseProps;
	var fillTester = /-fill$/;
	var outlineTester = /-o$/;
	var twoToneTester = /-twotone$/;
	
	function getThemeFromTypeName(type) {
	  var result = null;
	
	  if (fillTester.test(type)) {
	    result = 'filled';
	  } else if (outlineTester.test(type)) {
	    result = 'outlined';
	  } else if (twoToneTester.test(type)) {
	    result = 'twoTone';
	  }
	
	  return result;
	}
	
	function removeTypeTheme(type) {
	  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
	}
	
	function withThemeSuffix(type, theme) {
	  var result = type;
	
	  if (theme === 'filled') {
	    result += '-fill';
	  } else if (theme === 'outlined') {
	    result += '-o';
	  } else if (theme === 'twoTone') {
	    result += '-twotone';
	  } else {
	    (0, _warning["default"])(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
	  }
	
	  return result;
	} // For alias or compatibility
	
	
	function alias(type) {
	  var newType = type;
	
	  switch (type) {
	    case 'cross':
	      newType = 'close';
	      break;
	    // https://github.com/ant-design/ant-design/issues/13007
	
	    case 'interation':
	      newType = 'interaction';
	      break;
	    // https://github.com/ant-design/ant-design/issues/16810
	
	    case 'canlendar':
	      newType = 'calendar';
	      break;
	    // https://github.com/ant-design/ant-design/issues/17448
	
	    case 'colum-height':
	      newType = 'column-height';
	      break;
	
	    default:
	  }
	
	  (0, _warning["default"])(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
	  return newType;
	}

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _rcInputNumber = _interopRequireDefault(__webpack_require__(468));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var InputNumber = /*#__PURE__*/function (_React$Component) {
	  _inherits(InputNumber, _React$Component);
	
	  var _super = _createSuper(InputNumber);
	
	  function InputNumber() {
	    var _this;
	
	    _classCallCheck(this, InputNumber);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInputNumber = function (inputNumberRef) {
	      _this.inputNumberRef = inputNumberRef;
	    };
	
	    _this.renderInputNumber = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          className = _a.className,
	          size = _a.size,
	          customizePrefixCls = _a.prefixCls,
	          others = __rest(_a, ["className", "size", "prefixCls"]);
	
	      var prefixCls = getPrefixCls('input-number', customizePrefixCls);
	      var inputNumberClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className);
	      var upIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "up",
	        className: "".concat(prefixCls, "-handler-up-inner")
	      });
	      var downIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-handler-down-inner")
	      });
	      return (/*#__PURE__*/React.createElement(_rcInputNumber["default"], _extends({
	          ref: _this.saveInputNumber,
	          className: inputNumberClass,
	          upHandler: upIcon,
	          downHandler: downIcon,
	          prefixCls: prefixCls
	        }, others))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(InputNumber, [{
	    key: "focus",
	    value: function focus() {
	      this.inputNumberRef.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.inputNumberRef.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderInputNumber)
	      );
	    }
	  }]);
	
	  return InputNumber;
	}(React.Component);
	
	exports["default"] = InputNumber;
	InputNumber.defaultProps = {
	  step: 1
	};

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var Group = function Group(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var customizePrefixCls = props.prefixCls,
	          _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className;
	      var prefixCls = getPrefixCls('input-group', customizePrefixCls);
	      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
	      return (/*#__PURE__*/React.createElement("span", {
	          className: cls,
	          style: props.style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave,
	          onFocus: props.onFocus,
	          onBlur: props.onBlur
	        }, props.children)
	      );
	    })
	  );
	};
	
	var _default = Group;
	exports["default"] = _default;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Input = _interopRequireDefault(__webpack_require__(201));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ActionMap = {
	  click: 'onClick',
	  hover: 'onMouseOver'
	};
	
	var Password = /*#__PURE__*/function (_React$Component) {
	  _inherits(Password, _React$Component);
	
	  var _super = _createSuper(Password);
	
	  function Password() {
	    var _this;
	
	    _classCallCheck(this, Password);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      visible: false
	    };
	
	    _this.onVisibleChange = function () {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setState(function (_ref) {
	        var visible = _ref.visible;
	        return {
	          visible: !visible
	        };
	      });
	    };
	
	    _this.saveInput = function (instance) {
	      if (instance && instance.input) {
	        _this.input = instance.input;
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Password, [{
	    key: "getIcon",
	    value: function getIcon() {
	      var _iconProps;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          action = _this$props.action;
	      var iconTrigger = ActionMap[action] || '';
	      var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, this.onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "type", this.state.visible ? 'eye' : 'eye-invisible'), _defineProperty(_iconProps, "key", 'passwordIcon'), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
	        // Prevent focused state lost
	        // https://github.com/ant-design/ant-design/issues/15173
	        e.preventDefault();
	      }), _iconProps);
	      return (/*#__PURE__*/React.createElement(_icon["default"], iconProps)
	      );
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          inputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          visibilityToggle = _a.visibilityToggle,
	          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);
	
	      var suffixIcon = visibilityToggle && this.getIcon();
	      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	      return (/*#__PURE__*/React.createElement(_Input["default"], _extends({}, (0, _omit["default"])(restProps, ['suffix']), {
	          type: this.state.visible ? 'text' : 'password',
	          size: size,
	          className: inputClassName,
	          prefixCls: inputPrefixCls,
	          suffix: suffixIcon,
	          ref: this.saveInput
	        }))
	      );
	    }
	  }]);
	
	  return Password;
	}(React.Component);
	
	exports["default"] = Password;
	Password.defaultProps = {
	  inputPrefixCls: 'ant-input',
	  prefixCls: 'ant-input-password',
	  action: 'click',
	  visibilityToggle: true
	};

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(1216));
	
	var _raf = _interopRequireDefault(__webpack_require__(200));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ResizableTextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(ResizableTextArea, _React$Component);
	
	  var _super = _createSuper(ResizableTextArea);
	
	  function ResizableTextArea(props) {
	    var _this;
	
	    _classCallCheck(this, ResizableTextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (textArea) {
	      _this.textArea = textArea;
	    };
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.nextFrameActionId);
	
	      _this.nextFrameActionId = (0, _raf["default"])(_this.resizeTextarea);
	    };
	
	    _this.resizeTextarea = function () {
	      var autoSize = _this.props.autoSize || _this.props.autosize;
	
	      if (!autoSize || !_this.textArea) {
	        return;
	      }
	
	      var minRows = autoSize.minRows,
	          maxRows = autoSize.maxRows;
	      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textArea, false, minRows, maxRows);
	
	      _this.setState({
	        textareaStyles: textareaStyles,
	        resizing: true
	      }, function () {
	        _raf["default"].cancel(_this.resizeFrameId);
	
	        _this.resizeFrameId = (0, _raf["default"])(function () {
	          _this.setState({
	            resizing: false
	          });
	
	          _this.fixFirefoxAutoScroll();
	        });
	      });
	    };
	
	    _this.renderTextArea = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          autoSize = _this$props.autoSize,
	          autosize = _this$props.autosize,
	          className = _this$props.className,
	          disabled = _this$props.disabled;
	      var _this$state = _this.state,
	          textareaStyles = _this$state.textareaStyles,
	          resizing = _this$state.resizing;
	      (0, _warning["default"])(autosize === undefined, 'Input.TextArea', 'autosize is deprecated, please use autoSize instead.');
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'autosize', 'defaultValue', 'allowClear']);
	      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
	      // Make sure it could be reset when using form.getFieldDecorator
	
	      if ('value' in otherProps) {
	        otherProps.value = otherProps.value || '';
	      }
	
	      var style = _extends(_extends(_extends({}, _this.props.style), textareaStyles), resizing ? {
	        overflowX: 'hidden',
	        overflowY: 'hidden'
	      } : null);
	
	      return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: _this.resizeOnNextFrame,
	          disabled: !(autoSize || autosize)
	        }, /*#__PURE__*/React.createElement("textarea", _extends({}, otherProps, {
	          className: cls,
	          style: style,
	          ref: _this.saveTextArea
	        })))
	      );
	    };
	
	    _this.state = {
	      textareaStyles: {},
	      resizing: false
	    };
	    return _this;
	  }
	
	  _createClass(ResizableTextArea, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resizeTextarea();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // Re-render with the new content then recalculate the height as required.
	      if (prevProps.value !== this.props.value) {
	        this.resizeTextarea();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.nextFrameActionId);
	
	      _raf["default"].cancel(this.resizeFrameId);
	    } // https://github.com/ant-design/ant-design/issues/21870
	
	  }, {
	    key: "fixFirefoxAutoScroll",
	    value: function fixFirefoxAutoScroll() {
	      try {
	        if (document.activeElement === this.textArea) {
	          var currentStart = this.textArea.selectionStart;
	          var currentEnd = this.textArea.selectionEnd;
	          this.textArea.setSelectionRange(currentStart, currentEnd);
	        }
	      } catch (e) {// Fix error in Chrome:
	        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
	        // http://stackoverflow.com/q/21177489/3040605
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderTextArea();
	    }
	  }]);
	
	  return ResizableTextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ResizableTextArea);
	var _default = ResizableTextArea;
	exports["default"] = _default;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _isMobile = __webpack_require__(510);
	
	var _Input = _interopRequireDefault(__webpack_require__(201));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _button = _interopRequireDefault(__webpack_require__(136));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.onChange = function (e) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onSearch = _this$props.onSearch;
	
	      if (e && e.target && e.type === 'click' && onSearch) {
	        onSearch(e.target.value, e);
	      }
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.onSearch = function (e) {
	      var _this$props2 = _this.props,
	          onSearch = _this$props2.onSearch,
	          loading = _this$props2.loading,
	          disabled = _this$props2.disabled;
	
	      if (loading || disabled) {
	        return;
	      }
	
	      if (onSearch) {
	        onSearch(_this.input.input.value, e);
	      }
	
	      if (!(0, _isMobile.isMobile)({
	        tablet: true
	      })) {
	        _this.input.focus();
	      }
	    };
	
	    _this.renderLoading = function (prefixCls) {
	      var _this$props3 = _this.props,
	          enterButton = _this$props3.enterButton,
	          size = _this$props3.size;
	
	      if (enterButton) {
	        return (/*#__PURE__*/React.createElement(_button["default"], {
	            className: "".concat(prefixCls, "-button"),
	            type: "primary",
	            size: size,
	            key: "enterButton"
	          }, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading"
	          }))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          className: "".concat(prefixCls, "-icon"),
	          type: "loading",
	          key: "loadingIcon"
	        })
	      );
	    };
	
	    _this.renderSuffix = function (prefixCls) {
	      var _this$props4 = _this.props,
	          suffix = _this$props4.suffix,
	          enterButton = _this$props4.enterButton,
	          loading = _this$props4.loading;
	
	      if (loading && !enterButton) {
	        return [suffix, _this.renderLoading(prefixCls)];
	      }
	
	      if (enterButton) return suffix;
	      var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: "search",
	        key: "searchIcon",
	        onClick: _this.onSearch
	      });
	
	      if (suffix) {
	        return [/*#__PURE__*/React.isValidElement(suffix) ? /*#__PURE__*/React.cloneElement(suffix, {
	          key: 'suffix'
	        }) : null, icon];
	      }
	
	      return icon;
	    };
	
	    _this.renderAddonAfter = function (prefixCls) {
	      var _this$props5 = _this.props,
	          enterButton = _this$props5.enterButton,
	          size = _this$props5.size,
	          disabled = _this$props5.disabled,
	          addonAfter = _this$props5.addonAfter,
	          loading = _this$props5.loading;
	      var btnClassName = "".concat(prefixCls, "-button");
	
	      if (loading && enterButton) {
	        return [_this.renderLoading(prefixCls), addonAfter];
	      }
	
	      if (!enterButton) return addonAfter;
	      var button;
	      var enterButtonAsElement = enterButton;
	      var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
	
	      if (isAntdButton || enterButtonAsElement.type === 'button') {
	        button = /*#__PURE__*/React.cloneElement(enterButtonAsElement, _extends({
	          onClick: _this.onSearch,
	          key: 'enterButton'
	        }, isAntdButton ? {
	          className: btnClassName,
	          size: size
	        } : {}));
	      } else {
	        button = /*#__PURE__*/React.createElement(_button["default"], {
	          className: btnClassName,
	          type: "primary",
	          size: size,
	          disabled: disabled,
	          key: "enterButton",
	          onClick: _this.onSearch
	        }, enterButton === true ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "search"
	        }) : enterButton);
	      }
	
	      if (addonAfter) {
	        return [button, /*#__PURE__*/React.isValidElement(addonAfter) ? /*#__PURE__*/React.cloneElement(addonAfter, {
	          key: 'addonAfter'
	        }) : null];
	      }
	
	      return button;
	    };
	
	    _this.renderSearch = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeInputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          enterButton = _a.enterButton,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "inputPrefixCls", "size", "enterButton", "className"]);
	
	      delete restProps.onSearch;
	      delete restProps.loading;
	      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var inputClassName;
	
	      if (enterButton) {
	        var _classNames;
	
	        inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
	      } else {
	        inputClassName = (0, _classnames["default"])(prefixCls, className);
	      }
	
	      return (/*#__PURE__*/React.createElement(_Input["default"], _extends({
	          onPressEnter: _this.onSearch
	        }, restProps, {
	          size: size,
	          prefixCls: inputPrefixCls,
	          addonAfter: _this.renderAddonAfter(prefixCls),
	          suffix: _this.renderSuffix(prefixCls),
	          onChange: _this.onChange,
	          ref: _this.saveInput,
	          className: inputClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch)
	      );
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  enterButton: false
	};

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateNodeStyling = calculateNodeStyling;
	exports["default"] = calculateNodeHeight;
	// Thanks to https://github.com/andreypopp/react-textarea-autosize/
	
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	var computedStyleCache = {};
	var hiddenTextarea;
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	  var sizingStyle = SIZING_STYLE.map(function (name) {
	    return "".concat(name, ":").concat(style.getPropertyValue(name));
	  }).join(';');
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  } // Fix wrap="off" issue
	  // https://github.com/ant-design/ant-design/issues/6577
	
	
	  if (uiTextNode.getAttribute('wrap')) {
	    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
	  } else {
	    hiddenTextarea.removeAttribute('wrap');
	  } // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	
	  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
	  var minHeight = Number.MIN_SAFE_INTEGER;
	  var maxHeight = Number.MAX_SAFE_INTEGER;
	  var height = hiddenTextarea.scrollHeight;
	  var overflowY;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height += borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height -= paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = ' ';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	
	      height = Math.max(minHeight, height);
	    }
	
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	
	      overflowY = height > maxHeight ? '' : 'hidden';
	      height = Math.min(maxHeight, height);
	    }
	  }
	
	  return {
	    height: height,
	    minHeight: minHeight,
	    maxHeight: maxHeight,
	    overflowY: overflowY
	  };
	}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _layout = _interopRequireDefault(__webpack_require__(651));
	
	var _Sider = _interopRequireDefault(__webpack_require__(357));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_layout["default"].Sider = _Sider["default"];
	var _default = _layout["default"];
	exports["default"] = _default;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Meta = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _grid = __webpack_require__(243);
	
	var _configProvider = __webpack_require__(14);
	
	var _reactNode = __webpack_require__(631);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Meta = function Meta(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          avatar = props.avatar,
	          title = props.title,
	          description = props.description,
	          others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-item-meta"), className);
	      var content = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-meta-content")
	      }, title && /*#__PURE__*/React.createElement("h4", {
	        className: "".concat(prefixCls, "-item-meta-title")
	      }, title), description && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-meta-description")
	      }, description));
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }), avatar && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-meta-avatar")
	        }, avatar), (title || description) && content)
	      );
	    })
	  );
	};
	
	exports.Meta = Meta;
	
	function getGrid(grid, t) {
	  return grid[t] && Math.floor(24 / grid[t]);
	}
	
	var Item = /*#__PURE__*/function (_React$Component) {
	  _inherits(Item, _React$Component);
	
	  var _super = _createSuper(Item);
	
	  function Item() {
	    var _this;
	
	    _classCallCheck(this, Item);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderItem = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	      var _this$context = _this.context,
	          grid = _this$context.grid,
	          itemLayout = _this$context.itemLayout;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          children = _a.children,
	          actions = _a.actions,
	          extra = _a.extra,
	          className = _a.className,
	          others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var actionsContent = actions && actions.length > 0 && /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-item-action"),
	        key: "actions"
	      }, actions.map(function (action, i) {
	        return (
	          /*#__PURE__*/
	          // eslint-disable-next-line react/no-array-index-key
	          React.createElement("li", {
	            key: "".concat(prefixCls, "-item-action-").concat(i)
	          }, action, i !== actions.length - 1 && /*#__PURE__*/React.createElement("em", {
	            className: "".concat(prefixCls, "-item-action-split")
	          }))
	        );
	      }));
	      var Tag = grid ? 'div' : 'li';
	      var itemChildren = /*#__PURE__*/React.createElement(Tag, _extends({}, others, {
	        // `li` element `onCopy` prop args is not same as `div`
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className, _defineProperty({}, "".concat(prefixCls, "-item-no-flex"), !_this.isFlexMode()))
	      }), itemLayout === 'vertical' && extra ? [/*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-main"),
	        key: "content"
	      }, children, actionsContent), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-extra"),
	        key: "extra"
	      }, extra)] : [children, actionsContent, (0, _reactNode.cloneElement)(extra, {
	        key: 'extra'
	      })]);
	      return grid ? /*#__PURE__*/React.createElement(_grid.Col, {
	        span: getGrid(grid, 'column'),
	        xs: getGrid(grid, 'xs'),
	        sm: getGrid(grid, 'sm'),
	        md: getGrid(grid, 'md'),
	        lg: getGrid(grid, 'lg'),
	        xl: getGrid(grid, 'xl'),
	        xxl: getGrid(grid, 'xxl')
	      }, itemChildren) : itemChildren;
	    };
	
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: "isItemContainsTextNodeAndNotSingular",
	    value: function isItemContainsTextNodeAndNotSingular() {
	      var children = this.props.children;
	      var result;
	      React.Children.forEach(children, function (element) {
	        if (typeof element === 'string') {
	          result = true;
	        }
	      });
	      return result && React.Children.count(children) > 1;
	    }
	  }, {
	    key: "isFlexMode",
	    value: function isFlexMode() {
	      var extra = this.props.extra;
	      var itemLayout = this.context.itemLayout;
	
	      if (itemLayout === 'vertical') {
	        return !!extra;
	      }
	
	      return !this.isItemContainsTextNodeAndNotSingular();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderItem)
	      );
	    }
	  }]);
	
	  return Item;
	}(React.Component);
	
	exports["default"] = Item;
	Item.Meta = Meta;
	Item.contextTypes = {
	  grid: PropTypes.any,
	  itemLayout: PropTypes.string
	};

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _spin = _interopRequireDefault(__webpack_require__(246));
	
	var _configProvider = __webpack_require__(14);
	
	var _pagination = _interopRequireDefault(__webpack_require__(361));
	
	var _grid = __webpack_require__(243);
	
	var _Item = _interopRequireDefault(__webpack_require__(1218));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var List = /*#__PURE__*/function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  var _super = _createSuper(List);
	
	  function List(props) {
	    var _this;
	
	    _classCallCheck(this, List);
	
	    _this = _super.call(this, props);
	    _this.defaultPaginationProps = {
	      current: 1,
	      total: 0
	    };
	    _this.keys = {};
	    _this.onPaginationChange = _this.triggerPaginationEvent('onChange');
	    _this.onPaginationShowSizeChange = _this.triggerPaginationEvent('onShowSizeChange');
	
	    _this.renderItem = function (item, index) {
	      var _this$props = _this.props,
	          renderItem = _this$props.renderItem,
	          rowKey = _this$props.rowKey;
	      if (!renderItem) return null;
	      var key;
	
	      if (typeof rowKey === 'function') {
	        key = rowKey(item);
	      } else if (typeof rowKey === 'string') {
	        key = item[rowKey];
	      } else {
	        key = item.key;
	      }
	
	      if (!key) {
	        key = "list-item-".concat(index);
	      }
	
	      _this.keys[index] = key;
	      return renderItem(item, index);
	    };
	
	    _this.renderEmpty = function (prefixCls, renderEmpty) {
	      var locale = _this.props.locale;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-empty-text")
	        }, locale && locale.emptyText || renderEmpty('List'))
	      );
	    };
	
	    _this.renderList = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	      var _this$state = _this.state,
	          paginationCurrent = _this$state.paginationCurrent,
	          paginationSize = _this$state.paginationSize;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          bordered = _a.bordered,
	          split = _a.split,
	          className = _a.className,
	          children = _a.children,
	          itemLayout = _a.itemLayout,
	          loadMore = _a.loadMore,
	          pagination = _a.pagination,
	          grid = _a.grid,
	          _a$dataSource = _a.dataSource,
	          dataSource = _a$dataSource === void 0 ? [] : _a$dataSource,
	          size = _a.size,
	          header = _a.header,
	          footer = _a.footer,
	          loading = _a.loading,
	          rest = __rest(_a, ["prefixCls", "bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "grid", "dataSource", "size", "header", "footer", "loading"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var loadingProp = loading;
	
	      if (typeof loadingProp === 'boolean') {
	        loadingProp = {
	          spinning: loadingProp
	        };
	      }
	
	      var isLoading = loadingProp && loadingProp.spinning; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-split"), split), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), isLoading), _defineProperty(_classNames, "".concat(prefixCls, "-grid"), grid), _defineProperty(_classNames, "".concat(prefixCls, "-something-after-last-item"), _this.isSomethingAfterLastItem()), _classNames));
	
	      var paginationProps = _extends(_extends(_extends({}, _this.defaultPaginationProps), {
	        total: dataSource.length,
	        current: paginationCurrent,
	        pageSize: paginationSize
	      }), pagination || {});
	
	      var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
	
	      if (paginationProps.current > largestPage) {
	        paginationProps.current = largestPage;
	      }
	
	      var paginationContent = pagination ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-pagination")
	      }, /*#__PURE__*/React.createElement(_pagination["default"], _extends({}, paginationProps, {
	        onChange: _this.onPaginationChange,
	        onShowSizeChange: _this.onPaginationShowSizeChange
	      }))) : null;
	
	      var splitDataSource = _toConsumableArray(dataSource);
	
	      if (pagination) {
	        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
	          splitDataSource = _toConsumableArray(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
	        }
	      }
	
	      var childrenContent;
	      childrenContent = isLoading && /*#__PURE__*/React.createElement("div", {
	        style: {
	          minHeight: 53
	        }
	      });
	
	      if (splitDataSource.length > 0) {
	        var items = splitDataSource.map(function (item, index) {
	          return _this.renderItem(item, index);
	        });
	        var childrenList = [];
	        React.Children.forEach(items, function (child, index) {
	          childrenList.push( /*#__PURE__*/React.cloneElement(child, {
	            key: _this.keys[index]
	          }));
	        });
	        childrenContent = grid ? /*#__PURE__*/React.createElement(_grid.Row, {
	          gutter: grid.gutter
	        }, childrenList) : /*#__PURE__*/React.createElement("ul", {
	          className: "".concat(prefixCls, "-items")
	        }, childrenList);
	      } else if (!children && !isLoading) {
	        childrenContent = _this.renderEmpty(prefixCls, renderEmpty);
	      }
	
	      var paginationPosition = paginationProps.position || 'bottom';
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString
	        }, (0, _omit["default"])(rest, ['rowKey', 'renderItem', 'locale'])), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-header")
	        }, header), /*#__PURE__*/React.createElement(_spin["default"], loadingProp, childrenContent, children), footer && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-footer")
	        }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent)
	      );
	    };
	
	    var pagination = props.pagination;
	    var paginationObj = pagination && _typeof(pagination) === 'object' ? pagination : {};
	    _this.state = {
	      paginationCurrent: paginationObj.defaultCurrent || 1,
	      paginationSize: paginationObj.defaultPageSize || 10
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        grid: this.props.grid,
	        itemLayout: this.props.itemLayout
	      };
	    }
	  }, {
	    key: "triggerPaginationEvent",
	    value: function triggerPaginationEvent(eventName) {
	      var _this2 = this;
	
	      return function (page, pageSize) {
	        var pagination = _this2.props.pagination;
	
	        _this2.setState({
	          paginationCurrent: page,
	          paginationSize: pageSize
	        });
	
	        if (pagination && pagination[eventName]) {
	          pagination[eventName](page, pageSize);
	        }
	      };
	    }
	  }, {
	    key: "isSomethingAfterLastItem",
	    value: function isSomethingAfterLastItem() {
	      var _this$props2 = this.props,
	          loadMore = _this$props2.loadMore,
	          pagination = _this$props2.pagination,
	          footer = _this$props2.footer;
	      return !!(loadMore || pagination || footer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderList)
	      );
	    }
	  }]);
	
	  return List;
	}(React.Component);
	
	exports["default"] = List;
	List.Item = _Item["default"];
	List.childContextTypes = {
	  grid: PropTypes.any,
	  itemLayout: PropTypes.string
	};
	List.defaultProps = {
	  dataSource: [],
	  bordered: false,
	  split: true,
	  loading: false,
	  pagination: false
	};

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _default2 = _interopRequireDefault(__webpack_require__(157));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _default2["default"];
	exports["default"] = _default;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcEditorMention = _interopRequireWildcard(__webpack_require__(466));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Mention = /*#__PURE__*/function (_React$Component) {
	  _inherits(Mention, _React$Component);
	
	  var _super = _createSuper(Mention);
	
	  function Mention(props) {
	    var _this;
	
	    _classCallCheck(this, Mention);
	
	    _this = _super.call(this, props);
	
	    _this.mentionRef = function (ele) {
	      _this.mentionEle = ele;
	    };
	
	    _this.onSearchChange = function (value, prefix) {
	      if (_this.props.onSearchChange) {
	        return _this.props.onSearchChange(value, prefix);
	      }
	
	      return _this.defaultSearchChange(value);
	    };
	
	    _this.onChange = function (editorState) {
	      if (_this.props.onChange) {
	        _this.props.onChange(editorState);
	      }
	    };
	
	    _this.onFocus = function (ev) {
	      _this.setState({
	        focus: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(ev);
	      }
	    };
	
	    _this.onBlur = function (ev) {
	      _this.setState({
	        focus: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(ev);
	      }
	    };
	
	    _this.focus = function () {
	      _this.mentionEle._editor.focusEditor();
	    };
	
	    _this.renderMention = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          loading = _this$props.loading,
	          placement = _this$props.placement,
	          suggestions = _this$props.suggestions;
	      var _this$state = _this.state,
	          filteredSuggestions = _this$state.filteredSuggestions,
	          focus = _this$state.focus;
	      var prefixCls = getPrefixCls('mention', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-active"), focus), _defineProperty(_classNames, "".concat(prefixCls, "-placement-top"), placement === 'top'), _classNames));
	      var notFoundContent = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "loading"
	      }) : _this.props.notFoundContent;
	      return (/*#__PURE__*/React.createElement(_rcEditorMention["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: cls,
	          ref: _this.mentionRef,
	          onSearchChange: _this.onSearchChange,
	          onChange: _this.onChange,
	          onFocus: _this.onFocus,
	          onBlur: _this.onBlur,
	          suggestions: suggestions || filteredSuggestions,
	          notFoundContent: notFoundContent
	        }))
	      );
	    };
	
	    _this.state = {
	      filteredSuggestions: props.defaultSuggestions,
	      focus: false
	    };
	    (0, _warning["default"])(false, 'Mention', 'Mention component is deprecated. Please use Mentions component instead.');
	    return _this;
	  }
	
	  _createClass(Mention, [{
	    key: "defaultSearchChange",
	    value: function defaultSearchChange(value) {
	      var searchValue = value.toLowerCase();
	      var filteredSuggestions = (this.props.defaultSuggestions || []).filter(function (suggestion) {
	        if (typeof suggestion === 'string') {
	          return suggestion.toLowerCase().indexOf(searchValue) !== -1;
	        }
	
	        if (suggestion.type && suggestion.type === _rcEditorMention.Nav) {
	          return suggestion.props.value ? suggestion.props.value.toLowerCase().indexOf(searchValue) !== -1 : true;
	        }
	
	        return false;
	      });
	      this.setState({
	        filteredSuggestions: filteredSuggestions
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMention)
	      );
	    }
	  }]);
	
	  return Mention;
	}(React.Component);
	
	Mention.getMentions = _rcEditorMention.getMentions;
	Mention.defaultProps = {
	  notFoundContent: 'No matches found',
	  loading: false,
	  multiLines: false,
	  placement: 'bottom'
	};
	Mention.Nav = _rcEditorMention.Nav;
	Mention.toString = _rcEditorMention.toString;
	Mention.toContentState = _rcEditorMention.toEditorState;
	(0, _reactLifecyclesCompat.polyfill)(Mention);
	var _default = Mention;
	exports["default"] = _default;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcMentions = _interopRequireDefault(__webpack_require__(469));
	
	var _spin = _interopRequireDefault(__webpack_require__(246));
	
	var _configProvider = __webpack_require__(14);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Option = _rcMentions["default"].Option;
	
	function loadingFilterOption() {
	  return true;
	}
	
	var Mentions = /*#__PURE__*/function (_React$Component) {
	  _inherits(Mentions, _React$Component);
	
	  var _super = _createSuper(Mentions);
	
	  function Mentions() {
	    var _this;
	
	    _classCallCheck(this, Mentions);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      focused: false
	    };
	
	    _this.onFocus = function () {
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) {
	        onFocus.apply(void 0, arguments);
	      }
	
	      _this.setState({
	        focused: true
	      });
	    };
	
	    _this.onBlur = function () {
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) {
	        onBlur.apply(void 0, arguments);
	      }
	
	      _this.setState({
	        focused: false
	      });
	    };
	
	    _this.getOptions = function () {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          loading = _this$props.loading;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(Option, {
	            value: "ANTD_SEARCHING",
	            disabled: true
	          }, /*#__PURE__*/React.createElement(_spin["default"], {
	            size: "small"
	          }))
	        );
	      }
	
	      return children;
	    };
	
	    _this.getFilterOption = function () {
	      var _this$props2 = _this.props,
	          filterOption = _this$props2.filterOption,
	          loading = _this$props2.loading;
	
	      if (loading) {
	        return loadingFilterOption;
	      }
	
	      return filterOption;
	    };
	
	    _this.saveMentions = function (node) {
	      _this.rcMentions = node;
	    };
	
	    _this.renderMentions = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	      var focused = _this.state.focused;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          disabled = _a.disabled,
	          restProps = __rest(_a, ["prefixCls", "className", "disabled"]);
	
	      var prefixCls = getPrefixCls('mentions', customizePrefixCls);
	      var mentionsProps = (0, _omit["default"])(restProps, ['loading']);
	      var mergedClassName = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-focused"), focused), _classNames));
	      return (/*#__PURE__*/React.createElement(_rcMentions["default"], _extends({
	          prefixCls: prefixCls,
	          notFoundContent: _this.getNotFoundContent(renderEmpty),
	          className: mergedClassName,
	          disabled: disabled
	        }, mentionsProps, {
	          filterOption: _this.getFilterOption(),
	          onFocus: _this.onFocus,
	          onBlur: _this.onBlur,
	          ref: _this.saveMentions
	        }), _this.getOptions())
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Mentions, [{
	    key: "getNotFoundContent",
	    value: function getNotFoundContent(renderEmpty) {
	      var notFoundContent = this.props.notFoundContent;
	
	      if (notFoundContent !== undefined) {
	        return notFoundContent;
	      }
	
	      return renderEmpty('Select');
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcMentions.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcMentions.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMentions)
	      );
	    }
	  }]);
	
	  return Mentions;
	}(React.Component);
	
	Mentions.Option = Option;
	
	Mentions.getMentions = function () {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var config = arguments.length > 1 ? arguments[1] : undefined;
	
	  var _ref2 = config || {},
	      _ref2$prefix = _ref2.prefix,
	      prefix = _ref2$prefix === void 0 ? '@' : _ref2$prefix,
	      _ref2$split = _ref2.split,
	      split = _ref2$split === void 0 ? ' ' : _ref2$split;
	
	  var prefixList = Array.isArray(prefix) ? prefix : [prefix];
	  return value.split(split).map(function () {
	    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var hitPrefix = null;
	    prefixList.some(function (prefixStr) {
	      var startStr = str.slice(0, prefixStr.length);
	
	      if (startStr === prefixStr) {
	        hitPrefix = prefixStr;
	        return true;
	      }
	
	      return false;
	    });
	
	    if (hitPrefix !== null) {
	      return {
	        prefix: hitPrefix,
	        value: str.slice(hitPrefix.length)
	      };
	    }
	
	    return null;
	  }).filter(function (entity) {
	    return !!entity && !!entity.value;
	  });
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Mentions);
	var _default = Mentions;
	exports["default"] = _default;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcMenu = __webpack_require__(93);
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(358));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(124));
	
	var _Sider = __webpack_require__(357);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var MenuItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  var _super = _createSuper(MenuItem);
	
	  function MenuItem() {
	    var _this;
	
	    _classCallCheck(this, MenuItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.menuItem.onKeyDown(e);
	    };
	
	    _this.saveMenuItem = function (menuItem) {
	      _this.menuItem = menuItem;
	    };
	
	    _this.renderItem = function (_ref) {
	      var siderCollapsed = _ref.siderCollapsed;
	      var _this$props = _this.props,
	          level = _this$props.level,
	          children = _this$props.children,
	          rootPrefixCls = _this$props.rootPrefixCls;
	
	      var _a = _this.props,
	          title = _a.title,
	          rest = __rest(_a, ["title"]);
	
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref2) {
	          var inlineCollapsed = _ref2.inlineCollapsed;
	          var tooltipProps = {
	            title: title || (level === 1 ? children : '')
	          };
	
	          if (!siderCollapsed && !inlineCollapsed) {
	            tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct
	            // ref: https://github.com/ant-design/ant-design/issues/16742
	
	            tooltipProps.visible = false;
	          }
	
	          return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, tooltipProps, {
	              placement: "right",
	              overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
	            }), /*#__PURE__*/React.createElement(_rcMenu.Item, _extends({}, rest, {
	              title: title,
	              ref: _this.saveMenuItem
	            })))
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, this.renderItem)
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(React.Component);
	
	exports["default"] = MenuItem;
	MenuItem.isMenuItem = true;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcMenu = __webpack_require__(93);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(358));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var SubMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(SubMenu, _React$Component);
	
	  var _super = _createSuper(SubMenu);
	
	  function SubMenu() {
	    var _this;
	
	    _classCallCheck(this, SubMenu);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.subMenu.onKeyDown(e);
	    };
	
	    _this.saveSubMenu = function (subMenu) {
	      _this.subMenu = subMenu;
	    };
	
	    return _this;
	  }
	
	  _createClass(SubMenu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          rootPrefixCls = _this$props.rootPrefixCls,
	          popupClassName = _this$props.popupClassName;
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref) {
	          var antdMenuTheme = _ref.antdMenuTheme;
	          return (/*#__PURE__*/React.createElement(_rcMenu.SubMenu, _extends({}, _this2.props, {
	              ref: _this2.saveSubMenu,
	              popupClassName: (0, _classnames["default"])("".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
	            }))
	          );
	        })
	      );
	    }
	  }]);
	
	  return SubMenu;
	}(React.Component);
	
	SubMenu.contextTypes = {
	  antdMenuTheme: PropTypes.string
	}; // fix issue:https://github.com/ant-design/ant-design/issues/8666
	
	SubMenu.isSubMenu = 1;
	var _default = SubMenu;
	exports["default"] = _default;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcNotification = _interopRequireDefault(__webpack_require__(189));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var defaultDuration = 3;
	var defaultTop;
	var messageInstance;
	var key = 1;
	var prefixCls = 'ant-message';
	var transitionName = 'move-up';
	var getContainer;
	var maxCount;
	
	function getMessageInstance(callback) {
	  if (messageInstance) {
	    callback(messageInstance);
	    return;
	  }
	
	  _rcNotification["default"].newInstance({
	    prefixCls: prefixCls,
	    transitionName: transitionName,
	    style: {
	      top: defaultTop
	    },
	    getContainer: getContainer,
	    maxCount: maxCount
	  }, function (instance) {
	    if (messageInstance) {
	      callback(messageInstance);
	      return;
	    }
	
	    messageInstance = instance;
	    callback(instance);
	  });
	}
	
	function notice(args) {
	  var duration = args.duration !== undefined ? args.duration : defaultDuration;
	  var iconType = {
	    info: 'info-circle',
	    success: 'check-circle',
	    error: 'close-circle',
	    warning: 'exclamation-circle',
	    loading: 'loading'
	  }[args.type];
	  var target = args.key || key++;
	  var closePromise = new Promise(function (resolve) {
	    var callback = function callback() {
	      if (typeof args.onClose === 'function') {
	        args.onClose();
	      }
	
	      return resolve(true);
	    };
	
	    getMessageInstance(function (instance) {
	      var iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType,
	        theme: iconType === 'loading' ? 'outlined' : 'filled'
	      });
	      var switchIconNode = iconType ? iconNode : '';
	      instance.notice({
	        key: target,
	        duration: duration,
	        style: {},
	        content: /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-custom-content").concat(args.type ? " ".concat(prefixCls, "-").concat(args.type) : '')
	        }, args.icon ? args.icon : switchIconNode, /*#__PURE__*/React.createElement("span", null, args.content)),
	        onClose: callback
	      });
	    });
	  });
	
	  var result = function result() {
	    if (messageInstance) {
	      messageInstance.removeNotice(target);
	    }
	  };
	
	  result.then = function (filled, rejected) {
	    return closePromise.then(filled, rejected);
	  };
	
	  result.promise = closePromise;
	  return result;
	}
	
	function isArgsProps(content) {
	  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
	}
	
	var api = {
	  open: notice,
	  config: function config(options) {
	    if (options.top !== undefined) {
	      defaultTop = options.top;
	      messageInstance = null; // delete messageInstance for new defaultTop
	    }
	
	    if (options.duration !== undefined) {
	      defaultDuration = options.duration;
	    }
	
	    if (options.prefixCls !== undefined) {
	      prefixCls = options.prefixCls;
	    }
	
	    if (options.getContainer !== undefined) {
	      getContainer = options.getContainer;
	    }
	
	    if (options.transitionName !== undefined) {
	      transitionName = options.transitionName;
	      messageInstance = null; // delete messageInstance for new transitionName
	    }
	
	    if (options.maxCount !== undefined) {
	      maxCount = options.maxCount;
	      messageInstance = null;
	    }
	  },
	  destroy: function destroy() {
	    if (messageInstance) {
	      messageInstance.destroy();
	      messageInstance = null;
	    }
	  }
	};
	['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
	  api[type] = function (content, duration, onClose) {
	    if (isArgsProps(content)) {
	      return api.open(_extends(_extends({}, content), {
	        type: type
	      }));
	    }
	
	    if (typeof duration === 'function') {
	      onClose = duration;
	      duration = undefined;
	    }
	
	    return api.open({
	      content: content,
	      duration: duration,
	      type: type,
	      onClose: onClose
	    });
	  };
	});
	api.warn = api.warning;
	var _default = api;
	exports["default"] = _default;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _button = _interopRequireDefault(__webpack_require__(136));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ActionButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(ActionButton, _React$Component);
	
	  var _super = _createSuper(ActionButton);
	
	  function ActionButton(props) {
	    var _this;
	
	    _classCallCheck(this, ActionButton);
	
	    _this = _super.call(this, props);
	
	    _this.onClick = function () {
	      var _this$props = _this.props,
	          actionFn = _this$props.actionFn,
	          closeModal = _this$props.closeModal;
	
	      if (actionFn) {
	        var ret;
	
	        if (actionFn.length) {
	          ret = actionFn(closeModal);
	        } else {
	          ret = actionFn();
	
	          if (!ret) {
	            closeModal();
	          }
	        }
	
	        if (ret && ret.then) {
	          _this.setState({
	            loading: true
	          });
	
	          ret.then(function () {
	            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
	            // this.setState({ loading: false });
	            closeModal.apply(void 0, arguments);
	          }, function (e) {
	            // Emit error when catch promise reject
	            // eslint-disable-next-line no-console
	            console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183
	
	            _this.setState({
	              loading: false
	            });
	          });
	        }
	      } else {
	        closeModal();
	      }
	    };
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(ActionButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoFocus) {
	        var $this = ReactDOM.findDOMNode(this);
	        this.timeoutId = setTimeout(function () {
	          return $this.focus();
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          type = _this$props2.type,
	          children = _this$props2.children,
	          buttonProps = _this$props2.buttonProps;
	      var loading = this.state.loading;
	      return (/*#__PURE__*/React.createElement(_button["default"], _extends({
	          type: type,
	          onClick: this.onClick,
	          loading: loading
	        }, buttonProps), children)
	      );
	    }
	  }]);
	
	  return ActionButton;
	}(React.Component);
	
	exports["default"] = ActionButton;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = confirm;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(653));
	
	var _ActionButton = _interopRequireDefault(__webpack_require__(1226));
	
	var _locale = __webpack_require__(360);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var IS_REACT_16 = !!ReactDOM.createPortal;
	
	var ConfirmDialog = function ConfirmDialog(props) {
	  var onCancel = props.onCancel,
	      onOk = props.onOk,
	      close = props.close,
	      zIndex = props.zIndex,
	      afterClose = props.afterClose,
	      visible = props.visible,
	      keyboard = props.keyboard,
	      centered = props.centered,
	      getContainer = props.getContainer,
	      maskStyle = props.maskStyle,
	      okButtonProps = props.okButtonProps,
	      cancelButtonProps = props.cancelButtonProps,
	      _props$iconType = props.iconType,
	      iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
	  (0, _warning["default"])(!('iconType' in props), 'Modal', "The property 'iconType' is deprecated. Use the property 'icon' instead."); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
	
	  var icon = props.icon === undefined ? iconType : props.icon;
	  var okType = props.okType || 'primary';
	  var prefixCls = props.prefixCls || 'ant-modal';
	  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容
	
	  var okCancel = 'okCancel' in props ? props.okCancel : true;
	  var width = props.width || 416;
	  var style = props.style || {};
	  var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为
	
	  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
	  var runtimeLocale = (0, _locale.getConfirmLocale)();
	  var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
	  var cancelText = props.cancelText || runtimeLocale.cancelText;
	  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
	  var transitionName = props.transitionName || 'zoom';
	  var maskTransitionName = props.maskTransitionName || 'fade';
	  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
	  var cancelButton = okCancel && /*#__PURE__*/React.createElement(_ActionButton["default"], {
	    actionFn: onCancel,
	    closeModal: close,
	    autoFocus: autoFocusButton === 'cancel',
	    buttonProps: cancelButtonProps
	  }, cancelText);
	  var iconNode = typeof icon === 'string' ? /*#__PURE__*/React.createElement(_icon["default"], {
	    type: icon
	  }) : icon;
	  return (/*#__PURE__*/React.createElement(_Modal["default"], {
	      prefixCls: prefixCls,
	      className: classString,
	      wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
	      onCancel: function onCancel() {
	        return close({
	          triggerCancel: true
	        });
	      },
	      visible: visible,
	      title: "",
	      transitionName: transitionName,
	      footer: "",
	      maskTransitionName: maskTransitionName,
	      mask: mask,
	      maskClosable: maskClosable,
	      maskStyle: maskStyle,
	      style: style,
	      width: width,
	      zIndex: zIndex,
	      afterClose: afterClose,
	      keyboard: keyboard,
	      centered: centered,
	      getContainer: getContainer
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-body-wrapper")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-body")
	    }, iconNode, props.title === undefined ? null : /*#__PURE__*/React.createElement("span", {
	      className: "".concat(contentPrefixCls, "-title")
	    }, props.title), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-content")
	    }, props.content)), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-btns")
	    }, cancelButton, /*#__PURE__*/React.createElement(_ActionButton["default"], {
	      type: okType,
	      actionFn: onOk,
	      closeModal: close,
	      autoFocus: autoFocusButton === 'ok',
	      buttonProps: okButtonProps
	    }, okText))))
	  );
	};
	
	function confirm(config) {
	  var div = document.createElement('div');
	  document.body.appendChild(div); // eslint-disable-next-line no-use-before-define
	
	  var currentConfig = _extends(_extends({}, config), {
	    close: close,
	    visible: true
	  });
	
	  function destroy() {
	    var unmountResult = ReactDOM.unmountComponentAtNode(div);
	
	    if (unmountResult && div.parentNode) {
	      div.parentNode.removeChild(div);
	    }
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var triggerCancel = args.some(function (param) {
	      return param && param.triggerCancel;
	    });
	
	    if (config.onCancel && triggerCancel) {
	      config.onCancel.apply(config, args);
	    }
	
	    for (var i = 0; i < _Modal.destroyFns.length; i++) {
	      var fn = _Modal.destroyFns[i]; // eslint-disable-next-line no-use-before-define
	
	      if (fn === close) {
	        _Modal.destroyFns.splice(i, 1);
	
	        break;
	      }
	    }
	  }
	
	  function render(props) {
	    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmDialog, props), div);
	  }
	
	  function close() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    currentConfig = _extends(_extends({}, currentConfig), {
	      visible: false,
	      afterClose: destroy.bind.apply(destroy, [this].concat(args))
	    });
	
	    if (IS_REACT_16) {
	      render(currentConfig);
	    } else {
	      destroy.apply(void 0, args);
	    }
	  }
	
	  function update(newConfig) {
	    currentConfig = _extends(_extends({}, currentConfig), newConfig);
	    render(currentConfig);
	  }
	
	  render(currentConfig);
	
	  _Modal.destroyFns.push(close);
	
	  return {
	    destroy: close,
	    update: update
	  };
	}

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(653));
	
	var _confirm = _interopRequireDefault(__webpack_require__(1227));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function modalWarn(props) {
	  var config = _extends({
	    type: 'warning',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "exclamation-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	}
	
	_Modal["default"].info = function infoFn(props) {
	  var config = _extends({
	    type: 'info',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "info-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].success = function successFn(props) {
	  var config = _extends({
	    type: 'success',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "check-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].error = function errorFn(props) {
	  var config = _extends({
	    type: 'error',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "close-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].warning = modalWarn;
	_Modal["default"].warn = modalWarn;
	
	_Modal["default"].confirm = function confirmFn(props) {
	  var config = _extends({
	    type: 'confirm',
	    okCancel: true
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].destroyAll = function destroyAllFn() {
	  while (_Modal.destroyFns.length) {
	    var close = _Modal.destroyFns.pop();
	
	    if (close) {
	      close();
	    }
	  }
	};
	
	var _default = _Modal["default"];
	exports["default"] = _default;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcNotification = _interopRequireDefault(__webpack_require__(189));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var notificationInstance = {};
	var defaultDuration = 4.5;
	var defaultTop = 24;
	var defaultBottom = 24;
	var defaultPlacement = 'topRight';
	var defaultGetContainer;
	var defaultCloseIcon;
	
	function setNotificationConfig(options) {
	  var duration = options.duration,
	      placement = options.placement,
	      bottom = options.bottom,
	      top = options.top,
	      getContainer = options.getContainer,
	      closeIcon = options.closeIcon;
	
	  if (duration !== undefined) {
	    defaultDuration = duration;
	  }
	
	  if (placement !== undefined) {
	    defaultPlacement = placement;
	  }
	
	  if (bottom !== undefined) {
	    defaultBottom = bottom;
	  }
	
	  if (top !== undefined) {
	    defaultTop = top;
	  }
	
	  if (getContainer !== undefined) {
	    defaultGetContainer = getContainer;
	  }
	
	  if (closeIcon !== undefined) {
	    defaultCloseIcon = closeIcon;
	  }
	}
	
	function getPlacementStyle(placement) {
	  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTop;
	  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBottom;
	  var style;
	
	  switch (placement) {
	    case 'topLeft':
	      style = {
	        left: 0,
	        top: top,
	        bottom: 'auto'
	      };
	      break;
	
	    case 'topRight':
	      style = {
	        right: 0,
	        top: top,
	        bottom: 'auto'
	      };
	      break;
	
	    case 'bottomLeft':
	      style = {
	        left: 0,
	        top: 'auto',
	        bottom: bottom
	      };
	      break;
	
	    default:
	      style = {
	        right: 0,
	        top: 'auto',
	        bottom: bottom
	      };
	      break;
	  }
	
	  return style;
	}
	
	function getNotificationInstance(_ref, callback) {
	  var prefixCls = _ref.prefixCls,
	      _ref$placement = _ref.placement,
	      placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
	      _ref$getContainer = _ref.getContainer,
	      getContainer = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer,
	      top = _ref.top,
	      bottom = _ref.bottom,
	      _ref$closeIcon = _ref.closeIcon,
	      closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon;
	  var cacheKey = "".concat(prefixCls, "-").concat(placement);
	
	  if (notificationInstance[cacheKey]) {
	    callback(notificationInstance[cacheKey]);
	    return;
	  }
	
	  var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-close-x")
	  }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	    className: "".concat(prefixCls, "-close-icon"),
	    type: "close"
	  }));
	
	  _rcNotification["default"].newInstance({
	    prefixCls: prefixCls,
	    className: "".concat(prefixCls, "-").concat(placement),
	    style: getPlacementStyle(placement, top, bottom),
	    getContainer: getContainer,
	    closeIcon: closeIconToRender
	  }, function (notification) {
	    notificationInstance[cacheKey] = notification;
	    callback(notification);
	  });
	}
	
	var typeToIcon = {
	  success: 'check-circle-o',
	  info: 'info-circle-o',
	  error: 'close-circle-o',
	  warning: 'exclamation-circle-o'
	};
	
	function notice(args) {
	  var outerPrefixCls = args.prefixCls || 'ant-notification';
	  var prefixCls = "".concat(outerPrefixCls, "-notice");
	  var duration = args.duration === undefined ? defaultDuration : args.duration;
	  var iconNode = null;
	
	  if (args.icon) {
	    iconNode = /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-icon")
	    }, args.icon);
	  } else if (args.type) {
	    var iconType = typeToIcon[args.type];
	    iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
	      className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(args.type),
	      type: iconType
	    });
	  }
	
	  var autoMarginTag = !args.description && iconNode ? /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-message-single-line-auto-margin")
	  }) : null;
	  var placement = args.placement,
	      top = args.top,
	      bottom = args.bottom,
	      getContainer = args.getContainer,
	      closeIcon = args.closeIcon;
	  getNotificationInstance({
	    prefixCls: outerPrefixCls,
	    placement: placement,
	    top: top,
	    bottom: bottom,
	    getContainer: getContainer,
	    closeIcon: closeIcon
	  }, function (notification) {
	    notification.notice({
	      content: /*#__PURE__*/React.createElement("div", {
	        className: iconNode ? "".concat(prefixCls, "-with-icon") : ''
	      }, iconNode, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-message")
	      }, autoMarginTag, args.message), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-description")
	      }, args.description), args.btn ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-btn")
	      }, args.btn) : null),
	      duration: duration,
	      closable: true,
	      onClose: args.onClose,
	      onClick: args.onClick,
	      key: args.key,
	      style: args.style || {},
	      className: args.className
	    });
	  });
	}
	
	var api = {
	  open: notice,
	  close: function close(key) {
	    Object.keys(notificationInstance).forEach(function (cacheKey) {
	      return notificationInstance[cacheKey].removeNotice(key);
	    });
	  },
	  config: setNotificationConfig,
	  destroy: function destroy() {
	    Object.keys(notificationInstance).forEach(function (cacheKey) {
	      notificationInstance[cacheKey].destroy();
	      delete notificationInstance[cacheKey];
	    });
	  }
	};
	['success', 'info', 'warning', 'error'].forEach(function (type) {
	  api[type] = function (args) {
	    return api.open(_extends(_extends({}, args), {
	      type: type
	    }));
	  };
	});
	api.warn = api.warning;
	var _default = api;
	exports["default"] = _default;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _breadcrumb = _interopRequireDefault(__webpack_require__(637));
	
	var _avatar = _interopRequireDefault(__webpack_require__(635));
	
	var _transButton = _interopRequireDefault(__webpack_require__(352));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var renderBack = function renderBack(prefixCls, backIcon, onBack) {
	  if (!backIcon || !onBack) {
	    return null;
	  }
	
	  return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	      componentName: "PageHeader"
	    }, function (_ref) {
	      var back = _ref.back;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-back")
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          onClick: function onClick(e) {
	            if (onBack) {
	              onBack(e);
	            }
	          },
	          className: "".concat(prefixCls, "-back-button"),
	          "aria-label": back
	        }, backIcon))
	      );
	    })
	  );
	};
	
	var renderBreadcrumb = function renderBreadcrumb(breadcrumb) {
	  return (/*#__PURE__*/React.createElement(_breadcrumb["default"], breadcrumb)
	  );
	};
	
	var renderTitle = function renderTitle(prefixCls, props) {
	  var title = props.title,
	      avatar = props.avatar,
	      subTitle = props.subTitle,
	      tags = props.tags,
	      extra = props.extra,
	      backIcon = props.backIcon,
	      onBack = props.onBack;
	  var headingPrefixCls = "".concat(prefixCls, "-heading");
	
	  if (title || subTitle || tags || extra) {
	    var backIconDom = renderBack(prefixCls, backIcon, onBack);
	    return (/*#__PURE__*/React.createElement("div", {
	        className: headingPrefixCls
	      }, backIconDom, avatar && /*#__PURE__*/React.createElement(_avatar["default"], avatar), title && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-title")
	      }, title), subTitle && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-sub-title")
	      }, subTitle), tags && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-tags")
	      }, tags), extra && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-extra")
	      }, extra))
	    );
	  }
	
	  return null;
	};
	
	var renderFooter = function renderFooter(prefixCls, footer) {
	  if (footer) {
	    return (/*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, footer)
	    );
	  }
	
	  return null;
	};
	
	var renderChildren = function renderChildren(prefixCls, children) {
	  return (/*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-content")
	    }, children)
	  );
	};
	
	var PageHeader = function PageHeader(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls,
	          pageHeader = _ref2.pageHeader;
	      var customizePrefixCls = props.prefixCls,
	          style = props.style,
	          footer = props.footer,
	          children = props.children,
	          breadcrumb = props.breadcrumb,
	          customizeClassName = props.className;
	      var ghost = true; // Use `ghost` from `props` or from `ConfigProvider` instead.
	
	      if ('ghost' in props) {
	        ghost = props.ghost;
	      } else if (pageHeader && 'ghost' in pageHeader) {
	        ghost = pageHeader.ghost;
	      }
	
	      var prefixCls = getPrefixCls('page-header', customizePrefixCls);
	      var breadcrumbDom = breadcrumb && breadcrumb.routes ? renderBreadcrumb(breadcrumb) : null;
	      var className = (0, _classnames2["default"])(prefixCls, customizeClassName, _defineProperty({
	        'has-breadcrumb': breadcrumbDom,
	        'has-footer': footer
	      }, "".concat(prefixCls, "-ghost"), ghost));
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className,
	          style: style
	        }, breadcrumbDom, renderTitle(prefixCls, props), children && renderChildren(prefixCls, children), renderFooter(prefixCls, footer))
	      );
	    })
	  );
	};
	
	PageHeader.defaultProps = {
	  backIcon: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "arrow-left"
	  })
	};
	var _default = PageHeader;
	exports["default"] = _default;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _select = _interopRequireDefault(__webpack_require__(202));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var MiniSelect = /*#__PURE__*/function (_React$Component) {
	  _inherits(MiniSelect, _React$Component);
	
	  var _super = _createSuper(MiniSelect);
	
	  function MiniSelect() {
	    _classCallCheck(this, MiniSelect);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(MiniSelect, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_select["default"], _extends({
	          size: "small"
	        }, this.props))
	      );
	    }
	  }]);
	
	  return MiniSelect;
	}(React.Component);
	
	exports["default"] = MiniSelect;
	MiniSelect.Option = _select["default"].Option;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcPagination = _interopRequireDefault(__webpack_require__(471));
	
	var _en_US = _interopRequireDefault(__webpack_require__(190));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _MiniSelect = _interopRequireDefault(__webpack_require__(1231));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _select = _interopRequireDefault(__webpack_require__(202));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Pagination = /*#__PURE__*/function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  var _super = _createSuper(Pagination);
	
	  function Pagination() {
	    var _this;
	
	    _classCallCheck(this, Pagination);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getIconsProps = function (prefixCls) {
	      var prevIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "left"
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right"
	      }));
	      var jumpPrevIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-container")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-item-link-icon"),
	        type: "double-left"
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-ellipsis")
	      }, "\u2022\u2022\u2022")));
	      var jumpNextIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-container")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-item-link-icon"),
	        type: "double-right"
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-ellipsis")
	      }, "\u2022\u2022\u2022")));
	      return {
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        jumpPrevIcon: jumpPrevIcon,
	        jumpNextIcon: jumpNextIcon
	      };
	    };
	
	    _this.renderPagination = function (contextLocale) {
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeSelectPrefixCls = _a.selectPrefixCls,
	          className = _a.className,
	          size = _a.size,
	          customLocale = _a.locale,
	          restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);
	
	      var locale = _extends(_extends({}, contextLocale), customLocale);
	
	      var isSmall = size === 'small';
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	          var getPrefixCls = _ref.getPrefixCls;
	          var prefixCls = getPrefixCls('pagination', customizePrefixCls);
	          var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
	          return (/*#__PURE__*/React.createElement(_rcPagination["default"], _extends({}, restProps, {
	              prefixCls: prefixCls,
	              selectPrefixCls: selectPrefixCls
	            }, _this.getIconsProps(prefixCls), {
	              className: (0, _classnames["default"])(className, {
	                mini: isSmall
	              }),
	              selectComponentClass: isSmall ? _MiniSelect["default"] : _select["default"],
	              locale: locale
	            }))
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Pagination, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Pagination",
	          defaultLocale: _en_US["default"]
	        }, this.renderPagination)
	      );
	    }
	  }]);
	
	  return Pagination;
	}(React.Component);
	
	exports["default"] = Pagination;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _tooltip = _interopRequireDefault(__webpack_require__(124));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _button = _interopRequireDefault(__webpack_require__(136));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _default2 = _interopRequireDefault(__webpack_require__(157));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popconfirm = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popconfirm, _React$Component);
	
	  var _super = _createSuper(Popconfirm);
	
	  function Popconfirm(props) {
	    var _this;
	
	    _classCallCheck(this, Popconfirm);
	
	    _this = _super.call(this, props);
	
	    _this.onConfirm = function (e) {
	      _this.setVisible(false, e);
	
	      var onConfirm = _this.props.onConfirm;
	
	      if (onConfirm) {
	        onConfirm.call(_assertThisInitialized(_this), e);
	      }
	    };
	
	    _this.onCancel = function (e) {
	      _this.setVisible(false, e);
	
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel.call(_assertThisInitialized(_this), e);
	      }
	    };
	
	    _this.onVisibleChange = function (visible) {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setVisible(visible);
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderOverlay = function (prefixCls, popconfirmLocale) {
	      var _this$props = _this.props,
	          okButtonProps = _this$props.okButtonProps,
	          cancelButtonProps = _this$props.cancelButtonProps,
	          title = _this$props.title,
	          cancelText = _this$props.cancelText,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          icon = _this$props.icon;
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-inner-content")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-message")
	        }, icon, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-message-title")
	        }, title)), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-buttons")
	        }, /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.onCancel,
	          size: "small"
	        }, cancelButtonProps), cancelText || popconfirmLocale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.onConfirm,
	          type: okType,
	          size: "small"
	        }, okButtonProps), okText || popconfirmLocale.okText))))
	      );
	    };
	
	    _this.renderConfirm = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          placement = _a.placement,
	          restProps = __rest(_a, ["prefixCls", "placement"]);
	
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      var overlay = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Popconfirm",
	        defaultLocale: _default2["default"].Popconfirm
	      }, function (popconfirmLocale) {
	        return _this.renderOverlay(prefixCls, popconfirmLocale);
	      });
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, restProps, {
	          prefixCls: prefixCls,
	          placement: placement,
	          onVisibleChange: _this.onVisibleChange,
	          visible: _this.state.visible,
	          overlay: overlay,
	          ref: _this.saveTooltip
	        }))
	      );
	    };
	
	    _this.state = {
	      visible: props.visible
	    };
	    return _this;
	  }
	
	  _createClass(Popconfirm, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible, e) {
	      var props = this.props;
	
	      if (!('visible' in props)) {
	        this.setState({
	          visible: visible
	        });
	      }
	
	      var onVisibleChange = props.onVisibleChange;
	
	      if (onVisibleChange) {
	        onVisibleChange(visible, e);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderConfirm)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      if ('defaultVisible' in nextProps) {
	        return {
	          visible: nextProps.defaultVisible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Popconfirm;
	}(React.Component);
	
	Popconfirm.defaultProps = {
	  transitionName: 'zoom-big',
	  placement: 'top',
	  trigger: 'click',
	  okType: 'primary',
	  icon: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "exclamation-circle",
	    theme: "filled"
	  }),
	  disabled: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Popconfirm);
	var _default = Popconfirm;
	exports["default"] = _default;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(124));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popover = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popover, _React$Component);
	
	  var _super = _createSuper(Popover);
	
	  function Popover() {
	    var _this;
	
	    _classCallCheck(this, Popover);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderPopover = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          props = __rest(_a, ["prefixCls"]);
	
	      delete props.title;
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, props, {
	          prefixCls: prefixCls,
	          ref: _this.saveTooltip,
	          overlay: _this.getOverlay(prefixCls)
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Popover, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay(prefixCls) {
	      var _this$props = this.props,
	          title = _this$props.title,
	          content = _this$props.content;
	      (0, _warning["default"])(!('overlay' in this.props), 'Popover', '`overlay` is removed, please use `content` instead, ' + 'see: https://u.ant.design/popover-content');
	      return (/*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-inner-content")
	        }, content))
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPopover)
	      );
	    }
	  }]);
	
	  return Popover;
	}(React.Component);
	
	exports["default"] = Popover;
	Popover.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big',
	  trigger: 'hover',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  overlayStyle: {}
	};

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcProgress = __webpack_require__(472);
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(362);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var statusColorMap = {
	  normal: '#108ee9',
	  exception: '#ff5500',
	  success: '#87d068'
	};
	
	function getPercentage(_ref) {
	  var percent = _ref.percent,
	      successPercent = _ref.successPercent;
	  var ptg = (0, _utils.validProgress)(percent);
	
	  if (!successPercent) {
	    return ptg;
	  }
	
	  var successPtg = (0, _utils.validProgress)(successPercent);
	  return [successPercent, (0, _utils.validProgress)(ptg - successPtg)];
	}
	
	function getStrokeColor(_ref2) {
	  var progressStatus = _ref2.progressStatus,
	      successPercent = _ref2.successPercent,
	      strokeColor = _ref2.strokeColor;
	  var color = strokeColor || statusColorMap[progressStatus];
	
	  if (!successPercent) {
	    return color;
	  }
	
	  return [statusColorMap.success, color];
	}
	
	var Circle = function Circle(props) {
	  var prefixCls = props.prefixCls,
	      width = props.width,
	      strokeWidth = props.strokeWidth,
	      trailColor = props.trailColor,
	      strokeLinecap = props.strokeLinecap,
	      gapPosition = props.gapPosition,
	      gapDegree = props.gapDegree,
	      type = props.type,
	      children = props.children;
	  var circleSize = width || 120;
	  var circleStyle = {
	    width: circleSize,
	    height: circleSize,
	    fontSize: circleSize * 0.15 + 6
	  };
	  var circleWidth = strokeWidth || 6;
	  var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
	  var gapDeg = gapDegree || (type === 'dashboard' ? 75 : undefined);
	  var strokeColor = getStrokeColor(props);
	  var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
	  var wrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-inner"), _defineProperty({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
	  return (/*#__PURE__*/React.createElement("div", {
	      className: wrapperClassName,
	      style: circleStyle
	    }, /*#__PURE__*/React.createElement(_rcProgress.Circle, {
	      percent: getPercentage(props),
	      strokeWidth: circleWidth,
	      trailWidth: circleWidth,
	      strokeColor: strokeColor,
	      strokeLinecap: strokeLinecap,
	      trailColor: trailColor,
	      prefixCls: prefixCls,
	      gapDegree: gapDeg,
	      gapPosition: gapPos
	    }), children)
	  );
	};
	
	var _default = Circle;
	exports["default"] = _default;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.handleGradient = exports.sortGradient = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(362);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	/**
	 * {
	 *   '0%': '#afc163',
	 *   '75%': '#009900',
	 *   '50%': 'green',     ====>     '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
	 *   '25%': '#66FF00',
	 *   '100%': '#ffffff'
	 * }
	 */
	var sortGradient = function sortGradient(gradients) {
	  var tempArr = []; // eslint-disable-next-line no-restricted-syntax
	
	  for (var _i = 0, _Object$entries = Object.entries(gradients); _i < _Object$entries.length; _i++) {
	    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
	        key = _Object$entries$_i[0],
	        value = _Object$entries$_i[1];
	
	    var formatKey = parseFloat(key.replace(/%/g, ''));
	
	    if (isNaN(formatKey)) {
	      return {};
	    }
	
	    tempArr.push({
	      key: formatKey,
	      value: value
	    });
	  }
	
	  tempArr = tempArr.sort(function (a, b) {
	    return a.key - b.key;
	  });
	  return tempArr.map(function (_ref) {
	    var key = _ref.key,
	        value = _ref.value;
	    return "".concat(value, " ").concat(key, "%");
	  }).join(', ');
	};
	/**
	 * {
	 *   '0%': '#afc163',
	 *   '25%': '#66FF00',
	 *   '50%': '#00CC00',     ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
	 *   '75%': '#009900',              #00CC00 50%, #009900 75%, #ffffff 100%)
	 *   '100%': '#ffffff'
	 * }
	 *
	 * Then this man came to realize the truth:
	 * Besides six pence, there is the moon.
	 * Besides bread and butter, there is the bug.
	 * And...
	 * Besides women, there is the code.
	 */
	
	exports.sortGradient = sortGradient;
	
	var handleGradient = function handleGradient(strokeColor) {
	  var _strokeColor$from = strokeColor.from,
	      from = _strokeColor$from === void 0 ? '#1890ff' : _strokeColor$from,
	      _strokeColor$to = strokeColor.to,
	      to = _strokeColor$to === void 0 ? '#1890ff' : _strokeColor$to,
	      _strokeColor$directio = strokeColor.direction,
	      direction = _strokeColor$directio === void 0 ? 'to right' : _strokeColor$directio,
	      rest = __rest(strokeColor, ["from", "to", "direction"]);
	
	  if (Object.keys(rest).length !== 0) {
	    var sortedGradients = sortGradient(rest);
	    return {
	      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
	    };
	  }
	
	  return {
	    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
	  };
	};
	
	exports.handleGradient = handleGradient;
	
	var Line = function Line(props) {
	  var prefixCls = props.prefixCls,
	      percent = props.percent,
	      successPercent = props.successPercent,
	      strokeWidth = props.strokeWidth,
	      size = props.size,
	      strokeColor = props.strokeColor,
	      strokeLinecap = props.strokeLinecap,
	      children = props.children;
	  var backgroundProps;
	
	  if (strokeColor && typeof strokeColor !== 'string') {
	    backgroundProps = handleGradient(strokeColor);
	  } else {
	    backgroundProps = {
	      background: strokeColor
	    };
	  }
	
	  var percentStyle = _extends({
	    width: "".concat((0, _utils.validProgress)(percent), "%"),
	    height: strokeWidth || (size === 'small' ? 6 : 8),
	    borderRadius: strokeLinecap === 'square' ? 0 : ''
	  }, backgroundProps);
	
	  var successPercentStyle = {
	    width: "".concat((0, _utils.validProgress)(successPercent), "%"),
	    height: strokeWidth || (size === 'small' ? 6 : 8),
	    borderRadius: strokeLinecap === 'square' ? 0 : ''
	  };
	  var successSegment = successPercent !== undefined ? /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-success-bg"),
	    style: successPercentStyle
	  }) : null;
	  return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-outer")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-inner")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-bg"),
	      style: percentStyle
	    }), successSegment)), children)
	  );
	};
	
	var _default = Line;
	exports["default"] = _default;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _type = __webpack_require__(82);
	
	var _Line = _interopRequireDefault(__webpack_require__(1236));
	
	var _Circle = _interopRequireDefault(__webpack_require__(1235));
	
	var _utils = __webpack_require__(362);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ProgressTypes = (0, _type.tuple)('line', 'circle', 'dashboard');
	var ProgressStatuses = (0, _type.tuple)('normal', 'exception', 'active', 'success');
	
	var Progress = /*#__PURE__*/function (_React$Component) {
	  _inherits(Progress, _React$Component);
	
	  var _super = _createSuper(Progress);
	
	  function Progress() {
	    var _this;
	
	    _classCallCheck(this, Progress);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderProgress = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          size = props.size,
	          type = props.type,
	          showInfo = props.showInfo,
	          restProps = __rest(props, ["prefixCls", "className", "size", "type", "showInfo"]);
	
	      var prefixCls = getPrefixCls('progress', customizePrefixCls);
	
	      var progressStatus = _this.getProgressStatus();
	
	      var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);
	
	      var progress; // Render progress shape
	
	      if (type === 'line') {
	        progress = /*#__PURE__*/React.createElement(_Line["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls
	        }), progressInfo);
	      } else if (type === 'circle' || type === 'dashboard') {
	        progress = /*#__PURE__*/React.createElement(_Circle["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          progressStatus: progressStatus
	        }), progressInfo);
	      }
	
	      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, (0, _omit["default"])(restProps, ['status', 'format', 'trailColor', 'successPercent', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeColor', 'strokeLinecap', 'percent']), {
	          className: classString
	        }), progress)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Progress, [{
	    key: "getPercentNumber",
	    value: function getPercentNumber() {
	      var _this$props = this.props,
	          successPercent = _this$props.successPercent,
	          _this$props$percent = _this$props.percent,
	          percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
	      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
	    }
	  }, {
	    key: "getProgressStatus",
	    value: function getProgressStatus() {
	      var status = this.props.status;
	
	      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
	        return 'success';
	      }
	
	      return status || 'normal';
	    }
	  }, {
	    key: "renderProcessInfo",
	    value: function renderProcessInfo(prefixCls, progressStatus) {
	      var _this$props2 = this.props,
	          showInfo = _this$props2.showInfo,
	          format = _this$props2.format,
	          type = _this$props2.type,
	          percent = _this$props2.percent,
	          successPercent = _this$props2.successPercent;
	      if (!showInfo) return null;
	      var text;
	
	      var textFormatter = format || function (percentNumber) {
	        return "".concat(percentNumber, "%");
	      };
	
	      var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';
	
	      if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
	        text = textFormatter((0, _utils.validProgress)(percent), (0, _utils.validProgress)(successPercent));
	      } else if (progressStatus === 'exception') {
	        text = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close".concat(iconType),
	          theme: type === 'line' ? 'filled' : 'outlined'
	        });
	      } else if (progressStatus === 'success') {
	        text = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "check".concat(iconType),
	          theme: type === 'line' ? 'filled' : 'outlined'
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-text"),
	          title: typeof text === 'string' ? text : undefined
	        }, text)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderProgress)
	      );
	    }
	  }]);
	
	  return Progress;
	}(React.Component);
	
	exports["default"] = Progress;
	Progress.defaultProps = {
	  type: 'line',
	  percent: 0,
	  showInfo: true,
	  trailColor: '#f3f3f3',
	  size: 'default',
	  gapDegree: 0,
	  strokeLinecap: 'round'
	};
	Progress.propTypes = {
	  status: PropTypes.oneOf(ProgressStatuses),
	  type: PropTypes.oneOf(ProgressTypes),
	  showInfo: PropTypes.bool,
	  percent: PropTypes.number,
	  width: PropTypes.number,
	  strokeWidth: PropTypes.number,
	  strokeLinecap: PropTypes.oneOf(['round', 'square']),
	  strokeColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  trailColor: PropTypes.string,
	  format: PropTypes.func,
	  gapDegree: PropTypes.number
	};

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _radio = _interopRequireDefault(__webpack_require__(363));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getCheckedValue(children) {
	  var value = null;
	  var matched = false;
	  React.Children.forEach(children, function (radio) {
	    if (radio && radio.props && radio.props.checked) {
	      value = radio.props.value;
	      matched = true;
	    }
	  });
	  return matched ? {
	    value: value
	  } : undefined;
	}
	
	var RadioGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioGroup, _React$Component);
	
	  var _super = _createSuper(RadioGroup);
	
	  function RadioGroup(props) {
	    var _this;
	
	    _classCallCheck(this, RadioGroup);
	
	    _this = _super.call(this, props);
	
	    _this.onRadioChange = function (ev) {
	      var lastValue = _this.state.value;
	      var value = ev.target.value;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange && value !== lastValue) {
	        onChange(ev);
	      }
	    };
	
	    _this.renderGroup = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className,
	          options = props.options,
	          buttonStyle = props.buttonStyle;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), _defineProperty({}, "".concat(groupPrefixCls, "-").concat(props.size), props.size), className);
	      var children = props.children; // 如果存在 options, 优先使用
	
	      if (options && options.length > 0) {
	        children = options.map(function (option) {
	          if (typeof option === 'string') {
	            // 此处类型自动推导为 string
	            return (/*#__PURE__*/React.createElement(_radio["default"], {
	                key: option,
	                prefixCls: prefixCls,
	                disabled: _this.props.disabled,
	                value: option,
	                checked: _this.state.value === option
	              }, option)
	            );
	          } // 此处类型自动推导为 { label: string value: string }
	
	
	          return (/*#__PURE__*/React.createElement(_radio["default"], {
	              key: "radio-group-value-options-".concat(option.value),
	              prefixCls: prefixCls,
	              disabled: option.disabled || _this.props.disabled,
	              value: option.value,
	              checked: _this.state.value === option.value
	            }, option.label)
	          );
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: classString,
	          style: props.style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave,
	          id: props.id
	        }, children)
	      );
	    };
	
	    var value;
	
	    if ('value' in props) {
	      value = props.value;
	    } else if ('defaultValue' in props) {
	      value = props.defaultValue;
	    } else {
	      var checkedValue = getCheckedValue(props.children);
	      value = checkedValue && checkedValue.value;
	    }
	
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(RadioGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        radioGroup: {
	          onChange: this.onRadioChange,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      var checkedValue = getCheckedValue(nextProps.children);
	
	      if (checkedValue) {
	        return {
	          value: checkedValue.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return RadioGroup;
	}(React.Component);
	
	RadioGroup.defaultProps = {
	  buttonStyle: 'outline'
	};
	RadioGroup.childContextTypes = {
	  radioGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(RadioGroup);
	var _default = RadioGroup;
	exports["default"] = _default;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _radio = _interopRequireDefault(__webpack_require__(363));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RadioButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioButton, _React$Component);
	
	  var _super = _createSuper(RadioButton);
	
	  function RadioButton() {
	    var _this;
	
	    _classCallCheck(this, RadioButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderRadioButton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          radioProps = __rest(_a, ["prefixCls"]);
	
	      var prefixCls = getPrefixCls('radio-button', customizePrefixCls);
	
	      if (_this.context.radioGroup) {
	        radioProps.checked = _this.props.value === _this.context.radioGroup.value;
	        radioProps.disabled = _this.props.disabled || _this.context.radioGroup.disabled;
	      }
	
	      return (/*#__PURE__*/React.createElement(_radio["default"], _extends({
	          prefixCls: prefixCls
	        }, radioProps))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(RadioButton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadioButton)
	      );
	    }
	  }]);
	
	  return RadioButton;
	}(React.Component);
	
	exports["default"] = RadioButton;
	RadioButton.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcRate = _interopRequireDefault(__webpack_require__(473));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(124));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Rate = /*#__PURE__*/function (_React$Component) {
	  _inherits(Rate, _React$Component);
	
	  var _super = _createSuper(Rate);
	
	  function Rate() {
	    var _this;
	
	    _classCallCheck(this, Rate);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveRate = function (node) {
	      _this.rcRate = node;
	    };
	
	    _this.characterRender = function (node, _ref) {
	      var index = _ref.index;
	      var tooltips = _this.props.tooltips;
	      if (!tooltips) return node;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          title: tooltips[index]
	        }, node)
	      );
	    };
	
	    _this.renderRate = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          prefixCls = _a.prefixCls,
	          restProps = __rest(_a, ["prefixCls"]);
	
	      var rateProps = (0, _omit["default"])(restProps, ['tooltips']);
	      return (/*#__PURE__*/React.createElement(_rcRate["default"], _extends({
	          ref: _this.saveRate,
	          characterRender: _this.characterRender
	        }, rateProps, {
	          prefixCls: getPrefixCls('rate', prefixCls)
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Rate, [{
	    key: "focus",
	    value: function focus() {
	      this.rcRate.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcRate.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRate)
	      );
	    }
	  }]);
	
	  return Rate;
	}(React.Component);
	
	exports["default"] = Rate;
	Rate.propTypes = {
	  prefixCls: PropTypes.string,
	  character: PropTypes.node
	};
	Rate.defaultProps = {
	  character: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "star",
	    theme: "filled"
	  })
	};

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ExceptionMap = exports.IconMap = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _noFound = _interopRequireDefault(__webpack_require__(1242));
	
	var _serverError = _interopRequireDefault(__webpack_require__(1243));
	
	var _unauthorized = _interopRequireDefault(__webpack_require__(1244));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var IconMap = {
	  success: 'check-circle',
	  error: 'close-circle',
	  info: 'exclamation-circle',
	  warning: 'warning'
	};
	exports.IconMap = IconMap;
	var ExceptionMap = {
	  '404': _noFound["default"],
	  '500': _serverError["default"],
	  '403': _unauthorized["default"]
	}; // ExceptionImageMap keys
	
	exports.ExceptionMap = ExceptionMap;
	var ExceptionStatus = Object.keys(ExceptionMap);
	/**
	 * render icon
	 * if ExceptionStatus includes ,render svg image
	 * else render iconNode
	 * @param prefixCls
	 * @param {status, icon}
	 */
	
	var renderIcon = function renderIcon(prefixCls, _ref) {
	  var status = _ref.status,
	      icon = _ref.icon;
	  var className = (0, _classnames["default"])("".concat(prefixCls, "-icon"));
	
	  if (ExceptionStatus.includes("".concat(status))) {
	    var SVGComponent = ExceptionMap[status];
	    return (/*#__PURE__*/React.createElement("div", {
	        className: "".concat(className, " ").concat(prefixCls, "-image")
	      }, /*#__PURE__*/React.createElement(SVGComponent, null))
	    );
	  }
	
	  var iconString = IconMap[status];
	  var iconNode = icon || /*#__PURE__*/React.createElement(_icon["default"], {
	    type: iconString,
	    theme: "filled"
	  });
	  return (/*#__PURE__*/React.createElement("div", {
	      className: className
	    }, iconNode)
	  );
	};
	
	var renderExtra = function renderExtra(prefixCls, _ref2) {
	  var extra = _ref2.extra;
	  return extra && /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-extra")
	  }, extra);
	};
	
	var Result = function Result(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls;
	      var customizePrefixCls = props.prefixCls,
	          customizeClassName = props.className,
	          subTitle = props.subTitle,
	          title = props.title,
	          style = props.style,
	          children = props.children,
	          status = props.status;
	      var prefixCls = getPrefixCls('result', customizePrefixCls);
	      var className = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(status), customizeClassName);
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className,
	          style: style
	        }, renderIcon(prefixCls, props), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), subTitle && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-subtitle")
	        }, subTitle), children && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, children), renderExtra(prefixCls, props))
	      );
	    })
	  );
	};
	
	Result.defaultProps = {
	  status: 'info'
	};
	Result.PRESENTED_IMAGE_403 = ExceptionMap[403];
	Result.PRESENTED_IMAGE_404 = ExceptionMap[404];
	Result.PRESENTED_IMAGE_500 = ExceptionMap[500];
	var _default = Result;
	exports["default"] = _default;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var NoFound = function NoFound() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "252",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
	      d: "M0 .387h251.772v251.772H0z"
	    })), /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 .012)"
	    }, /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
	      fill: "#E4EBF7",
	      mask: "url(#b)"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#FFF",
	      strokeWidth: "2",
	      d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
	      fill: "#1890FF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.275 222.1s2.773-1.11 6.102-3.884",
	      stroke: "#648BD8",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
	      fill: "#520038"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M110.846 74.481s1.79-.716 2.506.537",
	      stroke: "#5C2552",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M103.287 72.93s1.83 1.113 4.137.954",
	      stroke: "#5C2552",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M119.306 107.329s.452 4.366-2.127 32.062",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
	      fill: "#F4D19D"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
	      fill: "#F4D19D"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
	      fill: "#5BA02E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
	      fill: "#92C110"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M88.979 89.48s7.776 5.384 16.6 2.842",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    })))
	  );
	};
	
	var _default = NoFound;
	exports["default"] = _default;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var ServerError = function ServerError() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "254",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
	      d: "M0 .335h253.49v253.49H0z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 293.665h253.49V.401H0z"
	    })), /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 .067)"
	    }, /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
	      fill: "#E4EBF7",
	      mask: "url(#b)"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
	      fill: "#FF603B"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
	      fill: "#520038"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.063",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.926 73.284s1.8-.72 2.52.54",
	      stroke: "#5C2552",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
	      stroke: "#DB836E",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.326 71.724s1.84 1.12 4.16.96",
	      stroke: "#5C2552",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
	      stroke: "#DB836E",
	      strokeWidth: "1.063",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.136",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M96.973 219.373s2.882-1.153 6.34-4.034",
	      stroke: "#648BD8",
	      strokeWidth: "1.032",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
	      stroke: "#DB836E",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M109.278 112.533s3.38-3.613 7.575-4.662",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.375 123.006s9.697-2.745 11.445-.88",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
	      stroke: "#BFCDDD",
	      strokeWidth: "2",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
	      fill: "#A3B4C6"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
	      fill: "#A3B4C6"
	    }), /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#A3B4C6",
	      mask: "url(#d)",
	      d: "M154.098 190.096h70.513v-84.617h-70.513z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
	      fill: "#FFF",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
	      stroke: "#7C90A5",
	      strokeWidth: "1.124",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
	      fill: "#FFF",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M177.259 207.217v11.52M201.05 207.217v11.52",
	      stroke: "#A3B4C6",
	      strokeWidth: "1.124",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
	      fill: "#5BA02E",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
	      fill: "#92C110",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
	      fill: "#F2D7AD",
	      mask: "url(#d)"
	    })))
	  );
	};
	
	var _default = ServerError;
	exports["default"] = _default;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Unauthorized = function Unauthorized() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "251",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("path", {
	      d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
	      fill: "#E4EBF7"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#FFF",
	      strokeWidth: "2",
	      d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
	      fill: "#A26EF4"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
	      fill: "#5BA02E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
	      fill: "#92C110"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M78.18 94.656s.911 7.41-4.914 13.078",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
	      stroke: "#E4EBF7",
	      strokeWidth: ".932",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
	      fill: "#5C2552"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M91.132 86.786s5.269 4.957 12.679 2.327",
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
	      fill: "#DB836E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
	      stroke: "#5C2552",
	      strokeWidth: "1.526",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.114",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M128.31 87.934s3.013 4.121 4.06 11.785",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
	      stroke: "#DB836E",
	      strokeWidth: ".795",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M130.532 85.488s4.588 5.757 11.619 6.214",
	      stroke: "#DB836E",
	      strokeWidth: ".75",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M121.708 105.73s-.393 8.564-1.34 13.612",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.459 220.905s2.759-1.104 6.07-3.863",
	      stroke: "#648BD8",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    })))
	  );
	};
	
	var _default = Unauthorized;
	exports["default"] = _default;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// eslint-disable-next-line react/prefer-stateless-function
	var SkeletonAvatar = /*#__PURE__*/function (_React$Component) {
	  _inherits(SkeletonAvatar, _React$Component);
	
	  var _super = _createSuper(SkeletonAvatar);
	
	  function SkeletonAvatar() {
	    _classCallCheck(this, SkeletonAvatar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(SkeletonAvatar, [{
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          style = _this$props.style,
	          size = _this$props.size,
	          shape = _this$props.shape;
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
	      var shapeCls = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-circle"), shape === 'circle'), _defineProperty(_classNames2, "".concat(prefixCls, "-square"), shape === 'square'), _classNames2));
	      var sizeStyle = typeof size === 'number' ? {
	        width: size,
	        height: size,
	        lineHeight: "".concat(size, "px")
	      } : {};
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])(prefixCls, className, sizeCls, shapeCls),
	          style: _extends(_extends({}, sizeStyle), style)
	        })
	      );
	    }
	  }]);
	
	  return SkeletonAvatar;
	}(React.Component);
	
	SkeletonAvatar.defaultProps = {
	  size: 'large'
	};
	var _default = SkeletonAvatar;
	exports["default"] = _default;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Paragraph = /*#__PURE__*/function (_React$Component) {
	  _inherits(Paragraph, _React$Component);
	
	  var _super = _createSuper(Paragraph);
	
	  function Paragraph() {
	    _classCallCheck(this, Paragraph);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Paragraph, [{
	    key: "getWidth",
	    value: function getWidth(index) {
	      var _this$props = this.props,
	          width = _this$props.width,
	          _this$props$rows = _this$props.rows,
	          rows = _this$props$rows === void 0 ? 2 : _this$props$rows;
	
	      if (Array.isArray(width)) {
	        return width[index];
	      } // last paragraph
	
	
	      if (rows - 1 === index) {
	        return width;
	      }
	
	      return undefined;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          style = _this$props2.style,
	          rows = _this$props2.rows;
	
	      var rowList = _toConsumableArray(Array(rows)).map(function (_, index) {
	        return (
	          /*#__PURE__*/
	          // eslint-disable-next-line react/no-array-index-key
	          React.createElement("li", {
	            key: index,
	            style: {
	              width: _this.getWidth(index)
	            }
	          })
	        );
	      });
	
	      return (/*#__PURE__*/React.createElement("ul", {
	          className: (0, _classnames["default"])(prefixCls, className),
	          style: style
	        }, rowList)
	      );
	    }
	  }]);
	
	  return Paragraph;
	}(React.Component);
	
	var _default = Paragraph;
	exports["default"] = _default;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Title = function Title(_ref) {
	  var prefixCls = _ref.prefixCls,
	      className = _ref.className,
	      width = _ref.width,
	      style = _ref.style;
	  return (/*#__PURE__*/React.createElement("h3", {
	      className: (0, _classnames["default"])(prefixCls, className),
	      style: _extends({
	        width: width
	      }, style)
	    })
	  );
	};
	
	var _default = Title;
	exports["default"] = _default;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _Avatar = _interopRequireDefault(__webpack_require__(1245));
	
	var _Title = _interopRequireDefault(__webpack_require__(1247));
	
	var _Paragraph = _interopRequireDefault(__webpack_require__(1246));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function getComponentProps(prop) {
	  if (prop && _typeof(prop) === 'object') {
	    return prop;
	  }
	
	  return {};
	}
	
	function getAvatarBasicProps(hasTitle, hasParagraph) {
	  if (hasTitle && !hasParagraph) {
	    return {
	      shape: 'square'
	    };
	  }
	
	  return {
	    shape: 'circle'
	  };
	}
	
	function getTitleBasicProps(hasAvatar, hasParagraph) {
	  if (!hasAvatar && hasParagraph) {
	    return {
	      width: '38%'
	    };
	  }
	
	  if (hasAvatar && hasParagraph) {
	    return {
	      width: '50%'
	    };
	  }
	
	  return {};
	}
	
	function getParagraphBasicProps(hasAvatar, hasTitle) {
	  var basicProps = {}; // Width
	
	  if (!hasAvatar || !hasTitle) {
	    basicProps.width = '61%';
	  } // Rows
	
	
	  if (!hasAvatar && hasTitle) {
	    basicProps.rows = 3;
	  } else {
	    basicProps.rows = 2;
	  }
	
	  return basicProps;
	}
	
	var Skeleton = /*#__PURE__*/function (_React$Component) {
	  _inherits(Skeleton, _React$Component);
	
	  var _super = _createSuper(Skeleton);
	
	  function Skeleton() {
	    var _this;
	
	    _classCallCheck(this, Skeleton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSkeleton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          loading = _this$props.loading,
	          className = _this$props.className,
	          children = _this$props.children,
	          avatar = _this$props.avatar,
	          title = _this$props.title,
	          paragraph = _this$props.paragraph,
	          active = _this$props.active;
	      var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
	
	      if (loading || !('loading' in _this.props)) {
	        var _classNames;
	
	        var hasAvatar = !!avatar;
	        var hasTitle = !!title;
	        var hasParagraph = !!paragraph; // Avatar
	
	        var avatarNode;
	
	        if (hasAvatar) {
	          var avatarProps = _extends(_extends({
	            prefixCls: "".concat(prefixCls, "-avatar")
	          }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));
	
	          avatarNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-header")
	          }, /*#__PURE__*/React.createElement(_Avatar["default"], avatarProps));
	        }
	
	        var contentNode;
	
	        if (hasTitle || hasParagraph) {
	          // Title
	          var $title;
	
	          if (hasTitle) {
	            var titleProps = _extends(_extends({
	              prefixCls: "".concat(prefixCls, "-title")
	            }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
	
	            $title = /*#__PURE__*/React.createElement(_Title["default"], titleProps);
	          } // Paragraph
	
	
	          var paragraphNode;
	
	          if (hasParagraph) {
	            var paragraphProps = _extends(_extends({
	              prefixCls: "".concat(prefixCls, "-paragraph")
	            }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
	
	            paragraphNode = /*#__PURE__*/React.createElement(_Paragraph["default"], paragraphProps);
	          }
	
	          contentNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-content")
	          }, $title, paragraphNode);
	        }
	
	        var cls = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-avatar"), hasAvatar), _defineProperty(_classNames, "".concat(prefixCls, "-active"), active), _classNames));
	        return (/*#__PURE__*/React.createElement("div", {
	            className: cls
	          }, avatarNode, contentNode)
	        );
	      }
	
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Skeleton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSkeleton)
	      );
	    }
	  }]);
	
	  return Skeleton;
	}(React.Component);
	
	Skeleton.defaultProps = {
	  avatar: false,
	  title: true,
	  paragraph: true
	};
	var _default = Skeleton;
	exports["default"] = _default;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Slider = _interopRequireDefault(__webpack_require__(475));
	
	var _Range = _interopRequireDefault(__webpack_require__(474));
	
	var _Handle = _interopRequireDefault(__webpack_require__(503));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(124));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _this.toggleTooltipVisible = function (index, visible) {
	      _this.setState(function (_ref) {
	        var visibles = _ref.visibles;
	        return {
	          visibles: _extends(_extends({}, visibles), _defineProperty({}, index, visible))
	        };
	      });
	    };
	
	    _this.handleWithTooltip = function (_a) {
	      var tooltipPrefixCls = _a.tooltipPrefixCls,
	          prefixCls = _a.prefixCls,
	          _b = _a.info,
	          value = _b.value,
	          dragging = _b.dragging,
	          index = _b.index,
	          restProps = __rest(_b, ["value", "dragging", "index"]);
	
	      var _this$props = _this.props,
	          tipFormatter = _this$props.tipFormatter,
	          tooltipVisible = _this$props.tooltipVisible,
	          tooltipPlacement = _this$props.tooltipPlacement,
	          getTooltipPopupContainer = _this$props.getTooltipPopupContainer;
	      var visibles = _this.state.visibles;
	      var isTipFormatter = tipFormatter ? visibles[index] || dragging : false;
	      var visible = tooltipVisible || tooltipVisible === undefined && isTipFormatter;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          prefixCls: tooltipPrefixCls,
	          title: tipFormatter ? tipFormatter(value) : '',
	          visible: visible,
	          placement: tooltipPlacement || 'top',
	          transitionName: "zoom-down",
	          key: index,
	          overlayClassName: "".concat(prefixCls, "-tooltip"),
	          getPopupContainer: getTooltipPopupContainer || function () {
	            return document.body;
	          }
	        }, /*#__PURE__*/React.createElement(_Handle["default"], _extends({}, restProps, {
	          value: value,
	          onMouseEnter: function onMouseEnter() {
	            return _this.toggleTooltipVisible(index, true);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this.toggleTooltipVisible(index, false);
	          }
	        })))
	      );
	    };
	
	    _this.saveSlider = function (node) {
	      _this.rcSlider = node;
	    };
	
	    _this.renderSlider = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeTooltipPrefixCls = _a.tooltipPrefixCls,
	          range = _a.range,
	          restProps = __rest(_a, ["prefixCls", "tooltipPrefixCls", "range"]);
	
	      var prefixCls = getPrefixCls('slider', customizePrefixCls);
	      var tooltipPrefixCls = getPrefixCls('tooltip', customizeTooltipPrefixCls);
	
	      if (range) {
	        return (/*#__PURE__*/React.createElement(_Range["default"], _extends({}, restProps, {
	            ref: _this.saveSlider,
	            handle: function handle(info) {
	              return _this.handleWithTooltip({
	                tooltipPrefixCls: tooltipPrefixCls,
	                prefixCls: prefixCls,
	                info: info
	              });
	            },
	            prefixCls: prefixCls,
	            tooltipPrefixCls: tooltipPrefixCls
	          }))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_Slider["default"], _extends({}, restProps, {
	          ref: _this.saveSlider,
	          handle: function handle(info) {
	            return _this.handleWithTooltip({
	              tooltipPrefixCls: tooltipPrefixCls,
	              prefixCls: prefixCls,
	              info: info
	            });
	          },
	          prefixCls: prefixCls,
	          tooltipPrefixCls: tooltipPrefixCls
	        }))
	      );
	    };
	
	    _this.state = {
	      visibles: {}
	    };
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "focus",
	    value: function focus() {
	      this.rcSlider.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSlider.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSlider)
	      );
	    }
	  }]);
	
	  return Slider;
	}(React.Component);
	
	exports["default"] = Slider;
	Slider.defaultProps = {
	  tipFormatter: function tipFormatter(value) {
	    return value.toString();
	  }
	};

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	var _Statistic = _interopRequireDefault(__webpack_require__(656));
	
	var _utils = __webpack_require__(1253);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var REFRESH_INTERVAL = 1000 / 30;
	
	function getTime(value) {
	  return (0, _interopDefault["default"])(moment)(value).valueOf();
	}
	
	var Countdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Countdown, _React$Component);
	
	  var _super = _createSuper(Countdown);
	
	  function Countdown() {
	    var _this;
	
	    _classCallCheck(this, Countdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.syncTimer = function () {
	      var value = _this.props.value;
	      var timestamp = getTime(value);
	
	      if (timestamp >= Date.now()) {
	        _this.startTimer();
	      } else {
	        _this.stopTimer();
	      }
	    };
	
	    _this.startTimer = function () {
	      if (_this.countdownId) return;
	      _this.countdownId = window.setInterval(function () {
	        _this.forceUpdate();
	      }, REFRESH_INTERVAL);
	    };
	
	    _this.stopTimer = function () {
	      var _this$props = _this.props,
	          onFinish = _this$props.onFinish,
	          value = _this$props.value;
	
	      if (_this.countdownId) {
	        clearInterval(_this.countdownId);
	        _this.countdownId = undefined;
	        var timestamp = getTime(value);
	
	        if (onFinish && timestamp < Date.now()) {
	          onFinish();
	        }
	      }
	    };
	
	    _this.formatCountdown = function (value, config) {
	      var format = _this.props.format;
	      return (0, _utils.formatCountdown)(value, _extends(_extends({}, config), {
	        format: format
	      }));
	    }; // Countdown do not need display the timestamp
	
	
	    _this.valueRender = function (node) {
	      return (/*#__PURE__*/React.cloneElement(node, {
	          title: undefined
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Countdown, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.syncTimer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.syncTimer();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopTimer();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_Statistic["default"], _extends({
	          valueRender: this.valueRender
	        }, this.props, {
	          formatter: this.formatCountdown
	        }))
	      );
	    }
	  }]);
	
	  return Countdown;
	}(React.Component);
	
	Countdown.defaultProps = {
	  format: 'HH:mm:ss'
	};
	(0, _reactLifecyclesCompat.polyfill)(Countdown);
	var _default = Countdown;
	exports["default"] = _default;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _padEnd = _interopRequireDefault(__webpack_require__(457));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var StatisticNumber = function StatisticNumber(props) {
	  var value = props.value,
	      formatter = props.formatter,
	      precision = props.precision,
	      decimalSeparator = props.decimalSeparator,
	      _props$groupSeparator = props.groupSeparator,
	      groupSeparator = _props$groupSeparator === void 0 ? '' : _props$groupSeparator,
	      prefixCls = props.prefixCls;
	  var valueNode;
	
	  if (typeof formatter === 'function') {
	    // Customize formatter
	    valueNode = formatter(value);
	  } else {
	    // Internal formatter
	    var val = String(value);
	    var cells = val.match(/^(-?)(\d*)(\.(\d+))?$/); // Process if illegal number
	
	    if (!cells) {
	      valueNode = val;
	    } else {
	      var negative = cells[1];
	
	      var _int = cells[2] || '0';
	
	      var decimal = cells[4] || '';
	      _int = _int.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
	
	      if (typeof precision === 'number') {
	        decimal = (0, _padEnd["default"])(decimal, precision, '0').slice(0, precision);
	      }
	
	      if (decimal) {
	        decimal = "".concat(decimalSeparator).concat(decimal);
	      }
	
	      valueNode = [/*#__PURE__*/React.createElement("span", {
	        key: "int",
	        className: "".concat(prefixCls, "-content-value-int")
	      }, negative, _int), decimal && /*#__PURE__*/React.createElement("span", {
	        key: "decimal",
	        className: "".concat(prefixCls, "-content-value-decimal")
	      }, decimal)];
	    }
	  }
	
	  return (/*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-value")
	    }, valueNode)
	  );
	};
	
	var _default = StatisticNumber;
	exports["default"] = _default;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Statistic = _interopRequireDefault(__webpack_require__(656));
	
	var _Countdown = _interopRequireDefault(__webpack_require__(1250));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Statistic["default"].Countdown = _Countdown["default"];
	var _default = _Statistic["default"];
	exports["default"] = _default;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTimeStr = formatTimeStr;
	exports.formatCountdown = formatCountdown;
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _padStart = _interopRequireDefault(__webpack_require__(458));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(108));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	// Countdown
	var timeUnits = [['Y', 1000 * 60 * 60 * 24 * 365], ['M', 1000 * 60 * 60 * 24 * 30], ['D', 1000 * 60 * 60 * 24], ['H', 1000 * 60 * 60], ['m', 1000 * 60], ['s', 1000], ['S', 1]];
	
	function formatTimeStr(duration, format) {
	  var leftDuration = duration;
	  var escapeRegex = /\[[^\]]*\]/g;
	  var keepList = (format.match(escapeRegex) || []).map(function (str) {
	    return str.slice(1, -1);
	  });
	  var templateText = format.replace(escapeRegex, '[]');
	  var replacedText = timeUnits.reduce(function (current, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        name = _ref2[0],
	        unit = _ref2[1];
	
	    if (current.indexOf(name) !== -1) {
	      var value = Math.floor(leftDuration / unit);
	      leftDuration -= value * unit;
	      return current.replace(new RegExp("".concat(name, "+"), 'g'), function (match) {
	        var len = match.length;
	        return (0, _padStart["default"])(value.toString(), len, '0');
	      });
	    }
	
	    return current;
	  }, templateText);
	  var index = 0;
	  return replacedText.replace(escapeRegex, function () {
	    var match = keepList[index];
	    index += 1;
	    return match;
	  });
	}
	
	function formatCountdown(value, config) {
	  var _config$format = config.format,
	      format = _config$format === void 0 ? '' : _config$format;
	  var target = (0, _interopDefault["default"])(moment)(value).valueOf();
	  var current = (0, _interopDefault["default"])(moment)().valueOf();
	  var diff = Math.max(target - current, 0);
	  return formatTimeStr(diff, format);
	}

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSteps = _interopRequireDefault(__webpack_require__(476));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Steps = /*#__PURE__*/function (_React$Component) {
	  _inherits(Steps, _React$Component);
	
	  var _super = _createSuper(Steps);
	
	  function Steps() {
	    var _this;
	
	    _classCallCheck(this, Steps);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSteps = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var prefixCls = getPrefixCls('steps', _this.props.prefixCls);
	      var iconPrefix = getPrefixCls('', _this.props.iconPrefix);
	      var icons = {
	        finish: /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "check",
	          className: "".concat(prefixCls, "-finish-icon")
	        }),
	        error: /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close",
	          className: "".concat(prefixCls, "-error-icon")
	        })
	      };
	      return (/*#__PURE__*/React.createElement(_rcSteps["default"], _extends({
	          icons: icons
	        }, _this.props, {
	          prefixCls: prefixCls,
	          iconPrefix: iconPrefix
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Steps, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSteps)
	      );
	    }
	  }]);
	
	  return Steps;
	}(React.Component);
	
	exports["default"] = Steps;
	Steps.Step = _rcSteps["default"].Step;
	Steps.defaultProps = {
	  current: 0
	};
	Steps.propTypes = {
	  prefixCls: PropTypes.string,
	  iconPrefix: PropTypes.string,
	  current: PropTypes.number
	};

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSwitch = _interopRequireDefault(__webpack_require__(477));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _wave = _interopRequireDefault(__webpack_require__(353));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Switch = /*#__PURE__*/function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  var _super = _createSuper(Switch);
	
	  function Switch(props) {
	    var _this;
	
	    _classCallCheck(this, Switch);
	
	    _this = _super.call(this, props);
	
	    _this.saveSwitch = function (node) {
	      _this.rcSwitch = node;
	    };
	
	    _this.renderSwitch = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          size = _this$props.size,
	          loading = _this$props.loading,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          disabled = _this$props.disabled;
	      var prefixCls = getPrefixCls('switch', customizePrefixCls);
	      var classes = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-small"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _classNames));
	      var loadingIcon = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "loading",
	        className: "".concat(prefixCls, "-loading-icon")
	      }) : null;
	      return (/*#__PURE__*/React.createElement(_wave["default"], {
	          insertExtraNode: true
	        }, /*#__PURE__*/React.createElement(_rcSwitch["default"], _extends({}, (0, _omit["default"])(_this.props, ['loading']), {
	          prefixCls: prefixCls,
	          className: classes,
	          disabled: disabled || loading,
	          ref: _this.saveSwitch,
	          loadingIcon: loadingIcon
	        })))
	      );
	    };
	
	    (0, _warning["default"])('checked' in props || !('value' in props), 'Switch', '`value` is not validate prop, do you mean `checked`?');
	    return _this;
	  }
	
	  _createClass(Switch, [{
	    key: "focus",
	    value: function focus() {
	      this.rcSwitch.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSwitch.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSwitch)
	      );
	    }
	  }]);
	
	  return Switch;
	}(React.Component);
	
	exports["default"] = Switch;
	Switch.__ANT_SWITCH = true;
	Switch.propTypes = {
	  prefixCls: PropTypes.string,
	  // HACK: https://github.com/ant-design/ant-design/issues/5368
	  // size=default and size=large are the same
	  size: PropTypes.oneOf(['small', 'default', 'large']),
	  className: PropTypes.string
	};

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	/* eslint-disable react/prefer-stateless-function */
	var Column = /*#__PURE__*/function (_React$Component) {
	  _inherits(Column, _React$Component);
	
	  var _super = _createSuper(Column);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _super.apply(this, arguments);
	  }
	
	  return Column;
	}(React.Component);
	
	exports["default"] = Column;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ColumnGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(ColumnGroup, _React$Component);
	
	  var _super = _createSuper(ColumnGroup);
	
	  function ColumnGroup() {
	    _classCallCheck(this, ColumnGroup);
	
	    return _super.apply(this, arguments);
	  }
	
	  return ColumnGroup;
	}(React.Component);
	
	exports["default"] = ColumnGroup;
	ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
	  return (/*#__PURE__*/React.createElement("div", {
	      className: props.className,
	      onClick: function onClick(e) {
	        return e.stopPropagation();
	      }
	    }, props.children)
	  );
	};
	
	var _default = FilterDropdownMenuWrapper;
	exports["default"] = _default;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(156));
	
	var _radio = _interopRequireDefault(__webpack_require__(245));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SelectionBox = /*#__PURE__*/function (_React$Component) {
	  _inherits(SelectionBox, _React$Component);
	
	  var _super = _createSuper(SelectionBox);
	
	  function SelectionBox(props) {
	    var _this;
	
	    _classCallCheck(this, SelectionBox);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      checked: _this.getCheckState(props)
	    };
	    return _this;
	  }
	
	  _createClass(SelectionBox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.subscribe();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribe) {
	        this.unsubscribe();
	      }
	    } // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: "getCheckState",
	    value: function getCheckState(props) {
	      var store = props.store,
	          defaultSelection = props.defaultSelection,
	          rowIndex = props.rowIndex;
	      var checked = false;
	
	      if (store.getState().selectionDirty) {
	        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
	      } else {
	        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
	      }
	
	      return checked;
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe() {
	      var _this2 = this;
	
	      var store = this.props.store;
	      this.unsubscribe = store.subscribe(function () {
	        var checked = _this2.getCheckState(_this2.props);
	
	        _this2.setState({
	          checked: checked
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          type = _a.type,
	          rowIndex = _a.rowIndex,
	          rest = __rest(_a, ["type", "rowIndex"]);
	
	      var checked = this.state.checked;
	
	      if (type === 'radio') {
	        return (/*#__PURE__*/React.createElement(_radio["default"], _extends({
	            checked: checked,
	            value: rowIndex
	          }, rest))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_checkbox["default"], _extends({
	          checked: checked
	        }, rest))
	      );
	    }
	  }]);
	
	  return SelectionBox;
	}(React.Component);
	
	exports["default"] = SelectionBox;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _checkbox = _interopRequireDefault(__webpack_require__(156));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(356));
	
	var _menu = _interopRequireDefault(__webpack_require__(359));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function checkSelection(_ref) {
	  var store = _ref.store,
	      getCheckboxPropsByItem = _ref.getCheckboxPropsByItem,
	      getRecordKey = _ref.getRecordKey,
	      data = _ref.data,
	      type = _ref.type,
	      byDefaultChecked = _ref.byDefaultChecked;
	  return byDefaultChecked ? data[type](function (item, i) {
	    return getCheckboxPropsByItem(item, i).defaultChecked;
	  }) : data[type](function (item, i) {
	    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
	  });
	}
	
	function getIndeterminateState(props) {
	  var store = props.store,
	      data = props.data;
	
	  if (!data.length) {
	    return false;
	  }
	
	  var someCheckedNotByDefaultChecked = checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'some',
	    byDefaultChecked: false
	  })) && !checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: false
	  }));
	  var someCheckedByDefaultChecked = checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'some',
	    byDefaultChecked: true
	  })) && !checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: true
	  }));
	
	  if (store.getState().selectionDirty) {
	    return someCheckedNotByDefaultChecked;
	  }
	
	  return someCheckedNotByDefaultChecked || someCheckedByDefaultChecked;
	}
	
	function getCheckState(props) {
	  var store = props.store,
	      data = props.data;
	
	  if (!data.length) {
	    return false;
	  }
	
	  if (store.getState().selectionDirty) {
	    return checkSelection(_extends(_extends({}, props), {
	      data: data,
	      type: 'every',
	      byDefaultChecked: false
	    }));
	  }
	
	  return checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: false
	  })) || checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: true
	  }));
	}
	
	var SelectionCheckboxAll = /*#__PURE__*/function (_React$Component) {
	  _inherits(SelectionCheckboxAll, _React$Component);
	
	  var _super = _createSuper(SelectionCheckboxAll);
	
	  function SelectionCheckboxAll(props) {
	    var _this;
	
	    _classCallCheck(this, SelectionCheckboxAll);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      checked: false,
	      indeterminate: false
	    };
	
	    _this.handleSelectAllChange = function (e) {
	      var checked = e.target.checked;
	
	      _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
	    };
	
	    _this.defaultSelections = props.hideDefaultSelections ? [] : [{
	      key: 'all',
	      text: props.locale.selectAll
	    }, {
	      key: 'invert',
	      text: props.locale.selectInvert
	    }];
	    return _this;
	  }
	
	  _createClass(SelectionCheckboxAll, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.subscribe();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribe) {
	        this.unsubscribe();
	      }
	    }
	  }, {
	    key: "setCheckState",
	    value: function setCheckState(props) {
	      var checked = getCheckState(props);
	      var indeterminate = getIndeterminateState(props);
	      this.setState(function (prevState) {
	        var newState = {};
	
	        if (indeterminate !== prevState.indeterminate) {
	          newState.indeterminate = indeterminate;
	        }
	
	        if (checked !== prevState.checked) {
	          newState.checked = checked;
	        }
	
	        return newState;
	      });
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe() {
	      var _this2 = this;
	
	      var store = this.props.store;
	      this.unsubscribe = store.subscribe(function () {
	        _this2.setCheckState(_this2.props);
	      });
	    }
	  }, {
	    key: "renderMenus",
	    value: function renderMenus(selections) {
	      var _this3 = this;
	
	      return selections.map(function (selection, index) {
	        return (/*#__PURE__*/React.createElement(_menu["default"].Item, {
	            key: selection.key || index
	          }, /*#__PURE__*/React.createElement("div", {
	            onClick: function onClick() {
	              _this3.props.onSelect(selection.key, index, selection.onSelect);
	            }
	          }, selection.text))
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          disabled = _this$props.disabled,
	          prefixCls = _this$props.prefixCls,
	          selections = _this$props.selections,
	          getPopupContainer = _this$props.getPopupContainer;
	      var _this$state = this.state,
	          checked = _this$state.checked,
	          indeterminate = _this$state.indeterminate;
	      var selectionPrefixCls = "".concat(prefixCls, "-selection");
	      var customSelections = null;
	
	      if (selections) {
	        var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
	        var menu = /*#__PURE__*/React.createElement(_menu["default"], {
	          className: "".concat(selectionPrefixCls, "-menu"),
	          selectedKeys: []
	        }, this.renderMenus(newSelections));
	        customSelections = newSelections.length > 0 ? /*#__PURE__*/React.createElement(_dropdown["default"], {
	          overlay: menu,
	          getPopupContainer: getPopupContainer
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(selectionPrefixCls, "-down")
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "down"
	        }))) : null;
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: selectionPrefixCls
	        }, /*#__PURE__*/React.createElement(_checkbox["default"], {
	          className: (0, _classnames["default"])(_defineProperty({}, "".concat(selectionPrefixCls, "-select-all-custom"), customSelections)),
	          checked: checked,
	          indeterminate: indeterminate,
	          disabled: disabled,
	          onChange: this.handleSelectAllChange
	        }), customSelections)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      var checked = getCheckState(props);
	      var indeterminate = getIndeterminateState(props);
	      var newState = {};
	
	      if (indeterminate !== state.indeterminate) {
	        newState.indeterminate = indeterminate;
	      }
	
	      if (checked !== state.checked) {
	        newState.checked = checked;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return SelectionCheckboxAll;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(SelectionCheckboxAll);
	var _default = SelectionCheckboxAll;
	exports["default"] = _default;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcTable = _interopRequireWildcard(__webpack_require__(479));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _filterDropdown = _interopRequireDefault(__webpack_require__(1264));
	
	var _createStore = _interopRequireDefault(__webpack_require__(1263));
	
	var _SelectionBox = _interopRequireDefault(__webpack_require__(1259));
	
	var _SelectionCheckboxAll = _interopRequireDefault(__webpack_require__(1260));
	
	var _Column = _interopRequireDefault(__webpack_require__(1256));
	
	var _ColumnGroup = _interopRequireDefault(__webpack_require__(1257));
	
	var _createBodyRow = _interopRequireDefault(__webpack_require__(1262));
	
	var _util = __webpack_require__(657);
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(351));
	
	var _pagination = _interopRequireDefault(__webpack_require__(361));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _spin = _interopRequireDefault(__webpack_require__(246));
	
	var _transButton = _interopRequireDefault(__webpack_require__(352));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _default2 = _interopRequireDefault(__webpack_require__(157));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable prefer-spread */
	
	function noop() {}
	
	function stopPropagation(e) {
	  e.stopPropagation();
	}
	
	function getRowSelection(props) {
	  return props.rowSelection || {};
	}
	
	function getColumnKey(column, index) {
	  return column.key || column.dataIndex || index;
	}
	
	function isSameColumn(a, b) {
	  if (a && b && a.key && a.key === b.key) {
	    return true;
	  }
	
	  return a === b || (0, _shallowequal["default"])(a, b, function (value, other) {
	    // https://github.com/ant-design/ant-design/issues/12737
	    if (typeof value === 'function' && typeof other === 'function') {
	      return value === other || value.toString() === other.toString();
	    } // https://github.com/ant-design/ant-design/issues/19398
	
	
	    if (Array.isArray(value) && Array.isArray(other)) {
	      return value === other || (0, _shallowequal["default"])(value, other);
	    }
	  });
	}
	
	var defaultPagination = {
	  onChange: noop,
	  onShowSizeChange: noop
	};
	/**
	 * Avoid creating new object, so that parent component's shouldComponentUpdate
	 * can works appropriately。
	 */
	
	var emptyObject = {};
	
	var createComponents = function createComponents() {
	  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var bodyRow = components && components.body && components.body.row;
	  return _extends(_extends({}, components), {
	    body: _extends(_extends({}, components.body), {
	      row: (0, _createBodyRow["default"])(bodyRow)
	    })
	  });
	};
	
	function isTheSameComponents() {
	  var components1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var components2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return components1 === components2 || ['table', 'header', 'body'].every(function (key) {
	    return (0, _shallowequal["default"])(components1[key], components2[key]);
	  });
	}
	
	function getFilteredValueColumns(state, columns) {
	  return (0, _util.flatFilter)(columns || (state || {}).columns || [], function (column) {
	    return typeof column.filteredValue !== 'undefined';
	  });
	}
	
	function getFiltersFromColumns() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var columns = arguments.length > 1 ? arguments[1] : undefined;
	  var filters = {};
	  getFilteredValueColumns(state, columns).forEach(function (col) {
	    var colKey = getColumnKey(col);
	    filters[colKey] = col.filteredValue;
	  });
	  return filters;
	}
	
	function isFiltersChanged(state, filters) {
	  if (Object.keys(filters).length !== Object.keys(state.filters).length) {
	    return true;
	  }
	
	  return Object.keys(filters).some(function (columnKey) {
	    return filters[columnKey] !== state.filters[columnKey];
	  });
	}
	
	var Table = /*#__PURE__*/function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  var _super = _createSuper(Table);
	
	  function Table(props) {
	    var _this;
	
	    _classCallCheck(this, Table);
	
	    _this = _super.call(this, props);
	
	    _this.setTableRef = function (table) {
	      _this.rcTable = table;
	    };
	
	    _this.getCheckboxPropsByItem = function (item, index) {
	      var rowSelection = getRowSelection(_this.props);
	
	      if (!rowSelection.getCheckboxProps) {
	        return {};
	      }
	
	      var key = _this.getRecordKey(item, index); // Cache checkboxProps
	
	
	      if (!_this.props.checkboxPropsCache[key]) {
	        _this.props.checkboxPropsCache[key] = rowSelection.getCheckboxProps(item) || {};
	        var checkboxProps = _this.props.checkboxPropsCache[key];
	        (0, _warning["default"])(!('checked' in checkboxProps) && !('defaultChecked' in checkboxProps), 'Table', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
	      }
	
	      return _this.props.checkboxPropsCache[key];
	    };
	
	    _this.getRecordKey = function (record, index) {
	      var rowKey = _this.props.rowKey;
	      var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
	      (0, _warning["default"])(recordKey !== undefined, 'Table', 'Each record in dataSource of table should have a unique `key` prop, ' + 'or set `rowKey` of Table to an unique primary key, ' + 'see https://u.ant.design/table-row-key');
	      return recordKey === undefined ? index : recordKey;
	    };
	
	    _this.onRow = function (prefixCls, record, index) {
	      var onRow = _this.props.onRow;
	      var custom = onRow ? onRow(record, index) : {};
	      return _extends(_extends({}, custom), {
	        prefixCls: prefixCls,
	        store: _this.props.store,
	        rowKey: _this.getRecordKey(record, index)
	      });
	    };
	
	    _this.generatePopupContainerFunc = function (getPopupContainer) {
	      var scroll = _this.props.scroll;
	      var table = _this.rcTable;
	
	      if (getPopupContainer) {
	        return getPopupContainer;
	      } // Use undefined to let rc component use default logic.
	
	
	      return scroll && table ? function () {
	        return table.tableNode;
	      } : undefined;
	    };
	
	    _this.scrollToFirstRow = function () {
	      var scroll = _this.props.scroll;
	
	      if (scroll && scroll.scrollToFirstRowOnChange !== false) {
	        (0, _scrollTo["default"])(0, {
	          getContainer: function getContainer() {
	            return _this.rcTable.bodyTable;
	          }
	        });
	      }
	    };
	
	    _this.handleFilter = function (column, nextFilters) {
	      var props = _this.props;
	
	      var pagination = _extends({}, _this.state.pagination);
	
	      var filters = _extends(_extends({}, _this.state.filters), _defineProperty({}, getColumnKey(column), nextFilters)); // Remove filters not in current columns
	
	
	      var currentColumnKeys = [];
	      (0, _util.treeMap)(_this.state.columns, function (c) {
	        if (!c.children) {
	          currentColumnKeys.push(getColumnKey(c));
	        }
	      });
	      Object.keys(filters).forEach(function (columnKey) {
	        if (currentColumnKeys.indexOf(columnKey) < 0) {
	          delete filters[columnKey];
	        }
	      });
	
	      if (props.pagination) {
	        // Reset current prop
	        pagination.current = 1;
	        pagination.onChange(pagination.current);
	      }
	
	      var newState = {
	        pagination: pagination,
	        filters: {}
	      };
	
	      var filtersToSetState = _extends({}, filters); // Remove filters which is controlled
	
	
	      getFilteredValueColumns(_this.state).forEach(function (col) {
	        var columnKey = getColumnKey(col);
	
	        if (columnKey) {
	          delete filtersToSetState[columnKey];
	        }
	      });
	
	      if (Object.keys(filtersToSetState).length > 0) {
	        newState.filters = filtersToSetState;
	      } // Controlled current prop will not respond user interaction
	
	
	      if (_typeof(props.pagination) === 'object' && 'current' in props.pagination) {
	        newState.pagination = _extends(_extends({}, pagination), {
	          current: _this.state.pagination.current
	        });
	      }
	
	      _this.setState(newState, function () {
	        _this.scrollToFirstRow();
	
	        _this.props.store.setState({
	          selectionDirty: false
	        });
	
	        var onChange = _this.props.onChange;
	
	        if (onChange) {
	          onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	            selectionDirty: false,
	            filters: filters,
	            pagination: pagination
	          })));
	        }
	      });
	    };
	
	    _this.handleSelect = function (record, rowIndex, e) {
	      var checked = e.target.checked;
	      var nativeEvent = e.nativeEvent;
	      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	
	      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);
	
	      var key = _this.getRecordKey(record, rowIndex);
	
	      var pivot = _this.state.pivot;
	
	      var rows = _this.getFlatCurrentPageData();
	
	      var realIndex = rowIndex;
	
	      if (_this.props.expandedRowRender) {
	        realIndex = rows.findIndex(function (row) {
	          return _this.getRecordKey(row, rowIndex) === key;
	        });
	      }
	
	      if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
	        var changeRowKeys = [];
	        var direction = Math.sign(pivot - realIndex);
	        var dist = Math.abs(pivot - realIndex);
	        var step = 0;
	
	        var _loop = function _loop() {
	          var i = realIndex + step * direction;
	          step += 1;
	          var row = rows[i];
	
	          var rowKey = _this.getRecordKey(row, i);
	
	          var checkboxProps = _this.getCheckboxPropsByItem(row, i);
	
	          if (!checkboxProps.disabled) {
	            if (selectedRowKeys.includes(rowKey)) {
	              if (!checked) {
	                selectedRowKeys = selectedRowKeys.filter(function (j) {
	                  return rowKey !== j;
	                });
	                changeRowKeys.push(rowKey);
	              }
	            } else if (checked) {
	              selectedRowKeys.push(rowKey);
	              changeRowKeys.push(rowKey);
	            }
	          }
	        };
	
	        while (step <= dist) {
	          _loop();
	        }
	
	        _this.setState({
	          pivot: realIndex
	        });
	
	        _this.props.store.setState({
	          selectionDirty: true
	        });
	
	        _this.setSelectedRowKeys(selectedRowKeys, {
	          selectWay: 'onSelectMultiple',
	          record: record,
	          checked: checked,
	          changeRowKeys: changeRowKeys,
	          nativeEvent: nativeEvent
	        });
	      } else {
	        if (checked) {
	          selectedRowKeys.push(_this.getRecordKey(record, realIndex));
	        } else {
	          selectedRowKeys = selectedRowKeys.filter(function (i) {
	            return key !== i;
	          });
	        }
	
	        _this.setState({
	          pivot: realIndex
	        });
	
	        _this.props.store.setState({
	          selectionDirty: true
	        });
	
	        _this.setSelectedRowKeys(selectedRowKeys, {
	          selectWay: 'onSelect',
	          record: record,
	          checked: checked,
	          changeRowKeys: undefined,
	          nativeEvent: nativeEvent
	        });
	      }
	    };
	
	    _this.handleRadioSelect = function (record, rowIndex, e) {
	      var checked = e.target.checked;
	      var nativeEvent = e.nativeEvent;
	
	      var key = _this.getRecordKey(record, rowIndex);
	
	      var selectedRowKeys = [key];
	
	      _this.props.store.setState({
	        selectionDirty: true
	      });
	
	      _this.setSelectedRowKeys(selectedRowKeys, {
	        selectWay: 'onSelect',
	        record: record,
	        checked: checked,
	        changeRowKeys: undefined,
	        nativeEvent: nativeEvent
	      });
	    };
	
	    _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
	      var data = _this.getFlatCurrentPageData();
	
	      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	
	      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);
	
	      var changeableRowKeys = data.filter(function (item, i) {
	        return !_this.getCheckboxPropsByItem(item, i).disabled;
	      }).map(function (item, i) {
	        return _this.getRecordKey(item, i);
	      });
	      var changeRowKeys = [];
	      var selectWay = 'onSelectAll';
	      var checked; // handle default selection
	
	      switch (selectionKey) {
	        case 'all':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) < 0) {
	              selectedRowKeys.push(key);
	              changeRowKeys.push(key);
	            }
	          });
	          selectWay = 'onSelectAll';
	          checked = true;
	          break;
	
	        case 'removeAll':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) >= 0) {
	              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	              changeRowKeys.push(key);
	            }
	          });
	          selectWay = 'onSelectAll';
	          checked = false;
	          break;
	
	        case 'invert':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) < 0) {
	              selectedRowKeys.push(key);
	            } else {
	              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	            }
	
	            changeRowKeys.push(key);
	            selectWay = 'onSelectInvert';
	          });
	          break;
	
	        default:
	          break;
	      }
	
	      _this.props.store.setState({
	        selectionDirty: true
	      }); // when select custom selection, callback selections[n].onSelect
	
	
	      var rowSelection = _this.props.rowSelection;
	      var customSelectionStartIndex = 2;
	
	      if (rowSelection && rowSelection.hideDefaultSelections) {
	        customSelectionStartIndex = 0;
	      }
	
	      if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
	        return onSelectFunc(changeableRowKeys);
	      }
	
	      _this.setSelectedRowKeys(selectedRowKeys, {
	        selectWay: selectWay,
	        checked: checked,
	        changeRowKeys: changeRowKeys
	      });
	    };
	
	    _this.handlePageChange = function (current) {
	      var props = _this.props;
	
	      var pagination = _extends({}, _this.state.pagination);
	
	      if (current) {
	        pagination.current = current;
	      } else {
	        pagination.current = pagination.current || 1;
	      }
	
	      for (var _len = arguments.length, otherArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        otherArguments[_key - 1] = arguments[_key];
	      }
	
	      pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
	      var newState = {
	        pagination: pagination
	      }; // Controlled current prop will not respond user interaction
	
	      if (props.pagination && _typeof(props.pagination) === 'object' && 'current' in props.pagination) {
	        newState.pagination = _extends(_extends({}, pagination), {
	          current: _this.state.pagination.current
	        });
	      }
	
	      _this.setState(newState, _this.scrollToFirstRow);
	
	      _this.props.store.setState({
	        selectionDirty: false
	      });
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	          selectionDirty: false,
	          pagination: pagination
	        })));
	      }
	    };
	
	    _this.handleShowSizeChange = function (current, pageSize) {
	      var pagination = _this.state.pagination;
	      pagination.onShowSizeChange(current, pageSize);
	
	      var nextPagination = _extends(_extends({}, pagination), {
	        pageSize: pageSize,
	        current: current
	      });
	
	      _this.setState({
	        pagination: nextPagination
	      }, _this.scrollToFirstRow);
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	          pagination: nextPagination
	        })));
	      }
	    };
	
	    _this.renderExpandIcon = function (prefixCls) {
	      return function (_ref) {
	        var expandable = _ref.expandable,
	            expanded = _ref.expanded,
	            needIndentSpaced = _ref.needIndentSpaced,
	            record = _ref.record,
	            onExpand = _ref.onExpand;
	
	        if (expandable) {
	          return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	              componentName: "Table",
	              defaultLocale: _default2["default"].Table
	            }, function (locale) {
	              var _classNames;
	
	              return (/*#__PURE__*/React.createElement(_transButton["default"], {
	                  className: (0, _classnames["default"])("".concat(prefixCls, "-row-expand-icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _defineProperty(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), _classNames)),
	                  onClick: function onClick(event) {
	                    onExpand(record, event);
	                  },
	                  "aria-label": expanded ? locale.collapse : locale.expand,
	                  noStyle: true
	                })
	              );
	            })
	          );
	        }
	
	        if (needIndentSpaced) {
	          return (/*#__PURE__*/React.createElement("span", {
	              className: "".concat(prefixCls, "-row-expand-icon ").concat(prefixCls, "-row-spaced")
	            })
	          );
	        }
	
	        return null;
	      };
	    };
	
	    _this.renderSelectionBox = function (type) {
	      return function (_, record, index) {
	        var rowKey = _this.getRecordKey(record, index);
	
	        var props = _this.getCheckboxPropsByItem(record, index);
	
	        var handleChange = function handleChange(e) {
	          return type === 'radio' ? _this.handleRadioSelect(record, index, e) : _this.handleSelect(record, index, e);
	        };
	
	        return (/*#__PURE__*/React.createElement("span", {
	            onClick: stopPropagation
	          }, /*#__PURE__*/React.createElement(_SelectionBox["default"], _extends({
	            type: type,
	            store: _this.props.store,
	            rowIndex: rowKey,
	            onChange: handleChange,
	            defaultSelection: _this.getDefaultSelection()
	          }, props)))
	        );
	      };
	    };
	
	    _this.renderTable = function (_ref2) {
	      var _classNames2;
	
	      var prefixCls = _ref2.prefixCls,
	          renderEmpty = _ref2.renderEmpty,
	          dropdownPrefixCls = _ref2.dropdownPrefixCls,
	          contextLocale = _ref2.contextLocale,
	          contextGetPopupContainer = _ref2.getPopupContainer;
	
	      var _a = _this.props,
	          showHeader = _a.showHeader,
	          locale = _a.locale,
	          getPopupContainer = _a.getPopupContainer,
	          restTableProps = __rest(_a, ["showHeader", "locale", "getPopupContainer"]); // do not pass prop.style to rc-table, since already apply it to container div
	
	
	      var restProps = (0, _omit["default"])(restTableProps, ['style']);
	
	      var data = _this.getCurrentPageData();
	
	      var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false; // use props.getPopupContainer first
	
	      var realGetPopupContainer = getPopupContainer || contextGetPopupContainer; // Merge too locales
	
	      var mergedLocale = _extends(_extends({}, contextLocale), locale);
	
	      if (!locale || !locale.emptyText) {
	        mergedLocale.emptyText = renderEmpty('Table');
	      }
	
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-").concat(_this.props.size), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-bordered"), _this.props.bordered), _defineProperty(_classNames2, "".concat(prefixCls, "-empty"), !data.length), _defineProperty(_classNames2, "".concat(prefixCls, "-without-column-header"), !showHeader), _classNames2));
	
	      var columnsWithRowSelection = _this.renderRowSelection({
	        prefixCls: prefixCls,
	        locale: mergedLocale,
	        getPopupContainer: realGetPopupContainer
	      });
	
	      var columns = _this.renderColumnsDropdown({
	        columns: columnsWithRowSelection,
	        prefixCls: prefixCls,
	        dropdownPrefixCls: dropdownPrefixCls,
	        locale: mergedLocale,
	        getPopupContainer: realGetPopupContainer
	      }).map(function (column, i) {
	        var newColumn = _extends({}, column);
	
	        newColumn.key = getColumnKey(newColumn, i);
	        return newColumn;
	      });
	
	      var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;
	
	      if ('expandIconColumnIndex' in restProps) {
	        expandIconColumnIndex = restProps.expandIconColumnIndex;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcTable["default"], _extends({
	          ref: _this.setTableRef,
	          key: "table",
	          expandIcon: _this.renderExpandIcon(prefixCls)
	        }, restProps, {
	          onRow: function onRow(record, index) {
	            return _this.onRow(prefixCls, record, index);
	          },
	          components: _this.state.components,
	          prefixCls: prefixCls,
	          data: data,
	          columns: columns,
	          showHeader: showHeader,
	          className: classString,
	          expandIconColumnIndex: expandIconColumnIndex,
	          expandIconAsCell: expandIconAsCell,
	          emptyText: mergedLocale.emptyText
	        }))
	      );
	    };
	
	    _this.renderComponent = function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls,
	          renderEmpty = _ref3.renderEmpty,
	          getPopupContainer = _ref3.getPopupContainer;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          customizeDropdownPrefixCls = _this$props.dropdownPrefixCls,
	          style = _this$props.style,
	          className = _this$props.className;
	
	      var data = _this.getCurrentPageData();
	
	      var loading = _this.props.loading;
	
	      if (typeof loading === 'boolean') {
	        loading = {
	          spinning: loading
	        };
	      }
	
	      var prefixCls = getPrefixCls('table', customizePrefixCls);
	      var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
	      var table = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Table",
	        defaultLocale: _default2["default"].Table
	      }, function (locale) {
	        return _this.renderTable({
	          prefixCls: prefixCls,
	          renderEmpty: renderEmpty,
	          dropdownPrefixCls: dropdownPrefixCls,
	          contextLocale: locale,
	          getPopupContainer: getPopupContainer
	        });
	      }); // if there is no pagination or no data,
	      // the height of spin should decrease by half of pagination
	
	      var paginationPatchClass = _this.hasPagination() && data && data.length !== 0 ? "".concat(prefixCls, "-with-pagination") : "".concat(prefixCls, "-without-pagination");
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), className),
	          style: style
	        }, /*#__PURE__*/React.createElement(_spin["default"], _extends({}, loading, {
	          className: loading.spinning ? "".concat(paginationPatchClass, " ").concat(prefixCls, "-spin-holder") : ''
	        }), _this.renderPagination(prefixCls, 'top'), table, _this.renderPagination(prefixCls, 'bottom')))
	      );
	    };
	
	    var expandedRowRender = props.expandedRowRender,
	        columnsProp = props.columns;
	    (0, _warning["default"])(!('columnsPageRange' in props || 'columnsPageSize' in props), 'Table', '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');
	
	    if (expandedRowRender && (columnsProp || []).some(function (_ref4) {
	      var fixed = _ref4.fixed;
	      return !!fixed;
	    })) {
	      (0, _warning["default"])(false, 'Table', '`expandedRowRender` and `Column.fixed` are not compatible. Please use one of them at one time.');
	    }
	
	    var columns = columnsProp || (0, _util.normalizeColumns)(props.children);
	    _this.state = _extends(_extends({}, _this.getDefaultSortOrder(columns || [])), {
	      // 减少状态
	      filters: _this.getDefaultFilters(columns),
	      pagination: _this.getDefaultPagination(props),
	      pivot: undefined,
	      prevProps: props,
	      components: createComponents(props.components),
	      columns: columns
	    });
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this$state = this.state,
	          columns = _this$state.columns,
	          sortColumn = _this$state.sortColumn,
	          sortOrder = _this$state.sortOrder;
	
	      if (this.getSortOrderColumns(columns).length > 0) {
	        var sortState = this.getSortStateFromColumns(columns);
	
	        if (!isSameColumn(sortState.sortColumn, sortColumn) || sortState.sortOrder !== sortOrder) {
	          this.setState(sortState);
	        }
	      }
	    }
	  }, {
	    key: "getDefaultSelection",
	    value: function getDefaultSelection() {
	      var _this2 = this;
	
	      var rowSelection = getRowSelection(this.props);
	
	      if (!rowSelection.getCheckboxProps) {
	        return [];
	      }
	
	      return this.getFlatData().filter(function (item, rowIndex) {
	        return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
	      }).map(function (record, rowIndex) {
	        return _this2.getRecordKey(record, rowIndex);
	      });
	    }
	  }, {
	    key: "getDefaultPagination",
	    value: function getDefaultPagination(props) {
	      var pagination = _typeof(props.pagination) === 'object' ? props.pagination : {};
	      var current;
	
	      if ('current' in pagination) {
	        current = pagination.current;
	      } else if ('defaultCurrent' in pagination) {
	        current = pagination.defaultCurrent;
	      }
	
	      var pageSize;
	
	      if ('pageSize' in pagination) {
	        pageSize = pagination.pageSize;
	      } else if ('defaultPageSize' in pagination) {
	        pageSize = pagination.defaultPageSize;
	      }
	
	      return this.hasPagination(props) ? _extends(_extends(_extends({}, defaultPagination), pagination), {
	        current: current || 1,
	        pageSize: pageSize || 10
	      }) : {};
	    }
	  }, {
	    key: "getSortOrderColumns",
	    value: function getSortOrderColumns(columns) {
	      return (0, _util.flatFilter)(columns || (this.state || {}).columns || [], function (column) {
	        return 'sortOrder' in column;
	      });
	    }
	  }, {
	    key: "getDefaultFilters",
	    value: function getDefaultFilters(columns) {
	      var definedFilters = getFiltersFromColumns(this.state, columns);
	      var defaultFilteredValueColumns = (0, _util.flatFilter)(columns || [], function (column) {
	        return typeof column.defaultFilteredValue !== 'undefined';
	      });
	      var defaultFilters = defaultFilteredValueColumns.reduce(function (soFar, col) {
	        var colKey = getColumnKey(col);
	        soFar[colKey] = col.defaultFilteredValue;
	        return soFar;
	      }, {});
	      return _extends(_extends({}, defaultFilters), definedFilters);
	    }
	  }, {
	    key: "getDefaultSortOrder",
	    value: function getDefaultSortOrder(columns) {
	      var definedSortState = this.getSortStateFromColumns(columns);
	      var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
	        return column.defaultSortOrder != null;
	      })[0];
	
	      if (defaultSortedColumn && !definedSortState.sortColumn) {
	        return {
	          sortColumn: defaultSortedColumn,
	          sortOrder: defaultSortedColumn.defaultSortOrder
	        };
	      }
	
	      return definedSortState;
	    }
	  }, {
	    key: "getSortStateFromColumns",
	    value: function getSortStateFromColumns(columns) {
	      // return first column which sortOrder is not falsy
	      var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
	        return col.sortOrder;
	      })[0];
	
	      if (sortedColumn) {
	        return {
	          sortColumn: sortedColumn,
	          sortOrder: sortedColumn.sortOrder
	        };
	      }
	
	      return {
	        sortColumn: null,
	        sortOrder: null
	      };
	    }
	  }, {
	    key: "getMaxCurrent",
	    value: function getMaxCurrent(total) {
	      var _this$state$paginatio = this.state.pagination,
	          current = _this$state$paginatio.current,
	          pageSize = _this$state$paginatio.pageSize;
	
	      if ((current - 1) * pageSize >= total) {
	        return Math.floor((total - 1) / pageSize) + 1;
	      }
	
	      return current;
	    }
	  }, {
	    key: "getSorterFn",
	    value: function getSorterFn(state) {
	      var _ref5 = state || this.state,
	          sortOrder = _ref5.sortOrder,
	          sortColumn = _ref5.sortColumn;
	
	      if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
	        return;
	      }
	
	      return function (a, b) {
	        var result = sortColumn.sorter(a, b, sortOrder);
	
	        if (result !== 0) {
	          return sortOrder === 'descend' ? -result : result;
	        }
	
	        return 0;
	      };
	    }
	  }, {
	    key: "getCurrentPageData",
	    value: function getCurrentPageData() {
	      var data = this.getLocalData();
	      var current;
	      var pageSize;
	      var state = this.state; // 如果没有分页的话，默认全部展示
	
	      if (!this.hasPagination()) {
	        pageSize = Number.MAX_VALUE;
	        current = 1;
	      } else {
	        pageSize = state.pagination.pageSize;
	        current = this.getMaxCurrent(state.pagination.total || data.length);
	      } // 分页
	      // ---
	      // 当数据量少于等于每页数量时，直接设置数据
	      // 否则进行读取分页数据
	
	
	      if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
	        data = data.slice((current - 1) * pageSize, current * pageSize);
	      }
	
	      return data;
	    }
	  }, {
	    key: "getFlatData",
	    value: function getFlatData() {
	      var childrenColumnName = this.props.childrenColumnName;
	      return (0, _util.flatArray)(this.getLocalData(null, false), childrenColumnName);
	    }
	  }, {
	    key: "getFlatCurrentPageData",
	    value: function getFlatCurrentPageData() {
	      var childrenColumnName = this.props.childrenColumnName;
	      return (0, _util.flatArray)(this.getCurrentPageData(), childrenColumnName);
	    }
	  }, {
	    key: "getLocalData",
	    value: function getLocalData(state) {
	      var _this3 = this;
	
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var currentState = state || this.state;
	      var dataSource = this.props.dataSource;
	      var data = dataSource || []; // 优化本地排序
	
	      data = data.slice(0);
	      var sorterFn = this.getSorterFn(currentState);
	
	      if (sorterFn) {
	        data = this.recursiveSort(data, sorterFn);
	      } // 筛选
	
	
	      if (filter && currentState.filters) {
	        Object.keys(currentState.filters).forEach(function (columnKey) {
	          var col = _this3.findColumn(columnKey);
	
	          if (!col) {
	            return;
	          }
	
	          var values = currentState.filters[columnKey] || [];
	
	          if (values.length === 0) {
	            return;
	          }
	
	          var onFilter = col.onFilter;
	          data = onFilter ? data.filter(function (record) {
	            return values.some(function (v) {
	              return onFilter(v, record);
	            });
	          }) : data;
	        });
	      }
	
	      return data;
	    }
	  }, {
	    key: "setSelectedRowKeys",
	    value: function setSelectedRowKeys(selectedRowKeys, selectionInfo) {
	      var _this4 = this;
	
	      var selectWay = selectionInfo.selectWay,
	          record = selectionInfo.record,
	          checked = selectionInfo.checked,
	          changeRowKeys = selectionInfo.changeRowKeys,
	          nativeEvent = selectionInfo.nativeEvent;
	      var rowSelection = getRowSelection(this.props);
	
	      if (rowSelection && !('selectedRowKeys' in rowSelection)) {
	        this.props.store.setState({
	          selectedRowKeys: selectedRowKeys
	        });
	      }
	
	      var data = this.getFlatData();
	
	      if (!rowSelection.onChange && !rowSelection[selectWay]) {
	        return;
	      }
	
	      var selectedRows = data.filter(function (row, i) {
	        return selectedRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	      });
	
	      if (rowSelection.onChange) {
	        rowSelection.onChange(selectedRowKeys, selectedRows);
	      }
	
	      if (selectWay === 'onSelect' && rowSelection.onSelect) {
	        rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
	      } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
	        var changeRows = data.filter(function (row, i) {
	          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	        });
	        rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
	      } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
	        var _changeRows = data.filter(function (row, i) {
	          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	        });
	
	        rowSelection.onSelectAll(checked, selectedRows, _changeRows);
	      } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
	        rowSelection.onSelectInvert(selectedRowKeys);
	      }
	    }
	  }, {
	    key: "toggleSortOrder",
	    value: function toggleSortOrder(column) {
	      var sortDirections = column.sortDirections || this.props.sortDirections;
	      var _this$state2 = this.state,
	          sortOrder = _this$state2.sortOrder,
	          sortColumn = _this$state2.sortColumn; // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题
	
	      var newSortOrder; // 切换另一列时，丢弃 sortOrder 的状态
	
	      if (isSameColumn(sortColumn, column) && sortOrder !== undefined) {
	        // 按照sortDirections的内容依次切换排序状态
	        var methodIndex = sortDirections.indexOf(sortOrder) + 1;
	        newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
	      } else {
	        newSortOrder = sortDirections[0];
	      }
	
	      var newState = {
	        sortOrder: newSortOrder,
	        sortColumn: newSortOrder ? column : null
	      }; // Controlled
	
	      if (this.getSortOrderColumns().length === 0) {
	        this.setState(newState, this.scrollToFirstRow);
	      }
	
	      var onChange = this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, this.prepareParamsArguments(_extends(_extends({}, this.state), newState), column));
	      }
	    }
	  }, {
	    key: "hasPagination",
	    value: function hasPagination(props) {
	      return (props || this.props).pagination !== false;
	    }
	  }, {
	    key: "isSortColumn",
	    value: function isSortColumn(column) {
	      var sortColumn = this.state.sortColumn;
	
	      if (!column || !sortColumn) {
	        return false;
	      }
	
	      return getColumnKey(sortColumn) === getColumnKey(column);
	    } // Get pagination, filters, sorter
	
	  }, {
	    key: "prepareParamsArguments",
	    value: function prepareParamsArguments(state, column) {
	      var pagination = _extends({}, state.pagination); // remove useless handle function in Table.onChange
	
	
	      delete pagination.onChange;
	      delete pagination.onShowSizeChange;
	      var filters = state.filters;
	      var sorter = {};
	      var currentColumn = column;
	
	      if (state.sortColumn && state.sortOrder) {
	        currentColumn = state.sortColumn;
	        sorter.column = state.sortColumn;
	        sorter.order = state.sortOrder;
	      }
	
	      if (currentColumn) {
	        sorter.field = currentColumn.dataIndex;
	        sorter.columnKey = getColumnKey(currentColumn);
	      }
	
	      var extra = {
	        currentDataSource: this.getLocalData(state)
	      };
	      return [pagination, filters, sorter, extra];
	    }
	  }, {
	    key: "findColumn",
	    value: function findColumn(myKey) {
	      var column;
	      (0, _util.treeMap)(this.state.columns, function (c) {
	        if (getColumnKey(c) === myKey) {
	          column = c;
	        }
	      });
	      return column;
	    }
	  }, {
	    key: "recursiveSort",
	    value: function recursiveSort(data, sorterFn) {
	      var _this5 = this;
	
	      var _this$props$childrenC = this.props.childrenColumnName,
	          childrenColumnName = _this$props$childrenC === void 0 ? 'children' : _this$props$childrenC;
	      return data.sort(sorterFn).map(function (item) {
	        return item[childrenColumnName] ? _extends(_extends({}, item), _defineProperty({}, childrenColumnName, _this5.recursiveSort(item[childrenColumnName], sorterFn))) : item;
	      });
	    }
	  }, {
	    key: "renderPagination",
	    value: function renderPagination(prefixCls, paginationPosition) {
	      // 强制不需要分页
	      if (!this.hasPagination()) {
	        return null;
	      }
	
	      var size = 'default';
	      var pagination = this.state.pagination;
	
	      if (pagination.size) {
	        size = pagination.size;
	      } else if (this.props.size === 'middle' || this.props.size === 'small') {
	        size = 'small';
	      }
	
	      var position = pagination.position || 'bottom';
	      var total = pagination.total || this.getLocalData().length;
	      return total > 0 && (position === paginationPosition || position === 'both') ? /*#__PURE__*/React.createElement(_pagination["default"], _extends({
	        key: "pagination-".concat(paginationPosition)
	      }, pagination, {
	        className: (0, _classnames["default"])(pagination.className, "".concat(prefixCls, "-pagination")),
	        onChange: this.handlePageChange,
	        total: total,
	        size: size,
	        current: this.getMaxCurrent(total),
	        onShowSizeChange: this.handleShowSizeChange
	      })) : null;
	    }
	  }, {
	    key: "renderRowSelection",
	    value: function renderRowSelection(_ref6) {
	      var _this6 = this;
	
	      var prefixCls = _ref6.prefixCls,
	          locale = _ref6.locale,
	          getPopupContainer = _ref6.getPopupContainer;
	      var rowSelection = this.props.rowSelection;
	      var columns = this.state.columns.concat();
	
	      if (rowSelection) {
	        var data = this.getFlatCurrentPageData().filter(function (item, index) {
	          if (rowSelection.getCheckboxProps) {
	            return !_this6.getCheckboxPropsByItem(item, index).disabled;
	          }
	
	          return true;
	        });
	        var selectionColumnClass = (0, _classnames["default"])("".concat(prefixCls, "-selection-column"), _defineProperty({}, "".concat(prefixCls, "-selection-column-custom"), rowSelection.selections));
	
	        var selectionColumn = _defineProperty({
	          key: 'selection-column',
	          render: this.renderSelectionBox(rowSelection.type),
	          className: selectionColumnClass,
	          fixed: rowSelection.fixed,
	          width: rowSelection.columnWidth,
	          title: rowSelection.columnTitle
	        }, _rcTable.INTERNAL_COL_DEFINE, {
	          className: "".concat(prefixCls, "-selection-col")
	        });
	
	        if (rowSelection.type !== 'radio') {
	          var checkboxAllDisabled = data.every(function (item, index) {
	            return _this6.getCheckboxPropsByItem(item, index).disabled;
	          });
	          selectionColumn.title = selectionColumn.title || /*#__PURE__*/React.createElement(_SelectionCheckboxAll["default"], {
	            store: this.props.store,
	            locale: locale,
	            data: data,
	            getCheckboxPropsByItem: this.getCheckboxPropsByItem,
	            getRecordKey: this.getRecordKey,
	            disabled: checkboxAllDisabled,
	            prefixCls: prefixCls,
	            onSelect: this.handleSelectRow,
	            selections: rowSelection.selections,
	            hideDefaultSelections: rowSelection.hideDefaultSelections,
	            getPopupContainer: this.generatePopupContainerFunc(getPopupContainer)
	          });
	        }
	
	        if ('fixed' in rowSelection) {
	          selectionColumn.fixed = rowSelection.fixed;
	        } else if (columns.some(function (column) {
	          return column.fixed === 'left' || column.fixed === true;
	        })) {
	          selectionColumn.fixed = 'left';
	        }
	
	        if (columns[0] && columns[0].key === 'selection-column') {
	          columns[0] = selectionColumn;
	        } else {
	          columns.unshift(selectionColumn);
	        }
	      }
	
	      return columns;
	    }
	  }, {
	    key: "renderColumnsDropdown",
	    value: function renderColumnsDropdown(_ref7) {
	      var _this7 = this;
	
	      var prefixCls = _ref7.prefixCls,
	          dropdownPrefixCls = _ref7.dropdownPrefixCls,
	          columns = _ref7.columns,
	          locale = _ref7.locale,
	          getPopupContainer = _ref7.getPopupContainer;
	      var _this$state3 = this.state,
	          sortOrder = _this$state3.sortOrder,
	          filters = _this$state3.filters;
	      return (0, _util.treeMap)(columns, function (column, i) {
	        var _classNames4;
	
	        var key = getColumnKey(column, i);
	        var filterDropdown;
	        var sortButton;
	        var onHeaderCell = column.onHeaderCell;
	
	        var isSortColumn = _this7.isSortColumn(column);
	
	        if (column.filters && column.filters.length > 0 || column.filterDropdown) {
	          var colFilters = key in filters ? filters[key] : [];
	          filterDropdown = /*#__PURE__*/React.createElement(_filterDropdown["default"], {
	            locale: locale,
	            column: column,
	            selectedKeys: colFilters,
	            confirmFilter: _this7.handleFilter,
	            prefixCls: "".concat(prefixCls, "-filter"),
	            dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown',
	            getPopupContainer: _this7.generatePopupContainerFunc(getPopupContainer),
	            key: "filter-dropdown"
	          });
	        }
	
	        if (column.sorter) {
	          var sortDirections = column.sortDirections || _this7.props.sortDirections;
	          var isAscend = isSortColumn && sortOrder === 'ascend';
	          var isDescend = isSortColumn && sortOrder === 'descend';
	          var ascend = sortDirections.indexOf('ascend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
	            className: "".concat(prefixCls, "-column-sorter-up ").concat(isAscend ? 'on' : 'off'),
	            type: "caret-up",
	            theme: "filled"
	          });
	          var descend = sortDirections.indexOf('descend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
	            className: "".concat(prefixCls, "-column-sorter-down ").concat(isDescend ? 'on' : 'off'),
	            type: "caret-down",
	            theme: "filled"
	          });
	          sortButton = /*#__PURE__*/React.createElement("div", {
	            title: locale.sortTitle,
	            className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter-inner"), ascend && descend && "".concat(prefixCls, "-column-sorter-inner-full")),
	            key: "sorter"
	          }, ascend, descend);
	
	          onHeaderCell = function onHeaderCell(col) {
	            var colProps = {}; // Get original first
	
	            if (column.onHeaderCell) {
	              colProps = _extends({}, column.onHeaderCell(col));
	            } // Add sorter logic
	
	
	            var onHeaderCellClick = colProps.onClick;
	
	            colProps.onClick = function () {
	              _this7.toggleSortOrder(column);
	
	              if (onHeaderCellClick) {
	                onHeaderCellClick.apply(void 0, arguments);
	              }
	            };
	
	            return colProps;
	          };
	        }
	
	        return _extends(_extends({}, column), {
	          className: (0, _classnames["default"])(column.className, (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-actions"), sortButton || filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-filters"), filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-sorters"), sortButton), _defineProperty(_classNames4, "".concat(prefixCls, "-column-sort"), isSortColumn && sortOrder), _classNames4)),
	          title: [/*#__PURE__*/React.createElement("span", {
	            key: "title",
	            className: "".concat(prefixCls, "-header-column")
	          }, /*#__PURE__*/React.createElement("div", {
	            className: sortButton ? "".concat(prefixCls, "-column-sorters") : undefined
	          }, /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-column-title")
	          }, _this7.renderColumnTitle(column.title)), /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-column-sorter")
	          }, sortButton))), filterDropdown],
	          onHeaderCell: onHeaderCell
	        });
	      });
	    }
	  }, {
	    key: "renderColumnTitle",
	    value: function renderColumnTitle(title) {
	      var _this$state4 = this.state,
	          filters = _this$state4.filters,
	          sortOrder = _this$state4.sortOrder,
	          sortColumn = _this$state4.sortColumn; // https://github.com/ant-design/ant-design/issues/11246#issuecomment-405009167
	
	      if (title instanceof Function) {
	        return title({
	          filters: filters,
	          sortOrder: sortOrder,
	          sortColumn: sortColumn
	        });
	      }
	
	      return title;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);
	
	      var nextState = _extends(_extends({}, prevState), {
	        prevProps: nextProps,
	        columns: columns
	      });
	
	      if ('pagination' in nextProps || 'pagination' in prevProps) {
	        var newPagination = _extends(_extends(_extends({}, defaultPagination), prevState.pagination), nextProps.pagination);
	
	        newPagination.current = newPagination.current || 1;
	        newPagination.pageSize = newPagination.pageSize || 10;
	        nextState = _extends(_extends({}, nextState), {
	          pagination: nextProps.pagination !== false ? newPagination : emptyObject
	        });
	      }
	
	      if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
	        nextProps.store.setState({
	          selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
	        });
	      } else if (prevProps.rowSelection && !nextProps.rowSelection) {
	        nextProps.store.setState({
	          selectedRowKeys: []
	        });
	      }
	
	      if ('dataSource' in nextProps && nextProps.dataSource !== prevProps.dataSource) {
	        nextProps.store.setState({
	          selectionDirty: false
	        });
	      } // https://github.com/ant-design/ant-design/issues/10133
	
	
	      nextProps.setCheckboxPropsCache({}); // Update filters
	
	      var filteredValueColumns = getFilteredValueColumns(nextState, nextState.columns);
	
	      if (filteredValueColumns.length > 0) {
	        var filtersFromColumns = getFiltersFromColumns(nextState, nextState.columns);
	
	        var newFilters = _extends({}, nextState.filters);
	
	        Object.keys(filtersFromColumns).forEach(function (key) {
	          newFilters[key] = filtersFromColumns[key];
	        });
	
	        if (isFiltersChanged(nextState, newFilters)) {
	          nextState = _extends(_extends({}, nextState), {
	            filters: newFilters
	          });
	        }
	      }
	
	      if (!isTheSameComponents(nextProps.components, prevProps.components)) {
	        var components = createComponents(nextProps.components);
	        nextState = _extends(_extends({}, nextState), {
	          components: components
	        });
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return Table;
	}(React.Component);
	
	Table.propTypes = {
	  dataSource: PropTypes.array,
	  columns: PropTypes.array,
	  prefixCls: PropTypes.string,
	  useFixedHeader: PropTypes.bool,
	  rowSelection: PropTypes.object,
	  className: PropTypes.string,
	  size: PropTypes.string,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  bordered: PropTypes.bool,
	  onChange: PropTypes.func,
	  locale: PropTypes.object,
	  dropdownPrefixCls: PropTypes.string,
	  sortDirections: PropTypes.array,
	  getPopupContainer: PropTypes.func
	};
	Table.defaultProps = {
	  dataSource: [],
	  useFixedHeader: false,
	  className: '',
	  size: 'default',
	  loading: false,
	  bordered: false,
	  indentSize: 20,
	  locale: {},
	  rowKey: 'key',
	  showHeader: true,
	  sortDirections: ['ascend', 'descend'],
	  childrenColumnName: 'children'
	};
	(0, _reactLifecyclesCompat.polyfill)(Table);
	
	var StoreTable = /*#__PURE__*/function (_React$Component2) {
	  _inherits(StoreTable, _React$Component2);
	
	  var _super2 = _createSuper(StoreTable);
	
	  function StoreTable(props) {
	    var _this8;
	
	    _classCallCheck(this, StoreTable);
	
	    _this8 = _super2.call(this, props);
	
	    _this8.setCheckboxPropsCache = function (cache) {
	      return _this8.CheckboxPropsCache = cache;
	    };
	
	    _this8.CheckboxPropsCache = {};
	    _this8.store = (0, _createStore["default"])({
	      selectedRowKeys: getRowSelection(props).selectedRowKeys || [],
	      selectionDirty: false
	    });
	    return _this8;
	  }
	
	  _createClass(StoreTable, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
	          store: this.store,
	          checkboxPropsCache: this.CheckboxPropsCache,
	          setCheckboxPropsCache: this.setCheckboxPropsCache
	        }))
	      );
	    }
	  }]);
	
	  return StoreTable;
	}(React.Component);
	
	StoreTable.displayName = 'withStore(Table)';
	StoreTable.Column = _Column["default"];
	StoreTable.ColumnGroup = _ColumnGroup["default"];
	var _default = StoreTable;
	exports["default"] = _default;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createBodyRow;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function createBodyRow() {
	  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';
	
	  var BodyRow = /*#__PURE__*/function (_React$Component) {
	    _inherits(BodyRow, _React$Component);
	
	    var _super = _createSuper(BodyRow);
	
	    function BodyRow(props) {
	      var _this;
	
	      _classCallCheck(this, BodyRow);
	
	      _this = _super.call(this, props);
	      _this.store = props.store;
	
	      var _this$store$getState = _this.store.getState(),
	          selectedRowKeys = _this$store$getState.selectedRowKeys;
	
	      _this.state = {
	        selected: selectedRowKeys.indexOf(props.rowKey) >= 0
	      };
	      return _this;
	    }
	
	    _createClass(BodyRow, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.subscribe();
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	        }
	      }
	    }, {
	      key: "subscribe",
	      value: function subscribe() {
	        var _this2 = this;
	
	        var _this$props = this.props,
	            store = _this$props.store,
	            rowKey = _this$props.rowKey;
	        this.unsubscribe = store.subscribe(function () {
	          var _this2$store$getState = _this2.store.getState(),
	              selectedRowKeys = _this2$store$getState.selectedRowKeys;
	
	          var selected = selectedRowKeys.indexOf(rowKey) >= 0;
	
	          if (selected !== _this2.state.selected) {
	            _this2.setState({
	              selected: selected
	            });
	          }
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var rowProps = (0, _omit["default"])(this.props, ['prefixCls', 'rowKey', 'store']);
	        var className = (0, _classnames2["default"])(this.props.className, _defineProperty({}, "".concat(this.props.prefixCls, "-row-selected"), this.state.selected));
	        return (/*#__PURE__*/React.createElement(Component, _extends(_extends({}, rowProps), {
	            className: className
	          }), this.props.children)
	        );
	      }
	    }]);
	
	    return BodyRow;
	  }(React.Component);
	
	  return BodyRow;
	}

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createStore;
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function createStore(initialState) {
	  var state = initialState;
	  var listeners = [];
	
	  function setState(partial) {
	    state = _extends(_extends({}, state), partial);
	
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	  }
	
	  function getState() {
	    return state;
	  }
	
	  function subscribe(listener) {
	    listeners.push(listener);
	    return function unsubscribe() {
	      var index = listeners.indexOf(listener);
	      listeners.splice(index, 1);
	    };
	  }
	
	  return {
	    setState: setState,
	    getState: getState,
	    subscribe: subscribe
	  };
	}

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(93));
	
	var _domClosest = _interopRequireDefault(__webpack_require__(509));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(356));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(156));
	
	var _radio = _interopRequireDefault(__webpack_require__(245));
	
	var _FilterDropdownMenuWrapper = _interopRequireDefault(__webpack_require__(1258));
	
	var _util = __webpack_require__(657);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function stopPropagation(e) {
	  e.stopPropagation();
	
	  if (e.nativeEvent.stopImmediatePropagation) {
	    e.nativeEvent.stopImmediatePropagation();
	  }
	}
	
	var FilterMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(FilterMenu, _React$Component);
	
	  var _super = _createSuper(FilterMenu);
	
	  function FilterMenu(props) {
	    var _this;
	
	    _classCallCheck(this, FilterMenu);
	
	    _this = _super.call(this, props);
	
	    _this.setNeverShown = function (column) {
	      var rootNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var filterBelongToScrollBody = !!(0, _domClosest["default"])(rootNode, ".ant-table-scroll");
	
	      if (filterBelongToScrollBody) {
	        // When fixed column have filters, there will be two dropdown menus
	        // Filter dropdown menu inside scroll body should never be shown
	        // To fix https://github.com/ant-design/ant-design/issues/5010 and
	        // https://github.com/ant-design/ant-design/issues/7909
	        _this.neverShown = !!column.fixed;
	      }
	    };
	
	    _this.setSelectedKeys = function (_ref) {
	      var selectedKeys = _ref.selectedKeys;
	
	      _this.setState({
	        selectedKeys: selectedKeys
	      });
	    };
	
	    _this.handleClearFilters = function () {
	      _this.setState({
	        selectedKeys: []
	      }, _this.handleConfirm);
	    };
	
	    _this.handleConfirm = function () {
	      _this.setVisible(false); // Call `setSelectedKeys` & `confirm` in the same time will make filter data not up to date
	      // https://github.com/ant-design/ant-design/issues/12284
	
	
	      _this.setState({}, _this.confirmFilter);
	    };
	
	    _this.onVisibleChange = function (visible) {
	      _this.setVisible(visible);
	
	      var column = _this.props.column; // https://github.com/ant-design/ant-design/issues/17833
	
	      if (!visible && !(column.filterDropdown instanceof Function)) {
	        _this.confirmFilter();
	      }
	    };
	
	    _this.handleMenuItemClick = function (info) {
	      var selectedKeys = _this.state.selectedKeys;
	
	      if (!info.keyPath || info.keyPath.length <= 1) {
	        return;
	      }
	
	      var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;
	
	      if (selectedKeys && selectedKeys.indexOf(info.key) >= 0) {
	        // deselect SubMenu child
	        delete keyPathOfSelectedItem[info.key];
	      } else {
	        // select SubMenu child
	        keyPathOfSelectedItem[info.key] = info.keyPath;
	      }
	
	      _this.setState({
	        keyPathOfSelectedItem: keyPathOfSelectedItem
	      });
	    };
	
	    _this.renderFilterIcon = function () {
	      var _classNames;
	
	      var _this$props = _this.props,
	          column = _this$props.column,
	          locale = _this$props.locale,
	          prefixCls = _this$props.prefixCls,
	          selectedKeys = _this$props.selectedKeys;
	      var filtered = selectedKeys && selectedKeys.length > 0;
	      var filterIcon = column.filterIcon;
	
	      if (typeof filterIcon === 'function') {
	        filterIcon = filterIcon(filtered);
	      }
	
	      var dropdownIconClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-selected"), 'filtered' in column ? column.filtered : filtered), _defineProperty(_classNames, "".concat(prefixCls, "-open"), _this.getDropdownVisible()), _classNames));
	
	      if (!filterIcon) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            title: locale.filterTitle,
	            type: "filter",
	            theme: "filled",
	            className: dropdownIconClass,
	            onClick: stopPropagation
	          })
	        );
	      }
	
	      if ( /*#__PURE__*/React.isValidElement(filterIcon)) {
	        return (/*#__PURE__*/React.cloneElement(filterIcon, {
	            title: filterIcon.props.title || locale.filterTitle,
	            className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass, filterIcon.props.className),
	            onClick: stopPropagation
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass)
	        }, filterIcon)
	      );
	    };
	
	    var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
	    _this.state = {
	      selectedKeys: props.selectedKeys,
	      valueKeys: (0, _util.generateValueMaps)(props.column.filters),
	      keyPathOfSelectedItem: {},
	      visible: visible,
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(FilterMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var column = this.props.column;
	      this.setNeverShown(column);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var column = this.props.column;
	      this.setNeverShown(column);
	    }
	  }, {
	    key: "getDropdownVisible",
	    value: function getDropdownVisible() {
	      return this.neverShown ? false : this.state.visible;
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible) {
	      var column = this.props.column;
	
	      if (!('filterDropdownVisible' in column)) {
	        this.setState({
	          visible: visible
	        });
	      }
	
	      if (column.onFilterDropdownVisibleChange) {
	        column.onFilterDropdownVisibleChange(visible);
	      }
	    }
	  }, {
	    key: "hasSubMenu",
	    value: function hasSubMenu() {
	      var _this$props$column$fi = this.props.column.filters,
	          filters = _this$props$column$fi === void 0 ? [] : _this$props$column$fi;
	      return filters.some(function (item) {
	        return !!(item.children && item.children.length > 0);
	      });
	    }
	  }, {
	    key: "confirmFilter",
	    value: function confirmFilter() {
	      var _this$props2 = this.props,
	          column = _this$props2.column,
	          propSelectedKeys = _this$props2.selectedKeys,
	          confirmFilter = _this$props2.confirmFilter;
	      var _this$state = this.state,
	          selectedKeys = _this$state.selectedKeys,
	          valueKeys = _this$state.valueKeys;
	      var filterDropdown = column.filterDropdown;
	
	      if (!(0, _shallowequal["default"])(selectedKeys, propSelectedKeys)) {
	        confirmFilter(column, filterDropdown ? selectedKeys : selectedKeys.map(function (key) {
	          return valueKeys[key];
	        }).filter(function (key) {
	          return key !== undefined;
	        }));
	      }
	    }
	  }, {
	    key: "renderMenus",
	    value: function renderMenus(items) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          dropdownPrefixCls = _this$props3.dropdownPrefixCls,
	          prefixCls = _this$props3.prefixCls;
	      return items.map(function (item) {
	        if (item.children && item.children.length > 0) {
	          var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
	          var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
	            return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
	          });
	          var subMenuCls = (0, _classnames["default"])("".concat(prefixCls, "-dropdown-submenu"), _defineProperty({}, "".concat(dropdownPrefixCls, "-submenu-contain-selected"), containSelected));
	          return (/*#__PURE__*/React.createElement(_rcMenu.SubMenu, {
	              title: item.text,
	              popupClassName: subMenuCls,
	              key: item.value.toString()
	            }, _this2.renderMenus(item.children))
	          );
	        }
	
	        return _this2.renderMenuItem(item);
	      });
	    }
	  }, {
	    key: "renderMenuItem",
	    value: function renderMenuItem(item) {
	      var column = this.props.column;
	      var selectedKeys = this.state.selectedKeys;
	      var multiple = 'filterMultiple' in column ? column.filterMultiple : true; // We still need trade key as string since Menu render need string
	
	      var internalSelectedKeys = (selectedKeys || []).map(function (key) {
	        return key.toString();
	      });
	      var input = multiple ? /*#__PURE__*/React.createElement(_checkbox["default"], {
	        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
	      }) : /*#__PURE__*/React.createElement(_radio["default"], {
	        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
	      });
	      return (/*#__PURE__*/React.createElement(_rcMenu.Item, {
	          key: item.value
	        }, input, /*#__PURE__*/React.createElement("span", null, item.text))
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var originSelectedKeys = this.state.selectedKeys;
	      var _this$props4 = this.props,
	          column = _this$props4.column,
	          locale = _this$props4.locale,
	          prefixCls = _this$props4.prefixCls,
	          dropdownPrefixCls = _this$props4.dropdownPrefixCls,
	          getPopupContainer = _this$props4.getPopupContainer; // default multiple selection in filter dropdown
	
	      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
	      var dropdownMenuClass = (0, _classnames["default"])(_defineProperty({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !this.hasSubMenu()));
	      var filterDropdown = column.filterDropdown;
	
	      if (filterDropdown instanceof Function) {
	        filterDropdown = filterDropdown({
	          prefixCls: "".concat(dropdownPrefixCls, "-custom"),
	          setSelectedKeys: function setSelectedKeys(selectedKeys) {
	            return _this3.setSelectedKeys({
	              selectedKeys: selectedKeys
	            });
	          },
	          selectedKeys: originSelectedKeys,
	          confirm: this.handleConfirm,
	          clearFilters: this.handleClearFilters,
	          filters: column.filters,
	          visible: this.getDropdownVisible()
	        });
	      }
	
	      var menus = filterDropdown ? /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
	        className: "".concat(prefixCls, "-dropdown")
	      }, filterDropdown) : /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
	        className: "".concat(prefixCls, "-dropdown")
	      }, /*#__PURE__*/React.createElement(_rcMenu["default"], {
	        multiple: multiple,
	        onClick: this.handleMenuItemClick,
	        prefixCls: "".concat(dropdownPrefixCls, "-menu"),
	        className: dropdownMenuClass,
	        onSelect: this.setSelectedKeys,
	        onDeselect: this.setSelectedKeys,
	        selectedKeys: originSelectedKeys && originSelectedKeys.map(function (val) {
	          return val.toString();
	        }),
	        getPopupContainer: getPopupContainer
	      }, this.renderMenus(column.filters)), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-dropdown-btns")
	      }, /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-dropdown-link confirm"),
	        onClick: this.handleConfirm
	      }, locale.filterConfirm), /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-dropdown-link clear"),
	        onClick: this.handleClearFilters
	      }, locale.filterReset)));
	      return (/*#__PURE__*/React.createElement(_dropdown["default"], {
	          trigger: ['click'],
	          placement: "bottomRight",
	          overlay: menus,
	          visible: this.getDropdownVisible(),
	          onVisibleChange: this.onVisibleChange,
	          getPopupContainer: getPopupContainer,
	          forceRender: true
	        }, this.renderFilterIcon())
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var column = nextProps.column;
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	      /**
	       * if the state is visible the component should ignore updates on selectedKeys prop to avoid
	       * that the user selection is lost
	       * this happens frequently when a table is connected on some sort of realtime data
	       * Fixes https://github.com/ant-design/ant-design/issues/10289 and
	       * https://github.com/ant-design/ant-design/issues/10209
	       */
	
	      if ('selectedKeys' in nextProps && !(0, _shallowequal["default"])(prevProps.selectedKeys, nextProps.selectedKeys)) {
	        newState.selectedKeys = nextProps.selectedKeys;
	      }
	
	      if (!(0, _shallowequal["default"])((prevProps.column || {}).filters, (nextProps.column || {}).filters)) {
	        newState.valueKeys = (0, _util.generateValueMaps)(nextProps.column.filters);
	      }
	
	      if ('filterDropdownVisible' in column) {
	        newState.visible = column.filterDropdownVisible;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return FilterMenu;
	}(React.Component);
	
	FilterMenu.defaultProps = {
	  column: {}
	};
	(0, _reactLifecyclesCompat.polyfill)(FilterMenu);
	var _default = FilterMenu;
	exports["default"] = _default;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Table = _interopRequireDefault(__webpack_require__(1261));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Table["default"];
	exports["default"] = _default;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _ScrollableInkTabBar = _interopRequireDefault(__webpack_require__(480));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var TabBar = /*#__PURE__*/function (_React$Component) {
	  _inherits(TabBar, _React$Component);
	
	  var _super = _createSuper(TabBar);
	
	  function TabBar() {
	    _classCallCheck(this, TabBar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(TabBar, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          tabBarStyle = _this$props.tabBarStyle,
	          animated = _this$props.animated,
	          renderTabBar = _this$props.renderTabBar,
	          tabBarExtraContent = _this$props.tabBarExtraContent,
	          tabPosition = _this$props.tabPosition,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          size = _this$props.size,
	          type = _this$props.type;
	      var inkBarAnimated = _typeof(animated) === 'object' ? animated.inkBar : animated;
	      var isVertical = tabPosition === 'left' || tabPosition === 'right';
	      var prevIconType = isVertical ? 'up' : 'left';
	      var nextIconType = isVertical ? 'down' : 'right';
	      var prevIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-prev-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: prevIconType,
	        className: "".concat(prefixCls, "-tab-prev-icon-target")
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-next-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: nextIconType,
	        className: "".concat(prefixCls, "-tab-next-icon-target")
	      })); // Additional className for style usage
	
	      var cls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-bar"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size, "-bar"), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card-bar"), type && type.indexOf('card') >= 0), _classNames), className);
	
	      var renderProps = _extends(_extends({}, this.props), {
	        children: null,
	        inkBarAnimated: inkBarAnimated,
	        extraContent: tabBarExtraContent,
	        style: tabBarStyle,
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        className: cls
	      });
	
	      var RenderTabBar;
	
	      if (renderTabBar) {
	        RenderTabBar = renderTabBar(renderProps, _ScrollableInkTabBar["default"]);
	      } else {
	        RenderTabBar = /*#__PURE__*/React.createElement(_ScrollableInkTabBar["default"], renderProps);
	      }
	
	      return (/*#__PURE__*/React.cloneElement(RenderTabBar)
	      );
	    }
	  }]);
	
	  return TabBar;
	}(React.Component);
	
	exports["default"] = TabBar;
	TabBar.defaultProps = {
	  animated: true,
	  type: 'line'
	};

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var CheckableTag = /*#__PURE__*/function (_React$Component) {
	  _inherits(CheckableTag, _React$Component);
	
	  var _super = _createSuper(CheckableTag);
	
	  function CheckableTag() {
	    var _this;
	
	    _classCallCheck(this, CheckableTag);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function () {
	      var _this$props = _this.props,
	          checked = _this$props.checked,
	          onChange = _this$props.onChange;
	
	      if (onChange) {
	        onChange(!checked);
	      }
	    };
	
	    _this.renderCheckableTag = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          checked = _a.checked,
	          restProps = __rest(_a, ["prefixCls", "className", "checked"]);
	
	      var prefixCls = getPrefixCls('tag', customizePrefixCls);
	      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checkable"), true), _defineProperty(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
	      delete restProps.onChange; // TypeScript cannot check delete now.
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, restProps, {
	          className: cls,
	          onClick: _this.handleClick
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(CheckableTag, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckableTag)
	      );
	    }
	  }]);
	
	  return CheckableTag;
	}(React.Component);
	
	exports["default"] = CheckableTag;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _TimelineItem = _interopRequireDefault(__webpack_require__(1269));
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Timeline = /*#__PURE__*/function (_React$Component) {
	  _inherits(Timeline, _React$Component);
	
	  var _super = _createSuper(Timeline);
	
	  function Timeline() {
	    var _this;
	
	    _classCallCheck(this, Timeline);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderTimeline = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          _a$pending = _a.pending,
	          pending = _a$pending === void 0 ? null : _a$pending,
	          pendingDot = _a.pendingDot,
	          children = _a.children,
	          className = _a.className,
	          reverse = _a.reverse,
	          mode = _a.mode,
	          restProps = __rest(_a, ["prefixCls", "pending", "pendingDot", "children", "className", "reverse", "mode"]);
	
	      var prefixCls = getPrefixCls('timeline', customizePrefixCls);
	      var pendingNode = typeof pending === 'boolean' ? null : pending;
	      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-pending"), !!pending), _defineProperty(_classNames, "".concat(prefixCls, "-reverse"), !!reverse), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(mode), !!mode), _classNames), className);
	      var pendingItem = pending ? /*#__PURE__*/React.createElement(_TimelineItem["default"], {
	        pending: !!pending,
	        dot: pendingDot || /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading"
	        })
	      }, pendingNode) : null;
	      var timeLineItems = reverse ? [pendingItem].concat(_toConsumableArray(React.Children.toArray(children).reverse())) : [].concat(_toConsumableArray(React.Children.toArray(children)), [pendingItem]);
	
	      var getPositionCls = function getPositionCls(ele, idx) {
	        if (mode === 'alternate') {
	          if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
	          if (ele.props.position === 'left') return "".concat(prefixCls, "-item-left");
	          return idx % 2 === 0 ? "".concat(prefixCls, "-item-left") : "".concat(prefixCls, "-item-right");
	        }
	
	        if (mode === 'left') return "".concat(prefixCls, "-item-left");
	        if (mode === 'right') return "".concat(prefixCls, "-item-right");
	        if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
	        return '';
	      }; // Remove falsy items
	
	
	      var truthyItems = timeLineItems.filter(function (item) {
	        return !!item;
	      });
	      var itemsCount = React.Children.count(truthyItems);
	      var lastCls = "".concat(prefixCls, "-item-last");
	      var items = React.Children.map(truthyItems, function (ele, idx) {
	        var pendingClass = idx === itemsCount - 2 ? lastCls : '';
	        var readyClass = idx === itemsCount - 1 ? lastCls : '';
	        return (/*#__PURE__*/React.cloneElement(ele, {
	            className: (0, _classnames["default"])([ele.props.className, !reverse && !!pending ? pendingClass : readyClass, getPositionCls(ele, idx)])
	          })
	        );
	      });
	      return (/*#__PURE__*/React.createElement("ul", _extends({}, restProps, {
	          className: classString
	        }), items)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Timeline, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTimeline)
	      );
	    }
	  }]);
	
	  return Timeline;
	}(React.Component);
	
	exports["default"] = Timeline;
	Timeline.Item = _TimelineItem["default"];
	Timeline.defaultProps = {
	  reverse: false,
	  mode: ''
	};

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TimelineItem = function TimelineItem(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames, _classNames2;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          _props$color = props.color,
	          color = _props$color === void 0 ? '' : _props$color,
	          children = props.children,
	          pending = props.pending,
	          dot = props.dot,
	          restProps = __rest(props, ["prefixCls", "className", "color", "children", "pending", "dot"]);
	
	      var prefixCls = getPrefixCls('timeline', customizePrefixCls);
	      var itemClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-item-pending"), pending), _classNames), className);
	      var dotClassName = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-item-head"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-custom"), dot), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-").concat(color), true), _classNames2));
	      return (/*#__PURE__*/React.createElement("li", _extends({}, (0, _omit["default"])(restProps, ['position']), {
	          className: itemClassName
	        }), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-tail")
	        }), /*#__PURE__*/React.createElement("div", {
	          className: dotClassName,
	          style: {
	            borderColor: /blue|red|green|gray/.test(color) ? undefined : color
	          }
	        }, dot), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-content")
	        }, children))
	      );
	    })
	  );
	};
	
	TimelineItem.defaultProps = {
	  color: 'blue',
	  pending: false,
	  position: ''
	};
	var _default = TimelineItem;
	exports["default"] = _default;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Timeline = _interopRequireDefault(__webpack_require__(1268));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Timeline["default"];
	exports["default"] = _default;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOverflowOptions = getOverflowOptions;
	exports["default"] = getPlacements;
	
	var _placements = __webpack_require__(506);
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var autoAdjustOverflowEnabled = {
	  adjustX: 1,
	  adjustY: 1
	};
	var autoAdjustOverflowDisabled = {
	  adjustX: 0,
	  adjustY: 0
	};
	var targetOffset = [0, 0];
	
	function getOverflowOptions(autoAdjustOverflow) {
	  if (typeof autoAdjustOverflow === 'boolean') {
	    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
	  }
	
	  return _extends(_extends({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
	}
	
	function getPlacements() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$arrowWidth = config.arrowWidth,
	      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
	      _config$horizontalArr = config.horizontalArrowShift,
	      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
	      _config$verticalArrow = config.verticalArrowShift,
	      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
	      _config$autoAdjustOve = config.autoAdjustOverflow,
	      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
	  var placementMap = {
	    left: {
	      points: ['cr', 'cl'],
	      offset: [-4, 0]
	    },
	    right: {
	      points: ['cl', 'cr'],
	      offset: [4, 0]
	    },
	    top: {
	      points: ['bc', 'tc'],
	      offset: [0, -4]
	    },
	    bottom: {
	      points: ['tc', 'bc'],
	      offset: [0, 4]
	    },
	    topLeft: {
	      points: ['bl', 'tc'],
	      offset: [-(horizontalArrowShift + arrowWidth), -4]
	    },
	    leftTop: {
	      points: ['tr', 'cl'],
	      offset: [-4, -(verticalArrowShift + arrowWidth)]
	    },
	    topRight: {
	      points: ['br', 'tc'],
	      offset: [horizontalArrowShift + arrowWidth, -4]
	    },
	    rightTop: {
	      points: ['tl', 'cr'],
	      offset: [4, -(verticalArrowShift + arrowWidth)]
	    },
	    bottomRight: {
	      points: ['tr', 'bc'],
	      offset: [horizontalArrowShift + arrowWidth, 4]
	    },
	    rightBottom: {
	      points: ['bl', 'cr'],
	      offset: [4, verticalArrowShift + arrowWidth]
	    },
	    bottomLeft: {
	      points: ['tl', 'bc'],
	      offset: [-(horizontalArrowShift + arrowWidth), 4]
	    },
	    leftBottom: {
	      points: ['br', 'cl'],
	      offset: [-4, verticalArrowShift + arrowWidth]
	    }
	  };
	  Object.keys(placementMap).forEach(function (key) {
	    placementMap[key] = config.arrowPointAtCenter ? _extends(_extends({}, placementMap[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow),
	      targetOffset: targetOffset
	    }) : _extends(_extends({}, _placements.placements[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow)
	    });
	    placementMap[key].ignoreShake = true;
	  });
	  return placementMap;
	}

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _PureRenderMixin = _interopRequireDefault(__webpack_require__(192));
	
	var _reactLazyLoad = _interopRequireDefault(__webpack_require__(486));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(156));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ListItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(ListItem, _React$Component);
	
	  var _super = _createSuper(ListItem);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ListItem, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          renderedText = _this$props.renderedText,
	          renderedEl = _this$props.renderedEl,
	          item = _this$props.item,
	          lazy = _this$props.lazy,
	          checked = _this$props.checked,
	          disabled = _this$props.disabled,
	          prefixCls = _this$props.prefixCls,
	          onClick = _this$props.onClick;
	      var className = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-content-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-disabled"), disabled || item.disabled), _classNames));
	      var title;
	
	      if (typeof renderedText === 'string' || typeof renderedText === 'number') {
	        title = String(renderedText);
	      }
	
	      var listItem = /*#__PURE__*/React.createElement("li", {
	        className: className,
	        title: title,
	        onClick: disabled || item.disabled ? undefined : function () {
	          return onClick(item);
	        }
	      }, /*#__PURE__*/React.createElement(_checkbox["default"], {
	        checked: checked,
	        disabled: disabled || item.disabled
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-item-text")
	      }, renderedEl));
	      var children = null;
	
	      if (lazy) {
	        var lazyProps = _extends({
	          height: 32,
	          offset: 500,
	          throttle: 0,
	          debounce: false
	        }, lazy);
	
	        children = /*#__PURE__*/React.createElement(_reactLazyLoad["default"], lazyProps, listItem);
	      } else {
	        children = listItem;
	      }
	
	      return children;
	    }
	  }]);
	
	  return ListItem;
	}(React.Component);
	
	exports["default"] = ListItem;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _list = _interopRequireDefault(__webpack_require__(1274));
	
	var _operation = _interopRequireDefault(__webpack_require__(1275));
	
	var _search = _interopRequireDefault(__webpack_require__(661));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(73));
	
	var _default2 = _interopRequireDefault(__webpack_require__(157));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Transfer = /*#__PURE__*/function (_React$Component) {
	  _inherits(Transfer, _React$Component);
	
	  var _super = _createSuper(Transfer);
	
	  function Transfer(props) {
	    var _this;
	
	    _classCallCheck(this, Transfer);
	
	    _this = _super.call(this, props);
	    _this.separatedDataSource = null;
	
	    _this.getLocale = function (transferLocale, renderEmpty) {
	      // Keep old locale props still working.
	      var oldLocale = {
	        notFoundContent: renderEmpty('Transfer')
	      };
	
	      if ('notFoundContent' in _this.props) {
	        oldLocale.notFoundContent = _this.props.notFoundContent;
	      }
	
	      if ('searchPlaceholder' in _this.props) {
	        oldLocale.searchPlaceholder = _this.props.searchPlaceholder;
	      }
	
	      return _extends(_extends(_extends({}, transferLocale), oldLocale), _this.props.locale);
	    };
	
	    _this.moveTo = function (direction) {
	      var _this$props = _this.props,
	          _this$props$targetKey = _this$props.targetKeys,
	          targetKeys = _this$props$targetKey === void 0 ? [] : _this$props$targetKey,
	          _this$props$dataSourc = _this$props.dataSource,
	          dataSource = _this$props$dataSourc === void 0 ? [] : _this$props$dataSourc,
	          onChange = _this$props.onChange;
	      var _this$state = _this.state,
	          sourceSelectedKeys = _this$state.sourceSelectedKeys,
	          targetSelectedKeys = _this$state.targetSelectedKeys;
	      var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys; // filter the disabled options
	
	      var newMoveKeys = moveKeys.filter(function (key) {
	        return !dataSource.some(function (data) {
	          return !!(key === data.key && data.disabled);
	        });
	      }); // move items to target box
	
	      var newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(function (targetKey) {
	        return newMoveKeys.indexOf(targetKey) === -1;
	      }); // empty checked keys
	
	      var oppositeDirection = direction === 'right' ? 'left' : 'right';
	
	      _this.setState(_defineProperty({}, _this.getSelectedKeysName(oppositeDirection), []));
	
	      _this.handleSelectChange(oppositeDirection, []);
	
	      if (onChange) {
	        onChange(newTargetKeys, direction, newMoveKeys);
	      }
	    };
	
	    _this.moveToLeft = function () {
	      return _this.moveTo('left');
	    };
	
	    _this.moveToRight = function () {
	      return _this.moveTo('right');
	    };
	
	    _this.onItemSelectAll = function (direction, selectedKeys, checkAll) {
	      var originalSelectedKeys = _this.state[_this.getSelectedKeysName(direction)] || [];
	      var mergedCheckedKeys = [];
	
	      if (checkAll) {
	        // Merge current keys with origin key
	        mergedCheckedKeys = Array.from(new Set([].concat(_toConsumableArray(originalSelectedKeys), _toConsumableArray(selectedKeys))));
	      } else {
	        // Remove current keys from origin keys
	        mergedCheckedKeys = originalSelectedKeys.filter(function (key) {
	          return selectedKeys.indexOf(key) === -1;
	        });
	      }
	
	      _this.handleSelectChange(direction, mergedCheckedKeys);
	
	      if (!_this.props.selectedKeys) {
	        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), mergedCheckedKeys));
	      }
	    };
	
	    _this.handleSelectAll = function (direction, filteredDataSource, checkAll) {
	      (0, _warning["default"])(false, 'Transfer', '`handleSelectAll` will be removed, please use `onSelectAll` instead.');
	
	      _this.onItemSelectAll(direction, filteredDataSource.map(function (_ref) {
	        var key = _ref.key;
	        return key;
	      }), !checkAll);
	    }; // [Legacy] Old prop `body` pass origin check as arg. It's confusing.
	    // TODO: Remove this in next version.
	
	
	    _this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
	      return _this.handleSelectAll('left', filteredDataSource, !checkAll);
	    };
	
	    _this.handleRightSelectAll = function (filteredDataSource, checkAll) {
	      return _this.handleSelectAll('right', filteredDataSource, !checkAll);
	    };
	
	    _this.onLeftItemSelectAll = function (selectedKeys, checkAll) {
	      return _this.onItemSelectAll('left', selectedKeys, checkAll);
	    };
	
	    _this.onRightItemSelectAll = function (selectedKeys, checkAll) {
	      return _this.onItemSelectAll('right', selectedKeys, checkAll);
	    };
	
	    _this.handleFilter = function (direction, e) {
	      var _this$props2 = _this.props,
	          onSearchChange = _this$props2.onSearchChange,
	          onSearch = _this$props2.onSearch;
	      var value = e.target.value;
	
	      if (onSearchChange) {
	        (0, _warning["default"])(false, 'Transfer', '`onSearchChange` is deprecated. Please use `onSearch` instead.');
	        onSearchChange(direction, e);
	      }
	
	      if (onSearch) {
	        onSearch(direction, value);
	      }
	    };
	
	    _this.handleLeftFilter = function (e) {
	      return _this.handleFilter('left', e);
	    };
	
	    _this.handleRightFilter = function (e) {
	      return _this.handleFilter('right', e);
	    };
	
	    _this.handleClear = function (direction) {
	      var onSearch = _this.props.onSearch;
	
	      if (onSearch) {
	        onSearch(direction, '');
	      }
	    };
	
	    _this.handleLeftClear = function () {
	      return _this.handleClear('left');
	    };
	
	    _this.handleRightClear = function () {
	      return _this.handleClear('right');
	    };
	
	    _this.onItemSelect = function (direction, selectedKey, checked) {
	      var _this$state2 = _this.state,
	          sourceSelectedKeys = _this$state2.sourceSelectedKeys,
	          targetSelectedKeys = _this$state2.targetSelectedKeys;
	      var holder = direction === 'left' ? _toConsumableArray(sourceSelectedKeys) : _toConsumableArray(targetSelectedKeys);
	      var index = holder.indexOf(selectedKey);
	
	      if (index > -1) {
	        holder.splice(index, 1);
	      }
	
	      if (checked) {
	        holder.push(selectedKey);
	      }
	
	      _this.handleSelectChange(direction, holder);
	
	      if (!_this.props.selectedKeys) {
	        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), holder));
	      }
	    };
	
	    _this.handleSelect = function (direction, selectedItem, checked) {
	      (0, _warning["default"])(false, 'Transfer', '`handleSelect` will be removed, please use `onSelect` instead.');
	
	      _this.onItemSelect(direction, selectedItem.key, checked);
	    };
	
	    _this.handleLeftSelect = function (selectedItem, checked) {
	      return _this.handleSelect('left', selectedItem, checked);
	    };
	
	    _this.handleRightSelect = function (selectedItem, checked) {
	      return _this.handleSelect('right', selectedItem, checked);
	    };
	
	    _this.onLeftItemSelect = function (selectedKey, checked) {
	      return _this.onItemSelect('left', selectedKey, checked);
	    };
	
	    _this.onRightItemSelect = function (selectedKey, checked) {
	      return _this.onItemSelect('right', selectedKey, checked);
	    };
	
	    _this.handleScroll = function (direction, e) {
	      var onScroll = _this.props.onScroll;
	
	      if (onScroll) {
	        onScroll(direction, e);
	      }
	    };
	
	    _this.handleLeftScroll = function (e) {
	      return _this.handleScroll('left', e);
	    };
	
	    _this.handleRightScroll = function (e) {
	      return _this.handleScroll('right', e);
	    };
	
	    _this.handleListStyle = function (listStyle, direction) {
	      if (typeof listStyle === 'function') {
	        return listStyle({
	          direction: direction
	        });
	      }
	
	      return listStyle;
	    };
	
	    _this.renderTransfer = function (transferLocale) {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	          var _classNames;
	
	          var getPrefixCls = _ref2.getPrefixCls,
	              renderEmpty = _ref2.renderEmpty;
	          var _this$props3 = _this.props,
	              customizePrefixCls = _this$props3.prefixCls,
	              className = _this$props3.className,
	              disabled = _this$props3.disabled,
	              _this$props3$operatio = _this$props3.operations,
	              operations = _this$props3$operatio === void 0 ? [] : _this$props3$operatio,
	              showSearch = _this$props3.showSearch,
	              body = _this$props3.body,
	              footer = _this$props3.footer,
	              style = _this$props3.style,
	              listStyle = _this$props3.listStyle,
	              operationStyle = _this$props3.operationStyle,
	              filterOption = _this$props3.filterOption,
	              render = _this$props3.render,
	              lazy = _this$props3.lazy,
	              children = _this$props3.children,
	              showSelectAll = _this$props3.showSelectAll;
	          var prefixCls = getPrefixCls('transfer', customizePrefixCls);
	
	          var locale = _this.getLocale(transferLocale, renderEmpty);
	
	          var _this$state3 = _this.state,
	              sourceSelectedKeys = _this$state3.sourceSelectedKeys,
	              targetSelectedKeys = _this$state3.targetSelectedKeys;
	
	          var _this$separateDataSou = _this.separateDataSource(),
	              leftDataSource = _this$separateDataSou.leftDataSource,
	              rightDataSource = _this$separateDataSou.rightDataSource;
	
	          var leftActive = targetSelectedKeys.length > 0;
	          var rightActive = sourceSelectedKeys.length > 0;
	          var cls = (0, _classnames["default"])(className, prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-customize-list"), !!children), _classNames));
	
	          var titles = _this.getTitles(locale);
	
	          return (/*#__PURE__*/React.createElement("div", {
	              className: cls,
	              style: style
	            }, /*#__PURE__*/React.createElement(_list["default"], _extends({
	              prefixCls: "".concat(prefixCls, "-list"),
	              titleText: titles[0],
	              dataSource: leftDataSource,
	              filterOption: filterOption,
	              style: _this.handleListStyle(listStyle, 'left'),
	              checkedKeys: sourceSelectedKeys,
	              handleFilter: _this.handleLeftFilter,
	              handleClear: _this.handleLeftClear,
	              handleSelect: _this.handleLeftSelect,
	              handleSelectAll: _this.handleLeftSelectAll,
	              onItemSelect: _this.onLeftItemSelect,
	              onItemSelectAll: _this.onLeftItemSelectAll,
	              render: render,
	              showSearch: showSearch,
	              body: body,
	              renderList: children,
	              footer: footer,
	              lazy: lazy,
	              onScroll: _this.handleLeftScroll,
	              disabled: disabled,
	              direction: "left",
	              showSelectAll: showSelectAll
	            }, locale)), /*#__PURE__*/React.createElement(_operation["default"], {
	              className: "".concat(prefixCls, "-operation"),
	              rightActive: rightActive,
	              rightArrowText: operations[0],
	              moveToRight: _this.moveToRight,
	              leftActive: leftActive,
	              leftArrowText: operations[1],
	              moveToLeft: _this.moveToLeft,
	              style: operationStyle,
	              disabled: disabled
	            }), /*#__PURE__*/React.createElement(_list["default"], _extends({
	              prefixCls: "".concat(prefixCls, "-list"),
	              titleText: titles[1],
	              dataSource: rightDataSource,
	              filterOption: filterOption,
	              style: _this.handleListStyle(listStyle, 'right'),
	              checkedKeys: targetSelectedKeys,
	              handleFilter: _this.handleRightFilter,
	              handleClear: _this.handleRightClear,
	              handleSelect: _this.handleRightSelect,
	              handleSelectAll: _this.handleRightSelectAll,
	              onItemSelect: _this.onRightItemSelect,
	              onItemSelectAll: _this.onRightItemSelectAll,
	              render: render,
	              showSearch: showSearch,
	              body: body,
	              renderList: children,
	              footer: footer,
	              lazy: lazy,
	              onScroll: _this.handleRightScroll,
	              disabled: disabled,
	              direction: "right",
	              showSelectAll: showSelectAll
	            }, locale)))
	          );
	        })
	      );
	    };
	
	    (0, _warning["default"])(!('notFoundContent' in props || 'searchPlaceholder' in props), 'Transfer', '`notFoundContent` and `searchPlaceholder` will be removed, ' + 'please use `locale` instead.');
	    (0, _warning["default"])(!('body' in props), 'Transfer', '`body` is internal usage and will bre removed, please use `children` instead.');
	    var _props$selectedKeys = props.selectedKeys,
	        selectedKeys = _props$selectedKeys === void 0 ? [] : _props$selectedKeys,
	        _props$targetKeys = props.targetKeys,
	        targetKeys = _props$targetKeys === void 0 ? [] : _props$targetKeys;
	    _this.state = {
	      sourceSelectedKeys: selectedKeys.filter(function (key) {
	        return targetKeys.indexOf(key) === -1;
	      }),
	      targetSelectedKeys: selectedKeys.filter(function (key) {
	        return targetKeys.indexOf(key) > -1;
	      })
	    };
	    return _this;
	  }
	
	  _createClass(Transfer, [{
	    key: "getSelectedKeysName",
	    // eslint-disable-next-line
	    value: function getSelectedKeysName(direction) {
	      return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
	    }
	  }, {
	    key: "getTitles",
	    value: function getTitles(transferLocale) {
	      var props = this.props;
	
	      if (props.titles) {
	        return props.titles;
	      }
	
	      return transferLocale.titles;
	    }
	  }, {
	    key: "handleSelectChange",
	    value: function handleSelectChange(direction, holder) {
	      var _this$state4 = this.state,
	          sourceSelectedKeys = _this$state4.sourceSelectedKeys,
	          targetSelectedKeys = _this$state4.targetSelectedKeys;
	      var onSelectChange = this.props.onSelectChange;
	
	      if (!onSelectChange) {
	        return;
	      }
	
	      if (direction === 'left') {
	        onSelectChange(holder, targetSelectedKeys);
	      } else {
	        onSelectChange(sourceSelectedKeys, holder);
	      }
	    }
	  }, {
	    key: "separateDataSource",
	    value: function separateDataSource() {
	      var _this$props4 = this.props,
	          dataSource = _this$props4.dataSource,
	          rowKey = _this$props4.rowKey,
	          _this$props4$targetKe = _this$props4.targetKeys,
	          targetKeys = _this$props4$targetKe === void 0 ? [] : _this$props4$targetKe;
	      var leftDataSource = [];
	      var rightDataSource = new Array(targetKeys.length);
	      dataSource.forEach(function (record) {
	        if (rowKey) {
	          record.key = rowKey(record);
	        } // rightDataSource should be ordered by targetKeys
	        // leftDataSource should be ordered by dataSource
	
	
	        var indexOfKey = targetKeys.indexOf(record.key);
	
	        if (indexOfKey !== -1) {
	          rightDataSource[indexOfKey] = record;
	        } else {
	          leftDataSource.push(record);
	        }
	      });
	      return {
	        leftDataSource: leftDataSource,
	        rightDataSource: rightDataSource
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Transfer",
	          defaultLocale: _default2["default"].Transfer
	        }, this.renderTransfer)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if (nextProps.selectedKeys) {
	        var targetKeys = nextProps.targetKeys || [];
	        return {
	          sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	            return !targetKeys.includes(key);
	          }),
	          targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	            return targetKeys.includes(key);
	          })
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Transfer;
	}(React.Component); // For high-level customized Transfer @dqaria
	
	
	Transfer.List = _list["default"];
	Transfer.Operation = _operation["default"];
	Transfer.Search = _search["default"];
	Transfer.defaultProps = {
	  dataSource: [],
	  locale: {},
	  showSearch: false,
	  listStyle: function listStyle() {}
	};
	Transfer.propTypes = {
	  prefixCls: PropTypes.string,
	  disabled: PropTypes.bool,
	  dataSource: PropTypes.array,
	  render: PropTypes.func,
	  targetKeys: PropTypes.array,
	  onChange: PropTypes.func,
	  height: PropTypes.number,
	  style: PropTypes.object,
	  listStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
	  operationStyle: PropTypes.object,
	  className: PropTypes.string,
	  titles: PropTypes.array,
	  operations: PropTypes.array,
	  showSearch: PropTypes.bool,
	  filterOption: PropTypes.func,
	  searchPlaceholder: PropTypes.string,
	  notFoundContent: PropTypes.node,
	  locale: PropTypes.object,
	  body: PropTypes.func,
	  footer: PropTypes.func,
	  rowKey: PropTypes.func,
	  lazy: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
	};
	(0, _reactLifecyclesCompat.polyfill)(Transfer);
	var _default = Transfer;
	exports["default"] = _default;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _PureRenderMixin = _interopRequireDefault(__webpack_require__(192));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(156));
	
	var _search = _interopRequireDefault(__webpack_require__(661));
	
	var _renderListBody = _interopRequireWildcard(__webpack_require__(1276));
	
	var _triggerEvent = _interopRequireDefault(__webpack_require__(1165));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var defaultRender = function defaultRender() {
	  return null;
	};
	
	function isRenderResultPlainObject(result) {
	  return result && ! /*#__PURE__*/React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
	}
	
	function renderListNode(renderList, props) {
	  var bodyContent = renderList ? renderList(props) : null;
	  var customize = !!bodyContent;
	
	  if (!customize) {
	    bodyContent = (0, _renderListBody["default"])(props);
	  }
	
	  return {
	    customize: customize,
	    bodyContent: bodyContent
	  };
	}
	
	var TransferList = /*#__PURE__*/function (_React$Component) {
	  _inherits(TransferList, _React$Component);
	
	  var _super = _createSuper(TransferList);
	
	  function TransferList(props) {
	    var _this;
	
	    _classCallCheck(this, TransferList);
	
	    _this = _super.call(this, props);
	
	    _this.handleFilter = function (e) {
	      var handleFilter = _this.props.handleFilter;
	      var filterValue = e.target.value;
	
	      _this.setState({
	        filterValue: filterValue
	      });
	
	      handleFilter(e);
	
	      if (!filterValue) {
	        return;
	      } // Manually trigger scroll event for lazy search bug
	      // https://github.com/ant-design/ant-design/issues/5631
	
	
	      _this.triggerScrollTimer = window.setTimeout(function () {
	        var transferNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	        var listNode = transferNode.querySelectorAll('.ant-transfer-list-content')[0];
	
	        if (listNode) {
	          (0, _triggerEvent["default"])(listNode, 'scroll');
	        }
	      }, 0);
	    };
	
	    _this.handleClear = function () {
	      var handleClear = _this.props.handleClear;
	
	      _this.setState({
	        filterValue: ''
	      });
	
	      handleClear();
	    };
	
	    _this.matchFilter = function (text, item) {
	      var filterValue = _this.state.filterValue;
	      var filterOption = _this.props.filterOption;
	
	      if (filterOption) {
	        return filterOption(filterValue, item);
	      }
	
	      return text.indexOf(filterValue) >= 0;
	    };
	
	    _this.renderItem = function (item) {
	      var _this$props$render = _this.props.render,
	          render = _this$props$render === void 0 ? defaultRender : _this$props$render;
	      var renderResult = render(item);
	      var isRenderResultPlain = isRenderResultPlainObject(renderResult);
	      return {
	        renderedText: isRenderResultPlain ? renderResult.value : renderResult,
	        renderedEl: isRenderResultPlain ? renderResult.label : renderResult,
	        item: item
	      };
	    };
	
	    _this.state = {
	      filterValue: ''
	    };
	    return _this;
	  }
	
	  _createClass(TransferList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.triggerScrollTimer);
	    }
	  }, {
	    key: "getCheckStatus",
	    value: function getCheckStatus(filteredItems) {
	      var checkedKeys = this.props.checkedKeys;
	
	      if (checkedKeys.length === 0) {
	        return 'none';
	      }
	
	      if (filteredItems.every(function (item) {
	        return checkedKeys.indexOf(item.key) >= 0 || !!item.disabled;
	      })) {
	        return 'all';
	      }
	
	      return 'part';
	    }
	  }, {
	    key: "getFilteredItems",
	    value: function getFilteredItems(dataSource, filterValue) {
	      var _this2 = this;
	
	      var filteredItems = [];
	      var filteredRenderItems = [];
	      dataSource.forEach(function (item) {
	        var renderedItem = _this2.renderItem(item);
	
	        var renderedText = renderedItem.renderedText; // Filter skip
	
	        if (filterValue && filterValue.trim() && !_this2.matchFilter(renderedText, item)) {
	          return null;
	        }
	
	        filteredItems.push(item);
	        filteredRenderItems.push(renderedItem);
	      });
	      return {
	        filteredItems: filteredItems,
	        filteredRenderItems: filteredRenderItems
	      };
	    }
	  }, {
	    key: "getListBody",
	    value: function getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled) {
	      var search = showSearch ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body-search-wrapper")
	      }, /*#__PURE__*/React.createElement(_search["default"], {
	        prefixCls: "".concat(prefixCls, "-search"),
	        onChange: this.handleFilter,
	        handleClear: this.handleClear,
	        placeholder: searchPlaceholder,
	        value: filterValue,
	        disabled: disabled
	      })) : null;
	      var listBody = bodyDom;
	
	      if (!listBody) {
	        var bodyNode;
	
	        var _renderListNode = renderListNode(renderList, _extends(_extends({}, (0, _omit["default"])(this.props, _renderListBody.OmitProps)), {
	          filteredItems: filteredItems,
	          filteredRenderItems: filteredRenderItems,
	          selectedKeys: checkedKeys
	        })),
	            bodyContent = _renderListNode.bodyContent,
	            customize = _renderListNode.customize; // We should wrap customize list body in a classNamed div to use flex layout.
	
	
	        if (customize) {
	          bodyNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-body-customize-wrapper")
	          }, bodyContent);
	        } else {
	          bodyNode = filteredItems.length ? bodyContent : /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-body-not-found")
	          }, notFoundContent);
	        }
	
	        listBody = /*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])(showSearch ? "".concat(prefixCls, "-body ").concat(prefixCls, "-body-with-search") : "".concat(prefixCls, "-body"))
	        }, search, bodyNode);
	      }
	
	      return listBody;
	    }
	  }, {
	    key: "getCheckBox",
	    value: function getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled) {
	      var checkStatus = this.getCheckStatus(filteredItems);
	      var checkedAll = checkStatus === 'all';
	      var checkAllCheckbox = showSelectAll !== false && /*#__PURE__*/React.createElement(_checkbox["default"], {
	        disabled: disabled,
	        checked: checkedAll,
	        indeterminate: checkStatus === 'part',
	        onChange: function onChange() {
	          // Only select enabled items
	          onItemSelectAll(filteredItems.filter(function (item) {
	            return !item.disabled;
	          }).map(function (_ref) {
	            var key = _ref.key;
	            return key;
	          }), !checkedAll);
	        }
	      });
	      return checkAllCheckbox;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var filterValue = this.state.filterValue;
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          dataSource = _this$props.dataSource,
	          titleText = _this$props.titleText,
	          checkedKeys = _this$props.checkedKeys,
	          disabled = _this$props.disabled,
	          body = _this$props.body,
	          footer = _this$props.footer,
	          showSearch = _this$props.showSearch,
	          style = _this$props.style,
	          searchPlaceholder = _this$props.searchPlaceholder,
	          notFoundContent = _this$props.notFoundContent,
	          itemUnit = _this$props.itemUnit,
	          itemsUnit = _this$props.itemsUnit,
	          renderList = _this$props.renderList,
	          onItemSelectAll = _this$props.onItemSelectAll,
	          showSelectAll = _this$props.showSelectAll; // Custom Layout
	
	      var footerDom = footer && footer(this.props);
	      var bodyDom = body && body(this.props);
	      var listCls = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-with-footer"), !!footerDom)); // ====================== Get filtered, checked item list ======================
	
	      var _this$getFilteredItem = this.getFilteredItems(dataSource, filterValue),
	          filteredItems = _this$getFilteredItem.filteredItems,
	          filteredRenderItems = _this$getFilteredItem.filteredRenderItems; // ================================= List Body =================================
	
	
	      var unit = dataSource.length > 1 ? itemsUnit : itemUnit;
	      var listBody = this.getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled); // ================================ List Footer ================================
	
	      var listFooter = footerDom ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, footerDom) : null;
	      var checkAllCheckbox = this.getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled); // ================================== Render ===================================
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: listCls,
	          style: style
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-header")
	        }, checkAllCheckbox, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-header-selected")
	        }, /*#__PURE__*/React.createElement("span", null, (checkedKeys.length > 0 ? "".concat(checkedKeys.length, "/") : '') + filteredItems.length, ' ', unit), /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-header-title")
	        }, titleText))), listBody, listFooter)
	      );
	    }
	  }]);
	
	  return TransferList;
	}(React.Component);
	
	exports["default"] = TransferList;
	TransferList.defaultProps = {
	  dataSource: [],
	  titleText: '',
	  showSearch: false,
	  lazy: {}
	};

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _button = _interopRequireDefault(__webpack_require__(136));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Operation = function Operation(_ref) {
	  var disabled = _ref.disabled,
	      moveToLeft = _ref.moveToLeft,
	      moveToRight = _ref.moveToRight,
	      _ref$leftArrowText = _ref.leftArrowText,
	      leftArrowText = _ref$leftArrowText === void 0 ? '' : _ref$leftArrowText,
	      _ref$rightArrowText = _ref.rightArrowText,
	      rightArrowText = _ref$rightArrowText === void 0 ? '' : _ref$rightArrowText,
	      leftActive = _ref.leftActive,
	      rightActive = _ref.rightActive,
	      className = _ref.className,
	      style = _ref.style;
	  return (/*#__PURE__*/React.createElement("div", {
	      className: className,
	      style: style
	    }, /*#__PURE__*/React.createElement(_button["default"], {
	      type: "primary",
	      size: "small",
	      disabled: disabled || !rightActive,
	      onClick: moveToRight,
	      icon: "right"
	    }, rightArrowText), /*#__PURE__*/React.createElement(_button["default"], {
	      type: "primary",
	      size: "small",
	      disabled: disabled || !leftActive,
	      onClick: moveToLeft,
	      icon: "left"
	    }, leftArrowText))
	  );
	};
	
	var _default = Operation;
	exports["default"] = _default;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OmitProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(16);
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _raf = _interopRequireDefault(__webpack_require__(200));
	
	var _type = __webpack_require__(82);
	
	var _ListItem = _interopRequireDefault(__webpack_require__(1272));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var OmitProps = (0, _type.tuple)('handleFilter', 'handleSelect', 'handleSelectAll', 'handleClear', 'body', 'checkedKeys');
	exports.OmitProps = OmitProps;
	
	var ListBody = /*#__PURE__*/function (_React$Component) {
	  _inherits(ListBody, _React$Component);
	
	  var _super = _createSuper(ListBody);
	
	  function ListBody() {
	    var _this;
	
	    _classCallCheck(this, ListBody);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      mounted: false
	    };
	
	    _this.onItemSelect = function (item) {
	      var _this$props = _this.props,
	          onItemSelect = _this$props.onItemSelect,
	          selectedKeys = _this$props.selectedKeys;
	      var checked = selectedKeys.indexOf(item.key) >= 0;
	      onItemSelect(item.key, !checked);
	    };
	
	    return _this;
	  }
	
	  _createClass(ListBody, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mountId = (0, _raf["default"])(function () {
	        _this2.setState({
	          mounted: true
	        });
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props2 = this.props,
	          filteredRenderItems = _this$props2.filteredRenderItems,
	          lazy = _this$props2.lazy;
	
	      if (prevProps.filteredRenderItems.length !== filteredRenderItems.length && lazy !== false) {
	        // TODO: Replace this with ref when react 15 support removed.
	        var container = (0, _reactDom.findDOMNode)(this);
	
	        _raf["default"].cancel(this.lazyId);
	
	        this.lazyId = (0, _raf["default"])(function () {
	          if (container) {
	            var scrollEvent = new Event('scroll', {
	              bubbles: true
	            });
	            container.dispatchEvent(scrollEvent);
	          }
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountId);
	
	      _raf["default"].cancel(this.lazyId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var mounted = this.state.mounted;
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          onScroll = _this$props3.onScroll,
	          filteredRenderItems = _this$props3.filteredRenderItems,
	          lazy = _this$props3.lazy,
	          selectedKeys = _this$props3.selectedKeys,
	          globalDisabled = _this$props3.disabled;
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "ul",
	          componentProps: {
	            onScroll: onScroll
	          },
	          className: "".concat(prefixCls, "-content"),
	          transitionName: mounted ? "".concat(prefixCls, "-content-item-highlight") : '',
	          transitionLeave: false
	        }, filteredRenderItems.map(function (_ref) {
	          var renderedEl = _ref.renderedEl,
	              renderedText = _ref.renderedText,
	              item = _ref.item;
	          var disabled = item.disabled;
	          var checked = selectedKeys.indexOf(item.key) >= 0;
	          return (/*#__PURE__*/React.createElement(_ListItem["default"], {
	              disabled: globalDisabled || disabled,
	              key: item.key,
	              item: item,
	              lazy: lazy,
	              renderedText: renderedText,
	              renderedEl: renderedEl,
	              checked: checked,
	              prefixCls: prefixCls,
	              onClick: _this3.onItemSelect
	            })
	          );
	        }))
	      );
	    }
	  }]);
	
	  return ListBody;
	}(React.Component);
	
	var ListBodyWrapper = function ListBodyWrapper(props) {
	  return (/*#__PURE__*/React.createElement(ListBody, props)
	  );
	};
	
	var _default = ListBodyWrapper;
	exports["default"] = _default;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcTreeSelect = _interopRequireWildcard(__webpack_require__(484));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(14);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _reactNode = __webpack_require__(631);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TreeSelect = /*#__PURE__*/function (_React$Component) {
	  _inherits(TreeSelect, _React$Component);
	
	  var _super = _createSuper(TreeSelect);
	
	  function TreeSelect(props) {
	    var _this;
	
	    _classCallCheck(this, TreeSelect);
	
	    _this = _super.call(this, props);
	
	    _this.saveTreeSelect = function (node) {
	      _this.rcTreeSelect = node;
	    };
	
	    _this.renderSwitcherIcon = function (prefixCls, _ref) {
	      var isLeaf = _ref.isLeaf,
	          loading = _ref.loading;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading",
	            className: "".concat(prefixCls, "-switcher-loading-icon")
	          })
	        );
	      }
	
	      if (isLeaf) {
	        return null;
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "caret-down",
	          className: "".concat(prefixCls, "-switcher-icon")
	        })
	      );
	    };
	
	    _this.renderTreeSelect = function (_ref2) {
	      var _classNames;
	
	      var getContextPopupContainer = _ref2.getPopupContainer,
	          getPrefixCls = _ref2.getPrefixCls,
	          renderEmpty = _ref2.renderEmpty;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          size = _a.size,
	          notFoundContent = _a.notFoundContent,
	          dropdownStyle = _a.dropdownStyle,
	          dropdownClassName = _a.dropdownClassName,
	          suffixIcon = _a.suffixIcon,
	          removeIcon = _a.removeIcon,
	          clearIcon = _a.clearIcon,
	          getPopupContainer = _a.getPopupContainer,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "notFoundContent", "dropdownStyle", "dropdownClassName", "suffixIcon", "removeIcon", "clearIcon", "getPopupContainer"]);
	
	      var rest = (0, _omit["default"])(restProps, ['inputIcon', 'removeIcon', 'clearIcon', 'switcherIcon']);
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className); // showSearch: single - false, multiple - true
	
	      var showSearch = restProps.showSearch;
	
	      if (!('showSearch' in restProps)) {
	        showSearch = !!(restProps.multiple || restProps.treeCheckable);
	      }
	
	      var checkable = rest.treeCheckable;
	
	      if (checkable) {
	        checkable = /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-tree-checkbox-inner")
	        });
	      }
	
	      var inputIcon = suffixIcon ? (0, _reactNode.cloneElement)(suffixIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-arrow-icon")
	      });
	      var finalRemoveIcon = removeIcon ? (0, _reactNode.cloneElement)(removeIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        className: "".concat(prefixCls, "-remove-icon")
	      });
	      var finalClearIcon = clearIcon ? (0, _reactNode.cloneElement)(clearIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-clear-icon")
	      });
	      return (/*#__PURE__*/React.createElement(_rcTreeSelect["default"], _extends({
	          switcherIcon: function switcherIcon(nodeProps) {
	            return _this.renderSwitcherIcon(prefixCls, nodeProps);
	          },
	          inputIcon: inputIcon,
	          removeIcon: finalRemoveIcon,
	          clearIcon: finalClearIcon
	        }, rest, {
	          showSearch: showSearch,
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          dropdownClassName: (0, _classnames["default"])(dropdownClassName, "".concat(prefixCls, "-tree-dropdown")),
	          prefixCls: prefixCls,
	          className: cls,
	          dropdownStyle: _extends({
	            maxHeight: '100vh',
	            overflow: 'auto'
	          }, dropdownStyle),
	          treeCheckable: checkable,
	          notFoundContent: notFoundContent || renderEmpty('Select'),
	          ref: _this.saveTreeSelect
	        }))
	      );
	    };
	
	    (0, _warning["default"])(props.multiple !== false || !props.treeCheckable, 'TreeSelect', '`multiple` will alway be `true` when `treeCheckable` is true');
	    return _this;
	  }
	
	  _createClass(TreeSelect, [{
	    key: "focus",
	    value: function focus() {
	      this.rcTreeSelect.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcTreeSelect.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTreeSelect)
	      );
	    }
	  }]);
	
	  return TreeSelect;
	}(React.Component);
	
	exports["default"] = TreeSelect;
	TreeSelect.TreeNode = _rcTreeSelect.TreeNode;
	TreeSelect.SHOW_ALL = _rcTreeSelect.SHOW_ALL;
	TreeSelect.SHOW_PARENT = _rcTreeSelect.SHOW_PARENT;
	TreeSelect.SHOW_CHILD = _rcTreeSelect.SHOW_CHILD;
	TreeSelect.defaultProps = {
	  transitionName: 'slide-up',
	  choiceTransitionName: 'zoom'
	};

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _util = __webpack_require__(182);
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _configProvider = __webpack_require__(14);
	
	var _Tree = _interopRequireDefault(__webpack_require__(662));
	
	var _util2 = __webpack_require__(1280);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getIcon(props) {
	  var isLeaf = props.isLeaf,
	      expanded = props.expanded;
	
	  if (isLeaf) {
	    return (/*#__PURE__*/React.createElement(_icon["default"], {
	        type: "file"
	      })
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement(_icon["default"], {
	      type: expanded ? 'folder-open' : 'folder'
	    })
	  );
	}
	
	var DirectoryTree = /*#__PURE__*/function (_React$Component) {
	  _inherits(DirectoryTree, _React$Component);
	
	  var _super = _createSuper(DirectoryTree);
	
	  function DirectoryTree(props) {
	    var _this;
	
	    _classCallCheck(this, DirectoryTree);
	
	    _this = _super.call(this, props);
	
	    _this.onExpand = function (expandedKeys, info) {
	      var onExpand = _this.props.onExpand;
	
	      _this.setUncontrolledState({
	        expandedKeys: expandedKeys
	      }); // Call origin function
	
	
	      if (onExpand) {
	        return onExpand(expandedKeys, info);
	      }
	
	      return undefined;
	    };
	
	    _this.onClick = function (event, node) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          expandAction = _this$props.expandAction; // Expand the tree
	
	      if (expandAction === 'click') {
	        _this.onDebounceExpand(event, node);
	      }
	
	      if (onClick) {
	        onClick(event, node);
	      }
	    };
	
	    _this.onDoubleClick = function (event, node) {
	      var _this$props2 = _this.props,
	          onDoubleClick = _this$props2.onDoubleClick,
	          expandAction = _this$props2.expandAction; // Expand the tree
	
	      if (expandAction === 'doubleClick') {
	        _this.onDebounceExpand(event, node);
	      }
	
	      if (onDoubleClick) {
	        onDoubleClick(event, node);
	      }
	    };
	
	    _this.onSelect = function (keys, event) {
	      var _this$props3 = _this.props,
	          onSelect = _this$props3.onSelect,
	          multiple = _this$props3.multiple,
	          children = _this$props3.children;
	      var _this$state$expandedK = _this.state.expandedKeys,
	          expandedKeys = _this$state$expandedK === void 0 ? [] : _this$state$expandedK;
	      var node = event.node,
	          nativeEvent = event.nativeEvent;
	      var _node$props$eventKey = node.props.eventKey,
	          eventKey = _node$props$eventKey === void 0 ? '' : _node$props$eventKey;
	      var newState = {}; // We need wrap this event since some value is not same
	
	      var newEvent = _extends(_extends({}, event), {
	        selected: true
	      }); // Windows / Mac single pick
	
	
	      var ctrlPick = nativeEvent.ctrlKey || nativeEvent.metaKey;
	      var shiftPick = nativeEvent.shiftKey; // Generate new selected keys
	
	      var newSelectedKeys;
	
	      if (multiple && ctrlPick) {
	        // Control click
	        newSelectedKeys = keys;
	        _this.lastSelectedKey = eventKey;
	        _this.cachedSelectedKeys = newSelectedKeys;
	        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
	      } else if (multiple && shiftPick) {
	        // Shift click
	        newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(_this.cachedSelectedKeys || []), _toConsumableArray((0, _util2.calcRangeKeys)(children, expandedKeys, eventKey, _this.lastSelectedKey)))));
	        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
	      } else {
	        // Single click
	        newSelectedKeys = [eventKey];
	        _this.lastSelectedKey = eventKey;
	        _this.cachedSelectedKeys = newSelectedKeys;
	        newEvent.selectedNodes = [event.node];
	      }
	
	      newState.selectedKeys = newSelectedKeys;
	
	      if (onSelect) {
	        onSelect(newSelectedKeys, newEvent);
	      }
	
	      _this.setUncontrolledState(newState);
	    };
	
	    _this.setTreeRef = function (node) {
	      _this.tree = node;
	    };
	
	    _this.expandFolderNode = function (event, node) {
	      var isLeaf = node.props.isLeaf;
	
	      if (isLeaf || event.shiftKey || event.metaKey || event.ctrlKey) {
	        return;
	      } // Get internal rc-tree
	
	
	      var internalTree = _this.tree.tree; // Call internal rc-tree expand function
	      // https://github.com/ant-design/ant-design/issues/12567
	
	      internalTree.onNodeExpand(event, node);
	    };
	
	    _this.setUncontrolledState = function (state) {
	      var newState = (0, _omit["default"])(state, Object.keys(_this.props));
	
	      if (Object.keys(newState).length) {
	        _this.setState(newState);
	      }
	    };
	
	    _this.renderDirectoryTree = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          props = __rest(_a, ["prefixCls", "className"]);
	
	      var _this$state = _this.state,
	          expandedKeys = _this$state.expandedKeys,
	          selectedKeys = _this$state.selectedKeys;
	      var prefixCls = getPrefixCls('tree', customizePrefixCls);
	      var connectClassName = (0, _classnames["default"])("".concat(prefixCls, "-directory"), className);
	      return (/*#__PURE__*/React.createElement(_Tree["default"], _extends({
	          icon: getIcon,
	          ref: _this.setTreeRef
	        }, props, {
	          prefixCls: prefixCls,
	          className: connectClassName,
	          expandedKeys: expandedKeys,
	          selectedKeys: selectedKeys,
	          onSelect: _this.onSelect,
	          onClick: _this.onClick,
	          onDoubleClick: _this.onDoubleClick,
	          onExpand: _this.onExpand
	        }))
	      );
	    };
	
	    var defaultExpandAll = props.defaultExpandAll,
	        defaultExpandParent = props.defaultExpandParent,
	        expandedKeys = props.expandedKeys,
	        defaultExpandedKeys = props.defaultExpandedKeys,
	        children = props.children;
	
	    var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
	        keyEntities = _convertTreeToEntitie.keyEntities; // Selected keys
	
	
	    _this.state = {
	      selectedKeys: props.selectedKeys || props.defaultSelectedKeys || []
	    }; // Expanded keys
	
	    if (defaultExpandAll) {
	      if (props.treeData) {
	        _this.state.expandedKeys = (0, _util2.getFullKeyListByTreeData)(props.treeData);
	      } else {
	        _this.state.expandedKeys = (0, _util2.getFullKeyList)(props.children);
	      }
	    } else if (defaultExpandParent) {
	      _this.state.expandedKeys = (0, _util.conductExpandParent)(expandedKeys || defaultExpandedKeys, keyEntities);
	    } else {
	      _this.state.expandedKeys = expandedKeys || defaultExpandedKeys;
	    }
	
	    _this.onDebounceExpand = (0, _debounce["default"])(_this.expandFolderNode, 200, {
	      leading: true
	    });
	    return _this;
	  }
	
	  _createClass(DirectoryTree, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDirectoryTree)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	
	      if ('expandedKeys' in nextProps) {
	        newState.expandedKeys = nextProps.expandedKeys;
	      }
	
	      if ('selectedKeys' in nextProps) {
	        newState.selectedKeys = nextProps.selectedKeys;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return DirectoryTree;
	}(React.Component);
	
	DirectoryTree.defaultProps = {
	  showIcon: true,
	  expandAction: 'click'
	};
	(0, _reactLifecyclesCompat.polyfill)(DirectoryTree);
	var _default = DirectoryTree;
	exports["default"] = _default;

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Tree = _interopRequireDefault(__webpack_require__(662));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Tree["default"];
	exports["default"] = _default;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFullKeyList = getFullKeyList;
	exports.calcRangeKeys = calcRangeKeys;
	exports.convertDirectoryKeysToNodes = convertDirectoryKeysToNodes;
	exports.getFullKeyListByTreeData = getFullKeyListByTreeData;
	
	var _util = __webpack_require__(182);
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var Record;
	
	(function (Record) {
	  Record[Record["None"] = 0] = "None";
	  Record[Record["Start"] = 1] = "Start";
	  Record[Record["End"] = 2] = "End";
	})(Record || (Record = {})); // TODO: Move this logic into `rc-tree`
	
	
	function traverseNodesKey(rootChildren, callback) {
	  var nodeList = (0, _util.getNodeChildren)(rootChildren) || [];
	
	  function processNode(node) {
	    var key = node.key,
	        children = node.props.children;
	
	    if (callback(key, node) !== false) {
	      traverseNodesKey(children, callback);
	    }
	  }
	
	  nodeList.forEach(processNode);
	}
	
	function getFullKeyList(children) {
	  var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
	      keyEntities = _convertTreeToEntitie.keyEntities;
	
	  return Object.keys(keyEntities);
	}
	/** 计算选中范围，只考虑expanded情况以优化性能 */
	
	function calcRangeKeys(rootChildren, expandedKeys, startKey, endKey) {
	  var keys = [];
	  var record = Record.None;
	
	  if (startKey && startKey === endKey) {
	    return [startKey];
	  }
	
	  if (!startKey || !endKey) {
	    return [];
	  }
	
	  function matchKey(key) {
	    return key === startKey || key === endKey;
	  }
	
	  traverseNodesKey(rootChildren, function (key) {
	    if (record === Record.End) {
	      return false;
	    }
	
	    if (matchKey(key)) {
	      // Match test
	      keys.push(key);
	
	      if (record === Record.None) {
	        record = Record.Start;
	      } else if (record === Record.Start) {
	        record = Record.End;
	        return false;
	      }
	    } else if (record === Record.Start) {
	      // Append selection
	      keys.push(key);
	    }
	
	    if (expandedKeys.indexOf(key) === -1) {
	      return false;
	    }
	
	    return true;
	  });
	  return keys;
	}
	
	function convertDirectoryKeysToNodes(rootChildren, keys) {
	  var restKeys = _toConsumableArray(keys);
	
	  var nodes = [];
	  traverseNodesKey(rootChildren, function (key, node) {
	    var index = restKeys.indexOf(key);
	
	    if (index !== -1) {
	      nodes.push(node);
	      restKeys.splice(index, 1);
	    }
	
	    return !!restKeys.length;
	  });
	  return nodes;
	}
	
	function getFullKeyListByTreeData(treeData) {
	  var keys = [];
	  (treeData || []).forEach(function (item) {
	    keys.push(item.key);
	
	    if (item.children) {
	      keys = [].concat(_toConsumableArray(keys), _toConsumableArray(getFullKeyListByTreeData(item.children)));
	    }
	  });
	  return keys;
	}

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(650));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Editable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Editable, _React$Component);
	
	  var _super = _createSuper(Editable);
	
	  function Editable() {
	    var _this;
	
	    _classCallCheck(this, Editable);
	
	    _this = _super.apply(this, arguments);
	    _this.inComposition = false;
	    _this.state = {
	      current: ''
	    };
	
	    _this.onChange = function (_ref) {
	      var value = _ref.target.value;
	
	      _this.setState({
	        current: value.replace(/[\r\n]/g, '')
	      });
	    };
	
	    _this.onCompositionStart = function () {
	      _this.inComposition = true;
	    };
	
	    _this.onCompositionEnd = function () {
	      _this.inComposition = false;
	    };
	
	    _this.onKeyDown = function (_ref2) {
	      var keyCode = _ref2.keyCode;
	      // We don't record keyCode when IME is using
	      if (_this.inComposition) return;
	      _this.lastKeyCode = keyCode;
	    };
	
	    _this.onKeyUp = function (_ref3) {
	      var keyCode = _ref3.keyCode,
	          ctrlKey = _ref3.ctrlKey,
	          altKey = _ref3.altKey,
	          metaKey = _ref3.metaKey,
	          shiftKey = _ref3.shiftKey;
	      var onCancel = _this.props.onCancel; // Check if it's a real key
	
	      if (_this.lastKeyCode === keyCode && !_this.inComposition && !ctrlKey && !altKey && !metaKey && !shiftKey) {
	        if (keyCode === _KeyCode["default"].ENTER) {
	          _this.confirmChange();
	        } else if (keyCode === _KeyCode["default"].ESC) {
	          onCancel();
	        }
	      }
	    };
	
	    _this.onBlur = function () {
	      _this.confirmChange();
	    };
	
	    _this.confirmChange = function () {
	      var current = _this.state.current;
	      var onSave = _this.props.onSave;
	      onSave(current.trim());
	    };
	
	    _this.setTextarea = function (textarea) {
	      _this.textarea = textarea;
	    };
	
	    return _this;
	  }
	
	  _createClass(Editable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.textarea && this.textarea.resizableTextArea) {
	        var textArea = this.textarea.resizableTextArea.textArea;
	        textArea.focus();
	        var length = textArea.value.length;
	        textArea.setSelectionRange(length, length);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var current = this.state.current;
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          ariaLabel = _this$props['aria-label'],
	          className = _this$props.className,
	          style = _this$props.style;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-edit-content"), className),
	          style: style
	        }, /*#__PURE__*/React.createElement(_TextArea["default"], {
	          ref: this.setTextarea,
	          value: current,
	          onChange: this.onChange,
	          onKeyDown: this.onKeyDown,
	          onKeyUp: this.onKeyUp,
	          onCompositionStart: this.onCompositionStart,
	          onCompositionEnd: this.onCompositionEnd,
	          onBlur: this.onBlur,
	          "aria-label": ariaLabel,
	          autoSize: true
	        }), /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "enter",
	          className: "".concat(prefixCls, "-edit-content-confirm")
	        }))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevValue = prevState.prevValue;
	      var value = nextProps.value;
	      var newState = {
	        prevValue: value
	      };
	
	      if (prevValue !== value) {
	        newState.current = value;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Editable;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(Editable);
	var _default = Editable;
	exports["default"] = _default;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Base = _interopRequireDefault(__webpack_require__(365));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Paragraph = function Paragraph(props) {
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, props, {
	      component: "div"
	    }))
	  );
	};
	
	var _default = Paragraph;
	exports["default"] = _default;

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _Base = _interopRequireDefault(__webpack_require__(365));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Text = function Text(_a) {
	  var ellipsis = _a.ellipsis,
	      restProps = __rest(_a, ["ellipsis"]);
	
	  (0, _warning["default"])(_typeof(ellipsis) !== 'object', 'Typography.Text', '`ellipsis` only supports boolean value.');
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, restProps, {
	      ellipsis: !!ellipsis,
	      component: "span"
	    }))
	  );
	};
	
	var _default = Text;
	exports["default"] = _default;

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(495));
	
	var _Base = _interopRequireDefault(__webpack_require__(365));
	
	var _type = __webpack_require__(82);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TITLE_ELE_LIST = (0, _type.tupleNum)(1, 2, 3, 4);
	
	var Title = function Title(props) {
	  var _props$level = props.level,
	      level = _props$level === void 0 ? 1 : _props$level,
	      restProps = __rest(props, ["level"]);
	
	  var component;
	
	  if (TITLE_ELE_LIST.indexOf(level) !== -1) {
	    component = "h".concat(level);
	  } else {
	    (0, _warning["default"])(false, 'Title only accept `1 | 2 | 3 | 4` as `level` value.');
	    component = 'h1';
	  }
	
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, restProps, {
	      component: component
	    }))
	  );
	};
	
	var _default = Title;
	exports["default"] = _default;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Typography = _interopRequireDefault(__webpack_require__(663));
	
	var _Text = _interopRequireDefault(__webpack_require__(1283));
	
	var _Title = _interopRequireDefault(__webpack_require__(1284));
	
	var _Paragraph = _interopRequireDefault(__webpack_require__(1282));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var Typography = _Typography["default"];
	Typography.Text = _Text["default"];
	Typography.Title = _Title["default"];
	Typography.Paragraph = _Paragraph["default"];
	var _default = Typography;
	exports["default"] = _default;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactDom = __webpack_require__(16);
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	// We only handle element & text node.
	var ELEMENT_NODE = 1;
	var TEXT_NODE = 3;
	var COMMENT_NODE = 8;
	var ellipsisContainer;
	var wrapperStyle = {
	  padding: 0,
	  margin: 0,
	  display: 'inline',
	  lineHeight: 'inherit'
	};
	
	function pxToNumber(value) {
	  if (!value) return 0;
	  var match = value.match(/^\d*(\.\d*)?/);
	  return match ? Number(match[0]) : 0;
	}
	
	function styleToString(style) {
	  // There are some different behavior between Firefox & Chrome.
	  // We have to handle this ourself.
	  var styleNames = Array.prototype.slice.apply(style);
	  return styleNames.map(function (name) {
	    return "".concat(name, ": ").concat(style.getPropertyValue(name), ";");
	  }).join('');
	}
	
	function mergeChildren(children) {
	  var childList = [];
	  children.forEach(function (child) {
	    var prevChild = childList[childList.length - 1];
	
	    if (typeof child === 'string' && typeof prevChild === 'string') {
	      childList[childList.length - 1] += child;
	    } else {
	      childList.push(child);
	    }
	  });
	  return childList;
	}
	
	var _default = function _default(originEle, rows, content, fixedContent, ellipsisStr) {
	  if (!ellipsisContainer) {
	    ellipsisContainer = document.createElement('div');
	    ellipsisContainer.setAttribute('aria-hidden', 'true');
	    document.body.appendChild(ellipsisContainer);
	  } // Get origin style
	
	
	  var originStyle = window.getComputedStyle(originEle);
	  var originCSS = styleToString(originStyle);
	  var lineHeight = pxToNumber(originStyle.lineHeight);
	  var maxHeight = lineHeight * (rows + 1) + pxToNumber(originStyle.paddingTop) + pxToNumber(originStyle.paddingBottom); // Set shadow
	
	  ellipsisContainer.setAttribute('style', originCSS);
	  ellipsisContainer.style.position = 'fixed';
	  ellipsisContainer.style.left = '0';
	  ellipsisContainer.style.height = 'auto';
	  ellipsisContainer.style.minHeight = 'auto';
	  ellipsisContainer.style.maxHeight = 'auto';
	  ellipsisContainer.style.top = '-999999px';
	  ellipsisContainer.style.zIndex = '-1000'; // clean up css overflow
	
	  ellipsisContainer.style.textOverflow = 'clip';
	  ellipsisContainer.style.whiteSpace = 'normal';
	  ellipsisContainer.style.webkitLineClamp = 'none'; // Render in the fake container
	
	  var contentList = mergeChildren((0, _toArray["default"])(content));
	  (0, _reactDom.render)( /*#__PURE__*/React.createElement("div", {
	    style: wrapperStyle
	  }, /*#__PURE__*/React.createElement("span", {
	    style: wrapperStyle
	  }, contentList), /*#__PURE__*/React.createElement("span", {
	    style: wrapperStyle
	  }, fixedContent)), ellipsisContainer); // wrap in an div for old version react
	  // Check if ellipsis in measure div is height enough for content
	
	  function inRange() {
	    return ellipsisContainer.offsetHeight < maxHeight;
	  } // Skip ellipsis if already match
	
	
	  if (inRange()) {
	    (0, _reactDom.unmountComponentAtNode)(ellipsisContainer);
	    return {
	      content: content,
	      text: ellipsisContainer.innerHTML,
	      ellipsis: false
	    };
	  } // We should clone the childNode since they're controlled by React and we can't reuse it without warning
	
	
	  var childNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[0].cloneNode(true).childNodes).filter(function (_ref) {
	    var nodeType = _ref.nodeType;
	    return nodeType !== COMMENT_NODE;
	  });
	  var fixedNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[1].cloneNode(true).childNodes);
	  (0, _reactDom.unmountComponentAtNode)(ellipsisContainer); // ========================= Find match ellipsis content =========================
	
	  var ellipsisChildren = [];
	  ellipsisContainer.innerHTML = ''; // Create origin content holder
	
	  var ellipsisContentHolder = document.createElement('span');
	  ellipsisContainer.appendChild(ellipsisContentHolder);
	  var ellipsisTextNode = document.createTextNode(ellipsisStr);
	  ellipsisContentHolder.appendChild(ellipsisTextNode);
	  fixedNodes.forEach(function (childNode) {
	    ellipsisContainer.appendChild(childNode);
	  }); // Append before fixed nodes
	
	  function appendChildNode(node) {
	    ellipsisContentHolder.insertBefore(node, ellipsisTextNode);
	  } // Get maximum text
	
	
	  function measureText(textNode, fullText) {
	    var startLoc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var endLoc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : fullText.length;
	    var lastSuccessLoc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	    var midLoc = Math.floor((startLoc + endLoc) / 2);
	    var currentText = fullText.slice(0, midLoc);
	    textNode.textContent = currentText;
	
	    if (startLoc >= endLoc - 1) {
	      // Loop when step is small
	      for (var step = endLoc; step >= startLoc; step -= 1) {
	        var currentStepText = fullText.slice(0, step);
	        textNode.textContent = currentStepText;
	
	        if (inRange()) {
	          return step === fullText.length ? {
	            finished: false,
	            reactNode: fullText
	          } : {
	            finished: true,
	            reactNode: currentStepText
	          };
	        }
	      }
	    }
	
	    if (inRange()) {
	      return measureText(textNode, fullText, midLoc, endLoc, midLoc);
	    }
	
	    return measureText(textNode, fullText, startLoc, midLoc, lastSuccessLoc);
	  }
	
	  function measureNode(childNode, index) {
	    var type = childNode.nodeType;
	
	    if (type === ELEMENT_NODE) {
	      // We don't split element, it will keep if whole element can be displayed.
	      appendChildNode(childNode);
	
	      if (inRange()) {
	        return {
	          finished: false,
	          reactNode: contentList[index]
	        };
	      } // Clean up if can not pull in
	
	
	      ellipsisContentHolder.removeChild(childNode);
	      return {
	        finished: true,
	        reactNode: null
	      };
	    }
	
	    if (type === TEXT_NODE) {
	      var fullText = childNode.textContent || '';
	      var textNode = document.createTextNode(fullText);
	      appendChildNode(textNode);
	      return measureText(textNode, fullText);
	    } // Not handle other type of content
	    // PS: This code should not be attached after react 16
	
	
	    return {
	      finished: false,
	      reactNode: null
	    };
	  }
	
	  childNodes.some(function (childNode, index) {
	    var _measureNode = measureNode(childNode, index),
	        finished = _measureNode.finished,
	        reactNode = _measureNode.reactNode;
	
	    if (reactNode) {
	      ellipsisChildren.push(reactNode);
	    }
	
	    return finished;
	  });
	  return {
	    content: ellipsisChildren,
	    text: ellipsisContainer.innerHTML,
	    ellipsis: true
	  };
	};
	
	exports["default"] = _default;

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Upload = _interopRequireDefault(__webpack_require__(664));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// stick class comoponent to avoid React ref warning inside Form
	// https://github.com/ant-design/ant-design/issues/18707
	// eslint-disable-next-line react/prefer-stateless-function
	var Dragger = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dragger, _React$Component);
	
	  var _super = _createSuper(Dragger);
	
	  function Dragger() {
	    _classCallCheck(this, Dragger);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dragger, [{
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          style = _a.style,
	          height = _a.height,
	          restProps = __rest(_a, ["style", "height"]);
	
	      return (/*#__PURE__*/React.createElement(_Upload["default"], _extends({}, restProps, {
	          type: "drag",
	          style: _extends(_extends({}, style), {
	            height: height
	          })
	        }))
	      );
	    }
	  }]);
	
	  return Dragger;
	}(React.Component);
	
	exports["default"] = Dragger;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _classnames = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(665);
	
	var _icon = _interopRequireDefault(__webpack_require__(22));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(124));
	
	var _progress = _interopRequireDefault(__webpack_require__(654));
	
	var _configProvider = __webpack_require__(14);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var UploadList = /*#__PURE__*/function (_React$Component) {
	  _inherits(UploadList, _React$Component);
	
	  var _super = _createSuper(UploadList);
	
	  function UploadList() {
	    var _this;
	
	    _classCallCheck(this, UploadList);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handlePreview = function (file, e) {
	      var onPreview = _this.props.onPreview;
	
	      if (!onPreview) {
	        return;
	      }
	
	      e.preventDefault();
	      return onPreview(file);
	    };
	
	    _this.handleDownload = function (file) {
	      var onDownload = _this.props.onDownload;
	
	      if (typeof onDownload === 'function') {
	        onDownload(file);
	      } else if (file.url) {
	        window.open(file.url);
	      }
	    };
	
	    _this.handleClose = function (file) {
	      var onRemove = _this.props.onRemove;
	
	      if (onRemove) {
	        onRemove(file);
	      }
	    };
	
	    _this.renderUploadList = function (_ref) {
	      var _classNames4;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$items = _this$props.items,
	          items = _this$props$items === void 0 ? [] : _this$props$items,
	          listType = _this$props.listType,
	          showPreviewIcon = _this$props.showPreviewIcon,
	          showRemoveIcon = _this$props.showRemoveIcon,
	          showDownloadIcon = _this$props.showDownloadIcon,
	          locale = _this$props.locale,
	          progressAttr = _this$props.progressAttr;
	      var prefixCls = getPrefixCls('upload', customizePrefixCls);
	      var list = items.map(function (file) {
	        var _classNames, _classNames2;
	
	        var progress;
	        var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: file.status === 'uploading' ? 'loading' : 'paper-clip'
	        });
	
	        if (listType === 'picture' || listType === 'picture-card') {
	          if (listType === 'picture-card' && file.status === 'uploading') {
	            icon = /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-list-item-uploading-text")
	            }, locale.uploading);
	          } else if (!file.thumbUrl && !file.url) {
	            icon = /*#__PURE__*/React.createElement(_icon["default"], {
	              className: "".concat(prefixCls, "-list-item-thumbnail"),
	              type: "picture",
	              theme: "twoTone"
	            });
	          } else {
	            var thumbnail = (0, _utils.isImageUrl)(file) ? /*#__PURE__*/React.createElement("img", {
	              src: file.thumbUrl || file.url,
	              alt: file.name,
	              className: "".concat(prefixCls, "-list-item-image")
	            }) : /*#__PURE__*/React.createElement(_icon["default"], {
	              type: "file",
	              className: "".concat(prefixCls, "-list-item-icon"),
	              theme: "twoTone"
	            });
	            icon = /*#__PURE__*/React.createElement("a", {
	              className: "".concat(prefixCls, "-list-item-thumbnail"),
	              onClick: function onClick(e) {
	                return _this.handlePreview(file, e);
	              },
	              href: file.url || file.thumbUrl,
	              target: "_blank",
	              rel: "noopener noreferrer"
	            }, thumbnail);
	          }
	        }
	
	        if (file.status === 'uploading') {
	          // show loading icon if upload progress listener is disabled
	          var loadingProgress = 'percent' in file ? /*#__PURE__*/React.createElement(_progress["default"], _extends({
	            type: "line"
	          }, progressAttr, {
	            percent: file.percent
	          })) : null;
	          progress = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-list-item-progress"),
	            key: "progress"
	          }, loadingProgress);
	        }
	
	        var infoUploadingClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-list-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-").concat(file.status), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames));
	        var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
	        var removeIcon = showRemoveIcon ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "delete",
	          title: locale.removeFile,
	          onClick: function onClick() {
	            return _this.handleClose(file);
	          }
	        }) : null;
	        var downloadIcon = showDownloadIcon && file.status === 'done' ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "download",
	          title: locale.downloadFile,
	          onClick: function onClick() {
	            return _this.handleDownload(file);
	          }
	        }) : null;
	        var downloadOrDelete = listType !== 'picture-card' && /*#__PURE__*/React.createElement("span", {
	          key: "download-delete",
	          className: "".concat(prefixCls, "-list-item-card-actions ").concat(listType === 'picture' ? 'picture' : '')
	        }, downloadIcon && /*#__PURE__*/React.createElement("a", {
	          title: locale.downloadFile
	        }, downloadIcon), removeIcon && /*#__PURE__*/React.createElement("a", {
	          title: locale.removeFile
	        }, removeIcon));
	        var listItemNameClass = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name-icon-count-").concat([downloadIcon, removeIcon].filter(function (x) {
	          return x;
	        }).length), true), _classNames2));
	        var preview = file.url ? [/*#__PURE__*/React.createElement("a", _extends({
	          key: "view",
	          target: "_blank",
	          rel: "noopener noreferrer",
	          className: listItemNameClass,
	          title: file.name
	        }, linkProps, {
	          href: file.url,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          }
	        }), file.name), downloadOrDelete] : [/*#__PURE__*/React.createElement("span", {
	          key: "view",
	          className: listItemNameClass,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          },
	          title: file.name
	        }, file.name), downloadOrDelete];
	        var style = {
	          pointerEvents: 'none',
	          opacity: 0.5
	        };
	        var previewIcon = showPreviewIcon ? /*#__PURE__*/React.createElement("a", {
	          href: file.url || file.thumbUrl,
	          target: "_blank",
	          rel: "noopener noreferrer",
	          style: file.url || file.thumbUrl ? undefined : style,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          },
	          title: locale.previewFile
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "eye-o"
	        })) : null;
	        var actions = listType === 'picture-card' && file.status !== 'uploading' && /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-list-item-actions")
	        }, previewIcon, file.status === 'done' && downloadIcon, removeIcon);
	        var message;
	
	        if (file.response && typeof file.response === 'string') {
	          message = file.response;
	        } else {
	          message = file.error && file.error.statusText || locale.uploadError;
	        }
	
	        var iconAndPreview = /*#__PURE__*/React.createElement("span", null, icon, preview);
	        var dom = /*#__PURE__*/React.createElement("div", {
	          className: infoUploadingClass
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-list-item-info")
	        }, iconAndPreview), actions, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "fade",
	          component: ""
	        }, progress));
	        var listContainerNameClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-list-picture-card-container"), listType === 'picture-card'));
	        return (/*#__PURE__*/React.createElement("div", {
	            key: file.uid,
	            className: listContainerNameClass
	          }, file.status === 'error' ? /*#__PURE__*/React.createElement(_tooltip["default"], {
	            title: message
	          }, dom) : /*#__PURE__*/React.createElement("span", null, dom))
	        );
	      });
	      var listClassNames = (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-list"), true), _defineProperty(_classNames4, "".concat(prefixCls, "-list-").concat(listType), true), _classNames4));
	      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "".concat(prefixCls, "-").concat(animationDirection),
	          component: "div",
	          className: listClassNames
	        }, list)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(UploadList, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          listType = _this$props2.listType,
	          items = _this$props2.items,
	          previewFile = _this$props2.previewFile;
	
	      if (listType !== 'picture' && listType !== 'picture-card') {
	        return;
	      }
	
	      (items || []).forEach(function (file) {
	        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
	          return;
	        }
	
	        file.thumbUrl = '';
	
	        if (previewFile) {
	          previewFile(file.originFileObj).then(function (previewDataUrl) {
	            // Need append '' to avoid dead loop
	            file.thumbUrl = previewDataUrl || '';
	
	            _this2.forceUpdate();
	          });
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUploadList)
	      );
	    }
	  }]);
	
	  return UploadList;
	}(React.Component);
	
	exports["default"] = UploadList;
	UploadList.defaultProps = {
	  listType: 'text',
	  progressAttr: {
	    strokeWidth: 2,
	    showInfo: false
	  },
	  showRemoveIcon: true,
	  showDownloadIcon: false,
	  showPreviewIcon: true,
	  previewFile: _utils.previewImage
	};

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Upload = _interopRequireDefault(__webpack_require__(664));
	
	var _Dragger = _interopRequireDefault(__webpack_require__(1287));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Upload["default"].Dragger = _Dragger["default"];
	var _default = _Upload["default"];
	exports["default"] = _default;

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _package = _interopRequireDefault({ version: '3.26.20' });
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _package["default"].version;
	exports["default"] = _default;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*!
	 * jsoneditor.js
	 *
	 * @brief
	 * JSONEditor is a web-based tool to view, edit, format, and validate JSON.
	 * It has various modes such as a tree editor, a code editor, and a plain text
	 * editor.
	 *
	 * Supported browsers: Chrome, Firefox, Safari, Opera, Internet Explorer 8+
	 *
	 * @license
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
	 * use this file except in compliance with the License. You may obtain a copy
	 * of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
	 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
	 * License for the specific language governing permissions and limitations under
	 * the License.
	 *
	 * Copyright (c) 2011-2020 Jos de Jong, http://jsoneditoronline.org
	 *
	 * @author  Jos de Jong, <wjosdejong@gmail.com>
	 * @version 8.6.8
	 * @date    2020-05-13
	 */!function(e,t){"object"==( false?"undefined":_typeof(exports))&&"object"==( false?"undefined":_typeof(module))?module.exports=t(): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==(typeof exports==="undefined"?"undefined":_typeof(exports))?exports.JSONEditor=t():e.JSONEditor=t();}(window,function(){return n={},r.m=i=[function(e,t,i){"use strict";i.r(t),i.d(t,"parse",function(){return g;}),i.d(t,"repair",function(){return p;}),i.d(t,"escapeUnicodeChars",function(){return m;}),i.d(t,"validate",function(){return f;}),i.d(t,"extend",function(){return C;}),i.d(t,"clear",function(){return I;}),i.d(t,"getType",function(){return A;}),i.d(t,"isUrl",function(){return b;}),i.d(t,"isArray",function(){return y;}),i.d(t,"getAbsoluteLeft",function(){return w;}),i.d(t,"getAbsoluteTop",function(){return S;}),i.d(t,"addClassName",function(){return x;}),i.d(t,"removeAllClassNames",function(){return k;}),i.d(t,"removeClassName",function(){return R;}),i.d(t,"stripFormatting",function(){return E;}),i.d(t,"setEndOfContentEditable",function(){return B;}),i.d(t,"selectContentEditable",function(){return Z;}),i.d(t,"getSelection",function(){return T;}),i.d(t,"setSelection",function(){return G;}),i.d(t,"getSelectionOffset",function(){return W;}),i.d(t,"setSelectionOffset",function(){return _;}),i.d(t,"getInnerText",function(){return H;}),i.d(t,"hasParentNode",function(){return L;}),i.d(t,"getInternetExplorerVersion",function(){return $;}),i.d(t,"isFirefox",function(){return V;}),i.d(t,"addEventListener",function(){return O;}),i.d(t,"removeEventListener",function(){return F;}),i.d(t,"isChildOf",function(){return P;}),i.d(t,"parsePath",function(){return K;}),i.d(t,"stringifyPath",function(){return M;}),i.d(t,"improveSchemaError",function(){return j;}),i.d(t,"isPromise",function(){return D;}),i.d(t,"isValidValidationError",function(){return X;}),i.d(t,"insideRect",function(){return Y;}),i.d(t,"debounce",function(){return z;}),i.d(t,"textDiff",function(){return J;}),i.d(t,"getInputSelection",function(){return U;}),i.d(t,"getIndexForPosition",function(){return Q;}),i.d(t,"getPositionForPath",function(){return q;}),i.d(t,"compileJSONPointer",function(){return ee;}),i.d(t,"getColorCSS",function(){return te;}),i.d(t,"isValidColor",function(){return ie;}),i.d(t,"makeFieldTooltip",function(){return ne;}),i.d(t,"get",function(){return re;}),i.d(t,"findUniqueName",function(){return oe;}),i.d(t,"getChildPaths",function(){return se;}),i.d(t,"sort",function(){return ae;}),i.d(t,"sortObjectKeys",function(){return le;}),i.d(t,"parseString",function(){return ce;}),i.d(t,"isTimestamp",function(){return he;}),i.d(t,"formatSize",function(){return de;}),i.d(t,"limitCharacters",function(){return ue;}),i.d(t,"isObject",function(){return ge;}),i.d(t,"contains",function(){return pe;}),i.d(t,"isValidationErrorChanged",function(){return me;});i(24);var n=i(11),o=i.n(n),r=i(22),s=i.n(r),a=i(33),l=i.n(a),c=i(1);function h(e){return(h="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return typeof e==="undefined"?"undefined":_typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e==="undefined"?"undefined":_typeof(e);})(e);}var d=1e4,u=9466848e5;function g(t){try{return JSON.parse(t);}catch(e){throw f(t),e;}}function p(n){var i=[],r=0,e=0,t=!1,o=n.match(/^\s*(\/\*(.|[\r\n])*?\*\/)?\s*[\da-zA-Z_$]+\s*\(([\s\S]*)\)\s*;?\s*$/);o&&(n=o[3]);var s,a={"\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t"},l={None:"null",True:"true",False:"false"};function c(){return n.charAt(r);}function h(){return n.charAt(r+1);}function d(e){return" "===e||"\n"===e||"\r"===e||"\t"===e;}function u(){for(var e=i.length-1;0<=e;){var t=i[e];if(!d(t))return t;e--;}return"";}function g(){for(var e=r+1;e<n.length&&d(n[e]);){e++;}return n[e];}function p(){for(var e=r;e<n.length&&d(n[e]);){e++;}return n[e];}function m(){if("/"===c()&&"*"===h()){for(r+=2;r<n.length&&("*"!==c()||"/"!==h());){r++;}r+=2,"\n"===c()&&r++;}}function f(){if("/"===c()&&"/"===h())for(r+=2;r<n.length&&"\n"!==c();){r++;}}function C(){for(var e="";r<n.length&&d(c());){e+=c(),r++;}return e;}function I(e){var t="";t+='"',r++;for(var i=c();r<n.length&&i!==e;){'"'===i&&"\\"!==n.charAt(r-1)?t+='\\"':i in a?t+=a[i]:("\\"===i&&(r++,"'"!==(i=c())&&(t+="\\")),t+=i),r++,i=c();}return i===e&&(t+='"',r++),t;}function A(){for(var e="",t=c(),i=/[a-zA-Z_$\d]/;i.test(t);){e+=t,r++,t=c();}return e in l?l[e]:-1===["null","true","false"].indexOf(e)?'"'+e+'"':e;}function v(){for(var e,t=c(),i="";/\w/.test(t);){i+=t,r++,t=c();}if(0<i.length&&"("===t){if(r++,'"'===(t=c()))e=I(t),t=c();else for(e="";")"!==t&&""!==t;){e+=t,r++,t=c();}return")"===t?(r++,e):i+"("+e+t;}return"string"==typeof l[i]?l[i]:i;}for(;r<n.length;){m(),f();var b,y=c();"{"===y&&e++,"}"===y&&e--," "===(s=y)||" "<=s&&s<=" "||" "===s||" "===s||"　"===s?(i.push(" "),r++):"'"===y?i.push(I(y)):'"'===y?i.push(I('"')):"`"===y?i.push(I("´")):"‘"===y?i.push(I("’")):"“"===y?i.push(I("”")):"}"===y?(i.push(y),r++,b=C(),m(),"{"===p()&&(i.push(","),0===e&&(t=!0)),i.push(b)):","===y&&-1!==["]","}"].indexOf(g())?r++:/[a-zA-Z_$]/.test(y)&&-1!==["{",","].indexOf(u())?i.push(A()):/\w/.test(y)?i.push(v()):(i.push(y),r++);}return t&&(i.unshift("[\n"),i.push("\n]")),i.join("");}function m(e){return e.replace(/[\u007F-\uFFFF]/g,function(e){return"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4);});}function f(e){void 0!==s.a?s.a.parse(e):JSON.parse(e);}function C(e,t){for(var i in t){fe(t,i)&&(e[i]=t[i]);}return e;}function I(e){for(var t in e){fe(e,t)&&delete e[t];}return e;}function A(e){return null===e?"null":void 0===e?"undefined":e instanceof Number||"number"==typeof e?"number":e instanceof String||"string"==typeof e?"string":e instanceof Boolean||"boolean"==typeof e?"boolean":e instanceof RegExp?"regexp":y(e)?"array":"object";}var v=/^https?:\/\/\S+$/;function b(e){return("string"==typeof e||e instanceof String)&&v.test(e);}function y(e){return"[object Array]"===Object.prototype.toString.call(e);}function w(e){return e.getBoundingClientRect().left+window.pageXOffset||document.scrollLeft||0;}function S(e){return e.getBoundingClientRect().top+window.pageYOffset||document.scrollTop||0;}function x(e,t){var i=e.className.split(" ");-1===i.indexOf(t)&&(i.push(t),e.className=i.join(" "));}function k(e){e.className="";}function R(e,t){var i=e.className.split(" "),n=i.indexOf(t);-1!==n&&(i.splice(n,1),e.className=i.join(" "));}function E(e){for(var t=e.childNodes,i=0,n=t.length;i<n;i++){var r=t[i];r.style&&r.removeAttribute("style");var o=r.attributes;if(o)for(var s=o.length-1;0<=s;s--){var a=o[s];!0===a.specified&&r.removeAttribute(a.name);}E(r);}}function B(e){var t,i;document.createRange&&((t=document.createRange()).selectNodeContents(e),t.collapse(!1),(i=window.getSelection()).removeAllRanges(),i.addRange(t));}function Z(e){var t,i;e&&"DIV"===e.nodeName&&window.getSelection&&document.createRange&&((i=document.createRange()).selectNodeContents(e),(t=window.getSelection()).removeAllRanges(),t.addRange(i));}function T(){if(window.getSelection){var e=window.getSelection();if(e.getRangeAt&&e.rangeCount)return e.getRangeAt(0);}return null;}function G(e){var t;e&&window.getSelection&&((t=window.getSelection()).removeAllRanges(),t.addRange(e));}function W(){var e=T();return e&&"startOffset"in e&&"endOffset"in e&&e.startContainer&&e.startContainer===e.endContainer?{startOffset:e.startOffset,endOffset:e.endOffset,container:e.startContainer.parentNode}:null;}function _(e){var t;document.createRange&&window.getSelection&&window.getSelection()&&(t=document.createRange(),e.container.firstChild||e.container.appendChild(document.createTextNode("")),t.setStart(e.container.firstChild,e.startOffset),t.setEnd(e.container.firstChild,e.endOffset),G(t));}function H(e,t){if(void 0===t&&(t={_text:"",flush:function flush(){var e=this._text;return this._text="",e;},set:function set(e){this._text=e;}}),e.nodeValue){var i=e.nodeValue.replace(/\s*\n\s*/g,"");return""!==i?t.flush()+i:"";}if(e.hasChildNodes()){for(var n=e.childNodes,r="",o=0,s=n.length;o<s;o++){var a,l,c=n[o];"DIV"===c.nodeName||"P"===c.nodeName?((l=(a=n[o-1])?a.nodeName:void 0)&&"DIV"!==l&&"P"!==l&&"BR"!==l&&(""!==r&&(r+="\n"),t.flush()),r+=H(c,t),t.set("\n")):"BR"===c.nodeName?(r+=t.flush(),t.set("\n")):r+=H(c,t);}return r;}return"";}function L(e,t){for(var i=e?e.parentNode:void 0;i;){if(i===t)return!0;i=i.parentNode;}return!1;}function $(){var e,t;return-1===N&&(e=-1,"undefined"!=typeof navigator&&"Microsoft Internet Explorer"===navigator.appName&&(t=navigator.userAgent,null!=new RegExp("MSIE ([0-9]+[.0-9]+)").exec(t)&&(e=parseFloat(RegExp.$1))),N=e),N;}function V(){return"undefined"!=typeof navigator&&-1!==navigator.userAgent.indexOf("Firefox");}var N=-1;function O(e,t,i,n){if(e.addEventListener)return void 0===n&&(n=!1),"mousewheel"===t&&V()&&(t="DOMMouseScroll"),e.addEventListener(t,i,n),i;if(e.attachEvent){var r=function r(){return i.call(e,window.event);};return e.attachEvent("on"+t,r),r;}}function F(e,t,i,n){e.removeEventListener?(void 0===n&&(n=!1),"mousewheel"===t&&V()&&(t="DOMMouseScroll"),e.removeEventListener(t,i,n)):e.detachEvent&&e.detachEvent("on"+t,i);}function P(e,t){for(var i=e.parentNode;i;){if(i===t)return!0;i=i.parentNode;}return!1;}function K(i){var e=[],n=0;function t(){for(var e="";void 0!==i[n]&&/[\w$]/.test(i[n]);){e+=i[n],n++;}if(""===e)throw new Error("Invalid JSON path: property name expected at index "+n);return e;}function r(e){for(var t="";void 0!==i[n]&&i[n]!==e;){t+=i[n],n++;}if(i[n]!==e)throw new Error("Invalid JSON path: unexpected end, character "+e+" expected");return t;}for(;void 0!==i[n];){if("."===i[n])n++,e.push(t());else{if("["!==i[n])throw new Error('Invalid JSON path: unexpected character "'+i[n]+'" at index '+n);if("'"===i[++n]||'"'===i[n]){var o=i[n];if(n++,e.push(r(o)),i[n]!==o)throw new Error("Invalid JSON path: closing quote ' expected at index "+n);n++;}else{var s=r("]").trim();if(0===s.length)throw new Error("Invalid JSON path: array value expected at index "+n);s="*"===s?s:JSON.parse(s),e.push(s);}if("]"!==i[n])throw new Error("Invalid JSON path: closing bracket ] expected at index "+n);n++;}}return e;}function M(e){return e.map(function(e){return"number"==typeof e?"["+e+"]":"string"==typeof e&&e.match(/^[A-Za-z0-9_$]+$/)?"."+e:'["'+e+'"]';}).join("");}function j(e){var t,i;return"enum"!==e.keyword||!Array.isArray(e.schema)||(i=e.schema)&&(5<(i=i.map(function(e){return JSON.stringify(e);})).length&&(t=["("+(i.length-5)+" more...)"],(i=i.slice(0,5)).push(t)),e.message="should be equal to one of: "+i.join(", ")),"additionalProperties"===e.keyword&&(e.message="should NOT have additional property: "+e.params.additionalProperty),e;}function D(e){return e&&"function"==typeof e.then&&"function"==typeof e.catch;}function X(e){return"object"===h(e)&&Array.isArray(e.path)&&"string"==typeof e.message;}function Y(e,t,i){var n=void 0!==i?i:0;return t.left-n>=e.left&&t.right+n<=e.right&&t.top-n>=e.top&&t.bottom+n<=e.bottom;}function z(n,r,o){var s;return function(){var e=this,t=arguments,i=o&&!s;clearTimeout(s),s=setTimeout(function(){s=null,o||n.apply(e,t);},r),i&&n.apply(e,t);};}function J(e,t){for(var i=t.length,n=0,r=e.length,o=t.length;t.charAt(n)===e.charAt(n)&&n<i;){n++;}for(;t.charAt(o-1)===e.charAt(r-1)&&n<o&&0<r;){o--,r--;}return{start:n,end:o};}function U(i){var e,t,n,r,o,s=0,a=0;return"number"==typeof i.selectionStart&&"number"==typeof i.selectionEnd?(s=i.selectionStart,a=i.selectionEnd):(t=document.selection.createRange())&&t.parentElement()===i&&(r=i.value.length,e=i.value.replace(/\r\n/g,"\n"),(n=i.createTextRange()).moveToBookmark(t.getBookmark()),(o=i.createTextRange()).collapse(!1),-1<n.compareEndPoints("StartToEnd",o)?s=a=r:(s=-n.moveStart("character",-r),s+=e.slice(0,s).split("\n").length-1,-1<n.compareEndPoints("EndToEnd",o)?a=r:(a=-n.moveEnd("character",-r),a+=e.slice(0,a).split("\n").length-1))),{startIndex:s,endIndex:a,start:l(s),end:l(a)};function l(e){var t=i.value.substring(0,e);return{row:(t.match(/\n/g)||[]).length+1,column:t.length-t.lastIndexOf("\n")};}}function Q(e,t,i){var n=e.value||"";if(0<t&&0<i){var r=n.split("\n",t);t=Math.min(r.length,t),i=Math.min(r[t-1].length,i-1);var o=1===t?i:i+1;return r.slice(0,t-1).join("\n").length+o;}return-1;}function q(e,t){var n,r=[];if(!t||!t.length)return r;try{n=l.a.parse(e);}catch(e){return r;}return t.forEach(function(e){var t=ee(K(e)),i=n.pointers[t];i&&r.push({path:e,line:i.key?i.key.line:i.value?i.value.line:0,column:i.key?i.key.column:i.value?i.value.column:0});}),r;}function ee(e){return e.map(function(e){return"/"+String(e).replace(/~/g,"~0").replace(/\//g,"~1");}).join("");}function te(e){var t=document.createElement("div");return t.style.color=e,t.style.color.split(/\s+/).join("").toLowerCase()||null;}function ie(e){return!!te(e);}function ne(i,e){if(!i)return"";var n="";return i.title&&(n+=i.title),i.description&&(0<n.length&&(n+="\n"),n+=i.description),i.default&&(0<n.length&&(n+="\n\n"),n+=Object(c.c)("default",void 0,e)+"\n",n+=JSON.stringify(i.default,null,2)),Array.isArray(i.examples)&&0<i.examples.length&&(0<n.length&&(n+="\n\n"),n+=Object(c.c)("examples",void 0,e)+"\n",i.examples.forEach(function(e,t){n+=JSON.stringify(e,null,2),t!==i.examples.length-1&&(n+="\n");})),n;}function re(e,t){for(var i=e,n=0;n<t.length&&null!=i;n++){i=i[t[n]];}return i;}function oe(e,t){for(var i=e.replace(/ \(copy( \d+)?\)$/,""),n=i,r=1;-1!==t.indexOf(n);){n=i+" ("+("copy"+(1<r?" "+r:""))+")";r++;}return n;}function se(e,t){var i={};function o(t,i,n,r){(Array.isArray(t)||ge(t))&&!r||(i[n||""]=!0),ge(t)&&Object.keys(t).forEach(function(e){o(t[e],i,n+"."+e,r);});}if(Array.isArray(e))for(var n=Math.min(e.length,d),r=0;r<n;r++){o(e[r],i,"",t);}else i[""]=!0;return Object.keys(i).sort();}function ae(e,t,i){var r=t&&"."!==t?K(t):[],o="desc"===i?-1:1,n=e.slice();return n.sort(function(e,t){var i=re(e,r),n=re(t,r);return o*(n<i?1:i<n?-1:0);}),n;}function le(t,e){var i="desc"===e?-1:1,n=Object.keys(t).sort(function(e,t){return i*o()(e,t);}),r={};return n.forEach(function(e){r[e]=t[e];}),r;}function ce(e){if(""===e)return"";var t=e.toLowerCase();if("null"===t)return null;if("true"===t)return!0;if("false"===t)return!1;var i=Number(e),n=parseFloat(e);return isNaN(i)||isNaN(n)?e:i;}function he(e,t){return"number"==typeof t&&u<t&&isFinite(t)&&Math.floor(t)===t&&!isNaN(new Date(t).valueOf());}function de(e){if(e<900)return e.toFixed()+" B";var t=e/1e3;if(t<900)return t.toFixed(1)+" KB";var i=t/1e3;if(i<900)return i.toFixed(1)+" MB";var n=i/1e3;return n<900?n.toFixed(1)+" GB":(n/1e3).toFixed(1)+" TB";}function ue(e,t){return e.length<=t?e:e.slice(0,t)+"...";}function ge(e){return"object"===h(e)&&null!==e&&!Array.isArray(e);}function pe(e,t){return-1!==e.indexOf(t);}function me(i,e){if(!e&&!i)return!1;if(e&&!i||!e&&i)return!0;if(e.length!==i.length)return!0;for(var t=function t(_t){if(!("error"===i[_t].type?e.find(function(e){return e.line===i[_t].line;}):e.find(function(e){return e.dataPath===i[_t].dataPath&&e.schemaPath===i[_t].schemaPath;})))return{v:!0};},n=0;n<i.length;++n){var r=t(n);if("object"===h(r))return r.v;}return!1;}function fe(e,t){return Object.prototype.hasOwnProperty.call(e,t);}},function(e,t,i){"use strict";i.d(t,"a",function(){return l;}),i.d(t,"b",function(){return c;}),i.d(t,"c",function(){return h;});i(24);var n=["en","pt-BR","zh-CN","tr","ja","fr-FR"],o={en:{array:"Array",auto:"Auto",appendText:"Append",appendTitle:"Append a new field with type 'auto' after this field (Ctrl+Shift+Ins)",appendSubmenuTitle:"Select the type of the field to be appended",appendTitleAuto:"Append a new field with type 'auto' (Ctrl+Shift+Ins)",ascending:"Ascending",ascendingTitle:"Sort the childs of this ${type} in ascending order",actionsMenu:"Click to open the actions menu (Ctrl+M)",cannotParseFieldError:"Cannot parse field into JSON",cannotParseValueError:"Cannot parse value into JSON",collapseAll:"Collapse all fields",compactTitle:"Compact JSON data, remove all whitespaces (Ctrl+Shift+\\)",descending:"Descending",descendingTitle:"Sort the childs of this ${type} in descending order",drag:"Drag to move this field (Alt+Shift+Arrows)",duplicateKey:"duplicate key",duplicateText:"Duplicate",duplicateTitle:"Duplicate selected fields (Ctrl+D)",duplicateField:"Duplicate this field (Ctrl+D)",duplicateFieldError:"Duplicate field name",empty:"empty",expandAll:"Expand all fields",expandTitle:"Click to expand/collapse this field (Ctrl+E). \nCtrl+Click to expand/collapse including all childs.",formatTitle:"Format JSON data, with proper indentation and line feeds (Ctrl+\\)",insert:"Insert",insertTitle:"Insert a new field with type 'auto' before this field (Ctrl+Ins)",insertSub:"Select the type of the field to be inserted",object:"Object",ok:"Ok",redo:"Redo (Ctrl+Shift+Z)",removeText:"Remove",removeTitle:"Remove selected fields (Ctrl+Del)",removeField:"Remove this field (Ctrl+Del)",repairTitle:"Repair JSON: fix quotes and escape characters, remove comments and JSONP notation, turn JavaScript objects into JSON.",searchTitle:"Search fields and values",searchNextResultTitle:"Next result (Enter)",searchPreviousResultTitle:"Previous result (Shift + Enter)",selectNode:"Select a node...",showAll:"show all",showMore:"show more",showMoreStatus:"displaying ${visibleChilds} of ${totalChilds} items.",sort:"Sort",sortTitle:"Sort the childs of this ${type}",sortTitleShort:"Sort contents",sortFieldLabel:"Field:",sortDirectionLabel:"Direction:",sortFieldTitle:"Select the nested field by which to sort the array or object",sortAscending:"Ascending",sortAscendingTitle:"Sort the selected field in ascending order",sortDescending:"Descending",sortDescendingTitle:"Sort the selected field in descending order",string:"String",transform:"Transform",transformTitle:"Filter, sort, or transform the childs of this ${type}",transformTitleShort:"Filter, sort, or transform contents",extract:"Extract",extractTitle:"Extract this ${type}",transformQueryTitle:"Enter a JMESPath query",transformWizardLabel:"Wizard",transformWizardFilter:"Filter",transformWizardSortBy:"Sort by",transformWizardSelectFields:"Select fields",transformQueryLabel:"Query",transformPreviewLabel:"Preview",type:"Type",typeTitle:"Change the type of this field",openUrl:"Ctrl+Click or Ctrl+Enter to open url in new window",undo:"Undo last action (Ctrl+Z)",validationCannotMove:"Cannot move a field into a child of itself",autoType:'Field type "auto". The field type is automatically determined from the value and can be a string, number, boolean, or null.',objectType:'Field type "object". An object contains an unordered set of key/value pairs.',arrayType:'Field type "array". An array contains an ordered collection of values.',stringType:'Field type "string". Field type is not determined from the value, but always returned as string.',modeEditorTitle:"Switch Editor Mode",modeCodeText:"Code",modeCodeTitle:"Switch to code highlighter",modeFormText:"Form",modeFormTitle:"Switch to form editor",modeTextText:"Text",modeTextTitle:"Switch to plain text editor",modeTreeText:"Tree",modeTreeTitle:"Switch to tree editor",modeViewText:"View",modeViewTitle:"Switch to tree view",modePreviewText:"Preview",modePreviewTitle:"Switch to preview mode",examples:"Examples",default:"Default"},"zh-CN":{array:"数组",auto:"自动",appendText:"追加",appendTitle:"在此字段后追加一个类型为“auto”的新字段 (Ctrl+Shift+Ins)",appendSubmenuTitle:"选择要追加的字段类型",appendTitleAuto:"追加类型为“auto”的新字段 (Ctrl+Shift+Ins)",ascending:"升序",ascendingTitle:"升序排列${type}的子节点",actionsMenu:"点击打开动作菜单(Ctrl+M)",cannotParseFieldError:"无法将字段解析为JSON",cannotParseValueError:"无法将值解析为JSON",collapseAll:"缩进所有字段",compactTitle:"压缩JSON数据，删除所有空格 (Ctrl+Shift+\\)",descending:"降序",descendingTitle:"降序排列${type}的子节点",drag:"拖拽移动该节点(Alt+Shift+Arrows)",duplicateKey:"重复键",duplicateText:"复制",duplicateTitle:"复制选中字段(Ctrl+D)",duplicateField:"复制该字段(Ctrl+D)",duplicateFieldError:"重复的字段名称",empty:"清空",expandAll:"展开所有字段",expandTitle:"点击 展开/收缩 该字段(Ctrl+E). \nCtrl+Click 展开/收缩 包含所有子节点.",formatTitle:"使用适当的缩进和换行符格式化JSON数据 (Ctrl+\\)",insert:"插入",insertTitle:"在此字段前插入类型为“auto”的新字段 (Ctrl+Ins)",insertSub:"选择要插入的字段类型",object:"对象",ok:"Ok",redo:"重做 (Ctrl+Shift+Z)",removeText:"移除",removeTitle:"移除选中字段 (Ctrl+Del)",removeField:"移除该字段 (Ctrl+Del)",repairTitle:"修复JSON：修复引号和转义符，删除注释和JSONP表示法，将JavaScript对象转换为JSON。",selectNode:"选择一个节点...",showAll:"展示全部",showMore:"展示更多",showMoreStatus:"显示${totalChilds}的${visibleChilds}项目.",sort:"排序",sortTitle:"排序${type}的子节点",sortTitleShort:"内容排序",sortFieldLabel:"字段：",sortDirectionLabel:"方向：",sortFieldTitle:"选择用于对数组或对象排序的嵌套字段",sortAscending:"升序排序",sortAscendingTitle:"按照该字段升序排序",sortDescending:"降序排序",sortDescendingTitle:"按照该字段降序排序",string:"字符串",transform:"变换",transformTitle:"筛选，排序，或者转换${type}的子节点",transformTitleShort:"筛选，排序，或者转换内容",extract:"提取",extractTitle:"提取这个 ${type}",transformQueryTitle:"输入JMESPath查询",transformWizardLabel:"向导",transformWizardFilter:"筛选",transformWizardSortBy:"排序",transformWizardSelectFields:"选择字段",transformQueryLabel:"查询",transformPreviewLabel:"预览",type:"类型",typeTitle:"更改字段类型",openUrl:"Ctrl+Click 或者 Ctrl+Enter 在新窗口打开链接",undo:"撤销上次动作 (Ctrl+Z)",validationCannotMove:"无法将字段移入其子节点",autoType:'字段类型 "auto". 字段类型由值自动确定 可以为 string，number，boolean，或者 null.',objectType:'字段类型 "object". 对象包含一组无序的键/值对.',arrayType:'字段类型 "array". 数组包含值的有序集合.',stringType:'字段类型 "string". 字段类型由值自动确定，但始终作为字符串返回.',modeCodeText:"代码",modeCodeTitle:"切换至代码高亮",modeFormText:"表单",modeFormTitle:"切换至表单编辑",modeTextText:"文本",modeTextTitle:"切换至文本编辑",modeTreeText:"树",modeTreeTitle:"切换至树编辑",modeViewText:"视图",modeViewTitle:"切换至树视图",modePreviewText:"预览",modePreviewTitle:"切换至预览模式",examples:"例子",default:"缺省"},"pt-BR":{array:"Lista",auto:"Automatico",appendText:"Adicionar",appendTitle:"Adicionar novo campo com tipo 'auto' depois deste campo (Ctrl+Shift+Ins)",appendSubmenuTitle:"Selecione o tipo do campo a ser adicionado",appendTitleAuto:"Adicionar novo campo com tipo 'auto' (Ctrl+Shift+Ins)",ascending:"Ascendente",ascendingTitle:"Organizar filhor do tipo ${type} em crescente",actionsMenu:"Clique para abrir o menu de ações (Ctrl+M)",cannotParseFieldError:"Não é possível analisar o campo no JSON",cannotParseValueError:"Não é possível analisar o valor em JSON",collapseAll:"Fechar todos campos",compactTitle:"Dados JSON compactos, remova todos os espaços em branco (Ctrl+Shift+\\)",descending:"Descendente",descendingTitle:"Organizar o filhos do tipo ${type} em decrescente",duplicateKey:"chave duplicada",drag:"Arraste para mover este campo (Alt+Shift+Arrows)",duplicateText:"Duplicar",duplicateTitle:"Duplicar campos selecionados (Ctrl+D)",duplicateField:"Duplicar este campo (Ctrl+D)",duplicateFieldError:"Nome do campo duplicado",empty:"vazio",expandAll:"Expandir todos campos",expandTitle:"Clique para expandir/encolher este campo (Ctrl+E). \nCtrl+Click para expandir/encolher incluindo todos os filhos.",formatTitle:"Formate dados JSON, com recuo e feeds de linha adequados (Ctrl+\\)",insert:"Inserir",insertTitle:"Inserir um novo campo do tipo 'auto' antes deste campo (Ctrl+Ins)",insertSub:"Selecionar o tipo de campo a ser inserido",object:"Objeto",ok:"Ok",redo:"Refazer (Ctrl+Shift+Z)",removeText:"Remover",removeTitle:"Remover campos selecionados (Ctrl+Del)",removeField:"Remover este campo (Ctrl+Del)",repairTitle:"Repare JSON: corrija aspas e caracteres de escape, remova comentários e notação JSONP, transforme objetos JavaScript em JSON.",selectNode:"Selecione um nódulo...",showAll:"mostrar todos",showMore:"mostrar mais",showMoreStatus:"exibindo ${visibleChilds} de ${totalChilds} itens.",sort:"Organizar",sortTitle:"Organizar os filhos deste ${type}",sortTitleShort:"Organizar os filhos",sortFieldLabel:"Campo:",sortDirectionLabel:"Direção:",sortFieldTitle:"Selecione um campo filho pelo qual ordenar o array ou objeto",sortAscending:"Ascendente",sortAscendingTitle:"Ordenar o campo selecionado por ordem ascendente",sortDescending:"Descendente",sortDescendingTitle:"Ordenar o campo selecionado por ordem descendente",string:"Texto",transform:"Transformar",transformTitle:"Filtrar, ordenar ou transformar os filhos deste ${type}",transformTitleShort:"Filtrar, ordenar ou transformar conteúdos",transformQueryTitle:"Insira uma expressão JMESPath",transformWizardLabel:"Assistente",transformWizardFilter:"Filtro",transformWizardSortBy:"Ordenar por",transformWizardSelectFields:"Selecionar campos",transformQueryLabel:"Expressão",transformPreviewLabel:"Visualizar",type:"Tipo",typeTitle:"Mudar o tipo deste campo",openUrl:"Ctrl+Click ou Ctrl+Enter para abrir link em nova janela",undo:"Desfazer último ação (Ctrl+Z)",validationCannotMove:"Não pode mover um campo como filho dele mesmo",autoType:'Campo do tipo "auto". O tipo do campo é determinao automaticamente a partir do seu valor e pode ser texto, número, verdade/falso ou nulo.',objectType:'Campo do tipo "objeto". Um objeto contém uma lista de pares com chave e valor.',arrayType:'Campo do tipo "lista". Uma lista contem uma coleção de valores ordenados.',stringType:'Campo do tipo "string". Campo do tipo nao é determinado através do seu valor, mas sempre retornara um texto.',examples:"Exemplos",default:"Revelia"},tr:{array:"Dizin",auto:"Otomatik",appendText:"Ekle",appendTitle:"Bu alanın altına 'otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",appendSubmenuTitle:"Eklenecek alanın tipini seç",appendTitleAuto:"'Otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",ascending:"Artan",ascendingTitle:"${type}'ın alt tiplerini artan düzende sırala",actionsMenu:"Aksiyon menüsünü açmak için tıklayın (Ctrl+M)",collapseAll:"Tüm alanları kapat",descending:"Azalan",descendingTitle:"${type}'ın alt tiplerini azalan düzende sırala",drag:"Bu alanı taşımak için sürükleyin (Alt+Shift+Arrows)",duplicateKey:"Var olan anahtar",duplicateText:"Aşağıya kopyala",duplicateTitle:"Seçili alanlardan bir daha oluştur (Ctrl+D)",duplicateField:"Bu alandan bir daha oluştur (Ctrl+D)",duplicateFieldError:"Duplicate field name",cannotParseFieldError:"Alan JSON'a ayrıştırılamıyor",cannotParseValueError:"JSON'a değer ayrıştırılamıyor",empty:"boş",expandAll:"Tüm alanları aç",expandTitle:"Bu alanı açmak/kapatmak için tıkla (Ctrl+E). \nAlt alanlarda dahil tüm alanları açmak için Ctrl+Click ",insert:"Ekle",insertTitle:"Bu alanın üstüne 'otomatik' tipinde yeni bir alan ekle (Ctrl+Ins)",insertSub:"Araya eklenecek alanın tipini seç",object:"Nesne",ok:"Tamam",redo:"Yeniden yap (Ctrl+Shift+Z)",removeText:"Kaldır",removeTitle:"Seçilen alanları kaldır (Ctrl+Del)",removeField:"Bu alanı kaldır (Ctrl+Del)",selectNode:"Bir nesne seç...",showAll:"tümünü göster",showMore:"daha fazla göster",showMoreStatus:"${totalChilds} alanın ${visibleChilds} alt alanları gösteriliyor",sort:"Sırala",sortTitle:"${type}'ın alt alanlarını sırala",sortTitleShort:"İçerikleri sırala",sortFieldLabel:"Alan:",sortDirectionLabel:"Yön:",sortFieldTitle:"Diziyi veya nesneyi sıralamak için iç içe geçmiş alanı seçin",sortAscending:"Artan",sortAscendingTitle:"Seçili alanı artan düzende sırala",sortDescending:"Azalan",sortDescendingTitle:"Seçili alanı azalan düzende sırala",string:"Karakter Dizisi",transform:"Dönüştür",transformTitle:"${type}'ın alt alanlarını filtrele, sırala veya dönüştür",transformTitleShort:"İçerikleri filterele, sırala veya dönüştür",transformQueryTitle:"JMESPath sorgusu gir",transformWizardLabel:"Sihirbaz",transformWizardFilter:"Filtre",transformWizardSortBy:"Sırala",transformWizardSelectFields:"Alanları seç",transformQueryLabel:"Sorgu",transformPreviewLabel:"Önizleme",type:"Tip",typeTitle:"Bu alanın tipini değiştir",openUrl:"URL'i yeni bir pencerede açmak için Ctrl+Click veya Ctrl+Enter",undo:"Son değişikliği geri al (Ctrl+Z)",validationCannotMove:"Alt alan olarak taşınamıyor",autoType:'Alan tipi "otomatik". Alan türü otomatik olarak değerden belirlenirve bir dize, sayı, boolean veya null olabilir.',objectType:'Alan tipi "nesne". Bir nesne, sıralanmamış bir anahtar / değer çifti kümesi içerir.',arrayType:'Alan tipi "dizi". Bir dizi, düzenli değerler koleksiyonu içerir.',stringType:'Alan tipi "karakter dizisi". Alan türü değerden belirlenmez,ancak her zaman karakter dizisi olarak döndürülür.',modeCodeText:"Kod",modeCodeTitle:"Kod vurgulayıcıya geç",modeFormText:"Form",modeFormTitle:"Form düzenleyiciye geç",modeTextText:"Metin",modeTextTitle:"Düz metin düzenleyiciye geç",modeTreeText:"Ağaç",modeTreeTitle:"Ağaç düzenleyiciye geç",modeViewText:"Görünüm",modeViewTitle:"Ağaç görünümüne geç",examples:"Örnekler",default:"Varsayılan"},ja:{array:"配列",auto:"オート",appendText:"追加",appendTitle:'次のフィールドに"オート"のフィールドを追加 (Ctrl+Shift+Ins)',appendSubmenuTitle:"追加するフィールドの型を選択してください",appendTitleAuto:'"オート"のフィールドを追加 (Ctrl+Shift+Ins)',ascending:"昇順",ascendingTitle:"${type}の子要素を昇順に並べ替え",actionsMenu:"クリックしてアクションメニューを開く (Ctrl+M)",collapseAll:"すべてを折りたたむ",descending:"降順",descendingTitle:"${type}の子要素を降順に並べ替え",drag:"ドラッグして選択中のフィールドを移動 (Alt+Shift+Arrows)",duplicateKey:"複製キー",duplicateText:"複製",duplicateTitle:"選択中のフィールドを複製 (Ctrl+D)",duplicateField:"選択中のフィールドを複製 (Ctrl+D)",duplicateFieldError:"フィールド名が重複しています",cannotParseFieldError:"JSONのフィールドを解析できません",cannotParseValueError:"JSONの値を解析できません",empty:"空",expandAll:"すべてを展開",expandTitle:"クリックしてフィールドを展開/折りたたむ (Ctrl+E). \nCtrl+Click ですべての子要素を展開/折りたたむ",insert:"挿入",insertTitle:"選択中のフィールドの前に新しいフィールドを挿入 (Ctrl+Ins)",insertSub:"挿入するフィールドの型を選択",object:"オブジェクト",ok:"実行",redo:"やり直す (Ctrl+Shift+Z)",removeText:"削除",removeTitle:"選択中のフィールドを削除 (Ctrl+Del)",removeField:"選択中のフィールドを削除 (Ctrl+Del)",selectNode:"ノードを選択...",showAll:"すべてを表示",showMore:"もっと見る",showMoreStatus:"${totalChilds}個のアイテムのうち ${visibleChilds}個を表示しています。",sort:"並べ替え",sortTitle:"${type}の子要素を並べ替え",sortTitleShort:"並べ替え",sortFieldLabel:"フィールド:",sortDirectionLabel:"順序:",sortFieldTitle:"配列またはオブジェクトを並び替えるためのフィールドを選択",sortAscending:"昇順",sortAscendingTitle:"選択中のフィールドを昇順に並び替え",sortDescending:"降順",sortDescendingTitle:"選択中のフィールドを降順に並び替え",string:"文字列",transform:"変換",transformTitle:"${type}の子要素をフィルター・並び替え・変換する",transformTitleShort:"内容をフィルター・並び替え・変換する",extract:"抽出",extractTitle:"${type}を抽出",transformQueryTitle:"JMESPathクエリを入力",transformWizardLabel:"ウィザード",transformWizardFilter:"フィルター",transformWizardSortBy:"並び替え",transformWizardSelectFields:"フィールドを選択",transformQueryLabel:"クエリ",transformPreviewLabel:"プレビュー",type:"型",typeTitle:"選択中のフィールドの型を変更",openUrl:"Ctrl+Click または Ctrl+Enter で 新規ウィンドウでURLを開く",undo:"元に戻す (Ctrl+Z)",validationCannotMove:"子要素に移動できません ",autoType:"オート： フィールドの型は値から自動的に決定されます。 (文字列・数値・ブール・null)",objectType:"オブジェクト： オブジェクトは順序が決まっていないキーと値のペア組み合わせです。",arrayType:"配列： 配列は順序が決まっている値の集合体です。",stringType:"文字列： フィールド型は値から決定されませんが、常に文字列として返されます。",modeCodeText:"コードモード",modeCodeTitle:"ハイライトモードに切り替え",modeFormText:"フォームモード",modeFormTitle:"フォームモードに切り替え",modeTextText:"テキストモード",modeTextTitle:"テキストモードに切り替え",modeTreeText:"ツリーモード",modeTreeTitle:"ツリーモードに切り替え",modeViewText:"ビューモード",modeViewTitle:"ビューモードに切り替え",modePreviewText:"プレビュー",modePreviewTitle:"プレビューに切り替え",examples:"例",default:"デフォルト"},"fr-FR":{array:"Liste",auto:"Auto",appendText:"Ajouter",appendTitle:"Ajouter un champ de type 'auto' après ce champ (Ctrl+Shift+Ins)",appendSubmenuTitle:"Sélectionner le type du champ à ajouter",appendTitleAuto:"Ajouter un champ de type 'auto' (Ctrl+Shift+Ins)",ascending:"Ascendant",ascendingTitle:"Trier les enfants de ce ${type} par ordre ascendant",actionsMenu:"Ouvrir le menu des actions (Ctrl+M)",collapseAll:"Regrouper",descending:"Descendant",descendingTitle:"Trier les enfants de ce ${type} par ordre descendant",drag:"Déplacer (Alt+Shift+Arrows)",duplicateKey:"Dupliquer la clé",duplicateText:"Dupliquer",duplicateTitle:"Dupliquer les champs sélectionnés (Ctrl+D)",duplicateField:"Dupliquer ce champ (Ctrl+D)",duplicateFieldError:"Dupliquer le nom de champ",cannotParseFieldError:"Champ impossible à parser en JSON",cannotParseValueError:"Valeur impossible à parser en JSON",empty:"vide",expandAll:"Étendre",expandTitle:"Étendre/regrouper ce champ (Ctrl+E). \nCtrl+Click pour étendre/regrouper avec tous les champs.",insert:"Insérer",insertTitle:"Insérer un champ de type 'auto' avant ce champ (Ctrl+Ins)",insertSub:"Sélectionner le type de champ à insérer",object:"Objet",ok:"Ok",redo:"Rejouer (Ctrl+Shift+Z)",removeText:"Supprimer",removeTitle:"Supprimer les champs sélectionnés (Ctrl+Del)",removeField:"Supprimer ce champ (Ctrl+Del)",searchTitle:"Rechercher champs et valeurs",searchNextResultTitle:"Résultat suivant (Enter)",searchPreviousResultTitle:"Résultat précédent (Shift + Enter)",selectNode:"Sélectionner un nœud...",showAll:"voir tout",showMore:"voir plus",showMoreStatus:"${visibleChilds} éléments affichés de ${totalChilds}.",sort:"Trier",sortTitle:"Trier les champs de ce ${type}",sortTitleShort:"Trier",sortFieldLabel:"Champ:",sortDirectionLabel:"Direction:",sortFieldTitle:"Sélectionner les champs permettant de trier les listes et objet",sortAscending:"Ascendant",sortAscendingTitle:"Trier les champs sélectionnés par ordre ascendant",sortDescending:"Descendant",sortDescendingTitle:"Trier les champs sélectionnés par ordre descendant",string:"Chaîne",transform:"Transformer",transformTitle:"Filtrer, trier, or transformer les enfants de ce ${type}",transformTitleShort:"Filtrer, trier ou transformer le contenu",extract:"Extraire",extractTitle:"Extraire ce ${type}",transformQueryTitle:"Saisir une requête JMESPath",transformWizardLabel:"Assistant",transformWizardFilter:"Filtrer",transformWizardSortBy:"Trier par",transformWizardSelectFields:"Sélectionner les champs",transformQueryLabel:"Requête",transformPreviewLabel:"Prévisualisation",type:"Type",typeTitle:"Changer le type de ce champ",openUrl:"Ctrl+Click ou Ctrl+Enter pour ouvrir l'url dans une autre fenêtre",undo:"Annuler la dernière action (Ctrl+Z)",validationCannotMove:"Cannot move a field into a child of itself",autoType:'Champe de type "auto". Ce type de champ est automatiquement déterminé en fonction de la valeur et peut être de type "chaîne", "nombre", "booléen" ou null.',objectType:'Champ de type "objet". Un objet contient un ensemble non ordonné de paires clé/valeur.',arrayType:'Champ de type "liste". Une liste contient une collection ordonnée de valeurs.',stringType:'Champ de type "chaîne". Ce type de champ n\'est pas déterminé en fonction de la valeur, mais retourne systématiquement une chaîne de caractères.',modeEditorTitle:"Changer mode d'édition",modeCodeText:"Code",modeCodeTitle:"Activer surlignage code",modeFormText:"Formulaire",modeFormTitle:"Activer formulaire",modeTextText:"Texte",modeTextTitle:"Activer éditeur texte",modeTreeText:"Arbre",modeTreeTitle:"Activer éditeur arbre",modeViewText:"Lecture seule",modeViewTitle:"Activer vue arbre",modePreviewText:"Prévisualisation",modePreviewTitle:"Activer mode prévisualiser",examples:"Exemples",default:"Défaut"}},s="en",r="undefined"!=typeof navigator?navigator.language||navigator.userLanguage:void 0,a=n.find(function(e){return e===r;})||s;function l(t){var e;t&&((e=n.find(function(e){return e===t;}))?a=e:console.error("Language not found"));}function c(e){if(e){var t=function t(_t2){n.find(function(e){return e===_t2;})||n.push(_t2),o[_t2]=Object.assign({},o[s],o[_t2],e[_t2]);};for(var i in e){t(i);}}}function h(e,t,i){var n=o[i=i||a][e]||o[s][e]||e;if(t)for(var r in t){n=n.replace("${"+r+"}",t[r]);}return n;}},function(e,t,i){"use strict";i.d(t,"a",function(){return n;}),i.d(t,"d",function(){return r;}),i.d(t,"b",function(){return o;}),i.d(t,"c",function(){return s;});var n=document.body,r=10485760,o=2e4,s=2147483648;},function(e,t,i){"use strict";i.d(t,"a",function(){return r;});var u=i(12),g=i(0),C=i(1);function n(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var r=function(){function d(i,e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,d),this.dom={};var f=this,t=this.dom;this.anchor=void 0,this.items=i,this.eventListeners={},this.selection=void 0,this.onClose=e?e.close:void 0;var n=document.createElement("div");n.className="jsoneditor-contextmenu-root",t.root=n;var r=document.createElement("div");r.className="jsoneditor-contextmenu",t.menu=r,n.appendChild(r);var o=document.createElement("ul");o.className="jsoneditor-menu",r.appendChild(o),t.list=o,t.items=[];var s=document.createElement("button");s.type="button",t.focusButton=s;var a=document.createElement("li");a.style.overflow="hidden",a.style.height="0",a.appendChild(s),o.appendChild(a),function g(p,m,e){e.forEach(function(t){var e,i,n,r,o,s,a,l,c,h,d,u;"separator"===t.type?((e=document.createElement("div")).className="jsoneditor-separator",(i=document.createElement("li")).appendChild(e),p.appendChild(i)):(n={},r=document.createElement("li"),p.appendChild(r),(o=document.createElement("button")).type="button",o.className=t.className,n.button=o,t.title&&(o.title=t.title),t.click&&(o.onclick=function(e){e.preventDefault(),f.hide(),t.click();}),r.appendChild(o),t.submenu?((s=document.createElement("div")).className="jsoneditor-icon",o.appendChild(s),(a=document.createElement("div")).className="jsoneditor-text"+(t.click?"":" jsoneditor-right-margin"),a.appendChild(document.createTextNode(t.text)),o.appendChild(a),(l=t.click?(o.className+=" jsoneditor-default",(c=document.createElement("button")).type="button",(n.buttonExpand=c).className="jsoneditor-expand",c.innerHTML='<div class="jsoneditor-expand"></div>',r.appendChild(c),t.submenuTitle&&(c.title=t.submenuTitle),c):((h=document.createElement("div")).className="jsoneditor-expand",o.appendChild(h),o)).onclick=function(e){e.preventDefault(),f._onExpandItem(n),l.focus();},d=[],n.subItems=d,u=document.createElement("ul"),(n.ul=u).className="jsoneditor-menu",u.style.height="0",r.appendChild(u),g(u,d,t.submenu)):o.innerHTML='<div class="jsoneditor-icon"></div><div class="jsoneditor-text">'+Object(C.c)(t.text)+"</div>",m.push(n));});}(o,this.dom.items,i),this.maxHeight=0,i.forEach(function(e){var t=24*(i.length+(e.submenu?e.submenu.length:0));f.maxHeight=Math.max(f.maxHeight,t);});}var e,t,i;return e=d,(t=[{key:"_getVisibleButtons",value:function value(){var t=[],i=this;return this.dom.items.forEach(function(e){t.push(e.button),e.buttonExpand&&t.push(e.buttonExpand),e.subItems&&e===i.expandedItem&&e.subItems.forEach(function(e){t.push(e.button),e.buttonExpand&&t.push(e.buttonExpand);});}),t;}},{key:"show",value:function value(e,t,i){this.hide();var n=!0,r=e.parentNode,o=e.getBoundingClientRect(),s=r.getBoundingClientRect(),a=t.getBoundingClientRect(),l=this;this.dom.absoluteAnchor=Object(u.a)(e,t,function(){l.hide();}),o.bottom+this.maxHeight<a.bottom||o.top-this.maxHeight>a.top&&(n=!1);var c,h=i?0:o.top-s.top;n?(c=e.offsetHeight,this.dom.menu.style.left="0",this.dom.menu.style.top=h+c+"px",this.dom.menu.style.bottom=""):(this.dom.menu.style.left="0",this.dom.menu.style.top="",this.dom.menu.style.bottom="0px"),this.dom.absoluteAnchor.appendChild(this.dom.root),this.selection=Object(g.getSelection)(),this.anchor=e,setTimeout(function(){l.dom.focusButton.focus();},0),d.visibleMenu&&d.visibleMenu.hide(),d.visibleMenu=this;}},{key:"hide",value:function value(){this.dom.absoluteAnchor&&(this.dom.absoluteAnchor.destroy(),delete this.dom.absoluteAnchor),this.dom.root.parentNode&&(this.dom.root.parentNode.removeChild(this.dom.root),this.onClose&&this.onClose()),d.visibleMenu===this&&(d.visibleMenu=void 0);}},{key:"_onExpandItem",value:function value(i){var n,r=this,e=i===this.expandedItem,t=this.expandedItem;t&&(t.ul.style.height="0",t.ul.style.padding="",setTimeout(function(){r.expandedItem!==t&&(t.ul.style.display="",Object(g.removeClassName)(t.ul.parentNode,"jsoneditor-selected"));},300),this.expandedItem=void 0),e||((n=i.ul).style.display="block",n.clientHeight,setTimeout(function(){if(r.expandedItem===i){for(var e=0,t=0;t<n.childNodes.length;t++){e+=n.childNodes[t].clientHeight;}n.style.height=e+"px",n.style.padding="5px 10px";}},0),Object(g.addClassName)(n.parentNode,"jsoneditor-selected"),this.expandedItem=i);}},{key:"_onKeyDown",value:function value(e){var t,i,n,r,o=e.target,s=e.which,a=!1;27===s?(this.selection&&Object(g.setSelection)(this.selection),this.anchor&&this.anchor.focus(),this.hide(),a=!0):9===s?e.shiftKey?0===(i=(t=this._getVisibleButtons()).indexOf(o))&&(t[t.length-1].focus(),a=!0):(i=(t=this._getVisibleButtons()).indexOf(o))===t.length-1&&(t[0].focus(),a=!0):37===s?("jsoneditor-expand"===o.className&&(i=(t=this._getVisibleButtons()).indexOf(o),(n=t[i-1])&&n.focus()),a=!0):38===s?(i=(t=this._getVisibleButtons()).indexOf(o),(n=t[i-1])&&"jsoneditor-expand"===n.className&&(n=t[i-2]),(n=n||t[t.length-1])&&n.focus(),a=!0):39===s?(i=(t=this._getVisibleButtons()).indexOf(o),(r=t[i+1])&&"jsoneditor-expand"===r.className&&r.focus(),a=!0):40===s&&(i=(t=this._getVisibleButtons()).indexOf(o),(r=t[i+1])&&"jsoneditor-expand"===r.className&&(r=t[i+2]),(r=r||t[0])&&(r.focus(),a=!0),a=!0),a&&(e.stopPropagation(),e.preventDefault());}}])&&n(e.prototype,t),i&&n(e,i),d;}();r.visibleMenu=void 0;},function(e,t,i){"use strict";i.d(t,"a",function(){return o;}),i.d(t,"b",function(){return s;});var n=i(34),r=i.n(n),l=i(0);function o(e,t){var i,n,r=t.sort,o=t.filter,s=t.projection,a="";return o?(i="@"!==o.field?["0"].concat(Object(l.parsePath)("."+o.field)):["0"],n="string"==typeof Object(l.get)(e,i)?o.value:Object(l.parseString)(o.value),a+="[? "+o.field+" "+o.relation+" `"+JSON.stringify(n)+"`]"):a+=Array.isArray(e)?"[*]":"@",r&&("desc"===r.direction?a+=" | reverse(sort_by(@, &"+r.field+"))":a+=" | sort_by(@, &"+r.field+")"),s&&("]"!==a[a.length-1]&&(a+=" | [*]"),1===s.fields.length?a+="."+s.fields[0]:1<s.fields.length&&(a+=".{"+s.fields.map(function(e){var t=e.split(".");return t[t.length-1]+": "+e;}).join(", ")+"}")),a;}function s(e,t){return r.a.search(e,t);}},function(e,t,i){"use strict";i.r(t),i.d(t,"showSortModal",function(){return s;});var n=i(14),r=i.n(n),o=i(1),h=i(0);function s(e,t,s,i){var a=Array.isArray(t)?Object(h.getChildPaths)(t):[""],l=i&&i.path&&Object(h.contains)(a,i.path)?i.path:a[0],c=i&&i.direction||"asc",n='<div class="pico-modal-contents"><div class="pico-modal-header">'+Object(o.c)("sort")+"</div><form><table><tbody><tr>  <td>"+Object(o.c)("sortFieldLabel")+' </td>  <td class="jsoneditor-modal-input">  <div class="jsoneditor-select-wrapper">    <select id="field" title="'+Object(o.c)("sortFieldTitle")+'">    </select>  </div>  </td></tr><tr>  <td>'+Object(o.c)("sortDirectionLabel")+' </td>  <td class="jsoneditor-modal-input">  <div id="direction" class="jsoneditor-button-group"><input type="button" value="'+Object(o.c)("sortAscending")+'" title="'+Object(o.c)("sortAscendingTitle")+'" data-value="asc" class="jsoneditor-button-first jsoneditor-button-asc"/><input type="button" value="'+Object(o.c)("sortDescending")+'" title="'+Object(o.c)("sortDescendingTitle")+'" data-value="desc" class="jsoneditor-button-last jsoneditor-button-desc"/>  </div>  </td></tr><tr><td colspan="2" class="jsoneditor-modal-input jsoneditor-modal-actions">  <input type="submit" id="ok" value="'+Object(o.c)("ok")+'" /></td></tr></tbody></table></form></div>';r()({parent:e,content:n,overlayClass:"jsoneditor-modal-overlay",overlayStyles:{backgroundColor:"rgb(1,1,1)",opacity:.3},modalClass:"jsoneditor-modal jsoneditor-modal-sort"}).afterCreate(function(t){var e=t.modalElem().querySelector("form"),i=t.modalElem().querySelector("#ok"),n=t.modalElem().querySelector("#field"),r=t.modalElem().querySelector("#direction");function o(e){r.value=e,r.className="jsoneditor-button-group jsoneditor-button-group-value-"+r.value;}a.forEach(function(e){var t,i=document.createElement("option");i.text=""===(t=e)?"@":"."===t[0]?t.slice(1):t,i.value=e,n.appendChild(i);}),n.value=l||a[0],o(c||"asc"),r.onclick=function(e){o(e.target.getAttribute("data-value"));},i.onclick=function(e){e.preventDefault(),e.stopPropagation(),t.close(),s({path:n.value,direction:r.value});},e&&(e.onsubmit=i.onclick);}).afterClose(function(e){e.destroy();}).show();}},function(e,t,i){"use strict";i.r(t),i.d(t,"showTransformModal",function(){return c;});var n=i(14),o=i.n(n),r=i(10),E=i.n(r),s=i(1);function a(e){return(a="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return typeof e==="undefined"?"undefined":_typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e==="undefined"?"undefined":_typeof(e);})(e);}function B(e,t,i,n){return"boolean"==typeof e||e instanceof Boolean||null===e||"number"==typeof e||e instanceof Number||"string"==typeof e||e instanceof String||e instanceof Date?JSON.stringify(e):Array.isArray(e)?function(e,t,i,n){for(var r=t?i+t:void 0,o=t?"[\n":"[",s=0;s<e.length;s++){var a=e[s];if(t&&(o+=r),o+=void 0!==a&&"function"!=typeof a?B(a,t,r,n):"null",s<e.length-1&&(o+=t?",\n":","),o.length>n)return o+"...";}return o+=t?"\n"+i+"]":"]";}(e,t,i,n):e&&"object"===a(e)?function(e,t,i,n){var r=t?i+t:void 0,o=!0,s=t?"{\n":"{";if("function"==typeof e.toJSON)return B(e.toJSON(),t,i,n);for(var a in e){if(c=e,h=a,Object.prototype.hasOwnProperty.call(c,h)){var l=e[a];if(o?o=!1:s+=t?",\n":",",s+=t?r+'"'+a+'": ':'"'+a+'":',(s+=B(l,t,r,n)).length>n)return s+"...";}}var c,h;return s+=t?"\n"+i+"}":"}";}(e,t,i,n):void 0;}function Z(e,t){for(var i="";0<t--;){i+=e;}return i;}var T=i(0),G=i(2),l='Enter a <a href="http://jmespath.org" target="_blank">JMESPath</a> query to filter, sort, or transform the JSON data.<br/>To learn JMESPath, go to <a href="http://jmespath.org/tutorial.html" target="_blank">the interactive tutorial</a>.';function c(e){var t=e.container,w=e.json,i=e.queryDescription,n=void 0===i?l:i,S=e.createQuery,x=e.executeQuery,k=e.onTransform,R=w,r='<label class="pico-modal-contents"><div class="pico-modal-header">'+Object(s.c)("transform")+"</div><p>"+n+'</p><div class="jsoneditor-jmespath-label">'+Object(s.c)("transformWizardLabel")+' </div><div id="wizard" class="jsoneditor-jmespath-block jsoneditor-jmespath-wizard">  <table class="jsoneditor-jmespath-wizard-table">    <tbody>      <tr>        <th>'+Object(s.c)("transformWizardFilter")+'</th>        <td class="jsoneditor-jmespath-filter">          <div class="jsoneditor-inline jsoneditor-jmespath-filter-field" >            <select id="filterField">            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-filter-relation" >            <select id="filterRelation">              <option value="==">==</option>              <option value="!=">!=</option>              <option value="<">&lt;</option>              <option value="<=">&lt;=</option>              <option value=">">&gt;</option>              <option value=">=">&gt;=</option>            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-filter-value" >            <input type="text" class="value" placeholder="value..." id="filterValue" />          </div>        </td>      </tr>      <tr>        <th>'+Object(s.c)("transformWizardSortBy")+'</th>        <td class="jsoneditor-jmespath-filter">          <div class="jsoneditor-inline jsoneditor-jmespath-sort-field">            <select id="sortField">            </select>          </div>          <div class="jsoneditor-inline jsoneditor-jmespath-sort-order" >            <select id="sortOrder">              <option value="asc">Ascending</option>              <option value="desc">Descending</option>            </select>          </div>        </td>      </tr>      <tr id="selectFieldsPart">        <th>'+Object(s.c)("transformWizardSelectFields")+'</th>        <td class="jsoneditor-jmespath-filter">          <select class="jsoneditor-jmespath-select-fields" id="selectFields" multiple></select>        </td>      </tr>    </tbody>  </table></div><div class="jsoneditor-jmespath-label">'+Object(s.c)("transformQueryLabel")+' </div><div class="jsoneditor-jmespath-block">  <textarea id="query"             rows="4"             autocomplete="off"             autocorrect="off"             autocapitalize="off"             spellcheck="false"            title="'+Object(s.c)("transformQueryTitle")+'">[*]</textarea></div><div class="jsoneditor-jmespath-label">'+Object(s.c)("transformPreviewLabel")+' </div><div class="jsoneditor-jmespath-block">  <textarea id="preview"       class="jsoneditor-transform-preview"      readonly> </textarea></div><div class="jsoneditor-jmespath-block jsoneditor-modal-actions">  <input type="submit" id="ok" value="'+Object(s.c)("ok")+'" autofocus /></div></div>';o()({parent:t,content:r,overlayClass:"jsoneditor-modal-overlay",overlayStyles:{backgroundColor:"rgb(1,1,1)",opacity:.3},modalClass:"jsoneditor-modal jsoneditor-modal-transform",focus:!1}).afterCreate(function(t){var e=t.modalElem(),i=e.querySelector("#wizard"),n=e.querySelector("#ok"),r=e.querySelector("#filterField"),o=e.querySelector("#filterRelation"),s=e.querySelector("#filterValue"),a=e.querySelector("#sortField"),l=e.querySelector("#sortOrder"),c=e.querySelector("#selectFields"),h=e.querySelector("#query"),d=e.querySelector("#preview");Array.isArray(R)||(i.style.fontStyle="italic",i.innerHTML="(wizard not available for objects, only for arrays)"),Object(T.getChildPaths)(w).forEach(function(e){var t=A(e),i=document.createElement("option");i.text=t,i.value=t,r.appendChild(i);var n=document.createElement("option");n.text=t,n.value=t,a.appendChild(n);});var u,g=Object(T.getChildPaths)(w,!0).filter(function(e){return""!==e;});0<g.length?g.forEach(function(e){var t=A(e),i=document.createElement("option");i.text=t,i.value=t,c.appendChild(i);}):(u=e.querySelector("#selectFieldsPart"))&&(u.style.display="none");var p=new E.a(r,{defaultSelected:!1,clearable:!0,allowDeselect:!0,placeholder:"field..."}),m=new E.a(o,{defaultSelected:!1,clearable:!0,allowDeselect:!0,placeholder:"compare..."}),f=new E.a(a,{defaultSelected:!1,clearable:!0,allowDeselect:!0,placeholder:"field..."}),C=new E.a(l,{defaultSelected:!1,clearable:!0,allowDeselect:!0,placeholder:"order..."}),I=new E.a(c,{multiple:!0,clearable:!0,defaultSelected:!1,placeholder:"select fields..."});function A(e){return""===e?"@":"."===e[0]?e.slice(1):e;}p.on("selectr.change",y),m.on("selectr.change",y),s.oninput=y,f.on("selectr.change",y),C.on("selectr.change",y),I.on("selectr.change",y),e.querySelector(".pico-modal-contents").onclick=function(e){"A"!==e.target.nodeName&&e.preventDefault();};var v=Object(T.debounce)(function(){try{var e=x(R,h.value);d.className="jsoneditor-transform-preview",d.value=function(e,t,i){var n;"number"==typeof t?10<t?n=Z(" ",10):1<=t&&(n=Z(" ",t)):"string"==typeof t&&""!==t&&(n=t);var r,o,s=B(e,n,"",i);return s.length>i?(r=s,("number"==typeof(o=i)?r.slice(0,o):r)+"..."):s;}(e,2,G.b),n.disabled=!1;}catch(e){d.className="jsoneditor-transform-preview jsoneditor-error",d.value=e.toString(),n.disabled=!0;}},300);function b(e,t){try{h.value=S(e,t),n.disabled=!1,v();}catch(e){var i='Error: an error happened when executing "createQuery": '+(e.message||e.toString());h.value="",n.disabled=!0,d.className="jsoneditor-transform-preview jsoneditor-error",d.value=i;}}function y(){var e={};if(r.value&&o.value&&s.value&&(e.filter={field:r.value,relation:o.value,value:s.value}),a.value&&l.value&&(e.sort={field:a.value,direction:l.value}),c.value){for(var t,i=[],n=0;n<c.options.length;n++){c.options[n].selected&&(t=c.options[n].value,i.push(t));}e.projection={fields:i};}b(w,e);}h.oninput=v,n.onclick=function(e){e.preventDefault(),e.stopPropagation(),t.close(),k(h.value);},b(w,{}),setTimeout(function(){h.select(),h.focus(),h.selectionStart=3,h.selectionEnd=3;});}).afterClose(function(e){e.destroy();}).show();}},function(e,t,i){"use strict";function o(e,t,i){var n=i?" !== ":" === ",r=i?" || ":" && ",o=i?"!":"",s=i?"":"!";switch(e){case"null":return t+n+"null";case"array":return o+"Array.isArray("+t+")";case"object":return"("+o+t+r+"typeof "+t+n+'"object"'+r+s+"Array.isArray("+t+"))";case"integer":return"(typeof "+t+n+'"number"'+r+s+"("+t+" % 1)"+r+t+n+t+")";default:return"typeof "+t+n+'"'+e+'"';}}e.exports={copy:function copy(e,t){for(var i in t=t||{},e){t[i]=e[i];}return t;},checkDataType:o,checkDataTypes:function checkDataTypes(e,t){switch(e.length){case 1:return o(e[0],t,!0);default:var i="",n=a(e);for(var r in n.array&&n.object&&(i=n.null?"(":"(!"+t+" || ",i+="typeof "+t+' !== "object")',delete n.null,delete n.array,delete n.object),n.number&&delete n.integer,n){i+=(i?" && ":"")+o(r,t,!0);}return i;}},coerceToTypes:function coerceToTypes(e,t){if(Array.isArray(t)){for(var i=[],n=0;n<t.length;n++){var r=t[n];(s[r]||"array"===e&&"array"===r)&&(i[i.length]=r);}if(i.length)return i;}else{if(s[t])return[t];if("array"===e&&"array"===t)return["array"];}},toHash:a,getProperty:d,escapeQuotes:l,equal:i(18),ucs2length:i(47),varOccurences:function varOccurences(e,t){t+="[^0-9]";var i=e.match(new RegExp(t,"g"));return i?i.length:0;},varReplace:function varReplace(e,t,i){return t+="([^0-9])",i=i.replace(/\$/g,"$$$$"),e.replace(new RegExp(t,"g"),i+"$1");},cleanUpCode:function cleanUpCode(e){return e.replace(c,"").replace(h,"").replace(u,"if (!($1))");},finalCleanUpCode:function finalCleanUpCode(e,t){var i=e.match(g);i&&2==i.length&&(e=t?e.replace(m,"").replace(I,A):e.replace(p,"").replace(f,C));return(i=e.match(v))&&3===i.length?e.replace(b,""):e;},schemaHasRules:function schemaHasRules(e,t){if("boolean"==typeof e)return!e;for(var i in e){if(t[i])return!0;}},schemaHasRulesExcept:function schemaHasRulesExcept(e,t,i){if("boolean"==typeof e)return!e&&"not"!=i;for(var n in e){if(n!=i&&t[n])return!0;}},schemaUnknownRules:function schemaUnknownRules(e,t){if("boolean"==typeof e)return;for(var i in e){if(!t[i])return i;}},toQuotedString:y,getPathExpr:function getPathExpr(e,t,i,n){return x(e,i?"'/' + "+t+(n?"":".replace(/~/g, '~0').replace(/\\//g, '~1')"):n?"'[' + "+t+" + ']'":"'[\\'' + "+t+" + '\\']'");},getPath:function getPath(e,t,i){var n=y(i?"/"+k(t):d(t));return x(e,n);},getData:function getData(e,t,i){var n,r,o,s;if(""===e)return"rootData";if("/"==e[0]){if(!w.test(e))throw new Error("Invalid JSON-pointer: "+e);r=e,o="rootData";}else{if(!(s=e.match(S)))throw new Error("Invalid JSON-pointer: "+e);if(n=+s[1],"#"==(r=s[2])){if(t<=n)throw new Error("Cannot access property/index "+n+" levels up, current level is "+t);return i[t-n];}if(t<n)throw new Error("Cannot access data "+n+" levels up, current level is "+t);if(o="data"+(t-n||""),!r)return o;}for(var a=o,l=r.split("/"),c=0;c<l.length;c++){var h=l[c];h&&(o+=d(R(h)),a+=" && "+o);}return a;},unescapeFragment:function unescapeFragment(e){return R(decodeURIComponent(e));},unescapeJsonPointer:R,escapeFragment:function escapeFragment(e){return encodeURIComponent(k(e));},escapeJsonPointer:k};var s=a(["string","number","integer","boolean","null"]);function a(e){for(var t={},i=0;i<e.length;i++){t[e[i]]=!0;}return t;}var n=/^[a-z$_][a-z$_0-9]*$/i,r=/'|\\/g;function d(e){return"number"==typeof e?"["+e+"]":n.test(e)?"."+e:"['"+l(e)+"']";}function l(e){return e.replace(r,"\\$&").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\f/g,"\\f").replace(/\t/g,"\\t");}var c=/else\s*{\s*}/g,h=/if\s*\([^)]+\)\s*\{\s*\}(?!\s*else)/g,u=/if\s*\(([^)]+)\)\s*\{\s*\}\s*else(?!\s*if)/g;var g=/[^v.]errors/g,p=/var errors = 0;|var vErrors = null;|validate.errors = vErrors;/g,m=/var errors = 0;|var vErrors = null;/g,f="return errors === 0;",C="validate.errors = null; return true;",I=/if \(errors === 0\) return data;\s*else throw new ValidationError\(vErrors\);/,A="return data;",v=/[^A-Za-z_$]rootData[^A-Za-z0-9_$]/g,b=/if \(rootData === undefined\) rootData = data;/;function y(e){return"'"+l(e)+"'";}var w=/^\/(?:[^~]|~0|~1)*$/,S=/^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;function x(e,t){return'""'==e?t:(e+" + "+t).replace(/' \+ '/g,"");}function k(e){return e.replace(/~/g,"~0").replace(/\//g,"~1");}function R(e){return e.replace(/~1/g,"/").replace(/~0/g,"~");}},function(e,t,i){"use strict";i.d(t,"a",function(){return r;});var p=i(3),m=i(1);function n(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var r=function(){function g(e,t,i,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,g);for(var r={code:{text:Object(m.c)("modeCodeText"),title:Object(m.c)("modeCodeTitle"),click:function click(){n("code");}},form:{text:Object(m.c)("modeFormText"),title:Object(m.c)("modeFormTitle"),click:function click(){n("form");}},text:{text:Object(m.c)("modeTextText"),title:Object(m.c)("modeTextTitle"),click:function click(){n("text");}},tree:{text:Object(m.c)("modeTreeText"),title:Object(m.c)("modeTreeTitle"),click:function click(){n("tree");}},view:{text:Object(m.c)("modeViewText"),title:Object(m.c)("modeViewTitle"),click:function click(){n("view");}},preview:{text:Object(m.c)("modePreviewText"),title:Object(m.c)("modePreviewTitle"),click:function click(){n("preview");}}},o=[],s=0;s<t.length;s++){var a=t[s],l=r[a];if(!l)throw new Error('Unknown mode "'+a+'"');l.className="jsoneditor-type-modes"+(i===a?" jsoneditor-selected":""),o.push(l);}var c=r[i];if(!c)throw new Error('Unknown mode "'+i+'"');var h=c.text,d=document.createElement("button");d.type="button",d.className="jsoneditor-modes jsoneditor-separator",d.innerHTML=h+" &#x25BE;",d.title=Object(m.c)("modeEditorTitle"),d.onclick=function(){new p.a(o).show(d,e);};var u=document.createElement("div");u.className="jsoneditor-modes",u.style.position="relative",u.appendChild(d),e.appendChild(u),this.dom={container:e,box:d,frame:u};}var e,t,i;return e=g,(t=[{key:"focus",value:function value(){this.dom.box.focus();}},{key:"destroy",value:function value(){this.dom&&this.dom.frame&&this.dom.frame.parentNode&&this.dom.frame.parentNode.removeChild(this.dom.frame),this.dom=null;}}])&&n(e.prototype,t),i&&n(e,i),g;}();},function(e,t,i){"use strict";function r(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}i.d(t,"a",function(){return n;});var n=function(){function t(e){if(!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,t),this.target=e.target||null,!this.target)throw new Error('FocusTracker constructor called without a "target" to track.');this.onFocus="function"==typeof e.onFocus?e.onFocus:null,this.onBlur="function"==typeof e.onBlur?e.onBlur:null,this._onClick=this._onEvent.bind(this),this._onKeyUp=function(e){9!==e.which&&9!==e.keyCode||this._onEvent(e);}.bind(this),this.focusFlag=!1,this.firstEventFlag=!0,(this.onFocus||this.onBlur)&&(document.addEventListener("click",this._onClick),document.addEventListener("keyup",this._onKeyUp));}var e,i,n;return e=t,(i=[{key:"destroy",value:function value(){document.removeEventListener("click",this._onClick),document.removeEventListener("keyup",this._onKeyUp),this._onEvent({target:document.body});}},{key:"_onEvent",value:function value(e){var t=e.target,i=t===this.target||!(!this.target.contains(t)&&!this.target.contains(document.activeElement));i?this.focusFlag||(this.onFocus&&this.onFocus({type:"focus",target:this.target}),this.focusFlag=!0):(this.focusFlag||this.firstEventFlag)&&(this.onBlur&&this.onBlur({type:"blur",target:this.target}),this.focusFlag=!1,this.firstEventFlag&&(this.firstEventFlag=!1));}}])&&r(e.prototype,i),n&&r(e,n),t;}();},function(e,t,i){"use strict";function n(){}var r={defaultSelected:!0,width:"auto",disabled:!1,searchable:!0,clearable:!1,sortSelected:!1,allowDeselect:!1,closeOnScroll:!1,nativeDropdown:!1,placeholder:"Select an option...",taggable:!1,tagPlaceholder:"Enter a tag..."};n.prototype={on:function on(e,t){this._events=this._events||{},this._events[e]=this._events[e]||[],this._events[e].push(t);},off:function off(e,t){this._events=this._events||{},e in this._events!=!1&&this._events[e].splice(this._events[e].indexOf(t),1);},emit:function emit(e){if(this._events=this._events||{},e in this._events!=!1)for(var t=0;t<this._events[e].length;t++){this._events[e][t].apply(this,Array.prototype.slice.call(arguments,1));}}},n.mixin=function(e){for(var t=["on","off","emit"],i=0;i<t.length;i++){"function"==typeof e?e.prototype[t[i]]=n.prototype[t[i]]:e[t[i]]=n.prototype[t[i]];}return e;};var l={extend:function extend(e,t){var i;for(i in t=t||{},e){e.hasOwnProperty(i)&&(t.hasOwnProperty(i)||(t[i]=e[i]));}return t;},each:function each(e,t,i){if("[object Object]"===Object.prototype.toString.call(e))for(var n in e){Object.prototype.hasOwnProperty.call(e,n)&&t.call(i,n,e[n],e);}else for(var r=0,o=e.length;r<o;r++){t.call(i,r,e[r],e);}},createElement:function createElement(e,t){var i,n,r=document,o=r.createElement(e);if(t&&"[object Object]"===Object.prototype.toString.call(t))for(i in t){i in o?o[i]=t[i]:"html"===i?o.innerHTML=t[i]:"text"===i?(n=r.createTextNode(t[i]),o.appendChild(n)):o.setAttribute(i,t[i]);}return o;},hasClass:function hasClass(e,t){if(e)return e.classList?e.classList.contains(t):!!e.className&&!!e.className.match(new RegExp("(\\s|^)"+t+"(\\s|$)"));},addClass:function addClass(e,t){l.hasClass(e,t)||(e.classList?e.classList.add(t):e.className=e.className.trim()+" "+t);},removeClass:function removeClass(e,t){l.hasClass(e,t)&&(e.classList?e.classList.remove(t):e.className=e.className.replace(new RegExp("(^|\\s)"+t.split(" ").join("|")+"(\\s|$)","gi")," "));},closest:function closest(e,t){return e&&e!==document.body&&(t(e)?e:l.closest(e.parentNode,t));},isInt:function isInt(e){return"number"==typeof e&&isFinite(e)&&Math.floor(e)===e;},debounce:function debounce(n,r,o){var s;return function(){var e=this,t=arguments,i=o&&!s;clearTimeout(s),s=setTimeout(function(){s=null,o||n.apply(e,t);},r),i&&n.apply(e,t);};},rect:function rect(e,t){var i=window,n=e.getBoundingClientRect(),r=t?i.pageXOffset:0,o=t?i.pageYOffset:0;return{bottom:n.bottom+o,height:n.height,left:n.left+r,right:n.right+r,top:n.top+o,width:n.width};},includes:function includes(e,t){return-1<e.indexOf(t);},truncate:function truncate(e){for(;e.firstChild;){e.removeChild(e.firstChild);}}};function c(e,t){return e.hasOwnProperty(t)&&(!0===e[t]||e[t].length);}function a(e,t,i){e.parentNode?e.parentNode.parentNode||t.appendChild(e.parentNode):t.appendChild(e),l.removeClass(e,"excluded"),i||(e.innerHTML=e.textContent);}function h(){var i,e;this.items.length&&(i=document.createDocumentFragment(),this.config.pagination?(e=this.pages.slice(0,this.pageIndex),l.each(e,function(e,t){l.each(t,function(e,t){a(t,i,this.customOption);},this);},this)):l.each(this.items,function(e,t){a(t,i,this.customOption);},this),i.childElementCount&&(l.removeClass(this.items[this.navIndex],"active"),this.navIndex=i.querySelector(".selectr-option").idx,l.addClass(this.items[this.navIndex],"active")),this.tree.appendChild(i));}function d(e,t){t=t||e;var i=this.customOption?this.config.renderOption(t):e.textContent,n=l.createElement("li",{class:"selectr-option",html:i,role:"treeitem","aria-selected":!1});return n.idx=e.idx,this.items.push(n),e.defaultSelected&&this.defaultSelected.push(e.idx),e.disabled&&(n.disabled=!0,l.addClass(n,"disabled")),n;}function o(){(this.config.searchable||this.config.taggable)&&(this.input.value=null,this.searching=!1,this.config.searchable&&l.removeClass(this.inputContainer,"active"),l.hasClass(this.container,"notice")&&(l.removeClass(this.container,"notice"),l.addClass(this.container,"open"),this.input.focus()),l.each(this.items,function(e,t){l.removeClass(t,"excluded"),this.customOption||(t.innerHTML=t.textContent);},this));}function s(e,t){if(t=t||{},!e)throw new Error("You must supply either a HTMLSelectElement or a CSS3 selector string.");if("string"==typeof(this.el=e)&&(this.el=document.querySelector(e)),null===this.el)throw new Error("The element you passed to Selectr can not be found.");if("select"!==this.el.nodeName.toLowerCase())throw new Error("The element you passed to Selectr is not a HTMLSelectElement.");this.render(t);}var u=function u(){var i,e=this.tree,t=e.scrollTop;e.scrollHeight-e.offsetHeight<=t&&this.pageIndex<this.pages.length&&(i=document.createDocumentFragment(),l.each(this.pages[this.pageIndex],function(e,t){a(t,i,this.customOption);},this),e.appendChild(i),this.pageIndex++,this.emit("selectr.paginate",{items:this.items.length,total:this.data.length,page:this.pageIndex,pages:this.pages.length}));};s.prototype.render=function(e){var t;this.rendered||(this.config=l.extend(r,e),this.originalType=this.el.type,this.originalIndex=this.el.tabIndex,this.defaultSelected=[],this.originalOptionCount=this.el.options.length,(this.config.multiple||this.config.taggable)&&(this.el.multiple=!0),this.disabled=c(this.config,"disabled"),this.opened=!1,this.config.taggable&&(this.config.searchable=!1),this.navigating=!1,this.mobileDevice=!1,/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)&&(this.mobileDevice=!0),this.customOption=this.config.hasOwnProperty("renderOption")&&"function"==typeof this.config.renderOption,this.customSelected=this.config.hasOwnProperty("renderSelection")&&"function"==typeof this.config.renderSelection,n.mixin(this),function(){this.requiresPagination=this.config.pagination&&0<this.config.pagination,c(this.config,"width")&&(l.isInt(this.config.width)?this.width=this.config.width+"px":"auto"===this.config.width?this.width="100%":l.includes(this.config.width,"%")&&(this.width=this.config.width)),this.container=l.createElement("div",{class:"selectr-container"}),this.config.customClass&&l.addClass(this.container,this.config.customClass),this.mobileDevice?l.addClass(this.container,"selectr-mobile"):l.addClass(this.container,"selectr-desktop"),this.el.tabIndex=-1,this.config.nativeDropdown||this.mobileDevice?l.addClass(this.el,"selectr-visible"):l.addClass(this.el,"selectr-hidden"),this.selected=l.createElement("div",{class:"selectr-selected",disabled:this.disabled,tabIndex:1,"aria-expanded":!1}),this.label=l.createElement(this.el.multiple?"ul":"span",{class:"selectr-label"});var e,t=l.createElement("div",{class:"selectr-options-container"});this.tree=l.createElement("ul",{class:"selectr-options",role:"tree","aria-hidden":!0,"aria-expanded":!1}),this.notice=l.createElement("div",{class:"selectr-notice"}),this.el.setAttribute("aria-hidden",!0),this.disabled&&(this.el.disabled=!0),this.el.multiple&&(l.addClass(this.label,"selectr-tags"),l.addClass(this.container,"multiple"),this.tags=[],this.selectedValues=this.getSelectedProperties("value"),this.selectedIndexes=this.getSelectedProperties("idx")),this.selected.appendChild(this.label),this.config.clearable&&(this.selectClear=l.createElement("button",{class:"selectr-clear",type:"button"}),this.container.appendChild(this.selectClear),l.addClass(this.container,"clearable")),this.config.taggable&&(e=l.createElement("li",{class:"input-tag"}),this.input=l.createElement("input",{class:"selectr-tag-input",placeholder:this.config.tagPlaceholder,tagIndex:0,autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false",role:"textbox",type:"search"}),e.appendChild(this.input),this.label.appendChild(e),l.addClass(this.container,"taggable"),this.tagSeperators=[","],this.config.tagSeperators&&(this.tagSeperators=this.tagSeperators.concat(this.config.tagSeperators))),this.config.searchable&&(this.input=l.createElement("input",{class:"selectr-input",tagIndex:-1,autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false",role:"textbox",type:"search"}),this.inputClear=l.createElement("button",{class:"selectr-input-clear",type:"button"}),this.inputContainer=l.createElement("div",{class:"selectr-input-container"}),this.inputContainer.appendChild(this.input),this.inputContainer.appendChild(this.inputClear),t.appendChild(this.inputContainer)),t.appendChild(this.notice),t.appendChild(this.tree),this.items=[],this.options=[],this.el.options.length&&(this.options=[].slice.call(this.el.options));var i,n,r,o=!1,s=0;this.el.children.length&&l.each(this.el.children,function(e,t){"OPTGROUP"===t.nodeName?(o=l.createElement("ul",{class:"selectr-optgroup",role:"group",html:"<li class='selectr-optgroup--label'>"+t.label+"</li>"}),l.each(t.children,function(e,t){t.idx=s,o.appendChild(d.call(this,t,o)),s++;},this)):(t.idx=s,d.call(this,t),s++);},this),this.config.data&&Array.isArray(this.config.data)&&(i=!(this.data=[]),o=!1,s=0,l.each(this.config.data,function(e,t){c(t,"children")?(i=l.createElement("optgroup",{label:t.text}),o=l.createElement("ul",{class:"selectr-optgroup",role:"group",html:"<li class='selectr-optgroup--label'>"+t.text+"</li>"}),l.each(t.children,function(e,t){(n=new Option(t.text,t.value,!1,t.hasOwnProperty("selected")&&!0===t.selected)).disabled=c(t,"disabled"),this.options.push(n),i.appendChild(n),n.idx=s,o.appendChild(d.call(this,n,t)),this.data[s]=t,s++;},this)):((n=new Option(t.text,t.value,!1,t.hasOwnProperty("selected")&&!0===t.selected)).disabled=c(t,"disabled"),this.options.push(n),n.idx=s,d.call(this,n,t),this.data[s]=t,s++);},this)),this.setSelected(!0);for(var a=this.navIndex=0;a<this.items.length;a++){if(r=this.items[a],!l.hasClass(r,"disabled")){l.addClass(r,"active"),this.navIndex=a;break;}}this.requiresPagination&&(this.pageIndex=1,this.paginate()),this.container.appendChild(this.selected),this.container.appendChild(t),this.placeEl=l.createElement("div",{class:"selectr-placeholder"}),this.setPlaceholder(),this.selected.appendChild(this.placeEl),this.disabled&&this.disable(),this.el.parentNode.insertBefore(this.container,this.el),this.container.appendChild(this.el);}.call(this),this.bindEvents(),this.update(),this.optsRect=l.rect(this.tree),this.rendered=!0,this.el.multiple||(this.el.selectedIndex=this.selectedIndex),t=this,setTimeout(function(){t.emit("selectr.init");},20));},s.prototype.getSelected=function(){return this.el.querySelectorAll("option:checked");},s.prototype.getSelectedProperties=function(t){var e=this.getSelected();return[].slice.call(e).map(function(e){return e[t];}).filter(function(e){return null!=e;});},s.prototype.bindEvents=function(){var n=this;this.events={},this.events.dismiss=function(e){var t=e.target;this.container.contains(t)||!this.opened&&!l.hasClass(this.container,"notice")||this.close();}.bind(this),this.events.navigate=function(e){if(e=e||window.event,this.items.length&&this.opened&&l.includes([13,38,40],e.which)){if(e.preventDefault(),13===e.which)return!(this.config.taggable&&0<this.input.value.length)&&this.change(this.navIndex);var t,i=this.items[this.navIndex];switch(e.which){case 38:(t=0)<this.navIndex&&this.navIndex--;break;case 40:t=1,this.navIndex<this.items.length-1&&this.navIndex++;}for(this.navigating=!0;l.hasClass(this.items[this.navIndex],"disabled")||l.hasClass(this.items[this.navIndex],"excluded");){if(t?this.navIndex++:this.navIndex--,this.searching){if(this.navIndex>this.tree.lastElementChild.idx){this.navIndex=this.tree.lastElementChild.idx;break;}if(this.navIndex<this.tree.firstElementChild.idx){this.navIndex=this.tree.firstElementChild.idx;break;}}}var n=l.rect(this.items[this.navIndex]);t?(0===this.navIndex?this.tree.scrollTop=0:n.top+n.height>this.optsRect.top+this.optsRect.height&&(this.tree.scrollTop=this.tree.scrollTop+(n.top+n.height-(this.optsRect.top+this.optsRect.height))),this.navIndex===this.tree.childElementCount-1&&this.requiresPagination&&u.call(this)):0===this.navIndex?this.tree.scrollTop=0:n.top-this.optsRect.top<0&&(this.tree.scrollTop=this.tree.scrollTop+(n.top-this.optsRect.top)),i&&l.removeClass(i,"active"),l.addClass(this.items[this.navIndex],"active");}else this.navigating=!1;}.bind(this),this.events.reset=this.reset.bind(this),(this.config.nativeDropdown||this.mobileDevice)&&(this.container.addEventListener("touchstart",function(e){e.changedTouches[0].target===n.el&&n.toggle();}),(this.config.nativeDropdown||this.mobileDevice)&&this.container.addEventListener("click",function(e){e.preventDefault(),e.stopPropagation(),e.target===n.el&&n.toggle();}),this.el.addEventListener("change",function(e){var t,i;n.el.multiple?(t=n.getSelectedProperties("idx"),i=function(e,t){for(var i,n=[],r=e.slice(0),o=0;o<t.length;o++){-1<(i=r.indexOf(t[o]))?r.splice(i,1):n.push(t[o]);}return[n,r];}(n.selectedIndexes,t),l.each(i[0],function(e,t){n.select(t);},n),l.each(i[1],function(e,t){n.deselect(t);},n)):-1<n.el.selectedIndex&&n.select(n.el.selectedIndex);})),this.config.nativeDropdown&&this.container.addEventListener("keydown",function(e){"Enter"===e.key&&n.selected===document.activeElement&&(n.toggle(),setTimeout(function(){n.el.focus();},200));}),this.selected.addEventListener("click",function(e){n.disabled||n.toggle(),e.preventDefault(),e.stopPropagation();}),this.label.addEventListener("click",function(e){l.hasClass(e.target,"selectr-tag-remove")&&n.deselect(e.target.parentNode.idx);}),this.selectClear&&this.selectClear.addEventListener("click",this.clear.bind(this)),this.tree.addEventListener("mousedown",function(e){e.preventDefault();}),this.tree.addEventListener("click",function(e){e.preventDefault(),e.stopPropagation();var t=l.closest(e.target,function(e){return e&&l.hasClass(e,"selectr-option");});t&&(l.hasClass(t,"disabled")||(l.hasClass(t,"selected")?(n.el.multiple||!n.el.multiple&&n.config.allowDeselect)&&n.deselect(t.idx):n.select(t.idx),n.opened&&!n.el.multiple&&n.close()));}),this.tree.addEventListener("mouseover",function(e){l.hasClass(e.target,"selectr-option")&&(l.hasClass(e.target,"disabled")||(l.removeClass(n.items[n.navIndex],"active"),l.addClass(e.target,"active"),n.navIndex=[].slice.call(n.items).indexOf(e.target)));}),this.config.searchable&&(this.input.addEventListener("focus",function(e){n.searching=!0;}),this.input.addEventListener("blur",function(e){n.searching=!1;}),this.input.addEventListener("keyup",function(e){n.search(),n.config.taggable||(this.value.length?l.addClass(this.parentNode,"active"):l.removeClass(this.parentNode,"active"));}),this.inputClear.addEventListener("click",function(e){n.input.value=null,o.call(n),n.tree.childElementCount||h.call(n);})),this.config.taggable&&this.input.addEventListener("keyup",function(e){var i;n.search(),n.config.taggable&&this.value.length&&(i=this.value.trim(),13!==e.which&&!l.includes(n.tagSeperators,e.key)||(l.each(n.tagSeperators,function(e,t){i=i.replace(t,"");}),n.add({value:i,text:i,selected:!0},!0)?(n.close(),o.call(n)):(this.value="",n.setMessage("That tag is already in use."))));}),this.update=l.debounce(function(){n.opened&&n.config.closeOnScroll&&n.close(),n.width&&(n.container.style.width=n.width),n.invert();},50),this.requiresPagination&&(this.paginateItems=l.debounce(function(){u.call(this);},50),this.tree.addEventListener("scroll",this.paginateItems.bind(this))),document.addEventListener("click",this.events.dismiss),window.addEventListener("keydown",this.events.navigate),window.addEventListener("resize",this.update),window.addEventListener("scroll",this.update),this.el.form&&this.el.form.addEventListener("reset",this.events.reset);},s.prototype.setSelected=function(e){var i;this.config.data||this.el.multiple||!this.el.options.length||(0===this.el.selectedIndex&&(this.el.options[0].defaultSelected||this.config.defaultSelected||(this.el.selectedIndex=-1)),this.selectedIndex=this.el.selectedIndex,-1<this.selectedIndex&&this.select(this.selectedIndex)),this.config.multiple&&"select-one"===this.originalType&&!this.config.data&&this.el.options[0].selected&&!this.el.options[0].defaultSelected&&(this.el.options[0].selected=!1),l.each(this.options,function(e,t){t.selected&&t.defaultSelected&&this.select(t.idx);},this),this.config.selectedValue&&this.setValue(this.config.selectedValue),this.config.data&&(!this.el.multiple&&this.config.defaultSelected&&this.el.selectedIndex<0&&this.select(0),i=0,l.each(this.config.data,function(e,t){c(t,"children")?l.each(t.children,function(e,t){t.hasOwnProperty("selected")&&!0===t.selected&&this.select(i),i++;},this):(t.hasOwnProperty("selected")&&!0===t.selected&&this.select(i),i++);},this));},s.prototype.destroy=function(){this.rendered&&(this.emit("selectr.destroy"),"select-one"===this.originalType&&(this.el.multiple=!1),this.config.data&&(this.el.innerHTML=""),l.removeClass(this.el,"selectr-hidden"),this.el.form&&l.off(this.el.form,"reset",this.events.reset),l.off(document,"click",this.events.dismiss),l.off(document,"keydown",this.events.navigate),l.off(window,"resize",this.update),l.off(window,"scroll",this.update),this.container.parentNode.replaceChild(this.el,this.container),this.rendered=!1);},s.prototype.change=function(e){var t=this.items[e],i=this.options[e];i.disabled||(i.selected&&l.hasClass(t,"selected")?this.deselect(e):this.select(e),this.opened&&!this.el.multiple&&this.close());},s.prototype.select=function(n){var e=this.items[n],t=[].slice.call(this.el.options),i=this.options[n];if(this.el.multiple){if(l.includes(this.selectedIndexes,n))return!1;if(this.config.maxSelections&&this.tags.length===this.config.maxSelections)return this.setMessage("A maximum of "+this.config.maxSelections+" items can be selected.",!0),!1;this.selectedValues.push(i.value),this.selectedIndexes.push(n),function(e){var t,c,h=this,i=document.createDocumentFragment(),n=this.options[e.idx],r=this.data?this.data[e.idx]:n,o=this.customSelected?this.config.renderSelection(r):n.textContent,s=l.createElement("li",{class:"selectr-tag",html:o}),a=l.createElement("button",{class:"selectr-tag-remove",type:"button"});s.appendChild(a),s.idx=e.idx,s.tag=n.value,this.tags.push(s),this.config.sortSelected?(t=this.tags.slice(),c=function c(e,n){e.replace(/(\d+)|(\D+)/g,function(e,t,i){n.push([t||1/0,i||""]);});},t.sort(function(e,t){var i,n,r=[],o=[];for(!0===h.config.sortSelected?(i=e.tag,n=t.tag):"text"===h.config.sortSelected&&(i=e.textContent,n=t.textContent),c(i,r),c(n,o);r.length&&o.length;){var s=r.shift(),a=o.shift(),l=s[0]-a[0]||s[1].localeCompare(a[1]);if(l)return l;}return r.length-o.length;}),l.each(t,function(e,t){i.appendChild(t);}),this.label.innerHTML=""):i.appendChild(s),this.config.taggable?this.label.insertBefore(i,this.input.parentNode):this.label.appendChild(i);}.call(this,e);}else{var r=this.data?this.data[n]:i;this.label.innerHTML=this.customSelected?this.config.renderSelection(r):i.textContent,this.selectedValue=i.value,this.selectedIndex=n,l.each(this.options,function(e,t){var i=this.items[e];e!==n&&(i&&l.removeClass(i,"selected"),t.selected=!1,t.removeAttribute("selected"));},this);}l.includes(t,i)||this.el.add(i),e.setAttribute("aria-selected",!0),l.addClass(e,"selected"),l.addClass(this.container,"has-selected"),i.selected=!0,i.setAttribute("selected",""),this.emit("selectr.change",i),this.emit("selectr.select",i);},s.prototype.deselect=function(e,t){var i=this.items[e],n=this.options[e];if(this.el.multiple){var r=this.selectedIndexes.indexOf(e);this.selectedIndexes.splice(r,1);var o=this.selectedValues.indexOf(n.value);this.selectedValues.splice(o,1),function(i){var n=!1;l.each(this.tags,function(e,t){t.idx===i.idx&&(n=t);},this),n&&(this.label.removeChild(n),this.tags.splice(this.tags.indexOf(n),1));}.call(this,i),this.tags.length||l.removeClass(this.container,"has-selected");}else{if(!t&&!this.config.clearable&&!this.config.allowDeselect)return!1;this.label.innerHTML="",this.selectedValue=null,this.el.selectedIndex=this.selectedIndex=-1,l.removeClass(this.container,"has-selected");}this.items[e].setAttribute("aria-selected",!1),l.removeClass(this.items[e],"selected"),n.selected=!1,n.removeAttribute("selected"),this.emit("selectr.change",null),this.emit("selectr.deselect",n);},s.prototype.setValue=function(i){var n=Array.isArray(i);if(n||(i=i.toString().trim()),!this.el.multiple&&n)return!1;l.each(this.options,function(e,t){(n&&l.includes(i.toString(),t.value)||t.value===i)&&this.change(t.idx);},this);},s.prototype.getValue=function(e,t){var i,n;return this.el.multiple?e?this.selectedIndexes.length&&(n={values:[]},l.each(this.selectedIndexes,function(e,t){var i=this.options[t];n.values[e]={value:i.value,text:i.textContent};},this)):n=this.selectedValues.slice():n=e?{value:(i=this.options[this.selectedIndex]).value,text:i.textContent}:this.selectedValue,e&&t&&(n=JSON.stringify(n)),n;},s.prototype.add=function(i,n){if(i){if(this.data=this.data||[],this.items=this.items||[],this.options=this.options||[],Array.isArray(i))l.each(i,function(e,t){this.add(t,n);},this);else if("[object Object]"===Object.prototype.toString.call(i)){if(n){var r=!1;if(l.each(this.options,function(e,t){t.value.toLowerCase()===i.value.toLowerCase()&&(r=!0);}),r)return!1;}var e=l.createElement("option",i);return this.data.push(i),this.options.push(e),e.idx=0<this.options.length?this.options.length-1:0,d.call(this,e),i.selected&&this.select(e.idx),e;}return this.setPlaceholder(),this.config.pagination&&this.paginate(),!0;}},s.prototype.remove=function(i){var n,r=[];Array.isArray(i)?l.each(i,function(e,t){l.isInt(t)?r.push(this.getOptionByIndex(t)):"string"==typeof i&&r.push(this.getOptionByValue(t));},this):l.isInt(i)?r.push(this.getOptionByIndex(i)):"string"==typeof i&&r.push(this.getOptionByValue(i)),r.length&&(l.each(r,function(e,t){n=t.idx,this.el.remove(t),this.options.splice(n,1);var i=this.items[n].parentNode;i&&i.removeChild(this.items[n]),this.items.splice(n,1),l.each(this.options,function(e,t){t.idx=e,this.items[e].idx=e;},this);},this),this.setPlaceholder(),this.config.pagination&&this.paginate());},s.prototype.removeAll=function(){this.clear(!0),l.each(this.el.options,function(e,t){this.el.remove(t);},this),l.truncate(this.tree),this.items=[],this.options=[],this.data=[],this.navIndex=0,this.requiresPagination&&(this.requiresPagination=!1,this.pageIndex=1,this.pages=[]),this.setPlaceholder();},s.prototype.search=function(o){var s,e,t;this.navigating||(o=o||this.input.value,s=document.createDocumentFragment(),this.removeMessage(),l.truncate(this.tree),1<o.length?(l.each(this.options,function(e,t){var i,n,r=this.items[t.idx];l.includes(t.textContent.toLowerCase(),o.toLowerCase())&&!t.disabled?(a(r,s,this.customOption),l.removeClass(r,"excluded"),this.customOption||(r.innerHTML=(i=t,!!(n=new RegExp(o,"i").exec(i.textContent))&&i.textContent.replace(n[0],"<span class='selectr-match'>"+n[0]+"</span>")))):l.addClass(r,"excluded");},this),s.childElementCount?(e=this.items[this.navIndex],t=s.firstElementChild,l.removeClass(e,"active"),this.navIndex=t.idx,l.addClass(t,"active")):this.config.taggable||this.setMessage("no results.")):h.call(this),this.tree.appendChild(s));},s.prototype.toggle=function(){this.disabled||(this.opened?this.close():this.open());},s.prototype.open=function(){var e=this;return!!this.options.length&&(this.opened||this.emit("selectr.open"),this.opened=!0,this.mobileDevice||this.config.nativeDropdown?(l.addClass(this.container,"native-open"),void(this.config.data&&l.each(this.options,function(e,t){this.el.add(t);},this))):(l.addClass(this.container,"open"),h.call(this),this.invert(),this.tree.scrollTop=0,l.removeClass(this.container,"notice"),this.selected.setAttribute("aria-expanded",!0),this.tree.setAttribute("aria-hidden",!1),this.tree.setAttribute("aria-expanded",!0),void(this.config.searchable&&!this.config.taggable&&setTimeout(function(){e.input.focus(),e.input.tabIndex=0;},10))));},s.prototype.close=function(){var e;this.opened&&this.emit("selectr.close"),this.opened=!1,this.mobileDevice||this.config.nativeDropdown?l.removeClass(this.container,"native-open"):(e=l.hasClass(this.container,"notice"),this.config.searchable&&!e&&(this.input.blur(),this.input.tabIndex=-1,this.searching=!1),e&&(l.removeClass(this.container,"notice"),this.notice.textContent=""),l.removeClass(this.container,"open"),l.removeClass(this.container,"native-open"),this.selected.setAttribute("aria-expanded",!1),this.tree.setAttribute("aria-hidden",!0),this.tree.setAttribute("aria-expanded",!1),l.truncate(this.tree),o.call(this));},s.prototype.enable=function(){this.disabled=!1,this.el.disabled=!1,this.selected.tabIndex=this.originalIndex,this.el.multiple&&l.each(this.tags,function(e,t){t.lastElementChild.tabIndex=0;}),l.removeClass(this.container,"selectr-disabled");},s.prototype.disable=function(e){e||(this.el.disabled=!0),this.selected.tabIndex=-1,this.el.multiple&&l.each(this.tags,function(e,t){t.lastElementChild.tabIndex=-1;}),this.disabled=!0,l.addClass(this.container,"selectr-disabled");},s.prototype.reset=function(){this.disabled||(this.clear(),this.setSelected(!0),l.each(this.defaultSelected,function(e,t){this.select(t);},this),this.emit("selectr.reset"));},s.prototype.clear=function(e){var t;this.el.multiple?this.selectedIndexes.length&&(t=this.selectedIndexes.slice(),l.each(t,function(e,t){this.deselect(t);},this)):-1<this.selectedIndex&&this.deselect(this.selectedIndex,e),this.emit("selectr.clear");},s.prototype.serialise=function(e){var n=[];return l.each(this.options,function(e,t){var i={value:t.value,text:t.textContent};t.selected&&(i.selected=!0),t.disabled&&(i.disabled=!0),n[e]=i;}),e?JSON.stringify(n):n;},s.prototype.serialize=function(e){return this.serialise(e);},s.prototype.setPlaceholder=function(e){e=e||this.config.placeholder||this.el.getAttribute("placeholder"),this.options.length||(e="No options available"),this.placeEl.innerHTML=e;},s.prototype.paginate=function(){if(this.items.length){var i=this;return this.pages=this.items.map(function(e,t){return t%i.config.pagination==0?i.items.slice(t,t+i.config.pagination):null;}).filter(function(e){return e;}),this.pages;}},s.prototype.setMessage=function(e,t){t&&this.close(),l.addClass(this.container,"notice"),this.notice.textContent=e;},s.prototype.removeMessage=function(){l.removeClass(this.container,"notice"),this.notice.innerHTML="";},s.prototype.invert=function(){var e=l.rect(this.selected),t=this.tree.parentNode.offsetHeight,i=window.innerHeight;e.top+e.height+t>i?(l.addClass(this.container,"inverted"),this.isInverted=!0):(l.removeClass(this.container,"inverted"),this.isInverted=!1),this.optsRect=l.rect(this.tree);},s.prototype.getOptionByIndex=function(e){return this.options[e];},s.prototype.getOptionByValue=function(e){for(var t=!1,i=0,n=this.options.length;i<n;i++){if(this.options[i].value.trim()===e.toString().trim()){t=this.options[i];break;}}return t;},e.exports=s;},function(e,t){e.exports=function t(e,i){"use strict";function n(e){return t.insensitive&&(""+e).toLowerCase()||""+e;}var r,o,s=/(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,a=/(^[ ]*|[ ]*$)/g,l=/(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,c=/^0x[0-9a-f]+$/i,h=/^0/,d=n(e).replace(a,"")||"",u=n(i).replace(a,"")||"",g=d.replace(s,"\0$1\0").replace(/\0$/,"").replace(/^\0/,"").split("\0"),p=u.replace(s,"\0$1\0").replace(/\0$/,"").replace(/^\0/,"").split("\0"),m=parseInt(d.match(c),16)||1!==g.length&&d.match(l)&&Date.parse(d),f=parseInt(u.match(c),16)||m&&u.match(l)&&Date.parse(u)||null;if(f){if(m<f)return-1;if(f<m)return 1;}for(var C=0,I=Math.max(g.length,p.length);C<I;C++){if(r=!(g[C]||"").match(h)&&parseFloat(g[C])||g[C]||0,o=!(p[C]||"").match(h)&&parseFloat(p[C])||p[C]||0,isNaN(r)!==isNaN(o))return isNaN(r)?1:-1;if((typeof r==="undefined"?"undefined":_typeof(r))!=(typeof o==="undefined"?"undefined":_typeof(o))&&(r+="",o+=""),r<o)return-1;if(o<r)return 1;}return 0;};},function(e,t,i){"use strict";i.d(t,"a",function(){return n;});var g=i(0);function n(r,e,o){var t,i,n=3<arguments.length&&void 0!==arguments[3]&&arguments[3],s="function"==typeof(t=r).getRootNode?t.getRootNode():window,a={},l=r.getBoundingClientRect(),c=e.getBoundingClientRect(),h=document.createElement("div");function d(){if(h&&h.parentNode){for(var e in h.parentNode.removeChild(h),a){var t;i=a,n=e,Object.prototype.hasOwnProperty.call(i,n)&&((t=a[e])&&Object(g.removeEventListener)(s,e,t),delete a[e]);}"function"==typeof o&&o(r);}var i,n;}function u(e){var t;(t=e.target)===h||Object(g.isChildOf)(t,h)||d();}return h.className="jsoneditor-anchor",h.style.position="absolute",h.style.left=l.left-c.left+"px",h.style.top=l.top-c.top+"px",h.style.width=l.width-2+"px",h.style.height=l.height-2+"px",h.style.boxSizing="border-box",e.appendChild(h),a.mousedown=Object(g.addEventListener)(s,"mousedown",u),a.mousewheel=Object(g.addEventListener)(s,"mousewheel",u),n&&(i=null,h.onmouseover=function(){clearTimeout(i),i=null;},h.onmouseout=function(){i=i||setTimeout(d,200);}),h.destroy=d,h;}},function(e,t,i){var n;if(window.Picker)n=window.Picker;else try{n=i(41);}catch(e){}e.exports=n;},function(e,t,i){var n,r,o;!function(){"use strict";r=[],void 0===(o="function"==typeof(n=function n(){"use strict";function k(e){if((typeof Node==="undefined"?"undefined":_typeof(Node))==="object"){return e instanceof Node;}else{return e&&(typeof e==="undefined"?"undefined":_typeof(e))==="object"&&typeof e.nodeType==="number";}}function e(e){return"string"==typeof e;}function R(){var o=[];return{watch:o.push.bind(o),trigger:function trigger(e,t){var i=true;var n={detail:t,preventDefault:function e(){i=false;}};for(var r=0;r<o.length;r++){o[r](e,n);}return i;}};}function E(e){return window.getComputedStyle(e).display==="none";}function B(e){this.elem=e;}function t(e,t){return B.make(e("parent")).clazz("pico-overlay").clazz(e("overlayClass","")).stylize({display:"none",position:"fixed",top:"0px",left:"0px",height:"100%",width:"100%",zIndex:1e4}).stylize(e("overlayStyles",{opacity:.5,background:"#000"})).onClick(function(){e("overlayClose",!0)&&t();});}B.make=function(e,t){if(typeof e==="string"){e=document.querySelector(e);}var i=document.createElement(t||"div");(e||document.body).appendChild(i);return new B(i);},B.prototype={child:function child(e){return B.make(this.elem,e);},stylize:function stylize(e){e=e||{};if(typeof e.opacity!=="undefined"){e.filter="alpha(opacity="+e.opacity*100+")";}for(var t in e){if(e.hasOwnProperty(t)){this.elem.style[t]=e[t];}}return this;},clazz:function clazz(e){this.elem.className+=" "+e;return this;},html:function html(e){if(k(e)){this.elem.appendChild(e);}else{this.elem.innerHTML=e;}return this;},onClick:function onClick(e){this.elem.addEventListener("click",e);return this;},destroy:function destroy(){this.elem.parentNode.removeChild(this.elem);},hide:function hide(){this.elem.style.display="none";},show:function show(){this.elem.style.display="block";},attr:function attr(e,t){if(t!==undefined){this.elem.setAttribute(e,t);}return this;},anyAncestor:function anyAncestor(e){var t=this.elem;while(t){if(e(new B(t))){return true;}else{t=t.parentNode;}}return false;},isVisible:function isVisible(){return!E(this.elem);}};var Z=1;function i(e,t){var i=e("width","auto");if("number"==typeof i)i+="px";var n=e("modalId","pico-"+Z++);return B.make(e("parent")).clazz("pico-content").clazz(e("modalClass","")).stylize({display:"none",position:"fixed",zIndex:10001,left:"50%",top:"38.1966%",maxHeight:"90%",boxSizing:"border-box",width:i,"-ms-transform":"translate(-50%,-38.1966%)","-moz-transform":"translate(-50%,-38.1966%)","-webkit-transform":"translate(-50%,-38.1966%)","-o-transform":"translate(-50%,-38.1966%)",transform:"translate(-50%,-38.1966%)"}).stylize(e("modalStyles",{overflow:"auto",backgroundColor:"white",padding:"20px",borderRadius:"5px"})).html(e("content")).attr("id",n).attr("role","dialog").attr("aria-labelledby",e("ariaLabelledBy")).attr("aria-describedby",e("ariaDescribedBy",n)).onClick(function(e){new B(e.target).anyAncestor(function(e){return /\bpico-close\b/.test(e.elem.className);})&&t();});}function n(e,t){if(t("closeButton",!0))return e.child("button").html(t("closeHtml","&#xD7;")).clazz("pico-close").clazz(t("closeClass","")).stylize(t("closeStyles",{borderRadius:"2px",border:0,padding:0,cursor:"pointer",height:"15px",width:"15px",position:"absolute",top:"5px",right:"5px",fontSize:"16px",textAlign:"center",lineHeight:"15px",background:"#CCC"})).attr("aria-label",t("close-label","Close"));}function T(e){return function(){return e().elem;};}var G=R(),W=R();function r(e,t){function w(e,t){return(e.msMatchesSelector||e.webkitMatchesSelector||e.matches).call(e,t);}function S(e){return!(E(e)||w(e,":disabled")||e.hasAttribute("contenteditable"))&&(e.hasAttribute("tabindex")||w(e,"input,select,textarea,button,a[href],area[href],iframe"));}function x(e){for(var t=e.getElementsByTagName("*"),i=0;i<t.length;i++){if(S(t[i]))return t[i];}}function o(e){for(var t=e.getElementsByTagName("*"),i=t.length;i--;){if(S(t[i]))return t[i];}}var e;h.beforeShow(function(){e=document.activeElement;}),h.afterShow(function(){var e;!d()||(e=x(h.modalElem()))&&e.focus();}),h.afterClose(function(){d()&&e&&e.focus(),e=null;}),W.watch(function(e){var t,i;d()&&h.isVisible()&&(t=x(h.modalElem()),i=function(e){for(var t=e.getElementsByTagName("*"),i=t.length;i--;){if(S(t[i]))return t[i];}}(h.modalElem()),(e.shiftKey?t:i)===document.activeElement&&((e.shiftKey?i:t).focus(),e.preventDefault()));});}function o(e,t){var p,m=new B(document.body);u.beforeShow(function(){p=m.elem.style.overflow,g()&&m.stylize({overflow:"hidden"});}),u.afterClose(function(){m.stylize({overflow:p});});}return document.documentElement.addEventListener("keydown",function(e){var t=e.which||e.keyCode;27===t?G.trigger():9===t&&W.trigger(e);}),function(n){"string"!=typeof n&&!k(n)||(n={content:n});var o=R(),t=R(),i=R(),r=R(),s=R();function a(e,t){var i=n[e];return"function"==typeof i&&(i=i(t)),void 0===i?t:i;}var l,c,h,d,e,u,g,p,m,f=y.bind(window,"modal"),C=y.bind(window,"overlay"),I=y.bind(window,"close");function A(e){C().hide(),f().hide(),s.trigger(l,e);}function v(e){r.trigger(l,e)&&A(e);}function b(e){return function(){return e.apply(this,arguments),l;};}function y(e,t){var i,n,r;return c||(i=function(e,t){var i=e("width","auto");"number"==typeof i&&(i+="px");var n=e("modalId","pico-"+Z++);return B.make(e("parent")).clazz("pico-content").clazz(e("modalClass","")).stylize({display:"none",position:"fixed",zIndex:10001,left:"50%",top:"38.1966%",maxHeight:"90%",boxSizing:"border-box",width:i,"-ms-transform":"translate(-50%,-38.1966%)","-moz-transform":"translate(-50%,-38.1966%)","-webkit-transform":"translate(-50%,-38.1966%)","-o-transform":"translate(-50%,-38.1966%)",transform:"translate(-50%,-38.1966%)"}).stylize(e("modalStyles",{overflow:"auto",backgroundColor:"white",padding:"20px",borderRadius:"5px"})).html(e("content")).attr("id",n).attr("role","dialog").attr("aria-labelledby",e("ariaLabelledBy")).attr("aria-describedby",e("ariaDescribedBy",n)).onClick(function(e){new B(e.target).anyAncestor(function(e){return /\bpico-close\b/.test(e.elem.className);})&&t();});}(a,v),c={modal:i,overlay:(r=v,B.make((n=a)("parent")).clazz("pico-overlay").clazz(n("overlayClass","")).stylize({display:"none",position:"fixed",top:"0px",left:"0px",height:"100%",width:"100%",zIndex:1e4}).stylize(n("overlayStyles",{opacity:.5,background:"#000"})).onClick(function(){n("overlayClose",!0)&&r();})),close:function(e,t){if(t("closeButton",!0))return e.child("button").html(t("closeHtml","&#xD7;")).clazz("pico-close").clazz(t("closeClass","")).stylize(t("closeStyles",{borderRadius:"2px",border:0,padding:0,cursor:"pointer",height:"15px",width:"15px",position:"absolute",top:"5px",right:"5px",fontSize:"16px",textAlign:"center",lineHeight:"15px",background:"#CCC"})).attr("aria-label",t("close-label","Close"));}(i,a)},o.trigger(l,t)),c[e];}function w(e,t){return(e.msMatchesSelector||e.webkitMatchesSelector||e.matches).call(e,t);}function S(e){return!(E(e)||w(e,":disabled")||e.hasAttribute("contenteditable"))&&(e.hasAttribute("tabindex")||w(e,"input,select,textarea,button,a[href],area[href],iframe"));}function x(e){for(var t=e.getElementsByTagName("*"),i=0;i<t.length;i++){if(S(t[i]))return t[i];}}return l={modalElem:T(f),closeElem:T(I),overlayElem:T(C),buildDom:b(y.bind(null,null)),isVisible:function isVisible(){return!!(c&&f&&f().isVisible());},show:function show(e){return t.trigger(l,e)&&(C().show(),I(),f().show(),i.trigger(l,e)),this;},close:b(v),forceClose:b(A),destroy:function destroy(){f().destroy(),C().destroy(),C=f=I=void 0;},options:function options(t){Object.keys(t).map(function(e){n[e]=t[e];});},afterCreate:b(o.watch),beforeShow:b(t.watch),afterShow:b(i.watch),beforeClose:b(r.watch),afterClose:b(s.watch)},h=l,d=a.bind(null,"focus",!0),h.beforeShow(function(){e=document.activeElement;}),h.afterShow(function(){var e;!d()||(e=x(h.modalElem()))&&e.focus();}),h.afterClose(function(){d()&&e&&e.focus(),e=null;}),W.watch(function(e){var t,i;d()&&h.isVisible()&&(t=x(h.modalElem()),i=function(e){for(var t=e.getElementsByTagName("*"),i=t.length;i--;){if(S(t[i]))return t[i];}}(h.modalElem()),(e.shiftKey?t:i)===document.activeElement&&((e.shiftKey?i:t).focus(),e.preventDefault()));}),u=l,g=a.bind(null,"bodyOverflow",!0),m=new B(document.body),u.beforeShow(function(){p=m.elem.style.overflow,g()&&m.stylize({overflow:"hidden"});}),u.afterClose(function(){m.stylize({overflow:p});}),G.watch(function(){a("escCloses",!0)&&l.isVisible()&&l.close();}),l;};})?n.apply(t,r):n)||(e.exports=o);}();},function(e,t,i){"use strict";function n(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}i.d(t,"a",function(){return r;});var r=function(){function o(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,o),this.errorTableVisible=e.errorTableVisible,this.onToggleVisibility=e.onToggleVisibility,this.onFocusLine=e.onFocusLine||function(){},this.onChangeHeight=e.onChangeHeight,this.dom={};var t=document.createElement("div");t.className="jsoneditor-validation-errors-container",this.dom.validationErrorsContainer=t;var i=document.createElement("div");i.style.display="none",i.className="jsoneditor-additional-errors fadein",i.innerHTML="Scroll for more &#9663;",this.dom.additionalErrorsIndication=i,t.appendChild(i);var n=document.createElement("span");n.className="jsoneditor-validation-error-icon",n.style.display="none",this.dom.validationErrorIcon=n;var r=document.createElement("span");r.className="jsoneditor-validation-error-count",r.style.display="none",this.dom.validationErrorCount=r,this.dom.parseErrorIndication=document.createElement("span"),this.dom.parseErrorIndication.className="jsoneditor-parse-error-icon",this.dom.parseErrorIndication.style.display="none";}var e,t,i;return e=o,(t=[{key:"getErrorTable",value:function value(){return this.dom.validationErrorsContainer;}},{key:"getErrorCounter",value:function value(){return this.dom.validationErrorCount;}},{key:"getWarningIcon",value:function value(){return this.dom.validationErrorIcon;}},{key:"getErrorIcon",value:function value(){return this.dom.parseErrorIndication;}},{key:"toggleTableVisibility",value:function value(){this.errorTableVisible=!this.errorTableVisible,this.onToggleVisibility(this.errorTableVisible);}},{key:"setErrors",value:function value(e,o){var t,s,i,a=this;this.dom.validationErrors&&(this.dom.validationErrors.parentNode.removeChild(this.dom.validationErrors),this.dom.validationErrors=null,this.dom.additionalErrorsIndication.style.display="none"),this.errorTableVisible&&0<e.length?((t=document.createElement("div")).className="jsoneditor-validation-errors",t.innerHTML='<table class="jsoneditor-text-errors"><tbody></tbody></table>',s=t.getElementsByTagName("tbody")[0],e.forEach(function(t){var e,i,n="string"==typeof t?'<td colspan="2"><pre>'+t+"</pre></td>":"<td>"+(t.dataPath||"")+"</td><td><pre>"+t.message+"</pre></td>";isNaN(t.line)?!t.dataPath||(i=o.find(function(e){return e.path===t.dataPath;}))&&(e=i.line+1):e=t.line;var r=document.createElement("tr");r.className=isNaN(e)?"":"jump-to-line","error"===t.type?r.className+=" parse-error":r.className+=" validation-error",r.innerHTML='<td><button class="jsoneditor-schema-error"></button></td><td style="white-space:nowrap;">'+(isNaN(e)?"":"Ln "+e)+"</td>"+n,r.onclick=function(){a.onFocusLine(e);},s.appendChild(r);}),this.dom.validationErrors=t,this.dom.validationErrorsContainer.appendChild(t),this.dom.additionalErrorsIndication.title=e.length+" errors total",this.dom.validationErrorsContainer.clientHeight<this.dom.validationErrorsContainer.scrollHeight?(this.dom.additionalErrorsIndication.style.display="block",this.dom.validationErrorsContainer.onscroll=function(){a.dom.additionalErrorsIndication.style.display=0<a.dom.validationErrorsContainer.clientHeight&&0===a.dom.validationErrorsContainer.scrollTop?"block":"none";}):this.dom.validationErrorsContainer.onscroll=void 0,i=this.dom.validationErrorsContainer.clientHeight+(this.dom.statusBar?this.dom.statusBar.clientHeight:0),this.onChangeHeight(i)):this.onChangeHeight(0);var n,r=e.filter(function(e){return"error"!==e.type;}).length;0<r?(this.dom.validationErrorCount.style.display="inline",this.dom.validationErrorCount.innerText=r,this.dom.validationErrorCount.onclick=this.toggleTableVisibility.bind(this),this.dom.validationErrorIcon.style.display="inline",this.dom.validationErrorIcon.title=r+" schema validation error(s) found",this.dom.validationErrorIcon.onclick=this.toggleTableVisibility.bind(this)):(this.dom.validationErrorCount.style.display="none",this.dom.validationErrorIcon.style.display="none"),e.some(function(e){return"error"===e.type;})?(n=e[0].line,this.dom.parseErrorIndication.style.display="block",this.dom.parseErrorIndication.title=isNaN(n)?"parse error - check that the json is valid":"parse error on line "+n,this.dom.parseErrorIndication.onclick=this.toggleTableVisibility.bind(this)):this.dom.parseErrorIndication.style.display="none";}}])&&n(e.prototype,t),i&&n(e,i),o;}();},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function get(){return e.l;}}),Object.defineProperty(e,"id",{enumerable:!0,get:function get(){return e.i;}}),e.webpackPolyfill=1),e;};},function(e,t,i){"use strict";var m=i(46),f=i(18),C=i(7),l=i(25),n=i(48);function c(e,t,i){var n=this._refs[i];if("string"==typeof n){if(!this._refs[n])return c.call(this,e,t,n);n=this._refs[n];}if((n=n||this._schemas[i])instanceof l)return u(n.schema,this._opts.inlineRefs)?n.schema:n.validate||this._compile(n);var r,o,s,a=h.call(this,t,i);return a&&(r=a.schema,t=a.root,s=a.baseId),r instanceof l?o=r.validate||e.call(this,r.schema,t,void 0,s):void 0!==r&&(o=u(r,this._opts.inlineRefs)?r:e.call(this,r,t,void 0,s)),o;}function h(e,t){var i=m.parse(t),n=g(i),r=I(this._getId(e.schema));if(0===Object.keys(e.schema).length||n!==r){var o=A(n),s=this._refs[o];if("string"==typeof s)return function(e,t,i){var n=h.call(this,e,t);if(n){var r=n.schema,o=n.baseId;e=n.root;var s=this._getId(r);return s&&(o=p(o,s)),a.call(this,i,o,r,e);}}.call(this,e,s,i);if(s instanceof l)s.validate||this._compile(s),e=s;else{if(!((s=this._schemas[o])instanceof l))return;if(s.validate||this._compile(s),o==A(t))return{schema:s,root:e,baseId:r};e=s;}if(!e.schema)return;r=I(this._getId(e.schema));}return a.call(this,i,r,e.schema,e);}(e.exports=c).normalizeId=A,c.fullPath=I,c.url=p,c.ids=function(e){var t=A(this._getId(e)),d={"":t},u={"":I(t,!1)},g={},p=this;return n(e,{allKeys:!0},function(e,t,i,n,r,o,s){if(""!==t){var a=p._getId(e),l=d[n],c=u[n]+"/"+r;if(void 0!==s&&(c+="/"+("number"==typeof s?s:C.escapeFragment(s))),"string"==typeof a){a=l=A(l?m.resolve(l,a):a);var h=p._refs[a];if("string"==typeof h&&(h=p._refs[h]),h&&h.schema){if(!f(e,h.schema))throw new Error('id "'+a+'" resolves to more than one schema');}else if(a!=A(c))if("#"==a[0]){if(g[a]&&!f(e,g[a]))throw new Error('id "'+a+'" resolves to more than one schema');g[a]=e;}else p._refs[a]=c;}d[t]=l,u[t]=c;}}),g;},c.inlineRef=u,c.schema=h;var d=C.toHash(["properties","patternProperties","enum","dependencies","definitions"]);function a(e,t,i,n){if(e.fragment=e.fragment||"","/"==e.fragment.slice(0,1)){for(var r=e.fragment.split("/"),o=1;o<r.length;o++){var s,a,l,c=r[o];if(c){if(void 0===(i=i[c=C.unescapeFragment(c)]))break;d[c]||((l=this._getId(i))&&(t=p(t,l)),i.$ref&&(s=p(t,i.$ref),(a=h.call(this,n,s))&&(i=a.schema,n=a.root,t=a.baseId)));}}return void 0!==i&&i!==n.schema?{schema:i,root:n,baseId:t}:void 0;}}var s=C.toHash(["type","format","pattern","maxLength","minLength","maxProperties","minProperties","maxItems","minItems","maximum","minimum","uniqueItems","multipleOf","required","enum"]);function u(e,t){return!1!==t&&(void 0===t||!0===t?function e(t){var i;if(Array.isArray(t)){for(var n=0;n<t.length;n++){if("object"==_typeof(i=t[n])&&!e(i))return!1;}}else for(var r in t){if("$ref"==r)return!1;if("object"==_typeof(i=t[r])&&!e(i))return!1;}return!0;}(e):t?function e(t){var i,n=0;if(Array.isArray(t)){for(var r=0;r<t.length;r++){if("object"==_typeof(i=t[r])&&(n+=e(i)),n==1/0)return 1/0;}}else for(var o in t){if("$ref"==o)return 1/0;if(s[o])n++;else if("object"==_typeof(i=t[o])&&(n+=e(i)+1),n==1/0)return 1/0;}return n;}(e)<=t:void 0);}function I(e,t){return!1!==t&&(e=A(e)),g(m.parse(e));}function g(e){return m.serialize(e).split("#")[0]+"#";}var r=/#\/?$/;function A(e){return e?e.replace(r,""):"";}function p(e,t){return t=A(t),m.resolve(e,t);}},function(e,t,i){"use strict";e.exports=function e(t,i){if(t===i)return!0;if(t&&i&&"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&"object"==(typeof i==="undefined"?"undefined":_typeof(i))){if(t.constructor!==i.constructor)return!1;var n,r,o;if(Array.isArray(t)){if((n=t.length)!=i.length)return!1;for(r=n;0!=r--;){if(!e(t[r],i[r]))return!1;}return!0;}if(t.constructor===RegExp)return t.source===i.source&&t.flags===i.flags;if(t.valueOf!==Object.prototype.valueOf)return t.valueOf()===i.valueOf();if(t.toString!==Object.prototype.toString)return t.toString()===i.toString();if((n=(o=Object.keys(t)).length)!==Object.keys(i).length)return!1;for(r=n;0!=r--;){if(!Object.prototype.hasOwnProperty.call(i,o[r]))return!1;}for(r=n;0!=r--;){var s=o[r];if(!e(t[s],i[s]))return!1;}return!0;}return t!=t&&i!=i;};},function(e,t,i){"use strict";var n=i(17);function r(e,t,i){this.message=i||r.message(e,t),this.missingRef=n.url(e,t),this.missingSchema=n.normalizeId(n.fullPath(this.missingRef));}function o(e){return e.prototype=Object.create(Error.prototype),e.prototype.constructor=e;}e.exports={Validation:o(function(e){this.message="validation failed",this.errors=e,this.ajv=this.validation=!0;}),MissingRef:o(r)},r.message=function(e,t){return"can't resolve reference "+t+" from id "+e;};},function(e,t,i){var n;if(window.ace)n=window.ace;else try{n=i(37),i(38),i(39);var r=i(40);n.config.setModuleUrl("ace/mode/json_worker",r);}catch(e){}e.exports=n;},function(e,t,i){"use strict";i.r(t),i.d(t,"textModeMixins",function(){return c;});var n=i(20),k=i.n(n),R=i(1),E=i(8),B=i(15),Z=i(0);var o=i(5),a=i(6),T=i(9),l=i(2),G=i(35),W=i(4);function _(e){return(_="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return typeof e==="undefined"?"undefined":_typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e==="undefined"?"undefined":_typeof(e);})(e);}var r={},H="ace/theme/jsoneditor";function s(){try{this.format();}catch(e){}}r.create=function(e){var t=this,i=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};void 0===i.statusBar&&(i.statusBar=!0),i.mainMenuBar=!1!==i.mainMenuBar,i.enableSort=!1!==i.enableSort,i.enableTransform=!1!==i.enableTransform,i.createQuery=i.createQuery||W.a,i.executeQuery=i.executeQuery||W.b,"number"==typeof(this.options=i).indentation?this.indentation=Number(i.indentation):this.indentation=2,Object(R.b)(this.options.languages),Object(R.a)(this.options.language);var n=i.ace?i.ace:k.a;this.mode="code"===i.mode?"code":"text","code"===this.mode&&void 0===n&&(this.mode="text",console.warn("Failed to load Ace editor, falling back to plain text mode. Please use a JSONEditor bundle including Ace, or pass Ace as via the configuration option `ace`.")),this.theme=i.theme||H,this.theme===H&&n&&Object(G.tryRequireThemeJsonEditor)(),i.onTextSelectionChange&&this.onTextSelectionChange(i.onTextSelectionChange);var r=this;this.container=e,this.dom={},this.aceEditor=void 0,this.textarea=void 0,this.validateSchema=null,this.annotations=[],this.lastSchemaErrors=void 0,this._debouncedValidate=Object(Z.debounce)(this.validate.bind(this),this.DEBOUNCE_INTERVAL),this.width=e.clientWidth,this.height=e.clientHeight,this.frame=document.createElement("div"),this.frame.className="jsoneditor jsoneditor-mode-"+this.options.mode,this.frame.onclick=function(e){e.preventDefault();},this.frame.onkeydown=function(e){r._onKeyDown(e);};var o,s,a,l,c,h,d,u,g={target:this.frame,onFocus:this.options.onFocus||null,onBlur:this.options.onBlur||null};this.frameFocusTracker=new T.a(g),this.content=document.createElement("div"),this.content.className="jsoneditor-outer",this.options.mainMenuBar&&(Object(Z.addClassName)(this.content,"has-main-menu-bar"),this.menu=document.createElement("div"),this.menu.className="jsoneditor-menu",this.frame.appendChild(this.menu),(o=document.createElement("button")).type="button",o.className="jsoneditor-format",o.title=Object(R.c)("formatTitle"),this.menu.appendChild(o),o.onclick=function(){try{r.format(),r._onChange();}catch(e){r._onError(e);}},(s=document.createElement("button")).type="button",s.className="jsoneditor-compact",s.title=Object(R.c)("compactTitle"),this.menu.appendChild(s),s.onclick=function(){try{r.compact(),r._onChange();}catch(e){r._onError(e);}},this.options.enableSort&&((a=document.createElement("button")).type="button",a.className="jsoneditor-sort",a.title=Object(R.c)("sortTitleShort"),a.onclick=function(){r._showSortModal();},this.menu.appendChild(a)),this.options.enableTransform&&((l=document.createElement("button")).type="button",l.title=Object(R.c)("transformTitleShort"),l.className="jsoneditor-transform",l.onclick=function(){r._showTransformModal();},this.menu.appendChild(l)),(c=document.createElement("button")).type="button",c.className="jsoneditor-repair",c.title=Object(R.c)("repairTitle"),this.menu.appendChild(c),c.onclick=function(){try{r.repair(),r._onChange();}catch(e){r._onError(e);}},"code"===this.mode&&((h=document.createElement("button")).type="button",h.className="jsoneditor-undo jsoneditor-separator",h.title=Object(R.c)("undo"),h.onclick=function(){t.aceEditor.getSession().getUndoManager().undo();},this.menu.appendChild(h),this.dom.undo=h,(d=document.createElement("button")).type="button",d.className="jsoneditor-redo",d.title=Object(R.c)("redo"),d.onclick=function(){t.aceEditor.getSession().getUndoManager().redo();},this.menu.appendChild(d),this.dom.redo=d),this.options&&this.options.modes&&this.options.modes.length&&(this.modeSwitcher=new E.a(this.menu,this.options.modes,this.options.mode,function(e){r.setMode(e),r.modeSwitcher.focus();})),"code"===this.mode&&((u=document.createElement("a")).appendChild(document.createTextNode("powered by ace")),u.href="http://ace.ajax.org",u.target="_blank",u.className="jsoneditor-poweredBy",u.onclick=function(){window.open(u.href,u.target);},this.menu.appendChild(u)));var p,m,f,C,I,A,v,b,y,w,S,x=this.options.onEditable&&_("function"===this.options.onEditable)&&!this.options.onEditable({});this.frame.appendChild(this.content),this.container.appendChild(this.frame),"code"===this.mode?(this.editorDom=document.createElement("div"),this.editorDom.style.height="100%",this.editorDom.style.width="100%",this.content.appendChild(this.editorDom),m=(p=n.edit(this.editorDom)).getSession(),p.$blockScrolling=1/0,p.setTheme(this.theme),p.setOptions({readOnly:x}),p.setShowPrintMargin(!1),p.setFontSize("13px"),m.setMode("ace/mode/json"),m.setTabSize(this.indentation),m.setUseSoftTabs(!0),m.setUseWrapMode(!0),f=m.setAnnotations,m.setAnnotations=function(e){f.call(this,e&&e.length?e:r.annotations);},p.commands.bindKey("Ctrl-L",null),p.commands.bindKey("Command-L",null),(this.aceEditor=p).on("change",this._onChange.bind(this)),p.on("changeSelection",this._onSelect.bind(this))):((C=document.createElement("textarea")).className="jsoneditor-text",C.spellcheck=!1,this.content.appendChild(C),this.textarea=C,this.textarea.readOnly=x,null===this.textarea.oninput?this.textarea.oninput=this._onChange.bind(this):this.textarea.onchange=this._onChange.bind(this),C.onselect=this._onSelect.bind(this),C.onmousedown=this._onMouseDown.bind(this),C.onblur=this._onBlur.bind(this)),this._updateHistoryButtons(),this.errorTable=new B.a({errorTableVisible:"text"===this.mode,onToggleVisibility:function onToggleVisibility(){r.validate();},onFocusLine:function onFocusLine(e){r.isFocused=!0,isNaN(e)||r.setTextSelection({row:e,column:1},{row:e,column:1e3});},onChangeHeight:function onChangeHeight(e){var t=e+(r.dom.statusBar?r.dom.statusBar.clientHeight:0)+1;r.content.style.marginBottom=-t+"px",r.content.style.paddingBottom=t+"px";}}),this.frame.appendChild(this.errorTable.getErrorTable()),i.statusBar&&(Object(Z.addClassName)(this.content,"has-status-bar"),this.curserInfoElements={},I=document.createElement("div"),(this.dom.statusBar=I).className="jsoneditor-statusbar",this.frame.appendChild(I),(A=document.createElement("span")).className="jsoneditor-curserinfo-label",A.innerText="Ln:",(v=document.createElement("span")).className="jsoneditor-curserinfo-val",v.innerText="1",I.appendChild(A),I.appendChild(v),(b=document.createElement("span")).className="jsoneditor-curserinfo-label",b.innerText="Col:",(y=document.createElement("span")).className="jsoneditor-curserinfo-val",y.innerText="1",I.appendChild(b),I.appendChild(y),this.curserInfoElements.colVal=y,this.curserInfoElements.lnVal=v,(w=document.createElement("span")).className="jsoneditor-curserinfo-label",w.innerText="characters selected",w.style.display="none",(S=document.createElement("span")).className="jsoneditor-curserinfo-count",S.innerText="0",S.style.display="none",this.curserInfoElements.countLabel=w,this.curserInfoElements.countVal=S,I.appendChild(S),I.appendChild(w),I.appendChild(this.errorTable.getErrorCounter()),I.appendChild(this.errorTable.getWarningIcon()),I.appendChild(this.errorTable.getErrorIcon())),this.setSchema(this.options.schema,this.options.schemaRefs);},r._onChange=function(){var e=this;if(!this.onChangeDisabled){if(setTimeout(function(){return e._updateHistoryButtons();}),this._debouncedValidate(),this.options.onChange)try{this.options.onChange();}catch(e){console.error("Error in onChange callback: ",e);}if(this.options.onChangeText)try{this.options.onChangeText(this.getText());}catch(e){console.error("Error in onChangeText callback: ",e);}}},r._updateHistoryButtons=function(){var e;this.aceEditor&&this.dom.undo&&this.dom.redo&&(e=this.aceEditor.getSession().getUndoManager())&&e.hasUndo&&e.hasRedo&&(this.dom.undo.disabled=!e.hasUndo(),this.dom.redo.disabled=!e.hasRedo());},r._showSortModal=function(){var n=this,e=this.options.modalAnchor||l.a,r=this.get();Object(o.showSortModal)(e,r,function(e){var t,i;Array.isArray(r)&&(t=Object(Z.sort)(r,e.path,e.direction),n.sortedBy=e,n.update(t)),Object(Z.isObject)(r)&&(i=Object(Z.sortObjectKeys)(r,e.direction),n.sortedBy=e,n.update(i));},n.sortedBy);},r._showTransformModal=function(){var i=this,e=this.options,t=e.modalAnchor,n=e.createQuery,r=e.executeQuery,o=e.queryDescription,s=this.get();Object(a.showTransformModal)({anchor:t||l.a,json:s,queryDescription:o,createQuery:n,executeQuery:r,onTransform:function onTransform(e){var t=r(s,e);i.update(t);}});},r._onSelect=function(){this._updateCursorInfo(),this._emitSelectionChange();},r._onKeyDown=function(e){var t=!1;220===(e.which||e.keyCode)&&e.ctrlKey&&(e.shiftKey?this.compact():this.format(),this._onChange(),t=!0),t&&(e.preventDefault(),e.stopPropagation()),this._updateCursorInfo(),this._emitSelectionChange();},r._onMouseDown=function(){this._updateCursorInfo(),this._emitSelectionChange();},r._onBlur=function(){var e=this;setTimeout(function(){e.isFocused||(e._updateCursorInfo(),e._emitSelectionChange()),e.isFocused=!1;});},r._updateCursorInfo=function(){var e,t,i,n,r,o=this;function s(){o.curserInfoElements.countVal.innerText!==r&&(o.curserInfoElements.countVal.innerText=r,o.curserInfoElements.countVal.style.display=r?"inline":"none",o.curserInfoElements.countLabel.style.display=r?"inline":"none"),o.curserInfoElements.lnVal.innerText=i,o.curserInfoElements.colVal.innerText=n;}this.textarea?setTimeout(function(){var e=Object(Z.getInputSelection)(o.textarea);e.startIndex!==e.endIndex&&(r=e.endIndex-e.startIndex),n=r&&o.cursorInfo&&o.cursorInfo.line===e.end.row&&o.cursorInfo.column===e.end.column?(i=e.start.row,e.start.column):(i=e.end.row,e.end.column),o.cursorInfo={line:i,column:n,count:r},o.options.statusBar&&s();},0):this.aceEditor&&this.curserInfoElements&&(e=this.aceEditor.getCursorPosition(),t=this.aceEditor.getSelectedText(),i=e.row+1,n=e.column+1,r=t.length,o.cursorInfo={line:i,column:n,count:r},this.options.statusBar&&s());},r._emitSelectionChange=function(){var e;this._selectionChangedHandler&&(e=this.getTextSelection(),this._selectionChangedHandler(e.start,e.end,e.text));},r._refreshAnnotations=function(){var e,t=this.aceEditor&&this.aceEditor.getSession();t&&(e=t.getAnnotations().filter(function(e){return"error"===e.type;}),t.setAnnotations(e));},r.destroy=function(){this.aceEditor&&(this.aceEditor.destroy(),this.aceEditor=null),this.frame&&this.container&&this.frame.parentNode===this.container&&this.container.removeChild(this.frame),this.modeSwitcher&&(this.modeSwitcher.destroy(),this.modeSwitcher=null),this.textarea=null,this._debouncedValidate=null,this.frameFocusTracker.destroy();},r.compact=function(){var e=this.get(),t=JSON.stringify(e);this.updateText(t);},r.format=function(){var e=this.get(),t=JSON.stringify(e,null,this.indentation);this.updateText(t);},r.repair=function(){var e=this.getText(),t=Object(Z.repair)(e);this.updateText(t);},r.focus=function(){this.textarea&&this.textarea.focus(),this.aceEditor&&this.aceEditor.focus();},r.resize=function(){this.aceEditor&&this.aceEditor.resize(!1);},r.set=function(e){this.setText(JSON.stringify(e,null,this.indentation));},r.update=function(e){this.updateText(JSON.stringify(e,null,this.indentation));},r.get=function(){var e=this.getText();return Object(Z.parse)(e);},r.getText=function(){return this.textarea?this.textarea.value:this.aceEditor?this.aceEditor.getValue():"";},r._setText=function(e,t){var i,n=this,r=!0===this.options.escapeUnicode?Object(Z.escapeUnicodeChars)(e):e;this.textarea&&(this.textarea.value=r),this.aceEditor&&(this.onChangeDisabled=!0,this.aceEditor.setValue(r,-1),this.onChangeDisabled=!1,t&&(i=this,setTimeout(function(){i.aceEditor&&i.aceEditor.session.getUndoManager().reset();})),setTimeout(function(){return n._updateHistoryButtons();})),this._debouncedValidate();},r.setText=function(e){this._setText(e,!0);},r.updateText=function(e){this.getText()!==e&&this._setText(e,!1);},r.validate=function(){var t,i,n=this,r=[],o=[];try{var e=this.get();this.validateSchema&&(this.validateSchema(e)||(r=this.validateSchema.errors.map(function(e){return e.type="validation",Object(Z.improveSchemaError)(e);}))),this.validationSequence=(this.validationSequence||0)+1;var s=this,a=this.validationSequence;(function(e,t){if(!t)return Promise.resolve([]);try{var i=t(e);return(Object(Z.isPromise)(i)?i:Promise.resolve(i)).then(function(e){return Array.isArray(e)?e.filter(function(e){var t=Object(Z.isValidValidationError)(e);return t||console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:',e),t;}).map(function(e){return{dataPath:Object(Z.stringifyPath)(e.path),message:e.message,type:"customValidation"};}):[];});}catch(e){return Promise.reject(e);}})(e,this.options.onValidate).then(function(e){var t;a===s.validationSequence&&(t=r.concat(o).concat(e),s._renderErrors(t),"function"==typeof n.options.onValidationError&&(Object(Z.isValidationErrorChanged)(t,n.lastSchemaErrors)&&n.options.onValidationError.call(n,t),n.lastSchemaErrors=t));}).catch(function(e){console.error("Custom validation function did throw an error",e);});}catch(e){this.getText()&&((t=/\w*line\s*(\d+)\w*/g.exec(e.message))&&(i=+t[1]),o=[{type:"error",message:e.message.replace(/\n/g,"<br>"),line:i}]),this._renderErrors(o),"function"==typeof this.options.onValidationError&&(Object(Z.isValidationErrorChanged)(o,this.lastSchemaErrors)&&this.options.onValidationError.call(this,o),this.lastSchemaErrors=o);}},r._renderErrors=function(n){var e=this.getText(),t=[];n.reduce(function(e,t){return"string"==typeof t.dataPath&&-1===e.indexOf(t.dataPath)&&e.push(t.dataPath),e;},t);var i=Object(Z.getPositionForPath)(e,t);this.aceEditor&&(this.annotations=i.map(function(t){var e=n.filter(function(e){return e.dataPath===t.path;}),i=e.map(function(e){return e.message;}).join("\n");return i?{row:t.line,column:t.column,text:"Schema validation error"+(1!==e.length?"s":"")+": \n"+i,type:"warning",source:"jsoneditor"}:{};}),this._refreshAnnotations()),this.errorTable.setErrors(n,i),this.aceEditor&&this.aceEditor.resize(!1);},r.getTextSelection=function(){var e={};if(this.textarea){var t=Object(Z.getInputSelection)(this.textarea);return this.cursorInfo&&this.cursorInfo.line===t.end.row&&this.cursorInfo.column===t.end.column?(e.start=t.end,e.end=t.start):e=t,{start:e.start,end:e.end,text:this.textarea.value.substring(t.startIndex,t.endIndex)};}if(this.aceEditor){var i=this.aceEditor.getSelection(),n=this.aceEditor.getSelectedText(),r=i.getRange(),o=i.getSelectionLead();return o.row===r.end.row&&o.column===r.end.column?e=r:(e.start=r.end,e.end=r.start),{start:{row:e.start.row+1,column:e.start.column+1},end:{row:e.end.row+1,column:e.end.column+1},text:n};}},r.onTextSelectionChange=function(e){"function"==typeof e&&(this._selectionChangedHandler=Object(Z.debounce)(e,this.DEBOUNCE_INTERVAL));},r.setTextSelection=function(e,t){var i,n,r,o,s,a,l;e&&t&&(this.textarea?(i=Object(Z.getIndexForPosition)(this.textarea,e.row,e.column),n=Object(Z.getIndexForPosition)(this.textarea,t.row,t.column),-1<i&&-1<n&&(this.textarea.setSelectionRange?(this.textarea.focus(),this.textarea.setSelectionRange(i,n)):this.textarea.createTextRange&&((r=this.textarea.createTextRange()).collapse(!0),r.moveEnd("character",n),r.moveStart("character",i),r.select()),o=(this.textarea.value.match(/\n/g)||[]).length+1,s=this.textarea.scrollHeight/o,a=e.row*s,this.textarea.scrollTop=a>this.textarea.clientHeight?a-this.textarea.clientHeight/2:0)):this.aceEditor&&(l={start:{row:e.row-1,column:e.column-1},end:{row:t.row-1,column:t.column-1}},this.aceEditor.selection.setRange(l),this.aceEditor.scrollToLine(e.row-1,!0)));};var c=[{mode:"text",mixin:r,data:"text",load:s},{mode:"code",mixin:r,data:"text",load:s}];},function(e,t,i){var n,r=((n={trace:function trace(){},yy:{},symbols_:{error:2,JSONString:3,STRING:4,JSONNumber:5,NUMBER:6,JSONNullLiteral:7,NULL:8,JSONBooleanLiteral:9,TRUE:10,FALSE:11,JSONText:12,JSONValue:13,EOF:14,JSONObject:15,JSONArray:16,"{":17,"}":18,JSONMemberList:19,JSONMember:20,":":21,",":22,"[":23,"]":24,JSONElementList:25,$accept:0,$end:1},terminals_:{2:"error",4:"STRING",6:"NUMBER",8:"NULL",10:"TRUE",11:"FALSE",14:"EOF",17:"{",18:"}",21:":",22:",",23:"[",24:"]"},productions_:[0,[3,1],[5,1],[7,1],[9,1],[9,1],[12,2],[13,1],[13,1],[13,1],[13,1],[13,1],[13,1],[15,2],[15,3],[20,3],[19,1],[19,3],[16,2],[16,3],[25,1],[25,3]],performAction:function performAction(e,t,i,n,r,o){var s=o.length-1;switch(r){case 1:this.$=e.replace(/\\(\\|")/g,"$1").replace(/\\n/g,"\n").replace(/\\r/g,"\r").replace(/\\t/g,"\t").replace(/\\v/g,"\v").replace(/\\f/g,"\f").replace(/\\b/g,"\b");break;case 2:this.$=Number(e);break;case 3:this.$=null;break;case 4:this.$=!0;break;case 5:this.$=!1;break;case 6:return this.$=o[s-1];case 13:this.$={};break;case 14:this.$=o[s-1];break;case 15:this.$=[o[s-2],o[s]];break;case 16:this.$={},this.$[o[s][0]]=o[s][1];break;case 17:this.$=o[s-2],o[s-2][o[s][0]]=o[s][1];break;case 18:this.$=[];break;case 19:this.$=o[s-1];break;case 20:this.$=[o[s]];break;case 21:this.$=o[s-2],o[s-2].push(o[s]);}},table:[{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],12:1,13:2,15:7,16:8,17:[1,14],23:[1,15]},{1:[3]},{14:[1,16]},{14:[2,7],18:[2,7],22:[2,7],24:[2,7]},{14:[2,8],18:[2,8],22:[2,8],24:[2,8]},{14:[2,9],18:[2,9],22:[2,9],24:[2,9]},{14:[2,10],18:[2,10],22:[2,10],24:[2,10]},{14:[2,11],18:[2,11],22:[2,11],24:[2,11]},{14:[2,12],18:[2,12],22:[2,12],24:[2,12]},{14:[2,3],18:[2,3],22:[2,3],24:[2,3]},{14:[2,4],18:[2,4],22:[2,4],24:[2,4]},{14:[2,5],18:[2,5],22:[2,5],24:[2,5]},{14:[2,1],18:[2,1],21:[2,1],22:[2,1],24:[2,1]},{14:[2,2],18:[2,2],22:[2,2],24:[2,2]},{3:20,4:[1,12],18:[1,17],19:18,20:19},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:23,15:7,16:8,17:[1,14],23:[1,15],24:[1,21],25:22},{1:[2,6]},{14:[2,13],18:[2,13],22:[2,13],24:[2,13]},{18:[1,24],22:[1,25]},{18:[2,16],22:[2,16]},{21:[1,26]},{14:[2,18],18:[2,18],22:[2,18],24:[2,18]},{22:[1,28],24:[1,27]},{22:[2,20],24:[2,20]},{14:[2,14],18:[2,14],22:[2,14],24:[2,14]},{3:20,4:[1,12],20:29},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:30,15:7,16:8,17:[1,14],23:[1,15]},{14:[2,19],18:[2,19],22:[2,19],24:[2,19]},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:31,15:7,16:8,17:[1,14],23:[1,15]},{18:[2,17],22:[2,17]},{18:[2,15],22:[2,15]},{22:[2,21],24:[2,21]}],defaultActions:{16:[2,6]},parseError:function parseError(e){throw new Error(e);},parse:function parse(e){var t=this,i=[0],n=[null],r=[],o=this.table,s="",a=0,l=0,c=0;this.lexer.setInput(e),this.lexer.yy=this.yy,this.yy.lexer=this.lexer,void 0===this.lexer.yylloc&&(this.lexer.yylloc={});var h=this.lexer.yylloc;function d(){var e=t.lexer.lex()||1;return"number"!=typeof e&&(e=t.symbols_[e]||e),e;}r.push(h),"function"==typeof this.yy.parseError&&(this.parseError=this.yy.parseError);for(var u,g,p,m,f,C,I,A,v,b,y={};;){if(p=i[i.length-1],void 0===(m=this.defaultActions[p]?this.defaultActions[p]:(null==u&&(u=d()),o[p]&&o[p][u]))||!m.length||!m[0]){if(!c){for(C in v=[],o[p]){this.terminals_[C]&&2<C&&v.push("'"+this.terminals_[C]+"'");}var w="",w=this.lexer.showPosition?"Parse error on line "+(a+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+v.join(", ")+", got '"+this.terminals_[u]+"'":"Parse error on line "+(a+1)+": Unexpected "+(1==u?"end of input":"'"+(this.terminals_[u]||u)+"'");this.parseError(w,{text:this.lexer.match,token:this.terminals_[u]||u,line:this.lexer.yylineno,loc:h,expected:v});}if(3==c){if(1==u)throw new Error(w||"Parsing halted.");l=this.lexer.yyleng,s=this.lexer.yytext,a=this.lexer.yylineno,h=this.lexer.yylloc,u=d();}for(;!(2..toString()in o[p]);){if(0==p)throw new Error(w||"Parsing halted.");b=1,i.length=i.length-2*b,n.length=n.length-b,r.length=r.length-b,p=i[i.length-1];}g=u,u=2,m=o[p=i[i.length-1]]&&o[p][2],c=3;}if(m[0]instanceof Array&&1<m.length)throw new Error("Parse Error: multiple actions possible at state: "+p+", token: "+u);switch(m[0]){case 1:i.push(u),n.push(this.lexer.yytext),r.push(this.lexer.yylloc),i.push(m[1]),u=null,g?(u=g,g=null):(l=this.lexer.yyleng,s=this.lexer.yytext,a=this.lexer.yylineno,h=this.lexer.yylloc,0<c&&c--);break;case 2:if(I=this.productions_[m[1]][1],y.$=n[n.length-I],y._$={first_line:r[r.length-(I||1)].first_line,last_line:r[r.length-1].last_line,first_column:r[r.length-(I||1)].first_column,last_column:r[r.length-1].last_column},void 0!==(f=this.performAction.call(y,s,l,a,this.yy,m[1],n,r)))return f;I&&(i=i.slice(0,-1*I*2),n=n.slice(0,-1*I),r=r.slice(0,-1*I)),i.push(this.productions_[m[1]][0]),n.push(y.$),r.push(y._$),A=o[i[i.length-2]][i[i.length-1]],i.push(A);break;case 3:return!0;}}return!0;}}).lexer={EOF:1,parseError:function parseError(e,t){if(!this.yy.parseError)throw new Error(e);this.yy.parseError(e,t);},setInput:function setInput(e){return this._input=e,this._more=this._less=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match="",this.conditionStack=["INITIAL"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this;},input:function input(){var e=this._input[0];return this.yytext+=e,this.yyleng++,this.match+=e,this.matched+=e,e.match(/\n/)&&this.yylineno++,this._input=this._input.slice(1),e;},unput:function unput(e){return this._input=e+this._input,this;},more:function more(){return this._more=!0,this;},less:function less(e){this._input=this.match.slice(e)+this._input;},pastInput:function pastInput(){var e=this.matched.substr(0,this.matched.length-this.match.length);return(20<e.length?"...":"")+e.substr(-20).replace(/\n/g,"");},upcomingInput:function upcomingInput(){var e=this.match;return e.length<20&&(e+=this._input.substr(0,20-e.length)),(e.substr(0,20)+(20<e.length?"...":"")).replace(/\n/g,"");},showPosition:function showPosition(){var e=this.pastInput(),t=new Array(e.length+1).join("-");return e+this.upcomingInput()+"\n"+t+"^";},next:function next(){if(this.done)return this.EOF;var e,t,i,n,r;this._input||(this.done=!0),this._more||(this.yytext="",this.match="");for(var o=this._currentRules(),s=0;s<o.length&&(!(i=this._input.match(this.rules[o[s]]))||t&&!(i[0].length>t[0].length)||(t=i,n=s,this.options.flex));s++){}return t?((r=t[0].match(/\n.*/g))&&(this.yylineno+=r.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:r?r[r.length-1].length-1:this.yylloc.last_column+t[0].length},this.yytext+=t[0],this.match+=t[0],this.yyleng=this.yytext.length,this._more=!1,this._input=this._input.slice(t[0].length),this.matched+=t[0],e=this.performAction.call(this,this.yy,this,o[n],this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),e||void 0):""===this._input?this.EOF:void this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno});},lex:function lex(){var e=this.next();return void 0!==e?e:this.lex();},begin:function begin(e){this.conditionStack.push(e);},popState:function popState(){return this.conditionStack.pop();},_currentRules:function _currentRules(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;},topState:function topState(){return this.conditionStack[this.conditionStack.length-2];},pushState:function pushState(e){this.begin(e);},options:{},performAction:function performAction(e,t,i){switch(i){case 0:break;case 1:return 6;case 2:return t.yytext=t.yytext.substr(1,t.yyleng-2),4;case 3:return 17;case 4:return 18;case 5:return 23;case 6:return 24;case 7:return 22;case 8:return 21;case 9:return 10;case 10:return 11;case 11:return 8;case 12:return 14;case 13:return"INVALID";}},rules:[/^(?:\s+)/,/^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,/^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,/^(?:\{)/,/^(?:\})/,/^(?:\[)/,/^(?:\])/,/^(?:,)/,/^(?::)/,/^(?:true\b)/,/^(?:false\b)/,/^(?:null\b)/,/^(?:$)/,/^(?:.)/],conditions:{INITIAL:{rules:[0,1,2,3,4,5,6,7,8,9,10,11,12,13],inclusive:!0}}},n);t.parser=r,t.parse=r.parse.bind(r);},function(e,t){e.exports=function(){throw new Error("define cannot be used indirect");};},function(e,t){function i(e){"remove"in e||Object.defineProperty(e,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function value(){void 0!==this.parentNode&&this.parentNode.removeChild(this);}});}"undefined"!=typeof Element&&(void 0!==window.Element&&i(window.Element.prototype),void 0!==window.CharacterData&&i(window.CharacterData.prototype),void 0!==window.DocumentType&&i(window.DocumentType.prototype)),Array.prototype.findIndex||(Array.prototype.findIndex=function(e){for(var t=0;t<this.length;t++){var i=this[t];if(e.call(this,i,t,this))return t;}return-1;}),Array.prototype.find||(Array.prototype.find=function(e){var t=this.findIndex(e);return this[t];}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"");});},function(e,t,i){"use strict";var n=i(7);e.exports=function(e){n.copy(e,this);};},function(e,t,i){"use strict";e.exports=function(e,t){"function"==typeof(t=t||{})&&(t={cmp:t});var o,l="boolean"==typeof t.cycles&&t.cycles,c=t.cmp&&(o=t.cmp,function(r){return function(e,t){var i={key:e,value:r[e]},n={key:t,value:r[t]};return o(i,n);};}),h=[];return function e(t){if(t&&t.toJSON&&"function"==typeof t.toJSON&&(t=t.toJSON()),void 0!==t){if("number"==typeof t)return isFinite(t)?""+t:"null";if("object"!=(typeof t==="undefined"?"undefined":_typeof(t)))return JSON.stringify(t);if(Array.isArray(t)){for(r="[",o=0;o<t.length;o++){o&&(r+=","),r+=e(t[o])||"null";}return r+"]";}if(null===t)return"null";if(-1!==h.indexOf(t)){if(l)return JSON.stringify("__cycle__");throw new TypeError("Converting circular structure to JSON");}for(var i=h.push(t)-1,n=Object.keys(t).sort(c&&c(t)),r="",o=0;o<n.length;o++){var s=n[o],a=e(t[s]);a&&(r&&(r+=","),r+=JSON.stringify(s)+":"+a);}return h.splice(i,1),"{"+r+"}";}}(e);};},function(e,t,i){"use strict";e.exports=function(n,e){var t="",i=!0===n.schema.$async,r=n.util.schemaHasRulesExcept(n.schema,n.RULES.all,"$ref"),o=n.self._getId(n.schema);if(n.opts.strictKeywords){var s=n.util.schemaUnknownRules(n.schema,n.RULES.keywords);if(s){var a="unknown keyword: "+s;if("log"!==n.opts.strictKeywords)throw new Error(a);n.logger.warn(a);}}if(n.isTop&&(t+=" var validate = ",i&&(n.async=!0,t+="async "),t+="function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ",o&&(n.opts.sourceCode||n.opts.processCode)&&(t+=" /*# sourceURL="+o+" */ ")),"boolean"==typeof n.schema||!r&&!n.schema.$ref){var e="false schema",l=n.level,c=n.dataLevel,h=n.schema[e],d=n.schemaPath+n.util.getProperty(e),u=n.errSchemaPath+"/"+e,g=!n.opts.allErrors,p="data"+(c||""),m="valid"+l;return!1===n.schema?(n.isTop?g=!0:t+=" var "+m+" = false; ",(j=j||[]).push(t),t="",!1!==n.createErrors?(t+=" { keyword: 'false schema' , dataPath: (dataPath || '') + "+n.errorPath+" , schemaPath: "+n.util.toQuotedString(u)+" , params: {} ",!1!==n.opts.messages&&(t+=" , message: 'boolean schema is false' "),n.opts.verbose&&(t+=" , schema: false , parentSchema: validate.schema"+n.schemaPath+" , data: "+p+" "),t+=" } "):t+=" {} ",G=t,t=j.pop(),!n.compositeRule&&g?n.async?t+=" throw new ValidationError(["+G+"]); ":t+=" validate.errors = ["+G+"]; return false; ":t+=" var err = "+G+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; "):n.isTop?t+=i?" return data; ":" validate.errors = null; return true; ":t+=" var "+m+" = true; ",n.isTop&&(t+=" }; return validate; "),t;}if(n.isTop){var f=n.isTop,l=n.level=0,c=n.dataLevel=0,p="data";if(n.rootId=n.resolve.fullPath(n.self._getId(n.root.schema)),n.baseId=n.baseId||n.rootId,delete n.isTop,n.dataPathArr=[void 0],void 0!==n.schema.default&&n.opts.useDefaults&&n.opts.strictDefaults){var C="default is ignored in the schema root";if("log"!==n.opts.strictDefaults)throw new Error(C);n.logger.warn(C);}t+=" var vErrors = null; ",t+=" var errors = 0;     ",t+=" if (rootData === undefined) rootData = data; ";}else{l=n.level,p="data"+((c=n.dataLevel)||"");if(o&&(n.baseId=n.resolve.url(n.baseId,o)),i&&!n.async)throw new Error("async schema in sync schema");t+=" var errs_"+l+" = errors;";}var I,m="valid"+l,g=!n.opts.allErrors,A="",v="",b=n.schema.type,y=Array.isArray(b);if(b&&n.opts.nullable&&!0===n.schema.nullable&&(y?-1==b.indexOf("null")&&(b=b.concat("null")):"null"!=b&&(b=[b,"null"],y=!0)),y&&1==b.length&&(b=b[0],y=!1),n.schema.$ref&&r){if("fail"==n.opts.extendRefs)throw new Error('$ref: validation keywords used in schema at path "'+n.errSchemaPath+'" (see option extendRefs)');!0!==n.opts.extendRefs&&(r=!1,n.logger.warn('$ref: keywords ignored in schema at path "'+n.errSchemaPath+'"'));}if(n.schema.$comment&&n.opts.$comment&&(t+=" "+n.RULES.all.$comment.code(n,"$comment")),b){n.opts.coerceTypes&&(I=n.util.coerceToTypes(n.opts.coerceTypes,b));var w=n.RULES.types[b];if(I||y||!0===w||w&&!U(w)){var d=n.schemaPath+".type",u=n.errSchemaPath+"/type",d=n.schemaPath+".type",u=n.errSchemaPath+"/type",S=y?"checkDataTypes":"checkDataType";if(t+=" if ("+n.util[S](b,p,!0)+") { ",I){var x="dataType"+l,k="coerced"+l;t+=" var "+x+" = typeof "+p+"; ","array"==n.opts.coerceTypes&&(t+=" if ("+x+" == 'object' && Array.isArray("+p+")) "+x+" = 'array'; "),t+=" var "+k+" = undefined; ";var R="",E=I;if(E)for(var B,Z=-1,T=E.length-1;Z<T;){B=E[Z+=1],Z&&(t+=" if ("+k+" === undefined) { ",R+="}"),"array"==n.opts.coerceTypes&&"array"!=B&&(t+=" if ("+x+" == 'array' && "+p+".length == 1) { "+k+" = "+p+" = "+p+"[0]; "+x+" = typeof "+p+";  } "),"string"==B?t+=" if ("+x+" == 'number' || "+x+" == 'boolean') "+k+" = '' + "+p+"; else if ("+p+" === null) "+k+" = ''; ":"number"==B||"integer"==B?(t+=" if ("+x+" == 'boolean' || "+p+" === null || ("+x+" == 'string' && "+p+" && "+p+" == +"+p+" ","integer"==B&&(t+=" && !("+p+" % 1)"),t+=")) "+k+" = +"+p+"; "):"boolean"==B?t+=" if ("+p+" === 'false' || "+p+" === 0 || "+p+" === null) "+k+" = false; else if ("+p+" === 'true' || "+p+" === 1) "+k+" = true; ":"null"==B?t+=" if ("+p+" === '' || "+p+" === 0 || "+p+" === false) "+k+" = null; ":"array"==n.opts.coerceTypes&&"array"==B&&(t+=" if ("+x+" == 'string' || "+x+" == 'number' || "+x+" == 'boolean' || "+p+" == null) "+k+" = ["+p+"]; ");}(j=j||[]).push(t+=" "+R+" if ("+k+" === undefined) {   "),t="",!1!==n.createErrors?(t+=" { keyword: 'type' , dataPath: (dataPath || '') + "+n.errorPath+" , schemaPath: "+n.util.toQuotedString(u)+" , params: { type: '",t+=y?""+b.join(","):""+b,t+="' } ",!1!==n.opts.messages&&(t+=" , message: 'should be ",t+=y?""+b.join(","):""+b,t+="' "),n.opts.verbose&&(t+=" , schema: validate.schema"+d+" , parentSchema: validate.schema"+n.schemaPath+" , data: "+p+" "),t+=" } "):t+=" {} ";var G=t;t=j.pop(),!n.compositeRule&&g?n.async?t+=" throw new ValidationError(["+G+"]); ":t+=" validate.errors = ["+G+"]; return false; ":t+=" var err = "+G+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",t+=" } else {  ";var W=c?"data"+(c-1||""):"parentData";t+=" "+p+" = "+k+"; ",c||(t+="if ("+W+" !== undefined)"),t+=" "+W+"["+(c?n.dataPathArr[c]:"parentDataProperty")+"] = "+k+"; } ";}else{(j=j||[]).push(t),t="",!1!==n.createErrors?(t+=" { keyword: 'type' , dataPath: (dataPath || '') + "+n.errorPath+" , schemaPath: "+n.util.toQuotedString(u)+" , params: { type: '",t+=y?""+b.join(","):""+b,t+="' } ",!1!==n.opts.messages&&(t+=" , message: 'should be ",t+=y?""+b.join(","):""+b,t+="' "),n.opts.verbose&&(t+=" , schema: validate.schema"+d+" , parentSchema: validate.schema"+n.schemaPath+" , data: "+p+" "),t+=" } "):t+=" {} ";G=t;t=j.pop(),!n.compositeRule&&g?n.async?t+=" throw new ValidationError(["+G+"]); ":t+=" validate.errors = ["+G+"]; return false; ":t+=" var err = "+G+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";}t+=" } ";}}if(n.schema.$ref&&!r)t+=" "+n.RULES.all.$ref.code(n,"$ref")+" ",g&&(t+=" } if (errors === ",t+=f?"0":"errs_"+l,t+=") { ",v+="}");else{var _=n.RULES;if(_)for(var H=-1,L=_.length-1;H<L;){if(U(w=_[H+=1])){if(w.type&&(t+=" if ("+n.util.checkDataType(w.type,p)+") { "),n.opts.useDefaults)if("object"==w.type&&n.schema.properties){var h=n.schema.properties,$=Object.keys(h);if($)for(var V,N=-1,O=$.length-1;N<O;){if(void 0!==(K=h[V=$[N+=1]]).default){var F=p+n.util.getProperty(V);if(n.compositeRule){if(n.opts.strictDefaults){C="default is ignored for: "+F;if("log"!==n.opts.strictDefaults)throw new Error(C);n.logger.warn(C);}}else t+=" if ("+F+" === undefined ","empty"==n.opts.useDefaults&&(t+=" || "+F+" === null || "+F+" === '' "),t+=" ) "+F+" = ","shared"==n.opts.useDefaults?t+=" "+n.useDefault(K.default)+" ":t+=" "+JSON.stringify(K.default)+" ",t+="; ";}}}else if("array"==w.type&&Array.isArray(n.schema.items)){var P=n.schema.items;if(P)for(var K,Z=-1,M=P.length-1;Z<M;){if(void 0!==(K=P[Z+=1]).default){F=p+"["+Z+"]";if(n.compositeRule){if(n.opts.strictDefaults){C="default is ignored for: "+F;if("log"!==n.opts.strictDefaults)throw new Error(C);n.logger.warn(C);}}else t+=" if ("+F+" === undefined ","empty"==n.opts.useDefaults&&(t+=" || "+F+" === null || "+F+" === '' "),t+=" ) "+F+" = ","shared"==n.opts.useDefaults?t+=" "+n.useDefault(K.default)+" ":t+=" "+JSON.stringify(K.default)+" ",t+="; ";}}}var j,D=w.rules;if(D)for(var X,Y,z=-1,J=D.length-1;z<J;){!Q(Y=D[z+=1])||(X=Y.code(n,Y.keyword,w.type))&&(t+=" "+X+" ",g&&(A+="}"));}g&&(t+=" "+A+" ",A=""),w.type&&(t+=" } ",b&&b===w.type&&!I&&(t+=" else { ",d=n.schemaPath+".type",u=n.errSchemaPath+"/type",(j=j||[]).push(t),t="",!1!==n.createErrors?(t+=" { keyword: 'type' , dataPath: (dataPath || '') + "+n.errorPath+" , schemaPath: "+n.util.toQuotedString(u)+" , params: { type: '",t+=y?""+b.join(","):""+b,t+="' } ",!1!==n.opts.messages&&(t+=" , message: 'should be ",t+=y?""+b.join(","):""+b,t+="' "),n.opts.verbose&&(t+=" , schema: validate.schema"+d+" , parentSchema: validate.schema"+n.schemaPath+" , data: "+p+" "),t+=" } "):t+=" {} ",G=t,t=j.pop(),!n.compositeRule&&g?n.async?t+=" throw new ValidationError(["+G+"]); ":t+=" validate.errors = ["+G+"]; return false; ":t+=" var err = "+G+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",t+=" } ")),g&&(t+=" if (errors === ",t+=f?"0":"errs_"+l,t+=") { ",v+="}");}}}function U(e){for(var t=e.rules,i=0;i<t.length;i++){if(Q(t[i]))return 1;}}function Q(e){return void 0!==n.schema[e.keyword]||e.implements&&function(e){for(var t=e.implements,i=0;i<t.length;i++){if(void 0!==n.schema[t[i]])return!0;}}(e);}return g&&(t+=" "+v+" "),f?(i?(t+=" if (errors === 0) return data;           ",t+=" else throw new ValidationError(vErrors); "):(t+=" validate.errors = vErrors; ",t+=" return errors === 0;       "),t+=" }; return validate;"):t+=" var "+m+" = errors === errs_"+l+";",t=n.util.cleanUpCode(t),f&&(t=n.util.finalCleanUpCode(t,i)),t;};},function(e,t,i){"use strict";e.exports=function(e,t){var i,n,r,o,s,a,l,c=" ",h=e.level,d=e.dataLevel,u=e.schema[t],g=e.schemaPath+e.util.getProperty(t),p=e.errSchemaPath+"/"+t,m=!e.opts.allErrors,f="data"+(d||""),C=e.opts.$data&&u&&u.$data,I=C?(c+=" var schema"+h+" = "+e.util.getData(u.$data,d,e.dataPathArr)+"; ","schema"+h):u,A="maximum"==t,v=A?"exclusiveMaximum":"exclusiveMinimum",b=e.schema[v],y=e.opts.$data&&b&&b.$data,w=A?"<":">",S=A?">":"<",x=void 0;y?(o="exclIsNumber"+h,s="' + "+(a="op"+h)+" + '",c+=" var schemaExcl"+h+" = "+(i=e.util.getData(b.$data,d,e.dataPathArr))+"; ",x=v,(l=l||[]).push(c+=" var "+(n="exclusive"+h)+"; var "+(r="exclType"+h)+" = typeof "+(i="schemaExcl"+h)+"; if ("+r+" != 'boolean' && "+r+" != 'undefined' && "+r+" != 'number') { "),c="",!1!==e.createErrors?(c+=" { keyword: '"+(x||"_exclusiveLimit")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: {} ",!1!==e.opts.messages&&(c+=" , message: '"+v+" should be boolean' "),e.opts.verbose&&(c+=" , schema: validate.schema"+g+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+f+" "),c+=" } "):c+=" {} ",k=c,c=l.pop(),!e.compositeRule&&m?e.async?c+=" throw new ValidationError(["+k+"]); ":c+=" validate.errors = ["+k+"]; return false; ":c+=" var err = "+k+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",c+=" } else if ( ",C&&(c+=" ("+I+" !== undefined && typeof "+I+" != 'number') || "),c+=" "+r+" == 'number' ? ( ("+n+" = "+I+" === undefined || "+i+" "+w+"= "+I+") ? "+f+" "+S+"= "+i+" : "+f+" "+S+" "+I+" ) : ( ("+n+" = "+i+" === true) ? "+f+" "+S+"= "+I+" : "+f+" "+S+" "+I+" ) || "+f+" !== "+f+") { var op"+h+" = "+n+" ? '"+w+"' : '"+w+"='; ",void 0===u&&(x=v,p=e.errSchemaPath+"/"+v,I=i,C=y)):(s=w,(o="number"==typeof b)&&C?(a="'"+s+"'",c+=" if ( ",C&&(c+=" ("+I+" !== undefined && typeof "+I+" != 'number') || "),c+=" ( "+I+" === undefined || "+b+" "+w+"= "+I+" ? "+f+" "+S+"= "+b+" : "+f+" "+S+" "+I+" ) || "+f+" !== "+f+") { "):(o&&void 0===u?(n=!0,x=v,p=e.errSchemaPath+"/"+v,I=b,S+="="):(o&&(I=Math[A?"min":"max"](b,u)),b===(!o||I)?(n=!0,x=v,p=e.errSchemaPath+"/"+v,S+="="):(n=!1,s+="=")),a="'"+s+"'",c+=" if ( ",C&&(c+=" ("+I+" !== undefined && typeof "+I+" != 'number') || "),c+=" "+f+" "+S+" "+I+" || "+f+" !== "+f+") { ")),x=x||t,(l=l||[]).push(c),c="",!1!==e.createErrors?(c+=" { keyword: '"+(x||"_limit")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(p)+" , params: { comparison: "+a+", limit: "+I+", exclusive: "+n+" } ",!1!==e.opts.messages&&(c+=" , message: 'should be "+s+" ",c+=C?"' + "+I:I+"'"),e.opts.verbose&&(c+=" , schema:  ",c+=C?"validate.schema"+g:""+u,c+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+f+" "),c+=" } "):c+=" {} ";var k=c;return c=l.pop(),!e.compositeRule&&m?e.async?c+=" throw new ValidationError(["+k+"]); ":c+=" validate.errors = ["+k+"]; return false; ":c+=" var err = "+k+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",c+=" } ",m&&(c+=" else { "),c;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h=e.opts.$data&&o&&o.$data,d=h?(i+=" var schema"+n+" = "+e.util.getData(o.$data,r,e.dataPathArr)+"; ","schema"+n):o;i+="if ( ",h&&(i+=" ("+d+" !== undefined && typeof "+d+" != 'number') || "),i+=" "+c+".length "+("maxItems"==t?">":"<")+" "+d+") { ";var u=t,g=g||[];g.push(i),i="",!1!==e.createErrors?(i+=" { keyword: '"+(u||"_limitItems")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { limit: "+d+" } ",!1!==e.opts.messages&&(i+=" , message: 'should NOT have ",i+="maxItems"==t?"more":"fewer",i+=" than ",i+=h?"' + "+d+" + '":""+o,i+=" items' "),e.opts.verbose&&(i+=" , schema:  ",i+=h?"validate.schema"+s:""+o,i+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var p=i,i=g.pop();return!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+p+"]); ":i+=" validate.errors = ["+p+"]; return false; ":i+=" var err = "+p+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+="} ",l&&(i+=" else { "),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h=e.opts.$data&&o&&o.$data,d=h?(i+=" var schema"+n+" = "+e.util.getData(o.$data,r,e.dataPathArr)+"; ","schema"+n):o,u="maxLength"==t?">":"<";i+="if ( ",h&&(i+=" ("+d+" !== undefined && typeof "+d+" != 'number') || "),!1===e.opts.unicode?i+=" "+c+".length ":i+=" ucs2length("+c+") ",i+=" "+u+" "+d+") { ";var g=t,p=p||[];p.push(i),i="",!1!==e.createErrors?(i+=" { keyword: '"+(g||"_limitLength")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { limit: "+d+" } ",!1!==e.opts.messages&&(i+=" , message: 'should NOT be ",i+="maxLength"==t?"longer":"shorter",i+=" than ",i+=h?"' + "+d+" + '":""+o,i+=" characters' "),e.opts.verbose&&(i+=" , schema:  ",i+=h?"validate.schema"+s:""+o,i+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var m=i,i=p.pop();return!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+m+"]); ":i+=" validate.errors = ["+m+"]; return false; ":i+=" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+="} ",l&&(i+=" else { "),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h=e.opts.$data&&o&&o.$data,d=h?(i+=" var schema"+n+" = "+e.util.getData(o.$data,r,e.dataPathArr)+"; ","schema"+n):o;i+="if ( ",h&&(i+=" ("+d+" !== undefined && typeof "+d+" != 'number') || "),i+=" Object.keys("+c+").length "+("maxProperties"==t?">":"<")+" "+d+") { ";var u=t,g=g||[];g.push(i),i="",!1!==e.createErrors?(i+=" { keyword: '"+(u||"_limitProperties")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { limit: "+d+" } ",!1!==e.opts.messages&&(i+=" , message: 'should NOT have ",i+="maxProperties"==t?"more":"fewer",i+=" than ",i+=h?"' + "+d+" + '":""+o,i+=" properties' "),e.opts.verbose&&(i+=" , schema:  ",i+=h?"validate.schema"+s:""+o,i+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var p=i,i=g.pop();return!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+p+"]); ":i+=" validate.errors = ["+p+"]; return false; ":i+=" var err = "+p+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+="} ",l&&(i+=" else { "),i;};},function(e){e.exports=JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');},function(e,t,i){"use strict";var y={b:"\b",f:"\f",n:"\n",r:"\r",t:"\t",'"':'"',"/":"/","\\":"\\"},w="a".charCodeAt();t.parse=function(r,e,t){var n={},i=0,o=0,s=0,a=t&&t.bigint&&"undefined"!=typeof BigInt;return{data:l("",!0),pointers:n};function l(e,t){var i;c(),f(e,"value");var n=u();switch(n){case"t":d("rue"),i=!0;break;case"f":d("alse"),i=!1;break;case"n":d("ull"),i=null;break;case'"':i=h();break;case"[":i=function(e){c();var t=[],i=0;if("]"==u())return t;g();for(;;){var n=e+"/"+i;t.push(l(n)),c();var r=u();if("]"==r)break;","!=r&&v(),c(),i++;}return t;}(e);break;case"{":i=function(e){c();var t={};if("}"==u())return t;g();for(;;){var i=I();'"'!=u()&&v();var n=h(),r=e+"/"+S(n);C(r,"key",i),f(r,"keyEnd"),c(),":"!=u()&&v(),c(),t[n]=l(r),c();var o=u();if("}"==o)break;","!=o&&v(),c();}return t;}(e);break;default:g(),0<="-0123456789".indexOf(n)?i=function(){var e="",t=!0;"-"==r[s]&&(e+=u());e+=("0"==r[s]?u:m)(),"."==r[s]&&(e+=u()+m(),t=!1);"e"!=r[s]&&"E"!=r[s]||(e+=u(),"+"!=r[s]&&"-"!=r[s]||(e+=u()),e+=m(),t=!1);var i=+e;return a&&t&&(i>Number.MAX_SAFE_INTEGER||i<Number.MIN_SAFE_INTEGER)?BigInt(e):i;}():A();}return f(e,"valueEnd"),c(),t&&s<r.length&&A(),i;}function c(){e:for(;s<r.length;){switch(r[s]){case" ":o++;break;case"\t":o+=4;break;case"\r":o=0;break;case"\n":o=0,i++;break;default:break e;}s++;}}function h(){for(var e,t="";'"'!=(e=u());){"\\"==e?(e=u())in y?t+=y[e]:"u"==e?t+=p():v():t+=e;}return t;}function d(e){for(var t=0;t<e.length;t++){u()!==e[t]&&v();}}function u(){b();var e=r[s];return s++,o++,e;}function g(){s--,o--;}function p(){for(var e=4,t=0;e--;){t<<=4;var i=u().toLowerCase();"a"<=i&&i<="f"?t+=i.charCodeAt()-w+10:"0"<=i&&i<="9"?t+=+i:v();}return String.fromCharCode(t);}function m(){for(var e="";"0"<=r[s]&&r[s]<="9";){e+=u();}if(e.length)return e;b(),A();}function f(e,t){C(e,t,I());}function C(e,t,i){n[e]=n[e]||{},n[e][t]=i;}function I(){return{line:i,column:o,pos:s};}function A(){throw new SyntaxError("Unexpected token "+r[s]+" in JSON at position "+s);}function v(){g(),A();}function b(){if(s>=r.length)throw new SyntaxError("Unexpected end of JSON input");}},t.stringify=function(e,t,i){if(A(e)){var n=0;switch(_typeof(g="object"==(typeof i==="undefined"?"undefined":_typeof(i))?i.space:i)){case"number":var r=10<g?10:g<0?0:Math.floor(g),g=r&&I(r," "),o=r,s=r;break;case"string":g=g.slice(0,10);for(var a=s=o=0;a<g.length;a++){switch(g[a]){case" ":s++;break;case"\t":s+=4;break;case"\r":s=0;break;case"\n":s=0,n++;break;default:throw new Error("whitespace characters not allowed in JSON");}o++;}break;default:g=void 0;}var l="",c={},h=0,d=0,u=0,p=i&&i.es6&&"function"==typeof Map;return function c(h,d,u){C(u,"value");switch(typeof h==="undefined"?"undefined":_typeof(h)){case"number":case"bigint":case"boolean":m(""+h);break;case"string":m(v(h));break;case"object":null===h?m("null"):"function"==typeof h.toJSON?m(v(h.toJSON())):Array.isArray(h)?e():p?h.constructor.BYTES_PER_ELEMENT?e():h instanceof Map?i():h instanceof Set?i(!0):t():t();}C(u,"valueEnd");function e(){if(h.length){m("[");for(var e=d+1,t=0;t<h.length;t++){t&&m(","),f(e);var i=A(h[t])?h[t]:null,n=u+"/"+t;c(i,e,n);}f(d),m("]");}else m("[]");}function t(){var e=Object.keys(h);if(e.length){m("{");for(var t=d+1,i=0;i<e.length;i++){var n,r=e[i],o=h[r];A(o)&&(i&&m(","),n=u+"/"+S(r),f(t),C(n,"key"),m(v(r)),C(n,"keyEnd"),m(":"),g&&m(" "),c(o,t,n));}f(d),m("}");}else m("{}");}function i(e){if(h.size){m("{");for(var t=d+1,i=!0,n=h.entries(),r=n.next();!r.done;){var o,s=r.value,a=s[0],l=!!e||s[1];A(l)&&(i||m(","),i=!1,o=u+"/"+S(a),f(t),C(o,"key"),m(v(a)),C(o,"keyEnd"),m(":"),g&&m(" "),c(l,t,o)),r=n.next();}f(d),m("}");}else m("{}");}}(e,0,""),{json:l,pointers:c};}function m(e){d+=e.length,u+=e.length,l+=e;}function f(e){if(g){for(l+="\n"+I(e,g),h++,d=0;e--;){n?(h+=n,d=s):d+=s,u+=o;}u+=1;}}function C(e,t){c[e]=c[e]||{},c[e][t]={line:h,column:d,pos:u};}function I(e,t){return Array(e+1).join(t);}};var n=["number","bigint","boolean","string","object"];function A(e){return 0<=n.indexOf(typeof e==="undefined"?"undefined":_typeof(e));}var r=/"|\\/g,o=/[\b]/g,s=/\f/g,a=/\n/g,l=/\r/g,c=/\t/g;function v(e){return'"'+(e=e.replace(r,"\\$&").replace(s,"\\f").replace(o,"\\b").replace(a,"\\n").replace(l,"\\r").replace(c,"\\t"))+'"';}var h=/~/g,d=/\//g;function S(e){return e.replace(h,"~0").replace(d,"~1");}},function(e,t,i){!function(e){"use strict";function R(e){return null!==e&&"[object Array]"===Object.prototype.toString.call(e);}function E(e){return null!==e&&"[object Object]"===Object.prototype.toString.call(e);}function B(e,t){if(e===t)return!0;if(Object.prototype.toString.call(e)!==Object.prototype.toString.call(t))return!1;if(!0===R(e)){if(e.length!==t.length)return!1;for(var i=0;i<e.length;i++){if(!1===B(e[i],t[i]))return!1;}return!0;}if(!0!==E(e))return!1;var n={};for(var r in e){if(hasOwnProperty.call(e,r)){if(!1===B(e[r],t[r]))return!1;n[r]=!0;}}for(var o in t){if(hasOwnProperty.call(t,o)&&!0!==n[o])return!1;}return!0;}function Z(e){if(""===e||!1===e||null===e)return!0;if(R(e)&&0===e.length)return!0;if(E(e)){for(var t in e){if(e.hasOwnProperty(t))return!1;}return!0;}return!1;}var s="function"==typeof String.prototype.trimLeft?function(e){return e.trimLeft();}:function(e){return e.match(/^\s*(.*)/)[1];},c=0,o=1,h=2,a=3,t=4,i=6,l=8,d=9,u="UnquotedIdentifier",g="QuotedIdentifier",p="Rbracket",m="Rparen",f="Comma",C="Colon",I="Rbrace",A="Number",T="Current",G="Expref",W="Pipe",_="GTE",H="LTE",L="Flatten",v="Star",b="Filter",y="Dot",w="Lbrace",S="Lbracket",x="Lparen",k="Literal",$={".":y,"*":v,",":f,":":C,"{":w,"}":I,"]":p,"(":x,")":m,"@":T},V={"<":!0,">":!0,"=":!0,"!":!0},N={" ":!0,"\t":!0,"\n":!0};function O(e){return"0"<=e&&e<="9"||"-"===e;}function n(){}n.prototype={tokenize:function tokenize(e){var t,i,n,r,o=[];for(this._current=0;this._current<e.length;){if("a"<=(r=e[this._current])&&r<="z"||"A"<=r&&r<="Z"||"_"===r)t=this._current,i=this._consumeUnquotedIdentifier(e),o.push({type:u,value:i,start:t});else if(void 0!==$[e[this._current]])o.push({type:$[e[this._current]],value:e[this._current],start:this._current}),this._current++;else if(O(e[this._current]))n=this._consumeNumber(e),o.push(n);else if("["===e[this._current])n=this._consumeLBracket(e),o.push(n);else if('"'===e[this._current])t=this._current,i=this._consumeQuotedIdentifier(e),o.push({type:g,value:i,start:t});else if("'"===e[this._current])t=this._current,i=this._consumeRawStringLiteral(e),o.push({type:k,value:i,start:t});else if("`"===e[this._current]){t=this._current;var s=this._consumeLiteral(e);o.push({type:k,value:s,start:t});}else if(void 0!==V[e[this._current]])o.push(this._consumeOperator(e));else if(void 0!==N[e[this._current]])this._current++;else if("&"===e[this._current])t=this._current,this._current++,"&"===e[this._current]?(this._current++,o.push({type:"And",value:"&&",start:t})):o.push({type:G,value:"&",start:t});else{if("|"!==e[this._current]){var a=new Error("Unknown character:"+e[this._current]);throw a.name="LexerError",a;}t=this._current,this._current++,"|"===e[this._current]?(this._current++,o.push({type:"Or",value:"||",start:t})):o.push({type:W,value:"|",start:t});}}return o;},_consumeUnquotedIdentifier:function _consumeUnquotedIdentifier(e){var t,i=this._current;for(this._current++;this._current<e.length&&("a"<=(t=e[this._current])&&t<="z"||"A"<=t&&t<="Z"||"0"<=t&&t<="9"||"_"===t);){this._current++;}return e.slice(i,this._current);},_consumeQuotedIdentifier:function _consumeQuotedIdentifier(e){var t=this._current;this._current++;for(var i=e.length;'"'!==e[this._current]&&this._current<i;){var n=this._current;"\\"!==e[n]||"\\"!==e[n+1]&&'"'!==e[n+1]?n++:n+=2,this._current=n;}return this._current++,JSON.parse(e.slice(t,this._current));},_consumeRawStringLiteral:function _consumeRawStringLiteral(e){var t=this._current;this._current++;for(var i=e.length;"'"!==e[this._current]&&this._current<i;){var n=this._current;"\\"!==e[n]||"\\"!==e[n+1]&&"'"!==e[n+1]?n++:n+=2,this._current=n;}return this._current++,e.slice(t+1,this._current-1).replace("\\'","'");},_consumeNumber:function _consumeNumber(e){var t=this._current;this._current++;for(var i=e.length;O(e[this._current])&&this._current<i;){this._current++;}var n=parseInt(e.slice(t,this._current));return{type:A,value:n,start:t};},_consumeLBracket:function _consumeLBracket(e){var t=this._current;return this._current++,"?"===e[this._current]?(this._current++,{type:b,value:"[?",start:t}):"]"===e[this._current]?(this._current++,{type:L,value:"[]",start:t}):{type:S,value:"[",start:t};},_consumeOperator:function _consumeOperator(e){var t=this._current,i=e[t];return this._current++,"!"===i?"="===e[this._current]?(this._current++,{type:"NE",value:"!=",start:t}):{type:"Not",value:"!",start:t}:"<"===i?"="===e[this._current]?(this._current++,{type:H,value:"<=",start:t}):{type:"LT",value:"<",start:t}:">"===i?"="===e[this._current]?(this._current++,{type:_,value:">=",start:t}):{type:"GT",value:">",start:t}:"="===i&&"="===e[this._current]?(this._current++,{type:"EQ",value:"==",start:t}):void 0;},_consumeLiteral:function _consumeLiteral(e){this._current++;for(var t=this._current,i=e.length;"`"!==e[this._current]&&this._current<i;){var n=this._current;"\\"!==e[n]||"\\"!==e[n+1]&&"`"!==e[n+1]?n++:n+=2,this._current=n;}var r=(r=s(e.slice(t,this._current))).replace("\\`","`"),o=this._looksLikeJSON(r)?JSON.parse(r):JSON.parse('"'+r+'"');return this._current++,o;},_looksLikeJSON:function _looksLikeJSON(e){if(""===e)return!1;if(0<='[{"'.indexOf(e[0]))return!0;if(0<=["true","false","null"].indexOf(e))return!0;if(!(0<="-0123456789".indexOf(e[0])))return!1;try{return JSON.parse(e),!0;}catch(e){return!1;}}};var F={};function P(){}function K(e){this.runtime=e;}function M(e){this._interpreter=e,this.functionTable={abs:{_func:this._functionAbs,_signature:[{types:[c]}]},avg:{_func:this._functionAvg,_signature:[{types:[l]}]},ceil:{_func:this._functionCeil,_signature:[{types:[c]}]},contains:{_func:this._functionContains,_signature:[{types:[h,a]},{types:[o]}]},ends_with:{_func:this._functionEndsWith,_signature:[{types:[h]},{types:[h]}]},floor:{_func:this._functionFloor,_signature:[{types:[c]}]},length:{_func:this._functionLength,_signature:[{types:[h,a,t]}]},map:{_func:this._functionMap,_signature:[{types:[i]},{types:[a]}]},max:{_func:this._functionMax,_signature:[{types:[l,d]}]},merge:{_func:this._functionMerge,_signature:[{types:[t],variadic:!0}]},max_by:{_func:this._functionMaxBy,_signature:[{types:[a]},{types:[i]}]},sum:{_func:this._functionSum,_signature:[{types:[l]}]},starts_with:{_func:this._functionStartsWith,_signature:[{types:[h]},{types:[h]}]},min:{_func:this._functionMin,_signature:[{types:[l,d]}]},min_by:{_func:this._functionMinBy,_signature:[{types:[a]},{types:[i]}]},type:{_func:this._functionType,_signature:[{types:[o]}]},keys:{_func:this._functionKeys,_signature:[{types:[t]}]},values:{_func:this._functionValues,_signature:[{types:[t]}]},sort:{_func:this._functionSort,_signature:[{types:[d,l]}]},sort_by:{_func:this._functionSortBy,_signature:[{types:[a]},{types:[i]}]},join:{_func:this._functionJoin,_signature:[{types:[h]},{types:[d]}]},reverse:{_func:this._functionReverse,_signature:[{types:[h,a]}]},to_array:{_func:this._functionToArray,_signature:[{types:[o]}]},to_string:{_func:this._functionToString,_signature:[{types:[o]}]},to_number:{_func:this._functionToNumber,_signature:[{types:[o]}]},not_null:{_func:this._functionNotNull,_signature:[{types:[o],variadic:!0}]}};}F.EOF=0,F[u]=0,F[g]=0,F[p]=0,F[m]=0,F[f]=0,F[I]=0,F[A]=0,F[T]=0,F[G]=0,F[W]=1,F.Or=2,F.And=3,F.EQ=5,F.GT=5,F.LT=5,F.GTE=5,F.LTE=5,F.NE=5,F[L]=9,F[v]=20,F[b]=21,F.Dot=40,F.Not=45,F[w]=50,F[S]=55,F[x]=60,P.prototype={parse:function parse(e){this._loadTokens(e),this.index=0;var t=this.expression(0);if("EOF"===this._lookahead(0))return t;var i=this._lookaheadToken(0),n=new Error("Unexpected token type: "+i.type+", value: "+i.value);throw n.name="ParserError",n;},_loadTokens:function _loadTokens(e){var t=new n().tokenize(e);t.push({type:"EOF",value:"",start:e.length}),this.tokens=t;},expression:function expression(e){var t=this._lookaheadToken(0);this._advance();for(var i=this.nud(t),n=this._lookahead(0);e<F[n];){this._advance(),i=this.led(n,i),n=this._lookahead(0);}return i;},_lookahead:function _lookahead(e){return this.tokens[this.index+e].type;},_lookaheadToken:function _lookaheadToken(e){return this.tokens[this.index+e];},_advance:function _advance(){this.index++;},nud:function nud(e){var t,i;switch(e.type){case k:return{type:"Literal",value:e.value};case u:return{type:"Field",name:e.value};case g:var n={type:"Field",name:e.value};if(this._lookahead(0)===x)throw new Error("Quoted identifier not allowed for function names.");return n;case"Not":return{type:"NotExpression",children:[t=this.expression(F.Not)]};case v:return t=null,{type:"ValueProjection",children:[{type:"Identity"},t=this._lookahead(0)===p?{type:"Identity"}:this._parseProjectionRHS(F.Star)]};case b:return this.led(e.type,{type:"Identity"});case w:return this._parseMultiselectHash();case L:return{type:"Projection",children:[{type:L,children:[{type:"Identity"}]},t=this._parseProjectionRHS(F.Flatten)]};case S:return this._lookahead(0)===A||this._lookahead(0)===C?(t=this._parseIndexExpression(),this._projectIfSlice({type:"Identity"},t)):this._lookahead(0)===v&&this._lookahead(1)===p?(this._advance(),this._advance(),{type:"Projection",children:[{type:"Identity"},t=this._parseProjectionRHS(F.Star)]}):this._parseMultiselectList();case T:return{type:T};case G:return{type:"ExpressionReference",children:[i=this.expression(F.Expref)]};case x:for(var r=[];this._lookahead(0)!==m;){this._lookahead(0)===T?(i={type:T},this._advance()):i=this.expression(0),r.push(i);}return this._match(m),r[0];default:this._errorToken(e);}},led:function led(e,t){var i;switch(e){case y:var n=F.Dot;return this._lookahead(0)!==v?{type:"Subexpression",children:[t,i=this._parseDotRHS(n)]}:(this._advance(),{type:"ValueProjection",children:[t,i=this._parseProjectionRHS(n)]});case W:return i=this.expression(F.Pipe),{type:W,children:[t,i]};case"Or":return{type:"OrExpression",children:[t,i=this.expression(F.Or)]};case"And":return{type:"AndExpression",children:[t,i=this.expression(F.And)]};case x:for(var r,o=t.name,s=[];this._lookahead(0)!==m;){this._lookahead(0)===T?(r={type:T},this._advance()):r=this.expression(0),this._lookahead(0)===f&&this._match(f),s.push(r);}return this._match(m),{type:"Function",name:o,children:s};case b:var a=this.expression(0);return this._match(p),{type:"FilterProjection",children:[t,i=this._lookahead(0)===L?{type:"Identity"}:this._parseProjectionRHS(F.Filter),a]};case L:return{type:"Projection",children:[{type:L,children:[t]},this._parseProjectionRHS(F.Flatten)]};case"EQ":case"NE":case"GT":case _:case"LT":case H:return this._parseComparator(t,e);case S:var l=this._lookaheadToken(0);return l.type===A||l.type===C?(i=this._parseIndexExpression(),this._projectIfSlice(t,i)):(this._match(v),this._match(p),{type:"Projection",children:[t,i=this._parseProjectionRHS(F.Star)]});default:this._errorToken(this._lookaheadToken(0));}},_match:function _match(e){if(this._lookahead(0)!==e){var t=this._lookaheadToken(0),i=new Error("Expected "+e+", got: "+t.type);throw i.name="ParserError",i;}this._advance();},_errorToken:function _errorToken(e){var t=new Error("Invalid token ("+e.type+'): "'+e.value+'"');throw t.name="ParserError",t;},_parseIndexExpression:function _parseIndexExpression(){if(this._lookahead(0)===C||this._lookahead(1)===C)return this._parseSliceExpression();var e={type:"Index",value:this._lookaheadToken(0).value};return this._advance(),this._match(p),e;},_projectIfSlice:function _projectIfSlice(e,t){var i={type:"IndexExpression",children:[e,t]};return"Slice"===t.type?{type:"Projection",children:[i,this._parseProjectionRHS(F.Star)]}:i;},_parseSliceExpression:function _parseSliceExpression(){for(var e=[null,null,null],t=0,i=this._lookahead(0);i!==p&&t<3;){if(i===C)t++,this._advance();else{if(i!==A){var n=this._lookahead(0),r=new Error("Syntax error, unexpected token: "+n.value+"("+n.type+")");throw r.name="Parsererror",r;}e[t]=this._lookaheadToken(0).value,this._advance();}i=this._lookahead(0);}return this._match(p),{type:"Slice",children:e};},_parseComparator:function _parseComparator(e,t){return{type:"Comparator",name:t,children:[e,this.expression(F[t])]};},_parseDotRHS:function _parseDotRHS(e){var t=this._lookahead(0);return 0<=[u,g,v].indexOf(t)?this.expression(e):t===S?(this._match(S),this._parseMultiselectList()):t===w?(this._match(w),this._parseMultiselectHash()):void 0;},_parseProjectionRHS:function _parseProjectionRHS(e){var t;if(F[this._lookahead(0)]<10)t={type:"Identity"};else if(this._lookahead(0)===S)t=this.expression(e);else if(this._lookahead(0)===b)t=this.expression(e);else{if(this._lookahead(0)!==y){var i=this._lookaheadToken(0),n=new Error("Sytanx error, unexpected token: "+i.value+"("+i.type+")");throw n.name="ParserError",n;}this._match(y),t=this._parseDotRHS(e);}return t;},_parseMultiselectList:function _parseMultiselectList(){for(var e=[];this._lookahead(0)!==p;){var t=this.expression(0);if(e.push(t),this._lookahead(0)===f&&(this._match(f),this._lookahead(0)===p))throw new Error("Unexpected token Rbracket");}return this._match(p),{type:"MultiSelectList",children:e};},_parseMultiselectHash:function _parseMultiselectHash(){for(var e,t,i,n=[],r=[u,g];;){if(e=this._lookaheadToken(0),r.indexOf(e.type)<0)throw new Error("Expecting an identifier token, got: "+e.type);if(t=e.value,this._advance(),this._match(C),i={type:"KeyValuePair",name:t,value:this.expression(0)},n.push(i),this._lookahead(0)===f)this._match(f);else if(this._lookahead(0)===I){this._match(I);break;}}return{type:"MultiSelectHash",children:n};}},K.prototype={search:function search(e,t){return this.visit(e,t);},visit:function visit(e,t){var i,n,r,o,s,a;switch(e.type){case"Field":return null===t||!E(t)||void 0===(s=t[e.name])?null:s;case"Subexpression":for(p=this.visit(e.children[0],t),C=1;C<e.children.length;C++){if(null===(p=this.visit(e.children[1],p)))return null;}return p;case"IndexExpression":return a=this.visit(e.children[0],t),this.visit(e.children[1],a);case"Index":if(!R(t))return null;var l=e.value;return l<0&&(l=t.length+l),void 0===(p=t[l])&&(p=null),p;case"Slice":if(!R(t))return null;var c=e.children.slice(0),h=this.computeSliceParams(t.length,c),d=h[0],u=h[1],g=h[2],p=[];if(0<g)for(C=d;C<u;C+=g){p.push(t[C]);}else for(C=d;u<C;C+=g){p.push(t[C]);}return p;case"Projection":var m=this.visit(e.children[0],t);if(!R(m))return null;for(S=[],C=0;C<m.length;C++){null!==(n=this.visit(e.children[1],m[C]))&&S.push(n);}return S;case"ValueProjection":if(!E(m=this.visit(e.children[0],t)))return null;S=[];for(var f=function(e){for(var t=Object.keys(e),i=[],n=0;n<t.length;n++){i.push(e[t[n]]);}return i;}(m),C=0;C<f.length;C++){null!==(n=this.visit(e.children[1],f[C]))&&S.push(n);}return S;case"FilterProjection":if(!R(m=this.visit(e.children[0],t)))return null;var I=[],A=[];for(C=0;C<m.length;C++){Z(i=this.visit(e.children[2],m[C]))||I.push(m[C]);}for(var v=0;v<I.length;v++){null!==(n=this.visit(e.children[1],I[v]))&&A.push(n);}return A;case"Comparator":switch(r=this.visit(e.children[0],t),o=this.visit(e.children[1],t),e.name){case"EQ":p=B(r,o);break;case"NE":p=!B(r,o);break;case"GT":p=o<r;break;case _:p=o<=r;break;case"LT":p=r<o;break;case H:p=r<=o;break;default:throw new Error("Unknown comparator: "+e.name);}return p;case L:var b=this.visit(e.children[0],t);if(!R(b))return null;var y=[];for(C=0;C<b.length;C++){R(n=b[C])?y.push.apply(y,n):y.push(n);}return y;case"Identity":return t;case"MultiSelectList":if(null===t)return null;for(S=[],C=0;C<e.children.length;C++){S.push(this.visit(e.children[C],t));}return S;case"MultiSelectHash":if(null===t)return null;var w,S={};for(C=0;C<e.children.length;C++){S[(w=e.children[C]).name]=this.visit(w.value,t);}return S;case"OrExpression":return Z(i=this.visit(e.children[0],t))&&(i=this.visit(e.children[1],t)),i;case"AndExpression":return!0===Z(r=this.visit(e.children[0],t))?r:this.visit(e.children[1],t);case"NotExpression":return Z(r=this.visit(e.children[0],t));case"Literal":return e.value;case W:return a=this.visit(e.children[0],t),this.visit(e.children[1],a);case T:return t;case"Function":var x=[];for(C=0;C<e.children.length;C++){x.push(this.visit(e.children[C],t));}return this.runtime.callFunction(e.name,x);case"ExpressionReference":var k=e.children[0];return k.jmespathType=G,k;default:throw new Error("Unknown node type: "+e.type);}},computeSliceParams:function computeSliceParams(e,t){var i=t[0],n=t[1],r=t[2],o=[null,null,null];if(null===r)r=1;else if(0===r){var s=new Error("Invalid slice, step cannot be 0");throw s.name="RuntimeError",s;}var a=r<0,i=null===i?a?e-1:0:this.capSliceRange(e,i,r),n=null===n?a?-1:e:this.capSliceRange(e,n,r);return o[0]=i,o[1]=n,o[2]=r,o;},capSliceRange:function capSliceRange(e,t,i){return t<0?(t+=e)<0&&(t=i<0?-1:0):e<=t&&(t=i<0?e-1:e),t;}},M.prototype={callFunction:function callFunction(e,t){var i=this.functionTable[e];if(void 0===i)throw new Error("Unknown function: "+e+"()");return this._validateArgs(e,t,i._signature),i._func.call(this,t);},_validateArgs:function _validateArgs(e,t,i){var n,r,o,s;if(i[i.length-1].variadic){if(t.length<i.length)throw n=1===i.length?" argument":" arguments",new Error("ArgumentError: "+e+"() takes at least"+i.length+n+" but received "+t.length);}else if(t.length!==i.length)throw n=1===i.length?" argument":" arguments",new Error("ArgumentError: "+e+"() takes "+i.length+n+" but received "+t.length);for(var a=0;a<i.length;a++){s=!1,r=i[a].types,o=this._getTypeName(t[a]);for(var l=0;l<r.length;l++){if(this._typeMatches(o,r[l],t[a])){s=!0;break;}}if(!s)throw new Error("TypeError: "+e+"() expected argument "+(a+1)+" to be type "+r+" but received type "+o+" instead.");}},_typeMatches:function _typeMatches(e,t,i){if(t===o)return!0;if(t!==d&&t!==l&&t!==a)return e===t;if(t===a)return e===a;if(e===a){var n;t===l?n=c:t===d&&(n=h);for(var r=0;r<i.length;r++){if(!this._typeMatches(this._getTypeName(i[r]),n,i[r]))return!1;}return!0;}},_getTypeName:function _getTypeName(e){switch(Object.prototype.toString.call(e)){case"[object String]":return h;case"[object Number]":return c;case"[object Array]":return a;case"[object Boolean]":return 5;case"[object Null]":return 7;case"[object Object]":return e.jmespathType===G?i:t;}},_functionStartsWith:function _functionStartsWith(e){return 0===e[0].lastIndexOf(e[1]);},_functionEndsWith:function _functionEndsWith(e){var t=e[0],i=e[1];return-1!==t.indexOf(i,t.length-i.length);},_functionReverse:function _functionReverse(e){if(this._getTypeName(e[0])===h){for(var t=e[0],i="",n=t.length-1;0<=n;n--){i+=t[n];}return i;}var r=e[0].slice(0);return r.reverse(),r;},_functionAbs:function _functionAbs(e){return Math.abs(e[0]);},_functionCeil:function _functionCeil(e){return Math.ceil(e[0]);},_functionAvg:function _functionAvg(e){for(var t=0,i=e[0],n=0;n<i.length;n++){t+=i[n];}return t/i.length;},_functionContains:function _functionContains(e){return 0<=e[0].indexOf(e[1]);},_functionFloor:function _functionFloor(e){return Math.floor(e[0]);},_functionLength:function _functionLength(e){return E(e[0])?Object.keys(e[0]).length:e[0].length;},_functionMap:function _functionMap(e){for(var t=[],i=this._interpreter,n=e[0],r=e[1],o=0;o<r.length;o++){t.push(i.visit(n,r[o]));}return t;},_functionMerge:function _functionMerge(e){for(var t={},i=0;i<e.length;i++){var n=e[i];for(var r in n){t[r]=n[r];}}return t;},_functionMax:function _functionMax(e){if(0<e[0].length){if(this._getTypeName(e[0][0])===c)return Math.max.apply(Math,e[0]);for(var t=e[0],i=t[0],n=1;n<t.length;n++){i.localeCompare(t[n])<0&&(i=t[n]);}return i;}return null;},_functionMin:function _functionMin(e){if(0<e[0].length){if(this._getTypeName(e[0][0])===c)return Math.min.apply(Math,e[0]);for(var t=e[0],i=t[0],n=1;n<t.length;n++){t[n].localeCompare(i)<0&&(i=t[n]);}return i;}return null;},_functionSum:function _functionSum(e){for(var t=0,i=e[0],n=0;n<i.length;n++){t+=i[n];}return t;},_functionType:function _functionType(e){switch(this._getTypeName(e[0])){case c:return"number";case h:return"string";case a:return"array";case t:return"object";case 5:return"boolean";case i:return"expref";case 7:return"null";}},_functionKeys:function _functionKeys(e){return Object.keys(e[0]);},_functionValues:function _functionValues(e){for(var t=e[0],i=Object.keys(t),n=[],r=0;r<i.length;r++){n.push(t[i[r]]);}return n;},_functionJoin:function _functionJoin(e){var t=e[0];return e[1].join(t);},_functionToArray:function _functionToArray(e){return this._getTypeName(e[0])===a?e[0]:[e[0]];},_functionToString:function _functionToString(e){return this._getTypeName(e[0])===h?e[0]:JSON.stringify(e[0]);},_functionToNumber:function _functionToNumber(e){var t,i=this._getTypeName(e[0]);return i===c?e[0]:i!==h||(t=+e[0],isNaN(t))?null:t;},_functionNotNull:function _functionNotNull(e){for(var t=0;t<e.length;t++){if(7!==this._getTypeName(e[t]))return e[t];}return null;},_functionSort:function _functionSort(e){var t=e[0].slice(0);return t.sort(),t;},_functionSortBy:function _functionSortBy(e){var t=e[0].slice(0);if(0===t.length)return t;var r=this._interpreter,o=e[1],s=this._getTypeName(r.visit(o,t[0]));if([c,h].indexOf(s)<0)throw new Error("TypeError");for(var a=this,i=[],n=0;n<t.length;n++){i.push([n,t[n]]);}i.sort(function(e,t){var i=r.visit(o,e[1]),n=r.visit(o,t[1]);if(a._getTypeName(i)!==s)throw new Error("TypeError: expected "+s+", received "+a._getTypeName(i));if(a._getTypeName(n)!==s)throw new Error("TypeError: expected "+s+", received "+a._getTypeName(n));return n<i?1:i<n?-1:e[0]-t[0];});for(var l=0;l<i.length;l++){t[l]=i[l][1];}return t;},_functionMaxBy:function _functionMaxBy(e){for(var t,i,n=e[1],r=e[0],o=this.createKeyFunction(n,[c,h]),s=-1/0,a=0;a<r.length;a++){s<(i=o(r[a]))&&(s=i,t=r[a]);}return t;},_functionMinBy:function _functionMinBy(e){for(var t,i,n=e[1],r=e[0],o=this.createKeyFunction(n,[c,h]),s=1/0,a=0;a<r.length;a++){(i=o(r[a]))<s&&(s=i,t=r[a]);}return t;},createKeyFunction:function createKeyFunction(n,r){var o=this,s=this._interpreter;return function(e){var t=s.visit(n,e);if(r.indexOf(o._getTypeName(t))<0){var i="TypeError: expected one of "+r+", received "+o._getTypeName(t);throw new Error(i);}return t;};}},e.tokenize=function(e){return new n().tokenize(e);},e.compile=function(e){return new P().parse(e);},e.search=function(e,t){var i=new P(),n=new M(),r=new K(n);n._interpreter=r;var o=i.parse(t);return r.search(o,e);},e.strictDeepEqual=B;}(t);},function(e,t,i){t.tryRequireThemeJsonEditor=function(){try{i(42);}catch(e){console.error(e);}};},function(e,t,r){"use strict";var i=r(20),n=r(13),o=r(80).treeModeMixins,s=r(21).textModeMixins,a=r(81).previewModeMixins,l=r(0),c=l.clear,h=l.extend,d=l.getInnerText,u=l.getInternetExplorerVersion,g=l.parse,p=r(43).tryRequireAjv,m=r(6).showTransformModal,f=r(5).showSortModal,C=p();function I(e,t,i){if(!(this instanceof I))throw new Error('JSONEditor constructor called without "new".');var n=u();if(-1!==n&&n<9)throw new Error("Unsupported browser, IE9 or newer required. Please install the newest version of your browser.");t&&(t.error&&(console.warn('Option "error" has been renamed to "onError"'),t.onError=t.error,delete t.error),t.change&&(console.warn('Option "change" has been renamed to "onChange"'),t.onChange=t.change,delete t.change),t.editable&&(console.warn('Option "editable" has been renamed to "onEditable"'),t.onEditable=t.editable,delete t.editable),t.onChangeJSON&&("text"!==t.mode&&"code"!==t.mode&&(!t.modes||-1===t.modes.indexOf("text")&&-1===t.modes.indexOf("code"))||console.warn('Option "onChangeJSON" is not applicable to modes "text" and "code". Use "onChangeText" or "onChange" instead.')),t&&Object.keys(t).forEach(function(e){-1===I.VALID_OPTIONS.indexOf(e)&&console.warn('Unknown option "'+e+'". This option will be ignored');})),arguments.length&&this._create(e,t,i);}"undefined"==typeof Promise&&console.error("Promise undefined. Please load a Promise polyfill in the browser in order to use JSONEditor"),I.modes={},I.prototype.DEBOUNCE_INTERVAL=150,I.VALID_OPTIONS=["ajv","schema","schemaRefs","templates","ace","theme","autocomplete","onChange","onChangeJSON","onChangeText","onEditable","onError","onEvent","onModeChange","onNodeName","onValidate","onCreateMenu","onSelectionChange","onTextSelectionChange","onClassName","onFocus","onBlur","colorPicker","onColorPicker","timestampTag","timestampFormat","escapeUnicode","history","search","mode","modes","name","indentation","sortObjectKeys","navigationBar","statusBar","mainMenuBar","languages","language","enableSort","enableTransform","maxVisibleChilds","onValidationError","modalAnchor","popupAnchor","createQuery","executeQuery","queryDescription"],I.prototype._create=function(e,t,i){this.container=e,this.options=t||{},this.json=i||{};var n=this.options.mode||this.options.modes&&this.options.modes[0]||"tree";this.setMode(n);},I.prototype.destroy=function(){},I.prototype.set=function(e){this.json=e;},I.prototype.get=function(){return this.json;},I.prototype.setText=function(e){this.json=g(e);},I.prototype.getText=function(){return JSON.stringify(this.json);},I.prototype.setName=function(e){this.options||(this.options={}),this.options.name=e;},I.prototype.getName=function(){return this.options&&this.options.name;},I.prototype.setMode=function(e){if(e!==this.options.mode||!this.create){var t=this.container,i=h({},this.options),n=i.mode;i.mode=e;var r=I.modes[e];if(!r)throw new Error('Unknown mode "'+i.mode+'"');try{var o="text"===r.data,s=this.getName(),a=this[o?"getText":"get"]();if(this.destroy(),c(this),h(this,r.mixin),this.create(t,i),this.setName(s),this[o?"setText":"set"](a),"function"==typeof r.load)try{r.load.call(this);}catch(e){console.error(e);}if("function"==typeof i.onModeChange&&e!==n)try{i.onModeChange(e,n);}catch(e){console.error(e);}}catch(e){this._onError(e);}}},I.prototype.getMode=function(){return this.options.mode;},I.prototype._onError=function(e){if(!this.options||"function"!=typeof this.options.onError)throw e;this.options.onError(e);},I.prototype.setSchema=function(e,t){if(e){var i;try{this.options.ajv?i=this.options.ajv:((i=C({allErrors:!0,verbose:!0,schemaId:"auto",$data:!0})).addMetaSchema(r(78)),i.addMetaSchema(r(79)));}catch(e){console.warn("Failed to create an instance of Ajv, JSON Schema validation is not available. Please use a JSONEditor bundle including Ajv, or pass an instance of Ajv as via the configuration option `ajv`.");}if(i){if(t){for(var n in t){i.removeSchema(n),t[n]&&i.addSchema(t[n],n);}this.options.schemaRefs=t;}this.validateSchema=i.compile(e),this.options.schema=e,this.validate();}this.refresh();}else this.validateSchema=null,this.options.schema=null,this.options.schemaRefs=null,this.validate(),this.refresh();},I.prototype.validate=function(){},I.prototype.refresh=function(){},I.registerMode=function(e){var t;if(Array.isArray(e))for(r=0;r<e.length;r++){I.registerMode(e[r]);}else{if(!("mode"in e))throw new Error('Property "mode" missing');if(!("mixin"in e))throw new Error('Property "mixin" missing');if(!("data"in e))throw new Error('Property "data" missing');var i=e.mode;if(i in I.modes)throw new Error('Mode "'+i+'" already registered');if("function"!=typeof e.mixin.create)throw new Error('Required function "create" missing on mixin');for(var n=["setMode","registerMode","modes"],r=0;r<n.length;r++){if((t=n[r])in e.mixin)throw new Error('Reserved property "'+t+'" not allowed in mixin');}I.modes[i]=e;}},I.registerMode(o),I.registerMode(s),I.registerMode(a),I.ace=i,I.Ajv=C,I.VanillaPicker=n,I.showTransformModal=m,I.showSortModal=f,I.getInnerText=d,I.default=I,e.exports=I;},function(e,t,A){(function(i){!function(){var e=function(){return this;}();e||"undefined"==typeof window||(e=window);var o=function o(e,t,i){"string"==typeof e?(2==arguments.length&&(i=t),o.modules[e]||(o.payloads[e]=i,o.modules[e]=null)):o.original?o.original.apply(this,arguments):(console.error("dropping module because define wasn't a string."),console.trace());};o.modules={},o.payloads={};function s(e,t,i){if("string"==typeof t){var n=c(e,t);if(null!=n)return i&&i(),n;}else if("[object Array]"===Object.prototype.toString.call(t)){for(var r=[],o=0,s=t.length;o<s;++o){var a=c(e,t[o]);if(null==a&&l.original)return;r.push(a);}return i&&i.apply(null,r)||!0;}}var t,i,l=function l(e,t){var i=s("",e,t);return null==i&&l.original?l.original.apply(this,arguments):i;},a=function a(e,t){if(-1!==t.indexOf("!")){var i=t.split("!");return a(e,i[0])+"!"+a(e,i[1]);}if("."==t.charAt(0))for(t=e.split("/").slice(0,-1).join("/")+"/"+t;-1!==t.indexOf(".")&&n!=t;){var n=t;t=t.replace(/\/\.\//,"/").replace(/[^\/]+\/\.\.\//,"");}return t;},c=function c(e,i){i=a(e,i);var t,n,r=o.modules[i];return r||("function"==typeof(r=o.payloads[i])&&(t={id:i,uri:"",exports:n={},packaged:!0},n=r(function(e,t){return s(i,e,t);},n,t)||t.exports,o.modules[i]=n,delete o.payloads[i]),r=o.modules[i]=n||r),r;};i=e,(t="ace")&&(e[t]||(e[t]={}),i=e[t]),i.define&&i.define.packaged||(o.original=i.define,i.define=o,i.define.packaged=!0),i.require&&i.require.packaged||(l.original=i.require,i.require=l,i.require.packaged=!0);}(),ace.define("ace/lib/regexp",["require","exports","module"],function(e,t,i){"use strict";var n,s={exec:RegExp.prototype.exec,test:RegExp.prototype.test,match:String.prototype.match,replace:String.prototype.replace,split:String.prototype.split},a=void 0===s.exec.call(/()??/,"")[1],l=(n=/^/g,s.test.call(n,""),!n.lastIndex);l&&a||(RegExp.prototype.exec=function(e){var t,i,n,r=s.exec.apply(this,arguments);if("string"==typeof e&&r){if(!a&&1<r.length&&-1<function(e,t,i){if(Array.prototype.indexOf)return e.indexOf(t,i);for(var n=i||0;n<e.length;n++){if(e[n]===t)return n;}return-1;}(r,"")&&(i=RegExp(this.source,s.replace.call(((n=this).global?"g":"")+(n.ignoreCase?"i":"")+(n.multiline?"m":"")+(n.extended?"x":"")+(n.sticky?"y":""),"g","")),s.replace.call(e.slice(r.index),i,function(){for(var e=1;e<arguments.length-2;e++){void 0===arguments[e]&&(r[e]=void 0);}})),this._xregexp&&this._xregexp.captureNames)for(var o=1;o<r.length;o++){(t=this._xregexp.captureNames[o-1])&&(r[t]=r[o]);}!l&&this.global&&!r[0].length&&this.lastIndex>r.index&&this.lastIndex--;}return r;},l||(RegExp.prototype.test=function(e){var t=s.exec.call(this,e);return t&&this.global&&!t[0].length&&this.lastIndex>t.index&&this.lastIndex--,!!t;}));}),ace.define("ace/lib/es5-shim",["require","exports","module"],function(e,t,i){function o(){}Function.prototype.bind||(Function.prototype.bind=function(t){var i=this;if("function"!=typeof i)throw new TypeError("Function.prototype.bind called on incompatible "+i);var n=m.call(arguments,1),r=function r(){if(this instanceof r){var e=i.apply(this,n.concat(m.call(arguments)));return Object(e)===e?e:this;}return i.apply(t,n.concat(m.call(arguments)));};return i.prototype&&(o.prototype=i.prototype,r.prototype=new o(),o.prototype=null),r;});var r,s,a,l,c,n,h,d,u=Function.prototype.call,g=Array.prototype,p=Object.prototype,m=g.slice,f=u.bind(p.toString),C=u.bind(p.hasOwnProperty);function I(e){var t=new Array(e+2);return t[0]=t[1]=0,t;}(c=C(p,"__defineGetter__"))&&(r=u.bind(p.__defineGetter__),s=u.bind(p.__defineSetter__),a=u.bind(p.__lookupGetter__),l=u.bind(p.__lookupSetter__)),2!=[1,2].splice(0).length&&((d=[]).splice.apply(d,I(20)),d.splice.apply(d,I(26)),h=d.length,d.splice(5,0,"XXX"),d.length,h+1==d.length?(n=Array.prototype.splice,Array.prototype.splice=function(e,t){return arguments.length?n.apply(this,[void 0===e?0:e,void 0===t?this.length-e:t].concat(m.call(arguments,2))):[];}):Array.prototype.splice=function(e,t){var i=this.length;0<e?i<e&&(e=i):null==e?e=0:e<0&&(e=Math.max(i+e,0)),e+t<i||(t=i-e);var n=this.slice(e,e+t),r=m.call(arguments,2),o=r.length;if(e===i)o&&this.push.apply(this,r);else{var s=Math.min(t,i-e),a=e+s,l=a+o-s,c=i-a,h=i-s;if(l<a)for(var d=0;d<c;++d){this[l+d]=this[a+d];}else if(a<l)for(d=c;d--;){this[l+d]=this[a+d];}if(o&&e===h)this.length=h,this.push.apply(this,r);else for(this.length=h+o,d=0;d<o;++d){this[e+d]=r[d];}}return n;}),Array.isArray||(Array.isArray=function(e){return"[object Array]"==f(e);});var A,v,b,y,w=Object("a"),S="a"!=w[0]||!(0 in w);function x(e){try{return Object.defineProperty(e,"sentinel",{}),"sentinel"in e;}catch(e){}}Array.prototype.forEach||(Array.prototype.forEach=function(e,t){var i=_(this),n=S&&"[object String]"==f(this)?this.split(""):i,r=t,o=-1,s=n.length>>>0;if("[object Function]"!=f(e))throw new TypeError();for(;++o<s;){o in n&&e.call(r,n[o],o,i);}}),Array.prototype.map||(Array.prototype.map=function(e,t){var i=_(this),n=S&&"[object String]"==f(this)?this.split(""):i,r=n.length>>>0,o=Array(r),s=t;if("[object Function]"!=f(e))throw new TypeError(e+" is not a function");for(var a=0;a<r;a++){a in n&&(o[a]=e.call(s,n[a],a,i));}return o;}),Array.prototype.filter||(Array.prototype.filter=function(e,t){var i,n=_(this),r=S&&"[object String]"==f(this)?this.split(""):n,o=r.length>>>0,s=[],a=t;if("[object Function]"!=f(e))throw new TypeError(e+" is not a function");for(var l=0;l<o;l++){l in r&&(i=r[l],e.call(a,i,l,n)&&s.push(i));}return s;}),Array.prototype.every||(Array.prototype.every=function(e,t){var i=_(this),n=S&&"[object String]"==f(this)?this.split(""):i,r=n.length>>>0,o=t;if("[object Function]"!=f(e))throw new TypeError(e+" is not a function");for(var s=0;s<r;s++){if(s in n&&!e.call(o,n[s],s,i))return!1;}return!0;}),Array.prototype.some||(Array.prototype.some=function(e,t){var i=_(this),n=S&&"[object String]"==f(this)?this.split(""):i,r=n.length>>>0,o=t;if("[object Function]"!=f(e))throw new TypeError(e+" is not a function");for(var s=0;s<r;s++){if(s in n&&e.call(o,n[s],s,i))return!0;}return!1;}),Array.prototype.reduce||(Array.prototype.reduce=function(e,t){var i=_(this),n=S&&"[object String]"==f(this)?this.split(""):i,r=n.length>>>0;if("[object Function]"!=f(e))throw new TypeError(e+" is not a function");if(!r&&1==arguments.length)throw new TypeError("reduce of empty array with no initial value");var o,s=0;if(2<=arguments.length)o=t;else for(;;){if(s in n){o=n[s++];break;}if(++s>=r)throw new TypeError("reduce of empty array with no initial value");}for(;s<r;s++){s in n&&(o=e.call(void 0,o,n[s],s,i));}return o;}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(e,t){var i=_(this),n=S&&"[object String]"==f(this)?this.split(""):i,r=n.length>>>0;if("[object Function]"!=f(e))throw new TypeError(e+" is not a function");if(!r&&1==arguments.length)throw new TypeError("reduceRight of empty array with no initial value");var o,s=r-1;if(2<=arguments.length)o=t;else for(;;){if(s in n){o=n[s--];break;}if(--s<0)throw new TypeError("reduceRight of empty array with no initial value");}for(;s in this&&(o=e.call(void 0,o,n[s],s,i)),s--;){}return o;}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(e,t){var i=S&&"[object String]"==f(this)?this.split(""):_(this),n=i.length>>>0;if(!n)return-1;var r=0;for(1<arguments.length&&(r=W(t)),r=0<=r?r:Math.max(0,n+r);r<n;r++){if(r in i&&i[r]===e)return r;}return-1;}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(e,t){var i=S&&"[object String]"==f(this)?this.split(""):_(this),n=i.length>>>0;if(!n)return-1;var r=n-1;for(1<arguments.length&&(r=Math.min(r,W(t))),r=0<=r?r:n-Math.abs(r);0<=r;r--){if(r in i&&e===i[r])return r;}return-1;}),Object.getPrototypeOf||(Object.getPrototypeOf=function(e){return e.__proto__||(e.constructor?e.constructor.prototype:p);}),Object.getOwnPropertyDescriptor||(Object.getOwnPropertyDescriptor=function(e,t){if("object"!=(typeof e==="undefined"?"undefined":_typeof(e))&&"function"!=typeof e||null===e)throw new TypeError("Object.getOwnPropertyDescriptor called on a non-object: "+e);if(C(e,t)){var i={enumerable:!0,configurable:!0};if(c){var n=e.__proto__;e.__proto__=p;var r=a(e,t),o=l(e,t);if(e.__proto__=n,r||o)return r&&(i.get=r),o&&(i.set=o),i;}return i.value=e[t],i;}}),Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(e){return Object.keys(e);}),Object.create||(A=null===Object.prototype.__proto__?function(){return{__proto__:null};}:function(){var e={};for(var t in e){e[t]=null;}return e.constructor=e.hasOwnProperty=e.propertyIsEnumerable=e.isPrototypeOf=e.toLocaleString=e.toString=e.valueOf=e.__proto__=null,e;},Object.create=function(e,t){var i;if(null===e)i=A();else{var _n=function _n(){};if("object"!=(typeof e==="undefined"?"undefined":_typeof(e)))throw new TypeError("typeof prototype["+(typeof e==="undefined"?"undefined":_typeof(e))+"] != 'object'");_n.prototype=e,(i=new _n()).__proto__=e;}return void 0!==t&&Object.defineProperties(i,t),i;}),Object.defineProperty&&(v=x({}),b="undefined"==typeof document||x(document.createElement("div")),v&&b||(y=Object.defineProperty)),Object.defineProperty&&!y||(Object.defineProperty=function(e,t,i){if("object"!=(typeof e==="undefined"?"undefined":_typeof(e))&&"function"!=typeof e||null===e)throw new TypeError("Object.defineProperty called on non-object: "+e);if("object"!=(typeof i==="undefined"?"undefined":_typeof(i))&&"function"!=typeof i||null===i)throw new TypeError("Property description must be an object: "+i);if(y)try{return y.call(Object,e,t,i);}catch(e){}if(C(i,"value")){var n;c&&(a(e,t)||l(e,t))?(n=e.__proto__,e.__proto__=p,delete e[t],e[t]=i.value,e.__proto__=n):e[t]=i.value;}else{if(!c)throw new TypeError("getters & setters can not be defined on this javascript engine");C(i,"get")&&r(e,t,i.get),C(i,"set")&&s(e,t,i.set);}return e;}),Object.defineProperties||(Object.defineProperties=function(e,t){for(var i in t){C(t,i)&&Object.defineProperty(e,i,t[i]);}return e;}),Object.seal||(Object.seal=function(e){return e;}),Object.freeze||(Object.freeze=function(e){return e;});try{Object.freeze(function(){});}catch(e){Object.freeze=function(t){return function(e){return"function"==typeof e?e:t(e);};}(Object.freeze);}if(Object.preventExtensions||(Object.preventExtensions=function(e){return e;}),Object.isSealed||(Object.isSealed=function(){return!1;}),Object.isFrozen||(Object.isFrozen=function(){return!1;}),Object.isExtensible||(Object.isExtensible=function(e){if(Object(e)===e)throw new TypeError();for(var t="";C(e,t);){t+="?";}e[t]=!0;var i=C(e,t);return delete e[t],i;}),!Object.keys){var k=!0,R=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],E=R.length;for(var B in{toString:null}){k=!1;}Object.keys=function(e){if("object"!=(typeof e==="undefined"?"undefined":_typeof(e))&&"function"!=typeof e||null===e)throw new TypeError("Object.keys called on a non-object");var t=[];for(var i in e){C(e,i)&&t.push(i);}if(k)for(var n=0,r=E;n<r;n++){var o=R[n];C(e,o)&&t.push(o);}return t;};}Date.now||(Date.now=function(){return new Date().getTime();});var Z,T,G="\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";function W(e){return(e=+e)!=e?e=0:0!==e&&e!==1/0&&e!==-1/0&&(e=(0<e||-1)*Math.floor(Math.abs(e))),e;}String.prototype.trim||(G="["+G+"]",Z=new RegExp("^"+G+G+"*"),T=new RegExp(G+G+"*$"),String.prototype.trim=function(){return String(this).replace(Z,"").replace(T,"");});var _=function _(e){if(null==e)throw new TypeError("can't convert "+e+" to object");return Object(e);};}),ace.define("ace/lib/fixoldbrowsers",["require","exports","module","ace/lib/regexp","ace/lib/es5-shim"],function(e,t,i){"use strict";e("./regexp"),e("./es5-shim"),"undefined"==typeof Element||Element.prototype.remove||Object.defineProperty(Element.prototype,"remove",{enumerable:!1,writable:!0,configurable:!0,value:function value(){this.parentNode&&this.parentNode.removeChild(this);}});}),ace.define("ace/lib/useragent",["require","exports","module"],function(e,t,i){"use strict";t.OS={LINUX:"LINUX",MAC:"MAC",WINDOWS:"WINDOWS"},t.getOS=function(){return t.isMac?t.OS.MAC:t.isLinux?t.OS.LINUX:t.OS.WINDOWS;};var n="object"==(typeof navigator==="undefined"?"undefined":_typeof(navigator))?navigator:{},r=(/mac|win|linux/i.exec(n.platform)||["other"])[0].toLowerCase(),o=n.userAgent||"",s=n.appName||"";t.isWin="win"==r,t.isMac="mac"==r,t.isLinux="linux"==r,t.isIE="Microsoft Internet Explorer"==s||0<=s.indexOf("MSAppHost")?parseFloat((o.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]):parseFloat((o.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]),t.isOldIE=t.isIE&&t.isIE<9,t.isGecko=t.isMozilla=o.match(/ Gecko\/\d+/),t.isOpera="object"==(typeof opera==="undefined"?"undefined":_typeof(opera))&&"[object Opera]"==Object.prototype.toString.call(window.opera),t.isWebKit=parseFloat(o.split("WebKit/")[1])||void 0,t.isChrome=parseFloat(o.split(" Chrome/")[1])||void 0,t.isEdge=parseFloat(o.split(" Edge/")[1])||void 0,t.isAIR=0<=o.indexOf("AdobeAIR"),t.isAndroid=0<=o.indexOf("Android"),t.isChromeOS=0<=o.indexOf(" CrOS "),t.isIOS=/iPad|iPhone|iPod/.test(o)&&!window.MSStream,t.isIOS&&(t.isMac=!0),t.isMobile=t.isIOS||t.isAndroid;}),ace.define("ace/lib/dom",["require","exports","module","ace/lib/useragent"],function(e,a,t){"use strict";var i,n=e("./useragent");a.buildDom=function e(t,i,n){if("string"==typeof t&&t){var r=document.createTextNode(t);return i&&i.appendChild(r),r;}if(!Array.isArray(t))return t&&t.appendChild&&i&&i.appendChild(t),t;if("string"!=typeof t[0]||!t[0]){for(var o=[],s=0;s<t.length;s++){var a=e(t[s],i,n);a&&o.push(a);}return o;}var l=document.createElement(t[0]),c=t[1],h=1;c&&"object"==(typeof c==="undefined"?"undefined":_typeof(c))&&!Array.isArray(c)&&(h=2);for(s=h;s<t.length;s++){e(t[s],l,n);}return 2==h&&Object.keys(c).forEach(function(e){var t=c[e];"class"===e?l.className=Array.isArray(t)?t.join(" "):t:"function"==typeof t||"value"==e||"$"==e[0]?l[e]=t:"ref"===e?n&&(n[t]=l):null!=t&&l.setAttribute(e,t);}),i&&i.appendChild(l),l;},a.getDocumentHead=function(e){return(e=e||document).head||e.getElementsByTagName("head")[0]||e.documentElement;},a.createElement=function(e,t){return document.createElementNS?document.createElementNS(t||"http://www.w3.org/1999/xhtml",e):document.createElement(e);},a.removeChildren=function(e){e.innerHTML="";},a.createTextNode=function(e,t){return(t?t.ownerDocument:document).createTextNode(e);},a.createFragment=function(e){return(e?e.ownerDocument:document).createDocumentFragment();},a.hasCssClass=function(e,t){return-1!==(e.className+"").split(/\s+/g).indexOf(t);},a.addCssClass=function(e,t){a.hasCssClass(e,t)||(e.className+=" "+t);},a.removeCssClass=function(e,t){for(var i=e.className.split(/\s+/g);;){var n=i.indexOf(t);if(-1==n)break;i.splice(n,1);}e.className=i.join(" ");},a.toggleCssClass=function(e,t){for(var i=e.className.split(/\s+/g),n=!0;;){var r=i.indexOf(t);if(-1==r)break;n=!1,i.splice(r,1);}return n&&i.push(t),e.className=i.join(" "),n;},a.setCssClass=function(e,t,i){i?a.addCssClass(e,t):a.removeCssClass(e,t);},a.hasCssString=function(e,t){var i,n=0;if(i=(t=t||document).querySelectorAll("style"))for(;n<i.length;){if(i[n++].id===e)return!0;}},a.importCssString=function(e,t,i){var n=i;i&&i.getRootNode&&(n=i.getRootNode())&&n!=i||(n=document);var r=n.ownerDocument||n;if(t&&a.hasCssString(t,n))return null;t&&(e+="\n/*# sourceURL=ace/css/"+t+" */");var o=a.createElement("style");o.appendChild(r.createTextNode(e)),t&&(o.id=t),n==r&&(n=a.getDocumentHead(r)),n.insertBefore(o,n.firstChild);},a.importCssStylsheet=function(e,t){a.buildDom(["link",{rel:"stylesheet",href:e}],a.getDocumentHead(t));},a.scrollbarWidth=function(e){var t=a.createElement("ace_inner");t.style.width="100%",t.style.minWidth="0px",t.style.height="200px",t.style.display="block";var i=a.createElement("ace_outer"),n=i.style;n.position="absolute",n.left="-10000px",n.overflow="hidden",n.width="200px",n.minWidth="0px",n.height="150px",n.display="block",i.appendChild(t);var r=e.documentElement;r.appendChild(i);var o=t.offsetWidth;n.overflow="scroll";var s=t.offsetWidth;return o==s&&(s=i.clientWidth),r.removeChild(i),o-s;},"undefined"==typeof document&&(a.importCssString=function(){}),a.computedStyle=function(e,t){return window.getComputedStyle(e,"")||{};},a.setStyle=function(e,t,i){e[t]!==i&&(e[t]=i);},a.HAS_CSS_ANIMATION=!1,a.HAS_CSS_TRANSFORMS=!1,a.HI_DPI=!n.isWin||"undefined"!=typeof window&&1.5<=window.devicePixelRatio,"undefined"!=typeof document&&(i=document.createElement("div"),a.HI_DPI&&void 0!==i.style.transform&&(a.HAS_CSS_TRANSFORMS=!0),n.isEdge||void 0===i.style.animationName||(a.HAS_CSS_ANIMATION=!0),i=null),a.HAS_CSS_TRANSFORMS?a.translate=function(e,t,i){e.style.transform="translate("+Math.round(t)+"px, "+Math.round(i)+"px)";}:a.translate=function(e,t,i){e.style.top=Math.round(i)+"px",e.style.left=Math.round(t)+"px";};}),ace.define("ace/lib/oop",["require","exports","module"],function(e,i,t){"use strict";i.inherits=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}});},i.mixin=function(e,t){for(var i in t){e[i]=t[i];}return e;},i.implement=function(e,t){i.mixin(e,t);};}),ace.define("ace/lib/keys",["require","exports","module","ace/lib/oop"],function(e,t,i){"use strict";var n=e("./oop"),r=function(){var e,t,i={MODIFIER_KEYS:{16:"Shift",17:"Ctrl",18:"Alt",224:"Meta",91:"MetaLeft",92:"MetaRight",93:"ContextMenu"},KEY_MODS:{ctrl:1,alt:2,option:2,shift:4,super:8,meta:8,command:8,cmd:8,control:1},FUNCTION_KEYS:{8:"Backspace",9:"Tab",13:"Return",19:"Pause",27:"Esc",32:"Space",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"Left",38:"Up",39:"Right",40:"Down",44:"Print",45:"Insert",46:"Delete",96:"Numpad0",97:"Numpad1",98:"Numpad2",99:"Numpad3",100:"Numpad4",101:"Numpad5",102:"Numpad6",103:"Numpad7",104:"Numpad8",105:"Numpad9","-13":"NumpadEnter",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"Numlock",145:"Scrolllock"},PRINTABLE_KEYS:{32:" ",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",59:";",61:"=",65:"a",66:"b",67:"c",68:"d",69:"e",70:"f",71:"g",72:"h",73:"i",74:"j",75:"k",76:"l",77:"m",78:"n",79:"o",80:"p",81:"q",82:"r",83:"s",84:"t",85:"u",86:"v",87:"w",88:"x",89:"y",90:"z",107:"+",109:"-",110:".",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'",111:"/",106:"*"}};for(t in i.FUNCTION_KEYS){e=i.FUNCTION_KEYS[t].toLowerCase(),i[e]=parseInt(t,10);}for(t in i.PRINTABLE_KEYS){e=i.PRINTABLE_KEYS[t].toLowerCase(),i[e]=parseInt(t,10);}return n.mixin(i,i.MODIFIER_KEYS),n.mixin(i,i.PRINTABLE_KEYS),n.mixin(i,i.FUNCTION_KEYS),i.enter=i.return,i.escape=i.esc,i.del=i.delete,i[173]="-",function(){for(var e=["cmd","ctrl","alt","shift"],t=Math.pow(2,e.length);t--;){i.KEY_MODS[t]=e.filter(function(e){return t&i.KEY_MODS[e];}).join("-")+"-";}}(),i.KEY_MODS[0]="",i.KEY_MODS[-1]="input-",i;}();n.mixin(t,r),t.keyCodeToString=function(e){var t=r[e];return"string"!=typeof t&&(t=String.fromCharCode(e)),t.toLowerCase();};}),ace.define("ace/lib/event",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,d,t){"use strict";var i,o=e("./keys"),u=e("./useragent"),s=null,a=0;function r(){return null==i&&function(){i=!1;try{document.createComment("").addEventListener("test",function(){},{get passive(){i={passive:!1};}});}catch(e){}}(),i;}function l(e,t,i){this.elem=e,this.type=t,this.callback=i;}l.prototype.destroy=function(){c(this.elem,this.type,this.callback),this.elem=this.type=this.callback=void 0;};var g=d.addListener=function(e,t,i,n){e.addEventListener(t,i,r()),n&&n.$toDestroy.push(new l(e,t,i));},c=d.removeListener=function(e,t,i){e.removeEventListener(t,i,r());};d.stopEvent=function(e){return d.stopPropagation(e),d.preventDefault(e),!1;},d.stopPropagation=function(e){e.stopPropagation&&e.stopPropagation();},d.preventDefault=function(e){e.preventDefault&&e.preventDefault();},d.getButton=function(e){return"dblclick"==e.type?0:"contextmenu"==e.type||u.isMac&&e.ctrlKey&&!e.altKey&&!e.shiftKey?2:e.button;},d.capture=function(e,t,i){function n(e){t&&t(e),i&&i(e),c(document,"mousemove",t),c(document,"mouseup",n),c(document,"dragstart",n);}return g(document,"mousemove",t),g(document,"mouseup",n),g(document,"dragstart",n),n;},d.addMouseWheelListener=function(e,t,i){"onmousewheel"in e?g(e,"mousewheel",function(e){void 0!==e.wheelDeltaX?(e.wheelX=-e.wheelDeltaX/8,e.wheelY=-e.wheelDeltaY/8):(e.wheelX=0,e.wheelY=-e.wheelDelta/8),t(e);},i):"onwheel"in e?g(e,"wheel",function(e){switch(e.deltaMode){case e.DOM_DELTA_PIXEL:e.wheelX=.35*e.deltaX||0,e.wheelY=.35*e.deltaY||0;break;case e.DOM_DELTA_LINE:case e.DOM_DELTA_PAGE:e.wheelX=5*(e.deltaX||0),e.wheelY=5*(e.deltaY||0);}t(e);},i):g(e,"DOMMouseScroll",function(e){e.axis&&e.axis==e.HORIZONTAL_AXIS?(e.wheelX=5*(e.detail||0),e.wheelY=0):(e.wheelX=0,e.wheelY=5*(e.detail||0)),t(e);},i);},d.addMultiMouseDownListener=function(e,i,n,r,t){var o,s,a,l=0,c={2:"dblclick",3:"tripleclick",4:"quadclick"};function h(e){var t;if(0!==d.getButton(e)?l=0:1<e.detail&&!(4<++l)||(l=1),u.isIE&&(t=5<Math.abs(e.clientX-o)||5<Math.abs(e.clientY-s),a&&!t||(l=1),a&&clearTimeout(a),a=setTimeout(function(){a=null;},i[l-1]||600),1==l&&(o=e.clientX,s=e.clientY)),e._clicks=l,n[r]("mousedown",e),4<l)l=0;else if(1<l)return n[r](c[l],e);}Array.isArray(e)||(e=[e]),e.forEach(function(e){g(e,"mousedown",h,t);});};function h(e){return 0|(e.ctrlKey?1:0)|(e.altKey?2:0)|(e.shiftKey?4:0)|(e.metaKey?8:0);}var p;function m(e,t,i){var n,r=h(t);if(!u.isMac&&s){if(t.getModifierState&&(t.getModifierState("OS")||t.getModifierState("Win"))&&(r|=8),s.altGr){if(3==(3&r))return;s.altGr=0;}18!==i&&17!==i||(n="location"in t?t.location:t.keyLocation,17===i&&1===n?1==s[i]&&(a=t.timeStamp):18===i&&3===r&&2===n&&t.timeStamp-a<50&&(s.altGr=!0));}if((i in o.MODIFIER_KEYS&&(i=-1),!r&&13===i)&&3===(n="location"in t?t.location:t.keyLocation)&&(e(t,r,-i),t.defaultPrevented))return;if(u.isChromeOS&&8&r){if(e(t,r,i),t.defaultPrevented)return;r&=-9;}return!!(r||i in o.FUNCTION_KEYS||i in o.PRINTABLE_KEYS)&&e(t,r,i);}function f(){s=Object.create(null);}d.getModifierString=function(e){return o.KEY_MODS[h(e)];},d.addCommandKeyListener=function(e,i,t){var n,r;u.isOldGecko||u.isOpera&&!("KeyboardEvent"in window)?(n=null,g(e,"keydown",function(e){n=e.keyCode;},t),g(e,"keypress",function(e){return m(i,e,n);},t)):(r=null,g(e,"keydown",function(e){s[e.keyCode]=(s[e.keyCode]||0)+1;var t=m(i,e,e.keyCode);return r=e.defaultPrevented,t;},t),g(e,"keypress",function(e){r&&(e.ctrlKey||e.altKey||e.shiftKey||e.metaKey)&&(d.stopEvent(e),r=null);},t),g(e,"keyup",function(e){s[e.keyCode]=null;},t),s||(f(),g(window,"focus",f)));},"object"==(typeof window==="undefined"?"undefined":_typeof(window))&&window.postMessage&&!u.isOldIE&&(p=1,d.nextTick=function(t,i){i=i||window;var n="zero-timeout-message-"+p++,r=function r(e){e.data==n&&(d.stopPropagation(e),c(i,"message",r),t());};g(i,"message",r),i.postMessage(n,"*");}),d.$idleBlocked=!1,d.onIdle=function(t,e){return setTimeout(function e(){d.$idleBlocked?setTimeout(e,100):t();},e);},d.$idleBlockId=null,d.blockIdle=function(e){d.$idleBlockId&&clearTimeout(d.$idleBlockId),d.$idleBlocked=!0,d.$idleBlockId=setTimeout(function(){d.$idleBlocked=!1;},e||100);},d.nextFrame="object"==(typeof window==="undefined"?"undefined":_typeof(window))&&(window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame),d.nextFrame?d.nextFrame=d.nextFrame.bind(window):d.nextFrame=function(e){setTimeout(e,17);};}),ace.define("ace/range",["require","exports","module"],function(e,t,i){"use strict";function o(e,t,i,n){this.start={row:e,column:t},this.end={row:i,column:n};}(function(){this.isEqual=function(e){return this.start.row===e.start.row&&this.end.row===e.end.row&&this.start.column===e.start.column&&this.end.column===e.end.column;},this.toString=function(){return"Range: ["+this.start.row+"/"+this.start.column+"] -> ["+this.end.row+"/"+this.end.column+"]";},this.contains=function(e,t){return 0==this.compare(e,t);},this.compareRange=function(e){var t=e.end,i=e.start,n=this.compare(t.row,t.column);return 1==n?1==(n=this.compare(i.row,i.column))?2:0==n?1:0:-1==n?-2:-1==(n=this.compare(i.row,i.column))?-1:1==n?42:0;},this.comparePoint=function(e){return this.compare(e.row,e.column);},this.containsRange=function(e){return 0==this.comparePoint(e.start)&&0==this.comparePoint(e.end);},this.intersects=function(e){var t=this.compareRange(e);return-1==t||0==t||1==t;},this.isEnd=function(e,t){return this.end.row==e&&this.end.column==t;},this.isStart=function(e,t){return this.start.row==e&&this.start.column==t;},this.setStart=function(e,t){"object"==(typeof e==="undefined"?"undefined":_typeof(e))?(this.start.column=e.column,this.start.row=e.row):(this.start.row=e,this.start.column=t);},this.setEnd=function(e,t){"object"==(typeof e==="undefined"?"undefined":_typeof(e))?(this.end.column=e.column,this.end.row=e.row):(this.end.row=e,this.end.column=t);},this.inside=function(e,t){return 0==this.compare(e,t)&&!this.isEnd(e,t)&&!this.isStart(e,t);},this.insideStart=function(e,t){return 0==this.compare(e,t)&&!this.isEnd(e,t);},this.insideEnd=function(e,t){return 0==this.compare(e,t)&&!this.isStart(e,t);},this.compare=function(e,t){return this.isMultiLine()||e!==this.start.row?e<this.start.row?-1:e>this.end.row?1:this.start.row===e?t>=this.start.column?0:-1:this.end.row!==e||t<=this.end.column?0:1:t<this.start.column?-1:t>this.end.column?1:0;},this.compareStart=function(e,t){return this.start.row==e&&this.start.column==t?-1:this.compare(e,t);},this.compareEnd=function(e,t){return this.end.row==e&&this.end.column==t?1:this.compare(e,t);},this.compareInside=function(e,t){return this.end.row==e&&this.end.column==t?1:this.start.row==e&&this.start.column==t?-1:this.compare(e,t);},this.clipRows=function(e,t){var i,n;return this.end.row>t?i={row:t+1,column:0}:this.end.row<e&&(i={row:e,column:0}),this.start.row>t?n={row:t+1,column:0}:this.start.row<e&&(n={row:e,column:0}),o.fromPoints(n||this.start,i||this.end);},this.extend=function(e,t){var i,n,r=this.compare(e,t);return 0==r?this:(-1==r?i={row:e,column:t}:n={row:e,column:t},o.fromPoints(i||this.start,n||this.end));},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column;},this.isMultiLine=function(){return this.start.row!==this.end.row;},this.clone=function(){return o.fromPoints(this.start,this.end);},this.collapseRows=function(){return 0==this.end.column?new o(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new o(this.start.row,0,this.end.row,0);},this.toScreenRange=function(e){var t=e.documentToScreenPosition(this.start),i=e.documentToScreenPosition(this.end);return new o(t.row,t.column,i.row,i.column);},this.moveBy=function(e,t){this.start.row+=e,this.start.column+=t,this.end.row+=e,this.end.column+=t;};}).call(o.prototype),o.fromPoints=function(e,t){return new o(e.row,e.column,t.row,t.column);},o.comparePoints=function(e,t){return e.row-t.row||e.column-t.column;},o.comparePoints=function(e,t){return e.row-t.row||e.column-t.column;},t.Range=o;}),ace.define("ace/lib/lang",["require","exports","module"],function(e,t,i){"use strict";t.last=function(e){return e[e.length-1];},t.stringReverse=function(e){return e.split("").reverse().join("");},t.stringRepeat=function(e,t){for(var i="";0<t;){1&t&&(i+=e),(t>>=1)&&(e+=e);}return i;};var n=/^\s\s*/,r=/\s\s*$/;t.stringTrimLeft=function(e){return e.replace(n,"");},t.stringTrimRight=function(e){return e.replace(r,"");},t.copyObject=function(e){var t={};for(var i in e){t[i]=e[i];}return t;},t.copyArray=function(e){for(var t=[],i=0,n=e.length;i<n;i++){e[i]&&"object"==_typeof(e[i])?t[i]=this.copyObject(e[i]):t[i]=e[i];}return t;},t.deepCopy=function e(t){if("object"!=(typeof t==="undefined"?"undefined":_typeof(t))||!t)return t;var i;if(Array.isArray(t)){i=[];for(var n=0;n<t.length;n++){i[n]=e(t[n]);}return i;}if("[object Object]"!==Object.prototype.toString.call(t))return t;for(var n in i={},t){i[n]=e(t[n]);}return i;},t.arrayToMap=function(e){for(var t={},i=0;i<e.length;i++){t[e[i]]=1;}return t;},t.createMap=function(e){var t=Object.create(null);for(var i in e){t[i]=e[i];}return t;},t.arrayRemove=function(e,t){for(var i=0;i<=e.length;i++){t===e[i]&&e.splice(i,1);}},t.escapeRegExp=function(e){return e.replace(/([.*+?^${}()|[\]\/\\])/g,"\\$1");},t.escapeHTML=function(e){return(""+e).replace(/&/g,"&#38;").replace(/"/g,"&#34;").replace(/'/g,"&#39;").replace(/</g,"&#60;");},t.getMatchOffsets=function(e,t){var i=[];return e.replace(t,function(e){i.push({offset:arguments[arguments.length-2],length:e.length});}),i;},t.deferredCall=function(e){function t(){i=null,e();}var i=null,n=function n(e){return n.cancel(),i=setTimeout(t,e||0),n;};return(n.schedule=n).call=function(){return this.cancel(),e(),n;},n.cancel=function(){return clearTimeout(i),i=null,n;},n.isPending=function(){return i;},n;},t.delayedCall=function(e,t){function i(){r=null,e();}function n(e){null==r&&(r=setTimeout(i,e||t));}var r=null;return n.delay=function(e){r&&clearTimeout(r),r=setTimeout(i,e||t);},(n.schedule=n).call=function(){this.cancel(),e();},n.cancel=function(){r&&clearTimeout(r),r=null;},n.isPending=function(){return r;},n;};}),ace.define("ace/clipboard",["require","exports","module"],function(e,t,i){"use strict";var n;i.exports={lineMode:!1,pasteCancelled:function pasteCancelled(){return!!(n&&n>Date.now()-50)||(n=!1);},cancel:function cancel(){n=Date.now();}};}),ace.define("ace/keyboard/textinput",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/lib/dom","ace/lib/lang","ace/clipboard","ace/lib/keys"],function(e,t,i){"use strict";var G=e("../lib/event"),W=e("../lib/useragent"),_=e("../lib/dom"),H=e("../lib/lang"),L=e("../clipboard"),$=W.isChrome<18,V=W.isIE,N=63<W.isChrome,O=e("../lib/keys"),F=O.KEY_MODS,P=W.isIOS,K=P?/\s/:/\n/,M=W.isMobile;t.TextInput=function(e,d){var u=_.createElement("textarea");u.className="ace_text-input",u.setAttribute("wrap","off"),u.setAttribute("autocorrect","off"),u.setAttribute("autocapitalize","off"),u.setAttribute("spellcheck",!1),u.style.opacity="0",e.insertBefore(u,e.firstChild);var c=!1,g=!1,h=!1,p=!1,l="";M||(u.style.fontSize="1px");var m=!1,t=!1,f="",C=0,I=0,A=0;try{var v=document.activeElement===u;}catch(e){}G.addListener(u,"blur",function(e){t||(d.onBlur(e),v=!1);},d),G.addListener(u,"focus",function(e){if(!t){if(v=!0,W.isEdge)try{if(!document.hasFocus())return;}catch(e){}d.onFocus(e),W.isEdge?setTimeout(b):b();}},d),this.$focusScroll=!1,this.focus=function(){if(l||N||"browser"==this.$focusScroll)return u.focus({preventScroll:!0});var e=u.style.top;u.style.position="fixed",u.style.top="0px";try{var t=0!=u.getBoundingClientRect().top;}catch(e){return;}var i=[];if(t)for(var n=u.parentElement;n&&1==n.nodeType;){i.push(n),n.setAttribute("ace_nocontext",!0),n=!n.parentElement&&n.getRootNode?n.getRootNode().host:n.parentElement;}u.focus({preventScroll:!0}),t&&i.forEach(function(e){e.removeAttribute("ace_nocontext");}),setTimeout(function(){u.style.position="","0px"==u.style.top&&(u.style.top=e);},0);},this.blur=function(){u.blur();},this.isFocused=function(){return v;},d.on("beforeEndOperation",function(){var e,t=d.curOp,i=t&&t.command&&t.command.name;"insertstring"!=i&&(e=i&&(t.docChanged||t.selectionChanged),h&&e&&(f=u.value="",k()),b());});var b=P?function(e){var t,i;!v||c&&!e||p||((t="\n ab"+(e=e||"")+"cde fg\n")!=u.value&&(u.value=f=t),i=4+(e.length||(d.selection.isEmpty()?0:1)),4==C&&I==i||u.setSelectionRange(4,i),C=4,I=i);}:function(){if(!h&&!p&&(v||w)){h=!0;var e,t,i,n,r,o=0,s=0,a="";d.session&&(t=(e=d.selection).getRange(),i=e.cursor.row,o=t.start.column,s=t.end.column,a=d.session.getLine(i),t.start.row!=i?(n=d.session.getLine(i-1),o=t.start.row<i-1?0:o,s+=n.length+1,a=n+"\n"+a):t.end.row!=i?(r=d.session.getLine(i+1),s=t.end.row>i+1?r.length:s,s+=a.length+1,a=a+"\n"+r):M&&0<i&&(a="\n"+a,s+=1,o+=1),400<a.length&&(o<400&&s<400?a=a.slice(0,400):(a="\n",o=0,s=1)));var l=a+"\n\n";if(l!=f&&(u.value=f=l,C=I=l.length),w&&(C=u.selectionStart,I=u.selectionEnd),I!=s||C!=o||u.selectionEnd!=I)try{u.setSelectionRange(o,s),C=o,I=s;}catch(e){}h=!1;}};this.resetSelection=b,v&&d.onFocus();var i=null;this.setInputHandler=function(e){i=e;};function n(e,t){if(w=w&&!1,g)return b(),e&&d.onPaste(e),g=!1,"";for(var i=u.selectionStart,n=u.selectionEnd,r=C,o=f.length-I,s=e,a=e.length-i,l=e.length-n,c=0;0<r&&f[c]==e[c];){c++,r--;}for(s=s.slice(c),c=1;0<o&&f.length-c>C-1&&f[f.length-c]==e[e.length-c];){c++,o--;}a-=c-1,l-=c-1;var h=s.length-c+1;return h<0&&(r=-h,h=0),s=s.slice(0,h),t||s||a||r||o||l?(p=!0,s&&!r&&!o&&!a&&!l||m?d.onTextInput(s):d.onTextInput(s,{extendLeft:r,extendRight:o,restoreStart:a,restoreEnd:l}),p=!1,f=e,C=i,I=n,A=l,s):"";}function r(e){if(h)return x();if(e&&e.inputType){if("historyUndo"==e.inputType)return d.execCommand("undo");if("historyRedo"==e.inputType)return d.execCommand("redo");}var t=u.value,i=n(t,!0);(500<t.length||K.test(i)||M&&C<1&&C==I)&&b();}function o(e,t){var i=d.getCopyText();if(!i)return G.preventDefault(e);S(e,i)?(P&&(b(i),c=i,setTimeout(function(){c=!1;},10)),t?d.onCut():d.onCopy(),G.preventDefault(e)):(c=!0,u.value=i,u.select(),setTimeout(function(){c=!1,b(),t?d.onCut():d.onCopy();}));}function s(e){o(e,!0);}function a(e){o(e,!1);}function y(e){var t=S(e);L.pasteCancelled()||("string"==typeof t?(t&&d.onPaste(t,e),W.isIE&&setTimeout(b),G.preventDefault(e)):(u.value="",g=!0));}var w=!(this.getInputHandler=function(){return i;}),S=function S(e,t,i){var n=e.clipboardData||window.clipboardData;if(n&&!$){var r=V||i?"Text":"text/plain";try{return t?!1!==n.setData(r,t):n.getData(r);}catch(e){if(!i)return S(e,t,!0);}}};G.addCommandKeyListener(u,d.onCommandKey.bind(d),d),G.addListener(u,"select",function(e){var t;h||(c?c=!1:0===(t=u).selectionStart&&t.selectionEnd>=f.length&&t.value===f&&f&&t.selectionEnd!==I?(d.selectAll(),b()):M&&u.selectionStart!=C&&b());},d),G.addListener(u,"input",r,d),G.addListener(u,"cut",s,d),G.addListener(u,"copy",a,d),G.addListener(u,"paste",y,d),"oncut"in u&&"oncopy"in u&&"onpaste"in u||G.addListener(e,"keydown",function(e){if((!W.isMac||e.metaKey)&&e.ctrlKey)switch(e.keyCode){case 67:a(e);break;case 86:y(e);break;case 88:s(e);}},d);var x=function x(){var e;if(h&&d.onCompositionUpdate&&!d.$readOnly)return m?R():void(h.useTextareaForIME?d.onCompositionUpdate(u.value):(e=u.value,n(e),h.markerRange&&(h.context&&(h.markerRange.start.column=h.selectionStart=h.context.compositionStartOffset),h.markerRange.end.column=h.markerRange.start.column+I-h.selectionStart+A)));},k=function k(e){d.onCompositionEnd&&!d.$readOnly&&(h=!1,d.onCompositionEnd(),d.off("mousedown",R),e&&r());};function R(){t=!0,u.blur(),u.focus(),t=!1;}var E,B=H.delayedCall(x,50).schedule.bind(null,null);function Z(){clearTimeout(E),E=setTimeout(function(){l&&(u.style.cssText=l,l=""),d.renderer.$isMousePressed=!1,d.renderer.$keepTextAreaAtCursor&&d.renderer.$moveTextAreaToCursor();},0);}G.addListener(u,"compositionstart",function(e){var t;h||!d.onCompositionStart||d.$readOnly||(h={},m||(e.data&&(h.useTextareaForIME=!1),setTimeout(x,0),d._signal("compositionStart"),d.on("mousedown",R),(t=d.getSelectionRange()).end.row=t.start.row,t.end.column=t.start.column,h.markerRange=t,h.selectionStart=C,d.onCompositionStart(h),h.useTextareaForIME?(f=u.value="",I=C=0):(u.msGetInputContext&&(h.context=u.msGetInputContext()),u.getInputContext&&(h.context=u.getInputContext()))));},d),G.addListener(u,"compositionupdate",x,d),G.addListener(u,"keyup",function(e){27==e.keyCode&&u.value.length<u.selectionStart&&(h||(f=u.value),C=I=-1,b()),B();},d),G.addListener(u,"keydown",B,d),G.addListener(u,"compositionend",k,d),this.getElement=function(){return u;},this.setCommandMode=function(e){m=e,u.readOnly=!1;},this.setReadOnly=function(e){m||(u.readOnly=e);},this.setCopyWithEmptySelection=function(e){},this.onContextMenu=function(e){w=!0,b(),d._emit("nativecontextmenu",{target:d,domEvent:e}),this.moveToMouse(e,!0);},this.moveToMouse=function(e,t){l=l||u.style.cssText,u.style.cssText=(t?"z-index:100000;":"")+(W.isIE?"opacity:0.1;":"")+"text-indent: -"+(C+I)*d.renderer.characterWidth*.5+"px;";function i(e){_.translate(u,e.clientX-s-2,Math.min(e.clientY-o-2,a));}var n=d.container.getBoundingClientRect(),r=_.computedStyle(d.container),o=n.top+(parseInt(r.borderTopWidth)||0),s=n.left+(parseInt(n.borderLeftWidth)||0),a=n.bottom-o-u.clientHeight-2;i(e),"mousedown"==e.type&&(d.renderer.$isMousePressed=!0,clearTimeout(E),W.isWin&&G.capture(d.container,i,Z));},this.onContextMenuClose=Z;function T(e){d.textInput.onContextMenu(e),Z();}G.addListener(u,"mouseup",T,d),G.addListener(u,"mousedown",function(e){e.preventDefault(),Z();},d),G.addListener(d.renderer.scroller,"contextmenu",T,d),G.addListener(u,"contextmenu",T,d),P&&function(s,a){var t=null,l=!1;a.addEventListener("keydown",function(e){t&&clearTimeout(t),l=!0;},!0),a.addEventListener("keyup",function(e){t=setTimeout(function(){l=!1;},100);},!0);function e(e){var t,i,n,r,o;document.activeElement===a&&(l||h||s.$mouseHandler.isMousePressed||c||(t=a.selectionStart,i=a.selectionEnd,n=null,(r=0)==t?n=O.up:1==t?n=O.home:I<i&&"\n"==f[i]?n=O.end:t<C&&" "==f[t-1]?(n=O.left,r=F.option):t<C||t==C&&I!=C&&t==i?n=O.left:I<i&&2<f.slice(0,i).split("\n").length?n=O.down:I<i&&" "==f[i-1]?(n=O.right,r=F.option):(I<i||i==I&&I!=C&&t==i)&&(n=O.right),t!==i&&(r|=F.shift),n&&(!s.onCommandKey({},r,n)&&s.commands&&(n=O.keyCodeToString(n),(o=s.commands.findKeyCommand(r,n))&&s.execCommand(o)),C=t,I=i,b(""))));}document.addEventListener("selectionchange",e),s.on("destroy",function(){document.removeEventListener("selectionchange",e);});}(d,u);},t.$setUserAgentForTests=function(e,t){M=e,P=t;};}),ace.define("ace/mouse/default_handlers",["require","exports","module","ace/lib/useragent"],function(e,t,i){"use strict";var o=e("../lib/useragent");function n(t){t.$clickSelection=null;var e=t.editor;e.setDefaultHandler("mousedown",this.onMouseDown.bind(t)),e.setDefaultHandler("dblclick",this.onDoubleClick.bind(t)),e.setDefaultHandler("tripleclick",this.onTripleClick.bind(t)),e.setDefaultHandler("quadclick",this.onQuadClick.bind(t)),e.setDefaultHandler("mousewheel",this.onMouseWheel.bind(t));["select","startSelect","selectEnd","selectAllEnd","selectByWordsEnd","selectByLinesEnd","dragWait","dragWaitEnd","focusWait"].forEach(function(e){t[e]=this[e];},this),t.selectByLines=this.extendSelectionBy.bind(t,"getLineRange"),t.selectByWords=this.extendSelectionBy.bind(t,"getWordRange");}function l(e,t){return(e.start.row==e.end.row?2*t.column-e.start.column-e.end.column:e.start.row!=e.end.row-1||e.start.column||e.end.column?2*t.row-e.start.row-e.end.row:t.column-4)<0?{cursor:e.start,anchor:e.end}:{cursor:e.end,anchor:e.start};}(function(){this.onMouseDown=function(e){var t=e.inSelection(),i=e.getDocumentPosition();this.mousedownEvent=e;var n=this.editor,r=e.getButton();return 0!==r?(!n.getSelectionRange().isEmpty()&&1!=r||n.selection.moveToPosition(i),void(2==r&&(n.textInput.onContextMenu(e.domEvent),o.isMozilla||e.preventDefault()))):(this.mousedownEvent.time=Date.now(),!t||n.isFocused()||(n.focus(),!this.$focusTimeout||this.$clickSelection||n.inMultiSelectMode)?(this.captureMouse(e),this.startSelect(i,1<e.domEvent._clicks),e.preventDefault()):(this.setState("focusWait"),void this.captureMouse(e)));},this.startSelect=function(e,t){e=e||this.editor.renderer.screenToTextCoordinates(this.x,this.y);var i=this.editor;this.mousedownEvent&&(this.mousedownEvent.getShiftKey()?i.selection.selectToPosition(e):t||i.selection.moveToPosition(e),t||this.select(),i.renderer.scroller.setCapture&&i.renderer.scroller.setCapture(),i.setStyle("ace_selecting"),this.setState("select"));},this.select=function(){var e,t,i,n=this.editor,r=n.renderer.screenToTextCoordinates(this.x,this.y);this.$clickSelection&&(i=-1==(e=this.$clickSelection.comparePoint(r))?this.$clickSelection.end:1==e?this.$clickSelection.start:(r=(t=l(this.$clickSelection,r)).cursor,t.anchor),n.selection.setSelectionAnchor(i.row,i.column)),n.selection.selectToPosition(r),n.renderer.scrollCursorIntoView();},this.extendSelectionBy=function(e){var t,i,n,r,o=this.editor,s=o.renderer.screenToTextCoordinates(this.x,this.y),a=o.selection[e](s.row,s.column);this.$clickSelection&&(t=this.$clickSelection.comparePoint(a.start),i=this.$clickSelection.comparePoint(a.end),-1==t&&i<=0?(r=this.$clickSelection.end,a.end.row==s.row&&a.end.column==s.column||(s=a.start)):1==i&&0<=t?(r=this.$clickSelection.start,a.start.row==s.row&&a.start.column==s.column||(s=a.end)):r=-1==t&&1==i?(s=a.end,a.start):(s=(n=l(this.$clickSelection,s)).cursor,n.anchor),o.selection.setSelectionAnchor(r.row,r.column)),o.selection.selectToPosition(s),o.renderer.scrollCursorIntoView();},this.selectEnd=this.selectAllEnd=this.selectByWordsEnd=this.selectByLinesEnd=function(){this.$clickSelection=null,this.editor.unsetStyle("ace_selecting"),this.editor.renderer.scroller.releaseCapture&&this.editor.renderer.scroller.releaseCapture();},this.focusWait=function(){var e,t,i,n,r=(e=this.mousedownEvent.x,t=this.mousedownEvent.y,i=this.x,n=this.y,Math.sqrt(Math.pow(i-e,2)+Math.pow(n-t,2))),o=Date.now();(0<r||o-this.mousedownEvent.time>this.$focusTimeout)&&this.startSelect(this.mousedownEvent.getDocumentPosition());},this.onDoubleClick=function(e){var t=e.getDocumentPosition(),i=this.editor,n=i.session.getBracketRange(t);n?(n.isEmpty()&&(n.start.column--,n.end.column++),this.setState("select")):(n=i.selection.getWordRange(t.row,t.column),this.setState("selectByWords")),this.$clickSelection=n,this.select();},this.onTripleClick=function(e){var t=e.getDocumentPosition(),i=this.editor;this.setState("selectByLines");var n=i.getSelectionRange();n.isMultiLine()&&n.contains(t.row,t.column)?(this.$clickSelection=i.selection.getLineRange(n.start.row),this.$clickSelection.end=i.selection.getLineRange(n.end.row).end):this.$clickSelection=i.selection.getLineRange(t.row),this.select();},this.onQuadClick=function(e){var t=this.editor;t.selectAll(),this.$clickSelection=t.getSelectionRange(),this.setState("selectAll");},this.onMouseWheel=function(e){if(!e.getAccelKey()){e.getShiftKey()&&e.wheelY&&!e.wheelX&&(e.wheelX=e.wheelY,e.wheelY=0);var t=this.editor;this.$lastScroll||(this.$lastScroll={t:0,vx:0,vy:0,allowed:0});var i=this.$lastScroll,n=e.domEvent.timeStamp,r=n-i.t,o=r?e.wheelX/r:i.vx,s=r?e.wheelY/r:i.vy;r<550&&(o=(o+i.vx)/2,s=(s+i.vy)/2);var a=Math.abs(o/s),l=!1;return 1<=a&&t.renderer.isScrollableBy(e.wheelX*e.speed,0)&&(l=!0),a<=1&&t.renderer.isScrollableBy(0,e.wheelY*e.speed)&&(l=!0),l?i.allowed=n:n-i.allowed<550&&(Math.abs(o)<=1.5*Math.abs(i.vx)&&Math.abs(s)<=1.5*Math.abs(i.vy)?(l=!0,i.allowed=n):i.allowed=0),i.t=n,i.vx=o,i.vy=s,l?(t.renderer.scrollBy(e.wheelX*e.speed,e.wheelY*e.speed),e.stop()):void 0;}};}).call(n.prototype),t.DefaultHandlers=n;}),ace.define("ace/tooltip",["require","exports","module","ace/lib/oop","ace/lib/dom"],function(e,t,i){"use strict";e("./lib/oop");var n=e("./lib/dom");function r(e){this.isOpen=!1,this.$element=null,this.$parentNode=e;}(function(){this.$init=function(){return this.$element=n.createElement("div"),this.$element.className="ace_tooltip",this.$element.style.display="none",this.$parentNode.appendChild(this.$element),this.$element;},this.getElement=function(){return this.$element||this.$init();},this.setText=function(e){this.getElement().textContent=e;},this.setHtml=function(e){this.getElement().innerHTML=e;},this.setPosition=function(e,t){this.getElement().style.left=e+"px",this.getElement().style.top=t+"px";},this.setClassName=function(e){n.addCssClass(this.getElement(),e);},this.show=function(e,t,i){null!=e&&this.setText(e),null!=t&&null!=i&&this.setPosition(t,i),this.isOpen||(this.getElement().style.display="block",this.isOpen=!0);},this.hide=function(){this.isOpen&&(this.getElement().style.display="none",this.isOpen=!1);},this.getHeight=function(){return this.getElement().offsetHeight;},this.getWidth=function(){return this.getElement().offsetWidth;},this.destroy=function(){this.isOpen=!1,this.$element&&this.$element.parentNode&&this.$element.parentNode.removeChild(this.$element);};}).call(r.prototype),t.Tooltip=r;}),ace.define("ace/mouse/default_gutter_handler",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/event","ace/tooltip"],function(e,t,i){"use strict";var n=e("../lib/dom"),r=e("../lib/oop"),o=e("../lib/event"),s=e("../tooltip").Tooltip;function p(e){s.call(this,e);}r.inherits(p,s),function(){this.setPosition=function(e,t){var i=window.innerWidth||document.documentElement.clientWidth,n=window.innerHeight||document.documentElement.clientHeight,r=this.getWidth(),o=this.getHeight();i<(e+=15)+r&&(e-=e+r-i),n<(t+=15)+o&&(t-=20+o),s.prototype.setPosition.call(this,e,t);};}.call(p.prototype),t.GutterHandler=function(s){var i,a,l,c=s.editor,h=c.renderer.$gutterLayer,d=new p(c.container);function u(){i=i&&clearTimeout(i),l&&(d.hide(),l=null,c._signal("hideGutterTooltip",d),c.off("mousewheel",u));}function g(e){d.setPosition(e.x,e.y);}s.editor.setDefaultHandler("guttermousedown",function(e){if(c.isFocused()&&0==e.getButton()&&"foldWidgets"!=h.getRegion(e)){var t=e.getDocumentPosition().row,i=c.session.selection;if(e.getShiftKey())i.selectTo(t,0);else{if(2==e.domEvent.detail)return c.selectAll(),e.preventDefault();s.$clickSelection=c.selection.getLineRange(t);}return s.setState("selectByLines"),s.captureMouse(e),e.preventDefault();}}),s.editor.setDefaultHandler("guttermousemove",function(e){var t=e.domEvent.target||e.domEvent.srcElement;if(n.hasCssClass(t,"ace_fold-widget"))return u();l&&s.$tooltipFollowsMouse&&g(e),a=e,i=i||setTimeout(function(){i=null,(a&&!s.isMousePressed?function(){var e,t,i=a.getDocumentPosition().row,n=h.$annotations[i];if(!n)return u();if(i==c.session.getLength()){var r=c.renderer.pixelToScreenCoordinates(0,a.y).row,o=a.$pos;if(r>c.session.documentToScreenRow(o.row,o.column))return u();}l!=n&&(l=n.text.join("<br/>"),d.setHtml(l),d.show(),c._signal("showGutterTooltip",d),c.on("mousewheel",u),s.$tooltipFollowsMouse?g(a):(e=a.domEvent.target.getBoundingClientRect(),(t=d.getElement().style).left=e.right+"px",t.top=e.bottom+"px"));}:u)();},50);}),o.addListener(c.renderer.$gutter,"mouseout",function(e){a=null,l&&!i&&(i=setTimeout(function(){i=null,u();},50));},c),c.on("changeSession",u);};}),ace.define("ace/mouse/mouse_event",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,i){"use strict";var n=e("../lib/event"),r=e("../lib/useragent"),o=t.MouseEvent=function(e,t){this.domEvent=e,this.editor=t,this.x=this.clientX=e.clientX,this.y=this.clientY=e.clientY,this.$pos=null,this.$inSelection=null,this.propagationStopped=!1,this.defaultPrevented=!1;};(function(){this.stopPropagation=function(){n.stopPropagation(this.domEvent),this.propagationStopped=!0;},this.preventDefault=function(){n.preventDefault(this.domEvent),this.defaultPrevented=!0;},this.stop=function(){this.stopPropagation(),this.preventDefault();},this.getDocumentPosition=function(){return this.$pos||(this.$pos=this.editor.renderer.screenToTextCoordinates(this.clientX,this.clientY)),this.$pos;},this.inSelection=function(){if(null!==this.$inSelection)return this.$inSelection;var e,t=this.editor.getSelectionRange();return t.isEmpty()?this.$inSelection=!1:(e=this.getDocumentPosition(),this.$inSelection=t.contains(e.row,e.column)),this.$inSelection;},this.getButton=function(){return n.getButton(this.domEvent);},this.getShiftKey=function(){return this.domEvent.shiftKey;},this.getAccelKey=r.isMac?function(){return this.domEvent.metaKey;}:function(){return this.domEvent.ctrlKey;};}).call(o.prototype);}),ace.define("ace/mouse/dragdrop_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"],function(e,t,i){"use strict";var w=e("../lib/dom"),S=e("../lib/event"),x=e("../lib/useragent");function n(t){var g=t.editor,n=w.createElement("img");n.src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",x.isOpera&&(n.style.cssText="width:1px;height:1px;position:fixed;top:0;left:0;z-index:2147483647;opacity:0;");["dragWait","dragWaitEnd","startDrag","dragReadyEnd","onMouseDrag"].forEach(function(e){t[e]=this[e];},this),g.on("mousedown",this.onMouseDown.bind(t));var i,p,m,e,r,s,o,a,f,l,c,h=g.container,d=0;function u(){var e,t,i,n,r,o=s;s=g.renderer.screenToTextCoordinates(p,m),e=s,t=o,i=Date.now(),n=!t||e.row!=t.row,r=!t||e.column!=t.column,!l||n||r?(g.moveCursorToPosition(e),l=i,c={x:p,y:m}):5<k(c.x,c.y,p,m)?l=null:200<=i-l&&(g.renderer.scrollCursorIntoView(),l=null),function(e,t){var i=Date.now(),n=g.renderer.layerConfig.lineHeight,r=g.renderer.layerConfig.characterWidth,o=g.renderer.scroller.getBoundingClientRect(),s={x:{left:p-o.left,right:o.right-p},y:{top:m-o.top,bottom:o.bottom-m}},a=Math.min(s.x.left,s.x.right),l=Math.min(s.y.top,s.y.bottom),c={row:e.row,column:e.column};a/r<=2&&(c.column+=s.x.left<s.x.right?-3:2),l/n<=1&&(c.row+=s.y.top<s.y.bottom?-1:1);var h=e.row!=c.row,d=e.column!=c.column,u=!t||e.row!=t.row;h||d&&!u?f?200<=i-f&&g.renderer.scrollCursorIntoView(c):f=i:f=null;}(s,o);}function C(){r=g.selection.toOrientedRange(),i=g.session.addMarker(r,"ace_selection",g.getSelectionStyle()),g.clearSelection(),g.isFocused()&&g.renderer.$cursorLayer.setBlinking(!1),clearInterval(e),u(),e=setInterval(u,20),d=0,S.addListener(document,"mousemove",v);}function I(){clearInterval(e),g.session.removeMarker(i),i=null,g.selection.fromOrientedRange(r),g.isFocused()&&!a&&g.$resetCursorStyle(),d=0,l=f=s=r=null,S.removeListener(document,"mousemove",v);}this.onDragStart=function(e){if(this.cancelDrag||!h.draggable){var t=this;return setTimeout(function(){t.startSelect(),t.captureMouse(e);},0),e.preventDefault();}r=g.getSelectionRange();var i=e.dataTransfer;i.effectAllowed=g.getReadOnly()?"copy":"copyMove",x.isOpera&&(g.container.appendChild(n),n.scrollTop=0),i.setDragImage&&i.setDragImage(n,0,0),x.isOpera&&g.container.removeChild(n),i.clearData(),i.setData("Text",g.session.getTextRange()),a=!0,this.setState("drag");},this.onDragEnd=function(e){var t;h.draggable=!1,a=!1,this.setState(null),g.getReadOnly()||(t=e.dataTransfer.dropEffect,o||"move"!=t||g.session.remove(g.getSelectionRange()),g.$resetCursorStyle()),this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle("");},this.onDragEnter=function(e){if(!g.getReadOnly()&&b(e.dataTransfer))return p=e.clientX,m=e.clientY,i||C(),d++,e.dataTransfer.dropEffect=o=y(e),S.preventDefault(e);},this.onDragOver=function(e){if(!g.getReadOnly()&&b(e.dataTransfer))return p=e.clientX,m=e.clientY,i||(C(),d++),null!==A&&(A=null),e.dataTransfer.dropEffect=o=y(e),S.preventDefault(e);},this.onDragLeave=function(e){if(--d<=0&&i)return I(),o=null,S.preventDefault(e);},this.onDrop=function(e){if(s){var t=e.dataTransfer;if(a)switch(o){case"move":r=r.contains(s.row,s.column)?{start:s,end:s}:g.moveText(r,s);break;case"copy":r=g.moveText(r,s,!0);}else{var i=t.getData("Text");r={start:s,end:g.session.insert(s,i)},g.focus(),o=null;}return I(),S.preventDefault(e);}},S.addListener(h,"dragstart",this.onDragStart.bind(t),g),S.addListener(h,"dragend",this.onDragEnd.bind(t),g),S.addListener(h,"dragenter",this.onDragEnter.bind(t),g),S.addListener(h,"dragover",this.onDragOver.bind(t),g),S.addListener(h,"dragleave",this.onDragLeave.bind(t),g),S.addListener(h,"drop",this.onDrop.bind(t),g);var A=null;function v(){null==A&&(A=setTimeout(function(){null!=A&&i&&I();},20));}function b(e){var t=e.types;return!t||Array.prototype.some.call(t,function(e){return"text/plain"==e||"Text"==e;});}function y(e){var t=["copy","copymove","all","uninitialized"],i=x.isMac?e.altKey:e.ctrlKey,n="uninitialized";try{n=e.dataTransfer.effectAllowed.toLowerCase();}catch(e){}var r="none";return i&&0<=t.indexOf(n)?r="copy":0<=["move","copymove","linkmove","all","uninitialized"].indexOf(n)?r="move":0<=t.indexOf(n)&&(r="copy"),r;}}function k(e,t,i,n){return Math.sqrt(Math.pow(i-e,2)+Math.pow(n-t,2));}(function(){this.dragWait=function(){Date.now()-this.mousedownEvent.time>this.editor.getDragDelay()&&this.startDrag();},this.dragWaitEnd=function(){this.editor.container.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()),this.selectEnd();},this.dragReadyEnd=function(e){this.editor.$resetCursorStyle(),this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle(""),this.dragWaitEnd();},this.startDrag=function(){this.cancelDrag=!1;var e=this.editor;e.container.draggable=!0,e.renderer.$cursorLayer.setBlinking(!1),e.setStyle("ace_dragging");var t=x.isWin?"default":"move";e.renderer.setCursorStyle(t),this.setState("dragReady");},this.onMouseDrag=function(e){var t=this.editor.container;x.isIE&&"dragReady"==this.state&&3<k(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y)&&t.dragDrop(),"dragWait"===this.state&&0<k(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y)&&(t.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()));},this.onMouseDown=function(e){if(this.$dragEnabled){this.mousedownEvent=e;var t=this.editor,i=e.inSelection(),n=e.getButton();if(1===(e.domEvent.detail||1)&&0===n&&i){if(e.editor.inMultiSelectMode&&(e.getAccelKey()||e.getShiftKey()))return;this.mousedownEvent.time=Date.now();var r=e.domEvent.target||e.domEvent.srcElement;"unselectable"in r&&(r.unselectable="on"),t.getDragDelay()?(x.isWebKit&&(this.cancelDrag=!0,t.container.draggable=!0),this.setState("dragWait")):this.startDrag(),this.captureMouse(e,this.onMouseDrag.bind(this)),e.defaultPrevented=!0;}}};}).call(n.prototype),t.DragdropHandler=n;}),ace.define("ace/mouse/touch_handler",["require","exports","module","ace/mouse/mouse_event","ace/lib/event","ace/lib/dom"],function(e,t,i){"use strict";var T=e("./mouse_event").MouseEvent,o=e("../lib/event"),a=e("../lib/dom");t.addTouchListeners=function(e,C){var I,A,v,b,y,t,w,S,s,x="scroll",k=0,R=0,E=0,B=0;function n(){function t(e){var t,i,n=e.target.getAttribute("action");if("more"==n||!o)return o=!o,t=C.getCopyText(),i=C.session.getUndoManager().hasUndo(),void s.replaceChild(a.buildDom(o?["span",!t&&["span",{class:"ace_mobile-button",action:"selectall"},"Select All"],t&&["span",{class:"ace_mobile-button",action:"copy"},"Copy"],t&&["span",{class:"ace_mobile-button",action:"cut"},"Cut"],r&&["span",{class:"ace_mobile-button",action:"paste"},"Paste"],i&&["span",{class:"ace_mobile-button",action:"undo"},"Undo"],["span",{class:"ace_mobile-button",action:"find"},"Find"],["span",{class:"ace_mobile-button",action:"openCommandPallete"},"Pallete"]]:["span"]),s.firstChild);"paste"==n?r.readText().then(function(e){C.execCommand(n,e);}):n&&("cut"!=n&&"copy"!=n||(r?r.writeText(C.getCopyText()):document.execCommand("copy")),C.execCommand(n)),s.firstChild.style.display="none",o=!1,"openCommandPallete"!=n&&C.focus();}var r=window.navigator&&window.navigator.clipboard,o=!1;s=a.buildDom(["div",{class:"ace_mobile-menu",ontouchstart:function ontouchstart(e){x="menu",e.stopPropagation(),e.preventDefault(),C.textInput.focus();},ontouchend:function ontouchend(e){e.stopPropagation(),e.preventDefault(),t(e);},onclick:t},["span"],["span",{class:"ace_mobile-button",action:"more"},"..."]],C.container);}function i(){s||n();var e=C.selection.cursor,t=C.renderer.textToScreenCoordinates(e.row,e.column),i=C.container.getBoundingClientRect();s.style.top=t.pageY-i.top-3+"px",s.style.right="10px",s.style.display="",s.firstChild.style.display="none",C.on("input",r);}function r(e){s&&(s.style.display="none"),C.off("input",r);}function Z(){y=null,clearTimeout(y);var e=C.selection.getRange(),t=e.contains(w.row,w.column);!e.isEmpty()&&t||(C.selection.moveToPosition(w),C.selection.selectWord()),x="wait",i();}o.addListener(e,"contextmenu",function(e){S&&C.textInput.getElement().focus();},C),o.addListener(e,"touchstart",function(e){var t=e.touches;if(y||1<t.length)return clearTimeout(y),y=null,v=-1,void(x="zoom");S=C.$mouseHandler.isMousePressed=!0;var i=C.renderer.layerConfig.lineHeight,n=C.renderer.layerConfig.lineHeight,r=e.timeStamp;b=r;var o=t[0],s=o.clientX,a=o.clientY;Math.abs(I-s)+Math.abs(A-a)>i&&(v=-1),I=e.clientX=s,A=e.clientY=a,E=B=0;var l=new T(e,C);if(w=l.getDocumentPosition(),r-v<500&&1==t.length&&!k)R++,e.preventDefault(),e.button=0,function(){y=null,clearTimeout(y),C.selection.moveToPosition(w);var e=2<=R?C.selection.getLineRange(w.row):C.session.getBracketRange(w);e&&!e.isEmpty()?C.selection.setRange(e):C.selection.selectWord(),x="wait";}();else{R=0;var c=C.selection.cursor,h=C.selection.isEmpty()?c:C.selection.anchor,d=C.renderer.$cursorLayer.getPixelPosition(c,!0),u=C.renderer.$cursorLayer.getPixelPosition(h,!0),g=C.renderer.scroller.getBoundingClientRect(),p=function p(e,t){return(e/=n)*e+(t=t/i-.75)*t;};if(e.clientX<g.left)return void(x="zoom");var m=p(e.clientX-g.left-d.left,e.clientY-g.top-d.top),f=p(e.clientX-g.left-u.left,e.clientY-g.top-u.top);m<3.5&&f<3.5&&(x=f<m?"cursor":"anchor"),x=f<3.5?"anchor":m<3.5?"cursor":"scroll",y=setTimeout(Z,450);}v=r;},C),o.addListener(e,"touchend",function(e){S=C.$mouseHandler.isMousePressed=!1,t&&clearInterval(t),"zoom"==x?(x="",k=0):y?(C.selection.moveToPosition(w),k=0,i()):"scroll"==x?(k+=60,t=setInterval(function(){k--<=0&&(clearInterval(t),t=null),Math.abs(E)<.01&&(E=0),Math.abs(B)<.01&&(B=0),k<20&&(E*=.9),k<20&&(B*=.9);var e=C.session.getScrollTop();C.renderer.scrollBy(10*E,10*B),e==C.session.getScrollTop()&&(k=0);},10),r()):i(),clearTimeout(y),y=null;},C),o.addListener(e,"touchmove",function(e){y&&(clearTimeout(y),y=null);var t=e.touches;if(!(1<t.length||"zoom"==x)){var i=t[0],n=I-i.clientX,r=A-i.clientY;if("wait"==x){if(!(4<n*n+r*r))return e.preventDefault();x="cursor";}I=i.clientX,A=i.clientY,e.clientX=i.clientX,e.clientY=i.clientY;var o,s,a=e.timeStamp,l=a-b;b=a,"scroll"==x?((o=new T(e,C)).speed=1,o.wheelX=n,o.wheelY=r,10*Math.abs(n)<Math.abs(r)&&(n=0),10*Math.abs(r)<Math.abs(n)&&(r=0),0!=l&&(E=n/l,B=r/l),C._emit("mousewheel",o),o.propagationStopped||(E=B=0)):(s=new T(e,C).getDocumentPosition(),"cursor"==x?C.selection.moveCursorToPosition(s):"anchor"==x&&C.selection.setSelectionAnchor(s.row,s.column),C.renderer.scrollCursorIntoView(s),e.preventDefault());}},C);};}),ace.define("ace/lib/net",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";var r=e("./dom");t.get=function(e,t){var i=new XMLHttpRequest();i.open("GET",e,!0),i.onreadystatechange=function(){4===i.readyState&&t(i.responseText);},i.send(null);},t.loadScript=function(e,i){var t=r.getDocumentHead(),n=document.createElement("script");n.src=e,t.appendChild(n),n.onload=n.onreadystatechange=function(e,t){!t&&n.readyState&&"loaded"!=n.readyState&&"complete"!=n.readyState||(n=n.onload=n.onreadystatechange=null,t||i());};},t.qualifyURL=function(e){var t=document.createElement("a");return t.href=e,t.href;};}),ace.define("ace/lib/event_emitter",["require","exports","module"],function(e,t,i){"use strict";function o(){this.propagationStopped=!0;}function s(){this.defaultPrevented=!0;}var n={};n._emit=n._dispatchEvent=function(e,t){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var i=this._eventRegistry[e]||[],n=this._defaultHandlers[e];if(i.length||n){"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&t||(t={}),t.type||(t.type=e),t.stopPropagation||(t.stopPropagation=o),t.preventDefault||(t.preventDefault=s),i=i.slice();for(var r=0;r<i.length&&(i[r](t,this),!t.propagationStopped);r++){}return n&&!t.defaultPrevented?n(t,this):void 0;}},n._signal=function(e,t){var i=(this._eventRegistry||{})[e];if(i){i=i.slice();for(var n=0;n<i.length;n++){i[n](t,this);}}},n.once=function(t,i){var n=this;if(this.on(t,function e(){n.off(t,e),i.apply(null,arguments);}),!i)return new Promise(function(e){i=e;});},n.setDefaultHandler=function(e,t){var i,n,r,o=this._defaultHandlers;(o=o||(this._defaultHandlers={_disabled_:{}}))[e]&&(i=o[e],(n=o._disabled_[e])||(o._disabled_[e]=n=[]),n.push(i),-1!=(r=n.indexOf(t))&&n.splice(r,1)),o[e]=t;},n.removeDefaultHandler=function(e,t){var i,n,r=this._defaultHandlers;r&&(i=r._disabled_[e],r[e]==t?i&&this.setDefaultHandler(e,i.pop()):!i||-1!=(n=i.indexOf(t))&&i.splice(n,1));},n.on=n.addEventListener=function(e,t,i){this._eventRegistry=this._eventRegistry||{};var n=this._eventRegistry[e];return-1==(n=n||(this._eventRegistry[e]=[])).indexOf(t)&&n[i?"unshift":"push"](t),t;},n.off=n.removeListener=n.removeEventListener=function(e,t){this._eventRegistry=this._eventRegistry||{};var i,n=this._eventRegistry[e];!n||-1!==(i=n.indexOf(t))&&n.splice(i,1);},n.removeAllListeners=function(e){e||(this._eventRegistry=this._defaultHandlers=void 0),this._eventRegistry&&(this._eventRegistry[e]=void 0),this._defaultHandlers&&(this._defaultHandlers[e]=void 0);},t.EventEmitter=n;}),ace.define("ace/lib/app_config",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,i){var r=e("./oop"),n=e("./event_emitter").EventEmitter,o={setOptions:function setOptions(t){Object.keys(t).forEach(function(e){this.setOption(e,t[e]);},this);},getOptions:function getOptions(e){var t,i={};return e?Array.isArray(e)||(i=e,e=Object.keys(i)):(t=this.$options,e=Object.keys(t).filter(function(e){return!t[e].hidden;})),e.forEach(function(e){i[e]=this.getOption(e);},this),i;},setOption:function setOption(e,t){if(this["$"+e]!==t){var i=this.$options[e];if(!i)return s('misspelled option "'+e+'"');if(i.forwardTo)return this[i.forwardTo]&&this[i.forwardTo].setOption(e,t);i.handlesSet||(this["$"+e]=t),i&&i.set&&i.set.call(this,t);}},getOption:function getOption(e){var t=this.$options[e];return t?t.forwardTo?this[t.forwardTo]&&this[t.forwardTo].getOption(e):t&&t.get?t.get.call(this):this["$"+e]:s('misspelled option "'+e+'"');}};function s(e){"undefined"!=typeof console&&console.warn&&console.warn.apply(console,arguments);}function a(e,t){var i=new Error(e);i.data=t,"object"==(typeof console==="undefined"?"undefined":_typeof(console))&&console.error&&console.error(i),setTimeout(function(){throw i;});}function l(){this.$defaultOptions={};}(function(){r.implement(this,n),this.defineOptions=function(i,e,n){return i.$options||(this.$defaultOptions[e]=i.$options={}),Object.keys(n).forEach(function(e){var t=n[e];"string"==typeof t&&(t={forwardTo:t}),t.name||(t.name=e),"initialValue"in(i.$options[t.name]=t)&&(i["$"+t.name]=t.initialValue);}),r.implement(i,o),this;},this.resetOptions=function(i){Object.keys(i.$options).forEach(function(e){var t=i.$options[e];"value"in t&&i.setOption(e,t.value);});},this.setDefaultValue=function(e,t,i){if(!e){for(e in this.$defaultOptions){if(this.$defaultOptions[e][t])break;}if(!this.$defaultOptions[e][t])return!1;}var n=this.$defaultOptions[e]||(this.$defaultOptions[e]={});n[t]&&(n.forwardTo?this.setDefaultValue(n.forwardTo,t,i):n[t].value=i);},this.setDefaultValues=function(t,i){Object.keys(i).forEach(function(e){this.setDefaultValue(t,e,i[e]);},this);},this.warn=s,this.reportError=a;}).call(l.prototype),t.AppConfig=l;}),ace.define("ace/config",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/lib/net","ace/lib/app_config"],function(p,m,f){var e=p("./lib/lang"),o=(p("./lib/oop"),p("./lib/net")),t=p("./lib/app_config").AppConfig;f.exports=m=new t();var C=function(){return this||"undefined"!=typeof window&&window;}(),I={packaged:!1,workerPath:null,modePath:null,themePath:null,basePath:"",suffix:".js",$moduleUrls:{},loadWorkerFromBlob:!0,sharedPopups:!1};m.get=function(e){if(!I.hasOwnProperty(e))throw new Error("Unknown config key: "+e);return I[e];},m.set=function(e,t){if(I.hasOwnProperty(e))I[e]=t;else if(0==this.setDefaultValue("",e,t))throw new Error("Unknown config key: "+e);},m.all=function(){return e.copyObject(I);},m.$modes={},m.moduleUrl=function(e,t){if(I.$moduleUrls[e])return I.$moduleUrls[e];var i,n=e.split("/"),r="snippets"==(t=t||n[n.length-2]||"")?"/":"-",o=n[n.length-1];"worker"==t&&"-"==r&&(i=new RegExp("^"+t+"[\\-_]|[\\-_]"+t+"$","g"),o=o.replace(i,"")),(!o||o==t)&&1<n.length&&(o=n[n.length-2]);var s=I[t+"Path"];return null==s?s=I.basePath:"/"==r&&(t=r=""),s&&"/"!=s.slice(-1)&&(s+="/"),s+t+r+o+this.get("suffix");},m.setModuleUrl=function(e,t){return I.$moduleUrls[e]=t;},m.$loading={},m.loadModule=function(i,e){var t,n;Array.isArray(i)&&(n=i[0],i=i[1]);try{t=p(i);}catch(e){}if(t&&!m.$loading[i])return e&&e(t);if(m.$loading[i]||(m.$loading[i]=[]),m.$loading[i].push(e),!(1<m.$loading[i].length)){var _r=function _r(){p([i],function(t){m._emit("load.module",{name:i,module:t});var e=m.$loading[i];m.$loading[i]=null,e.forEach(function(e){e&&e(t);});});};if(!m.get("packaged"))return _r();o.loadScript(m.moduleUrl(i,n),_r),_s();}};var _s=function s(){I.basePath||I.workerPath||I.modePath||I.themePath||Object.keys(I.$moduleUrls).length||(console.error("Unable to infer path to ace from script src,","use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes","or with webpack use ace/webpack-resolver"),_s=function s(){});};function i(e){if(C&&C.document){I.packaged=e||p.packaged||f.packaged||C.define&&A(23).packaged;for(var t={},i="",n=document.currentScript||document._currentScript,r=(n&&n.ownerDocument||document).getElementsByTagName("script"),o=0;o<r.length;o++){var s=r[o],a=s.src||s.getAttribute("src");if(a){for(var l=s.attributes,c=0,h=l.length;c<h;c++){var d=l[c];0===d.name.indexOf("data-ace-")&&(t[d.name.replace(/^data-ace-/,"").replace(/-(.)/g,function(e,t){return t.toUpperCase();})]=d.value);}var u=a.match(/^(.*)\/ace(\-\w+)?\.js(\?|$)/);u&&(i=u[1]);}}for(var g in i&&(t.base=t.base||i,t.packaged=!0),t.basePath=t.base,t.workerPath=t.workerPath||t.base,t.modePath=t.modePath||t.base,t.themePath=t.themePath||t.base,delete t.base,t){void 0!==t[g]&&m.set(g,t[g]);}}}i(!0),m.init=i,m.version="1.4.10";}),ace.define("ace/mouse/mouse_handler",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/mouse/default_handlers","ace/mouse/default_gutter_handler","ace/mouse/mouse_event","ace/mouse/dragdrop_handler","ace/mouse/touch_handler","ace/config"],function(e,t,i){"use strict";function n(r){var o=this;function e(e){document.hasFocus&&document.hasFocus()&&(r.isFocused()||document.activeElement!=(r.textInput&&r.textInput.getElement()))||window.focus(),r.focus();}this.editor=r,new s(this),new a(this),new l(this);var t=r.renderer.getMouseEventTarget();h.addListener(t,"click",this.onMouseEvent.bind(this,"click"),r),h.addListener(t,"mousemove",this.onMouseMove.bind(this,"mousemove"),r),h.addMultiMouseDownListener([t,r.renderer.scrollBarV&&r.renderer.scrollBarV.inner,r.renderer.scrollBarH&&r.renderer.scrollBarH.inner,r.textInput&&r.textInput.getElement()].filter(Boolean),[400,300,250],this,"onMouseEvent",r),h.addMouseWheelListener(r.container,this.onMouseWheel.bind(this,"mousewheel"),r),c(r.container,r);var i=r.renderer.$gutter;h.addListener(i,"mousedown",this.onMouseEvent.bind(this,"guttermousedown"),r),h.addListener(i,"click",this.onMouseEvent.bind(this,"gutterclick"),r),h.addListener(i,"dblclick",this.onMouseEvent.bind(this,"gutterdblclick"),r),h.addListener(i,"mousemove",this.onMouseEvent.bind(this,"guttermousemove"),r),h.addListener(t,"mousedown",e,r),h.addListener(i,"mousedown",e,r),d.isIE&&r.renderer.scrollBarV&&(h.addListener(r.renderer.scrollBarV.element,"mousedown",e,r),h.addListener(r.renderer.scrollBarH.element,"mousedown",e,r)),r.on("mousemove",function(e){var t,i,n;o.state||o.$dragDelay||!o.$dragEnabled||(t=r.renderer.screenToTextCoordinates(e.x,e.y),i=r.session.selection.getRange(),n=r.renderer,!i.isEmpty()&&i.insideStart(t.row,t.column)?n.setCursorStyle("default"):n.setCursorStyle(""));},r);}var h=e("../lib/event"),d=e("../lib/useragent"),s=e("./default_handlers").DefaultHandlers,a=e("./default_gutter_handler").GutterHandler,u=e("./mouse_event").MouseEvent,l=e("./dragdrop_handler").DragdropHandler,c=e("./touch_handler").addTouchListeners,r=e("../config");(function(){this.onMouseEvent=function(e,t){this.editor._emit(e,new u(t,this.editor));},this.onMouseMove=function(e,t){var i=this.editor._eventRegistry&&this.editor._eventRegistry.mousemove;i&&i.length&&this.editor._emit(e,new u(t,this.editor));},this.onMouseWheel=function(e,t){var i=new u(t,this.editor);i.speed=2*this.$scrollSpeed,i.wheelX=t.wheelX,i.wheelY=t.wheelY,this.editor._emit(e,i);},this.setState=function(e){this.state=e;},this.captureMouse=function(e,t){this.x=e.x,this.y=e.y,this.isMousePressed=!0;var i=this.editor,n=this.editor.renderer;n.$isMousePressed=!0;function r(e){if(e){if(d.isWebKit&&!e.which&&s.releaseMouse)return s.releaseMouse();s.x=e.clientX,s.y=e.clientY,t&&t(e),s.mouseEvent=new u(e,s.editor),s.$mouseMoved=!0;}}function o(e){i.off("beforeEndOperation",l),clearInterval(c),a(),s[s.state+"End"]&&s[s.state+"End"](e),s.state="",s.isMousePressed=n.$isMousePressed=!1,n.$keepTextAreaAtCursor&&n.$moveTextAreaToCursor(),s.$onCaptureMouseMove=s.releaseMouse=null,e&&s.onMouseEvent("mouseup",e),i.endOperation();}var s=this,a=function a(){s[s.state]&&s[s.state](),s.$mouseMoved=!1;};if(d.isOldIE&&"dblclick"==e.domEvent.type)return setTimeout(function(){o(e);});var l=function l(e){s.releaseMouse&&i.curOp.command.name&&i.curOp.selectionChanged&&(s[s.state+"End"]&&s[s.state+"End"](),s.state="",s.releaseMouse());};i.on("beforeEndOperation",l),i.startOperation({command:{name:"mouse"}}),s.$onCaptureMouseMove=r,s.releaseMouse=h.capture(this.editor.container,r,o);var c=setInterval(a,20);},this.releaseMouse=null,this.cancelContextMenu=function(){var t=function(e){e&&e.domEvent&&"contextmenu"!=e.domEvent.type||(this.editor.off("nativecontextmenu",t),e&&e.domEvent&&h.stopEvent(e.domEvent));}.bind(this);setTimeout(t,10),this.editor.on("nativecontextmenu",t);};}).call(n.prototype),r.defineOptions(n.prototype,"mouseHandler",{scrollSpeed:{initialValue:2},dragDelay:{initialValue:d.isMac?150:0},dragEnabled:{initialValue:!0},focusTimeout:{initialValue:0},tooltipFollowsMouse:{initialValue:!0}}),t.MouseHandler=n;}),ace.define("ace/mouse/fold_handler",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";var o=e("../lib/dom");t.FoldHandler=function(s){s.on("click",function(e){var t=e.getDocumentPosition(),i=s.session,n=i.getFoldAt(t.row,t.column,1);n&&(e.getAccelKey()?i.removeFold(n):i.expandFold(n),e.stop());var r=e.domEvent&&e.domEvent.target;r&&o.hasCssClass(r,"ace_inline_button")&&o.hasCssClass(r,"ace_toggle_wrap")&&(i.setOption("wrap",!i.getUseWrapMode()),s.renderer.scrollCursorIntoView());}),s.on("gutterclick",function(e){var t,i;"foldWidgets"==s.renderer.$gutterLayer.getRegion(e)&&(t=e.getDocumentPosition().row,(i=s.session).foldWidgets&&i.foldWidgets[t]&&s.session.onFoldWidgetClick(t,e),s.isFocused()||s.focus(),e.stop());}),s.on("gutterdblclick",function(e){var t,i,n,r,o;"foldWidgets"==s.renderer.$gutterLayer.getRegion(e)&&(t=e.getDocumentPosition().row,(r=(n=(i=s.session).getParentFoldRangeData(t,!0)).range||n.firstRange)&&(t=r.start.row,(o=i.getFoldAt(t,i.getLine(t).length,1))?i.removeFold(o):(i.addFold("...",r),s.renderer.scrollCursorIntoView({row:r.start.row,column:0}))),e.stop());});};}),ace.define("ace/keyboard/keybinding",["require","exports","module","ace/lib/keys","ace/lib/event"],function(e,t,i){"use strict";function n(e){this.$editor=e,this.$data={editor:e},this.$handlers=[],this.setDefaultHandler(e.commands);}var r=e("../lib/keys"),l=e("../lib/event");(function(){this.setDefaultHandler=function(e){this.removeKeyboardHandler(this.$defaultHandler),this.$defaultHandler=e,this.addKeyboardHandler(e,0);},this.setKeyboardHandler=function(e){var t=this.$handlers;if(t[t.length-1]!=e){for(;t[t.length-1]&&t[t.length-1]!=this.$defaultHandler;){this.removeKeyboardHandler(t[t.length-1]);}this.addKeyboardHandler(e,1);}},this.addKeyboardHandler=function(e,t){var i;e&&("function"!=typeof e||e.handleKeyboard||(e.handleKeyboard=e),-1!=(i=this.$handlers.indexOf(e))&&this.$handlers.splice(i,1),null==t?this.$handlers.push(e):this.$handlers.splice(t,0,e),-1==i&&e.attach&&e.attach(this.$editor));},this.removeKeyboardHandler=function(e){var t=this.$handlers.indexOf(e);return-1!=t&&(this.$handlers.splice(t,1),e.detach&&e.detach(this.$editor),!0);},this.getKeyboardHandler=function(){return this.$handlers[this.$handlers.length-1];},this.getStatusText=function(){var t=this.$data,i=t.editor;return this.$handlers.map(function(e){return e.getStatusText&&e.getStatusText(i,t)||"";}).filter(Boolean).join(" ");},this.$callKeyboardHandlers=function(e,t,i,n){for(var r,o=!1,s=this.$editor.commands,a=this.$handlers.length;a--&&!((r=this.$handlers[a].handleKeyboard(this.$data,e,t,i,n))&&r.command&&((o="null"==r.command||s.exec(r.command,this.$editor,r.args,n))&&n&&-1!=e&&1!=r.passEvent&&1!=r.command.passEvent&&l.stopEvent(n),o));){}return o||-1!=e||(r={command:"insertstring"},o=s.exec("insertstring",this.$editor,t)),o&&this.$editor._signal&&this.$editor._signal("keyboardActivity",r),o;},this.onCommandKey=function(e,t,i){var n=r.keyCodeToString(i);return this.$callKeyboardHandlers(t,n,i,e);},this.onTextInput=function(e){return this.$callKeyboardHandlers(-1,e);};}).call(n.prototype),t.KeyBinding=n;}),ace.define("ace/lib/bidiutil",["require","exports","module"],function(e,l,t){"use strict";var m=0,f=0,C=!1,I=!1,A=!1,v=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],b=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],d=0,u=1,g=2,p=3,y=4,w=5,S=6,x=7,k=8,R=9,E=10,B=11,Z=12,T=13,G=14,W=15,_=16,H=17,L=18,n=[L,L,L,L,L,L,L,L,L,S,w,S,k,w,L,L,L,L,L,L,L,L,L,L,L,L,L,L,w,w,w,S,k,y,y,B,B,B,y,y,y,y,y,E,R,E,R,R,g,g,g,g,g,g,g,g,g,g,R,y,y,y,y,y,y,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,y,y,y,y,y,y,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,d,y,y,y,y,L,L,L,L,L,L,w,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,L,R,y,B,B,B,B,y,y,y,y,d,y,y,L,y,y,B,B,g,g,y,d,y,y,y,g,d,y,y,y,y,y],r=[k,k,k,k,k,k,k,k,k,k,k,L,L,L,d,u,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,k,w,T,G,W,_,H,R,B,B,B,B,B,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,R,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,y,k];function c(e,t,i){if(!(f<e))if(1!=e||1!=m||I)for(var n,r,o,s,a=i.length,l=0;l<a;){if(t[l]>=e){for(n=l+1;n<a&&t[n]>=e;){n++;}for(r=l,o=n-1;r<o;r++,o--){s=i[r],i[r]=i[o],i[o]=s;}l=n;}l++;}else i.reverse();}function $(e,t,i,n){var r,o,s,a=t[n];switch(a){case d:case u:C=!1;case y:case p:return a;case g:return C?p:g;case x:return C=!0,u;case k:return y;case R:return n<1||n+1>=t.length||(h=i[n-1])!=g&&h!=p||(r=t[n+1])!=g&&r!=p?y:(C&&(r=p),r==h?r:y);case E:return(h=0<n?i[n-1]:w)==g&&n+1<t.length&&t[n+1]==g?g:y;case B:if(0<n&&i[n-1]==g)return g;if(C)return y;for(s=n+1,o=t.length;s<o&&t[s]==B;){s++;}return s<o&&t[s]==g?g:y;case Z:for(o=t.length,s=n+1;s<o&&t[s]==Z;){s++;}if(s<o){var l=e[n],c=1425<=l&&l<=2303||64286==l,h=t[s];if(c&&(h==u||h==x))return u;}return n<1||(h=t[n-1])==w?y:i[n-1];case w:return I=!(C=!1),m;case S:return A=!0,y;case T:case G:case _:case H:case W:C=!1;case L:return y;}}function V(e){var t=e.charCodeAt(0),i=t>>8;return 0==i?191<t?d:n[t]:5==i?/[\u0591-\u05f4]/.test(e)?u:d:6==i?/[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(e)?Z:/[\u0660-\u0669\u066b-\u066c]/.test(e)?p:1642==t?B:/[\u06f0-\u06f9]/.test(e)?g:x:32==i&&t<=8287?r[255&t]:254==i&&65136<=t?x:y;}l.L=d,l.R=u,l.EN=g,l.ON_R=3,l.AN=4,l.R_H=5,l.B=6,l.RLE=7,l.DOT="·",l.doBidiReorder=function(e,t,i){if(e.length<2)return{};var n=e.split(""),r=new Array(n.length),o=new Array(n.length),s=[];m=i?1:0,function(e,t,i,n){var r=m?b:v,o=null,s=null,a=null,l=0,c=null,h=-1,d=null,u=null,g=[];if(!n)for(d=0,n=[];d<i;d++){n[d]=V(e[d]);}for(f=m,A=I=C=!1,u=0;u<i;u++){if(o=l,g[u]=s=$(e,n,g,u),c=240&(l=r[o][s]),l&=15,t[u]=a=r[l][5],0<c)if(16==c){for(d=h;d<u;d++){t[d]=1;}h=-1;}else h=-1;if(r[l][6])-1==h&&(h=u);else if(-1<h){for(d=h;d<u;d++){t[d]=a;}h=-1;}n[u]==w&&(t[u]=0),f|=a;}if(A)for(d=0;d<i;d++){if(n[d]==S){t[d]=m;for(var p=d-1;0<=p&&n[p]==k;p--){t[p]=m;}}}}(n,s,n.length,t);for(var a=0;a<r.length;r[a]=a,a++){}c(2,s,r),c(1,s,r);for(a=0;a<r.length-1;a++){t[a]===p?s[a]=l.AN:s[a]===u&&(t[a]>x&&t[a]<T||t[a]===y||t[a]===L)?s[a]=l.ON_R:0<a&&"ل"===n[a-1]&&/\u0622|\u0623|\u0625|\u0627/.test(n[a])&&(s[a-1]=s[a]=l.R_H,a++);}n[n.length-1]===l.DOT&&(s[n.length-1]=l.B),"‫"===n[0]&&(s[0]=l.RLE);for(a=0;a<r.length;a++){o[a]=s[r[a]];}return{logicalFromVisual:r,bidiLevels:o};},l.hasBidiCharacters=function(e,t){for(var i=!1,n=0;n<e.length;n++){t[n]=V(e.charAt(n)),i||t[n]!=u&&t[n]!=x&&t[n]!=p||(i=!0);}return i;},l.getVisualFromLogicalIdx=function(e,t){for(var i=0;i<t.logicalFromVisual.length;i++){if(t.logicalFromVisual[i]==e)return i;}return 0;};}),ace.define("ace/bidihandler",["require","exports","module","ace/lib/bidiutil","ace/lib/lang"],function(e,t,i){"use strict";function n(e){this.session=e,this.bidiMap={},this.currentRow=null,this.bidiUtil=a,this.charWidths=[],this.EOL="¬",this.showInvisibles=!0,this.isRtlDir=!1,this.$isRtl=!1,this.line="",this.wrapIndent=0,this.EOF="¶",this.RLE="‫",this.contentWidth=0,this.fontMetrics=null,this.rtlLineOffset=0,this.wrapOffset=0,this.isMoveLeftOperation=!1,this.seenBidi=r.test(e.getValue());}var a=e("./lib/bidiutil"),l=e("./lib/lang"),r=/[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/;(function(){this.isBidiRow=function(e,t,i){return!!this.seenBidi&&(e!==this.currentRow&&(this.currentRow=e,this.updateRowLine(t,i),this.updateBidiMap()),this.bidiMap.bidiLevels);},this.onChange=function(e){this.seenBidi?this.currentRow=null:"insert"==e.action&&r.test(e.lines.join("\n"))&&(this.seenBidi=!0,this.currentRow=null);},this.getDocumentRow=function(){var e,t=0,i=this.session.$screenRowCache;return!i.length||0<=(e=this.session.$getRowCacheIndex(i,this.currentRow))&&(t=this.session.$docRowCache[e]),t;},this.getSplitIndex=function(){var e=0,t=this.session.$screenRowCache;if(t.length)for(var i,n=this.session.$getRowCacheIndex(t,this.currentRow);0<this.currentRow-e&&(i=this.session.$getRowCacheIndex(t,this.currentRow-e-1))===n;){n=i,e++;}else e=this.currentRow;return e;},this.updateRowLine=function(e,t){void 0===e&&(e=this.getDocumentRow());var i,n=e===this.session.getLength()-1?this.EOF:this.EOL;this.wrapIndent=0,this.line=this.session.getLine(e),this.isRtlDir=this.$isRtl||this.line.charAt(0)===this.RLE,this.session.$useWrapMode?((i=this.session.$wrapData[e])&&(void 0===t&&(t=this.getSplitIndex()),0<t&&i.length?(this.wrapIndent=i.indent,this.wrapOffset=this.wrapIndent*this.charWidths[a.L],this.line=t<i.length?this.line.substring(i[t-1],i[t]):this.line.substring(i[i.length-1])):this.line=this.line.substring(0,i[t])),t==i.length&&(this.line+=this.showInvisibles?n:a.DOT)):this.line+=this.showInvisibles?n:a.DOT;var r,o=this.session,s=0;this.line=this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g,function(e,t){return"\t"===e||o.isFullWidth(e.charCodeAt(0))?(r="\t"===e?o.getScreenTabSize(t+s):2,s+=r-1,l.stringRepeat(a.DOT,r)):e;}),this.isRtlDir&&(this.fontMetrics.$main.textContent=this.line.charAt(this.line.length-1)==a.DOT?this.line.substr(0,this.line.length-1):this.line,this.rtlLineOffset=this.contentWidth-this.fontMetrics.$main.getBoundingClientRect().width);},this.updateBidiMap=function(){var e=[];a.hasBidiCharacters(this.line,e)||this.isRtlDir?this.bidiMap=a.doBidiReorder(this.line,e,this.isRtlDir):this.bidiMap={};},this.markAsDirty=function(){this.currentRow=null;},this.updateCharacterWidths=function(e){var t,i;this.characterWidth!==e.$characterSize.width&&(this.fontMetrics=e,t=this.characterWidth=e.$characterSize.width,i=e.$measureCharWidth("ה"),this.charWidths[a.L]=this.charWidths[a.EN]=this.charWidths[a.ON_R]=t,this.charWidths[a.R]=this.charWidths[a.AN]=i,this.charWidths[a.R_H]=.45*i,this.charWidths[a.B]=this.charWidths[a.RLE]=0,this.currentRow=null);},this.setShowInvisibles=function(e){this.showInvisibles=e,this.currentRow=null;},this.setEolChar=function(e){this.EOL=e;},this.setContentWidth=function(e){this.contentWidth=e;},this.isRtlLine=function(e){return!!this.$isRtl||(null!=e?this.session.getLine(e).charAt(0)==this.RLE:this.isRtlDir);},this.setRtlDirection=function(e,t){for(var i=e.getCursorPosition(),n=e.selection.getSelectionAnchor().row;n<=i.row;n++){t||e.session.getLine(n).charAt(0)!==e.session.$bidiHandler.RLE?t&&e.session.getLine(n).charAt(0)!==e.session.$bidiHandler.RLE&&e.session.doc.insert({column:0,row:n},e.session.$bidiHandler.RLE):e.session.doc.removeInLine(n,0,1);}},this.getPosLeft=function(e){e-=this.wrapIndent;var t=this.line.charAt(0)===this.RLE?1:0,i=t<e?this.session.getOverwrite()?e:e-1:t,n=a.getVisualFromLogicalIdx(i,this.bidiMap),r=this.bidiMap.bidiLevels,o=0;!this.session.getOverwrite()&&e<=t&&r[n]%2!=0&&n++;for(var s=0;s<n;s++){o+=this.charWidths[r[s]];}return!this.session.getOverwrite()&&t<e&&r[n]%2==0&&(o+=this.charWidths[r[n]]),this.wrapIndent&&(o+=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset),this.isRtlDir&&(o+=this.rtlLineOffset),o;},this.getSelections=function(e,t){var i,n=this.bidiMap,r=n.bidiLevels,o=[],s=0,a=Math.min(e,t)-this.wrapIndent,l=Math.max(e,t)-this.wrapIndent,c=!1,h=!1,d=0;this.wrapIndent&&(s+=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset);for(var u,g=0;g<r.length;g++){u=n.logicalFromVisual[g],i=r[g],(c=a<=u&&u<l)&&!h?d=s:!c&&h&&o.push({left:d,width:s-d}),s+=this.charWidths[i],h=c;}if(c&&g===r.length&&o.push({left:d,width:s-d}),this.isRtlDir)for(var p=0;p<o.length;p++){o[p].left+=this.rtlLineOffset;}return o;},this.offsetToCol=function(e){this.isRtlDir&&(e-=this.rtlLineOffset);var t=0,e=Math.max(e,0),i=0,n=0,r=this.bidiMap.bidiLevels,o=this.charWidths[r[n]];for(this.wrapIndent&&(e-=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset);i+o/2<e;){if(i+=o,n===r.length-1){o=0;break;}o=this.charWidths[r[++n]];}return 0===(t=0<n&&r[n-1]%2!=0&&r[n]%2==0?(e<i&&n--,this.bidiMap.logicalFromVisual[n]):0<n&&r[n-1]%2==0&&r[n]%2!=0?1+(i<e?this.bidiMap.logicalFromVisual[n]:this.bidiMap.logicalFromVisual[n-1]):this.isRtlDir&&n===r.length-1&&0===o&&r[n-1]%2==0||!this.isRtlDir&&0===n&&r[n]%2!=0?1+this.bidiMap.logicalFromVisual[n]:(0<n&&r[n-1]%2!=0&&0!==o&&n--,this.bidiMap.logicalFromVisual[n]))&&this.isRtlDir&&t++,t+this.wrapIndent;};}).call(n.prototype),t.BidiHandler=n;}),ace.define("ace/selection",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/range"],function(e,t,i){"use strict";function n(e){this.session=e,this.doc=e.getDocument(),this.clearSelection(),this.cursor=this.lead=this.doc.createAnchor(0,0),this.anchor=this.doc.createAnchor(0,0),this.$silent=!1;var t=this;this.cursor.on("change",function(e){t.$cursorChanged=!0,t.$silent||t._emit("changeCursor"),t.$isEmpty||t.$silent||t._emit("changeSelection"),t.$keepDesiredColumnOnChange||e.old.column==e.value.column||(t.$desiredColumn=null);}),this.anchor.on("change",function(){t.$anchorChanged=!0,t.$isEmpty||t.$silent||t._emit("changeSelection");});}var r=e("./lib/oop"),s=e("./lib/lang"),o=e("./lib/event_emitter").EventEmitter,a=e("./range").Range;(function(){r.implement(this,o),this.isEmpty=function(){return this.$isEmpty||this.anchor.row==this.lead.row&&this.anchor.column==this.lead.column;},this.isMultiLine=function(){return!this.$isEmpty&&this.anchor.row!=this.cursor.row;},this.getCursor=function(){return this.lead.getPosition();},this.setSelectionAnchor=function(e,t){this.$isEmpty=!1,this.anchor.setPosition(e,t);},this.getAnchor=this.getSelectionAnchor=function(){return this.$isEmpty?this.getSelectionLead():this.anchor.getPosition();},this.getSelectionLead=function(){return this.lead.getPosition();},this.isBackwards=function(){var e=this.anchor,t=this.lead;return e.row>t.row||e.row==t.row&&e.column>t.column;},this.getRange=function(){var e=this.anchor,t=this.lead;return this.$isEmpty?a.fromPoints(t,t):this.isBackwards()?a.fromPoints(t,e):a.fromPoints(e,t);},this.clearSelection=function(){this.$isEmpty||(this.$isEmpty=!0,this._emit("changeSelection"));},this.selectAll=function(){this.$setSelection(0,0,Number.MAX_VALUE,Number.MAX_VALUE);},this.setRange=this.setSelectionRange=function(e,t){var i=t?e.end:e.start,n=t?e.start:e.end;this.$setSelection(i.row,i.column,n.row,n.column);},this.$setSelection=function(e,t,i,n){var r,o;this.$silent||(r=this.$isEmpty,o=this.inMultiSelectMode,this.$silent=!0,this.$cursorChanged=this.$anchorChanged=!1,this.anchor.setPosition(e,t),this.cursor.setPosition(i,n),this.$isEmpty=!a.comparePoints(this.anchor,this.cursor),this.$silent=!1,this.$cursorChanged&&this._emit("changeCursor"),(this.$cursorChanged||this.$anchorChanged||r!=this.$isEmpty||o)&&this._emit("changeSelection"));},this.$moveSelection=function(e){var t=this.lead;this.$isEmpty&&this.setSelectionAnchor(t.row,t.column),e.call(this);},this.selectTo=function(e,t){this.$moveSelection(function(){this.moveCursorTo(e,t);});},this.selectToPosition=function(e){this.$moveSelection(function(){this.moveCursorToPosition(e);});},this.moveTo=function(e,t){this.clearSelection(),this.moveCursorTo(e,t);},this.moveToPosition=function(e){this.clearSelection(),this.moveCursorToPosition(e);},this.selectUp=function(){this.$moveSelection(this.moveCursorUp);},this.selectDown=function(){this.$moveSelection(this.moveCursorDown);},this.selectRight=function(){this.$moveSelection(this.moveCursorRight);},this.selectLeft=function(){this.$moveSelection(this.moveCursorLeft);},this.selectLineStart=function(){this.$moveSelection(this.moveCursorLineStart);},this.selectLineEnd=function(){this.$moveSelection(this.moveCursorLineEnd);},this.selectFileEnd=function(){this.$moveSelection(this.moveCursorFileEnd);},this.selectFileStart=function(){this.$moveSelection(this.moveCursorFileStart);},this.selectWordRight=function(){this.$moveSelection(this.moveCursorWordRight);},this.selectWordLeft=function(){this.$moveSelection(this.moveCursorWordLeft);},this.getWordRange=function(e,t){var i;return void 0===t&&(e=(i=e||this.lead).row,t=i.column),this.session.getWordRange(e,t);},this.selectWord=function(){this.setSelectionRange(this.getWordRange());},this.selectAWord=function(){var e=this.getCursor(),t=this.session.getAWordRange(e.row,e.column);this.setSelectionRange(t);},this.getLineRange=function(e,t){var i="number"==typeof e?e:this.lead.row,n=this.session.getFoldLine(i),r=n?(i=n.start.row,n.end.row):i;return!0===t?new a(i,0,r,this.session.getLine(r).length):new a(i,0,r+1,0);},this.selectLine=function(){this.setSelectionRange(this.getLineRange());},this.moveCursorUp=function(){this.moveCursorBy(-1,0);},this.moveCursorDown=function(){this.moveCursorBy(1,0);},this.wouldMoveIntoSoftTab=function(e,t,i){var n=e.column,r=e.column+t;return i<0&&(n=e.column-t,r=e.column),this.session.isTabStop(e)&&this.doc.getLine(e.row).slice(n,r).split(" ").length-1==t;},this.moveCursorLeft=function(){var e,t,i=this.lead.getPosition();(e=this.session.getFoldAt(i.row,i.column,-1))?this.moveCursorTo(e.start.row,e.start.column):0===i.column?0<i.row&&this.moveCursorTo(i.row-1,this.doc.getLine(i.row-1).length):(t=this.session.getTabSize(),this.wouldMoveIntoSoftTab(i,t,-1)&&!this.session.getNavigateWithinSoftTabs()?this.moveCursorBy(0,-t):this.moveCursorBy(0,-1));},this.moveCursorRight=function(){var e,t,i=this.lead.getPosition();(e=this.session.getFoldAt(i.row,i.column,1))?this.moveCursorTo(e.end.row,e.end.column):this.lead.column==this.doc.getLine(this.lead.row).length?this.lead.row<this.doc.getLength()-1&&this.moveCursorTo(this.lead.row+1,0):(t=this.session.getTabSize(),i=this.lead,this.wouldMoveIntoSoftTab(i,t,1)&&!this.session.getNavigateWithinSoftTabs()?this.moveCursorBy(0,t):this.moveCursorBy(0,1));},this.moveCursorLineStart=function(){var e=this.lead.row,t=this.lead.column,i=this.session.documentToScreenRow(e,t),n=this.session.screenToDocumentPosition(i,0),r=this.session.getDisplayLine(e,null,n.row,n.column).match(/^\s*/);r[0].length==t||this.session.$useEmacsStyleLineStart||(n.column+=r[0].length),this.moveCursorToPosition(n);},this.moveCursorLineEnd=function(){var e,t,i=this.lead,n=this.session.getDocumentLastRowColumnPosition(i.row,i.column);this.lead.column==n.column&&(e=this.session.getLine(n.row),n.column!=e.length||0<(t=e.search(/\s+$/))&&(n.column=t)),this.moveCursorTo(n.row,n.column);},this.moveCursorFileEnd=function(){var e=this.doc.getLength()-1,t=this.doc.getLine(e).length;this.moveCursorTo(e,t);},this.moveCursorFileStart=function(){this.moveCursorTo(0,0);},this.moveCursorLongWordRight=function(){var e=this.lead.row,t=this.lead.column,i=this.doc.getLine(e),n=i.substring(t);this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0;var r=this.session.getFoldAt(e,t,1);if(r)this.moveCursorTo(r.end.row,r.end.column);else{if(this.session.nonTokenRe.exec(n)&&(t+=this.session.nonTokenRe.lastIndex,this.session.nonTokenRe.lastIndex=0,n=i.substring(t)),t>=i.length)return this.moveCursorTo(e,i.length),this.moveCursorRight(),void(e<this.doc.getLength()-1&&this.moveCursorWordRight());this.session.tokenRe.exec(n)&&(t+=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0),this.moveCursorTo(e,t);}},this.moveCursorLongWordLeft=function(){var e,t=this.lead.row,i=this.lead.column;if(e=this.session.getFoldAt(t,i,-1))this.moveCursorTo(e.start.row,e.start.column);else{var n=this.session.getFoldStringAt(t,i,-1);null==n&&(n=this.doc.getLine(t).substring(0,i));var r=s.stringReverse(n);if(this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0,this.session.nonTokenRe.exec(r)&&(i-=this.session.nonTokenRe.lastIndex,r=r.slice(this.session.nonTokenRe.lastIndex),this.session.nonTokenRe.lastIndex=0),i<=0)return this.moveCursorTo(t,0),this.moveCursorLeft(),void(0<t&&this.moveCursorWordLeft());this.session.tokenRe.exec(r)&&(i-=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0),this.moveCursorTo(t,i);}},this.$shortWordEndIndex=function(e){var t,i=0,n=/\s/,r=this.session.tokenRe;if(r.lastIndex=0,this.session.tokenRe.exec(e))i=this.session.tokenRe.lastIndex;else{for(;(t=e[i])&&n.test(t);){i++;}if(i<1)for(r.lastIndex=0;(t=e[i])&&!r.test(t);){if(r.lastIndex=0,i++,n.test(t)){if(2<i){i--;break;}for(;(t=e[i])&&n.test(t);){i++;}if(2<i)break;}}}return r.lastIndex=0,i;},this.moveCursorShortWordRight=function(){var e=this.lead.row,t=this.lead.column,i=this.doc.getLine(e),n=i.substring(t),r=this.session.getFoldAt(e,t,1);if(r)return this.moveCursorTo(r.end.row,r.end.column);if(t==i.length){for(var o=this.doc.getLength();e++,n=this.doc.getLine(e),e<o&&/^\s*$/.test(n);){}/^\s+/.test(n)||(n=""),t=0;}var s=this.$shortWordEndIndex(n);this.moveCursorTo(e,t+s);},this.moveCursorShortWordLeft=function(){var e,t=this.lead.row,i=this.lead.column;if(e=this.session.getFoldAt(t,i,-1))return this.moveCursorTo(e.start.row,e.start.column);var n=this.session.getLine(t).substring(0,i);if(0===i){for(;t--,n=this.doc.getLine(t),0<t&&/^\s*$/.test(n);){}i=n.length,/\s+$/.test(n)||(n="");}var r=s.stringReverse(n),o=this.$shortWordEndIndex(r);return this.moveCursorTo(t,i-o);},this.moveCursorWordRight=function(){this.session.$selectLongWords?this.moveCursorLongWordRight():this.moveCursorShortWordRight();},this.moveCursorWordLeft=function(){this.session.$selectLongWords?this.moveCursorLongWordLeft():this.moveCursorShortWordLeft();},this.moveCursorBy=function(e,t){var i,n,r=this.session.documentToScreenPosition(this.lead.row,this.lead.column);0===t&&(0!==e&&(this.session.$bidiHandler.isBidiRow(r.row,this.lead.row)?(i=this.session.$bidiHandler.getPosLeft(r.column),r.column=Math.round(i/this.session.$bidiHandler.charWidths[0])):i=r.column*this.session.$bidiHandler.charWidths[0]),this.$desiredColumn?r.column=this.$desiredColumn:this.$desiredColumn=r.column),0!=e&&this.session.lineWidgets&&this.session.lineWidgets[this.lead.row]&&(n=this.session.lineWidgets[this.lead.row],e<0?e-=n.rowsAbove||0:0<e&&(e+=n.rowCount-(n.rowsAbove||0)));var o=this.session.screenToDocumentPosition(r.row+e,r.column,i);0!==e&&0===t&&o.row===this.lead.row&&(o.column,this.lead.column),this.moveCursorTo(o.row,o.column+t,0===t);},this.moveCursorToPosition=function(e){this.moveCursorTo(e.row,e.column);},this.moveCursorTo=function(e,t,i){var n=this.session.getFoldAt(e,t,1);n&&(e=n.start.row,t=n.start.column),this.$keepDesiredColumnOnChange=!0;var r=this.session.getLine(e);/[\uDC00-\uDFFF]/.test(r.charAt(t))&&r.charAt(t-1)&&(this.lead.row==e&&this.lead.column==t+1?--t:t+=1),this.lead.setPosition(e,t),this.$keepDesiredColumnOnChange=!1,i||(this.$desiredColumn=null);},this.moveCursorToScreen=function(e,t,i){var n=this.session.screenToDocumentPosition(e,t);this.moveCursorTo(n.row,n.column,i);},this.detach=function(){this.lead.detach(),this.anchor.detach(),this.session=this.doc=null;},this.fromOrientedRange=function(e){this.setSelectionRange(e,e.cursor==e.start),this.$desiredColumn=e.desiredColumn||this.$desiredColumn;},this.toOrientedRange=function(e){var t=this.getRange();return e?(e.start.column=t.start.column,e.start.row=t.start.row,e.end.column=t.end.column,e.end.row=t.end.row):e=t,e.cursor=this.isBackwards()?e.start:e.end,e.desiredColumn=this.$desiredColumn,e;},this.getRangeOfMovements=function(e){var t=this.getCursor();try{e(this);var i=this.getCursor();return a.fromPoints(t,i);}catch(e){return a.fromPoints(t,t);}finally{this.moveCursorToPosition(t);}},this.toJSON=function(){var e;return this.rangeCount?e=this.ranges.map(function(e){var t=e.clone();return t.isBackwards=e.cursor==e.start,t;}):(e=this.getRange()).isBackwards=this.isBackwards(),e;},this.fromJSON=function(e){if(null==e.start){if(this.rangeList&&1<e.length){this.toSingleRange(e[0]);for(var t=e.length;t--;){var i=a.fromPoints(e[t].start,e[t].end);e[t].isBackwards&&(i.cursor=i.start),this.addRange(i,!0);}return;}e=e[0];}this.rangeList&&this.toSingleRange(e),this.setSelectionRange(e,e.isBackwards);},this.isEqual=function(e){if((e.length||this.rangeCount)&&e.length!=this.rangeCount)return!1;if(!e.length||!this.ranges)return this.getRange().isEqual(e);for(var t=this.ranges.length;t--;){if(!this.ranges[t].isEqual(e[t]))return!1;}return!0;};}).call(n.prototype),t.Selection=n;}),ace.define("ace/tokenizer",["require","exports","module","ace/config"],function(e,t,i){"use strict";function n(e){for(var t in this.states=e,this.regExps={},this.matchMappings={},this.states){for(var i=this.states[t],n=[],r=0,o=this.matchMappings[t]={defaultToken:"text"},s="g",a=[],l=0;l<i.length;l++){var c,h,d=i[l];d.defaultToken&&(o.defaultToken=d.defaultToken),d.caseInsensitive&&(s="gi"),null!=d.regex&&(d.regex instanceof RegExp&&(d.regex=d.regex.toString().slice(1,-1)),c=d.regex,h=new RegExp("(?:("+c+")|(.))").exec("a").length-2,Array.isArray(d.token)?1==d.token.length||1==h?d.token=d.token[0]:h-1!=d.token.length?(this.reportError("number of classes and regexp groups doesn't match",{rule:d,groupCount:h-1}),d.token=d.token[0]):(d.tokenArray=d.token,d.token=null,d.onMatch=this.$arrayTokens):"function"!=typeof d.token||d.onMatch||(d.onMatch=1<h?this.$applyToken:d.token),1<h&&(c=/\\\d/.test(d.regex)?d.regex.replace(/\\([0-9]+)/g,function(e,t){return"\\"+(parseInt(t,10)+r+1);}):(h=1,this.removeCapturingGroups(d.regex)),d.splitRegex||"string"==typeof d.token||a.push(d)),o[r]=l,r+=h,n.push(c),d.onMatch||(d.onMatch=null));}n.length||(o[0]=0,n.push("$")),a.forEach(function(e){e.splitRegex=this.createSplitterRegexp(e.regex,s);},this),this.regExps[t]=new RegExp("("+n.join(")|(")+")|($)",s);}}var r=e("./config"),I=2e3;(function(){this.$setMaxTokenCount=function(e){I=0|e;},this.$applyToken=function(e){var t=this.splitRegex.exec(e).slice(1),i=this.token.apply(this,t);if("string"==typeof i)return[{type:i,value:e}];for(var n=[],r=0,o=i.length;r<o;r++){t[r]&&(n[n.length]={type:i[r],value:t[r]});}return n;},this.$arrayTokens=function(e){if(!e)return[];var t=this.splitRegex.exec(e);if(!t)return"text";for(var i=[],n=this.tokenArray,r=0,o=n.length;r<o;r++){t[r+1]&&(i[i.length]={type:n[r],value:t[r+1]});}return i;},this.removeCapturingGroups=function(e){return e.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!]|(\()/g,function(e,t){return t?"(?:":e;});},this.createSplitterRegexp=function(e,t){var s,a,l;return-1!=e.indexOf("(?=")&&(s=0,a=!1,l={},e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g,function(e,t,i,n,r,o){return a?a="]"!=r:r?a=!0:n?(s==l.stack&&(l.end=o+1,l.stack=-1),s--):i&&(s++,1!=i.length&&(l.stack=s,l.start=o)),e;}),null!=l.end&&/^\)*$/.test(e.substr(l.end))&&(e=e.substring(0,l.start)+e.substr(l.end))),"^"!=e.charAt(0)&&(e="^"+e),"$"!=e.charAt(e.length-1)&&(e+="$"),new RegExp(e,(t||"").replace("g",""));},this.getLineTokens=function(e,t){var i;t&&"string"!=typeof t?"#tmp"===(t=(i=t.slice(0))[0])&&(i.shift(),t=i.shift()):i=[];var n=t||"start",r=this.states[n];r||(n="start",r=this.states[n]);for(var o,s=this.matchMappings[n],a=this.regExps[n],l=[],c=a.lastIndex=0,h=0,d={type:null,value:""};o=a.exec(e);){var u,g=s.defaultToken,p=null,m=o[0],f=a.lastIndex;f-m.length>c&&(u=e.substring(c,f-m.length),d.type==g?d.value+=u:(d.type&&l.push(d),d={type:g,value:u}));for(var C=0;C<o.length-2;C++){if(void 0!==o[C+1]){g=(p=r[s[C]]).onMatch?p.onMatch(m,n,i,e):p.token,p.next&&(n="string"==typeof p.next?p.next:p.next(n,i),(r=this.states[n])||(this.reportError("state doesn't exist",n),n="start",r=this.states[n]),s=this.matchMappings[n],c=f,(a=this.regExps[n]).lastIndex=f),p.consumeLineEnd&&(c=f);break;}}if(m)if("string"==typeof g)p&&!1===p.merge||d.type!==g?(d.type&&l.push(d),d={type:g,value:m}):d.value+=m;else if(g){d.type&&l.push(d),d={type:null,value:""};for(C=0;C<g.length;C++){l.push(g[C]);}}if(c==e.length)break;if(c=f,h++>I){for(h>2*e.length&&this.reportError("infinite loop with in ace tokenizer",{startState:t,line:e});c<e.length;){d.type&&l.push(d),d={value:e.substring(c,c+=500),type:"overflow"};}n="start",i=[];break;}}return d.type&&l.push(d),1<i.length&&i[0]!==n&&i.unshift("#tmp",n),{tokens:l,state:i.length?i:n};},this.reportError=r.reportError;}).call(n.prototype),t.Tokenizer=n;}),ace.define("ace/mode/text_highlight_rules",["require","exports","module","ace/lib/lang"],function(e,t,i){"use strict";function n(){this.$rules={start:[{token:"empty_line",regex:"^$"},{defaultToken:"text"}]};}var c=e("../lib/lang");(function(){this.addRules=function(e,t){if(t)for(var i in e){for(var n=e[i],r=0;r<n.length;r++){var o=n[r];(o.next||o.onMatch)&&("string"==typeof o.next&&0!==o.next.indexOf(t)&&(o.next=t+o.next),o.nextState&&0!==o.nextState.indexOf(t)&&(o.nextState=t+o.nextState));}this.$rules[t+i]=n;}else for(var i in e){this.$rules[i]=e[i];}},this.getRules=function(){return this.$rules;},this.embedRules=function(e,t,i,n,r){var o="function"==typeof e?new e().getRules():e;if(n)for(var s=0;s<n.length;s++){n[s]=t+n[s];}else for(var a in n=[],o){n.push(t+a);}if(this.addRules(o,t),i)for(var l=Array.prototype[r?"push":"unshift"],s=0;s<n.length;s++){l.apply(this.$rules[n[s]],c.deepCopy(i));}this.$embeds||(this.$embeds=[]),this.$embeds.push(t);},this.getEmbeds=function(){return this.$embeds;};function g(e,t){return"start"==e&&!t.length||t.unshift(this.nextState,e),this.nextState;}function p(e,t){return t.shift(),t.shift()||"start";}this.normalizeRules=function(){var d=0,u=this.$rules;Object.keys(u).forEach(function e(t){var i=u[t];i.processed=!0;for(var n=0;n<i.length;n++){var r=i[n],o=null;Array.isArray(r)&&(o=r,r={}),!r.regex&&r.start&&(r.regex=r.start,r.next||(r.next=[]),r.next.push({defaultToken:r.token},{token:r.token+".end",regex:r.end||r.start,next:"pop"}),r.token=r.token+".start",r.push=!0);var s,a=r.next||r.push;if(a&&Array.isArray(a)?((s=r.stateName)||("string"!=typeof(s=r.token)&&(s=s[0]||""),u[s]&&(s+=d++)),u[s]=a,e(r.next=s)):"pop"==a&&(r.next=p),r.push&&(r.nextState=r.next||r.push,r.next=g,delete r.push),r.rules)for(var l in r.rules){u[l]?u[l].push&&u[l].push.apply(u[l],r.rules[l]):u[l]=r.rules[l];}var c,h="string"==typeof r?r:r.include;h&&(o=Array.isArray(h)?h.map(function(e){return u[e];}):u[h]),o&&(c=[n,1].concat(o),r.noEscape&&(c=c.filter(function(e){return!e.next;})),i.splice.apply(i,c),n--),r.keywordMap&&(r.token=this.createKeywordMapper(r.keywordMap,r.defaultToken||"text",r.caseInsensitive),delete r.defaultToken);}},this);},this.createKeywordMapper=function(r,t,o,s){var a=Object.create(null);return Object.keys(r).forEach(function(e){var t=r[e];o&&(t=t.toLowerCase());for(var i=t.split(s||"|"),n=i.length;n--;){a[i[n]]=e;}}),Object.getPrototypeOf(a)&&(a.__proto__=null),this.$keywordList=Object.keys(a),r=null,o?function(e){return a[e.toLowerCase()]||t;}:function(e){return a[e]||t;};},this.getKeywords=function(){return this.$keywords;};}).call(n.prototype),t.TextHighlightRules=n;}),ace.define("ace/mode/behaviour",["require","exports","module"],function(e,t,i){"use strict";function n(){this.$behaviours={};}(function(){this.add=function(e,t,i){switch(void 0){case this.$behaviours:this.$behaviours={};case this.$behaviours[e]:this.$behaviours[e]={};}this.$behaviours[e][t]=i;},this.addBehaviours=function(e){for(var t in e){for(var i in e[t]){this.add(t,i,e[t][i]);}}},this.remove=function(e){this.$behaviours&&this.$behaviours[e]&&delete this.$behaviours[e];},this.inherit=function(e,t){var i;i="function"==typeof e?new e().getBehaviours(t):e.getBehaviours(t),this.addBehaviours(i);},this.getBehaviours=function(e){if(e){for(var t={},i=0;i<e.length;i++){this.$behaviours[e[i]]&&(t[e[i]]=this.$behaviours[e[i]]);}return t;}return this.$behaviours;};}).call(n.prototype),t.Behaviour=n;}),ace.define("ace/token_iterator",["require","exports","module","ace/range"],function(e,t,i){"use strict";function n(e,t,i){this.$session=e,this.$row=t,this.$rowTokens=e.getTokens(t);var n=e.getTokenAt(t,i);this.$tokenIndex=n?n.index:-1;}var r=e("./range").Range;(function(){this.stepBackward=function(){for(--this.$tokenIndex;this.$tokenIndex<0;){if(--this.$row,this.$row<0)return this.$row=0,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=this.$rowTokens.length-1;}return this.$rowTokens[this.$tokenIndex];},this.stepForward=function(){var e;for(this.$tokenIndex+=1;this.$tokenIndex>=this.$rowTokens.length;){if(this.$row+=1,e=e||this.$session.getLength(),this.$row>=e)return this.$row=e-1,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=0;}return this.$rowTokens[this.$tokenIndex];},this.getCurrentToken=function(){return this.$rowTokens[this.$tokenIndex];},this.getCurrentTokenRow=function(){return this.$row;},this.getCurrentTokenColumn=function(){var e=this.$rowTokens,t=this.$tokenIndex,i=e[t].start;if(void 0!==i)return i;for(i=0;0<t;){i+=e[--t].value.length;}return i;},this.getCurrentTokenPosition=function(){return{row:this.$row,column:this.getCurrentTokenColumn()};},this.getCurrentTokenRange=function(){var e=this.$rowTokens[this.$tokenIndex],t=this.getCurrentTokenColumn();return new r(this.$row,t,this.$row,t+e.value.length);};}).call(n.prototype),t.TokenIterator=n;}),ace.define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"],function(e,t,i){"use strict";function y(e){var t=-1;if(e.multiSelect&&(t=e.selection.index,l.rangeCount!=e.multiSelect.rangeCount&&(l={rangeCount:e.multiSelect.rangeCount})),l[t])return p=l[t];p=l[t]={autoInsertedBrackets:0,autoInsertedRow:-1,autoInsertedLineEnd:"",maybeInsertedBrackets:0,maybeInsertedRow:-1,maybeInsertedLineStart:"",maybeInsertedLineEnd:""};}function w(e,t,i,n){var r=e.end.row-e.start.row;return{text:i+t+n,selection:[0,e.start.column+1,r,e.end.column+(r?0:1)]};}var p,n=e("../../lib/oop"),r=e("../behaviour").Behaviour,o=e("../../token_iterator").TokenIterator,m=e("../../lib/lang"),s=["text","paren.rparen","rparen","paren","punctuation.operator"],a=["text","paren.rparen","rparen","paren","punctuation.operator","comment"],l={},S={'"':'"',"'":"'"},f=function f(g){this.add("braces","insertion",function(e,t,i,n,r){var o=i.getCursorPosition(),s=n.doc.getLine(o.row);if("{"==r){y(i);var a=i.getSelectionRange(),l=n.doc.getTextRange(a);if(""!==l&&"{"!==l&&i.getWrapBehavioursEnabled())return w(a,l,"{","}");if(f.isSaneInsertion(i,n))return /[\]\}\)]/.test(s[o.column])||i.inMultiSelectMode||g&&g.braces?(f.recordAutoInsert(i,n,"}"),{text:"{}",selection:[1,1]}):(f.recordMaybeInsert(i,n,"{"),{text:"{",selection:[1,1]});}else if("}"==r){if(y(i),"}"==s.substring(o.column,o.column+1))if(null!==n.$findOpeningBracket("}",{column:o.column+1,row:o.row})&&f.isAutoInsertedClosing(o,s,r))return f.popAutoInsertedClosing(),{text:"",selection:[1,1]};}else{if("\n"==r||"\r\n"==r){y(i);var c="";if(f.isMaybeInsertedClosing(o,s)&&(c=m.stringRepeat("}",p.maybeInsertedBrackets),f.clearMaybeInsertedClosing()),"}"===s.substring(o.column,o.column+1)){var h=n.findMatchingBracket({row:o.row,column:o.column+1},"}");if(!h)return null;var d=this.$getIndent(n.getLine(h.row));}else{if(!c)return void f.clearMaybeInsertedClosing();d=this.$getIndent(s);}var u=d+n.getTabString();return{text:"\n"+u+"\n"+d+c,selection:[1,u.length,1,u.length]};}f.clearMaybeInsertedClosing();}}),this.add("braces","deletion",function(e,t,i,n,r){var o=n.doc.getTextRange(r);if(!r.isMultiLine()&&"{"==o){if(y(i),"}"==n.doc.getLine(r.start.row).substring(r.end.column,r.end.column+1))return r.end.column++,r;p.maybeInsertedBrackets--;}}),this.add("parens","insertion",function(e,t,i,n,r){if("("==r){y(i);var o=i.getSelectionRange(),s=n.doc.getTextRange(o);if(""!==s&&i.getWrapBehavioursEnabled())return w(o,s,"(",")");if(f.isSaneInsertion(i,n))return f.recordAutoInsert(i,n,")"),{text:"()",selection:[1,1]};}else if(")"==r){y(i);var a=i.getCursorPosition(),l=n.doc.getLine(a.row);if(")"==l.substring(a.column,a.column+1))if(null!==n.$findOpeningBracket(")",{column:a.column+1,row:a.row})&&f.isAutoInsertedClosing(a,l,r))return f.popAutoInsertedClosing(),{text:"",selection:[1,1]};}}),this.add("parens","deletion",function(e,t,i,n,r){var o=n.doc.getTextRange(r);if(!r.isMultiLine()&&"("==o&&(y(i),")"==n.doc.getLine(r.start.row).substring(r.start.column+1,r.start.column+2)))return r.end.column++,r;}),this.add("brackets","insertion",function(e,t,i,n,r){if("["==r){y(i);var o=i.getSelectionRange(),s=n.doc.getTextRange(o);if(""!==s&&i.getWrapBehavioursEnabled())return w(o,s,"[","]");if(f.isSaneInsertion(i,n))return f.recordAutoInsert(i,n,"]"),{text:"[]",selection:[1,1]};}else if("]"==r){y(i);var a=i.getCursorPosition(),l=n.doc.getLine(a.row);if("]"==l.substring(a.column,a.column+1))if(null!==n.$findOpeningBracket("]",{column:a.column+1,row:a.row})&&f.isAutoInsertedClosing(a,l,r))return f.popAutoInsertedClosing(),{text:"",selection:[1,1]};}}),this.add("brackets","deletion",function(e,t,i,n,r){var o=n.doc.getTextRange(r);if(!r.isMultiLine()&&"["==o&&(y(i),"]"==n.doc.getLine(r.start.row).substring(r.start.column+1,r.start.column+2)))return r.end.column++,r;}),this.add("string_dquotes","insertion",function(e,t,i,n,r){var o=n.$mode.$quotes||S;if(1==r.length&&o[r]){if(this.lineCommentStart&&-1!=this.lineCommentStart.indexOf(r))return;y(i);var s=r,a=i.getSelectionRange(),l=n.doc.getTextRange(a);if(!(""===l||1==l.length&&o[l])&&i.getWrapBehavioursEnabled())return w(a,l,s,s);if(!l){var c=i.getCursorPosition(),h=n.doc.getLine(c.row),d=h.substring(c.column-1,c.column),u=h.substring(c.column,c.column+1),g=n.getTokenAt(c.row,c.column),p=n.getTokenAt(c.row,c.column+1);if("\\"==d&&g&&/escape/.test(g.type))return null;var m,f=g&&/string|escape/.test(g.type),C=!p||/string|escape/.test(p.type);if(u==s)(m=f!==C)&&/string\.end/.test(p.type)&&(m=!1);else{if(f&&!C)return null;if(f&&C)return null;var I=n.$mode.tokenRe;I.lastIndex=0;var A=I.test(d);I.lastIndex=0;var v=I.test(d);if(A||v)return null;if(u&&!/[\s;,.})\]\\]/.test(u))return null;var b=h[c.column-2];if(d==s&&(b==s||I.test(b)))return null;m=!0;}return{text:m?s+s:"",selection:[1,1]};}}}),this.add("string_dquotes","deletion",function(e,t,i,n,r){var o=n.$mode.$quotes||S,s=n.doc.getTextRange(r);if(!r.isMultiLine()&&o.hasOwnProperty(s)&&(y(i),n.doc.getLine(r.start.row).substring(r.start.column+1,r.start.column+2)==s))return r.end.column++,r;});};f.isSaneInsertion=function(e,t){var i=e.getCursorPosition(),n=new o(t,i.row,i.column);if(!this.$matchTokenType(n.getCurrentToken()||"text",s)){if(/[)}\]]/.test(e.session.getLine(i.row)[i.column]))return!0;var r=new o(t,i.row,i.column+1);if(!this.$matchTokenType(r.getCurrentToken()||"text",s))return!1;}return n.stepForward(),n.getCurrentTokenRow()!==i.row||this.$matchTokenType(n.getCurrentToken()||"text",a);},f.$matchTokenType=function(e,t){return-1<t.indexOf(e.type||e);},f.recordAutoInsert=function(e,t,i){var n=e.getCursorPosition(),r=t.doc.getLine(n.row);this.isAutoInsertedClosing(n,r,p.autoInsertedLineEnd[0])||(p.autoInsertedBrackets=0),p.autoInsertedRow=n.row,p.autoInsertedLineEnd=i+r.substr(n.column),p.autoInsertedBrackets++;},f.recordMaybeInsert=function(e,t,i){var n=e.getCursorPosition(),r=t.doc.getLine(n.row);this.isMaybeInsertedClosing(n,r)||(p.maybeInsertedBrackets=0),p.maybeInsertedRow=n.row,p.maybeInsertedLineStart=r.substr(0,n.column)+i,p.maybeInsertedLineEnd=r.substr(n.column),p.maybeInsertedBrackets++;},f.isAutoInsertedClosing=function(e,t,i){return 0<p.autoInsertedBrackets&&e.row===p.autoInsertedRow&&i===p.autoInsertedLineEnd[0]&&t.substr(e.column)===p.autoInsertedLineEnd;},f.isMaybeInsertedClosing=function(e,t){return 0<p.maybeInsertedBrackets&&e.row===p.maybeInsertedRow&&t.substr(e.column)===p.maybeInsertedLineEnd&&t.substr(0,e.column)==p.maybeInsertedLineStart;},f.popAutoInsertedClosing=function(){p.autoInsertedLineEnd=p.autoInsertedLineEnd.substr(1),p.autoInsertedBrackets--;},f.clearMaybeInsertedClosing=function(){p&&(p.maybeInsertedBrackets=0,p.maybeInsertedRow=-1);},n.inherits(f,r),t.CstyleBehaviour=f;}),ace.define("ace/unicode",["require","exports","module"],function(e,t,i){"use strict";for(var n=[48,9,8,25,5,0,2,25,48,0,11,0,5,0,6,22,2,30,2,457,5,11,15,4,8,0,2,0,18,116,2,1,3,3,9,0,2,2,2,0,2,19,2,82,2,138,2,4,3,155,12,37,3,0,8,38,10,44,2,0,2,1,2,1,2,0,9,26,6,2,30,10,7,61,2,9,5,101,2,7,3,9,2,18,3,0,17,58,3,100,15,53,5,0,6,45,211,57,3,18,2,5,3,11,3,9,2,1,7,6,2,2,2,7,3,1,3,21,2,6,2,0,4,3,3,8,3,1,3,3,9,0,5,1,2,4,3,11,16,2,2,5,5,1,3,21,2,6,2,1,2,1,2,1,3,0,2,4,5,1,3,2,4,0,8,3,2,0,8,15,12,2,2,8,2,2,2,21,2,6,2,1,2,4,3,9,2,2,2,2,3,0,16,3,3,9,18,2,2,7,3,1,3,21,2,6,2,1,2,4,3,8,3,1,3,2,9,1,5,1,2,4,3,9,2,0,17,1,2,5,4,2,2,3,4,1,2,0,2,1,4,1,4,2,4,11,5,4,4,2,2,3,3,0,7,0,15,9,18,2,2,7,2,2,2,22,2,9,2,4,4,7,2,2,2,3,8,1,2,1,7,3,3,9,19,1,2,7,2,2,2,22,2,9,2,4,3,8,2,2,2,3,8,1,8,0,2,3,3,9,19,1,2,7,2,2,2,22,2,15,4,7,2,2,2,3,10,0,9,3,3,9,11,5,3,1,2,17,4,23,2,8,2,0,3,6,4,0,5,5,2,0,2,7,19,1,14,57,6,14,2,9,40,1,2,0,3,1,2,0,3,0,7,3,2,6,2,2,2,0,2,0,3,1,2,12,2,2,3,4,2,0,2,5,3,9,3,1,35,0,24,1,7,9,12,0,2,0,2,0,5,9,2,35,5,19,2,5,5,7,2,35,10,0,58,73,7,77,3,37,11,42,2,0,4,328,2,3,3,6,2,0,2,3,3,40,2,3,3,32,2,3,3,6,2,0,2,3,3,14,2,56,2,3,3,66,5,0,33,15,17,84,13,619,3,16,2,25,6,74,22,12,2,6,12,20,12,19,13,12,2,2,2,1,13,51,3,29,4,0,5,1,3,9,34,2,3,9,7,87,9,42,6,69,11,28,4,11,5,11,11,39,3,4,12,43,5,25,7,10,38,27,5,62,2,28,3,10,7,9,14,0,89,75,5,9,18,8,13,42,4,11,71,55,9,9,4,48,83,2,2,30,14,230,23,280,3,5,3,37,3,5,3,7,2,0,2,0,2,0,2,30,3,52,2,6,2,0,4,2,2,6,4,3,3,5,5,12,6,2,2,6,67,1,20,0,29,0,14,0,17,4,60,12,5,0,4,11,18,0,5,0,3,9,2,0,4,4,7,0,2,0,2,0,2,3,2,10,3,3,6,4,5,0,53,1,2684,46,2,46,2,132,7,6,15,37,11,53,10,0,17,22,10,6,2,6,2,6,2,6,2,6,2,6,2,6,2,6,2,31,48,0,470,1,36,5,2,4,6,1,5,85,3,1,3,2,2,89,2,3,6,40,4,93,18,23,57,15,513,6581,75,20939,53,1164,68,45,3,268,4,27,21,31,3,13,13,1,2,24,9,69,11,1,38,8,3,102,3,1,111,44,25,51,13,68,12,9,7,23,4,0,5,45,3,35,13,28,4,64,15,10,39,54,10,13,3,9,7,22,4,1,5,66,25,2,227,42,2,1,3,9,7,11171,13,22,5,48,8453,301,3,61,3,105,39,6,13,4,6,11,2,12,2,4,2,0,2,1,2,1,2,107,34,362,19,63,3,53,41,11,5,15,17,6,13,1,25,2,33,4,2,134,20,9,8,25,5,0,2,25,12,88,4,5,3,5,3,5,3,2],r=0,o=[],s=0;s<n.length;s+=2){o.push(r+=n[s]),n[s+1]&&o.push(45,r+=n[s+1]);}t.wordChars=String.fromCharCode.apply(null,o);}),ace.define("ace/mode/text",["require","exports","module","ace/config","ace/tokenizer","ace/mode/text_highlight_rules","ace/mode/behaviour/cstyle","ace/unicode","ace/lib/lang","ace/token_iterator","ace/range"],function(e,t,i){"use strict";function n(){this.HighlightRules=o;}var s=e("../config"),r=e("../tokenizer").Tokenizer,o=e("./text_highlight_rules").TextHighlightRules,a=e("./behaviour/cstyle").CstyleBehaviour,l=e("../unicode"),b=e("../lib/lang"),m=e("../token_iterator").TokenIterator,f=e("../range").Range;(function(){this.$defaultBehaviour=new a(),this.tokenRe=new RegExp("^["+l.wordChars+"\\$_]+","g"),this.nonTokenRe=new RegExp("^(?:[^"+l.wordChars+"\\$_]|\\s])+","g"),this.getTokenizer=function(){return this.$tokenizer||(this.$highlightRules=this.$highlightRules||new this.HighlightRules(this.$highlightRuleConfig),this.$tokenizer=new r(this.$highlightRules.getRules())),this.$tokenizer;},this.lineCommentStart="",this.blockComment="",this.toggleCommentLines=function(e,r,i,n){var o=r.doc,s=!0,a=!0,l=1/0,c=r.getTabSize(),t=!1;if(this.lineCommentStart){m=Array.isArray(this.lineCommentStart)?(C=this.lineCommentStart.map(b.escapeRegExp).join("|"),this.lineCommentStart[0]):(C=b.escapeRegExp(this.lineCommentStart),this.lineCommentStart),C=new RegExp("^(\\s*)(?:"+C+") ?"),t=r.getUseSoftTabs();var h=function h(e,t){var i,n,r=e.match(C);r&&(i=r[1].length,n=r[0].length,p(e,i,n)||" "!=r[0][n-1]||n--,o.removeInLine(t,i,n));},d=m+" ",u=function u(e,t){s&&!/\S/.test(e)||(p(e,l,l)?o.insertInLine({row:t,column:l},d):o.insertInLine({row:t,column:l},m));},g=function g(e,t){return C.test(e);},p=function p(e,t,i){for(var n=0;t--&&" "==e.charAt(t);){n++;}if(n%c!=0)return!1;for(n=0;" "==e.charAt(i++);){n++;}return 2<c?n%c!=c-1:n%c==0;};}else{if(!this.blockComment)return!1;var m=this.blockComment.start,f=this.blockComment.end,C=new RegExp("^(\\s*)(?:"+b.escapeRegExp(m)+")"),I=new RegExp("(?:"+b.escapeRegExp(f)+")\\s*$"),u=function u(e,t){g(e,t)||s&&!/\S/.test(e)||(o.insertInLine({row:t,column:e.length},f),o.insertInLine({row:t,column:l},m));},h=function h(e,t){var i;(i=e.match(I))&&o.removeInLine(t,e.length-i[0].length,e.length),(i=e.match(C))&&o.removeInLine(t,i[1].length,i[0].length);},g=function g(e,t){if(C.test(e))return!0;for(var i=r.getTokens(t),n=0;n<i.length;n++){if("comment"===i[n].type)return!0;}};}function A(e){for(var t=i;t<=n;t++){e(o.getLine(t),t);}}var v=1/0;A(function(e,t){var i=e.search(/\S/);-1!==i?(i<l&&(l=i),a&&!g(e,t)&&(a=!1)):v>e.length&&(v=e.length);}),l==1/0&&(l=v,a=s=!1),t&&l%c!=0&&(l=Math.floor(l/c)*c),A(a?h:u);},this.toggleBlockComment=function(e,t,i,n){var r=this.blockComment;if(r){!r.start&&r[0]&&(r=r[0]);var o,s,a=(u=new m(t,n.row,n.column)).getCurrentToken(),l=(t.selection,t.selection.toOrientedRange());if(a&&/comment/.test(a.type)){for(;a&&/comment/.test(a.type);){if(-1!=(g=a.value.indexOf(r.start))){var c=u.getCurrentTokenRow(),h=u.getCurrentTokenColumn()+g,d=new f(c,h,c,h+r.start.length);break;}a=u.stepBackward();}for(var u,g,a=(u=new m(t,n.row,n.column)).getCurrentToken();a&&/comment/.test(a.type);){if(-1!=(g=a.value.indexOf(r.end))){var c=u.getCurrentTokenRow(),h=u.getCurrentTokenColumn()+g,p=new f(c,h,c,h+r.end.length);break;}a=u.stepForward();}p&&t.remove(p),d&&(t.remove(d),o=d.start.row,s=-r.start.length);}else s=r.start.length,o=i.start.row,t.insert(i.end,r.end),t.insert(i.start,r.start);l.start.row==o&&(l.start.column+=s),l.end.row==o&&(l.end.column+=s),t.selection.fromOrientedRange(l);}},this.getNextLineIndent=function(e,t,i){return this.$getIndent(t);},this.checkOutdent=function(e,t,i){return!1;},this.autoOutdent=function(e,t,i){},this.$getIndent=function(e){return e.match(/^\s*/)[0];},this.createWorker=function(e){return null;},this.createModeDelegates=function(e){for(var n in this.$embeds=[],this.$modes={},e){var t,i,r;e[n]&&(i=(t=e[n]).prototype.$id,(r=s.$modes[i])||(s.$modes[i]=r=new t()),s.$modes[n]||(s.$modes[n]=r),this.$embeds.push(n),this.$modes[n]=r);}for(var o=["toggleBlockComment","toggleCommentLines","getNextLineIndent","checkOutdent","autoOutdent","transformAction","getCompletions"],n=0;n<o.length;n++){!function(e){var t=o[n],i=e[t];e[o[n]]=function(){return this.$delegator(t,arguments,i);};}(this);}},this.$delegator=function(e,t,i){var n=t[0]||"start";if("string"!=typeof n){if(Array.isArray(n[2])){var r=n[2][n[2].length-1];if(s=this.$modes[r])return s[e].apply(s,[n[1]].concat([].slice.call(t,1)));}n=n[0]||"start";}for(var o=0;o<this.$embeds.length;o++){if(this.$modes[this.$embeds[o]]){var s,a=n.split(this.$embeds[o]);if(!a[0]&&a[1])return t[0]=a[1],(s=this.$modes[this.$embeds[o]])[e].apply(s,t);}}var l=i.apply(this,t);return i?l:void 0;},this.transformAction=function(e,t,i,n,r){if(this.$behaviour){var o=this.$behaviour.getBehaviours();for(var s in o){if(o[s][t]){var a=o[s][t].apply(this,arguments);if(a)return a;}}}},this.getKeywords=function(e){if(!this.completionKeywords){var t=this.$tokenizer.rules,i=[];for(var n in t){for(var r=t[n],o=0,s=r.length;o<s;o++){if("string"==typeof r[o].token)/keyword|support|storage/.test(r[o].token)&&i.push(r[o].regex);else if("object"==_typeof(r[o].token))for(var a=0,l=r[o].token.length;a<l;a++){/keyword|support|storage/.test(r[o].token[a])&&(n=r[o].regex.match(/\(.+?\)/g)[a],i.push(n.substr(1,n.length-2)));}}}this.completionKeywords=i;}return e?i.concat(this.$keywordList||[]):this.$keywordList;},this.$createKeywordList=function(){return this.$highlightRules||this.getTokenizer(),this.$keywordList=this.$highlightRules.$keywordList||[];},this.getCompletions=function(e,t,i,n){return(this.$keywordList||this.$createKeywordList()).map(function(e){return{name:e,value:e,score:0,meta:"keyword"};});},this.$id="ace/mode/text";}).call(n.prototype),t.Mode=n;}),ace.define("ace/apply_delta",["require","exports","module"],function(e,t,i){"use strict";t.applyDelta=function(e,t,i){var n,r=t.start.row,o=t.start.column,s=e[r]||"";switch(t.action){case"insert":1===t.lines.length?e[r]=s.substring(0,o)+t.lines[0]+s.substring(o):(n=[r,1].concat(t.lines),e.splice.apply(e,n),e[r]=s.substring(0,o)+e[r],e[r+t.lines.length-1]+=s.substring(o));break;case"remove":var a=t.end.column,l=t.end.row;r===l?e[r]=s.substring(0,o)+s.substring(a):e.splice(r,l-r+1,s.substring(0,o)+e[l].substring(a));}};}),ace.define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./lib/event_emitter").EventEmitter,o=t.Anchor=function(e,t,i){this.$onChange=this.onChange.bind(this),this.attach(e),void 0===i?this.setPosition(t.row,t.column):this.setPosition(t,i);};(function(){function l(e,t,i){var n=i?e.column<=t.column:e.column<t.column;return e.row<t.row||e.row==t.row&&n;}n.implement(this,r),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column);},this.getDocument=function(){return this.document;},this.$insertRight=!1,this.onChange=function(e){var t;e.start.row==e.end.row&&e.start.row!=this.row||e.start.row>this.row||(t=function(e,t,i){var n="insert"==e.action,r=(n?1:-1)*(e.end.row-e.start.row),o=(n?1:-1)*(e.end.column-e.start.column),s=e.start,a=n?s:e.end;if(l(t,s,i))return{row:t.row,column:t.column};if(l(a,t,!i))return{row:t.row+r,column:t.column+(t.row==a.row?o:0)};return{row:s.row,column:s.column};}(e,{row:this.row,column:this.column},this.$insertRight),this.setPosition(t.row,t.column,!0));},this.setPosition=function(e,t,i){var n,r=i?{row:e,column:t}:this.$clipPositionToDocument(e,t);this.row==r.row&&this.column==r.column||(n={row:this.row,column:this.column},this.row=r.row,this.column=r.column,this._signal("change",{old:n,value:r}));},this.detach=function(){this.document.off("change",this.$onChange);},this.attach=function(e){this.document=e||this.document,this.document.on("change",this.$onChange);},this.$clipPositionToDocument=function(e,t){var i={};return e>=this.document.getLength()?(i.row=Math.max(0,this.document.getLength()-1),i.column=this.document.getLine(i.row).length):e<0?(i.row=0,i.column=0):(i.row=e,i.column=Math.min(this.document.getLine(i.row).length,Math.max(0,t))),t<0&&(i.column=0),i;};}).call(o.prototype);}),ace.define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"],function(e,t,i){"use strict";function n(e){this.$lines=[""],0===e.length?this.$lines=[""]:Array.isArray(e)?this.insertMergedLines({row:0,column:0},e):this.insert({row:0,column:0},e);}var r=e("./lib/oop"),o=e("./apply_delta").applyDelta,s=e("./lib/event_emitter").EventEmitter,h=e("./range").Range,a=e("./anchor").Anchor;(function(){r.implement(this,s),this.setValue=function(e){var t=this.getLength()-1;this.remove(new h(0,0,t,this.getLine(t).length)),this.insert({row:0,column:0},e);},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter());},this.createAnchor=function(e,t){return new a(this,e,t);},0==="aaa".split(/a/).length?this.$split=function(e){return e.replace(/\r\n|\r/g,"\n").split("\n");}:this.$split=function(e){return e.split(/\r\n|\r|\n/);},this.$detectNewLine=function(e){var t=e.match(/^.*?(\r\n|\r|\n)/m);this.$autoNewLine=t?t[1]:"\n",this._signal("changeNewLineMode");},this.getNewLineCharacter=function(){switch(this.$newLineMode){case"windows":return"\r\n";case"unix":return"\n";default:return this.$autoNewLine||"\n";}},this.$autoNewLine="",this.$newLineMode="auto",this.setNewLineMode=function(e){this.$newLineMode!==e&&(this.$newLineMode=e,this._signal("changeNewLineMode"));},this.getNewLineMode=function(){return this.$newLineMode;},this.isNewLine=function(e){return"\r\n"==e||"\r"==e||"\n"==e;},this.getLine=function(e){return this.$lines[e]||"";},this.getLines=function(e,t){return this.$lines.slice(e,t+1);},this.getAllLines=function(){return this.getLines(0,this.getLength());},this.getLength=function(){return this.$lines.length;},this.getTextRange=function(e){return this.getLinesForRange(e).join(this.getNewLineCharacter());},this.getLinesForRange=function(e){var t,i;return e.start.row===e.end.row?t=[this.getLine(e.start.row).substring(e.start.column,e.end.column)]:((t=this.getLines(e.start.row,e.end.row))[0]=(t[0]||"").substring(e.start.column),i=t.length-1,e.end.row-e.start.row==i&&(t[i]=t[i].substring(0,e.end.column))),t;},this.insertLines=function(e,t){return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."),this.insertFullLines(e,t);},this.removeLines=function(e,t){return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."),this.removeFullLines(e,t);},this.insertNewLine=function(e){return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."),this.insertMergedLines(e,["",""]);},this.insert=function(e,t){return this.getLength()<=1&&this.$detectNewLine(t),this.insertMergedLines(e,this.$split(t));},this.insertInLine=function(e,t){var i=this.clippedPos(e.row,e.column),n=this.pos(e.row,e.column+t.length);return this.applyDelta({start:i,end:n,action:"insert",lines:[t]},!0),this.clonePos(n);},this.clippedPos=function(e,t){var i=this.getLength();void 0===e?e=i:e<0?e=0:i<=e&&(e=i-1,t=void 0);var n=this.getLine(e);return null==t&&(t=n.length),{row:e,column:t=Math.min(Math.max(t,0),n.length)};},this.clonePos=function(e){return{row:e.row,column:e.column};},this.pos=function(e,t){return{row:e,column:t};},this.$clipPosition=function(e){var t=this.getLength();return e.row>=t?(e.row=Math.max(0,t-1),e.column=this.getLine(t-1).length):(e.row=Math.max(0,e.row),e.column=Math.min(Math.max(e.column,0),this.getLine(e.row).length)),e;},this.insertFullLines=function(e,t){var i=0,i=(e=Math.min(Math.max(e,0),this.getLength()))<this.getLength()?(t=t.concat([""]),0):(t=[""].concat(t),e--,this.$lines[e].length);this.insertMergedLines({row:e,column:i},t);},this.insertMergedLines=function(e,t){var i=this.clippedPos(e.row,e.column),n={row:i.row+t.length-1,column:(1==t.length?i.column:0)+t[t.length-1].length};return this.applyDelta({start:i,end:n,action:"insert",lines:t}),this.clonePos(n);},this.remove=function(e){var t=this.clippedPos(e.start.row,e.start.column),i=this.clippedPos(e.end.row,e.end.column);return this.applyDelta({start:t,end:i,action:"remove",lines:this.getLinesForRange({start:t,end:i})}),this.clonePos(t);},this.removeInLine=function(e,t,i){var n=this.clippedPos(e,t),r=this.clippedPos(e,i);return this.applyDelta({start:n,end:r,action:"remove",lines:this.getLinesForRange({start:n,end:r})},!0),this.clonePos(n);},this.removeFullLines=function(e,t){e=Math.min(Math.max(0,e),this.getLength()-1);var i=(t=Math.min(Math.max(0,t),this.getLength()-1))==this.getLength()-1&&0<e,n=t<this.getLength()-1,r=i?e-1:e,o=i?this.getLine(r).length:0,s=n?t+1:t,a=n?0:this.getLine(s).length,l=new h(r,o,s,a),c=this.$lines.slice(e,t+1);return this.applyDelta({start:l.start,end:l.end,action:"remove",lines:this.getLinesForRange(l)}),c;},this.removeNewLine=function(e){e<this.getLength()-1&&0<=e&&this.applyDelta({start:this.pos(e,this.getLine(e).length),end:this.pos(e+1,0),action:"remove",lines:["",""]});},this.replace=function(e,t){return e instanceof h||(e=h.fromPoints(e.start,e.end)),0===t.length&&e.isEmpty()?e.start:t==this.getTextRange(e)?e.end:(this.remove(e),t?this.insert(e.start,t):e.start);},this.applyDeltas=function(e){for(var t=0;t<e.length;t++){this.applyDelta(e[t]);}},this.revertDeltas=function(e){for(var t=e.length-1;0<=t;t--){this.revertDelta(e[t]);}},this.applyDelta=function(e,t){var i="insert"==e.action;(i?e.lines.length<=1&&!e.lines[0]:!h.comparePoints(e.start,e.end))||(i&&2e4<e.lines.length?this.$splitAndapplyLargeDelta(e,2e4):(o(this.$lines,e,t),this._signal("change",e)));},this.$safeApplyDelta=function(e){var t=this.$lines.length;("remove"==e.action&&e.start.row<t&&e.end.row<t||"insert"==e.action&&e.start.row<=t)&&this.applyDelta(e);},this.$splitAndapplyLargeDelta=function(e,t){for(var i=e.lines,n=i.length-t+1,r=e.start.row,o=e.start.column,s=0,a=0;s<n;s=a){a+=t-1;var l=i.slice(s,a);l.push(""),this.applyDelta({start:this.pos(r+s,o),end:this.pos(r+a,o=0),action:e.action,lines:l},!0);}e.lines=i.slice(s),e.start.row=r+s,e.start.column=o,this.applyDelta(e,!0);},this.revertDelta=function(e){this.$safeApplyDelta({start:this.clonePos(e.start),end:this.clonePos(e.end),action:"insert"==e.action?"remove":"insert",lines:e.lines.slice()});},this.indexToPosition=function(e,t){for(var i=this.$lines||this.getAllLines(),n=this.getNewLineCharacter().length,r=t||0,o=i.length;r<o;r++){if((e-=i[r].length+n)<0)return{row:r,column:e+i[r].length+n};}return{row:o-1,column:e+i[o-1].length+n};},this.positionToIndex=function(e,t){for(var i=this.$lines||this.getAllLines(),n=this.getNewLineCharacter().length,r=0,o=Math.min(e.row,i.length),s=t||0;s<o;++s){r+=i[s].length+n;}return r+e.column;};}).call(n.prototype),t.Document=n;}),ace.define("ace/background_tokenizer",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,i){"use strict";function n(e,t){this.running=!1,this.lines=[],this.states=[],this.currentLine=0,this.tokenizer=e;var a=this;this.$worker=function(){if(a.running){for(var e=new Date(),t=a.currentLine,i=-1,n=a.doc,r=t;a.lines[t];){t++;}var o=n.getLength(),s=0;for(a.running=!1;t<o;){for(a.$tokenizeRow(t),i=t;t++,a.lines[t];){}if(++s%5==0&&20<new Date()-e){a.running=setTimeout(a.$worker,20);break;}}a.currentLine=t,-1==i&&(i=t),r<=i&&a.fireUpdateEvent(r,i);}};}var r=e("./lib/oop"),o=e("./lib/event_emitter").EventEmitter;(function(){r.implement(this,o),this.setTokenizer=function(e){this.tokenizer=e,this.lines=[],this.states=[],this.start(0);},this.setDocument=function(e){this.doc=e,this.lines=[],this.states=[],this.stop();},this.fireUpdateEvent=function(e,t){var i={first:e,last:t};this._signal("update",{data:i});},this.start=function(e){this.currentLine=Math.min(e||0,this.currentLine,this.doc.getLength()),this.lines.splice(this.currentLine,this.lines.length),this.states.splice(this.currentLine,this.states.length),this.stop(),this.running=setTimeout(this.$worker,700);},this.scheduleStart=function(){this.running||(this.running=setTimeout(this.$worker,700));},this.$updateOnChange=function(e){var t,i=e.start.row,n=e.end.row-i;0==n?this.lines[i]=null:"remove"==e.action?(this.lines.splice(i,1+n,null),this.states.splice(i,1+n,null)):((t=Array(1+n)).unshift(i,1),this.lines.splice.apply(this.lines,t),this.states.splice.apply(this.states,t)),this.currentLine=Math.min(i,this.currentLine,this.doc.getLength()),this.stop();},this.stop=function(){this.running&&clearTimeout(this.running),this.running=!1;},this.getTokens=function(e){return this.lines[e]||this.$tokenizeRow(e);},this.getState=function(e){return this.currentLine==e&&this.$tokenizeRow(e),this.states[e]||"start";},this.$tokenizeRow=function(e){var t=this.doc.getLine(e),i=this.states[e-1],n=this.tokenizer.getLineTokens(t,i,e);return this.states[e]+""!=n.state+""?(this.states[e]=n.state,this.lines[e+1]=null,this.currentLine>e+1&&(this.currentLine=e+1)):this.currentLine==e&&(this.currentLine=e+1),this.lines[e]=n.tokens;};}).call(n.prototype),t.BackgroundTokenizer=n;}),ace.define("ace/search_highlight",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"],function(e,t,i){"use strict";function n(e,t,i){this.setRegexp(e),this.clazz=t,this.type=i||"text";}var c=e("./lib/lang"),h=(e("./lib/oop"),e("./range").Range);(function(){this.MAX_RANGES=500,this.setRegexp=function(e){this.regExp+""!=e+""&&(this.regExp=e,this.cache=[]);},this.update=function(e,t,i,n){if(this.regExp)for(var r=n.firstRow,o=n.lastRow,s=r;s<=o;s++){var a=this.cache[s];null==a&&((a=c.getMatchOffsets(i.getLine(s),this.regExp)).length>this.MAX_RANGES&&(a=a.slice(0,this.MAX_RANGES)),a=a.map(function(e){return new h(s,e.offset,s,e.offset+e.length);}),this.cache[s]=a.length?a:"");for(var l=a.length;l--;){t.drawSingleLineMarker(e,a[l].toScreenRange(i),this.clazz,n);}}};}).call(n.prototype),t.SearchHighlight=n;}),ace.define("ace/edit_session/fold_line",["require","exports","module","ace/range"],function(e,t,i){"use strict";var n=e("../range").Range;function c(e,t){this.foldData=e,Array.isArray(t)?this.folds=t:t=this.folds=[t];var i=t[t.length-1];this.range=new n(t[0].start.row,t[0].start.column,i.end.row,i.end.column),this.start=this.range.start,this.end=this.range.end,this.folds.forEach(function(e){e.setFoldLine(this);},this);}(function(){this.shiftRow=function(t){this.start.row+=t,this.end.row+=t,this.folds.forEach(function(e){e.start.row+=t,e.end.row+=t;});},this.addFold=function(e){if(e.sameRow){if(e.start.row<this.startRow||e.endRow>this.endRow)throw new Error("Can't add a fold to this FoldLine as it has no connection");this.folds.push(e),this.folds.sort(function(e,t){return-e.range.compareEnd(t.start.row,t.start.column);}),0<this.range.compareEnd(e.start.row,e.start.column)?(this.end.row=e.end.row,this.end.column=e.end.column):this.range.compareStart(e.end.row,e.end.column)<0&&(this.start.row=e.start.row,this.start.column=e.start.column);}else if(e.start.row==this.end.row)this.folds.push(e),this.end.row=e.end.row,this.end.column=e.end.column;else{if(e.end.row!=this.start.row)throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");this.folds.unshift(e),this.start.row=e.start.row,this.start.column=e.start.column;}e.foldLine=this;},this.containsRow=function(e){return e>=this.start.row&&e<=this.end.row;},this.walk=function(e,t,i){var n,r,o=0,s=this.folds,a=!0;null==t&&(t=this.end.row,i=this.end.column);for(var l=0;l<s.length;l++){if(-1==(r=(n=s[l]).range.compareStart(t,i)))return void e(null,t,i,o,a);if(!e(null,n.start.row,n.start.column,o,a)&&e(n.placeholder,n.start.row,n.start.column,o)||0===r)return;a=!n.sameRow,o=n.end.column;}e(null,t,i,o,a);},this.getNextFoldTo=function(e,t){for(var i,n,r=0;r<this.folds.length;r++){if(-1==(n=(i=this.folds[r]).range.compareEnd(e,t)))return{fold:i,kind:"after"};if(0===n)return{fold:i,kind:"inside"};}return null;},this.addRemoveChars=function(e,t,i){var n,r,o=this.getNextFoldTo(e,t);if(o)if(n=o.fold,"inside"==o.kind&&n.start.column!=t&&n.start.row!=e)window.console&&window.console.log(e,t,n);else if(n.start.row==e){var s=(r=this.folds).indexOf(n);for(0===s&&(this.start.column+=i);s<r.length;s++){if((n=r[s]).start.column+=i,!n.sameRow)return;n.end.column+=i;}this.end.column+=i;}},this.split=function(e,t){var i=this.getNextFoldTo(e,t);if(!i||"inside"==i.kind)return null;var n=i.fold,r=this.folds,o=this.foldData,s=r.indexOf(n),a=r[s-1];this.end.row=a.end.row,this.end.column=a.end.column;var l=new c(o,r=r.splice(s,r.length-s));return o.splice(o.indexOf(this)+1,0,l),l;},this.merge=function(e){for(var t=e.folds,i=0;i<t.length;i++){this.addFold(t[i]);}var n=this.foldData;n.splice(n.indexOf(e),1);},this.toString=function(){var t=[this.range.toString()+": ["];return this.folds.forEach(function(e){t.push("  "+e.toString());}),t.push("]"),t.join("\n");},this.idxToPosition=function(e){for(var t=0,i=0;i<this.folds.length;i++){var n=this.folds[i];if((e-=n.start.column-t)<0)return{row:n.start.row,column:n.start.column+e};if((e-=n.placeholder.length)<0)return n.start;t=n.end.column;}return{row:this.end.row,column:this.end.column+e};};}).call(c.prototype),t.FoldLine=c;}),ace.define("ace/range_list",["require","exports","module","ace/range"],function(e,t,i){"use strict";function n(){this.ranges=[],this.$bias=1;}var l=e("./range").Range.comparePoints;(function(){this.comparePoints=l,this.pointIndex=function(e,t,i){for(var n=this.ranges,r=i||0;r<n.length;r++){var o=n[r],s=l(e,o.end);if(!(0<s)){var a=l(e,o.start);return 0===s?t&&0!==a?-r-2:r:0<a||0===a&&!t?r:-r-1;}}return-r-1;},this.add=function(e){var t=!e.isEmpty(),i=this.pointIndex(e.start,t);i<0&&(i=-i-1);var n=this.pointIndex(e.end,t,i);return n<0?n=-n-1:n++,this.ranges.splice(i,n-i,e);},this.addList=function(e){for(var t=[],i=e.length;i--;){t.push.apply(t,this.add(e[i]));}return t;},this.substractPoint=function(e){var t=this.pointIndex(e);if(0<=t)return this.ranges.splice(t,1);},this.merge=function(){for(var e,t=[],i=this.ranges,n=(i=i.sort(function(e,t){return l(e.start,t.start);}))[0],r=1;r<i.length;r++){e=n,n=i[r];var o=l(e.end,n.start);o<0||(0!=o||e.isEmpty()||n.isEmpty())&&(l(e.end,n.end)<0&&(e.end.row=n.end.row,e.end.column=n.end.column),i.splice(r,1),t.push(n),n=e,r--);}return this.ranges=i,t;},this.contains=function(e,t){return 0<=this.pointIndex({row:e,column:t});},this.containsPoint=function(e){return 0<=this.pointIndex(e);},this.rangeAtPoint=function(e){var t=this.pointIndex(e);if(0<=t)return this.ranges[t];},this.clipRows=function(e,t){var i=this.ranges;if(i[0].start.row>t||i[i.length-1].start.row<e)return[];var n=this.pointIndex({row:e,column:0});n<0&&(n=-n-1);var r=this.pointIndex({row:t,column:0},n);r<0&&(r=-r-1);for(var o=[],s=n;s<r;s++){o.push(i[s]);}return o;},this.removeAll=function(){return this.ranges.splice(0,this.ranges.length);},this.attach=function(e){this.session&&this.detach(),this.session=e,this.onChange=this.$onChange.bind(this),this.session.on("change",this.onChange);},this.detach=function(){this.session&&(this.session.removeListener("change",this.onChange),this.session=null);},this.$onChange=function(e){for(var t=e.start,i=e.end,n=t.row,r=i.row,o=this.ranges,s=0,a=o.length;s<a;s++){if((h=o[s]).end.row>=n)break;}if("insert"==e.action)for(var l=r-n,c=-t.column+i.column;s<a;s++){if((h=o[s]).start.row>n)break;if(h.start.row==n&&h.start.column>=t.column&&(h.start.column==t.column&&this.$bias<=0||(h.start.column+=c,h.start.row+=l)),h.end.row==n&&h.end.column>=t.column){if(h.end.column==t.column&&this.$bias<0)continue;h.end.column==t.column&&0<c&&s<a-1&&h.end.column>h.start.column&&h.end.column==o[s+1].start.column&&(h.end.column-=c),h.end.column+=c,h.end.row+=l;}}else for(var h,l=n-r,c=t.column-i.column;s<a;s++){if((h=o[s]).start.row>r)break;h.end.row<r&&(n<h.end.row||n==h.end.row&&t.column<h.end.column)?(h.end.row=n,h.end.column=t.column):h.end.row==r?h.end.column<=i.column?(l||h.end.column>t.column)&&(h.end.column=t.column,h.end.row=t.row):(h.end.column+=c,h.end.row+=l):h.end.row>r&&(h.end.row+=l),h.start.row<r&&(n<h.start.row||n==h.start.row&&t.column<h.start.column)?(h.start.row=n,h.start.column=t.column):h.start.row==r?h.start.column<=i.column?(l||h.start.column>t.column)&&(h.start.column=t.column,h.start.row=t.row):(h.start.column+=c,h.start.row+=l):h.start.row>r&&(h.start.row+=l);}if(0!=l&&s<a)for(;s<a;s++){(h=o[s]).start.row+=l,h.end.row+=l;}};}).call(n.prototype),t.RangeList=n;}),ace.define("ace/edit_session/fold",["require","exports","module","ace/range_list","ace/lib/oop"],function(e,t,i){"use strict";var n=e("../range_list").RangeList,r=e("../lib/oop"),o=t.Fold=function(e,t){this.foldLine=null,this.placeholder=t,this.range=e,this.start=e.start,this.end=e.end,this.sameRow=e.start.row==e.end.row,this.subFolds=this.ranges=[];};function g(e,t){e.row-=t.row,0==e.row&&(e.column-=t.column);}function s(e,t){0==e.row&&(e.column+=t.column),e.row+=t.row;}r.inherits(o,n),function(){this.toString=function(){return'"'+this.placeholder+'" '+this.range.toString();},this.setFoldLine=function(t){this.foldLine=t,this.subFolds.forEach(function(e){e.setFoldLine(t);});},this.clone=function(){var e=this.range.clone(),t=new o(e,this.placeholder);return this.subFolds.forEach(function(e){t.subFolds.push(e.clone());}),t.collapseChildren=this.collapseChildren,t;},this.addSubFold=function(e){if(!this.range.isEqual(e)){var t,i;t=e,i=this.start,g(t.start,i),g(t.end,i);for(var n=e.start.row,r=e.start.column,o=0,s=-1;o<this.subFolds.length&&1==(s=this.subFolds[o].range.compare(n,r));o++){}var a=this.subFolds[o],l=0;if(0==s){if(a.range.containsRange(e))return a.addSubFold(e);l=1;}for(var n=e.range.end.row,r=e.range.end.column,c=o,s=-1;c<this.subFolds.length&&1==(s=this.subFolds[c].range.compare(n,r));c++){}0==s&&c++;for(var h=this.subFolds.splice(o,c-o,e),d=0==s?h.length-1:h.length,u=l;u<d;u++){e.addSubFold(h[u]);}return e.setFoldLine(this.foldLine),e;}},this.restoreRange=function(e){return t=e,i=this.start,s(t.start,i),void s(t.end,i);var t,i;};}.call(o.prototype);}),ace.define("ace/edit_session/folding",["require","exports","module","ace/range","ace/edit_session/fold_line","ace/edit_session/fold","ace/token_iterator"],function(e,t,i){"use strict";var h=e("../range").Range,m=e("./fold_line").FoldLine,f=e("./fold").Fold,d=e("../token_iterator").TokenIterator;t.Folding=function(){this.getFoldAt=function(e,t,i){var n=this.getFoldLine(e);if(!n)return null;for(var r=n.folds,o=0;o<r.length;o++){var s=r[o].range;if(s.contains(e,t)){if(1==i&&s.isEnd(e,t)&&!s.isEmpty())continue;if(-1==i&&s.isStart(e,t)&&!s.isEmpty())continue;return r[o];}}},this.getFoldsInRange=function(e){var t=e.start,i=e.end,n=this.$foldData,r=[];t.column+=1,--i.column;for(var o=0;o<n.length;o++){if(2!=(l=n[o].range.compareRange(e))){if(-2==l)break;for(var s=n[o].folds,a=0;a<s.length;a++){var l,c=s[a];if(-2==(l=c.range.compareRange(e)))break;if(2!=l){if(42==l)break;r.push(c);}}}}return--t.column,i.column+=1,r;},this.getFoldsInRangeList=function(e){var t;return Array.isArray(e)?(t=[],e.forEach(function(e){t=t.concat(this.getFoldsInRange(e));},this)):t=this.getFoldsInRange(e),t;},this.getAllFolds=function(){for(var e=[],t=this.$foldData,i=0;i<t.length;i++){for(var n=0;n<t[i].folds.length;n++){e.push(t[i].folds[n]);}}return e;},this.getFoldStringAt=function(e,t,i,n){if(!(n=n||this.getFoldLine(e)))return null;for(var r,o,s={end:{column:0}},a=0;a<n.folds.length;a++){var l=(o=n.folds[a]).range.compareEnd(e,t);if(-1==l){r=this.getLine(o.start.row).substring(s.end.column,o.start.column);break;}if(0===l)return null;s=o;}return r=r||this.getLine(o.start.row).substring(s.end.column),-1==i?r.substring(0,t-s.end.column):1==i?r.substring(t-s.end.column):r;},this.getFoldLine=function(e,t){var i=this.$foldData,n=0;for(t&&(n=i.indexOf(t)),-1==n&&(n=0);n<i.length;n++){var r=i[n];if(r.start.row<=e&&r.end.row>=e)return r;if(r.end.row>e)return null;}return null;},this.getNextFoldLine=function(e,t){var i=this.$foldData,n=0;for(t&&(n=i.indexOf(t)),-1==n&&(n=0);n<i.length;n++){var r=i[n];if(r.end.row>=e)return r;}return null;},this.getFoldedRowCount=function(e,t){for(var i=this.$foldData,n=t-e+1,r=0;r<i.length;r++){var o=i[r],s=o.end.row,a=o.start.row;if(t<=s){a<t&&(e<=a?n-=t-a:n=0);break;}e<=s&&(n-=e<=a?s-a:s-e+1);}return n;},this.$addFoldLine=function(e){return this.$foldData.push(e),this.$foldData.sort(function(e,t){return e.start.row-t.start.row;}),e;},this.addFold=function(e,t){var i,n=this.$foldData,r=!1;e instanceof f?i=e:(i=new f(t,e)).collapseChildren=t.collapseChildren,this.$clipRangeToDocument(i.range);var o=i.start.row,s=i.start.column,a=i.end.row,l=i.end.column,c=this.getFoldAt(o,s,1),h=this.getFoldAt(a,l,-1);if(c&&h==c)return c.addSubFold(i);c&&!c.range.isStart(o,s)&&this.removeFold(c),h&&!h.range.isEnd(a,l)&&this.removeFold(h);var d=this.getFoldsInRange(i.range);0<d.length&&(this.removeFolds(d),d.forEach(function(e){i.addSubFold(e);}));for(var u=0;u<n.length;u++){var g=n[u];if(a==g.start.row){g.addFold(i),r=!0;break;}if(o==g.end.row){if(g.addFold(i),r=!0,!i.sameRow){var p=n[u+1];if(p&&p.start.row==a){g.merge(p);break;}}break;}if(a<=g.start.row)break;}return r||(g=this.$addFoldLine(new m(this.$foldData,i))),this.$useWrapMode?this.$updateWrapData(g.start.row,g.start.row):this.$updateRowLengthCache(g.start.row,g.start.row),this.$modified=!0,this._signal("changeFold",{data:i,action:"add"}),i;},this.addFolds=function(e){e.forEach(function(e){this.addFold(e);},this);},this.removeFold=function(e){var t,i=e.foldLine,n=i.start.row,r=i.end.row,o=this.$foldData,s=i.folds;1==s.length?o.splice(o.indexOf(i),1):i.range.isEnd(e.end.row,e.end.column)?(s.pop(),i.end.row=s[s.length-1].end.row,i.end.column=s[s.length-1].end.column):i.range.isStart(e.start.row,e.start.column)?(s.shift(),i.start.row=s[0].start.row,i.start.column=s[0].start.column):e.sameRow?s.splice(s.indexOf(e),1):((s=(t=i.split(e.start.row,e.start.column)).folds).shift(),t.start.row=s[0].start.row,t.start.column=s[0].start.column),this.$updating||(this.$useWrapMode?this.$updateWrapData(n,r):this.$updateRowLengthCache(n,r)),this.$modified=!0,this._signal("changeFold",{data:e,action:"remove"});},this.removeFolds=function(e){for(var t=[],i=0;i<e.length;i++){t.push(e[i]);}t.forEach(function(e){this.removeFold(e);},this),this.$modified=!0;},this.expandFold=function(t){this.removeFold(t),t.subFolds.forEach(function(e){t.restoreRange(e),this.addFold(e);},this),0<t.collapseChildren&&this.foldAll(t.start.row+1,t.end.row,t.collapseChildren-1),t.subFolds=[];},this.expandFolds=function(e){e.forEach(function(e){this.expandFold(e);},this);},this.unfold=function(e,t){var i,n;if(null==e?(i=new h(0,0,this.getLength(),0),t=!0):i="number"==typeof e?new h(e,0,e,this.getLine(e).length):"row"in e?h.fromPoints(e,e):e,n=this.getFoldsInRangeList(i),t)this.removeFolds(n);else for(var r=n;r.length;){this.expandFolds(r),r=this.getFoldsInRangeList(i);}if(n.length)return n;},this.isRowFolded=function(e,t){return!!this.getFoldLine(e,t);},this.getRowFoldEnd=function(e,t){var i=this.getFoldLine(e,t);return i?i.end.row:e;},this.getRowFoldStart=function(e,t){var i=this.getFoldLine(e,t);return i?i.start.row:e;},this.getFoldDisplayLine=function(e,t,i,r,o){null==r&&(r=e.start.row),null==o&&(o=0),null==t&&(t=e.end.row),null==i&&(i=this.getLine(t).length);var s=this.doc,a="";return e.walk(function(e,t,i,n){if(!(t<r)){if(t==r){if(i<o)return;n=Math.max(o,n);}a+=null!=e?e:s.getLine(t).substring(n,i);}},t,i),a;},this.getDisplayLine=function(e,t,i,n){var r=this.getFoldLine(e);if(r)return this.getFoldDisplayLine(r,e,t,i,n);var o=this.doc.getLine(e);return o.substring(n||0,t||o.length);},this.$cloneFoldData=function(){var i=[];return i=this.$foldData.map(function(e){var t=e.folds.map(function(e){return e.clone();});return new m(i,t);});},this.toggleFold=function(e){var t,i=this.selection.getRange();if(i.isEmpty()){var n,r=i.start;if(n=this.getFoldAt(r.row,r.column))return void this.expandFold(n);(t=this.findMatchingBracket(r))?1==i.comparePoint(t)?i.end=t:(i.start=t,i.start.column++,i.end.column--):(t=this.findMatchingBracket({row:r.row,column:r.column+1}))?(1==i.comparePoint(t)?i.end=t:i.start=t,i.start.column++):i=this.getCommentFoldRange(r.row,r.column)||i;}else{var o=this.getFoldsInRange(i);if(e&&o.length)return void this.expandFolds(o);1==o.length&&(n=o[0]);}if((n=n||this.getFoldAt(i.start.row,i.start.column))&&n.range.toString()==i.toString())this.expandFold(n);else{var s="...";if(!i.isMultiLine()){if((s=this.getTextRange(i)).length<4)return;s=s.trim().substring(0,2)+"..";}this.addFold(s,i);}},this.getCommentFoldRange=function(e,t,i){var n=new d(this,e,t),r=n.getCurrentToken(),o=r.type;if(r&&/^comment|string/.test(o)){"comment"==(o=o.match(/comment|string/)[0])&&(o+="|doc-start");var s=new RegExp(o),a=new h();if(1!=i){for(;(r=n.stepBackward())&&s.test(r.type);){}n.stepForward();}if(a.start.row=n.getCurrentTokenRow(),a.start.column=n.getCurrentTokenColumn()+2,n=new d(this,e,t),-1!=i){var l=-1;do{if(r=n.stepForward(),-1==l){var c=this.getState(n.$row);s.test(c)||(l=n.$row);}else if(n.$row>l)break;}while(r&&s.test(r.type));r=n.stepBackward();}else r=n.getCurrentToken();return a.end.row=n.getCurrentTokenRow(),a.end.column=n.getCurrentTokenColumn()+r.value.length-2,a;}},this.foldAll=function(e,t,i){null==i&&(i=1e5);var n=this.foldWidgets;if(n){t=t||this.getLength();for(var r=e=e||0;r<t;r++){if(null==n[r]&&(n[r]=this.getFoldWidget(r)),"start"==n[r]){var o=this.getFoldWidgetRange(r);if(o&&o.isMultiLine()&&o.end.row<=t&&o.start.row>=e){r=o.end.row;try{var s=this.addFold("...",o);s&&(s.collapseChildren=i);}catch(e){}}}}}},this.$foldStyles={manual:1,markbegin:1,markbeginend:1},this.$foldStyle="markbegin",this.setFoldStyle=function(e){if(!this.$foldStyles[e])throw new Error("invalid fold style: "+e+"["+Object.keys(this.$foldStyles).join(", ")+"]");var t;this.$foldStyle!=e&&("manual"==(this.$foldStyle=e)&&this.unfold(),t=this.$foldMode,this.$setFolding(null),this.$setFolding(t));},this.$setFolding=function(e){this.$foldMode!=e&&(this.$foldMode=e,this.off("change",this.$updateFoldWidgets),this.off("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets),this._signal("changeAnnotation"),e&&"manual"!=this.$foldStyle?(this.foldWidgets=[],this.getFoldWidget=e.getFoldWidget.bind(e,this,this.$foldStyle),this.getFoldWidgetRange=e.getFoldWidgetRange.bind(e,this,this.$foldStyle),this.$updateFoldWidgets=this.updateFoldWidgets.bind(this),this.$tokenizerUpdateFoldWidgets=this.tokenizerUpdateFoldWidgets.bind(this),this.on("change",this.$updateFoldWidgets),this.on("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets)):this.foldWidgets=null);},this.getParentFoldRangeData=function(e,t){var i=this.foldWidgets;if(!i||t&&i[e])return{};for(var n=e-1;0<=n;){var r=i[n];if(null==r&&(r=i[n]=this.getFoldWidget(n)),"start"==r){var o=this.getFoldWidgetRange(n),s=s||o;if(o&&o.end.row>=e)break;}n--;}return{range:-1!==n&&o,firstRange:s};},this.onFoldWidgetClick=function(e,t){var i,n={children:(t=t.domEvent).shiftKey,all:t.ctrlKey||t.metaKey,siblings:t.altKey};this.$toggleFoldWidget(e,n)||(i=t.target||t.srcElement)&&/ace_fold-widget/.test(i.className)&&(i.className+=" ace_invalid");},this.$toggleFoldWidget=function(e,t){if(this.getFoldWidget){var i=this.getFoldWidget(e),n=this.getLine(e),r="end"===i?-1:1,o=this.getFoldAt(e,-1==r?0:n.length,r);if(o)return t.children||t.all?this.removeFold(o):this.expandFold(o),o;var s,a,l,c=this.getFoldWidgetRange(e,!0);return c&&!c.isMultiLine()&&(o=this.getFoldAt(c.start.row,c.start.column,1))&&c.isEqual(o.range)?(this.removeFold(o),o):(t.siblings?((s=this.getParentFoldRangeData(e)).range&&(a=s.range.start.row+1,l=s.range.end.row),this.foldAll(a,l,t.all?1e4:0)):t.children?(l=c?c.end.row:this.getLength(),this.foldAll(e+1,l,t.all?1e4:0)):c&&(t.all&&(c.collapseChildren=1e4),this.addFold("...",c)),c);}},this.toggleFoldWidget=function(e){var t,i,n=this.selection.getCursor().row,n=this.getRowFoldStart(n),r=this.$toggleFoldWidget(n,{});r||(r=(t=this.getParentFoldRangeData(n,!0)).range||t.firstRange)&&(n=r.start.row,(i=this.getFoldAt(n,this.getLine(n).length,1))?this.removeFold(i):this.addFold("...",r));},this.updateFoldWidgets=function(e){var t,i=e.start.row,n=e.end.row-i;0==n?this.foldWidgets[i]=null:"remove"==e.action?this.foldWidgets.splice(i,1+n,null):((t=Array(1+n)).unshift(i,1),this.foldWidgets.splice.apply(this.foldWidgets,t));},this.tokenizerUpdateFoldWidgets=function(e){var t=e.data;t.first!=t.last&&this.foldWidgets.length>t.first&&this.foldWidgets.splice(t.first,this.foldWidgets.length);};};}),ace.define("ace/edit_session/bracket_match",["require","exports","module","ace/token_iterator","ace/range"],function(e,t,i){"use strict";var d=e("../token_iterator").TokenIterator,a=e("../range").Range;t.BracketMatch=function(){this.findMatchingBracket=function(e,t){if(0==e.column)return null;var i=t||this.getLine(e.row).charAt(e.column-1);if(""==i)return null;var n=i.match(/([\(\[\{])|([\)\]\}])/);return n?n[1]?this.$findClosingBracket(n[1],e):this.$findOpeningBracket(n[2],e):null;},this.getBracketRange=function(e){var t,i,n=this.getLine(e.row),r=!0,o=n.charAt(e.column-1),s=o&&o.match(/([\(\[\{])|([\)\]\}])/);if(s||(o=n.charAt(e.column),e={row:e.row,column:e.column+1},s=o&&o.match(/([\(\[\{])|([\)\]\}])/),r=!1),!s)return null;if(s[1]){if(!(i=this.$findClosingBracket(s[1],e)))return null;t=a.fromPoints(e,i),r||(t.end.column++,t.start.column--),t.cursor=t.end;}else{if(!(i=this.$findOpeningBracket(s[2],e)))return null;t=a.fromPoints(i,e),r||(t.start.column++,t.end.column--),t.cursor=t.start;}return t;},this.getMatchingBracketRanges=function(e){var t=this.getLine(e.row),i=t.charAt(e.column-1),n=i&&i.match(/([\(\[\{])|([\)\]\}])/);if(n||(i=t.charAt(e.column),e={row:e.row,column:e.column+1},n=i&&i.match(/([\(\[\{])|([\)\]\}])/)),!n)return null;var r=new a(e.row,e.column-1,e.row,e.column),o=n[1]?this.$findClosingBracket(n[1],e):this.$findOpeningBracket(n[2],e);return o?[r,new a(o.row,o.column,o.row,o.column+1)]:[r];},this.$brackets={")":"(","(":")","]":"[","[":"]","{":"}","}":"{","<":">",">":"<"},this.$findOpeningBracket=function(e,t,i){var n=this.$brackets[e],r=1,o=new d(this,t.row,t.column),s=o.getCurrentToken();if(s=s||o.stepForward()){i=i||new RegExp("(\\.?"+s.type.replace(".","\\.").replace("rparen",".paren").replace(/\b(?:end)\b/,"(?:start|begin|end)")+")+");for(var a=t.column-o.getCurrentTokenColumn()-2,l=s.value;;){for(;0<=a;){var c=l.charAt(a);if(c==n){if(0==--r)return{row:o.getCurrentTokenRow(),column:a+o.getCurrentTokenColumn()};}else c==e&&(r+=1);--a;}for(;(s=o.stepBackward())&&!i.test(s.type);){}if(null==s)break;a=(l=s.value).length-1;}return null;}},this.$findClosingBracket=function(e,t,i){var n=this.$brackets[e],r=1,o=new d(this,t.row,t.column),s=o.getCurrentToken();if(s=s||o.stepForward()){i=i||new RegExp("(\\.?"+s.type.replace(".","\\.").replace("lparen",".paren").replace(/\b(?:start|begin)\b/,"(?:start|begin|end)")+")+");for(var a=t.column-o.getCurrentTokenColumn();;){for(var l=s.value,c=l.length;a<c;){var h=l.charAt(a);if(h==n){if(0==--r)return{row:o.getCurrentTokenRow(),column:a+o.getCurrentTokenColumn()};}else h==e&&(r+=1);a+=1;}for(;(s=o.stepForward())&&!i.test(s.type);){}if(null==s)break;a=0;}return null;}};};}),ace.define("ace/edit_session",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/bidihandler","ace/config","ace/lib/event_emitter","ace/selection","ace/mode/text","ace/range","ace/document","ace/background_tokenizer","ace/search_highlight","ace/edit_session/folding","ace/edit_session/bracket_match"],function(e,t,i){"use strict";var n=e("./lib/oop"),r=e("./lib/lang"),o=e("./bidihandler").BidiHandler,s=e("./config"),l=e("./lib/event_emitter").EventEmitter,a=e("./selection").Selection,c=e("./mode/text").Mode,h=e("./range").Range,d=e("./document").Document,u=e("./background_tokenizer").BackgroundTokenizer,g=e("./search_highlight").SearchHighlight,p=function p(e,t){this.$breakpoints=[],this.$decorations=[],this.$frontMarkers={},this.$backMarkers={},this.$markerId=1,this.$undoSelect=!0,this.$foldData=[],this.id="session"+ ++p.$uid,this.$foldData.toString=function(){return this.join("\n");},this.on("changeFold",this.onChangeFold.bind(this)),this.$onChange=this.onChange.bind(this),"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&e.getLine||(e=new d(e)),this.setDocument(e),this.selection=new a(this),this.$bidiHandler=new o(this),s.resetOptions(this),this.setMode(t),s._signal("session",this);};p.$uid=0,function(){n.implement(this,l),this.setDocument=function(e){this.doc&&this.doc.removeListener("change",this.$onChange),(this.doc=e).on("change",this.$onChange),this.bgTokenizer&&this.bgTokenizer.setDocument(this.getDocument()),this.resetCaches();},this.getDocument=function(){return this.doc;},this.$resetRowCache=function(e){if(!e)return this.$docRowCache=[],void(this.$screenRowCache=[]);var t=this.$docRowCache.length,i=this.$getRowCacheIndex(this.$docRowCache,e)+1;i<t&&(this.$docRowCache.splice(i,t),this.$screenRowCache.splice(i,t));},this.$getRowCacheIndex=function(e,t){for(var i=0,n=e.length-1;i<=n;){var r=i+n>>1,o=e[r];if(o<t)i=1+r;else{if(!(t<o))return r;n=r-1;}}return i-1;},this.resetCaches=function(){this.$modified=!0,this.$wrapData=[],this.$rowLengthCache=[],this.$resetRowCache(0),this.bgTokenizer&&this.bgTokenizer.start(0);},this.onChangeFold=function(e){var t=e.data;this.$resetRowCache(t.start.row);},this.onChange=function(e){this.$modified=!0,this.$bidiHandler.onChange(e),this.$resetRowCache(e.start.row);var t=this.$updateInternalDataOnChange(e);!this.$fromUndo&&this.$undoManager&&(t&&t.length&&(this.$undoManager.add({action:"removeFolds",folds:t},this.mergeUndoDeltas),this.mergeUndoDeltas=!0),this.$undoManager.add(e,this.mergeUndoDeltas),this.mergeUndoDeltas=!0,this.$informUndoManager.schedule()),this.bgTokenizer&&this.bgTokenizer.$updateOnChange(e),this._signal("change",e);},this.setValue=function(e){this.doc.setValue(e),this.selection.moveTo(0,0),this.$resetRowCache(0),this.setUndoManager(this.$undoManager),this.getUndoManager().reset();},this.getValue=this.toString=function(){return this.doc.getValue();},this.getSelection=function(){return this.selection;},this.getState=function(e){return this.bgTokenizer.getState(e);},this.getTokens=function(e){return this.bgTokenizer.getTokens(e);},this.getTokenAt=function(e,t){var i,n=this.bgTokenizer.getTokens(e),r=0;if(null==t)var o=n.length-1,r=this.getLine(e).length;else for(o=0;o<n.length&&!(t<=(r+=n[o].value.length));o++){}return(i=n[o])?(i.index=o,i.start=r-i.value.length,i):null;},this.setUndoManager=function(e){var t;this.$undoManager=e,this.$informUndoManager&&this.$informUndoManager.cancel(),e?(t=this,e.addSession(this),this.$syncInformUndoManager=function(){t.$informUndoManager.cancel(),t.mergeUndoDeltas=!1;},this.$informUndoManager=r.delayedCall(this.$syncInformUndoManager)):this.$syncInformUndoManager=function(){};},this.markUndoGroup=function(){this.$syncInformUndoManager&&this.$syncInformUndoManager();},this.$defaultUndoManager={undo:function undo(){},redo:function redo(){},hasUndo:function hasUndo(){},hasRedo:function hasRedo(){},reset:function reset(){},add:function add(){},addSelection:function addSelection(){},startNewGroup:function startNewGroup(){},addSession:function addSession(){}},this.getUndoManager=function(){return this.$undoManager||this.$defaultUndoManager;},this.getTabString=function(){return this.getUseSoftTabs()?r.stringRepeat(" ",this.getTabSize()):"\t";},this.setUseSoftTabs=function(e){this.setOption("useSoftTabs",e);},this.getUseSoftTabs=function(){return this.$useSoftTabs&&!this.$mode.$indentWithTabs;},this.setTabSize=function(e){this.setOption("tabSize",e);},this.getTabSize=function(){return this.$tabSize;},this.isTabStop=function(e){return this.$useSoftTabs&&e.column%this.$tabSize==0;},this.setNavigateWithinSoftTabs=function(e){this.setOption("navigateWithinSoftTabs",e);},this.getNavigateWithinSoftTabs=function(){return this.$navigateWithinSoftTabs;},this.$overwrite=!1,this.setOverwrite=function(e){this.setOption("overwrite",e);},this.getOverwrite=function(){return this.$overwrite;},this.toggleOverwrite=function(){this.setOverwrite(!this.$overwrite);},this.addGutterDecoration=function(e,t){this.$decorations[e]||(this.$decorations[e]=""),this.$decorations[e]+=" "+t,this._signal("changeBreakpoint",{});},this.removeGutterDecoration=function(e,t){this.$decorations[e]=(this.$decorations[e]||"").replace(" "+t,""),this._signal("changeBreakpoint",{});},this.getBreakpoints=function(){return this.$breakpoints;},this.setBreakpoints=function(e){this.$breakpoints=[];for(var t=0;t<e.length;t++){this.$breakpoints[e[t]]="ace_breakpoint";}this._signal("changeBreakpoint",{});},this.clearBreakpoints=function(){this.$breakpoints=[],this._signal("changeBreakpoint",{});},this.setBreakpoint=function(e,t){void 0===t&&(t="ace_breakpoint"),t?this.$breakpoints[e]=t:delete this.$breakpoints[e],this._signal("changeBreakpoint",{});},this.clearBreakpoint=function(e){delete this.$breakpoints[e],this._signal("changeBreakpoint",{});},this.addMarker=function(e,t,i,n){var r=this.$markerId++,o={range:e,type:i||"line",renderer:"function"==typeof i?i:null,clazz:t,inFront:!!n,id:r};return n?(this.$frontMarkers[r]=o,this._signal("changeFrontMarker")):(this.$backMarkers[r]=o,this._signal("changeBackMarker")),r;},this.addDynamicMarker=function(e,t){if(e.update){var i=this.$markerId++;return e.id=i,e.inFront=!!t,t?(this.$frontMarkers[i]=e,this._signal("changeFrontMarker")):(this.$backMarkers[i]=e,this._signal("changeBackMarker")),e;}},this.removeMarker=function(e){var t=this.$frontMarkers[e]||this.$backMarkers[e];t&&(delete(t.inFront?this.$frontMarkers:this.$backMarkers)[e],this._signal(t.inFront?"changeFrontMarker":"changeBackMarker"));},this.getMarkers=function(e){return e?this.$frontMarkers:this.$backMarkers;},this.highlight=function(e){var t;this.$searchHighlight||(t=new g(null,"ace_selected-word","text"),this.$searchHighlight=this.addDynamicMarker(t)),this.$searchHighlight.setRegexp(e);},this.highlightLines=function(e,t,i,n){"number"!=typeof t&&(i=t,t=e),i=i||"ace_step";var r=new h(e,0,t,1/0);return r.id=this.addMarker(r,i,"fullLine",n),r;},this.setAnnotations=function(e){this.$annotations=e,this._signal("changeAnnotation",{});},this.getAnnotations=function(){return this.$annotations||[];},this.clearAnnotations=function(){this.setAnnotations([]);},this.$detectNewLine=function(e){var t=e.match(/^.*?(\r?\n)/m);this.$autoNewLine=t?t[1]:"\n";},this.getWordRange=function(e,t){var i,n=this.getLine(e),r=!1;0<t&&(r=!!n.charAt(t-1).match(this.tokenRe)),i=(r=r||!!n.charAt(t).match(this.tokenRe))?this.tokenRe:/^\s+$/.test(n.slice(t-1,t+1))?/\s/:this.nonTokenRe;var o=t;if(0<o){for(;0<=--o&&n.charAt(o).match(i);){}o++;}for(var s=t;s<n.length&&n.charAt(s).match(i);){s++;}return new h(e,o,e,s);},this.getAWordRange=function(e,t){for(var i=this.getWordRange(e,t),n=this.getLine(i.end.row);n.charAt(i.end.column).match(/[ \t]/);){i.end.column+=1;}return i;},this.setNewLineMode=function(e){this.doc.setNewLineMode(e);},this.getNewLineMode=function(){return this.doc.getNewLineMode();},this.setUseWorker=function(e){this.setOption("useWorker",e);},this.getUseWorker=function(){return this.$useWorker;},this.onReloadTokenizer=function(e){var t=e.data;this.bgTokenizer.start(t.first),this._signal("tokenizerUpdate",e);},this.$modes=s.$modes,this.$mode=null,this.$modeId=null,this.setMode=function(e,t){if(e&&"object"==(typeof e==="undefined"?"undefined":_typeof(e))){if(e.getTokenizer)return this.$onChangeMode(e);var i=e,n=i.path;}else n=e||"ace/mode/text";if(this.$modes["ace/mode/text"]||(this.$modes["ace/mode/text"]=new c()),this.$modes[n]&&!i)return this.$onChangeMode(this.$modes[n]),void(t&&t());this.$modeId=n,s.loadModule(["mode",n],function(e){if(this.$modeId!==n)return t&&t();this.$modes[n]&&!i?this.$onChangeMode(this.$modes[n]):e&&e.Mode&&(e=new e.Mode(i),i||((this.$modes[n]=e).$id=n),this.$onChangeMode(e)),t&&t();}.bind(this)),this.$mode||this.$onChangeMode(this.$modes["ace/mode/text"],!0);},this.$onChangeMode=function(e,t){var i,n,r,o;t||(this.$modeId=e.$id),this.$mode!==e&&(i=this.$mode,this.$mode=e,this.$stopWorker(),this.$useWorker&&this.$startWorker(),void 0!==(n=e.getTokenizer()).on&&(r=this.onReloadTokenizer.bind(this),n.on("update",r)),this.bgTokenizer?this.bgTokenizer.setTokenizer(n):(this.bgTokenizer=new u(n),(o=this).bgTokenizer.on("update",function(e){o._signal("tokenizerUpdate",e);})),this.bgTokenizer.setDocument(this.getDocument()),this.tokenRe=e.tokenRe,this.nonTokenRe=e.nonTokenRe,t||(e.attachToSession&&e.attachToSession(this),this.$options.wrapMethod.set.call(this,this.$wrapMethod),this.$setFolding(e.foldingRules),this.bgTokenizer.start(0),this._emit("changeMode",{oldMode:i,mode:e})));},this.$stopWorker=function(){this.$worker&&(this.$worker.terminate(),this.$worker=null);},this.$startWorker=function(){try{this.$worker=this.$mode.createWorker(this);}catch(e){s.warn("Could not load worker",e),this.$worker=null;}},this.getMode=function(){return this.$mode;},this.$scrollTop=0,this.setScrollTop=function(e){this.$scrollTop===e||isNaN(e)||(this.$scrollTop=e,this._signal("changeScrollTop",e));},this.getScrollTop=function(){return this.$scrollTop;},this.$scrollLeft=0,this.setScrollLeft=function(e){this.$scrollLeft===e||isNaN(e)||(this.$scrollLeft=e,this._signal("changeScrollLeft",e));},this.getScrollLeft=function(){return this.$scrollLeft;},this.getScreenWidth=function(){return this.$computeWidth(),this.lineWidgets?Math.max(this.getLineWidgetMaxWidth(),this.screenWidth):this.screenWidth;},this.getLineWidgetMaxWidth=function(){if(null!=this.lineWidgetsWidth)return this.lineWidgetsWidth;var t=0;return this.lineWidgets.forEach(function(e){e&&e.screenWidth>t&&(t=e.screenWidth);}),this.lineWidgetWidth=t;},this.$computeWidth=function(e){if(this.$modified||e){if(this.$modified=!1,this.$useWrapMode)return this.screenWidth=this.$wrapLimit;for(var t=this.doc.getAllLines(),i=this.$rowLengthCache,n=0,r=0,o=this.$foldData[r],s=o?o.start.row:1/0,a=t.length,l=0;l<a;l++){if(s<l){if(a<=(l=o.end.row+1))break;s=(o=this.$foldData[r++])?o.start.row:1/0;}null==i[l]&&(i[l]=this.$getStringScreenWidth(t[l])[0]),i[l]>n&&(n=i[l]);}this.screenWidth=n;}},this.getLine=function(e){return this.doc.getLine(e);},this.getLines=function(e,t){return this.doc.getLines(e,t);},this.getLength=function(){return this.doc.getLength();},this.getTextRange=function(e){return this.doc.getTextRange(e||this.selection.getRange());},this.insert=function(e,t){return this.doc.insert(e,t);},this.remove=function(e){return this.doc.remove(e);},this.removeFullLines=function(e,t){return this.doc.removeFullLines(e,t);},this.undoChanges=function(e,t){if(e.length){this.$fromUndo=!0;for(var i=e.length-1;-1!=i;i--){var n=e[i];"insert"==n.action||"remove"==n.action?this.doc.revertDelta(n):n.folds&&this.addFolds(n.folds);}!t&&this.$undoSelect&&(e.selectionBefore?this.selection.fromJSON(e.selectionBefore):this.selection.setRange(this.$getUndoSelection(e,!0))),this.$fromUndo=!1;}},this.redoChanges=function(e,t){if(e.length){this.$fromUndo=!0;for(var i=0;i<e.length;i++){var n=e[i];"insert"!=n.action&&"remove"!=n.action||this.doc.$safeApplyDelta(n);}!t&&this.$undoSelect&&(e.selectionAfter?this.selection.fromJSON(e.selectionAfter):this.selection.setRange(this.$getUndoSelection(e,!1))),this.$fromUndo=!1;}},this.setUndoSelect=function(e){this.$undoSelect=e;},this.$getUndoSelection=function(e,t){function i(e){return t?"insert"!==e.action:"insert"===e.action;}for(var n,r,o=0;o<e.length;o++){var s=e[o];s.start&&(n?i(s)?(r=s.start,-1==n.compare(r.row,r.column)&&n.setStart(r),r=s.end,1==n.compare(r.row,r.column)&&n.setEnd(r)):(r=s.start,-1==n.compare(r.row,r.column)&&(n=h.fromPoints(s.start,s.start))):n=i(s)?h.fromPoints(s.start,s.end):h.fromPoints(s.start,s.start));}return n;},this.replace=function(e,t){return this.doc.replace(e,t);},this.moveText=function(e,t,i){var n,r,o,s,a=this.getTextRange(e),l=this.getFoldsInRange(e),c=h.fromPoints(t,t);return i||(this.remove(e),o=e.start.row-e.end.row,(s=o?-e.end.column:e.start.column-e.end.column)&&(c.start.row==e.end.row&&c.start.column>e.end.column&&(c.start.column+=s),c.end.row==e.end.row&&c.end.column>e.end.column&&(c.end.column+=s)),o&&c.start.row>=e.end.row&&(c.start.row+=o,c.end.row+=o)),c.end=this.insert(c.start,a),l.length&&(n=e.start,r=c.start,o=r.row-n.row,s=r.column-n.column,this.addFolds(l.map(function(e){return(e=e.clone()).start.row==n.row&&(e.start.column+=s),e.end.row==n.row&&(e.end.column+=s),e.start.row+=o,e.end.row+=o,e;}))),c;},this.indentRows=function(e,t,i){i=i.replace(/\t/g,this.getTabString());for(var n=e;n<=t;n++){this.doc.insertInLine({row:n,column:0},i);}},this.outdentRows=function(e){for(var t=e.collapseRows(),i=new h(0,0,0,0),n=this.getTabSize(),r=t.start.row;r<=t.end.row;++r){var o=this.getLine(r);i.start.row=r,i.end.row=r;for(var s=0;s<n&&" "==o.charAt(s);++s){}s<n&&"\t"==o.charAt(s)?(i.start.column=s,i.end.column=s+1):(i.start.column=0,i.end.column=s),this.remove(i);}},this.$moveLines=function(e,t,i){if(e=this.getRowFoldStart(e),t=this.getRowFoldEnd(t),i<0){if((r=this.getRowFoldStart(e+i))<0)return 0;var n=r-e;}else if(0<i){var r;if((r=this.getRowFoldEnd(t+i))>this.doc.getLength()-1)return 0;n=r-t;}else{e=this.$clipRowToDocument(e);n=(t=this.$clipRowToDocument(t))-e+1;}var o=new h(e,0,t,Number.MAX_VALUE),s=this.getFoldsInRange(o).map(function(e){return(e=e.clone()).start.row+=n,e.end.row+=n,e;}),a=0==i?this.doc.getLines(e,t):this.doc.removeFullLines(e,t);return this.doc.insertFullLines(e+n,a),s.length&&this.addFolds(s),n;},this.moveLinesUp=function(e,t){return this.$moveLines(e,t,-1);},this.moveLinesDown=function(e,t){return this.$moveLines(e,t,1);},this.duplicateLines=function(e,t){return this.$moveLines(e,t,0);},this.$clipRowToDocument=function(e){return Math.max(0,Math.min(e,this.doc.getLength()-1));},this.$clipColumnToRow=function(e,t){return t<0?0:Math.min(this.doc.getLine(e).length,t);},this.$clipPositionToDocument=function(e,t){var i;return t=Math.max(0,t),t=e<0?e=0:(i=this.doc.getLength())<=e?(e=i-1,this.doc.getLine(i-1).length):Math.min(this.doc.getLine(e).length,t),{row:e,column:t};},this.$clipRangeToDocument=function(e){e.start.row<0?(e.start.row=0,e.start.column=0):e.start.column=this.$clipColumnToRow(e.start.row,e.start.column);var t=this.doc.getLength()-1;return e.end.row>t?(e.end.row=t,e.end.column=this.doc.getLine(t).length):e.end.column=this.$clipColumnToRow(e.end.row,e.end.column),e;},this.$wrapLimit=80,this.$useWrapMode=!1,this.$wrapLimitRange={min:null,max:null},this.setUseWrapMode=function(e){var t;e!=this.$useWrapMode&&(this.$useWrapMode=e,this.$modified=!0,this.$resetRowCache(0),e&&(t=this.getLength(),this.$wrapData=Array(t),this.$updateWrapData(0,t-1)),this._signal("changeWrapMode"));},this.getUseWrapMode=function(){return this.$useWrapMode;},this.setWrapLimitRange=function(e,t){this.$wrapLimitRange.min===e&&this.$wrapLimitRange.max===t||(this.$wrapLimitRange={min:e,max:t},this.$modified=!0,this.$bidiHandler.markAsDirty(),this.$useWrapMode&&this._signal("changeWrapMode"));},this.adjustWrapLimit=function(e,t){var i=this.$wrapLimitRange;i.max<0&&(i={min:t,max:t});var n=this.$constrainWrapLimit(e,i.min,i.max);return n!=this.$wrapLimit&&1<n&&(this.$wrapLimit=n,this.$modified=!0,this.$useWrapMode&&(this.$updateWrapData(0,this.getLength()-1),this.$resetRowCache(0),this._signal("changeWrapLimit")),!0);},this.$constrainWrapLimit=function(e,t,i){return t&&(e=Math.max(t,e)),i&&(e=Math.min(i,e)),e;},this.getWrapLimit=function(){return this.$wrapLimit;},this.setWrapLimit=function(e){this.setWrapLimitRange(e,e);},this.getWrapLimitRange=function(){return{min:this.$wrapLimitRange.min,max:this.$wrapLimitRange.max};},this.$updateInternalDataOnChange=function(e){var t=this.$useWrapMode,i=e.action,n=e.start,r=e.end,o=n.row,s=r.row,a=s-o,l=null;if(this.$updating=!0,0!=a){if("remove"===i){this[t?"$wrapData":"$rowLengthCache"].splice(o,a);var c=this.$foldData,l=this.getFoldsInRange(e);this.removeFolds(l);var h,d=0;for((m=this.getFoldLine(r.row))&&(m.addRemoveChars(r.row,r.column,n.column-r.column),m.shiftRow(-a),(h=this.getFoldLine(o))&&h!==m&&(h.merge(m),m=h),d=c.indexOf(m)+1);d<c.length;d++){(m=c[d]).start.row>=r.row&&m.shiftRow(-a);}s=o;}else{var u=Array(a);u.unshift(o,0);var g=t?this.$wrapData:this.$rowLengthCache;g.splice.apply(g,u);var p,c=this.$foldData,d=0;for((m=this.getFoldLine(o))&&(0==(p=m.range.compareInside(n.row,n.column))?(m=m.split(n.row,n.column))&&(m.shiftRow(a),m.addRemoveChars(s,0,r.column-n.column)):-1==p&&(m.addRemoveChars(o,0,r.column-n.column),m.shiftRow(a)),d=c.indexOf(m)+1);d<c.length;d++){(m=c[d]).start.row>=o&&m.shiftRow(a);}}}else{var m,a=Math.abs(e.start.column-e.end.column);"remove"===i&&(l=this.getFoldsInRange(e),this.removeFolds(l),a=-a),(m=this.getFoldLine(o))&&m.addRemoveChars(o,n.column,a);}return t&&this.$wrapData.length!=this.doc.getLength()&&console.error("doc.getLength() and $wrapData.length have to be the same!"),this.$updating=!1,t?this.$updateWrapData(o,s):this.$updateRowLengthCache(o,s),l;},this.$updateRowLengthCache=function(e,t,i){this.$rowLengthCache[e]=null,this.$rowLengthCache[t]=null;},this.$updateWrapData=function(e,t){var s,i,a=this.doc.getAllLines(),n=this.getTabSize(),r=this.$wrapData,o=this.$wrapLimit,l=e;for(t=Math.min(t,a.length-1);l<=t;){(i=this.getFoldLine(l,i))?(s=[],i.walk(function(e,t,i,n){var r;if(null!=e){(r=this.$getDisplayTokens(e,s.length))[0]=p;for(var o=1;o<r.length;o++){r[o]=m;}}else r=this.$getDisplayTokens(a[t].substring(n,i),s.length);s=s.concat(r);}.bind(this),i.end.row,a[i.end.row].length+1),r[i.start.row]=this.$computeWrapSplits(s,o,n),l=i.end.row+1):(s=this.$getDisplayTokens(a[l]),r[l]=this.$computeWrapSplits(s,o,n),l++);}};var p=3,m=4;function a(e){return!(e<4352)&&(4352<=e&&e<=4447||4515<=e&&e<=4519||4602<=e&&e<=4607||9001<=e&&e<=9002||11904<=e&&e<=11929||11931<=e&&e<=12019||12032<=e&&e<=12245||12272<=e&&e<=12283||12288<=e&&e<=12350||12353<=e&&e<=12438||12441<=e&&e<=12543||12549<=e&&e<=12589||12593<=e&&e<=12686||12688<=e&&e<=12730||12736<=e&&e<=12771||12784<=e&&e<=12830||12832<=e&&e<=12871||12880<=e&&e<=13054||13056<=e&&e<=19903||19968<=e&&e<=42124||42128<=e&&e<=42182||43360<=e&&e<=43388||44032<=e&&e<=55203||55216<=e&&e<=55238||55243<=e&&e<=55291||63744<=e&&e<=64255||65040<=e&&e<=65049||65072<=e&&e<=65106||65108<=e&&e<=65126||65128<=e&&e<=65131||65281<=e&&e<=65376||65504<=e&&e<=65510);}this.$computeWrapSplits=function(r,e,o){if(0==r.length)return[];var s=[],t=r.length,a=0,l=0,c=this.$wrapAsCode,h=this.$indentedSoftWrap,d=e<=Math.max(2*o,8)||!1===h?0:Math.floor(e/2);function i(e){for(var t=e-a,i=a;i<e;i++){var n=r[i];12!==n&&2!==n||--t;}s.length||(u=function(){var e=0;if(0===d)return e;if(h)for(var t=0;t<r.length;t++){var i=r[t];if(10==i)e+=1;else{if(11!=i){if(12==i)continue;break;}e+=o;}}return c&&!1!==h&&(e+=o),Math.min(e,d);}(),s.indent=u),l+=t,s.push(l),a=e;}for(var u=0;e-u<t-a;){var n=a+e-u;if(10<=r[n-1]&&10<=r[n])i(n);else if(r[n]!=p&&r[n]!=m){for(var g=Math.max(n-(e-(e>>2)),a-1);g<n&&r[n]<p;){n--;}if(c){for(;g<n&&r[n]<p;){n--;}for(;g<n&&9==r[n];){n--;}}else for(;g<n&&r[n]<10;){n--;}g<n?i(++n):(2==r[n=a+e]&&n--,i(n-u));}else{for(;n!=a-1&&r[n]!=p;n--){}if(a<n){i(n);continue;}for(n=a+e;n<r.length&&r[n]==m;n++){}if(n==r.length)break;i(n);}}return s;},this.$getDisplayTokens=function(e,t){var i,n=[];t=t||0;for(var r=0;r<e.length;r++){var o=e.charCodeAt(r);if(9==o){i=this.getScreenTabSize(n.length+t),n.push(11);for(var s=1;s<i;s++){n.push(12);}}else 32==o?n.push(10):39<o&&o<48||57<o&&o<64?n.push(9):4352<=o&&a(o)?n.push(1,2):n.push(1);}return n;},this.$getStringScreenWidth=function(e,t,i){if(0==t)return[0,0];var n,r;for(null==t&&(t=1/0),i=i||0,r=0;r<e.length&&(9==(n=e.charCodeAt(r))?i+=this.getScreenTabSize(i):4352<=n&&a(n)?i+=2:i+=1,!(t<i));r++){}return[i,r];},this.lineWidgets=null,this.getRowLength=function(e){var t=1;return this.lineWidgets&&(t+=this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0),this.$useWrapMode&&this.$wrapData[e]?this.$wrapData[e].length+t:t;},this.getRowLineCount=function(e){return this.$useWrapMode&&this.$wrapData[e]?this.$wrapData[e].length+1:1;},this.getRowWrapIndent=function(e){if(this.$useWrapMode){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE),i=this.$wrapData[t.row];return i.length&&i[0]<t.column?i.indent:0;}return 0;},this.getScreenLastRowColumn=function(e){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE);return this.documentToScreenColumn(t.row,t.column);},this.getDocumentLastRowColumn=function(e,t){var i=this.documentToScreenRow(e,t);return this.getScreenLastRowColumn(i);},this.getDocumentLastRowColumnPosition=function(e,t){var i=this.documentToScreenRow(e,t);return this.screenToDocumentPosition(i,Number.MAX_VALUE/10);},this.getRowSplitData=function(e){return this.$useWrapMode?this.$wrapData[e]:void 0;},this.getScreenTabSize=function(e){return this.$tabSize-(e%this.$tabSize|0);},this.screenToDocumentRow=function(e,t){return this.screenToDocumentPosition(e,t).row;},this.screenToDocumentColumn=function(e,t){return this.screenToDocumentPosition(e,t).column;},this.screenToDocumentPosition=function(e,t,i){if(e<0)return{row:0,column:0};var n,r,o,s=0,a=0,l=0,c=0,h=this.$screenRowCache,d=this.$getRowCacheIndex(h,e),u=h.length;o=u&&0<=d?(l=h[d],s=this.$docRowCache[d],e>h[u-1]):!u;for(var g=this.getLength()-1,p=this.getNextFoldLine(s),m=p?p.start.row:1/0;l<=e&&!(e<l+(c=this.getRowLength(s))||g<=s);){l+=c,m<++s&&(s=p.end.row+1,m=(p=this.getNextFoldLine(s,p))?p.start.row:1/0),o&&(this.$docRowCache.push(s),this.$screenRowCache.push(l));}if(p&&p.start.row<=s)n=this.getFoldDisplayLine(p),s=p.start.row;else{if(l+c<=e||g<s)return{row:g,column:this.getLine(g).length};n=this.getLine(s),p=null;}var f,C=0,I=Math.floor(e-l);return!this.$useWrapMode||(f=this.$wrapData[s])&&(r=f[I],0<I&&f.length&&(C=f.indent,a=f[I-1]||f[f.length-1],n=n.substring(a))),void 0!==i&&this.$bidiHandler.isBidiRow(l+I,s,I)&&(t=this.$bidiHandler.offsetToCol(i)),a+=this.$getStringScreenWidth(n,t-C)[1],this.$useWrapMode&&r<=a&&(a=r-1),p?p.idxToPosition(a):{row:s,column:a};},this.documentToScreenPosition=function(e,t){var i=void 0===t?this.$clipPositionToDocument(e.row,e.column):this.$clipPositionToDocument(e,t);e=i.row,t=i.column;var n,r=0,o=null;(n=this.getFoldAt(e,t,1))&&(e=n.start.row,t=n.start.column);var s,a,l=0,c=this.$docRowCache,h=this.$getRowCacheIndex(c,e),d=c.length;a=d&&0<=h?(l=c[h],r=this.$screenRowCache[h],e>c[d-1]):!d;for(var u=this.getNextFoldLine(l),g=u?u.start.row:1/0;l<e;){if(g<=l){if(e<(s=u.end.row+1))break;g=(u=this.getNextFoldLine(s,u))?u.start.row:1/0;}else s=l+1;r+=this.getRowLength(l),l=s,a&&(this.$docRowCache.push(l),this.$screenRowCache.push(r));}var p="",o=u&&g<=l?(p=this.getFoldDisplayLine(u,e,t),u.start.row):(p=this.getLine(e).substring(0,t),e),m=0;if(this.$useWrapMode){var f=this.$wrapData[o];if(f){for(var C=0;p.length>=f[C];){r++,C++;}p=p.substring(f[C-1]||0,p.length),m=0<C?f.indent:0;}}return this.lineWidgets&&this.lineWidgets[l]&&this.lineWidgets[l].rowsAbove&&(r+=this.lineWidgets[l].rowsAbove),{row:r,column:m+this.$getStringScreenWidth(p)[0]};},this.documentToScreenColumn=function(e,t){return this.documentToScreenPosition(e,t).column;},this.documentToScreenRow=function(e,t){return this.documentToScreenPosition(e,t).row;},this.getScreenLength=function(){var e=0,t=null;if(this.$useWrapMode)for(var i=this.$wrapData.length,n=0,r=0,o=(t=this.$foldData[r++])?t.start.row:1/0;n<i;){var s=this.$wrapData[n];e+=s?s.length+1:1,o<++n&&(n=t.end.row+1,o=(t=this.$foldData[r++])?t.start.row:1/0);}else{e=this.getLength();for(var a=this.$foldData,r=0;r<a.length;r++){e-=(t=a[r]).end.row-t.start.row;}}return this.lineWidgets&&(e+=this.$getWidgetScreenLength()),e;},this.$setFontMetrics=function(o){this.$enableVarChar&&(this.$getStringScreenWidth=function(e,t,i){if(0===t)return[0,0];var n,r;for(t=t||1/0,i=i||0,r=0;r<e.length&&!(t<(i+="\t"===(n=e.charAt(r))?this.getScreenTabSize(i):o.getCharacterWidth(n)));r++){}return[i,r];});},this.destroy=function(){this.bgTokenizer&&(this.bgTokenizer.setDocument(null),this.bgTokenizer=null),this.$stopWorker(),this.removeAllListeners(),this.selection.detach();},this.isFullWidth=a;}.call(p.prototype),e("./edit_session/folding").Folding.call(p.prototype),e("./edit_session/bracket_match").BracketMatch.call(p.prototype),s.defineOptions(p.prototype,"session",{wrap:{set:function set(e){var t;e&&"off"!=e?"free"==e?e=!0:"printMargin"==e?e=-1:"string"==typeof e&&(e=parseInt(e,10)||!1):e=!1,this.$wrap!=e&&((this.$wrap=e)?(t="number"==typeof e?e:null,this.setWrapLimitRange(t,t),this.setUseWrapMode(!0)):this.setUseWrapMode(!1));},get:function get(){return this.getUseWrapMode()?-1==this.$wrap?"printMargin":this.getWrapLimitRange().min?this.$wrap:"free":"off";},handlesSet:!0},wrapMethod:{set:function set(e){(e="auto"==e?"text"!=this.$mode.type:"text"!=e)!=this.$wrapAsCode&&(this.$wrapAsCode=e,this.$useWrapMode&&(this.$useWrapMode=!1,this.setUseWrapMode(!0)));},initialValue:"auto"},indentedSoftWrap:{set:function set(){this.$useWrapMode&&(this.$useWrapMode=!1,this.setUseWrapMode(!0));},initialValue:!0},firstLineNumber:{set:function set(){this._signal("changeBreakpoint");},initialValue:1},useWorker:{set:function set(e){this.$useWorker=e,this.$stopWorker(),e&&this.$startWorker();},initialValue:!0},useSoftTabs:{initialValue:!0},tabSize:{set:function set(e){0<(e=parseInt(e))&&this.$tabSize!==e&&(this.$modified=!0,this.$rowLengthCache=[],this.$tabSize=e,this._signal("changeTabSize"));},initialValue:4,handlesSet:!0},navigateWithinSoftTabs:{initialValue:!1},foldStyle:{set:function set(e){this.setFoldStyle(e);},handlesSet:!0},overwrite:{set:function set(e){this._signal("changeOverwrite");},initialValue:!1},newLineMode:{set:function set(e){this.doc.setNewLineMode(e);},get:function get(){return this.doc.getNewLineMode();},handlesSet:!0},mode:{set:function set(e){this.setMode(e);},get:function get(){return this.$modeId;},handlesSet:!0}}),t.EditSession=p;}),ace.define("ace/search",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"],function(e,t,i){"use strict";function n(){this.$options={};}var v=e("./lib/lang"),r=e("./lib/oop"),b=e("./range").Range;(function(){this.set=function(e){return r.mixin(this.$options,e),this;},this.getOptions=function(){return v.copyObject(this.$options);},this.setOptions=function(e){this.$options=e;},this.find=function(e){var r=this.$options,t=this.$matchIterator(e,r);if(!t)return!1;var o=null;return t.forEach(function(e,t,i,n){return o=new b(e,t,i,n),!(t==n&&r.start&&r.start.start&&0!=r.skipCurrent&&o.isEqual(r.start))||(o=null,!1);}),o;},this.findAll=function(e){var t=this.$options;if(!t.needle)return[];this.$assembleRegExp(t);var i=t.range,n=i?e.getLines(i.start.row,i.end.row):e.doc.getAllLines(),r=[],o=t.re;if(t.$isMultiLine){var s,a=o.length,l=n.length-a;e:for(var c=o.offset||0;c<=l;c++){for(var h=0;h<a;h++){if(-1==n[c+h].search(o[h]))continue e;}var d=n[c],u=n[c+a-1],g=d.length-d.match(o[0])[0].length,p=u.match(o[a-1])[0].length;s&&s.end.row===c&&s.end.column>g||(r.push(s=new b(c,g,c+a-1,p)),2<a&&(c=c+a-2));}}else for(var m=0;m<n.length;m++){for(var f=v.getMatchOffsets(n[m],o),h=0;h<f.length;h++){var C=f[h];r.push(new b(m,C.offset,m,C.offset+C.length));}}if(i){for(var I=i.start.column,A=i.start.column,m=0,h=r.length-1;m<h&&r[m].start.column<I&&r[m].start.row==i.start.row;){m++;}for(;m<h&&r[h].end.column>A&&r[h].end.row==i.end.row;){h--;}for(r=r.slice(m,h+1),m=0,h=r.length;m<h;m++){r[m].start.row+=i.start.row,r[m].end.row+=i.start.row;}}return r;},this.replace=function(e,t){var i=this.$options,n=this.$assembleRegExp(i);if(i.$isMultiLine)return t;if(n){var r=n.exec(e);if(!r||r[0].length!=e.length)return null;if(t=e.replace(n,t),i.preserveCase){t=t.split("");for(var o=Math.min(e.length,e.length);o--;){var s=e[o];s&&s.toLowerCase()!=s?t[o]=t[o].toUpperCase():t[o]=t[o].toLowerCase();}t=t.join("");}return t;}},this.$assembleRegExp=function(e,t){if(e.needle instanceof RegExp)return e.re=e.needle;var i,n,r=e.needle;if(!e.needle)return e.re=!1;function o(e){return /\w/.test(e)||n.regExp?"\\b":"";}e.regExp||(r=v.escapeRegExp(r)),e.wholeWord&&(n=e,r=o((i=r)[0])+i+o(i[i.length-1]));var s=e.caseSensitive?"gm":"gmi";if(e.$isMultiLine=!t&&/[\n\r]/.test(r),e.$isMultiLine)return e.re=this.$assembleMultilineRegExp(r,s);try{var a=new RegExp(r,s);}catch(e){a=!1;}return e.re=a;},this.$assembleMultilineRegExp=function(e,t){for(var i=e.replace(/\r\n|\r|\n/g,"$\n^").split("\n"),n=[],r=0;r<i.length;r++){try{n.push(new RegExp(i[r],t));}catch(e){return!1;}}return n;},this.$matchIterator=function(h,i){var d=this.$assembleRegExp(i);if(!d)return!1;var l=1==i.backwards,e=0!=i.skipCurrent,t=i.range,n=i.start;(n=n||(t?t[l?"end":"start"]:h.selection.getRange())).start&&(n=n[e!=l?"end":"start"]);var r,c,o,s=t?t.start.row:0,a=t?t.end.row:h.getLength()-1;return r=l?function(e){var t=n.row;if(!o(t,n.column,e)){for(t--;s<=t;t--){if(o(t,Number.MAX_VALUE,e))return;}if(0!=i.wrap)for(t=a,s=n.row;s<=t;t--){if(o(t,Number.MAX_VALUE,e))return;}}}:function(e){var t=n.row;if(!o(t,n.column,e)){for(t+=1;t<=a;t++){if(o(t,0,e))return;}if(0!=i.wrap)for(t=s,a=n.row;t<=a;t++){if(o(t,0,e))return;}}},o=i.$isMultiLine?(c=d.length,function(e,t,i){var n=l?e-c+1:e;if(!(n<0)){var r=h.getLine(n),o=r.search(d[0]);if(!(!l&&o<t||-1===o)){for(var s=1;s<c;s++){if(-1==(r=h.getLine(n+s)).search(d[s]))return;}var a=r.match(d[c-1])[0].length;if(!(l&&t<a))return!!i(n,o,n+c-1,a)||void 0;}}}):l?function(e,t,i){var n,r=h.getLine(e),o=[],s=0;for(d.lastIndex=0;n=d.exec(r);){var a=n[0].length,s=n.index;if(!a){if(s>=r.length)break;d.lastIndex=s+=1;}if(n.index+a>t)break;o.push(n.index,a);}for(var l=o.length-1;0<=l;l-=2){var c=o[l-1];if(i(e,c,e,c+(a=o[l])))return!0;}}:function(e,t,i){var n,r=h.getLine(e);for(d.lastIndex=t;n=d.exec(r);){var o,s=n[0].length;if(i(e,o=n.index,e,o+s))return!0;if(!s&&(d.lastIndex=o+=1,o>=r.length))return!1;}},{forEach:r};};}).call(n.prototype),t.Search=n;}),ace.define("ace/keyboard/hash_handler",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,i){"use strict";var a=e("../lib/keys"),n=e("../lib/useragent"),l=a.KEY_MODS;function r(e,t){this.platform=t||(n.isMac?"mac":"win"),this.commands={},this.commandKeyBinding={},this.addCommands(e),this.$singleCommand=!0;}function o(e,t){r.call(this,e,t),this.$singleCommand=!1;}o.prototype=r.prototype,function(){function s(e){return"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&e.bindKey&&e.bindKey.position||(e.isDefault?-100:0);}this.addCommand=function(e){this.commands[e.name]&&this.removeCommand(e),(this.commands[e.name]=e).bindKey&&this._buildKeyHash(e);},this.removeCommand=function(e,t){var i=e&&("string"==typeof e?e:e.name);e=this.commands[i],t||delete this.commands[i];var n=this.commandKeyBinding;for(var r in n){var o,s=n[r];s==e?delete n[r]:!Array.isArray(s)||-1!=(o=s.indexOf(e))&&(s.splice(o,1),1==s.length&&(n[r]=s[0]));}},this.bindKey=function(e,o,s){if("object"==(typeof e==="undefined"?"undefined":_typeof(e))&&e&&(null==s&&(s=e.position),e=e[this.platform]),e)return"function"==typeof o?this.addCommand({exec:o,bindKey:e,name:o.name||e}):void e.split("|").forEach(function(e){var t,n="";-1!=e.indexOf(" ")&&(e=(t=e.split(/\s+/)).pop(),t.forEach(function(e){var t=this.parseKeys(e),i=l[t.hashId]+t.key;n+=(n?" ":"")+i,this._addCommandToBinding(n,"chainKeys");},this),n+=" ");var i=this.parseKeys(e),r=l[i.hashId]+i.key;this._addCommandToBinding(n+r,o,s);},this);},this._addCommandToBinding=function(e,t,i){var n=this.commandKeyBinding;if(t){if(!n[e]||this.$singleCommand)n[e]=t;else{Array.isArray(n[e])?-1!=(o=n[e].indexOf(t))&&n[e].splice(o,1):n[e]=[n[e]],"number"!=typeof i&&(i=s(t));for(var r=n[e],o=0;o<r.length;o++){if(i<s(r[o]))break;}r.splice(o,0,t);}}else delete n[e];},this.addCommands=function(i){i&&Object.keys(i).forEach(function(e){var t=i[e];if(t){if("string"==typeof t)return this.bindKey(t,e);"function"==typeof t&&(t={exec:t}),"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&(t.name||(t.name=e),this.addCommand(t));}},this);},this.removeCommands=function(t){Object.keys(t).forEach(function(e){this.removeCommand(t[e]);},this);},this.bindKeys=function(t){Object.keys(t).forEach(function(e){this.bindKey(e,t[e]);},this);},this._buildKeyHash=function(e){this.bindKey(e.bindKey,e);},this.parseKeys=function(e){var t=e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(e){return e;}),i=t.pop(),n=a[i];if(a.FUNCTION_KEYS[n])i=a.FUNCTION_KEYS[n].toLowerCase();else{if(!t.length)return{key:i,hashId:-1};if(1==t.length&&"shift"==t[0])return{key:i.toUpperCase(),hashId:-1};}for(var r=0,o=t.length;o--;){var s=a.KEY_MODS[t[o]];if(null==s)return"undefined"!=typeof console&&console.error("invalid modifier "+t[o]+" in "+e),!1;r|=s;}return{key:i,hashId:r};},this.findKeyCommand=function(e,t){var i=l[e]+t;return this.commandKeyBinding[i];},this.handleKeyboard=function(e,t,i,n){if(!(n<0)){var r=l[t]+i,o=this.commandKeyBinding[r];return(e.$keyChain&&(e.$keyChain+=" "+r,o=this.commandKeyBinding[e.$keyChain]||o),!o||"chainKeys"!=o&&"chainKeys"!=o[o.length-1])?(e.$keyChain&&(t&&4!=t||1!=i.length?(-1==t||0<n)&&(e.$keyChain=""):e.$keyChain=e.$keyChain.slice(0,-r.length-1)),{command:o}):(e.$keyChain=e.$keyChain||r,{command:"null"});}},this.getStatusText=function(e,t){return t.$keyChain||"";};}.call(r.prototype),t.HashHandler=r,t.MultiHashHandler=o;}),ace.define("ace/commands/command_manager",["require","exports","module","ace/lib/oop","ace/keyboard/hash_handler","ace/lib/event_emitter"],function(e,t,i){"use strict";function n(e,t){o.call(this,t,e),this.byName=this.commands,this.setDefaultHandler("exec",function(e){return e.command.exec(e.editor,e.args||{});});}var r=e("../lib/oop"),o=e("../keyboard/hash_handler").MultiHashHandler,s=e("../lib/event_emitter").EventEmitter;r.inherits(n,o),function(){r.implement(this,s),this.exec=function(e,t,i){if(Array.isArray(e)){for(var n=e.length;n--;){if(this.exec(e[n],t,i))return!0;}return!1;}if("string"==typeof e&&(e=this.commands[e]),!e)return!1;if(t&&t.$readOnly&&!e.readOnly)return!1;if(0!=this.$checkCommandState&&e.isAvailable&&!e.isAvailable(t))return!1;var r={editor:t,command:e,args:i};return r.returnValue=this._emit("exec",r),this._signal("afterExec",r),!1!==r.returnValue;},this.toggleRecording=function(e){if(!this.$inReplay)return e&&e._emit("changeStatus"),this.recording?(this.macro.pop(),this.off("exec",this.$addCommandToMacro),this.macro.length||(this.macro=this.oldMacro),this.recording=!1):(this.$addCommandToMacro||(this.$addCommandToMacro=function(e){this.macro.push([e.command,e.args]);}.bind(this)),this.oldMacro=this.macro,this.macro=[],this.on("exec",this.$addCommandToMacro),this.recording=!0);},this.replay=function(t){if(!this.$inReplay&&this.macro){if(this.recording)return this.toggleRecording(t);try{this.$inReplay=!0,this.macro.forEach(function(e){"string"==typeof e?this.exec(e,t):this.exec(e[0],t,e[1]);},this);}finally{this.$inReplay=!1;}}},this.trimMacro=function(e){return e.map(function(e){return"string"!=typeof e[0]&&(e[0]=e[0].name),e[1]||(e=e[0]),e;});};}.call(n.prototype),t.CommandManager=n;}),ace.define("ace/commands/default_commands",["require","exports","module","ace/lib/lang","ace/config","ace/range"],function(e,t,i){"use strict";var c=e("../lib/lang"),n=e("../config"),h=e("../range").Range;function r(e,t){return{win:e,mac:t};}t.commands=[{name:"showSettingsMenu",bindKey:r("Ctrl-,","Command-,"),exec:function exec(t){n.loadModule("ace/ext/settings_menu",function(e){e.init(t),t.showSettingsMenu();});},readOnly:!0},{name:"goToNextError",bindKey:r("Alt-E","F4"),exec:function exec(t){n.loadModule("./ext/error_marker",function(e){e.showErrorMarker(t,1);});},scrollIntoView:"animate",readOnly:!0},{name:"goToPreviousError",bindKey:r("Alt-Shift-E","Shift-F4"),exec:function exec(t){n.loadModule("./ext/error_marker",function(e){e.showErrorMarker(t,-1);});},scrollIntoView:"animate",readOnly:!0},{name:"selectall",description:"Select all",bindKey:r("Ctrl-A","Command-A"),exec:function exec(e){e.selectAll();},readOnly:!0},{name:"centerselection",description:"Center selection",bindKey:r(null,"Ctrl-L"),exec:function exec(e){e.centerSelection();},readOnly:!0},{name:"gotoline",description:"Go to line...",bindKey:r("Ctrl-L","Command-L"),exec:function exec(e,t){"number"!=typeof t||isNaN(t)||e.gotoLine(t),e.prompt({$type:"gotoLine"});},readOnly:!0},{name:"fold",bindKey:r("Alt-L|Ctrl-F1","Command-Alt-L|Command-F1"),exec:function exec(e){e.session.toggleFold(!1);},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"unfold",bindKey:r("Alt-Shift-L|Ctrl-Shift-F1","Command-Alt-Shift-L|Command-Shift-F1"),exec:function exec(e){e.session.toggleFold(!0);},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleFoldWidget",bindKey:r("F2","F2"),exec:function exec(e){e.session.toggleFoldWidget();},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleParentFoldWidget",bindKey:r("Alt-F2","Alt-F2"),exec:function exec(e){e.session.toggleFoldWidget(!0);},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"foldall",description:"Fold all",bindKey:r(null,"Ctrl-Command-Option-0"),exec:function exec(e){e.session.foldAll();},scrollIntoView:"center",readOnly:!0},{name:"foldOther",description:"Fold other",bindKey:r("Alt-0","Command-Option-0"),exec:function exec(e){e.session.foldAll(),e.session.unfold(e.selection.getAllRanges());},scrollIntoView:"center",readOnly:!0},{name:"unfoldall",description:"Unfold all",bindKey:r("Alt-Shift-0","Command-Option-Shift-0"),exec:function exec(e){e.session.unfold();},scrollIntoView:"center",readOnly:!0},{name:"findnext",description:"Find next",bindKey:r("Ctrl-K","Command-G"),exec:function exec(e){e.findNext();},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"findprevious",description:"Find previous",bindKey:r("Ctrl-Shift-K","Command-Shift-G"),exec:function exec(e){e.findPrevious();},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"selectOrFindNext",description:"Select or find next",bindKey:r("Alt-K","Ctrl-G"),exec:function exec(e){e.selection.isEmpty()?e.selection.selectWord():e.findNext();},readOnly:!0},{name:"selectOrFindPrevious",description:"Select or find previous",bindKey:r("Alt-Shift-K","Ctrl-Shift-G"),exec:function exec(e){e.selection.isEmpty()?e.selection.selectWord():e.findPrevious();},readOnly:!0},{name:"find",description:"Find",bindKey:r("Ctrl-F","Command-F"),exec:function exec(t){n.loadModule("ace/ext/searchbox",function(e){e.Search(t);});},readOnly:!0},{name:"overwrite",description:"Overwrite",bindKey:"Insert",exec:function exec(e){e.toggleOverwrite();},readOnly:!0},{name:"selecttostart",description:"Select to start",bindKey:r("Ctrl-Shift-Home","Command-Shift-Home|Command-Shift-Up"),exec:function exec(e){e.getSelection().selectFileStart();},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotostart",description:"Go to start",bindKey:r("Ctrl-Home","Command-Home|Command-Up"),exec:function exec(e){e.navigateFileStart();},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectup",description:"Select up",bindKey:r("Shift-Up","Shift-Up|Ctrl-Shift-P"),exec:function exec(e){e.getSelection().selectUp();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golineup",description:"Go line up",bindKey:r("Up","Up|Ctrl-P"),exec:function exec(e,t){e.navigateUp(t.times);},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttoend",description:"Select to end",bindKey:r("Ctrl-Shift-End","Command-Shift-End|Command-Shift-Down"),exec:function exec(e){e.getSelection().selectFileEnd();},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotoend",description:"Go to end",bindKey:r("Ctrl-End","Command-End|Command-Down"),exec:function exec(e){e.navigateFileEnd();},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectdown",description:"Select down",bindKey:r("Shift-Down","Shift-Down|Ctrl-Shift-N"),exec:function exec(e){e.getSelection().selectDown();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golinedown",description:"Go line down",bindKey:r("Down","Down|Ctrl-N"),exec:function exec(e,t){e.navigateDown(t.times);},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordleft",description:"Select word left",bindKey:r("Ctrl-Shift-Left","Option-Shift-Left"),exec:function exec(e){e.getSelection().selectWordLeft();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordleft",description:"Go to word left",bindKey:r("Ctrl-Left","Option-Left"),exec:function exec(e){e.navigateWordLeft();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolinestart",description:"Select to line start",bindKey:r("Alt-Shift-Left","Command-Shift-Left|Ctrl-Shift-A"),exec:function exec(e){e.getSelection().selectLineStart();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolinestart",description:"Go to line start",bindKey:r("Alt-Left|Home","Command-Left|Home|Ctrl-A"),exec:function exec(e){e.navigateLineStart();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectleft",description:"Select left",bindKey:r("Shift-Left","Shift-Left|Ctrl-Shift-B"),exec:function exec(e){e.getSelection().selectLeft();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoleft",description:"Go to left",bindKey:r("Left","Left|Ctrl-B"),exec:function exec(e,t){e.navigateLeft(t.times);},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordright",description:"Select word right",bindKey:r("Ctrl-Shift-Right","Option-Shift-Right"),exec:function exec(e){e.getSelection().selectWordRight();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordright",description:"Go to word right",bindKey:r("Ctrl-Right","Option-Right"),exec:function exec(e){e.navigateWordRight();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolineend",description:"Select to line end",bindKey:r("Alt-Shift-Right","Command-Shift-Right|Shift-End|Ctrl-Shift-E"),exec:function exec(e){e.getSelection().selectLineEnd();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolineend",description:"Go to line end",bindKey:r("Alt-Right|End","Command-Right|End|Ctrl-E"),exec:function exec(e){e.navigateLineEnd();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectright",description:"Select right",bindKey:r("Shift-Right","Shift-Right"),exec:function exec(e){e.getSelection().selectRight();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoright",description:"Go to right",bindKey:r("Right","Right|Ctrl-F"),exec:function exec(e,t){e.navigateRight(t.times);},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectpagedown",description:"Select page down",bindKey:"Shift-PageDown",exec:function exec(e){e.selectPageDown();},readOnly:!0},{name:"pagedown",description:"Page down",bindKey:r(null,"Option-PageDown"),exec:function exec(e){e.scrollPageDown();},readOnly:!0},{name:"gotopagedown",description:"Go to page down",bindKey:r("PageDown","PageDown|Ctrl-V"),exec:function exec(e){e.gotoPageDown();},readOnly:!0},{name:"selectpageup",description:"Select page up",bindKey:"Shift-PageUp",exec:function exec(e){e.selectPageUp();},readOnly:!0},{name:"pageup",description:"Page up",bindKey:r(null,"Option-PageUp"),exec:function exec(e){e.scrollPageUp();},readOnly:!0},{name:"gotopageup",description:"Go to page up",bindKey:"PageUp",exec:function exec(e){e.gotoPageUp();},readOnly:!0},{name:"scrollup",description:"Scroll up",bindKey:r("Ctrl-Up",null),exec:function exec(e){e.renderer.scrollBy(0,-2*e.renderer.layerConfig.lineHeight);},readOnly:!0},{name:"scrolldown",description:"Scroll down",bindKey:r("Ctrl-Down",null),exec:function exec(e){e.renderer.scrollBy(0,2*e.renderer.layerConfig.lineHeight);},readOnly:!0},{name:"selectlinestart",description:"Select line start",bindKey:"Shift-Home",exec:function exec(e){e.getSelection().selectLineStart();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectlineend",description:"Select line end",bindKey:"Shift-End",exec:function exec(e){e.getSelection().selectLineEnd();},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"togglerecording",description:"Toggle recording",bindKey:r("Ctrl-Alt-E","Command-Option-E"),exec:function exec(e){e.commands.toggleRecording(e);},readOnly:!0},{name:"replaymacro",description:"Replay macro",bindKey:r("Ctrl-Shift-E","Command-Shift-E"),exec:function exec(e){e.commands.replay(e);},readOnly:!0},{name:"jumptomatching",description:"Jump to matching",bindKey:r("Ctrl-\\|Ctrl-P","Command-\\"),exec:function exec(e){e.jumpToMatching();},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"selecttomatching",description:"Select to matching",bindKey:r("Ctrl-Shift-\\|Ctrl-Shift-P","Command-Shift-\\"),exec:function exec(e){e.jumpToMatching(!0);},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"expandToMatching",description:"Expand to matching",bindKey:r("Ctrl-Shift-M","Ctrl-Shift-M"),exec:function exec(e){e.jumpToMatching(!0,!0);},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"passKeysToBrowser",description:"Pass keys to browser",bindKey:r(null,null),exec:function exec(){},passEvent:!0,readOnly:!0},{name:"copy",description:"Copy",exec:function exec(e){},readOnly:!0},{name:"cut",description:"Cut",exec:function exec(e){var t=e.$copyWithEmptySelection&&e.selection.isEmpty()?e.selection.getLineRange():e.selection.getRange();e._emit("cut",t),t.isEmpty()||e.session.remove(t),e.clearSelection();},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"paste",description:"Paste",exec:function exec(e,t){e.$handlePaste(t);},scrollIntoView:"cursor"},{name:"removeline",description:"Remove line",bindKey:r("Ctrl-D","Command-D"),exec:function exec(e){e.removeLines();},scrollIntoView:"cursor",multiSelectAction:"forEachLine"},{name:"duplicateSelection",description:"Duplicate selection",bindKey:r("Ctrl-Shift-D","Command-Shift-D"),exec:function exec(e){e.duplicateSelection();},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"sortlines",description:"Sort lines",bindKey:r("Ctrl-Alt-S","Command-Alt-S"),exec:function exec(e){e.sortLines();},scrollIntoView:"selection",multiSelectAction:"forEachLine"},{name:"togglecomment",description:"Toggle comment",bindKey:r("Ctrl-/","Command-/"),exec:function exec(e){e.toggleCommentLines();},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"toggleBlockComment",description:"Toggle block comment",bindKey:r("Ctrl-Shift-/","Command-Shift-/"),exec:function exec(e){e.toggleBlockComment();},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"modifyNumberUp",description:"Modify number up",bindKey:r("Ctrl-Shift-Up","Alt-Shift-Up"),exec:function exec(e){e.modifyNumber(1);},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"modifyNumberDown",description:"Modify number down",bindKey:r("Ctrl-Shift-Down","Alt-Shift-Down"),exec:function exec(e){e.modifyNumber(-1);},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"replace",description:"Replace",bindKey:r("Ctrl-H","Command-Option-F"),exec:function exec(t){n.loadModule("ace/ext/searchbox",function(e){e.Search(t,!0);});}},{name:"undo",description:"Undo",bindKey:r("Ctrl-Z","Command-Z"),exec:function exec(e){e.undo();}},{name:"redo",description:"Redo",bindKey:r("Ctrl-Shift-Z|Ctrl-Y","Command-Shift-Z|Command-Y"),exec:function exec(e){e.redo();}},{name:"copylinesup",description:"Copy lines up",bindKey:r("Alt-Shift-Up","Command-Option-Up"),exec:function exec(e){e.copyLinesUp();},scrollIntoView:"cursor"},{name:"movelinesup",description:"Move lines up",bindKey:r("Alt-Up","Option-Up"),exec:function exec(e){e.moveLinesUp();},scrollIntoView:"cursor"},{name:"copylinesdown",description:"Copy lines down",bindKey:r("Alt-Shift-Down","Command-Option-Down"),exec:function exec(e){e.copyLinesDown();},scrollIntoView:"cursor"},{name:"movelinesdown",description:"Move lines down",bindKey:r("Alt-Down","Option-Down"),exec:function exec(e){e.moveLinesDown();},scrollIntoView:"cursor"},{name:"del",description:"Delete",bindKey:r("Delete","Delete|Ctrl-D|Shift-Delete"),exec:function exec(e){e.remove("right");},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"backspace",description:"Backspace",bindKey:r("Shift-Backspace|Backspace","Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),exec:function exec(e){e.remove("left");},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"cut_or_delete",description:"Cut or delete",bindKey:r("Shift-Delete",null),exec:function exec(e){if(!e.selection.isEmpty())return!1;e.remove("left");},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolinestart",description:"Remove to line start",bindKey:r("Alt-Backspace","Command-Backspace"),exec:function exec(e){e.removeToLineStart();},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolineend",description:"Remove to line end",bindKey:r("Alt-Delete","Ctrl-K|Command-Delete"),exec:function exec(e){e.removeToLineEnd();},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolinestarthard",description:"Remove to line start hard",bindKey:r("Ctrl-Shift-Backspace",null),exec:function exec(e){var t=e.selection.getRange();t.start.column=0,e.session.remove(t);},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolineendhard",description:"Remove to line end hard",bindKey:r("Ctrl-Shift-Delete",null),exec:function exec(e){var t=e.selection.getRange();t.end.column=Number.MAX_VALUE,e.session.remove(t);},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordleft",description:"Remove word left",bindKey:r("Ctrl-Backspace","Alt-Backspace|Ctrl-Alt-Backspace"),exec:function exec(e){e.removeWordLeft();},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordright",description:"Remove word right",bindKey:r("Ctrl-Delete","Alt-Delete"),exec:function exec(e){e.removeWordRight();},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"outdent",description:"Outdent",bindKey:r("Shift-Tab","Shift-Tab"),exec:function exec(e){e.blockOutdent();},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"indent",description:"Indent",bindKey:r("Tab","Tab"),exec:function exec(e){e.indent();},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"blockoutdent",description:"Block outdent",bindKey:r("Ctrl-[","Ctrl-["),exec:function exec(e){e.blockOutdent();},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"blockindent",description:"Block indent",bindKey:r("Ctrl-]","Ctrl-]"),exec:function exec(e){e.blockIndent();},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"insertstring",description:"Insert string",exec:function exec(e,t){e.insert(t);},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"inserttext",description:"Insert text",exec:function exec(e,t){e.insert(c.stringRepeat(t.text||"",t.times||1));},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"splitline",description:"Split line",bindKey:r(null,"Ctrl-O"),exec:function exec(e){e.splitLine();},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"transposeletters",description:"Transpose letters",bindKey:r("Alt-Shift-X","Ctrl-T"),exec:function exec(e){e.transposeLetters();},multiSelectAction:function multiSelectAction(e){e.transposeSelections(1);},scrollIntoView:"cursor"},{name:"touppercase",description:"To uppercase",bindKey:r("Ctrl-U","Ctrl-U"),exec:function exec(e){e.toUpperCase();},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"tolowercase",description:"To lowercase",bindKey:r("Ctrl-Shift-U","Ctrl-Shift-U"),exec:function exec(e){e.toLowerCase();},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"autoindent",description:"Auto Indent",bindKey:r(null,null),exec:function exec(e){e.autoIndent();},multiSelectAction:"forEachLine",scrollIntoView:"animate"},{name:"expandtoline",description:"Expand to line",bindKey:r("Ctrl-Shift-L","Command-Shift-L"),exec:function exec(e){var t=e.selection.getRange();t.start.column=t.end.column=0,t.end.row++,e.selection.setRange(t,!1);},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"joinlines",description:"Join lines",bindKey:r(null,null),exec:function exec(e){for(var t=e.selection.isBackwards(),i=t?e.selection.getSelectionLead():e.selection.getSelectionAnchor(),n=t?e.selection.getSelectionAnchor():e.selection.getSelectionLead(),r=e.session.doc.getLine(i.row).length,o=e.session.doc.getTextRange(e.selection.getRange()).replace(/\n\s*/," ").length,s=e.session.doc.getLine(i.row),a=i.row+1;a<=n.row+1;a++){var l=c.stringTrimLeft(c.stringTrimRight(e.session.doc.getLine(a)));0!==l.length&&(l=" "+l),s+=l;}n.row+1<e.session.doc.getLength()-1&&(s+=e.session.doc.getNewLineCharacter()),e.clearSelection(),e.session.doc.replace(new h(i.row,0,n.row+2,0),s),0<o?(e.selection.moveCursorTo(i.row,i.column),e.selection.selectTo(i.row,i.column+o)):(r=e.session.doc.getLine(i.row).length>r?r+1:r,e.selection.moveCursorTo(i.row,r));},multiSelectAction:"forEach",readOnly:!0},{name:"invertSelection",description:"Invert selection",bindKey:r(null,null),exec:function exec(e){var t=e.session.doc.getLength()-1,i=e.session.doc.getLine(t).length,n=e.selection.rangeList.ranges,r=[];n.length<1&&(n=[e.selection.getRange()]);for(var o=0;o<n.length;o++){o==n.length-1&&(n[o].end.row===t&&n[o].end.column===i||r.push(new h(n[o].end.row,n[o].end.column,t,i))),0===o?0===n[o].start.row&&0===n[o].start.column||r.push(new h(0,0,n[o].start.row,n[o].start.column)):r.push(new h(n[o-1].end.row,n[o-1].end.column,n[o].start.row,n[o].start.column));}e.exitMultiSelectMode(),e.clearSelection();for(o=0;o<r.length;o++){e.selection.addRange(r[o],!1);}},readOnly:!0,scrollIntoView:"none"},{name:"addLineAfter",exec:function exec(e){e.selection.clearSelection(),e.navigateLineEnd(),e.insert("\n");},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"addLineBefore",exec:function exec(e){e.selection.clearSelection();var t=e.getCursorPosition();e.selection.moveTo(t.row-1,Number.MAX_VALUE),e.insert("\n"),0===t.row&&e.navigateUp();},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"openCommandPallete",description:"Open command pallete",bindKey:r("F1","F1"),exec:function exec(e){e.prompt({$type:"commands"});},readOnly:!0},{name:"modeSelect",description:"Change language mode...",bindKey:r(null,null),exec:function exec(e){e.prompt({$type:"modes"});},readOnly:!0}];}),ace.define("ace/editor",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/keyboard/textinput","ace/mouse/mouse_handler","ace/mouse/fold_handler","ace/keyboard/keybinding","ace/edit_session","ace/search","ace/range","ace/lib/event_emitter","ace/commands/command_manager","ace/commands/default_commands","ace/config","ace/token_iterator","ace/clipboard"],function(e,t,i){"use strict";e("./lib/fixoldbrowsers");var o=e("./lib/oop"),n=e("./lib/dom"),f=e("./lib/lang"),r=e("./lib/useragent"),s=e("./keyboard/textinput").TextInput,a=e("./mouse/mouse_handler").MouseHandler,l=e("./mouse/fold_handler").FoldHandler,c=e("./keyboard/keybinding").KeyBinding,h=e("./edit_session").EditSession,d=e("./search").Search,m=e("./range").Range,u=e("./lib/event_emitter").EventEmitter,g=e("./commands/command_manager").CommandManager,p=e("./commands/default_commands").commands,C=e("./config"),I=e("./token_iterator").TokenIterator,A=e("./clipboard"),v=function v(e,t,i){this.$toDestroy=[];var n=e.getContainerElement();this.container=n,this.renderer=e,this.id="editor"+ ++v.$uid,this.commands=new g(r.isMac?"mac":"win",p),"object"==(typeof document==="undefined"?"undefined":_typeof(document))&&(this.textInput=new s(e.getTextAreaContainer(),this),this.renderer.textarea=this.textInput.getElement(),this.$mouseHandler=new a(this),new l(this)),this.keyBinding=new c(this),this.$search=new d().set({wrap:!0}),this.$historyTracker=this.$historyTracker.bind(this),this.commands.on("exec",this.$historyTracker),this.$initOperationListeners(),this._$emitInputEvent=f.delayedCall(function(){this._signal("input",{}),this.session&&this.session.bgTokenizer&&this.session.bgTokenizer.scheduleStart();}.bind(this)),this.on("change",function(e,t){t._$emitInputEvent.schedule(31);}),this.setSession(t||i&&i.session||new h("")),C.resetOptions(this),i&&this.setOptions(i),C._signal("editor",this);};v.$uid=0,function(){o.implement(this,u),this.$initOperationListeners=function(){this.commands.on("exec",this.startOperation.bind(this),!0),this.commands.on("afterExec",this.endOperation.bind(this),!0),this.$opResetTimer=f.delayedCall(this.endOperation.bind(this,!0)),this.on("change",function(){this.curOp||(this.startOperation(),this.curOp.selectionBefore=this.$lastSel),this.curOp.docChanged=!0;}.bind(this),!0),this.on("changeSelection",function(){this.curOp||(this.startOperation(),this.curOp.selectionBefore=this.$lastSel),this.curOp.selectionChanged=!0;}.bind(this),!0);},this.curOp=null,this.prevOp={},this.startOperation=function(e){if(this.curOp){if(!e||this.curOp.command)return;this.prevOp=this.curOp;}e||(this.previousCommand=null,e={}),this.$opResetTimer.schedule(),this.curOp=this.session.curOp={command:e.command||{},args:e.args,scrollTop:this.renderer.scrollTop},this.curOp.selectionBefore=this.selection.toJSON();},this.endOperation=function(e){if(this.curOp&&this.session){if(e&&!1===e.returnValue||!this.session)return this.curOp=null;if(1==e&&this.curOp.command&&"mouse"==this.curOp.command.name)return;if(this._signal("beforeEndOperation"),!this.curOp)return;var t=this.curOp.command,i=t&&t.scrollIntoView;if(i){switch(i){case"center-animate":i="animate";case"center":this.renderer.scrollCursorIntoView(null,.5);break;case"animate":case"cursor":this.renderer.scrollCursorIntoView();break;case"selectionPart":var n=this.selection.getRange(),r=this.renderer.layerConfig;(n.start.row>=r.lastRow||n.end.row<=r.firstRow)&&this.renderer.scrollSelectionIntoView(this.selection.anchor,this.selection.lead);}"animate"==i&&this.renderer.animateScrolling(this.curOp.scrollTop);}var o=this.selection.toJSON();this.curOp.selectionAfter=o,this.$lastSel=this.selection.toJSON(),this.session.getUndoManager().addSelection(o),this.prevOp=this.curOp,this.curOp=null;}},this.$mergeableCommands=["backspace","del","insertstring"],this.$historyTracker=function(e){var t,i,n,r;this.$mergeUndoDeltas&&(t=this.prevOp,i=this.$mergeableCommands,n=t.command&&e.command.name==t.command.name,"insertstring"==e.command.name?(r=e.args,void 0===this.mergeNextCommand&&(this.mergeNextCommand=!0),n=n&&this.mergeNextCommand&&(!/\s/.test(r)||/\s/.test(t.args)),this.mergeNextCommand=!0):n=n&&-1!==i.indexOf(e.command.name),"always"!=this.$mergeUndoDeltas&&2e3<Date.now()-this.sequenceStartTime&&(n=!1),n?this.session.mergeUndoDeltas=!0:-1!==i.indexOf(e.command.name)&&(this.sequenceStartTime=Date.now()));},this.setKeyboardHandler=function(t,i){var n;t&&"string"==typeof t&&"ace"!=t?(this.$keybindingId=t,n=this,C.loadModule(["keybinding",t],function(e){n.$keybindingId==t&&n.keyBinding.setKeyboardHandler(e&&e.handler),i&&i();})):(this.$keybindingId=null,this.keyBinding.setKeyboardHandler(t),i&&i());},this.getKeyboardHandler=function(){return this.keyBinding.getKeyboardHandler();},this.setSession=function(e){var t,i;this.session!=e&&(this.curOp&&this.endOperation(),this.curOp={},(t=this.session)&&(this.session.off("change",this.$onDocumentChange),this.session.off("changeMode",this.$onChangeMode),this.session.off("tokenizerUpdate",this.$onTokenizerUpdate),this.session.off("changeTabSize",this.$onChangeTabSize),this.session.off("changeWrapLimit",this.$onChangeWrapLimit),this.session.off("changeWrapMode",this.$onChangeWrapMode),this.session.off("changeFold",this.$onChangeFold),this.session.off("changeFrontMarker",this.$onChangeFrontMarker),this.session.off("changeBackMarker",this.$onChangeBackMarker),this.session.off("changeBreakpoint",this.$onChangeBreakpoint),this.session.off("changeAnnotation",this.$onChangeAnnotation),this.session.off("changeOverwrite",this.$onCursorChange),this.session.off("changeScrollTop",this.$onScrollTopChange),this.session.off("changeScrollLeft",this.$onScrollLeftChange),(i=this.session.getSelection()).off("changeCursor",this.$onCursorChange),i.off("changeSelection",this.$onSelectionChange)),(this.session=e)?(this.$onDocumentChange=this.onDocumentChange.bind(this),e.on("change",this.$onDocumentChange),this.renderer.setSession(e),this.$onChangeMode=this.onChangeMode.bind(this),e.on("changeMode",this.$onChangeMode),this.$onTokenizerUpdate=this.onTokenizerUpdate.bind(this),e.on("tokenizerUpdate",this.$onTokenizerUpdate),this.$onChangeTabSize=this.renderer.onChangeTabSize.bind(this.renderer),e.on("changeTabSize",this.$onChangeTabSize),this.$onChangeWrapLimit=this.onChangeWrapLimit.bind(this),e.on("changeWrapLimit",this.$onChangeWrapLimit),this.$onChangeWrapMode=this.onChangeWrapMode.bind(this),e.on("changeWrapMode",this.$onChangeWrapMode),this.$onChangeFold=this.onChangeFold.bind(this),e.on("changeFold",this.$onChangeFold),this.$onChangeFrontMarker=this.onChangeFrontMarker.bind(this),this.session.on("changeFrontMarker",this.$onChangeFrontMarker),this.$onChangeBackMarker=this.onChangeBackMarker.bind(this),this.session.on("changeBackMarker",this.$onChangeBackMarker),this.$onChangeBreakpoint=this.onChangeBreakpoint.bind(this),this.session.on("changeBreakpoint",this.$onChangeBreakpoint),this.$onChangeAnnotation=this.onChangeAnnotation.bind(this),this.session.on("changeAnnotation",this.$onChangeAnnotation),this.$onCursorChange=this.onCursorChange.bind(this),this.session.on("changeOverwrite",this.$onCursorChange),this.$onScrollTopChange=this.onScrollTopChange.bind(this),this.session.on("changeScrollTop",this.$onScrollTopChange),this.$onScrollLeftChange=this.onScrollLeftChange.bind(this),this.session.on("changeScrollLeft",this.$onScrollLeftChange),this.selection=e.getSelection(),this.selection.on("changeCursor",this.$onCursorChange),this.$onSelectionChange=this.onSelectionChange.bind(this),this.selection.on("changeSelection",this.$onSelectionChange),this.onChangeMode(),this.onCursorChange(),this.onScrollTopChange(),this.onScrollLeftChange(),this.onSelectionChange(),this.onChangeFrontMarker(),this.onChangeBackMarker(),this.onChangeBreakpoint(),this.onChangeAnnotation(),this.session.getUseWrapMode()&&this.renderer.adjustWrapLimit(),this.renderer.updateFull()):(this.selection=null,this.renderer.setSession(e)),this._signal("changeSession",{session:e,oldSession:t}),this.curOp=null,t&&t._signal("changeEditor",{oldEditor:this}),e&&e._signal("changeEditor",{editor:this}),e&&e.bgTokenizer&&e.bgTokenizer.scheduleStart());},this.getSession=function(){return this.session;},this.setValue=function(e,t){return this.session.doc.setValue(e),t?1==t?this.navigateFileEnd():-1==t&&this.navigateFileStart():this.selectAll(),e;},this.getValue=function(){return this.session.getValue();},this.getSelection=function(){return this.selection;},this.resize=function(e){this.renderer.onResize(e);},this.setTheme=function(e,t){this.renderer.setTheme(e,t);},this.getTheme=function(){return this.renderer.getTheme();},this.setStyle=function(e){this.renderer.setStyle(e);},this.unsetStyle=function(e){this.renderer.unsetStyle(e);},this.getFontSize=function(){return this.getOption("fontSize")||n.computedStyle(this.container).fontSize;},this.setFontSize=function(e){this.setOption("fontSize",e);},this.$highlightBrackets=function(){var n;this.$highlightPending||((n=this).$highlightPending=!0,setTimeout(function(){n.$highlightPending=!1;var e,t,i=n.session;i&&i.bgTokenizer&&(i.$bracketHighlight&&(i.$bracketHighlight.markerIds.forEach(function(e){i.removeMarker(e);}),i.$bracketHighlight=null),!(e=i.getMatchingBracketRanges(n.getCursorPosition()))&&i.$mode.getMatching&&(e=i.$mode.getMatching(n.session)),e&&(t="ace_bracket",Array.isArray(e)?1==e.length&&(t="ace_error_bracket"):e=[e],2==e.length&&(0==m.comparePoints(e[0].end,e[1].start)?e=[m.fromPoints(e[0].start,e[1].end)]:0==m.comparePoints(e[0].start,e[1].end)&&(e=[m.fromPoints(e[1].start,e[0].end)])),i.$bracketHighlight={ranges:e,markerIds:e.map(function(e){return i.addMarker(e,t,"text");})}));},50));},this.$highlightTags=function(){var d;this.$highlightTagPending||((d=this).$highlightTagPending=!0,setTimeout(function(){d.$highlightTagPending=!1;var e=d.session;if(e&&e.bgTokenizer){var t=d.getCursorPosition(),i=new I(d.session,t.row,t.column),n=i.getCurrentToken();if(!n||!/\b(?:tag-open|tag-name)/.test(n.type))return e.removeMarker(e.$tagHighlight),void(e.$tagHighlight=null);if(-1==n.type.indexOf("tag-open")||(n=i.stepForward())){var r=n.value,o=0,s=i.stepBackward();if("<"==s.value)for(;s=n,(n=i.stepForward())&&n.value===r&&-1!==n.type.indexOf("tag-name")&&("<"===s.value?o++:"</"===s.value&&o--),n&&0<=o;){}else{for(;n=s,s=i.stepBackward(),n&&n.value===r&&-1!==n.type.indexOf("tag-name")&&("<"===s.value?o++:"</"===s.value&&o--),s&&o<=0;){}i.stepForward();}if(!n)return e.removeMarker(e.$tagHighlight),void(e.$tagHighlight=null);var a=i.getCurrentTokenRow(),l=i.getCurrentTokenColumn(),c=new m(a,l,a,l+n.value.length),h=e.$backMarkers[e.$tagHighlight];e.$tagHighlight&&null!=h&&0!==c.compareRange(h.range)&&(e.removeMarker(e.$tagHighlight),e.$tagHighlight=null),e.$tagHighlight||(e.$tagHighlight=e.addMarker(c,"ace_bracket","text"));}}},50));},this.focus=function(){var e=this;setTimeout(function(){e.isFocused()||e.textInput.focus();}),this.textInput.focus();},this.isFocused=function(){return this.textInput.isFocused();},this.blur=function(){this.textInput.blur();},this.onFocus=function(e){this.$isFocused||(this.$isFocused=!0,this.renderer.showCursor(),this.renderer.visualizeFocus(),this._emit("focus",e));},this.onBlur=function(e){this.$isFocused&&(this.$isFocused=!1,this.renderer.hideCursor(),this.renderer.visualizeBlur(),this._emit("blur",e));},this.$cursorChange=function(){this.renderer.updateCursor(),this.$highlightBrackets(),this.$highlightTags(),this.$updateHighlightActiveLine();},this.onDocumentChange=function(e){var t=this.session.$useWrapMode,i=e.start.row==e.end.row?e.end.row:1/0;this.renderer.updateLines(e.start.row,i,t),this._signal("change",e),this.$cursorChange();},this.onTokenizerUpdate=function(e){var t=e.data;this.renderer.updateLines(t.first,t.last);},this.onScrollTopChange=function(){this.renderer.scrollToY(this.session.getScrollTop());},this.onScrollLeftChange=function(){this.renderer.scrollToX(this.session.getScrollLeft());},this.onCursorChange=function(){this.$cursorChange(),this._signal("changeSelection");},this.$updateHighlightActiveLine=function(){var e,t,i=this.getSession();this.$highlightActiveLine&&("line"==this.$selectionStyle&&this.selection.isMultiLine()||(e=this.getCursorPosition()),this.renderer.theme&&this.renderer.theme.$selectionColorConflict&&!this.selection.isEmpty()&&(e=!1),!this.renderer.$maxLines||1!==this.session.getLength()||1<this.renderer.$minLines||(e=!1)),i.$highlightLineMarker&&!e?(i.removeMarker(i.$highlightLineMarker.id),i.$highlightLineMarker=null):!i.$highlightLineMarker&&e?((t=new m(e.row,e.column,e.row,1/0)).id=i.addMarker(t,"ace_active-line","screenLine"),i.$highlightLineMarker=t):e&&(i.$highlightLineMarker.start.row=e.row,i.$highlightLineMarker.end.row=e.row,i.$highlightLineMarker.start.column=e.column,i._signal("changeBackMarker"));},this.onSelectionChange=function(e){var t,i,n=this.session;n.$selectionMarker&&n.removeMarker(n.$selectionMarker),n.$selectionMarker=null,this.selection.isEmpty()?this.$updateHighlightActiveLine():(t=this.selection.getRange(),i=this.getSelectionStyle(),n.$selectionMarker=n.addMarker(t,"ace_selection",i));var r=this.$highlightSelectedWord&&this.$getSelectionHighLightRegexp();this.session.highlight(r),this._signal("changeSelection");},this.$getSelectionHighLightRegexp=function(){var e=this.session,t=this.getSelectionRange();if(!t.isEmpty()&&!t.isMultiLine()){var i=t.start.column,n=t.end.column,r=e.getLine(t.start.row),o=r.substring(i,n);if(!(5e3<o.length)&&/[\w\d]/.test(o)){var s=this.$search.$assembleRegExp({wholeWord:!0,caseSensitive:!0,needle:o}),a=r.substring(i-1,n+1);if(s.test(a))return s;}}},this.onChangeFrontMarker=function(){this.renderer.updateFrontMarkers();},this.onChangeBackMarker=function(){this.renderer.updateBackMarkers();},this.onChangeBreakpoint=function(){this.renderer.updateBreakpoints();},this.onChangeAnnotation=function(){this.renderer.setAnnotations(this.session.getAnnotations());},this.onChangeMode=function(e){this.renderer.updateText(),this._emit("changeMode",e);},this.onChangeWrapLimit=function(){this.renderer.updateFull();},this.onChangeWrapMode=function(){this.renderer.onResize(!0);},this.onChangeFold=function(){this.$updateHighlightActiveLine(),this.renderer.updateFull();},this.getSelectedText=function(){return this.session.getTextRange(this.getSelectionRange());},this.getCopyText=function(){var e=this.getSelectedText(),t=this.session.doc.getNewLineCharacter(),i=!1;if(!e&&this.$copyWithEmptySelection){i=!0;for(var n=this.selection.getAllRanges(),r=0;r<n.length;r++){var o=n[r];r&&n[r-1].start.row==o.start.row||(e+=this.session.getLine(o.start.row)+t);}}var s={text:e};return this._signal("copy",s),A.lineMode=i?s.text:"",s.text;},this.onCopy=function(){this.commands.exec("copy",this);},this.onCut=function(){this.commands.exec("cut",this);},this.onPaste=function(e,t){var i={text:e,event:t};this.commands.exec("paste",this,i);},this.$handlePaste=function(e){"string"==typeof e&&(e={text:e}),this._signal("paste",e);var t=e.text,i=t==A.lineMode,n=this.session;if(!this.inMultiSelectMode||this.inVirtualSelectionMode)i?n.insert({row:this.selection.lead.row,column:0},t):this.insert(t);else if(i)this.selection.rangeList.ranges.forEach(function(e){n.insert({row:e.start.row,column:0},t);});else{var r=t.split(/\r\n|\r|\n/),o=this.selection.rangeList.ranges,s=!(2!=r.length||r[0]&&r[1]);if(r.length!=o.length||s)return this.commands.exec("insertstring",this,t);for(var a=o.length;a--;){var l=o[a];l.isEmpty()||n.remove(l),n.insert(l.start,r[a]);}}},this.execCommand=function(e,t){return this.commands.exec(e,this,t);},this.insert=function(e,t){var i,n,r,o=this.session,s=o.getMode(),a=this.getCursorPosition();!this.getBehavioursEnabled()||t||(i=s.transformAction(o.getState(a.row),"insertion",this,o,e))&&(e!==i.text&&(this.inVirtualSelectionMode||(this.session.mergeUndoDeltas=!1,this.mergeNextCommand=!1)),e=i.text),"\t"==e&&(e=this.session.getTabString()),this.selection.isEmpty()?this.session.getOverwrite()&&-1==e.indexOf("\n")&&((n=new m.fromPoints(a,a)).end.column+=e.length,this.session.remove(n)):(n=this.getSelectionRange(),a=this.session.remove(n),this.clearSelection()),"\n"!=e&&"\r\n"!=e||(d=o.getLine(a.row),a.column>d.search(/\S|$/)&&(r=d.substr(a.column).search(/\S|$/),o.doc.removeInLine(a.row,a.column,a.column+r))),this.clearSelection();var l,c=a.column,h=o.getState(a.row),d=o.getLine(a.row),u=s.checkOutdent(h,d,e);o.insert(a,e),i&&i.selection&&(2==i.selection.length?this.selection.setSelectionRange(new m(a.row,c+i.selection[0],a.row,c+i.selection[1])):this.selection.setSelectionRange(new m(a.row+i.selection[0],i.selection[1],a.row+i.selection[2],i.selection[3]))),this.$enableAutoIndent&&(o.getDocument().isNewLine(e)&&(l=s.getNextLineIndent(h,d.slice(0,a.column),o.getTabString()),o.insert({row:a.row+1,column:0},l)),u&&s.autoOutdent(h,o,a.row));},this.autoIndent=function(){var e,t,i,n=this.session,r=n.getMode();i=this.selection.isEmpty()?(t=0,n.doc.getLength()-1):(t=(e=this.getSelectionRange()).start.row,e.end.row);for(var o,s,a,l="",c="",h="",d=n.getTabString(),u=t;u<=i;u++){0<u&&(l=n.getState(u-1),c=n.getLine(u-1),h=r.getNextLineIndent(l,c,d)),o=n.getLine(u),h!==(s=r.$getIndent(o))&&(0<s.length&&(a=new m(u,0,u,s.length),n.remove(a)),0<h.length&&n.insert({row:u,column:0},h)),r.autoOutdent(l,n,u);}},this.onTextInput=function(e,t){if(!t)return this.keyBinding.onTextInput(e);this.startOperation({command:{name:"insertstring"}});var i=this.applyComposition.bind(this,e,t);this.selection.rangeCount?this.forEachSelection(i):i(),this.endOperation();},this.applyComposition=function(e,t){var i;(t.extendLeft||t.extendRight)&&((i=this.selection.getRange()).start.column-=t.extendLeft,i.end.column+=t.extendRight,i.start.column<0&&(i.start.row--,i.start.column+=this.session.getLine(i.start.row).length+1),this.selection.setRange(i),e||i.isEmpty()||this.remove()),!e&&this.selection.isEmpty()||this.insert(e,!0),(t.restoreStart||t.restoreEnd)&&((i=this.selection.getRange()).start.column-=t.restoreStart,i.end.column-=t.restoreEnd,this.selection.setRange(i));},this.onCommandKey=function(e,t,i){return this.keyBinding.onCommandKey(e,t,i);},this.setOverwrite=function(e){this.session.setOverwrite(e);},this.getOverwrite=function(){return this.session.getOverwrite();},this.toggleOverwrite=function(){this.session.toggleOverwrite();},this.setScrollSpeed=function(e){this.setOption("scrollSpeed",e);},this.getScrollSpeed=function(){return this.getOption("scrollSpeed");},this.setDragDelay=function(e){this.setOption("dragDelay",e);},this.getDragDelay=function(){return this.getOption("dragDelay");},this.setSelectionStyle=function(e){this.setOption("selectionStyle",e);},this.getSelectionStyle=function(){return this.getOption("selectionStyle");},this.setHighlightActiveLine=function(e){this.setOption("highlightActiveLine",e);},this.getHighlightActiveLine=function(){return this.getOption("highlightActiveLine");},this.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e);},this.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine");},this.setHighlightSelectedWord=function(e){this.setOption("highlightSelectedWord",e);},this.getHighlightSelectedWord=function(){return this.$highlightSelectedWord;},this.setAnimatedScroll=function(e){this.renderer.setAnimatedScroll(e);},this.getAnimatedScroll=function(){return this.renderer.getAnimatedScroll();},this.setShowInvisibles=function(e){this.renderer.setShowInvisibles(e);},this.getShowInvisibles=function(){return this.renderer.getShowInvisibles();},this.setDisplayIndentGuides=function(e){this.renderer.setDisplayIndentGuides(e);},this.getDisplayIndentGuides=function(){return this.renderer.getDisplayIndentGuides();},this.setShowPrintMargin=function(e){this.renderer.setShowPrintMargin(e);},this.getShowPrintMargin=function(){return this.renderer.getShowPrintMargin();},this.setPrintMarginColumn=function(e){this.renderer.setPrintMarginColumn(e);},this.getPrintMarginColumn=function(){return this.renderer.getPrintMarginColumn();},this.setReadOnly=function(e){this.setOption("readOnly",e);},this.getReadOnly=function(){return this.getOption("readOnly");},this.setBehavioursEnabled=function(e){this.setOption("behavioursEnabled",e);},this.getBehavioursEnabled=function(){return this.getOption("behavioursEnabled");},this.setWrapBehavioursEnabled=function(e){this.setOption("wrapBehavioursEnabled",e);},this.getWrapBehavioursEnabled=function(){return this.getOption("wrapBehavioursEnabled");},this.setShowFoldWidgets=function(e){this.setOption("showFoldWidgets",e);},this.getShowFoldWidgets=function(){return this.getOption("showFoldWidgets");},this.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e);},this.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets");},this.remove=function(e){this.selection.isEmpty()&&("left"==e?this.selection.selectLeft():this.selection.selectRight());var t,i,n,r,o,s=this.getSelectionRange();this.getBehavioursEnabled()&&(i=(t=this.session).getState(s.start.row),n=t.getMode().transformAction(i,"deletion",this,t,s),0!==s.end.column||"\n"==(r=t.getTextRange(s))[r.length-1]&&(o=t.getLine(s.end.row),/^\s+$/.test(o)&&(s.end.column=o.length)),n&&(s=n)),this.session.remove(s),this.clearSelection();},this.removeWordRight=function(){this.selection.isEmpty()&&this.selection.selectWordRight(),this.session.remove(this.getSelectionRange()),this.clearSelection();},this.removeWordLeft=function(){this.selection.isEmpty()&&this.selection.selectWordLeft(),this.session.remove(this.getSelectionRange()),this.clearSelection();},this.removeToLineStart=function(){this.selection.isEmpty()&&this.selection.selectLineStart(),this.selection.isEmpty()&&this.selection.selectLeft(),this.session.remove(this.getSelectionRange()),this.clearSelection();},this.removeToLineEnd=function(){this.selection.isEmpty()&&this.selection.selectLineEnd();var e=this.getSelectionRange();e.start.column==e.end.column&&e.start.row==e.end.row&&(e.end.column=0,e.end.row++),this.session.remove(e),this.clearSelection();},this.splitLine=function(){this.selection.isEmpty()||(this.session.remove(this.getSelectionRange()),this.clearSelection());var e=this.getCursorPosition();this.insert("\n"),this.moveCursorToPosition(e);},this.transposeLetters=function(){var e,t,i,n,r;!this.selection.isEmpty()||0!==(t=(e=this.getCursorPosition()).column)&&(r=t<(i=this.session.getLine(e.row)).length?(n=i.charAt(t)+i.charAt(t-1),new m(e.row,t-1,e.row,t+1)):(n=i.charAt(t-1)+i.charAt(t-2),new m(e.row,t-2,e.row,t)),this.session.replace(r,n),this.session.selection.moveToPosition(r.end));},this.toLowerCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),i=this.session.getTextRange(t);this.session.replace(t,i.toLowerCase()),this.selection.setSelectionRange(e);},this.toUpperCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),i=this.session.getTextRange(t);this.session.replace(t,i.toUpperCase()),this.selection.setSelectionRange(e);},this.indent=function(){var e=this.session,t=this.getSelectionRange();if(!(t.start.row<t.end.row)){if(t.start.column<t.end.column){var i=e.getTextRange(t);if(!/^\s+$/.test(i)){c=this.$getSelectedRows();return void e.indentRows(c.first,c.last,"\t");}}var n=e.getLine(t.start.row),r=t.start,o=e.getTabSize(),s=e.documentToScreenColumn(r.row,r.column);if(this.session.getUseSoftTabs())var a=o-s%o,l=f.stringRepeat(" ",a);else{for(a=s%o;" "==n[t.start.column-1]&&a;){t.start.column--,a--;}this.selection.setSelectionRange(t),l="\t";}return this.insert(l);}var c=this.$getSelectedRows();e.indentRows(c.first,c.last,"\t");},this.blockIndent=function(){var e=this.$getSelectedRows();this.session.indentRows(e.first,e.last,"\t");},this.blockOutdent=function(){var e=this.session.getSelection();this.session.outdentRows(e.getRange());},this.sortLines=function(){for(var e=this.$getSelectedRows(),t=this.session,i=[],n=e.first;n<=e.last;n++){i.push(t.getLine(n));}i.sort(function(e,t){return e.toLowerCase()<t.toLowerCase()?-1:e.toLowerCase()>t.toLowerCase()?1:0;});for(var r=new m(0,0,0,0),n=e.first;n<=e.last;n++){var o=t.getLine(n);r.start.row=n,r.end.row=n,r.end.column=o.length,t.replace(r,i[n-e.first]);}},this.toggleCommentLines=function(){var e=this.session.getState(this.getCursorPosition().row),t=this.$getSelectedRows();this.session.getMode().toggleCommentLines(e,this.session,t.first,t.last);},this.toggleBlockComment=function(){var e=this.getCursorPosition(),t=this.session.getState(e.row),i=this.getSelectionRange();this.session.getMode().toggleBlockComment(t,this.session,i,e);},this.getNumberAt=function(e,t){var i=/[\-]?[0-9]+(?:\.[0-9]+)?/g;i.lastIndex=0;for(var n=this.session.getLine(e);i.lastIndex<t;){var r=i.exec(n);if(r.index<=t&&r.index+r[0].length>=t)return{value:r[0],start:r.index,end:r.index+r[0].length};}return null;},this.modifyNumber=function(e){var t,i,n,r,o,s,a=this.selection.getCursor().row,l=this.selection.getCursor().column,c=new m(a,l-1,a,l),h=this.session.getTextRange(c);!isNaN(parseFloat(h))&&isFinite(h)?(t=this.getNumberAt(a,l))&&(i=0<=t.value.indexOf(".")?t.start+t.value.indexOf(".")+1:t.end,n=t.start+t.value.length-i,r=parseFloat(t.value),r*=Math.pow(10,n),i!==t.end&&l<i?e*=Math.pow(10,t.end-l-1):e*=Math.pow(10,t.end-l),r+=e,o=(r/=Math.pow(10,n)).toFixed(n),s=new m(a,t.start,a,t.end),this.session.replace(s,o),this.moveCursorTo(a,Math.max(t.start+1,l+o.length-t.value.length))):this.toggleWord();},this.$toggleWordPairs=[["first","last"],["true","false"],["yes","no"],["width","height"],["top","bottom"],["right","left"],["on","off"],["x","y"],["get","set"],["max","min"],["horizontal","vertical"],["show","hide"],["add","remove"],["up","down"],["before","after"],["even","odd"],["in","out"],["inside","outside"],["next","previous"],["increase","decrease"],["attach","detach"],["&&","||"],["==","!="]],this.toggleWord=function(){var i=this.selection.getCursor().row,e=this.selection.getCursor().column;this.selection.selectWord();var n=this.getSelectedText(),r=this.selection.getWordRange().start.column,t=n.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g,"$1 ").split(/\s/),o=e-r-1;o<0&&(o=0);var s=0,a=0,l=this;n.match(/[A-Za-z0-9_]+/)&&t.forEach(function(e,t){a=s+e.length,s<=o&&o<=a&&(n=e,l.selection.clearSelection(),l.moveCursorTo(i,s+r),l.selection.selectTo(i,a+r)),s=a;});for(var c,h=this.$toggleWordPairs,d=0;d<h.length;d++){for(var u=h[d],g=0;g<=1;g++){var p=+!g,m=n.match(new RegExp("^\\s?_?("+f.escapeRegExp(u[g])+")\\s?$","i"));m&&n.match(new RegExp("([_]|^|\\s)("+f.escapeRegExp(m[1])+")($|\\s)","g"))&&(c=n.replace(new RegExp(f.escapeRegExp(u[g]),"i"),function(e){var t=u[p];return e.toUpperCase()==e?t=t.toUpperCase():e.charAt(0).toUpperCase()==e.charAt(0)&&(t=t.substr(0,0)+u[p].charAt(0).toUpperCase()+t.substr(1)),t;}),this.insert(c),c="");}}},this.removeLines=function(){var e=this.$getSelectedRows();this.session.removeFullLines(e.first,e.last),this.clearSelection();},this.duplicateSelection=function(){var e,t,i,n=this.selection,r=this.session,o=n.getRange(),s=n.isBackwards();o.isEmpty()?(e=o.start.row,r.duplicateLines(e,e)):(t=s?o.start:o.end,i=r.insert(t,r.getTextRange(o),!1),o.start=t,o.end=i,n.setSelectionRange(o,s));},this.moveLinesDown=function(){this.$moveLines(1,!1);},this.moveLinesUp=function(){this.$moveLines(-1,!1);},this.moveText=function(e,t,i){return this.session.moveText(e,t,i);},this.copyLinesUp=function(){this.$moveLines(-1,!0);},this.copyLinesDown=function(){this.$moveLines(1,!0);},this.$moveLines=function(e,t){var i=this.selection;if(!i.inMultiSelectMode||this.inVirtualSelectionMode){var n=i.toOrientedRange(),r=this.$getSelectedRows(n),o=this.session.$moveLines(r.first,r.last,t?0:e);t&&-1==e&&(o=0),n.moveBy(o,0),i.fromOrientedRange(n);}else{var s=i.rangeList.ranges;i.rangeList.detach(this.session),this.inVirtualSelectionMode=!0;for(var a=0,l=0,c=s.length,h=0;h<c;h++){var d=h;s[h].moveBy(a,0);for(var u=(r=this.$getSelectedRows(s[h])).first,g=r.last;++h<c;){l&&s[h].moveBy(l,0);var p=this.$getSelectedRows(s[h]);if(t&&p.first!=g)break;if(!t&&p.first>g+1)break;g=p.last;}for(h--,a=this.session.$moveLines(u,g,t?0:e),t&&-1==e&&(d=h+1);d<=h;){s[d].moveBy(a,0),d++;}t||(a=0),l+=a;}i.fromOrientedRange(i.ranges[0]),i.rangeList.attach(this.session),this.inVirtualSelectionMode=!1;}},this.$getSelectedRows=function(e){return e=(e||this.getSelectionRange()).collapseRows(),{first:this.session.getRowFoldStart(e.start.row),last:this.session.getRowFoldEnd(e.end.row)};},this.onCompositionStart=function(e){this.renderer.showComposition(e);},this.onCompositionUpdate=function(e){this.renderer.setCompositionText(e);},this.onCompositionEnd=function(){this.renderer.hideComposition();},this.getFirstVisibleRow=function(){return this.renderer.getFirstVisibleRow();},this.getLastVisibleRow=function(){return this.renderer.getLastVisibleRow();},this.isRowVisible=function(e){return e>=this.getFirstVisibleRow()&&e<=this.getLastVisibleRow();},this.isRowFullyVisible=function(e){return e>=this.renderer.getFirstFullyVisibleRow()&&e<=this.renderer.getLastFullyVisibleRow();},this.$getVisibleRowCount=function(){return this.renderer.getScrollBottomRow()-this.renderer.getScrollTopRow()+1;},this.$moveByPage=function(e,t){var i=this.renderer,n=this.renderer.layerConfig,r=e*Math.floor(n.height/n.lineHeight);!0===t?this.selection.$moveSelection(function(){this.moveCursorBy(r,0);}):!1===t&&(this.selection.moveCursorBy(r,0),this.selection.clearSelection());var o=i.scrollTop;i.scrollBy(0,r*n.lineHeight),null!=t&&i.scrollCursorIntoView(null,.5),i.animateScrolling(o);},this.selectPageDown=function(){this.$moveByPage(1,!0);},this.selectPageUp=function(){this.$moveByPage(-1,!0);},this.gotoPageDown=function(){this.$moveByPage(1,!1);},this.gotoPageUp=function(){this.$moveByPage(-1,!1);},this.scrollPageDown=function(){this.$moveByPage(1);},this.scrollPageUp=function(){this.$moveByPage(-1);},this.scrollToRow=function(e){this.renderer.scrollToRow(e);},this.scrollToLine=function(e,t,i,n){this.renderer.scrollToLine(e,t,i,n);},this.centerSelection=function(){var e=this.getSelectionRange(),t={row:Math.floor(e.start.row+(e.end.row-e.start.row)/2),column:Math.floor(e.start.column+(e.end.column-e.start.column)/2)};this.renderer.alignCursor(t,.5);},this.getCursorPosition=function(){return this.selection.getCursor();},this.getCursorPositionScreen=function(){return this.session.documentToScreenPosition(this.getCursorPosition());},this.getSelectionRange=function(){return this.selection.getRange();},this.selectAll=function(){this.selection.selectAll();},this.clearSelection=function(){this.selection.clearSelection();},this.moveCursorTo=function(e,t){this.selection.moveCursorTo(e,t);},this.moveCursorToPosition=function(e){this.selection.moveCursorToPosition(e);},this.jumpToMatching=function(e,t){var i=this.getCursorPosition(),n=new I(this.session,i.row,i.column),r=n.getCurrentToken(),o=r||n.stepForward();if(o){var s,a,l,c=!1,h={},d=i.column-o.start,u={")":"(","(":"(","]":"[","[":"[","{":"{","}":"{"};do{if(o.value.match(/[{}()\[\]]/g)){for(;d<o.value.length&&!c;d++){if(u[o.value[d]])switch(a=u[o.value[d]]+"."+o.type.replace("rparen","lparen"),isNaN(h[a])&&(h[a]=0),o.value[d]){case"(":case"[":case"{":h[a]++;break;case")":case"]":case"}":h[a]--,-1===h[a]&&(s="bracket",c=!0);}}}else-1!==o.type.indexOf("tag-name")&&(isNaN(h[o.value])&&(h[o.value]=0),"<"===r.value?h[o.value]++:"</"===r.value&&h[o.value]--,-1===h[o.value]&&(s="tag",c=!0));c||(r=o,o=n.stepForward(),d=0);}while(o&&!c);if(s){if("bracket"===s)(g=this.session.getBracketRange(i))||(l=(g=new m(n.getCurrentTokenRow(),n.getCurrentTokenColumn()+d-1,n.getCurrentTokenRow(),n.getCurrentTokenColumn()+d-1)).start,(t||l.row===i.row&&Math.abs(l.column-i.column)<2)&&(g=this.session.getBracketRange(l)));else if("tag"===s){if(!o||-1===o.type.indexOf("tag-name"))return;var g,p=o.value;if(0===(g=new m(n.getCurrentTokenRow(),n.getCurrentTokenColumn()-2,n.getCurrentTokenRow(),n.getCurrentTokenColumn()-2)).compare(i.row,i.column))for(c=!1;o=r,(r=n.stepBackward())&&(-1!==r.type.indexOf("tag-close")&&g.setEnd(n.getCurrentTokenRow(),n.getCurrentTokenColumn()+1),o.value===p&&-1!==o.type.indexOf("tag-name")&&("<"===r.value?h[p]++:"</"===r.value&&h[p]--,0===h[p]&&(c=!0))),r&&!c;){}o&&o.type.indexOf("tag-name")&&(l=g.start).row==i.row&&Math.abs(l.column-i.column)<2&&(l=g.end);}(l=g&&g.cursor||l)&&(e?g&&t?this.selection.setRange(g):g&&g.isEqual(this.getSelectionRange())?this.clearSelection():this.selection.selectTo(l.row,l.column):this.selection.moveTo(l.row,l.column));}}},this.gotoLine=function(e,t,i){this.selection.clearSelection(),this.session.unfold({row:e-1,column:t||0}),this.exitMultiSelectMode&&this.exitMultiSelectMode(),this.moveCursorTo(e-1,t||0),this.isRowFullyVisible(e-1)||this.scrollToLine(e-1,!0,i);},this.navigateTo=function(e,t){this.selection.moveTo(e,t);},this.navigateUp=function(e){if(this.selection.isMultiLine()&&!this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t);}this.selection.clearSelection(),this.selection.moveCursorBy(-e||-1,0);},this.navigateDown=function(e){if(this.selection.isMultiLine()&&this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t);}this.selection.clearSelection(),this.selection.moveCursorBy(e||1,0);},this.navigateLeft=function(e){if(this.selection.isEmpty())for(e=e||1;e--;){this.selection.moveCursorLeft();}else{var t=this.getSelectionRange().start;this.moveCursorToPosition(t);}this.clearSelection();},this.navigateRight=function(e){if(this.selection.isEmpty())for(e=e||1;e--;){this.selection.moveCursorRight();}else{var t=this.getSelectionRange().end;this.moveCursorToPosition(t);}this.clearSelection();},this.navigateLineStart=function(){this.selection.moveCursorLineStart(),this.clearSelection();},this.navigateLineEnd=function(){this.selection.moveCursorLineEnd(),this.clearSelection();},this.navigateFileEnd=function(){this.selection.moveCursorFileEnd(),this.clearSelection();},this.navigateFileStart=function(){this.selection.moveCursorFileStart(),this.clearSelection();},this.navigateWordRight=function(){this.selection.moveCursorWordRight(),this.clearSelection();},this.navigateWordLeft=function(){this.selection.moveCursorWordLeft(),this.clearSelection();},this.replace=function(e,t){t&&this.$search.set(t);var i=this.$search.find(this.session),n=0;return i&&(this.$tryReplace(i,e)&&(n=1),this.selection.setSelectionRange(i),this.renderer.scrollSelectionIntoView(i.start,i.end)),n;},this.replaceAll=function(e,t){t&&this.$search.set(t);var i=this.$search.findAll(this.session),n=0;if(!i.length)return n;var r=this.getSelectionRange();this.selection.moveTo(0,0);for(var o=i.length-1;0<=o;--o){this.$tryReplace(i[o],e)&&n++;}return this.selection.setSelectionRange(r),n;},this.$tryReplace=function(e,t){var i=this.session.getTextRange(e);return null!==(t=this.$search.replace(i,t))?(e.end=this.session.replace(e,t),e):null;},this.getLastSearchOptions=function(){return this.$search.getOptions();},this.find=function(e,t,i){t=t||{},"string"==typeof e||e instanceof RegExp?t.needle=e:"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&o.mixin(t,e);var n=this.selection.getRange();null==t.needle&&((e=this.session.getTextRange(n)||this.$search.$options.needle)||(n=this.session.getWordRange(n.start.row,n.start.column),e=this.session.getTextRange(n)),this.$search.set({needle:e})),this.$search.set(t),t.start||this.$search.set({start:n});var r=this.$search.find(this.session);return t.preventScroll?r:r?(this.revealRange(r,i),r):(t.backwards?n.start=n.end:n.end=n.start,void this.selection.setRange(n));},this.findNext=function(e,t){this.find({skipCurrent:!0,backwards:!1},e,t);},this.findPrevious=function(e,t){this.find(e,{skipCurrent:!0,backwards:!0},t);},this.revealRange=function(e,t){this.session.unfold(e),this.selection.setSelectionRange(e);var i=this.renderer.scrollTop;this.renderer.scrollSelectionIntoView(e.start,e.end,.5),!1!==t&&this.renderer.animateScrolling(i);},this.undo=function(){this.session.getUndoManager().undo(this.session),this.renderer.scrollCursorIntoView(null,.5);},this.redo=function(){this.session.getUndoManager().redo(this.session),this.renderer.scrollCursorIntoView(null,.5);},this.destroy=function(){this.$toDestroy&&(this.$toDestroy.forEach(function(e){e.destroy();}),this.$toDestroy=null),this.renderer.destroy(),this._signal("destroy",this),this.session&&this.session.destroy(),this._$emitInputEvent&&this._$emitInputEvent.cancel(),this.removeAllListeners();},this.setAutoScrollEditorIntoView=function(e){var r,o,s,a,t,i,n;e&&(s=!1,(o=this).$scrollAnchor||(this.$scrollAnchor=document.createElement("div")),(a=this.$scrollAnchor).style.cssText="position:absolute",this.container.insertBefore(a,this.container.firstChild),t=this.on("changeSelection",function(){s=!0;}),i=this.renderer.on("beforeRender",function(){s&&(r=o.renderer.container.getBoundingClientRect());}),n=this.renderer.on("afterRender",function(){var e,t,i,n;s&&r&&(o.isFocused()||o.searchBox&&o.searchBox.isFocused())&&(t=(e=o.renderer).$cursorLayer.$pixelPos,i=e.layerConfig,n=t.top-i.offset,null!=(s=0<=t.top&&n+r.top<0||!(t.top<i.height&&t.top+r.top+i.lineHeight>window.innerHeight)&&null)&&(a.style.top=n+"px",a.style.left=t.left+"px",a.style.height=i.lineHeight+"px",a.scrollIntoView(s)),s=r=null);}),this.setAutoScrollEditorIntoView=function(e){e||(delete this.setAutoScrollEditorIntoView,this.off("changeSelection",t),this.renderer.off("afterRender",n),this.renderer.off("beforeRender",i));});},this.$resetCursorStyle=function(){var e=this.$cursorStyle||"ace",t=this.renderer.$cursorLayer;t&&(t.setSmoothBlinking(/smooth/.test(e)),t.isBlinking=!this.$readOnly&&"wide"!=e,n.setCssClass(t.element,"ace_slim-cursors",/slim/.test(e)));},this.prompt=function(t,i,n){var r=this;C.loadModule("./ext/prompt",function(e){e.prompt(r,t,i,n);});};}.call(v.prototype),C.defineOptions(v.prototype,"editor",{selectionStyle:{set:function set(e){this.onSelectionChange(),this._signal("changeSelectionStyle",{data:e});},initialValue:"line"},highlightActiveLine:{set:function set(){this.$updateHighlightActiveLine();},initialValue:!0},highlightSelectedWord:{set:function set(e){this.$onSelectionChange();},initialValue:!0},readOnly:{set:function set(e){this.textInput.setReadOnly(e),this.$resetCursorStyle();},initialValue:!1},copyWithEmptySelection:{set:function set(e){this.textInput.setCopyWithEmptySelection(e);},initialValue:!1},cursorStyle:{set:function set(e){this.$resetCursorStyle();},values:["ace","slim","smooth","wide"],initialValue:"ace"},mergeUndoDeltas:{values:[!1,!0,"always"],initialValue:!0},behavioursEnabled:{initialValue:!0},wrapBehavioursEnabled:{initialValue:!0},enableAutoIndent:{initialValue:!0},autoScrollEditorIntoView:{set:function set(e){this.setAutoScrollEditorIntoView(e);}},keyboardHandler:{set:function set(e){this.setKeyboardHandler(e);},get:function get(){return this.$keybindingId;},handlesSet:!0},value:{set:function set(e){this.session.setValue(e);},get:function get(){return this.getValue();},handlesSet:!0,hidden:!0},session:{set:function set(e){this.setSession(e);},get:function get(){return this.session;},handlesSet:!0,hidden:!0},showLineNumbers:{set:function set(e){this.renderer.$gutterLayer.setShowLineNumbers(e),this.renderer.$loop.schedule(this.renderer.CHANGE_GUTTER),e&&this.$relativeLineNumbers?b.attach(this):b.detach(this);},initialValue:!0},relativeLineNumbers:{set:function set(e){this.$showLineNumbers&&e?b.attach(this):b.detach(this);}},placeholder:{set:function set(e){this.$updatePlaceholder||(this.$updatePlaceholder=function(){var e,t=this.session&&(this.renderer.$composition||this.getValue());t&&this.renderer.placeholderNode?(this.renderer.off("afterRender",this.$updatePlaceholder),n.removeCssClass(this.container,"ace_hasPlaceholder"),this.renderer.placeholderNode.remove(),this.renderer.placeholderNode=null):t||this.renderer.placeholderNode?!t&&this.renderer.placeholderNode&&(this.renderer.placeholderNode.textContent=this.$placeholder||""):(this.renderer.on("afterRender",this.$updatePlaceholder),n.addCssClass(this.container,"ace_hasPlaceholder"),(e=n.createElement("div")).className="ace_placeholder",e.textContent=this.$placeholder||"",this.renderer.placeholderNode=e,this.renderer.content.appendChild(this.renderer.placeholderNode));}.bind(this),this.on("input",this.$updatePlaceholder)),this.$updatePlaceholder();}},hScrollBarAlwaysVisible:"renderer",vScrollBarAlwaysVisible:"renderer",highlightGutterLine:"renderer",animatedScroll:"renderer",showInvisibles:"renderer",showPrintMargin:"renderer",printMarginColumn:"renderer",printMargin:"renderer",fadeFoldWidgets:"renderer",showFoldWidgets:"renderer",displayIndentGuides:"renderer",showGutter:"renderer",fontSize:"renderer",fontFamily:"renderer",maxLines:"renderer",minLines:"renderer",scrollPastEnd:"renderer",fixedWidthGutter:"renderer",theme:"renderer",hasCssTransforms:"renderer",maxPixelHeight:"renderer",useTextareaForIME:"renderer",scrollSpeed:"$mouseHandler",dragDelay:"$mouseHandler",dragEnabled:"$mouseHandler",focusTimeout:"$mouseHandler",tooltipFollowsMouse:"$mouseHandler",firstLineNumber:"session",overwrite:"session",newLineMode:"session",useWorker:"session",useSoftTabs:"session",navigateWithinSoftTabs:"session",tabSize:"session",wrap:"session",indentedSoftWrap:"session",foldStyle:"session",mode:"session"});var b={getText:function getText(e,t){return(Math.abs(e.selection.lead.row-t)||t+1+(t<9?"·":""))+"";},getWidth:function getWidth(e,t,i){return Math.max(t.toString().length,(i.lastRow+1).toString().length,2)*i.characterWidth;},update:function update(e,t){t.renderer.$loop.schedule(t.renderer.CHANGE_GUTTER);},attach:function attach(e){e.renderer.$gutterLayer.$renderer=this,e.on("changeSelection",this.update),this.update(null,e);},detach:function detach(e){e.renderer.$gutterLayer.$renderer==this&&(e.renderer.$gutterLayer.$renderer=null),e.off("changeSelection",this.update),this.update(null,e);}};t.Editor=v;}),ace.define("ace/undomanager",["require","exports","module","ace/range"],function(e,t,i){"use strict";function n(){this.$maxRev=0,this.$fromUndo=!1,this.reset();}(function(){this.addSession=function(e){this.$session=e;},this.add=function(e,t,i){this.$fromUndo||e!=this.$lastDelta&&(this.$keepRedoStack||(this.$redoStack.length=0),!1!==t&&this.lastDeltas||(this.lastDeltas=[],this.$undoStack.push(this.lastDeltas),e.id=this.$rev=++this.$maxRev),"remove"!=e.action&&"insert"!=e.action||(this.$lastDelta=e),this.lastDeltas.push(e));},this.addSelection=function(e,t){this.selections.push({value:e,rev:t||this.$rev});},this.startNewGroup=function(){return this.lastDeltas=null,this.$rev;},this.markIgnored=function(e,t){null==t&&(t=this.$rev+1);for(var i=this.$undoStack,n=i.length;n--;){var r=i[n][0];if(r.id<=e)break;r.id<t&&(r.ignore=!0);}this.lastDeltas=null;},this.getSelection=function(e,t){for(var i=this.selections,n=i.length;n--;){var r=i[n];if(r.rev<e)return t&&(r=i[n+1]),r;}},this.getRevision=function(){return this.$rev;},this.getDeltas=function(e,t){null==t&&(t=this.$rev+1);for(var i=this.$undoStack,n=null,r=0,o=i.length;o--;){var s=i[o][0];if(s.id<t&&!n&&(n=o+1),s.id<=e){r=o+1;break;}}return i.slice(r,n);},this.getChangedRanges=function(e,t){null==t&&(t=this.$rev+1);},this.getChangedLines=function(e,t){null==t&&(t=this.$rev+1);},this.undo=function(e,t){this.lastDeltas=null;var i=this.$undoStack;if(function(e,t){for(var i=t;i--;){var n=e[i];if(n&&!n[0].ignore){for(;i<t-1;){var r=h(e[i],e[i+1]);e[i]=r[0],e[i+1]=r[1],i++;}return 1;}}}(i,i.length)){e=e||this.$session,this.$redoStackBaseRev!==this.$rev&&this.$redoStack.length&&(this.$redoStack=[]),this.$fromUndo=!0;var n=i.pop(),r=null;return n&&(r=e.undoChanges(n,t),this.$redoStack.push(n),this.$syncRev()),this.$fromUndo=!1,r;}},this.redo=function(e,t){var i;this.lastDeltas=null,e=e||this.$session,this.$fromUndo=!0,this.$redoStackBaseRev!=this.$rev&&(i=this.getDeltas(this.$redoStackBaseRev,this.$rev+1),function(e,t){for(var i=0;i<t.length;i++){for(var n=t[i],r=0;r<n.length;r++){m(e,n[r]);}}}(this.$redoStack,i),this.$redoStackBaseRev=this.$rev,this.$redoStack.forEach(function(e){e[0].id=++this.$maxRev;},this));var n=this.$redoStack.pop(),r=null;return n&&(r=e.redoChanges(n,t),this.$undoStack.push(n),this.$syncRev()),this.$fromUndo=!1,r;},this.$syncRev=function(){var e=this.$undoStack,t=e[e.length-1],i=t&&t[0].id||0;this.$redoStackBaseRev=i,this.$rev=i;},this.reset=function(){this.lastDeltas=null,this.$lastDelta=null,this.$undoStack=[],this.$redoStack=[],this.$rev=0,this.mark=0,this.$redoStackBaseRev=this.$rev,this.selections=[];},this.canUndo=function(){return 0<this.$undoStack.length;},this.canRedo=function(){return 0<this.$redoStack.length;},this.bookmark=function(e){null==e&&(e=this.$rev),this.mark=e;},this.isAtBookmark=function(){return this.$rev===this.mark;},this.toJSON=function(){},this.fromJSON=function(){},this.hasUndo=this.canUndo,this.hasRedo=this.canRedo,this.isClean=this.isAtBookmark,this.markClean=this.bookmark,this.$prettyPrint=function(e){return e?r(e):r(this.$undoStack)+"\n---\n"+r(this.$redoStack);};}).call(n.prototype);var s=e("./range").Range,a=s.comparePoints;s.comparePoints;function l(e){return{row:e.row,column:e.column};}function r(e){if(e=e||this,Array.isArray(e))return e.map(r).join("\n");var t="";return e.action?(t="insert"==e.action?"+":"-",t+="["+e.lines+"]"):e.value&&(t=Array.isArray(e.value)?e.value.map(o).join("\n"):o(e.value)),e.start&&(t+=o(e)),(e.id||e.rev)&&(t+="\t("+(e.id||e.rev)+")"),t;}function o(e){return e.start.row+":"+e.start.column+"=>"+e.end.row+":"+e.end.column;}function c(e,t){var i="insert"==e.action,n="insert"==t.action;if(i&&n){if(0<=a(t.start,e.end))u(t,e,-1);else{if(!(a(t.start,e.start)<=0))return;u(e,t,1);}}else if(i&&!n){if(0<=a(t.start,e.end))u(t,e,-1);else{if(!(a(t.end,e.start)<=0))return;u(e,t,-1);}}else if(!i&&n){if(0<=a(t.start,e.start))u(t,e,1);else{if(!(a(t.start,e.start)<=0))return;u(e,t,1);}}else if(!i&&!n)if(0<=a(t.start,e.start))u(t,e,1);else{if(!(a(t.end,e.start)<=0))return;u(e,t,-1);}return 1;}function h(e,t){for(var i=e.length;i--;){for(var n=0;n<t.length;n++){if(!c(e[i],t[n])){for(;i<e.length;){for(;n--;){c(t[n],e[i]);}n=t.length,i++;}return[e,t];}}}return e.selectionBefore=t.selectionBefore=e.selectionAfter=t.selectionAfter=null,[t,e];}function d(e,t){var i,n,r="insert"==e.action,o="insert"==t.action;if(r&&o)a(e.start,t.start)<0?u(t,e,1):u(e,t,1);else if(r&&!o)0<=a(e.start,t.end)?u(e,t,-1):(a(e.start,t.start)<=0||u(e,s.fromPoints(t.start,e.start),-1),u(t,e,1));else if(!r&&o)0<=a(t.start,e.end)?u(t,e,-1):(a(t.start,e.start)<=0||u(t,s.fromPoints(e.start,t.start),-1),u(e,t,1));else if(!r&&!o)if(0<=a(t.start,e.end))u(t,e,-1);else{if(!(a(t.end,e.start)<=0))return a(e.start,t.start)<0&&(e=p(i=e,t.start)),0<a(e.end,t.end)&&(n=p(e,t.end)),g(t.end,e.start,e.end,-1),n&&!i&&(e.lines=n.lines,e.start=n.start,e.end=n.end,n=e),[t,i,n].filter(Boolean);u(e,t,-1);}return[t,e];}function u(e,t,i){g(e.start,t.start,t.end,i),g(e.end,t.start,t.end,i);}function g(e,t,i,n){e.row==(1==n?t:i).row&&(e.column+=n*(i.column-t.column)),e.row+=n*(i.row-t.row);}function p(e,t){var i=e.lines,n=e.end;e.end=l(t);var r=e.end.row-e.start.row,o=i.splice(r,i.length),s=r?t.column:t.column-e.start.column;return i.push(o[0].substring(0,s)),o[0]=o[0].substr(s),{start:l(t),end:n,lines:o,action:e.action};}function m(e,t){var i;t={start:l((i=t).start),end:l(i.end),action:i.action,lines:i.lines.slice()};for(var n=e.length;n--;){for(var r=e[n],o=0;o<r.length;o++){var s=d(r[o],t);t=s[0],2!=s.length&&(s[2]?(r.splice(o+1,1,s[1],s[2]),o++):s[1]||(r.splice(o,1),o--));}r.length||e.splice(n,1);}return e;}t.UndoManager=n;}),ace.define("ace/layer/lines",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";function n(e,t){this.element=e,this.canvasHeight=t||5e5,this.element.style.height=2*this.canvasHeight+"px",this.cells=[],this.cellCache=[],this.$offsetCoefficient=0;}var s=e("../lib/dom");(function(){this.moveContainer=function(e){s.translate(this.element,0,-(e.firstRowScreen*e.lineHeight%this.canvasHeight)-e.offset*this.$offsetCoefficient);},this.pageChanged=function(e,t){return Math.floor(e.firstRowScreen*e.lineHeight/this.canvasHeight)!==Math.floor(t.firstRowScreen*t.lineHeight/this.canvasHeight);},this.computeLineTop=function(e,t,i){var n=t.firstRowScreen*t.lineHeight,r=Math.floor(n/this.canvasHeight);return i.documentToScreenRow(e,0)*t.lineHeight-r*this.canvasHeight;},this.computeLineHeight=function(e,t,i){return t.lineHeight*i.getRowLineCount(e);},this.getLength=function(){return this.cells.length;},this.get=function(e){return this.cells[e];},this.shift=function(){this.$cacheCell(this.cells.shift());},this.pop=function(){this.$cacheCell(this.cells.pop());},this.push=function(e){if(Array.isArray(e)){this.cells.push.apply(this.cells,e);for(var t=s.createFragment(this.element),i=0;i<e.length;i++){t.appendChild(e[i].element);}this.element.appendChild(t);}else this.cells.push(e),this.element.appendChild(e.element);},this.unshift=function(e){if(Array.isArray(e)){this.cells.unshift.apply(this.cells,e);for(var t=s.createFragment(this.element),i=0;i<e.length;i++){t.appendChild(e[i].element);}this.element.firstChild?this.element.insertBefore(t,this.element.firstChild):this.element.appendChild(t);}else this.cells.unshift(e),this.element.insertAdjacentElement("afterbegin",e.element);},this.last=function(){return this.cells.length?this.cells[this.cells.length-1]:null;},this.$cacheCell=function(e){e&&(e.element.remove(),this.cellCache.push(e));},this.createCell=function(e,t,i,n){var r,o=this.cellCache.pop();return o||(r=s.createElement("div"),n&&n(r),this.element.appendChild(r),o={element:r,text:"",row:e}),o.row=e,o;};}).call(n.prototype),t.Lines=n;}),ace.define("ace/layer/gutter",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/layer/lines"],function(e,t,i){"use strict";function n(e){this.element=I.createElement("div"),this.element.className="ace_layer ace_gutter-layer",e.appendChild(this.element),this.setShowFoldWidgets(this.$showFoldWidgets),this.gutterWidth=0,this.$annotations=[],this.$updateAnnotations=this.$updateAnnotations.bind(this),this.$lines=new s(this.element),this.$lines.$offsetCoefficient=1;}var I=e("../lib/dom"),r=e("../lib/oop"),a=e("../lib/lang"),o=e("../lib/event_emitter").EventEmitter,s=e("./lines").Lines;function c(e){var t=document.createTextNode("");e.appendChild(t);var i=I.createElement("span");return e.appendChild(i),e;}(function(){r.implement(this,o),this.setSession=function(e){this.session&&this.session.off("change",this.$updateAnnotations),(this.session=e)&&e.on("change",this.$updateAnnotations);},this.addGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.addGutterDecoration"),this.session.addGutterDecoration(e,t);},this.removeGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.removeGutterDecoration"),this.session.removeGutterDecoration(e,t);},this.setAnnotations=function(e){this.$annotations=[];for(var t=0;t<e.length;t++){var i=e[t],n=i.row,r=(r=this.$annotations[n])||(this.$annotations[n]={text:[]}),o=(o=i.text)?a.escapeHTML(o):i.html||"";-1===r.text.indexOf(o)&&r.text.push(o);var s=i.type;"error"==s?r.className=" ace_error":"warning"==s&&" ace_error"!=r.className?r.className=" ace_warning":"info"!=s||r.className||(r.className=" ace_info");}},this.$updateAnnotations=function(e){var t,i,n;this.$annotations.length&&(t=e.start.row,0==(i=e.end.row-t)||("remove"==e.action?this.$annotations.splice(t,1+i,null):((n=new Array(1+i)).unshift(t,1),this.$annotations.splice.apply(this.$annotations,n))));},this.update=function(e){this.config=e;var t=this.session,i=e.firstRow,n=Math.min(e.lastRow+e.gutterOffset,t.getLength()-1);this.oldLastRow=n,this.config=e,this.$lines.moveContainer(e),this.$updateCursorRow();for(var r=t.getNextFoldLine(i),o=r?r.start.row:1/0,s=null,a=-1,l=i;;){if(o<l&&(l=r.end.row+1,o=(r=t.getNextFoldLine(l,r))?r.start.row:1/0),n<l){for(;this.$lines.getLength()>a+1;){this.$lines.pop();}break;}(s=this.$lines.get(++a))?s.row=l:(s=this.$lines.createCell(l,e,this.session,c),this.$lines.push(s)),this.$renderCell(s,e,r,l),l++;}this._signal("afterRender"),this.$updateGutterWidth(e);},this.$updateGutterWidth=function(e){var t=this.session,i=t.gutterRenderer||this.$renderer,n=t.$firstLineNumber,r=this.$lines.last()?this.$lines.last().text:"";(this.$fixedWidth||t.$useWrapMode)&&(r=t.getLength()+n-1);var o=i?i.getWidth(t,r,e):r.toString().length*e.characterWidth,s=this.$padding||this.$computePadding();(o+=s.left+s.right)===this.gutterWidth||isNaN(o)||(this.gutterWidth=o,this.element.parentNode.style.width=this.element.style.width=Math.ceil(this.gutterWidth)+"px",this._signal("changeGutterWidth",o));},this.$updateCursorRow=function(){var e;this.$highlightGutterLine&&(e=this.session.selection.getCursor(),this.$cursorRow!==e.row&&(this.$cursorRow=e.row));},this.updateLineHighlight=function(){if(this.$highlightGutterLine){var e=this.session.selection.cursor.row;if(this.$cursorRow=e,!this.$cursorCell||this.$cursorCell.row!=e){this.$cursorCell&&(this.$cursorCell.element.className=this.$cursorCell.element.className.replace("ace_gutter-active-line ",""));var t=this.$lines.cells;this.$cursorCell=null;for(var i=0;i<t.length;i++){var n=t[i];if(n.row>=this.$cursorRow){if(n.row>this.$cursorRow){var r=this.session.getFoldLine(this.$cursorRow);if(!(0<i&&r&&r.start.row==t[i-1].row))break;n=t[i-1];}n.element.className="ace_gutter-active-line "+n.element.className,this.$cursorCell=n;break;}}}}},this.scrollLines=function(e){var t=this.config;if(this.config=e,this.$updateCursorRow(),this.$lines.pageChanged(t,e))return this.update(e);this.$lines.moveContainer(e);var i=Math.min(e.lastRow+e.gutterOffset,this.session.getLength()-1),n=this.oldLastRow;if(this.oldLastRow=i,!t||n<e.firstRow)return this.update(e);if(i<t.firstRow)return this.update(e);if(t.firstRow<e.firstRow)for(var r=this.session.getFoldedRowCount(t.firstRow,e.firstRow-1);0<r;r--){this.$lines.shift();}if(i<n)for(r=this.session.getFoldedRowCount(i+1,n);0<r;r--){this.$lines.pop();}e.firstRow<t.firstRow&&this.$lines.unshift(this.$renderLines(e,e.firstRow,t.firstRow-1)),n<i&&this.$lines.push(this.$renderLines(e,n+1,i)),this.updateLineHighlight(),this._signal("afterRender"),this.$updateGutterWidth(e);},this.$renderLines=function(e,t,i){for(var n=[],r=t,o=this.session.getNextFoldLine(r),s=o?o.start.row:1/0;s<r&&(r=o.end.row+1,s=(o=this.session.getNextFoldLine(r,o))?o.start.row:1/0),!(i<r);){var a=this.$lines.createCell(r,e,this.session,c);this.$renderCell(a,e,o,r),n.push(a),r++;}return n;},this.$renderCell=function(e,t,i,n){var r,o,s=e.element,a=this.session,l=s.childNodes[0],c=s.childNodes[1],h=a.$firstLineNumber,d=a.$breakpoints,u=a.$decorations,g=a.gutterRenderer||this.$renderer,p=this.$showFoldWidgets&&a.foldWidgets,m=i?i.start.row:Number.MAX_VALUE,f="ace_gutter-cell ";this.$highlightGutterLine&&(n==this.$cursorRow||i&&n<this.$cursorRow&&m<=n&&this.$cursorRow<=i.end.row)&&(f+="ace_gutter-active-line ",this.$cursorCell!=e&&(this.$cursorCell&&(this.$cursorCell.element.className=this.$cursorCell.element.className.replace("ace_gutter-active-line ","")),this.$cursorCell=e)),d[n]&&(f+=d[n]),u[n]&&(f+=u[n]),this.$annotations[n]&&(f+=this.$annotations[n].className),s.className!=f&&(s.className=f),!p||null==(r=p[n])&&(r=p[n]=a.getFoldWidget(n)),r?(f="ace_fold-widget ace_"+r,"start"==r&&n==m&&n<i.end.row?f+=" ace_closed":f+=" ace_open",c.className!=f&&(c.className=f),o=t.lineHeight+"px",I.setStyle(c.style,"height",o),I.setStyle(c.style,"display","inline-block")):c&&I.setStyle(c.style,"display","none");var C=(g?g.getText(a,n):n+h).toString();return C!==l.data&&(l.data=C),I.setStyle(e.element.style,"height",this.$lines.computeLineHeight(n,t,a)+"px"),I.setStyle(e.element.style,"top",this.$lines.computeLineTop(n,t,a)+"px"),e.text=C,e;},this.$fixedWidth=!1,this.$highlightGutterLine=!0,this.$renderer="",this.setHighlightGutterLine=function(e){this.$highlightGutterLine=e;},this.$showLineNumbers=!0,this.$renderer="",this.setShowLineNumbers=function(e){this.$renderer=!e&&{getWidth:function getWidth(){return 0;},getText:function getText(){return"";}};},this.getShowLineNumbers=function(){return this.$showLineNumbers;},this.$showFoldWidgets=!0,this.setShowFoldWidgets=function(e){e?I.addCssClass(this.element,"ace_folding-enabled"):I.removeCssClass(this.element,"ace_folding-enabled"),this.$showFoldWidgets=e,this.$padding=null;},this.getShowFoldWidgets=function(){return this.$showFoldWidgets;},this.$computePadding=function(){if(!this.element.firstChild)return{left:0,right:0};var e=I.computedStyle(this.element.firstChild);return this.$padding={},this.$padding.left=(parseInt(e.borderLeftWidth)||0)+(parseInt(e.paddingLeft)||0)+1,this.$padding.right=(parseInt(e.borderRightWidth)||0)+(parseInt(e.paddingRight)||0),this.$padding;},this.getRegion=function(e){var t=this.$padding||this.$computePadding(),i=this.element.getBoundingClientRect();return e.x<t.left+i.left?"markers":this.$showFoldWidgets&&e.x>i.right-t.right?"foldWidgets":void 0;};}).call(n.prototype),t.Gutter=n;}),ace.define("ace/layer/marker",["require","exports","module","ace/range","ace/lib/dom"],function(e,t,i){"use strict";function n(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_marker-layer",e.appendChild(this.element);}var g=e("../range").Range,r=e("../lib/dom");(function(){this.$padding=0,this.setPadding=function(e){this.$padding=e;},this.setSession=function(e){this.session=e;},this.setMarkers=function(e){this.markers=e;},this.elt=function(e,t){var i=-1!=this.i&&this.element.childNodes[this.i];i?this.i++:(i=document.createElement("div"),this.element.appendChild(i),this.i=-1),i.style.cssText=t,i.className=e;},this.update=function(e){if(e){var t;for(var i in this.config=e,this.i=0,this.markers){var n,r,o,s=this.markers[i];s.range?(o=s.range.clipRows(e.firstRow,e.lastRow)).isEmpty()||(o=o.toScreenRange(this.session),s.renderer?(n=this.$getTop(o.start.row,e),r=this.$padding+o.start.column*e.characterWidth,s.renderer(t,o,r,n,e)):"fullLine"==s.type?this.drawFullLineMarker(t,o,s.clazz,e):"screenLine"==s.type?this.drawScreenLineMarker(t,o,s.clazz,e):o.isMultiLine()?"text"==s.type?this.drawTextMarker(t,o,s.clazz,e):this.drawMultiLineMarker(t,o,s.clazz,e):this.drawSingleLineMarker(t,o,s.clazz+" ace_start ace_br15",e)):s.update(t,this,this.session,e);}if(-1!=this.i)for(;this.i<this.element.childElementCount;){this.element.removeChild(this.element.lastChild);}}},this.$getTop=function(e,t){return(e-t.firstRowScreen)*t.lineHeight;},this.drawTextMarker=function(e,t,i,n,r){for(var o=this.session,s=t.start.row,a=t.end.row,l=s,c=0,h=0,d=o.getScreenLastRowColumn(l),u=new g(l,t.start.column,l,h);l<=a;l++){u.start.row=u.end.row=l,u.start.column=l==s?t.start.column:o.getRowWrapIndent(l),c=h,h=u.end.column=d,d=l+1<a?o.getScreenLastRowColumn(l+1):l==a?0:t.end.column,this.drawSingleLineMarker(e,u,i+(l==s?" ace_start":"")+" ace_br"+((l==s||l==s+1&&t.start.column?1:0)|(c<h?2:0)|(d<h?4:0)|(l==a?8:0)),n,l==a?0:1,r);}},this.drawMultiLineMarker=function(e,t,i,n,r){var o,s,a,l=this.$padding,c=n.lineHeight,h=this.$getTop(t.start.row,n),d=l+t.start.column*n.characterWidth;r=r||"",this.session.$bidiHandler.isBidiRow(t.start.row)?((o=t.clone()).end.row=o.start.row,o.end.column=this.session.getLine(o.start.row).length,this.drawBidiSingleLineMarker(e,o,i+" ace_br1 ace_start",n,null,r)):this.elt(i+" ace_br1 ace_start","height:"+c+"px;right:0;top:"+h+"px;left:"+d+"px;"+(r||"")),this.session.$bidiHandler.isBidiRow(t.end.row)?((o=t.clone()).start.row=o.end.row,o.start.column=0,this.drawBidiSingleLineMarker(e,o,i+" ace_br12",n,null,r)):(h=this.$getTop(t.end.row,n),s=t.end.column*n.characterWidth,this.elt(i+" ace_br12","height:"+c+"px;width:"+s+"px;top:"+h+"px;left:"+l+"px;"+(r||""))),(c=(t.end.row-t.start.row-1)*n.lineHeight)<=0||(h=this.$getTop(t.start.row+1,n),a=(t.start.column?1:0)|(t.end.column?0:8),this.elt(i+(a?" ace_br"+a:""),"height:"+c+"px;right:0;top:"+h+"px;left:"+l+"px;"+(r||"")));},this.drawSingleLineMarker=function(e,t,i,n,r,o){if(this.session.$bidiHandler.isBidiRow(t.start.row))return this.drawBidiSingleLineMarker(e,t,i,n,r,o);var s=n.lineHeight,a=(t.end.column+(r||0)-t.start.column)*n.characterWidth,l=this.$getTop(t.start.row,n),c=this.$padding+t.start.column*n.characterWidth;this.elt(i,"height:"+s+"px;width:"+a+"px;top:"+l+"px;left:"+c+"px;"+(o||""));},this.drawBidiSingleLineMarker=function(e,t,i,n,r,o){var s=n.lineHeight,a=this.$getTop(t.start.row,n),l=this.$padding;this.session.$bidiHandler.getSelections(t.start.column,t.end.column).forEach(function(e){this.elt(i,"height:"+s+"px;width:"+e.width+(r||0)+"px;top:"+a+"px;left:"+(l+e.left)+"px;"+(o||""));},this);},this.drawFullLineMarker=function(e,t,i,n,r){var o=this.$getTop(t.start.row,n),s=n.lineHeight;t.start.row!=t.end.row&&(s+=this.$getTop(t.end.row,n)-o),this.elt(i,"height:"+s+"px;top:"+o+"px;left:0;right:0;"+(r||""));},this.drawScreenLineMarker=function(e,t,i,n,r){var o=this.$getTop(t.start.row,n),s=n.lineHeight;this.elt(i,"height:"+s+"px;top:"+o+"px;left:0;right:0;"+(r||""));};}).call(n.prototype),t.Marker=n;}),ace.define("ace/layer/text",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/layer/lines","ace/lib/event_emitter"],function(e,t,i){"use strict";function n(e){this.dom=c,this.element=this.dom.createElement("div"),this.element.className="ace_layer ace_text-layer",e.appendChild(this.element),this.$updateEolChar=this.$updateEolChar.bind(this),this.$lines=new o(this.element);}var r=e("../lib/oop"),c=e("../lib/dom"),I=e("../lib/lang"),o=e("./lines").Lines,s=e("../lib/event_emitter").EventEmitter;(function(){r.implement(this,s),this.EOF_CHAR="¶",this.EOL_CHAR_LF="¬",this.EOL_CHAR_CRLF="¤",this.EOL_CHAR=this.EOL_CHAR_LF,this.TAB_CHAR="—",this.SPACE_CHAR="·",this.$padding=0,this.MAX_LINE_LENGTH=1e4,this.$updateEolChar=function(){var e=this.session.doc,t="\n"==e.getNewLineCharacter()&&"windows"!=e.getNewLineMode()?this.EOL_CHAR_LF:this.EOL_CHAR_CRLF;if(this.EOL_CHAR!=t)return this.EOL_CHAR=t,!0;},this.setPadding=function(e){this.$padding=e,this.element.style.margin="0 "+e+"px";},this.getLineHeight=function(){return this.$fontMetrics.$characterSize.height||0;},this.getCharacterWidth=function(){return this.$fontMetrics.$characterSize.width||0;},this.$setFontMetrics=function(e){this.$fontMetrics=e,this.$fontMetrics.on("changeCharacterSize",function(e){this._signal("changeCharacterSize",e);}.bind(this)),this.$pollSizeChanges();},this.checkForSizeChanges=function(){this.$fontMetrics.checkForSizeChanges();},this.$pollSizeChanges=function(){return this.$pollSizeChangesTimer=this.$fontMetrics.$pollSizeChanges();},this.setSession=function(e){(this.session=e)&&this.$computeTabString();},this.showInvisibles=!1,this.showSpaces=!1,this.showTabs=!1,this.showEOL=!1,this.setShowInvisibles=function(e){return this.showInvisibles!=e&&("string"==typeof(this.showInvisibles=e)?(this.showSpaces=/tab/i.test(e),this.showTabs=/space/i.test(e),this.showEOL=/eol/i.test(e)):this.showSpaces=this.showTabs=this.showEOL=e,this.$computeTabString(),!0);},this.displayIndentGuides=!0,this.setDisplayIndentGuides=function(e){return this.displayIndentGuides!=e&&(this.displayIndentGuides=e,this.$computeTabString(),!0);},this.$tabStrings=[],this.onChangeTabSize=this.$computeTabString=function(){var e=this.session.getTabSize();this.tabSize=e;for(var t,i,n,r,o,s,a=this.$tabStrings=[0],l=1;l<e+1;l++){this.showTabs?((s=this.dom.createElement("span")).className="ace_invisible ace_invisible_tab",s.textContent=I.stringRepeat(this.TAB_CHAR,l),a.push(s)):a.push(this.dom.createTextNode(I.stringRepeat(" ",l),this.element));}this.displayIndentGuides&&(this.$indentGuideRe=/\s\S| \t|\t |\s$/,t="ace_indent-guide",i=this.showSpaces?" ace_invisible ace_invisible_space":"",n=this.showSpaces?I.stringRepeat(this.SPACE_CHAR,this.tabSize):I.stringRepeat(" ",this.tabSize),r=this.showTabs?" ace_invisible ace_invisible_tab":"",o=this.showTabs?I.stringRepeat(this.TAB_CHAR,this.tabSize):n,(s=this.dom.createElement("span")).className=t+i,s.textContent=n,this.$tabStrings[" "]=s,(s=this.dom.createElement("span")).className=t+r,s.textContent=o,this.$tabStrings["\t"]=s);},this.updateLines=function(e,t,i){if(this.config.lastRow!=e.lastRow||this.config.firstRow!=e.firstRow)return this.update(e);this.config=e;for(var n=Math.max(t,e.firstRow),r=Math.min(i,e.lastRow),o=this.element.childNodes,s=0,a=e.firstRow;a<n;a++){if(l=this.session.getFoldLine(a)){if(l.containsRow(n)){n=l.start.row;break;}a=l.end.row;}s++;}for(var l,c=!1,a=n,h=(l=this.session.getNextFoldLine(a))?l.start.row:1/0;h<a&&(a=l.end.row+1,h=(l=this.session.getNextFoldLine(a,l))?l.start.row:1/0),!(r<a);){var d,u=o[s++];u&&(this.dom.removeChildren(u),this.$renderLine(u,a,a==h&&l),c&&(u.style.top=this.$lines.computeLineTop(a,e,this.session)+"px"),d=e.lineHeight*this.session.getRowLength(a)+"px",u.style.height!=d&&(c=!0,u.style.height=d)),a++;}if(c)for(;s<this.$lines.cells.length;){var g=this.$lines.cells[s++];g.element.style.top=this.$lines.computeLineTop(g.row,e,this.session)+"px";}},this.scrollLines=function(e){var t=this.config;if(this.config=e,this.$lines.pageChanged(t,e))return this.update(e);this.$lines.moveContainer(e);var i=e.lastRow,n=t?t.lastRow:-1;if(!t||n<e.firstRow)return this.update(e);if(i<t.firstRow)return this.update(e);if(!t||t.lastRow<e.firstRow)return this.update(e);if(e.lastRow<t.firstRow)return this.update(e);if(t.firstRow<e.firstRow)for(var r=this.session.getFoldedRowCount(t.firstRow,e.firstRow-1);0<r;r--){this.$lines.shift();}if(t.lastRow>e.lastRow)for(r=this.session.getFoldedRowCount(e.lastRow+1,t.lastRow);0<r;r--){this.$lines.pop();}e.firstRow<t.firstRow&&this.$lines.unshift(this.$renderLinesFragment(e,e.firstRow,t.firstRow-1)),e.lastRow>t.lastRow&&this.$lines.push(this.$renderLinesFragment(e,t.lastRow+1,e.lastRow));},this.$renderLinesFragment=function(e,t,i){for(var n=[],r=t,o=this.session.getNextFoldLine(r),s=o?o.start.row:1/0;s<r&&(r=o.end.row+1,s=(o=this.session.getNextFoldLine(r,o))?o.start.row:1/0),!(i<r);){var a=this.$lines.createCell(r,e,this.session),l=a.element;this.dom.removeChildren(l),c.setStyle(l.style,"height",this.$lines.computeLineHeight(r,e,this.session)+"px"),c.setStyle(l.style,"top",this.$lines.computeLineTop(r,e,this.session)+"px"),this.$renderLine(l,r,r==s&&o),this.$useLineGroups()?l.className="ace_line_group":l.className="ace_line",n.push(a),r++;}return n;},this.update=function(e){this.$lines.moveContainer(e);for(var t=(this.config=e).firstRow,i=e.lastRow,n=this.$lines;n.getLength();){n.pop();}n.push(this.$renderLinesFragment(e,t,i));},this.$textToken={text:!0,rparen:!0,lparen:!0},this.$renderToken=function(e,t,i,n){for(var r,o,s=this,a=/(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g,l=this.dom.createFragment(this.element),c=0;r=a.exec(n);){var h,d,u,g=r[1],p=r[2],m=r[3],f=r[4],C=r[5];!s.showSpaces&&p||(h=c!=r.index?n.slice(c,r.index):"",c=r.index+r[0].length,h&&l.appendChild(this.dom.createTextNode(h,this.element)),g?(d=s.session.getScreenTabSize(t+r.index),l.appendChild(s.$tabStrings[d].cloneNode(!0)),t+=d-1):p?s.showSpaces?((u=this.dom.createElement("span")).className="ace_invisible ace_invisible_space",u.textContent=I.stringRepeat(s.SPACE_CHAR,p.length),l.appendChild(u)):l.appendChild(this.com.createTextNode(p,this.element)):m?((u=this.dom.createElement("span")).className="ace_invisible ace_invisible_space ace_invalid",u.textContent=I.stringRepeat(s.SPACE_CHAR,m.length),l.appendChild(u)):f?(t+=1,(u=this.dom.createElement("span")).style.width=2*s.config.characterWidth+"px",u.className=s.showSpaces?"ace_cjk ace_invisible ace_invisible_space":"ace_cjk",u.textContent=s.showSpaces?s.SPACE_CHAR:f,l.appendChild(u)):C&&(t+=1,(u=this.dom.createElement("span")).style.width=2*s.config.characterWidth+"px",u.className="ace_cjk",u.textContent=C,l.appendChild(u)));}return l.appendChild(this.dom.createTextNode(c?n.slice(c):n,this.element)),this.$textToken[i.type]?e.appendChild(l):(o="ace_"+i.type.replace(/\./g," ace_"),u=this.dom.createElement("span"),"fold"==i.type&&(u.style.width=i.value.length*this.config.characterWidth+"px"),u.className=o,u.appendChild(l),e.appendChild(u)),t+n.length;},this.renderIndentGuide=function(e,t,i){var n=t.search(this.$indentGuideRe);if(n<=0||i<=n)return t;if(" "==t[0]){for(var r=(n-=n%this.tabSize)/this.tabSize,o=0;o<r;o++){e.appendChild(this.$tabStrings[" "].cloneNode(!0));}return t.substr(n);}if("\t"!=t[0])return t;for(o=0;o<n;o++){e.appendChild(this.$tabStrings["\t"].cloneNode(!0));}return t.substr(n);},this.$createLineElement=function(e){var t=this.dom.createElement("div");return t.className="ace_line",t.style.height=this.config.lineHeight+"px",t;},this.$renderWrappedLine=function(e,t,i){var n=0,r=0,o=i[0],s=0,a=this.$createLineElement();e.appendChild(a);for(var l=0;l<t.length;l++){var c=t[l],h=c.value;if(0==l&&this.displayIndentGuides){if(n=h.length,!(h=this.renderIndentGuide(a,h,o)))continue;n-=h.length;}if(n+h.length<o)s=this.$renderToken(a,s,c,h),n+=h.length;else{for(;n+h.length>=o;){s=this.$renderToken(a,s,c,h.substring(0,o-n)),h=h.substring(o-n),n=o,a=this.$createLineElement(),e.appendChild(a),a.appendChild(this.dom.createTextNode(I.stringRepeat(" ",i.indent),this.element)),s=0,o=i[++r]||Number.MAX_VALUE;}0!=h.length&&(n+=h.length,s=this.$renderToken(a,s,c,h));}}i[i.length-1]>this.MAX_LINE_LENGTH&&this.$renderOverflowMessage(a,s,null,"",!0);},this.$renderSimpleLine=function(e,t){var i=0,n=t[0],r=n.value;this.displayIndentGuides&&(r=this.renderIndentGuide(e,r)),r&&(i=this.$renderToken(e,i,n,r));for(var o=1;o<t.length;o++){if(i+(r=(n=t[o]).value).length>this.MAX_LINE_LENGTH)return this.$renderOverflowMessage(e,i,n,r);i=this.$renderToken(e,i,n,r);}},this.$renderOverflowMessage=function(e,t,i,n,r){i&&this.$renderToken(e,t,i,n.slice(0,this.MAX_LINE_LENGTH-t));var o=this.dom.createElement("span");o.className="ace_inline_button ace_keyword ace_toggle_wrap",o.textContent=r?"<hide>":"<click to see more...>",e.appendChild(o);},this.$renderLine=function(e,t,i){var n;i||0==i||(i=this.session.getFoldLine(t));var r,o,s=e;(n=i?this.$getFoldLineTokens(t,i):this.session.getTokens(t)).length?(r=this.session.getRowSplitData(t))&&r.length?(this.$renderWrappedLine(e,n,r),s=e.lastChild):(s=e,this.$useLineGroups()&&(s=this.$createLineElement(),e.appendChild(s)),this.$renderSimpleLine(s,n)):this.$useLineGroups()&&(s=this.$createLineElement(),e.appendChild(s)),this.showEOL&&s&&(i&&(t=i.end.row),(o=this.dom.createElement("span")).className="ace_invisible ace_invisible_eol",o.textContent=t==this.session.getLength()-1?this.EOF_CHAR:this.EOL_CHAR,s.appendChild(o));},this.$getFoldLineTokens=function(e,t){var o=this.session,s=[];var a=o.getTokens(e);return t.walk(function(e,t,i,n,r){null!=e?s.push({type:"fold",value:e}):(r&&(a=o.getTokens(t)),a.length&&function(e,t,i){for(var n,r=0,o=0;o+e[r].value.length<t;){if(o+=e[r].value.length,++r==e.length)return;}for(o!=t&&((n=e[r].value.substring(t-o)).length>i-t&&(n=n.substring(0,i-t)),s.push({type:e[r].type,value:n}),o=t+n.length,r+=1);o<i&&r<e.length;){(n=e[r].value).length+o>i?s.push({type:e[r].type,value:n.substring(0,i-o)}):s.push(e[r]),o+=n.length,r+=1;}}(a,n,i));},t.end.row,this.session.getLine(t.end.row).length),s;},this.$useLineGroups=function(){return this.session.getUseWrapMode();},this.destroy=function(){};}).call(n.prototype),t.Text=n;}),ace.define("ace/layer/cursor",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";function n(e){this.element=c.createElement("div"),this.element.className="ace_layer ace_cursor-layer",e.appendChild(this.element),this.isVisible=!1,this.isBlinking=!0,this.blinkInterval=1e3,this.smoothBlinking=!1,this.cursors=[],this.cursor=this.addCursor(),c.addCssClass(this.element,"ace_hidden-cursors"),this.$updateCursors=this.$updateOpacity.bind(this);}var c=e("../lib/dom");(function(){this.$updateOpacity=function(e){for(var t=this.cursors,i=t.length;i--;){c.setStyle(t[i].style,"opacity",e?"":"0");}},this.$startCssAnimation=function(){for(var e=this.cursors,t=e.length;t--;){e[t].style.animationDuration=this.blinkInterval+"ms";}setTimeout(function(){c.addCssClass(this.element,"ace_animate-blinking");}.bind(this));},this.$stopCssAnimation=function(){c.removeCssClass(this.element,"ace_animate-blinking");},this.$padding=0,this.setPadding=function(e){this.$padding=e;},this.setSession=function(e){this.session=e;},this.setBlinking=function(e){e!=this.isBlinking&&(this.isBlinking=e,this.restartTimer());},this.setBlinkInterval=function(e){e!=this.blinkInterval&&(this.blinkInterval=e,this.restartTimer());},this.setSmoothBlinking=function(e){e!=this.smoothBlinking&&(this.smoothBlinking=e,c.setCssClass(this.element,"ace_smooth-blinking",e),this.$updateCursors(!0),this.restartTimer());},this.addCursor=function(){var e=c.createElement("div");return e.className="ace_cursor",this.element.appendChild(e),this.cursors.push(e),e;},this.removeCursor=function(){if(1<this.cursors.length){var e=this.cursors.pop();return e.parentNode.removeChild(e),e;}},this.hideCursor=function(){this.isVisible=!1,c.addCssClass(this.element,"ace_hidden-cursors"),this.restartTimer();},this.showCursor=function(){this.isVisible=!0,c.removeCssClass(this.element,"ace_hidden-cursors"),this.restartTimer();},this.restartTimer=function(){var e,t=this.$updateCursors;clearInterval(this.intervalId),clearTimeout(this.timeoutId),this.$stopCssAnimation(),this.smoothBlinking&&c.removeCssClass(this.element,"ace_smooth-blinking"),t(!0),this.isBlinking&&this.blinkInterval&&this.isVisible?(this.smoothBlinking&&setTimeout(function(){c.addCssClass(this.element,"ace_smooth-blinking");}.bind(this)),c.HAS_CSS_ANIMATION?this.$startCssAnimation():(e=function(){this.timeoutId=setTimeout(function(){t(!1);},.6*this.blinkInterval);}.bind(this),this.intervalId=setInterval(function(){t(!0),e();},this.blinkInterval),e())):this.$stopCssAnimation();},this.getPixelPosition=function(e,t){if(!this.config||!this.session)return{left:0,top:0};e=e||this.session.selection.getCursor();var i=this.session.documentToScreenPosition(e);return{left:this.$padding+(this.session.$bidiHandler.isBidiRow(i.row,e.row)?this.session.$bidiHandler.getPosLeft(i.column):i.column*this.config.characterWidth),top:(i.row-(t?this.config.firstRowScreen:0))*this.config.lineHeight};},this.isCursorInView=function(e,t){return 0<=e.top&&e.top<t.maxHeight;},this.update=function(e){this.config=e;var t=this.session.$selectionMarkers,i=0,n=0;void 0!==t&&0!==t.length||(t=[{cursor:null}]);for(var i=0,r=t.length;i<r;i++){var o,s,a=this.getPixelPosition(t[i].cursor,!0);(a.top>e.height+e.offset||a.top<0)&&1<i||(s=(o=this.cursors[n++]||this.addCursor()).style,this.drawCursor?this.drawCursor(o,a,e,t[i],this.session):this.isCursorInView(a,e)?(c.setStyle(s,"display","block"),c.translate(o,a.left,a.top),c.setStyle(s,"width",Math.round(e.characterWidth)+"px"),c.setStyle(s,"height",e.lineHeight+"px")):c.setStyle(s,"display","none"));}for(;this.cursors.length>n;){this.removeCursor();}var l=this.session.getOverwrite();this.$setOverwrite(l),this.$pixelPos=a,this.restartTimer();},this.drawCursor=null,this.$setOverwrite=function(e){e!=this.overwrite&&((this.overwrite=e)?c.addCssClass(this.element,"ace_overwrite-cursors"):c.removeCssClass(this.element,"ace_overwrite-cursors"));},this.destroy=function(){clearInterval(this.intervalId),clearTimeout(this.timeoutId);};}).call(n.prototype),t.Cursor=n;}),ace.define("ace/scrollbar",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"],function(e,t,i){"use strict";function n(e){this.element=o.createElement("div"),this.element.className="ace_scrollbar ace_scrollbar"+this.classSuffix,this.inner=o.createElement("div"),this.inner.className="ace_scrollbar-inner",this.inner.textContent=" ",this.element.appendChild(this.inner),e.appendChild(this.element),this.setVisible(!1),this.skipEvent=!1,s.addListener(this.element,"scroll",this.onScroll.bind(this)),s.addListener(this.element,"mousedown",s.preventDefault);}var r=e("./lib/oop"),o=e("./lib/dom"),s=e("./lib/event"),a=e("./lib/event_emitter").EventEmitter;(function(){r.implement(this,a),this.setVisible=function(e){this.element.style.display=e?"":"none",this.isVisible=e,this.coeff=1;};}).call(n.prototype);function l(e,t){n.call(this,e),this.scrollTop=0,this.scrollHeight=0,t.$scrollbarWidth=this.width=o.scrollbarWidth(e.ownerDocument),this.inner.style.width=this.element.style.width=(this.width||15)+5+"px",this.$minWidth=0;}r.inherits(l,n),function(){this.classSuffix="-v",this.onScroll=function(){var e;this.skipEvent||(this.scrollTop=this.element.scrollTop,1!=this.coeff&&(e=this.element.clientHeight/this.scrollHeight,this.scrollTop=this.scrollTop*(1-e)/(this.coeff-e)),this._emit("scroll",{data:this.scrollTop})),this.skipEvent=!1;},this.getWidth=function(){return Math.max(this.isVisible?this.width:0,this.$minWidth||0);},this.setHeight=function(e){this.element.style.height=e+"px";},this.setInnerHeight=this.setScrollHeight=function(e){32768<(this.scrollHeight=e)?(this.coeff=32768/e,e=32768):1!=this.coeff&&(this.coeff=1),this.inner.style.height=e+"px";},this.setScrollTop=function(e){this.scrollTop!=e&&(this.skipEvent=!0,this.scrollTop=e,this.element.scrollTop=e*this.coeff);};}.call(l.prototype);function c(e,t){n.call(this,e),this.scrollLeft=0,this.height=t.$scrollbarWidth,this.inner.style.height=this.element.style.height=(this.height||15)+5+"px";}r.inherits(c,n),function(){this.classSuffix="-h",this.onScroll=function(){this.skipEvent||(this.scrollLeft=this.element.scrollLeft,this._emit("scroll",{data:this.scrollLeft})),this.skipEvent=!1;},this.getHeight=function(){return this.isVisible?this.height:0;},this.setWidth=function(e){this.element.style.width=e+"px";},this.setInnerWidth=function(e){this.inner.style.width=e+"px";},this.setScrollWidth=function(e){this.inner.style.width=e+"px";},this.setScrollLeft=function(e){this.scrollLeft!=e&&(this.skipEvent=!0,this.scrollLeft=this.element.scrollLeft=e);};}.call(c.prototype),t.ScrollBar=l,t.ScrollBarV=l,t.ScrollBarH=c,t.VScrollBar=l,t.HScrollBar=c;}),ace.define("ace/renderloop",["require","exports","module","ace/lib/event"],function(e,t,i){"use strict";function n(e,t){this.onRender=e,this.pending=!1,this.changes=0,this.$recursionLimit=2,this.window=t||window;var i=this;this._flush=function(e){i.pending=!1;var t=i.changes;if(t&&(r.blockIdle(100),i.changes=0,i.onRender(t)),i.changes){if(i.$recursionLimit--<0)return;i.schedule();}else i.$recursionLimit=2;};}var r=e("./lib/event");(function(){this.schedule=function(e){this.changes=this.changes|e,this.changes&&!this.pending&&(r.nextFrame(this._flush),this.pending=!0);},this.clear=function(e){var t=this.changes;return this.changes=0,t;};}).call(n.prototype),t.RenderLoop=n;}),ace.define("ace/layer/font_metrics",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/event","ace/lib/useragent","ace/lib/event_emitter"],function(e,t,i){var n=e("../lib/oop"),r=e("../lib/dom"),o=e("../lib/lang"),s=e("../lib/event"),a=e("../lib/useragent"),l=e("../lib/event_emitter").EventEmitter,c="function"==typeof ResizeObserver,h=t.FontMetrics=function(e){this.el=r.createElement("div"),this.$setMeasureNodeStyles(this.el.style,!0),this.$main=r.createElement("div"),this.$setMeasureNodeStyles(this.$main.style),this.$measureNode=r.createElement("div"),this.$setMeasureNodeStyles(this.$measureNode.style),this.el.appendChild(this.$main),this.el.appendChild(this.$measureNode),e.appendChild(this.el),this.$measureNode.textContent=o.stringRepeat("X",256),this.$characterSize={width:0,height:0},c?this.$addObserver():this.checkForSizeChanges();};(function(){n.implement(this,l),this.$characterSize={width:0,height:0},this.$setMeasureNodeStyles=function(e,t){e.width=e.height="auto",e.left=e.top="0px",e.visibility="hidden",e.position="absolute",e.whiteSpace="pre",a.isIE<8?e["font-family"]="inherit":e.font="inherit",e.overflow=t?"hidden":"visible";},this.checkForSizeChanges=function(e){var t;void 0===e&&(e=this.$measureSizes()),!e||this.$characterSize.width===e.width&&this.$characterSize.height===e.height||(this.$measureNode.style.fontWeight="bold",t=this.$measureSizes(),this.$measureNode.style.fontWeight="",this.$characterSize=e,this.charSizes=Object.create(null),this.allowBoldFonts=t&&t.width===e.width&&t.height===e.height,this._emit("changeCharacterSize",{data:e}));},this.$addObserver=function(){var t=this;this.$observer=new window.ResizeObserver(function(e){t.checkForSizeChanges();}),this.$observer.observe(this.$measureNode);},this.$pollSizeChanges=function(){if(this.$pollSizeChangesTimer||this.$observer)return this.$pollSizeChangesTimer;var t=this;return this.$pollSizeChangesTimer=s.onIdle(function e(){t.checkForSizeChanges(),s.onIdle(e,500);},500);},this.setPolling=function(e){e?this.$pollSizeChanges():this.$pollSizeChangesTimer&&(clearInterval(this.$pollSizeChangesTimer),this.$pollSizeChangesTimer=0);},this.$measureSizes=function(e){var t={height:(e||this.$measureNode).clientHeight,width:(e||this.$measureNode).clientWidth/256};return 0===t.width||0===t.height?null:t;},this.$measureCharWidth=function(e){return this.$main.textContent=o.stringRepeat(e,256),this.$main.getBoundingClientRect().width/256;},this.getCharacterWidth=function(e){var t=this.charSizes[e];return void 0===t&&(t=this.charSizes[e]=this.$measureCharWidth(e)/this.$characterSize.width),t;},this.destroy=function(){clearInterval(this.$pollSizeChangesTimer),this.$observer&&this.$observer.disconnect(),this.el&&this.el.parentNode&&this.el.parentNode.removeChild(this.el);},this.$getZoom=function e(t){return t?(window.getComputedStyle(t).zoom||1)*e(t.parentElement):1;},this.$initTransformMeasureNodes=function(){function e(e,t){return["div",{style:"position: absolute;top:"+e+"px;left:"+t+"px;"}];}this.els=r.buildDom([e(0,0),e(200,0),e(0,200),e(200,200)],this.el);},this.transformCoordinates=function(e,t){function i(e,t,i){var n=e[1]*t[0]-e[0]*t[1];return[(-t[1]*i[0]+t[0]*i[1])/n,(e[1]*i[0]-e[0]*i[1])/n];}function n(e,t){return[e[0]-t[0],e[1]-t[1]];}function r(e,t){return[e[0]+t[0],e[1]+t[1]];}function o(e,t){return[e*t[0],e*t[1]];}function s(e){var t=e.getBoundingClientRect();return[t.left,t.top];}e=e&&o(1/this.$getZoom(this.el),e),this.els||this.$initTransformMeasureNodes();var a=s(this.els[0]),l=s(this.els[1]),c=s(this.els[2]),h=s(this.els[3]),d=i(n(h,l),n(h,c),n(r(l,c),r(h,a))),u=o(1+d[0],n(l,a)),g=o(1+d[1],n(c,a));if(t){var p=d[0]*t[0]/200+d[1]*t[1]/200+1,m=r(o(t[0],u),o(t[1],g));return r(o(1/p/200,m),a);}var f=n(e,a),C=i(n(u,o(d[0],f)),n(g,o(d[1],f)),f);return o(200,C);};}).call(h.prototype);}),ace.define("ace/virtual_renderer",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/config","ace/layer/gutter","ace/layer/marker","ace/layer/text","ace/layer/cursor","ace/scrollbar","ace/scrollbar","ace/renderloop","ace/layer/font_metrics","ace/lib/event_emitter","ace/lib/useragent"],function(e,t,i){"use strict";var n=e("./lib/oop"),h=e("./lib/dom"),o=e("./config"),r=e("./layer/gutter").Gutter,s=e("./layer/marker").Marker,a=e("./layer/text").Text,l=e("./layer/cursor").Cursor,c=e("./scrollbar").HScrollBar,d=e("./scrollbar").VScrollBar,u=e("./renderloop").RenderLoop,g=e("./layer/font_metrics").FontMetrics,p=e("./lib/event_emitter").EventEmitter,m='.ace_br1 {border-top-left-radius    : 3px;}.ace_br2 {border-top-right-radius   : 3px;}.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}.ace_br4 {border-bottom-right-radius: 3px;}.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}.ace_br8 {border-bottom-left-radius : 3px;}.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}.ace_editor {position: relative;overflow: hidden;padding: 0;font: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'source-code-pro\', monospace;direction: ltr;text-align: left;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);}.ace_scroller {position: absolute;overflow: hidden;top: 0;bottom: 0;background-color: inherit;-ms-user-select: none;-moz-user-select: none;-webkit-user-select: none;user-select: none;cursor: text;}.ace_content {position: absolute;box-sizing: border-box;min-width: 100%;contain: style size layout;font-variant-ligatures: no-common-ligatures;}.ace_dragging .ace_scroller:before{position: absolute;top: 0;left: 0;right: 0;bottom: 0;content: \'\';background: rgba(250, 250, 250, 0.01);z-index: 1000;}.ace_dragging.ace_dark .ace_scroller:before{background: rgba(0, 0, 0, 0.01);}.ace_selecting, .ace_selecting * {cursor: text !important;}.ace_gutter {position: absolute;overflow : hidden;width: auto;top: 0;bottom: 0;left: 0;cursor: default;z-index: 4;-ms-user-select: none;-moz-user-select: none;-webkit-user-select: none;user-select: none;contain: style size layout;}.ace_gutter-active-line {position: absolute;left: 0;right: 0;}.ace_scroller.ace_scroll-left {box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;}.ace_gutter-cell {position: absolute;top: 0;left: 0;right: 0;padding-left: 19px;padding-right: 6px;background-repeat: no-repeat;}.ace_gutter-cell.ace_error {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");background-repeat: no-repeat;background-position: 2px center;}.ace_gutter-cell.ace_warning {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");background-position: 2px center;}.ace_gutter-cell.ace_info {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");background-position: 2px center;}.ace_dark .ace_gutter-cell.ace_info {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");}.ace_scrollbar {contain: strict;position: absolute;right: 0;bottom: 0;z-index: 6;}.ace_scrollbar-inner {position: absolute;cursor: text;left: 0;top: 0;}.ace_scrollbar-v{overflow-x: hidden;overflow-y: scroll;top: 0;}.ace_scrollbar-h {overflow-x: scroll;overflow-y: hidden;left: 0;}.ace_print-margin {position: absolute;height: 100%;}.ace_text-input {position: absolute;z-index: 0;width: 0.5em;height: 1em;opacity: 0;background: transparent;-moz-appearance: none;appearance: none;border: none;resize: none;outline: none;overflow: hidden;font: inherit;padding: 0 1px;margin: 0 -1px;contain: strict;-ms-user-select: text;-moz-user-select: text;-webkit-user-select: text;user-select: text;white-space: pre!important;}.ace_text-input.ace_composition {background: transparent;color: inherit;z-index: 1000;opacity: 1;}.ace_composition_placeholder { color: transparent }.ace_composition_marker { border-bottom: 1px solid;position: absolute;border-radius: 0;margin-top: 1px;}[ace_nocontext=true] {transform: none!important;filter: none!important;clip-path: none!important;mask : none!important;contain: none!important;perspective: none!important;mix-blend-mode: initial!important;z-index: auto;}.ace_layer {z-index: 1;position: absolute;overflow: hidden;word-wrap: normal;white-space: pre;height: 100%;width: 100%;box-sizing: border-box;pointer-events: none;}.ace_gutter-layer {position: relative;width: auto;text-align: right;pointer-events: auto;height: 1000000px;contain: style size layout;}.ace_text-layer {font: inherit !important;position: absolute;height: 1000000px;width: 1000000px;contain: style size layout;}.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {contain: style size layout;position: absolute;top: 0;left: 0;right: 0;}.ace_hidpi .ace_text-layer,.ace_hidpi .ace_gutter-layer,.ace_hidpi .ace_content,.ace_hidpi .ace_gutter {contain: strict;will-change: transform;}.ace_hidpi .ace_text-layer > .ace_line, .ace_hidpi .ace_text-layer > .ace_line_group {contain: strict;}.ace_cjk {display: inline-block;text-align: center;}.ace_cursor-layer {z-index: 4;}.ace_cursor {z-index: 4;position: absolute;box-sizing: border-box;border-left: 2px solid;transform: translatez(0);}.ace_multiselect .ace_cursor {border-left-width: 1px;}.ace_slim-cursors .ace_cursor {border-left-width: 1px;}.ace_overwrite-cursors .ace_cursor {border-left-width: 0;border-bottom: 1px solid;}.ace_hidden-cursors .ace_cursor {opacity: 0.2;}.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {opacity: 0;}.ace_smooth-blinking .ace_cursor {transition: opacity 0.18s;}.ace_animate-blinking .ace_cursor {animation-duration: 1000ms;animation-timing-function: step-end;animation-name: blink-ace-animate;animation-iteration-count: infinite;}.ace_animate-blinking.ace_smooth-blinking .ace_cursor {animation-duration: 1000ms;animation-timing-function: ease-in-out;animation-name: blink-ace-animate-smooth;}@keyframes blink-ace-animate {from, to { opacity: 1; }60% { opacity: 0; }}@keyframes blink-ace-animate-smooth {from, to { opacity: 1; }45% { opacity: 1; }60% { opacity: 0; }85% { opacity: 0; }}.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {position: absolute;z-index: 3;}.ace_marker-layer .ace_selection {position: absolute;z-index: 5;}.ace_marker-layer .ace_bracket {position: absolute;z-index: 6;}.ace_marker-layer .ace_error_bracket {position: absolute;border-bottom: 1px solid #DE5555;border-radius: 0;}.ace_marker-layer .ace_active-line {position: absolute;z-index: 2;}.ace_marker-layer .ace_selected-word {position: absolute;z-index: 4;box-sizing: border-box;}.ace_line .ace_fold {box-sizing: border-box;display: inline-block;height: 11px;margin-top: -2px;vertical-align: middle;background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");background-repeat: no-repeat, repeat-x;background-position: center center, top left;color: transparent;border: 1px solid black;border-radius: 2px;cursor: pointer;pointer-events: auto;}.ace_dark .ace_fold {}.ace_fold:hover{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");}.ace_tooltip {background-color: #FFF;background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));border: 1px solid gray;border-radius: 1px;box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);color: black;max-width: 100%;padding: 3px 4px;position: fixed;z-index: 999999;box-sizing: border-box;cursor: default;white-space: pre;word-wrap: break-word;line-height: normal;font-style: normal;font-weight: normal;letter-spacing: normal;pointer-events: none;}.ace_folding-enabled > .ace_gutter-cell {padding-right: 13px;}.ace_fold-widget {box-sizing: border-box;margin: 0 -12px 0 1px;display: none;width: 11px;vertical-align: top;background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");background-repeat: no-repeat;background-position: center;border-radius: 3px;border: 1px solid transparent;cursor: pointer;}.ace_folding-enabled .ace_fold-widget {display: inline-block;   }.ace_fold-widget.ace_end {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");}.ace_fold-widget.ace_closed {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");}.ace_fold-widget:hover {border: 1px solid rgba(0, 0, 0, 0.3);background-color: rgba(255, 255, 255, 0.2);box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);}.ace_fold-widget:active {border: 1px solid rgba(0, 0, 0, 0.4);background-color: rgba(0, 0, 0, 0.05);box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);}.ace_dark .ace_fold-widget {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");}.ace_dark .ace_fold-widget.ace_end {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");}.ace_dark .ace_fold-widget.ace_closed {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");}.ace_dark .ace_fold-widget:hover {box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);background-color: rgba(255, 255, 255, 0.1);}.ace_dark .ace_fold-widget:active {box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);}.ace_inline_button {border: 1px solid lightgray;display: inline-block;margin: -1px 8px;padding: 0 5px;pointer-events: auto;cursor: pointer;}.ace_inline_button:hover {border-color: gray;background: rgba(200,200,200,0.2);display: inline-block;pointer-events: auto;}.ace_fold-widget.ace_invalid {background-color: #FFB4B4;border-color: #DE5555;}.ace_fade-fold-widgets .ace_fold-widget {transition: opacity 0.4s ease 0.05s;opacity: 0;}.ace_fade-fold-widgets:hover .ace_fold-widget {transition: opacity 0.05s ease 0.05s;opacity:1;}.ace_underline {text-decoration: underline;}.ace_bold {font-weight: bold;}.ace_nobold .ace_bold {font-weight: normal;}.ace_italic {font-style: italic;}.ace_error-marker {background-color: rgba(255, 0, 0,0.2);position: absolute;z-index: 9;}.ace_highlight-marker {background-color: rgba(255, 255, 0,0.2);position: absolute;z-index: 8;}.ace_mobile-menu {position: absolute;line-height: 1.5;border-radius: 4px;-ms-user-select: none;-moz-user-select: none;-webkit-user-select: none;user-select: none;background: white;box-shadow: 1px 3px 2px grey;border: 1px solid #dcdcdc;color: black;}.ace_dark > .ace_mobile-menu {background: #333;color: #ccc;box-shadow: 1px 3px 2px grey;border: 1px solid #444;}.ace_mobile-button {padding: 2px;cursor: pointer;overflow: hidden;}.ace_mobile-button:hover {background-color: #eee;opacity:1;}.ace_mobile-button:active {background-color: #ddd;}.ace_placeholder {font-family: arial;transform: scale(0.9);transform-origin: left;white-space: pre;opacity: 0.7;margin: 0 10px;}',f=e("./lib/useragent"),C=f.isIE;h.importCssString(m,"ace_editor.css");function I(e,t){var i=this;this.container=e||h.createElement("div"),h.addCssClass(this.container,"ace_editor"),h.HI_DPI&&h.addCssClass(this.container,"ace_hidpi"),this.setTheme(t),this.$gutter=h.createElement("div"),this.$gutter.className="ace_gutter",this.container.appendChild(this.$gutter),this.$gutter.setAttribute("aria-hidden",!0),this.scroller=h.createElement("div"),this.scroller.className="ace_scroller",this.container.appendChild(this.scroller),this.content=h.createElement("div"),this.content.className="ace_content",this.scroller.appendChild(this.content),this.$gutterLayer=new r(this.$gutter),this.$gutterLayer.on("changeGutterWidth",this.onGutterResize.bind(this)),this.$markerBack=new s(this.content);var n=this.$textLayer=new a(this.content);this.canvas=n.element,this.$markerFront=new s(this.content),this.$cursorLayer=new l(this.content),this.$horizScroll=!1,this.$vScroll=!1,this.scrollBar=this.scrollBarV=new d(this.container,this),this.scrollBarH=new c(this.container,this),this.scrollBarV.on("scroll",function(e){i.$scrollAnimation||i.session.setScrollTop(e.data-i.scrollMargin.top);}),this.scrollBarH.on("scroll",function(e){i.$scrollAnimation||i.session.setScrollLeft(e.data-i.scrollMargin.left);}),this.scrollTop=0,this.scrollLeft=0,this.cursorPos={row:0,column:0},this.$fontMetrics=new g(this.container),this.$textLayer.$setFontMetrics(this.$fontMetrics),this.$textLayer.on("changeCharacterSize",function(e){i.updateCharacterSize(),i.onResize(!0,i.gutterWidth,i.$size.width,i.$size.height),i._signal("changeCharacterSize",e);}),this.$size={width:0,height:0,scrollerHeight:0,scrollerWidth:0,$dirty:!0},this.layerConfig={width:1,padding:0,firstRow:0,firstRowScreen:0,lastRow:0,lineHeight:0,characterWidth:0,minHeight:1,maxHeight:1,offset:0,height:1,gutterOffset:1},this.scrollMargin={left:0,right:0,top:0,bottom:0,v:0,h:0},this.margin={left:0,right:0,top:0,bottom:0,v:0,h:0},this.$keepTextAreaAtCursor=!f.isIOS,this.$loop=new u(this.$renderChanges.bind(this),this.container.ownerDocument.defaultView),this.$loop.schedule(this.CHANGE_FULL),this.updateCharacterSize(),this.setPadding(4),o.resetOptions(this),o._signal("renderer",this);}(function(){this.CHANGE_CURSOR=1,this.CHANGE_MARKER=2,this.CHANGE_GUTTER=4,this.CHANGE_SCROLL=8,this.CHANGE_LINES=16,this.CHANGE_TEXT=32,this.CHANGE_SIZE=64,this.CHANGE_MARKER_BACK=128,this.CHANGE_MARKER_FRONT=256,this.CHANGE_FULL=512,this.CHANGE_H_SCROLL=1024,n.implement(this,p),this.updateCharacterSize=function(){this.$textLayer.allowBoldFonts!=this.$allowBoldFonts&&(this.$allowBoldFonts=this.$textLayer.allowBoldFonts,this.setStyle("ace_nobold",!this.$allowBoldFonts)),this.layerConfig.characterWidth=this.characterWidth=this.$textLayer.getCharacterWidth(),this.layerConfig.lineHeight=this.lineHeight=this.$textLayer.getLineHeight(),this.$updatePrintMargin(),h.setStyle(this.scroller.style,"line-height",this.lineHeight+"px");},this.setSession=function(e){this.session&&this.session.doc.off("changeNewLineMode",this.onChangeNewLineMode),(this.session=e)&&this.scrollMargin.top&&e.getScrollTop()<=0&&e.setScrollTop(-this.scrollMargin.top),this.$cursorLayer.setSession(e),this.$markerBack.setSession(e),this.$markerFront.setSession(e),this.$gutterLayer.setSession(e),this.$textLayer.setSession(e),e&&(this.$loop.schedule(this.CHANGE_FULL),this.session.$setFontMetrics(this.$fontMetrics),this.scrollBarH.scrollLeft=this.scrollBarV.scrollTop=null,this.onChangeNewLineMode=this.onChangeNewLineMode.bind(this),this.onChangeNewLineMode(),this.session.doc.on("changeNewLineMode",this.onChangeNewLineMode));},this.updateLines=function(e,t,i){if(void 0===t&&(t=1/0),this.$changedLines?(this.$changedLines.firstRow>e&&(this.$changedLines.firstRow=e),this.$changedLines.lastRow<t&&(this.$changedLines.lastRow=t)):this.$changedLines={firstRow:e,lastRow:t},this.$changedLines.lastRow<this.layerConfig.firstRow){if(!i)return;this.$changedLines.lastRow=this.layerConfig.lastRow;}this.$changedLines.firstRow>this.layerConfig.lastRow||this.$loop.schedule(this.CHANGE_LINES);},this.onChangeNewLineMode=function(){this.$loop.schedule(this.CHANGE_TEXT),this.$textLayer.$updateEolChar(),this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR);},this.onChangeTabSize=function(){this.$loop.schedule(this.CHANGE_TEXT|this.CHANGE_MARKER),this.$textLayer.onChangeTabSize();},this.updateText=function(){this.$loop.schedule(this.CHANGE_TEXT);},this.updateFull=function(e){e?this.$renderChanges(this.CHANGE_FULL,!0):this.$loop.schedule(this.CHANGE_FULL);},this.updateFontSize=function(){this.$textLayer.checkForSizeChanges();},this.$changes=0,this.$updateSizeAsync=function(){this.$loop.pending?this.$size.$dirty=!0:this.onResize();},this.onResize=function(e,t,i,n){if(!(2<this.resizing)){0<this.resizing?this.resizing++:this.resizing=e?1:0;var r=this.container;n=n||r.clientHeight||r.scrollHeight,i=i||r.clientWidth||r.scrollWidth;var o=this.$updateCachedSize(e,t,i,n);if(!this.$size.scrollerHeight||!i&&!n)return this.resizing=0;e&&(this.$gutterLayer.$padding=null),e?this.$renderChanges(o|this.$changes,!0):this.$loop.schedule(o|this.$changes),this.resizing&&(this.resizing=0),this.scrollBarV.scrollLeft=this.scrollBarV.scrollTop=null;}},this.$updateCachedSize=function(e,t,i,n){n-=this.$extraHeight||0;var r,o=0,s=this.$size,a={width:s.width,height:s.height,scrollerHeight:s.scrollerHeight,scrollerWidth:s.scrollerWidth};return n&&(e||s.height!=n)&&(s.height=n,o|=this.CHANGE_SIZE,s.scrollerHeight=s.height,this.$horizScroll&&(s.scrollerHeight-=this.scrollBarH.getHeight()),this.scrollBarV.element.style.bottom=this.scrollBarH.getHeight()+"px",o|=this.CHANGE_SCROLL),i&&(e||s.width!=i)&&(o|=this.CHANGE_SIZE,s.width=i,null==t&&(t=this.$showGutter?this.$gutter.offsetWidth:0),this.gutterWidth=t,h.setStyle(this.scrollBarH.element.style,"left",t+"px"),h.setStyle(this.scroller.style,"left",t+this.margin.left+"px"),s.scrollerWidth=Math.max(0,i-t-this.scrollBarV.getWidth()-this.margin.h),h.setStyle(this.$gutter.style,"left",this.margin.left+"px"),r=this.scrollBarV.getWidth()+"px",h.setStyle(this.scrollBarH.element.style,"right",r),h.setStyle(this.scroller.style,"right",r),h.setStyle(this.scroller.style,"bottom",this.scrollBarH.getHeight()),(this.session&&this.session.getUseWrapMode()&&this.adjustWrapLimit()||e)&&(o|=this.CHANGE_FULL)),s.$dirty=!i||!n,o&&this._signal("resize",a),o;},this.onGutterResize=function(e){var t=this.$showGutter?e:0;t!=this.gutterWidth&&(this.$changes|=this.$updateCachedSize(!0,t,this.$size.width,this.$size.height)),this.session.getUseWrapMode()&&this.adjustWrapLimit()||this.$size.$dirty?this.$loop.schedule(this.CHANGE_FULL):this.$computeLayerConfig();},this.adjustWrapLimit=function(){var e=this.$size.scrollerWidth-2*this.$padding,t=Math.floor(e/this.characterWidth);return this.session.adjustWrapLimit(t,this.$showPrintMargin&&this.$printMarginColumn);},this.setAnimatedScroll=function(e){this.setOption("animatedScroll",e);},this.getAnimatedScroll=function(){return this.$animatedScroll;},this.setShowInvisibles=function(e){this.setOption("showInvisibles",e),this.session.$bidiHandler.setShowInvisibles(e);},this.getShowInvisibles=function(){return this.getOption("showInvisibles");},this.getDisplayIndentGuides=function(){return this.getOption("displayIndentGuides");},this.setDisplayIndentGuides=function(e){this.setOption("displayIndentGuides",e);},this.setShowPrintMargin=function(e){this.setOption("showPrintMargin",e);},this.getShowPrintMargin=function(){return this.getOption("showPrintMargin");},this.setPrintMarginColumn=function(e){this.setOption("printMarginColumn",e);},this.getPrintMarginColumn=function(){return this.getOption("printMarginColumn");},this.getShowGutter=function(){return this.getOption("showGutter");},this.setShowGutter=function(e){return this.setOption("showGutter",e);},this.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets");},this.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e);},this.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e);},this.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine");},this.$updatePrintMargin=function(){var e,t;(this.$showPrintMargin||this.$printMarginEl)&&(this.$printMarginEl||((e=h.createElement("div")).className="ace_layer ace_print-margin-layer",this.$printMarginEl=h.createElement("div"),this.$printMarginEl.className="ace_print-margin",e.appendChild(this.$printMarginEl),this.content.insertBefore(e,this.content.firstChild)),(t=this.$printMarginEl.style).left=Math.round(this.characterWidth*this.$printMarginColumn+this.$padding)+"px",t.visibility=this.$showPrintMargin?"visible":"hidden",this.session&&-1==this.session.$wrap&&this.adjustWrapLimit());},this.getContainerElement=function(){return this.container;},this.getMouseEventTarget=function(){return this.scroller;},this.getTextAreaContainer=function(){return this.container;},this.$moveTextAreaToCursor=function(){var e,t,i,n,r,o,s,a,l,c;this.$isMousePressed||(e=this.textarea.style,t=this.$composition,this.$keepTextAreaAtCursor||t?(i=this.$cursorLayer.$pixelPos)&&(t&&t.markerRange&&(i=this.$cursorLayer.getPixelPosition(t.markerRange.start,!0)),n=this.layerConfig,r=i.top,o=i.left,r-=n.offset,s=t&&t.useTextareaForIME?this.lineHeight:C?0:1,r<0||r>n.height-s?h.translate(this.textarea,0,0):(c=1,a=this.$size.height-s,t?t.useTextareaForIME?(l=this.textarea.value,c=this.characterWidth*this.session.$getStringScreenWidth(l)[0]):r+=this.lineHeight+2:r+=this.lineHeight,(o-=this.scrollLeft)>this.$size.scrollerWidth-c&&(o=this.$size.scrollerWidth-c),o+=this.gutterWidth+this.margin.left,h.setStyle(e,"height",s+"px"),h.setStyle(e,"width",c+"px"),h.translate(this.textarea,Math.min(o,this.$size.scrollerWidth-c),Math.min(r,a)))):h.translate(this.textarea,-100,0));},this.getFirstVisibleRow=function(){return this.layerConfig.firstRow;},this.getFirstFullyVisibleRow=function(){return this.layerConfig.firstRow+(0===this.layerConfig.offset?0:1);},this.getLastFullyVisibleRow=function(){var e=this.layerConfig,t=e.lastRow;return this.session.documentToScreenRow(t,0)*e.lineHeight-this.session.getScrollTop()>e.height-e.lineHeight?t-1:t;},this.getLastVisibleRow=function(){return this.layerConfig.lastRow;},this.$padding=null,this.setPadding=function(e){this.$padding=e,this.$textLayer.setPadding(e),this.$cursorLayer.setPadding(e),this.$markerFront.setPadding(e),this.$markerBack.setPadding(e),this.$loop.schedule(this.CHANGE_FULL),this.$updatePrintMargin();},this.setScrollMargin=function(e,t,i,n){var r=this.scrollMargin;r.top=0|e,r.bottom=0|t,r.right=0|n,r.left=0|i,r.v=r.top+r.bottom,r.h=r.left+r.right,r.top&&this.scrollTop<=0&&this.session&&this.session.setScrollTop(-r.top),this.updateFull();},this.setMargin=function(e,t,i,n){var r=this.margin;r.top=0|e,r.bottom=0|t,r.right=0|n,r.left=0|i,r.v=r.top+r.bottom,r.h=r.left+r.right,this.$updateCachedSize(!0,this.gutterWidth,this.$size.width,this.$size.height),this.updateFull();},this.getHScrollBarAlwaysVisible=function(){return this.$hScrollBarAlwaysVisible;},this.setHScrollBarAlwaysVisible=function(e){this.setOption("hScrollBarAlwaysVisible",e);},this.getVScrollBarAlwaysVisible=function(){return this.$vScrollBarAlwaysVisible;},this.setVScrollBarAlwaysVisible=function(e){this.setOption("vScrollBarAlwaysVisible",e);},this.$updateScrollBarV=function(){var e=this.layerConfig.maxHeight,t=this.$size.scrollerHeight;!this.$maxLines&&this.$scrollPastEnd&&(e-=(t-this.lineHeight)*this.$scrollPastEnd,this.scrollTop>e-t&&(e=this.scrollTop+t,this.scrollBarV.scrollTop=null)),this.scrollBarV.setScrollHeight(e+this.scrollMargin.v),this.scrollBarV.setScrollTop(this.scrollTop+this.scrollMargin.top);},this.$updateScrollBarH=function(){this.scrollBarH.setScrollWidth(this.layerConfig.width+2*this.$padding+this.scrollMargin.h),this.scrollBarH.setScrollLeft(this.scrollLeft+this.scrollMargin.left);},this.$frozen=!1,this.freeze=function(){this.$frozen=!0;},this.unfreeze=function(){this.$frozen=!1;},this.$renderChanges=function(e,t){if(this.$changes&&(e|=this.$changes,this.$changes=0),this.session&&this.container.offsetWidth&&!this.$frozen&&(e||t)){if(this.$size.$dirty)return this.$changes|=e,this.onResize(!0);this.lineHeight||this.$textLayer.checkForSizeChanges(),this._signal("beforeRender",e),this.session&&this.session.$bidiHandler&&this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);var i,n,r,o=this.layerConfig;if((e&this.CHANGE_FULL||e&this.CHANGE_SIZE||e&this.CHANGE_TEXT||e&this.CHANGE_LINES||e&this.CHANGE_SCROLL||e&this.CHANGE_H_SCROLL)&&(e|=this.$computeLayerConfig()|this.$loop.clear(),o.firstRow==this.layerConfig.firstRow||o.firstRowScreen!=this.layerConfig.firstRowScreen||0<(i=this.scrollTop+(o.firstRow-this.layerConfig.firstRow)*this.lineHeight)&&(this.scrollTop=i,e|=this.CHANGE_SCROLL,e|=this.$computeLayerConfig()|this.$loop.clear()),o=this.layerConfig,this.$updateScrollBarV(),e&this.CHANGE_H_SCROLL&&this.$updateScrollBarH(),h.translate(this.content,-this.scrollLeft,-o.offset),n=o.width+2*this.$padding+"px",r=o.minHeight+"px",h.setStyle(this.content.style,"width",n),h.setStyle(this.content.style,"height",r)),e&this.CHANGE_H_SCROLL&&(h.translate(this.content,-this.scrollLeft,-o.offset),this.scroller.className=this.scrollLeft<=0?"ace_scroller":"ace_scroller ace_scroll-left"),e&this.CHANGE_FULL)return this.$changedLines=null,this.$textLayer.update(o),this.$showGutter&&this.$gutterLayer.update(o),this.$markerBack.update(o),this.$markerFront.update(o),this.$cursorLayer.update(o),this.$moveTextAreaToCursor(),void this._signal("afterRender",e);if(e&this.CHANGE_SCROLL)return this.$changedLines=null,e&this.CHANGE_TEXT||e&this.CHANGE_LINES?this.$textLayer.update(o):this.$textLayer.scrollLines(o),this.$showGutter&&(e&this.CHANGE_GUTTER||e&this.CHANGE_LINES?this.$gutterLayer.update(o):this.$gutterLayer.scrollLines(o)),this.$markerBack.update(o),this.$markerFront.update(o),this.$cursorLayer.update(o),this.$moveTextAreaToCursor(),void this._signal("afterRender",e);e&this.CHANGE_TEXT?(this.$changedLines=null,this.$textLayer.update(o),this.$showGutter&&this.$gutterLayer.update(o)):e&this.CHANGE_LINES?(this.$updateLines()||e&this.CHANGE_GUTTER&&this.$showGutter)&&this.$gutterLayer.update(o):e&this.CHANGE_TEXT||e&this.CHANGE_GUTTER?this.$showGutter&&this.$gutterLayer.update(o):e&this.CHANGE_CURSOR&&this.$highlightGutterLine&&this.$gutterLayer.updateLineHighlight(o),e&this.CHANGE_CURSOR&&(this.$cursorLayer.update(o),this.$moveTextAreaToCursor()),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_FRONT)&&this.$markerFront.update(o),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_BACK)&&this.$markerBack.update(o),this._signal("afterRender",e);}else this.$changes|=e;},this.$autosize=function(){var e=this.session.getScreenLength()*this.lineHeight,t=this.$maxLines*this.lineHeight,i=Math.min(t,Math.max((this.$minLines||1)*this.lineHeight,e))+this.scrollMargin.v+(this.$extraHeight||0);this.$horizScroll&&(i+=this.scrollBarH.getHeight()),this.$maxPixelHeight&&i>this.$maxPixelHeight&&(i=this.$maxPixelHeight);var n,r=!(i<=2*this.lineHeight)&&t<e;i==this.desiredHeight&&this.$size.height==this.desiredHeight&&r==this.$vScroll||(r!=this.$vScroll&&(this.$vScroll=r,this.scrollBarV.setVisible(r)),n=this.container.clientWidth,this.container.style.height=i+"px",this.$updateCachedSize(!0,this.$gutterWidth,n,i),this.desiredHeight=i,this._signal("autosize"));},this.$computeLayerConfig=function(){var e=this.session,t=this.$size,i=t.height<=2*this.lineHeight,n=this.session.getScreenLength()*this.lineHeight,r=this.$getLongestLine(),o=!i&&(this.$hScrollBarAlwaysVisible||t.scrollerWidth-r-2*this.$padding<0),s=this.$horizScroll!==o;s&&(this.$horizScroll=o,this.scrollBarH.setVisible(o));var a=this.$vScroll;this.$maxLines&&1<this.lineHeight&&this.$autosize();var l=t.scrollerHeight+this.lineHeight,c=!this.$maxLines&&this.$scrollPastEnd?(t.scrollerHeight-this.lineHeight)*this.$scrollPastEnd:0;n+=c;var h=this.scrollMargin;this.session.setScrollTop(Math.max(-h.top,Math.min(this.scrollTop,n-t.scrollerHeight+h.bottom))),this.session.setScrollLeft(Math.max(-h.left,Math.min(this.scrollLeft,r+2*this.$padding-t.scrollerWidth+h.right)));var d=!i&&(this.$vScrollBarAlwaysVisible||t.scrollerHeight-n+c<0||this.scrollTop>h.top),u=a!==d;u&&(this.$vScroll=d,this.scrollBarV.setVisible(d));var g,p,m=this.scrollTop%this.lineHeight,f=Math.ceil(l/this.lineHeight)-1,C=(A=Math.max(0,Math.round((this.scrollTop-m)/this.lineHeight)))+f,I=this.lineHeight,A=e.screenToDocumentRow(A,0),v=e.getFoldLine(A);v&&(A=v.start.row),g=e.documentToScreenRow(A,0),p=e.getRowLength(A)*I,C=Math.min(e.screenToDocumentRow(C,0),e.getLength()-1),l=t.scrollerHeight+e.getRowLength(C)*I+p,m=this.scrollTop-g*I;var b=0;return this.layerConfig.width==r&&!s||(b=this.CHANGE_H_SCROLL),(s||u)&&(b|=this.$updateCachedSize(!0,this.gutterWidth,t.width,t.height),this._signal("scrollbarVisibilityChanged"),u&&(r=this.$getLongestLine())),this.layerConfig={width:r,padding:this.$padding,firstRow:A,firstRowScreen:g,lastRow:C,lineHeight:I,characterWidth:this.characterWidth,minHeight:l,maxHeight:n,offset:m,gutterOffset:I?Math.max(0,Math.ceil((m+t.height-t.scrollerHeight)/I)):0,height:this.$size.scrollerHeight},this.session.$bidiHandler&&this.session.$bidiHandler.setContentWidth(r-this.$padding),b;},this.$updateLines=function(){if(this.$changedLines){var e=this.$changedLines.firstRow,t=this.$changedLines.lastRow;this.$changedLines=null;var i=this.layerConfig;if(!(e>i.lastRow+1||t<i.firstRow))return t===1/0?(this.$showGutter&&this.$gutterLayer.update(i),void this.$textLayer.update(i)):(this.$textLayer.updateLines(i,e,t),!0);}},this.$getLongestLine=function(){var e=this.session.getScreenWidth();return this.showInvisibles&&!this.session.$useWrapMode&&(e+=1),this.$textLayer&&e>this.$textLayer.MAX_LINE_LENGTH&&(e=this.$textLayer.MAX_LINE_LENGTH+30),Math.max(this.$size.scrollerWidth-2*this.$padding,Math.round(e*this.characterWidth));},this.updateFrontMarkers=function(){this.$markerFront.setMarkers(this.session.getMarkers(!0)),this.$loop.schedule(this.CHANGE_MARKER_FRONT);},this.updateBackMarkers=function(){this.$markerBack.setMarkers(this.session.getMarkers()),this.$loop.schedule(this.CHANGE_MARKER_BACK);},this.addGutterDecoration=function(e,t){this.$gutterLayer.addGutterDecoration(e,t);},this.removeGutterDecoration=function(e,t){this.$gutterLayer.removeGutterDecoration(e,t);},this.updateBreakpoints=function(e){this.$loop.schedule(this.CHANGE_GUTTER);},this.setAnnotations=function(e){this.$gutterLayer.setAnnotations(e),this.$loop.schedule(this.CHANGE_GUTTER);},this.updateCursor=function(){this.$loop.schedule(this.CHANGE_CURSOR);},this.hideCursor=function(){this.$cursorLayer.hideCursor();},this.showCursor=function(){this.$cursorLayer.showCursor();},this.scrollSelectionIntoView=function(e,t,i){this.scrollCursorIntoView(e,i),this.scrollCursorIntoView(t,i);},this.scrollCursorIntoView=function(e,t,i){var n,r,o,s,a,l,c;0!==this.$size.scrollerHeight&&(r=(n=this.$cursorLayer.getPixelPosition(e)).left,o=n.top,s=i&&i.top||0,a=i&&i.bottom||0,o<(l=this.$scrollAnimation?this.session.getScrollTop():this.scrollTop)+s?(t&&l+s>o+this.lineHeight&&(o-=t*this.$size.scrollerHeight),0===o&&(o=-this.scrollMargin.top),this.session.setScrollTop(o)):l+this.$size.scrollerHeight-a<o+this.lineHeight&&(t&&l+this.$size.scrollerHeight-a<o-this.lineHeight&&(o+=t*this.$size.scrollerHeight),this.session.setScrollTop(o+this.lineHeight+a-this.$size.scrollerHeight)),r<(c=this.scrollLeft)?(r<this.$padding+2*this.layerConfig.characterWidth&&(r=-this.scrollMargin.left),this.session.setScrollLeft(r)):c+this.$size.scrollerWidth<r+this.characterWidth?this.session.setScrollLeft(Math.round(r+this.characterWidth-this.$size.scrollerWidth)):c<=this.$padding&&r-c<this.characterWidth&&this.session.setScrollLeft(0));},this.getScrollTop=function(){return this.session.getScrollTop();},this.getScrollLeft=function(){return this.session.getScrollLeft();},this.getScrollTopRow=function(){return this.scrollTop/this.lineHeight;},this.getScrollBottomRow=function(){return Math.max(0,Math.floor((this.scrollTop+this.$size.scrollerHeight)/this.lineHeight)-1);},this.scrollToRow=function(e){this.session.setScrollTop(e*this.lineHeight);},this.alignCursor=function(e,t){"number"==typeof e&&(e={row:e,column:0});var i=this.$cursorLayer.getPixelPosition(e),n=this.$size.scrollerHeight-this.lineHeight,r=i.top-n*(t||0);return this.session.setScrollTop(r),r;},this.STEPS=8,this.$calcSteps=function(e,t){for(var i,n,r=0,o=this.STEPS,s=[],r=0;r<o;++r){s.push((i=r/this.STEPS,(t-(n=e))*(Math.pow(i-1,3)+1)+n));}return s;},this.scrollToLine=function(e,t,i,n){var r=this.$cursorLayer.getPixelPosition({row:e,column:0}).top;t&&(r-=this.$size.scrollerHeight/2);var o=this.scrollTop;this.session.setScrollTop(r),!1!==i&&this.animateScrolling(o,n);},this.animateScrolling=function(e,t){var i=this.scrollTop;if(this.$animatedScroll){var n=this;if(e!=i){if(this.$scrollAnimation){var r=this.$scrollAnimation.steps;if(r.length&&(e=r[0])==i)return;}var o=n.$calcSteps(e,i);this.$scrollAnimation={from:e,to:i,steps:o},clearInterval(this.$timer),n.session.setScrollTop(o.shift()),n.session.$scrollTop=i,this.$timer=setInterval(function(){if(!n.session)return clearInterval(n.$timer);o.length?(n.session.setScrollTop(o.shift()),n.session.$scrollTop=i):null!=i?(n.session.$scrollTop=-1,n.session.setScrollTop(i),i=null):(n.$timer=clearInterval(n.$timer),n.$scrollAnimation=null,t&&t());},10);}}},this.scrollToY=function(e){this.scrollTop!==e&&(this.$loop.schedule(this.CHANGE_SCROLL),this.scrollTop=e);},this.scrollToX=function(e){this.scrollLeft!==e&&(this.scrollLeft=e),this.$loop.schedule(this.CHANGE_H_SCROLL);},this.scrollTo=function(e,t){this.session.setScrollTop(t),this.session.setScrollLeft(t);},this.scrollBy=function(e,t){t&&this.session.setScrollTop(this.session.getScrollTop()+t),e&&this.session.setScrollLeft(this.session.getScrollLeft()+e);},this.isScrollableBy=function(e,t){return t<0&&this.session.getScrollTop()>=1-this.scrollMargin.top||0<t&&this.session.getScrollTop()+this.$size.scrollerHeight-this.layerConfig.maxHeight<-1+this.scrollMargin.bottom||e<0&&this.session.getScrollLeft()>=1-this.scrollMargin.left||0<e&&this.session.getScrollLeft()+this.$size.scrollerWidth-this.layerConfig.width<-1+this.scrollMargin.right||void 0;},this.pixelToScreenCoordinates=function(e,t){var i,n;this.$hasCssTransforms?(i={top:0,left:0},e=(n=this.$fontMetrics.transformCoordinates([e,t]))[1]-this.gutterWidth-this.margin.left,t=n[0]):i=this.scroller.getBoundingClientRect();var r=e+this.scrollLeft-i.left-this.$padding,o=r/this.characterWidth,s=Math.floor((t+this.scrollTop-i.top)/this.lineHeight),a=this.$blockCursor?Math.floor(o):Math.round(o);return{row:s,column:a,side:0<o-a?1:-1,offsetX:r};},this.screenToTextCoordinates=function(e,t){var i,n;this.$hasCssTransforms?(i={top:0,left:0},e=(n=this.$fontMetrics.transformCoordinates([e,t]))[1]-this.gutterWidth-this.margin.left,t=n[0]):i=this.scroller.getBoundingClientRect();var r=e+this.scrollLeft-i.left-this.$padding,o=r/this.characterWidth,s=this.$blockCursor?Math.floor(o):Math.round(o),a=Math.floor((t+this.scrollTop-i.top)/this.lineHeight);return this.session.screenToDocumentPosition(a,Math.max(s,0),r);},this.textToScreenCoordinates=function(e,t){var i=this.scroller.getBoundingClientRect(),n=this.session.documentToScreenPosition(e,t),r=this.$padding+(this.session.$bidiHandler.isBidiRow(n.row,e)?this.session.$bidiHandler.getPosLeft(n.column):Math.round(n.column*this.characterWidth)),o=n.row*this.lineHeight;return{pageX:i.left+r-this.scrollLeft,pageY:i.top+o-this.scrollTop};},this.visualizeFocus=function(){h.addCssClass(this.container,"ace_focus");},this.visualizeBlur=function(){h.removeCssClass(this.container,"ace_focus");},this.showComposition=function(e){(this.$composition=e).cssText||(e.cssText=this.textarea.style.cssText),null==e.useTextareaForIME&&(e.useTextareaForIME=this.$useTextareaForIME),this.$useTextareaForIME?(h.addCssClass(this.textarea,"ace_composition"),this.textarea.style.cssText="",this.$moveTextAreaToCursor(),this.$cursorLayer.element.style.display="none"):e.markerId=this.session.addMarker(e.markerRange,"ace_composition_marker","text");},this.setCompositionText=function(e){var t=this.session.selection.cursor;this.addToken(e,"composition_placeholder",t.row,t.column),this.$moveTextAreaToCursor();},this.hideComposition=function(){var e;this.$composition&&(this.$composition.markerId&&this.session.removeMarker(this.$composition.markerId),h.removeCssClass(this.textarea,"ace_composition"),this.textarea.style.cssText=this.$composition.cssText,e=this.session.selection.cursor,this.removeExtraToken(e.row,e.column),this.$composition=null,this.$cursorLayer.element.style.display="");},this.addToken=function(e,t,i,n){var r=this.session;r.bgTokenizer.lines[i]=null;var o={type:t,value:e},s=r.getTokens(i);if(null==n)s.push(o);else for(var a=0,l=0;l<s.length;l++){var c=s[l];if(n<=(a+=c.value.length)){var h=c.value.length-(a-n),d=c.value.slice(0,h),u=c.value.slice(h);s.splice(l,1,{type:c.type,value:d},o,{type:c.type,value:u});break;}}this.updateLines(i,i);},this.removeExtraToken=function(e,t){this.updateLines(e,e);},this.setTheme=function(i,n){var e,r=this;function t(e){if(r.$themeId!=i)return n&&n();if(!e||!e.cssClass)throw new Error("couldn't load module "+i+" or it didn't call define");e.$id&&(r.$themeId=e.$id),h.importCssString(e.cssText,e.cssClass,r.container),r.theme&&h.removeCssClass(r.container,r.theme.cssClass);var t="padding"in e?e.padding:"padding"in(r.theme||{})?4:r.$padding;r.$padding&&t!=r.$padding&&r.setPadding(t),r.$theme=e.cssClass,r.theme=e,h.addCssClass(r.container,e.cssClass),h.setCssClass(r.container,"ace_dark",e.isDark),r.$size&&(r.$size.width=0,r.$updateSizeAsync()),r._dispatchEvent("themeLoaded",{theme:e}),n&&n();}this.$themeId=i,r._dispatchEvent("themeChange",{theme:i}),i&&"string"!=typeof i?t(i):(e=i||this.$options.theme.initialValue,o.loadModule(["theme",e],t));},this.getTheme=function(){return this.$themeId;},this.setStyle=function(e,t){h.setCssClass(this.container,e,!1!==t);},this.unsetStyle=function(e){h.removeCssClass(this.container,e);},this.setCursorStyle=function(e){h.setStyle(this.scroller.style,"cursor",e);},this.setMouseCursor=function(e){h.setStyle(this.scroller.style,"cursor",e);},this.attachToShadowRoot=function(){h.importCssString(m,"ace_editor.css",this.container);},this.destroy=function(){this.freeze(),this.$fontMetrics.destroy(),this.$cursorLayer.destroy(),this.removeAllListeners(),this.container.textContent="";};}).call(I.prototype),o.defineOptions(I.prototype,"renderer",{animatedScroll:{initialValue:!1},showInvisibles:{set:function set(e){this.$textLayer.setShowInvisibles(e)&&this.$loop.schedule(this.CHANGE_TEXT);},initialValue:!1},showPrintMargin:{set:function set(){this.$updatePrintMargin();},initialValue:!0},printMarginColumn:{set:function set(){this.$updatePrintMargin();},initialValue:80},printMargin:{set:function set(e){"number"==typeof e&&(this.$printMarginColumn=e),this.$showPrintMargin=!!e,this.$updatePrintMargin();},get:function get(){return this.$showPrintMargin&&this.$printMarginColumn;}},showGutter:{set:function set(e){this.$gutter.style.display=e?"block":"none",this.$loop.schedule(this.CHANGE_FULL),this.onGutterResize();},initialValue:!0},fadeFoldWidgets:{set:function set(e){h.setCssClass(this.$gutter,"ace_fade-fold-widgets",e);},initialValue:!1},showFoldWidgets:{set:function set(e){this.$gutterLayer.setShowFoldWidgets(e),this.$loop.schedule(this.CHANGE_GUTTER);},initialValue:!0},displayIndentGuides:{set:function set(e){this.$textLayer.setDisplayIndentGuides(e)&&this.$loop.schedule(this.CHANGE_TEXT);},initialValue:!0},highlightGutterLine:{set:function set(e){this.$gutterLayer.setHighlightGutterLine(e),this.$loop.schedule(this.CHANGE_GUTTER);},initialValue:!0},hScrollBarAlwaysVisible:{set:function set(e){this.$hScrollBarAlwaysVisible&&this.$horizScroll||this.$loop.schedule(this.CHANGE_SCROLL);},initialValue:!1},vScrollBarAlwaysVisible:{set:function set(e){this.$vScrollBarAlwaysVisible&&this.$vScroll||this.$loop.schedule(this.CHANGE_SCROLL);},initialValue:!1},fontSize:{set:function set(e){"number"==typeof e&&(e+="px"),this.container.style.fontSize=e,this.updateFontSize();},initialValue:12},fontFamily:{set:function set(e){this.container.style.fontFamily=e,this.updateFontSize();}},maxLines:{set:function set(e){this.updateFull();}},minLines:{set:function set(e){this.$minLines<562949953421311||(this.$minLines=0),this.updateFull();}},maxPixelHeight:{set:function set(e){this.updateFull();},initialValue:0},scrollPastEnd:{set:function set(e){e=+e||0,this.$scrollPastEnd!=e&&(this.$scrollPastEnd=e,this.$loop.schedule(this.CHANGE_SCROLL));},initialValue:0,handlesSet:!0},fixedWidthGutter:{set:function set(e){this.$gutterLayer.$fixedWidth=!!e,this.$loop.schedule(this.CHANGE_GUTTER);}},theme:{set:function set(e){this.setTheme(e);},get:function get(){return this.$themeId||this.theme;},initialValue:"./theme/textmate",handlesSet:!0},hasCssTransforms:{},useTextareaForIME:{initialValue:!f.isMobile&&!f.isIE}}),t.VirtualRenderer=I;}),ace.define("ace/worker/worker_client",["require","exports","module","ace/lib/oop","ace/lib/net","ace/lib/event_emitter","ace/config"],function(a,e,t){"use strict";var i=a("../lib/oop"),n=a("../lib/net"),c=a("../lib/event_emitter").EventEmitter,h=a("../config");function l(e){if("undefined"==typeof Worker)return{postMessage:function postMessage(){},terminate:function terminate(){}};if(h.get("loadWorkerFromBlob")){var t=function(e){var t="importScripts('"+n.qualifyURL(e)+"');";try{return new Blob([t],{type:"application/javascript"});}catch(e){var i=new(window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder)();return i.append(t),i.getBlob("application/javascript");}}(e),i=(window.URL||window.webkitURL).createObjectURL(t);return new Worker(i);}return new Worker(e);}function d(e){e.postMessage||(e=this.$createWorkerFromOldConfig.apply(this,arguments)),this.$worker=e,this.$sendDeltaQueue=this.$sendDeltaQueue.bind(this),this.changeListener=this.changeListener.bind(this),this.onMessage=this.onMessage.bind(this),this.callbackId=1,this.callbacks={},this.$worker.onmessage=this.onMessage;}(function(){i.implement(this,c),this.$createWorkerFromOldConfig=function(e,t,i,n,r){var o,s;return a.nameToUrl&&!a.toUrl&&(a.toUrl=a.nameToUrl),h.get("packaged")||!a.toUrl?n=n||h.moduleUrl(t,"worker"):(o=this.$normalizePath,n=n||o(a.toUrl("ace/worker/worker.js",null,"_")),s={},e.forEach(function(e){s[e]=o(a.toUrl(e,null,"_").replace(/(\.js)?(\?.*)?$/,""));})),this.$worker=l(n),r&&this.send("importScripts",r),this.$worker.postMessage({init:!0,tlns:s,module:t,classname:i}),this.$worker;},this.onMessage=function(e){var t=e.data;switch(t.type){case"event":this._signal(t.name,{data:t.data});break;case"call":var i=this.callbacks[t.id];i&&(i(t.data),delete this.callbacks[t.id]);break;case"error":this.reportError(t.data);break;case"log":window.console&&console.log&&console.log.apply(console,t.data);}},this.reportError=function(e){window.console&&console.error&&console.error(e);},this.$normalizePath=function(e){return n.qualifyURL(e);},this.terminate=function(){this._signal("terminate",{}),this.deltaQueue=null,this.$worker.terminate(),this.$worker=null,this.$doc&&this.$doc.off("change",this.changeListener),this.$doc=null;},this.send=function(e,t){this.$worker.postMessage({command:e,args:t});},this.call=function(e,t,i){var n;i&&(n=this.callbackId++,this.callbacks[n]=i,t.push(n)),this.send(e,t);},this.emit=function(e,t){try{t.data&&t.data.err&&(t.data.err={message:t.data.err.message,stack:t.data.err.stack,code:t.data.err.code}),this.$worker.postMessage({event:e,data:{data:t.data}});}catch(e){console.error(e.stack);}},this.attachToDocument=function(e){this.$doc&&this.terminate(),this.$doc=e,this.call("setValue",[e.getValue()]),e.on("change",this.changeListener);},this.changeListener=function(e){this.deltaQueue||(this.deltaQueue=[],setTimeout(this.$sendDeltaQueue,0)),"insert"==e.action?this.deltaQueue.push(e.start,e.lines):this.deltaQueue.push(e.start,e.end);},this.$sendDeltaQueue=function(){var e=this.deltaQueue;e&&(this.deltaQueue=null,50<e.length&&e.length>this.$doc.getLength()>>1?this.call("setValue",[this.$doc.getValue()]):this.emit("change",{data:e}));};}).call(d.prototype);e.UIWorkerClient=function(e,t,i){var n=null,r=!1,o=Object.create(c),s=[],a=new d({messageBuffer:s,terminate:function terminate(){},postMessage:function postMessage(e){s.push(e),n&&(r?setTimeout(l):l());}});a.setEmitSync=function(e){r=e;};var l=function l(){var e=s.shift();e.command?n[e.command].apply(n,e.args):e.event&&o._signal(e.event,e.data);};return o.postMessage=function(e){a.onMessage({data:e});},o.callback=function(e,t){this.postMessage({type:"call",id:t,data:e});},o.emit=function(e,t){this.postMessage({type:"event",name:e,data:t});},h.loadModule(["worker",t],function(e){for(n=new e[i](o);s.length;){l();}}),a;},e.WorkerClient=d,e.createWorker=l;}),ace.define("ace/placeholder",["require","exports","module","ace/range","ace/lib/event_emitter","ace/lib/oop"],function(e,t,i){"use strict";function n(e,t,i,n,r,o){var s=this;this.length=t,this.session=e,this.doc=e.getDocument(),this.mainClass=r,this.othersClass=o,this.$onUpdate=this.onUpdate.bind(this),this.doc.on("change",this.$onUpdate),this.$others=n,this.$onCursorChange=function(){setTimeout(function(){s.onCursorChange();});},this.$pos=i;var a=e.getUndoManager().$undoStack||e.getUndoManager().$undostack||{length:-1};this.$undoStackDepth=a.length,this.setup(),e.selection.on("changeCursor",this.$onCursorChange);}var l=e("./range").Range,r=e("./lib/event_emitter").EventEmitter,o=e("./lib/oop");(function(){o.implement(this,r),this.setup=function(){var i=this,n=this.doc,e=this.session;this.selectionBefore=e.selection.toJSON(),e.selection.inMultiSelectMode&&e.selection.toSingleRange(),this.pos=n.createAnchor(this.$pos.row,this.$pos.column);var t=this.pos;t.$insertRight=!0,t.detach(),t.markerId=e.addMarker(new l(t.row,t.column,t.row,t.column+this.length),this.mainClass,null,!1),this.others=[],this.$others.forEach(function(e){var t=n.createAnchor(e.row,e.column);t.$insertRight=!0,t.detach(),i.others.push(t);}),e.setUndoSelect(!1);},this.showOtherMarkers=function(){var t,i;this.othersActive||(t=this.session,(i=this).othersActive=!0,this.others.forEach(function(e){e.markerId=t.addMarker(new l(e.row,e.column,e.row,e.column+i.length),i.othersClass,null,!1);}));},this.hideOtherMarkers=function(){if(this.othersActive){this.othersActive=!1;for(var e=0;e<this.others.length;e++){this.session.removeMarker(this.others[e].markerId);}}},this.onUpdate=function(e){if(this.$updating)return this.updateAnchors(e);var t=e;if(t.start.row===t.end.row&&t.start.row===this.pos.row){this.$updating=!0;var i="insert"===e.action?t.end.column-t.start.column:t.start.column-t.end.column,n=t.start.column>=this.pos.column&&t.start.column<=this.pos.column+this.length+1,r=t.start.column-this.pos.column;if(this.updateAnchors(e),n&&(this.length+=i),n&&!this.session.$fromUndo)if("insert"===e.action)for(var o=this.others.length-1;0<=o;o--){var s={row:(a=this.others[o]).row,column:a.column+r};this.doc.insertMergedLines(s,e.lines);}else if("remove"===e.action)for(o=this.others.length-1;0<=o;o--){var a,s={row:(a=this.others[o]).row,column:a.column+r};this.doc.remove(new l(s.row,s.column,s.row,s.column-i));}this.$updating=!1,this.updateMarkers();}},this.updateAnchors=function(e){this.pos.onChange(e);for(var t=this.others.length;t--;){this.others[t].onChange(e);}this.updateMarkers();},this.updateMarkers=function(){if(!this.$updating){var i=this,n=this.session,e=function e(_e,t){n.removeMarker(_e.markerId),_e.markerId=n.addMarker(new l(_e.row,_e.column,_e.row,_e.column+i.length),t,null,!1);};e(this.pos,this.mainClass);for(var t=this.others.length;t--;){e(this.others[t],this.othersClass);}}},this.onCursorChange=function(e){var t;!this.$updating&&this.session&&((t=this.session.selection.getCursor()).row===this.pos.row&&t.column>=this.pos.column&&t.column<=this.pos.column+this.length?(this.showOtherMarkers(),this._emit("cursorEnter",e)):(this.hideOtherMarkers(),this._emit("cursorLeave",e)));},this.detach=function(){this.session.removeMarker(this.pos&&this.pos.markerId),this.hideOtherMarkers(),this.doc.off("change",this.$onUpdate),this.session.selection.off("changeCursor",this.$onCursorChange),this.session.setUndoSelect(!0),this.session=null;},this.cancel=function(){if(-1!==this.$undoStackDepth){for(var e=this.session.getUndoManager(),t=(e.$undoStack||e.$undostack).length-this.$undoStackDepth,i=0;i<t;i++){e.undo(this.session,!0);}this.selectionBefore&&this.session.selection.fromJSON(this.selectionBefore);}};}).call(n.prototype),t.PlaceHolder=n;}),ace.define("ace/mouse/multi_select_handler",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,i){var k=e("../lib/event"),R=e("../lib/useragent");function E(e,t){return e.row==t.row&&e.column==t.column;}t.onMouseDown=function(e){var t=e.domEvent,i=t.altKey,n=t.shiftKey,r=t.ctrlKey,o=e.getAccelKey(),s=e.getButton();if(r&&R.isMac&&(s=t.button),e.editor.inMultiSelectMode&&2==s)e.editor.textInput.onContextMenu(e.domEvent);else if(r||i||o){if(0===s){var a,l,c,h=e.editor,d=h.selection,u=h.inMultiSelectMode,g=e.getDocumentPosition(),p=d.getCursor(),m=e.inSelection()||d.isEmpty()&&E(g,p),f=e.x,C=e.y,I=h.session,A=h.renderer.pixelToScreenCoordinates(f,C),v=A;if(h.$mouseHandler.$enableJumpToDef)r&&i||o&&i?a=n?"block":"add":i&&h.$blockSelectEnabled&&(a="block");else if(o&&!i){if(a="add",!u&&n)return;}else i&&h.$blockSelectEnabled&&(a="block");if(a&&R.isMac&&t.ctrlKey&&h.$mouseHandler.cancelContextMenu(),"add"==a){if(!u&&m)return;u||(l=d.toOrientedRange(),h.addSelectionMarker(l));var b=d.rangeList.rangeAtPoint(g);h.inVirtualSelectionMode=!0,n&&(b=null,l=d.ranges[0]||l,h.removeSelectionMarker(l)),h.once("mouseup",function(){var e=d.toOrientedRange();b&&e.isEmpty()&&E(b.cursor,e.cursor)?d.substractPoint(e.cursor):(n?d.substractPoint(l.cursor):l&&(h.removeSelectionMarker(l),d.addRange(l)),d.addRange(e)),h.inVirtualSelectionMode=!1;});}else if("block"==a){var y=function y(){var e=h.renderer.pixelToScreenCoordinates(f,C),t=I.screenToDocumentPosition(e.row,e.column,e.offsetX);E(v,e)&&E(t,d.lead)||(v=e,h.selection.moveToPosition(t),h.renderer.scrollCursorIntoView(),h.removeSelectionMarkers(w),w=d.rectangularRangeBlock(v,A),h.$mouseHandler.$clickSelection&&1==w.length&&w[0].isEmpty()&&(w[0]=h.$mouseHandler.$clickSelection.clone()),w.forEach(h.addSelectionMarker,h),h.updateSelectionMarkers());};e.stop(),h.inVirtualSelectionMode=!0;var w=[];u&&!o?d.toSingleRange():!u&&o&&(c=d.toOrientedRange(),h.addSelectionMarker(c)),n?A=I.documentToScreenPosition(d.lead):d.moveToPosition(g),v={row:-1,column:-1};var S=y;k.capture(h.container,function(e){f=e.clientX,C=e.clientY;},function(e){y(),clearInterval(x),h.removeSelectionMarkers(w),w.length||(w=[d.toOrientedRange()]),c&&(h.removeSelectionMarker(c),d.toSingleRange(c));for(var t=0;t<w.length;t++){d.addRange(w[t]);}h.inVirtualSelectionMode=!1,h.$mouseHandler.$clickSelection=null;});var x=setInterval(function(){S();},20);return e.preventDefault();}}}else 0===s&&e.editor.inMultiSelectMode&&e.editor.exitMultiSelectMode();};}),ace.define("ace/commands/multi_select_commands",["require","exports","module","ace/keyboard/hash_handler"],function(e,t,i){t.defaultCommands=[{name:"addCursorAbove",description:"Add cursor above",exec:function exec(e){e.selectMoreLines(-1);},bindKey:{win:"Ctrl-Alt-Up",mac:"Ctrl-Alt-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelow",description:"Add cursor below",exec:function exec(e){e.selectMoreLines(1);},bindKey:{win:"Ctrl-Alt-Down",mac:"Ctrl-Alt-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorAboveSkipCurrent",description:"Add cursor above (skip current)",exec:function exec(e){e.selectMoreLines(-1,!0);},bindKey:{win:"Ctrl-Alt-Shift-Up",mac:"Ctrl-Alt-Shift-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelowSkipCurrent",description:"Add cursor below (skip current)",exec:function exec(e){e.selectMoreLines(1,!0);},bindKey:{win:"Ctrl-Alt-Shift-Down",mac:"Ctrl-Alt-Shift-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreBefore",description:"Select more before",exec:function exec(e){e.selectMore(-1);},bindKey:{win:"Ctrl-Alt-Left",mac:"Ctrl-Alt-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreAfter",description:"Select more after",exec:function exec(e){e.selectMore(1);},bindKey:{win:"Ctrl-Alt-Right",mac:"Ctrl-Alt-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextBefore",description:"Select next before",exec:function exec(e){e.selectMore(-1,!0);},bindKey:{win:"Ctrl-Alt-Shift-Left",mac:"Ctrl-Alt-Shift-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextAfter",description:"Select next after",exec:function exec(e){e.selectMore(1,!0);},bindKey:{win:"Ctrl-Alt-Shift-Right",mac:"Ctrl-Alt-Shift-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"toggleSplitSelectionIntoLines",description:"Split into lines",exec:function exec(e){1<e.multiSelect.rangeCount?e.multiSelect.joinSelections():e.multiSelect.splitIntoLines();},bindKey:{win:"Ctrl-Alt-L",mac:"Ctrl-Alt-L"},readOnly:!0},{name:"splitSelectionIntoLines",description:"Split into lines",exec:function exec(e){e.multiSelect.splitIntoLines();},readOnly:!0},{name:"alignCursors",description:"Align cursors",exec:function exec(e){e.alignCursors();},bindKey:{win:"Ctrl-Alt-A",mac:"Ctrl-Alt-A"},scrollIntoView:"cursor"},{name:"findAll",description:"Find all",exec:function exec(e){e.findAll();},bindKey:{win:"Ctrl-Alt-K",mac:"Ctrl-Alt-G"},scrollIntoView:"cursor",readOnly:!0}],t.multiSelectCommands=[{name:"singleSelection",description:"Single selection",bindKey:"esc",exec:function exec(e){e.exitMultiSelectMode();},scrollIntoView:"cursor",readOnly:!0,isAvailable:function isAvailable(e){return e&&e.inMultiSelectMode;}}];var n=e("../keyboard/hash_handler").HashHandler;t.keyboardHandler=new n(t.multiSelectCommands);}),ace.define("ace/multi_select",["require","exports","module","ace/range_list","ace/range","ace/selection","ace/mouse/multi_select_handler","ace/lib/event","ace/lib/lang","ace/commands/multi_select_commands","ace/search","ace/edit_session","ace/editor","ace/config"],function(e,t,i){var n=e("./range_list").RangeList,v=e("./range").Range,m=e("./selection").Selection,r=e("./mouse/multi_select_handler").onMouseDown,o=e("./lib/event"),f=e("./lib/lang"),s=e("./commands/multi_select_commands");t.commands=s.defaultCommands.concat(s.multiSelectCommands);var h=new(e("./search").Search)();var a=e("./edit_session").EditSession;(function(){this.getSelectionMarkers=function(){return this.$selectionMarkers;};}).call(a.prototype),function(){this.ranges=null,this.rangeList=null,this.addRange=function(e,t){if(e){if(!this.inMultiSelectMode&&0===this.rangeCount){var i=this.toOrientedRange();if(this.rangeList.add(i),this.rangeList.add(e),2!=this.rangeList.ranges.length)return this.rangeList.removeAll(),t||this.fromOrientedRange(e);this.rangeList.removeAll(),this.rangeList.add(i),this.$onAddRange(i);}e.cursor||(e.cursor=e.end);var n=this.rangeList.add(e);return this.$onAddRange(e),n.length&&this.$onRemoveRange(n),1<this.rangeCount&&!this.inMultiSelectMode&&(this._signal("multiSelect"),this.inMultiSelectMode=!0,this.session.$undoSelect=!1,this.rangeList.attach(this.session)),t||this.fromOrientedRange(e);}},this.toSingleRange=function(e){e=e||this.ranges[0];var t=this.rangeList.removeAll();t.length&&this.$onRemoveRange(t),e&&this.fromOrientedRange(e);},this.substractPoint=function(e){var t=this.rangeList.substractPoint(e);if(t)return this.$onRemoveRange(t),t[0];},this.mergeOverlappingRanges=function(){var e=this.rangeList.merge();e.length&&this.$onRemoveRange(e);},this.$onAddRange=function(e){this.rangeCount=this.rangeList.ranges.length,this.ranges.unshift(e),this._signal("addRange",{range:e});},this.$onRemoveRange=function(e){var t;this.rangeCount=this.rangeList.ranges.length,1==this.rangeCount&&this.inMultiSelectMode&&(t=this.rangeList.ranges.pop(),e.push(t),this.rangeCount=0);for(var i=e.length;i--;){var n=this.ranges.indexOf(e[i]);this.ranges.splice(n,1);}this._signal("removeRange",{ranges:e}),0===this.rangeCount&&this.inMultiSelectMode&&(this.inMultiSelectMode=!1,this._signal("singleSelect"),this.session.$undoSelect=!0,this.rangeList.detach(this.session)),(t=t||this.ranges[0])&&!t.isEqual(this.getRange())&&this.fromOrientedRange(t);},this.$initRangeList=function(){this.rangeList||(this.rangeList=new n(),this.ranges=[],this.rangeCount=0);},this.getAllRanges=function(){return this.rangeCount?this.rangeList.ranges.concat():[this.getRange()];},this.splitIntoLines=function(){for(var e=this.ranges.length?this.ranges:[this.getRange()],t=[],i=0;i<e.length;i++){var n=e[i],r=n.start.row,o=n.end.row;if(r===o)t.push(n.clone());else{for(t.push(new v(r,n.start.column,r,this.session.getLine(r).length));++r<o;){t.push(this.getLineRange(r,!0));}t.push(new v(o,0,o,n.end.column));}0!=i||this.isBackwards()||(t=t.reverse());}this.toSingleRange();for(i=t.length;i--;){this.addRange(t[i]);}},this.joinSelections=function(){var e=this.rangeList.ranges,t=e[e.length-1],i=v.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(i,t.cursor==t.start);},this.toggleBlockSelection=function(){var e,t,i,n,r;1<this.rangeCount?(t=(e=this.rangeList.ranges)[e.length-1],i=v.fromPoints(e[0].start,t.end),this.toSingleRange(),this.setSelectionRange(i,t.cursor==t.start)):(n=this.session.documentToScreenPosition(this.cursor),r=this.session.documentToScreenPosition(this.anchor),this.rectangularRangeBlock(n,r).forEach(this.addRange,this));},this.rectangularRangeBlock=function(e,t,i){var n,r,o,s,a=[],l=e.column<t.column;s=l?(n=e.column,r=t.column,o=e.offsetX,t.offsetX):(n=t.column,r=e.column,o=t.offsetX,e.offsetX);var c,h,d,u=e.row<t.row;h=u?(c=e.row,t.row):(c=t.row,e.row),n<0&&(n=0),c<0&&(c=0),c==h&&(i=!0);for(var g,p,m=c;m<=h;m++){var f=v.fromPoints(this.session.screenToDocumentPosition(m,n,o),this.session.screenToDocumentPosition(m,r,s));if(f.isEmpty()){if(d&&(g=f.end,p=d,g.row==p.row&&g.column==p.column))break;d=f.end;}f.cursor=l?f.start:f.end,a.push(f);}if(u&&a.reverse(),!i){for(var C=a.length-1;a[C].isEmpty()&&0<C;){C--;}if(0<C)for(var I=0;a[I].isEmpty();){I++;}for(var A=C;I<=A;A--){a[A].isEmpty()&&a.splice(A,1);}}return a;};}.call(m.prototype);var l=e("./editor").Editor;function c(e){e.$multiselectOnSessionChange||(e.$onAddRange=e.$onAddRange.bind(e),e.$onRemoveRange=e.$onRemoveRange.bind(e),e.$onMultiSelect=e.$onMultiSelect.bind(e),e.$onSingleSelect=e.$onSingleSelect.bind(e),e.$multiselectOnSessionChange=t.onSessionChange.bind(e),e.$checkMultiselectChange=e.$checkMultiselectChange.bind(e),e.$multiselectOnSessionChange(e),e.on("changeSession",e.$multiselectOnSessionChange),e.on("mousedown",r),e.commands.addCommands(s.defaultCommands),function(i){if(!i.textInput)return;var e=i.textInput.getElement(),n=!1;function r(e){n&&(i.renderer.setMouseCursor(""),n=!1);}o.addListener(e,"keydown",function(e){var t=18==e.keyCode&&!(e.ctrlKey||e.shiftKey||e.metaKey);i.$blockSelectEnabled&&t?n||(i.renderer.setMouseCursor("crosshair"),n=!0):n&&r();},i),o.addListener(e,"keyup",r,i),o.addListener(e,"blur",r,i);}(e));}(function(){this.updateSelectionMarkers=function(){this.renderer.updateCursor(),this.renderer.updateBackMarkers();},this.addSelectionMarker=function(e){e.cursor||(e.cursor=e.end);var t=this.getSelectionStyle();return e.marker=this.session.addMarker(e,"ace_selection",t),this.session.$selectionMarkers.push(e),this.session.selectionMarkerCount=this.session.$selectionMarkers.length,e;},this.removeSelectionMarker=function(e){var t;e.marker&&(this.session.removeMarker(e.marker),-1!=(t=this.session.$selectionMarkers.indexOf(e))&&this.session.$selectionMarkers.splice(t,1),this.session.selectionMarkerCount=this.session.$selectionMarkers.length);},this.removeSelectionMarkers=function(e){for(var t=this.session.$selectionMarkers,i=e.length;i--;){var n,r=e[i];r.marker&&(this.session.removeMarker(r.marker),-1!=(n=t.indexOf(r))&&t.splice(n,1));}this.session.selectionMarkerCount=t.length;},this.$onAddRange=function(e){this.addSelectionMarker(e.range),this.renderer.updateCursor(),this.renderer.updateBackMarkers();},this.$onRemoveRange=function(e){this.removeSelectionMarkers(e.ranges),this.renderer.updateCursor(),this.renderer.updateBackMarkers();},this.$onMultiSelect=function(e){this.inMultiSelectMode||(this.inMultiSelectMode=!0,this.setStyle("ace_multiselect"),this.keyBinding.addKeyboardHandler(s.keyboardHandler),this.commands.setDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers());},this.$onSingleSelect=function(e){this.session.multiSelect.inVirtualMode||(this.inMultiSelectMode=!1,this.unsetStyle("ace_multiselect"),this.keyBinding.removeKeyboardHandler(s.keyboardHandler),this.commands.removeDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers(),this._emit("changeSelection"));},this.$onMultiSelectExec=function(e){var t,i=e.command,n=e.editor;if(n.multiSelect)return i.multiSelectAction?t="forEach"==i.multiSelectAction?n.forEachSelection(i,e.args):"forEachLine"==i.multiSelectAction?n.forEachSelection(i,e.args,!0):"single"==i.multiSelectAction?(n.exitMultiSelectMode(),i.exec(n,e.args||{})):i.multiSelectAction(n,e.args||{}):(t=i.exec(n,e.args||{}),n.multiSelect.addRange(n.multiSelect.toOrientedRange()),n.multiSelect.mergeOverlappingRanges()),t;},this.forEachSelection=function(e,t,i){if(!this.inVirtualSelectionMode){var n,r=i&&i.keepOrder,o=1==i||i&&i.$byLines,s=this.session,a=this.selection,l=a.rangeList,c=(r?a:l).ranges;if(!c.length)return e.exec?e.exec(this,t||{}):e(this,t||{});var h=a._eventRegistry;a._eventRegistry={};var d=new m(s);this.inVirtualSelectionMode=!0;for(var u=c.length;u--;){if(o)for(;0<u&&c[u].start.row==c[u-1].end.row;){u--;}d.fromOrientedRange(c[u]),d.index=u,this.selection=s.selection=d;var g=e.exec?e.exec(this,t||{}):e(this,t||{});n||void 0===g||(n=g),d.toOrientedRange(c[u]);}d.detach(),this.selection=s.selection=a,this.inVirtualSelectionMode=!1,a._eventRegistry=h,a.mergeOverlappingRanges(),a.ranges[0]&&a.fromOrientedRange(a.ranges[0]);var p=this.renderer.$scrollAnimation;return this.onCursorChange(),this.onSelectionChange(),p&&p.from==p.to&&this.renderer.animateScrolling(p.from),n;}},this.exitMultiSelectMode=function(){this.inMultiSelectMode&&!this.inVirtualSelectionMode&&this.multiSelect.toSingleRange();},this.getSelectedText=function(){var e="";if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){for(var t=this.multiSelect.rangeList.ranges,i=[],n=0;n<t.length;n++){i.push(this.session.getTextRange(t[n]));}var r=this.session.getDocument().getNewLineCharacter();(e=i.join(r)).length==(i.length-1)*r.length&&(e="");}else this.selection.isEmpty()||(e=this.session.getTextRange(this.getSelectionRange()));return e;},this.$checkMultiselectChange=function(e,t){if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){var i=this.multiSelect.ranges[0];if(this.multiSelect.isEmpty()&&t==this.multiSelect.anchor)return;var n=t==this.multiSelect.anchor?i.cursor==i.start?i.end:i.start:i.cursor;n.row!=t.row||this.session.$clipPositionToDocument(n.row,n.column).column!=t.column?this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange()):this.multiSelect.mergeOverlappingRanges();}},this.findAll=function(e,t,i){var n;(t=t||{}).needle=e||t.needle,null==t.needle&&(n=this.selection.isEmpty()?this.selection.getWordRange():this.selection.getRange(),t.needle=this.session.getTextRange(n)),this.$search.set(t);var r=this.$search.findAll(this.session);if(!r.length)return 0;var o=this.multiSelect;i||o.toSingleRange(r[0]);for(var s=r.length;s--;){o.addRange(r[s],!0);}return n&&o.rangeList.rangeAtPoint(n.start)&&o.addRange(n,!0),r.length;},this.selectMoreLines=function(e,t){var i=this.selection.toOrientedRange(),n=i.cursor==i.end,r=this.session.documentToScreenPosition(i.cursor);this.selection.$desiredColumn&&(r.column=this.selection.$desiredColumn);var o,s,a,l,c=this.session.screenToDocumentPosition(r.row+e,r.column);s=i.isEmpty()?c:(o=this.session.documentToScreenPosition(n?i.end:i.start),this.session.screenToDocumentPosition(o.row+e,o.column)),n?(a=v.fromPoints(c,s)).cursor=a.start:(a=v.fromPoints(s,c)).cursor=a.end,a.desiredColumn=r.column,this.selection.inMultiSelectMode?t&&(l=i.cursor):this.selection.addRange(i),this.selection.addRange(a),l&&this.selection.substractPoint(l);},this.transposeSelections=function(e){for(var t=this.session,i=t.multiSelect,n=i.ranges,r=n.length;r--;){(s=n[r]).isEmpty()&&(a=t.getWordRange(s.start.row,s.start.column),s.start.row=a.start.row,s.start.column=a.start.column,s.end.row=a.end.row,s.end.column=a.end.column);}i.mergeOverlappingRanges();for(var o=[],r=n.length;r--;){var s=n[r];o.unshift(t.getTextRange(s));}e<0?o.unshift(o.pop()):o.push(o.shift());for(r=n.length;r--;){var a=(s=n[r]).clone();t.replace(s,o[r]),s.start.row=a.start.row,s.start.column=a.start.column;}i.fromOrientedRange(i.ranges[0]);},this.selectMore=function(e,t,i){var n,r,o,s,a,l=this.session,c=l.multiSelect.toOrientedRange();c.isEmpty()&&((c=l.getWordRange(c.start.row,c.start.column)).cursor=-1==e?c.start:c.end,this.multiSelect.addRange(c),i)||(n=l.getTextRange(c),o=l,s=n,a=e,h.$options.wrap=!0,h.$options.needle=s,h.$options.backwards=-1==a,(r=h.find(o))&&(r.cursor=-1==e?r.start:r.end,this.session.unfold(r),this.multiSelect.addRange(r),this.renderer.scrollCursorIntoView(null,.5)),t&&this.multiSelect.substractPoint(c.cursor));},this.alignCursors=function(){var o=this.session,t=o.multiSelect,e=t.ranges,i=-1,n=e.filter(function(e){if(e.cursor.row==i)return!0;i=e.cursor.row;});if(e.length&&n.length!=e.length-1){n.forEach(function(e){t.substractPoint(e.cursor);});var s=0,a=1/0,l=e.map(function(e){var t=e.cursor,i=o.getLine(t.row).substr(t.column).search(/\S/g);return-1==i&&(i=0),t.column>s&&(s=t.column),i<a&&(a=i),i;});e.forEach(function(e,t){var i=e.cursor,n=s-i.column,r=l[t]-a;r<n?o.insert(i,f.stringRepeat(" ",n-r)):o.remove(new v(i.row,i.column,i.row,i.column-n+r)),e.start.column=e.end.column=s,e.start.row=e.end.row=i.row,e.cursor=e.end;}),t.fromOrientedRange(e[0]),this.renderer.updateCursor(),this.renderer.updateBackMarkers();}else{var r=this.selection.getRange(),c=r.start.row,h=r.end.row,d=c==h;if(d){for(var u,g=this.session.getLength();u=this.session.getLine(h),/[=:]/.test(u)&&++h<g;){}for(;u=this.session.getLine(c),/[=:]/.test(u)&&0<--c;){}c<0&&(c=0),g<=h&&(h=g-1);}var p=this.session.removeFullLines(c,h),p=this.$reAlignText(p,d);this.session.insert({row:c,column:0},p.join("\n")+"\n"),d||(r.start.column=0,r.end.column=p[p.length-1].length),this.selection.setRange(r);}},this.$reAlignText=function(e,t){var i,n,r,o=!0,s=!0;return e.map(function(e){var t=e.match(/(\s*)(.*?)(\s*)([=:].*)/);return t?(null==i?(i=t[1].length,n=t[2].length,r=t[3].length):(i+n+r!=t[1].length+t[2].length+t[3].length&&(s=!1),i!=t[1].length&&(o=!1),i>t[1].length&&(i=t[1].length),n<t[2].length&&(n=t[2].length),r>t[3].length&&(r=t[3].length)),t):[e];}).map(t?l:o?s?function(e){return e[2]?a(i+n-e[2].length)+e[2]+a(r)+e[4].replace(/^([=:])\s+/,"$1 "):e[0];}:l:function(e){return e[2]?a(i)+e[2]+a(r)+e[4].replace(/^([=:])\s+/,"$1 "):e[0];});function a(e){return f.stringRepeat(" ",e);}function l(e){return e[2]?a(i)+e[2]+a(n-e[2].length+r)+e[4].replace(/^([=:])\s+/,"$1 "):e[0];}};}).call(l.prototype),t.onSessionChange=function(e){var t=e.session;t&&!t.multiSelect&&(t.$selectionMarkers=[],t.selection.$initRangeList(),t.multiSelect=t.selection),this.multiSelect=t&&t.multiSelect;var i=e.oldSession;i&&(i.multiSelect.off("addRange",this.$onAddRange),i.multiSelect.off("removeRange",this.$onRemoveRange),i.multiSelect.off("multiSelect",this.$onMultiSelect),i.multiSelect.off("singleSelect",this.$onSingleSelect),i.multiSelect.lead.off("change",this.$checkMultiselectChange),i.multiSelect.anchor.off("change",this.$checkMultiselectChange)),t&&(t.multiSelect.on("addRange",this.$onAddRange),t.multiSelect.on("removeRange",this.$onRemoveRange),t.multiSelect.on("multiSelect",this.$onMultiSelect),t.multiSelect.on("singleSelect",this.$onSingleSelect),t.multiSelect.lead.on("change",this.$checkMultiselectChange),t.multiSelect.anchor.on("change",this.$checkMultiselectChange)),t&&this.inMultiSelectMode!=t.selection.inMultiSelectMode&&(t.selection.inMultiSelectMode?this.$onMultiSelect():this.$onSingleSelect());},t.MultiSelect=c,e("./config").defineOptions(l.prototype,"editor",{enableMultiselect:{set:function set(e){c(this),e?(this.on("changeSession",this.$multiselectOnSessionChange),this.on("mousedown",r)):(this.off("changeSession",this.$multiselectOnSessionChange),this.off("mousedown",r));},value:!0},enableBlockSelect:{set:function set(e){this.$blockSelectEnabled=e;},value:!0}});}),ace.define("ace/mode/folding/fold_mode",["require","exports","module","ace/range"],function(e,t,i){"use strict";var g=e("../../range").Range,n=t.FoldMode=function(){};(function(){this.foldingStartMarker=null,this.foldingStopMarker=null,this.getFoldWidget=function(e,t,i){var n=e.getLine(i);return this.foldingStartMarker.test(n)?"start":"markbeginend"==t&&this.foldingStopMarker&&this.foldingStopMarker.test(n)?"end":"";},this.getFoldWidgetRange=function(e,t,i){return null;},this.indentationBlock=function(e,t,i){var n=/\S/,r=e.getLine(t),o=r.search(n);if(-1!=o){for(var s=i||r.length,a=e.getLength(),l=t,c=t;++t<a;){var h=e.getLine(t).search(n);if(-1!=h){if(h<=o){var d=e.getTokenAt(t,0);if(!d||"string"!==d.type)break;}c=t;}}if(l<c){var u=e.getLine(c).length;return new g(l,s,c,u);}}},this.openingBracketBlock=function(e,t,i,n,r){var o={row:i,column:n+1},s=e.$findClosingBracket(t,o,r);if(s){var a=e.foldWidgets[s.row];return null==a&&(a=e.getFoldWidget(s.row)),"start"==a&&s.row>o.row&&(s.row--,s.column=e.getLine(s.row).length),g.fromPoints(o,s);}},this.closingBracketBlock=function(e,t,i,n,r){var o={row:i,column:n},s=e.$findOpeningBracket(t,o);if(s)return s.column++,o.column--,g.fromPoints(s,o);};}).call(n.prototype);}),ace.define("ace/theme/textmate",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";t.isDark=!1,t.cssClass="ace-tm",t.cssText='.ace-tm .ace_gutter {background: #f0f0f0;color: #333;}.ace-tm .ace_print-margin {width: 1px;background: #e8e8e8;}.ace-tm .ace_fold {background-color: #6B72E6;}.ace-tm {background-color: #FFFFFF;color: black;}.ace-tm .ace_cursor {color: black;}.ace-tm .ace_invisible {color: rgb(191, 191, 191);}.ace-tm .ace_storage,.ace-tm .ace_keyword {color: blue;}.ace-tm .ace_constant {color: rgb(197, 6, 11);}.ace-tm .ace_constant.ace_buildin {color: rgb(88, 72, 246);}.ace-tm .ace_constant.ace_language {color: rgb(88, 92, 246);}.ace-tm .ace_constant.ace_library {color: rgb(6, 150, 14);}.ace-tm .ace_invalid {background-color: rgba(255, 0, 0, 0.1);color: red;}.ace-tm .ace_support.ace_function {color: rgb(60, 76, 114);}.ace-tm .ace_support.ace_constant {color: rgb(6, 150, 14);}.ace-tm .ace_support.ace_type,.ace-tm .ace_support.ace_class {color: rgb(109, 121, 222);}.ace-tm .ace_keyword.ace_operator {color: rgb(104, 118, 135);}.ace-tm .ace_string {color: rgb(3, 106, 7);}.ace-tm .ace_comment {color: rgb(76, 136, 107);}.ace-tm .ace_comment.ace_doc {color: rgb(0, 102, 255);}.ace-tm .ace_comment.ace_doc.ace_tag {color: rgb(128, 159, 191);}.ace-tm .ace_constant.ace_numeric {color: rgb(0, 0, 205);}.ace-tm .ace_variable {color: rgb(49, 132, 149);}.ace-tm .ace_xml-pe {color: rgb(104, 104, 91);}.ace-tm .ace_entity.ace_name.ace_function {color: #0000A2;}.ace-tm .ace_heading {color: rgb(12, 7, 255);}.ace-tm .ace_list {color:rgb(185, 6, 144);}.ace-tm .ace_meta.ace_tag {color:rgb(0, 22, 142);}.ace-tm .ace_string.ace_regex {color: rgb(255, 0, 0)}.ace-tm .ace_marker-layer .ace_selection {background: rgb(181, 213, 255);}.ace-tm.ace_multiselect .ace_selection.ace_start {box-shadow: 0 0 3px 0px white;}.ace-tm .ace_marker-layer .ace_step {background: rgb(252, 255, 0);}.ace-tm .ace_marker-layer .ace_stack {background: rgb(164, 229, 101);}.ace-tm .ace_marker-layer .ace_bracket {margin: -1px 0 0 -1px;border: 1px solid rgb(192, 192, 192);}.ace-tm .ace_marker-layer .ace_active-line {background: rgba(0, 0, 0, 0.07);}.ace-tm .ace_gutter-active-line {background-color : #dcdcdc;}.ace-tm .ace_marker-layer .ace_selected-word {background: rgb(250, 250, 255);border: 1px solid rgb(200, 200, 250);}.ace-tm .ace_indent-guide {background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;}',t.$id="ace/theme/textmate",e("../lib/dom").importCssString(t.cssText,t.cssClass);}),ace.define("ace/line_widgets",["require","exports","module","ace/lib/dom"],function(e,t,i){"use strict";var r=e("./lib/dom");function n(e){this.session=e,(this.session.widgetManager=this).session.getRowLength=this.getRowLength,this.session.$getWidgetScreenLength=this.$getWidgetScreenLength,this.updateOnChange=this.updateOnChange.bind(this),this.renderWidgets=this.renderWidgets.bind(this),this.measureWidgets=this.measureWidgets.bind(this),this.session._changedWidgets=[],this.$onChangeEditor=this.$onChangeEditor.bind(this),this.session.on("change",this.updateOnChange),this.session.on("changeFold",this.updateOnFold),this.session.on("changeEditor",this.$onChangeEditor);}(function(){this.getRowLength=function(e){var t=this.lineWidgets&&this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0;return this.$useWrapMode&&this.$wrapData[e]?this.$wrapData[e].length+1+t:1+t;},this.$getWidgetScreenLength=function(){var t=0;return this.lineWidgets.forEach(function(e){e&&e.rowCount&&!e.hidden&&(t+=e.rowCount);}),t;},this.$onChangeEditor=function(e){this.attach(e.editor);},this.attach=function(e){e&&e.widgetManager&&e.widgetManager!=this&&e.widgetManager.detach(),this.editor!=e&&(this.detach(),(this.editor=e)&&(e.widgetManager=this,e.renderer.on("beforeRender",this.measureWidgets),e.renderer.on("afterRender",this.renderWidgets)));},this.detach=function(e){var t,i=this.editor;i&&(this.editor=null,i.widgetManager=null,i.renderer.off("beforeRender",this.measureWidgets),i.renderer.off("afterRender",this.renderWidgets),(t=this.session.lineWidgets)&&t.forEach(function(e){e&&e.el&&e.el.parentNode&&(e._inDocument=!1,e.el.parentNode.removeChild(e.el));}));},this.updateOnFold=function(e,t){var i=t.lineWidgets;if(i&&e.action){for(var n=e.data,r=n.start.row,o=n.end.row,s="add"==e.action,a=r+1;a<o;a++){i[a]&&(i[a].hidden=s);}i[o]&&(s?i[r]?i[o].hidden=s:i[r]=i[o]:(i[r]==i[o]&&(i[r]=void 0),i[o].hidden=s));}},this.updateOnChange=function(e){var t,i,n,r,o=this.session.lineWidgets;o&&(t=e.start.row,0==(i=e.end.row-t)||("remove"==e.action?(n=o.splice(t+1,i),!o[t]&&n[n.length-1]&&(o[t]=n.pop()),n.forEach(function(e){e&&this.removeLineWidget(e);},this)):(r=new Array(i),o[t]&&null!=o[t].column&&e.start.column>o[t].column&&t++,r.unshift(t,0),o.splice.apply(o,r)),this.$updateRows()));},this.$updateRows=function(){var i,e=this.session.lineWidgets;e&&(i=!0,e.forEach(function(e,t){if(e)for(i=!1,e.row=t;e.$oldWidget;){e.$oldWidget.row=t,e=e.$oldWidget;}}),i&&(this.session.lineWidgets=null));},this.$registerLineWidget=function(e){this.session.lineWidgets||(this.session.lineWidgets=new Array(this.session.getLength()));var t=this.session.lineWidgets[e.row];return t&&(e.$oldWidget=t).el&&t.el.parentNode&&(t.el.parentNode.removeChild(t.el),t._inDocument=!1),this.session.lineWidgets[e.row]=e;},this.addLineWidget=function(e){if(this.$registerLineWidget(e),e.session=this.session,!this.editor)return e;var t=this.editor.renderer;e.html&&!e.el&&(e.el=r.createElement("div"),e.el.innerHTML=e.html),e.el&&(r.addCssClass(e.el,"ace_lineWidgetContainer"),e.el.style.position="absolute",e.el.style.zIndex=5,t.container.appendChild(e.el),e._inDocument=!0,e.coverGutter||(e.el.style.zIndex=3),null==e.pixelHeight&&(e.pixelHeight=e.el.offsetHeight)),null==e.rowCount&&(e.rowCount=e.pixelHeight/t.layerConfig.lineHeight);var i,n=this.session.getFoldAt(e.row,0);return(e.$fold=n)&&(i=this.session.lineWidgets,e.row!=n.end.row||i[n.start.row]?e.hidden=!0:i[n.start.row]=e),this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows(),this.renderWidgets(null,t),this.onWidgetChanged(e),e;},this.removeLineWidget=function(e){if(e._inDocument=!1,e.session=null,e.el&&e.el.parentNode&&e.el.parentNode.removeChild(e.el),e.editor&&e.editor.destroy)try{e.editor.destroy();}catch(e){}if(this.session.lineWidgets){var t=this.session.lineWidgets[e.row];if(t==e)this.session.lineWidgets[e.row]=e.$oldWidget,e.$oldWidget&&this.onWidgetChanged(e.$oldWidget);else for(;t;){if(t.$oldWidget==e){t.$oldWidget=e.$oldWidget;break;}t=t.$oldWidget;}}this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows();},this.getWidgetsAtRow=function(e){for(var t=this.session.lineWidgets,i=t&&t[e],n=[];i;){n.push(i),i=i.$oldWidget;}return n;},this.onWidgetChanged=function(e){this.session._changedWidgets.push(e),this.editor&&this.editor.renderer.updateFull();},this.measureWidgets=function(e,t){var i=this.session._changedWidgets,n=t.layerConfig;if(i&&i.length){for(var r=1/0,o=0;o<i.length;o++){var s=i[o];if(s&&s.el&&s.session==this.session){if(!s._inDocument){if(this.session.lineWidgets[s.row]!=s)continue;s._inDocument=!0,t.container.appendChild(s.el);}s.h=s.el.offsetHeight,s.fixedWidth||(s.w=s.el.offsetWidth,s.screenWidth=Math.ceil(s.w/n.characterWidth));var a=s.h/n.lineHeight;s.coverLine&&(a-=this.session.getRowLineCount(s.row))<0&&(a=0),s.rowCount!=a&&(s.rowCount=a,s.row<r&&(r=s.row));}}r!=1/0&&(this.session._emit("changeFold",{data:{start:{row:r}}}),this.session.lineWidgetWidth=null),this.session._changedWidgets=[];}},this.renderWidgets=function(e,t){var i=t.layerConfig,n=this.session.lineWidgets;if(n){for(var r=Math.min(this.firstRow,i.firstRow),o=Math.max(this.lastRow,i.lastRow,n.length);0<r&&!n[r];){r--;}this.firstRow=i.firstRow,this.lastRow=i.lastRow,t.$cursorLayer.config=i;for(var s=r;s<=o;s++){var a,l,c=n[s];c&&c.el&&(c.hidden?c.el.style.top=-100-(c.pixelHeight||0)+"px":(c._inDocument||(c._inDocument=!0,t.container.appendChild(c.el)),a=t.$cursorLayer.getPixelPosition({row:s,column:0},!0).top,c.coverLine||(a+=i.lineHeight*this.session.getRowLineCount(c.row)),c.el.style.top=a-i.offset+"px",l=c.coverGutter?0:t.gutterWidth,c.fixedWidth||(l-=t.scrollLeft),c.el.style.left=l+"px",c.fullWidth&&c.screenWidth&&(c.el.style.minWidth=i.width+2*i.padding+"px"),c.fixedWidth?c.el.style.right=t.scrollBar.getWidth()+"px":c.el.style.right=""));}}};}).call(n.prototype),t.LineWidgets=n;}),ace.define("ace/ext/error_marker",["require","exports","module","ace/line_widgets","ace/lib/dom","ace/range"],function(e,t,i){"use strict";var p=e("../line_widgets").LineWidgets,m=e("../lib/dom"),a=e("../range").Range;function f(e,t,i){var n=e.getAnnotations().sort(a.comparePoints);if(n.length){var r=function(e,t,i){for(var n=0,r=e.length-1;n<=r;){var o=n+r>>1,s=i(t,e[o]);if(0<s)n=1+o;else{if(!(s<0))return o;r=o-1;}}return-(n+1);}(n,{row:t,column:-1},a.comparePoints);r<0&&(r=-r-1),r>=n.length?r=0<i?0:n.length-1:0===r&&i<0&&(r=n.length-1);var o=n[r];if(o&&i){if(o.row===t){for(;(o=n[r+=i])&&o.row===t;){}if(!o)return n.slice();}var s=[];for(t=o.row;s[i<0?"unshift":"push"](o),(o=n[r+=i])&&o.row==t;){}return s.length&&s;}}}t.showErrorMarker=function(e,t){var i=e.session;i.widgetManager||(i.widgetManager=new p(i),i.widgetManager.attach(e));var n=e.getCursorPosition(),r=n.row,o=i.widgetManager.getWidgetsAtRow(r).filter(function(e){return"errorMarker"==e.type;})[0];o?o.destroy():r-=t;var s,a=f(i,r,t);if(a){var l=a[0];n.column=(l.pos&&"number"!=typeof l.column?l.pos.sc:l.column)||0,n.row=l.row,s=e.renderer.$gutterLayer.$annotations[n.row];}else{if(o)return;s={text:["Looks good!"],className:"ace_ok"};}e.session.unfold(n.row),e.selection.moveToPosition(n);var c={row:n.row,fixedWidth:!0,coverGutter:!0,el:m.createElement("div"),type:"errorMarker"},h=c.el.appendChild(m.createElement("div")),d=c.el.appendChild(m.createElement("div"));d.className="error_widget_arrow "+s.className;var u=e.renderer.$cursorLayer.getPixelPosition(n).left;d.style.left=u+e.renderer.gutterWidth-5+"px",c.el.className="error_widget_wrapper",h.className="error_widget "+s.className,h.innerHTML=s.text.join("<br>"),h.appendChild(m.createElement("div"));function g(e,t,i){if(0===t&&("esc"===i||"return"===i))return c.destroy(),{command:"null"};}c.destroy=function(){e.$mouseHandler.isMousePressed||(e.keyBinding.removeKeyboardHandler(g),i.widgetManager.removeLineWidget(c),e.off("changeSelection",c.destroy),e.off("changeSession",c.destroy),e.off("mouseup",c.destroy),e.off("change",c.destroy));},e.keyBinding.addKeyboardHandler(g),e.on("changeSelection",c.destroy),e.on("changeSession",c.destroy),e.on("mouseup",c.destroy),e.on("change",c.destroy),e.session.widgetManager.addLineWidget(c),c.el.onmousedown=e.focus.bind(e),e.renderer.scrollCursorIntoView(null,.5,{bottom:c.el.offsetHeight});},m.importCssString("    .error_widget_wrapper {        background: inherit;        color: inherit;        border:none    }    .error_widget {        border-top: solid 2px;        border-bottom: solid 2px;        margin: 5px 0;        padding: 10px 40px;        white-space: pre-wrap;    }    .error_widget.ace_error, .error_widget_arrow.ace_error{        border-color: #ff5a5a    }    .error_widget.ace_warning, .error_widget_arrow.ace_warning{        border-color: #F1D817    }    .error_widget.ace_info, .error_widget_arrow.ace_info{        border-color: #5a5a5a    }    .error_widget.ace_ok, .error_widget_arrow.ace_ok{        border-color: #5aaa5a    }    .error_widget_arrow {        position: absolute;        border: solid 5px;        border-top-color: transparent!important;        border-right-color: transparent!important;        border-left-color: transparent!important;        top: -5px;    }","");}),ace.define("ace/ace",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/dom","ace/lib/event","ace/range","ace/editor","ace/edit_session","ace/undomanager","ace/virtual_renderer","ace/worker/worker_client","ace/keyboard/hash_handler","ace/placeholder","ace/multi_select","ace/mode/folding/fold_mode","ace/theme/textmate","ace/ext/error_marker","ace/config"],function(e,l,t){"use strict";e("./lib/fixoldbrowsers");var c=e("./lib/dom"),h=e("./lib/event"),i=e("./range").Range,d=e("./editor").Editor,n=e("./edit_session").EditSession,r=e("./undomanager").UndoManager,u=e("./virtual_renderer").VirtualRenderer;e("./worker/worker_client"),e("./keyboard/hash_handler"),e("./placeholder"),e("./multi_select"),e("./mode/folding/fold_mode"),e("./theme/textmate"),e("./ext/error_marker"),l.config=e("./config"),l.require=e,l.define=A(23),l.edit=function(e,t){if("string"==typeof e){var i=e;if(!(e=document.getElementById(i)))throw new Error("ace.edit can't find div #"+i);}if(e&&e.env&&e.env.editor instanceof d)return e.env.editor;var n,r="";e&&/input|textarea/i.test(e.tagName)?(r=(n=e).value,e=c.createElement("pre"),n.parentNode.replaceChild(e,n)):e&&(r=e.textContent,e.innerHTML="");var o=l.createEditSession(r),s=new d(new u(e),o,t),a={document:o,editor:s,onResize:s.resize.bind(s,null)};return n&&(a.textarea=n),h.addListener(window,"resize",a.onResize),s.on("destroy",function(){h.removeListener(window,"resize",a.onResize),a.editor.container.env=null;}),s.container.env=s.env=a,s;},l.createEditSession=function(e,t){var i=new n(e,t);return i.setUndoManager(new r()),i;},l.Range=i,l.Editor=d,l.EditSession=n,l.UndoManager=r,l.VirtualRenderer=u,l.version=l.config.version;}),ace.require(["ace/ace"],function(e){for(var t in e&&(e.config.init(!0),e.define=ace.define),window.ace||(window.ace=e),e){e.hasOwnProperty(t)&&(window.ace[t]=e[t]);}window.ace.default=window.ace,i&&(i.exports=window.ace);});}).call(this,A(16)(e));},function(e,t,i){(function(t){ace.define("ace/mode/json_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,i){"use strict";function n(){this.$rules={start:[{token:"variable",regex:'["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'},{token:"string",regex:'"',next:"string"},{token:"constant.numeric",regex:"0[xX][0-9a-fA-F]+\\b"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:"constant.language.boolean",regex:"(?:true|false)\\b"},{token:"text",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},{token:"comment",regex:"\\/\\/.*$"},{token:"comment.start",regex:"\\/\\*",next:"comment"},{token:"paren.lparen",regex:"[[({]"},{token:"paren.rparen",regex:"[\\])}]"},{token:"text",regex:"\\s+"}],string:[{token:"constant.language.escape",regex:/\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/},{token:"string",regex:'"|$',next:"start"},{defaultToken:"string"}],comment:[{token:"comment.end",regex:"\\*\\/",next:"start"},{defaultToken:"comment"}]};}var r=e("../lib/oop"),o=e("./text_highlight_rules").TextHighlightRules;r.inherits(n,o),t.JsonHighlightRules=n;}),ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"],function(e,t,i){"use strict";function n(){}var s=e("../range").Range;(function(){this.checkOutdent=function(e,t){return!!/^\s+$/.test(e)&&/^\s*\}/.test(t);},this.autoOutdent=function(e,t){var i=e.getLine(t).match(/^(\s*\})/);if(!i)return 0;var n=i[1].length,r=e.findMatchingBracket({row:t,column:n});if(!r||r.row==t)return 0;var o=this.$getIndent(e.getLine(r.row));e.replace(new s(t,0,t,n-1),o);},this.$getIndent=function(e){return e.match(/^\s*/)[0];};}).call(n.prototype),t.MatchingBraceOutdent=n;}),ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"],function(e,t,i){"use strict";var n=e("../../lib/oop"),h=e("../../range").Range,r=e("./fold_mode").FoldMode,o=t.FoldMode=function(e){e&&(this.foldingStartMarker=new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/,"|"+e.start)),this.foldingStopMarker=new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/,"|"+e.end)));};n.inherits(o,r),function(){this.foldingStartMarker=/([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/,this.foldingStopMarker=/^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/,this.singleLineBlockCommentRe=/^\s*(\/\*).*\*\/\s*$/,this.tripleStarBlockCommentRe=/^\s*(\/\*\*\*).*\*\/\s*$/,this.startRegionRe=/^\s*(\/\*|\/\/)#?region\b/,this._getFoldWidgetBase=this.getFoldWidget,this.getFoldWidget=function(e,t,i){var n=e.getLine(i);if(this.singleLineBlockCommentRe.test(n)&&!this.startRegionRe.test(n)&&!this.tripleStarBlockCommentRe.test(n))return"";var r=this._getFoldWidgetBase(e,t,i);return!r&&this.startRegionRe.test(n)?"start":r;},this.getFoldWidgetRange=function(e,t,i,n){var r=e.getLine(i);if(this.startRegionRe.test(r))return this.getCommentRegionBlock(e,r,i);var o=r.match(this.foldingStartMarker);if(o){var s=o.index;if(o[1])return this.openingBracketBlock(e,o[1],i,s);var a=e.getCommentFoldRange(i,s+o[0].length,1);return a&&!a.isMultiLine()&&(n?a=this.getSectionRange(e,i):"all"!=t&&(a=null)),a;}if("markbegin"!==t&&(o=r.match(this.foldingStopMarker))){s=o.index+o[0].length;return o[1]?this.closingBracketBlock(e,o[1],i,s):e.getCommentFoldRange(i,s,-1);}},this.getSectionRange=function(e,t){for(var i=e.getLine(t),n=i.search(/\S/),r=t,o=i.length,s=t+=1,a=e.getLength();++t<a;){var l=(i=e.getLine(t)).search(/\S/);if(-1!==l){if(l<n)break;var c=this.getFoldWidgetRange(e,"all",t);if(c){if(c.start.row<=r)break;if(c.isMultiLine())t=c.end.row;else if(n==l)break;}s=t;}}return new h(r,o,s,e.getLine(s).length);},this.getCommentRegionBlock=function(e,t,i){for(var n=t.search(/\s*$/),r=e.getLength(),o=i,s=/^\s*(?:\/\*|\/\/|--)#?(end)?region\b/,a=1;++i<r;){t=e.getLine(i);var l=s.exec(t);if(l&&(l[1]?a--:a++,!a))break;}if(o<i)return new h(o,n,i,t.length);};}.call(o.prototype);}),ace.define("ace/mode/json",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/json_highlight_rules","ace/mode/matching_brace_outdent","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle","ace/worker/worker_client"],function(e,t,i){"use strict";function n(){this.HighlightRules=s,this.$outdent=new a(),this.$behaviour=new l(),this.foldingRules=new c();}var r=e("../lib/oop"),o=e("./text").Mode,s=e("./json_highlight_rules").JsonHighlightRules,a=e("./matching_brace_outdent").MatchingBraceOutdent,l=e("./behaviour/cstyle").CstyleBehaviour,c=e("./folding/cstyle").FoldMode,h=e("../worker/worker_client").WorkerClient;r.inherits(n,o),function(){this.lineCommentStart="//",this.blockComment={start:"/*",end:"*/"},this.getNextLineIndent=function(e,t,i){var n=this.$getIndent(t);return"start"==e&&t.match(/^.*[\{\(\[]\s*$/)&&(n+=i),n;},this.checkOutdent=function(e,t,i){return this.$outdent.checkOutdent(t,i);},this.autoOutdent=function(e,t,i){this.$outdent.autoOutdent(t,i);},this.createWorker=function(t){var e=new h(["ace"],"ace/mode/json_worker","JsonWorker");return e.attachToDocument(t.getDocument()),e.on("annotate",function(e){t.setAnnotations(e.data);}),e.on("terminate",function(){t.clearAnnotations();}),e;},this.$id="ace/mode/json";}.call(n.prototype),t.Mode=n;}),ace.require(["ace/mode/json"],function(e){t&&(t.exports=e);});}).call(this,i(16)(e));},function(e,t,i){(function(t){ace.define("ace/ext/searchbox",["require","exports","module","ace/lib/dom","ace/lib/lang","ace/lib/event","ace/keyboard/hash_handler","ace/lib/keys"],function(e,t,i){"use strict";var r=e("../lib/dom"),n=e("../lib/lang"),s=e("../lib/event"),o='.ace_search {background-color: #ddd;color: #666;border: 1px solid #cbcbcb;border-top: 0 none;overflow: hidden;margin: 0;padding: 4px 6px 0 4px;position: absolute;top: 0;z-index: 99;white-space: normal;}.ace_search.left {border-left: 0 none;border-radius: 0px 0px 5px 0px;left: 0;}.ace_search.right {border-radius: 0px 0px 0px 5px;border-right: 0 none;right: 0;}.ace_search_form, .ace_replace_form {margin: 0 20px 4px 0;overflow: hidden;line-height: 1.9;}.ace_replace_form {margin-right: 0;}.ace_search_form.ace_nomatch {outline: 1px solid red;}.ace_search_field {border-radius: 3px 0 0 3px;background-color: white;color: black;border: 1px solid #cbcbcb;border-right: 0 none;outline: 0;padding: 0;font-size: inherit;margin: 0;line-height: inherit;padding: 0 6px;min-width: 17em;vertical-align: top;min-height: 1.8em;box-sizing: content-box;}.ace_searchbtn {border: 1px solid #cbcbcb;line-height: inherit;display: inline-block;padding: 0 6px;background: #fff;border-right: 0 none;border-left: 1px solid #dcdcdc;cursor: pointer;margin: 0;position: relative;color: #666;}.ace_searchbtn:last-child {border-radius: 0 3px 3px 0;border-right: 1px solid #cbcbcb;}.ace_searchbtn:disabled {background: none;cursor: default;}.ace_searchbtn:hover {background-color: #eef1f6;}.ace_searchbtn.prev, .ace_searchbtn.next {padding: 0px 0.7em}.ace_searchbtn.prev:after, .ace_searchbtn.next:after {content: "";border: solid 2px #888;width: 0.5em;height: 0.5em;border-width:  2px 0 0 2px;display:inline-block;transform: rotate(-45deg);}.ace_searchbtn.next:after {border-width: 0 2px 2px 0 ;}.ace_searchbtn_close {background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAZ0lEQVR42u2SUQrAMAhDvazn8OjZBilCkYVVxiis8H4CT0VrAJb4WHT3C5xU2a2IQZXJjiQIRMdkEoJ5Q2yMqpfDIo+XY4k6h+YXOyKqTIj5REaxloNAd0xiKmAtsTHqW8sR2W5f7gCu5nWFUpVjZwAAAABJRU5ErkJggg==) no-repeat 50% 0;border-radius: 50%;border: 0 none;color: #656565;cursor: pointer;font: 16px/16px Arial;padding: 0;height: 14px;width: 14px;top: 9px;right: 7px;position: absolute;}.ace_searchbtn_close:hover {background-color: #656565;background-position: 50% 100%;color: white;}.ace_button {margin-left: 2px;cursor: pointer;-webkit-user-select: none;-moz-user-select: none;-o-user-select: none;-ms-user-select: none;user-select: none;overflow: hidden;opacity: 0.7;border: 1px solid rgba(100,100,100,0.23);padding: 1px;box-sizing:    border-box!important;color: black;}.ace_button:hover {background-color: #eee;opacity:1;}.ace_button:active {background-color: #ddd;}.ace_button.checked {border-color: #3399ff;opacity:1;}.ace_search_options{margin-bottom: 3px;text-align: right;-webkit-user-select: none;-moz-user-select: none;-o-user-select: none;-ms-user-select: none;user-select: none;clear: both;}.ace_search_counter {float: left;font-family: arial;padding: 0 8px;}',a=e("../keyboard/hash_handler").HashHandler,l=e("../lib/keys");r.importCssString(o,"ace_searchbox");function c(e,t,i){var n=r.createElement("div");r.buildDom(["div",{class:"ace_search right"},["span",{action:"hide",class:"ace_searchbtn_close"}],["div",{class:"ace_search_form"},["input",{class:"ace_search_field",placeholder:"Search for",spellcheck:"false"}],["span",{action:"findPrev",class:"ace_searchbtn prev"},"​"],["span",{action:"findNext",class:"ace_searchbtn next"},"​"],["span",{action:"findAll",class:"ace_searchbtn",title:"Alt-Enter"},"All"]],["div",{class:"ace_replace_form"},["input",{class:"ace_search_field",placeholder:"Replace with",spellcheck:"false"}],["span",{action:"replaceAndFindNext",class:"ace_searchbtn"},"Replace"],["span",{action:"replaceAll",class:"ace_searchbtn"},"All"]],["div",{class:"ace_search_options"},["span",{action:"toggleReplace",class:"ace_button",title:"Toggle Replace mode",style:"float:left;margin-top:-2px;padding:0 5px;"},"+"],["span",{class:"ace_search_counter"}],["span",{action:"toggleRegexpMode",class:"ace_button",title:"RegExp Search"},".*"],["span",{action:"toggleCaseSensitive",class:"ace_button",title:"CaseSensitive Search"},"Aa"],["span",{action:"toggleWholeWords",class:"ace_button",title:"Whole Word Search"},"\\b"],["span",{action:"searchInSelection",class:"ace_button",title:"Search In Selection"},"S"]]],n),this.element=n.firstChild,this.setSession=this.setSession.bind(this),this.$init(),this.setEditor(e),r.importCssString(o,"ace_searchbox",e.container);}(function(){this.setEditor=function(e){e.searchBox=this,e.renderer.scroller.appendChild(this.element),this.editor=e;},this.setSession=function(e){this.searchRange=null,this.$syncOptions(!0);},this.$initElements=function(e){this.searchBox=e.querySelector(".ace_search_form"),this.replaceBox=e.querySelector(".ace_replace_form"),this.searchOption=e.querySelector("[action=searchInSelection]"),this.replaceOption=e.querySelector("[action=toggleReplace]"),this.regExpOption=e.querySelector("[action=toggleRegexpMode]"),this.caseSensitiveOption=e.querySelector("[action=toggleCaseSensitive]"),this.wholeWordOption=e.querySelector("[action=toggleWholeWords]"),this.searchInput=this.searchBox.querySelector(".ace_search_field"),this.replaceInput=this.replaceBox.querySelector(".ace_search_field"),this.searchCounter=e.querySelector(".ace_search_counter");},this.$init=function(){var e=this.element;this.$initElements(e);var o=this;s.addListener(e,"mousedown",function(e){setTimeout(function(){o.activeInput.focus();},0),s.stopPropagation(e);}),s.addListener(e,"click",function(e){var t=(e.target||e.srcElement).getAttribute("action");t&&o[t]?o[t]():o.$searchBarKb.commands[t]&&o.$searchBarKb.commands[t].exec(o),s.stopPropagation(e);}),s.addCommandKeyListener(e,function(e,t,i){var n=l.keyCodeToString(i),r=o.$searchBarKb.findKeyCommand(t,n);r&&r.exec&&(r.exec(o),s.stopEvent(e));}),this.$onChange=n.delayedCall(function(){o.find(!1,!1);}),s.addListener(this.searchInput,"input",function(){o.$onChange.schedule(20);}),s.addListener(this.searchInput,"focus",function(){o.activeInput=o.searchInput,o.searchInput.value&&o.highlight();}),s.addListener(this.replaceInput,"focus",function(){o.activeInput=o.replaceInput,o.searchInput.value&&o.highlight();});},this.$closeSearchBarKb=new a([{bindKey:"Esc",name:"closeSearchBar",exec:function exec(e){e.searchBox.hide();}}]),this.$searchBarKb=new a(),this.$searchBarKb.bindKeys({"Ctrl-f|Command-f":function CtrlFCommandF(e){var t=e.isReplace=!e.isReplace;e.replaceBox.style.display=t?"":"none",e.replaceOption.checked=!1,e.$syncOptions(),e.searchInput.focus();},"Ctrl-H|Command-Option-F":function CtrlHCommandOptionF(e){e.editor.getReadOnly()||(e.replaceOption.checked=!0,e.$syncOptions(),e.replaceInput.focus());},"Ctrl-G|Command-G":function CtrlGCommandG(e){e.findNext();},"Ctrl-Shift-G|Command-Shift-G":function CtrlShiftGCommandShiftG(e){e.findPrev();},esc:function esc(e){setTimeout(function(){e.hide();});},Return:function Return(e){e.activeInput==e.replaceInput&&e.replace(),e.findNext();},"Shift-Return":function ShiftReturn(e){e.activeInput==e.replaceInput&&e.replace(),e.findPrev();},"Alt-Return":function AltReturn(e){e.activeInput==e.replaceInput&&e.replaceAll(),e.findAll();},Tab:function Tab(e){(e.activeInput==e.replaceInput?e.searchInput:e.replaceInput).focus();}}),this.$searchBarKb.addCommands([{name:"toggleRegexpMode",bindKey:{win:"Alt-R|Alt-/",mac:"Ctrl-Alt-R|Ctrl-Alt-/"},exec:function exec(e){e.regExpOption.checked=!e.regExpOption.checked,e.$syncOptions();}},{name:"toggleCaseSensitive",bindKey:{win:"Alt-C|Alt-I",mac:"Ctrl-Alt-R|Ctrl-Alt-I"},exec:function exec(e){e.caseSensitiveOption.checked=!e.caseSensitiveOption.checked,e.$syncOptions();}},{name:"toggleWholeWords",bindKey:{win:"Alt-B|Alt-W",mac:"Ctrl-Alt-B|Ctrl-Alt-W"},exec:function exec(e){e.wholeWordOption.checked=!e.wholeWordOption.checked,e.$syncOptions();}},{name:"toggleReplace",exec:function exec(e){e.replaceOption.checked=!e.replaceOption.checked,e.$syncOptions();}},{name:"searchInSelection",exec:function exec(e){e.searchOption.checked=!e.searchRange,e.setSearchRange(e.searchOption.checked&&e.editor.getSelectionRange()),e.$syncOptions();}}]),this.setSearchRange=function(e){(this.searchRange=e)?this.searchRangeMarker=this.editor.session.addMarker(e,"ace_active-line"):this.searchRangeMarker&&(this.editor.session.removeMarker(this.searchRangeMarker),this.searchRangeMarker=null);},this.$syncOptions=function(e){r.setCssClass(this.replaceOption,"checked",this.searchRange),r.setCssClass(this.searchOption,"checked",this.searchOption.checked),this.replaceOption.textContent=this.replaceOption.checked?"-":"+",r.setCssClass(this.regExpOption,"checked",this.regExpOption.checked),r.setCssClass(this.wholeWordOption,"checked",this.wholeWordOption.checked),r.setCssClass(this.caseSensitiveOption,"checked",this.caseSensitiveOption.checked);var t=this.editor.getReadOnly();this.replaceOption.style.display=t?"none":"",this.replaceBox.style.display=this.replaceOption.checked&&!t?"":"none",this.find(!1,!1,e);},this.highlight=function(e){this.editor.session.highlight(e||this.editor.$search.$options.re),this.editor.renderer.updateBackMarkers();},this.find=function(e,t,i){var n=!this.editor.find(this.searchInput.value,{skipCurrent:e,backwards:t,wrap:!0,regExp:this.regExpOption.checked,caseSensitive:this.caseSensitiveOption.checked,wholeWord:this.wholeWordOption.checked,preventScroll:i,range:this.searchRange})&&this.searchInput.value;r.setCssClass(this.searchBox,"ace_nomatch",n),this.editor._emit("findSearchBox",{match:!n}),this.highlight(),this.updateCounter();},this.updateCounter=function(){var e=this.editor,t=e.$search.$options.re,i=0,n=0;if(t){var r=this.searchRange?e.session.getTextRange(this.searchRange):e.getValue(),o=e.session.doc.positionToIndex(e.selection.anchor);this.searchRange&&(o-=e.session.doc.positionToIndex(this.searchRange.start));for(var s,a=t.lastIndex=0;(s=t.exec(r))&&(i++,(a=s.index)<=o&&n++,!(999<i))&&(s[0]||(t.lastIndex=a+=1,!(a>=r.length)));){}}this.searchCounter.textContent=n+" of "+(999<i?"999+":i);},this.findNext=function(){this.find(!0,!1);},this.findPrev=function(){this.find(!0,!0);},this.findAll=function(){var e=!this.editor.findAll(this.searchInput.value,{regExp:this.regExpOption.checked,caseSensitive:this.caseSensitiveOption.checked,wholeWord:this.wholeWordOption.checked})&&this.searchInput.value;r.setCssClass(this.searchBox,"ace_nomatch",e),this.editor._emit("findSearchBox",{match:!e}),this.highlight(),this.hide();},this.replace=function(){this.editor.getReadOnly()||this.editor.replace(this.replaceInput.value);},this.replaceAndFindNext=function(){this.editor.getReadOnly()||(this.editor.replace(this.replaceInput.value),this.findNext());},this.replaceAll=function(){this.editor.getReadOnly()||this.editor.replaceAll(this.replaceInput.value);},this.hide=function(){this.active=!1,this.setSearchRange(null),this.editor.off("changeSession",this.setSession),this.element.style.display="none",this.editor.keyBinding.removeKeyboardHandler(this.$closeSearchBarKb),this.editor.focus();},this.show=function(e,t){this.active=!0,this.editor.on("changeSession",this.setSession),this.element.style.display="",this.replaceOption.checked=t,e&&(this.searchInput.value=e),this.searchInput.focus(),this.searchInput.select(),this.editor.keyBinding.addKeyboardHandler(this.$closeSearchBarKb),this.$syncOptions(!0);},this.isFocused=function(){var e=document.activeElement;return e==this.searchInput||e==this.replaceInput;};}).call(c.prototype),t.SearchBox=c,t.Search=function(e,t){(e.searchBox||new c(e)).show(e.session.getTextRange(),t);};}),ace.require(["ace/ext/searchbox"],function(e){t&&(t.exports=e);});}).call(this,i(16)(e));},function(e,t){e.exports="data:application/javascript;base64,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";},function(e,t,i){e.exports=function(){"use strict";var s=function s(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function");}},e=function(){function n(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n);}}return function(e,t,i){if(t)n(e.prototype,t);if(i)n(e,i);return e;};}(),m=function(){function i(e,t){var i=[];var n=true;var r=false;var o=undefined;try{for(var s=e[Symbol.iterator](),a;!(n=(a=s.next()).done);n=true){i.push(a.value);if(t&&i.length===t)break;}}catch(e){r=true;o=e;}finally{try{if(!n&&s["return"])s["return"]();}finally{if(r)throw o;}}return i;}return function(e,t){if(Array.isArray(e)){return e;}else if(Symbol.iterator in Object(e)){return i(e,t);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();String.prototype.startsWith=String.prototype.startsWith||function(e){return this.indexOf(e)===0;},String.prototype.padStart=String.prototype.padStart||function(e,t){var i=this;while(i.length<e){i=t+i;}return i;};var r={cb:"0f8ff",tqw:"aebd7",q:"-ffff",qmrn:"7fffd4",zr:"0ffff",bg:"5f5dc",bsq:"e4c4",bck:"---",nch:"ebcd",b:"--ff",bvt:"8a2be2",brwn:"a52a2a",brw:"deb887",ctb:"5f9ea0",hrt:"7fff-",chcT:"d2691e",cr:"7f50",rnw:"6495ed",crns:"8dc",crms:"dc143c",cn:"-ffff",Db:"--8b",Dcn:"-8b8b",Dgnr:"b8860b",Dgr:"a9a9a9",Dgrn:"-64-",Dkhk:"bdb76b",Dmgn:"8b-8b",Dvgr:"556b2f",Drng:"8c-",Drch:"9932cc",Dr:"8b--",Dsmn:"e9967a",Dsgr:"8fbc8f",DsTb:"483d8b",DsTg:"2f4f4f",Dtrq:"-ced1",Dvt:"94-d3",ppnk:"1493",pskb:"-bfff",mgr:"696969",grb:"1e90ff",rbrc:"b22222",rwht:"af0",stg:"228b22",chs:"-ff",gnsb:"dcdcdc",st:"8f8ff",g:"d7-",gnr:"daa520",gr:"808080",grn:"-8-0",grnw:"adff2f",hnw:"0fff0",htpn:"69b4",nnr:"cd5c5c",ng:"4b-82",vr:"0",khk:"0e68c",vnr:"e6e6fa",nrb:"0f5",wngr:"7cfc-",mnch:"acd",Lb:"add8e6",Lcr:"08080",Lcn:"e0ffff",Lgnr:"afad2",Lgr:"d3d3d3",Lgrn:"90ee90",Lpnk:"b6c1",Lsmn:"a07a",Lsgr:"20b2aa",Lskb:"87cefa",LsTg:"778899",Lstb:"b0c4de",Lw:"e0",m:"-ff-",mgrn:"32cd32",nn:"af0e6",mgnt:"-ff",mrn:"8--0",mqm:"66cdaa",mmb:"--cd",mmrc:"ba55d3",mmpr:"9370db",msg:"3cb371",mmsT:"7b68ee","":"-fa9a",mtr:"48d1cc",mmvt:"c71585",mnLb:"191970",ntc:"5fffa",mstr:"e4e1",mccs:"e4b5",vjw:"dead",nv:"--80",c:"df5e6",v:"808-0",vrb:"6b8e23",rng:"a5-",rngr:"45-",rch:"da70d6",pgnr:"eee8aa",pgrn:"98fb98",ptrq:"afeeee",pvtr:"db7093",ppwh:"efd5",pchp:"dab9",pr:"cd853f",pnk:"c0cb",pm:"dda0dd",pwrb:"b0e0e6",prp:"8-080",cc:"663399",r:"--",sbr:"bc8f8f",rb:"4169e1",sbrw:"8b4513",smn:"a8072",nbr:"4a460",sgrn:"2e8b57",ssh:"5ee",snn:"a0522d",svr:"c0c0c0",skb:"87ceeb",sTb:"6a5acd",sTgr:"708090",snw:"afa",n:"-ff7f",stb:"4682b4",tn:"d2b48c",t:"-8080",thst:"d8bfd8",tmT:"6347",trqs:"40e0d0",vt:"ee82ee",whT:"5deb3",wht:"",hts:"5f5f5",w:"-",wgrn:"9acd32"};function a(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var i=t>0?e.toFixed(t).replace(/0+$/,"").replace(/\.$/,""):e.toString();return i||"0";}var o=function(){function p(e,t,i,n){s(this,p);var g=this;function r(e){if(e.startsWith("hsl")){var t=e.match(/([\-\d\.e]+)/g).map(Number),i=m(t,4),n=i[0],r=i[1],o=i[2],s=i[3];if(s===undefined){s=1;}n/=360;r/=100;o/=100;g.hsla=[n,r,o,s];}else if(e.startsWith("rgb")){var a=e.match(/([\-\d\.e]+)/g).map(Number),l=m(a,4),c=l[0],h=l[1],d=l[2],u=l[3];if(u===undefined){u=1;}g.rgba=[c,h,d,u];}else{if(e.startsWith("#")){g.rgba=p.hexToRgb(e);}else{g.rgba=p.nameToRgb(e)||p.hexToRgb(e);}}}if(e===undefined);else if(Array.isArray(e)){this.rgba=e;}else if(i===undefined){var o=e&&""+e;if(o){r(o.toLowerCase());}}else{this.rgba=[e,t,i,n===undefined?1:n];}}e(p,[{key:"printRGB",value:function e(t){var i=t?this.rgba:this.rgba.slice(0,3),n=i.map(function(e,t){return a(e,t===3?3:0);});return t?"rgba("+n+")":"rgb("+n+")";}},{key:"printHSL",value:function e(t){var i=[360,100,100,1],n=["","%","%",""];var r=t?this.hsla:this.hsla.slice(0,3),o=r.map(function(e,t){return a(e*i[t],t===3?3:1)+n[t];});return t?"hsla("+o+")":"hsl("+o+")";}},{key:"printHex",value:function e(t){var i=this.hex;return t?i:i.substring(0,7);}},{key:"rgba",get:function e(){if(this._rgba){return this._rgba;}if(!this._hsla){throw new Error("No color is set");}return this._rgba=p.hslToRgb(this._hsla);},set:function e(t){if(t.length===3){t[3]=1;}this._rgba=t;this._hsla=null;}},{key:"rgbString",get:function e(){return this.printRGB();}},{key:"rgbaString",get:function e(){return this.printRGB(true);}},{key:"hsla",get:function e(){if(this._hsla){return this._hsla;}if(!this._rgba){throw new Error("No color is set");}return this._hsla=p.rgbToHsl(this._rgba);},set:function e(t){if(t.length===3){t[3]=1;}this._hsla=t;this._rgba=null;}},{key:"hslString",get:function e(){return this.printHSL();}},{key:"hslaString",get:function e(){return this.printHSL(true);}},{key:"hex",get:function e(){var t=this.rgba,i=t.map(function(e,t){return t<3?e.toString(16):Math.round(e*255).toString(16);});return"#"+i.map(function(e){return e.padStart(2,"0");}).join("");},set:function e(t){this.rgba=p.hexToRgb(t);}}],[{key:"hexToRgb",value:function e(t){var i=(t.startsWith("#")?t.slice(1):t).replace(/^(\w{3})$/,"$1F").replace(/^(\w)(\w)(\w)(\w)$/,"$1$1$2$2$3$3$4$4").replace(/^(\w{6})$/,"$1FF");if(!i.match(/^([0-9a-fA-F]{8})$/)){throw new Error("Unknown hex color; "+t);}var n=i.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function(e){return parseInt(e,16);});n[3]=n[3]/255;return n;}},{key:"nameToRgb",value:function e(t){var i=t.toLowerCase().replace("at","T").replace(/[aeiouyldf]/g,"").replace("ght","L").replace("rk","D").slice(-5,4),n=r[i];return n===undefined?n:p.hexToRgb(n.replace(/\-/g,"00").padStart(6,"f"));}},{key:"rgbToHsl",value:function e(t){var i=m(t,4),n=i[0],r=i[1],o=i[2],s=i[3];n/=255;r/=255;o/=255;var a=Math.max(n,r,o),l=Math.min(n,r,o);var c=void 0,h=void 0,d=(a+l)/2;if(a===l){c=h=0;}else{var u=a-l;h=d>.5?u/(2-a-l):u/(a+l);switch(a){case n:c=(r-o)/u+(r<o?6:0);break;case r:c=(o-n)/u+2;break;case o:c=(n-r)/u+4;break;}c/=6;}return[c,h,d,s];}},{key:"hslToRgb",value:function e(t){var i=m(t,4),n=i[0],r=i[1],o=i[2],s=i[3];var a=void 0,l=void 0,c=void 0;if(r===0){a=l=c=o;}else{var h=function e(t,i,n){if(n<0)n+=1;if(n>1)n-=1;if(n<1/6)return t+(i-t)*6*n;if(n<1/2)return i;if(n<2/3)return t+(i-t)*(2/3-n)*6;return t;};var d=o<.5?o*(1+r):o+r-o*r,u=2*o-d;a=h(u,d,n+1/3);l=h(u,d,n);c=h(u,d,n-1/3);}var g=[a*255,l*255,c*255].map(Math.round);g[3]=s;return g;}}]);return p;}(),i=function(){function o(){s(this,o);this._events=[];}e(o,[{key:"add",value:function e(t,i,n){t.addEventListener(i,n,false);this._events.push({target:t,type:i,handler:n});}},{key:"remove",value:function e(i,n,r){this._events=this._events.filter(function(e){var t=true;if(i&&i!==e.target){t=false;}if(n&&n!==e.type){t=false;}if(r&&r!==e.handler){t=false;}if(t){o._doRemove(e.target,e.type,e.handler);}return!t;});}},{key:"destroy",value:function e(){this._events.forEach(function(e){return o._doRemove(e.target,e.type,e.handler);});this._events=[];}}],[{key:"_doRemove",value:function e(t,i,n){t.removeEventListener(i,n,false);}}]);return o;}();function t(e){var i=document.createElement("div");return t.innerHTML=e,t.firstElementChild;}function l(e,h,d){var u=false;function g(e,t,i){return Math.max(t,Math.min(e,i));}function n(e,t,i){if(i){u=true;}if(!u){return;}e.preventDefault();var n=h.getBoundingClientRect(),r=n.width,o=n.height,s=t.clientX,a=t.clientY;var l=g(s-n.left,0,r),c=g(a-n.top,0,o);d(l/r,c/o);}function t(e,t){var i=e.buttons===undefined?e.which:e.buttons;if(i===1){n(e,e,t);}else{u=false;}}function i(e,t){if(e.touches.length===1){n(e,e.touches[0],t);}else{u=false;}}e.add(h,"mousedown",function(e){t(e,true);});e.add(h,"touchstart",function(e){i(e,true);});e.add(window,"mousemove",t);e.add(h,"touchmove",i);e.add(window,"mouseup",function(e){u=false;});e.add(h,"touchend",function(e){u=false;});e.add(h,"touchcancel",function(e){u=false;});}var n="url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='2' height='2'%3E%3Cpath d='M1,0H0V1H2V2H1' fill='lightgrey'/%3E%3C/svg%3E\")",c=360,h="keydown",d="mousedown",u="focusin";function v(e,t){return(t||document).querySelector(e);}function g(e){e.preventDefault();e.stopPropagation();}function p(e,t,i,n,r){e.add(t,h,function(e){if(i.indexOf(e.key)>=0){if(r){g(e);}n(e);}});}var f=document.createElement("style"),C;return f.textContent=".picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-flow:row wrap;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:stretch;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:'';display:block;width:100%;height:0;-webkit-box-ordinal-group:2;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{-webkit-box-flex:1;flex:1 1 auto}.layout_default .picker_sl::before{content:'';display:block;padding-bottom:100%}.layout_default .picker_editor{-webkit-box-ordinal-group:2;order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{-webkit-box-ordinal-group:2;order:1;-webkit-box-flex:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{-webkit-box-ordinal-group:2;order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px dodgerblue}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:whitesmoke;background-image:-webkit-gradient(linear, left bottom, left top, from(gainsboro), to(transparent));background-image:-webkit-linear-gradient(bottom, gainsboro, transparent);background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:-webkit-gradient(linear, left bottom, left top, from(transparent), to(gainsboro));background-image:-webkit-linear-gradient(bottom, transparent, gainsboro);background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:white}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid white;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:-webkit-gradient(linear, left top, right top, from(red), color-stop(yellow), color-stop(lime), color-stop(cyan), color-stop(blue), color-stop(magenta), to(red));background-image:-webkit-linear-gradient(left, red, yellow, lime, cyan, blue, magenta, red);background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:-webkit-gradient(linear, left top, left bottom, from(white), color-stop(50%, rgba(255,255,255,0))),-webkit-gradient(linear, left bottom, left top, from(black), color-stop(50%, rgba(0,0,0,0))),-webkit-gradient(linear, left top, right top, from(gray), to(rgba(128,128,128,0)));background-image:-webkit-linear-gradient(top, white, rgba(255,255,255,0) 50%),-webkit-linear-gradient(bottom, black, rgba(0,0,0,0) 50%),-webkit-linear-gradient(left, gray, rgba(128,128,128,0));background-image:linear-gradient(180deg, white, rgba(255,255,255,0) 50%),linear-gradient(0deg, black, rgba(0,0,0,0) 50%),linear-gradient(90deg, gray, rgba(128,128,128,0))}.picker_alpha,.picker_sample{position:relative;background:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='2' height='2'%3E%3Cpath d='M1,0H0V1H2V2H1' fill='lightgrey'/%3E%3C/svg%3E\") left top/contain white;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:'';position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,0.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:\"\";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}",document.documentElement.firstElementChild.appendChild(f),function(){function t(e){s(this,t),this.settings={popup:"right",layout:"default",alpha:!0,editor:!0,editorFormat:"hex",cancelButton:!1,defaultColor:"#0cf"},this._events=new i(),this.onChange=null,this.onDone=null,this.onOpen=null,this.onClose=null,this.setOptions(e);}return e(t,[{key:"setOptions",value:function value(e){var t,i,n,r,o=this;e&&(t=this.settings,e instanceof HTMLElement?t.parent=e:(t.parent&&e.parent&&t.parent!==e.parent&&(this._events.remove(t.parent),this._popupInited=!1),function(e,t,i){for(var n in e){i&&0<=i.indexOf(n)||(t[n]=e[n]);}}(e,t),e.onChange&&(this.onChange=e.onChange),e.onDone&&(this.onDone=e.onDone),e.onOpen&&(this.onOpen=e.onOpen),e.onClose&&(this.onClose=e.onClose),(i=e.color||e.colour)&&this._setColor(i)),(n=t.parent)&&t.popup&&!this._popupInited?(r=function r(e){return o.openHandler(e);},this._events.add(n,"click",r),p(this._events,n,[" ","Spacebar","Enter"],r),this._popupInited=!0):e.parent&&!t.popup&&this.show());}},{key:"openHandler",value:function value(e){var t;this.show()&&(e&&e.preventDefault(),this.settings.parent.style.pointerEvents="none",t=e&&"keydown"===e.type?this._domEdit:this.domElement,setTimeout(function(){return t.focus();},100),this.onOpen&&this.onOpen(this.colour));}},{key:"closeHandler",value:function value(e){var t,i=e&&e.type,n=!1;e?i===d||i===u?(t=(this.__containedEvent||0)+100,e.timeStamp>t&&(n=!0)):(g(e),n=!0):n=!0,n&&this.hide()&&(this.settings.parent.style.pointerEvents="",i!==d&&this.settings.parent.focus(),this.onClose&&this.onClose(this.colour));}},{key:"movePopup",value:function value(e,t){this.closeHandler(),this.setOptions(e),t&&this.openHandler();}},{key:"setColor",value:function value(e,t){this._setColor(e,{silent:t});}},{key:"_setColor",value:function value(e,t){if("string"==typeof e&&(e=e.trim()),e){t=t||{};var i,n=void 0;try{n=new o(e);}catch(e){if(t.failSilently)return;throw e;}this.settings.alpha||((i=n.hsla)[3]=1,n.hsla=i),this.colour=this.color=n,this._setHSLA(null,null,null,null,t);}}},{key:"setColour",value:function value(e,t){this.setColor(e,t);}},{key:"show",value:function value(){if(!this.settings.parent)return!1;if(this.domElement){var e=this._toggleDOM(!0);return this._setPosition(),e;}var t,i,n=this.settings.template||'<div class="picker_wrapper" tabindex="-1"><div class="picker_arrow"></div><div class="picker_hue picker_slider"><div class="picker_selector"></div></div><div class="picker_sl"><div class="picker_selector"></div></div><div class="picker_alpha picker_slider"><div class="picker_selector"></div></div><div class="picker_editor"><input aria-label="Type a color name or hex value"/></div><div class="picker_sample"></div><div class="picker_done"><button>Ok</button></div><div class="picker_cancel"><button>Cancel</button></div></div>',r=(t=n,(i=document.createElement("div")).innerHTML=t,i.firstElementChild);return this.domElement=r,this._domH=v(".picker_hue",r),this._domSL=v(".picker_sl",r),this._domA=v(".picker_alpha",r),this._domEdit=v(".picker_editor input",r),this._domSample=v(".picker_sample",r),this._domOkay=v(".picker_done button",r),this._domCancel=v(".picker_cancel button",r),r.classList.add("layout_"+this.settings.layout),this.settings.alpha||r.classList.add("no_alpha"),this.settings.editor||r.classList.add("no_editor"),this.settings.cancelButton||r.classList.add("no_cancel"),this._ifPopup(function(){return r.classList.add("popup");}),this._setPosition(),this.colour?this._updateUI():this._setColor(this.settings.defaultColor),this._bindEvents(),!0;}},{key:"hide",value:function value(){return this._toggleDOM(!1);}},{key:"destroy",value:function value(){this._events.destroy(),this.domElement&&this.settings.parent.removeChild(this.domElement);}},{key:"_bindEvents",value:function value(){var i=this,n=this,r=this.domElement,o=this._events;function s(e,t,i){o.add(e,t,i);}s(r,"click",function(e){return e.preventDefault();}),l(o,this._domH,function(e,t){return n._setHSLA(e);}),l(o,this._domSL,function(e,t){return n._setHSLA(null,e,1-t);}),this.settings.alpha&&l(o,this._domA,function(e,t){return n._setHSLA(null,null,null,1-t);});var e=this._domEdit;s(e,"input",function(e){n._setColor(this.value,{fromEditor:!0,failSilently:!0});}),s(e,"focus",function(e){this.selectionStart===this.selectionEnd&&this.select();}),this._ifPopup(function(){function e(e){return i.closeHandler(e);}s(window,d,e),s(window,u,e),p(o,r,["Esc","Escape"],e);function t(e){i.__containedEvent=e.timeStamp;}s(r,d,t),s(r,u,t),s(i._domCancel,"click",e);});function t(e){i._ifPopup(function(){return i.closeHandler(e);}),i.onDone&&i.onDone(i.colour);}s(this._domOkay,"click",t),p(o,r,["Enter"],t);}},{key:"_setPosition",value:function value(){var i=this.settings.parent,n=this.domElement;i!==n.parentNode&&i.appendChild(n),this._ifPopup(function(e){"static"===getComputedStyle(i).position&&(i.style.position="relative");var t=!0===e?"popup_right":"popup_"+e;["popup_top","popup_bottom","popup_left","popup_right"].forEach(function(e){e===t?n.classList.add(e):n.classList.remove(e);}),n.classList.add(t);});}},{key:"_setHSLA",value:function value(e,t,i,n,r){r=r||{};var o=this.colour,s=o.hsla;[e,t,i,n].forEach(function(e,t){!e&&0!==e||(s[t]=e);}),o.hsla=s,this._updateUI(r),this.onChange&&!r.silent&&this.onChange(o);}},{key:"_updateUI",value:function value(e){if(this.domElement){e=e||{};var t=this.colour,i=t.hsla,n="hsl("+360*i[0]+", 100%, 50%)",r=t.hslString,o=t.hslaString,s=this._domH,a=this._domSL,l=this._domA,c=v(".picker_selector",s),h=v(".picker_selector",a),d=v(".picker_selector",l);I(0,c,i[0]),this._domSL.style.backgroundColor=this._domH.style.color=n,I(0,h,i[1]),A(0,h,1-i[2]),a.style.color=r,A(0,d,1-i[3]);var u=r,g=u.replace("hsl","hsla").replace(")",", 0)"),p="linear-gradient("+[u,g]+")";if(this._domA.style.backgroundImage=p+", url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='2' height='2'%3E%3Cpath d='M1,0H0V1H2V2H1' fill='lightgrey'/%3E%3C/svg%3E\")",!e.fromEditor){var m=this.settings.editorFormat,f=this.settings.alpha,C=void 0;switch(m){case"rgb":C=t.printRGB(f);break;case"hsl":C=t.printHSL(f);break;default:C=t.printHex(f);}this._domEdit.value=C;}this._domSample.style.color=o;}function I(e,t,i){t.style.left=100*i+"%";}function A(e,t,i){t.style.top=100*i+"%";}}},{key:"_ifPopup",value:function value(e,t){this.settings.parent&&this.settings.popup?e&&e(this.settings.popup):t&&t();}},{key:"_toggleDOM",value:function value(e){var t=this.domElement;if(!t)return!1;var i=e?"":"none",n=t.style.display!==i;return n&&(t.style.display=i),n;}}],[{key:"StyleElement",get:function get(){return f;}}]),t;}();}();},function(e,t){window.ace.define("ace/theme/jsoneditor",["require","exports","module","ace/lib/dom"],function(e,t,i){t.isDark=!1,t.cssClass="ace-jsoneditor",t.cssText='.ace-jsoneditor .ace_gutter {\nbackground: #ebebeb;\ncolor: #333\n}\n\n.ace-jsoneditor.ace_editor {\nfont-family: "dejavu sans mono", "droid sans mono", consolas, monaco, "lucida console", "courier new", courier, monospace, sans-serif;\nline-height: 1.3;\nbackground-color: #fff;\n}\n.ace-jsoneditor .ace_print-margin {\nwidth: 1px;\nbackground: #e8e8e8\n}\n.ace-jsoneditor .ace_scroller {\nbackground-color: #FFFFFF\n}\n.ace-jsoneditor .ace_text-layer {\ncolor: gray\n}\n.ace-jsoneditor .ace_variable {\ncolor: #1a1a1a\n}\n.ace-jsoneditor .ace_cursor {\nborder-left: 2px solid #000000\n}\n.ace-jsoneditor .ace_overwrite-cursors .ace_cursor {\nborder-left: 0px;\nborder-bottom: 1px solid #000000\n}\n.ace-jsoneditor .ace_marker-layer .ace_selection {\nbackground: lightgray\n}\n.ace-jsoneditor.ace_multiselect .ace_selection.ace_start {\nbox-shadow: 0 0 3px 0px #FFFFFF;\nborder-radius: 2px\n}\n.ace-jsoneditor .ace_marker-layer .ace_step {\nbackground: rgb(255, 255, 0)\n}\n.ace-jsoneditor .ace_marker-layer .ace_bracket {\nmargin: -1px 0 0 -1px;\nborder: 1px solid #BFBFBF\n}\n.ace-jsoneditor .ace_marker-layer .ace_active-line {\nbackground: #FFFBD1\n}\n.ace-jsoneditor .ace_gutter-active-line {\nbackground-color : #dcdcdc\n}\n.ace-jsoneditor .ace_marker-layer .ace_selected-word {\nborder: 1px solid lightgray\n}\n.ace-jsoneditor .ace_invisible {\ncolor: #BFBFBF\n}\n.ace-jsoneditor .ace_keyword,\n.ace-jsoneditor .ace_meta,\n.ace-jsoneditor .ace_support.ace_constant.ace_property-value {\ncolor: #AF956F\n}\n.ace-jsoneditor .ace_keyword.ace_operator {\ncolor: #484848\n}\n.ace-jsoneditor .ace_keyword.ace_other.ace_unit {\ncolor: #96DC5F\n}\n.ace-jsoneditor .ace_constant.ace_language {\ncolor: darkorange\n}\n.ace-jsoneditor .ace_constant.ace_numeric {\ncolor: red\n}\n.ace-jsoneditor .ace_constant.ace_character.ace_entity {\ncolor: #BF78CC\n}\n.ace-jsoneditor .ace_invalid {\ncolor: #FFFFFF;\nbackground-color: #FF002A;\n}\n.ace-jsoneditor .ace_fold {\nbackground-color: #AF956F;\nborder-color: #000000\n}\n.ace-jsoneditor .ace_storage,\n.ace-jsoneditor .ace_support.ace_class,\n.ace-jsoneditor .ace_support.ace_function,\n.ace-jsoneditor .ace_support.ace_other,\n.ace-jsoneditor .ace_support.ace_type {\ncolor: #C52727\n}\n.ace-jsoneditor .ace_string {\ncolor: green\n}\n.ace-jsoneditor .ace_comment {\ncolor: #BCC8BA\n}\n.ace-jsoneditor .ace_entity.ace_name.ace_tag,\n.ace-jsoneditor .ace_entity.ace_other.ace_attribute-name {\ncolor: #606060\n}\n.ace-jsoneditor .ace_markup.ace_underline {\ntext-decoration: underline\n}\n.ace-jsoneditor .ace_indent-guide {\nbackground: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y\n}',e("../lib/dom").importCssString(t.cssText,t.cssClass);});},function(e,t,i){t.tryRequireAjv=function(){try{return i(44);}catch(e){}};},function(e,t,n){"use strict";var a=n(45),u=n(17),i=n(49),g=n(25),r=n(26),o=n(50),s=n(51),l=n(72),c=n(7);(e.exports=C).prototype.validate=function(e,t){var i;if("string"==typeof e){if(!(i=this.getSchema(e)))throw new Error('no schema with key or ref "'+e+'"');}else{var n=this._addSchema(e);i=n.validate||this._compile(n);}var r=i(t);!0!==i.$async&&(this.errors=i.errors);return r;},C.prototype.compile=function(e,t){var i=this._addSchema(e,void 0,t);return i.validate||this._compile(i);},C.prototype.addSchema=function(e,t,i,n){if(Array.isArray(e)){for(var r=0;r<e.length;r++){this.addSchema(e[r],void 0,i,n);}return this;}var o=this._getId(e);if(void 0!==o&&"string"!=typeof o)throw new Error("schema id must be string");return w(this,t=u.normalizeId(t||o)),this._schemas[t]=this._addSchema(e,i,n,!0),this;},C.prototype.addMetaSchema=function(e,t,i){return this.addSchema(e,t,i,!0),this;},C.prototype.validateSchema=function(e,t){var i=e.$schema;if(void 0!==i&&"string"!=typeof i)throw new Error("$schema must be a string");if(!(i=i||this._opts.defaultMeta||function(e){var t=e._opts.meta;return e._opts.defaultMeta="object"==(typeof t==="undefined"?"undefined":_typeof(t))?e._getId(t)||t:e.getSchema(p)?p:void 0,e._opts.defaultMeta;}(this)))return this.logger.warn("meta-schema not available"),!(this.errors=null);var n=this.validate(i,e);if(!n&&t){var r="schema is invalid: "+this.errorsText();if("log"!=this._opts.validateSchema)throw new Error(r);this.logger.error(r);}return n;},C.prototype.getSchema=function(e){var t=I(this,e);switch(typeof t==="undefined"?"undefined":_typeof(t)){case"object":return t.validate||this._compile(t);case"string":return this.getSchema(t);case"undefined":return function(e,t){var i=u.schema.call(e,{schema:{}},t);if(i){var n=i.schema,r=i.root,o=i.baseId,s=a.call(e,n,r,void 0,o);return e._fragments[t]=new g({ref:t,fragment:!0,schema:n,root:r,baseId:o,validate:s}),s;}}(this,e);}},C.prototype.removeSchema=function(e){if(e instanceof RegExp)return A(this,this._schemas,e),A(this,this._refs,e),this;switch(typeof e==="undefined"?"undefined":_typeof(e)){case"undefined":return A(this,this._schemas),A(this,this._refs),this._cache.clear(),this;case"string":var t=I(this,e);return t&&this._cache.del(t.cacheKey),delete this._schemas[e],delete this._refs[e],this;case"object":var i=this._opts.serialize,n=i?i(e):e;this._cache.del(n);var r=this._getId(e);r&&(r=u.normalizeId(r),delete this._schemas[r],delete this._refs[r]);}return this;},C.prototype.addFormat=function(e,t){"string"==typeof t&&(t=new RegExp(t));return this._formats[e]=t,this;},C.prototype.errorsText=function(e,t){if(!(e=e||this.errors))return"No errors";for(var i=void 0===(t=t||{}).separator?", ":t.separator,n=void 0===t.dataVar?"data":t.dataVar,r="",o=0;o<e.length;o++){var s=e[o];s&&(r+=n+s.dataPath+" "+s.message+i);}return r.slice(0,-i.length);},C.prototype._addSchema=function(e,t,i,n){if("object"!=(typeof e==="undefined"?"undefined":_typeof(e))&&"boolean"!=typeof e)throw new Error("schema should be object or boolean");var r=this._opts.serialize,o=r?r(e):e,s=this._cache.get(o);if(s)return s;n=n||!1!==this._opts.addUsedSchema;var a=u.normalizeId(this._getId(e));a&&n&&w(this,a);var l,c=!1!==this._opts.validateSchema&&!t;c&&!(l=a&&a==u.normalizeId(e.$schema))&&this.validateSchema(e,!0);var h=u.ids.call(this,e),d=new g({id:a,schema:e,localRefs:h,cacheKey:o,meta:i});"#"!=a[0]&&n&&(this._refs[a]=d);this._cache.put(o,d),c&&l&&this.validateSchema(e,!0);return d;},C.prototype._compile=function(i,e){if(i.compiling)return(i.validate=r).schema=i.schema,r.errors=null,r.root=e||r,!0===i.schema.$async&&(r.$async=!0),r;var t,n;i.compiling=!0,i.meta&&(t=this._opts,this._opts=this._metaOpts);try{n=a.call(this,i.schema,e,i.localRefs);}catch(e){throw delete i.validate,e;}finally{i.compiling=!1,i.meta&&(this._opts=t);}return i.validate=n,i.refs=n.refs,i.refVal=n.refVal,i.root=n.root,n;function r(){var e=i.validate,t=e.apply(this,arguments);return r.errors=e.errors,t;}},C.prototype.compileAsync=n(73);var h=n(74);C.prototype.addKeyword=h.add,C.prototype.getKeyword=h.get,C.prototype.removeKeyword=h.remove,C.prototype.validateKeyword=h.validate;var d=n(19);C.ValidationError=d.Validation,C.MissingRefError=d.MissingRef,C.$dataMetaSchema=l;var p="http://json-schema.org/draft-07/schema",m=["removeAdditional","useDefaults","coerceTypes","strictDefaults"],f=["/properties"];function C(e){if(!(this instanceof C))return new C(e);e=this._opts=c.copy(e)||{},function(e){var t=e._opts.logger;if(!1===t)e.logger={log:S,warn:S,error:S};else{if(void 0===t&&(t=console),!("object"==(typeof t==="undefined"?"undefined":_typeof(t))&&t.log&&t.warn&&t.error))throw new Error("logger must implement log, warn and error methods");e.logger=t;}}(this),this._schemas={},this._refs={},this._fragments={},this._formats=o(e.format),this._cache=e.cache||new i(),this._loadingSchemas={},this._compilations=[],this.RULES=s(),this._getId=function(e){switch(e.schemaId){case"auto":return y;case"id":return v;default:return b;}}(e),e.loopRequired=e.loopRequired||1/0,"property"==e.errorDataPath&&(e._errorDataPathProperty=!0),void 0===e.serialize&&(e.serialize=r),this._metaOpts=function(e){for(var t=c.copy(e._opts),i=0;i<m.length;i++){delete t[m[i]];}return t;}(this),e.formats&&function(e){for(var t in e._opts.formats){var i=e._opts.formats[t];e.addFormat(t,i);}}(this),e.keywords&&function(e){for(var t in e._opts.keywords){var i=e._opts.keywords[t];e.addKeyword(t,i);}}(this),function(e){var t;e._opts.$data&&(t=n(77),e.addMetaSchema(t,t.$id,!0));if(!1===e._opts.meta)return;var i=n(32);e._opts.$data&&(i=l(i,f));e.addMetaSchema(i,p,!0),e._refs["http://json-schema.org/schema"]=p;}(this),"object"==_typeof(e.meta)&&this.addMetaSchema(e.meta),e.nullable&&this.addKeyword("nullable",{metaSchema:{type:"boolean"}}),function(e){var t=e._opts.schemas;if(!t)return;if(Array.isArray(t))e.addSchema(t);else for(var i in t){e.addSchema(t[i],i);}}(this);}function I(e,t){return t=u.normalizeId(t),e._schemas[t]||e._refs[t]||e._fragments[t];}function A(e,t,i){for(var n in t){var r=t[n];r.meta||i&&!i.test(n)||(e._cache.del(r.cacheKey),delete t[n]);}}function v(e){return e.$id&&this.logger.warn("schema $id ignored",e.$id),e.id;}function b(e){return e.id&&this.logger.warn("schema id ignored",e.id),e.$id;}function y(e){if(e.$id&&e.id&&e.$id!=e.id)throw new Error("schema $id is different from id");return e.$id||e.id;}function w(e,t){if(e._schemas[t]||e._refs[t])throw new Error('schema with key or id "'+t+'" already exists');}function S(){}},function(e,t,i){"use strict";var R=i(17),E=i(7),B=i(19),Z=i(26),T=i(27),G=E.ucs2length,W=i(18),_=B.Validation;function H(e,d,u,t){var g=this,p=this._opts,m=[void 0],f={},l=[],i={},c=[],n={},C=[],r=function(e,t,i){var n=L.call(this,e,t,i);return 0<=n?{index:n,compiling:!0}:(n=this._compilations.length,this._compilations[n]={schema:e,root:t,baseId:i},{index:n,compiling:!1});}.call(this,e,d=d||{schema:e,refVal:m,refs:f},t),o=this._compilations[r.index];if(r.compiling)return o.callValidate=A;var h=this._formats,I=this.RULES;try{var s=v(e,d,u,t);o.validate=s;var a=o.callValidate;return a&&(a.schema=s.schema,a.errors=null,a.refs=s.refs,a.refVal=s.refVal,a.root=s.root,a.$async=s.$async,p.sourceCode&&(a.source=s.source)),s;}finally{(function(e,t,i){var n=L.call(this,e,t,i);0<=n&&this._compilations.splice(n,1);}).call(this,e,d,t);}function A(){var e=o.validate,t=e.apply(this,arguments);return A.errors=e.errors,t;}function v(e,t,i,n){var r=!t||t&&t.schema==e;if(t.schema!=d.schema)return H.call(g,e,t,i,n);var o=!0===e.$async,s=T({isTop:!0,schema:e,isRoot:r,baseId:n,root:t,schemaPath:"",errSchemaPath:"#",errorPath:'""',MissingRefError:B.MissingRef,RULES:I,validate:T,util:E,resolve:R,resolveRef:b,usePattern:S,useDefault:x,useCustomRule:k,opts:p,formats:h,logger:g.logger,self:g}),s=F(m,N)+F(l,$)+F(c,V)+F(C,O)+s;p.processCode&&(s=p.processCode(s));try{var a=new Function("self","RULES","formats","root","refVal","defaults","customRules","equal","ucs2length","ValidationError",s)(g,I,h,d,m,c,C,W,G,_);m[0]=a;}catch(e){throw g.logger.error("Error compiling schema, function code:",s),e;}return a.schema=e,a.errors=null,a.refs=f,a.refVal=m,a.root=r?a:t,o&&(a.$async=!0),!0===p.sourceCode&&(a.source={code:s,patterns:l,defaults:c}),a;}function b(e,t,i){t=R.url(e,t);var n,r,o=f[t];if(void 0!==o)return w(n=m[o],r="refVal["+o+"]");if(!i&&d.refs){var s=d.refs[t];if(void 0!==s)return w(n=d.refVal[s],r=y(t,n));}r=y(t);var a,l,c,h=R.call(g,v,d,t);if(void 0!==h||(a=u&&u[t])&&(h=R.inlineRef(a,p.inlineRefs)?a:H.call(g,a,d,u,e)),void 0!==h)return l=h,c=f[t],m[c]=l,w(h,r);delete f[t];}function y(e,t){var i=m.length;return m[i]=t,"refVal"+(f[e]=i);}function w(e,t){return"object"==(typeof e==="undefined"?"undefined":_typeof(e))||"boolean"==typeof e?{code:t,schema:e,inline:!0}:{code:t,$async:e&&!!e.$async};}function S(e){var t=i[e];return void 0===t&&(t=i[e]=l.length,l[t]=e),"pattern"+t;}function x(e){switch(typeof e==="undefined"?"undefined":_typeof(e)){case"boolean":case"number":return""+e;case"string":return E.toQuotedString(e);case"object":if(null===e)return"null";var t=Z(e),i=n[t];return void 0===i&&(i=n[t]=c.length,c[i]=e),"default"+i;}}function k(e,t,i,n){if(!1!==g._opts.validateSchema){var r=e.definition.dependencies;if(r&&!r.every(function(e){return Object.prototype.hasOwnProperty.call(i,e);}))throw new Error("parent schema must have all required keywords: "+r.join(","));var o=e.definition.validateSchema;if(o)if(!o(t)){var s="keyword schema is invalid: "+g.errorsText(o.errors);if("log"!=g._opts.validateSchema)throw new Error(s);g.logger.error(s);}}var a,l=e.definition.compile,c=e.definition.inline,h=e.definition.macro;if(l)a=l.call(g,t,i,n);else if(h)a=h.call(g,t,i,n),!1!==p.validateSchema&&g.validateSchema(a,!0);else if(c)a=c.call(g,n,e.keyword,t,i);else if(!(a=e.definition.validate))return;if(void 0===a)throw new Error('custom keyword "'+e.keyword+'"failed to compile');var d=C.length;return{code:"customRule"+d,validate:C[d]=a};}}function L(e,t,i){for(var n=0;n<this._compilations.length;n++){var r=this._compilations[n];if(r.schema==e&&r.root==t&&r.baseId==i)return n;}return-1;}function $(e,t){return"var pattern"+e+" = new RegExp("+E.toQuotedString(t[e])+");";}function V(e){return"var default"+e+" = defaults["+e+"];";}function N(e,t){return void 0===t[e]?"":"var refVal"+e+" = refVal["+e+"];";}function O(e){return"var customRule"+e+" = customRules["+e+"];";}function F(e,t){if(!e.length)return"";for(var i="",n=0;n<e.length;n++){i+=t(n,e);}return i;}e.exports=H;},function(e,t,i){/** @license URI.js v4.2.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */!function(e){"use strict";function he(){for(var e=arguments.length,t=Array(e),i=0;i<e;i++){t[i]=arguments[i];}if(t.length>1){t[0]=t[0].slice(0,-1);var n=t.length-1;for(var r=1;r<n;++r){t[r]=t[r].slice(1,-1);}t[n]=t[n].slice(1);return t.join("");}else{return t[0];}}function de(e){return"(?:"+e+")";}function n(e){return e===undefined?"undefined":e===null?"null":Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();}function p(e){return e.toUpperCase();}function m(e){return e!==undefined&&e!==null?e instanceof Array?e:typeof e.length!=="number"||e.split||e.setInterval||e.call?[e]:Array.prototype.slice.call(e):[];}function r(e,t){var i=e;if(t){for(var n in t){i[n]=t[n];}}return i;}function t(e){var t="[A-Za-z]",i="[\\x0D]",n="[0-9]",r="[\\x22]",o=he(n,"[A-Fa-f]"),s="[\\x0A]",a="[\\x20]",l=de(de("%[EFef]"+o+"%"+o+o+"%"+o+o)+"|"+de("%[89A-Fa-f]"+o+"%"+o+o)+"|"+de("%"+o+o)),c="[\\:\\/\\?\\#\\[\\]\\@]",h="[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",d=he(c,h),u=e?"[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]":"[]",g=e?"[\\uE000-\\uF8FF]":"[]",p=he(t,n,"[\\-\\.\\_\\~]",u),m=de(t+he(t,n,"[\\+\\-\\.]")+"*"),f=de(de(l+"|"+he(p,h,"[\\:]"))+"*"),C=de(de("25[0-5]")+"|"+de("2[0-4]"+n)+"|"+de("1"+n+n)+"|"+de("[1-9]"+n)+"|"+n),I=de(de("25[0-5]")+"|"+de("2[0-4]"+n)+"|"+de("1"+n+n)+"|"+de("0?[1-9]"+n)+"|0?0?"+n),A=de(I+"\\."+I+"\\."+I+"\\."+I),v=de(o+"{1,4}"),b=de(de(v+"\\:"+v)+"|"+A),y=de(de(v+"\\:")+"{6}"+b),w=de("\\:\\:"+de(v+"\\:")+"{5}"+b),S=de(de(v)+"?\\:\\:"+de(v+"\\:")+"{4}"+b),x=de(de(de(v+"\\:")+"{0,1}"+v)+"?\\:\\:"+de(v+"\\:")+"{3}"+b),k=de(de(de(v+"\\:")+"{0,2}"+v)+"?\\:\\:"+de(v+"\\:")+"{2}"+b),R=de(de(de(v+"\\:")+"{0,3}"+v)+"?\\:\\:"+v+"\\:"+b),E=de(de(de(v+"\\:")+"{0,4}"+v)+"?\\:\\:"+b),B=de(de(de(v+"\\:")+"{0,5}"+v)+"?\\:\\:"+v),Z=de(de(de(v+"\\:")+"{0,6}"+v)+"?\\:\\:"),T=de([y,w,S,x,k,R,E,B,Z].join("|")),G=de(de(p+"|"+l)+"+"),W=de(T+"\\%25"+G),_=de(T+de("\\%25|\\%(?!"+o+"{2})")+G),H=de("[vV]"+o+"+\\."+he(p,h,"[\\:]")+"+"),L=de("\\["+de(_+"|"+T+"|"+H)+"\\]"),$=de(de(l+"|"+he(p,h))+"*"),V=de(L+"|"+A+"(?!"+$+")"+"|"+$),N=de(n+"*"),O=de(de(f+"@")+"?"+V+de("\\:"+N)+"?"),F=de(l+"|"+he(p,h,"[\\:\\@]")),P=de(F+"*"),K=de(F+"+"),M=de(de(l+"|"+he(p,h,"[\\@]"))+"+"),j=de(de("\\/"+P)+"*"),D=de("\\/"+de(K+j)+"?"),X=de(M+j),Y=de(K+j),z="(?!"+F+")",J=de(j+"|"+D+"|"+X+"|"+Y+"|"+z),U=de(de(F+"|"+he("[\\/\\?]",g))+"*"),Q=de(de(F+"|[\\/\\?]")+"*"),q=de(de("\\/\\/"+O+j)+"|"+D+"|"+Y+"|"+z),ee=de(m+"\\:"+q+de("\\?"+U)+"?"+de("\\#"+Q)+"?"),te=de(de("\\/\\/"+O+j)+"|"+D+"|"+X+"|"+z),ie=de(te+de("\\?"+U)+"?"+de("\\#"+Q)+"?"),ne=de(ee+"|"+ie),re=de(m+"\\:"+q+de("\\?"+U)+"?"),oe="^("+m+")\\:"+de(de("\\/\\/("+de("("+f+")@")+"?("+V+")"+de("\\:("+N+")")+"?)")+"?("+j+"|"+D+"|"+Y+"|"+z+")")+de("\\?("+U+")")+"?"+de("\\#("+Q+")")+"?$",se="^(){0}"+de(de("\\/\\/("+de("("+f+")@")+"?("+V+")"+de("\\:("+N+")")+"?)")+"?("+j+"|"+D+"|"+X+"|"+z+")")+de("\\?("+U+")")+"?"+de("\\#("+Q+")")+"?$",ae="^("+m+")\\:"+de(de("\\/\\/("+de("("+f+")@")+"?("+V+")"+de("\\:("+N+")")+"?)")+"?("+j+"|"+D+"|"+Y+"|"+z+")")+de("\\?("+U+")")+"?$",le="^"+de("\\#("+Q+")")+"?$",ce="^"+de("("+f+")@")+"?("+V+")"+de("\\:("+N+")")+"?$";return{NOT_SCHEME:new RegExp(he("[^]",t,n,"[\\+\\-\\.]"),"g"),NOT_USERINFO:new RegExp(he("[^\\%\\:]",p,h),"g"),NOT_HOST:new RegExp(he("[^\\%\\[\\]\\:]",p,h),"g"),NOT_PATH:new RegExp(he("[^\\%\\/\\:\\@]",p,h),"g"),NOT_PATH_NOSCHEME:new RegExp(he("[^\\%\\/\\@]",p,h),"g"),NOT_QUERY:new RegExp(he("[^\\%]",p,h,"[\\:\\@\\/\\?]",g),"g"),NOT_FRAGMENT:new RegExp(he("[^\\%]",p,h,"[\\:\\@\\/\\?]"),"g"),ESCAPE:new RegExp(he("[^]",p,h),"g"),UNRESERVED:new RegExp(p,"g"),OTHER_CHARS:new RegExp(he("[^\\%]",p,d),"g"),PCT_ENCODED:new RegExp(l,"g"),IPV4ADDRESS:new RegExp("^("+A+")$"),IPV6ADDRESS:new RegExp("^\\[?("+T+")"+de(de("\\%25|\\%(?!"+o+"{2})")+"("+G+")")+"?\\]?$")};}var a=t(false),l=t(true),y=function(){function i(e,t){var i=[];var n=true;var r=false;var o=undefined;try{for(var s=e[Symbol.iterator](),a;!(n=(a=s.next()).done);n=true){i.push(a.value);if(t&&i.length===t)break;}}catch(e){r=true;o=e;}finally{try{if(!n&&s["return"])s["return"]();}finally{if(r)throw o;}}return i;}return function(e,t){if(Array.isArray(e)){return e;}else if(Symbol.iterator in Object(e)){return i(e,t);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}(),i=function i(e){if(Array.isArray(e)){for(var t=0,i=Array(e.length);t<e.length;t++){i[t]=e[t];}return i;}else{return Array.from(e);}},_=2147483647,H=36,L=1,$=26,o=38,s=700,V=72,N=128,O="-",c=/^xn--/,h=/[^\0-\x7E]/,d=/[\x2E\u3002\uFF0E\uFF61]/g,u={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},g=H-L,F=Math.floor,P=String.fromCharCode;function K(e){throw new RangeError(u[e]);}function f(e,t){var i=[];var n=e.length;while(n--){i[n]=t(e[n]);}return i;}function C(e,t){var i=e.split("@");var n="";if(i.length>1){n=i[0]+"@";e=i[1];}e=e.replace(d,".");var r=e.split(".");var o=f(r,t).join(".");return n+o;}function M(e){var t=[];var i=0;var n=e.length;while(i<n){var r=e.charCodeAt(i++);if(r>=55296&&r<=56319&&i<n){var o=e.charCodeAt(i++);if((o&64512)==56320){t.push(((r&1023)<<10)+(o&1023)+65536);}else{t.push(r);i--;}}else{t.push(r);}}return t;}var I,A=function e(t){if(t-48<10){return t-22;}if(t-65<26){return t-65;}if(t-97<26){return t-97;}return H;},j=function e(t,i){return t+22+75*(t<26)-((i!=0)<<5);},D=function e(t,i,n){var r=0;t=n?F(t/s):t>>1;t+=F(t/i);for(;t>g*$>>1;r+=H){t=F(t/g);}return F(r+(g+1)*t/(t+o));},v=function e(t){var i=[];var n=t.length;var r=0;var o=N;var s=V;var a=t.lastIndexOf(O);if(a<0){a=0;}for(var l=0;l<a;++l){if(t.charCodeAt(l)>=128){K("not-basic");}i.push(t.charCodeAt(l));}for(var c=a>0?a+1:0;c<n;){var h=r;for(var d=1,u=H;;u+=H){if(c>=n){K("invalid-input");}var g=A(t.charCodeAt(c++));if(g>=H||g>F((_-r)/d)){K("overflow");}r+=g*d;var p=u<=s?L:u>=s+$?$:u-s;if(g<p){break;}var m=H-p;if(d>F(_/m)){K("overflow");}d*=m;}var f=i.length+1;s=D(r-h,f,h==0);if(F(r/f)>_-o){K("overflow");}o+=F(r/f);r%=f;i.splice(r++,0,o);}return String.fromCodePoint.apply(String,i);},b=function e(t){var i=[];t=M(t);var n=t.length;var r=N;var o=0;var s=V;var a=true;var l=false;var c=undefined;try{for(var h=t[Symbol.iterator](),d;!(a=(d=h.next()).done);a=true){var u=d.value;if(u<128){i.push(P(u));}}}catch(e){l=true;c=e;}finally{try{if(!a&&h.return){h.return();}}finally{if(l){throw c;}}}var g=i.length;var p=g;if(g){i.push(O);}while(p<n){var m=_;var f=true;var C=false;var I=undefined;try{for(var A=t[Symbol.iterator](),v;!(f=(v=A.next()).done);f=true){var b=v.value;if(b>=r&&b<m){m=b;}}}catch(e){C=true;I=e;}finally{try{if(!f&&A.return){A.return();}}finally{if(C){throw I;}}}var y=p+1;if(m-r>F((_-o)/y)){K("overflow");}o+=(m-r)*y;r=m;var w=true;var S=false;var x=undefined;try{for(var k=t[Symbol.iterator](),R;!(w=(R=k.next()).done);w=true){var E=R.value;if(E<r&&++o>_){K("overflow");}if(E==r){var B=o;for(var Z=H;;Z+=H){var T=Z<=s?L:Z>=s+$?$:Z-s;if(B<T){break;}var G=B-T;var W=H-T;i.push(P(j(T+G%W,0)));B=F(G/W);}i.push(P(j(B,0)));s=D(o,y,p==g);o=0;++p;}}}catch(e){S=true;x=e;}finally{try{if(!w&&k.return){k.return();}}finally{if(S){throw x;}}}++o;++r;}return i.join("");},w,S,x={version:"2.1.0",ucs2:{decode:M,encode:function e(t){return String.fromCodePoint.apply(String,i(t));}},decode:v,encode:b,toASCII:function e(t){return C(t,function(e){return h.test(e)?"xn--"+b(e):e;});},toUnicode:function e(t){return C(t,function(e){return c.test(e)?v(e.slice(4).toLowerCase()):e;});}},k={};function R(e){var t=e.charCodeAt(0);var i=void 0;if(t<16)i="%0"+t.toString(16).toUpperCase();else if(t<128)i="%"+t.toString(16).toUpperCase();else if(t<2048)i="%"+(t>>6|192).toString(16).toUpperCase()+"%"+(t&63|128).toString(16).toUpperCase();else i="%"+(t>>12|224).toString(16).toUpperCase()+"%"+(t>>6&63|128).toString(16).toUpperCase()+"%"+(t&63|128).toString(16).toUpperCase();return i;}function E(e){var t="";var i=0;var n=e.length;while(i<n){var r=parseInt(e.substr(i+1,2),16);if(r<128){t+=String.fromCharCode(r);i+=3;}else if(r>=194&&r<224){if(n-i>=6){var o=parseInt(e.substr(i+4,2),16);t+=String.fromCharCode((r&31)<<6|o&63);}else{t+=e.substr(i,6);}i+=6;}else if(r>=224){if(n-i>=9){var s=parseInt(e.substr(i+4,2),16);var a=parseInt(e.substr(i+7,2),16);t+=String.fromCharCode((r&15)<<12|(s&63)<<6|a&63);}else{t+=e.substr(i,9);}i+=9;}else{t+=e.substr(i,3);i+=3;}}return t;}function B(e,i){function t(e){var t=E(e);return!t.match(i.UNRESERVED)?e:t;}if(e.scheme)e.scheme=String(e.scheme).replace(i.PCT_ENCODED,t).toLowerCase().replace(i.NOT_SCHEME,"");if(e.userinfo!==undefined)e.userinfo=String(e.userinfo).replace(i.PCT_ENCODED,t).replace(i.NOT_USERINFO,R).replace(i.PCT_ENCODED,p);if(e.host!==undefined)e.host=String(e.host).replace(i.PCT_ENCODED,t).toLowerCase().replace(i.NOT_HOST,R).replace(i.PCT_ENCODED,p);if(e.path!==undefined)e.path=String(e.path).replace(i.PCT_ENCODED,t).replace(e.scheme?i.NOT_PATH:i.NOT_PATH_NOSCHEME,R).replace(i.PCT_ENCODED,p);if(e.query!==undefined)e.query=String(e.query).replace(i.PCT_ENCODED,t).replace(i.NOT_QUERY,R).replace(i.PCT_ENCODED,p);if(e.fragment!==undefined)e.fragment=String(e.fragment).replace(i.PCT_ENCODED,t).replace(i.NOT_FRAGMENT,R).replace(i.PCT_ENCODED,p);return e;}function Z(e){return e.replace(/^0*(.*)/,"$1")||"0";}function T(e,t){var i=e.match(t.IPV4ADDRESS)||[];var n=y(i,2),r=n[1];if(r){return r.split(".").map(Z).join(".");}else{return e;}}function G(e,t){var i=e.match(t.IPV6ADDRESS)||[];var n=y(i,3),r=n[1],o=n[2];if(r){var s=r.toLowerCase().split("::").reverse(),a=y(s,2),l=a[0],c=a[1];var h=c?c.split(":").map(Z):[];var d=l.split(":").map(Z);var u=t.IPV4ADDRESS.test(d[d.length-1]);var g=u?7:8;var p=d.length-g;var m=Array(g);for(var f=0;f<g;++f){m[f]=h[f]||d[p+f]||"";}if(u){m[g-1]=T(m[g-1],t);}var C=m.reduce(function(e,t,i){if(!t||t==="0"){var n=e[e.length-1];if(n&&n.index+n.length===i){n.length++;}else{e.push({index:i,length:1});}}return e;},[]);var I=C.sort(function(e,t){return t.length-e.length;})[0];var A=void 0;if(I&&I.length>1){var v=m.slice(0,I.index);var b=m.slice(I.index+I.length);A=v.join(":")+"::"+b.join(":");}else{A=m.join(":");}if(o){A+="%"+o;}return A;}else{return e;}}var W=/^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i,X="".match(/(){0}/)[1]===undefined;function Y(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var i={};var n=t.iri!==false?l:a;if(t.reference==="suffix")e=(t.scheme?t.scheme+":":"")+"//"+e;var r=e.match(W);if(r){if(X){i.scheme=r[1];i.userinfo=r[3];i.host=r[4];i.port=parseInt(r[5],10);i.path=r[6]||"";i.query=r[7];i.fragment=r[8];if(isNaN(i.port)){i.port=r[5];}}else{i.scheme=r[1]||undefined;i.userinfo=e.indexOf("@")!==-1?r[3]:undefined;i.host=e.indexOf("//")!==-1?r[4]:undefined;i.port=parseInt(r[5],10);i.path=r[6]||"";i.query=e.indexOf("?")!==-1?r[7]:undefined;i.fragment=e.indexOf("#")!==-1?r[8]:undefined;if(isNaN(i.port)){i.port=e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/)?r[4]:undefined;}}if(i.host){i.host=G(T(i.host,n),n);}if(i.scheme===undefined&&i.userinfo===undefined&&i.host===undefined&&i.port===undefined&&!i.path&&i.query===undefined){i.reference="same-document";}else if(i.scheme===undefined){i.reference="relative";}else if(i.fragment===undefined){i.reference="absolute";}else{i.reference="uri";}if(t.reference&&t.reference!=="suffix"&&t.reference!==i.reference){i.error=i.error||"URI is not a "+t.reference+" reference.";}var o=k[(t.scheme||i.scheme||"").toLowerCase()];if(!t.unicodeSupport&&(!o||!o.unicodeSupport)){if(i.host&&(t.domainHost||o&&o.domainHost)){try{i.host=x.toASCII(i.host.replace(n.PCT_ENCODED,E).toLowerCase());}catch(e){i.error=i.error||"Host's domain name can not be converted to ASCII via punycode: "+e;}}B(i,a);}else{B(i,n);}if(o&&o.parse){o.parse(i,t);}}else{i.error=i.error||"URI can not be parsed.";}return i;}function z(e,t){var i=t.iri!==false?l:a;var n=[];if(e.userinfo!==undefined){n.push(e.userinfo);n.push("@");}if(e.host!==undefined){n.push(G(T(String(e.host),i),i).replace(i.IPV6ADDRESS,function(e,t,i){return"["+t+(i?"%25"+i:"")+"]";}));}if(typeof e.port==="number"){n.push(":");n.push(e.port.toString(10));}return n.length?n.join(""):undefined;}var J=/^\.\.?\//,U=/^\/\.(\/|$)/,Q=/^\/\.\.(\/|$)/,q=/^\/?(?:.|\n)*?(?=\/|$)/;function ee(e){var t=[];while(e.length){if(e.match(J)){e=e.replace(J,"");}else if(e.match(U)){e=e.replace(U,"/");}else if(e.match(Q)){e=e.replace(Q,"/");t.pop();}else if(e==="."||e===".."){e="";}else{var i=e.match(q);if(i){var n=i[0];e=e.slice(n.length);t.push(n);}else{throw new Error("Unexpected dot segment condition");}}}return t.join("");}function te(t){var i=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var e=i.iri?l:a;var n=[];var r=k[(i.scheme||t.scheme||"").toLowerCase()];if(r&&r.serialize)r.serialize(t,i);if(t.host){if(e.IPV6ADDRESS.test(t.host)){}else if(i.domainHost||r&&r.domainHost){try{t.host=!i.iri?x.toASCII(t.host.replace(e.PCT_ENCODED,E).toLowerCase()):x.toUnicode(t.host);}catch(e){t.error=t.error||"Host's domain name can not be converted to "+(!i.iri?"ASCII":"Unicode")+" via punycode: "+e;}}}B(t,e);if(i.reference!=="suffix"&&t.scheme){n.push(t.scheme);n.push(":");}var o=z(t,i);if(o!==undefined){if(i.reference!=="suffix"){n.push("//");}n.push(o);if(t.path&&t.path.charAt(0)!=="/"){n.push("/");}}if(t.path!==undefined){var s=t.path;if(!i.absolutePath&&(!r||!r.absolutePath)){s=ee(s);}if(o===undefined){s=s.replace(/^\/\//,"/%2F");}n.push(s);}if(t.query!==undefined){n.push("?");n.push(t.query);}if(t.fragment!==undefined){n.push("#");n.push(t.fragment);}return n.join("");}function ie(e,t){var i=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var n=arguments[3];var r={};if(!n){e=Y(te(e,i),i);t=Y(te(t,i),i);}i=i||{};if(!i.tolerant&&t.scheme){r.scheme=t.scheme;r.userinfo=t.userinfo;r.host=t.host;r.port=t.port;r.path=ee(t.path||"");r.query=t.query;}else{if(t.userinfo!==undefined||t.host!==undefined||t.port!==undefined){r.userinfo=t.userinfo;r.host=t.host;r.port=t.port;r.path=ee(t.path||"");r.query=t.query;}else{if(!t.path){r.path=e.path;if(t.query!==undefined){r.query=t.query;}else{r.query=e.query;}}else{if(t.path.charAt(0)==="/"){r.path=ee(t.path);}else{if((e.userinfo!==undefined||e.host!==undefined||e.port!==undefined)&&!e.path){r.path="/"+t.path;}else if(!e.path){r.path=t.path;}else{r.path=e.path.slice(0,e.path.lastIndexOf("/")+1)+t.path;}r.path=ee(r.path);}r.query=t.query;}r.userinfo=e.userinfo;r.host=e.host;r.port=e.port;}r.scheme=e.scheme;}r.fragment=t.fragment;return r;}function ne(e,t,i){var n=r({scheme:"null"},i);return te(ie(Y(e,n),Y(t,n),n,true),n);}function re(e,t){if(typeof e==="string"){e=te(Y(e,t),t);}else if(n(e)==="object"){e=Y(te(e,t),t);}return e;}function oe(e,t,i){if(typeof e==="string"){e=te(Y(e,i),i);}else if(n(e)==="object"){e=te(e,i);}if(typeof t==="string"){t=te(Y(t,i),i);}else if(n(t)==="object"){t=te(t,i);}return e===t;}function se(e,t){return e&&e.toString().replace(!t||!t.iri?a.ESCAPE:l.ESCAPE,R);}function ae(e,t){return e&&e.toString().replace(!t||!t.iri?a.PCT_ENCODED:l.PCT_ENCODED,E);}var le={scheme:"http",domainHost:true,parse:function e(t,i){if(!t.host){t.error=t.error||"HTTP URIs must have a host.";}return t;},serialize:function e(t,i){if(t.port===(String(t.scheme).toLowerCase()!=="https"?80:443)||t.port===""){t.port=undefined;}if(!t.path){t.path="/";}return t;}},ce={scheme:"https",domainHost:le.domainHost,parse:le.parse,serialize:le.serialize},ue={},ge,pe="[A-Za-z0-9\\-\\.\\_\\~"+(true?"\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF":"")+"]",me="[0-9A-Fa-f]",fe=de(de("%[EFef]"+me+"%"+me+me+"%"+me+me)+"|"+de("%[89A-Fa-f]"+me+"%"+me+me)+"|"+de("%"+me+me)),Ce="[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]",Ie,Ae=he("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]",'[\\"\\\\]'),ve="[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]",be=new RegExp(pe,"g"),ye=new RegExp(fe,"g"),we=new RegExp(he("[^]",Ce,"[\\.]",'[\\"]',Ae),"g"),Se=new RegExp(he("[^]",pe,ve),"g"),xe=Se;function ke(e){var t=E(e);return!t.match(be)?e:t;}var Re={scheme:"mailto",parse:function e(t,i){var n=t;var r=n.to=n.path?n.path.split(","):[];n.path=undefined;if(n.query){var o=false;var s={};var a=n.query.split("&");for(var l=0,c=a.length;l<c;++l){var h=a[l].split("=");switch(h[0]){case"to":var d=h[1].split(",");for(var u=0,g=d.length;u<g;++u){r.push(d[u]);}break;case"subject":n.subject=ae(h[1],i);break;case"body":n.body=ae(h[1],i);break;default:o=true;s[ae(h[0],i)]=ae(h[1],i);break;}}if(o)n.headers=s;}n.query=undefined;for(var p=0,m=r.length;p<m;++p){var f=r[p].split("@");f[0]=ae(f[0]);if(!i.unicodeSupport){try{f[1]=x.toASCII(ae(f[1],i).toLowerCase());}catch(e){n.error=n.error||"Email address's domain name can not be converted to ASCII via punycode: "+e;}}else{f[1]=ae(f[1],i).toLowerCase();}r[p]=f.join("@");}return n;},serialize:function e(t,i){var n=t;var r=m(t.to);if(r){for(var o=0,s=r.length;o<s;++o){var a=String(r[o]);var l=a.lastIndexOf("@");var c=a.slice(0,l).replace(ye,ke).replace(ye,p).replace(we,R);var h=a.slice(l+1);try{h=!i.iri?x.toASCII(ae(h,i).toLowerCase()):x.toUnicode(h);}catch(e){n.error=n.error||"Email address's domain name can not be converted to "+(!i.iri?"ASCII":"Unicode")+" via punycode: "+e;}r[o]=c+"@"+h;}n.path=r.join(",");}var d=t.headers=t.headers||{};if(t.subject)d["subject"]=t.subject;if(t.body)d["body"]=t.body;var u=[];for(var g in d){if(d[g]!==ue[g]){u.push(g.replace(ye,ke).replace(ye,p).replace(Se,R)+"="+d[g].replace(ye,ke).replace(ye,p).replace(xe,R));}}if(u.length){n.query=u.join("&");}return n;}},Ee=/^([^\:]+)\:(.*)/,Be={scheme:"urn",parse:function e(t,i){var n=t.path&&t.path.match(Ee);var r=t;if(n){var o=i.scheme||r.scheme||"urn";var s=n[1].toLowerCase();var a=n[2];var l=o+":"+(i.nid||s);var c=k[l];r.nid=s;r.nss=a;r.path=undefined;if(c){r=c.parse(r,i);}}else{r.error=r.error||"URN can not be parsed.";}return r;},serialize:function e(t,i){var n=i.scheme||t.scheme||"urn";var r=t.nid;var o=n+":"+(i.nid||r);var s=k[o];if(s){t=s.serialize(t,i);}var a=t;var l=t.nss;a.path=(r||i.nid)+":"+l;return a;}},Ze=/^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/,Te={scheme:"urn:uuid",parse:function e(t,i){var n=t;n.uuid=n.nss;n.nss=undefined;if(!i.tolerant&&(!n.uuid||!n.uuid.match(Ze))){n.error=n.error||"UUID is not valid.";}return n;},serialize:function e(t,i){var n=t;n.nss=(t.uuid||"").toLowerCase();return n;}};k[le.scheme]=le,k[ce.scheme]=ce,k[Re.scheme]=Re,k[Be.scheme]=Be,k[Te.scheme]=Te,e.SCHEMES=k,e.pctEncChar=R,e.pctDecChars=E,e.parse=Y,e.removeDotSegments=ee,e.serialize=te,e.resolveComponents=ie,e.resolve=ne,e.normalize=re,e.equal=oe,e.escapeComponent=se,e.unescapeComponent=ae,Object.defineProperty(e,"__esModule",{value:true});}(t);},function(e,t,i){"use strict";e.exports=function(e){for(var t,i=0,n=e.length,r=0;r<n;){i++,55296<=(t=e.charCodeAt(r++))&&t<=56319&&r<n&&56320==(64512&(t=e.charCodeAt(r)))&&r++;}return i;};},function(e,t,i){"use strict";var m=e.exports=function(e,t,i){"function"==typeof t&&(i=t,t={}),function e(t,i,n,r,o,s,a,l,c,h){if(r&&"object"==(typeof r==="undefined"?"undefined":_typeof(r))&&!Array.isArray(r)){for(var d in i(r,o,s,a,l,c,h),r){var u=r[d];if(Array.isArray(u)){if(d in m.arrayKeywords)for(var g=0;g<u.length;g++){e(t,i,n,u[g],o+"/"+d+"/"+g,s,o,d,r,g);}}else if(d in m.propsKeywords){if(u&&"object"==(typeof u==="undefined"?"undefined":_typeof(u)))for(var p in u){e(t,i,n,u[p],o+"/"+d+"/"+p.replace(/~/g,"~0").replace(/\//g,"~1"),s,o,d,r,p);}}else(d in m.keywords||t.allKeys&&!(d in m.skipKeywords))&&e(t,i,n,u,o+"/"+d,s,o,d,r);}n(r,o,s,a,l,c,h);}}(t,"function"==typeof(i=t.cb||i)?i:i.pre||function(){},i.post||function(){},e,"",e);};m.keywords={additionalItems:!0,items:!0,contains:!0,additionalProperties:!0,propertyNames:!0,not:!0},m.arrayKeywords={items:!0,allOf:!0,anyOf:!0,oneOf:!0},m.propsKeywords={definitions:!0,properties:!0,patternProperties:!0,dependencies:!0},m.skipKeywords={default:!0,enum:!0,const:!0,required:!0,maximum:!0,minimum:!0,exclusiveMaximum:!0,exclusiveMinimum:!0,multipleOf:!0,maxLength:!0,minLength:!0,pattern:!0,format:!0,maxItems:!0,minItems:!0,uniqueItems:!0,maxProperties:!0,minProperties:!0};},function(e,t,i){"use strict";var n=e.exports=function(){this._cache={};};n.prototype.put=function(e,t){this._cache[e]=t;},n.prototype.get=function(e){return this._cache[e];},n.prototype.del=function(e){delete this._cache[e];},n.prototype.clear=function(){this._cache={};};},function(e,t,i){"use strict";var n=i(7),s=/^(\d\d\d\d)-(\d\d)-(\d\d)$/,a=[0,31,28,31,30,31,30,31,31,30,31,30,31],l=/^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i,r=/^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,o=/^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,c=/^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,h=/^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i,d=/^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,u=/^(?:\/(?:[^~/]|~0|~1)*)*$/,g=/^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,p=/^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;function m(e){return e="full"==e?"full":"fast",n.copy(m[e]);}function f(e){var t=e.match(s);if(!t)return!1;var i,n=+t[1],r=+t[2],o=+t[3];return 1<=r&&r<=12&&1<=o&&o<=(2!=r||(i=n)%4!=0||i%100==0&&i%400!=0?a[r]:29);}function C(e,t){var i=e.match(l);if(!i)return!1;var n=i[1],r=i[2],o=i[3],s=i[5];return(n<=23&&r<=59&&o<=59||23==n&&59==r&&60==o)&&(!t||s);}(e.exports=m).fast={date:/^\d\d\d\d-[0-1]\d-[0-3]\d$/,time:/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,"date-time":/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,uri:/^(?:[a-z][a-z0-9+-.]*:)(?:\/?\/)?[^\s]*$/i,"uri-reference":/^(?:(?:[a-z][a-z0-9+-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,"uri-template":c,url:h,email:/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,hostname:r,ipv4:/^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,ipv6:/^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,regex:b,uuid:d,"json-pointer":u,"json-pointer-uri-fragment":g,"relative-json-pointer":p},m.full={date:f,time:C,"date-time":function dateTime(e){var t=e.split(I);return 2==t.length&&f(t[0])&&C(t[1],!0);},uri:function uri(e){return A.test(e)&&o.test(e);},"uri-reference":/^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,"uri-template":c,url:h,email:/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,hostname:r,ipv4:/^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,ipv6:/^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,regex:b,uuid:d,"json-pointer":u,"json-pointer-uri-fragment":g,"relative-json-pointer":p};var I=/t|\s/i;var A=/\/|:/;var v=/[^\\]\\Z/;function b(e){if(v.test(e))return!1;try{return new RegExp(e),!0;}catch(e){return!1;}}},function(e,t,i){"use strict";var o=i(52),s=i(7).toHash;e.exports=function(){var n=[{type:"number",rules:[{maximum:["exclusiveMaximum"]},{minimum:["exclusiveMinimum"]},"multipleOf","format"]},{type:"string",rules:["maxLength","minLength","pattern","format"]},{type:"array",rules:["maxItems","minItems","items","contains","uniqueItems"]},{type:"object",rules:["maxProperties","minProperties","required","dependencies","propertyNames",{properties:["additionalProperties","patternProperties"]}]},{rules:["$ref","const","enum","not","anyOf","oneOf","allOf","if"]}],r=["type","$comment"];return n.all=s(r),n.types=s(["number","integer","string","array","object","boolean","null"]),n.forEach(function(e){e.rules=e.rules.map(function(e){var t,i;return"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&(i=e[t=Object.keys(e)[0]],e=t,i.forEach(function(e){r.push(e),n.all[e]=!0;})),r.push(e),n.all[e]={keyword:e,code:o[e],implements:i};}),n.all.$comment={keyword:"$comment",code:o.$comment},e.type&&(n.types[e.type]=e);}),n.keywords=s(r.concat(["$schema","$id","id","$data","$async","title","description","default","definitions","examples","readOnly","writeOnly","contentMediaType","contentEncoding","additionalItems","then","else"])),n.custom={},n;};},function(e,t,i){"use strict";e.exports={$ref:i(53),allOf:i(54),anyOf:i(55),$comment:i(56),const:i(57),contains:i(58),dependencies:i(59),enum:i(60),format:i(61),if:i(62),items:i(63),maximum:i(28),minimum:i(28),maxItems:i(29),minItems:i(29),maxLength:i(30),minLength:i(30),maxProperties:i(31),minProperties:i(31),multipleOf:i(64),not:i(65),oneOf:i(66),pattern:i(67),properties:i(68),propertyNames:i(69),required:i(70),uniqueItems:i(71),validate:i(27)};},function(e,t,i){"use strict";e.exports=function(e,t){var i,n,r=" ",o=e.level,s=e.dataLevel,a=e.schema[t],l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(s||""),d="valid"+o;if("#"==a||"#/"==a)n=e.isRoot?(i=e.async,"validate"):(i=!0===e.root.schema.$async,"root.refVal[0]");else{var u,g,p=e.resolveRef(e.baseId,a,e.isRoot);if(void 0===p){var m,f=e.MissingRefError.message(e.baseId,a);if("fail"==e.opts.missingRefs){e.logger.error(f),(m=m||[]).push(r),r="",!1!==e.createErrors?(r+=" { keyword: '$ref' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { ref: '"+e.util.escapeQuotes(a)+"' } ",!1!==e.opts.messages&&(r+=" , message: 'can\\'t resolve reference "+e.util.escapeQuotes(a)+"' "),e.opts.verbose&&(r+=" , schema: "+e.util.toQuotedString(a)+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),r+=" } "):r+=" {} ";var C=r,r=m.pop();!e.compositeRule&&c?e.async?r+=" throw new ValidationError(["+C+"]); ":r+=" validate.errors = ["+C+"]; return false; ":r+=" var err = "+C+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",c&&(r+=" if (false) { ");}else{if("ignore"!=e.opts.missingRefs)throw new e.MissingRefError(e.baseId,a,f);e.logger.warn(f),c&&(r+=" if (true) { ");}}else{p.inline?((u=e.util.copy(e)).level++,g="valid"+u.level,u.schema=p.schema,u.schemaPath="",u.errSchemaPath=a,r+=" "+e.validate(u).replace(/validate\.schema/g,p.code)+" ",c&&(r+=" if ("+g+") { ")):(i=!0===p.$async||e.async&&!1!==p.$async,n=p.code);}}if(n){(m=m||[]).push(r),r="",e.opts.passContext?r+=" "+n+".call(this, ":r+=" "+n+"( ",r+=" "+h+", (dataPath || '')",'""'!=e.errorPath&&(r+=" + "+e.errorPath);var I=r+=" , "+(s?"data"+(s-1||""):"parentData")+" , "+(s?e.dataPathArr[s]:"parentDataProperty")+", rootData)  ";if(r=m.pop(),i){if(!e.async)throw new Error("async schema referenced by sync schema");c&&(r+=" var "+d+"; "),r+=" try { await "+I+"; ",c&&(r+=" "+d+" = true; "),r+=" } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ",c&&(r+=" "+d+" = false; "),r+=" } ",c&&(r+=" if ("+d+") { ");}else r+=" if (!"+I+") { if (vErrors === null) vErrors = "+n+".errors; else vErrors = vErrors.concat("+n+".errors); errors = vErrors.length; } ",c&&(r+=" else { ");}return r;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.schema[t],r=e.schemaPath+e.util.getProperty(t),o=e.errSchemaPath+"/"+t,s=!e.opts.allErrors,a=e.util.copy(e),l="";a.level++;var c="valid"+a.level,h=a.baseId,d=!0,u=n;if(u)for(var g,p=-1,m=u.length-1;p<m;){g=u[p+=1],(e.opts.strictKeywords?"object"==(typeof g==="undefined"?"undefined":_typeof(g))&&0<Object.keys(g).length:e.util.schemaHasRules(g,e.RULES.all))&&(d=!1,a.schema=g,a.schemaPath=r+"["+p+"]",a.errSchemaPath=o+"/"+p,i+="  "+e.validate(a)+" ",a.baseId=h,s&&(i+=" if ("+c+") { ",l+="}"));}return s&&(i+=d?" if (true) { ":" "+l.slice(0,-1)+" "),i=e.util.cleanUpCode(i);};},function(e,t,i){"use strict";e.exports=function(t,e){var i=" ",n=t.level,r=t.dataLevel,o=t.schema[e],s=t.schemaPath+t.util.getProperty(e),a=t.errSchemaPath+"/"+e,l=!t.opts.allErrors,c="data"+(r||""),h="valid"+n,d="errs__"+n,u=t.util.copy(t),g="";u.level++;var p="valid"+u.level;if(o.every(function(e){return t.opts.strictKeywords?"object"==(typeof e==="undefined"?"undefined":_typeof(e))&&0<Object.keys(e).length:t.util.schemaHasRules(e,t.RULES.all);})){var m=u.baseId;i+=" var "+d+" = errors; var "+h+" = false;  ";var f=t.compositeRule;t.compositeRule=u.compositeRule=!0;var C=o;if(C)for(var I,A=-1,v=C.length-1;A<v;){I=C[A+=1],u.schema=I,u.schemaPath=s+"["+A+"]",u.errSchemaPath=a+"/"+A,i+="  "+t.validate(u)+" ",u.baseId=m,i+=" "+h+" = "+h+" || "+p+"; if (!"+h+") { ",g+="}";}t.compositeRule=u.compositeRule=f,i+=" "+g+" if (!"+h+") {   var err =   ",!1!==t.createErrors?(i+=" { keyword: 'anyOf' , dataPath: (dataPath || '') + "+t.errorPath+" , schemaPath: "+t.util.toQuotedString(a)+" , params: {} ",!1!==t.opts.messages&&(i+=" , message: 'should match some schema in anyOf' "),t.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+t.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!t.compositeRule&&l&&(t.async?i+=" throw new ValidationError(vErrors); ":i+=" validate.errors = vErrors; return false; "),i+=" } else {  errors = "+d+"; if (vErrors !== null) { if ("+d+") vErrors.length = "+d+"; else vErrors = null; } ",t.opts.allErrors&&(i+=" } "),i=t.util.cleanUpCode(i);}else l&&(i+=" if (true) { ");return i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.schema[t],r=e.errSchemaPath+"/"+t,o=(e.opts.allErrors,e.util.toQuotedString(n));return!0===e.opts.$comment?i+=" console.log("+o+");":"function"==typeof e.opts.$comment&&(i+=" self._opts.$comment("+o+", "+e.util.toQuotedString(r)+", validate.root.schema);"),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="valid"+n,d=e.opts.$data&&o&&o.$data;d&&(i+=" var schema"+n+" = "+e.util.getData(o.$data,r,e.dataPathArr)+"; ");d||(i+=" var schema"+n+" = validate.schema"+s+";"),i+="var "+h+" = equal("+c+", schema"+n+"); if (!"+h+") {   ";var u=u||[];u.push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'const' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { allowedValue: schema"+n+" } ",!1!==e.opts.messages&&(i+=" , message: 'should be equal to constant' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var g=i,i=u.pop();return!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+g+"]); ":i+=" validate.errors = ["+g+"]; return false; ":i+=" var err = "+g+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+=" }",l&&(i+=" else { "),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="valid"+n,d="errs__"+n,u=e.util.copy(e);u.level++;var g,p,m,f="valid"+u.level,C="i"+n,I=u.dataLevel=e.dataLevel+1,A="data"+I,v=e.baseId,b=e.opts.strictKeywords?"object"==(typeof o==="undefined"?"undefined":_typeof(o))&&0<Object.keys(o).length:e.util.schemaHasRules(o,e.RULES.all);i+="var "+d+" = errors;var "+h+";",b?(g=e.compositeRule,e.compositeRule=u.compositeRule=!0,u.schema=o,u.schemaPath=s,u.errSchemaPath=a,i+=" var "+f+" = false; for (var "+C+" = 0; "+C+" < "+c+".length; "+C+"++) { ",u.errorPath=e.util.getPathExpr(e.errorPath,C,e.opts.jsonPointers,!0),p=c+"["+C+"]",u.dataPathArr[I]=C,m=e.validate(u),u.baseId=v,e.util.varOccurences(m,A)<2?i+=" "+e.util.varReplace(m,A,p)+" ":i+=" var "+A+" = "+p+"; "+m+" ",i+=" if ("+f+") break; }  ",e.compositeRule=u.compositeRule=g,i+="  if (!"+f+") {"):i+=" if ("+c+".length == 0) {";var y=y||[];y.push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'contains' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: {} ",!1!==e.opts.messages&&(i+=" , message: 'should contain a valid item' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var w=i,i=y.pop();return!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+w+"]); ":i+=" validate.errors = ["+w+"]; return false; ":i+=" var err = "+w+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+=" } else { ",b&&(i+="  errors = "+d+"; if (vErrors !== null) { if ("+d+") vErrors.length = "+d+"; else vErrors = null; } "),e.opts.allErrors&&(i+=" } "),i=e.util.cleanUpCode(i);};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="errs__"+n,d=e.util.copy(e),u="";d.level++;var g="valid"+d.level,p={},m={},f=e.opts.ownProperties;for(v in o){var C=o[v],I=Array.isArray(C)?m:p;I[v]=C;}i+="var "+h+" = errors;";var A=e.errorPath;for(var v in i+="var missing"+n+";",m){if((I=m[v]).length){if(i+=" if ( "+c+e.util.getProperty(v)+" !== undefined ",f&&(i+=" && Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(v)+"') "),l){i+=" && ( ";var b=I;if(b)for(var y=-1,w=b.length-1;y<w;){B=b[y+=1],y&&(i+=" || "),i+=" ( ( "+(W=c+(G=e.util.getProperty(B)))+" === undefined ",f&&(i+=" || ! Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(B)+"') "),i+=") && (missing"+n+" = "+e.util.toQuotedString(e.opts.jsonPointers?B:G)+") ) ";}i+=")) {  ";var S="missing"+n,x="' + "+S+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.opts.jsonPointers?e.util.getPathExpr(A,S,!0):A+" + "+S);var k=k||[];k.push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'dependencies' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { property: '"+e.util.escapeQuotes(v)+"', missingProperty: '"+x+"', depsCount: "+I.length+", deps: '"+e.util.escapeQuotes(1==I.length?I[0]:I.join(", "))+"' } ",!1!==e.opts.messages&&(i+=" , message: 'should have ",1==I.length?i+="property "+e.util.escapeQuotes(I[0]):i+="properties "+e.util.escapeQuotes(I.join(", ")),i+=" when property "+e.util.escapeQuotes(v)+" is present' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var R=i,i=k.pop();!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+R+"]); ":i+=" validate.errors = ["+R+"]; return false; ":i+=" var err = "+R+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";}else{i+=" ) { ";var E=I;if(E)for(var B,Z=-1,T=E.length-1;Z<T;){B=E[Z+=1];var G=e.util.getProperty(B),x=e.util.escapeQuotes(B),W=c+G;e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPath(A,B,e.opts.jsonPointers)),i+=" if ( "+W+" === undefined ",f&&(i+=" || ! Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(B)+"') "),i+=") {  var err =   ",!1!==e.createErrors?(i+=" { keyword: 'dependencies' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { property: '"+e.util.escapeQuotes(v)+"', missingProperty: '"+x+"', depsCount: "+I.length+", deps: '"+e.util.escapeQuotes(1==I.length?I[0]:I.join(", "))+"' } ",!1!==e.opts.messages&&(i+=" , message: 'should have ",1==I.length?i+="property "+e.util.escapeQuotes(I[0]):i+="properties "+e.util.escapeQuotes(I.join(", ")),i+=" when property "+e.util.escapeQuotes(v)+" is present' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";}}i+=" }   ",l&&(u+="}",i+=" else { ");}}e.errorPath=A;var _=d.baseId;for(var v in p){C=p[v];(e.opts.strictKeywords?"object"==(typeof C==="undefined"?"undefined":_typeof(C))&&0<Object.keys(C).length:e.util.schemaHasRules(C,e.RULES.all))&&(i+=" "+g+" = true; if ( "+c+e.util.getProperty(v)+" !== undefined ",f&&(i+=" && Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(v)+"') "),i+=") { ",d.schema=C,d.schemaPath=s+e.util.getProperty(v),d.errSchemaPath=a+"/"+e.util.escapeFragment(v),i+="  "+e.validate(d)+" ",d.baseId=_,i+=" }  ",l&&(i+=" if ("+g+") { ",u+="}"));}return l&&(i+="   "+u+" if ("+h+" == errors) {"),i=e.util.cleanUpCode(i);};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="valid"+n,d=e.opts.$data&&o&&o.$data,u=(d&&(i+=" var schema"+n+" = "+e.util.getData(o.$data,r,e.dataPathArr)+"; "),"i"+n),g="schema"+n;d||(i+=" var "+g+" = validate.schema"+s+";"),i+="var "+h+";",d&&(i+=" if (schema"+n+" === undefined) "+h+" = true; else if (!Array.isArray(schema"+n+")) "+h+" = false; else {"),i+=h+" = false;for (var "+u+"=0; "+u+"<"+g+".length; "+u+"++) if (equal("+c+", "+g+"["+u+"])) { "+h+" = true; break; }",d&&(i+="  }  "),i+=" if (!"+h+") {   ";var p=p||[];p.push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'enum' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { allowedValues: schema"+n+" } ",!1!==e.opts.messages&&(i+=" , message: 'should be equal to one of the allowed values' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var m=i,i=p.pop();return!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+m+"]); ":i+=" validate.errors = ["+m+"]; return false; ":i+=" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+=" }",l&&(i+=" else { "),i;};},function(e,t,i){"use strict";e.exports=function(e,t,i){var n=" ",r=e.level,o=e.dataLevel,s=e.schema[t],a=e.schemaPath+e.util.getProperty(t),l=e.errSchemaPath+"/"+t,c=!e.opts.allErrors,h="data"+(o||"");if(!1===e.opts.format)return c&&(n+=" if (true) { "),n;var d,u=e.opts.$data&&s&&s.$data,g=u?(n+=" var schema"+r+" = "+e.util.getData(s.$data,o,e.dataPathArr)+"; ","schema"+r):s,p=e.opts.unknownFormats,m=Array.isArray(p);if(u){n+=" var "+(d="format"+r)+" = formats["+g+"]; var "+(f="isObject"+r)+" = typeof "+d+" == 'object' && !("+d+" instanceof RegExp) && "+d+".validate; var "+(I="formatType"+r)+" = "+f+" && "+d+".type || 'string'; if ("+f+") { ",e.async&&(n+=" var async"+r+" = "+d+".async; "),n+=" "+d+" = "+d+".validate; } if (  ",u&&(n+=" ("+g+" !== undefined && typeof "+g+" != 'string') || "),n+=" (","ignore"!=p&&(n+=" ("+g+" && !"+d+" ",m&&(n+=" && self._opts.unknownFormats.indexOf("+g+") == -1 "),n+=") || "),n+=" ("+d+" && "+I+" == '"+i+"' && !(typeof "+d+" == 'function' ? ",e.async?n+=" (async"+r+" ? await "+d+"("+h+") : "+d+"("+h+")) ":n+=" "+d+"("+h+") ",n+=" : "+d+".test("+h+"))))) {";}else{if(!(d=e.formats[s])){if("ignore"==p)return e.logger.warn('unknown format "'+s+'" ignored in schema at path "'+e.errSchemaPath+'"'),c&&(n+=" if (true) { "),n;if(m&&0<=p.indexOf(s))return c&&(n+=" if (true) { "),n;throw new Error('unknown format "'+s+'" is used in schema at path "'+e.errSchemaPath+'"');}var f,C,I=(f="object"==(typeof d==="undefined"?"undefined":_typeof(d))&&!(d instanceof RegExp)&&d.validate)&&d.type||"string";if(f&&(C=!0===d.async,d=d.validate),I!=i)return c&&(n+=" if (true) { "),n;if(C){if(!e.async)throw new Error("async format in sync schema");n+=" if (!(await "+(A="formats"+e.util.getProperty(s)+".validate")+"("+h+"))) { ";}else{n+=" if (! ";var A="formats"+e.util.getProperty(s);f&&(A+=".validate"),n+="function"==typeof d?" "+A+"("+h+") ":" "+A+".test("+h+") ",n+=") { ";}}var v=v||[];v.push(n),n="",!1!==e.createErrors?(n+=" { keyword: 'format' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(l)+" , params: { format:  ",n+=u?""+g:""+e.util.toQuotedString(s),n+="  } ",!1!==e.opts.messages&&(n+=" , message: 'should match format \"",n+=u?"' + "+g+" + '":""+e.util.escapeQuotes(s),n+="\"' "),e.opts.verbose&&(n+=" , schema:  ",n+=u?"validate.schema"+a:""+e.util.toQuotedString(s),n+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+h+" "),n+=" } "):n+=" {} ";var b=n,n=v.pop();return!e.compositeRule&&c?e.async?n+=" throw new ValidationError(["+b+"]); ":n+=" validate.errors = ["+b+"]; return false; ":n+=" var err = "+b+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",n+=" } ",c&&(n+=" else { "),n;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="valid"+n,d="errs__"+n,u=e.util.copy(e);u.level++;var g,p,m="valid"+u.level,f=e.schema.then,C=e.schema.else,I=void 0!==f&&(e.opts.strictKeywords?"object"==(typeof f==="undefined"?"undefined":_typeof(f))&&0<Object.keys(f).length:e.util.schemaHasRules(f,e.RULES.all)),A=void 0!==C&&(e.opts.strictKeywords?"object"==(typeof C==="undefined"?"undefined":_typeof(C))&&0<Object.keys(C).length:e.util.schemaHasRules(C,e.RULES.all)),v=u.baseId;return I||A?(u.createErrors=!1,u.schema=o,u.schemaPath=s,u.errSchemaPath=a,i+=" var "+d+" = errors; var "+h+" = true;  ",p=e.compositeRule,e.compositeRule=u.compositeRule=!0,i+="  "+e.validate(u)+" ",u.baseId=v,u.createErrors=!0,i+="  errors = "+d+"; if (vErrors !== null) { if ("+d+") vErrors.length = "+d+"; else vErrors = null; }  ",e.compositeRule=u.compositeRule=p,I?(i+=" if ("+m+") {  ",u.schema=e.schema.then,u.schemaPath=e.schemaPath+".then",u.errSchemaPath=e.errSchemaPath+"/then",i+="  "+e.validate(u)+" ",u.baseId=v,i+=" "+h+" = "+m+"; ",I&&A?i+=" var "+(g="ifClause"+n)+" = 'then'; ":g="'then'",i+=" } ",A&&(i+=" else { ")):i+=" if (!"+m+") { ",A&&(u.schema=e.schema.else,u.schemaPath=e.schemaPath+".else",u.errSchemaPath=e.errSchemaPath+"/else",i+="  "+e.validate(u)+" ",u.baseId=v,i+=" "+h+" = "+m+"; ",I&&A?i+=" var "+(g="ifClause"+n)+" = 'else'; ":g="'else'",i+=" } "),i+=" if (!"+h+") {   var err =   ",!1!==e.createErrors?(i+=" { keyword: 'if' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { failingKeyword: "+g+" } ",!1!==e.opts.messages&&(i+=" , message: 'should match \"' + "+g+" + '\" schema' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&l&&(e.async?i+=" throw new ValidationError(vErrors); ":i+=" validate.errors = vErrors; return false; "),i+=" }   ",l&&(i+=" else { "),i=e.util.cleanUpCode(i)):l&&(i+=" if (true) { "),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="valid"+n,d="errs__"+n,u=e.util.copy(e),g="";u.level++;var p="valid"+u.level,m="i"+n,f=u.dataLevel=e.dataLevel+1,C="data"+f,I=e.baseId;if(i+="var "+d+" = errors;var "+h+";",Array.isArray(o)){var A,v,b,y=e.schema.additionalItems;!1===y&&(i+=" "+h+" = "+c+".length <= "+o.length+"; ",A=a,a=e.errSchemaPath+"/additionalItems",(v=v||[]).push(i+="  if (!"+h+") {   "),i="",!1!==e.createErrors?(i+=" { keyword: 'additionalItems' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { limit: "+o.length+" } ",!1!==e.opts.messages&&(i+=" , message: 'should NOT have more than "+o.length+" items' "),e.opts.verbose&&(i+=" , schema: false , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",b=i,i=v.pop(),!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+b+"]); ":i+=" validate.errors = ["+b+"]; return false; ":i+=" var err = "+b+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+=" } ",a=A,l&&(g+="}",i+=" else { "));var w=o;if(w)for(var S=-1,x=w.length-1;S<x;){var k,R,E=w[S+=1];(e.opts.strictKeywords?"object"==(typeof E==="undefined"?"undefined":_typeof(E))&&0<Object.keys(E).length:e.util.schemaHasRules(E,e.RULES.all))&&(i+=" "+p+" = true; if ("+c+".length > "+S+") { ",k=c+"["+S+"]",u.schema=E,u.schemaPath=s+"["+S+"]",u.errSchemaPath=a+"/"+S,u.errorPath=e.util.getPathExpr(e.errorPath,S,e.opts.jsonPointers,!0),u.dataPathArr[f]=S,R=e.validate(u),u.baseId=I,e.util.varOccurences(R,C)<2?i+=" "+e.util.varReplace(R,C,k)+" ":i+=" var "+C+" = "+k+"; "+R+" ",i+=" }  ",l&&(i+=" if ("+p+") { ",g+="}"));}"object"==(typeof y==="undefined"?"undefined":_typeof(y))&&(e.opts.strictKeywords?"object"==(typeof y==="undefined"?"undefined":_typeof(y))&&0<Object.keys(y).length:e.util.schemaHasRules(y,e.RULES.all))&&(u.schema=y,u.schemaPath=e.schemaPath+".additionalItems",u.errSchemaPath=e.errSchemaPath+"/additionalItems",i+=" "+p+" = true; if ("+c+".length > "+o.length+") {  for (var "+m+" = "+o.length+"; "+m+" < "+c+".length; "+m+"++) { ",u.errorPath=e.util.getPathExpr(e.errorPath,m,e.opts.jsonPointers,!0),k=c+"["+m+"]",u.dataPathArr[f]=m,R=e.validate(u),u.baseId=I,e.util.varOccurences(R,C)<2?i+=" "+e.util.varReplace(R,C,k)+" ":i+=" var "+C+" = "+k+"; "+R+" ",l&&(i+=" if (!"+p+") break; "),i+=" } }  ",l&&(i+=" if ("+p+") { ",g+="}"));}else{(e.opts.strictKeywords?"object"==(typeof o==="undefined"?"undefined":_typeof(o))&&0<Object.keys(o).length:e.util.schemaHasRules(o,e.RULES.all))&&(u.schema=o,u.schemaPath=s,u.errSchemaPath=a,i+="  for (var "+m+" = 0; "+m+" < "+c+".length; "+m+"++) { ",u.errorPath=e.util.getPathExpr(e.errorPath,m,e.opts.jsonPointers,!0),k=c+"["+m+"]",u.dataPathArr[f]=m,R=e.validate(u),u.baseId=I,e.util.varOccurences(R,C)<2?i+=" "+e.util.varReplace(R,C,k)+" ":i+=" var "+C+" = "+k+"; "+R+" ",l&&(i+=" if (!"+p+") break; "),i+=" }");}return l&&(i+=" "+g+" if ("+d+" == errors) {"),i=e.util.cleanUpCode(i);};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h=e.opts.$data&&o&&o.$data,d=h?(i+=" var schema"+n+" = "+e.util.getData(o.$data,r,e.dataPathArr)+"; ","schema"+n):o;i+="var division"+n+";if (",h&&(i+=" "+d+" !== undefined && ( typeof "+d+" != 'number' || "),i+=" (division"+n+" = "+c+" / "+d+", ",e.opts.multipleOfPrecision?i+=" Math.abs(Math.round(division"+n+") - division"+n+") > 1e-"+e.opts.multipleOfPrecision+" ":i+=" division"+n+" !== parseInt(division"+n+") ",i+=" ) ",h&&(i+="  )  "),i+=" ) {   ";var u=u||[];u.push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'multipleOf' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { multipleOf: "+d+" } ",!1!==e.opts.messages&&(i+=" , message: 'should be multiple of ",i+=h?"' + "+d:d+"'"),e.opts.verbose&&(i+=" , schema:  ",i+=h?"validate.schema"+s:""+o,i+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var g=i,i=u.pop();return!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+g+"]); ":i+=" validate.errors = ["+g+"]; return false; ":i+=" var err = "+g+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+="} ",l&&(i+=" else { "),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="errs__"+n,d=e.util.copy(e);d.level++;var u,g,p,m,f="valid"+d.level;return(e.opts.strictKeywords?"object"==(typeof o==="undefined"?"undefined":_typeof(o))&&0<Object.keys(o).length:e.util.schemaHasRules(o,e.RULES.all))?(d.schema=o,d.schemaPath=s,d.errSchemaPath=a,i+=" var "+h+" = errors;  ",u=e.compositeRule,e.compositeRule=d.compositeRule=!0,d.createErrors=!1,d.opts.allErrors&&(g=d.opts.allErrors,d.opts.allErrors=!1),i+=" "+e.validate(d)+" ",d.createErrors=!0,g&&(d.opts.allErrors=g),e.compositeRule=d.compositeRule=u,(p=p||[]).push(i+=" if ("+f+") {   "),i="",!1!==e.createErrors?(i+=" { keyword: 'not' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: {} ",!1!==e.opts.messages&&(i+=" , message: 'should NOT be valid' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",m=i,i=p.pop(),!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+m+"]); ":i+=" validate.errors = ["+m+"]; return false; ":i+=" var err = "+m+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+=" } else {  errors = "+h+"; if (vErrors !== null) { if ("+h+") vErrors.length = "+h+"; else vErrors = null; } ",e.opts.allErrors&&(i+=" } ")):(i+="  var err =   ",!1!==e.createErrors?(i+=" { keyword: 'not' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: {} ",!1!==e.opts.messages&&(i+=" , message: 'should NOT be valid' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",l&&(i+=" if (false) { ")),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="valid"+n,d="errs__"+n,u=e.util.copy(e),g="";u.level++;var p="valid"+u.level,m=u.baseId,f="prevValid"+n,C="passingSchemas"+n;i+="var "+d+" = errors , "+f+" = false , "+h+" = false , "+C+" = null; ";var I=e.compositeRule;e.compositeRule=u.compositeRule=!0;var A=o;if(A)for(var v,b=-1,y=A.length-1;b<y;){v=A[b+=1],(e.opts.strictKeywords?"object"==(typeof v==="undefined"?"undefined":_typeof(v))&&0<Object.keys(v).length:e.util.schemaHasRules(v,e.RULES.all))?(u.schema=v,u.schemaPath=s+"["+b+"]",u.errSchemaPath=a+"/"+b,i+="  "+e.validate(u)+" ",u.baseId=m):i+=" var "+p+" = true; ",b&&(i+=" if ("+p+" && "+f+") { "+h+" = false; "+C+" = ["+C+", "+b+"]; } else { ",g+="}"),i+=" if ("+p+") { "+h+" = "+f+" = true; "+C+" = "+b+"; }";}return e.compositeRule=u.compositeRule=I,i+=g+"if (!"+h+") {   var err =   ",!1!==e.createErrors?(i+=" { keyword: 'oneOf' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { passingSchemas: "+C+" } ",!1!==e.opts.messages&&(i+=" , message: 'should match exactly one schema in oneOf' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&l&&(e.async?i+=" throw new ValidationError(vErrors); ":i+=" validate.errors = vErrors; return false; "),i+="} else {  errors = "+d+"; if (vErrors !== null) { if ("+d+") vErrors.length = "+d+"; else vErrors = null; }",e.opts.allErrors&&(i+=" } "),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h=e.opts.$data&&o&&o.$data,d=h?(i+=" var schema"+n+" = "+e.util.getData(o.$data,r,e.dataPathArr)+"; ","schema"+n):o;i+="if ( ",h&&(i+=" ("+d+" !== undefined && typeof "+d+" != 'string') || "),i+=" !"+(h?"(new RegExp("+d+"))":e.usePattern(o))+".test("+c+") ) {   ";var u=u||[];u.push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'pattern' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { pattern:  ",i+=h?""+d:""+e.util.toQuotedString(o),i+="  } ",!1!==e.opts.messages&&(i+=" , message: 'should match pattern \"",i+=h?"' + "+d+" + '":""+e.util.escapeQuotes(o),i+="\"' "),e.opts.verbose&&(i+=" , schema:  ",i+=h?"validate.schema"+s:""+e.util.toQuotedString(o),i+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var g=i,i=u.pop();return!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+g+"]); ":i+=" validate.errors = ["+g+"]; return false; ":i+=" var err = "+g+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+="} ",l&&(i+=" else { "),i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="errs__"+n,d=e.util.copy(e),u="";d.level++;var g,p,m,f="valid"+d.level,C="key"+n,I="idx"+n,A=d.dataLevel=e.dataLevel+1,v="data"+A,b="dataProperties"+n,y=Object.keys(o||{}),w=e.schema.patternProperties||{},S=Object.keys(w),x=e.schema.additionalProperties,k=y.length||S.length,R=!1===x,E="object"==(typeof x==="undefined"?"undefined":_typeof(x))&&Object.keys(x).length,B=e.opts.removeAdditional,Z=R||E||B,T=e.opts.ownProperties,G=e.baseId,W=e.schema.required;if(W&&(!e.opts.$data||!W.$data)&&W.length<e.opts.loopRequired&&(g=e.util.toHash(W)),i+="var "+h+" = errors;var "+f+" = true;",T&&(i+=" var "+b+" = undefined;"),Z){if(i+=T?" "+b+" = "+b+" || Object.keys("+c+"); for (var "+I+"=0; "+I+"<"+b+".length; "+I+"++) { var "+C+" = "+b+"["+I+"]; ":" for (var "+C+" in "+c+") { ",k){if(i+=" var isAdditional"+n+" = !(false ",y.length)if(8<y.length)i+=" || validate.schema"+s+".hasOwnProperty("+C+") ";else{var _=y;if(_)for(var H=-1,L=_.length-1;H<L;){P=_[H+=1],i+=" || "+C+" == "+e.util.toQuotedString(P)+" ";}}if(S.length){var $=S;if($)for(var V=-1,N=$.length-1;V<N;){te=$[V+=1],i+=" || "+e.usePattern(te)+".test("+C+") ";}}i+=" ); if (isAdditional"+n+") { ";}"all"==B?i+=" delete "+c+"["+C+"]; ":(Y=e.errorPath,p="' + "+C+" + '",e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(e.errorPath,C,e.opts.jsonPointers)),R?B?i+=" delete "+c+"["+C+"]; ":(i+=" "+f+" = false; ",z=a,a=e.errSchemaPath+"/additionalProperties",(U=U||[]).push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'additionalProperties' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { additionalProperty: '"+p+"' } ",!1!==e.opts.messages&&(i+=" , message: '",e.opts._errorDataPathProperty?i+="is an invalid additional property":i+="should NOT have additional properties",i+="' "),e.opts.verbose&&(i+=" , schema: false , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",Q=i,i=U.pop(),!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+Q+"]); ":i+=" validate.errors = ["+Q+"]; return false; ":i+=" var err = "+Q+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a=z,l&&(i+=" break; ")):E&&("failing"==B?(i+=" var "+h+" = errors;  ",m=e.compositeRule,e.compositeRule=d.compositeRule=!0,d.schema=x,d.schemaPath=e.schemaPath+".additionalProperties",d.errSchemaPath=e.errSchemaPath+"/additionalProperties",d.errorPath=e.opts._errorDataPathProperty?e.errorPath:e.util.getPathExpr(e.errorPath,C,e.opts.jsonPointers),re=c+"["+C+"]",d.dataPathArr[A]=C,oe=e.validate(d),d.baseId=G,e.util.varOccurences(oe,v)<2?i+=" "+e.util.varReplace(oe,v,re)+" ":i+=" var "+v+" = "+re+"; "+oe+" ",i+=" if (!"+f+") { errors = "+h+"; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete "+c+"["+C+"]; }  ",e.compositeRule=d.compositeRule=m):(d.schema=x,d.schemaPath=e.schemaPath+".additionalProperties",d.errSchemaPath=e.errSchemaPath+"/additionalProperties",d.errorPath=e.opts._errorDataPathProperty?e.errorPath:e.util.getPathExpr(e.errorPath,C,e.opts.jsonPointers),re=c+"["+C+"]",d.dataPathArr[A]=C,oe=e.validate(d),d.baseId=G,e.util.varOccurences(oe,v)<2?i+=" "+e.util.varReplace(oe,v,re)+" ":i+=" var "+v+" = "+re+"; "+oe+" ",l&&(i+=" if (!"+f+") break; "))),e.errorPath=Y),k&&(i+=" } "),i+=" }  ",l&&(i+=" if ("+f+") { ",u+="}");}var O=e.opts.useDefaults&&!e.compositeRule;if(y.length){var F=y;if(F)for(var P,K=-1,M=F.length-1;K<M;){var j,D,X,Y,z,J,U,Q,q=o[P=F[K+=1]];(e.opts.strictKeywords?"object"==(typeof q==="undefined"?"undefined":_typeof(q))&&0<Object.keys(q).length:e.util.schemaHasRules(q,e.RULES.all))&&(re=c+(j=e.util.getProperty(P)),D=O&&void 0!==q.default,d.schema=q,d.schemaPath=s+j,d.errSchemaPath=a+"/"+e.util.escapeFragment(P),d.errorPath=e.util.getPath(e.errorPath,P,e.opts.jsonPointers),d.dataPathArr[A]=e.util.toQuotedString(P),oe=e.validate(d),d.baseId=G,e.util.varOccurences(oe,v)<2?(oe=e.util.varReplace(oe,v,re),X=re):i+=" var "+(X=v)+" = "+re+"; ",D?i+=" "+oe+" ":(g&&g[P]?(i+=" if ( "+X+" === undefined ",T&&(i+=" || ! Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(P)+"') "),i+=") { "+f+" = false; ",Y=e.errorPath,z=a,J=e.util.escapeQuotes(P),e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPath(Y,P,e.opts.jsonPointers)),a=e.errSchemaPath+"/required",(U=U||[]).push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { missingProperty: '"+J+"' } ",!1!==e.opts.messages&&(i+=" , message: '",e.opts._errorDataPathProperty?i+="is a required property":i+="should have required property \\'"+J+"\\'",i+="' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",Q=i,i=U.pop(),!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+Q+"]); ":i+=" validate.errors = ["+Q+"]; return false; ":i+=" var err = "+Q+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a=z,e.errorPath=Y,i+=" } else { "):l?(i+=" if ( "+X+" === undefined ",T&&(i+=" || ! Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(P)+"') "),i+=") { "+f+" = true; } else { "):(i+=" if ("+X+" !== undefined ",T&&(i+=" &&   Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(P)+"') "),i+=" ) { "),i+=" "+oe+" } ")),l&&(i+=" if ("+f+") { ",u+="}");}}if(S.length){var ee=S;if(ee)for(var te,ie=-1,ne=ee.length-1;ie<ne;){var re,oe,q=w[te=ee[ie+=1]];(e.opts.strictKeywords?"object"==(typeof q==="undefined"?"undefined":_typeof(q))&&0<Object.keys(q).length:e.util.schemaHasRules(q,e.RULES.all))&&(d.schema=q,d.schemaPath=e.schemaPath+".patternProperties"+e.util.getProperty(te),d.errSchemaPath=e.errSchemaPath+"/patternProperties/"+e.util.escapeFragment(te),i+=T?" "+b+" = "+b+" || Object.keys("+c+"); for (var "+I+"=0; "+I+"<"+b+".length; "+I+"++) { var "+C+" = "+b+"["+I+"]; ":" for (var "+C+" in "+c+") { ",i+=" if ("+e.usePattern(te)+".test("+C+")) { ",d.errorPath=e.util.getPathExpr(e.errorPath,C,e.opts.jsonPointers),re=c+"["+C+"]",d.dataPathArr[A]=C,oe=e.validate(d),d.baseId=G,e.util.varOccurences(oe,v)<2?i+=" "+e.util.varReplace(oe,v,re)+" ":i+=" var "+v+" = "+re+"; "+oe+" ",l&&(i+=" if (!"+f+") break; "),i+=" } ",l&&(i+=" else "+f+" = true; "),i+=" }  ",l&&(i+=" if ("+f+") { ",u+="}"));}}return l&&(i+=" "+u+" if ("+h+" == errors) {"),i=e.util.cleanUpCode(i);};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="errs__"+n,d=e.util.copy(e);d.level++;var u,g,p,m,f,C,I,A,v,b,y,w="valid"+d.level;return i+="var "+h+" = errors;",(e.opts.strictKeywords?"object"==(typeof o==="undefined"?"undefined":_typeof(o))&&0<Object.keys(o).length:e.util.schemaHasRules(o,e.RULES.all))&&(d.schema=o,d.schemaPath=s,d.errSchemaPath=a,g="idx"+n,p="i"+n,m="' + "+(u="key"+n)+" + '",f="data"+(d.dataLevel=e.dataLevel+1),C="dataProperties"+n,I=e.opts.ownProperties,A=e.baseId,I&&(i+=" var "+C+" = undefined; "),i+=I?" "+C+" = "+C+" || Object.keys("+c+"); for (var "+g+"=0; "+g+"<"+C+".length; "+g+"++) { var "+u+" = "+C+"["+g+"]; ":" for (var "+u+" in "+c+") { ",i+=" var startErrs"+n+" = errors; ",v=u,b=e.compositeRule,e.compositeRule=d.compositeRule=!0,y=e.validate(d),d.baseId=A,e.util.varOccurences(y,f)<2?i+=" "+e.util.varReplace(y,f,v)+" ":i+=" var "+f+" = "+v+"; "+y+" ",e.compositeRule=d.compositeRule=b,i+=" if (!"+w+") { for (var "+p+"=startErrs"+n+"; "+p+"<errors; "+p+"++) { vErrors["+p+"].propertyName = "+u+"; }   var err =   ",!1!==e.createErrors?(i+=" { keyword: 'propertyNames' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { propertyName: '"+m+"' } ",!1!==e.opts.messages&&(i+=" , message: 'property name \\'"+m+"\\' is invalid' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&l&&(e.async?i+=" throw new ValidationError(vErrors); ":i+=" validate.errors = vErrors; return false; "),l&&(i+=" break; "),i+=" } }"),l&&(i+="  if ("+h+" == errors) {"),i=e.util.cleanUpCode(i);};},function(e,t,i){"use strict";e.exports=function(e,t){var i=" ",n=e.level,r=e.dataLevel,o=e.schema[t],s=e.schemaPath+e.util.getProperty(t),a=e.errSchemaPath+"/"+t,l=!e.opts.allErrors,c="data"+(r||""),h="valid"+n,d=e.opts.$data&&o&&o.$data,u=(d&&(i+=" var schema"+n+" = "+e.util.getData(o.$data,r,e.dataPathArr)+"; "),"schema"+n);if(!d)if(o.length<e.opts.loopRequired&&e.schema.properties&&Object.keys(e.schema.properties).length){var g=[],p=o;if(p)for(var m,f=-1,C=p.length-1;f<C;){m=p[f+=1];var I=e.schema.properties[m];I&&(e.opts.strictKeywords?"object"==(typeof I==="undefined"?"undefined":_typeof(I))&&0<Object.keys(I).length:e.util.schemaHasRules(I,e.RULES.all))||(g[g.length]=m);}}else g=o;if(d||g.length){var A=e.errorPath,v=d||g.length>=e.opts.loopRequired,b=e.opts.ownProperties;if(l){if(i+=" var missing"+n+"; ",v){d||(i+=" var "+u+" = validate.schema"+s+"; ");var y="' + "+(E="schema"+n+"["+(x="i"+n)+"]")+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(A,E,e.opts.jsonPointers)),i+=" var "+h+" = true; ",d&&(i+=" if (schema"+n+" === undefined) "+h+" = true; else if (!Array.isArray(schema"+n+")) "+h+" = false; else {"),i+=" for (var "+x+" = 0; "+x+" < "+u+".length; "+x+"++) { "+h+" = "+c+"["+u+"["+x+"]] !== undefined ",b&&(i+=" &&   Object.prototype.hasOwnProperty.call("+c+", "+u+"["+x+"]) "),i+="; if (!"+h+") break; } ",d&&(i+="  }  "),(R=R||[]).push(i+="  if (!"+h+") {   "),i="",!1!==e.createErrors?(i+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { missingProperty: '"+y+"' } ",!1!==e.opts.messages&&(i+=" , message: '",e.opts._errorDataPathProperty?i+="is a required property":i+="should have required property \\'"+y+"\\'",i+="' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";var w=i,i=R.pop();!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+w+"]); ":i+=" validate.errors = ["+w+"]; return false; ":i+=" var err = "+w+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+=" } else { ";}else{i+=" if ( ";var S=g;if(S)for(var x=-1,k=S.length-1;x<k;){Z=S[x+=1],x&&(i+=" || "),i+=" ( ( "+(_=c+(W=e.util.getProperty(Z)))+" === undefined ",b&&(i+=" || ! Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(Z)+"') "),i+=") && (missing"+n+" = "+e.util.toQuotedString(e.opts.jsonPointers?Z:W)+") ) ";}i+=") {  ";var R,y="' + "+(E="missing"+n)+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.opts.jsonPointers?e.util.getPathExpr(A,E,!0):A+" + "+E),(R=R||[]).push(i),i="",!1!==e.createErrors?(i+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { missingProperty: '"+y+"' } ",!1!==e.opts.messages&&(i+=" , message: '",e.opts._errorDataPathProperty?i+="is a required property":i+="should have required property \\'"+y+"\\'",i+="' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ";w=i;i=R.pop(),!e.compositeRule&&l?e.async?i+=" throw new ValidationError(["+w+"]); ":i+=" validate.errors = ["+w+"]; return false; ":i+=" var err = "+w+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",i+=" } else { ";}}else if(v){d||(i+=" var "+u+" = validate.schema"+s+"; ");var E,y="' + "+(E="schema"+n+"["+(x="i"+n)+"]")+" + '";e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPathExpr(A,E,e.opts.jsonPointers)),d&&(i+=" if ("+u+" && !Array.isArray("+u+")) {  var err =   ",!1!==e.createErrors?(i+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { missingProperty: '"+y+"' } ",!1!==e.opts.messages&&(i+=" , message: '",e.opts._errorDataPathProperty?i+="is a required property":i+="should have required property \\'"+y+"\\'",i+="' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if ("+u+" !== undefined) { "),i+=" for (var "+x+" = 0; "+x+" < "+u+".length; "+x+"++) { if ("+c+"["+u+"["+x+"]] === undefined ",b&&(i+=" || ! Object.prototype.hasOwnProperty.call("+c+", "+u+"["+x+"]) "),i+=") {  var err =   ",!1!==e.createErrors?(i+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { missingProperty: '"+y+"' } ",!1!==e.opts.messages&&(i+=" , message: '",e.opts._errorDataPathProperty?i+="is a required property":i+="should have required property \\'"+y+"\\'",i+="' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ",d&&(i+="  }  ");}else{var B=g;if(B)for(var Z,T=-1,G=B.length-1;T<G;){Z=B[T+=1];var W=e.util.getProperty(Z),y=e.util.escapeQuotes(Z),_=c+W;e.opts._errorDataPathProperty&&(e.errorPath=e.util.getPath(A,Z,e.opts.jsonPointers)),i+=" if ( "+_+" === undefined ",b&&(i+=" || ! Object.prototype.hasOwnProperty.call("+c+", '"+e.util.escapeQuotes(Z)+"') "),i+=") {  var err =   ",!1!==e.createErrors?(i+=" { keyword: 'required' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(a)+" , params: { missingProperty: '"+y+"' } ",!1!==e.opts.messages&&(i+=" , message: '",e.opts._errorDataPathProperty?i+="is a required property":i+="should have required property \\'"+y+"\\'",i+="' "),e.opts.verbose&&(i+=" , schema: validate.schema"+s+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+c+" "),i+=" } "):i+=" {} ",i+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";}}e.errorPath=A;}else l&&(i+=" if (true) {");return i;};},function(e,t,i){"use strict";e.exports=function(e,t){var i,n,r,o,s,a=" ",l=e.level,c=e.dataLevel,h=e.schema[t],d=e.schemaPath+e.util.getProperty(t),u=e.errSchemaPath+"/"+t,g=!e.opts.allErrors,p="data"+(c||""),m="valid"+l,f=e.opts.$data&&h&&h.$data,C=f?(a+=" var schema"+l+" = "+e.util.getData(h.$data,c,e.dataPathArr)+"; ","schema"+l):h;return(h||f)&&!1!==e.opts.uniqueItems?(f&&(a+=" var "+m+"; if ("+C+" === false || "+C+" === undefined) "+m+" = true; else if (typeof "+C+" != 'boolean') "+m+" = false; else { "),a+=" var i = "+p+".length , "+m+" = true , j; if (i > 1) { ",i=e.schema.items&&e.schema.items.type,n=Array.isArray(i),!i||"object"==i||"array"==i||n&&(0<=i.indexOf("object")||0<=i.indexOf("array"))?a+=" outer: for (;i--;) { for (j = i; j--;) { if (equal("+p+"[i], "+p+"[j])) { "+m+" = false; break outer; } } } ":(a+=" var itemIndices = {}, item; for (;i--;) { var item = "+p+"[i]; ",r="checkDataType"+(n?"s":""),a+=" if ("+e.util[r](i,"item",!0)+") continue; ",n&&(a+=" if (typeof item == 'string') item = '\"' + item; "),a+=" if (typeof itemIndices[item] == 'number') { "+m+" = false; j = itemIndices[item]; break; } itemIndices[item] = i; } "),a+=" } ",f&&(a+="  }  "),(o=o||[]).push(a+=" if (!"+m+") {   "),a="",!1!==e.createErrors?(a+=" { keyword: 'uniqueItems' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(u)+" , params: { i: i, j: j } ",!1!==e.opts.messages&&(a+=" , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "),e.opts.verbose&&(a+=" , schema:  ",a+=f?"validate.schema"+d:""+h,a+="         , parentSchema: validate.schema"+e.schemaPath+" , data: "+p+" "),a+=" } "):a+=" {} ",s=a,a=o.pop(),!e.compositeRule&&g?e.async?a+=" throw new ValidationError(["+s+"]); ":a+=" validate.errors = ["+s+"]; return false; ":a+=" var err = "+s+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",a+=" } ",g&&(a+=" else { ")):g&&(a+=" if (true) { "),a;};},function(e,t,i){"use strict";var l=["multipleOf","maximum","exclusiveMaximum","minimum","exclusiveMinimum","maxLength","minLength","pattern","additionalItems","maxItems","minItems","uniqueItems","maxProperties","minProperties","required","additionalProperties","enum","format","const"];e.exports=function(e,t){for(var i=0;i<t.length;i++){e=JSON.parse(JSON.stringify(e));for(var n=t[i].split("/"),r=e,o=1;o<n.length;o++){r=r[n[o]];}for(o=0;o<l.length;o++){var s=l[o],a=r[s];a&&(r[s]={anyOf:[a,{$ref:"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#"}]});}}return e;};},function(e,t,i){"use strict";var n=i(19).MissingRef;function r(t,a,i){var l=this;if("function"!=typeof this._opts.loadSchema)throw new Error("options.loadSchema should be a function");"function"==typeof a&&(i=a,a=void 0);var e=c(t).then(function(){var e=l._addSchema(t,void 0,a);return e.validate||function o(s){try{return l._compile(s);}catch(e){if(e instanceof n)return t(e);throw e;}function t(e){var t=e.missingSchema;if(r(t))throw new Error("Schema "+t+" is loaded but "+e.missingRef+" cannot be resolved");var i=l._loadingSchemas[t];return i||(i=l._loadingSchemas[t]=l._opts.loadSchema(t)).then(n,n),i.then(function(e){if(!r(t))return c(e).then(function(){r(t)||l.addSchema(e,t,void 0,a);});}).then(function(){return o(s);});function n(){delete l._loadingSchemas[t];}function r(e){return l._refs[e]||l._schemas[e];}}}(e);});return i&&e.then(function(e){i(null,e);},i),e;function c(e){var t=e.$schema;return t&&!l.getSchema(t)?r.call(l,{$ref:t},!0):Promise.resolve();}}e.exports=r;},function(e,t,i){"use strict";var s=/^[a-z_$][a-z0-9_$-]*$/i,l=i(75),n=i(76);function r(e,t){r.errors=null;var i=this._validateKeyword=this._validateKeyword||this.compile(n,!0);if(i(e))return!0;if(r.errors=i.errors,t)throw new Error("custom keyword definition is invalid: "+this.errorsText(i.errors));return!1;}e.exports={add:function add(e,t){var a=this.RULES;if(a.keywords[e])throw new Error("Keyword "+e+" is already defined");if(!s.test(e))throw new Error("Keyword "+e+" is not a valid identifier");if(t){this.validateKeyword(t,!0);var i=t.type;if(Array.isArray(i))for(var n=0;n<i.length;n++){o(e,i[n],t);}else o(e,i,t);var r=t.metaSchema;r&&(t.$data&&this._opts.$data&&(r={anyOf:[r,{$ref:"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#"}]}),t.validateSchema=this.compile(r,!0));}function o(e,t,i){for(var n,r=0;r<a.length;r++){var o=a[r];if(o.type==t){n=o;break;}}n||(n={type:t,rules:[]},a.push(n));var s={keyword:e,definition:i,custom:!0,code:l,implements:i.implements};n.rules.push(s),a.custom[e]=s;}return a.keywords[e]=a.all[e]=!0,this;},get:function get(e){var t=this.RULES.custom[e];return t?t.definition:this.RULES.keywords[e]||!1;},remove:function remove(e){var t=this.RULES;delete t.keywords[e],delete t.all[e],delete t.custom[e];for(var i=0;i<t.length;i++){for(var n=t[i].rules,r=0;r<n.length;r++){if(n[r].keyword==e){n.splice(r,1);break;}}}return this;},validate:r};},function(e,t,i){"use strict";e.exports=function(e,t){var i,n,r,o,s,a,l=" ",c=e.level,h=e.dataLevel,d=e.schema[t],u=e.schemaPath+e.util.getProperty(t),g=e.errSchemaPath+"/"+t,p=!e.opts.allErrors,m="data"+(h||""),f="valid"+c,C="errs__"+c,I=e.opts.$data&&d&&d.$data,A=I?(l+=" var schema"+c+" = "+e.util.getData(d.$data,h,e.dataPathArr)+"; ","schema"+c):d,v="definition"+c,b=this.definition,y="";if(I&&b.$data){a="keywordValidate"+c;var w=b.validateSchema;l+=" var "+v+" = RULES.custom['"+t+"'].definition; var "+a+" = "+v+".validate;";}else{if(!(s=e.useCustomRule(this,d,e.schema,e)))return;A="validate.schema"+u,a=s.code,n=b.compile,r=b.inline,o=b.macro;}var S,x,k,R,E,B,Z,T,G,W,_=a+".errors",H="i"+c,L="ruleErr"+c,$=b.async;if($&&!e.async)throw new Error("async keyword in sync schema");return r||o||(l+=_+" = null;"),l+="var "+C+" = errors;var "+f+";",I&&b.$data&&(y+="}",l+=" if ("+A+" === undefined) { "+f+" = true; } else { ",w&&(y+="}",l+=" "+f+" = "+v+".validateSchema("+A+"); if ("+f+") { ")),r?b.statements?l+=" "+s.validate+" ":l+=" "+f+" = "+s.validate+"; ":o?(y="",(S=e.util.copy(e)).level++,x="valid"+S.level,S.schema=s.validate,S.schemaPath="",k=e.compositeRule,e.compositeRule=S.compositeRule=!0,R=e.validate(S).replace(/validate\.schema/g,a),e.compositeRule=S.compositeRule=k,l+=" "+R):((T=T||[]).push(l),l="",l+="  "+a+".call( ",e.opts.passContext?l+="this":l+="self",n||!1===b.schema?l+=" , "+m+" ":l+=" , "+A+" , "+m+" , validate.schema"+e.schemaPath+" ",l+=" , (dataPath || '')",'""'!=e.errorPath&&(l+=" + "+e.errorPath),Z=l+=" , "+(E=h?"data"+(h-1||""):"parentData")+" , "+(B=h?e.dataPathArr[h]:"parentDataProperty")+" , rootData )  ",l=T.pop(),!1===b.errors?(l+=" "+f+" = ",$&&(l+="await "),l+=Z+"; "):l+=$?" var "+(_="customErrors"+c)+" = null; try { "+f+" = await "+Z+"; } catch (e) { "+f+" = false; if (e instanceof ValidationError) "+_+" = e.errors; else throw e; } ":" "+_+" = null; "+f+" = "+Z+"; "),b.modifying&&(l+=" if ("+E+") "+m+" = "+E+"["+B+"];"),l+=""+y,b.valid?p&&(l+=" if (true) { "):(l+=" if ( ",void 0===b.valid?(l+=" !",l+=o?""+x:f):l+=" "+!b.valid+" ",l+=") { ",i=this.keyword,(T=T||[]).push(l),(T=T||[]).push(l=""),l="",!1!==e.createErrors?(l+=" { keyword: '"+(i||"custom")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(g)+" , params: { keyword: '"+this.keyword+"' } ",!1!==e.opts.messages&&(l+=" , message: 'should pass \""+this.keyword+"\" keyword validation' "),e.opts.verbose&&(l+=" , schema: validate.schema"+u+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+m+" "),l+=" } "):l+=" {} ",G=l,l=T.pop(),!e.compositeRule&&p?e.async?l+=" throw new ValidationError(["+G+"]); ":l+=" validate.errors = ["+G+"]; return false; ":l+=" var err = "+G+";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",W=l,l=T.pop(),r?b.errors?"full"!=b.errors&&(l+="  for (var "+H+"="+C+"; "+H+"<errors; "+H+"++) { var "+L+" = vErrors["+H+"]; if ("+L+".dataPath === undefined) "+L+".dataPath = (dataPath || '') + "+e.errorPath+"; if ("+L+".schemaPath === undefined) { "+L+'.schemaPath = "'+g+'"; } ',e.opts.verbose&&(l+=" "+L+".schema = "+A+"; "+L+".data = "+m+"; "),l+=" } "):!1===b.errors?l+=" "+W+" ":(l+=" if ("+C+" == errors) { "+W+" } else {  for (var "+H+"="+C+"; "+H+"<errors; "+H+"++) { var "+L+" = vErrors["+H+"]; if ("+L+".dataPath === undefined) "+L+".dataPath = (dataPath || '') + "+e.errorPath+"; if ("+L+".schemaPath === undefined) { "+L+'.schemaPath = "'+g+'"; } ',e.opts.verbose&&(l+=" "+L+".schema = "+A+"; "+L+".data = "+m+"; "),l+=" } } "):o?(l+="   var err =   ",!1!==e.createErrors?(l+=" { keyword: '"+(i||"custom")+"' , dataPath: (dataPath || '') + "+e.errorPath+" , schemaPath: "+e.util.toQuotedString(g)+" , params: { keyword: '"+this.keyword+"' } ",!1!==e.opts.messages&&(l+=" , message: 'should pass \""+this.keyword+"\" keyword validation' "),e.opts.verbose&&(l+=" , schema: validate.schema"+u+" , parentSchema: validate.schema"+e.schemaPath+" , data: "+m+" "),l+=" } "):l+=" {} ",l+=";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ",!e.compositeRule&&p&&(e.async?l+=" throw new ValidationError(vErrors); ":l+=" validate.errors = vErrors; return false; ")):!1===b.errors?l+=" "+W+" ":(l+=" if (Array.isArray("+_+")) { if (vErrors === null) vErrors = "+_+"; else vErrors = vErrors.concat("+_+"); errors = vErrors.length;  for (var "+H+"="+C+"; "+H+"<errors; "+H+"++) { var "+L+" = vErrors["+H+"]; if ("+L+".dataPath === undefined) "+L+".dataPath = (dataPath || '') + "+e.errorPath+";  "+L+'.schemaPath = "'+g+'";  ',e.opts.verbose&&(l+=" "+L+".schema = "+A+"; "+L+".data = "+m+"; "),l+=" } } else { "+W+" } "),l+=" } ",p&&(l+=" else { ")),l;};},function(e,t,i){"use strict";var n=i(32);e.exports={$id:"https://github.com/epoberezkin/ajv/blob/master/lib/definition_schema.js",definitions:{simpleTypes:n.definitions.simpleTypes},type:"object",dependencies:{schema:["validate"],$data:["validate"],statements:["inline"],valid:{not:{required:["macro"]}}},properties:{type:n.properties.type,schema:{type:"boolean"},statements:{type:"boolean"},dependencies:{type:"array",items:{type:"string"}},metaSchema:{type:"object"},modifying:{type:"boolean"},valid:{type:"boolean"},$data:{type:"boolean"},async:{type:"boolean"},errors:{anyOf:[{type:"boolean"},{const:"full"}]}}};},function(e){e.exports=JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');},function(e){e.exports=JSON.parse('{"id":"http://json-schema.org/draft-04/schema#","$schema":"http://json-schema.org/draft-04/schema#","description":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"positiveInteger":{"type":"integer","minimum":0},"positiveIntegerDefault0":{"allOf":[{"$ref":"#/definitions/positiveInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"minItems":1,"uniqueItems":true}},"type":"object","properties":{"id":{"type":"string"},"$schema":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"multipleOf":{"type":"number","minimum":0,"exclusiveMinimum":true},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"boolean","default":false},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"boolean","default":false},"maxLength":{"$ref":"#/definitions/positiveInteger"},"minLength":{"$ref":"#/definitions/positiveIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"anyOf":[{"type":"boolean"},{"$ref":"#"}],"default":{}},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/positiveInteger"},"minItems":{"$ref":"#/definitions/positiveIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"maxProperties":{"$ref":"#/definitions/positiveInteger"},"minProperties":{"$ref":"#/definitions/positiveIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"anyOf":[{"type":"boolean"},{"$ref":"#"}],"default":{}},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"dependencies":{"exclusiveMaximum":["maximum"],"exclusiveMinimum":["minimum"]},"default":{}}');},function(e){e.exports=JSON.parse('{"$schema":"http://json-schema.org/draft-06/schema#","$id":"http://json-schema.org/draft-06/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"examples":{"type":"array","items":{}},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":{},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":{}}');},function(e,t,i){"use strict";i.r(t),i.d(t,"treeModeMixins",function(){return V;});var n=i(13),o=i.n(n);function r(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var s=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),this.locked=!1;}var t,i,n;return t=e,(i=[{key:"highlight",value:function value(e){this.locked||(this.node!==e&&(this.node&&this.node.setHighlight(!1),this.node=e,this.node.setHighlight(!0)),this._cancelUnhighlight());}},{key:"unhighlight",value:function value(){var e;this.locked||(e=this).node&&(this._cancelUnhighlight(),this.unhighlightTimer=setTimeout(function(){e.node.setHighlight(!1),e.node=void 0,e.unhighlightTimer=void 0;},0));}},{key:"_cancelUnhighlight",value:function value(){this.unhighlightTimer&&(clearTimeout(this.unhighlightTimer),this.unhighlightTimer=void 0);}},{key:"lock",value:function value(){this.locked=!0;}},{key:"unlock",value:function value(){this.locked=!1;}}])&&r(t.prototype,i),n&&r(t,n),e;}(),_=i(0);function a(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var l=function(){function e(t){function o(e){return t.node.findNodeByInternalPath(e);}!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),this.editor=t,this.history=[],this.index=-1,this.clear(),this.actions={editField:{undo:function undo(e){o(e.parentPath).childs[e.index].updateField(e.oldValue);},redo:function redo(e){o(e.parentPath).childs[e.index].updateField(e.newValue);}},editValue:{undo:function undo(e){o(e.path).updateValue(e.oldValue);},redo:function redo(e){o(e.path).updateValue(e.newValue);}},changeType:{undo:function undo(e){o(e.path).changeType(e.oldType);},redo:function redo(e){o(e.path).changeType(e.newType);}},appendNodes:{undo:function undo(e){var t=o(e.parentPath);e.paths.map(o).forEach(function(e){t.removeChild(e);});},redo:function redo(e){var t=o(e.parentPath);e.nodes.forEach(function(e){t.appendChild(e);});}},insertBeforeNodes:{undo:function undo(e){var t=o(e.parentPath);e.paths.map(o).forEach(function(e){t.removeChild(e);});},redo:function redo(e){var t=o(e.parentPath),i=o(e.beforePath);e.nodes.forEach(function(e){t.insertBefore(e,i);});}},insertAfterNodes:{undo:function undo(e){var t=o(e.parentPath);e.paths.map(o).forEach(function(e){t.removeChild(e);});},redo:function redo(e){var t=o(e.parentPath),i=o(e.afterPath);e.nodes.forEach(function(e){t.insertAfter(e,i),i=e;});}},removeNodes:{undo:function undo(e){var t=o(e.parentPath),i=t.childs[e.index]||t.append;e.nodes.forEach(function(e){t.insertBefore(e,i);});},redo:function redo(e){var t=o(e.parentPath);e.paths.map(o).forEach(function(e){t.removeChild(e);});}},duplicateNodes:{undo:function undo(e){var t=o(e.parentPath);e.clonePaths.map(o).forEach(function(e){t.removeChild(e);});},redo:function redo(e){var n=o(e.parentPath),r=o(e.afterPath);e.paths.map(o).forEach(function(e){var t,i=e.clone();"object"===n.type&&(t=n.getFieldNames(),i.field=Object(_.findUniqueName)(e.field,t)),n.insertAfter(i,r),r=i;});}},moveNodes:{undo:function undo(i){var n=o(i.oldParentPath),e=o(i.newParentPath),r=n.childs[i.oldIndex]||n.append;e.childs.slice(i.newIndex,i.newIndex+i.count).forEach(function(e,t){e.field=i.fieldNames[t],n.moveBefore(e,r);}),null===i.newParentPathRedo&&(i.newParentPathRedo=e.getInternalPath());},redo:function redo(i){var e=o(i.oldParentPathRedo),n=o(i.newParentPathRedo),r=n.childs[i.newIndexRedo]||n.append;e.childs.slice(i.oldIndexRedo,i.oldIndexRedo+i.count).forEach(function(e,t){e.field=i.fieldNames[t],n.moveBefore(e,r);});}},sort:{undo:function undo(e){var t=o(e.path);t.hideChilds(),t.childs=e.oldChilds,t.updateDom({updateIndexes:!0}),t.showChilds();},redo:function redo(e){var t=o(e.path);t.hideChilds(),t.childs=e.newChilds,t.updateDom({updateIndexes:!0}),t.showChilds();}},transform:{undo:function undo(e){o(e.path).setInternalValue(e.oldValue);},redo:function redo(e){o(e.path).setInternalValue(e.newValue);}}};}var t,i,n;return t=e,(i=[{key:"onChange",value:function value(){}},{key:"add",value:function value(e,t){this.index++,this.history[this.index]={action:e,params:t,timestamp:new Date()},this.index<this.history.length-1&&this.history.splice(this.index+1,this.history.length-this.index-1),this.onChange();}},{key:"clear",value:function value(){this.history=[],this.index=-1,this.onChange();}},{key:"canUndo",value:function value(){return 0<=this.index;}},{key:"canRedo",value:function value(){return this.index<this.history.length-1;}},{key:"undo",value:function value(){if(this.canUndo()){var e=this.history[this.index];if(e){var t=this.actions[e.action];if(t&&t.undo){if(t.undo(e.params),e.params.oldSelection)try{this.editor.setDomSelection(e.params.oldSelection);}catch(e){console.error(e);}}else console.error(new Error('unknown action "'+e.action+'"'));}this.index--,this.onChange();}}},{key:"redo",value:function value(){if(this.canRedo()){this.index++;var e=this.history[this.index];if(e){var t=this.actions[e.action];if(t&&t.redo){if(t.redo(e.params),e.params.newSelection)try{this.editor.setDomSelection(e.params.newSelection);}catch(e){console.error(e);}}else console.error(new Error('unknown action "'+e.action+'"'));}this.onChange();}}},{key:"destroy",value:function value(){this.editor=null,this.history=[],this.index=-1;}}])&&a(t.prototype,i),n&&a(t,n),e;}(),d=i(1);function c(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var h=function(){function h(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,h);var i=this;this.editor=e,this.timeout=void 0,this.delay=200,this.lastText=void 0,this.results=null,this.dom={},this.dom.container=t;var n=document.createElement("div");(this.dom.wrapper=n).className="jsoneditor-search",t.appendChild(n);var r=document.createElement("div");(this.dom.results=r).className="jsoneditor-results",n.appendChild(r);var o=document.createElement("div");(this.dom.input=o).className="jsoneditor-frame",o.title=Object(d.c)("searchTitle"),n.appendChild(o);var s=document.createElement("button");s.type="button",s.className="jsoneditor-refresh",o.appendChild(s);var a=document.createElement("input");a.type="text",(this.dom.search=a).oninput=function(e){i._onDelayedSearch(e);},a.onchange=function(e){i._onSearch();},a.onkeydown=function(e){i._onKeyDown(e);},a.onkeyup=function(e){i._onKeyUp(e);},s.onclick=function(e){a.select();},o.appendChild(a);var l=document.createElement("button");l.type="button",l.title=Object(d.c)("searchNextResultTitle"),l.className="jsoneditor-next",l.onclick=function(){i.next();},o.appendChild(l);var c=document.createElement("button");c.type="button",c.title=Object(d.c)("searchPreviousResultTitle"),c.className="jsoneditor-previous",c.onclick=function(){i.previous();},o.appendChild(c);}var e,t,i;return e=h,(t=[{key:"next",value:function value(e){var t;this.results&&((t=null!==this.resultIndex?this.resultIndex+1:0)>this.results.length-1&&(t=0),this._setActiveResult(t,e));}},{key:"previous",value:function value(e){var t,i;this.results&&(t=this.results.length-1,(i=null!==this.resultIndex?this.resultIndex-1:t)<0&&(i=t),this._setActiveResult(i,e));}},{key:"_setActiveResult",value:function value(e,t){var i;if(this.activeResult&&(i=this.activeResult.node,"field"===this.activeResult.elem?delete i.searchFieldActive:delete i.searchValueActive,i.updateDom()),!this.results||!this.results[e])return this.resultIndex=void 0,void(this.activeResult=void 0);this.resultIndex=e;var n=this.results[this.resultIndex].node,r=this.results[this.resultIndex].elem;"field"===r?n.searchFieldActive=!0:n.searchValueActive=!0,this.activeResult=this.results[this.resultIndex],n.updateDom(),n.scrollTo(function(){t&&n.focus(r);});}},{key:"_clearDelay",value:function value(){void 0!==this.timeout&&(clearTimeout(this.timeout),delete this.timeout);}},{key:"_onDelayedSearch",value:function value(){this._clearDelay();var t=this;this.timeout=setTimeout(function(e){t._onSearch();},this.delay);}},{key:"_onSearch",value:function value(e){this._clearDelay();var t=this.dom.search.value,i=0<t.length?t:void 0;if(i!==this.lastText||e){this.lastText=i,this.results=this.editor.search(i);var n,r=this.results[0]?this.results[0].node.MAX_SEARCH_RESULTS:1/0,o=0;if(this.activeResult)for(var s=0;s<this.results.length;s++){if(this.results[s].node===this.activeResult.node){o=s;break;}}this._setActiveResult(o,!1),void 0!==i?(n=this.results.length,this.dom.results.innerHTML=0===n?"no&nbsp;results":1===n?"1&nbsp;result":r<n?r+"+&nbsp;results":n+"&nbsp;results"):this.dom.results.innerHTML="";}}},{key:"_onKeyDown",value:function value(e){var t=e.which;27===t?(this.dom.search.value="",this._onSearch(),e.preventDefault(),e.stopPropagation()):13===t&&(e.ctrlKey?this._onSearch(!0):e.shiftKey?this.previous():this.next(),e.preventDefault(),e.stopPropagation());}},{key:"_onKeyUp",value:function value(e){var t=e.keyCode;27!==t&&13!==t&&this._onDelayedSearch(e);}},{key:"clear",value:function value(){this.dom.search.value="",this._onSearch();}},{key:"forceSearch",value:function value(){this._onSearch(!0);}},{key:"isEmpty",value:function value(){return""===this.dom.search.value;}},{key:"destroy",value:function value(){this.editor=null,this.dom.container.removeChild(this.dom.wrapper),this.dom=null,this.results=null,this.activeResult=null,this._clearDelay();}}])&&c(e.prototype,t),i&&c(e,i),h;}(),u=i(3);function g(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var p=function(){function i(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,i),e&&(this.root=t,this.path=document.createElement("div"),this.path.className="jsoneditor-treepath",this.path.setAttribute("tabindex",0),this.contentMenuClicked=!1,e.appendChild(this.path),this.reset());}var e,t,n;return e=i,(t=[{key:"reset",value:function value(){this.path.innerHTML=Object(d.c)("selectNode");}},{key:"setPath",value:function value(s){var a=this;this.path.innerHTML="",s&&s.length&&s.forEach(function(i,n){var e,t,r,o=document.createElement("span");o.className="jsoneditor-treepath-element",o.innerText=i.name,o.onclick=function(e){this.selectionCallback&&this.selectionCallback(e);}.bind(a,i),a.path.appendChild(o),i.children.length&&((e=document.createElement("span")).className="jsoneditor-treepath-seperator",e.innerHTML="&#9658;",e.onclick=function(){a.contentMenuClicked=!0;var t=[];i.children.forEach(function(e){t.push({text:e.name,className:"jsoneditor-type-modes"+(s[n+1]+1&&s[n+1].name===e.name?" jsoneditor-selected":""),click:function(e,t){this.contextMenuCallback&&this.contextMenuCallback(e,t);}.bind(a,i,e.name)});}),new u.a(t).show(e,a.root,!0);},a.path.appendChild(e)),n===s.length-1&&(t=(e||o).getBoundingClientRect().right,a.path.offsetWidth<t&&(a.path.scrollLeft=t),a.path.scrollLeft&&((r=document.createElement("span")).className="jsoneditor-treepath-show-all-btn",r.title="show all path",r.innerHTML="...",r.onclick=function(e){a.contentMenuClicked=!1,Object(_.addClassName)(a.path,"show-all"),a.path.style.width=a.path.parentNode.getBoundingClientRect().width-10+"px",a.path.onblur=function(){if(a.contentMenuClicked)return a.contentMenuClicked=!1,void a.path.focus();Object(_.removeClassName)(a.path,"show-all"),a.path.onblur=void 0,a.path.style.width="",a.setPath(e);};}.bind(a,s),a.path.insertBefore(r,a.path.firstChild)));});}},{key:"onSectionSelected",value:function value(e){"function"==typeof e&&(this.selectionCallback=e);}},{key:"onContextMenuItemSelected",value:function value(e){"function"==typeof e&&(this.contextMenuCallback=e);}}])&&g(e.prototype,t),n&&g(e,n),i;}(),m=i(11),f=i.n(m),C=i(12);var I=i(5),A=i(6),v=i(2);function b(e){return(b="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return typeof e==="undefined"?"undefined":_typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e==="undefined"?"undefined":_typeof(e);})(e);}function y(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var R=function(){function W(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,W),this.editor=e,this.dom={},this.expanded=!1,t&&t instanceof Object?(this.setField(t.field,t.fieldEditable),"value"in t&&this.setValue(t.value,t.type),"internalValue"in t&&this.setInternalValue(t.internalValue)):(this.setField(""),this.setValue(null)),this._debouncedOnChangeValue=Object(_.debounce)(this._onChangeValue.bind(this),W.prototype.DEBOUNCE_INTERVAL),this._debouncedOnChangeField=Object(_.debounce)(this._onChangeField.bind(this),W.prototype.DEBOUNCE_INTERVAL),this.visibleChilds=this.getMaxVisibleChilds();}var e,t,i;return e=W,(t=[{key:"getMaxVisibleChilds",value:function value(){return this.editor&&this.editor.options&&this.editor.options.maxVisibleChilds?this.editor.options.maxVisibleChilds:w;}},{key:"_updateEditability",value:function value(){var e;this.editable={field:!0,value:!0},this.editor&&(this.editable.field="tree"===this.editor.options.mode,this.editable.value="view"!==this.editor.options.mode,"tree"!==this.editor.options.mode&&"form"!==this.editor.options.mode||"function"!=typeof this.editor.options.onEditable||("boolean"==typeof(e=this.editor.options.onEditable({field:this.field,value:this.value,path:this.getPath()}))?(this.editable.field=e,this.editable.value=e):("boolean"==typeof e.field&&(this.editable.field=e.field),"boolean"==typeof e.value&&(this.editable.value=e.value))));}},{key:"getPath",value:function value(){for(var e=this,t=[];e;){var i=e.getName();void 0!==i&&t.unshift(i),e=e.parent;}return t;}},{key:"getInternalPath",value:function value(){for(var e=this,t=[];e;){e.parent&&t.unshift(e.getIndex()),e=e.parent;}return t;}},{key:"getName",value:function value(){return this.parent?"array"!==this.parent.type?this.field:this.index:void 0;}},{key:"findNodeByPath",value:function value(e){if(e){if(0===e.length)return this;if(e.length&&this.childs&&this.childs.length)for(var t=0;t<this.childs.length;++t){if(""+e[0]==""+this.childs[t].getName())return this.childs[t].findNodeByPath(e.slice(1));}}}},{key:"findNodeByInternalPath",value:function value(e){if(e){for(var t=this,i=0;i<e.length&&t;i++){var n=e[i],t=t.childs[n];}return t;}}},{key:"serialize",value:function value(){return{value:this.getValue(),path:this.getPath()};}},{key:"findNode",value:function value(e){for(var i=Object(_.parsePath)(e),n=this,t=function t(){var t=i.shift();if("number"==typeof t){if("array"!==n.type)throw new Error("Cannot get child node at index "+t+": node is no array");n=n.childs[t];}else{if("object"!==n.type)throw new Error("Cannot get child node "+t+": node is no object");n=n.childs.filter(function(e){return e.field===t;})[0];}};n&&0<i.length;){t();}return n;}},{key:"findParents",value:function value(){for(var e=[],t=this.parent;t;){e.unshift(t),t=t.parent;}return e;}},{key:"setError",value:function value(e,t){this.error=e,this.errorChild=t,this.dom&&this.dom.tr&&this.updateError();}},{key:"updateError",value:function value(){var o=this,s=this.fieldError||this.valueError||this.error,e=this.dom.tdError;if(s&&this.dom&&this.dom.tr){Object(_.addClassName)(this.dom.tr,"jsoneditor-validation-error"),e||(e=document.createElement("td"),this.dom.tdError=e,this.dom.tdValue.parentNode.appendChild(e));var a=document.createElement("button");a.type="button",a.className="jsoneditor-button jsoneditor-schema-error";var t=function t(){o.dom.popupAnchor&&o.dom.popupAnchor.destroy();},l=function l(){delete o.dom.popupAnchor;},i=function i(e){var t=o.editor.frame;o.dom.popupAnchor=Object(C.a)(a,o.editor.getPopupAnchor(),l,e);var i=a.getBoundingClientRect(),n=120<t.getBoundingClientRect().width-i.x?"jsoneditor-above":"jsoneditor-left",r=document.createElement("div");r.className="jsoneditor-popover "+n,r.appendChild(document.createTextNode(s.message)),o.dom.popupAnchor.appendChild(r);};a.onmouseover=function(){o.dom.popupAnchor||i(!0);},a.onfocus=function(){t(),i(!1);},a.onblur=function(){t();};var n=this.errorChild;for(n&&(a.onclick=function(){n.findParents().forEach(function(e){e.expand(!1);}),n.scrollTo(function(){n.focus();});});e.firstChild;){e.removeChild(e.firstChild);}e.appendChild(a);}else this.dom.tr&&Object(_.removeClassName)(this.dom.tr,"jsoneditor-validation-error"),e&&(this.dom.tdError.parentNode.removeChild(this.dom.tdError),delete this.dom.tdError);}},{key:"getIndex",value:function value(){if(this.parent){var e=this.parent.childs.indexOf(this);return-1!==e?e:null;}return-1;}},{key:"setParent",value:function value(e){this.parent=e;}},{key:"setField",value:function value(e,t){this.field=e,this.previousField=e,this.fieldEditable=!0===t;}},{key:"getField",value:function value(){return void 0===this.field&&this._getDomField(),this.field;}},{key:"setValue",value:function value(e,t){var i,n,r,o,s,a,l,c,h=this.childs;if(this.type=this._getType(e),t&&t!==this.type){if("string"!==t||"auto"!==this.type)throw new Error('Type mismatch: cannot cast value of type "'+this.type+' to the specified type "'+t+'"');this.type=t;}if("array"===this.type){for(this.childs||(this.childs=[]),n=0;n<e.length;n++){void 0===(s=e[n])||s instanceof Function||(n<this.childs.length?((i=this.childs[n]).fieldEditable=!1,i.index=n,i.setValue(s)):(i=new W(this.editor,{value:s}),o=n<this.getMaxVisibleChilds(),this.appendChild(i,o,!1)));}for(r=this.childs.length;r>=e.length;r--){this.removeChild(this.childs[r],!1);}}else if("object"===this.type){for(this.childs||(this.childs=[]),r=this.childs.length-1;0<=r;r--){x(e,this.childs[r].field)||this.removeChild(this.childs[r],!1);}for(var d in n=0,e){x(e,d)&&(void 0===(s=e[d])||s instanceof Function||((a=this.findChildByProperty(d))?(a.setField(d,!0),a.setValue(s)):(l=new W(this.editor,{field:d,value:s}),c=n<this.getMaxVisibleChilds(),this.appendChild(l,c,!1))),n++);}!(this.value="")===this.editor.options.sortObjectKeys&&this.sort([],"asc",!1);}else this.hideChilds(),delete this.append,delete this.showMore,delete this.expanded,delete this.childs,this.value=e;Array.isArray(h)!==Array.isArray(this.childs)&&this.recreateDom(),this.updateDom({updateIndexes:!0}),this.previousValue=this.value;}},{key:"setInternalValue",value:function value(e){var t,i,n,r,o,s=this.childs;if(this.type=e.type,"array"===e.type){for(this.childs||(this.childs=[]),r=0;r<e.childs.length;r++){void 0===(t=e.childs[r])||t instanceof Function||(r<this.childs.length?((i=this.childs[r]).fieldEditable=!1,i.index=r,i.setInternalValue(t)):(i=new W(this.editor,{internalValue:t}),n=r<this.getMaxVisibleChilds(),this.appendChild(i,n,!1)));}for(o=this.childs.length;o>=e.childs.length;o--){this.removeChild(this.childs[o],!1);}}else if("object"===e.type){for(this.childs||(this.childs=[]),r=0;r<e.childs.length;r++){void 0===(t=e.childs[r])||t instanceof Function||(r<this.childs.length?(delete(i=this.childs[r]).index,i.setField(t.field,!0),i.setInternalValue(t.value)):(i=new W(this.editor,{field:t.field,internalValue:t.value}),n=r<this.getMaxVisibleChilds(),this.appendChild(i,n,!1)));}for(o=this.childs.length;o>=e.childs.length;o--){this.removeChild(this.childs[o],!1);}}else this.hideChilds(),delete this.append,delete this.showMore,delete this.expanded,delete this.childs,this.value=e.value;Array.isArray(s)!==Array.isArray(this.childs)&&this.recreateDom(),this.updateDom({updateIndexes:!0}),this.previousValue=this.value;}},{key:"recreateDom",value:function value(){var e;this.dom&&this.dom.tr&&this.dom.tr.parentNode?(e=this._detachFromDom(),this.clearDom(),this._attachToDom(e)):this.clearDom();}},{key:"getValue",value:function value(){if("array"===this.type){var t=[];return this.childs.forEach(function(e){t.push(e.getValue());}),t;}if("object"!==this.type)return void 0===this.value&&this._getDomValue(),this.value;var i={};return this.childs.forEach(function(e){i[e.getField()]=e.getValue();}),i;}},{key:"getInternalValue",value:function value(){return"array"===this.type?{type:this.type,childs:this.childs.map(function(e){return e.getInternalValue();})}:"object"===this.type?{type:this.type,childs:this.childs.map(function(e){return{field:e.getField(),value:e.getInternalValue()};})}:(void 0===this.value&&this._getDomValue(),{type:this.type,value:this.value});}},{key:"getLevel",value:function value(){return this.parent?this.parent.getLevel()+1:0;}},{key:"getNodePath",value:function value(){var e=this.parent?this.parent.getNodePath():[];return e.push(this),e;}},{key:"clone",value:function value(){var i,n=new W(this.editor);return n.type=this.type,n.field=this.field,n.fieldInnerText=this.fieldInnerText,n.fieldEditable=this.fieldEditable,n.previousField=this.previousField,n.value=this.value,n.valueInnerText=this.valueInnerText,n.previousValue=this.previousValue,n.expanded=this.expanded,n.visibleChilds=this.visibleChilds,this.childs?(i=[],this.childs.forEach(function(e){var t=e.clone();t.setParent(n),i.push(t);}),n.childs=i):n.childs=void 0,n;}},{key:"expand",value:function value(t){this.childs&&(this.expanded=!0,this.dom.expand&&(this.dom.expand.className="jsoneditor-button jsoneditor-expanded"),this.showChilds(),!1!==t&&this.childs.forEach(function(e){e.expand(t);}),this.updateDom({recurse:!1}));}},{key:"collapse",value:function value(t){this.childs&&(this.hideChilds(),!1!==t&&this.childs.forEach(function(e){e.collapse(t);}),this.dom.expand&&(this.dom.expand.className="jsoneditor-button jsoneditor-collapsed"),this.expanded=!1,this.updateDom({recurse:!1}));}},{key:"showChilds",value:function value(){if(this.childs&&this.expanded){var e=this.dom.tr,t=e?e.parentNode:void 0;if(t){var i=this.getAppendDom();i.parentNode||((r=e.nextSibling)?t.insertBefore(i,r):t.appendChild(i));for(var n=Math.min(this.childs.length,this.visibleChilds),r=this._getNextTr(),o=0;o<n;o++){var s=this.childs[o];s.getDom().parentNode||t.insertBefore(s.getDom(),r),s.showChilds();}var a=this.getShowMoreDom();r=this._getNextTr(),a.parentNode||t.insertBefore(a,r),this.showMore.updateDom();}}}},{key:"_getNextTr",value:function value(){return this.showMore&&this.showMore.getDom().parentNode?this.showMore.getDom():this.append&&this.append.getDom().parentNode?this.append.getDom():void 0;}},{key:"hide",value:function value(e){var t=this.dom.tr,i=t?t.parentNode:void 0;i&&i.removeChild(t),this.dom.popupAnchor&&this.dom.popupAnchor.destroy(),this.hideChilds(e);}},{key:"hideChilds",value:function value(e){var t,i;this.childs&&this.expanded&&((t=this.getAppendDom()).parentNode&&t.parentNode.removeChild(t),this.childs.forEach(function(e){e.hide();}),(i=this.getShowMoreDom()).parentNode&&i.parentNode.removeChild(i),e&&!e.resetVisibleChilds||(this.visibleChilds=this.getMaxVisibleChilds()));}},{key:"_updateCssClassName",value:function value(){var e;this.dom.field&&this.editor&&this.editor.options&&"function"==typeof this.editor.options.onClassName&&this.dom.tree&&(Object(_.removeAllClassNames)(this.dom.tree),e=this.editor.options.onClassName({path:this.getPath(),field:this.field,value:this.value})||"",Object(_.addClassName)(this.dom.tree,"jsoneditor-values "+e));}},{key:"recursivelyUpdateCssClassesOnNodes",value:function value(){if(this._updateCssClassName(),Array.isArray(this.childs))for(var e=0;e<this.childs.length;e++){this.childs[e].recursivelyUpdateCssClassesOnNodes();}}},{key:"expandTo",value:function value(){for(var e=this.parent;e;){e.expanded||e.expand(),e=e.parent;}}},{key:"appendChild",value:function value(e,t,i){var n,r,o;this._hasChilds()&&(e.setParent(this),e.fieldEditable="object"===this.type,"array"===this.type&&(e.index=this.childs.length),"object"===this.type&&void 0===e.field&&e.setField(""),this.childs.push(e),this.expanded&&!1!==t&&(n=e.getDom(),o=(r=this._getNextTr())?r.parentNode:void 0,r&&o&&o.insertBefore(n,r),e.showChilds(),this.visibleChilds++),!1!==i&&(this.updateDom({updateIndexes:!0}),e.updateDom({recurse:!0})));}},{key:"moveBefore",value:function value(e,t,i){var n,r,o;this._hasChilds()&&((n=this.dom.tr?this.dom.tr.parentNode:void 0)&&((r=document.createElement("tr")).style.height=n.clientHeight+"px",n.appendChild(r)),e.parent&&e.parent.removeChild(e),t instanceof L||!t?this.childs.length+1>this.visibleChilds?(o=this.childs[this.visibleChilds-1],this.insertBefore(e,o,i)):this.appendChild(e,!0,i):this.insertBefore(e,t,i),n&&n.removeChild(r));}},{key:"insertBefore",value:function value(e,t,i){if(this._hasChilds()){if(this.visibleChilds++,"object"===this.type&&void 0===e.field&&e.setField(""),t===this.append)e.setParent(this),e.fieldEditable="object"===this.type,this.childs.push(e);else{var n=this.childs.indexOf(t);if(-1===n)throw new Error("Node not found");e.setParent(this),e.fieldEditable="object"===this.type,this.childs.splice(n,0,e);}var r,o,s;this.expanded&&(r=e.getDom(),s=(o=t.getDom())?o.parentNode:void 0,o&&s&&s.insertBefore(r,o),e.showChilds(),this.showChilds()),!1!==i&&(this.updateDom({updateIndexes:!0}),e.updateDom({recurse:!0}));}}},{key:"insertAfter",value:function value(e,t){var i,n;this._hasChilds()&&(i=this.childs.indexOf(t),(n=this.childs[i+1])?this.insertBefore(e,n):this.appendChild(e));}},{key:"search",value:function value(t,i){Array.isArray(i)||(i=[]);var e=t?t.toLowerCase():void 0;return delete this.searchField,delete this.searchValue,void 0!==this.field&&i.length<=this.MAX_SEARCH_RESULTS&&(-1!==String(this.field).toLowerCase().indexOf(e)&&(this.searchField=!0,i.push({node:this,elem:"field"})),this._updateDomField()),this._hasChilds()?this.childs&&this.childs.forEach(function(e){e.search(t,i);}):void 0!==this.value&&i.length<=this.MAX_SEARCH_RESULTS&&(-1!==String(this.value).toLowerCase().indexOf(e)&&(this.searchValue=!0,i.push({node:this,elem:"value"})),this._updateDomValue()),i;}},{key:"scrollTo",value:function value(e){this.expandPathToNode(),this.dom.tr&&this.dom.tr.parentNode&&this.editor.scrollTo(this.dom.tr.offsetTop,e);}},{key:"expandPathToNode",value:function value(){for(var e=this;e&&e.parent;){for(var t="array"===e.parent.type?e.index:e.parent.childs.indexOf(e);e.parent.visibleChilds<t+1;){e.parent.visibleChilds+=this.getMaxVisibleChilds();}e.parent.expand(!1),e=e.parent;}}},{key:"focus",value:function value(e){if(W.focusElement=e,this.dom.tr&&this.dom.tr.parentNode){var t=this.dom;switch(e){case"drag":t.drag?t.drag.focus():t.menu.focus();break;case"menu":t.menu.focus();break;case"expand":this._hasChilds()?t.expand.focus():t.field&&this.fieldEditable?(t.field.focus(),Object(_.selectContentEditable)(t.field)):t.value&&!this._hasChilds()?(t.value.focus(),Object(_.selectContentEditable)(t.value)):t.menu.focus();break;case"field":t.field&&this.fieldEditable?(t.field.focus(),Object(_.selectContentEditable)(t.field)):t.value&&!this._hasChilds()?(t.value.focus(),Object(_.selectContentEditable)(t.value)):this._hasChilds()?t.expand.focus():t.menu.focus();break;case"value":default:t.select?t.select.focus():t.value&&!this._hasChilds()?(t.value.focus(),Object(_.selectContentEditable)(t.value)):t.field&&this.fieldEditable?(t.field.focus(),Object(_.selectContentEditable)(t.field)):this._hasChilds()?t.expand.focus():t.menu.focus();}}}},{key:"containsNode",value:function value(e){if(this===e)return!0;var t=this.childs;if(t)for(var i=0,n=t.length;i<n;i++){if(t[i].containsNode(e))return!0;}return!1;}},{key:"removeChild",value:function value(e,t){if(this.childs){var i=this.childs.indexOf(e);if(-1!==i){i<this.visibleChilds&&this.expanded&&this.visibleChilds--,e.hide(),delete e.searchField,delete e.searchValue;var n=this.childs.splice(i,1)[0];return n.parent=null,!1!==t&&this.updateDom({updateIndexes:!0}),n;}}}},{key:"_remove",value:function value(e){this.removeChild(e);}},{key:"changeType",value:function value(e){var t,i=this.type;i!==e&&("string"!==e&&"auto"!==e||"string"!==i&&"auto"!==i?(t=this._detachFromDom(),this.clearDom(),"object"===(this.type=e)?(this.childs||(this.childs=[]),this.childs.forEach(function(e){e.clearDom(),delete e.index,e.fieldEditable=!0,void 0===e.field&&(e.field="");}),"string"!==i&&"auto"!==i||(this.expanded=!0)):"array"===e?(this.childs||(this.childs=[]),this.childs.forEach(function(e,t){e.clearDom(),e.fieldEditable=!1,e.index=t;}),"string"!==i&&"auto"!==i||(this.expanded=!0)):this.expanded=!1,this._attachToDom(t)):this.type=e,"auto"!==e&&"string"!==e||(this.value="string"===e?String(this.value):Object(_.parseString)(String(this.value)),this.focus()),this.updateDom({updateIndexes:!0}));}},{key:"deepEqual",value:function value(e){var t;if("array"===this.type){if(!Array.isArray(e))return!1;if(this.childs.length!==e.length)return!1;for(t=0;t<this.childs.length;t++){if(!this.childs[t].deepEqual(e[t]))return!1;}}else if("object"===this.type){if("object"!==b(e)||!e)return!1;var i=Object.keys(e);if(this.childs.length!==i.length)return!1;for(t=0;t<i.length;t++){var n=this.childs[t];if(n.field!==i[t]||!n.deepEqual(e[n.field]))return!1;}}else if(this.value!==e)return!1;return!0;}},{key:"_getDomValue",value:function value(){if(this._clearValueError(),this.dom.value&&"array"!==this.type&&"object"!==this.type&&(this.valueInnerText=Object(_.getInnerText)(this.dom.value),""===this.valueInnerText&&""!==this.dom.value.innerHTML&&(this.dom.value.innerHTML="")),void 0!==this.valueInnerText)try{var e,t;(t="string"===this.type?this._unescapeHTML(this.valueInnerText):(e=this._unescapeHTML(this.valueInnerText),Object(_.parseString)(e)))!==this.value&&(this.value=t,this._debouncedOnChangeValue());}catch(e){this._setValueError(Object(d.c)("cannotParseValueError"));}}},{key:"_setValueError",value:function value(e){this.valueError={message:e},this.updateError();}},{key:"_clearValueError",value:function value(){this.valueError&&(this.valueError=null,this.updateError());}},{key:"_setFieldError",value:function value(e){this.fieldError={message:e},this.updateError();}},{key:"_clearFieldError",value:function value(){this.fieldError&&(this.fieldError=null,this.updateError());}},{key:"_onChangeValue",value:function value(){var e,t=this.editor.getDomSelection();t.range&&(e=Object(_.textDiff)(String(this.value),String(this.previousValue)),t.range.startOffset=e.start,t.range.endOffset=e.end);var i,n=this.editor.getDomSelection();n.range&&(i=Object(_.textDiff)(String(this.previousValue),String(this.value)),n.range.startOffset=i.start,n.range.endOffset=i.end),this.editor._onAction("editValue",{path:this.getInternalPath(),oldValue:this.previousValue,newValue:this.value,oldSelection:t,newSelection:n}),this.previousValue=this.value;}},{key:"_onChangeField",value:function value(){var e,t=this.editor.getDomSelection(),i=this.previousField||"";t.range&&(e=Object(_.textDiff)(this.field,i),t.range.startOffset=e.start,t.range.endOffset=e.end);var n,r=this.editor.getDomSelection();r.range&&(n=Object(_.textDiff)(i,this.field),r.range.startOffset=n.start,r.range.endOffset=n.end),this.editor._onAction("editField",{parentPath:this.parent.getInternalPath(),index:this.getIndex(),oldValue:this.previousField,newValue:this.field,oldSelection:t,newSelection:r}),this.previousField=this.field;}},{key:"_updateDomValue",value:function value(){var e=this.dom.value;if(e){var t,i=["jsoneditor-value"],n=this.value,r="auto"===this.type?Object(_.getType)(n):this.type,o="string"===r&&Object(_.isUrl)(n);if(i.push("jsoneditor-"+r),o&&i.push("jsoneditor-url"),""===String(this.value)&&"array"!==this.type&&"object"!==this.type&&i.push("jsoneditor-empty"),this.searchValueActive&&i.push("jsoneditor-highlight-active"),this.searchValue&&i.push("jsoneditor-highlight"),e.className=i.join(" "),"array"===r||"object"===r?(t=this.childs?this.childs.length:0,e.title=this.type+" containing "+t+" items"):o&&this.editable.value?e.title=Object(d.c)("openUrl"):e.title="","boolean"===r&&this.editable.value?(this.dom.checkbox||(this.dom.checkbox=document.createElement("input"),this.dom.checkbox.type="checkbox",this.dom.tdCheckbox=document.createElement("td"),this.dom.tdCheckbox.className="jsoneditor-tree",this.dom.tdCheckbox.appendChild(this.dom.checkbox),this.dom.tdValue.parentNode.insertBefore(this.dom.tdCheckbox,this.dom.tdValue)),this.dom.checkbox.checked=this.value):this.dom.tdCheckbox&&(this.dom.tdCheckbox.parentNode.removeChild(this.dom.tdCheckbox),delete this.dom.tdCheckbox,delete this.dom.checkbox),this.enum&&this.editable.value){if(!this.dom.select){this.dom.select=document.createElement("select"),this.id=this.field+"_"+new Date().getUTCMilliseconds(),this.dom.select.id=this.id,this.dom.select.name=this.dom.select.id,this.dom.select.option=document.createElement("option"),this.dom.select.option.value="",this.dom.select.option.innerHTML="--",this.dom.select.appendChild(this.dom.select.option);for(var s=0;s<this.enum.length;s++){this.dom.select.option=document.createElement("option"),this.dom.select.option.value=this.enum[s],this.dom.select.option.innerHTML=this.enum[s],this.dom.select.option.value===this.value&&(this.dom.select.option.selected=!0),this.dom.select.appendChild(this.dom.select.option);}this.dom.tdSelect=document.createElement("td"),this.dom.tdSelect.className="jsoneditor-tree",this.dom.tdSelect.appendChild(this.dom.select),this.dom.tdValue.parentNode.insertBefore(this.dom.tdSelect,this.dom.tdValue);}!this.schema||x(this.schema,"oneOf")||x(this.schema,"anyOf")||x(this.schema,"allOf")?delete this.valueFieldHTML:(this.valueFieldHTML=this.dom.tdValue.innerHTML,this.dom.tdValue.style.visibility="hidden",this.dom.tdValue.innerHTML="");}else this.dom.tdSelect&&(this.dom.tdSelect.parentNode.removeChild(this.dom.tdSelect),delete this.dom.tdSelect,delete this.dom.select,this.dom.tdValue.innerHTML=this.valueFieldHTML,this.dom.tdValue.style.visibility="",delete this.valueFieldHTML);if(this.editable.value&&this.editor.options.colorPicker&&"string"==typeof n&&Object(_.isValidColor)(n)?(this.dom.color||(this.dom.color=document.createElement("div"),this.dom.color.className="jsoneditor-color",this.dom.tdColor=document.createElement("td"),this.dom.tdColor.className="jsoneditor-tree",this.dom.tdColor.appendChild(this.dom.color),this.dom.tdValue.parentNode.insertBefore(this.dom.tdColor,this.dom.tdValue),this.dom.value.style.color="#1A1A1A"),this.dom.color.style.backgroundColor=n):this._deleteDomColor(),this._showTimestampTag()){this.dom.date||(this.dom.date=document.createElement("div"),this.dom.date.className="jsoneditor-date",this.dom.value.parentNode.appendChild(this.dom.date));var a=null;if("function"==typeof this.editor.options.timestampFormat&&(a=this.editor.options.timestampFormat({field:this.field,value:this.value,path:this.getPath()})),a){for(;this.dom.date.firstChild;){this.dom.date.removeChild(this.dom.date.firstChild);}this.dom.date.appendChild(document.createTextNode(a));}else this.dom.date.innerHTML=new Date(n).toISOString();this.dom.date.title=new Date(n).toString();}else this.dom.date&&(this.dom.date.parentNode.removeChild(this.dom.date),delete this.dom.date);Object(_.stripFormatting)(e),this._updateDomDefault();}}},{key:"_deleteDomColor",value:function value(){this.dom.color&&(this.dom.tdColor.parentNode.removeChild(this.dom.tdColor),delete this.dom.tdColor,delete this.dom.color,this.dom.value.style.color="");}},{key:"_updateDomField",value:function value(){var e,t=this.dom.field;t&&((e=Object(_.makeFieldTooltip)(this.schema,this.editor.options.language))&&(t.title=e),(""===String(this.field)&&"array"!==this.parent.type?Object(_.addClassName):Object(_.removeClassName))(t,"jsoneditor-empty"),(this.searchFieldActive?Object(_.addClassName):Object(_.removeClassName))(t,"jsoneditor-highlight-active"),(this.searchField?Object(_.addClassName):Object(_.removeClassName))(t,"jsoneditor-highlight"),Object(_.stripFormatting)(t));}},{key:"_getDomField",value:function value(e){if(this._clearFieldError(),this.dom.field&&this.fieldEditable&&(this.fieldInnerText=Object(_.getInnerText)(this.dom.field),""===this.fieldInnerText&&""!==this.dom.field.innerHTML&&(this.dom.field.innerHTML="")),void 0!==this.fieldInnerText)try{var t=this._unescapeHTML(this.fieldInnerText),i=this.parent.getFieldNames(this);-1!==i.indexOf(t)?e?(t=Object(_.findUniqueName)(t,i))!==this.field&&(this.field=t,this._debouncedOnChangeField()):this._setFieldError(Object(d.c)("duplicateFieldError")):t!==this.field&&(this.field=t,this._debouncedOnChangeField());}catch(e){this._setFieldError(Object(d.c)("cannotParseFieldError"));}}},{key:"_updateDomDefault",value:function value(){var e;!this.schema||void 0===this.schema.default||this._hasChilds()||(e=this.dom.select?this.dom.select:this.dom.value)&&(this.value===this.schema.default?(e.title=Object(d.c)("default"),Object(_.addClassName)(e,"jsoneditor-is-default"),Object(_.removeClassName)(e,"jsoneditor-is-not-default")):(e.removeAttribute("title"),Object(_.removeClassName)(e,"jsoneditor-is-default"),Object(_.addClassName)(e,"jsoneditor-is-not-default")));}},{key:"_showTimestampTag",value:function value(){if("number"!=typeof this.value)return!1;var e=this.editor.options.timestampTag;if("function"!=typeof e)return!0===e&&Object(_.isTimestamp)(this.field,this.value);var t=e({field:this.field,value:this.value,path:this.getPath()});return"boolean"==typeof t?t:Object(_.isTimestamp)(this.field,this.value);}},{key:"clearDom",value:function value(){this.dom={};}},{key:"getDom",value:function value(){var e,t,i,n,r=this.dom;if(r.tr)return r.tr;this._updateEditability(),r.tr=document.createElement("tr"),"tree"===(r.tr.node=this).editor.options.mode&&(e=document.createElement("td"),this.editable.field&&this.parent&&((t=document.createElement("button")).type="button",(r.drag=t).className="jsoneditor-button jsoneditor-dragarea",t.title=Object(d.c)("drag"),e.appendChild(t)),r.tr.appendChild(e),i=document.createElement("td"),(n=document.createElement("button")).type="button",(r.menu=n).className="jsoneditor-button jsoneditor-contextmenu-button",n.title=Object(d.c)("actionsMenu"),i.appendChild(r.menu),r.tr.appendChild(i));var o=document.createElement("td");return r.tr.appendChild(o),r.tree=this._createDomTree(),o.appendChild(r.tree),this.updateDom({updateIndexes:!0}),r.tr;}},{key:"isVisible",value:function value(){return this.dom&&this.dom.tr&&this.dom.tr.parentNode||!1;}},{key:"isDescendantOf",value:function value(e){for(var t=this.parent;t;){if(t===e)return!0;t=t.parent;}return!1;}},{key:"_createDomField",value:function value(){return document.createElement("div");}},{key:"setHighlight",value:function value(t){this.dom.tr&&((t?Object(_.addClassName):Object(_.removeClassName))(this.dom.tr,"jsoneditor-highlight"),this.append&&this.append.setHighlight(t),this.childs&&this.childs.forEach(function(e){e.setHighlight(t);}));}},{key:"setSelected",value:function value(t,e){this.selected=t,this.dom.tr&&((t?Object(_.addClassName):Object(_.removeClassName))(this.dom.tr,"jsoneditor-selected"),(e?Object(_.addClassName):Object(_.removeClassName))(this.dom.tr,"jsoneditor-first"),this.append&&this.append.setSelected(t),this.showMore&&this.showMore.setSelected(t),this.childs&&this.childs.forEach(function(e){e.setSelected(t);}));}},{key:"updateValue",value:function value(e){this.value=e,this.previousValue=e,this.valueError=void 0,this.updateDom();}},{key:"updateField",value:function value(e){this.field=e,this.previousField=e,this.fieldError=void 0,this.updateDom();}},{key:"updateDom",value:function value(t){var e=this.dom.tree;e&&(e.style.marginLeft=24*this.getLevel()+"px");var i,n,r,o=this.dom.field;o&&(this.fieldEditable?(o.contentEditable=this.editable.field,o.spellcheck=!1,o.className="jsoneditor-field"):(o.contentEditable=!1,o.className="jsoneditor-readonly"),n=void 0!==this.index?this.index:void 0!==this.field?this.field:(i=this.editor.options.schema?W._findSchema(this.editor.options.schema,this.editor.options.schemaRefs||{},this.getPath()):void 0)&&i.title?i.title:this._hasChilds()?this.type:"",r=this._escapeHTML(n),document.activeElement===o&&r===this._unescapeHTML(Object(_.getInnerText)(o))||(o.innerHTML=r),this._updateSchema());var s,a=this.dom.value;a&&("array"===this.type||"object"===this.type?this.updateNodeName():(s=this._escapeHTML(this.value),document.activeElement===a&&s===this._unescapeHTML(Object(_.getInnerText)(a))||(a.innerHTML=s)));var l=this.dom.tr;l&&("array"===this.type||"object"===this.type?(Object(_.addClassName)(l,"jsoneditor-expandable"),this.expanded?(Object(_.addClassName)(l,"jsoneditor-expanded"),Object(_.removeClassName)(l,"jsoneditor-collapsed")):(Object(_.addClassName)(l,"jsoneditor-collapsed"),Object(_.removeClassName)(l,"jsoneditor-expanded"))):(Object(_.removeClassName)(l,"jsoneditor-expandable"),Object(_.removeClassName)(l,"jsoneditor-expanded"),Object(_.removeClassName)(l,"jsoneditor-collapsed"))),this._updateDomField(),this._updateDomValue(),t&&!0===t.updateIndexes&&this._updateDomIndexes(),t&&!0===t.recurse&&this.childs&&this.childs.forEach(function(e){e.updateDom(t);}),this.error&&this.updateError(),this.append&&this.append.updateDom(),this.showMore&&this.showMore.updateDom(),this._updateCssClassName();}},{key:"_updateSchema",value:function value(){this.editor&&this.editor.options&&(this.schema=this.editor.options.schema?W._findSchema(this.editor.options.schema,this.editor.options.schemaRefs||{},this.getPath()):null,this.schema?this.enum=W._findEnum(this.schema):delete this.enum);}},{key:"_updateDomIndexes",value:function value(){var e=this.dom.value,t=this.childs;e&&t&&("array"===this.type?t.forEach(function(e,t){e.index=t;var i=e.dom.field;i&&(i.innerHTML=t);}):"object"===this.type&&t.forEach(function(e){void 0!==e.index&&(delete e.index,void 0===e.field&&(e.field=""));}));}},{key:"_createDomValue",value:function value(){var e;return"array"===this.type?(e=document.createElement("div")).innerHTML="[...]":"object"===this.type?(e=document.createElement("div")).innerHTML="{...}":(!this.editable.value&&Object(_.isUrl)(this.value)?(e=document.createElement("a")).href=this.value:((e=document.createElement("div")).contentEditable=this.editable.value,e.spellcheck=!1),e.innerHTML=this._escapeHTML(this.value)),e;}},{key:"_createDomExpandButton",value:function value(){var e=document.createElement("button");return e.type="button",this._hasChilds()?(e.className=this.expanded?"jsoneditor-button jsoneditor-expanded":"jsoneditor-button jsoneditor-collapsed",e.title=Object(d.c)("expandTitle")):(e.className="jsoneditor-button jsoneditor-invisible",e.title=""),e;}},{key:"_createDomTree",value:function value(){var e=this.dom,t=document.createElement("table"),i=document.createElement("tbody");t.style.borderCollapse="collapse",t.className="jsoneditor-values",t.appendChild(i);var n=document.createElement("tr");i.appendChild(n);var r=document.createElement("td");r.className="jsoneditor-tree",n.appendChild(r),e.expand=this._createDomExpandButton(),r.appendChild(e.expand),e.tdExpand=r;var o=document.createElement("td");o.className="jsoneditor-tree",n.appendChild(o),e.field=this._createDomField(),o.appendChild(e.field),e.tdField=o;var s=document.createElement("td");s.className="jsoneditor-tree",n.appendChild(s),"object"!==this.type&&"array"!==this.type&&(s.appendChild(document.createTextNode(":")),s.className="jsoneditor-separator"),e.tdSeparator=s;var a=document.createElement("td");return a.className="jsoneditor-tree",n.appendChild(a),e.value=this._createDomValue(),a.appendChild(e.value),e.tdValue=a,t;}},{key:"onEvent",value:function value(e){var t,i,n=e.type,r=e.target||e.srcElement,o=this.dom,s=this,a=this._hasChilds();"function"==typeof this.editor.options.onEvent&&this._onEvent(e),r!==o.drag&&r!==o.menu||("mouseover"===n?this.editor.highlighter.highlight(this):"mouseout"===n&&this.editor.highlighter.unhighlight()),"click"===n&&r===o.menu&&((t=s.editor.highlighter).highlight(s),t.lock(),Object(_.addClassName)(o.menu,"jsoneditor-selected"),this.showContextMenu(o.menu,function(){Object(_.removeClassName)(o.menu,"jsoneditor-selected"),t.unlock(),t.unhighlight();})),"click"===n&&r===o.expand&&a&&(i=e.ctrlKey,this._onExpand(i)),"click"!==n||e.target!==s.dom.tdColor&&e.target!==s.dom.color||this._showColorPicker(),"change"===n&&r===o.checkbox&&(this.dom.value.innerHTML=!this.value,this._getDomValue(),this._updateDomDefault()),"change"===n&&r===o.select&&(this.dom.value.innerHTML=o.select.value,this._getDomValue(),this._updateDomValue());var l=o.value;if(r===l)switch(n){case"blur":case"change":this._getDomValue(),this._clearValueError(),this._updateDomValue();var c=this._escapeHTML(this.value);c!==this._unescapeHTML(Object(_.getInnerText)(l))&&(l.innerHTML=c);break;case"input":this._getDomValue(),this._updateDomValue();break;case"keydown":case"mousedown":this.editor.selection=this.editor.getDomSelection();break;case"click":e.ctrlKey&&this.editable.value&&Object(_.isUrl)(this.value)&&(e.preventDefault(),window.open(this.value,"_blank"));break;case"keyup":this._getDomValue(),this._updateDomValue();break;case"cut":case"paste":setTimeout(function(){s._getDomValue(),s._updateDomValue();},1);}var h=o.field;if(r===h)switch(n){case"blur":this._getDomField(!0),this._updateDomField();var d=this._escapeHTML(this.field);d!==this._unescapeHTML(Object(_.getInnerText)(h))&&(h.innerHTML=d);break;case"input":this._getDomField(),this._updateSchema(),this._updateDomField(),this._updateDomValue();break;case"keydown":case"mousedown":this.editor.selection=this.editor.getDomSelection();break;case"keyup":this._getDomField(),this._updateDomField();break;case"cut":case"paste":setTimeout(function(){s._getDomField(),s._updateDomField();},1);}var u=o.tree;u&&r===u.parentNode&&"click"===n&&!e.hasMoved&&((void 0!==e.offsetX?e.offsetX<24*(this.getLevel()+1):e.pageX<Object(_.getAbsoluteLeft)(o.tdSeparator))||a?h&&(Object(_.setEndOfContentEditable)(h),h.focus()):l&&!this.enum&&(Object(_.setEndOfContentEditable)(l),l.focus())),(r!==o.tdExpand||a)&&r!==o.tdField&&r!==o.tdSeparator||"click"!==n||e.hasMoved||h&&(Object(_.setEndOfContentEditable)(h),h.focus()),"keydown"===n&&this.onKeyDown(e);}},{key:"_onEvent",value:function value(e){var t,i=e.target;i!==this.dom.field&&i!==this.dom.value||(t={field:this.getField(),path:this.getPath()},this._hasChilds()||i!==this.dom.value||(t.value=this.getValue()),this.editor.options.onEvent(t,e));}},{key:"onKeyDown",value:function value(e){var t,i,n,r,o,s,a,l,c,h,d,u,g,p,m,f,C,I,A,v,b,y,w=e.which||e.keyCode,S=e.target||e.srcElement,x=e.ctrlKey,k=e.shiftKey,R=e.altKey,E=!1,B="tree"===this.editor.options.mode,Z=0<this.editor.multiselection.nodes.length?this.editor.multiselection.nodes:[this],T=Z[0],G=Z[Z.length-1];13===w?S===this.dom.value?this.editable.value&&!e.ctrlKey||Object(_.isUrl)(this.value)&&(window.open(this.value,"_blank"),E=!0):S===this.dom.expand&&this._hasChilds()&&(g=e.ctrlKey,this._onExpand(g),S.focus(),E=!0):68===w?x&&B&&(W.onDuplicate(Z),E=!0):69===w?x&&(this._onExpand(k),S.focus(),E=!0):77===w&&B?x&&(this.showContextMenu(S),E=!0):46===w&&B?x&&(W.onRemove(Z),E=!0):45===w&&B?x&&!k?(this._onInsertBefore(),E=!0):x&&k&&(this._onInsertAfter(),E=!0):35===w?R&&((p=this._lastNode())&&p.focus(W.focusElement||this._getElementName(S)),E=!0):36===w?R&&((m=this._firstNode())&&m.focus(W.focusElement||this._getElementName(S)),E=!0):37===w?R&&!k?((f=this._previousElement(S))&&this.focus(this._getElementName(f)),E=!0):R&&k&&B&&(I=G.expanded?(C=G.getAppendDom())?C.nextSibling:void 0:G.getDom().nextSibling)&&(i=W.getNodeFromTarget(I),n=I.nextSibling,A=W.getNodeFromTarget(n),i&&i instanceof L&&1!==G.parent.childs.length&&A&&A.parent&&(r=this.editor.getDomSelection(),o=(s=T.parent).childs[G.getIndex()+1]||s.append,a=T.getIndex(),l=A.getIndex(),c=s.getInternalPath(),h=A.parent.getInternalPath(),Z.forEach(function(e){A.parent.moveBefore(e,A);}),this.focus(W.focusElement||this._getElementName(S)),this.editor._onAction("moveNodes",{count:Z.length,fieldNames:Z.map(H),oldParentPath:s.getInternalPath(),newParentPath:T.parent.getInternalPath(),oldIndex:o.getIndex(),newIndex:T.getIndex(),oldIndexRedo:a,newIndexRedo:l,oldParentPathRedo:c,newParentPathRedo:h,oldSelection:r,newSelection:this.editor.getDomSelection()}))):38===w?R&&!k?((t=this._previousNode())&&(this.editor.deselect(!0),t.focus(W.focusElement||this._getElementName(S))),E=!0):!R&&x&&k&&B?((t=this._previousNode())&&((u=this.editor.multiselection).start=u.start||this,u.end=t,d=this.editor._findTopLevelNodes(u.start,u.end),this.editor.select(d),t.focus("field")),E=!0):R&&k&&B&&((t=T._previousNode())&&t.parent&&(r=this.editor.getDomSelection(),o=(s=T.parent).childs[G.getIndex()+1]||s.append,a=T.getIndex(),l=t.getIndex(),c=s.getInternalPath(),h=t.parent.getInternalPath(),Z.forEach(function(e){t.parent.moveBefore(e,t);}),this.focus(W.focusElement||this._getElementName(S)),this.editor._onAction("moveNodes",{count:Z.length,fieldNames:Z.map(H),oldParentPath:s.getInternalPath(),newParentPath:T.parent.getInternalPath(),oldIndex:o.getIndex(),newIndex:T.getIndex(),oldIndexRedo:a,newIndexRedo:l,oldParentPathRedo:c,newParentPathRedo:h,oldSelection:r,newSelection:this.editor.getDomSelection()})),E=!0):39===w?R&&!k?((v=this._nextElement(S))&&this.focus(this._getElementName(v)),E=!0):R&&k&&B&&(b=T.getDom().previousSibling)&&(t=W.getNodeFromTarget(b))&&t.parent&&!t.isVisible()&&(r=this.editor.getDomSelection(),o=(s=T.parent).childs[G.getIndex()+1]||s.append,a=T.getIndex(),l=t.getIndex(),c=s.getInternalPath(),h=t.parent.getInternalPath(),Z.forEach(function(e){t.parent.moveBefore(e,t);}),this.focus(W.focusElement||this._getElementName(S)),this.editor._onAction("moveNodes",{count:Z.length,fieldNames:Z.map(H),oldParentPath:s.getInternalPath(),newParentPath:T.parent.getInternalPath(),oldIndex:o.getIndex(),newIndex:T.getIndex(),oldIndexRedo:a,newIndexRedo:l,oldParentPathRedo:c,newParentPathRedo:h,oldSelection:r,newSelection:this.editor.getDomSelection()})):40===w&&(R&&!k?((i=this._nextNode())&&(this.editor.deselect(!0),i.focus(W.focusElement||this._getElementName(S))),E=!0):!R&&x&&k&&B?((i=this._nextNode())&&((u=this.editor.multiselection).start=u.start||this,u.end=i,d=this.editor._findTopLevelNodes(u.start,u.end),this.editor.select(d),i.focus("field")),E=!0):R&&k&&B&&((i=G.expanded?G.append?G.append._nextNode():void 0:G._nextNode())&&!i.isVisible()&&(i=i.parent.showMore),i&&i instanceof L&&(i=G),(y=i&&(i._nextNode()||i.parent.append))&&y.parent&&(r=this.editor.getDomSelection(),o=(s=T.parent).childs[G.getIndex()+1]||s.append,a=T.getIndex(),l=y.getIndex(),c=s.getInternalPath(),h=y.parent.getInternalPath(),Z.forEach(function(e){y.parent.moveBefore(e,y);}),this.focus(W.focusElement||this._getElementName(S)),this.editor._onAction("moveNodes",{count:Z.length,fieldNames:Z.map(H),oldParentPath:s.getInternalPath(),newParentPath:T.parent.getInternalPath(),oldParentPathRedo:c,newParentPathRedo:h,oldIndexRedo:a,newIndexRedo:l,oldIndex:o.getIndex(),newIndex:T.getIndex(),oldSelection:r,newSelection:this.editor.getDomSelection()})),E=!0)),E&&(e.preventDefault(),e.stopPropagation());}},{key:"_onExpand",value:function value(e){var t,i,n;e&&(n=(i=(t=this.dom.tr.parentNode).parentNode).scrollTop,i.removeChild(t)),this.expanded?this.collapse(e):this.expand(e),e&&(i.appendChild(t),i.scrollTop=n);}},{key:"_showColorPicker",value:function value(){var t,e;"function"==typeof this.editor.options.onColorPicker&&this.dom.color&&((t=this)._deleteDomColor(),t.updateDom(),e=Object(C.a)(this.dom.color,this.editor.getPopupAnchor()),this.editor.options.onColorPicker(e,this.value,function(e){"string"==typeof e&&e!==t.value&&(t._deleteDomColor(),t.value=e,t.updateDom(),t._debouncedOnChangeValue());}));}},{key:"getFieldNames",value:function value(t){return"object"===this.type?this.childs.filter(function(e){return e!==t;}).map(function(e){return e.field;}):[];}},{key:"_onInsertBefore",value:function value(e,t,i){var n=this.editor.getDomSelection(),r=new W(this.editor,{field:void 0!==e?e:"",value:void 0!==t?t:"",type:i});r.expand(!0);var o=this.getInternalPath();this.parent.insertBefore(r,this),this.editor.highlighter.unhighlight(),r.focus("field");var s=this.editor.getDomSelection();this.editor._onAction("insertBeforeNodes",{nodes:[r],paths:[r.getInternalPath()],beforePath:o,parentPath:this.parent.getInternalPath(),oldSelection:n,newSelection:s});}},{key:"_onInsertAfter",value:function value(e,t,i){var n=this.editor.getDomSelection(),r=new W(this.editor,{field:void 0!==e?e:"",value:void 0!==t?t:"",type:i});r.expand(!0),this.parent.insertAfter(r,this),this.editor.highlighter.unhighlight(),r.focus("field");var o=this.editor.getDomSelection();this.editor._onAction("insertAfterNodes",{nodes:[r],paths:[r.getInternalPath()],afterPath:this.getInternalPath(),parentPath:this.parent.getInternalPath(),oldSelection:n,newSelection:o});}},{key:"_onAppend",value:function value(e,t,i){var n=this.editor.getDomSelection(),r=new W(this.editor,{field:void 0!==e?e:"",value:void 0!==t?t:"",type:i});r.expand(!0),this.parent.appendChild(r),this.editor.highlighter.unhighlight(),r.focus("field");var o=this.editor.getDomSelection();this.editor._onAction("appendNodes",{nodes:[r],paths:[r.getInternalPath()],parentPath:this.parent.getInternalPath(),oldSelection:n,newSelection:o});}},{key:"_onChangeType",value:function value(e){var t,i,n=this.type;e!==n&&(t=this.editor.getDomSelection(),this.changeType(e),i=this.editor.getDomSelection(),this.editor._onAction("changeType",{path:this.getInternalPath(),oldType:n,newType:e,oldSelection:t,newSelection:i}));}},{key:"sort",value:function value(s,e,t){var i,a,n=!(2<arguments.length&&void 0!==t)||t;"string"==typeof s&&(s=Object(_.parsePath)(s)),this._hasChilds()&&(this.hideChilds(),i=this.childs,this.childs=this.childs.concat(),a="desc"===e?-1:1,"object"===this.type?this.childs.sort(function(e,t){return a*f()(e.field,t.field);}):this.childs.sort(function(e,t){var i=e.getNestedChild(s),n=t.getNestedChild(s);if(!i)return a;if(!n)return-a;var r=i.value,o=n.value;return"string"!=typeof r&&"string"!=typeof o?o<r?a:r<o?-a:0:a*f()(r,o);}),this._updateDomIndexes(),this.showChilds(),!0===n&&this.editor._onAction("sort",{path:this.getInternalPath(),oldChilds:i,newChilds:this.childs}));}},{key:"update",value:function value(e){var t=this.getInternalValue();this.setValue(e),this.editor._onAction("transform",{path:this.getInternalPath(),oldValue:t,newValue:this.getInternalValue()});}},{key:"_detachFromDom",value:function value(){var e=this.dom.tr?this.dom.tr.parentNode:void 0,t=this.expanded?this.getAppendDom():this.getDom(),i=t&&t.parentNode?t.nextSibling:void 0;return this.hide({resetVisibleChilds:!1}),{table:e,nextTr:i};}},{key:"_attachToDom",value:function value(e){e.table&&(e.nextTr?e.table.insertBefore(this.getDom(),e.nextTr):e.table.appendChild(this.getDom())),this.expanded&&this.showChilds();}},{key:"transform",value:function value(e){if(this._hasChilds()){this.hideChilds();try{var t=this.getInternalValue(),i=this.getValue(),n=this.editor.options.executeQuery(i,e);this.setValue(n);var r=this.getInternalValue();this.editor._onAction("transform",{path:this.getInternalPath(),oldValue:t,newValue:r}),this.showChilds();}catch(e){this.showChilds(),this.editor._onError(e);}}}},{key:"extract",value:function value(){this.editor.node.hideChilds(),this.hideChilds();try{var e=this.editor.node.getInternalValue();this.editor._setRoot(this);var t=this.editor.node.getInternalValue();this.editor._onAction("transform",{path:this.editor.node.getInternalPath(),oldValue:e,newValue:t});}catch(e){this.editor._onError(e);}finally{this.updateDom({recurse:!0}),this.showChilds();}}},{key:"getNestedChild",value:function value(e){for(var t=0,i=this;i&&t<e.length;){i=i.findChildByProperty(e[t]),t++;}return i;}},{key:"findChildByProperty",value:function value(t){if("object"===this.type)return this.childs.find(function(e){return e.field===t;});}},{key:"getAppendDom",value:function value(){return this.append||(this.append=new L(this.editor),this.append.setParent(this)),this.append.getDom();}},{key:"getShowMoreDom",value:function value(){return this.showMore||(this.showMore=new E(this.editor,this)),this.showMore.getDom();}},{key:"nextSibling",value:function value(){var e=this.parent.childs.indexOf(this);return this.parent.childs[e+1]||this.parent.append;}},{key:"_previousNode",value:function value(){var e=null,t=this.getDom();if(t&&t.parentNode)for(var i=t;i=i.previousSibling,e=W.getNodeFromTarget(i),i&&e&&e instanceof L&&!e.isVisible();){}return e;}},{key:"_nextNode",value:function value(){var e=null,t=this.getDom();if(t&&t.parentNode)for(var i=t;i=i.nextSibling,e=W.getNodeFromTarget(i),i&&e&&e instanceof L&&!e.isVisible();){}return e;}},{key:"_firstNode",value:function value(){var e,t=null,i=this.getDom();return i&&i.parentNode&&(e=i.parentNode.firstChild,t=W.getNodeFromTarget(e)),t;}},{key:"_lastNode",value:function value(){var e=null,t=this.getDom();if(t&&t.parentNode)for(var i=t.parentNode.lastChild,e=W.getNodeFromTarget(i);i&&e&&!e.isVisible();){i=i.previousSibling,e=W.getNodeFromTarget(i);}return e;}},{key:"_previousElement",value:function value(e){var t=this.dom;switch(e){case t.value:if(this.fieldEditable)return t.field;case t.field:if(this._hasChilds())return t.expand;case t.expand:return t.menu;case t.menu:if(t.drag)return t.drag;default:return null;}}},{key:"_nextElement",value:function value(e){var t=this.dom;switch(e){case t.drag:return t.menu;case t.menu:if(this._hasChilds())return t.expand;case t.expand:if(this.fieldEditable)return t.field;case t.field:if(!this._hasChilds())return t.value;default:return null;}}},{key:"_getElementName",value:function value(t){var i=this;return Object.keys(this.dom).find(function(e){return i.dom[e]===t;});}},{key:"_hasChilds",value:function value(){return"array"===this.type||"object"===this.type;}},{key:"addTemplates",value:function value(t,i){var n=this,e=n.editor.options.templates;null!=e&&(e.length&&t.push({type:"separator"}),e.forEach(function(e){t.push({text:e.text,className:e.className||"jsoneditor-type-object",title:e.title,click:i?function(e,t){n._onAppend(e,t);}.bind(this,e.field,e.value):function(e,t){n._onInsertBefore(e,t);}.bind(this,e.field,e.value)});}));}},{key:"showContextMenu",value:function value(e,t){var i,n,r,o,s=this,a=[];this.editable.value&&a.push({text:Object(d.c)("type"),title:Object(d.c)("typeTitle"),className:"jsoneditor-type-"+this.type,submenu:[{text:Object(d.c)("auto"),className:"jsoneditor-type-auto"+("auto"===this.type?" jsoneditor-selected":""),title:Object(d.c)("autoType"),click:function click(){s._onChangeType("auto");}},{text:Object(d.c)("array"),className:"jsoneditor-type-array"+("array"===this.type?" jsoneditor-selected":""),title:Object(d.c)("arrayType"),click:function click(){s._onChangeType("array");}},{text:Object(d.c)("object"),className:"jsoneditor-type-object"+("object"===this.type?" jsoneditor-selected":""),title:Object(d.c)("objectType"),click:function click(){s._onChangeType("object");}},{text:Object(d.c)("string"),className:"jsoneditor-type-string"+("string"===this.type?" jsoneditor-selected":""),title:Object(d.c)("stringType"),click:function click(){s._onChangeType("string");}}]}),this._hasChilds()&&(this.editor.options.enableSort&&a.push({text:Object(d.c)("sort"),title:Object(d.c)("sortTitle",{type:this.type}),className:"jsoneditor-sort-asc",click:function click(){s.showSortModal();}}),this.editor.options.enableTransform&&a.push({text:Object(d.c)("transform"),title:Object(d.c)("transformTitle",{type:this.type}),className:"jsoneditor-transform",click:function click(){s.showTransformModal();}}),this.parent&&a.push({text:Object(d.c)("extract"),title:Object(d.c)("extractTitle",{type:this.type}),className:"jsoneditor-extract",click:function click(){s.extract();}})),this.parent&&this.parent._hasChilds()&&(a.length&&a.push({type:"separator"}),i=s.parent.childs,s===i[i.length-1]&&(n=[{text:Object(d.c)("auto"),className:"jsoneditor-type-auto",title:Object(d.c)("autoType"),click:function click(){s._onAppend("","","auto");}},{text:Object(d.c)("array"),className:"jsoneditor-type-array",title:Object(d.c)("arrayType"),click:function click(){s._onAppend("",[]);}},{text:Object(d.c)("object"),className:"jsoneditor-type-object",title:Object(d.c)("objectType"),click:function click(){s._onAppend("",{});}},{text:Object(d.c)("string"),className:"jsoneditor-type-string",title:Object(d.c)("stringType"),click:function click(){s._onAppend("","","string");}}],s.addTemplates(n,!0),a.push({text:Object(d.c)("appendText"),title:Object(d.c)("appendTitle"),submenuTitle:Object(d.c)("appendSubmenuTitle"),className:"jsoneditor-append",click:function click(){s._onAppend("","","auto");},submenu:n})),r=[{text:Object(d.c)("auto"),className:"jsoneditor-type-auto",title:Object(d.c)("autoType"),click:function click(){s._onInsertBefore("","","auto");}},{text:Object(d.c)("array"),className:"jsoneditor-type-array",title:Object(d.c)("arrayType"),click:function click(){s._onInsertBefore("",[]);}},{text:Object(d.c)("object"),className:"jsoneditor-type-object",title:Object(d.c)("objectType"),click:function click(){s._onInsertBefore("",{});}},{text:Object(d.c)("string"),className:"jsoneditor-type-string",title:Object(d.c)("stringType"),click:function click(){s._onInsertBefore("","","string");}}],s.addTemplates(r,!1),a.push({text:Object(d.c)("insert"),title:Object(d.c)("insertTitle"),submenuTitle:Object(d.c)("insertSub"),className:"jsoneditor-insert",click:function click(){s._onInsertBefore("","","auto");},submenu:r}),this.editable.field&&(a.push({text:Object(d.c)("duplicateText"),title:Object(d.c)("duplicateField"),className:"jsoneditor-duplicate",click:function click(){W.onDuplicate(s);}}),a.push({text:Object(d.c)("removeText"),title:Object(d.c)("removeField"),className:"jsoneditor-remove",click:function click(){W.onRemove(s);}}))),this.editor.options.onCreateMenu&&(o=s.getPath(),a=this.editor.options.onCreateMenu(a,{type:"single",path:o,paths:[o]})),new u.a(a,{close:t}).show(e,this.editor.getPopupAnchor());}},{key:"showSortModal",value:function value(){var n=this,e=this.editor.options.modalAnchor||v.a,t=this.getValue();Object(I.showSortModal)(e,t,function(e){var t=e.path,i=Object(_.parsePath)(t);n.sortedBy=e,n.sort(i,e.direction);},n.sortedBy);}},{key:"showTransformModal",value:function value(){var t=this,e=this.editor.options,i=e.modalAnchor,n=e.createQuery,r=e.executeQuery,o=e.queryDescription,s=this.getValue();Object(A.showTransformModal)({anchor:i||v.a,json:s,queryDescription:o,createQuery:n,executeQuery:r,onTransform:function onTransform(e){t.transform(e);}});}},{key:"_getType",value:function value(e){return e instanceof Array?"array":e instanceof Object?"object":"string"==typeof e&&"string"!=typeof Object(_.parseString)(e)?"string":"auto";}},{key:"_escapeHTML",value:function value(e){if("string"!=typeof e)return String(e);var t=String(e).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/ {2}/g," &nbsp;").replace(/^ /,"&nbsp;").replace(/ $/,"&nbsp;"),i=JSON.stringify(t),n=i.substring(1,i.length-1);return!0===this.editor.options.escapeUnicode&&(n=Object(_.escapeUnicodeChars)(n)),n;}},{key:"_unescapeHTML",value:function value(e){var t='"'+this._escapeJSON(e)+'"';return Object(_.parse)(t).replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&nbsp;|\u00A0/g," ").replace(/&amp;/g,"&");}},{key:"_escapeJSON",value:function value(e){for(var t="",i=0;i<e.length;){var n=e.charAt(i);"\n"===n?t+="\\n":"\\"===n?(t+=n,i++,""!==(n=e.charAt(i))&&-1!=='"\\/bfnrtu'.indexOf(n)||(t+="\\"),t+=n):t+='"'===n?'\\"':n,i++;}return t;}},{key:"updateNodeName",value:function value(){var e,t=this.childs?this.childs.length:0;if("object"===this.type||"array"===this.type){if(this.editor.options.onNodeName)try{e=this.editor.options.onNodeName({path:this.getPath(),size:t,type:this.type});}catch(e){console.error("Error in onNodeName callback: ",e);}this.dom.value.innerHTML="object"===this.type?"{"+(e||t)+"}":"["+(e||t)+"]";}}},{key:"recursivelyUpdateNodeName",value:function value(){var e;if(this.expanded&&(this.updateNodeName(),"undefined"!==this.childs))for(e in this.childs){this.childs[e].recursivelyUpdateNodeName();}}}])&&y(e.prototype,t),i&&y(e,i),W;}();R.prototype.DEBOUNCE_INTERVAL=150,R.prototype.MAX_SEARCH_RESULTS=999;var w=100;function S(e){return e.getInternalPath();}function H(e){return e.getField();}function x(e,t){return Object.prototype.hasOwnProperty.call(e,t);}R.focusElement=void 0,R.select=function(e){setTimeout(function(){Object(_.selectContentEditable)(e);},0);},R.onDragStart=function(t,e){if(!Array.isArray(t))return R.onDragStart([t],e);var i,n,r,o,s,a;0!==t.length&&(i=t[0],n=t[t.length-1],r=i.parent,o=R.getNodeFromTarget(e.target),s=i.editor,a=Object(_.getAbsoluteTop)(o.dom.tr)-Object(_.getAbsoluteTop)(i.dom.tr),s.mousemove||(s.mousemove=Object(_.addEventListener)(window,"mousemove",function(e){R.onDrag(t,e);})),s.mouseup||(s.mouseup=Object(_.addEventListener)(window,"mouseup",function(e){R.onDragEnd(t,e);})),s.highlighter.lock(),s.drag={oldCursor:document.body.style.cursor,oldSelection:s.getDomSelection(),oldPaths:t.map(S),oldParent:r,oldNextNode:r.childs[n.getIndex()+1]||r.append,oldParentPathRedo:r.getInternalPath(),oldIndexRedo:i.getIndex(),mouseX:e.pageX,offsetY:a,level:i.getLevel()},document.body.style.cursor="move",e.preventDefault());},R.onDrag=function(e,t){if(!Array.isArray(e))return R.onDrag([e],t);if(0!==e.length){var i,n,r,o,s,a,l,c=e[0].editor,h=t.pageY-c.drag.offsetY,d=t.pageX,u=!1,g=e[0],p=g.dom.tr,m=Object(_.getAbsoluteTop)(p),f=p.offsetHeight;if(h<m){for(S=p;S=S.previousSibling,x=R.getNodeFromTarget(S),o=S?Object(_.getAbsoluteTop)(S):0,S&&h<o;){}x&&!x.parent&&(x=void 0),x||(S=(n=p.parentNode.firstChild)?n.nextSibling:void 0,(x=R.getNodeFromTarget(S))===g&&(x=void 0)),x&&x.isVisible()&&(o=(S=x.dom.tr)?Object(_.getAbsoluteTop)(S):0)+f<h&&(x=void 0),x&&(e.forEach(function(e){x.parent.moveBefore(e,x);}),u=!0);}else{var C,I,A=e[e.length-1];if(I=(C=A.expanded&&A.append?A.append.getDom():A.dom.tr)?C.nextSibling:void 0){for(s=Object(_.getAbsoluteTop)(I),i=I;r=R.getNodeFromTarget(i),i&&(a=i.nextSibling?Object(_.getAbsoluteTop)(i.nextSibling):0,l=i?a-s:0,r&&r.parent.childs.length===e.length&&r.parent.childs[e.length-1]===A&&(m+=27),i=i.nextSibling),i&&m+l<h;){}if(r&&r.parent){for(var v=d-c.drag.mouseX,b=Math.round(v/24/2),y=c.drag.level+b,w=r.getLevel(),S=r.dom.tr&&r.dom.tr.previousSibling;w<y&&S;){var x=R.getNodeFromTarget(S);if(!e.some(function(e){return e===x||x.isDescendantOf(e);})){if(!(x instanceof L))break;var k=x.parent.childs;if(k.length===e.length&&k[e.length-1]===A)break;w=(r=R.getNodeFromTarget(S)).getLevel();}S=S.previousSibling;}r instanceof L&&!r.isVisible()&&r.parent.showMore.isVisible()&&(r=r._nextNode()),r&&r.dom.tr&&C.nextSibling!==r.dom.tr&&(e.forEach(function(e){r.parent.moveBefore(e,r);}),u=!0);}}}u&&(c.drag.mouseX=d,c.drag.level=g.getLevel()),c.startAutoScroll(h),t.preventDefault();}},R.onDragEnd=function(e,t){if(!Array.isArray(e))return R.onDrag([e],t);var i,n,r,o,s,a,l,c,h,d;0!==e.length&&(i=e[0],n=i.editor,e[0]&&e[0].dom.menu.focus(),r=n.drag.oldParent.getInternalPath(),o=i.parent.getInternalPath(),s=n.drag.oldParent===i.parent,a=n.drag.oldNextNode.getIndex(),l=i.getIndex(),c=n.drag.oldParentPathRedo,h=n.drag.oldIndexRedo,d=s&&h<l?l+e.length:l,s&&h===l||n._onAction("moveNodes",{count:e.length,fieldNames:e.map(H),oldParentPath:r,newParentPath:o,oldIndex:a,newIndex:l,oldIndexRedo:h,newIndexRedo:d,oldParentPathRedo:c,newParentPathRedo:null,oldSelection:n.drag.oldSelection,newSelection:n.getDomSelection()}),document.body.style.cursor=n.drag.oldCursor,n.highlighter.unlock(),e.forEach(function(e){e.updateDom(),t.target!==e.dom.drag&&t.target!==e.dom.menu&&n.highlighter.unhighlight();}),delete n.drag,n.mousemove&&(Object(_.removeEventListener)(window,"mousemove",n.mousemove),delete n.mousemove),n.mouseup&&(Object(_.removeEventListener)(window,"mouseup",n.mouseup),delete n.mouseup),n.stopAutoScroll(),t.preventDefault());},R._findEnum=function(e){if(e.enum)return e.enum;var t=e.oneOf||e.anyOf||e.allOf;if(t){var i=t.filter(function(e){return e.enum;});if(0<i.length)return i[0].enum;}return null;},R._findSchema=function(e,t,i){for(var n=e,r=n,o=(o=e.oneOf||e.anyOf||e.allOf)||[e],s=0;s<o.length;s++){"$ref"in(n=o[s])&&"string"==typeof n.$ref&&(n=t[n.$ref])&&(r=R._findSchema(n,t,i));for(var a=0;a<i.length&&n;a++){var l=i.slice(a+1,i.length),c=i[a];if("string"!=typeof c||!n.patternProperties||n.properties&&c in n.properties)"string"==typeof c&&n.properties?c in n.properties?(n=n.properties[c])&&(r=R._findSchema(n,t,l)):r=null:"number"==typeof c&&n.items&&(n=n.items)&&(r=R._findSchema(n,t,l));else for(var h in n.patternProperties){c.match(h)&&(r=R._findSchema(n.patternProperties[h],t,l));}}}return r===e&&0<i.length?null:r;},R.onRemove=function(e){if(!Array.isArray(e))return R.onRemove([e]);var t,i,n,r,o,s,a;e&&0<e.length&&(i=(t=e[0]).parent,n=t.editor,r=t.getIndex(),n.highlighter.unhighlight(),o=n.getDomSelection(),R.blurNodes(e),s=n.getDomSelection(),a=e.map(S),e.forEach(function(e){e.parent._remove(e);}),n._onAction("removeNodes",{nodes:e,paths:a,parentPath:i.getInternalPath(),index:r,oldSelection:o,newSelection:s}));},R.onDuplicate=function(e){if(!Array.isArray(e))return R.onDuplicate([e]);var t,n,i,r,o,s,a;e&&0<e.length&&(t=e[e.length-1],n=t.parent,(i=t.editor).deselect(i.multiselection.nodes),r=i.getDomSelection(),o=t,s=e.map(function(e){var t,i=e.clone();return"object"===e.parent.type&&(t=e.parent.getFieldNames(),i.field=Object(_.findUniqueName)(e.field,t)),n.insertAfter(i,o),o=i;}),1===e.length?"object"===s[0].parent.type?(s[0].dom.field.innerHTML=e[0].field,s[0].focus("field")):s[0].focus():i.select(s),a=i.getDomSelection(),i._onAction("duplicateNodes",{paths:e.map(S),clonePaths:s.map(S),afterPath:t.getInternalPath(),parentPath:n.getInternalPath(),oldSelection:r,newSelection:a}));},R.getNodeFromTarget=function(e){for(;e;){if(e.node)return e.node;e=e.parentNode;}},R.targetIsColorPicker=function(e){var t=R.getNodeFromTarget(e);if(t)for(var i=e&&e.parentNode;i;){if(i===t.dom.color)return!0;i=i.parentNode;}return!1;},R.blurNodes=function(e){var t,i,n;Array.isArray(e)?(i=(t=e[0]).parent,n=t.getIndex(),i.childs[n+e.length]?i.childs[n+e.length].focus():i.childs[n-1]?i.childs[n-1].focus():i.focus()):R.blurNodes([e]);};var L=((k.prototype=new R()).getDom=function(){var e=this.dom;if(e.tr)return e.tr;this._updateEditability();var t,i,n=document.createElement("tr");n.className="jsoneditor-append",n.node=this,e.tr=n,"tree"===this.editor.options.mode&&(e.tdDrag=document.createElement("td"),t=document.createElement("td"),e.tdMenu=t,(i=document.createElement("button")).type="button",i.className="jsoneditor-button jsoneditor-contextmenu-button",i.title="Click to open the actions menu (Ctrl+M)",e.menu=i,t.appendChild(e.menu));var r=document.createElement("td"),o=document.createElement("div");return o.innerHTML="("+Object(d.c)("empty")+")",o.className="jsoneditor-readonly",r.appendChild(o),e.td=r,e.text=o,this.updateDom(),n;},k.prototype.getPath=function(){return null;},k.prototype.getIndex=function(){return null;},k.prototype.updateDom=function(e){var t=this.dom,i=t.td;i&&(i.style.paddingLeft=24*this.getLevel()+26+"px");var n=t.text;n&&(n.innerHTML="("+Object(d.c)("empty")+" "+this.parent.type+")");var r=t.tr;this.isVisible()?t.tr.firstChild||(t.tdDrag&&r.appendChild(t.tdDrag),t.tdMenu&&r.appendChild(t.tdMenu),r.appendChild(i)):t.tr.firstChild&&(t.tdDrag&&r.removeChild(t.tdDrag),t.tdMenu&&r.removeChild(t.tdMenu),r.removeChild(i));},k.prototype.isVisible=function(){return 0===this.parent.childs.length;},k.prototype.showContextMenu=function(e,t){var i=this,n=[{text:Object(d.c)("auto"),className:"jsoneditor-type-auto",title:Object(d.c)("autoType"),click:function click(){i._onAppend("","","auto");}},{text:Object(d.c)("array"),className:"jsoneditor-type-array",title:Object(d.c)("arrayType"),click:function click(){i._onAppend("",[]);}},{text:Object(d.c)("object"),className:"jsoneditor-type-object",title:Object(d.c)("objectType"),click:function click(){i._onAppend("",{});}},{text:Object(d.c)("string"),className:"jsoneditor-type-string",title:Object(d.c)("stringType"),click:function click(){i._onAppend("","","string");}}];i.addTemplates(n,!0);var r,o=[{text:Object(d.c)("appendText"),title:Object(d.c)("appendTitleAuto"),submenuTitle:Object(d.c)("appendSubmenuTitle"),className:"jsoneditor-insert",click:function click(){i._onAppend("","","auto");},submenu:n}];this.editor.options.onCreateMenu&&(r=i.parent.getPath(),o=this.editor.options.onCreateMenu(o,{type:"append",path:r,paths:[r]})),new u.a(o,{close:t}).show(e,this.editor.getPopupAnchor());},k.prototype.onEvent=function(e){var t,i=e.type,n=e.target||e.srcElement,r=this.dom;n===r.menu&&("mouseover"===i?this.editor.highlighter.highlight(this.parent):"mouseout"===i&&this.editor.highlighter.unhighlight()),"click"===i&&n===r.menu&&((t=this.editor.highlighter).highlight(this.parent),t.lock(),Object(_.addClassName)(r.menu,"jsoneditor-selected"),this.showContextMenu(r.menu,function(){Object(_.removeClassName)(r.menu,"jsoneditor-selected"),t.unlock(),t.unhighlight();})),"keydown"===i&&this.onKeyDown(e);},k);function k(e){this.editor=e,this.dom={};}var E=((B.prototype=new R()).getDom=function(){return this.dom.tr||(this._updateEditability(),this.dom.tr||(i=(t=this).parent,(e=document.createElement("a")).appendChild(document.createTextNode(Object(d.c)("showMore"))),e.href="#",e.onclick=function(e){return i.visibleChilds=Math.floor(i.visibleChilds/i.getMaxVisibleChilds()+1)*i.getMaxVisibleChilds(),t.updateDom(),i.showChilds(),e.preventDefault(),!1;},(n=document.createElement("a")).appendChild(document.createTextNode(Object(d.c)("showAll"))),n.href="#",n.onclick=function(e){return i.visibleChilds=1/0,t.updateDom(),i.showChilds(),e.preventDefault(),!1;},r=document.createElement("div"),o=document.createTextNode(this._getShowMoreText()),r.className="jsoneditor-show-more",r.appendChild(o),r.appendChild(e),r.appendChild(document.createTextNode(". ")),r.appendChild(n),r.appendChild(document.createTextNode(". ")),(s=document.createElement("td")).appendChild(r),a=document.createElement("tr"),"tree"===this.editor.options.mode&&(a.appendChild(document.createElement("td")),a.appendChild(document.createElement("td"))),a.appendChild(s),a.className="jsoneditor-show-more",this.dom.tr=a,this.dom.moreContents=r,this.dom.moreText=o),this.updateDom()),this.dom.tr;var t,i,e,n,r,o,s,a;},B.prototype.updateDom=function(e){var t;this.isVisible()?(this.dom.tr.node=this.parent.childs[this.parent.visibleChilds],this.dom.tr.parentNode||(t=this.parent._getNextTr())&&t.parentNode.insertBefore(this.dom.tr,t),this.dom.moreText.nodeValue=this._getShowMoreText(),this.dom.moreContents.style.marginLeft=24*(this.getLevel()+1)+"px"):this.dom.tr&&this.dom.tr.parentNode&&this.dom.tr.parentNode.removeChild(this.dom.tr);},B.prototype._getShowMoreText=function(){return Object(d.c)("showMoreStatus",{visibleChilds:this.parent.visibleChilds,totalChilds:this.parent.childs.length})+" ";},B.prototype.isVisible=function(){return this.parent.expanded&&this.parent.childs.length>this.parent.visibleChilds;},B.prototype.onEvent=function(e){"keydown"===e.type&&this.onKeyDown(e);},B);function B(e,t){this.editor=e,this.parent=t,this.dom={};}var Z=i(8),T=i(9),G={start:function start(e,t){return 0===t.indexOf(e);},contain:function contain(e,t){return-1<t.indexOf(e);}};var W=i(4),$={};$.create=function(e,t){if(!e)throw new Error("No container element provided.");this.container=e,this.dom={},this.highlighter=new s(),this.selection=void 0,this.multiselection={nodes:[]},this.validateSchema=null,this.validationSequence=0,this.errorNodes=[],this.lastSchemaErrors=void 0,this.node=null,this.focusTarget=null,this._setOptions(t),t.autocomplete&&(this.autocomplete=function(l){(l=l||{}).filter=l.filter||"start",l.trigger=l.trigger||"keydown",l.confirmKeys=l.confirmKeys||[39,35,9],l.caseSensitive=l.caseSensitive||!1;var r="",o="",s=document.createElement("div");s.style.position="relative",s.style.outline="0",s.style.border="0",s.style.margin="0",s.style.padding="0";var t,c,h=document.createElement("div");function d(e){var t,i;document.createRange?((t=document.createRange()).selectNodeContents(e),t.collapse(!1),(i=window.getSelection()).removeAllRanges(),i.addRange(t)):document.selection&&((t=document.body.createTextRange()).moveToElementText(e),t.collapse(!1),t.select());}function a(e){return void 0===t&&((t=document.createElement("span")).style.visibility="hidden",t.style.position="fixed",t.style.outline="0",t.style.margin="0",t.style.padding="0",t.style.border="0",t.style.left="0",t.style.whiteSpace="pre",t.style.fontSize=r,t.style.fontFamily=o,t.style.fontWeight="normal",document.body.appendChild(t)),t.innerHTML=String(e).replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/'/g,"&#39;").replace(/</g,"&lt;").replace(/>/g,"&gt;"),t.getBoundingClientRect().right;}h.className="autocomplete dropdown",h.style.position="absolute",h.style.visibility="hidden";var u,g,p,i,m,f={onArrowDown:function onArrowDown(){},onArrowUp:function onArrowUp(){},onEnter:function onEnter(){},onTab:function onTab(){},startFrom:0,options:[],element:null,elementHint:null,elementStyle:null,wrapper:s,show:function show(e,t,i){var n=this;this.startFrom=t,this.wrapper.remove(),this.elementHint&&(this.elementHint.remove(),this.elementHint=null),""===r&&(r=window.getComputedStyle(e).getPropertyValue("font-size")),""===o&&(o=window.getComputedStyle(e).getPropertyValue("font-family")),h.style.marginLeft="0",h.style.marginTop=e.getBoundingClientRect().height+"px",this.options=i.map(String),this.element!==e&&(this.element=e,this.elementStyle={zIndex:this.element.style.zIndex,position:this.element.style.position,backgroundColor:this.element.style.backgroundColor,borderColor:this.element.style.borderColor}),this.element.style.zIndex=3,this.element.style.position="relative",this.element.style.backgroundColor="transparent",this.element.style.borderColor="transparent",this.elementHint=e.cloneNode(),this.elementHint.className="autocomplete hint",this.elementHint.style.zIndex=2,this.elementHint.style.position="absolute",this.elementHint.onfocus=function(){n.element.focus();},this.element.addEventListener&&(this.element.removeEventListener("keydown",b),this.element.addEventListener("keydown",b,!1),this.element.removeEventListener("blur",y),this.element.addEventListener("blur",y,!1)),s.appendChild(this.elementHint),s.appendChild(h),e.parentElement.appendChild(s),this.repaint(e);},setText:function setText(e){this.element.innerText=e;},getText:function getText(){return this.element.innerText;},hideDropDown:function hideDropDown(){this.wrapper.remove(),this.elementHint&&(this.elementHint.remove(),this.elementHint=null,C.hide(),this.element.style.zIndex=this.elementStyle.zIndex,this.element.style.position=this.elementStyle.position,this.element.style.backgroundColor=this.elementStyle.backgroundColor,this.element.style.borderColor=this.elementStyle.borderColor);},repaint:function repaint(e){var t=(t=e.innerText).replace("\n",""),i=this.options.length,n=t.substring(this.startFrom);c=t.substring(0,this.startFrom);for(var r=0;r<i;r++){var o=this.options[r];if(!l.caseSensitive&&0===o.toLowerCase().indexOf(n.toLowerCase())||l.caseSensitive&&0===o.indexOf(n)){this.elementHint.innerText=c+n+o.substring(n.length),this.elementHint.realInnerText=c+o;break;}}h.style.left=a(c)+"px",C.refresh(n,this.options),this.elementHint.style.width=a(this.elementHint.innerText)+10+"px","hidden"===h.style.visibility||(this.elementHint.style.width=a(this.elementHint.innerText)+h.clientWidth+"px");}},C=(u=h,g=[],p=0,i=-1,m={rs:f,hide:function hide(){u.style.visibility="hidden";},refresh:function refresh(i,e){u.style.visibility="hidden",p=0,u.innerHTML="";var t=window.innerHeight||document.documentElement.clientHeight,n=u.parentNode.getBoundingClientRect(),r=n.top-6,o=t-n.bottom-6;g=[];var s="function"==typeof l.filter?l.filter:G[l.filter],a=s?e.filter(function(e){return s(l.caseSensitive?i:i.toLowerCase(),l.caseSensitive?e:e.toLowerCase(),l);}):[];0!==(g=a.map(function(e){var t=document.createElement("div");return t.className="item",t.onmouseover=I,t.onmouseout=A,t.onmousedown=v,t.__hint=e,t.innerHTML=e.substring(0,i.length)+"<b>"+e.substring(i.length)+"</b>",u.appendChild(t),t;})).length&&(1===g.length&&(i.toLowerCase()===g[0].__hint.toLowerCase()&&!l.caseSensitive||i===g[0].__hint&&l.caseSensitive)||g.length<2||(m.highlight(0),3*o<r?(u.style.maxHeight=r+"px",u.style.top="",u.style.bottom="100%"):(u.style.top="100%",u.style.bottom="",u.style.maxHeight=o+"px"),u.style.visibility="visible"));},highlight:function highlight(e){-1!==i&&g[i]&&(g[i].className="item"),g[e].className="item hover",i=e;},move:function move(e){return"hidden"===u.style.visibility?"":(p+e===-1||p+e===g.length||(p+=e,m.highlight(p)),g[p].__hint);},onmouseselection:function onmouseselection(){}});function I(){this.style.backgroundColor="#ddd";}function A(){this.style.backgroundColor="";}function v(){m.hide(),m.onmouseselection(this.__hint,m.rs);}var b=function(e){var t=(e=e||window.event).keyCode;if(null!=this.elementHint&&33!==t&&34!==t){if(27===t)return f.hideDropDown(),f.element.focus(),e.preventDefault(),void e.stopPropagation();var i,n,r=(r=this.element.innerText).replace("\n","");if(0<=l.confirmKeys.indexOf(t))return 9===t&&0===this.elementHint.innerText.length&&f.onTab(),void(0<this.elementHint.innerText.length&&this.element.innerText!==this.elementHint.realInnerText&&(this.element.innerText=this.elementHint.realInnerText,f.hideDropDown(),d(this.element),9===t&&(f.element.focus(),e.preventDefault(),e.stopPropagation())));if(13!==t){if(40===t){var o=r.substring(this.startFrom),s=C.move(1);return""===s&&f.onArrowDown(),this.elementHint.innerText=c+o+s.substring(o.length),this.elementHint.realInnerText=c+s,e.preventDefault(),void e.stopPropagation();}38===t&&(i=r.substring(this.startFrom),""===(n=C.move(-1))&&f.onArrowUp(),this.elementHint.innerText=c+i+n.substring(i.length),this.elementHint.realInnerText=c+n,e.preventDefault(),e.stopPropagation());}else if(0===this.elementHint.innerText.length)f.onEnter();else{var a="hidden"===h.style.visibility;if(C.hide(),a)return f.hideDropDown(),f.element.focus(),void f.onEnter();this.element.innerText=this.elementHint.realInnerText,f.hideDropDown(),d(this.element),e.preventDefault(),e.stopPropagation();}}}.bind(f),y=function y(){f.hideDropDown();};return C.onmouseselection=function(e,t){t.element.innerText=t.elementHint.innerText=c+e,t.hideDropDown(),window.setTimeout(function(){t.element.focus(),d(t.element);},1);},f;}(t.autocomplete)),this.options.history&&"view"!==this.options.mode&&(this.history=new l(this)),this._createFrame(),this._createTable();},$.destroy=function(){this.frame&&this.container&&this.frame.parentNode===this.container&&(this.container.removeChild(this.frame),this.frame=null),this.container=null,this.dom=null,this.clear(),this.node=null,this.focusTarget=null,this.selection=null,this.multiselection=null,this.errorNodes=null,this.validateSchema=null,this._debouncedValidate=null,this.history&&(this.history.destroy(),this.history=null),this.searchBox&&(this.searchBox.destroy(),this.searchBox=null),this.modeSwitcher&&(this.modeSwitcher.destroy(),this.modeSwitcher=null),this.frameFocusTracker.destroy();},$._setOptions=function(t){var i=this;this.options={search:!0,history:!0,mode:"tree",name:void 0,schema:null,schemaRefs:null,autocomplete:null,navigationBar:!0,mainMenuBar:!0,onSelectionChange:null,colorPicker:!0,onColorPicker:function onColorPicker(e,t,i){var n,r;o.a?(n=e.getBoundingClientRect().top,r=window.innerHeight-n<300&&300<n,new o.a({parent:e,color:t,popup:r?"top":"bottom",onDone:function onDone(e){var t=1===e.rgba[3]?e.hex.substr(0,7):e.hex;i(t);}}).show()):console.warn("Cannot open color picker: the `vanilla-picker` library is not included in the bundle. Either use the full bundle or implement your own color picker using `onColorPicker`.");},timestampTag:!0,timestampFormat:null,createQuery:W.a,executeQuery:W.b,onEvent:null,enableSort:!0,enableTransform:!0},t&&Object.keys(t).forEach(function(e){i.options[e]=t[e];}),this.setSchema(this.options.schema,this.options.schemaRefs),this._debouncedValidate=Object(_.debounce)(this.validate.bind(this),this.DEBOUNCE_INTERVAL),t.onSelectionChange&&this.onSelectionChange(t.onSelectionChange),Object(d.b)(this.options.languages),Object(d.a)(this.options.language);},$.set=function(e){var t,i;e instanceof Function||void 0===e?this.clear():(this.content.removeChild(this.table),t={field:this.options.name,value:e},i=new R(this,t),this._setRoot(i),this.validate(),this.node.expand(!1),this.content.appendChild(this.table)),this.history&&this.history.clear(),this.searchBox&&this.searchBox.clear();},$.update=function(e){var t,i,n;this.node.deepEqual(e)||(t=this.getSelection(),this.onChangeDisabled=!0,this.node.update(e),this.onChangeDisabled=!1,this.validate(),this.searchBox&&!this.searchBox.isEmpty()&&this.searchBox.forceSearch(),t&&t.start&&t.end?(i=this.node.findNodeByPath(t.start.path),n=this.node.findNodeByPath(t.end.path),i&&n?this.setSelection(t.start,t.end):this.setSelection({},{})):this.setSelection({},{}));},$.get=function(){return this.node?this.node.getValue():void 0;},$.getText=function(){return JSON.stringify(this.get());},$.setText=function(t){try{this.set(Object(_.parse)(t));}catch(e){var i=Object(_.repair)(t);this.set(Object(_.parse)(i));}},$.updateText=function(t){try{this.update(Object(_.parse)(t));}catch(e){var i=Object(_.repair)(t);this.update(Object(_.parse)(i));}},$.setName=function(e){this.options.name=e,this.node&&this.node.updateField(this.options.name);},$.getName=function(){return this.options.name;},$.focus=function(){var e=this.scrollableContent.querySelector("[contenteditable=true]");e?e.focus():this.node.dom.expand?this.node.dom.expand.focus():this.node.dom.menu?this.node.dom.menu.focus():(e=this.frame.querySelector("button"))&&e.focus();},$.clear=function(){this.node&&(this.node.hide(),delete this.node),this.treePath&&this.treePath.reset();},$._setRoot=function(e){this.clear(),(this.node=e).setParent(null),e.setField(this.getName(),!1),delete e.index,this.tbody.appendChild(e.getDom());},$.search=function(e){var t;return this.node?(this.content.removeChild(this.table),t=this.node.search(e),this.content.appendChild(this.table)):t=[],t;},$.expandAll=function(){this.node&&(this.content.removeChild(this.table),this.node.expand(),this.content.appendChild(this.table));},$.collapseAll=function(){this.node&&(this.content.removeChild(this.table),this.node.collapse(),this.content.appendChild(this.table));},$._onAction=function(e,t){this.history&&this.history.add(e,t),this._onChange();},$._onChange=function(){if(!this.onChangeDisabled){var e;if(this.selection=this.getDomSelection(),this._debouncedValidate(),this.treePath&&((e=this.node&&this.selection?this.node.findNodeByInternalPath(this.selection.path):this.multiselection?this.multiselection.nodes[0]:void 0)?this._updateTreePath(e.getNodePath()):this.treePath.reset()),this.options.onChange)try{this.options.onChange();}catch(e){console.error("Error in onChange callback: ",e);}if(this.options.onChangeJSON)try{this.options.onChangeJSON(this.get());}catch(e){console.error("Error in onChangeJSON callback: ",e);}if(this.options.onChangeText)try{this.options.onChangeText(this.getText());}catch(e){console.error("Error in onChangeText callback: ",e);}if(this.options.onClassName&&this.node.recursivelyUpdateCssClassesOnNodes(),this.options.onNodeName&&this.node.childs)try{this.node.recursivelyUpdateNodeName();}catch(e){console.error("Error in onNodeName callback: ",e);}}},$.validate=function(){var i=this,t=this.node;if(t){var e=t.getValue(),n=[];this.validateSchema&&(this.validateSchema(e)||(n=this.validateSchema.errors.map(function(e){return Object(_.improveSchemaError)(e);}).map(function(e){return{node:t.findNode(e.dataPath),error:e,type:"validation"};}).filter(function(e){return null!=e.node;})));try{this.validationSequence++;var r=this,o=this.validationSequence;this._validateCustom(e).then(function(e){var t;o===r.validationSequence&&(t=[].concat(n,e||[]),r._renderValidationErrors(t),"function"==typeof i.options.onValidationError&&(Object(_.isValidationErrorChanged)(t,i.lastSchemaErrors)&&i.options.onValidationError.call(i,t),i.lastSchemaErrors=t));}).catch(function(e){console.error(e);});}catch(e){console.error(e);}}},$._renderValidationErrors=function(e){this.errorNodes&&this.errorNodes.forEach(function(e){e.setError(null);});var t=e.reduce(function(e,t){return t.node.findParents().filter(function(t){return!e.some(function(e){return e[0]===t;});}).map(function(e){return[e,t.node];}).concat(e);},[]);this.errorNodes=t.map(function(e){return{node:e[0],child:e[1],error:{message:"object"===e[0].type?"Contains invalid properties":"Contains invalid items"}};}).concat(e).map(function(e){return e.node.setError(e.error,e.child),e.node;});},$._validateCustom=function(e){try{if(this.options.onValidate){var i=this.node,t=this.options.onValidate(e);return(Object(_.isPromise)(t)?t:Promise.resolve(t)).then(function(e){return Array.isArray(e)?e.filter(function(e){var t=Object(_.isValidValidationError)(e);return t||console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:',e),t;}).map(function(e){var t;try{t=e&&e.path?i.findNodeByPath(e.path):null;}catch(e){}return t||console.warn("Ignoring validation error: node not found. Path:",e.path,"Error:",e),{node:t,error:e,type:"customValidation"};}).filter(function(e){return e&&e.node&&e.error&&e.error.message;}):null;});}}catch(e){return Promise.reject(e);}return Promise.resolve(null);},$.refresh=function(){this.node&&this.node.updateDom({recurse:!0});},$.startAutoScroll=function(e){var t=this,i=this.scrollableContent,n=Object(_.getAbsoluteTop)(i),r=i.clientHeight,o=n+r;e<n+24&&0<i.scrollTop?this.autoScrollStep=(n+24-e)/3:o-24<e&&r+i.scrollTop<i.scrollHeight?this.autoScrollStep=(o-24-e)/3:this.autoScrollStep=void 0,this.autoScrollStep?this.autoScrollTimer||(this.autoScrollTimer=setInterval(function(){t.autoScrollStep?i.scrollTop-=t.autoScrollStep:t.stopAutoScroll();},50)):this.stopAutoScroll();},$.stopAutoScroll=function(){this.autoScrollTimer&&(clearTimeout(this.autoScrollTimer),delete this.autoScrollTimer),this.autoScrollStep&&delete this.autoScrollStep;},$.setDomSelection=function(e){var t,i,n,r,o;e&&("scrollTop"in e&&this.scrollableContent&&(this.scrollableContent.scrollTop=e.scrollTop),e.paths?(t=this,i=e.paths.map(function(e){return t.node.findNodeByInternalPath(e);}),this.select(i)):(r=(n=e.path?this.node.findNodeByInternalPath(e.path):null)&&e.domName?n.dom[e.domName]:null,e.range&&r?(o=Object.assign({},e.range,{container:r}),Object(_.setSelectionOffset)(o)):n&&n.focus()));},$.getDomSelection=function(){var t=R.getNodeFromTarget(this.focusTarget),i=this.focusTarget,e=t?Object.keys(t.dom).find(function(e){return t.dom[e]===i;}):null,n=Object(_.getSelectionOffset)();return n&&"DIV"!==n.container.nodeName&&(n=null),n&&n.container!==i&&(n=null),n&&delete n.container,{path:t?t.getInternalPath():null,domName:e,range:n,paths:0<this.multiselection.length?this.multiselection.nodes.map(function(e){return e.getInternalPath();}):null,scrollTop:this.scrollableContent?this.scrollableContent.scrollTop:0};},$.scrollTo=function(e,n){var r,t,i,o,s=this.scrollableContent;s?((r=this).animateTimeout&&(clearTimeout(r.animateTimeout),delete r.animateTimeout),r.animateCallback&&(r.animateCallback(!1),delete r.animateCallback),t=s.clientHeight,i=s.scrollHeight-t,o=Math.min(Math.max(e-t/4,0),i),function e(){var t=s.scrollTop,i=o-t;3<Math.abs(i)?(s.scrollTop+=i/3,r.animateCallback=n,r.animateTimeout=setTimeout(e,50)):(n&&n(!0),s.scrollTop=o,delete r.animateTimeout,delete r.animateCallback);}()):n&&n(!1);},$._createFrame=function(){this.frame=document.createElement("div"),this.frame.className="jsoneditor jsoneditor-mode-"+this.options.mode,this.container.appendChild(this.frame),this.contentOuter=document.createElement("div"),this.contentOuter.className="jsoneditor-outer";var t=this;function i(e){t._onEvent&&t._onEvent(e);}var e,n,r,o,s,a,l,c={target:this.frame,onFocus:this.options.onFocus||null,onBlur:this.options.onBlur||null};this.frameFocusTracker=new T.a(c),this.frame.onclick=function(e){var t=e.target;i(e),"BUTTON"===t.nodeName&&e.preventDefault();},this.frame.oninput=i,this.frame.onchange=i,this.frame.onkeydown=i,this.frame.onkeyup=i,this.frame.oncut=i,this.frame.onpaste=i,this.frame.onmousedown=i,this.frame.onmouseup=i,this.frame.onmouseover=i,this.frame.onmouseout=i,Object(_.addEventListener)(this.frame,"focus",i,!0),Object(_.addEventListener)(this.frame,"blur",i,!0),this.frame.onfocusin=i,this.frame.onfocusout=i,this.options.mainMenuBar&&(Object(_.addClassName)(this.contentOuter,"has-main-menu-bar"),this.menu=document.createElement("div"),this.menu.className="jsoneditor-menu",this.frame.appendChild(this.menu),(e=document.createElement("button")).type="button",e.className="jsoneditor-expand-all",e.title=Object(d.c)("expandAll"),e.onclick=function(){t.expandAll();},this.menu.appendChild(e),(n=document.createElement("button")).type="button",n.title=Object(d.c)("collapseAll"),n.className="jsoneditor-collapse-all",n.onclick=function(){t.collapseAll();},this.menu.appendChild(n),this.options.enableSort&&((r=document.createElement("button")).type="button",r.className="jsoneditor-sort",r.title=Object(d.c)("sortTitleShort"),r.onclick=function(){t.node.showSortModal();},this.menu.appendChild(r)),this.options.enableTransform&&((o=document.createElement("button")).type="button",o.title=Object(d.c)("transformTitleShort"),o.className="jsoneditor-transform",o.onclick=function(){t.node.showTransformModal();},this.menu.appendChild(o)),this.history&&((s=document.createElement("button")).type="button",s.className="jsoneditor-undo jsoneditor-separator",s.title=Object(d.c)("undo"),s.onclick=function(){t._onUndo();},this.menu.appendChild(s),this.dom.undo=s,(a=document.createElement("button")).type="button",a.className="jsoneditor-redo",a.title=Object(d.c)("redo"),a.onclick=function(){t._onRedo();},this.menu.appendChild(a),this.dom.redo=a,this.history.onChange=function(){s.disabled=!t.history.canUndo(),a.disabled=!t.history.canRedo();},this.history.onChange()),this.options&&this.options.modes&&this.options.modes.length&&((l=this).modeSwitcher=new Z.a(this.menu,this.options.modes,this.options.mode,function(e){l.setMode(e),l.modeSwitcher.focus();})),this.options.search&&(this.searchBox=new h(this,this.menu))),this.options.navigationBar&&(this.navBar=document.createElement("div"),this.navBar.className="jsoneditor-navigation-bar nav-bar-empty",this.frame.appendChild(this.navBar),this.treePath=new p(this.navBar,this.getPopupAnchor()),this.treePath.onSectionSelected(this._onTreePathSectionSelected.bind(this)),this.treePath.onContextMenuItemSelected(this._onTreePathMenuItemSelected.bind(this)));},$._onUndo=function(){this.history&&(this.history.undo(),this._onChange());},$._onRedo=function(){this.history&&(this.history.redo(),this._onChange());},$._onEvent=function(e){if(!R.targetIsColorPicker(e.target)){var t,i=R.getNodeFromTarget(e.target);if("keydown"===e.type&&this._onKeyDown(e),i&&"focus"===e.type&&(this.focusTarget=e.target,this.options.autocomplete&&"focus"===this.options.autocomplete.trigger&&this._showAutoComplete(e.target)),"mousedown"===e.type&&this._startDragDistance(e),"mousemove"!==e.type&&"mouseup"!==e.type&&"click"!==e.type||this._updateDragDistance(e),i&&this.options&&this.options.navigationBar&&i&&("keydown"===e.type||"mousedown"===e.type)&&(t=this,setTimeout(function(){t._updateTreePath(i.getNodePath());})),i&&i.selected){if("click"===e.type){if(e.target===i.dom.menu)return void this.showContextMenu(e.target);e.hasMoved||this.deselect();}"mousedown"===e.type&&R.onDragStart(this.multiselection.nodes,e);}else"mousedown"===e.type&&Object(_.hasParentNode)(e.target,this.content)&&(this.deselect(),i&&e.target===i.dom.drag?R.onDragStart(i,e):i&&(e.target===i.dom.field||e.target===i.dom.value||e.target===i.dom.select)||this._onMultiSelectStart(e));i&&i.onEvent(e);}},$._updateTreePath=function(e){var i;function n(e){return e.parent?"array"===e.parent.type?e.index:e.field:e.field||e.type;}e&&e.length?(Object(_.removeClassName)(this.navBar,"nav-bar-empty"),i=[],e.forEach(function(e){var t={name:n(e),node:e,children:[]};e.childs&&e.childs.length&&e.childs.forEach(function(e){t.children.push({name:n(e),node:e});}),i.push(t);}),this.treePath.setPath(i)):Object(_.addClassName)(this.navBar,"nav-bar-empty");},$._onTreePathSectionSelected=function(e){e&&e.node&&(e.node.expandTo(),e.node.focus());},$._onTreePathMenuItemSelected=function(e,t){var i;e&&e.children.length&&(i=e.children.find(function(e){return e.name===t;}))&&i.node&&(this._updateTreePath(i.node.getNodePath()),i.node.expandTo(),i.node.focus());},$._startDragDistance=function(e){this.dragDistanceEvent={initialTarget:e.target,initialPageX:e.pageX,initialPageY:e.pageY,dragDistance:0,hasMoved:!1};},$._updateDragDistance=function(e){this.dragDistanceEvent||this._startDragDistance(e);var t=e.pageX-this.dragDistanceEvent.initialPageX,i=e.pageY-this.dragDistanceEvent.initialPageY;return this.dragDistanceEvent.dragDistance=Math.sqrt(t*t+i*i),this.dragDistanceEvent.hasMoved=this.dragDistanceEvent.hasMoved||10<this.dragDistanceEvent.dragDistance,e.dragDistance=this.dragDistanceEvent.dragDistance,e.hasMoved=this.dragDistanceEvent.hasMoved,e.dragDistance;},$._onMultiSelectStart=function(e){var t,i=R.getNodeFromTarget(e.target);"tree"===this.options.mode&&void 0===this.options.onEditable&&(this.multiselection={start:i||null,end:null,nodes:[]},this._startDragDistance(e),(t=this).mousemove||(this.mousemove=Object(_.addEventListener)(window,"mousemove",function(e){t._onMultiSelect(e);})),this.mouseup||(this.mouseup=Object(_.addEventListener)(window,"mouseup",function(e){t._onMultiSelectEnd(e);})),e.preventDefault());},$._onMultiSelect=function(e){var t,i,n,r;e.preventDefault(),this._updateDragDistance(e),e.hasMoved&&((t=R.getNodeFromTarget(e.target))&&(null==this.multiselection.start&&(this.multiselection.start=t),this.multiselection.end=t),this.deselect(),i=this.multiselection.start,n=this.multiselection.end||this.multiselection.start,i&&n&&(this.multiselection.nodes=this._findTopLevelNodes(i,n),this.multiselection.nodes&&this.multiselection.nodes.length&&(r=this.multiselection.nodes[0],this.multiselection.start===r||this.multiselection.start.isDescendantOf(r)?this.multiselection.direction="down":this.multiselection.direction="up"),this.select(this.multiselection.nodes)));},$._onMultiSelectEnd=function(){this.multiselection.nodes[0]&&this.multiselection.nodes[0].dom.menu.focus(),this.multiselection.start=null,this.multiselection.end=null,this.mousemove&&(Object(_.removeEventListener)(window,"mousemove",this.mousemove),delete this.mousemove),this.mouseup&&(Object(_.removeEventListener)(window,"mouseup",this.mouseup),delete this.mouseup);},$.deselect=function(e){var t=!!this.multiselection.nodes.length;this.multiselection.nodes.forEach(function(e){e.setSelected(!1);}),this.multiselection.nodes=[],e&&(this.multiselection.start=null,this.multiselection.end=null),t&&this._selectionChangedHandler&&this._selectionChangedHandler();},$.select=function(e){if(!Array.isArray(e))return this.select([e]);var t,i;e&&(this.deselect(),this.multiselection.nodes=e.slice(0),t=e[0],e.forEach(function(e){e.expandPathToNode(),e.setSelected(!0,e===t);}),this._selectionChangedHandler&&(i=this.getSelection(),this._selectionChangedHandler(i.start,i.end)));},$._findTopLevelNodes=function(e,t){for(var i=e.getNodePath(),n=t.getNodePath(),r=0;r<i.length&&i[r]===n[r];){r++;}var o=i[r-1],s=i[r],a=n[r];if(s&&a||(o.parent?o=(a=s=o).parent:(s=o.childs[0],a=o.childs[o.childs.length-1])),o&&s&&a){var l=o.childs.indexOf(s),c=o.childs.indexOf(a),h=Math.min(l,c),d=Math.max(l,c);return o.childs.slice(h,d+1);}return[];},$._showAutoComplete=function(t){var i=R.getNodeFromTarget(t),n="";0<=t.className.indexOf("jsoneditor-value")&&(n="value"),0<=t.className.indexOf("jsoneditor-field")&&(n="field");var r=this;setTimeout(function(){var e;!i||!("focus"===r.options.autocomplete.trigger||0<t.innerText.length)||null===(e=r.options.autocomplete.getOptions(t.innerText,i.getPath(),n,i.editor))?r.autocomplete.hideDropDown():"function"==typeof e.then?e.then(function(e){null===e?r.autocomplete.hideDropDown():e.options?r.autocomplete.show(t,e.startFrom,e.options):r.autocomplete.show(t,0,e);}).catch(function(e){console.error(e);}):e.options?r.autocomplete.show(t,e.startFrom,e.options):r.autocomplete.show(t,0,e);},50);},$._onKeyDown=function(e){var t,i=e.which||e.keyCode,n=e.altKey,r=e.ctrlKey,o=e.metaKey,s=e.shiftKey,a=!1,l=this.focusTarget;9===i&&(t=this,setTimeout(function(){t.focusTarget!==l&&Object(_.selectContentEditable)(t.focusTarget);},0)),this.searchBox&&(r&&70===i?(this.searchBox.dom.search.focus(),this.searchBox.dom.search.select(),a=!0):(114===i||r&&71===i)&&(s?this.searchBox.previous(!0):this.searchBox.next(!0),a=!0)),this.history&&(r&&!s&&90===i?(this._onUndo(),a=!0):r&&s&&90===i&&(this._onRedo(),a=!0)),this.options.autocomplete&&!a&&(r||n||o||1!==e.key.length&&8!==i&&46!==i||(a=!1,this._showAutoComplete(e.target))),a&&(e.preventDefault(),e.stopPropagation());},$._createTable=function(){var e;this.options.navigationBar&&Object(_.addClassName)(this.contentOuter,"has-nav-bar"),this.scrollableContent=document.createElement("div"),this.scrollableContent.className="jsoneditor-tree",this.contentOuter.appendChild(this.scrollableContent),this.content=document.createElement("div"),this.content.className="jsoneditor-tree-inner",this.scrollableContent.appendChild(this.content),this.table=document.createElement("table"),this.table.className="jsoneditor-tree",this.content.appendChild(this.table),this.colgroupContent=document.createElement("colgroup"),"tree"===this.options.mode&&((e=document.createElement("col")).width="24px",this.colgroupContent.appendChild(e)),(e=document.createElement("col")).width="24px",this.colgroupContent.appendChild(e),e=document.createElement("col"),this.colgroupContent.appendChild(e),this.table.appendChild(this.colgroupContent),this.tbody=document.createElement("tbody"),this.table.appendChild(this.tbody),this.frame.appendChild(this.contentOuter);},$.showContextMenu=function(e,t){var i,n=[],r=this.multiselection.nodes.slice();n.push({text:Object(d.c)("duplicateText"),title:Object(d.c)("duplicateTitle"),className:"jsoneditor-duplicate",click:function click(){R.onDuplicate(r);}}),n.push({text:Object(d.c)("remove"),title:Object(d.c)("removeTitle"),className:"jsoneditor-remove",click:function click(){R.onRemove(r);}}),this.options.onCreateMenu&&(i=r.map(function(e){return e.getPath();}),n=this.options.onCreateMenu(n,{type:"multiple",path:i[0],paths:i})),new u.a(n,{close:t}).show(e,this.getPopupAnchor());},$.getPopupAnchor=function(){return this.options.popupAnchor||this.frame;},$.getSelection=function(){var e,t,i={start:null,end:null};return this.multiselection.nodes&&this.multiselection.nodes.length&&this.multiselection.nodes.length&&(e=this.multiselection.nodes[0],t=this.multiselection.nodes[this.multiselection.nodes.length-1],"down"===this.multiselection.direction?(i.start=e.serialize(),i.end=t.serialize()):(i.start=t.serialize(),i.end=e.serialize())),i;},$.onSelectionChange=function(e){"function"==typeof e&&(this._selectionChangedHandler=Object(_.debounce)(e,this.DEBOUNCE_INTERVAL));},$.setSelection=function(e,t){e&&e.dom&&e.range&&(console.warn("setSelection/getSelection usage for text selection is deprecated and should not be used, see documentation for supported selection options"),this.setDomSelection(e));var i=this._getNodeInstancesByRange(e,t);i.forEach(function(e){e.expandTo();}),this.select(i);},$._getNodeInstancesByRange=function(e,t){var i,n;e&&e.path&&(i=this.node.findNodeByPath(e.path),t&&t.path&&(n=this.node.findNodeByPath(t.path)));var r=[];if(i instanceof R)if(n instanceof R&&n!==i){if(i.parent===n.parent){t=i.getIndex()<n.getIndex()?(e=i,n):(e=n,i);var o=e;for(r.push(o);o=o.nextSibling(),r.push(o),o&&o!==t;){}}else r=this._findTopLevelNodes(i,n);}else r.push(i);return r;},$.getNodesByRange=function(e,t){var i=this._getNodeInstancesByRange(e,t),n=[];return i.forEach(function(e){n.push(e.serialize());}),n;};var V=[{mode:"tree",mixin:$,data:"json"},{mode:"view",mixin:$,data:"json"},{mode:"form",mixin:$,data:"json"}];},function(e,t,i){"use strict";i.r(t),i.d(t,"previewModeMixins",function(){return c;});var u=i(1),g=i(8),p=i(15),n=i(5),a=i(6),r=i(21),m=i(2),f=i(9),C=i(0);function o(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}var I=function(){function n(e,t,i){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,n),this.onChange=e,this.calculateItemSize=t||function(){return 1;},this.limit=i,this.items=[],this.index=-1;}var e,t,i;return e=n,(t=[{key:"add",value:function value(e){for(;this._calculateHistorySize()>this.limit&&1<this.items.length;){this.items.shift(),this.index--;}this.items=this.items.slice(0,this.index+1),this.items.push(e),this.index++,this.onChange();}},{key:"_calculateHistorySize",value:function value(){var t=this.calculateItemSize,i=0;return this.items.forEach(function(e){i+=t(e);}),i;}},{key:"undo",value:function value(){if(this.canUndo())return this.index--,this.onChange(),this.items[this.index];}},{key:"redo",value:function value(){if(this.canRedo())return this.index++,this.onChange(),this.items[this.index];}},{key:"canUndo",value:function value(){return 0<this.index;}},{key:"canRedo",value:function value(){return this.index<this.items.length-1;}},{key:"clear",value:function value(){this.items=[],this.index=-1,this.onChange();}}])&&o(e.prototype,t),i&&o(e,i),n;}(),A=i(4),s=r.textModeMixins[0].mixin,l={create:function create(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};void 0===t.statusBar&&(t.statusBar=!0),t.mainMenuBar=!1!==t.mainMenuBar,t.enableSort=!1!==t.enableSort,t.enableTransform=!1!==t.enableTransform,t.createQuery=t.createQuery||A.a,t.executeQuery=t.executeQuery||A.b,"number"==typeof(this.options=t).indentation?this.indentation=Number(t.indentation):this.indentation=2,Object(u.b)(this.options.languages),Object(u.a)(this.options.language),this.mode="preview";var i=this;this.container=e,this.dom={},this.json=void 0,this.text="",this._debouncedValidate=Object(C.debounce)(this.validate.bind(this),this.DEBOUNCE_INTERVAL),this.width=e.clientWidth,this.height=e.clientHeight,this.frame=document.createElement("div"),this.frame.className="jsoneditor jsoneditor-mode-preview",this.frame.onclick=function(e){e.preventDefault();};var n,r,o,s,a,l,c,h,d={target:this.frame,onFocus:this.options.onFocus||null,onBlur:this.options.onBlur||null};this.frameFocusTracker=new f.a(d),this.content=document.createElement("div"),this.content.className="jsoneditor-outer",this.dom.busy=document.createElement("div"),this.dom.busy.className="jsoneditor-busy",this.dom.busyContent=document.createElement("span"),this.dom.busyContent.innerHTML="busy...",this.dom.busy.appendChild(this.dom.busyContent),this.content.appendChild(this.dom.busy),this.dom.previewContent=document.createElement("pre"),this.dom.previewContent.className="jsoneditor-preview",this.dom.previewText=document.createTextNode(""),this.dom.previewContent.appendChild(this.dom.previewText),this.content.appendChild(this.dom.previewContent),this.options.mainMenuBar&&(Object(C.addClassName)(this.content,"has-main-menu-bar"),this.menu=document.createElement("div"),this.menu.className="jsoneditor-menu",this.frame.appendChild(this.menu),(n=document.createElement("button")).type="button",n.className="jsoneditor-format",n.title=Object(u.c)("formatTitle"),this.menu.appendChild(n),n.onclick=function(){i.executeWithBusyMessage(function(){try{i.format();}catch(e){i._onError(e);}},"formatting...");},(r=document.createElement("button")).type="button",r.className="jsoneditor-compact",r.title=Object(u.c)("compactTitle"),this.menu.appendChild(r),r.onclick=function(){i.executeWithBusyMessage(function(){try{i.compact();}catch(e){i._onError(e);}},"compacting...");},this.options.enableSort&&((o=document.createElement("button")).type="button",o.className="jsoneditor-sort",o.title=Object(u.c)("sortTitleShort"),o.onclick=function(){i._showSortModal();},this.menu.appendChild(o)),this.options.enableTransform&&((s=document.createElement("button")).type="button",s.title=Object(u.c)("transformTitleShort"),s.className="jsoneditor-transform",s.onclick=function(){i._showTransformModal();},this.dom.transform=s,this.menu.appendChild(s)),(a=document.createElement("button")).type="button",a.className="jsoneditor-repair",a.title=Object(u.c)("repairTitle"),this.menu.appendChild(a),!(a.onclick=function(){void 0===i.json&&i.executeWithBusyMessage(function(){try{i.repair();}catch(e){i._onError(e);}},"repairing...");})!==this.options.history&&(this.history=new I(function(){i.dom.undo.disabled=!i.history.canUndo(),i.dom.redo.disabled=!i.history.canRedo();},function(e){return 2*e.text.length;},m.c),(l=document.createElement("button")).type="button",l.className="jsoneditor-undo jsoneditor-separator",l.title=Object(u.c)("undo"),l.onclick=function(){var e=i.history.undo();e&&i._applyHistory(e);},this.menu.appendChild(l),this.dom.undo=l,(c=document.createElement("button")).type="button",c.className="jsoneditor-redo",c.title=Object(u.c)("redo"),c.onclick=function(){var e=i.history.redo();e&&i._applyHistory(e);},this.menu.appendChild(c),this.dom.redo=c,this.history.onChange()),this.options&&this.options.modes&&this.options.modes.length&&(this.modeSwitcher=new g.a(this.menu,this.options.modes,this.options.mode,function(e){i.setMode(e),i.modeSwitcher.focus();}))),this.errorTable=new p.a({errorTableVisible:!0,onToggleVisibility:function onToggleVisibility(){i.validate();},onFocusLine:null,onChangeHeight:function onChangeHeight(e){var t=e+(i.dom.statusBar?i.dom.statusBar.clientHeight:0)+1;i.content.style.marginBottom=-t+"px",i.content.style.paddingBottom=t+"px";}}),this.frame.appendChild(this.content),this.frame.appendChild(this.errorTable.getErrorTable()),this.container.appendChild(this.frame),t.statusBar&&(Object(C.addClassName)(this.content,"has-status-bar"),h=document.createElement("div"),(this.dom.statusBar=h).className="jsoneditor-statusbar",this.frame.appendChild(h),this.dom.fileSizeInfo=document.createElement("span"),this.dom.fileSizeInfo.className="jsoneditor-size-info",this.dom.fileSizeInfo.innerText="",h.appendChild(this.dom.fileSizeInfo),this.dom.arrayInfo=document.createElement("span"),this.dom.arrayInfo.className="jsoneditor-size-info",this.dom.arrayInfo.innerText="",h.appendChild(this.dom.arrayInfo),h.appendChild(this.errorTable.getErrorCounter()),h.appendChild(this.errorTable.getWarningIcon()),h.appendChild(this.errorTable.getErrorIcon())),this._renderPreview(),this.setSchema(this.options.schema,this.options.schemaRefs);},_renderPreview:function _renderPreview(){var e=this.getText();this.dom.previewText.nodeValue=Object(C.limitCharacters)(e,m.b),this.dom.fileSizeInfo&&(this.dom.fileSizeInfo.innerText="Size: "+Object(C.formatSize)(e.length)),this.dom.arrayInfo&&(Array.isArray(this.json)?this.dom.arrayInfo.innerText="Array: "+this.json.length+" items":this.dom.arrayInfo.innerText="");},_onChange:function _onChange(){if(this._debouncedValidate(),this.options.onChange)try{this.options.onChange();}catch(e){console.error("Error in onChange callback: ",e);}if(this.options.onChangeJSON)try{this.options.onChangeJSON(this.get());}catch(e){console.error("Error in onChangeJSON callback: ",e);}if(this.options.onChangeText)try{this.options.onChangeText(this.getText());}catch(e){console.error("Error in onChangeText callback: ",e);}}};l._showSortModal=function(){var s=this;this.executeWithBusyMessage(function(){var e=s.options.modalAnchor||m.a,o=s.get();s._renderPreview(),Object(n.showSortModal)(e,o,function(r){s.executeWithBusyMessage(function(){var e,t,i,n;e=o,t=r,Array.isArray(e)&&(i=Object(C.sort)(e,t.path,t.direction),s.sortedBy=t,s._setAndFireOnChange(i)),Object(C.isObject)(e)&&(n=Object(C.sortObjectKeys)(e,t.direction),s.sortedBy=t,s._setAndFireOnChange(n));},"sorting...");},s.sortedBy);},"parsing...");},l._showTransformModal=function(){var s=this;this.executeWithBusyMessage(function(){var e=s.options,t=e.createQuery,i=e.executeQuery,n=e.modalAnchor,r=e.queryDescription,o=s.get();s._renderPreview(),Object(a.showTransformModal)({anchor:n||m.a,json:o,queryDescription:r,createQuery:t,executeQuery:i,onTransform:function onTransform(t){s.executeWithBusyMessage(function(){var e=i(o,t);s._setAndFireOnChange(e);},"transforming...");}});},"parsing...");},l.destroy=function(){this.frame&&this.container&&this.frame.parentNode===this.container&&this.container.removeChild(this.frame),this.modeSwitcher&&(this.modeSwitcher.destroy(),this.modeSwitcher=null),this._debouncedValidate=null,this.history&&(this.history.clear(),this.history=null),this.frameFocusTracker.destroy();},l.compact=function(){var e=this.get(),t=JSON.stringify(e);this._setTextAndFireOnChange(t,e);},l.format=function(){var e=this.get(),t=JSON.stringify(e,null,this.indentation);this._setTextAndFireOnChange(t,e);},l.repair=function(){var e=this.getText(),t=Object(C.repair)(e);this._setTextAndFireOnChange(t);},l.focus=function(){this.dom.transform.focus();},l.set=function(e){this.history&&this.history.clear(),this._set(e);},l.update=function(e){this._set(e);},l._set=function(e){this.text=void 0,this.json=e,this._renderPreview(),this._pushHistory(),this._debouncedValidate();},l._setAndFireOnChange=function(e){this._set(e),this._onChange();},l.get=function(){var e;return void 0===this.json&&(e=this.getText(),this.json=Object(C.parse)(e)),this.json;},l.getText=function(){return void 0===this.text&&(this.text=JSON.stringify(this.json,null,this.indentation),!0===this.options.escapeUnicode&&(this.text=Object(C.escapeUnicodeChars)(this.text))),this.text;},l.setText=function(e){this.history&&this.history.clear(),this._setText(e);},l.updateText=function(e){this.getText()!==e&&this._setText(e);},l._setText=function(e,t){var i;!0===this.options.escapeUnicode?this.text=Object(C.escapeUnicodeChars)(e):this.text=e,this.json=t,this._renderPreview(),void 0===this.json?(i=this).executeWithBusyMessage(function(){try{i.json=i.get(),i._renderPreview(),i._pushHistory();}catch(e){}},"parsing..."):this._pushHistory(),this._debouncedValidate();},l._setTextAndFireOnChange=function(e,t){this._setText(e,t),this._onChange();},l._applyHistory=function(e){this.json=e.json,this.text=e.text,this._renderPreview(),this._debouncedValidate();},l._pushHistory=function(){var e;this.history&&(e={text:this.text,json:this.json},this.history.add(e));},l.executeWithBusyMessage=function(e,t){var i;this.getText().length>m.d?(i=this,Object(C.addClassName)(i.frame,"busy"),i.dom.busyContent.innerText=t,setTimeout(function(){e(),Object(C.removeClassName)(i.frame,"busy"),i.dom.busyContent.innerText="";},100)):e();},l.validate=s.validate,l._renderErrors=s._renderErrors;var c=[{mode:"preview",mixin:l,data:"json"}];}],r.c=n,r.d=function(e,t,i){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i});},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==(typeof t==="undefined"?"undefined":_typeof(t))&&t&&t.__esModule)return t;var i=Object.create(null);if(r.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var n in t){r.d(i,n,function(e){return t[e];}.bind(null,n));}return i;},r.n=function(e){var t=e&&e.__esModule?function(){return e.default;}:function(){return e;};return r.d(t,"a",t),t;},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t);},r.p="",r(r.s=36);function r(e){if(n[e])return n[e].exports;var t=n[e]={i:e,l:!1,exports:{}};return i[e].call(t.exports,t,t.exports,r),t.l=!0,t.exports;}var i,n;});//# sourceMappingURL=jsoneditor.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _EditorSelection = __webpack_require__(369);
	
	var _EditorSelection2 = _interopRequireDefault(_EditorSelection);
	
	var _EditorDom = __webpack_require__(160);
	
	var _EditorDom2 = _interopRequireDefault(_EditorDom);
	
	var _EditorResize = __webpack_require__(1311);
	
	var _EditorResize2 = _interopRequireDefault(_EditorResize);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var EditorContentEditableDiv = function (_React$Component) {
		_inherits(EditorContentEditableDiv, _React$Component);
	
		function EditorContentEditableDiv(props) {
			_classCallCheck(this, EditorContentEditableDiv);
	
			var _this = _possibleConstructorReturn(this, (EditorContentEditableDiv.__proto__ || Object.getPrototypeOf(EditorContentEditableDiv)).call(this, props));
	
			_this.handleWindowMouseDown = function (e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var tagName = target.tagName.toUpperCase();
				var FormControls = ["TEXTAREA", "INPUT", "SELECT", "OPTIONS"];
				if (FormControls.indexOf(tagName) != -1) {
					return;
				}
				_EditorSelection2.default.clearRange();
			};
	
			_this.handleMouseDown = function (e) {
				_EditorSelection2.default.clearRange();
				_EditorDom2.default.stopPropagation(e);
			};
	
			_this.handleMouseUp = function (e) {
				_EditorSelection2.default.createRange();
				if (_this.props.onRangeChange) {
					_this.props.onRangeChange(e);
				}
				_EditorDom2.default.stopPropagation(e);
			};
	
			_this.state = {
				content: ""
			};
			return _this;
		}
	
		_createClass(EditorContentEditableDiv, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				window.addEventListener('keydown', this.props.handleKeyDown);
				window.addEventListener('keyup', this.props.handleKeyUp);
				window.addEventListener("mousedown", this.handleWindowMouseDown);
				window.addEventListener("mouseup", this.handleMouseUp);
				setTimeout(this.props.onEditorMount, 50);
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				// reload判断当前是否可以允许刷新
				// loaded状态变化时，务必重新刷新
				var currentValue = nextProps.value;
				var editorValue = this.getContent();
	
				if (currentValue == editorValue) {
					return false;
				}
				return true;
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {
				// EditorSelection.cloneRange();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				// EditorSelection.cloneRange();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				window.removeEventListener("mousedown", this.handleWindowMouseDown);
				window.removeEventListener("mouseup", this.handleMouseUp);
				window.removeEventListener("keydown", this.props.handleKeyDown);
				window.removeEventListener("keyup", this.props.handleKeyUp);
			}
		}, {
			key: 'getContent',
			value: function getContent() {
				var target = _reactDom2.default.findDOMNode(this.refs.edit);
				return target.innerHTML;
			}
		}, {
			key: 'setContent',
			value: function setContent(content) {
				if (this.getContent() == content) return;
				this.setState({
					content: content
				});
				var target = _reactDom2.default.findDOMNode(this.refs.edit);
				target.innerHTML = content;
			}
		}, {
			key: 'getName',
			value: function getName() {
				return "div";
			}
		}, {
			key: 'setResizeTarget',
			value: function setResizeTarget(target) {
				this.refs.resize.setTarget(target);
			}
		}, {
			key: 'clearResizeTarget',
			value: function clearResizeTarget() {
				this.refs.resize.clearTarget();
			}
		}, {
			key: 'getEditorRange',
			value: function getEditorRange() {
				return _reactDom2.default.findDOMNode(this.refs.edit);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement('div', { className: 'editor-contenteditable-div' }, _react2.default.createElement(_EditorResize2.default, { ref: 'resize' }), _react2.default.createElement('div', { className: 'editable-range',
					ref: 'edit',
					onMouseUp: this.handleMouseUp,
					onMouseDown: this.handleMouseDown,
					onInput: function onInput(e) {
						_EditorSelection2.default.selection = _EditorSelection2.default.getSelection();
						if (_EditorSelection2.default.selection && _EditorSelection2.default.selection.rangeCount > 0) {
							_EditorSelection2.default.range = _EditorSelection2.default.selection.getRangeAt(0).cloneRange();
						} else {
							_EditorSelection2.default.range = null;
						}
					},
					contentEditable: true,
					dangerouslySetInnerHTML: { __html: this.state.content } }));
			}
		}]);
	
		return EditorContentEditableDiv;
	}(_react2.default.Component);
	
	exports.default = EditorContentEditableDiv;
	
	module.exports = EditorContentEditableDiv;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _EditorHistory = __webpack_require__(683);
	
	var _EditorHistory2 = _interopRequireDefault(_EditorHistory);
	
	var _EditorSelection = __webpack_require__(369);
	
	var _EditorSelection2 = _interopRequireDefault(_EditorSelection);
	
	var _EditorDom = __webpack_require__(160);
	
	var _EditorDom2 = _interopRequireDefault(_EditorDom);
	
	var _EditorTimer = __webpack_require__(1312);
	
	var _EditorTimer2 = _interopRequireDefault(_EditorTimer);
	
	var _ColorDropdown = __webpack_require__(1297);
	
	var _ColorDropdown2 = _interopRequireDefault(_ColorDropdown);
	
	var _FormulaDropdown = __webpack_require__(1301);
	
	var _FormulaDropdown2 = _interopRequireDefault(_FormulaDropdown);
	
	var _TablePickerDropdown = __webpack_require__(1307);
	
	var _TablePickerDropdown2 = _interopRequireDefault(_TablePickerDropdown);
	
	var _FontSizeComboBox = __webpack_require__(1300);
	
	var _FontSizeComboBox2 = _interopRequireDefault(_FontSizeComboBox);
	
	var _FontFamilyComboBox = __webpack_require__(1299);
	
	var _FontFamilyComboBox2 = _interopRequireDefault(_FontFamilyComboBox);
	
	var _ParagraphComboBox = __webpack_require__(1305);
	
	var _ParagraphComboBox2 = _interopRequireDefault(_ParagraphComboBox);
	
	var _EmotionDialog = __webpack_require__(1298);
	
	var _EmotionDialog2 = _interopRequireDefault(_EmotionDialog);
	
	var _SpecialCharsDialog = __webpack_require__(1306);
	
	var _SpecialCharsDialog2 = _interopRequireDefault(_SpecialCharsDialog);
	
	var _ImageDialog = __webpack_require__(1302);
	
	var _ImageDialog2 = _interopRequireDefault(_ImageDialog);
	
	var _EditorToolbar = __webpack_require__(1296);
	
	var _EditorToolbar2 = _interopRequireDefault(_EditorToolbar);
	
	var _EditorTextArea = __webpack_require__(1295);
	
	var _EditorTextArea2 = _interopRequireDefault(_EditorTextArea);
	
	var _EditorContentEditableDiv = __webpack_require__(1292);
	
	var _EditorContentEditableDiv2 = _interopRequireDefault(_EditorContentEditableDiv);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	// utlils
	
	
	// dialog & dropdown
	
	// combobox
	
	// dialog
	
	
	// base components
	
	
	// key down context
	var saveSceneTimer = null;
	var keycont = 0;
	
	var MQ = null;
	
	/**
	 * 对外接口方法
	 * @findDOMNode: 获取"root","editarea","toolbar","color"的ref对象以及相应的dom对象
	 * @setContent: 设置html格式数据
	 * @getContent: 获取html格式数据
	 * @onFocus: 监听focus事件
	 * @focusEditor: 聚焦到Editor上
	 * @defaultValue: 默认内容
	 * @value: 编辑器的值
	 * @icons: 工具条上需要显示的图标
	 **/
	
	var EditorCore = function (_Component) {
	  _inherits(EditorCore, _Component);
	
	  function EditorCore(props) {
	    _classCallCheck(this, EditorCore);
	
	    var _this = _possibleConstructorReturn(this, (EditorCore.__proto__ || Object.getPrototypeOf(EditorCore)).call(this, props));
	
	    _this.handleKeyDown = function (evt) {
	      evt = evt || event;
	      var target = evt.target || evt.srcElement;
	      var maxInputCount = _this.state.maxInputCount;
	
	      if (target.className && target.className.indexOf('editor-contenteditable-div') != -1) {
	        var keyCode = evt.keyCode || evt.which;
	        if (!evt.ctrlKey && !evt.metaKey && !evt.shiftKey && !evt.altKey) {
	          if (_EditorHistory2.default.getCommandStack().length == 0) {
	            _this.autoSave();
	            keycont = 0;
	          }
	          clearTimeout(saveSceneTimer);
	          saveSceneTimer = _EditorTimer2.default.setTimeout(function () {
	            var interalTimer = _EditorTimer2.default.setInterval(function () {
	              _this.autoSave();
	              keycont = 0;
	              _EditorTimer2.default.clearInterval(interalTimer);
	            }, 300);
	          }, 200);
	          lastKeyCode = keyCode;
	          keycont++;
	          if (keycont >= maxInputCount) {
	            _this.autoSave();
	            keycont = 0;
	          }
	        }
	      }
	      _EditorDom2.default.stopPropagation(evt);
	    };
	
	    _this.handleKeyUp = function (evt) {
	      evt = evt || event;
	      var target = evt.target || evt.srcElement;
	      if (target.className && target.className.indexOf('editor-contenteditable-div') != -1) {
	        if (!evt.ctrlKey && !evt.metaKey && !evt.shiftKey && !evt.altKey) {
	          // some handle
	        }
	      }
	      _EditorDom2.default.stopPropagation(evt);
	    };
	
	    _this.editorSource = function (state) {
	      var editorState = _this.state.editorState;
	      editorState.showHtml = !editorState.showHtml;
	      state.active = editorState.showHtml;
	      editorState.content = _this.refs.editarea.getContent();
	    };
	
	    _this.editorRemoveFormat = function (state) {
	      _EditorHistory2.default.execCommand(state.icon, false, null);
	      _EditorSelection2.default.storeRange();
	      var spanNodes = _EditorSelection2.default.getSpanNodes();
	      var spanNode = null;
	      var parentNode = null;
	      var nextSibling = null;
	      var childSum = null;
	      for (var i = 0; i < spanNodes.length; i++) {
	        switch (spanNodes[i].className) {
	          case "font-border":
	            spanNode = spanNodes[i];
	            parentNode = spanNode.parentNode;
	            nextSibling = spanNode.nextSibling || spanNode;
	            childSum = spanNode.childNodes.length;
	            for (var c = 0; c < childSum; c++) {
	              parentNode.insertBefore(spanNode.childNodes[c].cloneNode(), nextSibling);
	            }
	            parentNode.removeChild(spanNodes[i]);
	            break;
	          case "emphasis":
	            spanNode = spanNodes[i];
	            parentNode = spanNode.parentNode;
	            nextSibling = spanNode.nextSibling || spanNode;
	            childSum = spanNode.childNodes.length;
	            for (var _c = 0; _c < childSum; _c++) {
	              parentNode.insertBefore(spanNode.childNodes[_c].cloneNode(), nextSibling);
	            }
	            parentNode.removeChild(spanNodes[i]);
	            break;
	        }
	      }
	      _EditorSelection2.default.restoreRange();
	    };
	
	    _this.editorUpLowCase = function (state) {
	      _EditorSelection2.default.storeRange();
	      var textNodes = _EditorSelection2.default.getTextNodes();
	      var node = null;
	      var start = null;
	      var end = null;
	      for (var i = 0; i < textNodes.length; i++) {
	        node = textNodes[i].childNode;
	        start = textNodes[i].startOffset;
	        end = textNodes[i].endOffset;
	        node.nodeValue = node.nodeValue.substring(0, start) + (state.icon == "touppercase" ? node.nodeValue.substring(start, end).toUpperCase() : node.nodeValue.substring(start, end).toLowerCase()) + node.nodeValue.substring(end, node.length);
	      }
	      _EditorHistory2.default.execCommand(state.icon, false, null);
	      _EditorSelection2.default.restoreRange();
	    };
	
	    _this.editorFontBorder = function (state) {
	      var textNodes = _EditorSelection2.default.getTextNodes();
	      var startNode = null,
	          endNode = null,
	          startOffset = 0,
	          endOffset = 0;
	      for (var i = 0; i < textNodes.length; i++) {
	        // 获取
	        var node = textNodes[i].childNode;
	        var start = textNodes[i].startOffset;
	        var end = textNodes[i].endOffset;
	        // 拷贝
	        var cloneNode = node.cloneNode();
	        var startText = cloneNode.nodeValue.substring(0, start);
	        var endText = cloneNode.nodeValue.substring(end, cloneNode.length);
	        var borderText = cloneNode.nodeValue.substring(start, end);
	        var span = null;
	        var textParentNode = textNodes[i].childNode.parentNode;
	        if (textParentNode && textParentNode.className && textParentNode.className == "font-border") {
	          if (i == 0) {
	            startNode = textNodes[i].childNode;
	            startOffset = start;
	          }
	          if (i == textNodes.length - 1) {
	            endNode = textNodes[i].childNode;
	            endOffset = end;
	          }
	        } else {
	          // 重新赋值
	          node.nodeValue = startText;
	          span = document.createElement("span");
	          span.className = "font-border";
	          span.innerHTML = borderText;
	          span.style.border = "1px solid #000";
	          node.parentNode.insertBefore(span, node.nextSibling || node);
	          if (endText != "") {
	            node.parentNode.insertBefore(document.createTextNode(endText), span.nextSibling);
	          }
	          if (i == 0) startNode = span.childNodes[0];
	          if (i == textNodes.length - 1) {
	            endNode = span.childNodes[0];
	            endOffset = span.childNodes[0].length;
	          }
	        }
	      }
	      _EditorSelection2.default.addRange(startNode, startOffset, endNode, endOffset);
	      // 合并相同font-border元素
	      var spanNodes = _EditorSelection2.default.getSpanNodes();
	      for (var _i = 0; _i < spanNodes.length - 1; _i++) {
	        var spanNode = spanNodes[_i];
	        var parentNode = spanNodes[_i].parentNode;
	        if (_EditorDom2.default.isNullOfTextNode(spanNode.nextSibling)) {
	          // 移除空元素
	          parentNode.removeChild(spanNode.nextSibling);
	        }
	        if (spanNode.nextSibling === spanNodes[_i + 1]) {
	          var nextSiblingChildNodes = spanNodes[_i + 1].childNodes;
	          for (var c = 0; c < nextSiblingChildNodes.length; c++) {
	            spanNode.appendChild(nextSiblingChildNodes[c].cloneNode());
	          }
	          // 移除老元素
	          parentNode.removeChild(spanNodes[_i + 1]);
	          // 删除过后，重新指向
	          spanNodes[_i + 1] = spanNodes[_i];
	        }
	      }
	      _EditorHistory2.default.execCommand(state.icon, false, null);
	    };
	
	    _this.editorEmphasis = function (state) {
	      var textNodes = _EditorSelection2.default.getTextNodes();
	      var startNode = null,
	          endNode = null,
	          startOffset = 0,
	          endOffset = 0;
	      for (var i = 0; i < textNodes.length; i++) {
	        // 获取
	        var node = textNodes[i].childNode;
	        var start = textNodes[i].startOffset;
	        var end = textNodes[i].endOffset;
	        // 拷贝
	        var cloneNode = node.cloneNode();
	        var startText = cloneNode.nodeValue.substring(0, start);
	        var endText = cloneNode.nodeValue.substring(end, cloneNode.length);
	        var borderText = cloneNode.nodeValue.substring(start, end);
	        var span = null;
	        var textParentNode = textNodes[i].childNode.parentNode;
	        if (textParentNode && textParentNode.className && textParentNode.className == "emphasis") {
	          if (i == 0) {
	            startNode = textNodes[i].childNode;
	            startOffset = start;
	          }
	          if (i == textNodes.length - 1) {
	            endNode = textNodes[i].childNode;
	            endOffset = end;
	          }
	        } else {
	          // 重新赋值
	          node.nodeValue = startText;
	          span = document.createElement("span");
	          span.className = "emphasis";
	          span.innerHTML = borderText;
	          node.parentNode.insertBefore(span, node.nextSibling || node);
	          if (endText != "") {
	            node.parentNode.insertBefore(document.createTextNode(endText), span.nextSibling);
	          }
	          if (i == 0) startNode = span.childNodes[0];
	          if (i == textNodes.length - 1) {
	            endNode = span.childNodes[0];
	            endOffset = span.childNodes[0].length;
	          }
	        }
	      }
	      _EditorSelection2.default.addRange(startNode, startOffset, endNode, endOffset);
	      // 合并相同font-border元素
	      var spanNodes = _EditorSelection2.default.getSpanNodes();
	      for (var _i2 = 0; _i2 < spanNodes.length - 1; _i2++) {
	        var spanNode = spanNodes[_i2];
	        var parentNode = spanNodes[_i2].parentNode;
	
	        if (_EditorDom2.default.isNullOfTextNode(spanNode.nextSibling)) {
	          // 移除空元素
	          parentNode.removeChild(spanNode.nextSibling);
	        }
	        if (spanNode.nextSibling === spanNodes[_i2 + 1]) {
	          var nextSiblingChildNodes = spanNodes[_i2 + 1].childNodes;
	          for (var c = 0; c < nextSiblingChildNodes.length; c++) {
	            spanNode.appendChild(nextSiblingChildNodes[c].cloneNode());
	          }
	          // 移除老元素
	          parentNode.removeChild(spanNodes[_i2 + 1]);
	          // 删除过后，重新指向
	          spanNodes[_i2 + 1] = spanNodes[_i2];
	        }
	      }
	      _EditorHistory2.default.execCommand(state.icon, false, null);
	    };
	
	    _this.editorForeColor = function (state, offsetPosition, editarea) {
	      _EditorSelection2.default.storeRange();
	      offsetPosition.y += offsetPosition.h + 5;
	      _this.refs.color.toggle(offsetPosition, function (color) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	        _EditorHistory2.default.execCommand('forecolor', false, color);
	        _this.handleRangeChange();
	      });
	    };
	
	    _this.editorBackColor = function (state, offsetPosition, editarea) {
	      _EditorSelection2.default.storeRange();
	      offsetPosition.y += offsetPosition.h + 5;
	
	      _this.refs.color.toggle(offsetPosition, function (color) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	        _EditorHistory2.default.execCommand('backcolor', false, color);
	        _this.handleRangeChange();
	      });
	    };
	
	    _this.editorFontSize = function (state, offsetPosition, editarea) {
	      _EditorSelection2.default.storeRange();
	      offsetPosition.y += offsetPosition.h + 5;
	
	      _this.refs.fontsize.toggle(offsetPosition, function (fontsize) {
	        _EditorDom2.default.focusNode(editarea);
	        _EditorSelection2.default.restoreRange();
	        _EditorHistory2.default.execCommand('fontsize', false, fontsize);
	        _this.handleRangeChange();
	      });
	    };
	
	    _this.editorFontFamily = function (state, offsetPosition, editarea) {
	      _EditorSelection2.default.storeRange();
	      offsetPosition.y += offsetPosition.h + 5;
	
	      _this.refs.fontfamily.toggle(offsetPosition, function (fontfamily) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	        _EditorHistory2.default.execCommand('fontname', false, fontfamily);
	        _this.handleRangeChange();
	      });
	    };
	
	    _this.editorParagraph = function (state, offsetPosition, editarea) {
	      _EditorSelection2.default.storeRange();
	      offsetPosition.y += offsetPosition.h + 5;
	
	      _this.refs.paragraph.toggle(offsetPosition, function (paragraph) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	        var paragraphs = _EditorSelection2.default.getParagraphs();
	        var parentElement = null,
	            childNodes = null,
	            paraElement = null,
	            parentNode = null;
	        for (var i = 0; i < paragraphs.length; i++) {
	          switch (paragraphs[i].tagName.toUpperCase()) {
	            case "TD":
	            case "TH":
	            case "DIV":
	              childNodes = paragraphs[i].childNodes;
	              paraElement = document.createElement(paragraph);
	              for (var j = 0; j < childNodes.length; j++) {
	                paraElement.appendChild(childNodes[j]);
	              }
	              paragraphs[i].appendChild(paraElement);
	              break;
	            case "P":
	            case "H1":
	            case "H2":
	            case "H3":
	            case "H4":
	            case "H5":
	            case "H6":
	              parentElement = paragraphs[i];
	              childNodes = paragraphs[i].childNodes;
	              paraElement = document.createElement(paragraph);
	              parentNode = parentElement.parentNode;
	              parentNode.insertBefore(paraElement, parentElement.nextSibling);
	              for (var _j = 0; _j < childNodes.length; _j++) {
	                paraElement.appendChild(childNodes[_j]);
	              }
	              parentNode.removeChild(parentElement);
	              break;
	            default:
	              break;
	          }
	        }
	        _EditorHistory2.default.execCommand('paragraph', false, paragraph);
	        _this.handleRangeChange();
	      });
	    };
	
	    _this.editorHorizontal = function (editarea, root) {
	      var strTime = "<hr/><p></br></p>";
	      if (_EditorSelection2.default.range && _EditorSelection2.default.validateRange(root, _EditorSelection2.default.range)) {
	        if (_EditorSelection2.default.range.pasteHTML) {
	          _EditorSelection2.default.range.pasteHTML(strTime);
	        } else {
	          var hr = _EditorDom2.default.createHR();
	          var p = _EditorDom2.default.createNodeByTag('p', '<br/>');
	          _EditorSelection2.default.range.deleteContents();
	          _EditorSelection2.default.insertNode(p);
	          _EditorSelection2.default.insertNode(hr);
	        }
	      } else {
	        editarea.innerHTML += strTime;
	      }
	      // EditorHistory.execCommand('inserthtml',false,"<hr/><p><br/></p>");
	    };
	
	    _this.editorDate = function (editarea, root) {
	      var strDate = new Date().Format("yyyy-MM-dd");
	      if (_EditorSelection2.default.range && _EditorSelection2.default.validateRange(root, _EditorSelection2.default.range)) {
	        if (_EditorSelection2.default.range.pasteHTML) {
	          _EditorSelection2.default.range.pasteHTML(strDate);
	        } else {
	          var textNode = _EditorDom2.default.createTextNode(strDate);
	          _EditorSelection2.default.range.deleteContents();
	          _EditorSelection2.default.insertNode(textNode);
	        }
	      } else {
	        editarea.innerHTML += '<p>' + strDate + '</p>';
	      }
	      // EditorHistory.execCommand('inserthtml',false, strDate);
	    };
	
	    _this.editorTime = function (editarea, root) {
	      var strTime = new Date().Format('hh:mm:ss');
	      if (_EditorSelection2.default.range && _EditorSelection2.default.validateRange(root, _EditorSelection2.default.range)) {
	        if (_EditorSelection2.default.range.pasteHTML) {
	          _EditorSelection2.default.range.pasteHTML(strTime);
	        } else {
	          var textNode = _EditorDom2.default.createTextNode(strTime);
	          _EditorSelection2.default.range.deleteContents();
	          _EditorSelection2.default.insertNode(textNode);
	        }
	      } else {
	        editarea.innerHTML += '<p>' + strTime + '</p>';
	      }
	      // EditorHistory.execCommand('inserthtml',false,strTime);
	    };
	
	    _this.editorImage = function (editarea, root) {
	      _EditorSelection2.default.storeRange();
	      _this.refs.image.toggle(function (html) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	        if (html && html.length > 0) {
	          if (_EditorSelection2.default.range && _EditorSelection2.default.validateRange(root, _EditorSelection2.default.range)) {
	            if (_EditorSelection2.default.range.pasteHTML) {
	              _EditorSelection2.default.range.pasteHTML('<p>' + html + '</p>');
	            } else {
	              var p = _EditorDom2.default.createNodeByTag('p', html);
	              _EditorSelection2.default.range.deleteContents();
	              _EditorSelection2.default.insertNode(p);
	            }
	            // EditorHistory.execCommand('inserthtml',false,html);
	          } else {
	            editarea.innerHTML += '<p>' + html + '</p>';
	          }
	        }
	      });
	    };
	
	    _this.editorFormula = function (editarea, root, offsetPosition) {
	      _EditorSelection2.default.storeRange();
	      offsetPosition.y += offsetPosition.h + 5;
	      offsetPosition.x -= offsetPosition.w / 2;
	      _this.refs.formula.toggle(offsetPosition, function (latex, id) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	
	        if (latex && latex.length > 0) {
	          var html = '<span>&nbsp;<span class="mathquill-embedded-latex" id="' + id + '"></span>&nbsp;</span>';
	          if (_EditorSelection2.default.range && _EditorSelection2.default.validateRange(root, _EditorSelection2.default.range)) {
	            if (_EditorSelection2.default.range.pasteHTML) {
	              _EditorSelection2.default.range.pasteHTML(html);
	            } else {
	              var span = _EditorDom2.default.createNodeByTag('span', '&nbsp;<span class="mathquill-embedded-latex" id="' + id + '"></span>&nbsp;');
	              _EditorSelection2.default.range.deleteContents();
	              _EditorSelection2.default.insertNode(span);
	            }
	            // EditorHistory.execCommand('inserthtml',false,html);
	          } else {
	            editarea.innerHTML += html;
	          }
	          _EditorTimer2.default.setTimeout(function () {
	            _this.addFormula(id, latex);
	          }, 200);
	          _this.handleRangeChange();
	        }
	      });
	    };
	
	    _this.editorInsertTable = function (editarea, root, offsetPosition) {
	      _EditorSelection2.default.storeRange();
	      offsetPosition.y += offsetPosition.h + 5;
	      offsetPosition.x -= offsetPosition.w / 2;
	      _this.refs.table.toggle(offsetPosition, function (table) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	        if (_EditorSelection2.default.range && _EditorSelection2.default.validateRange(root, _EditorSelection2.default.range)) {
	          if (_EditorSelection2.default.range.pasteHTML) {
	            _EditorSelection2.default.range.pasteHTML(table.outerHTML);
	          } else {
	            _EditorSelection2.default.range.deleteContents();
	            _EditorSelection2.default.insertNode(table);
	          }
	        } else {
	          editarea.innerHTML += table.outerHTML;
	        }
	        // EditorHistory.execCommand('inserthtml',false,html);
	        _this.handleRangeChange();
	      });
	    };
	
	    _this.editorSpechars = function (editarea, root) {
	      _EditorSelection2.default.storeRange();
	      _this.refs.special.toggle(function (char) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	        if (_EditorSelection2.default.range && _EditorSelection2.default.validateRange(root, _EditorSelection2.default.range)) {
	          if (_EditorSelection2.default.range.pasteHTML) {
	            _EditorSelection2.default.range.pasteHTML(char);
	          } else {
	            var textNode = _EditorDom2.default.createTextNode(char);
	            _EditorSelection2.default.range.deleteContents();
	            _EditorSelection2.default.insertNode(textNode);
	          }
	        } else {
	          editarea.innerHTML += char;
	        }
	        // EditorHistory.execCommand('inserthtml',false,char);
	        _this.handleRangeChange();
	      });
	    };
	
	    _this.editorEmotion = function (editarea, root) {
	      _EditorSelection2.default.storeRange();
	      _this.refs.emotion.toggle(function (img) {
	        _EditorDom2.default.focusNode(editarea);;
	        _EditorSelection2.default.restoreRange();
	        if (_EditorSelection2.default.range && _EditorSelection2.default.validateRange(root, _EditorSelection2.default.range)) {
	          if (_EditorSelection2.default.range.pasteHTML) {
	            _EditorSelection2.default.range.pasteHTML(img.outerHTML);
	          } else {
	            _EditorSelection2.default.range.deleteContents();
	            _EditorSelection2.default.insertNode(img);
	          }
	        } else {
	          editarea.innerHTML += img.outerHTML;
	        }
	        // EditorHistory.execCommand('inserthtml',false,html);
	        _this.handleRangeChange();
	      });
	    };
	
	    _this.state = {
	      lastKeyCode: null,
	      maxInputCount: 10,
	      editorState: {
	        icon: "",
	        showHtml: false,
	        icons: {
	          "forecolor": {
	            color: 'transparent',
	            icon: "forecolor"
	          },
	          "backcolor": {
	            color: 'transparent',
	            icon: "backcolor"
	          },
	          "fontsize": {
	            value: "3",
	            icon: "fontsize"
	          },
	          "paragraph": {
	            value: "p",
	            icon: "fontsize"
	          },
	          "fontfamily": {
	            value: "宋体, SimSun",
	            icon: "fontfamily"
	          },
	          "indent": {
	            active: false,
	            icon: "indent"
	          },
	          "outdent": {
	            active: true,
	            icon: "outdent"
	          }
	        }
	      },
	      value: _this.props.value || _this.props.defaultValue
	    };
	    _this.iconComponetMap = {};
	    return _this;
	  }
	
	  _createClass(EditorCore, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _EditorHistory2.default.clear();
	      this.setContent(this.state.value);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var editorState = this.state.editorState;
	      switch (editorState.icon) {
	        case "source":
	        case "cleardoc":
	          if (editorState.content) {
	            this.setContent(editorState.content);
	          }
	          setTimeout(function () {
	            _this2.setState({
	              editorState: _extends({}, editorState, { icon: "" })
	            });
	          });
	          break;
	      }
	    }
	
	    // event handler
	
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      if (this.props.onFocus) {
	        this.props.onFocus(e, this.findDOMNode('root'));
	      }
	      _EditorDom2.default.stopPropagation(e);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      _EditorDom2.default.stopPropagation(e);
	    }
	  }, {
	    key: 'exchangeRangeState',
	    value: function exchangeRangeState(editorState) {
	      var rangeState = _EditorSelection2.default.getRangeState();
	      for (var icon in rangeState) {
	        if (!editorState.icons[icon]) editorState.icons[icon] = rangeState[icon];else {
	          switch (icon) {
	            case "forecolor":
	            case "backcolor":
	              editorState.icons[icon].color = rangeState[icon].color;
	              break;
	            case "paragraph":
	            case "fontfamily":
	            case "fontsize":
	              editorState.icons[icon].value = rangeState[icon].value;
	              break;
	          }
	          editorState.icons[icon].active = rangeState[icon].active;
	        }
	      }
	      return editorState;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(content) {
	      var value = this.state.value;
	      var editorState = this.state.editorState;
	      editorState.content = content;
	      if (value != content) {
	        this.props.onChange(content);
	        this.setState({
	          value: content,
	          editorState: editorState
	        });
	      }
	    }
	  }, {
	    key: 'handleRangeChange',
	    value: function handleRangeChange(e) {
	      e = e || event;
	      // if (e && e.type == "blur") return;
	      // 已经被卸载了。
	      if (this._calledComponentWillUnmount) return;
	      var target = e ? e.target || e.srcElement : null;
	      var selection = _EditorSelection2.default.getSelection();
	      if (this.props.onChange) {
	        var content = this.getContent();
	        var value = this.state.value;
	        if (value != content) {
	          this.props.onChange(content);
	          this.setState({
	            value: content
	          });
	        }
	      }
	      var editorState = this.state.editorState;
	      if (selection && selection.rangeCount > 0) {
	        if (editorState.icon == "source") {
	          editorState = this.exchangeRangeState(editorState);
	          this.setState({
	            editorState: editorState
	          });
	        } else {
	          var parentNode = _EditorSelection2.default.validateSelection(selection);
	          if (parentNode && _EditorDom2.default.isEditorDom(parentNode, _reactDom2.default.findDOMNode(this.refs.root))) {
	            editorState = this.exchangeRangeState(editorState);
	            this.setState({
	              editorState: editorState
	            });
	            if (this.refs.editarea && this.refs.editarea.clearResizeTarget) {
	              this.refs.editarea.clearResizeTarget();
	            }
	          }
	        }
	      } else if (target && _EditorDom2.default.isEditorDom(target, _reactDom2.default.findDOMNode(this.refs.root))) {
	        var tagName = target.tagName.toUpperCase();
	        switch (tagName) {
	          case "IMG":
	            if (this.refs.editarea && this.refs.editarea.setResizeTarget) {
	              this.refs.editarea.setResizeTarget(target);
	            }
	            break;
	        }
	      } else if (editorState.icon == "source") {
	        editorState = this.exchangeRangeState(editorState);
	        this.setState({
	          editorState: editorState
	        });
	      }
	    }
	  }, {
	    key: 'handleToolbarIconClick',
	    value: function handleToolbarIconClick(e, state) {
	      e = e || event;
	      var target = e.target || e.srcElement;
	      var root = _reactDom2.default.findDOMNode(this.refs.root);
	      var offsetPosition = _EditorDom2.default.getOffsetRootParentPosition(target, root);
	
	      var handleRangeChange = this.handleRangeChange.bind(this);
	      var editarea = _reactDom2.default.findDOMNode(this.refs.editarea);
	      if (this.refs.editarea.getEditorRange) {
	        editarea = this.refs.editarea.getEditorRange();
	      }
	      var editorState = this.state.editorState;
	      _EditorSelection2.default.cloneRange();
	      _EditorSelection2.default.storeRange();
	      //关闭所有Dialog、Box、Dropdown
	      this.closeAllOpenDialog(state.icon);
	      _EditorSelection2.default.restoreRange();
	      switch (state.icon) {
	        case "source":
	          this.editorSource(state);
	          break;
	        case "undo":
	          _EditorHistory2.default.undo();
	          break;
	        case "redo":
	          _EditorHistory2.default.redo();
	          break;
	        case "removeformat":
	          this.editorRemoveFormat(state);
	          break;
	        case "bold":
	        case "italic":
	        case "underline":
	        case "strikethrough":
	        case "subscript":
	        case "superscript":
	        case "insertorderedlist":
	        case "insertunorderedlist":
	        case "selectall":
	        case "justifyleft":
	        case "justifyright":
	        case "justifycenter":
	        case "indent":
	        case "outdent":
	          _EditorHistory2.default.execCommand(state.icon, false, null);
	          break;
	        case "touppercase":
	        case "tolowercase":
	          this.editorUpLowCase(state);
	          break;
	        case "fontborder":
	          this.editorFontBorder(state);
	          break;
	        case "emphasis":
	          this.editorEmphasis(state);
	          break;
	        case "forecolor":
	          this.editorForeColor(state, offsetPosition, editarea);
	          break;
	        case "backcolor":
	          this.editorBackColor(state, offsetPosition, editarea);
	          break;
	        case "fontsize":
	          this.editorFontSize(state, offsetPosition, editarea);
	          break;
	        case "fontfamily":
	          this.editorFontFamily(state, offsetPosition, editarea);
	          break;
	        case "paragraph":
	          this.editorParagraph(state, offsetPosition, editarea);
	          break;
	        case "cleardoc":
	          editorState.content = "<p><br/></p>";
	          break;
	        case "horizontal":
	          this.editorHorizontal(editarea, root);
	          break;
	        case "date":
	          this.editorDate(editarea, root);
	          break;
	        case "time":
	          this.editorTime(editarea, root);
	          break;
	        case "image":
	          this.editorImage(editarea, root);
	          break;
	        case "formula":
	          this.editorFormula(editarea, root, offsetPosition);
	          break;
	        case "inserttable":
	          this.editorInsertTable(editarea, root, offsetPosition);
	          break;
	        case "spechars":
	          this.editorSpechars(editarea, root);
	          break;
	        case "emotion":
	          this.editorEmotion(editarea, root);
	          break;
	        default:
	          var _ref = this.props.plugins || {},
	              _ref$toolbar = _ref.toolbar,
	              toolbar = _ref$toolbar === undefined ? {} : _ref$toolbar;
	
	          var pIcons = toolbar.icons || [];
	          var fIcon = pIcons.find(function (ic) {
	            return ic.name === state.icon;
	          });
	          if (fIcon && fIcon.onIconClick) fIcon.onIconClick({
	            editarea: editarea,
	            root: root,
	            offsetPosition: offsetPosition,
	            state: state,
	            ref: this.iconComponetMap[state.icon]
	          });
	          break;
	      }
	      // setState
	      editorState.icons[state.icon] = state;
	      editorState.icon = state.icon;
	      _EditorSelection2.default.createRange();
	
	      // range state
	      handleRangeChange();
	      _EditorDom2.default.stopPropagation(e);
	    }
	  }, {
	    key: 'closeAllOpenDialog',
	    value: function closeAllOpenDialog(icon) {
	      var refsDialog = ["image", "color", "formula", "table", "special", "emotion", "fontsize", "fontfamily", "paragraph"];
	      var icons = ["forecolor", "backcolor", "image", "emotion", "spechars", "inserttable", "formula", "paragraph", "fontsize", "fontfamily"];
	      if (icons.indexOf(icon) == -1) return;
	      for (var i = 0; i < refsDialog.length; i++) {
	        this.refs[refsDialog[i]].close();
	      }
	    }
	    // utils
	
	  }, {
	    key: 'addFormula',
	    value: function addFormula(id, latex) {
	      var editarea = _reactDom2.default.findDOMNode(this.refs.editarea);
	      var htmlElement = document.getElementById(id);
	
	      var config = {
	        handlers: {
	          edit: function edit() {}
	        },
	        restrictMismatchedBrackets: true
	      };
	
	      if (!MQ) MQ = MathQuill ? MathQuill.getInterface(2) : null;
	
	      if (htmlElement == null && MQ == null) return;
	      var mathField = MQ.MathField(htmlElement, config);
	      mathField.latex(latex);
	      var $htmlElement = $(htmlElement);
	      $htmlElement.keydown(function (e) {
	        mathField.focus();
	        _EditorDom2.default.stopPropagation(e);
	      });
	      $htmlElement.keyup(function (e) {
	        mathField.focus();
	        _EditorDom2.default.stopPropagation(e);
	      });
	      $htmlElement.mouseup(function (e) {
	        mathField.focus();
	        _EditorDom2.default.stopPropagation(e);
	      });
	      $htmlElement.mousedown(function (e) {
	        _EditorDom2.default.stopPropagation(e);
	      });
	      $htmlElement.mousemove(function (e) {
	        _EditorDom2.default.stopPropagation(e);
	      });
	      $(editarea).mousedown(function (e) {
	        mathField.blur();
	        _EditorDom2.default.stopPropagation(e);
	      });
	      $(editarea).mousemove(function (e) {
	        _EditorDom2.default.stopPropagation(e);
	      });
	    }
	  }, {
	    key: 'autoSave',
	    value: function autoSave() {
	      _EditorHistory2.default.execCommand('autosave', false, null);
	    }
	    // public functions
	
	  }, {
	    key: 'findDOMNode',
	    value: function findDOMNode(refName) {
	      // 对外公布方法
	      var keys = ["root", "editarea", "toolbar", "color"];
	      if (keys.indexOf(refName) == -1) return {
	        ref: null,
	        dom: null
	      };
	      return {
	        ref: this.refs[refName],
	        dom: _reactDom2.default.findDOMNode(this.refs[refName])
	      };
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent(content) {
	      content = content || "";
	      // 后续添加校验方法
	      this.refs.editarea.setContent(content);
	      // mathquill supports
	      if (content.indexOf("mathquill-embedded-latex") != -1) {
	        var _self = this;
	        _EditorTimer2.default.setTimeout(function () {
	          var editarea = _reactDom2.default.findDOMNode(_self.refs.editarea);
	          var elements = editarea.querySelectorAll('.mathquill-embedded-latex');
	          for (var i = 0; i < elements.length; i++) {
	            if (!elements[i].id) {
	              var id = "mathquill-" + i + "-" + new Date().valueOf();
	              var latex = elements[i].innerHTML;
	              elements[i].id = id;
	              _self.addFormula(id, latex);
	            }
	          }
	        }, 100);
	      }
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.refs.editarea) return this.refs.editarea.getContent();else return "";
	    }
	  }, {
	    key: 'focusEditor',
	    value: function focusEditor() {
	      var editarea = _reactDom2.default.findDOMNode(this.refs.editarea);
	      _EditorDom2.default.focusNode(editarea);;
	    }
	    // render functions  
	
	  }, {
	    key: 'renderEditArea',
	    value: function renderEditArea() {
	      var showHtml = this.state.editorState.showHtml;
	      if (showHtml) {
	        return _react2.default.createElement(_EditorTextArea2.default, { ref: 'editarea', onChange: this.handleChange.bind(this) });
	      } else {
	        return _react2.default.createElement(_EditorContentEditableDiv2.default, {
	          ref: 'editarea',
	          handleKeyDown: this.handleKeyDown,
	          handleKeyUp: this.handleKeyUp,
	          onEditorMount: this.props.onEditorMount,
	          onRangeChange: this.handleRangeChange.bind(this) });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var editArea = this.renderEditArea();
	
	      var _props = this.props,
	          index = _props.index,
	          fontSize = _props.fontSize,
	          paragraph = _props.paragraph,
	          fontFamily = _props.fontFamily,
	          icons = _props.icons,
	          plugins = _props.plugins,
	          onBlur = _props.onBlur,
	          className = _props.className,
	          id = _props.id,
	          onFocus = _props.onFocus,
	          onClick = _props.onClick,
	          onChange = _props.onChange,
	          onEditorMount = _props.onEditorMount,
	          uploadImageCallback = _props.uploadImageCallback,
	          props = _objectWithoutProperties(_props, ['index', 'fontSize', 'paragraph', 'fontFamily', 'icons', 'plugins', 'onBlur', 'className', 'id', 'onFocus', 'onClick', 'onChange', 'onEditorMount', 'uploadImageCallback']);
	
	      var editorState = this.state.editorState;
	      var _icons = icons.join(" ").replace(/\|/gm, "separator").split(" ");
	
	      var _ref2 = this.props.plugins || {},
	          _ref2$toolbar = _ref2.toolbar,
	          toolbar = _ref2$toolbar === undefined ? {} : _ref2$toolbar;
	
	      var pIcons = toolbar.icons || [];
	      _EditorSelection2.default.customIcons = pIcons;
	      return _react2.default.createElement('div', _extends({
	        ref: 'root',
	        id: id,
	        className: "editor-container editor-default" + (className ? " " + className : ""),
	        onClick: this.handleClick.bind(this),
	        onBlur: this.handleRangeChange.bind(this),
	        onFocus: this.handleFocus.bind(this)
	      }, props), _react2.default.createElement(_EditorToolbar2.default, {
	        ref: 'toolbar',
	        editorState: editorState,
	        onIconClick: function onIconClick(e, state) {
	          return _this3.handleToolbarIconClick(e, state);
	        },
	        icons: this.props.icons,
	        customIcons: pIcons,
	        paragraph: this.props.paragraph,
	        fontsize: this.props.fontSize,
	        fontfamily: this.props.fontFamily
	      }, _react2.default.createElement(_ImageDialog2.default, {
	        hidden: _icons.indexOf("image") == -1,
	        ref: 'image',
	        uploader: plugins.image.uploader,
	        customUploader: plugins.image.customUploader
	      }), _react2.default.createElement(_ColorDropdown2.default, {
	        hidden: _icons.indexOf("forecolor") == -1 && _icons.indexOf("forecolor"),
	        ref: 'color'
	      }), _react2.default.createElement(_FormulaDropdown2.default, {
	        hidden: _icons.indexOf("formula") == -1,
	        ref: 'formula'
	      }), _react2.default.createElement(_TablePickerDropdown2.default, {
	        hidden: _icons.indexOf("inserttable") == -1,
	        ref: 'table'
	      }), _react2.default.createElement(_SpecialCharsDialog2.default, {
	        hidden: _icons.indexOf("spechars") == -1,
	        ref: 'special'
	      }), _react2.default.createElement(_EmotionDialog2.default, {
	        hidden: _icons.indexOf("emotion") == -1,
	        ref: 'emotion'
	      }), _react2.default.createElement(_FontSizeComboBox2.default, {
	        hidden: _icons.indexOf("fontsize") == -1,
	        ref: 'fontsize',
	        fontsize: this.props.fontSize,
	        value: editorState.icons["fontsize"] ? editorState.icons["fontsize"].value : fontSize[0].value
	      }), _react2.default.createElement(_FontFamilyComboBox2.default, {
	        hidden: _icons.indexOf("fontfamily") == -1,
	        ref: 'fontfamily',
	        fontfamily: this.props.fontFamily,
	        value: editorState.icons["fontfamily"] ? editorState.icons["fontfamily"].value : fontFamily[0].value
	      }), _react2.default.createElement(_ParagraphComboBox2.default, {
	        hidden: _icons.indexOf("paragraph") == -1,
	        ref: 'paragraph',
	        paragraph: this.props.paragraph,
	        value: editorState.icons["paragraph"] ? editorState.icons["paragraph"].value : paragraph[0].value
	      }), pIcons.filter(function (ic) {
	        return ic.component;
	      }).map(function (ic) {
	        var Com = ic.component;
	        return _react2.default.createElement(Com, _extends({
	          hidden: _icons.indexOf(ic.name) == -1,
	          ref: function ref(com) {
	            return _this3.iconComponetMap[ic.name] = com;
	          }
	        }, ic.props, {
	          value: editorState.icons[ic.name] ? editorState.icons[ic.name].value : ic.defaultValue
	        }));
	      })), editArea);
	    }
	  }]);
	
	  return EditorCore;
	}(_react.Component);
	
	exports.default = EditorCore;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}return target;
	};
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
		var target = {};for (var i in obj) {
			if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
		}return target;
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/**
	* @icon: 图标名称 string
	* @disabled: 是否禁用 bool
	* @onClick: 暴露点击事件 function
	* @title: 提示 string
	* @active: 是否选中 bool
	* @showHtml: 是否当前是显示html属性
	* @color: 前景色和背景色
	**/
	var EditorIcon = function (_Component) {
		_inherits(EditorIcon, _Component);
	
		function EditorIcon() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, EditorIcon);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditorIcon.__proto__ || Object.getPrototypeOf(EditorIcon)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
				e = e || event;
				var target = e.target || e.srcElement;
				while (target.className.indexOf("editor-icon") == -1) {
					target = target.parentElement;
				}
				e.target = target;
	
				var _this$props = _this.props,
				    onClick = _this$props.onClick,
				    props = _objectWithoutProperties(_this$props, ['onClick']);
	
				if (_this.props.onClick) {
					_this.props.onClick(e, _extends({}, props));
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(EditorIcon, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.updateStyle();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				this.updateStyle();
			}
		}, {
			key: 'updateStyle',
			value: function updateStyle() {
				var root = _reactDom2.default.findDOMNode(this.refs.root);
				var icon = this.props.icon;
				switch (this.props.icon) {
					case "forecolor":
					case "backcolor":
						var color = this.props.color ? this.props.color : "transparent";
						root.id = icon + "_" + new Date().valueOf();
						var style = root.childElementCount > 0 ? root.children[0] : document.createElement('style');
						style.innerHTML = ".icon-" + icon + "#" + root.id + ":before{content:'';border-bottom:3px solid " + color + ";}";
						if (root.childElementCount == 0) root.appendChild(style);
						break;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    icon = _props.icon,
				    active = _props.active,
				    disabled = _props.disabled,
				    showHtml = _props.showHtml,
				    onClick = _props.onClick,
				    className = _props.className,
				    props = _objectWithoutProperties(_props, ['icon', 'active', 'disabled', 'showHtml', 'onClick', 'className']);
	
				var _disabled = showHtml && icon != "source" && icon != "separator";
				var _className = className || "editor-icon icon-" + icon;
				if (icon == "fontsize" || icon == "fontfamily" || icon == "paragraph") {
					return _react2.default.createElement('span', _extends({ ref: 'root', className: (0, _classnames2.default)(_className, { active: active, disabled: disabled || _disabled }), onClick: this.handleClick }, props), _react2.default.createElement('span', { className: 'icon-label' }, props.name), _react2.default.createElement('span', { className: 'icon-caret' }));
				} else {
					return _react2.default.createElement('span', _extends({ ref: 'root', className: (0, _classnames2.default)(_className, { active: active, disabled: disabled || _disabled }), onClick: this.handleClick }, props));
				}
			}
		}]);
	
		return EditorIcon;
	}(_react.Component);
	
	exports.default = EditorIcon;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var EditorTextArea = function (_Component) {
		_inherits(EditorTextArea, _Component);
	
		function EditorTextArea(props) {
			_classCallCheck(this, EditorTextArea);
	
			var _this = _possibleConstructorReturn(this, (EditorTextArea.__proto__ || Object.getPrototypeOf(EditorTextArea)).call(this, props));
	
			_this.state = {
				content: ""
			};
			return _this;
		}
	
		_createClass(EditorTextArea, [{
			key: 'getContent',
			value: function getContent() {
				var target = _reactDom2.default.findDOMNode(this.refs.root);
				return target.value;
			}
		}, {
			key: 'setContent',
			value: function setContent(content) {
				this.setState({
					content: content
				});
			}
		}, {
			key: 'getName',
			value: function getName() {
				return "textarea";
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				var content = this.getContent();
				this.setState({
					content: content
				});
				if (this.props.onChange) {
					this.props.onChange(content);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement('textarea', { ref: 'root', className: 'editor-textarea', value: this.state.content, onChange: this.handleChange.bind(this) });
			}
		}]);
	
		return EditorTextArea;
	}(_react.Component);
	
	exports.default = EditorTextArea;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}return target;
	};
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EditorIcon = __webpack_require__(1294);
	
	var _EditorIcon2 = _interopRequireDefault(_EditorIcon);
	
	var _EditorDom = __webpack_require__(160);
	
	var _EditorDom2 = _interopRequireDefault(_EditorDom);
	
	var _EditorConstants = __webpack_require__(203);
	
	var _EditorHistory = __webpack_require__(683);
	
	var _EditorHistory2 = _interopRequireDefault(_EditorHistory);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var EditorToolbar = function (_React$Component) {
		_inherits(EditorToolbar, _React$Component);
	
		function EditorToolbar() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, EditorToolbar);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditorToolbar.__proto__ || Object.getPrototypeOf(EditorToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleIconClick = function (e, state) {
				if (_this.props.onIconClick) {
					_this.props.onIconClick(e, state);
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(EditorToolbar, [{
			key: 'getNameByValue',
			value: function getNameByValue(arr, value) {
				var filterArr = arr.filter(function (ele) {
					return ele.value == value;
				});
				if (filterArr.length > 0) {
					return filterArr[0].name;
				} else {
					return "";
				}
			}
		}, {
			key: 'getIcons',
			value: function getIcons() {
				var editorState = this.props.editorState;
				editorState.icons["undo"] = { disabled: !_EditorHistory2.default.canUndo() };
				editorState.icons["redo"] = { disabled: !_EditorHistory2.default.canRedo() };
				if (editorState.icons["fontsize"]) editorState.icons["fontsize"].name = this.getNameByValue(this.props.fontsize, editorState.icons["fontsize"].value);
				if (editorState.icons["paragraph"]) editorState.icons["paragraph"].name = this.getNameByValue(this.props.paragraph, editorState.icons["paragraph"].value);
				if (editorState.icons["fontfamily"]) editorState.icons["fontfamily"].name = this.getNameByValue(this.props.fontfamily, editorState.icons["fontfamily"].value);
	
				var icons = this.props.icons;
				var customIcons = this.props.customIcons;
				var _icons = icons.join(" ").replace(/\|/gm, "separator").split(" ");
				_icons = _icons.filter(function (ico) {
					return ico != "";
				});
				var returnArray = [];
				for (var i = 0; i < _icons.length; i++) {
					returnArray[i] = _EditorConstants.EditorIconTypes[_icons[i]] || customIcons.find(function (cusIcon) {
						return cusIcon.name === _icons[i];
					}) || { title: "自定义按钮" };
					returnArray[i].onClick = this.handleIconClick;
					returnArray[i].icon = _icons[i];
					if (editorState.icons[_icons[i]]) {
						returnArray[i].disabled = !!editorState.icons[_icons[i]].disabled;
						returnArray[i].active = !!editorState.icons[_icons[i]].active;
						returnArray[i].color = editorState.icons[_icons[i]].color;
						returnArray[i].value = editorState.icons[_icons[i]].value;
						returnArray[i].name = editorState.icons[_icons[i]].name;
					}
					returnArray[i].showHtml = !!editorState.showHtml;
				}
				return returnArray;
			}
		}, {
			key: 'render',
			value: function render() {
				var icons = this.getIcons();
				return _react2.default.createElement('div', { className: 'editor-toolbar', onMouseDown: _EditorDom2.default.stopPropagation, onClick: _EditorDom2.default.stopPropagation }, icons.map(function (icon, pos) {
					var props = icon;
					return _react2.default.createElement(_EditorIcon2.default, _extends({ key: pos }, props));
				}), this.props.children);
			}
		}]);
	
		return EditorToolbar;
	}(_react2.default.Component);
	
	exports.default = EditorToolbar;
	
	EditorToolbar.propTypes = {
		icons: _propTypes2.default.array
	};
	EditorToolbar.defaultProps = {
		icons: []
	};

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(368);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _EditorConstants = __webpack_require__(203);
	
	var _EditorDom = __webpack_require__(160);
	
	var _EditorDom2 = _interopRequireDefault(_EditorDom);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var ColorDropdown = function (_React$Component) {
		_inherits(ColorDropdown, _React$Component);
	
		function ColorDropdown(props) {
			_classCallCheck(this, ColorDropdown);
	
			var _this = _possibleConstructorReturn(this, (ColorDropdown.__proto__ || Object.getPrototypeOf(ColorDropdown)).call(this, props));
	
			_this.state = {
				handle: function handle() {}
			};
			return _this;
		}
	
		_createClass(ColorDropdown, [{
			key: 'open',
			value: function open(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.open(position);
			}
		}, {
			key: 'close',
			value: function close() {
				if (this.refs.root) this.refs.root.close();
			}
		}, {
			key: 'toggle',
			value: function toggle(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.toggle(position);
			}
		}, {
			key: 'handleSelectColor',
			value: function handleSelectColor(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var color = target.getAttribute('data-color');
				if (this.state.handle) {
					this.state.handle(color);
				}
				this.close();
				_EditorDom2.default.stopPropagation(e);
			}
		}, {
			key: 'render',
			value: function render() {
				var handleSelectColor = this.handleSelectColor.bind(this);
				if (this.props.hidden) {
					return _react2.default.createElement('div', null);
				} else {
					return _react2.default.createElement(_Dropdown2.default, { ref: 'root', className: 'color-dropdown' }, _react2.default.createElement('table', null, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', { className: 'title-row', key: "title-row" }, _react2.default.createElement('td', { colSpan: 10 }, "\u4E3B\u9898\u989C\u8272")), _EditorConstants.ColorTypes.themeColors.map(function (colors, pos) {
						var firstRow = pos == 0;
						return _react2.default.createElement('tr', { key: pos, className: firstRow ? "first-row" : "" }, colors.map(function (color, index) {
							return _react2.default.createElement('td', { key: index }, _react2.default.createElement('a', { className: 'color-anchor', 'data-color': color, style: { "backgroundColor": color }, onClick: handleSelectColor }));
						}));
					}), _react2.default.createElement('tr', { className: 'title-row', key: "title-row2" }, _react2.default.createElement('td', { colSpan: 10 }, "\u6807\u51C6\u989C\u8272")), _react2.default.createElement('tr', { className: 'last-row', key: "last-row" }, _EditorConstants.ColorTypes.standardColors.map(function (color, pos) {
						return _react2.default.createElement('td', { key: pos }, _react2.default.createElement('a', { className: 'color-anchor', 'data-color': color, style: { "backgroundColor": color }, onClick: handleSelectColor }));
					})))));
				}
			}
		}]);
	
		return ColorDropdown;
	}(_react2.default.Component);
	
	exports.default = ColorDropdown;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.EmotionPanel = undefined;
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabGroup = __webpack_require__(250);
	
	var _TabGroup2 = _interopRequireDefault(_TabGroup);
	
	var _Dialog = __webpack_require__(367);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _EditorConstants = __webpack_require__(203);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var EmotionPanel = exports.EmotionPanel = function (_Component) {
		_inherits(EmotionPanel, _Component);
	
		function EmotionPanel() {
			_classCallCheck(this, EmotionPanel);
	
			return _possibleConstructorReturn(this, (EmotionPanel.__proto__ || Object.getPrototypeOf(EmotionPanel)).apply(this, arguments));
		}
	
		_createClass(EmotionPanel, [{
			key: 'handleClick',
			value: function handleClick(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var url = target.getAttribute("data-url");
				var title = target.getAttribute("data-title");
	
				if (this.props.onSelectImage) {
					var img = document.createElement('img');
					img.src = url;
					img.title = title;
					this.props.onSelectImage(e, img);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var images = this.props.images;
				var handleClick = this.handleClick.bind(this);
				return _react2.default.createElement('ul', { className: "emotion-images " + this.props.name }, images.map(function (ele, pos) {
					return _react2.default.createElement('li', { className: 'emotion-image', key: pos, 'data-url': ele.url, 'data-title': ele.title, onClick: handleClick }, _react2.default.createElement('img', { src: ele.url, title: ele.title, 'data-url': ele.url, 'data-title': ele.title }));
				}));
			}
		}]);
	
		return EmotionPanel;
	}(_react.Component);
	
	var EmotionDialog = function (_Component2) {
		_inherits(EmotionDialog, _Component2);
	
		function EmotionDialog(props) {
			_classCallCheck(this, EmotionDialog);
	
			var _this2 = _possibleConstructorReturn(this, (EmotionDialog.__proto__ || Object.getPrototypeOf(EmotionDialog)).call(this, props));
	
			_this2.state = {
				handle: function handle() {}
			};
			return _this2;
		}
	
		_createClass(EmotionDialog, [{
			key: 'open',
			value: function open(handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.open();
			}
		}, {
			key: 'close',
			value: function close() {
				if (this.refs.root) this.refs.root.close();
			}
		}, {
			key: 'toggle',
			value: function toggle(handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.toggle();
			}
		}, {
			key: 'handleSelectImage',
			value: function handleSelectImage(e, img) {
				e = e || event;
				if (this.state.handle) {
					this.state.handle(img);
				}
				if (e.stopPropagation) {
					e.stopPropagation();
				} else {
					e.cancelBubble = true;
				}
				this.close();
			}
		}, {
			key: 'getEmotionTabs',
			value: function getEmotionTabs() {
				var EmotionTabs = _EditorConstants.EmotionImages.EmotionTabs,
				    BaseUrl = _EditorConstants.EmotionImages.BaseUrl,
				    SmileyInfor = _EditorConstants.EmotionImages.SmileyInfor;
	
				var tabs = [];
				for (var key in EmotionTabs) {
					var tab = { title: EmotionTabs[key].name };
					var images = [];
					var titles = SmileyInfor[key];
					for (var i = 0; i < titles.length; i++) {
						var index = (i + 1).toString();
						index = index.length == 1 ? "0" + index : index;
						var image = {
							title: titles[i],
							url: BaseUrl + EmotionTabs[key].path + EmotionTabs[key].prefix + index + ".gif?v=1.1"
						};
						images.push(image);
					}
					tab.images = images;
					tabs.push(tab);
				}
				return tabs;
			}
		}, {
			key: 'render',
			value: function render() {
				var tabs = [];
				var EmotionTabs = this.getEmotionTabs();
	
				for (var i = 0; i < EmotionTabs.length; i++) {
					tabs.push({
						title: EmotionTabs[i].title,
						images: EmotionTabs[i].images,
						component: _react2.default.createElement(EmotionPanel, { images: EmotionTabs[i].images, name: 'common-images', onSelectImage: this.handleSelectImage.bind(this) })
					});
				}
				var buttons = [];
				if (this.props.hidden) {
					return _react2.default.createElement('div', null);
				} else {
					return _react2.default.createElement(_Dialog2.default, { ref: 'root', className: 'emotion-dropdwon', width: 700, height: 508, title: "\u8868\u60C5", buttons: buttons, onClose: this.close.bind(this) }, _react2.default.createElement(_TabGroup2.default, { tabs: tabs }));
				}
			}
		}]);
	
		return EmotionDialog;
	}(_react.Component);
	
	exports.default = EmotionDialog;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComboBox = __webpack_require__(366);
	
	var _ComboBox2 = _interopRequireDefault(_ComboBox);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var FontFamilyDropdown = function (_Component) {
		_inherits(FontFamilyDropdown, _Component);
	
		function FontFamilyDropdown(props) {
			_classCallCheck(this, FontFamilyDropdown);
	
			var _this = _possibleConstructorReturn(this, (FontFamilyDropdown.__proto__ || Object.getPrototypeOf(FontFamilyDropdown)).call(this, props));
	
			_this.state = {
				handle: function handle() {}
			};
			return _this;
		}
	
		_createClass(FontFamilyDropdown, [{
			key: 'open',
			value: function open(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.open(position);
			}
		}, {
			key: 'close',
			value: function close() {
				if (this.refs.root) this.refs.root.close();
			}
		}, {
			key: 'toggle',
			value: function toggle(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.toggle(position);
			}
		}, {
			key: 'handleSelect',
			value: function handleSelect(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var value = target.getAttribute('data-value');
				if (this.state.handle) {
					this.state.handle(value);
				}
				if (e.stopPropagation) {
					e.stopPropagation();
				} else {
					e.cancelBubble = true;
				}
				this.close();
			}
		}, {
			key: 'render',
			value: function render() {
				var handleSelect = this.handleSelect.bind(this);
				var fontfamily = this.props.fontfamily ? this.props.fontfamily : [];
				var props = this.props;
				if (this.props.hidden) {
					return _react2.default.createElement('div', null);
				} else {
					return _react2.default.createElement(_ComboBox2.default, { ref: 'root', className: 'fontfamily-combobox' }, _react2.default.createElement('ul', null, fontfamily.map(function (ele, pos) {
						return _react2.default.createElement('li', { className: ele.value == props.value ? "active" : "", key: pos, 'data-value': ele.value, onClick: handleSelect }, _react2.default.createElement('span', { 'data-value': ele.value, style: { "fontFamily": ele.value } }, ele.name));
					})));
				}
			}
		}]);
	
		return FontFamilyDropdown;
	}(_react.Component);
	
	exports.default = FontFamilyDropdown;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComboBox = __webpack_require__(366);
	
	var _ComboBox2 = _interopRequireDefault(_ComboBox);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var FontSizeDropdown = function (_Component) {
		_inherits(FontSizeDropdown, _Component);
	
		function FontSizeDropdown(props) {
			_classCallCheck(this, FontSizeDropdown);
	
			var _this = _possibleConstructorReturn(this, (FontSizeDropdown.__proto__ || Object.getPrototypeOf(FontSizeDropdown)).call(this, props));
	
			_this.state = {
				handle: function handle() {}
			};
			return _this;
		}
	
		_createClass(FontSizeDropdown, [{
			key: 'open',
			value: function open(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.open(position);
			}
		}, {
			key: 'close',
			value: function close() {
				if (this.refs.root) this.refs.root.close();
			}
		}, {
			key: 'toggle',
			value: function toggle(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.toggle(position);
			}
		}, {
			key: 'handleSelect',
			value: function handleSelect(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var value = target.getAttribute('data-value');
				if (this.state.handle) {
					this.state.handle(value);
				}
				if (e.stopPropagation) {
					e.stopPropagation();
				} else {
					e.cancelBubble = true;
				}
				this.close();
			}
		}, {
			key: 'render',
			value: function render() {
				var handleSelect = this.handleSelect.bind(this);
				var fontsize = this.props.fontsize ? this.props.fontsize : [];
				var props = this.props;
				if (this.props.hidden) {
					return _react2.default.createElement('div', null);
				} else {
					return _react2.default.createElement(_ComboBox2.default, { ref: 'root', className: 'fontsize-combobox' }, _react2.default.createElement('ul', null, fontsize.map(function (ele, pos) {
						return _react2.default.createElement('li', { className: ele.value == props.value ? "active" : "", key: pos, 'data-value': ele.value, onClick: handleSelect }, _react2.default.createElement('span', { 'data-value': ele.value, style: { "fontSize": ele.name } }, ele.name));
					})));
				}
			}
		}]);
	
		return FontSizeDropdown;
	}(_react.Component);
	
	exports.default = FontSizeDropdown;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FormulaIcons = undefined;
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabGroup = __webpack_require__(250);
	
	var _TabGroup2 = _interopRequireDefault(_TabGroup);
	
	var _Dropdown = __webpack_require__(368);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _EditorConstants = __webpack_require__(203);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var FormulaIcons = exports.FormulaIcons = function (_Component) {
		_inherits(FormulaIcons, _Component);
	
		function FormulaIcons() {
			_classCallCheck(this, FormulaIcons);
	
			return _possibleConstructorReturn(this, (FormulaIcons.__proto__ || Object.getPrototypeOf(FormulaIcons)).apply(this, arguments));
		}
	
		_createClass(FormulaIcons, [{
			key: 'handleClick',
			value: function handleClick(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var latex = target.getAttribute("data-latex");
				var id = 'mathquill-' + new Date().valueOf();
				if (this.props.onSelectFormula) {
					this.props.onSelectFormula(e, latex, id);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var icons = this.props.icons;
				var handleClick = this.handleClick.bind(this);
				return _react2.default.createElement('ul', { className: "formulas-icons " + this.props.name }, icons.map(function (ele, pos) {
					return _react2.default.createElement('li', { className: 'latex-icon', key: pos, 'data-latex': ele.latex, style: { "backgroundPosition": ele.backgroundPosition }, onClick: handleClick });
				}));
			}
		}]);
	
		return FormulaIcons;
	}(_react.Component);
	
	var FormulaDropdown = function (_React$Component) {
		_inherits(FormulaDropdown, _React$Component);
	
		function FormulaDropdown(props) {
			_classCallCheck(this, FormulaDropdown);
	
			var _this2 = _possibleConstructorReturn(this, (FormulaDropdown.__proto__ || Object.getPrototypeOf(FormulaDropdown)).call(this, props));
	
			_this2.state = {
				handle: function handle() {}
			};
			return _this2;
		}
	
		_createClass(FormulaDropdown, [{
			key: 'open',
			value: function open(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.open(position);
			}
		}, {
			key: 'close',
			value: function close() {
				if (this.refs.root) this.refs.root.close();
			}
		}, {
			key: 'toggle',
			value: function toggle(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.toggle(position);
			}
		}, {
			key: 'handleSelectFormula',
			value: function handleSelectFormula(e, latex, id) {
				e = e || event;
				if (this.state.handle) {
					this.state.handle(latex, id);
				}
				if (e.stopPropagation) {
					e.stopPropagation();
				} else {
					e.cancelBubble = true;
				}
				this.close();
			}
		}, {
			key: 'render',
			value: function render() {
				var tabs = [{ title: "常用公式", component: _react2.default.createElement(FormulaIcons, { icons: _EditorConstants.FormulaTypes.commonFormulas, name: 'common-formulas', onSelectFormula: this.handleSelectFormula.bind(this) }) }, { title: "符号", component: _react2.default.createElement(FormulaIcons, { icons: _EditorConstants.FormulaTypes.symbolFormulas, name: 'symbol-formulas', onSelectFormula: this.handleSelectFormula.bind(this) }) }, { title: "字母", component: _react2.default.createElement(FormulaIcons, { icons: _EditorConstants.FormulaTypes.arabicFormulas, name: 'arabic-formulas', onSelectFormula: this.handleSelectFormula.bind(this) }) }];
				if (this.props.hidden) {
					return _react2.default.createElement('div', null);
				} else {
					return _react2.default.createElement(_Dropdown2.default, { ref: 'root', className: 'formula-dropdown' }, _react2.default.createElement(_TabGroup2.default, { tabs: tabs }));
				}
			}
		}]);
	
		return FormulaDropdown;
	}(_react2.default.Component);
	
	exports.default = FormulaDropdown;
	
	module.exports = FormulaDropdown;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dialog = __webpack_require__(367);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _TabGroup = __webpack_require__(250);
	
	var _TabGroup2 = _interopRequireDefault(_TabGroup);
	
	var _ImageUpload = __webpack_require__(1304);
	
	var _ImageUpload2 = _interopRequireDefault(_ImageUpload);
	
	var _ImageSearch = __webpack_require__(1303);
	
	var _ImageSearch2 = _interopRequireDefault(_ImageSearch);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var ImageDialog = function (_Component) {
	  _inherits(ImageDialog, _Component);
	
	  function ImageDialog(props) {
	    _classCallCheck(this, ImageDialog);
	
	    var _this = _possibleConstructorReturn(this, (ImageDialog.__proto__ || Object.getPrototypeOf(ImageDialog)).call(this, props));
	
	    _this.state = {
	      images: [[], []],
	      handle: function handle() {}
	    };
	    return _this;
	  }
	
	  _createClass(ImageDialog, [{
	    key: 'open',
	    value: function open(handle) {
	      this.setState({
	        handle: handle
	      });
	      this.refs.modal.open();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.refs.modal) {
	        this.refs.modal.close();
	        if (this.state.handle) {
	          this.state.handle();
	        }
	        this.refs.image.clearImages();
	      }
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(handle) {
	      this.setState({
	        handle: handle
	      });
	      this.refs.modal.toggle();
	    }
	  }, {
	    key: 'handleOkClick',
	    value: function handleOkClick(e) {
	      // 做相应的处理做相应的处理
	      var tabIndex = this.refs.tab.getTabIndex();
	      var images = this.state.images[tabIndex];
	      var strImgs = "";
	      if (images.length > 0 && this.state.handle) {
	        for (var i = 0; i < images.length; i++) {
	          var src = images[i].src;
	          var str = "<img src='" + src + "'/>";
	          strImgs += str;
	        }
	        this.state.handle(strImgs);
	      }
	      this.close();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(index, imgs) {
	      var images = this.state.images;
	      images[index] = imgs;
	      this.setState({
	        images: images
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var uploader = this.props.uploader;
	      var customUploader = this.props.customUploader;
	      var buttons = [{
	        name: "btn-ok",
	        content: "确定",
	        onClick: this.handleOkClick.bind(this)
	      }, {
	        name: "btn-cancel",
	        content: "取消",
	        onClick: this.close.bind(this)
	      }];
	      var tabs = [{
	        title: "本地上传",
	        component: _react2.default.createElement(_ImageUpload2.default, _extends({
	          ref: 'image'
	        }, uploader, {
	          onChange: this.handleChange.bind(this),
	          customUploader: customUploader,
	          uploadImageCallback: this.props.uploadImageCallback
	        }))
	      }, {
	        title: "网络图片",
	        component: _react2.default.createElement(_ImageSearch2.default, {
	          ref: 'image',
	          onChange: this.handleChange.bind(this)
	        })
	      }];
	      if (this.props.hidden) {
	        return _react2.default.createElement('div', null);
	      } else {
	        return _react2.default.createElement(_Dialog2.default, {
	          ref: 'modal',
	          className: 'image-dialog',
	          width: 700,
	          height: 528,
	          title: "\u56FE\u7247",
	          buttons: buttons,
	          onClose: this.close.bind(this) }, _react2.default.createElement(_TabGroup2.default, { tabs: tabs, ref: 'tab' }));
	      }
	    }
	  }]);
	
	  return ImageDialog;
	}(_react.Component);
	
	exports.default = ImageDialog;
	
	ImageDialog.propTypes = {
	  uploader: _propTypes2.default.object,
	  customUploader: _propTypes2.default.object
	};
	
	ImageDialog.defaultProps = {
	  uploader: {
	    name: "file",
	    url: "/upload",
	    filter: function filter(res) {
	      return res.url;
	    },
	    data: {}
	  }
	};

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var ImageSearch = function (_Component) {
		_inherits(ImageSearch, _Component);
	
		function ImageSearch(props) {
			_classCallCheck(this, ImageSearch);
	
			var _this = _possibleConstructorReturn(this, (ImageSearch.__proto__ || Object.getPrototypeOf(ImageSearch)).call(this, props));
	
			_this.state = {
				images: []
			};
			return _this;
		}
	
		_createClass(ImageSearch, [{
			key: 'getImages',
			value: function getImages() {
				return this.state.images;
			}
		}, {
			key: 'clearImages',
			value: function clearImages() {
				this.setState({
					images: []
				});
			}
		}, {
			key: 'handleClick',
			value: function handleClick(e) {
				var text = _reactDom2.default.findDOMNode(this.refs.text);
				var src = text.value;
				var images = this.state.images;
				if (src && src.length > 0) {
					images.push({ src: src });
					this.setState({
						images: images
					});
					if (this.props.onChange) this.props.onChange(1, images);
					text.value = "";
				}
			}
		}, {
			key: 'handleRemoveImage',
			value: function handleRemoveImage(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var index = parseInt(target.getAttribute("data-index"));
				var images = this.state.images;
				images.splice(index, 1);
				this.setState({
					images: images
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var images = this.state.images;
				var handleRemoveImage = this.handleRemoveImage.bind(this);
				return _react2.default.createElement('div', { className: 'tab-panel' }, _react2.default.createElement('table', { className: 'search-bar' }, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('td', null, _react2.default.createElement('input', { className: 'image-searchTxt', type: 'text', ref: 'text' })), _react2.default.createElement('td', null, _react2.default.createElement('div', { className: 'image-searchAdd', onClick: this.handleClick.bind(this) }, "\u6DFB\u52A0"))))), _react2.default.createElement('div', { className: 'image-content' }, images.map(function (ele, pos) {
					return _react2.default.createElement('div', { key: pos, className: 'image-item' }, _react2.default.createElement('div', { className: 'image-close', 'data-index': pos, onClick: handleRemoveImage }), _react2.default.createElement('img', { src: ele.src, className: 'image-pic', height: '75', width: '120' }));
				})));
			}
		}]);
	
		return ImageSearch;
	}(_react.Component);
	
	exports.default = ImageSearch;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}return target;
	};
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FileUpload = __webpack_require__(1313);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
		var target = {};for (var i in obj) {
			if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
		}return target;
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var ImageUpload = function (_Component) {
		_inherits(ImageUpload, _Component);
	
		function ImageUpload(props) {
			_classCallCheck(this, ImageUpload);
	
			var _this = _possibleConstructorReturn(this, (ImageUpload.__proto__ || Object.getPrototypeOf(ImageUpload)).call(this, props));
	
			_this.argumentUpload = function (file, files, fileIndex, obj) {
				var _self = _this;
	
				var _this$props = _this.props,
				    customUploader = _this$props.customUploader,
				    name = _this$props.name,
				    data = _this$props.data,
				    url = _this$props.url,
				    filter = _this$props.filter,
				    others = _objectWithoutProperties(_this$props, ['customUploader', 'name', 'data', 'url', 'filter']);
	
				var uploader = _this.props.customUploader ? _this.props.customUploader : _FileUpload2.default;
	
				uploader.uploadFile(_extends({
					file: file,
					filename: name,
					data: data,
					url: url,
					filter: filter
				}, others, {
					onLoad: function onLoad() {
						_self.beforeUploading(files, fileIndex);
					},
					onSuccess: function onSuccess(res) {
						var url = _self.props.filter(res);
						_self.updateImage(url);
	
						setTimeout(function () {
							if (fileIndex + 1 < files.length) {
								//判断是否还有图片没有上传
								fileIndex += 1;
								_self.argumentUpload(files[fileIndex], files, fileIndex, obj);
							} else {
								//图片上传完毕，重置文件索引 fileIndex
								fileIndex = 0;
								if (!obj.dropEffect) {
									obj.value = "";
								}
								_self.afterUploading();
							}
						}, 200);
					},
					onError: function onError() {
						_self.errorUploading();
					}
				}));
			};
	
			_this.beforeUploading = function (files, fileIndex) {
				var mask = _reactDom2.default.findDOMNode(_this.refs.mask);
				mask.style.display = "block";
				mask.innerHTML = fileIndex + 1 + '/' + files.length + ' Uploading...';
			};
	
			_this.afterUploading = function () {
				// 去除遮罩层
				var mask = _reactDom2.default.findDOMNode(_this.refs.mask);
				mask.style.display = "none";
				mask.innerHTML = "Load Success";
			};
	
			_this.errorUploading = function () {
				var mask = _reactDom2.default.findDOMNode(_this.refs.mask);
				mask.style.display = "block";
				mask.innerHTML = "Load Error";
				setTimeout(function () {
					mask.style.display = "none";
				}, 200);
			};
	
			_this.updateImage = function (image) {
				var images = _this.state.images;
				images.push({
					src: image
				});
				_this.setState({
					images: images
				});
				if (_this.props.onChange) {
					_this.props.onChange(0, images);
				}
			};
	
			_this.state = {
				images: [],
				dragEnter: false
			};
			return _this;
		}
	
		_createClass(ImageUpload, [{
			key: 'handleUploadFile',
			value: function handleUploadFile(obj) {
				var file = obj.files[0];
				this.argumentUpload(file, obj.files, 0, obj);
			}
		}, {
			key: 'handleChange',
			value: function handleChange(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				if (target.files.length > 0) {
					this.handleUploadFile(target);
					// clear value
					// target.value = "";
				}
			}
		}, {
			key: 'getImages',
			value: function getImages() {
				return this.state.images;
			}
		}, {
			key: 'clearImages',
			value: function clearImages() {
				this.setState({
					images: []
				});
			}
		}, {
			key: 'handleRemoveImage',
			value: function handleRemoveImage(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var index = parseInt(target.getAttribute("data-index"));
				var images = this.state.images;
				images.splice(index, 1);
				this.setState({
					images: images
				});
				if (this.props.onChange) this.props.onChange(0, images);
			}
		}, {
			key: 'handleDrop',
			value: function handleDrop(e) {
				e.preventDefault();
				var files = e.dataTransfer.files;
				if (files.length > 0) {
					// this.handleUploadFile(files[0]);
					this.handleUploadFile(e.dataTransfer);
				}
				this.setState({
					dragEnter: false
				});
				// console.log(e.type);
			}
		}, {
			key: 'handleDragOver',
			value: function handleDragOver(e) {
				e.preventDefault();
				// console.log(e.type);
			}
		}, {
			key: 'handleDragEnter',
			value: function handleDragEnter(e) {
				this.setState({
					dragEnter: true
				});
				// console.log(e.type);
			}
		}, {
			key: 'handleDragLeave',
			value: function handleDragLeave(e) {
				this.setState({
					dragEnter: false
				});
				// console.log(e.type);
			}
		}, {
			key: 'render',
			value: function render() {
				var images = this.state.images;
				var dragEnter = this.state.dragEnter;
				var handleRemoveImage = this.handleRemoveImage.bind(this);
				var action = this.props.action ? this.props.action : "/upload";
				var showStyle = {
					"display": "block"
				};
				var hideStyle = {
					"display": "none"
				};
	
				var hasImages = images.length > 0;
				return _react2.default.createElement('div', { className: 'tab-panel' }, _react2.default.createElement('div', { className: (0, _classnames2.default)("image-content", { " drag-enter": dragEnter }), onDrop: this.handleDrop.bind(this),
					onDragOver: this.handleDragOver.bind(this),
					onDragEnter: this.handleDragEnter.bind(this),
					onDragLeave: this.handleDragLeave.bind(this),
					onDragEnd: this.handleDragLeave.bind(this),
					onDragStart: this.handleDragEnter.bind(this) }, images.map(function (ele, pos) {
					return _react2.default.createElement('div', { key: pos, className: 'image-item' }, _react2.default.createElement('div', { className: 'image-close', 'data-index': pos, onClick: handleRemoveImage }), _react2.default.createElement('img', { src: ele.src, className: 'image-pic', height: '75', width: '120' }));
				}), _react2.default.createElement('div', { className: 'image-upload2', style: hasImages ? showStyle : hideStyle }, _react2.default.createElement('span', { className: 'image-icon' }), _react2.default.createElement('form', { className: 'image-form', method: 'post', encType: 'multipart/form-data', target: 'up', action: action }, _react2.default.createElement('input', { onChange: this.handleChange.bind(this), multiple: 'multiple', style: { filter: "alpha(opacity=0)" }, className: 'image-file', type: 'file', name: 'file', accept: 'image/gif,image/jpeg,image/png,image/jpg,image/bmp' })))), _react2.default.createElement('div', { className: 'image-dragTip', style: hasImages ? hideStyle : showStyle }, "\u652F\u6301\u56FE\u7247\u62D6\u62FD\u4E0A\u4F20"), _react2.default.createElement('div', { className: 'image-upload1', style: hasImages ? hideStyle : showStyle }, _react2.default.createElement('span', { className: 'image-icon' }), _react2.default.createElement('form', { className: 'image-form', method: 'post', encType: 'multipart/form-data', target: 'up', action: action }, _react2.default.createElement('input', { onChange: this.handleChange.bind(this), multiple: 'multiple', style: { filter: "alpha(opacity=0)" }, className: 'image-file', type: 'file', name: 'file', accept: 'image/gif,image/jpeg,image/png,image/jpg,image/bmp' }))), _react2.default.createElement('div', { className: 'image-mask', ref: 'mask' }, "Loading...."));
			}
		}]);
	
		return ImageUpload;
	}(_react.Component);
	
	exports.default = ImageUpload;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComboBox = __webpack_require__(366);
	
	var _ComboBox2 = _interopRequireDefault(_ComboBox);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var ParagraphDropdown = function (_Component) {
		_inherits(ParagraphDropdown, _Component);
	
		function ParagraphDropdown(props) {
			_classCallCheck(this, ParagraphDropdown);
	
			var _this = _possibleConstructorReturn(this, (ParagraphDropdown.__proto__ || Object.getPrototypeOf(ParagraphDropdown)).call(this, props));
	
			_this.state = {
				handle: function handle() {}
			};
			return _this;
		}
	
		_createClass(ParagraphDropdown, [{
			key: 'open',
			value: function open(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.open(position);
			}
		}, {
			key: 'close',
			value: function close() {
				if (this.refs.root) this.refs.root.close();
			}
		}, {
			key: 'toggle',
			value: function toggle(position, handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.toggle(position);
			}
		}, {
			key: 'handleSelect',
			value: function handleSelect(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var value = target.getAttribute('data-value');
				if (this.state.handle) {
					this.state.handle(value);
				}
				if (e.stopPropagation) {
					e.stopPropagation();
				} else {
					e.cancelBubble = true;
				}
				this.close();
			}
		}, {
			key: 'render',
			value: function render() {
				var handleSelect = this.handleSelect.bind(this);
				var paragraph = this.props.paragraph ? this.props.paragraph : [];
				var props = this.props;
				if (this.props.hidden) {
					return _react2.default.createElement('div', null);
				} else {
					return _react2.default.createElement(_ComboBox2.default, { ref: 'root', className: 'paragraph-combobox' }, _react2.default.createElement('ul', null, paragraph.map(function (ele, pos) {
						return _react2.default.createElement('li', { className: ele.value == props.value ? "active" : "", key: pos, 'data-value': ele.value, onClick: handleSelect }, _react2.default.createElement(ele.value, { "data-value": ele.value }, ele.name));
					})));
				}
			}
		}]);
	
		return ParagraphDropdown;
	}(_react.Component);
	
	exports.default = ParagraphDropdown;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabGroup = __webpack_require__(250);
	
	var _TabGroup2 = _interopRequireDefault(_TabGroup);
	
	var _Dialog = __webpack_require__(367);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _EditorConstants = __webpack_require__(203);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var SCChars = function (_React$Component) {
		_inherits(SCChars, _React$Component);
	
		function SCChars() {
			_classCallCheck(this, SCChars);
	
			return _possibleConstructorReturn(this, (SCChars.__proto__ || Object.getPrototypeOf(SCChars)).apply(this, arguments));
		}
	
		_createClass(SCChars, [{
			key: 'handleClick',
			value: function handleClick(e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var char = target.getAttribute("data-char");
				var id = 'char-' + new Date().valueOf();
				if (this.props.onSelectChar) {
					this.props.onSelectChar(e, char);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var chars = this.props.chars;
				var handleClick = this.handleClick.bind(this);
				return _react2.default.createElement('ul', { className: "special-chars " + this.props.name }, chars.map(function (ele, pos) {
					return _react2.default.createElement('li', { className: 'special-char', key: pos, 'data-char': ele, onClick: handleClick }, ele);
				}));
			}
		}]);
	
		return SCChars;
	}(_react2.default.Component);
	
	var SpecialCharsDialog = function (_React$Component2) {
		_inherits(SpecialCharsDialog, _React$Component2);
	
		function SpecialCharsDialog(props) {
			_classCallCheck(this, SpecialCharsDialog);
	
			var _this2 = _possibleConstructorReturn(this, (SpecialCharsDialog.__proto__ || Object.getPrototypeOf(SpecialCharsDialog)).call(this, props));
	
			_this2.state = {
				handle: function handle() {}
			};
			return _this2;
		}
	
		_createClass(SpecialCharsDialog, [{
			key: 'open',
			value: function open(handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.open();
			}
		}, {
			key: 'close',
			value: function close() {
				if (this.refs.root) this.refs.root.close();
			}
		}, {
			key: 'toggle',
			value: function toggle(handle) {
				this.setState({
					handle: handle
				});
				this.refs.root.toggle();
			}
		}, {
			key: 'handleSelectChar',
			value: function handleSelectChar(e, char) {
				e = e || event;
				if (this.state.handle) {
					this.state.handle(char);
				}
				if (e.stopPropagation) {
					e.stopPropagation();
				} else {
					e.cancelBubble = true;
				}
				this.close();
			}
		}, {
			key: 'render',
			value: function render() {
				var tabs = [];
				for (var i = 0; i < _EditorConstants.SpecialChars.length; i++) {
					tabs.push({
						title: _EditorConstants.SpecialChars[i].title,
						chars: _EditorConstants.SpecialChars[i].chars,
						component: _react2.default.createElement(SCChars, { chars: _EditorConstants.SpecialChars[i].chars, name: 'common-chars', onSelectChar: this.handleSelectChar.bind(this) })
					});
				}
				var buttons = [];
				if (this.props.hidden) {
					return _react2.default.createElement('div', null);
				} else {
					return _react2.default.createElement(_Dialog2.default, { ref: 'root', className: 'special-chars-dialog', width: 700, height: 508, title: "\u7279\u6B8A\u5B57\u7B26", buttons: buttons, onClose: this.close.bind(this) }, _react2.default.createElement(_TabGroup2.default, { tabs: tabs }));
				}
			}
		}]);
	
		return SpecialCharsDialog;
	}(_react2.default.Component);
	
	exports.default = SpecialCharsDialog;
	
	module.exports = SpecialCharsDialog;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(368);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var TablePickerDropdown = function (_Component) {
	  _inherits(TablePickerDropdown, _Component);
	
	  function TablePickerDropdown(props) {
	    _classCallCheck(this, TablePickerDropdown);
	
	    var _this = _possibleConstructorReturn(this, (TablePickerDropdown.__proto__ || Object.getPrototypeOf(TablePickerDropdown)).call(this, props));
	
	    _this.state = {
	      row: 0,
	      column: 0,
	      handle: function handle() {}
	    };
	    return _this;
	  }
	
	  _createClass(TablePickerDropdown, [{
	    key: 'open',
	    value: function open(position, handle) {
	      this.setState({
	        handle: handle
	      });
	      this.refs.root.open(position);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.refs.root) this.refs.root.close();
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(position, handle) {
	      this.setState({
	        handle: handle
	      });
	      this.refs.root.toggle(position);
	    }
	  }, {
	    key: 'handleMouseEvent',
	    value: function handleMouseEvent(e) {
	      e = e || event;
	      var target = e.target || e.srcElement;
	      var parentPostion = target.getBoundingClientRect();
	      var column = Math.ceil((e.clientX - parentPostion.left) / 22);
	      var row = Math.ceil((e.clientY - parentPostion.top) / 22);
	      if (row < 0) row = 0;
	      if (column < 0) column = 0;
	
	      if (row > 10) row = 10;
	      if (column > 10) column = 10;
	      this.setState({
	        row: row,
	        column: column
	      });
	    }
	  }, {
	    key: 'handleMouseOut',
	    value: function handleMouseOut(e) {
	      this.setState({
	        row: 0,
	        column: 0
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      // insert table
	      var Table = document.createElement("table");
	      Table.className = "editor-table";
	      var TBody = Table.createTBody();
	      for (var i = 0; i < this.state.row; i++) {
	        var Tr = TBody.insertRow();
	        for (var j = 0; j < this.state.column; j++) {
	          var Td = Tr.insertCell();
	          Td.width = 200;
	        }
	      }
	      this.state.handle(Table);
	      this.refs.root.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var row = this.state.row;
	      var column = this.state.column;
	      if (this.props.hidden) {
	        return _react2.default.createElement('div', null);
	      } else {
	        return _react2.default.createElement(_Dropdown2.default, { ref: 'root', className: 'tablepicker-dropdown' }, _react2.default.createElement('div', { className: 'infoarea' }, ' ', _react2.default.createElement('span', null, row + "行 x " + column + "列")), _react2.default.createElement('div', { className: 'pickarea', onMouseOver: this.handleMouseEvent.bind(this), onMouseMove: this.handleMouseEvent.bind(this),
	          onMouseOut: this.handleMouseOut.bind(this), onClick: this.handleClick.bind(this) }, _react2.default.createElement('div', { className: 'overlay', style: { width: column * 22, height: row * 22 } })));
	      }
	    }
	  }]);
	
	  return TablePickerDropdown;
	}(_react.Component);
	
	exports.default = TablePickerDropdown;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _EditorCore = __webpack_require__(1293);
	
	var _EditorCore2 = _interopRequireDefault(_EditorCore);
	
	var _EditorEventEmitter = __webpack_require__(1310);
	
	var _EditorEventEmitter2 = _interopRequireDefault(_EditorEventEmitter);
	
	__webpack_require__(1995);
	
	__webpack_require__(1309);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var Editor = function (_Component) {
	  _inherits(Editor, _Component);
	
	  function Editor(props) {
	    _classCallCheck(this, Editor);
	
	    var _this = _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props));
	
	    _this.handleChange = function () {
	      _this.setState({
	        loaded: true
	      });
	    };
	
	    _this.state = {
	      loaded: false,
	      reload: true
	    };
	    return _this;
	  }
	
	  _createClass(Editor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.index = _EditorEventEmitter2.default.editorIndex;
	      _EditorEventEmitter2.default.addStartListener("start-" + this.index, this.handleChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var index = this.index;
	      _EditorEventEmitter2.default.removeStartListener("start-" + index, this.handleChange);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.loaded && this.state.reload) {
	        this.refs.editor.setContent(this.props.value || this.props.defaultValue);
	      }
	    }
	  }, {
	    key: 'handleMountSuccess',
	    value: function handleMountSuccess() {
	      _EditorEventEmitter2.default.mountEditorSuccess();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // reload判断当前是否可以允许刷新
	      // loaded状态变化时，务必重新刷新
	      var currentValue = nextProps.value;
	      var editorValue = this.getContent();
	
	      if (this.state.loaded != nextState.loaded) {
	        return true;
	      } else if (currentValue == editorValue) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      return this.refs.editor ? this.refs.editor.getContent() : "";
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent(content) {
	      return this.refs.editor ? this.refs.editor.setContent(content) : "";
	    }
	  }, {
	    key: 'focusEditor',
	    value: function focusEditor() {
	      return this.refs.editor ? this.refs.editor.focusEditor() : "";
	    }
	  }, {
	    key: 'findDOMNode',
	    value: function findDOMNode(refName) {
	      return this.refs.editor ? this.refs.editor.findDOMNode(refName) : "";
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var loaded = this.state.loaded;
	
	      var _props = this.props,
	          value = _props.value,
	          defaultValue = _props.defaultValue,
	          props = _objectWithoutProperties(_props, ['value', 'defaultValue']);
	
	      if (!this.state.loaded) {
	        return _react2.default.createElement('div', {
	          id: props.id,
	          className: 'editor-contenteditable-div',
	          style: { "minHeight": "30px", "border": "1px solid #ddd" } }, "\u6B63\u5728\u52A0\u8F7D...");
	      } else {
	        return _react2.default.createElement(_EditorCore2.default, _extends({ ref: 'editor' }, props, { onEditorMount: this.handleMountSuccess }));
	      }
	    }
	  }]);
	
	  return Editor;
	}(_react.Component);
	
	exports.default = Editor;
	
	Editor.propTypes = {
	  plugins: _propTypes2.default.object,
	  fontFamily: _propTypes2.default.array,
	  fontSize: _propTypes2.default.array,
	  paragraph: _propTypes2.default.array,
	  icons: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  value: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.string
	};
	
	Editor.defaultProps = {
	  "plugins": {
	    "image": {
	      "uploader": {
	        name: "file",
	        url: "/upload",
	        data: {},
	        filter: function filter(res) {
	          return res.url;
	        }
	      }
	    },
	    "toolbar": {
	      icons: []
	    }
	  },
	  "fontFamily": [{
	    "name": "宋体",
	    value: "宋体, SimSun",
	    defualt: true
	  }, {
	    "name": "隶书",
	    value: "隶书, SimLi"
	  }, {
	    "name": "楷体",
	    value: "楷体, SimKai"
	  }, {
	    "name": "微软雅黑",
	    value: "微软雅黑, Microsoft YaHei"
	  }, {
	    "name": "黑体",
	    value: "黑体, SimHei"
	  }, {
	    "name": "arial",
	    value: "arial, helvetica, sans-serif"
	  }, {
	    "name": "arial black",
	    value: "arial black, avant garde"
	  }, {
	    "name": "omic sans ms",
	    value: "omic sans ms"
	  }, {
	    "name": "impact",
	    value: "impact, chicago"
	  }, {
	    "name": "times new roman",
	    value: "times new roman"
	  }, {
	    "name": "andale mono",
	    value: "andale mono"
	  }],
	  "fontSize": [{
	    "name": "10px",
	    value: "1"
	  }, {
	    "name": "12px",
	    value: "2"
	  }, {
	    "name": "16px",
	    value: "3",
	    defualt: true
	  }, {
	    "name": "18px",
	    value: "4"
	  }, {
	    "name": "24px",
	    value: "5"
	  }, {
	    "name": "32px",
	    value: "6"
	  }, {
	    "name": "38px",
	    value: "7"
	  }],
	  "paragraph": [{
	    "name": "段落",
	    value: "p",
	    defualt: true
	  }, {
	    "name": "标题1",
	    value: "h1"
	  }, {
	    "name": "标题2",
	    value: "h2"
	  }, {
	    "name": "标题3",
	    value: "h3"
	  }, {
	    "name": "标题4",
	    value: "h4"
	  }, {
	    "name": "标题5",
	    value: "h5"
	  }, {
	    "name": "标题6",
	    value: "h6"
	  }],
	  "icons": [
	  // video map print preview drafts link unlink formula
	  "source | undo redo | bold italic underline strikethrough fontborder emphasis | ", "paragraph fontfamily fontsize | superscript subscript | ", "forecolor backcolor | removeformat | insertorderedlist insertunorderedlist | selectall | ", "cleardoc  | indent outdent | justifyleft justifycenter justifyright | touppercase tolowercase | ", "horizontal date time  | image emotion spechars | inserttable"],
	  "value": "",
	  "defaultValue": ""
	};

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	"use strict";
	
	Date.prototype.Format = function (n) {
	  var i = {
	    "M+": this.getMonth() + 1,
	    "d+": this.getDate(),
	    "h+": this.getHours(),
	    "m+": this.getMinutes(),
	    "s+": this.getSeconds(),
	    "q+": Math.floor((this.getMonth() + 3) / 3),
	    S: this.getMilliseconds()
	  },
	      t;
	  /(y+)/.test(n) && (n = n.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length)));
	  for (t in i) {
	    new RegExp("(" + t + ")").test(n) && (n = n.replace(RegExp.$1, RegExp.$1.length == 1 ? i[t] : ("00" + i[t]).substr(("" + i[t]).length)));
	  }return n;
	};

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.EditorEventEmitter = undefined;
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _events = __webpack_require__(1873);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var EditorEventEmitter = exports.EditorEventEmitter = function (_EventEmitter) {
		_inherits(EditorEventEmitter, _EventEmitter);
	
		function EditorEventEmitter() {
			_classCallCheck(this, EditorEventEmitter);
	
			var _this = _possibleConstructorReturn(this, (EditorEventEmitter.__proto__ || Object.getPrototypeOf(EditorEventEmitter)).call(this));
	
			_this.editorStack = [];
			_this.isStart = false;
			_this.startTime = null;
			_this.editorIndex = null;
			return _this;
		}
	
		_createClass(EditorEventEmitter, [{
			key: 'addStartListener',
			value: function addStartListener(type, callback) {
				if (this.editorStack.length == 0 && this.isStart == false) {
					this.startTime = this.startTime || new Date();
				}
				this.editorIndex = EditorEventEmitter.EditorIndex++;
				this.editorStack.push(type);
				this.on(type, callback);
	
				this.emitNextListener();
			}
		}, {
			key: 'emitNextListener',
			value: function emitNextListener() {
				if (this.editorStack.length == 0) this.isStart = false;else if (this.isStart == false) {
					this.isStart = true;
					var type = this.editorStack.shift();
					this.emit(type);
					this.startTime = this.startTime || new Date();
				}
			}
		}, {
			key: 'removeStartListener',
			value: function removeStartListener(type, callback) {
				this.removeListener(type, callback);
				var index = this.editorStack.indexOf(type);
				this.editorStack.splice(index, 1);
			}
		}, {
			key: 'mountEditorSuccess',
			value: function mountEditorSuccess() {
				this.isStart = false;
				this.emitNextListener();
			}
		}]);
	
		return EditorEventEmitter;
	}(_events2.default);
	
	EditorEventEmitter.EditorIndex = 0;
	
	var editorEventEmitter = new EditorEventEmitter();
	editorEventEmitter.setMaxListeners(10000);
	
	exports.default = editorEventEmitter;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
			}
		}return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		};
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _EditorDom = __webpack_require__(160);
	
	var _EditorDom2 = _interopRequireDefault(_EditorDom);
	
	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}
	
	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	// resize context
	var minWidth = 12;
	var minHeight = 12;
	
	var EditorResize = function (_Component) {
		_inherits(EditorResize, _Component);
	
		function EditorResize() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, EditorResize);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditorResize.__proto__ || Object.getPrototypeOf(EditorResize)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				direction: null,
				target: null,
				position: {
					x: 0,
					y: 0
				},
				width: 0,
				height: 0
			}, _this.componentDidMount = function () {
				_this.parentElement = _this.root.parentElement.querySelector('.editable-range');
				_this.parentElement.addEventListener('scroll', _this.resetPosition);
			}, _this.componentWillUnmount = function () {
				_this.parentElement.removeEventListener('scroll', _this.resetPosition);
			}, _this.resetPosition = function () {
				if (!_this.state.target) return;
				if (!_this.state.show) return;
				if (_this.state.direction) return;
				var position = _EditorDom2.default.getOffsetRootParentPosition(_this.state.target, _this.parentElement);
				_this.setState({
					position: { x: position.x, y: position.y }
				});
			}, _this.handleMouseDown = function (e) {
				e = e || event;
				var target = e.target || e.srcElement;
				var className = target.className;
				_this.startPosition = _this.getMousePosition(e);
				_this.targetPosition = _this.state.target.getBoundingClientRect();
	
				var direction = null;
				_this.clearSelect();
				if (className.indexOf("nw-resize") != -1) direction = "nw-resize";
				if (className.indexOf("ne-resize") != -1) direction = "ne-resize";
				if (className.indexOf("sw-resize") != -1) direction = "sw-resize";
				if (className.indexOf("se-resize") != -1) direction = "se-resize";
	
				window.removeEventListener("mouseup", _this.handleMouseUp);
				window.removeEventListener("mousemove", _this.handleMouseMove);
				window.addEventListener("mouseup", _this.handleMouseUp);
				window.addEventListener("mousemove", _this.handleMouseMove);
	
				_this.setState({
					direction: direction
				});
	
				_EditorDom2.default.stopPropagation(e);
			}, _this.handleMouseMove = function (e) {
				_this.updatePosition(e, _this.state.direction);
			}, _this.handleMouseUp = function (e) {
				window.removeEventListener("mouseup", _this.handleMouseUp);
				window.removeEventListener("mousemove", _this.handleMouseMove);
				_this.updatePosition(e, null);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(EditorResize, [{
			key: 'setTarget',
			value: function setTarget(target) {
				var position = _EditorDom2.default.getOffsetRootParentPosition(target, this.parentElement);
				var width = position.w;
				var height = position.h;
				var offsetPosition = { x: position.x, y: position.y };
				this.setState({
					target: target,
					width: width,
					height: height,
					show: true,
					position: offsetPosition
				});
			}
		}, {
			key: 'getTarget',
			value: function getTarget() {
				return this.state.target;
			}
		}, {
			key: 'clearTarget',
			value: function clearTarget() {
				this.setState({
					target: null,
					show: false
				});
			}
		}, {
			key: 'clearSelect',
			value: function clearSelect(e) {
				if (window.getSelection) {
					window.getSelection().removeAllRanges();
				} else {
					document.selection.empty();
				}
			}
		}, {
			key: 'getMousePosition',
			value: function getMousePosition(e) {
				e = e || window.event;
				var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
				var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
	
				var x = parseFloat(e.pageX || e.clientX + scrollX);
				var y = parseFloat(e.pageY || e.clientY + scrollY);
	
				return { x: x, y: y };
			}
		}, {
			key: 'updatePosition',
			value: function updatePosition(e, direction) {
				if (!this.state.direction) return;
				if (!this.state.show) return;
				this.clearSelect();
				var curPosition = this.getMousePosition(e);
				var startPosition = this.startPosition;
				var dx = curPosition.x - startPosition.x;
				var dy = curPosition.y - startPosition.y;
				var width = this.state.width;
				var height = this.state.height;
	
				switch (this.state.direction) {
					case "nw-resize":
						width -= dx;
						height -= dy;
						break;
					case "ne-resize":
						width += dx;
						height -= dy;
						break;
					case "sw-resize":
						width -= dx;
						height += dy;
						break;
					case "se-resize":
						width += dx;
						height += dy;
						break;
				}
	
				this.startPosition = curPosition;
	
				if (width < minWidth) width = minWidth;
				if (height < minHeight) height = minHeight;
	
				if (this.state.target) {
					this.state.target.style.width = width + "px";
					this.state.target.style.height = height + "px";
				}
	
				var position = _EditorDom2.default.getOffsetRootParentPosition(this.state.target, this.parentElement);
	
				this.setState({
					width: width,
					height: height,
					position: { x: position.x, y: position.y },
					direction: direction
				});
	
				_EditorDom2.default.stopPropagation(e);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var style = {
					width: this.state.width,
					height: this.state.height,
					left: this.state.position.x,
					top: this.state.position.y,
					display: this.state.show ? "block" : "none",
					positoin: "absolute"
				};
				return _react2.default.createElement('div', { className: 'editor-resize-container', ref: function ref(_ref2) {
						return _this2.root = _ref2;
					} }, _react2.default.createElement('div', { className: 'editor-resize', style: style }, _react2.default.createElement('div', { className: 'block-resize nw-resize', onMouseDown: this.handleMouseDown, onMouseMove: this.handleMouseMove, onMouseUp: this.handleMouseUp }), _react2.default.createElement('div', { className: 'block-resize ne-resize', onMouseDown: this.handleMouseDown, onMouseMove: this.handleMouseMove, onMouseUp: this.handleMouseUp }), _react2.default.createElement('div', { className: 'block-resize sw-resize', onMouseDown: this.handleMouseDown, onMouseMove: this.handleMouseMove, onMouseUp: this.handleMouseUp }), _react2.default.createElement('div', { className: 'block-resize se-resize', onMouseDown: this.handleMouseDown, onMouseMove: this.handleMouseMove, onMouseUp: this.handleMouseUp })));
			}
		}]);
	
		return EditorResize;
	}(_react.Component);
	
	exports.default = EditorResize;

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var INTERVAL_MS = 1000 / 60;
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = function (callback) {
			setTimeout(callback, INTERVAL_MS);
		};
	}
	
	var timeouts = [];
	var intervals = [];
	var animites = [];
	var running = false;
	var count = 0;
	
	var EditorTimer = {
		addCount: function addCount() {
			count = count + 1;
		},
		setTimeout: function setTimeout(callback, ms) {
			callback.prototype.ms = ms ? ms : INTERVAL_MS;
			callback.prototype.key = "timeout" + new Date().valueOf() + "-" + Math.round(Math.random() * 1000);
			callback.prototype.startTime = new Date().valueOf();
			callback.prototype.endTime = new Date().valueOf();
			timeouts.push(callback);
			return callback.prototype.key;
		},
		clearTimeout: function clearTimeout(key) {
			var _timeouts = timeouts.filter(function (ele, pos) {
				return ele.prototype.key == key;
			});
			if (_timeouts.length > 0) {
				var index = timeouts.indexOf(_timeouts[0]);
				if (index != -1) timeouts.disabled = true;
				return _timeouts[0];
			} else {
				return null;
			}
		},
		setInterval: function setInterval(callback, ms) {
			callback.prototype.ms = ms ? ms : INTERVAL_MS;
			callback.prototype.key = "interval" + new Date().valueOf() + "-" + Math.round(Math.random() * 1000);
			callback.prototype.startTime = new Date().valueOf();
			callback.prototype.endTime = new Date().valueOf();
			callback.prototype.lastTime = new Date().valueOf();
			intervals.push(callback);
			return callback.prototype.key;
		},
		clearInterval: function clearInterval(key) {
			var _intervals = intervals.filter(function (ele, pos) {
				return ele.prototype.key == key;
			});
			if (_intervals.length > 0) {
				var index = intervals.indexOf(_intervals[0]);
				if (index != -1) intervals.disabled = true;
				return _intervals[0];
			} else {
				return null;
			}
		},
		animate: function animate(callback) {
			window.requestAnimationFrame(EditorTimer.animate);
			if (running) {
				for (var i = 0; i < animites.length; i++) {
					animites[i]({
						count: count
					});
				}
				EditorTimer.addCount(); // count++
			}
			for (var i = 0; i < timeouts.length; i++) {
				timeouts[i].prototype.endTime = new Date().valueOf();
				if (timeouts[i].prototype.endTime - timeouts[i].prototype.startTime >= timeouts[i].prototype.ms && !timeouts[i].prototype.disabled) {
					timeouts[i].prototype.disabled = true;
					timeouts[i].call(timeouts[i].prototype, timeouts[i].prototype.endTime);
				}
			}
			for (var i = 0; i < intervals.length; i++) {
				intervals[i].prototype.endTime = new Date().valueOf();
				if (intervals[i].prototype.endTime - intervals[i].prototype.lastTime >= intervals[i].prototype.ms && !intervals[i].prototype.disabled) {
					intervals[i].prototype.lastTime = intervals[i].prototype.endTime;
					intervals[i].call(intervals[i].prototype, intervals[i].prototype.endTime);
				}
			}
			timeouts = timeouts.filter(function (ele, pos) {
				return !ele.prototype.disabled;
			});
			intervals = intervals.filter(function (ele, pos) {
				return !ele.prototype.disabled;
			});
		},
		startAnimation: function startAnimation() {
			running = true;
		},
		stopAnimation: function stopAnimation() {
			running = false;
		},
		addAnimationHandler: function addAnimationHandler(handler) {
			var _running = running;
			EditorTimer.stopAnimation(handler);
			window.requestAnimationFrame(function () {
				animites.push(handler);
				if (_running) EditorTimer.startAnimation(handler);
			});
		},
		removeAnimationHandler: function removeAnimationHandler(handler) {
			var _running = running;
			EditorTimer.stopAnimation(handler);
			window.requestAnimationFrame(function () {
				var index = animites.indexOf(handler);
				if (index != -1) animites.splice(handler, index);
				if (_running) EditorTimer.startAnimation(handler);
			});
		}
	};
	
	EditorTimer.animate();
	
	exports.default = EditorTimer;

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	'use strict';
	
	var getError = function getError(options, xhr) {
	    var msg = 'cannot post ' + options.url + ":" + xhr.status;
	    var err = new Error(msg);
	    err.status = xhr.status;
	    err.method = 'post';
	    err.url = options.url;
	    return err;
	};
	var getBody = function getBody(xhr) {
	    var text = xhr.responseText || xhr.response;
	    if (!text) {
	        return text;
	    }
	
	    try {
	        return JSON.parse(text);
	    } catch (e) {
	        return text;
	    }
	};
	var Uploader = {
	    post: function post(options) {
	        if (typeof XMLHttpRequest === 'undefined') {
	            return;
	        }
	
	        var xhr = new XMLHttpRequest();
	        if (xhr.upload) {
	            xhr.upload.onprogress = function (e) {
	                if (e.total > 0) {
	                    e.percent = e.loaded / e.total * 100;
	                }
	                options.onLoad(e);
	            };
	        }
	        var formData = new FormData();
	
	        if (options.data) {
	            for (var i in options.data) {
	                formData.append(i, options.data[i]);
	            }
	        }
	        formData.append(options.filename, options.file);
	
	        xhr.onerror = function (e) {
	            options.onEnd(e);
	            options.onError(e);
	        };
	        xhr.onload = function (e) {
	            if (xhr.status !== 200) {
	                options.onEnd(e);
	                return options.onError(getError(options, xhr), getBody(xhr));
	            }
	            options.onEnd(e);
	            options.onSuccess(getBody(xhr));
	        };
	
	        xhr.open('post', options.url, true);
	        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        xhr.send(formData);
	    }
	};
	
	module.exports = {
	    uploadFile: function uploadFile(options) {
	        options.url = options.url || "/upload";
	        options.filename = options.filename || "file";
	        options.beforeUpload = options.beforeUpload || function (e) {
	            return true;
	        };
	        options.onSuccess = options.onSuccess || function (e) {};
	        options.onError = options.onError || function (e) {};
	        options.onLoad = options.onLoad || function (e) {};
	        options.onStart = options.onStart || function (e) {};
	        options.onEnd = options.onEnd || function (e) {};
	
	        if (options.beforeUpload(options)) {
	            options.onStart(options);
	            // 开始上传文件
	            Uploader.post(options);
	        }
	    },
	    uploadFiles: function uploadFiles(options) {}
	};

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComponent2 = __webpack_require__(253);
	
	var _SgiCtnComponent3 = _interopRequireDefault(_SgiCtnComponent2);
	
	var _SgiCompComm = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiBadge = function (_SgiCtnComponent) {
		_inherits(SgiBadge, _SgiCtnComponent);
	
		function SgiBadge(props) {
			_classCallCheck(this, SgiBadge);
	
			var _this = _possibleConstructorReturn(this, (SgiBadge.__proto__ || Object.getPrototypeOf(SgiBadge)).call(this, props));
	
			_this.__render = function () {
				return _react2.default.createElement(
					_antd.Badge,
					_this.state._props,
					_this.state.sonItems,
					_this.props.children
				);
			};
	
			return _this;
		}
	
		_createClass(SgiBadge, [{
			key: '__fitSonItems',
			value: function __fitSonItems() {
				var _this2 = this;
	
				var _props2 = this.props,
				    moduleDesc = _props2.moduleDesc,
				    objFct = _props2.objFct,
				    type = _props2.type;
				var sonItems = this.state.sonItems;
	
	
				var cldSet = moduleDesc.cldSet || [];
				cldSet.forEach(function (item) {
					return sonItems.push((0, _SgiCompComm.convertModuleByGuid)(_this2, item, null, objFct, type));
				});
			}
	
			//渲染并返回一个虚拟DOM
	
		}, {
			key: '__AddAttribute',
			value: function __AddAttribute() {
				var _props3 = this.props,
				    moduleDesc = _props3.moduleDesc,
				    parentModule = _props3.parentModule;
				var _state = this.state,
				    _props = _state._props,
				    _style = _state._style,
				    _class = _state._class;
	
	
				var text = _props.te; //公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
				if (text) _props.title = text;
	
				/**
	    * color	自定义小圆点的颜色	string	-	3.16.0
	    * count	展示的数字，大于 overflowCount 时显示为 ${overflowCount}+，为 0 时隐藏	ReactNode		
	    * dot	不展示数字，只有一个小红点	boolean	false	
	    * offset	设置状态点的位置偏移，格式为 [x, y]	[number, number]	-	
	    * overflowCount	展示封顶的数字值	number	99	
	    * showZero	当数值为 0 时，是否展示 Badge	boolean	false	
	    * status	设置 Badge 为状态点	Enum{ 'success', 'processing, 'default', 'error', 'warning' }	''	
	    * text	在设置了 status 的前提下有效，设置状态点的文本	string	''	
	    * title	设置鼠标放在状态点上时显示的文字	string	count	3.5.0
	    */
				if (moduleDesc.color !== undefined) _props.color = moduleDesc.color;
				if (moduleDesc.count !== undefined) _props.count = moduleDesc.count;
				if (moduleDesc.dot !== undefined) _props.dot = moduleDesc.dot;
				if (moduleDesc.overflowCount !== undefined) _props.overflowCount = moduleDesc.overflowCount;
				if (moduleDesc.showZero !== undefined) _props.showZero = moduleDesc.showZero;
			}
		}]);
	
		return SgiBadge;
	}(_SgiCtnComponent3.default);
	
	exports.default = SgiBadge;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiEchartLine = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _MediaResourceCode = __webpack_require__(349);
	
	var _echartsForReact = __webpack_require__(796);
	
	var _echartsForReact2 = _interopRequireDefault(_echartsForReact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiEchartLine = function (_React$Component) {
	    _inherits(SgiEchartLine, _React$Component);
	
	    function SgiEchartLine(props) {
	        _classCallCheck(this, SgiEchartLine);
	
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiEchartLine.__proto__ || Object.getPrototypeOf(SgiEchartLine)).call(this, props));
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	
	                this.echart_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '100%', width: '100%' } },
	                _react2.default.createElement(_echartsForReact2.default, {
	                    option: this.state.echartprops
	                })
	            );
	        };
	
	        _this.state = {
	            echartprops: {
	                style: {}
	            },
	            functions: {}
	        };
	        return _this;
	    }
	
	    /**
	    * @param {父组件} parentModule
	    * @param {组件描述} moduleDesc
	    * @param {绑定实例ID} bdInst
	    * @param {对象工厂} objFct
	    * @param {make类型} type
	    */
	
	
	    _createClass(SgiEchartLine, [{
	        key: 'echart_mk',
	        value: function echart_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	            if (!moduleDesc) {
	                return;
	            }
	            this.AddechartAttribute(moduleDesc, this.state.echartprops);
	            //绑定事件
	            this.bindEvent(moduleDesc, this.state.echartprops, this.state.functions, type);
	        }
	        /**
	         * 绑定事件
	         * @param {*} moduleDesc
	         * @param {*} treeProps
	         */
	
	    }, {
	        key: 'bindEvent',
	        value: function bindEvent(moduleDesc, echartprops, functions, type) {
	            //拖拽模式 不生成事件
	            if (type == 'dnd') {
	                return;
	            }
	            var eck = moduleDesc.clkLsn; // 用户自定义点击事件
	            if (eck) {
	                var $eck = new Function("module", "objFct", eck);
	                functions.onClick = $eck;
	                echartprops.onClick = _SgiEventHandler.SgiEventHandler.onClick.bind(this);
	            }
	        }
	    }, {
	        key: 'AddechartAttribute',
	        value: function AddechartAttribute(moduleDesc, echartprops) {
	            //显示图片
	            var scId = moduleDesc.scId;
	            if (scId) {
	                var url = _MediaResourceCode.MediaResourceCode.getPrmUrl(scId);
	                if (url) {
	                    echartprops.src = url;
	                }
	            } else {
	                var disply = moduleDesc.disply;
	                if (disply) {
	                    echartprops.src = disply;
	                }
	            }
	
	            var show = moduleDesc.alt;
	            if (show) {
	                echartprops.alt = show;
	            }
	            //图片的大小设置
	            var ctlH = moduleDesc.ctlH;
	            if (ctlH) {
	                echartprops.style.height = ctlH;
	            }
	            var ctlW = moduleDesc.ctlW;
	            if (ctlW) {
	                echartprops.style.width = ctlW;
	            }
	
	            this.state.echartprops = {
	                title: {
	                    text: 'ECharts 入门示例'
	                },
	                tooltip: {},
	                xAxis: {
	                    type: 'category',
	                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
	                },
	                yAxis: {
	                    type: 'value'
	                },
	                series: [{
	                    data: [820, 932, 901, 934, 1290, 1330, 1320],
	                    type: 'line'
	                }]
	            };
	        }
	    }]);
	
	    return SgiEchartLine;
	}(_react2.default.Component);
	
	SgiEchartLine.defaultProps = {};
	SgiEchartLine.props = {};
	exports.SgiEchartLine = SgiEchartLine;
	exports.default = SgiEchartLine;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCodemirror = __webpack_require__(878);
	
	__webpack_require__(890);
	
	__webpack_require__(679);
	
	__webpack_require__(678);
	
	__webpack_require__(887);
	
	__webpack_require__(673);
	
	__webpack_require__(672);
	
	__webpack_require__(891);
	
	__webpack_require__(677);
	
	__webpack_require__(667);
	
	__webpack_require__(666);
	
	__webpack_require__(158);
	
	__webpack_require__(886);
	
	__webpack_require__(247);
	
	__webpack_require__(671);
	
	__webpack_require__(669);
	
	__webpack_require__(670);
	
	__webpack_require__(158);
	
	__webpack_require__(668);
	
	__webpack_require__(675);
	
	__webpack_require__(888);
	
	__webpack_require__(674);
	
	__webpack_require__(248);
	
	__webpack_require__(249);
	
	__webpack_require__(889);
	
	__webpack_require__(159);
	
	__webpack_require__(676);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiFormCtlComponent2 = __webpack_require__(727);
	
	var _SgiFormCtlComponent3 = _interopRequireDefault(_SgiFormCtlComponent2);
	
	var _antd = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// 导入样式
	
	// 导入语言
	
	// 导入ctrl+空格提示
	
	// 导入提示语言类型
	
	// 导入theme主题
	// import 'codemirror/theme/ambiance.css';
	
	
	var FormItem = _antd.Form.Item;
	
	var SgiFormCodeMirror = function (_SgiFormCtlComponent) {
		_inherits(SgiFormCodeMirror, _SgiFormCtlComponent);
	
		function SgiFormCodeMirror(props) {
			_classCallCheck(this, SgiFormCodeMirror);
	
			return _possibleConstructorReturn(this, (SgiFormCodeMirror.__proto__ || Object.getPrototypeOf(SgiFormCodeMirror)).call(this, props));
		}
	
		_createClass(SgiFormCodeMirror, [{
			key: '__AddInputAttribute',
			value: function __AddInputAttribute() {
				var _props = this.props,
				    parentModule = _props.parentModule,
				    moduleDesc = _props.moduleDesc,
				    bdInst = _props.bdInst,
				    objFct = _props.objFct,
				    type = _props.type;
				var inputProps = this.state.inputProps;
	
	
				var options = inputProps.options = {
					mode: 'javascript', //语言
					theme: 'monokai', //主题
					keyMap: 'sublime',
					lineNumbers: true, //显示行号  
					extraKeys: { "Ctrl": "autocomplete" }, //自动提示配置  
					lineWrapping: true, //代码折叠
					foldGutter: true,
					// showHint: true,
					// highlightSelectionMatches: true,
					highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
					// extraKeys: { "Ctrl-/": "autocomplete" },
					hintOptions: { schemaInfo: [] },
					lint: true,
					gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", 'CodeMirror.hint.javascript', 'CodeMirror.hint.coffeescript', 'CodeMirror-lint-markers'],
					matchBrackets: true, //括号匹配
					autoCloseBrackets: true, //关闭
					tabSize: 4
				};
	
				if (!moduleDesc) return;
				if (moduleDesc.cstmOptions) {
					var cstmOptions = eval('(' + moduleDesc.cstmOptions + ')');
					if (cstmOptions) {
						Object.assign(options, cstmOptions);
					}
				}
				// if (moduleDesc.mode) options.mode = moduleDesc.mode;
				// if (moduleDesc.lineSeparator) options.lineSeparator = moduleDesc.lineSeparator;
				// if (moduleDesc.theme) options.theme = moduleDesc.theme;
				// if (moduleDesc.indentUnit) options.indentUnit = moduleDesc.indentUnit;
				// if (moduleDesc.smartIndent) options.smartIndent = moduleDesc.smartIndent;
				// if (moduleDesc.tabSize) options.tabSize = moduleDesc.tabSize;
				// if (moduleDesc.indentWithTabs) options.indentWithTabs = moduleDesc.indentWithTabs;
				// if (moduleDesc.electricChars) options.electricChars = moduleDesc.electricChars;
				// if (moduleDesc.specialChars) options.specialChars = moduleDesc.specialChars;
				// if (moduleDesc.specialCharPlaceholder) options.specialCharPlaceholder = moduleDesc.specialCharPlaceholder;
				// if (moduleDesc.direction) options.direction = moduleDesc.direction;
				// if (moduleDesc.rtlMoveVisually) options.rtlMoveVisually = moduleDesc.rtlMoveVisually;
				// if (moduleDesc.keyMap) options.keyMap = moduleDesc.keyMap;
				// if (moduleDesc.extraKeys) options.extraKeys = moduleDesc.extraKeys;
				// .
				// .
				// .
				// 太多了，写不过来了
			}
		}, {
			key: '__bindEvent',
			value: function __bindEvent() {
				var _this2 = this;
	
				var _props2 = this.props,
				    parentModule = _props2.parentModule,
				    _props2$moduleDesc = _props2.moduleDesc,
				    moduleDesc = _props2$moduleDesc === undefined ? {} : _props2$moduleDesc,
				    bdInst = _props2.bdInst,
				    objFct = _props2.objFct,
				    type = _props2.type;
				var inputProps = this.state.inputProps;
				var functions = this.data.functions;
	
	
				inputProps.onBeforeChange = function (editor, data, value) {
					inputProps.value = value;
					_this2.setState({});
				};
	
				//onchange
				var chgLsn = moduleDesc.chgLsn;
				if (chgLsn) {
					var $chgLsn;
					try {
						// $chgLsn = new Function("module", "objFct", "value", "data", "editor", chgLsn);
						// $chgLsn = new Function("module", "objFct", "record", "nv", "nt", "itemData", "extra", chgLsn);
						$chgLsn = new Function("module", "objFct", "record", "nv", "data", "editor", chgLsn);
					} catch (error) {
						_sgiLogger.sgiLogger.eventErr(error);
					}
					functions.onChange = $chgLsn;
					// inputProps.onChange = (editor, data, value) => {
					// 	if ($chgLsn) $chgLsn(this, objFct, value, data, editor);
					// };
				}
				// inputProps.onChange = SgiEventHandler.onCodeMirrorChange.bind(this);
				inputProps.onChange = _SgiEventHandler.SgiEventHandler.onChange.bind(this, this);
			}
		}, {
			key: '__render',
			value: function __render() {
				// 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
				var _getReviseProps = this.getReviseProps(),
				    _inputProps = _getReviseProps._inputProps,
				    _formItemProps = _getReviseProps._formItemProps;
	
				var isLabel = _inputProps.isLabel;
	
				var cmProps = _extends({}, this.state.inputProps, _inputProps);
				if (!cmProps.className) cmProps.className = "";
				cmProps.className = "sgi-form-codemirror" + cmProps.className;
				return _react2.default.createElement(
					FormItem,
					_extends({}, this.state.formItemProps, _formItemProps),
					isLabel ? _react2.default.createElement(
						'span',
						_extends({}, this.state.inputProps, _inputProps),
						this.state.inputProps.value
					) : _react2.default.createElement(_reactCodemirror.Controlled, cmProps)
				);
			}
		}]);
	
		return SgiFormCodeMirror;
	}(_SgiFormCtlComponent3.default);
	
	exports.default = SgiFormCodeMirror;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 表单控件的基础方法，供控件继承
	 * wangz
	 * 2018.3.12
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sgiFormCtlBaseFun = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _sgiFormCtlValidator = __webpack_require__(254);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiCommon = __webpack_require__(29);
	
	var sgiFormCtlBaseFun = {
	
	    /**
	     * 初始化state属性
	     */
	    initState: function initState() {
	        //初始化state
	        this.state = {
	            validRules: {},
	            validState: true,
	            required: false,
	            loading: false,
	            isLabel: false,
	            formItemProps: {
	                style: { 'margin-bottom': "1px", 'margin-top': "1px" },
	                hasFeedback: false,
	                help: undefined,
	                validateStatus: 'success'
	                // colon: false //不显示：
	            }, //存放formItem属性
	            inputprops: {
	                style: { width: "100%" },
	                // value: undefined,  //文本框显示值 //2018.04.27-yly,有value会导致默认值无法赋值
	                disabled: false //是否可用
	            }, //存放input属性
	            functions: {}, //存放事件函数
	            _formProps: {}, //存放form属性
	            noFI: this.props.noFI //去除FormItem
	        };
	    },
	
	    /**
	    * 设置value值
	    * 刷新控件时候，调用的方法
	    */
	    setValue: function setValue(value) {
	        //更新state
	        if (value === this.state.inputprops.value) {
	            return;
	        }
	        this.state.inputprops.value = value;
	
	        //调用自定义change事件  2018.6.11追加的  //不能要了，出bug了，hanzb 2018-6-14
	        // let onChange = this.state.functions.onChange;
	        // if (onChange) {
	        //     sgiLogger.eventin('修改');
	        //     onChange(this, this.props.objFct, value, this.props.objFct.get(this.props.bdInst));
	        // }
	
	        //页面校验 刷新不校验
	        // this.validate(value);
	        this.setState({ loading: false });
	    },
	
	    /**
	    * 获取value值
	    */
	    getValue: function getValue() {
	        return this.state.inputprops.value;
	    },
	
	    /**
	     * 设置是否禁用
	     */
	    setDisabled: function setDisabled(value) {
	        this.state.inputprops.disabled = value;
	        this.setState(this.state.inputprops);
	    },
	
	    /**
	     * 设置form禁用标识
	     * @param {boolean} formDisabled form禁用标识
	     */
	    setFormDisabled: function setFormDisabled(formDisabled) {
	        this.state.inputprops.formDisabled = formDisabled;
	        this.setState(this.state.inputprops);
	    },
	
	    /**
	    * 设置是否隐藏
	    */
	    setHidden: function setHidden(value) {
	        // this.state.inputprops.hidden = value; //2018.04.25-yly,修改弹窗无法隐藏问题
	        // this.setState(this.state.inputprops);
	        if (value) {
	            this.state.formItemProps.style.display = "none";
	        } else {
	            this.state.formItemProps.style.display = undefined;
	        }
	        if ((0, _SgiCommon.testReactVsn)(this, 16)) {
	            // react16需要更新引用
	            this.state.formItemProps.style = _extends({}, this.state.formItemProps.style);
	        }
	        this.setState(this.state.formItemProps);
	    },
	
	    /**
	     * 设置是否必填
	     * @param {boolean} required 是否必填
	     */
	    setRequired: function setRequired(required) {
	        required = !!required;
	        this.state.required = required;
	        this.setState({});
	    },
	    // /**
	    // * 设置是否只读
	    // */
	    // setReadonly: function (value) {
	    //     this.state.inputprops.style.readonly = value;
	    //     this.setState(this.state.inputprops);
	    // },
	    /**
	     * 页面修改时，刷新工厂绑定的值
	     */
	    ctlRefresh: function ctlRefresh(attname, bdInst, objFct, value) {
	
	        //对象工厂的值刷新
	        this.setBindValue(attname, bdInst, objFct, value);
	        // if (bdInst && attname) {
	        //     //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	        //     //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	        //     let bdInstData;
	        //     if (this.props.type === 'tb') {
	        //         const bdInstKeyList = bdInst.split('`');
	        //         const bdInstList = objFct.get(bdInstKeyList[0]);
	        //         if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	        //             bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
	        //         }
	        //     } else {
	        //         bdInstData = objFct.get(bdInst);
	        //     }
	        //     bdInstData[attname] = value;
	        // }
	
	        //更新state
	        this.state.inputprops.value = value;
	
	        //页面校验
	        this.validate(value);
	    },
	
	    /**
	     * 仅更新工厂绑定值
	     * @param {string} attname 属性名
	     * @param {string} bdInst 绑定实例名
	     * @param {ObjFactory} objFct 对象工厂
	     * @param {object} value 值
	     */
	    setBindValue: function setBindValue(attname, bdInst, objFct, value) {
	        if (bdInst && attname) {
	            var bdInstData = void 0;
	            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	            if (typeof bdInst === "string") {
	                //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	                //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	                if (this.props.type === 'tb') {
	                    var bdInstKeyList = bdInst.split('`');
	                    var bdInstList = objFct.get(bdInstKeyList[0]);
	                    if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                        bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
	                    }
	                } else {
	                    bdInstData = objFct.get(bdInst);
	                }
	            } else {
	                bdInstData = bdInst;
	            }
	            if (bdInstData) {
	                if (RegExp(/[.|\[|\]]+/).test(attname)) {
	                    // 带层级赋值，catch避免中断
	                    try {
	                        eval("(bdInstData." + attname + " = value)");
	                    } catch (error) {
	                        _sgiLogger.sgiLogger.error("\u4FEE\u6539\u7ED1\u5B9A\u5BF9\u8C61\u65F6\uFF0C\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D[" + attname + "]");
	                        _sgiLogger.sgiLogger.eventErr(error);
	                    }
	                } else {
	                    bdInstData[attname] = value;
	                }
	            }
	            // if (bdInstData) bdInstData[attname] = value;
	        }
	    },
	
	    // 检查数据合法性
	    validate: function validate(value) {
	        if (!value) {
	            value = this.state.inputprops.value;
	        }
	        if (this.state.formItemProps.style.display == "none") {
	            this.setSuccess();
	            return false;
	        }
	        var validRules = this.state.validRules;
	        if (validRules.length === 0) {
	            this.setSuccess();
	            return false;
	        }
	
	        //var flag = true;
	        var msg = (0, _sgiFormCtlValidator.sgiFormCtlCheck)(validRules, value, { module: this, objFct: this.props.objFct });
	        if (Object.prototype.toString.call(msg) === "[object Object]") {
	            this.setValidate(msg.help, msg.validateStatus, msg.hasFeedback);
	        } else if (msg) {
	            this.setError(msg);
	        } else {
	            this.setSuccess();
	        }
	        return msg;
	    },
	    setError: function setError(msg) {
	        this.state.formItemProps.hasFeedback = true;
	        this.state.formItemProps.help = msg;
	        this.state.formItemProps.validateStatus = 'error';
	        this.setState(this.state.formItemProps);
	    },
	    setSuccess: function setSuccess() {
	        this.state.formItemProps.hasFeedback = this.state.showCheck || false;
	        this.state.formItemProps.help = undefined;
	        this.state.formItemProps.validateStatus = 'success';
	        this.setState(this.state.formItemProps);
	    },
	    // 设置组件校验(对外接口)
	    setValidate: function setValidate(message, status, hasFeedback) {
	        this.state.formItemProps.help = message;
	        this.state.formItemProps.validateStatus = status;
	        this.state.formItemProps.hasFeedback = !!hasFeedback;
	        this.setState({});
	    },
	    refresh: function refresh() {
	        this.loaded = false;
	        this.setState({ loading: false });
	    },
	    getIsLabel: function getIsLabel() {
	        // isLabel
	        var isLabel = this.state.isLabel || this.state.formIsLabel;
	
	        // 标签和非标签特殊处理
	        var _state = this.state,
	            formItemProps = _state.formItemProps,
	            validRules = _state.validRules;
	        var moduleDesc = this.props.moduleDesc;
	
	        if (isLabel) {
	            formItemProps.required = false;
	            validRules.required = false;
	        } else {
	            var alwBlk = moduleDesc.alwBlk; //是否允许为空
	            formItemProps.required = !alwBlk;
	            validRules.required = !alwBlk;
	        }
	
	        // 返回
	        return isLabel;
	    },
	    getReviseProps: function getReviseProps() {
	        var _state2 = this.state,
	            inputprops = _state2.inputprops,
	            formItemProps = _state2.formItemProps,
	            _formProps = _state2._formProps;
	
	        var isLabel = this.getIsLabel();
	        var reviseProps = {
	            _inputProps: {
	                isLabel: isLabel,
	                disabled: inputprops.disabled || inputprops.formDisabled,
	                title: inputprops.value,
	                className: inputprops.nowrap ? "sgiFormItemSpan" : undefined
	            },
	            _formItemProps: {
	                colon: isLabel || _formProps.colon //冒号
	            }
	        };
	        return reviseProps;
	    },
	
	    // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
	    renderBeforeReturn: function renderBeforeReturn() {
	        var _props = this.props,
	            parentModule = _props.parentModule,
	            moduleDesc = _props.moduleDesc,
	            objFct = _props.objFct,
	            type = _props.type;
	        var _state3 = this.state,
	            formItemProps = _state3.formItemProps,
	            inputprops = _state3.inputprops,
	            required = _state3.required;
	
	        // 自定义样式处理
	        // const getCstmStyle = this.state.cstmStyle;
	
	        var getCstmStyle = (0, _SgiCommon.getFunctionByKey)(this, "cstmStyle");;
	        var cstmStyle = {};
	        if (getCstmStyle) {
	            try {
	                cstmStyle = getCstmStyle(this, objFct) || {};
	            } catch (error) {
	                tool.sgiLogger.log(error);
	            }
	        }
	        for (var key in cstmStyle) {
	            if (key.toLowerCase() === "formItemStyle".toLowerCase() || key.toLowerCase() === "formItemProps".toLowerCase()) {
	                Object.assign(formItemProps.style, cstmStyle[key] || {}); //formTtem样式
	            } else if (key.toLowerCase() === "inputStyle".toLowerCase() || key.toLowerCase() === "inputProps".toLowerCase()) {
	                Object.assign(inputprops.style, cstmStyle[key] || {}); //input样式
	            } else {
	                this.state[key] = cstmStyle[key]; //其他样式，富文本等的其他样式
	            }
	        }
	
	        // 必填属性处理
	        formItemProps.required = required;
	        this.state.validRules.required = required;
	    }
	};
	exports.sgiFormCtlBaseFun = sgiFormCtlBaseFun;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 表单控件的maker的公共方法
	 * wangz
	 * 2018.3.9
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddFormCtlCommonAttribute = exports.setFormCtlLayout = exports.bindEvent = exports.bindValue = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 绑定显示值
	 * @param {描述信息} currentModule
	 * @param {描述信息} moduleDesc
	 * @param {数据} bdInst
	 * @param {对象工厂} objFct
	 * @param {属性} formItem
	 * @param {属性} inputprops
	 */
	var bindValue = function bindValue(currentModule, moduleDesc, bdInst, objFct, formItem, inputprops, checked) {
	
	    if (!moduleDesc.c) {
	        return;
	    }
	
	    //currentModule.bdInst = bdInst;
	    var attname = moduleDesc.c;
	    currentModule.state.attname = attname;
	
	    var bdInstValue;
	    if (!bdInst || !objFct) return;
	
	    if (typeof bdInst === "string") {
	        //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
	        //通过type区分，type==tb时候为表格控件，其他时候为普通控件
	        if (currentModule.props.type === 'tb') {
	            var bdInstKeyList = bdInst.split('`');
	            var bdInstList = objFct.get(bdInstKeyList[0]);
	            if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
	                bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
	            }
	        } else {
	            bdInstValue = objFct.get(bdInst);
	        }
	    } else {
	        bdInstValue = bdInst;
	    }
	
	    // 带点./[/]解析
	    var evalFlg = RegExp(/[.|\[|\]]+/).test(attname);
	    var valueFlg = evalFlg && eval('(bdInstValue.' + attname + ')') !== undefined;
	
	    if (bdInstValue && (bdInstValue[attname] !== undefined || valueFlg)) {
	        //2018.04.27-yly,有value会导致默认值无法赋值
	        var value = void 0;
	        if (evalFlg) {
	            // 带层级解析，catch防止中断
	            try {
	                value = eval('(bdInstValue.' + attname + ')');
	            } catch (error) {
	                _sgiLogger.sgiLogger.error('\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D' + attname);
	                _sgiLogger.sgiLogger.eventErr(error);
	            }
	        } else value = bdInstValue[attname];
	        //给checkbox 使用
	        if (checked) {
	            var _checked = value ? true : false;
	            var _escape = currentModule.state.escape;
	            if (_escape) {
	                //转义
	                var escs = _escape.split("/");
	                _checked = value === escs[0];
	            }
	            inputprops.checked = _checked;
	            inputprops.value = value;
	        } else {
	            inputprops.value = value;
	        }
	    } else {
	        //20180704 wzhe 默认值 给当前value
	        inputprops.value = inputprops.defaultValue;
	        if (bdInstValue) {
	            if (evalFlg) {
	                // 带层级解析，catch防止中断
	                try {
	                    eval('(bdInstValue.' + attname + ' = inputprops.defaultValue)');
	                } catch (error) {
	                    _sgiLogger.sgiLogger.error('\u5C5E\u6027\u540D\u89E3\u6790\u51FA\u9519\uFF0C\u5F53\u524D\u5C5E\u6027\u540D' + attname);
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	            } else bdInstValue[attname] = inputprops.defaultValue;
	        }
	    }
	
	    // if (bdInstValue && bdInstValue[attname]) {//2018.04.27-yly,有value会导致默认值无法赋值
	    //     //给checkbox 使用
	    //     if (checked) {
	    //         // inputprops.checked = bdInstValue[attname] ? true : false;
	    //         let value = bdInstValue[attname];
	    //         let checked = value ? true : false;
	    //         let escape = currentModule.state.escape;
	    //         if (escape) {//转义
	    //             let escs = escape.split("/");
	    //             checked = (value === escs[0]);
	    //         }
	    //         inputprops.checked = checked;
	    //         inputprops.value = value;
	    //     } else {
	    //         inputprops.value = bdInstValue[attname];
	    //     }
	    // } else {//20180704 wzhe 默认值 给当前value
	    //     inputprops.value = inputprops.defaultValue;
	    //     if (bdInstValue) {
	    //         bdInstValue[attname] = inputprops.defaultValue;
	    //     }
	    // }
	};
	
	/**
	 * 属性转换
	 * @param {描述信息} currentModule
	 * @param {描述信息} moduleDesc
	 * @param {属性} formItem
	 * @param {属性} inputprops
	 */
	var AddFormCtlCommonAttribute = function AddFormCtlCommonAttribute(currentModule, moduleDesc, formItem, inputprops) {
	    // label样式回显
	    var isLabel = moduleDesc.isLabel;
	    currentModule.state.isLabel = !!isLabel;
	    if (isLabel) formItem.colon = true; // 显示冒号
	
	    var cId = moduleDesc.cId; //cid 唯一标示
	    if (cId) inputprops.id = (0, _SgiCommon.getConstByKey)(currentModule, cId);
	
	    var isDis = moduleDesc.isDis; //是否可用
	    inputprops.disabled = isDis;
	
	    var isRead = moduleDesc.isRead; //是否只读
	    // inputprops.style.readonly = 'expression(this.readonly = true)';
	    inputprops.readOnly = !!isRead;
	
	    if (moduleDesc.te || moduleDesc.teid) {
	        //避免不必要的执行getTRByPrm()方法
	        var text = _Resource.Resource.getTRByPrm(moduleDesc).te; //设置标签
	        if (text) formItem.label = text;
	    }
	
	    var ctlW = moduleDesc.ctlW; //控件宽度
	    // if (ctlW) formItem.style.width = ctlW;
	
	    var ctlH = moduleDesc.ctlH; //控件高度
	    if (ctlH) {
	        formItem.style.height = ctlH;
	        inputprops.style.height = ctlH; //输入框也随着高度变动
	    } else {
	        formItem.style.height = undefined; //编辑的时候即时刷新，也可以不加
	        inputprops.style.height = undefined; //编辑的时候即时刷新，也可以不加
	    }
	
	    var lblW = moduleDesc.lblW; //设置标签宽度
	
	    if (ctlW && lblW) {
	        var lblWSpan = parseInt(lblW / ctlW * 24);
	        var wrapperSpan = 24 - lblWSpan;
	        formItem.labelCol = { span: lblWSpan };
	        formItem.wrapperCol = { span: wrapperSpan };
	    } else {
	        formItem.labelCol = { span: 6 };
	        formItem.wrapperCol = { span: 18 };
	    }
	
	    var isLbl = moduleDesc.isLbl; //设置是否隐藏标签
	    if (isLbl) {
	        formItem.label = undefined;
	        formItem.labelCol = { span: 0 };
	        formItem.wrapperCol = { span: 24 };
	    }
	
	    var inpPopTe = moduleDesc.inpPopTe; //提示内容
	    if (inpPopTe) inputprops.placeholder = (0, _SgiCommon.getConstByKey)(currentModule, inpPopTe);
	
	    var defVal10 = moduleDesc.defVal10; //默认内容
	    if (defVal10 !== undefined) inputprops.defaultValue = defVal10; //数字控件是可以有0的，所以别用!判定
	
	    var bdText = moduleDesc.bdText; //后置内容
	    if (bdText) inputprops.addonAfter = bdText;
	
	    var alwBlk = moduleDesc.alwBlk; //是否允许为空
	    formItem.required = !alwBlk;
	    currentModule.state.validRules.required = !alwBlk;
	    currentModule.state.required = !alwBlk;
	    if (isLabel) {
	        //仅回显状态不校验
	        formItem.required = false;
	        currentModule.state.validRules.required = false;
	        currentModule.state.required = false;
	    }
	    // if (!alwBlk) {
	    //     formItem.required = !alwBlk;
	    //     currentModule.state.validRules.required = !alwBlk;
	    // } else {
	    //     formItem.required = !alwBlk;
	    //     currentModule.state.validRules.required = !alwBlk;
	    // }
	
	    if (moduleDesc.vldC) currentModule.state.validRules.dataType = moduleDesc.vldC;
	
	    var maxL = moduleDesc.maxL; //设置字段输入的最大长度
	    if (maxL) currentModule.state.validRules.maxL = maxL;else currentModule.state.validRules.maxL = undefined;
	    var minL = moduleDesc.minL; //设置字段输入的最小长度
	    if (minL) currentModule.state.validRules.minL = minL;else currentModule.state.validRules.minL = undefined;
	
	    var vldC = moduleDesc.vldC;
	    if (vldC && (vldC === "int" || vldC === "double" || vldC === "money" || vldC === "number")) {
	        var maxV = moduleDesc.maxV; //设置字段输入的最大值
	        if (maxV) currentModule.state.validRules.maxV = maxV;else currentModule.state.validRules.maxV = undefined;
	        var minV = moduleDesc.minV; //设置字段输入的最小值
	        if (minV) currentModule.state.validRules.minV = minV;else currentModule.state.validRules.minV = undefined;
	    }
	
	    var isHdn = moduleDesc.isHdn; //是否隐藏
	    if (isHdn) {
	        formItem.style.display = "none";
	    } else {
	        formItem.style.display = undefined;
	    }
	
	    inputprops.nowrap = !!moduleDesc.nowrap;
	
	    // form属性
	    currentModule.state._formProps = moduleDesc._formProps || {};
	
	    var lblAlg = moduleDesc.lblAlg; //设置标签对齐方式??没实现
	    var isClp = moduleDesc.isClp; //设置是否根据内容字段进行伸展和收缩??没实现
	    var msfTgt = moduleDesc.msfTgt; //设置错误信息提示位置??没实现
	
	    // var prefix = moduleDesc.prefix;//前缀图
	    // if (prefix) inputprops.prefix = prefix;
	
	    // 自定义样式
	    var cstmStyle = moduleDesc.cstmStyle;
	    var $cstmStyle = void 0;
	    if (cstmStyle) {
	        try {
	            $cstmStyle = new Function("module", "objFct", cstmStyle);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        // currentModule.state.cstmStyle = $cstmStyle;
	        (0, _SgiCommon.setFunction)(currentModule, "cstmStyle", $cstmStyle);
	    }
	
	    currentModule.state.showCheck = moduleDesc.showCheck;
	
	    // 自定义校验规则
	    var cstmValid = moduleDesc.cstmValid;
	    var $cstmValid = void 0;
	    if (cstmValid) {
	        try {
	            $cstmValid = new Function("module", "objFct", "value", cstmValid);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        currentModule.state.validRules.cstmValid = $cstmValid;
	    }
	};
	
	/**
	 * 设置布局
	 * @param {描述信息} moduleDesc
	 * @param {属性} formItem
	 * @param {属性} inputprops
	 */
	var setFormCtlLayout = function setFormCtlLayout(moduleDesc, formItem, inputprops) {};
	
	/**
	 * 事件转换
	 * @param {描述信息} currentModule
	 * @param {描述信息} moduleDesc
	 * @param {对象工厂} objFct
	 * @param {属性} inputprops
	 */
	var bindEvent = function bindEvent(currentModule, moduleDesc, objFct, inputprops, functions, type) {
	
	    //拖拽模式 不生成事件
	    if (type == 'dnd') {
	        return;
	    }
	
	    //onchange
	    var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
	    if (chgLsn) {
	        var $chgLsn;
	        try {
	            $chgLsn = new Function("module", "objFct", "record", "nv", "nt", "itemData", "extra", chgLsn);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        functions.onChange = $chgLsn;
	    }
	    inputprops.onChange = _SgiEventHandler.SgiEventHandler.onChange.bind(this, currentModule);
	
	    //onFocus
	    var inLsn = moduleDesc.inLsn; // 用户自定义点击事件
	    if (inLsn) {
	        var $inLsn;
	        try {
	            $inLsn = new Function("module", "objFct", inLsn);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        functions.onFocus = $inLsn;
	        inputprops.onFocus = _SgiEventHandler.SgiEventHandler.onFocus.bind(this, currentModule);
	    }
	
	    //onBlur
	    var lveLsn = moduleDesc.lveLsn; // 用户自定义点击事件
	    if (lveLsn) {
	
	        var $lveLsn;
	        try {
	            $lveLsn = new Function("module", "objFct", lveLsn);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        functions.onBlur = $lveLsn;
	        inputprops.onBlur = _SgiEventHandler.SgiEventHandler.onBlur.bind(this, currentModule);
	    }
	
	    // 自定义渲染组件
	    var cstmRender = moduleDesc.cstmRender;
	    if ((0, _sgiCommon.funStrCheck)(cstmRender)) {
	        var $cstmRender = void 0;
	        try {
	            $cstmRender = new Function("module", "inputprops", "value", "objFct", cstmRender);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        functions.cstmRender = $cstmRender;
	    }
	
	    // //onInput
	    // inputprops.onInput = function() {
	    //     message.info('获取焦点事件');
	    // }
	    // //点击事件
	    // inputprops.onClick = function () {
	    //     message.info('点击事件');
	    // }
	    // //双击事件
	    // inputprops.onDoubleClick = function () {
	    //     message.info('双击事件');
	    // }
	    // //onCopy
	    // inputprops.onCopy = function () {
	    //     message.info('复制事件');
	    // }
	    // //onCut
	    // inputprops.onCut = function () {
	    //     message.info('剪切事件');
	    // }
	    // //onPaste
	    // inputprops.onPaste = function () {
	    //     message.info('粘贴事件');
	    // }
	};
	exports.bindValue = bindValue;
	exports.bindEvent = bindEvent;
	exports.setFormCtlLayout = setFormCtlLayout;
	exports.AddFormCtlCommonAttribute = AddFormCtlCommonAttribute;
	exports.default = { bindValue: bindValue, bindEvent: bindEvent, setFormCtlLayout: setFormCtlLayout, AddFormCtlCommonAttribute: AddFormCtlCommonAttribute };

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	/**
	 * 表单控件的校验的公共方法
	 * wangz 
	 * 2018.3.9
	 */
	
	"use strict";
	
	// 校验规则
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function FormVerify() {
	    // 1 代表 2009-09-30 , 2 代表 2009/09/30 , 3 代表 20090930 , 4 代表 2009年09月30日
	    this.regDate3 = /^[1-2]\d{6,7}$/;
	    this.regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
	    this.regPhone = /^((\(\d{1,5}\))|(\d{1,5}\-))?(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?$/;
	    this.regPhones = /^(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?([,|;](\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?)*$/;
	    this.regMobile = /^((\(\d{3}\))|(\d{3}\-))?1[1-9]\d{9}$/;
	    this.regUrl = /^http:\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/; //';
	    this.className = /^([_a-z0-9]+\.)*[A-Z][_A-Za-z0-9]+$/;
	    this.regIdCard15 = /^\d{15}(\d{2}[A-Za-z0-9])?$/;
	    this.regIdCard18 = /^\d{17}(?:\d|x|X)$/;
	    this.regMoney = /^[-\+]?\d+(\.\d{0,2})?$/;
	    this.regNumber = /^\d+$/;
	    this.regZip = /^[0-9]\d{5}$/;
	    this.regQQ = /^[1-9]\d{3,9}$/;
	    this.regInteger = /^[-\+]?\d+$/;
	    this.regDouble = /^[-\+]?\d+(\.\d+)?$/;
	    this.regEnglish = /^[A-Za-z]+$/;
	    this.regEnglish2 = /^[A-Za-z\s]+$/;
	    this.regChinese = /^[\u0391-\uFFE5]+$/;
	    this.regUnSafe = /^(([A-Z]*|[a-z]*|\d*|[-_\~!@#\$%\^&\*\.\(\)\[\]\{\}<>\?\\\/\'\"]*)|.{0,5})$|\s/; //';
	    this.regNotChar = /^[^`~!@#$%^&*()+=|\\\][\]\{\}:;'\,.<>/?]{1}[^`~!@$%^&()+=|\\\][\]\{\}:;'\,.<>?]{0,19}$/;
	    this.regChar = /[(\/)(\\)(')(")(<)(>)]/g; //';
	};
	
	var FormVerifyObj = new FormVerify();
	
	// required，max,min,dataType,pattern,patternPrompt,validator
	function sgiFormCtlCheck(rule, value, parameters) {
	    var isEmpty = value === '' || value === null || typeof value === "undefined";
	    //校验是否为空
	    if (rule.required === true) {
	        if (isEmpty) {
	            return '请输入,不允许为空';
	        }
	    }
	
	    if (isEmpty) {
	        return '';
	    }
	
	    //校验最长最小输入
	    if (rule.maxL > 0) {
	        // if (typeof rule.maxL === "number") {
	        if (value.length > rule.maxL) {
	            return '最多输入【' + rule.maxL + '】个字符';
	        }
	    }
	    if (rule.minL > 0) {
	        // if (typeof rule.minL === "number") {
	        if (value.length < rule.minL) {
	            return '至少输入【' + rule.minL + '】个字符';
	        }
	    }
	    //校验最大最小值
	    // if (rule.maxV > 0) {
	    if (typeof rule.maxV === "number") {
	        if (parseFloat(value) > rule.maxV) {
	            return '最大值【' + rule.maxV + '】';
	        }
	    }
	    // if (rule.minV > 0) {
	    if (typeof rule.minV === "number") {
	        if (parseFloat(value) < rule.minV) {
	            return '最小值【' + rule.minV + '】';
	        }
	    }
	
	    //常用类型校验
	    if (rule.dataType !== '' && rule.dataType !== null && typeof rule.dataType !== "undefined") {
	        var msg = _checkDataType(value, rule.dataType);
	        if (msg !== '' && msg !== null && typeof msg !== "undefined") {
	            return msg;
	        }
	    }
	
	    //自定义校验方法
	    if (rule.validator !== '' && rule.validator !== null && typeof rule.validator !== "undefined") {
	        var msg = rule.validator(value, rule, page);
	        if (msg !== '' && msg !== null && typeof msg !== "undefined") {
	            return msg;
	        }
	    }
	
	    // 自定义校验
	    if (rule.cstmValid && typeof rule.cstmValid === "function") {
	        try {
	            tool.sgiLogger.log("自定义校验");
	            var module = parameters.module,
	                objFct = parameters.objFct;
	
	            return rule.cstmValid(module, objFct, value);
	        } catch (error) {
	            tool.sgiLogger.error("custom verification error :", error);
	        }
	    }
	
	    return '';
	}
	
	// 检查域的有效性
	function _checkDataType(str, dataType) {
	    for (var x = _isValidMethod.length - 1; x >= 0; x--) {
	        var c = _isValidMethod[x];
	        if (c.type == dataType) {
	            return c.isValid(str);
	        }
	    }
	
	    return '未知的数据类型[' + dataType + ']';
	};
	
	// 有效性函数
	// isValid=检查数据有效性
	// checkValid=检查数据是否越界
	var _isValidMethod = [{
	    type: 'int',
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regInteger.test(str) == false) return "请输入整数!";
	    }
	}, {
	    type: 'double',
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regDouble.test(str) == false) return "请输入Double数据，比如：55.069!";
	    }
	}, {
	    type: 'money',
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regMoney.test(str) == false) return "请输入金额，比如：2355.00!";
	    }
	}, {
	    type: "email",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regEmail.test(str) == false) return "请输入电子邮件地址!";
	    }
	}, {
	    type: "idcard",
	    isValid: isIdCard
	}, {
	    type: "idcard18",
	    isValid: isIdCard
	}, {
	    type: "phone",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regPhone.test(str) == false) return "请输入电话号码!";
	    }
	}, {
	    type: "phones",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regPhones.test(str) == false) return "请输入电话号码，[,]分割!";
	    }
	}, {
	    type: "mobile",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regMobile.test(str) == false) return "请输入手机号码!";
	    }
	}, {
	    type: "zip",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regZip.test(str) == false) return "请输入六位数字的邮政编码!";
	    }
	}, {
	    type: "url",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regUrl.test(str.toLowerCase()) == false) return "请输入HTTP地址!";
	    }
	}, {
	    type: "classname",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.className.test(str) == false) return "请输入有效的类名称!";
	    }
	}, {
	    type: "qq",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regQQ.test(str) == false) return "请输入QQ号!";
	    }
	}, {
	    type: "number",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regNumber.test(str) == false) return "请输入数字!";
	    }
	}, {
	    type: "汉字",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regChinese.test(str) == false) return "请输入汉字!";
	    }
	}, {
	    type: "字母",
	    isValid: function isValid(str) {
	        if (FormVerifyObj.regEnglish2.test(str) == false) return "请输入字母或空格!";
	    }
	}];
	
	// 检测身份证号码输入的合法性	15位或者18位的数字
	function isIdCard(str) {
	    if (str.length != 18 && str.length != 15) return "请输入有效的身份证号码!";
	    var reg = str.length == 18 ? FormVerifyObj.regIdCard18 : FormVerifyObj.regIdCard15;
	    if (reg.test(str) == false) {
	        return "请输入有效的身份证号码!";
	    }
	
	    // 日期
	    var y = '';
	    var m = '';
	    var d = '';
	    if (str.length == 18) {
	        y = str.substr(6, 4);
	        m = str.substr(10, 2);
	        d = str.substr(12, 2);
	    } else if (str.length == 15) {
	        y = "19" + str.substr(6, 2);
	        m = str.substr(8, 2);
	        d = str.substr(10, 2);
	    }
	
	    if (checkYearMonthDay(y, m, d) == false) {
	        return "日期的取值范围不正确!";
	    }
	
	    // 强制检查身份证的校验位
	    var checkValue = strictCheckIdcard(str);
	    if (checkValue != null) {
	        return "请输入有效的身份证号码!";
	    }
	};
	
	// 检查日期中年月日的合法性
	function checkYearMonthDay(years, months, days) {
	    var reg = /^\d+$/;
	
	    //处理年
	    if (years.length != 4 || years == 0) return false;
	    if (!reg.test(years)) return false;
	
	    var leapyear = parseInt(years) % 4 == 0 && parseInt(years) % 100 != 0 || parseInt(years) % 400 == 0;
	
	    //处理月
	    if (!months || months == 0) return false;
	    if (!reg.test(months)) return false;
	    var mon = parseInt(months, 10);
	    if (mon > 12) return false;
	
	    //处理日
	    if (!days || days == 0) return false;
	    if (!reg.test(days)) return false;
	
	    var mdays = [29, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	    if (mon == 2 && leapyear) mon = 0;
	    if (days > mdays[mon]) return false;
	
	    return true;
	};
	
	// 严格检查身份证的有效性
	function strictCheckIdcard(id) {
	    // 只检查18位身份证
	    if (id.length != 18) {
	        return null;
	    }
	
	    var checkValue = getIdCheckNumber(id);
	    var iv = id.substring(17).toUpperCase();
	    if (checkValue != iv) {
	        return checkValue;
	    }
	
	    return null;
	};
	
	function getIdCheckNumber(id) {
	    var arrVerifyCode = "1,0,X,9,8,7,6,5,4,3,2".split(",");
	    var wi = "7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2".split(",");
	
	    var checkNumber = 0;
	    for (var i = 0; i < 17; i++) {
	        checkNumber = checkNumber + parseInt(id.substring(i, i + 1)) * wi[i];
	    }
	
	    var modValue = checkNumber % 11;
	    var checkValue = arrVerifyCode[modValue];
	
	    return checkValue;
	};
	
	exports.sgiFormCtlCheck = sgiFormCtlCheck;
	exports.default = { sgiFormCtlCheck: sgiFormCtlCheck };

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1997);
	
	var _jsoneditorMin = __webpack_require__(1291);
	
	var _jsoneditorMin2 = _interopRequireDefault(_jsoneditorMin);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiCtlComponent2 = __webpack_require__(161);
	
	var _SgiCtlComponent3 = _interopRequireDefault(_SgiCtlComponent2);
	
	var _SgiEventHandler = __webpack_require__(54);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiJsoneditor = function (_SgiCtlComponent) {
	    _inherits(SgiJsoneditor, _SgiCtlComponent);
	
	    function SgiJsoneditor(props) {
	        _classCallCheck(this, SgiJsoneditor);
	
	        var _this = _possibleConstructorReturn(this, (SgiJsoneditor.__proto__ || Object.getPrototypeOf(SgiJsoneditor)).call(this, props));
	
	        _this.__render = function () {
	            return _react2.default.createElement('div', _extends({ id: _this.state.dvId }, _this.state._props));
	        };
	
	        _this.refresh = function () {
	            var bdInst = _this.state.insName;
	            var objFct = _this.props.objFct;
	            var data = bdInst && objFct ? objFct.get(bdInst) : null;
	            _this.refreshByData(data);
	        };
	
	        _this.getJson = function () {
	            return _this.state.editor.get();
	        };
	
	        _this.getText = function () {
	            return _this.state.editor.getText();
	        };
	
	        _this.setJson = function (json) {
	            return _this.state.editor.set(json);
	        };
	
	        _this.setText = function (text) {
	            return _this.state.editor.setText(text);
	        };
	
	        _this.state = _extends({}, _this.state, {
	            dvId: (0, _sgiCommon.uuidDate)(6, "yyyyMMddhhmmssSSS"),
	            data: _this.props.data,
	            options: {},
	            inOutType: "json" //输入输出类型，string|json
	        });
	        return _this;
	    }
	
	    // 转换自身属性
	
	
	    _createClass(SgiJsoneditor, [{
	        key: '__AddAttribute',
	        value: function __AddAttribute() {
	            var _props2 = this.props,
	                parentModule = _props2.parentModule,
	                moduleDesc = _props2.moduleDesc,
	                objFct = _props2.objFct,
	                type = _props2.type;
	
	
	            if (!moduleDesc) return;
	
	            this.state.dvId = (0, _SgiCommon.getConstByKey)(this, moduleDesc.cId) || this.state.dvId || (0, _sgiCommon.uuidDate)(6, "yyyyMMddhhmmssSSS");
	            this.state.inOutType = moduleDesc.inOutType || this.state.inOutType;
	
	            var options = this.state.options = {};
	            for (var key in moduleDesc) {
	                if (key.substr(0, 4) === "opt_" && moduleDesc[key] !== undefined) {
	                    options[key.substring(4)] = moduleDesc[key];
	                }
	            }
	
	            // 取data
	            var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
	            this.state.insName = bdInst;
	            if (bdInst && objFct) this.state.data = objFct.get(bdInst);
	
	            // 自定义option
	            var getOption = moduleDesc.options;
	            var $getOption = void 0;
	            if (getOption) {
	                try {
	                    $getOption = new Function("module", "objFct", getOption);
	                    if ($getOption) {
	                        var cstmOptions = $getOption(this, objFct);
	                        if (cstmOptions) Object.assign(options, cstmOptions);
	                    }
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	            }
	        }
	
	        // 绑定事件
	
	    }, {
	        key: '__bindEvent',
	        value: function __bindEvent() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                parentModule = _props3.parentModule,
	                moduleDesc = _props3.moduleDesc,
	                bdInst = _props3.bdInst,
	                objFct = _props3.objFct,
	                type = _props3.type;
	            var _state = this.state,
	                _props = _state._props,
	                _class = _state._class,
	                options = _state.options,
	                insName = _state.insName,
	                inOutType = _state.inOutType;
	            var functions = this.data.functions;
	
	            // options.onChange = SgiEventHandler.onJsoneditorChange.bind(this, this.state.editor);
	
	            options.onChange = function () {
	                var editor = _this2.state.editor;
	                var json = editor.get();
	                var text = editor.getText();
	                _this2.state.data = inOutType === "string" ? text : json;
	                if (insName && objFct) objFct.set(insName, inOutType === "string" ? text : json);
	                _SgiEventHandler.SgiEventHandler.onJsoneditorChange.call(_this2, _this2.state.editor, text, json);
	            };
	
	            if (!moduleDesc || type == 'dnd') return;
	
	            //onchange
	            var chgLsn = moduleDesc.chgLsn; // 用户自定义修改事件
	            if (chgLsn) {
	                var $chgLsn;
	                try {
	                    $chgLsn = new Function("module", "editor", "objFct", "text", "json", chgLsn);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                functions.onChange = $chgLsn;
	            }
	        }
	
	        // 渲染
	
	    }, {
	        key: 'refreshByData',
	        value: function refreshByData(data) {
	            this.state.data = data;
	            if (typeof data === "string") this.state.editor.setText(data);else this.state.editor.set(data);
	        }
	
	        // 暴露主要接口
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var container = document.getElementById(this.state.dvId);
	            var options = this.state.options;
	            var data = this.state.data;
	            if (typeof data === "string") data = JSON.parse(data);
	            var editor = new _jsoneditorMin2.default(container, options, data);
	            this.state.editor = editor;
	        }
	    }]);
	
	    return SgiJsoneditor;
	}(_SgiCtlComponent3.default);
	
	exports.default = SgiJsoneditor;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiMainComp = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { text_mk } from '../common/UBCtlMaker';
	var FormItem = _antd.Form.Item;
	
	var SgiMainComp = function (_React$Component) {
	    _inherits(SgiMainComp, _React$Component);
	
	    function SgiMainComp(props) {
	        _classCallCheck(this, SgiMainComp);
	
	        // var bdInst = this.props.moduleDesc.bdInst;
	        var _this = _possibleConstructorReturn(this, (SgiMainComp.__proto__ || Object.getPrototypeOf(SgiMainComp)).call(this, props));
	
	        _this.createSonComp = function () {
	
	            tool.sgiLogger.log(22222222222222222222);
	
	            //获取当前需要打开的页面信息
	            var routerState = this.props.location.state;
	            var uid = routerState.uid;
	
	            //临时数据 测试用 后期获取uid属性
	            var field1 = { addonBefore: "前置1", addonAfter: "后置1", defaultValue: "", disabled: false, placeholder: "提示1", width: 200 };
	            var field2 = { addonBefore: "前置2", addonAfter: "后置2", defaultValue: "", disabled: false, placeholder: "提示2", width: 200 };
	            var fieldArray = [];
	            var fromArray = [];
	            if (uid == 'router1') {
	                // fieldArray.push(text_mk({}, field1));
	                fromArray.push(_react2.default.createElement(
	                    _antd.Form,
	                    null,
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        '\u6211\u662FForm1'
	                    ),
	                    fieldArray
	                ));
	            } else if (uid == 'router2') {
	                // fromArray.push(<Form><h1>我是Form1</h1>{text_mk({}, field1)}{text_mk({}, field2)}</Form>);
	            } else if (uid == 'router3') {
	                // fromArray.push(<Form><h1>我是Form1</h1>{text_mk({}, field1)}</Form>);
	                // fromArray.push(<Form><h1>我是Form2</h1>{text_mk({}, field1)}</Form>);
	            }
	            return fromArray;
	        };
	
	        _this.render = function () {
	            var sonComp = this.createSonComp();
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    '\u6211\u662F\u4E3BMKMain'
	                ),
	                sonComp
	            );
	        };
	
	        _this.componentWillMount = function () {
	            tool.sgiLogger.log("componentWillMount");
	        };
	
	        _this.componentDidMount = function () {
	            tool.sgiLogger.log("componentDidMount");
	        };
	
	        _this.componentWillReceiveProps = function () {
	            tool.sgiLogger.log("componentWillReceiveProps");
	        };
	
	        _this.shouldComponentUpdate = function () {
	            tool.sgiLogger.log("shouldComponentUpdate");
	            return true;
	        };
	
	        _this.componentWillUpdate = function () {
	            tool.sgiLogger.log("componentWillUpdate");
	        };
	
	        _this.componentDidUpdate = function () {
	            tool.sgiLogger.log("componentDidUpdate");
	        };
	
	        _this.componentWillUnmount = function () {
	            tool.sgiLogger.log("componentWillUnmount");
	        };
	
	        _this.state = {};
	        // if (bdInst) {
	        //     this.state[bdInst] = {};
	        // }
	        return _this;
	    }
	
	    //根据描述组装子对象
	
	
	    //渲染并返回一个虚拟DOM
	
	
	    //render之前调用，业务逻辑都应该放在这里，如对state的操作等
	
	
	    //该方法发生在render方法之后。在该方法中，ReactJS会使用render生成返回的虚拟DOM对象来创建真实的DOM结构
	
	
	    //3.更新阶段
	
	
	    //是否需要更新
	
	
	    //将要更新
	
	
	    //更新完毕
	
	
	    //4.销毁阶段
	
	
	    return SgiMainComp;
	}(_react2.default.Component);
	
	exports.SgiMainComp = SgiMainComp;
	exports.default = SgiMainComp;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _antd = __webpack_require__(18);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SgiCtlComponent2 = __webpack_require__(161);
	
	var _SgiCtlComponent3 = _interopRequireDefault(_SgiCtlComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiPassword = function (_SgiCtlComponent) {
		_inherits(SgiPassword, _SgiCtlComponent);
	
		function SgiPassword(props) {
			_classCallCheck(this, SgiPassword);
	
			var _this = _possibleConstructorReturn(this, (SgiPassword.__proto__ || Object.getPrototypeOf(SgiPassword)).call(this, props));
	
			_this._onInput = function (e) {
				var showVals = e.target.value.split("");
				var hideVals = _this.data.realVal.split("");
				var start = e.target.selectionStart;
				var length = Math.abs(_this.data.selectionEnd - _this.data.selectionStart);
				if (length == 0) {
					if (showVals.length < hideVals.length) {
						hideVals.splice(start, 1);
					} else {
						hideVals.splice(start - 1, 0, showVals[start - 1]);
					}
				} else {
					if (showVals.length < hideVals.length) {
						hideVals.splice(start, length);
					} else {
						hideVals.splice(start - 1, length, showVals[start - 1]);
					}
				}
				var showVal = "";
				var maskChar = _this.data.maskChar;
				for (var i = 0; i < showVals.length; i++) {
					showVal += maskChar;
				}
				e.target.value = showVal;
				_this.data.realVal = hideVals.join("");
	
				e.target.selectionEnd = start;
	
				// 真值回调
				if (_this.props.realVal && typeof _this.props.realVal === "function") {
					_this.props.realVal(_this.data.realVal);
				}
			};
	
			_this._onKeydown = function (e) {
				_this.data.selectionStart = e.target.selectionStart;
				_this.data.selectionEnd = e.target.selectionEnd;
			};
	
			_this.render = function () {
				return _react2.default.createElement(_antd.Input, _extends({}, _this.props, { onKeyDown: _this._onKeydown, onInput: _this._onInput }));
			};
	
			_this.state = {};
			_this.data = _extends({}, _this.data, {
				maskChar: _this.props.maskChar || "●",
				selectionStart: 0,
				selectionEnd: 0,
				realVal: ""
			});
			return _this;
		}
	
		return SgiPassword;
	}(_SgiCtlComponent3.default);
	
	exports.default = SgiPassword;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiProgress = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _moment = __webpack_require__(40);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	// import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm';
	
	// import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun";
	
	var SgiProgress = function (_React$Component) {
	    _inherits(SgiProgress, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiProgress(props) {
	        _classCallCheck(this, SgiProgress);
	
	        //初始化state属性
	        // this.initState();
	        var _this = _possibleConstructorReturn(this, (SgiProgress.__proto__ || Object.getPrototypeOf(SgiProgress)).call(this, props));
	
	        _this.render = function () {
	            return _react2.default.createElement(_antd.Progress, this.state.inputprops);
	        };
	
	        _this.state = {
	            inputprops: {
	                style: { width: "100%" }
	            } //存放input属性
	        };
	        var _this$props = _this.props,
	            parentModule = _this$props.parentModule,
	            moduleDesc = _this$props.moduleDesc,
	            bdInst = _this$props.bdInst,
	            objFct = _this$props.objFct,
	            type = _this$props.type;
	        //组装属性 初始化属性到this.state
	
	        _this.progress_mk(parentModule, moduleDesc, bdInst, objFct, type);
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiProgress, [{
	        key: 'progress_mk',
	        value: function progress_mk(parentModule, moduleDesc, bdInst, workspace, type) {
	
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.inputprops);
	            //转换form公共属性
	            // AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            // setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            // bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            // bindValue(this, moduleDesc, bdInst, this.state.formItemProps, this.state.inputprops);
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, inputprops) {
	            var percent = moduleDesc.percent; //百分比
	            if (percent) inputprops.percent = percent;
	
	            var status = moduleDesc.status; //status 状态，可选：success exception active
	            if (status) inputprops.status = status;
	
	            var showInfo = moduleDesc.showInfo; // 是否显示进度数值或状态图标
	            if (showInfo) inputprops.showInfo = showInfo;
	
	            var type = moduleDesc.type; // 类型，可选 line circle dashboard
	            if (type) inputprops.type = type;
	
	            // var size = moduleDesc.size; //线型大小，不好用
	            // if (size) inputprops.size = size;
	
	            //进度条线的宽度，单位 px,10; 圆形进度条线的宽度，单位是进度条画布宽度的百分比,6
	            var strokeWidth = moduleDesc.strokeWidth;
	            if (strokeWidth) inputprops.strokeWidth = strokeWidth;
	
	            var width = moduleDesc.width; // 圆形进度条画布宽度，单位 px,132
	            if (type == 'circle' && width) inputprops.width = width;
	
	            var format = moduleDesc.format; // 自定义文字格式
	            if (format) {
	                inputprops.format = function (percent) {
	                    return '' + percent + format;
	                };
	            }
	
	            // var successPercent = moduleDesc.successPercent;// 已完成的分段百分比，type="line" 时有效,0
	            // if (successPercent) inputprops.successPercent = successPercent;
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiProgress;
	}(_react2.default.Component);
	
	//给类添加公共方法
	// Object.assign(SgiProgress.prototype, sgiFormCtlBaseFun);
	
	SgiProgress.defaultProps = {};
	SgiProgress.propTypes = {};
	exports.SgiProgress = SgiProgress;
	exports.default = SgiProgress;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(18);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SgiCtnComponent2 = __webpack_require__(253);
	
	var _SgiCtnComponent3 = _interopRequireDefault(_SgiCtnComponent2);
	
	var _SgiCompComm = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiSpin = function (_SgiCtnComponent) {
		_inherits(SgiSpin, _SgiCtnComponent);
	
		function SgiSpin(props) {
			_classCallCheck(this, SgiSpin);
	
			var _this = _possibleConstructorReturn(this, (SgiSpin.__proto__ || Object.getPrototypeOf(SgiSpin)).call(this, props));
	
			_this.__render = function () {
				return _react2.default.createElement(
					_antd.Spin,
					_extends({ wrapperClassName: this.state._props.className }, this.state._props, {
						spinning: this.state.loading }),
					this.state.sonItems,
					this.props.children
				);
			};
	
			_this.state.loading = false;
			_this.state._class = ["sgiSpin"].concat(_toConsumableArray(_this.state._class));
			return _this;
		}
	
		_createClass(SgiSpin, [{
			key: '__fitSonItems',
			value: function __fitSonItems() {
				var _props = this.props,
				    moduleDesc = _props.moduleDesc,
				    objFct = _props.objFct,
				    type = _props.type;
				var sonItems = this.state.sonItems;
	
	
				var me = this;
				var cldSet = moduleDesc.cldSet;
				if (cldSet && cldSet.length > 0) cldSet.forEach(function (item, index) {
					return sonItems.push((0, _SgiCompComm.convertModuleByGuid)(me, item, null, objFct, type));
				});
			}
	
			//渲染并返回一个虚拟DOM
	
		}]);
	
		return SgiSpin;
	}(_SgiCtnComponent3.default);
	
	exports.default = SgiSpin;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiTag = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _StandardCode = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var CheckboxGroup = _antd.Checkbox.Group;
	
	var SgiTag = function (_React$Component) {
	    _inherits(SgiTag, _React$Component);
	
	    // 注意这里有分号
	
	    function SgiTag(props) {
	        _classCallCheck(this, SgiTag);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiTag.__proto__ || Object.getPrototypeOf(SgiTag)).call(this, props));
	
	        _this.render = function () {
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    bdInst = _props.bdInst,
	                    objFct = _props.objFct,
	                    type = _props.type;
	                //组装属性 初始化属性到this.state
	
	                this.checkbox_mk(parentModule, moduleDesc, bdInst, objFct, type);
	                this.loaded = true;
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var ctl = _react2.default.createElement(
	                _antd.Row,
	                this.state.inputprops,
	                ' ',
	                this.state.store,
	                this.state.btnshow ? _react2.default.createElement(
	                    _antd.Button,
	                    { size: 'small', onClick: this.moreClick.bind(this) },
	                    '\u66F4\u591A'
	                ) : null,
	                ' '
	            );
	
	            return this.state.noFI ? ctl : _react2.default.createElement(
	                FormItem,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                ctl
	            );
	        };
	
	        _this.initState();
	        _this.state.store = [];
	        _this.state.checked = "";
	        _this.state.scList = [];
	        _this.state.allScList = [];
	        _this.state.shows = null; //下拉窗显示项，不为空则表示启用，只能显示指定项
	        _this.state.occupied = null;
	        _this.state.isOccupied = false;
	        _this.state.btnshow = false;
	        return _this;
	    }
	
	    /**
	     * 根据描述创建文本框
	     * @param {父组件} parentModule
	     * @param {组件描述} moduleDesc
	     * @param {绑定实例ID} bdInst
	     * @param {当前工作区} ws
	     * @param {make类型} type
	     */
	    // 注意这里有分号
	
	
	    _createClass(SgiTag, [{
	        key: 'checkbox_mk',
	        value: function checkbox_mk(parentModule, moduleDesc, bdInst, objFct, type) {
	
	            //获取需要展示的数据信息
	            var moduleDesc = this.props.moduleDesc;
	            if (!moduleDesc) {
	                return;
	            }
	
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换基础属性
	            this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //组装下拉框内容
	            this.fitSelectOption(moduleDesc);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	            this.state.chkAll = moduleDesc.chkAll;
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'fitSelectOption',
	        value: function fitSelectOption(moduleDesc) {
	
	            this.state.store = [];
	
	            var scId = moduleDesc.scId,
	                useCodes = moduleDesc.useCodes;
	
	            if (!scId) {
	                return;
	            }
	            // 下拉窗列表值在标准代码中的id
	            var comboBoxData = _StandardCode.StandardCode.getSC(moduleDesc.scId);
	            if (!comboBoxData) {
	                return;
	            }
	            this.fitStore(comboBoxData);
	
	            //参数工厂获取标准代码 暂时当获取到了 属性为'sc', 'te', 'c'
	            //下面是临时数据
	            // let scList = [];
	            // for (let i = 1; i < 5; i++) {
	            //     scList.push({ te: (i.toString(2)), c: (i.toString(2)) });
	            // }
	
	            // if (!scList || scList.length < 1) {
	            //     return;
	            // }
	
	            // scList.forEach((item, index) => {
	            //     this.state.store.push(<Checkbox value={item.c}>{item.te}</Checkbox>);
	            // })
	        }
	
	        /**
	         * 组装下拉框内容
	         * @param {描述} moduleDesc
	         */
	
	    }, {
	        key: 'fitStore',
	        value: function fitStore(comboBoxData, attKey, attName) {
	            var _this2 = this;
	
	            attKey = attKey || 'c';
	            attName = attName || 'te';
	
	            this.state.store = [];
	
	            // 全部
	            var allScList = [];
	            for (var i = 0; i < comboBoxData.length; i++) {
	                var item = comboBoxData[i];
	                allScList.push({ te: item[attName], c: item[attKey] });
	            }
	            this.state.allScList = allScList;
	
	            // 展示
	            var scList = [];
	            var size = this.state.astrict || comboBoxData.length;
	            if (this.state.astrict && this.state.astrict < comboBoxData.length) {
	                this.state.btnshow = true;
	            } else {
	                this.state.btnshow = false;
	            }
	            if (!size == 0) {
	                for (var _i = 0; _i < size; _i++) {
	                    var item = comboBoxData[_i];
	                    scList.push({ te: item[attName], c: item[attKey] });
	                }
	                this.state.scList = scList;
	
	                var occ = this.state.isOccupied;
	
	                scList.forEach(function (item, index) {
	
	                    _this2.state.store.push(occ ? _react2.default.createElement(
	                        _antd.Col,
	                        { span: _this2.state.occupied },
	                        _react2.default.createElement(
	                            _antd.Tag,
	                            { onClick: _this2.tagClick.bind(_this2, item), value: item.c },
	                            item.te
	                        )
	                    ) : _react2.default.createElement(
	                        _antd.Tag,
	                        { onClick: _this2.tagClick.bind(_this2, item), value: item.c },
	                        item.te
	                    ));
	                });
	            }
	        }
	    }, {
	        key: 'tagClick',
	        value: function tagClick(item) {
	            var _props2 = this.props,
	                parentModule = _props2.parentModule,
	                moduleDesc = _props2.moduleDesc,
	                bdInst = _props2.bdInst,
	                objFct = _props2.objFct,
	                type = _props2.type;
	
	            var clkLsn = moduleDesc.clkLsn;
	            var $clkLsn = new Function("module", "objFct", "tagItem", "allTags", clkLsn);
	            $clkLsn(moduleDesc, objFct, item, this.state.allScList);
	        }
	    }, {
	        key: 'moreClick',
	        value: function moreClick() {
	            var _props3 = this.props,
	                parentModule = _props3.parentModule,
	                moduleDesc = _props3.moduleDesc,
	                bdInst = _props3.bdInst,
	                objFct = _props3.objFct,
	                type = _props3.type;
	
	            var moreLsn = moduleDesc.moreLsn;
	            var $moreLsn = new Function("module", "objFct", "allTags", moreLsn);
	            $moreLsn(moduleDesc, objFct, this.state.allScList);
	        }
	    }, {
	        key: 'dynamicRefreshTag',
	        value: function dynamicRefreshTag(comboBoxData, attKey, attName) {
	            if (!comboBoxData) {
	                return;
	            }
	            this.fitStore(comboBoxData, attKey, attName);
	            this.setState({ loading: false });
	        }
	
	        /**
	         * 属性转换
	         * @param {描述信息} moduleDesc
	         * @param {属性} formItem
	         * @param {属性} inputprops
	         */
	
	    }, {
	        key: 'AddInputAttribute',
	        value: function AddInputAttribute(moduleDesc, formItem, inputprops) {
	            //	初始是否选中
	            //var deChekd = moduleDesc.deChekd;
	            //if(deChekd)inputprops.defaultChecked = deChekd;
	            //是否显示按钮样式
	            //设置默认选中
	            // var checked = moduleDesc.checked;
	            // if (checked) {
	            //     inputprops.value = checked;
	            //     inputprops.defaultValue = checked;
	            // }
	
	            // // 显示项
	            // let shows = moduleDesc.shows;
	            // if (shows && shows.length > 0) this.state.shows = shows;
	            // else this.state.shows = null;
	            var height = moduleDesc.ctlH;
	            if (height) inputprops.style.height = height;
	            var width = moduleDesc.ctlW;
	            if (width) inputprops.style.width = width;
	            var occupied = moduleDesc.occupied;
	            if (occupied) {
	                this.state.occupied = occupied;
	                this.state.isOccupied = true;
	            } else {
	                this.state.isOccupied = false;
	            }
	
	            var astrict = moduleDesc.astrict;
	            if (astrict) {
	                this.state.astrict = parseInt(astrict);
	            } else {
	                this.state.astrict = null;
	            }
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiTag;
	}(_react2.default.Component);
	//给类添加公共方法
	
	
	SgiTag.defaultProps = {};
	SgiTag.propTypes = {};
	Object.assign(SgiTag.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	exports.SgiTag = SgiTag;
	exports.default = SgiTag;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tinymceReact = __webpack_require__(935);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _SgiComponent2 = __webpack_require__(204);
	
	var _SgiComponent3 = _interopRequireDefault(_SgiComponent2);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _sgiFormCtlBaseFun = __webpack_require__(64);
	
	var _sgiFormCtlComm = __webpack_require__(62);
	
	var _antd = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiTinyMCE = function (_SgiComponent) {
	    _inherits(SgiTinyMCE, _SgiComponent);
	
	    function SgiTinyMCE(props) {
	        _classCallCheck(this, SgiTinyMCE);
	
	        //初始化state属性
	        var _this = _possibleConstructorReturn(this, (SgiTinyMCE.__proto__ || Object.getPrototypeOf(SgiTinyMCE)).call(this, props));
	
	        _this.handleEditorChange = function (content, editor) {
	            _this.state.inputprops.onChange.call(_this, content, editor);
	            _this.setState({ content: content });
	        };
	
	        _this.render = function () {
	            var _props = this.props,
	                parentModule = _props.parentModule,
	                moduleDesc = _props.moduleDesc,
	                objFct = _props.objFct,
	                type = _props.type;
	
	
	            if (!this.loaded) {
	                //组装属性
	                this.tinymce_mk(parentModule, moduleDesc, objFct, type);
	                this.loaded = true;
	            }
	
	            // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
	
	            var _getReviseProps = this.getReviseProps(),
	                _inputProps = _getReviseProps._inputProps,
	                _formItemProps = _getReviseProps._formItemProps;
	
	            var isLabel = _inputProps.isLabel;
	
	            // 渲染前通用处理，如自定义样式等
	
	            this.renderBeforeReturn();
	
	            var editor = _react2.default.createElement(_tinymceReact.Editor, _extends({}, this.state.inputprops, _inputProps, {
	                // init={{
	                //     language: "zh_CN",
	                //     branding: false, //This option allows you to disable the "Powered by TinyMCE" branding.
	                //     menubar: "edit insert format table tools",
	                //     height: "100%",
	                //     body_class: "markdown-body",
	                //     plugins: "image imagetools advlist code media link colorpicker paste table textcolor",
	                //     toolbar: "undo redo | fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | bullist numlist | link image",
	                //     selector: "textarea",
	                //     paste_data_images: true
	                // }}
	                value: this.state.content,
	                onEditorChange: this.handleEditorChange }));
	
	            return this.state.isFormItem ? _react2.default.createElement(
	                _antd.Form.Item,
	                _extends({}, this.state.formItemProps, _formItemProps),
	                editor
	            ) : editor;
	        };
	
	        _this.initState();
	        _this.state = _extends({}, _this.state, {
	            content: '',
	            isFormItem: false
	        });
	        _this.state.inputprops.init = {
	            language: "zh_CN",
	            branding: false, //This option allows you to disable the "Powered by TinyMCE" branding.
	            menubar: "edit insert format table tools",
	            height: "100%",
	            body_class: "markdown-body",
	            plugins: "image imagetools advlist code media link colorpicker paste table textcolor",
	            toolbar: "undo redo | fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | bullist numlist | link image",
	            selector: "textarea",
	            paste_data_images: true
	        };
	        return _this;
	    }
	
	    /**
	     * maker构建
	     * @param {object} parentModule 
	     * @param {object} moduleDesc       
	     * @param {ObjFactory} objFct 
	     * @param {string} type 
	     */
	
	
	    _createClass(SgiTinyMCE, [{
	        key: 'tinymce_mk',
	        value: function tinymce_mk(parentModule, moduleDesc, objFct, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	
	            //转换form公共属性
	            (0, _sgiFormCtlComm.AddFormCtlCommonAttribute)(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //转换基础属性
	            this.AddAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //设置布局
	            (0, _sgiFormCtlComm.setFormCtlLayout)(moduleDesc, this.state.formItemProps, this.state.inputprops);
	            //绑定值
	            (0, _sgiFormCtlComm.bindValue)(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
	            //绑定事件
	            (0, _sgiFormCtlComm.bindEvent)(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	        }
	
	        /**
	         * 属性转换
	         */
	
	    }, {
	        key: 'AddAttribute',
	        value: function AddAttribute(moduleDesc, formItemProps, inputprops) {
	
	            if (!inputprops.init) inputprops.init = {};
	            if (moduleDesc.language) inputprops.init.language = moduleDesc.language;
	            if (moduleDesc.branding) inputprops.init.branding = moduleDesc.branding; //This option allows you to disable the "Powered by TinyMCE" branding.
	            if (moduleDesc.menubar) inputprops.init.menubar = moduleDesc.menubar;
	            if (moduleDesc.height) inputprops.init.height = moduleDesc.height;
	            if (moduleDesc.body_class) inputprops.init.body_class = moduleDesc.body_class;
	            if (moduleDesc.plugins) inputprops.init.plugins = moduleDesc.plugins;
	            if (moduleDesc.toolbar) inputprops.init.toolbar = moduleDesc.toolbar;
	            if (moduleDesc.selector) inputprops.init.selector = moduleDesc.selector;
	            if (moduleDesc.paste_data_images || moduleDesc.paste_data_images === false) inputprops.init.paste_data_images = moduleDesc.paste_data_images;
	
	            if (moduleDesc._formProps) this.state.isFormItem = true;
	
	            // 自定义props
	            var cstmPrps = moduleDesc.cstmPrps;
	            if (cstmPrps) {
	                var cstmPrpsObj = void 0;
	                try {
	                    cstmPrpsObj = JSON.parse(cstmPrps);
	                } catch (error) {
	                    _sgiLogger.sgiLogger.eventErr(error);
	                }
	                if (cstmPrpsObj) merge(inputprops, cstmPrpsObj);
	            }
	        }
	
	        //渲染并返回一个虚拟DOM
	
	    }]);
	
	    return SgiTinyMCE;
	}(_SgiComponent3.default);
	
	//给类添加公共方法
	
	
	exports.default = SgiTinyMCE;
	Object.assign(SgiTinyMCE.prototype, _sgiFormCtlBaseFun.sgiFormCtlBaseFun);
	
	/**
	 * 属性合并
	 * @param {object} target 目标对象
	 * @param {object} source 源对象
	 */
	function merge(target, source) {
	    // 目标和源相同，直接返回
	    if (target === source) return target;
	    // 分情况处理
	    if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
	        for (var key in source) {
	            if (target[key] === source[key]) continue; //相同，跳过
	            if (!target[key]) target[key] = source[key]; //target属性不存在，直接赋值
	            else target[key] = merge(target[key], source[key]); //target属性存在，合并
	        }
	    } else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
	        for (var i = 0; i < source.length; i++) {
	            if (target[i] === source[i]) continue; //相同，跳过
	            if (!target[i]) target.push(source[i]); //target元素不存在，直接添加
	            else target[i] = merge(target[i], source[i]); //target元素存在，合并
	        }
	    } else {
	        //其他情况，直接赋值
	        target = source;
	    }
	    // 返回target
	    return target;
	}

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComponent2 = __webpack_require__(253);
	
	var _SgiCtnComponent3 = _interopRequireDefault(_SgiCtnComponent2);
	
	var _SgiCompComm = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiTooltip = function (_SgiCtnComponent) {
		_inherits(SgiTooltip, _SgiCtnComponent);
	
		function SgiTooltip(props) {
			_classCallCheck(this, SgiTooltip);
	
			var _this = _possibleConstructorReturn(this, (SgiTooltip.__proto__ || Object.getPrototypeOf(SgiTooltip)).call(this, props));
	
			_this.__render = function () {
				return _react2.default.createElement(
					_antd.Tooltip,
					_this.state._props,
					_this.state.sonItems,
					_this.props.children
				);
			};
	
			return _this;
		}
	
		_createClass(SgiTooltip, [{
			key: '__fitSonItems',
			value: function __fitSonItems() {
				var _this2 = this;
	
				var _props2 = this.props,
				    moduleDesc = _props2.moduleDesc,
				    objFct = _props2.objFct,
				    type = _props2.type;
				var sonItems = this.state.sonItems;
	
	
				var cldSet = moduleDesc.cldSet || [];
				cldSet.forEach(function (item) {
					return sonItems.push((0, _SgiCompComm.convertModuleByGuid)(_this2, item, null, objFct, type));
				});
			}
	
			//渲染并返回一个虚拟DOM
	
		}, {
			key: '__AddAttribute',
			value: function __AddAttribute() {
				var _props3 = this.props,
				    moduleDesc = _props3.moduleDesc,
				    parentModule = _props3.parentModule;
				var _state = this.state,
				    _props = _state._props,
				    _style = _state._style,
				    _class = _state._class;
	
	
				var text = _props.te; //公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
				if (text) _props.title = text;
	
				/**
	    * arrowPointAtCenter	箭头是否指向目标元素中心，antd@1.11+ 支持	boolean	false	
	    * autoAdjustOverflow	气泡被遮挡时自动调整位置	boolean	true	
	    * defaultVisible	默认是否显隐	boolean	false	
	    * getPopupContainer	浮层渲染父节点，默认渲染到 body 上	Function(triggerNode)	() => document.body	
	    * mouseEnterDelay	鼠标移入后延时多少才显示 Tooltip，单位：秒	number	0.1	
	    * mouseLeaveDelay	鼠标移出后延时多少才隐藏 Tooltip，单位：秒	number	0.1	
	    * overlayClassName	卡片类名	string	无	
	    * overlayStyle	卡片样式	object	无	
	    * placement	气泡框位置，可选 top left right bottom topLeft topRight bottomLeft bottomRight leftTop leftBottom rightTop rightBottom	string	top	
	    * trigger	触发行为，可选 hover/focus/click/contextMenu	string	hover	
	    * visible	用于手动控制浮层显隐	boolean	false	
	    * onVisibleChange	显示隐藏的回调	(visible) => void	无	
	    * align	该值将合并到 placement 的配置中，设置参考 rc-tooltip	Object	无	3.10.0
	    */
				if (moduleDesc.mouseEnterDelay !== undefined) _props.mouseEnterDelay = moduleDesc.mouseEnterDelay;
				if (moduleDesc.mouseLeaveDelay !== undefined) _props.mouseLeaveDelay = moduleDesc.mouseLeaveDelay;
				if (moduleDesc.placement !== undefined) _props.placement = moduleDesc.placement;
				if (moduleDesc.trigger !== undefined) _props.trigger = moduleDesc.trigger;
			}
		}]);
	
		return SgiTooltip;
	}(_SgiCtnComponent3.default);
	
	exports.default = SgiTooltip;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SgiTransfer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(18);
	
	var _SgiCtnComm = __webpack_require__(52);
	
	var _SgiCompComm = __webpack_require__(45);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tranFConfConstant = {
	    key: 'key'
	};
	
	var SgiTransfer = function (_React$Component) {
	    _inherits(SgiTransfer, _React$Component);
	
	    function SgiTransfer(props) {
	        _classCallCheck(this, SgiTransfer);
	
	        //初始化state
	        var _this = _possibleConstructorReturn(this, (SgiTransfer.__proto__ || Object.getPrototypeOf(SgiTransfer)).call(this, props));
	
	        _this.handleChange = function (nextTargetKeys, direction, moveKeys) {
	            _this.setState({ targetKeys: nextTargetKeys });
	            tool.sgiLogger.log(nextTargetKeys);
	        };
	
	        _this.getTargetDatas = function () {
	            var data = [];
	            var rightData;
	            var targetKeys = _this.state.targetKeys;
	            var dataSource = _this.state.transferprops.dataSource;
	            for (var i = 0; i < targetKeys.length; i++) {
	                rightData = targetKeys[i];
	                for (var j = 0; j < dataSource.length; j++) {
	                    var leftData = dataSource[j][_this.state.key];
	                    if (leftData == rightData) {
	                        data.push(dataSource[j]);
	                        break;
	                    }
	                }
	            }
	            tool.sgiLogger.log('data: ', data);
	            return data;
	        };
	
	        _this.getSourceDatas = function () {
	            var data = [];
	            var rightData;
	            var targetKeys = _this.state.targetKeys;
	            var num = _this.state.transferprops.dataSource;
	            num = (0, _sgiCommon.copyArr)(num);
	            for (var i = 0; i < targetKeys.length; i++) {
	                rightData = targetKeys[i];
	                for (var j = 0; j < num.length; j++) {
	                    var leftData = num[j][_this.state.key];
	                    if (leftData == rightData) {
	                        num.splice(j, 1);
	                    }
	                }
	            }
	            tool.sgiLogger.log('source:  ', _this.state.transferprops.dataSource);
	            tool.sgiLogger.log('num: ', num);
	        };
	
	        _this.handleSelectChange = function (sourceSelectedKeys, targetSelectedKeys) {
	            _this.setState({ selectedKeys: [].concat(_toConsumableArray(sourceSelectedKeys), _toConsumableArray(targetSelectedKeys)) });
	        };
	
	        _this.refresh = function () {
	            _this.loaded = false;
	            _this.setState({ loading: false });
	        };
	
	        _this.render = function () {
	            var _this2 = this;
	
	            if (!this.loaded) {
	                var _props = this.props,
	                    parentModule = _props.parentModule,
	                    moduleDesc = _props.moduleDesc,
	                    objFct = _props.objFct,
	                    bdInst = _props.bdInst,
	                    type = _props.type;
	                //组装属性，初始化到this.state
	
	                this.transfer_mk(parentModule, moduleDesc, objFct, bdInst, type);
	                this.loaded = true;
	            }
	            return _react2.default.createElement(_antd.Transfer, _extends({}, this.state.transferprops, { render: function render(item) {
	                    return item.title;
	                },
	                targetKeys: this.state.targetKeys, onChange: this.handleChange,
	                selectedKeys: this.state.selectedKeys, onSelectChange: this.handleSelectChange,
	                rowKey: function rowKey(record) {
	                    return record[_this2.state.key];
	                }
	            }));
	        };
	
	        _this.state = {
	            loading: false,
	            transferprops: {
	                listStyle: {},
	                titles: [],
	                operations: []
	            },
	            selectedKeys: [],
	            targetKeys: [] //右显示数组
	        };
	        return _this;
	    }
	
	    _createClass(SgiTransfer, [{
	        key: 'transfer_mk',
	
	
	        /**
	        *根据描述创建穿梭框
	        *@param {父组件} parentModule
	        * @param {组件描述} moduleDesc
	        * @param {对象工厂} objFct
	        * @param {绑定实例ID} bdInst
	        * @param {make类型} type
	        */
	
	        value: function transfer_mk(parentModule, moduleDesc, objFct, bdInst, type) {
	            //获取需要展示的数据信息
	            if (!moduleDesc) {
	                return;
	            }
	            //转换基础属性
	            this.AddTFAttribute(moduleDesc, this.state.transferprops, objFct);
	            //绑定公共属性 
	            // CtnCommonAttribute(moduleDesc,this.Transfer,this);
	        }
	    }, {
	        key: 'AddTFAttribute',
	        value: function AddTFAttribute(moduleDesc, transferprops, objFct) {
	            //绑定数据，获取穿梭框的数据
	            var transferStore = this.getMock(moduleDesc, objFct);
	            if (moduleDesc._key) {
	                this.state.key = moduleDesc._key; //moduleDesc._key;
	            } else {
	                for (var i = 0; i < transferStore.length; i++) {
	                    if (!transferStore[i][tranFConfConstant.key]) {
	                        transferStore[i][tranFConfConstant.key] = (0, _sgiCommon.uuid)(6);
	                    }
	                }
	                this.state.key = tranFConfConstant.key;
	            }
	            this.state.transferprops.dataSource = transferStore;
	            //宽高
	            var height = moduleDesc.height;
	            if (height) {
	                transferprops.listStyle.height = height;
	            }
	            var width = moduleDesc.width;
	            if (width) {
	                transferprops.listStyle.width = width;
	            }
	            //搜索框
	            var showSearch = moduleDesc.showSearch;
	            if (showSearch) {
	                transferprops.showSearch = showSearch;
	            }
	            //左右两边的标题
	            var leftTitle = moduleDesc.leftTitle;
	            if (leftTitle) {
	                transferprops.titles[0] = leftTitle;
	            }
	            var rightTitle = moduleDesc.rightTitle;
	            if (rightTitle) {
	                transferprops.titles[1] = rightTitle;
	            }
	            //左右操作按键
	            var rightOperation = moduleDesc.rightOperation;
	            if (rightOperation) {
	                transferprops.operations[0] = rightOperation;
	            }
	            var leftOperation = moduleDesc.leftOperation;
	            if (leftOperation) {
	                transferprops.operations[1] = leftOperation;
	            }
	        }
	        /**
	        * @param {*} moduleDesc
	        * @param {*} transferprope
	        */
	        // 获取数据
	
	    }, {
	        key: 'getMock',
	        value: function getMock(moduleDesc, objFct) {
	            var insName = (0, _SgiCommon.getConstByKey)(this, moduleDesc.insName);
	            var tData;
	            if (insName && objFct) {
	                tData = objFct.get(insName);
	            }
	            if (!tData) {
	                return [];
	            }
	            return tData;
	        }
	    }]);
	
	    return SgiTransfer;
	}(_react2.default.Component);
	
	SgiTransfer.defaultProps = {};
	SgiTransfer.propsType = {};
	exports.SgiTransfer = SgiTransfer;
	exports.default = SgiTransfer;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 表单控件的maker的公共方法
	 * wangz 
	 * 2018.3.9
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.text_mk = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _antd = __webpack_require__(18);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormCtlMKComm = __webpack_require__(726);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormItem = _antd.Form.Item;
	
	/**
	 * 根据描述创建文本框
	 * @param {父组件} panelModule 
	 * @param {组件描述} moduleDesc 
	 * @param {绑定实例ID} bdInst 
	 * @param {当前工作区} ws 
	 * @param {make类型} type 
	 */
	function text_mk(panelModule, moduleDesc, bdInst, workspace, type) {
	    tool.sgiLogger.log(this);
	    var formItemProps = { style: {} }; //input外层属性
	    var inputprops = { style: {} }; //转换后属性
	    //转换基础属性
	    AddInputAttribute(moduleDesc, formItemProps, inputprops);
	    //转换form公共属性
	    (0, _FormCtlMKComm.AddFormCtlCommonAttribute)(moduleDesc, formItemProps, inputprops);
	    //设置布局
	    (0, _FormCtlMKComm.setFormCtlLayout)(moduleDesc, formItemProps, inputprops);
	    //绑定事件
	    (0, _FormCtlMKComm.bindEvent)(moduleDesc, formItemProps, inputprops);
	    //绑定值
	    (0, _FormCtlMKComm.bindValue)(panelModule, moduleDesc, bdInst, formItemProps, inputprops);
	
	    tool.sgiLogger.log(formItemProps);
	    tool.sgiLogger.log(inputprops);
	
	    var c = moduleDesc.c;
	    var resultJsx;
	    if (bdInst && panelModule.state && panelModule.state[bdInst]) {
	        resultJsx = _react2.default.createElement(
	            FormItem,
	            formItemProps,
	            _react2.default.createElement(_antd.Input, _extends({}, inputprops, { value: panelModule.state[bdInst][c] }))
	        );
	    } else {
	        resultJsx = _react2.default.createElement(
	            FormItem,
	            formItemProps,
	            _react2.default.createElement(_antd.Input, inputprops)
	        );
	    }
	    return resultJsx;
	}
	
	/**
	 * 属性转换
	 * @param {描述信息} moduleDesc 
	 * @param {属性} formItem 
	 * @param {属性} inputprops 
	 */
	var AddInputAttribute = function AddInputAttribute(moduleDesc, formItem, inputprops) {
	
	    //csstyle 样式文件?这个我还不知道怎么用
	    var csstyle = moduleDesc.csstyle;
	
	    //是否是密码控件 这个暂时不用
	    var isPwd = moduleDesc.isPwd;
	};
	
	exports.text_mk = text_mk;
	exports.default = text_mk;
	
	//import * as constants from './constants';
	//import {A, B} from './constants';
	//export * from 'UBCtlMaker';
	//export * as someIdentifier from "UBCtlMaker";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addCtnCommonAttribute = undefined;
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiCommon = __webpack_require__(29);
	
	/**
	 * 容器组件的公共方法，非组件继承方法
	 * hanzb
	 * 2019-8-7
	 */
	
	/**
	 * 转换ctn公共属性（不参与继承，所以放外面）
	 * @param {object} currentModule 当前module
	 * @param {object} moduleDesc json描述
	 * @param {object} ctnWrapProps ctn容器属性
	 * @param {object} ctnHeadProps ctnhead属性
	 * @param {object} ctnBodyProps ctnbody属性
	 */
	var addCtnCommonAttribute = function addCtnCommonAttribute(currentModule, moduleDesc, ctnWrapProps, ctnHeadProps, ctnBodyProps) {
	    var cId = moduleDesc.cId; //cid 唯一标示
	    if (cId) ctnWrapProps.id = (0, _SgiCommon.getConstByKey)(currentModule, cId);
	
	    var ctlW = moduleDesc.ctlW; //form宽度
	    ctnWrapProps.style.width = ctlW;
	    if (ctlW == 0 || ctlW == '0px') {
	        ctnWrapProps.style.width = undefined;
	    }
	
	    var ctlH = moduleDesc.ctlH; //form高度
	    ctnWrapProps.style.height = ctlH;
	    if (ctlH == 0 || ctlH == '0px') {
	        ctnWrapProps.style.height = undefined;
	    }
	
	    var isBrdr = moduleDesc.isBrdr; //form是否有边框??没实现
	    if (isBrdr) {
	        ctnWrapProps.style.border = "1px solid rgb(217, 217, 217)"; /*边线宽度 类型 颜色*/;
	    } else {
	        ctnWrapProps.style.border = undefined;
	    }
	
	    var mgn = moduleDesc.mgn; //form外边距
	    if (mgn) ctnWrapProps.style.margin = mgn;
	    var pad = moduleDesc.pad; //form内边距
	    if (pad) ctnWrapProps.style.padding = pad;
	
	    var isHdn = moduleDesc.isHdn; //form是否隐藏
	    if (isHdn) {
	        ctnWrapProps.style.display = "none";
	    } else {
	        ctnWrapProps.style.display = undefined;
	    }
	
	    var isScl = moduleDesc.isScl; //form是否可以滚动
	    if (isScl) {
	        if (!ctnBodyProps) ctnWrapProps.style.overflow = "auto";
	        if (ctnBodyProps) ctnBodyProps.style.overflow = "auto";
	    } else {
	        if (!ctnBodyProps) ctnWrapProps.style.overflow = undefined;
	        if (ctnBodyProps) ctnBodyProps.style.overflow = undefined;
	    }
	
	    //公共属性里统一进行文本资源转换，各个控件可直接从ctnProps.te中取出结果，不再需要单独转换
	    // if (moduleDesc.te || moduleDesc.teid) {//如果te和teid都不存在则不查找资源
	    //     var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
	    //     if (te) ctnProps.te = te;
	    // }
	    var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
	    ctnWrapProps.te = te;
	
	    // 初始加载中
	    currentModule.state.loading = !!moduleDesc.loading;
	
	    // 自定义样式
	    var cstmStyle = moduleDesc.cstmStyle;
	    var $cstmStyle = void 0;
	    if (cstmStyle) {
	        try {
	            $cstmStyle = new Function("module", "objFct", cstmStyle);
	        } catch (error) {
	            _sgiLogger.sgiLogger.eventErr(error);
	        }
	        // currentModule.state.cstmStyle = $cstmStyle;
	        (0, _SgiCommon.setFunction)(currentModule, "cstmStyle", $cstmStyle);
	    }
	};
	
	exports.addCtnCommonAttribute = addCtnCommonAttribute;
	exports.default = addCtnCommonAttribute;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgiG6Component2 = __webpack_require__(1332);
	
	var _SgiG6Component3 = _interopRequireDefault(_SgiG6Component2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SgiG6Common = function (_SgiG6Component) {
	  _inherits(SgiG6Common, _SgiG6Component);
	
	  function SgiG6Common() {
	    _classCallCheck(this, SgiG6Common);
	
	    return _possibleConstructorReturn(this, (SgiG6Common.__proto__ || Object.getPrototypeOf(SgiG6Common)).apply(this, arguments));
	  }
	
	  return SgiG6Common;
	}(_SgiG6Component3.default);
	
	exports.default = SgiG6Common;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _SgiCtlComponent2 = __webpack_require__(161);
	
	var _SgiCtlComponent3 = _interopRequireDefault(_SgiCtlComponent2);
	
	var _SgiCommon = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @Descripttion: 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @version: 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @Author: hanzb
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @Date: 2020-02-13 10:09:18
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @LastEditors: hanzb
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @LastEditTime: 2020-04-24 13:47:16
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	// import G6 from '@antv/g6';//G6使用外部文件
	
	
	var SgiG6Component = function (_SgiCtlComponent) {
		_inherits(SgiG6Component, _SgiCtlComponent);
	
		function SgiG6Component(props) {
			_classCallCheck(this, SgiG6Component);
	
			var _this = _possibleConstructorReturn(this, (SgiG6Component.__proto__ || Object.getPrototypeOf(SgiG6Component)).call(this, props));
	
			_this.__render = function () {
				return _react2.default.createElement('div', _extends({ id: _this.state.divId }, _this.state._props));
			};
	
			_this.refresh = function () {
				var bdInst = _this.state.insName;
				var objFct = _this.props.objFct;
				var data = bdInst && objFct ? objFct.get(bdInst) : null;
				_this.refreshByData(data);
			};
	
			var divId = (0, _sgiCommon.uuidDate)(6, "yyyyMMddhhmmssSSS");
			_this.state = _extends({}, _this.state, {
				divId: divId,
				data: _this.props.data,
				options: {}
			});
			return _this;
		}
	
		// 转换自身属性
	
	
		_createClass(SgiG6Component, [{
			key: '__AddAttribute',
			value: function __AddAttribute() {
				var _props2 = this.props,
				    parentModule = _props2.parentModule,
				    moduleDesc = _props2.moduleDesc,
				    objFct = _props2.objFct,
				    type = _props2.type;
	
	
				if (!moduleDesc) return;
	
				this.state.divId = (0, _SgiCommon.getConstByKey)(this, moduleDesc.cId) || this.state.divId || (0, _sgiCommon.uuidDate)(6, "yyyyMMddhhmmssSSS");
	
				// 取data
				var bdInst = (0, _SgiCommon.getConstByKey)(this, moduleDesc.bdInst);
				this.state.insName = bdInst;
				if (bdInst && objFct) this.state.data = objFct.get(bdInst);
			}
	
			// 渲染
	
		}, {
			key: 'refreshByData',
			value: function refreshByData(data) {
				this.state.data = data;
				this.state.graph.read(data || {});
			}
		}, {
			key: '__componentDidMount',
			value: function __componentDidMount() {
				var options = this.state.options || {};
				if (!options.container) options.container = this.state.divId;
				if (!options.width) options.width = document.getElementById(this.state.divId).scrollWidth;
				if (!options.height) options.height = document.getElementById(this.state.divId).scrollHeight || 500;
				var graph = new G6.Graph(Object.assign(options));
				var data = this.state.data;
				graph.data(data || {});
				graph.render();
				this.state.graph = graph;
			}
		}, {
			key: '__componentWillMount',
			value: function __componentWillMount() {
				var _props3 = this.props,
				    parentModule = _props3.parentModule,
				    moduleDesc = _props3.moduleDesc,
				    bdInst = _props3.bdInst,
				    objFct = _props3.objFct,
				    type = _props3.type;
				var _state = this.state,
				    _props = _state._props,
				    _class = _state._class,
				    options = _state.options,
				    insName = _state.insName,
				    inOutType = _state.inOutType;
				var functions = this.data.functions;
	
	
				if (!moduleDesc || !objFct) return;
	
				if (this.props.type != 'dnd') {
					try {
						var initFn = void 0;
						if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys["initLsn"]) {
							// 事件集模式
							var funs = Object.assign({}, objFct.get("@funs"), this.funs);
							var key = moduleDesc.eventKeys["initLsn"];
							initFn = funs[key];
						} else {
							// 原事件模式
							var initLsn = moduleDesc.initLsn; // 页面初始化监听器
							initFn = new Function("module", "objFct", "G6", "containerId", initLsn);
						}
						// var initFn = new Function("module", "objFct", initLsn);
						if (initFn && typeof initFn === "function") initFn(this, objFct, G6, this.state.divId);
					} catch (error) {
						_sgiLogger.sgiLogger.eventErr(error);
					}
				}
			}
		}]);
	
		return SgiG6Component;
	}(_SgiCtlComponent3.default);
	
	exports.default = SgiG6Component;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Workflow = __webpack_require__(1349);
	
	var _Workflow2 = _interopRequireDefault(_Workflow);
	
	var _FlowEdit = __webpack_require__(1347);
	
	var _FlowEdit2 = _interopRequireDefault(_FlowEdit);
	
	var _ServiceInterface = __webpack_require__(1339);
	
	var _ServiceInterface2 = _interopRequireDefault(_ServiceInterface);
	
	var _SICondition = __webpack_require__(1338);
	
	var _SICondition2 = _interopRequireDefault(_SICondition);
	
	var _SgiDV = __webpack_require__(370);
	
	var _reactColor = __webpack_require__(1970);
	
	var _G6Flow = __webpack_require__(1336);
	
	var _G6Flow2 = _interopRequireDefault(_G6Flow);
	
	var _echarts = __webpack_require__(8);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sgiCustomModule = {
	    Workflow: _Workflow2.default,
	    ServiceInterface: _ServiceInterface2.default,
	    SICondition: _SICondition2.default,
	    FlowEdit: _FlowEdit2.default,
	
	    // DV,TV(预览使用)
	    SgiDV: _SgiDV.SgiDV,
	    sgiEcharts: _echarts2.default,
	    // 颜色选择器
	    SketchPicker: _reactColor.SketchPicker,
	
	    G6Flow: _G6Flow2.default
	};
	
	if (!window.sgiCustomModule) window.sgiCustomModule = {};
	Object.assign(window.sgiCustomModule, sgiCustomModule);
	exports.default = window.sgiCustomModule;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Condition = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _draftJs = __webpack_require__(193);
	
	__webpack_require__(279);
	
	var _common = __webpack_require__(1335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonGroup = _antd.Button.Group;
	
	var mathOperators = [{ name: '+', code: '+' }, { name: '-', code: '-' }, { name: '×', code: '*' }, { name: '/', code: '/' }, { name: '%', code: '%' }, { name: '^', code: '^' }, { name: '(', code: '(' }, { name: ')', code: ')' }];
	
	var logicOperators = [{ name: 'and', code: 'and' }, { name: 'or', code: 'or' }, { name: 'not', code: '!' }];
	
	var relationOperators = [{ name: '>', code: '>' }, { name: '<', code: '<' }, { name: '>=', code: '>=' }, { name: '<=', code: '<=' }, { name: '=', code: '==' }, { name: '!=', code: '!=' }];
	
	var varOperators = [{ name: '变量符', code: '#' }];
	
	var Condition = exports.Condition = function (_Component) {
	  _inherits(Condition, _Component);
	
	  function Condition(props) {
	    _classCallCheck(this, Condition);
	
	    var _this = _possibleConstructorReturn(this, (Condition.__proto__ || Object.getPrototypeOf(Condition)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var initData = _this.props.contentStateToRowJson;
	    var editorState = void 0;
	    if (initData) {
	      editorState = _common.refreshByContentStateToRowJson.call(_this, initData);
	    } else {
	      editorState = _draftJs.EditorState.createEmpty(_common.compositeDecorator);
	    }
	
	    _this.state = {
	      editorState: editorState,
	      visible: false,
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(Condition, [{
	    key: 'handleKeyCommand',
	    value: function handleKeyCommand(command) {
	      if (command === 'myeditor-save') {
	        this.showModal();
	        return 'handled';
	      }
	      return 'not-handled';
	    }
	
	    // 导入common中的方法
	
	  }, {
	    key: 'getButtons',
	    value: function getButtons() {
	      var mathbuttons = [];
	      var len = mathOperators.length;
	      for (var i = 0; i < len; i++) {
	        mathbuttons.push(_react2.default.createElement(
	          _antd.Button,
	          { key: mathOperators[i].code, onClick: this.insertConstant.bind(this, mathOperators[i].name, mathOperators[i].code) },
	          mathOperators[i].name
	        ));
	      }
	      var logicbuttons = [];
	      for (var _i = 0; _i < logicOperators.length; _i++) {
	        logicbuttons.push(_react2.default.createElement(
	          _antd.Button,
	          { key: logicOperators[_i].code, onClick: this.insertConstant.bind(this, logicOperators[_i].name, logicOperators[_i].code) },
	          logicOperators[_i].name
	        ));
	      }
	      var relationbuttons = [];
	      for (var _i2 = 0; _i2 < relationOperators.length; _i2++) {
	        relationbuttons.push(_react2.default.createElement(
	          _antd.Button,
	          { key: relationOperators[_i2].code, onClick: this.insertConstant.bind(this, relationOperators[_i2].name, relationOperators[_i2].code) },
	          relationOperators[_i2].name
	        ));
	      }
	      var varbuttons = [];
	      for (var _i3 = 0; _i3 < varOperators.length; _i3++) {
	        varbuttons.push(_react2.default.createElement(
	          _antd.Button,
	          { key: varOperators[_i3].code, onClick: this.insertConstant.bind(this, varOperators[_i3].name, varOperators[_i3].code) },
	          varOperators[_i3].name
	        ));
	      }
	      var button = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          ButtonGroup,
	          null,
	          mathbuttons
	        ),
	        '\xA0\xA0',
	        _react2.default.createElement(
	          ButtonGroup,
	          null,
	          logicbuttons
	        ),
	        '\xA0\xA0',
	        _react2.default.createElement(
	          ButtonGroup,
	          null,
	          relationbuttons
	        ),
	        '\xA0\xA0',
	        _react2.default.createElement(
	          ButtonGroup,
	          null,
	          varbuttons
	        ),
	        '\xA0\xA0'
	      );
	
	      return button;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.state.loading) {
	        this.focus();
	        this.setState({ loading: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var buttons = this.getButtons();
	      tool.sgiLogger.log(this.getValue());
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          {
	            title: this.props.title,
	            extra: buttons,
	            style: { width: '100%' }
	          },
	          _react2.default.createElement(
	            'div',
	            { style: _common.styles.editor, onClick: this.focus },
	            _react2.default.createElement(_draftJs.Editor, {
	              editorState: this.state.editorState,
	              onChange: this._onChange,
	              handleKeyCommand: this.handleKeyCommand,
	              keyBindingFn: _common.myKeyBindingFn
	              // placeholder="Enter some text..."
	              , ref: 'editor'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Condition;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.focus = function () {
	    return _this2.refs.editor.focus();
	  };
	
	  this.showModal = function () {
	    return _this2.setState({ visible: true });
	  };
	
	  this.closeModal = function (e) {
	    return _this2.setState({ visible: false });
	  };
	
	  this._onChange = function (editorState, e, e2) {
	    _this2.setState({ editorState: editorState });
	    var onChange = _this2.props.onChange;
	    if (onChange && typeof onChange === "function") {
	      onChange(_this2, e, e2);
	    }
	  };
	
	  this.insertVariate = _common.insertFun.bind(this, "variable");
	  this.insertConstant = _common.insertFun.bind(this, "constant");
	  this.getValue = _common.getValue.bind(this);
	  this.getHtml = _common.getHtml.bind(this);
	  this.getContentStateToRowForJson = _common.getContentStateToRowForJson.bind(this);
	  this.refreshByContentStateToRowJson = _common.refreshByContentStateToRowJson.bind(this);
	};
	
	exports.default = Condition;

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.styles = exports.refreshByContentStateToRowJson = exports.getContentStateToRowForJson = exports.getHtml = exports.getValue = exports.myKeyBindingFn = exports.insertFun = exports.compositeDecorator = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _draftjsToHtml = __webpack_require__(680);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _htmlToDraftjs = __webpack_require__(681);
	
	var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);
	
	var _draftJs = __webpack_require__(193);
	
	__webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasCommandModifier = _draftJs.KeyBindingUtil.hasCommandModifier;
	
	
	var getEditorState = function getEditorState() {
	    return this.state.editorState;
	};
	var getContentState = function getContentState() {
	    var editorState = getEditorState.call(this);
	    if (!editorState) return null;
	    return editorState.getCurrentContent();
	};
	var getContentStateToRow = function getContentStateToRow() {
	    var contentState = getContentState.call(this);
	    if (!contentState) return null;
	    return (0, _draftJs.convertToRaw)(contentState);
	};
	var getBlocks = function getBlocks() {
	    var contentStateToRow = getContentStateToRow.call(this) || {};
	    return contentStateToRow.blocks;
	};
	
	function findEntitieByType(type, contentBlock, callback, contentState) {
	    // const text = contentBlock.getText();
	    contentBlock.findEntityRanges(function (character) {
	        var entityKey = character.getEntity();
	        return entityKey !== null && contentState.getEntity(entityKey).getType() === type;
	    }, callback);
	};
	function span_onClick() {
	    // alert("我是变量");
	}
	function constant_span_onClick() {
	    // alert("我是常量");
	}
	var TokenSpan = function TokenSpan(props) {
	    var contentState = props.contentState;
	    var blocks = (0, _draftJs.convertToRaw)(contentState);
	    var entityMap = blocks.entityMap;
	    var href = "not found";
	    for (var key in entityMap) {
	        var entity = entityMap[key];
	        if (props.decoratedText === entity.data.title) href = entity.data.href;
	    }
	    return _react2.default.createElement(
	        'span',
	        { title: href, style: { backgroundColor: '#d3adf7', padding: '2px' }, onClick: span_onClick },
	        props.children
	    );
	};
	var ConstantSpan = function ConstantSpan(props) {
	    var contentState = props.contentState;
	    var blocks = (0, _draftJs.convertToRaw)(contentState);
	    var entityMap = blocks.entityMap;
	    var href = "not found";
	    for (var key in entityMap) {
	        var entity = entityMap[key];
	        if (props.decoratedText === entity.data.title) href = entity.data.href;
	    }
	    return _react2.default.createElement(
	        'span',
	        { title: href, style: { backgroundColor: 'rgba(78,238,148, 0.9)', padding: '2px' }, onClick: constant_span_onClick },
	        props.children
	    );
	};
	var findWithRegex = function findWithRegex(regex, contentBlock, callback) {
	    var text = contentBlock.getText();
	    var matchArr = void 0;
	    var start = void 0;
	    while ((matchArr = regex.exec(text)) !== null) {
	        start = matchArr.index;
	        callback(start, start + matchArr[0].length);
	    }
	};
	var compositeDecorator = new _draftJs.CompositeDecorator([{
	    strategy: findEntitieByType.bind(undefined, "variable"),
	    component: TokenSpan
	},
	// {
	//     strategy:  (contentBlock, callback, contentState) => {
	//         const emojiRegex = /#{(.*?)}/g;
	//         findWithRegex(emojiRegex, contentBlock, callback);
	//     },
	//     component: TokenSpan,
	// },
	{
	    strategy: findEntitieByType.bind(undefined, "constant"),
	    component: ConstantSpan
	}]);
	
	var refreshByContentStateToRowJson = function refreshByContentStateToRowJson(json) {
	    if (!json) return;
	    var jsonObj = typeof json === "string" ? JSON.parse(json) : json;
	    var contentState = (0, _draftJs.convertFromRaw)(jsonObj);
	    var editorState = _draftJs.EditorState.createWithContent(contentState, compositeDecorator);
	    this.setState({ editorState: editorState });
	    return editorState;
	};
	
	var insertFun = function insertFun(type, link, title) {
	    var editorState = this.state.editorState;
	    var contentState = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    //创建Entity
	    var contentStateWithEntity = contentState.createEntity(type, 'mutability', {
	        href: link, title: title
	    });
	    //获取entityKey
	    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
	    if (title && title.length > 0) {
	        //包含title，则替换选中部分
	        contentState = _draftJs.Modifier.insertText(contentState, selection, '' + title,
	        // editorState.getCurrentInlineStyle(),
	        styles.immutable, entityKey);
	    } else {
	        //给选中部分加上链接
	        contentState = _draftJs.Modifier.applyEntity(contentState, selection, entityKey);
	    }
	    var newState = _draftJs.EditorState.push(editorState, contentState, 'insert-characters');
	
	    this.setState({ editorState: newState, visible: false, loading: false });
	};
	
	var myKeyBindingFn = function myKeyBindingFn(e) {
	    if (e.keyCode === 83 /* `S` key */ && hasCommandModifier(e)) {
	        return 'myeditor-save';
	    }
	    return (0, _draftJs.getDefaultKeyBinding)(e);
	};
	
	var getValue = function getValue() {
	    var contentStateToRow = getContentStateToRow.call(this) || {};
	    var blocks = contentStateToRow.blocks || [];
	    var result = "";
	    blocks.forEach(function (element) {
	        result = result + element.text;
	    });
	    return result;
	};
	
	var getHtml = function getHtml() {
	    var contentStateToRow = getContentStateToRow.call(this);
	    if (!contentStateToRow) return null;
	    var html = (0, _draftjsToHtml2.default)(contentStateToRow);
	    return html;
	};
	
	var getContentStateToRowForJson = function getContentStateToRowForJson() {
	    var contentStateToRow = getContentStateToRow.call(this);
	    if (!contentStateToRow) return null;
	    var contentStateToRowJson = JSON.stringify(contentStateToRow);
	    return contentStateToRowJson;
	};
	
	// const getEntityData = function (editorState) {
	//     //获取选中block
	//     const block = getSelectBlock(editorState);
	//     const entityKey = block.getEntityAt(0);
	//     const contentState = editorState.getCurrentContent();
	//     const entity = entityKey ? contentState.getEntity(entityKey) : null;
	//     return entity ? entity.getData() : {};
	// }
	var styles = {
	    root: {
	        fontFamily: '\'Helvetica\', sans-serif',
	        padding: 20,
	        // width: 600,
	        width: "100%"
	    },
	    editor: {
	        border: '1px solid #ccc',
	        cursor: 'text',
	        minHeight: 200,
	        padding: 10,
	        fontSize: 'large'
	    },
	    button: {
	        marginBottom: 10,
	        textAlign: 'center'
	    },
	    immutable: {
	        backgroundColor: 'rgba(0, 0, 0, 0.2)',
	        padding: '2px 0'
	    },
	    mutable: {
	        backgroundColor: 'rgba(204, 204, 255, 1.0)',
	        padding: '2px 0'
	    },
	    segmented: {
	        backgroundColor: 'rgba(248, 222, 126, 1.0)',
	        padding: '2px 0'
	    }
	};
	
	exports.compositeDecorator = compositeDecorator;
	exports.insertFun = insertFun;
	exports.myKeyBindingFn = myKeyBindingFn;
	exports.getValue = getValue;
	exports.getHtml = getHtml;
	exports.getContentStateToRowForJson = getContentStateToRowForJson;
	exports.refreshByContentStateToRowJson = refreshByContentStateToRowJson;
	exports.styles = styles;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.G6Flow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _g = __webpack_require__(2115);
	
	var _g2 = _interopRequireDefault(_g);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { GraphLayoutPredict } from "@antv/vis-predict-engine";
	var G6Flow = exports.G6Flow = function (_Component) {
	  _inherits(G6Flow, _Component);
	
	  function G6Flow(props) {
	    _classCallCheck(this, G6Flow);
	
	    var _this = _possibleConstructorReturn(this, (G6Flow.__proto__ || Object.getPrototypeOf(G6Flow)).call(this, props));
	
	    _this.graph = null;
	
	    _this.state = {
	      data: props.data == null ? {} : props.data,
	      width: props.width,
	      height: props.height
	    };
	    return _this;
	  }
	
	  _createClass(G6Flow, [{
	    key: "transData",
	    value: function transData(data) {
	      /***处理节点 */
	      if (data && data.nodes && data.nodes.length > 0) {
	        data.nodes.forEach(function (item) {
	          if (item.nam && item.nam.length > 8) {
	            item.label = item.nam.substring(0, 8) + "...";
	          } else {
	            item.label = item.nam;
	          }
	          // item.id = item.id;
	          item.description = item.ann;
	          switch (item.typ.toUpperCase()) {
	            case "START":
	              item.type = "rect";
	              item.size = [320, 180];
	              item.style = {
	                stroke: "#237804",
	                fill: "#73d13d",
	                lineWidth: 0,
	                radius: 50
	              };
	              break;
	            case "END":
	              item.type = "rect";
	              item.size = [320, 180];
	              item.style = {
	                stroke: "#CC0033",
	                fill: "#FF0033",
	                lineWidth: 0,
	                radius: 50
	              };
	              item.anchorPoints = [[0.5, 0]];
	              break;
	            case "TASK":
	              // item.type = "rect";
	              // item.size = [320, 120];
	              // item.style = {
	              //   stroke: "#003366",
	              //   fill: "#99CCFF",
	              //   lineWidth: 0,
	              //   radius: 10,
	              // };
	              // break;
	              if (item.nam && item.nam.length > 6) {
	                item.label = item.nam.substring(0, 6) + "...";
	              } else {
	                item.label = item.nam;
	              }
	              item.label = "\uE639   " + item.label;
	              item.labelCfg = {
	                position: "center",
	                style: {
	                  fill: "blue",
	                  fontFamily: "iconfont"
	                }
	              };
	              item.type = "modelRect";
	              item.size = [520, 220];
	              item.style = {
	                stroke: "#003366",
	                fill: "#99CCFF",
	                lineWidth: 0,
	                radius: 50
	              };
	
	              item.preRect = {
	                show: false,
	                fill: "#003366",
	                width: 10
	              };
	              item.logoIcon = {
	                show: false
	              };
	              item.stateIcon = {
	                show: false
	              };
	              break;
	            case "CTSGN":
	              item.type = "ellipse";
	              item.size = [520, 220];
	              item.style = {
	                stroke: "#CC6800",
	                fill: "#FFFF00",
	                lineWidth: 0,
	                radius: 50
	              };
	              break;
	            case "IF":
	              item.type = "diamond";
	              item.size = [520, 220];
	              item.style = {
	                stroke: "#FF9999",
	                fill: "#FFCCCC",
	                lineWidth: 0,
	                radius: 50
	              };
	              break;
	            case "SCRPT":
	              item.type = "modelRect";
	              item.size = [520, 220];
	              item.style = {
	                stroke: "#9966CC",
	                fill: "#CCCCFF",
	                lineWidth: 0,
	                radius: 50
	              };
	              if (item.nam && item.nam.length > 6) {
	                item.label = item.nam.substring(0, 6) + "...";
	              } else {
	                item.label = item.nam;
	              }
	              item.label = "\uE77E   " + item.label;
	              item.labelCfg = {
	                position: "center",
	                style: {
	                  fill: "#663333",
	                  fontFamily: "iconfont"
	                }
	              };
	
	              item.preRect = {
	                show: false,
	                fill: "#003366",
	                width: 10
	              };
	              item.logoIcon = {
	                show: false
	              };
	              item.stateIcon = {
	                show: false
	              };
	              break;
	
	            case "SRV":
	              item.type = "modelRect";
	              item.size = [520, 220];
	              item.style = {
	                stroke: "#669966",
	                fill: "#66CC99",
	                lineWidth: 0,
	                radius: 50
	              };
	              if (item.nam && item.nam.length > 6) {
	                item.label = item.nam.substring(0, 6) + "...";
	              } else {
	                item.label = item.nam;
	              }
	              item.label = "\uE615   " + item.label;
	              item.labelCfg = {
	                position: "center",
	                style: {
	                  fill: "#FFFFCC",
	                  fontFamily: "iconfont"
	                }
	              };
	
	              item.preRect = {
	                show: false,
	                fill: "#003366",
	                width: 10
	              };
	              item.logoIcon = {
	                show: false
	              };
	              item.stateIcon = {
	                show: false
	              };
	              break;
	            case "PARALLEL":
	              // item.type = "diamond";
	              // item.size = [220, 220];
	
	              item.type = "ellipse";
	              item.size = [520, 220];
	              item.height = 80;
	              item.style = {
	                stroke: "#FF9966",
	                fill: "#FFCC99",
	                lineWidth: 0,
	                radius: 10
	              };
	              break;
	            default:
	              break;
	          }
	        });
	      }
	      /***处理线段 */
	      if (data && data.edges && data.edges.length > 0) {
	        data.edges.forEach(function (item) {
	          // if (!item.sourceAnchor) item.sourceAnchor = 2;
	          // if (!item.targetAnchor) item.targetAnchor = 0;
	          if (item.cndtFlg === false) {
	            item.label = "N";
	            item.style = _extends({}, item.style, {
	              offset: 20, // 拐弯处距离节点最小距离
	              radius: 10, // 拐弯处的圆角弧度，若不设置则为直角
	              stroke: "#FF6666"
	            });
	
	            // if (!item.sourceAnchor) item.sourceAnchor = 0;
	            // if (!item.targetAnchor) item.targetAnchor = 2;
	          }
	          if (item.cndtFlg === true) {
	            item.label = "Y";
	          }
	          item.style = _extends({}, item.style, {
	            lineWidth: 6
	          });
	        });
	      }
	      return data;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var me = this;
	      console.log(me.state.data);
	
	      var data = this.transData(me.state.data);
	      me.graph = new _g2.default.Graph({
	        // 省略其他配置
	        layout: {
	          // type: predictLayout.predictLayout,
	          // nodeSize: 50,
	          // preventOverlap: true,
	          type: "dagre",
	          rankdir: "TB", // 可选，默认为图的中心
	          nodesep: 20, // 可选
	          ranksep: 50, // 可选
	          controlPoints: true // 可选
	        },
	        fitView: "autoZoom",
	        //fitView: true,
	        container: "G6FlowPanel",
	        width: me.state.width || 800,
	        height: me.state.height || 800,
	        defaultNode: {
	          // 其他配置
	          anchorPoints: [[0.5, 0], [1, 0.5], [0.5, 1], [0, 0.5]],
	          labelCfg: {
	            style: {
	              fontSize: 50
	            }
	          }
	        },
	        defaultEdge: {
	          // ... 其他属性
	          type: "polyline",
	          style: {
	            stroke: "#722ed1",
	            lineWidth: 2,
	            // ... 其他样式属性,
	            endArrow: {
	              path: _g2.default.Arrow.vee(10, 20, 0),
	              d: 0
	            }
	          },
	          labelCfg: {
	            refY: 20,
	            refX: 20,
	            style: {
	              fontSize: 40
	            }
	          }
	        },
	        modes: {
	          default: [{
	            type: "tooltip",
	            formatText: function formatText(model) {
	              return model.nam;
	            },
	
	            offset: 10
	          }]
	        }
	      });
	      me.graph.data(data);
	      me.graph.render();
	
	      // GraphLayoutPredict.predict(data)
	      //   .then((predictLayout, confidence) => {
	      //     me.graph = new G6.Graph({
	      //       // 省略其他配置
	      //       layout: {
	      //         // type: predictLayout.predictLayout,
	      //         // nodeSize: 50,
	      //         // preventOverlap: true,
	      //         type: "dagre",
	      //         rankdir: "TB", // 可选，默认为图的中心
	      //         nodesep: 20, // 可选
	      //         ranksep: 50, // 可选
	      //         controlPoints: true, // 可选
	      //       },
	      //       fitView: "autoZoom",
	      //       //fitView: true,
	      //       container: "G6FlowPanel",
	      //       width: me.state.width || 800,
	      //       height: me.state.height || 800,
	      //       defaultNode: {
	      //         // 其他配置
	      //         anchorPoints: [
	      //           [0.5, 0],
	      //           [1, 0.5],
	      //           [0.5, 1],
	      //           [0, 0.5],
	      //         ],
	      //         labelCfg: {
	      //           style: {
	      //             fontSize: 50,
	      //           },
	      //         },
	      //       },
	      //       defaultEdge: {
	      //         // ... 其他属性
	      //         type: "polyline",
	      //         style: {
	      //           stroke: "#722ed1",
	      //           lineWidth: 2,
	      //           // ... 其他样式属性,
	      //           endArrow: {
	      //             path: G6.Arrow.vee(10, 20, 0),
	      //             d: 0,
	      //           },
	      //         },
	      //         labelCfg: {
	      //           refY: 20,
	      //           refX: 20,
	      //           style: {
	      //             fontSize: 40,
	      //           },
	      //         },
	      //       },
	      //       modes: {
	      //         default: [
	      //           {
	      //             type: "tooltip",
	      //             formatText(model) {
	      //               return model.nam;
	      //             },
	      //             offset: 10,
	      //           },
	      //         ],
	      //       },
	      //     });
	      //     me.graph.data(data);
	      //     me.graph.render();
	      //   })
	      //   .catch((error) => {
	      //     console.log("error", error);
	      //   });
	    }
	  }, {
	    key: "setData",
	    value: function setData(data) {
	      this.graph.data(data);
	      this.graph.render();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        id: "G6FlowPanel",
	        style: {
	          width: this.state.width || 800,
	          height: this.state.height || 800
	        }
	      });
	    }
	  }]);
	
	  return G6Flow;
	}(_react.Component);
	
	exports.default = G6Flow;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.styles = exports.refreshByContentStateToRowJson = exports.getContentStateToRowForJson = exports.getHtml = exports.getValue = exports.myKeyBindingFn = exports.insertFun = exports.compositeDecorator = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _draftjsToHtml = __webpack_require__(680);
	
	var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);
	
	var _htmlToDraftjs = __webpack_require__(681);
	
	var _htmlToDraftjs2 = _interopRequireDefault(_htmlToDraftjs);
	
	var _draftJs = __webpack_require__(193);
	
	__webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasCommandModifier = _draftJs.KeyBindingUtil.hasCommandModifier;
	
	
	var getEditorState = function getEditorState() {
	    return this.state.editorState;
	};
	var getContentState = function getContentState() {
	    var editorState = getEditorState.call(this);
	    if (!editorState) return null;
	    return editorState.getCurrentContent();
	};
	var getContentStateToRow = function getContentStateToRow() {
	    var contentState = getContentState.call(this);
	    if (!contentState) return null;
	    return (0, _draftJs.convertToRaw)(contentState);
	};
	var getBlocks = function getBlocks() {
	    var contentStateToRow = getContentStateToRow.call(this) || {};
	    return contentStateToRow.blocks;
	};
	
	function findEntitieByType(type, contentBlock, callback, contentState) {
	    // const text = contentBlock.getText();
	    contentBlock.findEntityRanges(function (character) {
	        var entityKey = character.getEntity();
	        return entityKey !== null && contentState.getEntity(entityKey).getType() === type;
	    }, callback);
	};
	function span_onClick() {
	    // alert("我是变量");
	}
	function constant_span_onClick() {
	    // alert("我是常量");
	}
	var TokenSpan = function TokenSpan(props) {
	    var contentState = props.contentState;
	    var blocks = (0, _draftJs.convertToRaw)(contentState);
	    var entityMap = blocks.entityMap;
	    var href = "not found";
	    for (var key in entityMap) {
	        var entity = entityMap[key];
	        if (props.decoratedText === entity.data.title) href = entity.data.href;
	    }
	    return _react2.default.createElement(
	        'span',
	        { title: href, style: { backgroundColor: '#d3adf7', padding: '2px' }, onClick: span_onClick },
	        props.children
	    );
	};
	var ConstantSpan = function ConstantSpan(props) {
	    var contentState = props.contentState;
	    var blocks = (0, _draftJs.convertToRaw)(contentState);
	    var entityMap = blocks.entityMap;
	    var href = "not found";
	    for (var key in entityMap) {
	        var entity = entityMap[key];
	        if (props.decoratedText === entity.data.title) href = entity.data.href;
	    }
	    return _react2.default.createElement(
	        'span',
	        { title: href, style: { backgroundColor: 'rgba(78,238,148, 0.9)', padding: '2px' }, onClick: constant_span_onClick },
	        props.children
	    );
	};
	var findWithRegex = function findWithRegex(regex, contentBlock, callback) {
	    var text = contentBlock.getText();
	    var matchArr = void 0;
	    var start = void 0;
	    while ((matchArr = regex.exec(text)) !== null) {
	        start = matchArr.index;
	        callback(start, start + matchArr[0].length);
	    }
	};
	var compositeDecorator = new _draftJs.CompositeDecorator([
	// {
	//     strategy: findEntitieByType.bind(this, "variable"),
	//     component: TokenSpan,
	// },
	{
	    strategy: function strategy(contentBlock, callback, contentState) {
	        var emojiRegex = /#{(.*?)}/g;
	        findWithRegex(emojiRegex, contentBlock, callback);
	    },
	    component: TokenSpan
	}, {
	    strategy: findEntitieByType.bind(undefined, "constant"),
	    component: ConstantSpan
	}]);
	
	var refreshByContentStateToRowJson = function refreshByContentStateToRowJson(json) {
	    if (!json) return;
	    var jsonObj = typeof json === "string" ? JSON.parse(json) : json;
	    var contentState = (0, _draftJs.convertFromRaw)(jsonObj);
	    var editorState = _draftJs.EditorState.createWithContent(contentState, compositeDecorator);
	    this.setState({ editorState: editorState });
	    return editorState;
	};
	
	var insertFun = function insertFun(type, link, title) {
	    var editorState = this.state.editorState;
	    var contentState = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    //创建Entity
	    var contentStateWithEntity = contentState.createEntity(type, 'mutability', {
	        href: link, title: title
	    });
	    //获取entityKey
	    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
	    if (title && title.length > 0) {
	        //包含title，则替换选中部分
	        contentState = _draftJs.Modifier.insertText(contentState, selection, '' + title,
	        // editorState.getCurrentInlineStyle(),
	        styles.immutable, entityKey);
	    } else {
	        //给选中部分加上链接
	        contentState = _draftJs.Modifier.applyEntity(contentState, selection, entityKey);
	    }
	    var newState = _draftJs.EditorState.push(editorState, contentState, 'insert-characters');
	
	    this.setState({ editorState: newState, visible: false, loading: false });
	};
	
	var myKeyBindingFn = function myKeyBindingFn(e) {
	    if (e.keyCode === 83 /* `S` key */ && hasCommandModifier(e)) {
	        return 'myeditor-save';
	    }
	    return (0, _draftJs.getDefaultKeyBinding)(e);
	};
	
	var getValue = function getValue() {
	    var contentStateToRow = getContentStateToRow.call(this) || {};
	    var blocks = contentStateToRow.blocks || [];
	    var result = "";
	    blocks.forEach(function (element) {
	        result = result + element.text;
	    });
	    return result;
	};
	
	var getHtml = function getHtml() {
	    var contentStateToRow = getContentStateToRow.call(this);
	    if (!contentStateToRow) return null;
	    var html = (0, _draftjsToHtml2.default)(contentStateToRow);
	    return html;
	};
	
	var getContentStateToRowForJson = function getContentStateToRowForJson() {
	    var contentStateToRow = getContentStateToRow.call(this);
	    if (!contentStateToRow) return null;
	    var contentStateToRowJson = JSON.stringify(contentStateToRow);
	    return contentStateToRowJson;
	};
	
	// const getEntityData = function (editorState) {
	//     //获取选中block
	//     const block = getSelectBlock(editorState);
	//     const entityKey = block.getEntityAt(0);
	//     const contentState = editorState.getCurrentContent();
	//     const entity = entityKey ? contentState.getEntity(entityKey) : null;
	//     return entity ? entity.getData() : {};
	// }
	var styles = {
	    root: {
	        fontFamily: '\'Helvetica\', sans-serif',
	        padding: 20,
	        // width: 600,
	        width: "100%"
	    },
	    editor: {
	        border: '1px solid #ccc',
	        cursor: 'text',
	        minHeight: 200,
	        padding: 10,
	        fontSize: 'large'
	    },
	    button: {
	        marginBottom: 10,
	        textAlign: 'center'
	    },
	    immutable: {
	        backgroundColor: 'rgba(0, 0, 0, 0.2)',
	        padding: '2px 0'
	    },
	    mutable: {
	        backgroundColor: 'rgba(204, 204, 255, 1.0)',
	        padding: '2px 0'
	    },
	    segmented: {
	        backgroundColor: 'rgba(248, 222, 126, 1.0)',
	        padding: '2px 0'
	    }
	};
	
	exports.compositeDecorator = compositeDecorator;
	exports.insertFun = insertFun;
	exports.myKeyBindingFn = myKeyBindingFn;
	exports.getValue = getValue;
	exports.getHtml = getHtml;
	exports.getContentStateToRowForJson = getContentStateToRowForJson;
	exports.refreshByContentStateToRowJson = refreshByContentStateToRowJson;
	exports.styles = styles;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SICondition = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _draftJs = __webpack_require__(193);
	
	__webpack_require__(279);
	
	var _SICommon = __webpack_require__(1337);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonGroup = _antd.Button.Group;
	
	var mathOperators = [{ name: '+', code: '+' }, { name: '-', code: '-' }, { name: '×', code: '*' }, { name: '/', code: '/' }, { name: '%', code: '%' }, { name: '^', code: '^' }, { name: '(', code: '(' }, { name: ')', code: ')' }];
	
	var logicOperators = [{ name: 'and', code: '&&' }, { name: 'or', code: '||' }, { name: 'not', code: '!' }];
	
	var relationOperators = [{ name: '>', code: '>' }, { name: '<', code: '<' }, { name: '>=', code: '>=' }, { name: '<=', code: '<=' }, { name: '=', code: '==' }, { name: '!=', code: '!=' }];
	
	var varOperators = [{ name: '变量符', code: '#{}' }];
	
	var SICondition = exports.SICondition = function (_Component) {
	  _inherits(SICondition, _Component);
	
	  function SICondition(props) {
	    _classCallCheck(this, SICondition);
	
	    var _this = _possibleConstructorReturn(this, (SICondition.__proto__ || Object.getPrototypeOf(SICondition)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var initData = _this.props.contentStateToRowJson;
	    var editorState = void 0;
	    if (initData) {
	      editorState = _SICommon.refreshByContentStateToRowJson.call(_this, initData);
	    } else {
	      editorState = _draftJs.EditorState.createEmpty(_SICommon.compositeDecorator);
	    }
	
	    _this.state = {
	      editorState: editorState,
	      visible: false,
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(SICondition, [{
	    key: 'handleKeyCommand',
	    value: function handleKeyCommand(command) {
	      if (command === 'myeditor-save') {
	        this.showModal();
	        return 'handled';
	      }
	      return 'not-handled';
	    }
	
	    // 导入common中的方法
	
	  }, {
	    key: 'getButtons',
	    value: function getButtons() {
	      var mathbuttons = [];
	      var len = mathOperators.length;
	      for (var i = 0; i < len; i++) {
	        mathbuttons.push(_react2.default.createElement(
	          _antd.Button,
	          { key: mathOperators[i].code, onClick: this.insertConstant.bind(this, mathOperators[i].name, mathOperators[i].code) },
	          mathOperators[i].name
	        ));
	      }
	      var logicbuttons = [];
	      for (var _i = 0; _i < logicOperators.length; _i++) {
	        logicbuttons.push(_react2.default.createElement(
	          _antd.Button,
	          { key: logicOperators[_i].code, onClick: this.insertConstant.bind(this, logicOperators[_i].name, logicOperators[_i].code) },
	          logicOperators[_i].name
	        ));
	      }
	      var relationbuttons = [];
	      for (var _i2 = 0; _i2 < relationOperators.length; _i2++) {
	        relationbuttons.push(_react2.default.createElement(
	          _antd.Button,
	          { key: relationOperators[_i2].code, onClick: this.insertConstant.bind(this, relationOperators[_i2].name, relationOperators[_i2].code) },
	          relationOperators[_i2].name
	        ));
	      }
	      var varbuttons = [];
	      for (var _i3 = 0; _i3 < varOperators.length; _i3++) {
	        varbuttons.push(_react2.default.createElement(
	          _antd.Button,
	          { key: varOperators[_i3].code, onClick: this.insertConstant.bind(this, varOperators[_i3].name, varOperators[_i3].code) },
	          varOperators[_i3].name
	        ));
	      }
	      var button = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          ButtonGroup,
	          null,
	          mathbuttons
	        ),
	        '\xA0\xA0',
	        _react2.default.createElement(
	          ButtonGroup,
	          null,
	          logicbuttons
	        ),
	        '\xA0\xA0',
	        _react2.default.createElement(
	          ButtonGroup,
	          null,
	          relationbuttons
	        ),
	        '\xA0\xA0',
	        _react2.default.createElement(
	          ButtonGroup,
	          null,
	          varbuttons
	        ),
	        '\xA0\xA0'
	      );
	
	      return button;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.state.loading) {
	        this.focus();
	        this.setState({ loading: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var buttons = this.getButtons();
	      tool.sgiLogger.log(this.getValue());
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          {
	            title: this.props.title,
	            extra: buttons,
	            style: { width: '100%' }
	          },
	          _react2.default.createElement(
	            'div',
	            { style: _SICommon.styles.editor, onClick: this.focus },
	            _react2.default.createElement(_draftJs.Editor, {
	              editorState: this.state.editorState,
	              onChange: this._onChange,
	              handleKeyCommand: this.handleKeyCommand,
	              keyBindingFn: _SICommon.myKeyBindingFn
	              // placeholder="Enter some text..."
	              , ref: 'editor'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SICondition;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.focus = function () {
	    return _this2.refs.editor.focus();
	  };
	
	  this.showModal = function () {
	    return _this2.setState({ visible: true });
	  };
	
	  this.closeModal = function (e) {
	    return _this2.setState({ visible: false });
	  };
	
	  this._onChange = function (editorState, e, e2) {
	    _this2.setState({ editorState: editorState });
	    var onChange = _this2.props.onChange;
	    if (onChange && typeof onChange === "function") {
	      onChange(_this2, e, e2);
	    }
	  };
	
	  this.insertVariate = _SICommon.insertFun.bind(this, "variable");
	  this.insertConstant = _SICommon.insertFun.bind(this, "constant");
	  this.getValue = _SICommon.getValue.bind(this);
	  this.getHtml = _SICommon.getHtml.bind(this);
	  this.getContentStateToRowForJson = _SICommon.getContentStateToRowForJson.bind(this);
	  this.refreshByContentStateToRowJson = _SICommon.refreshByContentStateToRowJson.bind(this);
	};
	
	exports.default = SICondition;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import 'antd/dist/antd.css';
	// import $ from "jquery";
	// import NodeParaEditSD from "./NodeParaEditSD";
	
	
	// import { brotliDecompress } from "zlib";
	// import {render} from 'react-dom'
	// var jtopo = $('<script src="../../common/jtopo-0.4.8-min.js" type="text/javascript"></script>');
	// $(document.body).before(jtopo);
	var JTopo = window.JTopo;
	var STARTNODETYPE = "01";
	var contextmenu = [{
	    text: "添加跳转",
	    pk: "2",
	    img: "./images/si/jump.png",
	    func: function func(wf) {
	        wf.rmenuClick(wf, "02");
	    }
	}, {
	    text: "添加服务",
	    pk: "3",
	    img: "./images/si/services.png",
	    func: function func(wf) {
	        wf.rmenuClick(wf, "03");
	    }
	}, {
	    text: "添加脚本",
	    pk: "4",
	    img: "./images/si/script.png",
	    func: function func(wf) {
	        wf.rmenuClick(wf, "04");
	    }
	}, {
	    text: "添加子流程",
	    pk: "5",
	    img: "./images/si/child.png",
	    func: function func(wf) {
	        wf.rmenuClick(wf, "05");
	    }
	}, {
	    text: "添加终点",
	    pk: "6",
	    img: "./images/si/end.png",
	    func: function func(wf) {
	        wf.rmenuClick(wf, "99");
	    }
	}, {
	    text: "删除节点",
	    pk: "7",
	    img: "./images/si/delete.png",
	    func: function func(wf) {
	        var node = wf.state.currnode;
	        if (!node) {
	            alert("no selected node");
	            return;
	        }
	        node.remove();
	    }
	}];
	var startNodedata = {
	    serviceid: null, // 服务接口描述
	    servicecallin: [], // 从服务接口描述获取的输入参数列表
	    servicecallout: [], // 服务接口描述服务输出参数列表
	    serviceUrl: null, // 对外暴露的服务请求接口
	    servicecalltype: "0", // 服务调用类型
	    serviceAcynctype: "0", // 服务同步类型
	    servicetimeout: 30, // 服务总超时时间
	    serviceprotocol: "0", // 服务协议类型
	    servicetimeoutHandling: "01", // 服务超时处理机制
	    serviceredoTime: 0, // 服务重做次数
	    serviceredoCycle: "01", // 服务重做周期
	    servicecallbackUrl: "" // 服务撤销处理请求接口
	};
	
	var serviceNodedata = {
	    // 服务节点
	    servicecallin: [], // 服务输入参数列表
	    servicecallout: [], // 服务输入参数列表
	    servicecallMapping: [], // 服务报文映射
	    serviceUrl: null,
	    servicecalltype: "0", // 同异步类型
	    serviceAcynctype: "0", // 异步处理方式  0-回调接口  1-消息订阅
	    servicetimeout: 30,
	    serviceprotocol: "0", // 通讯协议
	    servicetimeoutHandling: "01", // 超时处理机制
	    serviceredoTime: 0, // 重试次数
	    serviceredoCycle: "01", // 重试周期
	    servicecallbackUrl: "" // 回调接口
	};
	var scriptNodedata = {
	    // 脚本节点
	    scripttype: "0", // 默认脚本类型为JavaScript
	    scriptcode: "", // 脚本内容
	    scriptcallin: [], // 服务输入参数列表
	    scriptcallout: [] // 回调接口服务输入参数列表
	};
	
	var ServiceInterface = function (_Component) {
	    _inherits(ServiceInterface, _Component);
	
	    function ServiceInterface(props) {
	        _classCallCheck(this, ServiceInterface);
	
	        var _this = _possibleConstructorReturn(this, (ServiceInterface.__proto__ || Object.getPrototypeOf(ServiceInterface)).call(this, props));
	
	        _this.state = {
	            editpanelWidth: 24, // 节点编辑面板宽度-目前使用抽屉编辑界面
	            root: undefined, // 根节点
	            over: undefined, // 结束节点
	            w: _this.props.width !== null && typeof _this.props.width !== "undefined" ? _this.props.width : "100%", // 当前编辑界面宽度
	            h: _this.props.height !== null && typeof _this.props.height !== "undefined" ? _this.props.height : "790px", // 当前编辑界面高度
	            canvas: undefined, // 绘制对象
	            code: _this.props.code !== null && typeof _this.props.code !== "undefined" ? _this.props.code : "SIEditPanel", // 当前编辑界面id
	            canvasid: _this.props.code !== null && typeof _this.props.code !== "undefined" ? "canvas" + _this.props.code : "canvasSIEditPanel", // 当前绘制界面id
	            editid: _this.props.code !== null && typeof _this.props.code !== "undefined" ? "editid" + _this.props.code : "canvasSIeditidPanel", // 当前绘制界面id
	            currnode: null, // 当前节点
	            currdata: null, // 当前节点数据
	            maxid: 1, // 节点序号使用
	            contextmenu: _this.props.ctxmenu !== null && typeof _this.props.ctxmenu !== "undefined" ? _this.props.ctxmenu : contextmenu,
	            // 自定义点击事件
	            clickfunction: _this.props.clickFunc !== null && typeof _this.props.clickFunc !== "undefined" ? _this.props.clickFunc : _this.clickFunc,
	            // 自定义空白处点击事件
	            blankClickFunc: _this.props.blankClickFunc !== null && typeof _this.props.blankClickFunc !== "undefined" ? _this.props.blankClickFunc : _this.blankClickFunc,
	            // 数据模型
	            model: _this.props.model !== null && typeof _this.props.model !== "undefined" ? _this.props.model : null,
	            // 是否可编辑
	            readOnly: _this.props.readOnly !== null && typeof _this.props.readOnly !== "undefined" ? _this.props.readOnly : true,
	            // 调试标志
	            debug: _this.props.debug !== null && typeof _this.props.debug !== "undefined" ? _this.props.debug : false,
	            objFct: _this.props.objFct,
	            uids: _this.props.uids !== null && typeof _this.props.uids !== "undefined" ? _this.props.uids : []
	        };
	        return _this;
	    }
	
	    _createClass(ServiceInterface, [{
	        key: "clickfunction",
	        value: function clickfunction(node, model) {
	            var me = this;
	            if (node.type !== STARTNODETYPE) {
	                me.setState({ editpanelWidth: 18 });
	            } else {
	                me.setState({ editpanelWidth: 24 });
	            }
	        }
	    }, {
	        key: "sceneClickFcuntion",
	        value: function sceneClickFcuntion() {
	            // 界面点击方法
	        }
	    }, {
	        key: "init",
	        value: function init() {
	            var baseDom = document.getElementById(this.state.canvasid);
	            var editpanel = document.getElementById(this.state.editid);
	            baseDom.width = editpanel.clientWidth;
	            baseDom.height = editpanel.clientHeight;
	            this.canvas = this.scene(baseDom);
	            if (this.state.model) {
	                if (!this.maxid) {
	                    this.maxid = 0;
	                }
	                this.drawRoot(this.state.model, this.state.readOnly);
	                this.maxid++;
	            } else {
	                if (!this.maxid) {
	                    this.maxid = 1;
	                }
	                var start = this.newData(null, STARTNODETYPE);
	                this.drawRoot(start);
	            }
	        }
	        // 绘制画布
	
	    }, {
	        key: "scene",
	        value: function scene(domNode) {
	            var me = this;
	            var stage = new JTopo.Stage(domNode); // 创建一个舞台对象
	            var scene = new JTopo.Scene(stage); // 创建一个场景对象
	            stage.wheelZoom = 0.9;
	            scene.mode = "normal";
	            if (me.readOnly) {
	                stage.mode = "drag";
	            }
	            stage.wheelZoom = null;
	            stage.click(function (event) {
	                // 关闭弹出菜单（div）
	                me._hideMenu("ctxmenu");
	                if (!me.nodeclick) {
	                    // 标识这次执行的是空白处的点击事件
	                    me.sceneClickFcuntion();
	                }
	                me.nodeclick = false;
	            });
	            return scene;
	        }
	        // 绘制流程图
	
	    }, {
	        key: "drawRoot",
	        value: function drawRoot(model, type) {
	            var me = this;
	            if (!this.canvas) {
	                me.init();
	            }
	            // this.root:model});
	            var jumps = [];
	            var nodes = [];
	            var draw = function draw(model) {
	                if (!model) {
	                    return;
	                }
	                var node = me.getnode(model, model.type, type);
	                if (model.type === STARTNODETYPE) {
	                    // me.root=node;
	                    // me.currnode=node;
	                    me.setState({ root: node, currnode: node });
	                }
	                if (!node) {
	                    tool.sgiLogger.log("create node failed," + model);
	                    return undefined;
	                }
	                nodes.push(node);
	                me.canvas.add(node);
	                var children = model.childNode;
	                if (!children) {
	                    if (model.type === "02") {
	                        jumps.push(node);
	                    }
	                    if (!me.maxid) {
	                        me.maxid = 0;
	                    }
	                    if (node.data.id > me.maxid) {
	                        me.maxid = node.data.id;
	                    }
	                    tool.sgiLogger.log(model.name + " no children");
	                    return node;
	                }
	                var downnodes = [];
	                for (var i = 0; i < children.length; i++) {
	                    var n = draw(children[i]);
	                    if (n) {
	                        if (!n.parentsNode) {
	                            n.parentsNode = [];
	                        }
	                        n.parentsNode.push(node);
	                        downnodes.push(n);
	                    }
	                }
	                node.to = downnodes;
	                for (var j = 0; j < downnodes.length; j++) {
	                    var link = me.line(node, downnodes[j]);
	                    if (link) {
	                        me.canvas.add(link);
	                    }
	                }
	                if (!me.maxid) {
	                    me.maxid = 0;
	                }
	                if (node.data.id > me.maxid) {
	                    me.maxid = node.data.id;
	                }
	                // if (node.data.type==="02") jumps.push(node);
	                return node;
	            };
	            var node = draw(model);
	            for (var n = 0; n < jumps.length; n++) {
	                var jpnode = jumps[n];
	                for (var m = 0; m < nodes.length; m++) {
	                    tool.sgiLogger.log(nodes[m].id);
	                    if (jpnode.data.ncode === nodes[m].data.id) {
	                        var link = me.dottedline(jpnode, nodes[m]);
	                        jpnode.dotline = link;
	                        me.canvas.add(link);
	                        break;
	                    }
	                }
	            }
	            return node;
	        }
	    }, {
	        key: "clear",
	        value: function clear() {
	            if (this.canvas) {
	                this.canvas.clear();
	            }
	        }
	        // 根据数据创建节点
	
	    }, {
	        key: "create",
	        value: function create(currentNode, model) {
	            if (!model) {
	                return;
	            }
	            var me = this;
	            if (!this.canvas) {
	                me.init();
	            }
	            var node = me.getnode(model, model.type);
	            if (model.type === STARTNODETYPE) {
	                // me.root = node
	                // me.currnode = node
	                me.setState({ root: node, currnode: node });
	            }
	            if (!node) {
	                tool.sgiLogger.log("unsupport node type : " + model.type);
	                return;
	            }
	            if (currentNode && node) {
	                me.canvas.add(node);
	                var link = me.line(currentNode, node);
	                me.canvas.add(link);
	            }
	            return node;
	        }
	    }, {
	        key: "remove",
	        value: function remove(node) {
	            var me = this;
	
	            if (node.data && node.data.type && node.data.type === "02") {
	                var dotline = node.dotline;
	                if (me.canvas && dotline) {
	                    me.canvas.remove(dotline);
	                }
	                if (dotline && dotline.nodeA && dotline.nodeA.type === "temp") {
	                    me.canvas.remove(dotline.nodeA);
	                }
	
	                if (dotline && dotline.nodeZ && dotline.nodeZ.type === "temp") {
	                    me.canvas.remove(dotline.nodeZ);
	                }
	            }
	            if (me.canvas) {
	                if (node.fromlines && node.fromlines.length > 0) {
	                    node.fromlines.forEach(function (line) {
	                        if (line && line.nodeA && line.nodeA.type === "temp") {
	                            me.canvas.remove(line.nodeA);
	                            me.canvas.remove(line);
	                        }
	
	                        if (line && line.nodeZ && line.nodeZ.type === "temp") {
	                            me.canvas.remove(line.nodeZ);
	                            me.canvas.remove(line);
	                        }
	                    });
	                }
	
	                if (node.tolines && node.tolines.length > 0) {
	                    node.tolines.forEach(function (line) {
	                        if (line && line.nodeA && line.nodeA.type === "temp") {
	                            me.canvas.remove(line.nodeA);
	                            me.canvas.remove(line);
	                        }
	
	                        if (line && line.nodeZ && line.nodeZ.type === "temp") {
	                            me.canvas.remove(line.nodeZ);
	                            me.canvas.remove(line);
	                        }
	                    });
	                }
	
	                me.canvas.remove(node);
	            }
	        }
	    }, {
	        key: "line",
	        value: function line(fromNode, toNode) {
	            var me = this;
	            var line = new JTopo.Link(fromNode, toNode);
	
	            line.lineWidth = 1; // 线宽
	            line.arrowsRadius = 5; // 箭头大小
	            line.textOffsetY = 3; // 文本偏移量(向下3个像素)
	            line.strokeColor = "192,192,192";
	            // line.bundleOffset = 60; // 折线拐角处的长度
	            // line.bundleGap = 20; // 线条之间的间隔
	
	            fromNode.setToline(line);
	            toNode.setFromline(line);
	
	            if (!me.state.readOnly) {
	                line.addEventListener("dbclick", function (e) {
	                    // var anode = this.nodeA;
	                    // var tempstart = me.lineStartNode(anode.x, anode.y, this);
	
	                    var anode = this.nodeA;
	                    var znode = this.nodeZ;
	
	                    if (znode && line.nodeZ.type !== "temp" && anode && line.nodeA.type !== "temp") {
	                        var tempstart = me.lineEndNode(znode.x - 35, znode.y, this);
	                        me.canvas.add(tempstart);
	                        for (var i = 0; i < anode.tolines.length; i++) {
	                            if (anode.tolines[i].nodeA === anode && anode.tolines[i].nodeZ === tempstart) {
	                                // anode.tolines[i].nodeZ = tempstart;
	                                if (anode.data.childNode) {
	                                    anode.data.childNode.splice(i, 1);
	                                }
	                            }
	                        }
	                        for (var _i = 0; _i < znode.fromlines.length; _i++) {
	                            if (znode.fromlines[_i].nodeA === anode && znode.fromlines[_i].nodeZ === tempstart) {
	                                // anode.tolines[i].nodeZ = tempstart;
	                                znode.fromlines.splice(_i, 1);
	                            }
	                        }
	                    }
	                });
	            }
	
	            return line;
	        }
	    }, {
	        key: "dottedline",
	        value: function dottedline(fromNode, toNode) {
	            var link = this.line(fromNode, toNode);
	            link.dashedPattern = 5; // 虚线
	            return link;
	        }
	    }, {
	        key: "lineStartNode",
	        value: function lineStartNode(x, y, line) {
	            var me = this;
	            var lsn = me._tempNode(x, y);
	
	            line.nodeA = lsn;
	            lsn.toline = line;
	
	            return lsn;
	        }
	    }, {
	        key: "lineEndNode",
	        value: function lineEndNode(x, y, line) {
	            var me = this;
	            var len = me._tempNode(x, y);
	
	            line.nodeZ = len;
	            len.fromline = line;
	
	            return len;
	        }
	    }, {
	        key: "jumpLine",
	        value: function jumpLine(node) {
	            var me = this;
	            var temp = me._tempNode(node.x + 130, node.y + 30);
	            temp.addEventListener("mousedrag", function (e) {
	                // me.dragnode = this;
	                me.setState({ dragnode: this });
	            });
	            var dotline = me.dottedline(node, temp);
	
	            dotline.nodeZ = temp;
	            temp.fromline = dotline;
	
	            this.canvas.add(temp);
	            this.canvas.add(dotline);
	
	            node.dotline = dotline;
	
	            return dotline;
	        }
	    }, {
	        key: "_addNodeListener",
	        value: function _addNodeListener(node) {
	            var me = this;
	            node.addEventListener("click", function (e) {
	                // if (!me.nodedrag) {
	                //     me.state.clickfunction(node, me);
	                //     me.nodeclick = true; // 标识这次执行的是node的点击事件
	                // }
	                // me.nodedrag = false;
	            });
	            node.addEventListener("dbclick", function (e) {
	                me.state.clickfunction(node, me);
	            });
	            node.addEventListener("mouseup", function (e) {
	                if (e.button === 2) {
	                    // 右键
	                    me.rclickFunc(node);
	                    me._showMenu(this, "ctxmenu");
	                }
	            });
	            node.addEventListener("mousedown", function (e) {
	                // tool.sgiLogger.log("mousedown:"+this);
	            });
	            node.addEventListener("mouseover", function (e) {
	                if (me.state.dragnode) {
	                    var current = this;
	                    var temp = me.state.dragnode;
	                    var line = void 0;
	                    if (temp.toline) {
	                        line = temp.toline;
	                        // var downNode = line.nodeZ;
	                        var tonode = line.nodeZ;
	                        if (tonode && tonode.type !== "temp") {
	                            // var childnodes = current.data.cldSet;
	
	                            for (var i = 0; i < tonode.fromlines.length; i++) {
	                                if (tonode.fromlines[i].nodeA === current && tonode.fromlines[i].nodeZ === tonode) {
	                                    return;
	                                }
	                            }
	
	                            current.setToline(line);
	                            var childnodes = current.data.childNode;
	                            if (!childnodes) {
	                                childnodes = [];
	                                // current.data.cldSet = childnodes;
	                                current.data.childNode = childnodes;
	                            }
	                            childnodes.push(tonode.data);
	                        }
	                    } else {
	                        line = temp.fromline;
	                        var upNode = line.nodeA;
	                        if (current === upNode) {
	                            return;
	                        }
	                        for (var _i2 = 0; _i2 < upNode.tolines.length; _i2++) {
	                            if (upNode.tolines[_i2].nodeA === upNode && upNode.tolines[_i2].nodeZ === current) {
	                                return;
	                            }
	                        }
	                        for (var _i3 = 0; _i3 < current.fromlines.length; _i3++) {
	                            if (current.fromlines[_i3].nodeA === upNode && current.fromlines[_i3].nodeZ === current) {
	                                return;
	                            }
	                        }
	                        current.setFromline(line);
	                        if (upNode && upNode.type !== "temp" && upNode.data.type !== "02") {
	                            var _childnodes = upNode.data.childNode;
	                            if (_childnodes) {
	                                _childnodes.push(current.data);
	                            }
	
	                            // upNode.data.gotoNodeId = current.data.id;
	                            // upNode.data.ncode = current.data.id;
	                        }
	                        if (upNode && upNode.type !== "temp" && upNode.data.type === "02") {
	                            upNode.data.gotoNodeId = current.data.id;
	                            upNode.data.ncode = current.data.id;
	                            upNode.click();
	                            // me.refs.NodeParaEditSD.refs.jumppanel.setFieldsValue({
	                            //   ncode: upNode.data.ncode
	                            // });
	                        }
	                        // upNode.data.transfer = current.data.sc ;
	                    }
	                    me.remove(temp);
	                    me.setState({ dragnode: undefined });
	                }
	            });
	            node.addEventListener("mousedrag", function (e) {
	                if (this.data) {
	                    if (this.data.x !== this.x || this.data.y !== this.y) {
	                        me.setState({ nodedrag: true });
	                    }
	                    this.data.x = this.x;
	                    this.data.y = this.y;
	                }
	            });
	        }
	    }, {
	        key: "_setModelPubFiedls",
	        value: function _setModelPubFiedls(model, node) {
	            var me = this;
	            node.data = model;
	            node.createNextNode = function (data) {
	                return me.create(this, data);
	            };
	            node.remove = function () {
	                var delNode = this;
	                var downlines = delNode.tolines;
	                if (downlines) {
	                    for (var _i4 = 0; _i4 < downlines.length; _i4++) {
	                        var _line = downlines[_i4];
	                        var tempstart = me.lineStartNode(delNode.x, delNode.y, _line);
	                        me.canvas.add(tempstart);
	                    }
	                }
	                delNode.tolines = [];
	
	                if (typeof me.state.over !== "undefined" && delNode.type === "99") {
	                    me.setState({ over: undefined });
	                }
	                me.remove(delNode);
	                var pnodes = delNode.parentsNode;
	                if (pnodes) {
	                    for (var j = 0; j < pnodes.length; j++) {
	                        if (pnodes[j].data.childNode) {
	                            for (var _i5 = 0; _i5 < pnodes[j].data.childNode.length; _i5++) {
	                                if (pnodes[j].data.childNode[_i5].id === delNode.data.id) {
	                                    pnodes[j].data.childNode.splice(_i5, 1);
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                    for (var _j = 0; _j < pnodes.length; _j++) {
	                        var _downlines = pnodes[_j].tolines;
	                        if (_downlines) {
	                            for (var i = 0; i < _downlines.length; i++) {
	                                var line = _downlines[i];
	                                if (line.nodeZ === delNode) {
	                                    pnodes[_j].tolines.splice(i, 1);
	                                }
	                            }
	                        }
	                    }
	                }
	            };
	            node.setToline = function (line) {
	                if (!this.tolines) {
	                    this.tolines = [];
	                }
	                this.tolines.push(line);
	
	                line.nodeA = this;
	            };
	            node.setFromline = function (line) {
	                if (!this.fromlines) {
	                    this.fromlines = [];
	                }
	                this.fromlines.push(line);
	
	                line.nodeZ = this;
	            };
	            node.getChart = function () {
	                return me;
	            };
	
	            node.id = model.sc;
	        }
	    }, {
	        key: "getnode",
	        value: function getnode(model, nodetype, type) {
	            var nodetypes = [STARTNODETYPE, "02", "03", "04", "05", "06", "99"];
	            if (nodetypes.indexOf(nodetype) < 0) {
	                return null;
	            }
	            var name = void 0;
	            switch (nodetype) {
	                case STARTNODETYPE:
	                    name = "开始";
	                    break;
	                case "02":
	                    name = "跳转节点";
	                    break;
	                case "03":
	                    name = "服务节点";
	                    break;
	                case "04":
	                    name = "脚本节点";
	                    break;
	                case "05":
	                    name = "子流程";
	                    break;
	                case "06":
	                    name = "任务节点";
	                    break;
	                case "99":
	                    name = "结束";
	                    break;
	
	                default:
	                    break;
	            }
	            var node = new JTopo.Node(model.id + " " + name);
	            if (!node) {
	                return node;
	            }
	            // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
	            node.font = "12px Consolas";
	            node.textPosition = "Middle_Center"; // 文字居中
	            node.fontColor = "0 ,0 ,0";
	            // node.borderRadius = 5; // 圆角
	            node.borderWidth = "1"; // 边框的宽度
	            node.borderColor = "255,255,255"; // 边框颜色
	            node.alpha = 0.9; // 透明度
	            // node.textPosition = "Middle_Center";
	            // node.setSize(58, 58);
	            if (nodetype) {
	                node.type = nodetype;
	            }
	            if (!model.name) {
	                model.name = name;
	            }
	            if (nodetype === STARTNODETYPE || nodetype === "99") {
	                node.beginDegree = 0;
	                node.width = node.height = 80;
	                node.paint = function (g) {
	                    g.beginPath();
	                    g.moveTo(0, 0);
	                    g.fillStyle = "rgba(255,140,0," + this.alpha + ")";
	                    g.arc(0, 0, this.width / 2, this.beginDegree, this.beginDegree + 2 * Math.PI);
	                    g.fill();
	                    g.closePath();
	
	                    g.save();
	                    g.beginPath();
	                    g.fillStyle = "rgba(255,239,213," + this.alpha + ")";
	                    g.moveTo(0, 0);
	                    g.arc(0, 0, this.width / 2 - 2, this.beginDegree, this.beginDegree + 2 * Math.PI);
	                    g.fill();
	                    g.closePath();
	                    g.restore();
	
	                    this.paintText(g);
	                };
	
	                // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
	                node.font = "12px Consolas";
	                node.textPosition = "Middle_Center"; // 文字居中
	                node.fontColor = "0 ,0 ,0";
	                // node.setSize(58, 58);
	                if (nodetype) {
	                    node.type = nodetype;
	                }
	                if (!model.name) {
	                    model.name = name;
	                }
	                node.radius = 50; // 半径
	                node.borderColor = "255,140,0"; // 边框颜色
	                node.fillColor = "	255,239,213"; // 边框颜色
	                // node.setImage(require('./images/start.png'));
	                if (nodetype === "99") {
	                    this.setState({ over: node });
	                }
	            } else {
	                node.borderWidth = 1; // 边框的宽度
	                node.setText = function (str) {
	                    if (!str) {
	                        this.text = name;
	                    }
	                    this.text = str;
	                };
	                if (model && model.name) {
	                    node.setText(model.id + " " + model.name);
	                }
	                if (nodetype === "02") {
	                    // node.fillColor = '255 ,255 ,0';
	                    node.setSize(70, 70);
	                    // node.rotate=45*Math.PI/180;
	                    node.borderRadius = 5; // 圆角
	                    node.fillColor = "127,255,170";
	                    node.borderColor = "50,205,50"; // 边框颜色
	                    // node.setImage(require('./images/jump_done.png'));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/jump_undo.png"));
	                        node.fillColor = "119 136 153";
	                        node.borderColor = "105 105 105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.fontColor = "30 144 255";
	                    }
	                }
	                if (nodetype === "03") {
	                    node.setSize(100, 60);
	                    node.borderRadius = 5; // 圆角
	                    node.fillColor = "250,128,114";
	                    node.borderColor = "255,0,0"; // 边框颜色
	                    // node.setImage(require('./images/service_done.png'));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/service_undo.png"));
	                        node.fillColor = "119 136 153";
	                        node.borderColor = "105 105 105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.fontColor = "30 144 255";
	                    }
	                }
	                if (nodetype === "04") {
	                    node.fillColor = "250 ,235 ,215";
	                    node.setSize(100, 60);
	                    node.borderRadius = 27; // 圆角
	                    node.fillColor = "255,20,147";
	                    node.borderColor = "255,215,0"; // 边框颜色
	                    // node.setImage(require('./images/script_done.png'));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/script_undo.png"));
	                        node.fillColor = "119 136 153";
	                        node.borderColor = "105 105 105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.fontColor = "30 144 255";
	                    }
	                }
	
	                if (nodetype === "05") {
	                    node.fillColor = "188 ,143 ,143";
	                    node.setSize(110, 60);
	                    node.borderRadius = 30; // 圆角
	                    node.fillColor = "	221,160,221";
	                    node.borderColor = "148,0,211"; // 边框颜色
	                    // node.setImage(require('./images/workflow_done.png'));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/workflow_undo.png"));
	                        node.fillColor = "119 136 153";
	                        node.borderColor = "105 105 105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.fontColor = "30 144 255";
	                    }
	                }
	                if (nodetype === "06") {
	                    // node.fillColor = "135 206 250";
	                    node.setSize(100, 60);
	                    node.borderRadius = 20; // 圆角
	                    node.fillColor = "142,229,238";
	                    node.borderColor = "30,144,255"; // 边框颜色
	                    // node.setImage(require("./images/task_done.png"));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/task_undo.png"));
	                        node.fillColor = "119 136 153";
	                        node.borderColor = "105 105 105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.fontColor = "30 ,144 ,255";
	                    }
	                }
	            }
	
	            node.setLocation(model.x, model.y);
	            this._setModelPubFiedls(model, node);
	            if (!type) {
	                this._addNodeListener(node);
	            } else {
	                // 当前执行节点  加特殊标识
	                if (model && model.status) {
	                    node.percent = 0.8;
	                    node.beginDegree = 0;
	                    if (model.status === "01" || model.status === "99") {
	                        if (model.status === "01") {
	                            node.color = "rgba(0,255,0,";
	                        }
	                        if (model.status === "99") {
	                            node.color = "rgba(255,0,0,";
	                        }
	                        // if (model.status === "03") node.color='rgba(143,153,159,';
	                        // if (model.status === "04") node.color='rgba(245,255,0,' ;
	                        // if (model.status === "05") node.color='rgba(244,248,244,';
	                        // if (model.status === "02") node.color='rgba(30 ,144 ,255,' ;
	                        if (model.status !== "01") {
	                            node.percent = 1;
	                        } else {
	                            node.percent = 0.1;
	                        }
	                        node.paint = function (g) {
	                            //
	                            g.save();
	                            g.beginPath();
	                            g.moveTo(0, 0);
	                            g.strokeStyle = this.color + this.alpha + ")";
	                            g.lineWidth = 6;
	                            g.arc(0, 0, (this.width + 3) / 2, this.beginDegree, this.beginDegree + 2 * Math.PI * this.percent);
	                            // g.fill();
	                            g.stroke();
	                            g.closePath();
	                            g.beginPath();
	                            g.moveTo(0, 0);
	                            g.drawImage(this.image, -this.width / 2, -this.height / 2, 38, 38);
	                            // g.fillStyle = 'rgba(0,0,255,' + this.alpha + ')';
	                            // g.moveTo(0,0);
	                            // g.arc(0, 0, this.width/2-8, this.beginDegree, this.beginDegree + 2*Math.PI);
	                            // g.fill();
	                            g.closePath();
	                            g.restore();
	                            this.paintText(g);
	                        };
	                        if (model.status === "01") {
	                            JTopo.Animate.stepByStep(node, {
	                                percent: 1
	                            }, 5000, true).start();
	                        }
	                    }
	                }
	            }
	            return node;
	        }
	    }, {
	        key: "_tempNode",
	        value: function _tempNode(x, y) {
	            var me = this;
	
	            var temp = new JTopo.CircleNode("连接点");
	            temp.type = "temp";
	            temp.fontColor = "0 0 0";
	            temp.fillColor = "0 0 0";
	            temp.setLocation(x, y);
	            temp.radius = 8;
	
	            temp.setFromline = function (line) {
	                if (!this.fromlines) {
	                    this.fromlines = [];
	                }
	                this.fromlines.push(line);
	
	                line.nodeZ = this;
	            };
	            temp.setToline = function (line) {
	                if (!this.tolines) {
	                    this.tolines = [];
	                }
	                this.tolines.push(line);
	
	                line.nodeA = this;
	            };
	
	            temp.addEventListener("mousedrag", function (e) {
	                me.setState({ dragnode: this });
	            });
	
	            temp.addEventListener("mouseout", function (e) {
	                // me.dragnode = undefined;
	            });
	
	            return temp;
	        }
	    }, {
	        key: "_createMenu",
	        value: function _createMenu(id, items, node, event) {
	            if (!items) {
	                return;
	            }
	            var e = event || window.event;
	            var me = this;
	            var child = document.getElementById(id);
	            if (child) {
	                child.parentNode.removeChild(child);
	            }
	
	            var wrapUl = document.createElement("ul");
	            wrapUl.setAttribute("id", id);
	            wrapUl.setAttribute("style", "position:fixed;top:" + e.clientY + "px;left:" + e.clientX + "px;width:110px;border-radius:3px;border:1px solid rgb(120, 120, 120);padding:0;margin:0;box-shadow:2px 2px 10px 0px rgb(200,200,200);font-size: 13px;");
	            for (var i = 0; i < items.length; i++) {
	                if (node.type === STARTNODETYPE && items[i].pk >= "7") {
	                    continue;
	                }
	                if (node.type === "99" && items[i].pk < "7") {
	                    continue;
	                }
	                if (node.type === "02" && items[i].pk < "7") {
	                    continue;
	                }
	                if (typeof this.over !== "undefined" && items[i].pk === "6") {
	                    continue;
	                }
	                var item = document.createElement("li");
	                item.setAttribute("style", "list-style-type:none;width:110px;background-color:rgb(240,240,240);");
	                var inneritem = document.createElement("a");
	                inneritem.onmouseover = function () {
	                    this.style.backgroundColor = "rgb(80,143,224)";
	                    this.style.color = "white";
	                };
	                inneritem.onmouseout = function () {
	                    this.style.backgroundColor = "rgb(240,240,240)";
	                    this.style.color = "";
	                };
	                inneritem.setAttribute("style", "margin:0 auto;border-bottom:1px solid rgb(210, 210, 210);display:block;width:110px;padding:2px 0 2px 2px;fontSize:14px;font-weight:400;background-color:rgb(240,240,240);");
	                inneritem.innerHTML = "<img src='" + items[i].img + "' style='height:25px;width:25px'/>&nbsp;&nbsp;&nbsp;" + items[i].text;
	                inneritem.func = items[i].func;
	                inneritem.onclick = function () {
	                    this.func(me);
	                    me._hideMenu("ctxmenu");
	                };
	                item.appendChild(inneritem);
	                wrapUl.appendChild(item);
	            }
	            document.body.appendChild(wrapUl);
	        }
	    }, {
	        key: "_showMenu",
	        value: function _showMenu(node, id, event) {
	            // let e = event || window.event;
	            this._createMenu(id, this.state.contextmenu, node);
	        }
	    }, {
	        key: "_hideMenu",
	        value: function _hideMenu(id) {
	            if (document.getElementById(id)) {
	                document.getElementById(id).style.display = "none";
	            }
	        }
	        /** *
	        * 节点点击事件
	        */
	
	    }, {
	        key: "rclickFunc",
	        value: function rclickFunc(node) {
	            this.setState({ currnode: node });
	            this.setState({ currdata: node.data });
	        }
	    }, {
	        key: "getNodeData",
	        value: function getNodeData(node, id) {
	            if (node.data.id === id) {
	                return node.data;
	            }
	            if (node.data.childNode) {
	                for (var i = 0; i < node.data.childNode.length; i++) {
	                    var re = this.getNodeData(node.data.childNode[i]);
	                    if (re) {
	                        return re;
	                    }
	                }
	            }
	            return null;
	        }
	    }, {
	        key: "setNodeData",
	        value: function setNodeData(data, id, node) {
	            var nodeid = void 0;
	            if (node === null) {
	                node = this.state.root;
	                nodeid = node.data.id;
	            } else {
	                nodeid = node.id;
	            }
	            if (nodeid === id) {
	                node.data = data;
	                return 0;
	            }
	            if (node.data.childNode) {
	                for (var i = 0; i < node.data.childNode.length; i++) {
	                    var re = this.setNodeData(data, id, node.data.childNode[i]);
	                    if (re === 0) {
	                        return re;
	                    }
	                }
	            }
	            return 1;
	        }
	    }, {
	        key: "clickFunc",
	        value: function clickFunc(node, wf) {
	            wf.setState({ currnode: node });
	            wf.setState({ currdata: node.data });
	            if (node.type === "99") {
	                return;
	            }
	            tool.setActiveWV("FLOWNodePanel", wf.state.objFct);
	            wf.state.objFct.set("currenttype", node.type);
	            wf.state.objFct.set("currentid", node.data.id);
	            // let descript=wf.state.objFct.get("editGSconfig");
	            // node.data=wf.getNodeData(descript,node.data.id);
	
	            var inCondition = tool.getVal(node.data, "inConditionExp");
	            var outCondition = tool.getVal(node.data, "outConditionExp");
	            var inConditionCtl = tool.createElement("SICondition", {
	                key: tool.uuid(8),
	                objFct: wf.state.objFct,
	                moduleDesc: { cId: "inCondition" + node.type },
	                contentStateToRowJson: inCondition
	            }, null, true);
	            var outConditionCtl = tool.createElement("SICondition", {
	                key: tool.uuid(8),
	                objFct: wf.state.objFct,
	                moduleDesc: { cId: "outCondition" + node.type },
	                contentStateToRowJson: outCondition
	            }, null, true);
	            var inpanel = void 0,
	                outpanel = void 0;
	            // 显示编辑界面
	            switch (node.type) {
	                case STARTNODETYPE:
	                    // var editGSconfig=wf.state.objFct.get("editGSconfig");
	
	                    wf.state.objFct.set("StartNodeData", node.data);
	                    tool.setActiveWV("FlowStartNodePanel", wf.state.objFct);
	                    tool.refreshWV("StartNodeForm", wf.state.objFct);
	
	                    // tool.popUI(wf.state.uids[0], wf.state.objFct, "开始节点配置", 1024, 800);
	                    break;
	                case "02":
	                    // name = "跳转节点";
	
	                    wf.state.objFct.set("JPNodeData", node.data);
	                    tool.setActiveWV("FlowJumpPanel", wf.state.objFct);
	                    tool.refreshWV("JPNodeForm", wf.state.objFct);
	
	                    inpanel = tool.getCmp("jumpinConditionPanel", wf.state.objFct);
	                    outpanel = tool.getCmp("jumpoutConditionPanel", wf.state.objFct);
	                    // tool.popUI(wf.state.uids[1], wf.state.objFct, "跳转节点配置", 1024, 800);
	                    break;
	                case "03":
	                    // name = "服务节点";
	
	                    wf.state.objFct.set("SIMsgData", []);
	                    wf.state.objFct.set("SVData", []);
	                    wf.state.objFct.set("SVNodeMappingData", []);
	                    wf.state.objFct.set("SVNodeMappingData", node.data.SVNodeMappingData);
	                    wf.state.objFct.set("SVNodeData", node.data);
	                    var currentSVRoot = wf.state.objFct.get("currentSVRoot");
	
	                    var mconfig = tool.getVal(currentSVRoot, "cldSet");
	                    var data = [];
	                    var tmp = [];
	                    var flag = 1;
	
	                    mconfig.forEach(function (element) {
	                        if (element.cldSet) {
	                            element.cldSet.forEach(function (cld) {
	                                cld.IO = element.iobType;
	                                data.push(cld);
	                            });
	                        }
	                    });
	                    if (node.data.SVNodeMappingData) {
	                        for (var j = 0; j < data.length; j++) {
	                            flag = 1;
	                            for (var i = 0; i < node.data.SVNodeMappingData.length; i++) {
	                                if (data[j].code === node.data.SVNodeMappingData[i].SIBusKey && data[j].IO === node.data.SVNodeMappingData[i].IO) {
	                                    flag = 0;
	                                    break;
	                                }
	                            }
	                            if (flag === 1) {
	                                tmp.push(data[j]);
	                            }
	                        }
	                        wf.state.objFct.set("SIMsgData", tmp);
	                    } else {
	                        wf.state.objFct.set("SIMsgData", data);
	                    }
	                    tool.refreshTable("SIMsgTable", wf.state.objFct);
	
	                    if (node.data.serviceID) {
	                        var callsi = PrmFactory.getPrm(node.data.serviceID);
	                        var siconfig = tool.getVal(callsi, "cldSet");
	                        var calldata = [];
	                        var calldatatmp = [];
	                        if (callsi.sitype == "03") {
	                            siconfig.forEach(function (element) {
	                                var tmp = {
	                                    code: element.oKey,
	                                    nam: element.n,
	                                    IO: element.iobType,
	                                    ptn: element.desId
	                                };
	                                calldata.push(tmp);
	                            });
	                        }
	                        if (callsi.sitype == "02") {
	                            siconfig.forEach(function (element) {
	                                if (element.cldSet) {
	                                    element.cldSet.forEach(function (cld) {
	                                        cld.IO = element.iobType;
	                                        calldata.push(cld);
	                                    });
	                                }
	                            });
	                        }
	                        if (node.data.SVNodeMappingData) {
	                            for (var _j2 = 0; _j2 < calldata.length; _j2++) {
	                                flag = 1;
	                                for (var _i6 = 0; _i6 < node.data.SVNodeMappingData.length; _i6++) {
	                                    if (calldata[_j2].code === node.data.SVNodeMappingData[_i6].SVBusKey && calldata[_j2].IO === node.data.SVNodeMappingData[_i6].IO) {
	                                        flag = 0;
	                                        break;
	                                    }
	                                }
	                                if (flag === 1) {
	                                    calldatatmp.push(calldata[_j2]);
	                                }
	                            }
	                            wf.state.objFct.set("SVData", calldatatmp);
	                        } else {
	                            wf.state.objFct.set("SVData", calldatatmp);
	                        }
	                        tool.refreshTable("SVTable", wf.state.objFct);
	                    }
	                    tool.setActiveWV("FlowServiceNodePanel", wf.state.objFct);
	                    tool.refreshTable("SVNodeMappingTable", wf.state.objFct);
	                    tool.refreshWV("SVNodeForm", wf.state.objFct);
	
	                    inpanel = tool.getCmp("servicesinConditionPanel", wf.state.objFct);
	                    outpanel = tool.getCmp("servicesoutConditionPanel", wf.state.objFct);
	                    // tool.popUI(wf.state.uids[2], wf.state.objFct, "服务节点配置", 1024, 800);
	                    break;
	                case "04":
	                    // name = "脚本节点";
	
	                    wf.state.objFct.set("scriptcallinData", node.data.scriptcallin);
	                    wf.state.objFct.set("scriptcalloutData", node.data.scriptcallout);
	                    tool.refreshTable("scriptcallinTable", wf.state.objFct);
	                    tool.refreshTable("scriptcalloutTable", wf.state.objFct);
	                    wf.state.objFct.set("SCNodeData", node.data);
	                    tool.setActiveWV("FlowScriptNodePanel", wf.state.objFct);
	                    tool.refreshWV("SCNodeSCFrom", wf.state.objFct);
	
	                    tool.refreshWV("SCNodeForm", wf.state.objFct);
	                    // tool.popUI(wf.state.uids[3], wf.state.objFct, "脚本节点配置", 1024, 800);
	                    inpanel = tool.getCmp("scriptinConditionPanel", wf.state.objFct);
	                    outpanel = tool.getCmp("scriptoutConditionPanel", wf.state.objFct);
	                    break;
	                case "05":
	                    // name = "子流程";
	                    wf.state.objFct.set("CLNodeData", node.data);
	                    tool.setActiveWV("FlowChildNodePanel", wf.state.objFct);
	                    tool.refreshWV("CLNodeForm", wf.state.objFct);
	                    inpanel = tool.getCmp("childinConditionPanel", wf.state.objFct);
	                    outpanel = tool.getCmp("childoutConditionPanel", wf.state.objFct);
	                    // tool.popUI(wf.state.uids[4], wf.state.objFct, "子流程节点配置", 1024, 800);
	                    break;
	                case "99":
	                    // name = "结束";
	                    // tool.popUI(wf.state.uids[5], wf.state.objFct, "结束节点配置", 1024, 800);
	                    break;
	                default:
	                    break;
	            }
	            inpanel.state.panelItems = [inConditionCtl];
	            inpanel.setState({ loading: false });
	            outpanel.state.panelItems = [outConditionCtl];
	            outpanel.setState({ loading: false });
	
	            // if (node.type !== STARTNODETYPE) wf.setState({ editpanelWidth: 18 });
	            // else {
	            //   wf.setState({ editpanelWidth: 24 });
	            // }
	            // wf.refs.NodeParaEditSD.showDrawer(node);
	        }
	    }, {
	        key: "blankClickFunc",
	        value: function blankClickFunc() {
	            this.setState({ currnode: null });
	            // this.currnode = null;
	            // this.refs.NodeParaEditSD.onClose();
	            // this.dragnode =null;
	        }
	    }, {
	        key: "rmenuClick",
	        value: function rmenuClick(wf, type) {
	            var node = wf.state.currnode;
	            if (!node) {
	                alert("no selected node");
	                return;
	            }
	
	            if (type === "99" && typeof this.state.over !== "undefined") {
	                alert("已有结束节点，请使用跳转节点结束流程");
	                return;
	            }
	
	            var data = wf.newData(node, type);
	            var nexnode = node.createNextNode(data);
	
	            if (nexnode.parentsNode === null || typeof nexnode.parentsNode === "undefined") {
	                nexnode.parentsNode = [];
	            }
	            nexnode.parentsNode.push(node);
	            if (!node.data.childNode) {
	                node.data.childNode = [];
	            }
	            node.data.childNode.push(data);
	            if (type === "02") {
	                var chart = node.getChart();
	                chart.jumpLine(nexnode);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return (
	                // <div style={{ height:'790px',width: '100%' }} >
	                _react2.default.createElement(
	                    "div",
	                    {
	                        ref: "ServerInterface",
	                        style: {
	                            height: this.state.h,
	                            width: this.state.w,
	                            border: 1,
	                            borderStyle: "solid",
	                            borderColor: "#DCDCDC"
	                        }
	                    },
	                    _react2.default.createElement(
	                        _antd.Row,
	                        { style: { height: "100%", width: "100%" } },
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: this.state.editpanelWidth, style: { height: "100%" } },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    id: this.state.editid,
	                                    style: {
	                                        backgroundColor: "#FFFFFF",
	                                        height: "100%",
	                                        border: 1,
	                                        borderStyle: "solid",
	                                        borderColor: "#DCDCDC"
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "canvas",
	                                    {
	                                        id: this.state.canvasid,
	                                        style: { height: "100%", backgroundColor: "#FFFFFF" }
	                                    },
	                                    " "
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_antd.Col, {
	                            span: 24 - this.state.editpanelWidth,
	                            style: {
	                                height: "100%",
	                                border: 1,
	                                borderStyle: "solid",
	                                borderColor: "#DCDCDC"
	                            }
	                        })
	                    ),
	                    this.state.debug ? _react2.default.createElement(
	                        _antd.Row,
	                        { style: { height: "10%", width: "100%" } },
	                        _react2.default.createElement(
	                            _antd.Button,
	                            { onClick: this.getData.bind(this), type: "primary" },
	                            "\u67E5\u770B\u6D41\u7A0B\u914D\u7F6E"
	                        ),
	                        _react2.default.createElement(
	                            _antd.Button,
	                            null,
	                            "\u6D4B\u8BD5\u6D41\u7A0B"
	                        )
	                    ) : ""
	                )
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var me = this;
	            if (!me.state.canvas) {
	                me.init();
	            }
	        }
	    }, {
	        key: "newData",
	        value: function newData(node, type) {
	            var x = 50;
	            var y = 30;
	            if (node) {
	                x = node.x + 150;
	                if (node.data.childNode) {
	                    y = node.y + node.data.childNode.length * 90;
	                } else {
	                    y = node.y;
	                }
	            }
	
	            var data = {
	                id: this.maxid++,
	                name: null,
	                type: type,
	                status: "00",
	                ann: null,
	                inCondition: null, // 准入条件
	                outCondition: null, // 准出条件
	                inConditionExp: null, // 准入条件表达式
	                outConditionExp: null, // 准出条件表达式
	                isfallback: "0", // 是否回退
	                fallback: null, // 回退接口
	                executionInterface: null, // 处理界面
	                executionInterfaceparm: null, // 界面启动参数
	                x: x,
	                y: y,
	                ishuman: "0",
	                human: [],
	                handling: []
	            };
	            if (type === STARTNODETYPE) {
	                var me = this;
	                var currentSVRoot = me.state.objFct.get("currentSVRoot");
	
	                for (var attr in startNodedata) {
	                    data[attr] = startNodedata[attr];
	                    data.serviceID = currentSVRoot.guid;
	                    data.serviceUrl = currentSVRoot.url;
	                    data.servicetimeout = currentSVRoot.timeout;
	                    data.servicecalltype = "0";
	                }
	            }
	            if (type === "03") {
	                for (var attr in serviceNodedata) {
	                    data[attr] = serviceNodedata[attr];
	                }
	            }
	            if (type === "04") {
	                for (var attr in scriptNodedata) {
	                    data[attr] = scriptNodedata[attr];
	                }
	            }
	
	            if (type === "99") {
	                // 结束节点
	                data.end = "0";
	                data.endtype = "0";
	                data.gototype = "0";
	            }
	            return data;
	        }
	    }, {
	        key: "cvtToJson",
	        value: function cvtToJson(root) {
	            if (!root) {
	                return;
	            }
	            var children = root.data.childNode;
	            if (!children) {
	                return;
	            }
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i].data;
	                if (child.type === "06") {
	                    var array = [];
	                    var us = child.users;
	                    if (us) {
	                        for (var j = 0; j < us.length; j++) {
	                            var u = us[j];
	                            array.push(u);
	                        }
	                        child.users = array;
	                    }
	                    var ps = child.posts;
	                    if (ps) {
	                        array = [];
	                        for (var _j3 = 0; _j3 < ps.length; _j3++) {
	                            var p = ps[_j3];
	                            array.push(p);
	                        }
	                        child.posts = array;
	                    }
	                } else {
	                    continue;
	                }
	                this.cvtToJson(child);
	            }
	        }
	    }, {
	        key: "getJson",
	        value: function getJson(root) {
	            if (!root) {
	                root = this.state.root.data;
	            }
	            var json = {};
	            json = root;
	            var children = root.childNode;
	            if (!children) {
	                return json;
	            }
	            json.childNode = [];
	            for (var i = 0; i < children.length; i++) {
	                json.childNode.push(this.getJson(children[i]));
	            }
	            return json;
	        }
	    }, {
	        key: "deleteEmptyProperty",
	        value: function deleteEmptyProperty(object) {
	            for (var i in object) {
	                var value = object[i];
	                if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
	                    if (Array.isArray(value)) {
	                        if (value.length === 0) {
	                            delete object[i];
	                            continue;
	                        }
	                    }
	                    this.deleteEmptyProperty(value);
	                    if (this.isEmpty(value)) {
	                        delete object[i];
	                    }
	                } else if (value === "" || value === null || value === undefined) {
	                    delete object[i];
	                } else {}
	            }
	        }
	    }, {
	        key: "isEmpty",
	        value: function isEmpty(object) {
	            for (var name in object) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: "getData",
	        value: function getData() {
	            var json = this.getJson();
	            // this.deleteEmptyProperty(json);
	            _antd.Modal.info({
	                title: "This is a notification message",
	                content: JSON.stringify(json),
	                onOk: function onOk() {}
	            });
	        }
	    }]);
	
	    return ServiceInterface;
	}(_react.Component);
	
	exports.default = ServiceInterface;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	var _UserModal = __webpack_require__(137);
	
	var _PubInfo = __webpack_require__(162);
	
	var _PubInfo2 = _interopRequireDefault(_PubInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	var RadioGroup = _antd.Radio.Group;
	
	var EndeNodeFrom = function (_Component) {
	    _inherits(EndeNodeFrom, _Component);
	
	    function EndeNodeFrom(props) {
	        _classCallCheck(this, EndeNodeFrom);
	
	        var _this = _possibleConstructorReturn(this, (EndeNodeFrom.__proto__ || Object.getPrototypeOf(EndeNodeFrom)).call(this, props));
	
	        _this.reload = function () {
	            _this.setState({ loading: false });
	        };
	
	        _this.selectOnChange = function (attname, value) {
	            //change传入对象为value
	            tool.sgiLogger.log("事件：selectOnChange");
	            _this.refresh(attname, value);
	        };
	
	        _this.checkboxGroupOnChange = function (attname, checkedValue) {
	            tool.sgiLogger.log("事件：checkboxGroupOnChange");
	            _this.refresh(attname, checkedValue);
	        };
	
	        _this.serviceCallInHandleOk = function (e) {
	            var newData = {
	                inParamKey: _this.state.inParamKey,
	                inParamValue: _this.state.inParamValue
	            };
	            if (typeof _this.state.nodedata.servicecallin == "undefined") {
	                _this.state.nodedata.servicecallin = [];
	            }
	            var servicecallin = _this.state.nodedata.servicecallin;
	
	            _this.state.nodedata.servicecallin = [].concat(_toConsumableArray(servicecallin), [newData]);
	            _this.state.modalServiceInShow = false;
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.serviceCallOutHandleOk = function (e) {
	            var newData = {
	                outParamKey: _this.state.outParamKey,
	                outParamValue: _this.state.outParamValue
	            };
	            if (typeof _this.state.nodedata.servicecallout == "undefined") {
	                _this.state.nodedata.servicecallout = [];
	            }
	            var servicecallout = _this.state.nodedata.servicecallout;
	
	            _this.state.nodedata.servicecallout = [].concat(_toConsumableArray(servicecallout), [newData]);
	            _this.state.modalServiceOutShow = false;
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.serviceCallbackInHandleOk = function (e) {
	            var newData = {
	                inParamKey: _this.state.inParamKey,
	                inParamValue: _this.state.inParamValue
	            };
	            if (typeof _this.state.nodedata.servicecallbackin == "undefined") {
	                _this.state.nodedata.servicecallbackin = [];
	            }
	            var servicecallbackin = _this.state.nodedata.servicecallbackin;
	
	            _this.state.nodedata.servicecallbackin = [].concat(_toConsumableArray(servicecallbackin), [newData]);
	            _this.state.modalServiceCbInShow = false;
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.serviceCallbackOutHandleOk = function (e) {
	            var newData = {
	                outParamKey: _this.state.outParamKey,
	                outParamValue: _this.state.outParamValue
	            };
	            if (typeof _this.state.nodedata.servicecallbackout == "undefined") {
	                _this.state.nodedata.servicecallbackout = [];
	            }
	            var servicecallbackout = _this.state.nodedata.servicecallbackout;
	
	            _this.state.nodedata.servicecallbackout = [].concat(_toConsumableArray(servicecallbackout), [newData]);
	            _this.state.modalServiceCbOutShow = false;
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.modalHandleCancel = function (e) {
	            var _this$setState;
	
	            _this.setState({
	                modalShow: false
	            });
	
	            _this.state.modalScriptInShow = true;
	            _this.setState((_this$setState = { modalServiceInShow: false, modalServiceCbInShow: false, modalServiceOutShow: false, modalServiceCbOutShow: false }, _defineProperty(_this$setState, 'modalServiceOutShow', false), _defineProperty(_this$setState, 'modalScriptOutShow', false), _this$setState));
	        };
	
	        _this.modalOnChange = function (attname, e, e2) {
	            tool.sgiLogger.log("事件：modalOnChange");
	            var value = e.target.value;
	            _this.state[attname] = value;
	        };
	
	        _this.scriptCallInHandleOk = function (e) {
	            var newData = {
	                inParamKey: _this.state.inParamKey,
	                inParamValue: _this.state.inParamValue
	            };
	            if (typeof _this.state.nodedata.scriptcallin == "undefined") {
	                _this.state.nodedata.scriptcallin = [];
	            }
	            var scriptcallin = _this.state.nodedata.scriptcallin;
	
	            _this.state.nodedata.scriptcallin = [].concat(_toConsumableArray(scriptcallin), [newData]);
	            _this.state.modalScriptInShow = false;
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.scriptCallOutHandleOk = function (e) {
	            var newData = {
	                outParamKey: _this.state.outParamKey,
	                outParamValue: _this.state.outParamValue
	            };
	            if (typeof _this.state.nodedata.scriptcallout == "undefined") {
	                _this.state.nodedata.scriptcallout = [];
	            }
	            var scriptcallout = _this.state.nodedata.scriptcallout;
	
	            _this.state.nodedata.scriptcallout = [].concat(_toConsumableArray(scriptcallout), [newData]);
	            _this.state.modalScriptOutShow = false;
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.handleAdd = function (modalType) {
	            tool.sgiLogger.log("handleAdd表格添加方法");
	            if (!modalType || modalType == '') {
	                _this.state.modalContent = null;;
	            }
	            if (modalType == "servicecallin") {
	                _this.state.modalServiceInShow = true;
	            } else if (modalType == "servicecallbackin") {
	                _this.state.modalServiceCbInShow = true;
	            } else if (modalType == "servicecallout") {
	                _this.state.modalServiceOutShow = true;
	            } else if (modalType == "servicecallbackout") {
	                _this.state.modalServiceCbOutShow = true;
	            } else if (modalType == "scriptcallin") {
	                _this.state.modalScriptInShow = true;
	            } else if (modalType == "scriptcallout") {
	                _this.state.modalScriptOutShow = true;
	            }
	            if (modalType == 'human') {
	                _this.state.modalContent = _react2.default.createElement(_UserModal.UserModal, { key: (0, _CommonFunc.uuid)(8), modalShow: true, title: '\u9009\u62E9\u64CD\u4F5C\u4EBA\u5458',
	                    approvalUserList: _this.state.nodedata.human, parent: _this });
	            }
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.handleDelete = function (delData, dataSource) {
	            if (dataSource && delData) {
	                for (var i = 0; i < dataSource.length; i++) {
	                    if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
	                        dataSource.splice(i, 1);
	                    }
	                }
	            }
	            _this.setState({ loading: false });
	        };
	
	        _this.getTBData = function (tData) {
	            if (!tData) {
	                tData = [];
	                return tData;
	            }
	            tData.forEach(function (element) {
	                if (!element._key) element._key = (0, _CommonFunc.uuid)(8);
	            });
	            return tData;
	        };
	
	        _this.state = {
	            node: props.node,
	            show: props.show != null && props.show == true ? props.show : 'none',
	            nodedata: props.nodedata,
	            modalServiceInShow: false,
	            modalServiceOutShow: false,
	            modalServiceCbInShow: false,
	            modalServiceCbOutShow: false,
	            modalScriptInShow: false,
	            modalScriptOutShow: false,
	
	            loading: false
	        };
	        return _this;
	    }
	
	    // 重新加载页面方法
	
	
	    _createClass(EndeNodeFrom, [{
	        key: 'textOnChange',
	
	        // 文本修改事件
	        value: function textOnChange(attname, e, e2) {
	            tool.sgiLogger.log("事件：textOnChange");
	            var value = e.target.value;
	            this.refresh(attname, value);
	        }
	        // 下拉窗修改事件
	
	        // 复选框组修改事件，checkedValue为数组["01","02"]
	
	    }, {
	        key: 'numberOnChange',
	
	        // 数字组件修改事件
	        value: function numberOnChange(attname, e) {
	            tool.sgiLogger.log("事件：numberOnChange");
	            var value = e;
	            this.refresh(attname, value);
	        }
	        // 单选框组修改事件
	
	    }, {
	        key: 'radioGroupOnChange',
	        value: function radioGroupOnChange(attname, e) {
	            tool.sgiLogger.log("事件：radioGroupOnChange");
	            var value = e.target.value;
	            this.refresh(attname, value);
	        }
	        // 属性更新
	
	    }, {
	        key: 'refresh',
	        value: function refresh(attname, value) {
	            if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
	            this.state.nodedata[attname] = value;
	        }
	
	        // 输入参数modal确认按钮事件
	
	        // 服务输出参数modal确认按钮事件
	
	
	        // 回调输入参数modal确认按钮事件
	
	
	        // 回调服务输出参数modal确认按钮事件
	        // 输入参数modal取消按钮事件
	
	        // modal中文本框修改事件
	
	        // 输入参数modal确认按钮事件
	
	        // 输出参数modal确认按钮事件
	
	        // 表格添加方法
	
	        // 表格添加方法
	        // handleAdd = (modalType) => {
	        //     tool.sgiLogger.log("handleAdd表格添加方法");
	        //     if (!modalType || modalType == '') {
	        //         this.state.modalContent = null;;
	        //     }
	        //     if (modalType == 'human') {
	        //         this.state.modalContent = <UserModal key={uuid(8)} modalShow={true} title="选择操作人员"
	        //             approvalUserList={this.state.nodedata.human} parent={this} />
	        //     }
	        //     this.setState({
	        //         loading: false
	        //     });
	        // }
	        // 表格删除方法
	
	        // 创建表格绑定store（生成数据key）
	
	    }, {
	        key: 'componentDidMount',
	
	
	        // 刷新form
	        value: function componentDidMount() {
	            tool.sgiLogger.log('事件：endNode加载后');
	            this.props.form.setFieldsValue({
	                // id: this.state.nodedata.id,
	                // name: this.state.nodedata.name,
	                // type: this.state.nodedata.type,
	                // status: this.state.nodedata.status,
	                // inCondition: this.state.nodedata.inCondition,
	                // outCondition: this.state.nodedata.outCondition,
	                // ann: this.state.nodedata.ann,
	
	                end: this.state.nodedata.end,
	                endtype: this.state.nodedata.endtype,
	                gototype: this.state.nodedata.gototype,
	                gotoInterface: this.state.nodedata.gotoInterface,
	                gotoInterfaceparm: this.state.nodedata.gotoInterfaceparm,
	
	                //service 调用
	                serviceUrl: this.state.nodedata.serviceUrl,
	                serviceprotocol: this.state.nodedata.serviceprotocol,
	                serviceprocessor: this.state.nodedata.serviceprocessor,
	                servicecallio: this.state.nodedata.servicecallio,
	
	                serviceAcynctype: this.state.nodedata.serviceAcynctype,
	                servicecalltype: this.state.nodedata.servicecalltype,
	                servicetimeout: this.state.nodedata.servicetimeout,
	                servicecallback: this.state.nodedata.servicecallback,
	                servicecallbackio: this.state.nodedata.servicecallbackio,
	
	                servicereceiveTimeout: this.state.nodedata.servicereceiveTimeout,
	                servicetimeoutHandling: this.state.nodedata.servicetimeoutHandling,
	                serviceredoServiceUrl: this.state.nodedata.serviceredoServiceUrl,
	
	                //执行脚本
	                scripttype: this.state.nodedata.scripttype,
	                scriptcode: this.state.nodedata.scriptcode,
	                scriptcallin: this.state.nodedata.scriptcallin,
	                scriptcallout: this.state.nodedata.scriptcallout,
	
	                ishuman: this.state.nodedata.ishuman,
	                receiveTimeoutHandling: this.state.nodedata.receiveTimeoutHandling,
	                human: this.state.nodedata.human
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var getFieldDecorator = this.props.form.getFieldDecorator;
	
	            var servicecallinList = this.getTBData(this.state.nodedata.servicecallin);
	            var servicecallinListColumns = [{
	                title: '输入参数key', // 列头显示名称
	                dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
	            }, {
	                title: '输入参数值', // 列头显示名称
	                dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
	            }, {
	                title: '操作',
	                key: 'action',
	                render: function render(text, record) {
	                    return _this2.state.nodedata.servicecallin.length >= 1 ? _react2.default.createElement(
	                        _antd.Popconfirm,
	                        { title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
	                                return _this2.handleDelete(record, _this2.state.nodedata.servicecallin);
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            '\u5220\u9664'
	                        )
	                    ) : null;
	                }
	            }];
	            var servicecallbackinList = this.getTBData(this.state.nodedata.servicecallbackin);
	            var servicecallbackinListColumns = [{
	                title: '输入参数key', // 列头显示名称
	                dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
	            }, {
	                title: '输入参数值', // 列头显示名称
	                dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
	            }, {
	                title: '操作',
	                key: 'action',
	                render: function render(text, record) {
	                    return _this2.state.nodedata.servicecallbackin.length >= 1 ? _react2.default.createElement(
	                        _antd.Popconfirm,
	                        { title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
	                                return _this2.handleDelete(record, _this2.state.nodedata.servicecallbackin);
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            '\u5220\u9664'
	                        )
	                    ) : null;
	                }
	            }];
	
	            var servicecalloutList = this.getTBData(this.state.nodedata.servicecallout);
	            var servicecalloutListColumns = [{
	                title: '输出参数key', // 列头显示名称
	                dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
	            }, {
	                title: '输出参数值', // 列头显示名称
	                dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
	            }, {
	                title: '操作',
	                key: 'action',
	                render: function render(text, record) {
	                    return _this2.state.nodedata.servicecallout.length >= 1 ? _react2.default.createElement(
	                        _antd.Popconfirm,
	                        { title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
	                                return _this2.handleDelete(record, _this2.state.nodedata.servicecallout);
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            '\u5220\u9664'
	                        )
	                    ) : null;
	                }
	            }];
	            var servicecallbackoutList = this.getTBData(this.state.nodedata.servicecallbackout);
	            var servicecallbackoutListColumns = [{
	                title: '输出参数key', // 列头显示名称
	                dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
	            }, {
	                title: '输出参数值', // 列头显示名称
	                dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
	            }, {
	                title: '操作',
	                key: 'action',
	                render: function render(text, record) {
	                    return _this2.state.nodedata.servicecallbackout.length >= 1 ? _react2.default.createElement(
	                        _antd.Popconfirm,
	                        { title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
	                                return _this2.handleDelete(record, _this2.state.nodedata.servicecallbackout);
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            '\u5220\u9664'
	                        )
	                    ) : null;
	                }
	            }];
	
	            var scriptcallinList = this.getTBData(this.state.nodedata.scriptcallin);
	            var scriptcallinListColumns = [{
	                title: '输入参数key', // 列头显示名称
	                dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
	            }, {
	                title: '输入参数值', // 列头显示名称
	                dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
	            }, {
	                title: '操作',
	                key: 'action',
	                render: function render(text, record) {
	                    return _this2.state.nodedata.scriptcallin.length >= 1 ? _react2.default.createElement(
	                        _antd.Popconfirm,
	                        { title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
	                                return _this2.handleDelete(record, _this2.state.nodedata.scriptcallin);
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            '\u5220\u9664'
	                        )
	                    ) : null;
	                }
	            }];
	            var scriptcalloutList = this.getTBData(this.state.nodedata.scriptcallout);
	            var scriptcalloutListColumns = [{
	                title: '输出参数key', // 列头显示名称
	                dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
	            }, {
	                title: '输出参数值', // 列头显示名称
	                dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
	            }, {
	                title: '操作',
	                key: 'action',
	                render: function render(text, record) {
	                    return _this2.state.nodedata.scriptcallout.length >= 1 ? _react2.default.createElement(
	                        _antd.Popconfirm,
	                        { title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
	                                return _this2.handleDelete(record, _this2.state.nodedata.scriptcallout);
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            '\u5220\u9664'
	                        )
	                    ) : null;
	                }
	            }];
	
	            var human = this.getTBData(this.state.nodedata.human);
	            var interventionUserListColumns = [{
	                title: '用户名称', // 列头显示名称
	                dataIndex: 'empName' // 列数据在数据项中对应的 key
	            }, {
	                title: '操作',
	                key: 'action',
	                render: function render(text, record) {
	                    return _this2.state.nodedata.human.length >= 1 ? _react2.default.createElement(
	                        _antd.Popconfirm,
	                        { title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
	                                return _this2.handleDelete(record, _this2.state.nodedata.human);
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            '\u5220\u9664'
	                        )
	                    ) : null;
	                }
	            }];
	
	            return _react2.default.createElement(
	                'div',
	                { style: { display: this.state.show } },
	                _react2.default.createElement(
	                    _antd.Form,
	                    { layout: 'vertical' },
	                    _react2.default.createElement(
	                        _antd.Collapse,
	                        { defaultActiveKey: ['1'] },
	                        _react2.default.createElement(
	                            Panel,
	                            { header: '\u901A\u7528\u8282\u70B9\u4FE1\u606F', key: '1' },
	                            _react2.default.createElement(_PubInfo2.default, { parent: this, node: this.state.node, nodedata: this.state.nodedata })
	                        ),
	                        _react2.default.createElement(
	                            Panel,
	                            { header: '\u7ED3\u675F\u8282\u70B9\u4FE1\u606F', key: '2' },
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u7ED3\u675F\u5904\u7406' },
	                                        getFieldDecorator('end', {
	                                            rules: [{ required: false, message: '' }]
	                                        })(_react2.default.createElement(
	                                            RadioGroup,
	                                            { onChange: this.radioGroupOnChange.bind(this, 'end') },
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "0" },
	                                                '\u65E0'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "1" },
	                                                '\u6709'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ),
	                            this.state.nodedata.end == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u754C\u9762\u8DF3\u8F6C' },
	                                        getFieldDecorator('gototype', {
	                                            rules: [{ required: false, message: '' }]
	                                        })(_react2.default.createElement(
	                                            RadioGroup,
	                                            { onChange: this.radioGroupOnChange.bind(this, 'gototype') },
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "0" },
	                                                '\u5426'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "1" },
	                                                '\u662F'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ) : "",
	                            this.state.nodedata.end == "1" && this.state.nodedata.gototype == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u8DF3\u8F6C\u754C\u9762' },
	                                        getFieldDecorator('gotoInterface', {
	                                            rules: [{ required: false, message: '请输入跳转界面' }]
	                                        })(_react2.default.createElement(_antd.Input, { placeholder: '\u8DF3\u8F6C\u754C\u9762',
	                                            onChange: this.textOnChange.bind(this, 'gotoInterface')
	                                        }))
	                                    )
	                                )
	                            ) : "",
	                            this.state.nodedata.end == "1" && this.state.nodedata.gototype == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u754C\u9762\u542F\u52A8\u53C2\u6570' },
	                                        getFieldDecorator('gotoInterfaceparm', {
	                                            rules: [{ required: false, message: '请输入界面启动参数' }]
	                                        })(_react2.default.createElement(_antd.Input, { placeholder: '\u754C\u9762\u542F\u52A8\u53C2\u6570',
	                                            onChange: this.textOnChange.bind(this, 'gotoInterfaceparm')
	                                        }))
	                                    )
	                                )
	                            ) : "",
	                            this.state.nodedata.end == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u5904\u7406\u7C7B\u578B' },
	                                        getFieldDecorator('endtype', {
	                                            rules: [{ required: false, message: '' }]
	                                        })(_react2.default.createElement(
	                                            RadioGroup,
	                                            { onChange: this.radioGroupOnChange.bind(this, 'endtype') },
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "0" },
	                                                '\u65E0'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "1" },
	                                                '\u8C03\u7528\u670D\u52A1'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "2" },
	                                                '\u6267\u884C\u811A\u672C'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "3" },
	                                                '\u5148\u6267\u884C\u811A\u672C\u518D\u8C03\u7528\u670D\u52A1'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "4" },
	                                                '\u5148\u8C03\u7528\u670D\u52A1\u518D\u6267\u884C\u811A\u672C'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ) : ""
	                        ),
	                        this.state.nodedata.end == "1" && this.state.nodedata.endtype != "0" && this.state.nodedata.endtype != "2" && typeof this.state.nodedata.endtype != "undefined" ? _react2.default.createElement(
	                            Panel,
	                            { header: '\u670D\u52A1\u8282\u70B9\u4FE1\u606F', key: '3' },
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u670D\u52A1url' },
	                                        getFieldDecorator('serviceUrl', {
	                                            rules: [{ required: true, message: '请输入服务url' }]
	                                        })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u670D\u52A1url',
	                                            onChange: this.textOnChange.bind(this, 'serviceUrl')
	                                        }))
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u901A\u8BAF\u534F\u8BAE' },
	                                        getFieldDecorator('serviceprotocol', {
	                                            rules: [{ required: true, message: '请输入通讯协议' }]
	                                        })(_react2.default.createElement(
	                                            _antd.Select,
	                                            { placeholder: '\u8BF7\u8F93\u5165\u901A\u8BAF\u534F\u8BAE',
	                                                onChange: this.selectOnChange.bind(this, 'serviceprotocol')
	                                            },
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '0' },
	                                                'resful'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '1' },
	                                                'xml'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '2' },
	                                                '\u5B9A\u957F\u62A5\u6587'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '3' },
	                                                '8583\u62A5\u6587'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '4' },
	                                                '\u81EA\u5B9A\u4E49\u62A5\u6587'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '5' },
	                                                '\u672C\u5730\u8C03\u7528'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u901A\u8BAF\u5904\u7406\u7A0B\u5E8F' },
	                                        getFieldDecorator('serviceprocessor', {
	                                            rules: [{ required: false, message: '请输入通讯处理程序' }]
	                                        })(_react2.default.createElement(_antd.Input.TextArea, { rows: 2, placeholder: '\u8BF7\u8F93\u5165\u901A\u8BAF\u5904\u7406\u7A0B\u5E8F',
	                                            onChange: this.textOnChange.bind(this, 'serviceprocessor')
	                                        }))
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { align: 'right' },
	                                        _react2.default.createElement(
	                                            _antd.Button,
	                                            { size: 'small', onClick: this.handleAdd.bind(this, "servicecallin"), type: 'primary', style: { marginBottom: 10 } },
	                                            '\u6DFB\u52A0\u670D\u52A1\u8F93\u5165'
	                                        )
	                                    ),
	                                    _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                                        rowClassName: function rowClassName() {
	                                            return 'incomeList-row';
	                                        } // 表格行的类名
	                                        , bordered: true // 是否展示外边框和列边框
	                                        , dataSource: servicecallinList,
	                                        columns: servicecallinListColumns
	                                    }),
	                                    _react2.default.createElement(
	                                        _antd.Modal,
	                                        {
	                                            title: '\u6DFB\u52A0\u670D\u52A1\u8F93\u5165\u53C2\u6570',
	                                            visible: this.state.modalServiceInShow,
	                                            onOk: this.serviceCallInHandleOk.bind(this),
	                                            onCancel: this.modalHandleCancel,
	                                            okText: '\u786E\u8BA4',
	                                            cancelText: '\u53D6\u6D88',
	                                            destroyOnClose: true
	                                        },
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u8F93\u5165\u53C2\u6570key' },
	                                            _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570key',
	                                                onChange: this.modalOnChange.bind(this, 'inParamKey')
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u8F93\u5165\u53C2\u6570value' },
	                                            _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570value',
	                                                onChange: this.modalOnChange.bind(this, 'inParamValue')
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { color: "red" } },
	                                        '\u8F93\u51FA\u53C2\u6570\u5C06\u4FDD\u5B58\u5728\u5DE5\u4F5C\u6D41\u7684\u4E1A\u52A1\u6570\u636E\u4E2D'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { align: 'right' },
	                                        _react2.default.createElement(
	                                            _antd.Button,
	                                            { size: 'small', onClick: this.handleAdd.bind(this, "servicecallout"), type: 'primary', style: { marginBottom: 10 } },
	                                            '\u6DFB\u52A0\u670D\u52A1\u8F93\u51FA'
	                                        )
	                                    ),
	                                    _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                                        rowClassName: function rowClassName() {
	                                            return 'incomeList-row';
	                                        } // 表格行的类名
	                                        , bordered: true // 是否展示外边框和列边框
	                                        , dataSource: servicecalloutList,
	                                        columns: servicecalloutListColumns
	                                    }),
	                                    _react2.default.createElement(
	                                        _antd.Modal,
	                                        {
	                                            title: '\u6DFB\u52A0\u670D\u52A1\u8F93\u51FA\u53C2\u6570',
	                                            visible: this.state.modalServiceOutShow,
	                                            onOk: this.serviceCallOutHandleOk.bind(this),
	                                            onCancel: this.modalHandleCancel,
	                                            okText: '\u786E\u8BA4',
	                                            cancelText: '\u53D6\u6D88',
	                                            destroyOnClose: true
	                                        },
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u8F93\u51FA\u53C2\u6570key' },
	                                            _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570key',
	                                                onChange: this.modalOnChange.bind(this, 'outParamKey')
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u8F93\u51FA\u53C2\u6570value' },
	                                            _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570value',
	                                                onChange: this.modalOnChange.bind(this, 'outParamValue')
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u8C03\u7528\u65B9\u5F0F' },
	                                        getFieldDecorator('servicecalltype', {
	                                            rules: [{ required: true, message: '' }]
	                                        })(_react2.default.createElement(
	                                            RadioGroup,
	                                            { onChange: this.radioGroupOnChange.bind(this, "servicecalltype") },
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "0" },
	                                                '\u540C\u6B65'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "1" },
	                                                '\u5F02\u6B65'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u8D85\u65F6\u65F6\u95F4' },
	                                        getFieldDecorator('servicetimeout', {
	                                            initialValue: this.state.nodedata.timeout,
	                                            rules: [{ required: false, message: '请输入超时时间' }]
	                                        })(_react2.default.createElement(_antd.InputNumber, {
	                                            min: 0,
	                                            onChange: this.numberOnChange.bind(this, "servicetimeout")
	                                        })),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' \u79D2'
	                                        )
	                                    )
	                                )
	                            ),
	                            this.state.nodedata.servicecalltype == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u5F02\u6B65\u56DE\u8C03\u65B9\u5F0F' },
	                                        getFieldDecorator('serviceAcynctype', {
	                                            rules: [{ required: true, message: '' }]
	                                        })(_react2.default.createElement(
	                                            RadioGroup,
	                                            { onChange: this.radioGroupOnChange.bind(this, "serviceAcynctype") },
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "1" },
	                                                '\u56DE\u8C03\u63A5\u53E3'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "2" },
	                                                '\u6D88\u606F\u901A\u77E5'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ) : "",
	                            this.state.nodedata.servicecalltype == "9" ? _react2.default.createElement(
	                                _antd.Card,
	                                null,
	                                this.state.nodedata.serviceAcynctype == "1" ? _react2.default.createElement(
	                                    _antd.Row,
	                                    { gutter: 16 },
	                                    _react2.default.createElement(
	                                        _antd.Col,
	                                        { span: 24 },
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u56DE\u8C03\u63A5\u53E3' },
	                                            getFieldDecorator('servicecallbackUrl', {
	                                                initialValue: this.state.nodedata.servicecallbackUrl,
	                                                rules: [{ required: false, message: '请输入回调接口' }]
	                                            })(_react2.default.createElement(_antd.Input.TextArea, { rows: 4, placeholder: '\u8BF7\u8F93\u5165\u56DE\u8C03\u63A5\u53E3',
	                                                onChange: this.textOnChange.bind(this, 'servicecallbackUrl')
	                                            }))
	                                        )
	                                    )
	                                ) : "",
	                                this.state.nodedata.serviceAcynctype == "2" ? _react2.default.createElement(
	                                    _antd.Row,
	                                    { gutter: 16 },
	                                    _react2.default.createElement(
	                                        _antd.Col,
	                                        { span: 24 },
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u81EA\u5B9A\u4E49\u56DE\u8C03\u5904\u7406' },
	                                            getFieldDecorator('servicecallbackUrl', {
	                                                initialValue: this.state.nodedata.servicecallbackUrl,
	                                                rules: [{ required: false, message: '请输入回调处理' }]
	                                            })(_react2.default.createElement(_antd.Input.TextArea, { rows: 4, placeholder: '\u8BF7\u8F93\u5165\u56DE\u8C03\u5904\u7406',
	                                                onChange: this.textOnChange.bind(this, 'servicecallbackUrl')
	                                            }))
	                                        )
	                                    )
	                                ) : "",
	                                this.state.nodedata.serviceAcynctype != "0" ? _react2.default.createElement(
	                                    _antd.Row,
	                                    { gutter: 16 },
	                                    _react2.default.createElement(
	                                        _antd.Col,
	                                        { span: 24 },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { align: 'right' },
	                                            _react2.default.createElement(
	                                                _antd.Button,
	                                                { size: 'small', onClick: this.handleAdd.bind(this, "servicecallbackin"), type: 'primary', style: { marginBottom: 10 } },
	                                                '\u6DFB\u52A0\u56DE\u8C03\u670D\u52A1\u8F93\u5165'
	                                            )
	                                        ),
	                                        _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                                            rowClassName: function rowClassName() {
	                                                return 'incomeList-row';
	                                            } // 表格行的类名
	                                            , bordered: true // 是否展示外边框和列边框
	                                            , dataSource: servicecallbackinList,
	                                            columns: servicecallbackinListColumns
	                                        }),
	                                        _react2.default.createElement(
	                                            _antd.Modal,
	                                            {
	                                                title: '\u6DFB\u52A0\u56DE\u8C03\u670D\u52A1\u8F93\u5165\u53C2\u6570',
	                                                visible: this.state.modalServiceCbInShow,
	                                                onOk: this.serviceCallbackInHandleOk.bind(this),
	                                                onCancel: this.modalHandleCancel,
	                                                okText: '\u786E\u8BA4',
	                                                cancelText: '\u53D6\u6D88',
	                                                destroyOnClose: true
	                                            },
	                                            _react2.default.createElement(
	                                                _antd.Form.Item,
	                                                { label: '\u8F93\u5165\u53C2\u6570key' },
	                                                _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570key',
	                                                    onChange: this.modalOnChange.bind(this, 'inParamKey')
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Form.Item,
	                                                { label: '\u8F93\u5165\u53C2\u6570value' },
	                                                _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570value',
	                                                    onChange: this.modalOnChange.bind(this, 'inParamValue')
	                                                })
	                                            )
	                                        )
	                                    )
	                                ) : "",
	                                this.state.nodedata.serviceAcynctype != "0" ? _react2.default.createElement(
	                                    _antd.Row,
	                                    { gutter: 16 },
	                                    _react2.default.createElement(
	                                        _antd.Col,
	                                        { span: 24 },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { style: { color: "red" } },
	                                            '\u8F93\u51FA\u53C2\u6570\u5C06\u4FDD\u5B58\u5728\u5DE5\u4F5C\u6D41\u7684\u4E1A\u52A1\u6570\u636E\u4E2D'
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { align: 'right' },
	                                            _react2.default.createElement(
	                                                _antd.Button,
	                                                { size: 'small', onClick: this.handleAdd.bind(this, "servicecallbackout"), type: 'primary', style: { marginBottom: 10 } },
	                                                '\u6DFB\u52A0\u56DE\u8C03\u670D\u52A1\u8F93\u5165'
	                                            )
	                                        ),
	                                        _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                                            rowClassName: function rowClassName() {
	                                                return 'incomeList-row';
	                                            } // 表格行的类名
	                                            , bordered: true // 是否展示外边框和列边框
	                                            , dataSource: servicecallbackoutList,
	                                            columns: servicecallbackoutListColumns
	                                        }),
	                                        _react2.default.createElement(
	                                            _antd.Modal,
	                                            {
	                                                title: '\u6DFB\u52A0\u670D\u52A1\u8F93\u51FA\u53C2\u6570',
	                                                visible: this.state.modalServiceCbOutShow,
	                                                onOk: this.serviceCallbackOutHandleOk.bind(this),
	                                                onCancel: this.modalHandleCancel,
	                                                okText: '\u786E\u8BA4',
	                                                cancelText: '\u53D6\u6D88',
	                                                destroyOnClose: true
	                                            },
	                                            _react2.default.createElement(
	                                                _antd.Form.Item,
	                                                { label: '\u8F93\u51FA\u53C2\u6570key' },
	                                                _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570key',
	                                                    onChange: this.modalOnChange.bind(this, 'outParamKey')
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Form.Item,
	                                                { label: '\u8F93\u51FA\u53C2\u6570value' },
	                                                _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570value',
	                                                    onChange: this.modalOnChange.bind(this, 'outParamValue')
	                                                })
	                                            )
	                                        )
	                                    )
	                                ) : ""
	                            ) : ""
	                        ) : "",
	                        this.state.nodedata.end == "1" && this.state.nodedata.endtype != "0" && this.state.nodedata.endtype != "2" && typeof this.state.nodedata.endtype != "undefined" ? _react2.default.createElement(
	                            Panel,
	                            { header: '\u8D85\u65F6\u7B56\u7565', key: '4' },
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u63A5\u6536\u8D85\u65F6\u65F6\u9650' },
	                                        getFieldDecorator('servicereceiveTimeout ', {
	                                            initialValue: this.state.nodedata.receiveTimeout,
	                                            rules: [{ required: false, message: '请输入超时时限' }]
	                                        })(_react2.default.createElement(_antd.InputNumber, {
	                                            min: 0,
	                                            onChange: this.numberOnChange.bind(this, "servicereceiveTimeout")
	                                        })),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' \u5206\u949F'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u8D85\u65F6\u5904\u7406\u89C4\u5219' },
	                                        getFieldDecorator('servicetimeoutHandling', {
	                                            rules: [{ required: false, message: '' }]
	                                        })(_react2.default.createElement(
	                                            _antd.Select,
	                                            { placeholder: '\u8BF7\u9009\u62E9\u8D85\u65F6\u5904\u7406\u89C4\u5219',
	                                                onChange: this.selectOnChange.bind(this, 'servicetimeoutHandling')
	                                            },
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '01' },
	                                                '\u4E0D\u5904\u7406'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '02' },
	                                                '\u8865\u507F\u5904\u7406'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '03' },
	                                                '\u5411\u521B\u5EFA\u4EBA\u53D1\u6D88\u606F'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '04' },
	                                                '\u56DE\u9000\u5904\u7406'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ),
	                            this.state.nodedata.timeoutHandling == "02" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u8865\u507F\u6267\u884C\u6B21\u6570' },
	                                        getFieldDecorator('serviceredoTime', {
	                                            initialValue: this.state.nodedata.redoTime,
	                                            rules: [{ required: false, message: '请输入补偿执行次数' }]
	                                        })(_react2.default.createElement(_antd.InputNumber, {
	                                            min: 0,
	                                            onChange: this.numberOnChange.bind(this, "serviceredoTime")
	                                        })),
	                                        _react2.default.createElement(
	                                            'span',
	                                            null,
	                                            ' \u6B21'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u8865\u507F\u6267\u884C\u5468\u671F' },
	                                        getFieldDecorator('serviceredoCycle', {
	                                            initialValue: this.state.nodedata.redoCycle,
	                                            rules: [{ required: false, message: '请选择补偿执行周期' }]
	                                        })(_react2.default.createElement(
	                                            _antd.Select,
	                                            { placeholder: '\u8BF7\u9009\u62E9\u8865\u507F\u6267\u884C\u5468\u671F',
	                                                onChange: this.selectOnChange.bind(this, 'serviceredoCycle')
	                                            },
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '01' },
	                                                '\u4E0D\u91CD\u590D'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '02' },
	                                                '\u6BCF10\u5206\u949F'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '03' },
	                                                '\u6BCF30\u5206\u949F'
	                                            ),
	                                            _react2.default.createElement(
	                                                Option,
	                                                { value: '04' },
	                                                '\u6BCF60\u5206\u949F'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ) : // 补偿处理显示内容
	                            null // 不显示内容
	
	                        ) : "",
	                        this.state.nodedata.end == "1" && this.state.nodedata.endtype != "0" && this.state.nodedata.endtype != "1" && typeof this.state.nodedata.endtype != "undefined" ? _react2.default.createElement(
	                            Panel,
	                            { header: '\u811A\u672C\u8282\u70B9\u4FE1\u606F', key: '5' },
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u811A\u672C\u7C7B\u578B' },
	                                        getFieldDecorator('scripttype', {
	                                            rules: [{ required: true, message: '请输入脚本类型' }]
	                                        })(_react2.default.createElement(
	                                            RadioGroup,
	                                            { onChange: this.radioGroupOnChange.bind(this, 'scripttype') },
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "0" },
	                                                'JavaScript'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "1" },
	                                                'JAVA'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { align: 'right' },
	                                        _react2.default.createElement(
	                                            _antd.Button,
	                                            { size: 'small', onClick: this.handleAdd.bind(this, "scriptcallin"), type: 'primary', style: { marginBottom: 10 } },
	                                            '\u6DFB\u52A0\u811A\u672C\u8F93\u5165'
	                                        )
	                                    ),
	                                    _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                                        rowClassName: function rowClassName() {
	                                            return 'incomeList-row';
	                                        } // 表格行的类名
	                                        , bordered: true // 是否展示外边框和列边框
	                                        , dataSource: scriptcallinList,
	                                        columns: scriptcallinListColumns
	                                    }),
	                                    _react2.default.createElement(
	                                        _antd.Modal,
	                                        {
	                                            title: '\u6DFB\u52A0\u811A\u672C\u8F93\u5165\u53C2\u6570',
	                                            visible: this.state.modalScriptInShow,
	                                            onOk: this.scriptCallInHandleOk.bind(this),
	                                            onCancel: this.modalHandleCancel,
	                                            okText: '\u786E\u8BA4',
	                                            cancelText: '\u53D6\u6D88',
	                                            destroyOnClose: true
	                                        },
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u8F93\u5165\u53C2\u6570key' },
	                                            _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570key',
	                                                onChange: this.modalOnChange.bind(this, 'inParamKey')
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u8F93\u5165\u53C2\u6570value' },
	                                            _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570value',
	                                                onChange: this.modalOnChange.bind(this, 'inParamValue')
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { style: { color: "red" } },
	                                        '\u8F93\u51FA\u53C2\u6570\u5C06\u4FDD\u5B58\u5728\u5DE5\u4F5C\u6D41\u7684\u4E1A\u52A1\u6570\u636E\u4E2D'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { align: 'right' },
	                                        _react2.default.createElement(
	                                            _antd.Button,
	                                            { size: 'small', onClick: this.handleAdd.bind(this, "scriptcallout"), type: 'primary', style: { marginBottom: 10 } },
	                                            '\u6DFB\u52A0\u811A\u672C\u8F93\u51FA'
	                                        )
	                                    ),
	                                    _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                                        rowClassName: function rowClassName() {
	                                            return 'incomeList-row';
	                                        } // 表格行的类名
	                                        , bordered: true // 是否展示外边框和列边框
	                                        , dataSource: scriptcalloutList,
	                                        columns: scriptcalloutListColumns
	                                    }),
	                                    _react2.default.createElement(
	                                        _antd.Modal,
	                                        {
	                                            title: '\u6DFB\u52A0\u811A\u672C\u8F93\u51FA\u53C2\u6570',
	                                            visible: this.state.modalScriptOutShow,
	                                            onOk: this.scriptCallOutHandleOk.bind(this),
	                                            onCancel: this.modalHandleCancel,
	                                            okText: '\u786E\u8BA4',
	                                            cancelText: '\u53D6\u6D88',
	                                            destroyOnClose: true
	                                        },
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u8F93\u51FA\u53C2\u6570key' },
	                                            _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570key',
	                                                onChange: this.modalOnChange.bind(this, 'outParamKey')
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            _antd.Form.Item,
	                                            { label: '\u8F93\u51FA\u53C2\u6570value' },
	                                            _react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570value',
	                                                onChange: this.modalOnChange.bind(this, 'outParamValue')
	                                            })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u811A\u672C\u5185\u5BB9' },
	                                        getFieldDecorator('scriptcode', {
	                                            rules: [{ required: false, message: '请输入脚本内容' }]
	                                        })(_react2.default.createElement(_antd.Input.TextArea, { rows: 10, placeholder: '\u8BF7\u8F93\u5165\u811A\u672C\u5185\u5BB9',
	                                            onChange: this.textOnChange.bind(this, 'scriptcode')
	                                        }))
	                                    )
	                                )
	                            )
	                        ) : "",
	                        _react2.default.createElement(
	                            Panel,
	                            { header: '\u5E72\u9884\u7B56\u7565', key: '9' },
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u4EBA\u5DE5\u5E72\u9884' },
	                                        getFieldDecorator('ishuman', {
	                                            rules: [{ required: false, message: '' }]
	                                        })(_react2.default.createElement(
	                                            RadioGroup,
	                                            { onChange: this.radioGroupOnChange.bind(this, 'ishuman') },
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "0" },
	                                                '\u4E0D\u5141\u8BB8'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "1" },
	                                                '\u5141\u8BB8'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ),
	                            this.state.nodedata.ishuman == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u5904\u7406\u89C4\u5219' },
	                                        getFieldDecorator('handling', {
	                                            rules: [{ required: false, message: '' }]
	                                        })(_react2.default.createElement(
	                                            CheckboxGroup,
	                                            { onChange: this.checkboxGroupOnChange.bind(this, 'handling') },
	                                            _react2.default.createElement(
	                                                _antd.Checkbox,
	                                                { value: "01" },
	                                                '\u5B8C\u6210\u5DE5\u4F5C\u6D41'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Checkbox,
	                                                { value: "02" },
	                                                '\u56DE\u9000\u5904\u7406'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ) : "",
	                            this.state.nodedata.ishuman == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Button,
	                                        { size: 'small', onClick: this.handleAdd.bind(this, "human"), type: 'primary', style: { marginBottom: 10 } },
	                                        '\u6DFB\u52A0\u64CD\u4F5C\u4EBA\u5458'
	                                    ),
	                                    _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                                        rowClassName: function rowClassName() {
	                                            return 'userList-row';
	                                        } // 表格行的类名
	                                        , bordered: true // 是否展示外边框和列边框
	                                        , dataSource: human,
	                                        columns: interventionUserListColumns
	                                    })
	                                )
	                            ) : ""
	                        )
	                    )
	                ),
	                this.state.modalContent
	            );
	        }
	    }]);
	
	    return EndeNodeFrom;
	}(_react.Component);
	
	var EndNode = _antd.Form.create()(EndeNodeFrom);
	exports.default = EndNode;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	var _UserModal = __webpack_require__(137);
	
	var _PubInfo = __webpack_require__(162);
	
	var _PubInfo2 = _interopRequireDefault(_PubInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	var RadioGroup = _antd.Radio.Group;
	
	var JumpNodeFrom = function (_Component) {
	    _inherits(JumpNodeFrom, _Component);
	
	    function JumpNodeFrom(props) {
	        _classCallCheck(this, JumpNodeFrom);
	
	        var _this = _possibleConstructorReturn(this, (JumpNodeFrom.__proto__ || Object.getPrototypeOf(JumpNodeFrom)).call(this, props));
	
	        _this.reload = function () {
	            _this.setState({ loading: false });
	        };
	
	        _this.selectOnChange = function (attname, value) {
	            //change传入对象为value
	            tool.sgiLogger.log("事件：selectOnChange");
	            _this.refresh(attname, value);
	        };
	
	        _this.checkboxGroupOnChange = function (attname, checkedValue) {
	            tool.sgiLogger.log("事件：checkboxGroupOnChange");
	            _this.refresh(attname, checkedValue);
	        };
	
	        _this.handleAdd = function (modalType) {
	            tool.sgiLogger.log("handleAdd表格添加方法");
	            if (!modalType || modalType == '') {
	                _this.state.modalContent = null;;
	            }
	            if (modalType == 'human') {
	                _this.state.modalContent = _react2.default.createElement(_UserModal.UserModal, { key: (0, _CommonFunc.uuid)(8), modalShow: true, title: '\u9009\u62E9\u64CD\u4F5C\u4EBA\u5458',
	                    approvalUserList: _this.state.nodedata.human, parent: _this });
	            }
	            _this.setState({
	                loading: false
	            });
	        };
	
	        _this.handleDelete = function (delData, dataSource) {
	            if (dataSource && delData) {
	                for (var i = 0; i < dataSource.length; i++) {
	                    if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
	                        dataSource.splice(i, 1);
	                    }
	                }
	            }
	            _this.setState({ loading: false });
	        };
	
	        _this.getTBData = function (tData) {
	            if (!tData) {
	                tData = [];
	                return tData;
	            }
	            tData.forEach(function (element) {
	                if (!element._key) element._key = (0, _CommonFunc.uuid)(8);
	            });
	            return tData;
	        };
	
	        _this.state = {
	            node: props.node,
	            show: props.show != null && props.show == true ? props.show : 'none',
	            nodedata: props.nodedata,
	
	            loading: false
	        };
	        return _this;
	    }
	
	    // 重新加载页面方法
	
	
	    _createClass(JumpNodeFrom, [{
	        key: 'textOnChange',
	
	        // 文本修改事件
	        value: function textOnChange(attname, e, e2) {
	            tool.sgiLogger.log("事件：textOnChange");
	            var value = e.target.value;
	            this.refresh(attname, value);
	        }
	        // 下拉窗修改事件
	
	        // 复选框组修改事件，checkedValue为数组["01","02"]
	
	    }, {
	        key: 'radioGroupOnChange',
	
	        // 单选框组修改事件
	        value: function radioGroupOnChange(attname, e) {
	            tool.sgiLogger.log("事件：radioGroupOnChange");
	            var value = e.target.value;
	            this.refresh(attname, value);
	        }
	        // 数字组件修改事件
	
	    }, {
	        key: 'numberOnChange',
	        value: function numberOnChange(attname, e) {
	            var value = e;
	            this.refresh(attname, value);
	        }
	        // 属性更新
	
	    }, {
	        key: 'refresh',
	        value: function refresh(attname, value) {
	            if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
	            this.state.nodedata[attname] = value;
	        }
	
	        // 表格添加方法
	
	        // 表格删除方法
	
	        // 创建表格绑定store（生成数据key）
	
	    }, {
	        key: 'componentDidMount',
	
	
	        // 刷新form
	        value: function componentDidMount() {
	            tool.sgiLogger.log('事件：jumpNode加载后');
	            this.props.form.setFieldsValue({
	                ncode: this.props.nodedata.ncode,
	
	                ishuman: this.state.nodedata.ishuman,
	                receiveTimeoutHandling: this.state.nodedata.receiveTimeoutHandling
	                // interventionUsers: this.state.nodedata.interventionUsers
	
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	            var human = this.getTBData(this.state.nodedata.human);
	            var interventionUserListColumns = [{
	                title: '用户名称', // 列头显示名称
	                dataIndex: 'empName' // 列数据在数据项中对应的 key
	            }, {
	                title: '操作',
	                key: 'action',
	                render: function render(text, record) {
	                    return _this2.state.nodedata.human.length >= 1 ? _react2.default.createElement(
	                        _antd.Popconfirm,
	                        { title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
	                                return _this2.handleDelete(record, _this2.state.nodedata.human);
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'javascript:;' },
	                            '\u5220\u9664'
	                        )
	                    ) : null;
	                }
	            }];
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _antd.Form,
	                    { layout: 'vertical' },
	                    _react2.default.createElement(
	                        _antd.Collapse,
	                        { defaultActiveKey: ['1'] },
	                        _react2.default.createElement(
	                            Panel,
	                            { header: '\u901A\u7528\u8282\u70B9\u4FE1\u606F', key: '1' },
	                            _react2.default.createElement(_PubInfo2.default, { parent: this, node: this.state.node, nodedata: this.state.nodedata })
	                        ),
	                        _react2.default.createElement(
	                            Panel,
	                            { header: '\u8DF3\u8F6C\u8282\u70B9\u4FE1\u606F', key: '2' },
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 12 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u76EE\u6807\u8282\u70B9\u7F16\u53F7' },
	                                        getFieldDecorator('ncode', {
	                                            rules: [{ required: true, message: '请链接目标节点' }]
	                                        })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u94FE\u63A5\u76EE\u6807\u8282\u70B9', readOnly: true,
	                                            onChange: this.textOnChange.bind(this, 'ncode')
	                                        })),
	                                        '\u53CC\u51FB\u865A\u7EBF\u4FEE\u6539\u8DF3\u8F6C\u76EE\u6807\u8282\u70B9'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            Panel,
	                            { header: '\u5E72\u9884\u7B56\u7565', key: '4' },
	                            _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u4EBA\u5DE5\u5E72\u9884' },
	                                        getFieldDecorator('ishuman', {
	                                            rules: [{ required: false, message: '' }]
	                                        })(_react2.default.createElement(
	                                            RadioGroup,
	                                            { onChange: this.radioGroupOnChange.bind(this, 'ishuman') },
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "0" },
	                                                '\u4E0D\u5141\u8BB8'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Radio,
	                                                { value: "1" },
	                                                '\u5141\u8BB8'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ),
	                            this.state.nodedata.ishuman == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Form.Item,
	                                        { label: '\u5904\u7406\u89C4\u5219' },
	                                        getFieldDecorator('handling', {
	                                            rules: [{ required: false, message: '' }]
	                                        })(_react2.default.createElement(
	                                            CheckboxGroup,
	                                            { onChange: this.checkboxGroupOnChange.bind(this, 'handling') },
	                                            _react2.default.createElement(
	                                                _antd.Checkbox,
	                                                { value: "01" },
	                                                '\u5B8C\u6210\u8282\u70B9'
	                                            ),
	                                            _react2.default.createElement(
	                                                _antd.Checkbox,
	                                                { value: "02" },
	                                                '\u56DE\u9000\u5904\u7406'
	                                            )
	                                        ))
	                                    )
	                                )
	                            ) : "",
	                            this.state.nodedata.ishuman == "1" ? _react2.default.createElement(
	                                _antd.Row,
	                                { gutter: 16 },
	                                _react2.default.createElement(
	                                    _antd.Col,
	                                    { span: 24 },
	                                    _react2.default.createElement(
	                                        _antd.Button,
	                                        { size: 'small', onClick: this.handleAdd.bind(this, "human"), type: 'primary', style: { marginBottom: 10 } },
	                                        '\u6DFB\u52A0\u64CD\u4F5C\u4EBA\u5458'
	                                    ),
	                                    _react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
	                                        rowClassName: function rowClassName() {
	                                            return 'userList-row';
	                                        } // 表格行的类名
	                                        , bordered: true // 是否展示外边框和列边框
	                                        , dataSource: human,
	                                        columns: interventionUserListColumns
	                                    })
	                                )
	                            ) : ""
	                        )
	                    )
	                ),
	                this.state.modalContent
	            );
	        }
	    }]);
	
	    return JumpNodeFrom;
	}(_react.Component);
	
	var JumpNode = _antd.Form.create()(JumpNodeFrom);
	exports.default = JumpNode;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	var _UserModal = __webpack_require__(137);
	
	var _PubInfo = __webpack_require__(162);
	
	var _PubInfo2 = _interopRequireDefault(_PubInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	var RadioGroup = _antd.Radio.Group;
	var jsPicture = __webpack_require__(2043);
	var javaPicture = __webpack_require__(2042);
	
	var ScriptNodeFrom = function (_Component) {
		_inherits(ScriptNodeFrom, _Component);
	
		function ScriptNodeFrom(props) {
			_classCallCheck(this, ScriptNodeFrom);
	
			var _this = _possibleConstructorReturn(this, (ScriptNodeFrom.__proto__ || Object.getPrototypeOf(ScriptNodeFrom)).call(this, props));
	
			_this.reload = function () {
				_this.setState({ loading: false });
			};
	
			_this.selectOnChange = function (attname, value) {
				//change传入对象为value
				tool.sgiLogger.log("事件：selectOnChange");
				_this.refresh(attname, value);
			};
	
			_this.checkboxGroupOnChange = function (attname, checkedValue) {
				tool.sgiLogger.log("事件：checkboxGroupOnChange");
				_this.refresh(attname, checkedValue);
			};
	
			_this.scriptcallinHandleOk = function (e) {
				var scriptcallin = _this.state.nodedata.scriptcallin;
	
				var newData = {
					inParamKey: _this.state.inParamKey,
					inParamValue: _this.state.inParamValue
				};
				_this.state.nodedata.scriptcallin = [].concat(_toConsumableArray(scriptcallin), [newData]);
				_this.state.modalinShow = false;
				_this.setState({
					loading: false
				});
			};
	
			_this.scriptcalloutHandleOk = function (e) {
				var scriptcallout = _this.state.nodedata.scriptcallout;
	
				var newData = {
					outParamKey: _this.state.outParamKey,
					outParamValue: _this.state.outParamValue
				};
				_this.state.nodedata.scriptcallout = [].concat(_toConsumableArray(scriptcallout), [newData]);
				_this.state.modaloutShow = false;
				_this.setState({
					loading: false
				});
			};
	
			_this.modalHandleCancel = function (e) {
				_this.setState({
					modalinShow: false,
					modaloutShow: false
				});
			};
	
			_this.modalOnChange = function (attname, e, e2) {
				tool.sgiLogger.log("事件：modalOnChange");
				var value = e.target.value;
				_this.state[attname] = value;
			};
	
			_this.getTBData = function (tData) {
				if (!tData) {
					tData = [];
					return tData;
				}
				tData.forEach(function (element) {
					if (!element._key) element._key = (0, _CommonFunc.uuid)(8);
				});
				return tData;
			};
	
			_this.handleAdd = function (modalType) {
				tool.sgiLogger.log("handleAdd表格添加方法");
				if (!modalType || modalType == '') {
					_this.state.modalContent = null;;
				}
				if (modalType == "scriptcallin") {
					_this.state.modalinShow = true;
				} else if (modalType == "scriptcallout") {
					_this.state.modaloutShow = true;
				}
				_this.setState({
					loading: false
				});
			};
	
			_this.handleDelete = function (delData, dataSource) {
				if (dataSource && delData) {
					for (var i = 0; i < dataSource.length; i++) {
						if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
							dataSource.splice(i, 1);
						}
					}
				}
				_this.setState({ loading: false });
			};
	
			_this.state = {
				node: props.node,
				show: props.show != null && props.show == true ? props.show : 'none',
				nodedata: props.nodedata,
				modalinShow: false,
				modaloutShow: false,
				loading: false,
				switch: false
			};
			return _this;
		}
	
		// 重新加载页面方法
	
	
		_createClass(ScriptNodeFrom, [{
			key: 'buttonOnChange',
	
			// 展示示例按钮点击事件
			value: function buttonOnChange(attname, e, e2) {
				tool.sgiLogger.log("事件：buttonOnChange");
				this.setState({
					switch: !this.state.switch
				});
			}
	
			// 文本修改事件
	
		}, {
			key: 'textOnChange',
			value: function textOnChange(attname, e, e2) {
				tool.sgiLogger.log("事件：textOnChange");
				var value = e.target.value;
				this.refresh(attname, value);
			}
			// 下拉窗修改事件
	
			// 复选框组修改事件，checkedValue为数组["01","02"]
	
		}, {
			key: 'numberOnChange',
	
			// 数字组件修改事件
			value: function numberOnChange(attname, e) {
				tool.sgiLogger.log("事件：numberOnChange");
				var value = e;
				this.refresh(attname, value);
			}
			// 单选框组修改事件
	
		}, {
			key: 'radioGroupOnChange',
			value: function radioGroupOnChange(attname, e) {
				tool.sgiLogger.log("事件：radioGroupOnChange");
				var value = e.target.value;
				this.refresh(attname, value);
			}
			// 属性更新
	
		}, {
			key: 'refresh',
			value: function refresh(attname, value) {
				if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
				this.state.nodedata[attname] = value;
			}
			// 输入参数modal确认按钮事件
	
			// 输出参数modal确认按钮事件
	
			// 输入参数modal取消按钮事件
	
			// modal中文本框修改事件
	
			// 创建表格绑定store（生成数据key）
	
		}, {
			key: 'componentDidMount',
	
			// 刷新form
			value: function componentDidMount() {
				tool.sgiLogger.log('事件：serviceNode加载后');
				this.props.form.setFieldsValue({
	
					scripttype: this.state.nodedata.scripttype,
					scriptcode: this.state.nodedata.scriptcode,
					scriptcallin: this.state.nodedata.scriptcallin,
					scriptcallout: this.state.nodedata.scriptcallout
				});
			}
			// 表格添加方法
	
			// 表格删除方法
	
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var getFieldDecorator = this.props.form.getFieldDecorator;
	
				var scriptcallinList = this.getTBData(this.state.nodedata.scriptcallin);
				var scriptcallinListColumns = [{
					title: '输入参数key', // 列头显示名称
					dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
				}, {
					title: '输入参数值', // 列头显示名称
					dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.scriptcallin.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.scriptcallin);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
				var scriptcalloutList = this.getTBData(this.state.nodedata.scriptcallout);
				var scriptcalloutListColumns = [{
					title: '输出参数key', // 列头显示名称
					dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
				}, {
					title: '输出参数值', // 列头显示名称
					dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.scriptcallout.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.scriptcallout);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
	
				tool.sgiLogger.log(this.props);
				tool.sgiLogger.log(this.state.show);
				return _react2.default.createElement(
					'div',
					{ style: { display: this.state.show } },
					_react2.default.createElement(
						_antd.Form,
						{ layout: 'vertical' },
						_react2.default.createElement(
							_antd.Collapse,
							{ defaultActiveKey: ['1'] },
							_react2.default.createElement(
								Panel,
								{ header: '\u901A\u7528\u8282\u70B9\u4FE1\u606F', key: '1' },
								_react2.default.createElement(_PubInfo2.default, { parent: this, node: this.state.node, nodedata: this.state.nodedata })
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u811A\u672C\u8282\u70B9\u4FE1\u606F', key: '2' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u811A\u672C\u7C7B\u578B' },
											getFieldDecorator('scripttype', {
												rules: [{ required: true, message: '请输入脚本类型' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'scripttype') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'JavaScript'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'JAVA'
												)
											))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											'div',
											{ align: 'right' },
											_react2.default.createElement(
												_antd.Button,
												{ size: 'small', onClick: this.handleAdd.bind(this, "scriptcallin"), type: 'primary', style: { marginBottom: 10 } },
												'\u6DFB\u52A0\u811A\u672C\u8F93\u5165'
											)
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'incomeList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: scriptcallinList,
											columns: scriptcallinListColumns
										}),
										_react2.default.createElement(
											_antd.Modal,
											{
												title: '\u6DFB\u52A0\u811A\u672C\u8F93\u5165\u53C2\u6570',
												visible: this.state.modalinShow,
												onOk: this.scriptcallinHandleOk.bind(this),
												onCancel: this.modalHandleCancel,
												okText: '\u786E\u8BA4',
												cancelText: '\u53D6\u6D88',
												destroyOnClose: true
											},
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u8F93\u5165\u53C2\u6570key' },
												_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570key',
													onChange: this.modalOnChange.bind(this, 'inParamKey')
												})
											),
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u8F93\u5165\u53C2\u6570value' },
												_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570value',
													onChange: this.modalOnChange.bind(this, 'inParamValue')
												})
											)
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											'div',
											{ style: { color: "red" } },
											'\u8F93\u51FA\u53C2\u6570\u5C06\u4FDD\u5B58\u5728\u5DE5\u4F5C\u6D41\u7684\u4E1A\u52A1\u6570\u636E\u4E2D'
										),
										_react2.default.createElement(
											'div',
											{ align: 'right' },
											_react2.default.createElement(
												_antd.Button,
												{ size: 'small', onClick: this.handleAdd.bind(this, "scriptcallout"), type: 'primary', style: { marginBottom: 10 } },
												'\u6DFB\u52A0\u811A\u672C\u8F93\u51FA'
											)
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'incomeList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: scriptcalloutList,
											columns: scriptcalloutListColumns
										}),
										_react2.default.createElement(
											_antd.Modal,
											{
												title: '\u6DFB\u52A0\u811A\u672C\u8F93\u51FA\u53C2\u6570',
												visible: this.state.modaloutShow,
												onOk: this.scriptcalloutHandleOk.bind(this),
												onCancel: this.modalHandleCancel,
												okText: '\u786E\u8BA4',
												cancelText: '\u53D6\u6D88',
												destroyOnClose: true
											},
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u8F93\u51FA\u53C2\u6570key' },
												_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570key',
													onChange: this.modalOnChange.bind(this, 'outParamKey')
												})
											),
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u8F93\u51FA\u53C2\u6570value' },
												_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570value',
													onChange: this.modalOnChange.bind(this, 'outParamValue')
												})
											)
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{
												// label="脚本内容">
												label: _react2.default.createElement(
													'div',
													{ style: { width: 620 } },
													'\u811A\u672C\u5185\u5BB9',
													_react2.default.createElement(
														_antd.Button
														// size="small"
														,
														{ style: {
																backgroundColor: "#1890ff",
																color: "white",
																marginLeft: "76%"
															},
															onClick: this.buttonOnChange.bind(this),
															type: 'primary' },
														this.state.switch == true ? "收起示例" : "展示示例"
													)
												) },
											getFieldDecorator('scriptcode', {
												rules: [{ required: false, message: '请输入脚本内容' }]
											})(_react2.default.createElement(_antd.Input.TextArea, { rows: 10, placeholder: '\u8BF7\u8F93\u5165\u811A\u672C\u5185\u5BB9',
												onChange: this.textOnChange.bind(this, 'scriptcode')
											}))
										)
									),
									this.state.nodedata.scripttype == "0" ? _react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{
												// label="示例"
												style: { display: this.state.switch == true ? undefined : "none" }
											},
											_react2.default.createElement(
												'div',
												{ style: { fontWeight: 'bold', fontSize: 17, backgroundColor: "green", color: "white", textAlign: "center" } },
												'\u793A\u4F8B'
											),
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement('img', {
													style: { width: "100%", height: "100%" },
													src: jsPicture })
											),
											_react2.default.createElement(_antd.Input.TextArea, { readOnly: true, rows: 10,
												value: "//获取输入参数时直接使用输入参数key\rvar e =inkeyone;\rvar f =inkeytwo;\rvar g =inkeythree;\r\r//输出参数\r//脚本中定义的所有变量名都可以作为输出参数的key\rvar a =1;\rvar b = \"str\";\rvar c = 3;"
											})
										)
									) : _react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{
												// label="示例"
												style: { display: this.state.switch == true ? undefined : "none" }
											},
											_react2.default.createElement(
												'div',
												{ style: { fontWeight: 'bold', fontSize: 17, backgroundColor: "green", color: "white", textAlign: "center" } },
												'\u793A\u4F8B'
											),
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement('img', {
													style: { width: "100%", height: "100%" },
													src: javaPicture })
											),
											_react2.default.createElement(_antd.Input.TextArea, { readOnly: true, rows: 10,
												value: "//从map中获取输入参数 \rObject getValueOne = map.get(\"inKeyOne\"); \rObject getValueTwo = map.get(\"inKeyTwo\");	\rObject getValueThree = map.get(\"inKeyThree\");\r\r//输出参数以key-value的形式放入map中	\r//输出内容为数字类型时,需要转换成Integer类型	\rjava.lang.Integer outPutValueOne = new java.lang.Integer(111);	\rmap.put(\"outKeyOne\",outPutValueOne );	\r\r//输出内容为字符串或对象类型时直接放入map中	\rmap.put(\"outKeyTwo\", \"www.baidu.com\");	\rmap.put(\"outKeyThree\",getValueThree );"
											})
										)
									)
								)
							)
						)
					),
					this.state.modalContent
				);
			}
		}]);
	
		return ScriptNodeFrom;
	}(_react.Component);
	
	var ScriptNode = _antd.Form.create()(ScriptNodeFrom);
	
	exports.default = ScriptNode;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	var _UserModal = __webpack_require__(137);
	
	var _PubInfo = __webpack_require__(162);
	
	var _PubInfo2 = _interopRequireDefault(_PubInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	var RadioGroup = _antd.Radio.Group;
	
	var ServiceNodeFrom = function (_Component) {
		_inherits(ServiceNodeFrom, _Component);
	
		function ServiceNodeFrom(props) {
			_classCallCheck(this, ServiceNodeFrom);
	
			var _this = _possibleConstructorReturn(this, (ServiceNodeFrom.__proto__ || Object.getPrototypeOf(ServiceNodeFrom)).call(this, props));
	
			_this.reload = function () {
				_this.setState({ loading: false });
			};
	
			_this.selectOnChange = function (attname, value) {
				//change传入对象为value
				tool.sgiLogger.log("事件：selectOnChange");
				_this.refresh(attname, value);
			};
	
			_this.checkboxGroupOnChange = function (attname, checkedValue) {
				tool.sgiLogger.log("事件：checkboxGroupOnChange");
				_this.refresh(attname, checkedValue);
			};
	
			_this.modalHandleOk = function (type) {
	
				if (type == "servicecallin") {
					var newData = {
						inParamKey: _this.state.inParamKey,
						inParamValue: _this.state.inParamValue
					};
					if (typeof _this.state.nodedata.servicecallin == "undefined") {
						_this.state.nodedata.servicecallin = [];
					}
					var servicecallin = _this.state.nodedata.servicecallin;
	
					_this.state.nodedata.servicecallin = [].concat(_toConsumableArray(servicecallin), [newData]);
					_this.state.servicecallinModalShow = false;
				} else if (type == "servicecallbackin") {
					var _newData = {
						inParamKey: _this.state.inParamKey,
						inParamValue: _this.state.inParamValue
					};
					if (typeof _this.state.nodedata.servicecallbackin == "undefined") {
						_this.state.nodedata.servicecallbackin = [];
					}
					var servicecallbackin = _this.state.nodedata.servicecallbackin;
	
					_this.state.nodedata.servicecallbackin = [].concat(_toConsumableArray(servicecallbackin), [_newData]);
					_this.state.servicecallbackinModalShow = false;
				} else if (type == "servicecallout") {
					var _newData2 = {
						outParamKey: _this.state.outParamKey,
						outParamValue: _this.state.outParamValue
					};
					if (typeof _this.state.nodedata.servicecallout == "undefined") {
						_this.state.nodedata.servicecallout = [];
					}
					var servicecallout = _this.state.nodedata.servicecallout;
	
					_this.state.nodedata.servicecallout = [].concat(_toConsumableArray(servicecallout), [_newData2]);
					_this.state.servicecalloutModalShow = false;
				} else if (type == "servicecallbackout") {
					var _newData3 = {
						outParamKey: _this.state.outParamKey,
						outParamValue: _this.state.outParamValue
					};
					if (typeof _this.state.nodedata.servicecallbackout == "undefined") {
						_this.state.nodedata.servicecallbackout = [];
					}
					var servicecallbackout = _this.state.nodedata.servicecallbackout;
	
					_this.state.nodedata.servicecallbackout = [].concat(_toConsumableArray(servicecallbackout), [_newData3]);
					_this.state.servicecallbackoutModalShow = false;
				}
				// 清空state中缓存，防止不填写数据点击确定时添加了旧数据
				_this.state.inParamKey = null;
				_this.state.inParamValue = null;
	
				_this.setState({
					loading: false
				});
			};
	
			_this.modalHandleCancel = function (type) {
				// 清空state中缓存，防止不填写数据点击确定时添加了旧数据
				_this.state.inParamKey = null;
				_this.state.inParamValue = null;
	
				_this.setState({ servicecallinModalShow: false, servicecallbackinModalShow: false, servicecalloutModalShow: false, servicecallbackoutModalShow: false });
			};
	
			_this.modalOnChange = function (attname, e, e2) {
				tool.sgiLogger.log("事件：modalOnChange");
				var value = e.target.value;
				_this.state[attname] = value;
			};
	
			_this.handleAdd = function (modalType) {
				tool.sgiLogger.log("handleAdd表格添加方法");
				if (!modalType || modalType == '') {
					_this.state.modalContent = null;;
				}
				if (modalType == "servicecallin") {
					_this.state.servicecallinModalShow = true;
				} else if (modalType == "servicecallbackin") {
					_this.state.servicecallbackinModalShow = true;
				} else if (modalType == "servicecallbackout") {
					_this.state.servicecallbackoutModalShow = true;
				} else if (modalType == "servicecallout") {
					_this.state.servicecalloutModalShow = true;
				} else if (modalType == 'human') {
					_this.state.modalContent = _react2.default.createElement(_UserModal.UserModal, { key: (0, _CommonFunc.uuid)(8), modalShow: true, title: '\u9009\u62E9\u64CD\u4F5C\u4EBA\u5458',
						approvalUserList: _this.state.nodedata.human, parent: _this });
				}
				_this.setState({
					loading: false
				});
			};
	
			_this.handleDelete = function (delData, dataSource) {
				if (dataSource && delData) {
					for (var i = 0; i < dataSource.length; i++) {
						if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
							dataSource.splice(i, 1);
						}
					}
				}
				_this.setState({ loading: false });
			};
	
			_this.getTBData = function (tData) {
				if (!tData) {
					tData = [];
					return tData;
				}
				tData.forEach(function (element) {
					if (!element._key) element._key = (0, _CommonFunc.uuid)(8);
				});
				return tData;
			};
	
			_this.state = {
				node: props.node,
				show: props.show != null && props.show == true ? props.show : 'none',
				nodedata: props.nodedata,
				servicecallinModalShow: false,
				servicecallbackinModalShow: false,
				servicecalloutModalShow: false,
				servicecallbackoutModalShow: false,
				loading: false
			};
			return _this;
		}
	
		// 重新加载页面方法
	
	
		_createClass(ServiceNodeFrom, [{
			key: 'textOnChange',
	
	
			// 文本修改事件
			value: function textOnChange(attname, e, e2) {
				tool.sgiLogger.log("事件：textOnChange");
				var value = e.target.value;
				this.refresh(attname, value);
			}
			// 下拉窗修改事件
	
			// 复选框组修改事件，checkedValue为数组["01","02"]
	
		}, {
			key: 'numberOnChange',
	
			// 数字组件修改事件
			value: function numberOnChange(attname, e) {
				tool.sgiLogger.log("事件：numberOnChange");
				var value = e;
				this.refresh(attname, value);
			}
			// 单选框组修改事件
	
		}, {
			key: 'radioGroupOnChange',
			value: function radioGroupOnChange(attname, e) {
				tool.sgiLogger.log("事件：radioGroupOnChange");
				var value = e.target.value;
				this.refresh(attname, value);
			}
			// 属性更新
	
		}, {
			key: 'refresh',
			value: function refresh(attname, value) {
				if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
				this.state.nodedata[attname] = value;
			}
			// modal确认按钮事件
	
			// modal取消按钮事件
	
			// modal中文本框修改事件
	
			// 表格添加方法
	
			// 表格删除方法
	
			// 创建表格绑定store（生成数据key）
	
		}, {
			key: 'componentDidMount',
	
			// 刷新form
			value: function componentDidMount() {
				tool.sgiLogger.log('事件：serviceNode加载后');
				this.props.form.setFieldsValue({
					// id: this.state.nodedata.id,
					// name: this.state.nodedata.name,
					// type: this.state.nodedata.type,
					// status: this.state.nodedata.status,
					// inCondition: this.state.nodedata.inCondition,
					// outCondition: this.state.nodedata.outCondition,
					// executionInterface: this.state.nodedata.executionInterface,
					// targetTaskCode: this.state.nodedata.targetTaskCode,
					// ann: this.state.nodedata.ann,
	
					serviceUrl: this.state.nodedata.serviceUrl,
					serviceprotocol: this.state.nodedata.serviceprotocol,
					serviceprocessor: this.state.nodedata.serviceprocessor,
					servicecallin: this.state.nodedata.servicecallin,
					servicecallout: this.state.nodedata.servicecallout,
	
					servicecalltype: this.state.nodedata.servicecalltype,
					serviceAcynctype: this.state.nodedata.serviceAcynctype,
					servicetimeout: this.state.nodedata.servicetimeout,
					servicecallbackUrl: this.state.nodedata.servicecallbackUrl,
					servicecallbackin: this.state.nodedata.servicecallbackin,
					servicecallbackout: this.state.nodedata.servicecallbackout,
	
					receivetimeout: this.state.nodedata.receivetimeout,
					servicetimeoutHandling: this.state.nodedata.servicetimeoutHandling,
					redoServiceUrl: this.state.nodedata.redoServiceUrl,
					// redoTime: this.state.nodedata.redoTime, // 注释掉是因为避免组件渲染之前赋值报错
					// redoCycle: this.state.nodedata.redoCycle,
	
					ishuman: this.state.nodedata.ishuman,
					receivetimeoutHandling: this.state.nodedata.receivetimeoutHandling
					// interventionUsers: this.state.nodedata.interventionUsers
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var getFieldDecorator = this.props.form.getFieldDecorator;
	
				var servicecallinList = this.getTBData(this.state.nodedata.servicecallin);
				var servicecallinListColumns = [{
					title: '输入参数key', // 列头显示名称
					dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
				}, {
					title: '输入参数值', // 列头显示名称
					dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.servicecallin.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.servicecallin);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
				var servicecalloutList = this.getTBData(this.state.nodedata.servicecallout);
				var servicecalloutListColumns = [{
					title: '输出参数key', // 列头显示名称
					dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
				}, {
					title: '输出参数值', // 列头显示名称
					dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.servicecallout.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.servicecallout);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
				var servicecallbackinList = this.getTBData(this.state.nodedata.servicecallbackin);
				var servicecallbackinListColumns = [{
					title: '输入参数key', // 列头显示名称
					dataIndex: 'inParamKey' // 列数据在数据项中对应的 key
				}, {
					title: '输入参数值', // 列头显示名称
					dataIndex: 'inParamValue' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.servicecallbackin.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.servicecallbackin);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
				var servicecallbackoutList = this.getTBData(this.state.nodedata.servicecallbackout);
				var servicecallbackoutListColumns = [{
					title: '输出参数key', // 列头显示名称
					dataIndex: 'outParamKey' // 列数据在数据项中对应的 key
				}, {
					title: '输出参数值', // 列头显示名称
					dataIndex: 'outParamValue' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.servicecallbackout.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.servicecallbackout);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
				var human = this.getTBData(this.state.nodedata.human);
				var interventionUserListColumns = [{
					title: '用户名称', // 列头显示名称
					dataIndex: 'empName' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.human.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.human);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
				return _react2.default.createElement(
					'div',
					{ style: { display: this.state.show } },
					_react2.default.createElement(
						_antd.Form,
						{ layout: 'vertical' },
						_react2.default.createElement(
							_antd.Collapse,
							{ defaultActiveKey: ['1'] },
							_react2.default.createElement(
								Panel,
								{ header: '\u901A\u7528\u8282\u70B9\u4FE1\u606F', key: '1' },
								_react2.default.createElement(_PubInfo2.default, { parent: this, node: this.state.node, nodedata: this.state.nodedata })
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u670D\u52A1\u8282\u70B9\u4FE1\u606F', key: '2' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u670D\u52A1url' },
											getFieldDecorator('serviceUrl', {
												rules: [{ required: true, message: '请输入服务url' }]
											})(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u670D\u52A1url',
												onChange: this.textOnChange.bind(this, 'serviceUrl')
											}))
										)
									),
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u901A\u8BAF\u534F\u8BAE' },
											getFieldDecorator('serviceprotocol', {
												rules: [{ required: true, message: '请输入通讯协议' }]
											})(_react2.default.createElement(
												_antd.Select,
												{ placeholder: '\u8BF7\u8F93\u5165\u901A\u8BAF\u534F\u8BAE',
													onChange: this.selectOnChange.bind(this, 'serviceprotocol')
												},
												_react2.default.createElement(
													Option,
													{ value: '0' },
													'resful'
												),
												_react2.default.createElement(
													Option,
													{ value: '1' },
													'xml'
												),
												_react2.default.createElement(
													Option,
													{ value: '2' },
													'\u5B9A\u957F\u62A5\u6587'
												),
												_react2.default.createElement(
													Option,
													{ value: '3' },
													'8583\u62A5\u6587'
												),
												_react2.default.createElement(
													Option,
													{ value: '4' },
													'\u81EA\u5B9A\u4E49\u62A5\u6587'
												),
												_react2.default.createElement(
													Option,
													{ value: '5' },
													'\u672C\u5730\u8C03\u7528'
												)
											))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u901A\u8BAF\u5904\u7406\u7A0B\u5E8F' },
											getFieldDecorator('serviceprocessor', {
												rules: [{ required: false, message: '请输入通讯处理程序' }]
											})(_react2.default.createElement(_antd.Input.TextArea, { rows: 2, placeholder: '\u8BF7\u8F93\u5165\u901A\u8BAF\u5904\u7406\u7A0B\u5E8F',
												onChange: this.textOnChange.bind(this, 'serviceprocessor')
											}))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											'div',
											{ align: 'right' },
											_react2.default.createElement(
												_antd.Button,
												{ size: 'small', onClick: this.handleAdd.bind(this, "servicecallin"), type: 'primary', style: { marginBottom: 10 } },
												'\u6DFB\u52A0\u670D\u52A1\u8F93\u5165'
											)
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'incomeList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: servicecallinList,
											columns: servicecallinListColumns
										}),
										_react2.default.createElement(
											_antd.Modal,
											{
												title: '\u6DFB\u52A0\u670D\u52A1\u8F93\u5165\u53C2\u6570',
												visible: this.state.servicecallinModalShow,
												onOk: this.modalHandleOk.bind(this, "servicecallin"),
												onCancel: this.modalHandleCancel.bind(this, "servicecallin"),
												okText: '\u786E\u8BA4',
												cancelText: '\u53D6\u6D88',
												destroyOnClose: true
											},
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u8F93\u5165\u53C2\u6570key' },
												_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570key',
													onChange: this.modalOnChange.bind(this, 'inParamKey')
												})
											),
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u8F93\u5165\u53C2\u6570value' },
												_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570value',
													onChange: this.modalOnChange.bind(this, 'inParamValue')
												})
											)
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											'div',
											{ style: { color: "red" } },
											'\u8F93\u51FA\u53C2\u6570\u5C06\u4FDD\u5B58\u5728\u5DE5\u4F5C\u6D41\u7684\u4E1A\u52A1\u6570\u636E\u4E2D'
										),
										_react2.default.createElement(
											'div',
											{ align: 'right' },
											_react2.default.createElement(
												_antd.Button,
												{ size: 'small', onClick: this.handleAdd.bind(this, "servicecallout"), type: 'primary', style: { marginBottom: 10 } },
												'\u6DFB\u52A0\u670D\u52A1\u8F93\u51FA'
											)
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'incomeList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: servicecalloutList,
											columns: servicecalloutListColumns
										}),
										_react2.default.createElement(
											_antd.Modal,
											{
												title: '\u6DFB\u52A0\u670D\u52A1\u8F93\u51FA\u53C2\u6570',
												visible: this.state.servicecalloutModalShow,
												onOk: this.modalHandleOk.bind(this, "servicecallout"),
												onCancel: this.modalHandleCancel,
												okText: '\u786E\u8BA4',
												cancelText: '\u53D6\u6D88',
												destroyOnClose: true
											},
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u8F93\u51FA\u53C2\u6570key' },
												_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570key',
													onChange: this.modalOnChange.bind(this, 'outParamKey')
												})
											),
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u8F93\u51FA\u53C2\u6570value' },
												_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570value',
													onChange: this.modalOnChange.bind(this, 'outParamValue')
												})
											)
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u8C03\u7528\u65B9\u5F0F' },
											getFieldDecorator('servicecalltype', {
												rules: [{ required: true, message: '' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, "servicecalltype") },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u540C\u6B65'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u5F02\u6B65'
												)
											))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u8D85\u65F6\u65F6\u95F4' },
											getFieldDecorator('servicetimeout', {
												initialValue: this.state.nodedata.servicetimeout,
												rules: [{ required: false, message: '请输入超时时间' }]
											})(_react2.default.createElement(_antd.InputNumber, {
												min: 0,
												onChange: this.numberOnChange.bind(this, "servicetimeout")
											})),
											_react2.default.createElement(
												'span',
												null,
												' \u79D2'
											)
										)
									)
								),
								this.state.nodedata.servicecalltype == "1" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5F02\u6B65\u56DE\u8C03\u65B9\u5F0F' },
											getFieldDecorator('serviceAcynctype', {
												rules: [{ required: true, message: '' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, "serviceAcynctype") },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u56DE\u8C03\u63A5\u53E3'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "2" },
													'\u6D88\u606F\u901A\u77E5'
												)
											))
										)
									)
								) : "",
								this.state.nodedata.servicecalltype == "9" ? _react2.default.createElement(
									_antd.Card,
									null,
									this.state.nodedata.serviceAcynctype == "1" ? _react2.default.createElement(
										_antd.Row,
										{ gutter: 16 },
										_react2.default.createElement(
											_antd.Col,
											{ span: 24 },
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u56DE\u8C03\u63A5\u53E3' },
												getFieldDecorator('servicecallbackUrl', {
													initialValue: this.state.nodedata.servicecallbackUrl,
													rules: [{ required: false, message: '请输入回调接口' }]
												})(_react2.default.createElement(_antd.Input.TextArea, { rows: 4, placeholder: '\u8BF7\u8F93\u5165\u56DE\u8C03\u63A5\u53E3',
													onChange: this.textOnChange.bind(this, 'servicecallbackUrl')
												}))
											)
										)
									) : "",
									this.state.nodedata.serviceAcynctype == "2" ? _react2.default.createElement(
										_antd.Row,
										{ gutter: 16 },
										_react2.default.createElement(
											_antd.Col,
											{ span: 24 },
											_react2.default.createElement(
												_antd.Form.Item,
												{ label: '\u81EA\u5B9A\u4E49\u56DE\u8C03\u5904\u7406' },
												getFieldDecorator('servicecallbackUrl', {
													initialValue: this.state.nodedata.servicecallbackUrl,
													rules: [{ required: false, message: '请输入回调处理' }]
												})(_react2.default.createElement(_antd.Input.TextArea, { rows: 4, placeholder: '\u8BF7\u8F93\u5165\u56DE\u8C03\u5904\u7406',
													onChange: this.textOnChange.bind(this, 'servicecallbackUrl')
												}))
											)
										)
									) : "",
									this.state.nodedata.serviceAcynctype != "0" ? _react2.default.createElement(
										_antd.Row,
										{ gutter: 16 },
										_react2.default.createElement(
											_antd.Col,
											{ span: 24 },
											_react2.default.createElement(
												'div',
												{ align: 'right' },
												_react2.default.createElement(
													_antd.Button,
													{ size: 'small', onClick: this.handleAdd.bind(this, "servicecallbackin"), type: 'primary', style: { marginBottom: 10 } },
													'\u6DFB\u52A0\u56DE\u8C03\u670D\u52A1\u8F93\u5165'
												)
											),
											_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
												rowClassName: function rowClassName() {
													return 'incomeList-row';
												} // 表格行的类名
												, bordered: true // 是否展示外边框和列边框
												, dataSource: servicecallbackinList,
												columns: servicecallbackinListColumns
											}),
											_react2.default.createElement(
												_antd.Modal,
												{
													title: '\u6DFB\u52A0\u56DE\u8C03\u670D\u52A1\u8F93\u5165\u53C2\u6570',
													visible: this.state.servicecallbackinModalShow,
													onOk: this.modalHandleOk.bind(this, "servicecallbackin"),
													onCancel: this.modalHandleCancel.bind(this, "servicecallbackin"),
													okText: '\u786E\u8BA4',
													cancelText: '\u53D6\u6D88',
													destroyOnClose: true
												},
												_react2.default.createElement(
													_antd.Form.Item,
													{ label: '\u8F93\u5165\u53C2\u6570key' },
													_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570key',
														onChange: this.modalOnChange.bind(this, 'inParamKey')
													})
												),
												_react2.default.createElement(
													_antd.Form.Item,
													{ label: '\u8F93\u5165\u53C2\u6570value' },
													_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u5165\u53C2\u6570value',
														onChange: this.modalOnChange.bind(this, 'inParamValue')
													})
												)
											)
										)
									) : "",
									this.state.nodedata.serviceAcynctype != "0" ? _react2.default.createElement(
										_antd.Row,
										{ gutter: 16 },
										_react2.default.createElement(
											_antd.Col,
											{ span: 24 },
											_react2.default.createElement(
												'div',
												{ style: { color: "red" } },
												'\u8F93\u51FA\u53C2\u6570\u5C06\u4FDD\u5B58\u5728\u5DE5\u4F5C\u6D41\u7684\u4E1A\u52A1\u6570\u636E\u4E2D'
											),
											_react2.default.createElement(
												'div',
												{ align: 'right' },
												_react2.default.createElement(
													_antd.Button,
													{ size: 'small', onClick: this.handleAdd.bind(this, "servicecallbackout"), type: 'primary', style: { marginBottom: 10 } },
													'\u6DFB\u52A0\u670D\u52A1\u8F93\u51FA'
												)
											),
											_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
												rowClassName: function rowClassName() {
													return 'incomeList-row';
												} // 表格行的类名
												, bordered: true // 是否展示外边框和列边框
												, dataSource: servicecallbackoutList,
												columns: servicecallbackoutListColumns
											}),
											_react2.default.createElement(
												_antd.Modal,
												{
													title: '\u6DFB\u52A0\u670D\u52A1\u8F93\u51FA\u53C2\u6570',
													visible: this.state.servicecallbackoutModalShow,
													onOk: this.modalHandleOk.bind(this, "servicecallbackout"),
													onCancel: this.modalHandleCancel,
													okText: '\u786E\u8BA4',
													cancelText: '\u53D6\u6D88',
													destroyOnClose: true
												},
												_react2.default.createElement(
													_antd.Form.Item,
													{ label: '\u8F93\u51FA\u53C2\u6570key' },
													_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570key',
														onChange: this.modalOnChange.bind(this, 'outParamKey')
													})
												),
												_react2.default.createElement(
													_antd.Form.Item,
													{ label: '\u8F93\u51FA\u53C2\u6570value' },
													_react2.default.createElement(_antd.Input, { placeholder: '\u8F93\u51FA\u53C2\u6570value',
														onChange: this.modalOnChange.bind(this, 'outParamValue')
													})
												)
											)
										)
									) : ""
								) : ""
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u8D85\u65F6\u7B56\u7565', key: '3' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u63A5\u6536\u8D85\u65F6\u65F6\u9650' },
											getFieldDecorator('receivetimeout ', {
												initialValue: this.state.nodedata.receivetimeout,
												rules: [{ required: false, message: '请输入超时时限' }]
											})(_react2.default.createElement(_antd.InputNumber, {
												min: 0,
												onChange: this.numberOnChange.bind(this, "receivetimeout")
											})),
											_react2.default.createElement(
												'span',
												null,
												' \u5206\u949F'
											)
										)
									),
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u8D85\u65F6\u5904\u7406\u89C4\u5219' },
											getFieldDecorator('servicetimeoutHandling', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												_antd.Select,
												{ placeholder: '\u8BF7\u9009\u62E9\u8D85\u65F6\u5904\u7406\u89C4\u5219',
													onChange: this.selectOnChange.bind(this, 'servicetimeoutHandling')
												},
												_react2.default.createElement(
													Option,
													{ value: '01' },
													'\u4E0D\u5904\u7406'
												),
												_react2.default.createElement(
													Option,
													{ value: '02' },
													'\u8865\u507F\u5904\u7406'
												),
												_react2.default.createElement(
													Option,
													{ value: '03' },
													'\u5411\u521B\u5EFA\u4EBA\u53D1\u6D88\u606F'
												),
												_react2.default.createElement(
													Option,
													{ value: '04' },
													'\u56DE\u9000\u5904\u7406'
												)
											))
										)
									)
								),
								this.state.nodedata.servicetimeoutHandling == "02" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u8865\u507F\u6267\u884C\u6B21\u6570' },
											getFieldDecorator('redoTime', {
												initialValue: this.state.nodedata.redoTime,
												rules: [{ required: false, message: '请输入补偿执行次数' }]
											})(_react2.default.createElement(_antd.InputNumber, {
												min: 0,
												onChange: this.numberOnChange.bind(this, "redoTime")
											})),
											_react2.default.createElement(
												'span',
												null,
												' \u6B21'
											)
										)
									),
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u8865\u507F\u6267\u884C\u5468\u671F' },
											getFieldDecorator('redoCycle', {
												initialValue: this.state.nodedata.redoCycle,
												rules: [{ required: false, message: '请选择补偿执行周期' }]
											})(_react2.default.createElement(
												_antd.Select,
												{ placeholder: '\u8BF7\u9009\u62E9\u8865\u507F\u6267\u884C\u5468\u671F',
													onChange: this.selectOnChange.bind(this, 'redoCycle')
												},
												_react2.default.createElement(
													Option,
													{ value: '01' },
													'\u4E0D\u91CD\u590D'
												),
												_react2.default.createElement(
													Option,
													{ value: '02' },
													'\u6BCF10\u5206\u949F'
												),
												_react2.default.createElement(
													Option,
													{ value: '03' },
													'\u6BCF30\u5206\u949F'
												),
												_react2.default.createElement(
													Option,
													{ value: '04' },
													'\u6BCF60\u5206\u949F'
												)
											))
										)
									)
								) : // 补偿处理显示内容
								null // 不显示内容
	
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u5E72\u9884\u7B56\u7565', key: '4' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u4EBA\u5DE5\u5E72\u9884' },
											getFieldDecorator('ishuman', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'ishuman') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u4E0D\u5141\u8BB8'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u5141\u8BB8'
												)
											))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5904\u7406\u89C4\u5219' },
											getFieldDecorator('handling', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												CheckboxGroup,
												{ onChange: this.checkboxGroupOnChange.bind(this, 'handling') },
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "01" },
													'\u5B8C\u6210\u8282\u70B9'
												),
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "02" },
													'\u56DE\u9000\u5904\u7406'
												),
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "03" },
													'\u91CD\u65B0\u6267\u884C'
												)
											))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Button,
											{ size: 'small', onClick: this.handleAdd.bind(this, "human"), type: 'primary', style: { marginBottom: 10 } },
											'\u6DFB\u52A0\u64CD\u4F5C\u4EBA\u5458'
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'userList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: human,
											columns: interventionUserListColumns
										})
									)
								)
							)
						)
					),
					this.state.modalContent
				);
			}
		}]);
	
		return ServiceNodeFrom;
	}(_react.Component);
	
	var ServiceNode = _antd.Form.create()(ServiceNodeFrom);
	exports.default = ServiceNode;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StartNode = function (_Component) {
	  _inherits(StartNode, _Component);
	
	  function StartNode(props) {
	    _classCallCheck(this, StartNode);
	
	    var _this = _possibleConstructorReturn(this, (StartNode.__proto__ || Object.getPrototypeOf(StartNode)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(StartNode, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { id: 'blankpanel', style: { height: '100%', display: 'none' } },
	        '\u7A7A\u767D'
	      );
	    }
	  }]);
	
	  return StartNode;
	}(_react.Component);
	
	exports.default = StartNode;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	var _UserModal = __webpack_require__(137);
	
	var _RoleModal = __webpack_require__(372);
	
	var _PubInfo = __webpack_require__(162);
	
	var _PubInfo2 = _interopRequireDefault(_PubInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	var RadioGroup = _antd.Radio.Group;
	
	var TaskNodeFrom = function (_Component) {
		_inherits(TaskNodeFrom, _Component);
	
		function TaskNodeFrom(props) {
			_classCallCheck(this, TaskNodeFrom);
	
			var _this = _possibleConstructorReturn(this, (TaskNodeFrom.__proto__ || Object.getPrototypeOf(TaskNodeFrom)).call(this, props));
	
			_this.reload = function () {
				_this.setState({ loading: false });
			};
	
			_this.selectOnChange = function (attname, value) {
				//change传入对象为value
				tool.sgiLogger.log("事件：selectOnChange");
				_this.refresh(attname, value);
			};
	
			_this.selectOnChange2 = function (attname, value) {
				//change传入对象为value
				var me = _this;
				tool.sgiLogger.log("事件：selectOnChange");
	
				//初始给医院、医药公司的查询地址与请求信息
				var req = {
					values: { lesseeType: value }, // 租户类型
					matchs: {},
					batch: false
				};
	
				// let url = "http://100.1.1.27:8088/lesuam/LesseeRoleTpl/list";
				var url = sgiConfig.service_baseuam + "LesseeRoleTpl/list";
	
				//如果是医保局、则更改查询地址与请求信息
				if (value == "10") {
					req = {
						values: {},
						matchs: {},
						batch: false
						// url = "http://100.1.1.27:8088/lesuam/role/list";
					};url = sgiConfig.service_baseuam + "role/list";
				}
	
				commonClient.simplecall(url, req, function (res) {
					if (res && res.head && res.head.code == "0000") {
						tool.sgiLogger.log("根据租户类型查询角色成功！res：", res);
						var datas = res.body || [];
						tool.sgiLogger.log("datas", datas);
	
						var arr = [];
						for (var index = 0; index < datas.length; index++) {
							var element = datas[index];
							arr.push(_react2.default.createElement(
								Option,
								{ value: element.roleId },
								element.roleName
							));
						}
	
						tool.sgiLogger.log("arr", arr);
						// this.refresh("roleOption", arr);
						me.state.roleOption = arr;
					} else {
						tool.sgiLogger.error("根据租户类型查询角色失败！res：", res);
					}
				});
				tool.sgiLogger.log("执行完毕！");
	
				_this.refresh(attname, value);
			};
	
			_this.checkboxGroupOnChange = function (attname, checkedValue) {
				tool.sgiLogger.log("事件：checkboxGroupOnChange");
				_this.refresh(attname, checkedValue);
			};
	
			_this.handleAdd = function (modalType) {
				tool.sgiLogger.log("handleAdd添加审批人/角色方法");
				if (!modalType || modalType == '') {
					_this.state.modalContent = null;
				}
				if (modalType == 'user') {
					_this.state.modalContent = _react2.default.createElement(_UserModal.UserModal, { key: (0, _CommonFunc.uuid)(8), modalShow: true, title: '\u9009\u62E9\u5BA1\u6279\u4EBA\u5458',
						approvalUserList: _this.state.nodedata.users, parent: _this });
				} else if (modalType == 'role') {
					_this.state.modalContent = _react2.default.createElement(_RoleModal.RoleModal, { key: (0, _CommonFunc.uuid)(8), modalShow: true, title: '\u9009\u62E9\u5BA1\u6279\u89D2\u8272',
						approvalRoleList: _this.state.nodedata.roles, parent: _this });
				} else if (modalType == 'overTimeout') {
					_this.state.modalContent = _react2.default.createElement(_UserModal.UserModal, { key: (0, _CommonFunc.uuid)(8), modalShow: true, title: '\u9009\u62E9\u63D0\u9192\u4EBA\u5458',
						approvalUserList: _this.state.nodedata.overTimeoutUsers, parent: _this });
				} else if (modalType == 'human') {
					_this.state.modalContent = _react2.default.createElement(_UserModal.UserModal, { key: (0, _CommonFunc.uuid)(8), modalShow: true, title: '\u9009\u62E9\u64CD\u4F5C\u4EBA\u5458',
						approvalUserList: _this.state.nodedata.human, parent: _this });
				}
				_this.setState({
					loading: false
				});
			};
	
			_this.handleDelete = function (delData, dataSource) {
				if (dataSource && delData) {
					for (var i = 0; i < dataSource.length; i++) {
						if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
							dataSource.splice(i, 1);
						}
					}
				}
				_this.setState({ loading: false });
			};
	
			_this.getTBData = function (tData) {
				if (!tData) {
					tData = [];
					return tData;
				}
				tData.forEach(function (element) {
					if (!element._key) element._key = (0, _CommonFunc.uuid)(8);
				});
				return tData;
			};
	
			_this.state = {
				node: props.node,
				show: props.show != null && props.show == true ? props.show : 'none',
				nodedata: props.nodedata,
				roleOption: _this.getRoleOption(props.nodedata.orgtype),
				loading: false
			};
			return _this;
		}
	
		_createClass(TaskNodeFrom, [{
			key: 'getRoleOption',
			value: function getRoleOption(orgtype) {
				tool.sgiLogger.log("getRoleOption====orgtype", orgtype);
	
				//初始给医院、医药公司的查询地址与请求信息
				var req = {
					values: { lesseeType: orgtype }, // 租户类型
					matchs: {},
					batch: false
				};
	
				// let url = "http://100.1.1.27:8088/lesuam/LesseeRoleTpl/list";
				var url = sgiConfig.service_baseuam + "LesseeRoleTpl/list";
	
				//如果是医保局、则更改查询地址与请求信息
				if (orgtype == "10") {
					req = {
						values: {},
						matchs: {},
						batch: false
						// url = "http://100.1.1.27:8088/lesuam/role/list";
					};url = sgiConfig.service_baseuam + "role/list";
				}
	
				var arr = [];
				commonClient.simplecall(url, req, function (res) {
					if (res && res.head && res.head.code == "0000") {
						tool.sgiLogger.log("根据租户类型查询角色成功！res：", res);
						var datas = res.body || [];
						tool.sgiLogger.log("datas", datas);
	
						for (var index = 0; index < datas.length; index++) {
							var element = datas[index];
							arr.push(_react2.default.createElement(
								Option,
								{ value: element.roleId },
								element.roleName
							));
						}
						tool.sgiLogger.log("arr", arr);
					} else {
						tool.sgiLogger.error("根据租户类型查询角色失败！res：", res);
					}
				});
	
				return arr;
			}
		}, {
			key: 'setValues',
			value: function setValues(values) {}
			// 重新加载页面方法
	
		}, {
			key: 'textOnChange',
	
			// 文本修改事件
			value: function textOnChange(attname, e, e2) {
				tool.sgiLogger.log("事件：textOnChange");
				var value = e.target.value;
				this.refresh(attname, value);
			}
			// 下拉窗修改事件
	
	
			//下拉窗修改事件2
	
	
			// 复选框组修改事件，checkedValue为数组["01","02"]
	
		}, {
			key: 'radioGroupOnChange',
	
			// 单选框组修改事件
			value: function radioGroupOnChange(attname, e) {
				tool.sgiLogger.log("事件：radioGroupOnChange");
				var value = e.target.value;
				this.refresh(attname, value);
			}
			// 数字组件修改事件
	
		}, {
			key: 'numberOnChange',
			value: function numberOnChange(attname, e) {
				var value = e;
				this.refresh(attname, value);
			}
			// 属性更新
	
		}, {
			key: 'refresh',
			value: function refresh(attname, value) {
				if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
				this.state.nodedata[attname] = value;
			}
			// 表格添加方法
	
			// 表格删除方法
	
			// 创建表格绑定store（生成数据key）
	
		}, {
			key: 'componentDidMount',
	
			// 刷新form
			value: function componentDidMount() {
				tool.sgiLogger.log('事件：taskNode加载后');
				this.props.form.setFieldsValue({
					executionInterface: this.state.nodedata.executionInterface,
					executionInterfaceparm: this.state.nodedata.executionInterfaceparm,
					tasktype: this.state.nodedata.tasktype,
					approvalstrategy: this.state.nodedata.approvalstrategy,
					approvalweight: this.state.nodedata.approvalweight,
					ismodiapproval: this.state.nodedata.ismodiapproval,
					isentrust: this.state.nodedata.isentrust,
					isjump: this.state.nodedata.isjump,
	
					remindMode: this.state.nodedata.remindMode,
					remindTime: this.state.nodedata.remindTime,
					remindCycle: this.state.nodedata.remindCycle,
	
					overTimeout: this.state.nodedata.overTimeout,
					overTimeoutHandling: this.state.nodedata.overTimeoutHandling,
					// overTimeoutUsers: this.state.nodedata.overTimeoutUsers,
	
					receiveTimeout: this.state.nodedata.receiveTimeout,
					receiveTimeoutHandling: this.state.nodedata.receiveTimeoutHandling,
	
					ishuman: this.state.nodedata.ishuman,
					handling: this.state.nodedata.handling,
					userrule: this.state.nodedata.userrule,
	
					orgkey: this.state.nodedata.orgkey,
					orgtype: this.state.nodedata.orgtype,
					rolekey: this.state.nodedata.rolekey
	
					// interventionUsers: this.state.nodedata.interventionUsers
	
				});
			}
	
			// 表格下拉窗修改事件
	
		}, {
			key: 'selectOnChangeTb',
			value: function selectOnChangeTb(record, attname, value, e) {
				tool.sgiLogger.log("事件：selectOnChangeTb");
				record[attname] = value;
				tool.sgiLogger.log('record :', record);
				this.setState({});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var getFieldDecorator = this.props.form.getFieldDecorator;
	
				var userList = this.getTBData(this.state.nodedata.users);
				var userListColumns = [{
					title: '用户名称', // 列头显示名称
					dataIndex: 'empName' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.users.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.users);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
				var roleList = this.getTBData(this.state.nodedata.roles);
				var roleListColumns = [{
					title: '角色名称', // 列头显示名称
					dataIndex: 'roleName' // 列数据在数据项中对应的 key
				}, {
					title: '类型', // 列头显示名称
					dataIndex: 'deptFlag', // 列数据在数据项中对应的 key
					render: function render(text, record, index) {
						return _react2.default.createElement(
							_antd.Select,
							{ placeholder: '\u8BF7\u9009\u62E9\u7C7B\u578B', value: text,
								onChange: _this2.selectOnChangeTb.bind(_this2, record, "deptFlag")
							},
							_react2.default.createElement(
								Option,
								{ value: '01' },
								'\u672C\u673A\u6784'
							),
							_react2.default.createElement(
								Option,
								{ value: '02' },
								'\u4E0A\u7EA7\u673A\u6784'
							)
						);
					}
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.roles.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.roles);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
	
				var overTimeoutUsers = this.getTBData(this.state.nodedata.overTimeoutUsers);
				var timeoutUserListColumns = [{
					title: '用户名称', // 列头显示名称
					dataIndex: 'empName' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.overTimeoutUsers.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.overTimeoutUsers);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
	
				var human = this.getTBData(this.state.nodedata.human);
				var interventionUserListColumns = [{
					title: '用户名称', // 列头显示名称
					dataIndex: 'empName' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.human.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.human);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
				return _react2.default.createElement(
					'div',
					{ style: { display: this.state.show } },
					_react2.default.createElement(
						_antd.Form,
						{ layout: 'vertical' },
						_react2.default.createElement(
							_antd.Collapse,
							{ defaultActiveKey: ['1'] },
							_react2.default.createElement(
								Panel,
								{ header: '\u901A\u7528\u8282\u70B9\u4FE1\u606F', key: '1' },
								_react2.default.createElement(_PubInfo2.default, { parent: this, node: this.state.node, nodedata: this.state.nodedata })
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u4EFB\u52A1\u8282\u70B9\u4FE1\u606F', key: '2' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u6267\u884C\u754C\u9762' },
											getFieldDecorator('executionInterface', {
												rules: [{ required: false, message: '请输入执行界面' }]
											})(_react2.default.createElement(_antd.Input, { placeholder: '\u6267\u884C\u754C\u9762',
												onChange: this.textOnChange.bind(this, 'executionInterface')
											}))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u754C\u9762\u542F\u52A8\u53C2\u6570' },
											getFieldDecorator('executionInterfaceparm', {
												rules: [{ required: false, message: '请输入界面启动参数' }]
											})(_react2.default.createElement(_antd.Input, { placeholder: '\u754C\u9762\u542F\u52A8\u53C2\u6570',
												onChange: this.textOnChange.bind(this, 'executionInterfaceparm')
											}))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u4EFB\u52A1\u7C7B\u578B' },
											getFieldDecorator('tasktype', {
												rules: [{ required: true, message: 'Please select an owner' }]
											})(_react2.default.createElement(
												_antd.Select,
												{ placeholder: '\u8BF7\u9009\u62E9\u4EFB\u52A1\u7C7B\u578B',
													onChange: this.selectOnChange.bind(this, 'tasktype')
												},
												_react2.default.createElement(
													Option,
													{ value: '01' },
													'\u666E\u901A\u4EFB\u52A1'
												),
												_react2.default.createElement(
													Option,
													{ value: '02' },
													'\u5BA1\u6279\u4EFB\u52A1'
												)
											))
										)
									),
									this.state.nodedata.tasktype == "02" ? _react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5BA1\u6279\u4EBA\u4FEE\u6539' },
											getFieldDecorator('ismodiapproval', {
												rules: [{ required: false, message: '是否允许修改审批人' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'ismodiapproval') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u4E0D\u5141\u8BB8'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u5141\u8BB8'
												)
											))
										)
									) : _react2.default.createElement(_antd.Col, { span: 12 })
								),
								this.state.nodedata.tasktype == "02" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5BA1\u6279\u7B56\u7565' },
											getFieldDecorator('approvalstrategy', {
												rules: [{ required: false, message: '请输入审批策略' }]
											})(_react2.default.createElement(
												_antd.Select,
												{ placeholder: '\u8BF7\u9009\u62E9\u8282\u70B9\u72B6\u6001',
													onChange: this.selectOnChange.bind(this, 'approvalstrategy')
												},
												_react2.default.createElement(
													Option,
													{ value: '0' },
													'\u5168\u90E8\u901A\u8FC7'
												),
												_react2.default.createElement(
													Option,
													{ value: '1' },
													'\u4E00\u7968\u901A\u8FC7'
												),
												_react2.default.createElement(
													Option,
													{ value: '2' },
													'\u4E00\u7968\u5426\u51B3'
												),
												_react2.default.createElement(
													Option,
													{ value: '3' },
													'\u5C11\u6570\u670D\u4ECE\u591A\u6570'
												),
												_react2.default.createElement(
													Option,
													{ value: '4' },
													'\u6743\u91CD'
												)
											))
										)
									),
									this.state.nodedata.approvalstrategy == "4" ? _react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5BA1\u6279\u6743\u91CD' },
											getFieldDecorator('approvalweight', {
												rules: [{ required: false, message: '请输入审批权重' }]
											})(_react2.default.createElement(_antd.Input, { placeholder: '\u5BA1\u6279\u6743\u91CD',
												onChange: this.textOnChange.bind(this, 'approvalweight')
											}))
										)
									) : _react2.default.createElement(_antd.Col, { span: 12 })
								) : "",
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5141\u8BB8\u59D4\u6258' },
											getFieldDecorator('isentrust', {
												rules: [{ required: true, message: 'Please select an owner' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'isentrust') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u4E0D\u5141\u8BB8'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u5141\u8BB8'
												)
											))
										)
									),
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5141\u8BB8\u8DF3\u8F6C' },
											getFieldDecorator('isjump', {
												rules: [{ required: true, message: '允许跳转' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'isjump') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u4E0D\u5141\u8BB8'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u5141\u8BB8'
												)
											))
										)
									)
								)
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u53C2\u4E0E\u4EBA', key: '3' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u89C4\u5219' },
											getFieldDecorator('userrule', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'userrule') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u8282\u70B9\u914D\u7F6E'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u4E1A\u52A1\u6570\u636E\u83B7\u53D6'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "2" },
													'\u4E1A\u52A1\u6570\u636E\u4F18\u5148\u8282\u70B9\u914D\u7F6E'
												)
											))
										)
									)
								),
								this.state.nodedata.userrule != "0" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u4F01\u4E1Akey' },
											getFieldDecorator('orgkey', {
												rules: [{ required: false, message: '企业key' }]
											})(_react2.default.createElement(_antd.Input, {
												style: { width: '100%' },
												placeholder: '\u4F01\u4E1Akey',
												onChange: this.textOnChange.bind(this, 'orgkey')
											}))
										)
									),
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u4F01\u4E1A\u7C7B\u578B' },
											getFieldDecorator('orgtype', {
												rules: [{ required: false, message: '企业类型' }]
											})(_react2.default.createElement(
												_antd.Select,
												{
													style: { width: '100%' },
													placeholder: '\u4F01\u4E1A\u7C7B\u578B',
													onChange: this.selectOnChange2.bind(this, 'orgtype')
												},
												_react2.default.createElement(
													Option,
													{ value: '10' },
													'\u533B\u4FDD\u5C40'
												),
												_react2.default.createElement(
													Option,
													{ value: '20' },
													'\u533B\u7597\u673A\u6784'
												),
												_react2.default.createElement(
													Option,
													{ value: '30' },
													'\u533B\u836F\u516C\u53F8'
												)
											))
										)
									),
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u89D2\u8272' },
											getFieldDecorator('rolekey', {
												rules: [{ required: false, message: '角色' }]
											})(_react2.default.createElement(
												_antd.Select,
												{
													placeholder: '\u89D2\u8272',
													mode: 'multiple',
													allowClear: true,
													style: { width: '100%' },
													onChange: this.checkboxGroupOnChange.bind(this, 'rolekey')
												},
												this.state.roleOption
											))
										)
									)
								) : "",
								this.state.nodedata.userrule != "1" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Button,
											{ size: 'small', onClick: this.handleAdd.bind(this, "role"), type: 'primary', style: { marginBottom: 10 } },
											'\u6DFB\u52A0\u53C2\u4E0E\u89D2\u8272'
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'roleList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: roleList,
											columns: roleListColumns
										})
									)
								) : "",
								this.state.nodedata.userrule != "1" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Button,
											{ size: 'small', onClick: this.handleAdd.bind(this, "user"), type: 'primary', style: { marginBottom: 10 } },
											'\u6DFB\u52A0\u53C2\u4E0E\u4EBA'
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'userList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: userList,
											columns: userListColumns
										})
									)
								) : ""
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u63D0\u9192\u7B56\u7565', key: '4' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u63D0\u9192\u65B9\u5F0F' },
											getFieldDecorator('remindMode', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												CheckboxGroup,
												{ onChange: this.checkboxGroupOnChange.bind(this, 'remindMode') },
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "01" },
													'\u77ED\u4FE1'
												),
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "02" },
													'\u90AE\u4EF6'
												),
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "03" },
													'\u7535\u8BDD'
												),
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "04" },
													'\u5FAE\u4FE1'
												),
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "99" },
													'\u5176\u4ED6'
												)
											))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u63D0\u9192\u65F6\u95F4' },
											getFieldDecorator('remindTime', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												_antd.Select,
												{ placeholder: '\u8BF7\u9009\u62E9\u63D0\u9192\u65F6\u95F4',
													onChange: this.selectOnChange.bind(this, 'remindTime')
												},
												_react2.default.createElement(
													Option,
													{ value: '01' },
													'\u7ACB\u5373\u63D0\u9192'
												),
												_react2.default.createElement(
													Option,
													{ value: '02' },
													'10\u5206\u949F\u540E'
												),
												_react2.default.createElement(
													Option,
													{ value: '03' },
													'30\u5206\u949F\u540E'
												)
											))
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u63D0\u9192\u5468\u671F' },
											getFieldDecorator('remindCycle', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												_antd.Select,
												{ placeholder: '\u8BF7\u9009\u62E9\u63D0\u9192\u5468\u671F',
													onChange: this.selectOnChange.bind(this, 'remindCycle')
												},
												_react2.default.createElement(
													Option,
													{ value: '01' },
													'\u4E0D\u91CD\u590D'
												),
												_react2.default.createElement(
													Option,
													{ value: '02' },
													'\u6BCF10\u5206\u949F'
												),
												_react2.default.createElement(
													Option,
													{ value: '03' },
													'\u6BCF30\u5206\u949F'
												),
												_react2.default.createElement(
													Option,
													{ value: '04' },
													'\u6BCF60\u5206\u949F'
												)
											))
										)
									)
								)
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u8D85\u65F6\u7B56\u7565', key: '5' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Card,
										{ title: '\u63A5\u6536\u8D85\u65F6' },
										_react2.default.createElement(
											_antd.Row,
											{ gutter: 16 },
											_react2.default.createElement(
												_antd.Col,
												{ span: 12 },
												_react2.default.createElement(
													_antd.Form.Item,
													{ label: '\u63A5\u6536\u8D85\u65F6\u65F6\u9650' },
													getFieldDecorator('receiveTimeout ', {
														initialValue: this.state.nodedata.receiveTimeout,
														rules: [{ required: false, message: '请输入超时时限' }]
													})(_react2.default.createElement(_antd.InputNumber, {
														min: 0,
														onChange: this.numberOnChange.bind(this, "receiveTimeout")
													})),
													_react2.default.createElement(
														'span',
														null,
														' \u5206\u949F'
													)
												)
											),
											_react2.default.createElement(
												_antd.Col,
												{ span: 12 },
												_react2.default.createElement(
													_antd.Form.Item,
													{ label: '\u8D85\u65F6\u5904\u7406\u89C4\u5219' },
													getFieldDecorator('receiveTimeoutHandling', {
														rules: [{ required: false, message: '' }]
													})(_react2.default.createElement(
														_antd.Select,
														{ placeholder: '\u8BF7\u9009\u62E9\u8D85\u65F6\u5904\u7406\u89C4\u5219',
															onChange: this.selectOnChange.bind(this, 'receiveTimeoutHandling')
														},
														_react2.default.createElement(
															Option,
															{ value: '01' },
															'\u4E0D\u5904\u7406'
														),
														_react2.default.createElement(
															Option,
															{ value: '02' },
															'\u5411\u521B\u5EFA\u4EBA\u53D1\u6D88\u606F'
														),
														_react2.default.createElement(
															Option,
															{ value: '03' },
															'\u8FD4\u56DE\u7ED9\u521B\u5EFA\u4EBA'
														)
													))
												)
											)
										)
									)
								),
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Card,
										{ title: '\u5B8C\u6210\u8D85\u65F6' },
										_react2.default.createElement(
											_antd.Row,
											{ gutter: 16 },
											_react2.default.createElement(
												_antd.Col,
												{ span: 12 },
												_react2.default.createElement(
													_antd.Form.Item,
													{ label: '\u5B8C\u6210\u8D85\u65F6\u65F6\u9650' },
													getFieldDecorator('overTimeout ', {
														initialValue: this.state.nodedata.overTimeout,
														rules: [{ required: false, message: '请输入超时时限' }]
													})(_react2.default.createElement(_antd.InputNumber, {
														min: 0,
														onChange: this.numberOnChange.bind(this, "overTimeout")
													})),
													_react2.default.createElement(
														'span',
														null,
														' \u5206\u949F'
													)
												)
											),
											_react2.default.createElement(
												_antd.Col,
												{ span: 12 },
												_react2.default.createElement(
													_antd.Form.Item,
													{ label: '\u8D85\u65F6\u5904\u7406\u89C4\u5219' },
													getFieldDecorator('overTimeoutHandling', {
														rules: [{ required: false, message: '' }]
													})(_react2.default.createElement(
														_antd.Select,
														{ placeholder: '\u8BF7\u9009\u62E9\u8D85\u65F6\u5904\u7406\u89C4\u5219',
															onChange: this.selectOnChange.bind(this, 'overTimeoutHandling')
														},
														_react2.default.createElement(
															Option,
															{ value: '01' },
															'\u4E0D\u5904\u7406'
														),
														_react2.default.createElement(
															Option,
															{ value: '02' },
															'\u81EA\u52A8\u5411\u4E0B\u8FD0\u884C'
														),
														_react2.default.createElement(
															Option,
															{ value: '03' },
															'\u5411\u521B\u5EFA\u4EBA\u53D1\u6D88\u606F'
														),
														_react2.default.createElement(
															Option,
															{ value: '04' },
															'\u8FD4\u56DE\u7ED9\u521B\u5EFA\u4EBA'
														),
														_react2.default.createElement(
															Option,
															{ value: '05' },
															'\u5411\u63A5\u6536\u4EBA\u5458\u53D1\u6D88\u606F'
														),
														_react2.default.createElement(
															Option,
															{ value: '06' },
															'\u5411\u6307\u5B9A\u7684\u4EBA\u5458\u53D1\u6D88\u606F'
														)
													))
												)
											)
										),
										this.state.nodedata.overTimeoutHandling == "06" ? _react2.default.createElement(
											_antd.Row,
											{ gutter: 16 },
											_react2.default.createElement(
												_antd.Col,
												{ span: 24 },
												_react2.default.createElement(
													_antd.Button,
													{ size: 'small', onClick: this.handleAdd.bind(this, "overTimeout"), type: 'primary', style: { marginBottom: 10 } },
													'\u6DFB\u52A0\u63D0\u9192\u4EBA\u5458'
												),
												_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
													rowClassName: function rowClassName() {
														return 'userList-row';
													} // 表格行的类名
													, bordered: true // 是否展示外边框和列边框
													, dataSource: overTimeoutUsers,
													columns: timeoutUserListColumns
												})
											)
										) : ""
									)
								)
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u5E72\u9884\u7B56\u7565', key: '6' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u4EBA\u5DE5\u5E72\u9884' },
											getFieldDecorator('ishuman', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'ishuman') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u4E0D\u5141\u8BB8'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u5141\u8BB8'
												)
											))
										)
									)
								),
								this.state.nodedata.ishuman == "1" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5904\u7406\u89C4\u5219' },
											getFieldDecorator('handling', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												CheckboxGroup,
												{ onChange: this.checkboxGroupOnChange.bind(this, 'handling') },
												_react2.default.createElement(
													_antd.Row,
													null,
													_react2.default.createElement(
														_antd.Col,
														{ span: 6 },
														_react2.default.createElement(
															_antd.Checkbox,
															{ value: "01" },
															'\u5B8C\u6210\u8282\u70B9'
														)
													),
													_react2.default.createElement(
														_antd.Col,
														{ span: 6 },
														_react2.default.createElement(
															_antd.Checkbox,
															{ value: "02" },
															'\u56DE\u9000\u5904\u7406'
														)
													),
													_react2.default.createElement(
														_antd.Col,
														{ span: 6 },
														_react2.default.createElement(
															_antd.Checkbox,
															{ value: "03" },
															'\u91CD\u65B0\u6267\u884C'
														)
													),
													_react2.default.createElement(
														_antd.Col,
														{ span: 6 },
														_react2.default.createElement(
															_antd.Checkbox,
															{ value: "04" },
															'\u7763\u4FC3\u6267\u884C'
														)
													),
													_react2.default.createElement(
														_antd.Col,
														{ span: 6 },
														_react2.default.createElement(
															_antd.Checkbox,
															{ value: "05" },
															'\u4EFB\u52A1\u91CD\u65B0\u5206\u914D'
														)
													),
													_react2.default.createElement(
														_antd.Col,
														{ span: 6 },
														_react2.default.createElement(
															_antd.Checkbox,
															{ value: "06" },
															'\u521B\u5EFA\u4EFB\u52A1'
														)
													),
													_react2.default.createElement(
														_antd.Col,
														{ span: 6 },
														_react2.default.createElement(
															_antd.Checkbox,
															{ value: "07" },
															'\u53D6\u6D88\u4EFB\u52A1'
														)
													)
												)
											))
										)
									)
								) : "",
								this.state.nodedata.ishuman == "1" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Button,
											{ size: 'small', onClick: this.handleAdd.bind(this, "human"), type: 'primary', style: { marginBottom: 10 } },
											'\u6DFB\u52A0\u64CD\u4F5C\u4EBA\u5458'
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'userList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: human,
											columns: interventionUserListColumns
										})
									)
								) : ""
							)
						)
					),
					this.state.modalContent
				);
			}
		}]);
	
		return TaskNodeFrom;
	}(_react.Component);
	
	var TaskNode = _antd.Form.create()(TaskNodeFrom);
	
	exports.default = TaskNode;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _CommonFunc = __webpack_require__(109);
	
	var _UserModal = __webpack_require__(137);
	
	var _RoleModal = __webpack_require__(372);
	
	var _PubInfo = __webpack_require__(162);
	
	var _PubInfo2 = _interopRequireDefault(_PubInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Panel = _antd.Collapse.Panel;
	var Option = _antd.Select.Option;
	var CheckboxGroup = _antd.Checkbox.Group;
	var RadioGroup = _antd.Radio.Group;
	
	var WorkflowNodeFrom = function (_Component) {
		_inherits(WorkflowNodeFrom, _Component);
	
		function WorkflowNodeFrom(props) {
			_classCallCheck(this, WorkflowNodeFrom);
	
			var _this = _possibleConstructorReturn(this, (WorkflowNodeFrom.__proto__ || Object.getPrototypeOf(WorkflowNodeFrom)).call(this, props));
	
			_this.reload = function () {
				_this.setState({ loading: false });
			};
	
			_this.selectOnChange = function (attname, value) {
				//change传入对象为value
				tool.sgiLogger.log("事件：selectOnChange");
				_this.refresh(attname, value);
			};
	
			_this.checkboxGroupOnChange = function (attname, checkedValue) {
				tool.sgiLogger.log("事件：checkboxGroupOnChange");
				_this.refresh(attname, checkedValue);
			};
	
			_this.handleAdd = function (modalType) {
				tool.sgiLogger.log("handleAdd表格添加方法");
				if (!modalType || modalType == '') {
					_this.state.modalContent = null;;
				}
				if (modalType == 'human') {
					_this.state.modalContent = _react2.default.createElement(_UserModal.UserModal, { key: (0, _CommonFunc.uuid)(8), modalShow: true, title: '\u9009\u62E9\u64CD\u4F5C\u4EBA\u5458',
						approvalUserList: _this.state.nodedata.human, parent: _this });
				}
				_this.setState({
					loading: false
				});
			};
	
			_this.handleDelete = function (delData, dataSource) {
				if (dataSource && delData) {
					for (var i = 0; i < dataSource.length; i++) {
						if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
							dataSource.splice(i, 1);
						}
					}
				}
				_this.setState({ loading: false });
			};
	
			_this.getTBData = function (tData) {
				if (!tData) {
					tData = [];
					return tData;
				}
				tData.forEach(function (element) {
					if (!element._key) element._key = (0, _CommonFunc.uuid)(8);
				});
				return tData;
			};
	
			_this.state = {
				node: props.node,
				show: props.show != null && props.show == true ? props.show : 'none',
				nodedata: props.nodedata,
	
				loading: false
			};
			return _this;
		}
	
		// 重新加载页面方法
	
	
		_createClass(WorkflowNodeFrom, [{
			key: 'textOnChange',
	
			// 文本修改事件
			value: function textOnChange(attname, e, e2) {
				tool.sgiLogger.log("事件：textOnChange");
				var value = e.target.value;
				this.refresh(attname, value);
			}
			// 下拉窗修改事件
	
			// 复选框组修改事件，checkedValue为数组["01","02"]
	
		}, {
			key: 'radioGroupOnChange',
	
			// 单选框组修改事件
			value: function radioGroupOnChange(attname, e) {
				tool.sgiLogger.log("事件：radioGroupOnChange");
				var value = e.target.value;
				this.refresh(attname, value);
			}
			// 数字组件修改事件
	
		}, {
			key: 'numberOnChange',
			value: function numberOnChange(attname, e) {
				var value = e;
				this.refresh(attname, value);
			}
			// 属性更新
	
		}, {
			key: 'refresh',
			value: function refresh(attname, value) {
				if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id + " " + value);
				this.state.nodedata[attname] = value;
			}
	
			// 表格添加方法
	
			// 表格删除方法
	
			// 创建表格绑定store（生成数据key）
	
		}, {
			key: 'componentDidMount',
	
	
			// 刷新form
			value: function componentDidMount() {
				tool.sgiLogger.log('事件：WorkflowNode加载后');
				this.props.form.setFieldsValue({
					wfopk: this.state.nodedata.wfopk,
					calltype: this.state.nodedata.calltype,
	
					ishuman: this.state.nodedata.ishuman,
					receiveTimeoutHandling: this.state.nodedata.receiveTimeoutHandling,
					human: this.state.nodedata.human
	
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
				var human = this.getTBData(this.state.nodedata.human);
				var interventionUserListColumns = [{
					title: '用户名称', // 列头显示名称
					dataIndex: 'empName' // 列数据在数据项中对应的 key
				}, {
					title: '操作',
					key: 'action',
					render: function render(text, record) {
						return _this2.state.nodedata.human.length >= 1 ? _react2.default.createElement(
							_antd.Popconfirm,
							{ title: '\u786E\u8BA4\u5220\u9664?', onConfirm: function onConfirm() {
									return _this2.handleDelete(record, _this2.state.nodedata.human);
								} },
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;' },
								'\u5220\u9664'
							)
						) : null;
					}
				}];
	
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_antd.Form,
						{ layout: 'vertical' },
						_react2.default.createElement(
							_antd.Collapse,
							{ defaultActiveKey: ['1'] },
							_react2.default.createElement(
								Panel,
								{ header: '\u901A\u7528\u8282\u70B9\u4FE1\u606F', key: '1' },
								_react2.default.createElement(_PubInfo2.default, { parent: this, node: this.state.node, nodedata: this.state.nodedata })
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u5B50\u6D41\u7A0B\u8282\u70B9\u4FE1\u606F', key: '2' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5B50\u5DE5\u4F5C\u6D41\u7F16\u53F7' },
											getFieldDecorator('wfopk', {
												rules: [{ required: true, message: '请输入子工作流编号' }]
											})(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5B50\u5DE5\u4F5C\u6D41\u7F16\u53F7',
												onChange: this.textOnChange.bind(this, 'wfopk')
											}))
										)
									),
									_react2.default.createElement(
										_antd.Col,
										{ span: 12 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u670D\u52A1\u8C03\u7528\u65B9\u5F0F' },
											getFieldDecorator('calltype', {
												rules: [{ required: false, message: '服务调用方式' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'calltype') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u7B49\u5F85\u5B50\u6D41\u7A0B\u7ED3\u679C'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u4E0D\u7B49\u5F85\u7ED3\u679C'
												)
											))
										)
									)
								)
							),
							_react2.default.createElement(
								Panel,
								{ header: '\u5E72\u9884\u7B56\u7565', key: '3' },
								_react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u4EBA\u5DE5\u5E72\u9884' },
											getFieldDecorator('ishuman', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												RadioGroup,
												{ onChange: this.radioGroupOnChange.bind(this, 'ishuman') },
												_react2.default.createElement(
													_antd.Radio,
													{ value: "0" },
													'\u4E0D\u5141\u8BB8'
												),
												_react2.default.createElement(
													_antd.Radio,
													{ value: "1" },
													'\u5141\u8BB8'
												)
											))
										)
									)
								),
								this.state.nodedata.ishuman == "1" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Form.Item,
											{ label: '\u5904\u7406\u89C4\u5219' },
											getFieldDecorator('handling', {
												rules: [{ required: false, message: '' }]
											})(_react2.default.createElement(
												CheckboxGroup,
												{ onChange: this.checkboxGroupOnChange.bind(this, 'handling') },
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "01" },
													'\u5B8C\u6210\u8282\u70B9'
												),
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "02" },
													'\u56DE\u9000\u5904\u7406'
												),
												_react2.default.createElement(
													_antd.Checkbox,
													{ value: "03" },
													'\u91CD\u65B0\u6267\u884C'
												)
											))
										)
									)
								) : "",
								this.state.nodedata.ishuman == "1" ? _react2.default.createElement(
									_antd.Row,
									{ gutter: 16 },
									_react2.default.createElement(
										_antd.Col,
										{ span: 24 },
										_react2.default.createElement(
											_antd.Button,
											{ size: 'small', onClick: this.handleAdd.bind(this, "human"), type: 'primary', style: { marginBottom: 10 } },
											'\u6DFB\u52A0\u64CD\u4F5C\u4EBA\u5458'
										),
										_react2.default.createElement(_antd.Table, { size: 'small', rowKey: "_key",
											rowClassName: function rowClassName() {
												return 'userList-row';
											} // 表格行的类名
											, bordered: true // 是否展示外边框和列边框
											, dataSource: human,
											columns: interventionUserListColumns
										})
									)
								) : ""
							)
						)
					),
					this.state.modalContent
				);
			}
		}]);
	
		return WorkflowNodeFrom;
	}(_react.Component);
	
	var WorkflowNode = _antd.Form.create()(WorkflowNodeFrom);
	exports.default = WorkflowNode;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2011);
	
	var _jquery = __webpack_require__(682);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _antd = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import {render} from 'react-dom'
	// var jtopo = $('<script src="jtopo-0.4.8-min.js" type="text/javascript"></script>');
	// $(document.body).before(jtopo);
	var JTopo = window.JTopo;
	
	/****
	 * FlowEdit组件使用说明
	 * 属性：
	 * contextmenu  右键弹出菜单
	 * 
	 * 方法：
	 * clickfunction：节点点击事件
	 * blankClickFunc：空白处点击事件
	 * rclickFunc：节点右键点击事件
	 * rmenuClick:右键弹出菜单点击事件
	 * model：自定义节点模型
	 * data:节点数据---已有数据初始化展示使用
	 * debug:显示调试按钮
	 * readOnly：组件是否为编辑状态
	 * 
	 * 
	 * getData:获取组件json数据
	 */
	
	var FlowEdit = function (_Component) {
	    _inherits(FlowEdit, _Component);
	
	    function FlowEdit(props) {
	        _classCallCheck(this, FlowEdit);
	
	        var _this = _possibleConstructorReturn(this, (FlowEdit.__proto__ || Object.getPrototypeOf(FlowEdit)).call(this, props));
	
	        _this.state = {
	            editpanelWidth: 24,
	            nodepanelWidth: 0,
	            root: undefined,
	            over: undefined,
	            w: _this.props.width != null && typeof _this.props.width != "undefined" ? _this.props.width : '100%',
	            h: _this.props.height != null && typeof _this.props.height != "undefined" ? _this.props.height : '790px',
	            canvas: undefined,
	            code: _this.props.code != null && typeof _this.props.code != "undefined" ? _this.props.code : "workflowEditPanel",
	            canvasid: _this.props.code != null && typeof _this.props.code != "undefined" ? "canvas" + _this.props.code : "canvasworkflowEditPanel",
	            editid: _this.props.code != null && typeof _this.props.code != "undefined" ? "editid" + _this.props.code : "canvaseditidPanel",
	            currnode: null,
	            currdata: null,
	            maxid: 1,
	            contextmenu: _this.props.contextmenu,
	            clickfunction: _this.props.clickfunction,
	            blankClickFunc: _this.props.blankClickFunc,
	            rclickFunc: _this.props.rclickFunc,
	            rmenuClick: _this.props.rmenuClick,
	            model: _this.props.model,
	            data: _this.props.data,
	            readOnly: _this.props.readOnly != null && typeof _this.props.readOnly != "undefined" ? _this.props.readOnly : true,
	            debug: _this.props.debug != null && typeof _this.props.debug != "undefined" ? _this.props.debug : false,
	            defcontextmenu: [{
	                text: '添加任务',
	                pk: "1",
	                img: './images/task_done.png',
	                func: function func(fe) {
	                    fe.rmenuClick(fe, "06");
	                }
	            }, {
	                text: '添加跳转',
	                pk: "2",
	                img: './images/jump_done.png',
	                func: function func(fe) {
	                    fe.rmenuClick(fe, "02");
	                }
	            }, {
	                text: '添加终点',
	                pk: "3",
	                img: './images/over.png',
	                func: function func(wf) {
	                    wf.rmenuClick(wf, "99");
	                }
	            }, {
	                text: '删除节点',
	                pk: "4",
	                img: './images/delete.png',
	                func: function func(wf) {
	                    var node = wf.state.currnode;
	                    if (!node) {
	                        alert("no selected node");
	                        return;
	                    }
	                    node.remove();
	                }
	            }]
	        };
	        return _this;
	    }
	
	    _createClass(FlowEdit, [{
	        key: 'sceneClickFcuntion',
	        value: function sceneClickFcuntion() {
	            this.state.blankClickFunc();
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            var baseDom = document.getElementById(this.state.canvasid);
	            var editpanel = document.getElementById(this.state.editid);
	            baseDom.width = editpanel.clientWidth;
	            baseDom.height = editpanel.clientHeight;
	            this.canvas = this.scene(baseDom);
	            if (this.state.data) {
	                if (!this.maxid) this.maxid = 0;
	                this.drawRoot(this.state.data, this.state.readOnly);
	                this.maxid++;
	            } else {
	                if (!this.maxid) this.maxid = 1;
	                var start = this.newData(null, '01');
	                this.drawRoot(start);
	            }
	        }
	    }, {
	        key: 'scene',
	        value: function scene(domNode) {
	            var me = this;
	            var stage = new JTopo.Stage(domNode); // 创建一个舞台对象
	            var scene = new JTopo.Scene(stage); // 创建一个场景对象
	            stage.wheelZoom = 0.9;
	            scene.mode = "normal";
	            if (me.readOnly) stage.mode = "drag";
	            stage.wheelZoom = null;
	            stage.click(function (event) {
	                // 关闭弹出菜单（div）
	                me._hideMenu("ctxmenu");
	                if (!me.nodeclick) {
	                    //标识这次执行的是空白处的点击事件
	                    me.sceneClickFcuntion();
	                }
	                me.nodeclick = false;
	            });
	            return scene;
	        }
	    }, {
	        key: 'drawRoot',
	        value: function drawRoot(data, type) {
	            var me = this;
	            if (!this.canvas) {
	                me.init();
	            }
	            // this.root:data});
	            var jumps = [];
	            var nodes = [];
	            var draw = function draw(data) {
	                if (!data) return;
	                var node = me.getnode(data, data.type, type);
	                if (data.type === '01') {
	                    me.setState({ root: node, currnode: node });
	                }
	                if (!node) {
	                    tool.sgiLogger.log("create node failed," + data);
	                    return undefined;
	                }
	                nodes.push(node);
	                me.canvas.add(node);
	                var children = data.childNode;
	                if (!children) {
	                    if (data.type === '02') {
	                        jumps.push(node);
	                    }
	                    if (!me.maxid) me.maxid = 0;
	                    if (node.data.id > me.maxid) me.maxid = node.data.id;
	                    tool.sgiLogger.log(data.name + " no children");
	                    return node;
	                }
	                var downnodes = [];
	                for (var i = 0; i < children.length; i++) {
	                    var n = draw(children[i]);
	                    if (n) {
	                        if (!n.parentsNode) n.parentsNode = [];
	                        n.parentsNode.push(node);
	                        downnodes.push(n);
	                    }
	                }
	                node.to = downnodes;
	                for (var j = 0; j < downnodes.length; j++) {
	                    var link = me.line(node, downnodes[j]);
	                    if (link) {
	                        me.canvas.add(link);
	                    }
	                }
	                if (!me.maxid) me.maxid = 0;
	                if (node.data.id > me.maxid) me.maxid = node.data.id;
	                return node;
	            };
	            var node = draw(data);
	            for (var n = 0; n < jumps.length; n++) {
	                var jpnode = jumps[n];
	                for (var m = 0; m < nodes.length; m++) {
	                    tool.sgiLogger.log(nodes[m].id);
	                    if (jpnode.data.ncode === nodes[m].data.id) {
	                        var link = me.dottedline(jpnode, nodes[m]);
	                        jpnode.dotline = link;
	                        me.canvas.add(link);
	                        break;
	                    }
	                }
	            }
	            return node;
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            if (this.canvas) {
	                this.canvas.clear();
	            }
	        }
	    }, {
	        key: 'rmenuClick',
	        value: function rmenuClick(wf, type) {
	            var node = wf.state.currnode;
	            if (!node) {
	                alert("no selected node");
	                return;
	            }
	
	            if (type === "99" && typeof this.state.over != "undefined") {
	                alert("已有结束节点，请使用跳转节点结束流程");
	                return;
	            }
	
	            var data = wf.newData(node, type);
	            var nexnode = node.createNextNode(data);
	
	            if (nexnode.parentsNode == null || typeof nexnode.parentsNode === "undefined") nexnode.parentsNode = [];
	            nexnode.parentsNode.push(node);
	            if (!node.data.childNode) {
	                node.data.childNode = [];
	            }
	            node.data.childNode.push(data);
	            if (type === "02") {
	                var chart = node.getChart();
	                chart.jumpLine(nexnode);
	            }
	            this.state.rmenuClick(wf, type);
	        }
	        /***
	         * 节点点击事件
	         */
	
	    }, {
	        key: 'rclickFunc',
	        value: function rclickFunc(node) {
	            this.setState({ currnode: node });
	            this.setState({ currdata: node.data });
	            this.props.rclickFunc(node);
	        }
	    }, {
	        key: 'clickFunc',
	        value: function clickFunc(node, wf) {
	            // var me=this;
	            // tool.sgiLogger.log(node);
	            // var oldnode = this.state.currnode;
	            wf.setState({ currnode: node });
	            wf.setState({ currdata: node.data });
	            //显示编辑界面
	            wf.props.clickfunction(node, wf);
	        }
	    }, {
	        key: 'blankClickFunc',
	        value: function blankClickFunc() {
	            this.setState({ currnode: null });
	        }
	    }, {
	        key: 'create',
	        value: function create(currentNode, data) {
	            if (!data) {
	                return;
	            }
	            var me = this;
	            if (!this.canvas) {
	                me.init();
	            }
	            var node = me.getnode(data, data.type);
	            if (data.type === '01') {
	                // me.root = node
	                // me.currnode = node
	                me.setState({ root: node, currnode: node });
	            }
	            if (!node) {
	                tool.sgiLogger.log("unsupport node type : " + data.type);
	                return;
	            }
	            if (currentNode && node) {
	                me.canvas.add(node);
	                var link = me.line(currentNode, node);
	                me.canvas.add(link);
	            }
	            return node;
	        }
	    }, {
	        key: 'remove',
	        value: function remove(node) {
	            var me = this;
	
	            if (node.data && node.data.type && node.data.type === "02") {
	                var dotline = node.dotline;
	                if (me.canvas && dotline) {
	                    me.canvas.remove(dotline);
	                }
	                if (dotline.nodeA && dotline.nodeA.type === "temp") {
	                    me.canvas.remove(dotline.nodeA);
	                }
	
	                if (dotline.nodeZ && dotline.nodeZ.type === "temp") {
	                    me.canvas.remove(dotline.nodeZ);
	                }
	            }
	            if (me.canvas) {
	                if (node.fromlines && node.fromlines.length > 0) {
	                    node.fromlines.forEach(function (line) {
	                        if (line.nodeA && line.nodeA.type === "temp") {
	                            me.canvas.remove(line.nodeA);
	                            me.canvas.remove(line);
	                        }
	
	                        if (line.nodeZ && line.nodeZ.type == "temp") {
	                            me.canvas.remove(line.nodeZ);
	                            me.canvas.remove(line);
	                        }
	                    });
	                }
	
	                if (node.tolines && node.tolines.length > 0) {
	                    node.tolines.forEach(function (line) {
	                        if (line.nodeA && line.nodeA.type === "temp") {
	                            me.canvas.remove(line.nodeA);
	                            me.canvas.remove(line);
	                        }
	
	                        if (line.nodeZ && line.nodeZ.type === "temp") {
	                            me.canvas.remove(line.nodeZ);
	                            me.canvas.remove(line);
	                        }
	                    });
	                }
	                me.canvas.remove(node);
	            }
	        }
	    }, {
	        key: 'line',
	        value: function line(fromNode, toNode) {
	            var me = this;
	            var line = new JTopo.Link(fromNode, toNode);
	
	            line.lineWidth = 3; // 线宽
	            line.arrowsRadius = 7; //箭头大小
	            line.textOffsetY = 3; // 文本偏移量(向下3个像素)
	            line.strokeColor = '240,131,31';
	            //line.bundleOffset = 60; // 折线拐角处的长度
	            //line.bundleGap = 20; // 线条之间的间隔
	
	            fromNode.setToline(line);
	            toNode.setFromline(line);
	
	            if (!me.state.readOnly) {
	                line.addEventListener('dbclick', function (e) {
	                    // var anode = this.nodeA;
	                    // var tempstart = me.lineStartNode(anode.x, anode.y, this);
	                    var anode = this.nodeA;
	                    var znode = this.nodeZ;
	                    if (znode && line.nodeZ.type != "temp" && anode && line.nodeA.type != "temp") {
	                        var tempstart = me.lineEndNode(znode.x - 35, znode.y, this);
	                        me.canvas.add(tempstart);
	                        for (var i = 0; i < anode.tolines.length; i++) {
	                            if (anode.tolines[i].nodeA == anode && anode.tolines[i].nodeZ == tempstart) {
	                                // anode.tolines[i].nodeZ = tempstart;
	                                if (anode.data.childNode) {
	                                    anode.data.childNode.splice(i, 1);
	                                };
	                            }
	                        }
	                        for (var i = 0; i < znode.fromlines.length; i++) {
	
	                            if (znode.fromlines[i].nodeA == anode && znode.fromlines[i].nodeZ == tempstart) {
	                                // anode.tolines[i].nodeZ = tempstart;
	                                znode.fromlines.splice(i, 1);
	                            }
	                        }
	                    }
	                });
	            }
	
	            return line;
	        }
	    }, {
	        key: 'dottedline',
	        value: function dottedline(fromNode, toNode) {
	            var link = this.line(fromNode, toNode);
	            link.dashedPattern = 5; // 虚线
	            return link;
	        }
	    }, {
	        key: 'lineStartNode',
	        value: function lineStartNode(x, y, line) {
	            var me = this;
	            var lsn = me._tempNode(x, y);
	
	            line.nodeA = lsn;
	            lsn.toline = line;
	
	            return lsn;
	        }
	    }, {
	        key: 'lineEndNode',
	        value: function lineEndNode(x, y, line) {
	            var me = this;
	            var len = me._tempNode(x, y);
	
	            line.nodeZ = len;
	            len.fromline = line;
	
	            return len;
	        }
	    }, {
	        key: 'jumpLine',
	        value: function jumpLine(node) {
	            var me = this;
	            var temp = me._tempNode(node.x + 50, node.y);
	            temp.addEventListener('mousedrag', function (e) {
	                // me.dragnode = this;
	                me.setState({ dragnode: this });
	            });
	            var dotline = me.dottedline(node, temp);
	
	            dotline.nodeZ = temp;
	            temp.fromline = dotline;
	
	            this.canvas.add(temp);
	            this.canvas.add(dotline);
	
	            node.dotline = dotline;
	
	            return dotline;
	        }
	    }, {
	        key: '_addNodeListener',
	        value: function _addNodeListener(node) {
	            var me = this;
	            node.addEventListener('click', function (e) {
	                if (!me.nodedrag) {
	                    me.clickFunc(node, me);
	                    me.nodeclick = true; //标识这次执行的是node的点击事件
	                }
	                me.nodedrag = false;
	            });
	            node.addEventListener('dbclick', function (e) {
	                me.clickFunc(node, me);
	            });
	            node.addEventListener('mouseup', function (e) {
	                if (e.button === 2) {
	                    // 右键
	                    me.rclickFunc(node);
	                    me._showMenu(this, "ctxmenu");
	                }
	            });
	            node.addEventListener('mousedown', function (e) {
	                //tool.sgiLogger.log("mousedown:"+this);
	            });
	            node.addEventListener('mouseover', function (e) {
	
	                if (me.state.dragnode) {
	                    var current = this;
	                    var temp = me.state.dragnode;
	                    var line;
	                    if (temp.toline) {
	                        line = temp.toline;
	                        //var downNode = line.nodeZ;
	                        var tonode = line.nodeZ;
	                        if (tonode && tonode.type != "temp") {
	                            // var childnodes = current.data.cldSet;
	
	                            for (var i = 0; i < tonode.fromlines.length; i++) {
	                                if (tonode.fromlines[i].nodeA == current && tonode.fromlines[i].nodeZ == tonode) {
	                                    return;
	                                }
	                            }
	
	                            current.setToline(line);
	                            var childnodes = current.data.childNode;
	                            if (!childnodes) {
	                                childnodes = [];
	                                // current.data.cldSet = childnodes;
	                                current.data.childNode = childnodes;
	                            }
	                            childnodes.push(tonode.data);
	                        }
	                    } else {
	                        line = temp.fromline;
	                        var upNode = line.nodeA;
	                        if (current == upNode) {
	                            return;
	                        }
	                        for (var _i = 0; _i < upNode.tolines.length; _i++) {
	                            if (upNode.tolines[_i].nodeA == upNode && upNode.tolines[_i].nodeZ == current) {
	                                return;
	                            }
	                        }
	                        for (var _i2 = 0; _i2 < current.fromlines.length; _i2++) {
	                            if (current.fromlines[_i2].nodeA == upNode && current.fromlines[_i2].nodeZ == current) {
	                                return;
	                            }
	                        }
	                        current.setFromline(line);
	                        if (upNode && upNode.type != "temp" && upNode.data.type != "02") {
	                            var childnodes = upNode.data.childNode;
	                            if (childnodes) childnodes.push(current.data);
	                        }
	                        if (upNode && upNode.type != "temp" && upNode.data.type == "02") {
	
	                            upNode.data.gotoNodeId = current.data.id;
	                            upNode.data.ncode = current.data.id;
	                            upNode.click();
	                        }
	                    }
	                    me.remove(temp);
	                    me.setState({ dragnode: undefined });
	                }
	            });
	            node.addEventListener('mousedrag', function (e) {
	                if (this.data) {
	                    if (this.data.x !== this.x || this.data.y !== this.y) {
	                        me.setState({ nodedrag: true });
	                    }
	                    this.data.x = this.x;
	                    this.data.y = this.y;
	                }
	            });
	        }
	    }, {
	        key: '_setdataPubFiedls',
	        value: function _setdataPubFiedls(data, node) {
	            var me = this;
	            node.data = data;
	            node.createNextNode = function (data) {
	                return me.create(this, data);
	            };
	            node.remove = function () {
	                var delNode = this;
	                var downlines = delNode.tolines;
	                if (downlines) {
	                    for (var i = 0; i < downlines.length; i++) {
	                        var line = downlines[i];
	                        var tempstart = me.lineStartNode(delNode.x, delNode.y, line);
	                        me.canvas.add(tempstart);
	                    }
	                }
	                delNode.tolines = [];
	
	                if (typeof me.state.over != "undefined" && delNode.type === "99") {
	                    me.setState({ over: undefined });
	                }
	                me.remove(delNode);
	                var pnodes = delNode.parentsNode;
	                if (pnodes) {
	                    for (var j = 0; j < pnodes.length; j++) {
	                        if (pnodes[j].data.childNode) {
	                            for (var i = 0; i < pnodes[j].data.childNode.length; i++) {
	                                if (pnodes[j].data.childNode[i].id === delNode.data.id) {
	                                    pnodes[j].data.childNode.splice(i, 1);
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                    for (var j = 0; j < pnodes.length; j++) {
	                        var downlines = pnodes[j].tolines;
	                        if (downlines) {
	                            for (var i = 0; i < downlines.length; i++) {
	                                var line = downlines[i];
	                                if (line.nodeZ === delNode) {
	                                    pnodes[j].tolines.splice(i, 1);
	                                }
	                            }
	                        }
	                    }
	                }
	            };
	            node.setToline = function (line) {
	                if (!this.tolines) {
	                    this.tolines = [];
	                }
	                this.tolines.push(line);
	
	                line.nodeA = this;
	            };
	            node.setFromline = function (line) {
	                if (!this.fromlines) {
	                    this.fromlines = [];
	                }
	                this.fromlines.push(line);
	
	                line.nodeZ = this;
	            };
	            node.getChart = function () {
	                return me;
	            };
	
	            node.id = data.sc;
	        }
	    }, {
	        key: 'getnode',
	        value: function getnode(data, nodetype, type) {
	            var nodetypes = ['01', '02', '03', '04', '05', '06', '99'];
	            if (nodetypes.indexOf(nodetype) < 0) {
	                return null;
	            }
	            var name;
	            switch (nodetype) {
	                case "01":
	                    name = "开始";
	                    break;
	                case "02":
	                    name = "跳转节点";
	                    break;
	                case "99":
	                    name = "结束";
	                    break;
	
	                default:
	                    name = "新节点";
	                    break;
	            }
	            var node = new JTopo.Node(data.id + " " + name);
	            if (!node) {
	                return node;
	            }
	            node.textOffsetY = 8; // 文本偏移量(向下3个像素)
	            node.font = "12px Consolas";
	            node.fontColor = '0 ,0 ,0';
	            //node.textPosition = "Middle_Center";
	            node.setSize(38, 38);
	            if (nodetype) node.type = nodetype;
	            if (!data.name) data.name = name;
	            if (nodetype === "01") {
	                node.setImage(__webpack_require__(2051));
	            } else if (nodetype === "99") {
	                node.setText = function (str) {
	                    if (!str) {
	                        this.text = name;
	                    }
	                    this.text = str;
	                };
	                node.setImage(__webpack_require__(893));
	                if (type && data && data.status && data.status === "00") {
	                    node.setImage(__webpack_require__(2046));
	                } else if (data && data.status && data.status === "02") {
	                    node.setImage(__webpack_require__(893));
	                }
	                this.setState({ over: node });
	            } else {
	                node.setText = function (str) {
	                    if (!str) {
	                        this.text = name;
	                    }
	                    this.text = str;
	                };
	                if (data && data.name) node.setText(data.id + " " + data.name);
	                if (nodetype === "02") {
	                    node.fillColor = '255 ,255 ,0';
	                    node.setImage(__webpack_require__(2044));
	                    if (type && data && data.status && data.status === "00") {
	                        node.setImage(__webpack_require__(2045));
	                    } else if (data && data.status && data.status === "02") {
	                        node.fontColor = '30 144 255';
	                    }
	                }
	                if (nodetype === "03") {
	                    node.fillColor = '218 ,112 ,214';
	                    node.setImage(__webpack_require__(2049));
	                    if (type && data && data.status && data.status === "00") {
	                        node.setImage(__webpack_require__(2050));
	                    } else if (data && data.status && data.status === "02") {
	                        node.fontColor = '30 144 255';
	                    }
	                }
	                if (nodetype === "04") {
	                    node.fillColor = '250 ,235 ,215';
	                    node.setImage(__webpack_require__(2047));
	                    if (type && data && data.status && data.status === "00") {
	                        node.setImage(__webpack_require__(2048));
	                    } else if (data && data.status && data.status === "02") {
	                        node.fontColor = '30 144 255';
	                    }
	                }
	
	                if (nodetype === "05") {
	                    node.fillColor = '188 ,143 ,143';
	                    node.setImage(__webpack_require__(2054));
	                    if (type && data && data.status && data.status === "00") {
	                        node.setImage(__webpack_require__(2055));
	                    } else if (data && data.status && data.status === "02") {
	                        node.fontColor = '30 144 255';
	                    }
	                }
	                if (nodetype === "06") {
	                    node.fillColor = '127 ,255 ,212';
	                    node.setImage(__webpack_require__(2052));
	                    if (type && data && data.status && data.status === "00") {
	                        node.setImage(__webpack_require__(2053));
	                    } else if (data && data.status && data.status === "02") {
	                        node.fontColor = '30 ,144 ,255';
	                    }
	                }
	            }
	
	            node.setLocation(data.x, data.y);
	            this._setdataPubFiedls(data, node);
	            if (!type) {
	                this._addNodeListener(node);
	            } else {
	                //当前执行节点  加特殊标识
	                if (data && data.status) {
	                    node.percent = 0.8;
	                    node.beginDegree = 0;
	                    if (data.status === "01" || data.status === "99") {
	                        if (data.status === "01") node.color = 'rgba(0,255,0,';
	                        if (data.status === "99") node.color = 'rgba(255,0,0,';
	                        // if (data.status === "03") node.color='rgba(143,153,159,';
	                        // if (data.status === "04") node.color='rgba(245,255,0,' ;
	                        // if (data.status === "05") node.color='rgba(244,248,244,';
	                        // if (data.status === "02") node.color='rgba(30 ,144 ,255,' ;
	                        if (data.status != "01") {
	                            node.percent = 1;
	                        } else {
	                            node.percent = 0.1;
	                        }
	                        node.paint = function (g) {
	                            //
	                            g.save();
	                            g.beginPath();
	                            g.moveTo(0, 0);
	                            g.strokeStyle = this.color + this.alpha + ')';
	                            g.lineWidth = 6;
	                            g.arc(0, 0, (this.width + 3) / 2, this.beginDegree, this.beginDegree + 2 * Math.PI * this.percent);
	                            // g.fill();  
	                            g.stroke();
	                            g.closePath();
	                            g.beginPath();
	                            g.moveTo(0, 0);
	                            g.drawImage(this.image, -this.width / 2, -this.height / 2, 38, 38);
	                            // g.fillStyle = 'rgba(0,0,255,' + this.alpha + ')';
	                            // g.moveTo(0,0);
	                            // g.arc(0, 0, this.width/2-8, this.beginDegree, this.beginDegree + 2*Math.PI);                
	                            // g.fill();
	                            g.closePath();
	                            g.restore();
	                            this.paintText(g);
	                        };
	                        if (data.status === "01") JTopo.Animate.stepByStep(node, {
	                            percent: 1
	                        }, 5000, true).start();
	                    }
	                }
	            }
	            return node;
	        }
	    }, {
	        key: '_tempNode',
	        value: function _tempNode(x, y) {
	            var me = this;
	
	            var temp = new JTopo.CircleNode("连接点");
	            temp.type = "temp";
	            temp.fillColor = '255 ,255 ,0';
	            temp.setLocation(x, y);
	            temp.radius = 5;
	
	            temp.setFromline = function (line) {
	                if (!this.fromlines) {
	                    this.fromlines = [];
	                }
	                this.fromlines.push(line);
	
	                line.nodeZ = this;
	            };
	            temp.setToline = function (line) {
	                if (!this.tolines) {
	                    this.tolines = [];
	                }
	                this.tolines.push(line);
	
	                line.nodeA = this;
	            };
	
	            temp.addEventListener('mousedrag', function (e) {
	                me.setState({ dragnode: this });
	            });
	
	            temp.addEventListener('mouseout', function (e) {
	                //me.dragnode = undefined;
	            });
	
	            return temp;
	        }
	    }, {
	        key: '_createMenu',
	        value: function _createMenu(id, items, node, event) {
	            if (!items) {
	                return;
	            }
	            var e = event || window.event;
	            var me = this;
	            var child = document.getElementById(id);
	            if (child) child.parentNode.removeChild(child);
	
	            var wrapUl = document.createElement('ul');
	            wrapUl.setAttribute('id', id);
	            wrapUl.setAttribute('style', 'position:fixed;top:' + e.clientY + 'px;left:' + e.clientX + 'px;width:100px;border-radius:3px;border:1px solid rgb(120, 120, 120);padding:0;margin:0;box-shadow:2px 2px 10px 0px rgb(200,200,200);font-size: 13px;');
	            for (var i = 0; i < items.length; i++) {
	                // if (node.type==="01" &&(items[i].pk>="7")) continue; 
	                // if (node.type==="99" &&(items[i].pk<"7")) continue; 
	                // if (node.type==="02" &&(items[i].pk<"7")) continue; 
	                // if (typeof(this.over)!="undefined" &&(items[i].pk==="6")) continue; 
	                var item = document.createElement('li');
	                item.setAttribute('style', 'list-style-type:none;width:100px;background-color:rgb(240,240,240);');
	                var inneritem = document.createElement('a');
	                inneritem.onmouseover = function () {
	                    this.style.backgroundColor = "rgb(80,143,224)";
	                    this.style.color = "white";
	                };
	                inneritem.onmouseout = function () {
	                    this.style.backgroundColor = "rgb(240,240,240)";
	                    this.style.color = "";
	                };
	                inneritem.setAttribute('style', 'margin:0 auto;border-bottom:1px solid rgb(210, 210, 210);display:block;width:100px;padding:2px 0 2px 2px;fontSize:14px;font-weight:400;background-color:rgb(240,240,240);');
	                inneritem.innerHTML = "<img src='" + items[i].img + "' style='height:25px;width:25px'/>" + items[i].text;
	                inneritem.func = items[i].func;
	                inneritem.onclick = function () {
	                    this.func(me);
	                    me._hideMenu("ctxmenu");
	                };
	                item.appendChild(inneritem);
	                wrapUl.appendChild(item);
	            }
	            document.body.appendChild(wrapUl);
	        }
	    }, {
	        key: '_showMenu',
	        value: function _showMenu(node, id, event) {
	            var e = event || window.event;
	
	            var menu = this.state.defcontextmenu.concat(this.state.contextmenu);
	            // for(var i in this.state.model){
	            //     data[i] = this.state.model[i];
	            // }
	            this._createMenu(id, menu, node);
	        }
	    }, {
	        key: '_hideMenu',
	        value: function _hideMenu(id) {
	            if (document.getElementById(id)) {
	                document.getElementById(id).style.display = "none";
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return (
	                // <div style={{ height:'790px',width: '100%' }} >
	                _react2.default.createElement(
	                    'div',
	                    { ref: 'FlowEdit', style: { height: this.state.h, width: this.state.w } },
	                    _react2.default.createElement(
	                        _antd.Row,
	                        { style: { height: '90%', width: '100%' } },
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: this.state.editpanelWidth, style: { height: '100%' } },
	                            _react2.default.createElement(
	                                'div',
	                                { id: this.state.editid, style: { backgroundColor: '#6c757d', height: '100%' } },
	                                _react2.default.createElement(
	                                    'canvas',
	                                    { id: this.state.canvasid, style: { height: '100%', backgroundColor: '#6c757d' } },
	                                    ' '
	                                )
	                            )
	                        )
	                    ),
	                    this.state.debug ? _react2.default.createElement(
	                        _antd.Row,
	                        { style: { height: '10%', width: '100%' } },
	                        _react2.default.createElement(
	                            _antd.Button,
	                            { type: 'primary', onClick: this.getData.bind(this) },
	                            '\u67E5\u770B\u6D41\u7A0B\u914D\u7F6E'
	                        ),
	                        _react2.default.createElement(
	                            _antd.Button,
	                            null,
	                            '\u6D4B\u8BD5\u6D41\u7A0B'
	                        )
	                    ) : ""
	                )
	            );
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var me = this;
	            if (!me.state.canvas) {
	                me.init();
	            }
	        }
	    }, {
	        key: 'newData',
	        value: function newData(node, type) {
	            var x = 50,
	                y = 30;
	            if (node) {
	                x = node.x + 150;
	                if (node.data.childNode) y = node.y + node.data.childNode.length * 70;else y = node.y;
	            }
	            var data = {
	                id: this.maxid++,
	                name: null,
	                type: type,
	                status: "00",
	                ann: null,
	                x: x,
	                y: y
	            };
	            for (var i in this.state.model) {
	                data[i] = this.state.model[i];
	            }
	            return data;
	        }
	    }, {
	        key: 'cvtToJson',
	        value: function cvtToJson(root) {
	            if (!root) return;
	            var children = root.data.childNode;
	            if (!children) return;
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i].data;
	                if (child.type === '06') {
	                    var array = [];
	                    var us = child.users;
	                    if (us) {
	                        for (var j = 0; j < us.length; j++) {
	                            var u = us[j];
	                            array.push(u);
	                        }
	                        child.users = array;
	                    }
	                    var ps = child.posts;
	                    if (ps) {
	                        array = [];
	                        for (var j = 0; j < ps.length; j++) {
	                            var p = ps[j];
	                            array.push(p);
	                        }
	                        child.posts = array;
	                    }
	                } else {
	                    continue;
	                }
	                this.cvtToJson(child);
	            }
	        }
	    }, {
	        key: 'getJson',
	        value: function getJson(root) {
	            if (!root) root = this.state.root.data;
	            var json = {};
	            json = root;
	            var children = root.childNode;
	            if (!children) return json;
	            json.childNode = [];
	            for (var i = 0; i < children.length; i++) {
	                json.childNode.push(this.getJson(children[i]));
	            }
	            return json;
	        }
	    }, {
	        key: 'deleteEmptyProperty',
	        value: function deleteEmptyProperty(object) {
	            for (var i in object) {
	                var value = object[i];
	                if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	                    if (Array.isArray(value)) {
	                        if (value.length == 0) {
	                            delete object[i];
	                            continue;
	                        }
	                    }
	                    this.deleteEmptyProperty(value);
	                    if (this.isEmpty(value)) {
	                        delete object[i];
	                    }
	                } else {
	                    if (value === '' || value === null || value === undefined) {
	                        delete object[i];
	                    } else {}
	                }
	            }
	        }
	    }, {
	        key: 'isEmpty',
	        value: function isEmpty(object) {
	            for (var name in object) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'getData',
	        value: function getData() {
	            var json = this.getJson();
	            // this.deleteEmptyProperty(json);
	            _antd.Modal.info({
	                title: 'This is a notification message',
	                content: JSON.stringify(json),
	                onOk: function onOk() {}
	            });
	        }
	    }]);
	
	    return FlowEdit;
	}(_react.Component);
	
	exports.default = FlowEdit;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(18);
	
	var _StartNode = __webpack_require__(1344);
	
	var _StartNode2 = _interopRequireDefault(_StartNode);
	
	var _TaskNode = __webpack_require__(1345);
	
	var _TaskNode2 = _interopRequireDefault(_TaskNode);
	
	var _ScriptNode = __webpack_require__(1342);
	
	var _ScriptNode2 = _interopRequireDefault(_ScriptNode);
	
	var _ServiceNode = __webpack_require__(1343);
	
	var _ServiceNode2 = _interopRequireDefault(_ServiceNode);
	
	var _EndNode = __webpack_require__(1340);
	
	var _EndNode2 = _interopRequireDefault(_EndNode);
	
	var _JumpNode = __webpack_require__(1341);
	
	var _JumpNode2 = _interopRequireDefault(_JumpNode);
	
	var _WorkflowNode = __webpack_require__(1346);
	
	var _WorkflowNode2 = _interopRequireDefault(_WorkflowNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NodeParaEdit = function (_Component) {
	    _inherits(NodeParaEdit, _Component);
	
	    function NodeParaEdit(props) {
	        _classCallCheck(this, NodeParaEdit);
	
	        var _this = _possibleConstructorReturn(this, (NodeParaEdit.__proto__ || Object.getPrototypeOf(NodeParaEdit)).call(this, props));
	
	        _this.showDrawer = function (node) {
	            if (node && node.data && node.data.type && node.data.type == "01" || node && node.type && node.type == "01") {
	                tool.sgiLogger.log("no-------------------");
	                tool.sgiLogger.log(node);
	                tool.sgiLogger.log(node.data.type);
	                tool.sgiLogger.log(node.type);
	                _this.setState({ visible: false });
	                return;
	            }
	            tool.sgiLogger.log("done-------------------");
	            if (node && node.data) _this.setState({ type: node.data.type, node: node, nodedata: node.data, visible: true });
	        };
	
	        _this.onClose = function () {
	            _this.setState({
	                visible: false
	            });
	        };
	
	        _this.state = {
	            type: null,
	            visible: false,
	            placement: 'right',
	            node: props.node,
	            nodedata: props.nodedata,
	            loading: false
	        };
	        return _this;
	    }
	
	    _createClass(NodeParaEdit, [{
	        key: 'save',
	        value: function save(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	            this.props.form.validateFields(function (errors, values) {
	                if (errors) {
	                    tool.sgiLogger.log('输入错误,请检查!!');
	                    return;
	                }
	                //所有的form表单值，等同于values
	                var formData = _this2.props.form.getFieldsValue();
	                //从表单中获取日期timeRange的值(起始时间+结束时间)是个数组
	                var timeRange = formData['timeRange'];
	                /*若是不限时段 日期数组就为null*/
	                if (timeRange === undefined || formData['timeFlag'] === '-1') {
	                    formData.startDate = null;
	                    formData.endDate = null;
	                } else if (timeRange !== undefined && formData['timeFlag'] === '1') {
	                    //格式化时间数组为YYYYMMDD  startDate:起始时间 endDate：结束时间          
	                    formData.startDate = timeRange[0].format('YYYYMMDD');
	                    formData.endDate = timeRange[1].format('YYYYMMDD');
	                }
	                //默认添加创建人
	                formData.createUser = '创建人1';
	                _this2.props.createActions.createActivity(formData);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var child = void 0;
	            if (this.state.type === '06') {
	                child = _react2.default.createElement(_TaskNode2.default, { key: this.state.nodedata.id, ref: 'taskpanel', show: true, node: this.state.node, nodedata: this.state.nodedata });
	            }
	            if (this.state.type === '02') {
	                child = _react2.default.createElement(_JumpNode2.default, { key: this.state.nodedata.id, ref: 'jumppanel', show: true, node: this.state.node, nodedata: this.state.nodedata });
	            }
	            if (this.state.type === '03') {
	                child = _react2.default.createElement(_ServiceNode2.default, { key: this.state.nodedata.id, ref: 'servicepanel', show: true, node: this.state.node, nodedata: this.state.nodedata });
	            }
	            if (this.state.type === '04') {
	                child = _react2.default.createElement(_ScriptNode2.default, { key: this.state.nodedata.id, ref: 'scriptpanel', show: true, node: this.state.node, nodedata: this.state.nodedata });
	            }
	            if (this.state.type === '05') {
	                child = _react2.default.createElement(_WorkflowNode2.default, { key: this.state.nodedata.id, ref: 'workflownode', show: true, node: this.state.node, nodedata: this.state.nodedata });
	            }
	            if (this.state.type === '99') {
	                child = _react2.default.createElement(_EndNode2.default, { key: this.state.nodedata.id, ref: 'endpanel', show: true, node: this.state.node, nodedata: this.state.nodedata });
	            }
	            tool.sgiLogger.log(this.state);
	            tool.sgiLogger.log(child);
	            tool.sgiLogger.log(this.state.visible);
	            return _react2.default.createElement(
	                _antd.Drawer,
	                {
	                    mask: false,
	                    destroyOnClose: true,
	                    title: '\u8282\u70B9\u53C2\u6570',
	                    width: 720,
	                    placement: 'right',
	                    closable: true,
	                    onClose: this.onClose,
	                    visible: this.state.visible,
	                    style: {
	                        // height: 'calc(100% - 55px)',
	                        // overflow: 'auto',
	                        paddingBottom: 55
	                    },
	                    bodyStyle: { // 为了标题固定
	                        height: 'calc(100% - 55px)',
	                        // overflow: 'auto',
	                        paddingBottom: 55
	                    }
	                },
	                child
	            );
	        }
	    }]);
	
	    return NodeParaEdit;
	}(_react.Component);
	
	exports.default = NodeParaEdit;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(682);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _NodeParaEdit = __webpack_require__(1348);
	
	var _NodeParaEdit2 = _interopRequireDefault(_NodeParaEdit);
	
	var _antd = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import 'antd/dist/antd.css';
	
	
	// import {render} from 'react-dom'
	// var jtopo = $('<script src="jtopo-0.4.8-min.js" type="text/javascript"></script>');
	// $(document.body).before(jtopo);
	var JTopo = window.JTopo;
	var STARTNODETYPE = "01";
	
	var Workflow = function (_Component) {
	    _inherits(Workflow, _Component);
	
	    function Workflow(props) {
	        _classCallCheck(this, Workflow);
	
	        var _this = _possibleConstructorReturn(this, (Workflow.__proto__ || Object.getPrototypeOf(Workflow)).call(this, props));
	
	        _this.state = {
	            editpanelWidth: 24,
	            nodepanelWidth: 0,
	            root: undefined,
	            over: undefined,
	            w: _this.props.width != null && typeof _this.props.width !== "undefined" ? _this.props.width : "100%",
	            h: _this.props.height != null && typeof _this.props.height !== "undefined" ? _this.props.height : "790px",
	            canvas: undefined,
	            code: _this.props.code != null && typeof _this.props.code !== "undefined" ? _this.props.code : "workflowEditPanel",
	            canvasid: _this.props.code != null && typeof _this.props.code !== "undefined" ? "canvas" + _this.props.code : "canvasworkflowEditPanel",
	            editid: _this.props.code != null && typeof _this.props.code !== "undefined" ? "editid" + _this.props.code : "canvaseditidPanel",
	            currnode: null,
	            currdata: null,
	            maxid: 1,
	            contextmenu: _this.props.ctxmenu != null && typeof _this.props.ctxmenu !== "undefined" ? _this.props.ctxmenu : [{
	                text: "添加任务",
	                pk: "1",
	                img: "./images/task_done.png",
	                func: function func(wf) {
	                    wf.rmenuClick(wf, "06");
	                }
	            }, {
	                text: "添加跳转",
	                pk: "2",
	                img: "./images/jump_done.png",
	                func: function func(wf) {
	                    wf.rmenuClick(wf, "02");
	                }
	            }, {
	                text: "添加服务",
	                pk: "3",
	                img: "./images/service_done.png",
	                func: function func(wf) {
	                    wf.rmenuClick(wf, "03");
	                }
	            }, {
	                text: "添加脚本",
	                img: "./images/script_done.png",
	                pk: "4",
	                func: function func(wf) {
	                    wf.rmenuClick(wf, "04");
	                }
	            }, {
	                text: "添加子流程",
	                pk: "5",
	                img: "./images/workflow_done.png",
	                func: function func(wf) {
	                    wf.rmenuClick(wf, "05");
	                }
	            }, {
	                text: "添加终点",
	                pk: "6",
	                img: "./images/over.png",
	                func: function func(wf) {
	                    wf.rmenuClick(wf, "99");
	                }
	            }, {
	                text: "删除节点",
	                pk: "7",
	                img: "./images/delete.png",
	                func: function func(wf) {
	                    var node = wf.state.currnode;
	                    if (!node) {
	                        alert("no selected node");
	                        return;
	                    }
	                    node.remove();
	                }
	            }],
	            config: {},
	            clickfunction: _this.props.clickFunc != null && typeof _this.props.clickFunc !== "undefined" ? _this.props.clickFunc : _this.clickFunc,
	            blankClickFunc: _this.props.blankClickFunc != null && typeof _this.props.blankClickFunc !== "undefined" ? _this.props.blankClickFunc : _this.blankClickFunc,
	            model: _this.props.model != null && typeof _this.props.model !== "undefined" ? _this.props.model : null,
	            readOnly: _this.props.readOnly != null && typeof _this.props.readOnly !== "undefined" ? _this.props.readOnly : true,
	            debug: _this.props.debug != null && typeof _this.props.debug !== "undefined" ? _this.props.debug : false
	
	        };
	        return _this;
	    }
	
	    _createClass(Workflow, [{
	        key: "clickfunction",
	        value: function clickfunction(node, model) {}
	    }, {
	        key: "sceneClickFcuntion",
	        value: function sceneClickFcuntion() {}
	    }, {
	        key: "init",
	        value: function init() {
	            var baseDom = document.getElementById(this.state.canvasid);
	            var editpanel = document.getElementById(this.state.editid);
	            tool.sgiLogger.log(baseDom);
	            tool.sgiLogger.log(editpanel);
	            baseDom.width = editpanel.clientWidth;
	            baseDom.height = editpanel.clientHeight;
	            this.canvas = this.scene(baseDom);
	            if (this.state.model) {
	                if (!this.maxid) {
	                    this.maxid = 0;
	                }
	                this.drawRoot(this.state.model, this.state.readOnly);
	                this.maxid++;
	            } else {
	                if (!this.maxid) {
	                    this.maxid = 1;
	                }
	                var start = this.newData(null, "01");
	                this.drawRoot(start);
	            }
	        }
	    }, {
	        key: "scene",
	        value: function scene(domNode) {
	            var me = this;
	            var stage = new JTopo.Stage(domNode); // 创建一个舞台对象
	            var scene = new JTopo.Scene(stage); // 创建一个场景对象
	            stage.wheelZoom = 0.9;
	            scene.mode = "normal";
	            if (me.readOnly) {
	                stage.mode = "drag";
	            }
	            stage.wheelZoom = null;
	            stage.click(function (event) {
	                // 关闭弹出菜单（div）
	                me._hideMenu("ctxmenu");
	                if (!me.nodeclick) {
	                    // 标识这次执行的是空白处的点击事件
	                    me.sceneClickFcuntion();
	                }
	                me.nodeclick = false;
	            });
	            return scene;
	        }
	    }, {
	        key: "drawRoot",
	        value: function drawRoot(model, type) {
	            var me = this;
	            if (!this.canvas) {
	                me.init();
	            }
	            // this.root:model});
	            var jumps = [];
	            var nodes = [];
	            var draw = function draw(model) {
	                if (!model) {
	                    return;
	                }
	                var node = me.getnode(model, model.type, type);
	                if (model.type === "01") {
	                    // me.root=node;
	                    // me.currnode=node;
	                    me.setState({ root: node, currnode: node });
	                }
	                if (!node) {
	                    tool.sgiLogger.log("create node failed," + model);
	                    return undefined;
	                }
	                nodes.push(node);
	                me.canvas.add(node);
	                var children = model.childNode;
	                if (!children) {
	                    if (model.type === "02") {
	                        jumps.push(node);
	                    }
	                    if (!me.maxid) {
	                        me.maxid = 0;
	                    }
	                    if (node.data.id > me.maxid) {
	                        me.maxid = node.data.id;
	                    }
	                    tool.sgiLogger.log(model.name + " no children");
	                    return node;
	                }
	                var downnodes = [];
	                for (var i = 0; i < children.length; i++) {
	                    var n = draw(children[i]);
	                    if (n) {
	                        if (!n.parentsNode) {
	                            n.parentsNode = [];
	                        }
	                        n.parentsNode.push(node);
	                        downnodes.push(n);
	                    }
	                }
	                node.to = downnodes;
	                for (var j = 0; j < downnodes.length; j++) {
	                    var link = me.line(node, downnodes[j]);
	                    if (link) {
	                        me.canvas.add(link);
	                    }
	                }
	                if (!me.maxid) {
	                    me.maxid = 0;
	                }
	                if (node.data.id > me.maxid) {
	                    me.maxid = node.data.id;
	                }
	                // if (node.data.type==="02") jumps.push(node);
	                return node;
	            };
	            var node = draw(model);
	            for (var n = 0; n < jumps.length; n++) {
	                var jpnode = jumps[n];
	                for (var m = 0; m < nodes.length; m++) {
	                    tool.sgiLogger.log(nodes[m].id);
	                    if (jpnode.data.ncode === nodes[m].data.id) {
	                        var link = me.dottedline(jpnode, nodes[m]);
	                        jpnode.dotline = link;
	                        me.canvas.add(link);
	                        break;
	                    }
	                }
	            }
	            return node;
	        }
	    }, {
	        key: "clear",
	        value: function clear() {
	            if (this.canvas) {
	                this.canvas.clear();
	            }
	        }
	    }, {
	        key: "create",
	        value: function create(currentNode, model) {
	            if (!model) {
	                return;
	            }
	            var me = this;
	            if (!this.canvas) {
	                me.init();
	            }
	            var node = me.getnode(model, model.type);
	            if (model.type === "01") {
	                // me.root = node
	                // me.currnode = node
	                me.setState({ root: node, currnode: node });
	            }
	            if (!node) {
	                tool.sgiLogger.log("unsupport node type : " + model.type);
	                return;
	            }
	            if (currentNode && node) {
	                me.canvas.add(node);
	                var link = me.line(currentNode, node);
	                me.canvas.add(link);
	            }
	            return node;
	        }
	    }, {
	        key: "remove",
	        value: function remove(node) {
	            var me = this;
	
	            if (node.data && node.data.type && node.data.type === "02") {
	
	                var dotline = node.dotline;
	                if (me.canvas && dotline) {
	                    me.canvas.remove(dotline);
	                }
	                if (dotline.nodeA && dotline.nodeA.type === "temp") {
	                    me.canvas.remove(dotline.nodeA);
	                }
	
	                if (dotline.nodeZ && dotline.nodeZ.type === "temp") {
	                    me.canvas.remove(dotline.nodeZ);
	                }
	            }
	            if (me.canvas) {
	                if (node.fromlines && node.fromlines.length > 0) {
	                    node.fromlines.forEach(function (line) {
	                        if (line.nodeA && line.nodeA.type === "temp") {
	                            me.canvas.remove(line.nodeA);
	                            me.canvas.remove(line);
	                        }
	
	                        if (line.nodeZ && line.nodeZ.type == "temp") {
	                            me.canvas.remove(line.nodeZ);
	                            me.canvas.remove(line);
	                        }
	                    });
	                }
	
	                if (node.tolines && node.tolines.length > 0) {
	                    node.tolines.forEach(function (line) {
	                        if (line.nodeA && line.nodeA.type === "temp") {
	                            me.canvas.remove(line.nodeA);
	                            me.canvas.remove(line);
	                        }
	
	                        if (line.nodeZ && line.nodeZ.type === "temp") {
	                            me.canvas.remove(line.nodeZ);
	                            me.canvas.remove(line);
	                        }
	                    });
	                }
	
	                me.canvas.remove(node);
	            }
	        }
	    }, {
	        key: "line",
	        value: function line(fromNode, toNode) {
	            var me = this;
	            var line = new JTopo.Link(fromNode, toNode);
	
	            line.lineWidth = 2; // 线宽
	            line.arrowsRadius = 7; // 箭头大小
	            line.textOffsetY = 3; // 文本偏移量(向下3个像素)
	            // line.strokeColor = "240,131,31";
	
	            line.strokeColor = "28 28 28";
	            // line.bundleOffset = 60; // 折线拐角处的长度
	            // line.bundleGap = 20; // 线条之间的间隔
	
	            fromNode.setToline(line);
	            toNode.setFromline(line);
	
	            if (!me.state.readOnly) {
	                line.addEventListener("dbclick", function (e) {
	                    // var anode = this.nodeA;
	                    // var tempstart = me.lineStartNode(anode.x, anode.y, this);
	
	
	                    var anode = this.nodeA;
	                    var znode = this.nodeZ;
	
	                    if (znode && line.nodeZ.type != "temp" && anode && line.nodeA.type != "temp") {
	                        var tempstart = me.lineEndNode(znode.x - 35, znode.y, this);
	                        me.canvas.add(tempstart);
	                        for (var i = 0; i < anode.tolines.length; i++) {
	                            if (anode.tolines[i].nodeA == anode && anode.tolines[i].nodeZ == tempstart) {
	                                // anode.tolines[i].nodeZ = tempstart;
	                                if (anode.data.childNode) {
	                                    anode.data.childNode.splice(i, 1);
	                                }
	                            }
	                        }
	                        for (var i = 0; i < znode.fromlines.length; i++) {
	
	                            if (znode.fromlines[i].nodeA == anode && znode.fromlines[i].nodeZ == tempstart) {
	                                // anode.tolines[i].nodeZ = tempstart;
	                                znode.fromlines.splice(i, 1);
	                            }
	                        }
	                    }
	                    // if (znode&& line.nodeZ.type!="temp" && anode && line.nodeA.type == "temp") {
	                    //     tempstart = me.lineEndNode(znode.x, znode.y, this);
	                    //     me.canvas.add(tempstart);
	                    //     for (let i = 0; i < anode.tolines.length; i++) {
	                    //         if (anode.tolines[i].nodeA == anode && anode.tolines[i].nodeZ == znode) {
	                    //             anode.tolines[i].nodeZ=tmpstart;
	                    //             if (anode.data.childNode) { anode.data.childNode.splice(i, 1) };
	                    //         }
	                    //     }
	                    // }
	                    // if (anode && line.nodeA.type != "temp") {
	                    //     for (let i = 0; i < anode.tolines.length; i++) {
	                    //         if (anode.tolines[i].nodeA == anode && anode.tolines[i].nodeZ == znode) {
	                    //             anode.tolines[i].nodeZ=tmpstart;
	                    //             if (anode.data.childNode) { anode.data.childNode.splice(i, 1) };
	                    //         }
	                    //     }
	
	                    //     // Ext.Array.remove(anode.tolines ,this);
	                    //     // anode.tolines.splice($.inArray(this, anode.tolines), 1);
	
	                    //     // var childnodes = anode.data.childNode;
	                    //     // if (childnodes) {
	                    //     // // Ext.Array.remove(childnodes ,znode.data);
	                    //     //     childnodes.splice($.inArray(anode.data, childnodes), 1);
	                    //     // //anode.data.cldSet = childnodes;
	                    //     // }
	                    // }
	                });
	            }
	
	            return line;
	        }
	    }, {
	        key: "dottedline",
	        value: function dottedline(fromNode, toNode) {
	            var link = this.line(fromNode, toNode);
	            link.dashedPattern = 5; // 虚线
	            return link;
	        }
	    }, {
	        key: "lineStartNode",
	        value: function lineStartNode(x, y, line) {
	            var me = this;
	            var lsn = me._tempNode(x, y);
	
	            line.nodeA = lsn;
	            lsn.toline = line;
	
	            return lsn;
	        }
	    }, {
	        key: "lineEndNode",
	        value: function lineEndNode(x, y, line) {
	            var me = this;
	            var len = me._tempNode(x, y);
	
	            line.nodeZ = len;
	            len.fromline = line;
	
	            return len;
	        }
	    }, {
	        key: "jumpLine",
	        value: function jumpLine(node) {
	            var me = this;
	            var temp = me._tempNode(node.x + 130, node.y + 30);
	            temp.addEventListener("mousedrag", function (e) {
	                // me.dragnode = this;
	                me.setState({ dragnode: this });
	            });
	            var dotline = me.dottedline(node, temp);
	
	            dotline.nodeZ = temp;
	            temp.fromline = dotline;
	
	            this.canvas.add(temp);
	            this.canvas.add(dotline);
	
	            node.dotline = dotline;
	
	            return dotline;
	        }
	    }, {
	        key: "_addNodeListener",
	        value: function _addNodeListener(node) {
	            var me = this;
	            node.addEventListener("click", function (e) {
	                // if (!me.nodedrag) {
	                //     me.state.clickfunction(node, me);
	                //     me.nodeclick = true; // 标识这次执行的是node的点击事件
	                // }
	                // me.nodedrag = false;
	            });
	            node.addEventListener("dbclick", function (e) {
	                me.state.clickfunction(node, me);
	            });
	            node.addEventListener("mouseup", function (e) {
	                if (e.button === 2) {
	                    // 右键
	                    me.rclickFunc(node);
	                    me._showMenu(this, "ctxmenu");
	                }
	            });
	            node.addEventListener("mousedown", function (e) {
	                // tool.sgiLogger.log("mousedown:"+this);
	            });
	            node.addEventListener("mouseover", function (e) {
	
	                if (me.state.dragnode) {
	                    var current = this;
	                    var temp = me.state.dragnode;
	                    var line;
	                    if (temp.toline) {
	                        line = temp.toline;
	                        // var downNode = line.nodeZ;
	                        var tonode = line.nodeZ;
	                        if (tonode && tonode.type != "temp") {
	                            // var childnodes = current.data.cldSet;
	
	                            for (var i = 0; i < tonode.fromlines.length; i++) {
	                                if (tonode.fromlines[i].nodeA == current && tonode.fromlines[i].nodeZ == tonode) {
	                                    return;
	                                }
	                            }
	
	                            current.setToline(line);
	                            var childnodes = current.data.childNode;
	                            if (!childnodes) {
	                                childnodes = [];
	                                // current.data.cldSet = childnodes;
	                                current.data.childNode = childnodes;
	                            }
	                            childnodes.push(tonode.data);
	                        }
	                    } else {
	                        line = temp.fromline;
	                        var upNode = line.nodeA;
	                        if (current == upNode) {
	                            return;
	                        }
	                        for (var _i = 0; _i < upNode.tolines.length; _i++) {
	                            if (upNode.tolines[_i].nodeA == upNode && upNode.tolines[_i].nodeZ == current) {
	                                return;
	                            }
	                        }
	                        for (var _i2 = 0; _i2 < current.fromlines.length; _i2++) {
	                            if (current.fromlines[_i2].nodeA == upNode && current.fromlines[_i2].nodeZ == current) {
	                                return;
	                            }
	                        }
	                        current.setFromline(line);
	                        if (upNode && upNode.type != "temp" && upNode.data.type != "02") {
	                            var childnodes = upNode.data.childNode;
	                            if (childnodes) {
	                                childnodes.push(current.data);
	                            }
	
	                            // upNode.data.gotoNodeId = current.data.id;
	                            // upNode.data.ncode = current.data.id;
	                        }
	                        if (upNode && upNode.type != "temp" && upNode.data.type == "02") {
	
	                            upNode.data.gotoNodeId = current.data.id;
	                            upNode.data.ncode = current.data.id;
	                            upNode.click();
	                            if (me.refs.NodeParaEdit.refs.jumppanel) {
	                                me.refs.NodeParaEdit.refs.jumppanel.setFieldsValue({ ncode: upNode.data.ncode });
	                            }
	                        }
	                        // upNode.data.transfer = current.data.sc ;
	                    }
	                    me.remove(temp);
	                    me.setState({ dragnode: undefined });
	                }
	            });
	            node.addEventListener("mousedrag", function (e) {
	                if (this.data) {
	                    if (this.data.x !== this.x || this.data.y !== this.y) {
	                        me.setState({ nodedrag: true });
	                    }
	                    this.data.x = this.x;
	                    this.data.y = this.y;
	                }
	            });
	        }
	    }, {
	        key: "_setModelPubFiedls",
	        value: function _setModelPubFiedls(model, node) {
	            var me = this;
	            node.data = model;
	            node.createNextNode = function (data) {
	                return me.create(this, data);
	            };
	            node.remove = function () {
	                var delNode = this;
	                var downlines = delNode.tolines;
	                if (downlines) {
	                    for (var i = 0; i < downlines.length; i++) {
	                        var line = downlines[i];
	                        var tempstart = me.lineStartNode(delNode.x, delNode.y, line);
	                        me.canvas.add(tempstart);
	                    }
	                }
	                delNode.tolines = [];
	
	                if (typeof me.state.over !== "undefined" && delNode.type === "99") {
	                    me.setState({ over: undefined });
	                }
	                me.remove(delNode);
	                var pnodes = delNode.parentsNode;
	                if (pnodes) {
	                    for (var j = 0; j < pnodes.length; j++) {
	                        if (pnodes[j].data.childNode) {
	                            for (var i = 0; i < pnodes[j].data.childNode.length; i++) {
	                                if (pnodes[j].data.childNode[i].id === delNode.data.id) {
	                                    pnodes[j].data.childNode.splice(i, 1);
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                    for (var j = 0; j < pnodes.length; j++) {
	                        var downlines = pnodes[j].tolines;
	                        if (downlines) {
	                            for (var i = 0; i < downlines.length; i++) {
	                                var line = downlines[i];
	                                if (line.nodeZ === delNode) {
	                                    pnodes[j].tolines.splice(i, 1);
	                                }
	                            }
	                        }
	                    }
	                }
	            };
	            node.setToline = function (line) {
	                if (!this.tolines) {
	                    this.tolines = [];
	                }
	                this.tolines.push(line);
	
	                line.nodeA = this;
	            };
	            node.setFromline = function (line) {
	                if (!this.fromlines) {
	                    this.fromlines = [];
	                }
	                this.fromlines.push(line);
	
	                line.nodeZ = this;
	            };
	            node.getChart = function () {
	                return me;
	            };
	
	            node.id = model.sc;
	        }
	    }, {
	        key: "getnode",
	        value: function getnode(model, nodetype, type) {
	            var nodetypes = ["01", "02", "03", "04", "05", "06", "99"];
	            if (nodetypes.indexOf(nodetype) < 0) {
	                return null;
	            }
	            var name;
	            switch (nodetype) {
	                case "01":
	                    name = "开始";
	                    break;
	                case "02":
	                    name = "跳转节点";
	                    break;
	                case "03":
	                    name = "服务节点";
	                    break;
	                case "04":
	                    name = "脚本节点";
	                    break;
	                case "05":
	                    name = "子流程";
	                    break;
	                case "06":
	                    name = "任务节点";
	                    break;
	                case "99":
	                    name = "结束";
	                    break;
	
	                default:
	                    break;
	            }
	            // var node = new JTopo.Node(model.id + " " + name);
	            // if (!node) {
	            //     return node;
	            // }
	            // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
	            // node.font = "12px Consolas";
	            // node.fontColor = "0 ,0 ,0";
	            // // node.textPosition = "Middle_Center";
	            // node.setSize(38, 38);
	            // if (nodetype) {node.type = nodetype;}
	            // if (!model.name) {model.name = name;}
	            // if (nodetype === "01") {
	            //     node.setImage(require("./images/start.png"));
	            // } else if (nodetype === "99") {
	            //     node.setText = function (str) {
	            //         if (!str) {
	            //             this.text = name;
	            //         }
	            //         this.text = str;
	            //     };
	            //     node.setImage(require("./images/over.png"));
	            //     if (type && model && model.status && model.status === "00") {
	            //         node.setImage(require("./images/over_undo.png"));
	            //     } else if (model && model.status && model.status === "02") {
	            //         node.setImage(require("./images/over.png"));
	            //     }
	            //     this.setState({over: node});
	            // } else {
	            //     node.setText = function (str) {
	            //         if (!str) {
	            //             this.text = name;
	            //         }
	            //         this.text = str;
	            //     };
	            //     if (model && model.name) {node.setText(model.id + " " + model.name);}
	            //     if (nodetype === "02") {
	            //         node.fillColor = "255 ,255 ,0";
	            //         node.setImage(require("./images/jump_done.png"));
	            //         if (type && model && model.status && model.status === "00") {
	            //             node.setImage(require("./images/jump_undo.png"));
	            //         } else if (model && model.status && model.status === "02") {
	            //             node.fontColor = "30 144 255";
	            //         }
	
	            //     }
	            //     if (nodetype === "03") {
	            //         node.fillColor = "218 ,112 ,214";
	            //         node.setImage(require("./images/service_done.png"));
	            //         if (type && model && model.status && model.status === "00") {
	            //             node.setImage(require("./images/service_undo.png"));
	            //         } else if (model && model.status && model.status === "02") {
	            //             node.fontColor = "30 144 255";
	            //         }
	
	            //     }
	            //     if (nodetype === "04") {
	            //         node.fillColor = "250 ,235 ,215";
	            //         node.setImage(require("./images/script_done.png"));
	            //         if (type && model && model.status && model.status === "00") {
	            //             node.setImage(require("./images/script_undo.png"));
	            //         } else if (model && model.status && model.status === "02") {
	            //             node.fontColor = "30 144 255";
	            //         }
	
	            //     }
	
	            //     if (nodetype === "05") {
	            //         node.fillColor = "188 ,143 ,143";
	            //         node.setImage(require("./images/workflow_done.png"));
	            //         if (type && model && model.status && model.status === "00") {
	            //             node.setImage(require("./images/workflow_undo.png"));
	            //         } else if (model && model.status && model.status === "02") {
	            //             node.fontColor = "30 144 255";
	            //         }
	
	            //     }
	            //     if (nodetype === "06") {
	            //         node.fillColor = "127 ,255 ,212";
	            //         node.setImage(require("./images/task_done.png"));
	            //         if (type && model && model.status && model.status === "00") {
	            //             node.setImage(require("./images/task_undo.png"));
	            //         } else if (model && model.status && model.status === "02") {
	            //             node.fontColor = "30 ,144 ,255";
	            //         }
	
	            //     }
	            // }
	            var node = new JTopo.Node(model.id + " " + name);
	            if (!node) {
	                return node;
	            }
	            // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
	            node.font = "12px Consolas";
	            node.textPosition = "Middle_Center"; // 文字居中
	            node.fontColor = "0 ,0 ,0";
	            // node.borderRadius = 5; // 圆角
	            node.borderWidth = "1"; // 边框的宽度
	            node.borderColor = "255,255,255"; // 边框颜色
	            node.alpha = 0.9; // 透明度
	            // node.textPosition = "Middle_Center";
	            // node.setSize(58, 58);
	            if (nodetype) {
	                node.type = nodetype;
	            }
	            if (!model.name) {
	                model.name = name;
	            }
	            if (nodetype === STARTNODETYPE || nodetype === "99") {
	                node.beginDegree = 0;
	                node.width = node.height = 80;
	                node.paint = function (g) {
	                    g.beginPath();
	                    g.moveTo(0, 0);
	                    g.fillStyle = "rgba(255,140,0," + this.alpha + ")";
	                    g.arc(0, 0, this.width / 2, this.beginDegree, this.beginDegree + 2 * Math.PI);
	                    g.fill();
	                    g.closePath();
	
	                    g.save();
	                    g.beginPath();
	                    g.fillStyle = "rgba(255,239,213," + this.alpha + ")";
	                    g.moveTo(0, 0);
	                    g.arc(0, 0, this.width / 2 - 2, this.beginDegree, this.beginDegree + 2 * Math.PI);
	                    g.fill();
	                    g.closePath();
	                    g.restore();
	
	                    this.paintText(g);
	                };
	
	                // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
	                node.font = "12px Consolas";
	                node.textPosition = "Middle_Center"; // 文字居中
	                node.fontColor = "0 ,0 ,0";
	                // node.setSize(58, 58);
	                if (nodetype) {
	                    node.type = nodetype;
	                }
	                if (!model.name) {
	                    model.name = name;
	                }
	                node.radius = 50; // 半径
	                node.borderColor = "255,140,0"; // 边框颜色
	                node.fillColor = "	255,239,213"; // 边框颜色
	                // node.setImage(require('./images/start.png'));
	                if (nodetype === "99") {
	                    this.setState({ over: node });
	                }
	            } else {
	                node.borderWidth = 1; // 边框的宽度
	                node.setText = function (str) {
	                    if (!str) {
	                        this.text = name;
	                    }
	                    this.text = str;
	                };
	                if (model && model.name) {
	                    node.setText(model.id + " " + model.name);
	                }
	                if (nodetype === "02") {
	                    // node.fillColor = '255 ,255 ,0';
	                    node.setSize(70, 70);
	                    // node.rotate=45*Math.PI/180;
	                    node.borderRadius = 5; // 圆角
	                    node.fillColor = "127,255,170";
	                    node.borderColor = "50,205,50"; // 边框颜色
	                    // node.setImage(require('./images/jump_done.png'));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/jump_undo.png"));
	                        node.fillColor = "119,136,153";
	                        node.alpha = 100;
	                        node.borderColor = "105,105,105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.alpha = 100;
	                        node.fontColor = "30,144,255";
	                    }
	                }
	                if (nodetype === "03") {
	                    node.setSize(100, 60);
	                    node.borderRadius = 5; // 圆角
	                    node.fillColor = "250,128,114";
	                    node.borderColor = "255,0,0"; // 边框颜色
	                    // node.setImage(require('./images/service_done.png'));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/service_undo.png"));
	                        node.fillColor = "119,136,153";
	                        node.alpha = 100;
	                        node.borderColor = "105,105,105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.alpha = 100;
	                        node.fontColor = "30,144,255";
	                    }
	                }
	                if (nodetype === "04") {
	                    node.fillColor = "250 ,235 ,215";
	                    node.setSize(100, 60);
	                    node.borderRadius = 27; // 圆角
	                    node.fillColor = "255,20,147";
	                    node.borderColor = "255,215,0"; // 边框颜色
	                    // node.setImage(require('./images/script_done.png'));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/script_undo.png"));
	                        node.fillColor = "119,136,153";
	                        node.alpha = 100;
	                        node.borderColor = "105,105,105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.alpha = 100;
	                        node.fontColor = "30,144,255";
	                    }
	                }
	
	                if (nodetype === "05") {
	                    node.fillColor = "188 ,143 ,143";
	                    node.setSize(110, 60);
	                    node.borderRadius = 30; // 圆角
	                    node.fillColor = "	221,160,221";
	                    node.borderColor = "148,0,211"; // 边框颜色
	                    // node.setImage(require('./images/workflow_done.png'));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/workflow_undo.png"));
	                        node.fillColor = "119,136,153";
	                        node.alpha = 100;
	                        node.borderColor = "105,105,105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.alpha = 100;
	                        node.fontColor = "30,144,255";
	                    }
	                }
	                if (nodetype === "06") {
	                    // node.fillColor = "135 206 250";
	                    node.setSize(100, 60);
	                    node.borderRadius = 20; // 圆角
	                    node.fillColor = "142,229,238";
	                    node.borderColor = "30,144,255"; // 边框颜色
	                    // node.setImage(require("./images/task_done.png"));
	                    if (type && model && model.status && model.status === "00") {
	                        // node.setImage(require("./images/task_undo.png"));
	                        node.fillColor = "119,136,153";
	                        node.alpha = 100;
	                        node.borderColor = "105,105,105";
	                    } else if (model && model.status && model.status === "02") {
	                        node.alpha = 100;
	                        node.fontColor = "30,144,255";
	                    }
	                }
	            }
	            node.setLocation(model.x, model.y);
	            this._setModelPubFiedls(model, node);
	            if (!type) {
	                tool.sgiLogger.log("编辑模式");
	                this._addNodeListener(node);
	            } else {
	                tool.sgiLogger.log("只读模式");
	                tool.sgiLogger.log("model.status", model, model.status);
	
	                // 当前执行节点  加特殊标识
	                if (model && model.status) {
	                    node.percent = 0.8;
	                    node.beginDegree = 0;
	                    if (model.status === "01" || model.status === "99") {
	                        if (model.status === "01") {
	                            node.color = "rgba(0,255,0,";
	                        }
	                        if (model.status === "99") {
	                            node.color = "rgba(255,0,0,";
	                        }
	                        // if (model.status === "03") node.color='rgba(143,153,159,';
	                        // if (model.status === "04") node.color='rgba(245,255,0,' ;
	                        // if (model.status === "05") node.color='rgba(244,248,244,';
	                        // if (model.status === "02") node.color='rgba(30 ,144 ,255,' ;
	                        if (model.status != "01") {
	                            node.percent = 1;
	                        } else {
	                            node.width = node.height = 80;
	                            node.percent = 1;
	                        }
	                        // node.paint = function (g) {
	                        //     //
	                        //     g.save();
	                        //     g.beginPath();
	                        //     g.moveTo(0, 0);
	                        //     g.strokeStyle = this.color + this.alpha + ")";
	                        //     g.lineWidth = 6;
	                        //     g.arc(0, 0, (this.width + 3) / 2, this.beginDegree, this.beginDegree + 2 * Math.PI * this.percent);
	                        //     // g.fill();
	                        //     g.stroke();
	                        //     g.closePath();
	                        //     g.beginPath();
	                        //     g.moveTo(0, 0);
	                        //     // g.drawImage(this.image, -this.width / 2, -this.height / 2, 38, 38);
	                        //     // g.fillStyle = 'rgba(0,0,255,' + this.alpha + ')';
	                        //     // g.moveTo(0,0);
	                        //     // g.arc(0, 0, this.width/2-8, this.beginDegree, this.beginDegree + 2*Math.PI);
	                        //     // g.fill();
	                        //     g.closePath();
	                        //     g.restore();
	                        //     this.paintText(g);
	                        // };
	
	                        node.paint = function (g) {
	                            //
	                            g.save();
	                            g.beginPath();
	                            g.moveTo(0, 0);
	                            g.strokeStyle = this.color + this.alpha + ")";
	                            g.lineWidth = 7;
	                            g.arc(0, 0, (this.width + 3) / 2, this.beginDegree, this.beginDegree + 2 * Math.PI * this.percent, true);
	                            g.stroke();
	                            g.closePath();
	
	                            g.beginPath();
	                            g.moveTo(0, 0);
	                            g.fillStyle = "rgba(30,144,255," + 100 + ")";
	                            g.arc(0, 0, (this.width + 3) / 2, this.beginDegree, this.beginDegree + 2 * Math.PI, true);
	                            g.fill();
	                            g.closePath();
	
	                            g.restore();
	                            this.paintText(g);
	                        };
	
	                        if (model.status === "01") {
	                            tool.sgiLogger.log("进入画圈环节！！");
	                            JTopo.Animate.stepByStep(node, {
	                                percent: 0
	                            }, 2500, true).start();
	                            tool.sgiLogger.log("画圈环节结束！！");
	                        }
	                    }
	                }
	            }
	            return node;
	        }
	    }, {
	        key: "_tempNode",
	        value: function _tempNode(x, y) {
	            var me = this;
	
	            var temp = new JTopo.CircleNode("连接点");
	            temp.type = "temp";
	            temp.fillColor = "255 ,255 ,0";
	            temp.setLocation(x, y);
	            temp.radius = 5;
	
	            temp.setFromline = function (line) {
	                if (!this.fromlines) {
	                    this.fromlines = [];
	                }
	                this.fromlines.push(line);
	
	                line.nodeZ = this;
	            };
	            temp.setToline = function (line) {
	                if (!this.tolines) {
	                    this.tolines = [];
	                }
	                this.tolines.push(line);
	
	                line.nodeA = this;
	            };
	
	            temp.addEventListener("mousedrag", function (e) {
	                me.setState({ dragnode: this });
	            });
	
	            temp.addEventListener("mouseout", function (e) {
	                // me.dragnode = undefined;
	            });
	
	            return temp;
	        }
	    }, {
	        key: "_createMenu",
	        value: function _createMenu(id, items, node, event) {
	            if (!items) {
	                return;
	            }
	            var e = event || window.event;
	            var me = this;
	            var child = document.getElementById(id);
	            if (child) {
	                child.parentNode.removeChild(child);
	            }
	
	            var wrapUl = document.createElement("ul");
	            wrapUl.setAttribute("id", id);
	            wrapUl.setAttribute("style", "position:fixed;top:" + e.clientY + "px;left:" + e.clientX + "px;width:100px;border-radius:3px;border:1px solid rgb(120, 120, 120);padding:0;margin:0;box-shadow:2px 2px 10px 0px rgb(200,200,200);font-size: 13px;");
	            for (var i = 0; i < items.length; i++) {
	                if (node.type === "01" && items[i].pk >= "7") {
	                    continue;
	                }
	                if (node.type === "99" && items[i].pk < "7") {
	                    continue;
	                }
	                if (node.type === "02" && items[i].pk < "7") {
	                    continue;
	                }
	                if (typeof this.over !== "undefined" && items[i].pk === "6") {
	                    continue;
	                }
	                var item = document.createElement("li");
	                item.setAttribute("style", "list-style-type:none;width:100px;background-color:rgb(240,240,240);");
	                var inneritem = document.createElement("a");
	                inneritem.onmouseover = function () {
	                    this.style.backgroundColor = "rgb(80,143,224)";
	                    this.style.color = "white";
	                };
	                inneritem.onmouseout = function () {
	                    this.style.backgroundColor = "rgb(240,240,240)";
	                    this.style.color = "";
	                };
	                inneritem.setAttribute("style", "margin:0 auto;border-bottom:1px solid rgb(210, 210, 210);display:block;width:100px;padding:2px 0 2px 2px;fontSize:14px;font-weight:400;background-color:rgb(240,240,240);");
	                inneritem.innerHTML = "<img src='" + items[i].img + "' style='height:25px;width:25px'/>" + items[i].text;
	                inneritem.func = items[i].func;
	                inneritem.onclick = function () {
	                    this.func(me);
	                    me._hideMenu("ctxmenu");
	                };
	                item.appendChild(inneritem);
	                wrapUl.appendChild(item);
	            }
	            document.body.appendChild(wrapUl);
	        }
	    }, {
	        key: "_showMenu",
	        value: function _showMenu(node, id, event) {
	            var e = event || window.event;
	            this._createMenu(id, this.state.contextmenu, node);
	        }
	    }, {
	        key: "_hideMenu",
	        value: function _hideMenu(id) {
	            if (document.getElementById(id)) {
	                document.getElementById(id).style.display = "none";
	            }
	        }
	        /** *
	         * 节点点击事件
	         */
	
	    }, {
	        key: "rclickFunc",
	        value: function rclickFunc(node) {
	            this.setState({ currnode: node });
	            this.setState({ currdata: node.data });
	        }
	    }, {
	        key: "clickFunc",
	        value: function clickFunc(node, wf) {
	            // var me=this;
	            // tool.sgiLogger.log(node);
	            // var oldnode = this.state.currnode;
	            wf.setState({ currnode: node });
	            wf.setState({ currdata: node.data });
	            // 显示编辑界面
	            wf.refs.NodeParaEdit.showDrawer(node);
	        }
	    }, {
	        key: "blankClickFunc",
	        value: function blankClickFunc() {
	            this.setState({ currnode: null });
	            // this.currnode = null;
	            this.refs.NodeParaEdit.onClose();
	            // this.dragnode =null;
	        }
	    }, {
	        key: "rmenuClick",
	        value: function rmenuClick(wf, type) {
	            var node = wf.state.currnode;
	            if (!node) {
	                alert("no selected node");
	                return;
	            }
	
	            if (type === "99" && typeof this.state.over !== "undefined") {
	                alert("已有结束节点，请使用跳转节点结束流程");
	                return;
	            }
	
	            var data = wf.newData(node, type);
	            var nexnode = node.createNextNode(data);
	
	            if (nexnode.parentsNode == null || typeof nexnode.parentsNode === "undefined") {
	                nexnode.parentsNode = [];
	            }
	            nexnode.parentsNode.push(node);
	            if (!node.data.childNode) {
	                node.data.childNode = [];
	            }
	            node.data.childNode.push(data);
	            if (type === "02") {
	                var chart = node.getChart();
	                chart.jumpLine(nexnode);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return (
	                // <div style={{ height:'790px',width: '100%' }} >
	                _react2.default.createElement(
	                    "div",
	                    { ref: "Workflow", style: { height: this.state.h, width: this.state.w } },
	                    _react2.default.createElement(
	                        _antd.Row,
	                        { style: { height: "90%", width: "100%" } },
	                        _react2.default.createElement(
	                            _antd.Col,
	                            { span: this.state.editpanelWidth, style: { height: "100%" } },
	                            _react2.default.createElement(
	                                "div",
	                                { id: this.state.editid, style: { backgroundColor: "#6c757d", height: "100%" } },
	                                _react2.default.createElement(
	                                    "canvas",
	                                    { id: this.state.canvasid, style: { height: "100%", backgroundColor: "#6c757d", width: "100%" } },
	                                    " "
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_NodeParaEdit2.default, { ref: "NodeParaEdit", node: this.state.currnode, nodedata: this.state.currdata }),
	                    this.state.debug ? _react2.default.createElement(
	                        _antd.Row,
	                        { style: { height: "10%", width: "100%" } },
	                        _react2.default.createElement(
	                            _antd.Button,
	                            { type: "primary", onClick: this.getData.bind(this) },
	                            "\u67E5\u770B\u6D41\u7A0B\u914D\u7F6E"
	                        ),
	                        _react2.default.createElement(
	                            _antd.Button,
	                            null,
	                            "\u6D4B\u8BD5\u6D41\u7A0B"
	                        )
	                    ) : ""
	                )
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var me = this;
	            if (!me.state.canvas) {
	                me.init();
	            }
	        }
	        // newData(node,type){
	        //     var x=50, y=30;
	        //     if (node) {
	        //         x = node.x + 150;
	        //         if (node.data.childNode) y = node.y + node.data.childNode.length * 70;
	        //         else y = node.y;
	        //     }
	        //     var data={
	        //         id: this.maxid++,
	        //         name: null,
	        //         type: type,
	        //         status: "00",
	        //         ann: null,
	        //         inCondition: null,
	        //         outCondition: null,
	        //         inConditionExp: null,
	        //         outConditionExp: null,
	        //         isfallback:"0",
	        //         fallback:null,
	        //         executionInterface:null, //处理界面
	        //         executionInterfaceparm:null,//界面启动参数
	        //         // isfallback:"0",
	        //         // isfallback:"0",
	        //         // isfallback:"0",
	        //         x: x,
	        //         y: y,
	        //         ishuman:"0",
	        //         human:[],
	        //         handling:[]};
	        //     if (type==="03") { // 服务节点
	        //         data.callin = []; // 服务输入参数列表
	        //         data.callbackin = []; // 回调接口服务输入参数列表
	        //         data.callout = []; // 服务输入参数列表
	        //         data.        = []; // 回调接口服务输入参数列表
	        //         data.calltype="0";
	        //         data.timeout=30;
	        //         data.protocol="0";
	        //         data.timeoutHandling="01";
	        //         data.redoTime=0;
	        //         data.redoCycle="01";
	        //         data.callbackUrl="";
	        //     }
	        //     if (type==="04") { // 脚本节点
	        //         data.scripttype = "0"; // 默认脚本类型为JavaScript
	        //         data.scriptcode="";//脚本内容
	        //         data.callin = []; // 服务输入参数列表
	        //         data.callout = []; // 回调接口服务输入参数列表
	        //     }
	        //     if (type==="06"){ // 任务节点
	        //         data.tasktype="01";
	        //         data.approvalstrategy="1";
	        //         data.approvalweight="100";
	        //         data.ismodiapproval="0";
	        //         data.isentrust="0";
	        //         data.isjump="0";
	        //         data.users = [];
	        //         data.overTimeoutUsers = [];
	        //         data.roles = [];
	        //         data.remindMode = [];
	        //         data.remindTime = "01";
	        //         data.remindCycle = "01";
	        //         data.receiveTimeout = 0;
	        //         data.receiveTimeoutHandling = "01";
	        //         data.overTimeout = 0;
	        //         data.overTimeoutHandling = "01";
	        //         data.userrule="0";
	        //     }
	
	        //     if (type==="99"){ // 结束节点
	
	        //         data.end="0";
	        //         data.endtype="0";
	        //         data.gototype="0";
	        //         data.gotoInterface=null; //处理界面
	        //         data.totoInterfaceparm=null;//界面启动参数
	
	
	        //         data.servicecallin = []; // 服务输入参数列表
	        //         data.servicecallbackin = []; // 回调接口服务输入参数列表
	        //         data.servicecallout = []; // 服务输入参数列表
	        //         data.servicecallbackout = []; // 回调接口服务输入参数列表
	        //         data.servicecalltype="0";
	        //         data.servicetimeout=30;
	        //         data.serviceprotocol="0";
	        //         data.servicetimeoutHandling="01";
	        //         data.serviceredoTime=0;
	        //         data.serviceredoCycle="01";
	        //         data.servicecallbackUrl="";
	
	
	        //         data.scripttype = "0"; // 默认脚本类型为JavaScript
	        //         data.scriptcode="";//脚本内容
	        //         data.scriptcallin = []; // 服务输入参数列表
	        //         data.scriptcallout = []; // 回调接口服务输入参数列表
	        //     }
	        //     return data;
	
	        // }
	
	    }, {
	        key: "newData",
	        value: function newData(node, type) {
	            var x = 50;var y = 30;
	            if (node) {
	                x = node.x + 150;
	                if (node.data.childNode) {
	                    y = node.y + node.data.childNode.length * 90;
	                } else {
	                    y = node.y;
	                }
	            }
	            var data = {
	                id: this.maxid++,
	                name: null,
	                type: type,
	                status: "00",
	                ann: null,
	                inCondition: null,
	                outCondition: null,
	                inConditionExp: null,
	                outConditionExp: null,
	                isfallback: "0",
	                fallback: null,
	                executionInterface: null, // 处理界面
	                executionInterfaceparm: null, // 界面启动参数
	                // isfallback:"0",
	                // isfallback:"0",
	                // isfallback:"0",
	                x: x,
	                y: y,
	                ishuman: "0",
	                human: [],
	                handling: []
	            };
	            if (type === "03") {
	                // 服务节点
	                data.servicecallin = []; // 服务输入参数列表
	                data.servicecallout = []; // 服务输入参数列表
	                data.servicecallbackin = []; // 回调接口服务输入参数列表
	                data.servicecallbackout = []; // 回调接口服务输入参数列表
	                data.serviceUrl = null;
	                data.servicecalltype = "0";
	                data.serviceAcynctype = "0";
	                data.servicetimeout = 30;
	                data.serviceprotocol = "0";
	                data.servicetimeoutHandling = "01";
	                data.serviceredoTime = 0;
	                data.serviceredoCycle = "01";
	                data.servicecallbackUrl = "";
	            }
	            if (type === "04") {
	                // 脚本节点
	                data.scripttype = "0"; // 默认脚本类型为JavaScript
	                data.scriptcode = ""; // 脚本内容
	                data.scriptcallin = []; // 服务输入参数列表
	                data.scriptcallout = []; // 回调接口服务输入参数列表
	            }
	            if (type === "06") {
	                // 任务节点
	                data.tasktype = "01";
	                data.approvalstrategy = "1";
	                data.approvalweight = "100";
	                data.ismodiapproval = "0";
	                data.isentrust = "0";
	                data.isjump = "0";
	                data.users = [];
	                data.overTimeoutUsers = [];
	                data.roles = [];
	                data.remindMode = [];
	                data.remindTime = "01";
	                data.remindCycle = "01";
	                data.receiveTimeout = 0;
	                data.receiveTimeoutHandling = "01";
	                data.overTimeout = 0;
	                data.overTimeoutHandling = "01";
	                data.userrule = "0";
	
	                data.orgkey = "";
	                data.orgtype = "";
	                data.rolekey = [];
	            }
	
	            if (type === "99") {
	                // 结束节点
	
	                data.end = "0";
	                data.endtype = "0";
	                data.gototype = "0";
	                data.gotoInterface = null; // 处理界面
	                data.totoInterfaceparm = null; // 界面启动参数
	
	
	                data.serviceUrl = null;
	                data.servicecallin = []; // 服务输入参数列表
	                data.servicecallbackin = []; // 回调接口服务输入参数列表
	                data.servicecallout = []; // 服务输入参数列表
	                data.servicecallbackout = []; // 回调接口服务输入参数列表
	                data.servicecalltype = "0";
	                data.serviceAcynctype = "0";
	                data.servicetimeout = 30;
	                data.serviceprotocol = "0";
	                data.servicetimeoutHandling = "01";
	                data.serviceredoTime = 0;
	                data.serviceredoCycle = "01";
	                data.servicecallbackUrl = "";
	
	                data.scripttype = "0"; // 默认脚本类型为JavaScript
	                data.scriptcode = ""; // 脚本内容
	                data.scriptcallin = []; // 服务输入参数列表
	                data.scriptcallout = []; // 回调接口服务输入参数列表
	            }
	            return data;
	        }
	    }, {
	        key: "cvtToJson",
	        value: function cvtToJson(root) {
	            if (!root) {
	                return;
	            }
	            var children = root.data.childNode;
	            if (!children) {
	                return;
	            }
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i].data;
	                if (child.type === "06") {
	                    var array = [];
	                    var us = child.users;
	                    if (us) {
	                        for (var j = 0; j < us.length; j++) {
	                            var u = us[j];
	                            array.push(u);
	                        }
	                        child.users = array;
	                    }
	                    var ps = child.posts;
	                    if (ps) {
	                        array = [];
	                        for (var j = 0; j < ps.length; j++) {
	                            var p = ps[j];
	                            array.push(p);
	                        }
	                        child.posts = array;
	                    }
	                } else {
	                    continue;
	                }
	                this.cvtToJson(child);
	            }
	        }
	    }, {
	        key: "getJson",
	        value: function getJson(root) {
	            if (!root) {
	                root = this.state.root.data;
	            }
	            var json = {};
	            json = root;
	            var children = root.childNode;
	            if (!children) {
	                return json;
	            }
	            json.childNode = [];
	            for (var i = 0; i < children.length; i++) {
	                json.childNode.push(this.getJson(children[i]));
	            }
	            return json;
	        }
	    }, {
	        key: "deleteEmptyProperty",
	        value: function deleteEmptyProperty(object) {
	            for (var i in object) {
	                var value = object[i];
	                if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
	                    if (Array.isArray(value)) {
	                        if (value.length == 0) {
	                            delete object[i];
	                            continue;
	                        }
	                    }
	                    this.deleteEmptyProperty(value);
	                    if (this.isEmpty(value)) {
	                        delete object[i];
	                    }
	                } else {
	                    if (value === "" || value === null || value === undefined) {
	                        delete object[i];
	                    } else {}
	                }
	            }
	        }
	    }, {
	        key: "isEmpty",
	        value: function isEmpty(object) {
	            for (var name in object) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: "getData",
	        value: function getData() {
	            var json = this.getJson();
	            // this.deleteEmptyProperty(json);
	            _antd.Modal.info({
	                title: "This is a notification message",
	                content: JSON.stringify(json),
	                onOk: function onOk() {}
	            });
	        }
	    }]);
	
	    return Workflow;
	}(_react.Component);
	
	exports.default = Workflow;

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.easeInOutCubic = easeInOutCubic;
	
	// eslint-disable-next-line import/prefer-default-export
	function easeInOutCubic(t, b, c, d) {
	  var cc = c - b;
	  t /= d / 2;
	
	  if (t < 1) {
	    return cc / 2 * t * t * t + b;
	  }
	
	  return cc / 2 * ((t -= 2) * t * t + 2) + b;
	}

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var isNumeric = function isNumeric(value) {
	  return !isNaN(parseFloat(value)) && isFinite(value);
	};
	
	var _default = isNumeric;
	exports["default"] = _default;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _cssAnimation = _interopRequireDefault(__webpack_require__(489));
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	/**
	 * Deprecated. We should replace the animation with pure react motion instead of modify style directly.
	 * If you are creating new component with animation, please use `./motion`.
	 */
	function animate(node, show, done) {
	  var height;
	  var requestAnimationFrameId;
	  return (0, _cssAnimation["default"])(node, 'ant-motion-collapse-legacy', {
	    start: function start() {
	      if (!show) {
	        node.style.height = "".concat(node.offsetHeight, "px");
	        node.style.opacity = '1';
	      } else {
	        height = node.offsetHeight;
	        node.style.height = '0px';
	        node.style.opacity = '0';
	      }
	    },
	    active: function active() {
	      if (requestAnimationFrameId) {
	        _raf["default"].cancel(requestAnimationFrameId);
	      }
	
	      requestAnimationFrameId = (0, _raf["default"])(function () {
	        node.style.height = "".concat(show ? height : 0, "px");
	        node.style.opacity = show ? '1' : '0';
	      });
	    },
	    end: function end() {
	      if (requestAnimationFrameId) {
	        _raf["default"].cancel(requestAnimationFrameId);
	      }
	
	      node.style.height = '';
	      node.style.opacity = '';
	      done();
	    }
	  });
	}
	
	var animation = {
	  enter: function enter(node, done) {
	    return animate(node, true, done);
	  },
	  leave: function leave(node, done) {
	    return animate(node, false, done);
	  },
	  appear: function appear(node, done) {
	    return animate(node, true, done);
	  }
	};
	var _default = animation;
	exports["default"] = _default;

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fillRef = fillRef;
	exports.composeRef = composeRef;
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function fillRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
	    ref.current = node;
	  }
	}
	
	function composeRef() {
	  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
	    refs[_key] = arguments[_key];
	  }
	
	  return function (node) {
	    refs.forEach(function (ref) {
	      fillRef(ref, node);
	    });
	  };
	}

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = throttleByAnimationFrame;
	exports.throttleByAnimationFrameDecorator = throttleByAnimationFrameDecorator;
	
	var _raf = _interopRequireDefault(__webpack_require__(87));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function throttleByAnimationFrame(fn) {
	  var requestId;
	
	  var later = function later(args) {
	    return function () {
	      requestId = null;
	      fn.apply(void 0, _toConsumableArray(args));
	    };
	  };
	
	  var throttled = function throttled() {
	    if (requestId == null) {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      requestId = (0, _raf["default"])(later(args));
	    }
	  };
	
	  throttled.cancel = function () {
	    return _raf["default"].cancel(requestId);
	  };
	
	  return throttled;
	}
	
	function throttleByAnimationFrameDecorator() {
	  // eslint-disable-next-line func-names
	  return function (target, key, descriptor) {
	    var fn = descriptor.value;
	    var definingProperty = false;
	    return {
	      configurable: true,
	      get: function get() {
	        // eslint-disable-next-line no-prototype-builtins
	        if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	          return fn;
	        }
	
	        var boundFn = throttleByAnimationFrame(fn.bind(this));
	        definingProperty = true;
	        Object.defineProperty(this, key, {
	          value: boundFn,
	          configurable: true,
	          writable: true
	        });
	        definingProperty = false;
	        return boundFn;
	      }
	    };
	  };
	}

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = triggerEvent;
	
	function triggerEvent(el, type) {
	  if ('createEvent' in document) {
	    // modern browsers, IE9+
	    var e = document.createEvent('HTMLEvents');
	    e.initEvent(type, false, true);
	    el.dispatchEvent(e);
	  }
	}

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTargetRect = getTargetRect;
	exports.getFixedTop = getFixedTop;
	exports.getFixedBottom = getFixedBottom;
	exports.getObserverEntities = getObserverEntities;
	exports.addObserveTarget = addObserveTarget;
	exports.removeObserveTarget = removeObserveTarget;
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function getTargetRect(target) {
	  return target !== window ? target.getBoundingClientRect() : {
	    top: 0,
	    bottom: window.innerHeight
	  };
	}
	
	function getFixedTop(placeholderReact, targetRect, offsetTop) {
	  if (offsetTop !== undefined && targetRect.top > placeholderReact.top - offsetTop) {
	    return offsetTop + targetRect.top;
	  }
	
	  return undefined;
	}
	
	function getFixedBottom(placeholderReact, targetRect, offsetBottom) {
	  if (offsetBottom !== undefined && targetRect.bottom < placeholderReact.bottom + offsetBottom) {
	    var targetBottomOffset = window.innerHeight - targetRect.bottom;
	    return offsetBottom + targetBottomOffset;
	  }
	
	  return undefined;
	} // ======================== Observer ========================
	
	
	var TRIGGER_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
	var observerEntities = [];
	
	function getObserverEntities() {
	  // Only used in test env. Can be removed if refactor.
	  return observerEntities;
	}
	
	function addObserveTarget(target, affix) {
	  if (!target) return;
	  var entity = observerEntities.find(function (item) {
	    return item.target === target;
	  });
	
	  if (entity) {
	    entity.affixList.push(affix);
	  } else {
	    entity = {
	      target: target,
	      affixList: [affix],
	      eventHandlers: {}
	    };
	    observerEntities.push(entity); // Add listener
	
	    TRIGGER_EVENTS.forEach(function (eventName) {
	      entity.eventHandlers[eventName] = (0, _addEventListener["default"])(target, eventName, function () {
	        entity.affixList.forEach(function (targetAffix) {
	          targetAffix.lazyUpdatePosition();
	        });
	      });
	    });
	  }
	}
	
	function removeObserveTarget(affix) {
	  var observerEntity = observerEntities.find(function (oriObserverEntity) {
	    var hasAffix = oriObserverEntity.affixList.some(function (item) {
	      return item === affix;
	    });
	
	    if (hasAffix) {
	      oriObserverEntity.affixList = oriObserverEntity.affixList.filter(function (item) {
	        return item !== affix;
	      });
	    }
	
	    return hasAffix;
	  });
	
	  if (observerEntity && observerEntity.affixList.length === 0) {
	    observerEntities = observerEntities.filter(function (item) {
	      return item !== observerEntity;
	    }); // Remove listener
	
	    TRIGGER_EVENTS.forEach(function (eventName) {
	      var handler = observerEntity.eventHandlers[eventName];
	
	      if (handler && handler.remove) {
	        handler.remove();
	      }
	    });
	  }
	}

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(84));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(731));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function noop() {}
	
	var Alert = /*#__PURE__*/function (_React$Component) {
	  _inherits(Alert, _React$Component);
	
	  var _super = _createSuper(Alert);
	
	  function Alert(props) {
	    var _this;
	
	    _classCallCheck(this, Alert);
	
	    _this = _super.call(this, props);
	
	    _this.handleClose = function (e) {
	      e.preventDefault();
	      var dom = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      dom.style.height = "".concat(dom.offsetHeight, "px"); // Magic code
	      // 重复一次后才能正确设置 height
	
	      dom.style.height = "".concat(dom.offsetHeight, "px");
	
	      _this.setState({
	        closing: true
	      });
	
	      (_this.props.onClose || noop)(e);
	    };
	
	    _this.animationEnd = function () {
	      _this.setState({
	        closing: false,
	        closed: true
	      });
	
	      (_this.props.afterClose || noop)();
	    };
	
	    _this.renderAlert = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          description = _this$props.description,
	          customizePrefixCls = _this$props.prefixCls,
	          message = _this$props.message,
	          closeText = _this$props.closeText,
	          banner = _this$props.banner,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          style = _this$props.style,
	          icon = _this$props.icon;
	      var _this$props2 = _this.props,
	          closable = _this$props2.closable,
	          type = _this$props2.type,
	          showIcon = _this$props2.showIcon,
	          iconType = _this$props2.iconType;
	      var _this$state = _this.state,
	          closing = _this$state.closing,
	          closed = _this$state.closed;
	      var prefixCls = getPrefixCls('alert', customizePrefixCls); // banner模式默认有 Icon
	
	      showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告
	
	      type = banner && type === undefined ? 'warning' : type || 'info';
	      var iconTheme = 'filled';
	
	      if (!iconType) {
	        switch (type) {
	          case 'success':
	            iconType = 'check-circle';
	            break;
	
	          case 'info':
	            iconType = 'info-circle';
	            break;
	
	          case 'error':
	            iconType = 'close-circle';
	            break;
	
	          case 'warning':
	            iconType = 'exclamation-circle';
	            break;
	
	          default:
	            iconType = 'default';
	        } // use outline icon in alert with description
	
	
	        if (description) {
	          iconTheme = 'outlined';
	        }
	      } // closeable when closeText is assigned
	
	
	      if (closeText) {
	        closable = true;
	      }
	
	      var alertCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-closing"), closing), _defineProperty(_classNames, "".concat(prefixCls, "-with-description"), !!description), _defineProperty(_classNames, "".concat(prefixCls, "-no-icon"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-banner"), !!banner), _defineProperty(_classNames, "".concat(prefixCls, "-closable"), closable), _classNames), className);
	      var closeIcon = closable ? /*#__PURE__*/React.createElement("button", {
	        type: "button",
	        onClick: _this.handleClose,
	        className: "".concat(prefixCls, "-close-icon"),
	        tabIndex: 0
	      }, closeText ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-text")
	      }, closeText) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close"
	      })) : null;
	      var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(_this.props);
	      var iconNode = icon && ( /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), _defineProperty({}, icon.props.className, icon.props.className))
	      }) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-icon")
	      }, icon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: iconType,
	        theme: iconTheme
	      });
	      return closed ? null : /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        component: "",
	        showProp: "data-show",
	        transitionName: "".concat(prefixCls, "-slide-up"),
	        onEnd: _this.animationEnd
	      }, /*#__PURE__*/React.createElement("div", _extends({
	        "data-show": !closing,
	        className: alertCls,
	        style: style
	      }, dataOrAriaProps), showIcon ? iconNode : null, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-message")
	      }, message), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-description")
	      }, description), closeIcon));
	    };
	
	    (0, _warning["default"])(!('iconType' in props), 'Alert', '`iconType` is deprecated. Please use `icon` instead.');
	    _this.state = {
	      closing: false,
	      closed: false
	    };
	    return _this;
	  }
	
	  _createClass(Alert, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAlert)
	      );
	    }
	  }]);
	
	  return Alert;
	}(React.Component);
	
	exports["default"] = Alert;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(84));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _affix = _interopRequireDefault(__webpack_require__(736));
	
	var _configProvider = __webpack_require__(15);
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(374));
	
	var _getScroll = _interopRequireDefault(__webpack_require__(373));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getDefaultContainer() {
	  return window;
	}
	
	function getOffsetTop(element, container) {
	  if (!element) {
	    return 0;
	  }
	
	  if (!element.getClientRects().length) {
	    return 0;
	  }
	
	  var rect = element.getBoundingClientRect();
	
	  if (rect.width || rect.height) {
	    if (container === window) {
	      container = element.ownerDocument.documentElement;
	      return rect.top - container.clientTop;
	    }
	
	    return rect.top - container.getBoundingClientRect().top;
	  }
	
	  return rect.top;
	}
	
	var sharpMatcherRegx = /#([^#]+)$/;
	
	var Anchor = /*#__PURE__*/function (_React$Component) {
	  _inherits(Anchor, _React$Component);
	
	  var _super = _createSuper(Anchor);
	
	  function Anchor() {
	    var _this;
	
	    _classCallCheck(this, Anchor);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      activeLink: null
	    };
	    _this.links = [];
	
	    _this.handleScrollTo = function (link) {
	      var _this$props = _this.props,
	          offsetTop = _this$props.offsetTop,
	          getContainer = _this$props.getContainer,
	          targetOffset = _this$props.targetOffset;
	
	      _this.setCurrentActiveLink(link);
	
	      var container = getContainer();
	      var scrollTop = (0, _getScroll["default"])(container, true);
	      var sharpLinkMatch = sharpMatcherRegx.exec(link);
	
	      if (!sharpLinkMatch) {
	        return;
	      }
	
	      var targetElement = document.getElementById(sharpLinkMatch[1]);
	
	      if (!targetElement) {
	        return;
	      }
	
	      var eleOffsetTop = getOffsetTop(targetElement, container);
	      var y = scrollTop + eleOffsetTop;
	      y -= targetOffset !== undefined ? targetOffset : offsetTop || 0;
	      _this.animating = true;
	      (0, _scrollTo["default"])(y, {
	        callback: function callback() {
	          _this.animating = false;
	        },
	        getContainer: getContainer
	      });
	    };
	
	    _this.saveInkNode = function (node) {
	      _this.inkNode = node;
	    };
	
	    _this.setCurrentActiveLink = function (link) {
	      var activeLink = _this.state.activeLink;
	      var onChange = _this.props.onChange;
	
	      if (activeLink !== link) {
	        _this.setState({
	          activeLink: link
	        });
	
	        if (onChange) {
	          onChange(link);
	        }
	      }
	    };
	
	    _this.handleScroll = function () {
	      if (_this.animating) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          offsetTop = _this$props2.offsetTop,
	          bounds = _this$props2.bounds,
	          targetOffset = _this$props2.targetOffset;
	
	      var currentActiveLink = _this.getCurrentAnchor(targetOffset !== undefined ? targetOffset : offsetTop || 0, bounds);
	
	      _this.setCurrentActiveLink(currentActiveLink);
	    };
	
	    _this.updateInk = function () {
	      if (typeof document === 'undefined') {
	        return;
	      }
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      var anchorNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var linkNode = anchorNode.getElementsByClassName("".concat(prefixCls, "-link-title-active"))[0];
	
	      if (linkNode) {
	        _this.inkNode.style.top = "".concat(linkNode.offsetTop + linkNode.clientHeight / 2 - 4.5, "px");
	      }
	    };
	
	    _this.renderAnchor = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props3 = _this.props,
	          customizePrefixCls = _this$props3.prefixCls,
	          _this$props3$classNam = _this$props3.className,
	          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
	          style = _this$props3.style,
	          offsetTop = _this$props3.offsetTop,
	          affix = _this$props3.affix,
	          showInkInFixed = _this$props3.showInkInFixed,
	          children = _this$props3.children,
	          getContainer = _this$props3.getContainer;
	      var activeLink = _this.state.activeLink;
	      var prefixCls = getPrefixCls('anchor', customizePrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      var inkClass = (0, _classnames["default"])("".concat(prefixCls, "-ink-ball"), {
	        visible: activeLink
	      });
	      var wrapperClass = (0, _classnames["default"])(className, "".concat(prefixCls, "-wrapper"));
	      var anchorClass = (0, _classnames["default"])(prefixCls, {
	        fixed: !affix && !showInkInFixed
	      });
	
	      var wrapperStyle = _extends({
	        maxHeight: offsetTop ? "calc(100vh - ".concat(offsetTop, "px)") : '100vh'
	      }, style);
	
	      var anchorContent = /*#__PURE__*/React.createElement("div", {
	        className: wrapperClass,
	        style: wrapperStyle
	      }, /*#__PURE__*/React.createElement("div", {
	        className: anchorClass
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-ink")
	      }, /*#__PURE__*/React.createElement("span", {
	        className: inkClass,
	        ref: _this.saveInkNode
	      })), children));
	      return !affix ? anchorContent : /*#__PURE__*/React.createElement(_affix["default"], {
	        offsetTop: offsetTop,
	        target: getContainer
	      }, anchorContent);
	    };
	
	    return _this;
	  }
	
	  _createClass(Anchor, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _this2 = this;
	
	      var antAnchor = {
	        registerLink: function registerLink(link) {
	          if (!_this2.links.includes(link)) {
	            _this2.links.push(link);
	          }
	        },
	        unregisterLink: function unregisterLink(link) {
	          var index = _this2.links.indexOf(link);
	
	          if (index !== -1) {
	            _this2.links.splice(index, 1);
	          }
	        },
	        activeLink: this.state.activeLink,
	        scrollTo: this.handleScrollTo,
	        onClick: this.props.onClick
	      };
	      return {
	        antAnchor: antAnchor
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var getContainer = this.props.getContainer;
	      this.scrollContainer = getContainer();
	      this.scrollEvent = (0, _addEventListener["default"])(this.scrollContainer, 'scroll', this.handleScroll);
	      this.handleScroll();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.scrollEvent) {
	        var getContainer = this.props.getContainer;
	        var currentContainer = getContainer();
	
	        if (this.scrollContainer !== currentContainer) {
	          this.scrollContainer = currentContainer;
	          this.scrollEvent.remove();
	          this.scrollEvent = (0, _addEventListener["default"])(this.scrollContainer, 'scroll', this.handleScroll);
	          this.handleScroll();
	        }
	      }
	
	      this.updateInk();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEvent) {
	        this.scrollEvent.remove();
	      }
	    }
	  }, {
	    key: "getCurrentAnchor",
	    value: function getCurrentAnchor() {
	      var offsetTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var bounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	      var getCurrentAnchor = this.props.getCurrentAnchor;
	
	      if (typeof getCurrentAnchor === 'function') {
	        return getCurrentAnchor();
	      }
	
	      var activeLink = '';
	
	      if (typeof document === 'undefined') {
	        return activeLink;
	      }
	
	      var linkSections = [];
	      var getContainer = this.props.getContainer;
	      var container = getContainer();
	      this.links.forEach(function (link) {
	        var sharpLinkMatch = sharpMatcherRegx.exec(link.toString());
	
	        if (!sharpLinkMatch) {
	          return;
	        }
	
	        var target = document.getElementById(sharpLinkMatch[1]);
	
	        if (target) {
	          var top = getOffsetTop(target, container);
	
	          if (top < offsetTop + bounds) {
	            linkSections.push({
	              link: link,
	              top: top
	            });
	          }
	        }
	      });
	
	      if (linkSections.length) {
	        var maxSection = linkSections.reduce(function (prev, curr) {
	          return curr.top > prev.top ? curr : prev;
	        });
	        return maxSection.link;
	      }
	
	      return '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAnchor)
	      );
	    }
	  }]);
	
	  return Anchor;
	}(React.Component);
	
	exports["default"] = Anchor;
	Anchor.defaultProps = {
	  affix: true,
	  showInkInFixed: false,
	  getContainer: getDefaultContainer
	};
	Anchor.childContextTypes = {
	  antAnchor: PropTypes.object
	};

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var AnchorLink = /*#__PURE__*/function (_React$Component) {
	  _inherits(AnchorLink, _React$Component);
	
	  var _super = _createSuper(AnchorLink);
	
	  function AnchorLink() {
	    var _this;
	
	    _classCallCheck(this, AnchorLink);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function (e) {
	      var _this$context$antAnch = _this.context.antAnchor,
	          scrollTo = _this$context$antAnch.scrollTo,
	          onClick = _this$context$antAnch.onClick;
	      var _this$props = _this.props,
	          href = _this$props.href,
	          title = _this$props.title;
	
	      if (onClick) {
	        onClick(e, {
	          title: title,
	          href: href
	        });
	      }
	
	      scrollTo(href);
	    };
	
	    _this.renderAnchorLink = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          href = _this$props2.href,
	          title = _this$props2.title,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          target = _this$props2.target;
	      var prefixCls = getPrefixCls('anchor', customizePrefixCls);
	      var active = _this.context.antAnchor.activeLink === href;
	      var wrapperClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-link"), _defineProperty({}, "".concat(prefixCls, "-link-active"), active));
	      var titleClassName = (0, _classnames["default"])("".concat(prefixCls, "-link-title"), _defineProperty({}, "".concat(prefixCls, "-link-title-active"), active));
	      return (/*#__PURE__*/React.createElement("div", {
	          className: wrapperClassName
	        }, /*#__PURE__*/React.createElement("a", {
	          className: titleClassName,
	          href: href,
	          title: typeof title === 'string' ? title : '',
	          target: target,
	          onClick: _this.handleClick
	        }, title), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(AnchorLink, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.context.antAnchor.registerLink(this.props.href);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref2) {
	      var prevHref = _ref2.href;
	      var href = this.props.href;
	
	      if (prevHref !== href) {
	        this.context.antAnchor.unregisterLink(prevHref);
	        this.context.antAnchor.registerLink(href);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.context.antAnchor.unregisterLink(this.props.href);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAnchorLink)
	      );
	    }
	  }]);
	
	  return AnchorLink;
	}(React.Component);
	
	AnchorLink.defaultProps = {
	  href: '#'
	};
	AnchorLink.contextTypes = {
	  antAnchor: PropTypes.object
	};
	(0, _reactLifecyclesCompat.polyfill)(AnchorLink);
	var _default = AnchorLink;
	exports["default"] = _default;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Anchor = _interopRequireDefault(__webpack_require__(1358));
	
	var _AnchorLink = _interopRequireDefault(__webpack_require__(1359));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Anchor["default"].Link = _AnchorLink["default"];
	var _default = _Anchor["default"];
	exports["default"] = _default;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var InputElement = /*#__PURE__*/function (_React$Component) {
	  _inherits(InputElement, _React$Component);
	
	  var _super = _createSuper(InputElement);
	
	  function InputElement() {
	    var _this;
	
	    _classCallCheck(this, InputElement);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveRef = function (ele) {
	      var childRef = _this.props.children.ref;
	
	      if (typeof childRef === 'function') {
	        childRef(ele);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(InputElement, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.cloneElement(this.props.children, _extends(_extends({}, this.props), {
	          ref: this.saveRef
	        }), null)
	      );
	    }
	  }]);
	
	  return InputElement;
	}(React.Component);
	
	exports["default"] = InputElement;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcSelect = __webpack_require__(191);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _InputElement = _interopRequireDefault(__webpack_require__(1361));
	
	var _input = _interopRequireDefault(__webpack_require__(257));
	
	var _select = _interopRequireDefault(__webpack_require__(208));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function isSelectOptionOrSelectOptGroup(child) {
	  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
	}
	
	var AutoComplete = /*#__PURE__*/function (_React$Component) {
	  _inherits(AutoComplete, _React$Component);
	
	  var _super = _createSuper(AutoComplete);
	
	  function AutoComplete() {
	    var _this;
	
	    _classCallCheck(this, AutoComplete);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveSelect = function (node) {
	      _this.select = node;
	    };
	
	    _this.getInputElement = function () {
	      var children = _this.props.children;
	      var element = children && /*#__PURE__*/React.isValidElement(children) && children.type !== _rcSelect.Option ? React.Children.only(_this.props.children) : /*#__PURE__*/React.createElement(_input["default"], null);
	
	      var elementProps = _extends({}, element.props); // https://github.com/ant-design/ant-design/pull/7742
	
	
	      delete elementProps.children;
	      return (/*#__PURE__*/React.createElement(_InputElement["default"], elementProps, element)
	      );
	    };
	
	    _this.renderAutoComplete = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          size = _this$props.size,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          notFoundContent = _this$props.notFoundContent,
	          optionLabelProp = _this$props.optionLabelProp,
	          dataSource = _this$props.dataSource,
	          children = _this$props.children;
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "".concat(prefixCls, "-show-search"), true), _defineProperty(_classNames, "".concat(prefixCls, "-auto-complete"), true), _classNames));
	      var options;
	      var childArray = React.Children.toArray(children);
	
	      if (childArray.length && isSelectOptionOrSelectOptGroup(childArray[0])) {
	        options = children;
	      } else {
	        options = dataSource ? dataSource.map(function (item) {
	          if ( /*#__PURE__*/React.isValidElement(item)) {
	            return item;
	          }
	
	          switch (_typeof(item)) {
	            case 'string':
	              return (/*#__PURE__*/React.createElement(_rcSelect.Option, {
	                  key: item
	                }, item)
	              );
	
	            case 'object':
	              return (/*#__PURE__*/React.createElement(_rcSelect.Option, {
	                  key: item.value
	                }, item.text)
	              );
	
	            default:
	              throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
	          }
	        }) : [];
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], _extends({}, _this.props, {
	          className: cls,
	          mode: _select["default"].SECRET_COMBOBOX_MODE_DO_NOT_USE,
	          optionLabelProp: optionLabelProp,
	          getInputElement: _this.getInputElement,
	          notFoundContent: notFoundContent,
	          ref: _this.saveSelect
	        }), options)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(AutoComplete, [{
	    key: "focus",
	    value: function focus() {
	      this.select.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.select.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAutoComplete)
	      );
	    }
	  }]);
	
	  return AutoComplete;
	}(React.Component);
	
	exports["default"] = AutoComplete;
	AutoComplete.Option = _rcSelect.Option;
	AutoComplete.OptGroup = _rcSelect.OptGroup;
	AutoComplete.defaultProps = {
	  transitionName: 'slide-up',
	  optionLabelProp: 'children',
	  choiceTransitionName: 'zoom',
	  showSearch: false,
	  filterOption: false
	};

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(92));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(15);
	
	var _getScroll = _interopRequireDefault(__webpack_require__(373));
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(374));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getDefaultTarget() {
	  return window;
	}
	
	var BackTop = /*#__PURE__*/function (_React$Component) {
	  _inherits(BackTop, _React$Component);
	
	  var _super = _createSuper(BackTop);
	
	  function BackTop(props) {
	    var _this;
	
	    _classCallCheck(this, BackTop);
	
	    _this = _super.call(this, props);
	
	    _this.scrollToTop = function (e) {
	      var _this$props = _this.props,
	          _this$props$target = _this$props.target,
	          target = _this$props$target === void 0 ? getDefaultTarget : _this$props$target,
	          onClick = _this$props.onClick;
	      (0, _scrollTo["default"])(0, {
	        getContainer: target
	      });
	
	      if (typeof onClick === 'function') {
	        onClick(e);
	      }
	    };
	
	    _this.handleScroll = function () {
	      var _this$props2 = _this.props,
	          visibilityHeight = _this$props2.visibilityHeight,
	          _this$props2$target = _this$props2.target,
	          target = _this$props2$target === void 0 ? getDefaultTarget : _this$props2$target;
	      var scrollTop = (0, _getScroll["default"])(target(), true);
	
	      _this.setState({
	        visible: scrollTop > visibilityHeight
	      });
	    };
	
	    _this.renderBackTop = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props3 = _this.props,
	          customizePrefixCls = _this$props3.prefixCls,
	          _this$props3$classNam = _this$props3.className,
	          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
	          children = _this$props3.children;
	      var prefixCls = getPrefixCls('back-top', customizePrefixCls);
	      var classString = (0, _classnames["default"])(prefixCls, className);
	      var defaultElement = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-icon")
	      })); // fix https://fb.me/react-unknown-prop
	
	      var divProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'children', 'visibilityHeight', 'target', 'visible']);
	      var visible = 'visible' in _this.props ? _this.props.visible : _this.state.visible;
	      var backTopBtn = visible ? /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        className: classString,
	        onClick: _this.scrollToTop
	      }), children || defaultElement) : null;
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "",
	          transitionName: "fade"
	        }, backTopBtn)
	      );
	    };
	
	    _this.state = {
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(BackTop, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var getTarget = this.props.target || getDefaultTarget;
	      this.scrollEvent = (0, _addEventListener["default"])(getTarget(), 'scroll', this.handleScroll);
	      this.handleScroll();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEvent) {
	        this.scrollEvent.remove();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBackTop)
	      );
	    }
	  }]);
	
	  return BackTop;
	}(React.Component);
	
	exports["default"] = BackTop;
	BackTop.defaultProps = {
	  visibilityHeight: 400
	};

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getNumberArray(num) {
	  return num ? num.toString().split('').reverse().map(function (i) {
	    var current = Number(i);
	    return isNaN(current) ? i : current;
	  }) : [];
	}
	
	function renderNumberList(position, className) {
	  var childrenToReturn = [];
	
	  for (var i = 0; i < 30; i++) {
	    childrenToReturn.push( /*#__PURE__*/React.createElement("p", {
	      key: i.toString(),
	      className: (0, _classnames["default"])(className, {
	        current: position === i
	      })
	    }, i % 10));
	  }
	
	  return childrenToReturn;
	}
	
	var ScrollNumber = /*#__PURE__*/function (_React$Component) {
	  _inherits(ScrollNumber, _React$Component);
	
	  var _super = _createSuper(ScrollNumber);
	
	  function ScrollNumber(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollNumber);
	
	    _this = _super.call(this, props);
	
	    _this.onAnimated = function () {
	      var onAnimated = _this.props.onAnimated;
	
	      if (onAnimated) {
	        onAnimated();
	      }
	    };
	
	    _this.renderScrollNumber = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          style = _this$props.style,
	          title = _this$props.title,
	          _this$props$component = _this$props.component,
	          component = _this$props$component === void 0 ? 'sup' : _this$props$component,
	          displayComponent = _this$props.displayComponent; // fix https://fb.me/react-unknown-prop
	
	      var restProps = (0, _omit["default"])(_this.props, ['count', 'onAnimated', 'component', 'prefixCls', 'displayComponent']);
	      var prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
	
	      var newProps = _extends(_extends({}, restProps), {
	        className: (0, _classnames["default"])(prefixCls, className),
	        title: title
	      }); // allow specify the border
	      // mock border-color by box-shadow for compatible with old usage:
	      // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
	
	
	      if (style && style.borderColor) {
	        newProps.style = _extends(_extends({}, style), {
	          boxShadow: "0 0 0 1px ".concat(style.borderColor, " inset")
	        });
	      }
	
	      if (displayComponent) {
	        return (/*#__PURE__*/React.cloneElement(displayComponent, {
	            className: (0, _classnames["default"])("".concat(prefixCls, "-custom-component"), displayComponent.props && displayComponent.props.className)
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(component, newProps, _this.renderNumberElement(prefixCls))
	      );
	    };
	
	    _this.state = {
	      animateStarted: true,
	      count: props.count
	    };
	    return _this;
	  }
	
	  _createClass(ScrollNumber, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      var _this2 = this;
	
	      this.lastCount = prevState.count;
	      var animateStarted = this.state.animateStarted;
	
	      if (animateStarted) {
	        this.clearTimeout(); // Let browser has time to reset the scroller before actually
	        // performing the transition.
	
	        this.timeout = setTimeout(function () {
	          // eslint-disable-next-line react/no-did-update-set-state
	          _this2.setState(function (__, props) {
	            return {
	              animateStarted: false,
	              count: props.count
	            };
	          }, _this2.onAnimated);
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearTimeout();
	    }
	  }, {
	    key: "getPositionByNum",
	    value: function getPositionByNum(num, i) {
	      var count = this.state.count;
	      var currentCount = Math.abs(Number(count));
	      var lastCount = Math.abs(Number(this.lastCount));
	      var currentDigit = Math.abs(getNumberArray(this.state.count)[i]);
	      var lastDigit = Math.abs(getNumberArray(this.lastCount)[i]);
	
	      if (this.state.animateStarted) {
	        return 10 + num;
	      } // 同方向则在同一侧切换数字
	
	
	      if (currentCount > lastCount) {
	        if (currentDigit >= lastDigit) {
	          return 10 + num;
	        }
	
	        return 20 + num;
	      }
	
	      if (currentDigit <= lastDigit) {
	        return 10 + num;
	      }
	
	      return num;
	    }
	  }, {
	    key: "renderCurrentNumber",
	    value: function renderCurrentNumber(prefixCls, num, i) {
	      if (typeof num === 'number') {
	        var position = this.getPositionByNum(num, i);
	        var removeTransition = this.state.animateStarted || getNumberArray(this.lastCount)[i] === undefined;
	        return (/*#__PURE__*/React.createElement('span', {
	            className: "".concat(prefixCls, "-only"),
	            style: {
	              transition: removeTransition ? 'none' : undefined,
	              msTransform: "translateY(".concat(-position * 100, "%)"),
	              WebkitTransform: "translateY(".concat(-position * 100, "%)"),
	              transform: "translateY(".concat(-position * 100, "%)")
	            },
	            key: i
	          }, renderNumberList(position, "".concat(prefixCls, "-only-unit")))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          key: "symbol",
	          className: "".concat(prefixCls, "-symbol")
	        }, num)
	      );
	    }
	  }, {
	    key: "renderNumberElement",
	    value: function renderNumberElement(prefixCls) {
	      var _this3 = this;
	
	      var count = this.state.count;
	
	      if (count && Number(count) % 1 === 0) {
	        return getNumberArray(count).map(function (num, i) {
	          return _this3.renderCurrentNumber(prefixCls, num, i);
	        }).reverse();
	      }
	
	      return count;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderScrollNumber)
	      );
	    }
	  }, {
	    key: "clearTimeout",
	    value: function (_clearTimeout) {
	      function clearTimeout() {
	        return _clearTimeout.apply(this, arguments);
	      }
	
	      clearTimeout.toString = function () {
	        return _clearTimeout.toString();
	      };
	
	      return clearTimeout;
	    }(function () {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = undefined;
	      }
	    })
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, nextState) {
	      if ('count' in nextProps) {
	        if (nextState.count === nextProps.count) {
	          return null;
	        }
	
	        return {
	          animateStarted: true
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScrollNumber;
	}(React.Component);
	
	ScrollNumber.defaultProps = {
	  count: null,
	  onAnimated: function onAnimated() {}
	};
	(0, _reactLifecyclesCompat.polyfill)(ScrollNumber);
	var _default = ScrollNumber;
	exports["default"] = _default;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _ScrollNumber = _interopRequireDefault(__webpack_require__(1364));
	
	var _colors = __webpack_require__(730);
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function isPresetColor(color) {
	  return _colors.PresetColorTypes.indexOf(color) !== -1;
	}
	
	var Badge = /*#__PURE__*/function (_React$Component) {
	  _inherits(Badge, _React$Component);
	
	  var _super = _createSuper(Badge);
	
	  function Badge() {
	    var _this;
	
	    _classCallCheck(this, Badge);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderBadge = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeScrollNumberPrefixCls = _a.scrollNumberPrefixCls,
	          children = _a.children,
	          status = _a.status,
	          text = _a.text,
	          color = _a.color,
	          restProps = __rest(_a, ["prefixCls", "scrollNumberPrefixCls", "children", "status", "text", "color"]);
	
	      var omitArr = ['count', 'showZero', 'overflowCount', 'className', 'style', 'dot', 'offset', 'title'];
	      var prefixCls = getPrefixCls('badge', customizePrefixCls);
	      var scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);
	
	      var scrollNumber = _this.renderBadgeNumber(prefixCls, scrollNumberPrefixCls);
	
	      var statusText = _this.renderStatusText(prefixCls);
	
	      var statusCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-status-dot"), _this.hasStatus()), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames));
	      var statusStyle = {};
	
	      if (color && !isPresetColor(color)) {
	        statusStyle.background = color;
	      } // <Badge status="success" />
	
	
	      if (!children && _this.hasStatus()) {
	        var styleWithOffset = _this.getStyleWithOffset();
	
	        var statusTextColor = styleWithOffset && styleWithOffset.color;
	        return (/*#__PURE__*/React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
	            className: _this.getBadgeClassName(prefixCls),
	            style: styleWithOffset
	          }), /*#__PURE__*/React.createElement("span", {
	            className: statusCls,
	            style: statusStyle
	          }), /*#__PURE__*/React.createElement("span", {
	            style: {
	              color: statusTextColor
	            },
	            className: "".concat(prefixCls, "-status-text")
	          }, text))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
	          className: _this.getBadgeClassName(prefixCls)
	        }), children, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "",
	          showProp: "data-show",
	          transitionName: children ? "".concat(prefixCls, "-zoom") : '',
	          transitionAppear: true
	        }, scrollNumber), statusText)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Badge, [{
	    key: "getNumberedDispayCount",
	    value: function getNumberedDispayCount() {
	      var _this$props = this.props,
	          count = _this$props.count,
	          overflowCount = _this$props.overflowCount;
	      var displayCount = count > overflowCount ? "".concat(overflowCount, "+") : count;
	      return displayCount;
	    }
	  }, {
	    key: "getDispayCount",
	    value: function getDispayCount() {
	      var isDot = this.isDot(); // dot mode don't need count
	
	      if (isDot) {
	        return '';
	      }
	
	      return this.getNumberedDispayCount();
	    }
	  }, {
	    key: "getScrollNumberTitle",
	    value: function getScrollNumberTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          count = _this$props2.count;
	
	      if (title) {
	        return title;
	      }
	
	      return typeof count === 'string' || typeof count === 'number' ? count : undefined;
	    }
	  }, {
	    key: "getStyleWithOffset",
	    value: function getStyleWithOffset() {
	      var _this$props3 = this.props,
	          offset = _this$props3.offset,
	          style = _this$props3.style;
	      return offset ? _extends({
	        right: -parseInt(offset[0], 10),
	        marginTop: offset[1]
	      }, style) : style;
	    }
	  }, {
	    key: "getBadgeClassName",
	    value: function getBadgeClassName(prefixCls) {
	      var _classNames2;
	
	      var _this$props4 = this.props,
	          className = _this$props4.className,
	          children = _this$props4.children;
	      return (0, _classnames["default"])(className, prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-status"), this.hasStatus()), _defineProperty(_classNames2, "".concat(prefixCls, "-not-a-wrapper"), !children), _classNames2));
	    }
	  }, {
	    key: "hasStatus",
	    value: function hasStatus() {
	      var _this$props5 = this.props,
	          status = _this$props5.status,
	          color = _this$props5.color;
	      return !!status || !!color;
	    }
	  }, {
	    key: "isZero",
	    value: function isZero() {
	      var numberedDispayCount = this.getNumberedDispayCount();
	      return numberedDispayCount === '0' || numberedDispayCount === 0;
	    }
	  }, {
	    key: "isDot",
	    value: function isDot() {
	      var dot = this.props.dot;
	      var isZero = this.isZero();
	      return dot && !isZero || this.hasStatus();
	    }
	  }, {
	    key: "isHidden",
	    value: function isHidden() {
	      var showZero = this.props.showZero;
	      var displayCount = this.getDispayCount();
	      var isZero = this.isZero();
	      var isDot = this.isDot();
	      var isEmpty = displayCount === null || displayCount === undefined || displayCount === '';
	      return (isEmpty || isZero && !showZero) && !isDot;
	    }
	  }, {
	    key: "renderStatusText",
	    value: function renderStatusText(prefixCls) {
	      var text = this.props.text;
	      var hidden = this.isHidden();
	      return hidden || !text ? null : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-status-text")
	      }, text);
	    }
	  }, {
	    key: "renderDispayComponent",
	    value: function renderDispayComponent() {
	      var count = this.props.count;
	      var customNode = count;
	
	      if (!customNode || _typeof(customNode) !== 'object') {
	        return undefined;
	      }
	
	      return (/*#__PURE__*/React.cloneElement(customNode, {
	          style: _extends(_extends({}, this.getStyleWithOffset()), customNode.props && customNode.props.style)
	        })
	      );
	    }
	  }, {
	    key: "renderBadgeNumber",
	    value: function renderBadgeNumber(prefixCls, scrollNumberPrefixCls) {
	      var _classNames3;
	
	      var _this$props6 = this.props,
	          status = _this$props6.status,
	          count = _this$props6.count,
	          color = _this$props6.color;
	      var displayCount = this.getDispayCount();
	      var isDot = this.isDot();
	      var hidden = this.isHidden();
	      var scrollNumberCls = (0, _classnames["default"])((_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-dot"), isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-count"), !isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-multiple-words"), !isDot && count && count.toString && count.toString().length > 1), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames3));
	      var statusStyle = this.getStyleWithOffset();
	
	      if (color && !isPresetColor(color)) {
	        statusStyle = statusStyle || {};
	        statusStyle.background = color;
	      }
	
	      return hidden ? null : /*#__PURE__*/React.createElement(_ScrollNumber["default"], {
	        prefixCls: scrollNumberPrefixCls,
	        "data-show": !hidden,
	        className: scrollNumberCls,
	        count: displayCount,
	        displayComponent: this.renderDispayComponent() // <Badge status="success" count={<Icon type="xxx" />}></Badge>
	
	        , title: this.getScrollNumberTitle(),
	        style: statusStyle,
	        key: "scrollNumber"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBadge)
	      );
	    }
	  }]);
	
	  return Badge;
	}(React.Component);
	
	exports["default"] = Badge;
	Badge.defaultProps = {
	  count: null,
	  showZero: false,
	  dot: false,
	  overflowCount: 99
	};
	Badge.propTypes = {
	  count: PropTypes.node,
	  showZero: PropTypes.bool,
	  dot: PropTypes.bool,
	  overflowCount: PropTypes.number
	};

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(738));
	
	var _menu = _interopRequireDefault(__webpack_require__(382));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getBreadcrumbName(route, params) {
	  if (!route.breadcrumbName) {
	    return null;
	  }
	
	  var paramsKeys = Object.keys(params).join('|');
	  var name = route.breadcrumbName.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function (replacement, key) {
	    return params[key] || replacement;
	  });
	  return name;
	}
	
	function defaultItemRender(route, params, routes, paths) {
	  var isLastItem = routes.indexOf(route) === routes.length - 1;
	  var name = getBreadcrumbName(route, params);
	  return isLastItem ? /*#__PURE__*/React.createElement("span", null, name) : /*#__PURE__*/React.createElement("a", {
	    href: "#/".concat(paths.join('/'))
	  }, name);
	}
	
	function filterFragment(children) {
	  return (0, _toArray["default"])(children).map(function (element) {
	    if ( /*#__PURE__*/React.isValidElement(element) && element.type === React.Fragment) {
	      var props = element.props;
	      return props.children;
	    }
	
	    return element;
	  });
	}
	
	var Breadcrumb = /*#__PURE__*/function (_React$Component) {
	  _inherits(Breadcrumb, _React$Component);
	
	  var _super = _createSuper(Breadcrumb);
	
	  function Breadcrumb() {
	    var _this;
	
	    _classCallCheck(this, Breadcrumb);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getPath = function (path, params) {
	      path = (path || '').replace(/^\//, '');
	      Object.keys(params).forEach(function (key) {
	        path = path.replace(":".concat(key), params[key]);
	      });
	      return path;
	    };
	
	    _this.addChildPath = function (paths) {
	      var childPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var params = arguments.length > 2 ? arguments[2] : undefined;
	
	      var originalPaths = _toConsumableArray(paths);
	
	      var path = _this.getPath(childPath, params);
	
	      if (path) {
	        originalPaths.push(path);
	      }
	
	      return originalPaths;
	    };
	
	    _this.genForRoutes = function (_ref) {
	      var _ref$routes = _ref.routes,
	          routes = _ref$routes === void 0 ? [] : _ref$routes,
	          _ref$params = _ref.params,
	          params = _ref$params === void 0 ? {} : _ref$params,
	          separator = _ref.separator,
	          _ref$itemRender = _ref.itemRender,
	          itemRender = _ref$itemRender === void 0 ? defaultItemRender : _ref$itemRender;
	      var paths = [];
	      return routes.map(function (route) {
	        var path = _this.getPath(route.path, params);
	
	        if (path) {
	          paths.push(path);
	        } // generated overlay by route.children
	
	
	        var overlay = null;
	
	        if (route.children && route.children.length) {
	          overlay = /*#__PURE__*/React.createElement(_menu["default"], null, route.children.map(function (child) {
	            return (/*#__PURE__*/React.createElement(_menu["default"].Item, {
	                key: child.breadcrumbName || child.path
	              }, itemRender(child, params, routes, _this.addChildPath(paths, child.path, params)))
	            );
	          }));
	        }
	
	        return (/*#__PURE__*/React.createElement(_BreadcrumbItem["default"], {
	            overlay: overlay,
	            separator: separator,
	            key: route.breadcrumbName || path
	          }, itemRender(route, params, routes, paths))
	        );
	      });
	    };
	
	    _this.renderBreadcrumb = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	      var crumbs;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          separator = _a.separator,
	          style = _a.style,
	          className = _a.className,
	          routes = _a.routes,
	          children = _a.children,
	          restProps = __rest(_a, ["prefixCls", "separator", "style", "className", "routes", "children"]);
	
	      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
	
	      if (routes && routes.length > 0) {
	        // generated by route
	        crumbs = _this.genForRoutes(_this.props);
	      } else if (children) {
	        crumbs = React.Children.map(filterFragment(children), function (element, index) {
	          if (!element) {
	            return element;
	          }
	
	          (0, _warning["default"])(element.type && (element.type.__ANT_BREADCRUMB_ITEM === true || element.type.__ANT_BREADCRUMB_SEPARATOR === true), 'Breadcrumb', "Only accepts Breadcrumb.Item and Breadcrumb.Separator as it's children");
	          return (/*#__PURE__*/React.cloneElement(element, {
	              separator: separator,
	              key: index
	            })
	          );
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: (0, _classnames["default"])(className, prefixCls),
	          style: style
	        }, (0, _omit["default"])(restProps, ['itemRender', 'params'])), crumbs)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Breadcrumb, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var props = this.props;
	      (0, _warning["default"])(!('linkRender' in props || 'nameRender' in props), 'Breadcrumb', '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumb)
	      );
	    }
	  }]);
	
	  return Breadcrumb;
	}(React.Component);
	
	exports["default"] = Breadcrumb;
	Breadcrumb.defaultProps = {
	  separator: '/'
	};
	Breadcrumb.propTypes = {
	  prefixCls: PropTypes.string,
	  separator: PropTypes.node,
	  routes: PropTypes.array
	};

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _configProvider = __webpack_require__(15);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var BreadcrumbSeparator = /*#__PURE__*/function (_React$Component) {
	  _inherits(BreadcrumbSeparator, _React$Component);
	
	  var _super = _createSuper(BreadcrumbSeparator);
	
	  function BreadcrumbSeparator() {
	    var _this;
	
	    _classCallCheck(this, BreadcrumbSeparator);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSeparator = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var children = _this.props.children;
	      var prefixCls = getPrefixCls('breadcrumb');
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-separator")
	        }, children || '/')
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(BreadcrumbSeparator, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSeparator)
	      );
	    }
	  }]);
	
	  return BreadcrumbSeparator;
	}(React.Component);
	
	exports["default"] = BreadcrumbSeparator;
	BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          size = props.size,
	          className = props.className,
	          others = __rest(props, ["prefixCls", "size", "className"]);
	
	      var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classes
	        }))
	      );
	    })
	  );
	};
	
	var _default = ButtonGroup;
	exports["default"] = _default;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _wave = _interopRequireDefault(__webpack_require__(376));
	
	var _type = __webpack_require__(83);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable react/button-has-type */
	
	var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
	var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
	
	function isString(str) {
	  return typeof str === 'string';
	} // Insert one space between two chinese characters automatically.
	
	
	function insertSpace(child, needInserted) {
	  // Check the child if is undefined or null.
	  if (child == null) {
	    return;
	  }
	
	  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.
	
	  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
	    return (/*#__PURE__*/React.cloneElement(child, {}, child.props.children.split('').join(SPACE))
	    );
	  }
	
	  if (typeof child === 'string') {
	    if (isTwoCNChar(child)) {
	      child = child.split('').join(SPACE);
	    }
	
	    return (/*#__PURE__*/React.createElement("span", null, child)
	    );
	  }
	
	  return child;
	}
	
	function spaceChildren(children, needInserted) {
	  var isPrevChildPure = false;
	  var childList = [];
	  React.Children.forEach(children, function (child) {
	    var type = _typeof(child);
	
	    var isCurrentChildPure = type === 'string' || type === 'number';
	
	    if (isPrevChildPure && isCurrentChildPure) {
	      var lastIndex = childList.length - 1;
	      var lastChild = childList[lastIndex];
	      childList[lastIndex] = "".concat(lastChild).concat(child);
	    } else {
	      childList.push(child);
	    }
	
	    isPrevChildPure = isCurrentChildPure;
	  }); // Pass to React.Children.map to auto fill key
	
	  return React.Children.map(childList, function (child) {
	    return insertSpace(child, needInserted);
	  });
	}
	
	var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
	var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline', 'round');
	var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
	var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');
	
	var Button = /*#__PURE__*/function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  var _super = _createSuper(Button);
	
	  function Button(props) {
	    var _this;
	
	    _classCallCheck(this, Button);
	
	    _this = _super.call(this, props);
	
	    _this.saveButtonRef = function (node) {
	      _this.buttonNode = node;
	    };
	
	    _this.handleClick = function (e) {
	      var loading = _this.state.loading;
	      var onClick = _this.props.onClick;
	
	      if (loading) {
	        return;
	      }
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.renderButton = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          shape = _a.shape,
	          size = _a.size,
	          className = _a.className,
	          children = _a.children,
	          icon = _a.icon,
	          ghost = _a.ghost,
	          block = _a.block,
	          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "block"]);
	
	      var _this$state = _this.state,
	          loading = _this$state.loading,
	          hasTwoCNChar = _this$state.hasTwoCNChar;
	      var prefixCls = getPrefixCls('btn', customizePrefixCls);
	      var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var iconType = loading ? 'loading' : icon;
	      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), !!loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
	      var iconNode = iconType ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType
	      }) : null;
	      var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
	      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType', 'loading']);
	
	      if (linkButtonRestProps.href !== undefined) {
	        return (/*#__PURE__*/React.createElement("a", _extends({}, linkButtonRestProps, {
	            className: classes,
	            onClick: _this.handleClick,
	            ref: _this.saveButtonRef
	          }), iconNode, kids)
	        );
	      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
	
	
	      var _b = rest,
	          htmlType = _b.htmlType,
	          otherProps = __rest(_b, ["htmlType"]);
	
	      var buttonNode = /*#__PURE__*/React.createElement("button", _extends({}, (0, _omit["default"])(otherProps, ['loading']), {
	        type: htmlType,
	        className: classes,
	        onClick: _this.handleClick,
	        ref: _this.saveButtonRef
	      }), iconNode, kids);
	
	      if (type === 'link') {
	        return buttonNode;
	      }
	
	      return (/*#__PURE__*/React.createElement(_wave["default"], null, buttonNode)
	      );
	    };
	
	    _this.state = {
	      loading: props.loading,
	      hasTwoCNChar: false
	    };
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fixTwoCNChar();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      this.fixTwoCNChar();
	
	      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
	        clearTimeout(this.delayTimeout);
	      }
	
	      var loading = this.props.loading;
	
	      if (loading && typeof loading !== 'boolean' && loading.delay) {
	        this.delayTimeout = window.setTimeout(function () {
	          _this2.setState({
	            loading: loading
	          });
	        }, loading.delay);
	      } else if (prevProps.loading !== loading) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          loading: loading
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.delayTimeout) {
	        clearTimeout(this.delayTimeout);
	      }
	    }
	  }, {
	    key: "fixTwoCNChar",
	    value: function fixTwoCNChar() {
	      // Fix for HOC usage like <FormatMessage />
	      if (!this.buttonNode) {
	        return;
	      }
	
	      var buttonText = this.buttonNode.textContent;
	
	      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
	        if (!this.state.hasTwoCNChar) {
	          this.setState({
	            hasTwoCNChar: true
	          });
	        }
	      } else if (this.state.hasTwoCNChar) {
	        this.setState({
	          hasTwoCNChar: false
	        });
	      }
	    }
	  }, {
	    key: "isNeedInserted",
	    value: function isNeedInserted() {
	      var _this$props = this.props,
	          icon = _this$props.icon,
	          children = _this$props.children,
	          type = _this$props.type;
	      return React.Children.count(children) === 1 && !icon && type !== 'link';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton)
	      );
	    }
	  }]);
	
	  return Button;
	}(React.Component);
	
	Button.__ANT_BUTTON = true;
	Button.defaultProps = {
	  loading: false,
	  ghost: false,
	  block: false,
	  htmlType: 'button'
	};
	Button.propTypes = {
	  type: PropTypes.string,
	  shape: PropTypes.oneOf(ButtonShapes),
	  size: PropTypes.oneOf(ButtonSizes),
	  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
	  onClick: PropTypes.func,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  className: PropTypes.string,
	  icon: PropTypes.string,
	  block: PropTypes.bool,
	  title: PropTypes.string
	};
	(0, _reactLifecyclesCompat.polyfill)(Button);
	var _default = Button;
	exports["default"] = _default;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _select = _interopRequireDefault(__webpack_require__(208));
	
	var _radio = __webpack_require__(258);
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Option = _select["default"].Option;
	
	function getMonthsLocale(value) {
	  var current = value.clone();
	  var localeData = value.localeData();
	  var months = [];
	
	  for (var i = 0; i < 12; i++) {
	    current.month(i);
	    months.push(localeData.monthsShort(current));
	  }
	
	  return months;
	}
	
	var Header = /*#__PURE__*/function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  var _super = _createSuper(Header);
	
	  function Header() {
	    var _this;
	
	    _classCallCheck(this, Header);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onYearChange = function (year) {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          validRange = _this$props.validRange;
	      var newValue = value.clone();
	      newValue.year(parseInt(year, 10)); // switch the month so that it remains within range when year changes
	
	      if (validRange) {
	        var _validRange = _slicedToArray(validRange, 2),
	            start = _validRange[0],
	            end = _validRange[1];
	
	        var newYear = newValue.get('year');
	        var newMonth = newValue.get('month');
	
	        if (newYear === end.get('year') && newMonth > end.get('month')) {
	          newValue.month(end.get('month'));
	        }
	
	        if (newYear === start.get('year') && newMonth < start.get('month')) {
	          newValue.month(start.get('month'));
	        }
	      }
	
	      var onValueChange = _this.props.onValueChange;
	
	      if (onValueChange) {
	        onValueChange(newValue);
	      }
	    };
	
	    _this.onMonthChange = function (month) {
	      var newValue = _this.props.value.clone();
	
	      newValue.month(parseInt(month, 10));
	      var onValueChange = _this.props.onValueChange;
	
	      if (onValueChange) {
	        onValueChange(newValue);
	      }
	    };
	
	    _this.onInternalTypeChange = function (e) {
	      _this.onTypeChange(e.target.value);
	    };
	
	    _this.onTypeChange = function (type) {
	      var onTypeChange = _this.props.onTypeChange;
	
	      if (onTypeChange) {
	        onTypeChange(type);
	      }
	    };
	
	    _this.getCalenderHeaderNode = function (node) {
	      _this.calenderHeaderNode = node;
	    };
	
	    _this.getMonthYearSelections = function (getPrefixCls) {
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          type = _this$props2.type,
	          value = _this$props2.value;
	      var prefixCls = getPrefixCls('fullcalendar', customizePrefixCls);
	
	      var yearReactNode = _this.getYearSelectElement(prefixCls, value.year());
	
	      var monthReactNode = type === 'month' ? _this.getMonthSelectElement(prefixCls, value.month(), getMonthsLocale(value)) : null;
	      return {
	        yearReactNode: yearReactNode,
	        monthReactNode: monthReactNode
	      };
	    };
	
	    _this.getTypeSwitch = function () {
	      var _this$props3 = _this.props,
	          _this$props3$locale = _this$props3.locale,
	          locale = _this$props3$locale === void 0 ? {} : _this$props3$locale,
	          type = _this$props3.type,
	          fullscreen = _this$props3.fullscreen;
	      var size = fullscreen ? 'default' : 'small';
	      return (/*#__PURE__*/React.createElement(_radio.Group, {
	          onChange: _this.onInternalTypeChange,
	          value: type,
	          size: size
	        }, /*#__PURE__*/React.createElement(_radio.Button, {
	          value: "month"
	        }, locale.month), /*#__PURE__*/React.createElement(_radio.Button, {
	          value: "year"
	        }, locale.year))
	      );
	    };
	
	    _this.headerRenderCustom = function (headerRender) {
	      var _this$props4 = _this.props,
	          type = _this$props4.type,
	          onValueChange = _this$props4.onValueChange,
	          value = _this$props4.value;
	      return headerRender({
	        value: value,
	        type: type || 'month',
	        onChange: onValueChange,
	        onTypeChange: _this.onTypeChange
	      });
	    };
	
	    _this.renderHeader = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props5 = _this.props,
	          prefixCls = _this$props5.prefixCls,
	          headerRender = _this$props5.headerRender;
	
	      var typeSwitch = _this.getTypeSwitch();
	
	      var _this$getMonthYearSel = _this.getMonthYearSelections(getPrefixCls),
	          yearReactNode = _this$getMonthYearSel.yearReactNode,
	          monthReactNode = _this$getMonthYearSel.monthReactNode;
	
	      return headerRender ? _this.headerRenderCustom(headerRender) : /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-header"),
	        ref: _this.getCalenderHeaderNode
	      }, yearReactNode, monthReactNode, typeSwitch);
	    };
	
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "getYearSelectElement",
	    value: function getYearSelectElement(prefixCls, year) {
	      var _this2 = this;
	
	      var _this$props6 = this.props,
	          yearSelectOffset = _this$props6.yearSelectOffset,
	          yearSelectTotal = _this$props6.yearSelectTotal,
	          _this$props6$locale = _this$props6.locale,
	          locale = _this$props6$locale === void 0 ? {} : _this$props6$locale,
	          fullscreen = _this$props6.fullscreen,
	          validRange = _this$props6.validRange;
	      var start = year - yearSelectOffset;
	      var end = start + yearSelectTotal;
	
	      if (validRange) {
	        start = validRange[0].get('year');
	        end = validRange[1].get('year') + 1;
	      }
	
	      var suffix = locale.year === '年' ? '年' : '';
	      var options = [];
	
	      for (var index = start; index < end; index++) {
	        options.push( /*#__PURE__*/React.createElement(Option, {
	          key: "".concat(index)
	        }, index + suffix));
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], {
	          size: fullscreen ? 'default' : 'small',
	          dropdownMatchSelectWidth: false,
	          className: "".concat(prefixCls, "-year-select"),
	          onChange: this.onYearChange,
	          value: String(year),
	          getPopupContainer: function getPopupContainer() {
	            return _this2.calenderHeaderNode;
	          }
	        }, options)
	      );
	    }
	  }, {
	    key: "getMonthSelectElement",
	    value: function getMonthSelectElement(prefixCls, month, months) {
	      var _this3 = this;
	
	      var _this$props7 = this.props,
	          fullscreen = _this$props7.fullscreen,
	          validRange = _this$props7.validRange,
	          value = _this$props7.value;
	      var options = [];
	      var start = 0;
	      var end = 12;
	
	      if (validRange) {
	        var _validRange2 = _slicedToArray(validRange, 2),
	            rangeStart = _validRange2[0],
	            rangeEnd = _validRange2[1];
	
	        var currentYear = value.get('year');
	
	        if (rangeEnd.get('year') === currentYear) {
	          end = rangeEnd.get('month') + 1;
	        }
	
	        if (rangeStart.get('year') === currentYear) {
	          start = rangeStart.get('month');
	        }
	      }
	
	      for (var index = start; index < end; index++) {
	        options.push( /*#__PURE__*/React.createElement(Option, {
	          key: "".concat(index)
	        }, months[index]));
	      }
	
	      return (/*#__PURE__*/React.createElement(_select["default"], {
	          size: fullscreen ? 'default' : 'small',
	          dropdownMatchSelectWidth: false,
	          className: "".concat(prefixCls, "-month-select"),
	          value: String(month),
	          onChange: this.onMonthChange,
	          getPopupContainer: function getPopupContainer() {
	            return _this3.calenderHeaderNode;
	          }
	        }, options)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderHeader)
	      );
	    }
	  }]);
	
	  return Header;
	}(React.Component);
	
	exports["default"] = Header;
	Header.defaultProps = {
	  yearSelectOffset: 10,
	  yearSelectTotal: 20
	};

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _FullCalendar = _interopRequireDefault(__webpack_require__(460));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _Header = _interopRequireDefault(__webpack_require__(1370));
	
	var _en_US = _interopRequireDefault(__webpack_require__(740));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _configProvider = __webpack_require__(15);
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function noop() {
	  return null;
	}
	
	function zerofixed(v) {
	  if (v < 10) {
	    return "0".concat(v);
	  }
	
	  return "".concat(v);
	}
	
	var Calendar = /*#__PURE__*/function (_React$Component) {
	  _inherits(Calendar, _React$Component);
	
	  var _super = _createSuper(Calendar);
	
	  function Calendar(props) {
	    var _this;
	
	    _classCallCheck(this, Calendar);
	
	    _this = _super.call(this, props);
	
	    _this.onHeaderValueChange = function (value) {
	      _this.setValue(value, 'changePanel');
	    };
	
	    _this.onHeaderTypeChange = function (mode) {
	      _this.setState({
	        mode: mode
	      });
	
	      _this.onPanelChange(_this.state.value, mode);
	    };
	
	    _this.onSelect = function (value) {
	      _this.setValue(value, 'select');
	    };
	
	    _this.setValue = function (value, way) {
	      var prevValue = _this.props.value || _this.state.value;
	      var mode = _this.state.mode;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      if (way === 'select') {
	        if (prevValue && prevValue.month() !== value.month()) {
	          _this.onPanelChange(value, mode);
	        }
	
	        if (_this.props.onSelect) {
	          _this.props.onSelect(value);
	        }
	      } else if (way === 'changePanel') {
	        _this.onPanelChange(value, mode);
	      }
	    };
	
	    _this.getDateRange = function (validRange, disabledDate) {
	      return function (current) {
	        if (!current) {
	          return false;
	        }
	
	        var _validRange = _slicedToArray(validRange, 2),
	            startDate = _validRange[0],
	            endDate = _validRange[1];
	
	        var inRange = !current.isBetween(startDate, endDate, 'days', '[]');
	
	        if (disabledDate) {
	          return disabledDate(current) || inRange;
	        }
	
	        return inRange;
	      };
	    };
	
	    _this.getDefaultLocale = function () {
	      var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	      result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
	      return result;
	    };
	
	    _this.monthCellRender = function (value) {
	      var _this$props$monthCell = _this.props.monthCellRender,
	          monthCellRender = _this$props$monthCell === void 0 ? noop : _this$props$monthCell;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-month")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-value")
	        }, value.localeData().monthsShort(value)), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, monthCellRender(value)))
	      );
	    };
	
	    _this.dateCellRender = function (value) {
	      var _this$props$dateCellR = _this.props.dateCellRender,
	          dateCellRender = _this$props$dateCellR === void 0 ? noop : _this$props$dateCellR;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize2.prefixCls;
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-date")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-value")
	        }, zerofixed(value.date())), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, dateCellRender(value)))
	      );
	    };
	
	    _this.renderCalendar = function (locale, localeCode) {
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          state = _assertThisInitialize3.state,
	          props = _assertThisInitialize3.props;
	
	      var value = state.value,
	          mode = state.mode;
	
	      if (value && localeCode) {
	        value.locale(localeCode);
	      }
	
	      var customizePrefixCls = props.prefixCls,
	          style = props.style,
	          className = props.className,
	          fullscreen = props.fullscreen,
	          headerRender = props.headerRender,
	          dateFullCellRender = props.dateFullCellRender,
	          monthFullCellRender = props.monthFullCellRender;
	      var monthCellRender = monthFullCellRender || _this.monthCellRender;
	      var dateCellRender = dateFullCellRender || _this.dateCellRender;
	      var disabledDate = props.disabledDate;
	
	      if (props.validRange) {
	        disabledDate = _this.getDateRange(props.validRange, disabledDate);
	      }
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	          var getPrefixCls = _ref.getPrefixCls;
	          var prefixCls = getPrefixCls('fullcalendar', customizePrefixCls); // To support old version react.
	          // Have to add prefixCls on the instance.
	          // https://github.com/facebook/react/issues/12397
	
	          _this.prefixCls = prefixCls;
	          var cls = className || '';
	
	          if (fullscreen) {
	            cls += " ".concat(prefixCls, "-fullscreen");
	          }
	
	          return (/*#__PURE__*/React.createElement("div", {
	              className: cls,
	              style: style
	            }, /*#__PURE__*/React.createElement(_Header["default"], {
	              fullscreen: fullscreen,
	              type: mode,
	              headerRender: headerRender,
	              value: value,
	              locale: locale.lang,
	              prefixCls: prefixCls,
	              onTypeChange: _this.onHeaderTypeChange,
	              onValueChange: _this.onHeaderValueChange,
	              validRange: props.validRange
	            }), /*#__PURE__*/React.createElement(_FullCalendar["default"], _extends({}, props, {
	              disabledDate: disabledDate,
	              Select: noop,
	              locale: locale.lang,
	              type: mode === 'year' ? 'month' : 'date',
	              prefixCls: prefixCls,
	              showHeader: false,
	              value: value,
	              monthCellRender: monthCellRender,
	              dateCellRender: dateCellRender,
	              onSelect: _this.onSelect
	            })))
	          );
	        })
	      );
	    };
	
	    var value = props.value || props.defaultValue || (0, _interopDefault["default"])(moment)();
	
	    if (!(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of Calendar must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/calendar-value');
	    }
	
	    _this.state = {
	      value: value,
	      mode: props.mode || 'month'
	    };
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: "onPanelChange",
	    value: function onPanelChange(value, mode) {
	      var _this$props = this.props,
	          onPanelChange = _this$props.onPanelChange,
	          onChange = _this$props.onChange;
	
	      if (onPanelChange) {
	        onPanelChange(value, mode);
	      }
	
	      if (onChange && value !== this.state.value) {
	        onChange(value);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Calendar",
	          defaultLocale: this.getDefaultLocale
	        }, this.renderCalendar)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	
	      if ('value' in nextProps) {
	        newState.value = nextProps.value;
	      }
	
	      if ('mode' in nextProps) {
	        newState.mode = nextProps.mode;
	      }
	
	      return Object.keys(newState).length > 0 ? newState : null;
	    }
	  }]);
	
	  return Calendar;
	}(React.Component);
	
	Calendar.defaultProps = {
	  locale: {},
	  fullscreen: true,
	  onSelect: noop,
	  onPanelChange: noop,
	  onChange: noop
	};
	Calendar.propTypes = {
	  monthCellRender: PropTypes.func,
	  dateCellRender: PropTypes.func,
	  monthFullCellRender: PropTypes.func,
	  dateFullCellRender: PropTypes.func,
	  fullscreen: PropTypes.bool,
	  locale: PropTypes.object,
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  style: PropTypes.object,
	  onPanelChange: PropTypes.func,
	  value: PropTypes.object,
	  onSelect: PropTypes.func,
	  onChange: PropTypes.func,
	  headerRender: PropTypes.func
	};
	(0, _reactLifecyclesCompat.polyfill)(Calendar);
	var _default = Calendar;
	exports["default"] = _default;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Grid = function Grid(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          _props$hoverable = props.hoverable,
	          hoverable = _props$hoverable === void 0 ? true : _props$hoverable,
	          others = __rest(props, ["prefixCls", "className", "hoverable"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-grid"), className, _defineProperty({}, "".concat(prefixCls, "-grid-hoverable"), hoverable));
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }))
	      );
	    })
	  );
	};
	
	var _default = Grid;
	exports["default"] = _default;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Meta = function Meta(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          avatar = props.avatar,
	          title = props.title,
	          description = props.description,
	          others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-meta"), className);
	      var avatarDom = avatar ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-avatar")
	      }, avatar) : null;
	      var titleDom = title ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-title")
	      }, title) : null;
	      var descriptionDom = description ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-description")
	      }, description) : null;
	      var MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-meta-detail")
	      }, titleDom, descriptionDom) : null;
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }), avatarDom, MetaDetail)
	      );
	    })
	  );
	};
	
	var _default = Meta;
	exports["default"] = _default;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Grid = _interopRequireDefault(__webpack_require__(1372));
	
	var _Meta = _interopRequireDefault(__webpack_require__(1373));
	
	var _tabs = _interopRequireDefault(__webpack_require__(760));
	
	var _row = _interopRequireDefault(__webpack_require__(757));
	
	var _col = _interopRequireDefault(__webpack_require__(742));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getAction(actions) {
	  var actionList = actions.map(function (action, index) {
	    return (
	      /*#__PURE__*/
	      // eslint-disable-next-line react/no-array-index-key
	      React.createElement("li", {
	        style: {
	          width: "".concat(100 / actions.length, "%")
	        },
	        key: "action-".concat(index)
	      }, /*#__PURE__*/React.createElement("span", null, action))
	    );
	  });
	  return actionList;
	}
	
	var Card = /*#__PURE__*/function (_React$Component) {
	  _inherits(Card, _React$Component);
	
	  var _super = _createSuper(Card);
	
	  function Card() {
	    var _this;
	
	    _classCallCheck(this, Card);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onTabChange = function (key) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(key);
	      }
	    };
	
	    _this.renderCard = function (_ref) {
	      var _classNames, _extraProps;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          extra = _a.extra,
	          _a$headStyle = _a.headStyle,
	          headStyle = _a$headStyle === void 0 ? {} : _a$headStyle,
	          _a$bodyStyle = _a.bodyStyle,
	          bodyStyle = _a$bodyStyle === void 0 ? {} : _a$bodyStyle,
	          title = _a.title,
	          loading = _a.loading,
	          _a$bordered = _a.bordered,
	          bordered = _a$bordered === void 0 ? true : _a$bordered,
	          _a$size = _a.size,
	          size = _a$size === void 0 ? 'default' : _a$size,
	          type = _a.type,
	          cover = _a.cover,
	          actions = _a.actions,
	          tabList = _a.tabList,
	          children = _a.children,
	          activeTabKey = _a.activeTabKey,
	          defaultActiveTabKey = _a.defaultActiveTabKey,
	          tabBarExtraContent = _a.tabBarExtraContent,
	          others = __rest(_a, ["prefixCls", "className", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-hoverable"), _this.getCompatibleHoverable()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-grid"), _this.isContainGrid()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-type-").concat(type), !!type), _classNames));
	      var loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? {
	        padding: 24
	      } : undefined;
	      var loadingBlock = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-content"),
	        style: loadingBlockStyle
	      }, /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 22
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 8
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 15
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 6
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 18
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 13
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 9
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 4
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 3
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 16
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))));
	      var hasActiveTabKey = activeTabKey !== undefined;
	      var extraProps = (_extraProps = {}, _defineProperty(_extraProps, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey), _defineProperty(_extraProps, "tabBarExtraContent", tabBarExtraContent), _extraProps);
	      var head;
	      var tabs = tabList && tabList.length ? /*#__PURE__*/React.createElement(_tabs["default"], _extends({}, extraProps, {
	        className: "".concat(prefixCls, "-head-tabs"),
	        size: "large",
	        onChange: _this.onTabChange
	      }), tabList.map(function (item) {
	        return (/*#__PURE__*/React.createElement(_tabs["default"].TabPane, {
	            tab: item.tab,
	            disabled: item.disabled,
	            key: item.key
	          })
	        );
	      })) : null;
	
	      if (title || extra || tabs) {
	        head = /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head"),
	          style: headStyle
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head-wrapper")
	        }, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head-title")
	        }, title), extra && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-extra")
	        }, extra)), tabs);
	      }
	
	      var coverDom = cover ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-cover")
	      }, cover) : null;
	      var body = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body"),
	        style: bodyStyle
	      }, loading ? loadingBlock : children);
	      var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-actions")
	      }, getAction(actions)) : null;
	      var divProps = (0, _omit["default"])(others, ['onTabChange', 'noHovering', 'hoverable']);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	          className: classString
	        }), head, coverDom, body, actionDom)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if ('noHovering' in this.props) {
	        (0, _warning["default"])(!this.props.noHovering, 'Card', '`noHovering` is deprecated, you can remove it safely or use `hoverable` instead.');
	        (0, _warning["default"])(!!this.props.noHovering, 'Card', '`noHovering={false}` is deprecated, use `hoverable` instead.');
	      }
	    } // For 2.x compatible
	
	  }, {
	    key: "getCompatibleHoverable",
	    value: function getCompatibleHoverable() {
	      var _this$props = this.props,
	          noHovering = _this$props.noHovering,
	          hoverable = _this$props.hoverable;
	
	      if ('noHovering' in this.props) {
	        return !noHovering || hoverable;
	      }
	
	      return !!hoverable;
	    }
	  }, {
	    key: "isContainGrid",
	    value: function isContainGrid() {
	      var containGrid;
	      React.Children.forEach(this.props.children, function (element) {
	        if (element && element.type && element.type === _Grid["default"]) {
	          containGrid = true;
	        }
	      });
	      return containGrid;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCard)
	      );
	    }
	  }]);
	
	  return Card;
	}(React.Component);
	
	exports["default"] = Card;
	Card.Grid = _Grid["default"];
	Card.Meta = _Meta["default"];

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	} // Use require over import (will be lifted up)
	// make sure matchMedia polyfill run before require('react-slick')
	// Fix https://github.com/ant-design/ant-design/issues/6560
	// Fix https://github.com/ant-design/ant-design/issues/3308
	
	
	var SlickCarousel = __webpack_require__(487)["default"];
	
	var Carousel = /*#__PURE__*/function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  var _super = _createSuper(Carousel);
	
	  function Carousel(props) {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _super.call(this, props);
	
	    _this.saveSlick = function (node) {
	      _this.slick = node;
	    };
	
	    _this.onWindowResized = function () {
	      // Fix https://github.com/ant-design/ant-design/issues/2550
	      var autoplay = _this.props.autoplay;
	
	      if (autoplay && _this.slick && _this.slick.innerSlider && _this.slick.innerSlider.autoPlay) {
	        _this.slick.innerSlider.autoPlay();
	      }
	    };
	
	    _this.renderCarousel = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var props = _extends({}, _this.props);
	
	      if (props.effect === 'fade') {
	        props.fade = true;
	      }
	
	      var className = getPrefixCls('carousel', props.prefixCls);
	      var dotsClass = 'slick-dots';
	
	      var dotPosition = _this.getDotPosition();
	
	      props.vertical = dotPosition === 'left' || dotPosition === 'right';
	      props.dotsClass = "".concat(dotsClass, " ").concat(dotsClass, "-").concat(dotPosition || 'bottom');
	
	      if (props.vertical) {
	        className = "".concat(className, " ").concat(className, "-vertical");
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className
	        }, /*#__PURE__*/React.createElement(SlickCarousel, _extends({
	          ref: _this.saveSlick
	        }, props)))
	      );
	    };
	
	    _this.onWindowResized = (0, _debounce["default"])(_this.onWindowResized, 500, {
	      leading: false
	    });
	
	    if ('vertical' in _this.props) {
	      (0, _warning["default"])(!_this.props.vertical, 'Carousel', '`vertical` is deprecated, please use `dotPosition` instead.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var autoplay = this.props.autoplay;
	
	      if (autoplay) {
	        window.addEventListener('resize', this.onWindowResized);
	      } // https://github.com/ant-design/ant-design/issues/7191
	
	
	      this.innerSlider = this.slick && this.slick.innerSlider;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (React.Children.count(this.props.children) !== React.Children.count(prevProps.children)) {
	        this.goTo(this.props.initialSlide || 0, false);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var autoplay = this.props.autoplay;
	
	      if (autoplay) {
	        window.removeEventListener('resize', this.onWindowResized);
	        this.onWindowResized.cancel();
	      }
	    }
	  }, {
	    key: "getDotPosition",
	    value: function getDotPosition() {
	      if (this.props.dotPosition) {
	        return this.props.dotPosition;
	      }
	
	      if ('vertical' in this.props) {
	        return this.props.vertical ? 'right' : 'bottom';
	      }
	
	      return 'bottom';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      this.slick.slickNext();
	    }
	  }, {
	    key: "prev",
	    value: function prev() {
	      this.slick.slickPrev();
	    }
	  }, {
	    key: "goTo",
	    value: function goTo(slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      this.slick.slickGoTo(slide, dontAnimate);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCarousel)
	      );
	    }
	  }]);
	
	  return Carousel;
	}(React.Component);
	
	exports["default"] = Carousel;
	Carousel.defaultProps = {
	  dots: true,
	  arrows: false,
	  draggable: false
	};

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcCascader = _interopRequireDefault(__webpack_require__(462));
	
	var _arrayTreeFilter = _interopRequireDefault(__webpack_require__(488));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _input = _interopRequireDefault(__webpack_require__(257));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// We limit the filtered item count by default
	var defaultLimit = 50;
	
	function highlightKeyword(str, keyword, prefixCls) {
	  return str.split(keyword).map(function (node, index) {
	    return index === 0 ? node : [/*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-menu-item-keyword"),
	      key: "seperator"
	    }, keyword), node];
	  });
	}
	
	function defaultFilterOption(inputValue, path, names) {
	  return path.some(function (option) {
	    return option[names.label].indexOf(inputValue) > -1;
	  });
	}
	
	function defaultRenderFilteredOption(inputValue, path, prefixCls, names) {
	  return path.map(function (option, index) {
	    var label = option[names.label];
	    var node = label.indexOf(inputValue) > -1 ? highlightKeyword(label, inputValue, prefixCls) : label;
	    return index === 0 ? node : [' / ', node];
	  });
	}
	
	function defaultSortFilteredOption(a, b, inputValue, names) {
	  function callback(elem) {
	    return elem[names.label].indexOf(inputValue) > -1;
	  }
	
	  return a.findIndex(callback) - b.findIndex(callback);
	}
	
	function getFieldNames(props) {
	  var fieldNames = props.fieldNames,
	      filedNames = props.filedNames;
	
	  if ('filedNames' in props) {
	    return filedNames; // For old compatibility
	  }
	
	  return fieldNames;
	}
	
	function getFilledFieldNames(props) {
	  var fieldNames = getFieldNames(props) || {};
	  var names = {
	    children: fieldNames.children || 'children',
	    label: fieldNames.label || 'label',
	    value: fieldNames.value || 'value'
	  };
	  return names;
	}
	
	function flattenTree(options, props) {
	  var ancestor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var names = getFilledFieldNames(props);
	  var flattenOptions = [];
	  var childrenName = names.children;
	  options.forEach(function (option) {
	    var path = ancestor.concat(option);
	
	    if (props.changeOnSelect || !option[childrenName] || !option[childrenName].length) {
	      flattenOptions.push(path);
	    }
	
	    if (option[childrenName]) {
	      flattenOptions = flattenOptions.concat(flattenTree(option[childrenName], props, path));
	    }
	  });
	  return flattenOptions;
	}
	
	var defaultDisplayRender = function defaultDisplayRender(label) {
	  return label.join(' / ');
	};
	
	function warningValueNotExist(list) {
	  var fieldNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (list || []).forEach(function (item) {
	    var valueFieldName = fieldNames.value || 'value';
	    (0, _warning["default"])(valueFieldName in item, 'Cascader', 'Not found `value` in `options`.');
	    warningValueNotExist(item[fieldNames.children || 'children'], fieldNames);
	  });
	}
	
	var Cascader = /*#__PURE__*/function (_React$Component) {
	  _inherits(Cascader, _React$Component);
	
	  var _super = _createSuper(Cascader);
	
	  function Cascader(props) {
	    var _this;
	
	    _classCallCheck(this, Cascader);
	
	    _this = _super.call(this, props);
	    _this.cachedOptions = [];
	
	    _this.setValue = function (value) {
	      var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(value, selectedOptions);
	      }
	    };
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.handleChange = function (value, selectedOptions) {
	      _this.setState({
	        inputValue: ''
	      });
	
	      if (selectedOptions[0].__IS_FILTERED_OPTION) {
	        var unwrappedValue = value[0];
	        var unwrappedSelectedOptions = selectedOptions[0].path;
	
	        _this.setValue(unwrappedValue, unwrappedSelectedOptions);
	
	        return;
	      }
	
	      _this.setValue(value, selectedOptions);
	    };
	
	    _this.handlePopupVisibleChange = function (popupVisible) {
	      if (!('popupVisible' in _this.props)) {
	        _this.setState(function (state) {
	          return {
	            popupVisible: popupVisible,
	            inputFocused: popupVisible,
	            inputValue: popupVisible ? state.inputValue : ''
	          };
	        });
	      }
	
	      var onPopupVisibleChange = _this.props.onPopupVisibleChange;
	
	      if (onPopupVisibleChange) {
	        onPopupVisibleChange(popupVisible);
	      }
	    };
	
	    _this.handleInputBlur = function () {
	      _this.setState({
	        inputFocused: false
	      });
	    };
	
	    _this.handleInputClick = function (e) {
	      var _this$state = _this.state,
	          inputFocused = _this$state.inputFocused,
	          popupVisible = _this$state.popupVisible; // Prevent `Trigger` behaviour.
	
	      if (inputFocused || popupVisible) {
	        e.stopPropagation();
	
	        if (e.nativeEvent.stopImmediatePropagation) {
	          e.nativeEvent.stopImmediatePropagation();
	        }
	      }
	    };
	
	    _this.handleKeyDown = function (e) {
	      // SPACE => https://github.com/ant-design/ant-design/issues/16871
	      if (e.keyCode === _KeyCode["default"].BACKSPACE || e.keyCode === _KeyCode["default"].SPACE) {
	        e.stopPropagation();
	      }
	    };
	
	    _this.handleInputChange = function (e) {
	      var inputValue = e.target.value;
	
	      _this.setState({
	        inputValue: inputValue
	      });
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (!_this.state.inputValue) {
	        _this.setValue([]);
	
	        _this.handlePopupVisibleChange(false);
	      } else {
	        _this.setState({
	          inputValue: ''
	        });
	      }
	    };
	
	    _this.renderCascader = function (_ref, locale) {
	      var _classNames, _classNames2, _classNames3, _classNames4;
	
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          customizeInputPrefixCls = props.inputPrefixCls,
	          children = props.children,
	          _props$placeholder = props.placeholder,
	          placeholder = _props$placeholder === void 0 ? locale.placeholder || 'Please select' : _props$placeholder,
	          size = props.size,
	          disabled = props.disabled,
	          className = props.className,
	          style = props.style,
	          allowClear = props.allowClear,
	          _props$showSearch = props.showSearch,
	          showSearch = _props$showSearch === void 0 ? false : _props$showSearch,
	          suffixIcon = props.suffixIcon,
	          notFoundContent = props.notFoundContent,
	          otherProps = __rest(props, ["prefixCls", "inputPrefixCls", "children", "placeholder", "size", "disabled", "className", "style", "allowClear", "showSearch", "suffixIcon", "notFoundContent"]);
	
	      var value = state.value,
	          inputFocused = state.inputFocused;
	      var prefixCls = getPrefixCls('cascader', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-sm"), size === 'small'), _classNames));
	      var clearIcon = allowClear && !disabled && value.length > 0 || state.inputValue ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection
	      }) : null;
	      var arrowCls = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-picker-arrow"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-arrow-expand"), state.popupVisible), _classNames2));
	      var pickerCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-picker"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-picker-with-value"), state.inputValue), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-disabled"), disabled), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-").concat(size), !!size), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-show-search"), !!showSearch), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-focused"), inputFocused), _classNames3)); // Fix bug of https://github.com/facebook/react/pull/5004
	      // and https://fb.me/react-unknown-prop
	
	      var inputProps = (0, _omit["default"])(otherProps, ['onChange', 'options', 'popupPlacement', 'transitionName', 'displayRender', 'onPopupVisibleChange', 'changeOnSelect', 'expandTrigger', 'popupVisible', 'getPopupContainer', 'loadData', 'popupClassName', 'filterOption', 'renderFilteredOption', 'sortFilteredOption', 'notFoundContent', 'fieldNames', 'filedNames']);
	      var options = props.options;
	      var names = getFilledFieldNames(_this.props);
	
	      if (options && options.length > 0) {
	        if (state.inputValue) {
	          options = _this.generateFilteredOptions(prefixCls, renderEmpty);
	        }
	      } else {
	        var _ref2;
	
	        options = [(_ref2 = {}, _defineProperty(_ref2, names.value, 'ANT_CASCADER_NOT_FOUND'), _defineProperty(_ref2, names.label, notFoundContent || renderEmpty('Cascader')), _defineProperty(_ref2, "disabled", true), _defineProperty(_ref2, "isEmptyNode", true), _ref2)];
	      } // Dropdown menu should keep previous status until it is fully closed.
	
	
	      if (!state.popupVisible) {
	        options = _this.cachedOptions;
	      } else {
	        _this.cachedOptions = options;
	      }
	
	      var dropdownMenuColumnStyle = {};
	      var isNotFound = (options || []).length === 1 && options[0].isEmptyNode;
	
	      if (isNotFound) {
	        dropdownMenuColumnStyle.height = 'auto'; // Height of one row.
	      } // The default value of `matchInputWidth` is `true`
	
	
	      var resultListMatchInputWidth = showSearch.matchInputWidth !== false;
	
	      if (resultListMatchInputWidth && (state.inputValue || isNotFound) && _this.input) {
	        dropdownMenuColumnStyle.width = _this.input.input.offsetWidth;
	      }
	
	      var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	        className: (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames4, "".concat(prefixCls, "-picker-arrow"), true), _classNames4))
	      }) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-picker-arrow")
	      }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: arrowCls
	      });
	      var input = children || /*#__PURE__*/React.createElement("span", {
	        style: style,
	        className: pickerCls
	      }, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-picker-label")
	      }, _this.getLabel()), /*#__PURE__*/React.createElement(_input["default"], _extends({}, inputProps, {
	        tabIndex: "-1",
	        ref: _this.saveInput,
	        prefixCls: inputPrefixCls,
	        placeholder: value && value.length > 0 ? undefined : placeholder,
	        className: "".concat(prefixCls, "-input ").concat(sizeCls),
	        value: state.inputValue,
	        disabled: disabled,
	        readOnly: !showSearch,
	        autoComplete: inputProps.autoComplete || 'off',
	        onClick: showSearch ? _this.handleInputClick : undefined,
	        onBlur: showSearch ? _this.handleInputBlur : undefined,
	        onKeyDown: _this.handleKeyDown,
	        onChange: showSearch ? _this.handleInputChange : undefined
	      })), clearIcon, inputIcon);
	      var expandIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right"
	      });
	      var loadingIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-item-loading-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "redo",
	        spin: true
	      }));
	      var getPopupContainer = props.getPopupContainer || getContextPopupContainer;
	      var rest = (0, _omit["default"])(props, ['inputIcon', 'expandIcon', 'loadingIcon']);
	      return (/*#__PURE__*/React.createElement(_rcCascader["default"], _extends({}, rest, {
	          prefixCls: prefixCls,
	          getPopupContainer: getPopupContainer,
	          options: options,
	          value: value,
	          popupVisible: state.popupVisible,
	          onPopupVisibleChange: _this.handlePopupVisibleChange,
	          onChange: _this.handleChange,
	          dropdownMenuColumnStyle: dropdownMenuColumnStyle,
	          expandIcon: expandIcon,
	          loadingIcon: loadingIcon
	        }), input)
	      );
	    };
	
	    _this.state = {
	      value: props.value || props.defaultValue || [],
	      inputValue: '',
	      inputFocused: false,
	      popupVisible: props.popupVisible,
	      flattenOptions: props.showSearch ? flattenTree(props.options, props) : undefined,
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(Cascader, [{
	    key: "getLabel",
	    value: function getLabel() {
	      var _this$props = this.props,
	          options = _this$props.options,
	          _this$props$displayRe = _this$props.displayRender,
	          displayRender = _this$props$displayRe === void 0 ? defaultDisplayRender : _this$props$displayRe;
	      var names = getFilledFieldNames(this.props);
	      var value = this.state.value;
	      var unwrappedValue = Array.isArray(value[0]) ? value[0] : value;
	      var selectedOptions = (0, _arrayTreeFilter["default"])(options, function (o, level) {
	        return o[names.value] === unwrappedValue[level];
	      }, {
	        childrenKeyName: names.children
	      });
	      var label = selectedOptions.map(function (o) {
	        return o[names.label];
	      });
	      return displayRender(label, selectedOptions);
	    }
	  }, {
	    key: "generateFilteredOptions",
	    value: function generateFilteredOptions(prefixCls, renderEmpty) {
	      var _this2 = this,
	          _ref4;
	
	      var _this$props2 = this.props,
	          showSearch = _this$props2.showSearch,
	          notFoundContent = _this$props2.notFoundContent;
	      var names = getFilledFieldNames(this.props);
	      var _showSearch$filter = showSearch.filter,
	          filter = _showSearch$filter === void 0 ? defaultFilterOption : _showSearch$filter,
	          _showSearch$render = showSearch.render,
	          render = _showSearch$render === void 0 ? defaultRenderFilteredOption : _showSearch$render,
	          _showSearch$sort = showSearch.sort,
	          sort = _showSearch$sort === void 0 ? defaultSortFilteredOption : _showSearch$sort,
	          _showSearch$limit = showSearch.limit,
	          limit = _showSearch$limit === void 0 ? defaultLimit : _showSearch$limit;
	      var _this$state2 = this.state,
	          _this$state2$flattenO = _this$state2.flattenOptions,
	          flattenOptions = _this$state2$flattenO === void 0 ? [] : _this$state2$flattenO,
	          inputValue = _this$state2.inputValue; // Limit the filter if needed
	
	      var filtered;
	
	      if (limit > 0) {
	        filtered = [];
	        var matchCount = 0; // Perf optimization to filter items only below the limit
	
	        flattenOptions.some(function (path) {
	          var match = filter(_this2.state.inputValue, path, names);
	
	          if (match) {
	            filtered.push(path);
	            matchCount += 1;
	          }
	
	          return matchCount >= limit;
	        });
	      } else {
	        (0, _warning["default"])(typeof limit !== 'number', 'Cascader', "'limit' of showSearch should be positive number or false.");
	        filtered = flattenOptions.filter(function (path) {
	          return filter(_this2.state.inputValue, path, names);
	        });
	      }
	
	      filtered.sort(function (a, b) {
	        return sort(a, b, inputValue, names);
	      });
	
	      if (filtered.length > 0) {
	        return filtered.map(function (path) {
	          var _ref3;
	
	          return _ref3 = {
	            __IS_FILTERED_OPTION: true,
	            path: path
	          }, _defineProperty(_ref3, names.value, path.map(function (o) {
	            return o[names.value];
	          })), _defineProperty(_ref3, names.label, render(inputValue, path, prefixCls, names)), _defineProperty(_ref3, "disabled", path.some(function (o) {
	            return !!o.disabled;
	          })), _defineProperty(_ref3, "isEmptyNode", true), _ref3;
	        });
	      }
	
	      return [(_ref4 = {}, _defineProperty(_ref4, names.value, 'ANT_CASCADER_NOT_FOUND'), _defineProperty(_ref4, names.label, notFoundContent || renderEmpty('Cascader')), _defineProperty(_ref4, "disabled", true), _defineProperty(_ref4, "isEmptyNode", true), _ref4)];
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (configArgument) {
	          return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (locale) {
	              return _this3.renderCascader(configArgument, locale);
	            })
	          );
	        })
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, _ref5) {
	      var prevProps = _ref5.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if ('value' in nextProps) {
	        newState.value = nextProps.value || [];
	      }
	
	      if ('popupVisible' in nextProps) {
	        newState.popupVisible = nextProps.popupVisible;
	      }
	
	      if (nextProps.showSearch && prevProps.options !== nextProps.options) {
	        newState.flattenOptions = flattenTree(nextProps.options, nextProps);
	      }
	
	      if (false) {
	        warningValueNotExist(nextProps.options, getFieldNames(nextProps));
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Cascader;
	}(React.Component);
	
	Cascader.defaultProps = {
	  transitionName: 'slide-up',
	  popupPlacement: 'bottomLeft',
	  options: [],
	  disabled: false,
	  allowClear: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Cascader);
	var _default = Cascader;
	exports["default"] = _default;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(741));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(CheckboxGroup, _React$Component);
	
	  var _super = _createSuper(CheckboxGroup);
	
	  function CheckboxGroup(props) {
	    var _this;
	
	    _classCallCheck(this, CheckboxGroup);
	
	    _this = _super.call(this, props);
	
	    _this.cancelValue = function (value) {
	      _this.setState(function (_ref) {
	        var registeredValues = _ref.registeredValues;
	        return {
	          registeredValues: registeredValues.filter(function (val) {
	            return val !== value;
	          })
	        };
	      });
	    };
	
	    _this.registerValue = function (value) {
	      _this.setState(function (_ref2) {
	        var registeredValues = _ref2.registeredValues;
	        return {
	          registeredValues: [].concat(_toConsumableArray(registeredValues), [value])
	        };
	      });
	    };
	
	    _this.toggleOption = function (option) {
	      var registeredValues = _this.state.registeredValues;
	
	      var optionIndex = _this.state.value.indexOf(option.value);
	
	      var value = _toConsumableArray(_this.state.value);
	
	      if (optionIndex === -1) {
	        value.push(option.value);
	      } else {
	        value.splice(optionIndex, 1);
	      }
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        var options = _this.getOptions();
	
	        onChange(value.filter(function (val) {
	          return registeredValues.indexOf(val) !== -1;
	        }).sort(function (a, b) {
	          var indexA = options.findIndex(function (opt) {
	            return opt.value === a;
	          });
	          var indexB = options.findIndex(function (opt) {
	            return opt.value === b;
	          });
	          return indexA - indexB;
	        }));
	      }
	    };
	
	    _this.renderGroup = function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          style = props.style,
	          options = props.options,
	          restProps = __rest(props, ["prefixCls", "className", "style", "options"]);
	
	      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var domProps = (0, _omit["default"])(restProps, ['children', 'defaultValue', 'value', 'onChange', 'disabled']);
	      var children = props.children;
	
	      if (options && options.length > 0) {
	        children = _this.getOptions().map(function (option) {
	          return (/*#__PURE__*/React.createElement(_Checkbox["default"], {
	              prefixCls: prefixCls,
	              key: option.value.toString(),
	              disabled: 'disabled' in option ? option.disabled : props.disabled,
	              value: option.value,
	              checked: state.value.indexOf(option.value) !== -1,
	              onChange: option.onChange,
	              className: "".concat(groupPrefixCls, "-item")
	            }, option.label)
	          );
	        });
	      }
	
	      var classString = (0, _classnames["default"])(groupPrefixCls, className);
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString,
	          style: style
	        }, domProps), children)
	      );
	    };
	
	    _this.state = {
	      value: props.value || props.defaultValue || [],
	      registeredValues: []
	    };
	    return _this;
	  }
	
	  _createClass(CheckboxGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        checkboxGroup: {
	          toggleOption: this.toggleOption,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name,
	          // https://github.com/ant-design/ant-design/issues/16376
	          registerValue: this.registerValue,
	          cancelValue: this.cancelValue
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var options = this.props.options; // https://github.com/Microsoft/TypeScript/issues/7960
	
	      return options.map(function (option) {
	        if (typeof option === 'string') {
	          return {
	            label: option,
	            value: option
	          };
	        }
	
	        return option;
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value || []
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return CheckboxGroup;
	}(React.Component);
	
	CheckboxGroup.defaultProps = {
	  options: []
	};
	CheckboxGroup.propTypes = {
	  defaultValue: PropTypes.array,
	  value: PropTypes.array,
	  options: PropTypes.array.isRequired,
	  onChange: PropTypes.func
	};
	CheckboxGroup.childContextTypes = {
	  checkboxGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(CheckboxGroup);
	var _default = CheckboxGroup;
	exports["default"] = _default;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcCollapse = _interopRequireDefault(__webpack_require__(188));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _CollapsePanel = _interopRequireDefault(__webpack_require__(1379));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _openAnimation = _interopRequireDefault(__webpack_require__(1352));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Collapse = /*#__PURE__*/function (_React$Component) {
	  _inherits(Collapse, _React$Component);
	
	  var _super = _createSuper(Collapse);
	
	  function Collapse() {
	    var _this;
	
	    _classCallCheck(this, Collapse);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderExpandIcon = function () {
	      var panelProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var prefixCls = arguments.length > 1 ? arguments[1] : undefined;
	      var expandIcon = _this.props.expandIcon;
	      var icon = expandIcon ? expandIcon(panelProps) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        rotate: panelProps.isActive ? 90 : undefined
	      });
	      return (/*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
	          className: (0, _classnames["default"])(icon.props.className, "".concat(prefixCls, "-arrow"))
	        }) : icon
	      );
	    };
	
	    _this.renderCollapse = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          bordered = _this$props.bordered,
	          expandIconPosition = _this$props.expandIconPosition;
	      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
	      var collapseClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _defineProperty(_classNames, "".concat(prefixCls, "-icon-position-").concat(expandIconPosition), true), _classNames), className);
	      return (/*#__PURE__*/React.createElement(_rcCollapse["default"], _extends({}, _this.props, {
	          expandIcon: function expandIcon(panelProps) {
	            return _this.renderExpandIcon(panelProps, prefixCls);
	          },
	          prefixCls: prefixCls,
	          className: collapseClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapse)
	      );
	    }
	  }]);
	
	  return Collapse;
	}(React.Component);
	
	exports["default"] = Collapse;
	Collapse.Panel = _CollapsePanel["default"];
	Collapse.defaultProps = {
	  bordered: true,
	  openAnimation: _extends(_extends({}, _openAnimation["default"]), {
	    appear: function appear() {}
	  }),
	  expandIconPosition: 'left'
	};

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcCollapse = _interopRequireDefault(__webpack_require__(188));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var CollapsePanel = /*#__PURE__*/function (_React$Component) {
	  _inherits(CollapsePanel, _React$Component);
	
	  var _super = _createSuper(CollapsePanel);
	
	  function CollapsePanel() {
	    var _this;
	
	    _classCallCheck(this, CollapsePanel);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderCollapsePanel = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          _this$props$showArrow = _this$props.showArrow,
	          showArrow = _this$props$showArrow === void 0 ? true : _this$props$showArrow;
	      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
	      var collapsePanelClassName = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-no-arrow"), !showArrow), className);
	      return (/*#__PURE__*/React.createElement(_rcCollapse["default"].Panel, _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: collapsePanelClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(CollapsePanel, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapsePanel)
	      );
	    }
	  }]);
	
	  return CollapsePanel;
	}(React.Component);
	
	exports["default"] = CollapsePanel;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Collapse = _interopRequireDefault(__webpack_require__(1378));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Collapse["default"];
	exports["default"] = _default;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getAction(actions) {
	  if (!actions || !actions.length) {
	    return null;
	  } // eslint-disable-next-line react/no-array-index-key
	
	
	  var actionList = actions.map(function (action, index) {
	    return (/*#__PURE__*/React.createElement("li", {
	        key: "action-".concat(index)
	      }, action)
	    );
	  });
	  return actionList;
	}
	
	var Comment = /*#__PURE__*/function (_React$Component) {
	  _inherits(Comment, _React$Component);
	
	  var _super = _createSuper(Comment);
	
	  function Comment() {
	    var _this;
	
	    _classCallCheck(this, Comment);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderNested = function (prefixCls, children) {
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-nested"))
	        }, children)
	      );
	    };
	
	    _this.renderComment = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          actions = _a.actions,
	          author = _a.author,
	          avatar = _a.avatar,
	          children = _a.children,
	          className = _a.className,
	          content = _a.content,
	          customizePrefixCls = _a.prefixCls,
	          style = _a.style,
	          datetime = _a.datetime,
	          otherProps = __rest(_a, ["actions", "author", "avatar", "children", "className", "content", "prefixCls", "style", "datetime"]);
	
	      var prefixCls = getPrefixCls('comment', customizePrefixCls);
	      var avatarDom = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-avatar")
	      }, typeof avatar === 'string' ? /*#__PURE__*/React.createElement("img", {
	        src: avatar,
	        alt: "comment-avatar"
	      }) : avatar);
	      var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-actions")
	      }, getAction(actions)) : null;
	      var authorContent = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content-author")
	      }, author && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-author-name")
	      }, author), datetime && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-author-time")
	      }, datetime));
	      var contentDom = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, authorContent, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content-detail")
	      }, content), actionDom);
	      var comment = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-inner")
	      }, avatarDom, contentDom);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
	          className: (0, _classnames["default"])(prefixCls, className),
	          style: style
	        }), comment, children ? _this.renderNested(prefixCls, children) : null)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Comment, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComment)
	      );
	    }
	  }]);
	
	  return Comment;
	}(React.Component);
	
	exports["default"] = Comment;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _empty = _interopRequireDefault(__webpack_require__(745));
	
	var _ = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var renderEmpty = function renderEmpty(componentName) {
	  return (/*#__PURE__*/React.createElement(_.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var prefix = getPrefixCls('empty');
	
	      switch (componentName) {
	        case 'Table':
	        case 'List':
	          return (/*#__PURE__*/React.createElement(_empty["default"], {
	              image: _empty["default"].PRESENTED_IMAGE_SIMPLE
	            })
	          );
	
	        case 'Select':
	        case 'TreeSelect':
	        case 'Cascader':
	        case 'Transfer':
	        case 'Mentions':
	          return (/*#__PURE__*/React.createElement(_empty["default"], {
	              image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
	              className: "".concat(prefix, "-small")
	            })
	          );
	
	        default:
	          return (/*#__PURE__*/React.createElement(_empty["default"], null)
	          );
	      }
	    })
	  );
	};
	
	var _default = renderEmpty;
	exports["default"] = _default;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _RangeCalendar = _interopRequireDefault(__webpack_require__(461));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _tag = _interopRequireDefault(__webpack_require__(761));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	var _utils = __webpack_require__(744);
	
	var _InputIcon = _interopRequireDefault(__webpack_require__(743));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function getShowDateFromValue(value, mode) {
	  var _value = _slicedToArray(value, 2),
	      start = _value[0],
	      end = _value[1]; // value could be an empty array, then we should not reset showDate
	
	
	  if (!start && !end) {
	    return;
	  }
	
	  if (mode && mode[0] === 'month') {
	    return [start, end];
	  }
	
	  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
	  return [start, newEnd];
	}
	
	function pickerValueAdapter(value) {
	  if (!value) {
	    return;
	  }
	
	  if (Array.isArray(value)) {
	    return value;
	  }
	
	  return [value, value.clone().add(1, 'month')];
	}
	
	function isEmptyArray(arr) {
	  if (Array.isArray(arr)) {
	    return arr.length === 0 || arr.every(function (i) {
	      return !i;
	    });
	  }
	
	  return false;
	}
	
	function fixLocale(value, localeCode) {
	  if (!localeCode) {
	    return;
	  }
	
	  if (!value || value.length === 0) {
	    return;
	  }
	
	  var _value2 = _slicedToArray(value, 2),
	      start = _value2[0],
	      end = _value2[1];
	
	  if (start) {
	    start.locale(localeCode);
	  }
	
	  if (end) {
	    end.locale(localeCode);
	  }
	}
	
	var RangePicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(RangePicker, _React$Component);
	
	  var _super = _createSuper(RangePicker);
	
	  function RangePicker(props) {
	    var _this;
	
	    _classCallCheck(this, RangePicker);
	
	    _this = _super.call(this, props);
	
	    _this.savePicker = function (node) {
	      _this.picker = node;
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.setState({
	        value: []
	      });
	
	      _this.handleChange([]);
	    };
	
	    _this.clearHoverValue = function () {
	      return _this.setState({
	        hoverValue: []
	      });
	    };
	
	    _this.handleChange = function (value) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      if (!('value' in props)) {
	        _this.setState(function (_ref) {
	          var showDate = _ref.showDate;
	          return {
	            value: value,
	            showDate: getShowDateFromValue(value) || showDate
	          };
	        });
	      }
	
	      if (value[0] && value[1] && value[0].diff(value[1]) > 0) {
	        value[1] = undefined;
	      }
	
	      var _value3 = _slicedToArray(value, 2),
	          start = _value3[0],
	          end = _value3[1];
	
	      if (typeof props.onChange === 'function') {
	        props.onChange(value, [(0, _utils.formatDate)(start, props.format), (0, _utils.formatDate)(end, props.format)]);
	      }
	    };
	
	    _this.handleOpenChange = function (open) {
	      if (!('open' in _this.props)) {
	        _this.setState({
	          open: open
	        });
	      }
	
	      if (open === false) {
	        _this.clearHoverValue();
	      }
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.handleShowDateChange = function (showDate) {
	      return _this.setState({
	        showDate: showDate
	      });
	    };
	
	    _this.handleHoverChange = function (hoverValue) {
	      return _this.setState({
	        hoverValue: hoverValue
	      });
	    };
	
	    _this.handleRangeMouseLeave = function () {
	      if (_this.state.open) {
	        _this.clearHoverValue();
	      }
	    };
	
	    _this.handleCalendarInputSelect = function (value) {
	      var _value4 = _slicedToArray(value, 1),
	          start = _value4[0];
	
	      if (!start) {
	        return;
	      }
	
	      _this.setState(function (_ref2) {
	        var showDate = _ref2.showDate;
	        return {
	          value: value,
	          showDate: getShowDateFromValue(value) || showDate
	        };
	      });
	    };
	
	    _this.handleRangeClick = function (value) {
	      if (typeof value === 'function') {
	        value = value();
	      }
	
	      _this.setValue(value, true);
	
	      var _this$props = _this.props,
	          onOk = _this$props.onOk,
	          onOpenChange = _this$props.onOpenChange;
	
	      if (onOk) {
	        onOk(value);
	      }
	
	      if (onOpenChange) {
	        onOpenChange(false);
	      }
	    };
	
	    _this.renderFooter = function () {
	      var _this$props2 = _this.props,
	          ranges = _this$props2.ranges,
	          renderExtraFooter = _this$props2.renderExtraFooter;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize2.prefixCls,
	          tagPrefixCls = _assertThisInitialize2.tagPrefixCls;
	
	      if (!ranges && !renderExtraFooter) {
	        return null;
	      }
	
	      var customFooter = renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra"),
	        key: "extra"
	      }, renderExtraFooter()) : null;
	      var operations = ranges && Object.keys(ranges).map(function (range) {
	        var value = ranges[range];
	        var hoverValue = typeof value === 'function' ? value.call(_assertThisInitialized(_this)) : value;
	        return (/*#__PURE__*/React.createElement(_tag["default"], {
	            key: range,
	            prefixCls: tagPrefixCls,
	            color: "blue",
	            onClick: function onClick() {
	              return _this.handleRangeClick(value);
	            },
	            onMouseEnter: function onMouseEnter() {
	              return _this.setState({
	                hoverValue: hoverValue
	              });
	            },
	            onMouseLeave: _this.handleRangeMouseLeave
	          }, range)
	        );
	      });
	      var rangeNode = operations && operations.length > 0 ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra ").concat(prefixCls, "-range-quick-selector"),
	        key: "range"
	      }, operations) : null;
	      return [rangeNode, customFooter];
	    };
	
	    _this.renderRangePicker = function (_ref3) {
	      var _classNames;
	
	      var getPrefixCls = _ref3.getPrefixCls;
	
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          state = _assertThisInitialize3.state,
	          props = _assertThisInitialize3.props;
	
	      var value = state.value,
	          showDate = state.showDate,
	          hoverValue = state.hoverValue,
	          open = state.open;
	      var customizePrefixCls = props.prefixCls,
	          customizeTagPrefixCls = props.tagPrefixCls,
	          popupStyle = props.popupStyle,
	          style = props.style,
	          disabledDate = props.disabledDate,
	          disabledTime = props.disabledTime,
	          showTime = props.showTime,
	          showToday = props.showToday,
	          ranges = props.ranges,
	          onOk = props.onOk,
	          locale = props.locale,
	          localeCode = props.localeCode,
	          format = props.format,
	          dateRender = props.dateRender,
	          onCalendarChange = props.onCalendarChange,
	          suffixIcon = props.suffixIcon,
	          separator = props.separator;
	      var prefixCls = getPrefixCls('calendar', customizePrefixCls);
	      var tagPrefixCls = getPrefixCls('tag', customizeTagPrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      _this.tagPrefixCls = tagPrefixCls;
	      fixLocale(value, localeCode);
	      fixLocale(showDate, localeCode);
	      (0, _warning["default"])(!('onOK' in props), 'RangePicker', 'It should be `RangePicker[onOk]`, instead of `onOK`!');
	      var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), showTime), _defineProperty(_classNames, "".concat(prefixCls, "-range-with-ranges"), ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange
	
	      var pickerChangeHandler = {
	        onChange: _this.handleChange
	      };
	      var calendarProps = {
	        onOk: _this.handleChange
	      };
	
	      if (props.timePicker) {
	        pickerChangeHandler.onChange = function (changedValue) {
	          return _this.handleChange(changedValue);
	        };
	      } else {
	        calendarProps = {};
	      }
	
	      if ('mode' in props) {
	        calendarProps.mode = props.mode;
	      }
	
	      var startPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
	      var endPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
	      var calendar = /*#__PURE__*/React.createElement(_RangeCalendar["default"], _extends({}, calendarProps, {
	        seperator: separator,
	        onChange: onCalendarChange,
	        format: format,
	        prefixCls: prefixCls,
	        className: calendarClassName,
	        renderFooter: _this.renderFooter,
	        timePicker: props.timePicker,
	        disabledDate: disabledDate,
	        disabledTime: disabledTime,
	        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
	        locale: locale.lang,
	        onOk: onOk,
	        dateRender: dateRender,
	        value: showDate,
	        onValueChange: _this.handleShowDateChange,
	        hoverValue: hoverValue,
	        onHoverChange: _this.handleHoverChange,
	        onPanelChange: props.onPanelChange,
	        showToday: showToday,
	        onInputSelect: _this.handleCalendarInputSelect
	      })); // default width for showTime
	
	      var pickerStyle = {};
	
	      if (props.showTime) {
	        pickerStyle.width = style && style.width || 350;
	      }
	
	      var _value5 = _slicedToArray(value, 2),
	          startValue = _value5[0],
	          endValue = _value5[1];
	
	      var clearIcon = !props.disabled && props.allowClear && value && (startValue || endValue) ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection,
	        theme: "filled"
	      }) : null;
	      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
	        suffixIcon: suffixIcon,
	        prefixCls: prefixCls
	      });
	
	      var input = function input(_ref4) {
	        var inputValue = _ref4.value;
	
	        var _inputValue = _slicedToArray(inputValue, 2),
	            start = _inputValue[0],
	            end = _inputValue[1];
	
	        return (/*#__PURE__*/React.createElement("span", {
	            className: props.pickerInputClass
	          }, /*#__PURE__*/React.createElement("input", {
	            disabled: props.disabled,
	            readOnly: true,
	            value: (0, _utils.formatDate)(start, props.format),
	            placeholder: startPlaceholder,
	            className: "".concat(prefixCls, "-range-picker-input"),
	            tabIndex: -1
	          }), /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-range-picker-separator")
	          }, " ", separator, " "), /*#__PURE__*/React.createElement("input", {
	            disabled: props.disabled,
	            readOnly: true,
	            value: (0, _utils.formatDate)(end, props.format),
	            placeholder: endPlaceholder,
	            className: "".concat(prefixCls, "-range-picker-input"),
	            tabIndex: -1
	          }), clearIcon, inputIcon)
	        );
	      };
	
	      return (/*#__PURE__*/React.createElement("span", {
	          ref: _this.savePicker,
	          id: typeof props.id === 'number' ? props.id.toString() : props.id,
	          className: (0, _classnames["default"])(props.className, props.pickerClass),
	          style: _extends(_extends({}, style), pickerStyle),
	          tabIndex: props.disabled ? -1 : 0,
	          onFocus: props.onFocus,
	          onBlur: props.onBlur,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerChangeHandler, {
	          calendar: calendar,
	          value: value,
	          open: open,
	          onOpenChange: _this.handleOpenChange,
	          prefixCls: "".concat(prefixCls, "-picker-container"),
	          style: popupStyle
	        }), input))
	      );
	    };
	
	    var value = props.value || props.defaultValue || [];
	
	    var _value6 = _slicedToArray(value, 2),
	        start = _value6[0],
	        end = _value6[1];
	
	    if (start && !(0, _interopDefault["default"])(moment).isMoment(start) || end && !(0, _interopDefault["default"])(moment).isMoment(end)) {
	      throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
	    }
	
	    var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
	    _this.state = {
	      value: value,
	      showDate: pickerValueAdapter(pickerValue || (0, _interopDefault["default"])(moment)()),
	      open: props.open,
	      hoverValue: []
	    };
	    return _this;
	  }
	
	  _createClass(RangePicker, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      if (!('open' in this.props) && prevState.open && !this.state.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, hidePanel) {
	      this.handleChange(value);
	
	      if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.picker.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.picker.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRangePicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var state = null;
	
	      if ('value' in nextProps) {
	        var value = nextProps.value || [];
	        state = {
	          value: value
	        };
	
	        if (!(0, _shallowequal["default"])(nextProps.value, prevState.value)) {
	          state = _extends(_extends({}, state), {
	            showDate: getShowDateFromValue(value, nextProps.mode) || prevState.showDate
	          });
	        }
	      }
	
	      if ('open' in nextProps && prevState.open !== nextProps.open) {
	        state = _extends(_extends({}, state), {
	          open: nextProps.open
	        });
	      }
	
	      return state;
	    }
	  }]);
	
	  return RangePicker;
	}(React.Component);
	
	RangePicker.defaultProps = {
	  allowClear: true,
	  showToday: false,
	  separator: '~'
	};
	(0, _reactLifecyclesCompat.polyfill)(RangePicker);
	var _default = RangePicker;
	exports["default"] = _default;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcCalendar = _interopRequireDefault(__webpack_require__(186));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	var _InputIcon = _interopRequireDefault(__webpack_require__(743));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function formatValue(value, format) {
	  return value && value.format(format) || '';
	}
	
	var WeekPicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(WeekPicker, _React$Component);
	
	  var _super = _createSuper(WeekPicker);
	
	  function WeekPicker(props) {
	    var _this;
	
	    _classCallCheck(this, WeekPicker);
	
	    _this = _super.call(this, props);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.weekDateRender = function (current) {
	      var selectedValue = _this.state.value;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      var dateRender = _this.props.dateRender;
	      var dateNode = dateRender ? dateRender(current) : current.date();
	
	      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
	        return (/*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-selected-day")
	          }, /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-date")
	          }, dateNode))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-date")
	        }, dateNode)
	      );
	    };
	
	    _this.handleChange = function (value) {
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      _this.props.onChange(value, formatValue(value, _this.props.format));
	    };
	
	    _this.handleOpenChange = function (open) {
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (!('open' in _this.props)) {
	        _this.setState({
	          open: open
	        });
	      }
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.handleChange(null);
	    };
	
	    _this.renderFooter = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          renderExtraFooter = _this$props.renderExtraFooter;
	      return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra")
	      }, renderExtraFooter.apply(void 0, arguments)) : null;
	    };
	
	    _this.renderWeekPicker = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          disabled = _this$props2.disabled,
	          pickerClass = _this$props2.pickerClass,
	          popupStyle = _this$props2.popupStyle,
	          pickerInputClass = _this$props2.pickerInputClass,
	          format = _this$props2.format,
	          allowClear = _this$props2.allowClear,
	          locale = _this$props2.locale,
	          localeCode = _this$props2.localeCode,
	          disabledDate = _this$props2.disabledDate,
	          style = _this$props2.style,
	          onFocus = _this$props2.onFocus,
	          onBlur = _this$props2.onBlur,
	          id = _this$props2.id,
	          suffixIcon = _this$props2.suffixIcon,
	          defaultPickerValue = _this$props2.defaultPickerValue;
	      var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      var _this$state = _this.state,
	          open = _this$state.open,
	          pickerValue = _this$state.value;
	
	      if (pickerValue && localeCode) {
	        pickerValue.locale(localeCode);
	      }
	
	      var placeholder = 'placeholder' in _this.props ? _this.props.placeholder : locale.lang.placeholder;
	      var calendar = /*#__PURE__*/React.createElement(_rcCalendar["default"], {
	        showWeekNumber: true,
	        dateRender: _this.weekDateRender,
	        prefixCls: prefixCls,
	        format: format,
	        locale: locale.lang,
	        showDateInput: false,
	        showToday: false,
	        disabledDate: disabledDate,
	        renderFooter: _this.renderFooter,
	        defaultValue: defaultPickerValue
	      });
	      var clearIcon = !disabled && allowClear && _this.state.value ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection,
	        theme: "filled"
	      }) : null;
	      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
	        suffixIcon: suffixIcon,
	        prefixCls: prefixCls
	      });
	
	      var input = function input(_ref2) {
	        var value = _ref2.value;
	        return (/*#__PURE__*/React.createElement("span", {
	            style: {
	              display: 'inline-block',
	              width: '100%'
	            }
	          }, /*#__PURE__*/React.createElement("input", {
	            ref: _this.saveInput,
	            disabled: disabled,
	            readOnly: true,
	            value: value && value.format(format) || '',
	            placeholder: placeholder,
	            className: pickerInputClass,
	            onFocus: onFocus,
	            onBlur: onBlur
	          }), clearIcon, inputIcon)
	        );
	      };
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])(className, pickerClass),
	          style: style,
	          id: id
	        }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, _this.props, {
	          calendar: calendar,
	          prefixCls: "".concat(prefixCls, "-picker-container"),
	          value: pickerValue,
	          onChange: _this.handleChange,
	          open: open,
	          onOpenChange: _this.handleOpenChange,
	          style: popupStyle
	        }), input))
	      );
	    };
	
	    var value = props.value || props.defaultValue;
	
	    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of WeekPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	    }
	
	    _this.state = {
	      value: value,
	      open: props.open
	    };
	    return _this;
	  }
	
	  _createClass(WeekPicker, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      if (!('open' in this.props) && prevState.open && !this.state.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWeekPicker)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps || 'open' in nextProps) {
	        var state = {};
	
	        if ('value' in nextProps) {
	          state.value = nextProps.value;
	        }
	
	        if ('open' in nextProps) {
	          state.open = nextProps.open;
	        }
	
	        return state;
	      }
	
	      return null;
	    }
	  }]);
	
	  return WeekPicker;
	}(React.Component);
	
	WeekPicker.defaultProps = {
	  format: 'gggg-wo',
	  allowClear: true
	};
	(0, _reactLifecyclesCompat.polyfill)(WeekPicker);
	var _default = WeekPicker;
	exports["default"] = _default;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createPicker;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _MonthCalendar = _interopRequireDefault(__webpack_require__(185));
	
	var _Picker = _interopRequireDefault(__webpack_require__(118));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(731));
	
	var _utils = __webpack_require__(744);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function createPicker(TheCalendar) {
	  var CalenderWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(CalenderWrapper, _React$Component);
	
	    var _super = _createSuper(CalenderWrapper);
	
	    function CalenderWrapper(props) {
	      var _this;
	
	      _classCallCheck(this, CalenderWrapper);
	
	      _this = _super.call(this, props);
	
	      _this.saveInput = function (node) {
	        _this.input = node;
	      };
	
	      _this.clearSelection = function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        _this.handleChange(null);
	      };
	
	      _this.handleChange = function (value) {
	        var _assertThisInitialize = _assertThisInitialized(_this),
	            props = _assertThisInitialize.props;
	
	        if (!('value' in props)) {
	          _this.setState({
	            value: value,
	            showDate: value
	          });
	        }
	
	        props.onChange(value, (0, _utils.formatDate)(value, props.format));
	      };
	
	      _this.handleCalendarChange = function (value) {
	        _this.setState({
	          showDate: value
	        });
	      };
	
	      _this.handleOpenChange = function (open) {
	        var onOpenChange = _this.props.onOpenChange;
	
	        if (!('open' in _this.props)) {
	          _this.setState({
	            open: open
	          });
	        }
	
	        if (onOpenChange) {
	          onOpenChange(open);
	        }
	      };
	
	      _this.renderFooter = function () {
	        var renderExtraFooter = _this.props.renderExtraFooter;
	
	        var _assertThisInitialize2 = _assertThisInitialized(_this),
	            prefixCls = _assertThisInitialize2.prefixCls;
	
	        return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-footer-extra")
	        }, renderExtraFooter.apply(void 0, arguments)) : null;
	      };
	
	      _this.renderPicker = function (_ref) {
	        var _classNames, _classNames2;
	
	        var getPrefixCls = _ref.getPrefixCls;
	        var _this$state = _this.state,
	            value = _this$state.value,
	            showDate = _this$state.showDate,
	            open = _this$state.open;
	        var props = (0, _omit["default"])(_this.props, ['onChange']);
	        var customizePrefixCls = props.prefixCls,
	            locale = props.locale,
	            localeCode = props.localeCode,
	            suffixIcon = props.suffixIcon;
	        var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
	        // Have to add prefixCls on the instance.
	        // https://github.com/facebook/react/issues/12397
	
	        _this.prefixCls = prefixCls;
	        var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
	        var disabledTime = props.showTime ? props.disabledTime : null;
	        var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), props.showTime), _defineProperty(_classNames, "".concat(prefixCls, "-month"), _MonthCalendar["default"] === TheCalendar), _classNames));
	
	        if (value && localeCode) {
	          value.locale(localeCode);
	        }
	
	        var pickerProps = {};
	        var calendarProps = {};
	        var pickerStyle = {};
	
	        if (props.showTime) {
	          calendarProps = {
	            // fix https://github.com/ant-design/ant-design/issues/1902
	            onSelect: _this.handleChange
	          };
	          pickerStyle.minWidth = 195;
	        } else {
	          pickerProps = {
	            onChange: _this.handleChange
	          };
	        }
	
	        if ('mode' in props) {
	          calendarProps.mode = props.mode;
	        }
	
	        (0, _warning["default"])(!('onOK' in props), 'DatePicker', 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
	        var calendar = /*#__PURE__*/React.createElement(TheCalendar, _extends({}, calendarProps, {
	          disabledDate: props.disabledDate,
	          disabledTime: disabledTime,
	          locale: locale.lang,
	          timePicker: props.timePicker,
	          defaultValue: props.defaultPickerValue || (0, _interopDefault["default"])(moment)(),
	          dateInputPlaceholder: placeholder,
	          prefixCls: prefixCls,
	          className: calendarClassName,
	          onOk: props.onOk,
	          dateRender: props.dateRender,
	          format: props.format,
	          showToday: props.showToday,
	          monthCellContentRender: props.monthCellContentRender,
	          renderFooter: _this.renderFooter,
	          onPanelChange: props.onPanelChange,
	          onChange: _this.handleCalendarChange,
	          value: showDate
	        }));
	        var clearIcon = !props.disabled && props.allowClear && value ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          className: "".concat(prefixCls, "-picker-clear"),
	          onClick: _this.clearSelection,
	          theme: "filled"
	        }) : null;
	        var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-icon"), true), _classNames2))
	        }) : /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-picker-icon")
	        }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "calendar",
	          className: "".concat(prefixCls, "-picker-icon")
	        });
	        var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(props);
	
	        var input = function input(_ref2) {
	          var inputValue = _ref2.value;
	          return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
	              ref: _this.saveInput,
	              disabled: props.disabled,
	              readOnly: true,
	              value: (0, _utils.formatDate)(inputValue, props.format),
	              placeholder: placeholder,
	              className: props.pickerInputClass,
	              tabIndex: props.tabIndex,
	              name: props.name
	            }, dataOrAriaProps)), clearIcon, inputIcon)
	          );
	        };
	
	        return (/*#__PURE__*/React.createElement("span", {
	            id: props.id,
	            className: (0, _classnames["default"])(props.className, props.pickerClass),
	            style: _extends(_extends({}, pickerStyle), props.style),
	            onFocus: props.onFocus,
	            onBlur: props.onBlur,
	            onMouseEnter: props.onMouseEnter,
	            onMouseLeave: props.onMouseLeave
	          }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerProps, {
	            calendar: calendar,
	            value: value,
	            prefixCls: "".concat(prefixCls, "-picker-container"),
	            style: props.popupStyle,
	            open: open,
	            onOpenChange: _this.handleOpenChange
	          }), input))
	        );
	      };
	
	      var value = props.value || props.defaultValue;
	
	      if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	        throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	      }
	
	      _this.state = {
	        value: value,
	        showDate: value,
	        open: false
	      };
	      return _this;
	    }
	
	    _createClass(CalenderWrapper, [{
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(_, prevState) {
	        if (!('open' in this.props) && prevState.open && !this.state.open) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.input.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.input.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPicker)
	        );
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(nextProps, prevState) {
	        var state = {};
	        var open = prevState.open;
	
	        if ('open' in nextProps) {
	          state.open = nextProps.open;
	          open = nextProps.open || false;
	        }
	
	        if ('value' in nextProps) {
	          state.value = nextProps.value;
	
	          if (nextProps.value !== prevState.value || !open && nextProps.value !== prevState.showDate) {
	            state.showDate = nextProps.value;
	          }
	        }
	
	        return Object.keys(state).length > 0 ? state : null;
	      }
	    }]);
	
	    return CalenderWrapper;
	  }(React.Component);
	
	  CalenderWrapper.defaultProps = {
	    allowClear: true,
	    showToday: true
	  };
	  (0, _reactLifecyclesCompat.polyfill)(CalenderWrapper);
	  return CalenderWrapper;
	}

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _rcCalendar = _interopRequireDefault(__webpack_require__(186));
	
	var _MonthCalendar = _interopRequireDefault(__webpack_require__(185));
	
	var _createPicker = _interopRequireDefault(__webpack_require__(1385));
	
	var _wrapPicker = _interopRequireDefault(__webpack_require__(1387));
	
	var _RangePicker = _interopRequireDefault(__webpack_require__(1383));
	
	var _WeekPicker = _interopRequireDefault(__webpack_require__(1384));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var DatePicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_rcCalendar["default"]), 'date');
	var MonthPicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_MonthCalendar["default"]), 'month');
	
	_extends(DatePicker, {
	  RangePicker: (0, _wrapPicker["default"])(_RangePicker["default"], 'date'),
	  MonthPicker: MonthPicker,
	  WeekPicker: (0, _wrapPicker["default"])(_WeekPicker["default"], 'week')
	});
	
	var _default = DatePicker;
	exports["default"] = _default;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapPicker;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _Panel = _interopRequireDefault(__webpack_require__(505));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _en_US = _interopRequireDefault(__webpack_require__(377));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _timePicker = __webpack_require__(762);
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var DEFAULT_FORMAT = {
	  date: 'YYYY-MM-DD',
	  dateTime: 'YYYY-MM-DD HH:mm:ss',
	  week: 'gggg-wo',
	  month: 'YYYY-MM'
	};
	var LOCALE_FORMAT_MAPPING = {
	  date: 'dateFormat',
	  dateTime: 'dateTimeFormat',
	  week: 'weekFormat',
	  month: 'monthFormat'
	};
	
	function getColumns(_ref) {
	  var showHour = _ref.showHour,
	      showMinute = _ref.showMinute,
	      showSecond = _ref.showSecond,
	      use12Hours = _ref.use12Hours;
	  var column = 0;
	
	  if (showHour) {
	    column += 1;
	  }
	
	  if (showMinute) {
	    column += 1;
	  }
	
	  if (showSecond) {
	    column += 1;
	  }
	
	  if (use12Hours) {
	    column += 1;
	  }
	
	  return column;
	}
	
	function checkValidate(value, propName) {
	  var values = Array.isArray(value) ? value : [value];
	  values.forEach(function (val) {
	    if (!val) return;
	    (0, _warning["default"])(!(0, _interopDefault["default"])(moment).isMoment(val) || val.isValid(), 'DatePicker', "`".concat(propName, "` provides invalidate moment time. If you want to set empty value, use `null` instead."));
	  });
	}
	
	function wrapPicker(Picker, pickerType) {
	  var PickerWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(PickerWrapper, _React$Component);
	
	    var _super = _createSuper(PickerWrapper);
	
	    function PickerWrapper() {
	      var _this;
	
	      _classCallCheck(this, PickerWrapper);
	
	      _this = _super.apply(this, arguments); // Since we need call `getDerivedStateFromProps` for check. Need leave an empty `state` here.
	
	      _this.state = {};
	
	      _this.savePicker = function (node) {
	        _this.picker = node;
	      };
	
	      _this.getDefaultLocale = function () {
	        var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	        result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
	        return result;
	      };
	
	      _this.handleOpenChange = function (open) {
	        var onOpenChange = _this.props.onOpenChange;
	        onOpenChange(open);
	      };
	
	      _this.handleFocus = function (e) {
	        var onFocus = _this.props.onFocus;
	
	        if (onFocus) {
	          onFocus(e);
	        }
	      };
	
	      _this.handleBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        if (onMouseEnter) {
	          onMouseEnter(e);
	        }
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	
	        if (onMouseLeave) {
	          onMouseLeave(e);
	        }
	      };
	
	      _this.renderPicker = function (locale, localeCode) {
	        var _this$props = _this.props,
	            format = _this$props.format,
	            showTime = _this$props.showTime;
	        var mergedPickerType = showTime ? "".concat(pickerType, "Time") : pickerType;
	        var mergedFormat = format || locale[LOCALE_FORMAT_MAPPING[mergedPickerType]] || DEFAULT_FORMAT[mergedPickerType];
	        return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	            var _classNames2;
	
	            var getPrefixCls = _ref2.getPrefixCls,
	                getContextPopupContainer = _ref2.getPopupContainer;
	            var _this$props2 = _this.props,
	                customizePrefixCls = _this$props2.prefixCls,
	                customizeInputPrefixCls = _this$props2.inputPrefixCls,
	                getCalendarContainer = _this$props2.getCalendarContainer,
	                size = _this$props2.size,
	                disabled = _this$props2.disabled;
	            var getPopupContainer = getCalendarContainer || getContextPopupContainer;
	            var prefixCls = getPrefixCls('calendar', customizePrefixCls);
	            var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	            var pickerClass = (0, _classnames["default"])("".concat(prefixCls, "-picker"), _defineProperty({}, "".concat(prefixCls, "-picker-").concat(size), !!size));
	            var pickerInputClass = (0, _classnames["default"])("".concat(prefixCls, "-picker-input"), inputPrefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-sm"), size === 'small'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames2));
	            var timeFormat = showTime && showTime.format || 'HH:mm:ss';
	
	            var rcTimePickerProps = _extends(_extends({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat)), {
	              format: timeFormat,
	              use12Hours: showTime && showTime.use12Hours
	            });
	
	            var columns = getColumns(rcTimePickerProps);
	            var timePickerCls = "".concat(prefixCls, "-time-picker-column-").concat(columns);
	            var timePicker = showTime ? /*#__PURE__*/React.createElement(_Panel["default"], _extends({}, rcTimePickerProps, showTime, {
	              prefixCls: "".concat(prefixCls, "-time-picker"),
	              className: timePickerCls,
	              placeholder: locale.timePickerLocale.placeholder,
	              transitionName: "slide-up",
	              onEsc: function onEsc() {}
	            })) : null;
	            return (/*#__PURE__*/React.createElement(Picker, _extends({}, _this.props, {
	                getCalendarContainer: getPopupContainer,
	                format: mergedFormat,
	                ref: _this.savePicker,
	                pickerClass: pickerClass,
	                pickerInputClass: pickerInputClass,
	                locale: locale,
	                localeCode: localeCode,
	                timePicker: timePicker,
	                onOpenChange: _this.handleOpenChange,
	                onFocus: _this.handleFocus,
	                onBlur: _this.handleBlur,
	                onMouseEnter: _this.handleMouseEnter,
	                onMouseLeave: _this.handleMouseLeave
	              }))
	            );
	          })
	        );
	      };
	
	      return _this;
	    }
	
	    _createClass(PickerWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this$props3 = this.props,
	            autoFocus = _this$props3.autoFocus,
	            disabled = _this$props3.disabled;
	
	        if (autoFocus && !disabled) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.picker.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.picker.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	            componentName: "DatePicker",
	            defaultLocale: this.getDefaultLocale
	          }, this.renderPicker)
	        );
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(_ref3) {
	        var value = _ref3.value,
	            defaultValue = _ref3.defaultValue;
	        checkValidate(defaultValue, 'defaultValue');
	        checkValidate(value, 'value');
	        return {};
	      }
	    }]);
	
	    return PickerWrapper;
	  }(React.Component);
	
	  PickerWrapper.defaultProps = {
	    transitionName: 'slide-up',
	    popupStyle: {},
	    onChange: function onChange() {},
	    onOk: function onOk() {},
	    onOpenChange: function onOpenChange() {},
	    locale: {}
	  };
	  (0, _reactLifecyclesCompat.polyfill)(PickerWrapper);
	  return PickerWrapper;
	}

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var Col = function Col(props) {
	  var _classNames;
	
	  var child = props.child,
	      bordered = props.bordered,
	      colon = props.colon,
	      type = props.type,
	      layout = props.layout;
	  var _child$props = child.props,
	      prefixCls = _child$props.prefixCls,
	      label = _child$props.label,
	      className = _child$props.className,
	      children = _child$props.children,
	      _child$props$span = _child$props.span,
	      span = _child$props$span === void 0 ? 1 : _child$props$span;
	  var labelProps = {
	    className: (0, _classnames["default"])("".concat(prefixCls, "-item-label"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-colon"), colon), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-label"), !label), _classNames)),
	    key: 'label'
	  };
	
	  if (layout === 'vertical') {
	    labelProps.colSpan = span * 2 - 1;
	  }
	
	  if (bordered) {
	    if (type === 'label') {
	      return (/*#__PURE__*/React.createElement("th", labelProps, label)
	      );
	    }
	
	    return (/*#__PURE__*/React.createElement("td", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item-content"), className),
	        key: "content",
	        colSpan: span * 2 - 1
	      }, children)
	    );
	  }
	
	  if (layout === 'vertical') {
	    if (type === 'content') {
	      return (/*#__PURE__*/React.createElement("td", {
	          colSpan: span,
	          className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	        }, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-item-content"),
	          key: "content"
	        }, children))
	      );
	    }
	
	    return (/*#__PURE__*/React.createElement("td", {
	        colSpan: span,
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	      }, /*#__PURE__*/React.createElement("span", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item-label"), _defineProperty({}, "".concat(prefixCls, "-item-colon"), colon)),
	        key: "label"
	      }, label))
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement("td", {
	      colSpan: span,
	      className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	    }, /*#__PURE__*/React.createElement("span", labelProps, label), /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-item-content"),
	      key: "content"
	    }, children))
	  );
	};
	
	var _default = Col;
	exports["default"] = _default;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _responsiveObserve = _interopRequireWildcard(__webpack_require__(734));
	
	var _configProvider = __webpack_require__(15);
	
	var _Col = _interopRequireDefault(__webpack_require__(1388));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// https://github.com/smooth-code/react-flatten-children/
	function flattenChildren(children) {
	  if (!children) {
	    return [];
	  }
	
	  return (0, _toArray["default"])(children).reduce(function (flatChildren, child) {
	    if (child && child.type === React.Fragment) {
	      return flatChildren.concat(flattenChildren(child.props.children));
	    }
	
	    flatChildren.push(child);
	    return flatChildren;
	  }, []);
	}
	
	var DescriptionsItem = function DescriptionsItem(_ref) {
	  var children = _ref.children;
	  return children;
	};
	/**
	 * Convert children into `column` groups.
	 * @param children: DescriptionsItem
	 * @param column: number
	 */
	
	var generateChildrenRows = function generateChildrenRows(children, column) {
	  var rows = [];
	  var columns = null;
	  var leftSpans;
	  var itemNodes = flattenChildren(children);
	  itemNodes.forEach(function (node, index) {
	    var itemNode = node;
	
	    if (!columns) {
	      leftSpans = column;
	      columns = [];
	      rows.push(columns);
	    } // Always set last span to align the end of Descriptions
	
	
	    var lastItem = index === itemNodes.length - 1;
	    var lastSpanSame = true;
	
	    if (lastItem) {
	      lastSpanSame = !itemNode.props.span || itemNode.props.span === leftSpans;
	      itemNode = /*#__PURE__*/React.cloneElement(itemNode, {
	        span: leftSpans
	      });
	    } // Calculate left fill span
	
	
	    var _itemNode$props$span = itemNode.props.span,
	        span = _itemNode$props$span === void 0 ? 1 : _itemNode$props$span;
	    columns.push(itemNode);
	    leftSpans -= span;
	
	    if (leftSpans <= 0) {
	      columns = null;
	      (0, _warning["default"])(leftSpans === 0 && lastSpanSame, 'Descriptions', 'Sum of column `span` in a line exceeds `column` of Descriptions.');
	    }
	  });
	  return rows;
	};
	
	var renderRow = function renderRow(children, index, _ref2, bordered, layout, colon) {
	  var prefixCls = _ref2.prefixCls;
	
	  var renderCol = function renderCol(colItem, type, idx) {
	    return (/*#__PURE__*/React.createElement(_Col["default"], {
	        child: colItem,
	        bordered: bordered,
	        colon: colon,
	        type: type,
	        key: "".concat(type, "-").concat(colItem.key || idx),
	        layout: layout
	      })
	    );
	  };
	
	  var cloneChildren = [];
	  var cloneContentChildren = [];
	  flattenChildren(children).forEach(function (childrenItem, idx) {
	    cloneChildren.push(renderCol(childrenItem, 'label', idx));
	
	    if (layout === 'vertical') {
	      cloneContentChildren.push(renderCol(childrenItem, 'content', idx));
	    } else if (bordered) {
	      cloneChildren.push(renderCol(childrenItem, 'content', idx));
	    }
	  });
	
	  if (layout === 'vertical') {
	    return [/*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: "label-".concat(index)
	    }, cloneChildren), /*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: "content-".concat(index)
	    }, cloneContentChildren)];
	  }
	
	  return (/*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: index
	    }, cloneChildren)
	  );
	};
	
	var defaultColumnMap = {
	  xxl: 3,
	  xl: 3,
	  lg: 3,
	  md: 3,
	  sm: 2,
	  xs: 1
	};
	
	var Descriptions = /*#__PURE__*/function (_React$Component) {
	  _inherits(Descriptions, _React$Component);
	
	  var _super = _createSuper(Descriptions);
	
	  function Descriptions() {
	    var _this;
	
	    _classCallCheck(this, Descriptions);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      screens: {}
	    };
	    return _this;
	  }
	
	  _createClass(Descriptions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var column = this.props.column;
	      this.token = _responsiveObserve["default"].subscribe(function (screens) {
	        if (_typeof(column) !== 'object') {
	          return;
	        }
	
	        _this2.setState({
	          screens: screens
	        });
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _responsiveObserve["default"].unsubscribe(this.token);
	    }
	  }, {
	    key: "getColumn",
	    value: function getColumn() {
	      var column = this.props.column;
	
	      if (_typeof(column) === 'object') {
	        for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
	          var breakpoint = _responsiveObserve.responsiveArray[i];
	
	          if (this.state.screens[breakpoint] && column[breakpoint] !== undefined) {
	            return column[breakpoint] || defaultColumnMap[breakpoint];
	          }
	        }
	      } // If the configuration is not an object, it is a number, return number
	
	
	      if (typeof column === 'number') {
	        return column;
	      } // If it is an object, but no response is found, this happens only in the test.
	      // Maybe there are some strange environments
	
	
	      return 3;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
	          var _classNames;
	
	          var getPrefixCls = _ref3.getPrefixCls;
	          var _this3$props = _this3.props,
	              className = _this3$props.className,
	              customizePrefixCls = _this3$props.prefixCls,
	              title = _this3$props.title,
	              size = _this3$props.size,
	              children = _this3$props.children,
	              _this3$props$bordered = _this3$props.bordered,
	              bordered = _this3$props$bordered === void 0 ? false : _this3$props$bordered,
	              _this3$props$layout = _this3$props.layout,
	              layout = _this3$props$layout === void 0 ? 'horizontal' : _this3$props$layout,
	              _this3$props$colon = _this3$props.colon,
	              colon = _this3$props$colon === void 0 ? true : _this3$props$colon,
	              style = _this3$props.style;
	          var prefixCls = getPrefixCls('descriptions', customizePrefixCls);
	
	          var column = _this3.getColumn();
	
	          var cloneChildren = flattenChildren(children).map(function (child) {
	            if ( /*#__PURE__*/React.isValidElement(child)) {
	              return (/*#__PURE__*/React.cloneElement(child, {
	                  prefixCls: prefixCls
	                })
	              );
	            }
	
	            return null;
	          }).filter(function (node) {
	            return node;
	          });
	          var childrenArray = generateChildrenRows(cloneChildren, column);
	          return (/*#__PURE__*/React.createElement("div", {
	              className: (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), !!bordered), _classNames)),
	              style: style
	            }, title && /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-title")
	            }, title), /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-view")
	            }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, childrenArray.map(function (child, index) {
	              return renderRow(child, index, {
	                prefixCls: prefixCls
	              }, bordered, layout, colon);
	            })))))
	          );
	        })
	      );
	    }
	  }]);
	
	  return Descriptions;
	}(React.Component);
	
	Descriptions.defaultProps = {
	  size: 'default',
	  column: defaultColumnMap
	};
	Descriptions.Item = DescriptionsItem;
	var _default = Descriptions;
	exports["default"] = _default;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Divider = function Divider(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          _props$type = props.type,
	          type = _props$type === void 0 ? 'horizontal' : _props$type,
	          _props$orientation = props.orientation,
	          orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
	          className = props.className,
	          children = props.children,
	          dashed = props.dashed,
	          restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed"]);
	
	      var prefixCls = getPrefixCls('divider', customizePrefixCls);
	      var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
	      var classString = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), children), _defineProperty(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), _classNames));
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString
	        }, restProps, {
	          role: "separator"
	        }), children && /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-inner-text")
	        }, children))
	      );
	    })
	  );
	};
	
	var _default = Divider;
	exports["default"] = _default;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcDrawer = _interopRequireDefault(__webpack_require__(464));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(60));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _context = __webpack_require__(255);
	
	var _type = __webpack_require__(83);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var DrawerContext = (0, _createReactContext["default"])(null);
	var PlacementTypes = (0, _type.tuple)('top', 'right', 'bottom', 'left');
	
	var Drawer = /*#__PURE__*/function (_React$Component) {
	  _inherits(Drawer, _React$Component);
	
	  var _super = _createSuper(Drawer);
	
	  function Drawer() {
	    var _this;
	
	    _classCallCheck(this, Drawer);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      push: false
	    };
	
	    _this.push = function () {
	      _this.setState({
	        push: true
	      });
	    };
	
	    _this.pull = function () {
	      _this.setState({
	        push: false
	      });
	    };
	
	    _this.onDestroyTransitionEnd = function () {
	      var isDestroyOnClose = _this.getDestroyOnClose();
	
	      if (!isDestroyOnClose) {
	        return;
	      }
	
	      if (!_this.props.visible) {
	        _this.destroyClose = true;
	
	        _this.forceUpdate();
	      }
	    };
	
	    _this.getDestroyOnClose = function () {
	      return _this.props.destroyOnClose && !_this.props.visible;
	    }; // get drawer push width or height
	
	
	    _this.getPushTransform = function (placement) {
	      if (placement === 'left' || placement === 'right') {
	        return "translateX(".concat(placement === 'left' ? 180 : -180, "px)");
	      }
	
	      if (placement === 'top' || placement === 'bottom') {
	        return "translateY(".concat(placement === 'top' ? 180 : -180, "px)");
	      }
	    };
	
	    _this.getRcDrawerStyle = function () {
	      var _this$props = _this.props,
	          zIndex = _this$props.zIndex,
	          placement = _this$props.placement,
	          style = _this$props.style;
	      var push = _this.state.push;
	      return _extends({
	        zIndex: zIndex,
	        transform: push ? _this.getPushTransform(placement) : undefined
	      }, style);
	    }; // render drawer body dom
	
	
	    _this.renderBody = function () {
	      var _this$props2 = _this.props,
	          bodyStyle = _this$props2.bodyStyle,
	          drawerStyle = _this$props2.drawerStyle,
	          prefixCls = _this$props2.prefixCls,
	          visible = _this$props2.visible;
	
	      if (_this.destroyClose && !visible) {
	        return null;
	      }
	
	      _this.destroyClose = false;
	      var containerStyle = {};
	
	      var isDestroyOnClose = _this.getDestroyOnClose();
	
	      if (isDestroyOnClose) {
	        // Increase the opacity transition, delete children after closing.
	        containerStyle.opacity = 0;
	        containerStyle.transition = 'opacity .3s';
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-wrapper-body"),
	          style: _extends(_extends({}, containerStyle), drawerStyle),
	          onTransitionEnd: _this.onDestroyTransitionEnd
	        }, _this.renderHeader(), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-body"),
	          style: bodyStyle
	        }, _this.props.children))
	      );
	    }; // render Provider for Multi-level drawer
	
	
	    _this.renderProvider = function (value) {
	      var _a = _this.props,
	          prefixCls = _a.prefixCls,
	          placement = _a.placement,
	          className = _a.className,
	          wrapClassName = _a.wrapClassName,
	          width = _a.width,
	          height = _a.height,
	          mask = _a.mask,
	          rest = __rest(_a, ["prefixCls", "placement", "className", "wrapClassName", "width", "height", "mask"]);
	
	      (0, _warning["default"])(wrapClassName === undefined, 'Drawer', 'wrapClassName is deprecated, please use className instead.');
	      var haveMask = mask ? '' : 'no-mask';
	      _this.parentDrawer = value;
	      var offsetStyle = {};
	
	      if (placement === 'left' || placement === 'right') {
	        offsetStyle.width = width;
	      } else {
	        offsetStyle.height = height;
	      }
	
	      return (/*#__PURE__*/React.createElement(DrawerContext.Provider, {
	          value: _assertThisInitialized(_this)
	        }, /*#__PURE__*/React.createElement(_rcDrawer["default"], _extends({
	          handler: false
	        }, (0, _omit["default"])(rest, ['zIndex', 'style', 'closable', 'destroyOnClose', 'drawerStyle', 'headerStyle', 'bodyStyle', 'title', 'push', 'visible', 'getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'pageHeader', 'autoInsertSpaceInButton']), offsetStyle, {
	          prefixCls: prefixCls,
	          open: _this.props.visible,
	          showMask: mask,
	          placement: placement,
	          style: _this.getRcDrawerStyle(),
	          className: (0, _classnames["default"])(wrapClassName, className, haveMask)
	        }), _this.renderBody()))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Drawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // fix: delete drawer in child and re-render, no push started.
	      // <Drawer>{show && <Drawer />}</Drawer>
	      var visible = this.props.visible;
	
	      if (visible && this.parentDrawer) {
	        this.parentDrawer.push();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(preProps) {
	      var visible = this.props.visible;
	
	      if (preProps.visible !== visible && this.parentDrawer) {
	        if (visible) {
	          this.parentDrawer.push();
	        } else {
	          this.parentDrawer.pull();
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // unmount drawer in child, clear push.
	      if (this.parentDrawer) {
	        this.parentDrawer.pull();
	        this.parentDrawer = null;
	      }
	    }
	  }, {
	    key: "renderHeader",
	    value: function renderHeader() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          prefixCls = _this$props3.prefixCls,
	          closable = _this$props3.closable,
	          headerStyle = _this$props3.headerStyle;
	
	      if (!title && !closable) {
	        return null;
	      }
	
	      var headerClassName = title ? "".concat(prefixCls, "-header") : "".concat(prefixCls, "-header-no-title");
	      return (/*#__PURE__*/React.createElement("div", {
	          className: headerClassName,
	          style: headerStyle
	        }, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), closable && this.renderCloseIcon())
	      );
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var _this$props4 = this.props,
	          closable = _this$props4.closable,
	          prefixCls = _this$props4.prefixCls,
	          onClose = _this$props4.onClose;
	      return closable &&
	      /*#__PURE__*/
	      // eslint-disable-next-line react/button-has-type
	      React.createElement("button", {
	        onClick: onClose,
	        "aria-label": "Close",
	        className: "".concat(prefixCls, "-close")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close"
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(DrawerContext.Consumer, null, this.renderProvider)
	      );
	    }
	  }]);
	
	  return Drawer;
	}(React.Component);
	
	Drawer.defaultProps = {
	  width: 256,
	  height: 256,
	  closable: true,
	  placement: 'right',
	  maskClosable: true,
	  mask: true,
	  level: null,
	  keyboard: true
	};
	
	var _default = (0, _context.withConfigConsumer)({
	  prefixCls: 'drawer'
	})(Drawer);
	
	exports["default"] = _default;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _button = _interopRequireDefault(__webpack_require__(138));
	
	var _configProvider = __webpack_require__(15);
	
	var _dropdown = _interopRequireDefault(__webpack_require__(378));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = _button["default"].Group;
	
	var DropdownButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(DropdownButton, _React$Component);
	
	  var _super = _createSuper(DropdownButton);
	
	  function DropdownButton() {
	    var _this;
	
	    _classCallCheck(this, DropdownButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderButton = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          onClick = _a.onClick,
	          htmlType = _a.htmlType,
	          children = _a.children,
	          className = _a.className,
	          overlay = _a.overlay,
	          trigger = _a.trigger,
	          align = _a.align,
	          visible = _a.visible,
	          onVisibleChange = _a.onVisibleChange,
	          placement = _a.placement,
	          getPopupContainer = _a.getPopupContainer,
	          href = _a.href,
	          _a$icon = _a.icon,
	          icon = _a$icon === void 0 ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "ellipsis"
	      }) : _a$icon,
	          title = _a.title,
	          restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title"]);
	
	      var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
	      var dropdownProps = {
	        align: align,
	        overlay: overlay,
	        disabled: disabled,
	        trigger: disabled ? [] : trigger,
	        onVisibleChange: onVisibleChange,
	        placement: placement,
	        getPopupContainer: getPopupContainer || getContextPopupContainer
	      };
	
	      if ('visible' in _this.props) {
	        dropdownProps.visible = visible;
	      }
	
	      return (/*#__PURE__*/React.createElement(ButtonGroup, _extends({}, restProps, {
	          className: (0, _classnames["default"])(prefixCls, className)
	        }), /*#__PURE__*/React.createElement(_button["default"], {
	          type: type,
	          disabled: disabled,
	          onClick: onClick,
	          htmlType: htmlType,
	          href: href,
	          title: title
	        }, children), /*#__PURE__*/React.createElement(_dropdown["default"], dropdownProps, /*#__PURE__*/React.createElement(_button["default"], {
	          type: type
	        }, icon)))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(DropdownButton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton)
	      );
	    }
	  }]);
	
	  return DropdownButton;
	}(React.Component);
	
	exports["default"] = DropdownButton;
	DropdownButton.defaultProps = {
	  placement: 'bottomRight',
	  type: 'default'
	};

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Empty = function Empty() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "184",
	      height: "152",
	      viewBox: "0 0 184 152",
	      xmlns: "http://www.w3.org/2000/svg"
	    }, /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(24 31.67)"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      fillOpacity: ".8",
	      fill: "#F5F5F7",
	      cx: "67.797",
	      cy: "106.89",
	      rx: "67.797",
	      ry: "12.668"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
	      fill: "#AEB8C2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
	      fill: "url(#linearGradient-1)",
	      transform: "translate(13.56)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
	      fill: "#F5F5F7"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
	      fill: "#DCE0E6"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
	      fill: "#DCE0E6"
	    }), /*#__PURE__*/React.createElement("g", {
	      transform: "translate(149.65 15.383)",
	      fill: "#FFF"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      cx: "20.654",
	      cy: "3.167",
	      rx: "2.849",
	      ry: "2.815"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
	    }))))
	  );
	};
	
	var _default = Empty;
	exports["default"] = _default;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Simple = function Simple() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "64",
	      height: "41",
	      viewBox: "0 0 64 41",
	      xmlns: "http://www.w3.org/2000/svg"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 1)",
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("ellipse", {
	      fill: "#F5F5F5",
	      cx: "32",
	      cy: "33",
	      rx: "32",
	      ry: "7"
	    }), /*#__PURE__*/React.createElement("g", {
	      fillRule: "nonzero",
	      stroke: "#D9D9D9"
	    }, /*#__PURE__*/React.createElement("path", {
	      d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
	      fill: "#FAFAFA"
	    }))))
	  );
	};
	
	var _default = Simple;
	exports["default"] = _default;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _createDOMForm = _interopRequireDefault(__webpack_require__(467));
	
	var _createFormField = _interopRequireDefault(__webpack_require__(502));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(15);
	
	var _type = __webpack_require__(83);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _FormItem = _interopRequireDefault(__webpack_require__(1396));
	
	var _constants = __webpack_require__(746);
	
	var _context = _interopRequireDefault(__webpack_require__(747));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var FormLayouts = (0, _type.tuple)('horizontal', 'inline', 'vertical');
	
	var Form = /*#__PURE__*/function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  var _super = _createSuper(Form);
	
	  function Form(props) {
	    var _this;
	
	    _classCallCheck(this, Form);
	
	    _this = _super.call(this, props);
	
	    _this.renderForm = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          hideRequiredMark = _this$props.hideRequiredMark,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          layout = _this$props.layout;
	      var prefixCls = getPrefixCls('form', customizePrefixCls);
	      var formClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-horizontal"), layout === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), layout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-inline"), layout === 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _classNames), className);
	      var formProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark', 'wrapperCol', 'labelAlign', 'labelCol', 'colon']);
	      return (/*#__PURE__*/React.createElement("form", _extends({}, formProps, {
	          className: formClassName
	        }))
	      );
	    };
	
	    (0, _warning["default"])(!props.form, 'Form', 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperCol = _this$props2.wrapperCol,
	          labelAlign = _this$props2.labelAlign,
	          labelCol = _this$props2.labelCol,
	          layout = _this$props2.layout,
	          colon = _this$props2.colon;
	      return (/*#__PURE__*/React.createElement(_context["default"].Provider, {
	          value: {
	            wrapperCol: wrapperCol,
	            labelAlign: labelAlign,
	            labelCol: labelCol,
	            vertical: layout === 'vertical',
	            colon: colon
	          }
	        }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderForm))
	      );
	    }
	  }]);
	
	  return Form;
	}(React.Component);
	
	exports["default"] = Form;
	Form.defaultProps = {
	  colon: true,
	  layout: 'horizontal',
	  hideRequiredMark: false,
	  onSubmit: function onSubmit(e) {
	    e.preventDefault();
	  }
	};
	Form.propTypes = {
	  prefixCls: PropTypes.string,
	  layout: PropTypes.oneOf(FormLayouts),
	  children: PropTypes.any,
	  onSubmit: PropTypes.func,
	  hideRequiredMark: PropTypes.bool,
	  colon: PropTypes.bool
	};
	Form.Item = _FormItem["default"];
	Form.createFormField = _createFormField["default"];
	
	Form.create = function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return (0, _createDOMForm["default"])(_extends(_extends({
	    fieldNameProp: 'id'
	  }, options), {
	    fieldMetaProp: _constants.FIELD_META_PROP,
	    fieldDataProp: _constants.FIELD_DATA_PROP
	  }));
	};

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(84));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _row = _interopRequireDefault(__webpack_require__(750));
	
	var _col = _interopRequireDefault(__webpack_require__(749));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _type = __webpack_require__(83);
	
	var _constants = __webpack_require__(746);
	
	var _context = _interopRequireDefault(__webpack_require__(747));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ValidateStatuses = (0, _type.tuple)('success', 'warning', 'error', 'validating', '');
	var FormLabelAligns = (0, _type.tuple)('left', 'right');
	
	function intersperseSpace(list) {
	  return list.reduce(function (current, item) {
	    return [].concat(_toConsumableArray(current), [' ', item]);
	  }, []).slice(1);
	}
	
	var FormItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(FormItem, _React$Component);
	
	  var _super = _createSuper(FormItem);
	
	  function FormItem() {
	    var _this;
	
	    _classCallCheck(this, FormItem);
	
	    _this = _super.apply(this, arguments);
	    _this.helpShow = false; // Resolve duplicated ids bug between different forms
	    // https://github.com/ant-design/ant-design/issues/7351
	
	    _this.onLabelClick = function () {
	      var id = _this.props.id || _this.getId();
	
	      if (!id) {
	        return;
	      }
	
	      var formItemNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var control = formItemNode.querySelector("[id=\"".concat(id, "\"]"));
	
	      if (control && control.focus) {
	        control.focus();
	      }
	    };
	
	    _this.onHelpAnimEnd = function (_key, helpShow) {
	      _this.helpShow = helpShow;
	
	      if (!helpShow) {
	        _this.setState({});
	      }
	    };
	
	    _this.renderFormItem = function (_ref) {
	      var _itemClassName;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          style = _a.style,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "style", "className"]);
	
	      var prefixCls = getPrefixCls('form', customizePrefixCls);
	
	      var children = _this.renderChildren(prefixCls);
	
	      var itemClassName = (_itemClassName = {}, _defineProperty(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-with-help"), _this.helpShow), _defineProperty(_itemClassName, "".concat(className), !!className), _itemClassName);
	      return (/*#__PURE__*/React.createElement(_row["default"], _extends({
	          className: (0, _classnames["default"])(itemClassName),
	          style: style
	        }, (0, _omit["default"])(restProps, ['id', 'htmlFor', 'label', 'labelAlign', 'labelCol', 'wrapperCol', 'help', 'extra', 'validateStatus', 'hasFeedback', 'required', 'colon']), {
	          key: "row"
	        }), children)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(FormItem, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          help = _this$props.help,
	          validateStatus = _this$props.validateStatus,
	          id = _this$props.id;
	      (0, _warning["default"])(this.getControls(children, true).length <= 1 || help !== undefined || validateStatus !== undefined, 'Form.Item', 'Cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
	      (0, _warning["default"])(!id, 'Form.Item', '`id` is deprecated for its label `htmlFor`. Please use `htmlFor` directly.');
	    }
	  }, {
	    key: "getHelpMessage",
	    value: function getHelpMessage() {
	      var help = this.props.help;
	
	      if (help === undefined && this.getOnlyControl()) {
	        var _this$getField = this.getField(),
	            errors = _this$getField.errors;
	
	        if (errors) {
	          return intersperseSpace(errors.map(function (e, index) {
	            var node = null;
	
	            if ( /*#__PURE__*/React.isValidElement(e)) {
	              node = e;
	            } else if ( /*#__PURE__*/React.isValidElement(e.message)) {
	              node = e.message;
	            } // eslint-disable-next-line react/no-array-index-key
	
	
	            return node ? /*#__PURE__*/React.cloneElement(node, {
	              key: index
	            }) : e.message;
	          }));
	        }
	
	        return '';
	      }
	
	      return help;
	    }
	  }, {
	    key: "getControls",
	    value: function getControls(children, recursively) {
	      var controls = [];
	      var childrenArray = React.Children.toArray(children);
	
	      for (var i = 0; i < childrenArray.length; i++) {
	        if (!recursively && controls.length > 0) {
	          break;
	        }
	
	        var child = childrenArray[i];
	
	        if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
	          continue;
	        }
	
	        if (!child.props) {
	          continue;
	        }
	
	        if (_constants.FIELD_META_PROP in child.props) {
	          // And means FIELD_DATA_PROP in child.props, too.
	          controls.push(child);
	        } else if (child.props.children) {
	          controls = controls.concat(this.getControls(child.props.children, recursively));
	        }
	      }
	
	      return controls;
	    }
	  }, {
	    key: "getOnlyControl",
	    value: function getOnlyControl() {
	      var child = this.getControls(this.props.children, false)[0];
	      return child !== undefined ? child : null;
	    }
	  }, {
	    key: "getChildProp",
	    value: function getChildProp(prop) {
	      var child = this.getOnlyControl();
	      return child && child.props && child.props[prop];
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.getChildProp('id');
	    }
	  }, {
	    key: "getMeta",
	    value: function getMeta() {
	      return this.getChildProp(_constants.FIELD_META_PROP);
	    }
	  }, {
	    key: "getField",
	    value: function getField() {
	      return this.getChildProp(_constants.FIELD_DATA_PROP);
	    }
	  }, {
	    key: "getValidateStatus",
	    value: function getValidateStatus() {
	      var onlyControl = this.getOnlyControl();
	
	      if (!onlyControl) {
	        return '';
	      }
	
	      var field = this.getField();
	
	      if (field.validating) {
	        return 'validating';
	      }
	
	      if (field.errors) {
	        return 'error';
	      }
	
	      var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;
	
	      if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
	        return 'success';
	      }
	
	      return '';
	    }
	  }, {
	    key: "isRequired",
	    value: function isRequired() {
	      var required = this.props.required;
	
	      if (required !== undefined) {
	        return required;
	      }
	
	      if (this.getOnlyControl()) {
	        var meta = this.getMeta() || {};
	        var validate = meta.validate || [];
	        return validate.filter(function (item) {
	          return !!item.rules;
	        }).some(function (item) {
	          return item.rules.some(function (rule) {
	            return rule.required;
	          });
	        });
	      }
	
	      return false;
	    }
	  }, {
	    key: "renderHelp",
	    value: function renderHelp(prefixCls) {
	      var help = this.getHelpMessage();
	      var children = help ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-explain"),
	        key: "help"
	      }, help) : null;
	
	      if (children) {
	        this.helpShow = !!children;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "show-help",
	          component: "",
	          transitionAppear: true,
	          key: "help",
	          onEnd: this.onHelpAnimEnd
	        }, children)
	      );
	    }
	  }, {
	    key: "renderExtra",
	    value: function renderExtra(prefixCls) {
	      var extra = this.props.extra;
	      return extra ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra")
	      }, extra) : null;
	    }
	  }, {
	    key: "renderValidateWrapper",
	    value: function renderValidateWrapper(prefixCls, c1, c2, c3) {
	      var props = this.props;
	      var onlyControl = this.getOnlyControl;
	      var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
	      var classes = "".concat(prefixCls, "-item-control");
	
	      if (validateStatus) {
	        classes = (0, _classnames["default"])("".concat(prefixCls, "-item-control"), {
	          'has-feedback': validateStatus && props.hasFeedback,
	          'has-success': validateStatus === 'success',
	          'has-warning': validateStatus === 'warning',
	          'has-error': validateStatus === 'error',
	          'is-validating': validateStatus === 'validating'
	        });
	      }
	
	      var iconType = '';
	
	      switch (validateStatus) {
	        case 'success':
	          iconType = 'check-circle';
	          break;
	
	        case 'warning':
	          iconType = 'exclamation-circle';
	          break;
	
	        case 'error':
	          iconType = 'close-circle';
	          break;
	
	        case 'validating':
	          iconType = 'loading';
	          break;
	
	        default:
	          iconType = '';
	          break;
	      }
	
	      var icon = props.hasFeedback && iconType ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-children-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType,
	        theme: iconType === 'loading' ? 'outlined' : 'filled'
	      })) : null;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: classes
	        }, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-item-children")
	        }, c1, icon), c2, c3)
	      );
	    }
	  }, {
	    key: "renderWrapper",
	    value: function renderWrapper(prefixCls, children) {
	      var _this2 = this;
	
	      return (/*#__PURE__*/React.createElement(_context["default"].Consumer, {
	          key: "wrapper"
	        }, function (_ref2) {
	          var contextWrapperCol = _ref2.wrapperCol,
	              vertical = _ref2.vertical;
	          var wrapperCol = _this2.props.wrapperCol;
	          var mergedWrapperCol = ('wrapperCol' in _this2.props ? wrapperCol : contextWrapperCol) || {};
	          var className = (0, _classnames["default"])("".concat(prefixCls, "-item-control-wrapper"), mergedWrapperCol.className); // No pass FormContext since it's useless
	
	          return (/*#__PURE__*/React.createElement(_context["default"].Provider, {
	              value: {
	                vertical: vertical
	              }
	            }, /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedWrapperCol, {
	              className: className
	            }), children))
	          );
	        })
	      );
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel(prefixCls) {
	      var _this3 = this;
	
	      return (/*#__PURE__*/React.createElement(_context["default"].Consumer, {
	          key: "label"
	        }, function (_ref3) {
	          var _classNames;
	
	          var vertical = _ref3.vertical,
	              contextLabelAlign = _ref3.labelAlign,
	              contextLabelCol = _ref3.labelCol,
	              contextColon = _ref3.colon;
	          var _this3$props = _this3.props,
	              label = _this3$props.label,
	              labelCol = _this3$props.labelCol,
	              labelAlign = _this3$props.labelAlign,
	              colon = _this3$props.colon,
	              id = _this3$props.id,
	              htmlFor = _this3$props.htmlFor;
	
	          var required = _this3.isRequired();
	
	          var mergedLabelCol = ('labelCol' in _this3.props ? labelCol : contextLabelCol) || {};
	          var mergedLabelAlign = 'labelAlign' in _this3.props ? labelAlign : contextLabelAlign;
	          var labelClsBasic = "".concat(prefixCls, "-item-label");
	          var labelColClassName = (0, _classnames["default"])(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className);
	          var labelChildren = label; // Keep label is original where there should have no colon
	
	          var computedColon = colon === true || contextColon !== false && colon !== false;
	          var haveColon = computedColon && !vertical; // Remove duplicated user input colon
	
	          if (haveColon && typeof label === 'string' && label.trim() !== '') {
	            labelChildren = label.replace(/[：:]\s*$/, '');
	          }
	
	          var labelClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-required"), required), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
	          return label ? /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedLabelCol, {
	            className: labelColClassName
	          }), /*#__PURE__*/React.createElement("label", {
	            htmlFor: htmlFor || id || _this3.getId(),
	            className: labelClassName,
	            title: typeof label === 'string' ? label : '',
	            onClick: _this3.onLabelClick
	          }, labelChildren)) : null;
	        })
	      );
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(prefixCls) {
	      var children = this.props.children;
	      return [this.renderLabel(prefixCls), this.renderWrapper(prefixCls, this.renderValidateWrapper(prefixCls, children, this.renderHelp(prefixCls), this.renderExtra(prefixCls)))];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderFormItem)
	      );
	    }
	  }]);
	
	  return FormItem;
	}(React.Component);
	
	exports["default"] = FormItem;
	FormItem.defaultProps = {
	  hasFeedback: false
	};
	FormItem.propTypes = {
	  prefixCls: PropTypes.string,
	  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	  labelCol: PropTypes.object,
	  help: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
	  validateStatus: PropTypes.oneOf(ValidateStatuses),
	  hasFeedback: PropTypes.bool,
	  wrapperCol: PropTypes.object,
	  className: PropTypes.string,
	  id: PropTypes.string,
	  children: PropTypes.node,
	  colon: PropTypes.bool
	};

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Form = _interopRequireDefault(__webpack_require__(1395));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Form["default"];
	exports["default"] = _default;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = create;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _index = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var customCache = new Set();
	
	function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var scriptUrl = options.scriptUrl,
	      _options$extraCommonP = options.extraCommonProps,
	      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
	  /**
	   * DOM API required.
	   * Make sure in browser environment.
	   * The Custom Icon will create a <script/>
	   * that loads SVG symbols and insert the SVG Element into the document body.
	   */
	
	  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
	    var script = document.createElement('script');
	    script.setAttribute('src', scriptUrl);
	    script.setAttribute('data-namespace', scriptUrl);
	    customCache.add(scriptUrl);
	    document.body.appendChild(script);
	  }
	
	  var Iconfont = function Iconfont(props) {
	    var type = props.type,
	        children = props.children,
	        restProps = __rest(props, ["type", "children"]); // component > children > type
	
	
	    var content = null;
	
	    if (props.type) {
	      content = /*#__PURE__*/React.createElement("use", {
	        xlinkHref: "#".concat(type)
	      });
	    }
	
	    if (children) {
	      content = children;
	    }
	
	    return (/*#__PURE__*/React.createElement(_index["default"], _extends({}, extraCommonProps, restProps), content)
	    );
	  };
	
	  Iconfont.displayName = 'Iconfont';
	  return Iconfont;
	}

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTwoToneColor = setTwoToneColor;
	exports.getTwoToneColor = getTwoToneColor;
	
	var _iconsReact = _interopRequireDefault(__webpack_require__(184));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function setTwoToneColor(primaryColor) {
	  return _iconsReact["default"].setTwoToneColors({
	    primaryColor: primaryColor
	  });
	}
	
	function getTwoToneColor() {
	  var colors = _iconsReact["default"].getTwoToneColors();
	
	  return colors.primaryColor;
	}

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getThemeFromTypeName = getThemeFromTypeName;
	exports.removeTypeTheme = removeTypeTheme;
	exports.withThemeSuffix = withThemeSuffix;
	exports.alias = alias;
	exports.svgBaseProps = void 0;
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	// These props make sure that the SVG behaviours like general text.
	// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
	var svgBaseProps = {
	  width: '1em',
	  height: '1em',
	  fill: 'currentColor',
	  'aria-hidden': true,
	  focusable: 'false'
	};
	exports.svgBaseProps = svgBaseProps;
	var fillTester = /-fill$/;
	var outlineTester = /-o$/;
	var twoToneTester = /-twotone$/;
	
	function getThemeFromTypeName(type) {
	  var result = null;
	
	  if (fillTester.test(type)) {
	    result = 'filled';
	  } else if (outlineTester.test(type)) {
	    result = 'outlined';
	  } else if (twoToneTester.test(type)) {
	    result = 'twoTone';
	  }
	
	  return result;
	}
	
	function removeTypeTheme(type) {
	  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
	}
	
	function withThemeSuffix(type, theme) {
	  var result = type;
	
	  if (theme === 'filled') {
	    result += '-fill';
	  } else if (theme === 'outlined') {
	    result += '-o';
	  } else if (theme === 'twoTone') {
	    result += '-twotone';
	  } else {
	    (0, _warning["default"])(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
	  }
	
	  return result;
	} // For alias or compatibility
	
	
	function alias(type) {
	  var newType = type;
	
	  switch (type) {
	    case 'cross':
	      newType = 'close';
	      break;
	    // https://github.com/ant-design/ant-design/issues/13007
	
	    case 'interation':
	      newType = 'interaction';
	      break;
	    // https://github.com/ant-design/ant-design/issues/16810
	
	    case 'canlendar':
	      newType = 'calendar';
	      break;
	    // https://github.com/ant-design/ant-design/issues/17448
	
	    case 'colum-height':
	      newType = 'column-height';
	      break;
	
	    default:
	  }
	
	  (0, _warning["default"])(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
	  return newType;
	}

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _rcInputNumber = _interopRequireDefault(__webpack_require__(468));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var InputNumber = /*#__PURE__*/function (_React$Component) {
	  _inherits(InputNumber, _React$Component);
	
	  var _super = _createSuper(InputNumber);
	
	  function InputNumber() {
	    var _this;
	
	    _classCallCheck(this, InputNumber);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInputNumber = function (inputNumberRef) {
	      _this.inputNumberRef = inputNumberRef;
	    };
	
	    _this.renderInputNumber = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          className = _a.className,
	          size = _a.size,
	          customizePrefixCls = _a.prefixCls,
	          others = __rest(_a, ["className", "size", "prefixCls"]);
	
	      var prefixCls = getPrefixCls('input-number', customizePrefixCls);
	      var inputNumberClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className);
	      var upIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "up",
	        className: "".concat(prefixCls, "-handler-up-inner")
	      });
	      var downIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-handler-down-inner")
	      });
	      return (/*#__PURE__*/React.createElement(_rcInputNumber["default"], _extends({
	          ref: _this.saveInputNumber,
	          className: inputNumberClass,
	          upHandler: upIcon,
	          downHandler: downIcon,
	          prefixCls: prefixCls
	        }, others))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(InputNumber, [{
	    key: "focus",
	    value: function focus() {
	      this.inputNumberRef.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.inputNumberRef.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderInputNumber)
	      );
	    }
	  }]);
	
	  return InputNumber;
	}(React.Component);
	
	exports["default"] = InputNumber;
	InputNumber.defaultProps = {
	  step: 1
	};

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var Group = function Group(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var customizePrefixCls = props.prefixCls,
	          _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className;
	      var prefixCls = getPrefixCls('input-group', customizePrefixCls);
	      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
	      return (/*#__PURE__*/React.createElement("span", {
	          className: cls,
	          style: props.style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave,
	          onFocus: props.onFocus,
	          onBlur: props.onBlur
	        }, props.children)
	      );
	    })
	  );
	};
	
	var _default = Group;
	exports["default"] = _default;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _Input = _interopRequireDefault(__webpack_require__(207));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ActionMap = {
	  click: 'onClick',
	  hover: 'onMouseOver'
	};
	
	var Password = /*#__PURE__*/function (_React$Component) {
	  _inherits(Password, _React$Component);
	
	  var _super = _createSuper(Password);
	
	  function Password() {
	    var _this;
	
	    _classCallCheck(this, Password);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      visible: false
	    };
	
	    _this.onVisibleChange = function () {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setState(function (_ref) {
	        var visible = _ref.visible;
	        return {
	          visible: !visible
	        };
	      });
	    };
	
	    _this.saveInput = function (instance) {
	      if (instance && instance.input) {
	        _this.input = instance.input;
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Password, [{
	    key: "getIcon",
	    value: function getIcon() {
	      var _iconProps;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          action = _this$props.action;
	      var iconTrigger = ActionMap[action] || '';
	      var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, this.onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "type", this.state.visible ? 'eye' : 'eye-invisible'), _defineProperty(_iconProps, "key", 'passwordIcon'), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
	        // Prevent focused state lost
	        // https://github.com/ant-design/ant-design/issues/15173
	        e.preventDefault();
	      }), _iconProps);
	      return (/*#__PURE__*/React.createElement(_icon["default"], iconProps)
	      );
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          inputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          visibilityToggle = _a.visibilityToggle,
	          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);
	
	      var suffixIcon = visibilityToggle && this.getIcon();
	      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	      return (/*#__PURE__*/React.createElement(_Input["default"], _extends({}, (0, _omit["default"])(restProps, ['suffix']), {
	          type: this.state.visible ? 'text' : 'password',
	          size: size,
	          className: inputClassName,
	          prefixCls: inputPrefixCls,
	          suffix: suffixIcon,
	          ref: this.saveInput
	        }))
	      );
	    }
	  }]);
	
	  return Password;
	}(React.Component);
	
	exports["default"] = Password;
	Password.defaultProps = {
	  inputPrefixCls: 'ant-input',
	  prefixCls: 'ant-input-password',
	  action: 'click',
	  visibilityToggle: true
	};

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(119));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(1406));
	
	var _raf = _interopRequireDefault(__webpack_require__(205));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ResizableTextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(ResizableTextArea, _React$Component);
	
	  var _super = _createSuper(ResizableTextArea);
	
	  function ResizableTextArea(props) {
	    var _this;
	
	    _classCallCheck(this, ResizableTextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (textArea) {
	      _this.textArea = textArea;
	    };
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.nextFrameActionId);
	
	      _this.nextFrameActionId = (0, _raf["default"])(_this.resizeTextarea);
	    };
	
	    _this.resizeTextarea = function () {
	      var autoSize = _this.props.autoSize || _this.props.autosize;
	
	      if (!autoSize || !_this.textArea) {
	        return;
	      }
	
	      var minRows = autoSize.minRows,
	          maxRows = autoSize.maxRows;
	      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textArea, false, minRows, maxRows);
	
	      _this.setState({
	        textareaStyles: textareaStyles,
	        resizing: true
	      }, function () {
	        _raf["default"].cancel(_this.resizeFrameId);
	
	        _this.resizeFrameId = (0, _raf["default"])(function () {
	          _this.setState({
	            resizing: false
	          });
	
	          _this.fixFirefoxAutoScroll();
	        });
	      });
	    };
	
	    _this.renderTextArea = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          autoSize = _this$props.autoSize,
	          autosize = _this$props.autosize,
	          className = _this$props.className,
	          disabled = _this$props.disabled;
	      var _this$state = _this.state,
	          textareaStyles = _this$state.textareaStyles,
	          resizing = _this$state.resizing;
	      (0, _warning["default"])(autosize === undefined, 'Input.TextArea', 'autosize is deprecated, please use autoSize instead.');
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'autosize', 'defaultValue', 'allowClear']);
	      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
	      // Make sure it could be reset when using form.getFieldDecorator
	
	      if ('value' in otherProps) {
	        otherProps.value = otherProps.value || '';
	      }
	
	      var style = _extends(_extends(_extends({}, _this.props.style), textareaStyles), resizing ? {
	        overflowX: 'hidden',
	        overflowY: 'hidden'
	      } : null);
	
	      return (/*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: _this.resizeOnNextFrame,
	          disabled: !(autoSize || autosize)
	        }, /*#__PURE__*/React.createElement("textarea", _extends({}, otherProps, {
	          className: cls,
	          style: style,
	          ref: _this.saveTextArea
	        })))
	      );
	    };
	
	    _this.state = {
	      textareaStyles: {},
	      resizing: false
	    };
	    return _this;
	  }
	
	  _createClass(ResizableTextArea, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resizeTextarea();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // Re-render with the new content then recalculate the height as required.
	      if (prevProps.value !== this.props.value) {
	        this.resizeTextarea();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.nextFrameActionId);
	
	      _raf["default"].cancel(this.resizeFrameId);
	    } // https://github.com/ant-design/ant-design/issues/21870
	
	  }, {
	    key: "fixFirefoxAutoScroll",
	    value: function fixFirefoxAutoScroll() {
	      try {
	        if (document.activeElement === this.textArea) {
	          var currentStart = this.textArea.selectionStart;
	          var currentEnd = this.textArea.selectionEnd;
	          this.textArea.setSelectionRange(currentStart, currentEnd);
	        }
	      } catch (e) {// Fix error in Chrome:
	        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
	        // http://stackoverflow.com/q/21177489/3040605
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderTextArea();
	    }
	  }]);
	
	  return ResizableTextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ResizableTextArea);
	var _default = ResizableTextArea;
	exports["default"] = _default;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _isMobile = __webpack_require__(510);
	
	var _Input = _interopRequireDefault(__webpack_require__(207));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _button = _interopRequireDefault(__webpack_require__(138));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.onChange = function (e) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onSearch = _this$props.onSearch;
	
	      if (e && e.target && e.type === 'click' && onSearch) {
	        onSearch(e.target.value, e);
	      }
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.onSearch = function (e) {
	      var _this$props2 = _this.props,
	          onSearch = _this$props2.onSearch,
	          loading = _this$props2.loading,
	          disabled = _this$props2.disabled;
	
	      if (loading || disabled) {
	        return;
	      }
	
	      if (onSearch) {
	        onSearch(_this.input.input.value, e);
	      }
	
	      if (!(0, _isMobile.isMobile)({
	        tablet: true
	      })) {
	        _this.input.focus();
	      }
	    };
	
	    _this.renderLoading = function (prefixCls) {
	      var _this$props3 = _this.props,
	          enterButton = _this$props3.enterButton,
	          size = _this$props3.size;
	
	      if (enterButton) {
	        return (/*#__PURE__*/React.createElement(_button["default"], {
	            className: "".concat(prefixCls, "-button"),
	            type: "primary",
	            size: size,
	            key: "enterButton"
	          }, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading"
	          }))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          className: "".concat(prefixCls, "-icon"),
	          type: "loading",
	          key: "loadingIcon"
	        })
	      );
	    };
	
	    _this.renderSuffix = function (prefixCls) {
	      var _this$props4 = _this.props,
	          suffix = _this$props4.suffix,
	          enterButton = _this$props4.enterButton,
	          loading = _this$props4.loading;
	
	      if (loading && !enterButton) {
	        return [suffix, _this.renderLoading(prefixCls)];
	      }
	
	      if (enterButton) return suffix;
	      var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: "search",
	        key: "searchIcon",
	        onClick: _this.onSearch
	      });
	
	      if (suffix) {
	        return [/*#__PURE__*/React.isValidElement(suffix) ? /*#__PURE__*/React.cloneElement(suffix, {
	          key: 'suffix'
	        }) : null, icon];
	      }
	
	      return icon;
	    };
	
	    _this.renderAddonAfter = function (prefixCls) {
	      var _this$props5 = _this.props,
	          enterButton = _this$props5.enterButton,
	          size = _this$props5.size,
	          disabled = _this$props5.disabled,
	          addonAfter = _this$props5.addonAfter,
	          loading = _this$props5.loading;
	      var btnClassName = "".concat(prefixCls, "-button");
	
	      if (loading && enterButton) {
	        return [_this.renderLoading(prefixCls), addonAfter];
	      }
	
	      if (!enterButton) return addonAfter;
	      var button;
	      var enterButtonAsElement = enterButton;
	      var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
	
	      if (isAntdButton || enterButtonAsElement.type === 'button') {
	        button = /*#__PURE__*/React.cloneElement(enterButtonAsElement, _extends({
	          onClick: _this.onSearch,
	          key: 'enterButton'
	        }, isAntdButton ? {
	          className: btnClassName,
	          size: size
	        } : {}));
	      } else {
	        button = /*#__PURE__*/React.createElement(_button["default"], {
	          className: btnClassName,
	          type: "primary",
	          size: size,
	          disabled: disabled,
	          key: "enterButton",
	          onClick: _this.onSearch
	        }, enterButton === true ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "search"
	        }) : enterButton);
	      }
	
	      if (addonAfter) {
	        return [button, /*#__PURE__*/React.isValidElement(addonAfter) ? /*#__PURE__*/React.cloneElement(addonAfter, {
	          key: 'addonAfter'
	        }) : null];
	      }
	
	      return button;
	    };
	
	    _this.renderSearch = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeInputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          enterButton = _a.enterButton,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "inputPrefixCls", "size", "enterButton", "className"]);
	
	      delete restProps.onSearch;
	      delete restProps.loading;
	      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var inputClassName;
	
	      if (enterButton) {
	        var _classNames;
	
	        inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
	      } else {
	        inputClassName = (0, _classnames["default"])(prefixCls, className);
	      }
	
	      return (/*#__PURE__*/React.createElement(_Input["default"], _extends({
	          onPressEnter: _this.onSearch
	        }, restProps, {
	          size: size,
	          prefixCls: inputPrefixCls,
	          addonAfter: _this.renderAddonAfter(prefixCls),
	          suffix: _this.renderSuffix(prefixCls),
	          onChange: _this.onChange,
	          ref: _this.saveInput,
	          className: inputClassName
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch)
	      );
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  enterButton: false
	};

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateNodeStyling = calculateNodeStyling;
	exports["default"] = calculateNodeHeight;
	// Thanks to https://github.com/andreypopp/react-textarea-autosize/
	
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	var computedStyleCache = {};
	var hiddenTextarea;
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	  var sizingStyle = SIZING_STYLE.map(function (name) {
	    return "".concat(name, ":").concat(style.getPropertyValue(name));
	  }).join(';');
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  } // Fix wrap="off" issue
	  // https://github.com/ant-design/ant-design/issues/6577
	
	
	  if (uiTextNode.getAttribute('wrap')) {
	    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
	  } else {
	    hiddenTextarea.removeAttribute('wrap');
	  } // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	
	  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
	  var minHeight = Number.MIN_SAFE_INTEGER;
	  var maxHeight = Number.MAX_SAFE_INTEGER;
	  var height = hiddenTextarea.scrollHeight;
	  var overflowY;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height += borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height -= paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = ' ';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	
	      height = Math.max(minHeight, height);
	    }
	
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	
	      overflowY = height > maxHeight ? '' : 'hidden';
	      height = Math.min(maxHeight, height);
	    }
	  }
	
	  return {
	    height: height,
	    minHeight: minHeight,
	    maxHeight: maxHeight,
	    overflowY: overflowY
	  };
	}

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _layout = _interopRequireDefault(__webpack_require__(753));
	
	var _Sider = _interopRequireDefault(__webpack_require__(380));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_layout["default"].Sider = _Sider["default"];
	var _default = _layout["default"];
	exports["default"] = _default;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Meta = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _grid = __webpack_require__(256);
	
	var _configProvider = __webpack_require__(15);
	
	var _reactNode = __webpack_require__(733);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Meta = function Meta(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          avatar = props.avatar,
	          title = props.title,
	          description = props.description,
	          others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-item-meta"), className);
	      var content = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-meta-content")
	      }, title && /*#__PURE__*/React.createElement("h4", {
	        className: "".concat(prefixCls, "-item-meta-title")
	      }, title), description && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-meta-description")
	      }, description));
	      return (/*#__PURE__*/React.createElement("div", _extends({}, others, {
	          className: classString
	        }), avatar && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-meta-avatar")
	        }, avatar), (title || description) && content)
	      );
	    })
	  );
	};
	
	exports.Meta = Meta;
	
	function getGrid(grid, t) {
	  return grid[t] && Math.floor(24 / grid[t]);
	}
	
	var Item = /*#__PURE__*/function (_React$Component) {
	  _inherits(Item, _React$Component);
	
	  var _super = _createSuper(Item);
	
	  function Item() {
	    var _this;
	
	    _classCallCheck(this, Item);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderItem = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	      var _this$context = _this.context,
	          grid = _this$context.grid,
	          itemLayout = _this$context.itemLayout;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          children = _a.children,
	          actions = _a.actions,
	          extra = _a.extra,
	          className = _a.className,
	          others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var actionsContent = actions && actions.length > 0 && /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-item-action"),
	        key: "actions"
	      }, actions.map(function (action, i) {
	        return (
	          /*#__PURE__*/
	          // eslint-disable-next-line react/no-array-index-key
	          React.createElement("li", {
	            key: "".concat(prefixCls, "-item-action-").concat(i)
	          }, action, i !== actions.length - 1 && /*#__PURE__*/React.createElement("em", {
	            className: "".concat(prefixCls, "-item-action-split")
	          }))
	        );
	      }));
	      var Tag = grid ? 'div' : 'li';
	      var itemChildren = /*#__PURE__*/React.createElement(Tag, _extends({}, others, {
	        // `li` element `onCopy` prop args is not same as `div`
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className, _defineProperty({}, "".concat(prefixCls, "-item-no-flex"), !_this.isFlexMode()))
	      }), itemLayout === 'vertical' && extra ? [/*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-main"),
	        key: "content"
	      }, children, actionsContent), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-extra"),
	        key: "extra"
	      }, extra)] : [children, actionsContent, (0, _reactNode.cloneElement)(extra, {
	        key: 'extra'
	      })]);
	      return grid ? /*#__PURE__*/React.createElement(_grid.Col, {
	        span: getGrid(grid, 'column'),
	        xs: getGrid(grid, 'xs'),
	        sm: getGrid(grid, 'sm'),
	        md: getGrid(grid, 'md'),
	        lg: getGrid(grid, 'lg'),
	        xl: getGrid(grid, 'xl'),
	        xxl: getGrid(grid, 'xxl')
	      }, itemChildren) : itemChildren;
	    };
	
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: "isItemContainsTextNodeAndNotSingular",
	    value: function isItemContainsTextNodeAndNotSingular() {
	      var children = this.props.children;
	      var result;
	      React.Children.forEach(children, function (element) {
	        if (typeof element === 'string') {
	          result = true;
	        }
	      });
	      return result && React.Children.count(children) > 1;
	    }
	  }, {
	    key: "isFlexMode",
	    value: function isFlexMode() {
	      var extra = this.props.extra;
	      var itemLayout = this.context.itemLayout;
	
	      if (itemLayout === 'vertical') {
	        return !!extra;
	      }
	
	      return !this.isItemContainsTextNodeAndNotSingular();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderItem)
	      );
	    }
	  }]);
	
	  return Item;
	}(React.Component);
	
	exports["default"] = Item;
	Item.Meta = Meta;
	Item.contextTypes = {
	  grid: PropTypes.any,
	  itemLayout: PropTypes.string
	};

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _spin = _interopRequireDefault(__webpack_require__(259));
	
	var _configProvider = __webpack_require__(15);
	
	var _pagination = _interopRequireDefault(__webpack_require__(384));
	
	var _grid = __webpack_require__(256);
	
	var _Item = _interopRequireDefault(__webpack_require__(1408));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var List = /*#__PURE__*/function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  var _super = _createSuper(List);
	
	  function List(props) {
	    var _this;
	
	    _classCallCheck(this, List);
	
	    _this = _super.call(this, props);
	    _this.defaultPaginationProps = {
	      current: 1,
	      total: 0
	    };
	    _this.keys = {};
	    _this.onPaginationChange = _this.triggerPaginationEvent('onChange');
	    _this.onPaginationShowSizeChange = _this.triggerPaginationEvent('onShowSizeChange');
	
	    _this.renderItem = function (item, index) {
	      var _this$props = _this.props,
	          renderItem = _this$props.renderItem,
	          rowKey = _this$props.rowKey;
	      if (!renderItem) return null;
	      var key;
	
	      if (typeof rowKey === 'function') {
	        key = rowKey(item);
	      } else if (typeof rowKey === 'string') {
	        key = item[rowKey];
	      } else {
	        key = item.key;
	      }
	
	      if (!key) {
	        key = "list-item-".concat(index);
	      }
	
	      _this.keys[index] = key;
	      return renderItem(item, index);
	    };
	
	    _this.renderEmpty = function (prefixCls, renderEmpty) {
	      var locale = _this.props.locale;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-empty-text")
	        }, locale && locale.emptyText || renderEmpty('List'))
	      );
	    };
	
	    _this.renderList = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	      var _this$state = _this.state,
	          paginationCurrent = _this$state.paginationCurrent,
	          paginationSize = _this$state.paginationSize;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          bordered = _a.bordered,
	          split = _a.split,
	          className = _a.className,
	          children = _a.children,
	          itemLayout = _a.itemLayout,
	          loadMore = _a.loadMore,
	          pagination = _a.pagination,
	          grid = _a.grid,
	          _a$dataSource = _a.dataSource,
	          dataSource = _a$dataSource === void 0 ? [] : _a$dataSource,
	          size = _a.size,
	          header = _a.header,
	          footer = _a.footer,
	          loading = _a.loading,
	          rest = __rest(_a, ["prefixCls", "bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "grid", "dataSource", "size", "header", "footer", "loading"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var loadingProp = loading;
	
	      if (typeof loadingProp === 'boolean') {
	        loadingProp = {
	          spinning: loadingProp
	        };
	      }
	
	      var isLoading = loadingProp && loadingProp.spinning; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-split"), split), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), isLoading), _defineProperty(_classNames, "".concat(prefixCls, "-grid"), grid), _defineProperty(_classNames, "".concat(prefixCls, "-something-after-last-item"), _this.isSomethingAfterLastItem()), _classNames));
	
	      var paginationProps = _extends(_extends(_extends({}, _this.defaultPaginationProps), {
	        total: dataSource.length,
	        current: paginationCurrent,
	        pageSize: paginationSize
	      }), pagination || {});
	
	      var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
	
	      if (paginationProps.current > largestPage) {
	        paginationProps.current = largestPage;
	      }
	
	      var paginationContent = pagination ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-pagination")
	      }, /*#__PURE__*/React.createElement(_pagination["default"], _extends({}, paginationProps, {
	        onChange: _this.onPaginationChange,
	        onShowSizeChange: _this.onPaginationShowSizeChange
	      }))) : null;
	
	      var splitDataSource = _toConsumableArray(dataSource);
	
	      if (pagination) {
	        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
	          splitDataSource = _toConsumableArray(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
	        }
	      }
	
	      var childrenContent;
	      childrenContent = isLoading && /*#__PURE__*/React.createElement("div", {
	        style: {
	          minHeight: 53
	        }
	      });
	
	      if (splitDataSource.length > 0) {
	        var items = splitDataSource.map(function (item, index) {
	          return _this.renderItem(item, index);
	        });
	        var childrenList = [];
	        React.Children.forEach(items, function (child, index) {
	          childrenList.push( /*#__PURE__*/React.cloneElement(child, {
	            key: _this.keys[index]
	          }));
	        });
	        childrenContent = grid ? /*#__PURE__*/React.createElement(_grid.Row, {
	          gutter: grid.gutter
	        }, childrenList) : /*#__PURE__*/React.createElement("ul", {
	          className: "".concat(prefixCls, "-items")
	        }, childrenList);
	      } else if (!children && !isLoading) {
	        childrenContent = _this.renderEmpty(prefixCls, renderEmpty);
	      }
	
	      var paginationPosition = paginationProps.position || 'bottom';
	      return (/*#__PURE__*/React.createElement("div", _extends({
	          className: classString
	        }, (0, _omit["default"])(rest, ['rowKey', 'renderItem', 'locale'])), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-header")
	        }, header), /*#__PURE__*/React.createElement(_spin["default"], loadingProp, childrenContent, children), footer && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-footer")
	        }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent)
	      );
	    };
	
	    var pagination = props.pagination;
	    var paginationObj = pagination && _typeof(pagination) === 'object' ? pagination : {};
	    _this.state = {
	      paginationCurrent: paginationObj.defaultCurrent || 1,
	      paginationSize: paginationObj.defaultPageSize || 10
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        grid: this.props.grid,
	        itemLayout: this.props.itemLayout
	      };
	    }
	  }, {
	    key: "triggerPaginationEvent",
	    value: function triggerPaginationEvent(eventName) {
	      var _this2 = this;
	
	      return function (page, pageSize) {
	        var pagination = _this2.props.pagination;
	
	        _this2.setState({
	          paginationCurrent: page,
	          paginationSize: pageSize
	        });
	
	        if (pagination && pagination[eventName]) {
	          pagination[eventName](page, pageSize);
	        }
	      };
	    }
	  }, {
	    key: "isSomethingAfterLastItem",
	    value: function isSomethingAfterLastItem() {
	      var _this$props2 = this.props,
	          loadMore = _this$props2.loadMore,
	          pagination = _this$props2.pagination,
	          footer = _this$props2.footer;
	      return !!(loadMore || pagination || footer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderList)
	      );
	    }
	  }]);
	
	  return List;
	}(React.Component);
	
	exports["default"] = List;
	List.Item = _Item["default"];
	List.childContextTypes = {
	  grid: PropTypes.any,
	  itemLayout: PropTypes.string
	};
	List.defaultProps = {
	  dataSource: [],
	  bordered: false,
	  split: true,
	  loading: false,
	  pagination: false
	};

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _default2 = _interopRequireDefault(__webpack_require__(164));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _default2["default"];
	exports["default"] = _default;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcEditorMention = _interopRequireWildcard(__webpack_require__(466));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Mention = /*#__PURE__*/function (_React$Component) {
	  _inherits(Mention, _React$Component);
	
	  var _super = _createSuper(Mention);
	
	  function Mention(props) {
	    var _this;
	
	    _classCallCheck(this, Mention);
	
	    _this = _super.call(this, props);
	
	    _this.mentionRef = function (ele) {
	      _this.mentionEle = ele;
	    };
	
	    _this.onSearchChange = function (value, prefix) {
	      if (_this.props.onSearchChange) {
	        return _this.props.onSearchChange(value, prefix);
	      }
	
	      return _this.defaultSearchChange(value);
	    };
	
	    _this.onChange = function (editorState) {
	      if (_this.props.onChange) {
	        _this.props.onChange(editorState);
	      }
	    };
	
	    _this.onFocus = function (ev) {
	      _this.setState({
	        focus: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(ev);
	      }
	    };
	
	    _this.onBlur = function (ev) {
	      _this.setState({
	        focus: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(ev);
	      }
	    };
	
	    _this.focus = function () {
	      _this.mentionEle._editor.focusEditor();
	    };
	
	    _this.renderMention = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          loading = _this$props.loading,
	          placement = _this$props.placement,
	          suggestions = _this$props.suggestions;
	      var _this$state = _this.state,
	          filteredSuggestions = _this$state.filteredSuggestions,
	          focus = _this$state.focus;
	      var prefixCls = getPrefixCls('mention', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-active"), focus), _defineProperty(_classNames, "".concat(prefixCls, "-placement-top"), placement === 'top'), _classNames));
	      var notFoundContent = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "loading"
	      }) : _this.props.notFoundContent;
	      return (/*#__PURE__*/React.createElement(_rcEditorMention["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          className: cls,
	          ref: _this.mentionRef,
	          onSearchChange: _this.onSearchChange,
	          onChange: _this.onChange,
	          onFocus: _this.onFocus,
	          onBlur: _this.onBlur,
	          suggestions: suggestions || filteredSuggestions,
	          notFoundContent: notFoundContent
	        }))
	      );
	    };
	
	    _this.state = {
	      filteredSuggestions: props.defaultSuggestions,
	      focus: false
	    };
	    (0, _warning["default"])(false, 'Mention', 'Mention component is deprecated. Please use Mentions component instead.');
	    return _this;
	  }
	
	  _createClass(Mention, [{
	    key: "defaultSearchChange",
	    value: function defaultSearchChange(value) {
	      var searchValue = value.toLowerCase();
	      var filteredSuggestions = (this.props.defaultSuggestions || []).filter(function (suggestion) {
	        if (typeof suggestion === 'string') {
	          return suggestion.toLowerCase().indexOf(searchValue) !== -1;
	        }
	
	        if (suggestion.type && suggestion.type === _rcEditorMention.Nav) {
	          return suggestion.props.value ? suggestion.props.value.toLowerCase().indexOf(searchValue) !== -1 : true;
	        }
	
	        return false;
	      });
	      this.setState({
	        filteredSuggestions: filteredSuggestions
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMention)
	      );
	    }
	  }]);
	
	  return Mention;
	}(React.Component);
	
	Mention.getMentions = _rcEditorMention.getMentions;
	Mention.defaultProps = {
	  notFoundContent: 'No matches found',
	  loading: false,
	  multiLines: false,
	  placement: 'bottom'
	};
	Mention.Nav = _rcEditorMention.Nav;
	Mention.toString = _rcEditorMention.toString;
	Mention.toContentState = _rcEditorMention.toEditorState;
	(0, _reactLifecyclesCompat.polyfill)(Mention);
	var _default = Mention;
	exports["default"] = _default;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcMentions = _interopRequireDefault(__webpack_require__(469));
	
	var _spin = _interopRequireDefault(__webpack_require__(259));
	
	var _configProvider = __webpack_require__(15);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Option = _rcMentions["default"].Option;
	
	function loadingFilterOption() {
	  return true;
	}
	
	var Mentions = /*#__PURE__*/function (_React$Component) {
	  _inherits(Mentions, _React$Component);
	
	  var _super = _createSuper(Mentions);
	
	  function Mentions() {
	    var _this;
	
	    _classCallCheck(this, Mentions);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      focused: false
	    };
	
	    _this.onFocus = function () {
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) {
	        onFocus.apply(void 0, arguments);
	      }
	
	      _this.setState({
	        focused: true
	      });
	    };
	
	    _this.onBlur = function () {
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) {
	        onBlur.apply(void 0, arguments);
	      }
	
	      _this.setState({
	        focused: false
	      });
	    };
	
	    _this.getOptions = function () {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          loading = _this$props.loading;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(Option, {
	            value: "ANTD_SEARCHING",
	            disabled: true
	          }, /*#__PURE__*/React.createElement(_spin["default"], {
	            size: "small"
	          }))
	        );
	      }
	
	      return children;
	    };
	
	    _this.getFilterOption = function () {
	      var _this$props2 = _this.props,
	          filterOption = _this$props2.filterOption,
	          loading = _this$props2.loading;
	
	      if (loading) {
	        return loadingFilterOption;
	      }
	
	      return filterOption;
	    };
	
	    _this.saveMentions = function (node) {
	      _this.rcMentions = node;
	    };
	
	    _this.renderMentions = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	      var focused = _this.state.focused;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          disabled = _a.disabled,
	          restProps = __rest(_a, ["prefixCls", "className", "disabled"]);
	
	      var prefixCls = getPrefixCls('mentions', customizePrefixCls);
	      var mentionsProps = (0, _omit["default"])(restProps, ['loading']);
	      var mergedClassName = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-focused"), focused), _classNames));
	      return (/*#__PURE__*/React.createElement(_rcMentions["default"], _extends({
	          prefixCls: prefixCls,
	          notFoundContent: _this.getNotFoundContent(renderEmpty),
	          className: mergedClassName,
	          disabled: disabled
	        }, mentionsProps, {
	          filterOption: _this.getFilterOption(),
	          onFocus: _this.onFocus,
	          onBlur: _this.onBlur,
	          ref: _this.saveMentions
	        }), _this.getOptions())
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Mentions, [{
	    key: "getNotFoundContent",
	    value: function getNotFoundContent(renderEmpty) {
	      var notFoundContent = this.props.notFoundContent;
	
	      if (notFoundContent !== undefined) {
	        return notFoundContent;
	      }
	
	      return renderEmpty('Select');
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcMentions.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcMentions.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMentions)
	      );
	    }
	  }]);
	
	  return Mentions;
	}(React.Component);
	
	Mentions.Option = Option;
	
	Mentions.getMentions = function () {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var config = arguments.length > 1 ? arguments[1] : undefined;
	
	  var _ref2 = config || {},
	      _ref2$prefix = _ref2.prefix,
	      prefix = _ref2$prefix === void 0 ? '@' : _ref2$prefix,
	      _ref2$split = _ref2.split,
	      split = _ref2$split === void 0 ? ' ' : _ref2$split;
	
	  var prefixList = Array.isArray(prefix) ? prefix : [prefix];
	  return value.split(split).map(function () {
	    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var hitPrefix = null;
	    prefixList.some(function (prefixStr) {
	      var startStr = str.slice(0, prefixStr.length);
	
	      if (startStr === prefixStr) {
	        hitPrefix = prefixStr;
	        return true;
	      }
	
	      return false;
	    });
	
	    if (hitPrefix !== null) {
	      return {
	        prefix: hitPrefix,
	        value: str.slice(hitPrefix.length)
	      };
	    }
	
	    return null;
	  }).filter(function (entity) {
	    return !!entity && !!entity.value;
	  });
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Mentions);
	var _default = Mentions;
	exports["default"] = _default;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcMenu = __webpack_require__(93);
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(381));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(126));
	
	var _Sider = __webpack_require__(380);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var MenuItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  var _super = _createSuper(MenuItem);
	
	  function MenuItem() {
	    var _this;
	
	    _classCallCheck(this, MenuItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.menuItem.onKeyDown(e);
	    };
	
	    _this.saveMenuItem = function (menuItem) {
	      _this.menuItem = menuItem;
	    };
	
	    _this.renderItem = function (_ref) {
	      var siderCollapsed = _ref.siderCollapsed;
	      var _this$props = _this.props,
	          level = _this$props.level,
	          children = _this$props.children,
	          rootPrefixCls = _this$props.rootPrefixCls;
	
	      var _a = _this.props,
	          title = _a.title,
	          rest = __rest(_a, ["title"]);
	
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref2) {
	          var inlineCollapsed = _ref2.inlineCollapsed;
	          var tooltipProps = {
	            title: title || (level === 1 ? children : '')
	          };
	
	          if (!siderCollapsed && !inlineCollapsed) {
	            tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct
	            // ref: https://github.com/ant-design/ant-design/issues/16742
	
	            tooltipProps.visible = false;
	          }
	
	          return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, tooltipProps, {
	              placement: "right",
	              overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
	            }), /*#__PURE__*/React.createElement(_rcMenu.Item, _extends({}, rest, {
	              title: title,
	              ref: _this.saveMenuItem
	            })))
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, this.renderItem)
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(React.Component);
	
	exports["default"] = MenuItem;
	MenuItem.isMenuItem = true;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcMenu = __webpack_require__(93);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(381));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var SubMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(SubMenu, _React$Component);
	
	  var _super = _createSuper(SubMenu);
	
	  function SubMenu() {
	    var _this;
	
	    _classCallCheck(this, SubMenu);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.subMenu.onKeyDown(e);
	    };
	
	    _this.saveSubMenu = function (subMenu) {
	      _this.subMenu = subMenu;
	    };
	
	    return _this;
	  }
	
	  _createClass(SubMenu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          rootPrefixCls = _this$props.rootPrefixCls,
	          popupClassName = _this$props.popupClassName;
	      return (/*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref) {
	          var antdMenuTheme = _ref.antdMenuTheme;
	          return (/*#__PURE__*/React.createElement(_rcMenu.SubMenu, _extends({}, _this2.props, {
	              ref: _this2.saveSubMenu,
	              popupClassName: (0, _classnames["default"])("".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
	            }))
	          );
	        })
	      );
	    }
	  }]);
	
	  return SubMenu;
	}(React.Component);
	
	SubMenu.contextTypes = {
	  antdMenuTheme: PropTypes.string
	}; // fix issue:https://github.com/ant-design/ant-design/issues/8666
	
	SubMenu.isSubMenu = 1;
	var _default = SubMenu;
	exports["default"] = _default;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcNotification = _interopRequireDefault(__webpack_require__(189));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var defaultDuration = 3;
	var defaultTop;
	var messageInstance;
	var key = 1;
	var prefixCls = 'ant-message';
	var transitionName = 'move-up';
	var getContainer;
	var maxCount;
	
	function getMessageInstance(callback) {
	  if (messageInstance) {
	    callback(messageInstance);
	    return;
	  }
	
	  _rcNotification["default"].newInstance({
	    prefixCls: prefixCls,
	    transitionName: transitionName,
	    style: {
	      top: defaultTop
	    },
	    getContainer: getContainer,
	    maxCount: maxCount
	  }, function (instance) {
	    if (messageInstance) {
	      callback(messageInstance);
	      return;
	    }
	
	    messageInstance = instance;
	    callback(instance);
	  });
	}
	
	function notice(args) {
	  var duration = args.duration !== undefined ? args.duration : defaultDuration;
	  var iconType = {
	    info: 'info-circle',
	    success: 'check-circle',
	    error: 'close-circle',
	    warning: 'exclamation-circle',
	    loading: 'loading'
	  }[args.type];
	  var target = args.key || key++;
	  var closePromise = new Promise(function (resolve) {
	    var callback = function callback() {
	      if (typeof args.onClose === 'function') {
	        args.onClose();
	      }
	
	      return resolve(true);
	    };
	
	    getMessageInstance(function (instance) {
	      var iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType,
	        theme: iconType === 'loading' ? 'outlined' : 'filled'
	      });
	      var switchIconNode = iconType ? iconNode : '';
	      instance.notice({
	        key: target,
	        duration: duration,
	        style: {},
	        content: /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-custom-content").concat(args.type ? " ".concat(prefixCls, "-").concat(args.type) : '')
	        }, args.icon ? args.icon : switchIconNode, /*#__PURE__*/React.createElement("span", null, args.content)),
	        onClose: callback
	      });
	    });
	  });
	
	  var result = function result() {
	    if (messageInstance) {
	      messageInstance.removeNotice(target);
	    }
	  };
	
	  result.then = function (filled, rejected) {
	    return closePromise.then(filled, rejected);
	  };
	
	  result.promise = closePromise;
	  return result;
	}
	
	function isArgsProps(content) {
	  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
	}
	
	var api = {
	  open: notice,
	  config: function config(options) {
	    if (options.top !== undefined) {
	      defaultTop = options.top;
	      messageInstance = null; // delete messageInstance for new defaultTop
	    }
	
	    if (options.duration !== undefined) {
	      defaultDuration = options.duration;
	    }
	
	    if (options.prefixCls !== undefined) {
	      prefixCls = options.prefixCls;
	    }
	
	    if (options.getContainer !== undefined) {
	      getContainer = options.getContainer;
	    }
	
	    if (options.transitionName !== undefined) {
	      transitionName = options.transitionName;
	      messageInstance = null; // delete messageInstance for new transitionName
	    }
	
	    if (options.maxCount !== undefined) {
	      maxCount = options.maxCount;
	      messageInstance = null;
	    }
	  },
	  destroy: function destroy() {
	    if (messageInstance) {
	      messageInstance.destroy();
	      messageInstance = null;
	    }
	  }
	};
	['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
	  api[type] = function (content, duration, onClose) {
	    if (isArgsProps(content)) {
	      return api.open(_extends(_extends({}, content), {
	        type: type
	      }));
	    }
	
	    if (typeof duration === 'function') {
	      onClose = duration;
	      duration = undefined;
	    }
	
	    return api.open({
	      content: content,
	      duration: duration,
	      type: type,
	      onClose: onClose
	    });
	  };
	});
	api.warn = api.warning;
	var _default = api;
	exports["default"] = _default;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(84));
	
	var _button = _interopRequireDefault(__webpack_require__(138));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ActionButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(ActionButton, _React$Component);
	
	  var _super = _createSuper(ActionButton);
	
	  function ActionButton(props) {
	    var _this;
	
	    _classCallCheck(this, ActionButton);
	
	    _this = _super.call(this, props);
	
	    _this.onClick = function () {
	      var _this$props = _this.props,
	          actionFn = _this$props.actionFn,
	          closeModal = _this$props.closeModal;
	
	      if (actionFn) {
	        var ret;
	
	        if (actionFn.length) {
	          ret = actionFn(closeModal);
	        } else {
	          ret = actionFn();
	
	          if (!ret) {
	            closeModal();
	          }
	        }
	
	        if (ret && ret.then) {
	          _this.setState({
	            loading: true
	          });
	
	          ret.then(function () {
	            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
	            // this.setState({ loading: false });
	            closeModal.apply(void 0, arguments);
	          }, function (e) {
	            // Emit error when catch promise reject
	            // eslint-disable-next-line no-console
	            console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183
	
	            _this.setState({
	              loading: false
	            });
	          });
	        }
	      } else {
	        closeModal();
	      }
	    };
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(ActionButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoFocus) {
	        var $this = ReactDOM.findDOMNode(this);
	        this.timeoutId = setTimeout(function () {
	          return $this.focus();
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          type = _this$props2.type,
	          children = _this$props2.children,
	          buttonProps = _this$props2.buttonProps;
	      var loading = this.state.loading;
	      return (/*#__PURE__*/React.createElement(_button["default"], _extends({
	          type: type,
	          onClick: this.onClick,
	          loading: loading
	        }, buttonProps), children)
	      );
	    }
	  }]);
	
	  return ActionButton;
	}(React.Component);
	
	exports["default"] = ActionButton;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = confirm;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(84));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(755));
	
	var _ActionButton = _interopRequireDefault(__webpack_require__(1416));
	
	var _locale = __webpack_require__(383);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var IS_REACT_16 = !!ReactDOM.createPortal;
	
	var ConfirmDialog = function ConfirmDialog(props) {
	  var onCancel = props.onCancel,
	      onOk = props.onOk,
	      close = props.close,
	      zIndex = props.zIndex,
	      afterClose = props.afterClose,
	      visible = props.visible,
	      keyboard = props.keyboard,
	      centered = props.centered,
	      getContainer = props.getContainer,
	      maskStyle = props.maskStyle,
	      okButtonProps = props.okButtonProps,
	      cancelButtonProps = props.cancelButtonProps,
	      _props$iconType = props.iconType,
	      iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
	  (0, _warning["default"])(!('iconType' in props), 'Modal', "The property 'iconType' is deprecated. Use the property 'icon' instead."); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
	
	  var icon = props.icon === undefined ? iconType : props.icon;
	  var okType = props.okType || 'primary';
	  var prefixCls = props.prefixCls || 'ant-modal';
	  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容
	
	  var okCancel = 'okCancel' in props ? props.okCancel : true;
	  var width = props.width || 416;
	  var style = props.style || {};
	  var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为
	
	  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
	  var runtimeLocale = (0, _locale.getConfirmLocale)();
	  var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
	  var cancelText = props.cancelText || runtimeLocale.cancelText;
	  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
	  var transitionName = props.transitionName || 'zoom';
	  var maskTransitionName = props.maskTransitionName || 'fade';
	  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
	  var cancelButton = okCancel && /*#__PURE__*/React.createElement(_ActionButton["default"], {
	    actionFn: onCancel,
	    closeModal: close,
	    autoFocus: autoFocusButton === 'cancel',
	    buttonProps: cancelButtonProps
	  }, cancelText);
	  var iconNode = typeof icon === 'string' ? /*#__PURE__*/React.createElement(_icon["default"], {
	    type: icon
	  }) : icon;
	  return (/*#__PURE__*/React.createElement(_Modal["default"], {
	      prefixCls: prefixCls,
	      className: classString,
	      wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
	      onCancel: function onCancel() {
	        return close({
	          triggerCancel: true
	        });
	      },
	      visible: visible,
	      title: "",
	      transitionName: transitionName,
	      footer: "",
	      maskTransitionName: maskTransitionName,
	      mask: mask,
	      maskClosable: maskClosable,
	      maskStyle: maskStyle,
	      style: style,
	      width: width,
	      zIndex: zIndex,
	      afterClose: afterClose,
	      keyboard: keyboard,
	      centered: centered,
	      getContainer: getContainer
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-body-wrapper")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-body")
	    }, iconNode, props.title === undefined ? null : /*#__PURE__*/React.createElement("span", {
	      className: "".concat(contentPrefixCls, "-title")
	    }, props.title), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-content")
	    }, props.content)), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(contentPrefixCls, "-btns")
	    }, cancelButton, /*#__PURE__*/React.createElement(_ActionButton["default"], {
	      type: okType,
	      actionFn: onOk,
	      closeModal: close,
	      autoFocus: autoFocusButton === 'ok',
	      buttonProps: okButtonProps
	    }, okText))))
	  );
	};
	
	function confirm(config) {
	  var div = document.createElement('div');
	  document.body.appendChild(div); // eslint-disable-next-line no-use-before-define
	
	  var currentConfig = _extends(_extends({}, config), {
	    close: close,
	    visible: true
	  });
	
	  function destroy() {
	    var unmountResult = ReactDOM.unmountComponentAtNode(div);
	
	    if (unmountResult && div.parentNode) {
	      div.parentNode.removeChild(div);
	    }
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var triggerCancel = args.some(function (param) {
	      return param && param.triggerCancel;
	    });
	
	    if (config.onCancel && triggerCancel) {
	      config.onCancel.apply(config, args);
	    }
	
	    for (var i = 0; i < _Modal.destroyFns.length; i++) {
	      var fn = _Modal.destroyFns[i]; // eslint-disable-next-line no-use-before-define
	
	      if (fn === close) {
	        _Modal.destroyFns.splice(i, 1);
	
	        break;
	      }
	    }
	  }
	
	  function render(props) {
	    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmDialog, props), div);
	  }
	
	  function close() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    currentConfig = _extends(_extends({}, currentConfig), {
	      visible: false,
	      afterClose: destroy.bind.apply(destroy, [this].concat(args))
	    });
	
	    if (IS_REACT_16) {
	      render(currentConfig);
	    } else {
	      destroy.apply(void 0, args);
	    }
	  }
	
	  function update(newConfig) {
	    currentConfig = _extends(_extends({}, currentConfig), newConfig);
	    render(currentConfig);
	  }
	
	  render(currentConfig);
	
	  _Modal.destroyFns.push(close);
	
	  return {
	    destroy: close,
	    update: update
	  };
	}

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(755));
	
	var _confirm = _interopRequireDefault(__webpack_require__(1417));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function modalWarn(props) {
	  var config = _extends({
	    type: 'warning',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "exclamation-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	}
	
	_Modal["default"].info = function infoFn(props) {
	  var config = _extends({
	    type: 'info',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "info-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].success = function successFn(props) {
	  var config = _extends({
	    type: 'success',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "check-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].error = function errorFn(props) {
	  var config = _extends({
	    type: 'error',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "close-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].warning = modalWarn;
	_Modal["default"].warn = modalWarn;
	
	_Modal["default"].confirm = function confirmFn(props) {
	  var config = _extends({
	    type: 'confirm',
	    okCancel: true
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].destroyAll = function destroyAllFn() {
	  while (_Modal.destroyFns.length) {
	    var close = _Modal.destroyFns.pop();
	
	    if (close) {
	      close();
	    }
	  }
	};
	
	var _default = _Modal["default"];
	exports["default"] = _default;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcNotification = _interopRequireDefault(__webpack_require__(189));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var notificationInstance = {};
	var defaultDuration = 4.5;
	var defaultTop = 24;
	var defaultBottom = 24;
	var defaultPlacement = 'topRight';
	var defaultGetContainer;
	var defaultCloseIcon;
	
	function setNotificationConfig(options) {
	  var duration = options.duration,
	      placement = options.placement,
	      bottom = options.bottom,
	      top = options.top,
	      getContainer = options.getContainer,
	      closeIcon = options.closeIcon;
	
	  if (duration !== undefined) {
	    defaultDuration = duration;
	  }
	
	  if (placement !== undefined) {
	    defaultPlacement = placement;
	  }
	
	  if (bottom !== undefined) {
	    defaultBottom = bottom;
	  }
	
	  if (top !== undefined) {
	    defaultTop = top;
	  }
	
	  if (getContainer !== undefined) {
	    defaultGetContainer = getContainer;
	  }
	
	  if (closeIcon !== undefined) {
	    defaultCloseIcon = closeIcon;
	  }
	}
	
	function getPlacementStyle(placement) {
	  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTop;
	  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBottom;
	  var style;
	
	  switch (placement) {
	    case 'topLeft':
	      style = {
	        left: 0,
	        top: top,
	        bottom: 'auto'
	      };
	      break;
	
	    case 'topRight':
	      style = {
	        right: 0,
	        top: top,
	        bottom: 'auto'
	      };
	      break;
	
	    case 'bottomLeft':
	      style = {
	        left: 0,
	        top: 'auto',
	        bottom: bottom
	      };
	      break;
	
	    default:
	      style = {
	        right: 0,
	        top: 'auto',
	        bottom: bottom
	      };
	      break;
	  }
	
	  return style;
	}
	
	function getNotificationInstance(_ref, callback) {
	  var prefixCls = _ref.prefixCls,
	      _ref$placement = _ref.placement,
	      placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
	      _ref$getContainer = _ref.getContainer,
	      getContainer = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer,
	      top = _ref.top,
	      bottom = _ref.bottom,
	      _ref$closeIcon = _ref.closeIcon,
	      closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon;
	  var cacheKey = "".concat(prefixCls, "-").concat(placement);
	
	  if (notificationInstance[cacheKey]) {
	    callback(notificationInstance[cacheKey]);
	    return;
	  }
	
	  var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-close-x")
	  }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	    className: "".concat(prefixCls, "-close-icon"),
	    type: "close"
	  }));
	
	  _rcNotification["default"].newInstance({
	    prefixCls: prefixCls,
	    className: "".concat(prefixCls, "-").concat(placement),
	    style: getPlacementStyle(placement, top, bottom),
	    getContainer: getContainer,
	    closeIcon: closeIconToRender
	  }, function (notification) {
	    notificationInstance[cacheKey] = notification;
	    callback(notification);
	  });
	}
	
	var typeToIcon = {
	  success: 'check-circle-o',
	  info: 'info-circle-o',
	  error: 'close-circle-o',
	  warning: 'exclamation-circle-o'
	};
	
	function notice(args) {
	  var outerPrefixCls = args.prefixCls || 'ant-notification';
	  var prefixCls = "".concat(outerPrefixCls, "-notice");
	  var duration = args.duration === undefined ? defaultDuration : args.duration;
	  var iconNode = null;
	
	  if (args.icon) {
	    iconNode = /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-icon")
	    }, args.icon);
	  } else if (args.type) {
	    var iconType = typeToIcon[args.type];
	    iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
	      className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(args.type),
	      type: iconType
	    });
	  }
	
	  var autoMarginTag = !args.description && iconNode ? /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-message-single-line-auto-margin")
	  }) : null;
	  var placement = args.placement,
	      top = args.top,
	      bottom = args.bottom,
	      getContainer = args.getContainer,
	      closeIcon = args.closeIcon;
	  getNotificationInstance({
	    prefixCls: outerPrefixCls,
	    placement: placement,
	    top: top,
	    bottom: bottom,
	    getContainer: getContainer,
	    closeIcon: closeIcon
	  }, function (notification) {
	    notification.notice({
	      content: /*#__PURE__*/React.createElement("div", {
	        className: iconNode ? "".concat(prefixCls, "-with-icon") : ''
	      }, iconNode, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-message")
	      }, autoMarginTag, args.message), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-description")
	      }, args.description), args.btn ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-btn")
	      }, args.btn) : null),
	      duration: duration,
	      closable: true,
	      onClose: args.onClose,
	      onClick: args.onClick,
	      key: args.key,
	      style: args.style || {},
	      className: args.className
	    });
	  });
	}
	
	var api = {
	  open: notice,
	  close: function close(key) {
	    Object.keys(notificationInstance).forEach(function (cacheKey) {
	      return notificationInstance[cacheKey].removeNotice(key);
	    });
	  },
	  config: setNotificationConfig,
	  destroy: function destroy() {
	    Object.keys(notificationInstance).forEach(function (cacheKey) {
	      notificationInstance[cacheKey].destroy();
	      delete notificationInstance[cacheKey];
	    });
	  }
	};
	['success', 'info', 'warning', 'error'].forEach(function (type) {
	  api[type] = function (args) {
	    return api.open(_extends(_extends({}, args), {
	      type: type
	    }));
	  };
	});
	api.warn = api.warning;
	var _default = api;
	exports["default"] = _default;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _breadcrumb = _interopRequireDefault(__webpack_require__(739));
	
	var _avatar = _interopRequireDefault(__webpack_require__(737));
	
	var _transButton = _interopRequireDefault(__webpack_require__(375));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var renderBack = function renderBack(prefixCls, backIcon, onBack) {
	  if (!backIcon || !onBack) {
	    return null;
	  }
	
	  return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	      componentName: "PageHeader"
	    }, function (_ref) {
	      var back = _ref.back;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-back")
	        }, /*#__PURE__*/React.createElement(_transButton["default"], {
	          onClick: function onClick(e) {
	            if (onBack) {
	              onBack(e);
	            }
	          },
	          className: "".concat(prefixCls, "-back-button"),
	          "aria-label": back
	        }, backIcon))
	      );
	    })
	  );
	};
	
	var renderBreadcrumb = function renderBreadcrumb(breadcrumb) {
	  return (/*#__PURE__*/React.createElement(_breadcrumb["default"], breadcrumb)
	  );
	};
	
	var renderTitle = function renderTitle(prefixCls, props) {
	  var title = props.title,
	      avatar = props.avatar,
	      subTitle = props.subTitle,
	      tags = props.tags,
	      extra = props.extra,
	      backIcon = props.backIcon,
	      onBack = props.onBack;
	  var headingPrefixCls = "".concat(prefixCls, "-heading");
	
	  if (title || subTitle || tags || extra) {
	    var backIconDom = renderBack(prefixCls, backIcon, onBack);
	    return (/*#__PURE__*/React.createElement("div", {
	        className: headingPrefixCls
	      }, backIconDom, avatar && /*#__PURE__*/React.createElement(_avatar["default"], avatar), title && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-title")
	      }, title), subTitle && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-sub-title")
	      }, subTitle), tags && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-tags")
	      }, tags), extra && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(headingPrefixCls, "-extra")
	      }, extra))
	    );
	  }
	
	  return null;
	};
	
	var renderFooter = function renderFooter(prefixCls, footer) {
	  if (footer) {
	    return (/*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, footer)
	    );
	  }
	
	  return null;
	};
	
	var renderChildren = function renderChildren(prefixCls, children) {
	  return (/*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-content")
	    }, children)
	  );
	};
	
	var PageHeader = function PageHeader(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls,
	          pageHeader = _ref2.pageHeader;
	      var customizePrefixCls = props.prefixCls,
	          style = props.style,
	          footer = props.footer,
	          children = props.children,
	          breadcrumb = props.breadcrumb,
	          customizeClassName = props.className;
	      var ghost = true; // Use `ghost` from `props` or from `ConfigProvider` instead.
	
	      if ('ghost' in props) {
	        ghost = props.ghost;
	      } else if (pageHeader && 'ghost' in pageHeader) {
	        ghost = pageHeader.ghost;
	      }
	
	      var prefixCls = getPrefixCls('page-header', customizePrefixCls);
	      var breadcrumbDom = breadcrumb && breadcrumb.routes ? renderBreadcrumb(breadcrumb) : null;
	      var className = (0, _classnames2["default"])(prefixCls, customizeClassName, _defineProperty({
	        'has-breadcrumb': breadcrumbDom,
	        'has-footer': footer
	      }, "".concat(prefixCls, "-ghost"), ghost));
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className,
	          style: style
	        }, breadcrumbDom, renderTitle(prefixCls, props), children && renderChildren(prefixCls, children), renderFooter(prefixCls, footer))
	      );
	    })
	  );
	};
	
	PageHeader.defaultProps = {
	  backIcon: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "arrow-left"
	  })
	};
	var _default = PageHeader;
	exports["default"] = _default;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _select = _interopRequireDefault(__webpack_require__(208));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var MiniSelect = /*#__PURE__*/function (_React$Component) {
	  _inherits(MiniSelect, _React$Component);
	
	  var _super = _createSuper(MiniSelect);
	
	  function MiniSelect() {
	    _classCallCheck(this, MiniSelect);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(MiniSelect, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_select["default"], _extends({
	          size: "small"
	        }, this.props))
	      );
	    }
	  }]);
	
	  return MiniSelect;
	}(React.Component);
	
	exports["default"] = MiniSelect;
	MiniSelect.Option = _select["default"].Option;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcPagination = _interopRequireDefault(__webpack_require__(471));
	
	var _en_US = _interopRequireDefault(__webpack_require__(190));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _MiniSelect = _interopRequireDefault(__webpack_require__(1421));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _select = _interopRequireDefault(__webpack_require__(208));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Pagination = /*#__PURE__*/function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  var _super = _createSuper(Pagination);
	
	  function Pagination() {
	    var _this;
	
	    _classCallCheck(this, Pagination);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getIconsProps = function (prefixCls) {
	      var prevIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "left"
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right"
	      }));
	      var jumpPrevIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-container")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-item-link-icon"),
	        type: "double-left"
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-ellipsis")
	      }, "\u2022\u2022\u2022")));
	      var jumpNextIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-container")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-item-link-icon"),
	        type: "double-right"
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-ellipsis")
	      }, "\u2022\u2022\u2022")));
	      return {
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        jumpPrevIcon: jumpPrevIcon,
	        jumpNextIcon: jumpNextIcon
	      };
	    };
	
	    _this.renderPagination = function (contextLocale) {
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeSelectPrefixCls = _a.selectPrefixCls,
	          className = _a.className,
	          size = _a.size,
	          customLocale = _a.locale,
	          restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);
	
	      var locale = _extends(_extends({}, contextLocale), customLocale);
	
	      var isSmall = size === 'small';
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	          var getPrefixCls = _ref.getPrefixCls;
	          var prefixCls = getPrefixCls('pagination', customizePrefixCls);
	          var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
	          return (/*#__PURE__*/React.createElement(_rcPagination["default"], _extends({}, restProps, {
	              prefixCls: prefixCls,
	              selectPrefixCls: selectPrefixCls
	            }, _this.getIconsProps(prefixCls), {
	              className: (0, _classnames["default"])(className, {
	                mini: isSmall
	              }),
	              selectComponentClass: isSmall ? _MiniSelect["default"] : _select["default"],
	              locale: locale
	            }))
	          );
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Pagination, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Pagination",
	          defaultLocale: _en_US["default"]
	        }, this.renderPagination)
	      );
	    }
	  }]);
	
	  return Pagination;
	}(React.Component);
	
	exports["default"] = Pagination;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _tooltip = _interopRequireDefault(__webpack_require__(126));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _button = _interopRequireDefault(__webpack_require__(138));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _default2 = _interopRequireDefault(__webpack_require__(164));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popconfirm = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popconfirm, _React$Component);
	
	  var _super = _createSuper(Popconfirm);
	
	  function Popconfirm(props) {
	    var _this;
	
	    _classCallCheck(this, Popconfirm);
	
	    _this = _super.call(this, props);
	
	    _this.onConfirm = function (e) {
	      _this.setVisible(false, e);
	
	      var onConfirm = _this.props.onConfirm;
	
	      if (onConfirm) {
	        onConfirm.call(_assertThisInitialized(_this), e);
	      }
	    };
	
	    _this.onCancel = function (e) {
	      _this.setVisible(false, e);
	
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel.call(_assertThisInitialized(_this), e);
	      }
	    };
	
	    _this.onVisibleChange = function (visible) {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setVisible(visible);
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderOverlay = function (prefixCls, popconfirmLocale) {
	      var _this$props = _this.props,
	          okButtonProps = _this$props.okButtonProps,
	          cancelButtonProps = _this$props.cancelButtonProps,
	          title = _this$props.title,
	          cancelText = _this$props.cancelText,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          icon = _this$props.icon;
	      return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-inner-content")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-message")
	        }, icon, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-message-title")
	        }, title)), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-buttons")
	        }, /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.onCancel,
	          size: "small"
	        }, cancelButtonProps), cancelText || popconfirmLocale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	          onClick: _this.onConfirm,
	          type: okType,
	          size: "small"
	        }, okButtonProps), okText || popconfirmLocale.okText))))
	      );
	    };
	
	    _this.renderConfirm = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          placement = _a.placement,
	          restProps = __rest(_a, ["prefixCls", "placement"]);
	
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      var overlay = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Popconfirm",
	        defaultLocale: _default2["default"].Popconfirm
	      }, function (popconfirmLocale) {
	        return _this.renderOverlay(prefixCls, popconfirmLocale);
	      });
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, restProps, {
	          prefixCls: prefixCls,
	          placement: placement,
	          onVisibleChange: _this.onVisibleChange,
	          visible: _this.state.visible,
	          overlay: overlay,
	          ref: _this.saveTooltip
	        }))
	      );
	    };
	
	    _this.state = {
	      visible: props.visible
	    };
	    return _this;
	  }
	
	  _createClass(Popconfirm, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible, e) {
	      var props = this.props;
	
	      if (!('visible' in props)) {
	        this.setState({
	          visible: visible
	        });
	      }
	
	      var onVisibleChange = props.onVisibleChange;
	
	      if (onVisibleChange) {
	        onVisibleChange(visible, e);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderConfirm)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      if ('defaultVisible' in nextProps) {
	        return {
	          visible: nextProps.defaultVisible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Popconfirm;
	}(React.Component);
	
	Popconfirm.defaultProps = {
	  transitionName: 'zoom-big',
	  placement: 'top',
	  trigger: 'click',
	  okType: 'primary',
	  icon: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "exclamation-circle",
	    theme: "filled"
	  }),
	  disabled: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Popconfirm);
	var _default = Popconfirm;
	exports["default"] = _default;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(126));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popover = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popover, _React$Component);
	
	  var _super = _createSuper(Popover);
	
	  function Popover() {
	    var _this;
	
	    _classCallCheck(this, Popover);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderPopover = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          props = __rest(_a, ["prefixCls"]);
	
	      delete props.title;
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, props, {
	          prefixCls: prefixCls,
	          ref: _this.saveTooltip,
	          overlay: _this.getOverlay(prefixCls)
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Popover, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay(prefixCls) {
	      var _this$props = this.props,
	          title = _this$props.title,
	          content = _this$props.content;
	      (0, _warning["default"])(!('overlay' in this.props), 'Popover', '`overlay` is removed, please use `content` instead, ' + 'see: https://u.ant.design/popover-content');
	      return (/*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-inner-content")
	        }, content))
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPopover)
	      );
	    }
	  }]);
	
	  return Popover;
	}(React.Component);
	
	exports["default"] = Popover;
	Popover.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big',
	  trigger: 'hover',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  overlayStyle: {}
	};

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcProgress = __webpack_require__(472);
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(385);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var statusColorMap = {
	  normal: '#108ee9',
	  exception: '#ff5500',
	  success: '#87d068'
	};
	
	function getPercentage(_ref) {
	  var percent = _ref.percent,
	      successPercent = _ref.successPercent;
	  var ptg = (0, _utils.validProgress)(percent);
	
	  if (!successPercent) {
	    return ptg;
	  }
	
	  var successPtg = (0, _utils.validProgress)(successPercent);
	  return [successPercent, (0, _utils.validProgress)(ptg - successPtg)];
	}
	
	function getStrokeColor(_ref2) {
	  var progressStatus = _ref2.progressStatus,
	      successPercent = _ref2.successPercent,
	      strokeColor = _ref2.strokeColor;
	  var color = strokeColor || statusColorMap[progressStatus];
	
	  if (!successPercent) {
	    return color;
	  }
	
	  return [statusColorMap.success, color];
	}
	
	var Circle = function Circle(props) {
	  var prefixCls = props.prefixCls,
	      width = props.width,
	      strokeWidth = props.strokeWidth,
	      trailColor = props.trailColor,
	      strokeLinecap = props.strokeLinecap,
	      gapPosition = props.gapPosition,
	      gapDegree = props.gapDegree,
	      type = props.type,
	      children = props.children;
	  var circleSize = width || 120;
	  var circleStyle = {
	    width: circleSize,
	    height: circleSize,
	    fontSize: circleSize * 0.15 + 6
	  };
	  var circleWidth = strokeWidth || 6;
	  var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
	  var gapDeg = gapDegree || (type === 'dashboard' ? 75 : undefined);
	  var strokeColor = getStrokeColor(props);
	  var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
	  var wrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-inner"), _defineProperty({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
	  return (/*#__PURE__*/React.createElement("div", {
	      className: wrapperClassName,
	      style: circleStyle
	    }, /*#__PURE__*/React.createElement(_rcProgress.Circle, {
	      percent: getPercentage(props),
	      strokeWidth: circleWidth,
	      trailWidth: circleWidth,
	      strokeColor: strokeColor,
	      strokeLinecap: strokeLinecap,
	      trailColor: trailColor,
	      prefixCls: prefixCls,
	      gapDegree: gapDeg,
	      gapPosition: gapPos
	    }), children)
	  );
	};
	
	var _default = Circle;
	exports["default"] = _default;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.handleGradient = exports.sortGradient = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _utils = __webpack_require__(385);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	/**
	 * {
	 *   '0%': '#afc163',
	 *   '75%': '#009900',
	 *   '50%': 'green',     ====>     '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
	 *   '25%': '#66FF00',
	 *   '100%': '#ffffff'
	 * }
	 */
	var sortGradient = function sortGradient(gradients) {
	  var tempArr = []; // eslint-disable-next-line no-restricted-syntax
	
	  for (var _i = 0, _Object$entries = Object.entries(gradients); _i < _Object$entries.length; _i++) {
	    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
	        key = _Object$entries$_i[0],
	        value = _Object$entries$_i[1];
	
	    var formatKey = parseFloat(key.replace(/%/g, ''));
	
	    if (isNaN(formatKey)) {
	      return {};
	    }
	
	    tempArr.push({
	      key: formatKey,
	      value: value
	    });
	  }
	
	  tempArr = tempArr.sort(function (a, b) {
	    return a.key - b.key;
	  });
	  return tempArr.map(function (_ref) {
	    var key = _ref.key,
	        value = _ref.value;
	    return "".concat(value, " ").concat(key, "%");
	  }).join(', ');
	};
	/**
	 * {
	 *   '0%': '#afc163',
	 *   '25%': '#66FF00',
	 *   '50%': '#00CC00',     ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
	 *   '75%': '#009900',              #00CC00 50%, #009900 75%, #ffffff 100%)
	 *   '100%': '#ffffff'
	 * }
	 *
	 * Then this man came to realize the truth:
	 * Besides six pence, there is the moon.
	 * Besides bread and butter, there is the bug.
	 * And...
	 * Besides women, there is the code.
	 */
	
	exports.sortGradient = sortGradient;
	
	var handleGradient = function handleGradient(strokeColor) {
	  var _strokeColor$from = strokeColor.from,
	      from = _strokeColor$from === void 0 ? '#1890ff' : _strokeColor$from,
	      _strokeColor$to = strokeColor.to,
	      to = _strokeColor$to === void 0 ? '#1890ff' : _strokeColor$to,
	      _strokeColor$directio = strokeColor.direction,
	      direction = _strokeColor$directio === void 0 ? 'to right' : _strokeColor$directio,
	      rest = __rest(strokeColor, ["from", "to", "direction"]);
	
	  if (Object.keys(rest).length !== 0) {
	    var sortedGradients = sortGradient(rest);
	    return {
	      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
	    };
	  }
	
	  return {
	    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
	  };
	};
	
	exports.handleGradient = handleGradient;
	
	var Line = function Line(props) {
	  var prefixCls = props.prefixCls,
	      percent = props.percent,
	      successPercent = props.successPercent,
	      strokeWidth = props.strokeWidth,
	      size = props.size,
	      strokeColor = props.strokeColor,
	      strokeLinecap = props.strokeLinecap,
	      children = props.children;
	  var backgroundProps;
	
	  if (strokeColor && typeof strokeColor !== 'string') {
	    backgroundProps = handleGradient(strokeColor);
	  } else {
	    backgroundProps = {
	      background: strokeColor
	    };
	  }
	
	  var percentStyle = _extends({
	    width: "".concat((0, _utils.validProgress)(percent), "%"),
	    height: strokeWidth || (size === 'small' ? 6 : 8),
	    borderRadius: strokeLinecap === 'square' ? 0 : ''
	  }, backgroundProps);
	
	  var successPercentStyle = {
	    width: "".concat((0, _utils.validProgress)(successPercent), "%"),
	    height: strokeWidth || (size === 'small' ? 6 : 8),
	    borderRadius: strokeLinecap === 'square' ? 0 : ''
	  };
	  var successSegment = successPercent !== undefined ? /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-success-bg"),
	    style: successPercentStyle
	  }) : null;
	  return (/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-outer")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-inner")
	    }, /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-bg"),
	      style: percentStyle
	    }), successSegment)), children)
	  );
	};
	
	var _default = Line;
	exports["default"] = _default;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _type = __webpack_require__(83);
	
	var _Line = _interopRequireDefault(__webpack_require__(1426));
	
	var _Circle = _interopRequireDefault(__webpack_require__(1425));
	
	var _utils = __webpack_require__(385);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ProgressTypes = (0, _type.tuple)('line', 'circle', 'dashboard');
	var ProgressStatuses = (0, _type.tuple)('normal', 'exception', 'active', 'success');
	
	var Progress = /*#__PURE__*/function (_React$Component) {
	  _inherits(Progress, _React$Component);
	
	  var _super = _createSuper(Progress);
	
	  function Progress() {
	    var _this;
	
	    _classCallCheck(this, Progress);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderProgress = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          size = props.size,
	          type = props.type,
	          showInfo = props.showInfo,
	          restProps = __rest(props, ["prefixCls", "className", "size", "type", "showInfo"]);
	
	      var prefixCls = getPrefixCls('progress', customizePrefixCls);
	
	      var progressStatus = _this.getProgressStatus();
	
	      var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);
	
	      var progress; // Render progress shape
	
	      if (type === 'line') {
	        progress = /*#__PURE__*/React.createElement(_Line["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls
	        }), progressInfo);
	      } else if (type === 'circle' || type === 'dashboard') {
	        progress = /*#__PURE__*/React.createElement(_Circle["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          progressStatus: progressStatus
	        }), progressInfo);
	      }
	
	      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
	      return (/*#__PURE__*/React.createElement("div", _extends({}, (0, _omit["default"])(restProps, ['status', 'format', 'trailColor', 'successPercent', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeColor', 'strokeLinecap', 'percent']), {
	          className: classString
	        }), progress)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Progress, [{
	    key: "getPercentNumber",
	    value: function getPercentNumber() {
	      var _this$props = this.props,
	          successPercent = _this$props.successPercent,
	          _this$props$percent = _this$props.percent,
	          percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
	      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
	    }
	  }, {
	    key: "getProgressStatus",
	    value: function getProgressStatus() {
	      var status = this.props.status;
	
	      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
	        return 'success';
	      }
	
	      return status || 'normal';
	    }
	  }, {
	    key: "renderProcessInfo",
	    value: function renderProcessInfo(prefixCls, progressStatus) {
	      var _this$props2 = this.props,
	          showInfo = _this$props2.showInfo,
	          format = _this$props2.format,
	          type = _this$props2.type,
	          percent = _this$props2.percent,
	          successPercent = _this$props2.successPercent;
	      if (!showInfo) return null;
	      var text;
	
	      var textFormatter = format || function (percentNumber) {
	        return "".concat(percentNumber, "%");
	      };
	
	      var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';
	
	      if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
	        text = textFormatter((0, _utils.validProgress)(percent), (0, _utils.validProgress)(successPercent));
	      } else if (progressStatus === 'exception') {
	        text = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close".concat(iconType),
	          theme: type === 'line' ? 'filled' : 'outlined'
	        });
	      } else if (progressStatus === 'success') {
	        text = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "check".concat(iconType),
	          theme: type === 'line' ? 'filled' : 'outlined'
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-text"),
	          title: typeof text === 'string' ? text : undefined
	        }, text)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderProgress)
	      );
	    }
	  }]);
	
	  return Progress;
	}(React.Component);
	
	exports["default"] = Progress;
	Progress.defaultProps = {
	  type: 'line',
	  percent: 0,
	  showInfo: true,
	  trailColor: '#f3f3f3',
	  size: 'default',
	  gapDegree: 0,
	  strokeLinecap: 'round'
	};
	Progress.propTypes = {
	  status: PropTypes.oneOf(ProgressStatuses),
	  type: PropTypes.oneOf(ProgressTypes),
	  showInfo: PropTypes.bool,
	  percent: PropTypes.number,
	  width: PropTypes.number,
	  strokeWidth: PropTypes.number,
	  strokeLinecap: PropTypes.oneOf(['round', 'square']),
	  strokeColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  trailColor: PropTypes.string,
	  format: PropTypes.func,
	  gapDegree: PropTypes.number
	};

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _radio = _interopRequireDefault(__webpack_require__(386));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function getCheckedValue(children) {
	  var value = null;
	  var matched = false;
	  React.Children.forEach(children, function (radio) {
	    if (radio && radio.props && radio.props.checked) {
	      value = radio.props.value;
	      matched = true;
	    }
	  });
	  return matched ? {
	    value: value
	  } : undefined;
	}
	
	var RadioGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioGroup, _React$Component);
	
	  var _super = _createSuper(RadioGroup);
	
	  function RadioGroup(props) {
	    var _this;
	
	    _classCallCheck(this, RadioGroup);
	
	    _this = _super.call(this, props);
	
	    _this.onRadioChange = function (ev) {
	      var lastValue = _this.state.value;
	      var value = ev.target.value;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange && value !== lastValue) {
	        onChange(ev);
	      }
	    };
	
	    _this.renderGroup = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className,
	          options = props.options,
	          buttonStyle = props.buttonStyle;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), _defineProperty({}, "".concat(groupPrefixCls, "-").concat(props.size), props.size), className);
	      var children = props.children; // 如果存在 options, 优先使用
	
	      if (options && options.length > 0) {
	        children = options.map(function (option) {
	          if (typeof option === 'string') {
	            // 此处类型自动推导为 string
	            return (/*#__PURE__*/React.createElement(_radio["default"], {
	                key: option,
	                prefixCls: prefixCls,
	                disabled: _this.props.disabled,
	                value: option,
	                checked: _this.state.value === option
	              }, option)
	            );
	          } // 此处类型自动推导为 { label: string value: string }
	
	
	          return (/*#__PURE__*/React.createElement(_radio["default"], {
	              key: "radio-group-value-options-".concat(option.value),
	              prefixCls: prefixCls,
	              disabled: option.disabled || _this.props.disabled,
	              value: option.value,
	              checked: _this.state.value === option.value
	            }, option.label)
	          );
	        });
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: classString,
	          style: props.style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave,
	          id: props.id
	        }, children)
	      );
	    };
	
	    var value;
	
	    if ('value' in props) {
	      value = props.value;
	    } else if ('defaultValue' in props) {
	      value = props.defaultValue;
	    } else {
	      var checkedValue = getCheckedValue(props.children);
	      value = checkedValue && checkedValue.value;
	    }
	
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(RadioGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        radioGroup: {
	          onChange: this.onRadioChange,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      var checkedValue = getCheckedValue(nextProps.children);
	
	      if (checkedValue) {
	        return {
	          value: checkedValue.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return RadioGroup;
	}(React.Component);
	
	RadioGroup.defaultProps = {
	  buttonStyle: 'outline'
	};
	RadioGroup.childContextTypes = {
	  radioGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(RadioGroup);
	var _default = RadioGroup;
	exports["default"] = _default;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _radio = _interopRequireDefault(__webpack_require__(386));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RadioButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioButton, _React$Component);
	
	  var _super = _createSuper(RadioButton);
	
	  function RadioButton() {
	    var _this;
	
	    _classCallCheck(this, RadioButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderRadioButton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          radioProps = __rest(_a, ["prefixCls"]);
	
	      var prefixCls = getPrefixCls('radio-button', customizePrefixCls);
	
	      if (_this.context.radioGroup) {
	        radioProps.checked = _this.props.value === _this.context.radioGroup.value;
	        radioProps.disabled = _this.props.disabled || _this.context.radioGroup.disabled;
	      }
	
	      return (/*#__PURE__*/React.createElement(_radio["default"], _extends({
	          prefixCls: prefixCls
	        }, radioProps))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(RadioButton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadioButton)
	      );
	    }
	  }]);
	
	  return RadioButton;
	}(React.Component);
	
	exports["default"] = RadioButton;
	RadioButton.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcRate = _interopRequireDefault(__webpack_require__(473));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(126));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Rate = /*#__PURE__*/function (_React$Component) {
	  _inherits(Rate, _React$Component);
	
	  var _super = _createSuper(Rate);
	
	  function Rate() {
	    var _this;
	
	    _classCallCheck(this, Rate);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveRate = function (node) {
	      _this.rcRate = node;
	    };
	
	    _this.characterRender = function (node, _ref) {
	      var index = _ref.index;
	      var tooltips = _this.props.tooltips;
	      if (!tooltips) return node;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          title: tooltips[index]
	        }, node)
	      );
	    };
	
	    _this.renderRate = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          prefixCls = _a.prefixCls,
	          restProps = __rest(_a, ["prefixCls"]);
	
	      var rateProps = (0, _omit["default"])(restProps, ['tooltips']);
	      return (/*#__PURE__*/React.createElement(_rcRate["default"], _extends({
	          ref: _this.saveRate,
	          characterRender: _this.characterRender
	        }, rateProps, {
	          prefixCls: getPrefixCls('rate', prefixCls)
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Rate, [{
	    key: "focus",
	    value: function focus() {
	      this.rcRate.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcRate.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRate)
	      );
	    }
	  }]);
	
	  return Rate;
	}(React.Component);
	
	exports["default"] = Rate;
	Rate.propTypes = {
	  prefixCls: PropTypes.string,
	  character: PropTypes.node
	};
	Rate.defaultProps = {
	  character: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "star",
	    theme: "filled"
	  })
	};

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ExceptionMap = exports.IconMap = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _noFound = _interopRequireDefault(__webpack_require__(1432));
	
	var _serverError = _interopRequireDefault(__webpack_require__(1433));
	
	var _unauthorized = _interopRequireDefault(__webpack_require__(1434));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var IconMap = {
	  success: 'check-circle',
	  error: 'close-circle',
	  info: 'exclamation-circle',
	  warning: 'warning'
	};
	exports.IconMap = IconMap;
	var ExceptionMap = {
	  '404': _noFound["default"],
	  '500': _serverError["default"],
	  '403': _unauthorized["default"]
	}; // ExceptionImageMap keys
	
	exports.ExceptionMap = ExceptionMap;
	var ExceptionStatus = Object.keys(ExceptionMap);
	/**
	 * render icon
	 * if ExceptionStatus includes ,render svg image
	 * else render iconNode
	 * @param prefixCls
	 * @param {status, icon}
	 */
	
	var renderIcon = function renderIcon(prefixCls, _ref) {
	  var status = _ref.status,
	      icon = _ref.icon;
	  var className = (0, _classnames["default"])("".concat(prefixCls, "-icon"));
	
	  if (ExceptionStatus.includes("".concat(status))) {
	    var SVGComponent = ExceptionMap[status];
	    return (/*#__PURE__*/React.createElement("div", {
	        className: "".concat(className, " ").concat(prefixCls, "-image")
	      }, /*#__PURE__*/React.createElement(SVGComponent, null))
	    );
	  }
	
	  var iconString = IconMap[status];
	  var iconNode = icon || /*#__PURE__*/React.createElement(_icon["default"], {
	    type: iconString,
	    theme: "filled"
	  });
	  return (/*#__PURE__*/React.createElement("div", {
	      className: className
	    }, iconNode)
	  );
	};
	
	var renderExtra = function renderExtra(prefixCls, _ref2) {
	  var extra = _ref2.extra;
	  return extra && /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-extra")
	  }, extra);
	};
	
	var Result = function Result(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls;
	      var customizePrefixCls = props.prefixCls,
	          customizeClassName = props.className,
	          subTitle = props.subTitle,
	          title = props.title,
	          style = props.style,
	          children = props.children,
	          status = props.status;
	      var prefixCls = getPrefixCls('result', customizePrefixCls);
	      var className = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(status), customizeClassName);
	      return (/*#__PURE__*/React.createElement("div", {
	          className: className,
	          style: style
	        }, renderIcon(prefixCls, props), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), subTitle && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-subtitle")
	        }, subTitle), children && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, children), renderExtra(prefixCls, props))
	      );
	    })
	  );
	};
	
	Result.defaultProps = {
	  status: 'info'
	};
	Result.PRESENTED_IMAGE_403 = ExceptionMap[403];
	Result.PRESENTED_IMAGE_404 = ExceptionMap[404];
	Result.PRESENTED_IMAGE_500 = ExceptionMap[500];
	var _default = Result;
	exports["default"] = _default;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var NoFound = function NoFound() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "252",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
	      d: "M0 .387h251.772v251.772H0z"
	    })), /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 .012)"
	    }, /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
	      fill: "#E4EBF7",
	      mask: "url(#b)"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#FFF",
	      strokeWidth: "2",
	      d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
	      fill: "#1890FF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.275 222.1s2.773-1.11 6.102-3.884",
	      stroke: "#648BD8",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
	      fill: "#520038"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M110.846 74.481s1.79-.716 2.506.537",
	      stroke: "#5C2552",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M103.287 72.93s1.83 1.113 4.137.954",
	      stroke: "#5C2552",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
	      stroke: "#DB836E",
	      strokeWidth: "1.118",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M119.306 107.329s.452 4.366-2.127 32.062",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
	      fill: "#F4D19D"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
	      fill: "#F4D19D"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#CC9B6E",
	      d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
	      stroke: "#DB836E",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
	      fill: "#5BA02E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
	      fill: "#92C110"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M88.979 89.48s7.776 5.384 16.6 2.842",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.101",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    })))
	  );
	};
	
	var _default = NoFound;
	exports["default"] = _default;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var ServerError = function ServerError() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "254",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
	      d: "M0 .335h253.49v253.49H0z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 293.665h253.49V.401H0z"
	    })), /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("g", {
	      transform: "translate(0 .067)"
	    }, /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
	      fill: "#E4EBF7",
	      mask: "url(#b)"
	    })), /*#__PURE__*/React.createElement("path", {
	      d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
	      fill: "#FF603B"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
	      fill: "#520038"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.063",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.926 73.284s1.8-.72 2.52.54",
	      stroke: "#5C2552",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
	      stroke: "#DB836E",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.326 71.724s1.84 1.12 4.16.96",
	      stroke: "#5C2552",
	      strokeWidth: "1.117",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
	      stroke: "#DB836E",
	      strokeWidth: "1.063",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.136",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M96.973 219.373s2.882-1.153 6.34-4.034",
	      stroke: "#648BD8",
	      strokeWidth: "1.032",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
	      stroke: "#648BD8",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
	      stroke: "#DB836E",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M109.278 112.533s3.38-3.613 7.575-4.662",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.085",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.375 123.006s9.697-2.745 11.445-.88",
	      stroke: "#E59788",
	      strokeWidth: ".774",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
	      stroke: "#BFCDDD",
	      strokeWidth: "2",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
	      fill: "#A3B4C6"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
	      fill: "#A3B4C6"
	    }), /*#__PURE__*/React.createElement("mask", {
	      fill: "#fff"
	    }), /*#__PURE__*/React.createElement("path", {
	      fill: "#A3B4C6",
	      mask: "url(#d)",
	      d: "M154.098 190.096h70.513v-84.617h-70.513z"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
	      fill: "#FFF",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
	      stroke: "#7C90A5",
	      strokeWidth: "1.124",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
	      fill: "#FFF",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
	      fill: "#BFCDDD",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M177.259 207.217v11.52M201.05 207.217v11.52",
	      stroke: "#A3B4C6",
	      strokeWidth: "1.124",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
	      fill: "#5BA02E",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
	      fill: "#92C110",
	      mask: "url(#d)"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
	      fill: "#F2D7AD",
	      mask: "url(#d)"
	    })))
	  );
	};
	
	var _default = ServerError;
	exports["default"] = _default;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Unauthorized = function Unauthorized() {
	  return (/*#__PURE__*/React.createElement("svg", {
	      width: "251",
	      height: "294"
	    }, /*#__PURE__*/React.createElement("g", {
	      fill: "none",
	      fillRule: "evenodd"
	    }, /*#__PURE__*/React.createElement("path", {
	      d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
	      fill: "#E4EBF7"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
	      stroke: "#FFF",
	      strokeWidth: "2"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#FFF",
	      strokeWidth: "2",
	      d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
	      fill: "#A26EF4"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
	      fill: "#5BA02E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
	      fill: "#92C110"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
	      fill: "#F2D7AD"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M78.18 94.656s.911 7.41-4.914 13.078",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
	      stroke: "#E4EBF7",
	      strokeWidth: ".932",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
	      fill: "#FFB594"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
	      fill: "#5C2552"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round",
	      d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
	      fill: "#552950"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M91.132 86.786s5.269 4.957 12.679 2.327",
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
	      fill: "#DB836E"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
	      stroke: "#5C2552",
	      strokeWidth: "1.526",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
	      stroke: "#DB836E",
	      strokeWidth: "1.145",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.114",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M128.31 87.934s3.013 4.121 4.06 11.785",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
	      stroke: "#DB836E",
	      strokeWidth: ".795",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
	      fill: "#FFC6A0"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M130.532 85.488s4.588 5.757 11.619 6.214",
	      stroke: "#DB836E",
	      strokeWidth: ".75",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M121.708 105.73s-.393 8.564-1.34 13.612",
	      stroke: "#E4EBF7",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
	      fill: "#CBD1D1"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
	      fill: "#2B0849"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
	      fill: "#A4AABA"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
	      fill: "#7BB2F9"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M108.459 220.905s2.759-1.104 6.07-3.863",
	      stroke: "#648BD8",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
	      fill: "#FFF"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
	      fill: "#192064"
	    }), /*#__PURE__*/React.createElement("path", {
	      d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
	      stroke: "#648BD8",
	      strokeWidth: "1.051",
	      strokeLinecap: "round",
	      strokeLinejoin: "round"
	    })))
	  );
	};
	
	var _default = Unauthorized;
	exports["default"] = _default;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	// eslint-disable-next-line react/prefer-stateless-function
	var SkeletonAvatar = /*#__PURE__*/function (_React$Component) {
	  _inherits(SkeletonAvatar, _React$Component);
	
	  var _super = _createSuper(SkeletonAvatar);
	
	  function SkeletonAvatar() {
	    _classCallCheck(this, SkeletonAvatar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(SkeletonAvatar, [{
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          style = _this$props.style,
	          size = _this$props.size,
	          shape = _this$props.shape;
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
	      var shapeCls = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-circle"), shape === 'circle'), _defineProperty(_classNames2, "".concat(prefixCls, "-square"), shape === 'square'), _classNames2));
	      var sizeStyle = typeof size === 'number' ? {
	        width: size,
	        height: size,
	        lineHeight: "".concat(size, "px")
	      } : {};
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])(prefixCls, className, sizeCls, shapeCls),
	          style: _extends(_extends({}, sizeStyle), style)
	        })
	      );
	    }
	  }]);
	
	  return SkeletonAvatar;
	}(React.Component);
	
	SkeletonAvatar.defaultProps = {
	  size: 'large'
	};
	var _default = SkeletonAvatar;
	exports["default"] = _default;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Paragraph = /*#__PURE__*/function (_React$Component) {
	  _inherits(Paragraph, _React$Component);
	
	  var _super = _createSuper(Paragraph);
	
	  function Paragraph() {
	    _classCallCheck(this, Paragraph);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Paragraph, [{
	    key: "getWidth",
	    value: function getWidth(index) {
	      var _this$props = this.props,
	          width = _this$props.width,
	          _this$props$rows = _this$props.rows,
	          rows = _this$props$rows === void 0 ? 2 : _this$props$rows;
	
	      if (Array.isArray(width)) {
	        return width[index];
	      } // last paragraph
	
	
	      if (rows - 1 === index) {
	        return width;
	      }
	
	      return undefined;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          style = _this$props2.style,
	          rows = _this$props2.rows;
	
	      var rowList = _toConsumableArray(Array(rows)).map(function (_, index) {
	        return (
	          /*#__PURE__*/
	          // eslint-disable-next-line react/no-array-index-key
	          React.createElement("li", {
	            key: index,
	            style: {
	              width: _this.getWidth(index)
	            }
	          })
	        );
	      });
	
	      return (/*#__PURE__*/React.createElement("ul", {
	          className: (0, _classnames["default"])(prefixCls, className),
	          style: style
	        }, rowList)
	      );
	    }
	  }]);
	
	  return Paragraph;
	}(React.Component);
	
	var _default = Paragraph;
	exports["default"] = _default;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Title = function Title(_ref) {
	  var prefixCls = _ref.prefixCls,
	      className = _ref.className,
	      width = _ref.width,
	      style = _ref.style;
	  return (/*#__PURE__*/React.createElement("h3", {
	      className: (0, _classnames["default"])(prefixCls, className),
	      style: _extends({
	        width: width
	      }, style)
	    })
	  );
	};
	
	var _default = Title;
	exports["default"] = _default;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _Avatar = _interopRequireDefault(__webpack_require__(1435));
	
	var _Title = _interopRequireDefault(__webpack_require__(1437));
	
	var _Paragraph = _interopRequireDefault(__webpack_require__(1436));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function getComponentProps(prop) {
	  if (prop && _typeof(prop) === 'object') {
	    return prop;
	  }
	
	  return {};
	}
	
	function getAvatarBasicProps(hasTitle, hasParagraph) {
	  if (hasTitle && !hasParagraph) {
	    return {
	      shape: 'square'
	    };
	  }
	
	  return {
	    shape: 'circle'
	  };
	}
	
	function getTitleBasicProps(hasAvatar, hasParagraph) {
	  if (!hasAvatar && hasParagraph) {
	    return {
	      width: '38%'
	    };
	  }
	
	  if (hasAvatar && hasParagraph) {
	    return {
	      width: '50%'
	    };
	  }
	
	  return {};
	}
	
	function getParagraphBasicProps(hasAvatar, hasTitle) {
	  var basicProps = {}; // Width
	
	  if (!hasAvatar || !hasTitle) {
	    basicProps.width = '61%';
	  } // Rows
	
	
	  if (!hasAvatar && hasTitle) {
	    basicProps.rows = 3;
	  } else {
	    basicProps.rows = 2;
	  }
	
	  return basicProps;
	}
	
	var Skeleton = /*#__PURE__*/function (_React$Component) {
	  _inherits(Skeleton, _React$Component);
	
	  var _super = _createSuper(Skeleton);
	
	  function Skeleton() {
	    var _this;
	
	    _classCallCheck(this, Skeleton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSkeleton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          loading = _this$props.loading,
	          className = _this$props.className,
	          children = _this$props.children,
	          avatar = _this$props.avatar,
	          title = _this$props.title,
	          paragraph = _this$props.paragraph,
	          active = _this$props.active;
	      var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
	
	      if (loading || !('loading' in _this.props)) {
	        var _classNames;
	
	        var hasAvatar = !!avatar;
	        var hasTitle = !!title;
	        var hasParagraph = !!paragraph; // Avatar
	
	        var avatarNode;
	
	        if (hasAvatar) {
	          var avatarProps = _extends(_extends({
	            prefixCls: "".concat(prefixCls, "-avatar")
	          }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));
	
	          avatarNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-header")
	          }, /*#__PURE__*/React.createElement(_Avatar["default"], avatarProps));
	        }
	
	        var contentNode;
	
	        if (hasTitle || hasParagraph) {
	          // Title
	          var $title;
	
	          if (hasTitle) {
	            var titleProps = _extends(_extends({
	              prefixCls: "".concat(prefixCls, "-title")
	            }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
	
	            $title = /*#__PURE__*/React.createElement(_Title["default"], titleProps);
	          } // Paragraph
	
	
	          var paragraphNode;
	
	          if (hasParagraph) {
	            var paragraphProps = _extends(_extends({
	              prefixCls: "".concat(prefixCls, "-paragraph")
	            }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
	
	            paragraphNode = /*#__PURE__*/React.createElement(_Paragraph["default"], paragraphProps);
	          }
	
	          contentNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-content")
	          }, $title, paragraphNode);
	        }
	
	        var cls = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-avatar"), hasAvatar), _defineProperty(_classNames, "".concat(prefixCls, "-active"), active), _classNames));
	        return (/*#__PURE__*/React.createElement("div", {
	            className: cls
	          }, avatarNode, contentNode)
	        );
	      }
	
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Skeleton, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSkeleton)
	      );
	    }
	  }]);
	
	  return Skeleton;
	}(React.Component);
	
	Skeleton.defaultProps = {
	  avatar: false,
	  title: true,
	  paragraph: true
	};
	var _default = Skeleton;
	exports["default"] = _default;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _Slider = _interopRequireDefault(__webpack_require__(475));
	
	var _Range = _interopRequireDefault(__webpack_require__(474));
	
	var _Handle = _interopRequireDefault(__webpack_require__(503));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(126));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _this.toggleTooltipVisible = function (index, visible) {
	      _this.setState(function (_ref) {
	        var visibles = _ref.visibles;
	        return {
	          visibles: _extends(_extends({}, visibles), _defineProperty({}, index, visible))
	        };
	      });
	    };
	
	    _this.handleWithTooltip = function (_a) {
	      var tooltipPrefixCls = _a.tooltipPrefixCls,
	          prefixCls = _a.prefixCls,
	          _b = _a.info,
	          value = _b.value,
	          dragging = _b.dragging,
	          index = _b.index,
	          restProps = __rest(_b, ["value", "dragging", "index"]);
	
	      var _this$props = _this.props,
	          tipFormatter = _this$props.tipFormatter,
	          tooltipVisible = _this$props.tooltipVisible,
	          tooltipPlacement = _this$props.tooltipPlacement,
	          getTooltipPopupContainer = _this$props.getTooltipPopupContainer;
	      var visibles = _this.state.visibles;
	      var isTipFormatter = tipFormatter ? visibles[index] || dragging : false;
	      var visible = tooltipVisible || tooltipVisible === undefined && isTipFormatter;
	      return (/*#__PURE__*/React.createElement(_tooltip["default"], {
	          prefixCls: tooltipPrefixCls,
	          title: tipFormatter ? tipFormatter(value) : '',
	          visible: visible,
	          placement: tooltipPlacement || 'top',
	          transitionName: "zoom-down",
	          key: index,
	          overlayClassName: "".concat(prefixCls, "-tooltip"),
	          getPopupContainer: getTooltipPopupContainer || function () {
	            return document.body;
	          }
	        }, /*#__PURE__*/React.createElement(_Handle["default"], _extends({}, restProps, {
	          value: value,
	          onMouseEnter: function onMouseEnter() {
	            return _this.toggleTooltipVisible(index, true);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this.toggleTooltipVisible(index, false);
	          }
	        })))
	      );
	    };
	
	    _this.saveSlider = function (node) {
	      _this.rcSlider = node;
	    };
	
	    _this.renderSlider = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeTooltipPrefixCls = _a.tooltipPrefixCls,
	          range = _a.range,
	          restProps = __rest(_a, ["prefixCls", "tooltipPrefixCls", "range"]);
	
	      var prefixCls = getPrefixCls('slider', customizePrefixCls);
	      var tooltipPrefixCls = getPrefixCls('tooltip', customizeTooltipPrefixCls);
	
	      if (range) {
	        return (/*#__PURE__*/React.createElement(_Range["default"], _extends({}, restProps, {
	            ref: _this.saveSlider,
	            handle: function handle(info) {
	              return _this.handleWithTooltip({
	                tooltipPrefixCls: tooltipPrefixCls,
	                prefixCls: prefixCls,
	                info: info
	              });
	            },
	            prefixCls: prefixCls,
	            tooltipPrefixCls: tooltipPrefixCls
	          }))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_Slider["default"], _extends({}, restProps, {
	          ref: _this.saveSlider,
	          handle: function handle(info) {
	            return _this.handleWithTooltip({
	              tooltipPrefixCls: tooltipPrefixCls,
	              prefixCls: prefixCls,
	              info: info
	            });
	          },
	          prefixCls: prefixCls,
	          tooltipPrefixCls: tooltipPrefixCls
	        }))
	      );
	    };
	
	    _this.state = {
	      visibles: {}
	    };
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "focus",
	    value: function focus() {
	      this.rcSlider.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSlider.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSlider)
	      );
	    }
	  }]);
	
	  return Slider;
	}(React.Component);
	
	exports["default"] = Slider;
	Slider.defaultProps = {
	  tipFormatter: function tipFormatter(value) {
	    return value.toString();
	  }
	};

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	var _Statistic = _interopRequireDefault(__webpack_require__(758));
	
	var _utils = __webpack_require__(1443);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var REFRESH_INTERVAL = 1000 / 30;
	
	function getTime(value) {
	  return (0, _interopDefault["default"])(moment)(value).valueOf();
	}
	
	var Countdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Countdown, _React$Component);
	
	  var _super = _createSuper(Countdown);
	
	  function Countdown() {
	    var _this;
	
	    _classCallCheck(this, Countdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.syncTimer = function () {
	      var value = _this.props.value;
	      var timestamp = getTime(value);
	
	      if (timestamp >= Date.now()) {
	        _this.startTimer();
	      } else {
	        _this.stopTimer();
	      }
	    };
	
	    _this.startTimer = function () {
	      if (_this.countdownId) return;
	      _this.countdownId = window.setInterval(function () {
	        _this.forceUpdate();
	      }, REFRESH_INTERVAL);
	    };
	
	    _this.stopTimer = function () {
	      var _this$props = _this.props,
	          onFinish = _this$props.onFinish,
	          value = _this$props.value;
	
	      if (_this.countdownId) {
	        clearInterval(_this.countdownId);
	        _this.countdownId = undefined;
	        var timestamp = getTime(value);
	
	        if (onFinish && timestamp < Date.now()) {
	          onFinish();
	        }
	      }
	    };
	
	    _this.formatCountdown = function (value, config) {
	      var format = _this.props.format;
	      return (0, _utils.formatCountdown)(value, _extends(_extends({}, config), {
	        format: format
	      }));
	    }; // Countdown do not need display the timestamp
	
	
	    _this.valueRender = function (node) {
	      return (/*#__PURE__*/React.cloneElement(node, {
	          title: undefined
	        })
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Countdown, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.syncTimer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.syncTimer();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopTimer();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_Statistic["default"], _extends({
	          valueRender: this.valueRender
	        }, this.props, {
	          formatter: this.formatCountdown
	        }))
	      );
	    }
	  }]);
	
	  return Countdown;
	}(React.Component);
	
	Countdown.defaultProps = {
	  format: 'HH:mm:ss'
	};
	(0, _reactLifecyclesCompat.polyfill)(Countdown);
	var _default = Countdown;
	exports["default"] = _default;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _padEnd = _interopRequireDefault(__webpack_require__(457));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var StatisticNumber = function StatisticNumber(props) {
	  var value = props.value,
	      formatter = props.formatter,
	      precision = props.precision,
	      decimalSeparator = props.decimalSeparator,
	      _props$groupSeparator = props.groupSeparator,
	      groupSeparator = _props$groupSeparator === void 0 ? '' : _props$groupSeparator,
	      prefixCls = props.prefixCls;
	  var valueNode;
	
	  if (typeof formatter === 'function') {
	    // Customize formatter
	    valueNode = formatter(value);
	  } else {
	    // Internal formatter
	    var val = String(value);
	    var cells = val.match(/^(-?)(\d*)(\.(\d+))?$/); // Process if illegal number
	
	    if (!cells) {
	      valueNode = val;
	    } else {
	      var negative = cells[1];
	
	      var _int = cells[2] || '0';
	
	      var decimal = cells[4] || '';
	      _int = _int.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
	
	      if (typeof precision === 'number') {
	        decimal = (0, _padEnd["default"])(decimal, precision, '0').slice(0, precision);
	      }
	
	      if (decimal) {
	        decimal = "".concat(decimalSeparator).concat(decimal);
	      }
	
	      valueNode = [/*#__PURE__*/React.createElement("span", {
	        key: "int",
	        className: "".concat(prefixCls, "-content-value-int")
	      }, negative, _int), decimal && /*#__PURE__*/React.createElement("span", {
	        key: "decimal",
	        className: "".concat(prefixCls, "-content-value-decimal")
	      }, decimal)];
	    }
	  }
	
	  return (/*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-content-value")
	    }, valueNode)
	  );
	};
	
	var _default = StatisticNumber;
	exports["default"] = _default;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Statistic = _interopRequireDefault(__webpack_require__(758));
	
	var _Countdown = _interopRequireDefault(__webpack_require__(1440));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Statistic["default"].Countdown = _Countdown["default"];
	var _default = _Statistic["default"];
	exports["default"] = _default;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTimeStr = formatTimeStr;
	exports.formatCountdown = formatCountdown;
	
	var moment = _interopRequireWildcard(__webpack_require__(40));
	
	var _padStart = _interopRequireDefault(__webpack_require__(458));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(110));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;_e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }return _arr;
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	// Countdown
	var timeUnits = [['Y', 1000 * 60 * 60 * 24 * 365], ['M', 1000 * 60 * 60 * 24 * 30], ['D', 1000 * 60 * 60 * 24], ['H', 1000 * 60 * 60], ['m', 1000 * 60], ['s', 1000], ['S', 1]];
	
	function formatTimeStr(duration, format) {
	  var leftDuration = duration;
	  var escapeRegex = /\[[^\]]*\]/g;
	  var keepList = (format.match(escapeRegex) || []).map(function (str) {
	    return str.slice(1, -1);
	  });
	  var templateText = format.replace(escapeRegex, '[]');
	  var replacedText = timeUnits.reduce(function (current, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        name = _ref2[0],
	        unit = _ref2[1];
	
	    if (current.indexOf(name) !== -1) {
	      var value = Math.floor(leftDuration / unit);
	      leftDuration -= value * unit;
	      return current.replace(new RegExp("".concat(name, "+"), 'g'), function (match) {
	        var len = match.length;
	        return (0, _padStart["default"])(value.toString(), len, '0');
	      });
	    }
	
	    return current;
	  }, templateText);
	  var index = 0;
	  return replacedText.replace(escapeRegex, function () {
	    var match = keepList[index];
	    index += 1;
	    return match;
	  });
	}
	
	function formatCountdown(value, config) {
	  var _config$format = config.format,
	      format = _config$format === void 0 ? '' : _config$format;
	  var target = (0, _interopDefault["default"])(moment)(value).valueOf();
	  var current = (0, _interopDefault["default"])(moment)().valueOf();
	  var diff = Math.max(target - current, 0);
	  return formatTimeStr(diff, format);
	}

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSteps = _interopRequireDefault(__webpack_require__(476));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Steps = /*#__PURE__*/function (_React$Component) {
	  _inherits(Steps, _React$Component);
	
	  var _super = _createSuper(Steps);
	
	  function Steps() {
	    var _this;
	
	    _classCallCheck(this, Steps);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSteps = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var prefixCls = getPrefixCls('steps', _this.props.prefixCls);
	      var iconPrefix = getPrefixCls('', _this.props.iconPrefix);
	      var icons = {
	        finish: /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "check",
	          className: "".concat(prefixCls, "-finish-icon")
	        }),
	        error: /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close",
	          className: "".concat(prefixCls, "-error-icon")
	        })
	      };
	      return (/*#__PURE__*/React.createElement(_rcSteps["default"], _extends({
	          icons: icons
	        }, _this.props, {
	          prefixCls: prefixCls,
	          iconPrefix: iconPrefix
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Steps, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSteps)
	      );
	    }
	  }]);
	
	  return Steps;
	}(React.Component);
	
	exports["default"] = Steps;
	Steps.Step = _rcSteps["default"].Step;
	Steps.defaultProps = {
	  current: 0
	};
	Steps.propTypes = {
	  prefixCls: PropTypes.string,
	  iconPrefix: PropTypes.string,
	  current: PropTypes.number
	};

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSwitch = _interopRequireDefault(__webpack_require__(477));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _wave = _interopRequireDefault(__webpack_require__(376));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Switch = /*#__PURE__*/function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  var _super = _createSuper(Switch);
	
	  function Switch(props) {
	    var _this;
	
	    _classCallCheck(this, Switch);
	
	    _this = _super.call(this, props);
	
	    _this.saveSwitch = function (node) {
	      _this.rcSwitch = node;
	    };
	
	    _this.renderSwitch = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          size = _this$props.size,
	          loading = _this$props.loading,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          disabled = _this$props.disabled;
	      var prefixCls = getPrefixCls('switch', customizePrefixCls);
	      var classes = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-small"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _classNames));
	      var loadingIcon = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "loading",
	        className: "".concat(prefixCls, "-loading-icon")
	      }) : null;
	      return (/*#__PURE__*/React.createElement(_wave["default"], {
	          insertExtraNode: true
	        }, /*#__PURE__*/React.createElement(_rcSwitch["default"], _extends({}, (0, _omit["default"])(_this.props, ['loading']), {
	          prefixCls: prefixCls,
	          className: classes,
	          disabled: disabled || loading,
	          ref: _this.saveSwitch,
	          loadingIcon: loadingIcon
	        })))
	      );
	    };
	
	    (0, _warning["default"])('checked' in props || !('value' in props), 'Switch', '`value` is not validate prop, do you mean `checked`?');
	    return _this;
	  }
	
	  _createClass(Switch, [{
	    key: "focus",
	    value: function focus() {
	      this.rcSwitch.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSwitch.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSwitch)
	      );
	    }
	  }]);
	
	  return Switch;
	}(React.Component);
	
	exports["default"] = Switch;
	Switch.__ANT_SWITCH = true;
	Switch.propTypes = {
	  prefixCls: PropTypes.string,
	  // HACK: https://github.com/ant-design/ant-design/issues/5368
	  // size=default and size=large are the same
	  size: PropTypes.oneOf(['small', 'default', 'large']),
	  className: PropTypes.string
	};

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	/* eslint-disable react/prefer-stateless-function */
	var Column = /*#__PURE__*/function (_React$Component) {
	  _inherits(Column, _React$Component);
	
	  var _super = _createSuper(Column);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _super.apply(this, arguments);
	  }
	
	  return Column;
	}(React.Component);
	
	exports["default"] = Column;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ColumnGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(ColumnGroup, _React$Component);
	
	  var _super = _createSuper(ColumnGroup);
	
	  function ColumnGroup() {
	    _classCallCheck(this, ColumnGroup);
	
	    return _super.apply(this, arguments);
	  }
	
	  return ColumnGroup;
	}(React.Component);
	
	exports["default"] = ColumnGroup;
	ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
	  return (/*#__PURE__*/React.createElement("div", {
	      className: props.className,
	      onClick: function onClick(e) {
	        return e.stopPropagation();
	      }
	    }, props.children)
	  );
	};
	
	var _default = FilterDropdownMenuWrapper;
	exports["default"] = _default;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(163));
	
	var _radio = _interopRequireDefault(__webpack_require__(258));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SelectionBox = /*#__PURE__*/function (_React$Component) {
	  _inherits(SelectionBox, _React$Component);
	
	  var _super = _createSuper(SelectionBox);
	
	  function SelectionBox(props) {
	    var _this;
	
	    _classCallCheck(this, SelectionBox);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      checked: _this.getCheckState(props)
	    };
	    return _this;
	  }
	
	  _createClass(SelectionBox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.subscribe();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribe) {
	        this.unsubscribe();
	      }
	    } // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: "getCheckState",
	    value: function getCheckState(props) {
	      var store = props.store,
	          defaultSelection = props.defaultSelection,
	          rowIndex = props.rowIndex;
	      var checked = false;
	
	      if (store.getState().selectionDirty) {
	        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
	      } else {
	        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
	      }
	
	      return checked;
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe() {
	      var _this2 = this;
	
	      var store = this.props.store;
	      this.unsubscribe = store.subscribe(function () {
	        var checked = _this2.getCheckState(_this2.props);
	
	        _this2.setState({
	          checked: checked
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          type = _a.type,
	          rowIndex = _a.rowIndex,
	          rest = __rest(_a, ["type", "rowIndex"]);
	
	      var checked = this.state.checked;
	
	      if (type === 'radio') {
	        return (/*#__PURE__*/React.createElement(_radio["default"], _extends({
	            checked: checked,
	            value: rowIndex
	          }, rest))
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement(_checkbox["default"], _extends({
	          checked: checked
	        }, rest))
	      );
	    }
	  }]);
	
	  return SelectionBox;
	}(React.Component);
	
	exports["default"] = SelectionBox;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _checkbox = _interopRequireDefault(__webpack_require__(163));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(379));
	
	var _menu = _interopRequireDefault(__webpack_require__(382));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function checkSelection(_ref) {
	  var store = _ref.store,
	      getCheckboxPropsByItem = _ref.getCheckboxPropsByItem,
	      getRecordKey = _ref.getRecordKey,
	      data = _ref.data,
	      type = _ref.type,
	      byDefaultChecked = _ref.byDefaultChecked;
	  return byDefaultChecked ? data[type](function (item, i) {
	    return getCheckboxPropsByItem(item, i).defaultChecked;
	  }) : data[type](function (item, i) {
	    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
	  });
	}
	
	function getIndeterminateState(props) {
	  var store = props.store,
	      data = props.data;
	
	  if (!data.length) {
	    return false;
	  }
	
	  var someCheckedNotByDefaultChecked = checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'some',
	    byDefaultChecked: false
	  })) && !checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: false
	  }));
	  var someCheckedByDefaultChecked = checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'some',
	    byDefaultChecked: true
	  })) && !checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: true
	  }));
	
	  if (store.getState().selectionDirty) {
	    return someCheckedNotByDefaultChecked;
	  }
	
	  return someCheckedNotByDefaultChecked || someCheckedByDefaultChecked;
	}
	
	function getCheckState(props) {
	  var store = props.store,
	      data = props.data;
	
	  if (!data.length) {
	    return false;
	  }
	
	  if (store.getState().selectionDirty) {
	    return checkSelection(_extends(_extends({}, props), {
	      data: data,
	      type: 'every',
	      byDefaultChecked: false
	    }));
	  }
	
	  return checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: false
	  })) || checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: true
	  }));
	}
	
	var SelectionCheckboxAll = /*#__PURE__*/function (_React$Component) {
	  _inherits(SelectionCheckboxAll, _React$Component);
	
	  var _super = _createSuper(SelectionCheckboxAll);
	
	  function SelectionCheckboxAll(props) {
	    var _this;
	
	    _classCallCheck(this, SelectionCheckboxAll);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      checked: false,
	      indeterminate: false
	    };
	
	    _this.handleSelectAllChange = function (e) {
	      var checked = e.target.checked;
	
	      _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
	    };
	
	    _this.defaultSelections = props.hideDefaultSelections ? [] : [{
	      key: 'all',
	      text: props.locale.selectAll
	    }, {
	      key: 'invert',
	      text: props.locale.selectInvert
	    }];
	    return _this;
	  }
	
	  _createClass(SelectionCheckboxAll, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.subscribe();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribe) {
	        this.unsubscribe();
	      }
	    }
	  }, {
	    key: "setCheckState",
	    value: function setCheckState(props) {
	      var checked = getCheckState(props);
	      var indeterminate = getIndeterminateState(props);
	      this.setState(function (prevState) {
	        var newState = {};
	
	        if (indeterminate !== prevState.indeterminate) {
	          newState.indeterminate = indeterminate;
	        }
	
	        if (checked !== prevState.checked) {
	          newState.checked = checked;
	        }
	
	        return newState;
	      });
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe() {
	      var _this2 = this;
	
	      var store = this.props.store;
	      this.unsubscribe = store.subscribe(function () {
	        _this2.setCheckState(_this2.props);
	      });
	    }
	  }, {
	    key: "renderMenus",
	    value: function renderMenus(selections) {
	      var _this3 = this;
	
	      return selections.map(function (selection, index) {
	        return (/*#__PURE__*/React.createElement(_menu["default"].Item, {
	            key: selection.key || index
	          }, /*#__PURE__*/React.createElement("div", {
	            onClick: function onClick() {
	              _this3.props.onSelect(selection.key, index, selection.onSelect);
	            }
	          }, selection.text))
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          disabled = _this$props.disabled,
	          prefixCls = _this$props.prefixCls,
	          selections = _this$props.selections,
	          getPopupContainer = _this$props.getPopupContainer;
	      var _this$state = this.state,
	          checked = _this$state.checked,
	          indeterminate = _this$state.indeterminate;
	      var selectionPrefixCls = "".concat(prefixCls, "-selection");
	      var customSelections = null;
	
	      if (selections) {
	        var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
	        var menu = /*#__PURE__*/React.createElement(_menu["default"], {
	          className: "".concat(selectionPrefixCls, "-menu"),
	          selectedKeys: []
	        }, this.renderMenus(newSelections));
	        customSelections = newSelections.length > 0 ? /*#__PURE__*/React.createElement(_dropdown["default"], {
	          overlay: menu,
	          getPopupContainer: getPopupContainer
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(selectionPrefixCls, "-down")
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "down"
	        }))) : null;
	      }
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: selectionPrefixCls
	        }, /*#__PURE__*/React.createElement(_checkbox["default"], {
	          className: (0, _classnames["default"])(_defineProperty({}, "".concat(selectionPrefixCls, "-select-all-custom"), customSelections)),
	          checked: checked,
	          indeterminate: indeterminate,
	          disabled: disabled,
	          onChange: this.handleSelectAllChange
	        }), customSelections)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      var checked = getCheckState(props);
	      var indeterminate = getIndeterminateState(props);
	      var newState = {};
	
	      if (indeterminate !== state.indeterminate) {
	        newState.indeterminate = indeterminate;
	      }
	
	      if (checked !== state.checked) {
	        newState.checked = checked;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return SelectionCheckboxAll;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(SelectionCheckboxAll);
	var _default = SelectionCheckboxAll;
	exports["default"] = _default;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _rcTable = _interopRequireWildcard(__webpack_require__(479));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _filterDropdown = _interopRequireDefault(__webpack_require__(1454));
	
	var _createStore = _interopRequireDefault(__webpack_require__(1453));
	
	var _SelectionBox = _interopRequireDefault(__webpack_require__(1449));
	
	var _SelectionCheckboxAll = _interopRequireDefault(__webpack_require__(1450));
	
	var _Column = _interopRequireDefault(__webpack_require__(1446));
	
	var _ColumnGroup = _interopRequireDefault(__webpack_require__(1447));
	
	var _createBodyRow = _interopRequireDefault(__webpack_require__(1452));
	
	var _util = __webpack_require__(759);
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(374));
	
	var _pagination = _interopRequireDefault(__webpack_require__(384));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _spin = _interopRequireDefault(__webpack_require__(259));
	
	var _transButton = _interopRequireDefault(__webpack_require__(375));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _default2 = _interopRequireDefault(__webpack_require__(164));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable prefer-spread */
	
	function noop() {}
	
	function stopPropagation(e) {
	  e.stopPropagation();
	}
	
	function getRowSelection(props) {
	  return props.rowSelection || {};
	}
	
	function getColumnKey(column, index) {
	  return column.key || column.dataIndex || index;
	}
	
	function isSameColumn(a, b) {
	  if (a && b && a.key && a.key === b.key) {
	    return true;
	  }
	
	  return a === b || (0, _shallowequal["default"])(a, b, function (value, other) {
	    // https://github.com/ant-design/ant-design/issues/12737
	    if (typeof value === 'function' && typeof other === 'function') {
	      return value === other || value.toString() === other.toString();
	    } // https://github.com/ant-design/ant-design/issues/19398
	
	
	    if (Array.isArray(value) && Array.isArray(other)) {
	      return value === other || (0, _shallowequal["default"])(value, other);
	    }
	  });
	}
	
	var defaultPagination = {
	  onChange: noop,
	  onShowSizeChange: noop
	};
	/**
	 * Avoid creating new object, so that parent component's shouldComponentUpdate
	 * can works appropriately。
	 */
	
	var emptyObject = {};
	
	var createComponents = function createComponents() {
	  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var bodyRow = components && components.body && components.body.row;
	  return _extends(_extends({}, components), {
	    body: _extends(_extends({}, components.body), {
	      row: (0, _createBodyRow["default"])(bodyRow)
	    })
	  });
	};
	
	function isTheSameComponents() {
	  var components1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var components2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return components1 === components2 || ['table', 'header', 'body'].every(function (key) {
	    return (0, _shallowequal["default"])(components1[key], components2[key]);
	  });
	}
	
	function getFilteredValueColumns(state, columns) {
	  return (0, _util.flatFilter)(columns || (state || {}).columns || [], function (column) {
	    return typeof column.filteredValue !== 'undefined';
	  });
	}
	
	function getFiltersFromColumns() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var columns = arguments.length > 1 ? arguments[1] : undefined;
	  var filters = {};
	  getFilteredValueColumns(state, columns).forEach(function (col) {
	    var colKey = getColumnKey(col);
	    filters[colKey] = col.filteredValue;
	  });
	  return filters;
	}
	
	function isFiltersChanged(state, filters) {
	  if (Object.keys(filters).length !== Object.keys(state.filters).length) {
	    return true;
	  }
	
	  return Object.keys(filters).some(function (columnKey) {
	    return filters[columnKey] !== state.filters[columnKey];
	  });
	}
	
	var Table = /*#__PURE__*/function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  var _super = _createSuper(Table);
	
	  function Table(props) {
	    var _this;
	
	    _classCallCheck(this, Table);
	
	    _this = _super.call(this, props);
	
	    _this.setTableRef = function (table) {
	      _this.rcTable = table;
	    };
	
	    _this.getCheckboxPropsByItem = function (item, index) {
	      var rowSelection = getRowSelection(_this.props);
	
	      if (!rowSelection.getCheckboxProps) {
	        return {};
	      }
	
	      var key = _this.getRecordKey(item, index); // Cache checkboxProps
	
	
	      if (!_this.props.checkboxPropsCache[key]) {
	        _this.props.checkboxPropsCache[key] = rowSelection.getCheckboxProps(item) || {};
	        var checkboxProps = _this.props.checkboxPropsCache[key];
	        (0, _warning["default"])(!('checked' in checkboxProps) && !('defaultChecked' in checkboxProps), 'Table', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
	      }
	
	      return _this.props.checkboxPropsCache[key];
	    };
	
	    _this.getRecordKey = function (record, index) {
	      var rowKey = _this.props.rowKey;
	      var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
	      (0, _warning["default"])(recordKey !== undefined, 'Table', 'Each record in dataSource of table should have a unique `key` prop, ' + 'or set `rowKey` of Table to an unique primary key, ' + 'see https://u.ant.design/table-row-key');
	      return recordKey === undefined ? index : recordKey;
	    };
	
	    _this.onRow = function (prefixCls, record, index) {
	      var onRow = _this.props.onRow;
	      var custom = onRow ? onRow(record, index) : {};
	      return _extends(_extends({}, custom), {
	        prefixCls: prefixCls,
	        store: _this.props.store,
	        rowKey: _this.getRecordKey(record, index)
	      });
	    };
	
	    _this.generatePopupContainerFunc = function (getPopupContainer) {
	      var scroll = _this.props.scroll;
	      var table = _this.rcTable;
	
	      if (getPopupContainer) {
	        return getPopupContainer;
	      } // Use undefined to let rc component use default logic.
	
	
	      return scroll && table ? function () {
	        return table.tableNode;
	      } : undefined;
	    };
	
	    _this.scrollToFirstRow = function () {
	      var scroll = _this.props.scroll;
	
	      if (scroll && scroll.scrollToFirstRowOnChange !== false) {
	        (0, _scrollTo["default"])(0, {
	          getContainer: function getContainer() {
	            return _this.rcTable.bodyTable;
	          }
	        });
	      }
	    };
	
	    _this.handleFilter = function (column, nextFilters) {
	      var props = _this.props;
	
	      var pagination = _extends({}, _this.state.pagination);
	
	      var filters = _extends(_extends({}, _this.state.filters), _defineProperty({}, getColumnKey(column), nextFilters)); // Remove filters not in current columns
	
	
	      var currentColumnKeys = [];
	      (0, _util.treeMap)(_this.state.columns, function (c) {
	        if (!c.children) {
	          currentColumnKeys.push(getColumnKey(c));
	        }
	      });
	      Object.keys(filters).forEach(function (columnKey) {
	        if (currentColumnKeys.indexOf(columnKey) < 0) {
	          delete filters[columnKey];
	        }
	      });
	
	      if (props.pagination) {
	        // Reset current prop
	        pagination.current = 1;
	        pagination.onChange(pagination.current);
	      }
	
	      var newState = {
	        pagination: pagination,
	        filters: {}
	      };
	
	      var filtersToSetState = _extends({}, filters); // Remove filters which is controlled
	
	
	      getFilteredValueColumns(_this.state).forEach(function (col) {
	        var columnKey = getColumnKey(col);
	
	        if (columnKey) {
	          delete filtersToSetState[columnKey];
	        }
	      });
	
	      if (Object.keys(filtersToSetState).length > 0) {
	        newState.filters = filtersToSetState;
	      } // Controlled current prop will not respond user interaction
	
	
	      if (_typeof(props.pagination) === 'object' && 'current' in props.pagination) {
	        newState.pagination = _extends(_extends({}, pagination), {
	          current: _this.state.pagination.current
	        });
	      }
	
	      _this.setState(newState, function () {
	        _this.scrollToFirstRow();
	
	        _this.props.store.setState({
	          selectionDirty: false
	        });
	
	        var onChange = _this.props.onChange;
	
	        if (onChange) {
	          onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	            selectionDirty: false,
	            filters: filters,
	            pagination: pagination
	          })));
	        }
	      });
	    };
	
	    _this.handleSelect = function (record, rowIndex, e) {
	      var checked = e.target.checked;
	      var nativeEvent = e.nativeEvent;
	      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	
	      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);
	
	      var key = _this.getRecordKey(record, rowIndex);
	
	      var pivot = _this.state.pivot;
	
	      var rows = _this.getFlatCurrentPageData();
	
	      var realIndex = rowIndex;
	
	      if (_this.props.expandedRowRender) {
	        realIndex = rows.findIndex(function (row) {
	          return _this.getRecordKey(row, rowIndex) === key;
	        });
	      }
	
	      if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
	        var changeRowKeys = [];
	        var direction = Math.sign(pivot - realIndex);
	        var dist = Math.abs(pivot - realIndex);
	        var step = 0;
	
	        var _loop = function _loop() {
	          var i = realIndex + step * direction;
	          step += 1;
	          var row = rows[i];
	
	          var rowKey = _this.getRecordKey(row, i);
	
	          var checkboxProps = _this.getCheckboxPropsByItem(row, i);
	
	          if (!checkboxProps.disabled) {
	            if (selectedRowKeys.includes(rowKey)) {
	              if (!checked) {
	                selectedRowKeys = selectedRowKeys.filter(function (j) {
	                  return rowKey !== j;
	                });
	                changeRowKeys.push(rowKey);
	              }
	            } else if (checked) {
	              selectedRowKeys.push(rowKey);
	              changeRowKeys.push(rowKey);
	            }
	          }
	        };
	
	        while (step <= dist) {
	          _loop();
	        }
	
	        _this.setState({
	          pivot: realIndex
	        });
	
	        _this.props.store.setState({
	          selectionDirty: true
	        });
	
	        _this.setSelectedRowKeys(selectedRowKeys, {
	          selectWay: 'onSelectMultiple',
	          record: record,
	          checked: checked,
	          changeRowKeys: changeRowKeys,
	          nativeEvent: nativeEvent
	        });
	      } else {
	        if (checked) {
	          selectedRowKeys.push(_this.getRecordKey(record, realIndex));
	        } else {
	          selectedRowKeys = selectedRowKeys.filter(function (i) {
	            return key !== i;
	          });
	        }
	
	        _this.setState({
	          pivot: realIndex
	        });
	
	        _this.props.store.setState({
	          selectionDirty: true
	        });
	
	        _this.setSelectedRowKeys(selectedRowKeys, {
	          selectWay: 'onSelect',
	          record: record,
	          checked: checked,
	          changeRowKeys: undefined,
	          nativeEvent: nativeEvent
	        });
	      }
	    };
	
	    _this.handleRadioSelect = function (record, rowIndex, e) {
	      var checked = e.target.checked;
	      var nativeEvent = e.nativeEvent;
	
	      var key = _this.getRecordKey(record, rowIndex);
	
	      var selectedRowKeys = [key];
	
	      _this.props.store.setState({
	        selectionDirty: true
	      });
	
	      _this.setSelectedRowKeys(selectedRowKeys, {
	        selectWay: 'onSelect',
	        record: record,
	        checked: checked,
	        changeRowKeys: undefined,
	        nativeEvent: nativeEvent
	      });
	    };
	
	    _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
	      var data = _this.getFlatCurrentPageData();
	
	      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	
	      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);
	
	      var changeableRowKeys = data.filter(function (item, i) {
	        return !_this.getCheckboxPropsByItem(item, i).disabled;
	      }).map(function (item, i) {
	        return _this.getRecordKey(item, i);
	      });
	      var changeRowKeys = [];
	      var selectWay = 'onSelectAll';
	      var checked; // handle default selection
	
	      switch (selectionKey) {
	        case 'all':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) < 0) {
	              selectedRowKeys.push(key);
	              changeRowKeys.push(key);
	            }
	          });
	          selectWay = 'onSelectAll';
	          checked = true;
	          break;
	
	        case 'removeAll':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) >= 0) {
	              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	              changeRowKeys.push(key);
	            }
	          });
	          selectWay = 'onSelectAll';
	          checked = false;
	          break;
	
	        case 'invert':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) < 0) {
	              selectedRowKeys.push(key);
	            } else {
	              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	            }
	
	            changeRowKeys.push(key);
	            selectWay = 'onSelectInvert';
	          });
	          break;
	
	        default:
	          break;
	      }
	
	      _this.props.store.setState({
	        selectionDirty: true
	      }); // when select custom selection, callback selections[n].onSelect
	
	
	      var rowSelection = _this.props.rowSelection;
	      var customSelectionStartIndex = 2;
	
	      if (rowSelection && rowSelection.hideDefaultSelections) {
	        customSelectionStartIndex = 0;
	      }
	
	      if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
	        return onSelectFunc(changeableRowKeys);
	      }
	
	      _this.setSelectedRowKeys(selectedRowKeys, {
	        selectWay: selectWay,
	        checked: checked,
	        changeRowKeys: changeRowKeys
	      });
	    };
	
	    _this.handlePageChange = function (current) {
	      var props = _this.props;
	
	      var pagination = _extends({}, _this.state.pagination);
	
	      if (current) {
	        pagination.current = current;
	      } else {
	        pagination.current = pagination.current || 1;
	      }
	
	      for (var _len = arguments.length, otherArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        otherArguments[_key - 1] = arguments[_key];
	      }
	
	      pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
	      var newState = {
	        pagination: pagination
	      }; // Controlled current prop will not respond user interaction
	
	      if (props.pagination && _typeof(props.pagination) === 'object' && 'current' in props.pagination) {
	        newState.pagination = _extends(_extends({}, pagination), {
	          current: _this.state.pagination.current
	        });
	      }
	
	      _this.setState(newState, _this.scrollToFirstRow);
	
	      _this.props.store.setState({
	        selectionDirty: false
	      });
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	          selectionDirty: false,
	          pagination: pagination
	        })));
	      }
	    };
	
	    _this.handleShowSizeChange = function (current, pageSize) {
	      var pagination = _this.state.pagination;
	      pagination.onShowSizeChange(current, pageSize);
	
	      var nextPagination = _extends(_extends({}, pagination), {
	        pageSize: pageSize,
	        current: current
	      });
	
	      _this.setState({
	        pagination: nextPagination
	      }, _this.scrollToFirstRow);
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	          pagination: nextPagination
	        })));
	      }
	    };
	
	    _this.renderExpandIcon = function (prefixCls) {
	      return function (_ref) {
	        var expandable = _ref.expandable,
	            expanded = _ref.expanded,
	            needIndentSpaced = _ref.needIndentSpaced,
	            record = _ref.record,
	            onExpand = _ref.onExpand;
	
	        if (expandable) {
	          return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	              componentName: "Table",
	              defaultLocale: _default2["default"].Table
	            }, function (locale) {
	              var _classNames;
	
	              return (/*#__PURE__*/React.createElement(_transButton["default"], {
	                  className: (0, _classnames["default"])("".concat(prefixCls, "-row-expand-icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _defineProperty(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), _classNames)),
	                  onClick: function onClick(event) {
	                    onExpand(record, event);
	                  },
	                  "aria-label": expanded ? locale.collapse : locale.expand,
	                  noStyle: true
	                })
	              );
	            })
	          );
	        }
	
	        if (needIndentSpaced) {
	          return (/*#__PURE__*/React.createElement("span", {
	              className: "".concat(prefixCls, "-row-expand-icon ").concat(prefixCls, "-row-spaced")
	            })
	          );
	        }
	
	        return null;
	      };
	    };
	
	    _this.renderSelectionBox = function (type) {
	      return function (_, record, index) {
	        var rowKey = _this.getRecordKey(record, index);
	
	        var props = _this.getCheckboxPropsByItem(record, index);
	
	        var handleChange = function handleChange(e) {
	          return type === 'radio' ? _this.handleRadioSelect(record, index, e) : _this.handleSelect(record, index, e);
	        };
	
	        return (/*#__PURE__*/React.createElement("span", {
	            onClick: stopPropagation
	          }, /*#__PURE__*/React.createElement(_SelectionBox["default"], _extends({
	            type: type,
	            store: _this.props.store,
	            rowIndex: rowKey,
	            onChange: handleChange,
	            defaultSelection: _this.getDefaultSelection()
	          }, props)))
	        );
	      };
	    };
	
	    _this.renderTable = function (_ref2) {
	      var _classNames2;
	
	      var prefixCls = _ref2.prefixCls,
	          renderEmpty = _ref2.renderEmpty,
	          dropdownPrefixCls = _ref2.dropdownPrefixCls,
	          contextLocale = _ref2.contextLocale,
	          contextGetPopupContainer = _ref2.getPopupContainer;
	
	      var _a = _this.props,
	          showHeader = _a.showHeader,
	          locale = _a.locale,
	          getPopupContainer = _a.getPopupContainer,
	          restTableProps = __rest(_a, ["showHeader", "locale", "getPopupContainer"]); // do not pass prop.style to rc-table, since already apply it to container div
	
	
	      var restProps = (0, _omit["default"])(restTableProps, ['style']);
	
	      var data = _this.getCurrentPageData();
	
	      var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false; // use props.getPopupContainer first
	
	      var realGetPopupContainer = getPopupContainer || contextGetPopupContainer; // Merge too locales
	
	      var mergedLocale = _extends(_extends({}, contextLocale), locale);
	
	      if (!locale || !locale.emptyText) {
	        mergedLocale.emptyText = renderEmpty('Table');
	      }
	
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-").concat(_this.props.size), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-bordered"), _this.props.bordered), _defineProperty(_classNames2, "".concat(prefixCls, "-empty"), !data.length), _defineProperty(_classNames2, "".concat(prefixCls, "-without-column-header"), !showHeader), _classNames2));
	
	      var columnsWithRowSelection = _this.renderRowSelection({
	        prefixCls: prefixCls,
	        locale: mergedLocale,
	        getPopupContainer: realGetPopupContainer
	      });
	
	      var columns = _this.renderColumnsDropdown({
	        columns: columnsWithRowSelection,
	        prefixCls: prefixCls,
	        dropdownPrefixCls: dropdownPrefixCls,
	        locale: mergedLocale,
	        getPopupContainer: realGetPopupContainer
	      }).map(function (column, i) {
	        var newColumn = _extends({}, column);
	
	        newColumn.key = getColumnKey(newColumn, i);
	        return newColumn;
	      });
	
	      var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;
	
	      if ('expandIconColumnIndex' in restProps) {
	        expandIconColumnIndex = restProps.expandIconColumnIndex;
	      }
	
	      return (/*#__PURE__*/React.createElement(_rcTable["default"], _extends({
	          ref: _this.setTableRef,
	          key: "table",
	          expandIcon: _this.renderExpandIcon(prefixCls)
	        }, restProps, {
	          onRow: function onRow(record, index) {
	            return _this.onRow(prefixCls, record, index);
	          },
	          components: _this.state.components,
	          prefixCls: prefixCls,
	          data: data,
	          columns: columns,
	          showHeader: showHeader,
	          className: classString,
	          expandIconColumnIndex: expandIconColumnIndex,
	          expandIconAsCell: expandIconAsCell,
	          emptyText: mergedLocale.emptyText
	        }))
	      );
	    };
	
	    _this.renderComponent = function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls,
	          renderEmpty = _ref3.renderEmpty,
	          getPopupContainer = _ref3.getPopupContainer;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          customizeDropdownPrefixCls = _this$props.dropdownPrefixCls,
	          style = _this$props.style,
	          className = _this$props.className;
	
	      var data = _this.getCurrentPageData();
	
	      var loading = _this.props.loading;
	
	      if (typeof loading === 'boolean') {
	        loading = {
	          spinning: loading
	        };
	      }
	
	      var prefixCls = getPrefixCls('table', customizePrefixCls);
	      var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
	      var table = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Table",
	        defaultLocale: _default2["default"].Table
	      }, function (locale) {
	        return _this.renderTable({
	          prefixCls: prefixCls,
	          renderEmpty: renderEmpty,
	          dropdownPrefixCls: dropdownPrefixCls,
	          contextLocale: locale,
	          getPopupContainer: getPopupContainer
	        });
	      }); // if there is no pagination or no data,
	      // the height of spin should decrease by half of pagination
	
	      var paginationPatchClass = _this.hasPagination() && data && data.length !== 0 ? "".concat(prefixCls, "-with-pagination") : "".concat(prefixCls, "-without-pagination");
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), className),
	          style: style
	        }, /*#__PURE__*/React.createElement(_spin["default"], _extends({}, loading, {
	          className: loading.spinning ? "".concat(paginationPatchClass, " ").concat(prefixCls, "-spin-holder") : ''
	        }), _this.renderPagination(prefixCls, 'top'), table, _this.renderPagination(prefixCls, 'bottom')))
	      );
	    };
	
	    var expandedRowRender = props.expandedRowRender,
	        columnsProp = props.columns;
	    (0, _warning["default"])(!('columnsPageRange' in props || 'columnsPageSize' in props), 'Table', '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');
	
	    if (expandedRowRender && (columnsProp || []).some(function (_ref4) {
	      var fixed = _ref4.fixed;
	      return !!fixed;
	    })) {
	      (0, _warning["default"])(false, 'Table', '`expandedRowRender` and `Column.fixed` are not compatible. Please use one of them at one time.');
	    }
	
	    var columns = columnsProp || (0, _util.normalizeColumns)(props.children);
	    _this.state = _extends(_extends({}, _this.getDefaultSortOrder(columns || [])), {
	      // 减少状态
	      filters: _this.getDefaultFilters(columns),
	      pagination: _this.getDefaultPagination(props),
	      pivot: undefined,
	      prevProps: props,
	      components: createComponents(props.components),
	      columns: columns
	    });
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this$state = this.state,
	          columns = _this$state.columns,
	          sortColumn = _this$state.sortColumn,
	          sortOrder = _this$state.sortOrder;
	
	      if (this.getSortOrderColumns(columns).length > 0) {
	        var sortState = this.getSortStateFromColumns(columns);
	
	        if (!isSameColumn(sortState.sortColumn, sortColumn) || sortState.sortOrder !== sortOrder) {
	          this.setState(sortState);
	        }
	      }
	    }
	  }, {
	    key: "getDefaultSelection",
	    value: function getDefaultSelection() {
	      var _this2 = this;
	
	      var rowSelection = getRowSelection(this.props);
	
	      if (!rowSelection.getCheckboxProps) {
	        return [];
	      }
	
	      return this.getFlatData().filter(function (item, rowIndex) {
	        return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
	      }).map(function (record, rowIndex) {
	        return _this2.getRecordKey(record, rowIndex);
	      });
	    }
	  }, {
	    key: "getDefaultPagination",
	    value: function getDefaultPagination(props) {
	      var pagination = _typeof(props.pagination) === 'object' ? props.pagination : {};
	      var current;
	
	      if ('current' in pagination) {
	        current = pagination.current;
	      } else if ('defaultCurrent' in pagination) {
	        current = pagination.defaultCurrent;
	      }
	
	      var pageSize;
	
	      if ('pageSize' in pagination) {
	        pageSize = pagination.pageSize;
	      } else if ('defaultPageSize' in pagination) {
	        pageSize = pagination.defaultPageSize;
	      }
	
	      return this.hasPagination(props) ? _extends(_extends(_extends({}, defaultPagination), pagination), {
	        current: current || 1,
	        pageSize: pageSize || 10
	      }) : {};
	    }
	  }, {
	    key: "getSortOrderColumns",
	    value: function getSortOrderColumns(columns) {
	      return (0, _util.flatFilter)(columns || (this.state || {}).columns || [], function (column) {
	        return 'sortOrder' in column;
	      });
	    }
	  }, {
	    key: "getDefaultFilters",
	    value: function getDefaultFilters(columns) {
	      var definedFilters = getFiltersFromColumns(this.state, columns);
	      var defaultFilteredValueColumns = (0, _util.flatFilter)(columns || [], function (column) {
	        return typeof column.defaultFilteredValue !== 'undefined';
	      });
	      var defaultFilters = defaultFilteredValueColumns.reduce(function (soFar, col) {
	        var colKey = getColumnKey(col);
	        soFar[colKey] = col.defaultFilteredValue;
	        return soFar;
	      }, {});
	      return _extends(_extends({}, defaultFilters), definedFilters);
	    }
	  }, {
	    key: "getDefaultSortOrder",
	    value: function getDefaultSortOrder(columns) {
	      var definedSortState = this.getSortStateFromColumns(columns);
	      var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
	        return column.defaultSortOrder != null;
	      })[0];
	
	      if (defaultSortedColumn && !definedSortState.sortColumn) {
	        return {
	          sortColumn: defaultSortedColumn,
	          sortOrder: defaultSortedColumn.defaultSortOrder
	        };
	      }
	
	      return definedSortState;
	    }
	  }, {
	    key: "getSortStateFromColumns",
	    value: function getSortStateFromColumns(columns) {
	      // return first column which sortOrder is not falsy
	      var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
	        return col.sortOrder;
	      })[0];
	
	      if (sortedColumn) {
	        return {
	          sortColumn: sortedColumn,
	          sortOrder: sortedColumn.sortOrder
	        };
	      }
	
	      return {
	        sortColumn: null,
	        sortOrder: null
	      };
	    }
	  }, {
	    key: "getMaxCurrent",
	    value: function getMaxCurrent(total) {
	      var _this$state$paginatio = this.state.pagination,
	          current = _this$state$paginatio.current,
	          pageSize = _this$state$paginatio.pageSize;
	
	      if ((current - 1) * pageSize >= total) {
	        return Math.floor((total - 1) / pageSize) + 1;
	      }
	
	      return current;
	    }
	  }, {
	    key: "getSorterFn",
	    value: function getSorterFn(state) {
	      var _ref5 = state || this.state,
	          sortOrder = _ref5.sortOrder,
	          sortColumn = _ref5.sortColumn;
	
	      if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
	        return;
	      }
	
	      return function (a, b) {
	        var result = sortColumn.sorter(a, b, sortOrder);
	
	        if (result !== 0) {
	          return sortOrder === 'descend' ? -result : result;
	        }
	
	        return 0;
	      };
	    }
	  }, {
	    key: "getCurrentPageData",
	    value: function getCurrentPageData() {
	      var data = this.getLocalData();
	      var current;
	      var pageSize;
	      var state = this.state; // 如果没有分页的话，默认全部展示
	
	      if (!this.hasPagination()) {
	        pageSize = Number.MAX_VALUE;
	        current = 1;
	      } else {
	        pageSize = state.pagination.pageSize;
	        current = this.getMaxCurrent(state.pagination.total || data.length);
	      } // 分页
	      // ---
	      // 当数据量少于等于每页数量时，直接设置数据
	      // 否则进行读取分页数据
	
	
	      if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
	        data = data.slice((current - 1) * pageSize, current * pageSize);
	      }
	
	      return data;
	    }
	  }, {
	    key: "getFlatData",
	    value: function getFlatData() {
	      var childrenColumnName = this.props.childrenColumnName;
	      return (0, _util.flatArray)(this.getLocalData(null, false), childrenColumnName);
	    }
	  }, {
	    key: "getFlatCurrentPageData",
	    value: function getFlatCurrentPageData() {
	      var childrenColumnName = this.props.childrenColumnName;
	      return (0, _util.flatArray)(this.getCurrentPageData(), childrenColumnName);
	    }
	  }, {
	    key: "getLocalData",
	    value: function getLocalData(state) {
	      var _this3 = this;
	
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var currentState = state || this.state;
	      var dataSource = this.props.dataSource;
	      var data = dataSource || []; // 优化本地排序
	
	      data = data.slice(0);
	      var sorterFn = this.getSorterFn(currentState);
	
	      if (sorterFn) {
	        data = this.recursiveSort(data, sorterFn);
	      } // 筛选
	
	
	      if (filter && currentState.filters) {
	        Object.keys(currentState.filters).forEach(function (columnKey) {
	          var col = _this3.findColumn(columnKey);
	
	          if (!col) {
	            return;
	          }
	
	          var values = currentState.filters[columnKey] || [];
	
	          if (values.length === 0) {
	            return;
	          }
	
	          var onFilter = col.onFilter;
	          data = onFilter ? data.filter(function (record) {
	            return values.some(function (v) {
	              return onFilter(v, record);
	            });
	          }) : data;
	        });
	      }
	
	      return data;
	    }
	  }, {
	    key: "setSelectedRowKeys",
	    value: function setSelectedRowKeys(selectedRowKeys, selectionInfo) {
	      var _this4 = this;
	
	      var selectWay = selectionInfo.selectWay,
	          record = selectionInfo.record,
	          checked = selectionInfo.checked,
	          changeRowKeys = selectionInfo.changeRowKeys,
	          nativeEvent = selectionInfo.nativeEvent;
	      var rowSelection = getRowSelection(this.props);
	
	      if (rowSelection && !('selectedRowKeys' in rowSelection)) {
	        this.props.store.setState({
	          selectedRowKeys: selectedRowKeys
	        });
	      }
	
	      var data = this.getFlatData();
	
	      if (!rowSelection.onChange && !rowSelection[selectWay]) {
	        return;
	      }
	
	      var selectedRows = data.filter(function (row, i) {
	        return selectedRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	      });
	
	      if (rowSelection.onChange) {
	        rowSelection.onChange(selectedRowKeys, selectedRows);
	      }
	
	      if (selectWay === 'onSelect' && rowSelection.onSelect) {
	        rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
	      } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
	        var changeRows = data.filter(function (row, i) {
	          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	        });
	        rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
	      } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
	        var _changeRows = data.filter(function (row, i) {
	          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	        });
	
	        rowSelection.onSelectAll(checked, selectedRows, _changeRows);
	      } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
	        rowSelection.onSelectInvert(selectedRowKeys);
	      }
	    }
	  }, {
	    key: "toggleSortOrder",
	    value: function toggleSortOrder(column) {
	      var sortDirections = column.sortDirections || this.props.sortDirections;
	      var _this$state2 = this.state,
	          sortOrder = _this$state2.sortOrder,
	          sortColumn = _this$state2.sortColumn; // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题
	
	      var newSortOrder; // 切换另一列时，丢弃 sortOrder 的状态
	
	      if (isSameColumn(sortColumn, column) && sortOrder !== undefined) {
	        // 按照sortDirections的内容依次切换排序状态
	        var methodIndex = sortDirections.indexOf(sortOrder) + 1;
	        newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
	      } else {
	        newSortOrder = sortDirections[0];
	      }
	
	      var newState = {
	        sortOrder: newSortOrder,
	        sortColumn: newSortOrder ? column : null
	      }; // Controlled
	
	      if (this.getSortOrderColumns().length === 0) {
	        this.setState(newState, this.scrollToFirstRow);
	      }
	
	      var onChange = this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, this.prepareParamsArguments(_extends(_extends({}, this.state), newState), column));
	      }
	    }
	  }, {
	    key: "hasPagination",
	    value: function hasPagination(props) {
	      return (props || this.props).pagination !== false;
	    }
	  }, {
	    key: "isSortColumn",
	    value: function isSortColumn(column) {
	      var sortColumn = this.state.sortColumn;
	
	      if (!column || !sortColumn) {
	        return false;
	      }
	
	      return getColumnKey(sortColumn) === getColumnKey(column);
	    } // Get pagination, filters, sorter
	
	  }, {
	    key: "prepareParamsArguments",
	    value: function prepareParamsArguments(state, column) {
	      var pagination = _extends({}, state.pagination); // remove useless handle function in Table.onChange
	
	
	      delete pagination.onChange;
	      delete pagination.onShowSizeChange;
	      var filters = state.filters;
	      var sorter = {};
	      var currentColumn = column;
	
	      if (state.sortColumn && state.sortOrder) {
	        currentColumn = state.sortColumn;
	        sorter.column = state.sortColumn;
	        sorter.order = state.sortOrder;
	      }
	
	      if (currentColumn) {
	        sorter.field = currentColumn.dataIndex;
	        sorter.columnKey = getColumnKey(currentColumn);
	      }
	
	      var extra = {
	        currentDataSource: this.getLocalData(state)
	      };
	      return [pagination, filters, sorter, extra];
	    }
	  }, {
	    key: "findColumn",
	    value: function findColumn(myKey) {
	      var column;
	      (0, _util.treeMap)(this.state.columns, function (c) {
	        if (getColumnKey(c) === myKey) {
	          column = c;
	        }
	      });
	      return column;
	    }
	  }, {
	    key: "recursiveSort",
	    value: function recursiveSort(data, sorterFn) {
	      var _this5 = this;
	
	      var _this$props$childrenC = this.props.childrenColumnName,
	          childrenColumnName = _this$props$childrenC === void 0 ? 'children' : _this$props$childrenC;
	      return data.sort(sorterFn).map(function (item) {
	        return item[childrenColumnName] ? _extends(_extends({}, item), _defineProperty({}, childrenColumnName, _this5.recursiveSort(item[childrenColumnName], sorterFn))) : item;
	      });
	    }
	  }, {
	    key: "renderPagination",
	    value: function renderPagination(prefixCls, paginationPosition) {
	      // 强制不需要分页
	      if (!this.hasPagination()) {
	        return null;
	      }
	
	      var size = 'default';
	      var pagination = this.state.pagination;
	
	      if (pagination.size) {
	        size = pagination.size;
	      } else if (this.props.size === 'middle' || this.props.size === 'small') {
	        size = 'small';
	      }
	
	      var position = pagination.position || 'bottom';
	      var total = pagination.total || this.getLocalData().length;
	      return total > 0 && (position === paginationPosition || position === 'both') ? /*#__PURE__*/React.createElement(_pagination["default"], _extends({
	        key: "pagination-".concat(paginationPosition)
	      }, pagination, {
	        className: (0, _classnames["default"])(pagination.className, "".concat(prefixCls, "-pagination")),
	        onChange: this.handlePageChange,
	        total: total,
	        size: size,
	        current: this.getMaxCurrent(total),
	        onShowSizeChange: this.handleShowSizeChange
	      })) : null;
	    }
	  }, {
	    key: "renderRowSelection",
	    value: function renderRowSelection(_ref6) {
	      var _this6 = this;
	
	      var prefixCls = _ref6.prefixCls,
	          locale = _ref6.locale,
	          getPopupContainer = _ref6.getPopupContainer;
	      var rowSelection = this.props.rowSelection;
	      var columns = this.state.columns.concat();
	
	      if (rowSelection) {
	        var data = this.getFlatCurrentPageData().filter(function (item, index) {
	          if (rowSelection.getCheckboxProps) {
	            return !_this6.getCheckboxPropsByItem(item, index).disabled;
	          }
	
	          return true;
	        });
	        var selectionColumnClass = (0, _classnames["default"])("".concat(prefixCls, "-selection-column"), _defineProperty({}, "".concat(prefixCls, "-selection-column-custom"), rowSelection.selections));
	
	        var selectionColumn = _defineProperty({
	          key: 'selection-column',
	          render: this.renderSelectionBox(rowSelection.type),
	          className: selectionColumnClass,
	          fixed: rowSelection.fixed,
	          width: rowSelection.columnWidth,
	          title: rowSelection.columnTitle
	        }, _rcTable.INTERNAL_COL_DEFINE, {
	          className: "".concat(prefixCls, "-selection-col")
	        });
	
	        if (rowSelection.type !== 'radio') {
	          var checkboxAllDisabled = data.every(function (item, index) {
	            return _this6.getCheckboxPropsByItem(item, index).disabled;
	          });
	          selectionColumn.title = selectionColumn.title || /*#__PURE__*/React.createElement(_SelectionCheckboxAll["default"], {
	            store: this.props.store,
	            locale: locale,
	            data: data,
	            getCheckboxPropsByItem: this.getCheckboxPropsByItem,
	            getRecordKey: this.getRecordKey,
	            disabled: checkboxAllDisabled,
	            prefixCls: prefixCls,
	            onSelect: this.handleSelectRow,
	            selections: rowSelection.selections,
	            hideDefaultSelections: rowSelection.hideDefaultSelections,
	            getPopupContainer: this.generatePopupContainerFunc(getPopupContainer)
	          });
	        }
	
	        if ('fixed' in rowSelection) {
	          selectionColumn.fixed = rowSelection.fixed;
	        } else if (columns.some(function (column) {
	          return column.fixed === 'left' || column.fixed === true;
	        })) {
	          selectionColumn.fixed = 'left';
	        }
	
	        if (columns[0] && columns[0].key === 'selection-column') {
	          columns[0] = selectionColumn;
	        } else {
	          columns.unshift(selectionColumn);
	        }
	      }
	
	      return columns;
	    }
	  }, {
	    key: "renderColumnsDropdown",
	    value: function renderColumnsDropdown(_ref7) {
	      var _this7 = this;
	
	      var prefixCls = _ref7.prefixCls,
	          dropdownPrefixCls = _ref7.dropdownPrefixCls,
	          columns = _ref7.columns,
	          locale = _ref7.locale,
	          getPopupContainer = _ref7.getPopupContainer;
	      var _this$state3 = this.state,
	          sortOrder = _this$state3.sortOrder,
	          filters = _this$state3.filters;
	      return (0, _util.treeMap)(columns, function (column, i) {
	        var _classNames4;
	
	        var key = getColumnKey(column, i);
	        var filterDropdown;
	        var sortButton;
	        var onHeaderCell = column.onHeaderCell;
	
	        var isSortColumn = _this7.isSortColumn(column);
	
	        if (column.filters && column.filters.length > 0 || column.filterDropdown) {
	          var colFilters = key in filters ? filters[key] : [];
	          filterDropdown = /*#__PURE__*/React.createElement(_filterDropdown["default"], {
	            locale: locale,
	            column: column,
	            selectedKeys: colFilters,
	            confirmFilter: _this7.handleFilter,
	            prefixCls: "".concat(prefixCls, "-filter"),
	            dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown',
	            getPopupContainer: _this7.generatePopupContainerFunc(getPopupContainer),
	            key: "filter-dropdown"
	          });
	        }
	
	        if (column.sorter) {
	          var sortDirections = column.sortDirections || _this7.props.sortDirections;
	          var isAscend = isSortColumn && sortOrder === 'ascend';
	          var isDescend = isSortColumn && sortOrder === 'descend';
	          var ascend = sortDirections.indexOf('ascend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
	            className: "".concat(prefixCls, "-column-sorter-up ").concat(isAscend ? 'on' : 'off'),
	            type: "caret-up",
	            theme: "filled"
	          });
	          var descend = sortDirections.indexOf('descend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
	            className: "".concat(prefixCls, "-column-sorter-down ").concat(isDescend ? 'on' : 'off'),
	            type: "caret-down",
	            theme: "filled"
	          });
	          sortButton = /*#__PURE__*/React.createElement("div", {
	            title: locale.sortTitle,
	            className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter-inner"), ascend && descend && "".concat(prefixCls, "-column-sorter-inner-full")),
	            key: "sorter"
	          }, ascend, descend);
	
	          onHeaderCell = function onHeaderCell(col) {
	            var colProps = {}; // Get original first
	
	            if (column.onHeaderCell) {
	              colProps = _extends({}, column.onHeaderCell(col));
	            } // Add sorter logic
	
	
	            var onHeaderCellClick = colProps.onClick;
	
	            colProps.onClick = function () {
	              _this7.toggleSortOrder(column);
	
	              if (onHeaderCellClick) {
	                onHeaderCellClick.apply(void 0, arguments);
	              }
	            };
	
	            return colProps;
	          };
	        }
	
	        return _extends(_extends({}, column), {
	          className: (0, _classnames["default"])(column.className, (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-actions"), sortButton || filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-filters"), filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-sorters"), sortButton), _defineProperty(_classNames4, "".concat(prefixCls, "-column-sort"), isSortColumn && sortOrder), _classNames4)),
	          title: [/*#__PURE__*/React.createElement("span", {
	            key: "title",
	            className: "".concat(prefixCls, "-header-column")
	          }, /*#__PURE__*/React.createElement("div", {
	            className: sortButton ? "".concat(prefixCls, "-column-sorters") : undefined
	          }, /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-column-title")
	          }, _this7.renderColumnTitle(column.title)), /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-column-sorter")
	          }, sortButton))), filterDropdown],
	          onHeaderCell: onHeaderCell
	        });
	      });
	    }
	  }, {
	    key: "renderColumnTitle",
	    value: function renderColumnTitle(title) {
	      var _this$state4 = this.state,
	          filters = _this$state4.filters,
	          sortOrder = _this$state4.sortOrder,
	          sortColumn = _this$state4.sortColumn; // https://github.com/ant-design/ant-design/issues/11246#issuecomment-405009167
	
	      if (title instanceof Function) {
	        return title({
	          filters: filters,
	          sortOrder: sortOrder,
	          sortColumn: sortColumn
	        });
	      }
	
	      return title;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);
	
	      var nextState = _extends(_extends({}, prevState), {
	        prevProps: nextProps,
	        columns: columns
	      });
	
	      if ('pagination' in nextProps || 'pagination' in prevProps) {
	        var newPagination = _extends(_extends(_extends({}, defaultPagination), prevState.pagination), nextProps.pagination);
	
	        newPagination.current = newPagination.current || 1;
	        newPagination.pageSize = newPagination.pageSize || 10;
	        nextState = _extends(_extends({}, nextState), {
	          pagination: nextProps.pagination !== false ? newPagination : emptyObject
	        });
	      }
	
	      if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
	        nextProps.store.setState({
	          selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
	        });
	      } else if (prevProps.rowSelection && !nextProps.rowSelection) {
	        nextProps.store.setState({
	          selectedRowKeys: []
	        });
	      }
	
	      if ('dataSource' in nextProps && nextProps.dataSource !== prevProps.dataSource) {
	        nextProps.store.setState({
	          selectionDirty: false
	        });
	      } // https://github.com/ant-design/ant-design/issues/10133
	
	
	      nextProps.setCheckboxPropsCache({}); // Update filters
	
	      var filteredValueColumns = getFilteredValueColumns(nextState, nextState.columns);
	
	      if (filteredValueColumns.length > 0) {
	        var filtersFromColumns = getFiltersFromColumns(nextState, nextState.columns);
	
	        var newFilters = _extends({}, nextState.filters);
	
	        Object.keys(filtersFromColumns).forEach(function (key) {
	          newFilters[key] = filtersFromColumns[key];
	        });
	
	        if (isFiltersChanged(nextState, newFilters)) {
	          nextState = _extends(_extends({}, nextState), {
	            filters: newFilters
	          });
	        }
	      }
	
	      if (!isTheSameComponents(nextProps.components, prevProps.components)) {
	        var components = createComponents(nextProps.components);
	        nextState = _extends(_extends({}, nextState), {
	          components: components
	        });
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return Table;
	}(React.Component);
	
	Table.propTypes = {
	  dataSource: PropTypes.array,
	  columns: PropTypes.array,
	  prefixCls: PropTypes.string,
	  useFixedHeader: PropTypes.bool,
	  rowSelection: PropTypes.object,
	  className: PropTypes.string,
	  size: PropTypes.string,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  bordered: PropTypes.bool,
	  onChange: PropTypes.func,
	  locale: PropTypes.object,
	  dropdownPrefixCls: PropTypes.string,
	  sortDirections: PropTypes.array,
	  getPopupContainer: PropTypes.func
	};
	Table.defaultProps = {
	  dataSource: [],
	  useFixedHeader: false,
	  className: '',
	  size: 'default',
	  loading: false,
	  bordered: false,
	  indentSize: 20,
	  locale: {},
	  rowKey: 'key',
	  showHeader: true,
	  sortDirections: ['ascend', 'descend'],
	  childrenColumnName: 'children'
	};
	(0, _reactLifecyclesCompat.polyfill)(Table);
	
	var StoreTable = /*#__PURE__*/function (_React$Component2) {
	  _inherits(StoreTable, _React$Component2);
	
	  var _super2 = _createSuper(StoreTable);
	
	  function StoreTable(props) {
	    var _this8;
	
	    _classCallCheck(this, StoreTable);
	
	    _this8 = _super2.call(this, props);
	
	    _this8.setCheckboxPropsCache = function (cache) {
	      return _this8.CheckboxPropsCache = cache;
	    };
	
	    _this8.CheckboxPropsCache = {};
	    _this8.store = (0, _createStore["default"])({
	      selectedRowKeys: getRowSelection(props).selectedRowKeys || [],
	      selectionDirty: false
	    });
	    return _this8;
	  }
	
	  _createClass(StoreTable, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
	          store: this.store,
	          checkboxPropsCache: this.CheckboxPropsCache,
	          setCheckboxPropsCache: this.setCheckboxPropsCache
	        }))
	      );
	    }
	  }]);
	
	  return StoreTable;
	}(React.Component);
	
	StoreTable.displayName = 'withStore(Table)';
	StoreTable.Column = _Column["default"];
	StoreTable.ColumnGroup = _ColumnGroup["default"];
	var _default = StoreTable;
	exports["default"] = _default;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createBodyRow;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function createBodyRow() {
	  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';
	
	  var BodyRow = /*#__PURE__*/function (_React$Component) {
	    _inherits(BodyRow, _React$Component);
	
	    var _super = _createSuper(BodyRow);
	
	    function BodyRow(props) {
	      var _this;
	
	      _classCallCheck(this, BodyRow);
	
	      _this = _super.call(this, props);
	      _this.store = props.store;
	
	      var _this$store$getState = _this.store.getState(),
	          selectedRowKeys = _this$store$getState.selectedRowKeys;
	
	      _this.state = {
	        selected: selectedRowKeys.indexOf(props.rowKey) >= 0
	      };
	      return _this;
	    }
	
	    _createClass(BodyRow, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.subscribe();
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	        }
	      }
	    }, {
	      key: "subscribe",
	      value: function subscribe() {
	        var _this2 = this;
	
	        var _this$props = this.props,
	            store = _this$props.store,
	            rowKey = _this$props.rowKey;
	        this.unsubscribe = store.subscribe(function () {
	          var _this2$store$getState = _this2.store.getState(),
	              selectedRowKeys = _this2$store$getState.selectedRowKeys;
	
	          var selected = selectedRowKeys.indexOf(rowKey) >= 0;
	
	          if (selected !== _this2.state.selected) {
	            _this2.setState({
	              selected: selected
	            });
	          }
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var rowProps = (0, _omit["default"])(this.props, ['prefixCls', 'rowKey', 'store']);
	        var className = (0, _classnames2["default"])(this.props.className, _defineProperty({}, "".concat(this.props.prefixCls, "-row-selected"), this.state.selected));
	        return (/*#__PURE__*/React.createElement(Component, _extends(_extends({}, rowProps), {
	            className: className
	          }), this.props.children)
	        );
	      }
	    }]);
	
	    return BodyRow;
	  }(React.Component);
	
	  return BodyRow;
	}

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createStore;
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function createStore(initialState) {
	  var state = initialState;
	  var listeners = [];
	
	  function setState(partial) {
	    state = _extends(_extends({}, state), partial);
	
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	  }
	
	  function getState() {
	    return state;
	  }
	
	  function subscribe(listener) {
	    listeners.push(listener);
	    return function unsubscribe() {
	      var index = listeners.indexOf(listener);
	      listeners.splice(index, 1);
	    };
	  }
	
	  return {
	    setState: setState,
	    getState: getState,
	    subscribe: subscribe
	  };
	}

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(84));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(93));
	
	var _domClosest = _interopRequireDefault(__webpack_require__(509));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(59));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(379));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(163));
	
	var _radio = _interopRequireDefault(__webpack_require__(258));
	
	var _FilterDropdownMenuWrapper = _interopRequireDefault(__webpack_require__(1448));
	
	var _util = __webpack_require__(759);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	function stopPropagation(e) {
	  e.stopPropagation();
	
	  if (e.nativeEvent.stopImmediatePropagation) {
	    e.nativeEvent.stopImmediatePropagation();
	  }
	}
	
	var FilterMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(FilterMenu, _React$Component);
	
	  var _super = _createSuper(FilterMenu);
	
	  function FilterMenu(props) {
	    var _this;
	
	    _classCallCheck(this, FilterMenu);
	
	    _this = _super.call(this, props);
	
	    _this.setNeverShown = function (column) {
	      var rootNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var filterBelongToScrollBody = !!(0, _domClosest["default"])(rootNode, ".ant-table-scroll");
	
	      if (filterBelongToScrollBody) {
	        // When fixed column have filters, there will be two dropdown menus
	        // Filter dropdown menu inside scroll body should never be shown
	        // To fix https://github.com/ant-design/ant-design/issues/5010 and
	        // https://github.com/ant-design/ant-design/issues/7909
	        _this.neverShown = !!column.fixed;
	      }
	    };
	
	    _this.setSelectedKeys = function (_ref) {
	      var selectedKeys = _ref.selectedKeys;
	
	      _this.setState({
	        selectedKeys: selectedKeys
	      });
	    };
	
	    _this.handleClearFilters = function () {
	      _this.setState({
	        selectedKeys: []
	      }, _this.handleConfirm);
	    };
	
	    _this.handleConfirm = function () {
	      _this.setVisible(false); // Call `setSelectedKeys` & `confirm` in the same time will make filter data not up to date
	      // https://github.com/ant-design/ant-design/issues/12284
	
	
	      _this.setState({}, _this.confirmFilter);
	    };
	
	    _this.onVisibleChange = function (visible) {
	      _this.setVisible(visible);
	
	      var column = _this.props.column; // https://github.com/ant-design/ant-design/issues/17833
	
	      if (!visible && !(column.filterDropdown instanceof Function)) {
	        _this.confirmFilter();
	      }
	    };
	
	    _this.handleMenuItemClick = function (info) {
	      var selectedKeys = _this.state.selectedKeys;
	
	      if (!info.keyPath || info.keyPath.length <= 1) {
	        return;
	      }
	
	      var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;
	
	      if (selectedKeys && selectedKeys.indexOf(info.key) >= 0) {
	        // deselect SubMenu child
	        delete keyPathOfSelectedItem[info.key];
	      } else {
	        // select SubMenu child
	        keyPathOfSelectedItem[info.key] = info.keyPath;
	      }
	
	      _this.setState({
	        keyPathOfSelectedItem: keyPathOfSelectedItem
	      });
	    };
	
	    _this.renderFilterIcon = function () {
	      var _classNames;
	
	      var _this$props = _this.props,
	          column = _this$props.column,
	          locale = _this$props.locale,
	          prefixCls = _this$props.prefixCls,
	          selectedKeys = _this$props.selectedKeys;
	      var filtered = selectedKeys && selectedKeys.length > 0;
	      var filterIcon = column.filterIcon;
	
	      if (typeof filterIcon === 'function') {
	        filterIcon = filterIcon(filtered);
	      }
	
	      var dropdownIconClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-selected"), 'filtered' in column ? column.filtered : filtered), _defineProperty(_classNames, "".concat(prefixCls, "-open"), _this.getDropdownVisible()), _classNames));
	
	      if (!filterIcon) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            title: locale.filterTitle,
	            type: "filter",
	            theme: "filled",
	            className: dropdownIconClass,
	            onClick: stopPropagation
	          })
	        );
	      }
	
	      if ( /*#__PURE__*/React.isValidElement(filterIcon)) {
	        return (/*#__PURE__*/React.cloneElement(filterIcon, {
	            title: filterIcon.props.title || locale.filterTitle,
	            className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass, filterIcon.props.className),
	            onClick: stopPropagation
	          })
	        );
	      }
	
	      return (/*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass)
	        }, filterIcon)
	      );
	    };
	
	    var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
	    _this.state = {
	      selectedKeys: props.selectedKeys,
	      valueKeys: (0, _util.generateValueMaps)(props.column.filters),
	      keyPathOfSelectedItem: {},
	      visible: visible,
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(FilterMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var column = this.props.column;
	      this.setNeverShown(column);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var column = this.props.column;
	      this.setNeverShown(column);
	    }
	  }, {
	    key: "getDropdownVisible",
	    value: function getDropdownVisible() {
	      return this.neverShown ? false : this.state.visible;
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible) {
	      var column = this.props.column;
	
	      if (!('filterDropdownVisible' in column)) {
	        this.setState({
	          visible: visible
	        });
	      }
	
	      if (column.onFilterDropdownVisibleChange) {
	        column.onFilterDropdownVisibleChange(visible);
	      }
	    }
	  }, {
	    key: "hasSubMenu",
	    value: function hasSubMenu() {
	      var _this$props$column$fi = this.props.column.filters,
	          filters = _this$props$column$fi === void 0 ? [] : _this$props$column$fi;
	      return filters.some(function (item) {
	        return !!(item.children && item.children.length > 0);
	      });
	    }
	  }, {
	    key: "confirmFilter",
	    value: function confirmFilter() {
	      var _this$props2 = this.props,
	          column = _this$props2.column,
	          propSelectedKeys = _this$props2.selectedKeys,
	          confirmFilter = _this$props2.confirmFilter;
	      var _this$state = this.state,
	          selectedKeys = _this$state.selectedKeys,
	          valueKeys = _this$state.valueKeys;
	      var filterDropdown = column.filterDropdown;
	
	      if (!(0, _shallowequal["default"])(selectedKeys, propSelectedKeys)) {
	        confirmFilter(column, filterDropdown ? selectedKeys : selectedKeys.map(function (key) {
	          return valueKeys[key];
	        }).filter(function (key) {
	          return key !== undefined;
	        }));
	      }
	    }
	  }, {
	    key: "renderMenus",
	    value: function renderMenus(items) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          dropdownPrefixCls = _this$props3.dropdownPrefixCls,
	          prefixCls = _this$props3.prefixCls;
	      return items.map(function (item) {
	        if (item.children && item.children.length > 0) {
	          var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
	          var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
	            return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
	          });
	          var subMenuCls = (0, _classnames["default"])("".concat(prefixCls, "-dropdown-submenu"), _defineProperty({}, "".concat(dropdownPrefixCls, "-submenu-contain-selected"), containSelected));
	          return (/*#__PURE__*/React.createElement(_rcMenu.SubMenu, {
	              title: item.text,
	              popupClassName: subMenuCls,
	              key: item.value.toString()
	            }, _this2.renderMenus(item.children))
	          );
	        }
	
	        return _this2.renderMenuItem(item);
	      });
	    }
	  }, {
	    key: "renderMenuItem",
	    value: function renderMenuItem(item) {
	      var column = this.props.column;
	      var selectedKeys = this.state.selectedKeys;
	      var multiple = 'filterMultiple' in column ? column.filterMultiple : true; // We still need trade key as string since Menu render need string
	
	      var internalSelectedKeys = (selectedKeys || []).map(function (key) {
	        return key.toString();
	      });
	      var input = multiple ? /*#__PURE__*/React.createElement(_checkbox["default"], {
	        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
	      }) : /*#__PURE__*/React.createElement(_radio["default"], {
	        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
	      });
	      return (/*#__PURE__*/React.createElement(_rcMenu.Item, {
	          key: item.value
	        }, input, /*#__PURE__*/React.createElement("span", null, item.text))
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var originSelectedKeys = this.state.selectedKeys;
	      var _this$props4 = this.props,
	          column = _this$props4.column,
	          locale = _this$props4.locale,
	          prefixCls = _this$props4.prefixCls,
	          dropdownPrefixCls = _this$props4.dropdownPrefixCls,
	          getPopupContainer = _this$props4.getPopupContainer; // default multiple selection in filter dropdown
	
	      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
	      var dropdownMenuClass = (0, _classnames["default"])(_defineProperty({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !this.hasSubMenu()));
	      var filterDropdown = column.filterDropdown;
	
	      if (filterDropdown instanceof Function) {
	        filterDropdown = filterDropdown({
	          prefixCls: "".concat(dropdownPrefixCls, "-custom"),
	          setSelectedKeys: function setSelectedKeys(selectedKeys) {
	            return _this3.setSelectedKeys({
	              selectedKeys: selectedKeys
	            });
	          },
	          selectedKeys: originSelectedKeys,
	          confirm: this.handleConfirm,
	          clearFilters: this.handleClearFilters,
	          filters: column.filters,
	          visible: this.getDropdownVisible()
	        });
	      }
	
	      var menus = filterDropdown ? /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
	        className: "".concat(prefixCls, "-dropdown")
	      }, filterDropdown) : /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
	        className: "".concat(prefixCls, "-dropdown")
	      }, /*#__PURE__*/React.createElement(_rcMenu["default"], {
	        multiple: multiple,
	        onClick: this.handleMenuItemClick,
	        prefixCls: "".concat(dropdownPrefixCls, "-menu"),
	        className: dropdownMenuClass,
	        onSelect: this.setSelectedKeys,
	        onDeselect: this.setSelectedKeys,
	        selectedKeys: originSelectedKeys && originSelectedKeys.map(function (val) {
	          return val.toString();
	        }),
	        getPopupContainer: getPopupContainer
	      }, this.renderMenus(column.filters)), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-dropdown-btns")
	      }, /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-dropdown-link confirm"),
	        onClick: this.handleConfirm
	      }, locale.filterConfirm), /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-dropdown-link clear"),
	        onClick: this.handleClearFilters
	      }, locale.filterReset)));
	      return (/*#__PURE__*/React.createElement(_dropdown["default"], {
	          trigger: ['click'],
	          placement: "bottomRight",
	          overlay: menus,
	          visible: this.getDropdownVisible(),
	          onVisibleChange: this.onVisibleChange,
	          getPopupContainer: getPopupContainer,
	          forceRender: true
	        }, this.renderFilterIcon())
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var column = nextProps.column;
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	      /**
	       * if the state is visible the component should ignore updates on selectedKeys prop to avoid
	       * that the user selection is lost
	       * this happens frequently when a table is connected on some sort of realtime data
	       * Fixes https://github.com/ant-design/ant-design/issues/10289 and
	       * https://github.com/ant-design/ant-design/issues/10209
	       */
	
	      if ('selectedKeys' in nextProps && !(0, _shallowequal["default"])(prevProps.selectedKeys, nextProps.selectedKeys)) {
	        newState.selectedKeys = nextProps.selectedKeys;
	      }
	
	      if (!(0, _shallowequal["default"])((prevProps.column || {}).filters, (nextProps.column || {}).filters)) {
	        newState.valueKeys = (0, _util.generateValueMaps)(nextProps.column.filters);
	      }
	
	      if ('filterDropdownVisible' in column) {
	        newState.visible = column.filterDropdownVisible;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return FilterMenu;
	}(React.Component);
	
	FilterMenu.defaultProps = {
	  column: {}
	};
	(0, _reactLifecyclesCompat.polyfill)(FilterMenu);
	var _default = FilterMenu;
	exports["default"] = _default;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Table = _interopRequireDefault(__webpack_require__(1451));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Table["default"];
	exports["default"] = _default;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _ScrollableInkTabBar = _interopRequireDefault(__webpack_require__(480));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var TabBar = /*#__PURE__*/function (_React$Component) {
	  _inherits(TabBar, _React$Component);
	
	  var _super = _createSuper(TabBar);
	
	  function TabBar() {
	    _classCallCheck(this, TabBar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(TabBar, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          tabBarStyle = _this$props.tabBarStyle,
	          animated = _this$props.animated,
	          renderTabBar = _this$props.renderTabBar,
	          tabBarExtraContent = _this$props.tabBarExtraContent,
	          tabPosition = _this$props.tabPosition,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          size = _this$props.size,
	          type = _this$props.type;
	      var inkBarAnimated = _typeof(animated) === 'object' ? animated.inkBar : animated;
	      var isVertical = tabPosition === 'left' || tabPosition === 'right';
	      var prevIconType = isVertical ? 'up' : 'left';
	      var nextIconType = isVertical ? 'down' : 'right';
	      var prevIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-prev-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: prevIconType,
	        className: "".concat(prefixCls, "-tab-prev-icon-target")
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-next-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: nextIconType,
	        className: "".concat(prefixCls, "-tab-next-icon-target")
	      })); // Additional className for style usage
	
	      var cls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-bar"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size, "-bar"), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card-bar"), type && type.indexOf('card') >= 0), _classNames), className);
	
	      var renderProps = _extends(_extends({}, this.props), {
	        children: null,
	        inkBarAnimated: inkBarAnimated,
	        extraContent: tabBarExtraContent,
	        style: tabBarStyle,
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        className: cls
	      });
	
	      var RenderTabBar;
	
	      if (renderTabBar) {
	        RenderTabBar = renderTabBar(renderProps, _ScrollableInkTabBar["default"]);
	      } else {
	        RenderTabBar = /*#__PURE__*/React.createElement(_ScrollableInkTabBar["default"], renderProps);
	      }
	
	      return (/*#__PURE__*/React.cloneElement(RenderTabBar)
	      );
	    }
	  }]);
	
	  return TabBar;
	}(React.Component);
	
	exports["default"] = TabBar;
	TabBar.defaultProps = {
	  animated: true,
	  type: 'line'
	};

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var CheckableTag = /*#__PURE__*/function (_React$Component) {
	  _inherits(CheckableTag, _React$Component);
	
	  var _super = _createSuper(CheckableTag);
	
	  function CheckableTag() {
	    var _this;
	
	    _classCallCheck(this, CheckableTag);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function () {
	      var _this$props = _this.props,
	          checked = _this$props.checked,
	          onChange = _this$props.onChange;
	
	      if (onChange) {
	        onChange(!checked);
	      }
	    };
	
	    _this.renderCheckableTag = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          checked = _a.checked,
	          restProps = __rest(_a, ["prefixCls", "className", "checked"]);
	
	      var prefixCls = getPrefixCls('tag', customizePrefixCls);
	      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checkable"), true), _defineProperty(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
	      delete restProps.onChange; // TypeScript cannot check delete now.
	
	      return (/*#__PURE__*/React.createElement("span", _extends({}, restProps, {
	          className: cls,
	          onClick: _this.handleClick
	        }))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(CheckableTag, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckableTag)
	      );
	    }
	  }]);
	
	  return CheckableTag;
	}(React.Component);
	
	exports["default"] = CheckableTag;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _TimelineItem = _interopRequireDefault(__webpack_require__(1459));
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Timeline = /*#__PURE__*/function (_React$Component) {
	  _inherits(Timeline, _React$Component);
	
	  var _super = _createSuper(Timeline);
	
	  function Timeline() {
	    var _this;
	
	    _classCallCheck(this, Timeline);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderTimeline = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          _a$pending = _a.pending,
	          pending = _a$pending === void 0 ? null : _a$pending,
	          pendingDot = _a.pendingDot,
	          children = _a.children,
	          className = _a.className,
	          reverse = _a.reverse,
	          mode = _a.mode,
	          restProps = __rest(_a, ["prefixCls", "pending", "pendingDot", "children", "className", "reverse", "mode"]);
	
	      var prefixCls = getPrefixCls('timeline', customizePrefixCls);
	      var pendingNode = typeof pending === 'boolean' ? null : pending;
	      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-pending"), !!pending), _defineProperty(_classNames, "".concat(prefixCls, "-reverse"), !!reverse), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(mode), !!mode), _classNames), className);
	      var pendingItem = pending ? /*#__PURE__*/React.createElement(_TimelineItem["default"], {
	        pending: !!pending,
	        dot: pendingDot || /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading"
	        })
	      }, pendingNode) : null;
	      var timeLineItems = reverse ? [pendingItem].concat(_toConsumableArray(React.Children.toArray(children).reverse())) : [].concat(_toConsumableArray(React.Children.toArray(children)), [pendingItem]);
	
	      var getPositionCls = function getPositionCls(ele, idx) {
	        if (mode === 'alternate') {
	          if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
	          if (ele.props.position === 'left') return "".concat(prefixCls, "-item-left");
	          return idx % 2 === 0 ? "".concat(prefixCls, "-item-left") : "".concat(prefixCls, "-item-right");
	        }
	
	        if (mode === 'left') return "".concat(prefixCls, "-item-left");
	        if (mode === 'right') return "".concat(prefixCls, "-item-right");
	        if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
	        return '';
	      }; // Remove falsy items
	
	
	      var truthyItems = timeLineItems.filter(function (item) {
	        return !!item;
	      });
	      var itemsCount = React.Children.count(truthyItems);
	      var lastCls = "".concat(prefixCls, "-item-last");
	      var items = React.Children.map(truthyItems, function (ele, idx) {
	        var pendingClass = idx === itemsCount - 2 ? lastCls : '';
	        var readyClass = idx === itemsCount - 1 ? lastCls : '';
	        return (/*#__PURE__*/React.cloneElement(ele, {
	            className: (0, _classnames["default"])([ele.props.className, !reverse && !!pending ? pendingClass : readyClass, getPositionCls(ele, idx)])
	          })
	        );
	      });
	      return (/*#__PURE__*/React.createElement("ul", _extends({}, restProps, {
	          className: classString
	        }), items)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Timeline, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTimeline)
	      );
	    }
	  }]);
	
	  return Timeline;
	}(React.Component);
	
	exports["default"] = Timeline;
	Timeline.Item = _TimelineItem["default"];
	Timeline.defaultProps = {
	  reverse: false,
	  mode: ''
	};

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TimelineItem = function TimelineItem(props) {
	  return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	      var _classNames, _classNames2;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          _props$color = props.color,
	          color = _props$color === void 0 ? '' : _props$color,
	          children = props.children,
	          pending = props.pending,
	          dot = props.dot,
	          restProps = __rest(props, ["prefixCls", "className", "color", "children", "pending", "dot"]);
	
	      var prefixCls = getPrefixCls('timeline', customizePrefixCls);
	      var itemClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-item-pending"), pending), _classNames), className);
	      var dotClassName = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-item-head"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-custom"), dot), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-").concat(color), true), _classNames2));
	      return (/*#__PURE__*/React.createElement("li", _extends({}, (0, _omit["default"])(restProps, ['position']), {
	          className: itemClassName
	        }), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-tail")
	        }), /*#__PURE__*/React.createElement("div", {
	          className: dotClassName,
	          style: {
	            borderColor: /blue|red|green|gray/.test(color) ? undefined : color
	          }
	        }, dot), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-item-content")
	        }, children))
	      );
	    })
	  );
	};
	
	TimelineItem.defaultProps = {
	  color: 'blue',
	  pending: false,
	  position: ''
	};
	var _default = TimelineItem;
	exports["default"] = _default;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Timeline = _interopRequireDefault(__webpack_require__(1458));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Timeline["default"];
	exports["default"] = _default;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOverflowOptions = getOverflowOptions;
	exports["default"] = getPlacements;
	
	var _placements = __webpack_require__(506);
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var autoAdjustOverflowEnabled = {
	  adjustX: 1,
	  adjustY: 1
	};
	var autoAdjustOverflowDisabled = {
	  adjustX: 0,
	  adjustY: 0
	};
	var targetOffset = [0, 0];
	
	function getOverflowOptions(autoAdjustOverflow) {
	  if (typeof autoAdjustOverflow === 'boolean') {
	    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
	  }
	
	  return _extends(_extends({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
	}
	
	function getPlacements() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$arrowWidth = config.arrowWidth,
	      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
	      _config$horizontalArr = config.horizontalArrowShift,
	      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
	      _config$verticalArrow = config.verticalArrowShift,
	      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
	      _config$autoAdjustOve = config.autoAdjustOverflow,
	      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
	  var placementMap = {
	    left: {
	      points: ['cr', 'cl'],
	      offset: [-4, 0]
	    },
	    right: {
	      points: ['cl', 'cr'],
	      offset: [4, 0]
	    },
	    top: {
	      points: ['bc', 'tc'],
	      offset: [0, -4]
	    },
	    bottom: {
	      points: ['tc', 'bc'],
	      offset: [0, 4]
	    },
	    topLeft: {
	      points: ['bl', 'tc'],
	      offset: [-(horizontalArrowShift + arrowWidth), -4]
	    },
	    leftTop: {
	      points: ['tr', 'cl'],
	      offset: [-4, -(verticalArrowShift + arrowWidth)]
	    },
	    topRight: {
	      points: ['br', 'tc'],
	      offset: [horizontalArrowShift + arrowWidth, -4]
	    },
	    rightTop: {
	      points: ['tl', 'cr'],
	      offset: [4, -(verticalArrowShift + arrowWidth)]
	    },
	    bottomRight: {
	      points: ['tr', 'bc'],
	      offset: [horizontalArrowShift + arrowWidth, 4]
	    },
	    rightBottom: {
	      points: ['bl', 'cr'],
	      offset: [4, verticalArrowShift + arrowWidth]
	    },
	    bottomLeft: {
	      points: ['tl', 'bc'],
	      offset: [-(horizontalArrowShift + arrowWidth), 4]
	    },
	    leftBottom: {
	      points: ['br', 'cl'],
	      offset: [-4, verticalArrowShift + arrowWidth]
	    }
	  };
	  Object.keys(placementMap).forEach(function (key) {
	    placementMap[key] = config.arrowPointAtCenter ? _extends(_extends({}, placementMap[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow),
	      targetOffset: targetOffset
	    }) : _extends(_extends({}, _placements.placements[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow)
	    });
	    placementMap[key].ignoreShake = true;
	  });
	  return placementMap;
	}

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _PureRenderMixin = _interopRequireDefault(__webpack_require__(192));
	
	var _reactLazyLoad = _interopRequireDefault(__webpack_require__(486));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(163));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var ListItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(ListItem, _React$Component);
	
	  var _super = _createSuper(ListItem);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ListItem, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          renderedText = _this$props.renderedText,
	          renderedEl = _this$props.renderedEl,
	          item = _this$props.item,
	          lazy = _this$props.lazy,
	          checked = _this$props.checked,
	          disabled = _this$props.disabled,
	          prefixCls = _this$props.prefixCls,
	          onClick = _this$props.onClick;
	      var className = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-content-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-disabled"), disabled || item.disabled), _classNames));
	      var title;
	
	      if (typeof renderedText === 'string' || typeof renderedText === 'number') {
	        title = String(renderedText);
	      }
	
	      var listItem = /*#__PURE__*/React.createElement("li", {
	        className: className,
	        title: title,
	        onClick: disabled || item.disabled ? undefined : function () {
	          return onClick(item);
	        }
	      }, /*#__PURE__*/React.createElement(_checkbox["default"], {
	        checked: checked,
	        disabled: disabled || item.disabled
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-item-text")
	      }, renderedEl));
	      var children = null;
	
	      if (lazy) {
	        var lazyProps = _extends({
	          height: 32,
	          offset: 500,
	          throttle: 0,
	          debounce: false
	        }, lazy);
	
	        children = /*#__PURE__*/React.createElement(_reactLazyLoad["default"], lazyProps, listItem);
	      } else {
	        children = listItem;
	      }
	
	      return children;
	    }
	  }]);
	
	  return ListItem;
	}(React.Component);
	
	exports["default"] = ListItem;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _list = _interopRequireDefault(__webpack_require__(1464));
	
	var _operation = _interopRequireDefault(__webpack_require__(1465));
	
	var _search = _interopRequireDefault(__webpack_require__(763));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(74));
	
	var _default2 = _interopRequireDefault(__webpack_require__(164));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Transfer = /*#__PURE__*/function (_React$Component) {
	  _inherits(Transfer, _React$Component);
	
	  var _super = _createSuper(Transfer);
	
	  function Transfer(props) {
	    var _this;
	
	    _classCallCheck(this, Transfer);
	
	    _this = _super.call(this, props);
	    _this.separatedDataSource = null;
	
	    _this.getLocale = function (transferLocale, renderEmpty) {
	      // Keep old locale props still working.
	      var oldLocale = {
	        notFoundContent: renderEmpty('Transfer')
	      };
	
	      if ('notFoundContent' in _this.props) {
	        oldLocale.notFoundContent = _this.props.notFoundContent;
	      }
	
	      if ('searchPlaceholder' in _this.props) {
	        oldLocale.searchPlaceholder = _this.props.searchPlaceholder;
	      }
	
	      return _extends(_extends(_extends({}, transferLocale), oldLocale), _this.props.locale);
	    };
	
	    _this.moveTo = function (direction) {
	      var _this$props = _this.props,
	          _this$props$targetKey = _this$props.targetKeys,
	          targetKeys = _this$props$targetKey === void 0 ? [] : _this$props$targetKey,
	          _this$props$dataSourc = _this$props.dataSource,
	          dataSource = _this$props$dataSourc === void 0 ? [] : _this$props$dataSourc,
	          onChange = _this$props.onChange;
	      var _this$state = _this.state,
	          sourceSelectedKeys = _this$state.sourceSelectedKeys,
	          targetSelectedKeys = _this$state.targetSelectedKeys;
	      var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys; // filter the disabled options
	
	      var newMoveKeys = moveKeys.filter(function (key) {
	        return !dataSource.some(function (data) {
	          return !!(key === data.key && data.disabled);
	        });
	      }); // move items to target box
	
	      var newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(function (targetKey) {
	        return newMoveKeys.indexOf(targetKey) === -1;
	      }); // empty checked keys
	
	      var oppositeDirection = direction === 'right' ? 'left' : 'right';
	
	      _this.setState(_defineProperty({}, _this.getSelectedKeysName(oppositeDirection), []));
	
	      _this.handleSelectChange(oppositeDirection, []);
	
	      if (onChange) {
	        onChange(newTargetKeys, direction, newMoveKeys);
	      }
	    };
	
	    _this.moveToLeft = function () {
	      return _this.moveTo('left');
	    };
	
	    _this.moveToRight = function () {
	      return _this.moveTo('right');
	    };
	
	    _this.onItemSelectAll = function (direction, selectedKeys, checkAll) {
	      var originalSelectedKeys = _this.state[_this.getSelectedKeysName(direction)] || [];
	      var mergedCheckedKeys = [];
	
	      if (checkAll) {
	        // Merge current keys with origin key
	        mergedCheckedKeys = Array.from(new Set([].concat(_toConsumableArray(originalSelectedKeys), _toConsumableArray(selectedKeys))));
	      } else {
	        // Remove current keys from origin keys
	        mergedCheckedKeys = originalSelectedKeys.filter(function (key) {
	          return selectedKeys.indexOf(key) === -1;
	        });
	      }
	
	      _this.handleSelectChange(direction, mergedCheckedKeys);
	
	      if (!_this.props.selectedKeys) {
	        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), mergedCheckedKeys));
	      }
	    };
	
	    _this.handleSelectAll = function (direction, filteredDataSource, checkAll) {
	      (0, _warning["default"])(false, 'Transfer', '`handleSelectAll` will be removed, please use `onSelectAll` instead.');
	
	      _this.onItemSelectAll(direction, filteredDataSource.map(function (_ref) {
	        var key = _ref.key;
	        return key;
	      }), !checkAll);
	    }; // [Legacy] Old prop `body` pass origin check as arg. It's confusing.
	    // TODO: Remove this in next version.
	
	
	    _this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
	      return _this.handleSelectAll('left', filteredDataSource, !checkAll);
	    };
	
	    _this.handleRightSelectAll = function (filteredDataSource, checkAll) {
	      return _this.handleSelectAll('right', filteredDataSource, !checkAll);
	    };
	
	    _this.onLeftItemSelectAll = function (selectedKeys, checkAll) {
	      return _this.onItemSelectAll('left', selectedKeys, checkAll);
	    };
	
	    _this.onRightItemSelectAll = function (selectedKeys, checkAll) {
	      return _this.onItemSelectAll('right', selectedKeys, checkAll);
	    };
	
	    _this.handleFilter = function (direction, e) {
	      var _this$props2 = _this.props,
	          onSearchChange = _this$props2.onSearchChange,
	          onSearch = _this$props2.onSearch;
	      var value = e.target.value;
	
	      if (onSearchChange) {
	        (0, _warning["default"])(false, 'Transfer', '`onSearchChange` is deprecated. Please use `onSearch` instead.');
	        onSearchChange(direction, e);
	      }
	
	      if (onSearch) {
	        onSearch(direction, value);
	      }
	    };
	
	    _this.handleLeftFilter = function (e) {
	      return _this.handleFilter('left', e);
	    };
	
	    _this.handleRightFilter = function (e) {
	      return _this.handleFilter('right', e);
	    };
	
	    _this.handleClear = function (direction) {
	      var onSearch = _this.props.onSearch;
	
	      if (onSearch) {
	        onSearch(direction, '');
	      }
	    };
	
	    _this.handleLeftClear = function () {
	      return _this.handleClear('left');
	    };
	
	    _this.handleRightClear = function () {
	      return _this.handleClear('right');
	    };
	
	    _this.onItemSelect = function (direction, selectedKey, checked) {
	      var _this$state2 = _this.state,
	          sourceSelectedKeys = _this$state2.sourceSelectedKeys,
	          targetSelectedKeys = _this$state2.targetSelectedKeys;
	      var holder = direction === 'left' ? _toConsumableArray(sourceSelectedKeys) : _toConsumableArray(targetSelectedKeys);
	      var index = holder.indexOf(selectedKey);
	
	      if (index > -1) {
	        holder.splice(index, 1);
	      }
	
	      if (checked) {
	        holder.push(selectedKey);
	      }
	
	      _this.handleSelectChange(direction, holder);
	
	      if (!_this.props.selectedKeys) {
	        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), holder));
	      }
	    };
	
	    _this.handleSelect = function (direction, selectedItem, checked) {
	      (0, _warning["default"])(false, 'Transfer', '`handleSelect` will be removed, please use `onSelect` instead.');
	
	      _this.onItemSelect(direction, selectedItem.key, checked);
	    };
	
	    _this.handleLeftSelect = function (selectedItem, checked) {
	      return _this.handleSelect('left', selectedItem, checked);
	    };
	
	    _this.handleRightSelect = function (selectedItem, checked) {
	      return _this.handleSelect('right', selectedItem, checked);
	    };
	
	    _this.onLeftItemSelect = function (selectedKey, checked) {
	      return _this.onItemSelect('left', selectedKey, checked);
	    };
	
	    _this.onRightItemSelect = function (selectedKey, checked) {
	      return _this.onItemSelect('right', selectedKey, checked);
	    };
	
	    _this.handleScroll = function (direction, e) {
	      var onScroll = _this.props.onScroll;
	
	      if (onScroll) {
	        onScroll(direction, e);
	      }
	    };
	
	    _this.handleLeftScroll = function (e) {
	      return _this.handleScroll('left', e);
	    };
	
	    _this.handleRightScroll = function (e) {
	      return _this.handleScroll('right', e);
	    };
	
	    _this.handleListStyle = function (listStyle, direction) {
	      if (typeof listStyle === 'function') {
	        return listStyle({
	          direction: direction
	        });
	      }
	
	      return listStyle;
	    };
	
	    _this.renderTransfer = function (transferLocale) {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	          var _classNames;
	
	          var getPrefixCls = _ref2.getPrefixCls,
	              renderEmpty = _ref2.renderEmpty;
	          var _this$props3 = _this.props,
	              customizePrefixCls = _this$props3.prefixCls,
	              className = _this$props3.className,
	              disabled = _this$props3.disabled,
	              _this$props3$operatio = _this$props3.operations,
	              operations = _this$props3$operatio === void 0 ? [] : _this$props3$operatio,
	              showSearch = _this$props3.showSearch,
	              body = _this$props3.body,
	              footer = _this$props3.footer,
	              style = _this$props3.style,
	              listStyle = _this$props3.listStyle,
	              operationStyle = _this$props3.operationStyle,
	              filterOption = _this$props3.filterOption,
	              render = _this$props3.render,
	              lazy = _this$props3.lazy,
	              children = _this$props3.children,
	              showSelectAll = _this$props3.showSelectAll;
	          var prefixCls = getPrefixCls('transfer', customizePrefixCls);
	
	          var locale = _this.getLocale(transferLocale, renderEmpty);
	
	          var _this$state3 = _this.state,
	              sourceSelectedKeys = _this$state3.sourceSelectedKeys,
	              targetSelectedKeys = _this$state3.targetSelectedKeys;
	
	          var _this$separateDataSou = _this.separateDataSource(),
	              leftDataSource = _this$separateDataSou.leftDataSource,
	              rightDataSource = _this$separateDataSou.rightDataSource;
	
	          var leftActive = targetSelectedKeys.length > 0;
	          var rightActive = sourceSelectedKeys.length > 0;
	          var cls = (0, _classnames["default"])(className, prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-customize-list"), !!children), _classNames));
	
	          var titles = _this.getTitles(locale);
	
	          return (/*#__PURE__*/React.createElement("div", {
	              className: cls,
	              style: style
	            }, /*#__PURE__*/React.createElement(_list["default"], _extends({
	              prefixCls: "".concat(prefixCls, "-list"),
	              titleText: titles[0],
	              dataSource: leftDataSource,
	              filterOption: filterOption,
	              style: _this.handleListStyle(listStyle, 'left'),
	              checkedKeys: sourceSelectedKeys,
	              handleFilter: _this.handleLeftFilter,
	              handleClear: _this.handleLeftClear,
	              handleSelect: _this.handleLeftSelect,
	              handleSelectAll: _this.handleLeftSelectAll,
	              onItemSelect: _this.onLeftItemSelect,
	              onItemSelectAll: _this.onLeftItemSelectAll,
	              render: render,
	              showSearch: showSearch,
	              body: body,
	              renderList: children,
	              footer: footer,
	              lazy: lazy,
	              onScroll: _this.handleLeftScroll,
	              disabled: disabled,
	              direction: "left",
	              showSelectAll: showSelectAll
	            }, locale)), /*#__PURE__*/React.createElement(_operation["default"], {
	              className: "".concat(prefixCls, "-operation"),
	              rightActive: rightActive,
	              rightArrowText: operations[0],
	              moveToRight: _this.moveToRight,
	              leftActive: leftActive,
	              leftArrowText: operations[1],
	              moveToLeft: _this.moveToLeft,
	              style: operationStyle,
	              disabled: disabled
	            }), /*#__PURE__*/React.createElement(_list["default"], _extends({
	              prefixCls: "".concat(prefixCls, "-list"),
	              titleText: titles[1],
	              dataSource: rightDataSource,
	              filterOption: filterOption,
	              style: _this.handleListStyle(listStyle, 'right'),
	              checkedKeys: targetSelectedKeys,
	              handleFilter: _this.handleRightFilter,
	              handleClear: _this.handleRightClear,
	              handleSelect: _this.handleRightSelect,
	              handleSelectAll: _this.handleRightSelectAll,
	              onItemSelect: _this.onRightItemSelect,
	              onItemSelectAll: _this.onRightItemSelectAll,
	              render: render,
	              showSearch: showSearch,
	              body: body,
	              renderList: children,
	              footer: footer,
	              lazy: lazy,
	              onScroll: _this.handleRightScroll,
	              disabled: disabled,
	              direction: "right",
	              showSelectAll: showSelectAll
	            }, locale)))
	          );
	        })
	      );
	    };
	
	    (0, _warning["default"])(!('notFoundContent' in props || 'searchPlaceholder' in props), 'Transfer', '`notFoundContent` and `searchPlaceholder` will be removed, ' + 'please use `locale` instead.');
	    (0, _warning["default"])(!('body' in props), 'Transfer', '`body` is internal usage and will bre removed, please use `children` instead.');
	    var _props$selectedKeys = props.selectedKeys,
	        selectedKeys = _props$selectedKeys === void 0 ? [] : _props$selectedKeys,
	        _props$targetKeys = props.targetKeys,
	        targetKeys = _props$targetKeys === void 0 ? [] : _props$targetKeys;
	    _this.state = {
	      sourceSelectedKeys: selectedKeys.filter(function (key) {
	        return targetKeys.indexOf(key) === -1;
	      }),
	      targetSelectedKeys: selectedKeys.filter(function (key) {
	        return targetKeys.indexOf(key) > -1;
	      })
	    };
	    return _this;
	  }
	
	  _createClass(Transfer, [{
	    key: "getSelectedKeysName",
	    // eslint-disable-next-line
	    value: function getSelectedKeysName(direction) {
	      return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
	    }
	  }, {
	    key: "getTitles",
	    value: function getTitles(transferLocale) {
	      var props = this.props;
	
	      if (props.titles) {
	        return props.titles;
	      }
	
	      return transferLocale.titles;
	    }
	  }, {
	    key: "handleSelectChange",
	    value: function handleSelectChange(direction, holder) {
	      var _this$state4 = this.state,
	          sourceSelectedKeys = _this$state4.sourceSelectedKeys,
	          targetSelectedKeys = _this$state4.targetSelectedKeys;
	      var onSelectChange = this.props.onSelectChange;
	
	      if (!onSelectChange) {
	        return;
	      }
	
	      if (direction === 'left') {
	        onSelectChange(holder, targetSelectedKeys);
	      } else {
	        onSelectChange(sourceSelectedKeys, holder);
	      }
	    }
	  }, {
	    key: "separateDataSource",
	    value: function separateDataSource() {
	      var _this$props4 = this.props,
	          dataSource = _this$props4.dataSource,
	          rowKey = _this$props4.rowKey,
	          _this$props4$targetKe = _this$props4.targetKeys,
	          targetKeys = _this$props4$targetKe === void 0 ? [] : _this$props4$targetKe;
	      var leftDataSource = [];
	      var rightDataSource = new Array(targetKeys.length);
	      dataSource.forEach(function (record) {
	        if (rowKey) {
	          record.key = rowKey(record);
	        } // rightDataSource should be ordered by targetKeys
	        // leftDataSource should be ordered by dataSource
	
	
	        var indexOfKey = targetKeys.indexOf(record.key);
	
	        if (indexOfKey !== -1) {
	          rightDataSource[indexOfKey] = record;
	        } else {
	          leftDataSource.push(record);
	        }
	      });
	      return {
	        leftDataSource: leftDataSource,
	        rightDataSource: rightDataSource
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "Transfer",
	          defaultLocale: _default2["default"].Transfer
	        }, this.renderTransfer)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if (nextProps.selectedKeys) {
	        var targetKeys = nextProps.targetKeys || [];
	        return {
	          sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	            return !targetKeys.includes(key);
	          }),
	          targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	            return targetKeys.includes(key);
	          })
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Transfer;
	}(React.Component); // For high-level customized Transfer @dqaria
	
	
	Transfer.List = _list["default"];
	Transfer.Operation = _operation["default"];
	Transfer.Search = _search["default"];
	Transfer.defaultProps = {
	  dataSource: [],
	  locale: {},
	  showSearch: false,
	  listStyle: function listStyle() {}
	};
	Transfer.propTypes = {
	  prefixCls: PropTypes.string,
	  disabled: PropTypes.bool,
	  dataSource: PropTypes.array,
	  render: PropTypes.func,
	  targetKeys: PropTypes.array,
	  onChange: PropTypes.func,
	  height: PropTypes.number,
	  style: PropTypes.object,
	  listStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
	  operationStyle: PropTypes.object,
	  className: PropTypes.string,
	  titles: PropTypes.array,
	  operations: PropTypes.array,
	  showSearch: PropTypes.bool,
	  filterOption: PropTypes.func,
	  searchPlaceholder: PropTypes.string,
	  notFoundContent: PropTypes.node,
	  locale: PropTypes.object,
	  body: PropTypes.func,
	  footer: PropTypes.func,
	  rowKey: PropTypes.func,
	  lazy: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
	};
	(0, _reactLifecyclesCompat.polyfill)(Transfer);
	var _default = Transfer;
	exports["default"] = _default;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(84));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _PureRenderMixin = _interopRequireDefault(__webpack_require__(192));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(163));
	
	var _search = _interopRequireDefault(__webpack_require__(763));
	
	var _renderListBody = _interopRequireWildcard(__webpack_require__(1466));
	
	var _triggerEvent = _interopRequireDefault(__webpack_require__(1355));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var defaultRender = function defaultRender() {
	  return null;
	};
	
	function isRenderResultPlainObject(result) {
	  return result && ! /*#__PURE__*/React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
	}
	
	function renderListNode(renderList, props) {
	  var bodyContent = renderList ? renderList(props) : null;
	  var customize = !!bodyContent;
	
	  if (!customize) {
	    bodyContent = (0, _renderListBody["default"])(props);
	  }
	
	  return {
	    customize: customize,
	    bodyContent: bodyContent
	  };
	}
	
	var TransferList = /*#__PURE__*/function (_React$Component) {
	  _inherits(TransferList, _React$Component);
	
	  var _super = _createSuper(TransferList);
	
	  function TransferList(props) {
	    var _this;
	
	    _classCallCheck(this, TransferList);
	
	    _this = _super.call(this, props);
	
	    _this.handleFilter = function (e) {
	      var handleFilter = _this.props.handleFilter;
	      var filterValue = e.target.value;
	
	      _this.setState({
	        filterValue: filterValue
	      });
	
	      handleFilter(e);
	
	      if (!filterValue) {
	        return;
	      } // Manually trigger scroll event for lazy search bug
	      // https://github.com/ant-design/ant-design/issues/5631
	
	
	      _this.triggerScrollTimer = window.setTimeout(function () {
	        var transferNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	        var listNode = transferNode.querySelectorAll('.ant-transfer-list-content')[0];
	
	        if (listNode) {
	          (0, _triggerEvent["default"])(listNode, 'scroll');
	        }
	      }, 0);
	    };
	
	    _this.handleClear = function () {
	      var handleClear = _this.props.handleClear;
	
	      _this.setState({
	        filterValue: ''
	      });
	
	      handleClear();
	    };
	
	    _this.matchFilter = function (text, item) {
	      var filterValue = _this.state.filterValue;
	      var filterOption = _this.props.filterOption;
	
	      if (filterOption) {
	        return filterOption(filterValue, item);
	      }
	
	      return text.indexOf(filterValue) >= 0;
	    };
	
	    _this.renderItem = function (item) {
	      var _this$props$render = _this.props.render,
	          render = _this$props$render === void 0 ? defaultRender : _this$props$render;
	      var renderResult = render(item);
	      var isRenderResultPlain = isRenderResultPlainObject(renderResult);
	      return {
	        renderedText: isRenderResultPlain ? renderResult.value : renderResult,
	        renderedEl: isRenderResultPlain ? renderResult.label : renderResult,
	        item: item
	      };
	    };
	
	    _this.state = {
	      filterValue: ''
	    };
	    return _this;
	  }
	
	  _createClass(TransferList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.triggerScrollTimer);
	    }
	  }, {
	    key: "getCheckStatus",
	    value: function getCheckStatus(filteredItems) {
	      var checkedKeys = this.props.checkedKeys;
	
	      if (checkedKeys.length === 0) {
	        return 'none';
	      }
	
	      if (filteredItems.every(function (item) {
	        return checkedKeys.indexOf(item.key) >= 0 || !!item.disabled;
	      })) {
	        return 'all';
	      }
	
	      return 'part';
	    }
	  }, {
	    key: "getFilteredItems",
	    value: function getFilteredItems(dataSource, filterValue) {
	      var _this2 = this;
	
	      var filteredItems = [];
	      var filteredRenderItems = [];
	      dataSource.forEach(function (item) {
	        var renderedItem = _this2.renderItem(item);
	
	        var renderedText = renderedItem.renderedText; // Filter skip
	
	        if (filterValue && filterValue.trim() && !_this2.matchFilter(renderedText, item)) {
	          return null;
	        }
	
	        filteredItems.push(item);
	        filteredRenderItems.push(renderedItem);
	      });
	      return {
	        filteredItems: filteredItems,
	        filteredRenderItems: filteredRenderItems
	      };
	    }
	  }, {
	    key: "getListBody",
	    value: function getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled) {
	      var search = showSearch ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body-search-wrapper")
	      }, /*#__PURE__*/React.createElement(_search["default"], {
	        prefixCls: "".concat(prefixCls, "-search"),
	        onChange: this.handleFilter,
	        handleClear: this.handleClear,
	        placeholder: searchPlaceholder,
	        value: filterValue,
	        disabled: disabled
	      })) : null;
	      var listBody = bodyDom;
	
	      if (!listBody) {
	        var bodyNode;
	
	        var _renderListNode = renderListNode(renderList, _extends(_extends({}, (0, _omit["default"])(this.props, _renderListBody.OmitProps)), {
	          filteredItems: filteredItems,
	          filteredRenderItems: filteredRenderItems,
	          selectedKeys: checkedKeys
	        })),
	            bodyContent = _renderListNode.bodyContent,
	            customize = _renderListNode.customize; // We should wrap customize list body in a classNamed div to use flex layout.
	
	
	        if (customize) {
	          bodyNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-body-customize-wrapper")
	          }, bodyContent);
	        } else {
	          bodyNode = filteredItems.length ? bodyContent : /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-body-not-found")
	          }, notFoundContent);
	        }
	
	        listBody = /*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])(showSearch ? "".concat(prefixCls, "-body ").concat(prefixCls, "-body-with-search") : "".concat(prefixCls, "-body"))
	        }, search, bodyNode);
	      }
	
	      return listBody;
	    }
	  }, {
	    key: "getCheckBox",
	    value: function getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled) {
	      var checkStatus = this.getCheckStatus(filteredItems);
	      var checkedAll = checkStatus === 'all';
	      var checkAllCheckbox = showSelectAll !== false && /*#__PURE__*/React.createElement(_checkbox["default"], {
	        disabled: disabled,
	        checked: checkedAll,
	        indeterminate: checkStatus === 'part',
	        onChange: function onChange() {
	          // Only select enabled items
	          onItemSelectAll(filteredItems.filter(function (item) {
	            return !item.disabled;
	          }).map(function (_ref) {
	            var key = _ref.key;
	            return key;
	          }), !checkedAll);
	        }
	      });
	      return checkAllCheckbox;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var filterValue = this.state.filterValue;
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          dataSource = _this$props.dataSource,
	          titleText = _this$props.titleText,
	          checkedKeys = _this$props.checkedKeys,
	          disabled = _this$props.disabled,
	          body = _this$props.body,
	          footer = _this$props.footer,
	          showSearch = _this$props.showSearch,
	          style = _this$props.style,
	          searchPlaceholder = _this$props.searchPlaceholder,
	          notFoundContent = _this$props.notFoundContent,
	          itemUnit = _this$props.itemUnit,
	          itemsUnit = _this$props.itemsUnit,
	          renderList = _this$props.renderList,
	          onItemSelectAll = _this$props.onItemSelectAll,
	          showSelectAll = _this$props.showSelectAll; // Custom Layout
	
	      var footerDom = footer && footer(this.props);
	      var bodyDom = body && body(this.props);
	      var listCls = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-with-footer"), !!footerDom)); // ====================== Get filtered, checked item list ======================
	
	      var _this$getFilteredItem = this.getFilteredItems(dataSource, filterValue),
	          filteredItems = _this$getFilteredItem.filteredItems,
	          filteredRenderItems = _this$getFilteredItem.filteredRenderItems; // ================================= List Body =================================
	
	
	      var unit = dataSource.length > 1 ? itemsUnit : itemUnit;
	      var listBody = this.getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled); // ================================ List Footer ================================
	
	      var listFooter = footerDom ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, footerDom) : null;
	      var checkAllCheckbox = this.getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled); // ================================== Render ===================================
	
	      return (/*#__PURE__*/React.createElement("div", {
	          className: listCls,
	          style: style
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-header")
	        }, checkAllCheckbox, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-header-selected")
	        }, /*#__PURE__*/React.createElement("span", null, (checkedKeys.length > 0 ? "".concat(checkedKeys.length, "/") : '') + filteredItems.length, ' ', unit), /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-header-title")
	        }, titleText))), listBody, listFooter)
	      );
	    }
	  }]);
	
	  return TransferList;
	}(React.Component);
	
	exports["default"] = TransferList;
	TransferList.defaultProps = {
	  dataSource: [],
	  titleText: '',
	  showSearch: false,
	  lazy: {}
	};

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _button = _interopRequireDefault(__webpack_require__(138));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	var Operation = function Operation(_ref) {
	  var disabled = _ref.disabled,
	      moveToLeft = _ref.moveToLeft,
	      moveToRight = _ref.moveToRight,
	      _ref$leftArrowText = _ref.leftArrowText,
	      leftArrowText = _ref$leftArrowText === void 0 ? '' : _ref$leftArrowText,
	      _ref$rightArrowText = _ref.rightArrowText,
	      rightArrowText = _ref$rightArrowText === void 0 ? '' : _ref$rightArrowText,
	      leftActive = _ref.leftActive,
	      rightActive = _ref.rightActive,
	      className = _ref.className,
	      style = _ref.style;
	  return (/*#__PURE__*/React.createElement("div", {
	      className: className,
	      style: style
	    }, /*#__PURE__*/React.createElement(_button["default"], {
	      type: "primary",
	      size: "small",
	      disabled: disabled || !rightActive,
	      onClick: moveToRight,
	      icon: "right"
	    }, rightArrowText), /*#__PURE__*/React.createElement(_button["default"], {
	      type: "primary",
	      size: "small",
	      disabled: disabled || !leftActive,
	      onClick: moveToLeft,
	      icon: "left"
	    }, leftArrowText))
	  );
	};
	
	var _default = Operation;
	exports["default"] = _default;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OmitProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactDom = __webpack_require__(84);
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _raf = _interopRequireDefault(__webpack_require__(205));
	
	var _type = __webpack_require__(83);
	
	var _ListItem = _interopRequireDefault(__webpack_require__(1462));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var OmitProps = (0, _type.tuple)('handleFilter', 'handleSelect', 'handleSelectAll', 'handleClear', 'body', 'checkedKeys');
	exports.OmitProps = OmitProps;
	
	var ListBody = /*#__PURE__*/function (_React$Component) {
	  _inherits(ListBody, _React$Component);
	
	  var _super = _createSuper(ListBody);
	
	  function ListBody() {
	    var _this;
	
	    _classCallCheck(this, ListBody);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      mounted: false
	    };
	
	    _this.onItemSelect = function (item) {
	      var _this$props = _this.props,
	          onItemSelect = _this$props.onItemSelect,
	          selectedKeys = _this$props.selectedKeys;
	      var checked = selectedKeys.indexOf(item.key) >= 0;
	      onItemSelect(item.key, !checked);
	    };
	
	    return _this;
	  }
	
	  _createClass(ListBody, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mountId = (0, _raf["default"])(function () {
	        _this2.setState({
	          mounted: true
	        });
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props2 = this.props,
	          filteredRenderItems = _this$props2.filteredRenderItems,
	          lazy = _this$props2.lazy;
	
	      if (prevProps.filteredRenderItems.length !== filteredRenderItems.length && lazy !== false) {
	        // TODO: Replace this with ref when react 15 support removed.
	        var container = (0, _reactDom.findDOMNode)(this);
	
	        _raf["default"].cancel(this.lazyId);
	
	        this.lazyId = (0, _raf["default"])(function () {
	          if (container) {
	            var scrollEvent = new Event('scroll', {
	              bubbles: true
	            });
	            container.dispatchEvent(scrollEvent);
	          }
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountId);
	
	      _raf["default"].cancel(this.lazyId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var mounted = this.state.mounted;
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          onScroll = _this$props3.onScroll,
	          filteredRenderItems = _this$props3.filteredRenderItems,
	          lazy = _this$props3.lazy,
	          selectedKeys = _this$props3.selectedKeys,
	          globalDisabled = _this$props3.disabled;
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          component: "ul",
	          componentProps: {
	            onScroll: onScroll
	          },
	          className: "".concat(prefixCls, "-content"),
	          transitionName: mounted ? "".concat(prefixCls, "-content-item-highlight") : '',
	          transitionLeave: false
	        }, filteredRenderItems.map(function (_ref) {
	          var renderedEl = _ref.renderedEl,
	              renderedText = _ref.renderedText,
	              item = _ref.item;
	          var disabled = item.disabled;
	          var checked = selectedKeys.indexOf(item.key) >= 0;
	          return (/*#__PURE__*/React.createElement(_ListItem["default"], {
	              disabled: globalDisabled || disabled,
	              key: item.key,
	              item: item,
	              lazy: lazy,
	              renderedText: renderedText,
	              renderedEl: renderedEl,
	              checked: checked,
	              prefixCls: prefixCls,
	              onClick: _this3.onItemSelect
	            })
	          );
	        }))
	      );
	    }
	  }]);
	
	  return ListBody;
	}(React.Component);
	
	var ListBodyWrapper = function ListBodyWrapper(props) {
	  return (/*#__PURE__*/React.createElement(ListBody, props)
	  );
	};
	
	var _default = ListBodyWrapper;
	exports["default"] = _default;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcTreeSelect = _interopRequireWildcard(__webpack_require__(484));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _configProvider = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _reactNode = __webpack_require__(733);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TreeSelect = /*#__PURE__*/function (_React$Component) {
	  _inherits(TreeSelect, _React$Component);
	
	  var _super = _createSuper(TreeSelect);
	
	  function TreeSelect(props) {
	    var _this;
	
	    _classCallCheck(this, TreeSelect);
	
	    _this = _super.call(this, props);
	
	    _this.saveTreeSelect = function (node) {
	      _this.rcTreeSelect = node;
	    };
	
	    _this.renderSwitcherIcon = function (prefixCls, _ref) {
	      var isLeaf = _ref.isLeaf,
	          loading = _ref.loading;
	
	      if (loading) {
	        return (/*#__PURE__*/React.createElement(_icon["default"], {
	            type: "loading",
	            className: "".concat(prefixCls, "-switcher-loading-icon")
	          })
	        );
	      }
	
	      if (isLeaf) {
	        return null;
	      }
	
	      return (/*#__PURE__*/React.createElement(_icon["default"], {
	          type: "caret-down",
	          className: "".concat(prefixCls, "-switcher-icon")
	        })
	      );
	    };
	
	    _this.renderTreeSelect = function (_ref2) {
	      var _classNames;
	
	      var getContextPopupContainer = _ref2.getPopupContainer,
	          getPrefixCls = _ref2.getPrefixCls,
	          renderEmpty = _ref2.renderEmpty;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          size = _a.size,
	          notFoundContent = _a.notFoundContent,
	          dropdownStyle = _a.dropdownStyle,
	          dropdownClassName = _a.dropdownClassName,
	          suffixIcon = _a.suffixIcon,
	          removeIcon = _a.removeIcon,
	          clearIcon = _a.clearIcon,
	          getPopupContainer = _a.getPopupContainer,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "notFoundContent", "dropdownStyle", "dropdownClassName", "suffixIcon", "removeIcon", "clearIcon", "getPopupContainer"]);
	
	      var rest = (0, _omit["default"])(restProps, ['inputIcon', 'removeIcon', 'clearIcon', 'switcherIcon']);
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className); // showSearch: single - false, multiple - true
	
	      var showSearch = restProps.showSearch;
	
	      if (!('showSearch' in restProps)) {
	        showSearch = !!(restProps.multiple || restProps.treeCheckable);
	      }
	
	      var checkable = rest.treeCheckable;
	
	      if (checkable) {
	        checkable = /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-tree-checkbox-inner")
	        });
	      }
	
	      var inputIcon = suffixIcon ? (0, _reactNode.cloneElement)(suffixIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-arrow-icon")
	      });
	      var finalRemoveIcon = removeIcon ? (0, _reactNode.cloneElement)(removeIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        className: "".concat(prefixCls, "-remove-icon")
	      });
	      var finalClearIcon = clearIcon ? (0, _reactNode.cloneElement)(clearIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-clear-icon")
	      });
	      return (/*#__PURE__*/React.createElement(_rcTreeSelect["default"], _extends({
	          switcherIcon: function switcherIcon(nodeProps) {
	            return _this.renderSwitcherIcon(prefixCls, nodeProps);
	          },
	          inputIcon: inputIcon,
	          removeIcon: finalRemoveIcon,
	          clearIcon: finalClearIcon
	        }, rest, {
	          showSearch: showSearch,
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          dropdownClassName: (0, _classnames["default"])(dropdownClassName, "".concat(prefixCls, "-tree-dropdown")),
	          prefixCls: prefixCls,
	          className: cls,
	          dropdownStyle: _extends({
	            maxHeight: '100vh',
	            overflow: 'auto'
	          }, dropdownStyle),
	          treeCheckable: checkable,
	          notFoundContent: notFoundContent || renderEmpty('Select'),
	          ref: _this.saveTreeSelect
	        }))
	      );
	    };
	
	    (0, _warning["default"])(props.multiple !== false || !props.treeCheckable, 'TreeSelect', '`multiple` will alway be `true` when `treeCheckable` is true');
	    return _this;
	  }
	
	  _createClass(TreeSelect, [{
	    key: "focus",
	    value: function focus() {
	      this.rcTreeSelect.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcTreeSelect.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTreeSelect)
	      );
	    }
	  }]);
	
	  return TreeSelect;
	}(React.Component);
	
	exports["default"] = TreeSelect;
	TreeSelect.TreeNode = _rcTreeSelect.TreeNode;
	TreeSelect.SHOW_ALL = _rcTreeSelect.SHOW_ALL;
	TreeSelect.SHOW_PARENT = _rcTreeSelect.SHOW_PARENT;
	TreeSelect.SHOW_CHILD = _rcTreeSelect.SHOW_CHILD;
	TreeSelect.defaultProps = {
	  transitionName: 'slide-up',
	  choiceTransitionName: 'zoom'
	};

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _omit = _interopRequireDefault(__webpack_require__(7));
	
	var _debounce = _interopRequireDefault(__webpack_require__(100));
	
	var _util = __webpack_require__(182);
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _configProvider = __webpack_require__(15);
	
	var _Tree = _interopRequireDefault(__webpack_require__(764));
	
	var _util2 = __webpack_require__(1470);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getIcon(props) {
	  var isLeaf = props.isLeaf,
	      expanded = props.expanded;
	
	  if (isLeaf) {
	    return (/*#__PURE__*/React.createElement(_icon["default"], {
	        type: "file"
	      })
	    );
	  }
	
	  return (/*#__PURE__*/React.createElement(_icon["default"], {
	      type: expanded ? 'folder-open' : 'folder'
	    })
	  );
	}
	
	var DirectoryTree = /*#__PURE__*/function (_React$Component) {
	  _inherits(DirectoryTree, _React$Component);
	
	  var _super = _createSuper(DirectoryTree);
	
	  function DirectoryTree(props) {
	    var _this;
	
	    _classCallCheck(this, DirectoryTree);
	
	    _this = _super.call(this, props);
	
	    _this.onExpand = function (expandedKeys, info) {
	      var onExpand = _this.props.onExpand;
	
	      _this.setUncontrolledState({
	        expandedKeys: expandedKeys
	      }); // Call origin function
	
	
	      if (onExpand) {
	        return onExpand(expandedKeys, info);
	      }
	
	      return undefined;
	    };
	
	    _this.onClick = function (event, node) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          expandAction = _this$props.expandAction; // Expand the tree
	
	      if (expandAction === 'click') {
	        _this.onDebounceExpand(event, node);
	      }
	
	      if (onClick) {
	        onClick(event, node);
	      }
	    };
	
	    _this.onDoubleClick = function (event, node) {
	      var _this$props2 = _this.props,
	          onDoubleClick = _this$props2.onDoubleClick,
	          expandAction = _this$props2.expandAction; // Expand the tree
	
	      if (expandAction === 'doubleClick') {
	        _this.onDebounceExpand(event, node);
	      }
	
	      if (onDoubleClick) {
	        onDoubleClick(event, node);
	      }
	    };
	
	    _this.onSelect = function (keys, event) {
	      var _this$props3 = _this.props,
	          onSelect = _this$props3.onSelect,
	          multiple = _this$props3.multiple,
	          children = _this$props3.children;
	      var _this$state$expandedK = _this.state.expandedKeys,
	          expandedKeys = _this$state$expandedK === void 0 ? [] : _this$state$expandedK;
	      var node = event.node,
	          nativeEvent = event.nativeEvent;
	      var _node$props$eventKey = node.props.eventKey,
	          eventKey = _node$props$eventKey === void 0 ? '' : _node$props$eventKey;
	      var newState = {}; // We need wrap this event since some value is not same
	
	      var newEvent = _extends(_extends({}, event), {
	        selected: true
	      }); // Windows / Mac single pick
	
	
	      var ctrlPick = nativeEvent.ctrlKey || nativeEvent.metaKey;
	      var shiftPick = nativeEvent.shiftKey; // Generate new selected keys
	
	      var newSelectedKeys;
	
	      if (multiple && ctrlPick) {
	        // Control click
	        newSelectedKeys = keys;
	        _this.lastSelectedKey = eventKey;
	        _this.cachedSelectedKeys = newSelectedKeys;
	        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
	      } else if (multiple && shiftPick) {
	        // Shift click
	        newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(_this.cachedSelectedKeys || []), _toConsumableArray((0, _util2.calcRangeKeys)(children, expandedKeys, eventKey, _this.lastSelectedKey)))));
	        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
	      } else {
	        // Single click
	        newSelectedKeys = [eventKey];
	        _this.lastSelectedKey = eventKey;
	        _this.cachedSelectedKeys = newSelectedKeys;
	        newEvent.selectedNodes = [event.node];
	      }
	
	      newState.selectedKeys = newSelectedKeys;
	
	      if (onSelect) {
	        onSelect(newSelectedKeys, newEvent);
	      }
	
	      _this.setUncontrolledState(newState);
	    };
	
	    _this.setTreeRef = function (node) {
	      _this.tree = node;
	    };
	
	    _this.expandFolderNode = function (event, node) {
	      var isLeaf = node.props.isLeaf;
	
	      if (isLeaf || event.shiftKey || event.metaKey || event.ctrlKey) {
	        return;
	      } // Get internal rc-tree
	
	
	      var internalTree = _this.tree.tree; // Call internal rc-tree expand function
	      // https://github.com/ant-design/ant-design/issues/12567
	
	      internalTree.onNodeExpand(event, node);
	    };
	
	    _this.setUncontrolledState = function (state) {
	      var newState = (0, _omit["default"])(state, Object.keys(_this.props));
	
	      if (Object.keys(newState).length) {
	        _this.setState(newState);
	      }
	    };
	
	    _this.renderDirectoryTree = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          props = __rest(_a, ["prefixCls", "className"]);
	
	      var _this$state = _this.state,
	          expandedKeys = _this$state.expandedKeys,
	          selectedKeys = _this$state.selectedKeys;
	      var prefixCls = getPrefixCls('tree', customizePrefixCls);
	      var connectClassName = (0, _classnames["default"])("".concat(prefixCls, "-directory"), className);
	      return (/*#__PURE__*/React.createElement(_Tree["default"], _extends({
	          icon: getIcon,
	          ref: _this.setTreeRef
	        }, props, {
	          prefixCls: prefixCls,
	          className: connectClassName,
	          expandedKeys: expandedKeys,
	          selectedKeys: selectedKeys,
	          onSelect: _this.onSelect,
	          onClick: _this.onClick,
	          onDoubleClick: _this.onDoubleClick,
	          onExpand: _this.onExpand
	        }))
	      );
	    };
	
	    var defaultExpandAll = props.defaultExpandAll,
	        defaultExpandParent = props.defaultExpandParent,
	        expandedKeys = props.expandedKeys,
	        defaultExpandedKeys = props.defaultExpandedKeys,
	        children = props.children;
	
	    var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
	        keyEntities = _convertTreeToEntitie.keyEntities; // Selected keys
	
	
	    _this.state = {
	      selectedKeys: props.selectedKeys || props.defaultSelectedKeys || []
	    }; // Expanded keys
	
	    if (defaultExpandAll) {
	      if (props.treeData) {
	        _this.state.expandedKeys = (0, _util2.getFullKeyListByTreeData)(props.treeData);
	      } else {
	        _this.state.expandedKeys = (0, _util2.getFullKeyList)(props.children);
	      }
	    } else if (defaultExpandParent) {
	      _this.state.expandedKeys = (0, _util.conductExpandParent)(expandedKeys || defaultExpandedKeys, keyEntities);
	    } else {
	      _this.state.expandedKeys = expandedKeys || defaultExpandedKeys;
	    }
	
	    _this.onDebounceExpand = (0, _debounce["default"])(_this.expandFolderNode, 200, {
	      leading: true
	    });
	    return _this;
	  }
	
	  _createClass(DirectoryTree, [{
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDirectoryTree)
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	
	      if ('expandedKeys' in nextProps) {
	        newState.expandedKeys = nextProps.expandedKeys;
	      }
	
	      if ('selectedKeys' in nextProps) {
	        newState.selectedKeys = nextProps.selectedKeys;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return DirectoryTree;
	}(React.Component);
	
	DirectoryTree.defaultProps = {
	  showIcon: true,
	  expandAction: 'click'
	};
	(0, _reactLifecyclesCompat.polyfill)(DirectoryTree);
	var _default = DirectoryTree;
	exports["default"] = _default;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Tree = _interopRequireDefault(__webpack_require__(764));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _Tree["default"];
	exports["default"] = _default;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFullKeyList = getFullKeyList;
	exports.calcRangeKeys = calcRangeKeys;
	exports.convertDirectoryKeysToNodes = convertDirectoryKeysToNodes;
	exports.getFullKeyListByTreeData = getFullKeyListByTreeData;
	
	var _util = __webpack_require__(182);
	
	function _toConsumableArray(arr) {
	  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
	}
	
	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
	}
	
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }return arr2;
	}
	
	var Record;
	
	(function (Record) {
	  Record[Record["None"] = 0] = "None";
	  Record[Record["Start"] = 1] = "Start";
	  Record[Record["End"] = 2] = "End";
	})(Record || (Record = {})); // TODO: Move this logic into `rc-tree`
	
	
	function traverseNodesKey(rootChildren, callback) {
	  var nodeList = (0, _util.getNodeChildren)(rootChildren) || [];
	
	  function processNode(node) {
	    var key = node.key,
	        children = node.props.children;
	
	    if (callback(key, node) !== false) {
	      traverseNodesKey(children, callback);
	    }
	  }
	
	  nodeList.forEach(processNode);
	}
	
	function getFullKeyList(children) {
	  var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
	      keyEntities = _convertTreeToEntitie.keyEntities;
	
	  return Object.keys(keyEntities);
	}
	/** 计算选中范围，只考虑expanded情况以优化性能 */
	
	function calcRangeKeys(rootChildren, expandedKeys, startKey, endKey) {
	  var keys = [];
	  var record = Record.None;
	
	  if (startKey && startKey === endKey) {
	    return [startKey];
	  }
	
	  if (!startKey || !endKey) {
	    return [];
	  }
	
	  function matchKey(key) {
	    return key === startKey || key === endKey;
	  }
	
	  traverseNodesKey(rootChildren, function (key) {
	    if (record === Record.End) {
	      return false;
	    }
	
	    if (matchKey(key)) {
	      // Match test
	      keys.push(key);
	
	      if (record === Record.None) {
	        record = Record.Start;
	      } else if (record === Record.Start) {
	        record = Record.End;
	        return false;
	      }
	    } else if (record === Record.Start) {
	      // Append selection
	      keys.push(key);
	    }
	
	    if (expandedKeys.indexOf(key) === -1) {
	      return false;
	    }
	
	    return true;
	  });
	  return keys;
	}
	
	function convertDirectoryKeysToNodes(rootChildren, keys) {
	  var restKeys = _toConsumableArray(keys);
	
	  var nodes = [];
	  traverseNodesKey(rootChildren, function (key, node) {
	    var index = restKeys.indexOf(key);
	
	    if (index !== -1) {
	      nodes.push(node);
	      restKeys.splice(index, 1);
	    }
	
	    return !!restKeys.length;
	  });
	  return nodes;
	}
	
	function getFullKeyListByTreeData(treeData) {
	  var keys = [];
	  (treeData || []).forEach(function (item) {
	    keys.push(item.key);
	
	    if (item.children) {
	      keys = [].concat(_toConsumableArray(keys), _toConsumableArray(getFullKeyListByTreeData(item.children)));
	    }
	  });
	  return keys;
	}

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(117));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _reactLifecyclesCompat = __webpack_require__(9);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(752));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var Editable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Editable, _React$Component);
	
	  var _super = _createSuper(Editable);
	
	  function Editable() {
	    var _this;
	
	    _classCallCheck(this, Editable);
	
	    _this = _super.apply(this, arguments);
	    _this.inComposition = false;
	    _this.state = {
	      current: ''
	    };
	
	    _this.onChange = function (_ref) {
	      var value = _ref.target.value;
	
	      _this.setState({
	        current: value.replace(/[\r\n]/g, '')
	      });
	    };
	
	    _this.onCompositionStart = function () {
	      _this.inComposition = true;
	    };
	
	    _this.onCompositionEnd = function () {
	      _this.inComposition = false;
	    };
	
	    _this.onKeyDown = function (_ref2) {
	      var keyCode = _ref2.keyCode;
	      // We don't record keyCode when IME is using
	      if (_this.inComposition) return;
	      _this.lastKeyCode = keyCode;
	    };
	
	    _this.onKeyUp = function (_ref3) {
	      var keyCode = _ref3.keyCode,
	          ctrlKey = _ref3.ctrlKey,
	          altKey = _ref3.altKey,
	          metaKey = _ref3.metaKey,
	          shiftKey = _ref3.shiftKey;
	      var onCancel = _this.props.onCancel; // Check if it's a real key
	
	      if (_this.lastKeyCode === keyCode && !_this.inComposition && !ctrlKey && !altKey && !metaKey && !shiftKey) {
	        if (keyCode === _KeyCode["default"].ENTER) {
	          _this.confirmChange();
	        } else if (keyCode === _KeyCode["default"].ESC) {
	          onCancel();
	        }
	      }
	    };
	
	    _this.onBlur = function () {
	      _this.confirmChange();
	    };
	
	    _this.confirmChange = function () {
	      var current = _this.state.current;
	      var onSave = _this.props.onSave;
	      onSave(current.trim());
	    };
	
	    _this.setTextarea = function (textarea) {
	      _this.textarea = textarea;
	    };
	
	    return _this;
	  }
	
	  _createClass(Editable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.textarea && this.textarea.resizableTextArea) {
	        var textArea = this.textarea.resizableTextArea.textArea;
	        textArea.focus();
	        var length = textArea.value.length;
	        textArea.setSelectionRange(length, length);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var current = this.state.current;
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          ariaLabel = _this$props['aria-label'],
	          className = _this$props.className,
	          style = _this$props.style;
	      return (/*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-edit-content"), className),
	          style: style
	        }, /*#__PURE__*/React.createElement(_TextArea["default"], {
	          ref: this.setTextarea,
	          value: current,
	          onChange: this.onChange,
	          onKeyDown: this.onKeyDown,
	          onKeyUp: this.onKeyUp,
	          onCompositionStart: this.onCompositionStart,
	          onCompositionEnd: this.onCompositionEnd,
	          onBlur: this.onBlur,
	          "aria-label": ariaLabel,
	          autoSize: true
	        }), /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "enter",
	          className: "".concat(prefixCls, "-edit-content-confirm")
	        }))
	      );
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevValue = prevState.prevValue;
	      var value = nextProps.value;
	      var newState = {
	        prevValue: value
	      };
	
	      if (prevValue !== value) {
	        newState.current = value;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Editable;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(Editable);
	var _default = Editable;
	exports["default"] = _default;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _Base = _interopRequireDefault(__webpack_require__(388));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var Paragraph = function Paragraph(props) {
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, props, {
	      component: "div"
	    }))
	  );
	};
	
	var _default = Paragraph;
	exports["default"] = _default;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _warning = _interopRequireDefault(__webpack_require__(38));
	
	var _Base = _interopRequireDefault(__webpack_require__(388));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Text = function Text(_a) {
	  var ellipsis = _a.ellipsis,
	      restProps = __rest(_a, ["ellipsis"]);
	
	  (0, _warning["default"])(_typeof(ellipsis) !== 'object', 'Typography.Text', '`ellipsis` only supports boolean value.');
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, restProps, {
	      ellipsis: !!ellipsis,
	      component: "span"
	    }))
	  );
	};
	
	var _default = Text;
	exports["default"] = _default;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _warning = _interopRequireDefault(__webpack_require__(495));
	
	var _Base = _interopRequireDefault(__webpack_require__(388));
	
	var _type = __webpack_require__(83);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TITLE_ELE_LIST = (0, _type.tupleNum)(1, 2, 3, 4);
	
	var Title = function Title(props) {
	  var _props$level = props.level,
	      level = _props$level === void 0 ? 1 : _props$level,
	      restProps = __rest(props, ["level"]);
	
	  var component;
	
	  if (TITLE_ELE_LIST.indexOf(level) !== -1) {
	    component = "h".concat(level);
	  } else {
	    (0, _warning["default"])(false, 'Title only accept `1 | 2 | 3 | 4` as `level` value.');
	    component = 'h1';
	  }
	
	  return (/*#__PURE__*/React.createElement(_Base["default"], _extends({}, restProps, {
	      component: component
	    }))
	  );
	};
	
	var _default = Title;
	exports["default"] = _default;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Typography = _interopRequireDefault(__webpack_require__(765));
	
	var _Text = _interopRequireDefault(__webpack_require__(1473));
	
	var _Title = _interopRequireDefault(__webpack_require__(1474));
	
	var _Paragraph = _interopRequireDefault(__webpack_require__(1472));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var Typography = _Typography["default"];
	Typography.Text = _Text["default"];
	Typography.Title = _Title["default"];
	Typography.Paragraph = _Paragraph["default"];
	var _default = Typography;
	exports["default"] = _default;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactDom = __webpack_require__(84);
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _toArray = _interopRequireDefault(__webpack_require__(91));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	// We only handle element & text node.
	var ELEMENT_NODE = 1;
	var TEXT_NODE = 3;
	var COMMENT_NODE = 8;
	var ellipsisContainer;
	var wrapperStyle = {
	  padding: 0,
	  margin: 0,
	  display: 'inline',
	  lineHeight: 'inherit'
	};
	
	function pxToNumber(value) {
	  if (!value) return 0;
	  var match = value.match(/^\d*(\.\d*)?/);
	  return match ? Number(match[0]) : 0;
	}
	
	function styleToString(style) {
	  // There are some different behavior between Firefox & Chrome.
	  // We have to handle this ourself.
	  var styleNames = Array.prototype.slice.apply(style);
	  return styleNames.map(function (name) {
	    return "".concat(name, ": ").concat(style.getPropertyValue(name), ";");
	  }).join('');
	}
	
	function mergeChildren(children) {
	  var childList = [];
	  children.forEach(function (child) {
	    var prevChild = childList[childList.length - 1];
	
	    if (typeof child === 'string' && typeof prevChild === 'string') {
	      childList[childList.length - 1] += child;
	    } else {
	      childList.push(child);
	    }
	  });
	  return childList;
	}
	
	var _default = function _default(originEle, rows, content, fixedContent, ellipsisStr) {
	  if (!ellipsisContainer) {
	    ellipsisContainer = document.createElement('div');
	    ellipsisContainer.setAttribute('aria-hidden', 'true');
	    document.body.appendChild(ellipsisContainer);
	  } // Get origin style
	
	
	  var originStyle = window.getComputedStyle(originEle);
	  var originCSS = styleToString(originStyle);
	  var lineHeight = pxToNumber(originStyle.lineHeight);
	  var maxHeight = lineHeight * (rows + 1) + pxToNumber(originStyle.paddingTop) + pxToNumber(originStyle.paddingBottom); // Set shadow
	
	  ellipsisContainer.setAttribute('style', originCSS);
	  ellipsisContainer.style.position = 'fixed';
	  ellipsisContainer.style.left = '0';
	  ellipsisContainer.style.height = 'auto';
	  ellipsisContainer.style.minHeight = 'auto';
	  ellipsisContainer.style.maxHeight = 'auto';
	  ellipsisContainer.style.top = '-999999px';
	  ellipsisContainer.style.zIndex = '-1000'; // clean up css overflow
	
	  ellipsisContainer.style.textOverflow = 'clip';
	  ellipsisContainer.style.whiteSpace = 'normal';
	  ellipsisContainer.style.webkitLineClamp = 'none'; // Render in the fake container
	
	  var contentList = mergeChildren((0, _toArray["default"])(content));
	  (0, _reactDom.render)( /*#__PURE__*/React.createElement("div", {
	    style: wrapperStyle
	  }, /*#__PURE__*/React.createElement("span", {
	    style: wrapperStyle
	  }, contentList), /*#__PURE__*/React.createElement("span", {
	    style: wrapperStyle
	  }, fixedContent)), ellipsisContainer); // wrap in an div for old version react
	  // Check if ellipsis in measure div is height enough for content
	
	  function inRange() {
	    return ellipsisContainer.offsetHeight < maxHeight;
	  } // Skip ellipsis if already match
	
	
	  if (inRange()) {
	    (0, _reactDom.unmountComponentAtNode)(ellipsisContainer);
	    return {
	      content: content,
	      text: ellipsisContainer.innerHTML,
	      ellipsis: false
	    };
	  } // We should clone the childNode since they're controlled by React and we can't reuse it without warning
	
	
	  var childNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[0].cloneNode(true).childNodes).filter(function (_ref) {
	    var nodeType = _ref.nodeType;
	    return nodeType !== COMMENT_NODE;
	  });
	  var fixedNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[1].cloneNode(true).childNodes);
	  (0, _reactDom.unmountComponentAtNode)(ellipsisContainer); // ========================= Find match ellipsis content =========================
	
	  var ellipsisChildren = [];
	  ellipsisContainer.innerHTML = ''; // Create origin content holder
	
	  var ellipsisContentHolder = document.createElement('span');
	  ellipsisContainer.appendChild(ellipsisContentHolder);
	  var ellipsisTextNode = document.createTextNode(ellipsisStr);
	  ellipsisContentHolder.appendChild(ellipsisTextNode);
	  fixedNodes.forEach(function (childNode) {
	    ellipsisContainer.appendChild(childNode);
	  }); // Append before fixed nodes
	
	  function appendChildNode(node) {
	    ellipsisContentHolder.insertBefore(node, ellipsisTextNode);
	  } // Get maximum text
	
	
	  function measureText(textNode, fullText) {
	    var startLoc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var endLoc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : fullText.length;
	    var lastSuccessLoc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	    var midLoc = Math.floor((startLoc + endLoc) / 2);
	    var currentText = fullText.slice(0, midLoc);
	    textNode.textContent = currentText;
	
	    if (startLoc >= endLoc - 1) {
	      // Loop when step is small
	      for (var step = endLoc; step >= startLoc; step -= 1) {
	        var currentStepText = fullText.slice(0, step);
	        textNode.textContent = currentStepText;
	
	        if (inRange()) {
	          return step === fullText.length ? {
	            finished: false,
	            reactNode: fullText
	          } : {
	            finished: true,
	            reactNode: currentStepText
	          };
	        }
	      }
	    }
	
	    if (inRange()) {
	      return measureText(textNode, fullText, midLoc, endLoc, midLoc);
	    }
	
	    return measureText(textNode, fullText, startLoc, midLoc, lastSuccessLoc);
	  }
	
	  function measureNode(childNode, index) {
	    var type = childNode.nodeType;
	
	    if (type === ELEMENT_NODE) {
	      // We don't split element, it will keep if whole element can be displayed.
	      appendChildNode(childNode);
	
	      if (inRange()) {
	        return {
	          finished: false,
	          reactNode: contentList[index]
	        };
	      } // Clean up if can not pull in
	
	
	      ellipsisContentHolder.removeChild(childNode);
	      return {
	        finished: true,
	        reactNode: null
	      };
	    }
	
	    if (type === TEXT_NODE) {
	      var fullText = childNode.textContent || '';
	      var textNode = document.createTextNode(fullText);
	      appendChildNode(textNode);
	      return measureText(textNode, fullText);
	    } // Not handle other type of content
	    // PS: This code should not be attached after react 16
	
	
	    return {
	      finished: false,
	      reactNode: null
	    };
	  }
	
	  childNodes.some(function (childNode, index) {
	    var _measureNode = measureNode(childNode, index),
	        finished = _measureNode.finished,
	        reactNode = _measureNode.reactNode;
	
	    if (reactNode) {
	      ellipsisChildren.push(reactNode);
	    }
	
	    return finished;
	  });
	  return {
	    content: ellipsisChildren,
	    text: ellipsisContainer.innerHTML,
	    ellipsis: true
	  };
	};
	
	exports["default"] = _default;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _Upload = _interopRequireDefault(__webpack_require__(766));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// stick class comoponent to avoid React ref warning inside Form
	// https://github.com/ant-design/ant-design/issues/18707
	// eslint-disable-next-line react/prefer-stateless-function
	var Dragger = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dragger, _React$Component);
	
	  var _super = _createSuper(Dragger);
	
	  function Dragger() {
	    _classCallCheck(this, Dragger);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dragger, [{
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          style = _a.style,
	          height = _a.height,
	          restProps = __rest(_a, ["style", "height"]);
	
	      return (/*#__PURE__*/React.createElement(_Upload["default"], _extends({}, restProps, {
	          type: "drag",
	          style: _extends(_extends({}, style), {
	            height: height
	          })
	        }))
	      );
	    }
	  }]);
	
	  return Dragger;
	}(React.Component);
	
	exports["default"] = Dragger;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(3));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(68));
	
	var _classnames = _interopRequireDefault(__webpack_require__(11));
	
	var _utils = __webpack_require__(767);
	
	var _icon = _interopRequireDefault(__webpack_require__(23));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(126));
	
	var _progress = _interopRequireDefault(__webpack_require__(756));
	
	var _configProvider = __webpack_require__(15);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return { "default": obj };
	  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }newObj["default"] = obj;if (cache) {
	    cache.set(obj, newObj);
	  }return newObj;
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	    };
	  }return _typeof(obj);
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;return o;
	  };return _setPrototypeOf(o, p);
	}
	
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }return _possibleConstructorReturn(this, result);
	  };
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }return _assertThisInitialized(self);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return self;
	}
	
	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };return _getPrototypeOf(o);
	}
	
	var UploadList = /*#__PURE__*/function (_React$Component) {
	  _inherits(UploadList, _React$Component);
	
	  var _super = _createSuper(UploadList);
	
	  function UploadList() {
	    var _this;
	
	    _classCallCheck(this, UploadList);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handlePreview = function (file, e) {
	      var onPreview = _this.props.onPreview;
	
	      if (!onPreview) {
	        return;
	      }
	
	      e.preventDefault();
	      return onPreview(file);
	    };
	
	    _this.handleDownload = function (file) {
	      var onDownload = _this.props.onDownload;
	
	      if (typeof onDownload === 'function') {
	        onDownload(file);
	      } else if (file.url) {
	        window.open(file.url);
	      }
	    };
	
	    _this.handleClose = function (file) {
	      var onRemove = _this.props.onRemove;
	
	      if (onRemove) {
	        onRemove(file);
	      }
	    };
	
	    _this.renderUploadList = function (_ref) {
	      var _classNames4;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$items = _this$props.items,
	          items = _this$props$items === void 0 ? [] : _this$props$items,
	          listType = _this$props.listType,
	          showPreviewIcon = _this$props.showPreviewIcon,
	          showRemoveIcon = _this$props.showRemoveIcon,
	          showDownloadIcon = _this$props.showDownloadIcon,
	          locale = _this$props.locale,
	          progressAttr = _this$props.progressAttr;
	      var prefixCls = getPrefixCls('upload', customizePrefixCls);
	      var list = items.map(function (file) {
	        var _classNames, _classNames2;
	
	        var progress;
	        var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: file.status === 'uploading' ? 'loading' : 'paper-clip'
	        });
	
	        if (listType === 'picture' || listType === 'picture-card') {
	          if (listType === 'picture-card' && file.status === 'uploading') {
	            icon = /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-list-item-uploading-text")
	            }, locale.uploading);
	          } else if (!file.thumbUrl && !file.url) {
	            icon = /*#__PURE__*/React.createElement(_icon["default"], {
	              className: "".concat(prefixCls, "-list-item-thumbnail"),
	              type: "picture",
	              theme: "twoTone"
	            });
	          } else {
	            var thumbnail = (0, _utils.isImageUrl)(file) ? /*#__PURE__*/React.createElement("img", {
	              src: file.thumbUrl || file.url,
	              alt: file.name,
	              className: "".concat(prefixCls, "-list-item-image")
	            }) : /*#__PURE__*/React.createElement(_icon["default"], {
	              type: "file",
	              className: "".concat(prefixCls, "-list-item-icon"),
	              theme: "twoTone"
	            });
	            icon = /*#__PURE__*/React.createElement("a", {
	              className: "".concat(prefixCls, "-list-item-thumbnail"),
	              onClick: function onClick(e) {
	                return _this.handlePreview(file, e);
	              },
	              href: file.url || file.thumbUrl,
	              target: "_blank",
	              rel: "noopener noreferrer"
	            }, thumbnail);
	          }
	        }
	
	        if (file.status === 'uploading') {
	          // show loading icon if upload progress listener is disabled
	          var loadingProgress = 'percent' in file ? /*#__PURE__*/React.createElement(_progress["default"], _extends({
	            type: "line"
	          }, progressAttr, {
	            percent: file.percent
	          })) : null;
	          progress = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-list-item-progress"),
	            key: "progress"
	          }, loadingProgress);
	        }
	
	        var infoUploadingClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-list-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-").concat(file.status), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames));
	        var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
	        var removeIcon = showRemoveIcon ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "delete",
	          title: locale.removeFile,
	          onClick: function onClick() {
	            return _this.handleClose(file);
	          }
	        }) : null;
	        var downloadIcon = showDownloadIcon && file.status === 'done' ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "download",
	          title: locale.downloadFile,
	          onClick: function onClick() {
	            return _this.handleDownload(file);
	          }
	        }) : null;
	        var downloadOrDelete = listType !== 'picture-card' && /*#__PURE__*/React.createElement("span", {
	          key: "download-delete",
	          className: "".concat(prefixCls, "-list-item-card-actions ").concat(listType === 'picture' ? 'picture' : '')
	        }, downloadIcon && /*#__PURE__*/React.createElement("a", {
	          title: locale.downloadFile
	        }, downloadIcon), removeIcon && /*#__PURE__*/React.createElement("a", {
	          title: locale.removeFile
	        }, removeIcon));
	        var listItemNameClass = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name-icon-count-").concat([downloadIcon, removeIcon].filter(function (x) {
	          return x;
	        }).length), true), _classNames2));
	        var preview = file.url ? [/*#__PURE__*/React.createElement("a", _extends({
	          key: "view",
	          target: "_blank",
	          rel: "noopener noreferrer",
	          className: listItemNameClass,
	          title: file.name
	        }, linkProps, {
	          href: file.url,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          }
	        }), file.name), downloadOrDelete] : [/*#__PURE__*/React.createElement("span", {
	          key: "view",
	          className: listItemNameClass,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          },
	          title: file.name
	        }, file.name), downloadOrDelete];
	        var style = {
	          pointerEvents: 'none',
	          opacity: 0.5
	        };
	        var previewIcon = showPreviewIcon ? /*#__PURE__*/React.createElement("a", {
	          href: file.url || file.thumbUrl,
	          target: "_blank",
	          rel: "noopener noreferrer",
	          style: file.url || file.thumbUrl ? undefined : style,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          },
	          title: locale.previewFile
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "eye-o"
	        })) : null;
	        var actions = listType === 'picture-card' && file.status !== 'uploading' && /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-list-item-actions")
	        }, previewIcon, file.status === 'done' && downloadIcon, removeIcon);
	        var message;
	
	        if (file.response && typeof file.response === 'string') {
	          message = file.response;
	        } else {
	          message = file.error && file.error.statusText || locale.uploadError;
	        }
	
	        var iconAndPreview = /*#__PURE__*/React.createElement("span", null, icon, preview);
	        var dom = /*#__PURE__*/React.createElement("div", {
	          className: infoUploadingClass
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-list-item-info")
	        }, iconAndPreview), actions, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "fade",
	          component: ""
	        }, progress));
	        var listContainerNameClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-list-picture-card-container"), listType === 'picture-card'));
	        return (/*#__PURE__*/React.createElement("div", {
	            key: file.uid,
	            className: listContainerNameClass
	          }, file.status === 'error' ? /*#__PURE__*/React.createElement(_tooltip["default"], {
	            title: message
	          }, dom) : /*#__PURE__*/React.createElement("span", null, dom))
	        );
	      });
	      var listClassNames = (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-list"), true), _defineProperty(_classNames4, "".concat(prefixCls, "-list-").concat(listType), true), _classNames4));
	      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
	      return (/*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "".concat(prefixCls, "-").concat(animationDirection),
	          component: "div",
	          className: listClassNames
	        }, list)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(UploadList, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          listType = _this$props2.listType,
	          items = _this$props2.items,
	          previewFile = _this$props2.previewFile;
	
	      if (listType !== 'picture' && listType !== 'picture-card') {
	        return;
	      }
	
	      (items || []).forEach(function (file) {
	        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
	          return;
	        }
	
	        file.thumbUrl = '';
	
	        if (previewFile) {
	          previewFile(file.originFileObj).then(function (previewDataUrl) {
	            // Need append '' to avoid dead loop
	            file.thumbUrl = previewDataUrl || '';
	
	            _this2.forceUpdate();
	          });
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return (/*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUploadList)
	      );
	    }
	  }]);
	
	  return UploadList;
	}(React.Component);
	
	exports["default"] = UploadList;
	UploadList.defaultProps = {
	  listType: 'text',
	  progressAttr: {
	    strokeWidth: 2,
	    showInfo: false
	  },
	  showRemoveIcon: true,
	  showDownloadIcon: false,
	  showPreviewIcon: true,
	  previewFile: _utils.previewImage
	};

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Upload = _interopRequireDefault(__webpack_require__(766));
	
	var _Dragger = _interopRequireDefault(__webpack_require__(1477));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	_Upload["default"].Dragger = _Dragger["default"];
	var _default = _Upload["default"];
	exports["default"] = _default;

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _package = _interopRequireDefault({ version: '3.26.20' });
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { "default": obj };
	}
	
	var _default = _package["default"].version;
	exports["default"] = _default;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var defaults = {
	    pairs: "()[]{}''\"\"",
	    closeBefore: ")]}'\":;>",
	    triples: "",
	    explode: "[]{}"
	  };
	
	  var Pos = CodeMirror.Pos;
	
	  CodeMirror.defineOption("autoCloseBrackets", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.removeKeyMap(keyMap);
	      cm.state.closeBrackets = null;
	    }
	    if (val) {
	      ensureBound(getOption(val, "pairs"));
	      cm.state.closeBrackets = val;
	      cm.addKeyMap(keyMap);
	    }
	  });
	
	  function getOption(conf, name) {
	    if (name == "pairs" && typeof conf == "string") return conf;
	    if ((typeof conf === "undefined" ? "undefined" : _typeof(conf)) == "object" && conf[name] != null) return conf[name];
	    return defaults[name];
	  }
	
	  var keyMap = { Backspace: handleBackspace, Enter: handleEnter };
	  function ensureBound(chars) {
	    for (var i = 0; i < chars.length; i++) {
	      var ch = chars.charAt(i),
	          key = "'" + ch + "'";
	      if (!keyMap[key]) keyMap[key] = handler(ch);
	    }
	  }
	  ensureBound(defaults.pairs + "`");
	
	  function handler(ch) {
	    return function (cm) {
	      return handleChar(cm, ch);
	    };
	  }
	
	  function getConfig(cm) {
	    var deflt = cm.state.closeBrackets;
	    if (!deflt || deflt.override) return deflt;
	    var mode = cm.getModeAt(cm.getCursor());
	    return mode.closeBrackets || deflt;
	  }
	
	  function handleBackspace(cm) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || pairs.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    for (var i = ranges.length - 1; i >= 0; i--) {
	      var cur = ranges[i].head;
	      cm.replaceRange("", Pos(cur.line, cur.ch - 1), Pos(cur.line, cur.ch + 1), "+delete");
	    }
	  }
	
	  function handleEnter(cm) {
	    var conf = getConfig(cm);
	    var explode = conf && getOption(conf, "explode");
	    if (!explode || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) return CodeMirror.Pass;
	      var around = charsAround(cm, ranges[i].head);
	      if (!around || explode.indexOf(around) % 2 != 0) return CodeMirror.Pass;
	    }
	    cm.operation(function () {
	      var linesep = cm.lineSeparator() || "\n";
	      cm.replaceSelection(linesep + linesep, null);
	      moveSel(cm, -1);
	      ranges = cm.listSelections();
	      for (var i = 0; i < ranges.length; i++) {
	        var line = ranges[i].head.line;
	        cm.indentLine(line, null, true);
	        cm.indentLine(line + 1, null, true);
	      }
	    });
	  }
	
	  function moveSel(cm, dir) {
	    var newRanges = [],
	        ranges = cm.listSelections(),
	        primary = 0;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      if (range.head == cm.getCursor()) primary = i;
	      var pos = range.head.ch || dir > 0 ? { line: range.head.line, ch: range.head.ch + dir } : { line: range.head.line - 1 };
	      newRanges.push({ anchor: pos, head: pos });
	    }
	    cm.setSelections(newRanges, primary);
	  }
	
	  function contractSelection(sel) {
	    var inverted = CodeMirror.cmpPos(sel.anchor, sel.head) > 0;
	    return { anchor: new Pos(sel.anchor.line, sel.anchor.ch + (inverted ? -1 : 1)),
	      head: new Pos(sel.head.line, sel.head.ch + (inverted ? 1 : -1)) };
	  }
	
	  function handleChar(cm, ch) {
	    var conf = getConfig(cm);
	    if (!conf || cm.getOption("disableInput")) return CodeMirror.Pass;
	
	    var pairs = getOption(conf, "pairs");
	    var pos = pairs.indexOf(ch);
	    if (pos == -1) return CodeMirror.Pass;
	
	    var closeBefore = getOption(conf, "closeBefore");
	
	    var triples = getOption(conf, "triples");
	
	    var identical = pairs.charAt(pos + 1) == ch;
	    var ranges = cm.listSelections();
	    var opening = pos % 2 == 0;
	
	    var type;
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i],
	          cur = range.head,
	          curType;
	      var next = cm.getRange(cur, Pos(cur.line, cur.ch + 1));
	      if (opening && !range.empty()) {
	        curType = "surround";
	      } else if ((identical || !opening) && next == ch) {
	        if (identical && stringStartsAfter(cm, cur)) curType = "both";else if (triples.indexOf(ch) >= 0 && cm.getRange(cur, Pos(cur.line, cur.ch + 3)) == ch + ch + ch) curType = "skipThree";else curType = "skip";
	      } else if (identical && cur.ch > 1 && triples.indexOf(ch) >= 0 && cm.getRange(Pos(cur.line, cur.ch - 2), cur) == ch + ch) {
	        if (cur.ch > 2 && /\bstring/.test(cm.getTokenTypeAt(Pos(cur.line, cur.ch - 2)))) return CodeMirror.Pass;
	        curType = "addFour";
	      } else if (identical) {
	        var prev = cur.ch == 0 ? " " : cm.getRange(Pos(cur.line, cur.ch - 1), cur);
	        if (!CodeMirror.isWordChar(next) && prev != ch && !CodeMirror.isWordChar(prev)) curType = "both";else return CodeMirror.Pass;
	      } else if (opening && (next.length === 0 || /\s/.test(next) || closeBefore.indexOf(next) > -1)) {
	        curType = "both";
	      } else {
	        return CodeMirror.Pass;
	      }
	      if (!type) type = curType;else if (type != curType) return CodeMirror.Pass;
	    }
	
	    var left = pos % 2 ? pairs.charAt(pos - 1) : ch;
	    var right = pos % 2 ? ch : pairs.charAt(pos + 1);
	    cm.operation(function () {
	      if (type == "skip") {
	        moveSel(cm, 1);
	      } else if (type == "skipThree") {
	        moveSel(cm, 3);
	      } else if (type == "surround") {
	        var sels = cm.getSelections();
	        for (var i = 0; i < sels.length; i++) {
	          sels[i] = left + sels[i] + right;
	        }cm.replaceSelections(sels, "around");
	        sels = cm.listSelections().slice();
	        for (var i = 0; i < sels.length; i++) {
	          sels[i] = contractSelection(sels[i]);
	        }cm.setSelections(sels);
	      } else if (type == "both") {
	        cm.replaceSelection(left + right, null);
	        cm.triggerElectric(left + right);
	        moveSel(cm, -1);
	      } else if (type == "addFour") {
	        cm.replaceSelection(left + left + left + left, "before");
	        moveSel(cm, 1);
	      }
	    });
	  }
	
	  function charsAround(cm, pos) {
	    var str = cm.getRange(Pos(pos.line, pos.ch - 1), Pos(pos.line, pos.ch + 1));
	    return str.length == 2 ? str : null;
	  }
	
	  function stringStartsAfter(cm, pos) {
	    var token = cm.getTokenAt(Pos(pos.line, pos.ch + 1));
	    return (/\bstring/.test(token.type) && token.start == pos.ch && (pos.ch == 0 || !/\bstring/.test(cm.getTokenTypeAt(pos)))
	    );
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var ie_lt8 = /MSIE \d/.test(navigator.userAgent) && (document.documentMode == null || document.documentMode < 8);
	
	  var Pos = CodeMirror.Pos;
	
	  var matching = { "(": ")>", ")": "(<", "[": "]>", "]": "[<", "{": "}>", "}": "{<", "<": ">>", ">": "<<" };
	
	  function bracketRegex(config) {
	    return config && config.bracketRegex || /[(){}[\]]/;
	  }
	
	  function findMatchingBracket(cm, where, config) {
	    var line = cm.getLineHandle(where.line),
	        pos = where.ch - 1;
	    var afterCursor = config && config.afterCursor;
	    if (afterCursor == null) afterCursor = /(^| )cm-fat-cursor($| )/.test(cm.getWrapperElement().className);
	    var re = bracketRegex(config);
	
	    // A cursor is defined as between two characters, but in vim command mode
	    // (i.e. not insert mode), the cursor is visually represented as a
	    // highlighted box on top of the 2nd character. Otherwise, we allow matches
	    // from before or after the cursor.
	    var match = !afterCursor && pos >= 0 && re.test(line.text.charAt(pos)) && matching[line.text.charAt(pos)] || re.test(line.text.charAt(pos + 1)) && matching[line.text.charAt(++pos)];
	    if (!match) return null;
	    var dir = match.charAt(1) == ">" ? 1 : -1;
	    if (config && config.strict && dir > 0 != (pos == where.ch)) return null;
	    var style = cm.getTokenTypeAt(Pos(where.line, pos + 1));
	
	    var found = scanForBracket(cm, Pos(where.line, pos + (dir > 0 ? 1 : 0)), dir, style, config);
	    if (found == null) return null;
	    return { from: Pos(where.line, pos), to: found && found.pos,
	      match: found && found.ch == match.charAt(0), forward: dir > 0 };
	  }
	
	  // bracketRegex is used to specify which type of bracket to scan
	  // should be a regexp, e.g. /[[\]]/
	  //
	  // Note: If "where" is on an open bracket, then this bracket is ignored.
	  //
	  // Returns false when no bracket was found, null when it reached
	  // maxScanLines and gave up
	  function scanForBracket(cm, where, dir, style, config) {
	    var maxScanLen = config && config.maxScanLineLength || 10000;
	    var maxScanLines = config && config.maxScanLines || 1000;
	
	    var stack = [];
	    var re = bracketRegex(config);
	    var lineEnd = dir > 0 ? Math.min(where.line + maxScanLines, cm.lastLine() + 1) : Math.max(cm.firstLine() - 1, where.line - maxScanLines);
	    for (var lineNo = where.line; lineNo != lineEnd; lineNo += dir) {
	      var line = cm.getLine(lineNo);
	      if (!line) continue;
	      var pos = dir > 0 ? 0 : line.length - 1,
	          end = dir > 0 ? line.length : -1;
	      if (line.length > maxScanLen) continue;
	      if (lineNo == where.line) pos = where.ch - (dir < 0 ? 1 : 0);
	      for (; pos != end; pos += dir) {
	        var ch = line.charAt(pos);
	        if (re.test(ch) && (style === undefined || (cm.getTokenTypeAt(Pos(lineNo, pos + 1)) || "") == (style || ""))) {
	          var match = matching[ch];
	          if (match && match.charAt(1) == ">" == dir > 0) stack.push(ch);else if (!stack.length) return { pos: Pos(lineNo, pos), ch: ch };else stack.pop();
	        }
	      }
	    }
	    return lineNo - dir == (dir > 0 ? cm.lastLine() : cm.firstLine()) ? false : null;
	  }
	
	  function matchBrackets(cm, autoclear, config) {
	    // Disable brace matching in long lines, since it'll cause hugely slow updates
	    var maxHighlightLen = cm.state.matchBrackets.maxHighlightLineLength || 1000,
	        highlightNonMatching = config && config.highlightNonMatching;
	    var marks = [],
	        ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      var match = ranges[i].empty() && findMatchingBracket(cm, ranges[i].head, config);
	      if (match && (match.match || highlightNonMatching !== false) && cm.getLine(match.from.line).length <= maxHighlightLen) {
	        var style = match.match ? "CodeMirror-matchingbracket" : "CodeMirror-nonmatchingbracket";
	        marks.push(cm.markText(match.from, Pos(match.from.line, match.from.ch + 1), { className: style }));
	        if (match.to && cm.getLine(match.to.line).length <= maxHighlightLen) marks.push(cm.markText(match.to, Pos(match.to.line, match.to.ch + 1), { className: style }));
	      }
	    }
	
	    if (marks.length) {
	      // Kludge to work around the IE bug from issue #1193, where text
	      // input stops going to the textarea whenever this fires.
	      if (ie_lt8 && cm.state.focused) cm.focus();
	
	      var clear = function clear() {
	        cm.operation(function () {
	          for (var i = 0; i < marks.length; i++) {
	            marks[i].clear();
	          }
	        });
	      };
	      if (autoclear) setTimeout(clear, 800);else return clear;
	    }
	  }
	
	  function doMatchBrackets(cm) {
	    cm.operation(function () {
	      if (cm.state.matchBrackets.currentlyHighlighted) {
	        cm.state.matchBrackets.currentlyHighlighted();
	        cm.state.matchBrackets.currentlyHighlighted = null;
	      }
	      cm.state.matchBrackets.currentlyHighlighted = matchBrackets(cm, false, cm.state.matchBrackets);
	    });
	  }
	
	  function clearHighlighted(cm) {
	    if (cm.state.matchBrackets && cm.state.matchBrackets.currentlyHighlighted) {
	      cm.state.matchBrackets.currentlyHighlighted();
	      cm.state.matchBrackets.currentlyHighlighted = null;
	    }
	  }
	
	  CodeMirror.defineOption("matchBrackets", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.off("cursorActivity", doMatchBrackets);
	      cm.off("focus", doMatchBrackets);
	      cm.off("blur", clearHighlighted);
	      clearHighlighted(cm);
	    }
	    if (val) {
	      cm.state.matchBrackets = (typeof val === "undefined" ? "undefined" : _typeof(val)) == "object" ? val : {};
	      cm.on("cursorActivity", doMatchBrackets);
	      cm.on("focus", doMatchBrackets);
	      cm.on("blur", clearHighlighted);
	    }
	  });
	
	  CodeMirror.defineExtension("matchBrackets", function () {
	    matchBrackets(this, true);
	  });
	  CodeMirror.defineExtension("findMatchingBracket", function (pos, config, oldConfig) {
	    // Backwards-compatibility kludge
	    if (oldConfig || typeof config == "boolean") {
	      if (!oldConfig) {
	        config = config ? { strict: true } : null;
	      } else {
	        oldConfig.strict = config;
	        config = oldConfig;
	      }
	    }
	    return findMatchingBracket(this, pos, config);
	  });
	  CodeMirror.defineExtension("scanForBracket", function (pos, dir, style, config) {
	    return scanForBracket(this, pos, dir, style, config);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  function bracketFolding(pairs) {
	    return function (cm, start) {
	      var line = start.line,
	          lineText = cm.getLine(line);
	
	      function findOpening(pair) {
	        var tokenType;
	        for (var at = start.ch, pass = 0;;) {
	          var found = at <= 0 ? -1 : lineText.lastIndexOf(pair[0], at - 1);
	          if (found == -1) {
	            if (pass == 1) break;
	            pass = 1;
	            at = lineText.length;
	            continue;
	          }
	          if (pass == 1 && found < start.ch) break;
	          tokenType = cm.getTokenTypeAt(CodeMirror.Pos(line, found + 1));
	          if (!/^(comment|string)/.test(tokenType)) return { ch: found + 1, tokenType: tokenType, pair: pair };
	          at = found - 1;
	        }
	      }
	
	      function findRange(found) {
	        var count = 1,
	            lastLine = cm.lastLine(),
	            end,
	            startCh = found.ch,
	            endCh;
	        outer: for (var i = line; i <= lastLine; ++i) {
	          var text = cm.getLine(i),
	              pos = i == line ? startCh : 0;
	          for (;;) {
	            var nextOpen = text.indexOf(found.pair[0], pos),
	                nextClose = text.indexOf(found.pair[1], pos);
	            if (nextOpen < 0) nextOpen = text.length;
	            if (nextClose < 0) nextClose = text.length;
	            pos = Math.min(nextOpen, nextClose);
	            if (pos == text.length) break;
	            if (cm.getTokenTypeAt(CodeMirror.Pos(i, pos + 1)) == found.tokenType) {
	              if (pos == nextOpen) ++count;else if (! --count) {
	                end = i;endCh = pos;break outer;
	              }
	            }
	            ++pos;
	          }
	        }
	
	        if (end == null || line == end) return null;
	        return { from: CodeMirror.Pos(line, startCh),
	          to: CodeMirror.Pos(end, endCh) };
	      }
	
	      var found = [];
	      for (var i = 0; i < pairs.length; i++) {
	        var open = findOpening(pairs[i]);
	        if (open) found.push(open);
	      }
	      found.sort(function (a, b) {
	        return a.ch - b.ch;
	      });
	      for (var i = 0; i < found.length; i++) {
	        var range = findRange(found[i]);
	        if (range) return range;
	      }
	      return null;
	    };
	  }
	
	  CodeMirror.registerHelper("fold", "brace", bracketFolding([["{", "}"], ["[", "]"]]));
	
	  CodeMirror.registerHelper("fold", "brace-paren", bracketFolding([["{", "}"], ["[", "]"], ["(", ")"]]));
	
	  CodeMirror.registerHelper("fold", "import", function (cm, start) {
	    function hasImport(line) {
	      if (line < cm.firstLine() || line > cm.lastLine()) return null;
	      var start = cm.getTokenAt(CodeMirror.Pos(line, 1));
	      if (!/\S/.test(start.string)) start = cm.getTokenAt(CodeMirror.Pos(line, start.end + 1));
	      if (start.type != "keyword" || start.string != "import") return null;
	      // Now find closing semicolon, return its position
	      for (var i = line, e = Math.min(cm.lastLine(), line + 10); i <= e; ++i) {
	        var text = cm.getLine(i),
	            semi = text.indexOf(";");
	        if (semi != -1) return { startCh: start.end, end: CodeMirror.Pos(i, semi) };
	      }
	    }
	
	    var startLine = start.line,
	        has = hasImport(startLine),
	        prev;
	    if (!has || hasImport(startLine - 1) || (prev = hasImport(startLine - 2)) && prev.end.line == startLine - 1) return null;
	    for (var end = has.end;;) {
	      var next = hasImport(end.line + 1);
	      if (next == null) break;
	      end = next.end;
	    }
	    return { from: cm.clipPos(CodeMirror.Pos(startLine, has.startCh + 1)), to: end };
	  });
	
	  CodeMirror.registerHelper("fold", "include", function (cm, start) {
	    function hasInclude(line) {
	      if (line < cm.firstLine() || line > cm.lastLine()) return null;
	      var start = cm.getTokenAt(CodeMirror.Pos(line, 1));
	      if (!/\S/.test(start.string)) start = cm.getTokenAt(CodeMirror.Pos(line, start.end + 1));
	      if (start.type == "meta" && start.string.slice(0, 8) == "#include") return start.start + 8;
	    }
	
	    var startLine = start.line,
	        has = hasInclude(startLine);
	    if (has == null || hasInclude(startLine - 1) != null) return null;
	    for (var end = startLine;;) {
	      var next = hasInclude(end + 1);
	      if (next == null) break;
	      ++end;
	    }
	    return { from: CodeMirror.Pos(startLine, has + 1),
	      to: cm.clipPos(CodeMirror.Pos(end)) };
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.registerGlobalHelper("fold", "comment", function (mode) {
	    return mode.blockCommentStart && mode.blockCommentEnd;
	  }, function (cm, start) {
	    var mode = cm.getModeAt(start),
	        startToken = mode.blockCommentStart,
	        endToken = mode.blockCommentEnd;
	    if (!startToken || !endToken) return;
	    var line = start.line,
	        lineText = cm.getLine(line);
	
	    var startCh;
	    for (var at = start.ch, pass = 0;;) {
	      var found = at <= 0 ? -1 : lineText.lastIndexOf(startToken, at - 1);
	      if (found == -1) {
	        if (pass == 1) return;
	        pass = 1;
	        at = lineText.length;
	        continue;
	      }
	      if (pass == 1 && found < start.ch) return;
	      if (/comment/.test(cm.getTokenTypeAt(CodeMirror.Pos(line, found + 1))) && (found == 0 || lineText.slice(found - endToken.length, found) == endToken || !/comment/.test(cm.getTokenTypeAt(CodeMirror.Pos(line, found))))) {
	        startCh = found + startToken.length;
	        break;
	      }
	      at = found - 1;
	    }
	
	    var depth = 1,
	        lastLine = cm.lastLine(),
	        end,
	        endCh;
	    outer: for (var i = line; i <= lastLine; ++i) {
	      var text = cm.getLine(i),
	          pos = i == line ? startCh : 0;
	      for (;;) {
	        var nextOpen = text.indexOf(startToken, pos),
	            nextClose = text.indexOf(endToken, pos);
	        if (nextOpen < 0) nextOpen = text.length;
	        if (nextClose < 0) nextClose = text.length;
	        pos = Math.min(nextOpen, nextClose);
	        if (pos == text.length) break;
	        if (pos == nextOpen) ++depth;else if (! --depth) {
	          end = i;endCh = pos;break outer;
	        }
	        ++pos;
	      }
	    }
	    if (end == null || line == end && endCh == startCh) return;
	    return { from: CodeMirror.Pos(line, startCh),
	      to: CodeMirror.Pos(end, endCh) };
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41), __webpack_require__(389));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41), __webpack_require__(389)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineOption("foldGutter", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.clearGutter(cm.state.foldGutter.options.gutter);
	      cm.state.foldGutter = null;
	      cm.off("gutterClick", onGutterClick);
	      cm.off("changes", onChange);
	      cm.off("viewportChange", onViewportChange);
	      cm.off("fold", onFold);
	      cm.off("unfold", onFold);
	      cm.off("swapDoc", onChange);
	      cm.off("optionChange", optionChange);
	    }
	    if (val) {
	      cm.state.foldGutter = new State(parseOptions(val));
	      updateInViewport(cm);
	      cm.on("gutterClick", onGutterClick);
	      cm.on("changes", onChange);
	      cm.on("viewportChange", onViewportChange);
	      cm.on("fold", onFold);
	      cm.on("unfold", onFold);
	      cm.on("swapDoc", onChange);
	      cm.on("optionChange", optionChange);
	    }
	  });
	
	  var Pos = CodeMirror.Pos;
	
	  function State(options) {
	    this.options = options;
	    this.from = this.to = 0;
	  }
	
	  function parseOptions(opts) {
	    if (opts === true) opts = {};
	    if (opts.gutter == null) opts.gutter = "CodeMirror-foldgutter";
	    if (opts.indicatorOpen == null) opts.indicatorOpen = "CodeMirror-foldgutter-open";
	    if (opts.indicatorFolded == null) opts.indicatorFolded = "CodeMirror-foldgutter-folded";
	    return opts;
	  }
	
	  function isFolded(cm, line) {
	    var marks = cm.findMarks(Pos(line, 0), Pos(line + 1, 0));
	    for (var i = 0; i < marks.length; ++i) {
	      if (marks[i].__isFold) {
	        var fromPos = marks[i].find(-1);
	        if (fromPos && fromPos.line === line) return marks[i];
	      }
	    }
	  }
	
	  function marker(spec) {
	    if (typeof spec == "string") {
	      var elt = document.createElement("div");
	      elt.className = spec + " CodeMirror-guttermarker-subtle";
	      return elt;
	    } else {
	      return spec.cloneNode(true);
	    }
	  }
	
	  function updateFoldInfo(cm, from, to) {
	    var opts = cm.state.foldGutter.options,
	        cur = from - 1;
	    var minSize = cm.foldOption(opts, "minFoldSize");
	    var func = cm.foldOption(opts, "rangeFinder");
	    // we can reuse the built-in indicator element if its className matches the new state
	    var clsFolded = typeof opts.indicatorFolded == "string" && classTest(opts.indicatorFolded);
	    var clsOpen = typeof opts.indicatorOpen == "string" && classTest(opts.indicatorOpen);
	    cm.eachLine(from, to, function (line) {
	      ++cur;
	      var mark = null;
	      var old = line.gutterMarkers;
	      if (old) old = old[opts.gutter];
	      if (isFolded(cm, cur)) {
	        if (clsFolded && old && clsFolded.test(old.className)) return;
	        mark = marker(opts.indicatorFolded);
	      } else {
	        var pos = Pos(cur, 0);
	        var range = func && func(cm, pos);
	        if (range && range.to.line - range.from.line >= minSize) {
	          if (clsOpen && old && clsOpen.test(old.className)) return;
	          mark = marker(opts.indicatorOpen);
	        }
	      }
	      if (!mark && !old) return;
	      cm.setGutterMarker(line, opts.gutter, mark);
	    });
	  }
	
	  // copied from CodeMirror/src/util/dom.js
	  function classTest(cls) {
	    return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
	  }
	
	  function updateInViewport(cm) {
	    var vp = cm.getViewport(),
	        state = cm.state.foldGutter;
	    if (!state) return;
	    cm.operation(function () {
	      updateFoldInfo(cm, vp.from, vp.to);
	    });
	    state.from = vp.from;state.to = vp.to;
	  }
	
	  function onGutterClick(cm, line, gutter) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    if (gutter != opts.gutter) return;
	    var folded = isFolded(cm, line);
	    if (folded) folded.clear();else cm.foldCode(Pos(line, 0), opts);
	  }
	
	  function optionChange(cm, option) {
	    if (option == "mode") onChange(cm);
	  }
	
	  function onChange(cm) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    state.from = state.to = 0;
	    clearTimeout(state.changeUpdate);
	    state.changeUpdate = setTimeout(function () {
	      updateInViewport(cm);
	    }, opts.foldOnChangeTimeSpan || 600);
	  }
	
	  function onViewportChange(cm) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var opts = state.options;
	    clearTimeout(state.changeUpdate);
	    state.changeUpdate = setTimeout(function () {
	      var vp = cm.getViewport();
	      if (state.from == state.to || vp.from - state.to > 20 || state.from - vp.to > 20) {
	        updateInViewport(cm);
	      } else {
	        cm.operation(function () {
	          if (vp.from < state.from) {
	            updateFoldInfo(cm, vp.from, state.from);
	            state.from = vp.from;
	          }
	          if (vp.to > state.to) {
	            updateFoldInfo(cm, state.to, vp.to);
	            state.to = vp.to;
	          }
	        });
	      }
	    }, opts.updateViewportTimeSpan || 400);
	  }
	
	  function onFold(cm, from) {
	    var state = cm.state.foldGutter;
	    if (!state) return;
	    var line = from.line;
	    if (line >= state.from && line < state.to) updateFoldInfo(cm, line, line + 1);
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  var Pos = CodeMirror.Pos;
	
	  function forEach(arr, f) {
	    for (var i = 0, e = arr.length; i < e; ++i) {
	      f(arr[i]);
	    }
	  }
	
	  function arrayContains(arr, item) {
	    if (!Array.prototype.indexOf) {
	      var i = arr.length;
	      while (i--) {
	        if (arr[i] === item) {
	          return true;
	        }
	      }
	      return false;
	    }
	    return arr.indexOf(item) != -1;
	  }
	
	  function scriptHint(editor, keywords, getToken, options) {
	    // Find the token at the cursor
	    var cur = editor.getCursor(),
	        token = getToken(editor, cur);
	    if (/\b(?:string|comment)\b/.test(token.type)) return;
	    var innerMode = CodeMirror.innerMode(editor.getMode(), token.state);
	    if (innerMode.mode.helperType === "json") return;
	    token.state = innerMode.state;
	
	    // If it's not a 'word-style' token, ignore the token.
	    if (!/^[\w$_]*$/.test(token.string)) {
	      token = { start: cur.ch, end: cur.ch, string: "", state: token.state,
	        type: token.string == "." ? "property" : null };
	    } else if (token.end > cur.ch) {
	      token.end = cur.ch;
	      token.string = token.string.slice(0, cur.ch - token.start);
	    }
	
	    var tprop = token;
	    // If it is a property, find out what it is a property of.
	    while (tprop.type == "property") {
	      tprop = getToken(editor, Pos(cur.line, tprop.start));
	      if (tprop.string != ".") return;
	      tprop = getToken(editor, Pos(cur.line, tprop.start));
	      if (!context) var context = [];
	      context.push(tprop);
	    }
	    return { list: getCompletions(token, context, keywords, options),
	      from: Pos(cur.line, token.start),
	      to: Pos(cur.line, token.end) };
	  }
	
	  function javascriptHint(editor, options) {
	    return scriptHint(editor, javascriptKeywords, function (e, cur) {
	      return e.getTokenAt(cur);
	    }, options);
	  };
	  CodeMirror.registerHelper("hint", "javascript", javascriptHint);
	
	  function getCoffeeScriptToken(editor, cur) {
	    // This getToken, it is for coffeescript, imitates the behavior of
	    // getTokenAt method in javascript.js, that is, returning "property"
	    // type and treat "." as independent token.
	    var token = editor.getTokenAt(cur);
	    if (cur.ch == token.start + 1 && token.string.charAt(0) == '.') {
	      token.end = token.start;
	      token.string = '.';
	      token.type = "property";
	    } else if (/^\.[\w$_]*$/.test(token.string)) {
	      token.type = "property";
	      token.start++;
	      token.string = token.string.replace(/\./, '');
	    }
	    return token;
	  }
	
	  function coffeescriptHint(editor, options) {
	    return scriptHint(editor, coffeescriptKeywords, getCoffeeScriptToken, options);
	  }
	  CodeMirror.registerHelper("hint", "coffeescript", coffeescriptHint);
	
	  var stringProps = ("charAt charCodeAt indexOf lastIndexOf substring substr slice trim trimLeft trimRight " + "toUpperCase toLowerCase split concat match replace search").split(" ");
	  var arrayProps = ("length concat join splice push pop shift unshift slice reverse sort indexOf " + "lastIndexOf every some filter forEach map reduce reduceRight ").split(" ");
	  var funcProps = "prototype apply call bind".split(" ");
	  var javascriptKeywords = ("break case catch class const continue debugger default delete do else export extends false finally for function " + "if in import instanceof new null return super switch this throw true try typeof var void while with yield").split(" ");
	  var coffeescriptKeywords = ("and break catch class continue delete do else extends false finally for " + "if in instanceof isnt new no not null of off on or return switch then throw true try typeof until void while with yes").split(" ");
	
	  function forAllProps(obj, callback) {
	    if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
	      for (var name in obj) {
	        callback(name);
	      }
	    } else {
	      for (var o = obj; o; o = Object.getPrototypeOf(o)) {
	        Object.getOwnPropertyNames(o).forEach(callback);
	      }
	    }
	  }
	
	  function getCompletions(token, context, keywords, options) {
	    var found = [],
	        start = token.string,
	        global = options && options.globalScope || window;
	    function maybeAdd(str) {
	      if (str.lastIndexOf(start, 0) == 0 && !arrayContains(found, str)) found.push(str);
	    }
	    function gatherCompletions(obj) {
	      if (typeof obj == "string") forEach(stringProps, maybeAdd);else if (obj instanceof Array) forEach(arrayProps, maybeAdd);else if (obj instanceof Function) forEach(funcProps, maybeAdd);
	      forAllProps(obj, maybeAdd);
	    }
	
	    if (context && context.length) {
	      // If this is a property, see if it belongs to some object we can
	      // find in the current environment.
	      var obj = context.pop(),
	          base;
	      if (obj.type && obj.type.indexOf("variable") === 0) {
	        if (options && options.additionalContext) base = options.additionalContext[obj.string];
	        if (!options || options.useGlobalScope !== false) base = base || global[obj.string];
	      } else if (obj.type == "string") {
	        base = "";
	      } else if (obj.type == "atom") {
	        base = 1;
	      } else if (obj.type == "function") {
	        if (global.jQuery != null && (obj.string == '$' || obj.string == 'jQuery') && typeof global.jQuery == 'function') base = global.jQuery();else if (global._ != null && obj.string == '_' && typeof global._ == 'function') base = global._();
	      }
	      while (base != null && context.length) {
	        base = base[context.pop().string];
	      }if (base != null) gatherCompletions(base);
	    } else {
	      // If not, just look in the global object, any local scope, and optional additional-context
	      // (reading into JS mode internals to get at the local and global variables)
	      for (var v = token.state.localVars; v; v = v.next) {
	        maybeAdd(v.name);
	      }for (var c = token.state.context; c; c = c.prev) {
	        for (var v = c.vars; v; v = v.next) {
	          maybeAdd(v.name);
	        }
	      }for (var v = token.state.globalVars; v; v = v.next) {
	        maybeAdd(v.name);
	      }if (options && options.additionalContext != null) for (var key in options.additionalContext) {
	        maybeAdd(key);
	      }if (!options || options.useGlobalScope !== false) gatherCompletions(global);
	      forEach(keywords, maybeAdd);
	    }
	    return found;
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// declare global: DOMRect
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var HINT_ELEMENT_CLASS = "CodeMirror-hint";
	  var ACTIVE_HINT_ELEMENT_CLASS = "CodeMirror-hint-active";
	
	  // This is the old interface, kept around for now to stay
	  // backwards-compatible.
	  CodeMirror.showHint = function (cm, getHints, options) {
	    if (!getHints) return cm.showHint(options);
	    if (options && options.async) getHints.async = true;
	    var newOpts = { hint: getHints };
	    if (options) for (var prop in options) {
	      newOpts[prop] = options[prop];
	    }return cm.showHint(newOpts);
	  };
	
	  CodeMirror.defineExtension("showHint", function (options) {
	    options = parseOptions(this, this.getCursor("start"), options);
	    var selections = this.listSelections();
	    if (selections.length > 1) return;
	    // By default, don't allow completion when something is selected.
	    // A hint function can have a `supportsSelection` property to
	    // indicate that it can handle selections.
	    if (this.somethingSelected()) {
	      if (!options.hint.supportsSelection) return;
	      // Don't try with cross-line selections
	      for (var i = 0; i < selections.length; i++) {
	        if (selections[i].head.line != selections[i].anchor.line) return;
	      }
	    }
	
	    if (this.state.completionActive) this.state.completionActive.close();
	    var completion = this.state.completionActive = new Completion(this, options);
	    if (!completion.options.hint) return;
	
	    CodeMirror.signal(this, "startCompletion", this);
	    completion.update(true);
	  });
	
	  CodeMirror.defineExtension("closeHint", function () {
	    if (this.state.completionActive) this.state.completionActive.close();
	  });
	
	  function Completion(cm, options) {
	    this.cm = cm;
	    this.options = options;
	    this.widget = null;
	    this.debounce = 0;
	    this.tick = 0;
	    this.startPos = this.cm.getCursor("start");
	    this.startLen = this.cm.getLine(this.startPos.line).length - this.cm.getSelection().length;
	
	    if (this.options.updateOnCursorActivity) {
	      var self = this;
	      cm.on("cursorActivity", this.activityFunc = function () {
	        self.cursorActivity();
	      });
	    }
	  }
	
	  var requestAnimationFrame = window.requestAnimationFrame || function (fn) {
	    return setTimeout(fn, 1000 / 60);
	  };
	  var cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
	
	  Completion.prototype = {
	    close: function close() {
	      if (!this.active()) return;
	      this.cm.state.completionActive = null;
	      this.tick = null;
	      if (this.options.updateOnCursorActivity) {
	        this.cm.off("cursorActivity", this.activityFunc);
	      }
	
	      if (this.widget && this.data) CodeMirror.signal(this.data, "close");
	      if (this.widget) this.widget.close();
	      CodeMirror.signal(this.cm, "endCompletion", this.cm);
	    },
	
	    active: function active() {
	      return this.cm.state.completionActive == this;
	    },
	
	    pick: function pick(data, i) {
	      var completion = data.list[i],
	          self = this;
	      this.cm.operation(function () {
	        if (completion.hint) completion.hint(self.cm, data, completion);else self.cm.replaceRange(getText(completion), completion.from || data.from, completion.to || data.to, "complete");
	        CodeMirror.signal(data, "pick", completion);
	        self.cm.scrollIntoView();
	      });
	      if (this.options.closeOnPick) {
	        this.close();
	      }
	    },
	
	    cursorActivity: function cursorActivity() {
	      if (this.debounce) {
	        cancelAnimationFrame(this.debounce);
	        this.debounce = 0;
	      }
	
	      var identStart = this.startPos;
	      if (this.data) {
	        identStart = this.data.from;
	      }
	
	      var pos = this.cm.getCursor(),
	          line = this.cm.getLine(pos.line);
	      if (pos.line != this.startPos.line || line.length - pos.ch != this.startLen - this.startPos.ch || pos.ch < identStart.ch || this.cm.somethingSelected() || !pos.ch || this.options.closeCharacters.test(line.charAt(pos.ch - 1))) {
	        this.close();
	      } else {
	        var self = this;
	        this.debounce = requestAnimationFrame(function () {
	          self.update();
	        });
	        if (this.widget) this.widget.disable();
	      }
	    },
	
	    update: function update(first) {
	      if (this.tick == null) return;
	      var self = this,
	          myTick = ++this.tick;
	      fetchHints(this.options.hint, this.cm, this.options, function (data) {
	        if (self.tick == myTick) self.finishUpdate(data, first);
	      });
	    },
	
	    finishUpdate: function finishUpdate(data, first) {
	      if (this.data) CodeMirror.signal(this.data, "update");
	
	      var picked = this.widget && this.widget.picked || first && this.options.completeSingle;
	      if (this.widget) this.widget.close();
	
	      this.data = data;
	
	      if (data && data.list.length) {
	        if (picked && data.list.length == 1) {
	          this.pick(data, 0);
	        } else {
	          this.widget = new Widget(this, data);
	          CodeMirror.signal(data, "shown");
	        }
	      }
	    }
	  };
	
	  function parseOptions(cm, pos, options) {
	    var editor = cm.options.hintOptions;
	    var out = {};
	    for (var prop in defaultOptions) {
	      out[prop] = defaultOptions[prop];
	    }if (editor) for (var prop in editor) {
	      if (editor[prop] !== undefined) out[prop] = editor[prop];
	    }if (options) for (var prop in options) {
	      if (options[prop] !== undefined) out[prop] = options[prop];
	    }if (out.hint.resolve) out.hint = out.hint.resolve(cm, pos);
	    return out;
	  }
	
	  function getText(completion) {
	    if (typeof completion == "string") return completion;else return completion.text;
	  }
	
	  function buildKeyMap(completion, handle) {
	    var baseMap = {
	      Up: function Up() {
	        handle.moveFocus(-1);
	      },
	      Down: function Down() {
	        handle.moveFocus(1);
	      },
	      PageUp: function PageUp() {
	        handle.moveFocus(-handle.menuSize() + 1, true);
	      },
	      PageDown: function PageDown() {
	        handle.moveFocus(handle.menuSize() - 1, true);
	      },
	      Home: function Home() {
	        handle.setFocus(0);
	      },
	      End: function End() {
	        handle.setFocus(handle.length - 1);
	      },
	      Enter: handle.pick,
	      Tab: handle.pick,
	      Esc: handle.close
	    };
	
	    var mac = /Mac/.test(navigator.platform);
	
	    if (mac) {
	      baseMap["Ctrl-P"] = function () {
	        handle.moveFocus(-1);
	      };
	      baseMap["Ctrl-N"] = function () {
	        handle.moveFocus(1);
	      };
	    }
	
	    var custom = completion.options.customKeys;
	    var ourMap = custom ? {} : baseMap;
	    function addBinding(key, val) {
	      var bound;
	      if (typeof val != "string") bound = function bound(cm) {
	        return val(cm, handle);
	      };
	      // This mechanism is deprecated
	      else if (baseMap.hasOwnProperty(val)) bound = baseMap[val];else bound = val;
	      ourMap[key] = bound;
	    }
	    if (custom) for (var key in custom) {
	      if (custom.hasOwnProperty(key)) addBinding(key, custom[key]);
	    }var extra = completion.options.extraKeys;
	    if (extra) for (var key in extra) {
	      if (extra.hasOwnProperty(key)) addBinding(key, extra[key]);
	    }return ourMap;
	  }
	
	  function getHintElement(hintsElement, el) {
	    while (el && el != hintsElement) {
	      if (el.nodeName.toUpperCase() === "LI" && el.parentNode == hintsElement) return el;
	      el = el.parentNode;
	    }
	  }
	
	  function Widget(completion, data) {
	    this.id = "cm-complete-" + Math.floor(Math.random(1e6));
	    this.completion = completion;
	    this.data = data;
	    this.picked = false;
	    var widget = this,
	        cm = completion.cm;
	    var ownerDocument = cm.getInputField().ownerDocument;
	    var parentWindow = ownerDocument.defaultView || ownerDocument.parentWindow;
	
	    var hints = this.hints = ownerDocument.createElement("ul");
	    hints.setAttribute("role", "listbox");
	    hints.setAttribute("aria-expanded", "true");
	    hints.id = this.id;
	    var theme = completion.cm.options.theme;
	    hints.className = "CodeMirror-hints " + theme;
	    this.selectedHint = data.selectedHint || 0;
	
	    var completions = data.list;
	    for (var i = 0; i < completions.length; ++i) {
	      var elt = hints.appendChild(ownerDocument.createElement("li")),
	          cur = completions[i];
	      var className = HINT_ELEMENT_CLASS + (i != this.selectedHint ? "" : " " + ACTIVE_HINT_ELEMENT_CLASS);
	      if (cur.className != null) className = cur.className + " " + className;
	      elt.className = className;
	      if (i == this.selectedHint) elt.setAttribute("aria-selected", "true");
	      elt.id = this.id + "-" + i;
	      elt.setAttribute("role", "option");
	      if (cur.render) cur.render(elt, data, cur);else elt.appendChild(ownerDocument.createTextNode(cur.displayText || getText(cur)));
	      elt.hintId = i;
	    }
	
	    var container = completion.options.container || ownerDocument.body;
	    var pos = cm.cursorCoords(completion.options.alignWithWord ? data.from : null);
	    var left = pos.left,
	        top = pos.bottom,
	        below = true;
	    var offsetLeft = 0,
	        offsetTop = 0;
	    if (container !== ownerDocument.body) {
	      // We offset the cursor position because left and top are relative to the offsetParent's top left corner.
	      var isContainerPositioned = ['absolute', 'relative', 'fixed'].indexOf(parentWindow.getComputedStyle(container).position) !== -1;
	      var offsetParent = isContainerPositioned ? container : container.offsetParent;
	      var offsetParentPosition = offsetParent.getBoundingClientRect();
	      var bodyPosition = ownerDocument.body.getBoundingClientRect();
	      offsetLeft = offsetParentPosition.left - bodyPosition.left - offsetParent.scrollLeft;
	      offsetTop = offsetParentPosition.top - bodyPosition.top - offsetParent.scrollTop;
	    }
	    hints.style.left = left - offsetLeft + "px";
	    hints.style.top = top - offsetTop + "px";
	
	    // If we're at the edge of the screen, then we want the menu to appear on the left of the cursor.
	    var winW = parentWindow.innerWidth || Math.max(ownerDocument.body.offsetWidth, ownerDocument.documentElement.offsetWidth);
	    var winH = parentWindow.innerHeight || Math.max(ownerDocument.body.offsetHeight, ownerDocument.documentElement.offsetHeight);
	    container.appendChild(hints);
	    cm.getInputField().setAttribute("aria-autocomplete", "list");
	    cm.getInputField().setAttribute("aria-owns", this.id);
	    cm.getInputField().setAttribute("aria-activedescendant", this.id + "-" + this.selectedHint);
	
	    var box = completion.options.moveOnOverlap ? hints.getBoundingClientRect() : new DOMRect();
	    var scrolls = completion.options.paddingForScrollbar ? hints.scrollHeight > hints.clientHeight + 1 : false;
	
	    // Compute in the timeout to avoid reflow on init
	    var startScroll;
	    setTimeout(function () {
	      startScroll = cm.getScrollInfo();
	    });
	
	    var overlapY = box.bottom - winH;
	    if (overlapY > 0) {
	      // Does not fit below
	      var height = box.bottom - box.top,
	          spaceAbove = box.top - (pos.bottom - pos.top) - 2;
	      if (winH - box.top < spaceAbove) {
	        // More room at the top
	        if (height > spaceAbove) hints.style.height = (height = spaceAbove) + "px";
	        hints.style.top = (top = pos.top - height) + offsetTop + "px";
	        below = false;
	      } else {
	        hints.style.height = winH - box.top - 2 + "px";
	      }
	    }
	    var overlapX = box.right - winW;
	    if (scrolls) overlapX += cm.display.nativeBarWidth;
	    if (overlapX > 0) {
	      if (box.right - box.left > winW) {
	        hints.style.width = winW - 5 + "px";
	        overlapX -= box.right - box.left - winW;
	      }
	      hints.style.left = (left = Math.max(pos.left - overlapX - offsetLeft, 0)) + "px";
	    }
	    if (scrolls) for (var node = hints.firstChild; node; node = node.nextSibling) {
	      node.style.paddingRight = cm.display.nativeBarWidth + "px";
	    }cm.addKeyMap(this.keyMap = buildKeyMap(completion, {
	      moveFocus: function moveFocus(n, avoidWrap) {
	        widget.changeActive(widget.selectedHint + n, avoidWrap);
	      },
	      setFocus: function setFocus(n) {
	        widget.changeActive(n);
	      },
	      menuSize: function menuSize() {
	        return widget.screenAmount();
	      },
	      length: completions.length,
	      close: function close() {
	        completion.close();
	      },
	      pick: function pick() {
	        widget.pick();
	      },
	      data: data
	    }));
	
	    if (completion.options.closeOnUnfocus) {
	      var closingOnBlur;
	      cm.on("blur", this.onBlur = function () {
	        closingOnBlur = setTimeout(function () {
	          completion.close();
	        }, 100);
	      });
	      cm.on("focus", this.onFocus = function () {
	        clearTimeout(closingOnBlur);
	      });
	    }
	
	    cm.on("scroll", this.onScroll = function () {
	      var curScroll = cm.getScrollInfo(),
	          editor = cm.getWrapperElement().getBoundingClientRect();
	      if (!startScroll) startScroll = cm.getScrollInfo();
	      var newTop = top + startScroll.top - curScroll.top;
	      var point = newTop - (parentWindow.pageYOffset || (ownerDocument.documentElement || ownerDocument.body).scrollTop);
	      if (!below) point += hints.offsetHeight;
	      if (point <= editor.top || point >= editor.bottom) return completion.close();
	      hints.style.top = newTop + "px";
	      hints.style.left = left + startScroll.left - curScroll.left + "px";
	    });
	
	    CodeMirror.on(hints, "dblclick", function (e) {
	      var t = getHintElement(hints, e.target || e.srcElement);
	      if (t && t.hintId != null) {
	        widget.changeActive(t.hintId);widget.pick();
	      }
	    });
	
	    CodeMirror.on(hints, "click", function (e) {
	      var t = getHintElement(hints, e.target || e.srcElement);
	      if (t && t.hintId != null) {
	        widget.changeActive(t.hintId);
	        if (completion.options.completeOnSingleClick) widget.pick();
	      }
	    });
	
	    CodeMirror.on(hints, "mousedown", function () {
	      setTimeout(function () {
	        cm.focus();
	      }, 20);
	    });
	
	    // The first hint doesn't need to be scrolled to on init
	    var selectedHintRange = this.getSelectedHintRange();
	    if (selectedHintRange.from !== 0 || selectedHintRange.to !== 0) {
	      this.scrollToActive();
	    }
	
	    CodeMirror.signal(data, "select", completions[this.selectedHint], hints.childNodes[this.selectedHint]);
	    return true;
	  }
	
	  Widget.prototype = {
	    close: function close() {
	      if (this.completion.widget != this) return;
	      this.completion.widget = null;
	      if (this.hints.parentNode) this.hints.parentNode.removeChild(this.hints);
	      this.completion.cm.removeKeyMap(this.keyMap);
	      var input = this.completion.cm.getInputField();
	      input.removeAttribute("aria-activedescendant");
	      input.removeAttribute("aria-owns");
	
	      var cm = this.completion.cm;
	      if (this.completion.options.closeOnUnfocus) {
	        cm.off("blur", this.onBlur);
	        cm.off("focus", this.onFocus);
	      }
	      cm.off("scroll", this.onScroll);
	    },
	
	    disable: function disable() {
	      this.completion.cm.removeKeyMap(this.keyMap);
	      var widget = this;
	      this.keyMap = { Enter: function Enter() {
	          widget.picked = true;
	        } };
	      this.completion.cm.addKeyMap(this.keyMap);
	    },
	
	    pick: function pick() {
	      this.completion.pick(this.data, this.selectedHint);
	    },
	
	    changeActive: function changeActive(i, avoidWrap) {
	      if (i >= this.data.list.length) i = avoidWrap ? this.data.list.length - 1 : 0;else if (i < 0) i = avoidWrap ? 0 : this.data.list.length - 1;
	      if (this.selectedHint == i) return;
	      var node = this.hints.childNodes[this.selectedHint];
	      if (node) {
	        node.className = node.className.replace(" " + ACTIVE_HINT_ELEMENT_CLASS, "");
	        node.removeAttribute("aria-selected");
	      }
	      node = this.hints.childNodes[this.selectedHint = i];
	      node.className += " " + ACTIVE_HINT_ELEMENT_CLASS;
	      node.setAttribute("aria-selected", "true");
	      this.completion.cm.getInputField().setAttribute("aria-activedescendant", node.id);
	      this.scrollToActive();
	      CodeMirror.signal(this.data, "select", this.data.list[this.selectedHint], node);
	    },
	
	    scrollToActive: function scrollToActive() {
	      var selectedHintRange = this.getSelectedHintRange();
	      var node1 = this.hints.childNodes[selectedHintRange.from];
	      var node2 = this.hints.childNodes[selectedHintRange.to];
	      var firstNode = this.hints.firstChild;
	      if (node1.offsetTop < this.hints.scrollTop) this.hints.scrollTop = node1.offsetTop - firstNode.offsetTop;else if (node2.offsetTop + node2.offsetHeight > this.hints.scrollTop + this.hints.clientHeight) this.hints.scrollTop = node2.offsetTop + node2.offsetHeight - this.hints.clientHeight + firstNode.offsetTop;
	    },
	
	    screenAmount: function screenAmount() {
	      return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1;
	    },
	
	    getSelectedHintRange: function getSelectedHintRange() {
	      var margin = this.completion.options.scrollMargin || 0;
	      return {
	        from: Math.max(0, this.selectedHint - margin),
	        to: Math.min(this.data.list.length - 1, this.selectedHint + margin)
	      };
	    }
	  };
	
	  function applicableHelpers(cm, helpers) {
	    if (!cm.somethingSelected()) return helpers;
	    var result = [];
	    for (var i = 0; i < helpers.length; i++) {
	      if (helpers[i].supportsSelection) result.push(helpers[i]);
	    }return result;
	  }
	
	  function fetchHints(hint, cm, options, callback) {
	    if (hint.async) {
	      hint(cm, callback, options);
	    } else {
	      var result = hint(cm, options);
	      if (result && result.then) result.then(callback);else callback(result);
	    }
	  }
	
	  function resolveAutoHints(cm, pos) {
	    var helpers = cm.getHelpers(pos, "hint"),
	        words;
	    if (helpers.length) {
	      var resolved = function resolved(cm, callback, options) {
	        var app = applicableHelpers(cm, helpers);
	        function run(i) {
	          if (i == app.length) return callback(null);
	          fetchHints(app[i], cm, options, function (result) {
	            if (result && result.list.length > 0) callback(result);else run(i + 1);
	          });
	        }
	        run(0);
	      };
	      resolved.async = true;
	      resolved.supportsSelection = true;
	      return resolved;
	    } else if (words = cm.getHelper(cm.getCursor(), "hintWords")) {
	      return function (cm) {
	        return CodeMirror.hint.fromList(cm, { words: words });
	      };
	    } else if (CodeMirror.hint.anyword) {
	      return function (cm, options) {
	        return CodeMirror.hint.anyword(cm, options);
	      };
	    } else {
	      return function () {};
	    }
	  }
	
	  CodeMirror.registerHelper("hint", "auto", {
	    resolve: resolveAutoHints
	  });
	
	  CodeMirror.registerHelper("hint", "fromList", function (cm, options) {
	    var cur = cm.getCursor(),
	        token = cm.getTokenAt(cur);
	    var term,
	        from = CodeMirror.Pos(cur.line, token.start),
	        to = cur;
	    if (token.start < cur.ch && /\w/.test(token.string.charAt(cur.ch - token.start - 1))) {
	      term = token.string.substr(0, cur.ch - token.start);
	    } else {
	      term = "";
	      from = cur;
	    }
	    var found = [];
	    for (var i = 0; i < options.words.length; i++) {
	      var word = options.words[i];
	      if (word.slice(0, term.length) == term) found.push(word);
	    }
	
	    if (found.length) return { list: found, from: from, to: to };
	  });
	
	  CodeMirror.commands.autocomplete = CodeMirror.showHint;
	
	  var defaultOptions = {
	    hint: CodeMirror.hint.auto,
	    completeSingle: true,
	    alignWithWord: true,
	    closeCharacters: /[\s()\[\]{};:>,]/,
	    closeOnPick: true,
	    closeOnUnfocus: true,
	    updateOnCursorActivity: true,
	    completeOnSingleClick: true,
	    container: null,
	    customKeys: null,
	    extraKeys: null,
	    paddingForScrollbar: true,
	    moveOnOverlap: true
	  };
	
	  CodeMirror.defineOption("hintOptions", null);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// Depends on jshint.js from https://github.com/jshint/jshint
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	  // declare global: JSHINT
	
	  function validator(text, options) {
	    if (!window.JSHINT) {
	      if (window.console) {
	        window.console.error("Error: window.JSHINT not defined, CodeMirror JavaScript linting cannot run.");
	      }
	      return [];
	    }
	    if (!options.indent) // JSHint error.character actually is a column index, this fixes underlining on lines using tabs for indentation
	      options.indent = 1; // JSHint default value is 4
	    JSHINT(text, options, options.globals);
	    var errors = JSHINT.data().errors,
	        result = [];
	    if (errors) parseErrors(errors, result);
	    return result;
	  }
	
	  CodeMirror.registerHelper("lint", "javascript", validator);
	
	  function parseErrors(errors, output) {
	    for (var i = 0; i < errors.length; i++) {
	      var error = errors[i];
	      if (error) {
	        if (error.line <= 0) {
	          if (window.console) {
	            window.console.warn("Cannot display JSHint error (invalid line " + error.line + ")", error);
	          }
	          continue;
	        }
	
	        var start = error.character - 1,
	            end = start + 1;
	        if (error.evidence) {
	          var index = error.evidence.substring(start).search(/.\b/);
	          if (index > -1) {
	            end += index;
	          }
	        }
	
	        // Convert to format expected by validation service
	        var hint = {
	          message: error.reason,
	          severity: error.code ? error.code.startsWith('W') ? "warning" : "error" : "error",
	          from: CodeMirror.Pos(error.line - 1, start),
	          to: CodeMirror.Pos(error.line - 1, end)
	        };
	
	        output.push(hint);
	      }
	    }
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var GUTTER_ID = "CodeMirror-lint-markers";
	  var LINT_LINE_ID = "CodeMirror-lint-line-";
	
	  function showTooltip(cm, e, content) {
	    var tt = document.createElement("div");
	    tt.className = "CodeMirror-lint-tooltip cm-s-" + cm.options.theme;
	    tt.appendChild(content.cloneNode(true));
	    if (cm.state.lint.options.selfContain) cm.getWrapperElement().appendChild(tt);else document.body.appendChild(tt);
	
	    function position(e) {
	      if (!tt.parentNode) return CodeMirror.off(document, "mousemove", position);
	      var top = Math.max(0, e.clientY - tt.offsetHeight - 5);
	      var left = Math.max(0, Math.min(e.clientX + 5, tt.ownerDocument.defaultView.innerWidth - tt.offsetWidth));
	      tt.style.top = top + "px";
	      tt.style.left = left + "px";
	    }
	    CodeMirror.on(document, "mousemove", position);
	    position(e);
	    if (tt.style.opacity != null) tt.style.opacity = 1;
	    return tt;
	  }
	  function rm(elt) {
	    if (elt.parentNode) elt.parentNode.removeChild(elt);
	  }
	  function hideTooltip(tt) {
	    if (!tt.parentNode) return;
	    if (tt.style.opacity == null) rm(tt);
	    tt.style.opacity = 0;
	    setTimeout(function () {
	      rm(tt);
	    }, 600);
	  }
	
	  function showTooltipFor(cm, e, content, node) {
	    var tooltip = showTooltip(cm, e, content);
	    function hide() {
	      CodeMirror.off(node, "mouseout", hide);
	      if (tooltip) {
	        hideTooltip(tooltip);tooltip = null;
	      }
	    }
	    var poll = setInterval(function () {
	      if (tooltip) for (var n = node;; n = n.parentNode) {
	        if (n && n.nodeType == 11) n = n.host;
	        if (n == document.body) return;
	        if (!n) {
	          hide();break;
	        }
	      }
	      if (!tooltip) return clearInterval(poll);
	    }, 400);
	    CodeMirror.on(node, "mouseout", hide);
	  }
	
	  function LintState(cm, conf, hasGutter) {
	    this.marked = [];
	    if (conf instanceof Function) conf = { getAnnotations: conf };
	    if (!conf || conf === true) conf = {};
	    this.options = {};
	    this.linterOptions = conf.options || {};
	    for (var prop in defaults) {
	      this.options[prop] = defaults[prop];
	    }for (var prop in conf) {
	      if (defaults.hasOwnProperty(prop)) {
	        if (conf[prop] != null) this.options[prop] = conf[prop];
	      } else if (!conf.options) {
	        this.linterOptions[prop] = conf[prop];
	      }
	    }
	    this.timeout = null;
	    this.hasGutter = hasGutter;
	    this.onMouseOver = function (e) {
	      onMouseOver(cm, e);
	    };
	    this.waitingFor = 0;
	  }
	
	  var defaults = {
	    highlightLines: false,
	    tooltips: true,
	    delay: 500,
	    lintOnChange: true,
	    getAnnotations: null,
	    async: false,
	    selfContain: null,
	    formatAnnotation: null,
	    onUpdateLinting: null
	  };
	
	  function clearMarks(cm) {
	    var state = cm.state.lint;
	    if (state.hasGutter) cm.clearGutter(GUTTER_ID);
	    if (state.options.highlightLines) clearErrorLines(cm);
	    for (var i = 0; i < state.marked.length; ++i) {
	      state.marked[i].clear();
	    }state.marked.length = 0;
	  }
	
	  function clearErrorLines(cm) {
	    cm.eachLine(function (line) {
	      var has = line.wrapClass && /\bCodeMirror-lint-line-\w+\b/.exec(line.wrapClass);
	      if (has) cm.removeLineClass(line, "wrap", has[0]);
	    });
	  }
	
	  function makeMarker(cm, labels, severity, multiple, tooltips) {
	    var marker = document.createElement("div"),
	        inner = marker;
	    marker.className = "CodeMirror-lint-marker CodeMirror-lint-marker-" + severity;
	    if (multiple) {
	      inner = marker.appendChild(document.createElement("div"));
	      inner.className = "CodeMirror-lint-marker CodeMirror-lint-marker-multiple";
	    }
	
	    if (tooltips != false) CodeMirror.on(inner, "mouseover", function (e) {
	      showTooltipFor(cm, e, labels, inner);
	    });
	
	    return marker;
	  }
	
	  function getMaxSeverity(a, b) {
	    if (a == "error") return a;else return b;
	  }
	
	  function groupByLine(annotations) {
	    var lines = [];
	    for (var i = 0; i < annotations.length; ++i) {
	      var ann = annotations[i],
	          line = ann.from.line;
	      (lines[line] || (lines[line] = [])).push(ann);
	    }
	    return lines;
	  }
	
	  function annotationTooltip(ann) {
	    var severity = ann.severity;
	    if (!severity) severity = "error";
	    var tip = document.createElement("div");
	    tip.className = "CodeMirror-lint-message CodeMirror-lint-message-" + severity;
	    if (typeof ann.messageHTML != 'undefined') {
	      tip.innerHTML = ann.messageHTML;
	    } else {
	      tip.appendChild(document.createTextNode(ann.message));
	    }
	    return tip;
	  }
	
	  function lintAsync(cm, getAnnotations) {
	    var state = cm.state.lint;
	    var id = ++state.waitingFor;
	    function abort() {
	      id = -1;
	      cm.off("change", abort);
	    }
	    cm.on("change", abort);
	    getAnnotations(cm.getValue(), function (annotations, arg2) {
	      cm.off("change", abort);
	      if (state.waitingFor != id) return;
	      if (arg2 && annotations instanceof CodeMirror) annotations = arg2;
	      cm.operation(function () {
	        updateLinting(cm, annotations);
	      });
	    }, state.linterOptions, cm);
	  }
	
	  function startLinting(cm) {
	    var state = cm.state.lint;
	    if (!state) return;
	    var options = state.options;
	    /*
	     * Passing rules in `options` property prevents JSHint (and other linters) from complaining
	     * about unrecognized rules like `onUpdateLinting`, `delay`, `lintOnChange`, etc.
	     */
	    var getAnnotations = options.getAnnotations || cm.getHelper(CodeMirror.Pos(0, 0), "lint");
	    if (!getAnnotations) return;
	    if (options.async || getAnnotations.async) {
	      lintAsync(cm, getAnnotations);
	    } else {
	      var annotations = getAnnotations(cm.getValue(), state.linterOptions, cm);
	      if (!annotations) return;
	      if (annotations.then) annotations.then(function (issues) {
	        cm.operation(function () {
	          updateLinting(cm, issues);
	        });
	      });else cm.operation(function () {
	        updateLinting(cm, annotations);
	      });
	    }
	  }
	
	  function updateLinting(cm, annotationsNotSorted) {
	    var state = cm.state.lint;
	    if (!state) return;
	    var options = state.options;
	    clearMarks(cm);
	
	    var annotations = groupByLine(annotationsNotSorted);
	
	    for (var line = 0; line < annotations.length; ++line) {
	      var anns = annotations[line];
	      if (!anns) continue;
	
	      var maxSeverity = null;
	      var tipLabel = state.hasGutter && document.createDocumentFragment();
	
	      for (var i = 0; i < anns.length; ++i) {
	        var ann = anns[i];
	        var severity = ann.severity;
	        if (!severity) severity = "error";
	        maxSeverity = getMaxSeverity(maxSeverity, severity);
	
	        if (options.formatAnnotation) ann = options.formatAnnotation(ann);
	        if (state.hasGutter) tipLabel.appendChild(annotationTooltip(ann));
	
	        if (ann.to) state.marked.push(cm.markText(ann.from, ann.to, {
	          className: "CodeMirror-lint-mark CodeMirror-lint-mark-" + severity,
	          __annotation: ann
	        }));
	      }
	      if (state.hasGutter) cm.setGutterMarker(line, GUTTER_ID, makeMarker(cm, tipLabel, maxSeverity, anns.length > 1, options.tooltips));
	
	      if (options.highlightLines) cm.addLineClass(line, "wrap", LINT_LINE_ID + maxSeverity);
	    }
	    if (options.onUpdateLinting) options.onUpdateLinting(annotationsNotSorted, annotations, cm);
	  }
	
	  function onChange(cm) {
	    var state = cm.state.lint;
	    if (!state) return;
	    clearTimeout(state.timeout);
	    state.timeout = setTimeout(function () {
	      startLinting(cm);
	    }, state.options.delay);
	  }
	
	  function popupTooltips(cm, annotations, e) {
	    var target = e.target || e.srcElement;
	    var tooltip = document.createDocumentFragment();
	    for (var i = 0; i < annotations.length; i++) {
	      var ann = annotations[i];
	      tooltip.appendChild(annotationTooltip(ann));
	    }
	    showTooltipFor(cm, e, tooltip, target);
	  }
	
	  function onMouseOver(cm, e) {
	    var target = e.target || e.srcElement;
	    if (!/\bCodeMirror-lint-mark-/.test(target.className)) return;
	    var box = target.getBoundingClientRect(),
	        x = (box.left + box.right) / 2,
	        y = (box.top + box.bottom) / 2;
	    var spans = cm.findMarksAt(cm.coordsChar({ left: x, top: y }, "client"));
	
	    var annotations = [];
	    for (var i = 0; i < spans.length; ++i) {
	      var ann = spans[i].__annotation;
	      if (ann) annotations.push(ann);
	    }
	    if (annotations.length) popupTooltips(cm, annotations, e);
	  }
	
	  CodeMirror.defineOption("lint", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      clearMarks(cm);
	      if (cm.state.lint.options.lintOnChange !== false) cm.off("change", onChange);
	      CodeMirror.off(cm.getWrapperElement(), "mouseover", cm.state.lint.onMouseOver);
	      clearTimeout(cm.state.lint.timeout);
	      delete cm.state.lint;
	    }
	
	    if (val) {
	      var gutters = cm.getOption("gutters"),
	          hasLintGutter = false;
	      for (var i = 0; i < gutters.length; ++i) {
	        if (gutters[i] == GUTTER_ID) hasLintGutter = true;
	      }var state = cm.state.lint = new LintState(cm, val, hasLintGutter);
	      if (state.options.lintOnChange) cm.on("change", onChange);
	      if (state.options.tooltips != false && state.options.tooltips != "gutter") CodeMirror.on(cm.getWrapperElement(), "mouseover", state.onMouseOver);
	
	      startLinting(cm);
	    }
	  });
	
	  CodeMirror.defineExtension("performLint", function () {
	    startLinting(this);
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// Highlighting text that matches the selection
	//
	// Defines an option highlightSelectionMatches, which, when enabled,
	// will style strings that match the selection throughout the
	// document.
	//
	// The option can be set to true to simply enable it, or to a
	// {minChars, style, wordsOnly, showToken, delay} object to explicitly
	// configure it. minChars is the minimum amount of characters that should be
	// selected for the behavior to occur, and style is the token style to
	// apply to the matches. This will be prefixed by "cm-" to create an
	// actual CSS class name. If wordsOnly is enabled, the matches will be
	// highlighted only if the selected text is a word. showToken, when enabled,
	// will cause the current token to be highlighted when nothing is selected.
	// delay is used to specify how much time to wait, in milliseconds, before
	// highlighting the matches. If annotateScrollbar is enabled, the occurrences
	// will be highlighted on the scrollbar via the matchesonscrollbar addon.
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41), __webpack_require__(391));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41), __webpack_require__(391)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  var defaults = {
	    style: "matchhighlight",
	    minChars: 2,
	    delay: 100,
	    wordsOnly: false,
	    annotateScrollbar: false,
	    showToken: false,
	    trim: true
	  };
	
	  function State(options) {
	    this.options = {};
	    for (var name in defaults) {
	      this.options[name] = (options && options.hasOwnProperty(name) ? options : defaults)[name];
	    }this.overlay = this.timeout = null;
	    this.matchesonscroll = null;
	    this.active = false;
	  }
	
	  CodeMirror.defineOption("highlightSelectionMatches", false, function (cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      removeOverlay(cm);
	      clearTimeout(cm.state.matchHighlighter.timeout);
	      cm.state.matchHighlighter = null;
	      cm.off("cursorActivity", cursorActivity);
	      cm.off("focus", onFocus);
	    }
	    if (val) {
	      var state = cm.state.matchHighlighter = new State(val);
	      if (cm.hasFocus()) {
	        state.active = true;
	        highlightMatches(cm);
	      } else {
	        cm.on("focus", onFocus);
	      }
	      cm.on("cursorActivity", cursorActivity);
	    }
	  });
	
	  function cursorActivity(cm) {
	    var state = cm.state.matchHighlighter;
	    if (state.active || cm.hasFocus()) scheduleHighlight(cm, state);
	  }
	
	  function onFocus(cm) {
	    var state = cm.state.matchHighlighter;
	    if (!state.active) {
	      state.active = true;
	      scheduleHighlight(cm, state);
	    }
	  }
	
	  function scheduleHighlight(cm, state) {
	    clearTimeout(state.timeout);
	    state.timeout = setTimeout(function () {
	      highlightMatches(cm);
	    }, state.options.delay);
	  }
	
	  function addOverlay(cm, query, hasBoundary, style) {
	    var state = cm.state.matchHighlighter;
	    cm.addOverlay(state.overlay = makeOverlay(query, hasBoundary, style));
	    if (state.options.annotateScrollbar && cm.showMatchesOnScrollbar) {
	      var searchFor = hasBoundary ? new RegExp((/\w/.test(query.charAt(0)) ? "\\b" : "") + query.replace(/[\\\[.+*?(){|^$]/g, "\\$&") + (/\w/.test(query.charAt(query.length - 1)) ? "\\b" : "")) : query;
	      state.matchesonscroll = cm.showMatchesOnScrollbar(searchFor, false, { className: "CodeMirror-selection-highlight-scrollbar" });
	    }
	  }
	
	  function removeOverlay(cm) {
	    var state = cm.state.matchHighlighter;
	    if (state.overlay) {
	      cm.removeOverlay(state.overlay);
	      state.overlay = null;
	      if (state.matchesonscroll) {
	        state.matchesonscroll.clear();
	        state.matchesonscroll = null;
	      }
	    }
	  }
	
	  function highlightMatches(cm) {
	    cm.operation(function () {
	      var state = cm.state.matchHighlighter;
	      removeOverlay(cm);
	      if (!cm.somethingSelected() && state.options.showToken) {
	        var re = state.options.showToken === true ? /[\w$]/ : state.options.showToken;
	        var cur = cm.getCursor(),
	            line = cm.getLine(cur.line),
	            start = cur.ch,
	            end = start;
	        while (start && re.test(line.charAt(start - 1))) {
	          --start;
	        }while (end < line.length && re.test(line.charAt(end))) {
	          ++end;
	        }if (start < end) addOverlay(cm, line.slice(start, end), re, state.options.style);
	        return;
	      }
	      var from = cm.getCursor("from"),
	          to = cm.getCursor("to");
	      if (from.line != to.line) return;
	      if (state.options.wordsOnly && !isWord(cm, from, to)) return;
	      var selection = cm.getRange(from, to);
	      if (state.options.trim) selection = selection.replace(/^\s+|\s+$/g, "");
	      if (selection.length >= state.options.minChars) addOverlay(cm, selection, false, state.options.style);
	    });
	  }
	
	  function isWord(cm, from, to) {
	    var str = cm.getRange(from, to);
	    if (str.match(/^\w+$/) !== null) {
	      if (from.ch > 0) {
	        var pos = { line: from.line, ch: from.ch - 1 };
	        var chr = cm.getRange(pos, from);
	        if (chr.match(/\W/) === null) return false;
	      }
	      if (to.ch < cm.getLine(from.line).length) {
	        var pos = { line: to.line, ch: to.ch + 1 };
	        var chr = cm.getRange(to, pos);
	        if (chr.match(/\W/) === null) return false;
	      }
	      return true;
	    } else return false;
	  }
	
	  function boundariesAround(stream, re) {
	    return (!stream.start || !re.test(stream.string.charAt(stream.start - 1))) && (stream.pos == stream.string.length || !re.test(stream.string.charAt(stream.pos)));
	  }
	
	  function makeOverlay(query, hasBoundary, style) {
	    return { token: function token(stream) {
	        if (stream.match(query) && (!hasBoundary || boundariesAround(stream, hasBoundary))) return style;
	        stream.next();
	        stream.skipTo(query.charAt(0)) || stream.skipToEnd();
	      } };
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("css", function (config, parserConfig) {
	    var inline = parserConfig.inline;
	    if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
	
	    var indentUnit = config.indentUnit,
	        tokenHooks = parserConfig.tokenHooks,
	        documentTypes = parserConfig.documentTypes || {},
	        mediaTypes = parserConfig.mediaTypes || {},
	        mediaFeatures = parserConfig.mediaFeatures || {},
	        mediaValueKeywords = parserConfig.mediaValueKeywords || {},
	        propertyKeywords = parserConfig.propertyKeywords || {},
	        nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
	        fontProperties = parserConfig.fontProperties || {},
	        counterDescriptors = parserConfig.counterDescriptors || {},
	        colorKeywords = parserConfig.colorKeywords || {},
	        valueKeywords = parserConfig.valueKeywords || {},
	        allowNested = parserConfig.allowNested,
	        lineComment = parserConfig.lineComment,
	        supportsAtComponent = parserConfig.supportsAtComponent === true,
	        highlightNonStandardPropertyKeywords = config.highlightNonStandardPropertyKeywords !== false;
	
	    var type, override;
	    function ret(style, tp) {
	      type = tp;return style;
	    }
	
	    // Tokenizers
	
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	      if (tokenHooks[ch]) {
	        var result = tokenHooks[ch](stream, state);
	        if (result !== false) return result;
	      }
	      if (ch == "@") {
	        stream.eatWhile(/[\w\\\-]/);
	        return ret("def", stream.current());
	      } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
	        return ret(null, "compare");
	      } else if (ch == "\"" || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      } else if (ch == "#") {
	        stream.eatWhile(/[\w\\\-]/);
	        return ret("atom", "hash");
	      } else if (ch == "!") {
	        stream.match(/^\s*\w*/);
	        return ret("keyword", "important");
	      } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
	        stream.eatWhile(/[\w.%]/);
	        return ret("number", "unit");
	      } else if (ch === "-") {
	        if (/[\d.]/.test(stream.peek())) {
	          stream.eatWhile(/[\w.%]/);
	          return ret("number", "unit");
	        } else if (stream.match(/^-[\w\\\-]*/)) {
	          stream.eatWhile(/[\w\\\-]/);
	          if (stream.match(/^\s*:/, false)) return ret("variable-2", "variable-definition");
	          return ret("variable-2", "variable");
	        } else if (stream.match(/^\w+-/)) {
	          return ret("meta", "meta");
	        }
	      } else if (/[,+>*\/]/.test(ch)) {
	        return ret(null, "select-op");
	      } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
	        return ret("qualifier", "qualifier");
	      } else if (/[:;{}\[\]\(\)]/.test(ch)) {
	        return ret(null, ch);
	      } else if (stream.match(/^[\w-.]+(?=\()/)) {
	        if (/^(url(-prefix)?|domain|regexp)$/i.test(stream.current())) {
	          state.tokenize = tokenParenthesized;
	        }
	        return ret("variable callee", "variable");
	      } else if (/[\w\\\-]/.test(ch)) {
	        stream.eatWhile(/[\w\\\-]/);
	        return ret("property", "word");
	      } else {
	        return ret(null, null);
	      }
	    }
	
	    function tokenString(quote) {
	      return function (stream, state) {
	        var escaped = false,
	            ch;
	        while ((ch = stream.next()) != null) {
	          if (ch == quote && !escaped) {
	            if (quote == ")") stream.backUp(1);
	            break;
	          }
	          escaped = !escaped && ch == "\\";
	        }
	        if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	        return ret("string", "string");
	      };
	    }
	
	    function tokenParenthesized(stream, state) {
	      stream.next(); // Must be '('
	      if (!stream.match(/^\s*[\"\')]/, false)) state.tokenize = tokenString(")");else state.tokenize = null;
	      return ret(null, "(");
	    }
	
	    // Context management
	
	    function Context(type, indent, prev) {
	      this.type = type;
	      this.indent = indent;
	      this.prev = prev;
	    }
	
	    function pushContext(state, stream, type, indent) {
	      state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
	      return type;
	    }
	
	    function popContext(state) {
	      if (state.context.prev) state.context = state.context.prev;
	      return state.context.type;
	    }
	
	    function pass(type, stream, state) {
	      return states[state.context.type](type, stream, state);
	    }
	    function popAndPass(type, stream, state, n) {
	      for (var i = n || 1; i > 0; i--) {
	        state.context = state.context.prev;
	      }return pass(type, stream, state);
	    }
	
	    // Parser
	
	    function wordAsValue(stream) {
	      var word = stream.current().toLowerCase();
	      if (valueKeywords.hasOwnProperty(word)) override = "atom";else if (colorKeywords.hasOwnProperty(word)) override = "keyword";else override = "variable";
	    }
	
	    var states = {};
	
	    states.top = function (type, stream, state) {
	      if (type == "{") {
	        return pushContext(state, stream, "block");
	      } else if (type == "}" && state.context.prev) {
	        return popContext(state);
	      } else if (supportsAtComponent && /@component/i.test(type)) {
	        return pushContext(state, stream, "atComponentBlock");
	      } else if (/^@(-moz-)?document$/i.test(type)) {
	        return pushContext(state, stream, "documentTypes");
	      } else if (/^@(media|supports|(-moz-)?document|import)$/i.test(type)) {
	        return pushContext(state, stream, "atBlock");
	      } else if (/^@(font-face|counter-style)/i.test(type)) {
	        state.stateArg = type;
	        return "restricted_atBlock_before";
	      } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(type)) {
	        return "keyframes";
	      } else if (type && type.charAt(0) == "@") {
	        return pushContext(state, stream, "at");
	      } else if (type == "hash") {
	        override = "builtin";
	      } else if (type == "word") {
	        override = "tag";
	      } else if (type == "variable-definition") {
	        return "maybeprop";
	      } else if (type == "interpolation") {
	        return pushContext(state, stream, "interpolation");
	      } else if (type == ":") {
	        return "pseudo";
	      } else if (allowNested && type == "(") {
	        return pushContext(state, stream, "parens");
	      }
	      return state.context.type;
	    };
	
	    states.block = function (type, stream, state) {
	      if (type == "word") {
	        var word = stream.current().toLowerCase();
	        if (propertyKeywords.hasOwnProperty(word)) {
	          override = "property";
	          return "maybeprop";
	        } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
	          override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
	          return "maybeprop";
	        } else if (allowNested) {
	          override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
	          return "block";
	        } else {
	          override += " error";
	          return "maybeprop";
	        }
	      } else if (type == "meta") {
	        return "block";
	      } else if (!allowNested && (type == "hash" || type == "qualifier")) {
	        override = "error";
	        return "block";
	      } else {
	        return states.top(type, stream, state);
	      }
	    };
	
	    states.maybeprop = function (type, stream, state) {
	      if (type == ":") return pushContext(state, stream, "prop");
	      return pass(type, stream, state);
	    };
	
	    states.prop = function (type, stream, state) {
	      if (type == ";") return popContext(state);
	      if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
	      if (type == "}" || type == "{") return popAndPass(type, stream, state);
	      if (type == "(") return pushContext(state, stream, "parens");
	
	      if (type == "hash" && !/^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(stream.current())) {
	        override += " error";
	      } else if (type == "word") {
	        wordAsValue(stream);
	      } else if (type == "interpolation") {
	        return pushContext(state, stream, "interpolation");
	      }
	      return "prop";
	    };
	
	    states.propBlock = function (type, _stream, state) {
	      if (type == "}") return popContext(state);
	      if (type == "word") {
	        override = "property";return "maybeprop";
	      }
	      return state.context.type;
	    };
	
	    states.parens = function (type, stream, state) {
	      if (type == "{" || type == "}") return popAndPass(type, stream, state);
	      if (type == ")") return popContext(state);
	      if (type == "(") return pushContext(state, stream, "parens");
	      if (type == "interpolation") return pushContext(state, stream, "interpolation");
	      if (type == "word") wordAsValue(stream);
	      return "parens";
	    };
	
	    states.pseudo = function (type, stream, state) {
	      if (type == "meta") return "pseudo";
	
	      if (type == "word") {
	        override = "variable-3";
	        return state.context.type;
	      }
	      return pass(type, stream, state);
	    };
	
	    states.documentTypes = function (type, stream, state) {
	      if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
	        override = "tag";
	        return state.context.type;
	      } else {
	        return states.atBlock(type, stream, state);
	      }
	    };
	
	    states.atBlock = function (type, stream, state) {
	      if (type == "(") return pushContext(state, stream, "atBlock_parens");
	      if (type == "}" || type == ";") return popAndPass(type, stream, state);
	      if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
	
	      if (type == "interpolation") return pushContext(state, stream, "interpolation");
	
	      if (type == "word") {
	        var word = stream.current().toLowerCase();
	        if (word == "only" || word == "not" || word == "and" || word == "or") override = "keyword";else if (mediaTypes.hasOwnProperty(word)) override = "attribute";else if (mediaFeatures.hasOwnProperty(word)) override = "property";else if (mediaValueKeywords.hasOwnProperty(word)) override = "keyword";else if (propertyKeywords.hasOwnProperty(word)) override = "property";else if (nonStandardPropertyKeywords.hasOwnProperty(word)) override = highlightNonStandardPropertyKeywords ? "string-2" : "property";else if (valueKeywords.hasOwnProperty(word)) override = "atom";else if (colorKeywords.hasOwnProperty(word)) override = "keyword";else override = "error";
	      }
	      return state.context.type;
	    };
	
	    states.atComponentBlock = function (type, stream, state) {
	      if (type == "}") return popAndPass(type, stream, state);
	      if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
	      if (type == "word") override = "error";
	      return state.context.type;
	    };
	
	    states.atBlock_parens = function (type, stream, state) {
	      if (type == ")") return popContext(state);
	      if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
	      return states.atBlock(type, stream, state);
	    };
	
	    states.restricted_atBlock_before = function (type, stream, state) {
	      if (type == "{") return pushContext(state, stream, "restricted_atBlock");
	      if (type == "word" && state.stateArg == "@counter-style") {
	        override = "variable";
	        return "restricted_atBlock_before";
	      }
	      return pass(type, stream, state);
	    };
	
	    states.restricted_atBlock = function (type, stream, state) {
	      if (type == "}") {
	        state.stateArg = null;
	        return popContext(state);
	      }
	      if (type == "word") {
	        if (state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase()) || state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())) override = "error";else override = "property";
	        return "maybeprop";
	      }
	      return "restricted_atBlock";
	    };
	
	    states.keyframes = function (type, stream, state) {
	      if (type == "word") {
	        override = "variable";return "keyframes";
	      }
	      if (type == "{") return pushContext(state, stream, "top");
	      return pass(type, stream, state);
	    };
	
	    states.at = function (type, stream, state) {
	      if (type == ";") return popContext(state);
	      if (type == "{" || type == "}") return popAndPass(type, stream, state);
	      if (type == "word") override = "tag";else if (type == "hash") override = "builtin";
	      return "at";
	    };
	
	    states.interpolation = function (type, stream, state) {
	      if (type == "}") return popContext(state);
	      if (type == "{" || type == ";") return popAndPass(type, stream, state);
	      if (type == "word") override = "variable";else if (type != "variable" && type != "(" && type != ")") override = "error";
	      return "interpolation";
	    };
	
	    return {
	      startState: function startState(base) {
	        return { tokenize: null,
	          state: inline ? "block" : "top",
	          stateArg: null,
	          context: new Context(inline ? "block" : "top", base || 0, null) };
	      },
	
	      token: function token(stream, state) {
	        if (!state.tokenize && stream.eatSpace()) return null;
	        var style = (state.tokenize || tokenBase)(stream, state);
	        if (style && (typeof style === "undefined" ? "undefined" : _typeof(style)) == "object") {
	          type = style[1];
	          style = style[0];
	        }
	        override = style;
	        if (type != "comment") state.state = states[state.state](type, stream, state);
	        return override;
	      },
	
	      indent: function indent(state, textAfter) {
	        var cx = state.context,
	            ch = textAfter && textAfter.charAt(0);
	        var indent = cx.indent;
	        if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
	        if (cx.prev) {
	          if (ch == "}" && (cx.type == "block" || cx.type == "top" || cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
	            // Resume indentation from parent context.
	            cx = cx.prev;
	            indent = cx.indent;
	          } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") || ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
	            // Dedent relative to current context.
	            indent = Math.max(0, cx.indent - indentUnit);
	          }
	        }
	        return indent;
	      },
	
	      electricChars: "}",
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      blockCommentContinue: " * ",
	      lineComment: lineComment,
	      fold: "brace"
	    };
	  });
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) {
	      keys[array[i].toLowerCase()] = true;
	    }
	    return keys;
	  }
	
	  var documentTypes_ = ["domain", "regexp", "url", "url-prefix"],
	      documentTypes = keySet(documentTypes_);
	
	  var mediaTypes_ = ["all", "aural", "braille", "handheld", "print", "projection", "screen", "tty", "tv", "embossed"],
	      mediaTypes = keySet(mediaTypes_);
	
	  var mediaFeatures_ = ["width", "min-width", "max-width", "height", "min-height", "max-height", "device-width", "min-device-width", "max-device-width", "device-height", "min-device-height", "max-device-height", "aspect-ratio", "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio", "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color", "max-color", "color-index", "min-color-index", "max-color-index", "monochrome", "min-monochrome", "max-monochrome", "resolution", "min-resolution", "max-resolution", "scan", "grid", "orientation", "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio", "pointer", "any-pointer", "hover", "any-hover", "prefers-color-scheme", "dynamic-range", "video-dynamic-range"],
	      mediaFeatures = keySet(mediaFeatures_);
	
	  var mediaValueKeywords_ = ["landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover", "interlace", "progressive", "dark", "light", "standard", "high"],
	      mediaValueKeywords = keySet(mediaValueKeywords_);
	
	  var propertyKeywords_ = ["align-content", "align-items", "align-self", "alignment-adjust", "alignment-baseline", "all", "anchor-point", "animation", "animation-delay", "animation-direction", "animation-duration", "animation-fill-mode", "animation-iteration-count", "animation-name", "animation-play-state", "animation-timing-function", "appearance", "azimuth", "backdrop-filter", "backface-visibility", "background", "background-attachment", "background-blend-mode", "background-clip", "background-color", "background-image", "background-origin", "background-position", "background-position-x", "background-position-y", "background-repeat", "background-size", "baseline-shift", "binding", "bleed", "block-size", "bookmark-label", "bookmark-level", "bookmark-state", "bookmark-target", "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius", "border-bottom-right-radius", "border-bottom-style", "border-bottom-width", "border-collapse", "border-color", "border-image", "border-image-outset", "border-image-repeat", "border-image-slice", "border-image-source", "border-image-width", "border-left", "border-left-color", "border-left-style", "border-left-width", "border-radius", "border-right", "border-right-color", "border-right-style", "border-right-width", "border-spacing", "border-style", "border-top", "border-top-color", "border-top-left-radius", "border-top-right-radius", "border-top-style", "border-top-width", "border-width", "bottom", "box-decoration-break", "box-shadow", "box-sizing", "break-after", "break-before", "break-inside", "caption-side", "caret-color", "clear", "clip", "color", "color-profile", "column-count", "column-fill", "column-gap", "column-rule", "column-rule-color", "column-rule-style", "column-rule-width", "column-span", "column-width", "columns", "contain", "content", "counter-increment", "counter-reset", "crop", "cue", "cue-after", "cue-before", "cursor", "direction", "display", "dominant-baseline", "drop-initial-after-adjust", "drop-initial-after-align", "drop-initial-before-adjust", "drop-initial-before-align", "drop-initial-size", "drop-initial-value", "elevation", "empty-cells", "fit", "fit-content", "fit-position", "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap", "float", "float-offset", "flow-from", "flow-into", "font", "font-family", "font-feature-settings", "font-kerning", "font-language-override", "font-optical-sizing", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-synthesis", "font-variant", "font-variant-alternates", "font-variant-caps", "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric", "font-variant-position", "font-variation-settings", "font-weight", "gap", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow", "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap", "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap", "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns", "grid-template-rows", "hanging-punctuation", "height", "hyphens", "icon", "image-orientation", "image-rendering", "image-resolution", "inline-box-align", "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline", "inset-inline-end", "inset-inline-start", "isolation", "justify-content", "justify-items", "justify-self", "left", "letter-spacing", "line-break", "line-height", "line-height-step", "line-stacking", "line-stacking-ruby", "line-stacking-shift", "line-stacking-strategy", "list-style", "list-style-image", "list-style-position", "list-style-type", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "marks", "marquee-direction", "marquee-loop", "marquee-play-count", "marquee-speed", "marquee-style", "mask-clip", "mask-composite", "mask-image", "mask-mode", "mask-origin", "mask-position", "mask-repeat", "mask-size", "mask-type", "max-block-size", "max-height", "max-inline-size", "max-width", "min-block-size", "min-height", "min-inline-size", "min-width", "mix-blend-mode", "move-to", "nav-down", "nav-index", "nav-left", "nav-right", "nav-up", "object-fit", "object-position", "offset", "offset-anchor", "offset-distance", "offset-path", "offset-position", "offset-rotate", "opacity", "order", "orphans", "outline", "outline-color", "outline-offset", "outline-style", "outline-width", "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y", "padding", "padding-bottom", "padding-left", "padding-right", "padding-top", "page", "page-break-after", "page-break-before", "page-break-inside", "page-policy", "pause", "pause-after", "pause-before", "perspective", "perspective-origin", "pitch", "pitch-range", "place-content", "place-items", "place-self", "play-during", "position", "presentation-level", "punctuation-trim", "quotes", "region-break-after", "region-break-before", "region-break-inside", "region-fragment", "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness", "right", "rotate", "rotation", "rotation-point", "row-gap", "ruby-align", "ruby-overhang", "ruby-position", "ruby-span", "scale", "scroll-behavior", "scroll-margin", "scroll-margin-block", "scroll-margin-block-end", "scroll-margin-block-start", "scroll-margin-bottom", "scroll-margin-inline", "scroll-margin-inline-end", "scroll-margin-inline-start", "scroll-margin-left", "scroll-margin-right", "scroll-margin-top", "scroll-padding", "scroll-padding-block", "scroll-padding-block-end", "scroll-padding-block-start", "scroll-padding-bottom", "scroll-padding-inline", "scroll-padding-inline-end", "scroll-padding-inline-start", "scroll-padding-left", "scroll-padding-right", "scroll-padding-top", "scroll-snap-align", "scroll-snap-type", "shape-image-threshold", "shape-inside", "shape-margin", "shape-outside", "size", "speak", "speak-as", "speak-header", "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set", "tab-size", "table-layout", "target", "target-name", "target-new", "target-position", "text-align", "text-align-last", "text-combine-upright", "text-decoration", "text-decoration-color", "text-decoration-line", "text-decoration-skip", "text-decoration-skip-ink", "text-decoration-style", "text-emphasis", "text-emphasis-color", "text-emphasis-position", "text-emphasis-style", "text-height", "text-indent", "text-justify", "text-orientation", "text-outline", "text-overflow", "text-rendering", "text-shadow", "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position", "text-wrap", "top", "touch-action", "transform", "transform-origin", "transform-style", "transition", "transition-delay", "transition-duration", "transition-property", "transition-timing-function", "translate", "unicode-bidi", "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration", "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress", "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break", "word-spacing", "word-wrap", "writing-mode", "z-index",
	  // SVG-specific
	  "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color", "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events", "color-interpolation", "color-interpolation-filters", "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering", "marker", "marker-end", "marker-mid", "marker-start", "paint-order", "shape-rendering", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering", "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal", "glyph-orientation-vertical", "text-anchor", "writing-mode"],
	      propertyKeywords = keySet(propertyKeywords_);
	
	  var nonStandardPropertyKeywords_ = ["accent-color", "aspect-ratio", "border-block", "border-block-color", "border-block-end", "border-block-end-color", "border-block-end-style", "border-block-end-width", "border-block-start", "border-block-start-color", "border-block-start-style", "border-block-start-width", "border-block-style", "border-block-width", "border-inline", "border-inline-color", "border-inline-end", "border-inline-end-color", "border-inline-end-style", "border-inline-end-width", "border-inline-start", "border-inline-start-color", "border-inline-start-style", "border-inline-start-width", "border-inline-style", "border-inline-width", "content-visibility", "margin-block", "margin-block-end", "margin-block-start", "margin-inline", "margin-inline-end", "margin-inline-start", "overflow-anchor", "overscroll-behavior", "padding-block", "padding-block-end", "padding-block-start", "padding-inline", "padding-inline-end", "padding-inline-start", "scroll-snap-stop", "scrollbar-3d-light-color", "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color", "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color", "scrollbar-track-color", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "shape-inside", "zoom"],
	      nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
	
	  var fontProperties_ = ["font-display", "font-family", "src", "unicode-range", "font-variant", "font-feature-settings", "font-stretch", "font-weight", "font-style"],
	      fontProperties = keySet(fontProperties_);
	
	  var counterDescriptors_ = ["additive-symbols", "fallback", "negative", "pad", "prefix", "range", "speak-as", "suffix", "symbols", "system"],
	      counterDescriptors = keySet(counterDescriptors_);
	
	  var colorKeywords_ = ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
	      colorKeywords = keySet(colorKeywords_);
	
	  var valueKeywords_ = ["above", "absolute", "activeborder", "additive", "activecaption", "afar", "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate", "always", "amharic", "amharic-abegede", "antialiased", "appworkspace", "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page", "avoid-region", "axis-pan", "background", "backwards", "baseline", "below", "bidi-override", "binary", "bengali", "blink", "block", "block-axis", "blur", "bold", "bolder", "border", "border-box", "both", "bottom", "break", "break-all", "break-word", "brightness", "bullets", "button", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian", "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret", "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch", "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote", "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse", "compact", "condensed", "conic-gradient", "contain", "content", "contents", "content-box", "context-menu", "continuous", "contrast", "copy", "counter", "counters", "cover", "crop", "cross", "crosshair", "cubic-bezier", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal", "decimal-leading-zero", "default", "default-button", "dense", "destination-atop", "destination-in", "destination-out", "destination-over", "devanagari", "difference", "disc", "discard", "disclosure-closed", "disclosure-open", "document", "dot-dash", "dot-dot-dash", "dotted", "double", "down", "drop-shadow", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out", "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede", "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er", "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er", "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et", "ethiopic-halehame-gez", "ethiopic-halehame-om-et", "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et", "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig", "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed", "extra-expanded", "fantasy", "fast", "fill", "fill-box", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes", "forwards", "from", "geometricPrecision", "georgian", "grayscale", "graytext", "grid", "groove", "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew", "help", "hidden", "hide", "higher", "highlight", "highlighttext", "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "hue-rotate", "icon", "ignore", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite", "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis", "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert", "italic", "japanese-formal", "japanese-informal", "justify", "kannada", "katakana", "katakana-iroha", "keep-all", "khmer", "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal", "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten", "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem", "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian", "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian", "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "manipulation", "match", "matrix", "matrix3d", "media-play-button", "media-slider", "media-sliderthumb", "media-volume-slider", "media-volume-sliderthumb", "medium", "menu", "menulist", "menulist-button", "menutext", "message-box", "middle", "min-intrinsic", "mix", "mongolian", "monospace", "move", "multiple", "multiple_mask_images", "multiply", "myanmar", "n-resize", "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop", "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap", "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote", "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset", "outside", "outside-shape", "overlay", "overline", "padding", "padding-box", "painted", "page", "paused", "persian", "perspective", "pinch-zoom", "plus-darker", "plus-lighter", "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d", "progress", "push-button", "radial-gradient", "radio", "read-only", "read-write", "read-write-plaintext-only", "rectangle", "region", "relative", "repeat", "repeating-linear-gradient", "repeating-radial-gradient", "repeating-conic-gradient", "repeat-x", "repeat-y", "reset", "reverse", "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY", "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running", "s-resize", "sans-serif", "saturate", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen", "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end", "semi-condensed", "semi-expanded", "separate", "sepia", "serif", "show", "sidama", "simp-chinese-formal", "simp-chinese-informal", "single", "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal", "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow", "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali", "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square", "square-button", "start", "static", "status-bar", "stretch", "stroke", "stroke-box", "sub", "subpixel-antialiased", "svg_masks", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row", "table-row-group", "tamil", "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai", "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er", "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top", "trad-chinese-formal", "trad-chinese-informal", "transform", "translate", "translate3d", "translateX", "translateY", "translateZ", "transparent", "ultra-condensed", "ultra-expanded", "underline", "unidirectional-pan", "unset", "up", "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal", "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url", "var", "vertical", "vertical-text", "view-box", "visible", "visibleFill", "visiblePainted", "visibleStroke", "visual", "w-resize", "wait", "wave", "wider", "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor", "xx-large", "xx-small"],
	      valueKeywords = keySet(valueKeywords_);
	
	  var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_).concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_).concat(valueKeywords_);
	  CodeMirror.registerHelper("hintWords", "css", allWords);
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false,
	        ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = ch == "*";
	    }
	    return ["comment", "comment"];
	  }
	
	  CodeMirror.defineMIME("text/css", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    tokenHooks: {
	      "/": function _(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css"
	  });
	
	  CodeMirror.defineMIME("text/x-scss", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    lineComment: "//",
	    tokenHooks: {
	      "/": function _(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      ":": function _(stream) {
	        if (stream.match(/^\s*\{/, false)) return [null, null];
	        return false;
	      },
	      "$": function $(stream) {
	        stream.match(/^[\w-]+/);
	        if (stream.match(/^\s*:/, false)) return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "#": function _(stream) {
	        if (!stream.eat("{")) return false;
	        return [null, "interpolation"];
	      }
	    },
	    name: "css",
	    helperType: "scss"
	  });
	
	  CodeMirror.defineMIME("text/x-less", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    lineComment: "//",
	    tokenHooks: {
	      "/": function _(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      "@": function _(stream) {
	        if (stream.eat("{")) return [null, "interpolation"];
	        if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, false)) return false;
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false)) return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "&": function _() {
	        return ["atom", "atom"];
	      }
	    },
	    name: "css",
	    helperType: "less"
	  });
	
	  CodeMirror.defineMIME("text/x-gss", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    supportsAtComponent: true,
	    tokenHooks: {
	      "/": function _(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css",
	    helperType: "gss"
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	(function (mod) {
	  if (( false ? "undefined" : _typeof(exports)) == "object" && ( false ? "undefined" : _typeof(module)) == "object") // CommonJS
	    mod(__webpack_require__(41));else if (true) // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(41)], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else // Plain browser env
	    mod(CodeMirror);
	})(function (CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("javascript", function (config, parserConfig) {
	    var indentUnit = config.indentUnit;
	    var statementIndent = parserConfig.statementIndent;
	    var jsonldMode = parserConfig.jsonld;
	    var jsonMode = parserConfig.json || jsonldMode;
	    var trackScope = parserConfig.trackScope !== false;
	    var isTS = parserConfig.typescript;
	    var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
	
	    // Tokenizer
	
	    var keywords = function () {
	      function kw(type) {
	        return { type: type, style: "keyword" };
	      }
	      var A = kw("keyword a"),
	          B = kw("keyword b"),
	          C = kw("keyword c"),
	          D = kw("keyword d");
	      var operator = kw("operator"),
	          atom = { type: "atom", style: "atom" };
	
	      return {
	        "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
	        "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
	        "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
	        "function": kw("function"), "catch": kw("catch"),
	        "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	        "in": operator, "typeof": operator, "instanceof": operator,
	        "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
	        "this": kw("this"), "class": kw("class"), "super": kw("atom"),
	        "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
	        "await": C
	      };
	    }();
	
	    var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
	    var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
	
	    function readRegexp(stream) {
	      var escaped = false,
	          next,
	          inSet = false;
	      while ((next = stream.next()) != null) {
	        if (!escaped) {
	          if (next == "/" && !inSet) return;
	          if (next == "[") inSet = true;else if (inSet && next == "]") inSet = false;
	        }
	        escaped = !escaped && next == "\\";
	      }
	    }
	
	    // Used as scratch variables to communicate multiple values without
	    // consing up tons of objects.
	    var type, content;
	    function ret(tp, style, cont) {
	      type = tp;content = cont;
	      return style;
	    }
	    function tokenBase(stream, state) {
	      var ch = stream.next();
	      if (ch == '"' || ch == "'") {
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) {
	        return ret("number", "number");
	      } else if (ch == "." && stream.match("..")) {
	        return ret("spread", "meta");
	      } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	        return ret(ch);
	      } else if (ch == "=" && stream.eat(">")) {
	        return ret("=>", "operator");
	      } else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
	        return ret("number", "number");
	      } else if (/\d/.test(ch)) {
	        stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
	        return ret("number", "number");
	      } else if (ch == "/") {
	        if (stream.eat("*")) {
	          state.tokenize = tokenComment;
	          return tokenComment(stream, state);
	        } else if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ret("comment", "comment");
	        } else if (expressionAllowed(stream, state, 1)) {
	          readRegexp(stream);
	          stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
	          return ret("regexp", "string-2");
	        } else {
	          stream.eat("=");
	          return ret("operator", "operator", stream.current());
	        }
	      } else if (ch == "`") {
	        state.tokenize = tokenQuasi;
	        return tokenQuasi(stream, state);
	      } else if (ch == "#" && stream.peek() == "!") {
	        stream.skipToEnd();
	        return ret("meta", "meta");
	      } else if (ch == "#" && stream.eatWhile(wordRE)) {
	        return ret("variable", "property");
	      } else if (ch == "<" && stream.match("!--") || ch == "-" && stream.match("->") && !/\S/.test(stream.string.slice(0, stream.start))) {
	        stream.skipToEnd();
	        return ret("comment", "comment");
	      } else if (isOperatorChar.test(ch)) {
	        if (ch != ">" || !state.lexical || state.lexical.type != ">") {
	          if (stream.eat("=")) {
	            if (ch == "!" || ch == "=") stream.eat("=");
	          } else if (/[<>*+\-|&?]/.test(ch)) {
	            stream.eat(ch);
	            if (ch == ">") stream.eat(ch);
	          }
	        }
	        if (ch == "?" && stream.eat(".")) return ret(".");
	        return ret("operator", "operator", stream.current());
	      } else if (wordRE.test(ch)) {
	        stream.eatWhile(wordRE);
	        var word = stream.current();
	        if (state.lastType != ".") {
	          if (keywords.propertyIsEnumerable(word)) {
	            var kw = keywords[word];
	            return ret(kw.type, kw.style, word);
	          }
	          if (word == "async" && stream.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, false)) return ret("async", "keyword", word);
	        }
	        return ret("variable", "variable", word);
	      }
	    }
	
	    function tokenString(quote) {
	      return function (stream, state) {
	        var escaped = false,
	            next;
	        if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)) {
	          state.tokenize = tokenBase;
	          return ret("jsonld-keyword", "meta");
	        }
	        while ((next = stream.next()) != null) {
	          if (next == quote && !escaped) break;
	          escaped = !escaped && next == "\\";
	        }
	        if (!escaped) state.tokenize = tokenBase;
	        return ret("string", "string");
	      };
	    }
	
	    function tokenComment(stream, state) {
	      var maybeEnd = false,
	          ch;
	      while (ch = stream.next()) {
	        if (ch == "/" && maybeEnd) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        maybeEnd = ch == "*";
	      }
	      return ret("comment", "comment");
	    }
	
	    function tokenQuasi(stream, state) {
	      var escaped = false,
	          next;
	      while ((next = stream.next()) != null) {
	        if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = !escaped && next == "\\";
	      }
	      return ret("quasi", "string-2", stream.current());
	    }
	
	    var brackets = "([{}])";
	    // This is a crude lookahead trick to try and notice that we're
	    // parsing the argument patterns for a fat-arrow function before we
	    // actually hit the arrow token. It only works if the arrow is on
	    // the same line as the arguments and there's no strange noise
	    // (comments) in between. Fallback is to only notice when we hit the
	    // arrow, and not declare the arguments as locals for the arrow
	    // body.
	    function findFatArrow(stream, state) {
	      if (state.fatArrowAt) state.fatArrowAt = null;
	      var arrow = stream.string.indexOf("=>", stream.start);
	      if (arrow < 0) return;
	
	      if (isTS) {
	        // Try to skip TypeScript return type declarations after the arguments
	        var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow));
	        if (m) arrow = m.index;
	      }
	
	      var depth = 0,
	          sawSomething = false;
	      for (var pos = arrow - 1; pos >= 0; --pos) {
	        var ch = stream.string.charAt(pos);
	        var bracket = brackets.indexOf(ch);
	        if (bracket >= 0 && bracket < 3) {
	          if (!depth) {
	            ++pos;break;
	          }
	          if (--depth == 0) {
	            if (ch == "(") sawSomething = true;break;
	          }
	        } else if (bracket >= 3 && bracket < 6) {
	          ++depth;
	        } else if (wordRE.test(ch)) {
	          sawSomething = true;
	        } else if (/["'\/`]/.test(ch)) {
	          for (;; --pos) {
	            if (pos == 0) return;
	            var next = stream.string.charAt(pos - 1);
	            if (next == ch && stream.string.charAt(pos - 2) != "\\") {
	              pos--;break;
	            }
	          }
	        } else if (sawSomething && !depth) {
	          ++pos;
	          break;
	        }
	      }
	      if (sawSomething && !depth) state.fatArrowAt = pos;
	    }
	
	    // Parser
	
	    var atomicTypes = { "atom": true, "number": true, "variable": true, "string": true,
	      "regexp": true, "this": true, "import": true, "jsonld-keyword": true };
	
	    function JSLexical(indented, column, type, align, prev, info) {
	      this.indented = indented;
	      this.column = column;
	      this.type = type;
	      this.prev = prev;
	      this.info = info;
	      if (align != null) this.align = align;
	    }
	
	    function inScope(state, varname) {
	      if (!trackScope) return false;
	      for (var v = state.localVars; v; v = v.next) {
	        if (v.name == varname) return true;
	      }for (var cx = state.context; cx; cx = cx.prev) {
	        for (var v = cx.vars; v; v = v.next) {
	          if (v.name == varname) return true;
	        }
	      }
	    }
	
	    function parseJS(state, style, type, content, stream) {
	      var cc = state.cc;
	      // Communicate our context to the combinators.
	      // (Less wasteful than consing up a hundred closures on every call.)
	      cx.state = state;cx.stream = stream;cx.marked = null, cx.cc = cc;cx.style = style;
	
	      if (!state.lexical.hasOwnProperty("align")) state.lexical.align = true;
	
	      while (true) {
	        var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
	        if (combinator(type, content)) {
	          while (cc.length && cc[cc.length - 1].lex) {
	            cc.pop()();
	          }if (cx.marked) return cx.marked;
	          if (type == "variable" && inScope(state, content)) return "variable-2";
	          return style;
	        }
	      }
	    }
	
	    // Combinator utils
	
	    var cx = { state: null, column: null, marked: null, cc: null };
	    function pass() {
	      for (var i = arguments.length - 1; i >= 0; i--) {
	        cx.cc.push(arguments[i]);
	      }
	    }
	    function cont() {
	      pass.apply(null, arguments);
	      return true;
	    }
	    function inList(name, list) {
	      for (var v = list; v; v = v.next) {
	        if (v.name == name) return true;
	      }return false;
	    }
	    function register(varname) {
	      var state = cx.state;
	      cx.marked = "def";
	      if (!trackScope) return;
	      if (state.context) {
	        if (state.lexical.info == "var" && state.context && state.context.block) {
	          // FIXME function decls are also not block scoped
	          var newContext = registerVarScoped(varname, state.context);
	          if (newContext != null) {
	            state.context = newContext;
	            return;
	          }
	        } else if (!inList(varname, state.localVars)) {
	          state.localVars = new Var(varname, state.localVars);
	          return;
	        }
	      }
	      // Fall through means this is global
	      if (parserConfig.globalVars && !inList(varname, state.globalVars)) state.globalVars = new Var(varname, state.globalVars);
	    }
	    function registerVarScoped(varname, context) {
	      if (!context) {
	        return null;
	      } else if (context.block) {
	        var inner = registerVarScoped(varname, context.prev);
	        if (!inner) return null;
	        if (inner == context.prev) return context;
	        return new Context(inner, context.vars, true);
	      } else if (inList(varname, context.vars)) {
	        return context;
	      } else {
	        return new Context(context.prev, new Var(varname, context.vars), false);
	      }
	    }
	
	    function isModifier(name) {
	      return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly";
	    }
	
	    // Combinators
	
	    function Context(prev, vars, block) {
	      this.prev = prev;this.vars = vars;this.block = block;
	    }
	    function Var(name, next) {
	      this.name = name;this.next = next;
	    }
	
	    var defaultVars = new Var("this", new Var("arguments", null));
	    function pushcontext() {
	      cx.state.context = new Context(cx.state.context, cx.state.localVars, false);
	      cx.state.localVars = defaultVars;
	    }
	    function pushblockcontext() {
	      cx.state.context = new Context(cx.state.context, cx.state.localVars, true);
	      cx.state.localVars = null;
	    }
	    pushcontext.lex = pushblockcontext.lex = true;
	    function popcontext() {
	      cx.state.localVars = cx.state.context.vars;
	      cx.state.context = cx.state.context.prev;
	    }
	    popcontext.lex = true;
	    function pushlex(type, info) {
	      var result = function result() {
	        var state = cx.state,
	            indent = state.indented;
	        if (state.lexical.type == "stat") indent = state.lexical.indented;else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev) {
	          indent = outer.indented;
	        }state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
	      };
	      result.lex = true;
	      return result;
	    }
	    function poplex() {
	      var state = cx.state;
	      if (state.lexical.prev) {
	        if (state.lexical.type == ")") state.indented = state.lexical.indented;
	        state.lexical = state.lexical.prev;
	      }
	    }
	    poplex.lex = true;
	
	    function expect(wanted) {
	      function exp(type) {
	        if (type == wanted) return cont();else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();else return cont(exp);
	      };
	      return exp;
	    }
	
	    function statement(type, value) {
	      if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
	      if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
	      if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	      if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
	      if (type == "debugger") return cont(expect(";"));
	      if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
	      if (type == ";") return cont();
	      if (type == "if") {
	        if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex) cx.state.cc.pop()();
	        return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
	      }
	      if (type == "function") return cont(functiondef);
	      if (type == "for") return cont(pushlex("form"), pushblockcontext, forspec, statement, popcontext, poplex);
	      if (type == "class" || isTS && value == "interface") {
	        cx.marked = "keyword";
	        return cont(pushlex("form", type == "class" ? type : value), className, poplex);
	      }
	      if (type == "variable") {
	        if (isTS && value == "declare") {
	          cx.marked = "keyword";
	          return cont(statement);
	        } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
	          cx.marked = "keyword";
	          if (value == "enum") return cont(enumdef);else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex);
	        } else if (isTS && value == "namespace") {
	          cx.marked = "keyword";
	          return cont(pushlex("form"), expression, statement, poplex);
	        } else if (isTS && value == "abstract") {
	          cx.marked = "keyword";
	          return cont(statement);
	        } else {
	          return cont(pushlex("stat"), maybelabel);
	        }
	      }
	      if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext, block, poplex, poplex, popcontext);
	      if (type == "case") return cont(expression, expect(":"));
	      if (type == "default") return cont(expect(":"));
	      if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
	      if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
	      if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
	      if (type == "async") return cont(statement);
	      if (value == "@") return cont(expression, statement);
	      return pass(pushlex("stat"), expression, expect(";"), poplex);
	    }
	    function maybeCatchBinding(type) {
	      if (type == "(") return cont(funarg, expect(")"));
	    }
	    function expression(type, value) {
	      return expressionInner(type, value, false);
	    }
	    function expressionNoComma(type, value) {
	      return expressionInner(type, value, true);
	    }
	    function parenExpr(type) {
	      if (type != "(") return pass();
	      return cont(pushlex(")"), maybeexpression, expect(")"), poplex);
	    }
	    function expressionInner(type, value, noComma) {
	      if (cx.state.fatArrowAt == cx.stream.start) {
	        var body = noComma ? arrowBodyNoComma : arrowBody;
	        if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
	      }
	
	      var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
	      if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
	      if (type == "function") return cont(functiondef, maybeop);
	      if (type == "class" || isTS && value == "interface") {
	        cx.marked = "keyword";return cont(pushlex("form"), classExpression, poplex);
	      }
	      if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
	      if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
	      if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
	      if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
	      if (type == "{") return contCommasep(objprop, "}", null, maybeop);
	      if (type == "quasi") return pass(quasi, maybeop);
	      if (type == "new") return cont(maybeTarget(noComma));
	      return cont();
	    }
	    function maybeexpression(type) {
	      if (type.match(/[;\}\)\],]/)) return pass();
	      return pass(expression);
	    }
	
	    function maybeoperatorComma(type, value) {
	      if (type == ",") return cont(maybeexpression);
	      return maybeoperatorNoComma(type, value, false);
	    }
	    function maybeoperatorNoComma(type, value, noComma) {
	      var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
	      var expr = noComma == false ? expression : expressionNoComma;
	      if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
	      if (type == "operator") {
	        if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
	        if (isTS && value == "<" && cx.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, false)) return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
	        if (value == "?") return cont(expression, expect(":"), expr);
	        return cont(expr);
	      }
	      if (type == "quasi") {
	        return pass(quasi, me);
	      }
	      if (type == ";") return;
	      if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
	      if (type == ".") return cont(property, me);
	      if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
	      if (isTS && value == "as") {
	        cx.marked = "keyword";return cont(typeexpr, me);
	      }
	      if (type == "regexp") {
	        cx.state.lastType = cx.marked = "operator";
	        cx.stream.backUp(cx.stream.pos - cx.stream.start - 1);
	        return cont(expr);
	      }
	    }
	    function quasi(type, value) {
	      if (type != "quasi") return pass();
	      if (value.slice(value.length - 2) != "${") return cont(quasi);
	      return cont(maybeexpression, continueQuasi);
	    }
	    function continueQuasi(type) {
	      if (type == "}") {
	        cx.marked = "string-2";
	        cx.state.tokenize = tokenQuasi;
	        return cont(quasi);
	      }
	    }
	    function arrowBody(type) {
	      findFatArrow(cx.stream, cx.state);
	      return pass(type == "{" ? statement : expression);
	    }
	    function arrowBodyNoComma(type) {
	      findFatArrow(cx.stream, cx.state);
	      return pass(type == "{" ? statement : expressionNoComma);
	    }
	    function maybeTarget(noComma) {
	      return function (type) {
	        if (type == ".") return cont(noComma ? targetNoComma : target);else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma);else return pass(noComma ? expressionNoComma : expression);
	      };
	    }
	    function target(_, value) {
	      if (value == "target") {
	        cx.marked = "keyword";return cont(maybeoperatorComma);
	      }
	    }
	    function targetNoComma(_, value) {
	      if (value == "target") {
	        cx.marked = "keyword";return cont(maybeoperatorNoComma);
	      }
	    }
	    function maybelabel(type) {
	      if (type == ":") return cont(poplex, statement);
	      return pass(maybeoperatorComma, expect(";"), poplex);
	    }
	    function property(type) {
	      if (type == "variable") {
	        cx.marked = "property";return cont();
	      }
	    }
	    function objprop(type, value) {
	      if (type == "async") {
	        cx.marked = "property";
	        return cont(objprop);
	      } else if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        if (value == "get" || value == "set") return cont(getterSetter);
	        var m; // Work around fat-arrow-detection complication for detecting typescript typed arrow params
	        if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false))) cx.state.fatArrowAt = cx.stream.pos + m[0].length;
	        return cont(afterprop);
	      } else if (type == "number" || type == "string") {
	        cx.marked = jsonldMode ? "property" : cx.style + " property";
	        return cont(afterprop);
	      } else if (type == "jsonld-keyword") {
	        return cont(afterprop);
	      } else if (isTS && isModifier(value)) {
	        cx.marked = "keyword";
	        return cont(objprop);
	      } else if (type == "[") {
	        return cont(expression, maybetype, expect("]"), afterprop);
	      } else if (type == "spread") {
	        return cont(expressionNoComma, afterprop);
	      } else if (value == "*") {
	        cx.marked = "keyword";
	        return cont(objprop);
	      } else if (type == ":") {
	        return pass(afterprop);
	      }
	    }
	    function getterSetter(type) {
	      if (type != "variable") return pass(afterprop);
	      cx.marked = "property";
	      return cont(functiondef);
	    }
	    function afterprop(type) {
	      if (type == ":") return cont(expressionNoComma);
	      if (type == "(") return pass(functiondef);
	    }
	    function commasep(what, end, sep) {
	      function proceed(type, value) {
	        if (sep ? sep.indexOf(type) > -1 : type == ",") {
	          var lex = cx.state.lexical;
	          if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
	          return cont(function (type, value) {
	            if (type == end || value == end) return pass();
	            return pass(what);
	          }, proceed);
	        }
	        if (type == end || value == end) return cont();
	        if (sep && sep.indexOf(";") > -1) return pass(what);
	        return cont(expect(end));
	      }
	      return function (type, value) {
	        if (type == end || value == end) return cont();
	        return pass(what, proceed);
	      };
	    }
	    function contCommasep(what, end, info) {
	      for (var i = 3; i < arguments.length; i++) {
	        cx.cc.push(arguments[i]);
	      }return cont(pushlex(end, info), commasep(what, end), poplex);
	    }
	    function block(type) {
	      if (type == "}") return cont();
	      return pass(statement, block);
	    }
	    function maybetype(type, value) {
	      if (isTS) {
	        if (type == ":") return cont(typeexpr);
	        if (value == "?") return cont(maybetype);
	      }
	    }
	    function maybetypeOrIn(type, value) {
	      if (isTS && (type == ":" || value == "in")) return cont(typeexpr);
	    }
	    function mayberettype(type) {
	      if (isTS && type == ":") {
	        if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr);else return cont(typeexpr);
	      }
	    }
	    function isKW(_, value) {
	      if (value == "is") {
	        cx.marked = "keyword";
	        return cont();
	      }
	    }
	    function typeexpr(type, value) {
	      if (value == "keyof" || value == "typeof" || value == "infer" || value == "readonly") {
	        cx.marked = "keyword";
	        return cont(value == "typeof" ? expressionNoComma : typeexpr);
	      }
	      if (type == "variable" || value == "void") {
	        cx.marked = "type";
	        return cont(afterType);
	      }
	      if (value == "|" || value == "&") return cont(typeexpr);
	      if (type == "string" || type == "number" || type == "atom") return cont(afterType);
	      if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType);
	      if (type == "{") return cont(pushlex("}"), typeprops, poplex, afterType);
	      if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType);
	      if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr);
	      if (type == "quasi") {
	        return pass(quasiType, afterType);
	      }
	    }
	    function maybeReturnType(type) {
	      if (type == "=>") return cont(typeexpr);
	    }
	    function typeprops(type) {
	      if (type.match(/[\}\)\]]/)) return cont();
	      if (type == "," || type == ";") return cont(typeprops);
	      return pass(typeprop, typeprops);
	    }
	    function typeprop(type, value) {
	      if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        return cont(typeprop);
	      } else if (value == "?" || type == "number" || type == "string") {
	        return cont(typeprop);
	      } else if (type == ":") {
	        return cont(typeexpr);
	      } else if (type == "[") {
	        return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop);
	      } else if (type == "(") {
	        return pass(functiondecl, typeprop);
	      } else if (!type.match(/[;\}\)\],]/)) {
	        return cont();
	      }
	    }
	    function quasiType(type, value) {
	      if (type != "quasi") return pass();
	      if (value.slice(value.length - 2) != "${") return cont(quasiType);
	      return cont(typeexpr, continueQuasiType);
	    }
	    function continueQuasiType(type) {
	      if (type == "}") {
	        cx.marked = "string-2";
	        cx.state.tokenize = tokenQuasi;
	        return cont(quasiType);
	      }
	    }
	    function typearg(type, value) {
	      if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg);
	      if (type == ":") return cont(typeexpr);
	      if (type == "spread") return cont(typearg);
	      return pass(typeexpr);
	    }
	    function afterType(type, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
	      if (value == "|" || type == "." || value == "&") return cont(typeexpr);
	      if (type == "[") return cont(typeexpr, expect("]"), afterType);
	      if (value == "extends" || value == "implements") {
	        cx.marked = "keyword";return cont(typeexpr);
	      }
	      if (value == "?") return cont(typeexpr, expect(":"), typeexpr);
	    }
	    function maybeTypeArgs(_, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
	    }
	    function typeparam() {
	      return pass(typeexpr, maybeTypeDefault);
	    }
	    function maybeTypeDefault(_, value) {
	      if (value == "=") return cont(typeexpr);
	    }
	    function vardef(_, value) {
	      if (value == "enum") {
	        cx.marked = "keyword";return cont(enumdef);
	      }
	      return pass(pattern, maybetype, maybeAssign, vardefCont);
	    }
	    function pattern(type, value) {
	      if (isTS && isModifier(value)) {
	        cx.marked = "keyword";return cont(pattern);
	      }
	      if (type == "variable") {
	        register(value);return cont();
	      }
	      if (type == "spread") return cont(pattern);
	      if (type == "[") return contCommasep(eltpattern, "]");
	      if (type == "{") return contCommasep(proppattern, "}");
	    }
	    function proppattern(type, value) {
	      if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
	        register(value);
	        return cont(maybeAssign);
	      }
	      if (type == "variable") cx.marked = "property";
	      if (type == "spread") return cont(pattern);
	      if (type == "}") return pass();
	      if (type == "[") return cont(expression, expect(']'), expect(':'), proppattern);
	      return cont(expect(":"), pattern, maybeAssign);
	    }
	    function eltpattern() {
	      return pass(pattern, maybeAssign);
	    }
	    function maybeAssign(_type, value) {
	      if (value == "=") return cont(expressionNoComma);
	    }
	    function vardefCont(type) {
	      if (type == ",") return cont(vardef);
	    }
	    function maybeelse(type, value) {
	      if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
	    }
	    function forspec(type, value) {
	      if (value == "await") return cont(forspec);
	      if (type == "(") return cont(pushlex(")"), forspec1, poplex);
	    }
	    function forspec1(type) {
	      if (type == "var") return cont(vardef, forspec2);
	      if (type == "variable") return cont(forspec2);
	      return pass(forspec2);
	    }
	    function forspec2(type, value) {
	      if (type == ")") return cont();
	      if (type == ";") return cont(forspec2);
	      if (value == "in" || value == "of") {
	        cx.marked = "keyword";return cont(expression, forspec2);
	      }
	      return pass(expression, forspec2);
	    }
	    function functiondef(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(functiondef);
	      }
	      if (type == "variable") {
	        register(value);return cont(functiondef);
	      }
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
	      if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef);
	    }
	    function functiondecl(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(functiondecl);
	      }
	      if (type == "variable") {
	        register(value);return cont(functiondecl);
	      }
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
	      if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl);
	    }
	    function typename(type, value) {
	      if (type == "keyword" || type == "variable") {
	        cx.marked = "type";
	        return cont(typename);
	      } else if (value == "<") {
	        return cont(pushlex(">"), commasep(typeparam, ">"), poplex);
	      }
	    }
	    function funarg(type, value) {
	      if (value == "@") cont(expression, funarg);
	      if (type == "spread") return cont(funarg);
	      if (isTS && isModifier(value)) {
	        cx.marked = "keyword";return cont(funarg);
	      }
	      if (isTS && type == "this") return cont(maybetype, maybeAssign);
	      return pass(pattern, maybetype, maybeAssign);
	    }
	    function classExpression(type, value) {
	      // Class expressions may have an optional name.
	      if (type == "variable") return className(type, value);
	      return classNameAfter(type, value);
	    }
	    function className(type, value) {
	      if (type == "variable") {
	        register(value);return cont(classNameAfter);
	      }
	    }
	    function classNameAfter(type, value) {
	      if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter);
	      if (value == "extends" || value == "implements" || isTS && type == ",") {
	        if (value == "implements") cx.marked = "keyword";
	        return cont(isTS ? typeexpr : expression, classNameAfter);
	      }
	      if (type == "{") return cont(pushlex("}"), classBody, poplex);
	    }
	    function classBody(type, value) {
	      if (type == "async" || type == "variable" && (value == "static" || value == "get" || value == "set" || isTS && isModifier(value)) && cx.stream.match(/^\s+#?[\w$\xa1-\uffff]/, false)) {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      if (type == "variable" || cx.style == "keyword") {
	        cx.marked = "property";
	        return cont(classfield, classBody);
	      }
	      if (type == "number" || type == "string") return cont(classfield, classBody);
	      if (type == "[") return cont(expression, maybetype, expect("]"), classfield, classBody);
	      if (value == "*") {
	        cx.marked = "keyword";
	        return cont(classBody);
	      }
	      if (isTS && type == "(") return pass(functiondecl, classBody);
	      if (type == ";" || type == ",") return cont(classBody);
	      if (type == "}") return cont();
	      if (value == "@") return cont(expression, classBody);
	    }
	    function classfield(type, value) {
	      if (value == "!") return cont(classfield);
	      if (value == "?") return cont(classfield);
	      if (type == ":") return cont(typeexpr, maybeAssign);
	      if (value == "=") return cont(expressionNoComma);
	      var context = cx.state.lexical.prev,
	          isInterface = context && context.info == "interface";
	      return pass(isInterface ? functiondecl : functiondef);
	    }
	    function afterExport(type, value) {
	      if (value == "*") {
	        cx.marked = "keyword";return cont(maybeFrom, expect(";"));
	      }
	      if (value == "default") {
	        cx.marked = "keyword";return cont(expression, expect(";"));
	      }
	      if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
	      return pass(statement);
	    }
	    function exportField(type, value) {
	      if (value == "as") {
	        cx.marked = "keyword";return cont(expect("variable"));
	      }
	      if (type == "variable") return pass(expressionNoComma, exportField);
	    }
	    function afterImport(type) {
	      if (type == "string") return cont();
	      if (type == "(") return pass(expression);
	      if (type == ".") return pass(maybeoperatorComma);
	      return pass(importSpec, maybeMoreImports, maybeFrom);
	    }
	    function importSpec(type, value) {
	      if (type == "{") return contCommasep(importSpec, "}");
	      if (type == "variable") register(value);
	      if (value == "*") cx.marked = "keyword";
	      return cont(maybeAs);
	    }
	    function maybeMoreImports(type) {
	      if (type == ",") return cont(importSpec, maybeMoreImports);
	    }
	    function maybeAs(_type, value) {
	      if (value == "as") {
	        cx.marked = "keyword";return cont(importSpec);
	      }
	    }
	    function maybeFrom(_type, value) {
	      if (value == "from") {
	        cx.marked = "keyword";return cont(expression);
	      }
	    }
	    function arrayLiteral(type) {
	      if (type == "]") return cont();
	      return pass(commasep(expressionNoComma, "]"));
	    }
	    function enumdef() {
	      return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex);
	    }
	    function enummember() {
	      return pass(pattern, maybeAssign);
	    }
	
	    function isContinuedStatement(state, textAfter) {
	      return state.lastType == "operator" || state.lastType == "," || isOperatorChar.test(textAfter.charAt(0)) || /[,.]/.test(textAfter.charAt(0));
	    }
	
	    function expressionAllowed(stream, state, backUp) {
	      return state.tokenize == tokenBase && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) || state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0)));
	    }
	
	    // Interface
	
	    return {
	      startState: function startState(basecolumn) {
	        var state = {
	          tokenize: tokenBase,
	          lastType: "sof",
	          cc: [],
	          lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	          localVars: parserConfig.localVars,
	          context: parserConfig.localVars && new Context(null, null, false),
	          indented: basecolumn || 0
	        };
	        if (parserConfig.globalVars && _typeof(parserConfig.globalVars) == "object") state.globalVars = parserConfig.globalVars;
	        return state;
	      },
	
	      token: function token(stream, state) {
	        if (stream.sol()) {
	          if (!state.lexical.hasOwnProperty("align")) state.lexical.align = false;
	          state.indented = stream.indentation();
	          findFatArrow(stream, state);
	        }
	        if (state.tokenize != tokenComment && stream.eatSpace()) return null;
	        var style = state.tokenize(stream, state);
	        if (type == "comment") return style;
	        state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
	        return parseJS(state, style, type, content, stream);
	      },
	
	      indent: function indent(state, textAfter) {
	        if (state.tokenize == tokenComment || state.tokenize == tokenQuasi) return CodeMirror.Pass;
	        if (state.tokenize != tokenBase) return 0;
	        var firstChar = textAfter && textAfter.charAt(0),
	            lexical = state.lexical,
	            top;
	        // Kludge to prevent 'maybelse' from blocking lexical scope pops
	        if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
	          var c = state.cc[i];
	          if (c == poplex) lexical = lexical.prev;else if (c != maybeelse && c != popcontext) break;
	        }
	        while ((lexical.type == "stat" || lexical.type == "form") && (firstChar == "}" || (top = state.cc[state.cc.length - 1]) && (top == maybeoperatorComma || top == maybeoperatorNoComma) && !/^[,\.=+\-*:?[\(]/.test(textAfter))) {
	          lexical = lexical.prev;
	        }if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat") lexical = lexical.prev;
	        var type = lexical.type,
	            closing = firstChar == type;
	
	        if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);else if (type == "form" && firstChar == "{") return lexical.indented;else if (type == "form") return lexical.indented + indentUnit;else if (type == "stat") return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false) return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);else if (lexical.align) return lexical.column + (closing ? 0 : 1);else return lexical.indented + (closing ? 0 : indentUnit);
	      },
	
	      electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
	      blockCommentStart: jsonMode ? null : "/*",
	      blockCommentEnd: jsonMode ? null : "*/",
	      blockCommentContinue: jsonMode ? null : " * ",
	      lineComment: jsonMode ? null : "//",
	      fold: "brace",
	      closeBrackets: "()[]{}''\"\"``",
	
	      helperType: jsonMode ? "json" : "javascript",
	      jsonldMode: jsonldMode,
	      jsonMode: jsonMode,
	
	      expressionAllowed: expressionAllowed,
	
	      skipExpression: function skipExpression(state) {
	        parseJS(state, "atom", "atom", "true", new CodeMirror.StringStream("", 2, null));
	      }
	    };
	  });
	
	  CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
	
	  CodeMirror.defineMIME("text/javascript", "javascript");
	  CodeMirror.defineMIME("text/ecmascript", "javascript");
	  CodeMirror.defineMIME("application/javascript", "javascript");
	  CodeMirror.defineMIME("application/x-javascript", "javascript");
	  CodeMirror.defineMIME("application/ecmascript", "javascript");
	  CodeMirror.defineMIME("application/json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/x-json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/manifest+json", { name: "javascript", json: true });
	  CodeMirror.defineMIME("application/ld+json", { name: "javascript", jsonld: true });
	  CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
	  CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)(module)))

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(84);
	var PropTypes = __webpack_require__(6);
	var className = __webpack_require__(11);
	var debounce = __webpack_require__(2109);
	var isEqual = __webpack_require__(1886);
	var createReactClass = __webpack_require__(2116);
	
	function normalizeLineEndings(str) {
		if (!str) return str;
		return str.replace(/\r\n|\r/g, '\n');
	}
	
	var CodeMirror = createReactClass({
		displayName: 'CodeMirror',
	
		propTypes: {
			autoFocus: PropTypes.bool,
			className: PropTypes.any,
			codeMirrorInstance: PropTypes.func,
			defaultValue: PropTypes.string,
			name: PropTypes.string,
			onChange: PropTypes.func,
			onCursorActivity: PropTypes.func,
			onFocusChange: PropTypes.func,
			onScroll: PropTypes.func,
			options: PropTypes.object,
			path: PropTypes.string,
			value: PropTypes.string,
			preserveScrollPosition: PropTypes.bool
		},
		getDefaultProps: function getDefaultProps() {
			return {
				preserveScrollPosition: false
			};
		},
		getCodeMirrorInstance: function getCodeMirrorInstance() {
			return this.props.codeMirrorInstance || __webpack_require__(41);
		},
		getInitialState: function getInitialState() {
			return {
				isFocused: false
			};
		},
		componentWillMount: function componentWillMount() {
			this.componentWillReceiveProps = debounce(this.componentWillReceiveProps, 0);
			if (this.props.path) {
				console.error('Warning: react-codemirror: the `path` prop has been changed to `name`');
			}
		},
		componentDidMount: function componentDidMount() {
			var codeMirrorInstance = this.getCodeMirrorInstance();
			this.codeMirror = codeMirrorInstance.fromTextArea(this.textareaNode, this.props.options);
			this.codeMirror.on('change', this.codemirrorValueChanged);
			this.codeMirror.on('cursorActivity', this.cursorActivity);
			this.codeMirror.on('focus', this.focusChanged.bind(this, true));
			this.codeMirror.on('blur', this.focusChanged.bind(this, false));
			this.codeMirror.on('scroll', this.scrollChanged);
			this.codeMirror.setValue(this.props.defaultValue || this.props.value || '');
		},
		componentWillUnmount: function componentWillUnmount() {
			// is there a lighter-weight way to remove the cm instance?
			if (this.codeMirror) {
				this.codeMirror.toTextArea();
			}
		},
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			if (this.codeMirror && nextProps.value !== undefined && nextProps.value !== this.props.value && normalizeLineEndings(this.codeMirror.getValue()) !== normalizeLineEndings(nextProps.value)) {
				if (this.props.preserveScrollPosition) {
					var prevScrollPosition = this.codeMirror.getScrollInfo();
					this.codeMirror.setValue(nextProps.value);
					this.codeMirror.scrollTo(prevScrollPosition.left, prevScrollPosition.top);
				} else {
					this.codeMirror.setValue(nextProps.value);
				}
			}
			if (_typeof(nextProps.options) === 'object') {
				for (var optionName in nextProps.options) {
					if (nextProps.options.hasOwnProperty(optionName)) {
						this.setOptionIfChanged(optionName, nextProps.options[optionName]);
					}
				}
			}
		},
		setOptionIfChanged: function setOptionIfChanged(optionName, newValue) {
			var oldValue = this.codeMirror.getOption(optionName);
			if (!isEqual(oldValue, newValue)) {
				this.codeMirror.setOption(optionName, newValue);
			}
		},
		getCodeMirror: function getCodeMirror() {
			return this.codeMirror;
		},
		focus: function focus() {
			if (this.codeMirror) {
				this.codeMirror.focus();
			}
		},
		focusChanged: function focusChanged(focused) {
			this.setState({
				isFocused: focused
			});
			this.props.onFocusChange && this.props.onFocusChange(focused);
		},
		cursorActivity: function cursorActivity(cm) {
			this.props.onCursorActivity && this.props.onCursorActivity(cm);
		},
		scrollChanged: function scrollChanged(cm) {
			this.props.onScroll && this.props.onScroll(cm.getScrollInfo());
		},
		codemirrorValueChanged: function codemirrorValueChanged(doc, change) {
			if (this.props.onChange && change.origin !== 'setValue') {
				this.props.onChange(doc.getValue(), change);
			}
		},
		render: function render() {
			var _this = this;
	
			var editorClassName = className('ReactCodeMirror', this.state.isFocused ? 'ReactCodeMirror--focused' : null, this.props.className);
			return React.createElement('div', { className: editorClassName }, React.createElement('textarea', {
				ref: function ref(_ref) {
					return _this.textareaNode = _ref;
				},
				name: this.props.name || this.props.path,
				defaultValue: this.props.value,
				autoComplete: 'off',
				autoFocus: this.props.autoFocus
			}));
		}
	});
	
	module.exports = CodeMirror;

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(56);
	
	var focusNode = __webpack_require__(926);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function focusDOMComponent() {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var EventPropagators = __webpack_require__(210);
	var ExecutionEnvironment = __webpack_require__(90);
	var FallbackCompositionState = __webpack_require__(1502);
	var SyntheticCompositionEvent = __webpack_require__(1539);
	var SyntheticInputEvent = __webpack_require__(1542);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return (typeof opera === 'undefined' ? 'undefined' : _typeof(opera)) === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if ((typeof detail === 'undefined' ? 'undefined' : _typeof(detail)) === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(768);
	var ExecutionEnvironment = __webpack_require__(90);
	var ReactInstrumentation = __webpack_require__(94);
	
	var camelizeStyleName = __webpack_require__(2117);
	var dangerousStyleValue = __webpack_require__(1548);
	var hyphenateStyleName = __webpack_require__(2119);
	var memoizeStringOnly = __webpack_require__(2108);
	var warning = __webpack_require__(44);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function warnValidStyle(name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function createMarkupForStyles(styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function setValueForStyles(node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(209);
	var EventPropagators = __webpack_require__(210);
	var ExecutionEnvironment = __webpack_require__(90);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactUpdates = __webpack_require__(101);
	var SyntheticEvent = __webpack_require__(111);
	
	var inputValueTracking = __webpack_require__(784);
	var getEventTarget = __webpack_require__(405);
	var isEventSupported = __webpack_require__(406);
	var isTextInputElement = __webpack_require__(786);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var DOMLazyTree = __webpack_require__(165);
	var ExecutionEnvironment = __webpack_require__(90);
	
	var createNodesFromMarkup = __webpack_require__(2118);
	var emptyFunction = __webpack_require__(120);
	var invariant = __webpack_require__(32);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function dangerouslyReplaceNodeWithMarkup(oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(210);
	var ReactDOMComponentTree = __webpack_require__(56);
	var SyntheticMouseEvent = __webpack_require__(261);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var PooledClass = __webpack_require__(139);
	
	var getTextContentAccessor = __webpack_require__(783);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function destructor() {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function getText() {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function getData() {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(166);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function value(node, _value) {
	      if (_value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + _value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + _value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(167);
	
	var instantiateReactComponent = __webpack_require__(785);
	var KeyEscapeUtils = __webpack_require__(397);
	var shouldUpdateReactComponent = __webpack_require__(407);
	var traverseAllChildren = __webpack_require__(788);
	var warning = __webpack_require__(44);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(790);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function instantiateChildren(nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function unmountChildren(renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(470)))

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(393);
	var ReactDOMIDOperations = __webpack_require__(1512);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(53);
	
	var React = __webpack_require__(168);
	var ReactComponentEnvironment = __webpack_require__(399);
	var ReactCurrentOwner = __webpack_require__(112);
	var ReactErrorUtils = __webpack_require__(400);
	var ReactInstanceMap = __webpack_require__(211);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactNodeTypes = __webpack_require__(778);
	var ReactReconciler = __webpack_require__(167);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(287);
	var invariant = __webpack_require__(32);
	var shallowEqual = __webpack_require__(490);
	var shouldUpdateReactComponent = __webpack_require__(407);
	var warning = __webpack_require__(44);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function construct(element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !((typeof initialState === 'undefined' ? 'undefined' : _typeof(initialState)) === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function _constructComponent(doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function _constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function getHostNode() {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function unmountComponent(safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function _maskContext(context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function _processContext(context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function _processChildContext(currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(_typeof(Component.childContextTypes) === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function _checkContextTypes(typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function receiveComponent(nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function performUpdateIfNecessary(transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function updateComponent(transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function _processPendingState(props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function _performComponentUpdate(nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function _updateRenderedComponent(transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function _replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function _renderValidatedComponentWithoutOwnerOrContext() {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function _renderValidatedComponent() {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function attachRef(ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function detachRef(ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function getName() {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function getPublicInstance() {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactDefaultInjection = __webpack_require__(1520);
	var ReactMount = __webpack_require__(777);
	var ReactReconciler = __webpack_require__(167);
	var ReactUpdates = __webpack_require__(101);
	var ReactVersion = __webpack_require__(1533);
	
	var findDOMNode = __webpack_require__(1549);
	var getHostComponentFromComposite = __webpack_require__(782);
	var renderSubtreeIntoContainer = __webpack_require__(1556);
	var warning = __webpack_require__(44);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function getNodeFromInstance(inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(53);
	
	var AutoFocusUtils = __webpack_require__(1495);
	var CSSPropertyOperations = __webpack_require__(1497);
	var DOMLazyTree = __webpack_require__(165);
	var DOMNamespaces = __webpack_require__(394);
	var DOMProperty = __webpack_require__(166);
	var DOMPropertyOperations = __webpack_require__(770);
	var EventPluginHub = __webpack_require__(209);
	var EventPluginRegistry = __webpack_require__(395);
	var ReactBrowserEventEmitter = __webpack_require__(260);
	var ReactDOMComponentFlags = __webpack_require__(771);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactDOMInput = __webpack_require__(1513);
	var ReactDOMOption = __webpack_require__(1514);
	var ReactDOMSelect = __webpack_require__(772);
	var ReactDOMTextarea = __webpack_require__(1517);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactMultiChild = __webpack_require__(1526);
	var ReactServerRenderingTransaction = __webpack_require__(1531);
	
	var emptyFunction = __webpack_require__(120);
	var escapeTextContentForBrowser = __webpack_require__(263);
	var invariant = __webpack_require__(32);
	var isEventSupported = __webpack_require__(406);
	var shallowEqual = __webpack_require__(490);
	var inputValueTracking = __webpack_require__(784);
	var validateDOMNesting = __webpack_require__(408);
	var warning = __webpack_require__(44);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(_typeof(props.dangerouslySetInnerHTML) === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || _typeof(props.style) === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function setAndValidateContentChildDev(content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function _createOpenTagMarkupAndPutListeners(transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function _createContentMarkup(transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[_typeof(props.children)] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function _createInitialChildren(transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[_typeof(props.children)] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function receiveComponent(nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function updateComponent(transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function _updateDOMProperties(lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function _updateDOMChildren(lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[_typeof(lastProps.children)] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[_typeof(nextProps.children)] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function getHostNode() {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function unmountComponent(safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function getPublicInstance() {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(408);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var DOMLazyTree = __webpack_require__(165);
	var ReactDOMComponentTree = __webpack_require__(56);
	
	var ReactDOMEmptyComponent = function ReactDOMEmptyComponent(instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function receiveComponent() {},
	  getHostNode: function getHostNode() {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function unmountComponent() {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(393);
	var ReactDOMComponentTree = __webpack_require__(56);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function dangerouslyProcessChildrenUpdates(parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(53);
	
	var DOMPropertyOperations = __webpack_require__(770);
	var LinkedValueUtils = __webpack_require__(398);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactUpdates = __webpack_require__(101);
	
	var invariant = __webpack_require__(32);
	var warning = __webpack_require__(44);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function getHostProps(inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function mountWrapper(inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function updateWrapper(inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function postMountWrapper(inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var React = __webpack_require__(168);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactDOMSelect = __webpack_require__(772);
	
	var warning = __webpack_require__(44);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function mountWrapper(inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function postMountWrapper(inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function getHostProps(inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(90);
	
	var getNodeForCharacterOffset = __webpack_require__(1553);
	var getTextContentAccessor = __webpack_require__(783);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(53);
	
	var DOMChildrenOperations = __webpack_require__(393);
	var DOMLazyTree = __webpack_require__(165);
	var ReactDOMComponentTree = __webpack_require__(56);
	
	var escapeTextContentForBrowser = __webpack_require__(263);
	var invariant = __webpack_require__(32);
	var validateDOMNesting = __webpack_require__(408);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function ReactDOMTextComponent(text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function receiveComponent(nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function getHostNode() {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function unmountComponent() {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46),
	    _assign = __webpack_require__(53);
	
	var LinkedValueUtils = __webpack_require__(398);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactUpdates = __webpack_require__(101);
	
	var invariant = __webpack_require__(32);
	var warning = __webpack_require__(44);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function getHostProps(inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function mountWrapper(inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function updateWrapper(inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function postMountWrapper(inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var ReactUpdates = __webpack_require__(101);
	var Transaction = __webpack_require__(262);
	
	var emptyFunction = __webpack_require__(120);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function close() {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function getTransactionWrappers() {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function batchedUpdates(callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1494);
	var BeforeInputEventPlugin = __webpack_require__(1496);
	var ChangeEventPlugin = __webpack_require__(1498);
	var DefaultEventPluginOrder = __webpack_require__(1500);
	var EnterLeaveEventPlugin = __webpack_require__(1501);
	var HTMLDOMPropertyConfig = __webpack_require__(1503);
	var ReactComponentBrowserEnvironment = __webpack_require__(1505);
	var ReactDOMComponent = __webpack_require__(1508);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactDOMEmptyComponent = __webpack_require__(1510);
	var ReactDOMTreeTraversal = __webpack_require__(1518);
	var ReactDOMTextComponent = __webpack_require__(1516);
	var ReactDefaultBatchingStrategy = __webpack_require__(1519);
	var ReactEventListener = __webpack_require__(1523);
	var ReactInjection = __webpack_require__(1524);
	var ReactReconcileTransaction = __webpack_require__(1529);
	var SVGDOMPropertyConfig = __webpack_require__(1534);
	var SelectEventPlugin = __webpack_require__(1535);
	var SimpleEventPlugin = __webpack_require__(1536);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(209);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function handleTopLevel(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var EventListener = __webpack_require__(925);
	var ExecutionEnvironment = __webpack_require__(90);
	var PooledClass = __webpack_require__(139);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactUpdates = __webpack_require__(101);
	
	var getEventTarget = __webpack_require__(405);
	var getUnboundedScrollPosition = __webpack_require__(2107);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function destructor() {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function setHandleTopLevel(handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function setEnabled(enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function isEnabled() {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function trapBubbledEvent(topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function trapCapturedEvent(topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function monitorScrollValue(refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function dispatchEvent(topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(166);
	var EventPluginHub = __webpack_require__(209);
	var EventPluginUtils = __webpack_require__(396);
	var ReactComponentEnvironment = __webpack_require__(399);
	var ReactEmptyComponent = __webpack_require__(773);
	var ReactBrowserEventEmitter = __webpack_require__(260);
	var ReactHostComponent = __webpack_require__(775);
	var ReactUpdates = __webpack_require__(101);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1547);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function addChecksumToMarkup(markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function canReuseMarkup(markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactComponentEnvironment = __webpack_require__(399);
	var ReactInstanceMap = __webpack_require__(211);
	var ReactInstrumentation = __webpack_require__(94);
	
	var ReactCurrentOwner = __webpack_require__(112);
	var ReactReconciler = __webpack_require__(167);
	var ReactChildReconciler = __webpack_require__(1504);
	
	var emptyFunction = __webpack_require__(120);
	var flattenChildren = __webpack_require__(1550);
	var invariant = __webpack_require__(32);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function getDebugID(inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function setChildrenForInstrumentation(children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function _reconcilerInstantiateChildren(nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function _reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function mountChildren(nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function updateTextContent(nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function updateMarkup(nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function updateChildren(nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function _updateChildren(nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function unmountChildren(safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function moveChild(child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function createChild(child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function removeChild(child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function _mountChildAtIndex(child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function _unmountChild(child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function addComponentAsRefTo(component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function removeComponentAsRefFrom(component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var CallbackQueue = __webpack_require__(769);
	var PooledClass = __webpack_require__(139);
	var ReactBrowserEventEmitter = __webpack_require__(260);
	var ReactInputSelection = __webpack_require__(776);
	var ReactInstrumentation = __webpack_require__(94);
	var Transaction = __webpack_require__(262);
	var ReactUpdateQueue = __webpack_require__(401);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function initialize() {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function close(previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function initialize() {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function close() {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function getTransactionWrappers() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function getReactMountReady() {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function getUpdateQueue() {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function checkpoint() {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function rollback(checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function destructor() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var ReactOwner = __webpack_require__(1527);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || (typeof element === 'undefined' ? 'undefined' : _typeof(element)) !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && (typeof prevElement === 'undefined' ? 'undefined' : _typeof(prevElement)) === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && (typeof nextElement === 'undefined' ? 'undefined' : _typeof(nextElement)) === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || (typeof element === 'undefined' ? 'undefined' : _typeof(element)) !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(53);
	
	var PooledClass = __webpack_require__(139);
	var Transaction = __webpack_require__(262);
	var ReactInstrumentation = __webpack_require__(94);
	var ReactServerUpdateQueue = __webpack_require__(1532);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function enqueue() {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function getTransactionWrappers() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function getReactMountReady() {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function getUpdateQueue() {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function destructor() {},
	
	  checkpoint: function checkpoint() {},
	
	  rollback: function rollback() {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var ReactUpdateQueue = __webpack_require__(401);
	
	var warning = __webpack_require__(44);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(210);
	var ExecutionEnvironment = __webpack_require__(90);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactInputSelection = __webpack_require__(776);
	var SyntheticEvent = __webpack_require__(111);
	
	var getActiveElement = __webpack_require__(923);
	var isTextInputElement = __webpack_require__(786);
	var shallowEqual = __webpack_require__(490);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function didPutListener(inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var EventListener = __webpack_require__(925);
	var EventPropagators = __webpack_require__(210);
	var ReactDOMComponentTree = __webpack_require__(56);
	var SyntheticAnimationEvent = __webpack_require__(1537);
	var SyntheticClipboardEvent = __webpack_require__(1538);
	var SyntheticEvent = __webpack_require__(111);
	var SyntheticFocusEvent = __webpack_require__(1541);
	var SyntheticKeyboardEvent = __webpack_require__(1543);
	var SyntheticMouseEvent = __webpack_require__(261);
	var SyntheticDragEvent = __webpack_require__(1540);
	var SyntheticTouchEvent = __webpack_require__(1544);
	var SyntheticTransitionEvent = __webpack_require__(1545);
	var SyntheticUIEvent = __webpack_require__(212);
	var SyntheticWheelEvent = __webpack_require__(1546);
	
	var emptyFunction = __webpack_require__(120);
	var getEventCharCode = __webpack_require__(403);
	var invariant = __webpack_require__(32);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function didPutListener(inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function willDeleteListener(inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function clipboardData(event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(261);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(212);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(212);
	
	var getEventCharCode = __webpack_require__(403);
	var getEventKey = __webpack_require__(1551);
	var getEventModifierState = __webpack_require__(404);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function charCode(event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function keyCode(event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function which(event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(212);
	
	var getEventModifierState = __webpack_require__(404);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(261);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function deltaX(event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function deltaY(event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(768);
	var warning = __webpack_require__(44);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(46);
	
	var ReactCurrentOwner = __webpack_require__(112);
	var ReactDOMComponentTree = __webpack_require__(56);
	var ReactInstanceMap = __webpack_require__(211);
	
	var getHostComponentFromComposite = __webpack_require__(782);
	var invariant = __webpack_require__(32);
	var warning = __webpack_require__(44);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var KeyEscapeUtils = __webpack_require__(397);
	var traverseAllChildren = __webpack_require__(788);
	var warning = __webpack_require__(44);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(790);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && (typeof traverseContext === 'undefined' ? 'undefined' : _typeof(traverseContext)) === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(470)))

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(403);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(90);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(263);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(777);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(213);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function oneArgumentPooler(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function threeArgumentPooler(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1558);
	var ReactElement = __webpack_require__(169);
	
	var emptyFunction = __webpack_require__(120);
	var traverseAllChildren = __webpack_require__(1568);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(169);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(169),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(500);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(789),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(169),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(792);
	var factory = __webpack_require__(924);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function lowPriorityWarning() {};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function lowPriorityWarning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(213);
	
	var ReactElement = __webpack_require__(169);
	
	var invariant = __webpack_require__(32);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(213);
	
	var ReactCurrentOwner = __webpack_require__(112);
	var REACT_ELEMENT_TYPE = __webpack_require__(791);
	
	var getIteratorFn = __webpack_require__(1564);
	var invariant = __webpack_require__(32);
	var KeyEscapeUtils = __webpack_require__(1557);
	var warning = __webpack_require__(44);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getContainerBackgroundColor = exports.getShowTypeDivCss = exports.getBackgroundColor = exports.getCodeMirror = exports.codemirror_options = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(84);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactCodemirror = __webpack_require__(1493);
	
	var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);
	
	var _sgiCommon = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(2002);
	__webpack_require__(1998);
	
	__webpack_require__(1492);
	__webpack_require__(389);
	__webpack_require__(1485);
	__webpack_require__(1483);
	__webpack_require__(1484);
	__webpack_require__(1482);
	__webpack_require__(1481);
	
	__webpack_require__(1999);
	__webpack_require__(1487);
	__webpack_require__(1486);
	
	__webpack_require__(1489);
	__webpack_require__(2000);
	__webpack_require__(1491);
	__webpack_require__(1488);
	
	__webpack_require__(390);
	__webpack_require__(391);
	__webpack_require__(2001);
	__webpack_require__(392);
	__webpack_require__(1490);
	
	var codemirror_js_tags = [];
	
	var codemirror_options = {
	    lineNumbers: true,
	    mode: 'javascript',
	    lineWrapping: true, //代码折叠
	    foldGutter: true,
	    // showHint: true,
	    // highlightSelectionMatches: true,
	    highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
	    extraKeys: { "Ctrl-/": "autocomplete" },
	    hintOptions: { schemaInfo: codemirror_js_tags },
	    lint: true,
	    gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", 'CodeMirror.hint.javascript', 'CodeMirror.hint.coffeescript', 'CodeMirror-lint-markers'],
	    matchBrackets: true, //括号匹配
	    autoCloseBrackets: true //关闭
	};
	
	var getContainerBackgroundColor = function getContainerBackgroundColor(isActive, canDrop, hover) {
	    var backgroundColor = 'rgb(205,221,238)';
	    if (isActive) {
	        backgroundColor = 'rgb(88,158,148)';
	    } else if (canDrop) {
	        backgroundColor = 'rgb(197,212,194)';
	    } else if (hover) {
	        // backgroundColor = '#49a9ee1c'
	        backgroundColor = 'rgb(143,182,211)';
	    }
	    return backgroundColor;
	};
	
	var getBackgroundColor = function getBackgroundColor(isActive, canDrop, hover) {
	    var backgroundColor = 'rgb(205,221,238)';
	    if (isActive) {
	        backgroundColor = 'rgb(88,158,148)';
	    } else if (canDrop) {
	        backgroundColor = 'rgb(197,212,194)';
	    } else if (hover) {
	        // backgroundColor = '#49a9ee1c'
	        backgroundColor = 'rgb(143,182,211)';
	    }
	    return backgroundColor;
	};
	
	var getCodeMirror = function getCodeMirror(value, onChange, key, height) {
	    return _react2.default.createElement(_reactCodemirror2.default, { key: key, options: codemirror_options, autoFocus: true,
	        value: value, style: { height: height || '300px' },
	        onChange: onChange });
	};
	
	var getShowTypeDivCss = {
	    position: 'absolute', top: 0, right: 0, 'font-size': '8px', backgroundColor: 'red',
	    mixWidth: '70px', height: '20px', 'z-index': 100,
	    padding: '1px 3px 1px 3px', color: 'rgb(255, 255, 255)',
	    lineHeight: "20px"
	};
	
	exports.codemirror_options = codemirror_options;
	exports.getCodeMirror = getCodeMirror;
	exports.getBackgroundColor = getBackgroundColor;
	exports.getShowTypeDivCss = getShowTypeDivCss;
	exports.getContainerBackgroundColor = getContainerBackgroundColor;

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Common = [["te", "alwBlk", "isDis", "isRead", "isHdn", "isLbl", "isLabel", "nowrap"], ["c", "cId", "lblAlg"], ["desId", "lblW", "ctlW", "ctlH"]];
	var Common_cm = [["te", "alwBlk", "isDis", "isRead", "isHdn", "isLbl", "isLabel", "nowrap"], ["c_mult", "cId", "lblAlg"], ["desId", "lblW", "ctlW", "ctlH"]];
	
	var EditorTypes = {
	    // 通用描述
	    Common: Common,
	    // 文本控件
	    Dnd_SgiFormTextEditor: [].concat(Common, [["vldC", "defVal10", "bdText"], ["minL", "maxL", "isPwd"], ["minV", "maxV"], ["inpPopTe"]]),
	    // 数字控件
	    Dnd_SgiFormNumberEditor: [].concat(Common, [["minV", "maxV", "step"], ["minL", "maxL", "dcmDgt"], ["inpPopTe", "selectType"]]),
	    // 文本域控件
	    Dnd_SgiFormTextAreaEditor: [].concat(Common, [["minL", "maxL", "ctlRow"], ["inpPopTe", "isScl"]]),
	    // 日期控件
	    Dnd_SgiFormDateEditor: [].concat(Common_cm, [["dateFmt", "optBDt", "optEDt"], ["ctlMode", "inpPopTe"]]),
	    // 时间控件
	    Dnd_SgiFormTimeEditor: [].concat(Common, [["hourStep", "minuteStep", "secondStep"], ["inpPopTe", "timeFmt"]]),
	    // 文件控件
	    Dnd_SgiFormFileEditor: [].concat(Common, [["btnN", "cluW", "iconPh"], ["disType", "mulSel", "isHdnLst", "isDrag", "isBttn", "hdUpld"], ["accept", "nLimit"], ["action"]]),
	    // 下拉窗控件
	    Dnd_SgiFormComboboxEditor: [].concat(Common, [["scId", "shows"], ["inpPopTe", "mulSel", "autoSel", "search"], ["emptyText", "allowClear", "numLimit"]]),
	    // 复选框控件
	    Dnd_SgiFormCheckboxEditor: [].concat(Common, [["defVal10", "escape"]]),
	    // 复选框组件
	    Dnd_SgiFormCheckboxGroupEditor: [].concat(Common, [["scId", "shows"], ["checked"], ["browserWidth", "occupiedBig", "occupiedSmall"]]),
	    // tag
	    Dnd_SgiTagEditor: [["te", "isLbl", "scId"], ["c", "cId"], ["desId", "lblW", "ctlW", "ctlH"], ["occupied", "astrict"]],
	    // 单选框组件
	    Dnd_SgiFormRadioEditor: [].concat(Common, [["scId", "shows"], ["checked"]]),
	    // 弹出窗控件
	    Dnd_SgiFormPopUIEditor: [].concat(Common, [["minL", "maxL"], ["isCustom", "uid"], ["inpPopTe"]]),
	    // 富文本控件
	    Dnd_SgiFormEditorEditor: [].concat(Common, [["fileUploadUrl", "toolbarHidden"]]),
	    // 下拉树控件
	    Dnd_SgiFormComboxTreeEditor: [].concat(Common, [["scId", "insName", "mulSel"], ["showKey", "saveKey"], ["inpPopTe"]]),
	    // 级联控件
	    Dnd_SgiFormCascaderEditor: [].concat(Common_cm, [["scId", "checked"]]),
	    // codemirror
	    Dnd_SgiFormCodeMirrorEditor: [].concat(Common)
	};
	
	var EditorDesc = {
	    // 通用描述
	    Common: [[{ code: "te", span: 8 }, { code: "alwBlk", span: 3 }, { code: "isDis", span: 3 }, { code: "isRead", span: 3 }, { code: "isHdn", span: 3 }, { code: "isLbl", span: 3 }], [{ code: "c", span: 8 }, { code: "cId", span: 8 }, { code: "lblAlg", span: 8 }], [{ code: "lblW", span: 8 }, { code: "ctlW", span: 8 }, { code: "ctlH", span: 8 }]],
	    // 日期组件
	    Dnd_SgiFormDateEditor: [[{ code: "te", span: 8 }, { code: "alwBlk", span: 3 }, { code: "isDis", span: 3 }, { code: "isRead", span: 3 }, { code: "isHdn", span: 3 }, { code: "isLbl", span: 3 }], [{ code: "c_mult", span: 8 }, { code: "cId", span: 8 }, { code: "lblAlg", span: 8 }], [{ code: "lblW", span: 8 }, { code: "ctlW", span: 8 }, { code: "ctlH", span: 8 }]],
	    // 级联组件
	    Dnd_SgiFormCascaderEditor: [[{ code: "te", span: 8 }, { code: "alwBlk", span: 3 }, { code: "isDis", span: 3 }, { code: "isRead", span: 3 }, { code: "isHdn", span: 3 }, { code: "isLbl", span: 3 }], [{ code: "c_mult", span: 8 }, { code: "cId", span: 8 }, { code: "lblAlg", span: 8 }], [{ code: "lblW", span: 8 }, { code: "ctlW", span: 8 }, { code: "ctlH", span: 8 }]],
	    // 文本控件
	    Dnd_SgiFormTextEditor: [[{ code: "te", span: 8 }, { code: "alwBlk", span: 3 }, { code: "isDis", span: 3 }, { code: "isRead", span: 3 }, { code: "isHdn", span: 3 }, { code: "isLbl", span: 3 }], [{ code: "c", span: 8 }, { code: "cId", span: 8 }, { code: "lblAlg", span: 8 }], [{ code: "lblW", span: 8 }, { code: "ctlW", span: 8 }, { code: "ctlH", span: 8 }], [{ code: "vldC", span: 8 }, { code: "defVal10", span: 8 }, { code: "bdText", span: 8 }], [{ code: "minL", span: 8 }, { code: "maxL", span: 8 }], [{ code: "inpPopTe", span: 16 }]]
	};
	
	exports.EditorTypes = EditorTypes;
	exports.EditorDesc = EditorDesc;
	exports.default = { EditorTypes: EditorTypes, EditorDesc: EditorDesc };

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dnd_SgiFormEditorRPSelect = function (_React$Component) {
	    _inherits(Dnd_SgiFormEditorRPSelect, _React$Component);
	
	    function Dnd_SgiFormEditorRPSelect(props) {
	        _classCallCheck(this, Dnd_SgiFormEditorRPSelect);
	
	        var _this = _possibleConstructorReturn(this, (Dnd_SgiFormEditorRPSelect.__proto__ || Object.getPrototypeOf(Dnd_SgiFormEditorRPSelect)).call(this, props));
	
	        _this.columns_IR = [{
	            title: '显示名称',
	            dataIndex: 'te',
	            width: 40
	        }, {
	            title: 'GUID',
	            dataIndex: 'guid',
	            width: 80
	        }, {
	            title: '图片预览',
	            dataIndex: 'c',
	            width: 40,
	            render: function render(text, record, index) {
	                return _react2.default.createElement('img', { src: text, alt: record.te,
	                    style: { width: 35, height: 35 },
	                    onClick: function onClick(e) {
	                        _this.setState({
	                            preVisible: true,
	                            preSrc: e.target.src,
	                            preAlt: e.target.alt
	                        });
	                    }
	                });
	            }
	        }];
	
	
	        var ap = tool.Global.currentAP;
	        var type = props.type;
	        var catId = void 0;
	        switch (type) {
	            case "IR":
	                catId = ap + "_RP_IR_0001";
	                break;
	            case "SR":
	                catId = ap + "_RP_SR_0001";
	                break;
	            case "VR":
	                catId = ap + "_RP_VR_0001";
	                break;
	
	            default:
	                break;
	        }
	
	        var prm = PrmFactory.getPrm(catId) || {};
	        var rps = tool.getAllLeaf(prm, "cldSet") || [];
	
	        _this.state = {
	            loading: false, //加载标志
	            selValues: {}, //查询条件
	            store: rps, //表格的store
	            selStore: rps, //给查询用的，保证永远都是最全的
	            attname: _this.props.attname, //对应属性名不一定一样
	            preVisible: false, //图片预览课件标志
	            preSrc: "", //图片预览路径
	            preAlt: "" //图片预览alt
	        };
	        return _this;
	    }
	
	    _createClass(Dnd_SgiFormEditorRPSelect, [{
	        key: 'selOnChange',
	
	
	        //及时筛选
	        value: function selOnChange(attname, e, e2) {
	            var value = e.target.value;
	            this.state.selValues[attname] = value;
	            this.setState({ loading: false });
	            this.onSel();
	        }
	
	        //筛选方法
	
	    }, {
	        key: 'onSel',
	        value: function onSel() {
	            var mat = this.state.selValues.mat;
	
	            if (!mat) {
	                this.setState(this.state.selStore);
	            }
	            var reg = void 0;
	            if (mat) {
	                reg = new RegExp(mat, 'gi');
	            }
	            this.setState({
	                store: this.state.selStore.filter(function (e, i, a) {
	                    return (e.te ? e.te.match(reg) : false) || (e.guid ? e.guid.match(reg) : false) || (e.c ? e.c.match(reg) : false);
	                })
	            });
	        }
	
	        //双击选中事件
	
	    }, {
	        key: 'onDoubleClick',
	        value: function onDoubleClick(record) {
	            var p = this.props.parentModule;
	            var values = p.state.values;
	            var val = record.guid;
	            var attname = this.state.attname;
	            values[attname] = val;
	            p.setState({ RPModalVisible: false });
	
	            p.refresh(attname, val);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '100%', width: '100%' } },
	                _react2.default.createElement(
	                    _antd.Row,
	                    { style: { margin: '5px 0px 5px 0px' } },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 10, style: { margin: "0px 5px 0px 5px" } },
	                        _react2.default.createElement(_antd.Input, { addonBefore: '\u7B5B\u9009\u6761\u4EF6', value: this.state.selValues.mat, onChange: this.selOnChange.bind(this, 'mat') })
	                    )
	                ),
	                _react2.default.createElement(
	                    _antd.Row,
	                    null,
	                    _react2.default.createElement(_antd.Table, { size: 'small', dataSource: this.state.store, rowKey: 'guid', columns: this.columns_IR
	                        // onRowClick={this.onClick.bind(this)}
	                        , onRowDoubleClick: this.onDoubleClick.bind(this)
	                    })
	                ),
	                _react2.default.createElement(
	                    _antd.Modal,
	                    { visible: this.state.preVisible, closable: false,
	                        onCancel: function onCancel() {
	                            _this2.setState({ preVisible: false });
	                        },
	                        footer: null
	                    },
	                    _react2.default.createElement('img', { src: this.state.preSrc, alt: this.state.preAlt,
	                        style: { width: "100%", height: "100%" }
	                        // onMouseOut={() => { this.setState({ preVisible: false }) }}
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Dnd_SgiFormEditorRPSelect;
	}(_react2.default.Component);
	
	exports.default = Dnd_SgiFormEditorRPSelect;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(84);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(206);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _smProjDndConfig = __webpack_require__(240);
	
	var _smProjDndConfig2 = _interopRequireDefault(_smProjDndConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	var Option = _antd.Select.Option;
	
	var treeConfConstant = {
	    childrenName: 'cldSet',
	    key: '_key'
	};
	
	var columns = [{
	    //     title: '名称',
	    //     dataIndex: 'n',
	    //     width: 40
	    // }, {
	    title: '显示名称',
	    dataIndex: 'te',
	    width: 40,
	    render: function render(text, record) {
	        return text || record.n;
	    }
	}, {
	    title: 'GUID',
	    dataIndex: 'guid',
	    width: 80
	}];
	
	var Dnd_SgiFormEditorSCSelect = function (_React$Component) {
	    _inherits(Dnd_SgiFormEditorSCSelect, _React$Component);
	
	    function Dnd_SgiFormEditorSCSelect(props) {
	        _classCallCheck(this, Dnd_SgiFormEditorSCSelect);
	
	        var _this = _possibleConstructorReturn(this, (Dnd_SgiFormEditorSCSelect.__proto__ || Object.getPrototypeOf(Dnd_SgiFormEditorSCSelect)).call(this, props));
	
	        _this.fitTreeNodes = function (data) {
	            return data.map(function (item) {
	                //因为树的key很重要，不能重复，数据中可能会有重复的key，所以检查是否有重复的key如果有，重新生成一个
	                if (!item[treeConfConstant.key]) {
	                    item[treeConfConstant.key] = (0, _sgiCommon.uuid)(6);
	                }
	
	                if (_this.state.keysTreeNode[item[treeConfConstant.key]]) {
	                    //存在重新生成一个 不存在添加进去
	                    item[treeConfConstant.key] = (0, _sgiCommon.uuid)(6);
	                }
	
	                var childrenName = treeConfConstant.childrenName;
	                var currentNode = void 0;
	
	                if (item[childrenName] && item[childrenName].length) {
	                    currentNode = _react2.default.createElement(
	                        TreeNode,
	                        { itemData: item, tree: _this, key: item[treeConfConstant.key], title: (item.n || item.te) + (item.c ? "[" + item.c + "]" : "") },
	                        _this.fitTreeNodes(item[childrenName])
	                    );
	                    currentNode.props.children.forEach(function (element) {
	                        element.props.parentNode = currentNode;
	                    });
	                    _this.state.keysTreeNode[item[treeConfConstant.key]] = currentNode; //统一存起来
	                    return currentNode;
	                }
	                var LeafTreeNode = _react2.default.createElement(TreeNode, { itemData: item, tree: _this, key: item[treeConfConstant.key], title: (item.n || item.te) + (item.c ? "[" + item.c + "]" : ""), isLeaf: true });
	                _this.state.keysTreeNode[item[treeConfConstant.key]] = LeafTreeNode; //统一存起来
	                return LeafTreeNode;
	            });
	        };
	
	        _this.state = {
	            loading: false, //加载标志
	            selValues: {}, //查询条件
	            store: [], //表格的store
	            selStore: [], //给查询用的，保证永远都是最全的
	            keysTreeNode: {}, //树节点key存储
	            treeData: [], //树的数据组
	            treeStore: [], //树的子节点数组
	            didUpdate: false, //是否已更新，更新后执行使用
	            attname: _this.props.attname, //对应属性名不一定一样
	            ap: tool.Global.currentAP, //当前ap
	            aps: [], //可选ap数组
	            apOptions: [] //select选项数组
	        };
	        return _this;
	    }
	
	    // 刷新
	
	
	    _createClass(Dnd_SgiFormEditorSCSelect, [{
	        key: 'refresh',
	        value: function refresh() {
	            this.setState({ loading: false });
	        }
	
	        // ap切换
	
	    }, {
	        key: 'apOnChange',
	        value: function apOnChange(e) {
	            var ap = e.target.value;
	            this.state.ap = ap; //切换ap
	            this.initSCs(); //重载参数
	            this.onSel(); //即时查询
	        }
	        // ap切换
	
	    }, {
	        key: 'apSelectOnChange',
	        value: function apSelectOnChange(e) {
	            var ap = e;
	            this.state.ap = ap; //切换ap
	            this.initSCs(); //重载参数
	            this.onSel(); //即时查询
	        }
	
	        // 重载参数
	
	    }, {
	        key: 'initSCs',
	        value: function initSCs() {
	            var ap = this.state.ap;
	            if (!ap) return;
	            var tt = this.props.tt || "SC";
	            // let prms = PrmFactory.getPrmByTT(ap, tt) || [];
	            var prms = _smProjDndConfig2.default.getPrmByTT(ap, tt) || [];
	            this.state.store = prms; //存在同步问题，这里不能使用setState
	            this.state.selStore = prms; //存在同步问题，这里不能使用setState
	            this.refresh();
	        }
	
	        //及时筛选
	
	    }, {
	        key: 'selOnChange',
	        value: function selOnChange(attname, e, e2) {
	            var value = e.target.value;
	            this.state.selValues[attname] = value;
	            this.setState({ loading: false });
	            this.onSel();
	        }
	
	        //筛选方法
	
	    }, {
	        key: 'onSel',
	        value: function onSel() {
	            var mat = this.state.selValues.mat;
	
	            if (!mat) {
	                this.setState(this.state.selStore);
	            }
	            var reg = void 0;
	            if (mat) {
	                reg = new RegExp(mat, 'gi');
	            }
	            this.setState({
	                store: this.state.selStore.filter(function (e, i, a) {
	                    // return e.n.match(reg) || e.te.match(reg) || e.guid.match(reg);
	                    return testBykey(e, "n") || testBykey(e, "te") || testBykey(e, "guid");
	                })
	            });
	
	            function testBykey(record, key) {
	                return record && record[key] && record[key].match(reg);
	            }
	        }
	
	        //单击事件
	
	    }, {
	        key: 'onClick',
	        value: function onClick(record, index) {
	            this.state.treeData = [record];
	            this.setState({ didUpdate: false });
	        }
	
	        //双击选中事件
	
	    }, {
	        key: 'onDoubleClick',
	        value: function onDoubleClick(record) {
	            var p = this.props.parentModule;
	            var values = p.state.values;
	            var val = record.guid;
	            var attname = this.state.attname;
	            values[attname] = val;
	            p.setState(_defineProperty({}, this.props.visibleKey || "SCModalVisible", false));
	
	            p.refresh(attname, val);
	        }
	
	        //树节点全展开方法
	
	    }, {
	        key: 'expandAll',
	        value: function expandAll() {
	            var keys = [];
	            for (var key in this.state.keysTreeNode) {
	                keys.push(key);
	            }
	            this.setState({ expandedKeys: keys, didUpdate: true });
	        }
	
	        //递归创建树节点方法
	
	    }, {
	        key: 'createTreeStore',
	
	
	        //创建树
	        value: function createTreeStore() {
	            this.state.keysTreeNode = {};
	            this.state.treeStore = this.fitTreeNodes(this.state.treeData);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            this.createTreeStore();
	
	            return _react2.default.createElement(
	                'div',
	                { style: { height: '100%', width: '100%' } },
	                _react2.default.createElement(
	                    _antd.Row,
	                    { style: { margin: '5px 0px 5px 0px' } },
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 4, style: { padding: "0px 5px 0px 5px" } },
	                        _react2.default.createElement(
	                            _antd.Select,
	                            { value: this.state.ap, onChange: this.apSelectOnChange.bind(this), style: { width: "100%" } },
	                            this.state.apOptions
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 12, style: { padding: "0px 5px 0px 5px" } },
	                        _react2.default.createElement(_antd.Input, { addonBefore: '\u7B5B\u9009\u6761\u4EF6', value: this.state.selValues.mat, onChange: this.selOnChange.bind(this, 'mat') })
	                    )
	                ),
	                _react2.default.createElement(
	                    _antd.Row,
	                    null,
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 16 },
	                        _react2.default.createElement(_antd.Table, { size: 'small', dataSource: this.state.store, rowKey: 'guid', columns: columns,
	                            onRowClick: this.onClick.bind(this),
	                            onRowDoubleClick: this.onDoubleClick.bind(this)
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _antd.Col,
	                        { span: 8 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { overflow: 'auto', height: "420px" } },
	                            _react2.default.createElement(
	                                _antd.Tree,
	                                {
	                                    defaultExpandAll: true,
	                                    showLine: true,
	                                    expandedKeys: this.state.expandedKeys
	                                },
	                                this.state.treeStore
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            var aps = PrmFactory.getAPList() || [];
	            aps.forEach(function (item, index) {
	                _this2.state.apOptions.push(_react2.default.createElement(
	                    Option,
	                    { value: item.c },
	                    item.c
	                ));
	            });
	            this.initSCs(); //加载参数
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (!this.state.didUpdate) this.expandAll(); //展开树节点
	        }
	    }]);
	
	    return Dnd_SgiFormEditorSCSelect;
	}(_react2.default.Component);
	
	exports.default = Dnd_SgiFormEditorSCSelect;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fitModalInfo = exports.addTabCtlDndInfoForMainDnd = exports.toggleHoverLeave = exports.onClick = exports.toggleHover = exports.addToolbarCtlDndInfo = exports.addSgiSplitterCtlDndInfo = exports.addCollapseCtlDndInfo = exports.addTabCtlDndInfoForDnd = exports.addTabCtlDndInfo = undefined;
	
	var _antd = __webpack_require__(206);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgiCommon = __webpack_require__(28);
	
	var _sgiLogger = __webpack_require__(39);
	
	var _ObjFactory = __webpack_require__(69);
	
	var _PrmFactory = __webpack_require__(63);
	
	var _Resource = __webpack_require__(67);
	
	var _SgiMainComp = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabPane = _antd.Tabs.TabPane;
	var Panel = _antd.Collapse.Panel;
	
	/**
	 * 额外要做代理解析的keys
	 */
	var otherProxyKeys = ["eventKeys"];
	/**
	 * 参数Editor编辑器使用，将moduleDesc用代理器包裹一下，传至页面对象工厂中的values身上。
	 * 功能：当values（moduleDesc）中的属性变动时，刷新组件并修改要保存的json
	 */
	var getModuleDesc2valuesHandler = function getModuleDesc2valuesHandler(dndDispatchObject, dnd_id) {
		return {
			set: function set(target, key, value, receiver) {
				if (key === "_currentDndCtl") {
					return Reflect.set(this, key, value);
				} else if (key === "_prefix") {
					return Reflect.set(this, key, value);
					// } else if (key === "cldSet" && this._currentDndCtl) {
					//     return new Proxy(target[key], {})
					//     let sonItems = syncSonItems(target, key, value, this._currentDndCtl);
					//     console.log('proxyModuleDesc sonItems :', sonItems);
					//     this._currentDndCtl.setState({ sonItems });
				} else if (this._currentDndCtl) {
					this._currentDndCtl.refresh(key, value);
				}
				if (Object.prototype.toString.call(value) === "[object Object]") {
					var proxyVal = new Proxy(value, getModuleDesc2valuesHandler(dndDispatchObject, dnd_id));
					proxyVal._prefix = (this._prefix || "") + key + ".";
					proxyVal._currentDndCtl = this._currentDndCtl;
					return Reflect.set(target, key, proxyVal);
				} else {
					dndDispatchObject.updateUIJson(dnd_id, (this._prefix || "") + key, value);
					return Reflect.set(target, key, value);
				}
			}
		};
	};
	
	function onDBClick(event) {
		// console.log(arguments);
		// console.log("thisModule", this);
	
		var dndDispatchObject = this.props.dndDispatchObject || this.state.dndDispatchObject;
	
		var mainUI = dndDispatchObject.getMainUI();
		fitModalInfo(this);
		mainUI.openModal();
		event.cancelBubble = true; //ie浏览器 组织向下传递
		event.stopPropagation(); //chrome等浏览器
	}
	
	/**
	 * 组装弹出框 编辑信息
	 */
	function fitModalInfo(module) {
	
		var dndDispatchObject = module.props.dndDispatchObject || module.state.dndDispatchObject;
	
		var mainUI = dndDispatchObject.getMainUI();
		mainUI.state.modal_title = module.props.modal_title;
		if (sgiConfig.prmEditor || module.props.dndCompEditor === "_prmEditor") {
			var guid = (sgiConfig.prefix_editor || "rtsd_UI_Editor_") + module.props.modal_context.replace(/Editor$/, "");
			var prm = _PrmFactory.PrmFactory.getPrm(guid);
			if (prm && prm.guid) {
				// let objFct = new ObjFactory("sgiMainEditor", { values: module.props.moduleDesc });
				var moduleDesc = new Proxy(module.props.moduleDesc, getModuleDesc2valuesHandler(dndDispatchObject, module.props.moduleDesc.dnd_id));
				moduleDesc._currentDndCtl = module;
				otherProxyKeys.forEach(function (key) {
					if (moduleDesc[key]) {
						moduleDesc[key] = moduleDesc[key];
						// let proxyVal = new Proxy(moduleDesc[key], getModuleDesc2valuesHandler(dndDispatchObject,module.props.moduleDesc.dnd_id));
						// proxyVal._prefix = key + ".";
						// proxyVal._currentDndCtl = module;
						// moduleDesc[key] = proxyVal;
					}
				});
				var objFct = new _ObjFactory.ObjFactory("sgiMainEditor", { values: moduleDesc });
				mainUI.state.modal_context = _react2.default.createElement(_SgiMainComp.SgiMainComp, { key: (0, _sgiCommon.uuid)(8), objFct: objFct, moduleDesc: prm, values: module.props.moduleDesc, currentCtl: module });
				mainUI.state.editorType = "SDEditor";
				return;
			}
		}
		if (module.props.dndCompEditor) {
			mainUI.state.modal_context = _react2.default.createElement(module.props.dndCompEditor, { values: module.props.moduleDesc, currentCtl: module });
			mainUI.state.editorType = "";
		} else {
			mainUI.state.modal_context = _react2.default.createElement(
				'div',
				{ style: { height: '300px' } },
				_react2.default.createElement(
					'h1',
					null,
					'\u627E\u4E0D\u5230\u7F16\u8F91\u9875\u9762\u6216\u4E0D\u53EF\u7F16\u8F91'
				)
			);
			mainUI.state.editorType = "";
		}
	}
	
	function onClick(moudule, event) {
	
		if (event) {
			event.cancelBubble = true; //ie浏览器 组织向下传递
			event.stopPropagation(); //chrome等浏览器
		}
	
		var parentModule = moudule.props.parentModule;
		var dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;
	
		//如果选中组件是当前组件，不做操作
	
		// console.log('同一个面板：' + diffMoudule(dndDispatchObject.getCurrentSelMoudle(), moudule))
		// console.log(dndDispatchObject.getCurrentSelMoudle())
		// console.log(moudule)
		if (diffMoudule(dndDispatchObject.getCurrentSelMoudle(), moudule)) {
			return;
		}
	
		var lastSelMoudule = dndDispatchObject.getCurrentSelMoudle();
		if (lastSelMoudule) {
			var lastProps = lastSelMoudule.state.formItemProps || lastSelMoudule.inputprops || lastSelMoudule.state;
			lastProps.style.border = '1px dashed grey';
			lastSelMoudule.setState({ hover: false });
		}
	
		_sgiLogger.sgiLogger.debug("moudule:", moudule);
		_sgiLogger.sgiLogger.debug("record:", moudule.props.moduleDesc);
	
		dndDispatchObject.setCurrentSelMoudle(moudule); //设置当前选中节点
		dndDispatchObject.setCurrentSelPraentMoudle(parentModule); //设置当前选中父节点
	
		fitModalInfo(moudule);
		var mainUI = dndDispatchObject.getMainUI(); //切到组件编辑面板
	
		mainUI.state.CurrentSelMoudlete = moudule.props.moduleDesc.te || moudule.props.moduleDesc.n;
		mainUI.state.CurrentSelMoudleguid = moudule.props.modal_title;
		// mainUI.setState({ activeKey: 'x' });
		mainUI.setState({ loading: true });
		mainUI.setState({
			selectedKeys: [moudule.props.moduleDesc.dnd_id],
			expandedKeys: [moudule.props.moduleDesc.dnd_id]
		});
	
		// 不存在事件的时候 是通过树点击调用过来的
		// 存在是点击页面调用的，点击页面调用 的时候  刷新树 节点
	}
	
	function diffMoudule(oldMoudule, newMoudule) {
		if (!oldMoudule || !newMoudule) {
			return false;
		}
		if (!oldMoudule || !oldMoudule.props || !oldMoudule.props.moduleDesc || !oldMoudule.props.moduleDesc.dnd_id) {
			return false;
		}
		if (!newMoudule || !newMoudule.props || !newMoudule.props.moduleDesc || !newMoudule.props.moduleDesc.dnd_id) {
			return false;
		}
		if (oldMoudule.props.moduleDesc.dnd_id == newMoudule.props.moduleDesc.dnd_id) {
			return true;
		}
		return false;
	}
	
	function toggleHover(moudule, event) {
		//给树点击用
		//this.state.style给拖拽控件使用的 formItemProps给sgiform控件使用的
		var props = moudule.state.formItemProps || moudule.inputprops || moudule.state;
		// if (!moudule.state.hover) {
		props.style.border = '1px dashed blue';
		// } else {
		//     props.style.border = '1px dashed grey'
		// }
		moudule.setState({ hover: !moudule.state.hover });
	}
	
	function toggleHoverEnter(moudule, event) {
	
		if (event) {
			event.cancelBubble = true; //ie浏览器 组织向下传递
			event.stopPropagation(); //chrome等浏览器
		}
	
		var dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;
	
		//如果选中组件是当前组件，不做操作
		// if (dndDispatchObject.getCurrentSelMoudle() == moudule) {
		// 	return;
		// }
		if (diffMoudule(dndDispatchObject.getCurrentSelMoudle(), moudule)) {
			return;
		}
		if (!moudule.state.hover) {
			var props = moudule.state.formItemProps || moudule.inputprops || moudule.state;
			props.style.border = '1px dashed red';
			moudule.setState({ hover: true });
		}
	
		// console.log("鼠标进入");
		// console.log(moudule.state.hover);
		// console.log(moudule);
	}
	
	function toggleHoverLeave(moudule, event) {
	
		if (event) {
			event.cancelBubble = true; //ie浏览器 组织向下传递
			event.stopPropagation(); //chrome等浏览器
		}
	
		var dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;
		//如果选中组件是当前组件，离开不再改变颜色，让当前选中组件一直高亮显示
		// if (dndDispatchObject.getCurrentSelMoudle() == moudule) {
		// 	return;
		// }
		if (diffMoudule(dndDispatchObject.getCurrentSelMoudle(), moudule)) {
			return;
		}
	
		// console.log("鼠标离开")
		// console.log(moudule.state.hover);
		// console.log(moudule);
	
		if (moudule.state.hover) {
			//this.state.style给拖拽控件使用的 formItemProps给sgiform控件使用的
			var props = moudule.state.formItemProps || moudule.inputprops || moudule.state;
			props.style.border = '1px dashed grey';
			moudule.setState({ hover: false });
		}
	}
	
	function toggleHoverEnterMain(moudule, event) {
		//qiuyl
		// console.log("鼠标进入")
		//this.state.style给拖拽控件使用的 formItemProps给sgiform控件使用的
		// console.log(moudule);
		moudule.setState({ hover: true });
		if (event) {
			event.cancelBubble = true; //ie浏览器 组织向下传递
			event.stopPropagation(); //chrome等浏览器
		}
	}
	
	function toggleHoverLeaveMain(moudule, event) {
		//qiuyl
		// console.log("鼠标离开")
		var dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;
		//如果选中组件是当前组件，离开不再改变颜色，让当前选中组件一直高亮显示
		if (dndDispatchObject.getCurrentSelMoudle() == moudule) {
			return;
		}
		//this.state.style给拖拽控件使用的 formItemProps给sgiform控件使用的
		// setTimeout(function () { moudule.setState({ hover: false }) }, 1000)
		moudule.setState({ hover: false });
		if (event) {
			event.cancelBubble = true; //ie浏览器 组织向下传递
			event.stopPropagation(); //chrome等浏览器
		}
	}
	
	function addMouseFun(moudule, params) {
		// params.onMouseEnter = toggleHoverEnter.bind(moudule, moudule);
		// params.onMouseLeave = toggleHoverLeave.bind(moudule, moudule);
		params.onMouseOver = toggleHoverEnter.bind(moudule, moudule);
		params.onMouseOut = toggleHoverLeave.bind(moudule, moudule);
		// params.onMouseLeave = toggleHover.bind(moudule, moudule);
	}
	
	function addMouseMainFun(moudule, params) {
		//qiuyl
		// params.onMouseEnter = toggleHoverEnter.bind(moudule, moudule);
		// params.onMouseLeave = toggleHoverLeave.bind(moudule, moudule);
		params.onMouseOver = toggleHoverEnterMain.bind(moudule, moudule);
		params.onMouseOut = toggleHoverLeaveMain.bind(moudule, moudule);
		// params.onMouseLeave = toggleHover.bind(moudule, moudule);
	}
	
	/**
	 * 对外接口,添加拖拽布局
	 * @param {控件样式} style 
	 */
	// function addFormCtlDndInfo(moudule, formItemProps, inputprops, type) {
	//     if (type != "dnd") {
	//         return;
	//     }
	//     //状态中追加一个hover状态,默认为false
	//     moudule.state.hover = false;
	//     addMouseFun(moudule, inputprops);
	//     inputprops.onDoubleClick = onDBClick.bind(moudule);
	//     inputprops.onClick = onClick.bind(moudule);
	//     formItemProps.style.border = '1px dashed grey';
	// }
	
	
	/**
	 * 对外接口,tab添加拖拽布局，解决鼠标滑过变色问题和点击事件编辑
	 * @param {控件样式} style 
	 */
	function addTabCtlDndInfoForDnd(moudule, tabsProps, type) {
		if (type != "dnd") {
			return;
		}
		//状态中追加一个hover状态,默认为false
		moudule.state.hover = false;
		addMouseFun(moudule, tabsProps);
		tabsProps.onDoubleClick = onDBClick.bind(moudule);
		tabsProps.onClick = onClick.bind(moudule, moudule);
	}
	
	function addTabCtlDndInfoForMainDnd(moudule, tabsProps, type) {
		if (type != "prev") {
			return;
		}
		//状态中追加一个hover状态,默认为false
		moudule.state.hover = false;
		addMouseMainFun(moudule, tabsProps);
		// tabsProps.onDoubleClick = onDBClick.bind(moudule);
		// tabsProps.onClick = onClick.bind(moudule, moudule);
	}
	
	/**
	 * 对外接口,tab添加拖拽布局
	 * @param {控件样式} style 
	 */
	function addTabCtlDndInfo(moudule, tabsItems, tabsProps, type) {
		if (type != "dnd") {
			return;
		}
	
		//获取拖拽数据
		var dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;
	
		var cldSet = moudule.props.children;
		if (cldSet && cldSet.length && cldSet.length > 0) {
			var tabPane = void 0;
			cldSet.forEach(function (item, index) {
				var _item$props$moduleDes = item.props.moduleDesc,
				    cId = _item$props$moduleDes.cId,
				    te = _item$props$moduleDes.te,
				    isDis = _item$props$moduleDes.isDis;
	
				tabPane = {};
				if (!cId) {
					cId = (0, _sgiCommon.uuid)(8);
					item.props.moduleDesc.cId = cId; //赋值的同时，也要给json数据赋值，保持同步
					dndDispatchObject.updateUIJson(item.props.moduleDesc.dnd_id, "cId", cId);
				}
				if (te) tabPane.tab = _Resource.Resource.getTRByPrm(item.props.moduleDesc).te;
				if (cId) tabPane.key = item.props.moduleDesc.dnd_id;
				if (isDis) tabPane.disabled = isDis;
				item.props.parentModule = moudule;
				tabsItems.push(_react2.default.createElement(
					TabPane,
					tabPane,
					item
				));
			});
		}
	}
	
	/**
	 * 对外接口,Collapse添加拖拽布局
	 * @param {控件样式} style 
	 */
	function addCollapseCtlDndInfo(moudule, tabsItems, tabsProps, type) {
		if (type != "dnd") {
			return;
		}
	
		//获取拖拽数据
		var dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;
	
		var cldSet = moudule.props.children;
		if (cldSet && cldSet.length && cldSet.length > 0) {
			var cosPane = void 0;
			cldSet.forEach(function (item, index) {
				var _item$props$moduleDes2 = item.props.moduleDesc,
				    cId = _item$props$moduleDes2.cId,
				    te = _item$props$moduleDes2.te,
				    isDis = _item$props$moduleDes2.isDis;
	
				cosPane = {};
				if (!cId) {
					cId = (0, _sgiCommon.uuid)(8);
					item.props.moduleDesc.cId = cId; //赋值的同时，也要给json数据赋值，保持同步
					dndDispatchObject.updateUIJson(item.props.moduleDesc.dnd_id, "cId", cId);
				}
				if (te) cosPane.header = _Resource.Resource.getTRByPrm(item.props.moduleDesc).te;
				if (cId) cosPane.key = item.props.moduleDesc.dnd_id;
				if (isDis) cosPane.disabled = isDis;
				item.props.parentModule = moudule;
				tabsItems.push(_react2.default.createElement(
					Panel,
					cosPane,
					item
				));
			});
		}
	}
	/**
	 * 对外接口,toolbar添加拖拽布局
	 * @param {控件样式} style 
	 */
	function addToolbarCtlDndInfo(moudule, tabsItems, tabsProps, type) {
		if (type != "dnd") {
			return;
		}
	
		var cldSet = moudule.props.children;
		var tlbAlg = moudule.props.moduleDesc.tlbAlg; //工具条位置  
		if (cldSet && cldSet.length && cldSet.length > 0) {
			if (!tlbAlg || tlbAlg == "top" || tlbAlg == "bottom") {
				cldSet.forEach(function (item, index) {
					tabsItems.push(item);
				});
			} else if (tlbAlg == "left" || tlbAlg == "right") {
				var rowlist = [];
				cldSet.forEach(function (item, index) {
					rowlist.push(_react2.default.createElement(
						_antd.Row,
						null,
						item
					));
				});
				tabsItems.push(_react2.default.createElement(
					_antd.Col,
					null,
					rowlist
				));
			}
		}
	}
	
	/**
	 * 对外接口,Collapse添加拖拽布局
	 * @param {控件样式} style 
	 */
	function addSgiSplitterCtlDndInfo(moudule, tabsItems, tabsProps, type) {
		if (type != "dnd") {
			return;
		}
	
		var _moudule$props = moudule.props,
		    bdInst = _moudule$props.bdInst,
		    objFct = _moudule$props.objFct,
		    moduleDesc = _moudule$props.moduleDesc;
	
		var colList = void 0;
		//分割比例
		var p = moduleDesc.sptSca;
		var ps = p.split(",");
	
		//计数
		var sumPs = 0;
		for (var i = 0; i < ps.length; i++) {
			sumPs += parseInt(ps[i]);
		}
		var isEdwSpt = moduleDesc.isEdwSpt; //纵向分割
	
		colList = [];
		var children = moudule.props.children;
		if (children) {
			var childSize = children.length;
			if (childSize != 0) {
				for (var i = 0; i < childSize; i++) {
					if (!ps[i]) {
						ps[i] = 0;
					}
					var span = Math.round(parseInt(ps[i]) / sumPs * 24);
					var height1 = parseInt(ps[i]) / sumPs * 100 + "%";
	
					if (isEdwSpt) {
						colList.push(_react2.default.createElement(
							_antd.Row,
							{ style: { height: height1 } },
							children[i]
						));
					} else {
						colList.push(_react2.default.createElement(
							_antd.Col,
							{ span: span },
							children[i]
						));
					}
				}
				if (isEdwSpt) {
					tabsItems.push(colList);
				} else {
					tabsItems.push(_react2.default.createElement(
						_antd.Row,
						null,
						colList
					));
				}
			}
		}
	}
	
	exports.addTabCtlDndInfo = addTabCtlDndInfo;
	exports.addTabCtlDndInfoForDnd = addTabCtlDndInfoForDnd;
	exports.addCollapseCtlDndInfo = addCollapseCtlDndInfo;
	exports.addSgiSplitterCtlDndInfo = addSgiSplitterCtlDndInfo;
	exports.addToolbarCtlDndInfo = addToolbarCtlDndInfo;
	exports.toggleHover = toggleHover;
	exports.onClick = onClick;
	exports.toggleHoverLeave = toggleHoverLeave;
	exports.addTabCtlDndInfoForMainDnd = addTabCtlDndInfoForMainDnd;
	exports.fitModalInfo = fitModalInfo;
	exports.default = { addTabCtlDndInfo: addTabCtlDndInfo, addTabCtlDndInfoForDnd: addTabCtlDndInfoForDnd, addCollapseCtlDndInfo: addCollapseCtlDndInfo, addSgiSplitterCtlDndInfo: addSgiSplitterCtlDndInfo, addToolbarCtlDndInfo: addToolbarCtlDndInfo, toggleHover: toggleHover, onClick: onClick, toggleHoverLeave: toggleHoverLeave, addTabCtlDndInfoForMainDnd: addTabCtlDndInfoForMainDnd, fitModalInfo: fitModalInfo };

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 *  big.js v6.2.2
	 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
	 *  Copyright (c) 2024 Michael Mclaughlin
	 *  https://github.com/MikeMcl/big.js/LICENCE.md
	 */
	;(function (GLOBAL) {
	  'use strict';
	  var Big,
	
	
	/************************************** EDITABLE DEFAULTS *****************************************/
	
	
	    // The default values below must be integers within the stated ranges.
	
	    /*
	     * The maximum number of decimal places (DP) of the results of operations involving division:
	     * div and sqrt, and pow with negative exponents.
	     */
	    DP = 20,            // 0 to MAX_DP
	
	    /*
	     * The rounding mode (RM) used when rounding to the above decimal places.
	     *
	     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
	     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
	     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
	     *  3  Away from zero.                                  (ROUND_UP)
	     */
	    RM = 1,             // 0, 1, 2 or 3
	
	    // The maximum value of DP and Big.DP.
	    MAX_DP = 1E6,       // 0 to 1000000
	
	    // The maximum magnitude of the exponent argument to the pow method.
	    MAX_POWER = 1E6,    // 1 to 1000000
	
	    /*
	     * The negative exponent (NE) at and beneath which toString returns exponential notation.
	     * (JavaScript numbers: -7)
	     * -1000000 is the minimum recommended exponent value of a Big.
	     */
	    NE = -7,            // 0 to -1000000
	
	    /*
	     * The positive exponent (PE) at and above which toString returns exponential notation.
	     * (JavaScript numbers: 21)
	     * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
	     */
	    PE = 21,            // 0 to 1000000
	
	    /*
	     * When true, an error will be thrown if a primitive number is passed to the Big constructor,
	     * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
	     * primitive number without a loss of precision.
	     */
	    STRICT = false,     // true or false
	
	
	/**************************************************************************************************/
	
	
	    // Error messages.
	    NAME = '[big.js] ',
	    INVALID = NAME + 'Invalid ',
	    INVALID_DP = INVALID + 'decimal places',
	    INVALID_RM = INVALID + 'rounding mode',
	    DIV_BY_ZERO = NAME + 'Division by zero',
	
	    // The shared prototype object.
	    P = {},
	    UNDEFINED = void 0,
	    NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
	
	
	  /*
	   * Create and return a Big constructor.
	   */
	  function _Big_() {
	
	    /*
	     * The Big constructor and exported function.
	     * Create and return a new instance of a Big number object.
	     *
	     * n {number|string|Big} A numeric value.
	     */
	    function Big(n) {
	      var x = this;
	
	      // Enable constructor usage without new.
	      if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
	
	      // Duplicate.
	      if (n instanceof Big) {
	        x.s = n.s;
	        x.e = n.e;
	        x.c = n.c.slice();
	      } else {
	        if (typeof n !== 'string') {
	          if (Big.strict === true && typeof n !== 'bigint') {
	            throw TypeError(INVALID + 'value');
	          }
	
	          // Minus zero?
	          n = n === 0 && 1 / n < 0 ? '-0' : String(n);
	        }
	
	        parse(x, n);
	      }
	
	      // Retain a reference to this Big constructor.
	      // Shadow Big.prototype.constructor which points to Object.
	      x.constructor = Big;
	    }
	
	    Big.prototype = P;
	    Big.DP = DP;
	    Big.RM = RM;
	    Big.NE = NE;
	    Big.PE = PE;
	    Big.strict = STRICT;
	    Big.roundDown = 0;
	    Big.roundHalfUp = 1;
	    Big.roundHalfEven = 2;
	    Big.roundUp = 3;
	
	    return Big;
	  }
	
	
	  /*
	   * Parse the number or string value passed to a Big constructor.
	   *
	   * x {Big} A Big number instance.
	   * n {number|string} A numeric value.
	   */
	  function parse(x, n) {
	    var e, i, nl;
	
	    if (!NUMERIC.test(n)) {
	      throw Error(INVALID + 'number');
	    }
	
	    // Determine sign.
	    x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;
	
	    // Decimal point?
	    if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');
	
	    // Exponential form?
	    if ((i = n.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +n.slice(i + 1);
	      n = n.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = n.length;
	    }
	
	    nl = n.length;
	
	    // Determine leading zeros.
	    for (i = 0; i < nl && n.charAt(i) == '0';) ++i;
	
	    if (i == nl) {
	
	      // Zero.
	      x.c = [x.e = 0];
	    } else {
	
	      // Determine trailing zeros.
	      for (; nl > 0 && n.charAt(--nl) == '0';);
	      x.e = e - i - 1;
	      x.c = [];
	
	      // Convert string to array of digits without leading/trailing zeros.
	      for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round Big x to a maximum of sd significant digits using rounding mode rm.
	   *
	   * x {Big} The Big to round.
	   * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
	   * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
	   * [more] {boolean} Whether the result of division was truncated.
	   */
	  function round(x, sd, rm, more) {
	    var xc = x.c;
	
	    if (rm === UNDEFINED) rm = x.constructor.RM;
	    if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) {
	      throw Error(INVALID_RM);
	    }
	
	    if (sd < 1) {
	      more =
	        rm === 3 && (more || !!xc[0]) || sd === 0 && (
	        rm === 1 && xc[0] >= 5 ||
	        rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED))
	      );
	
	      xc.length = 1;
	
	      if (more) {
	
	        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	        x.e = x.e - sd + 1;
	        xc[0] = 1;
	      } else {
	
	        // Zero.
	        xc[0] = x.e = 0;
	      }
	    } else if (sd < xc.length) {
	
	      // xc[sd] is the digit after the digit that may be rounded up.
	      more =
	        rm === 1 && xc[sd] >= 5 ||
	        rm === 2 && (xc[sd] > 5 || xc[sd] === 5 &&
	          (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) ||
	        rm === 3 && (more || !!xc[0]);
	
	      // Remove any digits after the required precision.
	      xc.length = sd;
	
	      // Round up?
	      if (more) {
	
	        // Rounding up may mean the previous digit has to be rounded up.
	        for (; ++xc[--sd] > 9;) {
	          xc[sd] = 0;
	          if (sd === 0) {
	            ++x.e;
	            xc.unshift(1);
	            break;
	          }
	        }
	      }
	
	      // Remove trailing zeros.
	      for (sd = xc.length; !xc[--sd];) xc.pop();
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Return a string representing the value of Big x in normal or exponential notation.
	   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
	   */
	  function stringify(x, doExponential, isNonzero) {
	    var e = x.e,
	      s = x.c.join(''),
	      n = s.length;
	
	    // Exponential notation?
	    if (doExponential) {
	      s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;
	
	    // Normal notation.
	    } else if (e < 0) {
	      for (; ++e;) s = '0' + s;
	      s = '0.' + s;
	    } else if (e > 0) {
	      if (++e > n) {
	        for (e -= n; e--;) s += '0';
	      } else if (e < n) {
	        s = s.slice(0, e) + '.' + s.slice(e);
	      }
	    } else if (n > 1) {
	      s = s.charAt(0) + '.' + s.slice(1);
	    }
	
	    return x.s < 0 && isNonzero ? '-' + s : s;
	  }
	
	
	  // Prototype/instance methods
	
	
	  /*
	   * Return a new Big whose value is the absolute value of this Big.
	   */
	  P.abs = function () {
	    var x = new this.constructor(this);
	    x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return 1 if the value of this Big is greater than the value of Big y,
	   *       -1 if the value of this Big is less than the value of Big y, or
	   *        0 if they have the same value.
	   */
	  P.cmp = function (y) {
	    var isneg,
	      x = this,
	      xc = x.c,
	      yc = (y = new x.constructor(y)).c,
	      i = x.s,
	      j = y.s,
	      k = x.e,
	      l = y.e;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
	
	    // Signs differ?
	    if (i != j) return i;
	
	    isneg = i < 0;
	
	    // Compare exponents.
	    if (k != l) return k > l ^ isneg ? 1 : -1;
	
	    j = (k = xc.length) < (l = yc.length) ? k : l;
	
	    // Compare digit by digit.
	    for (i = -1; ++i < j;) {
	      if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return k == l ? 0 : k > l ^ isneg ? 1 : -1;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
	   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
	   */
	  P.div = function (y) {
	    var x = this,
	      Big = x.constructor,
	      a = x.c,                  // dividend
	      b = (y = new Big(y)).c,   // divisor
	      k = x.s == y.s ? 1 : -1,
	      dp = Big.DP;
	
	    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
	      throw Error(INVALID_DP);
	    }
	
	    // Divisor is zero?
	    if (!b[0]) {
	      throw Error(DIV_BY_ZERO);
	    }
	
	    // Dividend is 0? Return +-0.
	    if (!a[0]) {
	      y.s = k;
	      y.c = [y.e = 0];
	      return y;
	    }
	
	    var bl, bt, n, cmp, ri,
	      bz = b.slice(),
	      ai = bl = b.length,
	      al = a.length,
	      r = a.slice(0, bl),   // remainder
	      rl = r.length,
	      q = y,                // quotient
	      qc = q.c = [],
	      qi = 0,
	      p = dp + (q.e = x.e - y.e) + 1;    // precision of the result
	
	    q.s = k;
	    k = p < 0 ? 0 : p;
	
	    // Create version of divisor with leading zero.
	    bz.unshift(0);
	
	    // Add zeros to make remainder as long as divisor.
	    for (; rl++ < bl;) r.push(0);
	
	    do {
	
	      // n is how many times the divisor goes into current remainder.
	      for (n = 0; n < 10; n++) {
	
	        // Compare divisor and remainder.
	        if (bl != (rl = r.length)) {
	          cmp = bl > rl ? 1 : -1;
	        } else {
	          for (ri = -1, cmp = 0; ++ri < bl;) {
	            if (b[ri] != r[ri]) {
	              cmp = b[ri] > r[ri] ? 1 : -1;
	              break;
	            }
	          }
	        }
	
	        // If divisor < remainder, subtract divisor from remainder.
	        if (cmp < 0) {
	
	          // Remainder can't be more than 1 digit longer than divisor.
	          // Equalise lengths using divisor with extra leading zero?
	          for (bt = rl == bl ? b : bz; rl;) {
	            if (r[--rl] < bt[rl]) {
	              ri = rl;
	              for (; ri && !r[--ri];) r[ri] = 9;
	              --r[ri];
	              r[rl] += 10;
	            }
	            r[rl] -= bt[rl];
	          }
	
	          for (; !r[0];) r.shift();
	        } else {
	          break;
	        }
	      }
	
	      // Add the digit n to the result array.
	      qc[qi++] = cmp ? n : ++n;
	
	      // Update the remainder.
	      if (r[0] && cmp) r[rl] = a[ai] || 0;
	      else r = [a[ai]];
	
	    } while ((ai++ < al || r[0] !== UNDEFINED) && k--);
	
	    // Leading zero? Do not remove if result is simply zero (qi == 1).
	    if (!qc[0] && qi != 1) {
	
	      // There can't be more than one zero.
	      qc.shift();
	      q.e--;
	      p--;
	    }
	
	    // Round?
	    if (qi > p) round(q, p, Big.RM, r[0] !== UNDEFINED);
	
	    return q;
	  };
	
	
	  /*
	   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
	   */
	  P.eq = function (y) {
	    return this.cmp(y) === 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is greater than the value of Big y, otherwise return
	   * false.
	   */
	  P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
	   * return false.
	   */
	  P.gte = function (y) {
	    return this.cmp(y) > -1;
	  };
	
	
	  /*
	   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
	   */
	  P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
	   * return false.
	   */
	  P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big minus the value of Big y.
	   */
	  P.minus = P.sub = function (y) {
	    var i, j, t, xlty,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    // Signs differ?
	    if (a != b) {
	      y.s = -b;
	      return x.plus(y);
	    }
	
	    var xc = x.c.slice(),
	      xe = x.e,
	      yc = y.c,
	      ye = y.e;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) {
	      if (yc[0]) {
	        y.s = -b;
	      } else if (xc[0]) {
	        y = new Big(x);
	      } else {
	        y.s = 1;
	      }
	      return y;
	    }
	
	    // Determine which is the bigger number. Prepend zeros to equalise exponents.
	    if (a = xe - ye) {
	
	      if (xlty = a < 0) {
	        a = -a;
	        t = xc;
	      } else {
	        ye = xe;
	        t = yc;
	      }
	
	      t.reverse();
	      for (b = a; b--;) t.push(0);
	      t.reverse();
	    } else {
	
	      // Exponents equal. Check digit by digit.
	      j = ((xlty = xc.length < yc.length) ? xc : yc).length;
	
	      for (a = b = 0; b < j; b++) {
	        if (xc[b] != yc[b]) {
	          xlty = xc[b] < yc[b];
	          break;
	        }
	      }
	    }
	
	    // x < y? Point xc to the array of the bigger number.
	    if (xlty) {
	      t = xc;
	      xc = yc;
	      yc = t;
	      y.s = -y.s;
	    }
	
	    /*
	     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
	     * needs to start at yc.length.
	     */
	    if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;
	
	    // Subtract yc from xc.
	    for (b = i; j > a;) {
	      if (xc[--j] < yc[j]) {
	        for (i = j; i && !xc[--i];) xc[i] = 9;
	        --xc[i];
	        xc[j] += 10;
	      }
	
	      xc[j] -= yc[j];
	    }
	
	    // Remove trailing zeros.
	    for (; xc[--b] === 0;) xc.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xc[0] === 0;) {
	      xc.shift();
	      --ye;
	    }
	
	    if (!xc[0]) {
	
	      // n - n = +0
	      y.s = 1;
	
	      // Result must be zero.
	      xc = [ye = 0];
	    }
	
	    y.c = xc;
	    y.e = ye;
	
	    return y;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big modulo the value of Big y.
	   */
	  P.mod = function (y) {
	    var ygtx,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    if (!y.c[0]) {
	      throw Error(DIV_BY_ZERO);
	    }
	
	    x.s = y.s = 1;
	    ygtx = y.cmp(x) == 1;
	    x.s = a;
	    y.s = b;
	
	    if (ygtx) return new Big(x);
	
	    a = Big.DP;
	    b = Big.RM;
	    Big.DP = Big.RM = 0;
	    x = x.div(y);
	    Big.DP = a;
	    Big.RM = b;
	
	    return this.minus(x.times(y));
	  };
	  
	  
	  /*
	   * Return a new Big whose value is the value of this Big negated.
	   */
	  P.neg = function () {
	    var x = new this.constructor(this);
	    x.s = -x.s;
	    return x;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big plus the value of Big y.
	   */
	  P.plus = P.add = function (y) {
	    var e, k, t,
	      x = this,
	      Big = x.constructor;
	
	    y = new Big(y);
	
	    // Signs differ?
	    if (x.s != y.s) {
	      y.s = -y.s;
	      return x.minus(y);
	    }
	
	    var xe = x.e,
	      xc = x.c,
	      ye = y.e,
	      yc = y.c;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) {
	      if (!yc[0]) {
	        if (xc[0]) {
	          y = new Big(x);
	        } else {
	          y.s = x.s;
	        }
	      }
	      return y;
	    }
	
	    xc = xc.slice();
	
	    // Prepend zeros to equalise exponents.
	    // Note: reverse faster than unshifts.
	    if (e = xe - ye) {
	      if (e > 0) {
	        ye = xe;
	        t = yc;
	      } else {
	        e = -e;
	        t = xc;
	      }
	
	      t.reverse();
	      for (; e--;) t.push(0);
	      t.reverse();
	    }
	
	    // Point xc to the longer array.
	    if (xc.length - yc.length < 0) {
	      t = yc;
	      yc = xc;
	      xc = t;
	    }
	
	    e = yc.length;
	
	    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
	    for (k = 0; e; xc[e] %= 10) k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
	
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	
	    if (k) {
	      xc.unshift(k);
	      ++ye;
	    }
	
	    // Remove trailing zeros.
	    for (e = xc.length; xc[--e] === 0;) xc.pop();
	
	    y.c = xc;
	    y.e = ye;
	
	    return y;
	  };
	
	
	  /*
	   * Return a Big whose value is the value of this Big raised to the power n.
	   * If n is negative, round to a maximum of Big.DP decimal places using rounding
	   * mode Big.RM.
	   *
	   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
	   */
	  P.pow = function (n) {
	    var x = this,
	      one = new x.constructor('1'),
	      y = one,
	      isneg = n < 0;
	
	    if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
	      throw Error(INVALID + 'exponent');
	    }
	
	    if (isneg) n = -n;
	
	    for (;;) {
	      if (n & 1) y = y.times(x);
	      n >>= 1;
	      if (!n) break;
	      x = x.times(x);
	    }
	
	    return isneg ? one.div(y) : y;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
	   * significant digits using rounding mode rm, or Big.RM if rm is not specified.
	   *
	   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
	   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
	   */
	  P.prec = function (sd, rm) {
	    if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
	      throw Error(INVALID + 'precision');
	    }
	    return round(new this.constructor(this), sd, rm);
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
	   * using rounding mode rm, or Big.RM if rm is not specified.
	   * If dp is negative, round to an integer which is a multiple of 10**-dp.
	   * If dp is not specified, round to 0 decimal places.
	   *
	   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
	   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
	   */
	  P.round = function (dp, rm) {
	    if (dp === UNDEFINED) dp = 0;
	    else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) {
	      throw Error(INVALID_DP);
	    }
	    return round(new this.constructor(this), dp + this.e + 1, rm);
	  };
	
	
	  /*
	   * Return a new Big whose value is the square root of the value of this Big, rounded, if
	   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
	   */
	  P.sqrt = function () {
	    var r, c, t,
	      x = this,
	      Big = x.constructor,
	      s = x.s,
	      e = x.e,
	      half = new Big('0.5');
	
	    // Zero?
	    if (!x.c[0]) return new Big(x);
	
	    // Negative?
	    if (s < 0) {
	      throw Error(NAME + 'No square root');
	    }
	
	    // Estimate.
	    s = Math.sqrt(+stringify(x, true, true));
	
	    // Math.sqrt underflow/overflow?
	    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
	    if (s === 0 || s === 1 / 0) {
	      c = x.c.join('');
	      if (!(c.length + e & 1)) c += '0';
	      s = Math.sqrt(c);
	      e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
	      r = new Big((s == 1 / 0 ? '5e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
	    } else {
	      r = new Big(s + '');
	    }
	
	    e = r.e + (Big.DP += 4);
	
	    // Newton-Raphson iteration.
	    do {
	      t = r;
	      r = half.times(t.plus(x.div(t)));
	    } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));
	
	    return round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big times the value of Big y.
	   */
	  P.times = P.mul = function (y) {
	    var c,
	      x = this,
	      Big = x.constructor,
	      xc = x.c,
	      yc = (y = new Big(y)).c,
	      a = xc.length,
	      b = yc.length,
	      i = x.e,
	      j = y.e;
	
	    // Determine sign of result.
	    y.s = x.s == y.s ? 1 : -1;
	
	    // Return signed 0 if either 0.
	    if (!xc[0] || !yc[0]) {
	      y.c = [y.e = 0];
	      return y;
	    }
	
	    // Initialise exponent of result as x.e + y.e.
	    y.e = i + j;
	
	    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
	    if (a < b) {
	      c = xc;
	      xc = yc;
	      yc = c;
	      j = a;
	      a = b;
	      b = j;
	    }
	
	    // Initialise coefficient array of result with zeros.
	    for (c = new Array(j = a + b); j--;) c[j] = 0;
	
	    // Multiply.
	
	    // i is initially xc.length.
	    for (i = b; i--;) {
	      b = 0;
	
	      // a is yc.length.
	      for (j = a + i; j > i;) {
	
	        // Current sum of products at this digit position, plus carry.
	        b = c[j] + yc[i] * xc[j - i - 1] + b;
	        c[j--] = b % 10;
	
	        // carry
	        b = b / 10 | 0;
	      }
	
	      c[j] = b;
	    }
	
	    // Increment result exponent if there is a final carry, otherwise remove leading zero.
	    if (b) ++y.e;
	    else c.shift();
	
	    // Remove trailing zeros.
	    for (i = c.length; !c[--i];) c.pop();
	    y.c = c;
	
	    return y;
	  };
	
	
	  /*
	   * Return a string representing the value of this Big in exponential notation rounded to dp fixed
	   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
	   *
	   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
	   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
	   */
	  P.toExponential = function (dp, rm) {
	    var x = this,
	      n = x.c[0];
	
	    if (dp !== UNDEFINED) {
	      if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
	        throw Error(INVALID_DP);
	      }
	      x = round(new x.constructor(x), ++dp, rm);
	      for (; x.c.length < dp;) x.c.push(0);
	    }
	
	    return stringify(x, true, !!n);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big in normal notation rounded to dp fixed
	   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
	   *
	   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
	   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   */
	  P.toFixed = function (dp, rm) {
	    var x = this,
	      n = x.c[0];
	
	    if (dp !== UNDEFINED) {
	      if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
	        throw Error(INVALID_DP);
	      }
	      x = round(new x.constructor(x), dp + x.e + 1, rm);
	
	      // x.e may have changed if the value is rounded up.
	      for (dp = dp + x.e + 1; x.c.length < dp;) x.c.push(0);
	    }
	
	    return stringify(x, false, !!n);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big.
	   * Return exponential notation if this Big has a positive exponent equal to or greater than
	   * Big.PE, or a negative exponent equal to or less than Big.NE.
	   * Omit the sign for negative zero.
	   */
	  P.toJSON = P.toString = function () {
	    var x = this,
	      Big = x.constructor;
	    return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
	  };
	
	
	  /*
	   * Return the value of this Big as a primitve number.
	   */
	  P.toNumber = function () {
	    var n = +stringify(this, true, true);
	    if (this.constructor.strict === true && !this.eq(n.toString())) {
	      throw Error(NAME + 'Imprecise conversion');
	    }
	    return n;
	  };
	
	
	  /*
	   * Return a string representing the value of this Big rounded to sd significant digits using
	   * rounding mode rm, or Big.RM if rm is not specified.
	   * Use exponential notation if sd is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
	   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
	   */
	  P.toPrecision = function (sd, rm) {
	    var x = this,
	      Big = x.constructor,
	      n = x.c[0];
	
	    if (sd !== UNDEFINED) {
	      if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
	        throw Error(INVALID + 'precision');
	      }
	      x = round(new Big(x), sd, rm);
	      for (; x.c.length < sd;) x.c.push(0);
	    }
	
	    return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big.
	   * Return exponential notation if this Big has a positive exponent equal to or greater than
	   * Big.PE, or a negative exponent equal to or less than Big.NE.
	   * Include the sign for negative zero.
	   */
	  P.valueOf = function () {
	    var x = this,
	      Big = x.constructor;
	    if (Big.strict === true) {
	      throw Error(NAME + 'valueOf disallowed');
	    }
	    return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
	  };
	
	
	  // Export
	
	
	  Big = _Big_();
	
	  Big['default'] = Big.Big = Big;
	
	  //AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return Big; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other CommonJS-like environments that support module.exports.
	  } else if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Big;
	
	  //Browser.
	  } else {
	    GLOBAL.Big = Big;
	  }
	})(this);


/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	function e(r){var o,t,f="";if("string"==typeof r||"number"==typeof r)f+=r;else if("object"==typeof r)if(Array.isArray(r))for(o=0;o<r.length;o++)r[o]&&(t=e(r[o]))&&(f&&(f+=" "),f+=t);else for(o in r)r[o]&&(f&&(f+=" "),f+=o);return f}function r(){for(var r,o,t=0,f="";t<arguments.length;)(r=arguments[t++])&&(o=e(r))&&(f&&(f+=" "),f+=o);return f}module.exports=r,module.exports.clsx=r;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/5/LICENSE
	
	// This is CodeMirror (https://codemirror.net/5), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.CodeMirror = factory());
	}(this, (function () { 'use strict';
	
	  // Kludges for bugs and behavior differences that can't be feature
	  // detected are enabled based on userAgent etc sniffing.
	  var userAgent = navigator.userAgent;
	  var platform = navigator.platform;
	
	  var gecko = /gecko\/\d/i.test(userAgent);
	  var ie_upto10 = /MSIE \d/.test(userAgent);
	  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
	  var edge = /Edge\/(\d+)/.exec(userAgent);
	  var ie = ie_upto10 || ie_11up || edge;
	  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
	  var webkit = !edge && /WebKit\//.test(userAgent);
	  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
	  var chrome = !edge && /Chrome\/(\d+)/.exec(userAgent);
	  var chrome_version = chrome && +chrome[1];
	  var presto = /Opera\//.test(userAgent);
	  var safari = /Apple Computer/.test(navigator.vendor);
	  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
	  var phantom = /PhantomJS/.test(userAgent);
	
	  var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
	  var android = /Android/.test(userAgent);
	  // This is woefully incomplete. Suggestions for alternative methods welcome.
	  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
	  var mac = ios || /Mac/.test(platform);
	  var chromeOS = /\bCrOS\b/.test(userAgent);
	  var windows = /win/i.test(platform);
	
	  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
	  if (presto_version) { presto_version = Number(presto_version[1]); }
	  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
	  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
	  var captureRightClick = gecko || (ie && ie_version >= 9);
	
	  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }
	
	  var rmClass = function(node, cls) {
	    var current = node.className;
	    var match = classTest(cls).exec(current);
	    if (match) {
	      var after = current.slice(match.index + match[0].length);
	      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
	    }
	  };
	
	  function removeChildren(e) {
	    for (var count = e.childNodes.length; count > 0; --count)
	      { e.removeChild(e.firstChild); }
	    return e
	  }
	
	  function removeChildrenAndAdd(parent, e) {
	    return removeChildren(parent).appendChild(e)
	  }
	
	  function elt(tag, content, className, style) {
	    var e = document.createElement(tag);
	    if (className) { e.className = className; }
	    if (style) { e.style.cssText = style; }
	    if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
	    else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
	    return e
	  }
	  // wrapper for elt, which removes the elt from the accessibility tree
	  function eltP(tag, content, className, style) {
	    var e = elt(tag, content, className, style);
	    e.setAttribute("role", "presentation");
	    return e
	  }
	
	  var range;
	  if (document.createRange) { range = function(node, start, end, endNode) {
	    var r = document.createRange();
	    r.setEnd(endNode || node, end);
	    r.setStart(node, start);
	    return r
	  }; }
	  else { range = function(node, start, end) {
	    var r = document.body.createTextRange();
	    try { r.moveToElementText(node.parentNode); }
	    catch(e) { return r }
	    r.collapse(true);
	    r.moveEnd("character", end);
	    r.moveStart("character", start);
	    return r
	  }; }
	
	  function contains(parent, child) {
	    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	      { child = child.parentNode; }
	    if (parent.contains)
	      { return parent.contains(child) }
	    do {
	      if (child.nodeType == 11) { child = child.host; }
	      if (child == parent) { return true }
	    } while (child = child.parentNode)
	  }
	
	  function activeElt(rootNode) {
	    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	    // IE < 10 will throw when accessed while the page is loading or in an iframe.
	    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	    var doc = rootNode.ownerDocument || rootNode;
	    var activeElement;
	    try {
	      activeElement = rootNode.activeElement;
	    } catch(e) {
	      activeElement = doc.body || null;
	    }
	    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
	      { activeElement = activeElement.shadowRoot.activeElement; }
	    return activeElement
	  }
	
	  function addClass(node, cls) {
	    var current = node.className;
	    if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
	  }
	  function joinClasses(a, b) {
	    var as = a.split(" ");
	    for (var i = 0; i < as.length; i++)
	      { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
	    return b
	  }
	
	  var selectInput = function(node) { node.select(); };
	  if (ios) // Mobile Safari apparently has a bug where select() is broken.
	    { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
	  else if (ie) // Suppress mysterious IE10 errors
	    { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }
	
	  function doc(cm) { return cm.display.wrapper.ownerDocument }
	
	  function root(cm) {
	    return rootNode(cm.display.wrapper)
	  }
	
	  function rootNode(element) {
	    // Detect modern browsers (2017+).
	    return element.getRootNode ? element.getRootNode() : element.ownerDocument
	  }
	
	  function win(cm) { return doc(cm).defaultView }
	
	  function bind(f) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return function(){return f.apply(null, args)}
	  }
	
	  function copyObj(obj, target, overwrite) {
	    if (!target) { target = {}; }
	    for (var prop in obj)
	      { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
	        { target[prop] = obj[prop]; } }
	    return target
	  }
	
	  // Counts the column offset in a string, taking tabs into account.
	  // Used mostly to find indentation.
	  function countColumn(string, end, tabSize, startIndex, startValue) {
	    if (end == null) {
	      end = string.search(/[^\s\u00a0]/);
	      if (end == -1) { end = string.length; }
	    }
	    for (var i = startIndex || 0, n = startValue || 0;;) {
	      var nextTab = string.indexOf("\t", i);
	      if (nextTab < 0 || nextTab >= end)
	        { return n + (end - i) }
	      n += nextTab - i;
	      n += tabSize - (n % tabSize);
	      i = nextTab + 1;
	    }
	  }
	
	  var Delayed = function() {
	    this.id = null;
	    this.f = null;
	    this.time = 0;
	    this.handler = bind(this.onTimeout, this);
	  };
	  Delayed.prototype.onTimeout = function (self) {
	    self.id = 0;
	    if (self.time <= +new Date) {
	      self.f();
	    } else {
	      setTimeout(self.handler, self.time - +new Date);
	    }
	  };
	  Delayed.prototype.set = function (ms, f) {
	    this.f = f;
	    var time = +new Date + ms;
	    if (!this.id || time < this.time) {
	      clearTimeout(this.id);
	      this.id = setTimeout(this.handler, ms);
	      this.time = time;
	    }
	  };
	
	  function indexOf(array, elt) {
	    for (var i = 0; i < array.length; ++i)
	      { if (array[i] == elt) { return i } }
	    return -1
	  }
	
	  // Number of pixels added to scroller and sizer to hide scrollbar
	  var scrollerGap = 50;
	
	  // Returned or thrown by various protocols to signal 'I'm not
	  // handling this'.
	  var Pass = {toString: function(){return "CodeMirror.Pass"}};
	
	  // Reused option objects for setSelection & friends
	  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};
	
	  // The inverse of countColumn -- find the offset that corresponds to
	  // a particular column.
	  function findColumn(string, goal, tabSize) {
	    for (var pos = 0, col = 0;;) {
	      var nextTab = string.indexOf("\t", pos);
	      if (nextTab == -1) { nextTab = string.length; }
	      var skipped = nextTab - pos;
	      if (nextTab == string.length || col + skipped >= goal)
	        { return pos + Math.min(skipped, goal - col) }
	      col += nextTab - pos;
	      col += tabSize - (col % tabSize);
	      pos = nextTab + 1;
	      if (col >= goal) { return pos }
	    }
	  }
	
	  var spaceStrs = [""];
	  function spaceStr(n) {
	    while (spaceStrs.length <= n)
	      { spaceStrs.push(lst(spaceStrs) + " "); }
	    return spaceStrs[n]
	  }
	
	  function lst(arr) { return arr[arr.length-1] }
	
	  function map(array, f) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
	    return out
	  }
	
	  function insertSorted(array, value, score) {
	    var pos = 0, priority = score(value);
	    while (pos < array.length && score(array[pos]) <= priority) { pos++; }
	    array.splice(pos, 0, value);
	  }
	
	  function nothing() {}
	
	  function createObj(base, props) {
	    var inst;
	    if (Object.create) {
	      inst = Object.create(base);
	    } else {
	      nothing.prototype = base;
	      inst = new nothing();
	    }
	    if (props) { copyObj(props, inst); }
	    return inst
	  }
	
	  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
	  function isWordCharBasic(ch) {
	    return /\w/.test(ch) || ch > "\x80" &&
	      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
	  }
	  function isWordChar(ch, helper) {
	    if (!helper) { return isWordCharBasic(ch) }
	    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
	    return helper.test(ch)
	  }
	
	  function isEmpty(obj) {
	    for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
	    return true
	  }
	
	  // Extending unicode characters. A series of a non-extending char +
	  // any number of extending chars is treated as a single unit as far
	  // as editing and measuring is concerned. This is not fully correct,
	  // since some scripts/fonts/browsers also treat other configurations
	  // of code points as a group.
	  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
	  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }
	
	  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
	  function skipExtendingChars(str, pos, dir) {
	    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
	    return pos
	  }
	
	  // Returns the value from the range [`from`; `to`] that satisfies
	  // `pred` and is closest to `from`. Assumes that at least `to`
	  // satisfies `pred`. Supports `from` being greater than `to`.
	  function findFirst(pred, from, to) {
	    // At any point we are certain `to` satisfies `pred`, don't know
	    // whether `from` does.
	    var dir = from > to ? -1 : 1;
	    for (;;) {
	      if (from == to) { return from }
	      var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
	      if (mid == from) { return pred(mid) ? from : to }
	      if (pred(mid)) { to = mid; }
	      else { from = mid + dir; }
	    }
	  }
	
	  // BIDI HELPERS
	
	  function iterateBidiSections(order, from, to, f) {
	    if (!order) { return f(from, to, "ltr", 0) }
	    var found = false;
	    for (var i = 0; i < order.length; ++i) {
	      var part = order[i];
	      if (part.from < to && part.to > from || from == to && part.to == from) {
	        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
	        found = true;
	      }
	    }
	    if (!found) { f(from, to, "ltr"); }
	  }
	
	  var bidiOther = null;
	  function getBidiPartAt(order, ch, sticky) {
	    var found;
	    bidiOther = null;
	    for (var i = 0; i < order.length; ++i) {
	      var cur = order[i];
	      if (cur.from < ch && cur.to > ch) { return i }
	      if (cur.to == ch) {
	        if (cur.from != cur.to && sticky == "before") { found = i; }
	        else { bidiOther = i; }
	      }
	      if (cur.from == ch) {
	        if (cur.from != cur.to && sticky != "before") { found = i; }
	        else { bidiOther = i; }
	      }
	    }
	    return found != null ? found : bidiOther
	  }
	
	  // Bidirectional ordering algorithm
	  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	  // that this (partially) implements.
	
	  // One-char codes used for character types:
	  // L (L):   Left-to-Right
	  // R (R):   Right-to-Left
	  // r (AL):  Right-to-Left Arabic
	  // 1 (EN):  European Number
	  // + (ES):  European Number Separator
	  // % (ET):  European Number Terminator
	  // n (AN):  Arabic Number
	  // , (CS):  Common Number Separator
	  // m (NSM): Non-Spacing Mark
	  // b (BN):  Boundary Neutral
	  // s (B):   Paragraph Separator
	  // t (S):   Segment Separator
	  // w (WS):  Whitespace
	  // N (ON):  Other Neutrals
	
	  // Returns null if characters are ordered as they appear
	  // (left-to-right), or an array of sections ({from, to, level}
	  // objects) in the order in which they occur visually.
	  var bidiOrdering = (function() {
	    // Character types for codepoints 0 to 0xff
	    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
	    // Character types for codepoints 0x600 to 0x6f9
	    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
	    function charType(code) {
	      if (code <= 0xf7) { return lowTypes.charAt(code) }
	      else if (0x590 <= code && code <= 0x5f4) { return "R" }
	      else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
	      else if (0x6ee <= code && code <= 0x8ac) { return "r" }
	      else if (0x2000 <= code && code <= 0x200b) { return "w" }
	      else if (code == 0x200c) { return "b" }
	      else { return "L" }
	    }
	
	    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
	    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
	
	    function BidiSpan(level, from, to) {
	      this.level = level;
	      this.from = from; this.to = to;
	    }
	
	    return function(str, direction) {
	      var outerType = direction == "ltr" ? "L" : "R";
	
	      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
	      var len = str.length, types = [];
	      for (var i = 0; i < len; ++i)
	        { types.push(charType(str.charCodeAt(i))); }
	
	      // W1. Examine each non-spacing mark (NSM) in the level run, and
	      // change the type of the NSM to the type of the previous
	      // character. If the NSM is at the start of the level run, it will
	      // get the type of sor.
	      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
	        var type = types[i$1];
	        if (type == "m") { types[i$1] = prev; }
	        else { prev = type; }
	      }
	
	      // W2. Search backwards from each instance of a European number
	      // until the first strong type (R, L, AL, or sor) is found. If an
	      // AL is found, change the type of the European number to Arabic
	      // number.
	      // W3. Change all ALs to R.
	      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
	        var type$1 = types[i$2];
	        if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
	        else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
	      }
	
	      // W4. A single European separator between two European numbers
	      // changes to a European number. A single common separator between
	      // two numbers of the same type changes to that type.
	      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
	        var type$2 = types[i$3];
	        if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
	        else if (type$2 == "," && prev$1 == types[i$3+1] &&
	                 (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
	        prev$1 = type$2;
	      }
	
	      // W5. A sequence of European terminators adjacent to European
	      // numbers changes to all European numbers.
	      // W6. Otherwise, separators and terminators change to Other
	      // Neutral.
	      for (var i$4 = 0; i$4 < len; ++i$4) {
	        var type$3 = types[i$4];
	        if (type$3 == ",") { types[i$4] = "N"; }
	        else if (type$3 == "%") {
	          var end = (void 0);
	          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
	          var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
	          for (var j = i$4; j < end; ++j) { types[j] = replace; }
	          i$4 = end - 1;
	        }
	      }
	
	      // W7. Search backwards from each instance of a European number
	      // until the first strong type (R, L, or sor) is found. If an L is
	      // found, then change the type of the European number to L.
	      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
	        var type$4 = types[i$5];
	        if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
	        else if (isStrong.test(type$4)) { cur$1 = type$4; }
	      }
	
	      // N1. A sequence of neutrals takes the direction of the
	      // surrounding strong text if the text on both sides has the same
	      // direction. European and Arabic numbers act as if they were R in
	      // terms of their influence on neutrals. Start-of-level-run (sor)
	      // and end-of-level-run (eor) are used at level run boundaries.
	      // N2. Any remaining neutrals take the embedding direction.
	      for (var i$6 = 0; i$6 < len; ++i$6) {
	        if (isNeutral.test(types[i$6])) {
	          var end$1 = (void 0);
	          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
	          var before = (i$6 ? types[i$6-1] : outerType) == "L";
	          var after = (end$1 < len ? types[end$1] : outerType) == "L";
	          var replace$1 = before == after ? (before ? "L" : "R") : outerType;
	          for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
	          i$6 = end$1 - 1;
	        }
	      }
	
	      // Here we depart from the documented algorithm, in order to avoid
	      // building up an actual levels array. Since there are only three
	      // levels (0, 1, 2) in an implementation that doesn't take
	      // explicit embedding into account, we can build up the order on
	      // the fly, without following the level-based algorithm.
	      var order = [], m;
	      for (var i$7 = 0; i$7 < len;) {
	        if (countsAsLeft.test(types[i$7])) {
	          var start = i$7;
	          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
	          order.push(new BidiSpan(0, start, i$7));
	        } else {
	          var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
	          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
	          for (var j$2 = pos; j$2 < i$7;) {
	            if (countsAsNum.test(types[j$2])) {
	              if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); at += isRTL; }
	              var nstart = j$2;
	              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
	              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
	              at += isRTL;
	              pos = j$2;
	            } else { ++j$2; }
	          }
	          if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
	        }
	      }
	      if (direction == "ltr") {
	        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	          order[0].from = m[0].length;
	          order.unshift(new BidiSpan(0, 0, m[0].length));
	        }
	        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	          lst(order).to -= m[0].length;
	          order.push(new BidiSpan(0, len - m[0].length, len));
	        }
	      }
	
	      return direction == "rtl" ? order.reverse() : order
	    }
	  })();
	
	  // Get the bidi ordering for the given line (and cache it). Returns
	  // false for lines that are fully left-to-right, and an array of
	  // BidiSpan objects otherwise.
	  function getOrder(line, direction) {
	    var order = line.order;
	    if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
	    return order
	  }
	
	  // EVENT HANDLING
	
	  // Lightweight event framework. on/off also work on DOM nodes,
	  // registering native DOM handlers.
	
	  var noHandlers = [];
	
	  var on = function(emitter, type, f) {
	    if (emitter.addEventListener) {
	      emitter.addEventListener(type, f, false);
	    } else if (emitter.attachEvent) {
	      emitter.attachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers || (emitter._handlers = {});
	      map[type] = (map[type] || noHandlers).concat(f);
	    }
	  };
	
	  function getHandlers(emitter, type) {
	    return emitter._handlers && emitter._handlers[type] || noHandlers
	  }
	
	  function off(emitter, type, f) {
	    if (emitter.removeEventListener) {
	      emitter.removeEventListener(type, f, false);
	    } else if (emitter.detachEvent) {
	      emitter.detachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers, arr = map && map[type];
	      if (arr) {
	        var index = indexOf(arr, f);
	        if (index > -1)
	          { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
	      }
	    }
	  }
	
	  function signal(emitter, type /*, values...*/) {
	    var handlers = getHandlers(emitter, type);
	    if (!handlers.length) { return }
	    var args = Array.prototype.slice.call(arguments, 2);
	    for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
	  }
	
	  // The DOM events that CodeMirror handles can be overridden by
	  // registering a (non-DOM) handler on the editor for the event name,
	  // and preventDefault-ing the event in that handler.
	  function signalDOMEvent(cm, e, override) {
	    if (typeof e == "string")
	      { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
	    signal(cm, override || e.type, cm, e);
	    return e_defaultPrevented(e) || e.codemirrorIgnore
	  }
	
	  function signalCursorActivity(cm) {
	    var arr = cm._handlers && cm._handlers.cursorActivity;
	    if (!arr) { return }
	    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
	    for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
	      { set.push(arr[i]); } }
	  }
	
	  function hasHandler(emitter, type) {
	    return getHandlers(emitter, type).length > 0
	  }
	
	  // Add on and off methods to a constructor's prototype, to make
	  // registering events on such objects more convenient.
	  function eventMixin(ctor) {
	    ctor.prototype.on = function(type, f) {on(this, type, f);};
	    ctor.prototype.off = function(type, f) {off(this, type, f);};
	  }
	
	  // Due to the fact that we still support jurassic IE versions, some
	  // compatibility wrappers are needed.
	
	  function e_preventDefault(e) {
	    if (e.preventDefault) { e.preventDefault(); }
	    else { e.returnValue = false; }
	  }
	  function e_stopPropagation(e) {
	    if (e.stopPropagation) { e.stopPropagation(); }
	    else { e.cancelBubble = true; }
	  }
	  function e_defaultPrevented(e) {
	    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
	  }
	  function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}
	
	  function e_target(e) {return e.target || e.srcElement}
	  function e_button(e) {
	    var b = e.which;
	    if (b == null) {
	      if (e.button & 1) { b = 1; }
	      else if (e.button & 2) { b = 3; }
	      else if (e.button & 4) { b = 2; }
	    }
	    if (mac && e.ctrlKey && b == 1) { b = 3; }
	    return b
	  }
	
	  // Detect drag-and-drop
	  var dragAndDrop = function() {
	    // There is *some* kind of drag-and-drop support in IE6-8, but I
	    // couldn't get it to work yet.
	    if (ie && ie_version < 9) { return false }
	    var div = elt('div');
	    return "draggable" in div || "dragDrop" in div
	  }();
	
	  var zwspSupported;
	  function zeroWidthElement(measure) {
	    if (zwspSupported == null) {
	      var test = elt("span", "\u200b");
	      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
	      if (measure.firstChild.offsetHeight != 0)
	        { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
	    }
	    var node = zwspSupported ? elt("span", "\u200b") :
	      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
	    node.setAttribute("cm-text", "");
	    return node
	  }
	
	  // Feature-detect IE's crummy client rect reporting for bidi text
	  var badBidiRects;
	  function hasBadBidiRects(measure) {
	    if (badBidiRects != null) { return badBidiRects }
	    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
	    var r0 = range(txt, 0, 1).getBoundingClientRect();
	    var r1 = range(txt, 1, 2).getBoundingClientRect();
	    removeChildren(measure);
	    if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
	    return badBidiRects = (r1.right - r0.right < 3)
	  }
	
	  // See if "".split is the broken IE version, if so, provide an
	  // alternative way to split lines.
	  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
	    var pos = 0, result = [], l = string.length;
	    while (pos <= l) {
	      var nl = string.indexOf("\n", pos);
	      if (nl == -1) { nl = string.length; }
	      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
	      var rt = line.indexOf("\r");
	      if (rt != -1) {
	        result.push(line.slice(0, rt));
	        pos += rt + 1;
	      } else {
	        result.push(line);
	        pos = nl + 1;
	      }
	    }
	    return result
	  } : function (string) { return string.split(/\r\n?|\n/); };
	
	  var hasSelection = window.getSelection ? function (te) {
	    try { return te.selectionStart != te.selectionEnd }
	    catch(e) { return false }
	  } : function (te) {
	    var range;
	    try {range = te.ownerDocument.selection.createRange();}
	    catch(e) {}
	    if (!range || range.parentElement() != te) { return false }
	    return range.compareEndPoints("StartToEnd", range) != 0
	  };
	
	  var hasCopyEvent = (function () {
	    var e = elt("div");
	    if ("oncopy" in e) { return true }
	    e.setAttribute("oncopy", "return;");
	    return typeof e.oncopy == "function"
	  })();
	
	  var badZoomedRects = null;
	  function hasBadZoomedRects(measure) {
	    if (badZoomedRects != null) { return badZoomedRects }
	    var node = removeChildrenAndAdd(measure, elt("span", "x"));
	    var normal = node.getBoundingClientRect();
	    var fromRange = range(node, 0, 1).getBoundingClientRect();
	    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
	  }
	
	  // Known modes, by name and by MIME
	  var modes = {}, mimeModes = {};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  function defineMode(name, mode) {
	    if (arguments.length > 2)
	      { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
	    modes[name] = mode;
	  }
	
	  function defineMIME(mime, spec) {
	    mimeModes[mime] = spec;
	  }
	
	  // Given a MIME type, a {name, ...options} config object, or a name
	  // string, return a mode config object.
	  function resolveMode(spec) {
	    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	      spec = mimeModes[spec];
	    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	      var found = mimeModes[spec.name];
	      if (typeof found == "string") { found = {name: found}; }
	      spec = createObj(found, spec);
	      spec.name = found.name;
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	      return resolveMode("application/xml")
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	      return resolveMode("application/json")
	    }
	    if (typeof spec == "string") { return {name: spec} }
	    else { return spec || {name: "null"} }
	  }
	
	  // Given a mode spec (anything that resolveMode accepts), find and
	  // initialize an actual mode object.
	  function getMode(options, spec) {
	    spec = resolveMode(spec);
	    var mfactory = modes[spec.name];
	    if (!mfactory) { return getMode(options, "text/plain") }
	    var modeObj = mfactory(options, spec);
	    if (modeExtensions.hasOwnProperty(spec.name)) {
	      var exts = modeExtensions[spec.name];
	      for (var prop in exts) {
	        if (!exts.hasOwnProperty(prop)) { continue }
	        if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
	        modeObj[prop] = exts[prop];
	      }
	    }
	    modeObj.name = spec.name;
	    if (spec.helperType) { modeObj.helperType = spec.helperType; }
	    if (spec.modeProps) { for (var prop$1 in spec.modeProps)
	      { modeObj[prop$1] = spec.modeProps[prop$1]; } }
	
	    return modeObj
	  }
	
	  // This can be used to attach properties to mode objects from
	  // outside the actual mode definition.
	  var modeExtensions = {};
	  function extendMode(mode, properties) {
	    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
	    copyObj(properties, exts);
	  }
	
	  function copyState(mode, state) {
	    if (state === true) { return state }
	    if (mode.copyState) { return mode.copyState(state) }
	    var nstate = {};
	    for (var n in state) {
	      var val = state[n];
	      if (val instanceof Array) { val = val.concat([]); }
	      nstate[n] = val;
	    }
	    return nstate
	  }
	
	  // Given a mode and a state (for that mode), find the inner mode and
	  // state at the position that the state refers to.
	  function innerMode(mode, state) {
	    var info;
	    while (mode.innerMode) {
	      info = mode.innerMode(state);
	      if (!info || info.mode == mode) { break }
	      state = info.state;
	      mode = info.mode;
	    }
	    return info || {mode: mode, state: state}
	  }
	
	  function startState(mode, a1, a2) {
	    return mode.startState ? mode.startState(a1, a2) : true
	  }
	
	  // STRING STREAM
	
	  // Fed to the mode parsers, provides helper functions to make
	  // parsers more succinct.
	
	  var StringStream = function(string, tabSize, lineOracle) {
	    this.pos = this.start = 0;
	    this.string = string;
	    this.tabSize = tabSize || 8;
	    this.lastColumnPos = this.lastColumnValue = 0;
	    this.lineStart = 0;
	    this.lineOracle = lineOracle;
	  };
	
	  StringStream.prototype.eol = function () {return this.pos >= this.string.length};
	  StringStream.prototype.sol = function () {return this.pos == this.lineStart};
	  StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
	  StringStream.prototype.next = function () {
	    if (this.pos < this.string.length)
	      { return this.string.charAt(this.pos++) }
	  };
	  StringStream.prototype.eat = function (match) {
	    var ch = this.string.charAt(this.pos);
	    var ok;
	    if (typeof match == "string") { ok = ch == match; }
	    else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
	    if (ok) {++this.pos; return ch}
	  };
	  StringStream.prototype.eatWhile = function (match) {
	    var start = this.pos;
	    while (this.eat(match)){}
	    return this.pos > start
	  };
	  StringStream.prototype.eatSpace = function () {
	    var start = this.pos;
	    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this.pos; }
	    return this.pos > start
	  };
	  StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
	  StringStream.prototype.skipTo = function (ch) {
	    var found = this.string.indexOf(ch, this.pos);
	    if (found > -1) {this.pos = found; return true}
	  };
	  StringStream.prototype.backUp = function (n) {this.pos -= n;};
	  StringStream.prototype.column = function () {
	    if (this.lastColumnPos < this.start) {
	      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
	      this.lastColumnPos = this.start;
	    }
	    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  };
	  StringStream.prototype.indentation = function () {
	    return countColumn(this.string, null, this.tabSize) -
	      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  };
	  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
	    if (typeof pattern == "string") {
	      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
	      var substr = this.string.substr(this.pos, pattern.length);
	      if (cased(substr) == cased(pattern)) {
	        if (consume !== false) { this.pos += pattern.length; }
	        return true
	      }
	    } else {
	      var match = this.string.slice(this.pos).match(pattern);
	      if (match && match.index > 0) { return null }
	      if (match && consume !== false) { this.pos += match[0].length; }
	      return match
	    }
	  };
	  StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
	  StringStream.prototype.hideFirstChars = function (n, inner) {
	    this.lineStart += n;
	    try { return inner() }
	    finally { this.lineStart -= n; }
	  };
	  StringStream.prototype.lookAhead = function (n) {
	    var oracle = this.lineOracle;
	    return oracle && oracle.lookAhead(n)
	  };
	  StringStream.prototype.baseToken = function () {
	    var oracle = this.lineOracle;
	    return oracle && oracle.baseToken(this.pos)
	  };
	
	  // Find the line object corresponding to the given line number.
	  function getLine(doc, n) {
	    n -= doc.first;
	    if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
	    var chunk = doc;
	    while (!chunk.lines) {
	      for (var i = 0;; ++i) {
	        var child = chunk.children[i], sz = child.chunkSize();
	        if (n < sz) { chunk = child; break }
	        n -= sz;
	      }
	    }
	    return chunk.lines[n]
	  }
	
	  // Get the part of a document between two positions, as an array of
	  // strings.
	  function getBetween(doc, start, end) {
	    var out = [], n = start.line;
	    doc.iter(start.line, end.line + 1, function (line) {
	      var text = line.text;
	      if (n == end.line) { text = text.slice(0, end.ch); }
	      if (n == start.line) { text = text.slice(start.ch); }
	      out.push(text);
	      ++n;
	    });
	    return out
	  }
	  // Get the lines between from and to, as array of strings.
	  function getLines(doc, from, to) {
	    var out = [];
	    doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
	    return out
	  }
	
	  // Update the height of a line, propagating the height change
	  // upwards to parent nodes.
	  function updateLineHeight(line, height) {
	    var diff = height - line.height;
	    if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
	  }
	
	  // Given a line object, find its line number by walking up through
	  // its parent links.
	  function lineNo(line) {
	    if (line.parent == null) { return null }
	    var cur = line.parent, no = indexOf(cur.lines, line);
	    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	      for (var i = 0;; ++i) {
	        if (chunk.children[i] == cur) { break }
	        no += chunk.children[i].chunkSize();
	      }
	    }
	    return no + cur.first
	  }
	
	  // Find the line at the given vertical position, using the height
	  // information in the document tree.
	  function lineAtHeight(chunk, h) {
	    var n = chunk.first;
	    outer: do {
	      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
	        var child = chunk.children[i$1], ch = child.height;
	        if (h < ch) { chunk = child; continue outer }
	        h -= ch;
	        n += child.chunkSize();
	      }
	      return n
	    } while (!chunk.lines)
	    var i = 0;
	    for (; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i], lh = line.height;
	      if (h < lh) { break }
	      h -= lh;
	    }
	    return n + i
	  }
	
	  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}
	
	  function lineNumberFor(options, i) {
	    return String(options.lineNumberFormatter(i + options.firstLineNumber))
	  }
	
	  // A Pos instance represents a position within the text.
	  function Pos(line, ch, sticky) {
	    if ( sticky === void 0 ) sticky = null;
	
	    if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
	    this.line = line;
	    this.ch = ch;
	    this.sticky = sticky;
	  }
	
	  // Compare two positions, return 0 if they are the same, a negative
	  // number when a is less, and a positive number otherwise.
	  function cmp(a, b) { return a.line - b.line || a.ch - b.ch }
	
	  function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }
	
	  function copyPos(x) {return Pos(x.line, x.ch)}
	  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
	  function minPos(a, b) { return cmp(a, b) < 0 ? a : b }
	
	  // Most of the external API clips given positions to make sure they
	  // actually exist within the document.
	  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
	  function clipPos(doc, pos) {
	    if (pos.line < doc.first) { return Pos(doc.first, 0) }
	    var last = doc.first + doc.size - 1;
	    if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
	    return clipToLen(pos, getLine(doc, pos.line).text.length)
	  }
	  function clipToLen(pos, linelen) {
	    var ch = pos.ch;
	    if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
	    else if (ch < 0) { return Pos(pos.line, 0) }
	    else { return pos }
	  }
	  function clipPosArray(doc, array) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
	    return out
	  }
	
	  var SavedContext = function(state, lookAhead) {
	    this.state = state;
	    this.lookAhead = lookAhead;
	  };
	
	  var Context = function(doc, state, line, lookAhead) {
	    this.state = state;
	    this.doc = doc;
	    this.line = line;
	    this.maxLookAhead = lookAhead || 0;
	    this.baseTokens = null;
	    this.baseTokenPos = 1;
	  };
	
	  Context.prototype.lookAhead = function (n) {
	    var line = this.doc.getLine(this.line + n);
	    if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
	    return line
	  };
	
	  Context.prototype.baseToken = function (n) {
	    if (!this.baseTokens) { return null }
	    while (this.baseTokens[this.baseTokenPos] <= n)
	      { this.baseTokenPos += 2; }
	    var type = this.baseTokens[this.baseTokenPos + 1];
	    return {type: type && type.replace(/( |^)overlay .*/, ""),
	            size: this.baseTokens[this.baseTokenPos] - n}
	  };
	
	  Context.prototype.nextLine = function () {
	    this.line++;
	    if (this.maxLookAhead > 0) { this.maxLookAhead--; }
	  };
	
	  Context.fromSaved = function (doc, saved, line) {
	    if (saved instanceof SavedContext)
	      { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
	    else
	      { return new Context(doc, copyState(doc.mode, saved), line) }
	  };
	
	  Context.prototype.save = function (copy) {
	    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
	    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
	  };
	
	
	  // Compute a style array (an array starting with a mode generation
	  // -- for invalidation -- followed by pairs of end positions and
	  // style strings), which is used to highlight the tokens on the
	  // line.
	  function highlightLine(cm, line, context, forceToEnd) {
	    // A styles array always starts with a number identifying the
	    // mode/overlays that it is based on (for easy invalidation).
	    var st = [cm.state.modeGen], lineClasses = {};
	    // Compute the base array of styles
	    runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
	            lineClasses, forceToEnd);
	    var state = context.state;
	
	    // Run overlays, adjust style array.
	    var loop = function ( o ) {
	      context.baseTokens = st;
	      var overlay = cm.state.overlays[o], i = 1, at = 0;
	      context.state = true;
	      runMode(cm, line.text, overlay.mode, context, function (end, style) {
	        var start = i;
	        // Ensure there's a token end at the current position, and that i points at it
	        while (at < end) {
	          var i_end = st[i];
	          if (i_end > end)
	            { st.splice(i, 1, end, st[i+1], i_end); }
	          i += 2;
	          at = Math.min(end, i_end);
	        }
	        if (!style) { return }
	        if (overlay.opaque) {
	          st.splice(start, i - start, end, "overlay " + style);
	          i = start + 2;
	        } else {
	          for (; start < i; start += 2) {
	            var cur = st[start+1];
	            st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
	          }
	        }
	      }, lineClasses);
	      context.state = state;
	      context.baseTokens = null;
	      context.baseTokenPos = 1;
	    };
	
	    for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );
	
	    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
	  }
	
	  function getLineStyles(cm, line, updateFrontier) {
	    if (!line.styles || line.styles[0] != cm.state.modeGen) {
	      var context = getContextBefore(cm, lineNo(line));
	      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
	      var result = highlightLine(cm, line, context);
	      if (resetState) { context.state = resetState; }
	      line.stateAfter = context.save(!resetState);
	      line.styles = result.styles;
	      if (result.classes) { line.styleClasses = result.classes; }
	      else if (line.styleClasses) { line.styleClasses = null; }
	      if (updateFrontier === cm.doc.highlightFrontier)
	        { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
	    }
	    return line.styles
	  }
	
	  function getContextBefore(cm, n, precise) {
	    var doc = cm.doc, display = cm.display;
	    if (!doc.mode.startState) { return new Context(doc, true, n) }
	    var start = findStartLine(cm, n, precise);
	    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
	    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
	
	    doc.iter(start, n, function (line) {
	      processLine(cm, line.text, context);
	      var pos = context.line;
	      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
	      context.nextLine();
	    });
	    if (precise) { doc.modeFrontier = context.line; }
	    return context
	  }
	
	  // Lightweight form of highlight -- proceed over this line and
	  // update state, but don't save a style array. Used for lines that
	  // aren't currently visible.
	  function processLine(cm, text, context, startAt) {
	    var mode = cm.doc.mode;
	    var stream = new StringStream(text, cm.options.tabSize, context);
	    stream.start = stream.pos = startAt || 0;
	    if (text == "") { callBlankLine(mode, context.state); }
	    while (!stream.eol()) {
	      readToken(mode, stream, context.state);
	      stream.start = stream.pos;
	    }
	  }
	
	  function callBlankLine(mode, state) {
	    if (mode.blankLine) { return mode.blankLine(state) }
	    if (!mode.innerMode) { return }
	    var inner = innerMode(mode, state);
	    if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
	  }
	
	  function readToken(mode, stream, state, inner) {
	    for (var i = 0; i < 10; i++) {
	      if (inner) { inner[0] = innerMode(mode, state).mode; }
	      var style = mode.token(stream, state);
	      if (stream.pos > stream.start) { return style }
	    }
	    throw new Error("Mode " + mode.name + " failed to advance stream.")
	  }
	
	  var Token = function(stream, type, state) {
	    this.start = stream.start; this.end = stream.pos;
	    this.string = stream.current();
	    this.type = type || null;
	    this.state = state;
	  };
	
	  // Utility for getTokenAt and getLineTokens
	  function takeToken(cm, pos, precise, asArray) {
	    var doc = cm.doc, mode = doc.mode, style;
	    pos = clipPos(doc, pos);
	    var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
	    var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
	    if (asArray) { tokens = []; }
	    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	      stream.start = stream.pos;
	      style = readToken(mode, stream, context.state);
	      if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
	    }
	    return asArray ? tokens : new Token(stream, style, context.state)
	  }
	
	  function extractLineClasses(type, output) {
	    if (type) { for (;;) {
	      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
	      if (!lineClass) { break }
	      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
	      var prop = lineClass[1] ? "bgClass" : "textClass";
	      if (output[prop] == null)
	        { output[prop] = lineClass[2]; }
	      else if (!(new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)")).test(output[prop]))
	        { output[prop] += " " + lineClass[2]; }
	    } }
	    return type
	  }
	
	  // Run the given mode's parser over a line, calling f for each token.
	  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
	    var flattenSpans = mode.flattenSpans;
	    if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
	    var curStart = 0, curStyle = null;
	    var stream = new StringStream(text, cm.options.tabSize, context), style;
	    var inner = cm.options.addModeClass && [null];
	    if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
	    while (!stream.eol()) {
	      if (stream.pos > cm.options.maxHighlightLength) {
	        flattenSpans = false;
	        if (forceToEnd) { processLine(cm, text, context, stream.pos); }
	        stream.pos = text.length;
	        style = null;
	      } else {
	        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
	      }
	      if (inner) {
	        var mName = inner[0].name;
	        if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
	      }
	      if (!flattenSpans || curStyle != style) {
	        while (curStart < stream.start) {
	          curStart = Math.min(stream.start, curStart + 5000);
	          f(curStart, curStyle);
	        }
	        curStyle = style;
	      }
	      stream.start = stream.pos;
	    }
	    while (curStart < stream.pos) {
	      // Webkit seems to refuse to render text nodes longer than 57444
	      // characters, and returns inaccurate measurements in nodes
	      // starting around 5000 chars.
	      var pos = Math.min(stream.pos, curStart + 5000);
	      f(pos, curStyle);
	      curStart = pos;
	    }
	  }
	
	  // Finds the line to start with when starting a parse. Tries to
	  // find a line with a stateAfter, so that it can start with a
	  // valid state. If that fails, it returns the line with the
	  // smallest indentation, which tends to need the least context to
	  // parse correctly.
	  function findStartLine(cm, n, precise) {
	    var minindent, minline, doc = cm.doc;
	    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
	    for (var search = n; search > lim; --search) {
	      if (search <= doc.first) { return doc.first }
	      var line = getLine(doc, search - 1), after = line.stateAfter;
	      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
	        { return search }
	      var indented = countColumn(line.text, null, cm.options.tabSize);
	      if (minline == null || minindent > indented) {
	        minline = search - 1;
	        minindent = indented;
	      }
	    }
	    return minline
	  }
	
	  function retreatFrontier(doc, n) {
	    doc.modeFrontier = Math.min(doc.modeFrontier, n);
	    if (doc.highlightFrontier < n - 10) { return }
	    var start = doc.first;
	    for (var line = n - 1; line > start; line--) {
	      var saved = getLine(doc, line).stateAfter;
	      // change is on 3
	      // state on line 1 looked ahead 2 -- so saw 3
	      // test 1 + 2 < 3 should cover this
	      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
	        start = line + 1;
	        break
	      }
	    }
	    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
	  }
	
	  // Optimize some code when these features are not used.
	  var sawReadOnlySpans = false, sawCollapsedSpans = false;
	
	  function seeReadOnlySpans() {
	    sawReadOnlySpans = true;
	  }
	
	  function seeCollapsedSpans() {
	    sawCollapsedSpans = true;
	  }
	
	  // TEXTMARKER SPANS
	
	  function MarkedSpan(marker, from, to) {
	    this.marker = marker;
	    this.from = from; this.to = to;
	  }
	
	  // Search an array of spans for a span matching the given marker.
	  function getMarkedSpanFor(spans, marker) {
	    if (spans) { for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.marker == marker) { return span }
	    } }
	  }
	
	  // Remove a span from an array, returning undefined if no spans are
	  // left (we don't store arrays for lines without spans).
	  function removeMarkedSpan(spans, span) {
	    var r;
	    for (var i = 0; i < spans.length; ++i)
	      { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
	    return r
	  }
	
	  // Add a span to a line.
	  function addMarkedSpan(line, span, op) {
	    var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
	    if (inThisOp && line.markedSpans && inThisOp.has(line.markedSpans)) {
	      line.markedSpans.push(span);
	    } else {
	      line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
	      if (inThisOp) { inThisOp.add(line.markedSpans); }
	    }
	    span.marker.attachLine(line);
	  }
	
	  // Used for the algorithm that adjusts markers for a change in the
	  // document. These functions cut an array of spans at a given
	  // character position, returning an array of remaining chunks (or
	  // undefined if nothing remains).
	  function markedSpansBefore(old, startCh, isInsert) {
	    var nw;
	    if (old) { for (var i = 0; i < old.length; ++i) {
	      var span = old[i], marker = span.marker;
	      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
	      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
	        ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
	      }
	    } }
	    return nw
	  }
	  function markedSpansAfter(old, endCh, isInsert) {
	    var nw;
	    if (old) { for (var i = 0; i < old.length; ++i) {
	      var span = old[i], marker = span.marker;
	      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
	      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
	        ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
	                                              span.to == null ? null : span.to - endCh));
	      }
	    } }
	    return nw
	  }
	
	  // Given a change object, compute the new set of marker spans that
	  // cover the line in which the change took place. Removes spans
	  // entirely within the change, reconnects spans belonging to the
	  // same marker that appear on both sides of the change, and cuts off
	  // spans partially within the change. Returns an array of span
	  // arrays with one element for each line in (after) the change.
	  function stretchSpansOverChange(doc, change) {
	    if (change.full) { return null }
	    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
	    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
	    if (!oldFirst && !oldLast) { return null }
	
	    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
	    // Get the spans that 'stick out' on both sides
	    var first = markedSpansBefore(oldFirst, startCh, isInsert);
	    var last = markedSpansAfter(oldLast, endCh, isInsert);
	
	    // Next, merge those two ends
	    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
	    if (first) {
	      // Fix up .to properties of first
	      for (var i = 0; i < first.length; ++i) {
	        var span = first[i];
	        if (span.to == null) {
	          var found = getMarkedSpanFor(last, span.marker);
	          if (!found) { span.to = startCh; }
	          else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
	        }
	      }
	    }
	    if (last) {
	      // Fix up .from in last (or move them into first in case of sameLine)
	      for (var i$1 = 0; i$1 < last.length; ++i$1) {
	        var span$1 = last[i$1];
	        if (span$1.to != null) { span$1.to += offset; }
	        if (span$1.from == null) {
	          var found$1 = getMarkedSpanFor(first, span$1.marker);
	          if (!found$1) {
	            span$1.from = offset;
	            if (sameLine) { (first || (first = [])).push(span$1); }
	          }
	        } else {
	          span$1.from += offset;
	          if (sameLine) { (first || (first = [])).push(span$1); }
	        }
	      }
	    }
	    // Make sure we didn't create any zero-length spans
	    if (first) { first = clearEmptySpans(first); }
	    if (last && last != first) { last = clearEmptySpans(last); }
	
	    var newMarkers = [first];
	    if (!sameLine) {
	      // Fill gap with whole-line-spans
	      var gap = change.text.length - 2, gapMarkers;
	      if (gap > 0 && first)
	        { for (var i$2 = 0; i$2 < first.length; ++i$2)
	          { if (first[i$2].to == null)
	            { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
	      for (var i$3 = 0; i$3 < gap; ++i$3)
	        { newMarkers.push(gapMarkers); }
	      newMarkers.push(last);
	    }
	    return newMarkers
	  }
	
	  // Remove spans that are empty and don't have a clearWhenEmpty
	  // option of false.
	  function clearEmptySpans(spans) {
	    for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
	        { spans.splice(i--, 1); }
	    }
	    if (!spans.length) { return null }
	    return spans
	  }
	
	  // Used to 'clip' out readOnly ranges when making a change.
	  function removeReadOnlyRanges(doc, from, to) {
	    var markers = null;
	    doc.iter(from.line, to.line + 1, function (line) {
	      if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	        var mark = line.markedSpans[i].marker;
	        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
	          { (markers || (markers = [])).push(mark); }
	      } }
	    });
	    if (!markers) { return null }
	    var parts = [{from: from, to: to}];
	    for (var i = 0; i < markers.length; ++i) {
	      var mk = markers[i], m = mk.find(0);
	      for (var j = 0; j < parts.length; ++j) {
	        var p = parts[j];
	        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
	        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
	        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
	          { newParts.push({from: p.from, to: m.from}); }
	        if (dto > 0 || !mk.inclusiveRight && !dto)
	          { newParts.push({from: m.to, to: p.to}); }
	        parts.splice.apply(parts, newParts);
	        j += newParts.length - 3;
	      }
	    }
	    return parts
	  }
	
	  // Connect or disconnect spans from a line.
	  function detachMarkedSpans(line) {
	    var spans = line.markedSpans;
	    if (!spans) { return }
	    for (var i = 0; i < spans.length; ++i)
	      { spans[i].marker.detachLine(line); }
	    line.markedSpans = null;
	  }
	  function attachMarkedSpans(line, spans) {
	    if (!spans) { return }
	    for (var i = 0; i < spans.length; ++i)
	      { spans[i].marker.attachLine(line); }
	    line.markedSpans = spans;
	  }
	
	  // Helpers used when computing which overlapping collapsed span
	  // counts as the larger one.
	  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
	  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }
	
	  // Returns a number indicating which of two overlapping collapsed
	  // spans is larger (and thus includes the other). Falls back to
	  // comparing ids when the spans cover exactly the same range.
	  function compareCollapsedMarkers(a, b) {
	    var lenDiff = a.lines.length - b.lines.length;
	    if (lenDiff != 0) { return lenDiff }
	    var aPos = a.find(), bPos = b.find();
	    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
	    if (fromCmp) { return -fromCmp }
	    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
	    if (toCmp) { return toCmp }
	    return b.id - a.id
	  }
	
	  // Find out whether a line ends or starts in a collapsed span. If
	  // so, return the marker for that span.
	  function collapsedSpanAtSide(line, start) {
	    var sps = sawCollapsedSpans && line.markedSpans, found;
	    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	      sp = sps[i];
	      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
	          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
	        { found = sp.marker; }
	    } }
	    return found
	  }
	  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
	  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }
	
	  function collapsedSpanAround(line, ch) {
	    var sps = sawCollapsedSpans && line.markedSpans, found;
	    if (sps) { for (var i = 0; i < sps.length; ++i) {
	      var sp = sps[i];
	      if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
	          (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
	    } }
	    return found
	  }
	
	  // Test whether there exists a collapsed span that partially
	  // overlaps (covers the start or end, but not both) of a new span.
	  // Such overlap is not allowed.
	  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
	    var line = getLine(doc, lineNo);
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) { for (var i = 0; i < sps.length; ++i) {
	      var sp = sps[i];
	      if (!sp.marker.collapsed) { continue }
	      var found = sp.marker.find(0);
	      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
	      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
	      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
	      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
	          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
	        { return true }
	    } }
	  }
	
	  // A visual line is a line as drawn on the screen. Folding, for
	  // example, can cause multiple logical lines to appear on the same
	  // visual line. This finds the start of the visual line that the
	  // given line is part of (usually that is the line itself).
	  function visualLine(line) {
	    var merged;
	    while (merged = collapsedSpanAtStart(line))
	      { line = merged.find(-1, true).line; }
	    return line
	  }
	
	  function visualLineEnd(line) {
	    var merged;
	    while (merged = collapsedSpanAtEnd(line))
	      { line = merged.find(1, true).line; }
	    return line
	  }
	
	  // Returns an array of logical lines that continue the visual line
	  // started by the argument, or undefined if there are no such lines.
	  function visualLineContinued(line) {
	    var merged, lines;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line
	      ;(lines || (lines = [])).push(line);
	    }
	    return lines
	  }
	
	  // Get the line number of the start of the visual line that the
	  // given line number is part of.
	  function visualLineNo(doc, lineN) {
	    var line = getLine(doc, lineN), vis = visualLine(line);
	    if (line == vis) { return lineN }
	    return lineNo(vis)
	  }
	
	  // Get the line number of the start of the next visual line after
	  // the given line.
	  function visualLineEndNo(doc, lineN) {
	    if (lineN > doc.lastLine()) { return lineN }
	    var line = getLine(doc, lineN), merged;
	    if (!lineIsHidden(doc, line)) { return lineN }
	    while (merged = collapsedSpanAtEnd(line))
	      { line = merged.find(1, true).line; }
	    return lineNo(line) + 1
	  }
	
	  // Compute whether a line is hidden. Lines count as hidden when they
	  // are part of a visual line that starts with another line, or when
	  // they are entirely covered by collapsed, non-widget span.
	  function lineIsHidden(doc, line) {
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	      sp = sps[i];
	      if (!sp.marker.collapsed) { continue }
	      if (sp.from == null) { return true }
	      if (sp.marker.widgetNode) { continue }
	      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
	        { return true }
	    } }
	  }
	  function lineIsHiddenInner(doc, line, span) {
	    if (span.to == null) {
	      var end = span.marker.find(1, true);
	      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
	    }
	    if (span.marker.inclusiveRight && span.to == line.text.length)
	      { return true }
	    for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
	      sp = line.markedSpans[i];
	      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
	          (sp.to == null || sp.to != span.from) &&
	          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
	          lineIsHiddenInner(doc, line, sp)) { return true }
	    }
	  }
	
	  // Find the height above the given line.
	  function heightAtLine(lineObj) {
	    lineObj = visualLine(lineObj);
	
	    var h = 0, chunk = lineObj.parent;
	    for (var i = 0; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i];
	      if (line == lineObj) { break }
	      else { h += line.height; }
	    }
	    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
	        var cur = p.children[i$1];
	        if (cur == chunk) { break }
	        else { h += cur.height; }
	      }
	    }
	    return h
	  }
	
	  // Compute the character length of a line, taking into account
	  // collapsed ranges (see markText) that might hide parts, and join
	  // other lines onto it.
	  function lineLength(line) {
	    if (line.height == 0) { return 0 }
	    var len = line.text.length, merged, cur = line;
	    while (merged = collapsedSpanAtStart(cur)) {
	      var found = merged.find(0, true);
	      cur = found.from.line;
	      len += found.from.ch - found.to.ch;
	    }
	    cur = line;
	    while (merged = collapsedSpanAtEnd(cur)) {
	      var found$1 = merged.find(0, true);
	      len -= cur.text.length - found$1.from.ch;
	      cur = found$1.to.line;
	      len += cur.text.length - found$1.to.ch;
	    }
	    return len
	  }
	
	  // Find the longest line in the document.
	  function findMaxLine(cm) {
	    var d = cm.display, doc = cm.doc;
	    d.maxLine = getLine(doc, doc.first);
	    d.maxLineLength = lineLength(d.maxLine);
	    d.maxLineChanged = true;
	    doc.iter(function (line) {
	      var len = lineLength(line);
	      if (len > d.maxLineLength) {
	        d.maxLineLength = len;
	        d.maxLine = line;
	      }
	    });
	  }
	
	  // LINE DATA STRUCTURE
	
	  // Line objects. These hold state related to a line, including
	  // highlighting info (the styles array).
	  var Line = function(text, markedSpans, estimateHeight) {
	    this.text = text;
	    attachMarkedSpans(this, markedSpans);
	    this.height = estimateHeight ? estimateHeight(this) : 1;
	  };
	
	  Line.prototype.lineNo = function () { return lineNo(this) };
	  eventMixin(Line);
	
	  // Change the content (text, markers) of a line. Automatically
	  // invalidates cached information and tries to re-estimate the
	  // line's height.
	  function updateLine(line, text, markedSpans, estimateHeight) {
	    line.text = text;
	    if (line.stateAfter) { line.stateAfter = null; }
	    if (line.styles) { line.styles = null; }
	    if (line.order != null) { line.order = null; }
	    detachMarkedSpans(line);
	    attachMarkedSpans(line, markedSpans);
	    var estHeight = estimateHeight ? estimateHeight(line) : 1;
	    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
	  }
	
	  // Detach a line from the document tree and its markers.
	  function cleanUpLine(line) {
	    line.parent = null;
	    detachMarkedSpans(line);
	  }
	
	  // Convert a style as returned by a mode (either null, or a string
	  // containing one or more styles) to a CSS style. This is cached,
	  // and also looks for line-wide styles.
	  var styleToClassCache = {}, styleToClassCacheWithMode = {};
	  function interpretTokenStyle(style, options) {
	    if (!style || /^\s*$/.test(style)) { return null }
	    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
	    return cache[style] ||
	      (cache[style] = style.replace(/\S+/g, "cm-$&"))
	  }
	
	  // Render the DOM representation of the text of a line. Also builds
	  // up a 'line map', which points at the DOM nodes that represent
	  // specific stretches of text, and is used by the measuring code.
	  // The returned object contains the DOM node, this map, and
	  // information about line-wide styles that were set by the mode.
	  function buildLineContent(cm, lineView) {
	    // The padding-right forces the element to have a 'border', which
	    // is needed on Webkit to be able to get line-level bounding
	    // rectangles for it (in measureChar).
	    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
	    var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
	                   col: 0, pos: 0, cm: cm,
	                   trailingSpace: false,
	                   splitSpaces: cm.getOption("lineWrapping")};
	    lineView.measure = {};
	
	    // Iterate over the logical lines that make up this visual line.
	    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	      var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
	      builder.pos = 0;
	      builder.addToken = buildToken;
	      // Optionally wire in some hacks into the token-rendering
	      // algorithm, to deal with browser quirks.
	      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
	        { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
	      builder.map = [];
	      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
	      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
	      if (line.styleClasses) {
	        if (line.styleClasses.bgClass)
	          { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
	        if (line.styleClasses.textClass)
	          { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
	      }
	
	      // Ensure at least a single node is present, for measuring.
	      if (builder.map.length == 0)
	        { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }
	
	      // Store the map and a cache object for the current logical line
	      if (i == 0) {
	        lineView.measure.map = builder.map;
	        lineView.measure.cache = {};
	      } else {
	  (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
	        ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
	      }
	    }
	
	    // See issue #2901
	    if (webkit) {
	      var last = builder.content.lastChild;
	      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
	        { builder.content.className = "cm-tab-wrap-hack"; }
	    }
	
	    signal(cm, "renderLine", cm, lineView.line, builder.pre);
	    if (builder.pre.className)
	      { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }
	
	    return builder
	  }
	
	  function defaultSpecialCharPlaceholder(ch) {
	    var token = elt("span", "\u2022", "cm-invalidchar");
	    token.title = "\\u" + ch.charCodeAt(0).toString(16);
	    token.setAttribute("aria-label", token.title);
	    return token
	  }
	
	  // Build up the DOM representation for a single token, and add it to
	  // the line map. Takes care to render special characters separately.
	  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
	    if (!text) { return }
	    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
	    var special = builder.cm.state.specialChars, mustWrap = false;
	    var content;
	    if (!special.test(text)) {
	      builder.col += text.length;
	      content = document.createTextNode(displayText);
	      builder.map.push(builder.pos, builder.pos + text.length, content);
	      if (ie && ie_version < 9) { mustWrap = true; }
	      builder.pos += text.length;
	    } else {
	      content = document.createDocumentFragment();
	      var pos = 0;
	      while (true) {
	        special.lastIndex = pos;
	        var m = special.exec(text);
	        var skipped = m ? m.index - pos : text.length - pos;
	        if (skipped) {
	          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
	          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
	          else { content.appendChild(txt); }
	          builder.map.push(builder.pos, builder.pos + skipped, txt);
	          builder.col += skipped;
	          builder.pos += skipped;
	        }
	        if (!m) { break }
	        pos += skipped + 1;
	        var txt$1 = (void 0);
	        if (m[0] == "\t") {
	          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
	          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
	          txt$1.setAttribute("role", "presentation");
	          txt$1.setAttribute("cm-text", "\t");
	          builder.col += tabWidth;
	        } else if (m[0] == "\r" || m[0] == "\n") {
	          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
	          txt$1.setAttribute("cm-text", m[0]);
	          builder.col += 1;
	        } else {
	          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
	          txt$1.setAttribute("cm-text", m[0]);
	          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
	          else { content.appendChild(txt$1); }
	          builder.col += 1;
	        }
	        builder.map.push(builder.pos, builder.pos + 1, txt$1);
	        builder.pos++;
	      }
	    }
	    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
	    if (style || startStyle || endStyle || mustWrap || css || attributes) {
	      var fullStyle = style || "";
	      if (startStyle) { fullStyle += startStyle; }
	      if (endStyle) { fullStyle += endStyle; }
	      var token = elt("span", [content], fullStyle, css);
	      if (attributes) {
	        for (var attr in attributes) { if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class")
	          { token.setAttribute(attr, attributes[attr]); } }
	      }
	      return builder.content.appendChild(token)
	    }
	    builder.content.appendChild(content);
	  }
	
	  // Change some spaces to NBSP to prevent the browser from collapsing
	  // trailing spaces at the end of a line when rendering text (issue #1362).
	  function splitSpaces(text, trailingBefore) {
	    if (text.length > 1 && !/  /.test(text)) { return text }
	    var spaceBefore = trailingBefore, result = "";
	    for (var i = 0; i < text.length; i++) {
	      var ch = text.charAt(i);
	      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
	        { ch = "\u00a0"; }
	      result += ch;
	      spaceBefore = ch == " ";
	    }
	    return result
	  }
	
	  // Work around nonsense dimensions being reported for stretches of
	  // right-to-left text.
	  function buildTokenBadBidi(inner, order) {
	    return function (builder, text, style, startStyle, endStyle, css, attributes) {
	      style = style ? style + " cm-force-border" : "cm-force-border";
	      var start = builder.pos, end = start + text.length;
	      for (;;) {
	        // Find the part that overlaps with the start of this text
	        var part = (void 0);
	        for (var i = 0; i < order.length; i++) {
	          part = order[i];
	          if (part.to > start && part.from <= start) { break }
	        }
	        if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, css, attributes) }
	        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
	        startStyle = null;
	        text = text.slice(part.to - start);
	        start = part.to;
	      }
	    }
	  }
	
	  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	    var widget = !ignoreWidget && marker.widgetNode;
	    if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
	    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	      if (!widget)
	        { widget = builder.content.appendChild(document.createElement("span")); }
	      widget.setAttribute("cm-marker", marker.id);
	    }
	    if (widget) {
	      builder.cm.display.input.setUneditable(widget);
	      builder.content.appendChild(widget);
	    }
	    builder.pos += size;
	    builder.trailingSpace = false;
	  }
	
	  // Outputs a number of spans to make up a line, taking highlighting
	  // and marked text into account.
	  function insertLineContent(line, builder, styles) {
	    var spans = line.markedSpans, allText = line.text, at = 0;
	    if (!spans) {
	      for (var i$1 = 1; i$1 < styles.length; i$1+=2)
	        { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
	      return
	    }
	
	    var len = allText.length, pos = 0, i = 1, text = "", style, css;
	    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
	    for (;;) {
	      if (nextChange == pos) { // Update current marker set
	        spanStyle = spanEndStyle = spanStartStyle = css = "";
	        attributes = null;
	        collapsed = null; nextChange = Infinity;
	        var foundBookmarks = [], endStyles = (void 0);
	        for (var j = 0; j < spans.length; ++j) {
	          var sp = spans[j], m = sp.marker;
	          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	            foundBookmarks.push(m);
	          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	              nextChange = sp.to;
	              spanEndStyle = "";
	            }
	            if (m.className) { spanStyle += " " + m.className; }
	            if (m.css) { css = (css ? css + ";" : "") + m.css; }
	            if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
	            if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
	            // support for the old title property
	            // https://github.com/codemirror/CodeMirror/pull/5673
	            if (m.title) { (attributes || (attributes = {})).title = m.title; }
	            if (m.attributes) {
	              for (var attr in m.attributes)
	                { (attributes || (attributes = {}))[attr] = m.attributes[attr]; }
	            }
	            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
	              { collapsed = sp; }
	          } else if (sp.from > pos && nextChange > sp.from) {
	            nextChange = sp.from;
	          }
	        }
	        if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
	          { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }
	
	        if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
	          { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
	        if (collapsed && (collapsed.from || 0) == pos) {
	          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
	                             collapsed.marker, collapsed.from == null);
	          if (collapsed.to == null) { return }
	          if (collapsed.to == pos) { collapsed = false; }
	        }
	      }
	      if (pos >= len) { break }
	
	      var upto = Math.min(len, nextChange);
	      while (true) {
	        if (text) {
	          var end = pos + text.length;
	          if (!collapsed) {
	            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
	            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
	                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
	          }
	          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
	          pos = end;
	          spanStartStyle = "";
	        }
	        text = allText.slice(at, at = styles[i++]);
	        style = interpretTokenStyle(styles[i++], builder.cm.options);
	      }
	    }
	  }
	
	
	  // These objects are used to represent the visible (currently drawn)
	  // part of the document. A LineView may correspond to multiple
	  // logical lines, if those are connected by collapsed ranges.
	  function LineView(doc, line, lineN) {
	    // The starting line
	    this.line = line;
	    // Continuing lines, if any
	    this.rest = visualLineContinued(line);
	    // Number of logical lines in this visual line
	    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
	    this.node = this.text = null;
	    this.hidden = lineIsHidden(doc, line);
	  }
	
	  // Create a range of LineView objects for the given lines.
	  function buildViewArray(cm, from, to) {
	    var array = [], nextPos;
	    for (var pos = from; pos < to; pos = nextPos) {
	      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
	      nextPos = pos + view.size;
	      array.push(view);
	    }
	    return array
	  }
	
	  var operationGroup = null;
	
	  function pushOperation(op) {
	    if (operationGroup) {
	      operationGroup.ops.push(op);
	    } else {
	      op.ownsGroup = operationGroup = {
	        ops: [op],
	        delayedCallbacks: []
	      };
	    }
	  }
	
	  function fireCallbacksForOps(group) {
	    // Calls delayed callbacks and cursorActivity handlers until no
	    // new ones appear
	    var callbacks = group.delayedCallbacks, i = 0;
	    do {
	      for (; i < callbacks.length; i++)
	        { callbacks[i].call(null); }
	      for (var j = 0; j < group.ops.length; j++) {
	        var op = group.ops[j];
	        if (op.cursorActivityHandlers)
	          { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
	            { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
	      }
	    } while (i < callbacks.length)
	  }
	
	  function finishOperation(op, endCb) {
	    var group = op.ownsGroup;
	    if (!group) { return }
	
	    try { fireCallbacksForOps(group); }
	    finally {
	      operationGroup = null;
	      endCb(group);
	    }
	  }
	
	  var orphanDelayedCallbacks = null;
	
	  // Often, we want to signal events at a point where we are in the
	  // middle of some work, but don't want the handler to start calling
	  // other methods on the editor, which might be in an inconsistent
	  // state or simply not expect any other events to happen.
	  // signalLater looks whether there are any handlers, and schedules
	  // them to be executed when the last operation ends, or, if no
	  // operation is active, when a timeout fires.
	  function signalLater(emitter, type /*, values...*/) {
	    var arr = getHandlers(emitter, type);
	    if (!arr.length) { return }
	    var args = Array.prototype.slice.call(arguments, 2), list;
	    if (operationGroup) {
	      list = operationGroup.delayedCallbacks;
	    } else if (orphanDelayedCallbacks) {
	      list = orphanDelayedCallbacks;
	    } else {
	      list = orphanDelayedCallbacks = [];
	      setTimeout(fireOrphanDelayed, 0);
	    }
	    var loop = function ( i ) {
	      list.push(function () { return arr[i].apply(null, args); });
	    };
	
	    for (var i = 0; i < arr.length; ++i)
	      loop( i );
	  }
	
	  function fireOrphanDelayed() {
	    var delayed = orphanDelayedCallbacks;
	    orphanDelayedCallbacks = null;
	    for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
	  }
	
	  // When an aspect of a line changes, a string is added to
	  // lineView.changes. This updates the relevant part of the line's
	  // DOM structure.
	  function updateLineForChanges(cm, lineView, lineN, dims) {
	    for (var j = 0; j < lineView.changes.length; j++) {
	      var type = lineView.changes[j];
	      if (type == "text") { updateLineText(cm, lineView); }
	      else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
	      else if (type == "class") { updateLineClasses(cm, lineView); }
	      else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
	    }
	    lineView.changes = null;
	  }
	
	  // Lines with gutter elements, widgets or a background class need to
	  // be wrapped, and have the extra elements added to the wrapper div
	  function ensureLineWrapped(lineView) {
	    if (lineView.node == lineView.text) {
	      lineView.node = elt("div", null, null, "position: relative");
	      if (lineView.text.parentNode)
	        { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
	      lineView.node.appendChild(lineView.text);
	      if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
	    }
	    return lineView.node
	  }
	
	  function updateLineBackground(cm, lineView) {
	    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
	    if (cls) { cls += " CodeMirror-linebackground"; }
	    if (lineView.background) {
	      if (cls) { lineView.background.className = cls; }
	      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
	    } else if (cls) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
	      cm.display.input.setUneditable(lineView.background);
	    }
	  }
	
	  // Wrapper around buildLineContent which will reuse the structure
	  // in display.externalMeasured when possible.
	  function getLineContent(cm, lineView) {
	    var ext = cm.display.externalMeasured;
	    if (ext && ext.line == lineView.line) {
	      cm.display.externalMeasured = null;
	      lineView.measure = ext.measure;
	      return ext.built
	    }
	    return buildLineContent(cm, lineView)
	  }
	
	  // Redraw the line's text. Interacts with the background and text
	  // classes because the mode may output tokens that influence these
	  // classes.
	  function updateLineText(cm, lineView) {
	    var cls = lineView.text.className;
	    var built = getLineContent(cm, lineView);
	    if (lineView.text == lineView.node) { lineView.node = built.pre; }
	    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
	    lineView.text = built.pre;
	    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	      lineView.bgClass = built.bgClass;
	      lineView.textClass = built.textClass;
	      updateLineClasses(cm, lineView);
	    } else if (cls) {
	      lineView.text.className = cls;
	    }
	  }
	
	  function updateLineClasses(cm, lineView) {
	    updateLineBackground(cm, lineView);
	    if (lineView.line.wrapClass)
	      { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
	    else if (lineView.node != lineView.text)
	      { lineView.node.className = ""; }
	    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
	    lineView.text.className = textClass || "";
	  }
	
	  function updateLineGutter(cm, lineView, lineN, dims) {
	    if (lineView.gutter) {
	      lineView.node.removeChild(lineView.gutter);
	      lineView.gutter = null;
	    }
	    if (lineView.gutterBackground) {
	      lineView.node.removeChild(lineView.gutterBackground);
	      lineView.gutterBackground = null;
	    }
	    if (lineView.line.gutterClass) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
	                                      ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
	      cm.display.input.setUneditable(lineView.gutterBackground);
	      wrap.insertBefore(lineView.gutterBackground, lineView.text);
	    }
	    var markers = lineView.line.gutterMarkers;
	    if (cm.options.lineNumbers || markers) {
	      var wrap$1 = ensureLineWrapped(lineView);
	      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
	      gutterWrap.setAttribute("aria-hidden", "true");
	      cm.display.input.setUneditable(gutterWrap);
	      wrap$1.insertBefore(gutterWrap, lineView.text);
	      if (lineView.line.gutterClass)
	        { gutterWrap.className += " " + lineView.line.gutterClass; }
	      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
	        { lineView.lineNumber = gutterWrap.appendChild(
	          elt("div", lineNumberFor(cm.options, lineN),
	              "CodeMirror-linenumber CodeMirror-gutter-elt",
	              ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
	      if (markers) { for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
	        var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
	        if (found)
	          { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
	                                     ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
	      } }
	    }
	  }
	
	  function updateLineWidgets(cm, lineView, dims) {
	    if (lineView.alignable) { lineView.alignable = null; }
	    var isWidget = classTest("CodeMirror-linewidget");
	    for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
	      next = node.nextSibling;
	      if (isWidget.test(node.className)) { lineView.node.removeChild(node); }
	    }
	    insertLineWidgets(cm, lineView, dims);
	  }
	
	  // Build a line's DOM representation from scratch
	  function buildLineElement(cm, lineView, lineN, dims) {
	    var built = getLineContent(cm, lineView);
	    lineView.text = lineView.node = built.pre;
	    if (built.bgClass) { lineView.bgClass = built.bgClass; }
	    if (built.textClass) { lineView.textClass = built.textClass; }
	
	    updateLineClasses(cm, lineView);
	    updateLineGutter(cm, lineView, lineN, dims);
	    insertLineWidgets(cm, lineView, dims);
	    return lineView.node
	  }
	
	  // A lineView may contain multiple logical lines (when merged by
	  // collapsed spans). The widgets for all of them need to be drawn.
	  function insertLineWidgets(cm, lineView, dims) {
	    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
	    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	      { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
	  }
	
	  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	    if (!line.widgets) { return }
	    var wrap = ensureLineWrapped(lineView);
	    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
	      if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
	      positionLineWidget(widget, node, lineView, dims);
	      cm.display.input.setUneditable(node);
	      if (allowAbove && widget.above)
	        { wrap.insertBefore(node, lineView.gutter || lineView.text); }
	      else
	        { wrap.appendChild(node); }
	      signalLater(widget, "redraw");
	    }
	  }
	
	  function positionLineWidget(widget, node, lineView, dims) {
	    if (widget.noHScroll) {
	  (lineView.alignable || (lineView.alignable = [])).push(node);
	      var width = dims.wrapperWidth;
	      node.style.left = dims.fixedPos + "px";
	      if (!widget.coverGutter) {
	        width -= dims.gutterTotalWidth;
	        node.style.paddingLeft = dims.gutterTotalWidth + "px";
	      }
	      node.style.width = width + "px";
	    }
	    if (widget.coverGutter) {
	      node.style.zIndex = 5;
	      node.style.position = "relative";
	      if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
	    }
	  }
	
	  function widgetHeight(widget) {
	    if (widget.height != null) { return widget.height }
	    var cm = widget.doc.cm;
	    if (!cm) { return 0 }
	    if (!contains(document.body, widget.node)) {
	      var parentStyle = "position: relative;";
	      if (widget.coverGutter)
	        { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
	      if (widget.noHScroll)
	        { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
	      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
	    }
	    return widget.height = widget.node.parentNode.offsetHeight
	  }
	
	  // Return true when the given mouse event happened in a widget
	  function eventInWidget(display, e) {
	    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
	          (n.parentNode == display.sizer && n != display.mover))
	        { return true }
	    }
	  }
	
	  // POSITION MEASUREMENT
	
	  function paddingTop(display) {return display.lineSpace.offsetTop}
	  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
	  function paddingH(display) {
	    if (display.cachedPaddingH) { return display.cachedPaddingH }
	    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
	    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
	    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
	    if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
	    return data
	  }
	
	  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
	  function displayWidth(cm) {
	    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
	  }
	  function displayHeight(cm) {
	    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
	  }
	
	  // Ensure the lineView.wrapping.heights array is populated. This is
	  // an array of bottom offsets for the lines that make up a drawn
	  // line. When lineWrapping is on, there might be more than one
	  // height.
	  function ensureLineHeights(cm, lineView, rect) {
	    var wrapping = cm.options.lineWrapping;
	    var curWidth = wrapping && displayWidth(cm);
	    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	      var heights = lineView.measure.heights = [];
	      if (wrapping) {
	        lineView.measure.width = curWidth;
	        var rects = lineView.text.firstChild.getClientRects();
	        for (var i = 0; i < rects.length - 1; i++) {
	          var cur = rects[i], next = rects[i + 1];
	          if (Math.abs(cur.bottom - next.bottom) > 2)
	            { heights.push((cur.bottom + next.top) / 2 - rect.top); }
	        }
	      }
	      heights.push(rect.bottom - rect.top);
	    }
	  }
	
	  // Find a line map (mapping character offsets to text nodes) and a
	  // measurement cache for the given line number. (A line view might
	  // contain multiple lines when collapsed ranges are present.)
	  function mapFromLineView(lineView, line, lineN) {
	    if (lineView.line == line)
	      { return {map: lineView.measure.map, cache: lineView.measure.cache} }
	    if (lineView.rest) {
	      for (var i = 0; i < lineView.rest.length; i++)
	        { if (lineView.rest[i] == line)
	          { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
	      for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
	        { if (lineNo(lineView.rest[i$1]) > lineN)
	          { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
	    }
	  }
	
	  // Render a line into the hidden node display.externalMeasured. Used
	  // when measurement is needed for a line that's not in the viewport.
	  function updateExternalMeasurement(cm, line) {
	    line = visualLine(line);
	    var lineN = lineNo(line);
	    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
	    view.lineN = lineN;
	    var built = view.built = buildLineContent(cm, view);
	    view.text = built.pre;
	    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
	    return view
	  }
	
	  // Get a {top, bottom, left, right} box (in line-local coordinates)
	  // for a given character.
	  function measureChar(cm, line, ch, bias) {
	    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
	  }
	
	  // Find a line view that corresponds to the given line number.
	  function findViewForLine(cm, lineN) {
	    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
	      { return cm.display.view[findViewIndex(cm, lineN)] }
	    var ext = cm.display.externalMeasured;
	    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
	      { return ext }
	  }
	
	  // Measurement can be split in two steps, the set-up work that
	  // applies to the whole line, and the measurement of the actual
	  // character. Functions like coordsChar, that need to do a lot of
	  // measurements in a row, can thus ensure that the set-up work is
	  // only done once.
	  function prepareMeasureForLine(cm, line) {
	    var lineN = lineNo(line);
	    var view = findViewForLine(cm, lineN);
	    if (view && !view.text) {
	      view = null;
	    } else if (view && view.changes) {
	      updateLineForChanges(cm, view, lineN, getDimensions(cm));
	      cm.curOp.forceUpdate = true;
	    }
	    if (!view)
	      { view = updateExternalMeasurement(cm, line); }
	
	    var info = mapFromLineView(view, line, lineN);
	    return {
	      line: line, view: view, rect: null,
	      map: info.map, cache: info.cache, before: info.before,
	      hasHeights: false
	    }
	  }
	
	  // Given a prepared measurement object, measures the position of an
	  // actual character (or fetches it from the cache).
	  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	    if (prepared.before) { ch = -1; }
	    var key = ch + (bias || ""), found;
	    if (prepared.cache.hasOwnProperty(key)) {
	      found = prepared.cache[key];
	    } else {
	      if (!prepared.rect)
	        { prepared.rect = prepared.view.text.getBoundingClientRect(); }
	      if (!prepared.hasHeights) {
	        ensureLineHeights(cm, prepared.view, prepared.rect);
	        prepared.hasHeights = true;
	      }
	      found = measureCharInner(cm, prepared, ch, bias);
	      if (!found.bogus) { prepared.cache[key] = found; }
	    }
	    return {left: found.left, right: found.right,
	            top: varHeight ? found.rtop : found.top,
	            bottom: varHeight ? found.rbottom : found.bottom}
	  }
	
	  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};
	
	  function nodeAndOffsetInLineMap(map, ch, bias) {
	    var node, start, end, collapse, mStart, mEnd;
	    // First, search the line map for the text node corresponding to,
	    // or closest to, the target character.
	    for (var i = 0; i < map.length; i += 3) {
	      mStart = map[i];
	      mEnd = map[i + 1];
	      if (ch < mStart) {
	        start = 0; end = 1;
	        collapse = "left";
	      } else if (ch < mEnd) {
	        start = ch - mStart;
	        end = start + 1;
	      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
	        end = mEnd - mStart;
	        start = end - 1;
	        if (ch >= mEnd) { collapse = "right"; }
	      }
	      if (start != null) {
	        node = map[i + 2];
	        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
	          { collapse = bias; }
	        if (bias == "left" && start == 0)
	          { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
	            node = map[(i -= 3) + 2];
	            collapse = "left";
	          } }
	        if (bias == "right" && start == mEnd - mStart)
	          { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
	            node = map[(i += 3) + 2];
	            collapse = "right";
	          } }
	        break
	      }
	    }
	    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
	  }
	
	  function getUsefulRect(rects, bias) {
	    var rect = nullRect;
	    if (bias == "left") { for (var i = 0; i < rects.length; i++) {
	      if ((rect = rects[i]).left != rect.right) { break }
	    } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
	      if ((rect = rects[i$1]).left != rect.right) { break }
	    } }
	    return rect
	  }
	
	  function measureCharInner(cm, prepared, ch, bias) {
	    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
	    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
	
	    var rect;
	    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
	      for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
	        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
	        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
	        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
	          { rect = node.parentNode.getBoundingClientRect(); }
	        else
	          { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
	        if (rect.left || rect.right || start == 0) { break }
	        end = start;
	        start = start - 1;
	        collapse = "right";
	      }
	      if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
	    } else { // If it is a widget, simply get the box for the whole widget.
	      if (start > 0) { collapse = bias = "right"; }
	      var rects;
	      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
	        { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
	      else
	        { rect = node.getBoundingClientRect(); }
	    }
	    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	      var rSpan = node.parentNode.getClientRects()[0];
	      if (rSpan)
	        { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
	      else
	        { rect = nullRect; }
	    }
	
	    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
	    var mid = (rtop + rbot) / 2;
	    var heights = prepared.view.measure.heights;
	    var i = 0;
	    for (; i < heights.length - 1; i++)
	      { if (mid < heights[i]) { break } }
	    var top = i ? heights[i - 1] : 0, bot = heights[i];
	    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	                  top: top, bottom: bot};
	    if (!rect.left && !rect.right) { result.bogus = true; }
	    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }
	
	    return result
	  }
	
	  // Work around problem with bounding client rects on ranges being
	  // returned incorrectly when zoomed on IE10 and below.
	  function maybeUpdateRectForZooming(measure, rect) {
	    if (!window.screen || screen.logicalXDPI == null ||
	        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
	      { return rect }
	    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
	    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
	    return {left: rect.left * scaleX, right: rect.right * scaleX,
	            top: rect.top * scaleY, bottom: rect.bottom * scaleY}
	  }
	
	  function clearLineMeasurementCacheFor(lineView) {
	    if (lineView.measure) {
	      lineView.measure.cache = {};
	      lineView.measure.heights = null;
	      if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	        { lineView.measure.caches[i] = {}; } }
	    }
	  }
	
	  function clearLineMeasurementCache(cm) {
	    cm.display.externalMeasure = null;
	    removeChildren(cm.display.lineMeasure);
	    for (var i = 0; i < cm.display.view.length; i++)
	      { clearLineMeasurementCacheFor(cm.display.view[i]); }
	  }
	
	  function clearCaches(cm) {
	    clearLineMeasurementCache(cm);
	    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
	    if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
	    cm.display.lineNumChars = null;
	  }
	
	  function pageScrollX(doc) {
	    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
	    // which causes page_Offset and bounding client rects to use
	    // different reference viewports and invalidate our calculations.
	    if (chrome && android) { return -(doc.body.getBoundingClientRect().left - parseInt(getComputedStyle(doc.body).marginLeft)) }
	    return doc.defaultView.pageXOffset || (doc.documentElement || doc.body).scrollLeft
	  }
	  function pageScrollY(doc) {
	    if (chrome && android) { return -(doc.body.getBoundingClientRect().top - parseInt(getComputedStyle(doc.body).marginTop)) }
	    return doc.defaultView.pageYOffset || (doc.documentElement || doc.body).scrollTop
	  }
	
	  function widgetTopHeight(lineObj) {
	    var ref = visualLine(lineObj);
	    var widgets = ref.widgets;
	    var height = 0;
	    if (widgets) { for (var i = 0; i < widgets.length; ++i) { if (widgets[i].above)
	      { height += widgetHeight(widgets[i]); } } }
	    return height
	  }
	
	  // Converts a {top, bottom, left, right} box from line-local
	  // coordinates into another coordinate system. Context may be one of
	  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
	  // or "page".
	  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
	    if (!includeWidgets) {
	      var height = widgetTopHeight(lineObj);
	      rect.top += height; rect.bottom += height;
	    }
	    if (context == "line") { return rect }
	    if (!context) { context = "local"; }
	    var yOff = heightAtLine(lineObj);
	    if (context == "local") { yOff += paddingTop(cm.display); }
	    else { yOff -= cm.display.viewOffset; }
	    if (context == "page" || context == "window") {
	      var lOff = cm.display.lineSpace.getBoundingClientRect();
	      yOff += lOff.top + (context == "window" ? 0 : pageScrollY(doc(cm)));
	      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX(doc(cm)));
	      rect.left += xOff; rect.right += xOff;
	    }
	    rect.top += yOff; rect.bottom += yOff;
	    return rect
	  }
	
	  // Coverts a box from "div" coords to another coordinate system.
	  // Context may be "window", "page", "div", or "local"./null.
	  function fromCoordSystem(cm, coords, context) {
	    if (context == "div") { return coords }
	    var left = coords.left, top = coords.top;
	    // First move into "page" coordinate system
	    if (context == "page") {
	      left -= pageScrollX(doc(cm));
	      top -= pageScrollY(doc(cm));
	    } else if (context == "local" || !context) {
	      var localBox = cm.display.sizer.getBoundingClientRect();
	      left += localBox.left;
	      top += localBox.top;
	    }
	
	    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
	    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
	  }
	
	  function charCoords(cm, pos, context, lineObj, bias) {
	    if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
	    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
	  }
	
	  // Returns a box for a given cursor position, which may have an
	  // 'other' property containing the position of the secondary cursor
	  // on a bidi boundary.
	  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
	  // and after `char - 1` in writing order of `char - 1`
	  // A cursor Pos(line, char, "after") is on the same visual line as `char`
	  // and before `char` in writing order of `char`
	  // Examples (upper-case letters are RTL, lower-case are LTR):
	  //     Pos(0, 1, ...)
	  //     before   after
	  // ab     a|b     a|b
	  // aB     a|B     aB|
	  // Ab     |Ab     A|b
	  // AB     B|A     B|A
	  // Every position after the last character on a line is considered to stick
	  // to the last character on the line.
	  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	    lineObj = lineObj || getLine(cm.doc, pos.line);
	    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
	    function get(ch, right) {
	      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
	      if (right) { m.left = m.right; } else { m.right = m.left; }
	      return intoCoordSystem(cm, lineObj, m, context)
	    }
	    var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
	    if (ch >= lineObj.text.length) {
	      ch = lineObj.text.length;
	      sticky = "before";
	    } else if (ch <= 0) {
	      ch = 0;
	      sticky = "after";
	    }
	    if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }
	
	    function getBidi(ch, partPos, invert) {
	      var part = order[partPos], right = part.level == 1;
	      return get(invert ? ch - 1 : ch, right != invert)
	    }
	    var partPos = getBidiPartAt(order, ch, sticky);
	    var other = bidiOther;
	    var val = getBidi(ch, partPos, sticky == "before");
	    if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
	    return val
	  }
	
	  // Used to cheaply estimate the coordinates for a position. Used for
	  // intermediate scroll updates.
	  function estimateCoords(cm, pos) {
	    var left = 0;
	    pos = clipPos(cm.doc, pos);
	    if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
	    var lineObj = getLine(cm.doc, pos.line);
	    var top = heightAtLine(lineObj) + paddingTop(cm.display);
	    return {left: left, right: left, top: top, bottom: top + lineObj.height}
	  }
	
	  // Positions returned by coordsChar contain some extra information.
	  // xRel is the relative x position of the input coordinates compared
	  // to the found position (so xRel > 0 means the coordinates are to
	  // the right of the character position, for example). When outside
	  // is true, that means the coordinates lie outside the line's
	  // vertical range.
	  function PosWithInfo(line, ch, sticky, outside, xRel) {
	    var pos = Pos(line, ch, sticky);
	    pos.xRel = xRel;
	    if (outside) { pos.outside = outside; }
	    return pos
	  }
	
	  // Compute the character position closest to the given coordinates.
	  // Input must be lineSpace-local ("div" coordinate system).
	  function coordsChar(cm, x, y) {
	    var doc = cm.doc;
	    y += cm.display.viewOffset;
	    if (y < 0) { return PosWithInfo(doc.first, 0, null, -1, -1) }
	    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
	    if (lineN > last)
	      { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1) }
	    if (x < 0) { x = 0; }
	
	    var lineObj = getLine(doc, lineN);
	    for (;;) {
	      var found = coordsCharInner(cm, lineObj, lineN, x, y);
	      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
	      if (!collapsed) { return found }
	      var rangeEnd = collapsed.find(1);
	      if (rangeEnd.line == lineN) { return rangeEnd }
	      lineObj = getLine(doc, lineN = rangeEnd.line);
	    }
	  }
	
	  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
	    y -= widgetTopHeight(lineObj);
	    var end = lineObj.text.length;
	    var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
	    end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
	    return {begin: begin, end: end}
	  }
	
	  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
	    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
	    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
	    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
	  }
	
	  // Returns true if the given side of a box is after the given
	  // coordinates, in top-to-bottom, left-to-right order.
	  function boxIsAfter(box, x, y, left) {
	    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
	  }
	
	  function coordsCharInner(cm, lineObj, lineNo, x, y) {
	    // Move y into line-local coordinate space
	    y -= heightAtLine(lineObj);
	    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    // When directly calling `measureCharPrepared`, we have to adjust
	    // for the widgets at this line.
	    var widgetHeight = widgetTopHeight(lineObj);
	    var begin = 0, end = lineObj.text.length, ltr = true;
	
	    var order = getOrder(lineObj, cm.doc.direction);
	    // If the line isn't plain left-to-right text, first figure out
	    // which bidi section the coordinates fall into.
	    if (order) {
	      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
	                   (cm, lineObj, lineNo, preparedMeasure, order, x, y);
	      ltr = part.level != 1;
	      // The awkward -1 offsets are needed because findFirst (called
	      // on these below) will treat its first bound as inclusive,
	      // second as exclusive, but we want to actually address the
	      // characters in the part's range
	      begin = ltr ? part.from : part.to - 1;
	      end = ltr ? part.to : part.from - 1;
	    }
	
	    // A binary search to find the first character whose bounding box
	    // starts after the coordinates. If we run across any whose box wrap
	    // the coordinates, store that.
	    var chAround = null, boxAround = null;
	    var ch = findFirst(function (ch) {
	      var box = measureCharPrepared(cm, preparedMeasure, ch);
	      box.top += widgetHeight; box.bottom += widgetHeight;
	      if (!boxIsAfter(box, x, y, false)) { return false }
	      if (box.top <= y && box.left <= x) {
	        chAround = ch;
	        boxAround = box;
	      }
	      return true
	    }, begin, end);
	
	    var baseX, sticky, outside = false;
	    // If a box around the coordinates was found, use that
	    if (boxAround) {
	      // Distinguish coordinates nearer to the left or right side of the box
	      var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
	      ch = chAround + (atStart ? 0 : 1);
	      sticky = atStart ? "after" : "before";
	      baseX = atLeft ? boxAround.left : boxAround.right;
	    } else {
	      // (Adjust for extended bound, if necessary.)
	      if (!ltr && (ch == end || ch == begin)) { ch++; }
	      // To determine which side to associate with, get the box to the
	      // left of the character and compare it's vertical position to the
	      // coordinates
	      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
	        (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y) == ltr ?
	        "after" : "before";
	      // Now get accurate coordinates for this place, in order to get a
	      // base X position
	      var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
	      baseX = coords.left;
	      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
	    }
	
	    ch = skipExtendingChars(lineObj.text, ch, 1);
	    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX)
	  }
	
	  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
	    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
	    // situation, we can take this ordering to correspond to the visual
	    // ordering. This finds the first part whose end is after the given
	    // coordinates.
	    var index = findFirst(function (i) {
	      var part = order[i], ltr = part.level != 1;
	      return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"),
	                                     "line", lineObj, preparedMeasure), x, y, true)
	    }, 0, order.length - 1);
	    var part = order[index];
	    // If this isn't the first part, the part's start is also after
	    // the coordinates, and the coordinates aren't on the same line as
	    // that start, move one part back.
	    if (index > 0) {
	      var ltr = part.level != 1;
	      var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"),
	                               "line", lineObj, preparedMeasure);
	      if (boxIsAfter(start, x, y, true) && start.top > y)
	        { part = order[index - 1]; }
	    }
	    return part
	  }
	
	  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
	    // In a wrapped line, rtl text on wrapping boundaries can do things
	    // that don't correspond to the ordering in our `order` array at
	    // all, so a binary search doesn't work, and we want to return a
	    // part that only spans one line so that the binary search in
	    // coordsCharInner is safe. As such, we first find the extent of the
	    // wrapped line, and then do a flat search in which we discard any
	    // spans that aren't on the line.
	    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
	    var begin = ref.begin;
	    var end = ref.end;
	    if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
	    var part = null, closestDist = null;
	    for (var i = 0; i < order.length; i++) {
	      var p = order[i];
	      if (p.from >= end || p.to <= begin) { continue }
	      var ltr = p.level != 1;
	      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
	      // Weigh against spans ending before this, so that they are only
	      // picked if nothing ends after
	      var dist = endX < x ? x - endX + 1e9 : endX - x;
	      if (!part || closestDist > dist) {
	        part = p;
	        closestDist = dist;
	      }
	    }
	    if (!part) { part = order[order.length - 1]; }
	    // Clip the part to the wrapped line.
	    if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
	    if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
	    return part
	  }
	
	  var measureText;
	  // Compute the default text height.
	  function textHeight(display) {
	    if (display.cachedTextHeight != null) { return display.cachedTextHeight }
	    if (measureText == null) {
	      measureText = elt("pre", null, "CodeMirror-line-like");
	      // Measure a bunch of lines, for browsers that compute
	      // fractional heights.
	      for (var i = 0; i < 49; ++i) {
	        measureText.appendChild(document.createTextNode("x"));
	        measureText.appendChild(elt("br"));
	      }
	      measureText.appendChild(document.createTextNode("x"));
	    }
	    removeChildrenAndAdd(display.measure, measureText);
	    var height = measureText.offsetHeight / 50;
	    if (height > 3) { display.cachedTextHeight = height; }
	    removeChildren(display.measure);
	    return height || 1
	  }
	
	  // Compute the default character width.
	  function charWidth(display) {
	    if (display.cachedCharWidth != null) { return display.cachedCharWidth }
	    var anchor = elt("span", "xxxxxxxxxx");
	    var pre = elt("pre", [anchor], "CodeMirror-line-like");
	    removeChildrenAndAdd(display.measure, pre);
	    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
	    if (width > 2) { display.cachedCharWidth = width; }
	    return width || 10
	  }
	
	  // Do a bulk-read of the DOM positions and sizes needed to draw the
	  // view, so that we don't interleave reading and writing to the DOM.
	  function getDimensions(cm) {
	    var d = cm.display, left = {}, width = {};
	    var gutterLeft = d.gutters.clientLeft;
	    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	      var id = cm.display.gutterSpecs[i].className;
	      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
	      width[id] = n.clientWidth;
	    }
	    return {fixedPos: compensateForHScroll(d),
	            gutterTotalWidth: d.gutters.offsetWidth,
	            gutterLeft: left,
	            gutterWidth: width,
	            wrapperWidth: d.wrapper.clientWidth}
	  }
	
	  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	  // but using getBoundingClientRect to get a sub-pixel-accurate
	  // result.
	  function compensateForHScroll(display) {
	    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
	  }
	
	  // Returns a function that estimates the height of a line, to use as
	  // first approximation until the line becomes visible (and is thus
	  // properly measurable).
	  function estimateHeight(cm) {
	    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
	    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
	    return function (line) {
	      if (lineIsHidden(cm.doc, line)) { return 0 }
	
	      var widgetsHeight = 0;
	      if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
	        if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
	      } }
	
	      if (wrapping)
	        { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
	      else
	        { return widgetsHeight + th }
	    }
	  }
	
	  function estimateLineHeights(cm) {
	    var doc = cm.doc, est = estimateHeight(cm);
	    doc.iter(function (line) {
	      var estHeight = est(line);
	      if (estHeight != line.height) { updateLineHeight(line, estHeight); }
	    });
	  }
	
	  // Given a mouse event, find the corresponding position. If liberal
	  // is false, it checks whether a gutter or scrollbar was clicked,
	  // and returns null if it was. forRect is used by rectangular
	  // selections, and tries to estimate a character position even for
	  // coordinates beyond the right of the text.
	  function posFromMouse(cm, e, liberal, forRect) {
	    var display = cm.display;
	    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }
	
	    var x, y, space = display.lineSpace.getBoundingClientRect();
	    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	    try { x = e.clientX - space.left; y = e.clientY - space.top; }
	    catch (e$1) { return null }
	    var coords = coordsChar(cm, x, y), line;
	    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
	      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
	    }
	    return coords
	  }
	
	  // Find the view element corresponding to a given line. Return null
	  // when the line isn't visible.
	  function findViewIndex(cm, n) {
	    if (n >= cm.display.viewTo) { return null }
	    n -= cm.display.viewFrom;
	    if (n < 0) { return null }
	    var view = cm.display.view;
	    for (var i = 0; i < view.length; i++) {
	      n -= view[i].size;
	      if (n < 0) { return i }
	    }
	  }
	
	  // Updates the display.view data structure for a given change to the
	  // document. From and to are in pre-change coordinates. Lendiff is
	  // the amount of lines added or subtracted by the change. This is
	  // used for changes that span multiple lines, or change the way
	  // lines are divided into visual lines. regLineChange (below)
	  // registers single-line changes.
	  function regChange(cm, from, to, lendiff) {
	    if (from == null) { from = cm.doc.first; }
	    if (to == null) { to = cm.doc.first + cm.doc.size; }
	    if (!lendiff) { lendiff = 0; }
	
	    var display = cm.display;
	    if (lendiff && to < display.viewTo &&
	        (display.updateLineNumbers == null || display.updateLineNumbers > from))
	      { display.updateLineNumbers = from; }
	
	    cm.curOp.viewChanged = true;
	
	    if (from >= display.viewTo) { // Change after
	      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
	        { resetView(cm); }
	    } else if (to <= display.viewFrom) { // Change before
	      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	        resetView(cm);
	      } else {
	        display.viewFrom += lendiff;
	        display.viewTo += lendiff;
	      }
	    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
	      resetView(cm);
	    } else if (from <= display.viewFrom) { // Top overlap
	      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cut) {
	        display.view = display.view.slice(cut.index);
	        display.viewFrom = cut.lineN;
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    } else if (to >= display.viewTo) { // Bottom overlap
	      var cut$1 = viewCuttingPoint(cm, from, from, -1);
	      if (cut$1) {
	        display.view = display.view.slice(0, cut$1.index);
	        display.viewTo = cut$1.lineN;
	      } else {
	        resetView(cm);
	      }
	    } else { // Gap in the middle
	      var cutTop = viewCuttingPoint(cm, from, from, -1);
	      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cutTop && cutBot) {
	        display.view = display.view.slice(0, cutTop.index)
	          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
	          .concat(display.view.slice(cutBot.index));
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    }
	
	    var ext = display.externalMeasured;
	    if (ext) {
	      if (to < ext.lineN)
	        { ext.lineN += lendiff; }
	      else if (from < ext.lineN + ext.size)
	        { display.externalMeasured = null; }
	    }
	  }
	
	  // Register a change to a single line. Type must be one of "text",
	  // "gutter", "class", "widget"
	  function regLineChange(cm, line, type) {
	    cm.curOp.viewChanged = true;
	    var display = cm.display, ext = cm.display.externalMeasured;
	    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
	      { display.externalMeasured = null; }
	
	    if (line < display.viewFrom || line >= display.viewTo) { return }
	    var lineView = display.view[findViewIndex(cm, line)];
	    if (lineView.node == null) { return }
	    var arr = lineView.changes || (lineView.changes = []);
	    if (indexOf(arr, type) == -1) { arr.push(type); }
	  }
	
	  // Clear the view.
	  function resetView(cm) {
	    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
	    cm.display.view = [];
	    cm.display.viewOffset = 0;
	  }
	
	  function viewCuttingPoint(cm, oldN, newN, dir) {
	    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
	    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
	      { return {index: index, lineN: newN} }
	    var n = cm.display.viewFrom;
	    for (var i = 0; i < index; i++)
	      { n += view[i].size; }
	    if (n != oldN) {
	      if (dir > 0) {
	        if (index == view.length - 1) { return null }
	        diff = (n + view[index].size) - oldN;
	        index++;
	      } else {
	        diff = n - oldN;
	      }
	      oldN += diff; newN += diff;
	    }
	    while (visualLineNo(cm.doc, newN) != newN) {
	      if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
	      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
	      index += dir;
	    }
	    return {index: index, lineN: newN}
	  }
	
	  // Force the view to cover a given range, adding empty view element
	  // or clipping off existing ones as needed.
	  function adjustView(cm, from, to) {
	    var display = cm.display, view = display.view;
	    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	      display.view = buildViewArray(cm, from, to);
	      display.viewFrom = from;
	    } else {
	      if (display.viewFrom > from)
	        { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
	      else if (display.viewFrom < from)
	        { display.view = display.view.slice(findViewIndex(cm, from)); }
	      display.viewFrom = from;
	      if (display.viewTo < to)
	        { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
	      else if (display.viewTo > to)
	        { display.view = display.view.slice(0, findViewIndex(cm, to)); }
	    }
	    display.viewTo = to;
	  }
	
	  // Count the number of lines in the view whose DOM representation is
	  // out of date (or nonexistent).
	  function countDirtyView(cm) {
	    var view = cm.display.view, dirty = 0;
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
	    }
	    return dirty
	  }
	
	  function updateSelection(cm) {
	    cm.display.input.showSelection(cm.display.input.prepareSelection());
	  }
	
	  function prepareSelection(cm, primary) {
	    if ( primary === void 0 ) primary = true;
	
	    var doc = cm.doc, result = {};
	    var curFragment = result.cursors = document.createDocumentFragment();
	    var selFragment = result.selection = document.createDocumentFragment();
	
	    var customCursor = cm.options.$customCursor;
	    if (customCursor) { primary = true; }
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      if (!primary && i == doc.sel.primIndex) { continue }
	      var range = doc.sel.ranges[i];
	      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
	      var collapsed = range.empty();
	      if (customCursor) {
	        var head = customCursor(cm, range);
	        if (head) { drawSelectionCursor(cm, head, curFragment); }
	      } else if (collapsed || cm.options.showCursorWhenSelecting) {
	        drawSelectionCursor(cm, range.head, curFragment);
	      }
	      if (!collapsed)
	        { drawSelectionRange(cm, range, selFragment); }
	    }
	    return result
	  }
	
	  // Draws a cursor for the given range
	  function drawSelectionCursor(cm, head, output) {
	    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
	
	    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
	    cursor.style.left = pos.left + "px";
	    cursor.style.top = pos.top + "px";
	    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
	
	    if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
	      var charPos = charCoords(cm, head, "div", null, null);
	      var width = charPos.right - charPos.left;
	      cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
	    }
	
	    if (pos.other) {
	      // Secondary cursor, shown when on a 'jump' in bi-directional text
	      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
	      otherCursor.style.display = "";
	      otherCursor.style.left = pos.other.left + "px";
	      otherCursor.style.top = pos.other.top + "px";
	      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
	    }
	  }
	
	  function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }
	
	  // Draws the given range as a highlighted selection
	  function drawSelectionRange(cm, range, output) {
	    var display = cm.display, doc = cm.doc;
	    var fragment = document.createDocumentFragment();
	    var padding = paddingH(cm.display), leftSide = padding.left;
	    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
	    var docLTR = doc.direction == "ltr";
	
	    function add(left, top, width, bottom) {
	      if (top < 0) { top = 0; }
	      top = Math.round(top);
	      bottom = Math.round(bottom);
	      fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
	    }
	
	    function drawForLine(line, fromArg, toArg) {
	      var lineObj = getLine(doc, line);
	      var lineLen = lineObj.text.length;
	      var start, end;
	      function coords(ch, bias) {
	        return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
	      }
	
	      function wrapX(pos, dir, side) {
	        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
	        var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
	        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
	        return coords(ch, prop)[prop]
	      }
	
	      var order = getOrder(lineObj, doc.direction);
	      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
	        var ltr = dir == "ltr";
	        var fromPos = coords(from, ltr ? "left" : "right");
	        var toPos = coords(to - 1, ltr ? "right" : "left");
	
	        var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
	        var first = i == 0, last = !order || i == order.length - 1;
	        if (toPos.top - fromPos.top <= 3) { // Single line
	          var openLeft = (docLTR ? openStart : openEnd) && first;
	          var openRight = (docLTR ? openEnd : openStart) && last;
	          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
	          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
	          add(left, fromPos.top, right - left, fromPos.bottom);
	        } else { // Multiple lines
	          var topLeft, topRight, botLeft, botRight;
	          if (ltr) {
	            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
	            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
	            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
	            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
	          } else {
	            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
	            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
	            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
	            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
	          }
	          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
	          if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
	          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
	        }
	
	        if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
	        if (cmpCoords(toPos, start) < 0) { start = toPos; }
	        if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
	        if (cmpCoords(toPos, end) < 0) { end = toPos; }
	      });
	      return {start: start, end: end}
	    }
	
	    var sFrom = range.from(), sTo = range.to();
	    if (sFrom.line == sTo.line) {
	      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
	    } else {
	      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
	      var singleVLine = visualLine(fromLine) == visualLine(toLine);
	      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
	      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
	      if (singleVLine) {
	        if (leftEnd.top < rightStart.top - 2) {
	          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
	          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
	        } else {
	          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
	        }
	      }
	      if (leftEnd.bottom < rightStart.top)
	        { add(leftSide, leftEnd.bottom, null, rightStart.top); }
	    }
	
	    output.appendChild(fragment);
	  }
	
	  // Cursor-blinking
	  function restartBlink(cm) {
	    if (!cm.state.focused) { return }
	    var display = cm.display;
	    clearInterval(display.blinker);
	    var on = true;
	    display.cursorDiv.style.visibility = "";
	    if (cm.options.cursorBlinkRate > 0)
	      { display.blinker = setInterval(function () {
	        if (!cm.hasFocus()) { onBlur(cm); }
	        display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
	      }, cm.options.cursorBlinkRate); }
	    else if (cm.options.cursorBlinkRate < 0)
	      { display.cursorDiv.style.visibility = "hidden"; }
	  }
	
	  function ensureFocus(cm) {
	    if (!cm.hasFocus()) {
	      cm.display.input.focus();
	      if (!cm.state.focused) { onFocus(cm); }
	    }
	  }
	
	  function delayBlurEvent(cm) {
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () { if (cm.state.delayingBlurEvent) {
	      cm.state.delayingBlurEvent = false;
	      if (cm.state.focused) { onBlur(cm); }
	    } }, 100);
	  }
	
	  function onFocus(cm, e) {
	    if (cm.state.delayingBlurEvent && !cm.state.draggingText) { cm.state.delayingBlurEvent = false; }
	
	    if (cm.options.readOnly == "nocursor") { return }
	    if (!cm.state.focused) {
	      signal(cm, "focus", cm, e);
	      cm.state.focused = true;
	      addClass(cm.display.wrapper, "CodeMirror-focused");
	      // This test prevents this from firing when a context
	      // menu is closed (since the input reset would kill the
	      // select-all detection hack)
	      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	        cm.display.input.reset();
	        if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
	      }
	      cm.display.input.receivedFocus();
	    }
	    restartBlink(cm);
	  }
	  function onBlur(cm, e) {
	    if (cm.state.delayingBlurEvent) { return }
	
	    if (cm.state.focused) {
	      signal(cm, "blur", cm, e);
	      cm.state.focused = false;
	      rmClass(cm.display.wrapper, "CodeMirror-focused");
	    }
	    clearInterval(cm.display.blinker);
	    setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
	  }
	
	  // Read the actual heights of the rendered lines, and update their
	  // stored heights to match.
	  function updateHeightsInViewport(cm) {
	    var display = cm.display;
	    var prevBottom = display.lineDiv.offsetTop;
	    var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
	    var oldHeight = display.lineDiv.getBoundingClientRect().top;
	    var mustScroll = 0;
	    for (var i = 0; i < display.view.length; i++) {
	      var cur = display.view[i], wrapping = cm.options.lineWrapping;
	      var height = (void 0), width = 0;
	      if (cur.hidden) { continue }
	      oldHeight += cur.line.height;
	      if (ie && ie_version < 8) {
	        var bot = cur.node.offsetTop + cur.node.offsetHeight;
	        height = bot - prevBottom;
	        prevBottom = bot;
	      } else {
	        var box = cur.node.getBoundingClientRect();
	        height = box.bottom - box.top;
	        // Check that lines don't extend past the right of the current
	        // editor width
	        if (!wrapping && cur.text.firstChild)
	          { width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1; }
	      }
	      var diff = cur.line.height - height;
	      if (diff > .005 || diff < -.005) {
	        if (oldHeight < viewTop) { mustScroll -= diff; }
	        updateLineHeight(cur.line, height);
	        updateWidgetHeight(cur.line);
	        if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
	          { updateWidgetHeight(cur.rest[j]); } }
	      }
	      if (width > cm.display.sizerWidth) {
	        var chWidth = Math.ceil(width / charWidth(cm.display));
	        if (chWidth > cm.display.maxLineLength) {
	          cm.display.maxLineLength = chWidth;
	          cm.display.maxLine = cur.line;
	          cm.display.maxLineChanged = true;
	        }
	      }
	    }
	    if (Math.abs(mustScroll) > 2) { display.scroller.scrollTop += mustScroll; }
	  }
	
	  // Read and store the height of line widgets associated with the
	  // given line.
	  function updateWidgetHeight(line) {
	    if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
	      var w = line.widgets[i], parent = w.node.parentNode;
	      if (parent) { w.height = parent.offsetHeight; }
	    } }
	  }
	
	  // Compute the lines that are visible in a given viewport (defaults
	  // the current scroll position). viewport may contain top,
	  // height, and ensure (see op.scrollToPos) properties.
	  function visibleLines(display, doc, viewport) {
	    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
	    top = Math.floor(top - paddingTop(display));
	    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
	
	    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
	    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	    // forces those lines into the viewport (if possible).
	    if (viewport && viewport.ensure) {
	      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
	      if (ensureFrom < from) {
	        from = ensureFrom;
	        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
	      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
	        to = ensureTo;
	      }
	    }
	    return {from: from, to: Math.max(to, from + 1)}
	  }
	
	  // SCROLLING THINGS INTO VIEW
	
	  // If an editor sits on the top or bottom of the window, partially
	  // scrolled out of view, this ensures that the cursor is visible.
	  function maybeScrollWindow(cm, rect) {
	    if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }
	
	    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
	    var doc = display.wrapper.ownerDocument;
	    if (rect.top + box.top < 0) { doScroll = true; }
	    else if (rect.bottom + box.top > (doc.defaultView.innerHeight || doc.documentElement.clientHeight)) { doScroll = false; }
	    if (doScroll != null && !phantom) {
	      var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
	      cm.display.lineSpace.appendChild(scrollNode);
	      scrollNode.scrollIntoView(doScroll);
	      cm.display.lineSpace.removeChild(scrollNode);
	    }
	  }
	
	  // Scroll a given position into view (immediately), verifying that
	  // it actually became visible (as line heights are accurately
	  // measured, the position of something may 'drift' during drawing).
	  function scrollPosIntoView(cm, pos, end, margin) {
	    if (margin == null) { margin = 0; }
	    var rect;
	    if (!cm.options.lineWrapping && pos == end) {
	      // Set pos and end to the cursor positions around the character pos sticks to
	      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
	      // If pos == Pos(_, 0, "before"), pos and end are unchanged
	      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
	      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
	    }
	    for (var limit = 0; limit < 5; limit++) {
	      var changed = false;
	      var coords = cursorCoords(cm, pos);
	      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
	      rect = {left: Math.min(coords.left, endCoords.left),
	              top: Math.min(coords.top, endCoords.top) - margin,
	              right: Math.max(coords.left, endCoords.left),
	              bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
	      var scrollPos = calculateScrollPos(cm, rect);
	      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
	      if (scrollPos.scrollTop != null) {
	        updateScrollTop(cm, scrollPos.scrollTop);
	        if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
	      }
	      if (scrollPos.scrollLeft != null) {
	        setScrollLeft(cm, scrollPos.scrollLeft);
	        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
	      }
	      if (!changed) { break }
	    }
	    return rect
	  }
	
	  // Scroll a given set of coordinates into view (immediately).
	  function scrollIntoView(cm, rect) {
	    var scrollPos = calculateScrollPos(cm, rect);
	    if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
	    if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
	  }
	
	  // Calculate a new scroll position needed to scroll the given
	  // rectangle into view. Returns an object with scrollTop and
	  // scrollLeft properties. When these are undefined, the
	  // vertical/horizontal position does not need to be adjusted.
	  function calculateScrollPos(cm, rect) {
	    var display = cm.display, snapMargin = textHeight(cm.display);
	    if (rect.top < 0) { rect.top = 0; }
	    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
	    var screen = displayHeight(cm), result = {};
	    if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
	    var docBottom = cm.doc.height + paddingVert(display);
	    var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
	    if (rect.top < screentop) {
	      result.scrollTop = atTop ? 0 : rect.top;
	    } else if (rect.bottom > screentop + screen) {
	      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
	      if (newTop != screentop) { result.scrollTop = newTop; }
	    }
	
	    var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
	    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
	    var screenw = displayWidth(cm) - display.gutters.offsetWidth;
	    var tooWide = rect.right - rect.left > screenw;
	    if (tooWide) { rect.right = rect.left + screenw; }
	    if (rect.left < 10)
	      { result.scrollLeft = 0; }
	    else if (rect.left < screenleft)
	      { result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10)); }
	    else if (rect.right > screenw + screenleft - 3)
	      { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
	    return result
	  }
	
	  // Store a relative adjustment to the scroll position in the current
	  // operation (to be applied when the operation finishes).
	  function addToScrollTop(cm, top) {
	    if (top == null) { return }
	    resolveScrollToPos(cm);
	    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
	  }
	
	  // Make sure that at the end of the operation the current cursor is
	  // shown.
	  function ensureCursorVisible(cm) {
	    resolveScrollToPos(cm);
	    var cur = cm.getCursor();
	    cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
	  }
	
	  function scrollToCoords(cm, x, y) {
	    if (x != null || y != null) { resolveScrollToPos(cm); }
	    if (x != null) { cm.curOp.scrollLeft = x; }
	    if (y != null) { cm.curOp.scrollTop = y; }
	  }
	
	  function scrollToRange(cm, range) {
	    resolveScrollToPos(cm);
	    cm.curOp.scrollToPos = range;
	  }
	
	  // When an operation has its scrollToPos property set, and another
	  // scroll action is applied before the end of the operation, this
	  // 'simulates' scrolling that position into view in a cheap way, so
	  // that the effect of intermediate scroll commands is not ignored.
	  function resolveScrollToPos(cm) {
	    var range = cm.curOp.scrollToPos;
	    if (range) {
	      cm.curOp.scrollToPos = null;
	      var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
	      scrollToCoordsRange(cm, from, to, range.margin);
	    }
	  }
	
	  function scrollToCoordsRange(cm, from, to, margin) {
	    var sPos = calculateScrollPos(cm, {
	      left: Math.min(from.left, to.left),
	      top: Math.min(from.top, to.top) - margin,
	      right: Math.max(from.right, to.right),
	      bottom: Math.max(from.bottom, to.bottom) + margin
	    });
	    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
	  }
	
	  // Sync the scrollable area and scrollbars, ensure the viewport
	  // covers the visible area.
	  function updateScrollTop(cm, val) {
	    if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
	    if (!gecko) { updateDisplaySimple(cm, {top: val}); }
	    setScrollTop(cm, val, true);
	    if (gecko) { updateDisplaySimple(cm); }
	    startWorker(cm, 100);
	  }
	
	  function setScrollTop(cm, val, forceScroll) {
	    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
	    if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
	    cm.doc.scrollTop = val;
	    cm.display.scrollbars.setScrollTop(val);
	    if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
	  }
	
	  // Sync scroller and scrollbar, ensure the gutter elements are
	  // aligned.
	  function setScrollLeft(cm, val, isScroller, forceScroll) {
	    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
	    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
	    cm.doc.scrollLeft = val;
	    alignHorizontally(cm);
	    if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
	    cm.display.scrollbars.setScrollLeft(val);
	  }
	
	  // SCROLLBARS
	
	  // Prepare DOM reads needed to update the scrollbars. Done in one
	  // shot to minimize update/measure roundtrips.
	  function measureForScrollbars(cm) {
	    var d = cm.display, gutterW = d.gutters.offsetWidth;
	    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
	    return {
	      clientHeight: d.scroller.clientHeight,
	      viewHeight: d.wrapper.clientHeight,
	      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	      viewWidth: d.wrapper.clientWidth,
	      barLeft: cm.options.fixedGutter ? gutterW : 0,
	      docHeight: docH,
	      scrollHeight: docH + scrollGap(cm) + d.barHeight,
	      nativeBarWidth: d.nativeBarWidth,
	      gutterWidth: gutterW
	    }
	  }
	
	  var NativeScrollbars = function(place, scroll, cm) {
	    this.cm = cm;
	    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
	    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
	    vert.tabIndex = horiz.tabIndex = -1;
	    place(vert); place(horiz);
	
	    on(vert, "scroll", function () {
	      if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
	    });
	    on(horiz, "scroll", function () {
	      if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
	    });
	
	    this.checkedZeroWidth = false;
	    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	    if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
	  };
	
	  NativeScrollbars.prototype.update = function (measure) {
	    var needsH = measure.scrollWidth > measure.clientWidth + 1;
	    var needsV = measure.scrollHeight > measure.clientHeight + 1;
	    var sWidth = measure.nativeBarWidth;
	
	    if (needsV) {
	      this.vert.style.display = "block";
	      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
	      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
	      // A bug in IE8 can cause this value to be negative, so guard it.
	      this.vert.firstChild.style.height =
	        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
	    } else {
	      this.vert.scrollTop = 0;
	      this.vert.style.display = "";
	      this.vert.firstChild.style.height = "0";
	    }
	
	    if (needsH) {
	      this.horiz.style.display = "block";
	      this.horiz.style.right = needsV ? sWidth + "px" : "0";
	      this.horiz.style.left = measure.barLeft + "px";
	      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
	      this.horiz.firstChild.style.width =
	        Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
	    } else {
	      this.horiz.style.display = "";
	      this.horiz.firstChild.style.width = "0";
	    }
	
	    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	      if (sWidth == 0) { this.zeroWidthHack(); }
	      this.checkedZeroWidth = true;
	    }
	
	    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
	  };
	
	  NativeScrollbars.prototype.setScrollLeft = function (pos) {
	    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
	    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
	  };
	
	  NativeScrollbars.prototype.setScrollTop = function (pos) {
	    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
	    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
	  };
	
	  NativeScrollbars.prototype.zeroWidthHack = function () {
	    var w = mac && !mac_geMountainLion ? "12px" : "18px";
	    this.horiz.style.height = this.vert.style.width = w;
	    this.horiz.style.visibility = this.vert.style.visibility = "hidden";
	    this.disableHoriz = new Delayed;
	    this.disableVert = new Delayed;
	  };
	
	  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
	    bar.style.visibility = "";
	    function maybeDisable() {
	      // To find out whether the scrollbar is still visible, we
	      // check whether the element under the pixel in the bottom
	      // right corner of the scrollbar box is the scrollbar box
	      // itself (when the bar is still visible) or its filler child
	      // (when the bar is hidden). If it is still visible, we keep
	      // it enabled, if it's hidden, we disable pointer events.
	      var box = bar.getBoundingClientRect();
	      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
	          : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
	      if (elt != bar) { bar.style.visibility = "hidden"; }
	      else { delay.set(1000, maybeDisable); }
	    }
	    delay.set(1000, maybeDisable);
	  };
	
	  NativeScrollbars.prototype.clear = function () {
	    var parent = this.horiz.parentNode;
	    parent.removeChild(this.horiz);
	    parent.removeChild(this.vert);
	  };
	
	  var NullScrollbars = function () {};
	
	  NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
	  NullScrollbars.prototype.setScrollLeft = function () {};
	  NullScrollbars.prototype.setScrollTop = function () {};
	  NullScrollbars.prototype.clear = function () {};
	
	  function updateScrollbars(cm, measure) {
	    if (!measure) { measure = measureForScrollbars(cm); }
	    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
	    updateScrollbarsInner(cm, measure);
	    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
	        { updateHeightsInViewport(cm); }
	      updateScrollbarsInner(cm, measureForScrollbars(cm));
	      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
	    }
	  }
	
	  // Re-synchronize the fake scrollbars with the actual size of the
	  // content.
	  function updateScrollbarsInner(cm, measure) {
	    var d = cm.display;
	    var sizes = d.scrollbars.update(measure);
	
	    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
	    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
	    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
	
	    if (sizes.right && sizes.bottom) {
	      d.scrollbarFiller.style.display = "block";
	      d.scrollbarFiller.style.height = sizes.bottom + "px";
	      d.scrollbarFiller.style.width = sizes.right + "px";
	    } else { d.scrollbarFiller.style.display = ""; }
	    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	      d.gutterFiller.style.display = "block";
	      d.gutterFiller.style.height = sizes.bottom + "px";
	      d.gutterFiller.style.width = measure.gutterWidth + "px";
	    } else { d.gutterFiller.style.display = ""; }
	  }
	
	  var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};
	
	  function initScrollbars(cm) {
	    if (cm.display.scrollbars) {
	      cm.display.scrollbars.clear();
	      if (cm.display.scrollbars.addClass)
	        { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
	    }
	
	    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
	      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
	      // Prevent clicks in the scrollbars from killing focus
	      on(node, "mousedown", function () {
	        if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
	      });
	      node.setAttribute("cm-not-content", "true");
	    }, function (pos, axis) {
	      if (axis == "horizontal") { setScrollLeft(cm, pos); }
	      else { updateScrollTop(cm, pos); }
	    }, cm);
	    if (cm.display.scrollbars.addClass)
	      { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
	  }
	
	  // Operations are used to wrap a series of changes to the editor
	  // state in such a way that each change won't have to update the
	  // cursor and display (which would be awkward, slow, and
	  // error-prone). Instead, display updates are batched and then all
	  // combined and executed at once.
	
	  var nextOpId = 0;
	  // Start a new operation.
	  function startOperation(cm) {
	    cm.curOp = {
	      cm: cm,
	      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
	      startHeight: cm.doc.height, // Used to detect need to update scrollbar
	      forceUpdate: false,      // Used to force a redraw
	      updateInput: 0,       // Whether to reset the input textarea
	      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
	      changeObjs: null,        // Accumulated changes, for firing change events
	      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	      selectionChanged: false, // Whether the selection needs to be redrawn
	      updateMaxLine: false,    // Set when the widest line needs to be determined anew
	      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	      scrollToPos: null,       // Used to scroll to a specific position
	      focus: false,
	      id: ++nextOpId,          // Unique ID
	      markArrays: null         // Used by addMarkedSpan
	    };
	    pushOperation(cm.curOp);
	  }
	
	  // Finish an operation, updating the display and signalling delayed events
	  function endOperation(cm) {
	    var op = cm.curOp;
	    if (op) { finishOperation(op, function (group) {
	      for (var i = 0; i < group.ops.length; i++)
	        { group.ops[i].cm.curOp = null; }
	      endOperations(group);
	    }); }
	  }
	
	  // The DOM updates done when an operation finishes are batched so
	  // that the minimum number of relayouts are required.
	  function endOperations(group) {
	    var ops = group.ops;
	    for (var i = 0; i < ops.length; i++) // Read DOM
	      { endOperation_R1(ops[i]); }
	    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
	      { endOperation_W1(ops[i$1]); }
	    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
	      { endOperation_R2(ops[i$2]); }
	    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
	      { endOperation_W2(ops[i$3]); }
	    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
	      { endOperation_finish(ops[i$4]); }
	  }
	
	  function endOperation_R1(op) {
	    var cm = op.cm, display = cm.display;
	    maybeClipScrollbars(cm);
	    if (op.updateMaxLine) { findMaxLine(cm); }
	
	    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
	      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
	                         op.scrollToPos.to.line >= display.viewTo) ||
	      display.maxLineChanged && cm.options.lineWrapping;
	    op.update = op.mustUpdate &&
	      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
	  }
	
	  function endOperation_W1(op) {
	    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
	  }
	
	  function endOperation_R2(op) {
	    var cm = op.cm, display = cm.display;
	    if (op.updatedDisplay) { updateHeightsInViewport(cm); }
	
	    op.barMeasure = measureForScrollbars(cm);
	
	    // If the max line changed since it was last measured, measure it,
	    // and ensure the document's width matches it.
	    // updateDisplay_W2 will use these properties to do the actual resizing
	    if (display.maxLineChanged && !cm.options.lineWrapping) {
	      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
	      cm.display.sizerWidth = op.adjustWidthTo;
	      op.barMeasure.scrollWidth =
	        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
	      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
	    }
	
	    if (op.updatedDisplay || op.selectionChanged)
	      { op.preparedSelection = display.input.prepareSelection(); }
	  }
	
	  function endOperation_W2(op) {
	    var cm = op.cm;
	
	    if (op.adjustWidthTo != null) {
	      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
	      if (op.maxScrollLeft < cm.doc.scrollLeft)
	        { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
	      cm.display.maxLineChanged = false;
	    }
	
	    var takeFocus = op.focus && op.focus == activeElt(root(cm));
	    if (op.preparedSelection)
	      { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
	    if (op.updatedDisplay || op.startHeight != cm.doc.height)
	      { updateScrollbars(cm, op.barMeasure); }
	    if (op.updatedDisplay)
	      { setDocumentHeight(cm, op.barMeasure); }
	
	    if (op.selectionChanged) { restartBlink(cm); }
	
	    if (cm.state.focused && op.updateInput)
	      { cm.display.input.reset(op.typing); }
	    if (takeFocus) { ensureFocus(op.cm); }
	  }
	
	  function endOperation_finish(op) {
	    var cm = op.cm, display = cm.display, doc = cm.doc;
	
	    if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }
	
	    // Abort mouse wheel delta measurement, when scrolling explicitly
	    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
	      { display.wheelStartX = display.wheelStartY = null; }
	
	    // Propagate the scroll position to the actual DOM scroller
	    if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }
	
	    if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
	    // If we need to scroll a specific position into view, do so.
	    if (op.scrollToPos) {
	      var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
	                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
	      maybeScrollWindow(cm, rect);
	    }
	
	    // Fire events for markers that are hidden/unidden by editing or
	    // undoing
	    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
	    if (hidden) { for (var i = 0; i < hidden.length; ++i)
	      { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
	    if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
	      { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }
	
	    if (display.wrapper.offsetHeight)
	      { doc.scrollTop = cm.display.scroller.scrollTop; }
	
	    // Fire change events, and delayed event handlers
	    if (op.changeObjs)
	      { signal(cm, "changes", cm, op.changeObjs); }
	    if (op.update)
	      { op.update.finish(); }
	  }
	
	  // Run the given function in an operation
	  function runInOp(cm, f) {
	    if (cm.curOp) { return f() }
	    startOperation(cm);
	    try { return f() }
	    finally { endOperation(cm); }
	  }
	  // Wraps a function in an operation. Returns the wrapped function.
	  function operation(cm, f) {
	    return function() {
	      if (cm.curOp) { return f.apply(cm, arguments) }
	      startOperation(cm);
	      try { return f.apply(cm, arguments) }
	      finally { endOperation(cm); }
	    }
	  }
	  // Used to add methods to editor and doc instances, wrapping them in
	  // operations.
	  function methodOp(f) {
	    return function() {
	      if (this.curOp) { return f.apply(this, arguments) }
	      startOperation(this);
	      try { return f.apply(this, arguments) }
	      finally { endOperation(this); }
	    }
	  }
	  function docMethodOp(f) {
	    return function() {
	      var cm = this.cm;
	      if (!cm || cm.curOp) { return f.apply(this, arguments) }
	      startOperation(cm);
	      try { return f.apply(this, arguments) }
	      finally { endOperation(cm); }
	    }
	  }
	
	  // HIGHLIGHT WORKER
	
	  function startWorker(cm, time) {
	    if (cm.doc.highlightFrontier < cm.display.viewTo)
	      { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
	  }
	
	  function highlightWorker(cm) {
	    var doc = cm.doc;
	    if (doc.highlightFrontier >= cm.display.viewTo) { return }
	    var end = +new Date + cm.options.workTime;
	    var context = getContextBefore(cm, doc.highlightFrontier);
	    var changedLines = [];
	
	    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
	      if (context.line >= cm.display.viewFrom) { // Visible
	        var oldStyles = line.styles;
	        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
	        var highlighted = highlightLine(cm, line, context, true);
	        if (resetState) { context.state = resetState; }
	        line.styles = highlighted.styles;
	        var oldCls = line.styleClasses, newCls = highlighted.classes;
	        if (newCls) { line.styleClasses = newCls; }
	        else if (oldCls) { line.styleClasses = null; }
	        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
	          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
	        for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
	        if (ischange) { changedLines.push(context.line); }
	        line.stateAfter = context.save();
	        context.nextLine();
	      } else {
	        if (line.text.length <= cm.options.maxHighlightLength)
	          { processLine(cm, line.text, context); }
	        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
	        context.nextLine();
	      }
	      if (+new Date > end) {
	        startWorker(cm, cm.options.workDelay);
	        return true
	      }
	    });
	    doc.highlightFrontier = context.line;
	    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
	    if (changedLines.length) { runInOp(cm, function () {
	      for (var i = 0; i < changedLines.length; i++)
	        { regLineChange(cm, changedLines[i], "text"); }
	    }); }
	  }
	
	  // DISPLAY DRAWING
	
	  var DisplayUpdate = function(cm, viewport, force) {
	    var display = cm.display;
	
	    this.viewport = viewport;
	    // Store some values that we'll need later (but don't want to force a relayout for)
	    this.visible = visibleLines(display, cm.doc, viewport);
	    this.editorIsHidden = !display.wrapper.offsetWidth;
	    this.wrapperHeight = display.wrapper.clientHeight;
	    this.wrapperWidth = display.wrapper.clientWidth;
	    this.oldDisplayWidth = displayWidth(cm);
	    this.force = force;
	    this.dims = getDimensions(cm);
	    this.events = [];
	  };
	
	  DisplayUpdate.prototype.signal = function (emitter, type) {
	    if (hasHandler(emitter, type))
	      { this.events.push(arguments); }
	  };
	  DisplayUpdate.prototype.finish = function () {
	    for (var i = 0; i < this.events.length; i++)
	      { signal.apply(null, this.events[i]); }
	  };
	
	  function maybeClipScrollbars(cm) {
	    var display = cm.display;
	    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
	      display.heightForcer.style.height = scrollGap(cm) + "px";
	      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
	      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
	      display.scrollbarsClipped = true;
	    }
	  }
	
	  function selectionSnapshot(cm) {
	    if (cm.hasFocus()) { return null }
	    var active = activeElt(root(cm));
	    if (!active || !contains(cm.display.lineDiv, active)) { return null }
	    var result = {activeElt: active};
	    if (window.getSelection) {
	      var sel = win(cm).getSelection();
	      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
	        result.anchorNode = sel.anchorNode;
	        result.anchorOffset = sel.anchorOffset;
	        result.focusNode = sel.focusNode;
	        result.focusOffset = sel.focusOffset;
	      }
	    }
	    return result
	  }
	
	  function restoreSelection(snapshot) {
	    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt(rootNode(snapshot.activeElt))) { return }
	    snapshot.activeElt.focus();
	    if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) &&
	        snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
	      var doc = snapshot.activeElt.ownerDocument;
	      var sel = doc.defaultView.getSelection(), range = doc.createRange();
	      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
	      range.collapse(false);
	      sel.removeAllRanges();
	      sel.addRange(range);
	      sel.extend(snapshot.focusNode, snapshot.focusOffset);
	    }
	  }
	
	  // Does the actual updating of the line display. Bails out
	  // (returning false) when there is nothing to be done and forced is
	  // false.
	  function updateDisplayIfNeeded(cm, update) {
	    var display = cm.display, doc = cm.doc;
	
	    if (update.editorIsHidden) {
	      resetView(cm);
	      return false
	    }
	
	    // Bail out if the visible area is already rendered and nothing changed.
	    if (!update.force &&
	        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
	        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
	        display.renderedView == display.view && countDirtyView(cm) == 0)
	      { return false }
	
	    if (maybeUpdateLineNumberWidth(cm)) {
	      resetView(cm);
	      update.dims = getDimensions(cm);
	    }
	
	    // Compute a suitable new viewport (from & to)
	    var end = doc.first + doc.size;
	    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
	    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
	    if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
	    if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
	    if (sawCollapsedSpans) {
	      from = visualLineNo(cm.doc, from);
	      to = visualLineEndNo(cm.doc, to);
	    }
	
	    var different = from != display.viewFrom || to != display.viewTo ||
	      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
	    adjustView(cm, from, to);
	
	    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
	    // Position the mover div to align with the current scroll position
	    cm.display.mover.style.top = display.viewOffset + "px";
	
	    var toUpdate = countDirtyView(cm);
	    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
	        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
	      { return false }
	
	    // For big changes, we hide the enclosing element during the
	    // update, since that speeds up the operations on most browsers.
	    var selSnapshot = selectionSnapshot(cm);
	    if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
	    patchDisplay(cm, display.updateLineNumbers, update.dims);
	    if (toUpdate > 4) { display.lineDiv.style.display = ""; }
	    display.renderedView = display.view;
	    // There might have been a widget with a focused element that got
	    // hidden or updated, if so re-focus it.
	    restoreSelection(selSnapshot);
	
	    // Prevent selection and cursors from interfering with the scroll
	    // width and height.
	    removeChildren(display.cursorDiv);
	    removeChildren(display.selectionDiv);
	    display.gutters.style.height = display.sizer.style.minHeight = 0;
	
	    if (different) {
	      display.lastWrapHeight = update.wrapperHeight;
	      display.lastWrapWidth = update.wrapperWidth;
	      startWorker(cm, 400);
	    }
	
	    display.updateLineNumbers = null;
	
	    return true
	  }
	
	  function postUpdateDisplay(cm, update) {
	    var viewport = update.viewport;
	
	    for (var first = true;; first = false) {
	      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	        // Clip forced viewport to actual scrollable area.
	        if (viewport && viewport.top != null)
	          { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
	        // Updated line heights might result in the drawn area not
	        // actually covering the viewport. Keep looping until it does.
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
	          { break }
	      } else if (first) {
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	      }
	      if (!updateDisplayIfNeeded(cm, update)) { break }
	      updateHeightsInViewport(cm);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.force = false;
	    }
	
	    update.signal(cm, "update", cm);
	    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
	      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
	    }
	  }
	
	  function updateDisplaySimple(cm, viewport) {
	    var update = new DisplayUpdate(cm, viewport);
	    if (updateDisplayIfNeeded(cm, update)) {
	      updateHeightsInViewport(cm);
	      postUpdateDisplay(cm, update);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.finish();
	    }
	  }
	
	  // Sync the actual display DOM structure with display.view, removing
	  // nodes for lines that are no longer in view, and creating the ones
	  // that are not there yet, and updating the ones that are out of
	  // date.
	  function patchDisplay(cm, updateNumbersFrom, dims) {
	    var display = cm.display, lineNumbers = cm.options.lineNumbers;
	    var container = display.lineDiv, cur = container.firstChild;
	
	    function rm(node) {
	      var next = node.nextSibling;
	      // Works around a throw-scroll bug in OS X Webkit
	      if (webkit && mac && cm.display.currentWheelTarget == node)
	        { node.style.display = "none"; }
	      else
	        { node.parentNode.removeChild(node); }
	      return next
	    }
	
	    var view = display.view, lineN = display.viewFrom;
	    // Loop over the elements in the view, syncing cur (the DOM nodes
	    // in display.lineDiv) with the view as we go.
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (lineView.hidden) ; else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
	        var node = buildLineElement(cm, lineView, lineN, dims);
	        container.insertBefore(node, cur);
	      } else { // Already drawn
	        while (cur != lineView.node) { cur = rm(cur); }
	        var updateNumber = lineNumbers && updateNumbersFrom != null &&
	          updateNumbersFrom <= lineN && lineView.lineNumber;
	        if (lineView.changes) {
	          if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
	          updateLineForChanges(cm, lineView, lineN, dims);
	        }
	        if (updateNumber) {
	          removeChildren(lineView.lineNumber);
	          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
	        }
	        cur = lineView.node.nextSibling;
	      }
	      lineN += lineView.size;
	    }
	    while (cur) { cur = rm(cur); }
	  }
	
	  function updateGutterSpace(display) {
	    var width = display.gutters.offsetWidth;
	    display.sizer.style.marginLeft = width + "px";
	    // Send an event to consumers responding to changes in gutter width.
	    signalLater(display, "gutterChanged", display);
	  }
	
	  function setDocumentHeight(cm, measure) {
	    cm.display.sizer.style.minHeight = measure.docHeight + "px";
	    cm.display.heightForcer.style.top = measure.docHeight + "px";
	    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
	  }
	
	  // Re-align line numbers and gutter marks to compensate for
	  // horizontal scrolling.
	  function alignHorizontally(cm) {
	    var display = cm.display, view = display.view;
	    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
	    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
	    var gutterW = display.gutters.offsetWidth, left = comp + "px";
	    for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
	      if (cm.options.fixedGutter) {
	        if (view[i].gutter)
	          { view[i].gutter.style.left = left; }
	        if (view[i].gutterBackground)
	          { view[i].gutterBackground.style.left = left; }
	      }
	      var align = view[i].alignable;
	      if (align) { for (var j = 0; j < align.length; j++)
	        { align[j].style.left = left; } }
	    } }
	    if (cm.options.fixedGutter)
	      { display.gutters.style.left = (comp + gutterW) + "px"; }
	  }
	
	  // Used to ensure that the line number gutter is still the right
	  // size for the current document size. Returns true when an update
	  // is needed.
	  function maybeUpdateLineNumberWidth(cm) {
	    if (!cm.options.lineNumbers) { return false }
	    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
	    if (last.length != display.lineNumChars) {
	      var test = display.measure.appendChild(elt("div", [elt("div", last)],
	                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
	      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
	      display.lineGutter.style.width = "";
	      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
	      display.lineNumWidth = display.lineNumInnerWidth + padding;
	      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
	      display.lineGutter.style.width = display.lineNumWidth + "px";
	      updateGutterSpace(cm.display);
	      return true
	    }
	    return false
	  }
	
	  function getGutters(gutters, lineNumbers) {
	    var result = [], sawLineNumbers = false;
	    for (var i = 0; i < gutters.length; i++) {
	      var name = gutters[i], style = null;
	      if (typeof name != "string") { style = name.style; name = name.className; }
	      if (name == "CodeMirror-linenumbers") {
	        if (!lineNumbers) { continue }
	        else { sawLineNumbers = true; }
	      }
	      result.push({className: name, style: style});
	    }
	    if (lineNumbers && !sawLineNumbers) { result.push({className: "CodeMirror-linenumbers", style: null}); }
	    return result
	  }
	
	  // Rebuild the gutter elements, ensure the margin to the left of the
	  // code matches their width.
	  function renderGutters(display) {
	    var gutters = display.gutters, specs = display.gutterSpecs;
	    removeChildren(gutters);
	    display.lineGutter = null;
	    for (var i = 0; i < specs.length; ++i) {
	      var ref = specs[i];
	      var className = ref.className;
	      var style = ref.style;
	      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
	      if (style) { gElt.style.cssText = style; }
	      if (className == "CodeMirror-linenumbers") {
	        display.lineGutter = gElt;
	        gElt.style.width = (display.lineNumWidth || 1) + "px";
	      }
	    }
	    gutters.style.display = specs.length ? "" : "none";
	    updateGutterSpace(display);
	  }
	
	  function updateGutters(cm) {
	    renderGutters(cm.display);
	    regChange(cm);
	    alignHorizontally(cm);
	  }
	
	  // The display handles the DOM integration, both for input reading
	  // and content drawing. It holds references to DOM nodes and
	  // display-related state.
	
	  function Display(place, doc, input, options) {
	    var d = this;
	    this.input = input;
	
	    // Covers bottom-right square when both scrollbars are present.
	    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
	    d.scrollbarFiller.setAttribute("cm-not-content", "true");
	    // Covers bottom of gutter when coverGutterNextToScrollbar is on
	    // and h scrollbar is present.
	    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
	    d.gutterFiller.setAttribute("cm-not-content", "true");
	    // Will contain the actual code, positioned to cover the viewport.
	    d.lineDiv = eltP("div", null, "CodeMirror-code");
	    // Elements are added to these to represent selection and cursors.
	    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
	    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
	    // A visibility: hidden element used to find the size of things.
	    d.measure = elt("div", null, "CodeMirror-measure");
	    // When lines outside of the viewport are measured, they are drawn in this.
	    d.lineMeasure = elt("div", null, "CodeMirror-measure");
	    // Wraps everything that needs to exist inside the vertically-padded coordinate system
	    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
	                      null, "position: relative; outline: none");
	    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
	    // Moved around its parent to cover visible view.
	    d.mover = elt("div", [lines], null, "position: relative");
	    // Set to the height of the document, allowing scrolling.
	    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
	    d.sizerWidth = null;
	    // Behavior of elts with overflow: auto and padding is
	    // inconsistent across browsers. This is used to ensure the
	    // scrollable area is big enough.
	    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
	    // Will contain the gutters, if any.
	    d.gutters = elt("div", null, "CodeMirror-gutters");
	    d.lineGutter = null;
	    // Actual scrollable element.
	    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
	    d.scroller.setAttribute("tabIndex", "-1");
	    // The element in which the editor lives.
	    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");
	    // See #6982. FIXME remove when this has been fixed for a while in Chrome
	    if (chrome && chrome_version >= 105) { d.wrapper.style.clipPath = "inset(0px)"; }
	
	    // This attribute is respected by automatic translation systems such as Google Translate,
	    // and may also be respected by tools used by human translators.
	    d.wrapper.setAttribute('translate', 'no');
	
	    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
	    if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }
	
	    if (place) {
	      if (place.appendChild) { place.appendChild(d.wrapper); }
	      else { place(d.wrapper); }
	    }
	
	    // Current rendered range (may be bigger than the view window).
	    d.viewFrom = d.viewTo = doc.first;
	    d.reportedViewFrom = d.reportedViewTo = doc.first;
	    // Information about the rendered lines.
	    d.view = [];
	    d.renderedView = null;
	    // Holds info about a single rendered line when it was rendered
	    // for measurement, while not in view.
	    d.externalMeasured = null;
	    // Empty space (in pixels) above the view
	    d.viewOffset = 0;
	    d.lastWrapHeight = d.lastWrapWidth = 0;
	    d.updateLineNumbers = null;
	
	    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
	    d.scrollbarsClipped = false;
	
	    // Used to only resize the line number gutter when necessary (when
	    // the amount of lines crosses a boundary that makes its width change)
	    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
	    // Set to true when a non-horizontal-scrolling line widget is
	    // added. As an optimization, line widget aligning is skipped when
	    // this is false.
	    d.alignWidgets = false;
	
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	
	    // Tracks the maximum line length so that the horizontal scrollbar
	    // can be kept static when scrolling.
	    d.maxLine = null;
	    d.maxLineLength = 0;
	    d.maxLineChanged = false;
	
	    // Used for measuring wheel scrolling granularity
	    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
	
	    // True when shift is held down.
	    d.shift = false;
	
	    // Used to track whether anything happened since the context menu
	    // was opened.
	    d.selForContextMenu = null;
	
	    d.activeTouch = null;
	
	    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
	    renderGutters(d);
	
	    input.init(d);
	  }
	
	  // Since the delta values reported on mouse wheel events are
	  // unstandardized between browsers and even browser versions, and
	  // generally horribly unpredictable, this code starts by measuring
	  // the scroll effect that the first few mouse wheel events have,
	  // and, from that, detects the way it can convert deltas to pixel
	  // offsets afterwards.
	  //
	  // The reason we want to know the amount a wheel event will scroll
	  // is that it gives us a chance to update the display before the
	  // actual scrolling happens, reducing flickering.
	
	  var wheelSamples = 0, wheelPixelsPerUnit = null;
	  // Fill in a browser-detected starting value on browsers where we
	  // know one. These don't have to be accurate -- the result of them
	  // being wrong would just be a slight flicker on the first wheel
	  // scroll (if it is large enough).
	  if (ie) { wheelPixelsPerUnit = -.53; }
	  else if (gecko) { wheelPixelsPerUnit = 15; }
	  else if (chrome) { wheelPixelsPerUnit = -.7; }
	  else if (safari) { wheelPixelsPerUnit = -1/3; }
	
	  function wheelEventDelta(e) {
	    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
	    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
	    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
	    else if (dy == null) { dy = e.wheelDelta; }
	    return {x: dx, y: dy}
	  }
	  function wheelEventPixels(e) {
	    var delta = wheelEventDelta(e);
	    delta.x *= wheelPixelsPerUnit;
	    delta.y *= wheelPixelsPerUnit;
	    return delta
	  }
	
	  function onScrollWheel(cm, e) {
	    // On Chrome 102, viewport updates somehow stop wheel-based
	    // scrolling. Turning off pointer events during the scroll seems
	    // to avoid the issue.
	    if (chrome && chrome_version == 102) {
	      if (cm.display.chromeScrollHack == null) { cm.display.sizer.style.pointerEvents = "none"; }
	      else { clearTimeout(cm.display.chromeScrollHack); }
	      cm.display.chromeScrollHack = setTimeout(function () {
	        cm.display.chromeScrollHack = null;
	        cm.display.sizer.style.pointerEvents = "";
	      }, 100);
	    }
	    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
	    var pixelsPerUnit = wheelPixelsPerUnit;
	    if (e.deltaMode === 0) {
	      dx = e.deltaX;
	      dy = e.deltaY;
	      pixelsPerUnit = 1;
	    }
	
	    var display = cm.display, scroll = display.scroller;
	    // Quit if there's nothing to scroll here
	    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
	    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
	    if (!(dx && canScrollX || dy && canScrollY)) { return }
	
	    // Webkit browsers on OS X abort momentum scrolls when the target
	    // of the scroll event is removed from the scrollable element.
	    // This hack (see related code in patchDisplay) makes sure the
	    // element is kept around.
	    if (dy && mac && webkit) {
	      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	        for (var i = 0; i < view.length; i++) {
	          if (view[i].node == cur) {
	            cm.display.currentWheelTarget = cur;
	            break outer
	          }
	        }
	      }
	    }
	
	    // On some browsers, horizontal scrolling will cause redraws to
	    // happen before the gutter has been realigned, causing it to
	    // wriggle around in a most unseemly way. When we have an
	    // estimated pixels/delta value, we just handle horizontal
	    // scrolling entirely here. It'll be slightly off from native, but
	    // better than glitching out.
	    if (dx && !gecko && !presto && pixelsPerUnit != null) {
	      if (dy && canScrollY)
	        { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit)); }
	      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
	      // Only prevent default scrolling if vertical scrolling is
	      // actually possible. Otherwise, it causes vertical scroll
	      // jitter on OSX trackpads when deltaX is small and deltaY
	      // is large (issue #3579)
	      if (!dy || (dy && canScrollY))
	        { e_preventDefault(e); }
	      display.wheelStartX = null; // Abort measurement, if in progress
	      return
	    }
	
	    // 'Project' the visible viewport to cover the area that is being
	    // scrolled into view (if we know enough to estimate it).
	    if (dy && pixelsPerUnit != null) {
	      var pixels = dy * pixelsPerUnit;
	      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
	      if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
	      else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
	      updateDisplaySimple(cm, {top: top, bottom: bot});
	    }
	
	    if (wheelSamples < 20 && e.deltaMode !== 0) {
	      if (display.wheelStartX == null) {
	        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
	        display.wheelDX = dx; display.wheelDY = dy;
	        setTimeout(function () {
	          if (display.wheelStartX == null) { return }
	          var movedX = scroll.scrollLeft - display.wheelStartX;
	          var movedY = scroll.scrollTop - display.wheelStartY;
	          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
	            (movedX && display.wheelDX && movedX / display.wheelDX);
	          display.wheelStartX = display.wheelStartY = null;
	          if (!sample) { return }
	          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
	          ++wheelSamples;
	        }, 200);
	      } else {
	        display.wheelDX += dx; display.wheelDY += dy;
	      }
	    }
	  }
	
	  // Selection objects are immutable. A new one is created every time
	  // the selection changes. A selection is one or more non-overlapping
	  // (and non-touching) ranges, sorted, and an integer that indicates
	  // which one is the primary selection (the one that's scrolled into
	  // view, that getCursor returns, etc).
	  var Selection = function(ranges, primIndex) {
	    this.ranges = ranges;
	    this.primIndex = primIndex;
	  };
	
	  Selection.prototype.primary = function () { return this.ranges[this.primIndex] };
	
	  Selection.prototype.equals = function (other) {
	    if (other == this) { return true }
	    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var here = this.ranges[i], there = other.ranges[i];
	      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
	    }
	    return true
	  };
	
	  Selection.prototype.deepCopy = function () {
	    var out = [];
	    for (var i = 0; i < this.ranges.length; i++)
	      { out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head)); }
	    return new Selection(out, this.primIndex)
	  };
	
	  Selection.prototype.somethingSelected = function () {
	    for (var i = 0; i < this.ranges.length; i++)
	      { if (!this.ranges[i].empty()) { return true } }
	    return false
	  };
	
	  Selection.prototype.contains = function (pos, end) {
	    if (!end) { end = pos; }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var range = this.ranges[i];
	      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
	        { return i }
	    }
	    return -1
	  };
	
	  var Range = function(anchor, head) {
	    this.anchor = anchor; this.head = head;
	  };
	
	  Range.prototype.from = function () { return minPos(this.anchor, this.head) };
	  Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
	  Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };
	
	  // Take an unsorted, potentially overlapping set of ranges, and
	  // build a selection out of it. 'Consumes' ranges array (modifying
	  // it).
	  function normalizeSelection(cm, ranges, primIndex) {
	    var mayTouch = cm && cm.options.selectionsMayTouch;
	    var prim = ranges[primIndex];
	    ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
	    primIndex = indexOf(ranges, prim);
	    for (var i = 1; i < ranges.length; i++) {
	      var cur = ranges[i], prev = ranges[i - 1];
	      var diff = cmp(prev.to(), cur.from());
	      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
	        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
	        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
	        if (i <= primIndex) { --primIndex; }
	        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
	      }
	    }
	    return new Selection(ranges, primIndex)
	  }
	
	  function simpleSelection(anchor, head) {
	    return new Selection([new Range(anchor, head || anchor)], 0)
	  }
	
	  // Compute the position of the end of a change (its 'to' property
	  // refers to the pre-change end).
	  function changeEnd(change) {
	    if (!change.text) { return change.to }
	    return Pos(change.from.line + change.text.length - 1,
	               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
	  }
	
	  // Adjust a position to refer to the post-change position of the
	  // same text, or the end of the change if the change covers it.
	  function adjustForChange(pos, change) {
	    if (cmp(pos, change.from) < 0) { return pos }
	    if (cmp(pos, change.to) <= 0) { return changeEnd(change) }
	
	    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
	    if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
	    return Pos(line, ch)
	  }
	
	  function computeSelAfterChange(doc, change) {
	    var out = [];
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      var range = doc.sel.ranges[i];
	      out.push(new Range(adjustForChange(range.anchor, change),
	                         adjustForChange(range.head, change)));
	    }
	    return normalizeSelection(doc.cm, out, doc.sel.primIndex)
	  }
	
	  function offsetPos(pos, old, nw) {
	    if (pos.line == old.line)
	      { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
	    else
	      { return Pos(nw.line + (pos.line - old.line), pos.ch) }
	  }
	
	  // Used by replaceSelections to allow moving the selection to the
	  // start or around the replaced test. Hint may be "start" or "around".
	  function computeReplacedSel(doc, changes, hint) {
	    var out = [];
	    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
	    for (var i = 0; i < changes.length; i++) {
	      var change = changes[i];
	      var from = offsetPos(change.from, oldPrev, newPrev);
	      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
	      oldPrev = change.to;
	      newPrev = to;
	      if (hint == "around") {
	        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
	        out[i] = new Range(inv ? to : from, inv ? from : to);
	      } else {
	        out[i] = new Range(from, from);
	      }
	    }
	    return new Selection(out, doc.sel.primIndex)
	  }
	
	  // Used to get the editor into a consistent state again when options change.
	
	  function loadMode(cm) {
	    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
	    resetModeState(cm);
	  }
	
	  function resetModeState(cm) {
	    cm.doc.iter(function (line) {
	      if (line.stateAfter) { line.stateAfter = null; }
	      if (line.styles) { line.styles = null; }
	    });
	    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
	    startWorker(cm, 100);
	    cm.state.modeGen++;
	    if (cm.curOp) { regChange(cm); }
	  }
	
	  // DOCUMENT DATA STRUCTURE
	
	  // By default, updates that start and end at the beginning of a line
	  // are treated specially, in order to make the association of line
	  // widgets and marker elements with the text behave more intuitive.
	  function isWholeLineUpdate(doc, change) {
	    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
	      (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
	  }
	
	  // Perform a change on the document data structure.
	  function updateDoc(doc, change, markedSpans, estimateHeight) {
	    function spansFor(n) {return markedSpans ? markedSpans[n] : null}
	    function update(line, text, spans) {
	      updateLine(line, text, spans, estimateHeight);
	      signalLater(line, "change", line, change);
	    }
	    function linesFor(start, end) {
	      var result = [];
	      for (var i = start; i < end; ++i)
	        { result.push(new Line(text[i], spansFor(i), estimateHeight)); }
	      return result
	    }
	
	    var from = change.from, to = change.to, text = change.text;
	    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
	    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
	
	    // Adjust the line structure
	    if (change.full) {
	      doc.insert(0, linesFor(0, text.length));
	      doc.remove(text.length, doc.size - text.length);
	    } else if (isWholeLineUpdate(doc, change)) {
	      // This is a whole-line replace. Treated specially to make
	      // sure line objects move the way they are supposed to.
	      var added = linesFor(0, text.length - 1);
	      update(lastLine, lastLine.text, lastSpans);
	      if (nlines) { doc.remove(from.line, nlines); }
	      if (added.length) { doc.insert(from.line, added); }
	    } else if (firstLine == lastLine) {
	      if (text.length == 1) {
	        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
	      } else {
	        var added$1 = linesFor(1, text.length - 1);
	        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
	        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	        doc.insert(from.line + 1, added$1);
	      }
	    } else if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
	      doc.remove(from.line + 1, nlines);
	    } else {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
	      var added$2 = linesFor(1, text.length - 1);
	      if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
	      doc.insert(from.line + 1, added$2);
	    }
	
	    signalLater(doc, "change", doc, change);
	  }
	
	  // Call f for all linked documents.
	  function linkedDocs(doc, f, sharedHistOnly) {
	    function propagate(doc, skip, sharedHist) {
	      if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
	        var rel = doc.linked[i];
	        if (rel.doc == skip) { continue }
	        var shared = sharedHist && rel.sharedHist;
	        if (sharedHistOnly && !shared) { continue }
	        f(rel.doc, shared);
	        propagate(rel.doc, doc, shared);
	      } }
	    }
	    propagate(doc, null, true);
	  }
	
	  // Attach a document to an editor.
	  function attachDoc(cm, doc) {
	    if (doc.cm) { throw new Error("This document is already in use.") }
	    cm.doc = doc;
	    doc.cm = cm;
	    estimateLineHeights(cm);
	    loadMode(cm);
	    setDirectionClass(cm);
	    cm.options.direction = doc.direction;
	    if (!cm.options.lineWrapping) { findMaxLine(cm); }
	    cm.options.mode = doc.modeOption;
	    regChange(cm);
	  }
	
	  function setDirectionClass(cm) {
	  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
	  }
	
	  function directionChanged(cm) {
	    runInOp(cm, function () {
	      setDirectionClass(cm);
	      regChange(cm);
	    });
	  }
	
	  function History(prev) {
	    // Arrays of change events and selections. Doing something adds an
	    // event to done and clears undo. Undoing moves events from done
	    // to undone, redoing moves them in the other direction.
	    this.done = []; this.undone = [];
	    this.undoDepth = prev ? prev.undoDepth : Infinity;
	    // Used to track when changes can be merged into a single undo
	    // event
	    this.lastModTime = this.lastSelTime = 0;
	    this.lastOp = this.lastSelOp = null;
	    this.lastOrigin = this.lastSelOrigin = null;
	    // Used by the isClean() method
	    this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
	  }
	
	  // Create a history change event from an updateDoc-style change
	  // object.
	  function historyChangeFromChange(doc, change) {
	    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
	    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
	    return histChange
	  }
	
	  // Pop all selection events off the end of a history array. Stop at
	  // a change event.
	  function clearSelectionEvents(array) {
	    while (array.length) {
	      var last = lst(array);
	      if (last.ranges) { array.pop(); }
	      else { break }
	    }
	  }
	
	  // Find the top change event in the history. Pop off selection
	  // events that are in the way.
	  function lastChangeEvent(hist, force) {
	    if (force) {
	      clearSelectionEvents(hist.done);
	      return lst(hist.done)
	    } else if (hist.done.length && !lst(hist.done).ranges) {
	      return lst(hist.done)
	    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	      hist.done.pop();
	      return lst(hist.done)
	    }
	  }
	
	  // Register a change in the history. Merges changes that are within
	  // a single operation, or are close together with an origin that
	  // allows merging (starting with "+") into a single event.
	  function addChangeToHistory(doc, change, selAfter, opId) {
	    var hist = doc.history;
	    hist.undone.length = 0;
	    var time = +new Date, cur;
	    var last;
	
	    if ((hist.lastOp == opId ||
	         hist.lastOrigin == change.origin && change.origin &&
	         ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
	          change.origin.charAt(0) == "*")) &&
	        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	      // Merge this change into the last event
	      last = lst(cur.changes);
	      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	        // Optimized case for simple insertion -- don't want to add
	        // new changesets for every character typed
	        last.to = changeEnd(change);
	      } else {
	        // Add new sub-event
	        cur.changes.push(historyChangeFromChange(doc, change));
	      }
	    } else {
	      // Can not be merged, start a new event.
	      var before = lst(hist.done);
	      if (!before || !before.ranges)
	        { pushSelectionToHistory(doc.sel, hist.done); }
	      cur = {changes: [historyChangeFromChange(doc, change)],
	             generation: hist.generation};
	      hist.done.push(cur);
	      while (hist.done.length > hist.undoDepth) {
	        hist.done.shift();
	        if (!hist.done[0].ranges) { hist.done.shift(); }
	      }
	    }
	    hist.done.push(selAfter);
	    hist.generation = ++hist.maxGeneration;
	    hist.lastModTime = hist.lastSelTime = time;
	    hist.lastOp = hist.lastSelOp = opId;
	    hist.lastOrigin = hist.lastSelOrigin = change.origin;
	
	    if (!last) { signal(doc, "historyAdded"); }
	  }
	
	  function selectionEventCanBeMerged(doc, origin, prev, sel) {
	    var ch = origin.charAt(0);
	    return ch == "*" ||
	      ch == "+" &&
	      prev.ranges.length == sel.ranges.length &&
	      prev.somethingSelected() == sel.somethingSelected() &&
	      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
	  }
	
	  // Called whenever the selection changes, sets the new selection as
	  // the pending selection in the history, and pushes the old pending
	  // selection into the 'done' array when it was significantly
	  // different (in number of selected ranges, emptiness, or time).
	  function addSelectionToHistory(doc, sel, opId, options) {
	    var hist = doc.history, origin = options && options.origin;
	
	    // A new event is started when the previous origin does not match
	    // the current, or the origins don't allow matching. Origins
	    // starting with * are always merged, those starting with + are
	    // merged when similar and close together in time.
	    if (opId == hist.lastSelOp ||
	        (origin && hist.lastSelOrigin == origin &&
	         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
	          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
	      { hist.done[hist.done.length - 1] = sel; }
	    else
	      { pushSelectionToHistory(sel, hist.done); }
	
	    hist.lastSelTime = +new Date;
	    hist.lastSelOrigin = origin;
	    hist.lastSelOp = opId;
	    if (options && options.clearRedo !== false)
	      { clearSelectionEvents(hist.undone); }
	  }
	
	  function pushSelectionToHistory(sel, dest) {
	    var top = lst(dest);
	    if (!(top && top.ranges && top.equals(sel)))
	      { dest.push(sel); }
	  }
	
	  // Used to store marked span information in the history.
	  function attachLocalSpans(doc, change, from, to) {
	    var existing = change["spans_" + doc.id], n = 0;
	    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
	      if (line.markedSpans)
	        { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
	      ++n;
	    });
	  }
	
	  // When un/re-doing restores text containing marked spans, those
	  // that have been explicitly cleared should not be restored.
	  function removeClearedSpans(spans) {
	    if (!spans) { return null }
	    var out;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
	      else if (out) { out.push(spans[i]); }
	    }
	    return !out ? spans : out.length ? out : null
	  }
	
	  // Retrieve and filter the old marked spans stored in a change event.
	  function getOldSpans(doc, change) {
	    var found = change["spans_" + doc.id];
	    if (!found) { return null }
	    var nw = [];
	    for (var i = 0; i < change.text.length; ++i)
	      { nw.push(removeClearedSpans(found[i])); }
	    return nw
	  }
	
	  // Used for un/re-doing changes from the history. Combines the
	  // result of computing the existing spans with the set of spans that
	  // existed in the history (so that deleting around a span and then
	  // undoing brings back the span).
	  function mergeOldSpans(doc, change) {
	    var old = getOldSpans(doc, change);
	    var stretched = stretchSpansOverChange(doc, change);
	    if (!old) { return stretched }
	    if (!stretched) { return old }
	
	    for (var i = 0; i < old.length; ++i) {
	      var oldCur = old[i], stretchCur = stretched[i];
	      if (oldCur && stretchCur) {
	        spans: for (var j = 0; j < stretchCur.length; ++j) {
	          var span = stretchCur[j];
	          for (var k = 0; k < oldCur.length; ++k)
	            { if (oldCur[k].marker == span.marker) { continue spans } }
	          oldCur.push(span);
	        }
	      } else if (stretchCur) {
	        old[i] = stretchCur;
	      }
	    }
	    return old
	  }
	
	  // Used both to provide a JSON-safe object in .getHistory, and, when
	  // detaching a document, to split the history in two
	  function copyHistoryArray(events, newGroup, instantiateSel) {
	    var copy = [];
	    for (var i = 0; i < events.length; ++i) {
	      var event = events[i];
	      if (event.ranges) {
	        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
	        continue
	      }
	      var changes = event.changes, newChanges = [];
	      copy.push({changes: newChanges});
	      for (var j = 0; j < changes.length; ++j) {
	        var change = changes[j], m = (void 0);
	        newChanges.push({from: change.from, to: change.to, text: change.text});
	        if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
	          if (indexOf(newGroup, Number(m[1])) > -1) {
	            lst(newChanges)[prop] = change[prop];
	            delete change[prop];
	          }
	        } } }
	      }
	    }
	    return copy
	  }
	
	  // The 'scroll' parameter given to many of these indicated whether
	  // the new cursor position should be scrolled into view after
	  // modifying the selection.
	
	  // If shift is held or the extend flag is set, extends a range to
	  // include a given position (and optionally a second position).
	  // Otherwise, simply returns the range between the given positions.
	  // Used for cursor motion and such.
	  function extendRange(range, head, other, extend) {
	    if (extend) {
	      var anchor = range.anchor;
	      if (other) {
	        var posBefore = cmp(head, anchor) < 0;
	        if (posBefore != (cmp(other, anchor) < 0)) {
	          anchor = head;
	          head = other;
	        } else if (posBefore != (cmp(head, other) < 0)) {
	          head = other;
	        }
	      }
	      return new Range(anchor, head)
	    } else {
	      return new Range(other || head, head)
	    }
	  }
	
	  // Extend the primary selection range, discard the rest.
	  function extendSelection(doc, head, other, options, extend) {
	    if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
	    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
	  }
	
	  // Extend all selections (pos is an array of selections with length
	  // equal the number of selections)
	  function extendSelections(doc, heads, options) {
	    var out = [];
	    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    for (var i = 0; i < doc.sel.ranges.length; i++)
	      { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
	    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
	    setSelection(doc, newSel, options);
	  }
	
	  // Updates a single range in the selection.
	  function replaceOneSelection(doc, i, range, options) {
	    var ranges = doc.sel.ranges.slice(0);
	    ranges[i] = range;
	    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
	  }
	
	  // Reset the selection to a single range.
	  function setSimpleSelection(doc, anchor, head, options) {
	    setSelection(doc, simpleSelection(anchor, head), options);
	  }
	
	  // Give beforeSelectionChange handlers a change to influence a
	  // selection update.
	  function filterSelectionChange(doc, sel, options) {
	    var obj = {
	      ranges: sel.ranges,
	      update: function(ranges) {
	        this.ranges = [];
	        for (var i = 0; i < ranges.length; i++)
	          { this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
	                                     clipPos(doc, ranges[i].head)); }
	      },
	      origin: options && options.origin
	    };
	    signal(doc, "beforeSelectionChange", doc, obj);
	    if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
	    if (obj.ranges != sel.ranges) { return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1) }
	    else { return sel }
	  }
	
	  function setSelectionReplaceHistory(doc, sel, options) {
	    var done = doc.history.done, last = lst(done);
	    if (last && last.ranges) {
	      done[done.length - 1] = sel;
	      setSelectionNoUndo(doc, sel, options);
	    } else {
	      setSelection(doc, sel, options);
	    }
	  }
	
	  // Set a new selection.
	  function setSelection(doc, sel, options) {
	    setSelectionNoUndo(doc, sel, options);
	    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
	  }
	
	  function setSelectionNoUndo(doc, sel, options) {
	    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
	      { sel = filterSelectionChange(doc, sel, options); }
	
	    var bias = options && options.bias ||
	      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
	    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
	
	    if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor")
	      { ensureCursorVisible(doc.cm); }
	  }
	
	  function setSelectionInner(doc, sel) {
	    if (sel.equals(doc.sel)) { return }
	
	    doc.sel = sel;
	
	    if (doc.cm) {
	      doc.cm.curOp.updateInput = 1;
	      doc.cm.curOp.selectionChanged = true;
	      signalCursorActivity(doc.cm);
	    }
	    signalLater(doc, "cursorActivity", doc);
	  }
	
	  // Verify that the selection does not partially select any atomic
	  // marked ranges.
	  function reCheckSelection(doc) {
	    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
	  }
	
	  // Return a selection that does not partially select any atomic
	  // ranges.
	  function skipAtomicInSelection(doc, sel, bias, mayClear) {
	    var out;
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i];
	      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
	      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
	      var newHead = range.head == range.anchor ? newAnchor : skipAtomic(doc, range.head, old && old.head, bias, mayClear);
	      if (out || newAnchor != range.anchor || newHead != range.head) {
	        if (!out) { out = sel.ranges.slice(0, i); }
	        out[i] = new Range(newAnchor, newHead);
	      }
	    }
	    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel
	  }
	
	  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	    var line = getLine(doc, pos.line);
	    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	      var sp = line.markedSpans[i], m = sp.marker;
	
	      // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
	      // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
	      // is with selectLeft/Right
	      var preventCursorLeft = ("selectLeft" in m) ? !m.selectLeft : m.inclusiveLeft;
	      var preventCursorRight = ("selectRight" in m) ? !m.selectRight : m.inclusiveRight;
	
	      if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
	          (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	        if (mayClear) {
	          signal(m, "beforeCursorEnter");
	          if (m.explicitlyCleared) {
	            if (!line.markedSpans) { break }
	            else {--i; continue}
	          }
	        }
	        if (!m.atomic) { continue }
	
	        if (oldPos) {
	          var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
	          if (dir < 0 ? preventCursorRight : preventCursorLeft)
	            { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
	          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
	            { return skipAtomicInner(doc, near, pos, dir, mayClear) }
	        }
	
	        var far = m.find(dir < 0 ? -1 : 1);
	        if (dir < 0 ? preventCursorLeft : preventCursorRight)
	          { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
	        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
	      }
	    } }
	    return pos
	  }
	
	  // Ensure a given position is not inside an atomic range.
	  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	    var dir = bias || 1;
	    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
	        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
	        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
	        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
	    if (!found) {
	      doc.cantEdit = true;
	      return Pos(doc.first, 0)
	    }
	    return found
	  }
	
	  function movePos(doc, pos, dir, line) {
	    if (dir < 0 && pos.ch == 0) {
	      if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
	      else { return null }
	    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	      if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
	      else { return null }
	    } else {
	      return new Pos(pos.line, pos.ch + dir)
	    }
	  }
	
	  function selectAll(cm) {
	    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
	  }
	
	  // UPDATING
	
	  // Allow "beforeChange" event handlers to influence a change
	  function filterChange(doc, change, update) {
	    var obj = {
	      canceled: false,
	      from: change.from,
	      to: change.to,
	      text: change.text,
	      origin: change.origin,
	      cancel: function () { return obj.canceled = true; }
	    };
	    if (update) { obj.update = function (from, to, text, origin) {
	      if (from) { obj.from = clipPos(doc, from); }
	      if (to) { obj.to = clipPos(doc, to); }
	      if (text) { obj.text = text; }
	      if (origin !== undefined) { obj.origin = origin; }
	    }; }
	    signal(doc, "beforeChange", doc, obj);
	    if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }
	
	    if (obj.canceled) {
	      if (doc.cm) { doc.cm.curOp.updateInput = 2; }
	      return null
	    }
	    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
	  }
	
	  // Apply a change to a document, and add it to the document's
	  // history, and propagating it to all linked documents.
	  function makeChange(doc, change, ignoreReadOnly) {
	    if (doc.cm) {
	      if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
	      if (doc.cm.state.suppressEdits) { return }
	    }
	
	    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	      change = filterChange(doc, change, true);
	      if (!change) { return }
	    }
	
	    // Possibly split or suppress the update based on the presence
	    // of read-only spans in its range.
	    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
	    if (split) {
	      for (var i = split.length - 1; i >= 0; --i)
	        { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
	    } else {
	      makeChangeInner(doc, change);
	    }
	  }
	
	  function makeChangeInner(doc, change) {
	    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
	    var selAfter = computeSelAfterChange(doc, change);
	    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
	
	    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
	    var rebased = [];
	
	    linkedDocs(doc, function (doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change);
	        rebased.push(doc.history);
	      }
	      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
	    });
	  }
	
	  // Revert a change stored in a document's history.
	  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	    var suppress = doc.cm && doc.cm.state.suppressEdits;
	    if (suppress && !allowSelectionOnly) { return }
	
	    var hist = doc.history, event, selAfter = doc.sel;
	    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
	
	    // Verify that there is a useable event (so that ctrl-z won't
	    // needlessly clear selection events)
	    var i = 0;
	    for (; i < source.length; i++) {
	      event = source[i];
	      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
	        { break }
	    }
	    if (i == source.length) { return }
	    hist.lastOrigin = hist.lastSelOrigin = null;
	
	    for (;;) {
	      event = source.pop();
	      if (event.ranges) {
	        pushSelectionToHistory(event, dest);
	        if (allowSelectionOnly && !event.equals(doc.sel)) {
	          setSelection(doc, event, {clearRedo: false});
	          return
	        }
	        selAfter = event;
	      } else if (suppress) {
	        source.push(event);
	        return
	      } else { break }
	    }
	
	    // Build up a reverse change object to add to the opposite history
	    // stack (redo when undoing, and vice versa).
	    var antiChanges = [];
	    pushSelectionToHistory(selAfter, dest);
	    dest.push({changes: antiChanges, generation: hist.generation});
	    hist.generation = event.generation || ++hist.maxGeneration;
	
	    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
	
	    var loop = function ( i ) {
	      var change = event.changes[i];
	      change.origin = type;
	      if (filter && !filterChange(doc, change, false)) {
	        source.length = 0;
	        return {}
	      }
	
	      antiChanges.push(historyChangeFromChange(doc, change));
	
	      var after = i ? computeSelAfterChange(doc, change) : lst(source);
	      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
	      if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
	      var rebased = [];
	
	      // Propagate to the linked documents
	      linkedDocs(doc, function (doc, sharedHist) {
	        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	          rebaseHist(doc.history, change);
	          rebased.push(doc.history);
	        }
	        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
	      });
	    };
	
	    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
	      var returned = loop( i$1 );
	
	      if ( returned ) return returned.v;
	    }
	  }
	
	  // Sub-views need their line numbers shifted when text is added
	  // above or below them in the parent document.
	  function shiftDoc(doc, distance) {
	    if (distance == 0) { return }
	    doc.first += distance;
	    doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
	      Pos(range.anchor.line + distance, range.anchor.ch),
	      Pos(range.head.line + distance, range.head.ch)
	    ); }), doc.sel.primIndex);
	    if (doc.cm) {
	      regChange(doc.cm, doc.first, doc.first - distance, distance);
	      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
	        { regLineChange(doc.cm, l, "gutter"); }
	    }
	  }
	
	  // More lower-level change function, handling only a single document
	  // (not linked ones).
	  function makeChangeSingleDoc(doc, change, selAfter, spans) {
	    if (doc.cm && !doc.cm.curOp)
	      { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }
	
	    if (change.to.line < doc.first) {
	      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
	      return
	    }
	    if (change.from.line > doc.lastLine()) { return }
	
	    // Clip the change to the size of this doc
	    if (change.from.line < doc.first) {
	      var shift = change.text.length - 1 - (doc.first - change.from.line);
	      shiftDoc(doc, shift);
	      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	                text: [lst(change.text)], origin: change.origin};
	    }
	    var last = doc.lastLine();
	    if (change.to.line > last) {
	      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
	                text: [change.text[0]], origin: change.origin};
	    }
	
	    change.removed = getBetween(doc, change.from, change.to);
	
	    if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
	    if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
	    else { updateDoc(doc, change, spans); }
	    setSelectionNoUndo(doc, selAfter, sel_dontScroll);
	
	    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0)))
	      { doc.cantEdit = false; }
	  }
	
	  // Handle the interaction of a change to a document with the editor
	  // that this document is part of.
	  function makeChangeSingleDocInEditor(cm, change, spans) {
	    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
	
	    var recomputeMaxLength = false, checkWidthStart = from.line;
	    if (!cm.options.lineWrapping) {
	      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
	      doc.iter(checkWidthStart, to.line + 1, function (line) {
	        if (line == display.maxLine) {
	          recomputeMaxLength = true;
	          return true
	        }
	      });
	    }
	
	    if (doc.sel.contains(change.from, change.to) > -1)
	      { signalCursorActivity(cm); }
	
	    updateDoc(doc, change, spans, estimateHeight(cm));
	
	    if (!cm.options.lineWrapping) {
	      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
	        var len = lineLength(line);
	        if (len > display.maxLineLength) {
	          display.maxLine = line;
	          display.maxLineLength = len;
	          display.maxLineChanged = true;
	          recomputeMaxLength = false;
	        }
	      });
	      if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
	    }
	
	    retreatFrontier(doc, from.line);
	    startWorker(cm, 400);
	
	    var lendiff = change.text.length - (to.line - from.line) - 1;
	    // Remember that these lines changed, for updating the display
	    if (change.full)
	      { regChange(cm); }
	    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
	      { regLineChange(cm, from.line, "text"); }
	    else
	      { regChange(cm, from.line, to.line + 1, lendiff); }
	
	    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
	    if (changeHandler || changesHandler) {
	      var obj = {
	        from: from, to: to,
	        text: change.text,
	        removed: change.removed,
	        origin: change.origin
	      };
	      if (changeHandler) { signalLater(cm, "change", cm, obj); }
	      if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
	    }
	    cm.display.selForContextMenu = null;
	  }
	
	  function replaceRange(doc, code, from, to, origin) {
	    var assign;
	
	    if (!to) { to = from; }
	    if (cmp(to, from) < 0) { (assign = [to, from], from = assign[0], to = assign[1]); }
	    if (typeof code == "string") { code = doc.splitLines(code); }
	    makeChange(doc, {from: from, to: to, text: code, origin: origin});
	  }
	
	  // Rebasing/resetting history to deal with externally-sourced changes
	
	  function rebaseHistSelSingle(pos, from, to, diff) {
	    if (to < pos.line) {
	      pos.line += diff;
	    } else if (from < pos.line) {
	      pos.line = from;
	      pos.ch = 0;
	    }
	  }
	
	  // Tries to rebase an array of history events given a change in the
	  // document. If the change touches the same lines as the event, the
	  // event, and everything 'behind' it, is discarded. If the change is
	  // before the event, the event's positions are updated. Uses a
	  // copy-on-write scheme for the positions, to avoid having to
	  // reallocate them all on every rebase, but also avoid problems with
	  // shared position objects being unsafely updated.
	  function rebaseHistArray(array, from, to, diff) {
	    for (var i = 0; i < array.length; ++i) {
	      var sub = array[i], ok = true;
	      if (sub.ranges) {
	        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
	        for (var j = 0; j < sub.ranges.length; j++) {
	          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
	          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
	        }
	        continue
	      }
	      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
	        var cur = sub.changes[j$1];
	        if (to < cur.from.line) {
	          cur.from = Pos(cur.from.line + diff, cur.from.ch);
	          cur.to = Pos(cur.to.line + diff, cur.to.ch);
	        } else if (from <= cur.to.line) {
	          ok = false;
	          break
	        }
	      }
	      if (!ok) {
	        array.splice(0, i + 1);
	        i = 0;
	      }
	    }
	  }
	
	  function rebaseHist(hist, change) {
	    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
	    rebaseHistArray(hist.done, from, to, diff);
	    rebaseHistArray(hist.undone, from, to, diff);
	  }
	
	  // Utility for applying a change to a line by handle or number,
	  // returning the number and optionally registering the line as
	  // changed.
	  function changeLine(doc, handle, changeType, op) {
	    var no = handle, line = handle;
	    if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
	    else { no = lineNo(handle); }
	    if (no == null) { return null }
	    if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
	    return line
	  }
	
	  // The document is represented as a BTree consisting of leaves, with
	  // chunk of lines in them, and branches, with up to ten leaves or
	  // other branch nodes below them. The top node is always a branch
	  // node, and is the document object itself (meaning it has
	  // additional methods and properties).
	  //
	  // All nodes have parent links. The tree is used both to go from
	  // line numbers to line objects, and to go from objects to numbers.
	  // It also indexes by height, and is used to convert between height
	  // and line object, and to find the total height of the document.
	  //
	  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	  function LeafChunk(lines) {
	    this.lines = lines;
	    this.parent = null;
	    var height = 0;
	    for (var i = 0; i < lines.length; ++i) {
	      lines[i].parent = this;
	      height += lines[i].height;
	    }
	    this.height = height;
	  }
	
	  LeafChunk.prototype = {
	    chunkSize: function() { return this.lines.length },
	
	    // Remove the n lines at offset 'at'.
	    removeInner: function(at, n) {
	      for (var i = at, e = at + n; i < e; ++i) {
	        var line = this.lines[i];
	        this.height -= line.height;
	        cleanUpLine(line);
	        signalLater(line, "delete");
	      }
	      this.lines.splice(at, n);
	    },
	
	    // Helper used to collapse a small branch into a single leaf.
	    collapse: function(lines) {
	      lines.push.apply(lines, this.lines);
	    },
	
	    // Insert the given array of lines at offset 'at', count them as
	    // having the given height.
	    insertInner: function(at, lines, height) {
	      this.height += height;
	      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
	      for (var i = 0; i < lines.length; ++i) { lines[i].parent = this; }
	    },
	
	    // Used to iterate over a part of the tree.
	    iterN: function(at, n, op) {
	      for (var e = at + n; at < e; ++at)
	        { if (op(this.lines[at])) { return true } }
	    }
	  };
	
	  function BranchChunk(children) {
	    this.children = children;
	    var size = 0, height = 0;
	    for (var i = 0; i < children.length; ++i) {
	      var ch = children[i];
	      size += ch.chunkSize(); height += ch.height;
	      ch.parent = this;
	    }
	    this.size = size;
	    this.height = height;
	    this.parent = null;
	  }
	
	  BranchChunk.prototype = {
	    chunkSize: function() { return this.size },
	
	    removeInner: function(at, n) {
	      this.size -= n;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at < sz) {
	          var rm = Math.min(n, sz - at), oldHeight = child.height;
	          child.removeInner(at, rm);
	          this.height -= oldHeight - child.height;
	          if (sz == rm) { this.children.splice(i--, 1); child.parent = null; }
	          if ((n -= rm) == 0) { break }
	          at = 0;
	        } else { at -= sz; }
	      }
	      // If the result is smaller than 25 lines, ensure that it is a
	      // single leaf node.
	      if (this.size - n < 25 &&
	          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	        var lines = [];
	        this.collapse(lines);
	        this.children = [new LeafChunk(lines)];
	        this.children[0].parent = this;
	      }
	    },
	
	    collapse: function(lines) {
	      for (var i = 0; i < this.children.length; ++i) { this.children[i].collapse(lines); }
	    },
	
	    insertInner: function(at, lines, height) {
	      this.size += lines.length;
	      this.height += height;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at <= sz) {
	          child.insertInner(at, lines, height);
	          if (child.lines && child.lines.length > 50) {
	            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	            var remaining = child.lines.length % 25 + 25;
	            for (var pos = remaining; pos < child.lines.length;) {
	              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
	              child.height -= leaf.height;
	              this.children.splice(++i, 0, leaf);
	              leaf.parent = this;
	            }
	            child.lines = child.lines.slice(0, remaining);
	            this.maybeSpill();
	          }
	          break
	        }
	        at -= sz;
	      }
	    },
	
	    // When a node has grown, check whether it should be split.
	    maybeSpill: function() {
	      if (this.children.length <= 10) { return }
	      var me = this;
	      do {
	        var spilled = me.children.splice(me.children.length - 5, 5);
	        var sibling = new BranchChunk(spilled);
	        if (!me.parent) { // Become the parent node
	          var copy = new BranchChunk(me.children);
	          copy.parent = me;
	          me.children = [copy, sibling];
	          me = copy;
	       } else {
	          me.size -= sibling.size;
	          me.height -= sibling.height;
	          var myIndex = indexOf(me.parent.children, me);
	          me.parent.children.splice(myIndex + 1, 0, sibling);
	        }
	        sibling.parent = me.parent;
	      } while (me.children.length > 10)
	      me.parent.maybeSpill();
	    },
	
	    iterN: function(at, n, op) {
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at < sz) {
	          var used = Math.min(n, sz - at);
	          if (child.iterN(at, used, op)) { return true }
	          if ((n -= used) == 0) { break }
	          at = 0;
	        } else { at -= sz; }
	      }
	    }
	  };
	
	  // Line widgets are block elements displayed above or below a line.
	
	  var LineWidget = function(doc, node, options) {
	    if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
	      { this[opt] = options[opt]; } } }
	    this.doc = doc;
	    this.node = node;
	  };
	
	  LineWidget.prototype.clear = function () {
	    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
	    if (no == null || !ws) { return }
	    for (var i = 0; i < ws.length; ++i) { if (ws[i] == this) { ws.splice(i--, 1); } }
	    if (!ws.length) { line.widgets = null; }
	    var height = widgetHeight(this);
	    updateLineHeight(line, Math.max(0, line.height - height));
	    if (cm) {
	      runInOp(cm, function () {
	        adjustScrollWhenAboveVisible(cm, line, -height);
	        regLineChange(cm, no, "widget");
	      });
	      signalLater(cm, "lineWidgetCleared", cm, this, no);
	    }
	  };
	
	  LineWidget.prototype.changed = function () {
	      var this$1 = this;
	
	    var oldH = this.height, cm = this.doc.cm, line = this.line;
	    this.height = null;
	    var diff = widgetHeight(this) - oldH;
	    if (!diff) { return }
	    if (!lineIsHidden(this.doc, line)) { updateLineHeight(line, line.height + diff); }
	    if (cm) {
	      runInOp(cm, function () {
	        cm.curOp.forceUpdate = true;
	        adjustScrollWhenAboveVisible(cm, line, diff);
	        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
	      });
	    }
	  };
	  eventMixin(LineWidget);
	
	  function adjustScrollWhenAboveVisible(cm, line, diff) {
	    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
	      { addToScrollTop(cm, diff); }
	  }
	
	  function addLineWidget(doc, handle, node, options) {
	    var widget = new LineWidget(doc, node, options);
	    var cm = doc.cm;
	    if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
	    changeLine(doc, handle, "widget", function (line) {
	      var widgets = line.widgets || (line.widgets = []);
	      if (widget.insertAt == null) { widgets.push(widget); }
	      else { widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget); }
	      widget.line = line;
	      if (cm && !lineIsHidden(doc, line)) {
	        var aboveVisible = heightAtLine(line) < doc.scrollTop;
	        updateLineHeight(line, line.height + widgetHeight(widget));
	        if (aboveVisible) { addToScrollTop(cm, widget.height); }
	        cm.curOp.forceUpdate = true;
	      }
	      return true
	    });
	    if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
	    return widget
	  }
	
	  // TEXTMARKERS
	
	  // Created with markText and setBookmark methods. A TextMarker is a
	  // handle that can be used to clear or find a marked position in the
	  // document. Line objects hold arrays (markedSpans) containing
	  // {from, to, marker} object pointing to such marker objects, and
	  // indicating that such a marker is present on that line. Multiple
	  // lines may point to the same marker when it spans across lines.
	  // The spans will have null for their from/to properties when the
	  // marker continues beyond the start/end of the line. Markers have
	  // links back to the lines they currently touch.
	
	  // Collapsed markers have unique ids, in order to be able to order
	  // them, which is needed for uniquely determining an outer marker
	  // when they overlap (they may nest, but not partially overlap).
	  var nextMarkerId = 0;
	
	  var TextMarker = function(doc, type) {
	    this.lines = [];
	    this.type = type;
	    this.doc = doc;
	    this.id = ++nextMarkerId;
	  };
	
	  // Clear the marker.
	  TextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) { return }
	    var cm = this.doc.cm, withOp = cm && !cm.curOp;
	    if (withOp) { startOperation(cm); }
	    if (hasHandler(this, "clear")) {
	      var found = this.find();
	      if (found) { signalLater(this, "clear", found.from, found.to); }
	    }
	    var min = null, max = null;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (cm && !this.collapsed) { regLineChange(cm, lineNo(line), "text"); }
	      else if (cm) {
	        if (span.to != null) { max = lineNo(line); }
	        if (span.from != null) { min = lineNo(line); }
	      }
	      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
	      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm)
	        { updateLineHeight(line, textHeight(cm.display)); }
	    }
	    if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
	      var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
	      if (len > cm.display.maxLineLength) {
	        cm.display.maxLine = visual;
	        cm.display.maxLineLength = len;
	        cm.display.maxLineChanged = true;
	      }
	    } }
	
	    if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
	    this.lines.length = 0;
	    this.explicitlyCleared = true;
	    if (this.atomic && this.doc.cantEdit) {
	      this.doc.cantEdit = false;
	      if (cm) { reCheckSelection(cm.doc); }
	    }
	    if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
	    if (withOp) { endOperation(cm); }
	    if (this.parent) { this.parent.clear(); }
	  };
	
	  // Find the position of the marker in the document. Returns a {from,
	  // to} object by default. Side can be passed to get a specific side
	  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	  // Pos objects returned contain a line object, rather than a line
	  // number (used to prevent looking up the same line twice).
	  TextMarker.prototype.find = function (side, lineObj) {
	    if (side == null && this.type == "bookmark") { side = 1; }
	    var from, to;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (span.from != null) {
	        from = Pos(lineObj ? line : lineNo(line), span.from);
	        if (side == -1) { return from }
	      }
	      if (span.to != null) {
	        to = Pos(lineObj ? line : lineNo(line), span.to);
	        if (side == 1) { return to }
	      }
	    }
	    return from && {from: from, to: to}
	  };
	
	  // Signals that the marker's widget changed, and surrounding layout
	  // should be recomputed.
	  TextMarker.prototype.changed = function () {
	      var this$1 = this;
	
	    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
	    if (!pos || !cm) { return }
	    runInOp(cm, function () {
	      var line = pos.line, lineN = lineNo(pos.line);
	      var view = findViewForLine(cm, lineN);
	      if (view) {
	        clearLineMeasurementCacheFor(view);
	        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
	      }
	      cm.curOp.updateMaxLine = true;
	      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	        var oldHeight = widget.height;
	        widget.height = null;
	        var dHeight = widgetHeight(widget) - oldHeight;
	        if (dHeight)
	          { updateLineHeight(line, line.height + dHeight); }
	      }
	      signalLater(cm, "markerChanged", cm, this$1);
	    });
	  };
	
	  TextMarker.prototype.attachLine = function (line) {
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;
	      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
	        { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
	    }
	    this.lines.push(line);
	  };
	
	  TextMarker.prototype.detachLine = function (line) {
	    this.lines.splice(indexOf(this.lines, line), 1);
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp
	      ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
	    }
	  };
	  eventMixin(TextMarker);
	
	  // Create a marker, wire it up to the right lines, and
	  function markText(doc, from, to, options, type) {
	    // Shared markers (across linked documents) are handled separately
	    // (markTextShared will call out to this again, once per
	    // document).
	    if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
	    // Ensure we are in an operation.
	    if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }
	
	    var marker = new TextMarker(doc, type), diff = cmp(from, to);
	    if (options) { copyObj(options, marker, false); }
	    // Don't connect empty markers unless clearWhenEmpty is false
	    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
	      { return marker }
	    if (marker.replacedWith) {
	      // Showing up as a widget implies collapsed (widget replaces text)
	      marker.collapsed = true;
	      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
	      if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
	      if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
	    }
	    if (marker.collapsed) {
	      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
	          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
	        { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
	      seeCollapsedSpans();
	    }
	
	    if (marker.addToHistory)
	      { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }
	
	    var curLine = from.line, cm = doc.cm, updateMaxLine;
	    doc.iter(curLine, to.line + 1, function (line) {
	      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
	        { updateMaxLine = true; }
	      if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
	      addMarkedSpan(line, new MarkedSpan(marker,
	                                         curLine == from.line ? from.ch : null,
	                                         curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
	      ++curLine;
	    });
	    // lineIsHidden depends on the presence of the spans, so needs a second pass
	    if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
	      if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
	    }); }
	
	    if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }
	
	    if (marker.readOnly) {
	      seeReadOnlySpans();
	      if (doc.history.done.length || doc.history.undone.length)
	        { doc.clearHistory(); }
	    }
	    if (marker.collapsed) {
	      marker.id = ++nextMarkerId;
	      marker.atomic = true;
	    }
	    if (cm) {
	      // Sync editor state
	      if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
	      if (marker.collapsed)
	        { regChange(cm, from.line, to.line + 1); }
	      else if (marker.className || marker.startStyle || marker.endStyle || marker.css ||
	               marker.attributes || marker.title)
	        { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
	      if (marker.atomic) { reCheckSelection(cm.doc); }
	      signalLater(cm, "markerAdded", cm, marker);
	    }
	    return marker
	  }
	
	  // SHARED TEXTMARKERS
	
	  // A shared marker spans multiple linked documents. It is
	  // implemented as a meta-marker-object controlling multiple normal
	  // markers.
	  var SharedTextMarker = function(markers, primary) {
	    this.markers = markers;
	    this.primary = primary;
	    for (var i = 0; i < markers.length; ++i)
	      { markers[i].parent = this; }
	  };
	
	  SharedTextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) { return }
	    this.explicitlyCleared = true;
	    for (var i = 0; i < this.markers.length; ++i)
	      { this.markers[i].clear(); }
	    signalLater(this, "clear");
	  };
	
	  SharedTextMarker.prototype.find = function (side, lineObj) {
	    return this.primary.find(side, lineObj)
	  };
	  eventMixin(SharedTextMarker);
	
	  function markTextShared(doc, from, to, options, type) {
	    options = copyObj(options);
	    options.shared = false;
	    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
	    var widget = options.widgetNode;
	    linkedDocs(doc, function (doc) {
	      if (widget) { options.widgetNode = widget.cloneNode(true); }
	      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
	      for (var i = 0; i < doc.linked.length; ++i)
	        { if (doc.linked[i].isParent) { return } }
	      primary = lst(markers);
	    });
	    return new SharedTextMarker(markers, primary)
	  }
	
	  function findSharedMarkers(doc) {
	    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
	  }
	
	  function copySharedMarkers(doc, markers) {
	    for (var i = 0; i < markers.length; i++) {
	      var marker = markers[i], pos = marker.find();
	      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
	      if (cmp(mFrom, mTo)) {
	        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
	        marker.markers.push(subMark);
	        subMark.parent = marker;
	      }
	    }
	  }
	
	  function detachSharedMarkers(markers) {
	    var loop = function ( i ) {
	      var marker = markers[i], linked = [marker.primary.doc];
	      linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
	      for (var j = 0; j < marker.markers.length; j++) {
	        var subMarker = marker.markers[j];
	        if (indexOf(linked, subMarker.doc) == -1) {
	          subMarker.parent = null;
	          marker.markers.splice(j--, 1);
	        }
	      }
	    };
	
	    for (var i = 0; i < markers.length; i++) loop( i );
	  }
	
	  var nextDocId = 0;
	  var Doc = function(text, mode, firstLine, lineSep, direction) {
	    if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
	    if (firstLine == null) { firstLine = 0; }
	
	    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
	    this.first = firstLine;
	    this.scrollTop = this.scrollLeft = 0;
	    this.cantEdit = false;
	    this.cleanGeneration = 1;
	    this.modeFrontier = this.highlightFrontier = firstLine;
	    var start = Pos(firstLine, 0);
	    this.sel = simpleSelection(start);
	    this.history = new History(null);
	    this.id = ++nextDocId;
	    this.modeOption = mode;
	    this.lineSep = lineSep;
	    this.direction = (direction == "rtl") ? "rtl" : "ltr";
	    this.extend = false;
	
	    if (typeof text == "string") { text = this.splitLines(text); }
	    updateDoc(this, {from: start, to: start, text: text});
	    setSelection(this, simpleSelection(start), sel_dontScroll);
	  };
	
	  Doc.prototype = createObj(BranchChunk.prototype, {
	    constructor: Doc,
	    // Iterate over the document. Supports two forms -- with only one
	    // argument, it calls that for each line in the document. With
	    // three, it iterates over the range given by the first two (with
	    // the second being non-inclusive).
	    iter: function(from, to, op) {
	      if (op) { this.iterN(from - this.first, to - from, op); }
	      else { this.iterN(this.first, this.first + this.size, from); }
	    },
	
	    // Non-public interface for adding and removing lines.
	    insert: function(at, lines) {
	      var height = 0;
	      for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
	      this.insertInner(at - this.first, lines, height);
	    },
	    remove: function(at, n) { this.removeInner(at - this.first, n); },
	
	    // From here, the methods are part of the public interface. Most
	    // are also available from CodeMirror (editor) instances.
	
	    getValue: function(lineSep) {
	      var lines = getLines(this, this.first, this.first + this.size);
	      if (lineSep === false) { return lines }
	      return lines.join(lineSep || this.lineSeparator())
	    },
	    setValue: docMethodOp(function(code) {
	      var top = Pos(this.first, 0), last = this.first + this.size - 1;
	      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
	                        text: this.splitLines(code), origin: "setValue", full: true}, true);
	      if (this.cm) { scrollToCoords(this.cm, 0, 0); }
	      setSelection(this, simpleSelection(top), sel_dontScroll);
	    }),
	    replaceRange: function(code, from, to, origin) {
	      from = clipPos(this, from);
	      to = to ? clipPos(this, to) : from;
	      replaceRange(this, code, from, to, origin);
	    },
	    getRange: function(from, to, lineSep) {
	      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
	      if (lineSep === false) { return lines }
	      if (lineSep === '') { return lines.join('') }
	      return lines.join(lineSep || this.lineSeparator())
	    },
	
	    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},
	
	    getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
	    getLineNumber: function(line) {return lineNo(line)},
	
	    getLineHandleVisualStart: function(line) {
	      if (typeof line == "number") { line = getLine(this, line); }
	      return visualLine(line)
	    },
	
	    lineCount: function() {return this.size},
	    firstLine: function() {return this.first},
	    lastLine: function() {return this.first + this.size - 1},
	
	    clipPos: function(pos) {return clipPos(this, pos)},
	
	    getCursor: function(start) {
	      var range = this.sel.primary(), pos;
	      if (start == null || start == "head") { pos = range.head; }
	      else if (start == "anchor") { pos = range.anchor; }
	      else if (start == "end" || start == "to" || start === false) { pos = range.to(); }
	      else { pos = range.from(); }
	      return pos
	    },
	    listSelections: function() { return this.sel.ranges },
	    somethingSelected: function() {return this.sel.somethingSelected()},
	
	    setCursor: docMethodOp(function(line, ch, options) {
	      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
	    }),
	    setSelection: docMethodOp(function(anchor, head, options) {
	      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
	    }),
	    extendSelection: docMethodOp(function(head, other, options) {
	      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
	    }),
	    extendSelections: docMethodOp(function(heads, options) {
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    extendSelectionsBy: docMethodOp(function(f, options) {
	      var heads = map(this.sel.ranges, f);
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    setSelections: docMethodOp(function(ranges, primary, options) {
	      if (!ranges.length) { return }
	      var out = [];
	      for (var i = 0; i < ranges.length; i++)
	        { out[i] = new Range(clipPos(this, ranges[i].anchor),
	                           clipPos(this, ranges[i].head || ranges[i].anchor)); }
	      if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
	      setSelection(this, normalizeSelection(this.cm, out, primary), options);
	    }),
	    addSelection: docMethodOp(function(anchor, head, options) {
	      var ranges = this.sel.ranges.slice(0);
	      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
	      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
	    }),
	
	    getSelection: function(lineSep) {
	      var ranges = this.sel.ranges, lines;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        lines = lines ? lines.concat(sel) : sel;
	      }
	      if (lineSep === false) { return lines }
	      else { return lines.join(lineSep || this.lineSeparator()) }
	    },
	    getSelections: function(lineSep) {
	      var parts = [], ranges = this.sel.ranges;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        if (lineSep !== false) { sel = sel.join(lineSep || this.lineSeparator()); }
	        parts[i] = sel;
	      }
	      return parts
	    },
	    replaceSelection: function(code, collapse, origin) {
	      var dup = [];
	      for (var i = 0; i < this.sel.ranges.length; i++)
	        { dup[i] = code; }
	      this.replaceSelections(dup, collapse, origin || "+input");
	    },
	    replaceSelections: docMethodOp(function(code, collapse, origin) {
	      var changes = [], sel = this.sel;
	      for (var i = 0; i < sel.ranges.length; i++) {
	        var range = sel.ranges[i];
	        changes[i] = {from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin};
	      }
	      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
	      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
	        { makeChange(this, changes[i$1]); }
	      if (newSel) { setSelectionReplaceHistory(this, newSel); }
	      else if (this.cm) { ensureCursorVisible(this.cm); }
	    }),
	    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
	    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
	    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
	    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),
	
	    setExtending: function(val) {this.extend = val;},
	    getExtending: function() {return this.extend},
	
	    historySize: function() {
	      var hist = this.history, done = 0, undone = 0;
	      for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
	      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
	      return {undo: done, redo: undone}
	    },
	    clearHistory: function() {
	      var this$1 = this;
	
	      this.history = new History(this.history);
	      linkedDocs(this, function (doc) { return doc.history = this$1.history; }, true);
	    },
	
	    markClean: function() {
	      this.cleanGeneration = this.changeGeneration(true);
	    },
	    changeGeneration: function(forceSplit) {
	      if (forceSplit)
	        { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
	      return this.history.generation
	    },
	    isClean: function (gen) {
	      return this.history.generation == (gen || this.cleanGeneration)
	    },
	
	    getHistory: function() {
	      return {done: copyHistoryArray(this.history.done),
	              undone: copyHistoryArray(this.history.undone)}
	    },
	    setHistory: function(histData) {
	      var hist = this.history = new History(this.history);
	      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
	      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
	    },
	
	    setGutterMarker: docMethodOp(function(line, gutterID, value) {
	      return changeLine(this, line, "gutter", function (line) {
	        var markers = line.gutterMarkers || (line.gutterMarkers = {});
	        markers[gutterID] = value;
	        if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
	        return true
	      })
	    }),
	
	    clearGutter: docMethodOp(function(gutterID) {
	      var this$1 = this;
	
	      this.iter(function (line) {
	        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	          changeLine(this$1, line, "gutter", function () {
	            line.gutterMarkers[gutterID] = null;
	            if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
	            return true
	          });
	        }
	      });
	    }),
	
	    lineInfo: function(line) {
	      var n;
	      if (typeof line == "number") {
	        if (!isLine(this, line)) { return null }
	        n = line;
	        line = getLine(this, line);
	        if (!line) { return null }
	      } else {
	        n = lineNo(line);
	        if (n == null) { return null }
	      }
	      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	              widgets: line.widgets}
	    },
	
	    addLineClass: docMethodOp(function(handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass"
	                 : where == "background" ? "bgClass"
	                 : where == "gutter" ? "gutterClass" : "wrapClass";
	        if (!line[prop]) { line[prop] = cls; }
	        else if (classTest(cls).test(line[prop])) { return false }
	        else { line[prop] += " " + cls; }
	        return true
	      })
	    }),
	    removeLineClass: docMethodOp(function(handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass"
	                 : where == "background" ? "bgClass"
	                 : where == "gutter" ? "gutterClass" : "wrapClass";
	        var cur = line[prop];
	        if (!cur) { return false }
	        else if (cls == null) { line[prop] = null; }
	        else {
	          var found = cur.match(classTest(cls));
	          if (!found) { return false }
	          var end = found.index + found[0].length;
	          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
	        }
	        return true
	      })
	    }),
	
	    addLineWidget: docMethodOp(function(handle, node, options) {
	      return addLineWidget(this, handle, node, options)
	    }),
	    removeLineWidget: function(widget) { widget.clear(); },
	
	    markText: function(from, to, options) {
	      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
	    },
	    setBookmark: function(pos, options) {
	      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
	                      insertLeft: options && options.insertLeft,
	                      clearWhenEmpty: false, shared: options && options.shared,
	                      handleMouseEvents: options && options.handleMouseEvents};
	      pos = clipPos(this, pos);
	      return markText(this, pos, pos, realOpts, "bookmark")
	    },
	    findMarksAt: function(pos) {
	      pos = clipPos(this, pos);
	      var markers = [], spans = getLine(this, pos.line).markedSpans;
	      if (spans) { for (var i = 0; i < spans.length; ++i) {
	        var span = spans[i];
	        if ((span.from == null || span.from <= pos.ch) &&
	            (span.to == null || span.to >= pos.ch))
	          { markers.push(span.marker.parent || span.marker); }
	      } }
	      return markers
	    },
	    findMarks: function(from, to, filter) {
	      from = clipPos(this, from); to = clipPos(this, to);
	      var found = [], lineNo = from.line;
	      this.iter(from.line, to.line + 1, function (line) {
	        var spans = line.markedSpans;
	        if (spans) { for (var i = 0; i < spans.length; i++) {
	          var span = spans[i];
	          if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
	                span.from == null && lineNo != from.line ||
	                span.from != null && lineNo == to.line && span.from >= to.ch) &&
	              (!filter || filter(span.marker)))
	            { found.push(span.marker.parent || span.marker); }
	        } }
	        ++lineNo;
	      });
	      return found
	    },
	    getAllMarks: function() {
	      var markers = [];
	      this.iter(function (line) {
	        var sps = line.markedSpans;
	        if (sps) { for (var i = 0; i < sps.length; ++i)
	          { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
	      });
	      return markers
	    },
	
	    posFromIndex: function(off) {
	      var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
	      this.iter(function (line) {
	        var sz = line.text.length + sepSize;
	        if (sz > off) { ch = off; return true }
	        off -= sz;
	        ++lineNo;
	      });
	      return clipPos(this, Pos(lineNo, ch))
	    },
	    indexFromPos: function (coords) {
	      coords = clipPos(this, coords);
	      var index = coords.ch;
	      if (coords.line < this.first || coords.ch < 0) { return 0 }
	      var sepSize = this.lineSeparator().length;
	      this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
	        index += line.text.length + sepSize;
	      });
	      return index
	    },
	
	    copy: function(copyHistory) {
	      var doc = new Doc(getLines(this, this.first, this.first + this.size),
	                        this.modeOption, this.first, this.lineSep, this.direction);
	      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
	      doc.sel = this.sel;
	      doc.extend = false;
	      if (copyHistory) {
	        doc.history.undoDepth = this.history.undoDepth;
	        doc.setHistory(this.getHistory());
	      }
	      return doc
	    },
	
	    linkedDoc: function(options) {
	      if (!options) { options = {}; }
	      var from = this.first, to = this.first + this.size;
	      if (options.from != null && options.from > from) { from = options.from; }
	      if (options.to != null && options.to < to) { to = options.to; }
	      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
	      if (options.sharedHist) { copy.history = this.history
	      ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
	      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
	      copySharedMarkers(copy, findSharedMarkers(this));
	      return copy
	    },
	    unlinkDoc: function(other) {
	      if (other instanceof CodeMirror) { other = other.doc; }
	      if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
	        var link = this.linked[i];
	        if (link.doc != other) { continue }
	        this.linked.splice(i, 1);
	        other.unlinkDoc(this);
	        detachSharedMarkers(findSharedMarkers(this));
	        break
	      } }
	      // If the histories were shared, split them again
	      if (other.history == this.history) {
	        var splitIds = [other.id];
	        linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
	        other.history = new History(null);
	        other.history.done = copyHistoryArray(this.history.done, splitIds);
	        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
	      }
	    },
	    iterLinkedDocs: function(f) {linkedDocs(this, f);},
	
	    getMode: function() {return this.mode},
	    getEditor: function() {return this.cm},
	
	    splitLines: function(str) {
	      if (this.lineSep) { return str.split(this.lineSep) }
	      return splitLinesAuto(str)
	    },
	    lineSeparator: function() { return this.lineSep || "\n" },
	
	    setDirection: docMethodOp(function (dir) {
	      if (dir != "rtl") { dir = "ltr"; }
	      if (dir == this.direction) { return }
	      this.direction = dir;
	      this.iter(function (line) { return line.order = null; });
	      if (this.cm) { directionChanged(this.cm); }
	    })
	  });
	
	  // Public alias.
	  Doc.prototype.eachLine = Doc.prototype.iter;
	
	  // Kludge to work around strange IE behavior where it'll sometimes
	  // re-fire a series of drag-related events right after the drop (#1551)
	  var lastDrop = 0;
	
	  function onDrop(e) {
	    var cm = this;
	    clearDragCursor(cm);
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
	      { return }
	    e_preventDefault(e);
	    if (ie) { lastDrop = +new Date; }
	    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
	    if (!pos || cm.isReadOnly()) { return }
	    // Might be a file drop, in which case we simply extract the text
	    // and insert it.
	    if (files && files.length && window.FileReader && window.File) {
	      var n = files.length, text = Array(n), read = 0;
	      var markAsReadAndPasteIfAllFilesAreRead = function () {
	        if (++read == n) {
	          operation(cm, function () {
	            pos = clipPos(cm.doc, pos);
	            var change = {from: pos, to: pos,
	                          text: cm.doc.splitLines(
	                              text.filter(function (t) { return t != null; }).join(cm.doc.lineSeparator())),
	                          origin: "paste"};
	            makeChange(cm.doc, change);
	            setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
	          })();
	        }
	      };
	      var readTextFromFile = function (file, i) {
	        if (cm.options.allowDropFileTypes &&
	            indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
	          markAsReadAndPasteIfAllFilesAreRead();
	          return
	        }
	        var reader = new FileReader;
	        reader.onerror = function () { return markAsReadAndPasteIfAllFilesAreRead(); };
	        reader.onload = function () {
	          var content = reader.result;
	          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
	            markAsReadAndPasteIfAllFilesAreRead();
	            return
	          }
	          text[i] = content;
	          markAsReadAndPasteIfAllFilesAreRead();
	        };
	        reader.readAsText(file);
	      };
	      for (var i = 0; i < files.length; i++) { readTextFromFile(files[i], i); }
	    } else { // Normal drop
	      // Don't do a replace if the drop happened inside of the selected text.
	      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	        cm.state.draggingText(e);
	        // Ensure the editor is re-focused
	        setTimeout(function () { return cm.display.input.focus(); }, 20);
	        return
	      }
	      try {
	        var text$1 = e.dataTransfer.getData("Text");
	        if (text$1) {
	          var selected;
	          if (cm.state.draggingText && !cm.state.draggingText.copy)
	            { selected = cm.listSelections(); }
	          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
	          if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
	            { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
	          cm.replaceSelection(text$1, "around", "paste");
	          cm.display.input.focus();
	        }
	      }
	      catch(e$1){}
	    }
	  }
	
	  function onDragStart(cm, e) {
	    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }
	
	    e.dataTransfer.setData("Text", cm.getSelection());
	    e.dataTransfer.effectAllowed = "copyMove";
	
	    // Use dummy image instead of default browsers image.
	    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	    if (e.dataTransfer.setDragImage && !safari) {
	      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
	      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	      if (presto) {
	        img.width = img.height = 1;
	        cm.display.wrapper.appendChild(img);
	        // Force a relayout, or Opera won't use our image for some obscure reason
	        img._top = img.offsetTop;
	      }
	      e.dataTransfer.setDragImage(img, 0, 0);
	      if (presto) { img.parentNode.removeChild(img); }
	    }
	  }
	
	  function onDragOver(cm, e) {
	    var pos = posFromMouse(cm, e);
	    if (!pos) { return }
	    var frag = document.createDocumentFragment();
	    drawSelectionCursor(cm, pos, frag);
	    if (!cm.display.dragCursor) {
	      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
	      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
	    }
	    removeChildrenAndAdd(cm.display.dragCursor, frag);
	  }
	
	  function clearDragCursor(cm) {
	    if (cm.display.dragCursor) {
	      cm.display.lineSpace.removeChild(cm.display.dragCursor);
	      cm.display.dragCursor = null;
	    }
	  }
	
	  // These must be handled carefully, because naively registering a
	  // handler for each editor will cause the editors to never be
	  // garbage collected.
	
	  function forEachCodeMirror(f) {
	    if (!document.getElementsByClassName) { return }
	    var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
	    for (var i = 0; i < byClass.length; i++) {
	      var cm = byClass[i].CodeMirror;
	      if (cm) { editors.push(cm); }
	    }
	    if (editors.length) { editors[0].operation(function () {
	      for (var i = 0; i < editors.length; i++) { f(editors[i]); }
	    }); }
	  }
	
	  var globalsRegistered = false;
	  function ensureGlobalHandlers() {
	    if (globalsRegistered) { return }
	    registerGlobalHandlers();
	    globalsRegistered = true;
	  }
	  function registerGlobalHandlers() {
	    // When the window resizes, we need to refresh active editors.
	    var resizeTimer;
	    on(window, "resize", function () {
	      if (resizeTimer == null) { resizeTimer = setTimeout(function () {
	        resizeTimer = null;
	        forEachCodeMirror(onResize);
	      }, 100); }
	    });
	    // When the window loses focus, we want to show the editor as blurred
	    on(window, "blur", function () { return forEachCodeMirror(onBlur); });
	  }
	  // Called when the window resizes
	  function onResize(cm) {
	    var d = cm.display;
	    // Might be a text scaling operation, clear size caches.
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	    d.scrollbarsClipped = false;
	    cm.setSize();
	  }
	
	  var keyNames = {
	    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
	    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	    221: "]", 222: "'", 224: "Mod", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	  };
	
	  // Number keys
	  for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
	  // Alphabetic keys
	  for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
	  // Function keys
	  for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }
	
	  var keyMap = {};
	
	  keyMap.basic = {
	    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	    "Esc": "singleSelection"
	  };
	  // Note that the save and find-related commands aren't defined by
	  // default. User code or addons can define them. Unknown commands
	  // are simply ignored.
	  keyMap.pcDefault = {
	    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	    "fallthrough": "basic"
	  };
	  // Very basic readline/emacs-style bindings, which are standard on Mac.
	  keyMap.emacsy = {
	    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	    "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd", "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp",
	    "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine",
	    "Ctrl-T": "transposeChars", "Ctrl-O": "openLine"
	  };
	  keyMap.macDefault = {
	    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	    "fallthrough": ["basic", "emacsy"]
	  };
	  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
	
	  // KEYMAP DISPATCH
	
	  function normalizeKeyName(name) {
	    var parts = name.split(/-(?!$)/);
	    name = parts[parts.length - 1];
	    var alt, ctrl, shift, cmd;
	    for (var i = 0; i < parts.length - 1; i++) {
	      var mod = parts[i];
	      if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
	      else if (/^a(lt)?$/i.test(mod)) { alt = true; }
	      else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
	      else if (/^s(hift)?$/i.test(mod)) { shift = true; }
	      else { throw new Error("Unrecognized modifier name: " + mod) }
	    }
	    if (alt) { name = "Alt-" + name; }
	    if (ctrl) { name = "Ctrl-" + name; }
	    if (cmd) { name = "Cmd-" + name; }
	    if (shift) { name = "Shift-" + name; }
	    return name
	  }
	
	  // This is a kludge to keep keymaps mostly working as raw objects
	  // (backwards compatibility) while at the same time support features
	  // like normalization and multi-stroke key bindings. It compiles a
	  // new normalized keymap, and then updates the old object to reflect
	  // this.
	  function normalizeKeyMap(keymap) {
	    var copy = {};
	    for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
	      var value = keymap[keyname];
	      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
	      if (value == "...") { delete keymap[keyname]; continue }
	
	      var keys = map(keyname.split(" "), normalizeKeyName);
	      for (var i = 0; i < keys.length; i++) {
	        var val = (void 0), name = (void 0);
	        if (i == keys.length - 1) {
	          name = keys.join(" ");
	          val = value;
	        } else {
	          name = keys.slice(0, i + 1).join(" ");
	          val = "...";
	        }
	        var prev = copy[name];
	        if (!prev) { copy[name] = val; }
	        else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
	      }
	      delete keymap[keyname];
	    } }
	    for (var prop in copy) { keymap[prop] = copy[prop]; }
	    return keymap
	  }
	
	  function lookupKey(key, map, handle, context) {
	    map = getKeyMap(map);
	    var found = map.call ? map.call(key, context) : map[key];
	    if (found === false) { return "nothing" }
	    if (found === "...") { return "multi" }
	    if (found != null && handle(found)) { return "handled" }
	
	    if (map.fallthrough) {
	      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
	        { return lookupKey(key, map.fallthrough, handle, context) }
	      for (var i = 0; i < map.fallthrough.length; i++) {
	        var result = lookupKey(key, map.fallthrough[i], handle, context);
	        if (result) { return result }
	      }
	    }
	  }
	
	  // Modifier key presses don't count as 'real' key presses for the
	  // purpose of keymap fallthrough.
	  function isModifierKey(value) {
	    var name = typeof value == "string" ? value : keyNames[value.keyCode];
	    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
	  }
	
	  function addModifierNames(name, event, noShift) {
	    var base = name;
	    if (event.altKey && base != "Alt") { name = "Alt-" + name; }
	    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
	    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") { name = "Cmd-" + name; }
	    if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
	    return name
	  }
	
	  // Look up the name of a key as indicated by an event object.
	  function keyName(event, noShift) {
	    if (presto && event.keyCode == 34 && event["char"]) { return false }
	    var name = keyNames[event.keyCode];
	    if (name == null || event.altGraphKey) { return false }
	    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
	    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
	    if (event.keyCode == 3 && event.code) { name = event.code; }
	    return addModifierNames(name, event, noShift)
	  }
	
	  function getKeyMap(val) {
	    return typeof val == "string" ? keyMap[val] : val
	  }
	
	  // Helper for deleting text near the selection(s), used to implement
	  // backspace, delete, and similar functionality.
	  function deleteNearSelection(cm, compute) {
	    var ranges = cm.doc.sel.ranges, kill = [];
	    // Build up a set of ranges to kill first, merging overlapping
	    // ranges.
	    for (var i = 0; i < ranges.length; i++) {
	      var toKill = compute(ranges[i]);
	      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	        var replaced = kill.pop();
	        if (cmp(replaced.from, toKill.from) < 0) {
	          toKill.from = replaced.from;
	          break
	        }
	      }
	      kill.push(toKill);
	    }
	    // Next, remove those actual ranges.
	    runInOp(cm, function () {
	      for (var i = kill.length - 1; i >= 0; i--)
	        { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
	      ensureCursorVisible(cm);
	    });
	  }
	
	  function moveCharLogically(line, ch, dir) {
	    var target = skipExtendingChars(line.text, ch + dir, dir);
	    return target < 0 || target > line.text.length ? null : target
	  }
	
	  function moveLogically(line, start, dir) {
	    var ch = moveCharLogically(line, start.ch, dir);
	    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
	  }
	
	  function endOfLine(visually, cm, lineObj, lineNo, dir) {
	    if (visually) {
	      if (cm.doc.direction == "rtl") { dir = -dir; }
	      var order = getOrder(lineObj, cm.doc.direction);
	      if (order) {
	        var part = dir < 0 ? lst(order) : order[0];
	        var moveInStorageOrder = (dir < 0) == (part.level == 1);
	        var sticky = moveInStorageOrder ? "after" : "before";
	        var ch;
	        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
	        // it could be that the last bidi part is not on the last visual line,
	        // since visual lines contain content order-consecutive chunks.
	        // Thus, in rtl, we are looking for the first (content-order) character
	        // in the rtl chunk that is on the last line (that is, the same line
	        // as the last (content-order) character).
	        if (part.level > 0 || cm.doc.direction == "rtl") {
	          var prep = prepareMeasureForLine(cm, lineObj);
	          ch = dir < 0 ? lineObj.text.length - 1 : 0;
	          var targetTop = measureCharPrepared(cm, prep, ch).top;
	          ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
	          if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
	        } else { ch = dir < 0 ? part.to : part.from; }
	        return new Pos(lineNo, ch, sticky)
	      }
	    }
	    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
	  }
	
	  function moveVisually(cm, line, start, dir) {
	    var bidi = getOrder(line, cm.doc.direction);
	    if (!bidi) { return moveLogically(line, start, dir) }
	    if (start.ch >= line.text.length) {
	      start.ch = line.text.length;
	      start.sticky = "before";
	    } else if (start.ch <= 0) {
	      start.ch = 0;
	      start.sticky = "after";
	    }
	    var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
	    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
	      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
	      // nothing interesting happens.
	      return moveLogically(line, start, dir)
	    }
	
	    var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
	    var prep;
	    var getWrappedLineExtent = function (ch) {
	      if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
	      prep = prep || prepareMeasureForLine(cm, line);
	      return wrappedLineExtentChar(cm, line, prep, ch)
	    };
	    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
	
	    if (cm.doc.direction == "rtl" || part.level == 1) {
	      var moveInStorageOrder = (part.level == 1) == (dir < 0);
	      var ch = mv(start, moveInStorageOrder ? 1 : -1);
	      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
	        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
	        var sticky = moveInStorageOrder ? "before" : "after";
	        return new Pos(start.line, ch, sticky)
	      }
	    }
	
	    // Case 3: Could not move within this bidi part in this visual line, so leave
	    // the current bidi part
	
	    var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
	      var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
	        ? new Pos(start.line, mv(ch, 1), "before")
	        : new Pos(start.line, ch, "after"); };
	
	      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
	        var part = bidi[partPos];
	        var moveInStorageOrder = (dir > 0) == (part.level != 1);
	        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
	        if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
	        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
	        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
	      }
	    };
	
	    // Case 3a: Look for other bidi parts on the same visual line
	    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
	    if (res) { return res }
	
	    // Case 3b: Look for other bidi parts on the next visual line
	    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
	    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
	      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
	      if (res) { return res }
	    }
	
	    // Case 4: Nowhere to move
	    return null
	  }
	
	  // Commands are parameter-less actions that can be performed on an
	  // editor, mostly used for keybindings.
	  var commands = {
	    selectAll: selectAll,
	    singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
	    killLine: function (cm) { return deleteNearSelection(cm, function (range) {
	      if (range.empty()) {
	        var len = getLine(cm.doc, range.head.line).text.length;
	        if (range.head.ch == len && range.head.line < cm.lastLine())
	          { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
	        else
	          { return {from: range.head, to: Pos(range.head.line, len)} }
	      } else {
	        return {from: range.from(), to: range.to()}
	      }
	    }); },
	    deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	      from: Pos(range.from().line, 0),
	      to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
	    }); }); },
	    delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	      from: Pos(range.from().line, 0), to: range.from()
	    }); }); },
	    delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
	      var top = cm.charCoords(range.head, "div").top + 5;
	      var leftPos = cm.coordsChar({left: 0, top: top}, "div");
	      return {from: leftPos, to: range.from()}
	    }); },
	    delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
	      var top = cm.charCoords(range.head, "div").top + 5;
	      var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
	      return {from: range.from(), to: rightPos }
	    }); },
	    undo: function (cm) { return cm.undo(); },
	    redo: function (cm) { return cm.redo(); },
	    undoSelection: function (cm) { return cm.undoSelection(); },
	    redoSelection: function (cm) { return cm.redoSelection(); },
	    goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
	    goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
	    goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
	      {origin: "+move", bias: 1}
	    ); },
	    goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
	      {origin: "+move", bias: 1}
	    ); },
	    goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
	      {origin: "+move", bias: -1}
	    ); },
	    goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
	    }, sel_move); },
	    goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      return cm.coordsChar({left: 0, top: top}, "div")
	    }, sel_move); },
	    goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      var pos = cm.coordsChar({left: 0, top: top}, "div");
	      if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
	      return pos
	    }, sel_move); },
	    goLineUp: function (cm) { return cm.moveV(-1, "line"); },
	    goLineDown: function (cm) { return cm.moveV(1, "line"); },
	    goPageUp: function (cm) { return cm.moveV(-1, "page"); },
	    goPageDown: function (cm) { return cm.moveV(1, "page"); },
	    goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
	    goCharRight: function (cm) { return cm.moveH(1, "char"); },
	    goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
	    goColumnRight: function (cm) { return cm.moveH(1, "column"); },
	    goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
	    goGroupRight: function (cm) { return cm.moveH(1, "group"); },
	    goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
	    goWordRight: function (cm) { return cm.moveH(1, "word"); },
	    delCharBefore: function (cm) { return cm.deleteH(-1, "codepoint"); },
	    delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
	    delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
	    delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
	    delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
	    delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
	    indentAuto: function (cm) { return cm.indentSelection("smart"); },
	    indentMore: function (cm) { return cm.indentSelection("add"); },
	    indentLess: function (cm) { return cm.indentSelection("subtract"); },
	    insertTab: function (cm) { return cm.replaceSelection("\t"); },
	    insertSoftTab: function (cm) {
	      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
	      for (var i = 0; i < ranges.length; i++) {
	        var pos = ranges[i].from();
	        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
	        spaces.push(spaceStr(tabSize - col % tabSize));
	      }
	      cm.replaceSelections(spaces);
	    },
	    defaultTab: function (cm) {
	      if (cm.somethingSelected()) { cm.indentSelection("add"); }
	      else { cm.execCommand("insertTab"); }
	    },
	    // Swap the two chars left and right of each selection's head.
	    // Move cursor behind the two swapped characters afterwards.
	    //
	    // Doesn't consider line feeds a character.
	    // Doesn't scan more than one line above to find a character.
	    // Doesn't do anything on an empty line.
	    // Doesn't do anything with non-empty selections.
	    transposeChars: function (cm) { return runInOp(cm, function () {
	      var ranges = cm.listSelections(), newSel = [];
	      for (var i = 0; i < ranges.length; i++) {
	        if (!ranges[i].empty()) { continue }
	        var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
	        if (line) {
	          if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
	          if (cur.ch > 0) {
	            cur = new Pos(cur.line, cur.ch + 1);
	            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
	                            Pos(cur.line, cur.ch - 2), cur, "+transpose");
	          } else if (cur.line > cm.doc.first) {
	            var prev = getLine(cm.doc, cur.line - 1).text;
	            if (prev) {
	              cur = new Pos(cur.line, 1);
	              cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
	                              prev.charAt(prev.length - 1),
	                              Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
	            }
	          }
	        }
	        newSel.push(new Range(cur, cur));
	      }
	      cm.setSelections(newSel);
	    }); },
	    newlineAndIndent: function (cm) { return runInOp(cm, function () {
	      var sels = cm.listSelections();
	      for (var i = sels.length - 1; i >= 0; i--)
	        { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
	      sels = cm.listSelections();
	      for (var i$1 = 0; i$1 < sels.length; i$1++)
	        { cm.indentLine(sels[i$1].from().line, null, true); }
	      ensureCursorVisible(cm);
	    }); },
	    openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
	    toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
	  };
	
	
	  function lineStart(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLine(line);
	    if (visual != line) { lineN = lineNo(visual); }
	    return endOfLine(true, cm, visual, lineN, 1)
	  }
	  function lineEnd(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLineEnd(line);
	    if (visual != line) { lineN = lineNo(visual); }
	    return endOfLine(true, cm, line, lineN, -1)
	  }
	  function lineStartSmart(cm, pos) {
	    var start = lineStart(cm, pos.line);
	    var line = getLine(cm.doc, start.line);
	    var order = getOrder(line, cm.doc.direction);
	    if (!order || order[0].level == 0) {
	      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
	      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
	      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
	    }
	    return start
	  }
	
	  // Run a handler that was bound to a key.
	  function doHandleBinding(cm, bound, dropShift) {
	    if (typeof bound == "string") {
	      bound = commands[bound];
	      if (!bound) { return false }
	    }
	    // Ensure previous input has been read, so that the handler sees a
	    // consistent view of the document
	    cm.display.input.ensurePolled();
	    var prevShift = cm.display.shift, done = false;
	    try {
	      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
	      if (dropShift) { cm.display.shift = false; }
	      done = bound(cm) != Pass;
	    } finally {
	      cm.display.shift = prevShift;
	      cm.state.suppressEdits = false;
	    }
	    return done
	  }
	
	  function lookupKeyForEditor(cm, name, handle) {
	    for (var i = 0; i < cm.state.keyMaps.length; i++) {
	      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
	      if (result) { return result }
	    }
	    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
	      || lookupKey(name, cm.options.keyMap, handle, cm)
	  }
	
	  // Note that, despite the name, this function is also used to check
	  // for bound mouse clicks.
	
	  var stopSeq = new Delayed;
	
	  function dispatchKey(cm, name, e, handle) {
	    var seq = cm.state.keySeq;
	    if (seq) {
	      if (isModifierKey(name)) { return "handled" }
	      if (/\'$/.test(name))
	        { cm.state.keySeq = null; }
	      else
	        { stopSeq.set(50, function () {
	          if (cm.state.keySeq == seq) {
	            cm.state.keySeq = null;
	            cm.display.input.reset();
	          }
	        }); }
	      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
	    }
	    return dispatchKeyInner(cm, name, e, handle)
	  }
	
	  function dispatchKeyInner(cm, name, e, handle) {
	    var result = lookupKeyForEditor(cm, name, handle);
	
	    if (result == "multi")
	      { cm.state.keySeq = name; }
	    if (result == "handled")
	      { signalLater(cm, "keyHandled", cm, name, e); }
	
	    if (result == "handled" || result == "multi") {
	      e_preventDefault(e);
	      restartBlink(cm);
	    }
	
	    return !!result
	  }
	
	  // Handle a key from the keydown event.
	  function handleKeyBinding(cm, e) {
	    var name = keyName(e, true);
	    if (!name) { return false }
	
	    if (e.shiftKey && !cm.state.keySeq) {
	      // First try to resolve full name (including 'Shift-'). Failing
	      // that, see if there is a cursor-motion command (starting with
	      // 'go') bound to the keyname without 'Shift-'.
	      return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
	          || dispatchKey(cm, name, e, function (b) {
	               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
	                 { return doHandleBinding(cm, b) }
	             })
	    } else {
	      return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
	    }
	  }
	
	  // Handle a key from the keypress event
	  function handleCharBinding(cm, e, ch) {
	    return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
	  }
	
	  var lastStoppedKey = null;
	  function onKeyDown(e) {
	    var cm = this;
	    if (e.target && e.target != cm.display.input.getField()) { return }
	    cm.curOp.focus = activeElt(root(cm));
	    if (signalDOMEvent(cm, e)) { return }
	    // IE does strange things with escape.
	    if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
	    var code = e.keyCode;
	    cm.display.shift = code == 16 || e.shiftKey;
	    var handled = handleKeyBinding(cm, e);
	    if (presto) {
	      lastStoppedKey = handled ? code : null;
	      // Opera has no cut event... we try to at least catch the key combo
	      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
	        { cm.replaceSelection("", null, "cut"); }
	    }
	    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand)
	      { document.execCommand("cut"); }
	
	    // Turn mouse into crosshair when Alt is held on Mac.
	    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
	      { showCrossHair(cm); }
	  }
	
	  function showCrossHair(cm) {
	    var lineDiv = cm.display.lineDiv;
	    addClass(lineDiv, "CodeMirror-crosshair");
	
	    function up(e) {
	      if (e.keyCode == 18 || !e.altKey) {
	        rmClass(lineDiv, "CodeMirror-crosshair");
	        off(document, "keyup", up);
	        off(document, "mouseover", up);
	      }
	    }
	    on(document, "keyup", up);
	    on(document, "mouseover", up);
	  }
	
	  function onKeyUp(e) {
	    if (e.keyCode == 16) { this.doc.sel.shift = false; }
	    signalDOMEvent(this, e);
	  }
	
	  function onKeyPress(e) {
	    var cm = this;
	    if (e.target && e.target != cm.display.input.getField()) { return }
	    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
	    var keyCode = e.keyCode, charCode = e.charCode;
	    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
	    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
	    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
	    // Some browsers fire keypress events for backspace
	    if (ch == "\x08") { return }
	    if (handleCharBinding(cm, e, ch)) { return }
	    cm.display.input.onKeyPress(e);
	  }
	
	  var DOUBLECLICK_DELAY = 400;
	
	  var PastClick = function(time, pos, button) {
	    this.time = time;
	    this.pos = pos;
	    this.button = button;
	  };
	
	  PastClick.prototype.compare = function (time, pos, button) {
	    return this.time + DOUBLECLICK_DELAY > time &&
	      cmp(pos, this.pos) == 0 && button == this.button
	  };
	
	  var lastClick, lastDoubleClick;
	  function clickRepeat(pos, button) {
	    var now = +new Date;
	    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
	      lastClick = lastDoubleClick = null;
	      return "triple"
	    } else if (lastClick && lastClick.compare(now, pos, button)) {
	      lastDoubleClick = new PastClick(now, pos, button);
	      lastClick = null;
	      return "double"
	    } else {
	      lastClick = new PastClick(now, pos, button);
	      lastDoubleClick = null;
	      return "single"
	    }
	  }
	
	  // A mouse down can be a single click, double click, triple click,
	  // start of selection drag, start of text drag, new cursor
	  // (ctrl-click), rectangle drag (alt-drag), or xwin
	  // middle-click-paste. Or it might be a click on something we should
	  // not interfere with, such as a scrollbar or widget.
	  function onMouseDown(e) {
	    var cm = this, display = cm.display;
	    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
	    display.input.ensurePolled();
	    display.shift = e.shiftKey;
	
	    if (eventInWidget(display, e)) {
	      if (!webkit) {
	        // Briefly turn off draggability, to allow widgets to do
	        // normal dragging things.
	        display.scroller.draggable = false;
	        setTimeout(function () { return display.scroller.draggable = true; }, 100);
	      }
	      return
	    }
	    if (clickInGutter(cm, e)) { return }
	    var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
	    win(cm).focus();
	
	    // #3261: make sure, that we're not starting a second selection
	    if (button == 1 && cm.state.selectingText)
	      { cm.state.selectingText(e); }
	
	    if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }
	
	    if (button == 1) {
	      if (pos) { leftButtonDown(cm, pos, repeat, e); }
	      else if (e_target(e) == display.scroller) { e_preventDefault(e); }
	    } else if (button == 2) {
	      if (pos) { extendSelection(cm.doc, pos); }
	      setTimeout(function () { return display.input.focus(); }, 20);
	    } else if (button == 3) {
	      if (captureRightClick) { cm.display.input.onContextMenu(e); }
	      else { delayBlurEvent(cm); }
	    }
	  }
	
	  function handleMappedButton(cm, button, pos, repeat, event) {
	    var name = "Click";
	    if (repeat == "double") { name = "Double" + name; }
	    else if (repeat == "triple") { name = "Triple" + name; }
	    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
	
	    return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
	      if (typeof bound == "string") { bound = commands[bound]; }
	      if (!bound) { return false }
	      var done = false;
	      try {
	        if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
	        done = bound(cm, pos) != Pass;
	      } finally {
	        cm.state.suppressEdits = false;
	      }
	      return done
	    })
	  }
	
	  function configureMouse(cm, repeat, event) {
	    var option = cm.getOption("configureMouse");
	    var value = option ? option(cm, repeat, event) : {};
	    if (value.unit == null) {
	      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
	      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
	    }
	    if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
	    if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
	    if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
	    return value
	  }
	
	  function leftButtonDown(cm, pos, repeat, event) {
	    if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
	    else { cm.curOp.focus = activeElt(root(cm)); }
	
	    var behavior = configureMouse(cm, repeat, event);
	
	    var sel = cm.doc.sel, contained;
	    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
	        repeat == "single" && (contained = sel.contains(pos)) > -1 &&
	        (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
	        (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
	      { leftButtonStartDrag(cm, event, pos, behavior); }
	    else
	      { leftButtonSelect(cm, event, pos, behavior); }
	  }
	
	  // Start a text drag. When it ends, see if any dragging actually
	  // happen, and treat as a click if it didn't.
	  function leftButtonStartDrag(cm, event, pos, behavior) {
	    var display = cm.display, moved = false;
	    var dragEnd = operation(cm, function (e) {
	      if (webkit) { display.scroller.draggable = false; }
	      cm.state.draggingText = false;
	      if (cm.state.delayingBlurEvent) {
	        if (cm.hasFocus()) { cm.state.delayingBlurEvent = false; }
	        else { delayBlurEvent(cm); }
	      }
	      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
	      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
	      off(display.scroller, "dragstart", dragStart);
	      off(display.scroller, "drop", dragEnd);
	      if (!moved) {
	        e_preventDefault(e);
	        if (!behavior.addNew)
	          { extendSelection(cm.doc, pos, null, null, behavior.extend); }
	        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	        if ((webkit && !safari) || ie && ie_version == 9)
	          { setTimeout(function () {display.wrapper.ownerDocument.body.focus({preventScroll: true}); display.input.focus();}, 20); }
	        else
	          { display.input.focus(); }
	      }
	    });
	    var mouseMove = function(e2) {
	      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
	    };
	    var dragStart = function () { return moved = true; };
	    // Let the drag handler handle this.
	    if (webkit) { display.scroller.draggable = true; }
	    cm.state.draggingText = dragEnd;
	    dragEnd.copy = !behavior.moveOnDrag;
	    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
	    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
	    on(display.scroller, "dragstart", dragStart);
	    on(display.scroller, "drop", dragEnd);
	
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () { return display.input.focus(); }, 20);
	    // IE's approach to draggable
	    if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
	  }
	
	  function rangeForUnit(cm, pos, unit) {
	    if (unit == "char") { return new Range(pos, pos) }
	    if (unit == "word") { return cm.findWordAt(pos) }
	    if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
	    var result = unit(cm, pos);
	    return new Range(result.from, result.to)
	  }
	
	  // Normal selection, as opposed to text dragging.
	  function leftButtonSelect(cm, event, start, behavior) {
	    if (ie) { delayBlurEvent(cm); }
	    var display = cm.display, doc = cm.doc;
	    e_preventDefault(event);
	
	    var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
	    if (behavior.addNew && !behavior.extend) {
	      ourIndex = doc.sel.contains(start);
	      if (ourIndex > -1)
	        { ourRange = ranges[ourIndex]; }
	      else
	        { ourRange = new Range(start, start); }
	    } else {
	      ourRange = doc.sel.primary();
	      ourIndex = doc.sel.primIndex;
	    }
	
	    if (behavior.unit == "rectangle") {
	      if (!behavior.addNew) { ourRange = new Range(start, start); }
	      start = posFromMouse(cm, event, true, true);
	      ourIndex = -1;
	    } else {
	      var range = rangeForUnit(cm, start, behavior.unit);
	      if (behavior.extend)
	        { ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend); }
	      else
	        { ourRange = range; }
	    }
	
	    if (!behavior.addNew) {
	      ourIndex = 0;
	      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
	      startSel = doc.sel;
	    } else if (ourIndex == -1) {
	      ourIndex = ranges.length;
	      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
	                   {scroll: false, origin: "*mouse"});
	    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
	      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
	                   {scroll: false, origin: "*mouse"});
	      startSel = doc.sel;
	    } else {
	      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
	    }
	
	    var lastPos = start;
	    function extendTo(pos) {
	      if (cmp(lastPos, pos) == 0) { return }
	      lastPos = pos;
	
	      if (behavior.unit == "rectangle") {
	        var ranges = [], tabSize = cm.options.tabSize;
	        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
	        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
	        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
	        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
	             line <= end; line++) {
	          var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
	          if (left == right)
	            { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
	          else if (text.length > leftPos)
	            { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
	        }
	        if (!ranges.length) { ranges.push(new Range(start, start)); }
	        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
	                     {origin: "*mouse", scroll: false});
	        cm.scrollIntoView(pos);
	      } else {
	        var oldRange = ourRange;
	        var range = rangeForUnit(cm, pos, behavior.unit);
	        var anchor = oldRange.anchor, head;
	        if (cmp(range.anchor, anchor) > 0) {
	          head = range.head;
	          anchor = minPos(oldRange.from(), range.anchor);
	        } else {
	          head = range.anchor;
	          anchor = maxPos(oldRange.to(), range.head);
	        }
	        var ranges$1 = startSel.ranges.slice(0);
	        ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
	        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
	      }
	    }
	
	    var editorSize = display.wrapper.getBoundingClientRect();
	    // Used to ensure timeout re-tries don't fire when another extend
	    // happened in the meantime (clearTimeout isn't reliable -- at
	    // least on Chrome, the timeouts still happen even when cleared,
	    // if the clear happens after their scheduled firing time).
	    var counter = 0;
	
	    function extend(e) {
	      var curCount = ++counter;
	      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
	      if (!cur) { return }
	      if (cmp(cur, lastPos) != 0) {
	        cm.curOp.focus = activeElt(root(cm));
	        extendTo(cur);
	        var visible = visibleLines(display, doc);
	        if (cur.line >= visible.to || cur.line < visible.from)
	          { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
	      } else {
	        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
	        if (outside) { setTimeout(operation(cm, function () {
	          if (counter != curCount) { return }
	          display.scroller.scrollTop += outside;
	          extend(e);
	        }), 50); }
	      }
	    }
	
	    function done(e) {
	      cm.state.selectingText = false;
	      counter = Infinity;
	      // If e is null or undefined we interpret this as someone trying
	      // to explicitly cancel the selection rather than the user
	      // letting go of the mouse button.
	      if (e) {
	        e_preventDefault(e);
	        display.input.focus();
	      }
	      off(display.wrapper.ownerDocument, "mousemove", move);
	      off(display.wrapper.ownerDocument, "mouseup", up);
	      doc.history.lastSelOrigin = null;
	    }
	
	    var move = operation(cm, function (e) {
	      if (e.buttons === 0 || !e_button(e)) { done(e); }
	      else { extend(e); }
	    });
	    var up = operation(cm, done);
	    cm.state.selectingText = up;
	    on(display.wrapper.ownerDocument, "mousemove", move);
	    on(display.wrapper.ownerDocument, "mouseup", up);
	  }
	
	  // Used when mouse-selecting to adjust the anchor to the proper side
	  // of a bidi jump depending on the visual position of the head.
	  function bidiSimplify(cm, range) {
	    var anchor = range.anchor;
	    var head = range.head;
	    var anchorLine = getLine(cm.doc, anchor.line);
	    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range }
	    var order = getOrder(anchorLine);
	    if (!order) { return range }
	    var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
	    if (part.from != anchor.ch && part.to != anchor.ch) { return range }
	    var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
	    if (boundary == 0 || boundary == order.length) { return range }
	
	    // Compute the relative visual position of the head compared to the
	    // anchor (<0 is to the left, >0 to the right)
	    var leftSide;
	    if (head.line != anchor.line) {
	      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
	    } else {
	      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
	      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
	      if (headIndex == boundary - 1 || headIndex == boundary)
	        { leftSide = dir < 0; }
	      else
	        { leftSide = dir > 0; }
	    }
	
	    var usePart = order[boundary + (leftSide ? -1 : 0)];
	    var from = leftSide == (usePart.level == 1);
	    var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
	    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head)
	  }
	
	
	  // Determines whether an event happened in the gutter, and fires the
	  // handlers for the corresponding event.
	  function gutterEvent(cm, e, type, prevent) {
	    var mX, mY;
	    if (e.touches) {
	      mX = e.touches[0].clientX;
	      mY = e.touches[0].clientY;
	    } else {
	      try { mX = e.clientX; mY = e.clientY; }
	      catch(e$1) { return false }
	    }
	    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
	    if (prevent) { e_preventDefault(e); }
	
	    var display = cm.display;
	    var lineBox = display.lineDiv.getBoundingClientRect();
	
	    if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
	    mY -= lineBox.top - display.viewOffset;
	
	    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
	      var g = display.gutters.childNodes[i];
	      if (g && g.getBoundingClientRect().right >= mX) {
	        var line = lineAtHeight(cm.doc, mY);
	        var gutter = cm.display.gutterSpecs[i];
	        signal(cm, type, cm, line, gutter.className, e);
	        return e_defaultPrevented(e)
	      }
	    }
	  }
	
	  function clickInGutter(cm, e) {
	    return gutterEvent(cm, e, "gutterClick", true)
	  }
	
	  // CONTEXT MENU HANDLING
	
	  // To make the context menu work, we need to briefly unhide the
	  // textarea (making it as unobtrusive as possible) to let the
	  // right-click take effect on it.
	  function onContextMenu(cm, e) {
	    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
	    if (signalDOMEvent(cm, e, "contextmenu")) { return }
	    if (!captureRightClick) { cm.display.input.onContextMenu(e); }
	  }
	
	  function contextMenuInGutter(cm, e) {
	    if (!hasHandler(cm, "gutterContextMenu")) { return false }
	    return gutterEvent(cm, e, "gutterContextMenu", false)
	  }
	
	  function themeChanged(cm) {
	    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
	      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
	    clearCaches(cm);
	  }
	
	  var Init = {toString: function(){return "CodeMirror.Init"}};
	
	  var defaults = {};
	  var optionHandlers = {};
	
	  function defineOptions(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    function option(name, deflt, handle, notOnInit) {
	      CodeMirror.defaults[name] = deflt;
	      if (handle) { optionHandlers[name] =
	        notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
	    }
	
	    CodeMirror.defineOption = option;
	
	    // Passed to option handlers when there is no old value.
	    CodeMirror.Init = Init;
	
	    // These two are, on init, called from the constructor because they
	    // have to be initialized before the editor can start at all.
	    option("value", "", function (cm, val) { return cm.setValue(val); }, true);
	    option("mode", null, function (cm, val) {
	      cm.doc.modeOption = val;
	      loadMode(cm);
	    }, true);
	
	    option("indentUnit", 2, loadMode, true);
	    option("indentWithTabs", false);
	    option("smartIndent", true);
	    option("tabSize", 4, function (cm) {
	      resetModeState(cm);
	      clearCaches(cm);
	      regChange(cm);
	    }, true);
	
	    option("lineSeparator", null, function (cm, val) {
	      cm.doc.lineSep = val;
	      if (!val) { return }
	      var newBreaks = [], lineNo = cm.doc.first;
	      cm.doc.iter(function (line) {
	        for (var pos = 0;;) {
	          var found = line.text.indexOf(val, pos);
	          if (found == -1) { break }
	          pos = found + val.length;
	          newBreaks.push(Pos(lineNo, found));
	        }
	        lineNo++;
	      });
	      for (var i = newBreaks.length - 1; i >= 0; i--)
	        { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
	    });
	    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
	      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
	      if (old != Init) { cm.refresh(); }
	    });
	    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
	    option("electricChars", true);
	    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
	      throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
	    }, true);
	    option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
	    option("autocorrect", false, function (cm, val) { return cm.getInputField().autocorrect = val; }, true);
	    option("autocapitalize", false, function (cm, val) { return cm.getInputField().autocapitalize = val; }, true);
	    option("rtlMoveVisually", !windows);
	    option("wholeLineUpdateBefore", true);
	
	    option("theme", "default", function (cm) {
	      themeChanged(cm);
	      updateGutters(cm);
	    }, true);
	    option("keyMap", "default", function (cm, val, old) {
	      var next = getKeyMap(val);
	      var prev = old != Init && getKeyMap(old);
	      if (prev && prev.detach) { prev.detach(cm, next); }
	      if (next.attach) { next.attach(cm, prev || null); }
	    });
	    option("extraKeys", null);
	    option("configureMouse", null);
	
	    option("lineWrapping", false, wrappingChanged, true);
	    option("gutters", [], function (cm, val) {
	      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
	      updateGutters(cm);
	    }, true);
	    option("fixedGutter", true, function (cm, val) {
	      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
	      cm.refresh();
	    }, true);
	    option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
	    option("scrollbarStyle", "native", function (cm) {
	      initScrollbars(cm);
	      updateScrollbars(cm);
	      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
	      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
	    }, true);
	    option("lineNumbers", false, function (cm, val) {
	      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
	      updateGutters(cm);
	    }, true);
	    option("firstLineNumber", 1, updateGutters, true);
	    option("lineNumberFormatter", function (integer) { return integer; }, updateGutters, true);
	    option("showCursorWhenSelecting", false, updateSelection, true);
	
	    option("resetSelectionOnContextMenu", true);
	    option("lineWiseCopyCut", true);
	    option("pasteLinesPerSelection", true);
	    option("selectionsMayTouch", false);
	
	    option("readOnly", false, function (cm, val) {
	      if (val == "nocursor") {
	        onBlur(cm);
	        cm.display.input.blur();
	      }
	      cm.display.input.readOnlyChanged(val);
	    });
	
	    option("screenReaderLabel", null, function (cm, val) {
	      val = (val === '') ? null : val;
	      cm.display.input.screenReaderLabelChanged(val);
	    });
	
	    option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
	    option("dragDrop", true, dragDropChanged);
	    option("allowDropFileTypes", null);
	
	    option("cursorBlinkRate", 530);
	    option("cursorScrollMargin", 0);
	    option("cursorHeight", 1, updateSelection, true);
	    option("singleCursorHeightPerLine", true, updateSelection, true);
	    option("workTime", 100);
	    option("workDelay", 100);
	    option("flattenSpans", true, resetModeState, true);
	    option("addModeClass", false, resetModeState, true);
	    option("pollInterval", 100);
	    option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
	    option("historyEventDelay", 1250);
	    option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
	    option("maxHighlightLength", 10000, resetModeState, true);
	    option("moveInputWithCursor", true, function (cm, val) {
	      if (!val) { cm.display.input.resetPosition(); }
	    });
	
	    option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
	    option("autofocus", null);
	    option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
	    option("phrases", null);
	  }
	
	  function dragDropChanged(cm, value, old) {
	    var wasOn = old && old != Init;
	    if (!value != !wasOn) {
	      var funcs = cm.display.dragFunctions;
	      var toggle = value ? on : off;
	      toggle(cm.display.scroller, "dragstart", funcs.start);
	      toggle(cm.display.scroller, "dragenter", funcs.enter);
	      toggle(cm.display.scroller, "dragover", funcs.over);
	      toggle(cm.display.scroller, "dragleave", funcs.leave);
	      toggle(cm.display.scroller, "drop", funcs.drop);
	    }
	  }
	
	  function wrappingChanged(cm) {
	    if (cm.options.lineWrapping) {
	      addClass(cm.display.wrapper, "CodeMirror-wrap");
	      cm.display.sizer.style.minWidth = "";
	      cm.display.sizerWidth = null;
	    } else {
	      rmClass(cm.display.wrapper, "CodeMirror-wrap");
	      findMaxLine(cm);
	    }
	    estimateLineHeights(cm);
	    regChange(cm);
	    clearCaches(cm);
	    setTimeout(function () { return updateScrollbars(cm); }, 100);
	  }
	
	  // A CodeMirror instance represents an editor. This is the object
	  // that user code is usually dealing with.
	
	  function CodeMirror(place, options) {
	    var this$1 = this;
	
	    if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }
	
	    this.options = options = options ? copyObj(options) : {};
	    // Determine effective options based on given values and defaults.
	    copyObj(defaults, options, false);
	
	    var doc = options.value;
	    if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
	    else if (options.mode) { doc.modeOption = options.mode; }
	    this.doc = doc;
	
	    var input = new CodeMirror.inputStyles[options.inputStyle](this);
	    var display = this.display = new Display(place, doc, input, options);
	    display.wrapper.CodeMirror = this;
	    themeChanged(this);
	    if (options.lineWrapping)
	      { this.display.wrapper.className += " CodeMirror-wrap"; }
	    initScrollbars(this);
	
	    this.state = {
	      keyMaps: [],  // stores maps added by addKeyMap
	      overlays: [], // highlighting overlays, as added by addOverlay
	      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
	      overwrite: false,
	      delayingBlurEvent: false,
	      focused: false,
	      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
	      selectingText: false,
	      draggingText: false,
	      highlight: new Delayed(), // stores highlight worker timeout
	      keySeq: null,  // Unfinished key sequence
	      specialChars: null
	    };
	
	    if (options.autofocus && !mobile) { display.input.focus(); }
	
	    // Override magic textarea content restore that IE sometimes does
	    // on our hidden textarea on reload
	    if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }
	
	    registerEventHandlers(this);
	    ensureGlobalHandlers();
	
	    startOperation(this);
	    this.curOp.forceUpdate = true;
	    attachDoc(this, doc);
	
	    if ((options.autofocus && !mobile) || this.hasFocus())
	      { setTimeout(function () {
	        if (this$1.hasFocus() && !this$1.state.focused) { onFocus(this$1); }
	      }, 20); }
	    else
	      { onBlur(this); }
	
	    for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
	      { optionHandlers[opt](this, options[opt], Init); } }
	    maybeUpdateLineNumberWidth(this);
	    if (options.finishInit) { options.finishInit(this); }
	    for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this); }
	    endOperation(this);
	    // Suppress optimizelegibility in Webkit, since it breaks text
	    // measuring on line wrapping boundaries.
	    if (webkit && options.lineWrapping &&
	        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
	      { display.lineDiv.style.textRendering = "auto"; }
	  }
	
	  // The default configuration options.
	  CodeMirror.defaults = defaults;
	  // Functions to run when options are changed.
	  CodeMirror.optionHandlers = optionHandlers;
	
	  // Attach the necessary event handlers when initializing the editor
	  function registerEventHandlers(cm) {
	    var d = cm.display;
	    on(d.scroller, "mousedown", operation(cm, onMouseDown));
	    // Older IE's will not fire a second mousedown for a double click
	    if (ie && ie_version < 11)
	      { on(d.scroller, "dblclick", operation(cm, function (e) {
	        if (signalDOMEvent(cm, e)) { return }
	        var pos = posFromMouse(cm, e);
	        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
	        e_preventDefault(e);
	        var word = cm.findWordAt(pos);
	        extendSelection(cm.doc, word.anchor, word.head);
	      })); }
	    else
	      { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
	    // Some browsers fire contextmenu *after* opening the menu, at
	    // which point we can't mess with it anymore. Context menu is
	    // handled in onMouseDown for these browsers.
	    on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); });
	    on(d.input.getField(), "contextmenu", function (e) {
	      if (!d.scroller.contains(e.target)) { onContextMenu(cm, e); }
	    });
	
	    // Used to suppress mouse event handling when a touch happens
	    var touchFinished, prevTouch = {end: 0};
	    function finishTouch() {
	      if (d.activeTouch) {
	        touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
	        prevTouch = d.activeTouch;
	        prevTouch.end = +new Date;
	      }
	    }
	    function isMouseLikeTouchEvent(e) {
	      if (e.touches.length != 1) { return false }
	      var touch = e.touches[0];
	      return touch.radiusX <= 1 && touch.radiusY <= 1
	    }
	    function farAway(touch, other) {
	      if (other.left == null) { return true }
	      var dx = other.left - touch.left, dy = other.top - touch.top;
	      return dx * dx + dy * dy > 20 * 20
	    }
	    on(d.scroller, "touchstart", function (e) {
	      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
	        d.input.ensurePolled();
	        clearTimeout(touchFinished);
	        var now = +new Date;
	        d.activeTouch = {start: now, moved: false,
	                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
	        if (e.touches.length == 1) {
	          d.activeTouch.left = e.touches[0].pageX;
	          d.activeTouch.top = e.touches[0].pageY;
	        }
	      }
	    });
	    on(d.scroller, "touchmove", function () {
	      if (d.activeTouch) { d.activeTouch.moved = true; }
	    });
	    on(d.scroller, "touchend", function (e) {
	      var touch = d.activeTouch;
	      if (touch && !eventInWidget(d, e) && touch.left != null &&
	          !touch.moved && new Date - touch.start < 300) {
	        var pos = cm.coordsChar(d.activeTouch, "page"), range;
	        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	          { range = new Range(pos, pos); }
	        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	          { range = cm.findWordAt(pos); }
	        else // Triple tap
	          { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
	        cm.setSelection(range.anchor, range.head);
	        cm.focus();
	        e_preventDefault(e);
	      }
	      finishTouch();
	    });
	    on(d.scroller, "touchcancel", finishTouch);
	
	    // Sync scrolling between fake scrollbars and real scrollable
	    // area, ensure viewport is updated when scrolling.
	    on(d.scroller, "scroll", function () {
	      if (d.scroller.clientHeight) {
	        updateScrollTop(cm, d.scroller.scrollTop);
	        setScrollLeft(cm, d.scroller.scrollLeft, true);
	        signal(cm, "scroll", cm);
	      }
	    });
	
	    // Listen to wheel events in order to try and update the viewport on time.
	    on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
	    on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });
	
	    // Prevent wrapper from ever scrolling
	    on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });
	
	    d.dragFunctions = {
	      enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
	      over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
	      start: function (e) { return onDragStart(cm, e); },
	      drop: operation(cm, onDrop),
	      leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
	    };
	
	    var inp = d.input.getField();
	    on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
	    on(inp, "keydown", operation(cm, onKeyDown));
	    on(inp, "keypress", operation(cm, onKeyPress));
	    on(inp, "focus", function (e) { return onFocus(cm, e); });
	    on(inp, "blur", function (e) { return onBlur(cm, e); });
	  }
	
	  var initHooks = [];
	  CodeMirror.defineInitHook = function (f) { return initHooks.push(f); };
	
	  // Indent the given line. The how parameter can be "smart",
	  // "add"/null, "subtract", or "prev". When aggressive is false
	  // (typically set to true for forced single-line indents), empty
	  // lines are not indented, and places where the mode returns Pass
	  // are left alone.
	  function indentLine(cm, n, how, aggressive) {
	    var doc = cm.doc, state;
	    if (how == null) { how = "add"; }
	    if (how == "smart") {
	      // Fall back to "prev" when the mode doesn't have an indentation
	      // method.
	      if (!doc.mode.indent) { how = "prev"; }
	      else { state = getContextBefore(cm, n).state; }
	    }
	
	    var tabSize = cm.options.tabSize;
	    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
	    if (line.stateAfter) { line.stateAfter = null; }
	    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
	    if (!aggressive && !/\S/.test(line.text)) {
	      indentation = 0;
	      how = "not";
	    } else if (how == "smart") {
	      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
	      if (indentation == Pass || indentation > 150) {
	        if (!aggressive) { return }
	        how = "prev";
	      }
	    }
	    if (how == "prev") {
	      if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
	      else { indentation = 0; }
	    } else if (how == "add") {
	      indentation = curSpace + cm.options.indentUnit;
	    } else if (how == "subtract") {
	      indentation = curSpace - cm.options.indentUnit;
	    } else if (typeof how == "number") {
	      indentation = curSpace + how;
	    }
	    indentation = Math.max(0, indentation);
	
	    var indentString = "", pos = 0;
	    if (cm.options.indentWithTabs)
	      { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
	    if (pos < indentation) { indentString += spaceStr(indentation - pos); }
	
	    if (indentString != curSpaceString) {
	      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
	      line.stateAfter = null;
	      return true
	    } else {
	      // Ensure that, if the cursor was in the whitespace at the start
	      // of the line, it is moved to the end of that space.
	      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
	        var range = doc.sel.ranges[i$1];
	        if (range.head.line == n && range.head.ch < curSpaceString.length) {
	          var pos$1 = Pos(n, curSpaceString.length);
	          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
	          break
	        }
	      }
	    }
	  }
	
	  // This will be set to a {lineWise: bool, text: [string]} object, so
	  // that, when pasting, we know what kind of selections the copied
	  // text was made out of.
	  var lastCopied = null;
	
	  function setLastCopied(newLastCopied) {
	    lastCopied = newLastCopied;
	  }
	
	  function applyTextInput(cm, inserted, deleted, sel, origin) {
	    var doc = cm.doc;
	    cm.display.shift = false;
	    if (!sel) { sel = doc.sel; }
	
	    var recent = +new Date - 200;
	    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
	    var textLines = splitLinesAuto(inserted), multiPaste = null;
	    // When pasting N lines into N selections, insert one line per selection
	    if (paste && sel.ranges.length > 1) {
	      if (lastCopied && lastCopied.text.join("\n") == inserted) {
	        if (sel.ranges.length % lastCopied.text.length == 0) {
	          multiPaste = [];
	          for (var i = 0; i < lastCopied.text.length; i++)
	            { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
	        }
	      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
	        multiPaste = map(textLines, function (l) { return [l]; });
	      }
	    }
	
	    var updateInput = cm.curOp.updateInput;
	    // Normal behavior is to insert the new text into every selection
	    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
	      var range = sel.ranges[i$1];
	      var from = range.from(), to = range.to();
	      if (range.empty()) {
	        if (deleted && deleted > 0) // Handle deletion
	          { from = Pos(from.line, from.ch - deleted); }
	        else if (cm.state.overwrite && !paste) // Handle overwrite
	          { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
	        else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n"))
	          { from = to = Pos(from.line, 0); }
	      }
	      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
	                         origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")};
	      makeChange(cm.doc, changeEvent);
	      signalLater(cm, "inputRead", cm, changeEvent);
	    }
	    if (inserted && !paste)
	      { triggerElectric(cm, inserted); }
	
	    ensureCursorVisible(cm);
	    if (cm.curOp.updateInput < 2) { cm.curOp.updateInput = updateInput; }
	    cm.curOp.typing = true;
	    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
	  }
	
	  function handlePaste(e, cm) {
	    var pasted = e.clipboardData && e.clipboardData.getData("Text");
	    if (pasted) {
	      e.preventDefault();
	      if (!cm.isReadOnly() && !cm.options.disableInput && cm.hasFocus())
	        { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
	      return true
	    }
	  }
	
	  function triggerElectric(cm, inserted) {
	    // When an 'electric' character is inserted, immediately trigger a reindent
	    if (!cm.options.electricChars || !cm.options.smartIndent) { return }
	    var sel = cm.doc.sel;
	
	    for (var i = sel.ranges.length - 1; i >= 0; i--) {
	      var range = sel.ranges[i];
	      if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
	      var mode = cm.getModeAt(range.head);
	      var indented = false;
	      if (mode.electricChars) {
	        for (var j = 0; j < mode.electricChars.length; j++)
	          { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	            indented = indentLine(cm, range.head.line, "smart");
	            break
	          } }
	      } else if (mode.electricInput) {
	        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
	          { indented = indentLine(cm, range.head.line, "smart"); }
	      }
	      if (indented) { signalLater(cm, "electricInput", cm, range.head.line); }
	    }
	  }
	
	  function copyableRanges(cm) {
	    var text = [], ranges = [];
	    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	      var line = cm.doc.sel.ranges[i].head.line;
	      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
	      ranges.push(lineRange);
	      text.push(cm.getRange(lineRange.anchor, lineRange.head));
	    }
	    return {text: text, ranges: ranges}
	  }
	
	  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
	    field.setAttribute("autocorrect", autocorrect ? "on" : "off");
	    field.setAttribute("autocapitalize", autocapitalize ? "on" : "off");
	    field.setAttribute("spellcheck", !!spellcheck);
	  }
	
	  function hiddenTextarea() {
	    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
	    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
	    // The textarea is kept positioned near the cursor to prevent the
	    // fact that it'll be scrolled into view on input from scrolling
	    // our fake cursor out of view. On webkit, when wrap=off, paste is
	    // very slow. So make the area wide instead.
	    if (webkit) { te.style.width = "1000px"; }
	    else { te.setAttribute("wrap", "off"); }
	    // If border: 0; -- iOS fails to open keyboard (issue #1287)
	    if (ios) { te.style.border = "1px solid black"; }
	    return div
	  }
	
	  // The publicly visible API. Note that methodOp(f) means
	  // 'wrap f in an operation, performed on its `this` parameter'.
	
	  // This is not the complete set of editor methods. Most of the
	  // methods defined on the Doc type are also injected into
	  // CodeMirror.prototype, for backwards compatibility and
	  // convenience.
	
	  function addEditorMethods(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    var helpers = CodeMirror.helpers = {};
	
	    CodeMirror.prototype = {
	      constructor: CodeMirror,
	      focus: function(){win(this).focus(); this.display.input.focus();},
	
	      setOption: function(option, value) {
	        var options = this.options, old = options[option];
	        if (options[option] == value && option != "mode") { return }
	        options[option] = value;
	        if (optionHandlers.hasOwnProperty(option))
	          { operation(this, optionHandlers[option])(this, value, old); }
	        signal(this, "optionChange", this, option);
	      },
	
	      getOption: function(option) {return this.options[option]},
	      getDoc: function() {return this.doc},
	
	      addKeyMap: function(map, bottom) {
	        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
	      },
	      removeKeyMap: function(map) {
	        var maps = this.state.keyMaps;
	        for (var i = 0; i < maps.length; ++i)
	          { if (maps[i] == map || maps[i].name == map) {
	            maps.splice(i, 1);
	            return true
	          } }
	      },
	
	      addOverlay: methodOp(function(spec, options) {
	        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
	        if (mode.startState) { throw new Error("Overlays may not be stateful.") }
	        insertSorted(this.state.overlays,
	                     {mode: mode, modeSpec: spec, opaque: options && options.opaque,
	                      priority: (options && options.priority) || 0},
	                     function (overlay) { return overlay.priority; });
	        this.state.modeGen++;
	        regChange(this);
	      }),
	      removeOverlay: methodOp(function(spec) {
	        var overlays = this.state.overlays;
	        for (var i = 0; i < overlays.length; ++i) {
	          var cur = overlays[i].modeSpec;
	          if (cur == spec || typeof spec == "string" && cur.name == spec) {
	            overlays.splice(i, 1);
	            this.state.modeGen++;
	            regChange(this);
	            return
	          }
	        }
	      }),
	
	      indentLine: methodOp(function(n, dir, aggressive) {
	        if (typeof dir != "string" && typeof dir != "number") {
	          if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
	          else { dir = dir ? "add" : "subtract"; }
	        }
	        if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
	      }),
	      indentSelection: methodOp(function(how) {
	        var ranges = this.doc.sel.ranges, end = -1;
	        for (var i = 0; i < ranges.length; i++) {
	          var range = ranges[i];
	          if (!range.empty()) {
	            var from = range.from(), to = range.to();
	            var start = Math.max(end, from.line);
	            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
	            for (var j = start; j < end; ++j)
	              { indentLine(this, j, how); }
	            var newRanges = this.doc.sel.ranges;
	            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
	              { replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
	          } else if (range.head.line > end) {
	            indentLine(this, range.head.line, how, true);
	            end = range.head.line;
	            if (i == this.doc.sel.primIndex) { ensureCursorVisible(this); }
	          }
	        }
	      }),
	
	      // Fetch the parser token for a given character. Useful for hacks
	      // that want to inspect the mode state (say, for completion).
	      getTokenAt: function(pos, precise) {
	        return takeToken(this, pos, precise)
	      },
	
	      getLineTokens: function(line, precise) {
	        return takeToken(this, Pos(line), precise, true)
	      },
	
	      getTokenTypeAt: function(pos) {
	        pos = clipPos(this.doc, pos);
	        var styles = getLineStyles(this, getLine(this.doc, pos.line));
	        var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
	        var type;
	        if (ch == 0) { type = styles[2]; }
	        else { for (;;) {
	          var mid = (before + after) >> 1;
	          if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
	          else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
	          else { type = styles[mid * 2 + 2]; break }
	        } }
	        var cut = type ? type.indexOf("overlay ") : -1;
	        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
	      },
	
	      getModeAt: function(pos) {
	        var mode = this.doc.mode;
	        if (!mode.innerMode) { return mode }
	        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
	      },
	
	      getHelper: function(pos, type) {
	        return this.getHelpers(pos, type)[0]
	      },
	
	      getHelpers: function(pos, type) {
	        var found = [];
	        if (!helpers.hasOwnProperty(type)) { return found }
	        var help = helpers[type], mode = this.getModeAt(pos);
	        if (typeof mode[type] == "string") {
	          if (help[mode[type]]) { found.push(help[mode[type]]); }
	        } else if (mode[type]) {
	          for (var i = 0; i < mode[type].length; i++) {
	            var val = help[mode[type][i]];
	            if (val) { found.push(val); }
	          }
	        } else if (mode.helperType && help[mode.helperType]) {
	          found.push(help[mode.helperType]);
	        } else if (help[mode.name]) {
	          found.push(help[mode.name]);
	        }
	        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
	          var cur = help._global[i$1];
	          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1)
	            { found.push(cur.val); }
	        }
	        return found
	      },
	
	      getStateAfter: function(line, precise) {
	        var doc = this.doc;
	        line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
	        return getContextBefore(this, line + 1, precise).state
	      },
	
	      cursorCoords: function(start, mode) {
	        var pos, range = this.doc.sel.primary();
	        if (start == null) { pos = range.head; }
	        else if (typeof start == "object") { pos = clipPos(this.doc, start); }
	        else { pos = start ? range.from() : range.to(); }
	        return cursorCoords(this, pos, mode || "page")
	      },
	
	      charCoords: function(pos, mode) {
	        return charCoords(this, clipPos(this.doc, pos), mode || "page")
	      },
	
	      coordsChar: function(coords, mode) {
	        coords = fromCoordSystem(this, coords, mode || "page");
	        return coordsChar(this, coords.left, coords.top)
	      },
	
	      lineAtHeight: function(height, mode) {
	        height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
	        return lineAtHeight(this.doc, height + this.display.viewOffset)
	      },
	      heightAtLine: function(line, mode, includeWidgets) {
	        var end = false, lineObj;
	        if (typeof line == "number") {
	          var last = this.doc.first + this.doc.size - 1;
	          if (line < this.doc.first) { line = this.doc.first; }
	          else if (line > last) { line = last; end = true; }
	          lineObj = getLine(this.doc, line);
	        } else {
	          lineObj = line;
	        }
	        return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
	          (end ? this.doc.height - heightAtLine(lineObj) : 0)
	      },
	
	      defaultTextHeight: function() { return textHeight(this.display) },
	      defaultCharWidth: function() { return charWidth(this.display) },
	
	      getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},
	
	      addWidget: function(pos, node, scroll, vert, horiz) {
	        var display = this.display;
	        pos = cursorCoords(this, clipPos(this.doc, pos));
	        var top = pos.bottom, left = pos.left;
	        node.style.position = "absolute";
	        node.setAttribute("cm-ignore-events", "true");
	        this.display.input.setUneditable(node);
	        display.sizer.appendChild(node);
	        if (vert == "over") {
	          top = pos.top;
	        } else if (vert == "above" || vert == "near") {
	          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	          hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
	          // Default to positioning above (if specified and possible); otherwise default to positioning below
	          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
	            { top = pos.top - node.offsetHeight; }
	          else if (pos.bottom + node.offsetHeight <= vspace)
	            { top = pos.bottom; }
	          if (left + node.offsetWidth > hspace)
	            { left = hspace - node.offsetWidth; }
	        }
	        node.style.top = top + "px";
	        node.style.left = node.style.right = "";
	        if (horiz == "right") {
	          left = display.sizer.clientWidth - node.offsetWidth;
	          node.style.right = "0px";
	        } else {
	          if (horiz == "left") { left = 0; }
	          else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
	          node.style.left = left + "px";
	        }
	        if (scroll)
	          { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
	      },
	
	      triggerOnKeyDown: methodOp(onKeyDown),
	      triggerOnKeyPress: methodOp(onKeyPress),
	      triggerOnKeyUp: onKeyUp,
	      triggerOnMouseDown: methodOp(onMouseDown),
	
	      execCommand: function(cmd) {
	        if (commands.hasOwnProperty(cmd))
	          { return commands[cmd].call(null, this) }
	      },
	
	      triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),
	
	      findPosH: function(from, amount, unit, visually) {
	        var dir = 1;
	        if (amount < 0) { dir = -1; amount = -amount; }
	        var cur = clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          cur = findPosH(this.doc, cur, dir, unit, visually);
	          if (cur.hitSide) { break }
	        }
	        return cur
	      },
	
	      moveH: methodOp(function(dir, unit) {
	        var this$1 = this;
	
	        this.extendSelectionsBy(function (range) {
	          if (this$1.display.shift || this$1.doc.extend || range.empty())
	            { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
	          else
	            { return dir < 0 ? range.from() : range.to() }
	        }, sel_move);
	      }),
	
	      deleteH: methodOp(function(dir, unit) {
	        var sel = this.doc.sel, doc = this.doc;
	        if (sel.somethingSelected())
	          { doc.replaceSelection("", null, "+delete"); }
	        else
	          { deleteNearSelection(this, function (range) {
	            var other = findPosH(doc, range.head, dir, unit, false);
	            return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
	          }); }
	      }),
	
	      findPosV: function(from, amount, unit, goalColumn) {
	        var dir = 1, x = goalColumn;
	        if (amount < 0) { dir = -1; amount = -amount; }
	        var cur = clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          var coords = cursorCoords(this, cur, "div");
	          if (x == null) { x = coords.left; }
	          else { coords.left = x; }
	          cur = findPosV(this, coords, dir, unit);
	          if (cur.hitSide) { break }
	        }
	        return cur
	      },
	
	      moveV: methodOp(function(dir, unit) {
	        var this$1 = this;
	
	        var doc = this.doc, goals = [];
	        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
	        doc.extendSelectionsBy(function (range) {
	          if (collapse)
	            { return dir < 0 ? range.from() : range.to() }
	          var headPos = cursorCoords(this$1, range.head, "div");
	          if (range.goalColumn != null) { headPos.left = range.goalColumn; }
	          goals.push(headPos.left);
	          var pos = findPosV(this$1, headPos, dir, unit);
	          if (unit == "page" && range == doc.sel.primary())
	            { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
	          return pos
	        }, sel_move);
	        if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
	          { doc.sel.ranges[i].goalColumn = goals[i]; } }
	      }),
	
	      // Find the word at the given position (as returned by coordsChar).
	      findWordAt: function(pos) {
	        var doc = this.doc, line = getLine(doc, pos.line).text;
	        var start = pos.ch, end = pos.ch;
	        if (line) {
	          var helper = this.getHelper(pos, "wordChars");
	          if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
	          var startChar = line.charAt(start);
	          var check = isWordChar(startChar, helper)
	            ? function (ch) { return isWordChar(ch, helper); }
	            : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
	            : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
	          while (start > 0 && check(line.charAt(start - 1))) { --start; }
	          while (end < line.length && check(line.charAt(end))) { ++end; }
	        }
	        return new Range(Pos(pos.line, start), Pos(pos.line, end))
	      },
	
	      toggleOverwrite: function(value) {
	        if (value != null && value == this.state.overwrite) { return }
	        if (this.state.overwrite = !this.state.overwrite)
	          { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
	        else
	          { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
	
	        signal(this, "overwriteToggle", this, this.state.overwrite);
	      },
	      hasFocus: function() { return this.display.input.getField() == activeElt(root(this)) },
	      isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },
	
	      scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
	      getScrollInfo: function() {
	        var scroller = this.display.scroller;
	        return {left: scroller.scrollLeft, top: scroller.scrollTop,
	                height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	                width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	                clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
	      },
	
	      scrollIntoView: methodOp(function(range, margin) {
	        if (range == null) {
	          range = {from: this.doc.sel.primary().head, to: null};
	          if (margin == null) { margin = this.options.cursorScrollMargin; }
	        } else if (typeof range == "number") {
	          range = {from: Pos(range, 0), to: null};
	        } else if (range.from == null) {
	          range = {from: range, to: null};
	        }
	        if (!range.to) { range.to = range.from; }
	        range.margin = margin || 0;
	
	        if (range.from.line != null) {
	          scrollToRange(this, range);
	        } else {
	          scrollToCoordsRange(this, range.from, range.to, range.margin);
	        }
	      }),
	
	      setSize: methodOp(function(width, height) {
	        var this$1 = this;
	
	        var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
	        if (width != null) { this.display.wrapper.style.width = interpret(width); }
	        if (height != null) { this.display.wrapper.style.height = interpret(height); }
	        if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
	        var lineNo = this.display.viewFrom;
	        this.doc.iter(lineNo, this.display.viewTo, function (line) {
	          if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
	            { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
	          ++lineNo;
	        });
	        this.curOp.forceUpdate = true;
	        signal(this, "refresh", this);
	      }),
	
	      operation: function(f){return runInOp(this, f)},
	      startOperation: function(){return startOperation(this)},
	      endOperation: function(){return endOperation(this)},
	
	      refresh: methodOp(function() {
	        var oldHeight = this.display.cachedTextHeight;
	        regChange(this);
	        this.curOp.forceUpdate = true;
	        clearCaches(this);
	        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
	        updateGutterSpace(this.display);
	        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping)
	          { estimateLineHeights(this); }
	        signal(this, "refresh", this);
	      }),
	
	      swapDoc: methodOp(function(doc) {
	        var old = this.doc;
	        old.cm = null;
	        // Cancel the current text selection if any (#5821)
	        if (this.state.selectingText) { this.state.selectingText(); }
	        attachDoc(this, doc);
	        clearCaches(this);
	        this.display.input.reset();
	        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
	        this.curOp.forceScroll = true;
	        signalLater(this, "swapDoc", this, old);
	        return old
	      }),
	
	      phrase: function(phraseText) {
	        var phrases = this.options.phrases;
	        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText
	      },
	
	      getInputField: function(){return this.display.input.getField()},
	      getWrapperElement: function(){return this.display.wrapper},
	      getScrollerElement: function(){return this.display.scroller},
	      getGutterElement: function(){return this.display.gutters}
	    };
	    eventMixin(CodeMirror);
	
	    CodeMirror.registerHelper = function(type, name, value) {
	      if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
	      helpers[type][name] = value;
	    };
	    CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
	      CodeMirror.registerHelper(type, name, value);
	      helpers[type]._global.push({pred: predicate, val: value});
	    };
	  }
	
	  // Used for horizontal relative motion. Dir is -1 or 1 (left or
	  // right), unit can be "codepoint", "char", "column" (like char, but
	  // doesn't cross line boundaries), "word" (across next word), or
	  // "group" (to the start of next group of word or
	  // non-word-non-whitespace chars). The visually param controls
	  // whether, in right-to-left text, direction 1 means to move towards
	  // the next index in the string, or towards the character to the right
	  // of the current position. The resulting position will have a
	  // hitSide=true property if it reached the end of the document.
	  function findPosH(doc, pos, dir, unit, visually) {
	    var oldPos = pos;
	    var origDir = dir;
	    var lineObj = getLine(doc, pos.line);
	    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
	    function findNextLine() {
	      var l = pos.line + lineDir;
	      if (l < doc.first || l >= doc.first + doc.size) { return false }
	      pos = new Pos(l, pos.ch, pos.sticky);
	      return lineObj = getLine(doc, l)
	    }
	    function moveOnce(boundToLine) {
	      var next;
	      if (unit == "codepoint") {
	        var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
	        if (isNaN(ch)) {
	          next = null;
	        } else {
	          var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
	          next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
	        }
	      } else if (visually) {
	        next = moveVisually(doc.cm, lineObj, pos, dir);
	      } else {
	        next = moveLogically(lineObj, pos, dir);
	      }
	      if (next == null) {
	        if (!boundToLine && findNextLine())
	          { pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir); }
	        else
	          { return false }
	      } else {
	        pos = next;
	      }
	      return true
	    }
	
	    if (unit == "char" || unit == "codepoint") {
	      moveOnce();
	    } else if (unit == "column") {
	      moveOnce(true);
	    } else if (unit == "word" || unit == "group") {
	      var sawType = null, group = unit == "group";
	      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
	      for (var first = true;; first = false) {
	        if (dir < 0 && !moveOnce(!first)) { break }
	        var cur = lineObj.text.charAt(pos.ch) || "\n";
	        var type = isWordChar(cur, helper) ? "w"
	          : group && cur == "\n" ? "n"
	          : !group || /\s/.test(cur) ? null
	          : "p";
	        if (group && !first && !type) { type = "s"; }
	        if (sawType && sawType != type) {
	          if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
	          break
	        }
	
	        if (type) { sawType = type; }
	        if (dir > 0 && !moveOnce(!first)) { break }
	      }
	    }
	    var result = skipAtomic(doc, pos, oldPos, origDir, true);
	    if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
	    return result
	  }
	
	  // For relative vertical movement. Dir may be -1 or 1. Unit can be
	  // "page" or "line". The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function findPosV(cm, pos, dir, unit) {
	    var doc = cm.doc, x = pos.left, y;
	    if (unit == "page") {
	      var pageSize = Math.min(cm.display.wrapper.clientHeight, win(cm).innerHeight || doc(cm).documentElement.clientHeight);
	      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
	      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
	
	    } else if (unit == "line") {
	      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
	    }
	    var target;
	    for (;;) {
	      target = coordsChar(cm, x, y);
	      if (!target.outside) { break }
	      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
	      y += dir * 5;
	    }
	    return target
	  }
	
	  // CONTENTEDITABLE INPUT STYLE
	
	  var ContentEditableInput = function(cm) {
	    this.cm = cm;
	    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
	    this.polling = new Delayed();
	    this.composing = null;
	    this.gracePeriod = false;
	    this.readDOMTimeout = null;
	  };
	
	  ContentEditableInput.prototype.init = function (display) {
	      var this$1 = this;
	
	    var input = this, cm = input.cm;
	    var div = input.div = display.lineDiv;
	    div.contentEditable = true;
	    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
	
	    function belongsToInput(e) {
	      for (var t = e.target; t; t = t.parentNode) {
	        if (t == div) { return true }
	        if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) { break }
	      }
	      return false
	    }
	
	    on(div, "paste", function (e) {
	      if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	      if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
	    });
	
	    on(div, "compositionstart", function (e) {
	      this$1.composing = {data: e.data, done: false};
	    });
	    on(div, "compositionupdate", function (e) {
	      if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
	    });
	    on(div, "compositionend", function (e) {
	      if (this$1.composing) {
	        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
	        this$1.composing.done = true;
	      }
	    });
	
	    on(div, "touchstart", function () { return input.forceCompositionEnd(); });
	
	    on(div, "input", function () {
	      if (!this$1.composing) { this$1.readFromDOMSoon(); }
	    });
	
	    function onCopyCut(e) {
	      if (!belongsToInput(e) || signalDOMEvent(cm, e)) { return }
	      if (cm.somethingSelected()) {
	        setLastCopied({lineWise: false, text: cm.getSelections()});
	        if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
	      } else if (!cm.options.lineWiseCopyCut) {
	        return
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({lineWise: true, text: ranges.text});
	        if (e.type == "cut") {
	          cm.operation(function () {
	            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
	            cm.replaceSelection("", null, "cut");
	          });
	        }
	      }
	      if (e.clipboardData) {
	        e.clipboardData.clearData();
	        var content = lastCopied.text.join("\n");
	        // iOS exposes the clipboard API, but seems to discard content inserted into it
	        e.clipboardData.setData("Text", content);
	        if (e.clipboardData.getData("Text") == content) {
	          e.preventDefault();
	          return
	        }
	      }
	      // Old-fashioned briefly-focus-a-textarea hack
	      var kludge = hiddenTextarea(), te = kludge.firstChild;
	      disableBrowserMagic(te);
	      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
	      te.value = lastCopied.text.join("\n");
	      var hadFocus = activeElt(rootNode(div));
	      selectInput(te);
	      setTimeout(function () {
	        cm.display.lineSpace.removeChild(kludge);
	        hadFocus.focus();
	        if (hadFocus == div) { input.showPrimarySelection(); }
	      }, 50);
	    }
	    on(div, "copy", onCopyCut);
	    on(div, "cut", onCopyCut);
	  };
	
	  ContentEditableInput.prototype.screenReaderLabelChanged = function (label) {
	    // Label for screenreaders, accessibility
	    if(label) {
	      this.div.setAttribute('aria-label', label);
	    } else {
	      this.div.removeAttribute('aria-label');
	    }
	  };
	
	  ContentEditableInput.prototype.prepareSelection = function () {
	    var result = prepareSelection(this.cm, false);
	    result.focus = activeElt(rootNode(this.div)) == this.div;
	    return result
	  };
	
	  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
	    if (!info || !this.cm.display.view.length) { return }
	    if (info.focus || takeFocus) { this.showPrimarySelection(); }
	    this.showMultipleSelections(info);
	  };
	
	  ContentEditableInput.prototype.getSelection = function () {
	    return this.cm.display.wrapper.ownerDocument.getSelection()
	  };
	
	  ContentEditableInput.prototype.showPrimarySelection = function () {
	    var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
	    var from = prim.from(), to = prim.to();
	
	    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
	      sel.removeAllRanges();
	      return
	    }
	
	    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
	        cmp(minPos(curAnchor, curFocus), from) == 0 &&
	        cmp(maxPos(curAnchor, curFocus), to) == 0)
	      { return }
	
	    var view = cm.display.view;
	    var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
	        {node: view[0].measure.map[2], offset: 0};
	    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
	    if (!end) {
	      var measure = view[view.length - 1].measure;
	      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
	      end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]};
	    }
	
	    if (!start || !end) {
	      sel.removeAllRanges();
	      return
	    }
	
	    var old = sel.rangeCount && sel.getRangeAt(0), rng;
	    try { rng = range(start.node, start.offset, end.offset, end.node); }
	    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	    if (rng) {
	      if (!gecko && cm.state.focused) {
	        sel.collapse(start.node, start.offset);
	        if (!rng.collapsed) {
	          sel.removeAllRanges();
	          sel.addRange(rng);
	        }
	      } else {
	        sel.removeAllRanges();
	        sel.addRange(rng);
	      }
	      if (old && sel.anchorNode == null) { sel.addRange(old); }
	      else if (gecko) { this.startGracePeriod(); }
	    }
	    this.rememberSelection();
	  };
	
	  ContentEditableInput.prototype.startGracePeriod = function () {
	      var this$1 = this;
	
	    clearTimeout(this.gracePeriod);
	    this.gracePeriod = setTimeout(function () {
	      this$1.gracePeriod = false;
	      if (this$1.selectionChanged())
	        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
	    }, 20);
	  };
	
	  ContentEditableInput.prototype.showMultipleSelections = function (info) {
	    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
	    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
	  };
	
	  ContentEditableInput.prototype.rememberSelection = function () {
	    var sel = this.getSelection();
	    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
	    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
	  };
	
	  ContentEditableInput.prototype.selectionInEditor = function () {
	    var sel = this.getSelection();
	    if (!sel.rangeCount) { return false }
	    var node = sel.getRangeAt(0).commonAncestorContainer;
	    return contains(this.div, node)
	  };
	
	  ContentEditableInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor") {
	      if (!this.selectionInEditor() || activeElt(rootNode(this.div)) != this.div)
	        { this.showSelection(this.prepareSelection(), true); }
	      this.div.focus();
	    }
	  };
	  ContentEditableInput.prototype.blur = function () { this.div.blur(); };
	  ContentEditableInput.prototype.getField = function () { return this.div };
	
	  ContentEditableInput.prototype.supportsTouch = function () { return true };
	
	  ContentEditableInput.prototype.receivedFocus = function () {
	      var this$1 = this;
	
	    var input = this;
	    if (this.selectionInEditor())
	      { setTimeout(function () { return this$1.pollSelection(); }, 20); }
	    else
	      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }
	
	    function poll() {
	      if (input.cm.state.focused) {
	        input.pollSelection();
	        input.polling.set(input.cm.options.pollInterval, poll);
	      }
	    }
	    this.polling.set(this.cm.options.pollInterval, poll);
	  };
	
	  ContentEditableInput.prototype.selectionChanged = function () {
	    var sel = this.getSelection();
	    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
	      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
	  };
	
	  ContentEditableInput.prototype.pollSelection = function () {
	    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
	    var sel = this.getSelection(), cm = this.cm;
	    // On Android Chrome (version 56, at least), backspacing into an
	    // uneditable block element will put the cursor in that element,
	    // and then, because it's not editable, hide the virtual keyboard.
	    // Because Android doesn't allow us to actually detect backspace
	    // presses in a sane way, this code checks for when that happens
	    // and simulates a backspace press in this case.
	    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
	      this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
	      this.blur();
	      this.focus();
	      return
	    }
	    if (this.composing) { return }
	    this.rememberSelection();
	    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (anchor && head) { runInOp(cm, function () {
	      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
	      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
	    }); }
	  };
	
	  ContentEditableInput.prototype.pollContent = function () {
	    if (this.readDOMTimeout != null) {
	      clearTimeout(this.readDOMTimeout);
	      this.readDOMTimeout = null;
	    }
	
	    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
	    var from = sel.from(), to = sel.to();
	    if (from.ch == 0 && from.line > cm.firstLine())
	      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
	    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
	      { to = Pos(to.line + 1, 0); }
	    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }
	
	    var fromIndex, fromLine, fromNode;
	    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	      fromLine = lineNo(display.view[0].line);
	      fromNode = display.view[0].node;
	    } else {
	      fromLine = lineNo(display.view[fromIndex].line);
	      fromNode = display.view[fromIndex - 1].node.nextSibling;
	    }
	    var toIndex = findViewIndex(cm, to.line);
	    var toLine, toNode;
	    if (toIndex == display.view.length - 1) {
	      toLine = display.viewTo - 1;
	      toNode = display.lineDiv.lastChild;
	    } else {
	      toLine = lineNo(display.view[toIndex + 1].line) - 1;
	      toNode = display.view[toIndex + 1].node.previousSibling;
	    }
	
	    if (!fromNode) { return false }
	    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
	    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
	    while (newText.length > 1 && oldText.length > 1) {
	      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
	      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
	      else { break }
	    }
	
	    var cutFront = 0, cutEnd = 0;
	    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
	    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
	      { ++cutFront; }
	    var newBot = lst(newText), oldBot = lst(oldText);
	    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
	                             oldBot.length - (oldText.length == 1 ? cutFront : 0));
	    while (cutEnd < maxCutEnd &&
	           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
	      { ++cutEnd; }
	    // Try to move start of change to start of selection if ambiguous
	    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
	      while (cutFront && cutFront > from.ch &&
	             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	        cutFront--;
	        cutEnd++;
	      }
	    }
	
	    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
	    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
	
	    var chFrom = Pos(fromLine, cutFront);
	    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
	    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	      replaceRange(cm.doc, newText, chFrom, chTo, "+input");
	      return true
	    }
	  };
	
	  ContentEditableInput.prototype.ensurePolled = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.reset = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.forceCompositionEnd = function () {
	    if (!this.composing) { return }
	    clearTimeout(this.readDOMTimeout);
	    this.composing = null;
	    this.updateFromDOM();
	    this.div.blur();
	    this.div.focus();
	  };
	  ContentEditableInput.prototype.readFromDOMSoon = function () {
	      var this$1 = this;
	
	    if (this.readDOMTimeout != null) { return }
	    this.readDOMTimeout = setTimeout(function () {
	      this$1.readDOMTimeout = null;
	      if (this$1.composing) {
	        if (this$1.composing.done) { this$1.composing = null; }
	        else { return }
	      }
	      this$1.updateFromDOM();
	    }, 80);
	  };
	
	  ContentEditableInput.prototype.updateFromDOM = function () {
	      var this$1 = this;
	
	    if (this.cm.isReadOnly() || !this.pollContent())
	      { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
	  };
	
	  ContentEditableInput.prototype.setUneditable = function (node) {
	    node.contentEditable = "false";
	  };
	
	  ContentEditableInput.prototype.onKeyPress = function (e) {
	    if (e.charCode == 0 || this.composing) { return }
	    e.preventDefault();
	    if (!this.cm.isReadOnly())
	      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
	  };
	
	  ContentEditableInput.prototype.readOnlyChanged = function (val) {
	    this.div.contentEditable = String(val != "nocursor");
	  };
	
	  ContentEditableInput.prototype.onContextMenu = function () {};
	  ContentEditableInput.prototype.resetPosition = function () {};
	
	  ContentEditableInput.prototype.needsContentAttribute = true;
	
	  function posToDOM(cm, pos) {
	    var view = findViewForLine(cm, pos.line);
	    if (!view || view.hidden) { return null }
	    var line = getLine(cm.doc, pos.line);
	    var info = mapFromLineView(view, line, pos.line);
	
	    var order = getOrder(line, cm.doc.direction), side = "left";
	    if (order) {
	      var partPos = getBidiPartAt(order, pos.ch);
	      side = partPos % 2 ? "right" : "left";
	    }
	    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
	    result.offset = result.collapse == "right" ? result.end : result.start;
	    return result
	  }
	
	  function isInGutter(node) {
	    for (var scan = node; scan; scan = scan.parentNode)
	      { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
	    return false
	  }
	
	  function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }
	
	  function domTextBetween(cm, from, to, fromLine, toLine) {
	    var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
	    function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
	    function close() {
	      if (closing) {
	        text += lineSep;
	        if (extraLinebreak) { text += lineSep; }
	        closing = extraLinebreak = false;
	      }
	    }
	    function addText(str) {
	      if (str) {
	        close();
	        text += str;
	      }
	    }
	    function walk(node) {
	      if (node.nodeType == 1) {
	        var cmText = node.getAttribute("cm-text");
	        if (cmText) {
	          addText(cmText);
	          return
	        }
	        var markerID = node.getAttribute("cm-marker"), range;
	        if (markerID) {
	          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
	          if (found.length && (range = found[0].find(0)))
	            { addText(getBetween(cm.doc, range.from, range.to).join(lineSep)); }
	          return
	        }
	        if (node.getAttribute("contenteditable") == "false") { return }
	        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
	        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }
	
	        if (isBlock) { close(); }
	        for (var i = 0; i < node.childNodes.length; i++)
	          { walk(node.childNodes[i]); }
	
	        if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
	        if (isBlock) { closing = true; }
	      } else if (node.nodeType == 3) {
	        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
	      }
	    }
	    for (;;) {
	      walk(from);
	      if (from == to) { break }
	      from = from.nextSibling;
	      extraLinebreak = false;
	    }
	    return text
	  }
	
	  function domToPos(cm, node, offset) {
	    var lineNode;
	    if (node == cm.display.lineDiv) {
	      lineNode = cm.display.lineDiv.childNodes[offset];
	      if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
	      node = null; offset = 0;
	    } else {
	      for (lineNode = node;; lineNode = lineNode.parentNode) {
	        if (!lineNode || lineNode == cm.display.lineDiv) { return null }
	        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
	      }
	    }
	    for (var i = 0; i < cm.display.view.length; i++) {
	      var lineView = cm.display.view[i];
	      if (lineView.node == lineNode)
	        { return locateNodeInLineView(lineView, node, offset) }
	    }
	  }
	
	  function locateNodeInLineView(lineView, node, offset) {
	    var wrapper = lineView.text.firstChild, bad = false;
	    if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
	    if (node == wrapper) {
	      bad = true;
	      node = wrapper.childNodes[offset];
	      offset = 0;
	      if (!node) {
	        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
	        return badPos(Pos(lineNo(line), line.text.length), bad)
	      }
	    }
	
	    var textNode = node.nodeType == 3 ? node : null, topNode = node;
	    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	      textNode = node.firstChild;
	      if (offset) { offset = textNode.nodeValue.length; }
	    }
	    while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
	    var measure = lineView.measure, maps = measure.maps;
	
	    function find(textNode, topNode, offset) {
	      for (var i = -1; i < (maps ? maps.length : 0); i++) {
	        var map = i < 0 ? measure.map : maps[i];
	        for (var j = 0; j < map.length; j += 3) {
	          var curNode = map[j + 2];
	          if (curNode == textNode || curNode == topNode) {
	            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
	            var ch = map[j] + offset;
	            if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)]; }
	            return Pos(line, ch)
	          }
	        }
	      }
	    }
	    var found = find(textNode, topNode, offset);
	    if (found) { return badPos(found, bad) }
	
	    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	      found = find(after, after.firstChild, 0);
	      if (found)
	        { return badPos(Pos(found.line, found.ch - dist), bad) }
	      else
	        { dist += after.textContent.length; }
	    }
	    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
	      found = find(before, before.firstChild, -1);
	      if (found)
	        { return badPos(Pos(found.line, found.ch + dist$1), bad) }
	      else
	        { dist$1 += before.textContent.length; }
	    }
	  }
	
	  // TEXTAREA INPUT STYLE
	
	  var TextareaInput = function(cm) {
	    this.cm = cm;
	    // See input.poll and input.reset
	    this.prevInput = "";
	
	    // Flag that indicates whether we expect input to appear real soon
	    // now (after some event like 'keypress' or 'input') and are
	    // polling intensively.
	    this.pollingFast = false;
	    // Self-resetting timeout for the poller
	    this.polling = new Delayed();
	    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	    this.hasSelection = false;
	    this.composing = null;
	    this.resetting = false;
	  };
	
	  TextareaInput.prototype.init = function (display) {
	      var this$1 = this;
	
	    var input = this, cm = this.cm;
	    this.createField(display);
	    var te = this.textarea;
	
	    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
	
	    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	    if (ios) { te.style.width = "0px"; }
	
	    on(te, "input", function () {
	      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
	      input.poll();
	    });
	
	    on(te, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	
	      cm.state.pasteIncoming = +new Date;
	      input.fastPoll();
	    });
	
	    function prepareCopyCut(e) {
	      if (signalDOMEvent(cm, e)) { return }
	      if (cm.somethingSelected()) {
	        setLastCopied({lineWise: false, text: cm.getSelections()});
	      } else if (!cm.options.lineWiseCopyCut) {
	        return
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({lineWise: true, text: ranges.text});
	        if (e.type == "cut") {
	          cm.setSelections(ranges.ranges, null, sel_dontScroll);
	        } else {
	          input.prevInput = "";
	          te.value = ranges.text.join("\n");
	          selectInput(te);
	        }
	      }
	      if (e.type == "cut") { cm.state.cutIncoming = +new Date; }
	    }
	    on(te, "cut", prepareCopyCut);
	    on(te, "copy", prepareCopyCut);
	
	    on(display.scroller, "paste", function (e) {
	      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
	      if (!te.dispatchEvent) {
	        cm.state.pasteIncoming = +new Date;
	        input.focus();
	        return
	      }
	
	      // Pass the `paste` event to the textarea so it's handled by its event listener.
	      var event = new Event("paste");
	      event.clipboardData = e.clipboardData;
	      te.dispatchEvent(event);
	    });
	
	    // Prevent normal selection in the editor (we handle our own)
	    on(display.lineSpace, "selectstart", function (e) {
	      if (!eventInWidget(display, e)) { e_preventDefault(e); }
	    });
	
	    on(te, "compositionstart", function () {
	      var start = cm.getCursor("from");
	      if (input.composing) { input.composing.range.clear(); }
	      input.composing = {
	        start: start,
	        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
	      };
	    });
	    on(te, "compositionend", function () {
	      if (input.composing) {
	        input.poll();
	        input.composing.range.clear();
	        input.composing = null;
	      }
	    });
	  };
	
	  TextareaInput.prototype.createField = function (_display) {
	    // Wraps and hides input textarea
	    this.wrapper = hiddenTextarea();
	    // The semihidden textarea that is focused when the editor is
	    // focused, and receives input.
	    this.textarea = this.wrapper.firstChild;
	    var opts = this.cm.options;
	    disableBrowserMagic(this.textarea, opts.spellcheck, opts.autocorrect, opts.autocapitalize);
	  };
	
	  TextareaInput.prototype.screenReaderLabelChanged = function (label) {
	    // Label for screenreaders, accessibility
	    if(label) {
	      this.textarea.setAttribute('aria-label', label);
	    } else {
	      this.textarea.removeAttribute('aria-label');
	    }
	  };
	
	  TextareaInput.prototype.prepareSelection = function () {
	    // Redraw the selection and/or cursor
	    var cm = this.cm, display = cm.display, doc = cm.doc;
	    var result = prepareSelection(cm);
	
	    // Move the hidden textarea near the cursor to prevent scrolling artifacts
	    if (cm.options.moveInputWithCursor) {
	      var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
	      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
	      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
	                                          headPos.top + lineOff.top - wrapOff.top));
	      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
	                                           headPos.left + lineOff.left - wrapOff.left));
	    }
	
	    return result
	  };
	
	  TextareaInput.prototype.showSelection = function (drawn) {
	    var cm = this.cm, display = cm.display;
	    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
	    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
	    if (drawn.teTop != null) {
	      this.wrapper.style.top = drawn.teTop + "px";
	      this.wrapper.style.left = drawn.teLeft + "px";
	    }
	  };
	
	  // Reset the input to correspond to the selection (or to be empty,
	  // when not typing and nothing is selected)
	  TextareaInput.prototype.reset = function (typing) {
	    if (this.contextMenuPending || this.composing && typing) { return }
	    var cm = this.cm;
	    this.resetting = true;
	    if (cm.somethingSelected()) {
	      this.prevInput = "";
	      var content = cm.getSelection();
	      this.textarea.value = content;
	      if (cm.state.focused) { selectInput(this.textarea); }
	      if (ie && ie_version >= 9) { this.hasSelection = content; }
	    } else if (!typing) {
	      this.prevInput = this.textarea.value = "";
	      if (ie && ie_version >= 9) { this.hasSelection = null; }
	    }
	    this.resetting = false;
	  };
	
	  TextareaInput.prototype.getField = function () { return this.textarea };
	
	  TextareaInput.prototype.supportsTouch = function () { return false };
	
	  TextareaInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt(rootNode(this.textarea)) != this.textarea)) {
	      try { this.textarea.focus(); }
	      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	    }
	  };
	
	  TextareaInput.prototype.blur = function () { this.textarea.blur(); };
	
	  TextareaInput.prototype.resetPosition = function () {
	    this.wrapper.style.top = this.wrapper.style.left = 0;
	  };
	
	  TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };
	
	  // Poll for input changes, using the normal rate of polling. This
	  // runs as long as the editor is focused.
	  TextareaInput.prototype.slowPoll = function () {
	      var this$1 = this;
	
	    if (this.pollingFast) { return }
	    this.polling.set(this.cm.options.pollInterval, function () {
	      this$1.poll();
	      if (this$1.cm.state.focused) { this$1.slowPoll(); }
	    });
	  };
	
	  // When an event has just come in that is likely to add or change
	  // something in the input textarea, we poll faster, to ensure that
	  // the change appears on the screen quickly.
	  TextareaInput.prototype.fastPoll = function () {
	    var missed = false, input = this;
	    input.pollingFast = true;
	    function p() {
	      var changed = input.poll();
	      if (!changed && !missed) {missed = true; input.polling.set(60, p);}
	      else {input.pollingFast = false; input.slowPoll();}
	    }
	    input.polling.set(20, p);
	  };
	
	  // Read input from the textarea, and update the document to match.
	  // When something is selected, it is present in the textarea, and
	  // selected (unless it is huge, in which case a placeholder is
	  // used). When nothing is selected, the cursor sits after previously
	  // seen text (can be empty), which is stored in prevInput (we must
	  // not reset the textarea when typing, because that breaks IME).
	  TextareaInput.prototype.poll = function () {
	      var this$1 = this;
	
	    var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
	    // Since this is called a *lot*, try to bail out as cheaply as
	    // possible when it is clear that nothing happened. hasSelection
	    // will be the case when there is a lot of text in the textarea,
	    // in which case reading its value would be expensive.
	    if (this.contextMenuPending || this.resetting || !cm.state.focused ||
	        (hasSelection(input) && !prevInput && !this.composing) ||
	        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
	      { return false }
	
	    var text = input.value;
	    // If nothing changed, bail.
	    if (text == prevInput && !cm.somethingSelected()) { return false }
	    // Work around nonsensical selection resetting in IE9/10, and
	    // inexplicable appearance of private area unicode characters on
	    // some key combos in Mac (#2689).
	    if (ie && ie_version >= 9 && this.hasSelection === text ||
	        mac && /[\uf700-\uf7ff]/.test(text)) {
	      cm.display.input.reset();
	      return false
	    }
	
	    if (cm.doc.sel == cm.display.selForContextMenu) {
	      var first = text.charCodeAt(0);
	      if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
	      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
	    }
	    // Find the part of the input that is actually new
	    var same = 0, l = Math.min(prevInput.length, text.length);
	    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }
	
	    runInOp(cm, function () {
	      applyTextInput(cm, text.slice(same), prevInput.length - same,
	                     null, this$1.composing ? "*compose" : null);
	
	      // Don't leave long text in the textarea, since it makes further polling slow
	      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
	      else { this$1.prevInput = text; }
	
	      if (this$1.composing) {
	        this$1.composing.range.clear();
	        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
	                                           {className: "CodeMirror-composing"});
	      }
	    });
	    return true
	  };
	
	  TextareaInput.prototype.ensurePolled = function () {
	    if (this.pollingFast && this.poll()) { this.pollingFast = false; }
	  };
	
	  TextareaInput.prototype.onKeyPress = function () {
	    if (ie && ie_version >= 9) { this.hasSelection = null; }
	    this.fastPoll();
	  };
	
	  TextareaInput.prototype.onContextMenu = function (e) {
	    var input = this, cm = input.cm, display = cm.display, te = input.textarea;
	    if (input.contextMenuPending) { input.contextMenuPending(); }
	    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
	    if (!pos || presto) { return } // Opera is difficult.
	
	    // Reset the current text selection only if the click is done outside of the selection
	    // and 'resetSelectionOnContextMenu' option is true.
	    var reset = cm.options.resetSelectionOnContextMenu;
	    if (reset && cm.doc.sel.contains(pos) == -1)
	      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }
	
	    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
	    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
	    input.wrapper.style.cssText = "position: static";
	    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
	    var oldScrollY;
	    if (webkit) { oldScrollY = te.ownerDocument.defaultView.scrollY; } // Work around Chrome issue (#2712)
	    display.input.focus();
	    if (webkit) { te.ownerDocument.defaultView.scrollTo(null, oldScrollY); }
	    display.input.reset();
	    // Adds "Select all" to context menu in FF
	    if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
	    input.contextMenuPending = rehide;
	    display.selForContextMenu = cm.doc.sel;
	    clearTimeout(display.detectingSelectAll);
	
	    // Select-all will be greyed out if there's nothing to select, so
	    // this adds a zero-width space so that we can later check whether
	    // it got selected.
	    function prepareSelectAllHack() {
	      if (te.selectionStart != null) {
	        var selected = cm.somethingSelected();
	        var extval = "\u200b" + (selected ? te.value : "");
	        te.value = "\u21da"; // Used to catch context-menu undo
	        te.value = extval;
	        input.prevInput = selected ? "" : "\u200b";
	        te.selectionStart = 1; te.selectionEnd = extval.length;
	        // Re-set this, in case some other handler touched the
	        // selection in the meantime.
	        display.selForContextMenu = cm.doc.sel;
	      }
	    }
	    function rehide() {
	      if (input.contextMenuPending != rehide) { return }
	      input.contextMenuPending = false;
	      input.wrapper.style.cssText = oldWrapperCSS;
	      te.style.cssText = oldCSS;
	      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }
	
	      // Try to detect the user choosing select-all
	      if (te.selectionStart != null) {
	        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
	        var i = 0, poll = function () {
	          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
	              te.selectionEnd > 0 && input.prevInput == "\u200b") {
	            operation(cm, selectAll)(cm);
	          } else if (i++ < 10) {
	            display.detectingSelectAll = setTimeout(poll, 500);
	          } else {
	            display.selForContextMenu = null;
	            display.input.reset();
	          }
	        };
	        display.detectingSelectAll = setTimeout(poll, 200);
	      }
	    }
	
	    if (ie && ie_version >= 9) { prepareSelectAllHack(); }
	    if (captureRightClick) {
	      e_stop(e);
	      var mouseup = function () {
	        off(window, "mouseup", mouseup);
	        setTimeout(rehide, 20);
	      };
	      on(window, "mouseup", mouseup);
	    } else {
	      setTimeout(rehide, 50);
	    }
	  };
	
	  TextareaInput.prototype.readOnlyChanged = function (val) {
	    if (!val) { this.reset(); }
	    this.textarea.disabled = val == "nocursor";
	    this.textarea.readOnly = !!val;
	  };
	
	  TextareaInput.prototype.setUneditable = function () {};
	
	  TextareaInput.prototype.needsContentAttribute = false;
	
	  function fromTextArea(textarea, options) {
	    options = options ? copyObj(options) : {};
	    options.value = textarea.value;
	    if (!options.tabindex && textarea.tabIndex)
	      { options.tabindex = textarea.tabIndex; }
	    if (!options.placeholder && textarea.placeholder)
	      { options.placeholder = textarea.placeholder; }
	    // Set autofocus to true if this textarea is focused, or if it has
	    // autofocus and no other element is focused.
	    if (options.autofocus == null) {
	      var hasFocus = activeElt(rootNode(textarea));
	      options.autofocus = hasFocus == textarea ||
	        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
	    }
	
	    function save() {textarea.value = cm.getValue();}
	
	    var realSubmit;
	    if (textarea.form) {
	      on(textarea.form, "submit", save);
	      // Deplorable hack to make the submit method do the right thing.
	      if (!options.leaveSubmitMethodAlone) {
	        var form = textarea.form;
	        realSubmit = form.submit;
	        try {
	          var wrappedSubmit = form.submit = function () {
	            save();
	            form.submit = realSubmit;
	            form.submit();
	            form.submit = wrappedSubmit;
	          };
	        } catch(e) {}
	      }
	    }
	
	    options.finishInit = function (cm) {
	      cm.save = save;
	      cm.getTextArea = function () { return textarea; };
	      cm.toTextArea = function () {
	        cm.toTextArea = isNaN; // Prevent this from being ran twice
	        save();
	        textarea.parentNode.removeChild(cm.getWrapperElement());
	        textarea.style.display = "";
	        if (textarea.form) {
	          off(textarea.form, "submit", save);
	          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function")
	            { textarea.form.submit = realSubmit; }
	        }
	      };
	    };
	
	    textarea.style.display = "none";
	    var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
	      options);
	    return cm
	  }
	
	  function addLegacyProps(CodeMirror) {
	    CodeMirror.off = off;
	    CodeMirror.on = on;
	    CodeMirror.wheelEventPixels = wheelEventPixels;
	    CodeMirror.Doc = Doc;
	    CodeMirror.splitLines = splitLinesAuto;
	    CodeMirror.countColumn = countColumn;
	    CodeMirror.findColumn = findColumn;
	    CodeMirror.isWordChar = isWordCharBasic;
	    CodeMirror.Pass = Pass;
	    CodeMirror.signal = signal;
	    CodeMirror.Line = Line;
	    CodeMirror.changeEnd = changeEnd;
	    CodeMirror.scrollbarModel = scrollbarModel;
	    CodeMirror.Pos = Pos;
	    CodeMirror.cmpPos = cmp;
	    CodeMirror.modes = modes;
	    CodeMirror.mimeModes = mimeModes;
	    CodeMirror.resolveMode = resolveMode;
	    CodeMirror.getMode = getMode;
	    CodeMirror.modeExtensions = modeExtensions;
	    CodeMirror.extendMode = extendMode;
	    CodeMirror.copyState = copyState;
	    CodeMirror.startState = startState;
	    CodeMirror.innerMode = innerMode;
	    CodeMirror.commands = commands;
	    CodeMirror.keyMap = keyMap;
	    CodeMirror.keyName = keyName;
	    CodeMirror.isModifierKey = isModifierKey;
	    CodeMirror.lookupKey = lookupKey;
	    CodeMirror.normalizeKeyMap = normalizeKeyMap;
	    CodeMirror.StringStream = StringStream;
	    CodeMirror.SharedTextMarker = SharedTextMarker;
	    CodeMirror.TextMarker = TextMarker;
	    CodeMirror.LineWidget = LineWidget;
	    CodeMirror.e_preventDefault = e_preventDefault;
	    CodeMirror.e_stopPropagation = e_stopPropagation;
	    CodeMirror.e_stop = e_stop;
	    CodeMirror.addClass = addClass;
	    CodeMirror.contains = contains;
	    CodeMirror.rmClass = rmClass;
	    CodeMirror.keyNames = keyNames;
	  }
	
	  // EDITOR CONSTRUCTOR
	
	  defineOptions(CodeMirror);
	
	  addEditorMethods(CodeMirror);
	
	  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
	  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
	  for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
	    { CodeMirror.prototype[prop] = (function(method) {
	      return function() {return method.apply(this.doc, arguments)}
	    })(Doc.prototype[prop]); } }
	
	  eventMixin(Doc);
	  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  CodeMirror.defineMode = function(name/*, mode, …*/) {
	    if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name; }
	    defineMode.apply(this, arguments);
	  };
	
	  CodeMirror.defineMIME = defineMIME;
	
	  // Minimal default mode.
	  CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
	  CodeMirror.defineMIME("text/plain", "null");
	
	  // EXTENSIONS
	
	  CodeMirror.defineExtension = function (name, func) {
	    CodeMirror.prototype[name] = func;
	  };
	  CodeMirror.defineDocExtension = function (name, func) {
	    Doc.prototype[name] = func;
	  };
	
	  CodeMirror.fromTextArea = fromTextArea;
	
	  addLegacyProps(CodeMirror);
	
	  CodeMirror.version = "5.65.19";
	
	  return CodeMirror;
	
	})));


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".DlCard{box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.DlCard .ant-card-body{padding:10px 20px;display:flex;height:120px}.DlCard .ant-card-body .left{height:100%;line-height:100px}.DlCard .ant-card-body .left img{width:70px;height:70px}.DlCard .ant-card-body .right{box-sizing:border-box;padding:15px 20px}.DlCard .ant-card-body .right .title{margin-bottom:30px;color:#333}.DlCard .ant-card-body .right .content{font-weight:400;font-size:24px;color:rgba(0,0,0,.85)}", ""]);
	
	// exports


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".DlMenu{background-color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".Notice{box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.Notice .ant-card-body{padding:15px 30px 18px;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".layout .ant-layout-sider{background-color:#fff}.layout .ant-layout-sider .menu_outer{height:calc(100vh - 60px);overflow:auto;overflow-x:hidden}.layout .ant-layout-sider .menu_outer ::-webkit-scrollbar{display:none}.layout .ant-layout-sider .mainLogo{width:100%;height:60px;background-color:#00b34f;cursor:pointer}.layout .ant-layout-sider .mainLogo img{width:90%;height:35px;vertical-align:middle;margin-top:12px}.layout .ant-layout-header{padding:0;height:115px}.layout .ant-layout-header .header_title{height:60px;padding:0 30px;line-height:60px;text-align:right;background-color:#00b34f}.layout .ant-layout-header .header_title .userTitle{display:inline-block;border-radius:4px;padding:0 10px;height:36px;line-height:36px;text-align:center;color:#fff;background-color:transparent;cursor:pointer}.layout .ant-layout-header .header_title .userTitle:hover{color:#000000A6;background-color:#fff}.layout .ant-layout-header .header_title .userTitle .anticon{font-size:18px}.layout .ant-layout-content{height:calc(100vh - 115px);overflow:auto;box-sizing:border-box;padding:15px}.layout .ant-layout-content .ContentMain{border-radius:4px;height:calc(100vh - 150px);background-color:#fff;box-sizing:border-box;padding:10px;overflow:auto}.layout .ant-layout-content .Footer_content{margin-top:13px;text-align:center}.layout .ant-layout-content .Footer_content a{color:#00b34f;background:#f0f0f0;margin-right:15px}.layout .ant-layout-content .Footer_content img{width:18px;height:18px;vertical-align:middle;margin-right:10px}::-webkit-scrollbar{width:14px;height:14px}::-webkit-scrollbar-thumb,::-webkit-scrollbar-track{border-radius:999px;border:5px solid transparent}::-webkit-scrollbar-track{box-shadow:inset 1px 1px 5px rgba(0,0,0,.2)}::-webkit-scrollbar-thumb{min-height:20px;background-color:#fff;background-clip:content-box;box-shadow:inset 0 0 0 5px rgba(0,0,0,.2)}::-webkit-scrollbar-corner{background:transparent}", ""]);
	
	// exports


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote{font-size:inherit}font[face=\"宋体, SimSun\"]{font-family:\\\\5B8B\\4F53,SimSun}font[face=\"隶书, SimLi\"]{font-family:\\\\96B6\\4E66,SimLi}font[face=\"楷体, SimKai\"]{font-family:\\\\6977\\4F53,SimKai}font[face=\"微软雅黑, Microsoft YaHei\"]{font-family:\\\\5FAE\\8F6F\\96C5\\9ED1,Microsoft YaHei}font[face=\"黑体, SimHei\"]{font-family:\\\\9ED1\\4F53,SimHei}font[face=\"arial, helvetica, sans-serif\"]{font-family:arial,helvetica,sans-serif}font[face=\"arial black, avant garde\"]{font-family:arial black,avant garde}font[face=\"impact, chicago\"]{font-family:impact,chicago}font[face=\"times new roman\"]{font-family:times new roman}font[face=\"andale mono\"]{font-family:andale mono}font[face=\"omic sans ms\"]{font-family:omic sans ms}.emphasis{-webkit-text-emphasis:circle;-webkit-text-emphasis-position:under;text-emphasis:circle;text-emphasis-position:under}.editor-container{width:auto;height:auto;position:relative;box-shadow:2px 2px 5px #d3d6da;background-color:#fff;border:1px solid #d8d8d8;border-radius:4px;font-size:16px;font-family:\\\\5B8B\\4F53,SimSun;overflow-y:visible}.editor-container .editor-toolbar{position:relative;border-top-right-radius:2px;border-top-left-radius:2px}.editor-container .editor-contenteditable-div{position:relative;left:0;top:0;padding:0}.editor-container .editor-contenteditable-div .editable-range{position:relative;left:0;top:0;border-top-right-radius:2px;border-top-left-radius:2px;min-height:100px;outline:none;resize:vertical;margin-left:10px;overflow-x:hidden}.editor-container .editor-contenteditable-div .editable-range:focus{outline:none}.editor-container .editor-textarea{width:100%;padding:0 10px;margin-top:8px;border:0 solid transparent;box-sizing:border-box;resize:vertical;min-height:100px;outline:none}.editor-container .editor-textarea:focus{outline:none}.editor-container .dropdown{position:absolute;top:0;left:0;z-index:999;background-color:#fff;border:1px solid #d8d8d8;border-radius:2px;padding:10px;font-size:12px}.editor-container .dropdown .dropdown-caret{top:-11px;left:11px;position:absolute;background:url(" + __webpack_require__(2033) + ") no-repeat 0;width:21px;height:11px}.editor-container .dropdown table tr td{padding:0 2px}.editor-container .dropdown table tr td .color-anchor{display:block;text-decoration:none;color:#000;width:14px;height:14px;margin:0;cursor:pointer;border:solid #ccc;border-width:1px}.editor-container .dropdown table tr.first-row,.editor-container .dropdown table tr.last-row{height:30px}.editor-container .dropdown table tr.title-row{margin-top:10px}.editor-container .combobox{position:absolute;top:0;left:0;z-index:999;background-color:#fff;border:1px solid #ccc;padding:0;margin:0 2px;line-height:20px;padding:10px;font-size:12px}.editor-container .combobox ul{padding:0;margin:3px 5px}.editor-container .combobox ul li{list-style:none;vertical-align:top;border:1px solid transparent;margin:0 1px;padding:0;cursor:pointer;width:160px}.editor-container .combobox ul li h1,.editor-container .combobox ul li h2,.editor-container .combobox ul li h3,.editor-container .combobox ul li h4,.editor-container .combobox ul li h5,.editor-container .combobox ul li h6,.editor-container .combobox ul li p,.editor-container .combobox ul li span{text-align:center;margin:0;padding:3px 5px;min-height:20px;vertical-align:middle}.editor-container .combobox ul li.active,.editor-container .combobox ul li:hover{background-color:#d5e1f2;border:1px solid #a3bde3}.editor-container .dialog-container .dialog{z-index:1001;display:block;margin-top:100px;position:fixed;top:10%;left:50%;border:1px solid #acacac;box-shadow:2px 2px 5px #d3d6da;background-color:#fff;outline:0;width:700px;margin-left:-350px}.editor-container .dialog-container .dialog .dialog-header{padding:5px 10px;border-bottom:1px solid #eee}.editor-container .dialog-container .dialog .dialog-header .dialog-close{float:right;width:20px;height:20px;margin-top:2px;padding:1px;border:0;background:url(" + __webpack_require__(2035) + ") no-repeat 50%;cursor:pointer}.editor-container .dialog-container .dialog .dialog-header .dialog-close:hover{background-color:#d5e1f2;padding:0;border:1px solid #a3bde3}.editor-container .dialog-container .dialog .dialog-header .dialog-title{margin:0;line-height:25px;font-size:20px}.editor-container .dialog-container .dialog .dialog-body{position:relative;min-height:400px;font-size:12px;overflow-y:auto;width:700px}.editor-container .dialog-container .dialog .dialog-footer{float:right;padding:5px 15px 15px;overflow:hidden}.editor-container .dialog-container .dialog .dialog-footer .dialog-button{float:left;height:24px;width:96px;margin:0 10px;background-color:#fff;padding:0;border:1px solid #ababab;font-size:12px;line-height:24px;text-align:center;cursor:pointer}.editor-container .dialog-container .dialog .dialog-footer .dialog-button:hover{background-color:#d5e1f2;border:1px solid #a3bde3}.editor-container .dialog-container .dialog-backdrop{opacity:.5;filter:alpha(opacity=50);position:fixed;top:0;right:0;bottom:0;left:0;background-color:#c6c6c6;z-index:1000}.editor-container .tab-group{font-size:12px;margin:15px}.editor-container .tab-group .tab-nav{margin:0;padding:0;border-bottom:1px solid #ddd;list-style:none;height:30px}.editor-container .tab-group .tab-nav .tab-item{float:left;margin-bottom:-1px}.editor-container .tab-group .tab-nav .tab-item .tab-text{display:block;padding:8px 12px;border:1px solid transparent;color:#08c;text-decoration:none;outline:0;cursor:pointer}.editor-container .tab-group .tab-nav .tab-item.active .tab-text{border:1px solid #ddd;border-bottom-color:transparent;background-color:#fff;padding:8px 12px;color:#555;cursor:default}.editor-container .tab-group .tab-content{padding:1px;position:relative;background-color:#fff;clear:both}.editor-container .image-dialog .tab-panel .image-content{height:330px;width:100%;position:relative;border:1px solid transparent;opacity:1}.editor-container .image-dialog .tab-panel .image-content.drag-enter{background-color:#769dd4;border:1px solid #d6e1f1;opacity:.5}.editor-container .image-dialog .tab-panel .image-content .image-item{position:relative;float:left;width:120px;height:120px;border:1px solid #d8d8d8;cursor:default;margin:5px 0 0 5px;background-color:#ccc}.editor-container .image-dialog .tab-panel .image-content .image-item .image-close{position:absolute;right:0;background:url(" + __webpack_require__(2036) + ");width:17px;height:17px;cursor:pointer;z-index:1}.editor-container .image-dialog .tab-panel .image-content .image-item .image-pic{margin-top:22.5px;background-color:#fff}.editor-container .image-dialog .tab-panel .image-content .image-upload2{position:relative;float:left;width:120px;height:120px;margin:5px 0 0 5px}.editor-container .image-dialog .tab-panel .image-content .image-upload2 .image-icon{display:inline-block;width:120px;height:120px;background-image:url(" + __webpack_require__(2041) + ")}.editor-container .image-dialog .tab-panel .image-content .image-upload2 .image-form{position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;cursor:pointer}.editor-container .image-dialog .tab-panel .image-content .image-upload2 .image-form .image-file{width:100%;height:100%;filter:alpha(opacity=0)}.editor-container .image-dialog .tab-panel .image-dragTip{position:absolute;top:50%;left:50%;margin-top:30px;margin-left:-60px;color:#222;font-size:14px;text-shadow:0 2px 3px #555}.editor-container .image-dialog .tab-panel .image-upload1{position:absolute;top:50%;left:50%;width:44px;height:38px;margin-top:-19px;margin-left:-22px}.editor-container .image-dialog .tab-panel .image-upload1:hover .image-icon{background-position:-50px 0}.editor-container .image-dialog .tab-panel .image-upload1 .image-icon{display:inline-block;width:44px;height:38px;background-image:url(" + __webpack_require__(2040) + ")}.editor-container .image-dialog .tab-panel .image-upload1 .image-form{position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;cursor:pointer}.editor-container .image-dialog .tab-panel .image-upload1 .image-form .image-file{width:100%;height:100%;filter:alpha(opacity=0);margin:3px 3px 3px 4px}.editor-container .image-dialog .tab-panel .image-mask{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff;text-align:center;line-height:300px;color:rgba(0,0,0,.6);font-size:14px;font-weight:700;display:none}.editor-container .image-dialog .tab-panel .search-bar{margin:10px;border-collapse:separate;border-spacing:2px}.editor-container .image-dialog .tab-panel .search-bar .image-searchTxt{display:inline-block!important;width:400px;border:1px solid #c5d2ff;height:20px;line-height:18px;font-size:14px;padding:3px;margin:0;outline:0}.editor-container .image-dialog .tab-panel .search-bar .image-searchAdd{display:inline-block!important;width:60px;height:25px;text-align:center;line-height:25px;background-color:#fff;padding:0;border:1px solid #ababab;margin-left:20px;cursor:pointer}.editor-container .editor-resize-container{position:relative;top:0;left:0;width:0;height:0}.editor-container .editor-resize-container .editor-resize{z-index:999;border:2px solid #38b2ce;position:absolute;left:0;top:0;box-sizing:border-box}.editor-container .editor-resize-container .editor-resize .block-resize{position:absolute;width:10px;height:10px;background-color:#38b2ce}.editor-container .editor-resize-container .editor-resize .nw-resize{cursor:nw-resize;top:-4px;left:-4px}.editor-container .editor-resize-container .editor-resize .ne-resize{cursor:ne-resize;top:-4px;right:-4px}.editor-container .editor-resize-container .editor-resize .se-resize{cursor:se-resize;bottom:-4px;right:-4px}.editor-container .editor-resize-container .editor-resize .sw-resize{cursor:sw-resize;bottom:-4px;left:-4px}.editor-container .formula-dropdown{width:350px}.editor-container .formula-dropdown .formulas-icons{margin:0;padding:10px 0}.editor-container .formula-dropdown .formulas-icons .latex-icon{display:block;float:left;margin:0 3px 3px 0;width:30px;height:30px;border:1px solid #ccc;background-image:url(" + __webpack_require__(2037) + ");cursor:pointer}.editor-container .mathquill-embedded-latex{border:0;padding:0;margin:0}.editor-container .mathquill-embedded-latex .mq-root-block,.editor-container .mathquill-embedded-latex .mq-root-block .mq-non-leaf{padding:0;margin:0}.editor-container .tablepicker-dropdown .infoarea{height:14px;line-height:14px;font-size:12px;width:220px;margin-bottom:3px;clear:both}.editor-container .tablepicker-dropdown .pickarea{width:220px;height:220px;background:url(" + __webpack_require__(2039) + ") repeat}.editor-container .tablepicker-dropdown .pickarea .overlay{width:0;height:0;background:url(" + __webpack_require__(2038) + ") repeat}.editor-container .special-chars-dialog .common-chars{padding:0}.editor-container .special-chars-dialog .common-chars .special-char{margin:5px 3px;text-align:center;display:inline-block;width:40px;height:16px;line-height:16px;cursor:pointer}.editor-container .emotion-dropdwon .common-images{padding:0}.editor-container .emotion-dropdwon .common-images .emotion-image{margin:5px 3px;text-align:center;display:inline-block;width:35px;height:35px;cursor:pointer}.editor-container .emotion-dropdwon .common-images .emotion-image img{max-width:35px;max-height:35px}.editor-container .font-border{display:inline-block;height:auto}.editor-default .editor-toolbar{position:relative;width:auto;border-bottom:1px solid #e1e1e1;box-shadow:2px 2px 5px #d3d6da;background-color:#fafafa;padding:5px}.editor-default .editor-toolbar .editor-icon{height:20px;width:20px;background-image:url(" + __webpack_require__(179) + ");display:inline-block;vertical-align:top;border:1px solid transparent;margin:0 1px}.editor-default .editor-toolbar .editor-icon.active,.editor-default .editor-toolbar .editor-icon:hover{background-color:#d5e1f2;border:1px solid #a3bde3}.editor-default .editor-toolbar .editor-icon:hover.icon-separator{background-color:transparent;border:1px solid transparent}.editor-default .editor-toolbar .editor-icon.disabled{opacity:.3}.editor-default .editor-toolbar .editor-icon:hover.disabled{background-color:transparent;border:1px solid transparent}.editor-default .editor-toolbar .editor-icon.icon-undo{background-position:-160px 0}.editor-default .editor-toolbar .editor-icon.icon-redo{background-position:-100px 0}.editor-default .editor-toolbar .editor-icon.icon-bold{background-position:0 0}.editor-default .editor-toolbar .editor-icon.icon-emphasis{background-position:0 -20px}.editor-default .editor-toolbar .editor-icon.icon-italic{background-position:-60px 0}.editor-default .editor-toolbar .editor-icon.icon-fontborder{background-position:-160px -40px}.editor-default .editor-toolbar .editor-icon.icon-underline{background-position:-140px 0}.editor-default .editor-toolbar .editor-icon.icon-strikethrough{background-position:-120px 0}.editor-default .editor-toolbar .editor-icon.icon-subscript{background-position:-600px 0}.editor-default .editor-toolbar .editor-icon.icon-superscript{background-position:-620px 0}.editor-default .editor-toolbar .editor-icon.icon-blockquote{background-position:-220px 0}.editor-default .editor-toolbar .editor-icon.icon-forecolor{background-image:none;width:32px!important}.editor-default .editor-toolbar .editor-icon.icon-forecolor:before{background-image:url(" + __webpack_require__(179) + ");background-position:-720px 0;height:20px!important;width:20px!important;content:\"\";display:inline-block}.editor-default .editor-toolbar .editor-icon.icon-forecolor:after{background-image:url(" + __webpack_require__(179) + ");background-position:-741px 0;height:20px!important;width:8px!important;content:\"\";display:inline-block}.editor-default .editor-toolbar .editor-icon.icon-backcolor{background-image:none;width:32px!important}.editor-default .editor-toolbar .editor-icon.icon-backcolor:before{background-image:url(" + __webpack_require__(179) + ");background-position:-760px 0;height:20px!important;width:20px!important;content:\"\";display:inline-block}.editor-default .editor-toolbar .editor-icon.icon-backcolor:after{background-image:url(" + __webpack_require__(179) + ");background-position:-741px 0;height:20px!important;width:8px!important;content:\"\";display:inline-block}.editor-default .editor-toolbar .editor-icon.icon-inserttable{background-position:-580px -20px}.editor-default .editor-toolbar .editor-icon.icon-autotypeset{background-position:-640px -40px}.editor-default .editor-toolbar .editor-icon.icon-justifyleft{background-position:-460px 0}.editor-default .editor-toolbar .editor-icon.icon-justifycenter{background-position:-420px 0}.editor-default .editor-toolbar .editor-icon.icon-justifyright{background-position:-480px 0}.editor-default .editor-toolbar .editor-icon.icon-justifyjustify{background-position:-440px 0}.editor-default .editor-toolbar .editor-icon.icon-insertorderedlist{background-position:-80px 0}.editor-default .editor-toolbar .editor-icon.icon-insertunorderedlist{background-position:-20px 0}.editor-default .editor-toolbar .editor-icon.icon-lineheight{background-position:-725px -40px}.editor-default .editor-toolbar .editor-icon.icon-rowspacingbottom{background-position:-745px -40px}.editor-default .editor-toolbar .editor-icon.icon-rowspacingtop{background-position:-765px -40px}.editor-default .editor-toolbar .editor-icon.icon-horizontal{background-position:-360px 0}.editor-default .editor-toolbar .editor-icon.icon-link{background-position:-500px 0}.editor-default .editor-toolbar .editor-icon.icon-code{background-position:-440px -40px}.editor-default .editor-toolbar .editor-icon.icon-image{background-position:-380px 0}.editor-default .editor-toolbar .editor-icon.icon-insertimage{background-position:-726px -77px}.editor-default .editor-toolbar .editor-icon.icon-insertframe{background-position:-240px -40px}.editor-default .editor-toolbar .editor-icon.icon-emotion{background-position:-60px -20px}.editor-default .editor-toolbar .editor-icon.icon-spechars{background-position:-240px 0}.editor-default .editor-toolbar .editor-icon.icon-help{background-position:-340px 0}.editor-default .editor-toolbar .editor-icon.icon-print{background-position:-440px -20px}.editor-default .editor-toolbar .editor-icon.icon-preview{background-position:-420px -20px}.editor-default .editor-toolbar .editor-icon.icon-selectall{background-position:-400px -20px}.editor-default .editor-toolbar .editor-icon.icon-searchreplace{background-position:-520px -20px}.editor-default .editor-toolbar .editor-icon.icon-map{background-position:-40px -40px}.editor-default .editor-toolbar .editor-icon.icon-gmap{background-position:-260px -40px}.editor-default .editor-toolbar .editor-icon.icon-insertvideo,.editor-default .editor-toolbar .editor-icon.icon-video{background-position:-320px -20px}.editor-default .editor-toolbar .editor-icon.icon-time{background-position:-160px -20px}.editor-default .editor-toolbar .editor-icon.icon-date{background-position:-140px -20px}.editor-default .editor-toolbar .editor-icon.icon-cut{background-position:-680px 0}.editor-default .editor-toolbar .editor-icon.icon-copy{background-position:-700px 0}.editor-default .editor-toolbar .editor-icon.icon-paste{background-position:-560px 0}.editor-default .editor-toolbar .editor-icon.icon-formatmatch{background-position:-40px 0}.editor-default .editor-toolbar .editor-icon.icon-pasteplain{background-position:-360px -20px}.editor-default .editor-toolbar .editor-icon.icon-directionalityltr{background-position:-20px -20px}.editor-default .editor-toolbar .editor-icon.icon-directionalityrtl{background-position:-40px -20px}.editor-default .editor-toolbar .editor-icon.icon-source{background-position:-261px 0}.editor-default .editor-toolbar .editor-icon.icon-removeformat{background-position:-580px 0}.editor-default .editor-toolbar .editor-icon.icon-unlink{background-position:-640px 0}.editor-default .editor-toolbar .editor-icon.icon-touppercase{background-position:-786px 0}.editor-default .editor-toolbar .editor-icon.icon-tolowercase{background-position:-806px 0}.editor-default .editor-toolbar .editor-icon.icon-insertrow{background-position:-478px -76px}.editor-default .editor-toolbar .editor-icon.icon-insertrownext{background-position:-498px -76px}.editor-default .editor-toolbar .editor-icon.icon-insertcol{background-position:-455px -76px}.editor-default .editor-toolbar .editor-icon.icon-insertcolnext{background-position:-429px -76px}.editor-default .editor-toolbar .editor-icon.icon-mergeright{background-position:-60px -40px}.editor-default .editor-toolbar .editor-icon.icon-mergedown{background-position:-80px -40px}.editor-default .editor-toolbar .editor-icon.icon-splittorows{background-position:-100px -40px}.editor-default .editor-toolbar .editor-icon.icon-splittocols{background-position:-120px -40px}.editor-default .editor-toolbar .editor-icon.icon-insertparagraphbeforetable{background-position:-140px 0}.editor-default .editor-toolbar .editor-icon.icon-deleterow{background-position:-660px -20px}.editor-default .editor-toolbar .editor-icon.icon-deletecol{background-position:-640px -20px}.editor-default .editor-toolbar .editor-icon.icon-splittocells{background-position:-800px -20px}.editor-default .editor-toolbar .editor-icon.icon-mergecells{background-position:-760px -20px}.editor-default .editor-toolbar .editor-icon.icon-deletetable{background-position:-620px -20px}.editor-default .editor-toolbar .editor-icon.icon-cleardoc{background-position:-520px 0}.editor-default .editor-toolbar .editor-icon.icon-fullscreen{background-position:-100px -20px}.editor-default .editor-toolbar .editor-icon.icon-anchor{background-position:-200px 0}.editor-default .editor-toolbar .editor-icon.icon-pagebreak{background-position:-460px -40px}.editor-default .editor-toolbar .editor-icon.icon-imagenone{background-position:-480px -40px}.editor-default .editor-toolbar .editor-icon.icon-imageleft{background-position:-500px -40px}.editor-default .editor-toolbar .editor-icon.icon-wordimage{background-position:-660px -40px}.editor-default .editor-toolbar .editor-icon.icon-imageright{background-position:-520px -40px}.editor-default .editor-toolbar .editor-icon.icon-imagecenter{background-position:-540px -40px}.editor-default .editor-toolbar .editor-icon.icon-indent{background-position:-400px 0}.editor-default .editor-toolbar .editor-icon.icon-outdent{background-position:-540px 0}.editor-default .editor-toolbar .editor-icon.icon-webapp{background-position:-601px -40px}.editor-default .editor-toolbar .editor-icon.icon-table{background-position:-580px -20px}.editor-default .editor-toolbar .editor-icon.icon-edittable{background-position:-420px -40px}.editor-default .editor-toolbar .editor-icon.icon-template{background-position:-339px -40px}.editor-default .editor-toolbar .editor-icon.icon-delete{background-position:-360px -40px}.editor-default .editor-toolbar .editor-icon.icon-attachment{background-position:-620px -40px}.editor-default .editor-toolbar .editor-icon.icon-edittd{background-position:-700px -40px}.editor-default .editor-toolbar .editor-icon.icon-snapscreen{background-position:-581px -40px}.editor-default .editor-toolbar .editor-icon.icon-scrawl{background-position:-801px -41px}.editor-default .editor-toolbar .editor-icon.icon-background{background-position:-680px -40px}.editor-default .editor-toolbar .editor-icon.icon-music{background-position:-18px -40px}.editor-default .editor-toolbar .editor-icon.icon-formula{background-position:-200px -40px}.editor-default .editor-toolbar .editor-icon.icon-aligntd{background-position:-236px -76px}.editor-default .editor-toolbar .editor-icon.icon-insertparagraphtrue{background-position:-625px -76px}.editor-default .editor-toolbar .editor-icon.icon-insertparagraph{background-position:-602px -76px}.editor-default .editor-toolbar .editor-icon.icon-insertcaption{background-position:-336px -76px}.editor-default .editor-toolbar .editor-icon.icon-deletecaption{background-position:-362px -76px}.editor-default .editor-toolbar .editor-icon.icon-inserttitle{background-position:-286px -76px}.editor-default .editor-toolbar .editor-icon.icon-deletetitle{background-position:-311px -76px}.editor-default .editor-toolbar .editor-icon.icon-aligntable{background-position:-440px 0}.editor-default .editor-toolbar .editor-icon.icon-tablealignment-left{background-position:-460px 0}.editor-default .editor-toolbar .editor-icon.icon-tablealignment-center{background-position:-420px 0}.editor-default .editor-toolbar .editor-icon.icon-tablealignment-right{background-position:-480px 0}.editor-default .editor-toolbar .editor-icon.icon-drafts{background-position:-560px 0}.editor-default .editor-toolbar .editor-icon.icon-charts{background:url(" + __webpack_require__(2034) + ") no-repeat 2px 3px!important}.editor-default .editor-toolbar .editor-icon.icon-inserttitlecol{background-position:-673px -76px}.editor-default .editor-toolbar .editor-icon.icon-deletetitlecol{background-position:-698px -76px}.editor-default .editor-toolbar .editor-icon.icon-simpleupload{background-position:-380px 0}.editor-default .editor-toolbar .editor-icon.icon-separator{background-position:-179px 1px;width:2px!important;padding:1px 2px}.editor-default .editor-toolbar .editor-icon.icon-fontfamily,.editor-default .editor-toolbar .editor-icon.icon-fontsize,.editor-default .editor-toolbar .editor-icon.icon-paragraph{background-image:none;background-color:transparent;border:1px solid #ccc;width:80px}.editor-default .editor-toolbar .editor-icon.icon-fontfamily:hover,.editor-default .editor-toolbar .editor-icon.icon-fontsize:hover,.editor-default .editor-toolbar .editor-icon.icon-paragraph:hover{background-color:#d5e1f2;padding:0;border:1px solid #a3bde3}.editor-default .editor-toolbar .editor-icon.icon-fontfamily .icon-label,.editor-default .editor-toolbar .editor-icon.icon-fontsize .icon-label,.editor-default .editor-toolbar .editor-icon.icon-paragraph .icon-label{display:inline-block;vertical-align:top;width:65px;height:20px;line-height:20px;padding:0;margin:0;font-size:12px;text-align:center;cursor:default;overflow:hidden}.editor-default .editor-toolbar .editor-icon.icon-fontfamily .icon-caret,.editor-default .editor-toolbar .editor-icon.icon-fontsize .icon-caret,.editor-default .editor-toolbar .editor-icon.icon-paragraph .icon-caret{display:inline-block;vertical-align:top;height:20px;width:12px;margin:0;padding:0;background:url(" + __webpack_require__(179) + ") -741px 0}.editor-default .editor-contenteditable-div p{margin:5px 0}.editor-default .editor-contenteditable-div table{margin-bottom:10px;border-collapse:collapse;display:table}.editor-default .editor-contenteditable-div table td,.editor-default .editor-contenteditable-div table th{padding:5px 10px;border:1px solid #d8d8d8;font-size:16px;vertical-align:top;height:18px}", ""]);
	
	// exports


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".editor-container .editor-contenteditable-div{position:relative;left:0;top:0;padding:5px}.editor-container .tab-group .tab-nav{margin:0;padding:0;border-bottom:1px solid #ddd;list-style:none;height:30px;line-height:10px}.editor-container .image-dialog .tab-panel .search-bar .image-searchTxt{display:inline-block!important;width:400px;border:1px solid #c5d2ff;height:25px;line-height:18px;font-size:14px;padding:3px;margin:0;outline:0}", ""]);
	
	// exports


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror-foldmarker{color:blue;text-shadow:#b9f 1px 1px 2px,#b9f -1px -1px 2px,#b9f 1px -1px 2px,#b9f -1px 1px 2px;font-family:arial;line-height:.3;cursor:pointer}.CodeMirror-foldgutter{width:.7em}.CodeMirror-foldgutter-folded,.CodeMirror-foldgutter-open{cursor:pointer}.CodeMirror-foldgutter-open:after{content:\"\\25BE\"}.CodeMirror-foldgutter-folded:after{content:\"\\25B8\"}", ""]);
	
	// exports


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror-hints{position:absolute;z-index:10;overflow:hidden;list-style:none;margin:0;padding:2px;box-shadow:2px 3px 5px rgba(0,0,0,.2);border-radius:3px;border:1px solid silver;background:#fff;font-size:90%;font-family:monospace;max-height:20em;overflow-y:auto;box-sizing:border-box}.CodeMirror-hint{margin:0;padding:0 4px;border-radius:2px;white-space:pre;color:#000;cursor:pointer}li.CodeMirror-hint-active{background:#08f;color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror-lint-markers{width:16px}.CodeMirror-lint-tooltip{background-color:#ffd;border:1px solid #000;border-radius:4px 4px 4px 4px;color:#000;font-family:monospace;font-size:10pt;overflow:hidden;padding:2px 5px;position:fixed;white-space:pre;white-space:pre-wrap;z-index:100;max-width:600px;opacity:0;transition:opacity .4s;-moz-transition:opacity .4s;-webkit-transition:opacity .4s;-o-transition:opacity .4s;-ms-transition:opacity .4s}.CodeMirror-lint-mark{background-position:0 100%;background-repeat:repeat-x}.CodeMirror-lint-mark-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJFhQXEbhTg7YAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAMklEQVQI12NkgIIvJ3QXMjAwdDN+OaEbysDA4MPAwNDNwMCwiOHLCd1zX07o6kBVGQEAKBANtobskNMAAAAASUVORK5CYII=\")}.CodeMirror-lint-mark-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJDw4cOCW1/KIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAHElEQVQI12NggIL/DAz/GdA5/xkY/qPKMDAwAADLZwf5rvm+LQAAAABJRU5ErkJggg==\")}.CodeMirror-lint-marker{background-position:50%;background-repeat:no-repeat;cursor:pointer;display:inline-block;height:16px;width:16px;vertical-align:middle;position:relative}.CodeMirror-lint-message{padding-left:18px;background-position:0 0;background-repeat:no-repeat}.CodeMirror-lint-marker-warning,.CodeMirror-lint-message-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX/uwDvrwD/uwD/uwD/uwD/uwD/uwD/uwD/uwD6twD/uwAAAADurwD2tQD7uAD+ugAAAAD/uwDhmeTRAAAADHRSTlMJ8mN1EYcbmiixgACm7WbuAAAAVklEQVR42n3PUQqAIBBFUU1LLc3u/jdbOJoW1P08DA9Gba8+YWJ6gNJoNYIBzAA2chBth5kLmG9YUoG0NHAUwFXwO9LuBQL1giCQb8gC9Oro2vp5rncCIY8L8uEx5ZkAAAAASUVORK5CYII=\")}.CodeMirror-lint-marker-error,.CodeMirror-lint-message-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAHlBMVEW7AAC7AACxAAC7AAC7AAAAAAC4AAC5AAD///+7AAAUdclpAAAABnRSTlMXnORSiwCK0ZKSAAAATUlEQVR42mWPOQ7AQAgDuQLx/z8csYRmPRIFIwRGnosRrpamvkKi0FTIiMASR3hhKW+hAN6/tIWhu9PDWiTGNEkTtIOucA5Oyr9ckPgAWm0GPBog6v4AAAAASUVORK5CYII=\")}.CodeMirror-lint-marker-multiple{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAMAAADzjKfhAAAACVBMVEUAAAAAAAC/v7914kyHAAAAAXRSTlMAQObYZgAAACNJREFUeNo1ioEJAAAIwmz/H90iFFSGJgFMe3gaLZ0od+9/AQZ0ADosbYraAAAAAElFTkSuQmCC\");background-repeat:no-repeat;background-position:100% 100%;width:100%;height:100%}.CodeMirror-lint-line-error{background-color:rgba(183,76,81,.08)}.CodeMirror-lint-line-warning{background-color:rgba(255,211,0,.1)}", ""]);
	
	// exports


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror-search-match{background:gold;border-top:1px solid orange;border-bottom:1px solid orange;box-sizing:border-box;opacity:.5}", ""]);
	
	// exports


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror{font-family:monospace;height:300px;color:#000;direction:ltr}.CodeMirror-lines{padding:4px 0}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{padding:0 4px}.CodeMirror-gutter-filler,.CodeMirror-scrollbar-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror-cursor{border-left:1px solid #000;border-right:none;width:0}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.cm-fat-cursor .CodeMirror-cursor{width:auto;border:0!important;background:#7e7}.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-fat-cursor .CodeMirror-line::selection,.cm-fat-cursor .CodeMirror-line>span::selection,.cm-fat-cursor .CodeMirror-line>span>span::selection{background:transparent}.cm-fat-cursor .CodeMirror-line::-moz-selection,.cm-fat-cursor .CodeMirror-line>span::-moz-selection,.cm-fat-cursor .CodeMirror-line>span>span::-moz-selection{background:transparent}.cm-fat-cursor{caret-color:transparent}@keyframes blink{50%{background-color:transparent}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-rulers{position:absolute;left:0;right:0;top:-50px;bottom:0;overflow:hidden}.CodeMirror-ruler{border-left:1px solid #ccc;top:0;bottom:0;position:absolute}.cm-s-default .cm-header{color:blue}.cm-s-default .cm-quote{color:#090}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-type,.cm-s-default .cm-variable-3{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-invalidchar,.cm-s-default .cm-error{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0b0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#a22}.CodeMirror-matchingtag{background:rgba(255,150,0,.3)}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-50px;margin-right:-50px;padding-bottom:50px;height:100%;outline:none;position:relative;z-index:0}.CodeMirror-sizer{position:relative;border-right:50px solid transparent}.CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none;outline:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;min-height:100%;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;vertical-align:top;margin-bottom:-50px}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;background:none!important;border:none!important}.CodeMirror-gutter-background{position:absolute;top:0;bottom:0;z-index:4}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper ::selection{background-color:transparent}.CodeMirror-gutter-wrapper ::-moz-selection{background-color:transparent}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{border-radius:0;border-width:0;background:transparent;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent;font-variant-ligatures:contextual}.CodeMirror-wrap pre.CodeMirror-line,.CodeMirror-wrap pre.CodeMirror-line-like{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;padding:.1px}.CodeMirror-rtl pre{direction:rtl}.CodeMirror-code{outline:none}.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber,.CodeMirror-scroll,.CodeMirror-sizer{box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-cursor{position:absolute;pointer-events:none}.CodeMirror-measure pre{position:static}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}.CodeMirror-focused div.CodeMirror-cursors,div.CodeMirror-dragcursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror-line::selection,.CodeMirror-line>span::selection,.CodeMirror-line>span>span::selection{background:#d7d4f0}.CodeMirror-line::-moz-selection,.CodeMirror-line>span::-moz-selection,.CodeMirror-line>span>span::-moz-selection{background:#d7d4f0}.cm-searching{background-color:#ffa;background-color:rgba(255,255,0,.4)}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:\"\"}span.CodeMirror-selectedtext{background:none}", ""]);
	
	// exports


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".cm-s-monokai.CodeMirror{background:#272822;color:#f8f8f2}.cm-s-monokai div.CodeMirror-selected{background:#49483e}.cm-s-monokai .CodeMirror-line::selection,.cm-s-monokai .CodeMirror-line>span::selection,.cm-s-monokai .CodeMirror-line>span>span::selection{background:rgba(73,72,62,.99)}.cm-s-monokai .CodeMirror-line::-moz-selection,.cm-s-monokai .CodeMirror-line>span::-moz-selection,.cm-s-monokai .CodeMirror-line>span>span::-moz-selection{background:rgba(73,72,62,.99)}.cm-s-monokai .CodeMirror-gutters{background:#272822;border-right:0}.cm-s-monokai .CodeMirror-guttermarker{color:#fff}.cm-s-monokai .CodeMirror-guttermarker-subtle,.cm-s-monokai .CodeMirror-linenumber{color:#d0d0d0}.cm-s-monokai .CodeMirror-cursor{border-left:1px solid #f8f8f0}.cm-s-monokai span.cm-comment{color:#75715e}.cm-s-monokai span.cm-atom,.cm-s-monokai span.cm-number{color:#ae81ff}.cm-s-monokai span.cm-comment.cm-attribute{color:#97b757}.cm-s-monokai span.cm-comment.cm-def{color:#bc9262}.cm-s-monokai span.cm-comment.cm-tag{color:#bc6283}.cm-s-monokai span.cm-comment.cm-type{color:#5998a6}.cm-s-monokai span.cm-attribute,.cm-s-monokai span.cm-property{color:#a6e22e}.cm-s-monokai span.cm-keyword{color:#f92672}.cm-s-monokai span.cm-builtin{color:#66d9ef}.cm-s-monokai span.cm-string{color:#e6db74}.cm-s-monokai span.cm-variable{color:#f8f8f2}.cm-s-monokai span.cm-variable-2{color:#9effff}.cm-s-monokai span.cm-type,.cm-s-monokai span.cm-variable-3{color:#66d9ef}.cm-s-monokai span.cm-def{color:#fd971f}.cm-s-monokai span.cm-bracket{color:#f8f8f2}.cm-s-monokai span.cm-tag{color:#f92672}.cm-s-monokai span.cm-header,.cm-s-monokai span.cm-link{color:#ae81ff}.cm-s-monokai span.cm-error{background:#f92672;color:#f8f8f0}.cm-s-monokai .CodeMirror-activeline-background{background:#373831}.cm-s-monokai .CodeMirror-matchingbracket{text-decoration:underline;color:#fff!important}", ""]);
	
	// exports


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".jsoneditor-modal input,.jsoneditor-modal input:not([type]),.jsoneditor-modal input[type=search],.jsoneditor-modal input[type=text],.jsoneditor input,.jsoneditor input:not([type]),.jsoneditor input[type=search],.jsoneditor input[type=text]{height:auto;border:inherit;box-shadow:none;font-size:inherit;box-sizing:inherit;padding:inherit;font-family:inherit;transition:none;line-height:inherit}.jsoneditor-modal input:focus,.jsoneditor-modal input:not([type]):focus,.jsoneditor-modal input[type=search]:focus,.jsoneditor-modal input[type=text]:focus,.jsoneditor input:focus,.jsoneditor input:not([type]):focus,.jsoneditor input[type=search]:focus,.jsoneditor input[type=text]:focus{border:inherit;box-shadow:inherit}.jsoneditor-modal textarea,.jsoneditor textarea{height:inherit}.jsoneditor-modal select,.jsoneditor select{display:inherit;height:inherit}.jsoneditor-modal label,.jsoneditor label{font-size:inherit;font-weight:inherit;color:inherit}.jsoneditor-modal table,.jsoneditor table{border-collapse:collapse;width:auto}.jsoneditor-modal td,.jsoneditor-modal th,.jsoneditor td,.jsoneditor th{padding:0;display:table-cell;text-align:left;vertical-align:inherit;border-radius:inherit}.jsoneditor .autocomplete.dropdown{position:absolute;background:#fff;box-shadow:2px 2px 12px hsla(0,0%,50%,.3);border:1px solid #d3d3d3;overflow-x:hidden;overflow-y:auto;cursor:default;margin:0;padding:5px;text-align:left;outline:0;font-family:dejavu sans mono,droid sans mono,consolas,monaco,lucida console,courier new,courier,monospace,sans-serif;font-size:10pt}.jsoneditor .autocomplete.dropdown .item{color:#333}.jsoneditor .autocomplete.dropdown .item.hover{background-color:#ddd}.jsoneditor .autocomplete.hint{color:#aaa;top:4px;left:4px}.jsoneditor-contextmenu-root{position:relative;width:0;height:0}.jsoneditor-contextmenu{position:absolute;box-sizing:content-box;z-index:1}.jsoneditor-contextmenu .jsoneditor-menu{position:relative;left:0;top:0;width:128px;height:auto;background:#fff;border:1px solid #d3d3d3;box-shadow:2px 2px 12px hsla(0,0%,50%,.3);list-style:none;margin:0;padding:0}.jsoneditor-contextmenu .jsoneditor-menu button{position:relative;padding:0 4px 0 0;margin:0;width:128px;height:auto;border:none;cursor:pointer;color:#4d4d4d;background:0 0;font-size:10pt;font-family:arial,sans-serif;box-sizing:border-box;text-align:left}.jsoneditor-contextmenu .jsoneditor-menu button::-moz-focus-inner{padding:0;border:0}.jsoneditor-contextmenu .jsoneditor-menu button.jsoneditor-default{width:96px}.jsoneditor-contextmenu .jsoneditor-menu button.jsoneditor-expand{float:right;width:32px;height:24px;border-left:1px solid #e5e5e5}.jsoneditor-contextmenu .jsoneditor-menu li{overflow:hidden}.jsoneditor-contextmenu .jsoneditor-menu li ul{display:none;position:relative;left:-10px;top:0;border:none;box-shadow:inset 0 0 10px hsla(0,0%,50%,.5);padding:0 10px;transition:all .3s ease-out}.jsoneditor-contextmenu .jsoneditor-menu li ul .jsoneditor-icon{margin-left:24px}.jsoneditor-contextmenu .jsoneditor-menu li ul li button{padding-left:24px;animation:all ease-in-out 1s}.jsoneditor-contextmenu .jsoneditor-menu li button .jsoneditor-expand{position:absolute;top:0;right:0;width:24px;height:24px;padding:0;margin:0 4px 0 0;background:url(" + __webpack_require__(99) + ") 0 -72px}.jsoneditor-contextmenu .jsoneditor-icon{position:absolute;top:0;left:0;width:24px;height:24px;border:none;padding:0;margin:0;background-image:url(" + __webpack_require__(99) + ")}.jsoneditor-contextmenu .jsoneditor-text{padding:4px 0 4px 24px;word-wrap:break-word}.jsoneditor-contextmenu .jsoneditor-text.jsoneditor-right-margin{padding-right:24px}.jsoneditor-contextmenu .jsoneditor-separator{height:0;border-top:1px solid #e5e5e5;padding-top:5px;margin-top:5px}.jsoneditor-contextmenu button.jsoneditor-remove .jsoneditor-icon{background-position:-24px 0}.jsoneditor-contextmenu button.jsoneditor-append .jsoneditor-icon,.jsoneditor-contextmenu button.jsoneditor-insert .jsoneditor-icon{background-position:0 0}.jsoneditor-contextmenu button.jsoneditor-duplicate .jsoneditor-icon{background-position:-48px 0}.jsoneditor-contextmenu button.jsoneditor-sort-asc .jsoneditor-icon{background-position:-168px 0}.jsoneditor-contextmenu button.jsoneditor-sort-desc .jsoneditor-icon{background-position:-192px 0}.jsoneditor-contextmenu button.jsoneditor-transform .jsoneditor-icon{background-position:-216px 0}.jsoneditor-contextmenu button.jsoneditor-extract .jsoneditor-icon{background-position:0 -24px}.jsoneditor-contextmenu button.jsoneditor-type-string .jsoneditor-icon{background-position:-144px 0}.jsoneditor-contextmenu button.jsoneditor-type-auto .jsoneditor-icon{background-position:-120px 0}.jsoneditor-contextmenu button.jsoneditor-type-object .jsoneditor-icon{background-position:-72px 0}.jsoneditor-contextmenu button.jsoneditor-type-array .jsoneditor-icon{background-position:-96px 0}.jsoneditor-contextmenu button.jsoneditor-type-modes .jsoneditor-icon{background-image:none;width:6px}.jsoneditor-contextmenu li,.jsoneditor-contextmenu ul{box-sizing:content-box;position:relative}.jsoneditor-contextmenu .jsoneditor-menu button:focus,.jsoneditor-contextmenu .jsoneditor-menu button:hover{color:#1a1a1a;background-color:#f5f5f5;outline:0}.jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected,.jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected:focus,.jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected:hover{color:#fff;background-color:#ee422e}.jsoneditor-contextmenu .jsoneditor-menu li ul li button:focus,.jsoneditor-contextmenu .jsoneditor-menu li ul li button:hover{background-color:#f5f5f5}.jsoneditor-modal{max-width:95%;border-radius:2px!important;padding:45px 15px 15px!important;box-shadow:2px 2px 12px hsla(0,0%,50%,.3);color:#4d4d4d;line-height:1.3em}.jsoneditor-modal.jsoneditor-modal-transform{width:600px!important}.jsoneditor-modal .pico-modal-header{position:absolute;box-sizing:border-box;top:0;left:0;width:100%;padding:0 10px;height:30px;line-height:30px;font-family:arial,sans-serif;font-size:11pt;background:#3883fa;color:#fff}.jsoneditor-modal table{width:100%}.jsoneditor-modal table td{padding:3px 0}.jsoneditor-modal table td.jsoneditor-modal-input{text-align:right;padding-right:0;white-space:nowrap}.jsoneditor-modal table td.jsoneditor-modal-actions{padding-top:15px}.jsoneditor-modal table th{vertical-align:middle}.jsoneditor-modal p:first-child{margin-top:0}.jsoneditor-modal a{color:#3883fa}.jsoneditor-modal .jsoneditor-jmespath-block{margin-bottom:10px}.jsoneditor-modal .pico-close{background:0 0!important;font-size:24px!important;top:7px!important;right:7px!important;color:#fff}.jsoneditor-modal input{padding:4px}.jsoneditor-modal input[type=text]{cursor:inherit}.jsoneditor-modal input[disabled]{background:#d3d3d3;color:grey}.jsoneditor-modal .jsoneditor-select-wrapper{position:relative;display:inline-block}.jsoneditor-modal .jsoneditor-select-wrapper:after{content:\"\";width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:6px solid #666;position:absolute;right:8px;top:14px;pointer-events:none}.jsoneditor-modal select{padding:3px 24px 3px 10px;min-width:180px;max-width:350px;-moz-appearance:none;appearance:none;text-indent:0;text-overflow:\"\";font-size:10pt;line-height:1.5em}.jsoneditor-modal select::-ms-expand{display:none}.jsoneditor-modal .jsoneditor-button-group input{padding:4px 10px;margin:0;border-radius:0;border-left-style:none}.jsoneditor-modal .jsoneditor-button-group input.jsoneditor-button-first{border-top-left-radius:3px;border-bottom-left-radius:3px;border-left-style:solid}.jsoneditor-modal .jsoneditor-button-group input.jsoneditor-button-last{border-top-right-radius:3px;border-bottom-right-radius:3px}.jsoneditor-modal .jsoneditor-transform-preview{background:#f5f5f5;height:200px}.jsoneditor-modal .jsoneditor-transform-preview.jsoneditor-error{color:#ee422e}.jsoneditor-modal .jsoneditor-jmespath-wizard{line-height:1.2em;width:100%;padding:0;border-radius:3px}.jsoneditor-modal .jsoneditor-jmespath-label{font-weight:700;color:#1e90ff;margin-top:20px;margin-bottom:5px}.jsoneditor-modal .jsoneditor-jmespath-wizard-table{width:100%;border-collapse:collapse}.jsoneditor-modal .jsoneditor-jmespath-wizard-label{font-style:italic;margin:4px 0 2px}.jsoneditor-modal .jsoneditor-inline{position:relative;display:inline-block;width:100%;padding-top:2px;padding-bottom:2px}.jsoneditor-modal .jsoneditor-inline:not(:last-child){padding-right:2px}.jsoneditor-modal .jsoneditor-jmespath-filter{display:flex;flex-wrap:wrap}.jsoneditor-modal .jsoneditor-jmespath-filter-field{width:180px}.jsoneditor-modal .jsoneditor-jmespath-filter-relation{width:100px}.jsoneditor-modal .jsoneditor-jmespath-filter-value{min-width:180px;flex:1}.jsoneditor-modal .jsoneditor-jmespath-sort-field{width:170px}.jsoneditor-modal .jsoneditor-jmespath-sort-order{width:150px}.jsoneditor-modal .jsoneditor-jmespath-select-fields{width:100%}.jsoneditor-modal .selectr-selected{border-color:#d3d3d3;padding:4px 28px 4px 8px}.jsoneditor-modal .selectr-selected .selectr-tag{background-color:#3883fa;border-radius:5px}.jsoneditor-modal table td,.jsoneditor-modal table th{text-align:left;vertical-align:middle;font-weight:400;color:#4d4d4d;border-spacing:0;border-collapse:collapse}.jsoneditor-modal #query,.jsoneditor-modal input,.jsoneditor-modal input[type=text],.jsoneditor-modal input[type=text]:focus,.jsoneditor-modal select,.jsoneditor-modal textarea{background:#fff;border:1px solid #d3d3d3;color:#4d4d4d;border-radius:3px;padding:4px}.jsoneditor-modal,.jsoneditor-modal #query,.jsoneditor-modal input,.jsoneditor-modal input[type=text],.jsoneditor-modal option,.jsoneditor-modal select,.jsoneditor-modal table td,.jsoneditor-modal table th,.jsoneditor-modal textarea{font-size:10.5pt;font-family:arial,sans-serif}.jsoneditor-modal #query,.jsoneditor-modal .jsoneditor-transform-preview{font-family:dejavu sans mono,droid sans mono,consolas,monaco,lucida console,courier new,courier,monospace,sans-serif;font-size:10pt;width:100%;box-sizing:border-box}.jsoneditor-modal input[type=button],.jsoneditor-modal input[type=submit]{background:#f5f5f5;padding:4px 20px}.jsoneditor-modal input,.jsoneditor-modal select{cursor:pointer}.jsoneditor-modal .jsoneditor-button-group.jsoneditor-button-group-value-asc input.jsoneditor-button-asc,.jsoneditor-modal .jsoneditor-button-group.jsoneditor-button-group-value-desc input.jsoneditor-button-desc{background:#3883fa;border-color:#3883fa;color:#fff}.jsoneditor{color:#1a1a1a;border:thin solid #3883fa;box-sizing:border-box;width:100%;height:100%;position:relative;padding:0;line-height:100%}div.jsoneditor-default,div.jsoneditor-field,div.jsoneditor-readonly,div.jsoneditor-value{border:1px solid transparent;min-height:16px;min-width:32px;padding:2px;margin:1px;word-wrap:break-word;float:left}div.jsoneditor-field p,div.jsoneditor-value p{margin:0}div.jsoneditor-value{word-break:break-word}div.jsoneditor-value.jsoneditor-empty:after{content:\"value\"}div.jsoneditor-value.jsoneditor-string{color:#006000}div.jsoneditor-value.jsoneditor-number{color:#ee422e}div.jsoneditor-value.jsoneditor-boolean{color:#ff8c00}div.jsoneditor-value.jsoneditor-null{color:#004ed0}div.jsoneditor-value.jsoneditor-invalid{color:#000}div.jsoneditor-readonly{min-width:16px;color:grey}div.jsoneditor-empty{border-color:#d3d3d3;border-style:dashed;border-radius:2px}div.jsoneditor-field.jsoneditor-empty:after{content:\"field\"}div.jsoneditor td{vertical-align:top}div.jsoneditor td.jsoneditor-separator{padding:3px 0;vertical-align:top;color:grey}div.jsoneditor td.jsoneditor-tree{vertical-align:top}div.jsoneditor.busy pre.jsoneditor-preview{background:#f5f5f5;color:grey}div.jsoneditor.busy div.jsoneditor-busy{display:inherit}div.jsoneditor code.jsoneditor-preview{background:0 0}div.jsoneditor.jsoneditor-mode-preview pre.jsoneditor-preview{width:100%;height:100%;box-sizing:border-box;overflow:auto;padding:2px;margin:0;white-space:pre-wrap;word-break:break-all}div.jsoneditor-default{color:grey;padding-left:10px}div.jsoneditor-tree{width:100%;height:100%;position:relative;overflow:auto}div.jsoneditor-tree button.jsoneditor-button{width:24px;height:24px;padding:0;margin:0;border:none;cursor:pointer;background:transparent url(" + __webpack_require__(99) + ")}div.jsoneditor-tree button.jsoneditor-button:focus{background-color:#f5f5f5;outline:1px solid #e5e5e5}div.jsoneditor-tree button.jsoneditor-collapsed{background-position:0 -48px}div.jsoneditor-tree button.jsoneditor-expanded{background-position:0 -72px}div.jsoneditor-tree button.jsoneditor-contextmenu-button{background-position:-48px -72px}div.jsoneditor-tree button.jsoneditor-invisible{visibility:hidden;background:0 0}div.jsoneditor-tree button.jsoneditor-dragarea{background:url(" + __webpack_require__(99) + ") -72px -72px;cursor:move}div.jsoneditor-tree :focus{outline:0}div.jsoneditor-tree div.jsoneditor-show-more{display:inline-block;padding:3px 4px;margin:2px 0;background-color:#e5e5e5;border-radius:3px;color:grey;font-family:arial,sans-serif;font-size:10pt}div.jsoneditor-tree div.jsoneditor-show-more a{display:inline-block;color:grey}div.jsoneditor-tree div.jsoneditor-color{display:inline-block;width:12px;height:12px;margin:4px;border:1px solid grey;cursor:pointer}div.jsoneditor-tree div.jsoneditor-date{background:#a1a1a1;color:#fff;font-family:arial,sans-serif;border-radius:3px;display:inline-block;padding:3px;margin:0 3px}div.jsoneditor-tree table.jsoneditor-tree{border-collapse:collapse;border-spacing:0;width:100%}div.jsoneditor-tree .jsoneditor-button.jsoneditor-schema-error{width:24px;height:24px;padding:0;margin:0 4px 0 0;background:url(" + __webpack_require__(99) + ") -168px -48px}div.jsoneditor-outer{position:static;width:100%;height:100%;margin:0;padding:0;box-sizing:border-box}div.jsoneditor-outer.has-nav-bar{margin-top:-26px;padding-top:26px}div.jsoneditor-outer.has-nav-bar.has-main-menu-bar{margin-top:-61px;padding-top:61px}div.jsoneditor-outer.has-status-bar{margin-bottom:-26px;padding-bottom:26px}div.jsoneditor-outer.has-main-menu-bar{margin-top:-35px;padding-top:35px}div.jsoneditor-busy{position:absolute;top:15%;left:0;box-sizing:border-box;width:100%;text-align:center;display:none}div.jsoneditor-busy span{background-color:#ffffab;border:1px solid #fe0;border-radius:3px;padding:5px 15px;box-shadow:0 0 5px rgba(0,0,0,.4)}div.jsoneditor-field.jsoneditor-empty:after,div.jsoneditor-value.jsoneditor-empty:after{pointer-events:none;color:#d3d3d3;font-size:8pt}a.jsoneditor-value.jsoneditor-url,div.jsoneditor-value.jsoneditor-url{color:#006000;text-decoration:underline}a.jsoneditor-value.jsoneditor-url{display:inline-block;padding:2px;margin:2px}a.jsoneditor-value.jsoneditor-url:focus,a.jsoneditor-value.jsoneditor-url:hover{color:#ee422e}div.jsoneditor-field.jsoneditor-highlight,div.jsoneditor-field[contenteditable=true]:focus,div.jsoneditor-field[contenteditable=true]:hover,div.jsoneditor-value.jsoneditor-highlight,div.jsoneditor-value[contenteditable=true]:focus,div.jsoneditor-value[contenteditable=true]:hover{background-color:#ffffab;border:1px solid #fe0;border-radius:2px}div.jsoneditor-field.jsoneditor-highlight-active,div.jsoneditor-field.jsoneditor-highlight-active:focus,div.jsoneditor-field.jsoneditor-highlight-active:hover,div.jsoneditor-value.jsoneditor-highlight-active,div.jsoneditor-value.jsoneditor-highlight-active:focus,div.jsoneditor-value.jsoneditor-highlight-active:hover{background-color:#fe0;border:1px solid #ffc700;border-radius:2px}div.jsoneditor-value.jsoneditor-array,div.jsoneditor-value.jsoneditor-object{min-width:16px}div.jsoneditor-tree button.jsoneditor-contextmenu-button.jsoneditor-selected,div.jsoneditor-tree button.jsoneditor-contextmenu-button:focus,div.jsoneditor-tree button.jsoneditor-contextmenu-button:hover,tr.jsoneditor-selected.jsoneditor-first button.jsoneditor-contextmenu-button{background-position:-48px -48px}div.jsoneditor-tree div.jsoneditor-show-more a:focus,div.jsoneditor-tree div.jsoneditor-show-more a:hover{color:#ee422e}.ace-jsoneditor,textarea.jsoneditor-text{min-height:150px}.ace-jsoneditor *,textarea.jsoneditor-text *{font-family:dejavu sans mono,droid sans mono,consolas,monaco,lucida console,courier new,courier,monospace,sans-serif}textarea.jsoneditor-text{width:100%;height:100%;margin:0;box-sizing:border-box;outline-width:0;border:none;background-color:#fff;resize:none}tr.jsoneditor-highlight,tr.jsoneditor-selected{background-color:#d3d3d3}tr.jsoneditor-selected button.jsoneditor-contextmenu-button,tr.jsoneditor-selected button.jsoneditor-dragarea{visibility:hidden}tr.jsoneditor-selected.jsoneditor-first button.jsoneditor-contextmenu-button,tr.jsoneditor-selected.jsoneditor-first button.jsoneditor-dragarea{visibility:visible}div.jsoneditor-tree button.jsoneditor-dragarea:focus,div.jsoneditor-tree button.jsoneditor-dragarea:hover,tr.jsoneditor-selected.jsoneditor-first button.jsoneditor-dragarea{background-position:-72px -48px}div.jsoneditor td,div.jsoneditor th,div.jsoneditor tr{padding:0;margin:0}.jsoneditor-popover,.jsoneditor-schema-error,div.jsoneditor-field,div.jsoneditor-value,div.jsoneditor td,div.jsoneditor textarea,div.jsoneditor th,pre.jsoneditor-preview{font-family:dejavu sans mono,droid sans mono,consolas,monaco,lucida console,courier new,courier,monospace,sans-serif;font-size:10pt;color:#1a1a1a}.jsoneditor-schema-error{cursor:default;display:inline-block;height:24px;line-height:24px;position:relative;text-align:center;width:24px}.jsoneditor-popover{background-color:#4c4c4c;border-radius:3px;box-shadow:0 0 5px rgba(0,0,0,.4);color:#fff;padding:7px 10px;position:absolute;cursor:auto;width:200px}.jsoneditor-popover.jsoneditor-above{bottom:32px;left:-98px}.jsoneditor-popover.jsoneditor-above:before{border-top:7px solid #4c4c4c;bottom:-7px}.jsoneditor-popover.jsoneditor-below{top:32px;left:-98px}.jsoneditor-popover.jsoneditor-below:before{border-bottom:7px solid #4c4c4c;top:-7px}.jsoneditor-popover.jsoneditor-left{top:-7px;right:32px}.jsoneditor-popover.jsoneditor-left:before{border-left:7px solid #4c4c4c;border-top:7px solid transparent;border-bottom:7px solid transparent;content:\"\";top:19px;right:-14px;left:inherit;margin-left:inherit;margin-top:-7px;position:absolute}.jsoneditor-popover.jsoneditor-right{top:-7px;left:32px}.jsoneditor-popover.jsoneditor-right:before{border-right:7px solid #4c4c4c;border-top:7px solid transparent;border-bottom:7px solid transparent;content:\"\";top:19px;left:-14px;margin-left:inherit;margin-top:-7px;position:absolute}.jsoneditor-popover:before{border-right:7px solid transparent;border-left:7px solid transparent;content:\"\";display:block;left:50%;margin-left:-7px;position:absolute}.jsoneditor-text-errors tr.jump-to-line:hover{text-decoration:underline;cursor:pointer}.jsoneditor-schema-error:focus .jsoneditor-popover,.jsoneditor-schema-error:hover .jsoneditor-popover{display:block;animation:fade-in .3s linear 1,move-up .3s linear 1}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.jsoneditor .jsoneditor-validation-errors-container{max-height:130px;overflow-y:auto}.jsoneditor .jsoneditor-validation-errors{width:100%;overflow:hidden}.jsoneditor .jsoneditor-additional-errors{position:absolute;margin:auto;bottom:31px;left:calc(50% - 92px);color:grey;background-color:#ebebeb;padding:7px 15px;border-radius:8px}.jsoneditor .jsoneditor-additional-errors.visible{visibility:visible;opacity:1;transition:opacity 2s linear}.jsoneditor .jsoneditor-additional-errors.hidden{visibility:hidden;opacity:0;transition:visibility 0s 2s,opacity 2s linear}.jsoneditor .jsoneditor-text-errors{width:100%;border-collapse:collapse;border-top:1px solid #ffc700}.jsoneditor .jsoneditor-text-errors td{padding:3px 6px;vertical-align:middle}.jsoneditor .jsoneditor-text-errors td pre{margin:0;white-space:normal}.jsoneditor .jsoneditor-text-errors tr{background-color:#ffffab}.jsoneditor .jsoneditor-text-errors tr.parse-error{background-color:#ee2e2e70}.jsoneditor-text-errors .jsoneditor-schema-error{border:none;width:24px;height:24px;padding:0;margin:0 4px 0 0;cursor:pointer}.jsoneditor-text-errors tr .jsoneditor-schema-error{background:url(" + __webpack_require__(99) + ") -168px -48px}.jsoneditor-text-errors tr.parse-error .jsoneditor-schema-error{background:url(" + __webpack_require__(99) + ") -25px 0}.jsoneditor-anchor{cursor:pointer}.jsoneditor-anchor .picker_wrapper.popup.popup_bottom{top:28px;left:-10px}.fadein{animation:fadein .3s;-moz-animation:fadein .3s;-o-animation:fadein .3s}@keyframes fadein{0%{opacity:0}to{opacity:1}}.jsoneditor-modal input[type=search].selectr-input{border:1px solid #d3d3d3;width:calc(100% - 4px);margin:2px;padding:4px;box-sizing:border-box}.jsoneditor-modal button.selectr-input-clear{right:8px}.jsoneditor-menu{width:100%;height:35px;padding:2px;margin:0;box-sizing:border-box;color:#fff;background-color:#3883fa;border-bottom:1px solid #3883fa}.jsoneditor-menu>.jsoneditor-modes>button,.jsoneditor-menu>button{width:26px;height:26px;margin:2px;padding:0;border-radius:2px;border:1px solid transparent;background:transparent url(" + __webpack_require__(99) + ");color:#fff;opacity:.8;font-family:arial,sans-serif;font-size:10pt;float:left}.jsoneditor-menu>.jsoneditor-modes>button:hover,.jsoneditor-menu>button:hover{background-color:hsla(0,0%,100%,.2);border:1px solid hsla(0,0%,100%,.4)}.jsoneditor-menu>.jsoneditor-modes>button:active,.jsoneditor-menu>.jsoneditor-modes>button:focus,.jsoneditor-menu>button:active,.jsoneditor-menu>button:focus{background-color:hsla(0,0%,100%,.3)}.jsoneditor-menu>.jsoneditor-modes>button:disabled,.jsoneditor-menu>button:disabled{opacity:.5;background-color:transparent;border:none}.jsoneditor-menu>button.jsoneditor-collapse-all{background-position:0 -96px}.jsoneditor-menu>button.jsoneditor-expand-all{background-position:0 -120px}.jsoneditor-menu>button.jsoneditor-sort{background-position:-120px -96px}.jsoneditor-menu>button.jsoneditor-transform{background-position:-144px -96px}.jsoneditor.jsoneditor-mode-form>.jsoneditor-menu>button.jsoneditor-sort,.jsoneditor.jsoneditor-mode-form>.jsoneditor-menu>button.jsoneditor-transform,.jsoneditor.jsoneditor-mode-view>.jsoneditor-menu>button.jsoneditor-sort,.jsoneditor.jsoneditor-mode-view>.jsoneditor-menu>button.jsoneditor-transform{display:none}.jsoneditor-menu>button.jsoneditor-undo{background-position:-24px -96px}.jsoneditor-menu>button.jsoneditor-undo:disabled{background-position:-24px -120px}.jsoneditor-menu>button.jsoneditor-redo{background-position:-48px -96px}.jsoneditor-menu>button.jsoneditor-redo:disabled{background-position:-48px -120px}.jsoneditor-menu>button.jsoneditor-compact{background-position:-72px -96px}.jsoneditor-menu>button.jsoneditor-format{background-position:-72px -120px}.jsoneditor-menu>button.jsoneditor-repair{background-position:-96px -96px}.jsoneditor-menu>.jsoneditor-modes{display:inline-block;float:left}.jsoneditor-menu>.jsoneditor-modes>button{background-image:none;width:auto;padding-left:6px;padding-right:6px}.jsoneditor-menu>.jsoneditor-modes>button.jsoneditor-separator,.jsoneditor-menu>button.jsoneditor-separator{margin-left:10px}.jsoneditor-menu a{font-family:arial,sans-serif;font-size:10pt;color:#fff;opacity:.8;vertical-align:middle}.jsoneditor-menu a:hover{opacity:1}.jsoneditor-menu a.jsoneditor-poweredBy{font-size:8pt;position:absolute;right:0;top:0;padding:10px}.jsoneditor-navigation-bar{width:100%;height:26px;line-height:26px;padding:0;margin:0;border-bottom:1px solid #d3d3d3;box-sizing:border-box;color:grey;background-color:#ebebeb;overflow:hidden;font-family:arial,sans-serif;font-size:10pt}.jsoneditor-search{font-family:arial,sans-serif;position:absolute;right:4px;top:4px;border-collapse:collapse;border-spacing:0;display:flex}.jsoneditor-search input{color:#1a1a1a;width:120px;border:none;outline:0;margin:1px;line-height:20px;font-family:arial,sans-serif}.jsoneditor-search button{width:16px;height:24px;padding:0;margin:0;border:none;background:url(" + __webpack_require__(99) + ");vertical-align:top}.jsoneditor-search button:hover{background-color:transparent}.jsoneditor-search button.jsoneditor-refresh{width:18px;background-position:-99px -73px}.jsoneditor-search button.jsoneditor-next{cursor:pointer;background-position:-124px -73px}.jsoneditor-search button.jsoneditor-next:hover{background-position:-124px -49px}.jsoneditor-search button.jsoneditor-previous{cursor:pointer;background-position:-148px -73px;margin-right:2px}.jsoneditor-search button.jsoneditor-previous:hover{background-position:-148px -49px}.jsoneditor-results{font-family:arial,sans-serif;color:#fff;padding-right:5px;line-height:26px}.jsoneditor-frame{border:1px solid transparent;background-color:#fff;padding:0 2px;margin:0}.jsoneditor-statusbar{line-height:26px;height:26px;color:grey;background-color:#ebebeb;border-top:1px solid #d3d3d3;box-sizing:border-box;font-size:10pt}.jsoneditor-statusbar>.jsoneditor-curserinfo-val{margin-right:12px}.jsoneditor-statusbar>.jsoneditor-curserinfo-count{margin-left:4px}.jsoneditor-statusbar>.jsoneditor-validation-error-icon{float:right;width:24px;height:24px;padding:0;margin-top:1px;background:url(" + __webpack_require__(99) + ") -168px -48px;cursor:pointer}.jsoneditor-statusbar>.jsoneditor-validation-error-count{float:right;margin:0 4px 0 0;cursor:pointer}.jsoneditor-statusbar>.jsoneditor-parse-error-icon{float:right;width:24px;height:24px;padding:0;margin:1px;background:url(" + __webpack_require__(99) + ") -25px 0}.jsoneditor-statusbar .jsoneditor-array-info a{color:inherit}div.jsoneditor-statusbar>.jsoneditor-curserinfo-label,div.jsoneditor-statusbar>.jsoneditor-size-info{margin:0 4px}.jsoneditor-treepath{padding:0 5px;overflow:hidden;white-space:nowrap;outline:0}.jsoneditor-treepath.show-all{word-wrap:break-word;white-space:normal;position:absolute;background-color:#ebebeb;z-index:1;box-shadow:2px 2px 12px hsla(0,0%,50%,.3)}.jsoneditor-treepath.show-all span.jsoneditor-treepath-show-all-btn{display:none}.jsoneditor-treepath div.jsoneditor-contextmenu-root{position:absolute;left:0}.jsoneditor-treepath .jsoneditor-treepath-show-all-btn{position:absolute;background-color:#ebebeb;left:0;height:20px;padding:0 3px;cursor:pointer}.jsoneditor-treepath .jsoneditor-treepath-element{margin:1px;font-family:arial,sans-serif;font-size:10pt}.jsoneditor-treepath .jsoneditor-treepath-seperator{margin:2px;font-size:9pt;font-family:arial,sans-serif}.jsoneditor-treepath span.jsoneditor-treepath-element:hover,.jsoneditor-treepath span.jsoneditor-treepath-seperator:hover{cursor:pointer;text-decoration:underline}/*!\n * Selectr 2.4.0\n * https://github.com/Mobius1/Selectr\n *\n * Released under the MIT license\n */.selectr-container{position:relative}.selectr-container li{list-style:none}.selectr-hidden{position:absolute;overflow:hidden;clip:rect(0,0,0,0);width:1px;height:1px;margin:-1px;padding:0;border:0 none}.selectr-visible{position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;z-index:11}.selectr-desktop.multiple .selectr-visible{display:none}.selectr-desktop.multiple.native-open .selectr-visible{top:100%;min-height:200px!important;height:auto;opacity:1;display:block}.selectr-container.multiple.selectr-mobile .selectr-selected{z-index:0}.selectr-selected{position:relative;z-index:1;box-sizing:border-box;width:100%;padding:7px 28px 7px 14px;cursor:pointer;border:1px solid #999;border-radius:3px;background-color:#fff}.selectr-selected:before{position:absolute;top:50%;right:10px;width:0;height:0;content:\"\";transform:rotate(0) translate3d(0,-50%,0);border-width:4px 4px 0;border-style:solid;border-color:#6c7a86 transparent transparent}.selectr-container.native-open .selectr-selected:before,.selectr-container.open .selectr-selected:before{border-width:0 4px 4px;border-style:solid;border-color:transparent transparent #6c7a86}.selectr-label{display:none;overflow:hidden;width:100%;white-space:nowrap;text-overflow:ellipsis}.selectr-placeholder{color:#6c7a86}.selectr-tags{margin:0;padding:0;white-space:normal}.has-selected .selectr-tags{margin:0 0 -2px}.selectr-tag{list-style:none;position:relative;float:left;padding:2px 25px 2px 8px;margin:0 2px 2px 0;cursor:default;color:#fff;border:medium none;border-radius:10px;background:#acb7bf none repeat scroll 0 0}.selectr-container.multiple.has-selected .selectr-selected{padding:5px 28px 5px 5px}.selectr-options-container{position:absolute;z-index:10000;top:calc(100% - 1px);left:0;display:none;box-sizing:border-box;width:100%;border-width:0 1px 1px;border-style:solid;border-color:transparent #999 #999;border-radius:0 0 3px 3px;background-color:#fff}.selectr-container.open .selectr-options-container{display:block}.selectr-input-container{position:relative;display:none}.selectr-clear,.selectr-input-clear,.selectr-tag-remove{position:absolute;top:50%;right:22px;width:20px;height:20px;padding:0;cursor:pointer;transform:translate3d(0,-50%,0);border:medium none;background-color:transparent;z-index:11}.selectr-clear,.selectr-input-clear{display:none}.selectr-container.has-selected .selectr-clear,.selectr-input-container.active .selectr-input-clear{display:block}.selectr-selected .selectr-tag-remove{right:2px}.selectr-clear:after,.selectr-clear:before,.selectr-input-clear:after,.selectr-input-clear:before,.selectr-tag-remove:after,.selectr-tag-remove:before{position:absolute;top:5px;left:9px;width:2px;height:10px;content:\" \";background-color:#6c7a86}.selectr-tag-remove:after,.selectr-tag-remove:before{top:4px;width:3px;height:12px;background-color:#fff}.selectr-clear:before,.selectr-input-clear:before,.selectr-tag-remove:before{transform:rotate(45deg)}.selectr-clear:after,.selectr-input-clear:after,.selectr-tag-remove:after{transform:rotate(-45deg)}.selectr-input-container.active,.selectr-input-container.active .selectr-clear{display:block}.selectr-input{top:5px;left:5px;box-sizing:border-box;width:calc(100% - 30px);margin:10px 15px;padding:7px 30px 7px 9px;border:1px solid #999;border-radius:3px}.selectr-notice{display:none;box-sizing:border-box;width:100%;padding:8px 16px;border-top:1px solid #999;border-radius:0 0 3px 3px;background-color:#fff}.selectr-container.notice .selectr-notice{display:block}.selectr-container.notice .selectr-selected{border-radius:3px 3px 0 0}.selectr-options{position:relative;top:calc(100% + 2px);display:none;overflow-x:auto;overflow-y:scroll;max-height:200px;margin:0;padding:0}.selectr-container.notice .selectr-options-container,.selectr-container.open .selectr-input-container,.selectr-container.open .selectr-options{display:block}.selectr-option{position:relative;display:block;padding:5px 20px;list-style:outside none none;cursor:pointer;font-weight:400}.selectr-options.optgroups>.selectr-option{padding-left:25px}.selectr-optgroup{font-weight:700;padding:0}.selectr-optgroup--label{font-weight:700;margin-top:10px;padding:5px 15px}.selectr-match{text-decoration:underline}.selectr-option.selected{background-color:#ddd}.selectr-option.active{color:#fff;background-color:#5897fb}.selectr-option.disabled{opacity:.4}.selectr-option.excluded{display:none}.selectr-container.open .selectr-selected{border-color:#999 #999 transparent;border-radius:3px 3px 0 0}.selectr-container.open .selectr-selected:after{transform:rotate(180deg) translate3d(0,50%,0)}.selectr-disabled{opacity:.6}.has-selected .selectr-placeholder,.selectr-empty{display:none}.has-selected .selectr-label{display:block}.taggable .selectr-selected{padding:4px 28px 4px 4px}.taggable .selectr-selected:after{display:table;content:\" \";clear:both}.taggable .selectr-label{width:auto}.taggable .selectr-tags{float:left;display:block}.taggable .selectr-placeholder{display:none}.input-tag{float:left;min-width:90px;width:auto}.selectr-tag-input{border:medium none;padding:3px 10px;width:100%;font-family:inherit;font-weight:inherit;font-size:inherit}.selectr-input-container.loading:after{position:absolute;top:50%;right:20px;width:20px;height:20px;content:\"\";transform:translate3d(0,-50%,0);transform-origin:50% 0 0;animation:.5s linear 0s normal forwards infinite running spin;border-width:3px;border-style:solid;border-color:#aaa #ddd #ddd;border-radius:50%}@keyframes spin{0%{transform:rotate(0) translate3d(0,-50%,0)}to{transform:rotate(1turn) translate3d(0,-50%,0)}}.selectr-container.open.inverted .selectr-selected{border-color:transparent #999 #999;border-radius:0 0 3px 3px}.selectr-container.inverted .selectr-options-container{border-width:1px 1px 0;border-color:#999 #999 transparent;border-radius:3px 3px 0 0;background-color:#fff;top:auto;bottom:calc(100% - 1px)}.selectr-container :-ms-input-placeholder{color:#6c7a86;opacity:1}.selectr-container ::placeholder{color:#6c7a86;opacity:1}", ""]);
	
	// exports


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror-foldmarker{color:blue;text-shadow:#b9f 1px 1px 2px,#b9f -1px -1px 2px,#b9f 1px -1px 2px,#b9f -1px 1px 2px;font-family:arial;line-height:.3;cursor:pointer}.CodeMirror-foldgutter{width:.7em}.CodeMirror-foldgutter-folded,.CodeMirror-foldgutter-open{cursor:pointer}.CodeMirror-foldgutter-open:after{content:\"\\25BE\"}.CodeMirror-foldgutter-folded:after{content:\"\\25B8\"}", ""]);
	
	// exports


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror-hints{position:absolute;z-index:10;overflow:hidden;list-style:none;margin:0;padding:2px;box-shadow:2px 3px 5px rgba(0,0,0,.2);border-radius:3px;border:1px solid silver;background:#fff;font-size:90%;font-family:monospace;max-height:20em;overflow-y:auto;box-sizing:border-box}.CodeMirror-hint{margin:0;padding:0 4px;border-radius:2px;white-space:pre;color:#000;cursor:pointer}li.CodeMirror-hint-active{background:#08f;color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror-lint-markers{width:16px}.CodeMirror-lint-tooltip{background-color:#ffd;border:1px solid #000;border-radius:4px 4px 4px 4px;color:#000;font-family:monospace;font-size:10pt;overflow:hidden;padding:2px 5px;position:fixed;white-space:pre;white-space:pre-wrap;z-index:100;max-width:600px;opacity:0;transition:opacity .4s;-moz-transition:opacity .4s;-webkit-transition:opacity .4s;-o-transition:opacity .4s;-ms-transition:opacity .4s}.CodeMirror-lint-mark{background-position:0 100%;background-repeat:repeat-x}.CodeMirror-lint-mark-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJFhQXEbhTg7YAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAMklEQVQI12NkgIIvJ3QXMjAwdDN+OaEbysDA4MPAwNDNwMCwiOHLCd1zX07o6kBVGQEAKBANtobskNMAAAAASUVORK5CYII=\")}.CodeMirror-lint-mark-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJDw4cOCW1/KIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAHElEQVQI12NggIL/DAz/GdA5/xkY/qPKMDAwAADLZwf5rvm+LQAAAABJRU5ErkJggg==\")}.CodeMirror-lint-marker{background-position:50%;background-repeat:no-repeat;cursor:pointer;display:inline-block;height:16px;width:16px;vertical-align:middle;position:relative}.CodeMirror-lint-message{padding-left:18px;background-position:0 0;background-repeat:no-repeat}.CodeMirror-lint-marker-warning,.CodeMirror-lint-message-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX/uwDvrwD/uwD/uwD/uwD/uwD/uwD/uwD/uwD6twD/uwAAAADurwD2tQD7uAD+ugAAAAD/uwDhmeTRAAAADHRSTlMJ8mN1EYcbmiixgACm7WbuAAAAVklEQVR42n3PUQqAIBBFUU1LLc3u/jdbOJoW1P08DA9Gba8+YWJ6gNJoNYIBzAA2chBth5kLmG9YUoG0NHAUwFXwO9LuBQL1giCQb8gC9Oro2vp5rncCIY8L8uEx5ZkAAAAASUVORK5CYII=\")}.CodeMirror-lint-marker-error,.CodeMirror-lint-message-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAHlBMVEW7AAC7AACxAAC7AAC7AAAAAAC4AAC5AAD///+7AAAUdclpAAAABnRSTlMXnORSiwCK0ZKSAAAATUlEQVR42mWPOQ7AQAgDuQLx/z8csYRmPRIFIwRGnosRrpamvkKi0FTIiMASR3hhKW+hAN6/tIWhu9PDWiTGNEkTtIOucA5Oyr9ckPgAWm0GPBog6v4AAAAASUVORK5CYII=\")}.CodeMirror-lint-marker-multiple{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAMAAADzjKfhAAAACVBMVEUAAAAAAAC/v7914kyHAAAAAXRSTlMAQObYZgAAACNJREFUeNo1ioEJAAAIwmz/H90iFFSGJgFMe3gaLZ0od+9/AQZ0ADosbYraAAAAAElFTkSuQmCC\");background-repeat:no-repeat;background-position:100% 100%;width:100%;height:100%}.CodeMirror-lint-line-error{background-color:rgba(183,76,81,.08)}.CodeMirror-lint-line-warning{background-color:rgba(255,211,0,.1)}", ""]);
	
	// exports


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror-search-match{background:gold;border-top:1px solid orange;border-bottom:1px solid orange;box-sizing:border-box;opacity:.5}", ""]);
	
	// exports


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".CodeMirror{font-family:monospace;height:300px;color:#000;direction:ltr}.CodeMirror-lines{padding:4px 0}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{padding:0 4px}.CodeMirror-gutter-filler,.CodeMirror-scrollbar-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror-cursor{border-left:1px solid #000;border-right:none;width:0}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.cm-fat-cursor .CodeMirror-cursor{width:auto;border:0!important;background:#7e7}.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-fat-cursor .CodeMirror-line::selection,.cm-fat-cursor .CodeMirror-line>span::selection,.cm-fat-cursor .CodeMirror-line>span>span::selection{background:transparent}.cm-fat-cursor .CodeMirror-line::-moz-selection,.cm-fat-cursor .CodeMirror-line>span::-moz-selection,.cm-fat-cursor .CodeMirror-line>span>span::-moz-selection{background:transparent}.cm-fat-cursor{caret-color:transparent}@keyframes blink{50%{background-color:transparent}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-rulers{position:absolute;left:0;right:0;top:-50px;bottom:0;overflow:hidden}.CodeMirror-ruler{border-left:1px solid #ccc;top:0;bottom:0;position:absolute}.cm-s-default .cm-header{color:blue}.cm-s-default .cm-quote{color:#090}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-type,.cm-s-default .cm-variable-3{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-invalidchar,.cm-s-default .cm-error{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0b0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#a22}.CodeMirror-matchingtag{background:rgba(255,150,0,.3)}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-50px;margin-right:-50px;padding-bottom:50px;height:100%;outline:none;position:relative;z-index:0}.CodeMirror-sizer{position:relative;border-right:50px solid transparent}.CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none;outline:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;min-height:100%;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;vertical-align:top;margin-bottom:-50px}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;background:none!important;border:none!important}.CodeMirror-gutter-background{position:absolute;top:0;bottom:0;z-index:4}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper ::selection{background-color:transparent}.CodeMirror-gutter-wrapper ::-moz-selection{background-color:transparent}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre.CodeMirror-line,.CodeMirror pre.CodeMirror-line-like{border-radius:0;border-width:0;background:transparent;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent;font-variant-ligatures:contextual}.CodeMirror-wrap pre.CodeMirror-line,.CodeMirror-wrap pre.CodeMirror-line-like{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;padding:.1px}.CodeMirror-rtl pre{direction:rtl}.CodeMirror-code{outline:none}.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber,.CodeMirror-scroll,.CodeMirror-sizer{box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-cursor{position:absolute;pointer-events:none}.CodeMirror-measure pre{position:static}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}.CodeMirror-focused div.CodeMirror-cursors,div.CodeMirror-dragcursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror-line::selection,.CodeMirror-line>span::selection,.CodeMirror-line>span>span::selection{background:#d7d4f0}.CodeMirror-line::-moz-selection,.CodeMirror-line>span::-moz-selection,.CodeMirror-line>span>span::-moz-selection{background:#d7d4f0}.cm-searching{background-color:#ffa;background-color:rgba(255,255,0,.4)}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:\"\"}span.CodeMirror-selectedtext{background:none}", ""]);
	
	// exports


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._3aNeEAvwYb0j8KbJU_haw5{color:#fff;height:100%;width:100%;background-size:cover;background-position:50%;background-repeat:no-repeat}._3iSwzDmwSUzrGPDNGwkbYv{display:inline-block;width:100px;line-height:20px;font-size:10px}._1TVzWzVzIRQ-d9AvPR3NmL{background-color:#00b34f;box-sizing:border-box;padding:0 28px;height:60px;line-height:53px;position:relative}._2j2GxjjQ9FPlwqEwaIutXD{background-color:transparent;box-sizing:border-box;padding:0 300px;overflow:auto}._281Vuxu7dbqbkZ3x5_Tf2{height:70px;text-align:center;background-color:transparent}._2U4NXbfN7VMnK2If3UisW7{position:absolute;top:0;right:20px;color:#fff;cursor:pointer}._3szI5QAdJ0PhnF57jUBY_5{display:inline-block;height:100%}._3vmeza7YiDuMKXuLeZLWXX{font-weight:700}._2lPF2-PsvjvShMjkBFQxVl{display:inline-block;height:36px;width:1px;margin:0 20px;background-color:#fff;vertical-align:middle}._3ipnhf2ilSg_6JNDS2PogL{background-color:#000}._2smUHzSLv14IUrNvDCWlQW{height:36px;display:inline-block;vertical-align:middle}._1PKFkYdrtvsPSipsza6EZ5{display:inline-block;font-size:13px;width:200px;height:39px;line-height:1.5;word-wrap:break-word;box-sizing:border-box;vertical-align:middle;color:#fff}._1YbfazEXoQdUPt5K7PpVH_{float:right;margin:20px 200px 0 0}.oRVbLCDrFeufNzqGPEMEW{display:flex;color:#1890ff;height:446px;background-color:#fff;box-shadow:0 0 20px rgb(0 0 0/50%);border-radius:15px;position:absolute;top:160px;right:168px;margin:auto;padding:40px 50px}.KO_PZtSFJkzEFjXsOQIRm{width:16px;height:172px;text-align:center;line-height:165px;background-color:#b9c3d4;border-radius:10px 0 0 10px;box-shadow:-5px 0 20px rgb(0 0 0/30%);position:absolute;top:16px;left:-16px;color:#fff;cursor:pointer}._29poKh9rkot8LyGc8dfn1z{font-size:10px}._16rSJqRRcpAiBt8koNUGhH{width:600px;height:100%;border-right:1px solid #dcdfe6;box-sizing:border-box;padding:20px 60px 20px 116px;color:#8f8f8f;font-size:13px}._16rSJqRRcpAiBt8koNUGhH,.BRS2EOrbd6iHDzg3DL5UW{overflow:hidden;transition:all .4s ease-in-out;white-space:nowrap}.BRS2EOrbd6iHDzg3DL5UW{width:0}._2FZ2J24hkmYNcPgsbJxe44{color:#8f8f8f;line-height:30px}._2FZ2J24hkmYNcPgsbJxe44 a{color:#c04323}._2FZ2J24hkmYNcPgsbJxe44 div{position:relative;line-height:20px}._12_c0jQ2qTntAX9nQ5uB2V{display:inline-block;position:absolute;right:30px;top:5px}._2-eN812-RYASRDBenOyMMm{margin-top:50px;font-size:14px;color:#8f8f8f}._2p7xPjv5H7Rml_VsV5fa1t{display:flex;justify-content:space-between}._2tjBFVVVY_YGxWaXKMguFv{width:390px;height:100%;box-sizing:border-box;padding:20px 38px 0}._2tjBFVVVY_YGxWaXKMguFv h2,._2tjBFVVVY_YGxWaXKMguFv h5{text-align:center;color:#124a85}._3ny7EUpE6vrsgb7dgaf_43{margin:20px 0;padding:0 0 10px;font-size:larger;text-align:center;border-bottom:1px solid #dcdcdc}.BjG43Vr7Ksr9o_AoxmO8l{width:215px;height:215px;margin:10px 0 7px 65px}._3K-ex9VAb3_t970CkelWlv{text-align:center;margin-top:10px;font-size:15px}._3ByP_xR5luVTten-IvBh7J{cursor:pointer;color:#1e90ff}._20IhY0ZWPt4WNSv71k6O3q{width:100%;margin-bottom:13px;background:#124a85}._20IhY0ZWPt4WNSv71k6O3q:hover{color:#fff;background-color:#124a85;border-color:#124a85}.i68d1mVhvs9mjHmESFZkx{cursor:pointer;color:#1890ff;margin-left:10px;font-size:12px}._1p7S_dcq3tj4HXKriKEQxf{color:#a8a8a8;font-size:12px;line-height:16px}._1pbEkEToPORDUWL4dNNneM{color:#fff}._2APnGxJ6CYcJvqEhlxrz0N{width:13px;height:15px}._18zSbt2QG78383cwLwVOmp{text-align:center;color:red;max-width:254px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.TwxGSRobFiV6nmxGIIjJY{height:30px;line-height:30px;text-align:center}.TwxGSRobFiV6nmxGIIjJY a{color:#00b34f;margin-right:15px;font-size:13px}.TwxGSRobFiV6nmxGIIjJY img{width:18px;height:18px;vertical-align:middle;margin-right:10px}._14rLInjMRMz-zEC0J9XE4V{display:inline-block;width:36px;height:36px;background-position:0 0;background-size:cover;margin-right:10px;background-image:url(" + __webpack_require__(2013) + ");vertical-align:text-bottom;text-align:center}._12pPosExdz48nn2fgMKJiP{font-weight:700;color:#124a85;margin:50px 0 0}._10OGKr5vv_O42fV8RRX2Lp{font-weight:700;color:#124a85;text-align:center;margin-bottom:10px}:globel ._2BcdjkSKaWFQQqCPrCRO5o .qGQJDiO-m5ZdIr5yj-KwZ{margin-bottom:18px}", ""]);
	
	// exports
	exports.locals = {
		"loginLayout": "_3aNeEAvwYb0j8KbJU_haw5",
		"loginDesc": "_3iSwzDmwSUzrGPDNGwkbYv",
		"loginHeader": "_1TVzWzVzIRQ-d9AvPR3NmL",
		"loginContent": "_2j2GxjjQ9FPlwqEwaIutXD",
		"loginFooter": "_281Vuxu7dbqbkZ3x5_Tf2",
		"toLogin": "_2U4NXbfN7VMnK2If3UisW7",
		"loginTitle": "_3szI5QAdJ0PhnF57jUBY_5",
		"loginTitleSpan": "_3vmeza7YiDuMKXuLeZLWXX",
		"divider": "_2lPF2-PsvjvShMjkBFQxVl",
		"Divider1": "_3ipnhf2ilSg_6JNDS2PogL",
		"loginTitleImg": "_2smUHzSLv14IUrNvDCWlQW",
		"loginTitleText": "_1PKFkYdrtvsPSipsza6EZ5",
		"registerBtn": "_1YbfazEXoQdUPt5K7PpVH_",
		"loginArea": "oRVbLCDrFeufNzqGPEMEW",
		"toggleBtn": "KO_PZtSFJkzEFjXsOQIRm",
		"toggleIcon": "_29poKh9rkot8LyGc8dfn1z",
		"loginAreaLeft": "_16rSJqRRcpAiBt8koNUGhH",
		"loginAreaLeft_hidden": "BRS2EOrbd6iHDzg3DL5UW",
		"proposal": "_2FZ2J24hkmYNcPgsbJxe44",
		"check": "_12_c0jQ2qTntAX9nQ5uB2V",
		"tip": "_2-eN812-RYASRDBenOyMMm",
		"diyItem": "_2p7xPjv5H7Rml_VsV5fa1t",
		"loginAreaRight": "_2tjBFVVVY_YGxWaXKMguFv",
		"accPwdLoginTitle": "_3ny7EUpE6vrsgb7dgaf_43",
		"QRCode": "BjG43Vr7Ksr9o_AoxmO8l",
		"QRCodeText": "_3K-ex9VAb3_t970CkelWlv",
		"QRCodeRefresh": "_3ByP_xR5luVTten-IvBh7J",
		"login-form-button": "_20IhY0ZWPt4WNSv71k6O3q",
		"changeOne": "i68d1mVhvs9mjHmESFZkx",
		"certification": "_1p7S_dcq3tj4HXKriKEQxf",
		"certificationText": "_1pbEkEToPORDUWL4dNNneM",
		"certificationImg": "_2APnGxJ6CYcJvqEhlxrz0N",
		"errMsg": "_18zSbt2QG78383cwLwVOmp",
		"Footer_content": "TwxGSRobFiV6nmxGIIjJY",
		"zllogo": "_14rLInjMRMz-zEC0J9XE4V",
		"formTitle": "_12pPosExdz48nn2fgMKJiP",
		"formSubTitle": "_10OGKr5vv_O42fV8RRX2Lp",
		"loginform": "_2BcdjkSKaWFQQqCPrCRO5o",
		"ant-form-item": "qGQJDiO-m5ZdIr5yj-KwZ"
	};

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._1h__PPS-xb-saLCRQoRryI{width:100px;height:100px;position:relative;top:40%;margin:0 auto}", ""]);
	
	// exports
	exports.locals = {
		"spaner_outer": "_1h__PPS-xb-saLCRQoRryI"
	};

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._205lYsiEL-cZShNSrBGZZ9{width:100vw;height:100vh;position:fixed;z-index:99999;background-color:#d2691e}", ""]);
	
	// exports
	exports.locals = {
		"outer": "_205lYsiEL-cZShNSrBGZZ9"
	};

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._2bv5EkYqHbDx6LT8Sy0wEz{color:#fff;height:100%;width:100%;background-image:url(" + __webpack_require__(2023) + ");background-size:100% 105%;background-position:50%;background-repeat:no-repeat}._3kU5NfvKYU45NJi1X8Uv0N{display:inline-block;width:100px;line-height:20px;font-size:10px}._1_smitQOJd3lXGxOz5tY8z{box-sizing:border-box;padding:0 28px;height:60px;line-height:53px}._1_smitQOJd3lXGxOz5tY8z,._3Xe-LFWUr_XWnCfJnMsLh6,.Sq-e_90EBeaJYl_SHYGWA{background-color:transparent}.Sq-e_90EBeaJYl_SHYGWA{height:70px;text-align:center}._3WnLjTVLz49Kl4a2IVnD8z{display:inline-block;height:100%}._21jnm1yWWrPqv-sOBEirxW{font-weight:700}._3LVYYxXL1BPifWRHvXHmJX{width:1px;margin:0 20px;background-color:#fff}._2hJYO-D54wBDDhfNkU1Jea,._3LVYYxXL1BPifWRHvXHmJX{display:inline-block;height:36px;vertical-align:middle}.NRKKjOeAJXR3RsbKDzQRg{display:inline-block;font-size:13px;width:200px;height:39px;line-height:1.5;word-wrap:break-word;box-sizing:border-box;vertical-align:middle;color:#fff}._3idZwoisRIYqYrfUbJhuNi{float:right;margin:20px 200px 0 0}._2ENsVzm-uEW9Gfky_1SCu9{display:flex;color:#1890ff;height:446px;background-color:#fff;box-shadow:0 0 20px rgb(0 0 0/50%);border-radius:15px;position:absolute;top:160px;right:10%;margin:auto;padding:40px 50px}._1qbxf0OrVQ3_TUX5uBVxGr{width:16px;height:172px;text-align:center;line-height:165px;background-color:#b9c3d4;border-radius:10px 0 0 10px;box-shadow:-5px 0 20px rgb(0 0 0/30%);position:absolute;top:16px;left:-16px;color:#fff;cursor:pointer}._2R2QEFVgcj3MGzqjVBhPfA{font-size:10px}._3uEPnPNx6NT33eTlA1yLVw{width:600px;height:100%;border-right:1px solid #dcdfe6;box-sizing:border-box;padding:20px 60px 20px 116px;color:#8f8f8f;font-size:13px}._1U0w8ytAn6wokTdDLRFGJg,._3uEPnPNx6NT33eTlA1yLVw{overflow:hidden;transition:all .4s ease-in-out;white-space:nowrap}._1U0w8ytAn6wokTdDLRFGJg{width:0}.y6wdHVIEl5xksXtKK5-a_{color:#8f8f8f;line-height:30px}.y6wdHVIEl5xksXtKK5-a_ a{color:#c04323}.y6wdHVIEl5xksXtKK5-a_ div{position:relative;line-height:20px}._3sXvEo2OfJiE3HG5Nq62l3{display:inline-block;position:absolute;right:30px;top:5px}.wm2SI8x_oQ2CTbNZ7qqy2{margin-top:50px;font-size:14px;color:#8f8f8f}._33IzDzofwPeFbPsFiislk7{display:flex;justify-content:space-between}._8Z1fOGlAoKgKQYO9YFUQz{width:390px;height:100%;box-sizing:border-box;padding:20px 38px 0}._8Z1fOGlAoKgKQYO9YFUQz h2,._8Z1fOGlAoKgKQYO9YFUQz h5{text-align:center;color:#00b34f}._1Hl_bUEiS3b-xZNLO9CC88{margin:20px 0;padding:0 0 10px;font-size:larger;text-align:center;border-bottom:1px solid #dcdcdc}._2XFfewK21Mp2Cqg9JblPOP{width:215px;height:215px;margin:10px 0 7px 65px}._3LAFYkAnpL7O1LeytCwswO{text-align:center;margin-top:10px;font-size:15px}._3XlJdtWoi6exXDuW2wiFtV{cursor:pointer;color:#1e90ff}._34ObCgr6rsmWWNmW4Qo9o8{width:100%;margin-bottom:13px;background:#00b34f}._34ObCgr6rsmWWNmW4Qo9o8:hover{color:#fff;background-color:#00b34f;border-color:#00b34f}._11HYOaceg2UIQgICrUlcIK{cursor:pointer;color:#1890ff;margin-left:10px;font-size:12px}._3YmhsoR0Lc5i_GnuiNVpk9{color:#a8a8a8;font-size:12px;line-height:16px}._3XpV3GyRYPcUWUOe9grmYz{color:#fff}._1VmACHYYQJTzfgrzyr9RUk{width:13px;height:15px}._2O4o2nzPo8_QHIpKWelODG{text-align:center;color:red;max-width:254px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}._1HPuE3JKXplHw0HzbhR193{height:30px;line-height:30px;text-align:center}._1HPuE3JKXplHw0HzbhR193 a{color:#000;margin-right:15px;font-size:13px}._1HPuE3JKXplHw0HzbhR193 img{width:18px;height:18px;vertical-align:middle;margin-right:10px}._2GC4LwmghVk_ZKZPx29LiW{display:inline-block;width:36px;height:36px;background-position:0 0;background-size:cover;margin-right:10px;background-image:url(" + __webpack_require__(2022) + ");vertical-align:text-bottom;text-align:center}._3Oi1y3Yq9S5dPfaQW4m9Sm{font-size:30px;font-weight:700;color:#00b34f;text-align:center;margin-bottom:40px}.JD6EmDL9pf8PbW-KyVN9R{font-weight:700;color:#00b34f;text-align:center;margin-bottom:10px}:globel ._3ZDzgU5WUt12FFbmb2-lXH ._18xL0DbcuLIE2xqRqq5GGe{margin-bottom:18px}._3n01yS_umd-m7mubW8p7hd{display:-webkit-box}._2jKA4-RAwiWlDvYSLr8WYV{width:750px!important}", ""]);
	
	// exports
	exports.locals = {
		"loginLayout": "_2bv5EkYqHbDx6LT8Sy0wEz",
		"loginDesc": "_3kU5NfvKYU45NJi1X8Uv0N",
		"loginHeader": "_1_smitQOJd3lXGxOz5tY8z",
		"loginContent": "_3Xe-LFWUr_XWnCfJnMsLh6",
		"loginFooter": "Sq-e_90EBeaJYl_SHYGWA",
		"loginTitle": "_3WnLjTVLz49Kl4a2IVnD8z",
		"loginTitleSpan": "_21jnm1yWWrPqv-sOBEirxW",
		"divider": "_3LVYYxXL1BPifWRHvXHmJX",
		"loginTitleImg": "_2hJYO-D54wBDDhfNkU1Jea",
		"loginTitleText": "NRKKjOeAJXR3RsbKDzQRg",
		"registerBtn": "_3idZwoisRIYqYrfUbJhuNi",
		"loginArea": "_2ENsVzm-uEW9Gfky_1SCu9",
		"toggleBtn": "_1qbxf0OrVQ3_TUX5uBVxGr",
		"toggleIcon": "_2R2QEFVgcj3MGzqjVBhPfA",
		"loginAreaLeft": "_3uEPnPNx6NT33eTlA1yLVw",
		"loginAreaLeft_hidden": "_1U0w8ytAn6wokTdDLRFGJg",
		"proposal": "y6wdHVIEl5xksXtKK5-a_",
		"check": "_3sXvEo2OfJiE3HG5Nq62l3",
		"tip": "wm2SI8x_oQ2CTbNZ7qqy2",
		"diyItem": "_33IzDzofwPeFbPsFiislk7",
		"loginAreaRight": "_8Z1fOGlAoKgKQYO9YFUQz",
		"accPwdLoginTitle": "_1Hl_bUEiS3b-xZNLO9CC88",
		"QRCode": "_2XFfewK21Mp2Cqg9JblPOP",
		"QRCodeText": "_3LAFYkAnpL7O1LeytCwswO",
		"QRCodeRefresh": "_3XlJdtWoi6exXDuW2wiFtV",
		"login-form-button": "_34ObCgr6rsmWWNmW4Qo9o8",
		"changeOne": "_11HYOaceg2UIQgICrUlcIK",
		"certification": "_3YmhsoR0Lc5i_GnuiNVpk9",
		"certificationText": "_3XpV3GyRYPcUWUOe9grmYz",
		"certificationImg": "_1VmACHYYQJTzfgrzyr9RUk",
		"errMsg": "_2O4o2nzPo8_QHIpKWelODG",
		"Footer_content": "_1HPuE3JKXplHw0HzbhR193",
		"zllogo": "_2GC4LwmghVk_ZKZPx29LiW",
		"formTitle": "_3Oi1y3Yq9S5dPfaQW4m9Sm",
		"formSubTitle": "JD6EmDL9pf8PbW-KyVN9R",
		"loginform": "_3ZDzgU5WUt12FFbmb2-lXH",
		"ant-form-item": "_18xL0DbcuLIE2xqRqq5GGe",
		"overflowHidden_index": "_3n01yS_umd-m7mubW8p7hd",
		"checkInfoModal_index": "_2jKA4-RAwiWlDvYSLr8WYV"
	};

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, ".q8iObQqAouvIG6AIOJvDr{width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column}#_2vi31dP0YissSeymmaeMV0{height:100%;min-width:1280px;width:100%;position:absolute;left:0;top:0;background:url(\"/theme/default.png\") no-repeat;background-position:10px 20px;background-size:347px 63px;background-color:rgb(200 225 251);z-index:10000}._18qNsHBmNeg1m5BX3S5Z_M{width:200px;height:100px;margin:30px auto;text-align:center}._2ANOFTxTPMP5dCN_9-b86J{text-align:center;margin-top:300px;font-size:35px}.ler2lGERVpYGJ9PPS_qfZ{text-align:center;margin-top:30px;font-size:35px}.CnxdtByO6I1rtPM8gpFyl{margin-bottom:20px}._1k2dsAeooyalsGIMVQWhp_,.CnxdtByO6I1rtPM8gpFyl{border:1px solid #646464}._3LrzF9zpTmuphUwdWoWD2-{text-align:center}._2h35iIxyKSqH9nKGbR7qaQ{height:60px;overflow:hidden;border-bottom:1px solid #bec0c2;display:flex;background-size:80% 200%;background-repeat:no-repeat;background-position:80%}._38e37JNlCqAjGTK4SSq1f9{overflow:hidden;padding:2px;box-sizing:border-box}._1b9idcU9k-tACGvTXpz6PO{height:40px;margin-top:8px;width:162px;float:left;padding:5px;box-sizing:border-box}.M1fwzKcLyOO2q_8qQUBpv{font-weight:700;height:40px;margin-top:7px;font-size:30px;line-height:41px;text-align:left;float:left;margin-left:5px;padding-left:25px;border-left:1px solid #bec0c2;font-family:\\\\6977\\4F53,\\\\6977\\4F53_GB2312,KaiTi,LiSu,kai}._5gO-y1-67IvLAM7rG0SuM{flex:1;overflow:hidden;display:flex;padding:10px;box-sizing:border-box}._2SUrUcLX-Zq5UwgMS3jfMP{flex:1;overflow:hidden;padding-top:4px}._1eWU_W_m7s_53JIu3mvR8Y{float:right}._2oinvFrz-R9KSOWfFhjcrU{padding:4px 10px;box-sizing:border-box}._3kZOqqqryemT9OmcQjqUR_{padding-top:4px;margin-left:10px}.dtG1-a3xdZuZ8w6zkLCad{flex:1;overflow:hidden;display:flex;width:100%}._3tc7htMKLcEZTocHOa5_1v{width:auto}.gooVUSaIt8BIHge8VJK-D{width:auto;display:flex;flex-direction:column;border-left:1px solid #e8e8e8}._2Yj_zzoQwaKH7vKheQ0W__{height:60px}._2z_IdHss1agcCZ8xGjso_O{height:100%;width:100%;text-align:center;line-height:100%;font-size:30px}._19sNnUmfXq_S5ZI7-zrFZk{flex:1;overflow:auto}._2QuEgodhjEYMS18-py0P1M{box-sizing:border-box;height:auto;width:100%}.FvPmTsB-AsPpXC62jrx9Q{padding:10px;height:100%;width:100%;text-align:center;line-height:100%;font-size:26px;display:block}.FvPmTsB-AsPpXC62jrx9Q:hover{opacity:.7}._2j6fY6iKo3irhzb3UxmLFg{font-size:13px;width:70px;text-align:center}._2xzXZgJPb-Oj7jhd74P9_l{flex:1;display:flex;flex-direction:column;overflow:hidden}._2z5clBV3KW3-DCbWbdHxw{height:auto;box-sizing:border-box;width:100%;overflow:hidden;display:flex;border-bottom:1px solid #e8e8e8}._2wcrGCZn_1S3iaO7ZGXLQy{width:24px;border-right:1px solid #e8e8e8;font-size:25px}._39kYToJHP8M0uf9KhcMjju{cursor:pointer;margin:11px 0 0 -2px}._1wBV_xyeRw4lQ6vjWjCL_B{flex:1;overflow:auto;padding:10px 5px;box-sizing:border-box}._1wBV_xyeRw4lQ6vjWjCL_B::-webkit-scrollbar{display:none}._2Sz5_NzqywGP43kIjEj1U6{width:24px;border-left:1px solid #e8e8e8;font-size:25px}._2cl2Lfj3olSzlW_U_rRsX4{cursor:pointer;margin:11px 0 0}._1lJWx-4I6w0PPf6g9tIqoN{width:100%;white-space:nowrap;overflow:auto;box-sizing:border-box;height:40px}._8v8jF6lGzf3T3T6-cMzan{margin:0 5px}._2O64r26iRIip8ymnwOU2Qd{width:100%;height:42px;padding:10px;box-sizing:border-box;overflow:hidden;border-bottom:1px solid #e8e8e8;display:flex}._3-SjJsmSdvAwnBvSdz8Aos{flex:1}._2ZpEcufoMk0HyaT3qSQ6jk{width:auto;font-size:19px;line-height:100%}._38BIHCHft83CaYd3xoqPQ7{flex:1;overflow:hidden;width:100%}.YZLgT6CK4XvfUDa_G2Gcn{width:auto;margin:5px;float:left}.GLtKCizYPhPJg7UgsmM2w{border:1px solid #e8e8e8}._2oJXlO2c4tPqO08kiMb1Jj{top:15px;left:25%;position:absolute;width:70%}._31_b8XF12AKueEK-3zHCIZ{width:100%;overflow:hidden;font-size:15px;display:flex;align-items:center}._3NDLuE-hDefqW0xLr_3Z8H ._3VCJHz6JcqJnzK1pZf5jdX{text-align:center;height:160px;line-height:160px;background:#364d79;overflow:hidden}._29biORAIgBi_w6YfWWO-lr{display:inline-block;white-space:nowrap;animation:_2J2tu_UbeWJhZBhpyftMJV 15s linear infinite normal}@keyframes _2J2tu_UbeWJhZBhpyftMJV{0%{transform:translateX(100%);-webkit-transform:translateX(100%)}to{transform:translateX(-100%);-webkit-transform:translateX(-100%)}}.s5nToMqibOo6ilnuwf8Yh{color:orange;margin-right:5px}.Z8y3Kkkxc3cSh5nTexX_l{text-align:left}.-V28i00vUm62pfgGaX2s0{color:#f66;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
	
	// exports
	exports.locals = {
		"mainWrap": "q8iObQqAouvIG6AIOJvDr",
		"overlay": "_2vi31dP0YissSeymmaeMV0",
		"lockScreen": "_18qNsHBmNeg1m5BX3S5Z_M",
		"lockScreenText": "_2ANOFTxTPMP5dCN_9-b86J",
		"lockScreenTextSub": "ler2lGERVpYGJ9PPS_qfZ",
		"lockScreenIpt": "CnxdtByO6I1rtPM8gpFyl",
		"lockScreenBtn": "_1k2dsAeooyalsGIMVQWhp_",
		"signPanel": "_3LrzF9zpTmuphUwdWoWD2-",
		"header": "_2h35iIxyKSqH9nKGbR7qaQ",
		"logo": "_38e37JNlCqAjGTK4SSq1f9",
		"logoImg": "_1b9idcU9k-tACGvTXpz6PO",
		"logoText": "M1fwzKcLyOO2q_8qQUBpv",
		"toolbar": "_5gO-y1-67IvLAM7rG0SuM",
		"assist": "_2SUrUcLX-Zq5UwgMS3jfMP",
		"assistBtms": "_1eWU_W_m7s_53JIu3mvR8Y",
		"search": "_2oinvFrz-R9KSOWfFhjcrU",
		"user": "_3kZOqqqryemT9OmcQjqUR_",
		"middle": "dtG1-a3xdZuZ8w6zkLCad",
		"middleSiderLeft": "_3tc7htMKLcEZTocHOa5_1v",
		"middleSider": "gooVUSaIt8BIHge8VJK-D",
		"middleSiderToggle": "_2Yj_zzoQwaKH7vKheQ0W__",
		"middleSiderToggleBtn": "_2z_IdHss1agcCZ8xGjso_O",
		"middleSiderList": "_19sNnUmfXq_S5ZI7-zrFZk",
		"middleSiderListBtns": "_2QuEgodhjEYMS18-py0P1M",
		"middleSiderListItem": "FvPmTsB-AsPpXC62jrx9Q",
		"middleSiderListItemText": "_2j6fY6iKo3irhzb3UxmLFg",
		"middleContent": "_2xzXZgJPb-Oj7jhd74P9_l",
		"ContentMenu": "_2z5clBV3KW3-DCbWbdHxw",
		"leftBtn": "_2wcrGCZn_1S3iaO7ZGXLQy",
		"leftCaret": "_39kYToJHP8M0uf9KhcMjju",
		"centerContent": "_1wBV_xyeRw4lQ6vjWjCL_B",
		"rightBtn": "_2Sz5_NzqywGP43kIjEj1U6",
		"rightCaret": "_2cl2Lfj3olSzlW_U_rRsX4",
		"ContentMenuItems": "_1lJWx-4I6w0PPf6g9tIqoN",
		"ContentMenuItem": "_8v8jF6lGzf3T3T6-cMzan",
		"ContentBreadcrumb": "_2O64r26iRIip8ymnwOU2Qd",
		"ContentBreadcrumbContent": "_3-SjJsmSdvAwnBvSdz8Aos",
		"ContentBreadcrumbOther": "_2ZpEcufoMk0HyaT3qSQ6jk",
		"ContentMain": "_38BIHCHft83CaYd3xoqPQ7",
		"shortcutBtn": "YZLgT6CK4XvfUDa_G2Gcn",
		"submenu": "GLtKCizYPhPJg7UgsmM2w",
		"breadTips": "_2oJXlO2c4tPqO08kiMb1Jj",
		"breadTipsBox": "_31_b8XF12AKueEK-3zHCIZ",
		"carousel": "_3NDLuE-hDefqW0xLr_3Z8H",
		"slick-slide": "_3VCJHz6JcqJnzK1pZf5jdX",
		"breadTipsAnimate": "_29biORAIgBi_w6YfWWO-lr",
		"move": "_2J2tu_UbeWJhZBhpyftMJV",
		"breadTipsIcon": "s5nToMqibOo6ilnuwf8Yh",
		"breadTipsBtn": "Z8y3Kkkxc3cSh5nTexX_l",
		"breadTipsWords": "-V28i00vUm62pfgGaX2s0"
	};

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._1s-tgHHhcz-8rcX-zRr7p0{padding-top:200px;width:100%;height:100%;padding:10px;font-size:12px;color:#fff;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"empty": "_1s-tgHHhcz-8rcX-zRr7p0"
	};

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._3Kduwk9zES94NTM3L6-ZWb{background-color:transparent!important}", ""]);
	
	// exports
	exports.locals = {
		"ant-collapse-borderless": "_3Kduwk9zES94NTM3L6-ZWb"
	};

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._3iIVVHlmwdTIGd8lsDxsgc{display:-webkit-box;-webkit-line-clamp:4;overflow:hidden;text-overflow:ellipsis}._2KjqnJzeOz9huOX9Wv-Ffk{width:530px!important}", ""]);
	
	// exports
	exports.locals = {
		"overflowHidden": "_3iIVVHlmwdTIGd8lsDxsgc",
		"checkInfoModal": "_2KjqnJzeOz9huOX9Wv-Ffk"
	};

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._3JFq4_ZyYd5Q0Eu4-lOnE5{color:#fff;height:100%;width:100%;background-size:cover;background-position:50%;background-repeat:no-repeat}._2xWvL9by_CRp5yJF0fySYs{display:inline-block;width:100px;line-height:20px;font-size:10px}.LweEjptowfefrh-QyqYYg{background-color:#00b34f;box-sizing:border-box;padding:0 28px;height:60px;line-height:53px;position:relative}._3if0lI87ICbtkeCaQJQn3r{background-color:transparent;box-sizing:border-box;padding:0 300px;overflow:auto}._3ofIjor346_xjt4cKctouZ{height:70px;text-align:center;background-color:transparent}._3KA4598MGWqTSpiCRaA8CO{position:absolute;top:0;right:20px;color:#fff;cursor:pointer}._1jAbqVr8wDKCTeQvwBvXFS{display:inline-block;height:100%}._11rUxXwE9Ks71iTacpgcdc{font-weight:700}.wnSo2VDuT-cwnjG3ygw4c{display:inline-block;height:36px;width:1px;margin:0 20px;background-color:#fff;vertical-align:middle}.zMRzaIvOi1xJS5RmN_5HH{background-color:#000}._231b9cunLw7fvfwxvWX0bU{height:36px;display:inline-block;vertical-align:middle}.zqa2Kf8mzl_-ktX66YILs{display:inline-block;font-size:13px;width:200px;height:39px;line-height:1.5;word-wrap:break-word;box-sizing:border-box;vertical-align:middle;color:#fff}._3M-VmUZRjgarePnE6UXNPV{float:right;margin:20px 200px 0 0}._27a-_8H3rg4RIjuR2d6rFA{display:flex;color:#1890ff;height:446px;background-color:#fff;box-shadow:0 0 20px rgb(0 0 0/50%);border-radius:15px;position:absolute;top:160px;right:168px;margin:auto;padding:40px 50px}._2aJ-Y_NP0A7tt-iaskmtsO{width:16px;height:172px;text-align:center;line-height:165px;background-color:#b9c3d4;border-radius:10px 0 0 10px;box-shadow:-5px 0 20px rgb(0 0 0/30%);position:absolute;top:16px;left:-16px;color:#fff;cursor:pointer}._1DJKBb-0133zYtcF3qAWaH{font-size:10px}.gjKC6wv9TH0XS5SFz2pK7{width:600px;height:100%;border-right:1px solid #dcdfe6;box-sizing:border-box;padding:20px 60px 20px 116px;color:#8f8f8f;font-size:13px}._2ekc3oiGVP9g4bzXwQTvhK,.gjKC6wv9TH0XS5SFz2pK7{overflow:hidden;transition:all .4s ease-in-out;white-space:nowrap}._2ekc3oiGVP9g4bzXwQTvhK{width:0}._2mMLtUWRbuIqxzRWCZa2pk{color:#8f8f8f;line-height:30px}._2mMLtUWRbuIqxzRWCZa2pk a{color:#c04323}._2mMLtUWRbuIqxzRWCZa2pk div{position:relative;line-height:20px}._3Kw_kYZLxM_6tzsk4L4Ww0{display:inline-block;position:absolute;right:30px;top:5px}._1R7kxiUovyBvnvk4B_IV_U{margin-top:50px;font-size:14px;color:#8f8f8f}.AVaQP5h0x3GsWfCrLnmJ3{display:flex;justify-content:space-between}.UXHNWYQ0AjdeYTL8Ps-gZ{width:390px;height:100%;box-sizing:border-box;padding:20px 38px 0}.UXHNWYQ0AjdeYTL8Ps-gZ h2,.UXHNWYQ0AjdeYTL8Ps-gZ h5{text-align:center;color:#124a85}._2CeUiXsxPrzTTvh3vcY7lG{margin:20px 0;padding:0 0 10px;font-size:larger;text-align:center;border-bottom:1px solid #dcdcdc}._2MJqJHj3f1L_ea22Bh2vST{width:215px;height:215px;margin:10px 0 7px 65px}._2kInET0klLXxPMZ8b35m02{text-align:center;margin-top:10px;font-size:15px}._2TxClFniTcntfYJZTze3zI{cursor:pointer;color:#1e90ff}._1LOXzNgn8kynx5vOpuDJBn{width:100%;margin-bottom:13px;background:#124a85}._1LOXzNgn8kynx5vOpuDJBn:hover{color:#fff;background-color:#124a85;border-color:#124a85}._2teXaGblj9TyfmGC_eXqcG{cursor:pointer;color:#1890ff;margin-left:10px;font-size:12px}._1OTrADawGO91Jx-A0PXugu{color:#a8a8a8;font-size:12px;line-height:16px}.Y6AGfN1Z6TPDLcp552uk3{color:#fff}.JA_q6k-_-VJVv7w34XObl{width:13px;height:15px}._2t4ttIaRKijdkTiOCpv92V{text-align:center;color:red;max-width:254px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}._3OV5mCB0pW4yaXqjlQxOqV{height:30px;line-height:30px;text-align:center}._3OV5mCB0pW4yaXqjlQxOqV a{color:#00b34f;margin-right:15px;font-size:13px}._3OV5mCB0pW4yaXqjlQxOqV img{width:18px;height:18px;vertical-align:middle;margin-right:10px}._2hQio5DyD0lT385WeMfBCq{display:inline-block;width:36px;height:36px;background-position:0 0;background-size:cover;margin-right:10px;background-image:url(" + __webpack_require__(2032) + ");vertical-align:text-bottom;text-align:center}._3rU1QsjhSmNl5MNbPHMa05{font-weight:700;color:#124a85;margin:50px 0 0}._18hNCLAYZSi4GNlPz4L2Xe{font-weight:700;color:#124a85;text-align:center;margin-bottom:10px}:globel .bnrzk-hf3_qEHCCjsNvkP .w-jTlMoH0xMG4Pk7cOPtG{margin-bottom:18px}", ""]);
	
	// exports
	exports.locals = {
		"loginLayout": "_3JFq4_ZyYd5Q0Eu4-lOnE5",
		"loginDesc": "_2xWvL9by_CRp5yJF0fySYs",
		"loginHeader": "LweEjptowfefrh-QyqYYg",
		"loginContent": "_3if0lI87ICbtkeCaQJQn3r",
		"loginFooter": "_3ofIjor346_xjt4cKctouZ",
		"toLogin": "_3KA4598MGWqTSpiCRaA8CO",
		"loginTitle": "_1jAbqVr8wDKCTeQvwBvXFS",
		"loginTitleSpan": "_11rUxXwE9Ks71iTacpgcdc",
		"divider": "wnSo2VDuT-cwnjG3ygw4c",
		"Divider1": "zMRzaIvOi1xJS5RmN_5HH",
		"loginTitleImg": "_231b9cunLw7fvfwxvWX0bU",
		"loginTitleText": "zqa2Kf8mzl_-ktX66YILs",
		"registerBtn": "_3M-VmUZRjgarePnE6UXNPV",
		"loginArea": "_27a-_8H3rg4RIjuR2d6rFA",
		"toggleBtn": "_2aJ-Y_NP0A7tt-iaskmtsO",
		"toggleIcon": "_1DJKBb-0133zYtcF3qAWaH",
		"loginAreaLeft": "gjKC6wv9TH0XS5SFz2pK7",
		"loginAreaLeft_hidden": "_2ekc3oiGVP9g4bzXwQTvhK",
		"proposal": "_2mMLtUWRbuIqxzRWCZa2pk",
		"check": "_3Kw_kYZLxM_6tzsk4L4Ww0",
		"tip": "_1R7kxiUovyBvnvk4B_IV_U",
		"diyItem": "AVaQP5h0x3GsWfCrLnmJ3",
		"loginAreaRight": "UXHNWYQ0AjdeYTL8Ps-gZ",
		"accPwdLoginTitle": "_2CeUiXsxPrzTTvh3vcY7lG",
		"QRCode": "_2MJqJHj3f1L_ea22Bh2vST",
		"QRCodeText": "_2kInET0klLXxPMZ8b35m02",
		"QRCodeRefresh": "_2TxClFniTcntfYJZTze3zI",
		"login-form-button": "_1LOXzNgn8kynx5vOpuDJBn",
		"changeOne": "_2teXaGblj9TyfmGC_eXqcG",
		"certification": "_1OTrADawGO91Jx-A0PXugu",
		"certificationText": "Y6AGfN1Z6TPDLcp552uk3",
		"certificationImg": "JA_q6k-_-VJVv7w34XObl",
		"errMsg": "_2t4ttIaRKijdkTiOCpv92V",
		"Footer_content": "_3OV5mCB0pW4yaXqjlQxOqV",
		"zllogo": "_2hQio5DyD0lT385WeMfBCq",
		"formTitle": "_3rU1QsjhSmNl5MNbPHMa05",
		"formSubTitle": "_18hNCLAYZSi4GNlPz4L2Xe",
		"loginform": "bnrzk-hf3_qEHCCjsNvkP",
		"ant-form-item": "w-jTlMoH0xMG4Pk7cOPtG"
	};

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._3mx4NOLVnJzzQk62K5XNl3,._46mgwSxAmEd_5gYuX_4r,.JSsz9ysLavmobPpRyKa7h{height:inherit;text-align:initial}._3mx4NOLVnJzzQk62K5XNl3[contenteditable=true]{-webkit-user-modify:read-write-plaintext-only}.JSsz9ysLavmobPpRyKa7h{position:relative}._46mgwSxAmEd_5gYuX_4r{background-color:hsla(0,0%,100%,0);border-left:.1px solid transparent;position:relative;z-index:1}._1ehaexJ4fzppwLIo6fh2W8{position:relative}.tKNIvmNN8k_P-tCiJrRGa ._142LTwYdu_2-huBhGfRR_N{text-align:left}.tKNIvmNN8k_P-tCiJrRGa .Jta9vXPBliPQQKGYYtnKJ{left:0;text-align:left}._3xRnXukA2pO3LDUDuRRU9p ._142LTwYdu_2-huBhGfRR_N{text-align:center}._3xRnXukA2pO3LDUDuRRU9p .Jta9vXPBliPQQKGYYtnKJ{margin:0 auto;text-align:center;width:100%}.qUcNoxbOc_Zqlq0PZvwDJ ._142LTwYdu_2-huBhGfRR_N{text-align:right}.qUcNoxbOc_Zqlq0PZvwDJ .Jta9vXPBliPQQKGYYtnKJ{right:0;text-align:right}.Jta9vXPBliPQQKGYYtnKJ{color:#9197a3;position:absolute;z-index:1}._1EdxEUqFHG9IFy0jTem5wr{color:#bdc1c9}._2Xsy9RCyf5Hpkb0qtwaIYf{display:none}._142LTwYdu_2-huBhGfRR_N{position:relative;white-space:pre-wrap}._1YV-mEU57JDZYiptJ82p2A{direction:ltr;text-align:left}._1EhqQaG0H7erk_4z-2b9-n{direction:rtl;text-align:right}._3lYIcbcxhaA6nGFkFvoZsW{direction:ltr}.krYxrB-XfNLyBkV4Av6jX{direction:rtl}._3RWBbzhIyuKN1lv11jPqV6,._40dX-VFUCAlR0rIybOeDR{margin:16px 0;padding:0}.i6zgINZPLr-kP6jh2Jt0F._3lYIcbcxhaA6nGFkFvoZsW{margin-left:1.5em}.i6zgINZPLr-kP6jh2Jt0F.krYxrB-XfNLyBkV4Av6jX{margin-right:1.5em}._1fDqv1KzWVTi2yW2ehES8-._3lYIcbcxhaA6nGFkFvoZsW{margin-left:3em}._1fDqv1KzWVTi2yW2ehES8-.krYxrB-XfNLyBkV4Av6jX{margin-right:3em}._1ZF44ohLxlFiNRlxDl62rT._3lYIcbcxhaA6nGFkFvoZsW{margin-left:4.5em}._1ZF44ohLxlFiNRlxDl62rT.krYxrB-XfNLyBkV4Av6jX{margin-right:4.5em}.ogA2KdtW697dcj6Een4Tu._3lYIcbcxhaA6nGFkFvoZsW{margin-left:6em}.ogA2KdtW697dcj6Een4Tu.krYxrB-XfNLyBkV4Av6jX{margin-right:6em}._3o_sMnNhc_KrL5dcGMphHa._3lYIcbcxhaA6nGFkFvoZsW{margin-left:7.5em}._3o_sMnNhc_KrL5dcGMphHa.krYxrB-XfNLyBkV4Av6jX{margin-right:7.5em}._3fZOhWnTbNcKQP3cJhKB_U{list-style-type:square;position:relative}._3fZOhWnTbNcKQP3cJhKB_U.i6zgINZPLr-kP6jh2Jt0F{list-style-type:disc}._3fZOhWnTbNcKQP3cJhKB_U._1fDqv1KzWVTi2yW2ehES8-{list-style-type:circle}.Ih-7w8j9v3dtcYXd5ZMGj{list-style-type:none;position:relative}.Ih-7w8j9v3dtcYXd5ZMGj._3lYIcbcxhaA6nGFkFvoZsW:before{left:-36px;position:absolute;text-align:right;width:30px}.Ih-7w8j9v3dtcYXd5ZMGj.krYxrB-XfNLyBkV4Av6jX:before{position:absolute;right:-36px;text-align:left;width:30px}.Ih-7w8j9v3dtcYXd5ZMGj:before{content:counter(ol0) \". \";counter-increment:ol0}.Ih-7w8j9v3dtcYXd5ZMGj._1fDqv1KzWVTi2yW2ehES8-:before{content:counter(ol1) \". \";counter-increment:ol1}.Ih-7w8j9v3dtcYXd5ZMGj._1ZF44ohLxlFiNRlxDl62rT:before{content:counter(ol2) \". \";counter-increment:ol2}.Ih-7w8j9v3dtcYXd5ZMGj.ogA2KdtW697dcj6Een4Tu:before{content:counter(ol3) \". \";counter-increment:ol3}.Ih-7w8j9v3dtcYXd5ZMGj._3o_sMnNhc_KrL5dcGMphHa:before{content:counter(ol4) \". \";counter-increment:ol4}.i6zgINZPLr-kP6jh2Jt0F.qw7VJkHB-K4Jjh2KrYnbU{counter-reset:ol0}._1fDqv1KzWVTi2yW2ehES8-.qw7VJkHB-K4Jjh2KrYnbU{counter-reset:ol1}._1ZF44ohLxlFiNRlxDl62rT.qw7VJkHB-K4Jjh2KrYnbU{counter-reset:ol2}.ogA2KdtW697dcj6Een4Tu.qw7VJkHB-K4Jjh2KrYnbU{counter-reset:ol3}._3o_sMnNhc_KrL5dcGMphHa.qw7VJkHB-K4Jjh2KrYnbU{counter-reset:ol4}", ""]);
	
	// exports
	exports.locals = {
		"DraftEditor-editorContainer": "_46mgwSxAmEd_5gYuX_4r",
		"DraftEditor-root": "JSsz9ysLavmobPpRyKa7h",
		"public-DraftEditor-content": "_3mx4NOLVnJzzQk62K5XNl3",
		"public-DraftEditor-block": "_1ehaexJ4fzppwLIo6fh2W8",
		"DraftEditor-alignLeft": "tKNIvmNN8k_P-tCiJrRGa",
		"public-DraftStyleDefault-block": "_142LTwYdu_2-huBhGfRR_N",
		"public-DraftEditorPlaceholder-root": "Jta9vXPBliPQQKGYYtnKJ",
		"DraftEditor-alignCenter": "_3xRnXukA2pO3LDUDuRRU9p",
		"DraftEditor-alignRight": "qUcNoxbOc_Zqlq0PZvwDJ",
		"public-DraftEditorPlaceholder-hasFocus": "_1EdxEUqFHG9IFy0jTem5wr",
		"DraftEditorPlaceholder-hidden": "_2Xsy9RCyf5Hpkb0qtwaIYf",
		"public-DraftStyleDefault-ltr": "_1YV-mEU57JDZYiptJ82p2A",
		"public-DraftStyleDefault-rtl": "_1EhqQaG0H7erk_4z-2b9-n",
		"public-DraftStyleDefault-listLTR": "_3lYIcbcxhaA6nGFkFvoZsW",
		"public-DraftStyleDefault-listRTL": "krYxrB-XfNLyBkV4Av6jX",
		"public-DraftStyleDefault-ol": "_3RWBbzhIyuKN1lv11jPqV6",
		"public-DraftStyleDefault-ul": "_40dX-VFUCAlR0rIybOeDR",
		"public-DraftStyleDefault-depth0": "i6zgINZPLr-kP6jh2Jt0F",
		"public-DraftStyleDefault-depth1": "_1fDqv1KzWVTi2yW2ehES8-",
		"public-DraftStyleDefault-depth2": "_1ZF44ohLxlFiNRlxDl62rT",
		"public-DraftStyleDefault-depth3": "ogA2KdtW697dcj6Een4Tu",
		"public-DraftStyleDefault-depth4": "_3o_sMnNhc_KrL5dcGMphHa",
		"public-DraftStyleDefault-unorderedListItem": "_3fZOhWnTbNcKQP3cJhKB_U",
		"public-DraftStyleDefault-orderedListItem": "Ih-7w8j9v3dtcYXd5ZMGj",
		"public-DraftStyleDefault-reset": "qw7VJkHB-K4Jjh2KrYnbU"
	};

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * \n * antd v3.26.20\n * \n * Copyright 2015-present, Alipay, Inc.\n * All rights reserved.\n *       \n */body,html{width:100%;height:100%}input::-ms-clear,input::-ms-reveal{display:none}*,:after,:before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0)}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;color:rgba(0,0,0,.65);font-size:14px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;font-variant:tabular-nums;line-height:1.5;background-color:#fff;font-feature-settings:\"tnum\"}[tabindex=\"-1\"]:focus{outline:none!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5em;color:rgba(0,0,0,.85);font-weight:500}p{margin-top:0;margin-bottom:1em}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;border-bottom:0;cursor:help}address{margin-bottom:1em;font-style:normal;line-height:inherit}input[type=number],input[type=password],input[type=text],textarea{-webkit-appearance:none}dl,ol,ul{margin-top:0;margin-bottom:1em}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:500}dd{margin-bottom:.5em;margin-left:0}blockquote{margin:0 0 1em}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#1890ff;text-decoration:none;background-color:transparent;outline:none;cursor:pointer;transition:color .3s;-webkit-text-decoration-skip:objects}a:hover{color:#40a9ff}a:active{color:#096dd9}a:active,a:hover{text-decoration:none;outline:0}a[disabled]{color:rgba(0,0,0,.25);cursor:not-allowed;pointer-events:none}code,kbd,pre,samp{font-size:1em;font-family:SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace}pre{margin-top:0;margin-bottom:1em;overflow:auto}figure{margin:0 0 1em}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}[role=button],a,area,button,input:not([type=range]),label,select,summary,textarea{-ms-touch-action:manipulation;touch-action:manipulation}table{border-collapse:collapse}caption{padding-top:.75em;padding-bottom:.3em;color:rgba(0,0,0,.45);text-align:left;caption-side:bottom}th{text-align:inherit}button,input,optgroup,select,textarea{margin:0;color:inherit;font-size:inherit;font-family:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;margin:0;padding:0;border:0}legend{display:block;width:100%;max-width:100%;margin-bottom:.5em;padding:0;color:inherit;font-size:1.5em;line-height:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item}template{display:none}[hidden]{display:none!important}mark{padding:.2em;background-color:#feffe6}::-moz-selection{color:#fff;background:#1890ff}::selection{color:#fff;background:#1890ff}.GRAxHGgP4KbQU49MIYMhy{zoom:1}.GRAxHGgP4KbQU49MIYMhy:after,.GRAxHGgP4KbQU49MIYMhy:before{display:table;content:\"\"}.GRAxHGgP4KbQU49MIYMhy:after{clear:both}._1oZ8xlpZEg3PzGp2jMNFuZ{display:inline-block;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}._1oZ8xlpZEg3PzGp2jMNFuZ>*{line-height:1}._1oZ8xlpZEg3PzGp2jMNFuZ svg{display:inline-block}._1oZ8xlpZEg3PzGp2jMNFuZ:before{display:none}._1oZ8xlpZEg3PzGp2jMNFuZ ._2a2Jxhx6-qqWCLHuIArc2k{display:block}._1oZ8xlpZEg3PzGp2jMNFuZ[tabindex]{cursor:pointer}._2T5KIe2E01O08ArJZjBwJx,._2T5KIe2E01O08ArJZjBwJx:before{display:inline-block;animation:Gr_4nuETdHDqjOknz5a9U 1s infinite linear}._1g2gTRrNLy24CadA0jRxpO,._2yIIjXWrx8HwbiBeOJ7gdX,._242E5v8yZFoYNA4OeftlIX{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._2yIIjXWrx8HwbiBeOJ7gdX._3axE2tLt2DDMqvBILVEMBR,._242E5v8yZFoYNA4OeftlIX._1dmGqoN_XvvLLUQXoHIIbn{animation-name:tsKMliLjM5nxk0U_4cZVn;animation-play-state:running}._1g2gTRrNLy24CadA0jRxpO._1iGuqruo0WWqvUmGbUeHLE{animation-name:_8ZbC_DJdfpXbZBUOpZ3Cr;animation-play-state:running;pointer-events:none}._2yIIjXWrx8HwbiBeOJ7gdX,._242E5v8yZFoYNA4OeftlIX{opacity:0;animation-timing-function:linear}._1g2gTRrNLy24CadA0jRxpO{animation-timing-function:linear}@keyframes tsKMliLjM5nxk0U_4cZVn{0%{opacity:0}to{opacity:1}}@keyframes _8ZbC_DJdfpXbZBUOpZ3Cr{0%{opacity:1}to{opacity:0}}._2T2CHtH4XgVwCRHMaV3ayw,._3O6v5VDnOMLJLvL1JCtQy3,.riJZyqT7Q70ZZl_RkQqyj{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._3O6v5VDnOMLJLvL1JCtQy3.KaewGU-uz3LKVRztEF57-,.riJZyqT7Q70ZZl_RkQqyj._2B53VgZ-RtYYcsiWcdk6pk{animation-name:RcEs12kfajOcoBCT-GpKI;animation-play-state:running}._2T2CHtH4XgVwCRHMaV3ayw._4yObpTmaBJmC5s1pcDxJp{animation-name:jTRGk-qJQWaDko4kBZfxg;animation-play-state:running;pointer-events:none}._3O6v5VDnOMLJLvL1JCtQy3,.riJZyqT7Q70ZZl_RkQqyj{opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._2T2CHtH4XgVwCRHMaV3ayw{animation-timing-function:cubic-bezier(.6,.04,.98,.34)}._1DiObDT4u8f9Y897gxe9PH,._3XZ4dtWJKkdq9R1Xmu106F,.s_DTZSr0waV5kr-Tm20dD{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._3XZ4dtWJKkdq9R1Xmu106F._2wJGs-4e9CRPyYdDWsh9uS,.s_DTZSr0waV5kr-Tm20dD._3xk3cu82w4bBWbu0hxYwQe{animation-name:_2Lfj8GIETyDn7FsnLjgMSW;animation-play-state:running}._1DiObDT4u8f9Y897gxe9PH._1DHL72AB2-jlGYEBTVi3pP{animation-name:_3ZXvXgSEv2FfFIIAYCvE4y;animation-play-state:running;pointer-events:none}._3XZ4dtWJKkdq9R1Xmu106F,.s_DTZSr0waV5kr-Tm20dD{opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._1DiObDT4u8f9Y897gxe9PH{animation-timing-function:cubic-bezier(.6,.04,.98,.34)}._2bqrjM0DJm9_YD1XFY2ADL,._2i3L63PguN9Dpl50vPt66j,._3oReU6WPlquQ_8SU0pFChc{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._2bqrjM0DJm9_YD1XFY2ADL._1T2H9eVwoV1tYHsInSeUmi,._3oReU6WPlquQ_8SU0pFChc._3GbZZz38H2D27LzYxDJCC8{animation-name:_2PtsioFep3Zhoj6_ZuefLT;animation-play-state:running}._2i3L63PguN9Dpl50vPt66j._2l4pfm-fqWBbZ7SOf29lUL{animation-name:_2rXSohlMGgE-sjxltVphUw;animation-play-state:running;pointer-events:none}._2bqrjM0DJm9_YD1XFY2ADL,._3oReU6WPlquQ_8SU0pFChc{opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._2i3L63PguN9Dpl50vPt66j{animation-timing-function:cubic-bezier(.6,.04,.98,.34)}.-gp1peJWX6WJ4WZ_iMD-z,._2WThW35UHIgZC5daxRYHgt,.hlld-L1gRwXDzcnmJdwMJ{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}.-gp1peJWX6WJ4WZ_iMD-z._3jwxWmbs6m69pZ_0OkgUyO,._2WThW35UHIgZC5daxRYHgt._1lEiinVBZmX_DqkNBbUGu8{animation-name:_1Z08p_YS3jHY07_7ngFzLo;animation-play-state:running}.hlld-L1gRwXDzcnmJdwMJ._7axc4JSxbSpOeWmtmCcEU{animation-name:cJpSuL12hmmVequ3tg4Oe;animation-play-state:running;pointer-events:none}.-gp1peJWX6WJ4WZ_iMD-z,._2WThW35UHIgZC5daxRYHgt{opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}.hlld-L1gRwXDzcnmJdwMJ{animation-timing-function:cubic-bezier(.6,.04,.98,.34)}@keyframes _2Lfj8GIETyDn7FsnLjgMSW{0%{transform:translateY(100%);transform-origin:0 0;opacity:0}to{transform:translateY(0);transform-origin:0 0;opacity:1}}@keyframes _3ZXvXgSEv2FfFIIAYCvE4y{0%{transform:translateY(0);transform-origin:0 0;opacity:1}to{transform:translateY(100%);transform-origin:0 0;opacity:0}}@keyframes _2PtsioFep3Zhoj6_ZuefLT{0%{transform:translateX(-100%);transform-origin:0 0;opacity:0}to{transform:translateX(0);transform-origin:0 0;opacity:1}}@keyframes _2rXSohlMGgE-sjxltVphUw{0%{transform:translateX(0);transform-origin:0 0;opacity:1}to{transform:translateX(-100%);transform-origin:0 0;opacity:0}}@keyframes _1Z08p_YS3jHY07_7ngFzLo{0%{transform:translateX(100%);transform-origin:0 0;opacity:0}to{transform:translateX(0);transform-origin:0 0;opacity:1}}@keyframes cJpSuL12hmmVequ3tg4Oe{0%{transform:translateX(0);transform-origin:0 0;opacity:1}to{transform:translateX(100%);transform-origin:0 0;opacity:0}}@keyframes RcEs12kfajOcoBCT-GpKI{0%{transform:translateY(-100%);transform-origin:0 0;opacity:0}to{transform:translateY(0);transform-origin:0 0;opacity:1}}@keyframes jTRGk-qJQWaDko4kBZfxg{0%{transform:translateY(0);transform-origin:0 0;opacity:1}to{transform:translateY(-100%);transform-origin:0 0;opacity:0}}@keyframes Gr_4nuETdHDqjOknz5a9U{to{transform:rotate(1turn)}}[ant-click-animating-without-extra-node=true],[ant-click-animating=true]{position:relative}html{--antd-wave-shadow-color:#1890ff}._13Kn8L5SZrD9eU43bEfYxr,[ant-click-animating-without-extra-node=true]:after{position:absolute;top:0;right:0;bottom:0;left:0;display:block;border-radius:inherit;box-shadow:0 0 0 0 #1890ff;box-shadow:0 0 0 0 var(--antd-wave-shadow-color);opacity:.2;animation:_3_W-3PzDq5urW3aTIYaMsy 2s cubic-bezier(.08,.82,.17,1),_2Sc6xgJ_JLcUTn9aYPDbl_ .4s cubic-bezier(.08,.82,.17,1);animation-fill-mode:forwards;content:\"\";pointer-events:none}@keyframes _2Sc6xgJ_JLcUTn9aYPDbl_{to{box-shadow:0 0 0 #1890ff;box-shadow:0 0 0 6px var(--antd-wave-shadow-color)}}@keyframes _3_W-3PzDq5urW3aTIYaMsy{to{opacity:0}}._1vRvMYH3Kp_wSCSKo1Vzkx,._3BcFfbN5qAnzO13exrUs03,._3JPmXAUWZHG7TyCs5QZHGb{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim,._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C{animation-name:_2lqTGgogIItpImYAn3wMQO;animation-play-state:running}._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX{animation-name:_2IDJAVNNcAmXsLtWbzNJtk;animation-play-state:running;pointer-events:none}._1vRvMYH3Kp_wSCSKo1Vzkx,._3BcFfbN5qAnzO13exrUs03{opacity:0;animation-timing-function:cubic-bezier(.23,1,.32,1)}._3JPmXAUWZHG7TyCs5QZHGb{animation-timing-function:cubic-bezier(.755,.05,.855,.06)}._3U26mI8v1P5mnWxpeY6WGl,._13M3iELddKrUZBZtrDutrC,.nnu83yLJXtrbX26qRN8Ql{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._3U26mI8v1P5mnWxpeY6WGl._1d3YwZDfYeQFLL1hGNfRl9,._13M3iELddKrUZBZtrDutrC._1oph4ifflZofWhYZ30mQw4{animation-name:_3JK1uFdxrQM9RK51sOtrar;animation-play-state:running}.nnu83yLJXtrbX26qRN8Ql.DA65YF9uBqCSmnAzuwyH{animation-name:_1F89QugyM0FQpooygKHf2k;animation-play-state:running;pointer-events:none}._3U26mI8v1P5mnWxpeY6WGl,._13M3iELddKrUZBZtrDutrC{opacity:0;animation-timing-function:cubic-bezier(.23,1,.32,1)}.nnu83yLJXtrbX26qRN8Ql{animation-timing-function:cubic-bezier(.755,.05,.855,.06)}._3Gh6P4Ql9wnf86pkRZMzf4,._22fvq84HK5LcqWmOfiyy2M,._30OXgs2pqK7fkuFxdpMfY5{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._22fvq84HK5LcqWmOfiyy2M._1Keo9exhwUVzJftLkQtIkF,._30OXgs2pqK7fkuFxdpMfY5._2lDndpWsv_W3joWMbiz8q4{animation-name:xYmKqzhgXItCbyPzNG7DK;animation-play-state:running}._3Gh6P4Ql9wnf86pkRZMzf4._1blKO9DK-2MInyDAZe6gyM{animation-name:aWiaj1S3bdrixEVCv6jl5;animation-play-state:running;pointer-events:none}._22fvq84HK5LcqWmOfiyy2M,._30OXgs2pqK7fkuFxdpMfY5{opacity:0;animation-timing-function:cubic-bezier(.23,1,.32,1)}._3Gh6P4Ql9wnf86pkRZMzf4{animation-timing-function:cubic-bezier(.755,.05,.855,.06)}._2WNm00xGXf63G71Cdrox0g,._177updpNu_ogWKAWgYeREG,.lcy-kgC9kh2tWu_nSxOr1{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._2WNm00xGXf63G71Cdrox0g._3PFYIOLZfgpGxApB3M74eA,.lcy-kgC9kh2tWu_nSxOr1._3TyAJl9FZjAHHHtJXKwVL3{animation-name:_2ErC7u5PkydcgIx1nvn53a;animation-play-state:running}._177updpNu_ogWKAWgYeREG._22EzDOTdN9WwsihthGXfAe{animation-name:_1PU8ByzRPeFddREmytc6xJ;animation-play-state:running;pointer-events:none}._2WNm00xGXf63G71Cdrox0g,.lcy-kgC9kh2tWu_nSxOr1{opacity:0;animation-timing-function:cubic-bezier(.23,1,.32,1)}._177updpNu_ogWKAWgYeREG{animation-timing-function:cubic-bezier(.755,.05,.855,.06)}@keyframes _2lqTGgogIItpImYAn3wMQO{0%{transform:scaleY(.8);transform-origin:0 0;opacity:0}to{transform:scaleY(1);transform-origin:0 0;opacity:1}}@keyframes _2IDJAVNNcAmXsLtWbzNJtk{0%{transform:scaleY(1);transform-origin:0 0;opacity:1}to{transform:scaleY(.8);transform-origin:0 0;opacity:0}}@keyframes _3JK1uFdxrQM9RK51sOtrar{0%{transform:scaleY(.8);transform-origin:100% 100%;opacity:0}to{transform:scaleY(1);transform-origin:100% 100%;opacity:1}}@keyframes _1F89QugyM0FQpooygKHf2k{0%{transform:scaleY(1);transform-origin:100% 100%;opacity:1}to{transform:scaleY(.8);transform-origin:100% 100%;opacity:0}}@keyframes xYmKqzhgXItCbyPzNG7DK{0%{transform:scaleX(.8);transform-origin:0 0;opacity:0}to{transform:scaleX(1);transform-origin:0 0;opacity:1}}@keyframes aWiaj1S3bdrixEVCv6jl5{0%{transform:scaleX(1);transform-origin:0 0;opacity:1}to{transform:scaleX(.8);transform-origin:0 0;opacity:0}}@keyframes _2ErC7u5PkydcgIx1nvn53a{0%{transform:scaleX(.8);transform-origin:100% 0;opacity:0}to{transform:scaleX(1);transform-origin:100% 0;opacity:1}}@keyframes _1PU8ByzRPeFddREmytc6xJ{0%{transform:scaleX(1);transform-origin:100% 0;opacity:1}to{transform:scaleX(.8);transform-origin:100% 0;opacity:0}}._9XOEXIbNDp87Yv3MvaT8T,._16wcgwCGQ_jLl8nHWFe7iq{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._9XOEXIbNDp87Yv3MvaT8T._3Ebdq4gSWkFOCtmLExCnCP,._16wcgwCGQ_jLl8nHWFe7iq.pwyhBz_HkooK-dMdHXMh6{animation-name:UxEmIDdjBs3MplNP5UFx3;animation-play-state:running}@keyframes UxEmIDdjBs3MplNP5UFx3{0%,to{transform:translateX(0)}20%{transform:translateX(-10px)}40%{transform:translateX(10px)}60%{transform:translateX(-5px)}80%{transform:translateX(5px)}}._1dq1hSnQ28O5mrHxyKeRa0,._1YgzGl4Cg8r4L98w4bKHc,._30--xMhxZ94JTK2d9gG6H5{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._1dq1hSnQ28O5mrHxyKeRa0._1VpJc9vXLf4V3hzrUlEwOE,._30--xMhxZ94JTK2d9gG6H5._223a30KA5pYI5LbXrVEQL0{animation-name:MpRT7DyQF1m-VY7aPPCYB;animation-play-state:running}._1YgzGl4Cg8r4L98w4bKHc._1uDppHf6JdMeIJCzdzEIXi{animation-name:_1vuPnqMO_T4JJwqOLazeij;animation-play-state:running;pointer-events:none}._1dq1hSnQ28O5mrHxyKeRa0,._30--xMhxZ94JTK2d9gG6H5{transform:scale(0);opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._1YgzGl4Cg8r4L98w4bKHc{animation-timing-function:cubic-bezier(.78,.14,.15,.86)}._1QIV4dFJN9Ntgg-dh-4u7V,._2H1LfkbcwoN8RTSOo_ag6P,._2770rp_u6RadV_fszv4tcu{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._1QIV4dFJN9Ntgg-dh-4u7V.ncRvHKNWep6mV4iYNRoot,._2H1LfkbcwoN8RTSOo_ag6P.-V8s0YhPDDMNAEHcRVYxf{animation-name:c5mf4FXCF0QTY_a_rOpd7;animation-play-state:running}._2770rp_u6RadV_fszv4tcu._13B1eoSndrgu1RoN1Q8hg5{animation-name:_1sFmlYzMjtL0HQENgQwwrd;animation-play-state:running;pointer-events:none}._1QIV4dFJN9Ntgg-dh-4u7V,._2H1LfkbcwoN8RTSOo_ag6P{transform:scale(0);opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._2770rp_u6RadV_fszv4tcu{animation-timing-function:cubic-bezier(.78,.14,.15,.86)}._2cHzdn3XK8HJa3b3fTpdVL,._3X4aWDEK-IBXFoOPXSialQ,._13SegEJP_MMNzqYF5MyHBu{animation-duration:.1s;animation-fill-mode:both;animation-play-state:paused}._3X4aWDEK-IBXFoOPXSialQ._2GFUBY_lE8Loo50dtXklqk,._13SegEJP_MMNzqYF5MyHBu.kij7wpKz8W7E4S4-JASIm{animation-name:c5mf4FXCF0QTY_a_rOpd7;animation-play-state:running}._2cHzdn3XK8HJa3b3fTpdVL._2Rt9tQ15ww2w4a6de-V45C{animation-name:_1sFmlYzMjtL0HQENgQwwrd;animation-play-state:running;pointer-events:none}._3X4aWDEK-IBXFoOPXSialQ,._13SegEJP_MMNzqYF5MyHBu{transform:scale(0);opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._2cHzdn3XK8HJa3b3fTpdVL{animation-timing-function:cubic-bezier(.78,.14,.15,.86)}._3C9B-1KZjJgoKOlgQqTpq6,._3QnKTfcB2AonJrxnjM1Q7S,._16qbuy5e4fq_F9AGL6jI4r{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._3QnKTfcB2AonJrxnjM1Q7S._3g8goyYCD1MPpDUzJBzVUb,._16qbuy5e4fq_F9AGL6jI4r._1u4nGsnu7NHNHPfb7TY8dt{animation-name:_3vkv06gZsPpCT7n09GPxHF;animation-play-state:running}._3C9B-1KZjJgoKOlgQqTpq6._1P4KFy_2SdhskyYkMzAs_H{animation-name:Sf_Lb8yVKL66PrLOYgJjw;animation-play-state:running;pointer-events:none}._3QnKTfcB2AonJrxnjM1Q7S,._16qbuy5e4fq_F9AGL6jI4r{transform:scale(0);opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._3C9B-1KZjJgoKOlgQqTpq6{animation-timing-function:cubic-bezier(.78,.14,.15,.86)}._1htT410frFKyzX80Av14sQ,._2FUShwmg3tCEVV4qNsmeHD,._3MqCteWlESS5iIF7dNgOIb{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._1htT410frFKyzX80Av14sQ.-TEuLlrgZyoWY_IISKLkO,._3MqCteWlESS5iIF7dNgOIb._2RZPdzyXkOrjpu1u3Ay2VU{animation-name:Y1nWzmrvbXH3mMK4epmGj;animation-play-state:running}._2FUShwmg3tCEVV4qNsmeHD._2HYCQ5ARLFhQm89MrtNoFY{animation-name:_3Pk8_kTJOH-dNlW5jb8__S;animation-play-state:running;pointer-events:none}._1htT410frFKyzX80Av14sQ,._3MqCteWlESS5iIF7dNgOIb{transform:scale(0);opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._2FUShwmg3tCEVV4qNsmeHD{animation-timing-function:cubic-bezier(.78,.14,.15,.86)}._2a5J8gXD3Tl7NADF0PAiIj,._2GPQ8BvBJ34Hcf9nvUTHe0,.l-D9Lhg38c0k8sF_zw8vP{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._2a5J8gXD3Tl7NADF0PAiIj.f75_2kHchoOzmKRjO3P3R,.l-D9Lhg38c0k8sF_zw8vP._1Yr9SRIzzy7b7K8V1Lm_fS{animation-name:o7Y1KBWEB2VRlja4z4vJx;animation-play-state:running}._2GPQ8BvBJ34Hcf9nvUTHe0._2O9-RcxpAfl1-xxwv8Fq-F{animation-name:_2gr8DF8GOmqrMKGyuZcU4y;animation-play-state:running;pointer-events:none}._2a5J8gXD3Tl7NADF0PAiIj,.l-D9Lhg38c0k8sF_zw8vP{transform:scale(0);opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}._2GPQ8BvBJ34Hcf9nvUTHe0{animation-timing-function:cubic-bezier(.78,.14,.15,.86)}._1CChw06B-tLjAxo2z1mqsR,._3t8hHiPisJ4cqNw0dDt-ez,.QkkpWu39UXBIYDU2o49j-{animation-duration:.2s;animation-fill-mode:both;animation-play-state:paused}._1CChw06B-tLjAxo2z1mqsR._24M4VLCG_rme-IgEvOUgra,._3t8hHiPisJ4cqNw0dDt-ez.aCjGBZ9k_i331T2Yjx7Eo{animation-name:T8xl7BDfXXtFEmJ7Tdi7U;animation-play-state:running}.QkkpWu39UXBIYDU2o49j-._29v2w6jU1uHkcu8VpU06PQ{animation-name:_1DkeRqEzcaJVYtBP2dTeX6;animation-play-state:running;pointer-events:none}._1CChw06B-tLjAxo2z1mqsR,._3t8hHiPisJ4cqNw0dDt-ez{transform:scale(0);opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1)}.QkkpWu39UXBIYDU2o49j-{animation-timing-function:cubic-bezier(.78,.14,.15,.86)}@keyframes MpRT7DyQF1m-VY7aPPCYB{0%{transform:scale(.2);opacity:0}to{transform:scale(1);opacity:1}}@keyframes _1vuPnqMO_T4JJwqOLazeij{0%{transform:scale(1)}to{transform:scale(.2);opacity:0}}@keyframes c5mf4FXCF0QTY_a_rOpd7{0%{transform:scale(.8);opacity:0}to{transform:scale(1);opacity:1}}@keyframes _1sFmlYzMjtL0HQENgQwwrd{0%{transform:scale(1)}to{transform:scale(.8);opacity:0}}@keyframes _3vkv06gZsPpCT7n09GPxHF{0%{transform:scale(.8);transform-origin:50% 0;opacity:0}to{transform:scale(1);transform-origin:50% 0}}@keyframes Sf_Lb8yVKL66PrLOYgJjw{0%{transform:scale(1);transform-origin:50% 0}to{transform:scale(.8);transform-origin:50% 0;opacity:0}}@keyframes o7Y1KBWEB2VRlja4z4vJx{0%{transform:scale(.8);transform-origin:0 50%;opacity:0}to{transform:scale(1);transform-origin:0 50%}}@keyframes _2gr8DF8GOmqrMKGyuZcU4y{0%{transform:scale(1);transform-origin:0 50%}to{transform:scale(.8);transform-origin:0 50%;opacity:0}}@keyframes T8xl7BDfXXtFEmJ7Tdi7U{0%{transform:scale(.8);transform-origin:100% 50%;opacity:0}to{transform:scale(1);transform-origin:100% 50%}}@keyframes _1DkeRqEzcaJVYtBP2dTeX6{0%{transform:scale(1);transform-origin:100% 50%}to{transform:scale(.8);transform-origin:100% 50%;opacity:0}}@keyframes Y1nWzmrvbXH3mMK4epmGj{0%{transform:scale(.8);transform-origin:50% 100%;opacity:0}to{transform:scale(1);transform-origin:50% 100%}}@keyframes _3Pk8_kTJOH-dNlW5jb8__S{0%{transform:scale(1);transform-origin:50% 100%}to{transform:scale(.8);transform-origin:50% 100%;opacity:0}}._3dkILaNGzAl9_U-6u_8bJk{overflow:hidden}._1CdpxfCyaJLDUhMBYBI3_t,._1e95NGO32NqQq_IG5I3iyP{transition:height .15s cubic-bezier(.645,.045,.355,1),opacity .15s cubic-bezier(.645,.045,.355,1)!important}._1CdpxfCyaJLDUhMBYBI3_t{overflow:hidden}._2Gc5kWaUkFPslOaXTBif30{position:fixed;z-index:10}._15qE0OF--suQ5_51-8sSS-{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;padding:8px 15px 8px 37px;word-wrap:break-word;border-radius:4px}._15qE0OF--suQ5_51-8sSS-._1pQIMzuKNzM-srum7hfnLH{padding:8px 15px}._15qE0OF--suQ5_51-8sSS-._2KrqkRNB0Wq8vHI9lZerqC{padding-right:30px}._2ZiWlHIHVEvOh2kMqh0MOD{position:absolute;top:11.5px;left:16px}._3XrL6b6jkLzxv7GOrpUxDK{display:none;font-size:14px;line-height:22px}.gXX0oQVSpeBAewhqrUDhj{background-color:#f6ffed;border:1px solid #b7eb8f}.gXX0oQVSpeBAewhqrUDhj ._2ZiWlHIHVEvOh2kMqh0MOD{color:#52c41a}._35JTMUls_Q-HIVNBvYuwHf{background-color:#e6f7ff;border:1px solid #91d5ff}._35JTMUls_Q-HIVNBvYuwHf ._2ZiWlHIHVEvOh2kMqh0MOD{color:#1890ff}.pNo_RWff8pOJcO2vH2W7x{background-color:#fffbe6;border:1px solid #ffe58f}.pNo_RWff8pOJcO2vH2W7x ._2ZiWlHIHVEvOh2kMqh0MOD{color:#faad14}.Mga1iPIKd7lgyWU1pfUQv{background-color:#fff1f0;border:1px solid #ffa39e}.Mga1iPIKd7lgyWU1pfUQv ._2ZiWlHIHVEvOh2kMqh0MOD{color:#f5222d}._3HJyMP81-tnmlSmRfnnulx{position:absolute;top:8px;right:16px;padding:0;overflow:hidden;font-size:12px;line-height:22px;background-color:transparent;border:none;outline:none;cursor:pointer}._3HJyMP81-tnmlSmRfnnulx ._3EEcVNYgJHJafe89WJy5Un{color:rgba(0,0,0,.45);transition:color .3s}._3HJyMP81-tnmlSmRfnnulx ._3EEcVNYgJHJafe89WJy5Un:hover{color:rgba(0,0,0,.75)}._3OEsGqj6n4Goge3kqIVBgx{color:rgba(0,0,0,.45);transition:color .3s}._3OEsGqj6n4Goge3kqIVBgx:hover{color:rgba(0,0,0,.75)}._29R0GIAD3zs4JFaQc8Dfc{position:relative;padding:15px 15px 15px 64px;color:rgba(0,0,0,.65);line-height:1.5;border-radius:4px}._29R0GIAD3zs4JFaQc8Dfc._1pQIMzuKNzM-srum7hfnLH{padding:15px}._29R0GIAD3zs4JFaQc8Dfc ._2ZiWlHIHVEvOh2kMqh0MOD{position:absolute;top:16px;left:24px;font-size:24px}._29R0GIAD3zs4JFaQc8Dfc ._3HJyMP81-tnmlSmRfnnulx{position:absolute;top:16px;right:16px;font-size:14px;cursor:pointer}._29R0GIAD3zs4JFaQc8Dfc .fggLJ9Apb9IbJYwDLM9m8{display:block;margin-bottom:4px;color:rgba(0,0,0,.85);font-size:16px}.fggLJ9Apb9IbJYwDLM9m8{color:rgba(0,0,0,.85)}._29R0GIAD3zs4JFaQc8Dfc ._3XrL6b6jkLzxv7GOrpUxDK{display:block}._15qE0OF--suQ5_51-8sSS-._1fhZsiy01D0j5ISIqdAiXe{height:0!important;margin:0;padding-top:0;padding-bottom:0;transform-origin:50% 0;transition:all .3s cubic-bezier(.78,.14,.15,.86)}._1iaeSvF8P5CUUaGlj_ByrS{animation:_1Ea-oHwxZLo3mXxH56aM2y .3s cubic-bezier(.78,.14,.15,.86);animation-fill-mode:both}._3MQVMSefFtHHE_QYCjGNhz{margin-bottom:0;border:0;border-radius:0}@keyframes _3aTOHX3Q6ehv2dio9EHqoX{0%{transform:scaleY(0);transform-origin:0 0;opacity:0}to{transform:scaleY(1);transform-origin:0 0;opacity:1}}@keyframes _1Ea-oHwxZLo3mXxH56aM2y{0%{transform:scaleY(1);transform-origin:0 0;opacity:1}to{transform:scaleY(0);transform-origin:0 0;opacity:0}}._2dIlk0xFhtVenLpTVx1LIk{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;padding-left:2px}._3T29BvbgPDiT9oUfLhMwnz{margin-left:-4px;padding-left:4px;overflow:auto;background-color:#fff}._1TWQErB-pr4ySnnTINPlsi{position:absolute;top:0;left:0;height:100%}._1TWQErB-pr4ySnnTINPlsi:before{position:relative;display:block;width:2px;height:100%;margin:0 auto;background-color:#e8e8e8;content:\" \"}._18iTx25M7zvZTLa3EUl4by{position:absolute;left:50%;display:none;width:8px;height:8px;background-color:#fff;border:2px solid #1890ff;border-radius:8px;transform:translateX(-50%);transition:top .3s ease-in-out}._18iTx25M7zvZTLa3EUl4by.xYUaTAqUuX9wO0g2kP0l0{display:inline-block}._2dIlk0xFhtVenLpTVx1LIk._2Z6fkhTw-MEaqRfY86Ki9u ._1TWQErB-pr4ySnnTINPlsi ._18iTx25M7zvZTLa3EUl4by{display:none}.NWc_VaZP7RbrNufUp4ddL{padding:7px 0 7px 16px;line-height:1.143}._1WW7FGgqg2ZKo4iOVZrdKd{position:relative;display:block;margin-bottom:6px;overflow:hidden;color:rgba(0,0,0,.65);white-space:nowrap;text-overflow:ellipsis;transition:all .3s}._1WW7FGgqg2ZKo4iOVZrdKd:only-child{margin-bottom:0}._2pS_QN32RwPGvI5otgHqBB>._1WW7FGgqg2ZKo4iOVZrdKd{color:#1890ff}.NWc_VaZP7RbrNufUp4ddL .NWc_VaZP7RbrNufUp4ddL{padding-top:5px;padding-bottom:5px}._29cP-s7uNehcuQVbYj4ozX{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\"}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._7Eyy1YVEF5PxhoJBXqU_f{border:0;box-shadow:none}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._2iYmNz-ByGCt4R8wmBpwCH{height:100%;margin-right:0;margin-left:0;line-height:32px}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._2B-xot8uBvYVWiXXFm21nC{margin-right:12px;margin-left:12px}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._97CQv9OIOWBrwr_cN2xfc{height:auto}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._3x43iIKADuc502oIMWL0XL{position:static;float:left}._29cP-s7uNehcuQVbYj4ozX._34q6vY4D86-q3YxTiKjerN ._7Eyy1YVEF5PxhoJBXqU_f:hover ._2iYmNz-ByGCt4R8wmBpwCH{margin-right:0!important}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._3pPc-OF79GHv_bF35yGDY1{height:32px;line-height:1.5;background:transparent;border-width:1px}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._3pPc-OF79GHv_bF35yGDY1:focus,._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._3pPc-OF79GHv_bF35yGDY1:hover{border-color:#40a9ff;border-right-width:1px!important}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._3pPc-OF79GHv_bF35yGDY1[disabled]{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1;background-color:transparent}._29cP-s7uNehcuQVbYj4ozX._1cNj85ZY8m7JAcdkxJ6Uc5 ._3pPc-OF79GHv_bF35yGDY1[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}._29cP-s7uNehcuQVbYj4ozX._6wpHSs3q6VdSXaBCsdq6x ._2iYmNz-ByGCt4R8wmBpwCH{line-height:40px}._29cP-s7uNehcuQVbYj4ozX._6wpHSs3q6VdSXaBCsdq6x ._3pPc-OF79GHv_bF35yGDY1{height:40px;padding-top:6px;padding-bottom:6px}._29cP-s7uNehcuQVbYj4ozX._3K8GmBeFUGeCVgLy-2eY0s ._2iYmNz-ByGCt4R8wmBpwCH{line-height:24px}._29cP-s7uNehcuQVbYj4ozX._3K8GmBeFUGeCVgLy-2eY0s ._3pPc-OF79GHv_bF35yGDY1{height:24px;padding-top:1px;padding-bottom:1px}._2Foe83O-mWINoezjOoes92>._29cP-s7uNehcuQVbYj4ozX ._3QNVZjB40c0mWzT3kRPS4o._2UvyS7V7PyOdhmJGWNnsQ9{display:inline;float:none}._1cNj85ZY8m7JAcdkxJ6Uc5{box-sizing:border-box;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;font-feature-settings:\"tnum\";position:relative;display:inline-block;outline:0}._1cNj85ZY8m7JAcdkxJ6Uc5,._1cNj85ZY8m7JAcdkxJ6Uc5 ol,._1cNj85ZY8m7JAcdkxJ6Uc5 ul{margin:0;padding:0;list-style:none}._1cNj85ZY8m7JAcdkxJ6Uc5>ul>li>a{padding:0;background-color:#fff}.eho88gQax86VLUCOnQl3y{display:inline-block;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;top:50%;right:11px;margin-top:-6px;color:rgba(0,0,0,.25);font-size:12px;line-height:1;transform-origin:50% 50%}.eho88gQax86VLUCOnQl3y>*{line-height:1}.eho88gQax86VLUCOnQl3y svg{display:inline-block}.eho88gQax86VLUCOnQl3y:before{display:none}.eho88gQax86VLUCOnQl3y ._3IgubU0xEedwAutt85YWBK{display:block}.eho88gQax86VLUCOnQl3y ._3IgubU0xEedwAutt85YWBK svg{transition:transform .3s}._7Eyy1YVEF5PxhoJBXqU_f{display:block;box-sizing:border-box;background-color:#fff;border:1px solid #d9d9d9;border-top-width:1.02px;border-radius:4px;outline:none;transition:all .3s cubic-bezier(.645,.045,.355,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._7Eyy1YVEF5PxhoJBXqU_f:hover{border-color:#40a9ff;border-right-width:1px!important}._3h6aN10we1czWU8G2MA6y_ ._7Eyy1YVEF5PxhoJBXqU_f,._7Eyy1YVEF5PxhoJBXqU_f:active,._7Eyy1YVEF5PxhoJBXqU_f:focus{border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._1pcT_amGFsaUucEvS4JQxC{position:absolute;top:50%;right:11px;z-index:1;display:inline-block;width:12px;height:12px;margin-top:-6px;color:rgba(0,0,0,.25);font-size:12px;font-style:normal;line-height:12px;text-align:center;text-transform:none;background:#fff;cursor:pointer;opacity:0;transition:color .3s ease,opacity .15s ease;text-rendering:auto}._1pcT_amGFsaUucEvS4JQxC:before{display:block}._1pcT_amGFsaUucEvS4JQxC:hover{color:rgba(0,0,0,.45)}._7Eyy1YVEF5PxhoJBXqU_f:hover ._1pcT_amGFsaUucEvS4JQxC{opacity:1}._1EQQ6QCFrDq86hXZOH3pNb{float:left;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._2slFdOVPJDGvh6vYFQ7LTb ._1EQQ6QCFrDq86hXZOH3pNb{padding-right:0}._2S_l4pRxOOamuZuhpIteKi{color:rgba(0,0,0,.25)}._2S_l4pRxOOamuZuhpIteKi ._7Eyy1YVEF5PxhoJBXqU_f{background:#f5f5f5;cursor:not-allowed}._2S_l4pRxOOamuZuhpIteKi ._7Eyy1YVEF5PxhoJBXqU_f:active,._2S_l4pRxOOamuZuhpIteKi ._7Eyy1YVEF5PxhoJBXqU_f:focus,._2S_l4pRxOOamuZuhpIteKi ._7Eyy1YVEF5PxhoJBXqU_f:hover{border-color:#d9d9d9;box-shadow:none}._2S_l4pRxOOamuZuhpIteKi ._1pcT_amGFsaUucEvS4JQxC{display:none;visibility:hidden;pointer-events:none}._2S_l4pRxOOamuZuhpIteKi ._2OYuEEegFtZL00LNyZS-lK ._1Hj9jU8JFS_1IqyFQN2dNM{padding-right:10px;color:rgba(0,0,0,.33);background:#f5f5f5}._2S_l4pRxOOamuZuhpIteKi ._2OYuEEegFtZL00LNyZS-lK ._12Kp3_TU-gpd2FSNEmrxc7{display:none}._97CQv9OIOWBrwr_cN2xfc{position:relative;height:32px;cursor:pointer}._97CQv9OIOWBrwr_cN2xfc ._2iYmNz-ByGCt4R8wmBpwCH{margin-right:24px}._2slFdOVPJDGvh6vYFQ7LTb ._2iYmNz-ByGCt4R8wmBpwCH{margin-right:11px}._2iYmNz-ByGCt4R8wmBpwCH{position:relative;display:block;margin-right:11px;margin-left:11px;line-height:30px}._2iYmNz-ByGCt4R8wmBpwCH:after{display:inline-block;width:0;visibility:hidden;content:\".\";pointer-events:none}._6wpHSs3q6VdSXaBCsdq6x{font-size:16px}._6wpHSs3q6VdSXaBCsdq6x ._97CQv9OIOWBrwr_cN2xfc{height:40px}._6wpHSs3q6VdSXaBCsdq6x ._2iYmNz-ByGCt4R8wmBpwCH{line-height:38px}._6wpHSs3q6VdSXaBCsdq6x ._2OYuEEegFtZL00LNyZS-lK{min-height:40px}._6wpHSs3q6VdSXaBCsdq6x ._2OYuEEegFtZL00LNyZS-lK ._2iYmNz-ByGCt4R8wmBpwCH li{height:32px;line-height:32px}._6wpHSs3q6VdSXaBCsdq6x ._2OYuEEegFtZL00LNyZS-lK ._1pcT_amGFsaUucEvS4JQxC,._6wpHSs3q6VdSXaBCsdq6x ._2OYuEEegFtZL00LNyZS-lK .eho88gQax86VLUCOnQl3y{top:20px}._3K8GmBeFUGeCVgLy-2eY0s ._97CQv9OIOWBrwr_cN2xfc{height:24px}._3K8GmBeFUGeCVgLy-2eY0s ._2iYmNz-ByGCt4R8wmBpwCH{margin-left:7px;line-height:22px}._3K8GmBeFUGeCVgLy-2eY0s ._2OYuEEegFtZL00LNyZS-lK{min-height:24px}._3K8GmBeFUGeCVgLy-2eY0s ._2OYuEEegFtZL00LNyZS-lK ._2iYmNz-ByGCt4R8wmBpwCH li{height:16px;line-height:14px}._3K8GmBeFUGeCVgLy-2eY0s ._2OYuEEegFtZL00LNyZS-lK ._1pcT_amGFsaUucEvS4JQxC,._3K8GmBeFUGeCVgLy-2eY0s ._2OYuEEegFtZL00LNyZS-lK .eho88gQax86VLUCOnQl3y{top:12px}._3K8GmBeFUGeCVgLy-2eY0s ._1pcT_amGFsaUucEvS4JQxC,._3K8GmBeFUGeCVgLy-2eY0s .eho88gQax86VLUCOnQl3y{right:8px}._2S_l4pRxOOamuZuhpIteKi ._12Kp3_TU-gpd2FSNEmrxc7{color:rgba(0,0,0,.25);cursor:default}._2S_l4pRxOOamuZuhpIteKi ._12Kp3_TU-gpd2FSNEmrxc7:hover{color:rgba(0,0,0,.25)}._25sQaSQpL04XTINFK9Yi6x{position:relative;display:inline-block}._2B-xot8uBvYVWiXXFm21nC,._3UWuHUw8iiPdNtXMW8IxR6{position:absolute;top:50%;right:9px;left:0;max-width:100%;height:20px;margin-top:-10px;overflow:hidden;color:#bfbfbf;line-height:20px;white-space:nowrap;text-align:left;text-overflow:ellipsis}._3UWuHUw8iiPdNtXMW8IxR6{left:12px}._2Tpvn1vT81zHxeRQiHeKyy{position:absolute;top:0;left:0;white-space:pre;opacity:0;pointer-events:none}._3x43iIKADuc502oIMWL0XL{position:absolute;width:100%;height:100%}._3x43iIKADuc502oIMWL0XL ._25sQaSQpL04XTINFK9Yi6x{width:100%;height:100%}._3x43iIKADuc502oIMWL0XL ._3QNVZjB40c0mWzT3kRPS4o{width:100%;height:100%;font-size:100%;line-height:1;background:transparent;border-width:0;border-radius:4px;outline:0}._3x43iIKADuc502oIMWL0XL>i{float:right}._2OYuEEegFtZL00LNyZS-lK{min-height:32px;padding-bottom:3px;cursor:text;zoom:1}._2OYuEEegFtZL00LNyZS-lK:after,._2OYuEEegFtZL00LNyZS-lK:before{display:table;content:\"\"}._2OYuEEegFtZL00LNyZS-lK:after{clear:both}._2OYuEEegFtZL00LNyZS-lK ._3x43iIKADuc502oIMWL0XL{position:static;float:left;width:auto;max-width:100%;padding:0}._2OYuEEegFtZL00LNyZS-lK ._3x43iIKADuc502oIMWL0XL ._3QNVZjB40c0mWzT3kRPS4o{width:.75em;max-width:100%;padding:1px}._2OYuEEegFtZL00LNyZS-lK ._2iYmNz-ByGCt4R8wmBpwCH{height:auto;margin-bottom:-3px;margin-left:5px}._2OYuEEegFtZL00LNyZS-lK ._2B-xot8uBvYVWiXXFm21nC{margin-left:6px}._2OYuEEegFtZL00LNyZS-lK ._2iYmNz-ByGCt4R8wmBpwCH>ul>li,._2OYuEEegFtZL00LNyZS-lK>ul>li{height:24px;margin-top:3px;line-height:22px}._2OYuEEegFtZL00LNyZS-lK ._1Hj9jU8JFS_1IqyFQN2dNM{position:relative;float:left;max-width:99%;margin-right:4px;padding:0 20px 0 10px;overflow:hidden;color:rgba(0,0,0,.65);background-color:#fafafa;border:1px solid #e8e8e8;border-radius:2px;cursor:default;transition:padding .3s cubic-bezier(.645,.045,.355,1)}._2OYuEEegFtZL00LNyZS-lK ._6yuRXaUAn2NCqhUWP3vba{padding:0 10px}._2OYuEEegFtZL00LNyZS-lK ._1YXNcRChjdkdJY_TdBexXn{display:inline-block;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;transition:margin .3s cubic-bezier(.645,.045,.355,1)}._2OYuEEegFtZL00LNyZS-lK ._12Kp3_TU-gpd2FSNEmrxc7{color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;right:4px;color:rgba(0,0,0,.45);font-weight:700;line-height:inherit;cursor:pointer;transition:all .3s;display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg)}._2OYuEEegFtZL00LNyZS-lK ._12Kp3_TU-gpd2FSNEmrxc7>*{line-height:1}._2OYuEEegFtZL00LNyZS-lK ._12Kp3_TU-gpd2FSNEmrxc7 svg{display:inline-block}._2OYuEEegFtZL00LNyZS-lK ._12Kp3_TU-gpd2FSNEmrxc7:before{display:none}._2OYuEEegFtZL00LNyZS-lK ._12Kp3_TU-gpd2FSNEmrxc7 ._2OYuEEegFtZL00LNyZS-lK ._2tNJx1oOOpHR1hzUUYmO2S{display:block}:root ._2OYuEEegFtZL00LNyZS-lK ._12Kp3_TU-gpd2FSNEmrxc7{font-size:12px}._2OYuEEegFtZL00LNyZS-lK ._12Kp3_TU-gpd2FSNEmrxc7:hover{color:rgba(0,0,0,.75)}._2OYuEEegFtZL00LNyZS-lK ._1pcT_amGFsaUucEvS4JQxC,._2OYuEEegFtZL00LNyZS-lK .eho88gQax86VLUCOnQl3y{top:16px}._3ck23EBaV-n0CzfUzZYU3X ._2OYuEEegFtZL00LNyZS-lK ._2iYmNz-ByGCt4R8wmBpwCH,._34q6vY4D86-q3YxTiKjerN ._2OYuEEegFtZL00LNyZS-lK ._2iYmNz-ByGCt4R8wmBpwCH{margin-right:20px}._1Wi0B5_u6mPgRTcwZk7Fyw ._3IgubU0xEedwAutt85YWBK svg{transform:rotate(180deg)}._1Wi0B5_u6mPgRTcwZk7Fyw ._7Eyy1YVEF5PxhoJBXqU_f{border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}.N0hmOJAs_SkCxu8EXCVXU .eho88gQax86VLUCOnQl3y{display:none}.N0hmOJAs_SkCxu8EXCVXU ._3x43iIKADuc502oIMWL0XL{float:none;width:100%;height:100%}.N0hmOJAs_SkCxu8EXCVXU ._25sQaSQpL04XTINFK9Yi6x{width:100%;height:100%}.N0hmOJAs_SkCxu8EXCVXU ._3QNVZjB40c0mWzT3kRPS4o{position:relative;z-index:1;width:100%;height:100%;box-shadow:none;transition:all .3s cubic-bezier(.645,.045,.355,1),height 0s}.N0hmOJAs_SkCxu8EXCVXU._3ck23EBaV-n0CzfUzZYU3X ._7Eyy1YVEF5PxhoJBXqU_f:hover ._2iYmNz-ByGCt4R8wmBpwCH,.N0hmOJAs_SkCxu8EXCVXU._34q6vY4D86-q3YxTiKjerN ._7Eyy1YVEF5PxhoJBXqU_f:hover ._2iYmNz-ByGCt4R8wmBpwCH{margin-right:20px}.WN7Z6DPhqHkerTCyV7wdv{margin:0;padding:0;color:rgba(0,0,0,.65);font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;top:-9999px;left:-9999px;z-index:1050;box-sizing:border-box;font-size:14px;font-variant:normal;background-color:#fff;border-radius:4px;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.15)}.WN7Z6DPhqHkerTCyV7wdv._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._3BTa0fib-sM8ZIP8DD425i,.WN7Z6DPhqHkerTCyV7wdv._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._3BTa0fib-sM8ZIP8DD425i{animation-name:_2lqTGgogIItpImYAn3wMQO}.WN7Z6DPhqHkerTCyV7wdv._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._1gVCDWKYZyJR3NBRB45An-,.WN7Z6DPhqHkerTCyV7wdv._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._1gVCDWKYZyJR3NBRB45An-{animation-name:_3JK1uFdxrQM9RK51sOtrar}.WN7Z6DPhqHkerTCyV7wdv._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._3BTa0fib-sM8ZIP8DD425i{animation-name:_2IDJAVNNcAmXsLtWbzNJtk}.WN7Z6DPhqHkerTCyV7wdv._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._1gVCDWKYZyJR3NBRB45An-{animation-name:_1F89QugyM0FQpooygKHf2k}._32x2M2CEyTUjfZn34dr_4f{display:none}._1Vvmk2tQ1x9CsYl55hxov9{max-height:250px;margin-bottom:0;padding:4px 0;padding-left:0;overflow:auto;list-style:none;outline:none}._5BszMZWDlP5_DZADNvlQl{margin:0;padding:0}._5BszMZWDlP5_DZADNvlQl>._88uX0Vc4eGp6W7q-GPULH{padding-left:20px}._3DsmG9_5oztY0l3auc1kX0{height:32px;padding:0 12px;color:rgba(0,0,0,.45);font-size:12px;line-height:32px}._3mepb_q6FnKecz0duYBeue:not(:last-child) ._5BszMZWDlP5_DZADNvlQl ._88uX0Vc4eGp6W7q-GPULH:last-child,._5BszMZWDlP5_DZADNvlQl ._88uX0Vc4eGp6W7q-GPULH:first-child:not(:last-child){border-radius:0}._88uX0Vc4eGp6W7q-GPULH{position:relative;display:block;padding:5px 12px;overflow:hidden;color:rgba(0,0,0,.65);font-weight:400;font-size:14px;line-height:22px;white-space:nowrap;text-overflow:ellipsis;cursor:pointer;transition:background .3s ease}._88uX0Vc4eGp6W7q-GPULH:hover:not(.Hlpgl-I9defIxbK-7gnER){background-color:#e6f7ff}._10Ps61pXYbLw4Ao6o26TGi{color:rgba(0,0,0,.65);font-weight:600;background-color:#fafafa}.Hlpgl-I9defIxbK-7gnER,.Hlpgl-I9defIxbK-7gnER:hover{color:rgba(0,0,0,.25);cursor:not-allowed}._2VWFr_6p3W4kFOA3XH16cw:not(.Hlpgl-I9defIxbK-7gnER){background-color:#e6f7ff}._9hAFc9enJBZkBoeRYk5qi{height:1px;margin:1px 0;overflow:hidden;line-height:0;background-color:#e8e8e8}.WN7Z6DPhqHkerTCyV7wdv._3Cd1B90tMa9ftnY7bnenv6 ._88uX0Vc4eGp6W7q-GPULH{padding-right:32px}.WN7Z6DPhqHkerTCyV7wdv._3Cd1B90tMa9ftnY7bnenv6 ._88uX0Vc4eGp6W7q-GPULH ._3qB4jXSep05-N8ldUnGH0u{position:absolute;top:50%;right:12px;color:transparent;font-weight:700;font-size:12px;text-shadow:0 .1px 0,.1px 0 0,0 -.1px 0,-.1px 0;transform:translateY(-50%);transition:all .2s}.WN7Z6DPhqHkerTCyV7wdv._3Cd1B90tMa9ftnY7bnenv6 ._88uX0Vc4eGp6W7q-GPULH:hover ._3qB4jXSep05-N8ldUnGH0u{color:rgba(0,0,0,.87)}.WN7Z6DPhqHkerTCyV7wdv._3Cd1B90tMa9ftnY7bnenv6 .Hlpgl-I9defIxbK-7gnER ._3qB4jXSep05-N8ldUnGH0u{display:none}.WN7Z6DPhqHkerTCyV7wdv._3Cd1B90tMa9ftnY7bnenv6 ._10Ps61pXYbLw4Ao6o26TGi ._3qB4jXSep05-N8ldUnGH0u,.WN7Z6DPhqHkerTCyV7wdv._3Cd1B90tMa9ftnY7bnenv6 ._10Ps61pXYbLw4Ao6o26TGi:hover ._3qB4jXSep05-N8ldUnGH0u{display:inline-block;color:#1890ff}._3iQQKMXsE-0ctOE12ztO8N._3Cd1B90tMa9ftnY7bnenv6 ._88uX0Vc4eGp6W7q-GPULH{padding-right:12px}._1RkPXKDp9_dHQGu0-nUoY4 .WN7Z6DPhqHkerTCyV7wdv,._2LSJV3jd5aP0-mJ3UccftA .WN7Z6DPhqHkerTCyV7wdv{display:block}.W1idWwUkjUeMPghSv6rw2{margin:0 8px;font-size:14px;line-height:22px;text-align:center}._2MpY-iSOHP7OkCk2l5lICJ{height:100px;margin-bottom:8px}._2MpY-iSOHP7OkCk2l5lICJ img{height:100%}._2MpY-iSOHP7OkCk2l5lICJ svg{height:100%;margin:auto}.tEibQoOlonbiv4fMqlsrp{margin:0}._363dtGF6a3cwNZpPJctKgS{margin-top:16px}._3fMhjPtRpyAmSH5MLC5ZKt{margin:32px 0;color:rgba(0,0,0,.25)}._3fMhjPtRpyAmSH5MLC5ZKt ._2MpY-iSOHP7OkCk2l5lICJ{height:40px}._1lq5n41-X8PpYQpiay2_3c{margin:8px 0;color:rgba(0,0,0,.25)}._1lq5n41-X8PpYQpiay2_3c ._2MpY-iSOHP7OkCk2l5lICJ{height:35px}._3pPc-OF79GHv_bF35yGDY1{box-sizing:border-box;margin:0;padding:0;font-variant:tabular-nums;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;width:100%;height:32px;padding:4px 11px;color:rgba(0,0,0,.65);font-size:14px;line-height:1.5;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s}._3pPc-OF79GHv_bF35yGDY1::-moz-placeholder{color:#bfbfbf;opacity:1}._3pPc-OF79GHv_bF35yGDY1:-ms-input-placeholder{color:#bfbfbf}._3pPc-OF79GHv_bF35yGDY1::-webkit-input-placeholder{color:#bfbfbf}._3pPc-OF79GHv_bF35yGDY1:-moz-placeholder-shown{text-overflow:ellipsis}._3pPc-OF79GHv_bF35yGDY1:-ms-input-placeholder{text-overflow:ellipsis}._3pPc-OF79GHv_bF35yGDY1:placeholder-shown{text-overflow:ellipsis}._3pPc-OF79GHv_bF35yGDY1:focus,._3pPc-OF79GHv_bF35yGDY1:hover{border-color:#40a9ff;border-right-width:1px!important}._3pPc-OF79GHv_bF35yGDY1:focus{outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._2A-ucu16pid4Gh76mY_Ebo{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._2A-ucu16pid4Gh76mY_Ebo:hover{border-color:#d9d9d9;border-right-width:1px!important}._3pPc-OF79GHv_bF35yGDY1[disabled]{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._3pPc-OF79GHv_bF35yGDY1[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea._3pPc-OF79GHv_bF35yGDY1{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}._2hZP2GaN_LKQwRGcY8oYw7{height:40px;padding:6px 11px;font-size:16px}._3XkyZAEWYxNQKnj5oRB-hf{height:24px;padding:1px 7px}._2Foe83O-mWINoezjOoes92{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:table;width:100%;border-collapse:separate;border-spacing:0}._2Foe83O-mWINoezjOoes92[class*=col-]{float:none;padding-right:0;padding-left:0}._2Foe83O-mWINoezjOoes92>[class*=col-]{padding-right:8px}._2Foe83O-mWINoezjOoes92>[class*=col-]:last-child{padding-right:0}._1p84ImfXKXI0mpXrH3erRG,._2Foe83O-mWINoezjOoes92>._3pPc-OF79GHv_bF35yGDY1,._3dGKlYP1lLzLrUd1RT8uLF{display:table-cell}._1p84ImfXKXI0mpXrH3erRG:not(:first-child):not(:last-child),._2Foe83O-mWINoezjOoes92>._3pPc-OF79GHv_bF35yGDY1:not(:first-child):not(:last-child),._3dGKlYP1lLzLrUd1RT8uLF:not(:first-child):not(:last-child){border-radius:0}._1p84ImfXKXI0mpXrH3erRG,._3dGKlYP1lLzLrUd1RT8uLF{width:1px;white-space:nowrap;vertical-align:middle}._3dGKlYP1lLzLrUd1RT8uLF>*{display:block!important}._2Foe83O-mWINoezjOoes92 ._3pPc-OF79GHv_bF35yGDY1{float:left;width:100%;margin-bottom:0;text-align:inherit}._2Foe83O-mWINoezjOoes92 ._3pPc-OF79GHv_bF35yGDY1:focus,._2Foe83O-mWINoezjOoes92 ._3pPc-OF79GHv_bF35yGDY1:hover{z-index:1;border-right-width:1px}._1p84ImfXKXI0mpXrH3erRG{position:relative;padding:0 11px;color:rgba(0,0,0,.65);font-weight:400;font-size:14px;text-align:center;background-color:#fafafa;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s}._1p84ImfXKXI0mpXrH3erRG ._1cNj85ZY8m7JAcdkxJ6Uc5{margin:-5px -11px}._1p84ImfXKXI0mpXrH3erRG ._1cNj85ZY8m7JAcdkxJ6Uc5 ._7Eyy1YVEF5PxhoJBXqU_f{margin:-1px;background-color:inherit;border:1px solid transparent;box-shadow:none}._1p84ImfXKXI0mpXrH3erRG ._1Wi0B5_u6mPgRTcwZk7Fyw ._7Eyy1YVEF5PxhoJBXqU_f,._1p84ImfXKXI0mpXrH3erRG ._3h6aN10we1czWU8G2MA6y_ ._7Eyy1YVEF5PxhoJBXqU_f{color:#1890ff}._1p84ImfXKXI0mpXrH3erRG>i:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;content:\"\"}._1p84ImfXKXI0mpXrH3erRG:first-child,._1p84ImfXKXI0mpXrH3erRG:first-child ._1cNj85ZY8m7JAcdkxJ6Uc5 ._7Eyy1YVEF5PxhoJBXqU_f,._2Foe83O-mWINoezjOoes92>._3pPc-OF79GHv_bF35yGDY1:first-child,._2Foe83O-mWINoezjOoes92>._3pPc-OF79GHv_bF35yGDY1:first-child ._1cNj85ZY8m7JAcdkxJ6Uc5 ._7Eyy1YVEF5PxhoJBXqU_f{border-top-right-radius:0;border-bottom-right-radius:0}._2Foe83O-mWINoezjOoes92>._2UvyS7V7PyOdhmJGWNnsQ9:not(:first-child) ._3pPc-OF79GHv_bF35yGDY1{border-top-left-radius:0;border-bottom-left-radius:0}._2Foe83O-mWINoezjOoes92>._2UvyS7V7PyOdhmJGWNnsQ9:not(:last-child) ._3pPc-OF79GHv_bF35yGDY1{border-top-right-radius:0;border-bottom-right-radius:0}._1p84ImfXKXI0mpXrH3erRG:first-child{border-right:0}._1p84ImfXKXI0mpXrH3erRG:last-child{border-left:0}._1p84ImfXKXI0mpXrH3erRG:last-child,._1p84ImfXKXI0mpXrH3erRG:last-child ._1cNj85ZY8m7JAcdkxJ6Uc5 ._7Eyy1YVEF5PxhoJBXqU_f,._2Foe83O-mWINoezjOoes92>._3pPc-OF79GHv_bF35yGDY1:last-child,._2Foe83O-mWINoezjOoes92>._3pPc-OF79GHv_bF35yGDY1:last-child ._1cNj85ZY8m7JAcdkxJ6Uc5 ._7Eyy1YVEF5PxhoJBXqU_f{border-top-left-radius:0;border-bottom-left-radius:0}._3StNdoTLSo85-EBhVduGKc ._3pPc-OF79GHv_bF35yGDY1,._3StNdoTLSo85-EBhVduGKc>._1p84ImfXKXI0mpXrH3erRG{height:40px;padding:6px 11px;font-size:16px}._28ogRmKLiWAFuajs6wQHQ4 ._3pPc-OF79GHv_bF35yGDY1,._28ogRmKLiWAFuajs6wQHQ4>._1p84ImfXKXI0mpXrH3erRG{height:24px;padding:1px 7px}._3StNdoTLSo85-EBhVduGKc ._97CQv9OIOWBrwr_cN2xfc{height:40px}._28ogRmKLiWAFuajs6wQHQ4 ._97CQv9OIOWBrwr_cN2xfc{height:24px}._2Foe83O-mWINoezjOoes92 ._2UvyS7V7PyOdhmJGWNnsQ9{display:table-cell;float:left;width:100%}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs{display:block;zoom:1}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs:after,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs:before{display:table;content:\"\"}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs:after{clear:both}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._3pPc-OF79GHv_bF35yGDY1:not(:first-child):not(:last-child),._2Foe83O-mWINoezjOoes92._4Z3_vLBkdx6ZBU3_P0are:not(:first-child):not(:last-child),._2Foe83O-mWINoezjOoes92.GUlqbOE_Lde3kR_V24cFN:not(:first-child):not(:last-child){border-right-width:1px}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._3pPc-OF79GHv_bF35yGDY1:not(:first-child):not(:last-child):focus,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._3pPc-OF79GHv_bF35yGDY1:not(:first-child):not(:last-child):hover,._2Foe83O-mWINoezjOoes92._4Z3_vLBkdx6ZBU3_P0are:not(:first-child):not(:last-child):focus,._2Foe83O-mWINoezjOoes92._4Z3_vLBkdx6ZBU3_P0are:not(:first-child):not(:last-child):hover,._2Foe83O-mWINoezjOoes92.GUlqbOE_Lde3kR_V24cFN:not(:first-child):not(:last-child):focus,._2Foe83O-mWINoezjOoes92.GUlqbOE_Lde3kR_V24cFN:not(:first-child):not(:last-child):hover{z-index:1}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>*{display:inline-block;float:none;vertical-align:top;border-radius:0}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>:not(:last-child){margin-right:-1px;border-right-width:1px}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs ._3pPc-OF79GHv_bF35yGDY1{float:none}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1cNj85ZY8m7JAcdkxJ6Uc5>._7Eyy1YVEF5PxhoJBXqU_f,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1j4rLEirQnvEigyl0F5j16 ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._2WUwSufUm-mWdZbWfdaTx0 ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._29cP-s7uNehcuQVbYj4ozX ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._pEx_feJBV_Kj7nPjRgq4 ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.ufc92ympr1e8GM1qw2Hz0 .rbO6RzhtTm7Ha5feDxDOm{border-right-width:1px;border-radius:0}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1cNj85ZY8m7JAcdkxJ6Uc5>._7Eyy1YVEF5PxhoJBXqU_f:focus,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1cNj85ZY8m7JAcdkxJ6Uc5>._7Eyy1YVEF5PxhoJBXqU_f:hover,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1j4rLEirQnvEigyl0F5j16 ._3pPc-OF79GHv_bF35yGDY1:focus,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1j4rLEirQnvEigyl0F5j16 ._3pPc-OF79GHv_bF35yGDY1:hover,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._2WUwSufUm-mWdZbWfdaTx0 ._3pPc-OF79GHv_bF35yGDY1:focus,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._2WUwSufUm-mWdZbWfdaTx0 ._3pPc-OF79GHv_bF35yGDY1:hover,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._29cP-s7uNehcuQVbYj4ozX ._3pPc-OF79GHv_bF35yGDY1:focus,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._29cP-s7uNehcuQVbYj4ozX ._3pPc-OF79GHv_bF35yGDY1:hover,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._pEx_feJBV_Kj7nPjRgq4 ._3pPc-OF79GHv_bF35yGDY1:focus,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._pEx_feJBV_Kj7nPjRgq4 ._3pPc-OF79GHv_bF35yGDY1:hover,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:focus,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:hover,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.ufc92ympr1e8GM1qw2Hz0 .rbO6RzhtTm7Ha5feDxDOm:focus,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.ufc92ympr1e8GM1qw2Hz0 .rbO6RzhtTm7Ha5feDxDOm:hover{z-index:1}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1cNj85ZY8m7JAcdkxJ6Uc5:first-child>._7Eyy1YVEF5PxhoJBXqU_f,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1j4rLEirQnvEigyl0F5j16:first-child ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._29cP-s7uNehcuQVbYj4ozX:first-child ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._pEx_feJBV_Kj7nPjRgq4:first-child ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.evz3k4BAlGZ29PrmHf8ZA:first-child .FgcTqoSfeRhgxyye0BL99,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.ufc92ympr1e8GM1qw2Hz0:first-child .rbO6RzhtTm7Ha5feDxDOm,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1cNj85ZY8m7JAcdkxJ6Uc5:last-child>._7Eyy1YVEF5PxhoJBXqU_f,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._1j4rLEirQnvEigyl0F5j16:last-child ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._2fDAzmrjntvwBWsvrRe6Jg:last-child ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._29cP-s7uNehcuQVbYj4ozX:last-child ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._pEx_feJBV_Kj7nPjRgq4:last-child ._3pPc-OF79GHv_bF35yGDY1,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.evz3k4BAlGZ29PrmHf8ZA:last-child .FgcTqoSfeRhgxyye0BL99,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>.ufc92ympr1e8GM1qw2Hz0:last-child .rbO6RzhtTm7Ha5feDxDOm,._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>:last-child{border-right-width:1px;border-top-right-radius:4px;border-bottom-right-radius:4px}._2Foe83O-mWINoezjOoes92._2UQSIjjV4RuRqwi4CqVlOs>._29cP-s7uNehcuQVbYj4ozX ._3pPc-OF79GHv_bF35yGDY1{vertical-align:top}._2WUwSufUm-mWdZbWfdaTx0{display:inline-block;width:100%;text-align:start;vertical-align:top}._2UvyS7V7PyOdhmJGWNnsQ9{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;width:100%;text-align:start}._2UvyS7V7PyOdhmJGWNnsQ9:hover ._3pPc-OF79GHv_bF35yGDY1:not(._2A-ucu16pid4Gh76mY_Ebo){border-color:#40a9ff;border-right-width:1px!important}._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1{position:relative;text-align:inherit}._2UvyS7V7PyOdhmJGWNnsQ9 ._2eJRbHPkX4xdgtxeMSNzx,._2UvyS7V7PyOdhmJGWNnsQ9 ._3JEoNL3m7Ci5dETGutSjIs{position:absolute;top:50%;z-index:2;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;color:rgba(0,0,0,.65);line-height:0;transform:translateY(-50%)}._2UvyS7V7PyOdhmJGWNnsQ9 ._2eJRbHPkX4xdgtxeMSNzx :not(._1oZ8xlpZEg3PzGp2jMNFuZ),._2UvyS7V7PyOdhmJGWNnsQ9 ._3JEoNL3m7Ci5dETGutSjIs :not(._1oZ8xlpZEg3PzGp2jMNFuZ){line-height:1.5}._2UvyS7V7PyOdhmJGWNnsQ9 ._2A-ucu16pid4Gh76mY_Ebo~._3JEoNL3m7Ci5dETGutSjIs ._1oZ8xlpZEg3PzGp2jMNFuZ{color:rgba(0,0,0,.25);cursor:not-allowed}._2UvyS7V7PyOdhmJGWNnsQ9 ._2eJRbHPkX4xdgtxeMSNzx{left:12px}._2UvyS7V7PyOdhmJGWNnsQ9 ._3JEoNL3m7Ci5dETGutSjIs{right:12px}._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1:not(:first-child){padding-left:30px}._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1:not(:last-child){padding-right:30px}._2UvyS7V7PyOdhmJGWNnsQ9._3fBw9iCv6caRMXShpPso-s ._3pPc-OF79GHv_bF35yGDY1:not(:last-child){padding-right:49px}._2UvyS7V7PyOdhmJGWNnsQ9._3bXbdFuisuLhFa84ghc58I ._3pPc-OF79GHv_bF35yGDY1{padding-right:22px}._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1{min-height:100%}._1htlbyDWgZlaYQpzMqqx-N{color:rgba(0,0,0,.45);cursor:pointer;transition:all .3s}._1htlbyDWgZlaYQpzMqqx-N:hover{color:#333}._1-iONiKMm8Xca6qFk7GRnk{color:rgba(0,0,0,.25);font-size:12px;cursor:pointer;transition:color .3s;vertical-align:0}._1-iONiKMm8Xca6qFk7GRnk:hover{color:rgba(0,0,0,.45)}._1-iONiKMm8Xca6qFk7GRnk:active{color:rgba(0,0,0,.65)}._1-iONiKMm8Xca6qFk7GRnk+i{margin-left:6px}._2x5_NpV1CSAoM1OILgQQxR{color:rgba(0,0,0,.25);font-size:12px;cursor:pointer;transition:color .3s;position:absolute;top:0;right:0;margin:8px 8px 0 0}._2x5_NpV1CSAoM1OILgQQxR:hover{color:rgba(0,0,0,.45)}._2x5_NpV1CSAoM1OILgQQxR:active{color:rgba(0,0,0,.65)}._2x5_NpV1CSAoM1OILgQQxR+i{margin-left:6px}.cruQjhV40twVe_2LlwwvM{color:rgba(0,0,0,.45);cursor:pointer;transition:all .3s}.cruQjhV40twVe_2LlwwvM:hover{color:rgba(0,0,0,.8)}.AswcrW7TSGC8OfYJuVWHr input{border-right:0}.AswcrW7TSGC8OfYJuVWHr+._1p84ImfXKXI0mpXrH3erRG,.AswcrW7TSGC8OfYJuVWHr input+._1p84ImfXKXI0mpXrH3erRG{padding:0;border:0}.AswcrW7TSGC8OfYJuVWHr+._1p84ImfXKXI0mpXrH3erRG ._3wckPmodLDaT7iLwLF79eH,.AswcrW7TSGC8OfYJuVWHr input+._1p84ImfXKXI0mpXrH3erRG ._3wckPmodLDaT7iLwLF79eH{border-top-left-radius:0;border-bottom-left-radius:0}._34ecc6_SGKef4Y6JfdE_DJ{line-height:1.499;position:relative;display:inline-block;font-weight:400;white-space:nowrap;text-align:center;background-image:none;border:1px solid transparent;box-shadow:0 2px 0 rgba(0,0,0,.015);cursor:pointer;transition:all .3s cubic-bezier(.645,.045,.355,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:manipulation;touch-action:manipulation;height:32px;padding:0 15px;font-size:14px;border-radius:4px;color:rgba(0,0,0,.65);background-color:#fff;border-color:#d9d9d9}._34ecc6_SGKef4Y6JfdE_DJ>._1oZ8xlpZEg3PzGp2jMNFuZ{line-height:1}._34ecc6_SGKef4Y6JfdE_DJ,._34ecc6_SGKef4Y6JfdE_DJ:active,._34ecc6_SGKef4Y6JfdE_DJ:focus{outline:0}._34ecc6_SGKef4Y6JfdE_DJ:not([disabled]):hover{text-decoration:none}._34ecc6_SGKef4Y6JfdE_DJ:not([disabled]):active{outline:0;box-shadow:none}._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB,._34ecc6_SGKef4Y6JfdE_DJ[disabled]{cursor:not-allowed}._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB>*,._34ecc6_SGKef4Y6JfdE_DJ[disabled]>*{pointer-events:none}._24N8kMOEo48v88KpPB3fPF{height:40px;padding:0 15px;font-size:16px;border-radius:4px}.m7OIj5e4R4jh4ez3P5chZ{height:24px;padding:0 7px;font-size:14px;border-radius:4px}._34ecc6_SGKef4Y6JfdE_DJ>a:only-child{color:currentColor}._34ecc6_SGKef4Y6JfdE_DJ>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._34ecc6_SGKef4Y6JfdE_DJ:focus,._34ecc6_SGKef4Y6JfdE_DJ:hover{color:#40a9ff;background-color:#fff;border-color:#40a9ff}._34ecc6_SGKef4Y6JfdE_DJ:focus>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ:hover>a:only-child{color:currentColor}._34ecc6_SGKef4Y6JfdE_DJ:focus>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._34ecc6_SGKef4Y6JfdE_DJ.em_Pqz__Gx36paHRPTcGY,._34ecc6_SGKef4Y6JfdE_DJ:active{color:#096dd9;background-color:#fff;border-color:#096dd9}._34ecc6_SGKef4Y6JfdE_DJ.em_Pqz__Gx36paHRPTcGY>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ:active>a:only-child{color:currentColor}._34ecc6_SGKef4Y6JfdE_DJ.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2HRWKsYV3NKCsengWsaT1n,._2HRWKsYV3NKCsengWsaT1n.em_Pqz__Gx36paHRPTcGY,._2HRWKsYV3NKCsengWsaT1n:active,._2HRWKsYV3NKCsengWsaT1n:focus,._2HRWKsYV3NKCsengWsaT1n:hover,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:active,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:focus,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:hover,._34ecc6_SGKef4Y6JfdE_DJ[disabled],._34ecc6_SGKef4Y6JfdE_DJ[disabled].em_Pqz__Gx36paHRPTcGY,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:active,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:focus,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}._2HRWKsYV3NKCsengWsaT1n.em_Pqz__Gx36paHRPTcGY>a:only-child,._2HRWKsYV3NKCsengWsaT1n:active>a:only-child,._2HRWKsYV3NKCsengWsaT1n:focus>a:only-child,._2HRWKsYV3NKCsengWsaT1n:hover>a:only-child,._2HRWKsYV3NKCsengWsaT1n>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:active>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:focus>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:hover>a:only-child,._34ecc6_SGKef4Y6JfdE_DJ[disabled]>a:only-child{color:currentColor}._2HRWKsYV3NKCsengWsaT1n.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2HRWKsYV3NKCsengWsaT1n:active>a:only-child:after,._2HRWKsYV3NKCsengWsaT1n:focus>a:only-child:after,._2HRWKsYV3NKCsengWsaT1n:hover>a:only-child:after,._2HRWKsYV3NKCsengWsaT1n>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:active>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:focus>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ[disabled]:hover>a:only-child:after,._34ecc6_SGKef4Y6JfdE_DJ[disabled]>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._34ecc6_SGKef4Y6JfdE_DJ.em_Pqz__Gx36paHRPTcGY,._34ecc6_SGKef4Y6JfdE_DJ:active,._34ecc6_SGKef4Y6JfdE_DJ:focus,._34ecc6_SGKef4Y6JfdE_DJ:hover{text-decoration:none;background:#fff}._34ecc6_SGKef4Y6JfdE_DJ>i,._34ecc6_SGKef4Y6JfdE_DJ>span{display:inline-block;transition:margin-left .3s cubic-bezier(.645,.045,.355,1);pointer-events:none}._1hBh0D8Z27qUhgXC7swls9{color:#fff;background-color:#1890ff;border-color:#1890ff;text-shadow:0 -1px 0 rgba(0,0,0,.12);box-shadow:0 2px 0 rgba(0,0,0,.045)}._1hBh0D8Z27qUhgXC7swls9>a:only-child{color:currentColor}._1hBh0D8Z27qUhgXC7swls9>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._1hBh0D8Z27qUhgXC7swls9:focus,._1hBh0D8Z27qUhgXC7swls9:hover{color:#fff;background-color:#40a9ff;border-color:#40a9ff}._1hBh0D8Z27qUhgXC7swls9:focus>a:only-child,._1hBh0D8Z27qUhgXC7swls9:hover>a:only-child{color:currentColor}._1hBh0D8Z27qUhgXC7swls9:focus>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._1hBh0D8Z27qUhgXC7swls9.em_Pqz__Gx36paHRPTcGY,._1hBh0D8Z27qUhgXC7swls9:active{color:#fff;background-color:#096dd9;border-color:#096dd9}._1hBh0D8Z27qUhgXC7swls9.em_Pqz__Gx36paHRPTcGY>a:only-child,._1hBh0D8Z27qUhgXC7swls9:active>a:only-child{color:currentColor}._1hBh0D8Z27qUhgXC7swls9.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:active,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:focus,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:hover,._1hBh0D8Z27qUhgXC7swls9[disabled],._1hBh0D8Z27qUhgXC7swls9[disabled].em_Pqz__Gx36paHRPTcGY,._1hBh0D8Z27qUhgXC7swls9[disabled]:active,._1hBh0D8Z27qUhgXC7swls9[disabled]:focus,._1hBh0D8Z27qUhgXC7swls9[disabled]:hover,._2n9ezvu5zWvbTSje8a1htn,._2n9ezvu5zWvbTSje8a1htn.em_Pqz__Gx36paHRPTcGY,._2n9ezvu5zWvbTSje8a1htn:active,._2n9ezvu5zWvbTSje8a1htn:focus,._2n9ezvu5zWvbTSje8a1htn:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB>a:only-child,._1hBh0D8Z27qUhgXC7swls9[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,._1hBh0D8Z27qUhgXC7swls9[disabled]:active>a:only-child,._1hBh0D8Z27qUhgXC7swls9[disabled]:focus>a:only-child,._1hBh0D8Z27qUhgXC7swls9[disabled]:hover>a:only-child,._1hBh0D8Z27qUhgXC7swls9[disabled]>a:only-child,._2n9ezvu5zWvbTSje8a1htn.em_Pqz__Gx36paHRPTcGY>a:only-child,._2n9ezvu5zWvbTSje8a1htn:active>a:only-child,._2n9ezvu5zWvbTSje8a1htn:focus>a:only-child,._2n9ezvu5zWvbTSje8a1htn:hover>a:only-child,._2n9ezvu5zWvbTSje8a1htn>a:only-child{color:currentColor}._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9[disabled]:active>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9[disabled]:focus>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9[disabled]:hover>a:only-child:after,._1hBh0D8Z27qUhgXC7swls9[disabled]>a:only-child:after,._2n9ezvu5zWvbTSje8a1htn.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2n9ezvu5zWvbTSje8a1htn:active>a:only-child:after,._2n9ezvu5zWvbTSje8a1htn:focus>a:only-child:after,._2n9ezvu5zWvbTSje8a1htn:hover>a:only-child:after,._2n9ezvu5zWvbTSje8a1htn>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9:not(:first-child):not(:last-child){border-right-color:#40a9ff;border-left-color:#40a9ff}._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9:not(:first-child):not(:last-child):disabled{border-color:#d9d9d9}._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9:first-child:not(:last-child){border-right-color:#40a9ff}._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9:first-child:not(:last-child)[disabled]{border-right-color:#d9d9d9}._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9+._1hBh0D8Z27qUhgXC7swls9,._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9:last-child:not(:first-child){border-left-color:#40a9ff}._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9+._1hBh0D8Z27qUhgXC7swls9[disabled],._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9:last-child:not(:first-child)[disabled]{border-left-color:#d9d9d9}._28cW-V5GKksY7EnHAfGGy7{color:rgba(0,0,0,.65);background-color:transparent;border-color:#d9d9d9}._28cW-V5GKksY7EnHAfGGy7>a:only-child{color:currentColor}._28cW-V5GKksY7EnHAfGGy7>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._28cW-V5GKksY7EnHAfGGy7:focus,._28cW-V5GKksY7EnHAfGGy7:hover{color:#40a9ff;background-color:transparent;border-color:#40a9ff}._28cW-V5GKksY7EnHAfGGy7:focus>a:only-child,._28cW-V5GKksY7EnHAfGGy7:hover>a:only-child{color:currentColor}._28cW-V5GKksY7EnHAfGGy7:focus>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._28cW-V5GKksY7EnHAfGGy7.em_Pqz__Gx36paHRPTcGY,._28cW-V5GKksY7EnHAfGGy7:active{color:#096dd9;background-color:transparent;border-color:#096dd9}._28cW-V5GKksY7EnHAfGGy7.em_Pqz__Gx36paHRPTcGY>a:only-child,._28cW-V5GKksY7EnHAfGGy7:active>a:only-child{color:currentColor}._28cW-V5GKksY7EnHAfGGy7.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:active,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:focus,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:hover,._28cW-V5GKksY7EnHAfGGy7[disabled],._28cW-V5GKksY7EnHAfGGy7[disabled].em_Pqz__Gx36paHRPTcGY,._28cW-V5GKksY7EnHAfGGy7[disabled]:active,._28cW-V5GKksY7EnHAfGGy7[disabled]:focus,._28cW-V5GKksY7EnHAfGGy7[disabled]:hover,.Sse4Jp3wPiasMhv97ZjQf,.Sse4Jp3wPiasMhv97ZjQf.em_Pqz__Gx36paHRPTcGY,.Sse4Jp3wPiasMhv97ZjQf:active,.Sse4Jp3wPiasMhv97ZjQf:focus,.Sse4Jp3wPiasMhv97ZjQf:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB>a:only-child,._28cW-V5GKksY7EnHAfGGy7[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,._28cW-V5GKksY7EnHAfGGy7[disabled]:active>a:only-child,._28cW-V5GKksY7EnHAfGGy7[disabled]:focus>a:only-child,._28cW-V5GKksY7EnHAfGGy7[disabled]:hover>a:only-child,._28cW-V5GKksY7EnHAfGGy7[disabled]>a:only-child,.Sse4Jp3wPiasMhv97ZjQf.em_Pqz__Gx36paHRPTcGY>a:only-child,.Sse4Jp3wPiasMhv97ZjQf:active>a:only-child,.Sse4Jp3wPiasMhv97ZjQf:focus>a:only-child,.Sse4Jp3wPiasMhv97ZjQf:hover>a:only-child,.Sse4Jp3wPiasMhv97ZjQf>a:only-child{color:currentColor}._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7[disabled]:active>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7[disabled]:focus>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7[disabled]:hover>a:only-child:after,._28cW-V5GKksY7EnHAfGGy7[disabled]>a:only-child:after,.Sse4Jp3wPiasMhv97ZjQf.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.Sse4Jp3wPiasMhv97ZjQf:active>a:only-child:after,.Sse4Jp3wPiasMhv97ZjQf:focus>a:only-child:after,.Sse4Jp3wPiasMhv97ZjQf:hover>a:only-child:after,.Sse4Jp3wPiasMhv97ZjQf>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._36EpuJ5cohCuuC4Ya_CMIW{color:rgba(0,0,0,.65);background-color:#fff;border-color:#d9d9d9;border-style:dashed}._36EpuJ5cohCuuC4Ya_CMIW>a:only-child{color:currentColor}._36EpuJ5cohCuuC4Ya_CMIW>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._36EpuJ5cohCuuC4Ya_CMIW:focus,._36EpuJ5cohCuuC4Ya_CMIW:hover{color:#40a9ff;background-color:#fff;border-color:#40a9ff}._36EpuJ5cohCuuC4Ya_CMIW:focus>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW:hover>a:only-child{color:currentColor}._36EpuJ5cohCuuC4Ya_CMIW:focus>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._36EpuJ5cohCuuC4Ya_CMIW.em_Pqz__Gx36paHRPTcGY,._36EpuJ5cohCuuC4Ya_CMIW:active{color:#096dd9;background-color:#fff;border-color:#096dd9}._36EpuJ5cohCuuC4Ya_CMIW.em_Pqz__Gx36paHRPTcGY>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW:active>a:only-child{color:currentColor}._36EpuJ5cohCuuC4Ya_CMIW.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._3RioMuu-JEeE5z6QL9mjHl,._3RioMuu-JEeE5z6QL9mjHl.em_Pqz__Gx36paHRPTcGY,._3RioMuu-JEeE5z6QL9mjHl:active,._3RioMuu-JEeE5z6QL9mjHl:focus,._3RioMuu-JEeE5z6QL9mjHl:hover,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:active,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:focus,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:hover,._36EpuJ5cohCuuC4Ya_CMIW[disabled],._36EpuJ5cohCuuC4Ya_CMIW[disabled].em_Pqz__Gx36paHRPTcGY,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:active,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:focus,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}._3RioMuu-JEeE5z6QL9mjHl.em_Pqz__Gx36paHRPTcGY>a:only-child,._3RioMuu-JEeE5z6QL9mjHl:active>a:only-child,._3RioMuu-JEeE5z6QL9mjHl:focus>a:only-child,._3RioMuu-JEeE5z6QL9mjHl:hover>a:only-child,._3RioMuu-JEeE5z6QL9mjHl>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:active>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:focus>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:hover>a:only-child,._36EpuJ5cohCuuC4Ya_CMIW[disabled]>a:only-child{color:currentColor}._3RioMuu-JEeE5z6QL9mjHl.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._3RioMuu-JEeE5z6QL9mjHl:active>a:only-child:after,._3RioMuu-JEeE5z6QL9mjHl:focus>a:only-child:after,._3RioMuu-JEeE5z6QL9mjHl:hover>a:only-child:after,._3RioMuu-JEeE5z6QL9mjHl>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:active>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:focus>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW[disabled]:hover>a:only-child:after,._36EpuJ5cohCuuC4Ya_CMIW[disabled]>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.kRhGgtBu5MP6Yiupx7QY5{color:#fff;background-color:#ff4d4f;border-color:#ff4d4f;text-shadow:0 -1px 0 rgba(0,0,0,.12);box-shadow:0 2px 0 rgba(0,0,0,.045)}.kRhGgtBu5MP6Yiupx7QY5>a:only-child{color:currentColor}.kRhGgtBu5MP6Yiupx7QY5>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.kRhGgtBu5MP6Yiupx7QY5:focus,.kRhGgtBu5MP6Yiupx7QY5:hover{color:#fff;background-color:#ff7875;border-color:#ff7875}.kRhGgtBu5MP6Yiupx7QY5:focus>a:only-child,.kRhGgtBu5MP6Yiupx7QY5:hover>a:only-child{color:currentColor}.kRhGgtBu5MP6Yiupx7QY5:focus>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.kRhGgtBu5MP6Yiupx7QY5.em_Pqz__Gx36paHRPTcGY,.kRhGgtBu5MP6Yiupx7QY5:active{color:#fff;background-color:#d9363e;border-color:#d9363e}.kRhGgtBu5MP6Yiupx7QY5.em_Pqz__Gx36paHRPTcGY>a:only-child,.kRhGgtBu5MP6Yiupx7QY5:active>a:only-child{color:currentColor}.kRhGgtBu5MP6Yiupx7QY5.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._1bDFL62BT0OwkwSvapqFsH,._1bDFL62BT0OwkwSvapqFsH.em_Pqz__Gx36paHRPTcGY,._1bDFL62BT0OwkwSvapqFsH:active,._1bDFL62BT0OwkwSvapqFsH:focus,._1bDFL62BT0OwkwSvapqFsH:hover,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:active,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:focus,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:hover,.kRhGgtBu5MP6Yiupx7QY5[disabled],.kRhGgtBu5MP6Yiupx7QY5[disabled].em_Pqz__Gx36paHRPTcGY,.kRhGgtBu5MP6Yiupx7QY5[disabled]:active,.kRhGgtBu5MP6Yiupx7QY5[disabled]:focus,.kRhGgtBu5MP6Yiupx7QY5[disabled]:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}._1bDFL62BT0OwkwSvapqFsH.em_Pqz__Gx36paHRPTcGY>a:only-child,._1bDFL62BT0OwkwSvapqFsH:active>a:only-child,._1bDFL62BT0OwkwSvapqFsH:focus>a:only-child,._1bDFL62BT0OwkwSvapqFsH:hover>a:only-child,._1bDFL62BT0OwkwSvapqFsH>a:only-child,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB>a:only-child,.kRhGgtBu5MP6Yiupx7QY5[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,.kRhGgtBu5MP6Yiupx7QY5[disabled]:active>a:only-child,.kRhGgtBu5MP6Yiupx7QY5[disabled]:focus>a:only-child,.kRhGgtBu5MP6Yiupx7QY5[disabled]:hover>a:only-child,.kRhGgtBu5MP6Yiupx7QY5[disabled]>a:only-child{color:currentColor}._1bDFL62BT0OwkwSvapqFsH.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._1bDFL62BT0OwkwSvapqFsH:active>a:only-child:after,._1bDFL62BT0OwkwSvapqFsH:focus>a:only-child:after,._1bDFL62BT0OwkwSvapqFsH:hover>a:only-child:after,._1bDFL62BT0OwkwSvapqFsH>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5[disabled]:active>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5[disabled]:focus>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5[disabled]:hover>a:only-child:after,.kRhGgtBu5MP6Yiupx7QY5[disabled]>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.hmK4fm7kmJWiBmE2QEBLL{color:#1890ff;background-color:transparent;border-color:transparent;box-shadow:none}.hmK4fm7kmJWiBmE2QEBLL>a:only-child{color:currentColor}.hmK4fm7kmJWiBmE2QEBLL>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.hmK4fm7kmJWiBmE2QEBLL:focus,.hmK4fm7kmJWiBmE2QEBLL:hover{color:#40a9ff;background-color:transparent;border-color:#40a9ff}.hmK4fm7kmJWiBmE2QEBLL:focus>a:only-child,.hmK4fm7kmJWiBmE2QEBLL:hover>a:only-child{color:currentColor}.hmK4fm7kmJWiBmE2QEBLL:focus>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.hmK4fm7kmJWiBmE2QEBLL.em_Pqz__Gx36paHRPTcGY,.hmK4fm7kmJWiBmE2QEBLL:active{color:#096dd9;background-color:transparent;border-color:#096dd9}.hmK4fm7kmJWiBmE2QEBLL.em_Pqz__Gx36paHRPTcGY>a:only-child,.hmK4fm7kmJWiBmE2QEBLL:active>a:only-child{color:currentColor}.hmK4fm7kmJWiBmE2QEBLL.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:active,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:focus,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:hover,.hmK4fm7kmJWiBmE2QEBLL[disabled],.hmK4fm7kmJWiBmE2QEBLL[disabled].em_Pqz__Gx36paHRPTcGY,.hmK4fm7kmJWiBmE2QEBLL[disabled]:active,.hmK4fm7kmJWiBmE2QEBLL[disabled]:focus,.hmK4fm7kmJWiBmE2QEBLL[disabled]:hover,.ZBDYoEl7_6eCPKgX2Hv0J,.ZBDYoEl7_6eCPKgX2Hv0J.em_Pqz__Gx36paHRPTcGY,.ZBDYoEl7_6eCPKgX2Hv0J:active,.ZBDYoEl7_6eCPKgX2Hv0J:focus,.ZBDYoEl7_6eCPKgX2Hv0J:hover{background-color:#f5f5f5;border-color:#d9d9d9}.hmK4fm7kmJWiBmE2QEBLL:active,.hmK4fm7kmJWiBmE2QEBLL:focus,.hmK4fm7kmJWiBmE2QEBLL:hover{border-color:transparent}.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:active,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:focus,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:hover,.hmK4fm7kmJWiBmE2QEBLL[disabled],.hmK4fm7kmJWiBmE2QEBLL[disabled].em_Pqz__Gx36paHRPTcGY,.hmK4fm7kmJWiBmE2QEBLL[disabled]:active,.hmK4fm7kmJWiBmE2QEBLL[disabled]:focus,.hmK4fm7kmJWiBmE2QEBLL[disabled]:hover,.ZBDYoEl7_6eCPKgX2Hv0J,.ZBDYoEl7_6eCPKgX2Hv0J.em_Pqz__Gx36paHRPTcGY,.ZBDYoEl7_6eCPKgX2Hv0J:active,.ZBDYoEl7_6eCPKgX2Hv0J:focus,.ZBDYoEl7_6eCPKgX2Hv0J:hover{color:rgba(0,0,0,.25);background-color:transparent;border-color:transparent;text-shadow:none;box-shadow:none}.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB>a:only-child,.hmK4fm7kmJWiBmE2QEBLL[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,.hmK4fm7kmJWiBmE2QEBLL[disabled]:active>a:only-child,.hmK4fm7kmJWiBmE2QEBLL[disabled]:focus>a:only-child,.hmK4fm7kmJWiBmE2QEBLL[disabled]:hover>a:only-child,.hmK4fm7kmJWiBmE2QEBLL[disabled]>a:only-child,.ZBDYoEl7_6eCPKgX2Hv0J.em_Pqz__Gx36paHRPTcGY>a:only-child,.ZBDYoEl7_6eCPKgX2Hv0J:active>a:only-child,.ZBDYoEl7_6eCPKgX2Hv0J:focus>a:only-child,.ZBDYoEl7_6eCPKgX2Hv0J:hover>a:only-child,.ZBDYoEl7_6eCPKgX2Hv0J>a:only-child{color:currentColor}.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL[disabled]:active>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL[disabled]:focus>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL[disabled]:hover>a:only-child:after,.hmK4fm7kmJWiBmE2QEBLL[disabled]>a:only-child:after,.ZBDYoEl7_6eCPKgX2Hv0J.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.ZBDYoEl7_6eCPKgX2Hv0J:active>a:only-child:after,.ZBDYoEl7_6eCPKgX2Hv0J:focus>a:only-child:after,.ZBDYoEl7_6eCPKgX2Hv0J:hover>a:only-child:after,.ZBDYoEl7_6eCPKgX2Hv0J>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2ocM8T51DT6FnbK5epT0eQ{width:32px;height:32px;padding:0;font-size:16px;border-radius:4px}._2ocM8T51DT6FnbK5epT0eQ._24N8kMOEo48v88KpPB3fPF{width:40px;height:40px;padding:0;font-size:18px;border-radius:4px}._2ocM8T51DT6FnbK5epT0eQ.m7OIj5e4R4jh4ez3P5chZ{width:24px;height:24px;padding:0;font-size:14px;border-radius:4px}._2ocM8T51DT6FnbK5epT0eQ>i{vertical-align:middle}._3KbNaV4fUjdt6wXlJ4HWNd{height:32px;padding:0 16px;font-size:14px;border-radius:32px}._3KbNaV4fUjdt6wXlJ4HWNd._24N8kMOEo48v88KpPB3fPF{height:40px;padding:0 20px;font-size:16px;border-radius:40px}._3KbNaV4fUjdt6wXlJ4HWNd.m7OIj5e4R4jh4ez3P5chZ{height:24px;padding:0 12px;font-size:14px;border-radius:24px}._3KbNaV4fUjdt6wXlJ4HWNd._2ocM8T51DT6FnbK5epT0eQ{width:auto}._2tU8AyFhj9UYKq9JE7auMM,.vtw-kryJIdaSOJcH4KB11{min-width:32px;padding-right:0;padding-left:0;text-align:center;border-radius:50%}._2tU8AyFhj9UYKq9JE7auMM._24N8kMOEo48v88KpPB3fPF,.vtw-kryJIdaSOJcH4KB11._24N8kMOEo48v88KpPB3fPF{min-width:40px;border-radius:50%}._2tU8AyFhj9UYKq9JE7auMM.m7OIj5e4R4jh4ez3P5chZ,.vtw-kryJIdaSOJcH4KB11.m7OIj5e4R4jh4ez3P5chZ{min-width:24px;border-radius:50%}._34ecc6_SGKef4Y6JfdE_DJ:before{position:absolute;top:-1px;right:-1px;bottom:-1px;left:-1px;z-index:1;display:none;background:#fff;border-radius:inherit;opacity:.35;transition:opacity .2s;content:\"\";pointer-events:none}._34ecc6_SGKef4Y6JfdE_DJ ._1oZ8xlpZEg3PzGp2jMNFuZ{transition:margin-left .3s cubic-bezier(.645,.045,.355,1)}._34ecc6_SGKef4Y6JfdE_DJ ._1oZ8xlpZEg3PzGp2jMNFuZ._1L4ck2wTdDCoauInK9YqtU>svg,._34ecc6_SGKef4Y6JfdE_DJ ._1oZ8xlpZEg3PzGp2jMNFuZ.Sycof4pIuBfRQRCgl2eFA>svg{shape-rendering:optimizeSpeed}._34ecc6_SGKef4Y6JfdE_DJ._1Wb6aP-YiUzgPhaiM1RXVK{position:relative}._34ecc6_SGKef4Y6JfdE_DJ._1Wb6aP-YiUzgPhaiM1RXVK:not([disabled]){pointer-events:none}._34ecc6_SGKef4Y6JfdE_DJ._1Wb6aP-YiUzgPhaiM1RXVK:before{display:block}._34ecc6_SGKef4Y6JfdE_DJ._1Wb6aP-YiUzgPhaiM1RXVK:not(._2tU8AyFhj9UYKq9JE7auMM):not(.vtw-kryJIdaSOJcH4KB11):not(._2ocM8T51DT6FnbK5epT0eQ){padding-left:29px}._34ecc6_SGKef4Y6JfdE_DJ._1Wb6aP-YiUzgPhaiM1RXVK:not(._2tU8AyFhj9UYKq9JE7auMM):not(.vtw-kryJIdaSOJcH4KB11):not(._2ocM8T51DT6FnbK5epT0eQ) ._1oZ8xlpZEg3PzGp2jMNFuZ:not(:last-child){margin-left:-14px}.m7OIj5e4R4jh4ez3P5chZ._1Wb6aP-YiUzgPhaiM1RXVK:not(._2tU8AyFhj9UYKq9JE7auMM):not(.vtw-kryJIdaSOJcH4KB11):not(._2ocM8T51DT6FnbK5epT0eQ){padding-left:24px}.m7OIj5e4R4jh4ez3P5chZ._1Wb6aP-YiUzgPhaiM1RXVK:not(._2tU8AyFhj9UYKq9JE7auMM):not(.vtw-kryJIdaSOJcH4KB11):not(._2ocM8T51DT6FnbK5epT0eQ) ._1oZ8xlpZEg3PzGp2jMNFuZ{margin-left:-17px}._351ag-o1wnW8fFXVy1ny9i{position:relative;display:inline-block}._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ,._351ag-o1wnW8fFXVy1ny9i>span>._34ecc6_SGKef4Y6JfdE_DJ{position:relative}._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ.em_Pqz__Gx36paHRPTcGY,._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:active,._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:focus,._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:hover,._351ag-o1wnW8fFXVy1ny9i>span>._34ecc6_SGKef4Y6JfdE_DJ.em_Pqz__Gx36paHRPTcGY,._351ag-o1wnW8fFXVy1ny9i>span>._34ecc6_SGKef4Y6JfdE_DJ:active,._351ag-o1wnW8fFXVy1ny9i>span>._34ecc6_SGKef4Y6JfdE_DJ:focus,._351ag-o1wnW8fFXVy1ny9i>span>._34ecc6_SGKef4Y6JfdE_DJ:hover{z-index:2}._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:disabled,._351ag-o1wnW8fFXVy1ny9i>span>._34ecc6_SGKef4Y6JfdE_DJ:disabled{z-index:0}._351ag-o1wnW8fFXVy1ny9i>._2ocM8T51DT6FnbK5epT0eQ{font-size:14px}._23cTBEB8rjillU4ypcQKWZ>._34ecc6_SGKef4Y6JfdE_DJ,._23cTBEB8rjillU4ypcQKWZ>span>._34ecc6_SGKef4Y6JfdE_DJ{height:40px;padding:0 15px;font-size:16px;border-radius:0;line-height:38px}._23cTBEB8rjillU4ypcQKWZ>._34ecc6_SGKef4Y6JfdE_DJ._2ocM8T51DT6FnbK5epT0eQ{width:40px;height:40px;padding-right:0;padding-left:0}._1TNuB9ebn-FhEmMV6SzBfS>._34ecc6_SGKef4Y6JfdE_DJ,._1TNuB9ebn-FhEmMV6SzBfS>span>._34ecc6_SGKef4Y6JfdE_DJ{height:24px;padding:0 7px;font-size:14px;border-radius:0;line-height:22px}._1TNuB9ebn-FhEmMV6SzBfS>._34ecc6_SGKef4Y6JfdE_DJ>._1oZ8xlpZEg3PzGp2jMNFuZ,._1TNuB9ebn-FhEmMV6SzBfS>span>._34ecc6_SGKef4Y6JfdE_DJ>._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:14px}._1TNuB9ebn-FhEmMV6SzBfS>._34ecc6_SGKef4Y6JfdE_DJ._2ocM8T51DT6FnbK5epT0eQ{width:24px;height:24px;padding-right:0;padding-left:0}._34ecc6_SGKef4Y6JfdE_DJ+._351ag-o1wnW8fFXVy1ny9i,._351ag-o1wnW8fFXVy1ny9i+._34ecc6_SGKef4Y6JfdE_DJ,._351ag-o1wnW8fFXVy1ny9i+._351ag-o1wnW8fFXVy1ny9i,._351ag-o1wnW8fFXVy1ny9i ._34ecc6_SGKef4Y6JfdE_DJ+._34ecc6_SGKef4Y6JfdE_DJ,._351ag-o1wnW8fFXVy1ny9i ._34ecc6_SGKef4Y6JfdE_DJ+span,._351ag-o1wnW8fFXVy1ny9i>span+span,._351ag-o1wnW8fFXVy1ny9i span+._34ecc6_SGKef4Y6JfdE_DJ{margin-left:-1px}._351ag-o1wnW8fFXVy1ny9i ._1hBh0D8Z27qUhgXC7swls9+._34ecc6_SGKef4Y6JfdE_DJ:not(._1hBh0D8Z27qUhgXC7swls9):not([disabled]){border-left-color:transparent}._351ag-o1wnW8fFXVy1ny9i ._34ecc6_SGKef4Y6JfdE_DJ{border-radius:0}._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:first-child,._351ag-o1wnW8fFXVy1ny9i>span:first-child>._34ecc6_SGKef4Y6JfdE_DJ{margin-left:0}._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:only-child,._351ag-o1wnW8fFXVy1ny9i>span:only-child>._34ecc6_SGKef4Y6JfdE_DJ{border-radius:4px}._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:first-child:not(:last-child),._351ag-o1wnW8fFXVy1ny9i>span:first-child:not(:last-child)>._34ecc6_SGKef4Y6JfdE_DJ{border-top-left-radius:4px;border-bottom-left-radius:4px}._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:last-child:not(:first-child),._351ag-o1wnW8fFXVy1ny9i>span:last-child:not(:first-child)>._34ecc6_SGKef4Y6JfdE_DJ{border-top-right-radius:4px;border-bottom-right-radius:4px}._1TNuB9ebn-FhEmMV6SzBfS>._34ecc6_SGKef4Y6JfdE_DJ:only-child,._1TNuB9ebn-FhEmMV6SzBfS>span:only-child>._34ecc6_SGKef4Y6JfdE_DJ{border-radius:4px}._1TNuB9ebn-FhEmMV6SzBfS>._34ecc6_SGKef4Y6JfdE_DJ:first-child:not(:last-child),._1TNuB9ebn-FhEmMV6SzBfS>span:first-child:not(:last-child)>._34ecc6_SGKef4Y6JfdE_DJ{border-top-left-radius:4px;border-bottom-left-radius:4px}._1TNuB9ebn-FhEmMV6SzBfS>._34ecc6_SGKef4Y6JfdE_DJ:last-child:not(:first-child),._1TNuB9ebn-FhEmMV6SzBfS>span:last-child:not(:first-child)>._34ecc6_SGKef4Y6JfdE_DJ{border-top-right-radius:4px;border-bottom-right-radius:4px}._351ag-o1wnW8fFXVy1ny9i>._351ag-o1wnW8fFXVy1ny9i{float:left}._351ag-o1wnW8fFXVy1ny9i>._351ag-o1wnW8fFXVy1ny9i:not(:first-child):not(:last-child)>._34ecc6_SGKef4Y6JfdE_DJ{border-radius:0}._351ag-o1wnW8fFXVy1ny9i>._351ag-o1wnW8fFXVy1ny9i:first-child:not(:last-child)>._34ecc6_SGKef4Y6JfdE_DJ:last-child{padding-right:8px;border-top-right-radius:0;border-bottom-right-radius:0}._351ag-o1wnW8fFXVy1ny9i>._351ag-o1wnW8fFXVy1ny9i:last-child:not(:first-child)>._34ecc6_SGKef4Y6JfdE_DJ:first-child{padding-left:8px;border-top-left-radius:0;border-bottom-left-radius:0}._34ecc6_SGKef4Y6JfdE_DJ:active>span,._34ecc6_SGKef4Y6JfdE_DJ:focus>span{position:relative}._34ecc6_SGKef4Y6JfdE_DJ>._1oZ8xlpZEg3PzGp2jMNFuZ+span,._34ecc6_SGKef4Y6JfdE_DJ>span+._1oZ8xlpZEg3PzGp2jMNFuZ{margin-left:8px}._2AlsDrNenR2zEmhOojCCar{color:#fff;background:transparent!important;border-color:#fff}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9{color:#1890ff;background-color:transparent;border-color:#1890ff;text-shadow:none}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:focus,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:hover{color:#40a9ff;background-color:transparent;border-color:#40a9ff}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:hover>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:active{color:#096dd9;background-color:transparent;border-color:#096dd9}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:active>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:active,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:focus,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:hover,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled],._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled].em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:active,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:focus,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:hover,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:active,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:focus,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:active>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]>a:only-child,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:active>a:only-child,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1hBh0D8Z27qUhgXC7swls9[disabled]>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._2n9ezvu5zWvbTSje8a1htn>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5{color:#ff4d4f;background-color:transparent;border-color:#ff4d4f;text-shadow:none}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:focus,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:hover{color:#ff7875;background-color:transparent;border-color:#ff7875}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:hover>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:active{color:#d9363e;background-color:transparent;border-color:#d9363e}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:active>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:active,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:focus,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:hover,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:active,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:focus,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:hover,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled],._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled].em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:active,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:focus,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:active>a:only-child,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:active>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar._1bDFL62BT0OwkwSvapqFsH>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.kRhGgtBu5MP6Yiupx7QY5[disabled]>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL{color:#1890ff;background-color:transparent;border-color:transparent;text-shadow:none;color:#fff}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:focus,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:hover{color:#40a9ff;background-color:transparent;border-color:transparent}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:hover>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:active{color:#096dd9;background-color:transparent;border-color:transparent}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:active>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:active,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:focus,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:hover,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled],._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled].em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:active,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:focus,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:hover,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J.em_Pqz__Gx36paHRPTcGY,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:active,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:focus,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:active>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]>a:only-child,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J.em_Pqz__Gx36paHRPTcGY>a:only-child,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:active>a:only-child,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:focus>a:only-child,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:hover>a:only-child,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J>a:only-child{color:currentColor}._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.hmK4fm7kmJWiBmE2QEBLL[disabled]>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J.em_Pqz__Gx36paHRPTcGY>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:active>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:focus>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J:hover>a:only-child:after,._2AlsDrNenR2zEmhOojCCar.ZBDYoEl7_6eCPKgX2Hv0J>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.Z_Iq1ZDhuPPU47RVwbaxh:first-letter{letter-spacing:.34em}.Z_Iq1ZDhuPPU47RVwbaxh>:not(._1oZ8xlpZEg3PzGp2jMNFuZ){margin-right:-.34em;letter-spacing:.34em}._1RU8_1cJ_Clh8vyuslfcBW{width:100%}._34ecc6_SGKef4Y6JfdE_DJ:empty{vertical-align:top}a._34ecc6_SGKef4Y6JfdE_DJ{padding-top:.1px;line-height:30px}a._24N8kMOEo48v88KpPB3fPF{line-height:38px}a.m7OIj5e4R4jh4ez3P5chZ{line-height:22px}._2MKp7hdKk2nS6JN5GBZgf8{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;overflow:hidden;color:#fff;white-space:nowrap;text-align:center;vertical-align:middle;background:#ccc;width:32px;height:32px;line-height:32px;border-radius:50%}._2voensPdXJsNPindxv663f{background:transparent}._J1Ln1LRoji6DROCV01oP{position:absolute;left:50%;transform-origin:0 center}._2MKp7hdKk2nS6JN5GBZgf8._3gvpByJ3mlSOG_KvZAjTAu{font-size:18px}.MBh9VoWv7zSvGmK45xhM2{width:40px;height:40px;line-height:40px;border-radius:50%}.XzLcClRb-Qdih9zx5B8Pu{position:absolute;left:50%;transform-origin:0 center}.MBh9VoWv7zSvGmK45xhM2._3gvpByJ3mlSOG_KvZAjTAu{font-size:24px}._1p6KWxbLxM7uf3gf5oSFd0{width:24px;height:24px;line-height:24px;border-radius:50%}._1bbkMYm5C70loMWMZ1eaJ8{position:absolute;left:50%;transform-origin:0 center}._1p6KWxbLxM7uf3gf5oSFd0._3gvpByJ3mlSOG_KvZAjTAu{font-size:14px}.Jpsfw2LtKLpB0wYN0WrpG{border-radius:4px}._2MKp7hdKk2nS6JN5GBZgf8>img{display:block;width:100%;height:100%;object-fit:cover}._2KfzFgSgK0sivgveX7CdVE{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:fixed;right:100px;bottom:50px;z-index:10;width:40px;height:40px;cursor:pointer}._2_Sxj24_Yy0OFpHcMvv92s{width:40px;height:40px;overflow:hidden;color:#fff;text-align:center;background-color:rgba(0,0,0,.45);border-radius:20px;transition:all .3s cubic-bezier(.645,.045,.355,1)}._2_Sxj24_Yy0OFpHcMvv92s:hover{background-color:rgba(0,0,0,.65);transition:all .3s cubic-bezier(.645,.045,.355,1)}._2l0Gl6kowN8GuetKelrT09{width:14px;height:16px;margin:12px auto;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAABGdBTUEAALGPC/xhBQAAAbtJREFUWAntmMtKw0AUhhMvS5cuxILgQlRUpIggIoKIIoigG1eC+AA+jo+i6FIXBfeuXIgoeKVeitVWJX5HWhhDksnUpp3FDPyZk3Nm5nycmZKkXhAEOXSA3lG7muTeRzmfy6HneUvIhnYkQK+Q9NhAA0Opg0vBEhjBKHiyb8iGMyQMOYuK41BcBSypAL+MYXSKjtFAW7EAGEO3qN4uMQbbAkXiSfRQJ1H6a+yhlkKRcAoVFYiweYNjtCVQJJpBz2GCiPt7fBOZQpFgDpUikse5HgnkM4Fi4QX0Fpc5wf9EbLqpUCy4jMoJSXWhFwbMNgWKhVbRhy5jirhs9fy/oFhgHVVTJEs7RLZ8sSEoJm6iz7SZDMbJ+/OKERQTttCXQRLToRUmrKWCYuA2+jbN0MB4OQobYShfdTCgn/sL1K36M7TLrN3n+758aPy2rrpR6+/od5E8tf/A1uLS9aId5T7J3CNYihkQ4D9PiMdMC7mp4rjB9kjFjZp8BlnVHJBuO1yFXIV0FdDF3RlyFdJVQBdv5AxVdIsq8apiZ2PyYO1EVykesGfZEESsCkweyR8MUW+V8uJ1gkYipmpdP1pm2aJVPEGzAAAAAElFTkSuQmCC) 100%/100% no-repeat}@media screen and (max-width:768px){._2KfzFgSgK0sivgveX7CdVE{right:60px}}@media screen and (max-width:480px){._2KfzFgSgK0sivgveX7CdVE{right:20px}}._3EuI91wvbrK1LjABksTMsm{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;color:unset;line-height:1}._2nDT_kZTrTBTrSRLtgW4n9{min-width:20px;height:20px;padding:0 6px;color:#fff;font-weight:400;font-size:12px;line-height:20px;white-space:nowrap;text-align:center;background:#f5222d;border-radius:10px;box-shadow:0 0 0 1px #fff}._2nDT_kZTrTBTrSRLtgW4n9 a,._2nDT_kZTrTBTrSRLtgW4n9 a:hover{color:#fff}._12w0yDQair4s91C9YdFthJ{padding:0 8px}._1bctaxQoDMRPoPLXK6-2Zg{width:6px;height:6px;background:#f5222d;border-radius:100%;box-shadow:0 0 0 1px #fff}._1bctaxQoDMRPoPLXK6-2Zg,._2nDT_kZTrTBTrSRLtgW4n9,._3EuI91wvbrK1LjABksTMsm ._15UcVxbgiOtrjsu3hyO-SN{position:absolute;top:0;right:0;z-index:1;transform:translate(50%,-50%);transform-origin:100% 0}._2Vq9bYGh03VgOPtXK-tuXX{line-height:inherit;vertical-align:baseline}._1jusEKcYABxmF8zlz9hVYp{position:relative;top:-1px;display:inline-block;width:6px;height:6px;vertical-align:middle;border-radius:50%}.FAgqRiO12ZbXXq5qKJH3J{background-color:#52c41a}.r8V9uyhqCGkYISVGtUBsu{position:relative;background-color:#1890ff}.r8V9uyhqCGkYISVGtUBsu:after{position:absolute;top:0;left:0;width:100%;height:100%;border:1px solid #1890ff;border-radius:50%;animation:gVdpUKGtq53ZGlQXYZ56y 1.2s infinite ease-in-out;content:\"\"}._12ojSFxDycFjb5I-Yfcj2K{background-color:#d9d9d9}._1pfbf0Gnc5oAsKtjpda3Er{background-color:#f5222d}._1fzTfSIY9sbQ9ZUq5lPE9q{background-color:#faad14}._8Nw3ARZfI5epBzJVONMns,._35O0gW7QuulBzyzUQva3uw{background:#eb2f96}._2Hrj32oWB7A93vQF4OYoC_{background:#f5222d}._1fNkfRXyThov80ulKazofW{background:#fa541c}.c_KqGtJ1Q_ieJHYJmFEc9{background:#fa8c16}._3lYANjGyoY0eQhqJ1K4ajt{background:#fadb14}._2Za780M8waWyRYh9VOJL5J{background:#faad14}.zwGzCBJqVWR_ZM3EXHucS{background:#13c2c2}._3YnXr-LYzZT1656EZSUoXv{background:#a0d911}._2XdA5DRZOXwEDf-mm3HNG{background:#52c41a}._1b6jQU3H9OxG4pgplRUe9P{background:#1890ff}._2-7miPu9FBUi6hMmoHeNF_{background:#2f54eb}._2P1SCY7IBzS5IeiP-OjuV-{background:#722ed1}._2M6cMp10Tqg42u-hm6mhhH{margin-left:8px;color:rgba(0,0,0,.65);font-size:14px}._2U_hhA7tZidjbKoSbohxP8,._3QeyVVkYZp3mk55XHRDHB4{animation:_1hyJbvKv1KapV5KPmfYW6R .3s cubic-bezier(.12,.4,.29,1.46);animation-fill-mode:both}._8bynXrT6pZGyWJI4aRqP7{animation:_2rrzwbCaPLGtsAXkoXX3Nx .3s cubic-bezier(.71,-.46,.88,.6);animation-fill-mode:both}.NQTf31sjxSirFP--Yvhqo:not(._2Vq9bYGh03VgOPtXK-tuXX){vertical-align:middle}.NQTf31sjxSirFP--Yvhqo ._26Wa8rMqBnh4XzEzu8xW_5{position:relative;top:auto;display:block}.NQTf31sjxSirFP--Yvhqo ._2nDT_kZTrTBTrSRLtgW4n9{transform:none}@keyframes gVdpUKGtq53ZGlQXYZ56y{0%{transform:scale(.8);opacity:.5}to{transform:scale(2.4);opacity:0}}._26Wa8rMqBnh4XzEzu8xW_5{overflow:hidden}._3Dc5CCGfzTy2NmEeGKwpnt{display:inline-block;height:20px;transition:all .3s cubic-bezier(.645,.045,.355,1)}._3Dc5CCGfzTy2NmEeGKwpnt>p._3ME6KxuzhJgzMvj1BCbUpQ{height:20px;margin:0}._19Nyp9oquFJfeW_ePOkEYV{vertical-align:top}@keyframes _1hyJbvKv1KapV5KPmfYW6R{0%{transform:scale(0) translate(50%,-50%);opacity:0}to{transform:scale(1) translate(50%,-50%)}}@keyframes _2rrzwbCaPLGtsAXkoXX3Nx{0%{transform:scale(1) translate(50%,-50%)}to{transform:scale(0) translate(50%,-50%);opacity:0}}._3eEogvwh7o7K3lNEC83dFg{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";color:rgba(0,0,0,.45);font-size:14px}._3eEogvwh7o7K3lNEC83dFg ._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:14px}._3eEogvwh7o7K3lNEC83dFg a{color:rgba(0,0,0,.45);transition:color .3s}._3eEogvwh7o7K3lNEC83dFg a:hover{color:#40a9ff}._3eEogvwh7o7K3lNEC83dFg>span:last-child,._3eEogvwh7o7K3lNEC83dFg>span:last-child a{color:rgba(0,0,0,.65)}._3eEogvwh7o7K3lNEC83dFg>span:last-child .ko_TN_UHl2AJ4E9sRwJSF{display:none}.ko_TN_UHl2AJ4E9sRwJSF{margin:0 8px;color:rgba(0,0,0,.45)}.f_LJXbj0Cnqch4wPuDlu2>._1oZ8xlpZEg3PzGp2jMNFuZ+span,.yMPmnlWn5PANts_Tno-Ky>._1oZ8xlpZEg3PzGp2jMNFuZ{margin-left:4px}._1gsorLwjR7Y-PP5FFI3vP-{box-sizing:border-box;margin:0;padding:0;font-size:14px;font-variant:tabular-nums;line-height:1.5;font-feature-settings:\"tnum\";margin-bottom:0;padding-left:0;color:rgba(0,0,0,.65);line-height:0;list-style:none;background:#fff;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.15);transition:background .3s,width .2s;zoom:1}._1gsorLwjR7Y-PP5FFI3vP-:after,._1gsorLwjR7Y-PP5FFI3vP-:before{display:table;content:\"\"}._1gsorLwjR7Y-PP5FFI3vP-:after{clear:both}._1gsorLwjR7Y-PP5FFI3vP- ol,._1gsorLwjR7Y-PP5FFI3vP- ul{margin:0;padding:0;list-style:none}._1gdeR0Fx6ZNKPVJTrrksaK{display:none}.xKQZCrIheuJ0Z14CTOZsC{padding:8px 16px;color:rgba(0,0,0,.45);font-size:14px;line-height:1.5;transition:all .3s}._1vBG_YDrLvGi02vtpeBxyx,._3BcPw7hinJJuDjuT9JfPUg{transition:border-color .3s cubic-bezier(.645,.045,.355,1),background .3s cubic-bezier(.645,.045,.355,1),padding .15s cubic-bezier(.645,.045,.355,1)}._1zhiBd1wp4s94gkbQup87S{color:#1890ff}._1ESAZGbxgRjRzA5qTyYs-Y:active,._3dAM_Z_DQGVNEBKvNI9u8a:active{background:#e6f7ff}._3BcPw7hinJJuDjuT9JfPUg ._2isXzdyoeyPew61lAdXl6g{cursor:auto;transition:background .3s cubic-bezier(.645,.045,.355,1),padding .3s cubic-bezier(.645,.045,.355,1)}._1ESAZGbxgRjRzA5qTyYs-Y>a{display:block;color:rgba(0,0,0,.65)}._1ESAZGbxgRjRzA5qTyYs-Y>a:hover{color:#1890ff}._1ESAZGbxgRjRzA5qTyYs-Y>a:before{position:absolute;top:0;right:0;bottom:0;left:0;background-color:transparent;content:\"\"}._1ESAZGbxgRjRzA5qTyYs-Y>._3EuI91wvbrK1LjABksTMsm>a{color:rgba(0,0,0,.65)}._1ESAZGbxgRjRzA5qTyYs-Y>._3EuI91wvbrK1LjABksTMsm>a:hover{color:#1890ff}._3T4oh7v3sba_RR2t4uNG9h{height:1px;overflow:hidden;line-height:0;background-color:#e8e8e8}._1ESAZGbxgRjRzA5qTyYs-Y:hover,._1gsorLwjR7Y-PP5FFI3vP-:not(._3IjzvPAJhP9Gw7HdqzdhUB) ._1MGPj4VxN-efhYLU1mnVAl,._3dAM_Z_DQGVNEBKvNI9u8a:hover,.dwnijamx0-ohAJnp60ba0,.PT2mTdhhT0GI2f7YtLC2H{color:#1890ff}.Q1GfZQgyTHhXX0UX8MShJ ._1ESAZGbxgRjRzA5qTyYs-Y,.Q1GfZQgyTHhXX0UX8MShJ ._3BcPw7hinJJuDjuT9JfPUg{margin-top:-1px}.Q1GfZQgyTHhXX0UX8MShJ>._1ESAZGbxgRjRzA5qTyYs-Y:hover,.Q1GfZQgyTHhXX0UX8MShJ>._3BcPw7hinJJuDjuT9JfPUg ._3dAM_Z_DQGVNEBKvNI9u8a:hover,.Q1GfZQgyTHhXX0UX8MShJ>.PT2mTdhhT0GI2f7YtLC2H{background-color:transparent}._16orcnJPiaH5JUK2ngYnV9,._16orcnJPiaH5JUK2ngYnV9>a,._16orcnJPiaH5JUK2ngYnV9>a:hover{color:#1890ff}._1gsorLwjR7Y-PP5FFI3vP-:not(.Q1GfZQgyTHhXX0UX8MShJ) ._16orcnJPiaH5JUK2ngYnV9{background-color:#e6f7ff}._3ftSq04uq93bpiWh57I9Vo,._3IjzvPAJhP9Gw7HdqzdhUB,.WOHun4LhPxwfBNb0rC3sU{border-right:1px solid #e8e8e8}._3EWd0zwU6oxDkqF808cbIR{border-left:1px solid #e8e8e8}._3EWd0zwU6oxDkqF808cbIR._2isXzdyoeyPew61lAdXl6g,._3ftSq04uq93bpiWh57I9Vo._2isXzdyoeyPew61lAdXl6g,.WOHun4LhPxwfBNb0rC3sU._2isXzdyoeyPew61lAdXl6g{min-width:160px;padding:0;border-right:0;transform-origin:0 0}._3EWd0zwU6oxDkqF808cbIR._2isXzdyoeyPew61lAdXl6g ._1ESAZGbxgRjRzA5qTyYs-Y,._3ftSq04uq93bpiWh57I9Vo._2isXzdyoeyPew61lAdXl6g ._1ESAZGbxgRjRzA5qTyYs-Y,.WOHun4LhPxwfBNb0rC3sU._2isXzdyoeyPew61lAdXl6g ._1ESAZGbxgRjRzA5qTyYs-Y{left:0;margin-left:0;border-right:0}._3EWd0zwU6oxDkqF808cbIR._2isXzdyoeyPew61lAdXl6g ._1ESAZGbxgRjRzA5qTyYs-Y:after,._3ftSq04uq93bpiWh57I9Vo._2isXzdyoeyPew61lAdXl6g ._1ESAZGbxgRjRzA5qTyYs-Y:after,.WOHun4LhPxwfBNb0rC3sU._2isXzdyoeyPew61lAdXl6g ._1ESAZGbxgRjRzA5qTyYs-Y:after{border-right:0}._3EWd0zwU6oxDkqF808cbIR._2isXzdyoeyPew61lAdXl6g>._1ESAZGbxgRjRzA5qTyYs-Y,._3EWd0zwU6oxDkqF808cbIR._2isXzdyoeyPew61lAdXl6g>._3BcPw7hinJJuDjuT9JfPUg,._3ftSq04uq93bpiWh57I9Vo._2isXzdyoeyPew61lAdXl6g>._1ESAZGbxgRjRzA5qTyYs-Y,._3ftSq04uq93bpiWh57I9Vo._2isXzdyoeyPew61lAdXl6g>._3BcPw7hinJJuDjuT9JfPUg,.WOHun4LhPxwfBNb0rC3sU._2isXzdyoeyPew61lAdXl6g>._1ESAZGbxgRjRzA5qTyYs-Y,.WOHun4LhPxwfBNb0rC3sU._2isXzdyoeyPew61lAdXl6g>._3BcPw7hinJJuDjuT9JfPUg{transform-origin:0 0}.Q1GfZQgyTHhXX0UX8MShJ._2isXzdyoeyPew61lAdXl6g{min-width:114px}._1ESAZGbxgRjRzA5qTyYs-Y,._3dAM_Z_DQGVNEBKvNI9u8a{position:relative;display:block;margin:0;padding:0 20px;white-space:nowrap;cursor:pointer;transition:color .3s cubic-bezier(.645,.045,.355,1),border-color .3s cubic-bezier(.645,.045,.355,1),background .3s cubic-bezier(.645,.045,.355,1),padding .15s cubic-bezier(.645,.045,.355,1)}._1ESAZGbxgRjRzA5qTyYs-Y ._1oZ8xlpZEg3PzGp2jMNFuZ,._3dAM_Z_DQGVNEBKvNI9u8a ._1oZ8xlpZEg3PzGp2jMNFuZ{min-width:14px;margin-right:10px;font-size:14px;transition:font-size .15s cubic-bezier(.215,.61,.355,1),margin .3s cubic-bezier(.645,.045,.355,1)}._1ESAZGbxgRjRzA5qTyYs-Y ._1oZ8xlpZEg3PzGp2jMNFuZ+span,._3dAM_Z_DQGVNEBKvNI9u8a ._1oZ8xlpZEg3PzGp2jMNFuZ+span{opacity:1;transition:opacity .3s cubic-bezier(.645,.045,.355,1),width .3s cubic-bezier(.645,.045,.355,1)}._1gsorLwjR7Y-PP5FFI3vP->._3T4oh7v3sba_RR2t4uNG9h{height:1px;margin:1px 0;padding:0;overflow:hidden;line-height:0;background-color:#e8e8e8}.WAPKMTUI_Hk9mA4J4IFPT{position:absolute;z-index:1050;background:#fff;border-radius:4px}.WAPKMTUI_Hk9mA4J4IFPT .O9AtCCymWBk8w95YsjiS-{padding-right:20px}.WAPKMTUI_Hk9mA4J4IFPT:before{position:absolute;top:-7px;right:0;bottom:0;left:0;opacity:.0001;content:\" \"}._3BcPw7hinJJuDjuT9JfPUg>._1gsorLwjR7Y-PP5FFI3vP-{background-color:#fff;border-radius:4px}._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a:after{transition:transform .3s cubic-bezier(.645,.045,.355,1)}._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR,._2CWDqxw4SOV9Loi-h_t5rE>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR,._2YkuSA_GOKqO2crM-2UsUB>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR,._3J025srdIEZB3tu67p8Ez>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR{position:absolute;top:50%;right:16px;width:10px;transition:transform .3s cubic-bezier(.645,.045,.355,1)}._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before,._2CWDqxw4SOV9Loi-h_t5rE>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._2CWDqxw4SOV9Loi-h_t5rE>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before,._2YkuSA_GOKqO2crM-2UsUB>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._2YkuSA_GOKqO2crM-2UsUB>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before,._3J025srdIEZB3tu67p8Ez>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._3J025srdIEZB3tu67p8Ez>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before{position:absolute;width:6px;height:1.5px;background:#fff;background:rgba(0,0,0,.65)\\9;background-image:linear-gradient(90deg,rgba(0,0,0,.65),rgba(0,0,0,.65));background-image:none\\9;border-radius:2px;transition:background .3s cubic-bezier(.645,.045,.355,1),transform .3s cubic-bezier(.645,.045,.355,1),top .3s cubic-bezier(.645,.045,.355,1);content:\"\"}._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before,._2CWDqxw4SOV9Loi-h_t5rE>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before,._2YkuSA_GOKqO2crM-2UsUB>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before,._3J025srdIEZB3tu67p8Ez>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before{transform:rotate(45deg) translateY(-2px)}._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._2CWDqxw4SOV9Loi-h_t5rE>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._2YkuSA_GOKqO2crM-2UsUB>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._3J025srdIEZB3tu67p8Ez>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after{transform:rotate(-45deg) translateY(2px)}._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a:hover ._1Y5fBL6Y_SRm9X7GYivBvR:after,._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a:hover ._1Y5fBL6Y_SRm9X7GYivBvR:before,._2CWDqxw4SOV9Loi-h_t5rE>._3dAM_Z_DQGVNEBKvNI9u8a:hover ._1Y5fBL6Y_SRm9X7GYivBvR:after,._2CWDqxw4SOV9Loi-h_t5rE>._3dAM_Z_DQGVNEBKvNI9u8a:hover ._1Y5fBL6Y_SRm9X7GYivBvR:before,._2YkuSA_GOKqO2crM-2UsUB>._3dAM_Z_DQGVNEBKvNI9u8a:hover ._1Y5fBL6Y_SRm9X7GYivBvR:after,._2YkuSA_GOKqO2crM-2UsUB>._3dAM_Z_DQGVNEBKvNI9u8a:hover ._1Y5fBL6Y_SRm9X7GYivBvR:before,._3J025srdIEZB3tu67p8Ez>._3dAM_Z_DQGVNEBKvNI9u8a:hover ._1Y5fBL6Y_SRm9X7GYivBvR:after,._3J025srdIEZB3tu67p8Ez>._3dAM_Z_DQGVNEBKvNI9u8a:hover ._1Y5fBL6Y_SRm9X7GYivBvR:before{background:linear-gradient(90deg,#1890ff,#1890ff)}._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before{transform:rotate(-45deg) translateX(2px)}._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after{transform:rotate(45deg) translateX(-2px)}._1MGPj4VxN-efhYLU1mnVAl._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR{transform:translateY(-2px)}._1MGPj4VxN-efhYLU1mnVAl._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after{transform:rotate(-45deg) translateX(-2px)}._1MGPj4VxN-efhYLU1mnVAl._1vBG_YDrLvGi02vtpeBxyx>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before{transform:rotate(45deg) translateX(2px)}._3EWd0zwU6oxDkqF808cbIR ._1zhiBd1wp4s94gkbQup87S,._3EWd0zwU6oxDkqF808cbIR ._1zhiBd1wp4s94gkbQup87S>a,._3ftSq04uq93bpiWh57I9Vo ._1zhiBd1wp4s94gkbQup87S,._3ftSq04uq93bpiWh57I9Vo ._1zhiBd1wp4s94gkbQup87S>a,.WOHun4LhPxwfBNb0rC3sU ._1zhiBd1wp4s94gkbQup87S,.WOHun4LhPxwfBNb0rC3sU ._1zhiBd1wp4s94gkbQup87S>a{color:#1890ff}.Q1GfZQgyTHhXX0UX8MShJ{line-height:46px;white-space:nowrap;border:0;border-bottom:1px solid #e8e8e8;box-shadow:none}.Q1GfZQgyTHhXX0UX8MShJ>._1ESAZGbxgRjRzA5qTyYs-Y,.Q1GfZQgyTHhXX0UX8MShJ>._3BcPw7hinJJuDjuT9JfPUg{position:relative;top:1px;display:inline-block;vertical-align:bottom;border-bottom:2px solid transparent}.Q1GfZQgyTHhXX0UX8MShJ>._1ESAZGbxgRjRzA5qTyYs-Y:hover,.Q1GfZQgyTHhXX0UX8MShJ>._1MGPj4VxN-efhYLU1mnVAl,.Q1GfZQgyTHhXX0UX8MShJ>._1zhiBd1wp4s94gkbQup87S,.Q1GfZQgyTHhXX0UX8MShJ>._3BcPw7hinJJuDjuT9JfPUg:hover,.Q1GfZQgyTHhXX0UX8MShJ>._16orcnJPiaH5JUK2ngYnV9,.Q1GfZQgyTHhXX0UX8MShJ>.dwnijamx0-ohAJnp60ba0,.Q1GfZQgyTHhXX0UX8MShJ>.oE21jcqOwgX-DcXvE86IB,.Q1GfZQgyTHhXX0UX8MShJ>.PT2mTdhhT0GI2f7YtLC2H{color:#1890ff;border-bottom:2px solid #1890ff}.Q1GfZQgyTHhXX0UX8MShJ>._1ESAZGbxgRjRzA5qTyYs-Y>a{display:block;color:rgba(0,0,0,.65)}.Q1GfZQgyTHhXX0UX8MShJ>._1ESAZGbxgRjRzA5qTyYs-Y>a:hover{color:#1890ff}.Q1GfZQgyTHhXX0UX8MShJ>._1ESAZGbxgRjRzA5qTyYs-Y>a:before{bottom:-2px}.Q1GfZQgyTHhXX0UX8MShJ>._16orcnJPiaH5JUK2ngYnV9>a{color:#1890ff}.Q1GfZQgyTHhXX0UX8MShJ:after{display:block;clear:both;height:0;content:\" \"}._3EWd0zwU6oxDkqF808cbIR ._1ESAZGbxgRjRzA5qTyYs-Y,._3ftSq04uq93bpiWh57I9Vo ._1ESAZGbxgRjRzA5qTyYs-Y,._3IjzvPAJhP9Gw7HdqzdhUB ._1ESAZGbxgRjRzA5qTyYs-Y,.WOHun4LhPxwfBNb0rC3sU ._1ESAZGbxgRjRzA5qTyYs-Y{position:relative}._3EWd0zwU6oxDkqF808cbIR ._1ESAZGbxgRjRzA5qTyYs-Y:after,._3ftSq04uq93bpiWh57I9Vo ._1ESAZGbxgRjRzA5qTyYs-Y:after,._3IjzvPAJhP9Gw7HdqzdhUB ._1ESAZGbxgRjRzA5qTyYs-Y:after,.WOHun4LhPxwfBNb0rC3sU ._1ESAZGbxgRjRzA5qTyYs-Y:after{position:absolute;top:0;right:0;bottom:0;border-right:3px solid #1890ff;transform:scaleY(.0001);opacity:0;transition:transform .15s cubic-bezier(.215,.61,.355,1),opacity .15s cubic-bezier(.215,.61,.355,1);content:\"\"}._3EWd0zwU6oxDkqF808cbIR ._1ESAZGbxgRjRzA5qTyYs-Y,._3EWd0zwU6oxDkqF808cbIR ._3dAM_Z_DQGVNEBKvNI9u8a,._3ftSq04uq93bpiWh57I9Vo ._1ESAZGbxgRjRzA5qTyYs-Y,._3ftSq04uq93bpiWh57I9Vo ._3dAM_Z_DQGVNEBKvNI9u8a,._3IjzvPAJhP9Gw7HdqzdhUB ._1ESAZGbxgRjRzA5qTyYs-Y,._3IjzvPAJhP9Gw7HdqzdhUB ._3dAM_Z_DQGVNEBKvNI9u8a,.WOHun4LhPxwfBNb0rC3sU ._1ESAZGbxgRjRzA5qTyYs-Y,.WOHun4LhPxwfBNb0rC3sU ._3dAM_Z_DQGVNEBKvNI9u8a{height:40px;margin-top:4px;margin-bottom:4px;padding:0 16px;overflow:hidden;font-size:14px;line-height:40px;text-overflow:ellipsis}._3EWd0zwU6oxDkqF808cbIR ._3BcPw7hinJJuDjuT9JfPUg,._3ftSq04uq93bpiWh57I9Vo ._3BcPw7hinJJuDjuT9JfPUg,._3IjzvPAJhP9Gw7HdqzdhUB ._3BcPw7hinJJuDjuT9JfPUg,.WOHun4LhPxwfBNb0rC3sU ._3BcPw7hinJJuDjuT9JfPUg{padding-bottom:.02px}._3EWd0zwU6oxDkqF808cbIR ._1ESAZGbxgRjRzA5qTyYs-Y:not(:last-child),._3ftSq04uq93bpiWh57I9Vo ._1ESAZGbxgRjRzA5qTyYs-Y:not(:last-child),._3IjzvPAJhP9Gw7HdqzdhUB ._1ESAZGbxgRjRzA5qTyYs-Y:not(:last-child),.WOHun4LhPxwfBNb0rC3sU ._1ESAZGbxgRjRzA5qTyYs-Y:not(:last-child){margin-bottom:8px}._3EWd0zwU6oxDkqF808cbIR>._1ESAZGbxgRjRzA5qTyYs-Y,._3EWd0zwU6oxDkqF808cbIR>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a,._3ftSq04uq93bpiWh57I9Vo>._1ESAZGbxgRjRzA5qTyYs-Y,._3ftSq04uq93bpiWh57I9Vo>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a,._3IjzvPAJhP9Gw7HdqzdhUB>._1ESAZGbxgRjRzA5qTyYs-Y,._3IjzvPAJhP9Gw7HdqzdhUB>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a,.WOHun4LhPxwfBNb0rC3sU>._1ESAZGbxgRjRzA5qTyYs-Y,.WOHun4LhPxwfBNb0rC3sU>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a{height:40px;line-height:40px}._3IjzvPAJhP9Gw7HdqzdhUB{width:100%}._3IjzvPAJhP9Gw7HdqzdhUB ._16orcnJPiaH5JUK2ngYnV9:after,._3IjzvPAJhP9Gw7HdqzdhUB ._143NCKkX4lYA3A2UIyU5KI:after{transform:scaleY(1);opacity:1;transition:transform .15s cubic-bezier(.645,.045,.355,1),opacity .15s cubic-bezier(.645,.045,.355,1)}._3IjzvPAJhP9Gw7HdqzdhUB ._1ESAZGbxgRjRzA5qTyYs-Y,._3IjzvPAJhP9Gw7HdqzdhUB ._3dAM_Z_DQGVNEBKvNI9u8a{width:calc(100% + 1px)}._3IjzvPAJhP9Gw7HdqzdhUB ._3dAM_Z_DQGVNEBKvNI9u8a{padding-right:34px}._1ih_HLExz1LDeD59xnmVMk{width:80px}._1ih_HLExz1LDeD59xnmVMk>._1ESAZGbxgRjRzA5qTyYs-Y,._1ih_HLExz1LDeD59xnmVMk>._2JvqVVWSSTUbd_UwKeVWXN>._3l-h5c2Iw_PQ_SyX0mu58h>._1ESAZGbxgRjRzA5qTyYs-Y,._1ih_HLExz1LDeD59xnmVMk>._2JvqVVWSSTUbd_UwKeVWXN>._3l-h5c2Iw_PQ_SyX0mu58h>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a,._1ih_HLExz1LDeD59xnmVMk>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a{left:0;padding:0 32px!important;text-overflow:clip}._1ih_HLExz1LDeD59xnmVMk>._1ESAZGbxgRjRzA5qTyYs-Y ._1Y5fBL6Y_SRm9X7GYivBvR,._1ih_HLExz1LDeD59xnmVMk>._2JvqVVWSSTUbd_UwKeVWXN>._3l-h5c2Iw_PQ_SyX0mu58h>._1ESAZGbxgRjRzA5qTyYs-Y ._1Y5fBL6Y_SRm9X7GYivBvR,._1ih_HLExz1LDeD59xnmVMk>._2JvqVVWSSTUbd_UwKeVWXN>._3l-h5c2Iw_PQ_SyX0mu58h>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR,._1ih_HLExz1LDeD59xnmVMk>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR{display:none}._1ih_HLExz1LDeD59xnmVMk>._1ESAZGbxgRjRzA5qTyYs-Y ._1oZ8xlpZEg3PzGp2jMNFuZ,._1ih_HLExz1LDeD59xnmVMk>._2JvqVVWSSTUbd_UwKeVWXN>._3l-h5c2Iw_PQ_SyX0mu58h>._1ESAZGbxgRjRzA5qTyYs-Y ._1oZ8xlpZEg3PzGp2jMNFuZ,._1ih_HLExz1LDeD59xnmVMk>._2JvqVVWSSTUbd_UwKeVWXN>._3l-h5c2Iw_PQ_SyX0mu58h>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a ._1oZ8xlpZEg3PzGp2jMNFuZ,._1ih_HLExz1LDeD59xnmVMk>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a ._1oZ8xlpZEg3PzGp2jMNFuZ{margin:0;font-size:16px;line-height:40px}._1ih_HLExz1LDeD59xnmVMk>._1ESAZGbxgRjRzA5qTyYs-Y ._1oZ8xlpZEg3PzGp2jMNFuZ+span,._1ih_HLExz1LDeD59xnmVMk>._2JvqVVWSSTUbd_UwKeVWXN>._3l-h5c2Iw_PQ_SyX0mu58h>._1ESAZGbxgRjRzA5qTyYs-Y ._1oZ8xlpZEg3PzGp2jMNFuZ+span,._1ih_HLExz1LDeD59xnmVMk>._2JvqVVWSSTUbd_UwKeVWXN>._3l-h5c2Iw_PQ_SyX0mu58h>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a ._1oZ8xlpZEg3PzGp2jMNFuZ+span,._1ih_HLExz1LDeD59xnmVMk>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a ._1oZ8xlpZEg3PzGp2jMNFuZ+span{display:inline-block;max-width:0;opacity:0}._2wQMxkdPCUP2hU6Pr7JcEk{pointer-events:none}._2wQMxkdPCUP2hU6Pr7JcEk ._1oZ8xlpZEg3PzGp2jMNFuZ{display:none}._2wQMxkdPCUP2hU6Pr7JcEk a{color:hsla(0,0%,100%,.85)}._1ih_HLExz1LDeD59xnmVMk .xKQZCrIheuJ0Z14CTOZsC{padding-right:4px;padding-left:4px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._3l-h5c2Iw_PQ_SyX0mu58h{margin:0;padding:0}._3l-h5c2Iw_PQ_SyX0mu58h ._1ESAZGbxgRjRzA5qTyYs-Y,._3l-h5c2Iw_PQ_SyX0mu58h ._3dAM_Z_DQGVNEBKvNI9u8a{padding:0 16px 0 28px}._3W-Rjkx0adTcdM_yk8Dhlk._3EWd0zwU6oxDkqF808cbIR,._3W-Rjkx0adTcdM_yk8Dhlk._3ftSq04uq93bpiWh57I9Vo,._3W-Rjkx0adTcdM_yk8Dhlk._3IjzvPAJhP9Gw7HdqzdhUB,._3W-Rjkx0adTcdM_yk8Dhlk.WOHun4LhPxwfBNb0rC3sU{box-shadow:none}._2isXzdyoeyPew61lAdXl6g._3IjzvPAJhP9Gw7HdqzdhUB{padding:0;border:0;border-radius:0;box-shadow:none}._2isXzdyoeyPew61lAdXl6g._3IjzvPAJhP9Gw7HdqzdhUB>._1ESAZGbxgRjRzA5qTyYs-Y,._2isXzdyoeyPew61lAdXl6g._3IjzvPAJhP9Gw7HdqzdhUB>._3BcPw7hinJJuDjuT9JfPUg>._3dAM_Z_DQGVNEBKvNI9u8a{height:40px;line-height:40px;list-style-position:inside;list-style-type:disc}._2isXzdyoeyPew61lAdXl6g._3IjzvPAJhP9Gw7HdqzdhUB .xKQZCrIheuJ0Z14CTOZsC{padding-left:32px}._1xCPeWQnXwkPkiapy785rY,._3BntBC6Ew4OSK3-q_aSlBZ{color:rgba(0,0,0,.25)!important;background:none;border-color:transparent!important;cursor:not-allowed}._1xCPeWQnXwkPkiapy785rY>a,._3BntBC6Ew4OSK3-q_aSlBZ>a{color:rgba(0,0,0,.25)!important;pointer-events:none}._1xCPeWQnXwkPkiapy785rY>._3dAM_Z_DQGVNEBKvNI9u8a,._3BntBC6Ew4OSK3-q_aSlBZ>._3dAM_Z_DQGVNEBKvNI9u8a{color:rgba(0,0,0,.25)!important;cursor:not-allowed}._1xCPeWQnXwkPkiapy785rY>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._1xCPeWQnXwkPkiapy785rY>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3BntBC6Ew4OSK3-q_aSlBZ>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3BntBC6Ew4OSK3-q_aSlBZ>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before{background:rgba(0,0,0,.25)!important}._3Q93cCC1mRNguRwHX0L77,._3Q93cCC1mRNguRwHX0L77 ._2isXzdyoeyPew61lAdXl6g{color:hsla(0,0%,100%,.65);background:#001529}._3Q93cCC1mRNguRwHX0L77 ._2isXzdyoeyPew61lAdXl6g ._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR{opacity:.45;transition:all .3s}._3Q93cCC1mRNguRwHX0L77 ._2isXzdyoeyPew61lAdXl6g ._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._2isXzdyoeyPew61lAdXl6g ._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a ._1Y5fBL6Y_SRm9X7GYivBvR:before{background:#fff}._3Q93cCC1mRNguRwHX0L77.WAPKMTUI_Hk9mA4J4IFPT{background:transparent}._3Q93cCC1mRNguRwHX0L77 ._3IjzvPAJhP9Gw7HdqzdhUB._2isXzdyoeyPew61lAdXl6g{background:#000c17;box-shadow:inset 0 2px 8px rgba(0,0,0,.45)}._3Q93cCC1mRNguRwHX0L77.Q1GfZQgyTHhXX0UX8MShJ{border-bottom:0}._3Q93cCC1mRNguRwHX0L77.Q1GfZQgyTHhXX0UX8MShJ>._1ESAZGbxgRjRzA5qTyYs-Y,._3Q93cCC1mRNguRwHX0L77.Q1GfZQgyTHhXX0UX8MShJ>._3BcPw7hinJJuDjuT9JfPUg{top:0;margin-top:0;border-color:#001529;border-bottom:0}._3Q93cCC1mRNguRwHX0L77.Q1GfZQgyTHhXX0UX8MShJ>._1ESAZGbxgRjRzA5qTyYs-Y>a:before{bottom:0}._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y,._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y>a,._3Q93cCC1mRNguRwHX0L77 .xKQZCrIheuJ0Z14CTOZsC{color:hsla(0,0%,100%,.65)}._3Q93cCC1mRNguRwHX0L77._3EWd0zwU6oxDkqF808cbIR,._3Q93cCC1mRNguRwHX0L77._3ftSq04uq93bpiWh57I9Vo,._3Q93cCC1mRNguRwHX0L77._3IjzvPAJhP9Gw7HdqzdhUB,._3Q93cCC1mRNguRwHX0L77.WOHun4LhPxwfBNb0rC3sU{border-right:0}._3Q93cCC1mRNguRwHX0L77._3EWd0zwU6oxDkqF808cbIR ._1ESAZGbxgRjRzA5qTyYs-Y,._3Q93cCC1mRNguRwHX0L77._3ftSq04uq93bpiWh57I9Vo ._1ESAZGbxgRjRzA5qTyYs-Y,._3Q93cCC1mRNguRwHX0L77._3IjzvPAJhP9Gw7HdqzdhUB ._1ESAZGbxgRjRzA5qTyYs-Y,._3Q93cCC1mRNguRwHX0L77.WOHun4LhPxwfBNb0rC3sU ._1ESAZGbxgRjRzA5qTyYs-Y{left:0;margin-left:0;border-right:0}._3Q93cCC1mRNguRwHX0L77._3EWd0zwU6oxDkqF808cbIR ._1ESAZGbxgRjRzA5qTyYs-Y:after,._3Q93cCC1mRNguRwHX0L77._3ftSq04uq93bpiWh57I9Vo ._1ESAZGbxgRjRzA5qTyYs-Y:after,._3Q93cCC1mRNguRwHX0L77._3IjzvPAJhP9Gw7HdqzdhUB ._1ESAZGbxgRjRzA5qTyYs-Y:after,._3Q93cCC1mRNguRwHX0L77.WOHun4LhPxwfBNb0rC3sU ._1ESAZGbxgRjRzA5qTyYs-Y:after{border-right:0}._3Q93cCC1mRNguRwHX0L77._3IjzvPAJhP9Gw7HdqzdhUB ._1ESAZGbxgRjRzA5qTyYs-Y,._3Q93cCC1mRNguRwHX0L77._3IjzvPAJhP9Gw7HdqzdhUB ._3dAM_Z_DQGVNEBKvNI9u8a{width:100%}._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover,._3Q93cCC1mRNguRwHX0L77 ._1MGPj4VxN-efhYLU1mnVAl,._3Q93cCC1mRNguRwHX0L77 ._1zhiBd1wp4s94gkbQup87S,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a:hover,._3Q93cCC1mRNguRwHX0L77 .dwnijamx0-ohAJnp60ba0,._3Q93cCC1mRNguRwHX0L77 .PT2mTdhhT0GI2f7YtLC2H{color:#fff;background-color:transparent}._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover>a,._3Q93cCC1mRNguRwHX0L77 ._1MGPj4VxN-efhYLU1mnVAl>a,._3Q93cCC1mRNguRwHX0L77 ._1zhiBd1wp4s94gkbQup87S>a,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a:hover>a,._3Q93cCC1mRNguRwHX0L77 .dwnijamx0-ohAJnp60ba0>a,._3Q93cCC1mRNguRwHX0L77 .PT2mTdhhT0GI2f7YtLC2H>a{color:#fff}._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 ._1MGPj4VxN-efhYLU1mnVAl>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 ._1MGPj4VxN-efhYLU1mnVAl>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 ._1zhiBd1wp4s94gkbQup87S>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 ._1zhiBd1wp4s94gkbQup87S>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a:hover>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a:hover>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 .dwnijamx0-ohAJnp60ba0>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 .dwnijamx0-ohAJnp60ba0>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 .PT2mTdhhT0GI2f7YtLC2H>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR,._3Q93cCC1mRNguRwHX0L77 .PT2mTdhhT0GI2f7YtLC2H>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR{opacity:1}._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._1MGPj4VxN-efhYLU1mnVAl>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._1MGPj4VxN-efhYLU1mnVAl>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._1MGPj4VxN-efhYLU1mnVAl>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._1MGPj4VxN-efhYLU1mnVAl>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._1zhiBd1wp4s94gkbQup87S>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._1zhiBd1wp4s94gkbQup87S>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._1zhiBd1wp4s94gkbQup87S>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._1zhiBd1wp4s94gkbQup87S>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a:hover>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a:hover>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a:hover>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._3dAM_Z_DQGVNEBKvNI9u8a:hover>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 .dwnijamx0-ohAJnp60ba0>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 .dwnijamx0-ohAJnp60ba0>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 .dwnijamx0-ohAJnp60ba0>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 .dwnijamx0-ohAJnp60ba0>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 .PT2mTdhhT0GI2f7YtLC2H>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 .PT2mTdhhT0GI2f7YtLC2H>._3dAM_Z_DQGVNEBKvNI9u8a:hover>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 .PT2mTdhhT0GI2f7YtLC2H>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 .PT2mTdhhT0GI2f7YtLC2H>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before{background:#fff}._3Q93cCC1mRNguRwHX0L77 ._1ESAZGbxgRjRzA5qTyYs-Y:hover{background-color:transparent}._3Q93cCC1mRNguRwHX0L77 ._16orcnJPiaH5JUK2ngYnV9{color:#fff;border-right:0}._3Q93cCC1mRNguRwHX0L77 ._16orcnJPiaH5JUK2ngYnV9:after{border-right:0}._3Q93cCC1mRNguRwHX0L77 ._16orcnJPiaH5JUK2ngYnV9 ._1oZ8xlpZEg3PzGp2jMNFuZ,._3Q93cCC1mRNguRwHX0L77 ._16orcnJPiaH5JUK2ngYnV9 ._1oZ8xlpZEg3PzGp2jMNFuZ+span,._3Q93cCC1mRNguRwHX0L77 ._16orcnJPiaH5JUK2ngYnV9>a,._3Q93cCC1mRNguRwHX0L77 ._16orcnJPiaH5JUK2ngYnV9>a:hover{color:#fff}._1gsorLwjR7Y-PP5FFI3vP-._3Q93cCC1mRNguRwHX0L77 ._16orcnJPiaH5JUK2ngYnV9,.WAPKMTUI_Hk9mA4J4IFPT._3Q93cCC1mRNguRwHX0L77 ._16orcnJPiaH5JUK2ngYnV9{background-color:#1890ff}._3Q93cCC1mRNguRwHX0L77 ._1xCPeWQnXwkPkiapy785rY,._3Q93cCC1mRNguRwHX0L77 ._1xCPeWQnXwkPkiapy785rY>a,._3Q93cCC1mRNguRwHX0L77 ._3BntBC6Ew4OSK3-q_aSlBZ,._3Q93cCC1mRNguRwHX0L77 ._3BntBC6Ew4OSK3-q_aSlBZ>a{color:hsla(0,0%,100%,.35)!important;opacity:.8}._3Q93cCC1mRNguRwHX0L77 ._1xCPeWQnXwkPkiapy785rY>._3dAM_Z_DQGVNEBKvNI9u8a,._3Q93cCC1mRNguRwHX0L77 ._3BntBC6Ew4OSK3-q_aSlBZ>._3dAM_Z_DQGVNEBKvNI9u8a{color:hsla(0,0%,100%,.35)!important}._3Q93cCC1mRNguRwHX0L77 ._1xCPeWQnXwkPkiapy785rY>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._1xCPeWQnXwkPkiapy785rY>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before,._3Q93cCC1mRNguRwHX0L77 ._3BntBC6Ew4OSK3-q_aSlBZ>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:after,._3Q93cCC1mRNguRwHX0L77 ._3BntBC6Ew4OSK3-q_aSlBZ>._3dAM_Z_DQGVNEBKvNI9u8a>._1Y5fBL6Y_SRm9X7GYivBvR:before{background:hsla(0,0%,100%,.35)!important}._1Tu6MQRb26CR7p_E03I_FG{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;z-index:1060;display:block;max-width:250px;visibility:visible}.TFOShMvuyImtZgSt8syKF{display:none}.E6wSGyzM1d4blOHCaIeRs,.M-hyS9_NqHbGBxzfxkuDs,.pU_eV6Emdy8ysS7TfDQuO{padding-bottom:8px}._2MG_1FeaF3YOzPbWxsh6_,._9nozo3fY124EHgoU5iNSy,._34dynbm7YjucutxGZllox9{padding-left:8px}._1XY2uThBm4zij3EzPoNiI6,.aKas_kGWrh_1nhMYJhCAH,.ESTyFzjXmQgCRfbDYB9MJ{padding-top:8px}._1KHvTU6f3HvtorEqtwspuZ,._2qOhz8KPPLgKmdf0BPCW3t,._3EYLaYKvBciXBMImbcVseO{padding-right:8px}._1TIARwNdoA8WneqfND7f4Z{min-width:30px;min-height:32px;padding:6px 8px;color:#fff;text-align:left;text-decoration:none;word-wrap:break-word;background-color:rgba(0,0,0,.75);border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15)}._3r9AdFH2NW7LvCdjX_TtGQ{position:absolute;display:block;width:13.07106781px;height:13.07106781px;overflow:hidden;background:transparent;pointer-events:none}._3r9AdFH2NW7LvCdjX_TtGQ:before{position:absolute;top:0;right:0;bottom:0;left:0;display:block;width:5px;height:5px;margin:auto;background-color:rgba(0,0,0,.75);content:\"\";pointer-events:auto}.E6wSGyzM1d4blOHCaIeRs ._3r9AdFH2NW7LvCdjX_TtGQ,.M-hyS9_NqHbGBxzfxkuDs ._3r9AdFH2NW7LvCdjX_TtGQ,.pU_eV6Emdy8ysS7TfDQuO ._3r9AdFH2NW7LvCdjX_TtGQ{bottom:-5.07106781px}.E6wSGyzM1d4blOHCaIeRs ._3r9AdFH2NW7LvCdjX_TtGQ:before,.M-hyS9_NqHbGBxzfxkuDs ._3r9AdFH2NW7LvCdjX_TtGQ:before,.pU_eV6Emdy8ysS7TfDQuO ._3r9AdFH2NW7LvCdjX_TtGQ:before{box-shadow:3px 3px 7px rgba(0,0,0,.07);transform:translateY(-6.53553391px) rotate(45deg)}.M-hyS9_NqHbGBxzfxkuDs ._3r9AdFH2NW7LvCdjX_TtGQ{left:50%;transform:translateX(-50%)}.pU_eV6Emdy8ysS7TfDQuO ._3r9AdFH2NW7LvCdjX_TtGQ{left:13px}.E6wSGyzM1d4blOHCaIeRs ._3r9AdFH2NW7LvCdjX_TtGQ{right:13px}._2MG_1FeaF3YOzPbWxsh6_ ._3r9AdFH2NW7LvCdjX_TtGQ,._9nozo3fY124EHgoU5iNSy ._3r9AdFH2NW7LvCdjX_TtGQ,._34dynbm7YjucutxGZllox9 ._3r9AdFH2NW7LvCdjX_TtGQ{left:-5.07106781px}._2MG_1FeaF3YOzPbWxsh6_ ._3r9AdFH2NW7LvCdjX_TtGQ:before,._9nozo3fY124EHgoU5iNSy ._3r9AdFH2NW7LvCdjX_TtGQ:before,._34dynbm7YjucutxGZllox9 ._3r9AdFH2NW7LvCdjX_TtGQ:before{box-shadow:-3px 3px 7px rgba(0,0,0,.07);transform:translateX(6.53553391px) rotate(45deg)}._2MG_1FeaF3YOzPbWxsh6_ ._3r9AdFH2NW7LvCdjX_TtGQ{top:50%;transform:translateY(-50%)}._34dynbm7YjucutxGZllox9 ._3r9AdFH2NW7LvCdjX_TtGQ{top:5px}._9nozo3fY124EHgoU5iNSy ._3r9AdFH2NW7LvCdjX_TtGQ{bottom:5px}._1KHvTU6f3HvtorEqtwspuZ ._3r9AdFH2NW7LvCdjX_TtGQ,._2qOhz8KPPLgKmdf0BPCW3t ._3r9AdFH2NW7LvCdjX_TtGQ,._3EYLaYKvBciXBMImbcVseO ._3r9AdFH2NW7LvCdjX_TtGQ{right:-5.07106781px}._1KHvTU6f3HvtorEqtwspuZ ._3r9AdFH2NW7LvCdjX_TtGQ:before,._2qOhz8KPPLgKmdf0BPCW3t ._3r9AdFH2NW7LvCdjX_TtGQ:before,._3EYLaYKvBciXBMImbcVseO ._3r9AdFH2NW7LvCdjX_TtGQ:before{box-shadow:3px -3px 7px rgba(0,0,0,.07);transform:translateX(-6.53553391px) rotate(45deg)}._3EYLaYKvBciXBMImbcVseO ._3r9AdFH2NW7LvCdjX_TtGQ{top:50%;transform:translateY(-50%)}._1KHvTU6f3HvtorEqtwspuZ ._3r9AdFH2NW7LvCdjX_TtGQ{top:5px}._2qOhz8KPPLgKmdf0BPCW3t ._3r9AdFH2NW7LvCdjX_TtGQ{bottom:5px}._1XY2uThBm4zij3EzPoNiI6 ._3r9AdFH2NW7LvCdjX_TtGQ,.aKas_kGWrh_1nhMYJhCAH ._3r9AdFH2NW7LvCdjX_TtGQ,.ESTyFzjXmQgCRfbDYB9MJ ._3r9AdFH2NW7LvCdjX_TtGQ{top:-5.07106781px}._1XY2uThBm4zij3EzPoNiI6 ._3r9AdFH2NW7LvCdjX_TtGQ:before,.aKas_kGWrh_1nhMYJhCAH ._3r9AdFH2NW7LvCdjX_TtGQ:before,.ESTyFzjXmQgCRfbDYB9MJ ._3r9AdFH2NW7LvCdjX_TtGQ:before{box-shadow:-3px -3px 7px rgba(0,0,0,.07);transform:translateY(6.53553391px) rotate(45deg)}.ESTyFzjXmQgCRfbDYB9MJ ._3r9AdFH2NW7LvCdjX_TtGQ{left:50%;transform:translateX(-50%)}.aKas_kGWrh_1nhMYJhCAH ._3r9AdFH2NW7LvCdjX_TtGQ{left:13px}._1XY2uThBm4zij3EzPoNiI6 ._3r9AdFH2NW7LvCdjX_TtGQ{right:13px}._1gFCwxNmWft-jTsqqtoszh{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;top:-9999px;left:-9999px;z-index:1050;display:block}._1gFCwxNmWft-jTsqqtoszh:before{position:absolute;top:-7px;right:0;bottom:-7px;left:-7px;z-index:-9999;opacity:.0001;content:\" \"}._3VQudVoYnwCoUQOUCoreMH{position:relative}._3VQudVoYnwCoUQOUCoreMH ._34ecc6_SGKef4Y6JfdE_DJ>._1iI0eo9hgIxxGhx-LIu_tr{display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg)}:root ._3VQudVoYnwCoUQOUCoreMH ._34ecc6_SGKef4Y6JfdE_DJ>._1iI0eo9hgIxxGhx-LIu_tr{font-size:12px}._3VQudVoYnwCoUQOUCoreMH ._1iI0eo9hgIxxGhx-LIu_tr:before{transition:transform .2s}._1pGggFWFRlJsjj8sX10evR ._1iI0eo9hgIxxGhx-LIu_tr:before{transform:rotate(180deg)}._1EBl5JNYghpTYYVfLpNF_i,.SfVf6GOEJSW4yaWpKNrSa{display:none}._2Euw4JTvgA5SfE5HM1wNOt{position:relative;margin:0;padding:4px 0;text-align:left;list-style-type:none;background-color:#fff;background-clip:padding-box;border-radius:4px;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.15);-webkit-transform:translateZ(0)}._1iq7TyR4c8nyFYdkwnDQou{padding:5px 12px;color:rgba(0,0,0,.45);transition:all .3s}._2sW1em59EJ4GCuURKWMNL3{position:absolute;z-index:1050}._2sW1em59EJ4GCuURKWMNL3>._2Euw4JTvgA5SfE5HM1wNOt{transform-origin:0 0}._2sW1em59EJ4GCuURKWMNL3 li,._2sW1em59EJ4GCuURKWMNL3 ul{list-style:none}._2sW1em59EJ4GCuURKWMNL3 ul{margin-right:.3em;margin-left:.3em;padding:0}._30LEIIPFE7sW-LscRgxxqs,.MY2e94iH-ikkSYLcfVXzB{clear:both;margin:0;padding:5px 12px;color:rgba(0,0,0,.65);font-weight:400;font-size:14px;line-height:22px;white-space:nowrap;cursor:pointer;transition:all .3s}._30LEIIPFE7sW-LscRgxxqs>._1oZ8xlpZEg3PzGp2jMNFuZ:first-child,._30LEIIPFE7sW-LscRgxxqs>span>._1oZ8xlpZEg3PzGp2jMNFuZ:first-child,.MY2e94iH-ikkSYLcfVXzB>._1oZ8xlpZEg3PzGp2jMNFuZ:first-child,.MY2e94iH-ikkSYLcfVXzB>span>._1oZ8xlpZEg3PzGp2jMNFuZ:first-child{min-width:12px;margin-right:8px;font-size:12px}._30LEIIPFE7sW-LscRgxxqs>a,.MY2e94iH-ikkSYLcfVXzB>a{display:block;margin:-5px -12px;padding:5px 12px;color:rgba(0,0,0,.65);transition:all .3s}._1EckrVBGIb2CxI3D99cufR,._1EckrVBGIb2CxI3D99cufR>a,._2TA4JhdvUsRdRpdMaSjpgP,._2TA4JhdvUsRdRpdMaSjpgP>a{color:#1890ff;background-color:#e6f7ff}._30LEIIPFE7sW-LscRgxxqs:hover,.MY2e94iH-ikkSYLcfVXzB:hover{background-color:#e6f7ff}._2HY-OiLVufewlCSkEaMn6r,._30XkTTnhC_9i-Y2-glk-is{color:rgba(0,0,0,.25);cursor:not-allowed}._2HY-OiLVufewlCSkEaMn6r:hover,._30XkTTnhC_9i-Y2-glk-is:hover{color:rgba(0,0,0,.25);background-color:#fff;cursor:not-allowed}._2M6GQrdMonzLOTxk4FQlmf,._3ls0sVNmFK1DZihgW6vNX_{height:1px;margin:4px 0;overflow:hidden;line-height:0;background-color:#e8e8e8}._30LEIIPFE7sW-LscRgxxqs ._3BE2tevVHdJGiMaQq80CVk,.MY2e94iH-ikkSYLcfVXzB ._3BE2tevVHdJGiMaQq80CVk{position:absolute;right:8px}._30LEIIPFE7sW-LscRgxxqs ._1VM-A_Yo0DBc4IST2reETk,.MY2e94iH-ikkSYLcfVXzB ._1VM-A_Yo0DBc4IST2reETk{color:rgba(0,0,0,.45);font-style:normal;display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg)}:root ._30LEIIPFE7sW-LscRgxxqs ._1VM-A_Yo0DBc4IST2reETk,:root .MY2e94iH-ikkSYLcfVXzB ._1VM-A_Yo0DBc4IST2reETk{font-size:12px}.Xtvdw4gz1WJuNa0GKEgal{margin:0 8px;padding:0;list-style:none}._30LEIIPFE7sW-LscRgxxqs{padding-right:26px}._2d4ttuIeQvDTlZ1IfKxSNA{position:relative}._2d4ttuIeQvDTlZ1IfKxSNA>._2Euw4JTvgA5SfE5HM1wNOt{position:absolute;top:0;left:100%;min-width:100%;margin-left:4px;transform-origin:0 0}.ZAVKaPG8dKIsabKbF81mP._1f01ochO8kdDpNt3PpLDWH ._30LEIIPFE7sW-LscRgxxqs,.ZAVKaPG8dKIsabKbF81mP._1f01ochO8kdDpNt3PpLDWH ._30LEIIPFE7sW-LscRgxxqs ._1VM-A_Yo0DBc4IST2reETk{color:rgba(0,0,0,.25);background-color:#fff;cursor:not-allowed}._2qiKOgs2D_DIi_oj49fd8h ._30LEIIPFE7sW-LscRgxxqs{color:#1890ff}._1gFCwxNmWft-jTsqqtoszh._3U26mI8v1P5mnWxpeY6WGl._1d3YwZDfYeQFLL1hGNfRl9._1JwCZBfDkYBetoEohol8Q_,._1gFCwxNmWft-jTsqqtoszh._3U26mI8v1P5mnWxpeY6WGl._1d3YwZDfYeQFLL1hGNfRl9._2VPxHLU7NaMTrgMyU0k3Zn,._1gFCwxNmWft-jTsqqtoszh._3U26mI8v1P5mnWxpeY6WGl._1d3YwZDfYeQFLL1hGNfRl9.HufWwkdtfGdtVUsrb-2jQ,._1gFCwxNmWft-jTsqqtoszh._13M3iELddKrUZBZtrDutrC._1oph4ifflZofWhYZ30mQw4._1JwCZBfDkYBetoEohol8Q_,._1gFCwxNmWft-jTsqqtoszh._13M3iELddKrUZBZtrDutrC._1oph4ifflZofWhYZ30mQw4._2VPxHLU7NaMTrgMyU0k3Zn,._1gFCwxNmWft-jTsqqtoszh._13M3iELddKrUZBZtrDutrC._1oph4ifflZofWhYZ30mQw4.HufWwkdtfGdtVUsrb-2jQ{animation-name:_2lqTGgogIItpImYAn3wMQO}._1gFCwxNmWft-jTsqqtoszh._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._1mm9iS6bL9bV_9isu3YC32,._1gFCwxNmWft-jTsqqtoszh._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._2yRtIFr1xMbrLlvzgq_Nfd,._1gFCwxNmWft-jTsqqtoszh._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._3LDxNLg_q639BnjUhOIwZX,._1gFCwxNmWft-jTsqqtoszh._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._1mm9iS6bL9bV_9isu3YC32,._1gFCwxNmWft-jTsqqtoszh._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._2yRtIFr1xMbrLlvzgq_Nfd,._1gFCwxNmWft-jTsqqtoszh._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._3LDxNLg_q639BnjUhOIwZX{animation-name:_3JK1uFdxrQM9RK51sOtrar}._1gFCwxNmWft-jTsqqtoszh.nnu83yLJXtrbX26qRN8Ql.DA65YF9uBqCSmnAzuwyH._1JwCZBfDkYBetoEohol8Q_,._1gFCwxNmWft-jTsqqtoszh.nnu83yLJXtrbX26qRN8Ql.DA65YF9uBqCSmnAzuwyH._2VPxHLU7NaMTrgMyU0k3Zn,._1gFCwxNmWft-jTsqqtoszh.nnu83yLJXtrbX26qRN8Ql.DA65YF9uBqCSmnAzuwyH.HufWwkdtfGdtVUsrb-2jQ{animation-name:_2IDJAVNNcAmXsLtWbzNJtk}._1gFCwxNmWft-jTsqqtoszh._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._1mm9iS6bL9bV_9isu3YC32,._1gFCwxNmWft-jTsqqtoszh._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._2yRtIFr1xMbrLlvzgq_Nfd,._1gFCwxNmWft-jTsqqtoszh._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._3LDxNLg_q639BnjUhOIwZX{animation-name:_1F89QugyM0FQpooygKHf2k}._2aQZN3k8LaN6hSzPUd6smx>._1oZ8xlpZEg3PzGp2jMNFuZ._1iI0eo9hgIxxGhx-LIu_tr,._3ldMO81oePfDy-6A26djas>._1oZ8xlpZEg3PzGp2jMNFuZ._1iI0eo9hgIxxGhx-LIu_tr{display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg)}:root ._2aQZN3k8LaN6hSzPUd6smx>._1oZ8xlpZEg3PzGp2jMNFuZ._1iI0eo9hgIxxGhx-LIu_tr,:root ._3ldMO81oePfDy-6A26djas>._1oZ8xlpZEg3PzGp2jMNFuZ._1iI0eo9hgIxxGhx-LIu_tr{font-size:12px}._1XKK0Rka3T4D4KNd0Cjs6J{white-space:nowrap}._1XKK0Rka3T4D4KNd0Cjs6J._351ag-o1wnW8fFXVy1ny9i>._34ecc6_SGKef4Y6JfdE_DJ:last-child:not(:first-child){padding-right:8px;padding-left:8px}._1XKK0Rka3T4D4KNd0Cjs6J ._1oZ8xlpZEg3PzGp2jMNFuZ._1iI0eo9hgIxxGhx-LIu_tr{display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg)}:root ._1XKK0Rka3T4D4KNd0Cjs6J ._1oZ8xlpZEg3PzGp2jMNFuZ._1iI0eo9hgIxxGhx-LIu_tr{font-size:12px}._1-UeUlX9_YkldTxzS2RuAT,._1-UeUlX9_YkldTxzS2RuAT ._2Euw4JTvgA5SfE5HM1wNOt{background:#001529}._1-UeUlX9_YkldTxzS2RuAT ._30LEIIPFE7sW-LscRgxxqs,._1-UeUlX9_YkldTxzS2RuAT ._30LEIIPFE7sW-LscRgxxqs ._3BE2tevVHdJGiMaQq80CVk:after,._1-UeUlX9_YkldTxzS2RuAT .MY2e94iH-ikkSYLcfVXzB,._1-UeUlX9_YkldTxzS2RuAT .MY2e94iH-ikkSYLcfVXzB ._3BE2tevVHdJGiMaQq80CVk:after,._1-UeUlX9_YkldTxzS2RuAT .MY2e94iH-ikkSYLcfVXzB>a,._1-UeUlX9_YkldTxzS2RuAT .MY2e94iH-ikkSYLcfVXzB>a ._3BE2tevVHdJGiMaQq80CVk:after{color:hsla(0,0%,100%,.65)}._1-UeUlX9_YkldTxzS2RuAT ._30LEIIPFE7sW-LscRgxxqs:hover,._1-UeUlX9_YkldTxzS2RuAT .MY2e94iH-ikkSYLcfVXzB:hover,._1-UeUlX9_YkldTxzS2RuAT .MY2e94iH-ikkSYLcfVXzB>a:hover{color:#fff;background:transparent}._1-UeUlX9_YkldTxzS2RuAT ._1EckrVBGIb2CxI3D99cufR,._1-UeUlX9_YkldTxzS2RuAT ._1EckrVBGIb2CxI3D99cufR:hover,._1-UeUlX9_YkldTxzS2RuAT ._1EckrVBGIb2CxI3D99cufR>a{color:#fff;background:#1890ff}._2cqq6gGvlUzyAwbnDsHRw_{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";border-top:1px solid #d9d9d9;outline:none}._1cNj85ZY8m7JAcdkxJ6Uc5._1u32yfEqKH7A5xGm-BlBtd{min-width:90px}._1cNj85ZY8m7JAcdkxJ6Uc5._1u32yfEqKH7A5xGm-BlBtd._3K8GmBeFUGeCVgLy-2eY0s{min-width:70px}._1cNj85ZY8m7JAcdkxJ6Uc5._2tnOjzCVgd6nQhHCEP_Bdz{min-width:80px;margin-left:8px}._1cNj85ZY8m7JAcdkxJ6Uc5._2tnOjzCVgd6nQhHCEP_Bdz._3K8GmBeFUGeCVgLy-2eY0s{min-width:70px}._2R7PxvTC3QZp6YcPegfiC{padding:11px 16px 11px 0;text-align:right}._2R7PxvTC3QZp6YcPegfiC .WN7Z6DPhqHkerTCyV7wdv{text-align:left}._2R7PxvTC3QZp6YcPegfiC .seEQkePeVORSE6FMzHzlp{margin-left:8px;text-align:left}._2R7PxvTC3QZp6YcPegfiC label._1lPFp3D5ac-kn6XW3Nuw-v{height:22px;padding:0 10px;line-height:20px}._3YzNXU1NG8RH-osX7fWWks{position:relative;outline:none}.o52TbX2OxmwEyg454QqN1{padding:8px 12px}._2cqq6gGvlUzyAwbnDsHRw_ table{width:100%;max-width:100%;height:256px;background-color:transparent;border-collapse:collapse}._2cqq6gGvlUzyAwbnDsHRw_ table,._2cqq6gGvlUzyAwbnDsHRw_ td,._2cqq6gGvlUzyAwbnDsHRw_ th{border:0}._2cqq6gGvlUzyAwbnDsHRw_ td{position:relative}._2To-CMy4rsD8KNiErKXd-U{margin-bottom:0;border-spacing:0}._2e7HkKj9MsLhFfGv5C0133{width:33px;padding:0;line-height:18px;text-align:center}._2e7HkKj9MsLhFfGv5C0133 ._2gwDwP78PLf4-fCVWTf-uE{display:block;font-weight:400}._2ILNN5tNAAFNBnqqyiLWs8 ._2gwDwP78PLf4-fCVWTf-uE{display:none}.pvds5eydPOSpMRBTV41-4,.wtw4UxI0IvnY92IOXWx9p{text-align:center;transition:all .3s}._1SVmik3kclUZ-SArbA2mzw{display:block;width:24px;height:24px;margin:0 auto;padding:0;color:rgba(0,0,0,.65);line-height:24px;background:transparent;border-radius:2px;transition:all .3s}._1SVmik3kclUZ-SArbA2mzw:hover{background:#e6f7ff;cursor:pointer}._1SVmik3kclUZ-SArbA2mzw:active{color:#fff;background:#1890ff}._2tbotB9kBcIbkHvU4p2US4 ._1SVmik3kclUZ-SArbA2mzw{width:48px}._3m5a9E7irCYd6BXtcO7Cc0 ._1SVmik3kclUZ-SArbA2mzw,.gkXfXplPgJ-5FtPZL5Xqd ._1SVmik3kclUZ-SArbA2mzw{box-shadow:inset 0 0 0 1px #1890ff}._2MSKl-YiRN87BqjFTqHPpj ._1SVmik3kclUZ-SArbA2mzw,._3g58MG53wdGl7Kl_D5fpVM ._1SVmik3kclUZ-SArbA2mzw{color:#fff;background:#1890ff}._2xrnkBb8J5TdSbor-dWtDR ._1SVmik3kclUZ-SArbA2mzw{border-top-left-radius:4px;border-bottom-left-radius:4px}._2JeyxUVXOAx5_7gI2d-W40 ._1SVmik3kclUZ-SArbA2mzw{border-top-right-radius:4px;border-bottom-right-radius:4px}._2vn5nIHJMy9kvIW2qDrsvv ._1SVmik3kclUZ-SArbA2mzw,.Zrfj2nH7sEDoAGkDJJ4Mp ._1SVmik3kclUZ-SArbA2mzw{color:rgba(0,0,0,.25)}.ohheqNek76Wz0CHkRmBZ0{width:100%;table-layout:fixed;border-collapse:separate}._39uP4dJTtgXDtz8f_GwB46{position:absolute;bottom:-9px;left:0;width:100%}._2UOeggdNuY3_Hkc4PSL-cm{border-top:0}._2UOeggdNuY3_Hkc4PSL-cm ._3wL7W4350nN5S3amuujjuh{table-layout:fixed}._2UOeggdNuY3_Hkc4PSL-cm ._2R7PxvTC3QZp6YcPegfiC .seEQkePeVORSE6FMzHzlp{margin-left:16px}._2UOeggdNuY3_Hkc4PSL-cm ._2R7PxvTC3QZp6YcPegfiC label._1lPFp3D5ac-kn6XW3Nuw-v{height:32px;line-height:30px}._2UOeggdNuY3_Hkc4PSL-cm .pvds5eydPOSpMRBTV41-4,._2UOeggdNuY3_Hkc4PSL-cm .wtw4UxI0IvnY92IOXWx9p{display:block;height:116px;margin:0 4px;padding:4px 8px;color:rgba(0,0,0,.65);text-align:left;border-top:2px solid #e8e8e8;transition:background .3s}._2UOeggdNuY3_Hkc4PSL-cm .pvds5eydPOSpMRBTV41-4:hover,._2UOeggdNuY3_Hkc4PSL-cm .wtw4UxI0IvnY92IOXWx9p:hover{background:#e6f7ff;cursor:pointer}._2UOeggdNuY3_Hkc4PSL-cm .pvds5eydPOSpMRBTV41-4:active,._2UOeggdNuY3_Hkc4PSL-cm .wtw4UxI0IvnY92IOXWx9p:active{background:#bae7ff}._2UOeggdNuY3_Hkc4PSL-cm ._2e7HkKj9MsLhFfGv5C0133{padding-right:12px;padding-bottom:5px;text-align:right}._2UOeggdNuY3_Hkc4PSL-cm ._1SVmik3kclUZ-SArbA2mzw{width:auto;text-align:right;background:transparent}._2UOeggdNuY3_Hkc4PSL-cm .gkXfXplPgJ-5FtPZL5Xqd ._1SVmik3kclUZ-SArbA2mzw{color:rgba(0,0,0,.65)}._2UOeggdNuY3_Hkc4PSL-cm ._3m5a9E7irCYd6BXtcO7Cc0 .pvds5eydPOSpMRBTV41-4,._2UOeggdNuY3_Hkc4PSL-cm .gkXfXplPgJ-5FtPZL5Xqd .wtw4UxI0IvnY92IOXWx9p{background:transparent;border-top-color:#1890ff}._2UOeggdNuY3_Hkc4PSL-cm ._3m5a9E7irCYd6BXtcO7Cc0 ._1SVmik3kclUZ-SArbA2mzw,._2UOeggdNuY3_Hkc4PSL-cm .gkXfXplPgJ-5FtPZL5Xqd ._1SVmik3kclUZ-SArbA2mzw{box-shadow:none}._2UOeggdNuY3_Hkc4PSL-cm ._2MSKl-YiRN87BqjFTqHPpj .pvds5eydPOSpMRBTV41-4,._2UOeggdNuY3_Hkc4PSL-cm ._3g58MG53wdGl7Kl_D5fpVM .wtw4UxI0IvnY92IOXWx9p{background:#e6f7ff}._2UOeggdNuY3_Hkc4PSL-cm ._2MSKl-YiRN87BqjFTqHPpj ._1SVmik3kclUZ-SArbA2mzw,._2UOeggdNuY3_Hkc4PSL-cm ._3g58MG53wdGl7Kl_D5fpVM ._1SVmik3kclUZ-SArbA2mzw{color:#1890ff}._2UOeggdNuY3_Hkc4PSL-cm ._2vn5nIHJMy9kvIW2qDrsvv .wtw4UxI0IvnY92IOXWx9p,._2UOeggdNuY3_Hkc4PSL-cm .Zrfj2nH7sEDoAGkDJJ4Mp .wtw4UxI0IvnY92IOXWx9p{color:rgba(0,0,0,.25)}._2UOeggdNuY3_Hkc4PSL-cm ._39uP4dJTtgXDtz8f_GwB46{position:static;width:auto;height:88px;overflow-y:auto}._3JJUpg87mY_oSeADCl9YQx .wtw4UxI0IvnY92IOXWx9p,._3JJUpg87mY_oSeADCl9YQx .wtw4UxI0IvnY92IOXWx9p:hover{cursor:not-allowed}._3JJUpg87mY_oSeADCl9YQx:not(.gkXfXplPgJ-5FtPZL5Xqd) .wtw4UxI0IvnY92IOXWx9p,._3JJUpg87mY_oSeADCl9YQx:not(.gkXfXplPgJ-5FtPZL5Xqd) .wtw4UxI0IvnY92IOXWx9p:hover{background:transparent}._3JJUpg87mY_oSeADCl9YQx ._1SVmik3kclUZ-SArbA2mzw{width:auto;color:rgba(0,0,0,.25);border-radius:0;cursor:not-allowed}.seEQkePeVORSE6FMzHzlp{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block}._339craOB4NhQayjvZn9-So{margin:0;margin-right:8px}._339craOB4NhQayjvZn9-So,.VaLFWv9E50AN8gGTQnDWf{box-sizing:border-box;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;white-space:nowrap;cursor:pointer}.VaLFWv9E50AN8gGTQnDWf{margin:0;line-height:1;vertical-align:sub;outline:none}._2S9eMyrOcHrUQEJaKe0x0P:focus+._3kKfvbzNtOjpL4_RV6NNLI,._339craOB4NhQayjvZn9-So:hover .VaLFWv9E50AN8gGTQnDWf,.VaLFWv9E50AN8gGTQnDWf:hover ._3kKfvbzNtOjpL4_RV6NNLI{border-color:#1890ff}._2S9eMyrOcHrUQEJaKe0x0P:focus+._3kKfvbzNtOjpL4_RV6NNLI{box-shadow:0 0 0 3px rgba(24,144,255,.08)}._1ZLKbY7CNiodzW9lWro0dx:after{position:absolute;top:0;left:0;width:100%;height:100%;border:1px solid #1890ff;border-radius:50%;visibility:hidden;animation:_3R52qcqqD69OKUfh7yWc2K .36s ease-in-out;animation-fill-mode:both;content:\"\"}._339craOB4NhQayjvZn9-So:hover .VaLFWv9E50AN8gGTQnDWf:after,.VaLFWv9E50AN8gGTQnDWf:hover:after{visibility:visible}._3kKfvbzNtOjpL4_RV6NNLI{position:relative;top:0;left:0;display:block;width:16px;height:16px;background-color:#fff;border:1px solid #d9d9d9;border-radius:100px;transition:all .3s}._3kKfvbzNtOjpL4_RV6NNLI:after{position:absolute;top:3px;left:3px;display:table;width:8px;height:8px;background-color:#1890ff;border-top:0;border-left:0;border-radius:8px;transform:scale(0);opacity:0;transition:all .3s cubic-bezier(.78,.14,.15,.86);content:\" \"}._2S9eMyrOcHrUQEJaKe0x0P{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;cursor:pointer;opacity:0}._1ZLKbY7CNiodzW9lWro0dx ._3kKfvbzNtOjpL4_RV6NNLI{border-color:#1890ff}._1ZLKbY7CNiodzW9lWro0dx ._3kKfvbzNtOjpL4_RV6NNLI:after{transform:scale(1);opacity:1;transition:all .3s cubic-bezier(.78,.14,.15,.86)}._3CSaPMqwHT_Jd9yOrN8etH ._3kKfvbzNtOjpL4_RV6NNLI{background-color:#f5f5f5;border-color:#d9d9d9!important;cursor:not-allowed}._3CSaPMqwHT_Jd9yOrN8etH ._3kKfvbzNtOjpL4_RV6NNLI:after{background-color:rgba(0,0,0,.2)}._3CSaPMqwHT_Jd9yOrN8etH ._2S9eMyrOcHrUQEJaKe0x0P{cursor:not-allowed}._3CSaPMqwHT_Jd9yOrN8etH+span{color:rgba(0,0,0,.25);cursor:not-allowed}span.VaLFWv9E50AN8gGTQnDWf+*{padding-right:8px;padding-left:8px}._2qMwTDkVc6UvxAi-qCP1R2{position:relative;display:inline-block;height:32px;margin:0;padding:0 15px;color:rgba(0,0,0,.65);line-height:30px;background:#fff;border:1px solid #d9d9d9;border-top-width:1.02px;border-left:0;cursor:pointer;transition:color .3s,background .3s,border-color .3s}._2qMwTDkVc6UvxAi-qCP1R2 a{color:rgba(0,0,0,.65)}._2qMwTDkVc6UvxAi-qCP1R2>._1lPFp3D5ac-kn6XW3Nuw-v{display:block;width:0;height:0;margin-left:0}._18TRP7uw4o40eEYoIDVZVn ._2qMwTDkVc6UvxAi-qCP1R2{height:40px;font-size:16px;line-height:38px}._1pWF7IQ-7UFXN5zKItbY2n ._2qMwTDkVc6UvxAi-qCP1R2{height:24px;padding:0 7px;line-height:22px}._2qMwTDkVc6UvxAi-qCP1R2:not(:first-child):before{position:absolute;top:0;left:-1px;display:block;width:1px;height:100%;background-color:#d9d9d9;content:\"\"}._2qMwTDkVc6UvxAi-qCP1R2:first-child{border-left:1px solid #d9d9d9;border-radius:4px 0 0 4px}._2qMwTDkVc6UvxAi-qCP1R2:last-child{border-radius:0 4px 4px 0}._2qMwTDkVc6UvxAi-qCP1R2:first-child:last-child{border-radius:4px}._2qMwTDkVc6UvxAi-qCP1R2:hover{position:relative;color:#1890ff}._2qMwTDkVc6UvxAi-qCP1R2:focus-within{outline:3px solid rgba(24,144,255,.06)}._2qMwTDkVc6UvxAi-qCP1R2 ._3kKfvbzNtOjpL4_RV6NNLI,._2qMwTDkVc6UvxAi-qCP1R2 input[type=checkbox],._2qMwTDkVc6UvxAi-qCP1R2 input[type=radio]{width:0;height:0;opacity:0;pointer-events:none}.UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-){z-index:1;color:#1890ff;background:#fff;border-color:#1890ff;box-shadow:-1px 0 0 0 #1890ff}.UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-):before{background-color:#1890ff!important;opacity:.1}.UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-):first-child{border-color:#1890ff;box-shadow:none!important}.UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-):hover{color:#40a9ff;border-color:#40a9ff;box-shadow:-1px 0 0 0 #40a9ff}.UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-):active{color:#096dd9;border-color:#096dd9;box-shadow:-1px 0 0 0 #096dd9}.UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-):focus-within{outline:3px solid rgba(24,144,255,.06)}._3CzY727xM9zaCipjfY0QcR .UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-){color:#fff;background:#1890ff;border-color:#1890ff}._3CzY727xM9zaCipjfY0QcR .UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-):hover{color:#fff;background:#40a9ff;border-color:#40a9ff}._3CzY727xM9zaCipjfY0QcR .UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-):active{color:#fff;background:#096dd9;border-color:#096dd9}._3CzY727xM9zaCipjfY0QcR .UnuO6e6RauX05FCjHyQEr:not(._3boIHN3HMyKX4R3RhYh9U-):focus-within{outline:3px solid rgba(24,144,255,.06)}._3boIHN3HMyKX4R3RhYh9U-{cursor:not-allowed}._3boIHN3HMyKX4R3RhYh9U-,._3boIHN3HMyKX4R3RhYh9U-:first-child,._3boIHN3HMyKX4R3RhYh9U-:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9}._3boIHN3HMyKX4R3RhYh9U-:first-child{border-left-color:#d9d9d9}._3boIHN3HMyKX4R3RhYh9U-.UnuO6e6RauX05FCjHyQEr{color:#fff;background-color:#e6e6e6;border-color:#d9d9d9;box-shadow:none}@keyframes _3R52qcqqD69OKUfh7yWc2K{0%{transform:scale(1);opacity:.5}to{transform:scale(1.6);opacity:0}}@supports (-moz-appearance:meterbar) and (background-blend-mode:difference,normal){.VaLFWv9E50AN8gGTQnDWf{vertical-align:text-bottom}}._3eBgg76u0Ccgd2COddX0ZT{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;background:#fff;border-radius:2px;transition:all .3s}._21lzjKqWxaO7GxBPXL9n-b{cursor:pointer}._21lzjKqWxaO7GxBPXL9n-b:hover{border-color:rgba(0,0,0,.09);box-shadow:0 2px 8px rgba(0,0,0,.09)}.JRFxxAM3oRFScThwCdybX{border:1px solid #e8e8e8}._1WV4HeKUBVi--QVnqF4zx_{min-height:48px;margin-bottom:-1px;padding:0 24px;color:rgba(0,0,0,.85);font-weight:500;font-size:16px;background:transparent;border-bottom:1px solid #e8e8e8;border-radius:2px 2px 0 0;zoom:1}._1WV4HeKUBVi--QVnqF4zx_:after,._1WV4HeKUBVi--QVnqF4zx_:before{display:table;content:\"\"}._1WV4HeKUBVi--QVnqF4zx_:after{clear:both}._3ukLIljT58nTto1dpALOWg{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}._1i5Z1hBaX9O_9EVp5VfS33{display:inline-block;-ms-flex:1;flex:1;padding:16px 0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._1WV4HeKUBVi--QVnqF4zx_ ._1OnGhTlpcNs7IMjAgk-4Je{clear:both;margin-bottom:-17px;color:rgba(0,0,0,.65);font-weight:400;font-size:14px}._1WV4HeKUBVi--QVnqF4zx_ ._1R-OR6gDlsIGQjy8z0PZpz{border-bottom:1px solid #e8e8e8}._2qrQRNM1-VQNAC_-zkaVz4{float:right;margin-left:auto;padding:16px 0;color:rgba(0,0,0,.65);font-weight:400;font-size:14px}._1E1pVxZOj97xBgZ0VZU5Gx{padding:24px;zoom:1}._1E1pVxZOj97xBgZ0VZU5Gx:after,._1E1pVxZOj97xBgZ0VZU5Gx:before{display:table;content:\"\"}._1E1pVxZOj97xBgZ0VZU5Gx:after{clear:both}._1RwBVOcekBc7Pze50uzKoW:not(._2zEICEz6Z0t_SfnYCQ6Tl4) ._1E1pVxZOj97xBgZ0VZU5Gx{margin:-1px 0 0 -1px;padding:0}._1RXGlMFfJqsugl7p6I0a3T{float:left;width:33.33%;padding:24px;border:0;border-radius:0;box-shadow:1px 0 0 0 #e8e8e8,0 1px 0 0 #e8e8e8,1px 1px 0 0 #e8e8e8,inset 1px 0 0 0 #e8e8e8,inset 0 1px 0 0 #e8e8e8;transition:all .3s}._37GS5CUktwenqFI7kYdnAk:hover{position:relative;z-index:1;box-shadow:0 2px 8px rgba(0,0,0,.15)}._3SbGqvM0EQ_qRyFr8hNePs>._1WV4HeKUBVi--QVnqF4zx_ ._1i5Z1hBaX9O_9EVp5VfS33{min-height:32px;padding-bottom:0}._3SbGqvM0EQ_qRyFr8hNePs>._1WV4HeKUBVi--QVnqF4zx_ ._2qrQRNM1-VQNAC_-zkaVz4{padding-bottom:0}.phbVO-erProvmNGgHePd->*{display:block;width:100%}.phbVO-erProvmNGgHePd- img{border-radius:2px 2px 0 0}._2qzG9ScI4tCBJJPoEOMJyH{margin:0;padding:0;list-style:none;background:#fafafa;border-top:1px solid #e8e8e8;zoom:1}._2qzG9ScI4tCBJJPoEOMJyH:after,._2qzG9ScI4tCBJJPoEOMJyH:before{display:table;content:\"\"}._2qzG9ScI4tCBJJPoEOMJyH:after{clear:both}._2qzG9ScI4tCBJJPoEOMJyH>li{float:left;margin:12px 0;color:rgba(0,0,0,.45);text-align:center}._2qzG9ScI4tCBJJPoEOMJyH>li>span{position:relative;display:block;min-width:32px;font-size:14px;line-height:22px;cursor:pointer}._2qzG9ScI4tCBJJPoEOMJyH>li>span:hover{color:#1890ff;transition:color .3s}._2qzG9ScI4tCBJJPoEOMJyH>li>span>._1oZ8xlpZEg3PzGp2jMNFuZ,._2qzG9ScI4tCBJJPoEOMJyH>li>span a:not(._34ecc6_SGKef4Y6JfdE_DJ){display:inline-block;width:100%;color:rgba(0,0,0,.45);line-height:22px;transition:color .3s}._2qzG9ScI4tCBJJPoEOMJyH>li>span>._1oZ8xlpZEg3PzGp2jMNFuZ:hover,._2qzG9ScI4tCBJJPoEOMJyH>li>span a:not(._34ecc6_SGKef4Y6JfdE_DJ):hover{color:#1890ff}._2qzG9ScI4tCBJJPoEOMJyH>li>span>._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:16px;line-height:22px}._2qzG9ScI4tCBJJPoEOMJyH>li:not(:last-child){border-right:1px solid #e8e8e8}._3d-k6z-8AGtWpo-D4hdr9b ._1WV4HeKUBVi--QVnqF4zx_{padding:0 24px;background:#fafafa}._3d-k6z-8AGtWpo-D4hdr9b ._1i5Z1hBaX9O_9EVp5VfS33{padding:12px 0;font-size:14px}._3d-k6z-8AGtWpo-D4hdr9b ._1E1pVxZOj97xBgZ0VZU5Gx{padding:16px 24px}._3d-k6z-8AGtWpo-D4hdr9b ._2qrQRNM1-VQNAC_-zkaVz4{padding:13.5px 0}._2sMnuCkCeb-taU8jrUAxGK{margin:-4px 0;zoom:1}._2sMnuCkCeb-taU8jrUAxGK:after,._2sMnuCkCeb-taU8jrUAxGK:before{display:table;content:\"\"}._2sMnuCkCeb-taU8jrUAxGK:after{clear:both}._2oPVOuLI1faEZIHP6GFb-q{float:left;padding-right:16px}._2noT7LwO-jTfgJ9xRrlsaC{overflow:hidden}._2noT7LwO-jTfgJ9xRrlsaC>div:not(:last-child){margin-bottom:8px}.tWKitCwzQXI7IwCD05w0U{overflow:hidden;color:rgba(0,0,0,.85);font-weight:500;font-size:16px;white-space:nowrap;text-overflow:ellipsis}._16GHx9tT-t3RNdE4oBAoiu{color:rgba(0,0,0,.45)}._2zEICEz6Z0t_SfnYCQ6Tl4{overflow:hidden}._2zEICEz6Z0t_SfnYCQ6Tl4 ._1E1pVxZOj97xBgZ0VZU5Gx{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._27UKGah6FTeB3X2T42SfDj p{margin:0}._1e49Sh7YfafeJv2pNd5sz-{height:14px;margin:4px 0;background:linear-gradient(90deg,rgba(207,216,220,.2),rgba(207,216,220,.4),rgba(207,216,220,.2));background-size:600% 600%;border-radius:2px;animation:Ttllar9VkbS5J8saPz5bq 1.4s ease infinite}@keyframes Ttllar9VkbS5J8saPz5bq{0%,to{background-position:0 50%}50%{background-position:100% 50%}}._3BynWZoUhPFhrem1Mvvv1X>._1WV4HeKUBVi--QVnqF4zx_{min-height:36px;padding:0 12px;font-size:14px}._3BynWZoUhPFhrem1Mvvv1X>._1WV4HeKUBVi--QVnqF4zx_>._3ukLIljT58nTto1dpALOWg>._1i5Z1hBaX9O_9EVp5VfS33{padding:8px 0}._3BynWZoUhPFhrem1Mvvv1X>._1WV4HeKUBVi--QVnqF4zx_>._3ukLIljT58nTto1dpALOWg>._2qrQRNM1-VQNAC_-zkaVz4{padding:8px 0;font-size:14px}._3BynWZoUhPFhrem1Mvvv1X>._1E1pVxZOj97xBgZ0VZU5Gx{padding:12px}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._3ZzV-aJqOmL0uNBhkPGwT-{height:40px}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._33ktI-PDVSHr74A60u5GWJ{visibility:hidden}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._1U7fGxHtLat1LEY_EUwPvV{height:40px;margin:0;margin-right:2px;padding:0 16px;line-height:38px;background:#fafafa;border:1px solid #e8e8e8;border-radius:4px 4px 0 0;transition:all .3s cubic-bezier(.645,.045,.355,1)}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._22R41sk3pHXP2hMLqBh9Qa{height:40px;color:#1890ff;background:#fff;border-color:#e8e8e8;border-bottom:1px solid #fff}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._22R41sk3pHXP2hMLqBh9Qa:before{border-top:2px solid transparent}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._23Fb-Q7MzBvV3EoAp7d2hv{color:#1890ff;color:rgba(0,0,0,.25)}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._22Xuk4RLRCohUfIRs8d0QX{padding:0}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._3gkwYpER15L91KyMz8QdgL{margin-bottom:0}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._1U7fGxHtLat1LEY_EUwPvV .jqRIDAfirHkCVij7fbKms{width:16px;height:16px;height:14px;margin-right:-5px;margin-left:3px;overflow:hidden;color:rgba(0,0,0,.45);font-size:12px;vertical-align:middle;transition:all .3s}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._1U7fGxHtLat1LEY_EUwPvV .jqRIDAfirHkCVij7fbKms:hover{color:rgba(0,0,0,.85)}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 .lsRnyRWJaSJBwLRNuRjIC>._1wF4RouzMvIYpfgtXSjYr6,._1OnGhTlpcNs7IMjAgk-4Je._2-4jMS9FVf-Gn3DzPTlEe .lsRnyRWJaSJBwLRNuRjIC>._1wF4RouzMvIYpfgtXSjYr6{transition:none!important}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 .lsRnyRWJaSJBwLRNuRjIC>._1uYXVTo6jwgqKOtuNUahXx,._1OnGhTlpcNs7IMjAgk-4Je._2-4jMS9FVf-Gn3DzPTlEe .lsRnyRWJaSJBwLRNuRjIC>._1uYXVTo6jwgqKOtuNUahXx{overflow:hidden}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS ._1U7fGxHtLat1LEY_EUwPvV:hover ._3EEcVNYgJHJafe89WJy5Un{opacity:1}.JCkq4SHXJpx1k9_TJF9eA{line-height:45px}.JCkq4SHXJpx1k9_TJF9eA ._1XFnFZqhuU8MgHhWOE-B0p{position:relative;width:20px;height:20px;color:rgba(0,0,0,.65);font-size:12px;line-height:20px;text-align:center;border:1px solid #e8e8e8;border-radius:2px;cursor:pointer;transition:all .3s}.JCkq4SHXJpx1k9_TJF9eA ._1XFnFZqhuU8MgHhWOE-B0p:hover{color:#1890ff;border-color:#1890ff}.JCkq4SHXJpx1k9_TJF9eA ._1XFnFZqhuU8MgHhWOE-B0p svg{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}._1OnGhTlpcNs7IMjAgk-4Je._2DbxJPaCsvRhwfaIeGhzFn .JCkq4SHXJpx1k9_TJF9eA{line-height:56px}._1OnGhTlpcNs7IMjAgk-4Je._3U-NpbgPNFoNQ6XxDsDUn5 .JCkq4SHXJpx1k9_TJF9eA{line-height:37px}._1OnGhTlpcNs7IMjAgk-4Je._1_DxpzvnilPzHY_Dcro1Z5 .JCkq4SHXJpx1k9_TJF9eA{line-height:40px}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS._2aarJHtQf0VvArtYJrhLjk ._3ZzV-aJqOmL0uNBhkPGwT-,.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS.TGmIM93jplrJNGI7aZt_x ._3ZzV-aJqOmL0uNBhkPGwT-{height:100%}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS._2aarJHtQf0VvArtYJrhLjk ._1U7fGxHtLat1LEY_EUwPvV,.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS.TGmIM93jplrJNGI7aZt_x ._1U7fGxHtLat1LEY_EUwPvV{margin-bottom:8px;border-bottom:1px solid #e8e8e8}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS._2aarJHtQf0VvArtYJrhLjk ._22R41sk3pHXP2hMLqBh9Qa,.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS.TGmIM93jplrJNGI7aZt_x ._22R41sk3pHXP2hMLqBh9Qa{padding-bottom:4px}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS._2aarJHtQf0VvArtYJrhLjk ._1U7fGxHtLat1LEY_EUwPvV:last-child,.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS.TGmIM93jplrJNGI7aZt_x ._1U7fGxHtLat1LEY_EUwPvV:last-child{margin-bottom:8px}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS._2aarJHtQf0VvArtYJrhLjk ._1XFnFZqhuU8MgHhWOE-B0p,.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5 ._2ad0eyWD9eaLZ675za07RS.TGmIM93jplrJNGI7aZt_x ._1XFnFZqhuU8MgHhWOE-B0p{width:90%}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5._3G1Smum3srTH6mdpnu2ry4 ._2ad0eyWD9eaLZ675za07RS._2aarJHtQf0VvArtYJrhLjk ._3gkwYpER15L91KyMz8QdgL{margin-right:0}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5._3G1Smum3srTH6mdpnu2ry4 ._2ad0eyWD9eaLZ675za07RS._2aarJHtQf0VvArtYJrhLjk ._1U7fGxHtLat1LEY_EUwPvV{margin-right:1px;border-right:0;border-radius:4px 0 0 4px}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5._3G1Smum3srTH6mdpnu2ry4 ._2ad0eyWD9eaLZ675za07RS._2aarJHtQf0VvArtYJrhLjk ._22R41sk3pHXP2hMLqBh9Qa{margin-right:-1px;padding-right:18px}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5._3UMhiHTP1NhJpJMSJTWbS4 ._2ad0eyWD9eaLZ675za07RS.TGmIM93jplrJNGI7aZt_x ._3gkwYpER15L91KyMz8QdgL{margin-left:0}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5._3UMhiHTP1NhJpJMSJTWbS4 ._2ad0eyWD9eaLZ675za07RS.TGmIM93jplrJNGI7aZt_x ._1U7fGxHtLat1LEY_EUwPvV{margin-left:1px;border-left:0;border-radius:0 4px 4px 0}.HYHb92nfc4QOFwO6dTq-Z._1_DxpzvnilPzHY_Dcro1Z5._3UMhiHTP1NhJpJMSJTWbS4 ._2ad0eyWD9eaLZ675za07RS.TGmIM93jplrJNGI7aZt_x ._22R41sk3pHXP2hMLqBh9Qa{margin-left:-1px;padding-left:18px}._1OnGhTlpcNs7IMjAgk-4Je ._2ad0eyWD9eaLZ675za07RS._2sOqAIfMsQojVdl1T8tM4P ._1U7fGxHtLat1LEY_EUwPvV{height:auto;border-top:0;border-bottom:1px solid #e8e8e8;border-radius:0 0 4px 4px}._1OnGhTlpcNs7IMjAgk-4Je ._2ad0eyWD9eaLZ675za07RS._2sOqAIfMsQojVdl1T8tM4P ._22R41sk3pHXP2hMLqBh9Qa{padding-top:1px;padding-bottom:0;color:#1890ff}._1OnGhTlpcNs7IMjAgk-4Je{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;overflow:hidden;zoom:1}._1OnGhTlpcNs7IMjAgk-4Je:after,._1OnGhTlpcNs7IMjAgk-4Je:before{display:table;content:\"\"}._1OnGhTlpcNs7IMjAgk-4Je:after{clear:both}._33ktI-PDVSHr74A60u5GWJ{position:absolute;bottom:1px;left:0;z-index:1;box-sizing:border-box;width:0;height:2px;background-color:#1890ff;transform-origin:0 0}._1R-OR6gDlsIGQjy8z0PZpz{margin:0 0 16px;border-bottom:1px solid #e8e8e8;outline:none}._1R-OR6gDlsIGQjy8z0PZpz,._3ZzV-aJqOmL0uNBhkPGwT-{transition:padding .3s cubic-bezier(.645,.045,.355,1)}._3ZzV-aJqOmL0uNBhkPGwT-{position:relative;box-sizing:border-box;margin-bottom:-1px;overflow:hidden;font-size:14px;line-height:1.5;white-space:nowrap;zoom:1}._3ZzV-aJqOmL0uNBhkPGwT-:after,._3ZzV-aJqOmL0uNBhkPGwT-:before{display:table;content:\"\"}._3ZzV-aJqOmL0uNBhkPGwT-:after{clear:both}._1txKnEmoOnpr2R02HatsBI{padding-right:32px;padding-left:32px}._2bnZZad55BFTSev6034TCk ._2sOqAIfMsQojVdl1T8tM4P{margin-top:16px;margin-bottom:0;border-top:1px solid #e8e8e8;border-bottom:none}._2bnZZad55BFTSev6034TCk ._2sOqAIfMsQojVdl1T8tM4P ._33ktI-PDVSHr74A60u5GWJ{top:1px;bottom:auto}._2bnZZad55BFTSev6034TCk ._2sOqAIfMsQojVdl1T8tM4P ._3ZzV-aJqOmL0uNBhkPGwT-{margin-top:-1px;margin-bottom:0}._2IRFRyOtJNu0fEhEs1GCqp,._60Jp7unGw4mHSCq1yPsYI{position:absolute;z-index:2;width:0;height:100%;color:rgba(0,0,0,.45);text-align:center;background-color:transparent;border:0;cursor:pointer;opacity:0;transition:width .3s cubic-bezier(.645,.045,.355,1),opacity .3s cubic-bezier(.645,.045,.355,1),color .3s cubic-bezier(.645,.045,.355,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}._2IRFRyOtJNu0fEhEs1GCqp._2nfVsJPsW_xFhAsA-R-PP,._60Jp7unGw4mHSCq1yPsYI._2nfVsJPsW_xFhAsA-R-PP{width:32px;height:100%;opacity:1;pointer-events:auto}._2IRFRyOtJNu0fEhEs1GCqp:hover,._60Jp7unGw4mHSCq1yPsYI:hover{color:rgba(0,0,0,.65)}._1PYxffJfVM30Vnm0dgzSAY,._2TebSGEST0wuINdBUAfLRB{position:absolute;top:50%;left:50%;font-weight:700;font-style:normal;font-variant:normal;line-height:inherit;text-align:center;text-transform:none;transform:translate(-50%,-50%)}._1lUKnsRQDBFJ15mnJjAusy,._3aYmSCOkr0AujbWaRlpjvT{display:block;display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg)}:root ._1lUKnsRQDBFJ15mnJjAusy,:root ._3aYmSCOkr0AujbWaRlpjvT{font-size:12px}._1YsvNPBdmz5iTaQcTezt7Y{cursor:not-allowed}._1YsvNPBdmz5iTaQcTezt7Y,._1YsvNPBdmz5iTaQcTezt7Y:hover{color:rgba(0,0,0,.25)}._2IRFRyOtJNu0fEhEs1GCqp{right:2px}._60Jp7unGw4mHSCq1yPsYI{left:0}:root ._60Jp7unGw4mHSCq1yPsYI{filter:none}._3gkwYpER15L91KyMz8QdgL{margin-bottom:-1px;overflow:hidden}._2dKI9ANRPyk6dOxcvtp6Wa{overflow:hidden;white-space:nowrap}.dtwF9ntXFX2e9pB4KtnpO{position:relative;display:inline-block;box-sizing:border-box;margin:0;padding-left:0;list-style:none;transition:transform .3s cubic-bezier(.645,.045,.355,1)}.dtwF9ntXFX2e9pB4KtnpO:after,.dtwF9ntXFX2e9pB4KtnpO:before{display:table;content:\" \"}.dtwF9ntXFX2e9pB4KtnpO:after{clear:both}.dtwF9ntXFX2e9pB4KtnpO ._1U7fGxHtLat1LEY_EUwPvV{position:relative;display:inline-block;box-sizing:border-box;height:100%;margin:0 32px 0 0;padding:12px 16px;text-decoration:none;cursor:pointer;transition:color .3s cubic-bezier(.645,.045,.355,1)}.dtwF9ntXFX2e9pB4KtnpO ._1U7fGxHtLat1LEY_EUwPvV:before{position:absolute;top:-1px;left:0;width:100%;border-top:2px solid transparent;border-radius:4px 4px 0 0;transition:all .3s;content:\"\";pointer-events:none}.dtwF9ntXFX2e9pB4KtnpO ._1U7fGxHtLat1LEY_EUwPvV:last-child{margin-right:0}.dtwF9ntXFX2e9pB4KtnpO ._1U7fGxHtLat1LEY_EUwPvV:hover{color:#40a9ff}.dtwF9ntXFX2e9pB4KtnpO ._1U7fGxHtLat1LEY_EUwPvV:active{color:#096dd9}.dtwF9ntXFX2e9pB4KtnpO ._1U7fGxHtLat1LEY_EUwPvV ._1oZ8xlpZEg3PzGp2jMNFuZ{margin-right:8px}.dtwF9ntXFX2e9pB4KtnpO ._22R41sk3pHXP2hMLqBh9Qa{color:#1890ff;font-weight:500}.dtwF9ntXFX2e9pB4KtnpO ._23Fb-Q7MzBvV3EoAp7d2hv,.dtwF9ntXFX2e9pB4KtnpO ._23Fb-Q7MzBvV3EoAp7d2hv:hover{color:rgba(0,0,0,.25);cursor:not-allowed}._1OnGhTlpcNs7IMjAgk-4Je ._9Mb5ippZgxTfAFbZ67b-V ._3ZzV-aJqOmL0uNBhkPGwT-{font-size:16px}._1OnGhTlpcNs7IMjAgk-4Je ._9Mb5ippZgxTfAFbZ67b-V ._1U7fGxHtLat1LEY_EUwPvV{padding:16px}._1OnGhTlpcNs7IMjAgk-4Je ._2E_NsX3k-VRlcvJLnklBBL ._3ZzV-aJqOmL0uNBhkPGwT-{font-size:14px}._1OnGhTlpcNs7IMjAgk-4Je ._2E_NsX3k-VRlcvJLnklBBL ._1U7fGxHtLat1LEY_EUwPvV{padding:8px 16px}._1GlhGAAmiPBMhkQ3dDBBco:before{display:block;overflow:hidden;content:\"\"}._1OnGhTlpcNs7IMjAgk-4Je ._1iV-CbId1KBB3PF1aRiTDp,._1OnGhTlpcNs7IMjAgk-4Je .iOXQJpHkJ4rLGQUq46Itr{width:100%}._1OnGhTlpcNs7IMjAgk-4Je ._1iV-CbId1KBB3PF1aRiTDp>._1wF4RouzMvIYpfgtXSjYr6,._1OnGhTlpcNs7IMjAgk-4Je .iOXQJpHkJ4rLGQUq46Itr>._1wF4RouzMvIYpfgtXSjYr6{-ms-flex-negative:0;flex-shrink:0;width:100%;-webkit-backface-visibility:hidden;opacity:1;transition:opacity .45s}._1OnGhTlpcNs7IMjAgk-4Je ._1iV-CbId1KBB3PF1aRiTDp>._1uYXVTo6jwgqKOtuNUahXx,._1OnGhTlpcNs7IMjAgk-4Je .iOXQJpHkJ4rLGQUq46Itr>._1uYXVTo6jwgqKOtuNUahXx{height:0;padding:0!important;overflow:hidden;opacity:0;pointer-events:none}._1OnGhTlpcNs7IMjAgk-4Je ._1iV-CbId1KBB3PF1aRiTDp>._1uYXVTo6jwgqKOtuNUahXx input,._1OnGhTlpcNs7IMjAgk-4Je .iOXQJpHkJ4rLGQUq46Itr>._1uYXVTo6jwgqKOtuNUahXx input{visibility:hidden}._1OnGhTlpcNs7IMjAgk-4Je ._1iV-CbId1KBB3PF1aRiTDp._3Mpk2VcnH9Y-AtTP9aKcOx,._1OnGhTlpcNs7IMjAgk-4Je .iOXQJpHkJ4rLGQUq46Itr._3Mpk2VcnH9Y-AtTP9aKcOx{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;transition:margin-left .3s cubic-bezier(.645,.045,.355,1);will-change:margin-left}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x{height:100%;border-bottom:0}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._2nfVsJPsW_xFhAsA-R-PP,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._2nfVsJPsW_xFhAsA-R-PP{width:100%;height:32px}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._1U7fGxHtLat1LEY_EUwPvV,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._1U7fGxHtLat1LEY_EUwPvV{display:block;float:none;margin:0 0 16px;padding:8px 24px}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._1U7fGxHtLat1LEY_EUwPvV:last-child,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._1U7fGxHtLat1LEY_EUwPvV:last-child{margin-bottom:0}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk .JCkq4SHXJpx1k9_TJF9eA,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x .JCkq4SHXJpx1k9_TJF9eA{text-align:center}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._2dKI9ANRPyk6dOxcvtp6Wa,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._2dKI9ANRPyk6dOxcvtp6Wa{width:auto}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._3gkwYpER15L91KyMz8QdgL,._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._3ZzV-aJqOmL0uNBhkPGwT-,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._3gkwYpER15L91KyMz8QdgL,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._3ZzV-aJqOmL0uNBhkPGwT-{height:100%}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._3ZzV-aJqOmL0uNBhkPGwT-,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._3ZzV-aJqOmL0uNBhkPGwT-{margin-bottom:0}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._3ZzV-aJqOmL0uNBhkPGwT-._1txKnEmoOnpr2R02HatsBI,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._3ZzV-aJqOmL0uNBhkPGwT-._1txKnEmoOnpr2R02HatsBI{padding:32px 0}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._3gkwYpER15L91KyMz8QdgL,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._3gkwYpER15L91KyMz8QdgL{margin-bottom:0}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk .dtwF9ntXFX2e9pB4KtnpO,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x .dtwF9ntXFX2e9pB4KtnpO{width:100%}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._33ktI-PDVSHr74A60u5GWJ,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._33ktI-PDVSHr74A60u5GWJ{top:0;bottom:auto;left:auto;width:2px;height:0}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._2IRFRyOtJNu0fEhEs1GCqp,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._2IRFRyOtJNu0fEhEs1GCqp{right:0;bottom:0;width:100%;height:32px}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._60Jp7unGw4mHSCq1yPsYI,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._60Jp7unGw4mHSCq1yPsYI{top:0;width:100%;height:32px}._1OnGhTlpcNs7IMjAgk-4Je ._3ktsnR-KDjnZ4MCcqMb7rN,._1OnGhTlpcNs7IMjAgk-4Je .naGrAWn5YwRZx_5twTRLR{width:auto;margin-top:0!important;overflow:hidden}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk{float:left;margin-right:-1px;margin-bottom:0;border-right:1px solid #e8e8e8}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._1U7fGxHtLat1LEY_EUwPvV{text-align:right}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._3gkwYpER15L91KyMz8QdgL,._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._3ZzV-aJqOmL0uNBhkPGwT-{margin-right:-1px}._1OnGhTlpcNs7IMjAgk-4Je ._2aarJHtQf0VvArtYJrhLjk ._33ktI-PDVSHr74A60u5GWJ{right:1px}._1OnGhTlpcNs7IMjAgk-4Je .naGrAWn5YwRZx_5twTRLR{padding-left:24px;border-left:1px solid #e8e8e8}._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x{float:right;margin-bottom:0;margin-left:-1px;border-left:1px solid #e8e8e8}._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._3gkwYpER15L91KyMz8QdgL,._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._3ZzV-aJqOmL0uNBhkPGwT-{margin-left:-1px}._1OnGhTlpcNs7IMjAgk-4Je .TGmIM93jplrJNGI7aZt_x ._33ktI-PDVSHr74A60u5GWJ{left:1px}._1OnGhTlpcNs7IMjAgk-4Je ._3ktsnR-KDjnZ4MCcqMb7rN{padding-right:24px;border-right:1px solid #e8e8e8}._2bnZZad55BFTSev6034TCk ._2koerhzTFsbOLR3waV9irJ,._30L6q_HJDR7EGF7o3o2ZpF ._2koerhzTFsbOLR3waV9irJ{transition:transform .3s cubic-bezier(.645,.045,.355,1),width .2s cubic-bezier(.645,.045,.355,1),left .3s cubic-bezier(.645,.045,.355,1)}._3G1Smum3srTH6mdpnu2ry4 ._2koerhzTFsbOLR3waV9irJ,._3UMhiHTP1NhJpJMSJTWbS4 ._2koerhzTFsbOLR3waV9irJ{transition:transform .3s cubic-bezier(.645,.045,.355,1),height .2s cubic-bezier(.645,.045,.355,1),top .3s cubic-bezier(.645,.045,.355,1)}._3E4Dru77qsUfne0QzYpnM4>._1GlhGAAmiPBMhkQ3dDBBco>._3Mpk2VcnH9Y-AtTP9aKcOx,.a8LENbXBCPB5QexGic0-I>._1GlhGAAmiPBMhkQ3dDBBco>._3Mpk2VcnH9Y-AtTP9aKcOx{margin-left:0!important;transform:none!important}._3E4Dru77qsUfne0QzYpnM4>._1GlhGAAmiPBMhkQ3dDBBco>._1uYXVTo6jwgqKOtuNUahXx,.a8LENbXBCPB5QexGic0-I>._1GlhGAAmiPBMhkQ3dDBBco>._1uYXVTo6jwgqKOtuNUahXx{height:0;padding:0!important;overflow:hidden;opacity:0;pointer-events:none}._3E4Dru77qsUfne0QzYpnM4>._1GlhGAAmiPBMhkQ3dDBBco>._1uYXVTo6jwgqKOtuNUahXx input,.a8LENbXBCPB5QexGic0-I>._1GlhGAAmiPBMhkQ3dDBBco>._1uYXVTo6jwgqKOtuNUahXx input{visibility:hidden}._3ktsnR-KDjnZ4MCcqMb7rN>._3Mpk2VcnH9Y-AtTP9aKcOx,.naGrAWn5YwRZx_5twTRLR>._3Mpk2VcnH9Y-AtTP9aKcOx{margin-left:0!important;transform:none!important}._3ktsnR-KDjnZ4MCcqMb7rN>._1uYXVTo6jwgqKOtuNUahXx,.naGrAWn5YwRZx_5twTRLR>._1uYXVTo6jwgqKOtuNUahXx{height:0;padding:0!important;overflow:hidden;opacity:0;pointer-events:none}._3ktsnR-KDjnZ4MCcqMb7rN>._1uYXVTo6jwgqKOtuNUahXx input,.naGrAWn5YwRZx_5twTRLR>._1uYXVTo6jwgqKOtuNUahXx input{visibility:hidden}._2RAEhgJ-n3VhxwqwabwZ95{position:relative;height:auto;margin-right:0;margin-left:0;zoom:1;display:block;box-sizing:border-box}._2RAEhgJ-n3VhxwqwabwZ95:after,._2RAEhgJ-n3VhxwqwabwZ95:before{display:table;content:\"\"}._2RAEhgJ-n3VhxwqwabwZ95+._2RAEhgJ-n3VhxwqwabwZ95:before,._2RAEhgJ-n3VhxwqwabwZ95:after{clear:both}._2Ph9ciDmPpC3Ep3Dk_B0VL{-ms-flex-flow:row wrap;flex-flow:row wrap}._2Ph9ciDmPpC3Ep3Dk_B0VL,._2Ph9ciDmPpC3Ep3Dk_B0VL:after,._2Ph9ciDmPpC3Ep3Dk_B0VL:before{display:-ms-flexbox;display:flex}._3tFUMNLTxdW4DItnPRcSZC{-ms-flex-pack:start;justify-content:flex-start}._2ldw8OzCLL0Ynv_VvsivIG{-ms-flex-pack:center;justify-content:center}._3PB89KM33ieKGaQ9mUPKwH{-ms-flex-pack:end;justify-content:flex-end}._3PiQl6MYi1qMOUsoFC6uCA{-ms-flex-pack:justify;justify-content:space-between}._3GHxHHxwFmH1C-99Ch7DAm{-ms-flex-pack:distribute;justify-content:space-around}.saUTU6t268deJotankCyH{-ms-flex-align:start;align-items:flex-start}._3oTtjXTMQe-a4hPiOOrYWc{-ms-flex-align:center;align-items:center}._3MQwHuNVaHQbVzaKnWjhkr{-ms-flex-align:end;align-items:flex-end}._3LZni_ayS-DnjajnxVwEnK{position:relative;min-height:1px}.-uBPcXtYp9ihZw5YZJALN,.-Z1-eQtXG4L1Aeo7OhmlD,._1a3H8pRTRilnk3hOaQJhVz,._1bGWoL_cmahSZlIP7tdzdi,._1bsf_E1csA87xJq8vx3SYT,._1CygQb8PSoqm6-iT926gmO,._1DccTYWhdrUhngSdRw0Q23,._1dP6VPpEc4wBmIXypfqS4k,._1eWOMOkJEnHjjENJuvIM66,._1f3ModEDEngGXeRWECJME_,._1f_s2equjEuhX6357mwZbu,._1gWdqkBIhtSVMA8XfAAjHK,._1iFjQ4zkCyzCwSur1q_rT5,._1kBCXD3cFNBkOPstuIVBTs,._1lNw0jLvmTwKcRstr-ThaX,._1pd8Yukkn_l-tv4Mdx7JSP,._1piZUF7RYzAIWnTMUzysW8,._1pKg_WTX5LvFxW61tehHPO,._1PLFNpOrbaG7oiBiR7gipJ,._1PslX56jAzDdf_hXaV05hf,._1PyD15OYKbZTp_I_WikPwW,._1QSaM04Tw-ngxJvlca177e,._1Rp147IjrGFnXdoOuXyHUG,._1rT1XmwWIFH1ix1IuUFMPb,._1s03fYFuPsLqRMcG8pBuuZ,._1TFkI74kFWtiGw9kIImgWl,._1vEvH4gHPSy8mXINZYLkkO,._1yCJ-sDDSCjS1mVMOkhiE-,._1YPj7v7dy0_YFPZ6CFlTnc,._1ZfzdFgwBI2oqp_NxjXKUo,._2cGJfoPA3WWm1v3yjeSiH9,._2CGXrecS6VMTsfEB8fOj0T,._2dHDJxEQGqcX0nDBBG9Txt,._2flvK6CrnX9pIJVL2tzV4D,._2IA-8ORy61E8LS2-excFp1,._2IsOYyj502MJQSxRaqcL9s,._2itRG9I_vzd1CYT8-BjnRO,._2jBJcp0F1wkihe04iWe1nf,._2jfSaSQApeIS6HTwgkJvvR,._2jOS9taLTFZbmYudNxO18b,._2kdXuDVRtXJ5eqcWXSW3dv,._2kxDw68IEnTPw7OhxHYFPi,._2MtVG2Kkjgn6fIM8M6DI9y,._2ndfC3Op6-f3H5-JJ48mxS,._2NutJQVTpHEHyIQRhv0qdP,._2oKbE4sz8c4pnWTkg44qF1,._2PlChE31SaYWkTBUivvBF0,._2R8vpW3_PclrUErAix1Pbo,._2T-tOig9i2gwf3xQivoxBI,._2tST687w1vpNs8Kedurh-8,._2v74XkxEDKcxmjl9s3XUh2,._2x82hSPkSbLrWu1u_IuaBS,._2Ysr2eC4I9RnesHYS5hK7s,._2ZORktP8qDOtoEDEmC6NcF,._2Zx8DUjtgbHTFWb9cn1yjJ,._3-mWJlec57C1Fx_9lQVOIo,._3agUl5Dq8NsFu0OSSeFVu2,._3BJ1JMUAwjamrpFKIjI066,._3H1BwxtmoEUW4bAMIm976S,._3hqmumCZFi4MhwBuW919uM,._3i-xIiBzZDaWBPNXQUlePv,._3ibpRFMuwhzQPJ-9VxI2ah,._3IHYLpmTIGL8IipTkhjuqx,._3JpwgGhcpSwePm3hRi3mcH,._3KrUSkOvoFDgvYxv4TaM2M,._3NYFS_uipYqCPD2KuZZ95e,._3o97Hmk6kzYIelTMDQWkYE,._3Ocm-iTvjR0mrXuuJaKks3,._3Q-lzIvo0UqJjw3LKfyE4u,._3Qix4GsW4eMZHyWfEfVfsX,._3ralCTchPhUc1Ct796RGuD,._3SjZB9d1sw2bLwLiq7gvCg,._3tAKx0tyLNqV3jstAtgDrz,._3trs0zD59rOIar_6GtdYuz,._3V1W78SkixqAgMeXGyRGgx,._3v4V9JwXDVlzAts4oP8QRD,._3v-2F_hmFDgY7fEjIitqJv,._3vg2vxwsuzsRd8X4LZQuBn,._3wVezvg4pKKLAa0xahOA-L,._3Y96kEwUwxn_Zcp-GoELRm,._3zC-PYcMIF-0HGUWDVWyA8,._3ZvpfWjEJ3giGgJn0mp9WC,._4pSZ1tb9bcmVOqTm1RnS0,._8OjniZjQdvUNQzFcDVXVQ,._13XOE4z0r_dfoIl7wjY5V,._14Z3ZZUzRwUvcerXJQt8OL,._17FmX5DLSPH7NwySuvd72l,._20-OtFIYggk9W3mCYEMB5l,._20a2eYnNcUUUHG2vqe46n7,._29X8IwM6ZpDwbop5ck25aK,._31H3EA3W2I2jvzzFEU8XR6,._31R7Z24-E4559-bge7uYvO,._32vXsJ026qkOYO3u9PteM3,._33cLB1N4VPqKgfxzUExB6d,._36FMMyk3yCijWGsvIMlp18,._74oQYE_RJmk48EBZwcABM,._137_X_XQzSVylC4rU4RI8s,._3744ErrgSP70rklc5lqnL7,._3784scNf_e7NwQHPzOybSR,._hc2lyZFXBRieqWVGvjlW,.DadoC1HXIRh6OUbv9B1_x,.FicZmEjlFJvo876G5rnk8,.FovrqvB6LLHSEWl19VDJh,.hWmcSHzTs6hAEGKgHfIiN,.jmRT5rs-OUvOqSIlzU3Du,.Kdi2aWxg0ioYtw00XZfOO,.m5GSJDA-XU2vizRVe6oI0,.n_eDAHREa5E2V4Jldvkfm,.oyDkQmtxF5gmYYEF1jcgX,.p4fy94ZdbfLMZ7-uol27o,.p_zAYo-DSVHJWfRIFHq8p,.pih3Q66IulQCubsjoEJFC,.PPy883M3zO4CPCsmOL3WK,.RZ6aHl-BwGRHv7xX_sgZS,.SxGva5irxm6JjTQGVfjis,.TKOEvk-l3BkcWrmjR59as,.u2n6k6rB4Z-PK-nThhYXt,.xibilcuZB_2LOGK1iozZk,.yqbtr8Y3D3MOOsKcuLxf1,.zBy98kdqeohBiEno7vU3V{position:relative;padding-right:0;padding-left:0}.-Z1-eQtXG4L1Aeo7OhmlD,._1f_s2equjEuhX6357mwZbu,._1gWdqkBIhtSVMA8XfAAjHK,._1PslX56jAzDdf_hXaV05hf,._1PyD15OYKbZTp_I_WikPwW,._1QSaM04Tw-ngxJvlca177e,._1rT1XmwWIFH1ix1IuUFMPb,._2kdXuDVRtXJ5eqcWXSW3dv,._2v74XkxEDKcxmjl9s3XUh2,._2ZORktP8qDOtoEDEmC6NcF,._3JpwgGhcpSwePm3hRi3mcH,._3ralCTchPhUc1Ct796RGuD,._3tAKx0tyLNqV3jstAtgDrz,._3V1W78SkixqAgMeXGyRGgx,._3zC-PYcMIF-0HGUWDVWyA8,._13XOE4z0r_dfoIl7wjY5V,._20-OtFIYggk9W3mCYEMB5l,._hc2lyZFXBRieqWVGvjlW,.DadoC1HXIRh6OUbv9B1_x,.hWmcSHzTs6hAEGKgHfIiN,.p4fy94ZdbfLMZ7-uol27o,.p_zAYo-DSVHJWfRIFHq8p,.PPy883M3zO4CPCsmOL3WK,.u2n6k6rB4Z-PK-nThhYXt{-ms-flex:0 0 auto;flex:0 0 auto;float:left}._hc2lyZFXBRieqWVGvjlW{display:block;box-sizing:border-box;width:100%}._1Tu_JDP1rjOMTL1EJQVoHa{left:100%}._10OaldKAVn_PCKKPvhpawF{right:100%}._3Unl5XV0UhnKyfXBFbKJtv{margin-left:100%}._23O8QZ2iWMsnRG7AP_sXPH{-ms-flex-order:24;order:24}._1f_s2equjEuhX6357mwZbu{display:block;box-sizing:border-box;width:95.83333333%}._3g3rBIlBGfzOJuXG_0IXEL{left:95.83333333%}.qqBJ9mDby1yteHJzPjHfM{right:95.83333333%}._2Tek9wGaQ4QcH52gV3l9O2{margin-left:95.83333333%}._1FS_hLI89vJ2AwuK8mcjMj{-ms-flex-order:23;order:23}.hWmcSHzTs6hAEGKgHfIiN{display:block;box-sizing:border-box;width:91.66666667%}._3klIz1pV19BbomcKKazkj6{left:91.66666667%}._3ZunCeinqMhBXL9qKO7KHU{right:91.66666667%}._2XBjGowaXm8b91q6S_WE3k{margin-left:91.66666667%}._38DidIwACZDYr3DXilqGvz{-ms-flex-order:22;order:22}._3ralCTchPhUc1Ct796RGuD{display:block;box-sizing:border-box;width:87.5%}._1vEsATrTspdElcUOM6pYed{left:87.5%}._1xxLCPa8K-bEAgEUZQ6Gh7{right:87.5%}.qQGi04MMxsRroz_rX8ZJE{margin-left:87.5%}._1eMH390wbsPp7MGrEsnCN2{-ms-flex-order:21;order:21}._1rT1XmwWIFH1ix1IuUFMPb{display:block;box-sizing:border-box;width:83.33333333%}._1FcqQcM9U508JfSwX-iDAA{left:83.33333333%}.EvZtiIost6uIMZQ3AF_53{right:83.33333333%}._2NzS8QhrVN_zS-Mwrt0ABr{margin-left:83.33333333%}._34fbGsieUChCHelfuLbmz6{-ms-flex-order:20;order:20}._3V1W78SkixqAgMeXGyRGgx{display:block;box-sizing:border-box;width:79.16666667%}._1yQtYV_gw2DTJPLrdmIoPI{left:79.16666667%}._3i5KHcKv8C1l1WErvmbxdO{right:79.16666667%}._3O9X1PBd4I5SqSWD25oLcj{margin-left:79.16666667%}._1tQElyvKnzqe_vFqZtCR5U{-ms-flex-order:19;order:19}._3tAKx0tyLNqV3jstAtgDrz{display:block;box-sizing:border-box;width:75%}._2J5goSsrlCKk0LlAGok92Z{left:75%}._1eIcQUhB_Skv7wXMxNl7Xh{right:75%}.lB58Nq6S2VXyOBvPszNa8{margin-left:75%}._3j7CgUmu73fmTtzsuY-Ylt{-ms-flex-order:18;order:18}._3JpwgGhcpSwePm3hRi3mcH{display:block;box-sizing:border-box;width:70.83333333%}._1X20KdduMYHyrl-c6N_CX2{left:70.83333333%}._7EvulRg_jQGr5auSnt5rr{right:70.83333333%}._2O6nhYCcshH5APGbMkxVhp{margin-left:70.83333333%}._2dMaU650dUnlm7Tpv2JHXh{-ms-flex-order:17;order:17}._3zC-PYcMIF-0HGUWDVWyA8{display:block;box-sizing:border-box;width:66.66666667%}._1tnEwRKm9F3nhR2deZro7H{left:66.66666667%}.u6tjJEK0NfqeuqgSdi-X-{right:66.66666667%}._3ph-exXpfUJI6UeGZGIQJC{margin-left:66.66666667%}.YhpFyEl0p0bBdoI-GT_4W{-ms-flex-order:16;order:16}.u2n6k6rB4Z-PK-nThhYXt{display:block;box-sizing:border-box;width:62.5%}._1wPQ0LeCAOCp0LIG6tkEQ5{left:62.5%}.Tm3z3nVB5lgQa8WJp6Kef{right:62.5%}._3C2V-CFtXIt9x-er-zxsxl{margin-left:62.5%}._3glQvzzhyiSziu1gUMJRyq{-ms-flex-order:15;order:15}._2kdXuDVRtXJ5eqcWXSW3dv{display:block;box-sizing:border-box;width:58.33333333%}._2VPSKa6Gq-OsFQOiSD-WS9{left:58.33333333%}._3b7EvX8ciWIUiUGLSsRqpE{right:58.33333333%}._3iCDI-Yt7Vd2jk2alBY79a{margin-left:58.33333333%}._3r5GAm36oaBuarJRJ7R3qk{-ms-flex-order:14;order:14}.p4fy94ZdbfLMZ7-uol27o{display:block;box-sizing:border-box;width:54.16666667%}.UJ5Va0X4UXEuazjw5tp64{left:54.16666667%}._1y1PBsSQqRIhpDgnNTJYkj{right:54.16666667%}._3bGFa3DWr03zkfYHe-jXmY{margin-left:54.16666667%}._2yyRtpVKVLHWeU410qx59Y{-ms-flex-order:13;order:13}._13XOE4z0r_dfoIl7wjY5V{display:block;box-sizing:border-box;width:50%}.z3j7BDvDwJUwWk-43v49Y{left:50%}._2QA7fozmoG3nJp6dF1YuQV{right:50%}.m6kMXAFJ1593KmGQoTye6{margin-left:50%}._23AeS0vYUgvpNHlfSuECeD{-ms-flex-order:12;order:12}._1gWdqkBIhtSVMA8XfAAjHK{display:block;box-sizing:border-box;width:45.83333333%}._1444jcCmV1S3MMFgZSkrXI{left:45.83333333%}.YMXqHGl89e1WE9nPrDtcg{right:45.83333333%}._1LMbRE5effWhugEpDx6hPN{margin-left:45.83333333%}.nLcbz8EqojQBv6d1bcdks{-ms-flex-order:11;order:11}.DadoC1HXIRh6OUbv9B1_x{display:block;box-sizing:border-box;width:41.66666667%}._1PbaOBjjmRVpVOvZKC_q7u{left:41.66666667%}._6dcwut7fzzUBBsSBxPt5I{right:41.66666667%}._1qxTx4MnpQDVWM7mWQY8N2{margin-left:41.66666667%}.DNaHkfeDZQA7TybMScZqJ{-ms-flex-order:10;order:10}.-Z1-eQtXG4L1Aeo7OhmlD{display:block;box-sizing:border-box;width:37.5%}._2kYQJyXf2DwlKzTiW_9nOG{left:37.5%}._1M7J5wx8uN3hKSwurM_rup{right:37.5%}._1iGJsSQpfVc4FSMiOIJddG{margin-left:37.5%}.UZVRG8-Qo4JA1PIXQ4k8J{-ms-flex-order:9;order:9}._2v74XkxEDKcxmjl9s3XUh2{display:block;box-sizing:border-box;width:33.33333333%}._3ntOejhVuFtLEFaFDXl9S-{left:33.33333333%}._2fd1qX_h_YP306sa0GwIkC{right:33.33333333%}._1pL0HS3W4Ixu6yswd5zAE7{margin-left:33.33333333%}._2MrVfLt-edDKqrBfOW7_fP{-ms-flex-order:8;order:8}.PPy883M3zO4CPCsmOL3WK{display:block;box-sizing:border-box;width:29.16666667%}.zFcHd6MnQQPwnygS5uFII{left:29.16666667%}.Nz1WEJZRpLyLRFEYLyGYN{right:29.16666667%}._3lG0SRqSnu3OECP8emv7gD{margin-left:29.16666667%}._1jUi9pBKS09cxhOUU6UGTw{-ms-flex-order:7;order:7}._1QSaM04Tw-ngxJvlca177e{display:block;box-sizing:border-box;width:25%}._2LBysoCcuJhAryYWrHkql3{left:25%}._1Hn3CagvquQiQx2IZyJt1d{right:25%}._1OFHfIjTewldKpBoLguLFN{margin-left:25%}._1ULOoHQuZ09hDYqfT6LHyT{-ms-flex-order:6;order:6}._1PslX56jAzDdf_hXaV05hf{display:block;box-sizing:border-box;width:20.83333333%}._2fzVtGx_lCp40aD4vDcM50{left:20.83333333%}._2olW9XxVvgGKNR59Boo5eq{right:20.83333333%}._1aSYGOCTFoH9jHVcLaeV3J{margin-left:20.83333333%}.j8NbC6yZUAkWlvPbQswqs{-ms-flex-order:5;order:5}._2ZORktP8qDOtoEDEmC6NcF{display:block;box-sizing:border-box;width:16.66666667%}._1U_vPTbQpEO4LiOG2OM_l{left:16.66666667%}.nVWqJufnkU3yPv008Jdtu{right:16.66666667%}._32a447Ft-xqCWAi70A0z6w{margin-left:16.66666667%}._10tFhMWqdcIJDO9DXkQsVS{-ms-flex-order:4;order:4}._1PyD15OYKbZTp_I_WikPwW{display:block;box-sizing:border-box;width:12.5%}._3DIfnytoXV9JITd62m4rRR{left:12.5%}._3dkzHTwN4kO2t6KzgdHMp-{right:12.5%}.JiRUI8q--Jp-86AO6P8Gr{margin-left:12.5%}._1ByPdMZuWDGRh6MaIT987v{-ms-flex-order:3;order:3}.p_zAYo-DSVHJWfRIFHq8p{display:block;box-sizing:border-box;width:8.33333333%}.zp0w_AyWtnQtNaOP0KYpL{left:8.33333333%}._2eJBeSZUqJNMUkiHseXHAU{right:8.33333333%}.PVjTjNzB_gkk867K-LGU6{margin-left:8.33333333%}._3kLb_d6levVmGLKkD-4TRu{-ms-flex-order:2;order:2}._20-OtFIYggk9W3mCYEMB5l{display:block;box-sizing:border-box;width:4.16666667%}._3KYQqwZKGBDh7dzqBj1Apu{left:4.16666667%}._3lM5HfUr5BFzFlcIcSFdHz{right:4.16666667%}._2sBZ6Srdhfd_HqKn5tbm6l{margin-left:4.16666667%}._1QnFEApe7ilgiOdCD1MgeC{-ms-flex-order:1;order:1}._27ykFHUF_LK-M5M66f1hrY{display:none}._3VXqc3tM1pQk3Mgx98VPn7{margin-left:0}._1CYHEQcc2ocjnhhS2YbIwk{-ms-flex-order:0;order:0}._1bGWoL_cmahSZlIP7tdzdi,._1eWOMOkJEnHjjENJuvIM66,._1pd8Yukkn_l-tv4Mdx7JSP,._2cGJfoPA3WWm1v3yjeSiH9,._2IsOYyj502MJQSxRaqcL9s,._2oKbE4sz8c4pnWTkg44qF1,._2R8vpW3_PclrUErAix1Pbo,._2tST687w1vpNs8Kedurh-8,._2Ysr2eC4I9RnesHYS5hK7s,._3H1BwxtmoEUW4bAMIm976S,._3hqmumCZFi4MhwBuW919uM,._3ibpRFMuwhzQPJ-9VxI2ah,._3KrUSkOvoFDgvYxv4TaM2M,._3Q-lzIvo0UqJjw3LKfyE4u,._3vg2vxwsuzsRd8X4LZQuBn,._20a2eYnNcUUUHG2vqe46n7,._29X8IwM6ZpDwbop5ck25aK,._74oQYE_RJmk48EBZwcABM,._137_X_XQzSVylC4rU4RI8s,._3784scNf_e7NwQHPzOybSR,.FicZmEjlFJvo876G5rnk8,.FovrqvB6LLHSEWl19VDJh,.Kdi2aWxg0ioYtw00XZfOO,.m5GSJDA-XU2vizRVe6oI0{-ms-flex:0 0 auto;flex:0 0 auto;float:left}.m5GSJDA-XU2vizRVe6oI0{display:block;box-sizing:border-box;width:100%}._270mB5a0pSleefwOT90Xx2{left:100%}.X6xzzcOb5s0uBE5-WzOEf{right:100%}._23oyRlR7XGP8qjnz9kUns2{margin-left:100%}.Q-tLqv4DoN9VxGV-x56x8{-ms-flex-order:24;order:24}._3H1BwxtmoEUW4bAMIm976S{display:block;box-sizing:border-box;width:95.83333333%}._1sOVb52E4PhzkSZWu8n-HC{left:95.83333333%}._3ILMIB6WxMEWhPzweFziBx{right:95.83333333%}.LAyu6S6CJi0tfNcSUHjGG{margin-left:95.83333333%}._3EoKWpqef9SbGjHNAXcg9T{-ms-flex-order:23;order:23}._2cGJfoPA3WWm1v3yjeSiH9{display:block;box-sizing:border-box;width:91.66666667%}._2-wCCIm6ZS1kEguUKSu9j9{left:91.66666667%}._2UCvvxuTdI_XBVS6q-2jzm{right:91.66666667%}._17y1iNJYpnM8DEc-1e_9QF{margin-left:91.66666667%}._2tH0gF6pHEdA70PrjZ60ID{-ms-flex-order:22;order:22}._137_X_XQzSVylC4rU4RI8s{display:block;box-sizing:border-box;width:87.5%}._1Nkf2WoDVXhyJvN-743XXA{left:87.5%}._2EG3np97Zk0zxfhNSQ1V_u{right:87.5%}.jAT9nDgYgKuxplGm-gQ-Z{margin-left:87.5%}._24DxOxTPZM0IAASV2eKo9B{-ms-flex-order:21;order:21}._3vg2vxwsuzsRd8X4LZQuBn{display:block;box-sizing:border-box;width:83.33333333%}._1s-G-1VF7dC52DMM54VzCL{left:83.33333333%}.hP0a4A5wO1GHU5MAbD2Tb{right:83.33333333%}._3Y1NoL-eLEJnkDlN86EFlz{margin-left:83.33333333%}.F59ycyzfgD84-6m2PTrK3{-ms-flex-order:20;order:20}._1pd8Yukkn_l-tv4Mdx7JSP{display:block;box-sizing:border-box;width:79.16666667%}._2ZM1cL7Km1OKXHsbKbXUNU{left:79.16666667%}._2mztNQ38m7UrjkeztS13f8{right:79.16666667%}._3iMRAuVZFbApOgjjar2pJK{margin-left:79.16666667%}._2NiVCdGZAB1ZhpEnrP9PqE{-ms-flex-order:19;order:19}._3hqmumCZFi4MhwBuW919uM{display:block;box-sizing:border-box;width:75%}._2hB2WcxPQE31WpApJkX85a{left:75%}.Ip-7irFAxgae730siFL8j{right:75%}._2EKsOPpV7y0dqQU42ATOVO{margin-left:75%}._3ErYWkda03uYstKggLFcbJ{-ms-flex-order:18;order:18}._1bGWoL_cmahSZlIP7tdzdi{display:block;box-sizing:border-box;width:70.83333333%}._2v2yU45EBEveWzO9qSw900{left:70.83333333%}._1AJ2agnFWlCCGY8FLUgfI3{right:70.83333333%}._1s5uVhSLaD0q4G6Sweu16i{margin-left:70.83333333%}._2rmyd3EHGyExifGfTl8qzy{-ms-flex-order:17;order:17}._2tST687w1vpNs8Kedurh-8{display:block;box-sizing:border-box;width:66.66666667%}._2zMk2FN9Rr98RJ_b8GLPxl{left:66.66666667%}._3rAeebWHLH6H8HYV8IbrON{right:66.66666667%}._1IA-mIIiE-8CUoQI5EN0SY{margin-left:66.66666667%}.hrKtt8JYwkAOaixW7Kt6m{-ms-flex-order:16;order:16}.Kdi2aWxg0ioYtw00XZfOO{display:block;box-sizing:border-box;width:62.5%}.IXSp-oHEveP0wYrz_8d2I{left:62.5%}._13IQRb7q_C6jckne30HH2T{right:62.5%}.V7FLbBcMCvUrHqZKDeRxh{margin-left:62.5%}.S_iW8DoMKzUrBMUo9K6Qo{-ms-flex-order:15;order:15}._3KrUSkOvoFDgvYxv4TaM2M{display:block;box-sizing:border-box;width:58.33333333%}._1FqLSng4a1VPeej3pljMbC{left:58.33333333%}._3ALts8lCFhyH1uoSipiuxM{right:58.33333333%}._3OzKUILpo0AQbbcpW7Dj8X{margin-left:58.33333333%}._2ZNhifkuMJSa6PtZQWLnnX{-ms-flex-order:14;order:14}._3784scNf_e7NwQHPzOybSR{display:block;box-sizing:border-box;width:54.16666667%}._2lzxJhxRuxARmcdHxGHiaR{left:54.16666667%}._3SnJ_4nEKwYRdVWBxPkoD{right:54.16666667%}.HLGKAlNMT_QJb4tLNmMWZ{margin-left:54.16666667%}.f7xmD6sBkz3M_58D6XS2d{-ms-flex-order:13;order:13}.FovrqvB6LLHSEWl19VDJh{display:block;box-sizing:border-box;width:50%}._3zFklpkMshg8DjtVuivWc1{left:50%}._3WnU_vsxcGgN86qxJxJ2lC{right:50%}.t7C9IiDRgo8CG0qh7ZSw-{margin-left:50%}._2N0-oFMHhSqU2jdRJiDLq8{-ms-flex-order:12;order:12}._29X8IwM6ZpDwbop5ck25aK{display:block;box-sizing:border-box;width:45.83333333%}._1eHmHN3MJBqwG0SSnt9MgV{left:45.83333333%}.T9ZcMmf1lrgCGp_1-nZzi{right:45.83333333%}._2JiRHbTMksUt2e8oLrsJ-{margin-left:45.83333333%}._1ECUlRK65QA-sisEGVSl9a{-ms-flex-order:11;order:11}._2Ysr2eC4I9RnesHYS5hK7s{display:block;box-sizing:border-box;width:41.66666667%}._3Qa-LOavFF-J7huN45v3iE{left:41.66666667%}._3nIpx0CWmcCc-uuW1ZCsho{right:41.66666667%}._3F_BtkbnGC3fj8eF_aqn7h{margin-left:41.66666667%}._2kpWzXBo__7_C4nTAYfN9H{-ms-flex-order:10;order:10}._2IsOYyj502MJQSxRaqcL9s{display:block;box-sizing:border-box;width:37.5%}._3aDaLuwCXI1K-wCzCWktNO{left:37.5%}._1-Tw2CsWMyQ01RCZhp0KiV{right:37.5%}._2QpOEoLDU6DaOP6Hqkil8W{margin-left:37.5%}._1b1tOwemWaadgYCPnlJZu7{-ms-flex-order:9;order:9}._74oQYE_RJmk48EBZwcABM{display:block;box-sizing:border-box;width:33.33333333%}._3XE5SWXuZ7NQbCJpyaTGQC{left:33.33333333%}._2ZYv-1TuKaG9SWFMr9BLAK{right:33.33333333%}._1JeXOqXoH9uOd24MujvCr9{margin-left:33.33333333%}._3v2m4bTb1gntT_o0uGSaen{-ms-flex-order:8;order:8}._20a2eYnNcUUUHG2vqe46n7{display:block;box-sizing:border-box;width:29.16666667%}._229PnlRF4JqhIcNjYSBi-l{left:29.16666667%}._234GXi6SsFQss349pQjEZI{right:29.16666667%}._2HQ2E_38eDC86d35Iwr7tE{margin-left:29.16666667%}.vqcatdVCmAks14eQr8epk{-ms-flex-order:7;order:7}._3ibpRFMuwhzQPJ-9VxI2ah{display:block;box-sizing:border-box;width:25%}._2gZjXVtHe0fSVwhbV3A6pX{left:25%}._2TsK98YCOIrYtYlziHwhDy{right:25%}.Svnbo7SGVh5EjBEA0M29e{margin-left:25%}._332GUWb5tgKAPizASu9_kc{-ms-flex-order:6;order:6}._2R8vpW3_PclrUErAix1Pbo{display:block;box-sizing:border-box;width:20.83333333%}.N92x-_-_moaEShvqshCU-{left:20.83333333%}._2nZGMbhh9w_oPHgVNSsoZl{right:20.83333333%}._1y9bLSmhZUgEBdli8XKUvv{margin-left:20.83333333%}._2KPn7WXfNhgJPbH6_F7kzO{-ms-flex-order:5;order:5}._3Q-lzIvo0UqJjw3LKfyE4u{display:block;box-sizing:border-box;width:16.66666667%}.NHYR1hxRNCWaMWFaS5I-n{left:16.66666667%}.EnJ32Qieahj4aY3qe-Zau{right:16.66666667%}._1Qgl1cQuVta97kCGQZqcTC{margin-left:16.66666667%}._2_7VuSy3AzCsPjwflMJctq{-ms-flex-order:4;order:4}.FicZmEjlFJvo876G5rnk8{display:block;box-sizing:border-box;width:12.5%}._1WIDRD9tdmVGtDzFC22Vm1{left:12.5%}._3vk-KdBMIaa_WrCj9EJppP{right:12.5%}.xfL859hoFbHXP2TDcphgO{margin-left:12.5%}._2Bd-lq6f68GAeBRyT8YM5N{-ms-flex-order:3;order:3}._2oKbE4sz8c4pnWTkg44qF1{display:block;box-sizing:border-box;width:8.33333333%}._84e_3soJjlulgrwLFKp0_{left:8.33333333%}.mP5bBZW8VMCWjeQUesrxu{right:8.33333333%}._18hc8JD1An_XW1cWrWO-ew{margin-left:8.33333333%}._3v5Hy0TvQKsQPvH9E6G2gL{-ms-flex-order:2;order:2}._1eWOMOkJEnHjjENJuvIM66{display:block;box-sizing:border-box;width:4.16666667%}._2WgMM1Vf8bWeqZrLJrA0f8{left:4.16666667%}._20p-fjtCWVjOMxJUEtTGCt{right:4.16666667%}._2hEKdgfjywBAfp07aNcnDe{margin-left:4.16666667%}._3G9D08ygW8W4aLTIzLVms8{-ms-flex-order:1;order:1}.o42JOCAgLB67Vr6prNuHi{display:none}._3eh9FwIUqNXQ75ZS1KOHUF{left:auto}._19fhy1NkdCWgU0GwLjJ-B2{right:auto}._2-olvJYGKXmv1Et94CWtRb{left:auto}._3o-suZwlC6d2EgFnDb6DwA{right:auto}._77xEzBkeu2ReLJNyTvnma{margin-left:0}.scRdG0nRjTJXJ6NMQxSnL{-ms-flex-order:0;order:0}@media (min-width:576px){._1DccTYWhdrUhngSdRw0Q23,._1dP6VPpEc4wBmIXypfqS4k,._1f3ModEDEngGXeRWECJME_,._1iFjQ4zkCyzCwSur1q_rT5,._1lNw0jLvmTwKcRstr-ThaX,._1piZUF7RYzAIWnTMUzysW8,._1pKg_WTX5LvFxW61tehHPO,._1ZfzdFgwBI2oqp_NxjXKUo,._2dHDJxEQGqcX0nDBBG9Txt,._2itRG9I_vzd1CYT8-BjnRO,._2jOS9taLTFZbmYudNxO18b,._2NutJQVTpHEHyIQRhv0qdP,._2PlChE31SaYWkTBUivvBF0,._3BJ1JMUAwjamrpFKIjI066,._3i-xIiBzZDaWBPNXQUlePv,._3IHYLpmTIGL8IipTkhjuqx,._3v-2F_hmFDgY7fEjIitqJv,._3wVezvg4pKKLAa0xahOA-L,._14Z3ZZUzRwUvcerXJQt8OL,._33cLB1N4VPqKgfxzUExB6d,.oyDkQmtxF5gmYYEF1jcgX,.RZ6aHl-BwGRHv7xX_sgZS,.SxGva5irxm6JjTQGVfjis,.TKOEvk-l3BkcWrmjR59as{-ms-flex:0 0 auto;flex:0 0 auto;float:left}._1lNw0jLvmTwKcRstr-ThaX{display:block;box-sizing:border-box;width:100%}._10M2KC6NGRe5v2va85M2wt{left:100%}._3zs6lUpdNRB3rTwFHAfxNU{right:100%}.j1Z5gCgOcP6YgXys_YDjo{margin-left:100%}._1hEK7ME-NsgdJFICTMKMJy{-ms-flex-order:24;order:24}._1pKg_WTX5LvFxW61tehHPO{display:block;box-sizing:border-box;width:95.83333333%}._3jiBhQAaL1-nQgpbSyGIm9{left:95.83333333%}.PCPYsnGL806aDTjK1dqlT{right:95.83333333%}._1tCo5W4u8KDjHCnr0QqLnW{margin-left:95.83333333%}._2OcGnz8guk1tL1W48-Sl_W{-ms-flex-order:23;order:23}._14Z3ZZUzRwUvcerXJQt8OL{display:block;box-sizing:border-box;width:91.66666667%}._1fkCn19OMdpgEAwRzomUbP{left:91.66666667%}._3Wa3OVF-wzeaRbXwXV3GcX{right:91.66666667%}._3lNGYH19daOyCcD-vUgtuZ{margin-left:91.66666667%}._20pjQu654MdJBYB2b8Znx2{-ms-flex-order:22;order:22}.TKOEvk-l3BkcWrmjR59as{display:block;box-sizing:border-box;width:87.5%}._2iR0q6tac62Ta_Vq-xGtgt{left:87.5%}._1xMEGtwDxitF92RzwAMf2h{right:87.5%}._1bmCYQmj6g-B8n8UFOSomi{margin-left:87.5%}._2wP_oGcHncoTMZoQzObGXx{-ms-flex-order:21;order:21}._1piZUF7RYzAIWnTMUzysW8{display:block;box-sizing:border-box;width:83.33333333%}._1cah7_MEYwOFD7Ec4CgI89{left:83.33333333%}._2pfBD8xvtNR_DLgdnp1uz5{right:83.33333333%}._1kzb_Fz_CMzDyEwiRr3plH{margin-left:83.33333333%}.KTsxYBAZlQT0IzSUB06LP{-ms-flex-order:20;order:20}._1DccTYWhdrUhngSdRw0Q23{display:block;box-sizing:border-box;width:79.16666667%}._3lxOQSEyFDHrs-vWrDxSAa{left:79.16666667%}._3asnO025KIdgn3gvEPa7Zs{right:79.16666667%}.ILrsyV35Ie2dAb3zBvex0{margin-left:79.16666667%}._2wwIEnM7c-kziCNT4NjXw6{-ms-flex-order:19;order:19}._3IHYLpmTIGL8IipTkhjuqx{display:block;box-sizing:border-box;width:75%}._201YayKY6Wt-AkMY7twdOl{left:75%}._3aCWuO6vwyDnkXOsaNk2-F{right:75%}._3kDiWS2N7B4badQBi0REY9{margin-left:75%}._1_YOmAwKCljzFKuTMIZ7de{-ms-flex-order:18;order:18}._1ZfzdFgwBI2oqp_NxjXKUo{display:block;box-sizing:border-box;width:70.83333333%}.E64NfcLND8rCRI2jk5NsM{left:70.83333333%}.H_t5_h5rC1uLo9YoogPXn{right:70.83333333%}.heZYF00Zdb2-MU7UQpMK-{margin-left:70.83333333%}._1ZztByf3Ls8RCHCGkcmxzX{-ms-flex-order:17;order:17}.RZ6aHl-BwGRHv7xX_sgZS{display:block;box-sizing:border-box;width:66.66666667%}._2rUluP_jnTFJvd31dTXbZX{left:66.66666667%}._3sYCh5wxNoWfZCURim3ATL{right:66.66666667%}._1uT9WzpLR8yxaWZx0rzEp1{margin-left:66.66666667%}._3UdseFS7K_wboSQgM-88Ku{-ms-flex-order:16;order:16}.oyDkQmtxF5gmYYEF1jcgX{display:block;box-sizing:border-box;width:62.5%}._3sxhZfYZukmuIe-s_A0kZT{left:62.5%}._1Dz5JJrZHwgWF7bdqUmBVG{right:62.5%}._3WBDPZb0njZoo7_tvrKwbF{margin-left:62.5%}._3CAVOfo9w6CqRKaPOCY5XZ{-ms-flex-order:15;order:15}._1dP6VPpEc4wBmIXypfqS4k{display:block;box-sizing:border-box;width:58.33333333%}._2d8QEmsDoMmv8-A6BTYhmd{left:58.33333333%}._3qDPgs3uaIgji-YEyb4KfD{right:58.33333333%}._1FRZ3_n5e4jOVzYu9DSMQI{margin-left:58.33333333%}._2-2xZ0mGxhaRFmfN53Wz4K{-ms-flex-order:14;order:14}._1iFjQ4zkCyzCwSur1q_rT5{display:block;box-sizing:border-box;width:54.16666667%}._1U8MabwppQVKKSVY7YGQvj{left:54.16666667%}._1DoqLO7oS5T4DU7UXhTlXt{right:54.16666667%}._3nZ_iU_rzkQloAHIMx7ppz{margin-left:54.16666667%}._1-UGWIPGGNmK6gVDYhlNSY{-ms-flex-order:13;order:13}._2dHDJxEQGqcX0nDBBG9Txt{display:block;box-sizing:border-box;width:50%}._2sNuln2bFNoCADnZP51ATq{left:50%}._2SanmyCTWRwAyiosnaN1U6{right:50%}._2Vpz7FO9Cucem3YSRyeFrl{margin-left:50%}._2O5HDwSTdTwJC7MK85W4Qk{-ms-flex-order:12;order:12}._33cLB1N4VPqKgfxzUExB6d{display:block;box-sizing:border-box;width:45.83333333%}._2iBNbLYyFqRs-NPePMIycV{left:45.83333333%}.u-fX8l7TYvdOtGF3iNck4{right:45.83333333%}._92KRwfTbo4LrCg8zO9RJk{margin-left:45.83333333%}._2EKdG26XBAj6XvEvAb_tu4{-ms-flex-order:11;order:11}._2itRG9I_vzd1CYT8-BjnRO{display:block;box-sizing:border-box;width:41.66666667%}._21E9TTDJgknq0cmBRZEUAr{left:41.66666667%}._2Z5fFv7avJW-n2de8AdAaf{right:41.66666667%}._3pPcR_WRzZAIzrz8LvRP9b{margin-left:41.66666667%}._21TxjqZoAEh_NMKYL_54g0{-ms-flex-order:10;order:10}._2PlChE31SaYWkTBUivvBF0{display:block;box-sizing:border-box;width:37.5%}._1PgFeOkmKLTgxB1okZm6Fh{left:37.5%}.LcCRqOf_NG_LShBxXibag{right:37.5%}._3tKOPvRYUYWSCgs8sF56rW{margin-left:37.5%}.A8jbYgkkvcbq1sT_jdfye{-ms-flex-order:9;order:9}._3BJ1JMUAwjamrpFKIjI066{display:block;box-sizing:border-box;width:33.33333333%}._2ll2yGHqqxMmAdszdBPZCE{left:33.33333333%}._1SWDF6efmoOQkBpJnyX2ee{right:33.33333333%}._32jHojZxrHqx9yFCNCJU2I{margin-left:33.33333333%}._1HYySxE8B0N0Y0snmuttsE{-ms-flex-order:8;order:8}._3v-2F_hmFDgY7fEjIitqJv{display:block;box-sizing:border-box;width:29.16666667%}._2egjisvxH6lmMOb38bT8NH{left:29.16666667%}._2xtZNnJJexbc3THDQ0xeZM{right:29.16666667%}.KTrq9giZy3UW-wotNs0iE{margin-left:29.16666667%}.cI5TTcWxBkvHtWyWPzDd2{-ms-flex-order:7;order:7}._2NutJQVTpHEHyIQRhv0qdP{display:block;box-sizing:border-box;width:25%}._9DDzaSCNt7SSRm4BXrleC{left:25%}._38i6PzF9SzOIf4KmLS2lOd{right:25%}.zCAcQZyozEaI5LAmklCyK{margin-left:25%}._2WecfddkC8LVI9_wHEmy3j{-ms-flex-order:6;order:6}._3i-xIiBzZDaWBPNXQUlePv{display:block;box-sizing:border-box;width:20.83333333%}.B3tW9AQc7-FHueXc20U-T{left:20.83333333%}._3ouBYFplxau-Y_w33DSMZ4{right:20.83333333%}._1Oppk37tTfMenqvBR5bZ5D{margin-left:20.83333333%}._2sYWeMpJpa384mb844Rv0-{-ms-flex-order:5;order:5}._3wVezvg4pKKLAa0xahOA-L{display:block;box-sizing:border-box;width:16.66666667%}._2Ojtb2Jd1UJU8lD4HXDCMQ{left:16.66666667%}._1PLHqePFVt8i9Ic-WzwD2R{right:16.66666667%}._3YgZtF5HQ8BIHC39ERU68M{margin-left:16.66666667%}.qpvDv_AmslcZCNlgdjSbb{-ms-flex-order:4;order:4}._1f3ModEDEngGXeRWECJME_{display:block;box-sizing:border-box;width:12.5%}._1JWNxBbkGNtNPB7Xn9ZoT{left:12.5%}.S1HbOSYUO07V-UyoFbvNh{right:12.5%}._1v6GejM0gzLmUxxjWZ4t8X{margin-left:12.5%}._1sMU9gxvegzB9-A0wufdzr{-ms-flex-order:3;order:3}.SxGva5irxm6JjTQGVfjis{display:block;box-sizing:border-box;width:8.33333333%}._1MlGQvJFITxDQrr_ySxWWv{left:8.33333333%}._1pHQhF1VzX6e7XLySiv6uG{right:8.33333333%}._1MLyjO3cIdtzJplF-F5y7L{margin-left:8.33333333%}._2Lrg_yJQTi6wV3H7E6iRdS{-ms-flex-order:2;order:2}._2jOS9taLTFZbmYudNxO18b{display:block;box-sizing:border-box;width:4.16666667%}._1c-OqQz0zFAIFNf_uQAjmo{left:4.16666667%}._28Xccg6RWQBoSkFsRCrfXm{right:4.16666667%}._1SOsfnvKT3GSTFHLvdw0Ij{margin-left:4.16666667%}.Ofc2gWnBRBLs8LYgtBbUF{-ms-flex-order:1;order:1}._3aPfWz7vd_zpA5tj0-7NxG{display:none}._3eh9FwIUqNXQ75ZS1KOHUF{left:auto}._19fhy1NkdCWgU0GwLjJ-B2{right:auto}._249rFDENkaKJ5ue-g-blcT{left:auto}._1R1ePCs_9AISZ1wmaN8OAf{right:auto}.FlCxOumQ5gI3swtDXtVvS{margin-left:0}._3nNInvFwXs_P9gIxRUssPe{-ms-flex-order:0;order:0}}@media (min-width:768px){.-uBPcXtYp9ihZw5YZJALN,._1s03fYFuPsLqRMcG8pBuuZ,._1TFkI74kFWtiGw9kIImgWl,._1vEvH4gHPSy8mXINZYLkkO,._2IA-8ORy61E8LS2-excFp1,._2jBJcp0F1wkihe04iWe1nf,._2jfSaSQApeIS6HTwgkJvvR,._2kxDw68IEnTPw7OhxHYFPi,._2MtVG2Kkjgn6fIM8M6DI9y,._2ndfC3Op6-f3H5-JJ48mxS,._2Zx8DUjtgbHTFWb9cn1yjJ,._3agUl5Dq8NsFu0OSSeFVu2,._3v4V9JwXDVlzAts4oP8QRD,._3Y96kEwUwxn_Zcp-GoELRm,._3ZvpfWjEJ3giGgJn0mp9WC,._8OjniZjQdvUNQzFcDVXVQ,._17FmX5DLSPH7NwySuvd72l,._31R7Z24-E4559-bge7uYvO,._36FMMyk3yCijWGsvIMlp18,._3744ErrgSP70rklc5lqnL7,.jmRT5rs-OUvOqSIlzU3Du,.xibilcuZB_2LOGK1iozZk,.yqbtr8Y3D3MOOsKcuLxf1,.zBy98kdqeohBiEno7vU3V{-ms-flex:0 0 auto;flex:0 0 auto;float:left}._2ndfC3Op6-f3H5-JJ48mxS{display:block;box-sizing:border-box;width:100%}._2osXkRbwDUFLAPPhfCQofi{left:100%}.NyFZV9rJdHKe12rxR223J{right:100%}._33rpFr5MTPZmyYCGcpo5yN{margin-left:100%}._23AROiQDqG5KFWmPjqyYex{-ms-flex-order:24;order:24}._3744ErrgSP70rklc5lqnL7{display:block;box-sizing:border-box;width:95.83333333%}.O_pHUZHoAvEfnIO6D2iCI{left:95.83333333%}.MemVXqcVe6BvC6BR-xDNf{right:95.83333333%}._2S8HPtcpSGqw_FF6icTzlV{margin-left:95.83333333%}.VCsfavrIH_rco4m-Ow8CX{-ms-flex-order:23;order:23}._8OjniZjQdvUNQzFcDVXVQ{display:block;box-sizing:border-box;width:91.66666667%}._2vtAeUImBQJFF9sU1sW4LM{left:91.66666667%}._12Mmzn74J5mjtya7fLWXYA{right:91.66666667%}._2y8PTswp_UpoWscOG0AQCd{margin-left:91.66666667%}._1f8qFLWf-R2UZDEP4usaN8{-ms-flex-order:22;order:22}._2MtVG2Kkjgn6fIM8M6DI9y{display:block;box-sizing:border-box;width:87.5%}._16zqRNj34OgGXjvTMjnYiP{left:87.5%}._3hupFVEahKxltRTxccWy-_{right:87.5%}._2FpVx-OVIJyBVX1jhpP1jL{margin-left:87.5%}.B9mVmlj9sKQIDqE6HtBDS{-ms-flex-order:21;order:21}._2jfSaSQApeIS6HTwgkJvvR{display:block;box-sizing:border-box;width:83.33333333%}._1nJJ7n-VbTTKRqbaP1-GMt{left:83.33333333%}.dLB-cDKGmrEXRs_WZKxIS{right:83.33333333%}._1lKe1RdAItj4PPkzgcDuXC{margin-left:83.33333333%}._27LopC4B_5modlJixc30He{-ms-flex-order:20;order:20}._3v4V9JwXDVlzAts4oP8QRD{display:block;box-sizing:border-box;width:79.16666667%}._3Rwjd48GF8u-LQ-s_0jted{left:79.16666667%}._1TDCpDhtIzqs0OR0VBLyvd{right:79.16666667%}.I-kmTy3YZsY_Ah7YpMj_r{margin-left:79.16666667%}._1nODElcvF2l_VeEgr0p_WF{-ms-flex-order:19;order:19}._3ZvpfWjEJ3giGgJn0mp9WC{display:block;box-sizing:border-box;width:75%}._2PVJ80K633OfMP87mmTHJI{left:75%}._1knzmnf9gxa1ZMSPA_Mmyh{right:75%}.xrs5ckKlEkGvxFjPkupxt{margin-left:75%}._2jHB82hMC9Dsh_qCXLspwd{-ms-flex-order:18;order:18}._17FmX5DLSPH7NwySuvd72l{display:block;box-sizing:border-box;width:70.83333333%}._2DwHRqP1K7urZVlYDDawni{left:70.83333333%}._3uu-TyumqaPUWyqjR9emkj{right:70.83333333%}._2oOZ_8oCCKlQXM22g_hab_{margin-left:70.83333333%}.D2KBbiZsSg_LAkCqp2Jnl{-ms-flex-order:17;order:17}.jmRT5rs-OUvOqSIlzU3Du{display:block;box-sizing:border-box;width:66.66666667%}._1JDrvjAvmaJmHY1hUC9w9C{left:66.66666667%}._1laFRsJnyKGTr0l27795FM{right:66.66666667%}.I3ejEsQ3qDSb62inUf6FO{margin-left:66.66666667%}._3uQVwOiN3wtPIQdErt05Fv{-ms-flex-order:16;order:16}.zBy98kdqeohBiEno7vU3V{display:block;box-sizing:border-box;width:62.5%}.ut8zZBgcumQCq_WLXjGsB{left:62.5%}._1KCsuEk1zADmsEFDa3km6r{right:62.5%}.dOhsx_wiJLaYdWJjD916W{margin-left:62.5%}._3RvLjB_gz6jBWeMl1TW8jK{-ms-flex-order:15;order:15}._1s03fYFuPsLqRMcG8pBuuZ{display:block;box-sizing:border-box;width:58.33333333%}.i6A5DNvlXWvrgYCmv3V1m{left:58.33333333%}.RaAxAvCOFwK4Ph3DBMOpH{right:58.33333333%}._3A_uMzcpAN28LRNiWTCV4g{margin-left:58.33333333%}.XqXFRMph2ouSvqT9KTIZM{-ms-flex-order:14;order:14}._3Y96kEwUwxn_Zcp-GoELRm{display:block;box-sizing:border-box;width:54.16666667%}._1RwoubZ3BAI6lu3hFN-2-K{left:54.16666667%}._1wt_DlyWQgfHamKP6Lmgpo{right:54.16666667%}._1b2ldC42SfrbJCpxp4NdME{margin-left:54.16666667%}._3mcR55o23uPvyzVSeE68wi{-ms-flex-order:13;order:13}._2Zx8DUjtgbHTFWb9cn1yjJ{display:block;box-sizing:border-box;width:50%}.UfCsQyiRY8iSqVVs8GSWe{left:50%}._18-QDJ3wcHjpiUuJfvJ6BO{right:50%}._3ItMtNSvaaDHaXAVwF649o{margin-left:50%}._2dSeM-pZjFzQqrgmfUel7t{-ms-flex-order:12;order:12}._31R7Z24-E4559-bge7uYvO{display:block;box-sizing:border-box;width:45.83333333%}._2xbJEXnKQoutlhCxZGXenp{left:45.83333333%}.LqruxZ6vayDk0iLgjlxQo{right:45.83333333%}.psoEZ2I5zDtPHKaWVsi4Z{margin-left:45.83333333%}._27mljOdDOuicJNfC7cJoYr{-ms-flex-order:11;order:11}._36FMMyk3yCijWGsvIMlp18{display:block;box-sizing:border-box;width:41.66666667%}._1_eqeqbzzbJZq3JdKULt-d{left:41.66666667%}._1bMsliJZFPzD9GgpphHSe5{right:41.66666667%}._3vReo-Tilt-zZVJmgQcLu-{margin-left:41.66666667%}._2A26tt5Keax-MwbGLuNv3j{-ms-flex-order:10;order:10}.yqbtr8Y3D3MOOsKcuLxf1{display:block;box-sizing:border-box;width:37.5%}._125NM7dEz-hIyhb4813KJe{left:37.5%}._1LaIyyPvwpDPC84PwQIN9s{right:37.5%}._3ghYDJID4TeJzLiE3oKXn0{margin-left:37.5%}._16kdaS8VnuELRj3bxRp1jX{-ms-flex-order:9;order:9}.xibilcuZB_2LOGK1iozZk{display:block;box-sizing:border-box;width:33.33333333%}._32mKkuHVyDik_ENgV1RhXq{left:33.33333333%}._1BoZWcT8YgeAsmmWxSOJ4a{right:33.33333333%}._1kSw0SLcltx1jYVt0l9CFu{margin-left:33.33333333%}.F-vnQfHd12KDdNNhYMfXY{-ms-flex-order:8;order:8}._3agUl5Dq8NsFu0OSSeFVu2{display:block;box-sizing:border-box;width:29.16666667%}._3pNxulVv6eF7PwUbzG5U_s{left:29.16666667%}._1oipe1KoxlAuJaAKIwA_Jc{right:29.16666667%}._36lrhw_DngtYuIWmfvncrC{margin-left:29.16666667%}._1mtuj6CQgJz2JrWbV29Psu{-ms-flex-order:7;order:7}.-uBPcXtYp9ihZw5YZJALN{display:block;box-sizing:border-box;width:25%}._3kNYPmx6oOFsE-ohG7dwL0{left:25%}._2UBazrsfh-m8C2msMz4Q9m{right:25%}._225M9GYfR-3NGO0xed9qPY{margin-left:25%}._35jcMCtG7hsJs0z4Xw2J9Y{-ms-flex-order:6;order:6}._2IA-8ORy61E8LS2-excFp1{display:block;box-sizing:border-box;width:20.83333333%}._1Pdw7FKYnXJatA5tSaOWkR{left:20.83333333%}.o_nxh7dwz4WvxlquOogfR{right:20.83333333%}._1wvyM3V9Uc9Rq7LR8CtqEK{margin-left:20.83333333%}._15p_J7edQvkt1Y7IhYg3d2{-ms-flex-order:5;order:5}._1vEvH4gHPSy8mXINZYLkkO{display:block;box-sizing:border-box;width:16.66666667%}._3ptXmc2-ZhbDiajvyqGDSN{left:16.66666667%}.XtbHy20QkwbM_udn_ce3v{right:16.66666667%}._1jdGRDYAomJjKHSUqlK_wV{margin-left:16.66666667%}._2VvfckkibEhWOrB0gvOSGu{-ms-flex-order:4;order:4}._2jBJcp0F1wkihe04iWe1nf{display:block;box-sizing:border-box;width:12.5%}.AWflC3bdWyeIDUgNEb58{left:12.5%}._3-6Mr5xCHrnGCfwQrC2vg-{right:12.5%}._3uJVb0xGvxSYmXJz9awDKs{margin-left:12.5%}._1Baxflf7UkHrMDVjBJMmAQ{-ms-flex-order:3;order:3}._2kxDw68IEnTPw7OhxHYFPi{display:block;box-sizing:border-box;width:8.33333333%}._2aEnM2xwQv8Ie1XqybIVZr{left:8.33333333%}.kpEB_WNP9W0iFawewT8RE{right:8.33333333%}._3DVgcwDzltf8zjGTaapx_8{margin-left:8.33333333%}.Zybxe5UV2TQ4GtJfRs2Ad{-ms-flex-order:2;order:2}._1TFkI74kFWtiGw9kIImgWl{display:block;box-sizing:border-box;width:4.16666667%}._2Vdoda-x7RUK-KL__7It4q{left:4.16666667%}._3FhFtxGCb8_bdvbQNqaQOQ{right:4.16666667%}._34UvqXj5tJuEWCf6AThgKH{margin-left:4.16666667%}._1woB8ms5cjMLVzc6Pa7fDt{-ms-flex-order:1;order:1}._1KlSwwBN2mV6iUJA_8EcD0{display:none}._3eh9FwIUqNXQ75ZS1KOHUF{left:auto}._19fhy1NkdCWgU0GwLjJ-B2{right:auto}._3_cSfil07EZdnW6bOHW-3j{left:auto}._2kLonuzJYLXjjVAE3kI-vj{right:auto}._1GS15Hjz7v82QkQjyIcfEH{margin-left:0}._3b49yxoRGWFvH1PDmB_2gO{-ms-flex-order:0;order:0}}@media (min-width:992px){._1a3H8pRTRilnk3hOaQJhVz,._1bsf_E1csA87xJq8vx3SYT,._1CygQb8PSoqm6-iT926gmO,._1kBCXD3cFNBkOPstuIVBTs,._1PLFNpOrbaG7oiBiR7gipJ,._1Rp147IjrGFnXdoOuXyHUG,._1yCJ-sDDSCjS1mVMOkhiE-,._1YPj7v7dy0_YFPZ6CFlTnc,._2CGXrecS6VMTsfEB8fOj0T,._2flvK6CrnX9pIJVL2tzV4D,._2T-tOig9i2gwf3xQivoxBI,._2x82hSPkSbLrWu1u_IuaBS,._3-mWJlec57C1Fx_9lQVOIo,._3NYFS_uipYqCPD2KuZZ95e,._3o97Hmk6kzYIelTMDQWkYE,._3Ocm-iTvjR0mrXuuJaKks3,._3Qix4GsW4eMZHyWfEfVfsX,._3SjZB9d1sw2bLwLiq7gvCg,._3trs0zD59rOIar_6GtdYuz,._4pSZ1tb9bcmVOqTm1RnS0,._31H3EA3W2I2jvzzFEU8XR6,._32vXsJ026qkOYO3u9PteM3,.n_eDAHREa5E2V4Jldvkfm,.pih3Q66IulQCubsjoEJFC{-ms-flex:0 0 auto;flex:0 0 auto;float:left}._4pSZ1tb9bcmVOqTm1RnS0{display:block;box-sizing:border-box;width:100%}.ml1l-PW40kIJP-N6n5Jx9{left:100%}.eC-WhX35ozF0KhlF-sbTd{right:100%}.SLTJ0UeBXv5ZndZ8GcG7M{margin-left:100%}.UyXJ2GSZf2NWnwQWZesrj{-ms-flex-order:24;order:24}._1YPj7v7dy0_YFPZ6CFlTnc{display:block;box-sizing:border-box;width:95.83333333%}._2MO_FcBG30S6OFhx2A4Wb7{left:95.83333333%}._3cD72ZasXpxrFWCS3LqeMQ{right:95.83333333%}._3697IlAFaseE89nLy3NjLP{margin-left:95.83333333%}._3uehUvvMXdMuacTfchkGnj{-ms-flex-order:23;order:23}._1yCJ-sDDSCjS1mVMOkhiE-{display:block;box-sizing:border-box;width:91.66666667%}.POLbxw1IDuqhwSV2ZX4kC{left:91.66666667%}._2dLwJRKNZsig6Po0Gb-26g{right:91.66666667%}._2jfIoYuwH2mG0qxYDSX1PY{margin-left:91.66666667%}._2at3tvCCQg24kqBrDGXzud{-ms-flex-order:22;order:22}._1PLFNpOrbaG7oiBiR7gipJ{display:block;box-sizing:border-box;width:87.5%}.rxGGNT5TQqMP1pP6z1Vd5{left:87.5%}._2sQ0JATZ3JVRG5j0DhPnSB{right:87.5%}._1MTMKErivD6xMaJI4qI-dX{margin-left:87.5%}._2iHLlGBR_3bpQCow6va1tm{-ms-flex-order:21;order:21}.n_eDAHREa5E2V4Jldvkfm{display:block;box-sizing:border-box;width:83.33333333%}.XrIHkJ30HrP_MHe3qNRLS{left:83.33333333%}._1v4ZbulGZciOU6HnM898BD{right:83.33333333%}._2Cd1sUl3SJ6n6R8JlWEhAz{margin-left:83.33333333%}._ZlI-XlvWdb7KQUNajPm6{-ms-flex-order:20;order:20}._3o97Hmk6kzYIelTMDQWkYE{display:block;box-sizing:border-box;width:79.16666667%}._1yU58L78rp4fONj530R_DR{left:79.16666667%}._3zDzuUYYih5wuO3Ka0sklo{right:79.16666667%}._2JewnKyvxOoFrgVQxMEH28{margin-left:79.16666667%}._3_DRPkguww2Wvi4TS9Qx5J{-ms-flex-order:19;order:19}._1CygQb8PSoqm6-iT926gmO{display:block;box-sizing:border-box;width:75%}._2eTQk9j2sMwtHQCROzYSSj{left:75%}._1MUcCWWgYTWC5Q7nWjyEu1{right:75%}._1lQr3h5W4y04s54ATbSwtq{margin-left:75%}.UItj7QL6yrldC7EWJ_zJz{-ms-flex-order:18;order:18}._2x82hSPkSbLrWu1u_IuaBS{display:block;box-sizing:border-box;width:70.83333333%}._2g6GNok5Iv9oTV_HKTI1iB{left:70.83333333%}._3LJ-QaMdt2LC9rk2TZMtVu{right:70.83333333%}.SXEuyzXQC98nTUspuYsR7{margin-left:70.83333333%}.sWXp1c7EWoxxJBrI4vBAk{-ms-flex-order:17;order:17}._2CGXrecS6VMTsfEB8fOj0T{display:block;box-sizing:border-box;width:66.66666667%}._15sIri6tpuhuUnTD5a5fjs{left:66.66666667%}.YxXH1eebf7TNYgpQ0Uhw3{right:66.66666667%}._2cJoCJiudRixXjYHmYODc4{margin-left:66.66666667%}._1kPLHFzRz8ZfuNZ6isf0ih{-ms-flex-order:16;order:16}._3SjZB9d1sw2bLwLiq7gvCg{display:block;box-sizing:border-box;width:62.5%}._1Zpm1UJZTfTD098VmWyuh-{left:62.5%}._3i4OI1IPWaPZGZqjmG7UkC{right:62.5%}._2y5W1H1YnsgqQRtiYjD69i{margin-left:62.5%}.XIOZLLvOQ0ZKv-Y9oBRcI{-ms-flex-order:15;order:15}._31H3EA3W2I2jvzzFEU8XR6{display:block;box-sizing:border-box;width:58.33333333%}.fje_3etFQ4hqJzMz0WDOY{left:58.33333333%}._1TATdh5cFn8rQETie4yhqq{right:58.33333333%}._11xkEJBox-C7QxcWUF705y{margin-left:58.33333333%}._23OzedXcUUw8g8rkvF5BOZ{-ms-flex-order:14;order:14}._2flvK6CrnX9pIJVL2tzV4D{display:block;box-sizing:border-box;width:54.16666667%}.r8hzaY-gZeV76PLJcEnRM{left:54.16666667%}._3IHx0TrXB9mppdnq0gicUb{right:54.16666667%}._1WGWWDlW_TTMvfgThDqsI4{margin-left:54.16666667%}.GFS24ntBQDQz2S4mEaA3q{-ms-flex-order:13;order:13}._1Rp147IjrGFnXdoOuXyHUG{display:block;box-sizing:border-box;width:50%}.MteW_96FVQ2tPd7_r-ifG{left:50%}._3hY65YxS6V17Ih0QugKM7{right:50%}._3w5rgyT4N4Cc7bySZRByhD{margin-left:50%}._18CzmO6Aw08KWbvbuqjOjn{-ms-flex-order:12;order:12}._3Qix4GsW4eMZHyWfEfVfsX{display:block;box-sizing:border-box;width:45.83333333%}.E20-qKnTDEBypMm3iABNt{left:45.83333333%}._3gu7bHGpbb0z42GYIIUnJ6{right:45.83333333%}.khOV4yrgvPi6lIPQWNBf-{margin-left:45.83333333%}._1Gg-URA8qjuVk91hVe3ELE{-ms-flex-order:11;order:11}._1bsf_E1csA87xJq8vx3SYT{display:block;box-sizing:border-box;width:41.66666667%}._36vlND5rvb8eLv1KEyz1JE{left:41.66666667%}._2wPd0bIImHuNlMK1Dly3Fe{right:41.66666667%}._1M31bNM1VQSQa_CQDoPPIG{margin-left:41.66666667%}._3B0HT7jEaA78KSl8ygdROf{-ms-flex-order:10;order:10}._3Ocm-iTvjR0mrXuuJaKks3{display:block;box-sizing:border-box;width:37.5%}._2UD129ZqLqpeutAD2TRO-E{left:37.5%}._2LS2n3ppUS_-7RL5OqBxP9{right:37.5%}._SNWkerHQLl5fAAOPQZaS{margin-left:37.5%}._10Z5HEnAuvdhhr3CgtYJbG{-ms-flex-order:9;order:9}._32vXsJ026qkOYO3u9PteM3{display:block;box-sizing:border-box;width:33.33333333%}._2uPklkhYHLtdcru5FCPHT8{left:33.33333333%}._2ztLUsgUeEwmqZIPrQSIXX{right:33.33333333%}._18vOcjI7xw1pbLw3Gm4QLr{margin-left:33.33333333%}._9oV0-3MWCQuGYq4SW4EC9{-ms-flex-order:8;order:8}._1a3H8pRTRilnk3hOaQJhVz{display:block;box-sizing:border-box;width:29.16666667%}._2POX3l5XUM8OM_Jmmue4zW{left:29.16666667%}._2iaZlndH3lz24sserGvNg7{right:29.16666667%}._3fEHBmYc5HPE2tD1jI4gS-{margin-left:29.16666667%}._1cSop9Rihe0NigtjDmRlJi{-ms-flex-order:7;order:7}._3NYFS_uipYqCPD2KuZZ95e{display:block;box-sizing:border-box;width:25%}._8ATZI2bAEO8h4Y22q5w3E{left:25%}.RBwCk62eVr4WxtVIm3b9w{right:25%}._3EmbHGd5344u9H-O7QiNSq{margin-left:25%}._3z-dhNPyNMq31RriZNYh33{-ms-flex-order:6;order:6}._1kBCXD3cFNBkOPstuIVBTs{display:block;box-sizing:border-box;width:20.83333333%}._2xMzv5-Tl3JP3NKWJY08Un{left:20.83333333%}._12rt-6jkWizWaRu2_zE3KV{right:20.83333333%}._3osrCHrd-1_pFAPT7DaswF{margin-left:20.83333333%}._3rdjS9B2RQjNkQHwjw_f-r{-ms-flex-order:5;order:5}._2T-tOig9i2gwf3xQivoxBI{display:block;box-sizing:border-box;width:16.66666667%}._3jWVgDK5rUj0XNXMbYdqHK{left:16.66666667%}._2t0houF0jDz_4jkr8ziBI{right:16.66666667%}._2w68dqt176peMBiUCLxC6-{margin-left:16.66666667%}._2asbusOWJWwjdrN6tKrk83{-ms-flex-order:4;order:4}._3-mWJlec57C1Fx_9lQVOIo{display:block;box-sizing:border-box;width:12.5%}._1mxy6SGjib5KDdXvr9WYdZ{left:12.5%}._173tmKVQkDDx-3Tn2YElR1{right:12.5%}._2YqTqNoNOFJ3Pnqpugwb_L{margin-left:12.5%}.sFHoE9Y_Udxw9WJjjjo2A{-ms-flex-order:3;order:3}.pih3Q66IulQCubsjoEJFC{display:block;box-sizing:border-box;width:8.33333333%}._2snx0IdaWnjj81GOyRufye{left:8.33333333%}._3J7vjnZQl5wLKWFaosH6Ui{right:8.33333333%}._3lCubDQomfkfqTKjzyWxp5{margin-left:8.33333333%}.zx-jzZJ44CAkwM6BBS0oe{-ms-flex-order:2;order:2}._3trs0zD59rOIar_6GtdYuz{display:block;box-sizing:border-box;width:4.16666667%}._2yyxubI5r-0Ma808cuScfy{left:4.16666667%}._3AoBpSAzwu-DNthMK_Rorq{right:4.16666667%}._3kR5sm7KmAjIvAMR98p5P4{margin-left:4.16666667%}._2iBr11dbMKSv7ADsUyUrhr{-ms-flex-order:1;order:1}.hFkfJN9IKdVcDPQ9aejj0{display:none}._3eh9FwIUqNXQ75ZS1KOHUF{left:auto}._19fhy1NkdCWgU0GwLjJ-B2{right:auto}._1bHnC1uON-3Su9TRSBkzSd{left:auto}._2JNu0RCbvXRtCdlrgeghsS{right:auto}._3EeMqbEG2e3rQa3XNenKZJ{margin-left:0}.__lcQ0hr5q4nlQRB23S5l{-ms-flex-order:0;order:0}}@media (min-width:1200px){._1guHYgWfw11KXDTvyw-1k,._1it3WWIC0U7Id1rXPGdSK-,._1J3OoneBjv10xgQHcGtbA_,._1QvHZrZ0esmSqgGQZdUsBt,._1SJZLtxI5Oge5Bz5yCzSfQ,._2E6or72vO9eOxJWrnpTORn,._2NGVk15Et-bAuvNJt_T_E8,._2oKMSPHC8SqbhssFijPsu3,._2pSBUjBzsR9oas2R3sNTx,._2R5w3p2oZAQoOWHPmi6yXC,._2rZ-FwDcnzkn-jYnSD2zBn,._2Sp8MhIm4qvHoP1cgYRlTo,._2T0jsoPffEAbUYB-lZbV_t,._2u4B6ZeePw980lqHPx71QP,._4Pp-27JoOSdkPeP_2FXPe,._10TSdrDX-D6mYY2aKBDNsq,._31HZwMVcGaVes6WEW8i2qa,.Al-Q0caU4vMWEws-hQLNO,.lQ6DWhEa2w9s1m1C6vfTt,.mXMYmo4QGS04XypadT_C8,.nQZ9B-eKoAbJz2FQ7GfJe,.qD8SOqnk4gCEL4GowsEtd,.ZGLZoM7utN_TlvJjg2mgE,.Zttg5EszsRpN0KEx3S7YE{-ms-flex:0 0 auto;flex:0 0 auto;float:left}._1J3OoneBjv10xgQHcGtbA_{display:block;box-sizing:border-box;width:100%}._1hEk9g00rPKiPPZP9dichG{left:100%}._3GS4vdVK4HJeIWUrquZbNf{right:100%}.K3ohez1NZ8zsfMFwh6-Dy{margin-left:100%}._2Z0D7foLs4xJyxbxTelk3P{-ms-flex-order:24;order:24}.Al-Q0caU4vMWEws-hQLNO{display:block;box-sizing:border-box;width:95.83333333%}.e9IbMUDXFYYg4w1aaPTqs{left:95.83333333%}._3OgZCdo7XPaiPO5kuj5QK5{right:95.83333333%}._1mM4e5lxeQXmTMfr4goa-F{margin-left:95.83333333%}.TwaSjTn-m1aHwWwLiI6-q{-ms-flex-order:23;order:23}._2rZ-FwDcnzkn-jYnSD2zBn{display:block;box-sizing:border-box;width:91.66666667%}._1gJWertmzZgSdLXQbYeQBr{left:91.66666667%}._2sKOiOiZLIgURgiK02dWPK{right:91.66666667%}._2D7g2J2zOnr_563P3bggVL{margin-left:91.66666667%}.-Lk8lMJuwV7YUsLLVEyNi{-ms-flex-order:22;order:22}._1QvHZrZ0esmSqgGQZdUsBt{display:block;box-sizing:border-box;width:87.5%}._1fWoCpT1bUdXVuggu5uD_E{left:87.5%}._1HD-TI5N5Ncd9WFiez_h44{right:87.5%}._1obmQDI-nbT1HsCw41Krag{margin-left:87.5%}._3XyaasS4Ku9eI57cgymMrm{-ms-flex-order:21;order:21}.ZGLZoM7utN_TlvJjg2mgE{display:block;box-sizing:border-box;width:83.33333333%}._3tj_p64kAb49zfEMT5Dz_B{left:83.33333333%}._1pfjqr-JoibcJb3J6rbKzc{right:83.33333333%}.gtroiDsdFApoCep0741r3{margin-left:83.33333333%}._3emkbLlGgIA9Hgcfn1ssKC{-ms-flex-order:20;order:20}.qD8SOqnk4gCEL4GowsEtd{display:block;box-sizing:border-box;width:79.16666667%}._1k_TDqEUt7o1KU59zzhj3j{left:79.16666667%}._2D0Avs5etCn6XkXssNEC1s{right:79.16666667%}.oh6lEhmo62uN5kca74YQu{margin-left:79.16666667%}._2CGKVRsnWqkwAXUCMTWYyE{-ms-flex-order:19;order:19}._1guHYgWfw11KXDTvyw-1k{display:block;box-sizing:border-box;width:75%}._3C-VBUfeIl5hojENnkLQEP{left:75%}._3FwywuDQ4znSzg2m_pmjbV{right:75%}._27hz0uy0osUF4Vi-DAUoDk{margin-left:75%}._3WWWLo1QCjQ9enjYWUxlkF{-ms-flex-order:18;order:18}._2E6or72vO9eOxJWrnpTORn{display:block;box-sizing:border-box;width:70.83333333%}._2aIFCV5HZ8ViwKIFQMgGqE{left:70.83333333%}._1NC9ieG7ye0wKtmF-UA11F{right:70.83333333%}._2EbD5-rv0Rl1_AcxcO4rvM{margin-left:70.83333333%}._1xSOjQdC-UEL5_Kz546Bhg{-ms-flex-order:17;order:17}._31HZwMVcGaVes6WEW8i2qa{display:block;box-sizing:border-box;width:66.66666667%}.ANlBcyBRyqBDlOjTjc3aT{left:66.66666667%}._32jWa6hKbUyrDWeh-ecyXf{right:66.66666667%}._1K9BzHcRxuznJXMTv_m9t1{margin-left:66.66666667%}.ns6npy3ZNuM_pbtQYHVay{-ms-flex-order:16;order:16}._2pSBUjBzsR9oas2R3sNTx{display:block;box-sizing:border-box;width:62.5%}.l2YzjkB3urbA_6HDmxrAh{left:62.5%}.b4tW4vLuE7TxdgmNfJG_R{right:62.5%}._3gAGE5M2cN7RiknwGbjwI5{margin-left:62.5%}._28m8faKRRYxTbwflWxVi3X{-ms-flex-order:15;order:15}._10TSdrDX-D6mYY2aKBDNsq{display:block;box-sizing:border-box;width:58.33333333%}._13GPL1HbDnRxj0Hw9bjecz{left:58.33333333%}._3VVzy58aozTYugTxGpVMMr{right:58.33333333%}._1M-lbE-L5EjvM0K_J177Yz{margin-left:58.33333333%}.DTrOhB-t5rkQR0snBuyFf{-ms-flex-order:14;order:14}._4Pp-27JoOSdkPeP_2FXPe{display:block;box-sizing:border-box;width:54.16666667%}.nUIDwCvJko-zMhbYB_2UQ{left:54.16666667%}._3DUO6j5r7k5-Yb1YRJvy_-{right:54.16666667%}._37qDw8YVZTrzy5vwopouTS{margin-left:54.16666667%}.Aogknsk_1q1TnBkXcNGtn{-ms-flex-order:13;order:13}._1it3WWIC0U7Id1rXPGdSK-{display:block;box-sizing:border-box;width:50%}._28JXI4I0waFOlwneDnI3lp{left:50%}._31GfGtZ7H5SVhiSAOztmuQ{right:50%}._209D2FPSd-smwM4iDNupHL{margin-left:50%}._3ZPM36SCV_WjPZwLPd1pID{-ms-flex-order:12;order:12}._2T0jsoPffEAbUYB-lZbV_t{display:block;box-sizing:border-box;width:45.83333333%}._3xn0mcTAiGXldCYSwvz_ju{left:45.83333333%}.f_glQ1CyS1qwyq6Zg6eVE{right:45.83333333%}._3TxTrLd7kVSQuOIeH2g6Rq{margin-left:45.83333333%}._1yOB3d24qtmbQ8g-Eqtrj-{-ms-flex-order:11;order:11}.nQZ9B-eKoAbJz2FQ7GfJe{display:block;box-sizing:border-box;width:41.66666667%}._1KIgeHrAHZNmfC-UBbNFNZ{left:41.66666667%}.bK5ESXjIHZ13VVwovgmgL{right:41.66666667%}.cLvPd7lh1X-0Tz0mgOvjI{margin-left:41.66666667%}._3Dh5Y_6sJXaIV-QNjoa5ld{-ms-flex-order:10;order:10}._2R5w3p2oZAQoOWHPmi6yXC{display:block;box-sizing:border-box;width:37.5%}.dPxgGmPqJV2rJI_ryCLy0{left:37.5%}._3cevUDalLjKwkBivdDEIkD{right:37.5%}._2Ky35JYZfcYBt5UZRAMxOy{margin-left:37.5%}._3kDBzWQY3ELwQhviTKBc09{-ms-flex-order:9;order:9}._2Sp8MhIm4qvHoP1cgYRlTo{display:block;box-sizing:border-box;width:33.33333333%}.JDkVYgOAFoyiZ5Y4kDpH9{left:33.33333333%}._2p_4gzgnDy32dTR3oIMh_m{right:33.33333333%}.zid5uOcv-xbBfvn4WeRO_{margin-left:33.33333333%}.UM1IiN4xIE9Lx4okwCNe7{-ms-flex-order:8;order:8}._2oKMSPHC8SqbhssFijPsu3{display:block;box-sizing:border-box;width:29.16666667%}._2i7GLDKwd8ZBSGAk9cPHw2{left:29.16666667%}._3zVdXFxfEeqIHJYxxO68e6{right:29.16666667%}._1A7R_IL7W6U7Fk8wgdrBuK{margin-left:29.16666667%}._2StR3vcSXcj4r2J7p8dMPd{-ms-flex-order:7;order:7}._1SJZLtxI5Oge5Bz5yCzSfQ{display:block;box-sizing:border-box;width:25%}._3MynzZBARVH8AqrroYSrmf{left:25%}._1EaThxFq-sb0pYx1qiTlz7{right:25%}._28RCgIbjGGj_wz3yE84XvS{margin-left:25%}._4rtUaQsL8LO8iQJse4m1C{-ms-flex-order:6;order:6}.Zttg5EszsRpN0KEx3S7YE{display:block;box-sizing:border-box;width:20.83333333%}._1YQ3YWvqTu9t2lF6kG_eL3{left:20.83333333%}._1pjnsjTMeNn16UFjR8qdEE{right:20.83333333%}.KVDTNvowQJQzNoaN6aOSI{margin-left:20.83333333%}._1NJZDVUxnCd5toLogaTucT{-ms-flex-order:5;order:5}._2NGVk15Et-bAuvNJt_T_E8{display:block;box-sizing:border-box;width:16.66666667%}._3dsR1JaR6WIkTDjYXxzKNS{left:16.66666667%}._3xt8uNeclc82Ty4_GbMOJj{right:16.66666667%}._3TyHo-G18haPlIZdLKaka8{margin-left:16.66666667%}._1rPK9qDRcr-hvdH3tZJV1R{-ms-flex-order:4;order:4}.mXMYmo4QGS04XypadT_C8{display:block;box-sizing:border-box;width:12.5%}._3EutNMQyLFFAzWeD1cYjqV{left:12.5%}.MvGv3xwAhavqmVzqS8Pwi{right:12.5%}.MzAGgaR5wLBkaWGoBgLFH{margin-left:12.5%}._3ybj4XrkgnxxJP4RAGnK2O{-ms-flex-order:3;order:3}.lQ6DWhEa2w9s1m1C6vfTt{display:block;box-sizing:border-box;width:8.33333333%}._1BYWvMiFR9ZQe2wuKu7Mqv{left:8.33333333%}._2A767bn6TCjRgdRMH5La_6{right:8.33333333%}._1KUb9sV2JWDYxYeDYvxYCn{margin-left:8.33333333%}._36rvBebbrxbUTGj4KtyiRU{-ms-flex-order:2;order:2}._2u4B6ZeePw980lqHPx71QP{display:block;box-sizing:border-box;width:4.16666667%}._2CDsLO0g4jZS8HW7vcOuIV{left:4.16666667%}._1E6qHbsggoA7h2hLdvj-h0{right:4.16666667%}.lvmcIdM4j-E4tkQhyZYUp{margin-left:4.16666667%}._2JPEPd0el3GC68EBhdT5iL{-ms-flex-order:1;order:1}._2S63Xo5sZhQn_SmD_Wdg7b{display:none}._3eh9FwIUqNXQ75ZS1KOHUF{left:auto}._19fhy1NkdCWgU0GwLjJ-B2{right:auto}._1IAQJfMYYLi2KYzOS43xXu{left:auto}._3IUyl1vd0lJhDXf_RHUyfP{right:auto}._1nOl96OTmwr75dDYAtdrob{margin-left:0}._2DrSyUL828TgJBnz6RStrj{-ms-flex-order:0;order:0}}@media (min-width:1600px){._1EG5J1cWF_ogmqtyjTfGPr,._1nW_B8lXAp9exlOEmWlkQZ,._1sfRdQyTe8lNKnKR-RMQt,._2-uXedP42hUmCzw8ExLTfl,._2_3A0saCeMioqOm1fHoGm0,._2_MPZOieQch1LB7k6Pk9pI,._2BaIHc1iNTuth8PZcCyvql,._2CYQCnzfU0CDDgZNeSLuL1,._2oNN0K5xRP3EqNnSEDEcFp,._2P9ydIYICB-KrGCn0yQOua,._2RL24ZKgg9ok9Xm4Z0HqT-,._2y2gYtN-bqHbv1eAOYXJY1,._2YtXR56LqlOsroASAhSDAG,._3khb_kpkYBsU5JCWtz_4d,._3prxOAvth--PxF8QzX6PFF,._3YcI64pDPNGivQ3hUzolOd,._20_gCcMkAfQt2biPuYonmH,.f0b6URYyWggWyR8xnth3l,.Ov_eqIdK6yqXNZE3RqjM0,.q3bJHWhPFHlyZvHdwn-OX,.r42pdeug_JdJnrsyIx9nq,.SaReG32YWslniRY4NvGsU,.UYl2JwwfaTyYfFeuo4dAv,.xwY9vkGCKrbYzgsn6oWFx{-ms-flex:0 0 auto;flex:0 0 auto;float:left}._3YcI64pDPNGivQ3hUzolOd{display:block;box-sizing:border-box;width:100%}._1a6Ch7g3jF7ZjGDMFBuVhf{left:100%}._3CICZ2_bWphufLwX_O-9Cb{right:100%}._2WcdN2VTA9Dvkz7_C6DTGj{margin-left:100%}._2XZQstDeJm6mG6uosMJOy9{-ms-flex-order:24;order:24}.Ov_eqIdK6yqXNZE3RqjM0{display:block;box-sizing:border-box;width:95.83333333%}.Y1DzG6gypM2yXXjrrrUHS{left:95.83333333%}.CnqlV_EXIvCsVAJUb2AmN{right:95.83333333%}._1NpTmAtJRfAi3KdWNFJTVP{margin-left:95.83333333%}._3TP_b6pB7bunWsV-d89Mj8{-ms-flex-order:23;order:23}._2y2gYtN-bqHbv1eAOYXJY1{display:block;box-sizing:border-box;width:91.66666667%}._3LuPmXknljmiaYe25O7g-C{left:91.66666667%}._25j7BZ41KV5lvlBSXlFn1J{right:91.66666667%}._34EuqobfdK6viQd_A3eYR4{margin-left:91.66666667%}._37MQqGfBwx9IO1Y-RH9Dor{-ms-flex-order:22;order:22}._2BaIHc1iNTuth8PZcCyvql{display:block;box-sizing:border-box;width:87.5%}._3WjdIfvpXMTjCEKUhrtbMn{left:87.5%}._3AD2yZm82-nHu-VWcrIe2G{right:87.5%}._2YYsEQBA0TJhBeHKlH2ef5{margin-left:87.5%}._1IKIDwWLQIDY3DMf0czZ4s{-ms-flex-order:21;order:21}._2_MPZOieQch1LB7k6Pk9pI{display:block;box-sizing:border-box;width:83.33333333%}._19SdZ3YvGkKqEyHaTgxcAI{left:83.33333333%}._3eNn-fNcGDYg5LW8f1zAxi{right:83.33333333%}.LPuXR8xJZz68PFgmpji7z{margin-left:83.33333333%}._1GIUQkvXyI1FfTxRP-GsGO{-ms-flex-order:20;order:20}._2YtXR56LqlOsroASAhSDAG{display:block;box-sizing:border-box;width:79.16666667%}._24dJzhnfKPmmmyEGwcJKEc{left:79.16666667%}._3wCzCXELIyne9yN2vSfnUB{right:79.16666667%}._2gF8qUGIBVb3sQDYgmTpaW{margin-left:79.16666667%}._1fa8xOACH554m9THUvOsbC{-ms-flex-order:19;order:19}.f0b6URYyWggWyR8xnth3l{display:block;box-sizing:border-box;width:75%}._2fFvOyI1it0w9uBhjba-7R{left:75%}._1faVha5c_LuvUWB6Gjw2n{right:75%}.C2el5trqwVBcXjCHHYngB{margin-left:75%}._3o1fFhb4Uvj5lxpMZodCiv{-ms-flex-order:18;order:18}._3prxOAvth--PxF8QzX6PFF{display:block;box-sizing:border-box;width:70.83333333%}._30Ye9x8OJf_ns1HjPBSO6i{left:70.83333333%}._3IyJeXCMkZUyaKkSJqJOdg{right:70.83333333%}._3NOmS9a1SAAHTPi6NK_vjJ{margin-left:70.83333333%}._1RWxWFkWShkGxIOYMwnMXs{-ms-flex-order:17;order:17}.xwY9vkGCKrbYzgsn6oWFx{display:block;box-sizing:border-box;width:66.66666667%}.nPKF6ttGX2wTgYQHnHCsS{left:66.66666667%}._1QaP1mmX_2p881bUPX07nF{right:66.66666667%}._3Ox7akspwROOK--X_c8ZT3{margin-left:66.66666667%}._3HD20IkBvDK_VmT774yKH0{-ms-flex-order:16;order:16}._20_gCcMkAfQt2biPuYonmH{display:block;box-sizing:border-box;width:62.5%}._1nFt1w7CTWEHlG4yVt5Yj5{left:62.5%}.P8d6fSMtG4eZZXX_VN2n2{right:62.5%}.hnto4nT9QTHPCHtk6GcEh{margin-left:62.5%}._2DspK8QKaXesgw3J6DUcMG{-ms-flex-order:15;order:15}._2CYQCnzfU0CDDgZNeSLuL1{display:block;box-sizing:border-box;width:58.33333333%}._1QUgl4BfcjlHm7x9Kn1A6j{left:58.33333333%}._4qKh0hizn4HF4AsTQBRk0{right:58.33333333%}._2AtHCBwXxmMUS6J72XHHL0{margin-left:58.33333333%}.pCSU_Fi6oAt8r7BUHhyAK{-ms-flex-order:14;order:14}._2RL24ZKgg9ok9Xm4Z0HqT-{display:block;box-sizing:border-box;width:54.16666667%}._2k52URtxidPY1zBkPWgh5b{left:54.16666667%}.er1cObXfoocbQxUsBgqEE{right:54.16666667%}._38BXB0fQ6BS9qv5g4fQZJI{margin-left:54.16666667%}._3L5BLzaEUIZW9lMmcUuXV5{-ms-flex-order:13;order:13}.q3bJHWhPFHlyZvHdwn-OX{display:block;box-sizing:border-box;width:50%}._3XwxWfNfNelxSO9s2c405c{left:50%}._2Wzvot5Y1a0sC1NXy-1Lg5{right:50%}.KPjIlFTT_wxab72e1Rz5I{margin-left:50%}._3fboNjO_Ec_07FtaxrK_OO{-ms-flex-order:12;order:12}.UYl2JwwfaTyYfFeuo4dAv{display:block;box-sizing:border-box;width:45.83333333%}._3ASrzQ4aTUnc545h6iJtuq{left:45.83333333%}._3XVuQA38gdt091661PXjdo{right:45.83333333%}._3-M-keh9Mih8OxgaGjZg9j{margin-left:45.83333333%}._22-paAjRm5kHy6lT3Q6Kek{-ms-flex-order:11;order:11}.r42pdeug_JdJnrsyIx9nq{display:block;box-sizing:border-box;width:41.66666667%}._6pJk7ecDun5IrBPRgEma-{left:41.66666667%}._1GjVdTT549YL3JS5Hp8mbr{right:41.66666667%}.JCuOrL29ZSOs6lAMTWMq6{margin-left:41.66666667%}._3M3RUwU5hKcrLlAWQ_fwV1{-ms-flex-order:10;order:10}._2P9ydIYICB-KrGCn0yQOua{display:block;box-sizing:border-box;width:37.5%}._3u6OEPaoyQEmxL_5jEB6j9{left:37.5%}.Je8QtTfL7dwtg9nL2vOKL{right:37.5%}._26WdT0szPiRUnbQgGUcWMj{margin-left:37.5%}._2nNNZCPMnJE9j6Yy9GGJzl{-ms-flex-order:9;order:9}._1sfRdQyTe8lNKnKR-RMQt{display:block;box-sizing:border-box;width:33.33333333%}._3gn64_-BBysH9456jAU6EK{left:33.33333333%}.BztFkdWrvkNNfL-pLzvaD{right:33.33333333%}._1u34BQ7w3q6wWlk0-KH6QH{margin-left:33.33333333%}._1qbcMLazCRT85ioLJXaPHV{-ms-flex-order:8;order:8}._2oNN0K5xRP3EqNnSEDEcFp{display:block;box-sizing:border-box;width:29.16666667%}._2EJDOcESPVX-E9pLGUkMQq{left:29.16666667%}._6Y9A9VXvDfzb8oxG9UpKx{right:29.16666667%}._2malPz0Zkg6x0TuneYRAe_{margin-left:29.16666667%}._2WMWdGaIxdjU3X7peoDIok{-ms-flex-order:7;order:7}._2-uXedP42hUmCzw8ExLTfl{display:block;box-sizing:border-box;width:25%}.CLMEOQCY3Qzqhf-TqpXRV{left:25%}._3_hanp0Im22opo51oyXXiF{right:25%}.gbSLfzildJ3jSCzSNL5-K{margin-left:25%}._3KhXPpn33RsnLRDR2Q4O4f{-ms-flex-order:6;order:6}._1EG5J1cWF_ogmqtyjTfGPr{display:block;box-sizing:border-box;width:20.83333333%}.eB-VIZeKyCl2beenbDvHb{left:20.83333333%}.PM1JeZ_WM-NfgyswBPT_F{right:20.83333333%}._1Ty43Dr_N8KcrBchTnb1Pf{margin-left:20.83333333%}._2SYOAd7uGCGyzdVnHG8o_6{-ms-flex-order:5;order:5}._3khb_kpkYBsU5JCWtz_4d{display:block;box-sizing:border-box;width:16.66666667%}._2GuTkPUpBbEGtSG8W_jaDh{left:16.66666667%}._1JquSl10OuwVjhVmz_6byc{right:16.66666667%}._269DaxY_L9MeHEtVWoAk2s{margin-left:16.66666667%}._3rkJ3cohft-EBYqxELNtpv{-ms-flex-order:4;order:4}.SaReG32YWslniRY4NvGsU{display:block;box-sizing:border-box;width:12.5%}._3KJzVjR4Vx8I4d-WB5ynH1{left:12.5%}._1D9H-O5LTpxeTqSL80oVpz{right:12.5%}._19OnciQQ8H7hrrt-2YTcYu{margin-left:12.5%}._1JU1OVX5D4R4X_SNzq4gaJ{-ms-flex-order:3;order:3}._1nW_B8lXAp9exlOEmWlkQZ{display:block;box-sizing:border-box;width:8.33333333%}._2noRKRbCVokYgz3IqYh-PI{left:8.33333333%}._3f-apBMyrZu0luga99b_ar{right:8.33333333%}.sVSEgYBLZEiLw_XJgVIBI{margin-left:8.33333333%}.D8tnASvcWCBo8b1wST9_5{-ms-flex-order:2;order:2}._2_3A0saCeMioqOm1fHoGm0{display:block;box-sizing:border-box;width:4.16666667%}._2xZmt7El7sTK4Y9k9CjJj9{left:4.16666667%}._23SUBCR09sbkZdWalrgi7D{right:4.16666667%}._1YNO-dS1s4Ml-z17aqhaaV{margin-left:4.16666667%}._2XSo7ZfA9n-VxS56i3pRGh{-ms-flex-order:1;order:1}._3gZCVOxDkV_rlH19adv1_B{display:none}._3eh9FwIUqNXQ75ZS1KOHUF{left:auto}._19fhy1NkdCWgU0GwLjJ-B2{right:auto}._2b2Y-2tGCqpLcVJrYT9PgU{left:auto}._2RGWrdfNHUfm_8jy8EBKKL{right:auto}._1JX2jsG73oLCZ--ZnoYd3p{margin-left:0}._1m5UuQtp735fnn8N7xKa5E{-ms-flex-order:0;order:0}}._3oe9-WI0tP6unk5FrTtouL{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\"}._3oe9-WI0tP6unk5FrTtouL ._2b7QFsC7AKk8R8D7s9MXM0{position:relative;display:block;box-sizing:border-box;-webkit-touch-callout:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk-{position:relative;display:block;margin:0;padding:0;overflow:hidden}._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk-:focus{outline:none}._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk-._3epwOdaPhz6EKcmKQVSv4X{cursor:pointer}._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk- ._3huWg6WBGDSIrwlb-2iT8-{pointer-events:none}._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk- ._3huWg6WBGDSIrwlb-2iT8- input._2S9eMyrOcHrUQEJaKe0x0P,._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk- ._3huWg6WBGDSIrwlb-2iT8- input._3bn1XXDMo4-lbvwh_h3njY{visibility:hidden}._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk- ._3huWg6WBGDSIrwlb-2iT8-.OU4fZNMsQ2Jg6sp8WfMIY{pointer-events:auto}._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk- ._3huWg6WBGDSIrwlb-2iT8-.OU4fZNMsQ2Jg6sp8WfMIY input._2S9eMyrOcHrUQEJaKe0x0P,._3oe9-WI0tP6unk5FrTtouL ._2k85WBVBceyVxqlPfFNfk- ._3huWg6WBGDSIrwlb-2iT8-.OU4fZNMsQ2Jg6sp8WfMIY input._3bn1XXDMo4-lbvwh_h3njY{visibility:visible}._3oe9-WI0tP6unk5FrTtouL ._2b7QFsC7AKk8R8D7s9MXM0 ._2k85WBVBceyVxqlPfFNfk-,._3oe9-WI0tP6unk5FrTtouL ._2b7QFsC7AKk8R8D7s9MXM0 ._5X11PgmiXLkjUMACuxYom{transform:translateZ(0)}._3oe9-WI0tP6unk5FrTtouL ._5X11PgmiXLkjUMACuxYom{position:relative;top:0;left:0;display:block}._3oe9-WI0tP6unk5FrTtouL ._5X11PgmiXLkjUMACuxYom:after,._3oe9-WI0tP6unk5FrTtouL ._5X11PgmiXLkjUMACuxYom:before{display:table;content:\"\"}._3oe9-WI0tP6unk5FrTtouL ._5X11PgmiXLkjUMACuxYom:after{clear:both}.hgY4-Ev3G3wgGBhQV7QfL ._3oe9-WI0tP6unk5FrTtouL ._5X11PgmiXLkjUMACuxYom{visibility:hidden}._3oe9-WI0tP6unk5FrTtouL ._3huWg6WBGDSIrwlb-2iT8-{display:none;float:left;height:100%;min-height:1px}[dir=rtl] ._3oe9-WI0tP6unk5FrTtouL ._3huWg6WBGDSIrwlb-2iT8-{float:right}._3oe9-WI0tP6unk5FrTtouL ._3huWg6WBGDSIrwlb-2iT8- img{display:block}._3oe9-WI0tP6unk5FrTtouL ._3huWg6WBGDSIrwlb-2iT8-.hgY4-Ev3G3wgGBhQV7QfL img{display:none}._3oe9-WI0tP6unk5FrTtouL ._3huWg6WBGDSIrwlb-2iT8-._3epwOdaPhz6EKcmKQVSv4X img{pointer-events:none}._3oe9-WI0tP6unk5FrTtouL ._2aoSTnqldSFA7hZS16T-94 ._3huWg6WBGDSIrwlb-2iT8-{display:block}._3oe9-WI0tP6unk5FrTtouL .hgY4-Ev3G3wgGBhQV7QfL ._3huWg6WBGDSIrwlb-2iT8-{visibility:hidden}._3oe9-WI0tP6unk5FrTtouL ._1Wh1O3A6QCGtBp5n9p4gFX ._3huWg6WBGDSIrwlb-2iT8-{display:block;height:auto;border:1px solid transparent}._3oe9-WI0tP6unk5FrTtouL ._3a7rM5ro41iK32orvpQ9HL._3np1ojosSnpTS2rOiALwdK{display:none}._3oe9-WI0tP6unk5FrTtouL ._2RosXPvayIWSCxAkMU3FK2,._3oe9-WI0tP6unk5FrTtouL .RLzopL2K8DeJRyhZAx8bX{position:absolute;top:50%;display:block;width:20px;height:20px;margin-top:-10px;padding:0;color:transparent;font-size:0;line-height:0;background:transparent;border:0;outline:none;cursor:pointer}._3oe9-WI0tP6unk5FrTtouL ._2RosXPvayIWSCxAkMU3FK2:focus,._3oe9-WI0tP6unk5FrTtouL ._2RosXPvayIWSCxAkMU3FK2:hover,._3oe9-WI0tP6unk5FrTtouL .RLzopL2K8DeJRyhZAx8bX:focus,._3oe9-WI0tP6unk5FrTtouL .RLzopL2K8DeJRyhZAx8bX:hover{color:transparent;background:transparent;outline:none}._3oe9-WI0tP6unk5FrTtouL ._2RosXPvayIWSCxAkMU3FK2:focus:before,._3oe9-WI0tP6unk5FrTtouL ._2RosXPvayIWSCxAkMU3FK2:hover:before,._3oe9-WI0tP6unk5FrTtouL .RLzopL2K8DeJRyhZAx8bX:focus:before,._3oe9-WI0tP6unk5FrTtouL .RLzopL2K8DeJRyhZAx8bX:hover:before{opacity:1}._3oe9-WI0tP6unk5FrTtouL ._2RosXPvayIWSCxAkMU3FK2._3MKU3SZVEq1gaVg5O_vJ2c:before,._3oe9-WI0tP6unk5FrTtouL .RLzopL2K8DeJRyhZAx8bX._3MKU3SZVEq1gaVg5O_vJ2c:before{opacity:.25}._3oe9-WI0tP6unk5FrTtouL ._2RosXPvayIWSCxAkMU3FK2{left:-25px}._3oe9-WI0tP6unk5FrTtouL ._2RosXPvayIWSCxAkMU3FK2:before{content:\"\\2190\"}._3oe9-WI0tP6unk5FrTtouL .RLzopL2K8DeJRyhZAx8bX{right:-25px}._3oe9-WI0tP6unk5FrTtouL .RLzopL2K8DeJRyhZAx8bX:before{content:\"\\2192\"}._3oe9-WI0tP6unk5FrTtouL ._1fB2SvKYh0XTGW18Y18cUk{position:absolute;display:block;width:100%;height:3px;margin:0;padding:0;text-align:center;list-style:none}._3oe9-WI0tP6unk5FrTtouL ._2zhMFdtISdvaAgDKAnSkap{bottom:12px}._3oe9-WI0tP6unk5FrTtouL ._3GNlAfJvjYj7hf5VVZ2O7H{top:12px}._3oe9-WI0tP6unk5FrTtouL ._1fB2SvKYh0XTGW18Y18cUk li{position:relative;display:inline-block;margin:0 2px;padding:0;text-align:center;vertical-align:top}._3oe9-WI0tP6unk5FrTtouL ._1fB2SvKYh0XTGW18Y18cUk li button{display:block;width:16px;height:3px;padding:0;color:transparent;font-size:0;background:#fff;border:0;border-radius:1px;outline:none;cursor:pointer;opacity:.3;transition:all .5s}._3oe9-WI0tP6unk5FrTtouL ._1fB2SvKYh0XTGW18Y18cUk li button:focus,._3oe9-WI0tP6unk5FrTtouL ._1fB2SvKYh0XTGW18Y18cUk li button:hover{opacity:.75}._3oe9-WI0tP6unk5FrTtouL ._1fB2SvKYh0XTGW18Y18cUk li.OU4fZNMsQ2Jg6sp8WfMIY button{width:24px;background:#fff;opacity:1}._3oe9-WI0tP6unk5FrTtouL ._1fB2SvKYh0XTGW18Y18cUk li.OU4fZNMsQ2Jg6sp8WfMIY button:focus,._3oe9-WI0tP6unk5FrTtouL ._1fB2SvKYh0XTGW18Y18cUk li.OU4fZNMsQ2Jg6sp8WfMIY button:hover{opacity:1}._2823sOpQKOBek4KN52Tbui ._1fB2SvKYh0XTGW18Y18cUk{top:50%;bottom:auto;width:3px;height:auto;transform:translateY(-50%)}._2823sOpQKOBek4KN52Tbui ._7A-JBQdDKinK_kVbJLkuT{left:12px}._2823sOpQKOBek4KN52Tbui ._38wBH4ktG57KaB6q6J0OIr{right:12px}._2823sOpQKOBek4KN52Tbui ._1fB2SvKYh0XTGW18Y18cUk li{margin:0 2px;vertical-align:baseline}._2823sOpQKOBek4KN52Tbui ._1fB2SvKYh0XTGW18Y18cUk li button{width:3px;height:16px}._2823sOpQKOBek4KN52Tbui ._1fB2SvKYh0XTGW18Y18cUk li.OU4fZNMsQ2Jg6sp8WfMIY button{width:3px;height:24px}._3InesuJTU62ULwRUKqy2sz{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\"}._3bU7CHT5Lss1v8CDoIJh-s._3pPc-OF79GHv_bF35yGDY1{position:static;width:100%;padding-right:24px;background-color:transparent!important;cursor:pointer}._2AeyWDIbJRDPr2AQQI6i9g ._3bU7CHT5Lss1v8CDoIJh-s._3pPc-OF79GHv_bF35yGDY1{position:relative}._pEx_feJBV_Kj7nPjRgq4{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;background-color:#fff;border-radius:4px;outline:0;cursor:pointer;transition:color .3s}._17wxYKGNXth62p3B083F54 ._3I7qT55QHTc0NsQm2o8Dzj{color:transparent}._2rTk814RCDUpmNh_D3mwY{color:rgba(0,0,0,.25);background:#f5f5f5;cursor:not-allowed}._2rTk814RCDUpmNh_D3mwY ._3bU7CHT5Lss1v8CDoIJh-s{cursor:not-allowed}._pEx_feJBV_Kj7nPjRgq4:focus ._3bU7CHT5Lss1v8CDoIJh-s{border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._2AeyWDIbJRDPr2AQQI6i9g._2fDAzmrjntvwBWsvrRe6Jg{color:rgba(0,0,0,.25)}._3I7qT55QHTc0NsQm2o8Dzj{position:absolute;top:50%;left:0;width:100%;height:20px;margin-top:-10px;padding:0 20px 0 12px;overflow:hidden;line-height:20px;white-space:nowrap;text-overflow:ellipsis}.DmiJkdTGX48H7r143gmkY{position:absolute;top:50%;right:12px;z-index:2;width:12px;height:12px;margin-top:-6px;color:rgba(0,0,0,.25);font-size:12px;line-height:12px;background:#fff;cursor:pointer;opacity:0;transition:color .3s ease,opacity .15s ease}.DmiJkdTGX48H7r143gmkY:hover{color:rgba(0,0,0,.45)}._pEx_feJBV_Kj7nPjRgq4:hover .DmiJkdTGX48H7r143gmkY{opacity:1}._213Bp5NguaOQg31JGehBAR{position:absolute;top:50%;right:12px;z-index:1;width:12px;height:12px;margin-top:-6px;color:rgba(0,0,0,.25);font-size:12px;line-height:12px;transition:transform .2s}._213Bp5NguaOQg31JGehBAR.xhe8hul9OwVPezwCVQROz{transform:rotate(180deg)}._3I7qT55QHTc0NsQm2o8Dzj:hover+._3bU7CHT5Lss1v8CDoIJh-s{border-color:#40a9ff;border-right-width:1px!important}.-nACrxzwPGt8dRTFJ6Q8H ._213Bp5NguaOQg31JGehBAR,.-nACrxzwPGt8dRTFJ6Q8H .DmiJkdTGX48H7r143gmkY{right:8px}._3Y36gjTEBq_e2mJnB7gtuw{position:absolute;z-index:1050;font-size:14px;white-space:nowrap;background:#fff;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15)}._3Y36gjTEBq_e2mJnB7gtuw ol,._3Y36gjTEBq_e2mJnB7gtuw ul{margin:0;list-style:none}._1B9mPUL-_ZNXNkOXciJrWP,._1o3-apY9-v62t7Dl2mkJ4h{display:none}._3Y36gjTEBq_e2mJnB7gtuw._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._3JTSOYgrZxGX24vTd_Yy36,._3Y36gjTEBq_e2mJnB7gtuw._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._3JTSOYgrZxGX24vTd_Yy36{animation-name:_2lqTGgogIItpImYAn3wMQO}._3Y36gjTEBq_e2mJnB7gtuw._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._1pt4DR7gcQGN6IvHYcrQ48,._3Y36gjTEBq_e2mJnB7gtuw._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._1pt4DR7gcQGN6IvHYcrQ48{animation-name:_3JK1uFdxrQM9RK51sOtrar}._3Y36gjTEBq_e2mJnB7gtuw._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._3JTSOYgrZxGX24vTd_Yy36{animation-name:_2IDJAVNNcAmXsLtWbzNJtk}._3Y36gjTEBq_e2mJnB7gtuw._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._1pt4DR7gcQGN6IvHYcrQ48{animation-name:_1F89QugyM0FQpooygKHf2k}._25pQODd24bANdVTX9s5V--{display:inline-block;min-width:111px;height:180px;margin:0;padding:4px 0;overflow:auto;vertical-align:top;list-style:none;border-right:1px solid #e8e8e8;-ms-overflow-style:-ms-autohiding-scrollbar}._25pQODd24bANdVTX9s5V--:first-child{border-radius:4px 0 0 4px}._25pQODd24bANdVTX9s5V--:last-child{margin-right:-1px;border-right-color:transparent;border-radius:0 4px 4px 0}._25pQODd24bANdVTX9s5V--:only-child{border-radius:4px}._1dXSuB9_gu82nCsPH6RZpy{padding:5px 12px;line-height:22px;white-space:nowrap;cursor:pointer;transition:all .3s}._1dXSuB9_gu82nCsPH6RZpy:hover{background:#e6f7ff}._1KwpxD70qDFYh6TjmMq--r{color:rgba(0,0,0,.25);cursor:not-allowed}._1KwpxD70qDFYh6TjmMq--r:hover{background:transparent}._16yhk1wX9ZGFd19b4Q_J4D:not(._1KwpxD70qDFYh6TjmMq--r),._16yhk1wX9ZGFd19b4Q_J4D:not(._1KwpxD70qDFYh6TjmMq--r):hover{font-weight:600;background-color:#fafafa}._2du_0ndv2iHWz2C6WA1z0g{position:relative;padding-right:24px}._2du_0ndv2iHWz2C6WA1z0g ._9o-6mBnzG1GCELI5bMI6w,.Ryqbl8mnOfepApHdkxkUo{display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg);position:absolute;right:12px;color:rgba(0,0,0,.45)}:root ._2du_0ndv2iHWz2C6WA1z0g ._9o-6mBnzG1GCELI5bMI6w,:root .Ryqbl8mnOfepApHdkxkUo{font-size:12px}._1dXSuB9_gu82nCsPH6RZpy ._3M6EnAB7MoiZyauk7SdhVU{color:#f5222d}._1qXIiaxtanPYob3LcMYCt1{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;top:-.09em;display:inline-block;line-height:1;white-space:nowrap;vertical-align:middle;outline:none;cursor:pointer}._1qXIiaxtanPYob3LcMYCt1:hover ._25Pc2GL9nkcjI4plpHGGd1,._3bn1XXDMo4-lbvwh_h3njY:focus+._25Pc2GL9nkcjI4plpHGGd1,._3LtXuasflPstC14W79Zpyb:hover ._25Pc2GL9nkcjI4plpHGGd1{border-color:#1890ff}.eG1BK9jAdcYnTPSdmJPxs:after{position:absolute;top:0;left:0;width:100%;height:100%;border:1px solid #1890ff;border-radius:2px;visibility:hidden;animation:_21X1U27xYleYdbKo6yuHqk .36s ease-in-out;animation-fill-mode:backwards;content:\"\"}._1qXIiaxtanPYob3LcMYCt1:hover:after,._3LtXuasflPstC14W79Zpyb:hover ._1qXIiaxtanPYob3LcMYCt1:after{visibility:visible}._25Pc2GL9nkcjI4plpHGGd1{position:relative;top:0;left:0;display:block;width:16px;height:16px;background-color:#fff;border:1px solid #d9d9d9;border-radius:2px;border-collapse:separate;transition:all .3s}._25Pc2GL9nkcjI4plpHGGd1:after{position:absolute;top:50%;left:22%;display:table;width:5.71428571px;height:9.14285714px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg) scale(0) translate(-50%,-50%);opacity:0;transition:all .1s cubic-bezier(.71,-.46,.88,.6),opacity .1s;content:\" \"}._3bn1XXDMo4-lbvwh_h3njY{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;width:100%;height:100%;cursor:pointer;opacity:0}.eG1BK9jAdcYnTPSdmJPxs ._25Pc2GL9nkcjI4plpHGGd1:after{position:absolute;display:table;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg) scale(1) translate(-50%,-50%);opacity:1;transition:all .2s cubic-bezier(.12,.4,.29,1.46) .1s;content:\" \"}.eG1BK9jAdcYnTPSdmJPxs ._25Pc2GL9nkcjI4plpHGGd1{background-color:#1890ff;border-color:#1890ff}._1e5SAP1exG-V5zWtAs4McQ{cursor:not-allowed}._1e5SAP1exG-V5zWtAs4McQ.eG1BK9jAdcYnTPSdmJPxs ._25Pc2GL9nkcjI4plpHGGd1:after{border-color:rgba(0,0,0,.25);animation-name:_1CY6uej5ij2TMImio1u0wc}._1e5SAP1exG-V5zWtAs4McQ ._3bn1XXDMo4-lbvwh_h3njY{cursor:not-allowed}._1e5SAP1exG-V5zWtAs4McQ ._25Pc2GL9nkcjI4plpHGGd1{background-color:#f5f5f5;border-color:#d9d9d9!important}._1e5SAP1exG-V5zWtAs4McQ ._25Pc2GL9nkcjI4plpHGGd1:after{border-color:#f5f5f5;border-collapse:separate;animation-name:_1CY6uej5ij2TMImio1u0wc}._1e5SAP1exG-V5zWtAs4McQ+span{color:rgba(0,0,0,.25);cursor:not-allowed}._1e5SAP1exG-V5zWtAs4McQ:hover:after,._3LtXuasflPstC14W79Zpyb:hover ._1e5SAP1exG-V5zWtAs4McQ:after{visibility:hidden}._3LtXuasflPstC14W79Zpyb{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block;line-height:unset;cursor:pointer}._3LtXuasflPstC14W79Zpyb._2rWRe8EdWeH28zowq6f-sm{cursor:not-allowed}._3LtXuasflPstC14W79Zpyb+._3LtXuasflPstC14W79Zpyb{margin-left:8px}._1qXIiaxtanPYob3LcMYCt1+span{padding-right:8px;padding-left:8px}.dvvLtjqiI9bDO91BRwGy0{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block}.eOS26o0Lm00OxlQRDB5lS{display:inline-block;margin-right:8px}.eOS26o0Lm00OxlQRDB5lS:last-child{margin-right:0}.eOS26o0Lm00OxlQRDB5lS+.eOS26o0Lm00OxlQRDB5lS{margin-left:0}._2g5KChYsc69byhrnbZALx4 ._25Pc2GL9nkcjI4plpHGGd1{background-color:#fff;border-color:#d9d9d9}._2g5KChYsc69byhrnbZALx4 ._25Pc2GL9nkcjI4plpHGGd1:after{top:50%;left:50%;width:8px;height:8px;background-color:#1890ff;border:0;transform:translate(-50%,-50%) scale(1);opacity:1;content:\" \"}._2g5KChYsc69byhrnbZALx4._1e5SAP1exG-V5zWtAs4McQ ._25Pc2GL9nkcjI4plpHGGd1:after{background-color:rgba(0,0,0,.25);border-color:rgba(0,0,0,.25)}._1bxtHNQVsihZgPjfejsPbG{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";background-color:#fafafa;border:1px solid #d9d9d9;border-bottom:0;border-radius:4px}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T{border-bottom:1px solid #d9d9d9}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T:last-child,._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T:last-child>._3t2hctYIR7ZYbNmtlLLJCv{border-radius:0 0 4px 4px}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv{position:relative;padding:12px 16px;padding-left:40px;color:rgba(0,0,0,.85);line-height:22px;cursor:pointer;transition:all .3s}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv .TX7E2PLri6sYA2qqJXeLj{color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;top:50%;left:16px;display:inline-block;font-size:12px;transform:translateY(-50%)}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv .TX7E2PLri6sYA2qqJXeLj>*{line-height:1}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv .TX7E2PLri6sYA2qqJXeLj svg{display:inline-block}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv .TX7E2PLri6sYA2qqJXeLj:before{display:none}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv .TX7E2PLri6sYA2qqJXeLj ._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv ._1sVC8xPzqOAmNIIPVJ3cmG{display:block}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv .TX7E2PLri6sYA2qqJXeLj svg{transition:transform .24s}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv ._8xyzjf2ILvOLk-P9VmdjO{float:right}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv:focus{outline:none}._1bxtHNQVsihZgPjfejsPbG>.doWBRub-3JuS8a891u7-T._26f9KhkP_4zZSywx-vvjBw>._3t2hctYIR7ZYbNmtlLLJCv{padding-left:12px}._3B3liA1u4ZPS-HoNFXlAEG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv{padding:12px 16px;padding-right:40px}._3B3liA1u4ZPS-HoNFXlAEG>.doWBRub-3JuS8a891u7-T>._3t2hctYIR7ZYbNmtlLLJCv .TX7E2PLri6sYA2qqJXeLj{right:16px;left:auto}._2o7rE8tWmuDVoVcU4pDeX0{transition:height .2s cubic-bezier(.215,.61,.355,1)}._1gTOs_fESxukIx8Qnr_E3K{overflow:hidden;color:rgba(0,0,0,.65);background-color:#fff;border-top:1px solid #d9d9d9}._1gTOs_fESxukIx8Qnr_E3K>._2N3ppCp2EiYkL5haTuYuvt{padding:16px}._1GXt_Vcn26tMNRESjgB3p2{display:none}.doWBRub-3JuS8a891u7-T:last-child>._1gTOs_fESxukIx8Qnr_E3K{border-radius:0 0 4px 4px}._2fVdrJMlaUrpW45weLMO2p{background-color:#fafafa;border:0}._2fVdrJMlaUrpW45weLMO2p>.doWBRub-3JuS8a891u7-T{border-bottom:1px solid #d9d9d9}._2fVdrJMlaUrpW45weLMO2p>.doWBRub-3JuS8a891u7-T:last-child,._2fVdrJMlaUrpW45weLMO2p>.doWBRub-3JuS8a891u7-T:last-child ._3t2hctYIR7ZYbNmtlLLJCv{border-radius:0}._2fVdrJMlaUrpW45weLMO2p>.doWBRub-3JuS8a891u7-T>._1gTOs_fESxukIx8Qnr_E3K{background-color:transparent;border-top:0}._2fVdrJMlaUrpW45weLMO2p>.doWBRub-3JuS8a891u7-T>._1gTOs_fESxukIx8Qnr_E3K>._2N3ppCp2EiYkL5haTuYuvt{padding-top:4px}._1bxtHNQVsihZgPjfejsPbG ._3F3HxQLS5s_5Wfk4MM030Q>._3t2hctYIR7ZYbNmtlLLJCv,._1bxtHNQVsihZgPjfejsPbG ._3F3HxQLS5s_5Wfk4MM030Q>._3t2hctYIR7ZYbNmtlLLJCv>._2RhSkvgeDEzTFhRNUn4R8_{color:rgba(0,0,0,.25);cursor:not-allowed}._2iDr-CRQU0iRpEaT3X-InR{position:relative}._2UUNZHWKdEFC2PWkOgxbU5{display:-ms-flexbox;display:flex;padding:16px 0}.GYanMrZZnA_LBs68UB1ox{position:relative;-ms-flex-negative:0;flex-shrink:0;margin-right:12px;cursor:pointer}.GYanMrZZnA_LBs68UB1ox img{width:32px;height:32px;border-radius:50%}.PKoYA_YJf_lb-O_v_0wmP{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;min-width:1px;font-size:14px;word-wrap:break-word}._3R8DjktmpgkWdM0XjlRf1_{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start;margin-bottom:4px;font-size:14px}._3R8DjktmpgkWdM0XjlRf1_>a,._3R8DjktmpgkWdM0XjlRf1_>span{padding-right:8px;font-size:12px;line-height:18px}._1J9F0Y9g1FOh1pl3NXLapS{color:rgba(0,0,0,.45);font-size:14px;transition:color .3s}._1J9F0Y9g1FOh1pl3NXLapS>*,._1J9F0Y9g1FOh1pl3NXLapS>:hover{color:rgba(0,0,0,.45)}._1VWGIZ_OA4L4sdIXe7OvM-{color:#ccc;white-space:nowrap;cursor:auto}._2ei8fUMgtNxq1CoW5Jt-s1 p{white-space:pre-wrap}._1J4VTvLzlgMlIW48FQWx3Z{margin-top:12px;padding-left:0}._1J4VTvLzlgMlIW48FQWx3Z>li{display:inline-block;color:rgba(0,0,0,.45)}._1J4VTvLzlgMlIW48FQWx3Z>li>span{padding-right:10px;color:rgba(0,0,0,.45);font-size:12px;cursor:pointer;transition:color .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1J4VTvLzlgMlIW48FQWx3Z>li>span:hover{color:#595959}.dHiEO-CBaeUPOKQ7ZpRZt{margin-left:44px}._1ZLQ4odGk130QM9PN6CXnM{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;z-index:1050;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif}._1ZLQ4odGk130QM9PN6CXnM._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._1AXLp_oojwk1sm9yYquaRo,._1ZLQ4odGk130QM9PN6CXnM._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._1ctEPZi-olDRIJ_ZCxfBkP,._1ZLQ4odGk130QM9PN6CXnM._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._1AXLp_oojwk1sm9yYquaRo,._1ZLQ4odGk130QM9PN6CXnM._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._1ctEPZi-olDRIJ_ZCxfBkP{animation-name:_3JK1uFdxrQM9RK51sOtrar}._1ZLQ4odGk130QM9PN6CXnM._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._1r_920LF15agLks16H_x3r,._1ZLQ4odGk130QM9PN6CXnM._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim.Z0wdtWvWQ1hy0bEuwQXpl,._1ZLQ4odGk130QM9PN6CXnM._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._1r_920LF15agLks16H_x3r,._1ZLQ4odGk130QM9PN6CXnM._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C.Z0wdtWvWQ1hy0bEuwQXpl{animation-name:_2lqTGgogIItpImYAn3wMQO}._1ZLQ4odGk130QM9PN6CXnM._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._1AXLp_oojwk1sm9yYquaRo,._1ZLQ4odGk130QM9PN6CXnM._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._1ctEPZi-olDRIJ_ZCxfBkP{animation-name:_1F89QugyM0FQpooygKHf2k}._1ZLQ4odGk130QM9PN6CXnM._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._1r_920LF15agLks16H_x3r,._1ZLQ4odGk130QM9PN6CXnM._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX.Z0wdtWvWQ1hy0bEuwQXpl{animation-name:_2IDJAVNNcAmXsLtWbzNJtk}._1j4rLEirQnvEigyl0F5j16{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;outline:none;cursor:text;transition:opacity .3s}._2JZfuIaTZD_lWK5HfZHFb0{outline:none}._2JZfuIaTZD_lWK5HfZHFb0._3pPc-OF79GHv_bF35yGDY1{line-height:1.5}._2JZfuIaTZD_lWK5HfZHFb0._3XkyZAEWYxNQKnj5oRB-hf{padding-top:0;padding-bottom:0}._1j4rLEirQnvEigyl0F5j16:hover ._2JZfuIaTZD_lWK5HfZHFb0:not(._2A-ucu16pid4Gh76mY_Ebo){border-color:#40a9ff}._1j4rLEirQnvEigyl0F5j16:focus ._2JZfuIaTZD_lWK5HfZHFb0:not(._2A-ucu16pid4Gh76mY_Ebo){border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._1rWIPd1klu-G8ILTxOBh3c,._2nqVLnLfxwaRHBun1ZdFs{position:absolute;top:50%;right:12px;z-index:1;width:14px;height:14px;margin-top:-7px;font-size:12px;line-height:14px;transition:all .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1rWIPd1klu-G8ILTxOBh3c{z-index:2;color:rgba(0,0,0,.25);font-size:14px;background:#fff;cursor:pointer;opacity:0;pointer-events:none}._1rWIPd1klu-G8ILTxOBh3c:hover{color:rgba(0,0,0,.45)}._1j4rLEirQnvEigyl0F5j16:hover ._1rWIPd1klu-G8ILTxOBh3c{opacity:1;pointer-events:auto}._2nqVLnLfxwaRHBun1ZdFs{display:inline-block;color:rgba(0,0,0,.25);font-size:14px;line-height:1}._2A-ucu16pid4Gh76mY_Ebo+._2nqVLnLfxwaRHBun1ZdFs{cursor:not-allowed}._2CvkQPMO_gBBB-hgiOJir5 ._1rWIPd1klu-G8ILTxOBh3c,._2CvkQPMO_gBBB-hgiOJir5 ._2nqVLnLfxwaRHBun1ZdFs{right:8px}.k6QPYJpdRnvekKiO19ids{position:relative;width:280px;font-size:14px;line-height:1.5;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #fff;border-radius:4px;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.15)}._31ntJTDLEi4D9asydwj0gz{height:34px;padding:6px 10px;border-bottom:1px solid #e8e8e8}._2Qcq1LR-Bq-DtnSniS6bOk{width:100%;height:22px;color:rgba(0,0,0,.65);background:#fff;border:0;outline:0;cursor:auto}._2Qcq1LR-Bq-DtnSniS6bOk::-moz-placeholder{color:#bfbfbf;opacity:1}._2Qcq1LR-Bq-DtnSniS6bOk:-ms-input-placeholder{color:#bfbfbf}._2Qcq1LR-Bq-DtnSniS6bOk::-webkit-input-placeholder{color:#bfbfbf}._2Qcq1LR-Bq-DtnSniS6bOk:-moz-placeholder-shown{text-overflow:ellipsis}._2Qcq1LR-Bq-DtnSniS6bOk:-ms-input-placeholder{text-overflow:ellipsis}._2Qcq1LR-Bq-DtnSniS6bOk:placeholder-shown{text-overflow:ellipsis}._8Drlz3GO0A5cZocJ4tBPm{width:286px}._3YSOHYTSeOuMvjDKKV2Cw4{text-align:center}._2kkvCXKMQ3plBGxJpV8ran{height:40px;line-height:40px;text-align:center;border-bottom:1px solid #e8e8e8;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._2kkvCXKMQ3plBGxJpV8ran a:hover{color:#40a9ff}._2kkvCXKMQ3plBGxJpV8ran ._1Rw2ggb9g1gPrPzUggApo8,._2kkvCXKMQ3plBGxJpV8ran ._1ueD-yLdA9SWfXEQNJKgoz,._2kkvCXKMQ3plBGxJpV8ran ._3H4v0BAhNk8in2qoOKSkl2,._2kkvCXKMQ3plBGxJpV8ran ._10f6HpQZl194W0Tfp2VMqG{display:inline-block;padding:0 2px;color:rgba(0,0,0,.85);font-weight:500;line-height:40px}._2kkvCXKMQ3plBGxJpV8ran ._1n2bWMG0mgItOKVGZT2pgJ,._2kkvCXKMQ3plBGxJpV8ran ._2sZtUQJdCSOUR3kHbQb4GJ,._2kkvCXKMQ3plBGxJpV8ran ._3Amf9CFrWL7rIwn9qM7eBD,._2kkvCXKMQ3plBGxJpV8ran ._3gV5zF_kr51NaZeXYxDYG_{display:none}._2kkvCXKMQ3plBGxJpV8ran ._1HrAGYGqfeVNu5lch37BM9,._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC,._2kkvCXKMQ3plBGxJpV8ran ._2mowPpQZXBhtBYBvCd1fe4,._2kkvCXKMQ3plBGxJpV8ran ._2ZNah7OMHbgAvnPEDwZVDc,._2kkvCXKMQ3plBGxJpV8ran ._3jDTNFXa36LL4SFs9UOiCt,._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS{position:absolute;top:0;display:inline-block;padding:0 5px;color:rgba(0,0,0,.45);font-size:16px;font-family:Arial,Hiragino Sans GB,Microsoft Yahei,Microsoft Sans Serif,sans-serif;line-height:40px}._2kkvCXKMQ3plBGxJpV8ran ._1HrAGYGqfeVNu5lch37BM9,._2kkvCXKMQ3plBGxJpV8ran ._2mowPpQZXBhtBYBvCd1fe4,._2kkvCXKMQ3plBGxJpV8ran ._2ZNah7OMHbgAvnPEDwZVDc{left:7px;height:100%}._2kkvCXKMQ3plBGxJpV8ran ._1HrAGYGqfeVNu5lch37BM9:after,._2kkvCXKMQ3plBGxJpV8ran ._1HrAGYGqfeVNu5lch37BM9:before,._2kkvCXKMQ3plBGxJpV8ran ._2mowPpQZXBhtBYBvCd1fe4:after,._2kkvCXKMQ3plBGxJpV8ran ._2mowPpQZXBhtBYBvCd1fe4:before,._2kkvCXKMQ3plBGxJpV8ran ._2ZNah7OMHbgAvnPEDwZVDc:after,._2kkvCXKMQ3plBGxJpV8ran ._2ZNah7OMHbgAvnPEDwZVDc:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2kkvCXKMQ3plBGxJpV8ran ._1HrAGYGqfeVNu5lch37BM9:hover:after,._2kkvCXKMQ3plBGxJpV8ran ._1HrAGYGqfeVNu5lch37BM9:hover:before,._2kkvCXKMQ3plBGxJpV8ran ._2mowPpQZXBhtBYBvCd1fe4:hover:after,._2kkvCXKMQ3plBGxJpV8ran ._2mowPpQZXBhtBYBvCd1fe4:hover:before,._2kkvCXKMQ3plBGxJpV8ran ._2ZNah7OMHbgAvnPEDwZVDc:hover:after,._2kkvCXKMQ3plBGxJpV8ran ._2ZNah7OMHbgAvnPEDwZVDc:hover:before{border-color:rgba(0,0,0,.65)}._2kkvCXKMQ3plBGxJpV8ran ._1HrAGYGqfeVNu5lch37BM9:after,._2kkvCXKMQ3plBGxJpV8ran ._2mowPpQZXBhtBYBvCd1fe4:after,._2kkvCXKMQ3plBGxJpV8ran ._2ZNah7OMHbgAvnPEDwZVDc:after{display:none;position:relative;left:-3px;display:inline-block}._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC{right:7px;height:100%}._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:after,._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:before,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:after,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:before,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:after,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:hover:after,._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:hover:before,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:hover:after,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:hover:before,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:hover:after,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:hover:before{border-color:rgba(0,0,0,.65)}._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:after,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:after,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:after{display:none}._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:after,._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:before,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:after,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:before,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:after,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:before{transform:rotate(135deg) scale(.8)}._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:before,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:before,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:before{position:relative;left:3px}._2kkvCXKMQ3plBGxJpV8ran ._1S_Y4kJYkE-Rt3HVabeno8:after,._2kkvCXKMQ3plBGxJpV8ran ._1siEj586OkHECWlExwB0_V:after,._2kkvCXKMQ3plBGxJpV8ran ._1zkst2vqI1vtFvUxtYUDFC:after{display:inline-block}._2kkvCXKMQ3plBGxJpV8ran ._3jDTNFXa36LL4SFs9UOiCt{left:29px;height:100%}._2kkvCXKMQ3plBGxJpV8ran ._3jDTNFXa36LL4SFs9UOiCt:after,._2kkvCXKMQ3plBGxJpV8ran ._3jDTNFXa36LL4SFs9UOiCt:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2kkvCXKMQ3plBGxJpV8ran ._3jDTNFXa36LL4SFs9UOiCt:hover:after,._2kkvCXKMQ3plBGxJpV8ran ._3jDTNFXa36LL4SFs9UOiCt:hover:before{border-color:rgba(0,0,0,.65)}._2kkvCXKMQ3plBGxJpV8ran ._3jDTNFXa36LL4SFs9UOiCt:after{display:none}._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS{right:29px;height:100%}._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS:after,._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS:hover:after,._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS:hover:before{border-color:rgba(0,0,0,.65)}._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS:after{display:none}._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS:after,._2kkvCXKMQ3plBGxJpV8ran .G2-EqywSap6H_iqn3dfYS:before{transform:rotate(135deg) scale(.8)}._2wW5JvPITyQhjq52fd8LKh{padding:8px 12px}.k6QPYJpdRnvekKiO19ids table{width:100%;max-width:100%;background-color:transparent;border-collapse:collapse}.k6QPYJpdRnvekKiO19ids table,.k6QPYJpdRnvekKiO19ids td,.k6QPYJpdRnvekKiO19ids th{text-align:center;border:0}._3kneDEqGmtTjQIrWSlAcwH{margin-bottom:0;border-spacing:0}._2nOi1xTU9WQVx26wuq_za9{width:33px;padding:6px 0;line-height:18px;text-align:center}._2nOi1xTU9WQVx26wuq_za9 ._2ghUTNWGAE8UGBEGuuH4g9{display:block;font-weight:400}._11eV1HHIX41Dv0jgGu55P8 ._2ghUTNWGAE8UGBEGuuH4g9{display:none}._1m6b64quzTkmUyG4KXrUPv{height:30px;padding:3px 0}._3slHMiNvDSTCjC_Oi7FLqJ{display:block;width:24px;height:24px;margin:0 auto;padding:0;color:rgba(0,0,0,.65);line-height:22px;text-align:center;background:transparent;border:1px solid transparent;border-radius:2px;transition:background .3s ease}.b3-X_hmZKU5zUXbpox5eq{position:relative;outline:none}._3slHMiNvDSTCjC_Oi7FLqJ:hover{background:#e6f7ff;cursor:pointer}._3slHMiNvDSTCjC_Oi7FLqJ:active{color:#fff;background:#40a9ff}._2EHQB_XsIRnUfNeNSRFsvc ._3slHMiNvDSTCjC_Oi7FLqJ{color:#1890ff;font-weight:700;border-color:#1890ff}.qQuZoLJftUhEnJq1MhTV3 ._3slHMiNvDSTCjC_Oi7FLqJ{background:#bae7ff}._1fSwm4B4puu7Y-HwqpIwEe ._3slHMiNvDSTCjC_Oi7FLqJ,._1fSwm4B4puu7Y-HwqpIwEe ._3slHMiNvDSTCjC_Oi7FLqJ:hover,._3TNOivRs6b3IDJ06G2OwKb ._3slHMiNvDSTCjC_Oi7FLqJ,._3TNOivRs6b3IDJ06G2OwKb ._3slHMiNvDSTCjC_Oi7FLqJ:hover{color:rgba(0,0,0,.25);background:transparent;border-color:transparent}._31mcDtESii0rdAOpFMD7SE ._3slHMiNvDSTCjC_Oi7FLqJ{position:relative;width:auto;color:rgba(0,0,0,.25);background:#f5f5f5;border:1px solid transparent;border-radius:0;cursor:not-allowed}._31mcDtESii0rdAOpFMD7SE ._3slHMiNvDSTCjC_Oi7FLqJ:hover{background:#f5f5f5}._31mcDtESii0rdAOpFMD7SE.qQuZoLJftUhEnJq1MhTV3 ._3slHMiNvDSTCjC_Oi7FLqJ:before{position:absolute;top:-1px;left:5px;width:24px;height:24px;background:rgba(0,0,0,.1);border-radius:2px;content:\"\"}._31mcDtESii0rdAOpFMD7SE._2EHQB_XsIRnUfNeNSRFsvc ._3slHMiNvDSTCjC_Oi7FLqJ{position:relative;padding-right:5px;padding-left:5px}._31mcDtESii0rdAOpFMD7SE._2EHQB_XsIRnUfNeNSRFsvc ._3slHMiNvDSTCjC_Oi7FLqJ:before{position:absolute;top:-1px;left:5px;width:24px;height:24px;border:1px solid rgba(0,0,0,.25);border-radius:2px;content:\" \"}.AVW5REWz6xXvNCIWsbgkZ ._3slHMiNvDSTCjC_Oi7FLqJ{border-top-left-radius:4px;border-bottom-left-radius:4px}._3nDV70eGXh_qMc6R5Zmtu8 ._3slHMiNvDSTCjC_Oi7FLqJ{border-top-right-radius:4px;border-bottom-right-radius:4px}._1MgpcwdTPCxW4vVEJzAbyw{padding:0 12px;line-height:38px;border-top:1px solid #e8e8e8}._1MgpcwdTPCxW4vVEJzAbyw:empty{border-top:0}._3pRBNhIn_p9N3-uTZp7FGA{display:block;text-align:center}._10xqdK8Nztq4MiNfc79sBH{text-align:left}.k6QPYJpdRnvekKiO19ids ._2sz5yU5QJo05sRNtM751fH,.k6QPYJpdRnvekKiO19ids .zAAxwi7oklKu4jQ3-GZVF{display:inline-block;margin:0 0 0 8px;text-align:center}.k6QPYJpdRnvekKiO19ids ._1LKCnhrOkQoyc4F7EwgS5X,.k6QPYJpdRnvekKiO19ids ._2h9wfUsLvEUcLWUBpxiXNL{color:rgba(0,0,0,.25);cursor:not-allowed}.k6QPYJpdRnvekKiO19ids ._2sz5yU5QJo05sRNtM751fH:only-child,.k6QPYJpdRnvekKiO19ids .zAAxwi7oklKu4jQ3-GZVF:only-child{margin:0}.k6QPYJpdRnvekKiO19ids .zAAxwi7oklKu4jQ3-GZVF{position:absolute;top:7px;right:5px;display:none;width:20px;height:20px;margin:0;overflow:hidden;line-height:20px;text-align:center;text-indent:-76px}.k6QPYJpdRnvekKiO19ids .zAAxwi7oklKu4jQ3-GZVF:after{display:inline-block;width:20px;color:rgba(0,0,0,.25);font-size:14px;line-height:1;text-indent:43px;transition:color .3s ease}.k6QPYJpdRnvekKiO19ids .zAAxwi7oklKu4jQ3-GZVF:hover:after{color:rgba(0,0,0,.45)}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0{position:relative;display:inline-block;font-weight:400;white-space:nowrap;text-align:center;background-image:none;border:1px solid transparent;box-shadow:0 2px 0 rgba(0,0,0,.015);cursor:pointer;transition:all .3s cubic-bezier(.645,.045,.355,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:manipulation;touch-action:manipulation;height:32px;padding:0 15px;color:#fff;background-color:#1890ff;border-color:#1890ff;text-shadow:0 -1px 0 rgba(0,0,0,.12);box-shadow:0 2px 0 rgba(0,0,0,.045);height:24px;padding:0 7px;font-size:14px;border-radius:4px;line-height:22px}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0>._1oZ8xlpZEg3PzGp2jMNFuZ{line-height:1}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:active,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:focus{outline:0}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:not([disabled]):hover{text-decoration:none}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:not([disabled]):active{outline:0;box-shadow:none}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]{cursor:not-allowed}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB>*,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]>*{pointer-events:none}.k6QPYJpdRnvekKiO19ids ._31EkOnGZz_KEB6WQSKo5Kr{height:40px;padding:0 15px;font-size:16px;border-radius:4px}.k6QPYJpdRnvekKiO19ids .mJn76RwrKFywM9XC--6nf{height:24px;padding:0 7px;font-size:14px;border-radius:4px}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0>a:only-child{color:currentColor}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:focus,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:hover{color:#fff;background-color:#40a9ff;border-color:#40a9ff}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:focus>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:hover>a:only-child{color:currentColor}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:focus>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:hover>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0.em_Pqz__Gx36paHRPTcGY,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:active{color:#fff;background-color:#096dd9;border-color:#096dd9}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0.em_Pqz__Gx36paHRPTcGY>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:active>a:only-child{color:currentColor}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0:active>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:active,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:focus,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:hover,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled],.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled].em_Pqz__Gx36paHRPTcGY,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:active,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:focus,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:hover,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL.em_Pqz__Gx36paHRPTcGY,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:active,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:focus,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:hover{color:rgba(0,0,0,.25);background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:active>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:active>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:focus>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:hover>a:only-child,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]>a:only-child,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL.em_Pqz__Gx36paHRPTcGY>a:only-child,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:active>a:only-child,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:focus>a:only-child,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:hover>a:only-child,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL>a:only-child{color:currentColor}.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:active>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:focus>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB:hover>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0._10gRqOxa4A45g-aoMVtjwB>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled].em_Pqz__Gx36paHRPTcGY>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:active>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:focus>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]:hover>a:only-child:after,.k6QPYJpdRnvekKiO19ids ._1oQQN1Wp0GrKUL0l0-ZiX0[disabled]>a:only-child:after,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL.em_Pqz__Gx36paHRPTcGY>a:only-child:after,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:active>a:only-child:after,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:focus>a:only-child:after,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL:hover>a:only-child:after,.k6QPYJpdRnvekKiO19ids .Y13Bhe_7k6aIonIxEabLL>a:only-child:after{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;content:\"\"}._39F2u6krlFsfPR1cSzGsVu{width:44%;height:99%;text-align:center;background-color:transparent;border:0;outline:0}._39F2u6krlFsfPR1cSzGsVu::-moz-placeholder{color:#bfbfbf;opacity:1}._39F2u6krlFsfPR1cSzGsVu:-ms-input-placeholder{color:#bfbfbf}._39F2u6krlFsfPR1cSzGsVu::-webkit-input-placeholder{color:#bfbfbf}._39F2u6krlFsfPR1cSzGsVu:-moz-placeholder-shown{text-overflow:ellipsis}._39F2u6krlFsfPR1cSzGsVu:-ms-input-placeholder{text-overflow:ellipsis}._39F2u6krlFsfPR1cSzGsVu:placeholder-shown{text-overflow:ellipsis}._39F2u6krlFsfPR1cSzGsVu[disabled]{cursor:not-allowed}._3VAW-irFbwAlXLuViXSYjy{display:inline-block;min-width:10px;height:100%;color:rgba(0,0,0,.45);white-space:nowrap;text-align:center;vertical-align:top;pointer-events:none}._3FSsiqFv7ewyrsZ0XZcEwC{width:552px;overflow:hidden}._3FSsiqFv7ewyrsZ0XZcEwC .b3-X_hmZKU5zUXbpox5eq:after{display:block;clear:both;height:0;visibility:hidden;content:\".\"}._2aChPRNCJaVfJTqvZzvr3D{position:relative;width:50%}._1sLE3SNpNh3SzKE3e9BOHJ{float:left}._1sLE3SNpNh3SzKE3e9BOHJ ._3qWIEQKUfDsOL9wB9KBrkv{border-right:1px solid #e8e8e8}.zbQ-asQD4HI1ayIaVnhN4{float:right}.zbQ-asQD4HI1ayIaVnhN4 ._3qWIEQKUfDsOL9wB9KBrkv{border-left:1px solid #e8e8e8}._2sB9KoxDFJkLiEocUI8dKB{position:absolute;left:50%;z-index:1;height:34px;margin:1px 0 0;padding:0 200px 0 0;color:rgba(0,0,0,.45);line-height:34px;text-align:center;transform:translateX(-50%);pointer-events:none}.zbQ-asQD4HI1ayIaVnhN4 ._1XhTqfY6g78iUTgtWGjyqw{margin-left:-90px}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._2sB9KoxDFJkLiEocUI8dKB{padding:0 10px 0 0;transform:translateX(-50%)}._3FSsiqFv7ewyrsZ0XZcEwC ._2EHQB_XsIRnUfNeNSRFsvc :not(._31mcDtESii0rdAOpFMD7SE) :not(._3TNOivRs6b3IDJ06G2OwKb) :not(._1fSwm4B4puu7Y-HwqpIwEe) ._3slHMiNvDSTCjC_Oi7FLqJ{color:#1890ff;background:#bae7ff;border-color:#1890ff}._3FSsiqFv7ewyrsZ0XZcEwC ._1lJR-gpJYPnz44lPIsza5H ._3slHMiNvDSTCjC_Oi7FLqJ,._3FSsiqFv7ewyrsZ0XZcEwC ._3dFZMq1QhFZ3OKZOih2f7d ._3slHMiNvDSTCjC_Oi7FLqJ{color:#fff;background:#1890ff;border:1px solid transparent}._3FSsiqFv7ewyrsZ0XZcEwC ._1lJR-gpJYPnz44lPIsza5H ._3slHMiNvDSTCjC_Oi7FLqJ:hover,._3FSsiqFv7ewyrsZ0XZcEwC ._3dFZMq1QhFZ3OKZOih2f7d ._3slHMiNvDSTCjC_Oi7FLqJ:hover{background:#1890ff}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY .zbQ-asQD4HI1ayIaVnhN4 ._1XhTqfY6g78iUTgtWGjyqw{margin-left:0}._3FSsiqFv7ewyrsZ0XZcEwC ._31ntJTDLEi4D9asydwj0gz{position:relative;height:34px}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps{position:relative;display:inline-block;width:100%;height:32px;padding:4px 11px;color:rgba(0,0,0,.65);font-size:14px;line-height:1.5;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s;height:24px;padding-right:0;padding-left:0;line-height:24px;border:0;box-shadow:none}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk::-moz-placeholder,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps::-moz-placeholder{color:#bfbfbf;opacity:1}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk:-ms-input-placeholder,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps:-ms-input-placeholder{color:#bfbfbf}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk::-webkit-input-placeholder,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps::-webkit-input-placeholder{color:#bfbfbf}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk:-moz-placeholder-shown,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps:-moz-placeholder-shown{text-overflow:ellipsis}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk:-ms-input-placeholder,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps:-ms-input-placeholder{text-overflow:ellipsis}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk:placeholder-shown,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps:placeholder-shown{text-overflow:ellipsis}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk:hover,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps:hover{border-color:#40a9ff;border-right-width:1px!important}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk:focus,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps:focus{border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._3FSsiqFv7ewyrsZ0XZcEwC ._1tzJnWx6V1H656bqPPMN_T,._3FSsiqFv7ewyrsZ0XZcEwC .Vw8zFmChZ5B-a2GnvqZ3A{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._3FSsiqFv7ewyrsZ0XZcEwC ._1tzJnWx6V1H656bqPPMN_T:hover,._3FSsiqFv7ewyrsZ0XZcEwC .Vw8zFmChZ5B-a2GnvqZ3A:hover{border-color:#d9d9d9;border-right-width:1px!important}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk[disabled],._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps[disabled]{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk[disabled]:hover,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk,textarea._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}._3FSsiqFv7ewyrsZ0XZcEwC ._1HTjOO06SbYvzbrGdioZOd,._3FSsiqFv7ewyrsZ0XZcEwC ._2jtNTN0hY6yneiVI4BFdLq{height:40px;padding:6px 11px;font-size:16px}._3FSsiqFv7ewyrsZ0XZcEwC ._3ugS0mb8U2Wqz1IWC10UcB,._3FSsiqFv7ewyrsZ0XZcEwC ._162vCx-q4xtwmaplSNab33{height:24px;padding:1px 7px}._3FSsiqFv7ewyrsZ0XZcEwC ._2Qcq1LR-Bq-DtnSniS6bOk:focus,._3FSsiqFv7ewyrsZ0XZcEwC ._3c8j69ATYTQ2LjOVlCt3Ps:focus{box-shadow:none}._3FSsiqFv7ewyrsZ0XZcEwC ._1kJ-2mTZqmbv5pPn5aJsJO{display:none}._3FSsiqFv7ewyrsZ0XZcEwC._8Drlz3GO0A5cZocJ4tBPm{width:574px}._3FSsiqFv7ewyrsZ0XZcEwC._8Drlz3GO0A5cZocJ4tBPm ._2aChPRNCJaVfJTqvZzvr3D{width:286px}._3FSsiqFv7ewyrsZ0XZcEwC ._3kn_HiNxNeZ8-54vXkOpWj,._3FSsiqFv7ewyrsZ0XZcEwC ._3XzI_7ZJ8rhRtqug7hMilQ,._3FSsiqFv7ewyrsZ0XZcEwC ._5i2IkmjITtOf_mk_ftYZc{top:34px}._3FSsiqFv7ewyrsZ0XZcEwC ._5i2IkmjITtOf_mk_ftYZc ._3kn_HiNxNeZ8-54vXkOpWj{top:0}._3FSsiqFv7ewyrsZ0XZcEwC ._2IMoWOliXKIcSKuf495oHA,._3FSsiqFv7ewyrsZ0XZcEwC ._31DF0gmr-NBuVR5G-cbhRE,._3FSsiqFv7ewyrsZ0XZcEwC .X4C1Cv0hFA7JEDXJRmsHv{height:208px}._3FSsiqFv7ewyrsZ0XZcEwC ._3_dnBh2usy1ehq7SCVSgsU{position:relative;border-radius:0}._3FSsiqFv7ewyrsZ0XZcEwC ._3_dnBh2usy1ehq7SCVSgsU>div{position:relative;z-index:1}._3FSsiqFv7ewyrsZ0XZcEwC ._3_dnBh2usy1ehq7SCVSgsU:before{position:absolute;top:4px;right:0;bottom:4px;left:0;display:block;background:#e6f7ff;border:0;border-radius:0;content:\"\"}._3FSsiqFv7ewyrsZ0XZcEwC ._10xqdK8Nztq4MiNfc79sBH{float:left}div._2qHlIE1V2A5dRGihU6ynjK{text-align:left}div._2qHlIE1V2A5dRGihU6ynjK>a{margin-right:8px}._3FSsiqFv7ewyrsZ0XZcEwC ._2jChZS1mmgphUk0iph8xcu,._3FSsiqFv7ewyrsZ0XZcEwC ._2kkvCXKMQ3plBGxJpV8ran,._3FSsiqFv7ewyrsZ0XZcEwC ._2Z5hgR5BfayNXIZAJe2b6d,._3FSsiqFv7ewyrsZ0XZcEwC ._13Qzdd5EtbGdEWMeRojuny{border-bottom:0}._3FSsiqFv7ewyrsZ0XZcEwC ._2qSkkOFNL5Hy59dHEVyD02,._3FSsiqFv7ewyrsZ0XZcEwC ._2wW5JvPITyQhjq52fd8LKh,._3FSsiqFv7ewyrsZ0XZcEwC ._27bGbehYIsvph00J3VxFS0,._3FSsiqFv7ewyrsZ0XZcEwC .b5LwnCqLHkTNxoeOJSteb{border-top:1px solid #e8e8e8}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._1Hox0Cktuv0KrRfTpMifX9{top:68px;z-index:2;width:100%;height:207px}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._1afavtvgBo-DPcZUTMs-kb{height:267px;margin-top:-34px}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._3qWIEQKUfDsOL9wB9KBrkv{height:100%;padding-top:40px;background:none}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._8PsybnRGb-obvxc6sN_wY{display:inline-block;height:100%;background-color:#fff;border-top:1px solid #e8e8e8}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._6tN-UalA-OWeaMyNN1wnn{height:100%}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._6tN-UalA-OWeaMyNN1wnn ul{max-height:100%}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._1MgpcwdTPCxW4vVEJzAbyw .Ql77bChlRjusuye40rq6M{margin-right:8px}._3FSsiqFv7ewyrsZ0XZcEwC._3QtsJW4BCw1yjNnO8KVmJY ._2sz5yU5QJo05sRNtM751fH{height:22px;margin:8px 12px;line-height:22px}._1Gr02Wxhnn5UsPxy5p_EcH._3QtsJW4BCw1yjNnO8KVmJY ._1Hox0Cktuv0KrRfTpMifX9{height:233px}._3FSsiqFv7ewyrsZ0XZcEwC._2S-mw0sPX3JyVL2G4zDybm ._2wW5JvPITyQhjq52fd8LKh{border-top-color:transparent}._1Hox0Cktuv0KrRfTpMifX9{position:absolute;top:40px;width:100%;background-color:#fff}._1afavtvgBo-DPcZUTMs-kb{position:absolute;z-index:1050;width:100%}._3qWIEQKUfDsOL9wB9KBrkv{position:relative;display:inline-block;width:100%;overflow:hidden;font-size:14px;line-height:1.5;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;outline:none}._3aBe8zOyUh_aCH_1-YSYU4,._3aBe8zOyUh_aCH_1-YSYU4 ._6tN-UalA-OWeaMyNN1wnn,._8PsybnRGb-obvxc6sN_wY{width:100%}._1h8WLFBbNbvMY3PICpm8mj ._6tN-UalA-OWeaMyNN1wnn{width:50%}._3obEyYcjPhk8zoytR-i_0_ ._6tN-UalA-OWeaMyNN1wnn{width:33.33%}.YsBnLujnxDfGmdlptnhLZ ._6tN-UalA-OWeaMyNN1wnn{width:25%}._1_yMVUi0PlpTw-gW-MtawV{display:none}._6tN-UalA-OWeaMyNN1wnn{position:relative;float:left;height:226px;overflow:hidden;font-size:14px;border-right:1px solid #e8e8e8}._6tN-UalA-OWeaMyNN1wnn:hover{overflow-y:auto}._6tN-UalA-OWeaMyNN1wnn:first-child{margin-left:0;border-left:0}._6tN-UalA-OWeaMyNN1wnn:last-child{border-right:0}._6tN-UalA-OWeaMyNN1wnn ul{width:100%;max-height:206px;margin:0;padding:0;list-style:none}._6tN-UalA-OWeaMyNN1wnn li{width:100%;height:24px;margin:0;line-height:24px;text-align:center;list-style:none;cursor:pointer;transition:all .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._6tN-UalA-OWeaMyNN1wnn li:last-child:after{display:block;height:202px;content:\"\"}._6tN-UalA-OWeaMyNN1wnn li:hover{background:#e6f7ff}._6tN-UalA-OWeaMyNN1wnn li:focus{color:#1890ff;font-weight:600;outline:none}li._2BPnBPRFUL6BMKlgaVHKzm{font-weight:600;background:#f5f5f5}li._22ulZnBCuJ0Y79UV-gLGLX{color:rgba(0,0,0,.25)}li._22ulZnBCuJ0Y79UV-gLGLX:hover{background:transparent;cursor:not-allowed}._3QtsJW4BCw1yjNnO8KVmJY .QN5EhGxBMO83enpFS7vIz{display:inline-block;padding:0 2px;color:rgba(0,0,0,.85);font-weight:500;line-height:34px}._3QtsJW4BCw1yjNnO8KVmJY ._1MgpcwdTPCxW4vVEJzAbyw{position:relative;height:auto}._3QtsJW4BCw1yjNnO8KVmJY ._3pRBNhIn_p9N3-uTZp7FGA{text-align:right}._3QtsJW4BCw1yjNnO8KVmJY ._1MgpcwdTPCxW4vVEJzAbyw ._2sz5yU5QJo05sRNtM751fH{float:left;margin:0}._3QtsJW4BCw1yjNnO8KVmJY ._1MgpcwdTPCxW4vVEJzAbyw .Ql77bChlRjusuye40rq6M{display:inline-block;margin-right:8px}._3QtsJW4BCw1yjNnO8KVmJY ._1MgpcwdTPCxW4vVEJzAbyw ._3cXcolAzy1nvQkCVCzSBFl{color:rgba(0,0,0,.25)}._5i2IkmjITtOf_mk_ftYZc{position:absolute;top:0;right:0;bottom:0;left:0;z-index:10;background:#fff;border-radius:4px;outline:none}._5i2IkmjITtOf_mk_ftYZc>div{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%}.XbCh2Rqt3mdZgBHlTUAii{display:none}._2Z5hgR5BfayNXIZAJe2b6d{height:40px;line-height:40px;text-align:center;border-bottom:1px solid #e8e8e8;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative}._2Z5hgR5BfayNXIZAJe2b6d a:hover{color:#40a9ff}._2Z5hgR5BfayNXIZAJe2b6d ._1T5DA6PUutFYtyXqhdQUal,._2Z5hgR5BfayNXIZAJe2b6d ._2GTe5mZTh66nqrlGfFEnKC,._2Z5hgR5BfayNXIZAJe2b6d ._2iGds_AC4wfmjmsm0Dkhgq,._2Z5hgR5BfayNXIZAJe2b6d ._2iQf7PopzT8i6iFsUQcPiQ{display:inline-block;padding:0 2px;color:rgba(0,0,0,.85);font-weight:500;line-height:40px}._2Z5hgR5BfayNXIZAJe2b6d ._1TuqVfGLq3Mh5ojzDMQ1yq,._2Z5hgR5BfayNXIZAJe2b6d ._2CZ0sRphKpWR09kYZYUu_s,._2Z5hgR5BfayNXIZAJe2b6d ._39Expx39AjgOgVlOo2daHO,._2Z5hgR5BfayNXIZAJe2b6d .AiVSUYqW8F4NmvDgXPhT4{display:none}._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2,._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI,._2Z5hgR5BfayNXIZAJe2b6d ._2pqOGvo3XNxEw4POCQVFT1,._2Z5hgR5BfayNXIZAJe2b6d ._3m2ip7m-AIVMKMH9IoGdN6,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH,._2Z5hgR5BfayNXIZAJe2b6d ._336MQABbjXtW62moRMuWru,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5,._2Z5hgR5BfayNXIZAJe2b6d .ylDUlwEEg_RLqOGdDQ7Fh{position:absolute;top:0;display:inline-block;padding:0 5px;color:rgba(0,0,0,.45);font-size:16px;font-family:Arial,Hiragino Sans GB,Microsoft Yahei,Microsoft Sans Serif,sans-serif;line-height:40px}._2Z5hgR5BfayNXIZAJe2b6d ._2pqOGvo3XNxEw4POCQVFT1,._2Z5hgR5BfayNXIZAJe2b6d ._336MQABbjXtW62moRMuWru,._2Z5hgR5BfayNXIZAJe2b6d .ylDUlwEEg_RLqOGdDQ7Fh{left:7px;height:100%}._2Z5hgR5BfayNXIZAJe2b6d ._2pqOGvo3XNxEw4POCQVFT1:after,._2Z5hgR5BfayNXIZAJe2b6d ._2pqOGvo3XNxEw4POCQVFT1:before,._2Z5hgR5BfayNXIZAJe2b6d ._336MQABbjXtW62moRMuWru:after,._2Z5hgR5BfayNXIZAJe2b6d ._336MQABbjXtW62moRMuWru:before,._2Z5hgR5BfayNXIZAJe2b6d .ylDUlwEEg_RLqOGdDQ7Fh:after,._2Z5hgR5BfayNXIZAJe2b6d .ylDUlwEEg_RLqOGdDQ7Fh:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2Z5hgR5BfayNXIZAJe2b6d ._2pqOGvo3XNxEw4POCQVFT1:hover:after,._2Z5hgR5BfayNXIZAJe2b6d ._2pqOGvo3XNxEw4POCQVFT1:hover:before,._2Z5hgR5BfayNXIZAJe2b6d ._336MQABbjXtW62moRMuWru:hover:after,._2Z5hgR5BfayNXIZAJe2b6d ._336MQABbjXtW62moRMuWru:hover:before,._2Z5hgR5BfayNXIZAJe2b6d .ylDUlwEEg_RLqOGdDQ7Fh:hover:after,._2Z5hgR5BfayNXIZAJe2b6d .ylDUlwEEg_RLqOGdDQ7Fh:hover:before{border-color:rgba(0,0,0,.65)}._2Z5hgR5BfayNXIZAJe2b6d ._2pqOGvo3XNxEw4POCQVFT1:after,._2Z5hgR5BfayNXIZAJe2b6d ._336MQABbjXtW62moRMuWru:after,._2Z5hgR5BfayNXIZAJe2b6d .ylDUlwEEg_RLqOGdDQ7Fh:after{display:none;position:relative;left:-3px;display:inline-block}._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5{right:7px;height:100%}._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:after,._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:before,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:after,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:before,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:after,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:hover:after,._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:hover:before,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:hover:after,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:hover:before,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:hover:after,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:hover:before{border-color:rgba(0,0,0,.65)}._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:after,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:after,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:after{display:none}._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:after,._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:before,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:after,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:before,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:after,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:before{transform:rotate(135deg) scale(.8)}._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:before,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:before,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:before{position:relative;left:3px}._2Z5hgR5BfayNXIZAJe2b6d ._2DXuuZ5ogBChLBpAk5iCYI:after,._2Z5hgR5BfayNXIZAJe2b6d ._4BRmGeedp1g013tGWoENH:after,._2Z5hgR5BfayNXIZAJe2b6d .TemtsXq6sB3csC_cTF8k5:after{display:inline-block}._2Z5hgR5BfayNXIZAJe2b6d ._3m2ip7m-AIVMKMH9IoGdN6{left:29px;height:100%}._2Z5hgR5BfayNXIZAJe2b6d ._3m2ip7m-AIVMKMH9IoGdN6:after,._2Z5hgR5BfayNXIZAJe2b6d ._3m2ip7m-AIVMKMH9IoGdN6:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2Z5hgR5BfayNXIZAJe2b6d ._3m2ip7m-AIVMKMH9IoGdN6:hover:after,._2Z5hgR5BfayNXIZAJe2b6d ._3m2ip7m-AIVMKMH9IoGdN6:hover:before{border-color:rgba(0,0,0,.65)}._2Z5hgR5BfayNXIZAJe2b6d ._3m2ip7m-AIVMKMH9IoGdN6:after{display:none}._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2{right:29px;height:100%}._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2:after,._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2:hover:after,._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2:hover:before{border-color:rgba(0,0,0,.65)}._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2:after{display:none}._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2:after,._2Z5hgR5BfayNXIZAJe2b6d ._1xYQSPFiX6wQqNOq_zdGt2:before{transform:rotate(135deg) scale(.8)}.b5LwnCqLHkTNxoeOJSteb{-ms-flex:1;flex:1}.eQvVSwNfx8jvrxmGvLzSw{border-top:1px solid #e8e8e8}.eQvVSwNfx8jvrxmGvLzSw ._10xqdK8Nztq4MiNfc79sBH{padding:0 12px}.X4C1Cv0hFA7JEDXJRmsHv{width:100%;height:100%;table-layout:fixed;border-collapse:separate}._11E2XEItWh24YX-RCOfjge ._2nibJAbTEq56afjlCwIVjW,._11E2XEItWh24YX-RCOfjge ._2nibJAbTEq56afjlCwIVjW:hover{color:#fff;background:#1890ff}._2qFu2biI_NGBsqdFvRzs2R{text-align:center}.hLaQ6WatXeJWKKHCs2w15 ._2nibJAbTEq56afjlCwIVjW,.hLaQ6WatXeJWKKHCs2w15 ._2nibJAbTEq56afjlCwIVjW:hover{color:rgba(0,0,0,.25);background:#f5f5f5;cursor:not-allowed}._2nibJAbTEq56afjlCwIVjW{display:inline-block;height:24px;margin:0 auto;padding:0 8px;color:rgba(0,0,0,.65);line-height:24px;text-align:center;background:transparent;border-radius:2px;transition:background .3s ease}._2nibJAbTEq56afjlCwIVjW:hover{background:#e6f7ff;cursor:pointer}._3kn_HiNxNeZ8-54vXkOpWj{position:absolute;top:0;right:0;bottom:0;left:0;z-index:10;background:#fff;border-radius:4px;outline:none}._3kn_HiNxNeZ8-54vXkOpWj>div{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%}._3ywtwKHcf6T6htQBzryHwd{display:none}._13Qzdd5EtbGdEWMeRojuny{height:40px;line-height:40px;text-align:center;border-bottom:1px solid #e8e8e8;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative}._13Qzdd5EtbGdEWMeRojuny a:hover{color:#40a9ff}._13Qzdd5EtbGdEWMeRojuny ._1ZJDvq6_7T6mlUQSOoNLB6,._13Qzdd5EtbGdEWMeRojuny ._3Ud775zZeyRZ5SvA6N9In6,._13Qzdd5EtbGdEWMeRojuny ._213hNuJT4BDSD0YmugElQ,._13Qzdd5EtbGdEWMeRojuny .eejR6aeX2TZLKZNJJU8OH{display:inline-block;padding:0 2px;color:rgba(0,0,0,.85);font-weight:500;line-height:40px}._13Qzdd5EtbGdEWMeRojuny .-kX_DcwnSjSkgEIAzep8J,._13Qzdd5EtbGdEWMeRojuny ._1XFEIjfzxyl1vqufIVbVty,._13Qzdd5EtbGdEWMeRojuny ._2PGpAFkilug9mTUnOg8KS1,._13Qzdd5EtbGdEWMeRojuny ._3EBmGuSHAOKlA3Jl4DDtJT{display:none}._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL,._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5,._13Qzdd5EtbGdEWMeRojuny ._3aRSzg4qnmpKlQfnggqAPE,._13Qzdd5EtbGdEWMeRojuny ._36KtwsBNS7qhPcwxFZVxMq,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4,._13Qzdd5EtbGdEWMeRojuny .qlD7cvKjieBjts2Oft7rb,._13Qzdd5EtbGdEWMeRojuny .TWoBI6b0DChhNJtpsZi6_{position:absolute;top:0;display:inline-block;padding:0 5px;color:rgba(0,0,0,.45);font-size:16px;font-family:Arial,Hiragino Sans GB,Microsoft Yahei,Microsoft Sans Serif,sans-serif;line-height:40px}._13Qzdd5EtbGdEWMeRojuny ._3aRSzg4qnmpKlQfnggqAPE,._13Qzdd5EtbGdEWMeRojuny ._36KtwsBNS7qhPcwxFZVxMq,._13Qzdd5EtbGdEWMeRojuny .qlD7cvKjieBjts2Oft7rb{left:7px;height:100%}._13Qzdd5EtbGdEWMeRojuny ._3aRSzg4qnmpKlQfnggqAPE:after,._13Qzdd5EtbGdEWMeRojuny ._3aRSzg4qnmpKlQfnggqAPE:before,._13Qzdd5EtbGdEWMeRojuny ._36KtwsBNS7qhPcwxFZVxMq:after,._13Qzdd5EtbGdEWMeRojuny ._36KtwsBNS7qhPcwxFZVxMq:before,._13Qzdd5EtbGdEWMeRojuny .qlD7cvKjieBjts2Oft7rb:after,._13Qzdd5EtbGdEWMeRojuny .qlD7cvKjieBjts2Oft7rb:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._13Qzdd5EtbGdEWMeRojuny ._3aRSzg4qnmpKlQfnggqAPE:hover:after,._13Qzdd5EtbGdEWMeRojuny ._3aRSzg4qnmpKlQfnggqAPE:hover:before,._13Qzdd5EtbGdEWMeRojuny ._36KtwsBNS7qhPcwxFZVxMq:hover:after,._13Qzdd5EtbGdEWMeRojuny ._36KtwsBNS7qhPcwxFZVxMq:hover:before,._13Qzdd5EtbGdEWMeRojuny .qlD7cvKjieBjts2Oft7rb:hover:after,._13Qzdd5EtbGdEWMeRojuny .qlD7cvKjieBjts2Oft7rb:hover:before{border-color:rgba(0,0,0,.65)}._13Qzdd5EtbGdEWMeRojuny ._3aRSzg4qnmpKlQfnggqAPE:after,._13Qzdd5EtbGdEWMeRojuny ._36KtwsBNS7qhPcwxFZVxMq:after,._13Qzdd5EtbGdEWMeRojuny .qlD7cvKjieBjts2Oft7rb:after{display:none;position:relative;left:-3px;display:inline-block}._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4{right:7px;height:100%}._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:after,._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:before,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:after,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:before,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:after,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:hover:after,._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:hover:before,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:hover:after,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:hover:before,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:hover:after,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:hover:before{border-color:rgba(0,0,0,.65)}._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:after,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:after,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:after{display:none}._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:after,._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:before,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:after,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:before,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:after,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:before{transform:rotate(135deg) scale(.8)}._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:before,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:before,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:before{position:relative;left:3px}._13Qzdd5EtbGdEWMeRojuny ._1ajnep20JTS6HHQgonDFzQ:after,._13Qzdd5EtbGdEWMeRojuny ._1ffvAG9sVfRQwwh4kw-QIL:after,._13Qzdd5EtbGdEWMeRojuny .KBF01uIJ3DNb-yNXE-Ae4:after{display:inline-block}._13Qzdd5EtbGdEWMeRojuny .TWoBI6b0DChhNJtpsZi6_{left:29px;height:100%}._13Qzdd5EtbGdEWMeRojuny .TWoBI6b0DChhNJtpsZi6_:after,._13Qzdd5EtbGdEWMeRojuny .TWoBI6b0DChhNJtpsZi6_:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._13Qzdd5EtbGdEWMeRojuny .TWoBI6b0DChhNJtpsZi6_:hover:after,._13Qzdd5EtbGdEWMeRojuny .TWoBI6b0DChhNJtpsZi6_:hover:before{border-color:rgba(0,0,0,.65)}._13Qzdd5EtbGdEWMeRojuny .TWoBI6b0DChhNJtpsZi6_:after{display:none}._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5{right:29px;height:100%}._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5:after,._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5:hover:after,._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5:hover:before{border-color:rgba(0,0,0,.65)}._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5:after{display:none}._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5:after,._13Qzdd5EtbGdEWMeRojuny ._1tQcfDl_LTu_uIV-imD7F5:before{transform:rotate(135deg) scale(.8)}._2qSkkOFNL5Hy59dHEVyD02{-ms-flex:1;flex:1}._3V9QoJ5591_6s5yg8OZTze{border-top:1px solid #e8e8e8}._3V9QoJ5591_6s5yg8OZTze ._10xqdK8Nztq4MiNfc79sBH{padding:0 12px}._2IMoWOliXKIcSKuf495oHA{width:100%;height:100%;table-layout:fixed;border-collapse:separate}._3FT4tYiEWy8kwmJBYdqb11{text-align:center}._3r_ViX6eroa2fv5AQnEuhP{display:inline-block;height:24px;margin:0 auto;padding:0 8px;color:rgba(0,0,0,.65);line-height:24px;text-align:center;background:transparent;border-radius:2px;transition:background .3s ease}._3r_ViX6eroa2fv5AQnEuhP:hover{background:#e6f7ff;cursor:pointer}._34YmSv1hFtrJpbUNedrHD0 ._3r_ViX6eroa2fv5AQnEuhP,._34YmSv1hFtrJpbUNedrHD0 ._3r_ViX6eroa2fv5AQnEuhP:hover{color:#fff;background:#1890ff}.lxqo0R2Cc6LRtcVnXaVMV ._3r_ViX6eroa2fv5AQnEuhP,.yg3YnBFZAcDOrqEk2am4c ._3r_ViX6eroa2fv5AQnEuhP{color:rgba(0,0,0,.25);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3XzI_7ZJ8rhRtqug7hMilQ{position:absolute;top:0;right:0;bottom:0;left:0;z-index:10;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;background:#fff;border-radius:4px;outline:none}._2Pvfrz5M1rjsty0KBnQiVp{display:none}._2jChZS1mmgphUk0iph8xcu{height:40px;line-height:40px;text-align:center;border-bottom:1px solid #e8e8e8;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative}._2jChZS1mmgphUk0iph8xcu a:hover{color:#40a9ff}._2jChZS1mmgphUk0iph8xcu ._3DNGitVy_7699goPX4SEPi,._2jChZS1mmgphUk0iph8xcu ._3xvl8E_LQ8PsYoS8vGzP4L,._2jChZS1mmgphUk0iph8xcu ._28ol_BDn0ry5FVt-fSnpXa,._2jChZS1mmgphUk0iph8xcu .ns29lBTpO6GyQYww8fV-2{display:inline-block;padding:0 2px;color:rgba(0,0,0,.85);font-weight:500;line-height:40px}._2jChZS1mmgphUk0iph8xcu ._1Fm5pJvq4npyU1ePcNVR_A,._2jChZS1mmgphUk0iph8xcu ._1HDLMY4osm4qVUlJwrfv9K,._2jChZS1mmgphUk0iph8xcu ._2c1BK-ZOlLNdl7ZHbDwKRZ,._2jChZS1mmgphUk0iph8xcu ._3d1j2zrc-Ja9_deA9uaNaa{display:none}._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm,._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf,._2jChZS1mmgphUk0iph8xcu ._2WF9RWijvPnyDhE3c-mA3f,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn,._2jChZS1mmgphUk0iph8xcu ._9xu4B_AS6sQJqK6O-LHyf,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-,._2jChZS1mmgphUk0iph8xcu .TMtoWvJVJPFMZqvh2ZbKg,._2jChZS1mmgphUk0iph8xcu .YPF7ZQmYIEG-qSyFrVcWC{position:absolute;top:0;display:inline-block;padding:0 5px;color:rgba(0,0,0,.45);font-size:16px;font-family:Arial,Hiragino Sans GB,Microsoft Yahei,Microsoft Sans Serif,sans-serif;line-height:40px}._2jChZS1mmgphUk0iph8xcu ._2WF9RWijvPnyDhE3c-mA3f,._2jChZS1mmgphUk0iph8xcu ._9xu4B_AS6sQJqK6O-LHyf,._2jChZS1mmgphUk0iph8xcu .TMtoWvJVJPFMZqvh2ZbKg{left:7px;height:100%}._2jChZS1mmgphUk0iph8xcu ._2WF9RWijvPnyDhE3c-mA3f:after,._2jChZS1mmgphUk0iph8xcu ._2WF9RWijvPnyDhE3c-mA3f:before,._2jChZS1mmgphUk0iph8xcu ._9xu4B_AS6sQJqK6O-LHyf:after,._2jChZS1mmgphUk0iph8xcu ._9xu4B_AS6sQJqK6O-LHyf:before,._2jChZS1mmgphUk0iph8xcu .TMtoWvJVJPFMZqvh2ZbKg:after,._2jChZS1mmgphUk0iph8xcu .TMtoWvJVJPFMZqvh2ZbKg:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2jChZS1mmgphUk0iph8xcu ._2WF9RWijvPnyDhE3c-mA3f:hover:after,._2jChZS1mmgphUk0iph8xcu ._2WF9RWijvPnyDhE3c-mA3f:hover:before,._2jChZS1mmgphUk0iph8xcu ._9xu4B_AS6sQJqK6O-LHyf:hover:after,._2jChZS1mmgphUk0iph8xcu ._9xu4B_AS6sQJqK6O-LHyf:hover:before,._2jChZS1mmgphUk0iph8xcu .TMtoWvJVJPFMZqvh2ZbKg:hover:after,._2jChZS1mmgphUk0iph8xcu .TMtoWvJVJPFMZqvh2ZbKg:hover:before{border-color:rgba(0,0,0,.65)}._2jChZS1mmgphUk0iph8xcu ._2WF9RWijvPnyDhE3c-mA3f:after,._2jChZS1mmgphUk0iph8xcu ._9xu4B_AS6sQJqK6O-LHyf:after,._2jChZS1mmgphUk0iph8xcu .TMtoWvJVJPFMZqvh2ZbKg:after{display:none;position:relative;left:-3px;display:inline-block}._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-{right:7px;height:100%}._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:after,._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:before,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:after,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:before,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:after,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:hover:after,._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:hover:before,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:hover:after,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:hover:before,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:hover:after,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:hover:before{border-color:rgba(0,0,0,.65)}._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:after,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:after,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:after{display:none}._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:after,._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:before,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:after,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:before,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:after,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:before{transform:rotate(135deg) scale(.8)}._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:before,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:before,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:before{position:relative;left:3px}._2jChZS1mmgphUk0iph8xcu ._2D2O6AG4cE2z6Ll__zQwKf:after,._2jChZS1mmgphUk0iph8xcu ._2yNSzl4h_i1odCDdRPOUCn:after,._2jChZS1mmgphUk0iph8xcu .RXhxbQ2DoEuB5dJbVchZ-:after{display:inline-block}._2jChZS1mmgphUk0iph8xcu .YPF7ZQmYIEG-qSyFrVcWC{left:29px;height:100%}._2jChZS1mmgphUk0iph8xcu .YPF7ZQmYIEG-qSyFrVcWC:after,._2jChZS1mmgphUk0iph8xcu .YPF7ZQmYIEG-qSyFrVcWC:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2jChZS1mmgphUk0iph8xcu .YPF7ZQmYIEG-qSyFrVcWC:hover:after,._2jChZS1mmgphUk0iph8xcu .YPF7ZQmYIEG-qSyFrVcWC:hover:before{border-color:rgba(0,0,0,.65)}._2jChZS1mmgphUk0iph8xcu .YPF7ZQmYIEG-qSyFrVcWC:after{display:none}._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm{right:29px;height:100%}._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm:after,._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm:before{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:\"\"}._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm:hover:after,._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm:hover:before{border-color:rgba(0,0,0,.65)}._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm:after{display:none}._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm:after,._2jChZS1mmgphUk0iph8xcu ._1dXmYT7p-_yLPTl9Xu52Lm:before{transform:rotate(135deg) scale(.8)}._27bGbehYIsvph00J3VxFS0{-ms-flex:1;flex:1}._2bU9GIAkO7xJ2BX1-DvdUf{border-top:1px solid #e8e8e8}._2bU9GIAkO7xJ2BX1-DvdUf ._10xqdK8Nztq4MiNfc79sBH{padding:0 12px}._31DF0gmr-NBuVR5G-cbhRE{width:100%;height:100%;table-layout:fixed;border-collapse:separate}._1eNxo5WIGWGHUCDW1EOPEp{white-space:nowrap;text-align:center}._2FxVtXKz3NjUhpiHpEFIgY{display:inline-block;height:24px;margin:0 auto;padding:0 6px;color:rgba(0,0,0,.65);line-height:24px;text-align:center;background:transparent;border-radius:2px;transition:background .3s ease}._2FxVtXKz3NjUhpiHpEFIgY:hover{background:#e6f7ff;cursor:pointer}.MxiIZTlNOAX4UbnsnO5C5 ._2FxVtXKz3NjUhpiHpEFIgY,.MxiIZTlNOAX4UbnsnO5C5 ._2FxVtXKz3NjUhpiHpEFIgY:hover{color:#fff;background:#1890ff}._2u5hTaEma1lgLkZRJCtvH7 ._2FxVtXKz3NjUhpiHpEFIgY,.qUTfszQXA-ZZnwzfzHV4z ._2FxVtXKz3NjUhpiHpEFIgY{color:rgba(0,0,0,.25);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.xL-0ydbiVfTshJaXvy0hl ._2xdSGSr3SlfZd4ktw5xu8z{position:relative;height:288px}.xL-0ydbiVfTshJaXvy0hl ._3kn_HiNxNeZ8-54vXkOpWj,.xL-0ydbiVfTshJaXvy0hl ._5i2IkmjITtOf_mk_ftYZc{top:0;height:100%}._3YSOHYTSeOuMvjDKKV2Cw4{opacity:.5}._8Drlz3GO0A5cZocJ4tBPm ._2wW5JvPITyQhjq52fd8LKh tr{cursor:pointer;transition:all .3s}._8Drlz3GO0A5cZocJ4tBPm ._2wW5JvPITyQhjq52fd8LKh tr:hover{background:#e6f7ff}._8Drlz3GO0A5cZocJ4tBPm ._2wW5JvPITyQhjq52fd8LKh tr._1KvGYQ2rN_mndInMfsJcDK{font-weight:700;background:#bae7ff}._8Drlz3GO0A5cZocJ4tBPm ._2wW5JvPITyQhjq52fd8LKh tr .qQuZoLJftUhEnJq1MhTV3 ._3slHMiNvDSTCjC_Oi7FLqJ,._8Drlz3GO0A5cZocJ4tBPm ._2wW5JvPITyQhjq52fd8LKh tr .qQuZoLJftUhEnJq1MhTV3:hover ._3slHMiNvDSTCjC_Oi7FLqJ{color:rgba(0,0,0,.65);background:transparent}._2GNtIDxw9jmNc-bwe9J9fs{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;z-index:1050;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif}._28fPCL1WEEkOsiyV40k6fa{position:relative;left:-2px;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border-radius:4px;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.15)}._1dc-htT2NExZftLEYPs_Y_{width:100%;max-width:154px;margin:0;padding:0;line-height:normal;border:0;outline:0;cursor:auto}._1dc-htT2NExZftLEYPs_Y_::-moz-placeholder{color:#bfbfbf;opacity:1}._1dc-htT2NExZftLEYPs_Y_:-ms-input-placeholder{color:#bfbfbf}._1dc-htT2NExZftLEYPs_Y_::-webkit-input-placeholder{color:#bfbfbf}._1dc-htT2NExZftLEYPs_Y_:-moz-placeholder-shown{text-overflow:ellipsis}._1dc-htT2NExZftLEYPs_Y_:-ms-input-placeholder{text-overflow:ellipsis}._1dc-htT2NExZftLEYPs_Y_:placeholder-shown{text-overflow:ellipsis}._37gUGNvFI06DRqyivDzwDG{position:relative;padding:7px 2px 7px 12px;border-bottom:1px solid #e8e8e8}._3acp7JS9rp2mfK3k0LJk9I{border-color:#f5222d}._3w2dyN3wwQ_jzexsuaENdI ._37gUGNvFI06DRqyivDzwDG{max-width:112px}.pcjsoR8Fy2hw5OFnGPlgL{position:relative;float:left;width:56px;max-height:192px;overflow:hidden;font-size:14px;border-left:1px solid #e8e8e8}.pcjsoR8Fy2hw5OFnGPlgL:hover{overflow-y:auto}.pcjsoR8Fy2hw5OFnGPlgL:first-child{margin-left:0;border-left:0}.pcjsoR8Fy2hw5OFnGPlgL:last-child{border-right:0}.pcjsoR8Fy2hw5OFnGPlgL:only-child{width:100%}.pcjsoR8Fy2hw5OFnGPlgL ul{width:56px;margin:0;padding:0 0 160px;list-style:none}.pcjsoR8Fy2hw5OFnGPlgL li{width:100%;height:32px;margin:0;padding:0 0 0 12px;line-height:32px;text-align:left;list-style:none;cursor:pointer;transition:all .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pcjsoR8Fy2hw5OFnGPlgL li:focus{color:#1890ff;font-weight:600;outline:none}.pcjsoR8Fy2hw5OFnGPlgL li:hover{background:#e6f7ff}li.tM3oWKZ-fYym95A9Je8kP{font-weight:600;background:#f5f5f5}li.tM3oWKZ-fYym95A9Je8kP:hover{background:#f5f5f5}li.EEGNkzTHyLT7bsQfV-QQt{color:rgba(0,0,0,.25)}li.EEGNkzTHyLT7bsQfV-QQt:hover{background:transparent;cursor:not-allowed}li.EEGNkzTHyLT7bsQfV-QQt:focus{color:rgba(0,0,0,.25);font-weight:inherit}._3c2cQnHkcnxmShnKXb4zH4{zoom:1}._3c2cQnHkcnxmShnKXb4zH4:after,._3c2cQnHkcnxmShnKXb4zH4:before{display:table;content:\"\"}._3c2cQnHkcnxmShnKXb4zH4:after{clear:both}.OfefvOc3nw6lr2WndWvYc{padding:8px;border-top:1px solid #e8e8e8}._2GNtIDxw9jmNc-bwe9J9fs._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._2rpLi83zVVb1IBP8dQZgUt,._2GNtIDxw9jmNc-bwe9J9fs._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._3dvb8njS5uArXjLVfoEQMn,._2GNtIDxw9jmNc-bwe9J9fs._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._2rpLi83zVVb1IBP8dQZgUt,._2GNtIDxw9jmNc-bwe9J9fs._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._3dvb8njS5uArXjLVfoEQMn{animation-name:_3JK1uFdxrQM9RK51sOtrar}._2GNtIDxw9jmNc-bwe9J9fs._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._2gdkUdvvFo7gxIgELpaaWJ,._2GNtIDxw9jmNc-bwe9J9fs._1vRvMYH3Kp_wSCSKo1Vzkx._1ULLr8re4ZnpLmsLEf9jim._3UpD-AMsLyIv6t7rhcE7N5,._2GNtIDxw9jmNc-bwe9J9fs._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._2gdkUdvvFo7gxIgELpaaWJ,._2GNtIDxw9jmNc-bwe9J9fs._3BcFfbN5qAnzO13exrUs03.rQ19DUBIWL66Zukwke2_C._3UpD-AMsLyIv6t7rhcE7N5{animation-name:_2lqTGgogIItpImYAn3wMQO}._2GNtIDxw9jmNc-bwe9J9fs._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._2rpLi83zVVb1IBP8dQZgUt,._2GNtIDxw9jmNc-bwe9J9fs._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._3dvb8njS5uArXjLVfoEQMn{animation-name:_1F89QugyM0FQpooygKHf2k}._2GNtIDxw9jmNc-bwe9J9fs._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._2gdkUdvvFo7gxIgELpaaWJ,._2GNtIDxw9jmNc-bwe9J9fs._3JPmXAUWZHG7TyCs5QZHGb.ScIepRKcudwUEDzyD4-cX._3UpD-AMsLyIv6t7rhcE7N5{animation-name:_2IDJAVNNcAmXsLtWbzNJtk}.ufc92ympr1e8GM1qw2Hz0{box-sizing:border-box;margin:0;padding:0;font-size:14px;font-variant:tabular-nums;list-style:none;font-feature-settings:\"tnum\";width:128px;outline:none;cursor:text;transition:opacity .3s}.rbO6RzhtTm7Ha5feDxDOm,.ufc92ympr1e8GM1qw2Hz0{color:rgba(0,0,0,.65);line-height:1.5;position:relative;display:inline-block}.rbO6RzhtTm7Ha5feDxDOm{width:100%;height:32px;padding:4px 11px;font-size:14px;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s}.rbO6RzhtTm7Ha5feDxDOm::-moz-placeholder{color:#bfbfbf;opacity:1}.rbO6RzhtTm7Ha5feDxDOm:-ms-input-placeholder{color:#bfbfbf}.rbO6RzhtTm7Ha5feDxDOm::-webkit-input-placeholder{color:#bfbfbf}.rbO6RzhtTm7Ha5feDxDOm:-moz-placeholder-shown{text-overflow:ellipsis}.rbO6RzhtTm7Ha5feDxDOm:-ms-input-placeholder{text-overflow:ellipsis}.rbO6RzhtTm7Ha5feDxDOm:placeholder-shown{text-overflow:ellipsis}.rbO6RzhtTm7Ha5feDxDOm:focus,.rbO6RzhtTm7Ha5feDxDOm:hover{border-color:#40a9ff;border-right-width:1px!important}.rbO6RzhtTm7Ha5feDxDOm:focus{outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._1daHxsBUJVWusuSKYMfbVu{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._1daHxsBUJVWusuSKYMfbVu:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea.rbO6RzhtTm7Ha5feDxDOm{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}._2Pyvp5o079s0QNFBkiCJ2O{height:40px;padding:6px 11px;font-size:16px}._29zwP_YFKmOXFlBRyZv6OG{height:24px;padding:1px 7px}.rbO6RzhtTm7Ha5feDxDOm[disabled]{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}.rbO6RzhtTm7Ha5feDxDOm[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}._3MTU2qYeJD0WQcxckTPPen{opacity:0}._3q9TG9Eekd0jcg5Jfeh-MJ,.iERe0CWcSdjLkEwAiRq4t{position:absolute;top:50%;right:11px;z-index:1;width:14px;height:14px;margin-top:-7px;color:rgba(0,0,0,.25);line-height:14px;transition:all .3s cubic-bezier(.645,.045,.355,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3q9TG9Eekd0jcg5Jfeh-MJ ._3Z3WqS4jhio8IG1rkNEjXP,.iERe0CWcSdjLkEwAiRq4t ._3Z3WqS4jhio8IG1rkNEjXP{display:block;color:rgba(0,0,0,.25);line-height:1}._3q9TG9Eekd0jcg5Jfeh-MJ{z-index:2;background:#fff;opacity:0;pointer-events:none}._3q9TG9Eekd0jcg5Jfeh-MJ:hover{color:rgba(0,0,0,.45)}.ufc92ympr1e8GM1qw2Hz0:hover ._3q9TG9Eekd0jcg5Jfeh-MJ{opacity:1;pointer-events:auto}.qIfYHydDmTibvi4A-i40s .rbO6RzhtTm7Ha5feDxDOm{height:40px;padding:6px 11px;font-size:16px}._3kUDHp7F0A47KOUnANFZpL .rbO6RzhtTm7Ha5feDxDOm{height:24px;padding:1px 7px}._3kUDHp7F0A47KOUnANFZpL ._3q9TG9Eekd0jcg5Jfeh-MJ,._3kUDHp7F0A47KOUnANFZpL .iERe0CWcSdjLkEwAiRq4t{right:7px}@media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none) and (stroke-color:transparent){._3pPc-OF79GHv_bF35yGDY1{line-height:1.5}}}._34hUjmK5pAowh5cdxG7iPA{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block;height:auto;margin-right:8px;padding:0 7px;font-size:12px;line-height:20px;white-space:nowrap;background:#fafafa;border:1px solid #d9d9d9;border-radius:4px;cursor:default;opacity:1;transition:all .3s cubic-bezier(.78,.14,.15,.86)}._34hUjmK5pAowh5cdxG7iPA:hover{opacity:.85}._34hUjmK5pAowh5cdxG7iPA,._34hUjmK5pAowh5cdxG7iPA a,._34hUjmK5pAowh5cdxG7iPA a:hover{color:rgba(0,0,0,.65)}._34hUjmK5pAowh5cdxG7iPA>a:first-child:last-child{display:inline-block;margin:0 -8px;padding:0 8px}._34hUjmK5pAowh5cdxG7iPA ._3EEcVNYgJHJafe89WJy5Un{display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg);margin-left:3px;color:rgba(0,0,0,.45);font-weight:700;cursor:pointer;transition:all .3s cubic-bezier(.78,.14,.15,.86)}:root ._34hUjmK5pAowh5cdxG7iPA ._3EEcVNYgJHJafe89WJy5Un{font-size:12px}._34hUjmK5pAowh5cdxG7iPA ._3EEcVNYgJHJafe89WJy5Un:hover{color:rgba(0,0,0,.85)}._3fm0tTtOra9C5RVVSDktZr{border-color:transparent}._3fm0tTtOra9C5RVVSDktZr,._3fm0tTtOra9C5RVVSDktZr ._3EEcVNYgJHJafe89WJy5Un,._3fm0tTtOra9C5RVVSDktZr ._3EEcVNYgJHJafe89WJy5Un:hover,._3fm0tTtOra9C5RVVSDktZr a,._3fm0tTtOra9C5RVVSDktZr a:hover{color:#fff}._1QSKQWhfWGpUKBMc4I19CI{background-color:transparent;border-color:transparent}._1QSKQWhfWGpUKBMc4I19CI:not(._23m3ZM4ZI3ZqgtY3_N9tOz):hover{color:#1890ff}._1QSKQWhfWGpUKBMc4I19CI:active,._23m3ZM4ZI3ZqgtY3_N9tOz{color:#fff}._23m3ZM4ZI3ZqgtY3_N9tOz{background-color:#1890ff}._1QSKQWhfWGpUKBMc4I19CI:active{background-color:#096dd9}._3hkH1v1bLJPSbF0cAgmj-h{display:none}.nQsPevY3j0qVa_JpddmwD{color:#eb2f96;background:#fff0f6;border-color:#ffadd2}._3d9P06tl-1U0fmNCwchyhe{color:#fff;background:#eb2f96;border-color:#eb2f96}._1AGjEsdUZ3HZKkFzMthvYS{color:#eb2f96;background:#fff0f6;border-color:#ffadd2}.VdbHKa7KP-hAkADrumBEW{color:#fff;background:#eb2f96;border-color:#eb2f96}._2MkOdcyIEWg25Z505_05oi{color:#f5222d;background:#fff1f0;border-color:#ffa39e}._1njBgpO4DnheQ47pjJrc0N{color:#fff;background:#f5222d;border-color:#f5222d}._26hX3lCzhaINiY1HDitwal{color:#fa541c;background:#fff2e8;border-color:#ffbb96}._1frfPifXvJ4Of51Z5g3Tld{color:#fff;background:#fa541c;border-color:#fa541c}.JDIy0tZGBSpsknPhG4Zow{color:#fa8c16;background:#fff7e6;border-color:#ffd591}._1uAHhO6dtQByTKLTXJ7GkF{color:#fff;background:#fa8c16;border-color:#fa8c16}.K8K24ko9T8jts688WfeM3{color:#fadb14;background:#feffe6;border-color:#fffb8f}._8CmaHU7SueWXM1S7BIW7u{color:#fff;background:#fadb14;border-color:#fadb14}._1IL5lLN_4_DlyeW73E5BSL{color:#faad14;background:#fffbe6;border-color:#ffe58f}.q9HJYlHF0KI7dBMDkV0J6{color:#fff;background:#faad14;border-color:#faad14}.UOkSdHZrIZ4iNHzRFOHmi{color:#13c2c2;background:#e6fffb;border-color:#87e8de}._2vK_TBknDdU9bpTHB0tpIy{color:#fff;background:#13c2c2;border-color:#13c2c2}._1hazu4pqsdkiOHKbA_ak-k{color:#a0d911;background:#fcffe6;border-color:#eaff8f}._2dMDl02c1UrXsLFTYKMzAr{color:#fff;background:#a0d911;border-color:#a0d911}._1eE8zoW5qaFNr0Cj70VR93{color:#52c41a;background:#f6ffed;border-color:#b7eb8f}._3bgdhWWIgZEzcMxbI2c-IH{color:#fff;background:#52c41a;border-color:#52c41a}._2Sv129GLzinjJ8EJ-pviGY{color:#1890ff;background:#e6f7ff;border-color:#91d5ff}._2BLttzUrT79F-O-qLr0DvL{color:#fff;background:#1890ff;border-color:#1890ff}._3b2QHG0GAMA5QAJQfKDbwj{color:#2f54eb;background:#f0f5ff;border-color:#adc6ff}._2ACUKEJBJw_uXO6IQfmZa9{color:#fff;background:#2f54eb;border-color:#2f54eb}.RXClilZOBVMboFyWSMinR{color:#722ed1;background:#f9f0ff;border-color:#d3adf7}.KbORZ9Gr5d3qA8zwvb0C9{color:#fff;background:#722ed1;border-color:#722ed1}.M2l7aGKFJjk0GLDF8efFr{margin-bottom:20px;color:rgba(0,0,0,.85);font-weight:700;font-size:16px;line-height:1.5}._1QcvqhJEAlfyUjuSjknRxT{width:100%;overflow:hidden;border-radius:4px}._1QcvqhJEAlfyUjuSjknRxT table{width:100%;table-layout:fixed}.Sot07S8jsidUeISHaZvtA>td,.Sot07S8jsidUeISHaZvtA>th{padding-bottom:16px}.Sot07S8jsidUeISHaZvtA:last-child{border-bottom:none}._3QXBA6cnWRGDZlEzSFaqPd{color:rgba(0,0,0,.85);font-weight:400;font-size:14px;line-height:1.5}._3QXBA6cnWRGDZlEzSFaqPd:after{position:relative;top:-.5px;margin:0 8px 0 2px;content:\" \"}._2xEteRvl_AbSvq3SLvuwu7:after{content:\":\"}._3eIDGCg9s2TKi36-oz859_:after{margin:0;content:\"\"}._24FRihf2N7SRyR-GaZv8Nl{display:table-cell;color:rgba(0,0,0,.65);font-size:14px;line-height:1.5}._2wwf-kbe8O5mO2PptwzB58{padding-bottom:0}._2wwf-kbe8O5mO2PptwzB58>span{display:inline-block}._3i2G2fswrF1azoUDAXp6Yr .Sot07S8jsidUeISHaZvtA>td,._3i2G2fswrF1azoUDAXp6Yr .Sot07S8jsidUeISHaZvtA>th{padding-bottom:12px}.b6E84UqLW-BH60i2jdowC .Sot07S8jsidUeISHaZvtA>td,.b6E84UqLW-BH60i2jdowC .Sot07S8jsidUeISHaZvtA>th{padding-bottom:8px}._1CeV5PEls8Qd2EPx_T1VRJ ._1QcvqhJEAlfyUjuSjknRxT{border:1px solid #e8e8e8}._1CeV5PEls8Qd2EPx_T1VRJ ._1QcvqhJEAlfyUjuSjknRxT>table{table-layout:auto}._1CeV5PEls8Qd2EPx_T1VRJ ._3QXBA6cnWRGDZlEzSFaqPd,._1CeV5PEls8Qd2EPx_T1VRJ ._24FRihf2N7SRyR-GaZv8Nl{padding:16px 24px;border-right:1px solid #e8e8e8}._1CeV5PEls8Qd2EPx_T1VRJ ._3QXBA6cnWRGDZlEzSFaqPd:last-child,._1CeV5PEls8Qd2EPx_T1VRJ ._24FRihf2N7SRyR-GaZv8Nl:last-child{border-right:none}._1CeV5PEls8Qd2EPx_T1VRJ ._3QXBA6cnWRGDZlEzSFaqPd{background-color:#fafafa}._1CeV5PEls8Qd2EPx_T1VRJ ._3QXBA6cnWRGDZlEzSFaqPd:after{display:none}._1CeV5PEls8Qd2EPx_T1VRJ .Sot07S8jsidUeISHaZvtA{border-bottom:1px solid #e8e8e8}._1CeV5PEls8Qd2EPx_T1VRJ .Sot07S8jsidUeISHaZvtA:last-child{border-bottom:none}._1CeV5PEls8Qd2EPx_T1VRJ._3i2G2fswrF1azoUDAXp6Yr ._3QXBA6cnWRGDZlEzSFaqPd,._1CeV5PEls8Qd2EPx_T1VRJ._3i2G2fswrF1azoUDAXp6Yr ._24FRihf2N7SRyR-GaZv8Nl{padding:12px 24px}._1CeV5PEls8Qd2EPx_T1VRJ.b6E84UqLW-BH60i2jdowC ._3QXBA6cnWRGDZlEzSFaqPd,._1CeV5PEls8Qd2EPx_T1VRJ.b6E84UqLW-BH60i2jdowC ._24FRihf2N7SRyR-GaZv8Nl{padding:8px 16px}._1FEnN_4Xw7j2HKvC56B3mu{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";background:#e8e8e8}._1FEnN_4Xw7j2HKvC56B3mu,._3Ui0E_Kjt95Y11pgFHRL5i{position:relative;top:-.06em;display:inline-block;width:1px;height:.9em;margin:0 8px;vertical-align:middle}._1MLnyi_RKS5waO7WI6Nouc{display:block;clear:both;width:100%;min-width:100%;height:1px;margin:24px 0}._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP,._1MLnyi_RKS5waO7WI6Nouc._2cJYftzCa-S1Ci8ZQWIaxQ,._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb{display:table;margin:16px 0;color:rgba(0,0,0,.85);font-weight:500;font-size:16px;white-space:nowrap;text-align:center;background:transparent}._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP:after,._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP:before,._1MLnyi_RKS5waO7WI6Nouc._2cJYftzCa-S1Ci8ZQWIaxQ:after,._1MLnyi_RKS5waO7WI6Nouc._2cJYftzCa-S1Ci8ZQWIaxQ:before,._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb:after,._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb:before{position:relative;top:50%;display:table-cell;width:50%;border-top:1px solid #e8e8e8;transform:translateY(50%);content:\"\"}._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP .SOVARUqJK1OApf6L6JnTq,._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb .SOVARUqJK1OApf6L6JnTq{display:inline-block;padding:0 10px}._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP:before{top:50%;width:5%}._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP:after,._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb:before{top:50%;width:95%}._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb:after{top:50%;width:5%}.SOVARUqJK1OApf6L6JnTq{display:inline-block;padding:0 24px}._1SpFgdGIEbmyp6SnLq4N_I{background:none;border-color:#e8e8e8;border-style:dashed;border-width:1px 0 0}._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP._1SpFgdGIEbmyp6SnLq4N_I,._1MLnyi_RKS5waO7WI6Nouc._2cJYftzCa-S1Ci8ZQWIaxQ._1SpFgdGIEbmyp6SnLq4N_I,._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb._1SpFgdGIEbmyp6SnLq4N_I{border-top:0}._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP._1SpFgdGIEbmyp6SnLq4N_I:after,._1MLnyi_RKS5waO7WI6Nouc._1BhAviZSlpjCEVDH_WJmpP._1SpFgdGIEbmyp6SnLq4N_I:before,._1MLnyi_RKS5waO7WI6Nouc._2cJYftzCa-S1Ci8ZQWIaxQ._1SpFgdGIEbmyp6SnLq4N_I:after,._1MLnyi_RKS5waO7WI6Nouc._2cJYftzCa-S1Ci8ZQWIaxQ._1SpFgdGIEbmyp6SnLq4N_I:before,._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb._1SpFgdGIEbmyp6SnLq4N_I:after,._1MLnyi_RKS5waO7WI6Nouc.iWdRBdGcJnWzClmtR2fVb._1SpFgdGIEbmyp6SnLq4N_I:before{border-style:dashed none none}._3Ui0E_Kjt95Y11pgFHRL5i._1SpFgdGIEbmyp6SnLq4N_I{border-width:0 0 0 1px}._1brJ42d6ccjRomTdVJGkQA{position:fixed;z-index:1000;width:0;height:100%;transition:transform .3s cubic-bezier(.7,.3,.1,1),height 0s ease .3s,width 0s ease .3s}._1brJ42d6ccjRomTdVJGkQA>*{transition:transform .3s cubic-bezier(.7,.3,.1,1),box-shadow .3s cubic-bezier(.7,.3,.1,1)}._1BHNl8FLIlJ2U0VQYE_hlY{position:absolute}._1brJ42d6ccjRomTdVJGkQA .KO0z9Yrx1ZduhaXAoHy2_{width:100%;height:100%}._3vb0crTFxsOakTpC91cJ1M,.xAf0DgIsIaxC07eZJl3Z{top:0;width:0;height:100%}._3vb0crTFxsOakTpC91cJ1M ._1BHNl8FLIlJ2U0VQYE_hlY,.xAf0DgIsIaxC07eZJl3Z ._1BHNl8FLIlJ2U0VQYE_hlY{height:100%}._3vb0crTFxsOakTpC91cJ1M._1-Yc2-3VAWhTBIxUF6ckRM,.xAf0DgIsIaxC07eZJl3Z._1-Yc2-3VAWhTBIxUF6ckRM{width:100%;transition:transform .3s cubic-bezier(.7,.3,.1,1)}._3vb0crTFxsOakTpC91cJ1M._1-Yc2-3VAWhTBIxUF6ckRM._5tlxe8BDbZvAZ7uqRG4Ob,.xAf0DgIsIaxC07eZJl3Z._1-Yc2-3VAWhTBIxUF6ckRM._5tlxe8BDbZvAZ7uqRG4Ob{width:0}._3vb0crTFxsOakTpC91cJ1M._1-Yc2-3VAWhTBIxUF6ckRM ._1BHNl8FLIlJ2U0VQYE_hlY{box-shadow:2px 0 8px rgba(0,0,0,.15)}.xAf0DgIsIaxC07eZJl3Z,.xAf0DgIsIaxC07eZJl3Z ._1BHNl8FLIlJ2U0VQYE_hlY{right:0}.xAf0DgIsIaxC07eZJl3Z._1-Yc2-3VAWhTBIxUF6ckRM ._1BHNl8FLIlJ2U0VQYE_hlY{box-shadow:-2px 0 8px rgba(0,0,0,.15)}.xAf0DgIsIaxC07eZJl3Z._1-Yc2-3VAWhTBIxUF6ckRM._5tlxe8BDbZvAZ7uqRG4Ob{right:1px;transform:translateX(1px)}._2DO4iwho7EvuicDacu2YQ_,._2jX2Aqvc5_3FGPzIF8kAhe{left:0;width:100%;height:0%}._2DO4iwho7EvuicDacu2YQ_ ._1BHNl8FLIlJ2U0VQYE_hlY,._2jX2Aqvc5_3FGPzIF8kAhe ._1BHNl8FLIlJ2U0VQYE_hlY{width:100%}._2DO4iwho7EvuicDacu2YQ_._1-Yc2-3VAWhTBIxUF6ckRM,._2jX2Aqvc5_3FGPzIF8kAhe._1-Yc2-3VAWhTBIxUF6ckRM{height:100%;transition:transform .3s cubic-bezier(.7,.3,.1,1)}._2DO4iwho7EvuicDacu2YQ_._1-Yc2-3VAWhTBIxUF6ckRM._5tlxe8BDbZvAZ7uqRG4Ob,._2jX2Aqvc5_3FGPzIF8kAhe._1-Yc2-3VAWhTBIxUF6ckRM._5tlxe8BDbZvAZ7uqRG4Ob{height:0%}._2jX2Aqvc5_3FGPzIF8kAhe{top:0}._2jX2Aqvc5_3FGPzIF8kAhe._1-Yc2-3VAWhTBIxUF6ckRM ._1BHNl8FLIlJ2U0VQYE_hlY{box-shadow:0 2px 8px rgba(0,0,0,.15)}._2DO4iwho7EvuicDacu2YQ_,._2DO4iwho7EvuicDacu2YQ_ ._1BHNl8FLIlJ2U0VQYE_hlY{bottom:0}._2DO4iwho7EvuicDacu2YQ_._1-Yc2-3VAWhTBIxUF6ckRM ._1BHNl8FLIlJ2U0VQYE_hlY{box-shadow:0 -2px 8px rgba(0,0,0,.15)}._2DO4iwho7EvuicDacu2YQ_._1-Yc2-3VAWhTBIxUF6ckRM._5tlxe8BDbZvAZ7uqRG4Ob{bottom:1px;transform:translateY(1px)}._1brJ42d6ccjRomTdVJGkQA._1-Yc2-3VAWhTBIxUF6ckRM ._2meVzYjYNYesRwhCyE8_qR{height:100%;opacity:1;transition:none;animation:aOZMUYzFuulrq0XsBkDlO .3s cubic-bezier(.7,.3,.1,1)}._27Gwa7nprIoEQW27Ol74HY{margin:0;color:rgba(0,0,0,.85);font-weight:500;font-size:16px;line-height:22px}.KO0z9Yrx1ZduhaXAoHy2_{position:relative;z-index:1;overflow:auto;background-color:#fff;background-clip:padding-box;border:0}._2p2MN1iEO9cC7MDs0ssVP8{position:absolute;top:0;right:0;z-index:10;display:block;width:56px;height:56px;padding:0;color:rgba(0,0,0,.45);font-weight:700;font-size:16px;font-style:normal;line-height:56px;text-align:center;text-transform:none;text-decoration:none;background:transparent;border:0;outline:0;cursor:pointer;transition:color .3s;text-rendering:auto}._2p2MN1iEO9cC7MDs0ssVP8:focus,._2p2MN1iEO9cC7MDs0ssVP8:hover{color:rgba(0,0,0,.75);text-decoration:none}._1qvM539Wy3QLZjwO32CqQN{position:relative;padding:16px 24px;border-bottom:1px solid #e8e8e8;border-radius:4px 4px 0 0}._1qvM539Wy3QLZjwO32CqQN,._260BYWR30mR-I-1GaVFdD_{color:rgba(0,0,0,.65);background:#fff}._15tNqDhkLq4y0OsKsOG88b{padding:24px;font-size:14px;line-height:1.5;word-wrap:break-word}._1waF7njPHLUdI4ESIPb29e{height:100%;overflow:auto}._2meVzYjYNYesRwhCyE8_qR{position:absolute;top:0;left:0;width:100%;height:0;background-color:rgba(0,0,0,.45);opacity:0;filter:alpha(opacity=45);transition:opacity .3s linear,height 0s ease .3s}._1mkGNTPKRoO023hvlnAuqQ{box-shadow:0 4px 12px rgba(0,0,0,.15)}@keyframes aOZMUYzFuulrq0XsBkDlO{0%{opacity:0}to{opacity:1}}._15Qo9KQmSwT0qKXbW-st1h{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\"}._15Qo9KQmSwT0qKXbW-st1h legend{display:block;width:100%;margin-bottom:20px;padding:0;color:rgba(0,0,0,.45);font-size:16px;line-height:inherit;border:0;border-bottom:1px solid #d9d9d9}._15Qo9KQmSwT0qKXbW-st1h label{font-size:14px}._15Qo9KQmSwT0qKXbW-st1h input[type=search]{box-sizing:border-box}._15Qo9KQmSwT0qKXbW-st1h input[type=checkbox],._15Qo9KQmSwT0qKXbW-st1h input[type=radio]{line-height:normal}._15Qo9KQmSwT0qKXbW-st1h input[type=file]{display:block}._15Qo9KQmSwT0qKXbW-st1h input[type=range]{display:block;width:100%}._15Qo9KQmSwT0qKXbW-st1h select[multiple],._15Qo9KQmSwT0qKXbW-st1h select[size]{height:auto}._15Qo9KQmSwT0qKXbW-st1h input[type=checkbox]:focus,._15Qo9KQmSwT0qKXbW-st1h input[type=file]:focus,._15Qo9KQmSwT0qKXbW-st1h input[type=radio]:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}._15Qo9KQmSwT0qKXbW-st1h output{display:block;padding-top:15px;color:rgba(0,0,0,.65);font-size:14px;line-height:1.5}._1buMok73lgT78pVHV_Iiii:before{display:inline-block;margin-right:4px;color:#f5222d;font-size:14px;font-family:SimSun,sans-serif;line-height:1;content:\"*\"}._3m4uDhSX5VZVv_sVRUX3Lw ._1buMok73lgT78pVHV_Iiii:before{display:none}.ELjJ_GsWjTuoRRMyAfHok>label{color:rgba(0,0,0,.85)}.ELjJ_GsWjTuoRRMyAfHok>label:after{content:\":\";position:relative;top:-.5px;margin:0 8px 0 2px}.ELjJ_GsWjTuoRRMyAfHok>label._1lfid9rMwb-hHKAfI-EmJ3:after{content:\" \"}._7hnn9vwcV8XmiAZUgTcWG{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";margin-bottom:24px;vertical-align:top}._7hnn9vwcV8XmiAZUgTcWG label{position:relative}._7hnn9vwcV8XmiAZUgTcWG label>._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:14px;vertical-align:top}._1xX0DsSkt7GiZAD7EU0Nfg{position:relative;line-height:40px;zoom:1}._1xX0DsSkt7GiZAD7EU0Nfg:after,._1xX0DsSkt7GiZAD7EU0Nfg:before{display:table;content:\"\"}._1xX0DsSkt7GiZAD7EU0Nfg:after{clear:both}._1fWfi_zByEISzoycmRiZMa{position:relative}._1ZPFwTvAqtwTYOncDtRvaZ{margin-bottom:5px}.ELjJ_GsWjTuoRRMyAfHok{display:inline-block;overflow:hidden;line-height:39.9999px;white-space:nowrap;text-align:right;vertical-align:middle}.ySeNiEQvvG0QEydkzgbnt{text-align:left}._7hnn9vwcV8XmiAZUgTcWG ._1pX4_L35Dl4y9IKf_tCLsc{margin:2px 0 4px}._1WZJQ2QnB4plwZjs7q2dlf,._3jy6nXG15JPTeZy62QY3dQ{clear:both;min-height:22px;margin-top:-2px;color:rgba(0,0,0,.45);font-size:14px;line-height:1.5;transition:color .3s cubic-bezier(.215,.61,.355,1)}._3jy6nXG15JPTeZy62QY3dQ{margin-bottom:-1px}._1WZJQ2QnB4plwZjs7q2dlf{padding-top:4px}.MfaP8-NcrfSK7OqaTRkg2{display:inline-block;padding-right:8px}._2LJPwEUvtby_NEuglCfw-3{display:block;text-align:center}form ._3rtccfv5gLbWUnczwUEtA9 ._3pPc-OF79GHv_bF35yGDY1{padding-right:30px}form ._3rtccfv5gLbWUnczwUEtA9 ._2UvyS7V7PyOdhmJGWNnsQ9 ._3JEoNL3m7Ci5dETGutSjIs{padding-right:18px}form ._3rtccfv5gLbWUnczwUEtA9 ._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1{padding-right:49px}form ._3rtccfv5gLbWUnczwUEtA9 ._2UvyS7V7PyOdhmJGWNnsQ9._3fBw9iCv6caRMXShpPso-s ._3pPc-OF79GHv_bF35yGDY1{padding-right:68px}form ._3rtccfv5gLbWUnczwUEtA9 :not(._1p84ImfXKXI0mpXrH3erRG)>._1cNj85ZY8m7JAcdkxJ6Uc5 ._1pcT_amGFsaUucEvS4JQxC,form ._3rtccfv5gLbWUnczwUEtA9 :not(._1p84ImfXKXI0mpXrH3erRG)>._1cNj85ZY8m7JAcdkxJ6Uc5 .eho88gQax86VLUCOnQl3y,form ._3rtccfv5gLbWUnczwUEtA9>._1cNj85ZY8m7JAcdkxJ6Uc5 ._1pcT_amGFsaUucEvS4JQxC,form ._3rtccfv5gLbWUnczwUEtA9>._1cNj85ZY8m7JAcdkxJ6Uc5 .eho88gQax86VLUCOnQl3y{right:28px}form ._3rtccfv5gLbWUnczwUEtA9 :not(._1p84ImfXKXI0mpXrH3erRG)>._1cNj85ZY8m7JAcdkxJ6Uc5 ._1EQQ6QCFrDq86hXZOH3pNb,form ._3rtccfv5gLbWUnczwUEtA9>._1cNj85ZY8m7JAcdkxJ6Uc5 ._1EQQ6QCFrDq86hXZOH3pNb{padding-right:42px}form ._3rtccfv5gLbWUnczwUEtA9 ._213Bp5NguaOQg31JGehBAR{margin-right:17px}form ._3rtccfv5gLbWUnczwUEtA9 ._1rWIPd1klu-G8ILTxOBh3c,form ._3rtccfv5gLbWUnczwUEtA9 ._2nqVLnLfxwaRHBun1ZdFs,form ._3rtccfv5gLbWUnczwUEtA9 ._3MbiO8TsBjLTDfxpyX8YY8:not(.AswcrW7TSGC8OfYJuVWHr) ._3JEoNL3m7Ci5dETGutSjIs,form ._3rtccfv5gLbWUnczwUEtA9 ._3q9TG9Eekd0jcg5Jfeh-MJ,form ._3rtccfv5gLbWUnczwUEtA9 .DmiJkdTGX48H7r143gmkY,form ._3rtccfv5gLbWUnczwUEtA9 .iERe0CWcSdjLkEwAiRq4t{right:28px}form ._2b1hOLgW0QbUm0CvwL-46V,form textarea._3pPc-OF79GHv_bF35yGDY1{height:auto;margin-bottom:4px}form ._1h8t2iciEXSc8I7I3peHuM{background:transparent}form input[type=checkbox],form input[type=radio]{width:14px;height:14px}form ._1sr_u3tk5Yu3V_dmNYfnYs,form .SIz6rwqHlowWagsE6hysJ{display:inline-block;margin-left:8px;font-weight:400;vertical-align:middle;cursor:pointer}form ._1sr_u3tk5Yu3V_dmNYfnYs:first-child,form .SIz6rwqHlowWagsE6hysJ:first-child{margin-left:0}form ._2PMnvd7YfLv4ICSoj05oSN,form ._2r-3diWr4jJwRnTUQwq2CB{display:block}form ._2PMnvd7YfLv4ICSoj05oSN+._2PMnvd7YfLv4ICSoj05oSN,form ._2r-3diWr4jJwRnTUQwq2CB+._2r-3diWr4jJwRnTUQwq2CB{margin-left:0}form .-RzW_3LJkkkKtbTlHEhUw+.MfaP8-NcrfSK7OqaTRkg2{margin-left:8px}form ._21oo90tksizKkQn7EjecHJ{z-index:2}form ._1cNj85ZY8m7JAcdkxJ6Uc5,form ._pEx_feJBV_Kj7nPjRgq4{width:100%}form ._2Foe83O-mWINoezjOoes92 ._1cNj85ZY8m7JAcdkxJ6Uc5,form ._2Foe83O-mWINoezjOoes92 ._pEx_feJBV_Kj7nPjRgq4{width:auto}form ._2WUwSufUm-mWdZbWfdaTx0,form :not(._2WUwSufUm-mWdZbWfdaTx0)>._2Foe83O-mWINoezjOoes92{display:inline-block;vertical-align:middle}form:not(.pWr5If0X_rD3eG_H8JLrd) ._2WUwSufUm-mWdZbWfdaTx0,form:not(.pWr5If0X_rD3eG_H8JLrd) :not(._2WUwSufUm-mWdZbWfdaTx0)>._2Foe83O-mWINoezjOoes92{position:relative;top:-1px}._1J3OoneBjv10xgQHcGtbA_.ELjJ_GsWjTuoRRMyAfHok,._hc2lyZFXBRieqWVGvjlW.ELjJ_GsWjTuoRRMyAfHok,.pWr5If0X_rD3eG_H8JLrd .ELjJ_GsWjTuoRRMyAfHok{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:normal;text-align:left}._1J3OoneBjv10xgQHcGtbA_.ELjJ_GsWjTuoRRMyAfHok label:after,._hc2lyZFXBRieqWVGvjlW.ELjJ_GsWjTuoRRMyAfHok label:after,.pWr5If0X_rD3eG_H8JLrd .ELjJ_GsWjTuoRRMyAfHok label:after{display:none}.pWr5If0X_rD3eG_H8JLrd ._7hnn9vwcV8XmiAZUgTcWG{padding-bottom:8px}.pWr5If0X_rD3eG_H8JLrd ._1xX0DsSkt7GiZAD7EU0Nfg{line-height:1.5}.pWr5If0X_rD3eG_H8JLrd ._3jy6nXG15JPTeZy62QY3dQ{margin-top:2px;margin-bottom:-5px}.pWr5If0X_rD3eG_H8JLrd ._1WZJQ2QnB4plwZjs7q2dlf{margin-top:2px;margin-bottom:-4px}@media (max-width:575px){._4Shtwfc77XFo-yEqUOS7f,.ELjJ_GsWjTuoRRMyAfHok{display:block;width:100%}.ELjJ_GsWjTuoRRMyAfHok{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:normal;text-align:left}.ELjJ_GsWjTuoRRMyAfHok label:after{display:none}.m5GSJDA-XU2vizRVe6oI0.ELjJ_GsWjTuoRRMyAfHok{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:normal;text-align:left}.m5GSJDA-XU2vizRVe6oI0.ELjJ_GsWjTuoRRMyAfHok label:after{display:none}}@media (max-width:767px){._1lNw0jLvmTwKcRstr-ThaX.ELjJ_GsWjTuoRRMyAfHok{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:normal;text-align:left}._1lNw0jLvmTwKcRstr-ThaX.ELjJ_GsWjTuoRRMyAfHok label:after{display:none}}@media (max-width:991px){._2ndfC3Op6-f3H5-JJ48mxS.ELjJ_GsWjTuoRRMyAfHok{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:normal;text-align:left}._2ndfC3Op6-f3H5-JJ48mxS.ELjJ_GsWjTuoRRMyAfHok label:after{display:none}}@media (max-width:1199px){._4pSZ1tb9bcmVOqTm1RnS0.ELjJ_GsWjTuoRRMyAfHok{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:normal;text-align:left}._4pSZ1tb9bcmVOqTm1RnS0.ELjJ_GsWjTuoRRMyAfHok label:after{display:none}}@media (max-width:1599px){._1J3OoneBjv10xgQHcGtbA_.ELjJ_GsWjTuoRRMyAfHok{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:normal;text-align:left}._1J3OoneBjv10xgQHcGtbA_.ELjJ_GsWjTuoRRMyAfHok label:after{display:none}}._3ow3vMuEBuB3YhoJ5t93hJ ._7hnn9vwcV8XmiAZUgTcWG{display:inline-block;margin-right:16px;margin-bottom:0}._3ow3vMuEBuB3YhoJ5t93hJ ._1ZPFwTvAqtwTYOncDtRvaZ{margin-bottom:24px}._3ow3vMuEBuB3YhoJ5t93hJ ._7hnn9vwcV8XmiAZUgTcWG>._4Shtwfc77XFo-yEqUOS7f,._3ow3vMuEBuB3YhoJ5t93hJ ._7hnn9vwcV8XmiAZUgTcWG>.ELjJ_GsWjTuoRRMyAfHok{display:inline-block;vertical-align:top}._3ow3vMuEBuB3YhoJ5t93hJ ._3rtccfv5gLbWUnczwUEtA9,._3ow3vMuEBuB3YhoJ5t93hJ .MfaP8-NcrfSK7OqaTRkg2{display:inline-block}._1PxRl654EayHhb4ltXaqyU._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL,._1uVRdcmSVUVSmxHP3p6xn2._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL,._2GRmUr8QIpVdG7NsGBYSTb._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL,._2vNbejHw1xnP-cOT2-_bGv._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL{position:absolute;top:50%;right:0;z-index:1;width:32px;height:20px;margin-top:-10px;font-size:14px;line-height:20px;text-align:center;visibility:visible;animation:_2l1p_XAL8knvE-TA3qBhyM .3s cubic-bezier(.12,.4,.29,1.46);pointer-events:none}._1PxRl654EayHhb4ltXaqyU._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL svg,._1uVRdcmSVUVSmxHP3p6xn2._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL svg,._2GRmUr8QIpVdG7NsGBYSTb._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL svg,._2vNbejHw1xnP-cOT2-_bGv._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL svg{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}._1PxRl654EayHhb4ltXaqyU._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL{color:#52c41a;animation-name:_1F2DvTG4-WjowJh9HUfVG-!important}._2vNbejHw1xnP-cOT2-_bGv ._2LJPwEUvtby_NEuglCfw-3,._2vNbejHw1xnP-cOT2-_bGv ._3jy6nXG15JPTeZy62QY3dQ{color:#faad14}._2vNbejHw1xnP-cOT2-_bGv ._3pPc-OF79GHv_bF35yGDY1,._2vNbejHw1xnP-cOT2-_bGv ._3pPc-OF79GHv_bF35yGDY1:hover{background-color:#fff;border-color:#faad14}._2vNbejHw1xnP-cOT2-_bGv ._3pPc-OF79GHv_bF35yGDY1:focus{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(250,173,20,.2)}._2vNbejHw1xnP-cOT2-_bGv ._3pPc-OF79GHv_bF35yGDY1:not([disabled]):hover{border-color:#faad14}._2vNbejHw1xnP-cOT2-_bGv .IBnQ3AnRCKBynOW9qwqSo ._2JZfuIaTZD_lWK5HfZHFb0{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(250,173,20,.2)}._2vNbejHw1xnP-cOT2-_bGv ._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1,._2vNbejHw1xnP-cOT2-_bGv ._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1:hover{background-color:#fff;border-color:#faad14}._2vNbejHw1xnP-cOT2-_bGv ._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1:focus{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(250,173,20,.2)}._2vNbejHw1xnP-cOT2-_bGv ._2UvyS7V7PyOdhmJGWNnsQ9:hover ._3pPc-OF79GHv_bF35yGDY1:not(._2A-ucu16pid4Gh76mY_Ebo){border-color:#faad14}._2vNbejHw1xnP-cOT2-_bGv ._2eJRbHPkX4xdgtxeMSNzx{color:#faad14}._2vNbejHw1xnP-cOT2-_bGv ._1p84ImfXKXI0mpXrH3erRG{color:#faad14;background-color:#fff;border-color:#faad14}._2vNbejHw1xnP-cOT2-_bGv ._3rtccfv5gLbWUnczwUEtA9{color:#faad14}._2vNbejHw1xnP-cOT2-_bGv._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL{color:#faad14;animation-name:_3-B0nx5dCFb49bpzi27Swn!important}._2vNbejHw1xnP-cOT2-_bGv ._7Eyy1YVEF5PxhoJBXqU_f,._2vNbejHw1xnP-cOT2-_bGv ._7Eyy1YVEF5PxhoJBXqU_f:hover{border-color:#faad14}._2vNbejHw1xnP-cOT2-_bGv ._1Wi0B5_u6mPgRTcwZk7Fyw ._7Eyy1YVEF5PxhoJBXqU_f,._2vNbejHw1xnP-cOT2-_bGv ._3h6aN10we1czWU8G2MA6y_ ._7Eyy1YVEF5PxhoJBXqU_f{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(250,173,20,.2)}._2vNbejHw1xnP-cOT2-_bGv ._2nqVLnLfxwaRHBun1ZdFs:after,._2vNbejHw1xnP-cOT2-_bGv ._2pzAxEajE34Kg1rIeoVX8B:after,._2vNbejHw1xnP-cOT2-_bGv ._213Bp5NguaOQg31JGehBAR,._2vNbejHw1xnP-cOT2-_bGv .eho88gQax86VLUCOnQl3y,._2vNbejHw1xnP-cOT2-_bGv .iERe0CWcSdjLkEwAiRq4t:after{color:#faad14}._2vNbejHw1xnP-cOT2-_bGv .-RzW_3LJkkkKtbTlHEhUw,._2vNbejHw1xnP-cOT2-_bGv .rbO6RzhtTm7Ha5feDxDOm{border-color:#faad14}._2vNbejHw1xnP-cOT2-_bGv .-RzW_3LJkkkKtbTlHEhUw:focus,._2vNbejHw1xnP-cOT2-_bGv ._2xff8EFXmm9qnF2wrTjPOy,._2vNbejHw1xnP-cOT2-_bGv ._3HZHDxDo4uhCBz6ZTQM7Ab,._2vNbejHw1xnP-cOT2-_bGv .rbO6RzhtTm7Ha5feDxDOm:focus{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(250,173,20,.2)}._2vNbejHw1xnP-cOT2-_bGv .-RzW_3LJkkkKtbTlHEhUw:not([disabled]):hover,._2vNbejHw1xnP-cOT2-_bGv .rbO6RzhtTm7Ha5feDxDOm:not([disabled]):hover{border-color:#faad14}._2vNbejHw1xnP-cOT2-_bGv ._pEx_feJBV_Kj7nPjRgq4:focus ._3bU7CHT5Lss1v8CDoIJh-s{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(250,173,20,.2)}._2vNbejHw1xnP-cOT2-_bGv ._pEx_feJBV_Kj7nPjRgq4:hover ._3bU7CHT5Lss1v8CDoIJh-s{border-color:#faad14}._1uVRdcmSVUVSmxHP3p6xn2 ._2LJPwEUvtby_NEuglCfw-3,._1uVRdcmSVUVSmxHP3p6xn2 ._3jy6nXG15JPTeZy62QY3dQ{color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._3pPc-OF79GHv_bF35yGDY1,._1uVRdcmSVUVSmxHP3p6xn2 ._3pPc-OF79GHv_bF35yGDY1:hover{background-color:#fff;border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._3pPc-OF79GHv_bF35yGDY1:focus{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(245,34,45,.2)}._1uVRdcmSVUVSmxHP3p6xn2 ._3pPc-OF79GHv_bF35yGDY1:not([disabled]):hover{border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 .IBnQ3AnRCKBynOW9qwqSo ._2JZfuIaTZD_lWK5HfZHFb0{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(245,34,45,.2)}._1uVRdcmSVUVSmxHP3p6xn2 ._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1,._1uVRdcmSVUVSmxHP3p6xn2 ._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1:hover{background-color:#fff;border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._2UvyS7V7PyOdhmJGWNnsQ9 ._3pPc-OF79GHv_bF35yGDY1:focus{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(245,34,45,.2)}._1uVRdcmSVUVSmxHP3p6xn2 ._2UvyS7V7PyOdhmJGWNnsQ9:hover ._3pPc-OF79GHv_bF35yGDY1:not(._2A-ucu16pid4Gh76mY_Ebo){border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._2eJRbHPkX4xdgtxeMSNzx{color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._1p84ImfXKXI0mpXrH3erRG{color:#f5222d;background-color:#fff;border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._3rtccfv5gLbWUnczwUEtA9{color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL{color:#f5222d;animation-name:_2Ary_buAgy7WuJU8fEjvBm!important}._1uVRdcmSVUVSmxHP3p6xn2 ._7Eyy1YVEF5PxhoJBXqU_f,._1uVRdcmSVUVSmxHP3p6xn2 ._7Eyy1YVEF5PxhoJBXqU_f:hover{border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._1Wi0B5_u6mPgRTcwZk7Fyw ._7Eyy1YVEF5PxhoJBXqU_f,._1uVRdcmSVUVSmxHP3p6xn2 ._3h6aN10we1czWU8G2MA6y_ ._7Eyy1YVEF5PxhoJBXqU_f{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(245,34,45,.2)}._1uVRdcmSVUVSmxHP3p6xn2 ._1cNj85ZY8m7JAcdkxJ6Uc5._29cP-s7uNehcuQVbYj4ozX ._3pPc-OF79GHv_bF35yGDY1:focus{border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._1p84ImfXKXI0mpXrH3erRG ._7Eyy1YVEF5PxhoJBXqU_f{border-color:transparent;box-shadow:none}._1uVRdcmSVUVSmxHP3p6xn2 ._2nqVLnLfxwaRHBun1ZdFs:after,._1uVRdcmSVUVSmxHP3p6xn2 ._2pzAxEajE34Kg1rIeoVX8B:after,._1uVRdcmSVUVSmxHP3p6xn2 ._213Bp5NguaOQg31JGehBAR,._1uVRdcmSVUVSmxHP3p6xn2 .eho88gQax86VLUCOnQl3y,._1uVRdcmSVUVSmxHP3p6xn2 .iERe0CWcSdjLkEwAiRq4t:after{color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 .-RzW_3LJkkkKtbTlHEhUw,._1uVRdcmSVUVSmxHP3p6xn2 .rbO6RzhtTm7Ha5feDxDOm{border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 .-RzW_3LJkkkKtbTlHEhUw:focus,._1uVRdcmSVUVSmxHP3p6xn2 ._2xff8EFXmm9qnF2wrTjPOy,._1uVRdcmSVUVSmxHP3p6xn2 ._3HZHDxDo4uhCBz6ZTQM7Ab,._1uVRdcmSVUVSmxHP3p6xn2 .rbO6RzhtTm7Ha5feDxDOm:focus{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(245,34,45,.2)}._1uVRdcmSVUVSmxHP3p6xn2 .-RzW_3LJkkkKtbTlHEhUw:not([disabled]):hover,._1uVRdcmSVUVSmxHP3p6xn2 .evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99,._1uVRdcmSVUVSmxHP3p6xn2 .evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:not([disabled]):hover,._1uVRdcmSVUVSmxHP3p6xn2 .rbO6RzhtTm7Ha5feDxDOm:not([disabled]):hover{border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._pEx_feJBV_Kj7nPjRgq4:focus ._3bU7CHT5Lss1v8CDoIJh-s,._1uVRdcmSVUVSmxHP3p6xn2 .evz3k4BAlGZ29PrmHf8ZA.bf5U_b82Zn-jzGoDLzpRV:not([disabled]) .FgcTqoSfeRhgxyye0BL99,._1uVRdcmSVUVSmxHP3p6xn2 .evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:not([disabled]):focus{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(245,34,45,.2)}._1uVRdcmSVUVSmxHP3p6xn2 ._2fWTapgGa9S4V8oTJQqPuC,._1uVRdcmSVUVSmxHP3p6xn2 ._pEx_feJBV_Kj7nPjRgq4:hover ._3bU7CHT5Lss1v8CDoIJh-s{border-color:#f5222d}._1uVRdcmSVUVSmxHP3p6xn2 ._2ahGzO6VPnpqbaNMwJwobm:not([disabled]){border-color:#d9d9d9}._1uVRdcmSVUVSmxHP3p6xn2 ._2ahGzO6VPnpqbaNMwJwobm:not([disabled]):hover{border-color:#40a9ff;border-right-width:1px!important}._1uVRdcmSVUVSmxHP3p6xn2 ._2ahGzO6VPnpqbaNMwJwobm:not([disabled]):focus{border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._2GRmUr8QIpVdG7NsGBYSTb._3rtccfv5gLbWUnczwUEtA9 ._4zk-kIJFv-XJmEfA_zhZL{display:inline-block;color:#1890ff}._18qk49lH79KVdqlXeLL7gy ._7hnn9vwcV8XmiAZUgTcWG{margin-bottom:24px}._18qk49lH79KVdqlXeLL7gy ._1ZPFwTvAqtwTYOncDtRvaZ{margin-bottom:5px}._1OFiTBCBckSN-5pgoAMdOE,._3KhjdDViy3psoEM-nkt93U,._3ztUd2T-fLpvttAQgEqsqs{animation-duration:.3s;animation-fill-mode:both;animation-play-state:paused}._1OFiTBCBckSN-5pgoAMdOE._2LMaYd31SP9DUC9m9HMSEq,._3ztUd2T-fLpvttAQgEqsqs._3bMkFTKjNTE0dkN8YfJAR0{animation-name:_2rqz12K75fw78vsM_Xk36a;animation-play-state:running}._3KhjdDViy3psoEM-nkt93U._2JLIkDTX2CPcBhE6RwKn2P{animation-name:_1Z_t4tw2mUmhZenz5t-bx-;animation-play-state:running;pointer-events:none}._1OFiTBCBckSN-5pgoAMdOE,._3ztUd2T-fLpvttAQgEqsqs{opacity:0}._1OFiTBCBckSN-5pgoAMdOE,._3KhjdDViy3psoEM-nkt93U,._3ztUd2T-fLpvttAQgEqsqs{animation-timing-function:cubic-bezier(.645,.045,.355,1)}@keyframes _2rqz12K75fw78vsM_Xk36a{0%{transform:translateY(-5px);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes _1Z_t4tw2mUmhZenz5t-bx-{to{transform:translateY(-5px);opacity:0}}@keyframes _1F2DvTG4-WjowJh9HUfVG-{0%{transform:scale(0)}to{transform:scale(1)}}@keyframes _2Ary_buAgy7WuJU8fEjvBm{0%{transform:scale(0)}to{transform:scale(1)}}@keyframes _3-B0nx5dCFb49bpzi27Swn{0%{transform:scale(0)}to{transform:scale(1)}}.-RzW_3LJkkkKtbTlHEhUw{box-sizing:border-box;font-variant:tabular-nums;list-style:none;font-feature-settings:\"tnum\";position:relative;width:100%;height:32px;padding:4px 11px;color:rgba(0,0,0,.65);font-size:14px;line-height:1.5;background-color:#fff;background-image:none;transition:all .3s;display:inline-block;width:90px;margin:0;padding:0;border:1px solid #d9d9d9;border-radius:4px}.-RzW_3LJkkkKtbTlHEhUw::-moz-placeholder{color:#bfbfbf;opacity:1}.-RzW_3LJkkkKtbTlHEhUw:-ms-input-placeholder{color:#bfbfbf}.-RzW_3LJkkkKtbTlHEhUw::-webkit-input-placeholder{color:#bfbfbf}.-RzW_3LJkkkKtbTlHEhUw:-moz-placeholder-shown{text-overflow:ellipsis}.-RzW_3LJkkkKtbTlHEhUw:-ms-input-placeholder{text-overflow:ellipsis}.-RzW_3LJkkkKtbTlHEhUw:placeholder-shown{text-overflow:ellipsis}.-RzW_3LJkkkKtbTlHEhUw:focus{border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}.-RzW_3LJkkkKtbTlHEhUw[disabled]{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}.-RzW_3LJkkkKtbTlHEhUw[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea.-RzW_3LJkkkKtbTlHEhUw{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}.w_qHgwuFTc3v4t_PAO5jH{height:40px;padding:6px 11px}.Ep-vfOMeIkNaHxjiWlrVl{height:24px;padding:1px 7px}._3t4-Cw_o5EuyS0AgK2vEuB{position:relative;display:block;width:100%;height:50%;overflow:hidden;color:rgba(0,0,0,.45);font-weight:700;line-height:0;text-align:center;transition:all .1s linear}._3t4-Cw_o5EuyS0AgK2vEuB:active{background:#f4f4f4}._3t4-Cw_o5EuyS0AgK2vEuB:hover ._1h-JmRCo_HqSwqiOh8BmWg,._3t4-Cw_o5EuyS0AgK2vEuB:hover .glQTOz8VsDHy4Jh_yBXkG{color:#40a9ff}._1h-JmRCo_HqSwqiOh8BmWg,.glQTOz8VsDHy4Jh_yBXkG{display:inline-block;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;right:4px;width:12px;height:12px;color:rgba(0,0,0,.45);line-height:12px;transition:all .1s linear;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1h-JmRCo_HqSwqiOh8BmWg>*,.glQTOz8VsDHy4Jh_yBXkG>*{line-height:1}._1h-JmRCo_HqSwqiOh8BmWg svg,.glQTOz8VsDHy4Jh_yBXkG svg{display:inline-block}._1h-JmRCo_HqSwqiOh8BmWg:before,.glQTOz8VsDHy4Jh_yBXkG:before{display:none}._1h-JmRCo_HqSwqiOh8BmWg ._1kf-gvoGBS6Z4dVQ6GkpXF,._1h-JmRCo_HqSwqiOh8BmWg ._3FdEhTrDh6FJR6_j_bFj9V,.glQTOz8VsDHy4Jh_yBXkG ._1kf-gvoGBS6Z4dVQ6GkpXF,.glQTOz8VsDHy4Jh_yBXkG ._3FdEhTrDh6FJR6_j_bFj9V{display:block}.-RzW_3LJkkkKtbTlHEhUw:hover,._2xff8EFXmm9qnF2wrTjPOy{border-color:#40a9ff;border-right-width:1px!important}._2xff8EFXmm9qnF2wrTjPOy{outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._2gqrr5CJflUo5nBlDHQEhl{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._2gqrr5CJflUo5nBlDHQEhl:hover{border-color:#d9d9d9;border-right-width:1px!important}._2gqrr5CJflUo5nBlDHQEhl ._3lAv5HBQDptJqKZz1q_N7m{cursor:not-allowed}._2gqrr5CJflUo5nBlDHQEhl ._21oo90tksizKkQn7EjecHJ{display:none}._3lAv5HBQDptJqKZz1q_N7m{width:100%;height:30px;padding:0 11px;text-align:left;background-color:transparent;border:0;border-radius:4px;outline:0;transition:all .3s linear;-moz-appearance:textfield!important}._3lAv5HBQDptJqKZz1q_N7m::-moz-placeholder{color:#bfbfbf;opacity:1}._3lAv5HBQDptJqKZz1q_N7m:-ms-input-placeholder{color:#bfbfbf}._3lAv5HBQDptJqKZz1q_N7m::-webkit-input-placeholder{color:#bfbfbf}._3lAv5HBQDptJqKZz1q_N7m:-moz-placeholder-shown{text-overflow:ellipsis}._3lAv5HBQDptJqKZz1q_N7m:-ms-input-placeholder{text-overflow:ellipsis}._3lAv5HBQDptJqKZz1q_N7m:placeholder-shown{text-overflow:ellipsis}._3lAv5HBQDptJqKZz1q_N7m[type=number]::-webkit-inner-spin-button,._3lAv5HBQDptJqKZz1q_N7m[type=number]::-webkit-outer-spin-button{margin:0;-webkit-appearance:none}.w_qHgwuFTc3v4t_PAO5jH{padding:0;font-size:16px}.w_qHgwuFTc3v4t_PAO5jH input{height:38px}.Ep-vfOMeIkNaHxjiWlrVl{padding:0}.Ep-vfOMeIkNaHxjiWlrVl input{height:22px;padding:0 7px}._21oo90tksizKkQn7EjecHJ{position:absolute;top:0;right:0;width:22px;height:100%;background:#fff;border-left:1px solid #d9d9d9;border-radius:0 4px 4px 0;opacity:0;transition:opacity .24s linear .1s}._21oo90tksizKkQn7EjecHJ ._3t4-Cw_o5EuyS0AgK2vEuB ._1h-JmRCo_HqSwqiOh8BmWg,._21oo90tksizKkQn7EjecHJ ._3t4-Cw_o5EuyS0AgK2vEuB .glQTOz8VsDHy4Jh_yBXkG{display:inline-block;font-size:12px;font-size:7px\\9;transform:scale(.58333333) rotate(0deg);min-width:auto;margin-right:0}:root ._21oo90tksizKkQn7EjecHJ ._3t4-Cw_o5EuyS0AgK2vEuB ._1h-JmRCo_HqSwqiOh8BmWg,:root ._21oo90tksizKkQn7EjecHJ ._3t4-Cw_o5EuyS0AgK2vEuB .glQTOz8VsDHy4Jh_yBXkG{font-size:12px}._21oo90tksizKkQn7EjecHJ:hover ._3t4-Cw_o5EuyS0AgK2vEuB{height:40%}.-RzW_3LJkkkKtbTlHEhUw:hover ._21oo90tksizKkQn7EjecHJ{opacity:1}._3YZhRPSuovDhOmgakq9C7o{border-top-right-radius:4px;cursor:pointer}.glQTOz8VsDHy4Jh_yBXkG{top:50%;margin-top:-5px;text-align:center}._3YZhRPSuovDhOmgakq9C7o:hover{height:60%!important}._3pMcvEEEeZ0Z-dZk0g_jcM{top:0;border-top:1px solid #d9d9d9;border-bottom-right-radius:4px;cursor:pointer}._1h-JmRCo_HqSwqiOh8BmWg{top:50%;margin-top:-6px;text-align:center}._3pMcvEEEeZ0Z-dZk0g_jcM:hover{height:60%!important}.CY9JRqz6VZqsOy5ttlZDE,.WFG3NS2BIDsohaUDIAFCX{cursor:not-allowed}.CY9JRqz6VZqsOy5ttlZDE:hover .glQTOz8VsDHy4Jh_yBXkG,.WFG3NS2BIDsohaUDIAFCX:hover ._1h-JmRCo_HqSwqiOh8BmWg{color:rgba(0,0,0,.25)}._3mikNXjaLhj5gSNJRA-I9U{display:-ms-flexbox;display:flex;-ms-flex:auto;flex:auto;-ms-flex-direction:column;flex-direction:column;min-height:0;background:#f0f2f5}._3mikNXjaLhj5gSNJRA-I9U,._3mikNXjaLhj5gSNJRA-I9U *{box-sizing:border-box}._3mikNXjaLhj5gSNJRA-I9U._10spVR-eMhLkEGrEWb8m_i{-ms-flex-direction:row;flex-direction:row}._3mikNXjaLhj5gSNJRA-I9U._10spVR-eMhLkEGrEWb8m_i>._3mikNXjaLhj5gSNJRA-I9U,._3mikNXjaLhj5gSNJRA-I9U._10spVR-eMhLkEGrEWb8m_i>.N9kmGkgwjDnn6VSfqMAjh{overflow-x:hidden}._1C3d81CDronxOML6Hc-_wC,._3ZFjEVciV7jA-Lz_ubggJC{-ms-flex:0 0 auto;flex:0 0 auto}._3ZFjEVciV7jA-Lz_ubggJC{height:64px;padding:0 50px;line-height:64px;background:#001529}._1C3d81CDronxOML6Hc-_wC{padding:24px 50px;color:rgba(0,0,0,.65);font-size:14px;background:#f0f2f5}.N9kmGkgwjDnn6VSfqMAjh{-ms-flex:auto;flex:auto;min-height:0}.OuC2CyVFAnUYkPsybXaw7{position:relative;min-width:0;background:#001529;transition:all .2s}.cb6yTmkTjY2NZFJQlwDBl{height:100%;margin-top:-.1px;padding-top:.1px}._2ll_cLbn0ljKue3wIhHPaC{padding-bottom:48px}._2XAQ0jFggvgrNd9wsrScz_{-ms-flex-order:1;order:1}._1XFzvO4DfM-DhzK7HLRWzv{position:fixed;bottom:0;z-index:1;height:48px;color:#fff;line-height:48px;text-align:center;background:#002140;cursor:pointer;transition:all .2s}._2gzVbX_oljYJEzQxJIk7GU>*{overflow:hidden}.P6xix3OjfwUdjiQil3v0K{position:absolute;top:64px;right:-36px;z-index:1;width:36px;height:42px;color:#fff;font-size:18px;line-height:42px;text-align:center;background:#001529;border-radius:0 4px 4px 0;cursor:pointer;transition:background .3s ease}.P6xix3OjfwUdjiQil3v0K:hover{background:#192c3e}.KKcSd00e4pLRPgAiwC5y-{left:-36px;border-radius:4px 0 0 4px}.QhBpai2gF-pVnFf-w9Obr{background:#fff}.QhBpai2gF-pVnFf-w9Obr ._1XFzvO4DfM-DhzK7HLRWzv,.QhBpai2gF-pVnFf-w9Obr .P6xix3OjfwUdjiQil3v0K{color:rgba(0,0,0,.65);background:#fff}._3HIgBcVpilUfQfQ9sAbNu2{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative}._3HIgBcVpilUfQfQ9sAbNu2 *{outline:none}.baji5TDXAeafQiFad3dvj{margin-top:24px;text-align:right}.baji5TDXAeafQiFad3dvj ._3E4NM-Xt86D76rf21xBrat{text-align:left}._2UR_lGHGFturZDmU__KNn_{margin-top:12px;text-align:center}._2UR_lGHGFturZDmU__KNn_ button{padding-right:32px;padding-left:32px}._3rYZoJZPBSTcvRdS4EhRs4{min-height:40px;text-align:center}._2T2KclM46l4EFjPw6uVKmr{padding:16px;color:rgba(0,0,0,.25);font-size:14px;text-align:center}._18chtvr8BoDiREOxb4666y{margin:0;padding:0;list-style:none}._3v6hS-oiYk2sOv4queo_A0{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:12px 0}._3EBvUiz2GDQ4JRqjuI2obg{color:rgba(0,0,0,.65)}._3lgtuc7jBY5OJt850ZtODx{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-align:start;align-items:flex-start;font-size:0}.Gu3sh4t2a4DVqBaFvfNA6{margin-right:16px}._1jHnJa3miHGEr1P-hmJVPK{-ms-flex:1 0;flex:1 0}._1xxzM1nlRzDHC6xvHMZ3YG{margin-bottom:4px;color:rgba(0,0,0,.65);font-size:14px;line-height:22px}._1xxzM1nlRzDHC6xvHMZ3YG>a{color:rgba(0,0,0,.65);transition:all .3s}._1xxzM1nlRzDHC6xvHMZ3YG>a:hover{color:#1890ff}._2KFFLpQwQdB8l0EwWweCWB{color:rgba(0,0,0,.45);font-size:14px;line-height:22px}._1hEm-CrAMHPul7abFCynGM{-ms-flex:0 0 auto;flex:0 0 auto;margin-left:48px;padding:0;font-size:0;list-style:none}._1hEm-CrAMHPul7abFCynGM>li{position:relative;display:inline-block;padding:0 8px;color:rgba(0,0,0,.45);font-size:14px;line-height:22px;text-align:center;cursor:pointer}._1hEm-CrAMHPul7abFCynGM>li:first-child{padding-left:0}._3JNoui1M2YmmwYtzpCdbt4{position:absolute;top:50%;right:0;width:1px;height:14px;margin-top:-7px;background-color:#e8e8e8}._39LTZfb4ErzHKHhG3VXAOA,.K7eVrQOGUsXQU8SUPZV6R{background:transparent}._39LTZfb4ErzHKHhG3VXAOA,.K7eVrQOGUsXQU8SUPZV6R{padding-top:12px;padding-bottom:12px}._3PRxMIN4ZUQj8dKrMwPiyZ{padding:16px 0;color:rgba(0,0,0,.45);font-size:12px;text-align:center}._2aqFSbTpv_mkNyS2623ag_ ._3v6hS-oiYk2sOv4queo_A0{border-bottom:1px solid #e8e8e8}._2aqFSbTpv_mkNyS2623ag_ ._3v6hS-oiYk2sOv4queo_A0:last-child{border-bottom:none}._2aqFSbTpv_mkNyS2623ag_ .K7eVrQOGUsXQU8SUPZV6R{border-bottom:1px solid #e8e8e8}._2UigaUqWLvuBQxTMVMgwjR .QqFPeU74URIiKbruoJWb6{min-height:32px}.vVpcPP0Jp3Rm1x5osINKE ._1jrq9dfOxKwT2J3sfo9HId>._18chtvr8BoDiREOxb4666y>._3v6hS-oiYk2sOv4queo_A0:last-child{border-bottom:1px solid #e8e8e8}.NL47r4ohAXVYgUOFrbTl7 ._3v6hS-oiYk2sOv4queo_A0{padding-top:16px;padding-bottom:16px}._2MIZdrc5QmLPuIQDOhYaSG ._3v6hS-oiYk2sOv4queo_A0{padding-top:8px;padding-bottom:8px}._2okJ9umcOw_j7RNkFM0NfQ ._3v6hS-oiYk2sOv4queo_A0{-ms-flex-align:initial;align-items:initial}._2okJ9umcOw_j7RNkFM0NfQ ._3ViShGJ04PrIhBnOVgqdsZ{display:block;-ms-flex:1;flex:1}._2okJ9umcOw_j7RNkFM0NfQ .UhcE8DlZZx03ATb3k7aG{margin-left:40px}._2okJ9umcOw_j7RNkFM0NfQ ._3lgtuc7jBY5OJt850ZtODx{margin-bottom:16px}._2okJ9umcOw_j7RNkFM0NfQ ._1xxzM1nlRzDHC6xvHMZ3YG{margin-bottom:12px;color:rgba(0,0,0,.85);font-size:16px;line-height:24px}._2okJ9umcOw_j7RNkFM0NfQ ._1hEm-CrAMHPul7abFCynGM{margin-top:16px;margin-left:auto}._2okJ9umcOw_j7RNkFM0NfQ ._1hEm-CrAMHPul7abFCynGM>li{padding:0 16px}._2okJ9umcOw_j7RNkFM0NfQ ._1hEm-CrAMHPul7abFCynGM>li:first-child{padding-left:0}._3H74wyAo6REdBWAcWxuzDS ._3LZni_ayS-DnjajnxVwEnK>._3v6hS-oiYk2sOv4queo_A0{display:block;max-width:100%;margin-bottom:16px;padding-top:0;padding-bottom:0;border-bottom:none}._3Q1mp1pJWlCe_IWMoz9WnX{display:block}._3HIgBcVpilUfQfQ9sAbNu2:not(._2okJ9umcOw_j7RNkFM0NfQ) ._3Q1mp1pJWlCe_IWMoz9WnX ._1hEm-CrAMHPul7abFCynGM{float:right}._d594fZSmN1Tl5iawj2Ab{border:1px solid #d9d9d9;border-radius:4px}._d594fZSmN1Tl5iawj2Ab ._39LTZfb4ErzHKHhG3VXAOA,._d594fZSmN1Tl5iawj2Ab .K7eVrQOGUsXQU8SUPZV6R{padding-right:24px;padding-left:24px}._d594fZSmN1Tl5iawj2Ab ._3v6hS-oiYk2sOv4queo_A0{padding-right:24px;padding-left:24px;border-bottom:1px solid #e8e8e8}._d594fZSmN1Tl5iawj2Ab .baji5TDXAeafQiFad3dvj{margin:16px 24px}._d594fZSmN1Tl5iawj2Ab._2MIZdrc5QmLPuIQDOhYaSG ._3v6hS-oiYk2sOv4queo_A0{padding-right:16px;padding-left:16px}._d594fZSmN1Tl5iawj2Ab._2MIZdrc5QmLPuIQDOhYaSG ._39LTZfb4ErzHKHhG3VXAOA,._d594fZSmN1Tl5iawj2Ab._2MIZdrc5QmLPuIQDOhYaSG .K7eVrQOGUsXQU8SUPZV6R{padding:8px 16px}._d594fZSmN1Tl5iawj2Ab.NL47r4ohAXVYgUOFrbTl7 ._39LTZfb4ErzHKHhG3VXAOA,._d594fZSmN1Tl5iawj2Ab.NL47r4ohAXVYgUOFrbTl7 .K7eVrQOGUsXQU8SUPZV6R{padding:16px 24px}@media screen and (max-width:768px){._1hEm-CrAMHPul7abFCynGM,._2okJ9umcOw_j7RNkFM0NfQ .UhcE8DlZZx03ATb3k7aG{margin-left:24px}}@media screen and (max-width:576px){._3v6hS-oiYk2sOv4queo_A0{-ms-flex-wrap:wrap;flex-wrap:wrap}._1hEm-CrAMHPul7abFCynGM{margin-left:12px}._2okJ9umcOw_j7RNkFM0NfQ ._3v6hS-oiYk2sOv4queo_A0{-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse}._2okJ9umcOw_j7RNkFM0NfQ ._3ViShGJ04PrIhBnOVgqdsZ{min-width:220px}._2okJ9umcOw_j7RNkFM0NfQ .UhcE8DlZZx03ATb3k7aG{margin:auto auto 16px}}._33_hjoFeTSOWk_t1Z7Sr-c{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;display:none;color:#1890ff;text-align:center;vertical-align:middle;opacity:0;transition:transform .3s cubic-bezier(.78,.14,.15,.86)}._25jf8kRv826BvBkZnoLXC9{position:static;display:inline-block;opacity:1}._3Ke6pb7hhqQtNVgQMQWFc2{position:relative}._3Ke6pb7hhqQtNVgQMQWFc2>div>._33_hjoFeTSOWk_t1Z7Sr-c{position:absolute;top:0;left:0;z-index:4;display:block;width:100%;height:100%;max-height:400px}._3Ke6pb7hhqQtNVgQMQWFc2>div>._33_hjoFeTSOWk_t1Z7Sr-c ._2dlEDqVGge90rcRSiRPwc3{position:absolute;top:50%;left:50%;margin:-10px}._3Ke6pb7hhqQtNVgQMQWFc2>div>._33_hjoFeTSOWk_t1Z7Sr-c ._31LyyB1MhQ63Vc5oqAeuoF{position:absolute;top:50%;width:100%;padding-top:5px;text-shadow:0 1px 2px #fff}._3Ke6pb7hhqQtNVgQMQWFc2>div>._33_hjoFeTSOWk_t1Z7Sr-c._3_T6l9g2pj8kzvGWRx-fo7 ._2dlEDqVGge90rcRSiRPwc3{margin-top:-20px}._3Ke6pb7hhqQtNVgQMQWFc2>div>._3kj8CHHlAaJjTHG_LXLDJ ._2dlEDqVGge90rcRSiRPwc3{margin:-7px}._3Ke6pb7hhqQtNVgQMQWFc2>div>._3kj8CHHlAaJjTHG_LXLDJ ._31LyyB1MhQ63Vc5oqAeuoF{padding-top:2px}._3Ke6pb7hhqQtNVgQMQWFc2>div>._3kj8CHHlAaJjTHG_LXLDJ._3_T6l9g2pj8kzvGWRx-fo7 ._2dlEDqVGge90rcRSiRPwc3{margin-top:-17px}._3Ke6pb7hhqQtNVgQMQWFc2>div>._3aWuqxcOolVHV_G5k1OqJm ._2dlEDqVGge90rcRSiRPwc3{margin:-16px}._3Ke6pb7hhqQtNVgQMQWFc2>div>._3aWuqxcOolVHV_G5k1OqJm ._31LyyB1MhQ63Vc5oqAeuoF{padding-top:11px}._3Ke6pb7hhqQtNVgQMQWFc2>div>._3aWuqxcOolVHV_G5k1OqJm._3_T6l9g2pj8kzvGWRx-fo7 ._2dlEDqVGge90rcRSiRPwc3{margin-top:-26px}._1jrq9dfOxKwT2J3sfo9HId{position:relative;transition:opacity .3s}._1jrq9dfOxKwT2J3sfo9HId:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:10;display:none\\9;width:100%;height:100%;background:#fff;opacity:0;transition:all .3s;content:\"\";pointer-events:none}._2JPYRrTSbxUfX7zWCrR_Rw{clear:both;overflow:hidden;opacity:.5;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}._2JPYRrTSbxUfX7zWCrR_Rw:after{opacity:.4;pointer-events:auto}._2OPv56d89J8Mue367okw8g{color:rgba(0,0,0,.45)}._2dlEDqVGge90rcRSiRPwc3{position:relative;display:inline-block;font-size:20px;width:1em;height:1em}._1vaXbUaFs8T_DAONOUI5Fd{position:absolute;display:block;width:9px;height:9px;background-color:#1890ff;border-radius:100%;transform:scale(.75);transform-origin:50% 50%;opacity:.3;animation:_1tKKIQE_-FtjjAD8yiF_Vb 1s infinite linear alternate}._1vaXbUaFs8T_DAONOUI5Fd:first-child{top:0;left:0}._1vaXbUaFs8T_DAONOUI5Fd:nth-child(2){top:0;right:0;animation-delay:.4s}._1vaXbUaFs8T_DAONOUI5Fd:nth-child(3){right:0;bottom:0;animation-delay:.8s}._1vaXbUaFs8T_DAONOUI5Fd:nth-child(4){bottom:0;left:0;animation-delay:1.2s}._2MSFA0f_y97EstHKy7mOI0{transform:rotate(45deg);animation:_1uA-MCavQFuoWkE8_d74T5 1.2s infinite linear}._3kj8CHHlAaJjTHG_LXLDJ ._2dlEDqVGge90rcRSiRPwc3{font-size:14px}._3kj8CHHlAaJjTHG_LXLDJ ._2dlEDqVGge90rcRSiRPwc3 i{width:6px;height:6px}._3aWuqxcOolVHV_G5k1OqJm ._2dlEDqVGge90rcRSiRPwc3{font-size:32px}._3aWuqxcOolVHV_G5k1OqJm ._2dlEDqVGge90rcRSiRPwc3 i{width:14px;height:14px}._33_hjoFeTSOWk_t1Z7Sr-c._3_T6l9g2pj8kzvGWRx-fo7 ._31LyyB1MhQ63Vc5oqAeuoF{display:block}@media (-ms-high-contrast:active),(-ms-high-contrast:none){._2JPYRrTSbxUfX7zWCrR_Rw{background:#fff;opacity:.5}}@keyframes _1tKKIQE_-FtjjAD8yiF_Vb{to{opacity:1}}@keyframes _1uA-MCavQFuoWkE8_d74T5{to{transform:rotate(405deg)}}._3yFO0ExW2lDi3iJscVlo6q{box-sizing:border-box;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;font-feature-settings:\"tnum\"}._3yFO0ExW2lDi3iJscVlo6q,._3yFO0ExW2lDi3iJscVlo6q ol,._3yFO0ExW2lDi3iJscVlo6q ul{margin:0;padding:0;list-style:none}._3yFO0ExW2lDi3iJscVlo6q:after{display:block;clear:both;height:0;overflow:hidden;visibility:hidden;content:\" \"}._1f1529XdUGcTWDgnn6rnUv,._1iBopO6rJc1O90ZFd7L2gz{display:inline-block;height:32px;margin-right:8px;line-height:30px;vertical-align:middle}._1f1529XdUGcTWDgnn6rnUv{min-width:32px;font-family:Arial;text-align:center;list-style:none;background-color:#fff;border:1px solid #d9d9d9;border-radius:4px;outline:0;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1f1529XdUGcTWDgnn6rnUv a{display:block;padding:0 6px;color:rgba(0,0,0,.65);transition:none}._1f1529XdUGcTWDgnn6rnUv a:hover{text-decoration:none}._1f1529XdUGcTWDgnn6rnUv:focus,._1f1529XdUGcTWDgnn6rnUv:hover{border-color:#1890ff;transition:all .3s}._1f1529XdUGcTWDgnn6rnUv:focus a,._1f1529XdUGcTWDgnn6rnUv:hover a{color:#1890ff}._2meHzWui1MaKcYqri7tufu{font-weight:500;background:#fff;border-color:#1890ff}._2meHzWui1MaKcYqri7tufu a{color:#1890ff}._2meHzWui1MaKcYqri7tufu:focus,._2meHzWui1MaKcYqri7tufu:hover{border-color:#40a9ff}._2meHzWui1MaKcYqri7tufu:focus a,._2meHzWui1MaKcYqri7tufu:hover a{color:#40a9ff}._3i4e8RnsYoFnDxr7H-mhMN,.OHwGF6QYpVU8Bnp_pSxIC{outline:0}._3i4e8RnsYoFnDxr7H-mhMN ._2i1DZPi3jW2cQLK0SEOa5r,.OHwGF6QYpVU8Bnp_pSxIC ._2i1DZPi3jW2cQLK0SEOa5r{position:relative}._3i4e8RnsYoFnDxr7H-mhMN ._2i1DZPi3jW2cQLK0SEOa5r ._2epQoamc0VtGpZB_edAmK8,.OHwGF6QYpVU8Bnp_pSxIC ._2i1DZPi3jW2cQLK0SEOa5r ._2epQoamc0VtGpZB_edAmK8{display:inline-block;font-size:12px;font-size:12px\\9;transform:scale(1) rotate(0deg);color:#1890ff;letter-spacing:-1px;opacity:0;transition:all .2s}:root ._3i4e8RnsYoFnDxr7H-mhMN ._2i1DZPi3jW2cQLK0SEOa5r ._2epQoamc0VtGpZB_edAmK8,:root .OHwGF6QYpVU8Bnp_pSxIC ._2i1DZPi3jW2cQLK0SEOa5r ._2epQoamc0VtGpZB_edAmK8{font-size:12px}._3i4e8RnsYoFnDxr7H-mhMN ._2i1DZPi3jW2cQLK0SEOa5r ._2ySmZOZI-TsAPn4Fpiv-Hm,.OHwGF6QYpVU8Bnp_pSxIC ._2i1DZPi3jW2cQLK0SEOa5r ._2ySmZOZI-TsAPn4Fpiv-Hm{top:0;right:0;bottom:0;left:0;margin:auto}._3i4e8RnsYoFnDxr7H-mhMN ._2i1DZPi3jW2cQLK0SEOa5r ._2jST0s6r8iPEVsdgWLFLBC,.OHwGF6QYpVU8Bnp_pSxIC ._2i1DZPi3jW2cQLK0SEOa5r ._2jST0s6r8iPEVsdgWLFLBC{position:absolute;top:0;right:0;bottom:0;left:0;display:block;margin:auto;color:rgba(0,0,0,.25);letter-spacing:2px;text-align:center;text-indent:.13em;opacity:1;transition:all .2s}._3i4e8RnsYoFnDxr7H-mhMN:focus ._2epQoamc0VtGpZB_edAmK8,._3i4e8RnsYoFnDxr7H-mhMN:hover ._2epQoamc0VtGpZB_edAmK8,.OHwGF6QYpVU8Bnp_pSxIC:focus ._2epQoamc0VtGpZB_edAmK8,.OHwGF6QYpVU8Bnp_pSxIC:hover ._2epQoamc0VtGpZB_edAmK8{opacity:1}._3i4e8RnsYoFnDxr7H-mhMN:focus ._2jST0s6r8iPEVsdgWLFLBC,._3i4e8RnsYoFnDxr7H-mhMN:hover ._2jST0s6r8iPEVsdgWLFLBC,.OHwGF6QYpVU8Bnp_pSxIC:focus ._2jST0s6r8iPEVsdgWLFLBC,.OHwGF6QYpVU8Bnp_pSxIC:hover ._2jST0s6r8iPEVsdgWLFLBC{opacity:0}._2jUvMeEGYqUYn2eIxGyIr0,._3i4e8RnsYoFnDxr7H-mhMN,.OHwGF6QYpVU8Bnp_pSxIC{margin-right:8px}._2jUvMeEGYqUYn2eIxGyIr0,._3i4e8RnsYoFnDxr7H-mhMN,.OHwGF6QYpVU8Bnp_pSxIC,.p8NyuniaW72c2_u0mcTNJ{display:inline-block;min-width:32px;height:32px;color:rgba(0,0,0,.65);font-family:Arial;line-height:32px;text-align:center;vertical-align:middle;list-style:none;border-radius:4px;cursor:pointer;transition:all .3s}._2jUvMeEGYqUYn2eIxGyIr0,.p8NyuniaW72c2_u0mcTNJ{outline:0}._2jUvMeEGYqUYn2eIxGyIr0 a,.p8NyuniaW72c2_u0mcTNJ a{color:rgba(0,0,0,.65);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._2jUvMeEGYqUYn2eIxGyIr0:hover a,.p8NyuniaW72c2_u0mcTNJ:hover a{border-color:#40a9ff}._2jUvMeEGYqUYn2eIxGyIr0 ._130IDfc9UumlVlkRj_tMd3,.p8NyuniaW72c2_u0mcTNJ ._130IDfc9UumlVlkRj_tMd3{display:block;height:100%;font-size:12px;text-align:center;background-color:#fff;border:1px solid #d9d9d9;border-radius:4px;outline:none;transition:all .3s}._2jUvMeEGYqUYn2eIxGyIr0:focus ._130IDfc9UumlVlkRj_tMd3,._2jUvMeEGYqUYn2eIxGyIr0:hover ._130IDfc9UumlVlkRj_tMd3,.p8NyuniaW72c2_u0mcTNJ:focus ._130IDfc9UumlVlkRj_tMd3,.p8NyuniaW72c2_u0mcTNJ:hover ._130IDfc9UumlVlkRj_tMd3{color:#1890ff;border-color:#1890ff}._2Erd3VemLmI_4IUPF1pNX5,._2Erd3VemLmI_4IUPF1pNX5:focus,._2Erd3VemLmI_4IUPF1pNX5:hover{cursor:not-allowed}._2Erd3VemLmI_4IUPF1pNX5 ._130IDfc9UumlVlkRj_tMd3,._2Erd3VemLmI_4IUPF1pNX5 a,._2Erd3VemLmI_4IUPF1pNX5:focus ._130IDfc9UumlVlkRj_tMd3,._2Erd3VemLmI_4IUPF1pNX5:focus a,._2Erd3VemLmI_4IUPF1pNX5:hover ._130IDfc9UumlVlkRj_tMd3,._2Erd3VemLmI_4IUPF1pNX5:hover a{color:rgba(0,0,0,.25);border-color:#d9d9d9;cursor:not-allowed}._1qd9Y7KpTnvonJIZNNUNKA{margin:0 10px 0 5px}._3E4NM-Xt86D76rf21xBrat{display:inline-block;margin-left:16px;vertical-align:middle}.Nrkfmn2t7in374axnSHb9._1cNj85ZY8m7JAcdkxJ6Uc5{display:inline-block;width:auto;margin-right:8px}._3csAWP7VhxIj4dAZ0PQ3TV{display:inline-block;height:32px;line-height:32px;vertical-align:top}._3csAWP7VhxIj4dAZ0PQ3TV input{position:relative;display:inline-block;width:100%;height:32px;padding:4px 11px;color:rgba(0,0,0,.65);font-size:14px;line-height:1.5;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s;width:50px;margin:0 8px}._3csAWP7VhxIj4dAZ0PQ3TV input::-moz-placeholder{color:#bfbfbf;opacity:1}._3csAWP7VhxIj4dAZ0PQ3TV input:-ms-input-placeholder{color:#bfbfbf}._3csAWP7VhxIj4dAZ0PQ3TV input::-webkit-input-placeholder{color:#bfbfbf}._3csAWP7VhxIj4dAZ0PQ3TV input:-moz-placeholder-shown{text-overflow:ellipsis}._3csAWP7VhxIj4dAZ0PQ3TV input:-ms-input-placeholder{text-overflow:ellipsis}._3csAWP7VhxIj4dAZ0PQ3TV input:placeholder-shown{text-overflow:ellipsis}._3csAWP7VhxIj4dAZ0PQ3TV input:focus,._3csAWP7VhxIj4dAZ0PQ3TV input:hover{border-color:#40a9ff;border-right-width:1px!important}._3csAWP7VhxIj4dAZ0PQ3TV input:focus{outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._3csAWP7VhxIj4dAZ0PQ3TV input-disabled{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._3csAWP7VhxIj4dAZ0PQ3TV input-disabled:hover{border-color:#d9d9d9;border-right-width:1px!important}._3csAWP7VhxIj4dAZ0PQ3TV input[disabled]{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._3csAWP7VhxIj4dAZ0PQ3TV input[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea._3csAWP7VhxIj4dAZ0PQ3TV input{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}._3csAWP7VhxIj4dAZ0PQ3TV input-lg{height:40px;padding:6px 11px;font-size:16px}._3csAWP7VhxIj4dAZ0PQ3TV input-sm{height:24px;padding:1px 7px}._2vu3x68gvy_NeGX1VA9hZh ._2jUvMeEGYqUYn2eIxGyIr0,._2vu3x68gvy_NeGX1VA9hZh .p8NyuniaW72c2_u0mcTNJ{height:24px;line-height:24px;vertical-align:top}._2vu3x68gvy_NeGX1VA9hZh ._2jUvMeEGYqUYn2eIxGyIr0 ._130IDfc9UumlVlkRj_tMd3,._2vu3x68gvy_NeGX1VA9hZh .p8NyuniaW72c2_u0mcTNJ ._130IDfc9UumlVlkRj_tMd3{height:24px;border:0}._2vu3x68gvy_NeGX1VA9hZh ._2jUvMeEGYqUYn2eIxGyIr0 ._130IDfc9UumlVlkRj_tMd3:after,._2vu3x68gvy_NeGX1VA9hZh .p8NyuniaW72c2_u0mcTNJ ._130IDfc9UumlVlkRj_tMd3:after{height:24px;line-height:24px}._2vu3x68gvy_NeGX1VA9hZh ._15bgL_6ieFiK72lBhmeVpJ{display:inline-block;height:24px;margin-right:8px}._2vu3x68gvy_NeGX1VA9hZh ._15bgL_6ieFiK72lBhmeVpJ input{box-sizing:border-box;height:100%;margin-right:8px;padding:0 6px;text-align:center;background-color:#fff;border:1px solid #d9d9d9;border-radius:4px;outline:none;transition:border-color .3s}._2vu3x68gvy_NeGX1VA9hZh ._15bgL_6ieFiK72lBhmeVpJ input:hover{border-color:#1890ff}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._1iBopO6rJc1O90ZFd7L2gz,._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._15bgL_6ieFiK72lBhmeVpJ{height:24px;line-height:24px}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._1f1529XdUGcTWDgnn6rnUv{min-width:24px;height:24px;margin:0;line-height:22px}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._1f1529XdUGcTWDgnn6rnUv:not(._2meHzWui1MaKcYqri7tufu){background:transparent;border-color:transparent}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._2jUvMeEGYqUYn2eIxGyIr0,._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W .p8NyuniaW72c2_u0mcTNJ{min-width:24px;height:24px;margin:0;line-height:24px}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._2jUvMeEGYqUYn2eIxGyIr0 ._130IDfc9UumlVlkRj_tMd3,._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W .p8NyuniaW72c2_u0mcTNJ ._130IDfc9UumlVlkRj_tMd3{background:transparent;border-color:transparent}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._2jUvMeEGYqUYn2eIxGyIr0 ._130IDfc9UumlVlkRj_tMd3:after,._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W .p8NyuniaW72c2_u0mcTNJ ._130IDfc9UumlVlkRj_tMd3:after{height:24px;line-height:24px}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._3i4e8RnsYoFnDxr7H-mhMN,._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W .OHwGF6QYpVU8Bnp_pSxIC{height:24px;margin-right:0;line-height:24px}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._3E4NM-Xt86D76rf21xBrat{margin-left:2px}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._3csAWP7VhxIj4dAZ0PQ3TV{height:24px;line-height:24px}._3yFO0ExW2lDi3iJscVlo6q._1VxqH_l6bGur6YTGvueD0W ._3csAWP7VhxIj4dAZ0PQ3TV input{height:24px;padding:1px 7px;width:44px}._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5{cursor:not-allowed}._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._1f1529XdUGcTWDgnn6rnUv{background:#f5f5f5;border-color:#d9d9d9;cursor:not-allowed}._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._1f1529XdUGcTWDgnn6rnUv a{color:rgba(0,0,0,.25);background:transparent;border:none;cursor:not-allowed}._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._2meHzWui1MaKcYqri7tufu{background:#dbdbdb;border-color:transparent}._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._2meHzWui1MaKcYqri7tufu a{color:#fff}._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._130IDfc9UumlVlkRj_tMd3,._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._130IDfc9UumlVlkRj_tMd3:focus,._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._130IDfc9UumlVlkRj_tMd3:hover{color:rgba(0,0,0,.45);background:#f5f5f5;border-color:#d9d9d9;cursor:not-allowed}._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._3i4e8RnsYoFnDxr7H-mhMN:focus ._2epQoamc0VtGpZB_edAmK8,._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._3i4e8RnsYoFnDxr7H-mhMN:hover ._2epQoamc0VtGpZB_edAmK8,._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 .OHwGF6QYpVU8Bnp_pSxIC:focus ._2epQoamc0VtGpZB_edAmK8,._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 .OHwGF6QYpVU8Bnp_pSxIC:hover ._2epQoamc0VtGpZB_edAmK8{opacity:0}._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._3i4e8RnsYoFnDxr7H-mhMN:focus ._2jST0s6r8iPEVsdgWLFLBC,._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 ._3i4e8RnsYoFnDxr7H-mhMN:hover ._2jST0s6r8iPEVsdgWLFLBC,._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 .OHwGF6QYpVU8Bnp_pSxIC:focus ._2jST0s6r8iPEVsdgWLFLBC,._3yFO0ExW2lDi3iJscVlo6q._2Erd3VemLmI_4IUPF1pNX5 .OHwGF6QYpVU8Bnp_pSxIC:hover ._2jST0s6r8iPEVsdgWLFLBC{opacity:1}@media only screen and (max-width:992px){.GGVp1H2RhTfDGf0-Utpt7,.ZfpZTNXn6MvWlfQXacS_k{display:none}}@media only screen and (max-width:576px){._3E4NM-Xt86D76rf21xBrat{display:none}}.evz3k4BAlGZ29PrmHf8ZA{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;width:100%;vertical-align:middle}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99{position:relative;display:inline-block;width:100%;height:32px;padding:4px 11px;color:rgba(0,0,0,.65);font-size:14px;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s;display:block;height:auto;min-height:32px;padding:0;line-height:1.5}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99::-moz-placeholder{color:#bfbfbf;opacity:1}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:-ms-input-placeholder{color:#bfbfbf}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99::-webkit-input-placeholder{color:#bfbfbf}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:-moz-placeholder-shown{text-overflow:ellipsis}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:-ms-input-placeholder{text-overflow:ellipsis}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:placeholder-shown{text-overflow:ellipsis}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:focus,.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:hover{border-color:#40a9ff;border-right-width:1px!important}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99:focus{outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}.evz3k4BAlGZ29PrmHf8ZA ._1RTi7ckd4PgsS2fCkneVWA{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}.evz3k4BAlGZ29PrmHf8ZA ._1RTi7ckd4PgsS2fCkneVWA:hover{border-color:#d9d9d9;border-right-width:1px!important}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99[disabled]{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea.evz3k4BAlGZ29PrmHf8ZA .FgcTqoSfeRhgxyye0BL99{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}.evz3k4BAlGZ29PrmHf8ZA ._36BCYnfNgZqiwRqq8vcOsT{height:40px;padding:6px 11px;font-size:16px}.evz3k4BAlGZ29PrmHf8ZA ._1smnBainYD0VStXjw8EV_Q{height:24px;padding:1px 7px}.evz3k4BAlGZ29PrmHf8ZA ._1VjLPOAvv4YCntQ2MmH_ey{height:auto;overflow-y:auto}.evz3k4BAlGZ29PrmHf8ZA.bf5U_b82Zn-jzGoDLzpRV:not(._10gRqOxa4A45g-aoMVtjwB) .FgcTqoSfeRhgxyye0BL99{border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}.evz3k4BAlGZ29PrmHf8ZA._10gRqOxa4A45g-aoMVtjwB .FgcTqoSfeRhgxyye0BL99{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}.evz3k4BAlGZ29PrmHf8ZA._10gRqOxa4A45g-aoMVtjwB .FgcTqoSfeRhgxyye0BL99:hover{border-color:#d9d9d9;border-right-width:1px!important}.evz3k4BAlGZ29PrmHf8ZA ._1uwngUxhOg2tREs8tYb01s{position:absolute;pointer-events:none}.evz3k4BAlGZ29PrmHf8ZA ._1uwngUxhOg2tREs8tYb01s ._2-g3_40Q2iEVf5_2ox9h31{height:auto;padding:5px 11px;color:#bfbfbf;white-space:pre-wrap;word-wrap:break-word;outline:none;opacity:1}.evz3k4BAlGZ29PrmHf8ZA ._2MBAOecTA-SLqVboZa6kNc ._24yvQhbhHxhMxFsdwYTxtA{height:auto;padding:5px 11px}.CpjRV0iU-4Nz1Z8T4WLys{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;top:-9999px;left:-9999px;z-index:1050;min-width:120px;max-height:250px;margin-top:1.5em;overflow-x:hidden;overflow-y:auto;background-color:#fff;border-radius:4px;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.15)}._2nkQMiH0tKJCXarnyu6Zj4{margin-top:-.1em}._2egnxmBYklXbJfz0cQ7yQ_._19Qtk0_pgNq77S2yM3RPaC{color:rgba(0,0,0,.25)}._2egnxmBYklXbJfz0cQ7yQ_._19Qtk0_pgNq77S2yM3RPaC .M1pWPFIKw7Lipb7_xEhWj{display:block;color:#1890ff;text-align:center}._19Qtk0_pgNq77S2yM3RPaC{position:relative;display:block;padding:5px 12px;overflow:hidden;color:rgba(0,0,0,.65);font-weight:400;line-height:22px;white-space:nowrap;text-overflow:ellipsis;cursor:pointer;transition:background .3s}._19Qtk0_pgNq77S2yM3RPaC._35mm_9_OLUgn5eifoIA-vO,._19Qtk0_pgNq77S2yM3RPaC:hover,.bmO63xp6pSS52jKLRV6dM{background-color:#e6f7ff}.YaxhbWIAwqwnDe6DCPIJM,.YaxhbWIAwqwnDe6DCPIJM:hover{color:rgba(0,0,0,.25);cursor:not-allowed}.YaxhbWIAwqwnDe6DCPIJM:hover{background-color:#fff}._3zKZJq-ySH40NY3j14wzUK,._3zKZJq-ySH40NY3j14wzUK:hover{color:rgba(0,0,0,.65);font-weight:700;background-color:#f5f5f5}._376sEn1wsb3Db-T6fpsrYf{height:1px;margin:1px 0;overflow:hidden;line-height:0;background-color:#e8e8e8}._2b1hOLgW0QbUm0CvwL-46V{box-sizing:border-box;margin:0;font-variant:tabular-nums;list-style:none;font-feature-settings:\"tnum\";width:100%;height:32px;padding:4px 11px;color:rgba(0,0,0,.65);font-size:14px;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s;position:relative;display:inline-block;height:auto;padding:0;overflow:hidden;line-height:1.5;white-space:pre-wrap;vertical-align:bottom}._2b1hOLgW0QbUm0CvwL-46V::-moz-placeholder{color:#bfbfbf;opacity:1}._2b1hOLgW0QbUm0CvwL-46V:-ms-input-placeholder{color:#bfbfbf}._2b1hOLgW0QbUm0CvwL-46V::-webkit-input-placeholder{color:#bfbfbf}._2b1hOLgW0QbUm0CvwL-46V:-moz-placeholder-shown{text-overflow:ellipsis}._2b1hOLgW0QbUm0CvwL-46V:-ms-input-placeholder{text-overflow:ellipsis}._2b1hOLgW0QbUm0CvwL-46V:placeholder-shown{text-overflow:ellipsis}._2b1hOLgW0QbUm0CvwL-46V:focus,._2b1hOLgW0QbUm0CvwL-46V:hover{border-color:#40a9ff;border-right-width:1px!important}._2b1hOLgW0QbUm0CvwL-46V:focus{outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._1VkwU6jDoiz0Rz3HMt67xg{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._1VkwU6jDoiz0Rz3HMt67xg:hover{border-color:#d9d9d9;border-right-width:1px!important}._2b1hOLgW0QbUm0CvwL-46V[disabled]{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._2b1hOLgW0QbUm0CvwL-46V[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea._2b1hOLgW0QbUm0CvwL-46V{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}._3FHavFPa-8yeylPYSFErfp{height:40px;padding:6px 11px;font-size:16px}.oMi_gy5EPp2H1hilHdUHS{height:24px;padding:1px 7px}._1VkwU6jDoiz0Rz3HMt67xg>textarea{color:rgba(0,0,0,.25);background-color:#f5f5f5;cursor:not-allowed;opacity:1}._1VkwU6jDoiz0Rz3HMt67xg>textarea:hover{border-color:#d9d9d9;border-right-width:1px!important}.BkIQLFUZjKkHSifr1ZKph{border-color:#40a9ff;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._2b1hOLgW0QbUm0CvwL-46V>textarea,._11EU93dV-SjK8flRW23jAU{min-height:30px;margin:0;padding:4px 11px;overflow:inherit;overflow-x:hidden;overflow-y:auto;font-weight:inherit;font-size:inherit;font-family:inherit;font-style:inherit;font-variant:inherit;font-size-adjust:inherit;font-stretch:inherit;line-height:inherit;direction:inherit;letter-spacing:inherit;white-space:inherit;text-align:inherit;vertical-align:top;word-wrap:break-word;word-break:inherit;-moz-tab-size:inherit;tab-size:inherit}._2b1hOLgW0QbUm0CvwL-46V>textarea{width:100%;border:none;outline:none;resize:none}._2b1hOLgW0QbUm0CvwL-46V>textarea::-moz-placeholder{color:#bfbfbf;opacity:1}._2b1hOLgW0QbUm0CvwL-46V>textarea:-ms-input-placeholder{color:#bfbfbf}._2b1hOLgW0QbUm0CvwL-46V>textarea::-webkit-input-placeholder{color:#bfbfbf}._2b1hOLgW0QbUm0CvwL-46V>textarea:-moz-placeholder-shown{text-overflow:ellipsis}._2b1hOLgW0QbUm0CvwL-46V>textarea:-ms-input-placeholder{text-overflow:ellipsis}._2b1hOLgW0QbUm0CvwL-46V>textarea:placeholder-shown{text-overflow:ellipsis}._2b1hOLgW0QbUm0CvwL-46V>textarea:-moz-read-only{cursor:default}._2b1hOLgW0QbUm0CvwL-46V>textarea:read-only{cursor:default}._11EU93dV-SjK8flRW23jAU{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;color:transparent;pointer-events:none}._11EU93dV-SjK8flRW23jAU>span{display:inline-block;min-height:1em}._3ChvqdzSqC56hMtsNxA8RA{margin:0;padding:0;color:rgba(0,0,0,.65);font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;top:-9999px;left:-9999px;z-index:1050;box-sizing:border-box;font-size:14px;font-variant:normal;background-color:#fff;border-radius:4px;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.15)}._1lRpaAJantPS-A2OopEbpu{display:none}._32OP3ph50munbPYgXAviiw{max-height:250px;margin-bottom:0;padding-left:0;overflow:auto;list-style:none;outline:none}._1kjQTt5weob-nzxHHD9OhT{position:relative;display:block;min-width:100px;padding:5px 12px;overflow:hidden;color:rgba(0,0,0,.65);font-weight:400;line-height:22px;white-space:nowrap;text-overflow:ellipsis;cursor:pointer;transition:background .3s ease}._1kjQTt5weob-nzxHHD9OhT:hover{background-color:#e6f7ff}._1kjQTt5weob-nzxHHD9OhT:first-child{border-radius:4px 4px 0 0}._1kjQTt5weob-nzxHHD9OhT:last-child{border-radius:0 0 4px 4px}._3tWz5XGYho7R6sHLjtskF,._3tWz5XGYho7R6sHLjtskF:hover{color:rgba(0,0,0,.25);cursor:not-allowed}._3tWz5XGYho7R6sHLjtskF:hover{background-color:#fff}._3T4NjiCCx240ILShqLVVEQ{color:rgba(0,0,0,.65);font-weight:600;background-color:#fafafa}._1ItyC9ldJ07fKyByCuZSjE{background-color:#e6f7ff}._2scQ5iv-KD3tc7_4wOYZeH{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:fixed;top:16px;left:0;z-index:1010;width:100%;pointer-events:none}.qijyafB7NLEXM9LFQ4bIH{padding:8px;text-align:center}.qijyafB7NLEXM9LFQ4bIH:first-child{margin-top:-8px}.EI-n64ltYTFKxGHk_Rn1_{display:inline-block;padding:10px 16px;background:#fff;border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,.15);pointer-events:all}.gkMUsKDxuGbFc1bGcMdjZ ._1oZ8xlpZEg3PzGp2jMNFuZ{color:#52c41a}._2CBg0Z1HkMY5cOeZFsHjDW ._1oZ8xlpZEg3PzGp2jMNFuZ{color:#f5222d}._2awRrnOKdlkv4RJpgYkdD9 ._1oZ8xlpZEg3PzGp2jMNFuZ{color:#faad14}._1bQC3GuFxcicO9K2l1aD8n ._1oZ8xlpZEg3PzGp2jMNFuZ,._31j5L1LOApFTa7sL8ibhAO ._1oZ8xlpZEg3PzGp2jMNFuZ{color:#1890ff}._2scQ5iv-KD3tc7_4wOYZeH ._1oZ8xlpZEg3PzGp2jMNFuZ{position:relative;top:1px;margin-right:8px;font-size:16px}.qijyafB7NLEXM9LFQ4bIH._2T2CHtH4XgVwCRHMaV3ayw._4yObpTmaBJmC5s1pcDxJp{overflow:hidden;animation-name:hAiSCIK6SrmkYWpF-gwLI;animation-duration:.3s}@keyframes hAiSCIK6SrmkYWpF-gwLI{0%{max-height:150px;padding:8px;opacity:1}to{max-height:0;padding:0;opacity:0}}._1p4wiVJpxk7sAs3u8XwUbe{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;top:100px;width:auto;margin:0 auto;padding-bottom:24px;pointer-events:none}._2qTKcbP4Ra0rVnrEbPEdNx{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1000;overflow:auto;outline:0;-webkit-overflow-scrolling:touch}._3__RNUXvpP1aLf3mDH1mLF{margin:0;color:rgba(0,0,0,.85);font-weight:500;font-size:16px;line-height:22px;word-wrap:break-word}._2d5FRv5V7mSPG_douar4Ul{position:relative;background-color:#fff;background-clip:padding-box;border:0;border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,.15);pointer-events:auto}._2ldhGnBmBU6RvFjHQ3JDQe{position:absolute;top:0;right:0;z-index:10;padding:0;color:rgba(0,0,0,.45);font-weight:700;line-height:1;text-decoration:none;background:transparent;border:0;outline:0;cursor:pointer;transition:color .3s}._3UKHG9lLTQi88eFRnVVv5P{display:block;width:56px;height:56px;font-size:16px;font-style:normal;line-height:56px;text-align:center;text-transform:none;text-rendering:auto}._2ldhGnBmBU6RvFjHQ3JDQe:focus,._2ldhGnBmBU6RvFjHQ3JDQe:hover{color:rgba(0,0,0,.75);text-decoration:none}._2wzMnkOsTe-3AWQ85m1TjK{padding:16px 24px;color:rgba(0,0,0,.65);background:#fff;border-bottom:1px solid #e8e8e8;border-radius:4px 4px 0 0}._10AeroU9dgP4jH85UkxC3-{padding:24px;font-size:14px;line-height:1.5;word-wrap:break-word}._1DtBpy6AkyyEoezB4t1rVh{padding:10px 16px;text-align:right;background:transparent;border-top:1px solid #e8e8e8;border-radius:0 0 4px 4px}._1DtBpy6AkyyEoezB4t1rVh button+button{margin-bottom:0;margin-left:8px}._1p4wiVJpxk7sAs3u8XwUbe._1dq1hSnQ28O5mrHxyKeRa0,._1p4wiVJpxk7sAs3u8XwUbe._30--xMhxZ94JTK2d9gG6H5{transform:none;opacity:0;animation-duration:.3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.eq0YVfAZO_meNhnr3yx60{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1000;height:100%;background-color:rgba(0,0,0,.45);filter:alpha(opacity=50)}.BBDzQtAmnJpdvRAkHUUIN{display:none}._2kgxLoU2rjK7uGiyjB-4fW{overflow:hidden}.EnFY7K0nMtUgUe1iXUI0d{text-align:center}.EnFY7K0nMtUgUe1iXUI0d:before{display:inline-block;width:0;height:100%;vertical-align:middle;content:\"\"}.EnFY7K0nMtUgUe1iXUI0d ._1p4wiVJpxk7sAs3u8XwUbe{top:0;display:inline-block;text-align:left;vertical-align:middle}@media (max-width:767px){._1p4wiVJpxk7sAs3u8XwUbe{max-width:calc(100vw - 16px);margin:8px auto}.EnFY7K0nMtUgUe1iXUI0d ._1p4wiVJpxk7sAs3u8XwUbe{-ms-flex:1;flex:1}}._2pio4Ippb2FVc_KA7GOcDC ._2ldhGnBmBU6RvFjHQ3JDQe,._2pio4Ippb2FVc_KA7GOcDC ._2wzMnkOsTe-3AWQ85m1TjK{display:none}._2pio4Ippb2FVc_KA7GOcDC ._10AeroU9dgP4jH85UkxC3-{padding:32px 32px 24px}._3NwImwuX4SDTAHABoMytrj{zoom:1}._3NwImwuX4SDTAHABoMytrj:after,._3NwImwuX4SDTAHABoMytrj:before{display:table;content:\"\"}._3NwImwuX4SDTAHABoMytrj:after{clear:both}._1zS8uHVyFRWPRjOcvbKISm ._32o5cMnV-gIZbjefZhq61i{display:block;overflow:hidden;color:rgba(0,0,0,.85);font-weight:500;font-size:16px;line-height:1.4}._1zS8uHVyFRWPRjOcvbKISm ._3QF8eid9eAKB3ANccNUJnD{margin-top:8px;color:rgba(0,0,0,.65);font-size:14px}._1zS8uHVyFRWPRjOcvbKISm>._1oZ8xlpZEg3PzGp2jMNFuZ{float:left;margin-right:16px;font-size:22px}._1zS8uHVyFRWPRjOcvbKISm>._1oZ8xlpZEg3PzGp2jMNFuZ+._32o5cMnV-gIZbjefZhq61i+._3QF8eid9eAKB3ANccNUJnD{margin-left:38px}._2pio4Ippb2FVc_KA7GOcDC .h2fqI7f2RVSnSbByxOdT{float:right;margin-top:24px}._2pio4Ippb2FVc_KA7GOcDC .h2fqI7f2RVSnSbByxOdT button+button{margin-bottom:0;margin-left:8px}.nqNTv7vkzy5BWTIJu8as4 ._1zS8uHVyFRWPRjOcvbKISm>._1oZ8xlpZEg3PzGp2jMNFuZ{color:#f5222d}._2_gOA-NqcuV7pr8MdDQRV4 ._1zS8uHVyFRWPRjOcvbKISm>._1oZ8xlpZEg3PzGp2jMNFuZ,._3vwTKAENvLi-VhCTOtb1Bj ._1zS8uHVyFRWPRjOcvbKISm>._1oZ8xlpZEg3PzGp2jMNFuZ{color:#faad14}.J7JyQKkzR9rSKiajIm1P0 ._1zS8uHVyFRWPRjOcvbKISm>._1oZ8xlpZEg3PzGp2jMNFuZ{color:#1890ff}._2_04kdOkEGAgnJmWug6FuC ._1zS8uHVyFRWPRjOcvbKISm>._1oZ8xlpZEg3PzGp2jMNFuZ{color:#52c41a}._3NPN7lUgfZGtdGoCG8h0cc{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:fixed;z-index:1010;width:384px;max-width:calc(100vw - 32px);margin-right:24px}._1JNd6GIyfRXX-XujzlqoW0,.gMs98mDL1U2UEyk3jt_pD{margin-right:0;margin-left:24px}._1JNd6GIyfRXX-XujzlqoW0 ._1AEK42-Ues4PFMucIxETek._3uzmwGdxO4qVvPHTT4jD-Z,._1JNd6GIyfRXX-XujzlqoW0 .WPeniBWOP1r9qW6H0h-e1._3rVWPmDwdtCvqWwboQ7WI3,.gMs98mDL1U2UEyk3jt_pD ._1AEK42-Ues4PFMucIxETek._3uzmwGdxO4qVvPHTT4jD-Z,.gMs98mDL1U2UEyk3jt_pD .WPeniBWOP1r9qW6H0h-e1._3rVWPmDwdtCvqWwboQ7WI3{animation-name:T7Mep6NGkTcPXDjdejT5F}._1Vb-VneAVHmSDWGSaZbTSe{font-size:14px;cursor:pointer}._3sw2WnyZWLNbAE52BZsF5N{position:relative;margin-bottom:16px;padding:16px 24px;overflow:hidden;line-height:1.5;background:#fff;border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,.15)}._2uAqHFLPbE3qvrlzdFqxGM{display:inline-block;margin-bottom:8px;color:rgba(0,0,0,.85);font-size:16px;line-height:24px}._1jblYp7mbU1RWAaKd6lDYH{display:block;width:calc(384px - 24px * 2 - 24px - 48px - 100%);max-width:4px;background-color:transparent;pointer-events:none}._1jblYp7mbU1RWAaKd6lDYH:before{display:block;content:\"\"}.Uc2oErVf_bRA6GIxalxca{font-size:14px}._1yjmRHpG_r2hwbG1MeNSPd ._2uAqHFLPbE3qvrlzdFqxGM{padding-right:24px}._3fuNERJi2jHFXcvW9FM50s ._2uAqHFLPbE3qvrlzdFqxGM{margin-bottom:4px;margin-left:48px;font-size:16px}._3fuNERJi2jHFXcvW9FM50s .Uc2oErVf_bRA6GIxalxca{margin-left:48px;font-size:14px}._3QMx5qPFm5JLqO1SfMCXcr{position:absolute;margin-left:4px;font-size:24px;line-height:24px}._1oZ8xlpZEg3PzGp2jMNFuZ._2YUmoPaJk4whM-n-96yQDl{color:#52c41a}._1oZ8xlpZEg3PzGp2jMNFuZ.E3vIGUuQ-RYn29WJ_fOcJ{color:#1890ff}._1oZ8xlpZEg3PzGp2jMNFuZ._1DZHehw4dEYqXYCH4OHs8S{color:#faad14}._1oZ8xlpZEg3PzGp2jMNFuZ._1Eg1Jef3ineGOXdqctBIxj{color:#f5222d}._1ruCiXV36WTGZutzzFIIHB{position:absolute;top:16px;right:22px;color:rgba(0,0,0,.45);outline:none}._1ruCiXV36WTGZutzzFIIHB:hover{color:rgba(0,0,0,.67)}._2Cw-JsLMMOW9r8pIABmBx4{float:right;margin-top:16px}._3NPN7lUgfZGtdGoCG8h0cc ._1gf29AM-L693KopVigc8aX{animation-duration:.24s;animation-timing-function:cubic-bezier(.645,.045,.355,1);animation-fill-mode:both}._1AEK42-Ues4PFMucIxETek,.WPeniBWOP1r9qW6H0h-e1{opacity:0;animation-play-state:paused}._1AEK42-Ues4PFMucIxETek,._284e-IuVgY2suYf_7mZ0K7,.WPeniBWOP1r9qW6H0h-e1{animation-duration:.24s;animation-timing-function:cubic-bezier(.645,.045,.355,1);animation-fill-mode:both}._284e-IuVgY2suYf_7mZ0K7{animation-duration:.2s;animation-play-state:paused}._1AEK42-Ues4PFMucIxETek._3uzmwGdxO4qVvPHTT4jD-Z,.WPeniBWOP1r9qW6H0h-e1._3rVWPmDwdtCvqWwboQ7WI3{animation-name:_5sy0UVdMxBJVZDIjhGCic;animation-play-state:running}._284e-IuVgY2suYf_7mZ0K7._3AHzO4UZtj6uVEyEt0g53S{animation-name:_3BAurSLEI06YezKhLoc7rf;animation-play-state:running}@keyframes _5sy0UVdMxBJVZDIjhGCic{0%{left:384px;opacity:0}to{left:0;opacity:1}}@keyframes T7Mep6NGkTcPXDjdejT5F{0%{right:384px;opacity:0}to{right:0;opacity:1}}@keyframes _3BAurSLEI06YezKhLoc7rf{0%{max-height:150px;margin-bottom:16px;padding-top:16px 24px;padding-bottom:16px 24px;opacity:1}to{max-height:0;margin-bottom:0;padding-top:0;padding-bottom:0;opacity:0}}._1xBuD_5Wc6kap5fKcdubCY{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;padding:16px 24px;background-color:#fff}._11ghs-GxCq-PpXXmUljJNz{background-color:inherit}._1xBuD_5Wc6kap5fKcdubCY._1yb4b_F5hEv-kZKZQhZh6o{padding-top:12px}._1xBuD_5Wc6kap5fKcdubCY._23loBlQkcBJMHeh5Py-MYy{padding-bottom:0}._1GvRtZomDeif5gNR_2S0BM{float:left;margin:8px 0;margin-right:16px;font-size:16px;line-height:1}._1ebhAUvP8RPRr8jvXZxEbb{color:#1890ff;text-decoration:none;outline:none;transition:color .3s;color:#000;cursor:pointer}._1ebhAUvP8RPRr8jvXZxEbb:focus,._1ebhAUvP8RPRr8jvXZxEbb:hover{color:#40a9ff}._1ebhAUvP8RPRr8jvXZxEbb:active{color:#096dd9}._1xBuD_5Wc6kap5fKcdubCY ._3Ui0E_Kjt95Y11pgFHRL5i{height:14px;margin:0 12px;vertical-align:middle}._3eEogvwh7o7K3lNEC83dFg+._3CD05zBVoPAlFWE-p-Bu7j{margin-top:8px}._3CD05zBVoPAlFWE-p-Bu7j{width:100%;overflow:hidden}._1mrkpViaA4wP3SVjraGWDg{display:block;float:left;margin-bottom:0;padding-right:12px;color:rgba(0,0,0,.85);font-weight:600;font-size:20px;line-height:32px}._3CD05zBVoPAlFWE-p-Bu7j ._2MKp7hdKk2nS6JN5GBZgf8{float:left;margin-right:12px}._2sP8egFXDhNhAq-9dnBijR{float:left;margin:5px 0;margin-right:12px;color:rgba(0,0,0,.45);font-size:14px;line-height:22px}._2RJWEdsFWY0HkEXQxeckZQ{float:left;margin:4px 0}._2lvXzboe7JiOpna2Ve4Y1q{float:right}._2lvXzboe7JiOpna2Ve4Y1q>*{margin-left:8px}._2lvXzboe7JiOpna2Ve4Y1q>:first-child{margin-left:0}._3DSYKFtdHU0fADEb23Rstd{padding-top:12px;overflow:hidden}._3TtnMW3OVG_zlPETRt7njv{margin-top:16px}._3TtnMW3OVG_zlPETRt7njv ._1R-OR6gDlsIGQjy8z0PZpz{margin-bottom:1px;border-bottom:0}._3TtnMW3OVG_zlPETRt7njv ._1R-OR6gDlsIGQjy8z0PZpz .dtwF9ntXFX2e9pB4KtnpO ._1U7fGxHtLat1LEY_EUwPvV{padding:8px;font-size:16px}@media (max-width:576px){._2lvXzboe7JiOpna2Ve4Y1q{display:block;float:unset;width:100%;padding-top:12px;overflow:hidden}}._3D4LR13qReFw-srmAnTyHG{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:absolute;top:0;left:0;z-index:1030;font-weight:400;white-space:normal;text-align:left;cursor:auto;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}._3D4LR13qReFw-srmAnTyHG:after{position:absolute;background:hsla(0,0%,100%,.01);content:\"\"}._2tZXIV6vmuAxGLOX_negTJ{display:none}._1WZTfgZiLGZ_8KsXMfTn1-,._2ueEXsYfvfMKCDsqcUSpmO,.hIa1DuPqWrMnQWx1NAXJD{padding-bottom:10px}._2NBUPwTTmP9Z8XThzZuU8g,._16Q7snpQtM7kb6wBiPDT18,.lb038aIsah01XcC9gwGvC{padding-left:10px}.-i-cBVrasFn38zOORhmGg,._2s9CF_PluZDzoKo6C_HNke,._3ci73bjTwkE8VXjJ_hxPCq{padding-top:10px}._2hXOqPJMFGGCxi2R5Q7I4P,._3mYGaiL2Xx0TG6tUJy0rza,.pjPt2FJwOJvyK1IlE46Lk{padding-right:10px}.S4aRvr_XPzfsiMF6goerE{background-color:#fff;background-clip:padding-box;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15);box-shadow:0 0 8px rgba(0,0,0,.15)\\9}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.S4aRvr_XPzfsiMF6goerE{box-shadow:0 2px 8px rgba(0,0,0,.15)}}.WaXkM7ygIqLJN66l2vGFm{min-width:177px;min-height:32px;margin:0;padding:5px 16px 4px;color:rgba(0,0,0,.85);font-weight:500;border-bottom:1px solid #e8e8e8}.FX0It6EoZoRaNYCLCjhBv{padding:12px 16px;color:rgba(0,0,0,.65)}._1KdnlVyH_1XRuZDv7v0Joi{position:relative;padding:4px 0 12px;color:rgba(0,0,0,.65);font-size:14px}._1KdnlVyH_1XRuZDv7v0Joi>._1oZ8xlpZEg3PzGp2jMNFuZ{position:absolute;top:8px;color:#faad14;font-size:14px}._1a02Nd8BYAKzVX74fkVDeP{padding-left:22px}._3lgNPqDm7BoXsErT1PNIwB{margin-bottom:4px;text-align:right}._3lgNPqDm7BoXsErT1PNIwB button{margin-left:8px}._3bzbe_mQmFyJrPgOzjznuh{position:absolute;display:block;width:8.48528137px;height:8.48528137px;background:transparent;border-style:solid;border-width:4.24264069px;transform:rotate(45deg)}._1WZTfgZiLGZ_8KsXMfTn1->._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh,._2ueEXsYfvfMKCDsqcUSpmO>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh,.hIa1DuPqWrMnQWx1NAXJD>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{bottom:6.2px;border-top-color:transparent;border-right-color:#fff;border-bottom-color:#fff;border-left-color:transparent;box-shadow:3px 3px 7px rgba(0,0,0,.07)}._2ueEXsYfvfMKCDsqcUSpmO>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{left:50%;transform:translateX(-50%) rotate(45deg)}._1WZTfgZiLGZ_8KsXMfTn1->._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{left:16px}.hIa1DuPqWrMnQWx1NAXJD>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{right:16px}._2NBUPwTTmP9Z8XThzZuU8g>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh,._16Q7snpQtM7kb6wBiPDT18>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh,.lb038aIsah01XcC9gwGvC>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{left:6px;border-top-color:transparent;border-right-color:transparent;border-bottom-color:#fff;border-left-color:#fff;box-shadow:-3px 3px 7px rgba(0,0,0,.07)}._16Q7snpQtM7kb6wBiPDT18>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{top:50%;transform:translateY(-50%) rotate(45deg)}._2NBUPwTTmP9Z8XThzZuU8g>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{top:12px}.lb038aIsah01XcC9gwGvC>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{bottom:12px}.-i-cBVrasFn38zOORhmGg>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh,._2s9CF_PluZDzoKo6C_HNke>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh,._3ci73bjTwkE8VXjJ_hxPCq>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{top:6px;border-top-color:#fff;border-right-color:transparent;border-bottom-color:transparent;border-left-color:#fff;box-shadow:-2px -2px 5px rgba(0,0,0,.06)}.-i-cBVrasFn38zOORhmGg>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{left:50%;transform:translateX(-50%) rotate(45deg)}._3ci73bjTwkE8VXjJ_hxPCq>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{left:16px}._2s9CF_PluZDzoKo6C_HNke>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{right:16px}._2hXOqPJMFGGCxi2R5Q7I4P>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh,._3mYGaiL2Xx0TG6tUJy0rza>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh,.pjPt2FJwOJvyK1IlE46Lk>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{right:6px;border-top-color:#fff;border-right-color:#fff;border-bottom-color:transparent;border-left-color:transparent;box-shadow:3px -3px 7px rgba(0,0,0,.07)}._2hXOqPJMFGGCxi2R5Q7I4P>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{top:50%;transform:translateY(-50%) rotate(45deg)}._3mYGaiL2Xx0TG6tUJy0rza>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{top:12px}.pjPt2FJwOJvyK1IlE46Lk>._1A_EJCOyAkSZ2iCc8A8Qma>._3bzbe_mQmFyJrPgOzjznuh{bottom:12px}._3w5wtC0PChZZogn9swm6l1{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block}._3udBCulYVKcs_qzVPYiNrJ{position:relative;width:100%;font-size:14px}._1BKV9qapPISM5xR9yjcHgv._3udBCulYVKcs_qzVPYiNrJ,._1BKV9qapPISM5xR9yjcHgv._3udBCulYVKcs_qzVPYiNrJ ._2-UkkxSbNnMY0-bIe_gURD ._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:12px}._3g3VOyyEg6hdcWm4mGsL29{display:inline-block;width:100%;margin-right:0;padding-right:0}._2wTS40XyzPhP5pd9DE0MHj ._3g3VOyyEg6hdcWm4mGsL29{margin-right:calc(-2em - 8px);padding-right:calc(2em + 8px)}._2_fybYL-yYnObzD1380t3g{position:relative;display:inline-block;width:100%;overflow:hidden;vertical-align:middle;background-color:#f5f5f5;border-radius:100px}._1GUTuct-d-6oaj0Ng0R28d{stroke:#f5f5f5}._1jM0mqVLZjh3tNU8E3snKw{animation:_3Dl7zlGAfdtWqrRkjGuEP2 .3s}._2_fybYL-yYnObzD1380t3g:not(._30mg-oF7kagP1eTQE6m7C2) ._1jM0mqVLZjh3tNU8E3snKw{stroke:#1890ff}._2IaWZSWto47_bgy5ZugQXO,.Ntsgfz0DkZEfl34WrSJMO{position:relative;background-color:#1890ff;border-radius:100px;transition:all .4s cubic-bezier(.08,.82,.17,1) 0s}.Ntsgfz0DkZEfl34WrSJMO{position:absolute;top:0;left:0;background-color:#52c41a}._2-UkkxSbNnMY0-bIe_gURD{display:inline-block;width:2em;margin-left:8px;color:rgba(0,0,0,.45);font-size:1em;line-height:1;white-space:nowrap;text-align:left;vertical-align:middle;word-break:normal}._2-UkkxSbNnMY0-bIe_gURD ._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:14px}._39OToP2gXtOplKkaHE2WQK ._2IaWZSWto47_bgy5ZugQXO:before{position:absolute;top:0;right:0;bottom:0;left:0;background:#fff;border-radius:10px;opacity:0;animation:_13OtZx-xjG14riuQxYKQGM 2.4s cubic-bezier(.23,1,.32,1) infinite;content:\"\"}._3eZjCzSyvFT-FtHdCPInqT ._2IaWZSWto47_bgy5ZugQXO{background-color:#f5222d}._3eZjCzSyvFT-FtHdCPInqT ._2-UkkxSbNnMY0-bIe_gURD{color:#f5222d}._3eZjCzSyvFT-FtHdCPInqT ._2_fybYL-yYnObzD1380t3g:not(._30mg-oF7kagP1eTQE6m7C2) ._1jM0mqVLZjh3tNU8E3snKw{stroke:#f5222d}.PfuP7W7BvMc1E3HAqwzkH ._2IaWZSWto47_bgy5ZugQXO{background-color:#52c41a}.PfuP7W7BvMc1E3HAqwzkH ._2-UkkxSbNnMY0-bIe_gURD{color:#52c41a}.PfuP7W7BvMc1E3HAqwzkH ._2_fybYL-yYnObzD1380t3g:not(._30mg-oF7kagP1eTQE6m7C2) ._1jM0mqVLZjh3tNU8E3snKw{stroke:#52c41a}._2PM1uH2Ls4GnMtHZDRzuLk ._2_fybYL-yYnObzD1380t3g{position:relative;line-height:1;background-color:transparent}._2PM1uH2Ls4GnMtHZDRzuLk ._2-UkkxSbNnMY0-bIe_gURD{position:absolute;top:50%;left:50%;width:100%;margin:0;padding:0;color:rgba(0,0,0,.65);line-height:1;white-space:normal;text-align:center;transform:translate(-50%,-50%)}._2PM1uH2Ls4GnMtHZDRzuLk ._2-UkkxSbNnMY0-bIe_gURD ._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:1.16666667em}._2PM1uH2Ls4GnMtHZDRzuLk._3eZjCzSyvFT-FtHdCPInqT ._2-UkkxSbNnMY0-bIe_gURD{color:#f5222d}._2PM1uH2Ls4GnMtHZDRzuLk.PfuP7W7BvMc1E3HAqwzkH ._2-UkkxSbNnMY0-bIe_gURD{color:#52c41a}@keyframes _13OtZx-xjG14riuQxYKQGM{0%{width:0;opacity:.1}20%{width:0;opacity:.5}to{width:100%;opacity:0}}._2i2R5hIDU65oDk1FwBeHf6{box-sizing:border-box;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;font-feature-settings:\"tnum\";display:inline-block;margin:0;padding:0;color:#fadb14;font-size:20px;line-height:unset;list-style:none;outline:none}._1cWhRdR90AnwONPHTmkr__ ._34Yus69sfgU1e8LztdGdwL{cursor:default}._1cWhRdR90AnwONPHTmkr__ ._34Yus69sfgU1e8LztdGdwL:hover{transform:scale(1)}._34Yus69sfgU1e8LztdGdwL{position:relative;display:inline-block;margin:0;padding:0;color:inherit;cursor:pointer;transition:all .3s}._34Yus69sfgU1e8LztdGdwL:not(:last-child){margin-right:8px}._34Yus69sfgU1e8LztdGdwL>div:focus{outline:0}._34Yus69sfgU1e8LztdGdwL>div:focus,._34Yus69sfgU1e8LztdGdwL>div:hover{transform:scale(1.1)}._1hFYKuanEi7Z1DOBExW2WQ,.aRTrvsDIYKUROTLFPZxuo{color:#e8e8e8;transition:all .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1hFYKuanEi7Z1DOBExW2WQ ._1oZ8xlpZEg3PzGp2jMNFuZ,.aRTrvsDIYKUROTLFPZxuo ._1oZ8xlpZEg3PzGp2jMNFuZ{vertical-align:middle}.aRTrvsDIYKUROTLFPZxuo{position:absolute;top:0;left:0;width:50%;height:100%;overflow:hidden;opacity:0}._19xuWaPRwgxPXRn4St6UzU ._1hFYKuanEi7Z1DOBExW2WQ,._19xuWaPRwgxPXRn4St6UzU .aRTrvsDIYKUROTLFPZxuo{opacity:1}._2txTEosl9BLdoqwwMGbOBi ._1hFYKuanEi7Z1DOBExW2WQ,._19xuWaPRwgxPXRn4St6UzU .aRTrvsDIYKUROTLFPZxuo{color:inherit}._1OD_KAA3sn6jmWD2OsQSKI{display:inline-block;margin-left:8px;font-size:14px}._1eoE8PWO1u4nsGAq_4FQ6H{padding:48px 32px}.Rhwlb9uD_t3gI65DatGzQ ._2FYX9RMnc2SG4KVq0-wXf0>._1oZ8xlpZEg3PzGp2jMNFuZ{color:#52c41a}._1neiGZcoU--iRmzEJ2e_9t ._2FYX9RMnc2SG4KVq0-wXf0>._1oZ8xlpZEg3PzGp2jMNFuZ{color:#f5222d}._3pAMmZ1E-gpX5mDSfS8MrP ._2FYX9RMnc2SG4KVq0-wXf0>._1oZ8xlpZEg3PzGp2jMNFuZ{color:#1890ff}.Gg9MMYmXFh-FxVpdHS6pJ ._2FYX9RMnc2SG4KVq0-wXf0>._1oZ8xlpZEg3PzGp2jMNFuZ{color:#faad14}.Ik3OHAGcpWLuA8qXWSmRQ{width:250px;height:295px;margin:auto}._2FYX9RMnc2SG4KVq0-wXf0{margin-bottom:24px;text-align:center}._2FYX9RMnc2SG4KVq0-wXf0>._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:72px}._2WGk7FrTiu1GmoBcHyK7-m{color:rgba(0,0,0,.85);font-size:24px;line-height:1.8;text-align:center}._2_xu9YqrKXdvxnWt-24P{color:rgba(0,0,0,.45);font-size:14px;line-height:1.6;text-align:center}._2YGV77FQffQytGGv02V6l9{margin-top:32px;text-align:center}._2YGV77FQffQytGGv02V6l9>*{margin-right:8px}._2YGV77FQffQytGGv02V6l9>:last-child{margin-right:0}.SoE_1PU_ssklusu2w8Tl-{margin-top:24px;padding:24px 40px;background-color:#fafafa}._3HQ3JBhC0OBnyb9CAwAl3g{display:table;width:100%}._1dAcBsQih_2waerw8wygOH{display:table-cell;padding-right:16px;vertical-align:top}._1dAcBsQih_2waerw8wygOH ._3ta1j9ZIvJml62hAjhIRrM{display:inline-block;vertical-align:top;background:#f2f2f2;width:32px;height:32px;line-height:32px}._1dAcBsQih_2waerw8wygOH ._3ta1j9ZIvJml62hAjhIRrM._316gP1-0tbLf1_XWQ9tx3W{border-radius:50%}._1dAcBsQih_2waerw8wygOH ._1To7HbWzxtV7mA1FgDPdZY{width:40px;height:40px;line-height:40px}._1dAcBsQih_2waerw8wygOH ._1To7HbWzxtV7mA1FgDPdZY._316gP1-0tbLf1_XWQ9tx3W{border-radius:50%}._1dAcBsQih_2waerw8wygOH .gB-1kKtb3YzaSBCU-8cQE{width:24px;height:24px;line-height:24px}._1dAcBsQih_2waerw8wygOH .gB-1kKtb3YzaSBCU-8cQE._316gP1-0tbLf1_XWQ9tx3W{border-radius:50%}._3h0mtMHELSiUkNj4cArJsE{display:table-cell;width:100%;vertical-align:top}._3h0mtMHELSiUkNj4cArJsE ._1I15yHBQcZZObXJxb2awMV{width:100%;height:16px;margin-top:16px;background:#f2f2f2}._3h0mtMHELSiUkNj4cArJsE ._1I15yHBQcZZObXJxb2awMV+._1T0v3Yt0YL1n3J9nVDSd5m{margin-top:24px}._3h0mtMHELSiUkNj4cArJsE ._1T0v3Yt0YL1n3J9nVDSd5m{padding:0}._3h0mtMHELSiUkNj4cArJsE ._1T0v3Yt0YL1n3J9nVDSd5m>li{width:100%;height:16px;list-style:none;background:#f2f2f2}._3h0mtMHELSiUkNj4cArJsE ._1T0v3Yt0YL1n3J9nVDSd5m>li:last-child:not(:first-child):not(:nth-child(2)){width:61%}._3h0mtMHELSiUkNj4cArJsE ._1T0v3Yt0YL1n3J9nVDSd5m>li+li{margin-top:16px}._29qBguLwjL8d9RiNazgkKG ._3h0mtMHELSiUkNj4cArJsE ._1I15yHBQcZZObXJxb2awMV{margin-top:12px}._29qBguLwjL8d9RiNazgkKG ._3h0mtMHELSiUkNj4cArJsE ._1I15yHBQcZZObXJxb2awMV+._1T0v3Yt0YL1n3J9nVDSd5m{margin-top:28px}._3HQ3JBhC0OBnyb9CAwAl3g._1duZR-Xs3jzRdB4iRYjnBg ._3h0mtMHELSiUkNj4cArJsE ._1I15yHBQcZZObXJxb2awMV,._3HQ3JBhC0OBnyb9CAwAl3g._1duZR-Xs3jzRdB4iRYjnBg ._3h0mtMHELSiUkNj4cArJsE ._1T0v3Yt0YL1n3J9nVDSd5m>li,._3HQ3JBhC0OBnyb9CAwAl3g._1duZR-Xs3jzRdB4iRYjnBg ._3ta1j9ZIvJml62hAjhIRrM{background:linear-gradient(90deg,#f2f2f2 25%,#e6e6e6 37%,#f2f2f2 63%);background-size:400% 100%;animation:_3Dt8mAs4hHJ0bzGnnwKHVf 1.4s ease infinite}@keyframes _3Dt8mAs4hHJ0bzGnnwKHVf{0%{background-position:100% 50%}to{background-position:0 50%}}._1CP7AY13ECSlGnipOQMtY0{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;height:12px;margin:14px 6px 10px;padding:4px 0;cursor:pointer;-ms-touch-action:none;touch-action:none}._9ukxJBAKXBGxa72nde9sn{width:12px;height:100%;margin:6px 10px;padding:0 4px}._9ukxJBAKXBGxa72nde9sn ._2keyBuA2Fe32w37BR9t3K8{width:4px;height:100%}._9ukxJBAKXBGxa72nde9sn ._2RaKKcsLOazEUtjjqhisnJ{width:4px}._9ukxJBAKXBGxa72nde9sn ._1EdBOLyUd8XpAH9MyAK_Hz{margin-bottom:-7px;margin-left:-5px}._9ukxJBAKXBGxa72nde9sn ._1Q5ri8KJaldwL9VxOkkhm_{top:0;left:12px;width:18px;height:100%}._9ukxJBAKXBGxa72nde9sn .Otnej03Hk2Ciz5Voc4Ryd{left:4px;white-space:nowrap}._9ukxJBAKXBGxa72nde9sn ._3s_fLyVrb-sAW2NAOIzn5S{width:4px;height:100%}._9ukxJBAKXBGxa72nde9sn .nphWWTF3-xs_JY1RGp6ZR{top:auto;left:2px;margin-bottom:-4px}._2vF7gIMZQltuMBlHhNAXJt ._1TIARwNdoA8WneqfND7f4Z{min-width:unset}.VbuAB8eCXfk8CqqAVni7Z{margin-bottom:28px}._2keyBuA2Fe32w37BR9t3K8{width:100%;background-color:#f5f5f5;border-radius:2px}._2keyBuA2Fe32w37BR9t3K8,._2RaKKcsLOazEUtjjqhisnJ{position:absolute;height:4px;transition:background-color .3s}._2RaKKcsLOazEUtjjqhisnJ{background-color:#91d5ff;border-radius:4px}._1EdBOLyUd8XpAH9MyAK_Hz{position:absolute;width:14px;height:14px;margin-top:-5px;background-color:#fff;border:2px solid #91d5ff;border-radius:50%;box-shadow:0;cursor:pointer;transition:border-color .3s,box-shadow .6s,transform .3s cubic-bezier(.18,.89,.32,1.28)}._1EdBOLyUd8XpAH9MyAK_Hz:focus{border-color:#46a6ff;outline:none;box-shadow:0 0 0 5px rgba(24,144,255,.2)}._1EdBOLyUd8XpAH9MyAK_Hz.wwpH4wfCxUeycMLj9beRw{border-color:#1890ff}._1CP7AY13ECSlGnipOQMtY0:hover ._2keyBuA2Fe32w37BR9t3K8{background-color:#e1e1e1}._1CP7AY13ECSlGnipOQMtY0:hover ._2RaKKcsLOazEUtjjqhisnJ{background-color:#69c0ff}._1CP7AY13ECSlGnipOQMtY0:hover ._1EdBOLyUd8XpAH9MyAK_Hz:not(.wwpH4wfCxUeycMLj9beRw){border-color:#69c0ff}._1Q5ri8KJaldwL9VxOkkhm_{position:absolute;top:14px;left:0;width:100%;font-size:14px}.Otnej03Hk2Ciz5Voc4Ryd{position:absolute;display:inline-block;color:rgba(0,0,0,.45);text-align:center;word-break:keep-all;cursor:pointer}._23FO7x1ktKyt0bqcgppHS9{color:rgba(0,0,0,.65)}._3s_fLyVrb-sAW2NAOIzn5S{position:absolute;width:100%;height:4px;background:transparent}.nphWWTF3-xs_JY1RGp6ZR{position:absolute;top:-2px;width:8px;height:8px;margin-left:-4px;background-color:#fff;border:2px solid #e8e8e8;border-radius:50%;cursor:pointer}.nphWWTF3-xs_JY1RGp6ZR:first-child,.nphWWTF3-xs_JY1RGp6ZR:last-child{margin-left:-4px}.Rpo-lEvxCy_W8E-znRsje{border-color:#8cc8ff}._1OuIMoFkbcdLp-f8OkaPQf{cursor:not-allowed}._1OuIMoFkbcdLp-f8OkaPQf ._2RaKKcsLOazEUtjjqhisnJ{background-color:rgba(0,0,0,.25)!important}._1OuIMoFkbcdLp-f8OkaPQf ._1EdBOLyUd8XpAH9MyAK_Hz,._1OuIMoFkbcdLp-f8OkaPQf .nphWWTF3-xs_JY1RGp6ZR{background-color:#fff;border-color:rgba(0,0,0,.25)!important;box-shadow:none;cursor:not-allowed}._1OuIMoFkbcdLp-f8OkaPQf .nphWWTF3-xs_JY1RGp6ZR,._1OuIMoFkbcdLp-f8OkaPQf .Otnej03Hk2Ciz5Voc4Ryd{cursor:not-allowed!important}._2giqNZExqH02sZP4SvShI6{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\"}.GLJpgr-8FqrVkvERjfQ_M{margin-bottom:4px;color:rgba(0,0,0,.45);font-size:14px}.s_EN8exKS9slhRiaxuev8{color:rgba(0,0,0,.85);font-size:24px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif}._24uVf19-H5EWbcMeGlVz6Q{font-size:16px}._2pe5B2VpHR4CzdGChl0gmV,.RdmNasdgHosQpyjur0rhp{display:inline-block}._2pe5B2VpHR4CzdGChl0gmV{margin-right:4px}.RdmNasdgHosQpyjur0rhp{margin-left:4px;font-size:16px}._2L2cvCH6JVON1pHloAxKOI{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:-ms-flexbox;display:flex;width:100%;font-size:0}._2yUz9uwXscGXcXq4V9tv5l{position:relative;display:inline-block;-ms-flex:1;flex:1;overflow:hidden;vertical-align:top}._3AlG4S7I4Mo7-_1R7Hj-68{outline:none}._2yUz9uwXscGXcXq4V9tv5l:last-child{-ms-flex:none;flex:none}._2yUz9uwXscGXcXq4V9tv5l:last-child>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw,._2yUz9uwXscGXcXq4V9tv5l:last-child>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR:after{display:none}._2keld22DNQ9RkxuNtDvjA1,._2324iDCEK6-6Db_LSuAip-{display:inline-block;vertical-align:top}._2keld22DNQ9RkxuNtDvjA1{width:32px;height:32px;margin-right:8px;font-size:16px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;line-height:32px;text-align:center;border:1px solid rgba(0,0,0,.25);border-radius:32px;transition:background-color .3s,border-color .3s}._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{position:relative;top:-1px;color:#1890ff;line-height:1}._1SNFtAG0gYWa6PR6KVrWfw{position:absolute;top:12px;left:0;width:100%;padding:0 10px}._1SNFtAG0gYWa6PR6KVrWfw:after{display:inline-block;width:100%;height:1px;background:#e8e8e8;border-radius:1px;transition:background .3s;content:\"\"}.aHzWEfLdEJiRzZ3HA64LR{position:relative;display:inline-block;padding-right:16px;color:rgba(0,0,0,.65);font-size:16px;line-height:32px}.aHzWEfLdEJiRzZ3HA64LR:after{position:absolute;top:16px;left:100%;display:block;width:9999px;height:1px;background:#e8e8e8;content:\"\"}.JUoukhAFUYmU5rA8FbdCd{display:inline;margin-left:8px;font-weight:400}._1Vchy2iuKVsBMsFJYD7hBZ,.JUoukhAFUYmU5rA8FbdCd{color:rgba(0,0,0,.45);font-size:14px}._1oBr-J_8unoNyu4Z5iJXNJ ._2keld22DNQ9RkxuNtDvjA1{background-color:#fff;border-color:rgba(0,0,0,.25)}._1oBr-J_8unoNyu4Z5iJXNJ ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{color:rgba(0,0,0,.25)}._1oBr-J_8unoNyu4Z5iJXNJ ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e ._3Ynjx7jKvq_YigobU0tOB9{background:rgba(0,0,0,.25)}._1oBr-J_8unoNyu4Z5iJXNJ>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR{color:rgba(0,0,0,.45)}._1oBr-J_8unoNyu4Z5iJXNJ>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR:after{background-color:#e8e8e8}._1oBr-J_8unoNyu4Z5iJXNJ>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->._1Vchy2iuKVsBMsFJYD7hBZ{color:rgba(0,0,0,.45)}._1oBr-J_8unoNyu4Z5iJXNJ>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw:after{background-color:#e8e8e8}._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1{background-color:#fff;border-color:#1890ff}._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{color:#1890ff}._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e ._3Ynjx7jKvq_YigobU0tOB9{background:#1890ff}._3H1_KHqzsj2cByqp-WammA>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR{color:rgba(0,0,0,.85)}._3H1_KHqzsj2cByqp-WammA>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR:after{background-color:#e8e8e8}._3H1_KHqzsj2cByqp-WammA>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->._1Vchy2iuKVsBMsFJYD7hBZ{color:rgba(0,0,0,.65)}._3H1_KHqzsj2cByqp-WammA>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw:after{background-color:#e8e8e8}._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1{background:#1890ff}._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{color:#fff}._3H1_KHqzsj2cByqp-WammA .aHzWEfLdEJiRzZ3HA64LR{font-weight:500}._30G1Hjs6h8i-MMdZx2MiEU ._2keld22DNQ9RkxuNtDvjA1{background-color:#fff;border-color:#1890ff}._30G1Hjs6h8i-MMdZx2MiEU ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{color:#1890ff}._30G1Hjs6h8i-MMdZx2MiEU ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e ._3Ynjx7jKvq_YigobU0tOB9{background:#1890ff}._30G1Hjs6h8i-MMdZx2MiEU>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR{color:rgba(0,0,0,.65)}._30G1Hjs6h8i-MMdZx2MiEU>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR:after{background-color:#1890ff}._30G1Hjs6h8i-MMdZx2MiEU>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->._1Vchy2iuKVsBMsFJYD7hBZ{color:rgba(0,0,0,.45)}._30G1Hjs6h8i-MMdZx2MiEU>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw:after{background-color:#1890ff}._3_G_r82yHfyAl71GbRMRya ._2keld22DNQ9RkxuNtDvjA1{background-color:#fff;border-color:#f5222d}._3_G_r82yHfyAl71GbRMRya ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{color:#f5222d}._3_G_r82yHfyAl71GbRMRya ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e ._3Ynjx7jKvq_YigobU0tOB9{background:#f5222d}._3_G_r82yHfyAl71GbRMRya>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR{color:#f5222d}._3_G_r82yHfyAl71GbRMRya>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR:after{background-color:#e8e8e8}._3_G_r82yHfyAl71GbRMRya>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->._1Vchy2iuKVsBMsFJYD7hBZ{color:#f5222d}._3_G_r82yHfyAl71GbRMRya>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw:after{background-color:#e8e8e8}._2yUz9uwXscGXcXq4V9tv5l._1KgVtEyduxqc_LV4x_38hr .aHzWEfLdEJiRzZ3HA64LR:after{background:#f5222d}._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button]{cursor:pointer}._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button] ._1Vchy2iuKVsBMsFJYD7hBZ,._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button] ._2keld22DNQ9RkxuNtDvjA1 ._3_IstjjgGVFB4to2J7iV6e,._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button] .aHzWEfLdEJiRzZ3HA64LR{transition:color .3s}._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button]:hover ._1Vchy2iuKVsBMsFJYD7hBZ,._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button]:hover .aHzWEfLdEJiRzZ3HA64LR,._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button]:hover .JUoukhAFUYmU5rA8FbdCd{color:#1890ff}._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA):not(._3H1_KHqzsj2cByqp-WammA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button]:hover ._2keld22DNQ9RkxuNtDvjA1{border-color:#1890ff}._2L2cvCH6JVON1pHloAxKOI ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA):not(._3H1_KHqzsj2cByqp-WammA)>._3AlG4S7I4Mo7-_1R7Hj-68[role=button]:hover ._2keld22DNQ9RkxuNtDvjA1 ._3_IstjjgGVFB4to2J7iV6e{color:#1890ff}.zm6Psfz4NJIs1NdwXRIpf:not(.fatIBfFS9XQKIKhBvFYWk) ._2yUz9uwXscGXcXq4V9tv5l{margin-right:16px;white-space:nowrap}.zm6Psfz4NJIs1NdwXRIpf:not(.fatIBfFS9XQKIKhBvFYWk) ._2yUz9uwXscGXcXq4V9tv5l:last-child{margin-right:0}.zm6Psfz4NJIs1NdwXRIpf:not(.fatIBfFS9XQKIKhBvFYWk) ._2yUz9uwXscGXcXq4V9tv5l:last-child .aHzWEfLdEJiRzZ3HA64LR{padding-right:0}.zm6Psfz4NJIs1NdwXRIpf:not(.fatIBfFS9XQKIKhBvFYWk) ._1SNFtAG0gYWa6PR6KVrWfw{display:none}.zm6Psfz4NJIs1NdwXRIpf:not(.fatIBfFS9XQKIKhBvFYWk) ._1Vchy2iuKVsBMsFJYD7hBZ{max-width:140px;white-space:normal}._3zYFdczDVUT2TJlHut1JYK ._2keld22DNQ9RkxuNtDvjA1{height:auto;background:none;border:0}._3zYFdczDVUT2TJlHut1JYK ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{top:0;left:.5px;width:32px;height:32px;font-size:24px;line-height:32px}._3zYFdczDVUT2TJlHut1JYK._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{color:#1890ff}._2L2cvCH6JVON1pHloAxKOI:not(._1k2gLjgA8u6eymax97uC69) ._3zYFdczDVUT2TJlHut1JYK ._2keld22DNQ9RkxuNtDvjA1{width:auto}._2y_Y74qNPWlEAs5huqTJbS.zm6Psfz4NJIs1NdwXRIpf:not(.fatIBfFS9XQKIKhBvFYWk) ._2yUz9uwXscGXcXq4V9tv5l{margin-right:12px}._2y_Y74qNPWlEAs5huqTJbS.zm6Psfz4NJIs1NdwXRIpf:not(.fatIBfFS9XQKIKhBvFYWk) ._2yUz9uwXscGXcXq4V9tv5l:last-child{margin-right:0}._2y_Y74qNPWlEAs5huqTJbS ._2keld22DNQ9RkxuNtDvjA1{width:24px;height:24px;font-size:12px;line-height:24px;text-align:center;border-radius:24px}._2y_Y74qNPWlEAs5huqTJbS .aHzWEfLdEJiRzZ3HA64LR{padding-right:12px;font-size:14px;line-height:24px}._2y_Y74qNPWlEAs5huqTJbS .aHzWEfLdEJiRzZ3HA64LR:after{top:12px}._2y_Y74qNPWlEAs5huqTJbS ._1Vchy2iuKVsBMsFJYD7hBZ{color:rgba(0,0,0,.45);font-size:14px}._2y_Y74qNPWlEAs5huqTJbS ._1SNFtAG0gYWa6PR6KVrWfw{top:8px}._2y_Y74qNPWlEAs5huqTJbS ._3zYFdczDVUT2TJlHut1JYK ._2keld22DNQ9RkxuNtDvjA1{width:inherit;height:inherit;line-height:inherit;background:none;border:0;border-radius:0}._2y_Y74qNPWlEAs5huqTJbS ._3zYFdczDVUT2TJlHut1JYK ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e{font-size:24px;line-height:24px;transform:none}._1k2gLjgA8u6eymax97uC69{display:block}._1k2gLjgA8u6eymax97uC69 ._2yUz9uwXscGXcXq4V9tv5l{display:block;overflow:visible}._1k2gLjgA8u6eymax97uC69 ._2keld22DNQ9RkxuNtDvjA1{float:left;margin-right:16px}._1k2gLjgA8u6eymax97uC69 ._2324iDCEK6-6Db_LSuAip-{display:block;min-height:48px;overflow:hidden}._1k2gLjgA8u6eymax97uC69 .aHzWEfLdEJiRzZ3HA64LR{line-height:32px}._1k2gLjgA8u6eymax97uC69 ._1Vchy2iuKVsBMsFJYD7hBZ{padding-bottom:12px}._1k2gLjgA8u6eymax97uC69>._2yUz9uwXscGXcXq4V9tv5l>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw{position:absolute;top:0;left:16px;width:1px;height:100%;padding:38px 0 6px}._1k2gLjgA8u6eymax97uC69>._2yUz9uwXscGXcXq4V9tv5l>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw:after{width:1px;height:100%}._1k2gLjgA8u6eymax97uC69>._2yUz9uwXscGXcXq4V9tv5l:not(:last-child)>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw{display:block}._1k2gLjgA8u6eymax97uC69>._2yUz9uwXscGXcXq4V9tv5l>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR:after{display:none}._1k2gLjgA8u6eymax97uC69._2y_Y74qNPWlEAs5huqTJbS ._3AlG4S7I4Mo7-_1R7Hj-68 ._1SNFtAG0gYWa6PR6KVrWfw{position:absolute;top:0;left:12px;padding:30px 0 6px}._1k2gLjgA8u6eymax97uC69._2y_Y74qNPWlEAs5huqTJbS ._3AlG4S7I4Mo7-_1R7Hj-68 .aHzWEfLdEJiRzZ3HA64LR{line-height:24px}@media (max-width:480px){.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U{display:block}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U ._2yUz9uwXscGXcXq4V9tv5l{display:block;overflow:visible}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U ._2keld22DNQ9RkxuNtDvjA1{float:left;margin-right:16px}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U ._2324iDCEK6-6Db_LSuAip-{display:block;min-height:48px;overflow:hidden}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U .aHzWEfLdEJiRzZ3HA64LR{line-height:32px}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U ._1Vchy2iuKVsBMsFJYD7hBZ{padding-bottom:12px}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U>._2yUz9uwXscGXcXq4V9tv5l>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw{position:absolute;top:0;left:16px;width:1px;height:100%;padding:38px 0 6px}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U>._2yUz9uwXscGXcXq4V9tv5l>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw:after{width:1px;height:100%}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U>._2yUz9uwXscGXcXq4V9tv5l:not(:last-child)>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw{display:block}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U>._2yUz9uwXscGXcXq4V9tv5l>._3AlG4S7I4Mo7-_1R7Hj-68>._2324iDCEK6-6Db_LSuAip->.aHzWEfLdEJiRzZ3HA64LR:after{display:none}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U._2y_Y74qNPWlEAs5huqTJbS ._3AlG4S7I4Mo7-_1R7Hj-68 ._1SNFtAG0gYWa6PR6KVrWfw{position:absolute;top:0;left:12px;padding:30px 0 6px}.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U._2y_Y74qNPWlEAs5huqTJbS ._3AlG4S7I4Mo7-_1R7Hj-68 .aHzWEfLdEJiRzZ3HA64LR{line-height:24px}}.fatIBfFS9XQKIKhBvFYWk ._2yUz9uwXscGXcXq4V9tv5l{overflow:visible}.fatIBfFS9XQKIKhBvFYWk ._1SNFtAG0gYWa6PR6KVrWfw{margin-left:58px;padding:3.5px 24px}.fatIBfFS9XQKIKhBvFYWk ._2324iDCEK6-6Db_LSuAip-{display:block;width:116px;margin-top:8px;text-align:center}.fatIBfFS9XQKIKhBvFYWk ._2keld22DNQ9RkxuNtDvjA1{display:inline-block;margin-left:42px}.fatIBfFS9XQKIKhBvFYWk .aHzWEfLdEJiRzZ3HA64LR{padding-right:0}.fatIBfFS9XQKIKhBvFYWk .aHzWEfLdEJiRzZ3HA64LR:after{display:none}.fatIBfFS9XQKIKhBvFYWk .JUoukhAFUYmU5rA8FbdCd{display:block;margin-bottom:4px;margin-left:0;line-height:1.5}.fatIBfFS9XQKIKhBvFYWk._2y_Y74qNPWlEAs5huqTJbS:not(.I3OtXp51S1ui1Y3fOpUrC) ._2keld22DNQ9RkxuNtDvjA1{margin-left:46px}.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS .aHzWEfLdEJiRzZ3HA64LR,.I3OtXp51S1ui1Y3fOpUrC .aHzWEfLdEJiRzZ3HA64LR{line-height:1.5}.I3OtXp51S1ui1Y3fOpUrC ._1SNFtAG0gYWa6PR6KVrWfw,.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._1SNFtAG0gYWa6PR6KVrWfw{top:2px;width:100%;margin:0 0 0 70px;padding:0}.I3OtXp51S1ui1Y3fOpUrC ._1SNFtAG0gYWa6PR6KVrWfw:after,.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._1SNFtAG0gYWa6PR6KVrWfw:after{width:calc(100% - 20px);height:3px;margin-left:12px}.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._2yUz9uwXscGXcXq4V9tv5l:first-child ._3Ynjx7jKvq_YigobU0tOB9,.I3OtXp51S1ui1Y3fOpUrC ._2yUz9uwXscGXcXq4V9tv5l:first-child ._3Ynjx7jKvq_YigobU0tOB9{left:2px}.I3OtXp51S1ui1Y3fOpUrC ._2keld22DNQ9RkxuNtDvjA1,.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._2keld22DNQ9RkxuNtDvjA1{width:8px;height:8px;margin-left:67px;padding-right:0;line-height:8px;background:transparent;border:0}.I3OtXp51S1ui1Y3fOpUrC ._2keld22DNQ9RkxuNtDvjA1 ._3Ynjx7jKvq_YigobU0tOB9,.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._2keld22DNQ9RkxuNtDvjA1 ._3Ynjx7jKvq_YigobU0tOB9{position:relative;float:left;width:100%;height:100%;border-radius:100px;transition:all .3s}.I3OtXp51S1ui1Y3fOpUrC ._2keld22DNQ9RkxuNtDvjA1 ._3Ynjx7jKvq_YigobU0tOB9:after,.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._2keld22DNQ9RkxuNtDvjA1 ._3Ynjx7jKvq_YigobU0tOB9:after{position:absolute;top:-12px;left:-26px;width:60px;height:32px;background:rgba(0,0,0,.001);content:\"\"}.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._2324iDCEK6-6Db_LSuAip-,.I3OtXp51S1ui1Y3fOpUrC ._2324iDCEK6-6Db_LSuAip-{width:140px}.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1,.I3OtXp51S1ui1Y3fOpUrC ._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1{width:10px;height:10px;line-height:10px}.I3OtXp51S1ui1Y3fOpUrC._2y_Y74qNPWlEAs5huqTJbS ._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1 ._3Ynjx7jKvq_YigobU0tOB9,.I3OtXp51S1ui1Y3fOpUrC ._3H1_KHqzsj2cByqp-WammA ._2keld22DNQ9RkxuNtDvjA1 ._3Ynjx7jKvq_YigobU0tOB9{top:-1px}._1k2gLjgA8u6eymax97uC69.I3OtXp51S1ui1Y3fOpUrC ._2keld22DNQ9RkxuNtDvjA1{margin-top:8px;margin-left:0}._1k2gLjgA8u6eymax97uC69.I3OtXp51S1ui1Y3fOpUrC ._2yUz9uwXscGXcXq4V9tv5l>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw{top:2px;left:-9px;margin:0;padding:22px 0 4px}._1k2gLjgA8u6eymax97uC69.I3OtXp51S1ui1Y3fOpUrC ._2yUz9uwXscGXcXq4V9tv5l:first-child ._3Ynjx7jKvq_YigobU0tOB9{left:0}._1k2gLjgA8u6eymax97uC69.I3OtXp51S1ui1Y3fOpUrC ._3H1_KHqzsj2cByqp-WammA ._3Ynjx7jKvq_YigobU0tOB9{left:-2px}._37SgGMT6_90YwCDJYCs_oQ{padding-top:12px}._37SgGMT6_90YwCDJYCs_oQ._2y_Y74qNPWlEAs5huqTJbS ._3AlG4S7I4Mo7-_1R7Hj-68{margin-left:-12px}._37SgGMT6_90YwCDJYCs_oQ ._2yUz9uwXscGXcXq4V9tv5l{overflow:visible;text-align:center}._37SgGMT6_90YwCDJYCs_oQ ._3AlG4S7I4Mo7-_1R7Hj-68{display:inline-block;height:100%;margin-left:-16px;padding-bottom:12px;text-align:left;transition:opacity .3s}._37SgGMT6_90YwCDJYCs_oQ ._3AlG4S7I4Mo7-_1R7Hj-68 ._2324iDCEK6-6Db_LSuAip-{max-width:auto}._37SgGMT6_90YwCDJYCs_oQ ._3AlG4S7I4Mo7-_1R7Hj-68 .aHzWEfLdEJiRzZ3HA64LR{max-width:100%;padding-right:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._37SgGMT6_90YwCDJYCs_oQ ._3AlG4S7I4Mo7-_1R7Hj-68 .aHzWEfLdEJiRzZ3HA64LR:after{display:none}._37SgGMT6_90YwCDJYCs_oQ ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA) ._3AlG4S7I4Mo7-_1R7Hj-68[role=button]{cursor:pointer}._37SgGMT6_90YwCDJYCs_oQ ._2yUz9uwXscGXcXq4V9tv5l:not(.Iss2Ywm1jeH1arMOglEbA) ._3AlG4S7I4Mo7-_1R7Hj-68[role=button]:hover{opacity:.85}._37SgGMT6_90YwCDJYCs_oQ ._2yUz9uwXscGXcXq4V9tv5l:last-child{-ms-flex:1;flex:1}._37SgGMT6_90YwCDJYCs_oQ ._2yUz9uwXscGXcXq4V9tv5l:last-child:after{display:none}._37SgGMT6_90YwCDJYCs_oQ ._2yUz9uwXscGXcXq4V9tv5l:after{position:absolute;top:50%;left:100%;display:inline-block;width:12px;height:12px;margin-top:-14px;margin-left:-2px;border:1px solid rgba(0,0,0,.25);border-bottom:none;border-left:none;transform:rotate(45deg);content:\"\"}._37SgGMT6_90YwCDJYCs_oQ ._2yUz9uwXscGXcXq4V9tv5l:before{position:absolute;bottom:0;left:50%;display:inline-block;width:0;height:3px;background-color:#1890ff;transition:width .3s,left .3s;transition-timing-function:ease-out;content:\"\"}._37SgGMT6_90YwCDJYCs_oQ ._2yUz9uwXscGXcXq4V9tv5l.Iss2Ywm1jeH1arMOglEbA:before{left:0;width:100%}@media (max-width:480px){._37SgGMT6_90YwCDJYCs_oQ>._2yUz9uwXscGXcXq4V9tv5l{margin-right:0!important}._37SgGMT6_90YwCDJYCs_oQ>._2yUz9uwXscGXcXq4V9tv5l:before{display:none}._37SgGMT6_90YwCDJYCs_oQ>._2yUz9uwXscGXcXq4V9tv5l.Iss2Ywm1jeH1arMOglEbA:before{top:0;right:0;left:unset;display:block;width:3px;height:calc(100% - 24px)}._37SgGMT6_90YwCDJYCs_oQ>._2yUz9uwXscGXcXq4V9tv5l:after{position:relative;top:-2px;left:50%;display:block;width:8px;height:8px;margin-bottom:8px;text-align:center;transform:rotate(135deg)}._37SgGMT6_90YwCDJYCs_oQ>._2yUz9uwXscGXcXq4V9tv5l>._3AlG4S7I4Mo7-_1R7Hj-68>._1SNFtAG0gYWa6PR6KVrWfw{visibility:hidden}}._2CYFmxe-NgJb3DCvlLjMf3.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U ._2yUz9uwXscGXcXq4V9tv5l{margin-left:-16px;padding-left:16px;background:#fff}._2CYFmxe-NgJb3DCvlLjMf3.zm6Psfz4NJIs1NdwXRIpf._3sluPivUVp-ohutg6mZ23U._2y_Y74qNPWlEAs5huqTJbS ._2yUz9uwXscGXcXq4V9tv5l{margin-left:-12px;padding-left:12px}._2CYFmxe-NgJb3DCvlLjMf3.I3OtXp51S1ui1Y3fOpUrC ._2yUz9uwXscGXcXq4V9tv5l:last-child{overflow:hidden}._2CYFmxe-NgJb3DCvlLjMf3.I3OtXp51S1ui1Y3fOpUrC ._2yUz9uwXscGXcXq4V9tv5l:last-child ._3Ynjx7jKvq_YigobU0tOB9:after{right:-200px;width:200px}._2CYFmxe-NgJb3DCvlLjMf3.I3OtXp51S1ui1Y3fOpUrC ._2yUz9uwXscGXcXq4V9tv5l ._3Ynjx7jKvq_YigobU0tOB9:after,._2CYFmxe-NgJb3DCvlLjMf3.I3OtXp51S1ui1Y3fOpUrC ._2yUz9uwXscGXcXq4V9tv5l ._3Ynjx7jKvq_YigobU0tOB9:before{position:absolute;top:0;left:-10px;width:10px;height:8px;background:#fff;content:\"\"}._2CYFmxe-NgJb3DCvlLjMf3.I3OtXp51S1ui1Y3fOpUrC ._2yUz9uwXscGXcXq4V9tv5l ._3Ynjx7jKvq_YigobU0tOB9:after{right:-10px;left:auto}._2CYFmxe-NgJb3DCvlLjMf3.I3OtXp51S1ui1Y3fOpUrC ._1oBr-J_8unoNyu4Z5iJXNJ ._2keld22DNQ9RkxuNtDvjA1>._3_IstjjgGVFB4to2J7iV6e ._3Ynjx7jKvq_YigobU0tOB9{background:#ccc}._1pX4_L35Dl4y9IKf_tCLsc{margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;display:inline-block;box-sizing:border-box;min-width:44px;height:22px;line-height:20px;vertical-align:middle;background-color:rgba(0,0,0,.25);border:1px solid transparent;border-radius:100px;cursor:pointer;transition:all .36s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3_PpZ-epyVIPncn4JoEksq{display:block;margin-right:6px;margin-left:24px;color:#fff;font-size:12px}._1pX4_L35Dl4y9IKf_tCLsc:after,._1yraPfT_0AUP_86HRF-NNP{position:absolute;top:1px;left:1px;width:18px;height:18px;background-color:#fff;border-radius:18px;cursor:pointer;transition:all .36s cubic-bezier(.78,.14,.15,.86);content:\" \"}._1pX4_L35Dl4y9IKf_tCLsc:after{box-shadow:0 2px 4px 0 rgba(0,35,11,.2)}._1pX4_L35Dl4y9IKf_tCLsc:not(._1u1wf55QN92BIk61srtozj):active:after,._1pX4_L35Dl4y9IKf_tCLsc:not(._1u1wf55QN92BIk61srtozj):active:before{width:24px}._1yraPfT_0AUP_86HRF-NNP{z-index:1;display:none;font-size:12px;background:transparent}._1yraPfT_0AUP_86HRF-NNP svg{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}.WlxIpyr8JVbwDhXeFKdHT ._1yraPfT_0AUP_86HRF-NNP{display:inline-block;color:rgba(0,0,0,.65)}.fa4XVx62F9S9UpPl-D6Dc.WlxIpyr8JVbwDhXeFKdHT ._1yraPfT_0AUP_86HRF-NNP{color:#1890ff}._1pX4_L35Dl4y9IKf_tCLsc:focus{outline:0;box-shadow:0 0 0 2px rgba(24,144,255,.2)}._1pX4_L35Dl4y9IKf_tCLsc:focus:hover{box-shadow:none}._3KLc6JOOSYA0O2os3NTPcS{min-width:28px;height:16px;line-height:14px}._3KLc6JOOSYA0O2os3NTPcS ._3_PpZ-epyVIPncn4JoEksq{margin-right:3px;margin-left:18px;font-size:12px}._3KLc6JOOSYA0O2os3NTPcS:after{width:12px;height:12px}._3KLc6JOOSYA0O2os3NTPcS:active:after,._3KLc6JOOSYA0O2os3NTPcS:active:before{width:16px}._3KLc6JOOSYA0O2os3NTPcS ._1yraPfT_0AUP_86HRF-NNP{width:12px;height:12px}._3KLc6JOOSYA0O2os3NTPcS.fa4XVx62F9S9UpPl-D6Dc ._3_PpZ-epyVIPncn4JoEksq{margin-right:18px;margin-left:3px}._3KLc6JOOSYA0O2os3NTPcS.fa4XVx62F9S9UpPl-D6Dc ._1yraPfT_0AUP_86HRF-NNP{left:100%;margin-left:-13px}._3KLc6JOOSYA0O2os3NTPcS.WlxIpyr8JVbwDhXeFKdHT ._1yraPfT_0AUP_86HRF-NNP{font-weight:700;transform:scale(.66667)}.fa4XVx62F9S9UpPl-D6Dc{background-color:#1890ff}.fa4XVx62F9S9UpPl-D6Dc ._3_PpZ-epyVIPncn4JoEksq{margin-right:24px;margin-left:6px}.fa4XVx62F9S9UpPl-D6Dc:after{left:100%;margin-left:-1px;transform:translateX(-100%)}.fa4XVx62F9S9UpPl-D6Dc ._1yraPfT_0AUP_86HRF-NNP{left:100%;margin-left:-19px}._1u1wf55QN92BIk61srtozj,.WlxIpyr8JVbwDhXeFKdHT{cursor:not-allowed;opacity:.4}._1u1wf55QN92BIk61srtozj *,._1u1wf55QN92BIk61srtozj:after,._1u1wf55QN92BIk61srtozj:before,.WlxIpyr8JVbwDhXeFKdHT *,.WlxIpyr8JVbwDhXeFKdHT:after,.WlxIpyr8JVbwDhXeFKdHT:before{cursor:not-allowed}@keyframes _1w_XcQ53DxedQa8VVmd1Fn{0%{transform:rotate(0deg) scale(.66667);transform-origin:50% 50%}to{transform:rotate(1turn) scale(.66667);transform-origin:50% 50%}}._1jESgGkhSIqc1vmWhMSm9q{zoom:1}._1jESgGkhSIqc1vmWhMSm9q:after,._1jESgGkhSIqc1vmWhMSm9q:before{display:table;content:\"\"}._1jESgGkhSIqc1vmWhMSm9q:after{clear:both}._3fMJwK7ehwYMI9WXIBXx7X{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;clear:both}._2yk3lyMbLlaUj9C-xn8dVZ{transition:opacity .3s}._3vcHok5L3bZVcOpv9E6yPq ._2yk3lyMbLlaUj9C-xn8dVZ{overflow-x:auto!important;overflow-y:hidden!important}._3fMJwK7ehwYMI9WXIBXx7X table{width:100%;text-align:left;border-radius:4px 4px 0 0;border-collapse:separate;border-spacing:0}._37mrRhU-KQbuTzaUydopIU table{table-layout:fixed}._25fu2zl2d-vqIl8bRXTsAN>tr>th{color:rgba(0,0,0,.85);font-weight:500;text-align:left;background:#fafafa;border-bottom:1px solid #e8e8e8;transition:background .3s ease}._25fu2zl2d-vqIl8bRXTsAN>tr>th[colspan]:not([colspan=\"1\"]){text-align:center}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1p6NMMSYwyGneBGs6hp8-O,._25fu2zl2d-vqIl8bRXTsAN>tr>th ._2EsU8Ah1V8O9SsN7Q6J18d{position:absolute;top:0;right:0;width:28px;height:100%;color:#bfbfbf;font-size:12px;text-align:center;cursor:pointer;transition:all .3s}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1p6NMMSYwyGneBGs6hp8-O>svg,._25fu2zl2d-vqIl8bRXTsAN>tr>th ._2EsU8Ah1V8O9SsN7Q6J18d>svg{position:absolute;top:50%;left:50%;margin-top:-5px;margin-left:-6px}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1yUPePoZbVwROzRfsBUETi._1oZ8xlpZEg3PzGp2jMNFuZ{color:#1890ff}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE{display:table-cell;vertical-align:middle}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE ._1XetCbJ1zxFcv77mWeboZJ{height:1em;margin-top:.35em;margin-left:.57142857em;color:#bfbfbf;line-height:1em;text-align:center;transition:all .3s}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE ._1XetCbJ1zxFcv77mWeboZJ ._2WnIjlv_B_4_I5rDgEvzC1,._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE ._1XetCbJ1zxFcv77mWeboZJ ._3E4sCKCVLnX65b27d7-rBe{display:inline-block;font-size:12px;font-size:11px\\9;transform:scale(.91666667) rotate(0deg);display:block;height:1em;line-height:1em;transition:all .3s}:root ._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE ._1XetCbJ1zxFcv77mWeboZJ ._2WnIjlv_B_4_I5rDgEvzC1,:root ._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE ._1XetCbJ1zxFcv77mWeboZJ ._3E4sCKCVLnX65b27d7-rBe{font-size:12px}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE ._1XetCbJ1zxFcv77mWeboZJ ._2WnIjlv_B_4_I5rDgEvzC1.Mk7bkM_sMBRMn9CSDU4Bn,._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE ._1XetCbJ1zxFcv77mWeboZJ ._3E4sCKCVLnX65b27d7-rBe.Mk7bkM_sMBRMn9CSDU4Bn{color:#1890ff}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE .TmPbI49vnzTWGGcy-izIr{margin-top:-.15em}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE .TmPbI49vnzTWGGcy-izIr ._2WnIjlv_B_4_I5rDgEvzC1,._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE .TmPbI49vnzTWGGcy-izIr ._3E4sCKCVLnX65b27d7-rBe{height:.5em;line-height:.5em}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._1JpZNn9Uq8AT8ojgWuDiCE .TmPbI49vnzTWGGcy-izIr ._3E4sCKCVLnX65b27d7-rBe{margin-top:.125em}._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4{position:relative;background-clip:padding-box;-webkit-background-clip:border-box}._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._2TxxQME9gvW2W98cWJtnrT{padding-right:30px!important}._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._2TxxQME9gvW2W98cWJtnrT ._1p6NMMSYwyGneBGs6hp8-O._2EN_aCKMnhMmtd0nL5aRFa,._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._2TxxQME9gvW2W98cWJtnrT ._2EsU8Ah1V8O9SsN7Q6J18d._2EN_aCKMnhMmtd0nL5aRFa,._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._2TxxQME9gvW2W98cWJtnrT:hover ._1p6NMMSYwyGneBGs6hp8-O:hover,._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._2TxxQME9gvW2W98cWJtnrT:hover ._2EsU8Ah1V8O9SsN7Q6J18d:hover{color:rgba(0,0,0,.45);background:#e5e5e5}._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._2TxxQME9gvW2W98cWJtnrT:hover ._1p6NMMSYwyGneBGs6hp8-O:active,._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._2TxxQME9gvW2W98cWJtnrT:hover ._2EsU8Ah1V8O9SsN7Q6J18d:active{color:rgba(0,0,0,.65)}._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._31nAKmbfc57MbYE3EOkS8I{cursor:pointer}._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._31nAKmbfc57MbYE3EOkS8I:hover,._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._31nAKmbfc57MbYE3EOkS8I:hover ._1p6NMMSYwyGneBGs6hp8-O,._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._31nAKmbfc57MbYE3EOkS8I:hover ._2EsU8Ah1V8O9SsN7Q6J18d{background:#f2f2f2}._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._31nAKmbfc57MbYE3EOkS8I:active ._2WnIjlv_B_4_I5rDgEvzC1:not(.Mk7bkM_sMBRMn9CSDU4Bn),._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4._31nAKmbfc57MbYE3EOkS8I:active ._3E4sCKCVLnX65b27d7-rBe:not(.Mk7bkM_sMBRMn9CSDU4Bn){color:rgba(0,0,0,.45)}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._17sBt_6CxL2T7zSI4aTTcO{display:inline-block;max-width:100%;vertical-align:top}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._17sBt_6CxL2T7zSI4aTTcO .IOlVHnKzPF9Mfpp8XP1Qo{display:table}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._17sBt_6CxL2T7zSI4aTTcO .IOlVHnKzPF9Mfpp8XP1Qo>._1L3zBpLVITT7hebPdM26Aj{display:table-cell;vertical-align:middle}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._17sBt_6CxL2T7zSI4aTTcO .IOlVHnKzPF9Mfpp8XP1Qo>:not(._1JpZNn9Uq8AT8ojgWuDiCE){position:relative}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._17sBt_6CxL2T7zSI4aTTcO .IOlVHnKzPF9Mfpp8XP1Qo:before{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;transition:all .3s;content:\"\"}._25fu2zl2d-vqIl8bRXTsAN>tr>th ._17sBt_6CxL2T7zSI4aTTcO .IOlVHnKzPF9Mfpp8XP1Qo:hover:before{background:rgba(0,0,0,.04)}._25fu2zl2d-vqIl8bRXTsAN>tr>th._31nAKmbfc57MbYE3EOkS8I{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._25fu2zl2d-vqIl8bRXTsAN>tr:first-child>th:first-child{border-top-left-radius:4px}._25fu2zl2d-vqIl8bRXTsAN>tr:first-child>th:last-child{border-top-right-radius:4px}._25fu2zl2d-vqIl8bRXTsAN>tr:not(:last-child)>th[colspan]{border-bottom:0}._3aml4KBMk9yAckKTSLa9gm>tr>td{border-bottom:1px solid #e8e8e8;transition:all .3s,border 0s}._3aml4KBMk9yAckKTSLa9gm>tr,._25fu2zl2d-vqIl8bRXTsAN>tr{transition:all .3s,height 0s}._3aml4KBMk9yAckKTSLa9gm>tr._2J4fDUx2azDRG_z7A7rZL9:not(._13tu_i3IPv3UXt8sfp2hEG):not(._2jOFqVn9Kg1t10fk76vtUQ)>td,._3aml4KBMk9yAckKTSLa9gm>tr:hover:not(._13tu_i3IPv3UXt8sfp2hEG):not(._2jOFqVn9Kg1t10fk76vtUQ)>td,._25fu2zl2d-vqIl8bRXTsAN>tr._2J4fDUx2azDRG_z7A7rZL9:not(._13tu_i3IPv3UXt8sfp2hEG):not(._2jOFqVn9Kg1t10fk76vtUQ)>td,._25fu2zl2d-vqIl8bRXTsAN>tr:hover:not(._13tu_i3IPv3UXt8sfp2hEG):not(._2jOFqVn9Kg1t10fk76vtUQ)>td{background:#e6f7ff}._3aml4KBMk9yAckKTSLa9gm>tr._2jOFqVn9Kg1t10fk76vtUQ>td._3pB5jA3sM4dqd-uWWtNYKq,._3aml4KBMk9yAckKTSLa9gm>tr:hover._2jOFqVn9Kg1t10fk76vtUQ>td,._3aml4KBMk9yAckKTSLa9gm>tr:hover._2jOFqVn9Kg1t10fk76vtUQ>td._3pB5jA3sM4dqd-uWWtNYKq,._25fu2zl2d-vqIl8bRXTsAN>tr._2jOFqVn9Kg1t10fk76vtUQ>td._3pB5jA3sM4dqd-uWWtNYKq,._25fu2zl2d-vqIl8bRXTsAN>tr:hover._2jOFqVn9Kg1t10fk76vtUQ>td,._25fu2zl2d-vqIl8bRXTsAN>tr:hover._2jOFqVn9Kg1t10fk76vtUQ>td._3pB5jA3sM4dqd-uWWtNYKq{background:#fafafa}._25fu2zl2d-vqIl8bRXTsAN>tr:hover{background:none}.C3p82omWOgy6nt98oQAH9{position:relative;padding:16px;color:rgba(0,0,0,.85);background:#fafafa;border-top:1px solid #e8e8e8;border-radius:0 0 4px 4px}.C3p82omWOgy6nt98oQAH9:before{position:absolute;top:-1px;left:0;width:100%;height:1px;background:#fafafa;content:\"\"}._3fMJwK7ehwYMI9WXIBXx7X._1NHo45BpUmMB_be0TIXnOP .C3p82omWOgy6nt98oQAH9{border:1px solid #e8e8e8}._1ySN9C7zVlgpW0qERhparj{position:relative;top:1px;padding:16px 0;border-radius:4px 4px 0 0}._3fMJwK7ehwYMI9WXIBXx7X._1NHo45BpUmMB_be0TIXnOP ._1ySN9C7zVlgpW0qERhparj{padding-right:16px;padding-left:16px;border:1px solid #e8e8e8}._1ySN9C7zVlgpW0qERhparj+._1aM_O0R3xvsULZstHSZ3Zp{position:relative;border-radius:4px 4px 0 0}._1NHo45BpUmMB_be0TIXnOP ._1ySN9C7zVlgpW0qERhparj+._1aM_O0R3xvsULZstHSZ3Zp,._1NHo45BpUmMB_be0TIXnOP ._1ySN9C7zVlgpW0qERhparj+._1aM_O0R3xvsULZstHSZ3Zp ._25fu2zl2d-vqIl8bRXTsAN>tr:first-child>th,._1NHo45BpUmMB_be0TIXnOP ._1ySN9C7zVlgpW0qERhparj+._1aM_O0R3xvsULZstHSZ3Zp table,._1sAfAHKYhZ01GZvkNilov7 ._1ySN9C7zVlgpW0qERhparj+._1aM_O0R3xvsULZstHSZ3Zp,._1sAfAHKYhZ01GZvkNilov7 table{border-radius:0}._1sAfAHKYhZ01GZvkNilov7._1NHo45BpUmMB_be0TIXnOP._3vcHok5L3bZVcOpv9E6yPq .avyuvw7jWNGDqMjtw7XzY{border-top:1px solid #e8e8e8;border-radius:4px}._3aml4KBMk9yAckKTSLa9gm>tr._2jOFqVn9Kg1t10fk76vtUQ td{color:inherit;background:#fafafa}._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq{background:#f5f5f5}._3aml4KBMk9yAckKTSLa9gm>tr>td._3pB5jA3sM4dqd-uWWtNYKq{background:rgba(0,0,0,.01)}._3aml4KBMk9yAckKTSLa9gm>tr>td,._25fu2zl2d-vqIl8bRXTsAN>tr>th{padding:16px;overflow-wrap:break-word}.TEXzPmB9nIuvX6Buuy4kA,.xfFWZPppNV0E5LDKjn4z_{width:50px;min-width:50px;text-align:center}._36uHTr7zz9hEZ-ZU--m2p_{overflow:hidden;background:#fafafa}._36uHTr7zz9hEZ-ZU--m2p_ table{border-radius:4px 4px 0 0}.tFYL2UoLk2ySH2Wh56ouI{position:relative}.tFYL2UoLk2ySH2Wh56ouI ._2yk3lyMbLlaUj9C-xn8dVZ{background:#fff;opacity:.5}.tFYL2UoLk2ySH2Wh56ouI ._3IYyKsAJKYUyD9YFm5ul1V{position:absolute;top:50%;left:50%;height:20px;margin-left:-30px;line-height:20px}.tFYL2UoLk2ySH2Wh56ouI ._1wQzLNINC3D1sZ6WJLmT6R{margin-top:-20px}.tFYL2UoLk2ySH2Wh56ouI ._3fQaTLg0reIj-P-Ol2SwI_{margin-top:10px}._1NHo45BpUmMB_be0TIXnOP ._1DD3eU5myBRjGsrlMGuYsg table,._1NHo45BpUmMB_be0TIXnOP ._2yk3lyMbLlaUj9C-xn8dVZ>table,._1NHo45BpUmMB_be0TIXnOP ._36uHTr7zz9hEZ-ZU--m2p_>table,._1NHo45BpUmMB_be0TIXnOP .zOPKs_xmF12yaFtAl8meW table{border:1px solid #e8e8e8;border-right:0;border-bottom:0}._1NHo45BpUmMB_be0TIXnOP._3vcHok5L3bZVcOpv9E6yPq .avyuvw7jWNGDqMjtw7XzY{border-right:1px solid #e8e8e8;border-left:1px solid #e8e8e8}._1NHo45BpUmMB_be0TIXnOP.EMaVlAtyYB9Gm2ywR9hb1 ._36uHTr7zz9hEZ-ZU--m2p_>table{border-bottom:0}._1NHo45BpUmMB_be0TIXnOP.EMaVlAtyYB9Gm2ywR9hb1 ._2yk3lyMbLlaUj9C-xn8dVZ>table{border-top-left-radius:0;border-top-right-radius:0}._1NHo45BpUmMB_be0TIXnOP.EMaVlAtyYB9Gm2ywR9hb1 ._2clRomWXZhcW1J7BQnpW8N>table,._1NHo45BpUmMB_be0TIXnOP.EMaVlAtyYB9Gm2ywR9hb1 ._36uHTr7zz9hEZ-ZU--m2p_+._2yk3lyMbLlaUj9C-xn8dVZ>table{border-top:0}._1NHo45BpUmMB_be0TIXnOP ._25fu2zl2d-vqIl8bRXTsAN>tr:not(:last-child)>th{border-bottom:1px solid #e8e8e8}._1NHo45BpUmMB_be0TIXnOP ._3aml4KBMk9yAckKTSLa9gm>tr>td,._1NHo45BpUmMB_be0TIXnOP ._25fu2zl2d-vqIl8bRXTsAN>tr>th{border-right:1px solid #e8e8e8}.avyuvw7jWNGDqMjtw7XzY{position:relative;z-index:1;margin-top:-1px;padding:16px;color:rgba(0,0,0,.25);font-size:14px;text-align:center;background:#fff;border-top:1px solid #e8e8e8;border-bottom:1px solid #e8e8e8;border-radius:0 0 4px 4px}._3nUHyDIF85CPUjqMJ4E2tz._3yFO0ExW2lDi3iJscVlo6q{float:right;margin:16px 0}.t0kPDaRyeP6iJ3hergby-{position:relative;min-width:96px;margin-left:-8px;background:#fff;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15)}.t0kPDaRyeP6iJ3hergby- ._2Euw4JTvgA5SfE5HM1wNOt{max-height:calc(100vh - 130px);overflow-x:hidden;border:0;border-radius:4px 4px 0 0;box-shadow:none}.t0kPDaRyeP6iJ3hergby- .MY2e94iH-ikkSYLcfVXzB>label+span{padding-right:0}.t0kPDaRyeP6iJ3hergby- ._3X3VnvLwfA1aPNRwkJxBvo{border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15)}.t0kPDaRyeP6iJ3hergby- ._2Euw4JTvgA5SfE5HM1wNOt ._1LoP0Kjr5fKVkljZW1E6E5 ._30LEIIPFE7sW-LscRgxxqs:after{color:#1890ff;font-weight:700;text-shadow:0 0 2px #bae7ff}.t0kPDaRyeP6iJ3hergby- .MY2e94iH-ikkSYLcfVXzB{overflow:hidden}.t0kPDaRyeP6iJ3hergby->._2Euw4JTvgA5SfE5HM1wNOt>.MY2e94iH-ikkSYLcfVXzB:last-child,.t0kPDaRyeP6iJ3hergby->._2Euw4JTvgA5SfE5HM1wNOt>.ZAVKaPG8dKIsabKbF81mP:last-child ._30LEIIPFE7sW-LscRgxxqs{border-radius:0}._2XbJH4NJ3feZ37ziS-RQg9{padding:7px 8px;overflow:hidden;border-top:1px solid #e8e8e8}._1DksAhaC8Z3xJwwJo0fvER{color:#1890ff}._1DksAhaC8Z3xJwwJo0fvER:hover{color:#40a9ff}._1DksAhaC8Z3xJwwJo0fvER:active{color:#096dd9}._1DksAhaC8Z3xJwwJo0fvER._2yXKr-mz8PfvL5gUVxucLn{float:left}._1DksAhaC8Z3xJwwJo0fvER._2vVoleoluS0hKV5sib3cTP{float:right}._1eZBhZqIcqssIcTOzuf3J-{white-space:nowrap}._26VUlbMwEOpegWnAWEfFfe{margin-right:4px!important}._1eZBhZqIcqssIcTOzuf3J- ._1iI0eo9hgIxxGhx-LIu_tr{color:#bfbfbf;transition:all .3s}.i_4e1cLa8JsNnq63Q2OjC{min-width:96px;margin-top:5px;margin-left:-30px;background:#fff;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15)}.i_4e1cLa8JsNnq63Q2OjC ._22cK_wJHUxqVGOjm69bQAo{color:#bfbfbf}._2MO6K-lKbRo1uFPD2mzkVB{display:inline-block;padding:0;line-height:1;cursor:pointer}._2MO6K-lKbRo1uFPD2mzkVB:hover ._1iI0eo9hgIxxGhx-LIu_tr{color:rgba(0,0,0,.6)}._1QmzmjVEnfIGfnhoCEvHya{color:#1890ff;text-decoration:none;cursor:pointer;transition:color .3s;display:inline-block;width:17px;height:17px;color:inherit;line-height:13px;text-align:center;background:#fff;border:1px solid #e8e8e8;border-radius:2px;outline:none;transition:all .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1QmzmjVEnfIGfnhoCEvHya:focus,._1QmzmjVEnfIGfnhoCEvHya:hover{color:#40a9ff}._1QmzmjVEnfIGfnhoCEvHya:active{color:#096dd9}._1QmzmjVEnfIGfnhoCEvHya:active,._1QmzmjVEnfIGfnhoCEvHya:focus,._1QmzmjVEnfIGfnhoCEvHya:hover{border-color:currentColor}._3wj8iT9zYn4PMtbzUfKfrh:after{content:\"-\"}._3CsReeSHRemedZGd1J2n7X:after{content:\"+\"}._2ViKNLhSUGpmPeavMR8p0Y{visibility:hidden}._2ViKNLhSUGpmPeavMR8p0Y:after{content:\".\"}._1ysuk0hMlpKFDpIxJAcrge,._1ysuk0hMlpKFDpIxJAcrge ._1L3zBpLVITT7hebPdM26Aj{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._1ysuk0hMlpKFDpIxJAcrge ._1L3zBpLVITT7hebPdM26Aj{display:block}._3e0aHHQQjRoDvDfSGBMXKV{word-wrap:break-word;word-break:break-word}tr._13tu_i3IPv3UXt8sfp2hEG,tr._13tu_i3IPv3UXt8sfp2hEG:hover{background:#fbfbfb}tr._13tu_i3IPv3UXt8sfp2hEG td>._1jESgGkhSIqc1vmWhMSm9q{margin:-16px -16px -17px}._3fMJwK7ehwYMI9WXIBXx7X ._2l00fp_FNeq2wZgKxp9x3Y+._1QmzmjVEnfIGfnhoCEvHya{margin-right:8px}._2X2kzVZ-zOogZARIeKOmTI{overflow:auto;overflow-x:hidden}._2X2kzVZ-zOogZARIeKOmTI table{min-width:100%}._2X2kzVZ-zOogZARIeKOmTI table ._1ZopjFbeHHox1KzK8x1mBp:not([colspan]){color:transparent}._2X2kzVZ-zOogZARIeKOmTI table ._1ZopjFbeHHox1KzK8x1mBp:not([colspan])>*{visibility:hidden}._2clRomWXZhcW1J7BQnpW8N{height:100%}.EMaVlAtyYB9Gm2ywR9hb1>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ{position:relative;background:#fff}.EMaVlAtyYB9Gm2ywR9hb1 ._2clRomWXZhcW1J7BQnpW8N{overflow:scroll}.EMaVlAtyYB9Gm2ywR9hb1 ._2X2kzVZ-zOogZARIeKOmTI ._36uHTr7zz9hEZ-ZU--m2p_{margin-bottom:-20px;padding-bottom:20px;overflow:scroll;opacity:.9999}.EMaVlAtyYB9Gm2ywR9hb1 ._2X2kzVZ-zOogZARIeKOmTI ._36uHTr7zz9hEZ-ZU--m2p_::-webkit-scrollbar{border:1px solid #e8e8e8;border-width:0 0 1px}._1Tq2kei88NxPzUfvd5OOUO{scrollbar-color:transparent transparent;min-width:unset}._1Tq2kei88NxPzUfvd5OOUO::-webkit-scrollbar{min-width:inherit;background-color:transparent}._1NHo45BpUmMB_be0TIXnOP.EMaVlAtyYB9Gm2ywR9hb1 ._2X2kzVZ-zOogZARIeKOmTI ._36uHTr7zz9hEZ-ZU--m2p_::-webkit-scrollbar{border:1px solid #e8e8e8;border-width:1px 1px 1px 0}._1NHo45BpUmMB_be0TIXnOP.EMaVlAtyYB9Gm2ywR9hb1 ._2X2kzVZ-zOogZARIeKOmTI ._36uHTr7zz9hEZ-ZU--m2p_._1Tq2kei88NxPzUfvd5OOUO ._25fu2zl2d-vqIl8bRXTsAN>tr:only-child>th:last-child{border-right-color:transparent}._1DD3eU5myBRjGsrlMGuYsg,.zOPKs_xmF12yaFtAl8meW{position:absolute;top:0;z-index:1;overflow:hidden;border-radius:0;transition:box-shadow .3s ease}._1DD3eU5myBRjGsrlMGuYsg table,.zOPKs_xmF12yaFtAl8meW table{width:auto;background:#fff}.EMaVlAtyYB9Gm2ywR9hb1 ._1DD3eU5myBRjGsrlMGuYsg ._1nbH7pXQuVgZPFDMFMbynd ._2wxWKt0vVLKFxkuTChCa-c,.EMaVlAtyYB9Gm2ywR9hb1 .zOPKs_xmF12yaFtAl8meW ._1nbH7pXQuVgZPFDMFMbynd ._2wxWKt0vVLKFxkuTChCa-c{border-radius:0}.zOPKs_xmF12yaFtAl8meW{left:0;box-shadow:6px 0 6px -4px rgba(0,0,0,.15)}.zOPKs_xmF12yaFtAl8meW ._36uHTr7zz9hEZ-ZU--m2p_{overflow-y:hidden}.zOPKs_xmF12yaFtAl8meW ._2clRomWXZhcW1J7BQnpW8N{margin-right:-20px;padding-right:20px}.EMaVlAtyYB9Gm2ywR9hb1 .zOPKs_xmF12yaFtAl8meW ._2clRomWXZhcW1J7BQnpW8N{padding-right:0}.zOPKs_xmF12yaFtAl8meW,.zOPKs_xmF12yaFtAl8meW table{border-radius:4px 0 0 0}.zOPKs_xmF12yaFtAl8meW ._25fu2zl2d-vqIl8bRXTsAN>tr>th:last-child{border-top-right-radius:0}._1DD3eU5myBRjGsrlMGuYsg{right:0;box-shadow:-6px 0 6px -4px rgba(0,0,0,.15)}._1DD3eU5myBRjGsrlMGuYsg,._1DD3eU5myBRjGsrlMGuYsg table{border-radius:0 4px 0 0}._1DD3eU5myBRjGsrlMGuYsg ._13tu_i3IPv3UXt8sfp2hEG{color:transparent;pointer-events:none}._1DD3eU5myBRjGsrlMGuYsg ._25fu2zl2d-vqIl8bRXTsAN>tr>th:first-child{border-top-left-radius:0}._3fMJwK7ehwYMI9WXIBXx7X._3fHFJ7uM1HI-0UF_EkeEih ._1DD3eU5myBRjGsrlMGuYsg,._3fMJwK7ehwYMI9WXIBXx7X._20udH_czWRD1xbA7TQGQzx .zOPKs_xmF12yaFtAl8meW{box-shadow:none}._3fMJwK7ehwYMI9WXIBXx7X colgroup>col._3fAf-8wbF558FoMIpz_62I{width:60px}._25fu2zl2d-vqIl8bRXTsAN>tr>th._1ue2cccChBZoFtcuuK6M8O ._1eZBhZqIcqssIcTOzuf3J-{margin-right:-15px}._3aml4KBMk9yAckKTSLa9gm>tr>td._12sev7OhOos5aWKQnwPFoi,._25fu2zl2d-vqIl8bRXTsAN>tr>th._12sev7OhOos5aWKQnwPFoi{text-align:center}._3aml4KBMk9yAckKTSLa9gm>tr>td._12sev7OhOos5aWKQnwPFoi ._339craOB4NhQayjvZn9-So,._25fu2zl2d-vqIl8bRXTsAN>tr>th._12sev7OhOos5aWKQnwPFoi ._339craOB4NhQayjvZn9-So{margin-right:0}.zrVqitjpiFV_CXWiKkbiT[class*=ant-table-row-level-0] ._12sev7OhOos5aWKQnwPFoi>span{display:inline-block}._3yGa1XSZ44smbr9KO39qrs ._3LtXuasflPstC14W79Zpyb+span,.t0kPDaRyeP6iJ3hergby- ._3LtXuasflPstC14W79Zpyb+span{padding-left:8px}@supports (-moz-appearance:meterbar){._25fu2zl2d-vqIl8bRXTsAN>tr>th._3ZCd4H6qi39RqknekInp4{background-clip:padding-box}}.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._36uHTr7zz9hEZ-ZU--m2p_>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>.C3p82omWOgy6nt98oQAH9,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.mFEjxgHrKxGkdkpToauxN>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.mFEjxgHrKxGkdkpToauxN>._1ySN9C7zVlgpW0qERhparj{padding:12px 8px}.mFEjxgHrKxGkdkpToauxN tr._13tu_i3IPv3UXt8sfp2hEG td>._1jESgGkhSIqc1vmWhMSm9q{margin:-12px -8px -13px}.N0dPkf-FPErzHMgAkrT_A{border:1px solid #e8e8e8;border-radius:4px}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.C3p82omWOgy6nt98oQAH9,.N0dPkf-FPErzHMgAkrT_A>._1ySN9C7zVlgpW0qERhparj{padding:8px}.N0dPkf-FPErzHMgAkrT_A>._1ySN9C7zVlgpW0qERhparj{top:0;border-bottom:1px solid #e8e8e8}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.C3p82omWOgy6nt98oQAH9{background-color:transparent;border-top:1px solid #e8e8e8}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.C3p82omWOgy6nt98oQAH9:before{background-color:transparent}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ{margin:0 8px}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._36uHTr7zz9hEZ-ZU--m2p_>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table{border:0}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._36uHTr7zz9hEZ-ZU--m2p_>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table>._3aml4KBMk9yAckKTSLa9gm>tr>td,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th{padding:8px}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th{background-color:transparent}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr{border-bottom:1px solid #e8e8e8}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th._3pB5jA3sM4dqd-uWWtNYKq{background-color:rgba(0,0,0,.01)}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._1DD3eU5myBRjGsrlMGuYsg>._36uHTr7zz9hEZ-ZU--m2p_>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._36uHTr7zz9hEZ-ZU--m2p_>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._1nbH7pXQuVgZPFDMFMbynd>._2clRomWXZhcW1J7BQnpW8N>table,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>.zOPKs_xmF12yaFtAl8meW>._36uHTr7zz9hEZ-ZU--m2p_>table{padding:0}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp ._36uHTr7zz9hEZ-ZU--m2p_{background-color:transparent;border-radius:4px 4px 0 0}.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp .avyuvw7jWNGDqMjtw7XzY,.N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp .zrVqitjpiFV_CXWiKkbiT:last-child td{border-bottom:0}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP{border-right:0}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP ._1ySN9C7zVlgpW0qERhparj{border:0;border-right:1px solid #e8e8e8;border-bottom:1px solid #e8e8e8}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP ._1aM_O0R3xvsULZstHSZ3Zp{border-right:1px solid #e8e8e8}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP .C3p82omWOgy6nt98oQAH9{border:0;border-top:1px solid #e8e8e8}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP .C3p82omWOgy6nt98oQAH9:before{display:none}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP .avyuvw7jWNGDqMjtw7XzY{border-right:0;border-bottom:0;border-left:0}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP ._3aml4KBMk9yAckKTSLa9gm>tr>td:last-child,.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP ._25fu2zl2d-vqIl8bRXTsAN>tr>th._2YahBMgj9LPsb4aFeq8R_u{border-right:none}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP .zOPKs_xmF12yaFtAl8meW ._3aml4KBMk9yAckKTSLa9gm>tr>td:last-child,.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP .zOPKs_xmF12yaFtAl8meW ._25fu2zl2d-vqIl8bRXTsAN>tr>th:last-child{border-right:1px solid #e8e8e8}.N0dPkf-FPErzHMgAkrT_A._1NHo45BpUmMB_be0TIXnOP ._1DD3eU5myBRjGsrlMGuYsg{border-right:1px solid #e8e8e8;border-left:1px solid #e8e8e8}.N0dPkf-FPErzHMgAkrT_A tr._13tu_i3IPv3UXt8sfp2hEG td>._1jESgGkhSIqc1vmWhMSm9q{margin:-8px -8px -9px}.N0dPkf-FPErzHMgAkrT_A.EMaVlAtyYB9Gm2ywR9hb1>._1aM_O0R3xvsULZstHSZ3Zp>._2X2kzVZ-zOogZARIeKOmTI>._2yk3lyMbLlaUj9C-xn8dVZ{border-radius:0 0 4px 4px}._3s1Jafw_2qZK40rdRRpAyl{box-sizing:border-box;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;font-feature-settings:\"tnum\";margin:0;padding:0;list-style:none}._3hBDOkRprJUIH4RsEeF9Uc{position:relative;margin:0;padding:0 0 20px;font-size:14px;list-style:none}._3if7QeEVevTzFqz4aNHs8z{position:absolute;top:10px;left:4px;height:calc(100% - 10px);border-left:2px solid #e8e8e8}._39s9p8XqJldJ0c55JvMaou ._2Iw0eW3yGZXI9d8NQV2T5Q{font-size:12px;background-color:transparent}._39s9p8XqJldJ0c55JvMaou ._3if7QeEVevTzFqz4aNHs8z{display:none}._2Iw0eW3yGZXI9d8NQV2T5Q{position:absolute;width:10px;height:10px;background-color:#fff;border:2px solid transparent;border-radius:100px}._3-YwRSIO_K2GkWZvGVzTBa{color:#1890ff;border-color:#1890ff}._2yUbw6TliE5ZFw6-soXSAI{color:#f5222d;border-color:#f5222d}._2AA1dQjUtBepFJTS_AfZ-b{color:#52c41a;border-color:#52c41a}.gZ-s-o7Ff1YStfdVdFWga{color:rgba(0,0,0,.25);border-color:rgba(0,0,0,.25)}._3AlAQ6tYln8HL5ZF-4pVTP{position:absolute;top:5.5px;left:5px;width:auto;height:auto;margin-top:0;padding:3px 1px;line-height:1;text-align:center;border:0;border-radius:0;transform:translate(-50%,-50%)}._3oUggV1jya_qunseiZVH1s{position:relative;top:-6px;margin:0 0 0 18px;word-break:break-word}.Y-dfWs_7uB2hgX65fGVwf>._3if7QeEVevTzFqz4aNHs8z{display:none}.Y-dfWs_7uB2hgX65fGVwf>._3oUggV1jya_qunseiZVH1s{min-height:48px}._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO ._2Iw0eW3yGZXI9d8NQV2T5Q,._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO ._3AlAQ6tYln8HL5ZF-4pVTP,._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO ._3if7QeEVevTzFqz4aNHs8z,._3s1Jafw_2qZK40rdRRpAyl.MlW17bxxI9CyJzMxlDV_k ._2Iw0eW3yGZXI9d8NQV2T5Q,._3s1Jafw_2qZK40rdRRpAyl.MlW17bxxI9CyJzMxlDV_k ._3AlAQ6tYln8HL5ZF-4pVTP,._3s1Jafw_2qZK40rdRRpAyl.MlW17bxxI9CyJzMxlDV_k ._3if7QeEVevTzFqz4aNHs8z{left:50%}._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO ._2Iw0eW3yGZXI9d8NQV2T5Q,._3s1Jafw_2qZK40rdRRpAyl.MlW17bxxI9CyJzMxlDV_k ._2Iw0eW3yGZXI9d8NQV2T5Q{margin-left:-4px}._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO ._3AlAQ6tYln8HL5ZF-4pVTP,._3s1Jafw_2qZK40rdRRpAyl.MlW17bxxI9CyJzMxlDV_k ._3AlAQ6tYln8HL5ZF-4pVTP{margin-left:1px}._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO ._1U9z13zH1NdnoifGCnczXL ._3oUggV1jya_qunseiZVH1s,._3s1Jafw_2qZK40rdRRpAyl.MlW17bxxI9CyJzMxlDV_k ._1U9z13zH1NdnoifGCnczXL ._3oUggV1jya_qunseiZVH1s{left:calc(50% - 4px);width:calc(50% - 14px);text-align:left}._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO .r52WJA0xU1MEHx86NziKE ._3oUggV1jya_qunseiZVH1s,._3s1Jafw_2qZK40rdRRpAyl.MlW17bxxI9CyJzMxlDV_k .r52WJA0xU1MEHx86NziKE ._3oUggV1jya_qunseiZVH1s{width:calc(50% - 12px);margin:0;text-align:right}._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO .r52WJA0xU1MEHx86NziKE ._2Iw0eW3yGZXI9d8NQV2T5Q,._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO .r52WJA0xU1MEHx86NziKE ._3AlAQ6tYln8HL5ZF-4pVTP,._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO .r52WJA0xU1MEHx86NziKE ._3if7QeEVevTzFqz4aNHs8z{left:calc(100% - 4px - 2px)}._3s1Jafw_2qZK40rdRRpAyl._1WNAv7xHahpXVEGH7yAwWO .r52WJA0xU1MEHx86NziKE ._3oUggV1jya_qunseiZVH1s{width:calc(100% - 18px)}._3s1Jafw_2qZK40rdRRpAyl._1x5uZy0H7yXeADduGEcDg1 .Y-dfWs_7uB2hgX65fGVwf ._3if7QeEVevTzFqz4aNHs8z{display:block;height:calc(100% - 14px);border-left:2px dotted #e8e8e8}._3s1Jafw_2qZK40rdRRpAyl._30JOgo4V0jDVg0Xx3_7Bk6 .Y-dfWs_7uB2hgX65fGVwf ._3if7QeEVevTzFqz4aNHs8z{display:none}._3s1Jafw_2qZK40rdRRpAyl._30JOgo4V0jDVg0Xx3_7Bk6 ._39s9p8XqJldJ0c55JvMaou ._3if7QeEVevTzFqz4aNHs8z{top:15px;display:block;height:calc(100% - 15px);border-left:2px dotted #e8e8e8}._3s1Jafw_2qZK40rdRRpAyl._30JOgo4V0jDVg0Xx3_7Bk6 ._39s9p8XqJldJ0c55JvMaou ._3oUggV1jya_qunseiZVH1s{min-height:48px}.rlMH4NlzQWJh83Dq9DdX5{display:-ms-flexbox;display:flex}.rlMH4NlzQWJh83Dq9DdX5 ._2iecrxAtvapq8cS3BBVGd9{-ms-flex:none;flex:none;-ms-flex-item-align:center;align-self:center}.rlMH4NlzQWJh83Dq9DdX5 ._2fWTapgGa9S4V8oTJQqPuC{-ms-flex:auto;flex:auto;width:auto;height:auto;min-height:200px}.rlMH4NlzQWJh83Dq9DdX5 ._10-WXXqs0ZlcFLnZGYGJZ1{padding-top:0}.rlMH4NlzQWJh83Dq9DdX5 .be0Q-RdCmS9S6OKeN9R_h{position:relative;padding-bottom:0}.rlMH4NlzQWJh83Dq9DdX5 ._1eZFgfpkzGXACdV9y0DQyn{padding:12px}.rlMH4NlzQWJh83Dq9DdX5 ._1jESgGkhSIqc1vmWhMSm9q .N0dPkf-FPErzHMgAkrT_A{border:0;border-radius:0}.rlMH4NlzQWJh83Dq9DdX5 ._1jESgGkhSIqc1vmWhMSm9q .N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp>._2yk3lyMbLlaUj9C-xn8dVZ>table>._25fu2zl2d-vqIl8bRXTsAN>tr>th{background:#fafafa}.rlMH4NlzQWJh83Dq9DdX5 ._1jESgGkhSIqc1vmWhMSm9q .N0dPkf-FPErzHMgAkrT_A>._1aM_O0R3xvsULZstHSZ3Zp .zrVqitjpiFV_CXWiKkbiT:last-child td{border-bottom:1px solid #e8e8e8}.rlMH4NlzQWJh83Dq9DdX5 ._1jESgGkhSIqc1vmWhMSm9q .N0dPkf-FPErzHMgAkrT_A ._2yk3lyMbLlaUj9C-xn8dVZ{margin:0}.rlMH4NlzQWJh83Dq9DdX5 ._1jESgGkhSIqc1vmWhMSm9q ._3nUHyDIF85CPUjqMJ4E2tz._3yFO0ExW2lDi3iJscVlo6q{margin:16px 0 4px}._2D2QtpzCwBFDz2ZekZgLlA{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative}._1pxg4uZSvhEmukw3Ep4BBz ._2fWTapgGa9S4V8oTJQqPuC{background:#f5f5f5}._2fWTapgGa9S4V8oTJQqPuC{position:relative;display:inline-block;width:180px;height:200px;padding-top:40px;vertical-align:middle;border:1px solid #d9d9d9;border-radius:4px}.KVBFZ_F6K_ySDznpKReT_{padding-bottom:34px}._2ahGzO6VPnpqbaNMwJwobm{padding:0 24px 0 8px}._3PmrhZRTM_SsoRP6xr0OA6{position:absolute;top:12px;right:12px;bottom:12px;width:28px;color:rgba(0,0,0,.25);line-height:32px;text-align:center}._3PmrhZRTM_SsoRP6xr0OA6 ._1oZ8xlpZEg3PzGp2jMNFuZ{color:rgba(0,0,0,.25);transition:all .3s}._3PmrhZRTM_SsoRP6xr0OA6 ._1oZ8xlpZEg3PzGp2jMNFuZ:hover{color:rgba(0,0,0,.45)}span._3PmrhZRTM_SsoRP6xr0OA6{pointer-events:none}._37pC92p0hfz6rTUJPr2gaV{position:absolute;top:0;left:0;width:100%;padding:8px 12px 9px;overflow:hidden;color:rgba(0,0,0,.65);background:#fff;border-bottom:1px solid #e8e8e8;border-radius:4px 4px 0 0}.RndxYLA26iGE88FBiPmoV{position:absolute;right:12px}._37pC92p0hfz6rTUJPr2gaV ._3LtXuasflPstC14W79Zpyb+span{padding-left:8px}._2oQEtG2Tr0IS5Dr54XFEzj{position:relative;height:100%;font-size:14px}.be0Q-RdCmS9S6OKeN9R_h{position:absolute;top:0;left:0;width:100%;padding:12px}._10-WXXqs0ZlcFLnZGYGJZ1{padding-top:56px}._1e3AJXT-N9-h5b4z8kE2Az{height:100%;margin:0;padding:0;overflow:auto;list-style:none}._1e3AJXT-N9-h5b4z8kE2Az>._3NGzKjRdPlWpgGzwSMJ1D6{animation:_1XmRi5uc5p2ADS-evGdaEv 1s}._3hibcDhRBvhxHS6tV5I91c{min-height:32px;padding:6px 12px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;transition:all .3s}._3hibcDhRBvhxHS6tV5I91c>span{padding-right:0}._1GjlRFUWtWEb71c4aUcc_H{padding-left:8px}._3hibcDhRBvhxHS6tV5I91c:not(._3f3C491D12e4YU0i4aBGEt):hover{background-color:#e6f7ff;cursor:pointer}._3f3C491D12e4YU0i4aBGEt{color:rgba(0,0,0,.25);cursor:not-allowed}._3qqVHAL1GoRLHhC531BxJj{position:absolute;top:50%;width:100%;padding-top:0;color:rgba(0,0,0,.25);text-align:center;transform:translateY(-50%)}._10-WXXqs0ZlcFLnZGYGJZ1 ._3qqVHAL1GoRLHhC531BxJj{margin-top:16px}._2clh250I8Q06en-5GCK1Fe{position:absolute;bottom:0;left:0;width:100%;border-top:1px solid #e8e8e8;border-radius:0 0 4px 4px}._2iecrxAtvapq8cS3BBVGd9{display:inline-block;margin:0 8px;overflow:hidden;vertical-align:middle}._2iecrxAtvapq8cS3BBVGd9 ._34ecc6_SGKef4Y6JfdE_DJ{display:block}._2iecrxAtvapq8cS3BBVGd9 ._34ecc6_SGKef4Y6JfdE_DJ:first-child{margin-bottom:4px}._2iecrxAtvapq8cS3BBVGd9 ._34ecc6_SGKef4Y6JfdE_DJ ._1oZ8xlpZEg3PzGp2jMNFuZ{font-size:12px}@keyframes _1XmRi5uc5p2ADS-evGdaEv{0%{background:#bae7ff}to{background:transparent}}.CUzmrYCooqKankKH0dZg1{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;top:-.09em;display:inline-block;line-height:1;white-space:nowrap;vertical-align:middle;outline:none;cursor:pointer}._2kQLF0NCfp_9auDgEqRz9p:focus+._3aKsfuvecj_xf_qhm1o-qG,._2LvMFSgY53-D24I85Jg15m:hover ._3aKsfuvecj_xf_qhm1o-qG,.CUzmrYCooqKankKH0dZg1:hover ._3aKsfuvecj_xf_qhm1o-qG{border-color:#1890ff}._3A6-r92EApUOl7NKxi-WP0:after{position:absolute;top:0;left:0;width:100%;height:100%;border:1px solid #1890ff;border-radius:2px;visibility:hidden;animation:_21X1U27xYleYdbKo6yuHqk .36s ease-in-out;animation-fill-mode:backwards;content:\"\"}._2LvMFSgY53-D24I85Jg15m:hover .CUzmrYCooqKankKH0dZg1:after,.CUzmrYCooqKankKH0dZg1:hover:after{visibility:visible}._3aKsfuvecj_xf_qhm1o-qG{position:relative;top:0;left:0;display:block;width:16px;height:16px;background-color:#fff;border:1px solid #d9d9d9;border-radius:2px;border-collapse:separate;transition:all .3s}._3aKsfuvecj_xf_qhm1o-qG:after{position:absolute;top:50%;left:22%;display:table;width:5.71428571px;height:9.14285714px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg) scale(0) translate(-50%,-50%);opacity:0;transition:all .1s cubic-bezier(.71,-.46,.88,.6),opacity .1s;content:\" \"}._2kQLF0NCfp_9auDgEqRz9p{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;width:100%;height:100%;cursor:pointer;opacity:0}._3A6-r92EApUOl7NKxi-WP0 ._3aKsfuvecj_xf_qhm1o-qG:after{position:absolute;display:table;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg) scale(1) translate(-50%,-50%);opacity:1;transition:all .2s cubic-bezier(.12,.4,.29,1.46) .1s;content:\" \"}._3A6-r92EApUOl7NKxi-WP0 ._3aKsfuvecj_xf_qhm1o-qG{background-color:#1890ff;border-color:#1890ff}.tuuKYf6pt0EsXC4MmGcyw{cursor:not-allowed}.tuuKYf6pt0EsXC4MmGcyw._3A6-r92EApUOl7NKxi-WP0 ._3aKsfuvecj_xf_qhm1o-qG:after{border-color:rgba(0,0,0,.25);animation-name:_1CY6uej5ij2TMImio1u0wc}.tuuKYf6pt0EsXC4MmGcyw ._2kQLF0NCfp_9auDgEqRz9p{cursor:not-allowed}.tuuKYf6pt0EsXC4MmGcyw ._3aKsfuvecj_xf_qhm1o-qG{background-color:#f5f5f5;border-color:#d9d9d9!important}.tuuKYf6pt0EsXC4MmGcyw ._3aKsfuvecj_xf_qhm1o-qG:after{border-color:#f5f5f5;border-collapse:separate;animation-name:_1CY6uej5ij2TMImio1u0wc}.tuuKYf6pt0EsXC4MmGcyw+span{color:rgba(0,0,0,.25);cursor:not-allowed}._2LvMFSgY53-D24I85Jg15m:hover .tuuKYf6pt0EsXC4MmGcyw:after,.tuuKYf6pt0EsXC4MmGcyw:hover:after{visibility:hidden}._2LvMFSgY53-D24I85Jg15m{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block;line-height:unset;cursor:pointer}._2LvMFSgY53-D24I85Jg15m._1RrKymZUHSLGVgHDX9w9hN{cursor:not-allowed}._2LvMFSgY53-D24I85Jg15m+._2LvMFSgY53-D24I85Jg15m{margin-left:8px}.CUzmrYCooqKankKH0dZg1+span{padding-right:8px;padding-left:8px}._33tPvi6_EPmaXdKgl4krsJ{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block}._30vB3xci_A6ZeUu5mGdthm{display:inline-block;margin-right:8px}._30vB3xci_A6ZeUu5mGdthm:last-child{margin-right:0}._30vB3xci_A6ZeUu5mGdthm+._30vB3xci_A6ZeUu5mGdthm{margin-left:0}._1FqAF7aA6ToW7ETCiQShJC ._3aKsfuvecj_xf_qhm1o-qG{background-color:#fff;border-color:#d9d9d9}._1FqAF7aA6ToW7ETCiQShJC ._3aKsfuvecj_xf_qhm1o-qG:after{top:50%;left:50%;width:8px;height:8px;background-color:#1890ff;border:0;transform:translate(-50%,-50%) scale(1);opacity:1;content:\" \"}._1FqAF7aA6ToW7ETCiQShJC.tuuKYf6pt0EsXC4MmGcyw ._3aKsfuvecj_xf_qhm1o-qG:after{background-color:rgba(0,0,0,.25);border-color:rgba(0,0,0,.25)}.arBNXWNSdVMhXqwttAeXr{box-sizing:border-box;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";margin:0;margin-top:-4px;padding:0 4px}.arBNXWNSdVMhXqwttAeXr li{margin:8px 0;padding:0;white-space:nowrap;list-style:none;outline:0}.arBNXWNSdVMhXqwttAeXr li.Us43Qi7jro2p5xJpEFQgv>span{font-weight:500}.arBNXWNSdVMhXqwttAeXr li ul{margin:0;padding:0 0 0 18px}.arBNXWNSdVMhXqwttAeXr li ._2gVXDLA_Cv6gJ7PzacdWn-{display:inline-block;width:calc(100% - 24px);margin:0;padding:3px 5px;color:rgba(0,0,0,.65);text-decoration:none;border-radius:2px;cursor:pointer;transition:all .3s}.arBNXWNSdVMhXqwttAeXr li ._2gVXDLA_Cv6gJ7PzacdWn-:hover{background-color:#e6f7ff}.arBNXWNSdVMhXqwttAeXr li ._2gVXDLA_Cv6gJ7PzacdWn-._34blrKC2wA5L_0m7ZHVxB7{background-color:#bae7ff}.arBNXWNSdVMhXqwttAeXr li span.CUzmrYCooqKankKH0dZg1{margin:0 4px 0 0}.arBNXWNSdVMhXqwttAeXr li span.CUzmrYCooqKankKH0dZg1+._2gVXDLA_Cv6gJ7PzacdWn-{width:calc(100% - 46px)}.arBNXWNSdVMhXqwttAeXr li span._3hFkulTE_jmD950iDnvjVe,.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn{display:inline-block;width:24px;height:24px;margin:0;line-height:22px;text-align:center;vertical-align:middle;border:0 none;outline:none;cursor:pointer}.arBNXWNSdVMhXqwttAeXr li span._2tXjrHR3Ao-N1fJPsKhS57 ._122XxPShq3_cicoywqJ2zx{position:absolute;left:0;display:inline-block;color:#1890ff;font-size:14px;transform:none}.arBNXWNSdVMhXqwttAeXr li span._2tXjrHR3Ao-N1fJPsKhS57 ._122XxPShq3_cicoywqJ2zx svg{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn{position:relative}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.-N_ffDKc8Bzg-uSGzeEXG{cursor:auto}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.tKkRd5E1TIUeAbYPPNkfA ._3iQjYMymFtoXZ_JuFMpsMI,.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.tKkRd5E1TIUeAbYPPNkfA ._3xAf4EQm7paPCHrnsxJhF8{font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg);display:inline-block;font-weight:700}:root .arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.tKkRd5E1TIUeAbYPPNkfA ._3iQjYMymFtoXZ_JuFMpsMI,:root .arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.tKkRd5E1TIUeAbYPPNkfA ._3xAf4EQm7paPCHrnsxJhF8{font-size:12px}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.tKkRd5E1TIUeAbYPPNkfA ._3iQjYMymFtoXZ_JuFMpsMI svg,.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.tKkRd5E1TIUeAbYPPNkfA ._3xAf4EQm7paPCHrnsxJhF8 svg{transition:transform .3s}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._3iQjYMymFtoXZ_JuFMpsMI,.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._3xAf4EQm7paPCHrnsxJhF8{font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg);display:inline-block;font-weight:700}:root .arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._3iQjYMymFtoXZ_JuFMpsMI,:root .arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._3xAf4EQm7paPCHrnsxJhF8{font-size:12px}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._3iQjYMymFtoXZ_JuFMpsMI svg,.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._3xAf4EQm7paPCHrnsxJhF8 svg{transition:transform .3s}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._3xAf4EQm7paPCHrnsxJhF8 svg{transform:rotate(-90deg)}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._122XxPShq3_cicoywqJ2zx,.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.tKkRd5E1TIUeAbYPPNkfA ._122XxPShq3_cicoywqJ2zx{position:absolute;left:0;display:inline-block;width:24px;height:24px;color:#1890ff;font-size:14px;transform:none}.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn._129vh-FzoYv4gdWq1O1N74 ._122XxPShq3_cicoywqJ2zx svg,.arBNXWNSdVMhXqwttAeXr li span.CBDL87EXvtLP80g-ONbPn.tKkRd5E1TIUeAbYPPNkfA ._122XxPShq3_cicoywqJ2zx svg{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}.arBNXWNSdVMhXqwttAeXr ._3YqJW1QD0n_LYxJe2Dhklu ._3hFkulTE_jmD950iDnvjVe,.QnoAaec0eJjTW0zqLnj80{display:none}._3gQCBrW_PLll3jhwISD-IP{display:block}li.abrK0tECynrrAKTwRDTCN>._2gVXDLA_Cv6gJ7PzacdWn-,li.abrK0tECynrrAKTwRDTCN>._2gVXDLA_Cv6gJ7PzacdWn- span,li.abrK0tECynrrAKTwRDTCN>span:not(.CBDL87EXvtLP80g-ONbPn){color:rgba(0,0,0,.25);cursor:not-allowed}li.abrK0tECynrrAKTwRDTCN>._2gVXDLA_Cv6gJ7PzacdWn-:hover{background:transparent}._1tGiIR953173DHTmLQ_Lx0,._2vnnThThMHmFferjAW2wCz{margin-right:2px;vertical-align:top}._2B_MBpF7swXfI1jtDON4YS{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\"}._2B_MBpF7swXfI1jtDON4YS .Tdu2wxx92tHUFda0pQkM7{position:sticky;top:0;z-index:1;display:block;padding:4px;background:#fff}._2B_MBpF7swXfI1jtDON4YS .Tdu2wxx92tHUFda0pQkM7 ._25sQaSQpL04XTINFK9Yi6x{width:100%}._2B_MBpF7swXfI1jtDON4YS .Tdu2wxx92tHUFda0pQkM7 ._3QNVZjB40c0mWzT3kRPS4o{box-sizing:border-box;width:100%;padding:4px 7px;border:1px solid #d9d9d9;border-radius:4px;outline:none}._2B_MBpF7swXfI1jtDON4YS .Tdu2wxx92tHUFda0pQkM7._2Jio1kMypbi9R2Isbzf_Z7{display:none}._2B_MBpF7swXfI1jtDON4YS .oebpIJETd572aj8cgCHiC{display:block;padding:7px 16px;color:rgba(0,0,0,.25);cursor:not-allowed}@keyframes _21X1U27xYleYdbKo6yuHqk{0%{transform:scale(1);opacity:.5}to{transform:scale(1.6);opacity:0}}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4{position:relative}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span.uB1rgOUC14-gYn6kP2jxh,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span.uB1rgOUC14-gYn6kP2jxh{position:relative;z-index:1}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span.uB1rgOUC14-gYn6kP2jxh._1m4iQUcL1hsRPSkwuxZ30e,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span.uB1rgOUC14-gYn6kP2jxh._1m4iQUcL1hsRPSkwuxZ30e{pointer-events:none}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span._38RRRh5s15LM-VKziqlZau,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span._38RRRh5s15LM-VKziqlZau{position:relative;z-index:1}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span.nMUQbT4bWOoxOFxci4eET,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span.nMUQbT4bWOoxOFxci4eET{border-radius:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span.nMUQbT4bWOoxOFxci4eET:hover,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span.nMUQbT4bWOoxOFxci4eET:hover{background:transparent}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span.nMUQbT4bWOoxOFxci4eET:hover:before,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span.nMUQbT4bWOoxOFxci4eET:hover:before{background:#e6f7ff}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span.nMUQbT4bWOoxOFxci4eET._2QvVNc4FXbIf1BxoboF8R8,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span.nMUQbT4bWOoxOFxci4eET._2QvVNc4FXbIf1BxoboF8R8{color:#fff;background:transparent}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span.nMUQbT4bWOoxOFxci4eET:before,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span.nMUQbT4bWOoxOFxci4eET:before{position:absolute;right:0;left:0;height:24px;transition:all .3s;content:\"\"}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li span.nMUQbT4bWOoxOFxci4eET>span,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li span.nMUQbT4bWOoxOFxci4eET>span{position:relative;z-index:1}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li._2TiFOzNZu_yOnyn80gD-Xi>span.uB1rgOUC14-gYn6kP2jxh,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li._2TiFOzNZu_yOnyn80gD-Xi>span.uB1rgOUC14-gYn6kP2jxh{color:#fff}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li._2TiFOzNZu_yOnyn80gD-Xi>span._38RRRh5s15LM-VKziqlZau ._1odwtHnWaKDfdUN9wKeTml,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li._2TiFOzNZu_yOnyn80gD-Xi>span._38RRRh5s15LM-VKziqlZau ._1odwtHnWaKDfdUN9wKeTml{border-color:#1890ff}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li._2TiFOzNZu_yOnyn80gD-Xi>span._38RRRh5s15LM-VKziqlZau._35_Oiqc6MsuwPYy1kV4XZK:after,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li._2TiFOzNZu_yOnyn80gD-Xi>span._38RRRh5s15LM-VKziqlZau._35_Oiqc6MsuwPYy1kV4XZK:after{border-color:#fff}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li._2TiFOzNZu_yOnyn80gD-Xi>span._38RRRh5s15LM-VKziqlZau._35_Oiqc6MsuwPYy1kV4XZK ._1odwtHnWaKDfdUN9wKeTml,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li._2TiFOzNZu_yOnyn80gD-Xi>span._38RRRh5s15LM-VKziqlZau._35_Oiqc6MsuwPYy1kV4XZK ._1odwtHnWaKDfdUN9wKeTml{background:#fff}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li._2TiFOzNZu_yOnyn80gD-Xi>span._38RRRh5s15LM-VKziqlZau._35_Oiqc6MsuwPYy1kV4XZK ._1odwtHnWaKDfdUN9wKeTml:after,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li._2TiFOzNZu_yOnyn80gD-Xi>span._38RRRh5s15LM-VKziqlZau._35_Oiqc6MsuwPYy1kV4XZK ._1odwtHnWaKDfdUN9wKeTml:after{border-color:#1890ff}.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4 ._3shUnC5Tlnyks2HmhTPxed>li._2TiFOzNZu_yOnyn80gD-Xi>span.nMUQbT4bWOoxOFxci4eET:before,.tXimqUKN4dRA2VIy-NOQX._1t7woQyCecpPw7LiFauJY4>li._2TiFOzNZu_yOnyn80gD-Xi>span.nMUQbT4bWOoxOFxci4eET:before{background:#1890ff}._38RRRh5s15LM-VKziqlZau{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";position:relative;top:-.09em;display:inline-block;line-height:1;white-space:nowrap;vertical-align:middle;outline:none;cursor:pointer}._1Uf_n4Uv5jlYoWVSQzmrAm:hover ._1odwtHnWaKDfdUN9wKeTml,._3a5kDHzUQQ2zvjhyhKo7_J:focus+._1odwtHnWaKDfdUN9wKeTml,._38RRRh5s15LM-VKziqlZau:hover ._1odwtHnWaKDfdUN9wKeTml{border-color:#1890ff}._35_Oiqc6MsuwPYy1kV4XZK:after{top:0;height:100%;border:1px solid #1890ff;border-radius:2px;visibility:hidden;animation:_21X1U27xYleYdbKo6yuHqk .36s ease-in-out;animation-fill-mode:backwards;content:\"\"}._1Uf_n4Uv5jlYoWVSQzmrAm:hover ._38RRRh5s15LM-VKziqlZau:after,._38RRRh5s15LM-VKziqlZau:hover:after{visibility:visible}._1odwtHnWaKDfdUN9wKeTml{position:relative;top:0;left:0;display:block;width:16px;height:16px;background-color:#fff;border:1px solid #d9d9d9;border-radius:2px;border-collapse:separate;transition:all .3s}._1odwtHnWaKDfdUN9wKeTml:after{position:absolute;top:50%;left:22%;display:table;width:5.71428571px;height:9.14285714px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg) scale(0) translate(-50%,-50%);opacity:0;transition:all .1s cubic-bezier(.71,-.46,.88,.6),opacity .1s;content:\" \"}._3a5kDHzUQQ2zvjhyhKo7_J{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;width:100%;height:100%;cursor:pointer;opacity:0}._35_Oiqc6MsuwPYy1kV4XZK ._1odwtHnWaKDfdUN9wKeTml:after{position:absolute;display:table;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg) scale(1) translate(-50%,-50%);opacity:1;transition:all .2s cubic-bezier(.12,.4,.29,1.46) .1s;content:\" \"}._35_Oiqc6MsuwPYy1kV4XZK ._1odwtHnWaKDfdUN9wKeTml{background-color:#1890ff;border-color:#1890ff}._1WHz5Hm-Ojs7A2jANk4oV{cursor:not-allowed}._1WHz5Hm-Ojs7A2jANk4oV._35_Oiqc6MsuwPYy1kV4XZK ._1odwtHnWaKDfdUN9wKeTml:after{border-color:rgba(0,0,0,.25);animation-name:_1CY6uej5ij2TMImio1u0wc}._1WHz5Hm-Ojs7A2jANk4oV ._3a5kDHzUQQ2zvjhyhKo7_J{cursor:not-allowed}._1WHz5Hm-Ojs7A2jANk4oV ._1odwtHnWaKDfdUN9wKeTml{background-color:#f5f5f5;border-color:#d9d9d9!important}._1WHz5Hm-Ojs7A2jANk4oV ._1odwtHnWaKDfdUN9wKeTml:after{border-color:#f5f5f5;border-collapse:separate;animation-name:_1CY6uej5ij2TMImio1u0wc}._1WHz5Hm-Ojs7A2jANk4oV+span{color:rgba(0,0,0,.25);cursor:not-allowed}._1Uf_n4Uv5jlYoWVSQzmrAm:hover ._1WHz5Hm-Ojs7A2jANk4oV:after,._1WHz5Hm-Ojs7A2jANk4oV:hover:after{visibility:hidden}._1Uf_n4Uv5jlYoWVSQzmrAm{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block;line-height:unset;cursor:pointer}._1Uf_n4Uv5jlYoWVSQzmrAm._3T_4_ARmV3ip_HUktGMzK8{cursor:not-allowed}._1Uf_n4Uv5jlYoWVSQzmrAm+._1Uf_n4Uv5jlYoWVSQzmrAm{margin-left:8px}._38RRRh5s15LM-VKziqlZau+span{padding-right:8px;padding-left:8px}._3IoUlzG6d4r5tiAxBgL0Mb{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";display:inline-block}._3Xbv8wen4jKh7taCp5fJYO{display:inline-block;margin-right:8px}._3Xbv8wen4jKh7taCp5fJYO:last-child{margin-right:0}._3Xbv8wen4jKh7taCp5fJYO+._3Xbv8wen4jKh7taCp5fJYO{margin-left:0}._28qUK4--zNKlPx807owR3K ._1odwtHnWaKDfdUN9wKeTml{background-color:#fff;border-color:#d9d9d9}._28qUK4--zNKlPx807owR3K ._1odwtHnWaKDfdUN9wKeTml:after{top:50%;left:50%;width:8px;height:8px;background-color:#1890ff;border:0;transform:translate(-50%,-50%) scale(1);opacity:1;content:\" \"}._28qUK4--zNKlPx807owR3K._1WHz5Hm-Ojs7A2jANk4oV ._1odwtHnWaKDfdUN9wKeTml:after{background-color:rgba(0,0,0,.25);border-color:rgba(0,0,0,.25)}.tXimqUKN4dRA2VIy-NOQX{box-sizing:border-box;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";margin:0;padding:0}._35_Oiqc6MsuwPYy1kV4XZK:after{position:absolute;top:16.67%;left:0;width:100%;height:66.67%}.tXimqUKN4dRA2VIy-NOQX ol,.tXimqUKN4dRA2VIy-NOQX ul{margin:0;padding:0;list-style:none}.tXimqUKN4dRA2VIy-NOQX li{margin:0;padding:4px 0;white-space:nowrap;list-style:none;outline:0}.tXimqUKN4dRA2VIy-NOQX li span[draggable=true],.tXimqUKN4dRA2VIy-NOQX li span[draggable]{line-height:20px;border-top:2px solid transparent;border-bottom:2px solid transparent;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-khtml-user-drag:element;-webkit-user-drag:element}.tXimqUKN4dRA2VIy-NOQX li._-86y1C_orEcn3j3-v7gmX>span[draggable]{color:#fff;background-color:#1890ff;opacity:.8}.tXimqUKN4dRA2VIy-NOQX li._3ml_CLU_aqwQBQLQ3HiZoJ>span[draggable]{border-top-color:#1890ff}.tXimqUKN4dRA2VIy-NOQX li._2-G5w1nT9bohoWjR_A_BaU>span[draggable]{border-bottom-color:#1890ff}.tXimqUKN4dRA2VIy-NOQX li.Us43Qi7jro2p5xJpEFQgv>span{color:#f5222d!important;font-weight:500!important}.tXimqUKN4dRA2VIy-NOQX li._3XIZTgJez3cVMsXA2QtswD span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._2PCDphFOklH3qy-QxJOIyG,.tXimqUKN4dRA2VIy-NOQX li._3XIZTgJez3cVMsXA2QtswD span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._2PCDphFOklH3qy-QxJOIyG{position:absolute;left:0;display:inline-block;width:24px;height:24px;color:#1890ff;font-size:14px;transform:none}.tXimqUKN4dRA2VIy-NOQX li._3XIZTgJez3cVMsXA2QtswD span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._2PCDphFOklH3qy-QxJOIyG svg,.tXimqUKN4dRA2VIy-NOQX li._3XIZTgJez3cVMsXA2QtswD span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._2PCDphFOklH3qy-QxJOIyG svg{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}:root .tXimqUKN4dRA2VIy-NOQX li._3XIZTgJez3cVMsXA2QtswD span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe:after,:root .tXimqUKN4dRA2VIy-NOQX li._3XIZTgJez3cVMsXA2QtswD span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ:after{opacity:0}.tXimqUKN4dRA2VIy-NOQX li ul{margin:0;padding:0 0 0 18px}.tXimqUKN4dRA2VIy-NOQX li .nMUQbT4bWOoxOFxci4eET{display:inline-block;height:24px;margin:0;padding:0 5px;color:rgba(0,0,0,.65);line-height:24px;text-decoration:none;vertical-align:top;border-radius:2px;cursor:pointer;transition:all .3s}.tXimqUKN4dRA2VIy-NOQX li .nMUQbT4bWOoxOFxci4eET:hover{background-color:#e6f7ff}.tXimqUKN4dRA2VIy-NOQX li .nMUQbT4bWOoxOFxci4eET._2QvVNc4FXbIf1BxoboF8R8{background-color:#bae7ff}.tXimqUKN4dRA2VIy-NOQX li span._38RRRh5s15LM-VKziqlZau{top:auto;height:24px;margin:0 4px 0 2px;padding:4px 0}.tXimqUKN4dRA2VIy-NOQX li span._2NZcuMeo194xMfCzNdUQ9g,.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh{display:inline-block;width:24px;height:24px;margin:0;line-height:24px;text-align:center;vertical-align:top;border:0 none;outline:none;cursor:pointer}.tXimqUKN4dRA2VIy-NOQX li span._2NZcuMeo194xMfCzNdUQ9g:empty{display:none}.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh{position:relative}.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._1m4iQUcL1hsRPSkwuxZ30e{cursor:default}.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3iQjYMymFtoXZ_JuFMpsMI,.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3xAf4EQm7paPCHrnsxJhF8{font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg);display:inline-block;font-weight:700}:root .tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3iQjYMymFtoXZ_JuFMpsMI,:root .tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3xAf4EQm7paPCHrnsxJhF8{font-size:12px}.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3iQjYMymFtoXZ_JuFMpsMI svg,.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3xAf4EQm7paPCHrnsxJhF8 svg{transition:transform .3s}.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3iQjYMymFtoXZ_JuFMpsMI,.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3xAf4EQm7paPCHrnsxJhF8{font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg);display:inline-block;font-weight:700}:root .tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3iQjYMymFtoXZ_JuFMpsMI,:root .tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3xAf4EQm7paPCHrnsxJhF8{font-size:12px}.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3iQjYMymFtoXZ_JuFMpsMI svg,.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3xAf4EQm7paPCHrnsxJhF8 svg{transition:transform .3s}.tXimqUKN4dRA2VIy-NOQX li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3iQjYMymFtoXZ_JuFMpsMI svg{transform:rotate(-90deg)}.tXimqUKN4dRA2VIy-NOQX li:last-child>span._2NZcuMeo194xMfCzNdUQ9g:before,.tXimqUKN4dRA2VIy-NOQX li:last-child>span.uB1rgOUC14-gYn6kP2jxh:before{display:none}.tXimqUKN4dRA2VIy-NOQX>li:first-child{padding-top:7px}.tXimqUKN4dRA2VIy-NOQX>li:last-child{padding-bottom:7px}._3shUnC5Tlnyks2HmhTPxed>li:first-child{padding-top:8px}._3shUnC5Tlnyks2HmhTPxed>li:last-child{padding-bottom:0}li._1BSxvvCCNyUz43IdtinMf_>.nMUQbT4bWOoxOFxci4eET,li._1BSxvvCCNyUz43IdtinMf_>.nMUQbT4bWOoxOFxci4eET span,li._1BSxvvCCNyUz43IdtinMf_>span:not(.uB1rgOUC14-gYn6kP2jxh){color:rgba(0,0,0,.25);cursor:not-allowed}li._1BSxvvCCNyUz43IdtinMf_>.nMUQbT4bWOoxOFxci4eET:hover{background:transparent}._1d5qKjhbj2LEPGJrB7TauU,.K5oHVclmJCP372UcQwRU9{margin-right:2px;vertical-align:top}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li{position:relative}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh{color:rgba(0,0,0,.45);background:#fff}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._1m4iQUcL1hsRPSkwuxZ30e ._3iQjYMymFtoXZ_JuFMpsMI,.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._1m4iQUcL1hsRPSkwuxZ30e ._3xAf4EQm7paPCHrnsxJhF8{display:inline-block;font-weight:400;font-size:12px}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._1m4iQUcL1hsRPSkwuxZ30e ._3iQjYMymFtoXZ_JuFMpsMI svg,.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._1m4iQUcL1hsRPSkwuxZ30e ._3xAf4EQm7paPCHrnsxJhF8 svg{transition:transform .3s}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3iQjYMymFtoXZ_JuFMpsMI,.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3xAf4EQm7paPCHrnsxJhF8{display:inline-block;font-weight:400;font-size:12px}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3iQjYMymFtoXZ_JuFMpsMI svg,.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._3QaAa3GLGS5rhW5tIeOPxZ ._3xAf4EQm7paPCHrnsxJhF8 svg{transition:transform .3s}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3iQjYMymFtoXZ_JuFMpsMI,.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3xAf4EQm7paPCHrnsxJhF8{display:inline-block;font-weight:400;font-size:12px}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3iQjYMymFtoXZ_JuFMpsMI svg,.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li span.uB1rgOUC14-gYn6kP2jxh._2GpmVQolEYAiPyq_3hLqbe ._3xAf4EQm7paPCHrnsxJhF8 svg{transition:transform .3s}.tXimqUKN4dRA2VIy-NOQX._1rFSdyrHgGXDR8pLi4nenc li:not(:last-child):before{position:absolute;left:12px;width:1px;height:100%;height:calc(100% - 22px);margin:22px 0 0;border-left:1px solid #d9d9d9;content:\" \"}.tXimqUKN4dRA2VIy-NOQX._3KKsaG-B0XgBxbw1Tt2Jkp ._3XIZTgJez3cVMsXA2QtswD ._2NZcuMeo194xMfCzNdUQ9g{display:none}.tXimqUKN4dRA2VIy-NOQX.O_EYOu8jKTbRLC-v94y3R li .nMUQbT4bWOoxOFxci4eET{width:calc(100% - 24px)}.tXimqUKN4dRA2VIy-NOQX.O_EYOu8jKTbRLC-v94y3R li span._38RRRh5s15LM-VKziqlZau+.nMUQbT4bWOoxOFxci4eET{width:calc(100% - 46px)}._1ev75OJ3m8MmeuEoQQJ7jo{color:rgba(0,0,0,.65)}._1ev75OJ3m8MmeuEoQQJ7jo._3MZGF7tjXldT1slpAxNhi2{color:rgba(0,0,0,.45)}._1ev75OJ3m8MmeuEoQQJ7jo._2RAD1zM6Bevz4eCB4KSIJO{color:#faad14}._1ev75OJ3m8MmeuEoQQJ7jo._3Bnp6LkhK4JPfInTFZwHbe{color:#f5222d}._1ev75OJ3m8MmeuEoQQJ7jo._1gIdHV5ngUEKgnBbTVO8sR{color:rgba(0,0,0,.25);cursor:not-allowed;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1ev75OJ3m8MmeuEoQQJ7jo p,div._1ev75OJ3m8MmeuEoQQJ7jo{margin-bottom:1em}._1ev75OJ3m8MmeuEoQQJ7jo h1,h1._1ev75OJ3m8MmeuEoQQJ7jo{margin-bottom:.5em;color:rgba(0,0,0,.85);font-weight:600;font-size:38px;line-height:1.23}._1ev75OJ3m8MmeuEoQQJ7jo h2,h2._1ev75OJ3m8MmeuEoQQJ7jo{margin-bottom:.5em;color:rgba(0,0,0,.85);font-weight:600;font-size:30px;line-height:1.35}._1ev75OJ3m8MmeuEoQQJ7jo h3,h3._1ev75OJ3m8MmeuEoQQJ7jo{margin-bottom:.5em;color:rgba(0,0,0,.85);font-weight:600;font-size:24px;line-height:1.35}._1ev75OJ3m8MmeuEoQQJ7jo h4,h4._1ev75OJ3m8MmeuEoQQJ7jo{margin-bottom:.5em;color:rgba(0,0,0,.85);font-weight:600;font-size:20px;line-height:1.4}._1ev75OJ3m8MmeuEoQQJ7jo+h1._1ev75OJ3m8MmeuEoQQJ7jo,._1ev75OJ3m8MmeuEoQQJ7jo+h2._1ev75OJ3m8MmeuEoQQJ7jo,._1ev75OJ3m8MmeuEoQQJ7jo+h3._1ev75OJ3m8MmeuEoQQJ7jo,._1ev75OJ3m8MmeuEoQQJ7jo+h4._1ev75OJ3m8MmeuEoQQJ7jo,._1ev75OJ3m8MmeuEoQQJ7jo div+h1,._1ev75OJ3m8MmeuEoQQJ7jo div+h2,._1ev75OJ3m8MmeuEoQQJ7jo div+h3,._1ev75OJ3m8MmeuEoQQJ7jo div+h4,._1ev75OJ3m8MmeuEoQQJ7jo h1+h1,._1ev75OJ3m8MmeuEoQQJ7jo h1+h2,._1ev75OJ3m8MmeuEoQQJ7jo h1+h3,._1ev75OJ3m8MmeuEoQQJ7jo h1+h4,._1ev75OJ3m8MmeuEoQQJ7jo h2+h1,._1ev75OJ3m8MmeuEoQQJ7jo h2+h2,._1ev75OJ3m8MmeuEoQQJ7jo h2+h3,._1ev75OJ3m8MmeuEoQQJ7jo h2+h4,._1ev75OJ3m8MmeuEoQQJ7jo h3+h1,._1ev75OJ3m8MmeuEoQQJ7jo h3+h2,._1ev75OJ3m8MmeuEoQQJ7jo h3+h3,._1ev75OJ3m8MmeuEoQQJ7jo h3+h4,._1ev75OJ3m8MmeuEoQQJ7jo h4+h1,._1ev75OJ3m8MmeuEoQQJ7jo h4+h2,._1ev75OJ3m8MmeuEoQQJ7jo h4+h3,._1ev75OJ3m8MmeuEoQQJ7jo h4+h4,._1ev75OJ3m8MmeuEoQQJ7jo li+h1,._1ev75OJ3m8MmeuEoQQJ7jo li+h2,._1ev75OJ3m8MmeuEoQQJ7jo li+h3,._1ev75OJ3m8MmeuEoQQJ7jo li+h4,._1ev75OJ3m8MmeuEoQQJ7jo p+h1,._1ev75OJ3m8MmeuEoQQJ7jo p+h2,._1ev75OJ3m8MmeuEoQQJ7jo p+h3,._1ev75OJ3m8MmeuEoQQJ7jo p+h4,._1ev75OJ3m8MmeuEoQQJ7jo ul+h1,._1ev75OJ3m8MmeuEoQQJ7jo ul+h2,._1ev75OJ3m8MmeuEoQQJ7jo ul+h3,._1ev75OJ3m8MmeuEoQQJ7jo ul+h4{margin-top:1.2em}span._1E0vzK3c1cPu6572DXhC_H{display:inline-block}._1ev75OJ3m8MmeuEoQQJ7jo a{color:#1890ff;text-decoration:none;outline:none;cursor:pointer;transition:color .3s}._1ev75OJ3m8MmeuEoQQJ7jo a:focus,._1ev75OJ3m8MmeuEoQQJ7jo a:hover{color:#40a9ff}._1ev75OJ3m8MmeuEoQQJ7jo a:active{color:#096dd9}._1ev75OJ3m8MmeuEoQQJ7jo a:active,._1ev75OJ3m8MmeuEoQQJ7jo a:hover{text-decoration:none}._1ev75OJ3m8MmeuEoQQJ7jo a[disabled]{color:rgba(0,0,0,.25);cursor:not-allowed;pointer-events:none}._1ev75OJ3m8MmeuEoQQJ7jo code{margin:0 .2em;padding:.2em .4em .1em;font-size:85%;background:rgba(0,0,0,.06);border:1px solid rgba(0,0,0,.06);border-radius:3px}._1ev75OJ3m8MmeuEoQQJ7jo mark{padding:0;background-color:#ffe58f}._1ev75OJ3m8MmeuEoQQJ7jo ins,._1ev75OJ3m8MmeuEoQQJ7jo u{text-decoration:underline;-webkit-text-decoration-skip:ink;text-decoration-skip-ink:auto}._1ev75OJ3m8MmeuEoQQJ7jo del,._1ev75OJ3m8MmeuEoQQJ7jo s{text-decoration:line-through}._1ev75OJ3m8MmeuEoQQJ7jo strong{font-weight:600}._1zf2EeUKjo7bccttxkcq6M,._2Ahk5tPntfGw2cr4-xt03V,.o8Y8Dk5CvUCCTrq11I3rz{color:#1890ff;text-decoration:none;outline:none;cursor:pointer;transition:color .3s;margin-left:8px}._1zf2EeUKjo7bccttxkcq6M:focus,._1zf2EeUKjo7bccttxkcq6M:hover,._2Ahk5tPntfGw2cr4-xt03V:focus,._2Ahk5tPntfGw2cr4-xt03V:hover,.o8Y8Dk5CvUCCTrq11I3rz:focus,.o8Y8Dk5CvUCCTrq11I3rz:hover{color:#40a9ff}._1zf2EeUKjo7bccttxkcq6M:active,._2Ahk5tPntfGw2cr4-xt03V:active,.o8Y8Dk5CvUCCTrq11I3rz:active{color:#096dd9}.ujyyT6UwnVTZjnrrPwaix,.ujyyT6UwnVTZjnrrPwaix:focus,.ujyyT6UwnVTZjnrrPwaix:hover{color:#52c41a}._3v1ZIEgEjmSQTuLp66KLE4{position:relative}div._3v1ZIEgEjmSQTuLp66KLE4{left:-12px;margin-top:-5px;margin-bottom:calc(1em - 4px - 2px)}._1ck3piiHKROOEkN938fuMQ{position:absolute;right:10px;bottom:8px;color:rgba(0,0,0,.45);pointer-events:none}._3v1ZIEgEjmSQTuLp66KLE4 textarea{-moz-transition:none}._1ev75OJ3m8MmeuEoQQJ7jo ol,._1ev75OJ3m8MmeuEoQQJ7jo ul{margin:0 0 1em;padding:0}._1ev75OJ3m8MmeuEoQQJ7jo ol li,._1ev75OJ3m8MmeuEoQQJ7jo ul li{margin:0 0 0 20px;padding:0 0 0 4px}._1ev75OJ3m8MmeuEoQQJ7jo ul li{list-style-type:circle}._1ev75OJ3m8MmeuEoQQJ7jo ul li li{list-style-type:disc}._1ev75OJ3m8MmeuEoQQJ7jo ol li{list-style-type:decimal}.B5S47y3G1yod1Oizo2zn4{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._4mrVkJdsglGzMWKWcqKvc{display:-webkit-box;-webkit-line-clamp:3;\n  /*! autoprefixer: ignore next */overflow:hidden}._1h8t2iciEXSc8I7I3peHuM{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";outline:0}._1h8t2iciEXSc8I7I3peHuM p{margin:0}._1QVJI2fnyV8WPndtGtUZ97{display:block;width:100%;outline:none}._1h8t2iciEXSc8I7I3peHuM input[type=file]{cursor:pointer}._1h8t2iciEXSc8I7I3peHuM._9iXM9OS_aXr4g7iRh9moq{display:inline-block}._1h8t2iciEXSc8I7I3peHuM._24sB5tmdOkPrI3TqucEqE5{cursor:not-allowed}._1h8t2iciEXSc8I7I3peHuM.Z1UZhvuBxbvVRvpD7fBjV{display:table;float:left;width:104px;height:104px;margin-right:8px;margin-bottom:8px;text-align:center;vertical-align:top;background-color:#fafafa;border:1px dashed #d9d9d9;border-radius:4px;cursor:pointer;transition:border-color .3s ease}._1h8t2iciEXSc8I7I3peHuM.Z1UZhvuBxbvVRvpD7fBjV>._1h8t2iciEXSc8I7I3peHuM{display:table-cell;width:100%;height:100%;padding:8px;text-align:center;vertical-align:middle}._1h8t2iciEXSc8I7I3peHuM.Z1UZhvuBxbvVRvpD7fBjV:hover{border-color:#1890ff}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv{position:relative;width:100%;height:100%;text-align:center;background:#fafafa;border:1px dashed #d9d9d9;border-radius:4px;cursor:pointer;transition:border-color .3s}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv ._1h8t2iciEXSc8I7I3peHuM{padding:16px 0}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv._1KzVMnwBUl0vRHHHHHe5BP:not(._24sB5tmdOkPrI3TqucEqE5){border-color:#096dd9}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv._24sB5tmdOkPrI3TqucEqE5{cursor:not-allowed}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv ._1QVJI2fnyV8WPndtGtUZ97{display:table;height:100%}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv .MkwWPZ_lOStWiui53er-i{display:table-cell;vertical-align:middle}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv:not(._24sB5tmdOkPrI3TqucEqE5):hover{border-color:#40a9ff}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv p._2465qk-DAqgkYiRhlBNmLL{margin-bottom:20px}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv p._2465qk-DAqgkYiRhlBNmLL ._1oZ8xlpZEg3PzGp2jMNFuZ{color:#40a9ff;font-size:48px}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv p._1TT9GHfYZDW3synEMVUC8m{margin:0 0 4px;color:rgba(0,0,0,.85);font-size:16px}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv p._19HCH1CphgVwVW3YSDpXZq{color:rgba(0,0,0,.45);font-size:14px}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv ._1L4ck2wTdDCoauInK9YqtU{color:rgba(0,0,0,.25);font-size:30px;transition:all .3s}._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv ._1L4ck2wTdDCoauInK9YqtU:hover,._1h8t2iciEXSc8I7I3peHuM._1F9t52IU7ApWj6hldzXLrv:hover ._1L4ck2wTdDCoauInK9YqtU{color:rgba(0,0,0,.45)}._1aP8zqzfJuF4wFr6tZC1Of{zoom:1;display:inline-block;width:100%}._1aP8zqzfJuF4wFr6tZC1Of:after,._1aP8zqzfJuF4wFr6tZC1Of:before{display:table;content:\"\"}._1aP8zqzfJuF4wFr6tZC1Of:after{clear:both}._1HTbCHWxHGefqZTG56pUqH{box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:\"tnum\";zoom:1}._1HTbCHWxHGefqZTG56pUqH:after,._1HTbCHWxHGefqZTG56pUqH:before{display:table;content:\"\"}._1HTbCHWxHGefqZTG56pUqH:after{clear:both}._3Th3A8mA6g6IN_N-ftGtoQ:hover ._2kr8IlS1PgyWs3akY49oun{padding-right:14px}._3Th3A8mA6g6IN_N-ftGtoQ:hover ._23V42CLebjkzdToi2tsj-v{padding-right:28px}._1xZSB1ODw4SEJ9vy0WcP7v{position:relative;height:22px;margin-top:8px;font-size:14px}._3H9QkCizcyWMDFSPeXw-Wq{display:inline-block;width:100%;padding-left:22px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}._2kr8IlS1PgyWs3akY49oun{padding-right:14px}.gP44me5-rxpnlT5aeTuN7{position:absolute;right:0;opacity:0}.gP44me5-rxpnlT5aeTuN7._2XypUSzQZ-ErWYW3pZRoYI{top:25px;line-height:1;opacity:1}.gP44me5-rxpnlT5aeTuN7 ._1oZ8xlpZEg3PzGp2jMNFuZ{padding-right:6px;color:rgba(0,0,0,.45)}.fuJx6I0dwWXU3oe6jE-IR{height:100%;padding:0 12px 0 4px;transition:background-color .3s}.fuJx6I0dwWXU3oe6jE-IR>span{display:block;width:100%;height:100%}.fuJx6I0dwWXU3oe6jE-IR .hAONR7Qe_wjqwC-5U0i_Y,.fuJx6I0dwWXU3oe6jE-IR .M1pWPFIKw7Lipb7_xEhWj{position:absolute;top:5px;color:rgba(0,0,0,.45);font-size:14px}._1xZSB1ODw4SEJ9vy0WcP7v ._3EEcVNYgJHJafe89WJy5Un{display:inline-block;font-size:12px;font-size:10px\\9;transform:scale(.83333333) rotate(0deg);position:absolute;top:6px;right:4px;color:rgba(0,0,0,.45);line-height:0;cursor:pointer;opacity:0;transition:all .3s}:root ._1xZSB1ODw4SEJ9vy0WcP7v ._3EEcVNYgJHJafe89WJy5Un{font-size:12px}._1xZSB1ODw4SEJ9vy0WcP7v ._3EEcVNYgJHJafe89WJy5Un:hover{color:rgba(0,0,0,.65)}._1xZSB1ODw4SEJ9vy0WcP7v:hover .fuJx6I0dwWXU3oe6jE-IR{background-color:#e6f7ff}._1xZSB1ODw4SEJ9vy0WcP7v:hover ._3EEcVNYgJHJafe89WJy5Un,._1xZSB1ODw4SEJ9vy0WcP7v:hover .gP44me5-rxpnlT5aeTuN7{opacity:1}._1TPn2WG51dKO_9EomQJamO,._1TPn2WG51dKO_9EomQJamO ._3H9QkCizcyWMDFSPeXw-Wq,._1TPn2WG51dKO_9EomQJamO .hAONR7Qe_wjqwC-5U0i_Y{color:#f5222d}._1TPn2WG51dKO_9EomQJamO .gP44me5-rxpnlT5aeTuN7{opacity:1}._1TPn2WG51dKO_9EomQJamO .gP44me5-rxpnlT5aeTuN7 ._1oZ8xlpZEg3PzGp2jMNFuZ{color:#f5222d}._3O6SgyvISXhAiL51_8xXWB{position:absolute;bottom:-12px;width:100%;padding-left:26px;font-size:14px;line-height:0}._1zx25rlpwEFyDExms_i9_d ._1xZSB1ODw4SEJ9vy0WcP7v,._38d_4uXC-bnL21aqSfTCmT ._1xZSB1ODw4SEJ9vy0WcP7v{position:relative;height:66px;padding:8px;border:1px solid #d9d9d9;border-radius:4px}._1zx25rlpwEFyDExms_i9_d ._1xZSB1ODw4SEJ9vy0WcP7v:hover,._38d_4uXC-bnL21aqSfTCmT ._1xZSB1ODw4SEJ9vy0WcP7v:hover{background:transparent}._1zx25rlpwEFyDExms_i9_d ._1TPn2WG51dKO_9EomQJamO,._38d_4uXC-bnL21aqSfTCmT ._1TPn2WG51dKO_9EomQJamO{border-color:#f5222d}._1zx25rlpwEFyDExms_i9_d .fuJx6I0dwWXU3oe6jE-IR,._38d_4uXC-bnL21aqSfTCmT .fuJx6I0dwWXU3oe6jE-IR{padding:0}._1zx25rlpwEFyDExms_i9_d ._1xZSB1ODw4SEJ9vy0WcP7v:hover .fuJx6I0dwWXU3oe6jE-IR,._38d_4uXC-bnL21aqSfTCmT ._1xZSB1ODw4SEJ9vy0WcP7v:hover .fuJx6I0dwWXU3oe6jE-IR{background:transparent}._1zx25rlpwEFyDExms_i9_d ._10FWJL_ElsGwmHbZQjJ20L,._38d_4uXC-bnL21aqSfTCmT ._10FWJL_ElsGwmHbZQjJ20L{border-style:dashed}._1zx25rlpwEFyDExms_i9_d ._2iqplV1svpz_C02HnLAe57,._38d_4uXC-bnL21aqSfTCmT ._2iqplV1svpz_C02HnLAe57{position:absolute;top:8px;left:8px;width:48px;height:48px;font-size:26px;line-height:54px;text-align:center;opacity:.8}._1zx25rlpwEFyDExms_i9_d ._3L6H7DHR6f5mWJgKfS7k_C,._38d_4uXC-bnL21aqSfTCmT ._3L6H7DHR6f5mWJgKfS7k_C{position:absolute;top:50%;left:50%;font-size:26px;transform:translate(-50%,-50%)}._1zx25rlpwEFyDExms_i9_d ._1LDtmLnyxVVJ4vTysjEMxI,._38d_4uXC-bnL21aqSfTCmT ._1LDtmLnyxVVJ4vTysjEMxI{max-width:100%}._1zx25rlpwEFyDExms_i9_d ._2iqplV1svpz_C02HnLAe57 img,._38d_4uXC-bnL21aqSfTCmT ._2iqplV1svpz_C02HnLAe57 img{display:block;width:48px;height:48px;overflow:hidden}._1zx25rlpwEFyDExms_i9_d ._3H9QkCizcyWMDFSPeXw-Wq,._38d_4uXC-bnL21aqSfTCmT ._3H9QkCizcyWMDFSPeXw-Wq{display:inline-block;box-sizing:border-box;max-width:100%;margin:0 0 0 8px;padding-right:8px;padding-left:48px;overflow:hidden;line-height:44px;white-space:nowrap;text-overflow:ellipsis;transition:all .3s}._1zx25rlpwEFyDExms_i9_d ._2kr8IlS1PgyWs3akY49oun,._38d_4uXC-bnL21aqSfTCmT ._2kr8IlS1PgyWs3akY49oun{padding-right:18px}._1zx25rlpwEFyDExms_i9_d ._23V42CLebjkzdToi2tsj-v,._38d_4uXC-bnL21aqSfTCmT ._23V42CLebjkzdToi2tsj-v{padding-right:36px}._1zx25rlpwEFyDExms_i9_d ._10FWJL_ElsGwmHbZQjJ20L ._3H9QkCizcyWMDFSPeXw-Wq,._38d_4uXC-bnL21aqSfTCmT ._10FWJL_ElsGwmHbZQjJ20L ._3H9QkCizcyWMDFSPeXw-Wq{line-height:28px}._1zx25rlpwEFyDExms_i9_d ._3O6SgyvISXhAiL51_8xXWB,._38d_4uXC-bnL21aqSfTCmT ._3O6SgyvISXhAiL51_8xXWB{bottom:14px;width:calc(100% - 24px);margin-top:0;padding-left:56px}._1zx25rlpwEFyDExms_i9_d ._3EEcVNYgJHJafe89WJy5Un,._38d_4uXC-bnL21aqSfTCmT ._3EEcVNYgJHJafe89WJy5Un{position:absolute;top:8px;right:8px;line-height:1;opacity:1}._38d_4uXC-bnL21aqSfTCmT._1HTbCHWxHGefqZTG56pUqH:after{display:none}._1lE1BIY0LPrElzMaiPNAS_,._38d_4uXC-bnL21aqSfTCmT ._1xZSB1ODw4SEJ9vy0WcP7v{float:left;width:104px;height:104px;margin:0 8px 8px 0}._38d_4uXC-bnL21aqSfTCmT .fuJx6I0dwWXU3oe6jE-IR{position:relative;height:100%;overflow:hidden}._38d_4uXC-bnL21aqSfTCmT .fuJx6I0dwWXU3oe6jE-IR:before{position:absolute;z-index:1;width:100%;height:100%;background-color:rgba(0,0,0,.5);opacity:0;transition:all .3s;content:\" \"}._38d_4uXC-bnL21aqSfTCmT ._1xZSB1ODw4SEJ9vy0WcP7v:hover .fuJx6I0dwWXU3oe6jE-IR:before{opacity:1}._38d_4uXC-bnL21aqSfTCmT ._29iBs326z3n2T6343ZPGE9{position:absolute;top:50%;left:50%;z-index:10;white-space:nowrap;transform:translate(-50%,-50%);opacity:0;transition:all .3s}._38d_4uXC-bnL21aqSfTCmT ._29iBs326z3n2T6343ZPGE9 ._2Du4yA7FKCaJmgj6Kuk1ic,._38d_4uXC-bnL21aqSfTCmT ._29iBs326z3n2T6343ZPGE9 ._2E0msfda8QaiSudkXvP2g7,._38d_4uXC-bnL21aqSfTCmT ._29iBs326z3n2T6343ZPGE9 .DFGxkWBk7-8am7yetoBzJ{z-index:10;width:16px;margin:0 4px;color:hsla(0,0%,100%,.85);font-size:16px;cursor:pointer;transition:all .3s}._38d_4uXC-bnL21aqSfTCmT ._29iBs326z3n2T6343ZPGE9 ._2Du4yA7FKCaJmgj6Kuk1ic:hover,._38d_4uXC-bnL21aqSfTCmT ._29iBs326z3n2T6343ZPGE9 ._2E0msfda8QaiSudkXvP2g7:hover,._38d_4uXC-bnL21aqSfTCmT ._29iBs326z3n2T6343ZPGE9 .DFGxkWBk7-8am7yetoBzJ:hover{color:#fff}._38d_4uXC-bnL21aqSfTCmT ._29iBs326z3n2T6343ZPGE9:hover,._38d_4uXC-bnL21aqSfTCmT .fuJx6I0dwWXU3oe6jE-IR:hover+._29iBs326z3n2T6343ZPGE9{opacity:1}._38d_4uXC-bnL21aqSfTCmT ._2iqplV1svpz_C02HnLAe57,._38d_4uXC-bnL21aqSfTCmT ._2iqplV1svpz_C02HnLAe57 img{position:static;display:block;width:100%;height:100%;object-fit:cover}._38d_4uXC-bnL21aqSfTCmT ._3H9QkCizcyWMDFSPeXw-Wq{display:none;margin:8px 0 0;padding:0;line-height:1.5;text-align:center}._38d_4uXC-bnL21aqSfTCmT ._1Igm5W5FltLrR8VE6bPhGj+._3H9QkCizcyWMDFSPeXw-Wq{position:absolute;bottom:10px;display:block}._38d_4uXC-bnL21aqSfTCmT ._10FWJL_ElsGwmHbZQjJ20L._1xZSB1ODw4SEJ9vy0WcP7v{background-color:#fafafa}._38d_4uXC-bnL21aqSfTCmT ._10FWJL_ElsGwmHbZQjJ20L .fuJx6I0dwWXU3oe6jE-IR{height:auto}._38d_4uXC-bnL21aqSfTCmT ._10FWJL_ElsGwmHbZQjJ20L .fuJx6I0dwWXU3oe6jE-IR ._2Du4yA7FKCaJmgj6Kuk1ic,._38d_4uXC-bnL21aqSfTCmT ._10FWJL_ElsGwmHbZQjJ20L .fuJx6I0dwWXU3oe6jE-IR ._2E0msfda8QaiSudkXvP2g7,._38d_4uXC-bnL21aqSfTCmT ._10FWJL_ElsGwmHbZQjJ20L .fuJx6I0dwWXU3oe6jE-IR:before{display:none}._38d_4uXC-bnL21aqSfTCmT ._2GPNPss8r9pfPTI348B9gj{margin-top:18px;color:rgba(0,0,0,.45)}._38d_4uXC-bnL21aqSfTCmT ._3O6SgyvISXhAiL51_8xXWB{bottom:32px;padding-left:0}._1HTbCHWxHGefqZTG56pUqH ._3yx244PUIziwxp6bu8pLHe{color:#52c41a;font-weight:700}._1HTbCHWxHGefqZTG56pUqH ._1F2Eo0rsMZgpbOg3kp_mvk,._1HTbCHWxHGefqZTG56pUqH ._1Pdz8gRZCy6OvYroSZrGqe,._1HTbCHWxHGefqZTG56pUqH ._1Phim6COpesfJuXoh7LHtw,._1HTbCHWxHGefqZTG56pUqH ._3Ibm5Q3kTLKWn6ukU67M5T{animation-duration:.3s;animation-fill-mode:cubic-bezier(.78,.14,.15,.86)}._1HTbCHWxHGefqZTG56pUqH ._3Ibm5Q3kTLKWn6ukU67M5T{animation-name:_189Q1pQ01TJSafIXju2srA}._1HTbCHWxHGefqZTG56pUqH ._1Phim6COpesfJuXoh7LHtw{animation-name:xI7iqGcsjAOZMs2Q2wyvX}._1HTbCHWxHGefqZTG56pUqH ._1Pdz8gRZCy6OvYroSZrGqe{animation-name:LmqYNZGEWRX7SSFklVSAm}._1HTbCHWxHGefqZTG56pUqH ._1F2Eo0rsMZgpbOg3kp_mvk{animation-name:tPcGWxZo3eefNYxUQKdSn}@keyframes _189Q1pQ01TJSafIXju2srA{0%{height:0;margin:0;padding:0;opacity:0}}@keyframes xI7iqGcsjAOZMs2Q2wyvX{to{height:0;margin:0;padding:0;opacity:0}}@keyframes LmqYNZGEWRX7SSFklVSAm{0%{width:0;height:0;margin:0;padding:0;opacity:0}}@keyframes tPcGWxZo3eefNYxUQKdSn{to{width:0;height:0;margin:0;padding:0;opacity:0}}", ""]);
	
	// exports
	exports.locals = {
		"clearfix": "GRAxHGgP4KbQU49MIYMhy",
		"anticon": "_1oZ8xlpZEg3PzGp2jMNFuZ",
		"anticon-icon": "_2a2Jxhx6-qqWCLHuIArc2k",
		"anticon-spin": "_2T5KIe2E01O08ArJZjBwJx",
		"loadingCircle": "Gr_4nuETdHDqjOknz5a9U",
		"fade-enter": "_242E5v8yZFoYNA4OeftlIX",
		"fade-appear": "_2yIIjXWrx8HwbiBeOJ7gdX",
		"fade-leave": "_1g2gTRrNLy24CadA0jRxpO",
		"fade-enter-active": "_1dmGqoN_XvvLLUQXoHIIbn",
		"fade-appear-active": "_3axE2tLt2DDMqvBILVEMBR",
		"antFadeIn": "tsKMliLjM5nxk0U_4cZVn",
		"fade-leave-active": "_1iGuqruo0WWqvUmGbUeHLE",
		"antFadeOut": "_8ZbC_DJdfpXbZBUOpZ3Cr",
		"move-up-enter": "_3O6v5VDnOMLJLvL1JCtQy3",
		"move-up-appear": "riJZyqT7Q70ZZl_RkQqyj",
		"move-up-leave": "_2T2CHtH4XgVwCRHMaV3ayw",
		"move-up-enter-active": "KaewGU-uz3LKVRztEF57-",
		"move-up-appear-active": "_2B53VgZ-RtYYcsiWcdk6pk",
		"antMoveUpIn": "RcEs12kfajOcoBCT-GpKI",
		"move-up-leave-active": "_4yObpTmaBJmC5s1pcDxJp",
		"antMoveUpOut": "jTRGk-qJQWaDko4kBZfxg",
		"move-down-enter": "s_DTZSr0waV5kr-Tm20dD",
		"move-down-appear": "_3XZ4dtWJKkdq9R1Xmu106F",
		"move-down-leave": "_1DiObDT4u8f9Y897gxe9PH",
		"move-down-enter-active": "_3xk3cu82w4bBWbu0hxYwQe",
		"move-down-appear-active": "_2wJGs-4e9CRPyYdDWsh9uS",
		"antMoveDownIn": "_2Lfj8GIETyDn7FsnLjgMSW",
		"move-down-leave-active": "_1DHL72AB2-jlGYEBTVi3pP",
		"antMoveDownOut": "_3ZXvXgSEv2FfFIIAYCvE4y",
		"move-left-enter": "_3oReU6WPlquQ_8SU0pFChc",
		"move-left-appear": "_2bqrjM0DJm9_YD1XFY2ADL",
		"move-left-leave": "_2i3L63PguN9Dpl50vPt66j",
		"move-left-enter-active": "_3GbZZz38H2D27LzYxDJCC8",
		"move-left-appear-active": "_1T2H9eVwoV1tYHsInSeUmi",
		"antMoveLeftIn": "_2PtsioFep3Zhoj6_ZuefLT",
		"move-left-leave-active": "_2l4pfm-fqWBbZ7SOf29lUL",
		"antMoveLeftOut": "_2rXSohlMGgE-sjxltVphUw",
		"move-right-enter": "_2WThW35UHIgZC5daxRYHgt",
		"move-right-appear": "-gp1peJWX6WJ4WZ_iMD-z",
		"move-right-leave": "hlld-L1gRwXDzcnmJdwMJ",
		"move-right-enter-active": "_1lEiinVBZmX_DqkNBbUGu8",
		"move-right-appear-active": "_3jwxWmbs6m69pZ_0OkgUyO",
		"antMoveRightIn": "_1Z08p_YS3jHY07_7ngFzLo",
		"move-right-leave-active": "_7axc4JSxbSpOeWmtmCcEU",
		"antMoveRightOut": "cJpSuL12hmmVequ3tg4Oe",
		"ant-click-animating-node": "_13Kn8L5SZrD9eU43bEfYxr",
		"fadeEffect": "_3_W-3PzDq5urW3aTIYaMsy",
		"waveEffect": "_2Sc6xgJ_JLcUTn9aYPDbl_",
		"slide-up-enter": "_1vRvMYH3Kp_wSCSKo1Vzkx",
		"slide-up-appear": "_3BcFfbN5qAnzO13exrUs03",
		"slide-up-leave": "_3JPmXAUWZHG7TyCs5QZHGb",
		"slide-up-enter-active": "_1ULLr8re4ZnpLmsLEf9jim",
		"slide-up-appear-active": "rQ19DUBIWL66Zukwke2_C",
		"antSlideUpIn": "_2lqTGgogIItpImYAn3wMQO",
		"slide-up-leave-active": "ScIepRKcudwUEDzyD4-cX",
		"antSlideUpOut": "_2IDJAVNNcAmXsLtWbzNJtk",
		"slide-down-enter": "_3U26mI8v1P5mnWxpeY6WGl",
		"slide-down-appear": "_13M3iELddKrUZBZtrDutrC",
		"slide-down-leave": "nnu83yLJXtrbX26qRN8Ql",
		"slide-down-enter-active": "_1d3YwZDfYeQFLL1hGNfRl9",
		"slide-down-appear-active": "_1oph4ifflZofWhYZ30mQw4",
		"antSlideDownIn": "_3JK1uFdxrQM9RK51sOtrar",
		"slide-down-leave-active": "DA65YF9uBqCSmnAzuwyH",
		"antSlideDownOut": "_1F89QugyM0FQpooygKHf2k",
		"slide-left-enter": "_30OXgs2pqK7fkuFxdpMfY5",
		"slide-left-appear": "_22fvq84HK5LcqWmOfiyy2M",
		"slide-left-leave": "_3Gh6P4Ql9wnf86pkRZMzf4",
		"slide-left-enter-active": "_2lDndpWsv_W3joWMbiz8q4",
		"slide-left-appear-active": "_1Keo9exhwUVzJftLkQtIkF",
		"antSlideLeftIn": "xYmKqzhgXItCbyPzNG7DK",
		"slide-left-leave-active": "_1blKO9DK-2MInyDAZe6gyM",
		"antSlideLeftOut": "aWiaj1S3bdrixEVCv6jl5",
		"slide-right-enter": "lcy-kgC9kh2tWu_nSxOr1",
		"slide-right-appear": "_2WNm00xGXf63G71Cdrox0g",
		"slide-right-leave": "_177updpNu_ogWKAWgYeREG",
		"slide-right-enter-active": "_3TyAJl9FZjAHHHtJXKwVL3",
		"slide-right-appear-active": "_3PFYIOLZfgpGxApB3M74eA",
		"antSlideRightIn": "_2ErC7u5PkydcgIx1nvn53a",
		"slide-right-leave-active": "_22EzDOTdN9WwsihthGXfAe",
		"antSlideRightOut": "_1PU8ByzRPeFddREmytc6xJ",
		"swing-enter": "_16wcgwCGQ_jLl8nHWFe7iq",
		"swing-appear": "_9XOEXIbNDp87Yv3MvaT8T",
		"swing-enter-active": "pwyhBz_HkooK-dMdHXMh6",
		"swing-appear-active": "_3Ebdq4gSWkFOCtmLExCnCP",
		"antSwingIn": "UxEmIDdjBs3MplNP5UFx3",
		"zoom-enter": "_30--xMhxZ94JTK2d9gG6H5",
		"zoom-appear": "_1dq1hSnQ28O5mrHxyKeRa0",
		"zoom-leave": "_1YgzGl4Cg8r4L98w4bKHc",
		"zoom-enter-active": "_223a30KA5pYI5LbXrVEQL0",
		"zoom-appear-active": "_1VpJc9vXLf4V3hzrUlEwOE",
		"antZoomIn": "MpRT7DyQF1m-VY7aPPCYB",
		"zoom-leave-active": "_1uDppHf6JdMeIJCzdzEIXi",
		"antZoomOut": "_1vuPnqMO_T4JJwqOLazeij",
		"zoom-big-enter": "_2H1LfkbcwoN8RTSOo_ag6P",
		"zoom-big-appear": "_1QIV4dFJN9Ntgg-dh-4u7V",
		"zoom-big-leave": "_2770rp_u6RadV_fszv4tcu",
		"zoom-big-enter-active": "-V8s0YhPDDMNAEHcRVYxf",
		"zoom-big-appear-active": "ncRvHKNWep6mV4iYNRoot",
		"antZoomBigIn": "c5mf4FXCF0QTY_a_rOpd7",
		"zoom-big-leave-active": "_13B1eoSndrgu1RoN1Q8hg5",
		"antZoomBigOut": "_1sFmlYzMjtL0HQENgQwwrd",
		"zoom-big-fast-enter": "_3X4aWDEK-IBXFoOPXSialQ",
		"zoom-big-fast-appear": "_13SegEJP_MMNzqYF5MyHBu",
		"zoom-big-fast-leave": "_2cHzdn3XK8HJa3b3fTpdVL",
		"zoom-big-fast-enter-active": "_2GFUBY_lE8Loo50dtXklqk",
		"zoom-big-fast-appear-active": "kij7wpKz8W7E4S4-JASIm",
		"zoom-big-fast-leave-active": "_2Rt9tQ15ww2w4a6de-V45C",
		"zoom-up-enter": "_3QnKTfcB2AonJrxnjM1Q7S",
		"zoom-up-appear": "_16qbuy5e4fq_F9AGL6jI4r",
		"zoom-up-leave": "_3C9B-1KZjJgoKOlgQqTpq6",
		"zoom-up-enter-active": "_3g8goyYCD1MPpDUzJBzVUb",
		"zoom-up-appear-active": "_1u4nGsnu7NHNHPfb7TY8dt",
		"antZoomUpIn": "_3vkv06gZsPpCT7n09GPxHF",
		"zoom-up-leave-active": "_1P4KFy_2SdhskyYkMzAs_H",
		"antZoomUpOut": "Sf_Lb8yVKL66PrLOYgJjw",
		"zoom-down-enter": "_1htT410frFKyzX80Av14sQ",
		"zoom-down-appear": "_3MqCteWlESS5iIF7dNgOIb",
		"zoom-down-leave": "_2FUShwmg3tCEVV4qNsmeHD",
		"zoom-down-enter-active": "-TEuLlrgZyoWY_IISKLkO",
		"zoom-down-appear-active": "_2RZPdzyXkOrjpu1u3Ay2VU",
		"antZoomDownIn": "Y1nWzmrvbXH3mMK4epmGj",
		"zoom-down-leave-active": "_2HYCQ5ARLFhQm89MrtNoFY",
		"antZoomDownOut": "_3Pk8_kTJOH-dNlW5jb8__S",
		"zoom-left-enter": "_2a5J8gXD3Tl7NADF0PAiIj",
		"zoom-left-appear": "l-D9Lhg38c0k8sF_zw8vP",
		"zoom-left-leave": "_2GPQ8BvBJ34Hcf9nvUTHe0",
		"zoom-left-enter-active": "f75_2kHchoOzmKRjO3P3R",
		"zoom-left-appear-active": "_1Yr9SRIzzy7b7K8V1Lm_fS",
		"antZoomLeftIn": "o7Y1KBWEB2VRlja4z4vJx",
		"zoom-left-leave-active": "_2O9-RcxpAfl1-xxwv8Fq-F",
		"antZoomLeftOut": "_2gr8DF8GOmqrMKGyuZcU4y",
		"zoom-right-enter": "_1CChw06B-tLjAxo2z1mqsR",
		"zoom-right-appear": "_3t8hHiPisJ4cqNw0dDt-ez",
		"zoom-right-leave": "QkkpWu39UXBIYDU2o49j-",
		"zoom-right-enter-active": "_24M4VLCG_rme-IgEvOUgra",
		"zoom-right-appear-active": "aCjGBZ9k_i331T2Yjx7Eo",
		"antZoomRightIn": "T8xl7BDfXXtFEmJ7Tdi7U",
		"zoom-right-leave-active": "_29v2w6jU1uHkcu8VpU06PQ",
		"antZoomRightOut": "_1DkeRqEzcaJVYtBP2dTeX6",
		"ant-motion-collapse-legacy": "_3dkILaNGzAl9_U-6u_8bJk",
		"ant-motion-collapse-legacy-active": "_1e95NGO32NqQq_IG5I3iyP",
		"ant-motion-collapse": "_1CdpxfCyaJLDUhMBYBI3_t",
		"ant-affix": "_2Gc5kWaUkFPslOaXTBif30",
		"ant-alert": "_15qE0OF--suQ5_51-8sSS-",
		"ant-alert-no-icon": "_1pQIMzuKNzM-srum7hfnLH",
		"ant-alert-closable": "_2KrqkRNB0Wq8vHI9lZerqC",
		"ant-alert-icon": "_2ZiWlHIHVEvOh2kMqh0MOD",
		"ant-alert-description": "_3XrL6b6jkLzxv7GOrpUxDK",
		"ant-alert-success": "gXX0oQVSpeBAewhqrUDhj",
		"ant-alert-info": "_35JTMUls_Q-HIVNBvYuwHf",
		"ant-alert-warning": "pNo_RWff8pOJcO2vH2W7x",
		"ant-alert-error": "Mga1iPIKd7lgyWU1pfUQv",
		"ant-alert-close-icon": "_3HJyMP81-tnmlSmRfnnulx",
		"anticon-close": "_3EEcVNYgJHJafe89WJy5Un",
		"ant-alert-close-text": "_3OEsGqj6n4Goge3kqIVBgx",
		"ant-alert-with-description": "_29R0GIAD3zs4JFaQc8Dfc",
		"ant-alert-message": "fggLJ9Apb9IbJYwDLM9m8",
		"ant-alert-closing": "_1fhZsiy01D0j5ISIqdAiXe",
		"ant-alert-slide-up-leave": "_1iaeSvF8P5CUUaGlj_ByrS",
		"antAlertSlideUpOut": "_1Ea-oHwxZLo3mXxH56aM2y",
		"ant-alert-banner": "_3MQVMSefFtHHE_QYCjGNhz",
		"ant-anchor": "_2dIlk0xFhtVenLpTVx1LIk",
		"ant-anchor-wrapper": "_3T29BvbgPDiT9oUfLhMwnz",
		"ant-anchor-ink": "_1TWQErB-pr4ySnnTINPlsi",
		"ant-anchor-ink-ball": "_18iTx25M7zvZTLa3EUl4by",
		"visible": "xYUaTAqUuX9wO0g2kP0l0",
		"fixed": "_2Z6fkhTw-MEaqRfY86Ki9u",
		"ant-anchor-link": "NWc_VaZP7RbrNufUp4ddL",
		"ant-anchor-link-title": "_1WW7FGgqg2ZKo4iOVZrdKd",
		"ant-anchor-link-active": "_2pS_QN32RwPGvI5otgHqBB",
		"ant-select-auto-complete": "_29cP-s7uNehcuQVbYj4ozX",
		"ant-select": "_1cNj85ZY8m7JAcdkxJ6Uc5",
		"ant-select-selection": "_7Eyy1YVEF5PxhoJBXqU_f",
		"ant-select-selection__rendered": "_2iYmNz-ByGCt4R8wmBpwCH",
		"ant-select-selection__placeholder": "_2B-xot8uBvYVWiXXFm21nC",
		"ant-select-selection--single": "_97CQv9OIOWBrwr_cN2xfc",
		"ant-select-search--inline": "_3x43iIKADuc502oIMWL0XL",
		"ant-select-allow-clear": "_34q6vY4D86-q3YxTiKjerN",
		"ant-input": "_3pPc-OF79GHv_bF35yGDY1",
		"ant-select-lg": "_6wpHSs3q6VdSXaBCsdq6x",
		"ant-select-sm": "_3K8GmBeFUGeCVgLy-2eY0s",
		"ant-input-group": "_2Foe83O-mWINoezjOoes92",
		"ant-select-search__field": "_3QNVZjB40c0mWzT3kRPS4o",
		"ant-input-affix-wrapper": "_2UvyS7V7PyOdhmJGWNnsQ9",
		"ant-select-arrow": "eho88gQax86VLUCOnQl3y",
		"ant-select-arrow-icon": "_3IgubU0xEedwAutt85YWBK",
		"ant-select-focused": "_3h6aN10we1czWU8G2MA6y_",
		"ant-select-selection__clear": "_1pcT_amGFsaUucEvS4JQxC",
		"ant-select-selection-selected-value": "_1EQQ6QCFrDq86hXZOH3pNb",
		"ant-select-no-arrow": "_2slFdOVPJDGvh6vYFQ7LTb",
		"ant-select-disabled": "_2S_l4pRxOOamuZuhpIteKi",
		"ant-select-selection--multiple": "_2OYuEEegFtZL00LNyZS-lK",
		"ant-select-selection__choice": "_1Hj9jU8JFS_1IqyFQN2dNM",
		"ant-select-selection__choice__remove": "_12Kp3_TU-gpd2FSNEmrxc7",
		"ant-select-search__field__wrap": "_25sQaSQpL04XTINFK9Yi6x",
		"ant-select-search__field__placeholder": "_3UWuHUw8iiPdNtXMW8IxR6",
		"ant-select-search__field__mirror": "_2Tpvn1vT81zHxeRQiHeKyy",
		"ant-select-selection__choice__disabled": "_6yuRXaUAn2NCqhUWP3vba",
		"ant-select-selection__choice__content": "_1YXNcRChjdkdJY_TdBexXn",
		"ant-select-selection__choice__remove-icon": "_2tNJx1oOOpHR1hzUUYmO2S",
		"ant-select-show-arrow": "_3ck23EBaV-n0CzfUzZYU3X",
		"ant-select-open": "_1Wi0B5_u6mPgRTcwZk7Fyw",
		"ant-select-combobox": "N0hmOJAs_SkCxu8EXCVXU",
		"ant-select-dropdown": "WN7Z6DPhqHkerTCyV7wdv",
		"ant-select-dropdown-placement-bottomLeft": "_3BTa0fib-sM8ZIP8DD425i",
		"ant-select-dropdown-placement-topLeft": "_1gVCDWKYZyJR3NBRB45An-",
		"ant-select-dropdown-hidden": "_32x2M2CEyTUjfZn34dr_4f",
		"ant-select-dropdown-menu": "_1Vvmk2tQ1x9CsYl55hxov9",
		"ant-select-dropdown-menu-item-group-list": "_5BszMZWDlP5_DZADNvlQl",
		"ant-select-dropdown-menu-item": "_88uX0Vc4eGp6W7q-GPULH",
		"ant-select-dropdown-menu-item-group-title": "_3DsmG9_5oztY0l3auc1kX0",
		"ant-select-dropdown-menu-item-group": "_3mepb_q6FnKecz0duYBeue",
		"ant-select-dropdown-menu-item-disabled": "Hlpgl-I9defIxbK-7gnER",
		"ant-select-dropdown-menu-item-selected": "_10Ps61pXYbLw4Ao6o26TGi",
		"ant-select-dropdown-menu-item-active": "_2VWFr_6p3W4kFOA3XH16cw",
		"ant-select-dropdown-menu-item-divider": "_9hAFc9enJBZkBoeRYk5qi",
		"ant-select-dropdown--multiple": "_3Cd1B90tMa9ftnY7bnenv6",
		"ant-select-selected-icon": "_3qB4jXSep05-N8ldUnGH0u",
		"ant-select-dropdown--empty": "_3iQQKMXsE-0ctOE12ztO8N",
		"ant-select-dropdown-container-open": "_1RkPXKDp9_dHQGu0-nUoY4",
		"ant-select-dropdown-open": "_2LSJV3jd5aP0-mJ3UccftA",
		"ant-empty": "W1idWwUkjUeMPghSv6rw2",
		"ant-empty-image": "_2MpY-iSOHP7OkCk2l5lICJ",
		"ant-empty-description": "tEibQoOlonbiv4fMqlsrp",
		"ant-empty-footer": "_363dtGF6a3cwNZpPJctKgS",
		"ant-empty-normal": "_3fMhjPtRpyAmSH5MLC5ZKt",
		"ant-empty-small": "_1lq5n41-X8PpYQpiay2_3c",
		"ant-input-disabled": "_2A-ucu16pid4Gh76mY_Ebo",
		"ant-input-lg": "_2hZP2GaN_LKQwRGcY8oYw7",
		"ant-input-sm": "_3XkyZAEWYxNQKnj5oRB-hf",
		"ant-input-group-addon": "_1p84ImfXKXI0mpXrH3erRG",
		"ant-input-group-wrap": "_3dGKlYP1lLzLrUd1RT8uLF",
		"ant-input-group-lg": "_3StNdoTLSo85-EBhVduGKc",
		"ant-input-group-sm": "_28ogRmKLiWAFuajs6wQHQ4",
		"ant-input-group-compact": "_2UQSIjjV4RuRqwi4CqVlOs",
		"ant-input-group-compact-addon": "_4Z3_vLBkdx6ZBU3_P0are",
		"ant-input-group-compact-wrap": "GUlqbOE_Lde3kR_V24cFN",
		"ant-calendar-picker": "_1j4rLEirQnvEigyl0F5j16",
		"ant-cascader-picker": "_pEx_feJBV_Kj7nPjRgq4",
		"ant-mention-wrapper": "evz3k4BAlGZ29PrmHf8ZA",
		"ant-mention-editor": "FgcTqoSfeRhgxyye0BL99",
		"ant-time-picker": "ufc92ympr1e8GM1qw2Hz0",
		"ant-time-picker-input": "rbO6RzhtTm7Ha5feDxDOm",
		"ant-input-group-wrapper": "_2WUwSufUm-mWdZbWfdaTx0",
		"ant-cascader-picker-focused": "_2fDAzmrjntvwBWsvrRe6Jg",
		"ant-input-prefix": "_2eJRbHPkX4xdgtxeMSNzx",
		"ant-input-suffix": "_3JEoNL3m7Ci5dETGutSjIs",
		"ant-input-affix-wrapper-input-with-clear-btn": "_3fBw9iCv6caRMXShpPso-s",
		"ant-input-affix-wrapper-textarea-with-clear-btn": "_3bXbdFuisuLhFa84ghc58I",
		"ant-input-password-icon": "_1htlbyDWgZlaYQpzMqqx-N",
		"ant-input-clear-icon": "_1-iONiKMm8Xca6qFk7GRnk",
		"ant-input-textarea-clear-icon": "_2x5_NpV1CSAoM1OILgQQxR",
		"ant-input-search-icon": "cruQjhV40twVe_2LlwwvM",
		"ant-input-search-enter-button": "AswcrW7TSGC8OfYJuVWHr",
		"ant-input-search-button": "_3wckPmodLDaT7iLwLF79eH",
		"ant-btn": "_34ecc6_SGKef4Y6JfdE_DJ",
		"disabled": "_10gRqOxa4A45g-aoMVtjwB",
		"ant-btn-lg": "_24N8kMOEo48v88KpPB3fPF",
		"ant-btn-sm": "m7OIj5e4R4jh4ez3P5chZ",
		"active": "em_Pqz__Gx36paHRPTcGY",
		"ant-btn-disabled": "_2HRWKsYV3NKCsengWsaT1n",
		"ant-btn-primary": "_1hBh0D8Z27qUhgXC7swls9",
		"ant-btn-primary-disabled": "_2n9ezvu5zWvbTSje8a1htn",
		"ant-btn-group": "_351ag-o1wnW8fFXVy1ny9i",
		"ant-btn-ghost": "_28cW-V5GKksY7EnHAfGGy7",
		"ant-btn-ghost-disabled": "Sse4Jp3wPiasMhv97ZjQf",
		"ant-btn-dashed": "_36EpuJ5cohCuuC4Ya_CMIW",
		"ant-btn-dashed-disabled": "_3RioMuu-JEeE5z6QL9mjHl",
		"ant-btn-danger": "kRhGgtBu5MP6Yiupx7QY5",
		"ant-btn-danger-disabled": "_1bDFL62BT0OwkwSvapqFsH",
		"ant-btn-link": "hmK4fm7kmJWiBmE2QEBLL",
		"ant-btn-link-disabled": "ZBDYoEl7_6eCPKgX2Hv0J",
		"ant-btn-icon-only": "_2ocM8T51DT6FnbK5epT0eQ",
		"ant-btn-round": "_3KbNaV4fUjdt6wXlJ4HWNd",
		"ant-btn-circle": "_2tU8AyFhj9UYKq9JE7auMM",
		"ant-btn-circle-outline": "vtw-kryJIdaSOJcH4KB11",
		"anticon-plus": "_1L4ck2wTdDCoauInK9YqtU",
		"anticon-minus": "Sycof4pIuBfRQRCgl2eFA",
		"ant-btn-loading": "_1Wb6aP-YiUzgPhaiM1RXVK",
		"ant-btn-group-lg": "_23cTBEB8rjillU4ypcQKWZ",
		"ant-btn-group-sm": "_1TNuB9ebn-FhEmMV6SzBfS",
		"ant-btn-background-ghost": "_2AlsDrNenR2zEmhOojCCar",
		"ant-btn-two-chinese-chars": "Z_Iq1ZDhuPPU47RVwbaxh",
		"ant-btn-block": "_1RU8_1cJ_Clh8vyuslfcBW",
		"ant-avatar": "_2MKp7hdKk2nS6JN5GBZgf8",
		"ant-avatar-image": "_2voensPdXJsNPindxv663f",
		"ant-avatar-string": "_J1Ln1LRoji6DROCV01oP",
		"ant-avatar-icon": "_3gvpByJ3mlSOG_KvZAjTAu",
		"ant-avatar-lg": "MBh9VoWv7zSvGmK45xhM2",
		"ant-avatar-lg-string": "XzLcClRb-Qdih9zx5B8Pu",
		"ant-avatar-sm": "_1p6KWxbLxM7uf3gf5oSFd0",
		"ant-avatar-sm-string": "_1bbkMYm5C70loMWMZ1eaJ8",
		"ant-avatar-square": "Jpsfw2LtKLpB0wYN0WrpG",
		"ant-back-top": "_2KfzFgSgK0sivgveX7CdVE",
		"ant-back-top-content": "_2_Sxj24_Yy0OFpHcMvv92s",
		"ant-back-top-icon": "_2l0Gl6kowN8GuetKelrT09",
		"ant-badge": "_3EuI91wvbrK1LjABksTMsm",
		"ant-badge-count": "_2nDT_kZTrTBTrSRLtgW4n9",
		"ant-badge-multiple-words": "_12w0yDQair4s91C9YdFthJ",
		"ant-badge-dot": "_1bctaxQoDMRPoPLXK6-2Zg",
		"ant-scroll-number-custom-component": "_15UcVxbgiOtrjsu3hyO-SN",
		"ant-badge-status": "_2Vq9bYGh03VgOPtXK-tuXX",
		"ant-badge-status-dot": "_1jusEKcYABxmF8zlz9hVYp",
		"ant-badge-status-success": "FAgqRiO12ZbXXq5qKJH3J",
		"ant-badge-status-processing": "r8V9uyhqCGkYISVGtUBsu",
		"antStatusProcessing": "gVdpUKGtq53ZGlQXYZ56y",
		"ant-badge-status-default": "_12ojSFxDycFjb5I-Yfcj2K",
		"ant-badge-status-error": "_1pfbf0Gnc5oAsKtjpda3Er",
		"ant-badge-status-warning": "_1fzTfSIY9sbQ9ZUq5lPE9q",
		"ant-badge-status-pink": "_35O0gW7QuulBzyzUQva3uw",
		"ant-badge-status-magenta": "_8Nw3ARZfI5epBzJVONMns",
		"ant-badge-status-red": "_2Hrj32oWB7A93vQF4OYoC_",
		"ant-badge-status-volcano": "_1fNkfRXyThov80ulKazofW",
		"ant-badge-status-orange": "c_KqGtJ1Q_ieJHYJmFEc9",
		"ant-badge-status-yellow": "_3lYANjGyoY0eQhqJ1K4ajt",
		"ant-badge-status-gold": "_2Za780M8waWyRYh9VOJL5J",
		"ant-badge-status-cyan": "zwGzCBJqVWR_ZM3EXHucS",
		"ant-badge-status-lime": "_3YnXr-LYzZT1656EZSUoXv",
		"ant-badge-status-green": "_2XdA5DRZOXwEDf-mm3HNG",
		"ant-badge-status-blue": "_1b6jQU3H9OxG4pgplRUe9P",
		"ant-badge-status-geekblue": "_2-7miPu9FBUi6hMmoHeNF_",
		"ant-badge-status-purple": "_2P1SCY7IBzS5IeiP-OjuV-",
		"ant-badge-status-text": "_2M6cMp10Tqg42u-hm6mhhH",
		"ant-badge-zoom-appear": "_3QeyVVkYZp3mk55XHRDHB4",
		"ant-badge-zoom-enter": "_2U_hhA7tZidjbKoSbohxP8",
		"antZoomBadgeIn": "_1hyJbvKv1KapV5KPmfYW6R",
		"ant-badge-zoom-leave": "_8bynXrT6pZGyWJI4aRqP7",
		"antZoomBadgeOut": "_2rrzwbCaPLGtsAXkoXX3Nx",
		"ant-badge-not-a-wrapper": "NQTf31sjxSirFP--Yvhqo",
		"ant-scroll-number": "_26Wa8rMqBnh4XzEzu8xW_5",
		"ant-scroll-number-only": "_3Dc5CCGfzTy2NmEeGKwpnt",
		"ant-scroll-number-only-unit": "_3ME6KxuzhJgzMvj1BCbUpQ",
		"ant-scroll-number-symbol": "_19Nyp9oquFJfeW_ePOkEYV",
		"ant-breadcrumb": "_3eEogvwh7o7K3lNEC83dFg",
		"ant-breadcrumb-separator": "ko_TN_UHl2AJ4E9sRwJSF",
		"ant-breadcrumb-link": "f_LJXbj0Cnqch4wPuDlu2",
		"ant-breadcrumb-overlay-link": "yMPmnlWn5PANts_Tno-Ky",
		"ant-menu": "_1gsorLwjR7Y-PP5FFI3vP-",
		"ant-menu-hidden": "_1gdeR0Fx6ZNKPVJTrrksaK",
		"ant-menu-item-group-title": "xKQZCrIheuJ0Z14CTOZsC",
		"ant-menu-submenu": "_3BcPw7hinJJuDjuT9JfPUg",
		"ant-menu-submenu-inline": "_1vBG_YDrLvGi02vtpeBxyx",
		"ant-menu-submenu-selected": "_1zhiBd1wp4s94gkbQup87S",
		"ant-menu-item": "_1ESAZGbxgRjRzA5qTyYs-Y",
		"ant-menu-submenu-title": "_3dAM_Z_DQGVNEBKvNI9u8a",
		"ant-menu-sub": "_2isXzdyoeyPew61lAdXl6g",
		"ant-menu-item-divider": "_3T4oh7v3sba_RR2t4uNG9h",
		"ant-menu-item-active": "PT2mTdhhT0GI2f7YtLC2H",
		"ant-menu-inline": "_3IjzvPAJhP9Gw7HdqzdhUB",
		"ant-menu-submenu-open": "_1MGPj4VxN-efhYLU1mnVAl",
		"ant-menu-submenu-active": "dwnijamx0-ohAJnp60ba0",
		"ant-menu-horizontal": "Q1GfZQgyTHhXX0UX8MShJ",
		"ant-menu-item-selected": "_16orcnJPiaH5JUK2ngYnV9",
		"ant-menu-vertical": "_3ftSq04uq93bpiWh57I9Vo",
		"ant-menu-vertical-left": "WOHun4LhPxwfBNb0rC3sU",
		"ant-menu-vertical-right": "_3EWd0zwU6oxDkqF808cbIR",
		"ant-menu-submenu-popup": "WAPKMTUI_Hk9mA4J4IFPT",
		"submenu-title-wrapper": "O9AtCCymWBk8w95YsjiS-",
		"ant-menu-submenu-vertical": "_2YkuSA_GOKqO2crM-2UsUB",
		"ant-menu-submenu-arrow": "_1Y5fBL6Y_SRm9X7GYivBvR",
		"ant-menu-submenu-vertical-left": "_2CWDqxw4SOV9Loi-h_t5rE",
		"ant-menu-submenu-vertical-right": "_3J025srdIEZB3tu67p8Ez",
		"ant-menu-item-open": "oE21jcqOwgX-DcXvE86IB",
		"ant-menu-selected": "_143NCKkX4lYA3A2UIyU5KI",
		"ant-menu-inline-collapsed": "_1ih_HLExz1LDeD59xnmVMk",
		"ant-menu-item-group": "_2JvqVVWSSTUbd_UwKeVWXN",
		"ant-menu-item-group-list": "_3l-h5c2Iw_PQ_SyX0mu58h",
		"ant-menu-inline-collapsed-tooltip": "_2wQMxkdPCUP2hU6Pr7JcEk",
		"ant-menu-root": "_3W-Rjkx0adTcdM_yk8Dhlk",
		"ant-menu-item-disabled": "_1xCPeWQnXwkPkiapy785rY",
		"ant-menu-submenu-disabled": "_3BntBC6Ew4OSK3-q_aSlBZ",
		"ant-menu-dark": "_3Q93cCC1mRNguRwHX0L77",
		"ant-tooltip": "_1Tu6MQRb26CR7p_E03I_FG",
		"ant-tooltip-hidden": "TFOShMvuyImtZgSt8syKF",
		"ant-tooltip-placement-top": "M-hyS9_NqHbGBxzfxkuDs",
		"ant-tooltip-placement-topLeft": "pU_eV6Emdy8ysS7TfDQuO",
		"ant-tooltip-placement-topRight": "E6wSGyzM1d4blOHCaIeRs",
		"ant-tooltip-placement-right": "_2MG_1FeaF3YOzPbWxsh6_",
		"ant-tooltip-placement-rightTop": "_34dynbm7YjucutxGZllox9",
		"ant-tooltip-placement-rightBottom": "_9nozo3fY124EHgoU5iNSy",
		"ant-tooltip-placement-bottom": "ESTyFzjXmQgCRfbDYB9MJ",
		"ant-tooltip-placement-bottomLeft": "aKas_kGWrh_1nhMYJhCAH",
		"ant-tooltip-placement-bottomRight": "_1XY2uThBm4zij3EzPoNiI6",
		"ant-tooltip-placement-left": "_3EYLaYKvBciXBMImbcVseO",
		"ant-tooltip-placement-leftTop": "_1KHvTU6f3HvtorEqtwspuZ",
		"ant-tooltip-placement-leftBottom": "_2qOhz8KPPLgKmdf0BPCW3t",
		"ant-tooltip-inner": "_1TIARwNdoA8WneqfND7f4Z",
		"ant-tooltip-arrow": "_3r9AdFH2NW7LvCdjX_TtGQ",
		"ant-dropdown": "_1gFCwxNmWft-jTsqqtoszh",
		"ant-dropdown-wrap": "_3VQudVoYnwCoUQOUCoreMH",
		"anticon-down": "_1iI0eo9hgIxxGhx-LIu_tr",
		"ant-dropdown-wrap-open": "_1pGggFWFRlJsjj8sX10evR",
		"ant-dropdown-hidden": "_1EBl5JNYghpTYYVfLpNF_i",
		"ant-dropdown-menu-hidden": "SfVf6GOEJSW4yaWpKNrSa",
		"ant-dropdown-menu": "_2Euw4JTvgA5SfE5HM1wNOt",
		"ant-dropdown-menu-item-group-title": "_1iq7TyR4c8nyFYdkwnDQou",
		"ant-dropdown-menu-submenu-popup": "_2sW1em59EJ4GCuURKWMNL3",
		"ant-dropdown-menu-item": "MY2e94iH-ikkSYLcfVXzB",
		"ant-dropdown-menu-submenu-title": "_30LEIIPFE7sW-LscRgxxqs",
		"ant-dropdown-menu-item-selected": "_1EckrVBGIb2CxI3D99cufR",
		"ant-dropdown-menu-submenu-title-selected": "_2TA4JhdvUsRdRpdMaSjpgP",
		"ant-dropdown-menu-item-disabled": "_30XkTTnhC_9i-Y2-glk-is",
		"ant-dropdown-menu-submenu-title-disabled": "_2HY-OiLVufewlCSkEaMn6r",
		"ant-dropdown-menu-item-divider": "_2M6GQrdMonzLOTxk4FQlmf",
		"ant-dropdown-menu-submenu-title-divider": "_3ls0sVNmFK1DZihgW6vNX_",
		"ant-dropdown-menu-submenu-arrow": "_3BE2tevVHdJGiMaQq80CVk",
		"ant-dropdown-menu-submenu-arrow-icon": "_1VM-A_Yo0DBc4IST2reETk",
		"ant-dropdown-menu-item-group-list": "Xtvdw4gz1WJuNa0GKEgal",
		"ant-dropdown-menu-submenu-vertical": "_2d4ttuIeQvDTlZ1IfKxSNA",
		"ant-dropdown-menu-submenu": "ZAVKaPG8dKIsabKbF81mP",
		"ant-dropdown-menu-submenu-disabled": "_1f01ochO8kdDpNt3PpLDWH",
		"ant-dropdown-menu-submenu-selected": "_2qiKOgs2D_DIi_oj49fd8h",
		"ant-dropdown-placement-bottomLeft": "_2VPxHLU7NaMTrgMyU0k3Zn",
		"ant-dropdown-placement-bottomCenter": "_1JwCZBfDkYBetoEohol8Q_",
		"ant-dropdown-placement-bottomRight": "HufWwkdtfGdtVUsrb-2jQ",
		"ant-dropdown-placement-topLeft": "_1mm9iS6bL9bV_9isu3YC32",
		"ant-dropdown-placement-topCenter": "_3LDxNLg_q639BnjUhOIwZX",
		"ant-dropdown-placement-topRight": "_2yRtIFr1xMbrLlvzgq_Nfd",
		"ant-dropdown-trigger": "_2aQZN3k8LaN6hSzPUd6smx",
		"ant-dropdown-link": "_3ldMO81oePfDy-6A26djas",
		"ant-dropdown-button": "_1XKK0Rka3T4D4KNd0Cjs6J",
		"ant-dropdown-menu-dark": "_1-UeUlX9_YkldTxzS2RuAT",
		"ant-fullcalendar": "_2cqq6gGvlUzyAwbnDsHRw_",
		"ant-fullcalendar-year-select": "_1u32yfEqKH7A5xGm-BlBtd",
		"ant-fullcalendar-month-select": "_2tnOjzCVgd6nQhHCEP_Bdz",
		"ant-fullcalendar-header": "_2R7PxvTC3QZp6YcPegfiC",
		"ant-radio-group": "seEQkePeVORSE6FMzHzlp",
		"ant-radio-button": "_1lPFp3D5ac-kn6XW3Nuw-v",
		"ant-fullcalendar-date-panel": "_3YzNXU1NG8RH-osX7fWWks",
		"ant-fullcalendar-calendar-body": "o52TbX2OxmwEyg454QqN1",
		"ant-fullcalendar-calendar-table": "_2To-CMy4rsD8KNiErKXd-U",
		"ant-fullcalendar-column-header": "_2e7HkKj9MsLhFfGv5C0133",
		"ant-fullcalendar-column-header-inner": "_2gwDwP78PLf4-fCVWTf-uE",
		"ant-fullcalendar-week-number-header": "_2ILNN5tNAAFNBnqqyiLWs8",
		"ant-fullcalendar-month": "pvds5eydPOSpMRBTV41-4",
		"ant-fullcalendar-date": "wtw4UxI0IvnY92IOXWx9p",
		"ant-fullcalendar-value": "_1SVmik3kclUZ-SArbA2mzw",
		"ant-fullcalendar-month-panel-cell": "_2tbotB9kBcIbkHvU4p2US4",
		"ant-fullcalendar-today": "gkXfXplPgJ-5FtPZL5Xqd",
		"ant-fullcalendar-month-panel-current-cell": "_3m5a9E7irCYd6BXtcO7Cc0",
		"ant-fullcalendar-selected-day": "_3g58MG53wdGl7Kl_D5fpVM",
		"ant-fullcalendar-month-panel-selected-cell": "_2MSKl-YiRN87BqjFTqHPpj",
		"ant-fullcalendar-disabled-cell-first-of-row": "_2xrnkBb8J5TdSbor-dWtDR",
		"ant-fullcalendar-disabled-cell-last-of-row": "_2JeyxUVXOAx5_7gI2d-W40",
		"ant-fullcalendar-last-month-cell": "_2vn5nIHJMy9kvIW2qDrsvv",
		"ant-fullcalendar-next-month-btn-day": "Zrfj2nH7sEDoAGkDJJ4Mp",
		"ant-fullcalendar-month-panel-table": "ohheqNek76Wz0CHkRmBZ0",
		"ant-fullcalendar-content": "_39uP4dJTtgXDtz8f_GwB46",
		"ant-fullcalendar-fullscreen": "_2UOeggdNuY3_Hkc4PSL-cm",
		"ant-fullcalendar-table": "_3wL7W4350nN5S3amuujjuh",
		"ant-fullcalendar-disabled-cell": "_3JJUpg87mY_oSeADCl9YQx",
		"ant-radio-wrapper": "_339craOB4NhQayjvZn9-So",
		"ant-radio": "VaLFWv9E50AN8gGTQnDWf",
		"ant-radio-inner": "_3kKfvbzNtOjpL4_RV6NNLI",
		"ant-radio-input": "_2S9eMyrOcHrUQEJaKe0x0P",
		"ant-radio-checked": "_1ZLKbY7CNiodzW9lWro0dx",
		"antRadioEffect": "_3R52qcqqD69OKUfh7yWc2K",
		"ant-radio-disabled": "_3CSaPMqwHT_Jd9yOrN8etH",
		"ant-radio-button-wrapper": "_2qMwTDkVc6UvxAi-qCP1R2",
		"ant-radio-group-large": "_18TRP7uw4o40eEYoIDVZVn",
		"ant-radio-group-small": "_1pWF7IQ-7UFXN5zKItbY2n",
		"ant-radio-button-wrapper-checked": "UnuO6e6RauX05FCjHyQEr",
		"ant-radio-button-wrapper-disabled": "_3boIHN3HMyKX4R3RhYh9U-",
		"ant-radio-group-solid": "_3CzY727xM9zaCipjfY0QcR",
		"ant-card": "_3eBgg76u0Ccgd2COddX0ZT",
		"ant-card-hoverable": "_21lzjKqWxaO7GxBPXL9n-b",
		"ant-card-bordered": "JRFxxAM3oRFScThwCdybX",
		"ant-card-head": "_1WV4HeKUBVi--QVnqF4zx_",
		"ant-card-head-wrapper": "_3ukLIljT58nTto1dpALOWg",
		"ant-card-head-title": "_1i5Z1hBaX9O_9EVp5VfS33",
		"ant-tabs": "_1OnGhTlpcNs7IMjAgk-4Je",
		"ant-tabs-bar": "_1R-OR6gDlsIGQjy8z0PZpz",
		"ant-card-extra": "_2qrQRNM1-VQNAC_-zkaVz4",
		"ant-card-body": "_1E1pVxZOj97xBgZ0VZU5Gx",
		"ant-card-contain-grid": "_1RwBVOcekBc7Pze50uzKoW",
		"ant-card-loading": "_2zEICEz6Z0t_SfnYCQ6Tl4",
		"ant-card-grid": "_1RXGlMFfJqsugl7p6I0a3T",
		"ant-card-grid-hoverable": "_37GS5CUktwenqFI7kYdnAk",
		"ant-card-contain-tabs": "_3SbGqvM0EQ_qRyFr8hNePs",
		"ant-card-cover": "phbVO-erProvmNGgHePd-",
		"ant-card-actions": "_2qzG9ScI4tCBJJPoEOMJyH",
		"ant-card-type-inner": "_3d-k6z-8AGtWpo-D4hdr9b",
		"ant-card-meta": "_2sMnuCkCeb-taU8jrUAxGK",
		"ant-card-meta-avatar": "_2oPVOuLI1faEZIHP6GFb-q",
		"ant-card-meta-detail": "_2noT7LwO-jTfgJ9xRrlsaC",
		"ant-card-meta-title": "tWKitCwzQXI7IwCD05w0U",
		"ant-card-meta-description": "_16GHx9tT-t3RNdE4oBAoiu",
		"ant-card-loading-content": "_27UKGah6FTeB3X2T42SfDj",
		"ant-card-loading-block": "_1e49Sh7YfafeJv2pNd5sz-",
		"card-loading": "Ttllar9VkbS5J8saPz5bq",
		"ant-card-small": "_3BynWZoUhPFhrem1Mvvv1X",
		"ant-tabs-card": "_1_DxpzvnilPzHY_Dcro1Z5",
		"ant-tabs-card-bar": "_2ad0eyWD9eaLZ675za07RS",
		"ant-tabs-nav-container": "_3ZzV-aJqOmL0uNBhkPGwT-",
		"ant-tabs-ink-bar": "_33ktI-PDVSHr74A60u5GWJ",
		"ant-tabs-tab": "_1U7fGxHtLat1LEY_EUwPvV",
		"ant-tabs-tab-active": "_22R41sk3pHXP2hMLqBh9Qa",
		"ant-tabs-tab-disabled": "_23Fb-Q7MzBvV3EoAp7d2hv",
		"ant-tabs-tab-inactive": "_22Xuk4RLRCohUfIRs8d0QX",
		"ant-tabs-nav-wrap": "_3gkwYpER15L91KyMz8QdgL",
		"ant-tabs-close-x": "jqRIDAfirHkCVij7fbKms",
		"ant-tabs-card-content": "lsRnyRWJaSJBwLRNuRjIC",
		"ant-tabs-tabpane": "_1wF4RouzMvIYpfgtXSjYr6",
		"ant-tabs-editable-card": "_2-4jMS9FVf-Gn3DzPTlEe",
		"ant-tabs-tabpane-inactive": "_1uYXVTo6jwgqKOtuNUahXx",
		"ant-tabs-extra-content": "JCkq4SHXJpx1k9_TJF9eA",
		"ant-tabs-new-tab": "_1XFnFZqhuU8MgHhWOE-B0p",
		"ant-tabs-large": "_2DbxJPaCsvRhwfaIeGhzFn",
		"ant-tabs-small": "_3U-NpbgPNFoNQ6XxDsDUn5",
		"ant-tabs-vertical": "HYHb92nfc4QOFwO6dTq-Z",
		"ant-tabs-left-bar": "_2aarJHtQf0VvArtYJrhLjk",
		"ant-tabs-right-bar": "TGmIM93jplrJNGI7aZt_x",
		"ant-tabs-left": "_3G1Smum3srTH6mdpnu2ry4",
		"ant-tabs-right": "_3UMhiHTP1NhJpJMSJTWbS4",
		"ant-tabs-bottom-bar": "_2sOqAIfMsQojVdl1T8tM4P",
		"ant-tabs-nav-container-scrolling": "_1txKnEmoOnpr2R02HatsBI",
		"ant-tabs-bottom": "_2bnZZad55BFTSev6034TCk",
		"ant-tabs-tab-prev": "_60Jp7unGw4mHSCq1yPsYI",
		"ant-tabs-tab-next": "_2IRFRyOtJNu0fEhEs1GCqp",
		"ant-tabs-tab-arrow-show": "_2nfVsJPsW_xFhAsA-R-PP",
		"ant-tabs-tab-prev-icon": "_1PYxffJfVM30Vnm0dgzSAY",
		"ant-tabs-tab-next-icon": "_2TebSGEST0wuINdBUAfLRB",
		"ant-tabs-tab-prev-icon-target": "_3aYmSCOkr0AujbWaRlpjvT",
		"ant-tabs-tab-next-icon-target": "_1lUKnsRQDBFJ15mnJjAusy",
		"ant-tabs-tab-btn-disabled": "_1YsvNPBdmz5iTaQcTezt7Y",
		"ant-tabs-nav-scroll": "_2dKI9ANRPyk6dOxcvtp6Wa",
		"ant-tabs-nav": "dtwF9ntXFX2e9pB4KtnpO",
		"ant-tabs-large-bar": "_9Mb5ippZgxTfAFbZ67b-V",
		"ant-tabs-small-bar": "_2E_NsX3k-VRlcvJLnklBBL",
		"ant-tabs-content": "_1GlhGAAmiPBMhkQ3dDBBco",
		"ant-tabs-top-content": "iOXQJpHkJ4rLGQUq46Itr",
		"ant-tabs-bottom-content": "_1iV-CbId1KBB3PF1aRiTDp",
		"ant-tabs-content-animated": "_3Mpk2VcnH9Y-AtTP9aKcOx",
		"ant-tabs-left-content": "naGrAWn5YwRZx_5twTRLR",
		"ant-tabs-right-content": "_3ktsnR-KDjnZ4MCcqMb7rN",
		"ant-tabs-top": "_30L6q_HJDR7EGF7o3o2ZpF",
		"ant-tabs-ink-bar-animated": "_2koerhzTFsbOLR3waV9irJ",
		"no-flex": "_3E4Dru77qsUfne0QzYpnM4",
		"ant-tabs-no-animation": "a8LENbXBCPB5QexGic0-I",
		"ant-row": "_2RAEhgJ-n3VhxwqwabwZ95",
		"ant-row-flex": "_2Ph9ciDmPpC3Ep3Dk_B0VL",
		"ant-row-flex-start": "_3tFUMNLTxdW4DItnPRcSZC",
		"ant-row-flex-center": "_2ldw8OzCLL0Ynv_VvsivIG",
		"ant-row-flex-end": "_3PB89KM33ieKGaQ9mUPKwH",
		"ant-row-flex-space-between": "_3PiQl6MYi1qMOUsoFC6uCA",
		"ant-row-flex-space-around": "_3GHxHHxwFmH1C-99Ch7DAm",
		"ant-row-flex-top": "saUTU6t268deJotankCyH",
		"ant-row-flex-middle": "_3oTtjXTMQe-a4hPiOOrYWc",
		"ant-row-flex-bottom": "_3MQwHuNVaHQbVzaKnWjhkr",
		"ant-col": "_3LZni_ayS-DnjajnxVwEnK",
		"ant-col-1": "_20-OtFIYggk9W3mCYEMB5l",
		"ant-col-xs-1": "_1eWOMOkJEnHjjENJuvIM66",
		"ant-col-sm-1": "_2jOS9taLTFZbmYudNxO18b",
		"ant-col-md-1": "_1TFkI74kFWtiGw9kIImgWl",
		"ant-col-lg-1": "_3trs0zD59rOIar_6GtdYuz",
		"ant-col-2": "p_zAYo-DSVHJWfRIFHq8p",
		"ant-col-xs-2": "_2oKbE4sz8c4pnWTkg44qF1",
		"ant-col-sm-2": "SxGva5irxm6JjTQGVfjis",
		"ant-col-md-2": "_2kxDw68IEnTPw7OhxHYFPi",
		"ant-col-lg-2": "pih3Q66IulQCubsjoEJFC",
		"ant-col-3": "_1PyD15OYKbZTp_I_WikPwW",
		"ant-col-xs-3": "FicZmEjlFJvo876G5rnk8",
		"ant-col-sm-3": "_1f3ModEDEngGXeRWECJME_",
		"ant-col-md-3": "_2jBJcp0F1wkihe04iWe1nf",
		"ant-col-lg-3": "_3-mWJlec57C1Fx_9lQVOIo",
		"ant-col-4": "_2ZORktP8qDOtoEDEmC6NcF",
		"ant-col-xs-4": "_3Q-lzIvo0UqJjw3LKfyE4u",
		"ant-col-sm-4": "_3wVezvg4pKKLAa0xahOA-L",
		"ant-col-md-4": "_1vEvH4gHPSy8mXINZYLkkO",
		"ant-col-lg-4": "_2T-tOig9i2gwf3xQivoxBI",
		"ant-col-5": "_1PslX56jAzDdf_hXaV05hf",
		"ant-col-xs-5": "_2R8vpW3_PclrUErAix1Pbo",
		"ant-col-sm-5": "_3i-xIiBzZDaWBPNXQUlePv",
		"ant-col-md-5": "_2IA-8ORy61E8LS2-excFp1",
		"ant-col-lg-5": "_1kBCXD3cFNBkOPstuIVBTs",
		"ant-col-6": "_1QSaM04Tw-ngxJvlca177e",
		"ant-col-xs-6": "_3ibpRFMuwhzQPJ-9VxI2ah",
		"ant-col-sm-6": "_2NutJQVTpHEHyIQRhv0qdP",
		"ant-col-md-6": "-uBPcXtYp9ihZw5YZJALN",
		"ant-col-lg-6": "_3NYFS_uipYqCPD2KuZZ95e",
		"ant-col-7": "PPy883M3zO4CPCsmOL3WK",
		"ant-col-xs-7": "_20a2eYnNcUUUHG2vqe46n7",
		"ant-col-sm-7": "_3v-2F_hmFDgY7fEjIitqJv",
		"ant-col-md-7": "_3agUl5Dq8NsFu0OSSeFVu2",
		"ant-col-lg-7": "_1a3H8pRTRilnk3hOaQJhVz",
		"ant-col-8": "_2v74XkxEDKcxmjl9s3XUh2",
		"ant-col-xs-8": "_74oQYE_RJmk48EBZwcABM",
		"ant-col-sm-8": "_3BJ1JMUAwjamrpFKIjI066",
		"ant-col-md-8": "xibilcuZB_2LOGK1iozZk",
		"ant-col-lg-8": "_32vXsJ026qkOYO3u9PteM3",
		"ant-col-9": "-Z1-eQtXG4L1Aeo7OhmlD",
		"ant-col-xs-9": "_2IsOYyj502MJQSxRaqcL9s",
		"ant-col-sm-9": "_2PlChE31SaYWkTBUivvBF0",
		"ant-col-md-9": "yqbtr8Y3D3MOOsKcuLxf1",
		"ant-col-lg-9": "_3Ocm-iTvjR0mrXuuJaKks3",
		"ant-col-10": "DadoC1HXIRh6OUbv9B1_x",
		"ant-col-xs-10": "_2Ysr2eC4I9RnesHYS5hK7s",
		"ant-col-sm-10": "_2itRG9I_vzd1CYT8-BjnRO",
		"ant-col-md-10": "_36FMMyk3yCijWGsvIMlp18",
		"ant-col-lg-10": "_1bsf_E1csA87xJq8vx3SYT",
		"ant-col-11": "_1gWdqkBIhtSVMA8XfAAjHK",
		"ant-col-xs-11": "_29X8IwM6ZpDwbop5ck25aK",
		"ant-col-sm-11": "_33cLB1N4VPqKgfxzUExB6d",
		"ant-col-md-11": "_31R7Z24-E4559-bge7uYvO",
		"ant-col-lg-11": "_3Qix4GsW4eMZHyWfEfVfsX",
		"ant-col-12": "_13XOE4z0r_dfoIl7wjY5V",
		"ant-col-xs-12": "FovrqvB6LLHSEWl19VDJh",
		"ant-col-sm-12": "_2dHDJxEQGqcX0nDBBG9Txt",
		"ant-col-md-12": "_2Zx8DUjtgbHTFWb9cn1yjJ",
		"ant-col-lg-12": "_1Rp147IjrGFnXdoOuXyHUG",
		"ant-col-13": "p4fy94ZdbfLMZ7-uol27o",
		"ant-col-xs-13": "_3784scNf_e7NwQHPzOybSR",
		"ant-col-sm-13": "_1iFjQ4zkCyzCwSur1q_rT5",
		"ant-col-md-13": "_3Y96kEwUwxn_Zcp-GoELRm",
		"ant-col-lg-13": "_2flvK6CrnX9pIJVL2tzV4D",
		"ant-col-14": "_2kdXuDVRtXJ5eqcWXSW3dv",
		"ant-col-xs-14": "_3KrUSkOvoFDgvYxv4TaM2M",
		"ant-col-sm-14": "_1dP6VPpEc4wBmIXypfqS4k",
		"ant-col-md-14": "_1s03fYFuPsLqRMcG8pBuuZ",
		"ant-col-lg-14": "_31H3EA3W2I2jvzzFEU8XR6",
		"ant-col-15": "u2n6k6rB4Z-PK-nThhYXt",
		"ant-col-xs-15": "Kdi2aWxg0ioYtw00XZfOO",
		"ant-col-sm-15": "oyDkQmtxF5gmYYEF1jcgX",
		"ant-col-md-15": "zBy98kdqeohBiEno7vU3V",
		"ant-col-lg-15": "_3SjZB9d1sw2bLwLiq7gvCg",
		"ant-col-16": "_3zC-PYcMIF-0HGUWDVWyA8",
		"ant-col-xs-16": "_2tST687w1vpNs8Kedurh-8",
		"ant-col-sm-16": "RZ6aHl-BwGRHv7xX_sgZS",
		"ant-col-md-16": "jmRT5rs-OUvOqSIlzU3Du",
		"ant-col-lg-16": "_2CGXrecS6VMTsfEB8fOj0T",
		"ant-col-17": "_3JpwgGhcpSwePm3hRi3mcH",
		"ant-col-xs-17": "_1bGWoL_cmahSZlIP7tdzdi",
		"ant-col-sm-17": "_1ZfzdFgwBI2oqp_NxjXKUo",
		"ant-col-md-17": "_17FmX5DLSPH7NwySuvd72l",
		"ant-col-lg-17": "_2x82hSPkSbLrWu1u_IuaBS",
		"ant-col-18": "_3tAKx0tyLNqV3jstAtgDrz",
		"ant-col-xs-18": "_3hqmumCZFi4MhwBuW919uM",
		"ant-col-sm-18": "_3IHYLpmTIGL8IipTkhjuqx",
		"ant-col-md-18": "_3ZvpfWjEJ3giGgJn0mp9WC",
		"ant-col-lg-18": "_1CygQb8PSoqm6-iT926gmO",
		"ant-col-19": "_3V1W78SkixqAgMeXGyRGgx",
		"ant-col-xs-19": "_1pd8Yukkn_l-tv4Mdx7JSP",
		"ant-col-sm-19": "_1DccTYWhdrUhngSdRw0Q23",
		"ant-col-md-19": "_3v4V9JwXDVlzAts4oP8QRD",
		"ant-col-lg-19": "_3o97Hmk6kzYIelTMDQWkYE",
		"ant-col-20": "_1rT1XmwWIFH1ix1IuUFMPb",
		"ant-col-xs-20": "_3vg2vxwsuzsRd8X4LZQuBn",
		"ant-col-sm-20": "_1piZUF7RYzAIWnTMUzysW8",
		"ant-col-md-20": "_2jfSaSQApeIS6HTwgkJvvR",
		"ant-col-lg-20": "n_eDAHREa5E2V4Jldvkfm",
		"ant-col-21": "_3ralCTchPhUc1Ct796RGuD",
		"ant-col-xs-21": "_137_X_XQzSVylC4rU4RI8s",
		"ant-col-sm-21": "TKOEvk-l3BkcWrmjR59as",
		"ant-col-md-21": "_2MtVG2Kkjgn6fIM8M6DI9y",
		"ant-col-lg-21": "_1PLFNpOrbaG7oiBiR7gipJ",
		"ant-col-22": "hWmcSHzTs6hAEGKgHfIiN",
		"ant-col-xs-22": "_2cGJfoPA3WWm1v3yjeSiH9",
		"ant-col-sm-22": "_14Z3ZZUzRwUvcerXJQt8OL",
		"ant-col-md-22": "_8OjniZjQdvUNQzFcDVXVQ",
		"ant-col-lg-22": "_1yCJ-sDDSCjS1mVMOkhiE-",
		"ant-col-23": "_1f_s2equjEuhX6357mwZbu",
		"ant-col-xs-23": "_3H1BwxtmoEUW4bAMIm976S",
		"ant-col-sm-23": "_1pKg_WTX5LvFxW61tehHPO",
		"ant-col-md-23": "_3744ErrgSP70rklc5lqnL7",
		"ant-col-lg-23": "_1YPj7v7dy0_YFPZ6CFlTnc",
		"ant-col-24": "_hc2lyZFXBRieqWVGvjlW",
		"ant-col-xs-24": "m5GSJDA-XU2vizRVe6oI0",
		"ant-col-sm-24": "_1lNw0jLvmTwKcRstr-ThaX",
		"ant-col-md-24": "_2ndfC3Op6-f3H5-JJ48mxS",
		"ant-col-lg-24": "_4pSZ1tb9bcmVOqTm1RnS0",
		"ant-col-push-24": "_1Tu_JDP1rjOMTL1EJQVoHa",
		"ant-col-pull-24": "_10OaldKAVn_PCKKPvhpawF",
		"ant-col-offset-24": "_3Unl5XV0UhnKyfXBFbKJtv",
		"ant-col-order-24": "_23O8QZ2iWMsnRG7AP_sXPH",
		"ant-col-push-23": "_3g3rBIlBGfzOJuXG_0IXEL",
		"ant-col-pull-23": "qqBJ9mDby1yteHJzPjHfM",
		"ant-col-offset-23": "_2Tek9wGaQ4QcH52gV3l9O2",
		"ant-col-order-23": "_1FS_hLI89vJ2AwuK8mcjMj",
		"ant-col-push-22": "_3klIz1pV19BbomcKKazkj6",
		"ant-col-pull-22": "_3ZunCeinqMhBXL9qKO7KHU",
		"ant-col-offset-22": "_2XBjGowaXm8b91q6S_WE3k",
		"ant-col-order-22": "_38DidIwACZDYr3DXilqGvz",
		"ant-col-push-21": "_1vEsATrTspdElcUOM6pYed",
		"ant-col-pull-21": "_1xxLCPa8K-bEAgEUZQ6Gh7",
		"ant-col-offset-21": "qQGi04MMxsRroz_rX8ZJE",
		"ant-col-order-21": "_1eMH390wbsPp7MGrEsnCN2",
		"ant-col-push-20": "_1FcqQcM9U508JfSwX-iDAA",
		"ant-col-pull-20": "EvZtiIost6uIMZQ3AF_53",
		"ant-col-offset-20": "_2NzS8QhrVN_zS-Mwrt0ABr",
		"ant-col-order-20": "_34fbGsieUChCHelfuLbmz6",
		"ant-col-push-19": "_1yQtYV_gw2DTJPLrdmIoPI",
		"ant-col-pull-19": "_3i5KHcKv8C1l1WErvmbxdO",
		"ant-col-offset-19": "_3O9X1PBd4I5SqSWD25oLcj",
		"ant-col-order-19": "_1tQElyvKnzqe_vFqZtCR5U",
		"ant-col-push-18": "_2J5goSsrlCKk0LlAGok92Z",
		"ant-col-pull-18": "_1eIcQUhB_Skv7wXMxNl7Xh",
		"ant-col-offset-18": "lB58Nq6S2VXyOBvPszNa8",
		"ant-col-order-18": "_3j7CgUmu73fmTtzsuY-Ylt",
		"ant-col-push-17": "_1X20KdduMYHyrl-c6N_CX2",
		"ant-col-pull-17": "_7EvulRg_jQGr5auSnt5rr",
		"ant-col-offset-17": "_2O6nhYCcshH5APGbMkxVhp",
		"ant-col-order-17": "_2dMaU650dUnlm7Tpv2JHXh",
		"ant-col-push-16": "_1tnEwRKm9F3nhR2deZro7H",
		"ant-col-pull-16": "u6tjJEK0NfqeuqgSdi-X-",
		"ant-col-offset-16": "_3ph-exXpfUJI6UeGZGIQJC",
		"ant-col-order-16": "YhpFyEl0p0bBdoI-GT_4W",
		"ant-col-push-15": "_1wPQ0LeCAOCp0LIG6tkEQ5",
		"ant-col-pull-15": "Tm3z3nVB5lgQa8WJp6Kef",
		"ant-col-offset-15": "_3C2V-CFtXIt9x-er-zxsxl",
		"ant-col-order-15": "_3glQvzzhyiSziu1gUMJRyq",
		"ant-col-push-14": "_2VPSKa6Gq-OsFQOiSD-WS9",
		"ant-col-pull-14": "_3b7EvX8ciWIUiUGLSsRqpE",
		"ant-col-offset-14": "_3iCDI-Yt7Vd2jk2alBY79a",
		"ant-col-order-14": "_3r5GAm36oaBuarJRJ7R3qk",
		"ant-col-push-13": "UJ5Va0X4UXEuazjw5tp64",
		"ant-col-pull-13": "_1y1PBsSQqRIhpDgnNTJYkj",
		"ant-col-offset-13": "_3bGFa3DWr03zkfYHe-jXmY",
		"ant-col-order-13": "_2yyRtpVKVLHWeU410qx59Y",
		"ant-col-push-12": "z3j7BDvDwJUwWk-43v49Y",
		"ant-col-pull-12": "_2QA7fozmoG3nJp6dF1YuQV",
		"ant-col-offset-12": "m6kMXAFJ1593KmGQoTye6",
		"ant-col-order-12": "_23AeS0vYUgvpNHlfSuECeD",
		"ant-col-push-11": "_1444jcCmV1S3MMFgZSkrXI",
		"ant-col-pull-11": "YMXqHGl89e1WE9nPrDtcg",
		"ant-col-offset-11": "_1LMbRE5effWhugEpDx6hPN",
		"ant-col-order-11": "nLcbz8EqojQBv6d1bcdks",
		"ant-col-push-10": "_1PbaOBjjmRVpVOvZKC_q7u",
		"ant-col-pull-10": "_6dcwut7fzzUBBsSBxPt5I",
		"ant-col-offset-10": "_1qxTx4MnpQDVWM7mWQY8N2",
		"ant-col-order-10": "DNaHkfeDZQA7TybMScZqJ",
		"ant-col-push-9": "_2kYQJyXf2DwlKzTiW_9nOG",
		"ant-col-pull-9": "_1M7J5wx8uN3hKSwurM_rup",
		"ant-col-offset-9": "_1iGJsSQpfVc4FSMiOIJddG",
		"ant-col-order-9": "UZVRG8-Qo4JA1PIXQ4k8J",
		"ant-col-push-8": "_3ntOejhVuFtLEFaFDXl9S-",
		"ant-col-pull-8": "_2fd1qX_h_YP306sa0GwIkC",
		"ant-col-offset-8": "_1pL0HS3W4Ixu6yswd5zAE7",
		"ant-col-order-8": "_2MrVfLt-edDKqrBfOW7_fP",
		"ant-col-push-7": "zFcHd6MnQQPwnygS5uFII",
		"ant-col-pull-7": "Nz1WEJZRpLyLRFEYLyGYN",
		"ant-col-offset-7": "_3lG0SRqSnu3OECP8emv7gD",
		"ant-col-order-7": "_1jUi9pBKS09cxhOUU6UGTw",
		"ant-col-push-6": "_2LBysoCcuJhAryYWrHkql3",
		"ant-col-pull-6": "_1Hn3CagvquQiQx2IZyJt1d",
		"ant-col-offset-6": "_1OFHfIjTewldKpBoLguLFN",
		"ant-col-order-6": "_1ULOoHQuZ09hDYqfT6LHyT",
		"ant-col-push-5": "_2fzVtGx_lCp40aD4vDcM50",
		"ant-col-pull-5": "_2olW9XxVvgGKNR59Boo5eq",
		"ant-col-offset-5": "_1aSYGOCTFoH9jHVcLaeV3J",
		"ant-col-order-5": "j8NbC6yZUAkWlvPbQswqs",
		"ant-col-push-4": "_1U_vPTbQpEO4LiOG2OM_l",
		"ant-col-pull-4": "nVWqJufnkU3yPv008Jdtu",
		"ant-col-offset-4": "_32a447Ft-xqCWAi70A0z6w",
		"ant-col-order-4": "_10tFhMWqdcIJDO9DXkQsVS",
		"ant-col-push-3": "_3DIfnytoXV9JITd62m4rRR",
		"ant-col-pull-3": "_3dkzHTwN4kO2t6KzgdHMp-",
		"ant-col-offset-3": "JiRUI8q--Jp-86AO6P8Gr",
		"ant-col-order-3": "_1ByPdMZuWDGRh6MaIT987v",
		"ant-col-push-2": "zp0w_AyWtnQtNaOP0KYpL",
		"ant-col-pull-2": "_2eJBeSZUqJNMUkiHseXHAU",
		"ant-col-offset-2": "PVjTjNzB_gkk867K-LGU6",
		"ant-col-order-2": "_3kLb_d6levVmGLKkD-4TRu",
		"ant-col-push-1": "_3KYQqwZKGBDh7dzqBj1Apu",
		"ant-col-pull-1": "_3lM5HfUr5BFzFlcIcSFdHz",
		"ant-col-offset-1": "_2sBZ6Srdhfd_HqKn5tbm6l",
		"ant-col-order-1": "_1QnFEApe7ilgiOdCD1MgeC",
		"ant-col-0": "_27ykFHUF_LK-M5M66f1hrY",
		"ant-col-push-0": "_3eh9FwIUqNXQ75ZS1KOHUF",
		"ant-col-pull-0": "_19fhy1NkdCWgU0GwLjJ-B2",
		"ant-col-offset-0": "_3VXqc3tM1pQk3Mgx98VPn7",
		"ant-col-order-0": "_1CYHEQcc2ocjnhhS2YbIwk",
		"ant-col-xs-push-24": "_270mB5a0pSleefwOT90Xx2",
		"ant-col-xs-pull-24": "X6xzzcOb5s0uBE5-WzOEf",
		"ant-col-xs-offset-24": "_23oyRlR7XGP8qjnz9kUns2",
		"ant-col-xs-order-24": "Q-tLqv4DoN9VxGV-x56x8",
		"ant-col-xs-push-23": "_1sOVb52E4PhzkSZWu8n-HC",
		"ant-col-xs-pull-23": "_3ILMIB6WxMEWhPzweFziBx",
		"ant-col-xs-offset-23": "LAyu6S6CJi0tfNcSUHjGG",
		"ant-col-xs-order-23": "_3EoKWpqef9SbGjHNAXcg9T",
		"ant-col-xs-push-22": "_2-wCCIm6ZS1kEguUKSu9j9",
		"ant-col-xs-pull-22": "_2UCvvxuTdI_XBVS6q-2jzm",
		"ant-col-xs-offset-22": "_17y1iNJYpnM8DEc-1e_9QF",
		"ant-col-xs-order-22": "_2tH0gF6pHEdA70PrjZ60ID",
		"ant-col-xs-push-21": "_1Nkf2WoDVXhyJvN-743XXA",
		"ant-col-xs-pull-21": "_2EG3np97Zk0zxfhNSQ1V_u",
		"ant-col-xs-offset-21": "jAT9nDgYgKuxplGm-gQ-Z",
		"ant-col-xs-order-21": "_24DxOxTPZM0IAASV2eKo9B",
		"ant-col-xs-push-20": "_1s-G-1VF7dC52DMM54VzCL",
		"ant-col-xs-pull-20": "hP0a4A5wO1GHU5MAbD2Tb",
		"ant-col-xs-offset-20": "_3Y1NoL-eLEJnkDlN86EFlz",
		"ant-col-xs-order-20": "F59ycyzfgD84-6m2PTrK3",
		"ant-col-xs-push-19": "_2ZM1cL7Km1OKXHsbKbXUNU",
		"ant-col-xs-pull-19": "_2mztNQ38m7UrjkeztS13f8",
		"ant-col-xs-offset-19": "_3iMRAuVZFbApOgjjar2pJK",
		"ant-col-xs-order-19": "_2NiVCdGZAB1ZhpEnrP9PqE",
		"ant-col-xs-push-18": "_2hB2WcxPQE31WpApJkX85a",
		"ant-col-xs-pull-18": "Ip-7irFAxgae730siFL8j",
		"ant-col-xs-offset-18": "_2EKsOPpV7y0dqQU42ATOVO",
		"ant-col-xs-order-18": "_3ErYWkda03uYstKggLFcbJ",
		"ant-col-xs-push-17": "_2v2yU45EBEveWzO9qSw900",
		"ant-col-xs-pull-17": "_1AJ2agnFWlCCGY8FLUgfI3",
		"ant-col-xs-offset-17": "_1s5uVhSLaD0q4G6Sweu16i",
		"ant-col-xs-order-17": "_2rmyd3EHGyExifGfTl8qzy",
		"ant-col-xs-push-16": "_2zMk2FN9Rr98RJ_b8GLPxl",
		"ant-col-xs-pull-16": "_3rAeebWHLH6H8HYV8IbrON",
		"ant-col-xs-offset-16": "_1IA-mIIiE-8CUoQI5EN0SY",
		"ant-col-xs-order-16": "hrKtt8JYwkAOaixW7Kt6m",
		"ant-col-xs-push-15": "IXSp-oHEveP0wYrz_8d2I",
		"ant-col-xs-pull-15": "_13IQRb7q_C6jckne30HH2T",
		"ant-col-xs-offset-15": "V7FLbBcMCvUrHqZKDeRxh",
		"ant-col-xs-order-15": "S_iW8DoMKzUrBMUo9K6Qo",
		"ant-col-xs-push-14": "_1FqLSng4a1VPeej3pljMbC",
		"ant-col-xs-pull-14": "_3ALts8lCFhyH1uoSipiuxM",
		"ant-col-xs-offset-14": "_3OzKUILpo0AQbbcpW7Dj8X",
		"ant-col-xs-order-14": "_2ZNhifkuMJSa6PtZQWLnnX",
		"ant-col-xs-push-13": "_2lzxJhxRuxARmcdHxGHiaR",
		"ant-col-xs-pull-13": "_3SnJ_4nEKwYRdVWBxPkoD",
		"ant-col-xs-offset-13": "HLGKAlNMT_QJb4tLNmMWZ",
		"ant-col-xs-order-13": "f7xmD6sBkz3M_58D6XS2d",
		"ant-col-xs-push-12": "_3zFklpkMshg8DjtVuivWc1",
		"ant-col-xs-pull-12": "_3WnU_vsxcGgN86qxJxJ2lC",
		"ant-col-xs-offset-12": "t7C9IiDRgo8CG0qh7ZSw-",
		"ant-col-xs-order-12": "_2N0-oFMHhSqU2jdRJiDLq8",
		"ant-col-xs-push-11": "_1eHmHN3MJBqwG0SSnt9MgV",
		"ant-col-xs-pull-11": "T9ZcMmf1lrgCGp_1-nZzi",
		"ant-col-xs-offset-11": "_2JiRHbTMksUt2e8oLrsJ-",
		"ant-col-xs-order-11": "_1ECUlRK65QA-sisEGVSl9a",
		"ant-col-xs-push-10": "_3Qa-LOavFF-J7huN45v3iE",
		"ant-col-xs-pull-10": "_3nIpx0CWmcCc-uuW1ZCsho",
		"ant-col-xs-offset-10": "_3F_BtkbnGC3fj8eF_aqn7h",
		"ant-col-xs-order-10": "_2kpWzXBo__7_C4nTAYfN9H",
		"ant-col-xs-push-9": "_3aDaLuwCXI1K-wCzCWktNO",
		"ant-col-xs-pull-9": "_1-Tw2CsWMyQ01RCZhp0KiV",
		"ant-col-xs-offset-9": "_2QpOEoLDU6DaOP6Hqkil8W",
		"ant-col-xs-order-9": "_1b1tOwemWaadgYCPnlJZu7",
		"ant-col-xs-push-8": "_3XE5SWXuZ7NQbCJpyaTGQC",
		"ant-col-xs-pull-8": "_2ZYv-1TuKaG9SWFMr9BLAK",
		"ant-col-xs-offset-8": "_1JeXOqXoH9uOd24MujvCr9",
		"ant-col-xs-order-8": "_3v2m4bTb1gntT_o0uGSaen",
		"ant-col-xs-push-7": "_229PnlRF4JqhIcNjYSBi-l",
		"ant-col-xs-pull-7": "_234GXi6SsFQss349pQjEZI",
		"ant-col-xs-offset-7": "_2HQ2E_38eDC86d35Iwr7tE",
		"ant-col-xs-order-7": "vqcatdVCmAks14eQr8epk",
		"ant-col-xs-push-6": "_2gZjXVtHe0fSVwhbV3A6pX",
		"ant-col-xs-pull-6": "_2TsK98YCOIrYtYlziHwhDy",
		"ant-col-xs-offset-6": "Svnbo7SGVh5EjBEA0M29e",
		"ant-col-xs-order-6": "_332GUWb5tgKAPizASu9_kc",
		"ant-col-xs-push-5": "N92x-_-_moaEShvqshCU-",
		"ant-col-xs-pull-5": "_2nZGMbhh9w_oPHgVNSsoZl",
		"ant-col-xs-offset-5": "_1y9bLSmhZUgEBdli8XKUvv",
		"ant-col-xs-order-5": "_2KPn7WXfNhgJPbH6_F7kzO",
		"ant-col-xs-push-4": "NHYR1hxRNCWaMWFaS5I-n",
		"ant-col-xs-pull-4": "EnJ32Qieahj4aY3qe-Zau",
		"ant-col-xs-offset-4": "_1Qgl1cQuVta97kCGQZqcTC",
		"ant-col-xs-order-4": "_2_7VuSy3AzCsPjwflMJctq",
		"ant-col-xs-push-3": "_1WIDRD9tdmVGtDzFC22Vm1",
		"ant-col-xs-pull-3": "_3vk-KdBMIaa_WrCj9EJppP",
		"ant-col-xs-offset-3": "xfL859hoFbHXP2TDcphgO",
		"ant-col-xs-order-3": "_2Bd-lq6f68GAeBRyT8YM5N",
		"ant-col-xs-push-2": "_84e_3soJjlulgrwLFKp0_",
		"ant-col-xs-pull-2": "mP5bBZW8VMCWjeQUesrxu",
		"ant-col-xs-offset-2": "_18hc8JD1An_XW1cWrWO-ew",
		"ant-col-xs-order-2": "_3v5Hy0TvQKsQPvH9E6G2gL",
		"ant-col-xs-push-1": "_2WgMM1Vf8bWeqZrLJrA0f8",
		"ant-col-xs-pull-1": "_20p-fjtCWVjOMxJUEtTGCt",
		"ant-col-xs-offset-1": "_2hEKdgfjywBAfp07aNcnDe",
		"ant-col-xs-order-1": "_3G9D08ygW8W4aLTIzLVms8",
		"ant-col-xs-0": "o42JOCAgLB67Vr6prNuHi",
		"ant-col-xs-push-0": "_2-olvJYGKXmv1Et94CWtRb",
		"ant-col-xs-pull-0": "_3o-suZwlC6d2EgFnDb6DwA",
		"ant-col-xs-offset-0": "_77xEzBkeu2ReLJNyTvnma",
		"ant-col-xs-order-0": "scRdG0nRjTJXJ6NMQxSnL",
		"ant-col-sm-push-24": "_10M2KC6NGRe5v2va85M2wt",
		"ant-col-sm-pull-24": "_3zs6lUpdNRB3rTwFHAfxNU",
		"ant-col-sm-offset-24": "j1Z5gCgOcP6YgXys_YDjo",
		"ant-col-sm-order-24": "_1hEK7ME-NsgdJFICTMKMJy",
		"ant-col-sm-push-23": "_3jiBhQAaL1-nQgpbSyGIm9",
		"ant-col-sm-pull-23": "PCPYsnGL806aDTjK1dqlT",
		"ant-col-sm-offset-23": "_1tCo5W4u8KDjHCnr0QqLnW",
		"ant-col-sm-order-23": "_2OcGnz8guk1tL1W48-Sl_W",
		"ant-col-sm-push-22": "_1fkCn19OMdpgEAwRzomUbP",
		"ant-col-sm-pull-22": "_3Wa3OVF-wzeaRbXwXV3GcX",
		"ant-col-sm-offset-22": "_3lNGYH19daOyCcD-vUgtuZ",
		"ant-col-sm-order-22": "_20pjQu654MdJBYB2b8Znx2",
		"ant-col-sm-push-21": "_2iR0q6tac62Ta_Vq-xGtgt",
		"ant-col-sm-pull-21": "_1xMEGtwDxitF92RzwAMf2h",
		"ant-col-sm-offset-21": "_1bmCYQmj6g-B8n8UFOSomi",
		"ant-col-sm-order-21": "_2wP_oGcHncoTMZoQzObGXx",
		"ant-col-sm-push-20": "_1cah7_MEYwOFD7Ec4CgI89",
		"ant-col-sm-pull-20": "_2pfBD8xvtNR_DLgdnp1uz5",
		"ant-col-sm-offset-20": "_1kzb_Fz_CMzDyEwiRr3plH",
		"ant-col-sm-order-20": "KTsxYBAZlQT0IzSUB06LP",
		"ant-col-sm-push-19": "_3lxOQSEyFDHrs-vWrDxSAa",
		"ant-col-sm-pull-19": "_3asnO025KIdgn3gvEPa7Zs",
		"ant-col-sm-offset-19": "ILrsyV35Ie2dAb3zBvex0",
		"ant-col-sm-order-19": "_2wwIEnM7c-kziCNT4NjXw6",
		"ant-col-sm-push-18": "_201YayKY6Wt-AkMY7twdOl",
		"ant-col-sm-pull-18": "_3aCWuO6vwyDnkXOsaNk2-F",
		"ant-col-sm-offset-18": "_3kDiWS2N7B4badQBi0REY9",
		"ant-col-sm-order-18": "_1_YOmAwKCljzFKuTMIZ7de",
		"ant-col-sm-push-17": "E64NfcLND8rCRI2jk5NsM",
		"ant-col-sm-pull-17": "H_t5_h5rC1uLo9YoogPXn",
		"ant-col-sm-offset-17": "heZYF00Zdb2-MU7UQpMK-",
		"ant-col-sm-order-17": "_1ZztByf3Ls8RCHCGkcmxzX",
		"ant-col-sm-push-16": "_2rUluP_jnTFJvd31dTXbZX",
		"ant-col-sm-pull-16": "_3sYCh5wxNoWfZCURim3ATL",
		"ant-col-sm-offset-16": "_1uT9WzpLR8yxaWZx0rzEp1",
		"ant-col-sm-order-16": "_3UdseFS7K_wboSQgM-88Ku",
		"ant-col-sm-push-15": "_3sxhZfYZukmuIe-s_A0kZT",
		"ant-col-sm-pull-15": "_1Dz5JJrZHwgWF7bdqUmBVG",
		"ant-col-sm-offset-15": "_3WBDPZb0njZoo7_tvrKwbF",
		"ant-col-sm-order-15": "_3CAVOfo9w6CqRKaPOCY5XZ",
		"ant-col-sm-push-14": "_2d8QEmsDoMmv8-A6BTYhmd",
		"ant-col-sm-pull-14": "_3qDPgs3uaIgji-YEyb4KfD",
		"ant-col-sm-offset-14": "_1FRZ3_n5e4jOVzYu9DSMQI",
		"ant-col-sm-order-14": "_2-2xZ0mGxhaRFmfN53Wz4K",
		"ant-col-sm-push-13": "_1U8MabwppQVKKSVY7YGQvj",
		"ant-col-sm-pull-13": "_1DoqLO7oS5T4DU7UXhTlXt",
		"ant-col-sm-offset-13": "_3nZ_iU_rzkQloAHIMx7ppz",
		"ant-col-sm-order-13": "_1-UGWIPGGNmK6gVDYhlNSY",
		"ant-col-sm-push-12": "_2sNuln2bFNoCADnZP51ATq",
		"ant-col-sm-pull-12": "_2SanmyCTWRwAyiosnaN1U6",
		"ant-col-sm-offset-12": "_2Vpz7FO9Cucem3YSRyeFrl",
		"ant-col-sm-order-12": "_2O5HDwSTdTwJC7MK85W4Qk",
		"ant-col-sm-push-11": "_2iBNbLYyFqRs-NPePMIycV",
		"ant-col-sm-pull-11": "u-fX8l7TYvdOtGF3iNck4",
		"ant-col-sm-offset-11": "_92KRwfTbo4LrCg8zO9RJk",
		"ant-col-sm-order-11": "_2EKdG26XBAj6XvEvAb_tu4",
		"ant-col-sm-push-10": "_21E9TTDJgknq0cmBRZEUAr",
		"ant-col-sm-pull-10": "_2Z5fFv7avJW-n2de8AdAaf",
		"ant-col-sm-offset-10": "_3pPcR_WRzZAIzrz8LvRP9b",
		"ant-col-sm-order-10": "_21TxjqZoAEh_NMKYL_54g0",
		"ant-col-sm-push-9": "_1PgFeOkmKLTgxB1okZm6Fh",
		"ant-col-sm-pull-9": "LcCRqOf_NG_LShBxXibag",
		"ant-col-sm-offset-9": "_3tKOPvRYUYWSCgs8sF56rW",
		"ant-col-sm-order-9": "A8jbYgkkvcbq1sT_jdfye",
		"ant-col-sm-push-8": "_2ll2yGHqqxMmAdszdBPZCE",
		"ant-col-sm-pull-8": "_1SWDF6efmoOQkBpJnyX2ee",
		"ant-col-sm-offset-8": "_32jHojZxrHqx9yFCNCJU2I",
		"ant-col-sm-order-8": "_1HYySxE8B0N0Y0snmuttsE",
		"ant-col-sm-push-7": "_2egjisvxH6lmMOb38bT8NH",
		"ant-col-sm-pull-7": "_2xtZNnJJexbc3THDQ0xeZM",
		"ant-col-sm-offset-7": "KTrq9giZy3UW-wotNs0iE",
		"ant-col-sm-order-7": "cI5TTcWxBkvHtWyWPzDd2",
		"ant-col-sm-push-6": "_9DDzaSCNt7SSRm4BXrleC",
		"ant-col-sm-pull-6": "_38i6PzF9SzOIf4KmLS2lOd",
		"ant-col-sm-offset-6": "zCAcQZyozEaI5LAmklCyK",
		"ant-col-sm-order-6": "_2WecfddkC8LVI9_wHEmy3j",
		"ant-col-sm-push-5": "B3tW9AQc7-FHueXc20U-T",
		"ant-col-sm-pull-5": "_3ouBYFplxau-Y_w33DSMZ4",
		"ant-col-sm-offset-5": "_1Oppk37tTfMenqvBR5bZ5D",
		"ant-col-sm-order-5": "_2sYWeMpJpa384mb844Rv0-",
		"ant-col-sm-push-4": "_2Ojtb2Jd1UJU8lD4HXDCMQ",
		"ant-col-sm-pull-4": "_1PLHqePFVt8i9Ic-WzwD2R",
		"ant-col-sm-offset-4": "_3YgZtF5HQ8BIHC39ERU68M",
		"ant-col-sm-order-4": "qpvDv_AmslcZCNlgdjSbb",
		"ant-col-sm-push-3": "_1JWNxBbkGNtNPB7Xn9ZoT",
		"ant-col-sm-pull-3": "S1HbOSYUO07V-UyoFbvNh",
		"ant-col-sm-offset-3": "_1v6GejM0gzLmUxxjWZ4t8X",
		"ant-col-sm-order-3": "_1sMU9gxvegzB9-A0wufdzr",
		"ant-col-sm-push-2": "_1MlGQvJFITxDQrr_ySxWWv",
		"ant-col-sm-pull-2": "_1pHQhF1VzX6e7XLySiv6uG",
		"ant-col-sm-offset-2": "_1MLyjO3cIdtzJplF-F5y7L",
		"ant-col-sm-order-2": "_2Lrg_yJQTi6wV3H7E6iRdS",
		"ant-col-sm-push-1": "_1c-OqQz0zFAIFNf_uQAjmo",
		"ant-col-sm-pull-1": "_28Xccg6RWQBoSkFsRCrfXm",
		"ant-col-sm-offset-1": "_1SOsfnvKT3GSTFHLvdw0Ij",
		"ant-col-sm-order-1": "Ofc2gWnBRBLs8LYgtBbUF",
		"ant-col-sm-0": "_3aPfWz7vd_zpA5tj0-7NxG",
		"ant-col-sm-push-0": "_249rFDENkaKJ5ue-g-blcT",
		"ant-col-sm-pull-0": "_1R1ePCs_9AISZ1wmaN8OAf",
		"ant-col-sm-offset-0": "FlCxOumQ5gI3swtDXtVvS",
		"ant-col-sm-order-0": "_3nNInvFwXs_P9gIxRUssPe",
		"ant-col-md-push-24": "_2osXkRbwDUFLAPPhfCQofi",
		"ant-col-md-pull-24": "NyFZV9rJdHKe12rxR223J",
		"ant-col-md-offset-24": "_33rpFr5MTPZmyYCGcpo5yN",
		"ant-col-md-order-24": "_23AROiQDqG5KFWmPjqyYex",
		"ant-col-md-push-23": "O_pHUZHoAvEfnIO6D2iCI",
		"ant-col-md-pull-23": "MemVXqcVe6BvC6BR-xDNf",
		"ant-col-md-offset-23": "_2S8HPtcpSGqw_FF6icTzlV",
		"ant-col-md-order-23": "VCsfavrIH_rco4m-Ow8CX",
		"ant-col-md-push-22": "_2vtAeUImBQJFF9sU1sW4LM",
		"ant-col-md-pull-22": "_12Mmzn74J5mjtya7fLWXYA",
		"ant-col-md-offset-22": "_2y8PTswp_UpoWscOG0AQCd",
		"ant-col-md-order-22": "_1f8qFLWf-R2UZDEP4usaN8",
		"ant-col-md-push-21": "_16zqRNj34OgGXjvTMjnYiP",
		"ant-col-md-pull-21": "_3hupFVEahKxltRTxccWy-_",
		"ant-col-md-offset-21": "_2FpVx-OVIJyBVX1jhpP1jL",
		"ant-col-md-order-21": "B9mVmlj9sKQIDqE6HtBDS",
		"ant-col-md-push-20": "_1nJJ7n-VbTTKRqbaP1-GMt",
		"ant-col-md-pull-20": "dLB-cDKGmrEXRs_WZKxIS",
		"ant-col-md-offset-20": "_1lKe1RdAItj4PPkzgcDuXC",
		"ant-col-md-order-20": "_27LopC4B_5modlJixc30He",
		"ant-col-md-push-19": "_3Rwjd48GF8u-LQ-s_0jted",
		"ant-col-md-pull-19": "_1TDCpDhtIzqs0OR0VBLyvd",
		"ant-col-md-offset-19": "I-kmTy3YZsY_Ah7YpMj_r",
		"ant-col-md-order-19": "_1nODElcvF2l_VeEgr0p_WF",
		"ant-col-md-push-18": "_2PVJ80K633OfMP87mmTHJI",
		"ant-col-md-pull-18": "_1knzmnf9gxa1ZMSPA_Mmyh",
		"ant-col-md-offset-18": "xrs5ckKlEkGvxFjPkupxt",
		"ant-col-md-order-18": "_2jHB82hMC9Dsh_qCXLspwd",
		"ant-col-md-push-17": "_2DwHRqP1K7urZVlYDDawni",
		"ant-col-md-pull-17": "_3uu-TyumqaPUWyqjR9emkj",
		"ant-col-md-offset-17": "_2oOZ_8oCCKlQXM22g_hab_",
		"ant-col-md-order-17": "D2KBbiZsSg_LAkCqp2Jnl",
		"ant-col-md-push-16": "_1JDrvjAvmaJmHY1hUC9w9C",
		"ant-col-md-pull-16": "_1laFRsJnyKGTr0l27795FM",
		"ant-col-md-offset-16": "I3ejEsQ3qDSb62inUf6FO",
		"ant-col-md-order-16": "_3uQVwOiN3wtPIQdErt05Fv",
		"ant-col-md-push-15": "ut8zZBgcumQCq_WLXjGsB",
		"ant-col-md-pull-15": "_1KCsuEk1zADmsEFDa3km6r",
		"ant-col-md-offset-15": "dOhsx_wiJLaYdWJjD916W",
		"ant-col-md-order-15": "_3RvLjB_gz6jBWeMl1TW8jK",
		"ant-col-md-push-14": "i6A5DNvlXWvrgYCmv3V1m",
		"ant-col-md-pull-14": "RaAxAvCOFwK4Ph3DBMOpH",
		"ant-col-md-offset-14": "_3A_uMzcpAN28LRNiWTCV4g",
		"ant-col-md-order-14": "XqXFRMph2ouSvqT9KTIZM",
		"ant-col-md-push-13": "_1RwoubZ3BAI6lu3hFN-2-K",
		"ant-col-md-pull-13": "_1wt_DlyWQgfHamKP6Lmgpo",
		"ant-col-md-offset-13": "_1b2ldC42SfrbJCpxp4NdME",
		"ant-col-md-order-13": "_3mcR55o23uPvyzVSeE68wi",
		"ant-col-md-push-12": "UfCsQyiRY8iSqVVs8GSWe",
		"ant-col-md-pull-12": "_18-QDJ3wcHjpiUuJfvJ6BO",
		"ant-col-md-offset-12": "_3ItMtNSvaaDHaXAVwF649o",
		"ant-col-md-order-12": "_2dSeM-pZjFzQqrgmfUel7t",
		"ant-col-md-push-11": "_2xbJEXnKQoutlhCxZGXenp",
		"ant-col-md-pull-11": "LqruxZ6vayDk0iLgjlxQo",
		"ant-col-md-offset-11": "psoEZ2I5zDtPHKaWVsi4Z",
		"ant-col-md-order-11": "_27mljOdDOuicJNfC7cJoYr",
		"ant-col-md-push-10": "_1_eqeqbzzbJZq3JdKULt-d",
		"ant-col-md-pull-10": "_1bMsliJZFPzD9GgpphHSe5",
		"ant-col-md-offset-10": "_3vReo-Tilt-zZVJmgQcLu-",
		"ant-col-md-order-10": "_2A26tt5Keax-MwbGLuNv3j",
		"ant-col-md-push-9": "_125NM7dEz-hIyhb4813KJe",
		"ant-col-md-pull-9": "_1LaIyyPvwpDPC84PwQIN9s",
		"ant-col-md-offset-9": "_3ghYDJID4TeJzLiE3oKXn0",
		"ant-col-md-order-9": "_16kdaS8VnuELRj3bxRp1jX",
		"ant-col-md-push-8": "_32mKkuHVyDik_ENgV1RhXq",
		"ant-col-md-pull-8": "_1BoZWcT8YgeAsmmWxSOJ4a",
		"ant-col-md-offset-8": "_1kSw0SLcltx1jYVt0l9CFu",
		"ant-col-md-order-8": "F-vnQfHd12KDdNNhYMfXY",
		"ant-col-md-push-7": "_3pNxulVv6eF7PwUbzG5U_s",
		"ant-col-md-pull-7": "_1oipe1KoxlAuJaAKIwA_Jc",
		"ant-col-md-offset-7": "_36lrhw_DngtYuIWmfvncrC",
		"ant-col-md-order-7": "_1mtuj6CQgJz2JrWbV29Psu",
		"ant-col-md-push-6": "_3kNYPmx6oOFsE-ohG7dwL0",
		"ant-col-md-pull-6": "_2UBazrsfh-m8C2msMz4Q9m",
		"ant-col-md-offset-6": "_225M9GYfR-3NGO0xed9qPY",
		"ant-col-md-order-6": "_35jcMCtG7hsJs0z4Xw2J9Y",
		"ant-col-md-push-5": "_1Pdw7FKYnXJatA5tSaOWkR",
		"ant-col-md-pull-5": "o_nxh7dwz4WvxlquOogfR",
		"ant-col-md-offset-5": "_1wvyM3V9Uc9Rq7LR8CtqEK",
		"ant-col-md-order-5": "_15p_J7edQvkt1Y7IhYg3d2",
		"ant-col-md-push-4": "_3ptXmc2-ZhbDiajvyqGDSN",
		"ant-col-md-pull-4": "XtbHy20QkwbM_udn_ce3v",
		"ant-col-md-offset-4": "_1jdGRDYAomJjKHSUqlK_wV",
		"ant-col-md-order-4": "_2VvfckkibEhWOrB0gvOSGu",
		"ant-col-md-push-3": "AWflC3bdWyeIDUgNEb58",
		"ant-col-md-pull-3": "_3-6Mr5xCHrnGCfwQrC2vg-",
		"ant-col-md-offset-3": "_3uJVb0xGvxSYmXJz9awDKs",
		"ant-col-md-order-3": "_1Baxflf7UkHrMDVjBJMmAQ",
		"ant-col-md-push-2": "_2aEnM2xwQv8Ie1XqybIVZr",
		"ant-col-md-pull-2": "kpEB_WNP9W0iFawewT8RE",
		"ant-col-md-offset-2": "_3DVgcwDzltf8zjGTaapx_8",
		"ant-col-md-order-2": "Zybxe5UV2TQ4GtJfRs2Ad",
		"ant-col-md-push-1": "_2Vdoda-x7RUK-KL__7It4q",
		"ant-col-md-pull-1": "_3FhFtxGCb8_bdvbQNqaQOQ",
		"ant-col-md-offset-1": "_34UvqXj5tJuEWCf6AThgKH",
		"ant-col-md-order-1": "_1woB8ms5cjMLVzc6Pa7fDt",
		"ant-col-md-0": "_1KlSwwBN2mV6iUJA_8EcD0",
		"ant-col-md-push-0": "_3_cSfil07EZdnW6bOHW-3j",
		"ant-col-md-pull-0": "_2kLonuzJYLXjjVAE3kI-vj",
		"ant-col-md-offset-0": "_1GS15Hjz7v82QkQjyIcfEH",
		"ant-col-md-order-0": "_3b49yxoRGWFvH1PDmB_2gO",
		"ant-col-lg-push-24": "ml1l-PW40kIJP-N6n5Jx9",
		"ant-col-lg-pull-24": "eC-WhX35ozF0KhlF-sbTd",
		"ant-col-lg-offset-24": "SLTJ0UeBXv5ZndZ8GcG7M",
		"ant-col-lg-order-24": "UyXJ2GSZf2NWnwQWZesrj",
		"ant-col-lg-push-23": "_2MO_FcBG30S6OFhx2A4Wb7",
		"ant-col-lg-pull-23": "_3cD72ZasXpxrFWCS3LqeMQ",
		"ant-col-lg-offset-23": "_3697IlAFaseE89nLy3NjLP",
		"ant-col-lg-order-23": "_3uehUvvMXdMuacTfchkGnj",
		"ant-col-lg-push-22": "POLbxw1IDuqhwSV2ZX4kC",
		"ant-col-lg-pull-22": "_2dLwJRKNZsig6Po0Gb-26g",
		"ant-col-lg-offset-22": "_2jfIoYuwH2mG0qxYDSX1PY",
		"ant-col-lg-order-22": "_2at3tvCCQg24kqBrDGXzud",
		"ant-col-lg-push-21": "rxGGNT5TQqMP1pP6z1Vd5",
		"ant-col-lg-pull-21": "_2sQ0JATZ3JVRG5j0DhPnSB",
		"ant-col-lg-offset-21": "_1MTMKErivD6xMaJI4qI-dX",
		"ant-col-lg-order-21": "_2iHLlGBR_3bpQCow6va1tm",
		"ant-col-lg-push-20": "XrIHkJ30HrP_MHe3qNRLS",
		"ant-col-lg-pull-20": "_1v4ZbulGZciOU6HnM898BD",
		"ant-col-lg-offset-20": "_2Cd1sUl3SJ6n6R8JlWEhAz",
		"ant-col-lg-order-20": "_ZlI-XlvWdb7KQUNajPm6",
		"ant-col-lg-push-19": "_1yU58L78rp4fONj530R_DR",
		"ant-col-lg-pull-19": "_3zDzuUYYih5wuO3Ka0sklo",
		"ant-col-lg-offset-19": "_2JewnKyvxOoFrgVQxMEH28",
		"ant-col-lg-order-19": "_3_DRPkguww2Wvi4TS9Qx5J",
		"ant-col-lg-push-18": "_2eTQk9j2sMwtHQCROzYSSj",
		"ant-col-lg-pull-18": "_1MUcCWWgYTWC5Q7nWjyEu1",
		"ant-col-lg-offset-18": "_1lQr3h5W4y04s54ATbSwtq",
		"ant-col-lg-order-18": "UItj7QL6yrldC7EWJ_zJz",
		"ant-col-lg-push-17": "_2g6GNok5Iv9oTV_HKTI1iB",
		"ant-col-lg-pull-17": "_3LJ-QaMdt2LC9rk2TZMtVu",
		"ant-col-lg-offset-17": "SXEuyzXQC98nTUspuYsR7",
		"ant-col-lg-order-17": "sWXp1c7EWoxxJBrI4vBAk",
		"ant-col-lg-push-16": "_15sIri6tpuhuUnTD5a5fjs",
		"ant-col-lg-pull-16": "YxXH1eebf7TNYgpQ0Uhw3",
		"ant-col-lg-offset-16": "_2cJoCJiudRixXjYHmYODc4",
		"ant-col-lg-order-16": "_1kPLHFzRz8ZfuNZ6isf0ih",
		"ant-col-lg-push-15": "_1Zpm1UJZTfTD098VmWyuh-",
		"ant-col-lg-pull-15": "_3i4OI1IPWaPZGZqjmG7UkC",
		"ant-col-lg-offset-15": "_2y5W1H1YnsgqQRtiYjD69i",
		"ant-col-lg-order-15": "XIOZLLvOQ0ZKv-Y9oBRcI",
		"ant-col-lg-push-14": "fje_3etFQ4hqJzMz0WDOY",
		"ant-col-lg-pull-14": "_1TATdh5cFn8rQETie4yhqq",
		"ant-col-lg-offset-14": "_11xkEJBox-C7QxcWUF705y",
		"ant-col-lg-order-14": "_23OzedXcUUw8g8rkvF5BOZ",
		"ant-col-lg-push-13": "r8hzaY-gZeV76PLJcEnRM",
		"ant-col-lg-pull-13": "_3IHx0TrXB9mppdnq0gicUb",
		"ant-col-lg-offset-13": "_1WGWWDlW_TTMvfgThDqsI4",
		"ant-col-lg-order-13": "GFS24ntBQDQz2S4mEaA3q",
		"ant-col-lg-push-12": "MteW_96FVQ2tPd7_r-ifG",
		"ant-col-lg-pull-12": "_3hY65YxS6V17Ih0QugKM7",
		"ant-col-lg-offset-12": "_3w5rgyT4N4Cc7bySZRByhD",
		"ant-col-lg-order-12": "_18CzmO6Aw08KWbvbuqjOjn",
		"ant-col-lg-push-11": "E20-qKnTDEBypMm3iABNt",
		"ant-col-lg-pull-11": "_3gu7bHGpbb0z42GYIIUnJ6",
		"ant-col-lg-offset-11": "khOV4yrgvPi6lIPQWNBf-",
		"ant-col-lg-order-11": "_1Gg-URA8qjuVk91hVe3ELE",
		"ant-col-lg-push-10": "_36vlND5rvb8eLv1KEyz1JE",
		"ant-col-lg-pull-10": "_2wPd0bIImHuNlMK1Dly3Fe",
		"ant-col-lg-offset-10": "_1M31bNM1VQSQa_CQDoPPIG",
		"ant-col-lg-order-10": "_3B0HT7jEaA78KSl8ygdROf",
		"ant-col-lg-push-9": "_2UD129ZqLqpeutAD2TRO-E",
		"ant-col-lg-pull-9": "_2LS2n3ppUS_-7RL5OqBxP9",
		"ant-col-lg-offset-9": "_SNWkerHQLl5fAAOPQZaS",
		"ant-col-lg-order-9": "_10Z5HEnAuvdhhr3CgtYJbG",
		"ant-col-lg-push-8": "_2uPklkhYHLtdcru5FCPHT8",
		"ant-col-lg-pull-8": "_2ztLUsgUeEwmqZIPrQSIXX",
		"ant-col-lg-offset-8": "_18vOcjI7xw1pbLw3Gm4QLr",
		"ant-col-lg-order-8": "_9oV0-3MWCQuGYq4SW4EC9",
		"ant-col-lg-push-7": "_2POX3l5XUM8OM_Jmmue4zW",
		"ant-col-lg-pull-7": "_2iaZlndH3lz24sserGvNg7",
		"ant-col-lg-offset-7": "_3fEHBmYc5HPE2tD1jI4gS-",
		"ant-col-lg-order-7": "_1cSop9Rihe0NigtjDmRlJi",
		"ant-col-lg-push-6": "_8ATZI2bAEO8h4Y22q5w3E",
		"ant-col-lg-pull-6": "RBwCk62eVr4WxtVIm3b9w",
		"ant-col-lg-offset-6": "_3EmbHGd5344u9H-O7QiNSq",
		"ant-col-lg-order-6": "_3z-dhNPyNMq31RriZNYh33",
		"ant-col-lg-push-5": "_2xMzv5-Tl3JP3NKWJY08Un",
		"ant-col-lg-pull-5": "_12rt-6jkWizWaRu2_zE3KV",
		"ant-col-lg-offset-5": "_3osrCHrd-1_pFAPT7DaswF",
		"ant-col-lg-order-5": "_3rdjS9B2RQjNkQHwjw_f-r",
		"ant-col-lg-push-4": "_3jWVgDK5rUj0XNXMbYdqHK",
		"ant-col-lg-pull-4": "_2t0houF0jDz_4jkr8ziBI",
		"ant-col-lg-offset-4": "_2w68dqt176peMBiUCLxC6-",
		"ant-col-lg-order-4": "_2asbusOWJWwjdrN6tKrk83",
		"ant-col-lg-push-3": "_1mxy6SGjib5KDdXvr9WYdZ",
		"ant-col-lg-pull-3": "_173tmKVQkDDx-3Tn2YElR1",
		"ant-col-lg-offset-3": "_2YqTqNoNOFJ3Pnqpugwb_L",
		"ant-col-lg-order-3": "sFHoE9Y_Udxw9WJjjjo2A",
		"ant-col-lg-push-2": "_2snx0IdaWnjj81GOyRufye",
		"ant-col-lg-pull-2": "_3J7vjnZQl5wLKWFaosH6Ui",
		"ant-col-lg-offset-2": "_3lCubDQomfkfqTKjzyWxp5",
		"ant-col-lg-order-2": "zx-jzZJ44CAkwM6BBS0oe",
		"ant-col-lg-push-1": "_2yyxubI5r-0Ma808cuScfy",
		"ant-col-lg-pull-1": "_3AoBpSAzwu-DNthMK_Rorq",
		"ant-col-lg-offset-1": "_3kR5sm7KmAjIvAMR98p5P4",
		"ant-col-lg-order-1": "_2iBr11dbMKSv7ADsUyUrhr",
		"ant-col-lg-0": "hFkfJN9IKdVcDPQ9aejj0",
		"ant-col-lg-push-0": "_1bHnC1uON-3Su9TRSBkzSd",
		"ant-col-lg-pull-0": "_2JNu0RCbvXRtCdlrgeghsS",
		"ant-col-lg-offset-0": "_3EeMqbEG2e3rQa3XNenKZJ",
		"ant-col-lg-order-0": "__lcQ0hr5q4nlQRB23S5l",
		"ant-col-xl-1": "_2u4B6ZeePw980lqHPx71QP",
		"ant-col-xl-2": "lQ6DWhEa2w9s1m1C6vfTt",
		"ant-col-xl-3": "mXMYmo4QGS04XypadT_C8",
		"ant-col-xl-4": "_2NGVk15Et-bAuvNJt_T_E8",
		"ant-col-xl-5": "Zttg5EszsRpN0KEx3S7YE",
		"ant-col-xl-6": "_1SJZLtxI5Oge5Bz5yCzSfQ",
		"ant-col-xl-7": "_2oKMSPHC8SqbhssFijPsu3",
		"ant-col-xl-8": "_2Sp8MhIm4qvHoP1cgYRlTo",
		"ant-col-xl-9": "_2R5w3p2oZAQoOWHPmi6yXC",
		"ant-col-xl-10": "nQZ9B-eKoAbJz2FQ7GfJe",
		"ant-col-xl-11": "_2T0jsoPffEAbUYB-lZbV_t",
		"ant-col-xl-12": "_1it3WWIC0U7Id1rXPGdSK-",
		"ant-col-xl-13": "_4Pp-27JoOSdkPeP_2FXPe",
		"ant-col-xl-14": "_10TSdrDX-D6mYY2aKBDNsq",
		"ant-col-xl-15": "_2pSBUjBzsR9oas2R3sNTx",
		"ant-col-xl-16": "_31HZwMVcGaVes6WEW8i2qa",
		"ant-col-xl-17": "_2E6or72vO9eOxJWrnpTORn",
		"ant-col-xl-18": "_1guHYgWfw11KXDTvyw-1k",
		"ant-col-xl-19": "qD8SOqnk4gCEL4GowsEtd",
		"ant-col-xl-20": "ZGLZoM7utN_TlvJjg2mgE",
		"ant-col-xl-21": "_1QvHZrZ0esmSqgGQZdUsBt",
		"ant-col-xl-22": "_2rZ-FwDcnzkn-jYnSD2zBn",
		"ant-col-xl-23": "Al-Q0caU4vMWEws-hQLNO",
		"ant-col-xl-24": "_1J3OoneBjv10xgQHcGtbA_",
		"ant-col-xl-push-24": "_1hEk9g00rPKiPPZP9dichG",
		"ant-col-xl-pull-24": "_3GS4vdVK4HJeIWUrquZbNf",
		"ant-col-xl-offset-24": "K3ohez1NZ8zsfMFwh6-Dy",
		"ant-col-xl-order-24": "_2Z0D7foLs4xJyxbxTelk3P",
		"ant-col-xl-push-23": "e9IbMUDXFYYg4w1aaPTqs",
		"ant-col-xl-pull-23": "_3OgZCdo7XPaiPO5kuj5QK5",
		"ant-col-xl-offset-23": "_1mM4e5lxeQXmTMfr4goa-F",
		"ant-col-xl-order-23": "TwaSjTn-m1aHwWwLiI6-q",
		"ant-col-xl-push-22": "_1gJWertmzZgSdLXQbYeQBr",
		"ant-col-xl-pull-22": "_2sKOiOiZLIgURgiK02dWPK",
		"ant-col-xl-offset-22": "_2D7g2J2zOnr_563P3bggVL",
		"ant-col-xl-order-22": "-Lk8lMJuwV7YUsLLVEyNi",
		"ant-col-xl-push-21": "_1fWoCpT1bUdXVuggu5uD_E",
		"ant-col-xl-pull-21": "_1HD-TI5N5Ncd9WFiez_h44",
		"ant-col-xl-offset-21": "_1obmQDI-nbT1HsCw41Krag",
		"ant-col-xl-order-21": "_3XyaasS4Ku9eI57cgymMrm",
		"ant-col-xl-push-20": "_3tj_p64kAb49zfEMT5Dz_B",
		"ant-col-xl-pull-20": "_1pfjqr-JoibcJb3J6rbKzc",
		"ant-col-xl-offset-20": "gtroiDsdFApoCep0741r3",
		"ant-col-xl-order-20": "_3emkbLlGgIA9Hgcfn1ssKC",
		"ant-col-xl-push-19": "_1k_TDqEUt7o1KU59zzhj3j",
		"ant-col-xl-pull-19": "_2D0Avs5etCn6XkXssNEC1s",
		"ant-col-xl-offset-19": "oh6lEhmo62uN5kca74YQu",
		"ant-col-xl-order-19": "_2CGKVRsnWqkwAXUCMTWYyE",
		"ant-col-xl-push-18": "_3C-VBUfeIl5hojENnkLQEP",
		"ant-col-xl-pull-18": "_3FwywuDQ4znSzg2m_pmjbV",
		"ant-col-xl-offset-18": "_27hz0uy0osUF4Vi-DAUoDk",
		"ant-col-xl-order-18": "_3WWWLo1QCjQ9enjYWUxlkF",
		"ant-col-xl-push-17": "_2aIFCV5HZ8ViwKIFQMgGqE",
		"ant-col-xl-pull-17": "_1NC9ieG7ye0wKtmF-UA11F",
		"ant-col-xl-offset-17": "_2EbD5-rv0Rl1_AcxcO4rvM",
		"ant-col-xl-order-17": "_1xSOjQdC-UEL5_Kz546Bhg",
		"ant-col-xl-push-16": "ANlBcyBRyqBDlOjTjc3aT",
		"ant-col-xl-pull-16": "_32jWa6hKbUyrDWeh-ecyXf",
		"ant-col-xl-offset-16": "_1K9BzHcRxuznJXMTv_m9t1",
		"ant-col-xl-order-16": "ns6npy3ZNuM_pbtQYHVay",
		"ant-col-xl-push-15": "l2YzjkB3urbA_6HDmxrAh",
		"ant-col-xl-pull-15": "b4tW4vLuE7TxdgmNfJG_R",
		"ant-col-xl-offset-15": "_3gAGE5M2cN7RiknwGbjwI5",
		"ant-col-xl-order-15": "_28m8faKRRYxTbwflWxVi3X",
		"ant-col-xl-push-14": "_13GPL1HbDnRxj0Hw9bjecz",
		"ant-col-xl-pull-14": "_3VVzy58aozTYugTxGpVMMr",
		"ant-col-xl-offset-14": "_1M-lbE-L5EjvM0K_J177Yz",
		"ant-col-xl-order-14": "DTrOhB-t5rkQR0snBuyFf",
		"ant-col-xl-push-13": "nUIDwCvJko-zMhbYB_2UQ",
		"ant-col-xl-pull-13": "_3DUO6j5r7k5-Yb1YRJvy_-",
		"ant-col-xl-offset-13": "_37qDw8YVZTrzy5vwopouTS",
		"ant-col-xl-order-13": "Aogknsk_1q1TnBkXcNGtn",
		"ant-col-xl-push-12": "_28JXI4I0waFOlwneDnI3lp",
		"ant-col-xl-pull-12": "_31GfGtZ7H5SVhiSAOztmuQ",
		"ant-col-xl-offset-12": "_209D2FPSd-smwM4iDNupHL",
		"ant-col-xl-order-12": "_3ZPM36SCV_WjPZwLPd1pID",
		"ant-col-xl-push-11": "_3xn0mcTAiGXldCYSwvz_ju",
		"ant-col-xl-pull-11": "f_glQ1CyS1qwyq6Zg6eVE",
		"ant-col-xl-offset-11": "_3TxTrLd7kVSQuOIeH2g6Rq",
		"ant-col-xl-order-11": "_1yOB3d24qtmbQ8g-Eqtrj-",
		"ant-col-xl-push-10": "_1KIgeHrAHZNmfC-UBbNFNZ",
		"ant-col-xl-pull-10": "bK5ESXjIHZ13VVwovgmgL",
		"ant-col-xl-offset-10": "cLvPd7lh1X-0Tz0mgOvjI",
		"ant-col-xl-order-10": "_3Dh5Y_6sJXaIV-QNjoa5ld",
		"ant-col-xl-push-9": "dPxgGmPqJV2rJI_ryCLy0",
		"ant-col-xl-pull-9": "_3cevUDalLjKwkBivdDEIkD",
		"ant-col-xl-offset-9": "_2Ky35JYZfcYBt5UZRAMxOy",
		"ant-col-xl-order-9": "_3kDBzWQY3ELwQhviTKBc09",
		"ant-col-xl-push-8": "JDkVYgOAFoyiZ5Y4kDpH9",
		"ant-col-xl-pull-8": "_2p_4gzgnDy32dTR3oIMh_m",
		"ant-col-xl-offset-8": "zid5uOcv-xbBfvn4WeRO_",
		"ant-col-xl-order-8": "UM1IiN4xIE9Lx4okwCNe7",
		"ant-col-xl-push-7": "_2i7GLDKwd8ZBSGAk9cPHw2",
		"ant-col-xl-pull-7": "_3zVdXFxfEeqIHJYxxO68e6",
		"ant-col-xl-offset-7": "_1A7R_IL7W6U7Fk8wgdrBuK",
		"ant-col-xl-order-7": "_2StR3vcSXcj4r2J7p8dMPd",
		"ant-col-xl-push-6": "_3MynzZBARVH8AqrroYSrmf",
		"ant-col-xl-pull-6": "_1EaThxFq-sb0pYx1qiTlz7",
		"ant-col-xl-offset-6": "_28RCgIbjGGj_wz3yE84XvS",
		"ant-col-xl-order-6": "_4rtUaQsL8LO8iQJse4m1C",
		"ant-col-xl-push-5": "_1YQ3YWvqTu9t2lF6kG_eL3",
		"ant-col-xl-pull-5": "_1pjnsjTMeNn16UFjR8qdEE",
		"ant-col-xl-offset-5": "KVDTNvowQJQzNoaN6aOSI",
		"ant-col-xl-order-5": "_1NJZDVUxnCd5toLogaTucT",
		"ant-col-xl-push-4": "_3dsR1JaR6WIkTDjYXxzKNS",
		"ant-col-xl-pull-4": "_3xt8uNeclc82Ty4_GbMOJj",
		"ant-col-xl-offset-4": "_3TyHo-G18haPlIZdLKaka8",
		"ant-col-xl-order-4": "_1rPK9qDRcr-hvdH3tZJV1R",
		"ant-col-xl-push-3": "_3EutNMQyLFFAzWeD1cYjqV",
		"ant-col-xl-pull-3": "MvGv3xwAhavqmVzqS8Pwi",
		"ant-col-xl-offset-3": "MzAGgaR5wLBkaWGoBgLFH",
		"ant-col-xl-order-3": "_3ybj4XrkgnxxJP4RAGnK2O",
		"ant-col-xl-push-2": "_1BYWvMiFR9ZQe2wuKu7Mqv",
		"ant-col-xl-pull-2": "_2A767bn6TCjRgdRMH5La_6",
		"ant-col-xl-offset-2": "_1KUb9sV2JWDYxYeDYvxYCn",
		"ant-col-xl-order-2": "_36rvBebbrxbUTGj4KtyiRU",
		"ant-col-xl-push-1": "_2CDsLO0g4jZS8HW7vcOuIV",
		"ant-col-xl-pull-1": "_1E6qHbsggoA7h2hLdvj-h0",
		"ant-col-xl-offset-1": "lvmcIdM4j-E4tkQhyZYUp",
		"ant-col-xl-order-1": "_2JPEPd0el3GC68EBhdT5iL",
		"ant-col-xl-0": "_2S63Xo5sZhQn_SmD_Wdg7b",
		"ant-col-xl-push-0": "_1IAQJfMYYLi2KYzOS43xXu",
		"ant-col-xl-pull-0": "_3IUyl1vd0lJhDXf_RHUyfP",
		"ant-col-xl-offset-0": "_1nOl96OTmwr75dDYAtdrob",
		"ant-col-xl-order-0": "_2DrSyUL828TgJBnz6RStrj",
		"ant-col-xxl-1": "_2_3A0saCeMioqOm1fHoGm0",
		"ant-col-xxl-2": "_1nW_B8lXAp9exlOEmWlkQZ",
		"ant-col-xxl-3": "SaReG32YWslniRY4NvGsU",
		"ant-col-xxl-4": "_3khb_kpkYBsU5JCWtz_4d",
		"ant-col-xxl-5": "_1EG5J1cWF_ogmqtyjTfGPr",
		"ant-col-xxl-6": "_2-uXedP42hUmCzw8ExLTfl",
		"ant-col-xxl-7": "_2oNN0K5xRP3EqNnSEDEcFp",
		"ant-col-xxl-8": "_1sfRdQyTe8lNKnKR-RMQt",
		"ant-col-xxl-9": "_2P9ydIYICB-KrGCn0yQOua",
		"ant-col-xxl-10": "r42pdeug_JdJnrsyIx9nq",
		"ant-col-xxl-11": "UYl2JwwfaTyYfFeuo4dAv",
		"ant-col-xxl-12": "q3bJHWhPFHlyZvHdwn-OX",
		"ant-col-xxl-13": "_2RL24ZKgg9ok9Xm4Z0HqT-",
		"ant-col-xxl-14": "_2CYQCnzfU0CDDgZNeSLuL1",
		"ant-col-xxl-15": "_20_gCcMkAfQt2biPuYonmH",
		"ant-col-xxl-16": "xwY9vkGCKrbYzgsn6oWFx",
		"ant-col-xxl-17": "_3prxOAvth--PxF8QzX6PFF",
		"ant-col-xxl-18": "f0b6URYyWggWyR8xnth3l",
		"ant-col-xxl-19": "_2YtXR56LqlOsroASAhSDAG",
		"ant-col-xxl-20": "_2_MPZOieQch1LB7k6Pk9pI",
		"ant-col-xxl-21": "_2BaIHc1iNTuth8PZcCyvql",
		"ant-col-xxl-22": "_2y2gYtN-bqHbv1eAOYXJY1",
		"ant-col-xxl-23": "Ov_eqIdK6yqXNZE3RqjM0",
		"ant-col-xxl-24": "_3YcI64pDPNGivQ3hUzolOd",
		"ant-col-xxl-push-24": "_1a6Ch7g3jF7ZjGDMFBuVhf",
		"ant-col-xxl-pull-24": "_3CICZ2_bWphufLwX_O-9Cb",
		"ant-col-xxl-offset-24": "_2WcdN2VTA9Dvkz7_C6DTGj",
		"ant-col-xxl-order-24": "_2XZQstDeJm6mG6uosMJOy9",
		"ant-col-xxl-push-23": "Y1DzG6gypM2yXXjrrrUHS",
		"ant-col-xxl-pull-23": "CnqlV_EXIvCsVAJUb2AmN",
		"ant-col-xxl-offset-23": "_1NpTmAtJRfAi3KdWNFJTVP",
		"ant-col-xxl-order-23": "_3TP_b6pB7bunWsV-d89Mj8",
		"ant-col-xxl-push-22": "_3LuPmXknljmiaYe25O7g-C",
		"ant-col-xxl-pull-22": "_25j7BZ41KV5lvlBSXlFn1J",
		"ant-col-xxl-offset-22": "_34EuqobfdK6viQd_A3eYR4",
		"ant-col-xxl-order-22": "_37MQqGfBwx9IO1Y-RH9Dor",
		"ant-col-xxl-push-21": "_3WjdIfvpXMTjCEKUhrtbMn",
		"ant-col-xxl-pull-21": "_3AD2yZm82-nHu-VWcrIe2G",
		"ant-col-xxl-offset-21": "_2YYsEQBA0TJhBeHKlH2ef5",
		"ant-col-xxl-order-21": "_1IKIDwWLQIDY3DMf0czZ4s",
		"ant-col-xxl-push-20": "_19SdZ3YvGkKqEyHaTgxcAI",
		"ant-col-xxl-pull-20": "_3eNn-fNcGDYg5LW8f1zAxi",
		"ant-col-xxl-offset-20": "LPuXR8xJZz68PFgmpji7z",
		"ant-col-xxl-order-20": "_1GIUQkvXyI1FfTxRP-GsGO",
		"ant-col-xxl-push-19": "_24dJzhnfKPmmmyEGwcJKEc",
		"ant-col-xxl-pull-19": "_3wCzCXELIyne9yN2vSfnUB",
		"ant-col-xxl-offset-19": "_2gF8qUGIBVb3sQDYgmTpaW",
		"ant-col-xxl-order-19": "_1fa8xOACH554m9THUvOsbC",
		"ant-col-xxl-push-18": "_2fFvOyI1it0w9uBhjba-7R",
		"ant-col-xxl-pull-18": "_1faVha5c_LuvUWB6Gjw2n",
		"ant-col-xxl-offset-18": "C2el5trqwVBcXjCHHYngB",
		"ant-col-xxl-order-18": "_3o1fFhb4Uvj5lxpMZodCiv",
		"ant-col-xxl-push-17": "_30Ye9x8OJf_ns1HjPBSO6i",
		"ant-col-xxl-pull-17": "_3IyJeXCMkZUyaKkSJqJOdg",
		"ant-col-xxl-offset-17": "_3NOmS9a1SAAHTPi6NK_vjJ",
		"ant-col-xxl-order-17": "_1RWxWFkWShkGxIOYMwnMXs",
		"ant-col-xxl-push-16": "nPKF6ttGX2wTgYQHnHCsS",
		"ant-col-xxl-pull-16": "_1QaP1mmX_2p881bUPX07nF",
		"ant-col-xxl-offset-16": "_3Ox7akspwROOK--X_c8ZT3",
		"ant-col-xxl-order-16": "_3HD20IkBvDK_VmT774yKH0",
		"ant-col-xxl-push-15": "_1nFt1w7CTWEHlG4yVt5Yj5",
		"ant-col-xxl-pull-15": "P8d6fSMtG4eZZXX_VN2n2",
		"ant-col-xxl-offset-15": "hnto4nT9QTHPCHtk6GcEh",
		"ant-col-xxl-order-15": "_2DspK8QKaXesgw3J6DUcMG",
		"ant-col-xxl-push-14": "_1QUgl4BfcjlHm7x9Kn1A6j",
		"ant-col-xxl-pull-14": "_4qKh0hizn4HF4AsTQBRk0",
		"ant-col-xxl-offset-14": "_2AtHCBwXxmMUS6J72XHHL0",
		"ant-col-xxl-order-14": "pCSU_Fi6oAt8r7BUHhyAK",
		"ant-col-xxl-push-13": "_2k52URtxidPY1zBkPWgh5b",
		"ant-col-xxl-pull-13": "er1cObXfoocbQxUsBgqEE",
		"ant-col-xxl-offset-13": "_38BXB0fQ6BS9qv5g4fQZJI",
		"ant-col-xxl-order-13": "_3L5BLzaEUIZW9lMmcUuXV5",
		"ant-col-xxl-push-12": "_3XwxWfNfNelxSO9s2c405c",
		"ant-col-xxl-pull-12": "_2Wzvot5Y1a0sC1NXy-1Lg5",
		"ant-col-xxl-offset-12": "KPjIlFTT_wxab72e1Rz5I",
		"ant-col-xxl-order-12": "_3fboNjO_Ec_07FtaxrK_OO",
		"ant-col-xxl-push-11": "_3ASrzQ4aTUnc545h6iJtuq",
		"ant-col-xxl-pull-11": "_3XVuQA38gdt091661PXjdo",
		"ant-col-xxl-offset-11": "_3-M-keh9Mih8OxgaGjZg9j",
		"ant-col-xxl-order-11": "_22-paAjRm5kHy6lT3Q6Kek",
		"ant-col-xxl-push-10": "_6pJk7ecDun5IrBPRgEma-",
		"ant-col-xxl-pull-10": "_1GjVdTT549YL3JS5Hp8mbr",
		"ant-col-xxl-offset-10": "JCuOrL29ZSOs6lAMTWMq6",
		"ant-col-xxl-order-10": "_3M3RUwU5hKcrLlAWQ_fwV1",
		"ant-col-xxl-push-9": "_3u6OEPaoyQEmxL_5jEB6j9",
		"ant-col-xxl-pull-9": "Je8QtTfL7dwtg9nL2vOKL",
		"ant-col-xxl-offset-9": "_26WdT0szPiRUnbQgGUcWMj",
		"ant-col-xxl-order-9": "_2nNNZCPMnJE9j6Yy9GGJzl",
		"ant-col-xxl-push-8": "_3gn64_-BBysH9456jAU6EK",
		"ant-col-xxl-pull-8": "BztFkdWrvkNNfL-pLzvaD",
		"ant-col-xxl-offset-8": "_1u34BQ7w3q6wWlk0-KH6QH",
		"ant-col-xxl-order-8": "_1qbcMLazCRT85ioLJXaPHV",
		"ant-col-xxl-push-7": "_2EJDOcESPVX-E9pLGUkMQq",
		"ant-col-xxl-pull-7": "_6Y9A9VXvDfzb8oxG9UpKx",
		"ant-col-xxl-offset-7": "_2malPz0Zkg6x0TuneYRAe_",
		"ant-col-xxl-order-7": "_2WMWdGaIxdjU3X7peoDIok",
		"ant-col-xxl-push-6": "CLMEOQCY3Qzqhf-TqpXRV",
		"ant-col-xxl-pull-6": "_3_hanp0Im22opo51oyXXiF",
		"ant-col-xxl-offset-6": "gbSLfzildJ3jSCzSNL5-K",
		"ant-col-xxl-order-6": "_3KhXPpn33RsnLRDR2Q4O4f",
		"ant-col-xxl-push-5": "eB-VIZeKyCl2beenbDvHb",
		"ant-col-xxl-pull-5": "PM1JeZ_WM-NfgyswBPT_F",
		"ant-col-xxl-offset-5": "_1Ty43Dr_N8KcrBchTnb1Pf",
		"ant-col-xxl-order-5": "_2SYOAd7uGCGyzdVnHG8o_6",
		"ant-col-xxl-push-4": "_2GuTkPUpBbEGtSG8W_jaDh",
		"ant-col-xxl-pull-4": "_1JquSl10OuwVjhVmz_6byc",
		"ant-col-xxl-offset-4": "_269DaxY_L9MeHEtVWoAk2s",
		"ant-col-xxl-order-4": "_3rkJ3cohft-EBYqxELNtpv",
		"ant-col-xxl-push-3": "_3KJzVjR4Vx8I4d-WB5ynH1",
		"ant-col-xxl-pull-3": "_1D9H-O5LTpxeTqSL80oVpz",
		"ant-col-xxl-offset-3": "_19OnciQQ8H7hrrt-2YTcYu",
		"ant-col-xxl-order-3": "_1JU1OVX5D4R4X_SNzq4gaJ",
		"ant-col-xxl-push-2": "_2noRKRbCVokYgz3IqYh-PI",
		"ant-col-xxl-pull-2": "_3f-apBMyrZu0luga99b_ar",
		"ant-col-xxl-offset-2": "sVSEgYBLZEiLw_XJgVIBI",
		"ant-col-xxl-order-2": "D8tnASvcWCBo8b1wST9_5",
		"ant-col-xxl-push-1": "_2xZmt7El7sTK4Y9k9CjJj9",
		"ant-col-xxl-pull-1": "_23SUBCR09sbkZdWalrgi7D",
		"ant-col-xxl-offset-1": "_1YNO-dS1s4Ml-z17aqhaaV",
		"ant-col-xxl-order-1": "_2XSo7ZfA9n-VxS56i3pRGh",
		"ant-col-xxl-0": "_3gZCVOxDkV_rlH19adv1_B",
		"ant-col-xxl-push-0": "_2b2Y-2tGCqpLcVJrYT9PgU",
		"ant-col-xxl-pull-0": "_2RGWrdfNHUfm_8jy8EBKKL",
		"ant-col-xxl-offset-0": "_1JX2jsG73oLCZ--ZnoYd3p",
		"ant-col-xxl-order-0": "_1m5UuQtp735fnn8N7xKa5E",
		"ant-carousel": "_3oe9-WI0tP6unk5FrTtouL",
		"slick-slider": "_2b7QFsC7AKk8R8D7s9MXM0",
		"slick-list": "_2k85WBVBceyVxqlPfFNfk-",
		"dragging": "_3epwOdaPhz6EKcmKQVSv4X",
		"slick-slide": "_3huWg6WBGDSIrwlb-2iT8-",
		"ant-checkbox-input": "_3bn1XXDMo4-lbvwh_h3njY",
		"slick-active": "OU4fZNMsQ2Jg6sp8WfMIY",
		"slick-track": "_5X11PgmiXLkjUMACuxYom",
		"slick-loading": "hgY4-Ev3G3wgGBhQV7QfL",
		"slick-initialized": "_2aoSTnqldSFA7hZS16T-94",
		"slick-vertical": "_1Wh1O3A6QCGtBp5n9p4gFX",
		"slick-arrow": "_3a7rM5ro41iK32orvpQ9HL",
		"slick-hidden": "_3np1ojosSnpTS2rOiALwdK",
		"slick-prev": "_2RosXPvayIWSCxAkMU3FK2",
		"slick-next": "RLzopL2K8DeJRyhZAx8bX",
		"slick-disabled": "_3MKU3SZVEq1gaVg5O_vJ2c",
		"slick-dots": "_1fB2SvKYh0XTGW18Y18cUk",
		"slick-dots-bottom": "_2zhMFdtISdvaAgDKAnSkap",
		"slick-dots-top": "_3GNlAfJvjYj7hf5VVZ2O7H",
		"ant-carousel-vertical": "_2823sOpQKOBek4KN52Tbui",
		"slick-dots-left": "_7A-JBQdDKinK_kVbJLkuT",
		"slick-dots-right": "_38wBH4ktG57KaB6q6J0OIr",
		"ant-cascader": "_3InesuJTU62ULwRUKqy2sz",
		"ant-cascader-input": "_3bU7CHT5Lss1v8CDoIJh-s",
		"ant-cascader-picker-show-search": "_2AeyWDIbJRDPr2AQQI6i9g",
		"ant-cascader-picker-with-value": "_17wxYKGNXth62p3B083F54",
		"ant-cascader-picker-label": "_3I7qT55QHTc0NsQm2o8Dzj",
		"ant-cascader-picker-disabled": "_2rTk814RCDUpmNh_D3mwY",
		"ant-cascader-picker-clear": "DmiJkdTGX48H7r143gmkY",
		"ant-cascader-picker-arrow": "_213Bp5NguaOQg31JGehBAR",
		"ant-cascader-picker-arrow-expand": "xhe8hul9OwVPezwCVQROz",
		"ant-cascader-picker-small": "-nACrxzwPGt8dRTFJ6Q8H",
		"ant-cascader-menus": "_3Y36gjTEBq_e2mJnB7gtuw",
		"ant-cascader-menus-empty": "_1o3-apY9-v62t7Dl2mkJ4h",
		"ant-cascader-menus-hidden": "_1B9mPUL-_ZNXNkOXciJrWP",
		"ant-cascader-menus-placement-bottomLeft": "_3JTSOYgrZxGX24vTd_Yy36",
		"ant-cascader-menus-placement-topLeft": "_1pt4DR7gcQGN6IvHYcrQ48",
		"ant-cascader-menu": "_25pQODd24bANdVTX9s5V--",
		"ant-cascader-menu-item": "_1dXSuB9_gu82nCsPH6RZpy",
		"ant-cascader-menu-item-disabled": "_1KwpxD70qDFYh6TjmMq--r",
		"ant-cascader-menu-item-active": "_16yhk1wX9ZGFd19b4Q_J4D",
		"ant-cascader-menu-item-expand": "_2du_0ndv2iHWz2C6WA1z0g",
		"ant-cascader-menu-item-expand-icon": "_9o-6mBnzG1GCELI5bMI6w",
		"ant-cascader-menu-item-loading-icon": "Ryqbl8mnOfepApHdkxkUo",
		"ant-cascader-menu-item-keyword": "_3M6EnAB7MoiZyauk7SdhVU",
		"ant-checkbox": "_1qXIiaxtanPYob3LcMYCt1",
		"ant-checkbox-wrapper": "_3LtXuasflPstC14W79Zpyb",
		"ant-checkbox-inner": "_25Pc2GL9nkcjI4plpHGGd1",
		"ant-checkbox-checked": "eG1BK9jAdcYnTPSdmJPxs",
		"antCheckboxEffect": "_21X1U27xYleYdbKo6yuHqk",
		"ant-checkbox-disabled": "_1e5SAP1exG-V5zWtAs4McQ",
		"none": "_1CY6uej5ij2TMImio1u0wc",
		"ant-checkbox-wrapper-disabled": "_2rWRe8EdWeH28zowq6f-sm",
		"ant-checkbox-group": "dvvLtjqiI9bDO91BRwGy0",
		"ant-checkbox-group-item": "eOS26o0Lm00OxlQRDB5lS",
		"ant-checkbox-indeterminate": "_2g5KChYsc69byhrnbZALx4",
		"ant-collapse": "_1bxtHNQVsihZgPjfejsPbG",
		"ant-collapse-item": "doWBRub-3JuS8a891u7-T",
		"ant-collapse-header": "_3t2hctYIR7ZYbNmtlLLJCv",
		"ant-collapse-arrow": "TX7E2PLri6sYA2qqJXeLj",
		"ant-collapse-arrow-icon": "_1sVC8xPzqOAmNIIPVJ3cmG",
		"ant-collapse-extra": "_8xyzjf2ILvOLk-P9VmdjO",
		"ant-collapse-no-arrow": "_26f9KhkP_4zZSywx-vvjBw",
		"ant-collapse-icon-position-right": "_3B3liA1u4ZPS-HoNFXlAEG",
		"ant-collapse-anim-active": "_2o7rE8tWmuDVoVcU4pDeX0",
		"ant-collapse-content": "_1gTOs_fESxukIx8Qnr_E3K",
		"ant-collapse-content-box": "_2N3ppCp2EiYkL5haTuYuvt",
		"ant-collapse-content-inactive": "_1GXt_Vcn26tMNRESjgB3p2",
		"ant-collapse-borderless": "_2fVdrJMlaUrpW45weLMO2p",
		"ant-collapse-item-disabled": "_3F3HxQLS5s_5Wfk4MM030Q",
		"arrow": "_2RhSkvgeDEzTFhRNUn4R8_",
		"ant-comment": "_2iDr-CRQU0iRpEaT3X-InR",
		"ant-comment-inner": "_2UUNZHWKdEFC2PWkOgxbU5",
		"ant-comment-avatar": "GYanMrZZnA_LBs68UB1ox",
		"ant-comment-content": "PKoYA_YJf_lb-O_v_0wmP",
		"ant-comment-content-author": "_3R8DjktmpgkWdM0XjlRf1_",
		"ant-comment-content-author-name": "_1J9F0Y9g1FOh1pl3NXLapS",
		"ant-comment-content-author-time": "_1VWGIZ_OA4L4sdIXe7OvM-",
		"ant-comment-content-detail": "_2ei8fUMgtNxq1CoW5Jt-s1",
		"ant-comment-actions": "_1J4VTvLzlgMlIW48FQWx3Z",
		"ant-comment-nested": "dHiEO-CBaeUPOKQ7ZpRZt",
		"ant-calendar-picker-container": "_1ZLQ4odGk130QM9PN6CXnM",
		"ant-calendar-picker-container-placement-topLeft": "_1ctEPZi-olDRIJ_ZCxfBkP",
		"ant-calendar-picker-container-placement-topRight": "_1AXLp_oojwk1sm9yYquaRo",
		"ant-calendar-picker-container-placement-bottomLeft": "Z0wdtWvWQ1hy0bEuwQXpl",
		"ant-calendar-picker-container-placement-bottomRight": "_1r_920LF15agLks16H_x3r",
		"ant-calendar-picker-input": "_2JZfuIaTZD_lWK5HfZHFb0",
		"ant-calendar-picker-clear": "_1rWIPd1klu-G8ILTxOBh3c",
		"ant-calendar-picker-icon": "_2nqVLnLfxwaRHBun1ZdFs",
		"ant-calendar-picker-small": "_2CvkQPMO_gBBB-hgiOJir5",
		"ant-calendar": "k6QPYJpdRnvekKiO19ids",
		"ant-calendar-input-wrap": "_31ntJTDLEi4D9asydwj0gz",
		"ant-calendar-input": "_2Qcq1LR-Bq-DtnSniS6bOk",
		"ant-calendar-week-number": "_8Drlz3GO0A5cZocJ4tBPm",
		"ant-calendar-week-number-cell": "_3YSOHYTSeOuMvjDKKV2Cw4",
		"ant-calendar-header": "_2kkvCXKMQ3plBGxJpV8ran",
		"ant-calendar-century-select": "_1Rw2ggb9g1gPrPzUggApo8",
		"ant-calendar-decade-select": "_1ueD-yLdA9SWfXEQNJKgoz",
		"ant-calendar-year-select": "_3H4v0BAhNk8in2qoOKSkl2",
		"ant-calendar-month-select": "_10f6HpQZl194W0Tfp2VMqG",
		"ant-calendar-century-select-arrow": "_1n2bWMG0mgItOKVGZT2pgJ",
		"ant-calendar-decade-select-arrow": "_3gV5zF_kr51NaZeXYxDYG_",
		"ant-calendar-year-select-arrow": "_3Amf9CFrWL7rIwn9qM7eBD",
		"ant-calendar-month-select-arrow": "_2sZtUQJdCSOUR3kHbQb4GJ",
		"ant-calendar-prev-century-btn": "_2ZNah7OMHbgAvnPEDwZVDc",
		"ant-calendar-next-century-btn": "_1siEj586OkHECWlExwB0_V",
		"ant-calendar-prev-decade-btn": "_2mowPpQZXBhtBYBvCd1fe4",
		"ant-calendar-next-decade-btn": "_1S_Y4kJYkE-Rt3HVabeno8",
		"ant-calendar-prev-month-btn": "_3jDTNFXa36LL4SFs9UOiCt",
		"ant-calendar-next-month-btn": "G2-EqywSap6H_iqn3dfYS",
		"ant-calendar-prev-year-btn": "_1HrAGYGqfeVNu5lch37BM9",
		"ant-calendar-next-year-btn": "_1zkst2vqI1vtFvUxtYUDFC",
		"ant-calendar-body": "_2wW5JvPITyQhjq52fd8LKh",
		"ant-calendar-calendar-table": "_3kneDEqGmtTjQIrWSlAcwH",
		"ant-calendar-column-header": "_2nOi1xTU9WQVx26wuq_za9",
		"ant-calendar-column-header-inner": "_2ghUTNWGAE8UGBEGuuH4g9",
		"ant-calendar-week-number-header": "_11eV1HHIX41Dv0jgGu55P8",
		"ant-calendar-cell": "_1m6b64quzTkmUyG4KXrUPv",
		"ant-calendar-date": "_3slHMiNvDSTCjC_Oi7FLqJ",
		"ant-calendar-date-panel": "b3-X_hmZKU5zUXbpox5eq",
		"ant-calendar-today": "_2EHQB_XsIRnUfNeNSRFsvc",
		"ant-calendar-selected-day": "qQuZoLJftUhEnJq1MhTV3",
		"ant-calendar-last-month-cell": "_3TNOivRs6b3IDJ06G2OwKb",
		"ant-calendar-next-month-btn-day": "_1fSwm4B4puu7Y-HwqpIwEe",
		"ant-calendar-disabled-cell": "_31mcDtESii0rdAOpFMD7SE",
		"ant-calendar-disabled-cell-first-of-row": "AVW5REWz6xXvNCIWsbgkZ",
		"ant-calendar-disabled-cell-last-of-row": "_3nDV70eGXh_qMc6R5Zmtu8",
		"ant-calendar-footer": "_1MgpcwdTPCxW4vVEJzAbyw",
		"ant-calendar-footer-btn": "_3pRBNhIn_p9N3-uTZp7FGA",
		"ant-calendar-footer-extra": "_10xqdK8Nztq4MiNfc79sBH",
		"ant-calendar-today-btn": "_2sz5yU5QJo05sRNtM751fH",
		"ant-calendar-clear-btn": "zAAxwi7oklKu4jQ3-GZVF",
		"ant-calendar-today-btn-disabled": "_2h9wfUsLvEUcLWUBpxiXNL",
		"ant-calendar-clear-btn-disabled": "_1LKCnhrOkQoyc4F7EwgS5X",
		"ant-calendar-ok-btn": "_1oQQN1Wp0GrKUL0l0-ZiX0",
		"ant-calendar-ok-btn-lg": "_31EkOnGZz_KEB6WQSKo5Kr",
		"ant-calendar-ok-btn-sm": "mJn76RwrKFywM9XC--6nf",
		"ant-calendar-ok-btn-disabled": "Y13Bhe_7k6aIonIxEabLL",
		"ant-calendar-range-picker-input": "_39F2u6krlFsfPR1cSzGsVu",
		"ant-calendar-range-picker-separator": "_3VAW-irFbwAlXLuViXSYjy",
		"ant-calendar-range": "_3FSsiqFv7ewyrsZ0XZcEwC",
		"ant-calendar-range-part": "_2aChPRNCJaVfJTqvZzvr3D",
		"ant-calendar-range-left": "_1sLE3SNpNh3SzKE3e9BOHJ",
		"ant-calendar-time-picker-inner": "_3qWIEQKUfDsOL9wB9KBrkv",
		"ant-calendar-range-right": "zbQ-asQD4HI1ayIaVnhN4",
		"ant-calendar-range-middle": "_2sB9KoxDFJkLiEocUI8dKB",
		"ant-calendar-date-input-wrap": "_1XhTqfY6g78iUTgtWGjyqw",
		"ant-calendar-time": "_3QtsJW4BCw1yjNnO8KVmJY",
		"ant-calendar-selected-start-date": "_1lJR-gpJYPnz44lPIsza5H",
		"ant-calendar-selected-end-date": "_3dFZMq1QhFZ3OKZOih2f7d",
		"ant-calendar-time-picker-input": "_3c8j69ATYTQ2LjOVlCt3Ps",
		"ant-calendar-input-disabled": "_1tzJnWx6V1H656bqPPMN_T",
		"ant-calendar-time-picker-input-disabled": "Vw8zFmChZ5B-a2GnvqZ3A",
		"ant-calendar-input-lg": "_1HTjOO06SbYvzbrGdioZOd",
		"ant-calendar-time-picker-input-lg": "_2jtNTN0hY6yneiVI4BFdLq",
		"ant-calendar-input-sm": "_3ugS0mb8U2Wqz1IWC10UcB",
		"ant-calendar-time-picker-input-sm": "_162vCx-q4xtwmaplSNab33",
		"ant-calendar-time-picker-icon": "_1kJ-2mTZqmbv5pPn5aJsJO",
		"ant-calendar-year-panel": "_3kn_HiNxNeZ8-54vXkOpWj",
		"ant-calendar-month-panel": "_5i2IkmjITtOf_mk_ftYZc",
		"ant-calendar-decade-panel": "_3XzI_7ZJ8rhRtqug7hMilQ",
		"ant-calendar-decade-panel-table": "_31DF0gmr-NBuVR5G-cbhRE",
		"ant-calendar-year-panel-table": "_2IMoWOliXKIcSKuf495oHA",
		"ant-calendar-month-panel-table": "X4C1Cv0hFA7JEDXJRmsHv",
		"ant-calendar-in-range-cell": "_3_dnBh2usy1ehq7SCVSgsU",
		"ant-calendar-range-quick-selector": "_2qHlIE1V2A5dRGihU6ynjK",
		"ant-calendar-month-panel-header": "_2Z5hgR5BfayNXIZAJe2b6d",
		"ant-calendar-year-panel-header": "_13Qzdd5EtbGdEWMeRojuny",
		"ant-calendar-decade-panel-header": "_2jChZS1mmgphUk0iph8xcu",
		"ant-calendar-month-panel-body": "b5LwnCqLHkTNxoeOJSteb",
		"ant-calendar-year-panel-body": "_2qSkkOFNL5Hy59dHEVyD02",
		"ant-calendar-decade-panel-body": "_27bGbehYIsvph00J3VxFS0",
		"ant-calendar-time-picker": "_1Hox0Cktuv0KrRfTpMifX9",
		"ant-calendar-time-picker-panel": "_1afavtvgBo-DPcZUTMs-kb",
		"ant-calendar-time-picker-combobox": "_8PsybnRGb-obvxc6sN_wY",
		"ant-calendar-time-picker-select": "_6tN-UalA-OWeaMyNN1wnn",
		"ant-calendar-time-picker-btn": "Ql77bChlRjusuye40rq6M",
		"ant-calendar-range-with-ranges": "_1Gr02Wxhnn5UsPxy5p_EcH",
		"ant-calendar-show-time-picker": "_2S-mw0sPX3JyVL2G4zDybm",
		"ant-calendar-time-picker-column-1": "_3aBe8zOyUh_aCH_1-YSYU4",
		"ant-calendar-time-picker-column-2": "_1h8WLFBbNbvMY3PICpm8mj",
		"ant-calendar-time-picker-column-3": "_3obEyYcjPhk8zoytR-i_0_",
		"ant-calendar-time-picker-column-4": "YsBnLujnxDfGmdlptnhLZ",
		"ant-calendar-time-picker-input-wrap": "_1_yMVUi0PlpTw-gW-MtawV",
		"ant-calendar-time-picker-select-option-selected": "_2BPnBPRFUL6BMKlgaVHKzm",
		"ant-calendar-time-picker-select-option-disabled": "_22ulZnBCuJ0Y79UV-gLGLX",
		"ant-calendar-day-select": "QN5EhGxBMO83enpFS7vIz",
		"ant-calendar-time-picker-btn-disabled": "_3cXcolAzy1nvQkCVCzSBFl",
		"ant-calendar-month-panel-hidden": "XbCh2Rqt3mdZgBHlTUAii",
		"ant-calendar-month-panel-century-select": "_2iGds_AC4wfmjmsm0Dkhgq",
		"ant-calendar-month-panel-decade-select": "_1T5DA6PUutFYtyXqhdQUal",
		"ant-calendar-month-panel-year-select": "_2GTe5mZTh66nqrlGfFEnKC",
		"ant-calendar-month-panel-month-select": "_2iQf7PopzT8i6iFsUQcPiQ",
		"ant-calendar-month-panel-century-select-arrow": "AiVSUYqW8F4NmvDgXPhT4",
		"ant-calendar-month-panel-decade-select-arrow": "_39Expx39AjgOgVlOo2daHO",
		"ant-calendar-month-panel-year-select-arrow": "_1TuqVfGLq3Mh5ojzDMQ1yq",
		"ant-calendar-month-panel-month-select-arrow": "_2CZ0sRphKpWR09kYZYUu_s",
		"ant-calendar-month-panel-prev-century-btn": "ylDUlwEEg_RLqOGdDQ7Fh",
		"ant-calendar-month-panel-next-century-btn": "_4BRmGeedp1g013tGWoENH",
		"ant-calendar-month-panel-prev-decade-btn": "_2pqOGvo3XNxEw4POCQVFT1",
		"ant-calendar-month-panel-next-decade-btn": "_2DXuuZ5ogBChLBpAk5iCYI",
		"ant-calendar-month-panel-prev-month-btn": "_3m2ip7m-AIVMKMH9IoGdN6",
		"ant-calendar-month-panel-next-month-btn": "_1xYQSPFiX6wQqNOq_zdGt2",
		"ant-calendar-month-panel-prev-year-btn": "_336MQABbjXtW62moRMuWru",
		"ant-calendar-month-panel-next-year-btn": "TemtsXq6sB3csC_cTF8k5",
		"ant-calendar-month-panel-footer": "eQvVSwNfx8jvrxmGvLzSw",
		"ant-calendar-month-panel-selected-cell": "_11E2XEItWh24YX-RCOfjge",
		"ant-calendar-month-panel-month": "_2nibJAbTEq56afjlCwIVjW",
		"ant-calendar-month-panel-cell": "_2qFu2biI_NGBsqdFvRzs2R",
		"ant-calendar-month-panel-cell-disabled": "hLaQ6WatXeJWKKHCs2w15",
		"ant-calendar-year-panel-hidden": "_3ywtwKHcf6T6htQBzryHwd",
		"ant-calendar-year-panel-century-select": "eejR6aeX2TZLKZNJJU8OH",
		"ant-calendar-year-panel-decade-select": "_3Ud775zZeyRZ5SvA6N9In6",
		"ant-calendar-year-panel-year-select": "_1ZJDvq6_7T6mlUQSOoNLB6",
		"ant-calendar-year-panel-month-select": "_213hNuJT4BDSD0YmugElQ",
		"ant-calendar-year-panel-century-select-arrow": "_3EBmGuSHAOKlA3Jl4DDtJT",
		"ant-calendar-year-panel-decade-select-arrow": "_1XFEIjfzxyl1vqufIVbVty",
		"ant-calendar-year-panel-year-select-arrow": "_2PGpAFkilug9mTUnOg8KS1",
		"ant-calendar-year-panel-month-select-arrow": "-kX_DcwnSjSkgEIAzep8J",
		"ant-calendar-year-panel-prev-century-btn": "_36KtwsBNS7qhPcwxFZVxMq",
		"ant-calendar-year-panel-next-century-btn": "KBF01uIJ3DNb-yNXE-Ae4",
		"ant-calendar-year-panel-prev-decade-btn": "_3aRSzg4qnmpKlQfnggqAPE",
		"ant-calendar-year-panel-next-decade-btn": "_1ffvAG9sVfRQwwh4kw-QIL",
		"ant-calendar-year-panel-prev-month-btn": "TWoBI6b0DChhNJtpsZi6_",
		"ant-calendar-year-panel-next-month-btn": "_1tQcfDl_LTu_uIV-imD7F5",
		"ant-calendar-year-panel-prev-year-btn": "qlD7cvKjieBjts2Oft7rb",
		"ant-calendar-year-panel-next-year-btn": "_1ajnep20JTS6HHQgonDFzQ",
		"ant-calendar-year-panel-footer": "_3V9QoJ5591_6s5yg8OZTze",
		"ant-calendar-year-panel-cell": "_3FT4tYiEWy8kwmJBYdqb11",
		"ant-calendar-year-panel-year": "_3r_ViX6eroa2fv5AQnEuhP",
		"ant-calendar-year-panel-selected-cell": "_34YmSv1hFtrJpbUNedrHD0",
		"ant-calendar-year-panel-last-decade-cell": "yg3YnBFZAcDOrqEk2am4c",
		"ant-calendar-year-panel-next-decade-cell": "lxqo0R2Cc6LRtcVnXaVMV",
		"ant-calendar-decade-panel-hidden": "_2Pvfrz5M1rjsty0KBnQiVp",
		"ant-calendar-decade-panel-century-select": "_28ol_BDn0ry5FVt-fSnpXa",
		"ant-calendar-decade-panel-decade-select": "_3xvl8E_LQ8PsYoS8vGzP4L",
		"ant-calendar-decade-panel-year-select": "_3DNGitVy_7699goPX4SEPi",
		"ant-calendar-decade-panel-month-select": "ns29lBTpO6GyQYww8fV-2",
		"ant-calendar-decade-panel-century-select-arrow": "_1Fm5pJvq4npyU1ePcNVR_A",
		"ant-calendar-decade-panel-decade-select-arrow": "_2c1BK-ZOlLNdl7ZHbDwKRZ",
		"ant-calendar-decade-panel-year-select-arrow": "_3d1j2zrc-Ja9_deA9uaNaa",
		"ant-calendar-decade-panel-month-select-arrow": "_1HDLMY4osm4qVUlJwrfv9K",
		"ant-calendar-decade-panel-prev-century-btn": "_9xu4B_AS6sQJqK6O-LHyf",
		"ant-calendar-decade-panel-next-century-btn": "_2yNSzl4h_i1odCDdRPOUCn",
		"ant-calendar-decade-panel-prev-decade-btn": "TMtoWvJVJPFMZqvh2ZbKg",
		"ant-calendar-decade-panel-next-decade-btn": "RXhxbQ2DoEuB5dJbVchZ-",
		"ant-calendar-decade-panel-prev-month-btn": "YPF7ZQmYIEG-qSyFrVcWC",
		"ant-calendar-decade-panel-next-month-btn": "_1dXmYT7p-_yLPTl9Xu52Lm",
		"ant-calendar-decade-panel-prev-year-btn": "_2WF9RWijvPnyDhE3c-mA3f",
		"ant-calendar-decade-panel-next-year-btn": "_2D2O6AG4cE2z6Ll__zQwKf",
		"ant-calendar-decade-panel-footer": "_2bU9GIAkO7xJ2BX1-DvdUf",
		"ant-calendar-decade-panel-cell": "_1eNxo5WIGWGHUCDW1EOPEp",
		"ant-calendar-decade-panel-decade": "_2FxVtXKz3NjUhpiHpEFIgY",
		"ant-calendar-decade-panel-selected-cell": "MxiIZTlNOAX4UbnsnO5C5",
		"ant-calendar-decade-panel-last-century-cell": "qUTfszQXA-ZZnwzfzHV4z",
		"ant-calendar-decade-panel-next-century-cell": "_2u5hTaEma1lgLkZRJCtvH7",
		"ant-calendar-month": "xL-0ydbiVfTshJaXvy0hl",
		"ant-calendar-month-header-wrap": "_2xdSGSr3SlfZd4ktw5xu8z",
		"ant-calendar-active-week": "_1KvGYQ2rN_mndInMfsJcDK",
		"ant-time-picker-panel": "_2GNtIDxw9jmNc-bwe9J9fs",
		"ant-time-picker-panel-inner": "_28fPCL1WEEkOsiyV40k6fa",
		"ant-time-picker-panel-input": "_1dc-htT2NExZftLEYPs_Y_",
		"ant-time-picker-panel-input-wrap": "_37gUGNvFI06DRqyivDzwDG",
		"ant-time-picker-panel-input-invalid": "_3acp7JS9rp2mfK3k0LJk9I",
		"ant-time-picker-panel-narrow": "_3w2dyN3wwQ_jzexsuaENdI",
		"ant-time-picker-panel-select": "pcjsoR8Fy2hw5OFnGPlgL",
		"ant-time-picker-panel-select-option-selected": "tM3oWKZ-fYym95A9Je8kP",
		"ant-time-picker-panel-select-option-disabled": "EEGNkzTHyLT7bsQfV-QQt",
		"ant-time-picker-panel-combobox": "_3c2cQnHkcnxmShnKXb4zH4",
		"ant-time-picker-panel-addon": "OfefvOc3nw6lr2WndWvYc",
		"ant-time-picker-panel-placement-topLeft": "_3dvb8njS5uArXjLVfoEQMn",
		"ant-time-picker-panel-placement-topRight": "_2rpLi83zVVb1IBP8dQZgUt",
		"ant-time-picker-panel-placement-bottomLeft": "_3UpD-AMsLyIv6t7rhcE7N5",
		"ant-time-picker-panel-placement-bottomRight": "_2gdkUdvvFo7gxIgELpaaWJ",
		"ant-time-picker-input-disabled": "_1daHxsBUJVWusuSKYMfbVu",
		"ant-time-picker-input-lg": "_2Pyvp5o079s0QNFBkiCJ2O",
		"ant-time-picker-input-sm": "_29zwP_YFKmOXFlBRyZv6OG",
		"ant-time-picker-open": "_3MTU2qYeJD0WQcxckTPPen",
		"ant-time-picker-icon": "iERe0CWcSdjLkEwAiRq4t",
		"ant-time-picker-clear": "_3q9TG9Eekd0jcg5Jfeh-MJ",
		"ant-time-picker-clock-icon": "_3Z3WqS4jhio8IG1rkNEjXP",
		"ant-time-picker-large": "qIfYHydDmTibvi4A-i40s",
		"ant-time-picker-small": "_3kUDHp7F0A47KOUnANFZpL",
		"ant-tag": "_34hUjmK5pAowh5cdxG7iPA",
		"ant-tag-has-color": "_3fm0tTtOra9C5RVVSDktZr",
		"ant-tag-checkable": "_1QSKQWhfWGpUKBMc4I19CI",
		"ant-tag-checkable-checked": "_23m3ZM4ZI3ZqgtY3_N9tOz",
		"ant-tag-hidden": "_3hkH1v1bLJPSbF0cAgmj-h",
		"ant-tag-pink": "nQsPevY3j0qVa_JpddmwD",
		"ant-tag-pink-inverse": "_3d9P06tl-1U0fmNCwchyhe",
		"ant-tag-magenta": "_1AGjEsdUZ3HZKkFzMthvYS",
		"ant-tag-magenta-inverse": "VdbHKa7KP-hAkADrumBEW",
		"ant-tag-red": "_2MkOdcyIEWg25Z505_05oi",
		"ant-tag-red-inverse": "_1njBgpO4DnheQ47pjJrc0N",
		"ant-tag-volcano": "_26hX3lCzhaINiY1HDitwal",
		"ant-tag-volcano-inverse": "_1frfPifXvJ4Of51Z5g3Tld",
		"ant-tag-orange": "JDIy0tZGBSpsknPhG4Zow",
		"ant-tag-orange-inverse": "_1uAHhO6dtQByTKLTXJ7GkF",
		"ant-tag-yellow": "K8K24ko9T8jts688WfeM3",
		"ant-tag-yellow-inverse": "_8CmaHU7SueWXM1S7BIW7u",
		"ant-tag-gold": "_1IL5lLN_4_DlyeW73E5BSL",
		"ant-tag-gold-inverse": "q9HJYlHF0KI7dBMDkV0J6",
		"ant-tag-cyan": "UOkSdHZrIZ4iNHzRFOHmi",
		"ant-tag-cyan-inverse": "_2vK_TBknDdU9bpTHB0tpIy",
		"ant-tag-lime": "_1hazu4pqsdkiOHKbA_ak-k",
		"ant-tag-lime-inverse": "_2dMDl02c1UrXsLFTYKMzAr",
		"ant-tag-green": "_1eE8zoW5qaFNr0Cj70VR93",
		"ant-tag-green-inverse": "_3bgdhWWIgZEzcMxbI2c-IH",
		"ant-tag-blue": "_2Sv129GLzinjJ8EJ-pviGY",
		"ant-tag-blue-inverse": "_2BLttzUrT79F-O-qLr0DvL",
		"ant-tag-geekblue": "_3b2QHG0GAMA5QAJQfKDbwj",
		"ant-tag-geekblue-inverse": "_2ACUKEJBJw_uXO6IQfmZa9",
		"ant-tag-purple": "RXClilZOBVMboFyWSMinR",
		"ant-tag-purple-inverse": "KbORZ9Gr5d3qA8zwvb0C9",
		"ant-descriptions-title": "M2l7aGKFJjk0GLDF8efFr",
		"ant-descriptions-view": "_1QcvqhJEAlfyUjuSjknRxT",
		"ant-descriptions-row": "Sot07S8jsidUeISHaZvtA",
		"ant-descriptions-item-label": "_3QXBA6cnWRGDZlEzSFaqPd",
		"ant-descriptions-item-colon": "_2xEteRvl_AbSvq3SLvuwu7",
		"ant-descriptions-item-no-label": "_3eIDGCg9s2TKi36-oz859_",
		"ant-descriptions-item-content": "_24FRihf2N7SRyR-GaZv8Nl",
		"ant-descriptions-item": "_2wwf-kbe8O5mO2PptwzB58",
		"ant-descriptions-middle": "_3i2G2fswrF1azoUDAXp6Yr",
		"ant-descriptions-small": "b6E84UqLW-BH60i2jdowC",
		"ant-descriptions-bordered": "_1CeV5PEls8Qd2EPx_T1VRJ",
		"ant-divider": "_1FEnN_4Xw7j2HKvC56B3mu",
		"ant-divider-vertical": "_3Ui0E_Kjt95Y11pgFHRL5i",
		"ant-divider-horizontal": "_1MLnyi_RKS5waO7WI6Nouc",
		"ant-divider-with-text-center": "_2cJYftzCa-S1Ci8ZQWIaxQ",
		"ant-divider-with-text-left": "_1BhAviZSlpjCEVDH_WJmpP",
		"ant-divider-with-text-right": "iWdRBdGcJnWzClmtR2fVb",
		"ant-divider-inner-text": "SOVARUqJK1OApf6L6JnTq",
		"ant-divider-dashed": "_1SpFgdGIEbmyp6SnLq4N_I",
		"ant-drawer": "_1brJ42d6ccjRomTdVJGkQA",
		"ant-drawer-content-wrapper": "_1BHNl8FLIlJ2U0VQYE_hlY",
		"ant-drawer-content": "KO0z9Yrx1ZduhaXAoHy2_",
		"ant-drawer-left": "_3vb0crTFxsOakTpC91cJ1M",
		"ant-drawer-right": "xAf0DgIsIaxC07eZJl3Z",
		"ant-drawer-open": "_1-Yc2-3VAWhTBIxUF6ckRM",
		"no-mask": "_5tlxe8BDbZvAZ7uqRG4Ob",
		"ant-drawer-top": "_2jX2Aqvc5_3FGPzIF8kAhe",
		"ant-drawer-bottom": "_2DO4iwho7EvuicDacu2YQ_",
		"ant-drawer-mask": "_2meVzYjYNYesRwhCyE8_qR",
		"antdDrawerFadeIn": "aOZMUYzFuulrq0XsBkDlO",
		"ant-drawer-title": "_27Gwa7nprIoEQW27Ol74HY",
		"ant-drawer-close": "_2p2MN1iEO9cC7MDs0ssVP8",
		"ant-drawer-header": "_1qvM539Wy3QLZjwO32CqQN",
		"ant-drawer-header-no-title": "_260BYWR30mR-I-1GaVFdD_",
		"ant-drawer-body": "_15tNqDhkLq4y0OsKsOG88b",
		"ant-drawer-wrapper-body": "_1waF7njPHLUdI4ESIPb29e",
		"ant-drawer-open-content": "_1mkGNTPKRoO023hvlnAuqQ",
		"ant-form": "_15Qo9KQmSwT0qKXbW-st1h",
		"ant-form-item-required": "_1buMok73lgT78pVHV_Iiii",
		"ant-form-hide-required-mark": "_3m4uDhSX5VZVv_sVRUX3Lw",
		"ant-form-item-label": "ELjJ_GsWjTuoRRMyAfHok",
		"ant-form-item-no-colon": "_1lfid9rMwb-hHKAfI-EmJ3",
		"ant-form-item": "_7hnn9vwcV8XmiAZUgTcWG",
		"ant-form-item-control": "_1xX0DsSkt7GiZAD7EU0Nfg",
		"ant-form-item-children": "_1fWfi_zByEISzoycmRiZMa",
		"ant-form-item-with-help": "_1ZPFwTvAqtwTYOncDtRvaZ",
		"ant-form-item-label-left": "ySeNiEQvvG0QEydkzgbnt",
		"ant-switch": "_1pX4_L35Dl4y9IKf_tCLsc",
		"ant-form-explain": "_3jy6nXG15JPTeZy62QY3dQ",
		"ant-form-extra": "_1WZJQ2QnB4plwZjs7q2dlf",
		"ant-form-text": "MfaP8-NcrfSK7OqaTRkg2",
		"ant-form-split": "_2LJPwEUvtby_NEuglCfw-3",
		"has-feedback": "_3rtccfv5gLbWUnczwUEtA9",
		"ant-input-search": "_3MbiO8TsBjLTDfxpyX8YY8",
		"ant-mentions": "_2b1hOLgW0QbUm0CvwL-46V",
		"ant-upload": "_1h8t2iciEXSc8I7I3peHuM",
		"ant-radio-inline": "SIz6rwqHlowWagsE6hysJ",
		"ant-checkbox-inline": "_1sr_u3tk5Yu3V_dmNYfnYs",
		"ant-checkbox-vertical": "_2r-3diWr4jJwRnTUQwq2CB",
		"ant-radio-vertical": "_2PMnvd7YfLv4ICSoj05oSN",
		"ant-input-number": "-RzW_3LJkkkKtbTlHEhUw",
		"ant-input-number-handler-wrap": "_21oo90tksizKkQn7EjecHJ",
		"ant-form-vertical": "pWr5If0X_rD3eG_H8JLrd",
		"ant-form-item-control-wrapper": "_4Shtwfc77XFo-yEqUOS7f",
		"ant-form-inline": "_3ow3vMuEBuB3YhoJ5t93hJ",
		"has-success": "_1PxRl654EayHhb4ltXaqyU",
		"ant-form-item-children-icon": "_4zk-kIJFv-XJmEfA_zhZL",
		"has-warning": "_2vNbejHw1xnP-cOT2-_bGv",
		"has-error": "_1uVRdcmSVUVSmxHP3p6xn2",
		"is-validating": "_2GRmUr8QIpVdG7NsGBYSTb",
		"zoomIn": "_2l1p_XAL8knvE-TA3qBhyM",
		"diffZoomIn1": "_1F2DvTG4-WjowJh9HUfVG-",
		"ant-calendar-picker-open": "IBnQ3AnRCKBynOW9qwqSo",
		"diffZoomIn3": "_3-B0nx5dCFb49bpzi27Swn",
		"ant-picker-icon": "_2pzAxEajE34Kg1rIeoVX8B",
		"ant-input-number-focused": "_2xff8EFXmm9qnF2wrTjPOy",
		"ant-time-picker-input-focused": "_3HZHDxDo4uhCBz6ZTQM7Ab",
		"diffZoomIn2": "_2Ary_buAgy7WuJU8fEjvBm",
		"ant-mention-active": "bf5U_b82Zn-jzGoDLzpRV",
		"ant-transfer-list": "_2fWTapgGa9S4V8oTJQqPuC",
		"ant-transfer-list-search": "_2ahGzO6VPnpqbaNMwJwobm",
		"ant-advanced-search-form": "_18qk49lH79KVdqlXeLL7gy",
		"show-help-enter": "_3ztUd2T-fLpvttAQgEqsqs",
		"show-help-appear": "_1OFiTBCBckSN-5pgoAMdOE",
		"show-help-leave": "_3KhjdDViy3psoEM-nkt93U",
		"show-help-enter-active": "_3bMkFTKjNTE0dkN8YfJAR0",
		"show-help-appear-active": "_2LMaYd31SP9DUC9m9HMSEq",
		"antShowHelpIn": "_2rqz12K75fw78vsM_Xk36a",
		"show-help-leave-active": "_2JLIkDTX2CPcBhE6RwKn2P",
		"antShowHelpOut": "_1Z_t4tw2mUmhZenz5t-bx-",
		"ant-input-number-disabled": "_2gqrr5CJflUo5nBlDHQEhl",
		"ant-input-number-lg": "w_qHgwuFTc3v4t_PAO5jH",
		"ant-input-number-sm": "Ep-vfOMeIkNaHxjiWlrVl",
		"ant-input-number-handler": "_3t4-Cw_o5EuyS0AgK2vEuB",
		"ant-input-number-handler-up-inner": "glQTOz8VsDHy4Jh_yBXkG",
		"ant-input-number-handler-down-inner": "_1h-JmRCo_HqSwqiOh8BmWg",
		"ant-input-number-handler-up-inner-icon": "_3FdEhTrDh6FJR6_j_bFj9V",
		"ant-input-number-handler-down-inner-icon": "_1kf-gvoGBS6Z4dVQ6GkpXF",
		"ant-input-number-input": "_3lAv5HBQDptJqKZz1q_N7m",
		"ant-input-number-handler-up": "_3YZhRPSuovDhOmgakq9C7o",
		"ant-input-number-handler-down": "_3pMcvEEEeZ0Z-dZk0g_jcM",
		"ant-input-number-handler-up-disabled": "CY9JRqz6VZqsOy5ttlZDE",
		"ant-input-number-handler-down-disabled": "WFG3NS2BIDsohaUDIAFCX",
		"ant-layout": "_3mikNXjaLhj5gSNJRA-I9U",
		"ant-layout-has-sider": "_10spVR-eMhLkEGrEWb8m_i",
		"ant-layout-content": "N9kmGkgwjDnn6VSfqMAjh",
		"ant-layout-header": "_3ZFjEVciV7jA-Lz_ubggJC",
		"ant-layout-footer": "_1C3d81CDronxOML6Hc-_wC",
		"ant-layout-sider": "OuC2CyVFAnUYkPsybXaw7",
		"ant-layout-sider-children": "cb6yTmkTjY2NZFJQlwDBl",
		"ant-layout-sider-has-trigger": "_2ll_cLbn0ljKue3wIhHPaC",
		"ant-layout-sider-right": "_2XAQ0jFggvgrNd9wsrScz_",
		"ant-layout-sider-trigger": "_1XFzvO4DfM-DhzK7HLRWzv",
		"ant-layout-sider-zero-width": "_2gzVbX_oljYJEzQxJIk7GU",
		"ant-layout-sider-zero-width-trigger": "P6xix3OjfwUdjiQil3v0K",
		"ant-layout-sider-zero-width-trigger-right": "KKcSd00e4pLRPgAiwC5y-",
		"ant-layout-sider-light": "QhBpai2gF-pVnFf-w9Obr",
		"ant-list": "_3HIgBcVpilUfQfQ9sAbNu2",
		"ant-list-pagination": "baji5TDXAeafQiFad3dvj",
		"ant-pagination-options": "_3E4NM-Xt86D76rf21xBrat",
		"ant-list-more": "_2UR_lGHGFturZDmU__KNn_",
		"ant-list-spin": "_3rYZoJZPBSTcvRdS4EhRs4",
		"ant-list-empty-text": "_2T2KclM46l4EFjPw6uVKmr",
		"ant-list-items": "_18chtvr8BoDiREOxb4666y",
		"ant-list-item": "_3v6hS-oiYk2sOv4queo_A0",
		"ant-list-item-content": "_3EBvUiz2GDQ4JRqjuI2obg",
		"ant-list-item-meta": "_3lgtuc7jBY5OJt850ZtODx",
		"ant-list-item-meta-avatar": "Gu3sh4t2a4DVqBaFvfNA6",
		"ant-list-item-meta-content": "_1jHnJa3miHGEr1P-hmJVPK",
		"ant-list-item-meta-title": "_1xxzM1nlRzDHC6xvHMZ3YG",
		"ant-list-item-meta-description": "_2KFFLpQwQdB8l0EwWweCWB",
		"ant-list-item-action": "_1hEm-CrAMHPul7abFCynGM",
		"ant-list-item-action-split": "_3JNoui1M2YmmwYtzpCdbt4",
		"ant-list-header": "K7eVrQOGUsXQU8SUPZV6R",
		"ant-list-footer": "_39LTZfb4ErzHKHhG3VXAOA",
		"ant-list-empty": "_3PRxMIN4ZUQj8dKrMwPiyZ",
		"ant-list-split": "_2aqFSbTpv_mkNyS2623ag_",
		"ant-list-loading": "_2UigaUqWLvuBQxTMVMgwjR",
		"ant-list-spin-nested-loading": "QqFPeU74URIiKbruoJWb6",
		"ant-list-something-after-last-item": "vVpcPP0Jp3Rm1x5osINKE",
		"ant-spin-container": "_1jrq9dfOxKwT2J3sfo9HId",
		"ant-list-lg": "NL47r4ohAXVYgUOFrbTl7",
		"ant-list-sm": "_2MIZdrc5QmLPuIQDOhYaSG",
		"ant-list-vertical": "_2okJ9umcOw_j7RNkFM0NfQ",
		"ant-list-item-main": "_3ViShGJ04PrIhBnOVgqdsZ",
		"ant-list-item-extra": "UhcE8DlZZx03ATb3k7aG",
		"ant-list-grid": "_3H74wyAo6REdBWAcWxuzDS",
		"ant-list-item-no-flex": "_3Q1mp1pJWlCe_IWMoz9WnX",
		"ant-list-bordered": "_d594fZSmN1Tl5iawj2Ab",
		"ant-spin": "_33_hjoFeTSOWk_t1Z7Sr-c",
		"ant-spin-spinning": "_25jf8kRv826BvBkZnoLXC9",
		"ant-spin-nested-loading": "_3Ke6pb7hhqQtNVgQMQWFc2",
		"ant-spin-dot": "_2dlEDqVGge90rcRSiRPwc3",
		"ant-spin-text": "_31LyyB1MhQ63Vc5oqAeuoF",
		"ant-spin-show-text": "_3_T6l9g2pj8kzvGWRx-fo7",
		"ant-spin-sm": "_3kj8CHHlAaJjTHG_LXLDJ",
		"ant-spin-lg": "_3aWuqxcOolVHV_G5k1OqJm",
		"ant-spin-blur": "_2JPYRrTSbxUfX7zWCrR_Rw",
		"ant-spin-tip": "_2OPv56d89J8Mue367okw8g",
		"ant-spin-dot-item": "_1vaXbUaFs8T_DAONOUI5Fd",
		"antSpinMove": "_1tKKIQE_-FtjjAD8yiF_Vb",
		"ant-spin-dot-spin": "_2MSFA0f_y97EstHKy7mOI0",
		"antRotate": "_1uA-MCavQFuoWkE8_d74T5",
		"ant-pagination": "_3yFO0ExW2lDi3iJscVlo6q",
		"ant-pagination-total-text": "_1iBopO6rJc1O90ZFd7L2gz",
		"ant-pagination-item": "_1f1529XdUGcTWDgnn6rnUv",
		"ant-pagination-item-active": "_2meHzWui1MaKcYqri7tufu",
		"ant-pagination-jump-prev": "OHwGF6QYpVU8Bnp_pSxIC",
		"ant-pagination-jump-next": "_3i4e8RnsYoFnDxr7H-mhMN",
		"ant-pagination-item-container": "_2i1DZPi3jW2cQLK0SEOa5r",
		"ant-pagination-item-link-icon": "_2epQoamc0VtGpZB_edAmK8",
		"ant-pagination-item-link-icon-svg": "_2ySmZOZI-TsAPn4Fpiv-Hm",
		"ant-pagination-item-ellipsis": "_2jST0s6r8iPEVsdgWLFLBC",
		"ant-pagination-prev": "_2jUvMeEGYqUYn2eIxGyIr0",
		"ant-pagination-next": "p8NyuniaW72c2_u0mcTNJ",
		"ant-pagination-item-link": "_130IDfc9UumlVlkRj_tMd3",
		"ant-pagination-disabled": "_2Erd3VemLmI_4IUPF1pNX5",
		"ant-pagination-slash": "_1qd9Y7KpTnvonJIZNNUNKA",
		"ant-pagination-options-size-changer": "Nrkfmn2t7in374axnSHb9",
		"ant-pagination-options-quick-jumper": "_3csAWP7VhxIj4dAZ0PQ3TV",
		"ant-pagination-simple": "_2vu3x68gvy_NeGX1VA9hZh",
		"ant-pagination-simple-pager": "_15bgL_6ieFiK72lBhmeVpJ",
		"mini": "_1VxqH_l6bGur6YTGvueD0W",
		"ant-pagination-item-after-jump-prev": "ZfpZTNXn6MvWlfQXacS_k",
		"ant-pagination-item-before-jump-next": "GGVp1H2RhTfDGf0-Utpt7",
		"ant-mention-editor-disabled": "_1RTi7ckd4PgsS2fCkneVWA",
		"ant-mention-editor-lg": "_36BCYnfNgZqiwRqq8vcOsT",
		"ant-mention-editor-sm": "_1smnBainYD0VStXjw8EV_Q",
		"ant-mention-editor-wrapper": "_1VjLPOAvv4YCntQ2MmH_ey",
		"public-DraftEditorPlaceholder-root": "_1uwngUxhOg2tREs8tYb01s",
		"public-DraftEditorPlaceholder-inner": "_2-g3_40Q2iEVf5_2ox9h31",
		"DraftEditor-editorContainer": "_2MBAOecTA-SLqVboZa6kNc",
		"public-DraftEditor-content": "_24yvQhbhHxhMxFsdwYTxtA",
		"ant-mention-dropdown": "CpjRV0iU-4Nz1Z8T4WLys",
		"ant-mention-dropdown-placement-top": "_2nkQMiH0tKJCXarnyu6Zj4",
		"ant-mention-dropdown-notfound": "_2egnxmBYklXbJfz0cQ7yQ_",
		"ant-mention-dropdown-item": "_19Qtk0_pgNq77S2yM3RPaC",
		"anticon-loading": "M1pWPFIKw7Lipb7_xEhWj",
		"focus": "_35mm_9_OLUgn5eifoIA-vO",
		"ant-mention-dropdown-item-active": "bmO63xp6pSS52jKLRV6dM",
		"ant-mention-dropdown-item-disabled": "YaxhbWIAwqwnDe6DCPIJM",
		"ant-mention-dropdown-item-selected": "_3zKZJq-ySH40NY3j14wzUK",
		"ant-mention-dropdown-item-divider": "_376sEn1wsb3Db-T6fpsrYf",
		"ant-mentions-disabled": "_1VkwU6jDoiz0Rz3HMt67xg",
		"ant-mentions-lg": "_3FHavFPa-8yeylPYSFErfp",
		"ant-mentions-sm": "oMi_gy5EPp2H1hilHdUHS",
		"ant-mentions-focused": "BkIQLFUZjKkHSifr1ZKph",
		"ant-mentions-measure": "_11EU93dV-SjK8flRW23jAU",
		"ant-mentions-dropdown": "_3ChvqdzSqC56hMtsNxA8RA",
		"ant-mentions-dropdown-hidden": "_1lRpaAJantPS-A2OopEbpu",
		"ant-mentions-dropdown-menu": "_32OP3ph50munbPYgXAviiw",
		"ant-mentions-dropdown-menu-item": "_1kjQTt5weob-nzxHHD9OhT",
		"ant-mentions-dropdown-menu-item-disabled": "_3tWz5XGYho7R6sHLjtskF",
		"ant-mentions-dropdown-menu-item-selected": "_3T4NjiCCx240ILShqLVVEQ",
		"ant-mentions-dropdown-menu-item-active": "_1ItyC9ldJ07fKyByCuZSjE",
		"ant-message": "_2scQ5iv-KD3tc7_4wOYZeH",
		"ant-message-notice": "qijyafB7NLEXM9LFQ4bIH",
		"ant-message-notice-content": "EI-n64ltYTFKxGHk_Rn1_",
		"ant-message-success": "gkMUsKDxuGbFc1bGcMdjZ",
		"ant-message-error": "_2CBg0Z1HkMY5cOeZFsHjDW",
		"ant-message-warning": "_2awRrnOKdlkv4RJpgYkdD9",
		"ant-message-info": "_1bQC3GuFxcicO9K2l1aD8n",
		"ant-message-loading": "_31j5L1LOApFTa7sL8ibhAO",
		"MessageMoveOut": "hAiSCIK6SrmkYWpF-gwLI",
		"ant-modal": "_1p4wiVJpxk7sAs3u8XwUbe",
		"ant-modal-wrap": "_2qTKcbP4Ra0rVnrEbPEdNx",
		"ant-modal-title": "_3__RNUXvpP1aLf3mDH1mLF",
		"ant-modal-content": "_2d5FRv5V7mSPG_douar4Ul",
		"ant-modal-close": "_2ldhGnBmBU6RvFjHQ3JDQe",
		"ant-modal-close-x": "_3UKHG9lLTQi88eFRnVVv5P",
		"ant-modal-header": "_2wzMnkOsTe-3AWQ85m1TjK",
		"ant-modal-body": "_10AeroU9dgP4jH85UkxC3-",
		"ant-modal-footer": "_1DtBpy6AkyyEoezB4t1rVh",
		"ant-modal-mask": "eq0YVfAZO_meNhnr3yx60",
		"ant-modal-mask-hidden": "BBDzQtAmnJpdvRAkHUUIN",
		"ant-modal-open": "_2kgxLoU2rjK7uGiyjB-4fW",
		"ant-modal-centered": "EnFY7K0nMtUgUe1iXUI0d",
		"ant-modal-confirm": "_2pio4Ippb2FVc_KA7GOcDC",
		"ant-modal-confirm-body-wrapper": "_3NwImwuX4SDTAHABoMytrj",
		"ant-modal-confirm-body": "_1zS8uHVyFRWPRjOcvbKISm",
		"ant-modal-confirm-title": "_32o5cMnV-gIZbjefZhq61i",
		"ant-modal-confirm-content": "_3QF8eid9eAKB3ANccNUJnD",
		"ant-modal-confirm-btns": "h2fqI7f2RVSnSbByxOdT",
		"ant-modal-confirm-error": "nqNTv7vkzy5BWTIJu8as4",
		"ant-modal-confirm-warning": "_3vwTKAENvLi-VhCTOtb1Bj",
		"ant-modal-confirm-confirm": "_2_gOA-NqcuV7pr8MdDQRV4",
		"ant-modal-confirm-info": "J7JyQKkzR9rSKiajIm1P0",
		"ant-modal-confirm-success": "_2_04kdOkEGAgnJmWug6FuC",
		"ant-notification": "_3NPN7lUgfZGtdGoCG8h0cc",
		"ant-notification-topLeft": "_1JNd6GIyfRXX-XujzlqoW0",
		"ant-notification-bottomLeft": "gMs98mDL1U2UEyk3jt_pD",
		"ant-notification-fade-enter": "WPeniBWOP1r9qW6H0h-e1",
		"ant-notification-fade-enter-active": "_3rVWPmDwdtCvqWwboQ7WI3",
		"ant-notification-fade-appear": "_1AEK42-Ues4PFMucIxETek",
		"ant-notification-fade-appear-active": "_3uzmwGdxO4qVvPHTT4jD-Z",
		"NotificationLeftFadeIn": "T7Mep6NGkTcPXDjdejT5F",
		"ant-notification-close-icon": "_1Vb-VneAVHmSDWGSaZbTSe",
		"ant-notification-notice": "_3sw2WnyZWLNbAE52BZsF5N",
		"ant-notification-notice-message": "_2uAqHFLPbE3qvrlzdFqxGM",
		"ant-notification-notice-message-single-line-auto-margin": "_1jblYp7mbU1RWAaKd6lDYH",
		"ant-notification-notice-description": "Uc2oErVf_bRA6GIxalxca",
		"ant-notification-notice-closable": "_1yjmRHpG_r2hwbG1MeNSPd",
		"ant-notification-notice-with-icon": "_3fuNERJi2jHFXcvW9FM50s",
		"ant-notification-notice-icon": "_3QMx5qPFm5JLqO1SfMCXcr",
		"ant-notification-notice-icon-success": "_2YUmoPaJk4whM-n-96yQDl",
		"ant-notification-notice-icon-info": "E3vIGUuQ-RYn29WJ_fOcJ",
		"ant-notification-notice-icon-warning": "_1DZHehw4dEYqXYCH4OHs8S",
		"ant-notification-notice-icon-error": "_1Eg1Jef3ineGOXdqctBIxj",
		"ant-notification-notice-close": "_1ruCiXV36WTGZutzzFIIHB",
		"ant-notification-notice-btn": "_2Cw-JsLMMOW9r8pIABmBx4",
		"notification-fade-effect": "_1gf29AM-L693KopVigc8aX",
		"ant-notification-fade-leave": "_284e-IuVgY2suYf_7mZ0K7",
		"NotificationFadeIn": "_5sy0UVdMxBJVZDIjhGCic",
		"ant-notification-fade-leave-active": "_3AHzO4UZtj6uVEyEt0g53S",
		"NotificationFadeOut": "_3BAurSLEI06YezKhLoc7rf",
		"ant-page-header": "_1xBuD_5Wc6kap5fKcdubCY",
		"ant-page-header-ghost": "_11ghs-GxCq-PpXXmUljJNz",
		"has-breadcrumb": "_1yb4b_F5hEv-kZKZQhZh6o",
		"has-footer": "_23loBlQkcBJMHeh5Py-MYy",
		"ant-page-header-back": "_1GvRtZomDeif5gNR_2S0BM",
		"ant-page-header-back-button": "_1ebhAUvP8RPRr8jvXZxEbb",
		"ant-page-header-heading": "_3CD05zBVoPAlFWE-p-Bu7j",
		"ant-page-header-heading-title": "_1mrkpViaA4wP3SVjraGWDg",
		"ant-page-header-heading-sub-title": "_2sP8egFXDhNhAq-9dnBijR",
		"ant-page-header-heading-tags": "_2RJWEdsFWY0HkEXQxeckZQ",
		"ant-page-header-heading-extra": "_2lvXzboe7JiOpna2Ve4Y1q",
		"ant-page-header-content": "_3DSYKFtdHU0fADEb23Rstd",
		"ant-page-header-footer": "_3TtnMW3OVG_zlPETRt7njv",
		"ant-popover": "_3D4LR13qReFw-srmAnTyHG",
		"ant-popover-hidden": "_2tZXIV6vmuAxGLOX_negTJ",
		"ant-popover-placement-top": "_2ueEXsYfvfMKCDsqcUSpmO",
		"ant-popover-placement-topLeft": "_1WZTfgZiLGZ_8KsXMfTn1-",
		"ant-popover-placement-topRight": "hIa1DuPqWrMnQWx1NAXJD",
		"ant-popover-placement-right": "_16Q7snpQtM7kb6wBiPDT18",
		"ant-popover-placement-rightTop": "_2NBUPwTTmP9Z8XThzZuU8g",
		"ant-popover-placement-rightBottom": "lb038aIsah01XcC9gwGvC",
		"ant-popover-placement-bottom": "-i-cBVrasFn38zOORhmGg",
		"ant-popover-placement-bottomLeft": "_3ci73bjTwkE8VXjJ_hxPCq",
		"ant-popover-placement-bottomRight": "_2s9CF_PluZDzoKo6C_HNke",
		"ant-popover-placement-left": "_2hXOqPJMFGGCxi2R5Q7I4P",
		"ant-popover-placement-leftTop": "_3mYGaiL2Xx0TG6tUJy0rza",
		"ant-popover-placement-leftBottom": "pjPt2FJwOJvyK1IlE46Lk",
		"ant-popover-inner": "S4aRvr_XPzfsiMF6goerE",
		"ant-popover-title": "WaXkM7ygIqLJN66l2vGFm",
		"ant-popover-inner-content": "FX0It6EoZoRaNYCLCjhBv",
		"ant-popover-message": "_1KdnlVyH_1XRuZDv7v0Joi",
		"ant-popover-message-title": "_1a02Nd8BYAKzVX74fkVDeP",
		"ant-popover-buttons": "_3lgNPqDm7BoXsErT1PNIwB",
		"ant-popover-arrow": "_3bzbe_mQmFyJrPgOzjznuh",
		"ant-popover-content": "_1A_EJCOyAkSZ2iCc8A8Qma",
		"ant-progress": "_3w5wtC0PChZZogn9swm6l1",
		"ant-progress-line": "_3udBCulYVKcs_qzVPYiNrJ",
		"ant-progress-small": "_1BKV9qapPISM5xR9yjcHgv",
		"ant-progress-text": "_2-UkkxSbNnMY0-bIe_gURD",
		"ant-progress-outer": "_3g3VOyyEg6hdcWm4mGsL29",
		"ant-progress-show-info": "_2wTS40XyzPhP5pd9DE0MHj",
		"ant-progress-inner": "_2_fybYL-yYnObzD1380t3g",
		"ant-progress-circle-trail": "_1GUTuct-d-6oaj0Ng0R28d",
		"ant-progress-circle-path": "_1jM0mqVLZjh3tNU8E3snKw",
		"ant-progress-appear": "_3Dl7zlGAfdtWqrRkjGuEP2",
		"ant-progress-circle-gradient": "_30mg-oF7kagP1eTQE6m7C2",
		"ant-progress-success-bg": "Ntsgfz0DkZEfl34WrSJMO",
		"ant-progress-bg": "_2IaWZSWto47_bgy5ZugQXO",
		"ant-progress-status-active": "_39OToP2gXtOplKkaHE2WQK",
		"ant-progress-active": "_13OtZx-xjG14riuQxYKQGM",
		"ant-progress-status-exception": "_3eZjCzSyvFT-FtHdCPInqT",
		"ant-progress-status-success": "PfuP7W7BvMc1E3HAqwzkH",
		"ant-progress-circle": "_2PM1uH2Ls4GnMtHZDRzuLk",
		"ant-rate": "_2i2R5hIDU65oDk1FwBeHf6",
		"ant-rate-disabled": "_1cWhRdR90AnwONPHTmkr__",
		"ant-rate-star": "_34Yus69sfgU1e8LztdGdwL",
		"ant-rate-star-first": "aRTrvsDIYKUROTLFPZxuo",
		"ant-rate-star-second": "_1hFYKuanEi7Z1DOBExW2WQ",
		"ant-rate-star-half": "_19xuWaPRwgxPXRn4St6UzU",
		"ant-rate-star-full": "_2txTEosl9BLdoqwwMGbOBi",
		"ant-rate-text": "_1OD_KAA3sn6jmWD2OsQSKI",
		"ant-result": "_1eoE8PWO1u4nsGAq_4FQ6H",
		"ant-result-success": "Rhwlb9uD_t3gI65DatGzQ",
		"ant-result-icon": "_2FYX9RMnc2SG4KVq0-wXf0",
		"ant-result-error": "_1neiGZcoU--iRmzEJ2e_9t",
		"ant-result-info": "_3pAMmZ1E-gpX5mDSfS8MrP",
		"ant-result-warning": "Gg9MMYmXFh-FxVpdHS6pJ",
		"ant-result-image": "Ik3OHAGcpWLuA8qXWSmRQ",
		"ant-result-title": "_2WGk7FrTiu1GmoBcHyK7-m",
		"ant-result-subtitle": "_2_xu9YqrKXdvxnWt-24P",
		"ant-result-extra": "_2YGV77FQffQytGGv02V6l9",
		"ant-result-content": "SoE_1PU_ssklusu2w8Tl-",
		"ant-skeleton": "_3HQ3JBhC0OBnyb9CAwAl3g",
		"ant-skeleton-header": "_1dAcBsQih_2waerw8wygOH",
		"ant-skeleton-avatar": "_3ta1j9ZIvJml62hAjhIRrM",
		"ant-skeleton-avatar-circle": "_316gP1-0tbLf1_XWQ9tx3W",
		"ant-skeleton-avatar-lg": "_1To7HbWzxtV7mA1FgDPdZY",
		"ant-skeleton-avatar-sm": "gB-1kKtb3YzaSBCU-8cQE",
		"ant-skeleton-content": "_3h0mtMHELSiUkNj4cArJsE",
		"ant-skeleton-title": "_1I15yHBQcZZObXJxb2awMV",
		"ant-skeleton-paragraph": "_1T0v3Yt0YL1n3J9nVDSd5m",
		"ant-skeleton-with-avatar": "_29qBguLwjL8d9RiNazgkKG",
		"ant-skeleton-active": "_1duZR-Xs3jzRdB4iRYjnBg",
		"ant-skeleton-loading": "_3Dt8mAs4hHJ0bzGnnwKHVf",
		"ant-slider": "_1CP7AY13ECSlGnipOQMtY0",
		"ant-slider-vertical": "_9ukxJBAKXBGxa72nde9sn",
		"ant-slider-rail": "_2keyBuA2Fe32w37BR9t3K8",
		"ant-slider-track": "_2RaKKcsLOazEUtjjqhisnJ",
		"ant-slider-handle": "_1EdBOLyUd8XpAH9MyAK_Hz",
		"ant-slider-mark": "_1Q5ri8KJaldwL9VxOkkhm_",
		"ant-slider-mark-text": "Otnej03Hk2Ciz5Voc4Ryd",
		"ant-slider-step": "_3s_fLyVrb-sAW2NAOIzn5S",
		"ant-slider-dot": "nphWWTF3-xs_JY1RGp6ZR",
		"ant-slider-tooltip": "_2vF7gIMZQltuMBlHhNAXJt",
		"ant-slider-with-marks": "VbuAB8eCXfk8CqqAVni7Z",
		"ant-tooltip-open": "wwpH4wfCxUeycMLj9beRw",
		"ant-slider-mark-text-active": "_23FO7x1ktKyt0bqcgppHS9",
		"ant-slider-dot-active": "Rpo-lEvxCy_W8E-znRsje",
		"ant-slider-disabled": "_1OuIMoFkbcdLp-f8OkaPQf",
		"ant-statistic": "_2giqNZExqH02sZP4SvShI6",
		"ant-statistic-title": "GLJpgr-8FqrVkvERjfQ_M",
		"ant-statistic-content": "s_EN8exKS9slhRiaxuev8",
		"ant-statistic-content-value-decimal": "_24uVf19-H5EWbcMeGlVz6Q",
		"ant-statistic-content-prefix": "_2pe5B2VpHR4CzdGChl0gmV",
		"ant-statistic-content-suffix": "RdmNasdgHosQpyjur0rhp",
		"ant-steps": "_2L2cvCH6JVON1pHloAxKOI",
		"ant-steps-item": "_2yUz9uwXscGXcXq4V9tv5l",
		"ant-steps-item-container": "_3AlG4S7I4Mo7-_1R7Hj-68",
		"ant-steps-item-tail": "_1SNFtAG0gYWa6PR6KVrWfw",
		"ant-steps-item-content": "_2324iDCEK6-6Db_LSuAip-",
		"ant-steps-item-title": "aHzWEfLdEJiRzZ3HA64LR",
		"ant-steps-item-icon": "_2keld22DNQ9RkxuNtDvjA1",
		"ant-steps-icon": "_3_IstjjgGVFB4to2J7iV6e",
		"ant-steps-item-subtitle": "JUoukhAFUYmU5rA8FbdCd",
		"ant-steps-item-description": "_1Vchy2iuKVsBMsFJYD7hBZ",
		"ant-steps-item-wait": "_1oBr-J_8unoNyu4Z5iJXNJ",
		"ant-steps-icon-dot": "_3Ynjx7jKvq_YigobU0tOB9",
		"ant-steps-item-process": "_3H1_KHqzsj2cByqp-WammA",
		"ant-steps-item-finish": "_30G1Hjs6h8i-MMdZx2MiEU",
		"ant-steps-item-error": "_3_G_r82yHfyAl71GbRMRya",
		"ant-steps-next-error": "_1KgVtEyduxqc_LV4x_38hr",
		"ant-steps-item-active": "Iss2Ywm1jeH1arMOglEbA",
		"ant-steps-horizontal": "zm6Psfz4NJIs1NdwXRIpf",
		"ant-steps-label-vertical": "fatIBfFS9XQKIKhBvFYWk",
		"ant-steps-item-custom": "_3zYFdczDVUT2TJlHut1JYK",
		"ant-steps-vertical": "_1k2gLjgA8u6eymax97uC69",
		"ant-steps-small": "_2y_Y74qNPWlEAs5huqTJbS",
		"ant-steps-label-horizontal": "_3sluPivUVp-ohutg6mZ23U",
		"ant-steps-dot": "I3OtXp51S1ui1Y3fOpUrC",
		"ant-steps-navigation": "_37SgGMT6_90YwCDJYCs_oQ",
		"ant-steps-flex-not-supported": "_2CYFmxe-NgJb3DCvlLjMf3",
		"ant-switch-inner": "_3_PpZ-epyVIPncn4JoEksq",
		"ant-switch-loading-icon": "_1yraPfT_0AUP_86HRF-NNP",
		"ant-switch-disabled": "_1u1wf55QN92BIk61srtozj",
		"ant-switch-loading": "WlxIpyr8JVbwDhXeFKdHT",
		"ant-switch-checked": "fa4XVx62F9S9UpPl-D6Dc",
		"ant-switch-small": "_3KLc6JOOSYA0O2os3NTPcS",
		"ant-table-wrapper": "_1jESgGkhSIqc1vmWhMSm9q",
		"ant-table": "_3fMJwK7ehwYMI9WXIBXx7X",
		"ant-table-body": "_2yk3lyMbLlaUj9C-xn8dVZ",
		"ant-table-empty": "_3vcHok5L3bZVcOpv9E6yPq",
		"ant-table-layout-fixed": "_37mrRhU-KQbuTzaUydopIU",
		"ant-table-thead": "_25fu2zl2d-vqIl8bRXTsAN",
		"anticon-filter": "_2EsU8Ah1V8O9SsN7Q6J18d",
		"ant-table-filter-icon": "_1p6NMMSYwyGneBGs6hp8-O",
		"ant-table-filter-selected": "_1yUPePoZbVwROzRfsBUETi",
		"ant-table-column-sorter": "_1JpZNn9Uq8AT8ojgWuDiCE",
		"ant-table-column-sorter-inner": "_1XetCbJ1zxFcv77mWeboZJ",
		"ant-table-column-sorter-up": "_2WnIjlv_B_4_I5rDgEvzC1",
		"ant-table-column-sorter-down": "_3E4sCKCVLnX65b27d7-rBe",
		"on": "Mk7bkM_sMBRMn9CSDU4Bn",
		"ant-table-column-sorter-inner-full": "TmPbI49vnzTWGGcy-izIr",
		"ant-table-column-has-actions": "_3ZCd4H6qi39RqknekInp4",
		"ant-table-column-has-filters": "_2TxxQME9gvW2W98cWJtnrT",
		"ant-table-filter-open": "_2EN_aCKMnhMmtd0nL5aRFa",
		"ant-table-column-has-sorters": "_31nAKmbfc57MbYE3EOkS8I",
		"ant-table-header-column": "_17sBt_6CxL2T7zSI4aTTcO",
		"ant-table-column-sorters": "IOlVHnKzPF9Mfpp8XP1Qo",
		"ant-table-column-title": "_1L3zBpLVITT7hebPdM26Aj",
		"ant-table-tbody": "_3aml4KBMk9yAckKTSLa9gm",
		"ant-table-row-hover": "_2J4fDUx2azDRG_z7A7rZL9",
		"ant-table-expanded-row": "_13tu_i3IPv3UXt8sfp2hEG",
		"ant-table-row-selected": "_2jOFqVn9Kg1t10fk76vtUQ",
		"ant-table-column-sort": "_3pB5jA3sM4dqd-uWWtNYKq",
		"ant-table-footer": "C3p82omWOgy6nt98oQAH9",
		"ant-table-bordered": "_1NHo45BpUmMB_be0TIXnOP",
		"ant-table-title": "_1ySN9C7zVlgpW0qERhparj",
		"ant-table-content": "_1aM_O0R3xvsULZstHSZ3Zp",
		"ant-table-without-column-header": "_1sAfAHKYhZ01GZvkNilov7",
		"ant-table-placeholder": "avyuvw7jWNGDqMjtw7XzY",
		"ant-table-expand-icon-th": "TEXzPmB9nIuvX6Buuy4kA",
		"ant-table-row-expand-icon-cell": "xfFWZPppNV0E5LDKjn4z_",
		"ant-table-header": "_36uHTr7zz9hEZ-ZU--m2p_",
		"ant-table-loading": "tFYL2UoLk2ySH2Wh56ouI",
		"ant-table-spin-holder": "_3IYyKsAJKYUyD9YFm5ul1V",
		"ant-table-with-pagination": "_1wQzLNINC3D1sZ6WJLmT6R",
		"ant-table-without-pagination": "_3fQaTLg0reIj-P-Ol2SwI_",
		"ant-table-fixed-left": "zOPKs_xmF12yaFtAl8meW",
		"ant-table-fixed-right": "_1DD3eU5myBRjGsrlMGuYsg",
		"ant-table-fixed-header": "EMaVlAtyYB9Gm2ywR9hb1",
		"ant-table-body-inner": "_2clRomWXZhcW1J7BQnpW8N",
		"ant-table-pagination": "_3nUHyDIF85CPUjqMJ4E2tz",
		"ant-table-filter-dropdown": "t0kPDaRyeP6iJ3hergby-",
		"ant-dropdown-menu-sub": "_3X3VnvLwfA1aPNRwkJxBvo",
		"ant-dropdown-submenu-contain-selected": "_1LoP0Kjr5fKVkljZW1E6E5",
		"ant-table-filter-dropdown-btns": "_2XbJH4NJ3feZ37ziS-RQg9",
		"ant-table-filter-dropdown-link": "_1DksAhaC8Z3xJwwJo0fvER",
		"confirm": "_2yXKr-mz8PfvL5gUVxucLn",
		"clear": "_2vVoleoluS0hKV5sib3cTP",
		"ant-table-selection": "_1eZBhZqIcqssIcTOzuf3J-",
		"ant-table-selection-select-all-custom": "_26VUlbMwEOpegWnAWEfFfe",
		"ant-table-selection-menu": "i_4e1cLa8JsNnq63Q2OjC",
		"ant-action-down": "_22cK_wJHUxqVGOjm69bQAo",
		"ant-table-selection-down": "_2MO6K-lKbRo1uFPD2mzkVB",
		"ant-table-row-expand-icon": "_1QmzmjVEnfIGfnhoCEvHya",
		"ant-table-row-expanded": "_3wj8iT9zYn4PMtbzUfKfrh",
		"ant-table-row-collapsed": "_3CsReeSHRemedZGd1J2n7X",
		"ant-table-row-spaced": "_2ViKNLhSUGpmPeavMR8p0Y",
		"ant-table-row-cell-ellipsis": "_1ysuk0hMlpKFDpIxJAcrge",
		"ant-table-row-cell-break-word": "_3e0aHHQQjRoDvDfSGBMXKV",
		"ant-table-row-indent": "_2l00fp_FNeq2wZgKxp9x3Y",
		"ant-table-scroll": "_2X2kzVZ-zOogZARIeKOmTI",
		"ant-table-fixed-columns-in-body": "_1ZopjFbeHHox1KzK8x1mBp",
		"ant-table-hide-scrollbar": "_1Tq2kei88NxPzUfvd5OOUO",
		"ant-table-body-outer": "_1nbH7pXQuVgZPFDMFMbynd",
		"ant-table-fixed": "_2wxWKt0vVLKFxkuTChCa-c",
		"ant-table-scroll-position-left": "_20udH_czWRD1xbA7TQGQzx",
		"ant-table-scroll-position-right": "_3fHFJ7uM1HI-0UF_EkeEih",
		"ant-table-selection-col": "_3fAf-8wbF558FoMIpz_62I",
		"ant-table-selection-column-custom": "_1ue2cccChBZoFtcuuK6M8O",
		"ant-table-selection-column": "_12sev7OhOos5aWKQnwPFoi",
		"ant-table-row": "zrVqitjpiFV_CXWiKkbiT",
		"ant-table-filter-dropdown-submenu": "_3yGa1XSZ44smbr9KO39qrs",
		"ant-table-middle": "mFEjxgHrKxGkdkpToauxN",
		"ant-table-small": "N0dPkf-FPErzHMgAkrT_A",
		"ant-table-row-cell-last": "_2YahBMgj9LPsb4aFeq8R_u",
		"ant-timeline": "_3s1Jafw_2qZK40rdRRpAyl",
		"ant-timeline-item": "_3hBDOkRprJUIH4RsEeF9Uc",
		"ant-timeline-item-tail": "_3if7QeEVevTzFqz4aNHs8z",
		"ant-timeline-item-pending": "_39s9p8XqJldJ0c55JvMaou",
		"ant-timeline-item-head": "_2Iw0eW3yGZXI9d8NQV2T5Q",
		"ant-timeline-item-head-blue": "_3-YwRSIO_K2GkWZvGVzTBa",
		"ant-timeline-item-head-red": "_2yUbw6TliE5ZFw6-soXSAI",
		"ant-timeline-item-head-green": "_2AA1dQjUtBepFJTS_AfZ-b",
		"ant-timeline-item-head-gray": "gZ-s-o7Ff1YStfdVdFWga",
		"ant-timeline-item-head-custom": "_3AlAQ6tYln8HL5ZF-4pVTP",
		"ant-timeline-item-content": "_3oUggV1jya_qunseiZVH1s",
		"ant-timeline-item-last": "Y-dfWs_7uB2hgX65fGVwf",
		"ant-timeline-alternate": "MlW17bxxI9CyJzMxlDV_k",
		"ant-timeline-right": "_1WNAv7xHahpXVEGH7yAwWO",
		"ant-timeline-item-left": "_1U9z13zH1NdnoifGCnczXL",
		"ant-timeline-item-right": "r52WJA0xU1MEHx86NziKE",
		"ant-timeline-pending": "_1x5uZy0H7yXeADduGEcDg1",
		"ant-timeline-reverse": "_30JOgo4V0jDVg0Xx3_7Bk6",
		"ant-transfer-customize-list": "rlMH4NlzQWJh83Dq9DdX5",
		"ant-transfer-operation": "_2iecrxAtvapq8cS3BBVGd9",
		"ant-transfer-list-body-with-search": "_10-WXXqs0ZlcFLnZGYGJZ1",
		"ant-transfer-list-body-search-wrapper": "be0Q-RdCmS9S6OKeN9R_h",
		"ant-transfer-list-body-customize-wrapper": "_1eZFgfpkzGXACdV9y0DQyn",
		"ant-transfer": "_2D2QtpzCwBFDz2ZekZgLlA",
		"ant-transfer-disabled": "_1pxg4uZSvhEmukw3Ep4BBz",
		"ant-transfer-list-with-footer": "KVBFZ_F6K_ySDznpKReT_",
		"ant-transfer-list-search-action": "_3PmrhZRTM_SsoRP6xr0OA6",
		"ant-transfer-list-header": "_37pC92p0hfz6rTUJPr2gaV",
		"ant-transfer-list-header-title": "RndxYLA26iGE88FBiPmoV",
		"ant-transfer-list-body": "_2oQEtG2Tr0IS5Dr54XFEzj",
		"ant-transfer-list-content": "_1e3AJXT-N9-h5b4z8kE2Az",
		"LazyLoad": "_3NGzKjRdPlWpgGzwSMJ1D6",
		"transferHighlightIn": "_1XmRi5uc5p2ADS-evGdaEv",
		"ant-transfer-list-content-item": "_3hibcDhRBvhxHS6tV5I91c",
		"ant-transfer-list-content-item-text": "_1GjlRFUWtWEb71c4aUcc_H",
		"ant-transfer-list-content-item-disabled": "_3f3C491D12e4YU0i4aBGEt",
		"ant-transfer-list-body-not-found": "_3qqVHAL1GoRLHhC531BxJj",
		"ant-transfer-list-footer": "_2clh250I8Q06en-5GCK1Fe",
		"ant-select-tree-checkbox": "CUzmrYCooqKankKH0dZg1",
		"ant-select-tree-checkbox-wrapper": "_2LvMFSgY53-D24I85Jg15m",
		"ant-select-tree-checkbox-inner": "_3aKsfuvecj_xf_qhm1o-qG",
		"ant-select-tree-checkbox-input": "_2kQLF0NCfp_9auDgEqRz9p",
		"ant-select-tree-checkbox-checked": "_3A6-r92EApUOl7NKxi-WP0",
		"ant-select-tree-checkbox-disabled": "tuuKYf6pt0EsXC4MmGcyw",
		"ant-select-tree-checkbox-wrapper-disabled": "_1RrKymZUHSLGVgHDX9w9hN",
		"ant-select-tree-checkbox-group": "_33tPvi6_EPmaXdKgl4krsJ",
		"ant-select-tree-checkbox-group-item": "_30vB3xci_A6ZeUu5mGdthm",
		"ant-select-tree-checkbox-indeterminate": "_1FqAF7aA6ToW7ETCiQShJC",
		"ant-select-tree": "arBNXWNSdVMhXqwttAeXr",
		"filter-node": "Us43Qi7jro2p5xJpEFQgv",
		"ant-select-tree-node-content-wrapper": "_2gVXDLA_Cv6gJ7PzacdWn-",
		"ant-select-tree-node-selected": "_34blrKC2wA5L_0m7ZHVxB7",
		"ant-select-tree-switcher": "CBDL87EXvtLP80g-ONbPn",
		"ant-select-tree-iconEle": "_3hFkulTE_jmD950iDnvjVe",
		"ant-select-icon_loading": "_2tXjrHR3Ao-N1fJPsKhS57",
		"ant-select-switcher-loading-icon": "_122XxPShq3_cicoywqJ2zx",
		"ant-select-tree-switcher-noop": "-N_ffDKc8Bzg-uSGzeEXG",
		"ant-select-tree-switcher_open": "tKkRd5E1TIUeAbYPPNkfA",
		"ant-tree-switcher-icon": "_3iQjYMymFtoXZ_JuFMpsMI",
		"ant-select-switcher-icon": "_3xAf4EQm7paPCHrnsxJhF8",
		"ant-select-tree-switcher_close": "_129vh-FzoYv4gdWq1O1N74",
		"ant-select-tree-treenode-loading": "_3YqJW1QD0n_LYxJe2Dhklu",
		"ant-select-tree-child-tree": "QnoAaec0eJjTW0zqLnj80",
		"ant-select-tree-child-tree-open": "_3gQCBrW_PLll3jhwISD-IP",
		"ant-select-tree-treenode-disabled": "abrK0tECynrrAKTwRDTCN",
		"ant-select-tree-icon__open": "_2vnnThThMHmFferjAW2wCz",
		"ant-select-tree-icon__close": "_1tGiIR953173DHTmLQ_Lx0",
		"ant-select-tree-dropdown": "_2B_MBpF7swXfI1jtDON4YS",
		"ant-select-dropdown-search": "Tdu2wxx92tHUFda0pQkM7",
		"ant-select-search--hide": "_2Jio1kMypbi9R2Isbzf_Z7",
		"ant-select-not-found": "oebpIJETd572aj8cgCHiC",
		"ant-tree": "tXimqUKN4dRA2VIy-NOQX",
		"ant-tree-directory": "_1t7woQyCecpPw7LiFauJY4",
		"ant-tree-switcher": "uB1rgOUC14-gYn6kP2jxh",
		"ant-tree-child-tree": "_3shUnC5Tlnyks2HmhTPxed",
		"ant-tree-switcher-noop": "_1m4iQUcL1hsRPSkwuxZ30e",
		"ant-tree-checkbox": "_38RRRh5s15LM-VKziqlZau",
		"ant-tree-node-content-wrapper": "nMUQbT4bWOoxOFxci4eET",
		"ant-tree-node-selected": "_2QvVNc4FXbIf1BxoboF8R8",
		"ant-tree-treenode-selected": "_2TiFOzNZu_yOnyn80gD-Xi",
		"ant-tree-checkbox-inner": "_1odwtHnWaKDfdUN9wKeTml",
		"ant-tree-checkbox-checked": "_35_Oiqc6MsuwPYy1kV4XZK",
		"ant-tree-checkbox-wrapper": "_1Uf_n4Uv5jlYoWVSQzmrAm",
		"ant-tree-checkbox-input": "_3a5kDHzUQQ2zvjhyhKo7_J",
		"ant-tree-checkbox-disabled": "_1WHz5Hm-Ojs7A2jANk4oV",
		"ant-tree-checkbox-wrapper-disabled": "_3T_4_ARmV3ip_HUktGMzK8",
		"ant-tree-checkbox-group": "_3IoUlzG6d4r5tiAxBgL0Mb",
		"ant-tree-checkbox-group-item": "_3Xbv8wen4jKh7taCp5fJYO",
		"ant-tree-checkbox-indeterminate": "_28qUK4--zNKlPx807owR3K",
		"drag-over": "_-86y1C_orEcn3j3-v7gmX",
		"drag-over-gap-top": "_3ml_CLU_aqwQBQLQ3HiZoJ",
		"drag-over-gap-bottom": "_2-G5w1nT9bohoWjR_A_BaU",
		"ant-tree-treenode-loading": "_3XIZTgJez3cVMsXA2QtswD",
		"ant-tree-switcher_open": "_3QaAa3GLGS5rhW5tIeOPxZ",
		"ant-tree-switcher-loading-icon": "_2PCDphFOklH3qy-QxJOIyG",
		"ant-tree-switcher_close": "_2GpmVQolEYAiPyq_3hLqbe",
		"ant-tree-iconEle": "_2NZcuMeo194xMfCzNdUQ9g",
		"ant-tree-treenode-disabled": "_1BSxvvCCNyUz43IdtinMf_",
		"ant-tree-icon__open": "K5oHVclmJCP372UcQwRU9",
		"ant-tree-icon__close": "_1d5qKjhbj2LEPGJrB7TauU",
		"ant-tree-show-line": "_1rFSdyrHgGXDR8pLi4nenc",
		"ant-tree-icon-hide": "_3KKsaG-B0XgBxbw1Tt2Jkp",
		"ant-tree-block-node": "O_EYOu8jKTbRLC-v94y3R",
		"ant-typography": "_1ev75OJ3m8MmeuEoQQJ7jo",
		"ant-typography-secondary": "_3MZGF7tjXldT1slpAxNhi2",
		"ant-typography-warning": "_2RAD1zM6Bevz4eCB4KSIJO",
		"ant-typography-danger": "_3Bnp6LkhK4JPfInTFZwHbe",
		"ant-typography-disabled": "_1gIdHV5ngUEKgnBbTVO8sR",
		"ant-typography-ellipsis": "_1E0vzK3c1cPu6572DXhC_H",
		"ant-typography-expand": "_2Ahk5tPntfGw2cr4-xt03V",
		"ant-typography-edit": "o8Y8Dk5CvUCCTrq11I3rz",
		"ant-typography-copy": "_1zf2EeUKjo7bccttxkcq6M",
		"ant-typography-copy-success": "ujyyT6UwnVTZjnrrPwaix",
		"ant-typography-edit-content": "_3v1ZIEgEjmSQTuLp66KLE4",
		"ant-typography-edit-content-confirm": "_1ck3piiHKROOEkN938fuMQ",
		"ant-typography-ellipsis-single-line": "B5S47y3G1yod1Oizo2zn4",
		"ant-typography-ellipsis-multiple-line": "_4mrVkJdsglGzMWKWcqKvc",
		"ant-upload-btn": "_1QVJI2fnyV8WPndtGtUZ97",
		"ant-upload-select": "_9iXM9OS_aXr4g7iRh9moq",
		"ant-upload-disabled": "_24sB5tmdOkPrI3TqucEqE5",
		"ant-upload-select-picture-card": "Z1UZhvuBxbvVRvpD7fBjV",
		"ant-upload-drag": "_1F9t52IU7ApWj6hldzXLrv",
		"ant-upload-drag-hover": "_1KzVMnwBUl0vRHHHHHe5BP",
		"ant-upload-drag-container": "MkwWPZ_lOStWiui53er-i",
		"ant-upload-drag-icon": "_2465qk-DAqgkYiRhlBNmLL",
		"ant-upload-text": "_1TT9GHfYZDW3synEMVUC8m",
		"ant-upload-hint": "_19HCH1CphgVwVW3YSDpXZq",
		"ant-upload-picture-card-wrapper": "_1aP8zqzfJuF4wFr6tZC1Of",
		"ant-upload-list": "_1HTbCHWxHGefqZTG56pUqH",
		"ant-upload-list-item-list-type-text": "_3Th3A8mA6g6IN_N-ftGtoQ",
		"ant-upload-list-item-name-icon-count-1": "_2kr8IlS1PgyWs3akY49oun",
		"ant-upload-list-item-name-icon-count-2": "_23V42CLebjkzdToi2tsj-v",
		"ant-upload-list-item": "_1xZSB1ODw4SEJ9vy0WcP7v",
		"ant-upload-list-item-name": "_3H9QkCizcyWMDFSPeXw-Wq",
		"ant-upload-list-item-card-actions": "gP44me5-rxpnlT5aeTuN7",
		"picture": "_2XypUSzQZ-ErWYW3pZRoYI",
		"ant-upload-list-item-info": "fuJx6I0dwWXU3oe6jE-IR",
		"anticon-paper-clip": "hAONR7Qe_wjqwC-5U0i_Y",
		"ant-upload-list-item-error": "_1TPn2WG51dKO_9EomQJamO",
		"ant-upload-list-item-progress": "_3O6SgyvISXhAiL51_8xXWB",
		"ant-upload-list-picture": "_1zx25rlpwEFyDExms_i9_d",
		"ant-upload-list-picture-card": "_38d_4uXC-bnL21aqSfTCmT",
		"ant-upload-list-item-uploading": "_10FWJL_ElsGwmHbZQjJ20L",
		"ant-upload-list-item-thumbnail": "_2iqplV1svpz_C02HnLAe57",
		"ant-upload-list-item-icon": "_3L6H7DHR6f5mWJgKfS7k_C",
		"ant-upload-list-item-image": "_1LDtmLnyxVVJ4vTysjEMxI",
		"ant-upload-list-picture-card-container": "_1lE1BIY0LPrElzMaiPNAS_",
		"ant-upload-list-item-actions": "_29iBs326z3n2T6343ZPGE9",
		"anticon-eye-o": "_2Du4yA7FKCaJmgj6Kuk1ic",
		"anticon-download": "DFGxkWBk7-8am7yetoBzJ",
		"anticon-delete": "_2E0msfda8QaiSudkXvP2g7",
		"anticon-picture": "_1Igm5W5FltLrR8VE6bPhGj",
		"ant-upload-list-item-uploading-text": "_2GPNPss8r9pfPTI348B9gj",
		"ant-upload-success-icon": "_3yx244PUIziwxp6bu8pLHe",
		"ant-upload-animate-enter": "_3Ibm5Q3kTLKWn6ukU67M5T",
		"ant-upload-animate-leave": "_1Phim6COpesfJuXoh7LHtw",
		"ant-upload-animate-inline-enter": "_1Pdz8gRZCy6OvYroSZrGqe",
		"ant-upload-animate-inline-leave": "_1F2Eo0rsMZgpbOg3kp_mvk",
		"uploadAnimateIn": "_189Q1pQ01TJSafIXju2srA",
		"uploadAnimateOut": "xI7iqGcsjAOZMs2Q2wyvX",
		"uploadAnimateInlineIn": "LmqYNZGEWRX7SSFklVSAm",
		"uploadAnimateInlineOut": "tPcGWxZo3eefNYxUQKdSn",
		"antAlertSlideUpIn": "_3aTOHX3Q6ehv2dio9EHqoX",
		"AntSwitchSmallLoadingCircle": "_1w_XcQ53DxedQa8VVmd1Fn"
	};

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._28iq2FiyUY-5x65i0o5mAo{width:100%;height:100%;margin:5px auto;border:1px solid #ccc;text-align:center;padding:5px}", ""]);
	
	// exports
	exports.locals = {
		"pic": "_28iq2FiyUY-5x65i0o5mAo"
	};

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(42)();
	// imports
	
	
	// module
	exports.push([module.id, "._3z-TTe8pKamRDDtKh3Zyjh{display:flex;flex-direction:column;margin:0;border-radius:3px;background:#fff;background-clip:content-box}._2_apLHH_P14xErEPEMPrSy{height:25px;text-align:left;line-height:20px;position:relative;padding:2px 10px;background:#fafafa;border-bottom:1px solid #d9d9d9;font-weight:700}._2-l4dK73YpzeAklE1iCkGh{position:absolute;top:3px;right:3px;width:10px;height:10px;background-image:url(\"http://img1.imgtn.bdimg.com/it/u=4152100876,641559203&fm=214&gp=0.jpg\");background-size:100% 100%;background-repeat:no-repeat}._1NmfGro4B0qi4Q_lTNecYo{flex:1;display:flex;flex-direction:column;height:inherit}", ""]);
	
	// exports
	exports.locals = {
		"panel": "_3z-TTe8pKamRDDtKh3Zyjh",
		"title": "_2_apLHH_P14xErEPEMPrSy",
		"delPanel": "_2-l4dK73YpzeAklE1iCkGh",
		"body": "_1NmfGro4B0qi4Q_lTNecYo"
	};

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fastDeepEqual = __webpack_require__(1874);
	
	var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);
	
	var _sizeSensor = __webpack_require__(1986);
	
	var _utils = __webpack_require__(1611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EchartsReactCore = function (_Component) {
	  _inherits(EchartsReactCore, _Component);
	
	  function EchartsReactCore(props) {
	    _classCallCheck(this, EchartsReactCore);
	
	    var _this = _possibleConstructorReturn(this, (EchartsReactCore.__proto__ || Object.getPrototypeOf(EchartsReactCore)).call(this, props));
	
	    _this.getEchartsInstance = function () {
	      return _this.echartsLib.getInstanceByDom(_this.echartsElement) || _this.echartsLib.init(_this.echartsElement, _this.props.theme, _this.props.opts);
	    };
	
	    _this.dispose = function () {
	      if (_this.echartsElement) {
	        try {
	          (0, _sizeSensor.clear)(_this.echartsElement);
	        } catch (e) {
	          console.warn(e);
	        }
	        // dispose echarts instance
	        _this.echartsLib.dispose(_this.echartsElement);
	      }
	    };
	
	    _this.rerender = function () {
	      var _this$props = _this.props,
	          onEvents = _this$props.onEvents,
	          onChartReady = _this$props.onChartReady;
	
	
	      var echartObj = _this.renderEchartDom();
	      _this.bindEvents(echartObj, onEvents || {});
	
	      // on chart ready
	      if (typeof onChartReady === 'function') _this.props.onChartReady(echartObj);
	      // on resize
	      if (_this.echartsElement) {
	        (0, _sizeSensor.bind)(_this.echartsElement, function () {
	          try {
	            echartObj.resize();
	          } catch (e) {
	            console.warn(e);
	          }
	        });
	      }
	    };
	
	    _this.bindEvents = function (instance, events) {
	      var _bindEvent = function _bindEvent(eventName, func) {
	        // ignore the event config which not satisfy
	        if (typeof eventName === 'string' && typeof func === 'function') {
	          // binding event
	          // instance.off(eventName); // 已经 dispose 在重建，所以无需 off 操作
	          instance.on(eventName, function (param) {
	            func(param, instance);
	          });
	        }
	      };
	
	      // loop and bind
	      for (var eventName in events) {
	        if (Object.prototype.hasOwnProperty.call(events, eventName)) {
	          _bindEvent(eventName, events[eventName]);
	        }
	      }
	    };
	
	    _this.renderEchartDom = function () {
	      // init the echart object
	      var echartObj = _this.getEchartsInstance();
	      // set the echart option
	      echartObj.setOption(_this.props.option, _this.props.notMerge || false, _this.props.lazyUpdate || false);
	      // set loading mask
	      if (_this.props.showLoading) echartObj.showLoading(_this.props.loadingOption || null);else echartObj.hideLoading();
	
	      return echartObj;
	    };
	
	    _this.echartsLib = props.echarts; // the echarts object.
	    _this.echartsElement = null; // echarts div element
	    return _this;
	  }
	
	  // first add
	
	
	  _createClass(EchartsReactCore, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.rerender();
	    }
	
	    // update
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // 判断是否需要 setOption，由开发者自己来确定。默认为 true
	      if (typeof this.props.shouldSetOption === 'function' && !this.props.shouldSetOption(prevProps, this.props)) {
	        return;
	      }
	
	      // 以下属性修改的时候，需要 dispose 之后再新建
	      // 1. 切换 theme 的时候
	      // 2. 修改 opts 的时候
	      // 3. 修改 onEvents 的时候，这样可以取消所有之前绑定的事件 issue #151
	      if (!(0, _fastDeepEqual2['default'])(prevProps.theme, this.props.theme) || !(0, _fastDeepEqual2['default'])(prevProps.opts, this.props.opts) || !(0, _fastDeepEqual2['default'])(prevProps.onEvents, this.props.onEvents)) {
	        this.dispose();
	
	        this.rerender(); // 重建
	        return;
	      }
	
	      // 当这些属性保持不变的时候，不 setOption
	      var pickKeys = ['option', 'notMerge', 'lazyUpdate', 'showLoading', 'loadingOption'];
	      if ((0, _fastDeepEqual2['default'])((0, _utils.pick)(this.props, pickKeys), (0, _utils.pick)(prevProps, pickKeys))) {
	        return;
	      }
	
	      var echartObj = this.renderEchartDom();
	      // 样式修改的时候，可能会导致大小变化，所以触发一下 resize
	      if (!(0, _fastDeepEqual2['default'])(prevProps.style, this.props.style) || !(0, _fastDeepEqual2['default'])(prevProps.className, this.props.className)) {
	        try {
	          echartObj.resize();
	        } catch (e) {
	          console.warn(e);
	        }
	      }
	    }
	
	    // remove
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.dispose();
	    }
	
	    // return the echart object
	
	
	    // dispose echarts and clear size-sensor
	
	
	    // bind the events
	
	
	    // render the dom
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className;
	
	      var newStyle = _extends({
	        height: 300
	      }, style);
	      // for render
	      return _react2['default'].createElement('div', {
	        ref: function ref(e) {
	          _this2.echartsElement = e;
	        },
	        style: newStyle,
	        className: 'echarts-for-react ' + className
	      });
	    }
	  }]);
	
	  return EchartsReactCore;
	}(_react.Component);
	
	exports['default'] = EchartsReactCore;
	
	
	EchartsReactCore.propTypes = {
	  option: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  echarts: _propTypes2['default'].object, // eslint-disable-line react/forbid-prop-types
	  notMerge: _propTypes2['default'].bool,
	  lazyUpdate: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object, // eslint-disable-line react/forbid-prop-types
	  className: _propTypes2['default'].string,
	  theme: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  onChartReady: _propTypes2['default'].func,
	  showLoading: _propTypes2['default'].bool,
	  loadingOption: _propTypes2['default'].object, // eslint-disable-line react/forbid-prop-types
	  onEvents: _propTypes2['default'].object, // eslint-disable-line react/forbid-prop-types
	  opts: _propTypes2['default'].shape({
	    devicePixelRatio: _propTypes2['default'].number,
	    renderer: _propTypes2['default'].oneOf(['canvas', 'svg']),
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].oneOf([null, undefined, 'auto'])]),
	    height: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].oneOf([null, undefined, 'auto'])])
	  }),
	  shouldSetOption: _propTypes2['default'].func
	};
	
	EchartsReactCore.defaultProps = {
	  echarts: {},
	  notMerge: false,
	  lazyUpdate: false,
	  style: {},
	  className: '',
	  theme: null,
	  onChartReady: function onChartReady() {},
	  showLoading: false,
	  loadingOption: null,
	  onEvents: {},
	  opts: {},
	  shouldSetOption: function shouldSetOption() {
	    return true;
	  }
	};

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable import/prefer-default-export */
	
	var pick = exports.pick = function pick(obj, keys) {
	  var r = {};
	  keys.forEach(function (key) {
	    r[key] = obj[key];
	  });
	  return r;
	};

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _echarts = __webpack_require__(8);
	
	(function () {
	  for (var key in _echarts) {
	    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _echarts[key];
	  }
	})();
	
	var _export = __webpack_require__(852);
	
	(function () {
	  for (var key in _export) {
	    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _export[key];
	  }
	})();
	
	__webpack_require__(821);
	
	__webpack_require__(1664);
	
	__webpack_require__(1613);
	
	__webpack_require__(1684);
	
	__webpack_require__(1700);
	
	__webpack_require__(1689);
	
	__webpack_require__(1672);
	
	__webpack_require__(1714);
	
	__webpack_require__(1720);
	
	__webpack_require__(1642);
	
	__webpack_require__(1638);
	
	__webpack_require__(1634);
	
	__webpack_require__(1679);
	
	__webpack_require__(1694);
	
	__webpack_require__(1619);
	
	__webpack_require__(1624);
	
	__webpack_require__(1631);
	
	__webpack_require__(1668);
	
	__webpack_require__(1655);
	
	__webpack_require__(1683);
	
	__webpack_require__(1709);
	
	__webpack_require__(1703);
	
	__webpack_require__(1630);
	
	__webpack_require__(1761);
	
	__webpack_require__(1778);
	
	__webpack_require__(1758);
	
	__webpack_require__(831);
	
	__webpack_require__(830);
	
	__webpack_require__(1746);
	
	__webpack_require__(1760);
	
	__webpack_require__(1792);
	
	__webpack_require__(1801);
	
	__webpack_require__(216);
	
	__webpack_require__(1740);
	
	__webpack_require__(1791);
	
	__webpack_require__(1782);
	
	__webpack_require__(1770);
	
	__webpack_require__(1769);
	
	__webpack_require__(1768);
	
	__webpack_require__(1762);
	
	__webpack_require__(827);
	
	__webpack_require__(1748);
	
	__webpack_require__(818);
	
	__webpack_require__(819);
	
	__webpack_require__(1806);
	
	__webpack_require__(832);
	
	__webpack_require__(833);
	
	__webpack_require__(2089);
	
	__webpack_require__(2085);

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var _barGrid = __webpack_require__(272);
	
	var layout = _barGrid.layout;
	var largeLayout = _barGrid.largeLayout;
	
	__webpack_require__(427);
	
	__webpack_require__(1614);
	
	__webpack_require__(1615);
	
	__webpack_require__(217);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(echarts.PRIORITY.VISUAL.LAYOUT, zrUtil.curry(layout, 'bar')); // Use higher prority to avoid to be blocked by other overall layout, which do not
	// only exist in this module, but probably also exist in other modules, like `barPolar`.
	
	echarts.registerLayout(echarts.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, largeLayout);
	echarts.registerVisual({
	  seriesType: 'bar',
	  reset: function (seriesModel) {
	    // Visual coding for legend
	    seriesModel.getData().setVisual('legendSymbol', 'roundRect');
	  }
	});

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(800);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = BaseBarSeries.extend({
	  type: 'series.bar',
	  dependencies: ['grid', 'polar'],
	  brushSelector: 'rect',
	
	  /**
	   * @override
	   */
	  getProgressive: function () {
	    // Do not support progressive in normal mode.
	    return this.get('large') ? this.get('progressive') : false;
	  },
	
	  /**
	   * @override
	   */
	  getProgressiveThreshold: function () {
	    // Do not support progressive in normal mode.
	    var progressiveThreshold = this.get('progressiveThreshold');
	    var largeThreshold = this.get('largeThreshold');
	
	    if (largeThreshold > progressiveThreshold) {
	      progressiveThreshold = largeThreshold;
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    // If clipped
	    // Only available on cartesian2d
	    clip: true,
	    // If use caps on two sides of bars
	    // Only available on tangential polar bar
	    roundCap: false,
	    showBackground: false,
	    backgroundStyle: {
	      color: 'rgba(180, 180, 180, 0.2)',
	      borderColor: null,
	      borderWidth: 0,
	      borderType: 'solid',
	      borderRadius: 0,
	      shadowBlur: 0,
	      shadowColor: null,
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var _helper = __webpack_require__(801);
	
	var setLabel = _helper.setLabel;
	
	var Model = __webpack_require__(57);
	
	var barItemStyle = __webpack_require__(1618);
	
	var Path = __webpack_require__(55);
	
	var Group = __webpack_require__(146);
	
	var _throttle = __webpack_require__(131);
	
	var throttle = _throttle.throttle;
	
	var _createClipPathFromCoordSys = __webpack_require__(215);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	var Sausage = __webpack_require__(1870);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'barBorderWidth'];
	var _eventPos = [0, 0]; // FIXME
	// Just for compatible with ec2.
	
	zrUtil.extend(Model.prototype, barItemStyle);
	
	function getClipArea(coord, data) {
	  var coordSysClipArea = coord.getArea && coord.getArea();
	
	  if (coord.type === 'cartesian2d') {
	    var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
	    // We should not clip this part.
	    // See test/bar2.html
	
	    if (baseAxis.type !== 'category' || !baseAxis.onBand) {
	      var expandWidth = data.getLayout('bandWidth');
	
	      if (baseAxis.isHorizontal()) {
	        coordSysClipArea.x -= expandWidth;
	        coordSysClipArea.width += expandWidth * 2;
	      } else {
	        coordSysClipArea.y -= expandWidth;
	        coordSysClipArea.height += expandWidth * 2;
	      }
	    }
	  }
	
	  return coordSysClipArea;
	}
	
	var _default = echarts.extendChartView({
	  type: 'bar',
	  render: function (seriesModel, ecModel, api) {
	    this._updateDrawMode(seriesModel);
	
	    var coordinateSystemType = seriesModel.get('coordinateSystem');
	
	    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
	      this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api);
	    } else {}
	
	    return this.group;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    // Do not support progressive in normal mode.
	    this._incrementalRenderLarge(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coord = seriesModel.coordinateSystem;
	    var baseAxis = coord.getBaseAxis();
	    var isHorizontalOrRadial;
	
	    if (coord.type === 'cartesian2d') {
	      isHorizontalOrRadial = baseAxis.isHorizontal();
	    } else if (coord.type === 'polar') {
	      isHorizontalOrRadial = baseAxis.dim === 'angle';
	    }
	
	    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
	    var needsClip = seriesModel.get('clip', true);
	    var coordSysClipArea = getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.
	
	    group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
	    // And don't want the label are clipped.
	
	    var roundCap = seriesModel.get('roundCap', true);
	    var drawBackground = seriesModel.get('showBackground', true);
	    var backgroundModel = seriesModel.getModel('backgroundStyle');
	    var barBorderRadius = backgroundModel.get('barBorderRadius') || 0;
	    var bgEls = [];
	    var oldBgEls = this._backgroundEls || [];
	
	    var createBackground = function (dataIndex) {
	      var bgLayout = getLayout[coord.type](data, dataIndex);
	      var bgEl = createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
	      bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
	
	      if (coord.type === 'cartesian2d') {
	        bgEl.setShape('r', barBorderRadius);
	      }
	
	      bgEls[dataIndex] = bgEl;
	      return bgEl;
	    };
	
	    data.diff(oldData).add(function (dataIndex) {
	      var itemModel = data.getItemModel(dataIndex);
	      var layout = getLayout[coord.type](data, dataIndex, itemModel);
	
	      if (drawBackground) {
	        createBackground(dataIndex);
	      } // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
	
	
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      if (needsClip) {
	        // Clip will modify the layout params.
	        // And return a boolean to determine if the shape are fully clipped.
	        var isClipped = clip[coord.type](coordSysClipArea, layout);
	
	        if (isClipped) {
	          group.remove(el);
	          return;
	        }
	      }
	
	      var el = elementCreator[coord.type](dataIndex, layout, isHorizontalOrRadial, animationModel, false, roundCap);
	      data.setItemGraphicEl(dataIndex, el);
	      group.add(el);
	      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).update(function (newIndex, oldIndex) {
	      var itemModel = data.getItemModel(newIndex);
	      var layout = getLayout[coord.type](data, newIndex, itemModel);
	
	      if (drawBackground) {
	        var bgEl;
	
	        if (oldBgEls.length === 0) {
	          bgEl = createBackground(oldIndex);
	        } else {
	          bgEl = oldBgEls[oldIndex];
	          bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
	
	          if (coord.type === 'cartesian2d') {
	            bgEl.setShape('r', barBorderRadius);
	          }
	
	          bgEls[newIndex] = bgEl;
	        }
	
	        var bgLayout = getLayout[coord.type](data, newIndex);
	        var shape = createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
	        graphic.updateProps(bgEl, {
	          shape: shape
	        }, animationModel, newIndex);
	      }
	
	      var el = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(el);
	        return;
	      }
	
	      if (needsClip) {
	        var isClipped = clip[coord.type](coordSysClipArea, layout);
	
	        if (isClipped) {
	          group.remove(el);
	          return;
	        }
	      }
	
	      if (el) {
	        graphic.updateProps(el, {
	          shape: layout
	        }, animationModel, newIndex);
	      } else {
	        el = elementCreator[coord.type](newIndex, layout, isHorizontalOrRadial, animationModel, true, roundCap);
	      }
	
	      data.setItemGraphicEl(newIndex, el); // Add back
	
	      group.add(el);
	      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).remove(function (dataIndex) {
	      var el = oldData.getItemGraphicEl(dataIndex);
	
	      if (coord.type === 'cartesian2d') {
	        el && removeRect(dataIndex, animationModel, el);
	      } else {
	        el && removeSector(dataIndex, animationModel, el);
	      }
	    }).execute();
	    var bgGroup = this._backgroundGroup || (this._backgroundGroup = new Group());
	    bgGroup.removeAll();
	
	    for (var i = 0; i < bgEls.length; ++i) {
	      bgGroup.add(bgEls[i]);
	    }
	
	    group.add(bgGroup);
	    this._backgroundEls = bgEls;
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    createLarge(seriesModel, this.group); // Use clipPath in large mode.
	
	    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    this._removeBackground();
	
	    createLarge(seriesModel, this.group, true);
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel) {
	    this._clear(ecModel);
	  },
	  _clear: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel && ecModel.get('animation') && data && !this._isLargeDraw) {
	      this._removeBackground();
	
	      this._backgroundEls = [];
	      data.eachItemGraphicEl(function (el) {
	        if (el.type === 'sector') {
	          removeSector(el.dataIndex, ecModel, el);
	        } else {
	          removeRect(el.dataIndex, ecModel, el);
	        }
	      });
	    } else {
	      group.removeAll();
	    }
	
	    this._data = null;
	  },
	  _removeBackground: function () {
	    this.group.remove(this._backgroundGroup);
	    this._backgroundGroup = null;
	  }
	});
	
	var mathMax = Math.max;
	var mathMin = Math.min;
	var clip = {
	  cartesian2d: function (coordSysBoundingRect, layout) {
	    var signWidth = layout.width < 0 ? -1 : 1;
	    var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height
	
	    if (signWidth < 0) {
	      layout.x += layout.width;
	      layout.width = -layout.width;
	    }
	
	    if (signHeight < 0) {
	      layout.y += layout.height;
	      layout.height = -layout.height;
	    }
	
	    var x = mathMax(layout.x, coordSysBoundingRect.x);
	    var x2 = mathMin(layout.x + layout.width, coordSysBoundingRect.x + coordSysBoundingRect.width);
	    var y = mathMax(layout.y, coordSysBoundingRect.y);
	    var y2 = mathMin(layout.y + layout.height, coordSysBoundingRect.y + coordSysBoundingRect.height);
	    layout.x = x;
	    layout.y = y;
	    layout.width = x2 - x;
	    layout.height = y2 - y;
	    var clipped = layout.width < 0 || layout.height < 0; // Reverse back
	
	    if (signWidth < 0) {
	      layout.x += layout.width;
	      layout.width = -layout.width;
	    }
	
	    if (signHeight < 0) {
	      layout.y += layout.height;
	      layout.height = -layout.height;
	    }
	
	    return clipped;
	  },
	  polar: function (coordSysClipArea, layout) {
	    var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0
	
	    if (signR < 0) {
	      var r = layout.r;
	      layout.r = layout.r0;
	      layout.r0 = r;
	    }
	
	    var r = mathMin(layout.r, coordSysClipArea.r);
	    var r0 = mathMax(layout.r0, coordSysClipArea.r0);
	    layout.r = r;
	    layout.r0 = r0;
	    var clipped = r - r0 < 0; // Reverse back
	
	    if (signR < 0) {
	      var r = layout.r;
	      layout.r = layout.r0;
	      layout.r0 = r;
	    }
	
	    return clipped;
	  }
	};
	var elementCreator = {
	  cartesian2d: function (dataIndex, layout, isHorizontal, animationModel, isUpdate) {
	    var rect = new graphic.Rect({
	      shape: zrUtil.extend({}, layout),
	      z2: 1
	    });
	    rect.name = 'item'; // Animation
	
	    if (animationModel) {
	      var rectShape = rect.shape;
	      var animateProperty = isHorizontal ? 'height' : 'width';
	      var animateTarget = {};
	      rectShape[animateProperty] = 0;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return rect;
	  },
	  polar: function (dataIndex, layout, isRadial, animationModel, isUpdate, roundCap) {
	    // Keep the same logic with bar in catesion: use end value to control
	    // direction. Notice that if clockwise is true (by default), the sector
	    // will always draw clockwisely, no matter whether endAngle is greater
	    // or less than startAngle.
	    var clockwise = layout.startAngle < layout.endAngle;
	    var ShapeClass = !isRadial && roundCap ? Sausage : graphic.Sector;
	    var sector = new ShapeClass({
	      shape: zrUtil.defaults({
	        clockwise: clockwise
	      }, layout),
	      z2: 1
	    });
	    sector.name = 'item'; // Animation
	
	    if (animationModel) {
	      var sectorShape = sector.shape;
	      var animateProperty = isRadial ? 'r' : 'endAngle';
	      var animateTarget = {};
	      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return sector;
	  }
	};
	
	function removeRect(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      width: 0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	function removeSector(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      r: el.shape.r0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	var getLayout = {
	  // itemModel is only used to get borderWidth, which is not needed
	  // when calculating bar background layout.
	  cartesian2d: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    var fixedLineWidth = itemModel ? getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth
	
	    var signX = layout.width > 0 ? 1 : -1;
	    var signY = layout.height > 0 ? 1 : -1;
	    return {
	      x: layout.x + signX * fixedLineWidth / 2,
	      y: layout.y + signY * fixedLineWidth / 2,
	      width: layout.width - signX * fixedLineWidth,
	      height: layout.height - signY * fixedLineWidth
	    };
	  },
	  polar: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    return {
	      cx: layout.cx,
	      cy: layout.cy,
	      r0: layout.r0,
	      r: layout.r,
	      startAngle: layout.startAngle,
	      endAngle: layout.endAngle
	    };
	  }
	};
	
	function isZeroOnPolar(layout) {
	  return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
	}
	
	function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
	  var color = data.getItemVisual(dataIndex, 'color');
	  var opacity = data.getItemVisual(dataIndex, 'opacity');
	  var stroke = data.getVisual('borderColor');
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getBarItemStyle();
	
	  if (!isPolar) {
	    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
	  }
	
	  el.useStyle(zrUtil.defaults({
	    stroke: isZeroOnPolar(layout) ? 'none' : stroke,
	    fill: isZeroOnPolar(layout) ? 'none' : color,
	    opacity: opacity
	  }, itemStyleModel.getBarItemStyle()));
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && el.attr('cursor', cursorStyle);
	  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';
	
	  if (!isPolar) {
	    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
	  }
	
	  if (isZeroOnPolar(layout)) {
	    hoverStyle.fill = hoverStyle.stroke = 'none';
	  }
	
	  graphic.setHoverStyle(el, hoverStyle);
	} // In case width or height are too small.
	
	
	function getLineWidth(itemModel, rawLayout) {
	  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0; // width or height may be NaN for empty data
	
	  var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
	  var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
	  return Math.min(lineWidth, width, height);
	}
	
	var LargePath = Path.extend({
	  type: 'largeBar',
	  shape: {
	    points: []
	  },
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	    var startPoint = this.__startPoint;
	    var baseDimIdx = this.__baseDimIdx;
	
	    for (var i = 0; i < points.length; i += 2) {
	      startPoint[baseDimIdx] = points[i + baseDimIdx];
	      ctx.moveTo(startPoint[0], startPoint[1]);
	      ctx.lineTo(points[i], points[i + 1]);
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  // TODO support polar
	  var data = seriesModel.getData();
	  var startPoint = [];
	  var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
	  startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
	  var largeDataIndices = data.getLayout('largeDataIndices');
	  var barWidth = data.getLayout('barWidth');
	  var backgroundModel = seriesModel.getModel('backgroundStyle');
	  var drawBackground = seriesModel.get('showBackground', true);
	
	  if (drawBackground) {
	    var points = data.getLayout('largeBackgroundPoints');
	    var backgroundStartPoint = [];
	    backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
	    var bgEl = new LargePath({
	      shape: {
	        points: points
	      },
	      incremental: !!incremental,
	      __startPoint: backgroundStartPoint,
	      __baseDimIdx: baseDimIdx,
	      __largeDataIndices: largeDataIndices,
	      __barWidth: barWidth,
	      silent: true,
	      z2: 0
	    });
	    setLargeBackgroundStyle(bgEl, backgroundModel, data);
	    group.add(bgEl);
	  }
	
	  var el = new LargePath({
	    shape: {
	      points: data.getLayout('largePoints')
	    },
	    incremental: !!incremental,
	    __startPoint: startPoint,
	    __baseDimIdx: baseDimIdx,
	    __largeDataIndices: largeDataIndices,
	    __barWidth: barWidth
	  });
	  group.add(el);
	  setLargeStyle(el, seriesModel, data); // Enable tooltip and user mouse/touch event handlers.
	
	  el.seriesIndex = seriesModel.seriesIndex;
	
	  if (!seriesModel.get('silent')) {
	    el.on('mousedown', largePathUpdateDataIndex);
	    el.on('mousemove', largePathUpdateDataIndex);
	  }
	} // Use throttle to avoid frequently traverse to find dataIndex.
	
	
	var largePathUpdateDataIndex = throttle(function (event) {
	  var largePath = this;
	  var dataIndex = largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
	  largePath.dataIndex = dataIndex >= 0 ? dataIndex : null;
	}, 30, false);
	
	function largePathFindDataIndex(largePath, x, y) {
	  var baseDimIdx = largePath.__baseDimIdx;
	  var valueDimIdx = 1 - baseDimIdx;
	  var points = largePath.shape.points;
	  var largeDataIndices = largePath.__largeDataIndices;
	  var barWidthHalf = Math.abs(largePath.__barWidth / 2);
	  var startValueVal = largePath.__startPoint[valueDimIdx];
	  _eventPos[0] = x;
	  _eventPos[1] = y;
	  var pointerBaseVal = _eventPos[baseDimIdx];
	  var pointerValueVal = _eventPos[1 - baseDimIdx];
	  var baseLowerBound = pointerBaseVal - barWidthHalf;
	  var baseUpperBound = pointerBaseVal + barWidthHalf;
	
	  for (var i = 0, len = points.length / 2; i < len; i++) {
	    var ii = i * 2;
	    var barBaseVal = points[ii + baseDimIdx];
	    var barValueVal = points[ii + valueDimIdx];
	
	    if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) {
	      return largeDataIndices[i];
	    }
	  }
	
	  return -1;
	}
	
	function setLargeStyle(el, seriesModel, data) {
	  var borderColor = data.getVisual('borderColor') || data.getVisual('color');
	  var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	function setLargeBackgroundStyle(el, backgroundModel, data) {
	  var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
	  var itemStyle = backgroundModel.getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	function createBackgroundShape(isHorizontalOrRadial, layout, coord) {
	  var coordLayout;
	  var isPolar = coord.type === 'polar';
	
	  if (isPolar) {
	    coordLayout = coord.getArea();
	  } else {
	    coordLayout = coord.grid.getRect();
	  }
	
	  if (isPolar) {
	    return {
	      cx: coordLayout.cx,
	      cy: coordLayout.cy,
	      r0: isHorizontalOrRadial ? coordLayout.r0 : layout.r0,
	      r: isHorizontalOrRadial ? coordLayout.r : layout.r,
	      startAngle: isHorizontalOrRadial ? layout.startAngle : 0,
	      endAngle: isHorizontalOrRadial ? layout.endAngle : Math.PI * 2
	    };
	  } else {
	    return {
	      x: isHorizontalOrRadial ? layout.x : coordLayout.x,
	      y: isHorizontalOrRadial ? coordLayout.y : layout.y,
	      width: isHorizontalOrRadial ? layout.width : coordLayout.width,
	      height: isHorizontalOrRadial ? coordLayout.height : layout.height
	    };
	  }
	}
	
	function createBackgroundEl(coord, isHorizontalOrRadial, layout) {
	  var ElementClz = coord.type === 'polar' ? graphic.Sector : graphic.Rect;
	  return new ElementClz({
	    shape: createBackgroundShape(isHorizontalOrRadial, layout, coord),
	    silent: true,
	    z2: 0
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(800);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PictorialBarSeries = BaseBarSeries.extend({
	  type: 'series.pictorialBar',
	  dependencies: ['grid'],
	  defaultOption: {
	    symbol: 'circle',
	    // Customized bar shape
	    symbolSize: null,
	    // Can be ['100%', '100%'], null means auto.
	    symbolRotate: null,
	    symbolPosition: null,
	    // 'start' or 'end' or 'center', null means auto.
	    symbolOffset: null,
	    symbolMargin: null,
	    // start margin and end margin. Can be a number or a percent string.
	    // Auto margin by default.
	    symbolRepeat: false,
	    // false/null/undefined, means no repeat.
	    // Can be true, means auto calculate repeat times and cut by data.
	    // Can be a number, specifies repeat times, and do not cut by data.
	    // Can be 'fixed', means auto calculate repeat times but do not cut by data.
	    symbolRepeatDirection: 'end',
	    // 'end' means from 'start' to 'end'.
	    symbolClip: false,
	    symbolBoundingData: null,
	    // Can be 60 or -40 or [-40, 60]
	    symbolPatternSize: 400,
	    // 400 * 400 px
	    barGap: '-100%',
	    // In most case, overlap is needed.
	    // z can be set in data item, which is z2 actually.
	    // Disable progressive
	    progressive: 0,
	    hoverAnimation: false // Open only when needed.
	
	  },
	  getInitialData: function (option) {
	    // Disable stack.
	    option.stack = null;
	    return PictorialBarSeries.superApply(this, 'getInitialData', arguments);
	  }
	});
	var _default = PictorialBarSeries;
	module.exports = _default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	var isNumeric = _number.isNumeric;
	
	var _helper = __webpack_require__(801);
	
	var setLabel = _helper.setLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal
	
	var LAYOUT_ATTRS = [{
	  xy: 'x',
	  wh: 'width',
	  index: 0,
	  posDesc: ['left', 'right']
	}, {
	  xy: 'y',
	  wh: 'height',
	  index: 1,
	  posDesc: ['top', 'bottom']
	}];
	var pathForLineWidth = new graphic.Circle();
	var BarView = echarts.extendChartView({
	  type: 'pictorialBar',
	  render: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var isHorizontal = !!baseAxis.isHorizontal();
	    var coordSysRect = cartesian.grid.getRect();
	    var opt = {
	      ecSize: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      seriesModel: seriesModel,
	      coordSys: cartesian,
	      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
	      isHorizontal: isHorizontal,
	      valueDim: LAYOUT_ATTRS[+isHorizontal],
	      categoryDim: LAYOUT_ATTRS[1 - isHorizontal]
	    };
	    data.diff(oldData).add(function (dataIndex) {
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      var itemModel = getItemModel(data, dataIndex);
	      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
	      var bar = createBar(data, opt, symbolMeta);
	      data.setItemGraphicEl(dataIndex, bar);
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).update(function (newIndex, oldIndex) {
	      var bar = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(bar);
	        return;
	      }
	
	      var itemModel = getItemModel(data, newIndex);
	      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
	      var pictorialShapeStr = getShapeStr(data, symbolMeta);
	
	      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
	        group.remove(bar);
	        data.setItemGraphicEl(newIndex, null);
	        bar = null;
	      }
	
	      if (bar) {
	        updateBar(bar, opt, symbolMeta);
	      } else {
	        bar = createBar(data, opt, symbolMeta, true);
	      }
	
	      data.setItemGraphicEl(newIndex, bar);
	      bar.__pictorialSymbolMeta = symbolMeta; // Add back
	
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).remove(function (dataIndex) {
	      var bar = oldData.getItemGraphicEl(dataIndex);
	      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
	    }).execute();
	    this._data = data;
	    return this.group;
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel, api) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel.get('animation')) {
	      if (data) {
	        data.eachItemGraphicEl(function (bar) {
	          removeBar(data, bar.dataIndex, ecModel, bar);
	        });
	      }
	    } else {
	      group.removeAll();
	    }
	  }
	}); // Set or calculate default value about symbol, and calculate layout info.
	
	function getSymbolMeta(data, dataIndex, itemModel, opt) {
	  var layout = data.getItemLayout(dataIndex);
	  var symbolRepeat = itemModel.get('symbolRepeat');
	  var symbolClip = itemModel.get('symbolClip');
	  var symbolPosition = itemModel.get('symbolPosition') || 'start';
	  var symbolRotate = itemModel.get('symbolRotate');
	  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
	  var isAnimationEnabled = itemModel.isAnimationEnabled();
	  var symbolMeta = {
	    dataIndex: dataIndex,
	    layout: layout,
	    itemModel: itemModel,
	    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
	    color: data.getItemVisual(dataIndex, 'color'),
	    symbolClip: symbolClip,
	    symbolRepeat: symbolRepeat,
	    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
	    symbolPatternSize: symbolPatternSize,
	    rotation: rotation,
	    animationModel: isAnimationEnabled ? itemModel : null,
	    hoverAnimation: isAnimationEnabled && itemModel.get('hoverAnimation'),
	    z2: itemModel.getShallow('z', true) || 0
	  };
	  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
	  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
	  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
	  var symbolSize = symbolMeta.symbolSize;
	  var symbolOffset = itemModel.get('symbolOffset');
	
	  if (zrUtil.isArray(symbolOffset)) {
	    symbolOffset = [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])];
	  }
	
	  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
	  return symbolMeta;
	} // bar length can be negative.
	
	
	function prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
	  var valueDim = opt.valueDim;
	  var symbolBoundingData = itemModel.get('symbolBoundingData');
	  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
	  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
	  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
	  var boundingLength;
	
	  if (zrUtil.isArray(symbolBoundingData)) {
	    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
	    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
	    boundingLength = symbolBoundingExtent[pxSignIdx];
	  } else if (symbolBoundingData != null) {
	    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
	  } else if (symbolRepeat) {
	    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
	  } else {
	    boundingLength = layout[valueDim.wh];
	  }
	
	  output.boundingLength = boundingLength;
	
	  if (symbolRepeat) {
	    output.repeatCutLength = layout[valueDim.wh];
	  }
	
	  output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
	}
	
	function convertToCoordOnAxis(axis, value) {
	  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
	} // Support ['100%', '100%']
	
	
	function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
	  var valueDim = opt.valueDim;
	  var categoryDim = opt.categoryDim;
	  var categorySize = Math.abs(layout[categoryDim.wh]);
	  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
	
	  if (zrUtil.isArray(symbolSize)) {
	    symbolSize = symbolSize.slice();
	  } else {
	    if (symbolSize == null) {
	      symbolSize = '100%';
	    }
	
	    symbolSize = [symbolSize, symbolSize];
	  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
	  // to complicated to calculate real percent value if considering scaled lineWidth.
	  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
	  // which can be tolerated in pictorial chart.
	
	
	  symbolSize[categoryDim.index] = parsePercent(symbolSize[categoryDim.index], categorySize);
	  symbolSize[valueDim.index] = parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
	  output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.
	
	  var symbolScale = output.symbolScale = [symbolSize[0] / symbolPatternSize, symbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.
	
	  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
	}
	
	function prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
	  // In symbols are drawn with scale, so do not need to care about the case that width
	  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
	  // be calculated.
	  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	
	  if (valueLineWidth) {
	    pathForLineWidth.attr({
	      scale: symbolScale.slice(),
	      rotation: rotation
	    });
	    pathForLineWidth.updateTransform();
	    valueLineWidth /= pathForLineWidth.getLineScale();
	    valueLineWidth *= symbolScale[opt.valueDim.index];
	  }
	
	  output.valueLineWidth = valueLineWidth;
	}
	
	function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
	  var categoryDim = opt.categoryDim;
	  var valueDim = opt.valueDim;
	  var pxSign = output.pxSign;
	  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
	  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
	  // want symbols to rotate on its center, which should not be translated
	  // when rotating.
	
	  if (symbolRepeat) {
	    var absBoundingLength = Math.abs(boundingLength);
	    var symbolMargin = zrUtil.retrieve(itemModel.get('symbolMargin'), '15%') + '';
	    var hasEndGap = false;
	
	    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
	      hasEndGap = true;
	      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
	    }
	
	    symbolMargin = parsePercent(symbolMargin, symbolSize[valueDim.index]);
	    var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
	    // to ensure that all of the symbols will not be overflow the given area.
	
	    var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
	    // boundingLength.
	
	    var repeatSpecified = isNumeric(symbolRepeat);
	    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
	    // entirely in the given layout area.
	
	    var mDiff = absBoundingLength - repeatTimes * unitLength;
	    symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
	    uLenWithMargin = unitLength + symbolMargin * 2;
	    endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.
	
	    if (!repeatSpecified && symbolRepeat !== 'fixed') {
	      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
	    }
	
	    pathLen = repeatTimes * uLenWithMargin - endFix;
	    output.repeatTimes = repeatTimes;
	    output.symbolMargin = symbolMargin;
	  }
	
	  var sizeFix = pxSign * (pathLen / 2);
	  var pathPosition = output.pathPosition = [];
	  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
	  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
	
	  if (symbolOffset) {
	    pathPosition[0] += symbolOffset[0];
	    pathPosition[1] += symbolOffset[1];
	  }
	
	  var bundlePosition = output.bundlePosition = [];
	  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
	  bundlePosition[valueDim.index] = layout[valueDim.xy];
	  var barRectShape = output.barRectShape = zrUtil.extend({}, layout);
	  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
	  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
	  var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.
	
	  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
	  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
	  clipShape[valueDim.xy] = 0;
	  clipShape[valueDim.wh] = layout[valueDim.wh];
	}
	
	function createPath(symbolMeta) {
	  var symbolPatternSize = symbolMeta.symbolPatternSize;
	  var path = createSymbol( // Consider texture img, make a big size.
	  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
	  path.attr({
	    culling: true
	  });
	  path.type !== 'image' && path.setStyle({
	    strokeNoScale: true
	  });
	  return path;
	}
	
	function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var symbolSize = symbolMeta.symbolSize;
	  var valueLineWidth = symbolMeta.valueLineWidth;
	  var pathPosition = symbolMeta.pathPosition;
	  var valueDim = opt.valueDim;
	  var repeatTimes = symbolMeta.repeatTimes || 0;
	  var index = 0;
	  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
	  eachPath(bar, function (path) {
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	
	    if (index < repeatTimes) {
	      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
	    } else {
	      updateAttr(path, null, {
	        scale: [0, 0]
	      }, symbolMeta, isUpdate, function () {
	        bundle.remove(path);
	      });
	    }
	
	    updateHoverAnimation(path, symbolMeta);
	    index++;
	  });
	
	  for (; index < repeatTimes; index++) {
	    var path = createPath(symbolMeta);
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	    bundle.add(path);
	    var target = makeTarget(index);
	    updateAttr(path, {
	      position: target.position,
	      scale: [0, 0]
	    }, {
	      scale: target.scale,
	      rotation: target.rotation
	    }, symbolMeta, isUpdate); // FIXME
	    // If all emphasis/normal through action.
	
	    path.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	    updateHoverAnimation(path, symbolMeta);
	  }
	
	  function makeTarget(index) {
	    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
	    // Otherwise: i = index;
	
	    var pxSign = symbolMeta.pxSign;
	    var i = index;
	
	    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
	      i = repeatTimes - 1 - index;
	    }
	
	    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
	    return {
	      position: position,
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    };
	  }
	
	  function onMouseOver() {
	    eachPath(bar, function (path) {
	      path.trigger('emphasis');
	    });
	  }
	
	  function onMouseOut() {
	    eachPath(bar, function (path) {
	      path.trigger('normal');
	    });
	  }
	}
	
	function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var mainPath = bar.__pictorialMainPath;
	
	  if (!mainPath) {
	    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
	    bundle.add(mainPath);
	    updateAttr(mainPath, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: [0, 0],
	      rotation: symbolMeta.rotation
	    }, {
	      scale: symbolMeta.symbolScale.slice()
	    }, symbolMeta, isUpdate);
	    mainPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	  } else {
	    updateAttr(mainPath, null, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    }, symbolMeta, isUpdate);
	  }
	
	  updateHoverAnimation(mainPath, symbolMeta);
	
	  function onMouseOver() {
	    this.trigger('emphasis');
	  }
	
	  function onMouseOut() {
	    this.trigger('normal');
	  }
	} // bar rect is used for label.
	
	
	function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
	  var rectShape = zrUtil.extend({}, symbolMeta.barRectShape);
	  var barRect = bar.__pictorialBarRect;
	
	  if (!barRect) {
	    barRect = bar.__pictorialBarRect = new graphic.Rect({
	      z2: 2,
	      shape: rectShape,
	      silent: true,
	      style: {
	        stroke: 'transparent',
	        fill: 'transparent',
	        lineWidth: 0
	      }
	    });
	    bar.add(barRect);
	  } else {
	    updateAttr(barRect, null, {
	      shape: rectShape
	    }, symbolMeta, isUpdate);
	  }
	}
	
	function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
	  // If not clip, symbol will be remove and rebuilt.
	  if (symbolMeta.symbolClip) {
	    var clipPath = bar.__pictorialClipPath;
	    var clipShape = zrUtil.extend({}, symbolMeta.clipShape);
	    var valueDim = opt.valueDim;
	    var animationModel = symbolMeta.animationModel;
	    var dataIndex = symbolMeta.dataIndex;
	
	    if (clipPath) {
	      graphic.updateProps(clipPath, {
	        shape: clipShape
	      }, animationModel, dataIndex);
	    } else {
	      clipShape[valueDim.wh] = 0;
	      clipPath = new graphic.Rect({
	        shape: clipShape
	      });
	
	      bar.__pictorialBundle.setClipPath(clipPath);
	
	      bar.__pictorialClipPath = clipPath;
	      var target = {};
	      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
	        shape: target
	      }, animationModel, dataIndex);
	    }
	  }
	}
	
	function getItemModel(data, dataIndex) {
	  var itemModel = data.getItemModel(dataIndex);
	  itemModel.getAnimationDelayParams = getAnimationDelayParams;
	  itemModel.isAnimationEnabled = isAnimationEnabled;
	  return itemModel;
	}
	
	function getAnimationDelayParams(path) {
	  // The order is the same as the z-order, see `symbolRepeatDiretion`.
	  return {
	    index: path.__pictorialAnimationIndex,
	    count: path.__pictorialRepeatTimes
	  };
	}
	
	function isAnimationEnabled() {
	  // `animation` prop can be set on itemModel in pictorial bar chart.
	  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
	}
	
	function updateHoverAnimation(path, symbolMeta) {
	  path.off('emphasis').off('normal');
	  var scale = symbolMeta.symbolScale.slice();
	  symbolMeta.hoverAnimation && path.on('emphasis', function () {
	    this.animateTo({
	      scale: [scale[0] * 1.1, scale[1] * 1.1]
	    }, 400, 'elasticOut');
	  }).on('normal', function () {
	    this.animateTo({
	      scale: scale.slice()
	    }, 400, 'elasticOut');
	  });
	}
	
	function createBar(data, opt, symbolMeta, isUpdate) {
	  // bar is the main element for each data.
	  var bar = new graphic.Group(); // bundle is used for location and clip.
	
	  var bundle = new graphic.Group();
	  bar.add(bundle);
	  bar.__pictorialBundle = bundle;
	  bundle.attr('position', symbolMeta.bundlePosition.slice());
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
	  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
	  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
	  bar.__pictorialSymbolMeta = symbolMeta;
	  return bar;
	}
	
	function updateBar(bar, opt, symbolMeta) {
	  var animationModel = symbolMeta.animationModel;
	  var dataIndex = symbolMeta.dataIndex;
	  var bundle = bar.__pictorialBundle;
	  graphic.updateProps(bundle, {
	    position: symbolMeta.bundlePosition.slice()
	  }, animationModel, dataIndex);
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, true);
	  createOrUpdateClip(bar, opt, symbolMeta, true);
	}
	
	function removeBar(data, dataIndex, animationModel, bar) {
	  // Not show text when animating
	  var labelRect = bar.__pictorialBarRect;
	  labelRect && (labelRect.style.text = null);
	  var pathes = [];
	  eachPath(bar, function (path) {
	    pathes.push(path);
	  });
	  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.
	
	  bar.__pictorialClipPath && (animationModel = null);
	  zrUtil.each(pathes, function (path) {
	    graphic.updateProps(path, {
	      scale: [0, 0]
	    }, animationModel, dataIndex, function () {
	      bar.parent && bar.parent.remove(bar);
	    });
	  });
	  data.setItemGraphicEl(dataIndex, null);
	}
	
	function getShapeStr(data, symbolMeta) {
	  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
	}
	
	function eachPath(bar, cb, context) {
	  // Do not use Group#eachChild, because it do not support remove.
	  zrUtil.each(bar.__pictorialBundle.children(), function (el) {
	    el !== bar.__pictorialBarRect && cb.call(context, el);
	  });
	}
	
	function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
	  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
	
	  if (symbolMeta.symbolClip && !isUpdate) {
	    animationAttrs && el.attr(animationAttrs);
	  } else {
	    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
	  }
	}
	
	function updateCommon(bar, opt, symbolMeta) {
	  var color = symbolMeta.color;
	  var dataIndex = symbolMeta.dataIndex;
	  var itemModel = symbolMeta.itemModel; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  eachPath(bar, function (path) {
	    // PENDING setColor should be before setStyle!!!
	    path.setColor(color);
	    path.setStyle(zrUtil.defaults({
	      fill: color,
	      opacity: symbolMeta.opacity
	    }, normalStyle));
	    graphic.setHoverStyle(path, hoverStyle);
	    cursorStyle && (path.cursor = cursorStyle);
	    path.z2 = symbolMeta.z2;
	  });
	  var barRectHoverStyle = {};
	  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
	  var barRect = bar.__pictorialBarRect;
	  setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
	  graphic.setHoverStyle(barRect, barRectHoverStyle);
	}
	
	function toIntTimes(times) {
	  var roundedTimes = Math.round(times); // Escapse accurate error
	
	  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
	}
	
	var _default = BarView;
	module.exports = _default;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
	['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getBarItemStyle: function (excludes) {
	    var style = getBarItemStyle(this, excludes);
	
	    if (this.getBorderLineDash) {
	      var lineDash = this.getBorderLineDash();
	      lineDash && (style.lineDash = lineDash);
	    }
	
	    return style;
	  }
	};
	module.exports = _default;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1620);
	
	__webpack_require__(1621);
	
	var boxplotVisual = __webpack_require__(1623);
	
	var boxplotLayout = __webpack_require__(1622);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(boxplotVisual);
	echarts.registerLayout(boxplotLayout);

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var SeriesModel = __webpack_require__(66);
	
	var _whiskerBoxCommon = __webpack_require__(808);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BoxplotSeries = SeriesModel.extend({
	  type: 'series.boxplot',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	  // TODO
	  // box width represents group size, so dimension should have 'size'.
	
	  /**
	   * @see <https://en.wikipedia.org/wiki/Box_plot>
	   * The meanings of 'min' and 'max' depend on user,
	   * and echarts do not need to know it.
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'min',
	    defaultTooltip: true
	  }, {
	    name: 'Q1',
	    defaultTooltip: true
	  }, {
	    name: 'median',
	    defaultTooltip: true
	  }, {
	    name: 'Q3',
	    defaultTooltip: true
	  }, {
	    name: 'max',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    boxWidth: [7, 50],
	    // [min, max] can be percent of band width.
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2,
	        shadowBlur: 5,
	        shadowOffsetX: 2,
	        shadowOffsetY: 2,
	        shadowColor: 'rgba(0,0,0,0.4)'
	      }
	    },
	    animationEasing: 'elasticOut',
	    animationDuration: 800
	  }
	});
	zrUtil.mixin(BoxplotSeries, seriesModelMixin, true);
	var _default = BoxplotSeries;
	module.exports = _default;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ChartView = __webpack_require__(103);
	
	var graphic = __webpack_require__(17);
	
	var Path = __webpack_require__(55);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Update common properties
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var BoxplotView = ChartView.extend({
	  type: 'boxplot',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var oldData = this._data; // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var itemLayout = data.getItemLayout(newIdx);
	        var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
	        data.setItemGraphicEl(newIdx, symbolEl);
	        group.add(symbolEl);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(symbolEl);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (!symbolEl) {
	        symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
	      } else {
	        updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
	      }
	
	      group.add(symbolEl);
	      data.setItemGraphicEl(newIdx, symbolEl);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	    this._data = null;
	    data && data.eachItemGraphicEl(function (el) {
	      el && group.remove(el);
	    });
	  },
	  dispose: zrUtil.noop
	});
	var BoxPath = Path.extend({
	  type: 'boxplotBoxPath',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	    var i = 0;
	    ctx.moveTo(ends[i][0], ends[i][1]);
	    i++;
	
	    for (; i < 4; i++) {
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	
	    ctx.closePath();
	
	    for (; i < ends.length; i++) {
	      ctx.moveTo(ends[i][0], ends[i][1]);
	      i++;
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
	  var ends = itemLayout.ends;
	  var el = new BoxPath({
	    shape: {
	      points: isInit ? transInit(ends, constDim, itemLayout) : ends
	    }
	  });
	  updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
	  return el;
	}
	
	function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
	  var seriesModel = data.hostModel;
	  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps'];
	  updateMethod(el, {
	    shape: {
	      points: itemLayout.ends
	    }
	  }, seriesModel, dataIndex);
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var borderColor = data.getItemVisual(dataIndex, 'color'); // Exclude borderColor.
	
	  var itemStyle = normalItemStyleModel.getItemStyle(['borderColor']);
	  itemStyle.stroke = borderColor;
	  itemStyle.strokeNoScale = true;
	  el.useStyle(itemStyle);
	  el.z2 = 100;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, dim, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[dim] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var _default = BoxplotView;
	module.exports = _default;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(ecModel) {
	  var groupResult = groupSeriesByAxis(ecModel);
	  each(groupResult, function (groupItem) {
	    var seriesModels = groupItem.seriesModels;
	
	    if (!seriesModels.length) {
	      return;
	    }
	
	    calculateBase(groupItem);
	    each(seriesModels, function (seriesModel, idx) {
	      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
	    });
	  });
	}
	/**
	 * Group series by axis.
	 */
	
	
	function groupSeriesByAxis(ecModel) {
	  var result = [];
	  var axisList = [];
	  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
	    var baseAxis = seriesModel.getBaseAxis();
	    var idx = zrUtil.indexOf(axisList, baseAxis);
	
	    if (idx < 0) {
	      idx = axisList.length;
	      axisList[idx] = baseAxis;
	      result[idx] = {
	        axis: baseAxis,
	        seriesModels: []
	      };
	    }
	
	    result[idx].seriesModels.push(seriesModel);
	  });
	  return result;
	}
	/**
	 * Calculate offset and box width for each series.
	 */
	
	
	function calculateBase(groupItem) {
	  var extent;
	  var baseAxis = groupItem.axis;
	  var seriesModels = groupItem.seriesModels;
	  var seriesCount = seriesModels.length;
	  var boxWidthList = groupItem.boxWidthList = [];
	  var boxOffsetList = groupItem.boxOffsetList = [];
	  var boundList = [];
	  var bandWidth;
	
	  if (baseAxis.type === 'category') {
	    bandWidth = baseAxis.getBandWidth();
	  } else {
	    var maxDataCount = 0;
	    each(seriesModels, function (seriesModel) {
	      maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
	    });
	    extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / maxDataCount;
	  }
	
	  each(seriesModels, function (seriesModel) {
	    var boxWidthBound = seriesModel.get('boxWidth');
	
	    if (!zrUtil.isArray(boxWidthBound)) {
	      boxWidthBound = [boxWidthBound, boxWidthBound];
	    }
	
	    boundList.push([parsePercent(boxWidthBound[0], bandWidth) || 0, parsePercent(boxWidthBound[1], bandWidth) || 0]);
	  });
	  var availableWidth = bandWidth * 0.8 - 2;
	  var boxGap = availableWidth / seriesCount * 0.3;
	  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
	  var base = boxWidth / 2 - availableWidth / 2;
	  each(seriesModels, function (seriesModel, idx) {
	    boxOffsetList.push(base);
	    base += boxGap + boxWidth;
	    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
	  });
	}
	/**
	 * Calculate points location for each series.
	 */
	
	
	function layoutSingleSeries(seriesModel, offset, boxWidth) {
	  var coordSys = seriesModel.coordinateSystem;
	  var data = seriesModel.getData();
	  var halfWidth = boxWidth / 2;
	  var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
	  var vDimIdx = 1 - cDimIdx;
	  var coordDims = ['x', 'y'];
	  var cDim = data.mapDimension(coordDims[cDimIdx]);
	  var vDims = data.mapDimension(coordDims[vDimIdx], true);
	
	  if (cDim == null || vDims.length < 5) {
	    return;
	  }
	
	  for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	    var axisDimVal = data.get(cDim, dataIndex);
	    var median = getPoint(axisDimVal, vDims[2], dataIndex);
	    var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
	    var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
	    var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
	    var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
	    var ends = [];
	    addBodyEnd(ends, end2, 0);
	    addBodyEnd(ends, end4, 1);
	    ends.push(end1, end2, end5, end4);
	    layEndLine(ends, end1);
	    layEndLine(ends, end5);
	    layEndLine(ends, median);
	    data.setItemLayout(dataIndex, {
	      initBaseline: median[vDimIdx],
	      ends: ends
	    });
	  }
	
	  function getPoint(axisDimVal, dimIdx, dataIndex) {
	    var val = data.get(dimIdx, dataIndex);
	    var p = [];
	    p[cDimIdx] = axisDimVal;
	    p[vDimIdx] = val;
	    var point;
	
	    if (isNaN(axisDimVal) || isNaN(val)) {
	      point = [NaN, NaN];
	    } else {
	      point = coordSys.dataToPoint(p);
	      point[cDimIdx] += offset;
	    }
	
	    return point;
	  }
	
	  function addBodyEnd(ends, point, start) {
	    var point1 = point.slice();
	    var point2 = point.slice();
	    point1[cDimIdx] += halfWidth;
	    point2[cDimIdx] -= halfWidth;
	    start ? ends.push(point1, point2) : ends.push(point2, point1);
	  }
	
	  function layEndLine(ends, endCenter) {
	    var from = endCenter.slice();
	    var to = endCenter.slice();
	    from[cDimIdx] -= halfWidth;
	    to[cDimIdx] += halfWidth;
	    ends.push(from, to);
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var borderColorQuery = ['itemStyle', 'borderColor'];
	
	function _default(ecModel, api) {
	  var globalColors = ecModel.get('color');
	  ecModel.eachRawSeriesByType('boxplot', function (seriesModel) {
	    var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      // Use name 'color' but not 'borderColor' for legend usage and
	      // visual coding from other component like dataRange.
	      color: seriesModel.get(borderColorQuery) || defaulColor
	    }); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        data.setItemVisual(idx, {
	          color: itemModel.get(borderColorQuery, true)
	        });
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1625);
	
	__webpack_require__(1626);
	
	var preprocessor = __webpack_require__(1629);
	
	var candlestickVisual = __webpack_require__(1628);
	
	var candlestickLayout = __webpack_require__(1627);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(preprocessor);
	echarts.registerVisual(candlestickVisual);
	echarts.registerLayout(candlestickLayout);

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var SeriesModel = __webpack_require__(66);
	
	var _whiskerBoxCommon = __webpack_require__(808);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CandlestickSeries = SeriesModel.extend({
	  type: 'series.candlestick',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	
	  /**
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'open',
	    defaultTooltip: true
	  }, {
	    name: 'close',
	    defaultTooltip: true
	  }, {
	    name: 'lowest',
	    defaultTooltip: true
	  }, {
	    name: 'highest',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    clip: true,
	    itemStyle: {
	      color: '#c23531',
	      // 阳线 positive
	      color0: '#314656',
	      // 阴线 negative     '#c23531', '#314656'
	      borderWidth: 1,
	      // FIXME
	      // ec2中使用的是lineStyle.color 和 lineStyle.color0
	      borderColor: '#c23531',
	      borderColor0: '#314656'
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2
	      }
	    },
	    barMaxWidth: null,
	    barMinWidth: null,
	    barWidth: null,
	    large: true,
	    largeThreshold: 600,
	    progressive: 3e3,
	    progressiveThreshold: 1e4,
	    progressiveChunkMode: 'mod',
	    animationUpdate: false,
	    animationEasing: 'linear',
	    animationDuration: 300
	  },
	
	  /**
	   * Get dimension for shadow in dataZoom
	   * @return {string} dimension name
	   */
	  getShadowDim: function () {
	    return 'open';
	  },
	  brushSelector: function (dataIndex, data, selectors) {
	    var itemLayout = data.getItemLayout(dataIndex);
	    return itemLayout && selectors.rect(itemLayout.brushRect);
	  }
	});
	zrUtil.mixin(CandlestickSeries, seriesModelMixin, true);
	var _default = CandlestickSeries;
	module.exports = _default;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ChartView = __webpack_require__(103);
	
	var graphic = __webpack_require__(17);
	
	var Path = __webpack_require__(55);
	
	var _createClipPathFromCoordSys = __webpack_require__(215);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var SKIP_PROPS = ['color', 'color0', 'borderColor', 'borderColor0'];
	var CandlestickView = ChartView.extend({
	  type: 'candlestick',
	  render: function (seriesModel, ecModel, api) {
	    // If there is clipPath created in large mode. Remove it.
	    this.group.removeClipPath();
	
	    this._updateDrawMode(seriesModel);
	
	    this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var needsClip = seriesModel.get('clip', true);
	    var coord = seriesModel.coordinateSystem;
	    var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var el;
	        var itemLayout = data.getItemLayout(newIdx);
	
	        if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	          return;
	        }
	
	        el = createNormalBox(itemLayout, newIdx, true);
	        graphic.initProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	        setBoxCommon(el, data, newIdx, isSimpleBox);
	        group.add(el);
	        data.setItemGraphicEl(newIdx, el);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(el);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	        group.remove(el);
	        return;
	      }
	
	      if (!el) {
	        el = createNormalBox(itemLayout, newIdx);
	      } else {
	        graphic.updateProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	      }
	
	      setBoxCommon(el, data, newIdx, isSimpleBox);
	      group.add(el);
	      data.setItemGraphicEl(newIdx, el);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel) {
	    this._clear();
	
	    createLarge(seriesModel, this.group);
	    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	  },
	  _incrementalRenderNormal: function (params, seriesModel) {
	    var data = seriesModel.getData();
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var el;
	      var itemLayout = data.getItemLayout(dataIndex);
	      el = createNormalBox(itemLayout, dataIndex);
	      setBoxCommon(el, data, dataIndex, isSimpleBox);
	      el.incremental = true;
	      this.group.add(el);
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    createLarge(seriesModel, this.group, true);
	  },
	  remove: function (ecModel) {
	    this._clear();
	  },
	  _clear: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: zrUtil.noop
	});
	var NormalBoxPath = Path.extend({
	  type: 'normalCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	
	    if (this.__simpleBox) {
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[6][0], ends[6][1]);
	    } else {
	      ctx.moveTo(ends[0][0], ends[0][1]);
	      ctx.lineTo(ends[1][0], ends[1][1]);
	      ctx.lineTo(ends[2][0], ends[2][1]);
	      ctx.lineTo(ends[3][0], ends[3][1]);
	      ctx.closePath();
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[5][0], ends[5][1]);
	      ctx.moveTo(ends[6][0], ends[6][1]);
	      ctx.lineTo(ends[7][0], ends[7][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, dataIndex, isInit) {
	  var ends = itemLayout.ends;
	  return new NormalBoxPath({
	    shape: {
	      points: isInit ? transInit(ends, itemLayout) : ends
	    },
	    z2: 100
	  });
	}
	
	function isNormalBoxClipped(clipArea, itemLayout) {
	  var clipped = true;
	
	  for (var i = 0; i < itemLayout.ends.length; i++) {
	    // If any point are in the region.
	    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
	      clipped = false;
	      break;
	    }
	  }
	
	  return clipped;
	}
	
	function setBoxCommon(el, data, dataIndex, isSimpleBox) {
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var color = data.getItemVisual(dataIndex, 'color');
	  var borderColor = data.getItemVisual(dataIndex, 'borderColor') || color; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = normalItemStyleModel.getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.strokeNoScale = true;
	  el.style.fill = color;
	  el.style.stroke = borderColor;
	  el.__simpleBox = isSimpleBox;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[1] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var LargeBoxPath = Path.extend({
	  type: 'largeCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	
	    for (var i = 0; i < points.length;) {
	      if (this.__sign === points[i++]) {
	        var x = points[i++];
	        ctx.moveTo(x, points[i++]);
	        ctx.lineTo(x, points[i++]);
	      } else {
	        i += 3;
	      }
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  var data = seriesModel.getData();
	  var largePoints = data.getLayout('largePoints');
	  var elP = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: 1
	  });
	  group.add(elP);
	  var elN = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: -1
	  });
	  group.add(elN);
	  setLargeStyle(1, elP, seriesModel, data);
	  setLargeStyle(-1, elN, seriesModel, data);
	
	  if (incremental) {
	    elP.incremental = true;
	    elN.incremental = true;
	  }
	}
	
	function setLargeStyle(sign, el, seriesModel, data) {
	  var suffix = sign > 0 ? 'P' : 'N';
	  var borderColor = data.getVisual('borderColor' + suffix) || data.getVisual('color' + suffix); // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = seriesModel.getModel(NORMAL_ITEM_STYLE_PATH).getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor; // No different
	  // el.style.lineWidth = .5;
	}
	
	var _default = CandlestickView;
	module.exports = _default;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(17);
	
	var subPixelOptimize = _graphic.subPixelOptimize;
	
	var createRenderPlanner = __webpack_require__(171);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	var _util = __webpack_require__(2);
	
	var retrieve2 = _util.retrieve2;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var candleWidth = calculateCandleWidth(seriesModel, data);
	    var cDimIdx = 0;
	    var vDimIdx = 1;
	    var coordDims = ['x', 'y'];
	    var cDim = data.mapDimension(coordDims[cDimIdx]);
	    var vDims = data.mapDimension(coordDims[vDimIdx], true);
	    var openDim = vDims[0];
	    var closeDim = vDims[1];
	    var lowestDim = vDims[2];
	    var highestDim = vDims[3];
	    data.setLayout({
	      candleWidth: candleWidth,
	      // The value is experimented visually.
	      isSimpleBox: candleWidth <= 1.3
	    });
	
	    if (cDim == null || vDims.length < 4) {
	      return;
	    }
	
	    return {
	      progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
	    };
	
	    function normalProgress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	        var ocLow = Math.min(openVal, closeVal);
	        var ocHigh = Math.max(openVal, closeVal);
	        var ocLowPoint = getPoint(ocLow, axisDimVal);
	        var ocHighPoint = getPoint(ocHigh, axisDimVal);
	        var lowestPoint = getPoint(lowestVal, axisDimVal);
	        var highestPoint = getPoint(highestVal, axisDimVal);
	        var ends = [];
	        addBodyEnd(ends, ocHighPoint, 0);
	        addBodyEnd(ends, ocLowPoint, 1);
	        ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
	        data.setItemLayout(dataIndex, {
	          sign: getSign(data, dataIndex, openVal, closeVal, closeDim),
	          initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
	          // open point.
	          ends: ends,
	          brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
	        });
	      }
	
	      function getPoint(val, axisDimVal) {
	        var p = [];
	        p[cDimIdx] = axisDimVal;
	        p[vDimIdx] = val;
	        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
	      }
	
	      function addBodyEnd(ends, point, start) {
	        var point1 = point.slice();
	        var point2 = point.slice();
	        point1[cDimIdx] = subPixelOptimize(point1[cDimIdx] + candleWidth / 2, 1, false);
	        point2[cDimIdx] = subPixelOptimize(point2[cDimIdx] - candleWidth / 2, 1, true);
	        start ? ends.push(point1, point2) : ends.push(point2, point1);
	      }
	
	      function makeBrushRect(lowestVal, highestVal, axisDimVal) {
	        var pmin = getPoint(lowestVal, axisDimVal);
	        var pmax = getPoint(highestVal, axisDimVal);
	        pmin[cDimIdx] -= candleWidth / 2;
	        pmax[cDimIdx] -= candleWidth / 2;
	        return {
	          x: pmin[0],
	          y: pmin[1],
	          width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
	          height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
	        };
	      }
	
	      function subPixelOptimizePoint(point) {
	        point[cDimIdx] = subPixelOptimize(point[cDimIdx], 1);
	        return point;
	      }
	    }
	
	    function largeProgress(params, data) {
	      // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
	      var points = new LargeArr(params.count * 4);
	      var offset = 0;
	      var point;
	      var tmpIn = [];
	      var tmpOut = [];
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	
	        if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
	          points[offset++] = NaN;
	          offset += 3;
	          continue;
	        }
	
	        points[offset++] = getSign(data, dataIndex, openVal, closeVal, closeDim);
	        tmpIn[cDimIdx] = axisDimVal;
	        tmpIn[vDimIdx] = lowestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[0] : NaN;
	        points[offset++] = point ? point[1] : NaN;
	        tmpIn[vDimIdx] = highestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[1] : NaN;
	      }
	
	      data.setLayout('largePoints', points);
	    }
	  }
	};
	
	function getSign(data, dataIndex, openVal, closeVal, closeDim) {
	  var sign;
	
	  if (openVal > closeVal) {
	    sign = -1;
	  } else if (openVal < closeVal) {
	    sign = 1;
	  } else {
	    sign = dataIndex > 0 // If close === open, compare with close of last record
	    ? data.get(closeDim, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
	    1;
	  }
	
	  return sign;
	}
	
	function calculateCandleWidth(seriesModel, data) {
	  var baseAxis = seriesModel.getBaseAxis();
	  var extent;
	  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
	  var barMaxWidth = parsePercent(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
	  var barMinWidth = parsePercent(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
	  var barWidth = seriesModel.get('barWidth');
	  return barWidth != null ? parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
	  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
	}
	
	module.exports = _default;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(171);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
	var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
	var positiveColorQuery = ['itemStyle', 'color'];
	var negativeColorQuery = ['itemStyle', 'color0'];
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  // For legend.
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      colorP: getColor(1, seriesModel),
	      colorN: getColor(-1, seriesModel),
	      borderColorP: getBorderColor(1, seriesModel),
	      borderColorN: getBorderColor(-1, seriesModel)
	    }); // Only visible series has each data be visual encoded
	
	    if (ecModel.isSeriesFiltered(seriesModel)) {
	      return;
	    }
	
	    var isLargeRender = seriesModel.pipelineContext.large;
	    return !isLargeRender && {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var itemModel = data.getItemModel(dataIndex);
	        var sign = data.getItemLayout(dataIndex).sign;
	        data.setItemVisual(dataIndex, {
	          color: getColor(sign, itemModel),
	          borderColor: getBorderColor(sign, itemModel)
	        });
	      }
	    }
	
	    function getColor(sign, model) {
	      return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
	    }
	
	    function getBorderColor(sign, model) {
	      return model.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  if (!option || !zrUtil.isArray(option.series)) {
	    return;
	  } // Translate 'k' to 'candlestick'.
	
	
	  zrUtil.each(option.series, function (seriesItem) {
	    if (zrUtil.isObject(seriesItem) && seriesItem.type === 'k') {
	      seriesItem.type = 'candlestick';
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var graphicUtil = __webpack_require__(17);
	
	var _labelHelper = __webpack_require__(414);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	var createListFromArray = __webpack_require__(113);
	
	var _barGrid = __webpack_require__(272);
	
	var getLayoutOnAxis = _barGrid.getLayoutOnAxis;
	
	var DataDiffer = __webpack_require__(142);
	
	var SeriesModel = __webpack_require__(66);
	
	var Model = __webpack_require__(57);
	
	var ChartView = __webpack_require__(103);
	
	var _createClipPathFromCoordSys = __webpack_require__(215);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	var prepareCartesian2d = __webpack_require__(1819);
	
	var prepareGeo = __webpack_require__(1828);
	
	var prepareSingleAxis = __webpack_require__(1846);
	
	var preparePolar = __webpack_require__(1839);
	
	var prepareCalendar = __webpack_require__(1814);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CACHED_LABEL_STYLE_PROPERTIES = graphicUtil.CACHED_LABEL_STYLE_PROPERTIES;
	var ITEM_STYLE_NORMAL_PATH = ['itemStyle'];
	var ITEM_STYLE_EMPHASIS_PATH = ['emphasis', 'itemStyle'];
	var LABEL_NORMAL = ['label'];
	var LABEL_EMPHASIS = ['emphasis', 'label']; // Use prefix to avoid index to be the same as el.name,
	// which will cause weird udpate animation.
	
	var GROUP_DIFF_PREFIX = 'e\0\0';
	/**
	 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
	 * of each coordinate systems are not required by each coordinate systems directly, but
	 * required by the module `custom`.
	 *
	 * prepareInfoForCustomSeries {Function}: optional
	 *     @return {Object} {coordSys: {...}, api: {
	 *         coord: function (data, clamp) {}, // return point in global.
	 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
	 *     }}
	 */
	
	var prepareCustoms = {
	  cartesian2d: prepareCartesian2d,
	  geo: prepareGeo,
	  singleAxis: prepareSingleAxis,
	  polar: preparePolar,
	  calendar: prepareCalendar
	}; // ------
	// Model
	// ------
	
	SeriesModel.extend({
	  type: 'series.custom',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    // Can be set as 'none'
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    useTransform: true,
	    // Custom series will not clip by default.
	    // Some case will use custom series to draw label
	    // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
	    // Only works on polar and cartesian2d coordinate system.
	    clip: false // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // label: {}
	    // itemStyle: {}
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	
	  /**
	   * @override
	   */
	  getDataParams: function (dataIndex, dataType, el) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    el && (params.info = el.info);
	    return params;
	  }
	}); // -----
	// View
	// -----
	
	ChartView.extend({
	  type: 'custom',
	
	  /**
	   * @private
	   * @type {module:echarts/data/List}
	   */
	  _data: null,
	
	  /**
	   * @override
	   */
	  render: function (customSeries, ecModel, api, payload) {
	    var oldData = this._data;
	    var data = customSeries.getData();
	    var group = this.group;
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api); // By default, merge mode is applied. In most cases, custom series is
	    // used in the scenario that data amount is not large but graphic elements
	    // is complicated, where merge mode is probably necessary for optimization.
	    // For example, reuse graphic elements and only update the transform when
	    // roam or data zoom according to `actionType`.
	
	    data.diff(oldData).add(function (newIdx) {
	      createOrUpdate(null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      createOrUpdate(el, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute(); // Do clipping
	
	    var clipPath = customSeries.get('clip', true) ? createClipPath(customSeries.coordinateSystem, false, customSeries) : null;
	
	    if (clipPath) {
	      group.setClipPath(clipPath);
	    } else {
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (customSeries, ecModel, api) {
	    this.group.removeAll();
	    this._data = null;
	  },
	  incrementalRender: function (params, customSeries, ecModel, api, payload) {
	    var data = customSeries.getData();
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
	
	    function setIncrementalAndHoverLayer(el) {
	      if (!el.isGroup) {
	        el.incremental = true;
	        el.useHoverLayer = true;
	      }
	    }
	
	    for (var idx = params.start; idx < params.end; idx++) {
	      var el = createOrUpdate(null, idx, renderItem(idx, payload), customSeries, this.group, data);
	      el.traverse(setIncrementalAndHoverLayer);
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: zrUtil.noop,
	
	  /**
	   * @override
	   */
	  filterForExposedEvent: function (eventType, query, targetEl, packedEvent) {
	    var elementName = query.element;
	
	    if (elementName == null || targetEl.name === elementName) {
	      return true;
	    } // Enable to give a name on a group made by `renderItem`, and listen
	    // events that triggerd by its descendents.
	
	
	    while ((targetEl = targetEl.parent) && targetEl !== this.group) {
	      if (targetEl.name === elementName) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	});
	
	function createEl(elOption) {
	  var graphicType = elOption.type;
	  var el; // Those graphic elements are not shapes. They should not be
	  // overwritten by users, so do them first.
	
	  if (graphicType === 'path') {
	    var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.
	
	    var pathRect = shape.width != null && shape.height != null ? {
	      x: shape.x || 0,
	      y: shape.y || 0,
	      width: shape.width,
	      height: shape.height
	    } : null;
	    var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.
	
	    el = graphicUtil.makePath(pathData, null, pathRect, shape.layout || 'center');
	    el.__customPathData = pathData;
	  } else if (graphicType === 'image') {
	    el = new graphicUtil.Image({});
	    el.__customImagePath = elOption.style.image;
	  } else if (graphicType === 'text') {
	    el = new graphicUtil.Text({});
	    el.__customText = elOption.style.text;
	  } else if (graphicType === 'group') {
	    el = new graphicUtil.Group();
	  } else if (graphicType === 'compoundPath') {
	    throw new Error('"compoundPath" is not supported yet.');
	  } else {
	    var Clz = graphicUtil.getShapeClass(graphicType);
	    el = new Clz();
	  }
	
	  el.__customGraphicType = graphicType;
	  el.name = elOption.name;
	  return el;
	}
	
	function updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot) {
	  var transitionProps = {};
	  var elOptionStyle = elOption.style || {};
	  elOption.shape && (transitionProps.shape = zrUtil.clone(elOption.shape));
	  elOption.position && (transitionProps.position = elOption.position.slice());
	  elOption.scale && (transitionProps.scale = elOption.scale.slice());
	  elOption.origin && (transitionProps.origin = elOption.origin.slice());
	  elOption.rotation && (transitionProps.rotation = elOption.rotation);
	
	  if (el.type === 'image' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y', 'width', 'height'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    });
	  }
	
	  if (el.type === 'text' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    }); // Compatible with previous: both support
	    // textFill and fill, textStroke and stroke in 'text' element.
	
	    !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	    !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	  }
	
	  if (el.type !== 'group') {
	    el.useStyle(elOptionStyle); // Init animation.
	
	    if (isInit) {
	      el.style.opacity = 0;
	      var targetOpacity = elOptionStyle.opacity;
	      targetOpacity == null && (targetOpacity = 1);
	      graphicUtil.initProps(el, {
	        style: {
	          opacity: targetOpacity
	        }
	      }, animatableModel, dataIndex);
	    }
	  }
	
	  if (isInit) {
	    el.attr(transitionProps);
	  } else {
	    graphicUtil.updateProps(el, transitionProps, animatableModel, dataIndex);
	  } // Merge by default.
	  // z2 must not be null/undefined, otherwise sort error may occur.
	
	
	  elOption.hasOwnProperty('z2') && el.attr('z2', elOption.z2 || 0);
	  elOption.hasOwnProperty('silent') && el.attr('silent', elOption.silent);
	  elOption.hasOwnProperty('invisible') && el.attr('invisible', elOption.invisible);
	  elOption.hasOwnProperty('ignore') && el.attr('ignore', elOption.ignore); // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	  // Update them only when user specified, otherwise, remain.
	
	  elOption.hasOwnProperty('info') && el.attr('info', elOption.info); // If `elOption.styleEmphasis` is `false`, remove hover style. The
	  // logic is ensured by `graphicUtil.setElementHoverStyle`.
	
	  var styleEmphasis = elOption.styleEmphasis; // hoverStyle should always be set here, because if the hover style
	  // may already be changed, where the inner cache should be reset.
	
	  graphicUtil.setElementHoverStyle(el, styleEmphasis);
	
	  if (isRoot) {
	    graphicUtil.setAsHighDownDispatcher(el, styleEmphasis !== false);
	  }
	}
	
	function prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
	  if (elOptionStyle[prop] != null && !isInit) {
	    targetStyle[prop] = elOptionStyle[prop];
	    elOptionStyle[prop] = oldElStyle[prop];
	  }
	}
	
	function makeRenderItem(customSeries, data, ecModel, api) {
	  var renderItem = customSeries.get('renderItem');
	  var coordSys = customSeries.coordinateSystem;
	  var prepareResult = {};
	
	  if (coordSys) {
	    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : prepareCustoms[coordSys.type](coordSys);
	  }
	
	  var userAPI = zrUtil.defaults({
	    getWidth: api.getWidth,
	    getHeight: api.getHeight,
	    getZr: api.getZr,
	    getDevicePixelRatio: api.getDevicePixelRatio,
	    value: value,
	    style: style,
	    styleEmphasis: styleEmphasis,
	    visual: visual,
	    barLayout: barLayout,
	    currentSeriesIndices: currentSeriesIndices,
	    font: font
	  }, prepareResult.api || {});
	  var userParams = {
	    // The life cycle of context: current round of rendering.
	    // The global life cycle is probably not necessary, because
	    // user can store global status by themselves.
	    context: {},
	    seriesId: customSeries.id,
	    seriesName: customSeries.name,
	    seriesIndex: customSeries.seriesIndex,
	    coordSys: prepareResult.coordSys,
	    dataInsideLength: data.count(),
	    encode: wrapEncodeDef(customSeries.getData())
	  }; // Do not support call `api` asynchronously without dataIndexInside input.
	
	  var currDataIndexInside;
	  var currDirty = true;
	  var currItemModel;
	  var currLabelNormalModel;
	  var currLabelEmphasisModel;
	  var currVisualColor;
	  return function (dataIndexInside, payload) {
	    currDataIndexInside = dataIndexInside;
	    currDirty = true;
	    return renderItem && renderItem(zrUtil.defaults({
	      dataIndexInside: dataIndexInside,
	      dataIndex: data.getRawIndex(dataIndexInside),
	      // Can be used for optimization when zoom or roam.
	      actionType: payload ? payload.type : null
	    }, userParams), userAPI);
	  }; // Do not update cache until api called.
	
	  function updateCache(dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	
	    if (currDirty) {
	      currItemModel = data.getItemModel(dataIndexInside);
	      currLabelNormalModel = currItemModel.getModel(LABEL_NORMAL);
	      currLabelEmphasisModel = currItemModel.getModel(LABEL_EMPHASIS);
	      currVisualColor = data.getItemVisual(dataIndexInside, 'color');
	      currDirty = false;
	    }
	  }
	  /**
	   * @public
	   * @param {number|string} dim
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   * @return {number|string} value
	   */
	
	
	  function value(dim, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.get(data.getDimension(dim || 0), dataIndexInside);
	  }
	  /**
	   * By default, `visual` is applied to style (to support visualMap).
	   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
	   * it can be implemented as:
	   * `api.style({stroke: api.visual('color'), fill: null})`;
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function style(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_NORMAL_PATH).getItemStyle();
	    currVisualColor != null && (itemStyle.fill = currVisualColor);
	    var opacity = data.getItemVisual(dataIndexInside, 'opacity');
	    opacity != null && (itemStyle.opacity = opacity);
	    var labelModel = extra ? applyExtraBefore(extra, currLabelNormalModel) : currLabelNormalModel;
	    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
	      autoColor: currVisualColor,
	      isRectText: true
	    });
	    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve2(customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && applyExtraAfter(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function styleEmphasis(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_EMPHASIS_PATH).getItemStyle();
	    var labelModel = extra ? applyExtraBefore(extra, currLabelEmphasisModel) : currLabelEmphasisModel;
	    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
	      isRectText: true
	    }, true);
	    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve3(customSeries.getFormattedLabel(dataIndexInside, 'emphasis'), customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && applyExtraAfter(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {string} visualType
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function visual(visualType, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.getItemVisual(dataIndexInside, visualType);
	  }
	  /**
	   * @public
	   * @param {number} opt.count Positive interger.
	   * @param {number} [opt.barWidth]
	   * @param {number} [opt.barMaxWidth]
	   * @param {number} [opt.barMinWidth]
	   * @param {number} [opt.barGap]
	   * @param {number} [opt.barCategoryGap]
	   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
	   */
	
	
	  function barLayout(opt) {
	    if (coordSys.getBaseAxis) {
	      var baseAxis = coordSys.getBaseAxis();
	      return getLayoutOnAxis(zrUtil.defaults({
	        axis: baseAxis
	      }, opt), api);
	    }
	  }
	  /**
	   * @public
	   * @return {Array.<number>}
	   */
	
	
	  function currentSeriesIndices() {
	    return ecModel.getCurrentSeriesIndices();
	  }
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {string} [opt.fontStyle]
	   * @param {number} [opt.fontWeight]
	   * @param {number} [opt.fontSize]
	   * @param {string} [opt.fontFamily]
	   * @return {string} font string
	   */
	
	
	  function font(opt) {
	    return graphicUtil.getFont(opt, ecModel);
	  }
	}
	
	function wrapEncodeDef(data) {
	  var encodeDef = {};
	  zrUtil.each(data.dimensions, function (dimName, dataDimIndex) {
	    var dimInfo = data.getDimensionInfo(dimName);
	
	    if (!dimInfo.isExtraCoord) {
	      var coordDim = dimInfo.coordDim;
	      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
	      dataDims[dimInfo.coordDimIndex] = dataDimIndex;
	    }
	  });
	  return encodeDef;
	}
	
	function createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
	  el = doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, true);
	  el && data.setItemGraphicEl(dataIndex, el);
	  return el;
	}
	
	function doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, isRoot) {
	  // [Rule]
	  // By default, follow merge mode.
	  //     (It probably brings benifit for performance in some cases of large data, where
	  //     user program can be optimized to that only updated props needed to be re-calculated,
	  //     or according to `actionType` some calculation can be skipped.)
	  // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
	  //     (It seems that violate the "merge" principle, but most of users probably intuitively
	  //     regard "return;" as "show nothing element whatever", so make a exception to meet the
	  //     most cases.)
	  var simplyRemove = !elOption; // `null`/`undefined`/`false`
	
	  elOption = elOption || {};
	  var elOptionType = elOption.type;
	  var elOptionShape = elOption.shape;
	  var elOptionStyle = elOption.style;
	
	  if (el && (simplyRemove // || elOption.$merge === false
	  // If `elOptionType` is `null`, follow the merge principle.
	  || elOptionType != null && elOptionType !== el.__customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== el.__customPathData || elOptionType === 'image' && hasOwn(elOptionStyle, 'image') && elOptionStyle.image !== el.__customImagePath // FIXME test and remove this restriction?
	  || elOptionType === 'text' && hasOwn(elOptionShape, 'text') && elOptionStyle.text !== el.__customText)) {
	    group.remove(el);
	    el = null;
	  } // `elOption.type` is undefined when `renderItem` returns nothing.
	
	
	  if (simplyRemove) {
	    return;
	  }
	
	  var isInit = !el;
	  !el && (el = createEl(elOption));
	  updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot);
	
	  if (elOptionType === 'group') {
	    mergeChildren(el, dataIndex, elOption, animatableModel, data);
	  } // Always add whatever already added to ensure sequence.
	
	
	  group.add(el);
	  return el;
	} // Usage:
	// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates that
	//     the existing children will not be removed, and enables the feature that
	//     update some of the props of some of the children simply by construct
	//     the returned children of `renderItem` like:
	//     `var children = group.children = []; children[3] = {opacity: 0.5};`
	// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
	//     by child.name. But that might be lower performance.
	// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
	//     replaced totally.
	// (4) If `!elOption.children`, following the "merge" principle, nothing will happen.
	//
	// For implementation simpleness, do not provide a direct way to remove sinlge
	// child (otherwise the total indicies of the children array have to be modified).
	// User can remove a single child by set its `ignore` as `true` or replace
	// it by another element, where its `$merge` can be set as `true` if necessary.
	
	
	function mergeChildren(el, dataIndex, elOption, animatableModel, data) {
	  var newChildren = elOption.children;
	  var newLen = newChildren ? newChildren.length : 0;
	  var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.
	
	  var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
	  var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.
	
	  if (!newLen && !byName && !notMerge) {
	    return;
	  }
	
	  if (byName) {
	    diffGroupChildren({
	      oldChildren: el.children() || [],
	      newChildren: newChildren || [],
	      dataIndex: dataIndex,
	      animatableModel: animatableModel,
	      group: el,
	      data: data
	    });
	    return;
	  }
	
	  notMerge && el.removeAll(); // Mapping children of a group simply by index, which
	  // might be better performance.
	
	  var index = 0;
	
	  for (; index < newLen; index++) {
	    newChildren[index] && doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
	  }
	}
	
	function diffGroupChildren(context) {
	  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
	}
	
	function getKey(item, idx) {
	  var name = item && item.name;
	  return name != null ? name : GROUP_DIFF_PREFIX + idx;
	}
	
	function processAddUpdate(newIndex, oldIndex) {
	  var context = this.context;
	  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
	  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
	  doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
	} // `graphic#applyDefaultTextStyle` will cache
	// textFill, textStroke, textStrokeWidth.
	// We have to do this trick.
	
	
	function applyExtraBefore(extra, model) {
	  var dummyModel = new Model({}, model);
	  zrUtil.each(CACHED_LABEL_STYLE_PROPERTIES, function (stylePropName, modelPropName) {
	    if (extra.hasOwnProperty(stylePropName)) {
	      dummyModel.option[modelPropName] = extra[stylePropName];
	    }
	  });
	  return dummyModel;
	}
	
	function applyExtraAfter(itemStyle, extra) {
	  for (var key in extra) {
	    if (extra.hasOwnProperty(key) || !CACHED_LABEL_STYLE_PROPERTIES.hasOwnProperty(key)) {
	      itemStyle[key] = extra[key];
	    }
	  }
	}
	
	function processRemove(oldIndex) {
	  var context = this.context;
	  var child = context.oldChildren[oldIndex];
	  child && context.group.remove(child);
	}
	
	function getPathData(shape) {
	  // "d" follows the SVG convention.
	  return shape && (shape.pathData || shape.d);
	}
	
	function hasOwnPathData(shape) {
	  return shape && (shape.hasOwnProperty('pathData') || shape.hasOwnProperty('d'));
	}
	
	function hasOwn(host, prop) {
	  return host && host.hasOwnProperty(prop);
	}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1632);
	
	__webpack_require__(1633);
	
	var visualSymbol = __webpack_require__(145);
	
	var layoutPoints = __webpack_require__(222);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('effectScatter', 'circle'));
	echarts.registerLayout(layoutPoints('effectScatter'));

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(113);
	
	var SeriesModel = __webpack_require__(66);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.effectScatter',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  brushSelector: 'point',
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    effectType: 'ripple',
	    progressive: 0,
	    // When to show the effect, option: 'render'|'emphasis'
	    showEffectOn: 'render',
	    // Ripple effect config
	    rippleEffect: {
	      period: 4,
	      // Scale of ripple
	      scale: 2.5,
	      // Brush type can be fill or stroke
	      brushType: 'fill'
	    },
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    // large: false,
	    // Available when large is true
	    // largeThreshold: 2000,
	    // itemStyle: {
	    //     opacity: 1
	    // }
	
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var SymbolDraw = __webpack_require__(214);
	
	var EffectSymbol = __webpack_require__(1660);
	
	var matrix = __webpack_require__(75);
	
	var pointsLayout = __webpack_require__(222);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'effectScatter',
	  init: function () {
	    this._symbolDraw = new SymbolDraw(EffectSymbol);
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var effectSymbolDraw = this._symbolDraw;
	    effectSymbolDraw.updateData(data);
	    this.group.add(effectSymbolDraw.group);
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    this.group.dirty();
	    var res = pointsLayout().reset(seriesModel);
	
	    if (res.progress) {
	      res.progress({
	        start: 0,
	        end: data.count()
	      }, data);
	    }
	
	    this._symbolDraw.updateLayout(data);
	  },
	  _updateGroupTransform: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.getRoamTransform) {
	      this.group.transform = matrix.clone(coordSys.getRoamTransform());
	      this.group.decomposeTransform();
	    }
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1635);
	
	__webpack_require__(1636);
	
	var dataColor = __webpack_require__(276);
	
	var funnelLayout = __webpack_require__(1637);
	
	var dataFilter = __webpack_require__(223);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(dataColor('funnel'));
	echarts.registerLayout(funnelLayout);
	echarts.registerProcessor(dataFilter('funnel'));

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var createListSimply = __webpack_require__(170);
	
	var _model = __webpack_require__(27);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var _sourceHelper = __webpack_require__(114);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	var LegendVisualProvider = __webpack_require__(225);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FunnelSeries = echarts.extendSeriesModel({
	  type: 'series.funnel',
	  init: function (option) {
	    FunnelSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this)); // Extend labelLine emphasis
	
	    this._defaultLabelLine(option);
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = FunnelSeries.superCall(this, 'getDataParams', dataIndex);
	    var valueDim = data.mapDimension('value');
	    var sum = data.getSum(valueDim); // Percent is 0 if sum is 0
	
	    params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
	    params.$vars.push('percent');
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    legendHoverLink: true,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    // 默认取数据最小最大值
	    // min: 0,
	    // max: 100,
	    minSize: '0%',
	    maxSize: '100%',
	    sort: 'descending',
	    // 'ascending', 'descending'
	    orient: 'vertical',
	    gap: 0,
	    funnelAlign: 'center',
	    label: {
	      show: true,
	      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    labelLine: {
	      show: true,
	      length: 20,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      // color: 各异,
	      borderColor: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = FunnelSeries;
	module.exports = _default;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var zrUtil = __webpack_require__(2);
	
	var ChartView = __webpack_require__(103);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	function FunnelPiece(data, idx) {
	  graphic.Group.call(this);
	  var polygon = new graphic.Polygon();
	  var labelLine = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(polygon);
	  this.add(labelLine);
	  this.add(text);
	
	  this.highDownOnUpdate = function (fromState, toState) {
	    if (toState === 'emphasis') {
	      labelLine.ignore = labelLine.hoverIgnore;
	      text.ignore = text.hoverIgnore;
	    } else {
	      labelLine.ignore = labelLine.normalIgnore;
	      text.ignore = text.normalIgnore;
	    }
	  };
	
	  this.updateData(data, idx, true);
	}
	
	var funnelPieceProto = FunnelPiece.prototype;
	var opacityAccessPath = ['itemStyle', 'opacity'];
	
	funnelPieceProto.updateData = function (data, idx, firstCreate) {
	  var polygon = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var opacity = data.getItemModel(idx).get(opacityAccessPath);
	  opacity = opacity == null ? 1 : opacity; // Reset style
	
	  polygon.useStyle({});
	
	  if (firstCreate) {
	    polygon.setShape({
	      points: layout.points
	    });
	    polygon.setStyle({
	      opacity: 0
	    });
	    graphic.initProps(polygon, {
	      style: {
	        opacity: opacity
	      }
	    }, seriesModel, idx);
	  } else {
	    graphic.updateProps(polygon, {
	      style: {
	        opacity: opacity
	      },
	      shape: {
	        points: layout.points
	      }
	    }, seriesModel, idx);
	  } // Update common style
	
	
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var visualColor = data.getItemVisual(idx, 'color');
	  polygon.setStyle(zrUtil.defaults({
	    lineJoin: 'round',
	    fill: visualColor
	  }, itemStyleModel.getItemStyle(['opacity'])));
	  polygon.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
	
	  this._updateLabel(data, idx);
	
	  graphic.setHoverStyle(this);
	};
	
	funnelPieceProto._updateLabel = function (data, idx) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.updateProps(labelLine, {
	    shape: {
	      points: labelLayout.linePoints || labelLayout.linePoints
	    }
	  }, seriesModel, idx);
	  graphic.updateProps(labelText, {
	    style: {
	      x: labelLayout.x,
	      y: labelLayout.y
	    }
	  }, seriesModel, idx);
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: data.getName(idx),
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	};
	
	zrUtil.inherits(FunnelPiece, graphic.Group);
	var FunnelView = ChartView.extend({
	  type: 'funnel',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    data.diff(oldData).add(function (idx) {
	      var funnelPiece = new FunnelPiece(data, idx);
	      data.setItemGraphicEl(idx, funnelPiece);
	      group.add(funnelPiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	      piePiece.updateData(data, newIdx);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	var _default = FunnelView;
	module.exports = _default;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var layout = __webpack_require__(47);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function getSortedIndices(data, sort) {
	  var valueDim = data.mapDimension('value');
	  var valueArr = data.mapArray(valueDim, function (val) {
	    return val;
	  });
	  var indices = [];
	  var isAscending = sort === 'ascending';
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    indices[i] = i;
	  } // Add custom sortable function & none sortable opetion by "options.sort"
	
	
	  if (typeof sort === 'function') {
	    indices.sort(sort);
	  } else if (sort !== 'none') {
	    indices.sort(function (a, b) {
	      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
	    });
	  }
	
	  return indices;
	}
	
	function labelLayout(data) {
	  data.each(function (idx) {
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label');
	    var labelPosition = labelModel.get('position');
	    var orient = itemModel.get('orient');
	    var labelLineModel = itemModel.getModel('labelLine');
	    var layout = data.getItemLayout(idx);
	    var points = layout.points;
	    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
	    var textAlign;
	    var textX;
	    var textY;
	    var linePoints;
	
	    if (isLabelInside) {
	      if (labelPosition === 'insideLeft') {
	        textX = (points[0][0] + points[3][0]) / 2 + 5;
	        textY = (points[0][1] + points[3][1]) / 2;
	        textAlign = 'left';
	      } else if (labelPosition === 'insideRight') {
	        textX = (points[1][0] + points[2][0]) / 2 - 5;
	        textY = (points[1][1] + points[2][1]) / 2;
	        textAlign = 'right';
	      } else {
	        textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
	        textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
	        textAlign = 'center';
	      }
	
	      linePoints = [[textX, textY], [textX, textY]];
	    } else {
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var labelLineLen = labelLineModel.get('length');
	
	      if (labelPosition === 'left') {
	        // Left side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        x2 = x1 - labelLineLen;
	        textX = x2 - 5;
	        textAlign = 'right';
	      } else if (labelPosition === 'right') {
	        // Right side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        x2 = x1 + labelLineLen;
	        textX = x2 + 5;
	        textAlign = 'left';
	      } else if (labelPosition === 'top') {
	        // Top side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        y2 = y1 - labelLineLen;
	        textY = y2 - 5;
	        textAlign = 'center';
	      } else if (labelPosition === 'bottom') {
	        // Bottom side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        y2 = y1 + labelLineLen;
	        textY = y2 + 5;
	        textAlign = 'center';
	      } else if (labelPosition === 'rightTop') {
	        // RightTop side
	        x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
	        y1 = orient === 'horizontal' ? points[3][1] : points[1][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 - labelLineLen;
	          textY = y2 - 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'top';
	        }
	      } else if (labelPosition === 'rightBottom') {
	        // RightBottom side
	        x1 = points[2][0];
	        y1 = points[2][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'bottom';
	        }
	      } else if (labelPosition === 'leftTop') {
	        // LeftTop side
	        x1 = points[0][0];
	        y1 = orient === 'horizontal' ? points[0][1] : points[1][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 - labelLineLen;
	          textY = y2 - 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 - labelLineLen;
	          textX = x2 - 5;
	          textAlign = 'right';
	        }
	      } else if (labelPosition === 'leftBottom') {
	        // LeftBottom side
	        x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
	        y1 = orient === 'horizontal' ? points[1][1] : points[2][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 - labelLineLen;
	          textX = x2 - 5;
	          textAlign = 'right';
	        }
	      } else {
	        // Right side or Bottom side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'left';
	        }
	      }
	
	      if (orient === 'horizontal') {
	        x2 = x1;
	        textX = x2;
	      } else {
	        y2 = y1;
	        textY = y2;
	      }
	
	      linePoints = [[x1, y1], [x2, y2]];
	    }
	
	    layout.label = {
	      linePoints: linePoints,
	      x: textX,
	      y: textY,
	      verticalAlign: 'middle',
	      textAlign: textAlign,
	      inside: isLabelInside
	    };
	  });
	}
	
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('funnel', function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var sort = seriesModel.get('sort');
	    var viewRect = getViewRect(seriesModel, api);
	    var indices = getSortedIndices(data, sort);
	    var orient = seriesModel.get('orient');
	    var viewWidth = viewRect.width;
	    var viewHeight = viewRect.height;
	    var x = viewRect.x;
	    var y = viewRect.y;
	    var sizeExtent = orient === 'horizontal' ? [parsePercent(seriesModel.get('minSize'), viewHeight), parsePercent(seriesModel.get('maxSize'), viewHeight)] : [parsePercent(seriesModel.get('minSize'), viewWidth), parsePercent(seriesModel.get('maxSize'), viewWidth)];
	    var dataExtent = data.getDataExtent(valueDim);
	    var min = seriesModel.get('min');
	    var max = seriesModel.get('max');
	
	    if (min == null) {
	      min = Math.min(dataExtent[0], 0);
	    }
	
	    if (max == null) {
	      max = dataExtent[1];
	    }
	
	    var funnelAlign = seriesModel.get('funnelAlign');
	    var gap = seriesModel.get('gap');
	    var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
	    var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
	
	    var getLinePoints = function (idx, offset) {
	      // End point index is data.count() and we assign it 0
	      if (orient === 'horizontal') {
	        var val = data.get(valueDim, idx) || 0;
	        var itemHeight = linearMap(val, [min, max], sizeExtent, true);
	        var y0;
	
	        switch (funnelAlign) {
	          case 'top':
	            y0 = y;
	            break;
	
	          case 'center':
	            y0 = y + (viewHeight - itemHeight) / 2;
	            break;
	
	          case 'bottom':
	            y0 = y + (viewHeight - itemHeight);
	            break;
	        }
	
	        return [[offset, y0], [offset, y0 + itemHeight]];
	      }
	
	      var val = data.get(valueDim, idx) || 0;
	      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
	      var x0;
	
	      switch (funnelAlign) {
	        case 'left':
	          x0 = x;
	          break;
	
	        case 'center':
	          x0 = x + (viewWidth - itemWidth) / 2;
	          break;
	
	        case 'right':
	          x0 = x + viewWidth - itemWidth;
	          break;
	      }
	
	      return [[x0, offset], [x0 + itemWidth, offset]];
	    };
	
	    if (sort === 'ascending') {
	      // From bottom to top
	      itemSize = -itemSize;
	      gap = -gap;
	
	      if (orient === 'horizontal') {
	        x += viewWidth;
	      } else {
	        y += viewHeight;
	      }
	
	      indices = indices.reverse();
	    }
	
	    for (var i = 0; i < indices.length; i++) {
	      var idx = indices[i];
	      var nextIdx = indices[i + 1];
	      var itemModel = data.getItemModel(idx);
	
	      if (orient === 'horizontal') {
	        var width = itemModel.get('itemStyle.width');
	
	        if (width == null) {
	          width = itemSize;
	        } else {
	          width = parsePercent(width, viewWidth);
	
	          if (sort === 'ascending') {
	            width = -width;
	          }
	        }
	
	        var start = getLinePoints(idx, x);
	        var end = getLinePoints(nextIdx, x + width);
	        x += width + gap;
	        data.setItemLayout(idx, {
	          points: start.concat(end.slice().reverse())
	        });
	      } else {
	        var height = itemModel.get('itemStyle.height');
	
	        if (height == null) {
	          height = itemSize;
	        } else {
	          height = parsePercent(height, viewHeight);
	
	          if (sort === 'ascending') {
	            height = -height;
	          }
	        }
	
	        var start = orient === 'horizontal' ? getLinePoints(idx, x) : getLinePoints(idx, y);
	        var end = orient === 'horizontal' ? getLinePoints(nextIdx, x + width) : getLinePoints(nextIdx, y + height);
	        y += height + gap;
	        data.setItemLayout(idx, {
	          points: start.concat(end.slice().reverse())
	        });
	      }
	    }
	
	    labelLayout(data);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1639);
	
	__webpack_require__(1640);

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(170);
	
	var SeriesModel = __webpack_require__(66);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GaugeSeries = SeriesModel.extend({
	  type: 'series.gauge',
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, ['value']);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    legendHoverLink: true,
	    radius: '75%',
	    startAngle: 225,
	    endAngle: -45,
	    clockwise: true,
	    // 最小值
	    min: 0,
	    // 最大值
	    max: 100,
	    // 分割段数，默认为10
	    splitNumber: 10,
	    // 坐标轴线
	    axisLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      lineStyle: {
	        // 属性lineStyle控制线条样式
	        color: [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
	        width: 30
	      }
	    },
	    // 分隔线
	    splitLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      // 属性length控制线长
	      length: 30,
	      // 属性lineStyle（详见lineStyle）控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 2,
	        type: 'solid'
	      }
	    },
	    // 坐标轴小标记
	    axisTick: {
	      // 属性show控制显示与否，默认不显示
	      show: true,
	      // 每份split细分多少段
	      splitNumber: 5,
	      // 属性length控制线长
	      length: 8,
	      // 属性lineStyle控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    axisLabel: {
	      show: true,
	      distance: 5,
	      // formatter: null,
	      color: 'auto'
	    },
	    pointer: {
	      show: true,
	      length: '80%',
	      width: 8
	    },
	    itemStyle: {
	      color: 'auto'
	    },
	    title: {
	      show: true,
	      // x, y，单位px
	      offsetCenter: [0, '-40%'],
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#333',
	      fontSize: 15
	    },
	    detail: {
	      show: true,
	      backgroundColor: 'rgba(0,0,0,0)',
	      borderWidth: 0,
	      borderColor: '#ccc',
	      width: 100,
	      height: null,
	      // self-adaption
	      padding: [5, 10],
	      // x, y，单位px
	      offsetCenter: [0, '40%'],
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: 'auto',
	      fontSize: 30
	    }
	  }
	});
	var _default = GaugeSeries;
	module.exports = _default;

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var PointerPath = __webpack_require__(1641);
	
	var graphic = __webpack_require__(17);
	
	var ChartView = __webpack_require__(103);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	var round = _number.round;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function parsePosition(seriesModel, api) {
	  var center = seriesModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  var size = Math.min(width, height);
	  var cx = parsePercent(center[0], api.getWidth());
	  var cy = parsePercent(center[1], api.getHeight());
	  var r = parsePercent(seriesModel.get('radius'), size / 2);
	  return {
	    cx: cx,
	    cy: cy,
	    r: r
	  };
	}
	
	function formatLabel(label, labelFormatter) {
	  if (labelFormatter) {
	    if (typeof labelFormatter === 'string') {
	      label = labelFormatter.replace('{value}', label != null ? label : '');
	    } else if (typeof labelFormatter === 'function') {
	      label = labelFormatter(label);
	    }
	  }
	
	  return label;
	}
	
	var PI2 = Math.PI * 2;
	var GaugeView = ChartView.extend({
	  type: 'gauge',
	  render: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	    var colorList = seriesModel.get('axisLine.lineStyle.color');
	    var posInfo = parsePosition(seriesModel, api);
	
	    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
	  },
	  dispose: function () {},
	  _renderMain: function (seriesModel, ecModel, api, colorList, posInfo) {
	    var group = this.group;
	    var axisLineModel = seriesModel.getModel('axisLine');
	    var lineStyleModel = axisLineModel.getModel('lineStyle');
	    var clockwise = seriesModel.get('clockwise');
	    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
	    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
	    var angleRangeSpan = (endAngle - startAngle) % PI2;
	    var prevEndAngle = startAngle;
	    var axisLineWidth = lineStyleModel.get('width');
	    var showAxis = axisLineModel.get('show');
	
	    for (var i = 0; showAxis && i < colorList.length; i++) {
	      // Clamp
	      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
	      var endAngle = startAngle + angleRangeSpan * percent;
	      var sector = new graphic.Sector({
	        shape: {
	          startAngle: prevEndAngle,
	          endAngle: endAngle,
	          cx: posInfo.cx,
	          cy: posInfo.cy,
	          clockwise: clockwise,
	          r0: posInfo.r - axisLineWidth,
	          r: posInfo.r
	        },
	        silent: true
	      });
	      sector.setStyle({
	        fill: colorList[i][1]
	      });
	      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
	      // so the properties for stroking are useless
	      ['color', 'borderWidth', 'borderColor']));
	      group.add(sector);
	      prevEndAngle = endAngle;
	    }
	
	    var getColor = function (percent) {
	      // Less than 0
	      if (percent <= 0) {
	        return colorList[0][1];
	      }
	
	      for (var i = 0; i < colorList.length; i++) {
	        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
	          return colorList[i][1];
	        }
	      } // More than 1
	
	
	      return colorList[i - 1][1];
	    };
	
	    if (!clockwise) {
	      var tmp = startAngle;
	      startAngle = endAngle;
	      endAngle = tmp;
	    }
	
	    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);
	
	    this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
	  },
	  _renderTicks: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var cx = posInfo.cx;
	    var cy = posInfo.cy;
	    var r = posInfo.r;
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	    var splitLineModel = seriesModel.getModel('splitLine');
	    var tickModel = seriesModel.getModel('axisTick');
	    var labelModel = seriesModel.getModel('axisLabel');
	    var splitNumber = seriesModel.get('splitNumber');
	    var subSplitNumber = tickModel.get('splitNumber');
	    var splitLineLen = parsePercent(splitLineModel.get('length'), r);
	    var tickLen = parsePercent(tickModel.get('length'), r);
	    var angle = startAngle;
	    var step = (endAngle - startAngle) / splitNumber;
	    var subStep = step / subSplitNumber;
	    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
	    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
	
	    for (var i = 0; i <= splitNumber; i++) {
	      var unitX = Math.cos(angle);
	      var unitY = Math.sin(angle); // Split line
	
	      if (splitLineModel.get('show')) {
	        var splitLine = new graphic.Line({
	          shape: {
	            x1: unitX * r + cx,
	            y1: unitY * r + cy,
	            x2: unitX * (r - splitLineLen) + cx,
	            y2: unitY * (r - splitLineLen) + cy
	          },
	          style: splitLineStyle,
	          silent: true
	        });
	
	        if (splitLineStyle.stroke === 'auto') {
	          splitLine.setStyle({
	            stroke: getColor(i / splitNumber)
	          });
	        }
	
	        group.add(splitLine);
	      } // Label
	
	
	      if (labelModel.get('show')) {
	        var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
	        var distance = labelModel.get('distance');
	        var autoColor = getColor(i / splitNumber);
	        group.add(new graphic.Text({
	          style: graphic.setTextStyle({}, labelModel, {
	            text: label,
	            x: unitX * (r - splitLineLen - distance) + cx,
	            y: unitY * (r - splitLineLen - distance) + cy,
	            textVerticalAlign: unitY < -0.4 ? 'top' : unitY > 0.4 ? 'bottom' : 'middle',
	            textAlign: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
	          }, {
	            autoColor: autoColor
	          }),
	          silent: true
	        }));
	      } // Axis tick
	
	
	      if (tickModel.get('show') && i !== splitNumber) {
	        for (var j = 0; j <= subSplitNumber; j++) {
	          var unitX = Math.cos(angle);
	          var unitY = Math.sin(angle);
	          var tickLine = new graphic.Line({
	            shape: {
	              x1: unitX * r + cx,
	              y1: unitY * r + cy,
	              x2: unitX * (r - tickLen) + cx,
	              y2: unitY * (r - tickLen) + cy
	            },
	            silent: true,
	            style: tickLineStyle
	          });
	
	          if (tickLineStyle.stroke === 'auto') {
	            tickLine.setStyle({
	              stroke: getColor((i + j / subSplitNumber) / splitNumber)
	            });
	          }
	
	          group.add(tickLine);
	          angle += subStep;
	        }
	
	        angle -= subStep;
	      } else {
	        angle += step;
	      }
	    }
	  },
	  _renderPointer: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var oldData = this._data;
	
	    if (!seriesModel.get('pointer.show')) {
	      // Remove old element
	      oldData && oldData.eachItemGraphicEl(function (el) {
	        group.remove(el);
	      });
	      return;
	    }
	
	    var valueExtent = [+seriesModel.get('min'), +seriesModel.get('max')];
	    var angleExtent = [startAngle, endAngle];
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    data.diff(oldData).add(function (idx) {
	      var pointer = new PointerPath({
	        shape: {
	          angle: startAngle
	        }
	      });
	      graphic.initProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, idx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(idx, pointer);
	    }).update(function (newIdx, oldIdx) {
	      var pointer = oldData.getItemGraphicEl(oldIdx);
	      graphic.updateProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, newIdx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(newIdx, pointer);
	    }).remove(function (idx) {
	      var pointer = oldData.getItemGraphicEl(idx);
	      group.remove(pointer);
	    }).execute();
	    data.eachItemGraphicEl(function (pointer, idx) {
	      var itemModel = data.getItemModel(idx);
	      var pointerModel = itemModel.getModel('pointer');
	      pointer.setShape({
	        x: posInfo.cx,
	        y: posInfo.cy,
	        width: parsePercent(pointerModel.get('width'), posInfo.r),
	        r: parsePercent(pointerModel.get('length'), posInfo.r)
	      });
	      pointer.useStyle(itemModel.getModel('itemStyle').getItemStyle());
	
	      if (pointer.style.fill === 'auto') {
	        pointer.setStyle('fill', getColor(linearMap(data.get(valueDim, idx), valueExtent, [0, 1], true)));
	      }
	
	      graphic.setHoverStyle(pointer, itemModel.getModel('emphasis.itemStyle').getItemStyle());
	    });
	    this._data = data;
	  },
	  _renderTitle: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var titleModel = seriesModel.getModel('title');
	
	    if (titleModel.get('show')) {
	      var offsetCenter = titleModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var minVal = +seriesModel.get('min');
	      var maxVal = +seriesModel.get('max');
	      var value = seriesModel.getData().get(valueDim, 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, titleModel, {
	          x: x,
	          y: y,
	          // FIXME First data name ?
	          text: data.getName(0),
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  },
	  _renderDetail: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var detailModel = seriesModel.getModel('detail');
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	
	    if (detailModel.get('show')) {
	      var offsetCenter = detailModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var width = parsePercent(detailModel.get('width'), posInfo.r);
	      var height = parsePercent(detailModel.get('height'), posInfo.r);
	      var data = seriesModel.getData();
	      var value = data.get(data.mapDimension('value'), 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, detailModel, {
	          x: x,
	          y: y,
	          text: formatLabel( // FIXME First data name ?
	          value, detailModel.get('formatter')),
	          textWidth: isNaN(width) ? null : width,
	          textHeight: isNaN(height) ? null : height,
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  }
	});
	var _default = GaugeView;
	module.exports = _default;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(55);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Path.extend({
	  type: 'echartsGaugePointer',
	  shape: {
	    angle: 0,
	    width: 10,
	    r: 10,
	    x: 0,
	    y: 0
	  },
	  buildPath: function (ctx, shape) {
	    var mathCos = Math.cos;
	    var mathSin = Math.sin;
	    var r = shape.r;
	    var width = shape.width;
	    var angle = shape.angle;
	    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
	    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
	    angle = shape.angle - Math.PI / 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
	    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
	    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
	    ctx.lineTo(x, y);
	    return;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1643);
	
	__webpack_require__(1644);
	
	__webpack_require__(1653);
	
	var categoryFilter = __webpack_require__(1646);
	
	var visualSymbol = __webpack_require__(145);
	
	var categoryVisual = __webpack_require__(1647);
	
	var edgeVisual = __webpack_require__(1650);
	
	var simpleLayout = __webpack_require__(1654);
	
	var circularLayout = __webpack_require__(1648);
	
	var forceLayout = __webpack_require__(1652);
	
	var createView = __webpack_require__(1649);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor(categoryFilter);
	echarts.registerVisual(visualSymbol('graph', 'circle', null));
	echarts.registerVisual(categoryVisual);
	echarts.registerVisual(edgeVisual);
	echarts.registerLayout(simpleLayout);
	echarts.registerLayout(echarts.PRIORITY.VISUAL.POST_CHART_LAYOUT, circularLayout);
	echarts.registerLayout(forceLayout); // Graph view coordinate system
	
	echarts.registerCoordinateSystem('graphView', {
	  create: createView
	});

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var List = __webpack_require__(88);
	
	var zrUtil = __webpack_require__(2);
	
	var _model = __webpack_require__(27);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var Model = __webpack_require__(57);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var createGraphFromNodeEdge = __webpack_require__(806);
	
	var LegendVisualProvider = __webpack_require__(225);
	
	var _multipleGraphEdgeHelper = __webpack_require__(266);
	
	var initCurvenessList = _multipleGraphEdgeHelper.initCurvenessList;
	var createEdgeMapForCurveness = _multipleGraphEdgeHelper.createEdgeMapForCurveness;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GraphSeries = echarts.extendSeriesModel({
	  type: 'series.graph',
	  init: function (option) {
	    GraphSeries.superApply(this, 'init', arguments);
	    var self = this;
	
	    function getCategoriesData() {
	      return self._categoriesData;
	    } // Provide data for legend select
	
	
	    this.legendVisualProvider = new LegendVisualProvider(getCategoriesData, getCategoriesData);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeOption: function (option) {
	    GraphSeries.superApply(this, 'mergeOption', arguments);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeDefaultAndTheme: function (option) {
	    GraphSeries.superApply(this, 'mergeDefaultAndTheme', arguments);
	    defaultEmphasis(option, ['edgeLabel'], ['show']);
	  },
	  getInitialData: function (option, ecModel) {
	    var edges = option.edges || option.links || [];
	    var nodes = option.data || option.nodes || [];
	    var self = this;
	
	    if (nodes && edges) {
	      // auto curveness
	      initCurvenessList(this);
	      var graph = createGraphFromNodeEdge(nodes, edges, this, true, beforeLink);
	      zrUtil.each(graph.edges, function (edge) {
	        createEdgeMapForCurveness(edge.node1, edge.node2, this, edge.dataIndex);
	      }, this);
	      return graph.data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      // Overwrite nodeData.getItemModel to
	      nodeData.wrapMethod('getItemModel', function (model) {
	        var categoriesModels = self._categoriesModels;
	        var categoryIdx = model.getShallow('category');
	        var categoryModel = categoriesModels[categoryIdx];
	
	        if (categoryModel) {
	          categoryModel.parentModel = model.parentModel;
	          model.parentModel = categoryModel;
	        }
	
	        return model;
	      });
	      var edgeLabelModel = self.getModel('edgeLabel'); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.
	
	      var fakeSeriesModel = new Model({
	        label: edgeLabelModel.option
	      }, edgeLabelModel.parentModel, ecModel);
	      var emphasisEdgeLabelModel = self.getModel('emphasis.edgeLabel');
	      var emphasisFakeSeriesModel = new Model({
	        emphasis: {
	          label: emphasisEdgeLabelModel.option
	        }
	      }, emphasisEdgeLabelModel.parentModel, ecModel);
	      edgeData.wrapMethod('getItemModel', function (model) {
	        model.customizeGetParent(edgeGetParent);
	        return model;
	      });
	
	      function edgeGetParent(path) {
	        path = this.parsePath(path);
	        return path && path[0] === 'label' ? fakeSeriesModel : path && path[0] === 'emphasis' && path[1] === 'label' ? emphasisFakeSeriesModel : this.parentModel;
	      }
	    }
	  },
	
	  /**
	   * @return {module:echarts/data/Graph}
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getCategoriesData: function () {
	    return this._categoriesData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    if (dataType === 'edge') {
	      var nodeData = this.getData();
	      var params = this.getDataParams(dataIndex, dataType);
	      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
	      var sourceName = nodeData.getName(edge.node1.dataIndex);
	      var targetName = nodeData.getName(edge.node2.dataIndex);
	      var html = [];
	      sourceName != null && html.push(sourceName);
	      targetName != null && html.push(targetName);
	      html = encodeHTML(html.join(' > '));
	
	      if (params.value) {
	        html += ' : ' + encodeHTML(params.value);
	      }
	
	      return html;
	    } else {
	      // dataType === 'node' or empty
	      return GraphSeries.superApply(this, 'formatTooltip', arguments);
	    }
	  },
	  _updateCategoriesData: function () {
	    var categories = zrUtil.map(this.option.categories || [], function (category) {
	      // Data must has value
	      return category.value != null ? category : zrUtil.extend({
	        value: 0
	      }, category);
	    });
	    var categoriesData = new List(['value'], this);
	    categoriesData.initData(categories);
	    this._categoriesData = categoriesData;
	    this._categoriesModels = categoriesData.mapArray(function (idx) {
	      return categoriesData.getItemModel(idx, true);
	    });
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  isAnimationEnabled: function () {
	    return GraphSeries.superCall(this, 'isAnimationEnabled') // Not enable animation when do force layout
	    && !(this.get('layout') === 'force' && this.get('force.layoutAnimation'));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // Default option for all coordinate systems
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // geoIndex: 0,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    layout: null,
	    focusNodeAdjacency: false,
	    // Configuration of circular layout
	    circular: {
	      rotateLabel: false
	    },
	    // Configuration of force directed layout
	    force: {
	      initLayout: null,
	      // Node repulsion. Can be an array to represent range.
	      repulsion: [0, 50],
	      gravity: 0.1,
	      // Initial friction
	      friction: 0.6,
	      // Edge length. Can be an array to represent range.
	      edgeLength: 30,
	      layoutAnimation: true
	    },
	    left: 'center',
	    top: 'center',
	    // right: null,
	    // bottom: null,
	    // width: '80%',
	    // height: '80%',
	    symbol: 'circle',
	    symbolSize: 10,
	    edgeSymbol: ['none', 'none'],
	    edgeSymbolSize: 10,
	    edgeLabel: {
	      position: 'middle',
	      distance: 5
	    },
	    draggable: false,
	    roam: false,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.6,
	    // cursor: null,
	    // categories: [],
	    // data: []
	    // Or
	    // nodes: []
	    //
	    // links: []
	    // Or
	    // edges: []
	    label: {
	      show: false,
	      formatter: '{b}'
	    },
	    itemStyle: {},
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      opacity: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = GraphSeries;
	module.exports = _default;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var SymbolDraw = __webpack_require__(214);
	
	var LineDraw = __webpack_require__(413);
	
	var RoamController = __webpack_require__(218);
	
	var roamHelper = __webpack_require__(421);
	
	var _cursorHelper = __webpack_require__(269);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(17);
	
	var adjustEdge = __webpack_require__(1645);
	
	var _graphHelper = __webpack_require__(411);
	
	var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FOCUS_ADJACENCY = '__focusNodeAdjacency';
	var UNFOCUS_ADJACENCY = '__unfocusNodeAdjacency';
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  var opacity = item.getVisual('opacity');
	  return opacity != null ? opacity : item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (!child.isGroup) {
	      var opct = child.lineLabelOriginalOpacity;
	
	      if (opct == null || opacityRatio != null) {
	        opct = opacity;
	      }
	
	      child.setStyle('opacity', opct);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl(); // Should go back to normal opacity first, consider hoverLayer,
	  // where current state is copied to elMirror, and support
	  // emphasis opacity here.
	
	  el.traverse(function (child) {
	    !child.isGroup && child.setStyle('opacity', opacity);
	  });
	  el.highlight && el.highlight();
	}
	
	var _default = echarts.extendChartView({
	  type: 'graph',
	  init: function (ecModel, api) {
	    var symbolDraw = new SymbolDraw();
	    var lineDraw = new LineDraw();
	    var group = this.group;
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: group
	    };
	    group.add(symbolDraw.group);
	    group.add(lineDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineDraw = lineDraw;
	    this._firstRender = true;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var graphView = this;
	    var coordSys = seriesModel.coordinateSystem;
	    this._model = seriesModel;
	    var symbolDraw = this._symbolDraw;
	    var lineDraw = this._lineDraw;
	    var group = this.group;
	
	    if (coordSys.type === 'view') {
	      var groupNewProp = {
	        position: coordSys.position,
	        scale: coordSys.scale
	      };
	
	      if (this._firstRender) {
	        group.attr(groupNewProp);
	      } else {
	        graphic.updateProps(group, groupNewProp, seriesModel);
	      }
	    } // Fix edge contact point with node
	
	
	    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	    var data = seriesModel.getData();
	    symbolDraw.updateData(data);
	    var edgeData = seriesModel.getEdgeData();
	    lineDraw.updateData(edgeData);
	
	    this._updateNodeAndLinkScale();
	
	    this._updateController(seriesModel, ecModel, api);
	
	    clearTimeout(this._layoutTimeout);
	    var forceLayout = seriesModel.forceLayout;
	    var layoutAnimation = seriesModel.get('force.layoutAnimation');
	
	    if (forceLayout) {
	      this._startForceLayoutIteration(forceLayout, layoutAnimation);
	    }
	
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx); // Update draggable
	
	      el.off('drag').off('dragend');
	      var draggable = itemModel.get('draggable');
	
	      if (draggable) {
	        el.on('drag', function () {
	          if (forceLayout) {
	            forceLayout.warmUp();
	            !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
	            forceLayout.setFixed(idx); // Write position back to layout
	
	            data.setItemLayout(idx, el.position);
	          }
	        }, this).on('dragend', function () {
	          if (forceLayout) {
	            forceLayout.setUnfixed(idx);
	          }
	        }, this);
	      }
	
	      el.setDraggable(draggable && forceLayout);
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          graphView._clearTimer();
	
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            dataIndex: el.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          graphView._dispatchUnfocus(api);
	        });
	      }
	    }, this);
	    data.graph.eachEdge(function (edge) {
	      var el = edge.getGraphicEl();
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (edge.getModel().get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          graphView._clearTimer();
	
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            edgeDataIndex: edge.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          graphView._dispatchUnfocus(api);
	        });
	      }
	    });
	    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get('circular.rotateLabel');
	    var cx = data.getLayout('cx');
	    var cy = data.getLayout('cy');
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx);
	      var labelRotate = itemModel.get('label.rotate') || 0;
	      var symbolPath = el.getSymbolPath();
	
	      if (circularRotateLabel) {
	        var pos = data.getItemLayout(idx);
	        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
	
	        if (rad < 0) {
	          rad = Math.PI * 2 + rad;
	        }
	
	        var isLeft = pos[0] < cx;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	
	        var textPosition = isLeft ? 'left' : 'right';
	        graphic.modifyLabelStyle(symbolPath, {
	          textRotation: -rad,
	          textPosition: textPosition,
	          textOrigin: 'center'
	        }, {
	          textPosition: textPosition
	        });
	      } else {
	        graphic.modifyLabelStyle(symbolPath, {
	          textRotation: labelRotate *= Math.PI / 180
	        });
	      }
	    });
	    this._firstRender = false;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	
	    this._clearTimer();
	  },
	  _dispatchUnfocus: function (api, opt) {
	    var self = this;
	
	    this._clearTimer();
	
	    this._unfocusDelayTimer = setTimeout(function () {
	      self._unfocusDelayTimer = null;
	      api.dispatchAction({
	        type: 'unfocusNodeAdjacency',
	        seriesId: self._model.id
	      });
	    }, 500);
	  },
	  _clearTimer: function () {
	    if (this._unfocusDelayTimer) {
	      clearTimeout(this._unfocusDelayTimer);
	      this._unfocusDelayTimer = null;
	    }
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var edgeDataIndex = payload.edgeDataIndex;
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	
	    if (!node && !edge) {
	      return;
	    }
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, nodeOpacityPath);
	      zrUtil.each(node.edges, function (adjacentEdge) {
	        if (adjacentEdge.dataIndex < 0) {
	          return;
	        }
	
	        fadeInItem(adjacentEdge, lineOpacityPath);
	        fadeInItem(adjacentEdge.node1, nodeOpacityPath);
	        fadeInItem(adjacentEdge.node2, nodeOpacityPath);
	      });
	    }
	
	    if (edge) {
	      fadeInItem(edge, lineOpacityPath);
	      fadeInItem(edge.node1, nodeOpacityPath);
	      fadeInItem(edge.node2, nodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = seriesModel.getData().graph;
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  },
	  _startForceLayoutIteration: function (forceLayout, layoutAnimation) {
	    var self = this;
	
	    (function step() {
	      forceLayout.step(function (stopped) {
	        self.updateLayout(self._model);
	        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
	      });
	    })();
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	
	    if (seriesModel.coordinateSystem.type !== 'view') {
	      controller.disable();
	      return;
	    }
	
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale();
	
	      adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	      this._lineDraw.updateLayout();
	    }, this);
	  },
	  _updateNodeAndLinkScale: function () {
	    var seriesModel = this._model;
	    var data = seriesModel.getData();
	    var nodeScale = getNodeGlobalScale(seriesModel);
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  updateLayout: function (seriesModel) {
	    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	    this._symbolDraw.updateLayout();
	
	    this._lineDraw.updateLayout();
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove();
	    this._lineDraw && this._lineDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var curveTool = __webpack_require__(134);
	
	var vec2 = __webpack_require__(49);
	
	var _graphHelper = __webpack_require__(411);
	
	var getSymbolSize = _graphHelper.getSymbolSize;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var v1 = [];
	var v2 = [];
	var v3 = [];
	var quadraticAt = curveTool.quadraticAt;
	var v2DistSquare = vec2.distSquare;
	var mathAbs = Math.abs;
	
	function intersectCurveCircle(curvePoints, center, radius) {
	  var p0 = curvePoints[0];
	  var p1 = curvePoints[1];
	  var p2 = curvePoints[2];
	  var d = Infinity;
	  var t;
	  var radiusSquare = radius * radius;
	  var interval = 0.1;
	
	  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
	    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
	    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
	    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);
	
	    if (diff < d) {
	      d = diff;
	      t = _t;
	    }
	  } // Assume the segment is monotone，Find root through Bisection method
	  // At most 32 iteration
	
	
	  for (var i = 0; i < 32; i++) {
	    // var prev = t - interval;
	    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
	    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
	
	    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
	    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
	    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
	    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
	    var diff = v2DistSquare(v2, center) - radiusSquare;
	
	    if (mathAbs(diff) < 1e-2) {
	      break;
	    } // var prevDiff = v2DistSquare(v1, center) - radiusSquare;
	
	
	    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
	    interval /= 2;
	
	    if (diff < 0) {
	      if (nextDiff >= 0) {
	        t = t + interval;
	      } else {
	        t = t - interval;
	      }
	    } else {
	      if (nextDiff >= 0) {
	        t = t - interval;
	      } else {
	        t = t + interval;
	      }
	    }
	  }
	
	  return t;
	} // Adjust edge to avoid
	
	
	function _default(graph, scale) {
	  var tmp0 = [];
	  var quadraticSubdivide = curveTool.quadraticSubdivide;
	  var pts = [[], [], []];
	  var pts2 = [[], []];
	  var v = [];
	  scale /= 2;
	  graph.eachEdge(function (edge, idx) {
	    var linePoints = edge.getLayout();
	    var fromSymbol = edge.getVisual('fromSymbol');
	    var toSymbol = edge.getVisual('toSymbol');
	
	    if (!linePoints.__original) {
	      linePoints.__original = [vec2.clone(linePoints[0]), vec2.clone(linePoints[1])];
	
	      if (linePoints[2]) {
	        linePoints.__original.push(vec2.clone(linePoints[2]));
	      }
	    }
	
	    var originalPoints = linePoints.__original; // Quadratic curve
	
	    if (linePoints[2] != null) {
	      vec2.copy(pts[0], originalPoints[0]);
	      vec2.copy(pts[1], originalPoints[2]);
	      vec2.copy(pts[2], originalPoints[1]);
	
	      if (fromSymbol && fromSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node1);
	        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[0][0] = tmp0[3];
	        pts[1][0] = tmp0[4];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[0][1] = tmp0[3];
	        pts[1][1] = tmp0[4];
	      }
	
	      if (toSymbol && toSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node2);
	        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[1][0] = tmp0[1];
	        pts[2][0] = tmp0[2];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[1][1] = tmp0[1];
	        pts[2][1] = tmp0[2];
	      } // Copy back to layout
	
	
	      vec2.copy(linePoints[0], pts[0]);
	      vec2.copy(linePoints[1], pts[2]);
	      vec2.copy(linePoints[2], pts[1]);
	    } // Line
	    else {
	        vec2.copy(pts2[0], originalPoints[0]);
	        vec2.copy(pts2[1], originalPoints[1]);
	        vec2.sub(v, pts2[1], pts2[0]);
	        vec2.normalize(v, v);
	
	        if (fromSymbol && fromSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node1);
	          vec2.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
	        }
	
	        if (toSymbol && toSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node2);
	          vec2.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
	        }
	
	        vec2.copy(linePoints[0], pts2[0]);
	        vec2.copy(linePoints[1], pts2[1]);
	      }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (!legendModels || !legendModels.length) {
	    return;
	  }
	
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var categoriesData = graphSeries.getCategoriesData();
	    var graph = graphSeries.getGraph();
	    var data = graph.data;
	    var categoryNames = categoriesData.mapArray(categoriesData.getName);
	    data.filterSelf(function (idx) {
	      var model = data.getItemModel(idx);
	      var category = model.getShallow('category');
	
	      if (category != null) {
	        if (typeof category === 'number') {
	          category = categoryNames[category];
	        } // If in any legend component the status is not selected.
	
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(category)) {
	            return false;
	          }
	        }
	      }
	
	      return true;
	    });
	  }, this);
	}
	
	module.exports = _default;

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var paletteScope = {};
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var categoriesData = seriesModel.getCategoriesData();
	    var data = seriesModel.getData();
	    var categoryNameIdxMap = {};
	    categoriesData.each(function (idx) {
	      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
	
	      categoryNameIdxMap['ec-' + name] = idx;
	      var itemModel = categoriesData.getItemModel(idx);
	      var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(name, paletteScope);
	      categoriesData.setItemVisual(idx, 'color', color);
	      var itemStyleList = ['opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];
	
	      for (var i = 0; i < itemStyleList.length; i++) {
	        var itemStyle = itemModel.getShallow(itemStyleList[i], true);
	
	        if (itemStyle != null) {
	          categoriesData.setItemVisual(idx, itemStyleList[i], itemStyle);
	        }
	      }
	    }); // Assign category color to visual
	
	    if (categoriesData.count()) {
	      data.each(function (idx) {
	        var model = data.getItemModel(idx);
	        var category = model.getShallow('category');
	
	        if (category != null) {
	          if (typeof category === 'string') {
	            category = categoryNameIdxMap['ec-' + category];
	          }
	
	          var itemStyleList = ['color', 'opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];
	
	          for (var i = 0; i < itemStyleList.length; i++) {
	            if (data.getItemVisual(idx, itemStyleList[i], true) == null) {
	              data.setItemVisual(idx, itemStyleList[i], categoriesData.getItemVisual(category, itemStyleList[i]));
	            }
	          }
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _circularLayoutHelper = __webpack_require__(802);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    if (seriesModel.get('layout') === 'circular') {
	      circularLayout(seriesModel, 'symbolSize');
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var View = __webpack_require__(426);
	
	var _layout = __webpack_require__(47);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var bbox = __webpack_require__(226);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Where to create the simple view coordinate system
	function getViewRect(seriesModel, api, aspect) {
	  var option = seriesModel.getBoxLayoutParams();
	  option.aspect = aspect;
	  return getLayoutRect(option, {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(ecModel, api) {
	  var viewList = [];
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var coordSysType = seriesModel.get('coordinateSystem');
	
	    if (!coordSysType || coordSysType === 'view') {
	      var data = seriesModel.getData();
	      var positions = data.mapArray(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        return [+itemModel.get('x'), +itemModel.get('y')];
	      });
	      var min = [];
	      var max = [];
	      bbox.fromPoints(positions, min, max); // If width or height is 0
	
	      if (max[0] - min[0] === 0) {
	        max[0] += 1;
	        min[0] -= 1;
	      }
	
	      if (max[1] - min[1] === 0) {
	        max[1] += 1;
	        min[1] -= 1;
	      }
	
	      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?
	
	      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead
	
	      if (isNaN(aspect)) {
	        min = [viewRect.x, viewRect.y];
	        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
	      }
	
	      var bbWidth = max[0] - min[0];
	      var bbHeight = max[1] - min[1];
	      var viewWidth = viewRect.width;
	      var viewHeight = viewRect.height;
	      var viewCoordSys = seriesModel.coordinateSystem = new View();
	      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
	      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info
	
	      viewCoordSys.setCenter(seriesModel.get('center'));
	      viewCoordSys.setZoom(seriesModel.get('zoom'));
	      viewList.push(viewCoordSys);
	    }
	  });
	  return viewList;
	}
	
	module.exports = _default;

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var edgeData = seriesModel.getEdgeData();
	    var symbolType = normalize(seriesModel.get('edgeSymbol'));
	    var symbolSize = normalize(seriesModel.get('edgeSymbolSize'));
	    var colorQuery = 'lineStyle.color'.split('.');
	    var opacityQuery = 'lineStyle.opacity'.split('.');
	    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
	    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
	    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    edgeData.setVisual('color', seriesModel.get(colorQuery));
	    edgeData.setVisual('opacity', seriesModel.get(opacityQuery));
	    edgeData.each(function (idx) {
	      var itemModel = edgeData.getItemModel(idx);
	      var edge = graph.getEdgeByIndex(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual
	
	      var color = itemModel.get(colorQuery);
	      var opacity = itemModel.get(opacityQuery);
	
	      switch (color) {
	        case 'source':
	          color = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          color = edge.node2.getVisual('color');
	          break;
	      }
	
	      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
	      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
	      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
	      edge.setVisual('color', color);
	      edge.setVisual('opacity', opacity);
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(49);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* Some formulas were originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment of the method "step" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var scaleAndAdd = vec2.scaleAndAdd; // function adjacentNode(n, e) {
	//     return e.n1 === n ? e.n2 : e.n1;
	// }
	
	function forceLayout(nodes, edges, opts) {
	  var rect = opts.rect;
	  var width = rect.width;
	  var height = rect.height;
	  var center = [rect.x + width / 2, rect.y + height / 2]; // var scale = opts.scale || 1;
	
	  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
	  //     var e = edges[i];
	  //     var n1 = e.n1;
	  //     var n2 = e.n2;
	  //     n1.edges = n1.edges || [];
	  //     n2.edges = n2.edges || [];
	  //     n1.edges.push(e);
	  //     n2.edges.push(e);
	  // }
	  // Init position
	
	  for (var i = 0; i < nodes.length; i++) {
	    var n = nodes[i];
	
	    if (!n.p) {
	      n.p = vec2.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
	    }
	
	    n.pp = vec2.clone(n.p);
	    n.edges = null;
	  } // Formula in 'Graph Drawing by Force-directed Placement'
	  // var k = scale * Math.sqrt(width * height / nodes.length);
	  // var k2 = k * k;
	
	
	  var initialFriction = opts.friction == null ? 0.6 : opts.friction;
	  var friction = initialFriction;
	  return {
	    warmUp: function () {
	      friction = initialFriction * 0.8;
	    },
	    setFixed: function (idx) {
	      nodes[idx].fixed = true;
	    },
	    setUnfixed: function (idx) {
	      nodes[idx].fixed = false;
	    },
	
	    /**
	     * Some formulas were originally copied from "d3.js"
	     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
	     * with some modifications made for this project.
	     * See the license statement at the head of this file.
	     */
	    step: function (cb) {
	      var v12 = [];
	      var nLen = nodes.length;
	
	      for (var i = 0; i < edges.length; i++) {
	        var e = edges[i];
	
	        if (e.ignoreForceLayout) {
	          continue;
	        }
	
	        var n1 = e.n1;
	        var n2 = e.n2;
	        vec2.sub(v12, n2.p, n1.p);
	        var d = vec2.len(v12) - e.d;
	        var w = n2.w / (n1.w + n2.w);
	
	        if (isNaN(w)) {
	          w = 0;
	        }
	
	        vec2.normalize(v12, v12);
	        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
	        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
	      } // Gravity
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v12, center, n.p); // var d = vec2.len(v12);
	          // vec2.scale(v12, v12, 1 / d);
	          // var gravityFactor = gravity;
	
	          scaleAndAdd(n.p, n.p, v12, gravity * friction);
	        }
	      } // Repulsive
	      // PENDING
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n1 = nodes[i];
	
	        for (var j = i + 1; j < nLen; j++) {
	          var n2 = nodes[j];
	          vec2.sub(v12, n2.p, n1.p);
	          var d = vec2.len(v12);
	
	          if (d === 0) {
	            // Random repulse
	            vec2.set(v12, Math.random() - 0.5, Math.random() - 0.5);
	            d = 1;
	          }
	
	          var repFact = (n1.rep + n2.rep) / d / d;
	          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
	          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
	        }
	      }
	
	      var v = [];
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v, n.p, n.pp);
	          scaleAndAdd(n.p, n.p, v, friction);
	          vec2.copy(n.pp, n.p);
	        }
	      }
	
	      friction = friction * 0.992;
	      cb && cb(nodes, edges, friction < 0.01);
	    }
	  };
	}
	
	exports.forceLayout = forceLayout;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _forceHelper = __webpack_require__(1651);
	
	var forceLayout = _forceHelper.forceLayout;
	
	var _simpleLayoutHelper = __webpack_require__(803);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	
	var _circularLayoutHelper = __webpack_require__(802);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	var _number = __webpack_require__(24);
	
	var linearMap = _number.linearMap;
	
	var vec2 = __webpack_require__(49);
	
	var zrUtil = __webpack_require__(2);
	
	var _multipleGraphEdgeHelper = __webpack_require__(266);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var coordSys = graphSeries.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      return;
	    }
	
	    if (graphSeries.get('layout') === 'force') {
	      var preservedPoints = graphSeries.preservedPoints || {};
	      var graph = graphSeries.getGraph();
	      var nodeData = graph.data;
	      var edgeData = graph.edgeData;
	      var forceModel = graphSeries.getModel('force');
	      var initLayout = forceModel.get('initLayout');
	
	      if (graphSeries.preservedPoints) {
	        nodeData.each(function (idx) {
	          var id = nodeData.getId(idx);
	          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
	        });
	      } else if (!initLayout || initLayout === 'none') {
	        simpleLayout(graphSeries);
	      } else if (initLayout === 'circular') {
	        circularLayout(graphSeries, 'value');
	      }
	
	      var nodeDataExtent = nodeData.getDataExtent('value');
	      var edgeDataExtent = edgeData.getDataExtent('value'); // var edgeDataExtent = edgeData.getDataExtent('value');
	
	      var repulsion = forceModel.get('repulsion');
	      var edgeLength = forceModel.get('edgeLength');
	
	      if (!zrUtil.isArray(repulsion)) {
	        repulsion = [repulsion, repulsion];
	      }
	
	      if (!zrUtil.isArray(edgeLength)) {
	        edgeLength = [edgeLength, edgeLength];
	      } // Larger value has smaller length
	
	
	      edgeLength = [edgeLength[1], edgeLength[0]];
	      var nodes = nodeData.mapArray('value', function (value, idx) {
	        var point = nodeData.getItemLayout(idx);
	        var rep = linearMap(value, nodeDataExtent, repulsion);
	
	        if (isNaN(rep)) {
	          rep = (repulsion[0] + repulsion[1]) / 2;
	        }
	
	        return {
	          w: rep,
	          rep: rep,
	          fixed: nodeData.getItemModel(idx).get('fixed'),
	          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
	        };
	      });
	      var edges = edgeData.mapArray('value', function (value, idx) {
	        var edge = graph.getEdgeByIndex(idx);
	        var d = linearMap(value, edgeDataExtent, edgeLength);
	
	        if (isNaN(d)) {
	          d = (edgeLength[0] + edgeLength[1]) / 2;
	        }
	
	        var edgeModel = edge.getModel();
	        var curveness = zrUtil.retrieve3(edgeModel.get('lineStyle.curveness'), -getCurvenessForEdge(edge, graphSeries, idx, true), 0);
	        return {
	          n1: nodes[edge.node1.dataIndex],
	          n2: nodes[edge.node2.dataIndex],
	          d: d,
	          curveness: curveness,
	          ignoreForceLayout: edgeModel.get('ignoreForceLayout')
	        };
	      });
	      var coordSys = graphSeries.coordinateSystem;
	      var rect = coordSys.getBoundingRect();
	      var forceInstance = forceLayout(nodes, edges, {
	        rect: rect,
	        gravity: forceModel.get('gravity'),
	        friction: forceModel.get('friction')
	      });
	      var oldStep = forceInstance.step;
	
	      forceInstance.step = function (cb) {
	        for (var i = 0, l = nodes.length; i < l; i++) {
	          if (nodes[i].fixed) {
	            // Write back to layout instance
	            vec2.copy(nodes[i].p, graph.getNodeByIndex(i).getLayout());
	          }
	        }
	
	        oldStep(function (nodes, edges, stopped) {
	          for (var i = 0, l = nodes.length; i < l; i++) {
	            if (!nodes[i].fixed) {
	              graph.getNodeByIndex(i).setLayout(nodes[i].p);
	            }
	
	            preservedPoints[nodeData.getId(i)] = nodes[i].p;
	          }
	
	          for (var i = 0, l = edges.length; i < l; i++) {
	            var e = edges[i];
	            var edge = graph.getEdgeByIndex(i);
	            var p1 = e.n1.p;
	            var p2 = e.n2.p;
	            var points = edge.getLayout();
	            points = points ? points.slice() : [];
	            points[0] = points[0] || [];
	            points[1] = points[1] || [];
	            vec2.copy(points[0], p1);
	            vec2.copy(points[1], p2);
	
	            if (+e.curveness) {
	              points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
	            }
	
	            edge.setLayout(points);
	          } // Update layout
	
	
	          cb && cb(stopped);
	        });
	      };
	
	      graphSeries.forceLayout = forceInstance;
	      graphSeries.preservedPoints = preservedPoints; // Step to get the layout
	
	      forceInstance.step();
	    } else {
	      // Remove prev injected forceLayout instance
	      graphSeries.forceLayout = null;
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var _roamHelper = __webpack_require__(410);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	__webpack_require__(807);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'graphRoam',
	  event: 'graphRoam',
	  update: 'none'
	};
	/**
	 * @payload
	 * @property {string} name Series name
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	
	var _simpleLayoutHelper = __webpack_require__(803);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	var simpleLayoutEdge = _simpleLayoutHelper.simpleLayoutEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var layout = seriesModel.get('layout');
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      var data = seriesModel.getData();
	      var dimensions = [];
	      each(coordSys.dimensions, function (coordDim) {
	        dimensions = dimensions.concat(data.mapDimension(coordDim, true));
	      });
	
	      for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	        var value = [];
	        var hasValue = false;
	
	        for (var i = 0; i < dimensions.length; i++) {
	          var val = data.get(dimensions[i], dataIndex);
	
	          if (!isNaN(val)) {
	            hasValue = true;
	          }
	
	          value.push(val);
	        }
	
	        if (hasValue) {
	          data.setItemLayout(dataIndex, coordSys.dataToPoint(value));
	        } else {
	          // Also {Array.<number>}, not undefined to avoid if...else... statement
	          data.setItemLayout(dataIndex, [NaN, NaN]);
	        }
	      }
	
	      simpleLayoutEdge(data.graph, seriesModel);
	    } else if (!layout || layout === 'none') {
	      simpleLayout(seriesModel);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1657);
	
	__webpack_require__(1658);

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8ClampedArray */
	var GRADIENT_LEVELS = 256;
	/**
	 * Heatmap Chart
	 *
	 * @class
	 */
	
	function Heatmap() {
	  var canvas = zrUtil.createCanvas();
	  this.canvas = canvas;
	  this.blurSize = 30;
	  this.pointSize = 20;
	  this.maxOpacity = 1;
	  this.minOpacity = 0;
	  this._gradientPixels = {};
	}
	
	Heatmap.prototype = {
	  /**
	   * Renders Heatmap and returns the rendered canvas
	   * @param {Array} data array of data, each has x, y, value
	   * @param {number} width canvas width
	   * @param {number} height canvas height
	   */
	  update: function (data, width, height, normalize, colorFunc, isInRange) {
	    var brush = this._getBrush();
	
	    var gradientInRange = this._getGradient(data, colorFunc, 'inRange');
	
	    var gradientOutOfRange = this._getGradient(data, colorFunc, 'outOfRange');
	
	    var r = this.pointSize + this.blurSize;
	    var canvas = this.canvas;
	    var ctx = canvas.getContext('2d');
	    var len = data.length;
	    canvas.width = width;
	    canvas.height = height;
	
	    for (var i = 0; i < len; ++i) {
	      var p = data[i];
	      var x = p[0];
	      var y = p[1];
	      var value = p[2]; // calculate alpha using value
	
	      var alpha = normalize(value); // draw with the circle brush with alpha
	
	      ctx.globalAlpha = alpha;
	      ctx.drawImage(brush, x - r, y - r);
	    }
	
	    if (!canvas.width || !canvas.height) {
	      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
	      // 'CanvasRenderingContext2D': The source height is 0."
	      return canvas;
	    } // colorize the canvas using alpha value and set with gradient
	
	
	    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	    var pixels = imageData.data;
	    var offset = 0;
	    var pixelLen = pixels.length;
	    var minOpacity = this.minOpacity;
	    var maxOpacity = this.maxOpacity;
	    var diffOpacity = maxOpacity - minOpacity;
	
	    while (offset < pixelLen) {
	      var alpha = pixels[offset + 3] / 256;
	      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data
	
	      if (alpha > 0) {
	        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
	
	        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
	        pixels[offset++] = gradient[gradientOffset];
	        pixels[offset++] = gradient[gradientOffset + 1];
	        pixels[offset++] = gradient[gradientOffset + 2];
	        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
	      } else {
	        offset += 4;
	      }
	    }
	
	    ctx.putImageData(imageData, 0, 0);
	    return canvas;
	  },
	
	  /**
	   * get canvas of a black circle brush used for canvas to draw later
	   * @private
	   * @returns {Object} circle brush canvas
	   */
	  _getBrush: function () {
	    var brushCanvas = this._brushCanvas || (this._brushCanvas = zrUtil.createCanvas()); // set brush size
	
	    var r = this.pointSize + this.blurSize;
	    var d = r * 2;
	    brushCanvas.width = d;
	    brushCanvas.height = d;
	    var ctx = brushCanvas.getContext('2d');
	    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
	    // draw the distinct circle in an invisible place,
	    // and use shadowOffset to draw shadow in the center of the canvas
	
	    ctx.shadowOffsetX = d;
	    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
	    // color in color map
	
	    ctx.shadowColor = '#000'; // draw circle in the left to the canvas
	
	    ctx.beginPath();
	    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    return brushCanvas;
	  },
	
	  /**
	   * get gradient color map
	   * @private
	   */
	  _getGradient: function (data, colorFunc, state) {
	    var gradientPixels = this._gradientPixels;
	    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
	    var color = [0, 0, 0, 0];
	    var off = 0;
	
	    for (var i = 0; i < 256; i++) {
	      colorFunc[state](i / 255, true, color);
	      pixelsSingleState[off++] = color[0];
	      pixelsSingleState[off++] = color[1];
	      pixelsSingleState[off++] = color[2];
	      pixelsSingleState[off++] = color[3];
	    }
	
	    return pixelsSingleState;
	  }
	};
	var _default = Heatmap;
	module.exports = _default;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(66);
	
	var createListFromArray = __webpack_require__(113);
	
	var CoordinateSystem = __webpack_require__(95);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.heatmap',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      generateCoord: 'value'
	    });
	  },
	  preventIncremental: function () {
	    var coordSysCreator = CoordinateSystem.get(this.get('coordinateSystem'));
	
	    if (coordSysCreator && coordSysCreator.dimensions) {
	      return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
	    }
	  },
	  defaultOption: {
	    // Cartesian2D or geo
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Geo coordinate system
	    geoIndex: 0,
	    blurSize: 30,
	    pointSize: 20,
	    maxOpacity: 1,
	    minOpacity: 0
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var graphic = __webpack_require__(17);
	
	var HeatmapLayer = __webpack_require__(1656);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  pieceList = zrUtil.map(pieceList, function (piece) {
	    return {
	      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
	    };
	  });
	  var len = pieceList.length;
	  var lastIndex = 0;
	  return function (val) {
	    // Try to find in the location of the last found
	    for (var i = lastIndex; i < len; i++) {
	      var interval = pieceList[i].interval;
	
	      if (interval[0] <= val && val <= interval[1]) {
	        lastIndex = i;
	        break;
	      }
	    }
	
	    if (i === len) {
	      // Not found, back interation
	      for (var i = lastIndex - 1; i >= 0; i--) {
	        var interval = pieceList[i].interval;
	
	        if (interval[0] <= val && val <= interval[1]) {
	          lastIndex = i;
	          break;
	        }
	      }
	    }
	
	    return i >= 0 && i < len && selected[i];
	  };
	}
	
	function getIsInContinuousRange(dataExtent, range) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
	  return function (val) {
	    return val >= range[0] && val <= range[1];
	  };
	}
	
	function isGeoCoordSys(coordSys) {
	  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended
	
	  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
	}
	
	var _default = echarts.extendChartView({
	  type: 'heatmap',
	  render: function (seriesModel, ecModel, api) {
	    var visualMapOfThisSeries;
	    ecModel.eachComponent('visualMap', function (visualMap) {
	      visualMap.eachTargetSeries(function (targetSeries) {
	        if (targetSeries === seriesModel) {
	          visualMapOfThisSeries = visualMap;
	        }
	      });
	    });
	    this.group.removeAll();
	    this._incrementalDisplayable = null;
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
	      this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
	    } else if (isGeoCoordSys(coordSys)) {
	      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
	    }
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys) {
	      this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
	    }
	  },
	  _renderOnCartesianAndCalendar: function (seriesModel, api, start, end, incremental) {
	    var coordSys = seriesModel.coordinateSystem;
	    var width;
	    var height;
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      width = xAxis.getBandWidth();
	      height = yAxis.getBandWidth();
	    }
	
	    var group = this.group;
	    var data = seriesModel.getData();
	    var itemStyleQuery = 'itemStyle';
	    var hoverItemStyleQuery = 'emphasis.itemStyle';
	    var labelQuery = 'label';
	    var hoverLabelQuery = 'emphasis.label';
	    var style = seriesModel.getModel(itemStyleQuery).getItemStyle(['color']);
	    var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
	    var labelModel = seriesModel.getModel(labelQuery);
	    var hoverLabelModel = seriesModel.getModel(hoverLabelQuery);
	    var coordSysType = coordSys.type;
	    var dataDims = coordSysType === 'cartesian2d' ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];
	
	    for (var idx = start; idx < end; idx++) {
	      var rect;
	
	      if (coordSysType === 'cartesian2d') {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[2], idx))) {
	          continue;
	        }
	
	        var point = coordSys.dataToPoint([data.get(dataDims[0], idx), data.get(dataDims[1], idx)]);
	        rect = new graphic.Rect({
	          shape: {
	            x: Math.floor(Math.round(point[0]) - width / 2),
	            y: Math.floor(Math.round(point[1]) - height / 2),
	            width: Math.ceil(width),
	            height: Math.ceil(height)
	          },
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      } else {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[1], idx))) {
	          continue;
	        }
	
	        rect = new graphic.Rect({
	          z2: 1,
	          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      }
	
	      var itemModel = data.getItemModel(idx); // Optimization for large datset
	
	      if (data.hasItemOption) {
	        style = itemModel.getModel(itemStyleQuery).getItemStyle(['color']);
	        hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
	        labelModel = itemModel.getModel(labelQuery);
	        hoverLabelModel = itemModel.getModel(hoverLabelQuery);
	      }
	
	      var rawValue = seriesModel.getRawValue(idx);
	      var defaultText = '-';
	
	      if (rawValue && rawValue[2] != null) {
	        defaultText = rawValue[2];
	      }
	
	      graphic.setLabelStyle(style, hoverStl, labelModel, hoverLabelModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: idx,
	        defaultText: defaultText,
	        isRectText: true
	      });
	      rect.setStyle(style);
	      graphic.setHoverStyle(rect, data.hasItemOption ? hoverStl : zrUtil.extend({}, hoverStl));
	      rect.incremental = incremental; // PENDING
	
	      if (incremental) {
	        // Rect must use hover layer if it's incremental.
	        rect.useHoverLayer = true;
	      }
	
	      group.add(rect);
	      data.setItemGraphicEl(idx, rect);
	    }
	  },
	  _renderOnGeo: function (geo, seriesModel, visualMapModel, api) {
	    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
	    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
	    //     throw new Error('Data range must have color visuals');
	    // }
	
	    var data = seriesModel.getData();
	    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
	    hmLayer.blurSize = seriesModel.get('blurSize');
	    hmLayer.pointSize = seriesModel.get('pointSize');
	    hmLayer.minOpacity = seriesModel.get('minOpacity');
	    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
	    var rect = geo.getViewRect().clone();
	    var roamTransform = geo.getRoamTransform();
	    rect.applyTransform(roamTransform); // Clamp on viewport
	
	    var x = Math.max(rect.x, 0);
	    var y = Math.max(rect.y, 0);
	    var x2 = Math.min(rect.width + rect.x, api.getWidth());
	    var y2 = Math.min(rect.height + rect.y, api.getHeight());
	    var width = x2 - x;
	    var height = y2 - y;
	    var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
	    var points = data.mapArray(dims, function (lng, lat, value) {
	      var pt = geo.dataToPoint([lng, lat]);
	      pt[0] -= x;
	      pt[1] -= y;
	      pt.push(value);
	      return pt;
	    });
	    var dataExtent = visualMapModel.getExtent();
	    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
	    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
	      inRange: inRangeVisuals.color.getColorMapper(),
	      outOfRange: outOfRangeVisuals.color.getColorMapper()
	    }, isInRange);
	    var img = new graphic.Image({
	      style: {
	        width: width,
	        height: height,
	        x: x,
	        y: y,
	        image: hmLayer.canvas
	      },
	      silent: true
	    });
	    this.group.add(img);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Polyline = __webpack_require__(805);
	
	var zrUtil = __webpack_require__(2);
	
	var EffectLine = __webpack_require__(804);
	
	var vec2 = __webpack_require__(49);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:echarts/chart/helper/EffectLine}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function EffectPolyline(lineData, idx, seriesScope) {
	  EffectLine.call(this, lineData, idx, seriesScope);
	  this._lastFrame = 0;
	  this._lastFramePercent = 0;
	}
	
	var effectPolylineProto = EffectPolyline.prototype; // Overwrite
	
	effectPolylineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Polyline(lineData, idx, seriesScope);
	}; // Overwrite
	
	
	effectPolylineProto.updateAnimationPoints = function (symbol, points) {
	  this._points = points;
	  var accLenArr = [0];
	  var len = 0;
	
	  for (var i = 1; i < points.length; i++) {
	    var p1 = points[i - 1];
	    var p2 = points[i];
	    len += vec2.dist(p1, p2);
	    accLenArr.push(len);
	  }
	
	  if (len === 0) {
	    return;
	  }
	
	  for (var i = 0; i < accLenArr.length; i++) {
	    accLenArr[i] /= len;
	  }
	
	  this._offsets = accLenArr;
	  this._length = len;
	}; // Overwrite
	
	
	effectPolylineProto.getLineLength = function (symbol) {
	  return this._length;
	}; // Overwrite
	
	
	effectPolylineProto.updateSymbolPosition = function (symbol) {
	  var t = symbol.__t;
	  var points = this._points;
	  var offsets = this._offsets;
	  var len = points.length;
	
	  if (!offsets) {
	    // Has length 0
	    return;
	  }
	
	  var lastFrame = this._lastFrame;
	  var frame;
	
	  if (t < this._lastFramePercent) {
	    // Start from the next frame
	    // PENDING start from lastFrame ?
	    var start = Math.min(lastFrame + 1, len - 1);
	
	    for (frame = start; frame >= 0; frame--) {
	      if (offsets[frame] <= t) {
	        break;
	      }
	    } // PENDING really need to do this ?
	
	
	    frame = Math.min(frame, len - 2);
	  } else {
	    for (var frame = lastFrame; frame < len; frame++) {
	      if (offsets[frame] > t) {
	        break;
	      }
	    }
	
	    frame = Math.min(frame - 1, len - 2);
	  }
	
	  vec2.lerp(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
	  var tx = points[frame + 1][0] - points[frame][0];
	  var ty = points[frame + 1][1] - points[frame][1];
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	  this._lastFrame = frame;
	  this._lastFramePercent = t;
	  symbol.ignore = false;
	};
	
	zrUtil.inherits(EffectPolyline, EffectLine);
	var _default = EffectPolyline;
	module.exports = _default;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var _graphic = __webpack_require__(17);
	
	var Group = _graphic.Group;
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	var SymbolClz = __webpack_require__(265);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Symbol with ripple effect
	 * @module echarts/chart/helper/EffectSymbol
	 */
	var EFFECT_RIPPLE_NUMBER = 3;
	
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	function updateRipplePath(rippleGroup, effectCfg) {
	  var color = effectCfg.rippleEffectColor || effectCfg.color;
	  rippleGroup.eachChild(function (ripplePath) {
	    ripplePath.attr({
	      z: effectCfg.z,
	      zlevel: effectCfg.zlevel,
	      style: {
	        stroke: effectCfg.brushType === 'stroke' ? color : null,
	        fill: effectCfg.brushType === 'fill' ? color : null
	      }
	    });
	  });
	}
	/**
	 * @constructor
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function EffectSymbol(data, idx) {
	  Group.call(this);
	  var symbol = new SymbolClz(data, idx);
	  var rippleGroup = new Group();
	  this.add(symbol);
	  this.add(rippleGroup);
	
	  rippleGroup.beforeUpdate = function () {
	    this.attr(symbol.getScale());
	  };
	
	  this.updateData(data, idx);
	}
	
	var effectSymbolProto = EffectSymbol.prototype;
	
	effectSymbolProto.stopEffectAnimation = function () {
	  this.childAt(1).removeAll();
	};
	
	effectSymbolProto.startEffectAnimation = function (effectCfg) {
	  var symbolType = effectCfg.symbolType;
	  var color = effectCfg.color;
	  var rippleGroup = this.childAt(1);
	
	  for (var i = 0; i < EFFECT_RIPPLE_NUMBER; i++) {
	    // If width/height are set too small (e.g., set to 1) on ios10
	    // and macOS Sierra, a circle stroke become a rect, no matter what
	    // the scale is set. So we set width/height as 2. See #4136.
	    var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
	    ripplePath.attr({
	      style: {
	        strokeNoScale: true
	      },
	      z2: 99,
	      silent: true,
	      scale: [0.5, 0.5]
	    });
	    var delay = -i / EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period
	
	    ripplePath.animate('', true).when(effectCfg.period, {
	      scale: [effectCfg.rippleScale / 2, effectCfg.rippleScale / 2]
	    }).delay(delay).start();
	    ripplePath.animateStyle(true).when(effectCfg.period, {
	      opacity: 0
	    }).delay(delay).start();
	    rippleGroup.add(ripplePath);
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Update effect symbol
	 */
	
	
	effectSymbolProto.updateEffectAnimation = function (effectCfg) {
	  var oldEffectCfg = this._effectCfg;
	  var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
	
	  var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale'];
	
	  for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
	    var propName = DIFFICULT_PROPS[i];
	
	    if (oldEffectCfg[propName] !== effectCfg[propName]) {
	      this.stopEffectAnimation();
	      this.startEffectAnimation(effectCfg);
	      return;
	    }
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Highlight symbol
	 */
	
	
	effectSymbolProto.highlight = function () {
	  this.trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	effectSymbolProto.downplay = function () {
	  this.trigger('normal');
	};
	/**
	 * Update symbol properties
	 * @param  {module:echarts/data/List} data
	 * @param  {number} idx
	 */
	
	
	effectSymbolProto.updateData = function (data, idx) {
	  var seriesModel = data.hostModel;
	  this.childAt(0).updateData(data, idx);
	  var rippleGroup = this.childAt(1);
	  var itemModel = data.getItemModel(idx);
	  var symbolType = data.getItemVisual(idx, 'symbol');
	  var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	  var color = data.getItemVisual(idx, 'color');
	  rippleGroup.attr('scale', symbolSize);
	  rippleGroup.traverse(function (ripplePath) {
	    ripplePath.attr({
	      fill: color
	    });
	  });
	  var symbolOffset = itemModel.getShallow('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = rippleGroup.position;
	    pos[0] = parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] = parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	  rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var effectCfg = {};
	  effectCfg.showEffectOn = seriesModel.get('showEffectOn');
	  effectCfg.rippleScale = itemModel.get('rippleEffect.scale');
	  effectCfg.brushType = itemModel.get('rippleEffect.brushType');
	  effectCfg.period = itemModel.get('rippleEffect.period') * 1000;
	  effectCfg.effectOffset = idx / data.count();
	  effectCfg.z = itemModel.getShallow('z') || 0;
	  effectCfg.zlevel = itemModel.getShallow('zlevel') || 0;
	  effectCfg.symbolType = symbolType;
	  effectCfg.color = color;
	  effectCfg.rippleEffectColor = itemModel.get('rippleEffect.color');
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	
	  if (effectCfg.showEffectOn === 'render') {
	    this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
	    this._effectCfg = effectCfg;
	  } else {
	    // Not keep old effect config
	    this._effectCfg = null;
	    this.stopEffectAnimation();
	    var symbol = this.childAt(0);
	
	    var onEmphasis = function () {
	      symbol.highlight();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.startEffectAnimation(effectCfg);
	      }
	    };
	
	    var onNormal = function () {
	      symbol.downplay();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.stopEffectAnimation();
	      }
	    };
	
	    this.on('mouseover', onEmphasis, this).on('mouseout', onNormal, this).on('emphasis', onEmphasis, this).on('normal', onNormal, this);
	  }
	
	  this._effectCfg = effectCfg;
	};
	
	effectSymbolProto.fadeOut = function (cb) {
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  cb && cb();
	};
	
	zrUtil.inherits(EffectSymbol, Group);
	var _default = EffectSymbol;
	module.exports = _default;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var IncrementalDisplayable = __webpack_require__(447);
	
	var lineContain = __webpack_require__(897);
	
	var quadraticContain = __webpack_require__(899);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Batch by color
	var LargeLineShape = graphic.extendShape({
	  shape: {
	    polyline: false,
	    curveness: 0,
	    segs: []
	  },
	  buildPath: function (path, shape) {
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          path.moveTo(segs[i++], segs[i++]);
	
	          for (var k = 1; k < count; k++) {
	            path.lineTo(segs[i++], segs[i++]);
	          }
	        }
	      }
	    } else {
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	        path.moveTo(x0, y0);
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	          path.quadraticCurveTo(x2, y2, x1, y1);
	        } else {
	          path.lineTo(x1, y1);
	        }
	      }
	    }
	  },
	  findDataIndex: function (x, y) {
	    var shape = this.shape;
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          var x0 = segs[i++];
	          var y0 = segs[i++];
	
	          for (var k = 1; k < count; k++) {
	            var x1 = segs[i++];
	            var y1 = segs[i++];
	
	            if (lineContain.containStroke(x0, y0, x1, y1)) {
	              return dataIndex;
	            }
	          }
	        }
	
	        dataIndex++;
	      }
	    } else {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	
	          if (quadraticContain.containStroke(x0, y0, x2, y2, x1, y1)) {
	            return dataIndex;
	          }
	        } else {
	          if (lineContain.containStroke(x0, y0, x1, y1)) {
	            return dataIndex;
	          }
	        }
	
	        dataIndex++;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeLineDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeLineProto = LargeLineDraw.prototype;
	
	largeLineProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	
	largeLineProto.updateData = function (data) {
	  this.group.removeAll();
	  var lineEl = new LargeLineShape({
	    rectHover: true,
	    cursor: 'default'
	  });
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data); // Add back
	
	
	  this.group.add(lineEl);
	  this._incremental = null;
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental();
	
	  if (data.count() > 5e5) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalUpdate = function (taskParams, data) {
	  var lineEl = new LargeLineShape();
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data, !!this._incremental);
	
	  if (!this._incremental) {
	    lineEl.rectHover = true;
	    lineEl.cursor = 'default';
	    lineEl.__startIndex = taskParams.start;
	    this.group.add(lineEl);
	  } else {
	    this._incremental.addDisplayable(lineEl, true);
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeLineProto._setCommon = function (lineEl, data, isIncremental) {
	  var hostModel = data.hostModel;
	  lineEl.setShape({
	    polyline: hostModel.get('polyline'),
	    curveness: hostModel.get('lineStyle.curveness')
	  });
	  lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
	  lineEl.style.strokeNoScale = true;
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    lineEl.setStyle('stroke', visualColor);
	  }
	
	  lineEl.setStyle('fill');
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    lineEl.seriesIndex = hostModel.seriesIndex;
	    lineEl.on('mousemove', function (e) {
	      lineEl.dataIndex = null;
	      var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex > 0) {
	        // Provide dataIndex for tooltip
	        lineEl.dataIndex = dataIndex + lineEl.__startIndex;
	      }
	    });
	  }
	};
	
	largeLineProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeLineDraw;
	module.exports = _default;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var IncrementalDisplayable = __webpack_require__(447);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	// TODO Batch by color
	var BOOST_SIZE_THRESHOLD = 4;
	var LargeSymbolPath = graphic.extendShape({
	  shape: {
	    points: null
	  },
	  symbolProxy: null,
	  softClipShape: null,
	  buildPath: function (path, shape) {
	    var points = shape.points;
	    var size = shape.size;
	    var symbolProxy = this.symbolProxy;
	    var symbolProxyShape = symbolProxy.shape;
	    var ctx = path.getContext ? path.getContext() : path;
	    var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.
	
	    if (canBoost) {
	      return;
	    }
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
	        continue;
	      }
	
	      symbolProxyShape.x = x - size[0] / 2;
	      symbolProxyShape.y = y - size[1] / 2;
	      symbolProxyShape.width = size[0];
	      symbolProxyShape.height = size[1];
	      symbolProxy.buildPath(path, symbolProxyShape, true);
	    }
	  },
	  afterBrush: function (ctx) {
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var canBoost = size[0] < BOOST_SIZE_THRESHOLD;
	
	    if (!canBoost) {
	      return;
	    }
	
	    this.setTransform(ctx); // PENDING If style or other canvas status changed?
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
	        continue;
	      } // fillRect is faster than building a rect path and draw.
	      // And it support light globalCompositeOperation.
	
	
	      ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
	    }
	
	    this.restoreTransform(ctx);
	  },
	  findDataIndex: function (x, y) {
	    // TODO ???
	    // Consider transform
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var w = Math.max(size[0], 4);
	    var h = Math.max(size[1], 4); // Not consider transform
	    // Treat each element as a rect
	    // top down traverse
	
	    for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
	      var i = idx * 2;
	      var x0 = points[i] - w / 2;
	      var y0 = points[i + 1] - h / 2;
	
	      if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
	        return idx;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeSymbolDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeSymbolProto = LargeSymbolDraw.prototype;
	
	largeSymbolProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} opt
	 * @param {Object} [opt.clipShape]
	 */
	
	
	largeSymbolProto.updateData = function (data, opt) {
	  this.group.removeAll();
	  var symbolEl = new LargeSymbolPath({
	    rectHover: true,
	    cursor: 'default'
	  });
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, false, opt);
	
	  this.group.add(symbolEl);
	  this._incremental = null;
	};
	
	largeSymbolProto.updateLayout = function (data) {
	  if (this._incremental) {
	    return;
	  }
	
	  var points = data.getLayout('symbolPoints');
	  this.group.eachChild(function (child) {
	    if (child.startIndex != null) {
	      var len = (child.endIndex - child.startIndex) * 2;
	      var byteOffset = child.startIndex * 4 * 2;
	      points = new Float32Array(points.buffer, byteOffset, len);
	    }
	
	    child.setShape('points', points);
	  });
	};
	
	largeSymbolProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
	  // PENDING Incremental data?
	
	
	  if (data.count() > 2e6) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	
	largeSymbolProto.incrementalUpdate = function (taskParams, data, opt) {
	  var symbolEl;
	
	  if (this._incremental) {
	    symbolEl = new LargeSymbolPath();
	
	    this._incremental.addDisplayable(symbolEl, true);
	  } else {
	    symbolEl = new LargeSymbolPath({
	      rectHover: true,
	      cursor: 'default',
	      startIndex: taskParams.start,
	      endIndex: taskParams.end
	    });
	    symbolEl.incremental = true;
	    this.group.add(symbolEl);
	  }
	
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, !!this._incremental, opt);
	};
	
	largeSymbolProto._setCommon = function (symbolEl, data, isIncremental, opt) {
	  var hostModel = data.hostModel;
	  opt = opt || {}; // TODO
	  // if (data.hasItemVisual.symbolSize) {
	  //     // TODO typed array?
	  //     symbolEl.setShape('sizes', data.mapArray(
	  //         function (idx) {
	  //             var size = data.getItemVisual(idx, 'symbolSize');
	  //             return (size instanceof Array) ? size : [size, size];
	  //         }
	  //     ));
	  // }
	  // else {
	
	  var size = data.getVisual('symbolSize');
	  symbolEl.setShape('size', size instanceof Array ? size : [size, size]); // }
	
	  symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data
	
	  symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
	
	  symbolEl.setColor = symbolEl.symbolProxy.setColor;
	  var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
	  symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
	  hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    symbolEl.setColor(visualColor);
	  }
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    symbolEl.seriesIndex = hostModel.seriesIndex;
	    symbolEl.on('mousemove', function (e) {
	      symbolEl.dataIndex = null;
	      var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex >= 0) {
	        // Provide dataIndex for tooltip
	        symbolEl.dataIndex = dataIndex + (symbolEl.startIndex || 0);
	      }
	    });
	  }
	};
	
	largeSymbolProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeSymbolProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeSymbolDraw;
	module.exports = _default;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var vec2 = __webpack_require__(49);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Line path for bezier and straight line draw
	 */
	var straightLineProto = graphic.Line.prototype;
	var bezierCurveProto = graphic.BezierCurve.prototype;
	
	function isLine(shape) {
	  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
	}
	
	var _default = graphic.extendShape({
	  type: 'ec-line',
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    percent: 1,
	    cpx1: null,
	    cpy1: null
	  },
	  buildPath: function (ctx, shape) {
	    this[isLine(shape) ? '_buildPathLine' : '_buildPathCurve'](ctx, shape);
	  },
	  _buildPathLine: straightLineProto.buildPath,
	  _buildPathCurve: bezierCurveProto.buildPath,
	  pointAt: function (t) {
	    return this[isLine(this.shape) ? '_pointAtLine' : '_pointAtCurve'](t);
	  },
	  _pointAtLine: straightLineProto.pointAt,
	  _pointAtCurve: bezierCurveProto.pointAt,
	  tangentAt: function (t) {
	    var shape = this.shape;
	    var p = isLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : this._tangentAtCurve(t);
	    return vec2.normalize(p, p);
	  },
	  _tangentAtCurve: bezierCurveProto.tangentAt
	});
	
	module.exports = _default;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1665);
	
	__webpack_require__(1666);
	
	var visualSymbol = __webpack_require__(145);
	
	var layoutPoints = __webpack_require__(222);
	
	var dataSample = __webpack_require__(1862);
	
	__webpack_require__(217);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('line', 'circle', 'line'));
	echarts.registerLayout(layoutPoints('line')); // Down sample after filter
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var createListFromArray = __webpack_require__(113);
	
	var SeriesModel = __webpack_require__(66);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.line',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // stack: null
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // If clip the overflow value
	    clip: true,
	    // cursor: null,
	    label: {
	      position: 'top'
	    },
	    // itemStyle: {
	    // },
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    // areaStyle: {
	    // origin of areaStyle. Valid values:
	    // `'auto'/null/undefined`: from axisLine to data
	    // `'start'`: from min to data
	    // `'end'`: from data to max
	    // origin: 'auto'
	    // },
	    // false, 'start', 'end', 'middle'
	    step: false,
	    // Disabled if step is true
	    smooth: false,
	    smoothMonotone: null,
	    symbol: 'emptyCircle',
	    symbolSize: 4,
	    symbolRotate: null,
	    showSymbol: true,
	    // `false`: follow the label interval strategy.
	    // `true`: show all symbols.
	    // `'auto'`: If possible, show all symbols, otherwise
	    //           follow the label interval strategy.
	    showAllSymbol: 'auto',
	    // Whether to connect break point.
	    connectNulls: false,
	    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
	    sampling: 'none',
	    animationEasing: 'linear',
	    // Disable progressive
	    progressive: 0,
	    hoverLayerThreshold: Infinity
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var _bbox = __webpack_require__(226);
	
	var fromPoints = _bbox.fromPoints;
	
	var SymbolDraw = __webpack_require__(214);
	
	var SymbolClz = __webpack_require__(265);
	
	var lineAnimationDiff = __webpack_require__(1667);
	
	var graphic = __webpack_require__(17);
	
	var modelUtil = __webpack_require__(27);
	
	var _poly = __webpack_require__(810);
	
	var Polyline = _poly.Polyline;
	var Polygon = _poly.Polygon;
	
	var ChartView = __webpack_require__(103);
	
	var _helper = __webpack_require__(809);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	var _createClipPathFromCoordSys = __webpack_require__(215);
	
	var createGridClipPath = _createClipPathFromCoordSys.createGridClipPath;
	var createPolarClipPath = _createClipPathFromCoordSys.createPolarClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME step not support polar
	function isPointsSame(points1, points2) {
	  if (points1.length !== points2.length) {
	    return;
	  }
	
	  for (var i = 0; i < points1.length; i++) {
	    var p1 = points1[i];
	    var p2 = points2[i];
	
	    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
	      return;
	    }
	  }
	
	  return true;
	}
	
	function getBoundingDiff(points1, points2) {
	  var min1 = [];
	  var max1 = [];
	  var min2 = [];
	  var max2 = [];
	  fromPoints(points1, min1, max1);
	  fromPoints(points2, min2, max2); // Get a max value from each corner of two boundings.
	
	  return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
	}
	
	function getSmooth(smooth) {
	  return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
	}
	/**
	 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {Object} dataCoordInfo
	 * @param {Array.<Array.<number>>} points
	 */
	
	
	function getStackedOnPoints(coordSys, data, dataCoordInfo) {
	  if (!dataCoordInfo.valueDim) {
	    return [];
	  }
	
	  var points = [];
	
	  for (var idx = 0, len = data.count(); idx < len; idx++) {
	    points.push(getStackedOnPoint(dataCoordInfo, coordSys, data, idx));
	  }
	
	  return points;
	}
	
	function turnPointsIntoStep(points, coordSys, stepTurnAt) {
	  var baseAxis = coordSys.getBaseAxis();
	  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
	  var stepPoints = [];
	
	  for (var i = 0; i < points.length - 1; i++) {
	    var nextPt = points[i + 1];
	    var pt = points[i];
	    stepPoints.push(pt);
	    var stepPt = [];
	
	    switch (stepTurnAt) {
	      case 'end':
	        stepPt[baseIndex] = nextPt[baseIndex];
	        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	        break;
	
	      case 'middle':
	        // default is start
	        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
	        var stepPt2 = [];
	        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
	        stepPt[1 - baseIndex] = pt[1 - baseIndex];
	        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
	        stepPoints.push(stepPt);
	        stepPoints.push(stepPt2);
	        break;
	
	      default:
	        stepPt[baseIndex] = pt[baseIndex];
	        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	    }
	  } // Last points
	
	
	  points[i] && stepPoints.push(points[i]);
	  return stepPoints;
	}
	
	function getVisualGradient(data, coordSys) {
	  var visualMetaList = data.getVisual('visualMeta');
	
	  if (!visualMetaList || !visualMetaList.length || !data.count()) {
	    // When data.count() is 0, gradient range can not be calculated.
	    return;
	  }
	
	  if (coordSys.type !== 'cartesian2d') {
	    return;
	  }
	
	  var coordDim;
	  var visualMeta;
	
	  for (var i = visualMetaList.length - 1; i >= 0; i--) {
	    var dimIndex = visualMetaList[i].dimension;
	    var dimName = data.dimensions[dimIndex];
	    var dimInfo = data.getDimensionInfo(dimName);
	    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
	
	    if (coordDim === 'x' || coordDim === 'y') {
	      visualMeta = visualMetaList[i];
	      break;
	    }
	  }
	
	  if (!visualMeta) {
	    return;
	  } // If the area to be rendered is bigger than area defined by LinearGradient,
	  // the canvas spec prescribes that the color of the first stop and the last
	  // stop should be used. But if two stops are added at offset 0, in effect
	  // browsers use the color of the second stop to render area outside
	  // LinearGradient. So we can only infinitesimally extend area defined in
	  // LinearGradient to render `outerColors`.
	
	
	  var axis = coordSys.getAxis(coordDim); // dataToCoor mapping may not be linear, but must be monotonic.
	
	  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
	    return {
	      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
	      color: stop.color
	    };
	  });
	  var stopLen = colorStops.length;
	  var outerColors = visualMeta.outerColors.slice();
	
	  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
	    colorStops.reverse();
	    outerColors.reverse();
	  }
	
	  var tinyExtent = 10; // Arbitrary value: 10px
	
	  var minCoord = colorStops[0].coord - tinyExtent;
	  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
	  var coordSpan = maxCoord - minCoord;
	
	  if (coordSpan < 1e-3) {
	    return 'transparent';
	  }
	
	  zrUtil.each(colorStops, function (stop) {
	    stop.offset = (stop.coord - minCoord) / coordSpan;
	  });
	  colorStops.push({
	    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
	    color: outerColors[1] || 'transparent'
	  });
	  colorStops.unshift({
	    // notice colorStops.length have been changed.
	    offset: stopLen ? colorStops[0].offset : 0.5,
	    color: outerColors[0] || 'transparent'
	  }); // zrUtil.each(colorStops, function (colorStop) {
	  //     // Make sure each offset has rounded px to avoid not sharp edge
	  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
	  // });
	
	  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
	  gradient[coordDim] = minCoord;
	  gradient[coordDim + '2'] = maxCoord;
	  return gradient;
	}
	
	function getIsIgnoreFunc(seriesModel, data, coordSys) {
	  var showAllSymbol = seriesModel.get('showAllSymbol');
	  var isAuto = showAllSymbol === 'auto';
	
	  if (showAllSymbol && !isAuto) {
	    return;
	  }
	
	  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	  if (!categoryAxis) {
	    return;
	  } // Note that category label interval strategy might bring some weird effect
	  // in some scenario: users may wonder why some of the symbols are not
	  // displayed. So we show all symbols as possible as we can.
	
	
	  if (isAuto // Simplify the logic, do not determine label overlap here.
	  && canShowAllSymbolForCategory(categoryAxis, data)) {
	    return;
	  } // Otherwise follow the label interval strategy on category axis.
	
	
	  var categoryDataDim = data.mapDimension(categoryAxis.dim);
	  var labelMap = {};
	  zrUtil.each(categoryAxis.getViewLabels(), function (labelItem) {
	    labelMap[labelItem.tickValue] = 1;
	  });
	  return function (dataIndex) {
	    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
	  };
	}
	
	function canShowAllSymbolForCategory(categoryAxis, data) {
	  // In mose cases, line is monotonous on category axis, and the label size
	  // is close with each other. So we check the symbol size and some of the
	  // label size alone with the category axis to estimate whether all symbol
	  // can be shown without overlap.
	  var axisExtent = categoryAxis.getExtent();
	  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
	  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
	  // Sampling some points, max 5.
	
	  var dataLen = data.count();
	  var step = Math.max(1, Math.round(dataLen / 5));
	
	  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
	    if (SymbolClz.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
	    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
	    * 1.5 > availSize) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function createLineClipPath(coordSys, hasAnimation, seriesModel) {
	  if (coordSys.type === 'cartesian2d') {
	    var isHorizontal = coordSys.getBaseAxis().isHorizontal();
	    var clipPath = createGridClipPath(coordSys, hasAnimation, seriesModel); // Expand clip shape to avoid clipping when line value exceeds axis
	
	    if (!seriesModel.get('clip', true)) {
	      var rectShape = clipPath.shape;
	      var expandSize = Math.max(rectShape.width, rectShape.height);
	
	      if (isHorizontal) {
	        rectShape.y -= expandSize;
	        rectShape.height += expandSize * 2;
	      } else {
	        rectShape.x -= expandSize;
	        rectShape.width += expandSize * 2;
	      }
	    }
	
	    return clipPath;
	  } else {
	    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	  }
	}
	
	var _default = ChartView.extend({
	  type: 'line',
	  init: function () {
	    var lineGroup = new graphic.Group();
	    var symbolDraw = new SymbolDraw();
	    this.group.add(symbolDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineGroup = lineGroup;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var areaStyleModel = seriesModel.getModel('areaStyle');
	    var points = data.mapArray(data.getItemLayout);
	    var isCoordSysPolar = coordSys.type === 'polar';
	    var prevCoordSys = this._coordSys;
	    var symbolDraw = this._symbolDraw;
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var lineGroup = this._lineGroup;
	    var hasAnimation = seriesModel.get('animation');
	    var isAreaChart = !areaStyleModel.isEmpty();
	    var valueOrigin = areaStyleModel.get('origin');
	    var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
	    var stackedOnPoints = getStackedOnPoints(coordSys, data, dataCoordInfo);
	    var showSymbol = seriesModel.get('showSymbol');
	    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
	
	    var oldData = this._data;
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    }); // Remove previous created symbols if showSymbol changed to false
	
	    if (!showSymbol) {
	      symbolDraw.remove();
	    }
	
	    group.add(lineGroup); // FIXME step not support polar
	
	    var step = !isCoordSysPolar && seriesModel.get('step');
	    var clipShapeForSymbol;
	
	    if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
	      clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	      // See #7913 and `test/dataZoom-clip.html`.
	
	      if (clipShapeForSymbol.width != null) {
	        clipShapeForSymbol.x -= 0.1;
	        clipShapeForSymbol.y -= 0.1;
	        clipShapeForSymbol.width += 0.2;
	        clipShapeForSymbol.height += 0.2;
	      } else if (clipShapeForSymbol.r0) {
	        clipShapeForSymbol.r0 -= 0.5;
	        clipShapeForSymbol.r1 += 0.5;
	      }
	    }
	
	    this._clipShapeForSymbol = clipShapeForSymbol; // Initialization animation or coordinate system changed
	
	    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: clipShapeForSymbol
	      });
	
	      if (step) {
	        // TODO If stacked series is not step
	        points = turnPointsIntoStep(points, coordSys, step);
	        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	      }
	
	      polyline = this._newPolyline(points, coordSys, hasAnimation);
	
	      if (isAreaChart) {
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      }
	
	      lineGroup.setClipPath(createLineClipPath(coordSys, true, seriesModel));
	    } else {
	      if (isAreaChart && !polygon) {
	        // If areaStyle is added
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      } else if (polygon && !isAreaChart) {
	        // If areaStyle is removed
	        lineGroup.remove(polygon);
	        polygon = this._polygon = null;
	      } // Update clipPath
	
	
	      lineGroup.setClipPath(createLineClipPath(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
	      // because points are not changed
	
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: clipShapeForSymbol
	      }); // Stop symbol animation and sync with line points
	      // FIXME performance?
	
	      data.eachItemGraphicEl(function (el) {
	        el.stopAnimation(true);
	      }); // In the case data zoom triggerred refreshing frequently
	      // Data may not change if line has a category axis. So it should animate nothing
	
	      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
	        if (hasAnimation) {
	          this._updateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
	        } else {
	          // Not do it in update with animation
	          if (step) {
	            // TODO If stacked series is not step
	            points = turnPointsIntoStep(points, coordSys, step);
	            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	          }
	
	          polyline.setShape({
	            points: points
	          });
	          polygon && polygon.setShape({
	            points: points,
	            stackedOnPoints: stackedOnPoints
	          });
	        }
	      }
	    }
	
	    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
	    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
	    lineStyleModel.getLineStyle(), {
	      fill: 'none',
	      stroke: visualColor,
	      lineJoin: 'bevel'
	    }));
	    var smooth = seriesModel.get('smooth');
	    smooth = getSmooth(seriesModel.get('smooth'));
	    polyline.setShape({
	      smooth: smooth,
	      smoothMonotone: seriesModel.get('smoothMonotone'),
	      connectNulls: seriesModel.get('connectNulls')
	    });
	
	    if (polygon) {
	      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	      var stackedOnSmooth = 0;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: visualColor,
	        opacity: 0.7,
	        lineJoin: 'bevel'
	      }));
	
	      if (stackedOnSeries) {
	        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
	      }
	
	      polygon.setShape({
	        smooth: smooth,
	        stackedOnSmooth: stackedOnSmooth,
	        smoothMonotone: seriesModel.get('smoothMonotone'),
	        connectNulls: seriesModel.get('connectNulls')
	      });
	    }
	
	    this._data = data; // Save the coordinate system for transition animation when data changed
	
	    this._coordSys = coordSys;
	    this._stackedOnPoints = stackedOnPoints;
	    this._points = points;
	    this._step = step;
	    this._valueOrigin = valueOrigin;
	  },
	  dispose: function () {},
	  highlight: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (!symbol) {
	        // Create a temporary symbol if it is not exists
	        var pt = data.getItemLayout(dataIndex);
	
	        if (!pt) {
	          // Null data
	          return;
	        } // fix #11360: should't draw symbol outside clipShapeForSymbol
	
	
	        if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(pt[0], pt[1])) {
	          return;
	        }
	
	        symbol = new SymbolClz(data, dataIndex);
	        symbol.position = pt;
	        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
	        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
	        symbol.__temp = true;
	        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
	
	        symbol.stopSymbolAnimation(true);
	        this.group.add(symbol);
	      }
	
	      symbol.highlight();
	    } else {
	      // Highlight whole series
	      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	  downplay: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (symbol) {
	        if (symbol.__temp) {
	          data.setItemGraphicEl(dataIndex, null);
	          this.group.remove(symbol);
	        } else {
	          symbol.downplay();
	        }
	      }
	    } else {
	      // FIXME
	      // can not downplay completely.
	      // Downplay whole series
	      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolyline: function (points) {
	    var polyline = this._polyline; // Remove previous created polyline
	
	    if (polyline) {
	      this._lineGroup.remove(polyline);
	    }
	
	    polyline = new Polyline({
	      shape: {
	        points: points
	      },
	      silent: true,
	      z2: 10
	    });
	
	    this._lineGroup.add(polyline);
	
	    this._polyline = polyline;
	    return polyline;
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} stackedOnPoints
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolygon: function (points, stackedOnPoints) {
	    var polygon = this._polygon; // Remove previous created polygon
	
	    if (polygon) {
	      this._lineGroup.remove(polygon);
	    }
	
	    polygon = new Polygon({
	      shape: {
	        points: points,
	        stackedOnPoints: stackedOnPoints
	      },
	      silent: true
	    });
	
	    this._lineGroup.add(polygon);
	
	    this._polygon = polygon;
	    return polygon;
	  },
	
	  /**
	   * @private
	   */
	  // FIXME Two value axis
	  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step, valueOrigin) {
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var seriesModel = data.hostModel;
	    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
	    var current = diff.current;
	    var stackedOnCurrent = diff.stackedOnCurrent;
	    var next = diff.next;
	    var stackedOnNext = diff.stackedOnNext;
	
	    if (step) {
	      // TODO If stacked series is not step
	      current = turnPointsIntoStep(diff.current, coordSys, step);
	      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
	      next = turnPointsIntoStep(diff.next, coordSys, step);
	      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
	    } // Don't apply animation if diff is large.
	    // For better result and avoid memory explosion problems like
	    // https://github.com/apache/incubator-echarts/issues/12229
	
	
	    if (getBoundingDiff(current, next) > 3000 || polygon && getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
	      polyline.setShape({
	        points: next
	      });
	
	      if (polygon) {
	        polygon.setShape({
	          points: next,
	          stackedOnPoints: stackedOnNext
	        });
	      }
	
	      return;
	    } // `diff.current` is subset of `current` (which should be ensured by
	    // turnPointsIntoStep), so points in `__points` can be updated when
	    // points in `current` are update during animation.
	
	
	    polyline.shape.__points = diff.current;
	    polyline.shape.points = current;
	    graphic.updateProps(polyline, {
	      shape: {
	        points: next
	      }
	    }, seriesModel);
	
	    if (polygon) {
	      polygon.setShape({
	        points: current,
	        stackedOnPoints: stackedOnCurrent
	      });
	      graphic.updateProps(polygon, {
	        shape: {
	          points: next,
	          stackedOnPoints: stackedOnNext
	        }
	      }, seriesModel);
	    }
	
	    var updatedDataInfo = [];
	    var diffStatus = diff.status;
	
	    for (var i = 0; i < diffStatus.length; i++) {
	      var cmd = diffStatus[i].cmd;
	
	      if (cmd === '=') {
	        var el = data.getItemGraphicEl(diffStatus[i].idx1);
	
	        if (el) {
	          updatedDataInfo.push({
	            el: el,
	            ptIdx: i // Index of points
	
	          });
	        }
	      }
	    }
	
	    if (polyline.animators && polyline.animators.length) {
	      polyline.animators[0].during(function () {
	        for (var i = 0; i < updatedDataInfo.length; i++) {
	          var el = updatedDataInfo[i].el;
	          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
	        }
	      });
	    }
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var oldData = this._data;
	
	    this._lineGroup.removeAll();
	
	    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
	
	
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    });
	    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _helper = __webpack_require__(809);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var arrayDiff = require('zrender/src/core/arrayDiff');
	// 'zrender/src/core/arrayDiff' has been used before, but it did
	// not do well in performance when roam with fixed dataZoom window.
	// function convertToIntId(newIdList, oldIdList) {
	//     // Generate int id instead of string id.
	//     // Compare string maybe slow in score function of arrDiff
	//     // Assume id in idList are all unique
	//     var idIndicesMap = {};
	//     var idx = 0;
	//     for (var i = 0; i < newIdList.length; i++) {
	//         idIndicesMap[newIdList[i]] = idx;
	//         newIdList[i] = idx++;
	//     }
	//     for (var i = 0; i < oldIdList.length; i++) {
	//         var oldId = oldIdList[i];
	//         // Same with newIdList
	//         if (idIndicesMap[oldId]) {
	//             oldIdList[i] = idIndicesMap[oldId];
	//         }
	//         else {
	//             oldIdList[i] = idx++;
	//         }
	//     }
	// }
	function diffData(oldData, newData) {
	  var diffResult = [];
	  newData.diff(oldData).add(function (idx) {
	    diffResult.push({
	      cmd: '+',
	      idx: idx
	    });
	  }).update(function (newIdx, oldIdx) {
	    diffResult.push({
	      cmd: '=',
	      idx: oldIdx,
	      idx1: newIdx
	    });
	  }).remove(function (idx) {
	    diffResult.push({
	      cmd: '-',
	      idx: idx
	    });
	  }).execute();
	  return diffResult;
	}
	
	function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
	  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
	  // var oldIdList = oldData.mapArray(oldData.getId);
	  // convertToIntId(newIdList, oldIdList);
	  // // FIXME One data ?
	  // diff = arrayDiff(oldIdList, newIdList);
	
	  var currPoints = [];
	  var nextPoints = []; // Points for stacking base line
	
	  var currStackedPoints = [];
	  var nextStackedPoints = [];
	  var status = [];
	  var sortedIndices = [];
	  var rawIndices = [];
	  var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin);
	  var oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
	
	  for (var i = 0; i < diff.length; i++) {
	    var diffItem = diff[i];
	    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
	    // Which is in case remvoing or add more than one data in the tail or head
	
	    switch (diffItem.cmd) {
	      case '=':
	        var currentPt = oldData.getItemLayout(diffItem.idx);
	        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly
	
	        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
	          currentPt = nextPt.slice();
	        }
	
	        currPoints.push(currentPt);
	        nextPoints.push(nextPt);
	        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
	        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
	        rawIndices.push(newData.getRawIndex(diffItem.idx1));
	        break;
	
	      case '+':
	        var idx = diffItem.idx;
	        currPoints.push(oldCoordSys.dataToPoint([newData.get(newDataOldCoordInfo.dataDimsForPoint[0], idx), newData.get(newDataOldCoordInfo.dataDimsForPoint[1], idx)]));
	        nextPoints.push(newData.getItemLayout(idx).slice());
	        currStackedPoints.push(getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, idx));
	        nextStackedPoints.push(newStackedOnPoints[idx]);
	        rawIndices.push(newData.getRawIndex(idx));
	        break;
	
	      case '-':
	        var idx = diffItem.idx;
	        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
	        // FIXME FIXME FIXME
	
	        if (rawIndex !== idx) {
	          currPoints.push(oldData.getItemLayout(idx));
	          nextPoints.push(newCoordSys.dataToPoint([oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0], idx), oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1], idx)]));
	          currStackedPoints.push(oldStackedOnPoints[idx]);
	          nextStackedPoints.push(getStackedOnPoint(oldDataNewCoordInfo, newCoordSys, oldData, idx));
	          rawIndices.push(rawIndex);
	        } else {
	          pointAdded = false;
	        }
	
	    } // Original indices
	
	
	    if (pointAdded) {
	      status.push(diffItem);
	      sortedIndices.push(sortedIndices.length);
	    }
	  } // Diff result may be crossed if all items are changed
	  // Sort by data index
	
	
	  sortedIndices.sort(function (a, b) {
	    return rawIndices[a] - rawIndices[b];
	  });
	  var sortedCurrPoints = [];
	  var sortedNextPoints = [];
	  var sortedCurrStackedPoints = [];
	  var sortedNextStackedPoints = [];
	  var sortedStatus = [];
	
	  for (var i = 0; i < sortedIndices.length; i++) {
	    var idx = sortedIndices[i];
	    sortedCurrPoints[i] = currPoints[idx];
	    sortedNextPoints[i] = nextPoints[idx];
	    sortedCurrStackedPoints[i] = currStackedPoints[idx];
	    sortedNextStackedPoints[i] = nextStackedPoints[idx];
	    sortedStatus[i] = status[idx];
	  }
	
	  return {
	    current: sortedCurrPoints,
	    next: sortedNextPoints,
	    stackedOnCurrent: sortedCurrStackedPoints,
	    stackedOnNext: sortedNextStackedPoints,
	    status: sortedStatus
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1669);
	
	__webpack_require__(1670);
	
	var linesLayout = __webpack_require__(811);
	
	var linesVisual = __webpack_require__(1671);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(linesLayout);
	echarts.registerVisual(linesVisual);

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var SeriesModel = __webpack_require__(66);
	
	var List = __webpack_require__(88);
	
	var _util = __webpack_require__(2);
	
	var concatArray = _util.concatArray;
	var mergeAll = _util.mergeAll;
	var map = _util.map;
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var CoordinateSystem = __webpack_require__(95);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint32Array, Float64Array, Float32Array */
	var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
	var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
	
	function compatEc2(seriesOpt) {
	  var data = seriesOpt.data;
	
	  if (data && data[0] && data[0][0] && data[0][0].coord) {
	    seriesOpt.data = map(data, function (itemOpt) {
	      var coords = [itemOpt[0].coord, itemOpt[1].coord];
	      var target = {
	        coords: coords
	      };
	
	      if (itemOpt[0].name) {
	        target.fromName = itemOpt[0].name;
	      }
	
	      if (itemOpt[1].name) {
	        target.toName = itemOpt[1].name;
	      }
	
	      return mergeAll([target, itemOpt[0], itemOpt[1]]);
	    });
	  }
	}
	
	var LinesSeries = SeriesModel.extend({
	  type: 'series.lines',
	  dependencies: ['grid', 'polar'],
	  visualColorAccessPath: 'lineStyle.color',
	  init: function (option) {
	    // The input data may be null/undefined.
	    option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type
	
	    compatEc2(option);
	
	    var result = this._processFlatCoordsArray(option.data);
	
	    this._flatCoords = result.flatCoords;
	    this._flatCoordsOffset = result.flatCoordsOffset;
	
	    if (result.flatCoords) {
	      option.data = new Float32Array(result.count);
	    }
	
	    LinesSeries.superApply(this, 'init', arguments);
	  },
	  mergeOption: function (option) {
	    compatEc2(option);
	
	    if (option.data) {
	      // Only update when have option data to merge.
	      var result = this._processFlatCoordsArray(option.data);
	
	      this._flatCoords = result.flatCoords;
	      this._flatCoordsOffset = result.flatCoordsOffset;
	
	      if (result.flatCoords) {
	        option.data = new Float32Array(result.count);
	      }
	    }
	
	    LinesSeries.superApply(this, 'mergeOption', arguments);
	  },
	  appendData: function (params) {
	    var result = this._processFlatCoordsArray(params.data);
	
	    if (result.flatCoords) {
	      if (!this._flatCoords) {
	        this._flatCoords = result.flatCoords;
	        this._flatCoordsOffset = result.flatCoordsOffset;
	      } else {
	        this._flatCoords = concatArray(this._flatCoords, result.flatCoords);
	        this._flatCoordsOffset = concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
	      }
	
	      params.data = new Float32Array(result.count);
	    }
	
	    this.getRawData().appendData(params.data);
	  },
	  _getCoordsFromItemModel: function (idx) {
	    var itemModel = this.getData().getItemModel(idx);
	    var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
	    return coords;
	  },
	  getLineCoordsCount: function (idx) {
	    if (this._flatCoordsOffset) {
	      return this._flatCoordsOffset[idx * 2 + 1];
	    } else {
	      return this._getCoordsFromItemModel(idx).length;
	    }
	  },
	  getLineCoords: function (idx, out) {
	    if (this._flatCoordsOffset) {
	      var offset = this._flatCoordsOffset[idx * 2];
	      var len = this._flatCoordsOffset[idx * 2 + 1];
	
	      for (var i = 0; i < len; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = this._flatCoords[offset + i * 2];
	        out[i][1] = this._flatCoords[offset + i * 2 + 1];
	      }
	
	      return len;
	    } else {
	      var coords = this._getCoordsFromItemModel(idx);
	
	      for (var i = 0; i < coords.length; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = coords[i][0];
	        out[i][1] = coords[i][1];
	      }
	
	      return coords.length;
	    }
	  },
	  _processFlatCoordsArray: function (data) {
	    var startOffset = 0;
	
	    if (this._flatCoords) {
	      startOffset = this._flatCoords.length;
	    } // Stored as a typed array. In format
	    // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
	
	
	    if (typeof data[0] === 'number') {
	      var len = data.length; // Store offset and len of each segment
	
	      var coordsOffsetAndLenStorage = new Uint32Arr(len);
	      var coordsStorage = new Float64Arr(len);
	      var coordsCursor = 0;
	      var offsetCursor = 0;
	      var dataCount = 0;
	
	      for (var i = 0; i < len;) {
	        dataCount++;
	        var count = data[i++]; // Offset
	
	        coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len
	
	        coordsOffsetAndLenStorage[offsetCursor++] = count;
	
	        for (var k = 0; k < count; k++) {
	          var x = data[i++];
	          var y = data[i++];
	          coordsStorage[coordsCursor++] = x;
	          coordsStorage[coordsCursor++] = y;
	
	          if (i > len) {}
	        }
	      }
	
	      return {
	        flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
	        flatCoords: coordsStorage,
	        count: dataCount
	      };
	    }
	
	    return {
	      flatCoordsOffset: null,
	      flatCoords: null,
	      count: data.length
	    };
	  },
	  getInitialData: function (option, ecModel) {
	    var lineData = new List(['value'], this);
	    lineData.hasItemOption = false;
	    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
	      // dataItem is simply coords
	      if (dataItem instanceof Array) {
	        return NaN;
	      } else {
	        lineData.hasItemOption = true;
	        var value = dataItem.value;
	
	        if (value != null) {
	          return value instanceof Array ? value[dimIndex] : value;
	        }
	      }
	    });
	    return lineData;
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var itemModel = data.getItemModel(dataIndex);
	    var name = itemModel.get('name');
	
	    if (name) {
	      return name;
	    }
	
	    var fromName = itemModel.get('fromName');
	    var toName = itemModel.get('toName');
	    var html = [];
	    fromName != null && html.push(fromName);
	    toName != null && html.push(toName);
	    return encodeHTML(html.join(' > '));
	  },
	  preventIncremental: function () {
	    return !!this.get('effect.show');
	  },
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      return this.option.large ? 1e4 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      return this.option.large ? 2e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'geo',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    xAxisIndex: 0,
	    yAxisIndex: 0,
	    symbol: ['none', 'none'],
	    symbolSize: [10, 10],
	    // Geo coordinate system
	    geoIndex: 0,
	    effect: {
	      show: false,
	      period: 4,
	      // Animation delay. support callback
	      // delay: 0,
	      // If move with constant speed px/sec
	      // period will be ignored if this property is > 0,
	      constantSpeed: 0,
	      symbol: 'circle',
	      symbolSize: 3,
	      loop: true,
	      // Length of trail, 0 - 1
	      trailLength: 0.2 // Same with lineStyle.color
	      // color
	
	    },
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // If lines are polyline
	    // polyline not support curveness, label, animation
	    polyline: false,
	    // If clip the overflow.
	    // Available when coordinateSystem is cartesian or polar.
	    clip: true,
	    label: {
	      show: false,
	      position: 'end' // distance: 5,
	      // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    lineStyle: {
	      opacity: 0.5
	    }
	  }
	});
	var _default = LinesSeries;
	module.exports = _default;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var LineDraw = __webpack_require__(413);
	
	var EffectLine = __webpack_require__(804);
	
	var Line = __webpack_require__(412);
	
	var Polyline = __webpack_require__(805);
	
	var EffectPolyline = __webpack_require__(1659);
	
	var LargeLineDraw = __webpack_require__(1661);
	
	var linesLayout = __webpack_require__(811);
	
	var _createClipPathFromCoordSys = __webpack_require__(215);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'lines',
	  init: function () {},
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    var zlevel = seriesModel.get('zlevel');
	    var trailLength = seriesModel.get('effect.trailLength');
	    var zr = api.getZr(); // Avoid the drag cause ghost shadow
	    // FIXME Better way ?
	    // SVG doesn't support
	
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg) {
	      zr.painter.getLayer(zlevel).clear(true);
	    } // Config layer with motion blur
	
	
	    if (this._lastZlevel != null && !isSvg) {
	      zr.configLayer(this._lastZlevel, {
	        motionBlur: false
	      });
	    }
	
	    if (this._showEffect(seriesModel) && trailLength) {
	      if (!isSvg) {
	        zr.configLayer(zlevel, {
	          motionBlur: true,
	          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
	        });
	      }
	    }
	
	    lineDraw.updateData(data);
	    var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	
	    this._lastZlevel = zlevel;
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    lineDraw.incrementalPrepareUpdate(data);
	
	    this._clearLayer(api);
	
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var pipelineContext = seriesModel.pipelineContext;
	
	    if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
	      // TODO Don't have to do update in large mode. Only do it when there are millions of data.
	      return {
	        update: true
	      };
	    } else {
	      // TODO Use same logic with ScatterView.
	      // Manually update layout
	      var res = linesLayout.reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._lineDraw.updateLayout();
	
	      this._clearLayer(api);
	    }
	  },
	  _updateLineDraw: function (data, seriesModel) {
	    var lineDraw = this._lineDraw;
	
	    var hasEffect = this._showEffect(seriesModel);
	
	    var isPolyline = !!seriesModel.get('polyline');
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
	      if (lineDraw) {
	        lineDraw.remove();
	      }
	
	      lineDraw = this._lineDraw = isLargeDraw ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline : hasEffect ? EffectLine : Line);
	      this._hasEffet = hasEffect;
	      this._isPolyline = isPolyline;
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(lineDraw.group);
	    return lineDraw;
	  },
	  _showEffect: function (seriesModel) {
	    return !!seriesModel.get('effect.show');
	  },
	  _clearLayer: function (api) {
	    // Not use motion when dragging or zooming
	    var zr = api.getZr();
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg && this._lastZlevel != null) {
	      zr.painter.getLayer(this._lastZlevel).clear(true);
	    }
	  },
	  remove: function (ecModel, api) {
	    this._lineDraw && this._lineDraw.remove();
	    this._lineDraw = null; // Clear motion when lineDraw is removed
	
	    this._clearLayer(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	var opacityQuery = 'lineStyle.opacity'.split('.');
	var _default = {
	  seriesType: 'lines',
	  reset: function (seriesModel, ecModel, api) {
	    var symbolType = normalize(seriesModel.get('symbol'));
	    var symbolSize = normalize(seriesModel.get('symbolSize'));
	    var data = seriesModel.getData();
	    data.setVisual('fromSymbol', symbolType && symbolType[0]);
	    data.setVisual('toSymbol', symbolType && symbolType[1]);
	    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    data.setVisual('opacity', seriesModel.get(opacityQuery));
	
	    function dataEach(data, idx) {
	      var itemModel = data.getItemModel(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
	      var opacity = itemModel.get(opacityQuery);
	      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
	      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
	      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
	      data.setItemVisual(idx, 'opacity', opacity);
	    }
	
	    return {
	      dataEach: data.hasItemOption ? dataEach : null
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1673);
	
	__webpack_require__(1674);
	
	__webpack_require__(799);
	
	__webpack_require__(428);
	
	var mapSymbolLayout = __webpack_require__(1677);
	
	var mapVisual = __webpack_require__(1678);
	
	var mapDataStatistic = __webpack_require__(1676);
	
	var backwardCompat = __webpack_require__(1675);
	
	var createDataSelectAction = __webpack_require__(798);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(mapSymbolLayout);
	echarts.registerVisual(mapVisual);
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
	echarts.registerPreprocessor(backwardCompat);
	createDataSelectAction('map', [{
	  type: 'mapToggleSelect',
	  event: 'mapselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'mapSelect',
	  event: 'mapselected',
	  method: 'select'
	}, {
	  type: 'mapUnSelect',
	  event: 'mapunselected',
	  method: 'unSelect'
	}]);

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var createListSimply = __webpack_require__(170);
	
	var SeriesModel = __webpack_require__(66);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var dataSelectableMixin = __webpack_require__(422);
	
	var _dataProvider = __webpack_require__(143);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var geoSourceManager = __webpack_require__(271);
	
	var _sourceHelper = __webpack_require__(114);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MapSeries = SeriesModel.extend({
	  type: 'series.map',
	  dependencies: ['geo'],
	  layoutMode: 'box',
	
	  /**
	   * Only first map series of same mapType will drawMap
	   * @type {boolean}
	   */
	  needsDrawMap: false,
	
	  /**
	   * Group of all map series with same mapType
	   * @type {boolean}
	   */
	  seriesGroup: [],
	  getInitialData: function (option) {
	    var data = createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	    var valueDim = data.mapDimension('value');
	    var dataNameMap = zrUtil.createHashMap();
	    var selectTargetList = [];
	    var toAppendNames = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      var name = data.getName(i);
	      dataNameMap.set(name, true);
	      selectTargetList.push({
	        name: name,
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    var geoSource = geoSourceManager.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
	    zrUtil.each(geoSource.regions, function (region) {
	      var name = region.name;
	
	      if (!dataNameMap.get(name)) {
	        selectTargetList.push({
	          name: name
	        });
	        toAppendNames.push(name);
	      }
	    });
	    this.updateSelectedMap(selectTargetList); // Complete data with missing regions. The consequent processes (like visual
	    // map and render) can not be performed without a "full data". For example,
	    // find `dataIndex` by name.
	
	    data.appendValues([], toAppendNames);
	    return data;
	  },
	
	  /**
	   * If no host geo model, return null, which means using a
	   * inner exclusive geo model.
	   */
	  getHostGeoModel: function () {
	    var geoIndex = this.option.geoIndex;
	    return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
	  },
	  getMapType: function () {
	    return (this.getHostGeoModel() || this).option.map;
	  },
	  // _fillOption: function (option, mapName) {
	  // Shallow clone
	  // option = zrUtil.extend({}, option);
	  // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
	  // return option;
	  // },
	  getRawValue: function (dataIndex) {
	    // Use value stored in data instead because it is calculated from multiple series
	    // FIXME Provide all value of multiple series ?
	    var data = this.getData();
	    return data.get(data.mapDimension('value'), dataIndex);
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (regionName) {
	    var data = this.getData();
	    return data.getItemModel(data.indexOfName(regionName));
	  },
	
	  /**
	   * Map tooltip formatter
	   *
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    // FIXME orignalData and data is a bit confusing
	    var data = this.getData();
	    var formattedValue = addCommas(this.getRawValue(dataIndex));
	    var name = data.getName(dataIndex);
	    var seriesGroup = this.seriesGroup;
	    var seriesNames = [];
	
	    for (var i = 0; i < seriesGroup.length; i++) {
	      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
	      var valueDim = data.mapDimension('value');
	
	      if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
	        seriesNames.push(encodeHTML(seriesGroup[i].name));
	      }
	    }
	
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    return seriesNames.join(', ') + newLine + encodeHTML(name + ' : ' + formattedValue);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var name = this.getData().getName(dataIndex);
	      var geo = this.coordinateSystem;
	      var region = geo.getRegion(name);
	      return region && geo.dataToPoint(region.center);
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 2,
	    coordinateSystem: 'geo',
	    // map should be explicitly specified since ec3.
	    map: '',
	    // If `geoIndex` is not specified, a exclusive geo will be
	    // created. Otherwise use the specified geo component, and
	    // `map` and `mapType` are ignored.
	    // geoIndex: 0,
	    // 'center' | 'left' | 'right' | 'x%' | {number}
	    left: 'center',
	    // 'center' | 'top' | 'bottom' | 'x%' | {number}
	    top: 'center',
	    // right
	    // bottom
	    // width:
	    // height
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    aspectScale: 0.75,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    // 数值合并方式，默认加和，可选为：
	    // 'sum' | 'average' | 'max' | 'min'
	    // mapValueCalculation: 'sum',
	    // 地图数值计算结果小数精度
	    // mapValuePrecision: 0,
	    // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
	    showLegendSymbol: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    dataRangeHoverLink: true,
	    // 是否开启缩放及漫游模式
	    // roam: false,
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ],
	    // higher priority than center and zoom
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    label: {
	      show: false,
	      color: '#000'
	    },
	    // scaleLimit: null,
	    itemStyle: {
	      borderWidth: 0.5,
	      borderColor: '#444',
	      areaColor: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        areaColor: 'rgba(255,215,0,0.8)'
	      }
	    },
	    nameProperty: 'name'
	  }
	});
	zrUtil.mixin(MapSeries, dataSelectableMixin);
	var _default = MapSeries;
	module.exports = _default;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var MapDraw = __webpack_require__(823);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var HIGH_DOWN_PROP = '__seriesMapHighDown';
	var RECORD_VERSION_PROP = '__seriesMapCallKey';
	
	var _default = echarts.extendChartView({
	  type: 'map',
	  render: function (mapModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var group = this.group;
	    group.removeAll();
	
	    if (mapModel.getHostGeoModel()) {
	      return;
	    } // Not update map if it is an roam action from self
	
	
	    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
	      if (mapModel.needsDrawMap) {
	        var mapDraw = this._mapDraw || new MapDraw(api, true);
	        group.add(mapDraw.group);
	        mapDraw.draw(mapModel, ecModel, api, this, payload);
	        this._mapDraw = mapDraw;
	      } else {
	        // Remove drawed map
	        this._mapDraw && this._mapDraw.remove();
	        this._mapDraw = null;
	      }
	    } else {
	      var mapDraw = this._mapDraw;
	      mapDraw && group.add(mapDraw.group);
	    }
	
	    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
	  },
	  remove: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	    this.group.removeAll();
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	  },
	  _renderSymbols: function (mapModel, ecModel, api) {
	    var originalData = mapModel.originalData;
	    var group = this.group;
	    originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
	      if (isNaN(value)) {
	        return;
	      }
	
	      var layout = originalData.getItemLayout(originalDataIndex);
	
	      if (!layout || !layout.point) {
	        // Not exists in map
	        return;
	      }
	
	      var point = layout.point;
	      var offset = layout.offset;
	      var circle = new graphic.Circle({
	        style: {
	          // Because the special of map draw.
	          // Which needs statistic of multiple series and draw on one map.
	          // And each series also need a symbol with legend color
	          //
	          // Layout and visual are put one the different data
	          fill: mapModel.getData().getVisual('color')
	        },
	        shape: {
	          cx: point[0] + offset * 9,
	          cy: point[1],
	          r: 3
	        },
	        silent: true,
	        // Do not overlap the first series, on which labels are displayed.
	        z2: 8 + (!offset ? graphic.Z2_EMPHASIS_LIFT + 1 : 0)
	      }); // Only the series that has the first value on the same region is in charge of rendering the label.
	      // But consider the case:
	      // series: [
	      //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
	      //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
	      // ]
	      // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
	      // For backward compatibility, we follow the rule that render label `A` by the
	      // settings on series `X` but render label `C` by the settings on series `Y`.
	
	      if (!offset) {
	        var fullData = mapModel.mainSeries.getData();
	        var name = originalData.getName(originalDataIndex);
	        var fullIndex = fullData.indexOfName(name);
	        var itemModel = originalData.getItemModel(originalDataIndex);
	        var labelModel = itemModel.getModel('label');
	        var hoverLabelModel = itemModel.getModel('emphasis.label');
	        var regionGroup = fullData.getItemGraphicEl(fullIndex); // `getFormattedLabel` needs to use `getData` inside. Here
	        // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
	        // FIXME
	        // If this is not the `mainSeries`, the item model (like label formatter)
	        // set on original data item will never get. But it has been working
	        // like that from the begining, and this scenario is rarely encountered.
	        // So it won't be fixed until have to.
	
	        var normalText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'normal'), name);
	        var emphasisText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'emphasis'), normalText);
	        var highDownRecord = regionGroup[HIGH_DOWN_PROP];
	        var recordVersion = Math.random(); // Prevent from register listeners duplicatedly when roaming.
	
	        if (!highDownRecord) {
	          highDownRecord = regionGroup[HIGH_DOWN_PROP] = {};
	          var onEmphasis = zrUtil.curry(onRegionHighDown, true);
	          var onNormal = zrUtil.curry(onRegionHighDown, false);
	          regionGroup.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	        } // Prevent removed regions effect current grapics.
	
	
	        regionGroup[RECORD_VERSION_PROP] = recordVersion;
	        zrUtil.extend(highDownRecord, {
	          recordVersion: recordVersion,
	          circle: circle,
	          labelModel: labelModel,
	          hoverLabelModel: hoverLabelModel,
	          emphasisText: emphasisText,
	          normalText: normalText
	        }); // FIXME
	        // Consider set option when emphasis.
	
	        enterRegionHighDown(highDownRecord, false);
	      }
	
	      group.add(circle);
	    });
	  }
	});
	
	function onRegionHighDown(toHighOrDown) {
	  var highDownRecord = this[HIGH_DOWN_PROP];
	
	  if (highDownRecord && highDownRecord.recordVersion === this[RECORD_VERSION_PROP]) {
	    enterRegionHighDown(highDownRecord, toHighOrDown);
	  }
	}
	
	function enterRegionHighDown(highDownRecord, toHighOrDown) {
	  var circle = highDownRecord.circle;
	  var labelModel = highDownRecord.labelModel;
	  var hoverLabelModel = highDownRecord.hoverLabelModel;
	  var emphasisText = highDownRecord.emphasisText;
	  var normalText = highDownRecord.normalText;
	
	  if (toHighOrDown) {
	    circle.style.extendFrom(graphic.setTextStyle({}, hoverLabelModel, {
	      text: hoverLabelModel.get('show') ? emphasisText : null
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }, true)); // Make label upper than others if overlaps.
	
	    circle.__mapOriginalZ2 = circle.z2;
	    circle.z2 += graphic.Z2_EMPHASIS_LIFT;
	  } else {
	    graphic.setTextStyle(circle.style, labelModel, {
	      text: labelModel.get('show') ? normalText : null,
	      textPosition: labelModel.getShallow('position') || 'bottom'
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }); // Trigger normalize style like padding.
	
	    circle.dirty(false);
	
	    if (circle.__mapOriginalZ2 != null) {
	      circle.z2 = circle.__mapOriginalZ2;
	      circle.__mapOriginalZ2 = null;
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  // Save geoCoord
	  var mapSeries = [];
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'map') {
	      mapSeries.push(seriesOpt);
	      seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level
	
	      zrUtil.defaults(seriesOpt, seriesOpt.mapLocation);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME 公用？
	
	/**
	 * @param {Array.<module:echarts/data/List>} datas
	 * @param {string} statisticType 'average' 'sum'
	 * @inner
	 */
	function dataStatistics(datas, statisticType) {
	  var dataNameMap = {};
	  zrUtil.each(datas, function (data) {
	    data.each(data.mapDimension('value'), function (value, idx) {
	      // Add prefix to avoid conflict with Object.prototype.
	      var mapKey = 'ec-' + data.getName(idx);
	      dataNameMap[mapKey] = dataNameMap[mapKey] || [];
	
	      if (!isNaN(value)) {
	        dataNameMap[mapKey].push(value);
	      }
	    });
	  });
	  return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
	    var mapKey = 'ec-' + datas[0].getName(idx);
	    var sum = 0;
	    var min = Infinity;
	    var max = -Infinity;
	    var len = dataNameMap[mapKey].length;
	
	    for (var i = 0; i < len; i++) {
	      min = Math.min(min, dataNameMap[mapKey][i]);
	      max = Math.max(max, dataNameMap[mapKey][i]);
	      sum += dataNameMap[mapKey][i];
	    }
	
	    var result;
	
	    if (statisticType === 'min') {
	      result = min;
	    } else if (statisticType === 'max') {
	      result = max;
	    } else if (statisticType === 'average') {
	      result = sum / len;
	    } else {
	      result = sum;
	    }
	
	    return len === 0 ? NaN : result;
	  });
	}
	
	function _default(ecModel) {
	  var seriesGroups = {};
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var hostGeoModel = seriesModel.getHostGeoModel();
	    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
	    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
	  });
	  zrUtil.each(seriesGroups, function (seriesList, key) {
	    var data = dataStatistics(zrUtil.map(seriesList, function (seriesModel) {
	      return seriesModel.getData();
	    }), seriesList[0].get('mapValueCalculation'));
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].originalData = seriesList[i].getData();
	    } // FIXME Put where?
	
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].seriesGroup = seriesList;
	      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
	      seriesList[i].setData(data.cloneShallow());
	      seriesList[i].mainSeries = seriesList[0];
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var processedMapType = {};
	  ecModel.eachSeriesByType('map', function (mapSeries) {
	    var mapType = mapSeries.getMapType();
	
	    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
	      return;
	    }
	
	    var mapSymbolOffsets = {};
	    zrUtil.each(mapSeries.seriesGroup, function (subMapSeries) {
	      var geo = subMapSeries.coordinateSystem;
	      var data = subMapSeries.originalData;
	
	      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
	        data.each(data.mapDimension('value'), function (value, idx) {
	          var name = data.getName(idx);
	          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
	          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
	          // not be drawn. So here must validate if value is NaN.
	
	          if (!region || isNaN(value)) {
	            return;
	          }
	
	          var offset = mapSymbolOffsets[name] || 0;
	          var point = geo.dataToPoint(region.center);
	          mapSymbolOffsets[name] = offset + 1;
	          data.setItemLayout(idx, {
	            point: point,
	            offset: offset
	          });
	        });
	      }
	    }); // Show label of those region not has legendSymbol(which is offset 0)
	
	    var data = mapSeries.getData();
	    data.each(function (idx) {
	      var name = data.getName(idx);
	      var layout = data.getItemLayout(idx) || {};
	      layout.showLabel = !mapSymbolOffsets[name];
	      data.setItemLayout(idx, layout);
	    });
	    processedMapType[mapType] = true;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var colorList = seriesModel.get('color');
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var areaColor = itemStyleModel.get('areaColor');
	    var color = itemStyleModel.get('color') || colorList[seriesModel.seriesIndex % colorList.length];
	    seriesModel.getData().setVisual({
	      'areaColor': areaColor,
	      'color': color
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(830);
	
	__webpack_require__(1680);
	
	__webpack_require__(1681);
	
	var parallelVisual = __webpack_require__(1682);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(parallelVisual);

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var SeriesModel = __webpack_require__(66);
	
	var createListFromArray = __webpack_require__(113);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.parallel',
	  dependencies: ['parallel'],
	  visualColorAccessPath: 'lineStyle.color',
	  getInitialData: function (option, ecModel) {
	    var source = this.getSource();
	    setEncodeAndDimensions(source, this);
	    return createListFromArray(source, this);
	  },
	
	  /**
	   * User can get data raw indices on 'axisAreaSelected' event received.
	   *
	   * @public
	   * @param {string} activeState 'active' or 'inactive' or 'normal'
	   * @return {Array.<number>} Raw indices
	   */
	  getRawIndicesByActiveState: function (activeState) {
	    var coordSys = this.coordinateSystem;
	    var data = this.getData();
	    var indices = [];
	    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
	      if (activeState === theActiveState) {
	        indices.push(data.getRawIndex(dataIndex));
	      }
	    });
	    return indices;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'parallel',
	    parallelIndex: 0,
	    label: {
	      show: false
	    },
	    inactiveOpacity: 0.05,
	    activeOpacity: 1,
	    lineStyle: {
	      width: 1,
	      opacity: 0.45,
	      type: 'solid'
	    },
	    emphasis: {
	      label: {
	        show: false
	      }
	    },
	    progressive: 500,
	    smooth: false,
	    // true | false | number
	    animationEasing: 'linear'
	  }
	});
	
	function setEncodeAndDimensions(source, seriesModel) {
	  // The mapping of parallelAxis dimension to data dimension can
	  // be specified in parallelAxis.option.dim. For example, if
	  // parallelAxis.option.dim is 'dim3', it mapping to the third
	  // dimension of data. But `data.encode` has higher priority.
	  // Moreover, parallelModel.dimension should not be regarded as data
	  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
	  if (source.encodeDefine) {
	    return;
	  }
	
	  var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	
	  if (!parallelModel) {
	    return;
	  }
	
	  var encodeDefine = source.encodeDefine = createHashMap();
	  each(parallelModel.dimensions, function (axisDim) {
	    var dataDimIndex = convertDimNameToNumber(axisDim);
	    encodeDefine.set(axisDim, dataDimIndex);
	  });
	}
	
	function convertDimNameToNumber(dimName) {
	  return +dimName.replace('dim', '');
	}
	
	module.exports = _default;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var ChartView = __webpack_require__(103);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_SMOOTH = 0.3;
	var ParallelView = ChartView.extend({
	  type: 'parallel',
	  init: function () {
	    /**
	     * @type {module:zrender/container/Group}
	     * @private
	     */
	    this._dataGroup = new graphic.Group();
	    this.group.add(this._dataGroup);
	    /**
	     * @type {module:echarts/data/List}
	     */
	
	    this._data;
	    /**
	     * @type {boolean}
	     */
	
	    this._initialized;
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var dataGroup = this._dataGroup;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	    data.diff(oldData).add(add).update(update).remove(remove).execute();
	
	    function add(newDataIndex) {
	      var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function update(newDataIndex, oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
	      data.setItemGraphicEl(newDataIndex, line);
	      var animationModel = payload && payload.animation === false ? null : seriesModel;
	      graphic.updateProps(line, {
	        shape: {
	          points: points
	        }
	      }, animationModel, newDataIndex);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function remove(oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      dataGroup.remove(line);
	    } // First create
	
	
	    if (!this._initialized) {
	      this._initialized = true;
	      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
	        // Callback will be invoked immediately if there is no animation
	        setTimeout(function () {
	          dataGroup.removeClipPath();
	        });
	      });
	      dataGroup.setClipPath(clipPath);
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._initialized = true;
	    this._data = null;
	
	    this._dataGroup.removeAll();
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	
	    for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
	      var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
	      line.incremental = true;
	      updateElCommon(line, data, dataIndex, seriesScope);
	    }
	  },
	  dispose: function () {},
	  // _renderForProgressive: function (seriesModel) {
	  //     var dataGroup = this._dataGroup;
	  //     var data = seriesModel.getData();
	  //     var oldData = this._data;
	  //     var coordSys = seriesModel.coordinateSystem;
	  //     var dimensions = coordSys.dimensions;
	  //     var option = seriesModel.option;
	  //     var progressive = option.progressive;
	  //     var smooth = option.smooth ? SMOOTH : null;
	  //     // In progressive animation is disabled, so use simple data diff,
	  //     // which effects performance less.
	  //     // (Typically performance for data with length 7000+ like:
	  //     // simpleDiff: 60ms, addEl: 184ms,
	  //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
	  //     if (simpleDiff(oldData, data, dimensions)) {
	  //         dataGroup.removeAll();
	  //         data.each(function (dataIndex) {
	  //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
	  //         });
	  //     }
	  //     updateElCommon(data, progressive, smooth);
	  //     // Consider switch between progressive and not.
	  //     data.__plProgressive = true;
	  //     this._data = data;
	  // },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._dataGroup && this._dataGroup.removeAll();
	    this._data = null;
	  }
	});
	
	function createGridClipShape(coordSys, seriesModel, cb) {
	  var parallelModel = coordSys.model;
	  var rect = coordSys.getRect();
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    }
	  });
	  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
	  rectEl.setShape(dim, 0);
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width,
	      height: rect.height
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	function createLinePoints(data, dataIndex, dimensions, coordSys) {
	  var points = [];
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimName = dimensions[i];
	    var value = data.get(data.mapDimension(dimName), dataIndex);
	
	    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
	      points.push(coordSys.dataToPoint(value, dimName));
	    }
	  }
	
	  return points;
	}
	
	function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
	  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    },
	    silent: true,
	    z2: 10
	  });
	  dataGroup.add(line);
	  data.setItemGraphicEl(dataIndex, line);
	  return line;
	}
	
	function makeSeriesScope(seriesModel) {
	  var smooth = seriesModel.get('smooth', true);
	  smooth === true && (smooth = DEFAULT_SMOOTH);
	  return {
	    lineStyle: seriesModel.getModel('lineStyle').getLineStyle(),
	    smooth: smooth != null ? smooth : DEFAULT_SMOOTH
	  };
	}
	
	function updateElCommon(el, data, dataIndex, seriesScope) {
	  var lineStyle = seriesScope.lineStyle;
	
	  if (data.hasItemOption) {
	    var lineStyleModel = data.getItemModel(dataIndex).getModel('lineStyle');
	    lineStyle = lineStyleModel.getLineStyle();
	  }
	
	  el.useStyle(lineStyle);
	  var elStyle = el.style;
	  elStyle.fill = null; // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.
	
	  elStyle.stroke = data.getItemVisual(dataIndex, 'color'); // lineStyle.opacity have been set to itemVisual in parallelVisual.
	
	  elStyle.opacity = data.getItemVisual(dataIndex, 'opacity');
	  seriesScope.smooth && (el.shape.smooth = seriesScope.smooth);
	} // function simpleDiff(oldData, newData, dimensions) {
	//     var oldLen;
	//     if (!oldData
	//         || !oldData.__plProgressive
	//         || (oldLen = oldData.count()) !== newData.count()
	//     ) {
	//         return true;
	//     }
	//     var dimLen = dimensions.length;
	//     for (var i = 0; i < oldLen; i++) {
	//         for (var j = 0; j < dimLen; j++) {
	//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
	//                 return true;
	//             }
	//         }
	//     }
	//     return false;
	// }
	// FIXME
	// 公用方法?
	
	
	function isEmptyValue(val, axisType) {
	  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
	}
	
	var _default = ParallelView;
	module.exports = _default;

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var opacityAccessPath = ['lineStyle', 'normal', 'opacity'];
	var _default = {
	  seriesType: 'parallel',
	  reset: function (seriesModel, ecModel, api) {
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var globalColors = ecModel.get('color');
	    var color = lineStyleModel.get('color') || itemStyleModel.get('color') || globalColors[seriesModel.seriesIndex % globalColors.length];
	    var inactiveOpacity = seriesModel.get('inactiveOpacity');
	    var activeOpacity = seriesModel.get('activeOpacity');
	    var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var opacityMap = {
	      normal: lineStyle.opacity,
	      active: activeOpacity,
	      inactive: inactiveOpacity
	    };
	    data.setVisual('color', color);
	
	    function progress(params, data) {
	      coordSys.eachActiveState(data, function (activeState, dataIndex) {
	        var opacity = opacityMap[activeState];
	
	        if (activeState === 'normal' && data.hasItemOption) {
	          var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath, true);
	          itemOpacity != null && (opacity = itemOpacity);
	        }
	
	        data.setItemVisual(dataIndex, 'opacity', opacity);
	      }, params.start, params.end);
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	__webpack_require__(427);
	
	__webpack_require__(1616);
	
	__webpack_require__(1617);
	
	var _barGrid = __webpack_require__(272);
	
	var layout = _barGrid.layout;
	
	var visualSymbol = __webpack_require__(145);
	
	__webpack_require__(217);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(zrUtil.curry(layout, 'pictorialBar'));
	echarts.registerVisual(visualSymbol('pictorialBar', 'roundRect'));

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	__webpack_require__(1685);
	
	__webpack_require__(1686);
	
	var createDataSelectAction = __webpack_require__(798);
	
	var dataColor = __webpack_require__(276);
	
	var pieLayout = __webpack_require__(1688);
	
	var dataFilter = __webpack_require__(223);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	createDataSelectAction('pie', [{
	  type: 'pieToggleSelect',
	  event: 'pieselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'pieSelect',
	  event: 'pieselected',
	  method: 'select'
	}, {
	  type: 'pieUnSelect',
	  event: 'pieunselected',
	  method: 'unSelect'
	}]);
	echarts.registerVisual(dataColor('pie'));
	echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
	echarts.registerProcessor(dataFilter('pie'));

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var createListSimply = __webpack_require__(170);
	
	var zrUtil = __webpack_require__(2);
	
	var modelUtil = __webpack_require__(27);
	
	var _number = __webpack_require__(24);
	
	var getPercentWithPrecision = _number.getPercentWithPrecision;
	
	var dataSelectableMixin = __webpack_require__(422);
	
	var _dataProvider = __webpack_require__(143);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var _sourceHelper = __webpack_require__(114);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	var LegendVisualProvider = __webpack_require__(225);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PieSeries = echarts.extendSeriesModel({
	  type: 'series.pie',
	  // Overwrite
	  init: function (option) {
	    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	    this.updateSelectedMap(this._createSelectableList());
	
	    this._defaultLabelLine(option);
	  },
	  // Overwrite
	  mergeOption: function (newOption) {
	    PieSeries.superCall(this, 'mergeOption', newOption);
	    this.updateSelectedMap(this._createSelectableList());
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	  },
	  _createSelectableList: function () {
	    var data = this.getRawData();
	    var valueDim = data.mapDimension('value');
	    var targetList = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      targetList.push({
	        name: data.getName(i),
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    return targetList;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?
	
	    var valueList = [];
	    data.each(data.mapDimension('value'), function (value) {
	      valueList.push(value);
	    });
	    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
	    params.$vars.push('percent');
	    return params;
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    modelUtil.defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    // If the angle of a sector less than `minShowLabelAngle`,
	    // the label will not be displayed.
	    minShowLabelAngle: 0,
	    // 选中时扇区偏移量
	    selectedOffset: 10,
	    // 高亮扇区偏移量
	    hoverOffset: 10,
	    // If use strategy to avoid label overlapping
	    avoidLabelOverlap: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
	    // roseType: null,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // cursor: null,
	    left: 0,
	    top: 0,
	    right: 0,
	    bottom: 0,
	    width: null,
	    height: null,
	    label: {
	      // If rotate around circle
	      rotate: false,
	      show: true,
	      // 'outer', 'inside', 'center'
	      position: 'outer',
	      // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
	      alignTo: 'none',
	      // Closest distance between label and chart edge.
	      // Works only position is 'outer' and alignTo is 'edge'.
	      margin: '25%',
	      // Works only position is 'outer' and alignTo is not 'edge'.
	      bleedMargin: 10,
	      // Distance between text and label line.
	      distanceToLabelLine: 5 // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	      // 默认使用全局文本样式，详见TEXTSTYLE
	      // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
	
	    },
	    // Enabled when label.normal.position is 'outer'
	    labelLine: {
	      show: true,
	      // 引导线两段中的第一段长度
	      length: 15,
	      // 引导线两段中的第二段长度
	      length2: 15,
	      smooth: false,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      borderWidth: 1
	    },
	    // Animation type. Valid values: expansion, scale
	    animationType: 'expansion',
	    // Animation type when update. Valid values: transition, expansion
	    animationTypeUpdate: 'transition',
	    animationEasing: 'cubicOut'
	  }
	});
	zrUtil.mixin(PieSeries, dataSelectableMixin);
	var _default = PieSeries;
	module.exports = _default;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var ChartView = __webpack_require__(103);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	function updateDataSelected(uid, seriesModel, hasAnimation, api) {
	  var data = seriesModel.getData();
	  var dataIndex = this.dataIndex;
	  var name = data.getName(dataIndex);
	  var selectedOffset = seriesModel.get('selectedOffset');
	  api.dispatchAction({
	    type: 'pieToggleSelect',
	    from: uid,
	    name: name,
	    seriesId: seriesModel.id
	  });
	  data.each(function (idx) {
	    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
	  });
	}
	/**
	 * @param {module:zrender/graphic/Sector} el
	 * @param {Object} layout
	 * @param {boolean} isSelected
	 * @param {number} selectedOffset
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	
	
	function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var offset = isSelected ? selectedOffset : 0;
	  var position = [dx * offset, dy * offset];
	  hasAnimation // animateTo will stop revious animation like update transition
	  ? el.animate().when(200, {
	    position: position
	  }).start('bounceOut') : el.attr('position', position);
	}
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function PiePiece(data, idx) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: 2
	  });
	  var polyline = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(sector);
	  this.add(polyline);
	  this.add(text);
	  this.updateData(data, idx, true);
	}
	
	var piePieceProto = PiePiece.prototype;
	
	piePieceProto.updateData = function (data, idx, firstCreate) {
	  var sector = this.childAt(0);
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var animationTypeUpdate = seriesModel.getShallow('animationTypeUpdate');
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    var animationType = seriesModel.getShallow('animationType');
	
	    if (animationType === 'scale') {
	      sector.shape.r = layout.r0;
	      graphic.initProps(sector, {
	        shape: {
	          r: layout.r
	        }
	      }, seriesModel, idx);
	    } // Expansion
	    else {
	        sector.shape.endAngle = layout.startAngle;
	        graphic.updateProps(sector, {
	          shape: {
	            endAngle: layout.endAngle
	          }
	        }, seriesModel, idx);
	      }
	  } else {
	    if (animationTypeUpdate === 'expansion') {
	      // Sectors are set to be target shape and an overlaying clipPath is used for animation
	      sector.setShape(sectorShape);
	    } else {
	      // Transition animation from the old shape
	      graphic.updateProps(sector, {
	        shape: sectorShape
	      }, seriesModel, idx);
	    }
	  } // Update common style
	
	
	  var visualColor = data.getItemVisual(idx, 'color');
	  sector.useStyle(zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: visualColor
	  }, itemModel.getModel('itemStyle').getItemStyle()));
	  sector.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected
	
	  toggleItemSelected(this, data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), seriesModel.get('selectedOffset'), seriesModel.get('animation')); // Label and text animation should be applied only for transition type animation when update
	
	  var withAnimation = !firstCreate && animationTypeUpdate === 'transition';
	
	  this._updateLabel(data, idx, withAnimation);
	
	  this.highDownOnUpdate = !seriesModel.get('silent') ? function (fromState, toState) {
	    var hasAnimation = seriesModel.isAnimationEnabled() && itemModel.get('hoverAnimation');
	
	    if (toState === 'emphasis') {
	      labelLine.ignore = labelLine.hoverIgnore;
	      labelText.ignore = labelText.hoverIgnore; // Sector may has animation of updating data. Force to move to the last frame
	      // Or it may stopped on the wrong shape
	
	      if (hasAnimation) {
	        sector.stopAnimation(true);
	        sector.animateTo({
	          shape: {
	            r: layout.r + seriesModel.get('hoverOffset')
	          }
	        }, 300, 'elasticOut');
	      }
	    } else {
	      labelLine.ignore = labelLine.normalIgnore;
	      labelText.ignore = labelText.normalIgnore;
	
	      if (hasAnimation) {
	        sector.stopAnimation(true);
	        sector.animateTo({
	          shape: {
	            r: layout.r
	          }
	        }, 300, 'elasticOut');
	      }
	    }
	  } : null;
	  graphic.setHoverStyle(this);
	};
	
	piePieceProto._updateLabel = function (data, idx, withAnimation) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	
	  if (!labelLayout || isNaN(labelLayout.x) || isNaN(labelLayout.y)) {
	    labelText.ignore = labelText.normalIgnore = labelText.hoverIgnore = labelLine.ignore = labelLine.normalIgnore = labelLine.hoverIgnore = true;
	    return;
	  }
	
	  var targetLineShape = {
	    points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
	  };
	  var targetTextStyle = {
	    x: labelLayout.x,
	    y: labelLayout.y
	  };
	
	  if (withAnimation) {
	    graphic.updateProps(labelLine, {
	      shape: targetLineShape
	    }, seriesModel, idx);
	    graphic.updateProps(labelText, {
	      style: targetTextStyle
	    }, seriesModel, idx);
	  } else {
	    labelLine.attr({
	      shape: targetLineShape
	    });
	    labelText.attr({
	      style: targetTextStyle
	    });
	  }
	
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: labelLayout.text,
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	  var smooth = labelLineModel.get('smooth');
	
	  if (smooth && smooth === true) {
	    smooth = 0.4;
	  }
	
	  labelLine.setShape({
	    smooth: smooth
	  });
	};
	
	zrUtil.inherits(PiePiece, graphic.Group); // Pie view
	
	var PieView = ChartView.extend({
	  type: 'pie',
	  init: function () {
	    var sectorGroup = new graphic.Group();
	    this._sectorGroup = sectorGroup;
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    if (payload && payload.from === this.uid) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var hasAnimation = ecModel.get('animation');
	    var isFirstRender = !oldData;
	    var animationType = seriesModel.get('animationType');
	    var animationTypeUpdate = seriesModel.get('animationTypeUpdate');
	    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
	    var selectedMode = seriesModel.get('selectedMode');
	    data.diff(oldData).add(function (idx) {
	      var piePiece = new PiePiece(data, idx); // Default expansion animation
	
	      if (isFirstRender && animationType !== 'scale') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      selectedMode && piePiece.on('click', onSectorClick);
	      data.setItemGraphicEl(idx, piePiece);
	      group.add(piePiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	
	      if (!isFirstRender && animationTypeUpdate !== 'transition') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      piePiece.updateData(data, newIdx);
	      piePiece.off('click');
	      selectedMode && piePiece.on('click', onSectorClick);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	
	    if (hasAnimation && data.count() > 0 && (isFirstRender ? animationType !== 'scale' : animationTypeUpdate !== 'transition')) {
	      var shape = data.getItemLayout(0);
	
	      for (var s = 1; isNaN(shape.startAngle) && s < data.count(); ++s) {
	        shape = data.getItemLayout(s);
	      }
	
	      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
	      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
	      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel, isFirstRender));
	    } else {
	      // clipPath is used in first-time animation, so remove it when otherwise. See: #8994
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  dispose: function () {},
	  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel, isFirstRender) {
	    var clipPath = new graphic.Sector({
	      shape: {
	        cx: cx,
	        cy: cy,
	        r0: 0,
	        r: r,
	        startAngle: startAngle,
	        endAngle: startAngle,
	        clockwise: clockwise
	      }
	    });
	    var initOrUpdate = isFirstRender ? graphic.initProps : graphic.updateProps;
	    initOrUpdate(clipPath, {
	      shape: {
	        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
	      }
	    }, seriesModel, cb);
	    return clipPath;
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var data = seriesModel.getData();
	    var itemLayout = data.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = PieView;
	module.exports = _default;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(86);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME emphasis label position is not same with normal label position
	var RADIAN = Math.PI / 180;
	
	function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
	  list.sort(function (a, b) {
	    return a.y - b.y;
	  });
	
	  function shiftDown(start, end, delta, dir) {
	    for (var j = start; j < end; j++) {
	      if (list[j].y + delta > viewTop + viewHeight) {
	        break;
	      }
	
	      list[j].y += delta;
	
	      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
	        shiftUp(j, delta / 2);
	        return;
	      }
	    }
	
	    shiftUp(end - 1, delta / 2);
	  }
	
	  function shiftUp(end, delta) {
	    for (var j = end; j >= 0; j--) {
	      if (list[j].y - delta < viewTop) {
	        break;
	      }
	
	      list[j].y -= delta;
	
	      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
	        break;
	      }
	    }
	  }
	
	  function changeX(list, isDownList, cx, cy, r, dir) {
	    var lastDeltaX = dir > 0 ? isDownList // right-side
	    ? Number.MAX_VALUE // down
	    : 0 // up
	    : isDownList // left-side
	    ? Number.MAX_VALUE // down
	    : 0; // up
	
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].labelAlignTo !== 'none') {
	        continue;
	      }
	
	      var deltaY = Math.abs(list[i].y - cy);
	      var length = list[i].len;
	      var length2 = list[i].len2;
	      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);
	
	      if (isDownList && deltaX >= lastDeltaX) {
	        // right-down, left-down
	        deltaX = lastDeltaX - 10;
	      }
	
	      if (!isDownList && deltaX <= lastDeltaX) {
	        // right-up, left-up
	        deltaX = lastDeltaX + 10;
	      }
	
	      list[i].x = cx + deltaX * dir;
	      lastDeltaX = deltaX;
	    }
	  }
	
	  var lastY = 0;
	  var delta;
	  var len = list.length;
	  var upList = [];
	  var downList = [];
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
	      var dx = list[i].x - farthestX;
	      list[i].linePoints[1][0] += dx;
	      list[i].x = farthestX;
	    }
	
	    delta = list[i].y - lastY;
	
	    if (delta < 0) {
	      shiftDown(i, len, -delta, dir);
	    }
	
	    lastY = list[i].y + list[i].height;
	  }
	
	  if (viewHeight - lastY < 0) {
	    shiftUp(len - 1, lastY - viewHeight);
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].y >= cy) {
	      downList.push(list[i]);
	    } else {
	      upList.push(list[i]);
	    }
	  }
	
	  changeX(upList, false, cx, cy, r, dir);
	  changeX(downList, true, cx, cy, r, dir);
	}
	
	function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
	  var leftList = [];
	  var rightList = [];
	  var leftmostX = Number.MAX_VALUE;
	  var rightmostX = -Number.MAX_VALUE;
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    if (isPositionCenter(labelLayoutList[i])) {
	      continue;
	    }
	
	    if (labelLayoutList[i].x < cx) {
	      leftmostX = Math.min(leftmostX, labelLayoutList[i].x);
	      leftList.push(labelLayoutList[i]);
	    } else {
	      rightmostX = Math.max(rightmostX, labelLayoutList[i].x);
	      rightList.push(labelLayoutList[i]);
	    }
	  }
	
	  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
	  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    var layout = labelLayoutList[i];
	
	    if (isPositionCenter(layout)) {
	      continue;
	    }
	
	    var linePoints = layout.linePoints;
	
	    if (linePoints) {
	      var isAlignToEdge = layout.labelAlignTo === 'edge';
	      var realTextWidth = layout.textRect.width;
	      var targetTextWidth;
	
	      if (isAlignToEdge) {
	        if (layout.x < cx) {
	          targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.labelMargin;
	        } else {
	          targetTextWidth = viewLeft + viewWidth - layout.labelMargin - linePoints[2][0] - layout.labelDistance;
	        }
	      } else {
	        if (layout.x < cx) {
	          targetTextWidth = layout.x - viewLeft - layout.bleedMargin;
	        } else {
	          targetTextWidth = viewLeft + viewWidth - layout.x - layout.bleedMargin;
	        }
	      }
	
	      if (targetTextWidth < layout.textRect.width) {
	        layout.text = textContain.truncateText(layout.text, targetTextWidth, layout.font);
	
	        if (layout.labelAlignTo === 'edge') {
	          realTextWidth = textContain.getWidth(layout.text, layout.font);
	        }
	      }
	
	      var dist = linePoints[1][0] - linePoints[2][0];
	
	      if (isAlignToEdge) {
	        if (layout.x < cx) {
	          linePoints[2][0] = viewLeft + layout.labelMargin + realTextWidth + layout.labelDistance;
	        } else {
	          linePoints[2][0] = viewLeft + viewWidth - layout.labelMargin - realTextWidth - layout.labelDistance;
	        }
	      } else {
	        if (layout.x < cx) {
	          linePoints[2][0] = layout.x + layout.labelDistance;
	        } else {
	          linePoints[2][0] = layout.x - layout.labelDistance;
	        }
	
	        linePoints[1][0] = linePoints[2][0] + dist;
	      }
	
	      linePoints[1][1] = linePoints[2][1] = layout.y;
	    }
	  }
	}
	
	function isPositionCenter(layout) {
	  // Not change x for center label
	  return layout.position === 'center';
	}
	
	function _default(seriesModel, r, viewWidth, viewHeight, viewLeft, viewTop) {
	  var data = seriesModel.getData();
	  var labelLayoutList = [];
	  var cx;
	  var cy;
	  var hasLabelRotate = false;
	  var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * RADIAN;
	  data.each(function (idx) {
	    var layout = data.getItemLayout(idx);
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis
	
	    var labelPosition = labelModel.get('position') || itemModel.get('emphasis.label.position');
	    var labelDistance = labelModel.get('distanceToLabelLine');
	    var labelAlignTo = labelModel.get('alignTo');
	    var labelMargin = parsePercent(labelModel.get('margin'), viewWidth);
	    var bleedMargin = labelModel.get('bleedMargin');
	    var font = labelModel.getFont();
	    var labelLineModel = itemModel.getModel('labelLine');
	    var labelLineLen = labelLineModel.get('length');
	    labelLineLen = parsePercent(labelLineLen, viewWidth);
	    var labelLineLen2 = labelLineModel.get('length2');
	    labelLineLen2 = parsePercent(labelLineLen2, viewWidth);
	
	    if (layout.angle < minShowLabelRadian) {
	      return;
	    }
	
	    var midAngle = (layout.startAngle + layout.endAngle) / 2;
	    var dx = Math.cos(midAngle);
	    var dy = Math.sin(midAngle);
	    var textX;
	    var textY;
	    var linePoints;
	    var textAlign;
	    cx = layout.cx;
	    cy = layout.cy;
	    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
	    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
	    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
	
	    if (labelPosition === 'center') {
	      textX = layout.cx;
	      textY = layout.cy;
	      textAlign = 'center';
	    } else {
	      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
	      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
	      textX = x1 + dx * 3;
	      textY = y1 + dy * 3;
	
	      if (!isLabelInside) {
	        // For roseType
	        var x2 = x1 + dx * (labelLineLen + r - layout.r);
	        var y2 = y1 + dy * (labelLineLen + r - layout.r);
	        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
	        var y3 = y2;
	
	        if (labelAlignTo === 'edge') {
	          // Adjust textX because text align of edge is opposite
	          textX = dx < 0 ? viewLeft + labelMargin : viewLeft + viewWidth - labelMargin;
	        } else {
	          textX = x3 + (dx < 0 ? -labelDistance : labelDistance);
	        }
	
	        textY = y3;
	        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
	      }
	
	      textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? dx > 0 ? 'right' : 'left' : dx > 0 ? 'left' : 'right';
	    }
	
	    var labelRotate;
	    var rotate = labelModel.get('rotate');
	
	    if (typeof rotate === 'number') {
	      labelRotate = rotate * (Math.PI / 180);
	    } else {
	      labelRotate = rotate ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
	    }
	
	    hasLabelRotate = !!labelRotate;
	    layout.label = {
	      x: textX,
	      y: textY,
	      position: labelPosition,
	      height: textRect.height,
	      len: labelLineLen,
	      len2: labelLineLen2,
	      linePoints: linePoints,
	      textAlign: textAlign,
	      verticalAlign: 'middle',
	      rotation: labelRotate,
	      inside: isLabelInside,
	      labelDistance: labelDistance,
	      labelAlignTo: labelAlignTo,
	      labelMargin: labelMargin,
	      bleedMargin: bleedMargin,
	      textRect: textRect,
	      text: text,
	      font: font
	    }; // Not layout the inside label
	
	    if (!isLabelInside) {
	      labelLayoutList.push(layout.label);
	    }
	  });
	
	  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
	    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	var layout = __webpack_require__(47);
	
	var labelLayout = __webpack_require__(1687);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var viewRect = getViewRect(seriesModel, api);
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = parsePercent(viewRect.width, api.getWidth());
	    var height = parsePercent(viewRect.height, api.getHeight());
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width) + viewRect.x;
	    var cy = parsePercent(center[1], height) + viewRect.y;
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var validDataCount = 0;
	    data.each(valueDim, function (value) {
	      !isNaN(value) && validDataCount++;
	    });
	    var sum = data.getSum(valueDim); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var clockwise = seriesModel.get('clockwise');
	    var roseType = seriesModel.get('roseType');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]
	
	    var extent = data.getDataExtent(valueDim);
	    extent[0] = 0; // In the case some sector angle is smaller than minAngle
	
	    var restAngle = PI2;
	    var valueSumLargerThanMinAngle = 0;
	    var currentAngle = startAngle;
	    var dir = clockwise ? 1 : -1;
	    data.each(valueDim, function (value, idx) {
	      var angle;
	
	      if (isNaN(value)) {
	        data.setItemLayout(idx, {
	          angle: NaN,
	          startAngle: NaN,
	          endAngle: NaN,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: r0,
	          r: roseType ? NaN : r,
	          viewRect: viewRect
	        });
	        return;
	      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
	
	
	      if (roseType !== 'area') {
	        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	      } else {
	        angle = PI2 / validDataCount;
	      }
	
	      if (angle < minAngle) {
	        angle = minAngle;
	        restAngle -= minAngle;
	      } else {
	        valueSumLargerThanMinAngle += value;
	      }
	
	      var endAngle = currentAngle + dir * angle;
	      data.setItemLayout(idx, {
	        angle: angle,
	        startAngle: currentAngle,
	        endAngle: endAngle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: roseType ? linearMap(value, extent, [r0, r]) : r,
	        viewRect: viewRect
	      });
	      currentAngle = endAngle;
	    }); // Some sector is constrained by minAngle
	    // Rest sectors needs recalculate angle
	
	    if (restAngle < PI2 && validDataCount) {
	      // Average the angle if rest angle is not enough after all angles is
	      // Constrained by minAngle
	      if (restAngle <= 1e-3) {
	        var angle = PI2 / validDataCount;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            layout.angle = angle;
	            layout.startAngle = startAngle + dir * idx * angle;
	            layout.endAngle = startAngle + dir * (idx + 1) * angle;
	          }
	        });
	      } else {
	        unitRadian = restAngle / valueSumLargerThanMinAngle;
	        currentAngle = startAngle;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
	            layout.startAngle = currentAngle;
	            layout.endAngle = currentAngle + dir * angle;
	            currentAngle += dir * angle;
	          }
	        });
	      }
	    }
	
	    labelLayout(seriesModel, r, viewRect.width, viewRect.height, viewRect.x, viewRect.y);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1779);
	
	__webpack_require__(1690);
	
	__webpack_require__(1691);
	
	var dataColor = __webpack_require__(276);
	
	var visualSymbol = __webpack_require__(145);
	
	var radarLayout = __webpack_require__(1693);
	
	var dataFilter = __webpack_require__(223);
	
	var backwardCompat = __webpack_require__(1692);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Must use radar component
	echarts.registerVisual(dataColor('radar'));
	echarts.registerVisual(visualSymbol('radar', 'circle'));
	echarts.registerLayout(radarLayout);
	echarts.registerProcessor(dataFilter('radar'));
	echarts.registerPreprocessor(backwardCompat);

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(66);
	
	var createListSimply = __webpack_require__(170);
	
	var zrUtil = __webpack_require__(2);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var LegendVisualProvider = __webpack_require__(225);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var RadarSeries = SeriesModel.extend({
	  type: 'series.radar',
	  dependencies: ['radar'],
	  // Overwrite
	  init: function (option) {
	    RadarSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      generateCoord: 'indicator_',
	      generateCoordCount: Infinity
	    });
	  },
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var data = this.getData();
	    var coordSys = this.coordinateSystem;
	    var indicatorAxes = coordSys.getIndicatorAxes();
	    var name = this.getData().getName(dataIndex);
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    return encodeHTML(name === '' ? this.name : name) + newLine + zrUtil.map(indicatorAxes, function (axis, idx) {
	      var val = data.get(data.mapDimension(axis.dim), dataIndex);
	      return encodeHTML(axis.name + ' : ' + val);
	    }).join(newLine);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var data = this.getData();
	      var coordSys = this.coordinateSystem;
	      var values = data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }), dataIndex, true);
	
	      for (var i = 0, len = values.length; i < len; i++) {
	        if (!isNaN(values[i])) {
	          var indicatorAxes = coordSys.getIndicatorAxes();
	          return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
	        }
	      }
	    }
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'radar',
	    legendHoverLink: true,
	    radarIndex: 0,
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    label: {
	      position: 'top'
	    },
	    // areaStyle: {
	    // },
	    // itemStyle: {}
	    symbol: 'emptyCircle',
	    symbolSize: 4 // symbolRotate: null
	
	  }
	});
	var _default = RadarSeries;
	module.exports = _default;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var graphic = __webpack_require__(17);
	
	var zrUtil = __webpack_require__(2);
	
	var symbolUtil = __webpack_require__(89);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	var _default = echarts.extendChartView({
	  type: 'radar',
	  render: function (seriesModel, ecModel, api) {
	    var polar = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	
	    function createSymbol(data, idx) {
	      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	      var color = data.getItemVisual(idx, 'color');
	
	      if (symbolType === 'none') {
	        return;
	      }
	
	      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	      var symbolPath = symbolUtil.createSymbol(symbolType, -1, -1, 2, 2, color);
	      var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
	      symbolPath.attr({
	        style: {
	          strokeNoScale: true
	        },
	        z2: 100,
	        scale: [symbolSize[0] / 2, symbolSize[1] / 2],
	        rotation: symbolRotate * Math.PI / 180 || 0
	      });
	      return symbolPath;
	    }
	
	    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
	      // Simply rerender all
	      symbolGroup.removeAll();
	
	      for (var i = 0; i < newPoints.length - 1; i++) {
	        var symbolPath = createSymbol(data, idx);
	
	        if (symbolPath) {
	          symbolPath.__dimIdx = i;
	
	          if (oldPoints[i]) {
	            symbolPath.attr('position', oldPoints[i]);
	            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
	              position: newPoints[i]
	            }, seriesModel, idx);
	          } else {
	            symbolPath.attr('position', newPoints[i]);
	          }
	
	          symbolGroup.add(symbolPath);
	        }
	      }
	    }
	
	    function getInitialPoints(points) {
	      return zrUtil.map(points, function (pt) {
	        return [polar.cx, polar.cy];
	      });
	    }
	
	    data.diff(oldData).add(function (idx) {
	      var points = data.getItemLayout(idx);
	
	      if (!points) {
	        return;
	      }
	
	      var polygon = new graphic.Polygon();
	      var polyline = new graphic.Polyline();
	      var target = {
	        shape: {
	          points: points
	        }
	      };
	      polygon.shape.points = getInitialPoints(points);
	      polyline.shape.points = getInitialPoints(points);
	      graphic.initProps(polygon, target, seriesModel, idx);
	      graphic.initProps(polyline, target, seriesModel, idx);
	      var itemGroup = new graphic.Group();
	      var symbolGroup = new graphic.Group();
	      itemGroup.add(polyline);
	      itemGroup.add(polygon);
	      itemGroup.add(symbolGroup);
	      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
	      data.setItemGraphicEl(idx, itemGroup);
	    }).update(function (newIdx, oldIdx) {
	      var itemGroup = oldData.getItemGraphicEl(oldIdx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var target = {
	        shape: {
	          points: data.getItemLayout(newIdx)
	        }
	      };
	
	      if (!target.shape.points) {
	        return;
	      }
	
	      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
	      graphic.updateProps(polyline, target, seriesModel);
	      graphic.updateProps(polygon, target, seriesModel);
	      data.setItemGraphicEl(newIdx, itemGroup);
	    }).remove(function (idx) {
	      group.remove(oldData.getItemGraphicEl(idx));
	    }).execute();
	    data.eachItemGraphicEl(function (itemGroup, idx) {
	      var itemModel = data.getItemModel(idx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var color = data.getItemVisual(idx, 'color');
	      group.add(itemGroup);
	      polyline.useStyle(zrUtil.defaults(itemModel.getModel('lineStyle').getLineStyle(), {
	        fill: 'none',
	        stroke: color
	      }));
	      polyline.hoverStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	      var areaStyleModel = itemModel.getModel('areaStyle');
	      var hoverAreaStyleModel = itemModel.getModel('emphasis.areaStyle');
	      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
	      var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
	      hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
	      polygon.ignore = polygonIgnore;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: color,
	        opacity: 0.7
	      }));
	      polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
	      var itemStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	      var itemHoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      symbolGroup.eachChild(function (symbolPath) {
	        symbolPath.setStyle(itemStyle);
	        symbolPath.hoverStyle = zrUtil.clone(itemHoverStyle);
	        var defaultText = data.get(data.dimensions[symbolPath.__dimIdx], idx);
	        (defaultText == null || isNaN(defaultText)) && (defaultText = '');
	        graphic.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
	          labelFetcher: data.hostModel,
	          labelDataIndex: idx,
	          labelDimIndex: symbolPath.__dimIdx,
	          defaultText: defaultText,
	          autoColor: color,
	          isRectText: true
	        });
	      });
	
	      itemGroup.highDownOnUpdate = function (fromState, toState) {
	        polygon.attr('ignore', toState === 'emphasis' ? hoverPolygonIgnore : polygonIgnore);
	      };
	
	      graphic.setHoverStyle(itemGroup);
	    });
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Backward compat for radar chart in 2
	function _default(option) {
	  var polarOptArr = option.polar;
	
	  if (polarOptArr) {
	    if (!zrUtil.isArray(polarOptArr)) {
	      polarOptArr = [polarOptArr];
	    }
	
	    var polarNotRadar = [];
	    zrUtil.each(polarOptArr, function (polarOpt, idx) {
	      if (polarOpt.indicator) {
	        if (polarOpt.type && !polarOpt.shape) {
	          polarOpt.shape = polarOpt.type;
	        }
	
	        option.radar = option.radar || [];
	
	        if (!zrUtil.isArray(option.radar)) {
	          option.radar = [option.radar];
	        }
	
	        option.radar.push(polarOpt);
	      } else {
	        polarNotRadar.push(polarOpt);
	      }
	    });
	    option.polar = polarNotRadar;
	  }
	
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
	      seriesOpt.radarIndex = seriesOpt.polarIndex;
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('radar', function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (!coordSys) {
	      return;
	    }
	
	    var axes = coordSys.getIndicatorAxes();
	    zrUtil.each(axes, function (axis, axisIndex) {
	      data.each(data.mapDimension(axes[axisIndex].dim), function (val, dataIndex) {
	        points[dataIndex] = points[dataIndex] || [];
	        var point = coordSys.dataToPoint(val, axisIndex);
	        points[dataIndex][axisIndex] = isValidPoint(point) ? point : getValueMissingPoint(coordSys);
	      });
	    }); // Close polygon
	
	    data.each(function (idx) {
	      // TODO
	      // Is it appropriate to connect to the next data when some data is missing?
	      // Or, should trade it like `connectNull` in line chart?
	      var firstPoint = zrUtil.find(points[idx], function (point) {
	        return isValidPoint(point);
	      }) || getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array
	
	      points[idx].push(firstPoint.slice());
	      data.setItemLayout(idx, points[idx]);
	    });
	  });
	}
	
	function isValidPoint(point) {
	  return !isNaN(point[0]) && !isNaN(point[1]);
	}
	
	function getValueMissingPoint(coordSys) {
	  // It is error-prone to input [NaN, NaN] into polygon, polygon.
	  // (probably cause problem when refreshing or animating)
	  return [coordSys.cx, coordSys.cy];
	}
	
	module.exports = _default;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1695);
	
	__webpack_require__(1696);
	
	__webpack_require__(1697);
	
	var sankeyLayout = __webpack_require__(1698);
	
	var sankeyVisual = __webpack_require__(1699);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(sankeyLayout);
	echarts.registerVisual(sankeyVisual);

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(66);
	
	var createGraphFromNodeEdge = __webpack_require__(806);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var Model = __webpack_require__(57);
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SankeySeries = SeriesModel.extend({
	  type: 'series.sankey',
	  layoutInfo: null,
	  levelModels: null,
	
	  /**
	   * Init a graph data structure from data in option series
	   *
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option, ecModel) {
	    var links = option.edges || option.links;
	    var nodes = option.data || option.nodes;
	    var levels = option.levels;
	    var levelModels = this.levelModels = {};
	
	    for (var i = 0; i < levels.length; i++) {
	      if (levels[i].depth != null && levels[i].depth >= 0) {
	        levelModels[levels[i].depth] = new Model(levels[i], this, ecModel);
	      } else {}
	    }
	
	    if (nodes && links) {
	      var graph = createGraphFromNodeEdge(nodes, links, this, true, beforeLink);
	      return graph.data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        model.customizeGetParent(function (path) {
	          var parentModel = this.parentModel;
	          var nodeDepth = parentModel.getData().getItemLayout(idx).depth;
	          var levelModel = parentModel.levelModels[nodeDepth];
	          return levelModel || this.parentModel;
	        });
	        return model;
	      });
	      edgeData.wrapMethod('getItemModel', function (model, idx) {
	        model.customizeGetParent(function (path) {
	          var parentModel = this.parentModel;
	          var edge = parentModel.getGraph().getEdgeByIndex(idx);
	          var depth = edge.node1.getLayout().depth;
	          var levelModel = parentModel.levelModels[depth];
	          return levelModel || this.parentModel;
	        });
	        return model;
	      });
	    }
	  },
	  setNodePosition: function (dataIndex, localPosition) {
	    var dataItem = this.option.data[dataIndex];
	    dataItem.localX = localPosition[0];
	    dataItem.localY = localPosition[1];
	  },
	
	  /**
	   * Return the graphic data structure
	   *
	   * @return {module:echarts/data/Graph} graphic data structure
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * Get edge data of graphic data structure
	   *
	   * @return {module:echarts/data/List} data structure of list
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    // dataType === 'node' or empty do not show tooltip by default
	    if (dataType === 'edge') {
	      var params = this.getDataParams(dataIndex, dataType);
	      var rawDataOpt = params.data;
	      var html = rawDataOpt.source + ' -- ' + rawDataOpt.target;
	
	      if (params.value) {
	        html += ' : ' + params.value;
	      }
	
	      return encodeHTML(html);
	    } else if (dataType === 'node') {
	      var node = this.getGraph().getNodeByIndex(dataIndex);
	      var value = node.getLayout().value;
	      var name = this.getDataParams(dataIndex, dataType).data.name;
	
	      if (value) {
	        var html = name + ' : ' + value;
	      }
	
	      return encodeHTML(html);
	    }
	
	    return SankeySeries.superCall(this, 'formatTooltip', dataIndex, multipleSeries);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	
	    if (option.focusNodeAdjacency === true) {
	      option.focusNodeAdjacency = 'allEdges';
	    }
	  },
	  // Override Series.getDataParams()
	  getDataParams: function (dataIndex, dataType) {
	    var params = SankeySeries.superCall(this, 'getDataParams', dataIndex, dataType);
	
	    if (params.value == null && dataType === 'node') {
	      var node = this.getGraph().getNodeByIndex(dataIndex);
	      var nodeValue = node.getLayout().value;
	      params.value = nodeValue;
	    }
	
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    layout: null,
	    // The position of the whole view
	    left: '5%',
	    top: '5%',
	    right: '20%',
	    bottom: '5%',
	    // Value can be 'vertical'
	    orient: 'horizontal',
	    // The dx of the node
	    nodeWidth: 20,
	    // The vertical distance between two nodes
	    nodeGap: 8,
	    // Control if the node can move or not
	    draggable: true,
	    // Value can be 'inEdges', 'outEdges', 'allEdges', true (the same as 'allEdges').
	    focusNodeAdjacency: false,
	    // The number of iterations to change the position of the node
	    layoutIterations: 32,
	    label: {
	      show: true,
	      position: 'right',
	      color: '#000',
	      fontSize: 12
	    },
	    levels: [],
	    // Value can be 'left' or 'right'
	    nodeAlign: 'justify',
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: '#333'
	    },
	    lineStyle: {
	      color: '#314656',
	      opacity: 0.2,
	      curveness: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        opacity: 0.5
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 1000
	  }
	});
	var _default = SankeySeries;
	module.exports = _default;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var hoverNodeOpacityPath = ['emphasis', 'itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	var hoverLineOpacityPath = ['emphasis', 'lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  return item.getVisual('opacity') || item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  }); // Support emphasis here.
	
	  el.highlight && el.highlight();
	}
	
	var SankeyShape = graphic.extendShape({
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    cpx2: 0,
	    cpy2: 0,
	    extent: 0,
	    orient: ''
	  },
	  buildPath: function (ctx, shape) {
	    var extent = shape.extent;
	    ctx.moveTo(shape.x1, shape.y1);
	    ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
	
	    if (shape.orient === 'vertical') {
	      ctx.lineTo(shape.x2 + extent, shape.y2);
	      ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
	    } else {
	      ctx.lineTo(shape.x2, shape.y2 + extent);
	      ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
	    }
	
	    ctx.closePath();
	  },
	  highlight: function () {
	    this.trigger('emphasis');
	  },
	  downplay: function () {
	    this.trigger('normal');
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'sankey',
	
	  /**
	   * @private
	   * @type {module:echarts/chart/sankey/SankeySeries}
	   */
	  _model: null,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _focusAdjacencyDisabled: false,
	  render: function (seriesModel, ecModel, api) {
	    var sankeyView = this;
	    var graph = seriesModel.getGraph();
	    var group = this.group;
	    var layoutInfo = seriesModel.layoutInfo; // view width
	
	    var width = layoutInfo.width; // view height
	
	    var height = layoutInfo.height;
	    var nodeData = seriesModel.getData();
	    var edgeData = seriesModel.getData('edge');
	    var orient = seriesModel.get('orient');
	    this._model = seriesModel;
	    group.removeAll();
	    group.attr('position', [layoutInfo.x, layoutInfo.y]); // generate a bezire Curve for each edge
	
	    graph.eachEdge(function (edge) {
	      var curve = new SankeyShape();
	      curve.dataIndex = edge.dataIndex;
	      curve.seriesIndex = seriesModel.seriesIndex;
	      curve.dataType = 'edge';
	      var lineStyleModel = edge.getModel('lineStyle');
	      var curvature = lineStyleModel.get('curveness');
	      var n1Layout = edge.node1.getLayout();
	      var node1Model = edge.node1.getModel();
	      var dragX1 = node1Model.get('localX');
	      var dragY1 = node1Model.get('localY');
	      var n2Layout = edge.node2.getLayout();
	      var node2Model = edge.node2.getModel();
	      var dragX2 = node2Model.get('localX');
	      var dragY2 = node2Model.get('localY');
	      var edgeLayout = edge.getLayout();
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var cpx1;
	      var cpy1;
	      var cpx2;
	      var cpy2;
	      curve.shape.extent = Math.max(1, edgeLayout.dy);
	      curve.shape.orient = orient;
	
	      if (orient === 'vertical') {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
	        x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
	        y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
	        cpx1 = x1;
	        cpy1 = y1 * (1 - curvature) + y2 * curvature;
	        cpx2 = x2;
	        cpy2 = y1 * curvature + y2 * (1 - curvature);
	      } else {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
	        x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
	        y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
	        cpx1 = x1 * (1 - curvature) + x2 * curvature;
	        cpy1 = y1;
	        cpx2 = x1 * curvature + x2 * (1 - curvature);
	        cpy2 = y2;
	      }
	
	      curve.setShape({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        cpx1: cpx1,
	        cpy1: cpy1,
	        cpx2: cpx2,
	        cpy2: cpy2
	      });
	      curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color
	
	      switch (curve.style.fill) {
	        case 'source':
	          curve.style.fill = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          curve.style.fill = edge.node2.getVisual('color');
	          break;
	      }
	
	      graphic.setHoverStyle(curve, edge.getModel('emphasis.lineStyle').getItemStyle());
	      group.add(curve);
	      edgeData.setItemGraphicEl(edge.dataIndex, curve);
	    }); // Generate a rect for each node
	
	    graph.eachNode(function (node) {
	      var layout = node.getLayout();
	      var itemModel = node.getModel();
	      var dragX = itemModel.get('localX');
	      var dragY = itemModel.get('localY');
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var rect = new graphic.Rect({
	        shape: {
	          x: dragX != null ? dragX * width : layout.x,
	          y: dragY != null ? dragY * height : layout.y,
	          width: layout.dx,
	          height: layout.dy
	        },
	        style: itemModel.getModel('itemStyle').getItemStyle()
	      });
	      var hoverStyle = node.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(rect.style, hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: node.dataIndex,
	        defaultText: node.id,
	        isRectText: true
	      });
	      rect.setStyle('fill', node.getVisual('color'));
	      graphic.setHoverStyle(rect, hoverStyle);
	      group.add(rect);
	      nodeData.setItemGraphicEl(node.dataIndex, rect);
	      rect.dataType = 'node';
	    });
	    nodeData.eachItemGraphicEl(function (el, dataIndex) {
	      var itemModel = nodeData.getItemModel(dataIndex);
	
	      if (itemModel.get('draggable')) {
	        el.drift = function (dx, dy) {
	          sankeyView._focusAdjacencyDisabled = true;
	          this.shape.x += dx;
	          this.shape.y += dy;
	          this.dirty();
	          api.dispatchAction({
	            type: 'dragNode',
	            seriesId: seriesModel.id,
	            dataIndex: nodeData.getRawIndex(dataIndex),
	            localX: this.shape.x / width,
	            localY: this.shape.y / height
	          });
	        };
	
	        el.ondragend = function () {
	          sankeyView._focusAdjacencyDisabled = false;
	        };
	
	        el.draggable = true;
	        el.cursor = 'move';
	      }
	
	      el.highlight = function () {
	        this.trigger('emphasis');
	      };
	
	      el.downplay = function () {
	        this.trigger('normal');
	      };
	
	      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
	      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.focusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._clearTimer();
	
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              dataIndex: el.dataIndex
	            });
	          }
	        });
	        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._dispatchUnfocus(api);
	          }
	        });
	      }
	    });
	    edgeData.eachItemGraphicEl(function (el, dataIndex) {
	      var edgeModel = edgeData.getItemModel(dataIndex);
	      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
	      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);
	
	      if (edgeModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.focusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._clearTimer();
	
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              edgeDataIndex: el.dataIndex
	            });
	          }
	        });
	        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._dispatchUnfocus(api);
	          }
	        });
	      }
	    });
	
	    if (!this._data && seriesModel.get('animation')) {
	      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
	        group.removeClipPath();
	      }));
	    }
	
	    this._data = seriesModel.getData();
	  },
	  dispose: function () {
	    this._clearTimer();
	  },
	  _dispatchUnfocus: function (api) {
	    var self = this;
	
	    this._clearTimer();
	
	    this._unfocusDelayTimer = setTimeout(function () {
	      self._unfocusDelayTimer = null;
	      api.dispatchAction({
	        type: 'unfocusNodeAdjacency',
	        seriesId: self._model.id
	      });
	    }, 500);
	  },
	  _clearTimer: function () {
	    if (this._unfocusDelayTimer) {
	      clearTimeout(this._unfocusDelayTimer);
	      this._unfocusDelayTimer = null;
	    }
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var itemModel = data.getItemModel(dataIndex);
	    var edgeDataIndex = payload.edgeDataIndex;
	
	    if (dataIndex == null && edgeDataIndex == null) {
	      return;
	    }
	
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, hoverNodeOpacityPath);
	      var focusNodeAdj = itemModel.get('focusNodeAdjacency');
	
	      if (focusNodeAdj === 'outEdges') {
	        zrUtil.each(node.outEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          fadeInItem(edge.node2, hoverNodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'inEdges') {
	        zrUtil.each(node.inEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          fadeInItem(edge.node1, hoverNodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'allEdges') {
	        zrUtil.each(node.edges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          edge.node1 !== node && fadeInItem(edge.node1, hoverNodeOpacityPath);
	          edge.node2 !== node && fadeInItem(edge.node2, hoverNodeOpacityPath);
	        });
	      }
	    }
	
	    if (edge) {
	      fadeInItem(edge, hoverLineOpacityPath);
	      fadeInItem(edge.node1, hoverNodeOpacityPath);
	      fadeInItem(edge.node2, hoverNodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = seriesModel.getGraph();
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  }
	}); // Add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(807);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'dragNode',
	  event: 'dragnode',
	  // here can only use 'update' now, other value is not support in echarts.
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sankey',
	    query: payload
	  }, function (seriesModel) {
	    seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
	  });
	});

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(47);
	
	var zrUtil = __webpack_require__(2);
	
	var _model = __webpack_require__(27);
	
	var groupData = _model.groupData;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var nodeWidth = seriesModel.get('nodeWidth');
	    var nodeGap = seriesModel.get('nodeGap');
	    var layoutInfo = getViewRect(seriesModel, api);
	    seriesModel.layoutInfo = layoutInfo;
	    var width = layoutInfo.width;
	    var height = layoutInfo.height;
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	    var edges = graph.edges;
	    computeNodeValues(nodes);
	    var filteredNodes = zrUtil.filter(nodes, function (node) {
	      return node.getLayout().value === 0;
	    });
	    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
	    var orient = seriesModel.get('orient');
	    var nodeAlign = seriesModel.get('nodeAlign');
	    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
	  });
	}
	/**
	 * Get the layout position of the whole view
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
	  computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
	  computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
	  computeEdgeDepths(nodes, orient);
	}
	/**
	 * Compute the value of each node by summing the associated edge's value
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeNodeValues(nodes) {
	  zrUtil.each(nodes, function (node) {
	    var value1 = sum(node.outEdges, getEdgeValue);
	    var value2 = sum(node.inEdges, getEdgeValue);
	    var nodeRawValue = node.getValue() || 0;
	    var value = Math.max(value1, value2, nodeRawValue);
	    node.setLayout({
	      value: value
	    }, true);
	  });
	}
	/**
	 * Compute the x-position for each node.
	 *
	 * Here we use Kahn algorithm to detect cycle when we traverse
	 * the node to computer the initial x position.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param  {number} nodeWidth  the dx of the node
	 * @param  {number} width  the whole width of the area to draw the view
	 */
	
	
	function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
	  // Used to mark whether the edge is deleted. if it is deleted,
	  // the value is 0, otherwise it is 1.
	  var remainEdges = []; // Storage each node's indegree.
	
	  var indegreeArr = []; //Used to storage the node with indegree is equal to 0.
	
	  var zeroIndegrees = [];
	  var nextTargetNode = [];
	  var x = 0;
	  var kx = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    remainEdges[i] = 1;
	  }
	
	  for (i = 0; i < nodes.length; i++) {
	    indegreeArr[i] = nodes[i].inEdges.length;
	
	    if (indegreeArr[i] === 0) {
	      zeroIndegrees.push(nodes[i]);
	    }
	  }
	
	  var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
	  // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
	  // position of the nodes.
	
	  while (zeroIndegrees.length) {
	    for (var idx = 0; idx < zeroIndegrees.length; idx++) {
	      var node = zeroIndegrees[idx];
	      var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	      var isItemDepth = item.depth != null && item.depth >= 0;
	
	      if (isItemDepth && item.depth > maxNodeDepth) {
	        maxNodeDepth = item.depth;
	      }
	
	      node.setLayout({
	        depth: isItemDepth ? item.depth : x
	      }, true);
	      orient === 'vertical' ? node.setLayout({
	        dy: nodeWidth
	      }, true) : node.setLayout({
	        dx: nodeWidth
	      }, true);
	
	      for (var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++) {
	        var edge = node.outEdges[edgeIdx];
	        var indexEdge = edges.indexOf(edge);
	        remainEdges[indexEdge] = 0;
	        var targetNode = edge.node2;
	        var nodeIndex = nodes.indexOf(targetNode);
	
	        if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) {
	          nextTargetNode.push(targetNode);
	        }
	      }
	    }
	
	    ++x;
	    zeroIndegrees = nextTargetNode;
	    nextTargetNode = [];
	  }
	
	  for (i = 0; i < remainEdges.length; i++) {
	    if (remainEdges[i] === 1) {
	      throw new Error('Sankey is a DAG, the original data has cycle!');
	    }
	  }
	
	  var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
	
	  if (nodeAlign && nodeAlign !== 'left') {
	    adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
	  }
	
	  var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
	  scaleNodeBreadths(nodes, kx, orient);
	}
	
	function isNodeDepth(node) {
	  var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	  return item.depth != null && item.depth >= 0;
	}
	
	function adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
	  if (nodeAlign === 'right') {
	    var nextSourceNode = [];
	    var remainNodes = nodes;
	    var nodeHeight = 0;
	
	    while (remainNodes.length) {
	      for (var i = 0; i < remainNodes.length; i++) {
	        var node = remainNodes[i];
	        node.setLayout({
	          skNodeHeight: nodeHeight
	        }, true);
	
	        for (var j = 0; j < node.inEdges.length; j++) {
	          var edge = node.inEdges[j];
	
	          if (nextSourceNode.indexOf(edge.node1) < 0) {
	            nextSourceNode.push(edge.node1);
	          }
	        }
	      }
	
	      remainNodes = nextSourceNode;
	      nextSourceNode = [];
	      ++nodeHeight;
	    }
	
	    zrUtil.each(nodes, function (node) {
	      if (!isNodeDepth(node)) {
	        node.setLayout({
	          depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
	        }, true);
	      }
	    });
	  } else if (nodeAlign === 'justify') {
	    moveSinksRight(nodes, maxDepth);
	  }
	}
	/**
	 * All the node without outEgdes are assigned maximum x-position and
	 *     be aligned in the last column.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes.  node of sankey view.
	 * @param {number} maxDepth.  use to assign to node without outEdges as x-position.
	 */
	
	
	function moveSinksRight(nodes, maxDepth) {
	  zrUtil.each(nodes, function (node) {
	    if (!isNodeDepth(node) && !node.outEdges.length) {
	      node.setLayout({
	        depth: maxDepth
	      }, true);
	    }
	  });
	}
	/**
	 * Scale node x-position to the width
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {number} kx   multiple used to scale nodes
	 */
	
	
	function scaleNodeBreadths(nodes, kx, orient) {
	  zrUtil.each(nodes, function (node) {
	    var nodeDepth = node.getLayout().depth * kx;
	    orient === 'vertical' ? node.setLayout({
	      y: nodeDepth
	    }, true) : node.setLayout({
	      x: nodeDepth
	    }, true);
	  });
	}
	/**
	 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 *     in the same column.
	 * @param {number} iterations  the number of iterations for the algorithm
	 */
	
	
	function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
	  var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
	  initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
	  resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	
	  for (var alpha = 1; iterations > 0; iterations--) {
	    // 0.99 is a experience parameter, ensure that each iterations of
	    // changes as small as possible.
	    alpha *= 0.99;
	    relaxRightToLeft(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	    relaxLeftToRight(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	  }
	}
	
	function prepareNodesByBreadth(nodes, orient) {
	  var nodesByBreadth = [];
	  var keyAttr = orient === 'vertical' ? 'y' : 'x';
	  var groupResult = groupData(nodes, function (node) {
	    return node.getLayout()[keyAttr];
	  });
	  groupResult.keys.sort(function (a, b) {
	    return a - b;
	  });
	  zrUtil.each(groupResult.keys, function (key) {
	    nodesByBreadth.push(groupResult.buckets.get(key));
	  });
	  return nodesByBreadth;
	}
	/**
	 * Compute the original y-position for each node
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 */
	
	
	function initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
	  var minKy = Infinity;
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    var n = nodes.length;
	    var sum = 0;
	    zrUtil.each(nodes, function (node) {
	      sum += node.getLayout().value;
	    });
	    var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
	
	    if (ky < minKy) {
	      minKy = ky;
	    }
	  });
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node, i) {
	      var nodeDy = node.getLayout().value * minKy;
	
	      if (orient === 'vertical') {
	        node.setLayout({
	          x: i
	        }, true);
	        node.setLayout({
	          dx: nodeDy
	        }, true);
	      } else {
	        node.setLayout({
	          y: i
	        }, true);
	        node.setLayout({
	          dy: nodeDy
	        }, true);
	      }
	    });
	  });
	  zrUtil.each(edges, function (edge) {
	    var edgeDy = +edge.getValue() * minKy;
	    edge.setLayout({
	      dy: edgeDy
	    }, true);
	  });
	}
	/**
	 * Resolve the collision of initialized depth (y-position)
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {number} nodeGap  the vertical distance between two nodes
	 * @param {number} height  the whole height of the area to draw the view
	 */
	
	
	function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
	  var keyAttr = orient === 'vertical' ? 'x' : 'y';
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    nodes.sort(function (a, b) {
	      return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
	    });
	    var nodeX;
	    var node;
	    var dy;
	    var y0 = 0;
	    var n = nodes.length;
	    var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';
	
	    for (var i = 0; i < n; i++) {
	      node = nodes[i];
	      dy = y0 - node.getLayout()[keyAttr];
	
	      if (dy > 0) {
	        nodeX = node.getLayout()[keyAttr] + dy;
	        orient === 'vertical' ? node.setLayout({
	          x: nodeX
	        }, true) : node.setLayout({
	          y: nodeX
	        }, true);
	      }
	
	      y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
	    }
	
	    var viewWidth = orient === 'vertical' ? width : height; // If the bottommost node goes outside the bounds, push it back up
	
	    dy = y0 - nodeGap - viewWidth;
	
	    if (dy > 0) {
	      nodeX = node.getLayout()[keyAttr] - dy;
	      orient === 'vertical' ? node.setLayout({
	        x: nodeX
	      }, true) : node.setLayout({
	        y: nodeX
	      }, true);
	      y0 = nodeX;
	
	      for (i = n - 2; i >= 0; --i) {
	        node = nodes[i];
	        dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
	
	        if (dy > 0) {
	          nodeX = node.getLayout()[keyAttr] - dy;
	          orient === 'vertical' ? node.setLayout({
	            x: nodeX
	          }, true) : node.setLayout({
	            y: nodeX
	          }, true);
	        }
	
	        y0 = node.getLayout()[keyAttr];
	      }
	    }
	  });
	}
	/**
	 * Change the y-position of the nodes, except most the right side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxRightToLeft(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth.slice().reverse(), function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.outEdges.length) {
	        var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue, orient);
	
	        if (isNaN(y)) {
	          var len = node.outEdges.length;
	          y = len ? sum(node.outEdges, centerTarget, orient) / len : 0;
	        }
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	
	function weightedTarget(edge, orient) {
	  return center(edge.node2, orient) * edge.getValue();
	}
	
	function centerTarget(edge, orient) {
	  return center(edge.node2, orient);
	}
	
	function weightedSource(edge, orient) {
	  return center(edge.node1, orient) * edge.getValue();
	}
	
	function centerSource(edge, orient) {
	  return center(edge.node1, orient);
	}
	
	function center(node, orient) {
	  return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
	}
	
	function getEdgeValue(edge) {
	  return edge.getValue();
	}
	
	function sum(array, cb, orient) {
	  var sum = 0;
	  var len = array.length;
	  var i = -1;
	
	  while (++i < len) {
	    var value = +cb.call(array, array[i], orient);
	
	    if (!isNaN(value)) {
	      sum += value;
	    }
	  }
	
	  return sum;
	}
	/**
	 * Change the y-position of the nodes, except most the left side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxLeftToRight(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.inEdges.length) {
	        var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue, orient);
	
	        if (isNaN(y)) {
	          var len = node.inEdges.length;
	          y = len ? sum(node.inEdges, centerSource, orient) / len : 0;
	        }
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	/**
	 * Compute the depth(y-position) of each edge
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeEdgeDepths(nodes, orient) {
	  var keyAttr = orient === 'vertical' ? 'x' : 'y';
	  zrUtil.each(nodes, function (node) {
	    node.outEdges.sort(function (a, b) {
	      return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
	    });
	    node.inEdges.sort(function (a, b) {
	      return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
	    });
	  });
	  zrUtil.each(nodes, function (node) {
	    var sy = 0;
	    var ty = 0;
	    zrUtil.each(node.outEdges, function (edge) {
	      edge.setLayout({
	        sy: sy
	      }, true);
	      sy += edge.getLayout().dy;
	    });
	    zrUtil.each(node.inEdges, function (edge) {
	      edge.setLayout({
	        ty: ty
	      }, true);
	      ty += edge.getLayout().dy;
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(144);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	
	    if (nodes.length) {
	      var minValue = Infinity;
	      var maxValue = -Infinity;
	      zrUtil.each(nodes, function (node) {
	        var nodeValue = node.getLayout().value;
	
	        if (nodeValue < minValue) {
	          minValue = nodeValue;
	        }
	
	        if (nodeValue > maxValue) {
	          maxValue = nodeValue;
	        }
	      });
	      zrUtil.each(nodes, function (node) {
	        var mapping = new VisualMapping({
	          type: 'color',
	          mappingMethod: 'linear',
	          dataExtent: [minValue, maxValue],
	          visual: seriesModel.get('color')
	        });
	        var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
	        var customColor = node.getModel().get('itemStyle.color');
	        customColor != null ? node.setVisual('color', customColor) : node.setVisual('color', mapValueToColor);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1701);
	
	__webpack_require__(1702);
	
	var visualSymbol = __webpack_require__(145);
	
	var layoutPoints = __webpack_require__(222);
	
	__webpack_require__(217);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as zrUtil from 'zrender/src/core/util';
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('scatter', 'circle'));
	echarts.registerLayout(layoutPoints('scatter')); // echarts.registerProcessor(function (ecModel, api) {
	//     ecModel.eachSeriesByType('scatter', function (seriesModel) {
	//         var data = seriesModel.getData();
	//         var coordSys = seriesModel.coordinateSystem;
	//         if (coordSys.type !== 'geo') {
	//             return;
	//         }
	//         var startPt = coordSys.pointToData([0, 0]);
	//         var endPt = coordSys.pointToData([api.getWidth(), api.getHeight()]);
	//         var dims = zrUtil.map(coordSys.dimensions, function (dim) {
	//             return data.mapDimension(dim);
	//         });
	//         var range = {};
	//         range[dims[0]] = [Math.min(startPt[0], endPt[0]), Math.max(startPt[0], endPt[0])];
	//         range[dims[1]] = [Math.min(startPt[1], endPt[1]), Math.max(startPt[1], endPt[1])];
	//         data.selectRange(range);
	//     });
	// });

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(113);
	
	var SeriesModel = __webpack_require__(66);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.scatter',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  brushSelector: 'point',
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      // PENDING
	      return this.option.large ? 5e3 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      // PENDING
	      return this.option.large ? 1e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10,
	    // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // cursor: null,
	    // label: {
	    // show: false
	    // distance: 5,
	    // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	    // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
	    //           'inside'|'left'|'right'|'top'|'bottom'
	    // 默认使用全局文本样式，详见TEXTSTYLE
	    // },
	    itemStyle: {
	      opacity: 0.8 // color: 各异
	
	    },
	    // If clip the overflow graphics
	    // Works on cartesian / polar series
	    clip: true // progressive: null
	
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var SymbolDraw = __webpack_require__(214);
	
	var LargeSymbolDraw = __webpack_require__(1662);
	
	var pointsLayout = __webpack_require__(222);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendChartView({
	  type: 'scatter',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.updateData(data, {
	      // TODO
	      // If this parameter should be a shape or a bounding volume
	      // shape will be more general.
	      // But bounding volume like bounding rect will be much faster in the contain calculation
	      clipShape: this._getClipShape(seriesModel)
	    });
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.incrementalPrepareUpdate(data);
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
	      clipShape: this._getClipShape(seriesModel)
	    });
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
	    // PENDING
	
	    this.group.dirty();
	
	    if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) {
	      return {
	        update: true
	      };
	    } else {
	      var res = pointsLayout().reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._symbolDraw.updateLayout(data);
	    }
	  },
	  _getClipShape: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
	    return seriesModel.get('clip', true) ? clipArea : null;
	  },
	  _updateSymbolDraw: function (data, seriesModel) {
	    var symbolDraw = this._symbolDraw;
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
	      symbolDraw && symbolDraw.remove();
	      symbolDraw = this._symbolDraw = isLargeDraw ? new LargeSymbolDraw() : new SymbolDraw();
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(symbolDraw.group);
	    return symbolDraw;
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(true);
	    this._symbolDraw = null;
	  },
	  dispose: function () {}
	});

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	__webpack_require__(1705);
	
	__webpack_require__(1706);
	
	__webpack_require__(1707);
	
	var dataColor = __webpack_require__(276);
	
	var sunburstLayout = __webpack_require__(1708);
	
	var dataFilter = __webpack_require__(223);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(zrUtil.curry(dataColor, 'sunburst'));
	echarts.registerLayout(zrUtil.curry(sunburstLayout, 'sunburst'));
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'sunburst'));

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NodeHighlightPolicy = {
	  NONE: 'none',
	  // not downplay others
	  DESCENDANT: 'descendant',
	  ANCESTOR: 'ancestor',
	  SELF: 'self'
	};
	var DEFAULT_SECTOR_Z = 2;
	var DEFAULT_TEXT_Z = 4;
	/**
	 * Sunburstce of Sunburst including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	function SunburstPiece(node, seriesModel, ecModel) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: DEFAULT_SECTOR_Z
	  });
	  sector.seriesIndex = seriesModel.seriesIndex;
	  var text = new graphic.Text({
	    z2: DEFAULT_TEXT_Z,
	    silent: node.getModel('label').get('silent')
	  });
	  this.add(sector);
	  this.add(text);
	  this.updateData(true, node, 'normal', seriesModel, ecModel); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var SunburstPieceProto = SunburstPiece.prototype;
	
	SunburstPieceProto.updateData = function (firstCreate, node, state, seriesModel, ecModel) {
	  this.node = node;
	  node.piece = this;
	  seriesModel = seriesModel || this._seriesModel;
	  ecModel = ecModel || this._ecModel;
	  var sector = this.childAt(0);
	  sector.dataIndex = node.dataIndex;
	  var itemModel = node.getModel();
	  var layout = node.getLayout(); // if (!layout) {
	  //     console.log(node.getLayout());
	  // }
	
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var visualColor = getNodeColor(node, seriesModel, ecModel);
	  fillDefaultColor(node, seriesModel, visualColor);
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle();
	  var style;
	
	  if (state === 'normal') {
	    style = normalStyle;
	  } else {
	    var stateStyle = itemModel.getModel(state + '.itemStyle').getItemStyle();
	    style = zrUtil.merge(stateStyle, normalStyle);
	  }
	
	  style = zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: style.fill || visualColor
	  }, style);
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    sector.shape.r = layout.r0;
	    graphic.updateProps(sector, {
	      shape: {
	        r: layout.r
	      }
	    }, seriesModel, node.dataIndex);
	    sector.useStyle(style);
	  } else if (typeof style.fill === 'object' && style.fill.type || typeof sector.style.fill === 'object' && sector.style.fill.type) {
	    // Disable animation for gradient since no interpolation method
	    // is supported for gradient
	    graphic.updateProps(sector, {
	      shape: sectorShape
	    }, seriesModel);
	    sector.useStyle(style);
	  } else {
	    graphic.updateProps(sector, {
	      shape: sectorShape,
	      style: style
	    }, seriesModel);
	  }
	
	  this._updateLabel(seriesModel, visualColor, state);
	
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle);
	
	  if (firstCreate) {
	    var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	
	    this._initEvents(sector, node, seriesModel, highlightPolicy);
	  }
	
	  this._seriesModel = seriesModel || this._seriesModel;
	  this._ecModel = ecModel || this._ecModel;
	  graphic.setHoverStyle(this);
	};
	
	SunburstPieceProto.onEmphasis = function (highlightPolicy) {
	  var that = this;
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      if (that.node === n) {
	        n.piece.updateData(false, n, 'emphasis');
	      } else if (isNodeHighlighted(n, that.node, highlightPolicy)) {
	        n.piece.childAt(0).trigger('highlight');
	      } else if (highlightPolicy !== NodeHighlightPolicy.NONE) {
	        n.piece.childAt(0).trigger('downplay');
	      }
	    }
	  });
	};
	
	SunburstPieceProto.onNormal = function () {
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      n.piece.updateData(false, n, 'normal');
	    }
	  });
	};
	
	SunburstPieceProto.onHighlight = function () {
	  this.updateData(false, this.node, 'highlight');
	};
	
	SunburstPieceProto.onDownplay = function () {
	  this.updateData(false, this.node, 'downplay');
	};
	
	SunburstPieceProto._updateLabel = function (seriesModel, visualColor, state) {
	  var itemModel = this.node.getModel();
	  var normalModel = itemModel.getModel('label');
	  var labelModel = state === 'normal' || state === 'emphasis' ? normalModel : itemModel.getModel(state + '.label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelFormatter = labelModel.get('formatter'); // Use normal formatter if no state formatter is defined
	
	  var labelState = labelFormatter ? state : 'normal';
	  var text = zrUtil.retrieve(seriesModel.getFormattedLabel(this.node.dataIndex, labelState, null, null, 'label'), this.node.name);
	
	  if (getLabelAttr('show') === false) {
	    text = '';
	  }
	
	  var layout = this.node.getLayout();
	  var labelMinAngle = labelModel.get('minAngle');
	
	  if (labelMinAngle == null) {
	    labelMinAngle = normalModel.get('minAngle');
	  }
	
	  labelMinAngle = labelMinAngle / 180 * Math.PI;
	  var angle = layout.endAngle - layout.startAngle;
	
	  if (labelMinAngle != null && Math.abs(angle) < labelMinAngle) {
	    // Not displaying text when angle is too small
	    text = '';
	  }
	
	  var label = this.childAt(1);
	  graphic.setLabelStyle(label.style, label.hoverStyle || {}, normalModel, labelHoverModel, {
	    defaultText: labelModel.getShallow('show') ? text : null,
	    autoColor: visualColor,
	    useInsideStyle: true
	  });
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var r;
	  var labelPosition = getLabelAttr('position');
	  var labelPadding = getLabelAttr('distance') || 0;
	  var textAlign = getLabelAttr('align');
	
	  if (labelPosition === 'outside') {
	    r = layout.r + labelPadding;
	    textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
	  } else {
	    if (!textAlign || textAlign === 'center') {
	      r = (layout.r + layout.r0) / 2;
	      textAlign = 'center';
	    } else if (textAlign === 'left') {
	      r = layout.r0 + labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'right';
	      }
	    } else if (textAlign === 'right') {
	      r = layout.r - labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'left';
	      }
	    }
	  }
	
	  label.attr('style', {
	    text: text,
	    textAlign: textAlign,
	    textVerticalAlign: getLabelAttr('verticalAlign') || 'middle',
	    opacity: getLabelAttr('opacity')
	  });
	  var textX = r * dx + layout.cx;
	  var textY = r * dy + layout.cy;
	  label.attr('position', [textX, textY]);
	  var rotateType = getLabelAttr('rotate');
	  var rotate = 0;
	
	  if (rotateType === 'radial') {
	    rotate = -midAngle;
	
	    if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (rotateType === 'tangential') {
	    rotate = Math.PI / 2 - midAngle;
	
	    if (rotate > Math.PI / 2) {
	      rotate -= Math.PI;
	    } else if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (typeof rotateType === 'number') {
	    rotate = rotateType * Math.PI / 180;
	  }
	
	  label.attr('rotation', rotate);
	
	  function getLabelAttr(name) {
	    var stateAttr = labelModel.get(name);
	
	    if (stateAttr == null) {
	      return normalModel.get(name);
	    } else {
	      return stateAttr;
	    }
	  }
	};
	
	SunburstPieceProto._initEvents = function (sector, node, seriesModel, highlightPolicy) {
	  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  var that = this;
	
	  var onEmphasis = function () {
	    that.onEmphasis(highlightPolicy);
	  };
	
	  var onNormal = function () {
	    that.onNormal();
	  };
	
	  var onDownplay = function () {
	    that.onDownplay();
	  };
	
	  var onHighlight = function () {
	    that.onHighlight();
	  };
	
	  if (seriesModel.isAnimationEnabled()) {
	    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal).on('downplay', onDownplay).on('highlight', onHighlight);
	  }
	};
	
	zrUtil.inherits(SunburstPiece, graphic.Group);
	var _default = SunburstPiece;
	/**
	 * Get node color
	 *
	 * @param {TreeNode} node the node to get color
	 * @param {module:echarts/model/Series} seriesModel series
	 * @param {module:echarts/model/Global} ecModel echarts defaults
	 */
	
	function getNodeColor(node, seriesModel, ecModel) {
	  // Color from visualMap
	  var visualColor = node.getVisual('color');
	  var visualMetaList = node.getVisual('visualMeta');
	
	  if (!visualMetaList || visualMetaList.length === 0) {
	    // Use first-generation color if has no visualMap
	    visualColor = null;
	  } // Self color or level color
	
	
	  var color = node.getModel('itemStyle').get('color');
	
	  if (color) {
	    return color;
	  } else if (visualColor) {
	    // Color mapping
	    return visualColor;
	  } else if (node.depth === 0) {
	    // Virtual root node
	    return ecModel.option.color[0];
	  } else {
	    // First-generation color
	    var length = ecModel.option.color.length;
	    color = ecModel.option.color[getRootId(node) % length];
	  }
	
	  return color;
	}
	/**
	 * Get index of root in sorted order
	 *
	 * @param {TreeNode} node current node
	 * @return {number} index in root
	 */
	
	
	function getRootId(node) {
	  var ancestor = node;
	
	  while (ancestor.depth > 1) {
	    ancestor = ancestor.parentNode;
	  }
	
	  var virtualRoot = node.getAncestors()[0];
	  return zrUtil.indexOf(virtualRoot.children, ancestor);
	}
	
	function isNodeHighlighted(node, activeNode, policy) {
	  if (policy === NodeHighlightPolicy.NONE) {
	    return false;
	  } else if (policy === NodeHighlightPolicy.SELF) {
	    return node === activeNode;
	  } else if (policy === NodeHighlightPolicy.ANCESTOR) {
	    return node === activeNode || node.isAncestorOf(activeNode);
	  } else {
	    return node === activeNode || node.isDescendantOf(activeNode);
	  }
	} // Fix tooltip callback function params.color incorrect when pick a default color
	
	
	function fillDefaultColor(node, seriesModel, color) {
	  var data = seriesModel.getData();
	  data.setItemVisual(node.dataIndex, 'color', color);
	}
	
	module.exports = _default;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var SeriesModel = __webpack_require__(66);
	
	var Tree = __webpack_require__(431);
	
	var Model = __webpack_require__(57);
	
	var _treeHelper = __webpack_require__(140);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.sunburst',
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levelModels = zrUtil.map(option.levels || [], function (levelDefine) {
	      return new Model(levelDefine, this, ecModel);
	    }, this); // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	        var levelModel = levelModels[node.depth];
	        levelModel && (model.parentModel = levelModel);
	        return model;
	      });
	    }
	
	    return tree.data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /*
	   * @override
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // Policy of highlighting pieces when hover on one
	    // Valid values: 'none' (for not downplay others), 'descendant',
	    // 'ancestor', 'self'
	    highlightPolicy: 'descendant',
	    // 'rootToNode', 'link', or false
	    nodeClick: 'rootToNode',
	    renderLabelForZeroData: false,
	    label: {
	      // could be: 'radial', 'tangential', or 'none'
	      rotate: 'radial',
	      show: true,
	      opacity: 1,
	      // 'left' is for inner side of inside, and 'right' is for outter
	      // side for inside
	      align: 'center',
	      position: 'inside',
	      distance: 5,
	      silent: true
	    },
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: 'white',
	      borderType: 'solid',
	      shadowBlur: 0,
	      shadowColor: 'rgba(0, 0, 0, 0.2)',
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1
	    },
	    highlight: {
	      itemStyle: {
	        opacity: 1
	      }
	    },
	    downplay: {
	      itemStyle: {
	        opacity: 0.5
	      },
	      label: {
	        opacity: 0.6
	      }
	    },
	    // Animation type canbe expansion, scale
	    animationType: 'expansion',
	    animationDuration: 1000,
	    animationDurationUpdate: 500,
	    animationEasing: 'cubicOut',
	    data: [],
	    levels: [],
	
	    /**
	     * Sort order.
	     *
	     * Valid values: 'desc', 'asc', null, or callback function.
	     * 'desc' and 'asc' for descend and ascendant order;
	     * null for not sorting;
	     * example of callback function:
	     * function(nodeA, nodeB) {
	     *     return nodeA.getValue() - nodeB.getValue();
	     * }
	     */
	    sort: 'desc'
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	
	module.exports = _default;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ChartView = __webpack_require__(103);
	
	var SunburstPiece = __webpack_require__(1704);
	
	var DataDiffer = __webpack_require__(142);
	
	var _format = __webpack_require__(48);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	var SunburstView = ChartView.extend({
	  type: 'sunburst',
	  init: function () {},
	  render: function (seriesModel, ecModel, api, payload) {
	    var that = this;
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var data = seriesModel.getData();
	    var virtualRoot = data.tree.root;
	    var newRoot = seriesModel.getViewRoot();
	    var group = this.group;
	    var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
	    var newChildren = [];
	    newRoot.eachNode(function (node) {
	      newChildren.push(node);
	    });
	    var oldChildren = this._oldChildren || [];
	    dualTravel(newChildren, oldChildren);
	    renderRollUp(virtualRoot, newRoot);
	
	    if (payload && payload.highlight && payload.highlight.piece) {
	      var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	      payload.highlight.piece.onEmphasis(highlightPolicy);
	    } else if (payload && payload.unhighlight) {
	      var piece = this.virtualPiece;
	
	      if (!piece && virtualRoot.children.length) {
	        piece = virtualRoot.children[0].piece;
	      }
	
	      if (piece) {
	        piece.onNormal();
	      }
	    }
	
	    this._initEvents();
	
	    this._oldChildren = newChildren;
	
	    function dualTravel(newChildren, oldChildren) {
	      if (newChildren.length === 0 && oldChildren.length === 0) {
	        return;
	      }
	
	      new DataDiffer(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	
	      function getKey(node) {
	        return node.getId();
	      }
	
	      function processNode(newId, oldId) {
	        var newNode = newId == null ? null : newChildren[newId];
	        var oldNode = oldId == null ? null : oldChildren[oldId];
	        doRenderNode(newNode, oldNode);
	      }
	    }
	
	    function doRenderNode(newNode, oldNode) {
	      if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
	        // Not render data with value 0
	        newNode = null;
	      }
	
	      if (newNode !== virtualRoot && oldNode !== virtualRoot) {
	        if (oldNode && oldNode.piece) {
	          if (newNode) {
	            // Update
	            oldNode.piece.updateData(false, newNode, 'normal', seriesModel, ecModel); // For tooltip
	
	            data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
	          } else {
	            // Remove
	            removeNode(oldNode);
	          }
	        } else if (newNode) {
	          // Add
	          var piece = new SunburstPiece(newNode, seriesModel, ecModel);
	          group.add(piece); // For tooltip
	
	          data.setItemGraphicEl(newNode.dataIndex, piece);
	        }
	      }
	    }
	
	    function removeNode(node) {
	      if (!node) {
	        return;
	      }
	
	      if (node.piece) {
	        group.remove(node.piece);
	        node.piece = null;
	      }
	    }
	
	    function renderRollUp(virtualRoot, viewRoot) {
	      if (viewRoot.depth > 0) {
	        // Render
	        if (that.virtualPiece) {
	          // Update
	          that.virtualPiece.updateData(false, virtualRoot, 'normal', seriesModel, ecModel);
	        } else {
	          // Add
	          that.virtualPiece = new SunburstPiece(virtualRoot, seriesModel, ecModel);
	          group.add(that.virtualPiece);
	        }
	
	        if (viewRoot.piece._onclickEvent) {
	          viewRoot.piece.off('click', viewRoot.piece._onclickEvent);
	        }
	
	        var event = function (e) {
	          that._rootToNode(viewRoot.parentNode);
	        };
	
	        viewRoot.piece._onclickEvent = event;
	        that.virtualPiece.on('click', event);
	      } else if (that.virtualPiece) {
	        // Remove
	        group.remove(that.virtualPiece);
	        that.virtualPiece = null;
	      }
	    }
	  },
	  dispose: function () {},
	
	  /**
	   * @private
	   */
	  _initEvents: function () {
	    var that = this;
	
	    var event = function (e) {
	      var targetFound = false;
	      var viewRoot = that.seriesModel.getViewRoot();
	      viewRoot.eachNode(function (node) {
	        if (!targetFound && node.piece && node.piece.childAt(0) === e.target) {
	          var nodeClick = node.getModel().get('nodeClick');
	
	          if (nodeClick === 'rootToNode') {
	            that._rootToNode(node);
	          } else if (nodeClick === 'link') {
	            var itemModel = node.getModel();
	            var link = itemModel.get('link');
	
	            if (link) {
	              var linkTarget = itemModel.get('target', true) || '_blank';
	              windowOpen(link, linkTarget);
	            }
	          }
	
	          targetFound = true;
	        }
	      });
	    };
	
	    if (this.group._onclickEvent) {
	      this.group.off('click', this.group._onclickEvent);
	    }
	
	    this.group.on('click', event);
	    this.group._onclickEvent = event;
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (node) {
	    if (node !== this.seriesModel.getViewRoot()) {
	      this.api.dispatchAction({
	        type: ROOT_TO_NODE_ACTION,
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        targetNode: node
	      });
	    }
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var treeRoot = seriesModel.getData();
	    var itemLayout = treeRoot.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = SunburstView;
	module.exports = _default;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var helper = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Sunburst action
	 */
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	echarts.registerAction({
	  type: ROOT_TO_NODE_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [ROOT_TO_NODE_ACTION], model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});
	var HIGHLIGHT_ACTION = 'sunburstHighlight';
	echarts.registerAction({
	  type: HIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleHighlight);
	
	  function handleHighlight(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [HIGHLIGHT_ACTION], model);
	
	    if (targetInfo) {
	      payload.highlight = targetInfo.node;
	    }
	  }
	});
	var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
	echarts.registerAction({
	  type: UNHIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleUnhighlight);
	
	  function handleUnhighlight(model, index) {
	    payload.unhighlight = true;
	  }
	});

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = api.getWidth();
	    var height = api.getHeight();
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width);
	    var cy = parsePercent(center[1], height);
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var virtualRoot = seriesModel.getData().tree.root;
	    var treeRoot = seriesModel.getViewRoot();
	    var rootDepth = treeRoot.depth;
	    var sort = seriesModel.get('sort');
	
	    if (sort != null) {
	      initChildren(treeRoot, sort);
	    }
	
	    var validDataCount = 0;
	    zrUtil.each(treeRoot.children, function (child) {
	      !isNaN(child.getValue()) && validDataCount++;
	    });
	    var sum = treeRoot.getValue(); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var renderRollupNode = treeRoot.depth > 0;
	    var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
	    var rPerLevel = (r - r0) / (levels || 1);
	    var clockwise = seriesModel.get('clockwise');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
	    // var restAngle = PI2;
	    // var valueSumLargerThanMinAngle = 0;
	
	    var dir = clockwise ? 1 : -1;
	    /**
	     * Render a tree
	     * @return increased angle
	     */
	
	    var renderNode = function (node, startAngle) {
	      if (!node) {
	        return;
	      }
	
	      var endAngle = startAngle; // Render self
	
	      if (node !== virtualRoot) {
	        // Tree node is virtual, so it doesn't need to be drawn
	        var value = node.getValue();
	        var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	
	        if (angle < minAngle) {
	          angle = minAngle; // restAngle -= minAngle;
	        } // else {
	        //     valueSumLargerThanMinAngle += value;
	        // }
	
	
	        endAngle = startAngle + dir * angle;
	        var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
	        var rStart = r0 + rPerLevel * depth;
	        var rEnd = r0 + rPerLevel * (depth + 1);
	        var itemModel = node.getModel();
	
	        if (itemModel.get('r0') != null) {
	          rStart = parsePercent(itemModel.get('r0'), size / 2);
	        }
	
	        if (itemModel.get('r') != null) {
	          rEnd = parsePercent(itemModel.get('r'), size / 2);
	        }
	
	        node.setLayout({
	          angle: angle,
	          startAngle: startAngle,
	          endAngle: endAngle,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: rStart,
	          r: rEnd
	        });
	      } // Render children
	
	
	      if (node.children && node.children.length) {
	        // currentAngle = startAngle;
	        var siblingAngle = 0;
	        zrUtil.each(node.children, function (node) {
	          siblingAngle += renderNode(node, startAngle + siblingAngle);
	        });
	      }
	
	      return endAngle - startAngle;
	    }; // Virtual root node for roll up
	
	
	    if (renderRollupNode) {
	      var rStart = r0;
	      var rEnd = r0 + rPerLevel;
	      var angle = Math.PI * 2;
	      virtualRoot.setLayout({
	        angle: angle,
	        startAngle: startAngle,
	        endAngle: startAngle + angle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: rStart,
	        r: rEnd
	      });
	    }
	
	    renderNode(treeRoot, startAngle);
	  });
	}
	/**
	 * Init node children by order and update visual
	 *
	 * @param {TreeNode} node  root node
	 * @param {boolean}  isAsc if is in ascendant order
	 */
	
	
	function initChildren(node, isAsc) {
	  var children = node.children || [];
	  node.children = sort(children, isAsc); // Init children recursively
	
	  if (children.length) {
	    zrUtil.each(node.children, function (child) {
	      initChildren(child, isAsc);
	    });
	  }
	}
	/**
	 * Sort children nodes
	 *
	 * @param {TreeNode[]}               children children of node to be sorted
	 * @param {string | function | null} sort sort method
	 *                                   See SunburstSeries.js for details.
	 */
	
	
	function sort(children, sortOrder) {
	  if (typeof sortOrder === 'function') {
	    return children.sort(sortOrder);
	  } else {
	    var isAsc = sortOrder === 'asc';
	    return children.sort(function (a, b) {
	      var diff = (a.getValue() - b.getValue()) * (isAsc ? 1 : -1);
	      return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc ? -1 : 1) : diff;
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(831);
	
	__webpack_require__(1710);
	
	__webpack_require__(1711);
	
	var themeRiverLayout = __webpack_require__(1712);
	
	var themeRiverVisual = __webpack_require__(1713);
	
	var dataFilter = __webpack_require__(223);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(themeRiverLayout);
	echarts.registerVisual(themeRiverVisual);
	echarts.registerProcessor(dataFilter('themeRiver'));

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(66);
	
	var createDimensions = __webpack_require__(176);
	
	var _dimensionHelper = __webpack_require__(220);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var List = __webpack_require__(88);
	
	var zrUtil = __webpack_require__(2);
	
	var _model = __webpack_require__(27);
	
	var groupData = _model.groupData;
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var LegendVisualProvider = __webpack_require__(225);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DATA_NAME_INDEX = 2;
	var ThemeRiverSeries = SeriesModel.extend({
	  type: 'series.themeRiver',
	  dependencies: ['singleAxis'],
	
	  /**
	   * @readOnly
	   * @type {module:zrender/core/util#HashMap}
	   */
	  nameMap: null,
	
	  /**
	   * @override
	   */
	  init: function (option) {
	    // eslint-disable-next-line
	    ThemeRiverSeries.superApply(this, 'init', arguments); // Put this function here is for the sake of consistency of code style.
	    // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	  },
	
	  /**
	   * If there is no value of a certain point in the time for some event,set it value to 0.
	   *
	   * @param {Array} data  initial data in the option
	   * @return {Array}
	   */
	  fixData: function (data) {
	    var rawDataLength = data.length;
	    /**
	     * Make sure every layer data get the same keys.
	     * The value index tells which layer has visited.
	     * {
	     *  2014/01/01: -1
	     * }
	     */
	
	    var timeValueKeys = {}; // grouped data by name
	
	    var groupResult = groupData(data, function (item) {
	      if (!timeValueKeys.hasOwnProperty(item[0])) {
	        timeValueKeys[item[0]] = -1;
	      }
	
	      return item[2];
	    });
	    var layData = [];
	    groupResult.buckets.each(function (items, key) {
	      layData.push({
	        name: key,
	        dataList: items
	      });
	    });
	    var layerNum = layData.length;
	
	    for (var k = 0; k < layerNum; ++k) {
	      var name = layData[k].name;
	
	      for (var j = 0; j < layData[k].dataList.length; ++j) {
	        var timeValue = layData[k].dataList[j][0];
	        timeValueKeys[timeValue] = k;
	      }
	
	      for (var timeValue in timeValueKeys) {
	        if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
	          timeValueKeys[timeValue] = k;
	          data[rawDataLength] = [];
	          data[rawDataLength][0] = timeValue;
	          data[rawDataLength][1] = 0;
	          data[rawDataLength][2] = name;
	          rawDataLength++;
	        }
	      }
	    }
	
	    return data;
	  },
	
	  /**
	   * @override
	   * @param  {Object} option  the initial option that user gived
	   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
	   * @return {module:echarts/data/List}
	   */
	  getInitialData: function (option, ecModel) {
	    var singleAxisModel = ecModel.queryComponents({
	      mainType: 'singleAxis',
	      index: this.get('singleAxisIndex'),
	      id: this.get('singleAxisId')
	    })[0];
	    var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined
	
	    var filterData = zrUtil.filter(option.data, function (dataItem) {
	      return dataItem[2] !== undefined;
	    }); // ??? TODO design a stage to transfer data for themeRiver and lines?
	
	    var data = this.fixData(filterData || []);
	    var nameList = [];
	    var nameMap = this.nameMap = zrUtil.createHashMap();
	    var count = 0;
	
	    for (var i = 0; i < data.length; ++i) {
	      nameList.push(data[i][DATA_NAME_INDEX]);
	
	      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
	        nameMap.set(data[i][DATA_NAME_INDEX], count);
	        count++;
	      }
	    }
	
	    var dimensionsInfo = createDimensions(data, {
	      coordDimensions: ['single'],
	      dimensionsDefine: [{
	        name: 'time',
	        type: getDimensionTypeByAxis(axisType)
	      }, {
	        name: 'value',
	        type: 'float'
	      }, {
	        name: 'name',
	        type: 'ordinal'
	      }],
	      encodeDefine: {
	        single: 0,
	        value: 1,
	        itemName: 2
	      }
	    });
	    var list = new List(dimensionsInfo, this);
	    list.initData(data);
	    return list;
	  },
	
	  /**
	   * The raw data is divided into multiple layers and each layer
	   *     has same name.
	   *
	   * @return {Array.<Array.<number>>}
	   */
	  getLayerSeries: function () {
	    var data = this.getData();
	    var lenCount = data.count();
	    var indexArr = [];
	
	    for (var i = 0; i < lenCount; ++i) {
	      indexArr[i] = i;
	    }
	
	    var timeDim = data.mapDimension('single'); // data group by name
	
	    var groupResult = groupData(indexArr, function (index) {
	      return data.get('name', index);
	    });
	    var layerSeries = [];
	    groupResult.buckets.each(function (items, key) {
	      items.sort(function (index1, index2) {
	        return data.get(timeDim, index1) - data.get(timeDim, index2);
	      });
	      layerSeries.push({
	        name: key,
	        indices: items
	      });
	    });
	    return layerSeries;
	  },
	
	  /**
	   * Get data indices for show tooltip content
	    * @param {Array.<string>|string} dim  single coordinate dimension
	   * @param {number} value axis value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
	   *     the themeRiver.
	   * @return {Object} {dataIndices, nestestValue}
	   */
	  getAxisTooltipData: function (dim, value, baseAxis) {
	    if (!zrUtil.isArray(dim)) {
	      dim = dim ? [dim] : [];
	    }
	
	    var data = this.getData();
	    var layerSeries = this.getLayerSeries();
	    var indices = [];
	    var layerNum = layerSeries.length;
	    var nestestValue;
	
	    for (var i = 0; i < layerNum; ++i) {
	      var minDist = Number.MAX_VALUE;
	      var nearestIdx = -1;
	      var pointNum = layerSeries[i].indices.length;
	
	      for (var j = 0; j < pointNum; ++j) {
	        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
	        var dist = Math.abs(theValue - value);
	
	        if (dist <= minDist) {
	          nestestValue = theValue;
	          minDist = dist;
	          nearestIdx = layerSeries[i].indices[j];
	        }
	      }
	
	      indices.push(nearestIdx);
	    }
	
	    return {
	      dataIndices: indices,
	      nestestValue: nestestValue
	    };
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex  index of data
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var htmlName = data.getName(dataIndex);
	    var htmlValue = data.get(data.mapDimension('value'), dataIndex);
	
	    if (isNaN(htmlValue) || htmlValue == null) {
	      htmlValue = '-';
	    }
	
	    return encodeHTML(htmlName + ' : ' + htmlValue);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'singleAxis',
	    // gap in axis's orthogonal orientation
	    boundaryGap: ['10%', '10%'],
	    // legendHoverLink: true,
	    singleAxisIndex: 0,
	    animationEasing: 'linear',
	    label: {
	      margin: 4,
	      show: true,
	      position: 'left',
	      color: '#000',
	      fontSize: 11
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = ThemeRiverSeries;
	module.exports = _default;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var _poly = __webpack_require__(810);
	
	var Polygon = _poly.Polygon;
	
	var graphic = __webpack_require__(17);
	
	var _util = __webpack_require__(2);
	
	var bind = _util.bind;
	var extend = _util.extend;
	
	var DataDiffer = __webpack_require__(142);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'themeRiver',
	  init: function () {
	    this._layers = [];
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var layerSeries = seriesModel.getLayerSeries();
	    var layoutInfo = data.getLayout('layoutInfo');
	    var rect = layoutInfo.rect;
	    var boundaryGap = layoutInfo.boundaryGap;
	    group.attr('position', [0, rect.y + boundaryGap[0]]);
	
	    function keyGetter(item) {
	      return item.name;
	    }
	
	    var dataDiffer = new DataDiffer(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
	    var newLayersGroups = {};
	    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();
	
	    function process(status, idx, oldIdx) {
	      var oldLayersGroups = this._layers;
	
	      if (status === 'remove') {
	        group.remove(oldLayersGroups[idx]);
	        return;
	      }
	
	      var points0 = [];
	      var points1 = [];
	      var color;
	      var indices = layerSeries[idx].indices;
	
	      for (var j = 0; j < indices.length; j++) {
	        var layout = data.getItemLayout(indices[j]);
	        var x = layout.x;
	        var y0 = layout.y0;
	        var y = layout.y;
	        points0.push([x, y0]);
	        points1.push([x, y0 + y]);
	        color = data.getItemVisual(indices[j], 'color');
	      }
	
	      var polygon;
	      var text;
	      var textLayout = data.getItemLayout(indices[0]);
	      var itemModel = data.getItemModel(indices[j - 1]);
	      var labelModel = itemModel.getModel('label');
	      var margin = labelModel.get('margin');
	
	      if (status === 'add') {
	        var layerGroup = newLayersGroups[idx] = new graphic.Group();
	        polygon = new Polygon({
	          shape: {
	            points: points0,
	            stackedOnPoints: points1,
	            smooth: 0.4,
	            stackedOnSmooth: 0.4,
	            smoothConstraint: false
	          },
	          z2: 0
	        });
	        text = new graphic.Text({
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        });
	        layerGroup.add(polygon);
	        layerGroup.add(text);
	        group.add(layerGroup);
	        polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
	          polygon.removeClipPath();
	        }));
	      } else {
	        var layerGroup = oldLayersGroups[oldIdx];
	        polygon = layerGroup.childAt(0);
	        text = layerGroup.childAt(1);
	        group.add(layerGroup);
	        newLayersGroups[idx] = layerGroup;
	        graphic.updateProps(polygon, {
	          shape: {
	            points: points0,
	            stackedOnPoints: points1
	          }
	        }, seriesModel);
	        graphic.updateProps(text, {
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        }, seriesModel);
	      }
	
	      var hoverItemStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      graphic.setTextStyle(text.style, labelModel, {
	        text: labelModel.get('show') ? seriesModel.getFormattedLabel(indices[j - 1], 'normal') || data.getName(indices[j - 1]) : null,
	        textVerticalAlign: 'middle'
	      });
	      polygon.setStyle(extend({
	        fill: color
	      }, itemStyleModel.getItemStyle(['color'])));
	      graphic.setHoverStyle(polygon, hoverItemStyleModel.getItemStyle());
	    }
	
	    this._layersSeries = layerSeries;
	    this._layers = newLayersGroups;
	  },
	  dispose: function () {}
	}); // add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20,
	      height: rect.height + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(470)))

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var numberUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var single = seriesModel.coordinateSystem;
	    var layoutInfo = {}; // use the axis boundingRect for view
	
	    var rect = single.getRect();
	    layoutInfo.rect = rect;
	    var boundaryGap = seriesModel.get('boundaryGap');
	    var axis = single.getAxis();
	    layoutInfo.boundaryGap = boundaryGap;
	
	    if (axis.orient === 'horizontal') {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.height);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.height);
	      var height = rect.height - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, height);
	    } else {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.width);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.width);
	      var width = rect.width - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, width);
	    }
	
	    data.setLayout('layoutInfo', layoutInfo);
	  });
	}
	/**
	 * The layout information about themeriver
	 *
	 * @param {module:echarts/data/List} data  data in the series
	 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
	 * @param {number} height  value used to compute every series height
	 */
	
	
	function themeRiverLayout(data, seriesModel, height) {
	  if (!data.count()) {
	    return;
	  }
	
	  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.
	
	  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.
	
	  var timeDim = data.mapDimension('single');
	  var valueDim = data.mapDimension('value');
	  var layerPoints = zrUtil.map(layerSeries, function (singleLayer) {
	    return zrUtil.map(singleLayer.indices, function (idx) {
	      var pt = coordSys.dataToPoint(data.get(timeDim, idx));
	      pt[1] = data.get(valueDim, idx);
	      return pt;
	    });
	  });
	  var base = computeBaseline(layerPoints);
	  var baseLine = base.y0;
	  var ky = height / base.max; // set layout information for each item.
	
	  var n = layerSeries.length;
	  var m = layerSeries[0].indices.length;
	  var baseY0;
	
	  for (var j = 0; j < m; ++j) {
	    baseY0 = baseLine[j] * ky;
	    data.setItemLayout(layerSeries[0].indices[j], {
	      layerIndex: 0,
	      x: layerPoints[0][j][0],
	      y0: baseY0,
	      y: layerPoints[0][j][1] * ky
	    });
	
	    for (var i = 1; i < n; ++i) {
	      baseY0 += layerPoints[i - 1][j][1] * ky;
	      data.setItemLayout(layerSeries[i].indices[j], {
	        layerIndex: i,
	        x: layerPoints[i][j][0],
	        y0: baseY0,
	        y: layerPoints[i][j][1] * ky
	      });
	    }
	  }
	}
	/**
	 * Compute the baseLine of the rawdata
	 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
	 *
	 * @param  {Array.<Array>} data  the points in each layer
	 * @return {Object}
	 */
	
	
	function computeBaseline(data) {
	  var layerNum = data.length;
	  var pointNum = data[0].length;
	  var sums = [];
	  var y0 = [];
	  var max = 0;
	  var temp;
	  var base = {};
	
	  for (var i = 0; i < pointNum; ++i) {
	    for (var j = 0, temp = 0; j < layerNum; ++j) {
	      temp += data[j][i][1];
	    }
	
	    if (temp > max) {
	      max = temp;
	    }
	
	    sums.push(temp);
	  }
	
	  for (var k = 0; k < pointNum; ++k) {
	    y0[k] = (max - sums[k]) / 2;
	  }
	
	  max = 0;
	
	  for (var l = 0; l < pointNum; ++l) {
	    var sum = sums[l] + y0[l];
	
	    if (sum > max) {
	      max = sum;
	    }
	  }
	
	  base.y0 = y0;
	  base.max = max;
	  return base;
	}
	
	module.exports = _default;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var rawData = seriesModel.getRawData();
	    var colorList = seriesModel.get('color');
	    var idxMap = createHashMap();
	    data.each(function (idx) {
	      idxMap.set(data.getRawIndex(idx), idx);
	    });
	    rawData.each(function (rawIndex) {
	      var name = rawData.getName(rawIndex);
	      var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
	      rawData.setItemVisual(rawIndex, 'color', color);
	      var idx = idxMap.get(rawIndex);
	
	      if (idx != null) {
	        data.setItemVisual(idx, 'color', color);
	      }
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1715);
	
	__webpack_require__(1716);
	
	__webpack_require__(1718);
	
	var visualSymbol = __webpack_require__(145);
	
	var treeLayout = __webpack_require__(1719);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('tree', 'circle'));
	echarts.registerLayout(treeLayout);

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(66);
	
	var Tree = __webpack_require__(431);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var Model = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.tree',
	  layoutInfo: null,
	  // can support the position parameters 'left', 'top','right','bottom', 'width',
	  // 'height' in the setOption() with 'merge' mode normal.
	  layoutMode: 'box',
	
	  /**
	   * Init a tree data structure from data in option series
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option) {
	    //create an virtual root
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    var leaves = option.leaves || {};
	    var leavesModel = new Model(leaves, this, this.ecModel);
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	
	        if (!node.children.length || !node.isExpand) {
	          model.parentModel = leavesModel;
	        }
	
	        return model;
	      });
	    }
	
	    var treeDepth = 0;
	    tree.eachNode('preorder', function (node) {
	      if (node.depth > treeDepth) {
	        treeDepth = node.depth;
	      }
	    });
	    var expandAndCollapse = option.expandAndCollapse;
	    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
	    tree.root.eachNode('preorder', function (node) {
	      var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.
	
	      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
	    });
	    return tree.data;
	  },
	
	  /**
	   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
	   * @returns {string} orient
	   */
	  getOrient: function () {
	    var orient = this.get('orient');
	
	    if (orient === 'horizontal') {
	      orient = 'LR';
	    } else if (orient === 'vertical') {
	      orient = 'TB';
	    }
	
	    return orient;
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex) {
	    var tree = this.getData().tree;
	    var realRoot = tree.root.children[0];
	    var node = tree.getNodeByDataIndex(dataIndex);
	    var value = node.getValue();
	    var name = node.name;
	
	    while (node && node !== realRoot) {
	      name = node.parentNode.name + '.' + name;
	      node = node.parentNode;
	    }
	
	    return encodeHTML(name + (isNaN(value) || value == null ? '' : ' : ' + value));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // the position of the whole view
	    left: '12%',
	    top: '12%',
	    right: '12%',
	    bottom: '12%',
	    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
	    layout: 'orthogonal',
	    // value can be 'polyline'
	    edgeShape: 'curve',
	    edgeForkPosition: '50%',
	    // true | false | 'move' | 'scale', see module:component/helper/RoamController.
	    roam: false,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.4,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // The orient of orthoginal layout, can be setted to 'LR', 'TB', 'RL', 'BT'.
	    // and the backward compatibility configuration 'horizontal = LR', 'vertical = TB'.
	    orient: 'LR',
	    symbol: 'emptyCircle',
	    symbolSize: 7,
	    expandAndCollapse: true,
	    initialTreeDepth: 2,
	    lineStyle: {
	      color: '#ccc',
	      width: 1.5,
	      curveness: 0.5
	    },
	    itemStyle: {
	      color: 'lightsteelblue',
	      borderColor: '#c23531',
	      borderWidth: 1.5
	    },
	    label: {
	      show: true,
	      color: '#555'
	    },
	    leaves: {
	      label: {
	        show: true
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 700,
	    animationDurationUpdate: 1000
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var SymbolClz = __webpack_require__(265);
	
	var _layoutHelper = __webpack_require__(812);
	
	var radialCoordinate = _layoutHelper.radialCoordinate;
	
	var echarts = __webpack_require__(8);
	
	var bbox = __webpack_require__(226);
	
	var View = __webpack_require__(426);
	
	var roamHelper = __webpack_require__(421);
	
	var RoamController = __webpack_require__(218);
	
	var _cursorHelper = __webpack_require__(269);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TreeShape = graphic.extendShape({
	  shape: {
	    parentPoint: [],
	    childPoints: [],
	    orient: '',
	    forkPosition: ''
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var childPoints = shape.childPoints;
	    var childLen = childPoints.length;
	    var parentPoint = shape.parentPoint;
	    var firstChildPos = childPoints[0];
	    var lastChildPos = childPoints[childLen - 1];
	
	    if (childLen === 1) {
	      ctx.moveTo(parentPoint[0], parentPoint[1]);
	      ctx.lineTo(firstChildPos[0], firstChildPos[1]);
	      return;
	    }
	
	    var orient = shape.orient;
	    var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
	    var otherDim = 1 - forkDim;
	    var forkPosition = parsePercent(shape.forkPosition, 1);
	    var tmpPoint = [];
	    tmpPoint[forkDim] = parentPoint[forkDim];
	    tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
	    ctx.moveTo(parentPoint[0], parentPoint[1]);
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    ctx.moveTo(firstChildPos[0], firstChildPos[1]);
	    tmpPoint[forkDim] = firstChildPos[forkDim];
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    tmpPoint[forkDim] = lastChildPos[forkDim];
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    ctx.lineTo(lastChildPos[0], lastChildPos[1]);
	
	    for (var i = 1; i < childLen - 1; i++) {
	      var point = childPoints[i];
	      ctx.moveTo(point[0], point[1]);
	      tmpPoint[forkDim] = point[forkDim];
	      ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    }
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'tree',
	
	  /**
	   * Init the chart
	   * @override
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup = new graphic.Group();
	    /**
	     * @private
	     * @type {module:echarts/componet/helper/RoamController}
	     */
	
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: this.group
	    };
	    this.group.add(this._mainGroup);
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var layoutInfo = seriesModel.layoutInfo;
	    var group = this._mainGroup;
	    var layout = seriesModel.get('layout');
	
	    if (layout === 'radial') {
	      group.attr('position', [layoutInfo.x + layoutInfo.width / 2, layoutInfo.y + layoutInfo.height / 2]);
	    } else {
	      group.attr('position', [layoutInfo.x, layoutInfo.y]);
	    }
	
	    this._updateViewCoordSys(seriesModel, layoutInfo, layout);
	
	    this._updateController(seriesModel, ecModel, api);
	
	    var oldData = this._data;
	    var seriesScope = {
	      expandAndCollapse: seriesModel.get('expandAndCollapse'),
	      layout: layout,
	      edgeShape: seriesModel.get('edgeShape'),
	      edgeForkPosition: seriesModel.get('edgeForkPosition'),
	      orient: seriesModel.getOrient(),
	      curvature: seriesModel.get('lineStyle.curveness'),
	      symbolRotate: seriesModel.get('symbolRotate'),
	      symbolOffset: seriesModel.get('symbolOffset'),
	      hoverAnimation: seriesModel.get('hoverAnimation'),
	      useNameLabel: true,
	      fadeIn: true
	    };
	    data.diff(oldData).add(function (newIdx) {
	      if (symbolNeedsDraw(data, newIdx)) {
	        // Create node and edge
	        updateNode(data, newIdx, null, group, seriesModel, seriesScope);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx);
	
	      if (!symbolNeedsDraw(data, newIdx)) {
	        symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	        return;
	      } // Update node and edge
	
	
	      updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
	    }).remove(function (oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
	      // node haven't been initialized with a symbol element,
	      // you can't found it's symbol element through index.
	      // so if we want to remove the symbol element we should insure
	      // that the symbol element is not null.
	
	      if (symbolEl) {
	        removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	      }
	    }).execute();
	    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
	
	    this._updateNodeAndLinkScale(seriesModel);
	
	    if (seriesScope.expandAndCollapse === true) {
	      data.eachItemGraphicEl(function (el, dataIndex) {
	        el.off('click').on('click', function () {
	          api.dispatchAction({
	            type: 'treeExpandAndCollapse',
	            seriesId: seriesModel.id,
	            dataIndex: dataIndex
	          });
	        });
	      });
	    }
	
	    this._data = data;
	  },
	  _updateViewCoordSys: function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    data.each(function (idx) {
	      var layout = data.getItemLayout(idx);
	
	      if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
	        points.push([+layout.x, +layout.y]);
	      }
	    });
	    var min = [];
	    var max = [];
	    bbox.fromPoints(points, min, max); // If don't Store min max when collapse the root node after roam,
	    // the root node will disappear.
	
	    var oldMin = this._min;
	    var oldMax = this._max; // If width or height is 0
	
	    if (max[0] - min[0] === 0) {
	      min[0] = oldMin ? oldMin[0] : min[0] - 1;
	      max[0] = oldMax ? oldMax[0] : max[0] + 1;
	    }
	
	    if (max[1] - min[1] === 0) {
	      min[1] = oldMin ? oldMin[1] : min[1] - 1;
	      max[1] = oldMax ? oldMax[1] : max[1] + 1;
	    }
	
	    var viewCoordSys = seriesModel.coordinateSystem = new View();
	    viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	    viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	    viewCoordSys.setCenter(seriesModel.get('center'));
	    viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
	
	    this.group.attr({
	      position: viewCoordSys.position,
	      scale: viewCoordSys.scale
	    });
	    this._viewCoordSys = viewCoordSys;
	    this._min = min;
	    this._max = max;
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }, this).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale(seriesModel);
	    }, this);
	  },
	  _updateNodeAndLinkScale: function (seriesModel) {
	    var data = seriesModel.getData();
	
	    var nodeScale = this._getNodeGlobalScale(seriesModel);
	
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  _getNodeGlobalScale: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type !== 'view') {
	      return 1;
	    }
	
	    var nodeScaleRatio = this._nodeScaleRatio;
	    var groupScale = coordSys.scale;
	    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	    var roamZoom = coordSys.getZoom();
	    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	    return nodeScale / groupZoom;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	  },
	  remove: function () {
	    this._mainGroup.removeAll();
	
	    this._data = null;
	  }
	});
	
	function symbolNeedsDraw(data, dataIndex) {
	  var layout = data.getItemLayout(dataIndex);
	  return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, 'symbol') !== 'none';
	}
	
	function getTreeNodeStyle(node, itemModel, seriesScope) {
	  seriesScope.itemModel = itemModel;
	  seriesScope.itemStyle = itemModel.getModel('itemStyle').getItemStyle();
	  seriesScope.hoverItemStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  seriesScope.lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	  seriesScope.labelModel = itemModel.getModel('label');
	  seriesScope.hoverLabelModel = itemModel.getModel('emphasis.label');
	
	  if (node.isExpand === false && node.children.length !== 0) {
	    seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
	  } else {
	    seriesScope.symbolInnerColor = '#fff';
	  }
	
	  return seriesScope;
	}
	
	function updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var isInit = !symbolEl;
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var virtualRoot = data.tree.root;
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceLayout = source.getLayout();
	  var sourceOldLayout = sourceSymbolEl ? {
	    x: sourceSymbolEl.position[0],
	    y: sourceSymbolEl.position[1],
	    rawX: sourceSymbolEl.__radialOldRawX,
	    rawY: sourceSymbolEl.__radialOldRawY
	  } : sourceLayout;
	  var targetLayout = node.getLayout();
	
	  if (isInit) {
	    symbolEl = new SymbolClz(data, dataIndex, seriesScope);
	    symbolEl.attr('position', [sourceOldLayout.x, sourceOldLayout.y]);
	  } else {
	    symbolEl.updateData(data, dataIndex, seriesScope);
	  }
	
	  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
	  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
	  symbolEl.__radialRawX = targetLayout.rawX;
	  symbolEl.__radialRawY = targetLayout.rawY;
	  group.add(symbolEl);
	  data.setItemGraphicEl(dataIndex, symbolEl);
	  graphic.updateProps(symbolEl, {
	    position: [targetLayout.x, targetLayout.y]
	  }, seriesModel);
	  var symbolPath = symbolEl.getSymbolPath();
	
	  if (seriesScope.layout === 'radial') {
	    var realRoot = virtualRoot.children[0];
	    var rootLayout = realRoot.getLayout();
	    var length = realRoot.children.length;
	    var rad;
	    var isLeft;
	
	    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
	      var center = {};
	      center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
	      center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
	      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      isLeft = center.x < rootLayout.x;
	
	      if (isLeft) {
	        rad = rad - Math.PI;
	      }
	    } else {
	      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
	        isLeft = targetLayout.x < rootLayout.x;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	      } else {
	        isLeft = targetLayout.x > rootLayout.x;
	
	        if (!isLeft) {
	          rad = rad - Math.PI;
	        }
	      }
	    }
	
	    var textPosition = isLeft ? 'left' : 'right';
	    var rotate = seriesScope.labelModel.get('rotate');
	    var labelRotateRadian = rotate * (Math.PI / 180);
	    symbolPath.setStyle({
	      textPosition: seriesScope.labelModel.get('position') || textPosition,
	      textRotation: rotate == null ? -rad : labelRotateRadian,
	      textOrigin: 'center',
	      verticalAlign: 'middle'
	    });
	  }
	
	  drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope);
	}
	
	function drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope) {
	  var edgeShape = seriesScope.edgeShape;
	  var edge = symbolEl.__edge;
	
	  if (edgeShape === 'curve') {
	    if (node.parentNode && node.parentNode !== virtualRoot) {
	      if (!edge) {
	        edge = symbolEl.__edge = new graphic.BezierCurve({
	          shape: getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
	          style: zrUtil.defaults({
	            opacity: 0,
	            strokeNoScale: true
	          }, seriesScope.lineStyle)
	        });
	      }
	
	      graphic.updateProps(edge, {
	        shape: getEdgeShape(seriesScope, sourceLayout, targetLayout),
	        style: zrUtil.defaults({
	          opacity: 1
	        }, seriesScope.lineStyle)
	      }, seriesModel);
	    }
	  } else if (edgeShape === 'polyline') {
	    if (seriesScope.layout === 'orthogonal') {
	      if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
	        var children = node.children;
	        var childPoints = [];
	
	        for (var i = 0; i < children.length; i++) {
	          var childLayout = children[i].getLayout();
	          childPoints.push([childLayout.x, childLayout.y]);
	        }
	
	        if (!edge) {
	          edge = symbolEl.__edge = new TreeShape({
	            shape: {
	              parentPoint: [targetLayout.x, targetLayout.y],
	              childPoints: [[targetLayout.x, targetLayout.y]],
	              orient: seriesScope.orient,
	              forkPosition: seriesScope.edgeForkPosition
	            },
	            style: zrUtil.defaults({
	              opacity: 0,
	              strokeNoScale: true
	            }, seriesScope.lineStyle)
	          });
	        }
	
	        graphic.updateProps(edge, {
	          shape: {
	            parentPoint: [targetLayout.x, targetLayout.y],
	            childPoints: childPoints
	          },
	          style: zrUtil.defaults({
	            opacity: 1
	          }, seriesScope.lineStyle)
	        }, seriesModel);
	      }
	    } else {}
	  }
	
	  group.add(edge);
	}
	
	function removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var virtualRoot = data.tree.root;
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var edgeShape = seriesScope.edgeShape;
	  var sourceLayout;
	
	  while (sourceLayout = source.getLayout(), sourceLayout == null) {
	    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
	  }
	
	  graphic.updateProps(symbolEl, {
	    position: [sourceLayout.x + 1, sourceLayout.y + 1]
	  }, seriesModel, function () {
	    group.remove(symbolEl);
	    data.setItemGraphicEl(dataIndex, null);
	  });
	  symbolEl.fadeOut(null, {
	    keepLabel: true
	  });
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
	  // the source at the same time. because the polyline edge shape is only owned by the source.
	  // 2.when the node is the only children of the source, delete the node should delete the edge of
	  // the source at the same time. the same reason as above.
	
	  var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
	  var edgeShape = seriesScope.edgeShape;
	
	  if (edge) {
	    if (edgeShape === 'curve') {
	      graphic.updateProps(edge, {
	        shape: getEdgeShape(seriesScope, sourceLayout, sourceLayout),
	        style: {
	          opacity: 0
	        }
	      }, seriesModel, function () {
	        group.remove(edge);
	      });
	    } else if (edgeShape === 'polyline' && seriesScope.layout === 'orthogonal') {
	      graphic.updateProps(edge, {
	        shape: {
	          parentPoint: [sourceLayout.x, sourceLayout.y],
	          childPoints: [[sourceLayout.x, sourceLayout.y]]
	        },
	        style: {
	          opacity: 0
	        }
	      }, seriesModel, function () {
	        group.remove(edge);
	      });
	    }
	  }
	}
	
	function getEdgeShape(seriesScope, sourceLayout, targetLayout) {
	  var cpx1;
	  var cpy1;
	  var cpx2;
	  var cpy2;
	  var orient = seriesScope.orient;
	  var x1;
	  var x2;
	  var y1;
	  var y2;
	
	  if (seriesScope.layout === 'radial') {
	    x1 = sourceLayout.rawX;
	    y1 = sourceLayout.rawY;
	    x2 = targetLayout.rawX;
	    y2 = targetLayout.rawY;
	    var radialCoor1 = radialCoordinate(x1, y1);
	    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
	    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
	    var radialCoor4 = radialCoordinate(x2, y2);
	    return {
	      x1: radialCoor1.x,
	      y1: radialCoor1.y,
	      x2: radialCoor4.x,
	      y2: radialCoor4.y,
	      cpx1: radialCoor2.x,
	      cpy1: radialCoor2.y,
	      cpx2: radialCoor3.x,
	      cpy2: radialCoor3.y
	    };
	  } else {
	    x1 = sourceLayout.x;
	    y1 = sourceLayout.y;
	    x2 = targetLayout.x;
	    y2 = targetLayout.y;
	
	    if (orient === 'LR' || orient === 'RL') {
	      cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
	      cpy1 = y1;
	      cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
	      cpy2 = y2;
	    }
	
	    if (orient === 'TB' || orient === 'BT') {
	      cpx1 = x1;
	      cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
	      cpx2 = x2;
	      cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
	    }
	  }
	
	  return {
	    x1: x1,
	    y1: y1,
	    x2: x2,
	    y2: y2,
	    cpx1: cpx1,
	    cpy1: cpy1,
	    cpx2: cpx2,
	    cpy2: cpy2
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Traverse the tree from bottom to top and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	function eachAfter(root, callback, separation) {
	  var nodes = [root];
	  var next = [];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    next.push(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = 0; i < children.length; i++) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	
	  while (node = next.pop()) {
	    // jshint ignore:line
	    callback(node, separation);
	  }
	}
	/**
	 * Traverse the tree from top to bottom and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	
	
	function eachBefore(root, callback) {
	  var nodes = [root];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    callback(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = children.length - 1; i >= 0; i--) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	}
	
	exports.eachAfter = eachAfter;
	exports.eachBefore = eachBefore;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var _roamHelper = __webpack_require__(410);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'treeExpandAndCollapse',
	  event: 'treeExpandAndCollapse',
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var dataIndex = payload.dataIndex;
	    var tree = seriesModel.getData().tree;
	    var node = tree.getNodeByDataIndex(dataIndex);
	    node.isExpand = !node.isExpand;
	  });
	});
	echarts.registerAction({
	  type: 'treeRoam',
	  event: 'treeRoam',
	  // Here we set 'none' instead of 'update', because roam action
	  // just need to update the transform matrix without having to recalculate
	  // the layout. So don't need to go through the whole update process, such
	  // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
	  update: 'none'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _traversalHelper = __webpack_require__(1717);
	
	var eachAfter = _traversalHelper.eachAfter;
	var eachBefore = _traversalHelper.eachBefore;
	
	var _layoutHelper = __webpack_require__(812);
	
	var init = _layoutHelper.init;
	var firstWalk = _layoutHelper.firstWalk;
	var secondWalk = _layoutHelper.secondWalk;
	var sep = _layoutHelper.separation;
	var radialCoordinate = _layoutHelper.radialCoordinate;
	var getViewRect = _layoutHelper.getViewRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('tree', function (seriesModel) {
	    commonLayout(seriesModel, api);
	  });
	}
	
	function commonLayout(seriesModel, api) {
	  var layoutInfo = getViewRect(seriesModel, api);
	  seriesModel.layoutInfo = layoutInfo;
	  var layout = seriesModel.get('layout');
	  var width = 0;
	  var height = 0;
	  var separation = null;
	
	  if (layout === 'radial') {
	    width = 2 * Math.PI;
	    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
	    separation = sep(function (node1, node2) {
	      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
	    });
	  } else {
	    width = layoutInfo.width;
	    height = layoutInfo.height;
	    separation = sep();
	  }
	
	  var virtualRoot = seriesModel.getData().tree.root;
	  var realRoot = virtualRoot.children[0];
	
	  if (realRoot) {
	    init(virtualRoot);
	    eachAfter(realRoot, firstWalk, separation);
	    virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
	    eachBefore(realRoot, secondWalk);
	    var left = realRoot;
	    var right = realRoot;
	    var bottom = realRoot;
	    eachBefore(realRoot, function (node) {
	      var x = node.getLayout().x;
	
	      if (x < left.getLayout().x) {
	        left = node;
	      }
	
	      if (x > right.getLayout().x) {
	        right = node;
	      }
	
	      if (node.depth > bottom.depth) {
	        bottom = node;
	      }
	    });
	    var delta = left === right ? 1 : separation(left, right) / 2;
	    var tx = delta - left.getLayout().x;
	    var kx = 0;
	    var ky = 0;
	    var coorX = 0;
	    var coorY = 0;
	
	    if (layout === 'radial') {
	      kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1
	
	      ky = height / (bottom.depth - 1 || 1);
	      eachBefore(realRoot, function (node) {
	        coorX = (node.getLayout().x + tx) * kx;
	        coorY = (node.depth - 1) * ky;
	        var finalCoor = radialCoordinate(coorX, coorY);
	        node.setLayout({
	          x: finalCoor.x,
	          y: finalCoor.y,
	          rawX: coorX,
	          rawY: coorY
	        }, true);
	      });
	    } else {
	      var orient = seriesModel.getOrient();
	
	      if (orient === 'RL' || orient === 'LR') {
	        ky = height / (right.getLayout().x + delta + tx);
	        kx = width / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorY = (node.getLayout().x + tx) * ky;
	          coorX = orient === 'LR' ? (node.depth - 1) * kx : width - (node.depth - 1) * kx;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      } else if (orient === 'TB' || orient === 'BT') {
	        kx = width / (right.getLayout().x + delta + tx);
	        ky = height / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorX = (node.getLayout().x + tx) * kx;
	          coorY = orient === 'TB' ? (node.depth - 1) * ky : height - (node.depth - 1) * ky;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      }
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1722);
	
	__webpack_require__(1723);
	
	__webpack_require__(1724);
	
	var treemapVisual = __webpack_require__(1726);
	
	var treemapLayout = __webpack_require__(1725);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(treemapVisual);
	echarts.registerLayout(treemapLayout);

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(17);
	
	var layout = __webpack_require__(47);
	
	var zrUtil = __webpack_require__(2);
	
	var _treeHelper = __webpack_require__(140);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TEXT_PADDING = 8;
	var ITEM_GAP = 8;
	var ARRAY_LENGTH = 5;
	
	function Breadcrumb(containerGroup) {
	  /**
	   * @private
	   * @type {module:zrender/container/Group}
	   */
	  this.group = new graphic.Group();
	  containerGroup.add(this.group);
	}
	
	Breadcrumb.prototype = {
	  constructor: Breadcrumb,
	  render: function (seriesModel, api, targetNode, onSelect) {
	    var model = seriesModel.getModel('breadcrumb');
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    if (!model.get('show') || !targetNode) {
	      return;
	    }
	
	    var normalStyleModel = model.getModel('itemStyle'); // var emphasisStyleModel = model.getModel('emphasis.itemStyle');
	
	    var textStyleModel = normalStyleModel.getModel('textStyle');
	    var layoutParam = {
	      pos: {
	        left: model.get('left'),
	        right: model.get('right'),
	        top: model.get('top'),
	        bottom: model.get('bottom')
	      },
	      box: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      emptyItemWidth: model.get('emptyItemWidth'),
	      totalWidth: 0,
	      renderList: []
	    };
	
	    this._prepare(targetNode, layoutParam, textStyleModel);
	
	    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);
	
	    layout.positionElement(thisGroup, layoutParam.pos, layoutParam.box);
	  },
	
	  /**
	   * Prepare render list and total width
	   * @private
	   */
	  _prepare: function (targetNode, layoutParam, textStyleModel) {
	    for (var node = targetNode; node; node = node.parentNode) {
	      var text = node.getModel().get('name');
	      var textRect = textStyleModel.getTextRect(text);
	      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
	      layoutParam.totalWidth += itemWidth + ITEM_GAP;
	      layoutParam.renderList.push({
	        node: node,
	        text: text,
	        width: itemWidth
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderContent: function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
	    // Start rendering.
	    var lastX = 0;
	    var emptyItemWidth = layoutParam.emptyItemWidth;
	    var height = seriesModel.get('breadcrumb.height');
	    var availableSize = layout.getAvailableSize(layoutParam.pos, layoutParam.box);
	    var totalWidth = layoutParam.totalWidth;
	    var renderList = layoutParam.renderList;
	
	    for (var i = renderList.length - 1; i >= 0; i--) {
	      var item = renderList[i];
	      var itemNode = item.node;
	      var itemWidth = item.width;
	      var text = item.text; // Hdie text and shorten width if necessary.
	
	      if (totalWidth > availableSize.width) {
	        totalWidth -= itemWidth - emptyItemWidth;
	        itemWidth = emptyItemWidth;
	        text = null;
	      }
	
	      var el = new graphic.Polygon({
	        shape: {
	          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
	        },
	        style: zrUtil.defaults(normalStyleModel.getItemStyle(), {
	          lineJoin: 'bevel',
	          text: text,
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        }),
	        z: 10,
	        onclick: zrUtil.curry(onSelect, itemNode)
	      });
	      this.group.add(el);
	      packEventData(el, seriesModel, itemNode);
	      lastX += itemWidth + ITEM_GAP;
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this.group.removeAll();
	  }
	};
	
	function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
	  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
	  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
	  !head && points.push([x, y + itemHeight / 2]);
	  return points;
	} // Package custom mouse event.
	
	
	function packEventData(el, seriesModel, itemNode) {
	  el.eventData = {
	    componentType: 'series',
	    componentSubType: 'treemap',
	    componentIndex: seriesModel.componentIndex,
	    seriesIndex: seriesModel.componentIndex,
	    seriesName: seriesModel.name,
	    seriesType: 'treemap',
	    selfType: 'breadcrumb',
	    // Distinguish with click event on treemap node.
	    nodeData: {
	      dataIndex: itemNode && itemNode.dataIndex,
	      name: itemNode && itemNode.name
	    },
	    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
	  };
	}
	
	var _default = Breadcrumb;
	module.exports = _default;

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var SeriesModel = __webpack_require__(66);
	
	var Tree = __webpack_require__(431);
	
	var Model = __webpack_require__(57);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var _treeHelper = __webpack_require__(140);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.treemap',
	  layoutMode: 'box',
	  dependencies: ['grid', 'polar'],
	  preventUsingHoverLayer: true,
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  defaultOption: {
	    // Disable progressive rendering
	    progressive: 0,
	    // center: ['50%', '50%'],          // not supported in ec3.
	    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
	    left: 'center',
	    top: 'middle',
	    right: null,
	    bottom: null,
	    width: '80%',
	    height: '80%',
	    sort: true,
	    // Can be null or false or true
	    // (order by desc default, asc not supported yet (strange effect))
	    clipWindow: 'origin',
	    // Size of clipped window when zooming. 'origin' or 'fullscreen'
	    squareRatio: 0.5 * (1 + Math.sqrt(5)),
	    // golden ratio
	    leafDepth: null,
	    // Nodes on depth from root are regarded as leaves.
	    // Count from zero (zero represents only view root).
	    drillDownIcon: '▶',
	    // Use html character temporarily because it is complicated
	    // to align specialized icon. ▷▶❒❐▼✚
	    zoomToNodeRatio: 0.32 * 0.32,
	    // Be effective when using zoomToNode. Specify the proportion of the
	    // target node area in the view area.
	    roam: true,
	    // true, false, 'scale' or 'zoom', 'move'.
	    nodeClick: 'zoomToNode',
	    // Leaf node click behaviour: 'zoomToNode', 'link', false.
	    // If leafDepth is set and clicking a node which has children but
	    // be on left depth, the behaviour would be changing root. Otherwise
	    // use behavious defined above.
	    animation: true,
	    animationDurationUpdate: 900,
	    animationEasing: 'quinticInOut',
	    breadcrumb: {
	      show: true,
	      height: 22,
	      left: 'center',
	      top: 'bottom',
	      // right
	      // bottom
	      emptyItemWidth: 25,
	      // Width of empty node.
	      itemStyle: {
	        color: 'rgba(0,0,0,0.7)',
	        //'#5793f3',
	        borderColor: 'rgba(255,255,255,0.7)',
	        borderWidth: 1,
	        shadowColor: 'rgba(150,150,150,1)',
	        shadowBlur: 3,
	        shadowOffsetX: 0,
	        shadowOffsetY: 0,
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      emphasis: {
	        textStyle: {}
	      }
	    },
	    label: {
	      show: true,
	      // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
	      distance: 0,
	      padding: 5,
	      position: 'inside',
	      // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true // align
	      // verticalAlign
	
	    },
	    upperLabel: {
	      // Label when node is parent.
	      show: false,
	      position: [0, '50%'],
	      height: 20,
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true,
	      // align: null,
	      verticalAlign: 'middle'
	    },
	    itemStyle: {
	      color: null,
	      // Can be 'none' if not necessary.
	      colorAlpha: null,
	      // Can be 'none' if not necessary.
	      colorSaturation: null,
	      // Can be 'none' if not necessary.
	      borderWidth: 0,
	      gapWidth: 0,
	      borderColor: '#fff',
	      borderColorSaturation: null // If specified, borderColor will be ineffective, and the
	      // border color is evaluated by color of current node and
	      // borderColorSaturation.
	
	    },
	    emphasis: {
	      upperLabel: {
	        show: true,
	        position: [0, '50%'],
	        color: '#fff',
	        ellipsis: true,
	        verticalAlign: 'middle'
	      }
	    },
	    visualDimension: 0,
	    // Can be 0, 1, 2, 3.
	    visualMin: null,
	    visualMax: null,
	    color: [],
	    // + treemapSeries.color should not be modified. Please only modified
	    // level[n].color (if necessary).
	    // + Specify color list of each level. level[0].color would be global
	    // color list if not specified. (see method `setDefault`).
	    // + But set as a empty array to forbid fetch color from global palette
	    // when using nodeModel.get('color'), otherwise nodes on deep level
	    // will always has color palette set and are not able to inherit color
	    // from parent node.
	    // + TreemapSeries.color can not be set as 'none', otherwise effect
	    // legend color fetching (see seriesColor.js).
	    colorAlpha: null,
	    // Array. Specify color alpha range of each level, like [0.2, 0.8]
	    colorSaturation: null,
	    // Array. Specify color saturation of each level, like [0.2, 0.5]
	    colorMappingBy: 'index',
	    // 'value' or 'index' or 'id'.
	    visibleMin: 10,
	    // If area less than this threshold (unit: pixel^2), node will not
	    // be rendered. Only works when sort is 'asc' or 'desc'.
	    childrenVisibleMin: null,
	    // If area of a node less than this threshold (unit: pixel^2),
	    // grandchildren will not show.
	    // Why grandchildren? If not grandchildren but children,
	    // some siblings show children and some not,
	    // the appearance may be mess and not consistent,
	    levels: [] // Each item: {
	    //     visibleMin, itemStyle, visualDimension, label
	    // }
	    // data: {
	    //      value: [],
	    //      children: [],
	    //      link: 'http://xxx.xxx.xxx',
	    //      target: 'blank' or 'self'
	    // }
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
	    // This way is a little tricky, must satisfy the precondition:
	    //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
	    //   2. The `Model.prototype.getModel()` will not use any clone-like way.
	
	    var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
	    var designatedVisualModel = new Model({
	      itemStyle: designatedVisualItemStyle
	    }, this, ecModel);
	    levels = option.levels = setDefault(levels, ecModel);
	    var levelModels = zrUtil.map(levels || [], function (levelDefine) {
	      return new Model(levelDefine, designatedVisualModel, ecModel);
	    }, this); // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	        var levelModel = levelModels[node.depth]; // If no levelModel, we also need `designatedVisualModel`.
	
	        model.parentModel = levelModel || designatedVisualModel;
	        return model;
	      });
	    }
	
	    return tree.data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   * @param {boolean} [mutipleSeries=false]
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? addCommas(value[0]) : addCommas(value);
	    var name = data.getName(dataIndex);
	    return encodeHTML(name + ': ' + formattedValue);
	  },
	
	  /**
	   * Add tree path to tooltip param
	   *
	   * @override
	   * @param {number} dataIndex
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	
	  /**
	   * @public
	   * @param {Object} layoutInfo {
	   *                                x: containerGroup x
	   *                                y: containerGroup y
	   *                                width: containerGroup width
	   *                                height: containerGroup height
	   *                            }
	   */
	  setLayoutInfo: function (layoutInfo) {
	    /**
	     * @readOnly
	     * @type {Object}
	     */
	    this.layoutInfo = this.layoutInfo || {};
	    zrUtil.extend(this.layoutInfo, layoutInfo);
	  },
	
	  /**
	   * @param  {string} id
	   * @return {number} index
	   */
	  mapIdToIndex: function (id) {
	    // A feature is implemented:
	    // index is monotone increasing with the sequence of
	    // input id at the first time.
	    // This feature can make sure that each data item and its
	    // mapped color have the same index between data list and
	    // color list at the beginning, which is useful for user
	    // to adjust data-color mapping.
	
	    /**
	     * @private
	     * @type {Object}
	     */
	    var idIndexMap = this._idIndexMap;
	
	    if (!idIndexMap) {
	      idIndexMap = this._idIndexMap = zrUtil.createHashMap();
	      /**
	       * @private
	       * @type {number}
	       */
	
	      this._idIndexMapCount = 0;
	    }
	
	    var index = idIndexMap.get(id);
	
	    if (index == null) {
	      idIndexMap.set(id, index = this._idIndexMapCount++);
	    }
	
	    return index;
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	/**
	 * set default to level configuration
	 */
	
	
	function setDefault(levels, ecModel) {
	  var globalColorList = ecModel.get('color');
	
	  if (!globalColorList) {
	    return;
	  }
	
	  levels = levels || [];
	  var hasColorDefine;
	  zrUtil.each(levels, function (levelDefine) {
	    var model = new Model(levelDefine);
	    var modelColor = model.get('color');
	
	    if (model.get('itemStyle.color') || modelColor && modelColor !== 'none') {
	      hasColorDefine = true;
	    }
	  });
	
	  if (!hasColorDefine) {
	    var level0 = levels[0] || (levels[0] = {});
	    level0.color = globalColorList.slice();
	  }
	
	  return levels;
	}
	
	module.exports = _default;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var DataDiffer = __webpack_require__(142);
	
	var helper = __webpack_require__(140);
	
	var Breadcrumb = __webpack_require__(1721);
	
	var RoamController = __webpack_require__(218);
	
	var BoundingRect = __webpack_require__(51);
	
	var matrix = __webpack_require__(75);
	
	var animationUtil = __webpack_require__(1869);
	
	var makeStyleMapper = __webpack_require__(177);
	
	var _format = __webpack_require__(48);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var Group = graphic.Group;
	var Rect = graphic.Rect;
	var each = zrUtil.each;
	var DRAG_THRESHOLD = 3;
	var PATH_LABEL_NOAMAL = ['label'];
	var PATH_LABEL_EMPHASIS = ['emphasis', 'label'];
	var PATH_UPPERLABEL_NORMAL = ['upperLabel'];
	var PATH_UPPERLABEL_EMPHASIS = ['emphasis', 'upperLabel'];
	var Z_BASE = 10; // Should bigger than every z.
	
	var Z_BG = 1;
	var Z_CONTENT = 2;
	var getItemStyleEmphasis = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
	// so use `stroke` to indicate the stroke of the rect.
	['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	
	var getItemStyleNormal = function (model) {
	  // Normal style props should include emphasis style props.
	  var itemStyle = getItemStyleEmphasis(model); // Clear styles set by emphasis.
	
	  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
	  return itemStyle;
	};
	
	var _default = echarts.extendChartView({
	  type: 'treemap',
	
	  /**
	   * @override
	   */
	  init: function (o, api) {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this._containerGroup;
	    /**
	     * @private
	     * @type {Object.<string, Array.<module:zrender/container/Group>>}
	     */
	
	    this._storage = createStorage();
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:echarts/chart/treemap/Breadcrumb}
	     */
	
	    this._breadcrumb;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/RoamController}
	     */
	
	    this._controller;
	    /**
	     * 'ready', 'animating'
	     * @private
	     */
	
	    this._state = 'ready';
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var models = ecModel.findComponents({
	      mainType: 'series',
	      subType: 'treemap',
	      query: payload
	    });
	
	    if (zrUtil.indexOf(models, seriesModel) < 0) {
	      return;
	    }
	
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var payloadType = payload && payload.type;
	    var layoutInfo = seriesModel.layoutInfo;
	    var isInit = !this._oldTree;
	    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.
	
	    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
	      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
	      direction: payload.direction
	    } : null;
	
	    var containerGroup = this._giveContainerGroup(layoutInfo);
	
	    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
	
	    !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
	
	    this._resetController(api);
	
	    this._renderBreadcrumb(seriesModel, api, targetInfo);
	  },
	
	  /**
	   * @private
	   */
	  _giveContainerGroup: function (layoutInfo) {
	    var containerGroup = this._containerGroup;
	
	    if (!containerGroup) {
	      // FIXME
	      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
	      containerGroup = this._containerGroup = new Group();
	
	      this._initEvents(containerGroup);
	
	      this.group.add(containerGroup);
	    }
	
	    containerGroup.attr('position', [layoutInfo.x, layoutInfo.y]);
	    return containerGroup;
	  },
	
	  /**
	   * @private
	   */
	  _doRender: function (containerGroup, seriesModel, reRoot) {
	    var thisTree = seriesModel.getData().tree;
	    var oldTree = this._oldTree; // Clear last shape records.
	
	    var lastsForAnimation = createStorage();
	    var thisStorage = createStorage();
	    var oldStorage = this._storage;
	    var willInvisibleEls = [];
	    var doRenderNode = zrUtil.curry(renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
	    // the oldTree is actually losted, so we can not find all of the old graphic
	    // elements from tree. So we use this stragegy: make element storage, move
	    // from old storage to new storage, clear old storage.
	
	    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.
	
	    var willDeleteEls = clearStorage(oldStorage);
	    this._oldTree = thisTree;
	    this._storage = thisStorage;
	    return {
	      lastsForAnimation: lastsForAnimation,
	      willDeleteEls: willDeleteEls,
	      renderFinally: renderFinally
	    };
	
	    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
	      // When 'render' is triggered by action,
	      // 'this' and 'old' may be the same tree,
	      // we use rawIndex in that case.
	      if (sameTree) {
	        oldViewChildren = thisViewChildren;
	        each(thisViewChildren, function (child, index) {
	          !child.isRemoved() && processNode(index, index);
	        });
	      } // Diff hierarchically (diff only in each subtree, but not whole).
	      // because, consistency of view is important.
	      else {
	          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	        }
	
	      function getKey(node) {
	        // Identify by name or raw index.
	        return node.getId();
	      }
	
	      function processNode(newIndex, oldIndex) {
	        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
	        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
	        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
	        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
	      }
	    }
	
	    function clearStorage(storage) {
	      var willDeleteEls = createStorage();
	      storage && each(storage, function (store, storageName) {
	        var delEls = willDeleteEls[storageName];
	        each(store, function (el) {
	          el && (delEls.push(el), el.__tmWillDelete = 1);
	        });
	      });
	      return willDeleteEls;
	    }
	
	    function renderFinally() {
	      each(willDeleteEls, function (els) {
	        each(els, function (el) {
	          el.parent && el.parent.remove(el);
	        });
	      });
	      each(willInvisibleEls, function (el) {
	        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
	        // just mark as invisible.
	
	        el.dirty();
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doAnimation: function (containerGroup, renderResult, seriesModel, reRoot) {
	    if (!seriesModel.get('animation')) {
	      return;
	    }
	
	    var duration = seriesModel.get('animationDurationUpdate');
	    var easing = seriesModel.get('animationEasing');
	    var animationWrap = animationUtil.createWrap(); // Make delete animations.
	
	    each(renderResult.willDeleteEls, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        if (el.invisible) {
	          return;
	        }
	
	        var parent = el.parent; // Always has parent, and parent is nodeGroup.
	
	        var target;
	
	        if (reRoot && reRoot.direction === 'drillDown') {
	          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
	          // Only `content` will enter this branch, because
	          // `background` and `nodeGroup` will not be deleted.
	          ? {
	            shape: {
	              x: 0,
	              y: 0,
	              width: parent.__tmNodeWidth,
	              height: parent.__tmNodeHeight
	            },
	            style: {
	              opacity: 0
	            } // Others.
	
	          } : {
	            style: {
	              opacity: 0
	            }
	          };
	        } else {
	          var targetX = 0;
	          var targetY = 0;
	
	          if (!parent.__tmWillDelete) {
	            // Let node animate to right-bottom corner, cooperating with fadeout,
	            // which is appropriate for user understanding.
	            // Divided by 2 for reRoot rolling up effect.
	            targetX = parent.__tmNodeWidth / 2;
	            targetY = parent.__tmNodeHeight / 2;
	          }
	
	          target = storageName === 'nodeGroup' ? {
	            position: [targetX, targetY],
	            style: {
	              opacity: 0
	            }
	          } : {
	            shape: {
	              x: targetX,
	              y: targetY,
	              width: 0,
	              height: 0
	            },
	            style: {
	              opacity: 0
	            }
	          };
	        }
	
	        target && animationWrap.add(el, target, duration, easing);
	      });
	    }); // Make other animations
	
	    each(this._storage, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        var last = renderResult.lastsForAnimation[storageName][rawIndex];
	        var target = {};
	
	        if (!last) {
	          return;
	        }
	
	        if (storageName === 'nodeGroup') {
	          if (last.old) {
	            target.position = el.position.slice();
	            el.attr('position', last.old);
	          }
	        } else {
	          if (last.old) {
	            target.shape = zrUtil.extend({}, el.shape);
	            el.setShape(last.old);
	          }
	
	          if (last.fadein) {
	            el.setStyle('opacity', 0);
	            target.style = {
	              opacity: 1
	            };
	          } // When animation is stopped for succedent animation starting,
	          // el.style.opacity might not be 1
	          else if (el.style.opacity !== 1) {
	              target.style = {
	                opacity: 1
	              };
	            }
	        }
	
	        animationWrap.add(el, target, duration, easing);
	      });
	    }, this);
	    this._state = 'animating';
	    animationWrap.done(bind(function () {
	      this._state = 'ready';
	      renderResult.renderFinally();
	    }, this)).start();
	  },
	
	  /**
	   * @private
	   */
	  _resetController: function (api) {
	    var controller = this._controller; // Init controller.
	
	    if (!controller) {
	      controller = this._controller = new RoamController(api.getZr());
	      controller.enable(this.seriesModel.get('roam'));
	      controller.on('pan', bind(this._onPan, this));
	      controller.on('zoom', bind(this._onZoom, this));
	    }
	
	    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
	    controller.setPointerChecker(function (e, x, y) {
	      return rect.contain(x, y);
	    });
	  },
	
	  /**
	   * @private
	   */
	  _clearController: function () {
	    var controller = this._controller;
	
	    if (controller) {
	      controller.dispose();
	      controller = null;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onPan: function (e) {
	    if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      this.api.dispatchAction({
	        type: 'treemapMove',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rootLayout.x + e.dx,
	          y: rootLayout.y + e.dy,
	          width: rootLayout.width,
	          height: rootLayout.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onZoom: function (e) {
	    var mouseX = e.originX;
	    var mouseY = e.originY;
	
	    if (this._state !== 'animating') {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
	      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.
	
	      mouseX -= layoutInfo.x;
	      mouseY -= layoutInfo.y; // Scale root bounding rect.
	
	      var m = matrix.create();
	      matrix.translate(m, m, [-mouseX, -mouseY]);
	      matrix.scale(m, m, [e.scale, e.scale]);
	      matrix.translate(m, m, [mouseX, mouseY]);
	      rect.applyTransform(m);
	      this.api.dispatchAction({
	        type: 'treemapRender',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _initEvents: function (containerGroup) {
	    containerGroup.on('click', function (e) {
	      if (this._state !== 'ready') {
	        return;
	      }
	
	      var nodeClick = this.seriesModel.get('nodeClick', true);
	
	      if (!nodeClick) {
	        return;
	      }
	
	      var targetInfo = this.findTarget(e.offsetX, e.offsetY);
	
	      if (!targetInfo) {
	        return;
	      }
	
	      var node = targetInfo.node;
	
	      if (node.getLayout().isLeafRoot) {
	        this._rootToNode(targetInfo);
	      } else {
	        if (nodeClick === 'zoomToNode') {
	          this._zoomToNode(targetInfo);
	        } else if (nodeClick === 'link') {
	          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
	          var link = itemModel.get('link', true);
	          var linkTarget = itemModel.get('target', true) || 'blank';
	          link && windowOpen(link, linkTarget);
	        }
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderBreadcrumb: function (seriesModel, api, targetInfo) {
	    if (!targetInfo) {
	      targetInfo = seriesModel.get('leafDepth', true) != null ? {
	        node: seriesModel.getViewRoot() // FIXME
	        // better way?
	        // Find breadcrumb tail on center of containerGroup.
	
	      } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
	
	      if (!targetInfo) {
	        targetInfo = {
	          node: seriesModel.getData().tree.root
	        };
	      }
	    }
	
	    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, bind(onSelect, this));
	
	    function onSelect(node) {
	      if (this._state !== 'animating') {
	        helper.aboveViewRoot(seriesModel.getViewRoot(), node) ? this._rootToNode({
	          node: node
	        }) : this._zoomToNode({
	          node: node
	        });
	      }
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearController();
	
	    this._containerGroup && this._containerGroup.removeAll();
	    this._storage = createStorage();
	    this._state = 'ready';
	    this._breadcrumb && this._breadcrumb.remove();
	  },
	  dispose: function () {
	    this._clearController();
	  },
	
	  /**
	   * @private
	   */
	  _zoomToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapZoomToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapRootToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @public
	   * @param {number} x Global coord x.
	   * @param {number} y Global coord y.
	   * @return {Object} info If not found, return undefined;
	   * @return {number} info.node Target node.
	   * @return {number} info.offsetX x refer to target node.
	   * @return {number} info.offsetY y refer to target node.
	   */
	  findTarget: function (x, y) {
	    var targetInfo;
	    var viewRoot = this.seriesModel.getViewRoot();
	    viewRoot.eachNode({
	      attr: 'viewChildren',
	      order: 'preorder'
	    }, function (node) {
	      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.
	
	
	      if (bgEl) {
	        var point = bgEl.transformCoordToLocal(x, y);
	        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.
	
	        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
	          targetInfo = {
	            node: node,
	            offsetX: point[0],
	            offsetY: point[1]
	          };
	        } else {
	          return false; // Suppress visit subtree.
	        }
	      }
	    }, this);
	    return targetInfo;
	  }
	});
	/**
	 * @inner
	 */
	
	
	function createStorage() {
	  return {
	    nodeGroup: [],
	    background: [],
	    content: []
	  };
	}
	/**
	 * @inner
	 * @return Return undefined means do not travel further.
	 */
	
	
	function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
	  // Whether under viewRoot.
	  if (!thisNode) {
	    // Deleting nodes will be performed finally. This method just find
	    // element from old storage, or create new element, set them to new
	    // storage, and set styles.
	    return;
	  } // -------------------------------------------------------------------
	  // Start of closure variables available in "Procedures in renderNode".
	
	
	  var thisLayout = thisNode.getLayout();
	  var data = seriesModel.getData(); // Only for enabling highlight/downplay. Clear firstly.
	  // Because some node will not be rendered.
	
	  data.setItemGraphicEl(thisNode.dataIndex, null);
	
	  if (!thisLayout || !thisLayout.isInView) {
	    return;
	  }
	
	  var thisWidth = thisLayout.width;
	  var thisHeight = thisLayout.height;
	  var borderWidth = thisLayout.borderWidth;
	  var thisInvisible = thisLayout.invisible;
	  var thisRawIndex = thisNode.getRawIndex();
	  var oldRawIndex = oldNode && oldNode.getRawIndex();
	  var thisViewChildren = thisNode.viewChildren;
	  var upperHeight = thisLayout.upperHeight;
	  var isParent = thisViewChildren && thisViewChildren.length;
	  var itemStyleNormalModel = thisNode.getModel('itemStyle');
	  var itemStyleEmphasisModel = thisNode.getModel('emphasis.itemStyle'); // End of closure ariables available in "Procedures in renderNode".
	  // -----------------------------------------------------------------
	  // Node group
	
	  var group = giveGraphic('nodeGroup', Group);
	
	  if (!group) {
	    return;
	  }
	
	  parentGroup.add(group); // x,y are not set when el is above view root.
	
	  group.attr('position', [thisLayout.x || 0, thisLayout.y || 0]);
	  group.__tmNodeWidth = thisWidth;
	  group.__tmNodeHeight = thisHeight;
	
	  if (thisLayout.isAboveViewRoot) {
	    return group;
	  }
	
	  var nodeModel = thisNode.getModel(); // Background
	
	  var bg = giveGraphic('background', Rect, depth, Z_BG);
	  bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight); // No children, render content.
	
	  if (isParent) {
	    // Because of the implementation about "traverse" in graphic hover style, we
	    // can not set hover listener on the "group" of non-leaf node. Otherwise the
	    // hover event from the descendents will be listenered.
	    if (graphic.isHighDownDispatcher(group)) {
	      graphic.setAsHighDownDispatcher(group, false);
	    }
	
	    if (bg) {
	      graphic.setAsHighDownDispatcher(bg, true); // Only for enabling highlight/downplay.
	
	      data.setItemGraphicEl(thisNode.dataIndex, bg);
	    }
	  } else {
	    var content = giveGraphic('content', Rect, depth, Z_CONTENT);
	    content && renderContent(group, content);
	
	    if (bg && graphic.isHighDownDispatcher(bg)) {
	      graphic.setAsHighDownDispatcher(bg, false);
	    }
	
	    graphic.setAsHighDownDispatcher(group, true); // Only for enabling highlight/downplay.
	
	    data.setItemGraphicEl(thisNode.dataIndex, group);
	  }
	
	  return group; // ----------------------------
	  // | Procedures in renderNode |
	  // ----------------------------
	
	  function renderBackground(group, bg, useUpperLabel) {
	    // For tooltip.
	    bg.dataIndex = thisNode.dataIndex;
	    bg.seriesIndex = seriesModel.seriesIndex;
	    bg.setShape({
	      x: 0,
	      y: 0,
	      width: thisWidth,
	      height: thisHeight
	    });
	
	    if (thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      processInvisible(bg);
	    } else {
	      bg.invisible = false;
	      var visualBorderColor = thisNode.getVisual('borderColor', true);
	      var emphasisBorderColor = itemStyleEmphasisModel.get('borderColor');
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualBorderColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      emphasisStyle.fill = emphasisBorderColor;
	
	      if (useUpperLabel) {
	        var upperLabelWidth = thisWidth - 2 * borderWidth;
	        prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
	          x: borderWidth,
	          y: 0,
	          width: upperLabelWidth,
	          height: upperHeight
	        });
	      } // For old bg.
	      else {
	          normalStyle.text = emphasisStyle.text = null;
	        }
	
	      bg.setStyle(normalStyle);
	      graphic.setElementHoverStyle(bg, emphasisStyle);
	    }
	
	    group.add(bg);
	  }
	
	  function renderContent(group, content) {
	    // For tooltip.
	    content.dataIndex = thisNode.dataIndex;
	    content.seriesIndex = seriesModel.seriesIndex;
	    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
	    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
	    content.culling = true;
	    content.setShape({
	      x: borderWidth,
	      y: borderWidth,
	      width: contentWidth,
	      height: contentHeight
	    });
	
	    if (thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      processInvisible(content);
	    } else {
	      content.invisible = false;
	      var visualColor = thisNode.getVisual('color', true);
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
	      content.setStyle(normalStyle);
	      graphic.setElementHoverStyle(content, emphasisStyle);
	    }
	
	    group.add(content);
	  }
	
	  function processInvisible(element) {
	    // Delay invisible setting utill animation finished,
	    // avoid element vanish suddenly before animation.
	    !element.invisible && willInvisibleEls.push(element);
	  }
	
	  function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
	    var defaultText = nodeModel.get('name');
	    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
	    var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_EMPHASIS : PATH_LABEL_EMPHASIS);
	    var isShow = normalLabelModel.getShallow('show');
	    graphic.setLabelStyle(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
	      defaultText: isShow ? defaultText : null,
	      autoColor: visualColor,
	      isRectText: true,
	      labelFetcher: seriesModel,
	      labelDataIndex: thisNode.dataIndex,
	      labelProp: upperLabelRect ? 'upperLabel' : 'label'
	    });
	    addDrillDownIcon(normalStyle, upperLabelRect, thisLayout);
	    addDrillDownIcon(emphasisStyle, upperLabelRect, thisLayout);
	    upperLabelRect && (normalStyle.textRect = zrUtil.clone(upperLabelRect));
	    normalStyle.truncate = isShow && normalLabelModel.get('ellipsis') ? {
	      outerWidth: width,
	      outerHeight: height,
	      minChar: 2
	    } : null;
	  }
	
	  function addDrillDownIcon(style, upperLabelRect, thisLayout) {
	    var text = style.text;
	
	    if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
	      var iconChar = seriesModel.get('drillDownIcon', true);
	      style.text = iconChar ? iconChar + ' ' + text : text;
	    }
	  }
	
	  function giveGraphic(storageName, Ctor, depth, z) {
	    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
	    var lasts = lastsForAnimation[storageName];
	
	    if (element) {
	      // Remove from oldStorage
	      oldStorage[storageName][oldRawIndex] = null;
	      prepareAnimationWhenHasOld(lasts, element, storageName);
	    } // If invisible and no old element, do not create new element (for optimizing).
	    else if (!thisInvisible) {
	        element = new Ctor({
	          z: calculateZ(depth, z)
	        });
	        element.__tmDepth = depth;
	        element.__tmStorageName = storageName;
	        prepareAnimationWhenNoOld(lasts, element, storageName);
	      } // Set to thisStorage
	
	
	    return thisStorage[storageName][thisRawIndex] = element;
	  }
	
	  function prepareAnimationWhenHasOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    lastCfg.old = storageName === 'nodeGroup' ? element.position.slice() : zrUtil.extend({}, element.shape);
	  } // If a element is new, we need to find the animation start point carefully,
	  // otherwise it will looks strange when 'zoomToNode'.
	
	
	  function prepareAnimationWhenNoOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    var parentNode = thisNode.parentNode;
	
	    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
	      var parentOldX = 0;
	      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
	      // For convenience, get old bounding rect from background.
	
	      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
	
	      if (!reRoot && parentOldBg && parentOldBg.old) {
	        parentOldX = parentOldBg.old.width;
	        parentOldY = parentOldBg.old.height;
	      } // When no parent old shape found, its parent is new too,
	      // so we can just use {x:0, y:0}.
	
	
	      lastCfg.old = storageName === 'nodeGroup' ? [0, parentOldY] : {
	        x: parentOldX,
	        y: parentOldY,
	        width: 0,
	        height: 0
	      };
	    } // Fade in, user can be aware that these nodes are new.
	
	
	    lastCfg.fadein = storageName !== 'nodeGroup';
	  }
	} // We can not set all backgroud with the same z, Because the behaviour of
	// drill down and roll up differ background creation sequence from tree
	// hierarchy sequence, which cause that lowser background element overlap
	// upper ones. So we calculate z based on depth.
	// Moreover, we try to shrink down z interval to [0, 1] to avoid that
	// treemap with large z overlaps other components.
	
	
	function calculateZ(depth, zInLevel) {
	  var zb = depth * Z_BASE + zInLevel;
	  return (zb - 1) / zb;
	}
	
	module.exports = _default;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var helper = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Treemap action
	 */
	var noop = function () {};
	
	var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
	
	for (var i = 0; i < actionTypes.length; i++) {
	  echarts.registerAction({
	    type: actionTypes[i],
	    update: 'updateView'
	  }, noop);
	}
	
	echarts.registerAction({
	  type: 'treemapRootToNode',
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'treemap',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var BoundingRect = __webpack_require__(51);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	var MAX_SAFE_INTEGER = _number.MAX_SAFE_INTEGER;
	
	var layout = __webpack_require__(47);
	
	var helper = __webpack_require__(140);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The treemap layout implementation was originally copied from
	* "d3.js" with some modifications made for this project.
	* (See more details in the comment of the method "squarify" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var retrieveValue = zrUtil.retrieve;
	var each = zrUtil.each;
	var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
	var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
	var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
	var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
	/**
	 * @public
	 */
	
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    // Layout result in each node:
	    // {x, y, width, height, area, borderWidth}
	    var ecWidth = api.getWidth();
	    var ecHeight = api.getHeight();
	    var seriesOption = seriesModel.option;
	    var layoutInfo = layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	    var size = seriesOption.size || []; // Compatible with ec2.
	
	    var containerWidth = parsePercent(retrieveValue(layoutInfo.width, size[0]), ecWidth);
	    var containerHeight = parsePercent(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.
	
	    var payloadType = payload && payload.type;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
	    var viewRoot = seriesModel.getViewRoot();
	    var viewAbovePath = helper.getPathToRoot(viewRoot);
	
	    if (payloadType !== 'treemapMove') {
	      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
	      var sort = seriesOption.sort;
	
	      if (sort && sort !== 'asc' && sort !== 'desc') {
	        sort = 'desc';
	      }
	
	      var options = {
	        squareRatio: seriesOption.squareRatio,
	        sort: sort,
	        leafDepth: seriesOption.leafDepth
	      }; // layout should be cleared because using updateView but not update.
	
	      viewRoot.hostTree.clearLayouts(); // TODO
	      // optimize: if out of view clip, do not layout.
	      // But take care that if do not render node out of view clip,
	      // how to calculate start po
	
	      var viewRootLayout = {
	        x: 0,
	        y: 0,
	        width: rootSize[0],
	        height: rootSize[1],
	        area: rootSize[0] * rootSize[1]
	      };
	      viewRoot.setLayout(viewRootLayout);
	      squarify(viewRoot, options, false, 0); // Supplement layout.
	
	      var viewRootLayout = viewRoot.getLayout();
	      each(viewAbovePath, function (node, index) {
	        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
	        node.setLayout(zrUtil.extend({
	          dataExtent: [childValue, childValue],
	          borderWidth: 0,
	          upperHeight: 0
	        }, viewRootLayout));
	      });
	    }
	
	    var treeRoot = seriesModel.getData().tree.root;
	    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
	    seriesModel.setLayoutInfo(layoutInfo); // FIXME
	    // 现在没有clip功能，暂时取ec高宽。
	
	    prunning(treeRoot, // Transform to base element coordinate system.
	    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
	  }
	};
	/**
	 * Layout treemap with squarify algorithm.
	 * The original presentation of this algorithm
	 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
	 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
	 * The implementation of this algorithm was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @protected
	 * @param {module:echarts/data/Tree~TreeNode} node
	 * @param {Object} options
	 * @param {string} options.sort 'asc' or 'desc'
	 * @param {number} options.squareRatio
	 * @param {boolean} hideChildren
	 * @param {number} depth
	 */
	
	function squarify(node, options, hideChildren, depth) {
	  var width;
	  var height;
	
	  if (node.isRemoved()) {
	    return;
	  }
	
	  var thisLayout = node.getLayout();
	  width = thisLayout.width;
	  height = thisLayout.height; // Considering border and gap
	
	  var nodeModel = node.getModel();
	  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
	  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
	  var upperLabelHeight = getUpperLabelHeight(nodeModel);
	  var upperHeight = Math.max(borderWidth, upperLabelHeight);
	  var layoutOffset = borderWidth - halfGapWidth;
	  var layoutOffsetUpper = upperHeight - halfGapWidth;
	  var nodeModel = node.getModel();
	  node.setLayout({
	    borderWidth: borderWidth,
	    upperHeight: upperHeight,
	    upperLabelHeight: upperLabelHeight
	  }, true);
	  width = mathMax(width - 2 * layoutOffset, 0);
	  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
	  var totalArea = width * height;
	  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
	
	  if (!viewChildren.length) {
	    return;
	  }
	
	  var rect = {
	    x: layoutOffset,
	    y: layoutOffsetUpper,
	    width: width,
	    height: height
	  };
	  var rowFixedLength = mathMin(width, height);
	  var best = Infinity; // the best row score so far
	
	  var row = [];
	  row.area = 0;
	
	  for (var i = 0, len = viewChildren.length; i < len;) {
	    var child = viewChildren[i];
	    row.push(child);
	    row.area += child.getLayout().area;
	    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation
	
	    if (score <= best) {
	      i++;
	      best = score;
	    } // abort, and try a different orientation
	    else {
	        row.area -= row.pop().getLayout().area;
	        position(row, rowFixedLength, rect, halfGapWidth, false);
	        rowFixedLength = mathMin(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	  }
	
	  if (row.length) {
	    position(row, rowFixedLength, rect, halfGapWidth, true);
	  }
	
	  if (!hideChildren) {
	    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
	
	    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
	      hideChildren = true;
	    }
	  }
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    squarify(viewChildren[i], options, hideChildren, depth + 1);
	  }
	}
	/**
	 * Set area to each child, and calculate data extent for visual coding.
	 */
	
	
	function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
	  var viewChildren = node.children || [];
	  var orderBy = options.sort;
	  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
	  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.
	
	  if (hideChildren && !overLeafDepth) {
	    return node.viewChildren = [];
	  } // Sort children, order by desc.
	
	
	  viewChildren = zrUtil.filter(viewChildren, function (child) {
	    return !child.isRemoved();
	  });
	  sort(viewChildren, orderBy);
	  var info = statistic(nodeModel, viewChildren, orderBy);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  }
	
	  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  } // Set area to each child.
	
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.
	
	    viewChildren[i].setLayout({
	      area: area
	    });
	  }
	
	  if (overLeafDepth) {
	    viewChildren.length && node.setLayout({
	      isLeafRoot: true
	    }, true);
	    viewChildren.length = 0;
	  }
	
	  node.viewChildren = viewChildren;
	  node.setLayout({
	    dataExtent: info.dataExtent
	  }, true);
	  return viewChildren;
	}
	/**
	 * Consider 'visibleMin'. Modify viewChildren and get new sum.
	 */
	
	
	function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
	  // visibleMin is not supported yet when no option.sort.
	  if (!orderBy) {
	    return sum;
	  }
	
	  var visibleMin = nodeModel.get('visibleMin');
	  var len = orderedChildren.length;
	  var deletePoint = len; // Always travel from little value to big value.
	
	  for (var i = len - 1; i >= 0; i--) {
	    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
	
	    if (value / sum * totalArea < visibleMin) {
	      deletePoint = i;
	      sum -= value;
	    }
	  }
	
	  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
	  return sum;
	}
	/**
	 * Sort
	 */
	
	
	function sort(viewChildren, orderBy) {
	  if (orderBy) {
	    viewChildren.sort(function (a, b) {
	      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
	      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
	    });
	  }
	
	  return viewChildren;
	}
	/**
	 * Statistic
	 */
	
	
	function statistic(nodeModel, children, orderBy) {
	  // Calculate sum.
	  var sum = 0;
	
	  for (var i = 0, len = children.length; i < len; i++) {
	    sum += children[i].getValue();
	  } // Statistic data extent for latter visual coding.
	  // Notice: data extent should be calculate based on raw children
	  // but not filtered view children, otherwise visual mapping will not
	  // be stable when zoom (where children is filtered by visibleMin).
	
	
	  var dimension = nodeModel.get('visualDimension');
	  var dataExtent; // The same as area dimension.
	
	  if (!children || !children.length) {
	    dataExtent = [NaN, NaN];
	  } else if (dimension === 'value' && orderBy) {
	    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
	    orderBy === 'asc' && dataExtent.reverse();
	  } // Other dimension.
	  else {
	      var dataExtent = [Infinity, -Infinity];
	      each(children, function (child) {
	        var value = child.getValue(dimension);
	        value < dataExtent[0] && (dataExtent[0] = value);
	        value > dataExtent[1] && (dataExtent[1] = value);
	      });
	    }
	
	  return {
	    sum: sum,
	    dataExtent: dataExtent
	  };
	}
	/**
	 * Computes the score for the specified row,
	 * as the worst aspect ratio.
	 */
	
	
	function worst(row, rowFixedLength, ratio) {
	  var areaMax = 0;
	  var areaMin = Infinity;
	
	  for (var i = 0, area, len = row.length; i < len; i++) {
	    area = row[i].getLayout().area;
	
	    if (area) {
	      area < areaMin && (areaMin = area);
	      area > areaMax && (areaMax = area);
	    }
	  }
	
	  var squareArea = row.area * row.area;
	  var f = rowFixedLength * rowFixedLength * ratio;
	  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
	}
	/**
	 * Positions the specified row of nodes. Modifies `rect`.
	 */
	
	
	function position(row, rowFixedLength, rect, halfGapWidth, flush) {
	  // When rowFixedLength === rect.width,
	  // it is horizontal subdivision,
	  // rowFixedLength is the width of the subdivision,
	  // rowOtherLength is the height of the subdivision,
	  // and nodes will be positioned from left to right.
	  // wh[idx0WhenH] means: when horizontal,
	  //      wh[idx0WhenH] => wh[0] => 'width'.
	  //      xy[idx1WhenH] => xy[1] => 'y'.
	  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
	  var idx1WhenH = 1 - idx0WhenH;
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  var last = rect[xy[idx0WhenH]];
	  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
	
	  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
	    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
	  }
	
	  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
	    var node = row[i];
	    var nodeLayout = {};
	    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
	    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.
	
	    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
	    var modWH = i === rowLen - 1 || remain < step ? remain : step;
	    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
	    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
	    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
	    last += modWH;
	    node.setLayout(nodeLayout, true);
	  }
	
	  rect[xy[idx1WhenH]] += rowOtherLength;
	  rect[wh[idx1WhenH]] -= rowOtherLength;
	} // Return [containerWidth, containerHeight] as default.
	
	
	function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
	  // If targetInfo.node exists, we zoom to the node,
	  // so estimate whold width and heigth by target node.
	  var currNode = (targetInfo || {}).node;
	  var defaultSize = [containerWidth, containerHeight];
	
	  if (!currNode || currNode === viewRoot) {
	    return defaultSize;
	  }
	
	  var parent;
	  var viewArea = containerWidth * containerHeight;
	  var area = viewArea * seriesModel.option.zoomToNodeRatio;
	
	  while (parent = currNode.parentNode) {
	    // jshint ignore:line
	    var sum = 0;
	    var siblings = parent.children;
	
	    for (var i = 0, len = siblings.length; i < len; i++) {
	      sum += siblings[i].getValue();
	    }
	
	    var currNodeValue = currNode.getValue();
	
	    if (currNodeValue === 0) {
	      return defaultSize;
	    }
	
	    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.
	
	    var parentModel = parent.getModel();
	    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
	    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel, borderWidth));
	    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
	    area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
	    currNode = parent;
	  }
	
	  area < viewArea && (area = viewArea);
	  var scale = Math.pow(area / viewArea, 0.5);
	  return [containerWidth * scale, containerHeight * scale];
	} // Root postion base on coord of containerGroup
	
	
	function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
	  if (rootRect) {
	    return {
	      x: rootRect.x,
	      y: rootRect.y
	    };
	  }
	
	  var defaultPosition = {
	    x: 0,
	    y: 0
	  };
	
	  if (!targetInfo) {
	    return defaultPosition;
	  } // If targetInfo is fetched by 'retrieveTargetInfo',
	  // old tree and new tree are the same tree,
	  // so the node still exists and we can visit it.
	
	
	  var targetNode = targetInfo.node;
	  var layout = targetNode.getLayout();
	
	  if (!layout) {
	    return defaultPosition;
	  } // Transform coord from local to container.
	
	
	  var targetCenter = [layout.width / 2, layout.height / 2];
	  var node = targetNode;
	
	  while (node) {
	    var nodeLayout = node.getLayout();
	    targetCenter[0] += nodeLayout.x;
	    targetCenter[1] += nodeLayout.y;
	    node = node.parentNode;
	  }
	
	  return {
	    x: layoutInfo.width / 2 - targetCenter[0],
	    y: layoutInfo.height / 2 - targetCenter[1]
	  };
	} // Mark nodes visible for prunning when visual coding and rendering.
	// Prunning depends on layout and root position, so we have to do it after layout.
	
	
	function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
	  var nodeLayout = node.getLayout();
	  var nodeInViewAbovePath = viewAbovePath[depth];
	  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
	
	  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
	    return;
	  }
	
	  node.setLayout({
	    // isInView means: viewRoot sub tree + viewAbovePath
	    isInView: true,
	    // invisible only means: outside view clip so that the node can not
	    // see but still layout for animation preparation but not render.
	    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
	    isAboveViewRoot: isAboveViewRoot
	  }, true); // Transform to child coordinate.
	
	  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
	  each(node.viewChildren || [], function (child) {
	    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
	  });
	}
	
	function getUpperLabelHeight(model) {
	  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
	}
	
	module.exports = _default;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(144);
	
	var zrColor = __webpack_require__(105);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var isArray = zrUtil.isArray;
	var ITEM_STYLE_NORMAL = 'itemStyle';
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    var tree = seriesModel.getData().tree;
	    var root = tree.root;
	
	    if (root.isRemoved()) {
	      return;
	    }
	
	    travelTree(root, // Visual should calculate from tree root but not view root.
	    {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
	  }
	};
	
	function travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
	  var nodeModel = node.getModel();
	  var nodeLayout = node.getLayout(); // Optimize
	
	  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
	    return;
	  }
	
	  var nodeItemStyleModel = node.getModel(ITEM_STYLE_NORMAL);
	  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel); // calculate border color
	
	  var borderColor = nodeItemStyleModel.get('borderColor');
	  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
	  var thisNodeColor;
	
	  if (borderColorSaturation != null) {
	    // For performance, do not always execute 'calculateColor'.
	    thisNodeColor = calculateColor(visuals, node);
	    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
	  }
	
	  node.setVisual('borderColor', borderColor);
	  var viewChildren = node.viewChildren;
	
	  if (!viewChildren || !viewChildren.length) {
	    thisNodeColor = calculateColor(visuals, node); // Apply visual to this node.
	
	    node.setVisual('color', thisNodeColor);
	  } else {
	    var mapping = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.
	
	    zrUtil.each(viewChildren, function (child, index) {
	      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
	      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
	        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
	        travelTree(child, childVisual, viewRootAncestors, seriesModel);
	      }
	    });
	  }
	}
	
	function buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
	  var visuals = zrUtil.extend({}, designatedVisual);
	  var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
	  zrUtil.each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
	    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
	    designatedVisualItemStyle[visualName] = designatedVisual[visualName];
	    var val = nodeItemStyleModel.get(visualName);
	    designatedVisualItemStyle[visualName] = null;
	    val != null && (visuals[visualName] = val);
	  });
	  return visuals;
	}
	
	function calculateColor(visuals) {
	  var color = getValueVisualDefine(visuals, 'color');
	
	  if (color) {
	    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
	    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');
	
	    if (colorSaturation) {
	      color = zrColor.modifyHSL(color, null, null, colorSaturation);
	    }
	
	    if (colorAlpha) {
	      color = zrColor.modifyAlpha(color, colorAlpha);
	    }
	
	    return color;
	  }
	}
	
	function calculateBorderColor(borderColorSaturation, thisNodeColor) {
	  return thisNodeColor != null ? zrColor.modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
	}
	
	function getValueVisualDefine(visuals, name) {
	  var value = visuals[name];
	
	  if (value != null && value !== 'none') {
	    return value;
	  }
	}
	
	function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
	  if (!viewChildren || !viewChildren.length) {
	    return;
	  }
	
	  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));
	
	  if (!rangeVisual) {
	    return;
	  }
	
	  var visualMin = nodeModel.get('visualMin');
	  var visualMax = nodeModel.get('visualMax');
	  var dataExtent = nodeLayout.dataExtent.slice();
	  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
	  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
	  var colorMappingBy = nodeModel.get('colorMappingBy');
	  var opt = {
	    type: rangeVisual.name,
	    dataExtent: dataExtent,
	    visual: rangeVisual.range
	  };
	
	  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
	    opt.mappingMethod = 'category';
	    opt.loop = true; // categories is ordinal, so do not set opt.categories.
	  } else {
	    opt.mappingMethod = 'linear';
	  }
	
	  var mapping = new VisualMapping(opt);
	  mapping.__drColorMappingBy = colorMappingBy;
	  return mapping;
	} // Notice: If we dont have the attribute 'colorRange', but only use
	// attribute 'color' to represent both concepts of 'colorRange' and 'color',
	// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
	// this problem will be encountered:
	// If a level-1 node dont have children, and its siblings has children,
	// and colorRange is set on level-1, then the node can not be colored.
	// So we separate 'colorRange' and 'color' to different attributes.
	
	
	function getRangeVisual(nodeModel, name) {
	  // 'colorRange', 'colorARange', 'colorSRange'.
	  // If not exsits on this node, fetch from levels and series.
	  var range = nodeModel.get(name);
	  return isArray(range) && range.length ? {
	    name: name,
	    range: range
	  } : null;
	}
	
	function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
	  var childVisuals = zrUtil.extend({}, visuals);
	
	  if (mapping) {
	    var mappingType = mapping.type;
	    var colorMappingBy = mappingType === 'color' && mapping.__drColorMappingBy;
	    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
	    childVisuals[mappingType] = mapping.mapValueToVisual(value);
	  }
	
	  return childVisuals;
	}
	
	module.exports = _default;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(430);
	
	__webpack_require__(1734);

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(842);
	
	__webpack_require__(1735);

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerModel = echarts.extendComponentModel({
	  type: 'axisPointer',
	  coordSysAxesInfo: null,
	  defaultOption: {
	    // 'auto' means that show when triggered by tooltip or handle.
	    show: 'auto',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: null,
	    // set default in AxisPonterView.js
	    zlevel: 0,
	    z: 50,
	    type: 'line',
	    // 'line' 'shadow' 'cross' 'none'.
	    // axispointer triggered by tootip determine snap automatically,
	    // see `modelHelper`.
	    snap: false,
	    triggerTooltip: true,
	    value: null,
	    status: null,
	    // Init value depends on whether handle is used.
	    // [group0, group1, ...]
	    // Each group can be: {
	    //      mapper: function () {},
	    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
	    //      xAxisId: ...,
	    //      yAxisName: ...,
	    //      angleAxisIndex: ...
	    // }
	    // mapper: can be ignored.
	    //      input: {axisInfo, value}
	    //      output: {axisInfo, value}
	    link: [],
	    // Do not set 'auto' here, otherwise global animation: false
	    // will not effect at this axispointer.
	    animation: null,
	    animationDurationUpdate: 200,
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      type: 'solid'
	    },
	    shadowStyle: {
	      color: 'rgba(150,150,150,0.3)'
	    },
	    label: {
	      show: true,
	      formatter: null,
	      // string | Function
	      precision: 'auto',
	      // Or a number like 0, 1, 2 ...
	      margin: 3,
	      color: '#fff',
	      padding: [5, 7, 5, 7],
	      backgroundColor: 'auto',
	      // default: axis line color
	      borderColor: null,
	      borderWidth: 0,
	      shadowBlur: 3,
	      shadowColor: '#aaa' // Considering applicability, common style should
	      // better not have shadowOffset.
	      // shadowOffsetX: 0,
	      // shadowOffsetY: 2
	
	    },
	    handle: {
	      show: false,
	
	      /* eslint-disable */
	      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
	      // jshint ignore:line
	
	      /* eslint-enable */
	      size: 45,
	      // handle margin is from symbol center to axis, which is stable when circular move.
	      margin: 50,
	      // color: '#1b8bbd'
	      // color: '#2f4554'
	      color: '#333',
	      shadowBlur: 3,
	      shadowColor: '#aaa',
	      shadowOffsetX: 0,
	      shadowOffsetY: 2,
	      // For mobile performance
	      throttle: 40
	    }
	  }
	});
	var _default = AxisPointerModel;
	module.exports = _default;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var globalListener = __webpack_require__(815);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerView = echarts.extendComponentView({
	  type: 'axisPointer',
	  render: function (globalAxisPointerModel, ecModel, api) {
	    var globalTooltipModel = ecModel.getComponent('tooltip');
	    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
	    // AxisPointerView to be independent to Tooltip.
	
	    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
	        dispatchAction({
	          type: 'updateAxisPointer',
	          currTrigger: currTrigger,
	          x: e && e.offsetX,
	          y: e && e.offsetY
	        });
	      }
	    });
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    globalListener.unregister(api.getZr(), 'axisPointer');
	    AxisPointerView.superApply(this._model, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    globalListener.unregister('axisPointer', api);
	    AxisPointerView.superApply(this._model, 'dispose', arguments);
	  }
	});
	var _default = AxisPointerView;
	module.exports = _default;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var formatUtil = __webpack_require__(48);
	
	var BaseAxisPointer = __webpack_require__(415);
	
	var graphic = __webpack_require__(17);
	
	var viewHelper = __webpack_require__(268);
	
	var matrix = __webpack_require__(75);
	
	var AxisBuilder = __webpack_require__(127);
	
	var AxisView = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	
	    if (axis.dim === 'angle') {
	      this.animationThreshold = Math.PI / 18;
	    }
	
	    var polar = axis.polar;
	    var otherAxis = polar.getOtherAxis(axis);
	    var otherExtent = otherAxis.getExtent();
	    var coordValue;
	    coordValue = axis['dataTo' + formatUtil.capitalFirst(axis.dim)](value);
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var labelMargin = axisPointerModel.get('label.margin');
	    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
	    viewHelper.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
	  } // Do not support handle, utill any user requires it.
	
	});
	
	function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
	  var axis = axisModel.axis;
	  var coord = axis.dataToCoord(value);
	  var axisAngle = polar.getAngleAxis().getExtent()[0];
	  axisAngle = axisAngle / 180 * Math.PI;
	  var radiusExtent = polar.getRadiusAxis().getExtent();
	  var position;
	  var align;
	  var verticalAlign;
	
	  if (axis.dim === 'radius') {
	    var transform = matrix.create();
	    matrix.rotate(transform, transform, axisAngle);
	    matrix.translate(transform, transform, [polar.cx, polar.cy]);
	    position = graphic.applyTransform([coord, -labelMargin], transform);
	    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
	    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
	    align = labelLayout.textAlign;
	    verticalAlign = labelLayout.textVerticalAlign;
	  } else {
	    // angle axis
	    var r = radiusExtent[1];
	    position = polar.coordToPoint([r + labelMargin, coord]);
	    var cx = polar.cx;
	    var cy = polar.cy;
	    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
	    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
	  }
	
	  return {
	    position: position,
	    align: align,
	    verticalAlign: verticalAlign
	  };
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, polar, coordValue, otherExtent, elStyle) {
	    return axis.dim === 'angle' ? {
	      type: 'Line',
	      shape: viewHelper.makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
	    } : {
	      type: 'Circle',
	      shape: {
	        cx: polar.cx,
	        cy: polar.cy,
	        r: coordValue
	      }
	    };
	  },
	  shadow: function (axis, polar, coordValue, otherExtent, elStyle) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var radian = Math.PI / 180;
	    return axis.dim === 'angle' ? {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
	      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
	    } : {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
	    };
	  }
	};
	AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
	var _default = PolarAxisPointer;
	module.exports = _default;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseAxisPointer = __webpack_require__(415);
	
	var viewHelper = __webpack_require__(268);
	
	var singleAxisHelper = __webpack_require__(847);
	
	var AxisView = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var XY = ['x', 'y'];
	var WH = ['width', 'height'];
	var SingleAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
	    var pixelValue = coordSys.dataToPoint(value)[0];
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = singleAxisHelper.layout(axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = singleAxisHelper.layout(axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var dimIndex = getPointDimIndex(axis);
	    var axisExtent = getGlobalExtent(coordSys, dimIndex);
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: {
	        verticalAlign: 'middle'
	      }
	    };
	  }
	});
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
	    return {
	      type: 'Line',
	      subPixelOptimize: true,
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent) {
	    var bandWidth = axis.getBandWidth();
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
	    };
	  }
	};
	
	function getPointDimIndex(axis) {
	  return axis.isHorizontal() ? 0 : 1;
	}
	
	function getGlobalExtent(coordSys, dimIndex) {
	  var rect = coordSys.getRect();
	  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
	}
	
	AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
	var _default = SingleAxisPointer;
	module.exports = _default;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	var modelHelper = __webpack_require__(267);
	
	var findPointFromSeries = __webpack_require__(814);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry;
	var inner = makeInner();
	/**
	 * Basic logic: check all axis, if they do not demand show/highlight,
	 * then hide/downplay them.
	 *
	 * @param {Object} coordSysAxesInfo
	 * @param {Object} payload
	 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
	 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
	 * @param {Object} [payload.dataIndex] finder, restrict target axes.
	 * @param {Object} [payload.axesInfo] finder, restrict target axes.
	 *        [{
	 *          axisDim: 'x'|'y'|'angle'|...,
	 *          axisIndex: ...,
	 *          value: ...
	 *        }, ...]
	 * @param {Function} [payload.dispatchAction]
	 * @param {Object} [payload.tooltipOption]
	 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
	 *        which can be specified in dispatchAction
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Object} content of event obj for echarts.connect.
	 */
	
	function _default(payload, ecModel, api) {
	  var currTrigger = payload.currTrigger;
	  var point = [payload.x, payload.y];
	  var finder = payload;
	  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
	  // See #6121. But we are not able to reproduce it yet.
	
	  if (!coordSysAxesInfo) {
	    return;
	  }
	
	  if (illegalPoint(point)) {
	    // Used in the default behavior of `connection`: use the sample seriesIndex
	    // and dataIndex. And also used in the tooltipView trigger.
	    point = findPointFromSeries({
	      seriesIndex: finder.seriesIndex,
	      // Do not use dataIndexInside from other ec instance.
	      // FIXME: auto detect it?
	      dataIndex: finder.dataIndex
	    }, ecModel).point;
	  }
	
	  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
	  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
	  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
	  // and dataIndex.
	
	  var inputAxesInfo = finder.axesInfo;
	  var axesInfo = coordSysAxesInfo.axesInfo;
	  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
	  var outputFinder = {};
	  var showValueMap = {};
	  var dataByCoordSys = {
	    list: [],
	    map: {}
	  };
	  var updaters = {
	    showPointer: curry(showPointer, showValueMap),
	    showTooltip: curry(showTooltip, dataByCoordSys)
	  }; // Process for triggered axes.
	
	  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
	    // If a point given, it must be contained by the coordinate system.
	    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
	    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
	      var axis = axisInfo.axis;
	      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
	
	      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
	        var val = inputAxisInfo && inputAxisInfo.value;
	
	        if (val == null && !isIllegalPoint) {
	          val = axis.pointToData(point);
	        }
	
	        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
	      }
	    });
	  }); // Process for linked axes.
	
	  var linkTriggers = {};
	  each(axesInfo, function (tarAxisInfo, tarKey) {
	    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
	
	    if (linkGroup && !showValueMap[tarKey]) {
	      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
	        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
	
	        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
	          var val = srcValItem.value;
	          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
	          linkTriggers[tarAxisInfo.key] = val;
	        }
	      });
	    }
	  });
	  each(linkTriggers, function (val, tarKey) {
	    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
	  });
	  updateModelActually(showValueMap, axesInfo, outputFinder);
	  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
	  dispatchHighDownActually(axesInfo, dispatchAction, api);
	  return outputFinder;
	}
	
	function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
	  var axis = axisInfo.axis;
	
	  if (axis.scale.isBlank() || !axis.containData(newValue)) {
	    return;
	  }
	
	  if (!axisInfo.involveSeries) {
	    updaters.showPointer(axisInfo, newValue);
	    return;
	  } // Heavy calculation. So put it after axis.containData checking.
	
	
	  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
	  var payloadBatch = payloadInfo.payloadBatch;
	  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
	  // By default use the first involved series data as a sample to connect.
	
	  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
	    zrUtil.extend(outputFinder, payloadBatch[0]);
	  } // If no linkSource input, this process is for collecting link
	  // target, where snap should not be accepted.
	
	
	  if (!dontSnap && axisInfo.snap) {
	    if (axis.containData(snapToValue) && snapToValue != null) {
	      newValue = snapToValue;
	    }
	  }
	
	  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
	  // incorrect "axis value ~ series value" mapping displayed in tooltip.
	
	  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
	}
	
	function buildPayloadsBySeries(value, axisInfo) {
	  var axis = axisInfo.axis;
	  var dim = axis.dim;
	  var snapToValue = value;
	  var payloadBatch = [];
	  var minDist = Number.MAX_VALUE;
	  var minDiff = -1;
	  each(axisInfo.seriesModels, function (series, idx) {
	    var dataDim = series.getData().mapDimension(dim, true);
	    var seriesNestestValue;
	    var dataIndices;
	
	    if (series.getAxisTooltipData) {
	      var result = series.getAxisTooltipData(dataDim, value, axis);
	      dataIndices = result.dataIndices;
	      seriesNestestValue = result.nestestValue;
	    } else {
	      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
	      // when data length is not same.
	      // false,
	      axis.type === 'category' ? 0.5 : null);
	
	      if (!dataIndices.length) {
	        return;
	      }
	
	      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
	    }
	
	    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
	      return;
	    }
	
	    var diff = value - seriesNestestValue;
	    var dist = Math.abs(diff); // Consider category case
	
	    if (dist <= minDist) {
	      if (dist < minDist || diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        snapToValue = seriesNestestValue;
	        payloadBatch.length = 0;
	      }
	
	      each(dataIndices, function (dataIndex) {
	        payloadBatch.push({
	          seriesIndex: series.seriesIndex,
	          dataIndexInside: dataIndex,
	          dataIndex: series.getData().getRawIndex(dataIndex)
	        });
	      });
	    }
	  });
	  return {
	    payloadBatch: payloadBatch,
	    snapToValue: snapToValue
	  };
	}
	
	function showPointer(showValueMap, axisInfo, value, payloadBatch) {
	  showValueMap[axisInfo.key] = {
	    value: value,
	    payloadBatch: payloadBatch
	  };
	}
	
	function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
	  var payloadBatch = payloadInfo.payloadBatch;
	  var axis = axisInfo.axis;
	  var axisModel = axis.model;
	  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
	  // whose length will be used to judge whether dispatch action.
	
	  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
	    return;
	  }
	
	  var coordSysModel = axisInfo.coordSys.model;
	  var coordSysKey = modelHelper.makeKey(coordSysModel);
	  var coordSysItem = dataByCoordSys.map[coordSysKey];
	
	  if (!coordSysItem) {
	    coordSysItem = dataByCoordSys.map[coordSysKey] = {
	      coordSysId: coordSysModel.id,
	      coordSysIndex: coordSysModel.componentIndex,
	      coordSysType: coordSysModel.type,
	      coordSysMainType: coordSysModel.mainType,
	      dataByAxis: []
	    };
	    dataByCoordSys.list.push(coordSysItem);
	  }
	
	  coordSysItem.dataByAxis.push({
	    axisDim: axis.dim,
	    axisIndex: axisModel.componentIndex,
	    axisType: axisModel.type,
	    axisId: axisModel.id,
	    value: value,
	    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
	    // depends that all models have been updated. So it should not be performed
	    // here. Considering axisPointerModel used here is volatile, which is hard
	    // to be retrieve in TooltipView, we prepare parameters here.
	    valueLabelOpt: {
	      precision: axisPointerModel.get('label.precision'),
	      formatter: axisPointerModel.get('label.formatter')
	    },
	    seriesDataIndices: payloadBatch.slice()
	  });
	}
	
	function updateModelActually(showValueMap, axesInfo, outputFinder) {
	  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    var valItem = showValueMap[key];
	
	    if (valItem) {
	      !axisInfo.useHandle && (option.status = 'show');
	      option.value = valItem.value; // For label formatter param and highlight.
	
	      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
	    } // When always show (e.g., handle used), remain
	    // original value and status.
	    else {
	        // If hide, value still need to be set, consider
	        // click legend to toggle axis blank.
	        !axisInfo.useHandle && (option.status = 'hide');
	      } // If status is 'hide', should be no info in payload.
	
	
	    option.status === 'show' && outputAxesInfo.push({
	      axisDim: axisInfo.axis.dim,
	      axisIndex: axisInfo.axis.model.componentIndex,
	      value: option.value
	    });
	  });
	}
	
	function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
	  // Basic logic: If no showTip required, hideTip will be dispatched.
	  if (illegalPoint(point) || !dataByCoordSys.list.length) {
	    dispatchAction({
	      type: 'hideTip'
	    });
	    return;
	  } // In most case only one axis (or event one series is used). It is
	  // convinient to fetch payload.seriesIndex and payload.dataIndex
	  // dirtectly. So put the first seriesIndex and dataIndex of the first
	  // axis on the payload.
	
	
	  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
	  dispatchAction({
	    type: 'showTip',
	    escapeConnect: true,
	    x: point[0],
	    y: point[1],
	    tooltipOption: payload.tooltipOption,
	    position: payload.position,
	    dataIndexInside: sampleItem.dataIndexInside,
	    dataIndex: sampleItem.dataIndex,
	    seriesIndex: sampleItem.seriesIndex,
	    dataByCoordSys: dataByCoordSys.list
	  });
	}
	
	function dispatchHighDownActually(axesInfo, dispatchAction, api) {
	  // FIXME
	  // highlight status modification shoule be a stage of main process?
	  // (Consider confilct (e.g., legend and axisPointer) and setOption)
	  var zr = api.getZr();
	  var highDownKey = 'axisPointerLastHighlights';
	  var lastHighlights = inner(zr)[highDownKey] || {};
	  var newHighlights = inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
	  // Build hash map and remove duplicate incidentally.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
	      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
	      newHighlights[key] = batchItem;
	    });
	  }); // Diff.
	
	  var toHighlight = [];
	  var toDownplay = [];
	  zrUtil.each(lastHighlights, function (batchItem, key) {
	    !newHighlights[key] && toDownplay.push(batchItem);
	  });
	  zrUtil.each(newHighlights, function (batchItem, key) {
	    !lastHighlights[key] && toHighlight.push(batchItem);
	  });
	  toDownplay.length && api.dispatchAction({
	    type: 'downplay',
	    escapeConnect: true,
	    batch: toDownplay
	  });
	  toHighlight.length && api.dispatchAction({
	    type: 'highlight',
	    escapeConnect: true,
	    batch: toHighlight
	  });
	}
	
	function findInputAxisInfo(inputAxesInfo, axisInfo) {
	  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
	    var inputAxisInfo = inputAxesInfo[i];
	
	    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
	      return inputAxisInfo;
	    }
	  }
	}
	
	function makeMapperParam(axisInfo) {
	  var axisModel = axisInfo.axis.model;
	  var item = {};
	  var dim = item.axisDim = axisInfo.axis.dim;
	  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
	  item.axisName = item[dim + 'AxisName'] = axisModel.name;
	  item.axisId = item[dim + 'AxisId'] = axisModel.id;
	  return item;
	}
	
	function illegalPoint(point) {
	  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
	}
	
	module.exports = _default;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var Model = __webpack_require__(57);
	
	var AxisView = __webpack_require__(141);
	
	var AxisBuilder = __webpack_require__(127);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisLabel', 'axisTick', 'minorTick', 'splitLine', 'minorSplitLine', 'splitArea'];
	
	function getAxisLineShape(polar, rExtent, angle) {
	  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
	  var start = polar.coordToPoint([rExtent[0], angle]);
	  var end = polar.coordToPoint([rExtent[1], angle]);
	  return {
	    x1: start[0],
	    y1: start[1],
	    x2: end[0],
	    y2: end[1]
	  };
	}
	
	function getRadiusIdx(polar) {
	  var radiusAxis = polar.getRadiusAxis();
	  return radiusAxis.inverse ? 0 : 1;
	} // Remove the last tick which will overlap the first tick
	
	
	function fixAngleOverlap(list) {
	  var firstItem = list[0];
	  var lastItem = list[list.length - 1];
	
	  if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
	    list.pop();
	  }
	}
	
	var _default = AxisView.extend({
	  type: 'angleAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (angleAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!angleAxisModel.get('show')) {
	      return;
	    }
	
	    var angleAxis = angleAxisModel.axis;
	    var polar = angleAxis.polar;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var ticksAngles = angleAxis.getTicksCoords();
	    var minorTickAngles = angleAxis.getMinorTicksCoords();
	    var labels = zrUtil.map(angleAxis.getViewLabels(), function (labelItem) {
	      var labelItem = zrUtil.clone(labelItem);
	      labelItem.coord = angleAxis.dataToCoord(labelItem.tickValue);
	      return labelItem;
	    });
	    fixAngleOverlap(labels);
	    fixAngleOverlap(ticksAngles);
	    zrUtil.each(elementList, function (name) {
	      if (angleAxisModel.get(name + '.show') && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
	        this['_' + name](angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _axisLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var lineStyleModel = angleAxisModel.getModel('axisLine.lineStyle'); // extent id of the axis radius (r0 and r)
	
	    var rId = getRadiusIdx(polar);
	    var r0Id = rId ? 0 : 1;
	    var shape;
	
	    if (radiusExtent[r0Id] === 0) {
	      shape = new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: radiusExtent[rId]
	        },
	        style: lineStyleModel.getLineStyle(),
	        z2: 1,
	        silent: true
	      });
	    } else {
	      shape = new graphic.Ring({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: radiusExtent[rId],
	          r0: radiusExtent[r0Id]
	        },
	        style: lineStyleModel.getLineStyle(),
	        z2: 1,
	        silent: true
	      });
	    }
	
	    shape.style.fill = null;
	    this.group.add(shape);
	  },
	
	  /**
	   * @private
	   */
	  _axisTick: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = zrUtil.map(ticksAngles, function (tickAngleItem) {
	      return new graphic.Line({
	        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
	      });
	    });
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      })
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _minorTick: function (angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
	    if (!minorTickAngles.length) {
	      return;
	    }
	
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var minorTickModel = angleAxisModel.getModel('minorTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = [];
	
	    for (var i = 0; i < minorTickAngles.length; i++) {
	      for (var k = 0; k < minorTickAngles[i].length; k++) {
	        lines.push(new graphic.Line({
	          shape: getAxisLineShape(polar, [radius, radius + tickLen], minorTickAngles[i][k].coord)
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(minorTickModel.getModel('lineStyle').getLineStyle(), zrUtil.defaults(tickModel.getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      }))
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _axisLabel: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
	    var rawCategoryData = angleAxisModel.getCategories(true);
	    var commonLabelModel = angleAxisModel.getModel('axisLabel');
	    var labelMargin = commonLabelModel.get('margin');
	    var triggerEvent = angleAxisModel.get('triggerEvent'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping
	
	    zrUtil.each(labels, function (labelItem, idx) {
	      var labelModel = commonLabelModel;
	      var tickValue = labelItem.tickValue;
	      var r = radiusExtent[getRadiusIdx(polar)];
	      var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
	      var cx = polar.cx;
	      var cy = polar.cy;
	      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
	      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
	
	      if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	        labelModel = new Model(rawCategoryData[tickValue].textStyle, commonLabelModel, commonLabelModel.ecModel);
	      }
	
	      var textEl = new graphic.Text({
	        silent: AxisBuilder.isLabelSilent(angleAxisModel)
	      });
	      this.group.add(textEl);
	      graphic.setTextStyle(textEl.style, labelModel, {
	        x: p[0],
	        y: p[1],
	        textFill: labelModel.getTextColor() || angleAxisModel.get('axisLine.lineStyle.color'),
	        text: labelItem.formattedLabel,
	        textAlign: labelTextAlign,
	        textVerticalAlign: labelTextVerticalAlign
	      }); // Pack data for mouse event
	
	      if (triggerEvent) {
	        textEl.eventData = AxisBuilder.makeAxisEventDataBase(angleAxisModel);
	        textEl.eventData.targetType = 'axisLabel';
	        textEl.eventData.value = labelItem.rawLabel;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var splitLineModel = angleAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length]
	        }, lineStyleModel.getLineStyle()),
	        silent: true,
	        z: angleAxisModel.get('z')
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _minorSplitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    if (!minorTickAngles.length) {
	      return;
	    }
	
	    var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var lines = [];
	
	    for (var i = 0; i < minorTickAngles.length; i++) {
	      for (var k = 0; k < minorTickAngles[i].length; k++) {
	        lines.push(new graphic.Line({
	          shape: getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: lineStyleModel.getLineStyle(),
	      silent: true,
	      z: angleAxisModel.get('z')
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    if (!ticksAngles.length) {
	      return;
	    }
	
	    var splitAreaModel = angleAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var RADIAN = Math.PI / 180;
	    var prevAngle = -ticksAngles[0].coord * RADIAN;
	    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
	    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
	    var clockwise = angleAxisModel.get('clockwise');
	
	    for (var i = 1; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: r0,
	          r: r1,
	          startAngle: prevAngle,
	          endAngle: -ticksAngles[i].coord * RADIAN,
	          clockwise: clockwise
	        },
	        silent: true
	      }));
	      prevAngle = -ticksAngles[i].coord * RADIAN;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var AxisBuilder = __webpack_require__(127);
	
	var AxisView = __webpack_require__(141);
	
	var cartesianAxisHelper = __webpack_require__(843);
	
	var _axisSplitHelper = __webpack_require__(816);
	
	var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
	var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];
	var CartesianAxisView = AxisView.extend({
	  type: 'cartesianAxis',
	  axisPointerClass: 'CartesianAxisPointer',
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var gridModel = axisModel.getCoordSysModel();
	    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel, gridModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    rectCoordAxisHandleRemove(this);
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      var tickValue = ticksCoords[i].tickValue;
	
	      this._axisGroup.add(new graphic.Line({
	        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
	        subPixelOptimize: true,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: zrUtil.defaults({
	          stroke: lineColors[colorIndex]
	        }, lineStyle),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _minorSplitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	    var minorSplitLineModel = axisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var minorTicksCoords = axis.getMinorTicksCoords();
	
	    if (!minorTicksCoords.length) {
	      return;
	    }
	
	    var p1 = [];
	    var p2 = [];
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < minorTicksCoords.length; i++) {
	      for (var k = 0; k < minorTicksCoords[i].length; k++) {
	        var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
	
	        if (isHorizontal) {
	          p1[0] = tickCoord;
	          p1[1] = gridRect.y;
	          p2[0] = tickCoord;
	          p2[1] = gridRect.y + gridRect.height;
	        } else {
	          p1[0] = gridRect.x;
	          p1[1] = tickCoord;
	          p2[0] = gridRect.x + gridRect.width;
	          p2[1] = tickCoord;
	        }
	
	        this._axisGroup.add(new graphic.Line({
	          anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
	          subPixelOptimize: true,
	          shape: {
	            x1: p1[0],
	            y1: p1[1],
	            x2: p2[0],
	            y2: p2[1]
	          },
	          style: lineStyle,
	          silent: true
	        }));
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitArea: function (axisModel, gridModel) {
	    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, gridModel);
	  }
	});
	CartesianAxisView.extend({
	  type: 'xAxis'
	});
	CartesianAxisView.extend({
	  type: 'yAxis'
	});

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var AxisBuilder = __webpack_require__(127);
	
	var BrushController = __webpack_require__(420);
	
	var brushHelper = __webpack_require__(824);
	
	var graphic = __webpack_require__(17);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
	var AxisView = echarts.extendComponentView({
	  type: 'parallelAxis',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    AxisView.superApply(this, 'init', arguments);
	    /**
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this));
	  },
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
	      return;
	    }
	
	    this.axisModel = axisModel;
	    this.api = api;
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var coordSysModel = getCoordSysModel(axisModel, ecModel);
	    var coordSys = coordSysModel.coordinateSystem;
	    var areaSelectStyle = axisModel.getAreaSelectStyle();
	    var areaWidth = areaSelectStyle.width;
	    var dim = axisModel.axis.dim;
	    var axisLayout = coordSys.getAxisLayout(dim);
	    var builderOpt = zrUtil.extend({
	      strokeContainThreshold: areaWidth
	    }, axisLayout);
	    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
	    zrUtil.each(elementList, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
	
	    var animationModel = payload && payload.animation === false ? null : axisModel;
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, animationModel);
	  },
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: function (axisModel, ecModel, api, payload) {
	  //     this._brushController && this._brushController
	  //         .updateCovers(getCoverInfoList(axisModel));
	  // },
	  _refreshBrushController: function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
	    // After filtering, axis may change, select area needs to be update.
	    var extent = axisModel.axis.getExtent();
	    var extentLen = extent[1] - extent[0];
	    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
	    // width/height might be negative, which will be
	    // normalized in BoundingRect.
	
	    var rect = graphic.BoundingRect.create({
	      x: extent[0],
	      y: -areaWidth / 2,
	      width: extentLen,
	      height: areaWidth
	    });
	    rect.x -= extra;
	    rect.width += 2 * extra;
	
	    this._brushController.mount({
	      enableGlobalPan: true,
	      rotation: builderOpt.rotation,
	      position: builderOpt.position
	    }).setPanels([{
	      panelId: 'pl',
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect, 0)
	    }]).enableBrush({
	      brushType: 'lineX',
	      brushStyle: areaSelectStyle,
	      removeOnClick: true
	    }).updateCovers(getCoverInfoList(axisModel));
	  },
	  _onBrush: function (coverInfoList, opt) {
	    // Do not cache these object, because the mey be changed.
	    var axisModel = this.axisModel;
	    var axis = axisModel.axis;
	    var intervals = zrUtil.map(coverInfoList, function (coverInfo) {
	      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
	    }); // If realtime is true, action is not dispatched on drag end, because
	    // the drag end emits the same params with the last drag move event,
	    // and may have some delay when using touch pad.
	
	    if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'axisAreaSelect',
	        parallelAxisId: axisModel.id,
	        intervals: intervals
	      });
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  }
	});
	
	function fromAxisAreaSelect(axisModel, ecModel, payload) {
	  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
	    mainType: 'parallelAxis',
	    query: payload
	  })[0] === axisModel;
	}
	
	function getCoverInfoList(axisModel) {
	  var axis = axisModel.axis;
	  return zrUtil.map(axisModel.activeIntervals, function (interval) {
	    return {
	      brushType: 'lineX',
	      panelId: 'pl',
	      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
	    };
	  });
	}
	
	function getCoordSysModel(axisModel, ecModel) {
	  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
	}
	
	var _default = AxisView;
	module.exports = _default;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var AxisBuilder = __webpack_require__(127);
	
	var AxisView = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitLine', 'splitArea', 'minorSplitLine'];
	
	var _default = AxisView.extend({
	  type: 'radiusAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (radiusAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!radiusAxisModel.get('show')) {
	      return;
	    }
	
	    var radiusAxis = radiusAxisModel.axis;
	    var polar = radiusAxis.polar;
	    var angleAxis = polar.getAngleAxis();
	    var ticksCoords = radiusAxis.getTicksCoords();
	    var minorTicksCoords = radiusAxis.getMinorTicksCoords();
	    var axisAngle = angleAxis.getExtent()[0];
	    var radiusExtent = radiusAxis.getExtent();
	    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
	    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    this.group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (radiusAxisModel.get(name + '.show') && !radiusAxis.scale.isBlank()) {
	        this['_' + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    var splitLineModel = radiusAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: ticksCoords[i].coord
	        }
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length],
	          fill: null
	        }, lineStyleModel.getLineStyle()),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _minorSplitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
	    if (!minorTicksCoords.length) {
	      return;
	    }
	
	    var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var lines = [];
	
	    for (var i = 0; i < minorTicksCoords.length; i++) {
	      for (var k = 0; k < minorTicksCoords[i].length; k++) {
	        lines.push(new graphic.Circle({
	          shape: {
	            cx: polar.cx,
	            cy: polar.cy,
	            r: minorTicksCoords[i][k].coord
	          }
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults({
	        fill: null
	      }, lineStyleModel.getLineStyle()),
	      silent: true
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    if (!ticksCoords.length) {
	      return;
	    }
	
	    var splitAreaModel = radiusAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var prevRadius = ticksCoords[0].coord;
	
	    for (var i = 1; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: prevRadius,
	          r: ticksCoords[i].coord,
	          startAngle: 0,
	          endAngle: Math.PI * 2
	        },
	        silent: true
	      }));
	      prevRadius = ticksCoords[i].coord;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	/**
	 * @inner
	 */
	
	
	function layoutAxis(polar, radiusAxisModel, axisAngle) {
	  return {
	    position: [polar.cx, polar.cy],
	    rotation: axisAngle / 180 * Math.PI,
	    labelDirection: -1,
	    tickDirection: -1,
	    nameDirection: 1,
	    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
	    // Over splitLine and splitArea
	    z2: 1
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var AxisBuilder = __webpack_require__(127);
	
	var graphic = __webpack_require__(17);
	
	var singleAxisHelper = __webpack_require__(847);
	
	var AxisView = __webpack_require__(141);
	
	var _axisSplitHelper = __webpack_require__(816);
	
	var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
	var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine'];
	var SingleAxisView = AxisView.extend({
	  type: 'singleAxis',
	  axisPointerClass: 'SingleAxisPointer',
	  render: function (axisModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    var layout = singleAxisHelper.layout(axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    group.add(this._axisGroup);
	    group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    SingleAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    rectCoordAxisHandleRemove(this);
	  },
	  _splitLine: function (axisModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineWidth = lineStyleModel.get('width');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var gridRect = axisModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var splitLines = [];
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	
	    for (var i = 0; i < ticksCoords.length; ++i) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        subPixelOptimize: true,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: {
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	
	    for (var i = 0; i < splitLines.length; ++i) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: {
	          stroke: lineColors[i % lineColors.length],
	          lineDash: lineStyleModel.getLineDash(lineWidth),
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	  },
	  _splitArea: function (axisModel) {
	    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, axisModel);
	  }
	});
	var _default = SingleAxisView;
	module.exports = _default;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} parallelAxisId
	 * @property {Array.<Array.<number>>} intervals
	 */
	var actionInfo = {
	  type: 'axisAreaSelect',
	  event: 'axisAreaSelected' // update: 'updateVisual'
	
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallelAxis',
	    query: payload
	  }, function (parallelAxisModel) {
	    parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
	  });
	});
	/**
	 * @payload
	 */
	
	echarts.registerAction('parallelAxisExpand', function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallel',
	    query: payload
	  }, function (parallelModel) {
	    parallelModel.setAxisExpand(payload);
	  });
	});

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var preprocessor = __webpack_require__(1744);
	
	__webpack_require__(817);
	
	__webpack_require__(1741);
	
	__webpack_require__(1742);
	
	__webpack_require__(1743);
	
	__webpack_require__(1795);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Brush component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var visualSolution = __webpack_require__(277);
	
	var Model = __webpack_require__(57);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_OUT_OF_BRUSH_COLOR = ['#ddd'];
	var BrushModel = echarts.extendComponentModel({
	  type: 'brush',
	  dependencies: ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // inBrush: null,
	    // outOfBrush: null,
	    toolbox: null,
	    // Default value see preprocessor.
	    brushLink: null,
	    // Series indices array, broadcast using dataIndex.
	    // or 'all', which means all series. 'none' or null means no series.
	    seriesIndex: 'all',
	    // seriesIndex array, specify series controlled by this brush component.
	    geoIndex: null,
	    //
	    xAxisIndex: null,
	    yAxisIndex: null,
	    brushType: 'rect',
	    // Default brushType, see BrushController.
	    brushMode: 'single',
	    // Default brushMode, 'single' or 'multiple'
	    transformable: true,
	    // Default transformable.
	    brushStyle: {
	      // Default brushStyle
	      borderWidth: 1,
	      color: 'rgba(120,140,180,0.3)',
	      borderColor: 'rgba(120,140,180,0.8)'
	    },
	    throttleType: 'fixRate',
	    // Throttle in brushSelected event. 'fixRate' or 'debounce'.
	    // If null, no throttle. Valid only in the first brush component
	    throttleDelay: 0,
	    // Unit: ms, 0 means every event will be triggered.
	    // FIXME
	    // 试验效果
	    removeOnClick: true,
	    z: 10000
	  },
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  areas: [],
	
	  /**
	   * Current activated brush type.
	   * If null, brush is inactived.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {string}
	   */
	  brushType: null,
	
	  /**
	   * Current brush opt.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {Object}
	   */
	  brushOption: {},
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  coordInfoList: [],
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
	    var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.
	
	    thisOption.outOfBrush = thisOption.outOfBrush || {
	      color: DEFAULT_OUT_OF_BRUSH_COLOR
	    };
	
	    if (!inBrush.hasOwnProperty('liftZ')) {
	      // Bigger than the highlight z lift, otherwise it will
	      // be effected by the highlight z when brush.
	      inBrush.liftZ = 5;
	    }
	  },
	
	  /**
	   * If ranges is null/undefined, range state remain.
	   *
	   * @param {Array.<Object>} [ranges]
	   */
	  setAreas: function (areas) {
	    // If ranges is null/undefined, range state remain.
	    // This helps user to dispatchAction({type: 'brush'}) with no areas
	    // set but just want to get the current brush select info from a `brush` event.
	    if (!areas) {
	      return;
	    }
	
	    this.areas = zrUtil.map(areas, function (area) {
	      return generateBrushOption(this.option, area);
	    }, this);
	  },
	
	  /**
	   * see module:echarts/component/helper/BrushController
	   * @param {Object} brushOption
	   */
	  setBrushOption: function (brushOption) {
	    this.brushOption = generateBrushOption(this.option, brushOption);
	    this.brushType = this.brushOption.brushType;
	  }
	});
	
	function generateBrushOption(option, brushOption) {
	  return zrUtil.merge({
	    brushType: option.brushType,
	    brushMode: option.brushMode,
	    transformable: option.transformable,
	    brushStyle: new Model(option.brushStyle).getItemStyle(),
	    removeOnClick: option.removeOnClick,
	    z: option.z
	  }, brushOption, true);
	}
	
	var _default = BrushModel;
	module.exports = _default;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var BrushController = __webpack_require__(420);
	
	var _visualEncoding = __webpack_require__(817);
	
	var layoutCovers = _visualEncoding.layoutCovers;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'brush',
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/brush/BrushModel}
	     */
	
	    this.model;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  },
	
	  /**
	   * @override
	   */
	  render: function (brushModel) {
	    this.model = brushModel;
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateTransform: function (brushModel, ecModel) {
	    // PENDING: `updateTransform` is a little tricky, whose layout need
	    // to be calculate mandatorily and other stages will not be performed.
	    // Take care the correctness of the logic. See #11754 .
	    layoutCovers(ecModel);
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateView: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateLayout: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: updateController,
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  },
	
	  /**
	   * @private
	   */
	  _onBrush: function (areas, opt) {
	    var modelId = this.model.id;
	    this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
	    // emits the same params with the last drag move event, and
	    // may have some delay when using touch pad, which makes
	    // animation not smooth (when using debounce).
	
	    (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
	      type: 'brush',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	    opt.isEnd && this.api.dispatchAction({
	      type: 'brushEnd',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	  }
	});
	
	function updateController(brushModel, ecModel, api, payload) {
	  // Do not update controller when drawing.
	  (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
	}
	
	module.exports = _default;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * payload: {
	 *      brushIndex: number, or,
	 *      brushId: string, or,
	 *      brushName: string,
	 *      globalRanges: Array
	 * }
	 */
	echarts.registerAction({
	  type: 'brush',
	  event: 'brush'
	  /*, update: 'updateView' */
	
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush',
	    query: payload
	  }, function (brushModel) {
	    brushModel.setAreas(payload.areas);
	  });
	});
	/**
	 * payload: {
	 *      brushComponents: [
	 *          {
	 *              brushId,
	 *              brushIndex,
	 *              brushName,
	 *              series: [
	 *                  {
	 *                      seriesId,
	 *                      seriesIndex,
	 *                      seriesName,
	 *                      rawIndices: [21, 34, ...]
	 *                  },
	 *                  ...
	 *              ]
	 *          },
	 *          ...
	 *      ]
	 * }
	 */
	
	echarts.registerAction({
	  type: 'brushSelect',
	  event: 'brushSelected',
	  update: 'none'
	}, function () {});
	echarts.registerAction({
	  type: 'brushEnd',
	  event: 'brushEnd',
	  update: 'none'
	}, function () {});

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
	
	function _default(option, isNew) {
	  var brushComponents = option && option.brush;
	
	  if (!zrUtil.isArray(brushComponents)) {
	    brushComponents = brushComponents ? [brushComponents] : [];
	  }
	
	  if (!brushComponents.length) {
	    return;
	  }
	
	  var brushComponentSpecifiedBtns = [];
	  zrUtil.each(brushComponents, function (brushOpt) {
	    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
	
	    if (tbs instanceof Array) {
	      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
	    }
	  });
	  var toolbox = option && option.toolbox;
	
	  if (zrUtil.isArray(toolbox)) {
	    toolbox = toolbox[0];
	  }
	
	  if (!toolbox) {
	    toolbox = {
	      feature: {}
	    };
	    option.toolbox = [toolbox];
	  }
	
	  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
	  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
	  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
	  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
	  removeDuplicate(brushTypes);
	
	  if (isNew && !brushTypes.length) {
	    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
	  }
	}
	
	function removeDuplicate(arr) {
	  var map = {};
	  zrUtil.each(arr, function (val) {
	    map[val] = 1;
	  });
	  arr.length = 0;
	  zrUtil.each(map, function (flag, val) {
	    arr.push(val);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var polygonContain = __webpack_require__(898);
	
	var BoundingRect = __webpack_require__(51);
	
	var _graphic = __webpack_require__(17);
	
	var linePolygonIntersect = _graphic.linePolygonIntersect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Key of the first level is brushType: `line`, `rect`, `polygon`.
	// Key of the second level is chart element type: `point`, `rect`.
	// See moudule:echarts/component/helper/BrushController
	// function param:
	//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
	//      {Object} selectors {point: selector, rect: selector, ...}
	//      {Object} area {range: [[], [], ..], boudingRect}
	// function return:
	//      {boolean} Whether in the given brush.
	var selector = {
	  lineX: getLineSelectors(0),
	  lineY: getLineSelectors(1),
	  rect: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.intersect(itemLayout);
	    }
	  },
	  polygon: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && polygonContain.contain(area.range, itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      var points = area.range;
	
	      if (!itemLayout || points.length <= 1) {
	        return false;
	      }
	
	      var x = itemLayout.x;
	      var y = itemLayout.y;
	      var width = itemLayout.width;
	      var height = itemLayout.height;
	      var p = points[0];
	
	      if (polygonContain.contain(points, x, y) || polygonContain.contain(points, x + width, y) || polygonContain.contain(points, x, y + height) || polygonContain.contain(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || linePolygonIntersect(x, y, x + width, y, points) || linePolygonIntersect(x, y, x, y + height, points) || linePolygonIntersect(x + width, y, x + width, y + height, points) || linePolygonIntersect(x, y + height, x + width, y + height, points)) {
	        return true;
	      }
	    }
	  }
	};
	
	function getLineSelectors(xyIndex) {
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  return {
	    point: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var p = itemLayout[xyIndex];
	        return inLineRange(p, range);
	      }
	    },
	    rect: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
	        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
	        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
	      }
	    }
	  };
	}
	
	function inLineRange(p, range) {
	  return range[0] <= p && p <= range[1];
	}
	
	var _default = selector;
	module.exports = _default;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1812);
	
	__webpack_require__(1813);
	
	__webpack_require__(1747);

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var formatUtil = __webpack_require__(48);
	
	var numberUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MONTH_TEXT = {
	  EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  CN: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var WEEK_TEXT = {
	  EN: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  CN: ['日', '一', '二', '三', '四', '五', '六']
	};
	
	var _default = echarts.extendComponentView({
	  type: 'calendar',
	
	  /**
	   * top/left line points
	   *  @private
	   */
	  _tlpoints: null,
	
	  /**
	   * bottom/right line points
	   *  @private
	   */
	  _blpoints: null,
	
	  /**
	   * first day of month
	   *  @private
	   */
	  _firstDayOfMonth: null,
	
	  /**
	   * first day point of month
	   *  @private
	   */
	  _firstDayPoints: null,
	  render: function (calendarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	    var coordSys = calendarModel.coordinateSystem; // range info
	
	    var rangeData = coordSys.getRangeInfo();
	    var orient = coordSys.getOrient();
	
	    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function
	
	
	    this._renderLines(calendarModel, rangeData, orient, group);
	
	    this._renderYearText(calendarModel, rangeData, orient, group);
	
	    this._renderMonthText(calendarModel, orient, group);
	
	    this._renderWeekText(calendarModel, rangeData, orient, group);
	  },
	  // render day rect
	  _renderDayRect: function (calendarModel, rangeData, group) {
	    var coordSys = calendarModel.coordinateSystem;
	    var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
	    var sw = coordSys.getCellWidth();
	    var sh = coordSys.getCellHeight();
	
	    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
	      var point = coordSys.dataToRect([i], false).tl; // every rect
	
	      var rect = new graphic.Rect({
	        shape: {
	          x: point[0],
	          y: point[1],
	          width: sw,
	          height: sh
	        },
	        cursor: 'default',
	        style: itemRectStyleModel
	      });
	      group.add(rect);
	    }
	  },
	  // render separate line
	  _renderLines: function (calendarModel, rangeData, orient, group) {
	    var self = this;
	    var coordSys = calendarModel.coordinateSystem;
	    var lineStyleModel = calendarModel.getModel('splitLine.lineStyle').getLineStyle();
	    var show = calendarModel.get('splitLine.show');
	    var lineWidth = lineStyleModel.lineWidth;
	    this._tlpoints = [];
	    this._blpoints = [];
	    this._firstDayOfMonth = [];
	    this._firstDayPoints = [];
	    var firstDay = rangeData.start;
	
	    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
	      addPoints(firstDay.formatedDate);
	
	      if (i === 0) {
	        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
	      }
	
	      var date = firstDay.date;
	      date.setMonth(date.getMonth() + 1);
	      firstDay = coordSys.getDateInfo(date);
	    }
	
	    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
	
	    function addPoints(date) {
	      self._firstDayOfMonth.push(coordSys.getDateInfo(date));
	
	      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);
	
	      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
	
	      self._tlpoints.push(points[0]);
	
	      self._blpoints.push(points[points.length - 1]);
	
	      show && self._drawSplitline(points, lineStyleModel, group);
	    } // render top/left line
	
	
	    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line
	
	    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
	  },
	  // get points at both ends
	  _getEdgesPoints: function (points, lineWidth, orient) {
	    var rs = [points[0].slice(), points[points.length - 1].slice()];
	    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth
	
	    rs[0][idx] = rs[0][idx] - lineWidth / 2;
	    rs[1][idx] = rs[1][idx] + lineWidth / 2;
	    return rs;
	  },
	  // render split line
	  _drawSplitline: function (points, lineStyleModel, group) {
	    var poyline = new graphic.Polyline({
	      z2: 20,
	      shape: {
	        points: points
	      },
	      style: lineStyleModel
	    });
	    group.add(poyline);
	  },
	  // render month line of one week points
	  _getLinePointsOfOneWeek: function (calendarModel, date, orient) {
	    var coordSys = calendarModel.coordinateSystem;
	    date = coordSys.getDateInfo(date);
	    var points = [];
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(date.time, i);
	      var point = coordSys.dataToRect([tmpD.time], false);
	      points[2 * tmpD.day] = point.tl;
	      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
	    }
	
	    return points;
	  },
	  _formatterLabel: function (formatter, params) {
	    if (typeof formatter === 'string' && formatter) {
	      return formatUtil.formatTplSimple(formatter, params);
	    }
	
	    if (typeof formatter === 'function') {
	      return formatter(params);
	    }
	
	    return params.nameMap;
	  },
	  _yearTextPositionControl: function (textEl, point, orient, position, margin) {
	    point = point.slice();
	    var aligns = ['center', 'bottom'];
	
	    if (position === 'bottom') {
	      point[1] += margin;
	      aligns = ['center', 'top'];
	    } else if (position === 'left') {
	      point[0] -= margin;
	    } else if (position === 'right') {
	      point[0] += margin;
	      aligns = ['center', 'top'];
	    } else {
	      // top
	      point[1] -= margin;
	    }
	
	    var rotate = 0;
	
	    if (position === 'left' || position === 'right') {
	      rotate = Math.PI / 2;
	    }
	
	    return {
	      rotation: rotate,
	      position: point,
	      style: {
	        textAlign: aligns[0],
	        textVerticalAlign: aligns[1]
	      }
	    };
	  },
	  // render year
	  _renderYearText: function (calendarModel, rangeData, orient, group) {
	    var yearLabel = calendarModel.getModel('yearLabel');
	
	    if (!yearLabel.get('show')) {
	      return;
	    }
	
	    var margin = yearLabel.get('margin');
	    var pos = yearLabel.get('position');
	
	    if (!pos) {
	      pos = orient !== 'horizontal' ? 'top' : 'left';
	    }
	
	    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
	    var xc = (points[0][0] + points[1][0]) / 2;
	    var yc = (points[0][1] + points[1][1]) / 2;
	    var idx = orient === 'horizontal' ? 0 : 1;
	    var posPoints = {
	      top: [xc, points[idx][1]],
	      bottom: [xc, points[1 - idx][1]],
	      left: [points[1 - idx][0], yc],
	      right: [points[idx][0], yc]
	    };
	    var name = rangeData.start.y;
	
	    if (+rangeData.end.y > +rangeData.start.y) {
	      name = name + '-' + rangeData.end.y;
	    }
	
	    var formatter = yearLabel.get('formatter');
	    var params = {
	      start: rangeData.start.y,
	      end: rangeData.end.y,
	      nameMap: name
	    };
	
	    var content = this._formatterLabel(formatter, params);
	
	    var yearText = new graphic.Text({
	      z2: 30
	    });
	    graphic.setTextStyle(yearText.style, yearLabel, {
	      text: content
	    }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
	    group.add(yearText);
	  },
	  _monthTextPositionControl: function (point, isCenter, orient, position, margin) {
	    var align = 'left';
	    var vAlign = 'top';
	    var x = point[0];
	    var y = point[1];
	
	    if (orient === 'horizontal') {
	      y = y + margin;
	
	      if (isCenter) {
	        align = 'center';
	      }
	
	      if (position === 'start') {
	        vAlign = 'bottom';
	      }
	    } else {
	      x = x + margin;
	
	      if (isCenter) {
	        vAlign = 'middle';
	      }
	
	      if (position === 'start') {
	        align = 'right';
	      }
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render month and year text
	  _renderMonthText: function (calendarModel, orient, group) {
	    var monthLabel = calendarModel.getModel('monthLabel');
	
	    if (!monthLabel.get('show')) {
	      return;
	    }
	
	    var nameMap = monthLabel.get('nameMap');
	    var margin = monthLabel.get('margin');
	    var pos = monthLabel.get('position');
	    var align = monthLabel.get('align');
	    var termPoints = [this._tlpoints, this._blpoints];
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = MONTH_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var idx = pos === 'start' ? 0 : 1;
	    var axis = orient === 'horizontal' ? 0 : 1;
	    margin = pos === 'start' ? -margin : margin;
	    var isCenter = align === 'center';
	
	    for (var i = 0; i < termPoints[idx].length - 1; i++) {
	      var tmp = termPoints[idx][i].slice();
	      var firstDay = this._firstDayOfMonth[i];
	
	      if (isCenter) {
	        var firstDayPoints = this._firstDayPoints[i];
	        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
	      }
	
	      var formatter = monthLabel.get('formatter');
	      var name = nameMap[+firstDay.m - 1];
	      var params = {
	        yyyy: firstDay.y,
	        yy: (firstDay.y + '').slice(2),
	        MM: firstDay.m,
	        M: +firstDay.m,
	        nameMap: name
	      };
	
	      var content = this._formatterLabel(formatter, params);
	
	      var monthText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(monthText.style, monthLabel, {
	        text: content
	      }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
	      group.add(monthText);
	    }
	  },
	  _weekTextPositionControl: function (point, orient, position, margin, cellSize) {
	    var align = 'center';
	    var vAlign = 'middle';
	    var x = point[0];
	    var y = point[1];
	    var isStart = position === 'start';
	
	    if (orient === 'horizontal') {
	      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
	      align = isStart ? 'right' : 'left';
	    } else {
	      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
	      vAlign = isStart ? 'bottom' : 'top';
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render weeks
	  _renderWeekText: function (calendarModel, rangeData, orient, group) {
	    var dayLabel = calendarModel.getModel('dayLabel');
	
	    if (!dayLabel.get('show')) {
	      return;
	    }
	
	    var coordSys = calendarModel.coordinateSystem;
	    var pos = dayLabel.get('position');
	    var nameMap = dayLabel.get('nameMap');
	    var margin = dayLabel.get('margin');
	    var firstDayOfWeek = coordSys.getFirstDayOfWeek();
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = WEEK_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
	    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
	    margin = numberUtil.parsePercent(margin, cellSize[orient === 'horizontal' ? 0 : 1]);
	
	    if (pos === 'start') {
	      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
	      margin = -margin;
	    }
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(start, i);
	      var point = coordSys.dataToRect([tmpD.time], false).center;
	      var day = i;
	      day = Math.abs((i + firstDayOfWeek) % 7);
	      var weekText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(weekText.style, dayLabel, {
	        text: nameMap[day]
	      }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
	      group.add(weekText);
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(819);
	
	__webpack_require__(818);

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(419);
	
	__webpack_require__(172);
	
	__webpack_require__(173);
	
	__webpack_require__(1753);
	
	__webpack_require__(1754);
	
	__webpack_require__(417);
	
	__webpack_require__(416);

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var numberUtil = __webpack_require__(24);
	
	var helper = __webpack_require__(418);
	
	var sliderMove = __webpack_require__(174);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	/**
	 * Operate single axis.
	 * One axis can only operated by one axis operator.
	 * Different dataZoomModels may be defined to operate the same axis.
	 * (i.e. 'inside' data zoom and 'slider' data zoom components)
	 * So dataZoomModels share one axisProxy in that case.
	 *
	 * @class
	 */
	
	var AxisProxy = function (dimName, axisIndex, dataZoomModel, ecModel) {
	  /**
	   * @private
	   * @type {string}
	   */
	  this._dimName = dimName;
	  /**
	   * @private
	   */
	
	  this._axisIndex = axisIndex;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._valueWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._percentWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._dataExtent;
	  /**
	   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
	   * @private
	   * @type {Object}
	   */
	
	  this._minMaxSpan;
	  /**
	   * @readOnly
	   * @type {module: echarts/model/Global}
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @private
	   * @type {module: echarts/component/dataZoom/DataZoomModel}
	   */
	
	  this._dataZoomModel = dataZoomModel; // /**
	  //  * @readOnly
	  //  * @private
	  //  */
	  // this.hasSeriesStacked;
	};
	
	AxisProxy.prototype = {
	  constructor: AxisProxy,
	
	  /**
	   * Whether the axisProxy is hosted by dataZoomModel.
	   *
	   * @public
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   * @return {boolean}
	   */
	  hostedBy: function (dataZoomModel) {
	    return this._dataZoomModel === dataZoomModel;
	  },
	
	  /**
	   * @return {Array.<number>} Value can only be NaN or finite value.
	   */
	  getDataValueWindow: function () {
	    return this._valueWindow.slice();
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getDataPercentWindow: function () {
	    return this._percentWindow.slice();
	  },
	
	  /**
	   * @public
	   * @param {number} axisIndex
	   * @return {Array} seriesModels
	   */
	  getTargetSeriesModels: function () {
	    var seriesModels = [];
	    var ecModel = this.ecModel;
	    ecModel.eachSeries(function (seriesModel) {
	      if (helper.isCoordSupported(seriesModel.get('coordinateSystem'))) {
	        var dimName = this._dimName;
	        var axisModel = ecModel.queryComponents({
	          mainType: dimName + 'Axis',
	          index: seriesModel.get(dimName + 'AxisIndex'),
	          id: seriesModel.get(dimName + 'AxisId')
	        })[0];
	
	        if (this._axisIndex === (axisModel && axisModel.componentIndex)) {
	          seriesModels.push(seriesModel);
	        }
	      }
	    }, this);
	    return seriesModels;
	  },
	  getAxisModel: function () {
	    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
	  },
	  getOtherAxisModel: function () {
	    var axisDim = this._dimName;
	    var ecModel = this.ecModel;
	    var axisModel = this.getAxisModel();
	    var isCartesian = axisDim === 'x' || axisDim === 'y';
	    var otherAxisDim;
	    var coordSysIndexName;
	
	    if (isCartesian) {
	      coordSysIndexName = 'gridIndex';
	      otherAxisDim = axisDim === 'x' ? 'y' : 'x';
	    } else {
	      coordSysIndexName = 'polarIndex';
	      otherAxisDim = axisDim === 'angle' ? 'radius' : 'angle';
	    }
	
	    var foundOtherAxisModel;
	    ecModel.eachComponent(otherAxisDim + 'Axis', function (otherAxisModel) {
	      if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) {
	        foundOtherAxisModel = otherAxisModel;
	      }
	    });
	    return foundOtherAxisModel;
	  },
	  getMinMaxSpan: function () {
	    return zrUtil.clone(this._minMaxSpan);
	  },
	
	  /**
	   * Only calculate by given range and this._dataExtent, do not change anything.
	   *
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  calculateDataWindow: function (opt) {
	    var dataExtent = this._dataExtent;
	    var axisModel = this.getAxisModel();
	    var scale = axisModel.axis.scale;
	
	    var rangePropMode = this._dataZoomModel.getRangePropMode();
	
	    var percentExtent = [0, 100];
	    var percentWindow = [];
	    var valueWindow = [];
	    var hasPropModeValue;
	    each(['start', 'end'], function (prop, idx) {
	      var boundPercent = opt[prop];
	      var boundValue = opt[prop + 'Value']; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
	      // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
	      // but not min/max of axis, which will be calculated by data window then).
	      // The former one is suitable for cases that a dataZoom component controls multiple
	      // axes with different unit or extent, and the latter one is suitable for accurate
	      // zoom by pixel (e.g., in dataZoomSelect).
	      // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
	      // only when setOption or dispatchAction, otherwise it remains its original value.
	      // (Why not only record `percentProp` and always map to `valueProp`? Because
	      // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
	      // `valueProp`. consider two axes constrolled by one dataZoom. They have different
	      // data extent. All of values that are overflow the `dataExtent` will be calculated
	      // to percent '100%').
	
	      if (rangePropMode[idx] === 'percent') {
	        boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.
	
	        boundValue = scale.parse(numberUtil.linearMap(boundPercent, percentExtent, dataExtent));
	      } else {
	        hasPropModeValue = true;
	        boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
	        // This calculation can not be inversed, because all of values that
	        // are overflow the `dataExtent` will be calculated to percent '100%'
	
	        boundPercent = numberUtil.linearMap(boundValue, dataExtent, percentExtent);
	      } // valueWindow[idx] = round(boundValue);
	      // percentWindow[idx] = round(boundPercent);
	
	
	      valueWindow[idx] = boundValue;
	      percentWindow[idx] = boundPercent;
	    });
	    asc(valueWindow);
	    asc(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
	    // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we dont restrict window
	    // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
	    // where API is able to initialize/modify the window size even though `zoomLock`
	    // specified.
	
	    var spans = this._minMaxSpan;
	    hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
	
	    function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
	      var suffix = toValue ? 'Span' : 'ValueSpan';
	      sliderMove(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);
	
	      for (var i = 0; i < 2; i++) {
	        toWindow[i] = numberUtil.linearMap(fromWindow[i], fromExtent, toExtent, true);
	        toValue && (toWindow[i] = scale.parse(toWindow[i]));
	      }
	    }
	
	    return {
	      valueWindow: valueWindow,
	      percentWindow: percentWindow
	    };
	  },
	
	  /**
	   * Notice: reset should not be called before series.restoreData() called,
	   * so it is recommanded to be called in "process stage" but not "model init
	   * stage".
	   *
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  reset: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.
	
	    this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // this.hasSeriesStacked = false;
	    // each(targetSeries, function (series) {
	    // var data = series.getData();
	    // var dataDim = data.mapDimension(this._dimName);
	    // var stackedDimension = data.getCalculationInfo('stackedDimension');
	    // if (stackedDimension && stackedDimension === dataDim) {
	    // this.hasSeriesStacked = true;
	    // }
	    // }, this);
	    // `calculateDataWindow` uses min/maxSpan.
	
	    setMinMaxSpan(this);
	    var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
	    this._valueWindow = dataWindow.valueWindow;
	    this._percentWindow = dataWindow.percentWindow; // Update axis setting then.
	
	    setAxisModel(this);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  restore: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    this._valueWindow = this._percentWindow = null;
	    setAxisModel(this, true);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  filterData: function (dataZoomModel, api) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var axisDim = this._dimName;
	    var seriesModels = this.getTargetSeriesModels();
	    var filterMode = dataZoomModel.get('filterMode');
	    var valueWindow = this._valueWindow;
	
	    if (filterMode === 'none') {
	      return;
	    } // FIXME
	    // Toolbox may has dataZoom injected. And if there are stacked bar chart
	    // with NaN data, NaN will be filtered and stack will be wrong.
	    // So we need to force the mode to be set empty.
	    // In fect, it is not a big deal that do not support filterMode-'filter'
	    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
	    // selection" some day, which might need "adapt to data extent on the
	    // otherAxis", which is disabled by filterMode-'empty'.
	    // But currently, stack has been fixed to based on value but not index,
	    // so this is not an issue any more.
	    // var otherAxisModel = this.getOtherAxisModel();
	    // if (dataZoomModel.get('$fromToolbox')
	    //     && otherAxisModel
	    //     && otherAxisModel.hasSeriesStacked
	    // ) {
	    //     filterMode = 'empty';
	    // }
	    // TODO
	    // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
	
	
	    each(seriesModels, function (seriesModel) {
	      var seriesData = seriesModel.getData();
	      var dataDims = seriesData.mapDimension(axisDim, true);
	
	      if (!dataDims.length) {
	        return;
	      }
	
	      if (filterMode === 'weakFilter') {
	        seriesData.filterSelf(function (dataIndex) {
	          var leftOut;
	          var rightOut;
	          var hasValue;
	
	          for (var i = 0; i < dataDims.length; i++) {
	            var value = seriesData.get(dataDims[i], dataIndex);
	            var thisHasValue = !isNaN(value);
	            var thisLeftOut = value < valueWindow[0];
	            var thisRightOut = value > valueWindow[1];
	
	            if (thisHasValue && !thisLeftOut && !thisRightOut) {
	              return true;
	            }
	
	            thisHasValue && (hasValue = true);
	            thisLeftOut && (leftOut = true);
	            thisRightOut && (rightOut = true);
	          } // If both left out and right out, do not filter.
	
	
	          return hasValue && leftOut && rightOut;
	        });
	      } else {
	        each(dataDims, function (dim) {
	          if (filterMode === 'empty') {
	            seriesModel.setData(seriesData = seriesData.map(dim, function (value) {
	              return !isInWindow(value) ? NaN : value;
	            }));
	          } else {
	            var range = {};
	            range[dim] = valueWindow; // console.time('select');
	
	            seriesData.selectRange(range); // console.timeEnd('select');
	          }
	        });
	      }
	
	      each(dataDims, function (dim) {
	        seriesData.setApproximateExtent(valueWindow, dim);
	      });
	    });
	
	    function isInWindow(value) {
	      return value >= valueWindow[0] && value <= valueWindow[1];
	    }
	  }
	};
	
	function calculateDataExtent(axisProxy, axisDim, seriesModels) {
	  var dataExtent = [Infinity, -Infinity];
	  each(seriesModels, function (seriesModel) {
	    var seriesData = seriesModel.getData();
	
	    if (seriesData) {
	      each(seriesData.mapDimension(axisDim, true), function (dim) {
	        var seriesExtent = seriesData.getApproximateExtent(dim);
	        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
	        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
	      });
	    }
	  });
	
	  if (dataExtent[1] < dataExtent[0]) {
	    dataExtent = [NaN, NaN];
	  } // It is important to get "consistent" extent when more then one axes is
	  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
	  // when zooming. But it is difficult to know what is "consistent", considering
	  // axes have different type or even different meanings (For example, two
	  // time axes are used to compare data of the same date in different years).
	  // So basically dataZoom just obtains extent by series.data (in category axis
	  // extent can be obtained from axis.data).
	  // Nevertheless, user can set min/max/scale on axes to make extent of axes
	  // consistent.
	
	
	  fixExtentByAxis(axisProxy, dataExtent);
	  return dataExtent;
	}
	
	function fixExtentByAxis(axisProxy, dataExtent) {
	  var axisModel = axisProxy.getAxisModel();
	  var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
	  // by axis.data by default.
	
	  var isCategoryAxis = axisModel.get('type') === 'category';
	  var axisDataLen = isCategoryAxis && axisModel.getCategories().length;
	
	  if (min != null && min !== 'dataMin' && typeof min !== 'function') {
	    dataExtent[0] = min;
	  } else if (isCategoryAxis) {
	    dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
	  }
	
	  var max = axisModel.getMax(true);
	
	  if (max != null && max !== 'dataMax' && typeof max !== 'function') {
	    dataExtent[1] = max;
	  } else if (isCategoryAxis) {
	    dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
	  }
	
	  if (!axisModel.get('scale', true)) {
	    dataExtent[0] > 0 && (dataExtent[0] = 0);
	    dataExtent[1] < 0 && (dataExtent[1] = 0);
	  } // For value axis, if min/max/scale are not set, we just use the extent obtained
	  // by series data, which may be a little different from the extent calculated by
	  // `axisHelper.getScaleExtent`. But the different just affects the experience a
	  // little when zooming. So it will not be fixed until some users require it strongly.
	
	
	  return dataExtent;
	}
	
	function setAxisModel(axisProxy, isRestore) {
	  var axisModel = axisProxy.getAxisModel();
	  var percentWindow = axisProxy._percentWindow;
	  var valueWindow = axisProxy._valueWindow;
	
	  if (!percentWindow) {
	    return;
	  } // [0, 500]: arbitrary value, guess axis extent.
	
	
	  var precision = numberUtil.getPixelPrecision(valueWindow, [0, 500]);
	  precision = Math.min(precision, 20); // isRestore or isFull
	
	  var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
	  axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
	}
	
	function setMinMaxSpan(axisProxy) {
	  var minMaxSpan = axisProxy._minMaxSpan = {};
	  var dataZoomModel = axisProxy._dataZoomModel;
	  var dataExtent = axisProxy._dataExtent;
	  each(['min', 'max'], function (minMax) {
	    var percentSpan = dataZoomModel.get(minMax + 'Span');
	    var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
	    valueSpan != null && (valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
	
	    if (valueSpan != null) {
	      percentSpan = numberUtil.linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
	    } else if (percentSpan != null) {
	      valueSpan = numberUtil.linearMap(percentSpan, [0, 100], dataExtent, true) - dataExtent[0];
	    }
	
	    minMaxSpan[minMax + 'Span'] = percentSpan;
	    minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
	  });
	}
	
	var _default = AxisProxy;
	module.exports = _default;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(172);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    disabled: false,
	    // Whether disable this inside zoom.
	    zoomLock: false,
	    // Whether disable zoom but only pan.
	    zoomOnMouseWheel: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseMove: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseWheel: false,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    preventDefaultMouseMove: true
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var DataZoomView = __webpack_require__(173);
	
	var sliderMove = __webpack_require__(174);
	
	var roams = __webpack_require__(1757);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var InsideZoomView = DataZoomView.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * 'throttle' is used in this.dispatchAction, so we save range
	     * to avoid missing some 'pan' info.
	     * @private
	     * @type {Array.<number>}
	     */
	    this._range;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    InsideZoomView.superApply(this, 'render', arguments); // Hence the `throttle` util ensures to preserve command order,
	    // here simply updating range all the time will not cause missing
	    // any of the the roam change.
	
	    this._range = dataZoomModel.getPercentRange(); // Reset controllers.
	
	    zrUtil.each(this.getTargetCoordInfo(), function (coordInfoList, coordSysName) {
	      var allCoordIds = zrUtil.map(coordInfoList, function (coordInfo) {
	        return roams.generateCoordId(coordInfo.model);
	      });
	      zrUtil.each(coordInfoList, function (coordInfo) {
	        var coordModel = coordInfo.model;
	        var getRange = {};
	        zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	          getRange[eventName] = bind(roamHandlers[eventName], this, coordInfo, coordSysName);
	        }, this);
	        roams.register(api, {
	          coordId: roams.generateCoordId(coordModel),
	          allCoordIds: allCoordIds,
	          containsPoint: function (e, x, y) {
	            return coordModel.coordinateSystem.containPoint([x, y]);
	          },
	          dataZoomId: dataZoomModel.id,
	          dataZoomModel: dataZoomModel,
	          getRange: getRange
	        });
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    roams.unregister(this.api, this.dataZoomModel.id);
	    InsideZoomView.superApply(this, 'dispose', arguments);
	    this._range = null;
	  }
	});
	var roamHandlers = {
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  zoom: function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var directionInfo = getDirectionInfo[coordSysName](null, [e.originX, e.originY], axisModel, controller, coordInfo);
	    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
	    var scale = Math.max(1 / e.scale, 0);
	    range[0] = (range[0] - percentPoint) * scale + percentPoint;
	    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.
	
	    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  },
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  pan: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
	  }),
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  scrollMove: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
	  })
	};
	
	function makeMover(getPercentDelta) {
	  return function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var percentDelta = getPercentDelta(range, axisModel, coordInfo, coordSysName, controller, e);
	    sliderMove(percentDelta, range, [0, 100], 'all');
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  };
	}
	
	var getDirectionInfo = {
	  grid: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.dim === 'x') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // axis.dim === 'y'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  polar: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var polar = coordInfo.model.coordinateSystem;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var angleExtent = polar.getAngleAxis().getExtent();
	    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
	    newPoint = polar.pointToCoord(newPoint);
	
	    if (axisModel.mainType === 'radiusAxis') {
	      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
	      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
	
	      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
	      ret.pixelStart = radiusExtent[0];
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'angleAxis'
	      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
	      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
	
	      ret.pixelLength = angleExtent[1] - angleExtent[0];
	      ret.pixelStart = angleExtent[0];
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    var ret = {};
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.orient === 'horizontal') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'vertical'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  }
	};
	var _default = InsideZoomView;
	module.exports = _default;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(172);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomView = __webpack_require__(173);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomView.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(172);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderZoomModel = DataZoomModel.extend({
	  type: 'dataZoom.slider',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    // ph => placeholder. Using placehoder here because
	    // deault value can only be drived in view stage.
	    right: 'ph',
	    // Default align to grid rect.
	    top: 'ph',
	    // Default align to grid rect.
	    width: 'ph',
	    // Default align to grid rect.
	    height: 'ph',
	    // Default align to grid rect.
	    left: null,
	    // Default align to grid rect.
	    bottom: null,
	    // Default align to grid rect.
	    backgroundColor: 'rgba(47,69,84,0)',
	    // Background of slider zoom component.
	    // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
	    // highest priority, remain for compatibility of
	    // previous version, but not recommended any more.
	    dataBackground: {
	      lineStyle: {
	        color: '#2f4554',
	        width: 0.5,
	        opacity: 0.3
	      },
	      areaStyle: {
	        color: 'rgba(47,69,84,0.3)',
	        opacity: 0.3
	      }
	    },
	    borderColor: '#ddd',
	    // border color of the box. For compatibility,
	    // if dataBackgroundColor is set, borderColor
	    // is ignored.
	    fillerColor: 'rgba(167,183,204,0.4)',
	    // Color of selected area.
	    // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
	    // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
	
	    /* eslint-disable */
	    handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',
	
	    /* eslint-enable */
	    // Percent of the slider height
	    handleSize: '100%',
	    handleStyle: {
	      color: '#a7b7cc'
	    },
	    labelPrecision: null,
	    labelFormatter: null,
	    showDetail: true,
	    showDataShadow: 'auto',
	    // Default auto decision.
	    realtime: true,
	    zoomLock: false,
	    // Whether disable zoom.
	    textStyle: {
	      color: '#333'
	    }
	  }
	});
	var _default = SliderZoomModel;
	module.exports = _default;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var eventTool = __webpack_require__(104);
	
	var graphic = __webpack_require__(17);
	
	var throttle = __webpack_require__(131);
	
	var DataZoomView = __webpack_require__(173);
	
	var numberUtil = __webpack_require__(24);
	
	var layout = __webpack_require__(47);
	
	var sliderMove = __webpack_require__(174);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Rect = graphic.Rect;
	var linearMap = numberUtil.linearMap;
	var asc = numberUtil.asc;
	var bind = zrUtil.bind;
	var each = zrUtil.each; // Constants
	
	var DEFAULT_LOCATION_EDGE_GAP = 7;
	var DEFAULT_FRAME_BORDER_WIDTH = 1;
	var DEFAULT_FILLER_SIZE = 30;
	var HORIZONTAL = 'horizontal';
	var VERTICAL = 'vertical';
	var LABEL_GAP = 5;
	var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
	var SliderZoomView = DataZoomView.extend({
	  type: 'dataZoom.slider',
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {Object}
	     */
	    this._displayables = {};
	    /**
	     * @private
	     * @type {string}
	     */
	
	    this._orient;
	    /**
	     * [0, 100]
	     * @private
	     */
	
	    this._range;
	    /**
	     * [coord of the first handle, coord of the second handle]
	     * @private
	     */
	
	    this._handleEnds;
	    /**
	     * [length, thick]
	     * @private
	     * @type {Array.<number>}
	     */
	
	    this._size;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleWidth;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleHeight;
	    /**
	     * @private
	     */
	
	    this._location;
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._dataShadowInfo;
	    this.api = api;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    SliderZoomView.superApply(this, 'render', arguments);
	    throttle.createOrUpdate(this, '_dispatchZoomAction', this.dataZoomModel.get('throttle'), 'fixRate');
	    this._orient = dataZoomModel.get('orient');
	
	    if (this.dataZoomModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    } // Notice: this._resetInterval() should not be executed when payload.type
	    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
	    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
	
	
	    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
	      this._buildView();
	    }
	
	    this._updateView();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    SliderZoomView.superApply(this, 'remove', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    SliderZoomView.superApply(this, 'dispose', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	  _buildView: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    this._resetLocation();
	
	    this._resetInterval();
	
	    var barGroup = this._displayables.barGroup = new graphic.Group();
	
	    this._renderBackground();
	
	    this._renderHandle();
	
	    this._renderDataShadow();
	
	    thisGroup.add(barGroup);
	
	    this._positionGroup();
	  },
	
	  /**
	   * @private
	   */
	  _resetLocation: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var api = this.api; // If some of x/y/width/height are not specified,
	    // auto-adapt according to target grid.
	
	    var coordRect = this._findCoordRect();
	
	    var ecSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }; // Default align by coordinate system rect.
	
	    var positionInfo = this._orient === HORIZONTAL ? {
	      // Why using 'right', because right should be used in vertical,
	      // and it is better to be consistent for dealing with position param merge.
	      right: ecSize.width - coordRect.x - coordRect.width,
	      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP,
	      width: coordRect.width,
	      height: DEFAULT_FILLER_SIZE
	    } : {
	      // vertical
	      right: DEFAULT_LOCATION_EDGE_GAP,
	      top: coordRect.y,
	      width: DEFAULT_FILLER_SIZE,
	      height: coordRect.height
	    }; // Do not write back to option and replace value 'ph', because
	    // the 'ph' value should be recalculated when resize.
	
	    var layoutParams = layout.getLayoutParams(dataZoomModel.option); // Replace the placeholder value.
	
	    zrUtil.each(['right', 'top', 'width', 'height'], function (name) {
	      if (layoutParams[name] === 'ph') {
	        layoutParams[name] = positionInfo[name];
	      }
	    });
	    var layoutRect = layout.getLayoutRect(layoutParams, ecSize, dataZoomModel.padding);
	    this._location = {
	      x: layoutRect.x,
	      y: layoutRect.y
	    };
	    this._size = [layoutRect.width, layoutRect.height];
	    this._orient === VERTICAL && this._size.reverse();
	  },
	
	  /**
	   * @private
	   */
	  _positionGroup: function () {
	    var thisGroup = this.group;
	    var location = this._location;
	    var orient = this._orient; // Just use the first axis to determine mapping.
	
	    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
	    var inverse = targetAxisModel && targetAxisModel.get('inverse');
	    var barGroup = this._displayables.barGroup;
	    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.
	
	    barGroup.attr(orient === HORIZONTAL && !inverse ? {
	      scale: otherAxisInverse ? [1, 1] : [1, -1]
	    } : orient === HORIZONTAL && inverse ? {
	      scale: otherAxisInverse ? [-1, 1] : [-1, -1]
	    } : orient === VERTICAL && !inverse ? {
	      scale: otherAxisInverse ? [1, -1] : [1, 1],
	      rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.
	
	    } : {
	      scale: otherAxisInverse ? [-1, -1] : [-1, 1],
	      rotation: Math.PI / 2
	    }); // Position barGroup
	
	    var rect = thisGroup.getBoundingRect([barGroup]);
	    thisGroup.attr('position', [location.x - rect.x, location.y - rect.y]);
	  },
	
	  /**
	   * @private
	   */
	  _getViewExtent: function () {
	    return [0, this._size[0]];
	  },
	  _renderBackground: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var size = this._size;
	    var barGroup = this._displayables.barGroup;
	    barGroup.add(new Rect({
	      silent: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: dataZoomModel.get('backgroundColor')
	      },
	      z2: -40
	    })); // Click panel, over shadow, below handles.
	
	    barGroup.add(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: 'transparent'
	      },
	      z2: 0,
	      onclick: zrUtil.bind(this._onClickPanelClick, this)
	    }));
	  },
	  _renderDataShadow: function () {
	    var info = this._dataShadowInfo = this._prepareDataShadowInfo();
	
	    if (!info) {
	      return;
	    }
	
	    var size = this._size;
	    var seriesModel = info.series;
	    var data = seriesModel.getRawData();
	    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
	    : info.otherDim;
	
	    if (otherDim == null) {
	      return;
	    }
	
	    var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.
	
	    var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
	    otherDataExtent = [otherDataExtent[0] - otherOffset, otherDataExtent[1] + otherOffset];
	    var otherShadowExtent = [0, size[1]];
	    var thisShadowExtent = [0, size[0]];
	    var areaPoints = [[size[0], 0], [0, 0]];
	    var linePoints = [];
	    var step = thisShadowExtent[1] / (data.count() - 1);
	    var thisCoord = 0; // Optimize for large data shadow
	
	    var stride = Math.round(data.count() / size[0]);
	    var lastIsEmpty;
	    data.each([otherDim], function (value, index) {
	      if (stride > 0 && index % stride) {
	        thisCoord += step;
	        return;
	      } // FIXME
	      // Should consider axis.min/axis.max when drawing dataShadow.
	      // FIXME
	      // 应该使用统一的空判断？还是在list里进行空判断？
	
	
	      var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.
	
	      var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.
	
	      if (isEmpty && !lastIsEmpty && index) {
	        areaPoints.push([areaPoints[areaPoints.length - 1][0], 0]);
	        linePoints.push([linePoints[linePoints.length - 1][0], 0]);
	      } else if (!isEmpty && lastIsEmpty) {
	        areaPoints.push([thisCoord, 0]);
	        linePoints.push([thisCoord, 0]);
	      }
	
	      areaPoints.push([thisCoord, otherCoord]);
	      linePoints.push([thisCoord, otherCoord]);
	      thisCoord += step;
	      lastIsEmpty = isEmpty;
	    });
	    var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');
	
	    this._displayables.barGroup.add(new graphic.Polygon({
	      shape: {
	        points: areaPoints
	      },
	      style: zrUtil.defaults({
	        fill: dataZoomModel.get('dataBackgroundColor')
	      }, dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),
	      silent: true,
	      z2: -20
	    }));
	
	    this._displayables.barGroup.add(new graphic.Polyline({
	      shape: {
	        points: linePoints
	      },
	      style: dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),
	      silent: true,
	      z2: -19
	    }));
	  },
	  _prepareDataShadowInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var showDataShadow = dataZoomModel.get('showDataShadow');
	
	    if (showDataShadow === false) {
	      return;
	    } // Find a representative series.
	
	
	    var result;
	    var ecModel = this.ecModel;
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
	      zrUtil.each(seriesModels, function (seriesModel) {
	        if (result) {
	          return;
	        }
	
	        if (showDataShadow !== true && zrUtil.indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
	          return;
	        }
	
	        var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
	        var otherDim = getOtherDim(dimNames.name);
	        var otherAxisInverse;
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (otherDim != null && coordSys.getOtherAxis) {
	          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
	        }
	
	        otherDim = seriesModel.getData().mapDimension(otherDim);
	        result = {
	          thisAxis: thisAxis,
	          series: seriesModel,
	          thisDim: dimNames.name,
	          otherDim: otherDim,
	          otherAxisInverse: otherAxisInverse
	        };
	      }, this);
	    }, this);
	    return result;
	  },
	  _renderHandle: function () {
	    var displaybles = this._displayables;
	    var handles = displaybles.handles = [];
	    var handleLabels = displaybles.handleLabels = [];
	    var barGroup = this._displayables.barGroup;
	    var size = this._size;
	    var dataZoomModel = this.dataZoomModel;
	    barGroup.add(displaybles.filler = new Rect({
	      draggable: true,
	      cursor: getCursor(this._orient),
	      drift: bind(this._onDragMove, this, 'all'),
	      ondragstart: bind(this._showDataInfo, this, true),
	      ondragend: bind(this._onDragEnd, this),
	      onmouseover: bind(this._showDataInfo, this, true),
	      onmouseout: bind(this._showDataInfo, this, false),
	      style: {
	        fill: dataZoomModel.get('fillerColor'),
	        textPosition: 'inside'
	      }
	    })); // Frame border.
	
	    barGroup.add(new Rect({
	      silent: true,
	      subPixelOptimize: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
	        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
	        fill: 'rgba(0,0,0,0)'
	      }
	    }));
	    each([0, 1], function (handleIndex) {
	      var path = graphic.createIcon(dataZoomModel.get('handleIcon'), {
	        cursor: getCursor(this._orient),
	        draggable: true,
	        drift: bind(this._onDragMove, this, handleIndex),
	        ondragend: bind(this._onDragEnd, this),
	        onmouseover: bind(this._showDataInfo, this, true),
	        onmouseout: bind(this._showDataInfo, this, false)
	      }, {
	        x: -1,
	        y: 0,
	        width: 2,
	        height: 2
	      });
	      var bRect = path.getBoundingRect();
	      this._handleHeight = numberUtil.parsePercent(dataZoomModel.get('handleSize'), this._size[1]);
	      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
	      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
	      var handleColor = dataZoomModel.get('handleColor'); // Compatitable with previous version
	
	      if (handleColor != null) {
	        path.style.fill = handleColor;
	      }
	
	      barGroup.add(handles[handleIndex] = path);
	      var textStyleModel = dataZoomModel.textStyleModel;
	      this.group.add(handleLabels[handleIndex] = new graphic.Text({
	        silent: true,
	        invisible: true,
	        style: {
	          x: 0,
	          y: 0,
	          text: '',
	          textVerticalAlign: 'middle',
	          textAlign: 'center',
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        },
	        z2: 10
	      }));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var range = this._range = this.dataZoomModel.getPercentRange();
	
	    var viewExtent = this._getViewExtent();
	
	    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} delta
	   * @return {boolean} changed
	   */
	  _updateInterval: function (handleIndex, delta) {
	    var dataZoomModel = this.dataZoomModel;
	    var handleEnds = this._handleEnds;
	
	    var viewExtend = this._getViewExtent();
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    var percentExtent = [0, 100];
	    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
	    var lastRange = this._range;
	    var range = this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
	    return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (nonRealtime) {
	    var displaybles = this._displayables;
	    var handleEnds = this._handleEnds;
	    var handleInterval = asc(handleEnds.slice());
	    var size = this._size;
	    each([0, 1], function (handleIndex) {
	      // Handles
	      var handle = displaybles.handles[handleIndex];
	      var handleHeight = this._handleHeight;
	      handle.attr({
	        scale: [handleHeight / 2, handleHeight / 2],
	        position: [handleEnds[handleIndex], size[1] / 2 - handleHeight / 2]
	      });
	    }, this); // Filler
	
	    displaybles.filler.setShape({
	      x: handleInterval[0],
	      y: 0,
	      width: handleInterval[1] - handleInterval[0],
	      height: size[1]
	    });
	
	    this._updateDataInfo(nonRealtime);
	  },
	
	  /**
	   * @private
	   */
	  _updateDataInfo: function (nonRealtime) {
	    var dataZoomModel = this.dataZoomModel;
	    var displaybles = this._displayables;
	    var handleLabels = displaybles.handleLabels;
	    var orient = this._orient;
	    var labelTexts = ['', '']; // FIXME
	    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
	
	    if (dataZoomModel.get('showDetail')) {
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        var axis = axisProxy.getAxisModel().axis;
	        var range = this._range;
	        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
	        ? axisProxy.calculateDataWindow({
	          start: range[0],
	          end: range[1]
	        }).valueWindow : axisProxy.getDataValueWindow();
	        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
	      }
	    }
	
	    var orderedHandleEnds = asc(this._handleEnds.slice());
	    setLabel.call(this, 0);
	    setLabel.call(this, 1);
	
	    function setLabel(handleIndex) {
	      // Label
	      // Text should not transform by barGroup.
	      // Ignore handlers transform
	      var barTransform = graphic.getTransform(displaybles.handles[handleIndex].parent, this.group);
	      var direction = graphic.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
	      var offset = this._handleWidth / 2 + LABEL_GAP;
	      var textPoint = graphic.applyTransform([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        textVerticalAlign: orient === HORIZONTAL ? 'middle' : direction,
	        textAlign: orient === HORIZONTAL ? direction : 'center',
	        text: labelTexts[handleIndex]
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _formatLabel: function (value, axis) {
	    var dataZoomModel = this.dataZoomModel;
	    var labelFormatter = dataZoomModel.get('labelFormatter');
	    var labelPrecision = dataZoomModel.get('labelPrecision');
	
	    if (labelPrecision == null || labelPrecision === 'auto') {
	      labelPrecision = axis.getPixelPrecision();
	    }
	
	    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
	    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
	    : value.toFixed(Math.min(labelPrecision, 20));
	    return zrUtil.isFunction(labelFormatter) ? labelFormatter(value, valueStr) : zrUtil.isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
	  },
	
	  /**
	   * @private
	   * @param {boolean} showOrHide true: show, false: hide
	   */
	  _showDataInfo: function (showOrHide) {
	    // Always show when drgging.
	    showOrHide = this._dragging || showOrHide;
	    var handleLabels = this._displayables.handleLabels;
	    handleLabels[0].attr('invisible', !showOrHide);
	    handleLabels[1].attr('invisible', !showOrHide);
	  },
	  _onDragMove: function (handleIndex, dx, dy, event) {
	    this._dragging = true; // For mobile device, prevent screen slider on the button.
	
	    eventTool.stop(event.event); // Transform dx, dy to bar coordination.
	
	    var barTransform = this._displayables.barGroup.getLocalTransform();
	
	    var vertex = graphic.applyTransform([dx, dy], barTransform, true);
	
	    var changed = this._updateInterval(handleIndex, vertex[0]);
	
	    var realtime = this.dataZoomModel.get('realtime');
	
	    this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
	    // which cause bad visual effect when progressive enabled.
	
	
	    changed && realtime && this._dispatchZoomAction();
	  },
	  _onDragEnd: function () {
	    this._dragging = false;
	
	    this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
	    // drag end will cause the whole view rerender, which is unnecessary.
	
	
	    var realtime = this.dataZoomModel.get('realtime');
	    !realtime && this._dispatchZoomAction();
	  },
	  _onClickPanelClick: function (e) {
	    var size = this._size;
	
	    var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);
	
	    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
	      return;
	    }
	
	    var handleEnds = this._handleEnds;
	    var center = (handleEnds[0] + handleEnds[1]) / 2;
	
	    var changed = this._updateInterval('all', localPoint[0] - center);
	
	    this._updateView();
	
	    changed && this._dispatchZoomAction();
	  },
	
	  /**
	   * This action will be throttled.
	   * @private
	   */
	  _dispatchZoomAction: function () {
	    var range = this._range;
	    this.api.dispatchAction({
	      type: 'dataZoom',
	      from: this.uid,
	      dataZoomId: this.dataZoomModel.id,
	      start: range[0],
	      end: range[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _findCoordRect: function () {
	    // Find the grid coresponding to the first axis referred by dataZoom.
	    var rect;
	    each(this.getTargetCoordInfo(), function (coordInfoList) {
	      if (!rect && coordInfoList.length) {
	        var coordSys = coordInfoList[0].model.coordinateSystem;
	        rect = coordSys.getRect && coordSys.getRect();
	      }
	    });
	
	    if (!rect) {
	      var width = this.api.getWidth();
	      var height = this.api.getHeight();
	      rect = {
	        x: width * 0.2,
	        y: height * 0.2,
	        width: width * 0.6,
	        height: height * 0.6
	      };
	    }
	
	    return rect;
	  }
	});
	
	function getOtherDim(thisDim) {
	  // FIXME
	  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
	  var map = {
	    x: 'y',
	    y: 'x',
	    radius: 'angle',
	    angle: 'radius'
	  };
	  return map[thisDim];
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = SliderZoomView;
	module.exports = _default;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var RoamController = __webpack_require__(218);
	
	var throttleUtil = __webpack_require__(131);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Only create one roam controller for each coordinate system.
	// one roam controller might be refered by two inside data zoom
	// components (for example, one for x and one for y). When user
	// pan or zoom, only dispatch one action for those data zoom
	// components.
	var ATTR = '\0_ec_dataZoom_roams';
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} dataZoomInfo
	 * @param {string} dataZoomInfo.coordId
	 * @param {Function} dataZoomInfo.containsPoint
	 * @param {Array.<string>} dataZoomInfo.allCoordIds
	 * @param {string} dataZoomInfo.dataZoomId
	 * @param {Object} dataZoomInfo.getRange
	 * @param {Function} dataZoomInfo.getRange.pan
	 * @param {Function} dataZoomInfo.getRange.zoom
	 * @param {Function} dataZoomInfo.getRange.scrollMove
	 * @param {boolean} dataZoomInfo.dataZoomModel
	 */
	
	function register(api, dataZoomInfo) {
	  var store = giveStore(api);
	  var theDataZoomId = dataZoomInfo.dataZoomId;
	  var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
	  // Avoid memory leak, dispose all not-used-registered.
	
	  zrUtil.each(store, function (record, coordId) {
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[theDataZoomId] && zrUtil.indexOf(dataZoomInfo.allCoordIds, theCoordId) < 0) {
	      delete dataZoomInfos[theDataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	  var record = store[theCoordId]; // Create if needed.
	
	  if (!record) {
	    record = store[theCoordId] = {
	      coordId: theCoordId,
	      dataZoomInfos: {},
	      count: 0
	    };
	    record.controller = createController(api, record);
	    record.dispatchAction = zrUtil.curry(dispatchAction, api);
	  } // Update reference of dataZoom.
	
	
	  !record.dataZoomInfos[theDataZoomId] && record.count++;
	  record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
	  var controllerParams = mergeControllerParams(record.dataZoomInfos);
	  record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.
	
	  record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.
	
	  throttleUtil.createOrUpdate(record, 'dispatchAction', dataZoomInfo.dataZoomModel.get('throttle', true), 'fixRate');
	}
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {string} dataZoomId
	 */
	
	
	function unregister(api, dataZoomId) {
	  var store = giveStore(api);
	  zrUtil.each(store, function (record) {
	    record.controller.dispose();
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[dataZoomId]) {
	      delete dataZoomInfos[dataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	}
	/**
	 * @public
	 */
	
	
	function generateCoordId(coordModel) {
	  return coordModel.type + '\0_' + coordModel.id;
	}
	/**
	 * Key: coordId, value: {dataZoomInfos: [], count, controller}
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(api) {
	  // Mount store on zrender instance, so that we do not
	  // need to worry about dispose.
	  var zr = api.getZr();
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	
	function createController(api, newRecord) {
	  var controller = new RoamController(api.getZr());
	  zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	    controller.on(eventName, function (event) {
	      var batch = [];
	      zrUtil.each(newRecord.dataZoomInfos, function (info) {
	        // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
	        // moveOnMouseWheel, ...) enabled.
	        if (!event.isAvailableBehavior(info.dataZoomModel.option)) {
	          return;
	        }
	
	        var method = (info.getRange || {})[eventName];
	        var range = method && method(newRecord.controller, event);
	        !info.dataZoomModel.get('disabled', true) && range && batch.push({
	          dataZoomId: info.dataZoomId,
	          start: range[0],
	          end: range[1]
	        });
	      });
	      batch.length && newRecord.dispatchAction(batch);
	    });
	  });
	  return controller;
	}
	
	function cleanStore(store) {
	  zrUtil.each(store, function (record, coordId) {
	    if (!record.count) {
	      record.controller.dispose();
	      delete store[coordId];
	    }
	  });
	}
	/**
	 * This action will be throttled.
	 */
	
	
	function dispatchAction(api, batch) {
	  api.dispatchAction({
	    type: 'dataZoom',
	    batch: batch
	  });
	}
	/**
	 * Merge roamController settings when multiple dataZooms share one roamController.
	 */
	
	
	function mergeControllerParams(dataZoomInfos) {
	  var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
	  // as string, it is probably revert to reserved word by compress tool. See #7411.
	
	  var prefix = 'type_';
	  var typePriority = {
	    'type_true': 2,
	    'type_move': 1,
	    'type_false': 0,
	    'type_undefined': -1
	  };
	  var preventDefaultMouseMove = true;
	  zrUtil.each(dataZoomInfos, function (dataZoomInfo) {
	    var dataZoomModel = dataZoomInfo.dataZoomModel;
	    var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
	
	    if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
	      controlType = oneType;
	    } // Prevent default move event by default. If one false, do not prevent. Otherwise
	    // users may be confused why it does not work when multiple insideZooms exist.
	
	
	    preventDefaultMouseMove &= dataZoomModel.get('preventDefaultMouseMove', true);
	  });
	  return {
	    controlType: controlType,
	    opt: {
	      // RoamController will enable all of these functionalities,
	      // and the final behavior is determined by its event listener
	      // provided by each inside zoom.
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      moveOnMouseWheel: true,
	      preventDefaultMouseMove: !!preventDefaultMouseMove
	    }
	  };
	}
	
	exports.register = register;
	exports.unregister = unregister;
	exports.generateCoordId = generateCoordId;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	__webpack_require__(1821);
	
	__webpack_require__(428);
	
	__webpack_require__(1759);
	
	__webpack_require__(799);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeAction(method, actionInfo) {
	  actionInfo.update = 'updateView';
	  echarts.registerAction(actionInfo, function (payload, ecModel) {
	    var selected = {};
	    ecModel.eachComponent({
	      mainType: 'geo',
	      query: payload
	    }, function (geoModel) {
	      geoModel[method](payload.name);
	      var geo = geoModel.coordinateSystem;
	      zrUtil.each(geo.regions, function (region) {
	        selected[region.name] = geoModel.isSelected(region.name) || false;
	      });
	    });
	    return {
	      selected: selected,
	      name: payload.name
	    };
	  });
	}
	
	makeAction('toggleSelected', {
	  type: 'geoToggleSelect',
	  event: 'geoselectchanged'
	});
	makeAction('select', {
	  type: 'geoSelect',
	  event: 'geoselected'
	});
	makeAction('unSelect', {
	  type: 'geoUnSelect',
	  event: 'geounselected'
	});

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MapDraw = __webpack_require__(823);
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'geo',
	  init: function (ecModel, api) {
	    var mapDraw = new MapDraw(api, true);
	    this._mapDraw = mapDraw;
	    this.group.add(mapDraw.group);
	  },
	  render: function (geoModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'geoToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var mapDraw = this._mapDraw;
	
	    if (geoModel.get('show')) {
	      mapDraw.draw(geoModel, ecModel, api, this, payload);
	    } else {
	      this._mapDraw.group.removeAll();
	    }
	
	    this.group.silent = geoModel.get('silent');
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var modelUtil = __webpack_require__(27);
	
	var graphicUtil = __webpack_require__(17);
	
	var layoutUtil = __webpack_require__(47);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _nonShapeGraphicElements = {
	  // Reserved but not supported in graphic component.
	  path: null,
	  compoundPath: null,
	  // Supported in graphic component.
	  group: graphicUtil.Group,
	  image: graphicUtil.Image,
	  text: graphicUtil.Text
	}; // -------------
	// Preprocessor
	// -------------
	
	echarts.registerPreprocessor(function (option) {
	  var graphicOption = option.graphic; // Convert
	  // {graphic: [{left: 10, type: 'circle'}, ...]}
	  // or
	  // {graphic: {left: 10, type: 'circle'}}
	  // to
	  // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
	
	  if (zrUtil.isArray(graphicOption)) {
	    if (!graphicOption[0] || !graphicOption[0].elements) {
	      option.graphic = [{
	        elements: graphicOption
	      }];
	    } else {
	      // Only one graphic instance can be instantiated. (We dont
	      // want that too many views are created in echarts._viewMap)
	      option.graphic = [option.graphic[0]];
	    }
	  } else if (graphicOption && !graphicOption.elements) {
	    option.graphic = [{
	      elements: [graphicOption]
	    }];
	  }
	}); // ------
	// Model
	// ------
	
	var GraphicModel = echarts.extendComponentModel({
	  type: 'graphic',
	  defaultOption: {
	    // Extra properties for each elements:
	    //
	    // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
	    //      If left/rigth is set, shape.x/shape.cx/position will not be used.
	    //      If top/bottom is set, shape.y/shape.cy/position will not be used.
	    //      This mechanism is useful when you want to position a group/element
	    //      against the right side or the center of this container.
	    //
	    // width/height: (can only be pixel value, default 0)
	    //      Only be used to specify contianer(group) size, if needed. And
	    //      can not be percentage value (like '33%'). See the reason in the
	    //      layout algorithm below.
	    //
	    // bounding: (enum: 'all' (default) | 'raw')
	    //      Specify how to calculate boundingRect when locating.
	    //      'all': Get uioned and transformed boundingRect
	    //          from both itself and its descendants.
	    //          This mode simplies confining a group of elements in the bounding
	    //          of their ancester container (e.g., using 'right: 0').
	    //      'raw': Only use the boundingRect of itself and before transformed.
	    //          This mode is similar to css behavior, which is useful when you
	    //          want an element to be able to overflow its container. (Consider
	    //          a rotated circle needs to be located in a corner.)
	    // info: custom info. enables user to mount some info on elements and use them
	    //      in event handlers. Update them only when user specified, otherwise, remain.
	    // Note: elements is always behind its ancestors in this elements array.
	    elements: [],
	    parentId: null
	  },
	
	  /**
	   * Save el options for the sake of the performance (only update modified graphics).
	   * The order is the same as those in option. (ancesters -> descendants)
	   *
	   * @private
	   * @type {Array.<Object>}
	   */
	  _elOptionsToUpdate: null,
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    // Prevent default merge to elements
	    var elements = this.option.elements;
	    this.option.elements = null;
	    GraphicModel.superApply(this, 'mergeOption', arguments);
	    this.option.elements = elements;
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    var newList = (isInit ? thisOption : newOption).elements;
	    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
	    var flattenedList = [];
	
	    this._flatten(newList, flattenedList);
	
	    var mappingResult = modelUtil.mappingToExists(existList, flattenedList);
	    modelUtil.makeIdAndName(mappingResult); // Clear elOptionsToUpdate
	
	    var elOptionsToUpdate = this._elOptionsToUpdate = [];
	    zrUtil.each(mappingResult, function (resultItem, index) {
	      var newElOption = resultItem.option;
	
	      if (!newElOption) {
	        return;
	      }
	
	      elOptionsToUpdate.push(newElOption);
	      setKeyInfoToNewElOption(resultItem, newElOption);
	      mergeNewElOptionToExist(existList, index, newElOption);
	      setLayoutInfoToExist(existList[index], newElOption);
	    }, this); // Clean
	
	    for (var i = existList.length - 1; i >= 0; i--) {
	      if (existList[i] == null) {
	        existList.splice(i, 1);
	      } else {
	        // $action should be volatile, otherwise option gotten from
	        // `getOption` will contain unexpected $action.
	        delete existList[i].$action;
	      }
	    }
	  },
	
	  /**
	   * Convert
	   * [{
	   *  type: 'group',
	   *  id: 'xx',
	   *  children: [{type: 'circle'}, {type: 'polygon'}]
	   * }]
	   * to
	   * [
	   *  {type: 'group', id: 'xx'},
	   *  {type: 'circle', parentId: 'xx'},
	   *  {type: 'polygon', parentId: 'xx'}
	   * ]
	   *
	   * @private
	   * @param {Array.<Object>} optionList option list
	   * @param {Array.<Object>} result result of flatten
	   * @param {Object} parentOption parent option
	   */
	  _flatten: function (optionList, result, parentOption) {
	    zrUtil.each(optionList, function (option) {
	      if (!option) {
	        return;
	      }
	
	      if (parentOption) {
	        option.parentOption = parentOption;
	      }
	
	      result.push(option);
	      var children = option.children;
	
	      if (option.type === 'group' && children) {
	        this._flatten(children, result, option);
	      } // Deleting for JSON output, and for not affecting group creation.
	
	
	      delete option.children;
	    }, this);
	  },
	  // FIXME
	  // Pass to view using payload? setOption has a payload?
	  useElOptionsToUpdate: function () {
	    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.
	
	    this._elOptionsToUpdate = null;
	    return els;
	  }
	}); // -----
	// View
	// -----
	
	echarts.extendComponentView({
	  type: 'graphic',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this._elMap = zrUtil.createHashMap();
	    /**
	     * @private
	     * @type {module:echarts/graphic/GraphicModel}
	     */
	
	    this._lastGraphicModel;
	  },
	
	  /**
	   * @override
	   */
	  render: function (graphicModel, ecModel, api) {
	    // Having leveraged between use cases and algorithm complexity, a very
	    // simple layout mechanism is used:
	    // The size(width/height) can be determined by itself or its parent (not
	    // implemented yet), but can not by its children. (Top-down travel)
	    // The location(x/y) can be determined by the bounding rect of itself
	    // (can including its descendants or not) and the size of its parent.
	    // (Bottom-up travel)
	    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
	    // view will be reused.
	    if (graphicModel !== this._lastGraphicModel) {
	      this._clear();
	    }
	
	    this._lastGraphicModel = graphicModel;
	
	    this._updateElements(graphicModel);
	
	    this._relocate(graphicModel, api);
	  },
	
	  /**
	   * Update graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   */
	  _updateElements: function (graphicModel) {
	    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
	
	    if (!elOptionsToUpdate) {
	      return;
	    }
	
	    var elMap = this._elMap;
	    var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.
	
	    zrUtil.each(elOptionsToUpdate, function (elOption) {
	      var $action = elOption.$action;
	      var id = elOption.id;
	      var existEl = elMap.get(id);
	      var parentId = elOption.parentId;
	      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
	      var elOptionStyle = elOption.style;
	
	      if (elOption.type === 'text' && elOptionStyle) {
	        // In top/bottom mode, textVerticalAlign should not be used, which cause
	        // inaccurately locating.
	        if (elOption.hv && elOption.hv[1]) {
	          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
	        } // Compatible with previous setting: both support fill and textFill,
	        // stroke and textStroke.
	
	
	        !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	        !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	      } // Remove unnecessary props to avoid potential problems.
	
	
	      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.
	
	      if (!$action || $action === 'merge') {
	        existEl ? existEl.attr(elOptionCleaned) : createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'replace') {
	        removeEl(existEl, elMap);
	        createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'remove') {
	        removeEl(existEl, elMap);
	      }
	
	      var el = elMap.get(id);
	
	      if (el) {
	        el.__ecGraphicWidthOption = elOption.width;
	        el.__ecGraphicHeightOption = elOption.height;
	        setEventData(el, graphicModel, elOption);
	      }
	    });
	  },
	
	  /**
	   * Locate graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   * @param {module:echarts/ExtensionAPI} api extension API
	   */
	  _relocate: function (graphicModel, api) {
	    var elOptions = graphicModel.option.elements;
	    var rootGroup = this.group;
	    var elMap = this._elMap;
	    var apiWidth = api.getWidth();
	    var apiHeight = api.getHeight(); // Top-down to calculate percentage width/height of group
	
	    for (var i = 0; i < elOptions.length; i++) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el || !el.isGroup) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.
	
	      el.__ecGraphicWidth = parsePercent(el.__ecGraphicWidthOption, isParentRoot ? apiWidth : parentEl.__ecGraphicWidth) || 0;
	      el.__ecGraphicHeight = parsePercent(el.__ecGraphicHeightOption, isParentRoot ? apiHeight : parentEl.__ecGraphicHeight) || 0;
	    } // Bottom-up tranvese all elements (consider ec resize) to locate elements.
	
	
	    for (var i = elOptions.length - 1; i >= 0; i--) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var containerInfo = parentEl === rootGroup ? {
	        width: apiWidth,
	        height: apiHeight
	      } : {
	        width: parentEl.__ecGraphicWidth,
	        height: parentEl.__ecGraphicHeight
	      }; // PENDING
	      // Currently, when `bounding: 'all'`, the union bounding rect of the group
	      // does not include the rect of [0, 0, group.width, group.height], which
	      // is probably weird for users. Should we make a break change for it?
	
	      layoutUtil.positionElement(el, elOption, containerInfo, null, {
	        hv: elOption.hv,
	        boundingMode: elOption.bounding
	      });
	    }
	  },
	
	  /**
	   * Clear all elements.
	   *
	   * @private
	   */
	  _clear: function () {
	    var elMap = this._elMap;
	    elMap.each(function (el) {
	      removeEl(el, elMap);
	    });
	    this._elMap = zrUtil.createHashMap();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clear();
	  }
	});
	
	function createEl(id, targetElParent, elOption, elMap) {
	  var graphicType = elOption.type;
	  var Clz = _nonShapeGraphicElements.hasOwnProperty(graphicType) // Those graphic elements are not shapes. They should not be
	  // overwritten by users, so do them first.
	  ? _nonShapeGraphicElements[graphicType] : graphicUtil.getShapeClass(graphicType);
	  var el = new Clz(elOption);
	  targetElParent.add(el);
	  elMap.set(id, el);
	  el.__ecGraphicId = id;
	}
	
	function removeEl(existEl, elMap) {
	  var existElParent = existEl && existEl.parent;
	
	  if (existElParent) {
	    existEl.type === 'group' && existEl.traverse(function (el) {
	      removeEl(el, elMap);
	    });
	    elMap.removeKey(existEl.__ecGraphicId);
	    existElParent.remove(existEl);
	  }
	} // Remove unnecessary props to avoid potential problems.
	
	
	function getCleanedElOption(elOption) {
	  elOption = zrUtil.extend({}, elOption);
	  zrUtil.each(['id', 'parentId', '$action', 'hv', 'bounding'].concat(layoutUtil.LOCATION_PARAMS), function (name) {
	    delete elOption[name];
	  });
	  return elOption;
	}
	
	function isSetLoc(obj, props) {
	  var isSet;
	  zrUtil.each(props, function (prop) {
	    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
	  });
	  return isSet;
	}
	
	function setKeyInfoToNewElOption(resultItem, newElOption) {
	  var existElOption = resultItem.exist; // Set id and type after id assigned.
	
	  newElOption.id = resultItem.keyInfo.id;
	  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified
	
	  if (newElOption.parentId == null) {
	    var newElParentOption = newElOption.parentOption;
	
	    if (newElParentOption) {
	      newElOption.parentId = newElParentOption.id;
	    } else if (existElOption) {
	      newElOption.parentId = existElOption.parentId;
	    }
	  } // Clear
	
	
	  newElOption.parentOption = null;
	}
	
	function mergeNewElOptionToExist(existList, index, newElOption) {
	  // Update existing options, for `getOption` feature.
	  var newElOptCopy = zrUtil.extend({}, newElOption);
	  var existElOption = existList[index];
	  var $action = newElOption.$action || 'merge';
	
	  if ($action === 'merge') {
	    if (existElOption) {
	      // We can ensure that newElOptCopy and existElOption are not
	      // the same object, so `merge` will not change newElOptCopy.
	      zrUtil.merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.
	
	      layoutUtil.mergeLayoutParam(existElOption, newElOptCopy, {
	        ignoreSize: true
	      }); // Will be used in render.
	
	      layoutUtil.copyLayoutParams(newElOption, existElOption);
	    } else {
	      existList[index] = newElOptCopy;
	    }
	  } else if ($action === 'replace') {
	    existList[index] = newElOptCopy;
	  } else if ($action === 'remove') {
	    // null will be cleaned later.
	    existElOption && (existList[index] = null);
	  }
	}
	
	function setLayoutInfoToExist(existItem, newElOption) {
	  if (!existItem) {
	    return;
	  }
	
	  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
	  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
	  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.
	
	  if (existItem.type === 'group') {
	    existItem.width == null && (existItem.width = newElOption.width = 0);
	    existItem.height == null && (existItem.height = newElOption.height = 0);
	  }
	}
	
	function setEventData(el, graphicModel, elOption) {
	  var eventData = el.eventData; // Simple optimize for large amount of elements that no need event.
	
	  if (!el.silent && !el.ignore && !eventData) {
	    eventData = el.eventData = {
	      componentType: 'graphic',
	      componentIndex: graphicModel.componentIndex,
	      name: el.name
	    };
	  } // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	
	
	  if (eventData) {
	    eventData.info = el.info;
	  }
	}

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(217);
	
	__webpack_require__(813);
	
	__webpack_require__(216);

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(827);
	
	__webpack_require__(1763);
	
	__webpack_require__(1764);
	
	__webpack_require__(1767);

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var LegendModel = __webpack_require__(828);
	
	var _layout = __webpack_require__(47);
	
	var mergeLayoutParam = _layout.mergeLayoutParam;
	var getLayoutParams = _layout.getLayoutParams;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ScrollableLegendModel = LegendModel.extend({
	  type: 'legend.scroll',
	
	  /**
	   * @param {number} scrollDataIndex
	   */
	  setScrollDataIndex: function (scrollDataIndex) {
	    this.option.scrollDataIndex = scrollDataIndex;
	  },
	  defaultOption: {
	    scrollDataIndex: 0,
	    pageButtonItemGap: 5,
	    pageButtonGap: null,
	    pageButtonPosition: 'end',
	    // 'start' or 'end'
	    pageFormatter: '{current}/{total}',
	    // If null/undefined, do not show page.
	    pageIcons: {
	      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
	      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
	    },
	    pageIconColor: '#2f4554',
	    pageIconInactiveColor: '#aaa',
	    pageIconSize: 15,
	    // Can be [10, 3], which represents [width, height]
	    pageTextStyle: {
	      color: '#333'
	    },
	    animationDurationUpdate: 800
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    ScrollableLegendModel.superCall(this, 'init', option, parentModel, ecModel, extraOpt);
	    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    ScrollableLegendModel.superCall(this, 'mergeOption', option, extraOpt);
	    mergeAndNormalizeLayoutParams(this, this.option, option);
	  }
	}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.
	
	function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
	  var orient = legendModel.getOrient();
	  var ignoreSize = [1, 1];
	  ignoreSize[orient.index] = 0;
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = ScrollableLegendModel;
	module.exports = _default;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var layoutUtil = __webpack_require__(47);
	
	var LegendView = __webpack_require__(829);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Separate legend and scrollable legend to reduce package size.
	 */
	var Group = graphic.Group;
	var WH = ['width', 'height'];
	var XY = ['x', 'y'];
	var ScrollableLegendView = LegendView.extend({
	  type: 'legend.scroll',
	  newlineDisabled: true,
	  init: function () {
	    ScrollableLegendView.superCall(this, 'init');
	    /**
	     * @private
	     * @type {number} For `scroll`.
	     */
	
	    this._currentIndex = 0;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._containerGroup = new Group());
	
	    this._containerGroup.add(this.getContentGroup());
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	
	    this.group.add(this._controllerGroup = new Group());
	    /**
	     *
	     * @private
	     */
	
	    this._showController;
	  },
	
	  /**
	   * @override
	   */
	  resetInner: function () {
	    ScrollableLegendView.superCall(this, 'resetInner');
	
	    this._controllerGroup.removeAll();
	
	    this._containerGroup.removeClipPath();
	
	    this._containerGroup.__rectSize = null;
	  },
	
	  /**
	   * @override
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	    var me = this; // Render content items.
	
	    ScrollableLegendView.superCall(this, 'renderInner', itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
	    var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
	    // e.g., '3/12345' should not overlap with the control arrow button.
	
	    var pageIconSize = legendModel.get('pageIconSize', true);
	
	    if (!zrUtil.isArray(pageIconSize)) {
	      pageIconSize = [pageIconSize, pageIconSize];
	    }
	
	    createPageButton('pagePrev', 0);
	    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
	    controllerGroup.add(new graphic.Text({
	      name: 'pageText',
	      style: {
	        textFill: pageTextStyleModel.getTextColor(),
	        font: pageTextStyleModel.getFont(),
	        textVerticalAlign: 'middle',
	        textAlign: 'center'
	      },
	      silent: true
	    }));
	    createPageButton('pageNext', 1);
	
	    function createPageButton(name, iconIdx) {
	      var pageDataIndexName = name + 'DataIndex';
	      var icon = graphic.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
	        // Buttons will be created in each render, so we do not need
	        // to worry about avoiding using legendModel kept in scope.
	        onclick: zrUtil.bind(me._pageGo, me, pageDataIndexName, legendModel, api)
	      }, {
	        x: -pageIconSize[0] / 2,
	        y: -pageIconSize[1] / 2,
	        width: pageIconSize[0],
	        height: pageIconSize[1]
	      });
	      icon.name = name;
	      controllerGroup.add(icon);
	    }
	  },
	
	  /**
	   * @override
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	    var selectorGroup = this.getSelectorGroup();
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	    var hw = WH[1 - orientIdx];
	    var yx = XY[1 - orientIdx];
	    selector && layoutUtil.box( // Buttons in selectorGroup always layout horizontally
	    'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	    var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	    var selectorRect = selectorGroup.getBoundingRect();
	    var selectorPos = [-selectorRect.x, -selectorRect.y];
	    var processMaxSize = zrUtil.clone(maxSize);
	    selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
	
	    var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx);
	
	    if (selector) {
	      if (selectorPosition === 'end') {
	        selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
	      } else {
	        var offset = selectorRect[wh] + selectorButtonGap;
	        selectorPos[orientIdx] -= offset;
	        mainRect[xy] -= offset;
	      }
	
	      mainRect[wh] += selectorRect[wh] + selectorButtonGap;
	      selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
	      mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
	      mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
	      selectorGroup.attr('position', selectorPos);
	    }
	
	    return mainRect;
	  },
	  _layoutContentAndController: function (legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx) {
	    var contentGroup = this.getContentGroup();
	    var containerGroup = this._containerGroup;
	    var controllerGroup = this._controllerGroup; // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
	    layoutUtil.box( // Buttons in controller are layout always horizontally.
	    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
	    var contentRect = contentGroup.getBoundingRect();
	    var controllerRect = controllerGroup.getBoundingRect();
	    var showController = this._showController = contentRect[wh] > maxSize[wh];
	    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
	    // If first rendering, `contentGroup.position` is [0, 0], which
	    // does not make sense and may cause unexepcted animation if adopted.
	
	    if (!isFirstRender) {
	      contentPos[orientIdx] = contentGroup.position[orientIdx];
	    } // Layout container group based on 0.
	
	
	    var containerPos = [0, 0];
	    var controllerPos = [-controllerRect.x, -controllerRect.y];
	    var pageButtonGap = zrUtil.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.
	
	    if (showController) {
	      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.
	
	      if (pageButtonPosition === 'end') {
	        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
	      } // controller is on the left / top.
	      else {
	          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
	        }
	    } // Always align controller to content as 'middle'.
	
	
	    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
	    contentGroup.attr('position', contentPos);
	    containerGroup.attr('position', containerPos);
	    controllerGroup.attr('position', controllerPos); // Calculate `mainRect` and set `clipPath`.
	    // mainRect should not be calculated by `this.group.getBoundingRect()`
	    // for sake of the overflow.
	
	    var mainRect = {
	      x: 0,
	      y: 0
	    }; // Consider content may be overflow (should be clipped).
	
	    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
	    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
	
	    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
	    containerGroup.__rectSize = maxSize[wh];
	
	    if (showController) {
	      var clipShape = {
	        x: 0,
	        y: 0
	      };
	      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
	      clipShape[hw] = mainRect[hw];
	      containerGroup.setClipPath(new graphic.Rect({
	        shape: clipShape
	      })); // Consider content may be larger than container, container rect
	      // can not be obtained from `containerGroup.getBoundingRect()`.
	
	      containerGroup.__rectSize = clipShape[wh];
	    } else {
	      // Do not remove or ignore controller. Keep them set as placeholders.
	      controllerGroup.eachChild(function (child) {
	        child.attr({
	          invisible: true,
	          silent: true
	        });
	      });
	    } // Content translate animation.
	
	
	    var pageInfo = this._getPageInfo(legendModel);
	
	    pageInfo.pageIndex != null && graphic.updateProps(contentGroup, {
	      position: pageInfo.contentPosition
	    }, // When switch from "show controller" to "not show controller", view should be
	    // updated immediately without animation, otherwise causes weird effect.
	    showController ? legendModel : false);
	
	    this._updatePageInfoView(legendModel, pageInfo);
	
	    return mainRect;
	  },
	  _pageGo: function (to, legendModel, api) {
	    var scrollDataIndex = this._getPageInfo(legendModel)[to];
	
	    scrollDataIndex != null && api.dispatchAction({
	      type: 'legendScroll',
	      scrollDataIndex: scrollDataIndex,
	      legendId: legendModel.id
	    });
	  },
	  _updatePageInfoView: function (legendModel, pageInfo) {
	    var controllerGroup = this._controllerGroup;
	    zrUtil.each(['pagePrev', 'pageNext'], function (name) {
	      var canJump = pageInfo[name + 'DataIndex'] != null;
	      var icon = controllerGroup.childOfName(name);
	
	      if (icon) {
	        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
	        icon.cursor = canJump ? 'pointer' : 'default';
	      }
	    });
	    var pageText = controllerGroup.childOfName('pageText');
	    var pageFormatter = legendModel.get('pageFormatter');
	    var pageIndex = pageInfo.pageIndex;
	    var current = pageIndex != null ? pageIndex + 1 : 0;
	    var total = pageInfo.pageCount;
	    pageText && pageFormatter && pageText.setStyle('text', zrUtil.isString(pageFormatter) ? pageFormatter.replace('{current}', current).replace('{total}', total) : pageFormatter({
	      current: current,
	      total: total
	    }));
	  },
	
	  /**
	   * @param {module:echarts/model/Model} legendModel
	   * @return {Object} {
	   *  contentPosition: Array.<number>, null when data item not found.
	   *  pageIndex: number, null when data item not found.
	   *  pageCount: number, always be a number, can be 0.
	   *  pagePrevDataIndex: number, null when no previous page.
	   *  pageNextDataIndex: number, null when no next page.
	   * }
	   */
	  _getPageInfo: function (legendModel) {
	    var scrollDataIndex = legendModel.get('scrollDataIndex', true);
	    var contentGroup = this.getContentGroup();
	    var containerRectSize = this._containerGroup.__rectSize;
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	
	    var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
	
	    var children = contentGroup.children();
	    var targetItem = children[targetItemIndex];
	    var itemCount = children.length;
	    var pCount = !itemCount ? 0 : 1;
	    var result = {
	      contentPosition: contentGroup.position.slice(),
	      pageCount: pCount,
	      pageIndex: pCount - 1,
	      pagePrevDataIndex: null,
	      pageNextDataIndex: null
	    };
	
	    if (!targetItem) {
	      return result;
	    }
	
	    var targetItemInfo = getItemInfo(targetItem);
	    result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
	    // (1) Always align based on the left/top most item.
	    // (2) It is user-friendly that the last item shown in the
	    // current window is shown at the begining of next window.
	    // Otherwise if half of the last item is cut by the window,
	    // it will have no chance to display entirely.
	    // (3) Consider that item size probably be different, we
	    // have calculate pageIndex by size rather than item index,
	    // and we can not get page index directly by division.
	    // (4) The window is to narrow to contain more than
	    // one item, we should make sure that the page can be fliped.
	
	    for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // Half of the last item is out of the window.
	      !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
	      // can be started at the current item or the last item.
	      currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
	        if (winEndItemInfo.i > winStartItemInfo.i) {
	          winStartItemInfo = winEndItemInfo;
	        } else {
	          // e.g., when page size is smaller than item size.
	          winStartItemInfo = currItemInfo;
	        }
	
	        if (winStartItemInfo) {
	          if (result.pageNextDataIndex == null) {
	            result.pageNextDataIndex = winStartItemInfo.i;
	          }
	
	          ++result.pageCount;
	        }
	      }
	
	      winEndItemInfo = currItemInfo;
	    }
	
	    for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // If the the end item does not intersect with the window started
	      // from the current item, a page can be settled.
	      (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
	      winStartItemInfo.i < winEndItemInfo.i) {
	        winEndItemInfo = winStartItemInfo;
	
	        if (result.pagePrevDataIndex == null) {
	          result.pagePrevDataIndex = winStartItemInfo.i;
	        }
	
	        ++result.pageCount;
	        ++result.pageIndex;
	      }
	
	      winStartItemInfo = currItemInfo;
	    }
	
	    return result;
	
	    function getItemInfo(el) {
	      if (el) {
	        var itemRect = el.getBoundingRect();
	        var start = itemRect[xy] + el.position[orientIdx];
	        return {
	          s: start,
	          e: start + itemRect[wh],
	          i: el.__legendDataIndex
	        };
	      }
	    }
	
	    function intersect(itemInfo, winStart) {
	      return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
	    }
	  },
	  _findTargetItemIndex: function (targetDataIndex) {
	    if (!this._showController) {
	      return 0;
	    }
	
	    var index;
	    var contentGroup = this.getContentGroup();
	    var defaultIndex;
	    contentGroup.eachChild(function (child, idx) {
	      var legendDataIdx = child.__legendDataIndex; // FIXME
	      // If the given targetDataIndex (from model) is illegal,
	      // we use defaultIndex. But the index on the legend model and
	      // action payload is still illegal. That case will not be
	      // changed until some scenario requires.
	
	      if (defaultIndex == null && legendDataIdx != null) {
	        defaultIndex = idx;
	      }
	
	      if (legendDataIdx === targetDataIndex) {
	        index = idx;
	      }
	    });
	    return index != null ? index : defaultIndex;
	  }
	});
	var _default = ScrollableLegendView;
	module.exports = _default;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function legendSelectActionHandler(methodName, payload, ecModel) {
	  var selectedMap = {};
	  var isToggleSelect = methodName === 'toggleSelected';
	  var isSelected; // Update all legend components
	
	  ecModel.eachComponent('legend', function (legendModel) {
	    if (isToggleSelect && isSelected != null) {
	      // Force other legend has same selected status
	      // Or the first is toggled to true and other are toggled to false
	      // In the case one legend has some item unSelected in option. And if other legend
	      // doesn't has the item, they will assume it is selected.
	      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
	    } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
	      legendModel[methodName]();
	    } else {
	      legendModel[methodName](payload.name);
	      isSelected = legendModel.isSelected(payload.name);
	    }
	
	    var legendData = legendModel.getData();
	    zrUtil.each(legendData, function (model) {
	      var name = model.get('name'); // Wrap element
	
	      if (name === '\n' || name === '') {
	        return;
	      }
	
	      var isItemSelected = legendModel.isSelected(name);
	
	      if (selectedMap.hasOwnProperty(name)) {
	        // Unselected if any legend is unselected
	        selectedMap[name] = selectedMap[name] && isItemSelected;
	      } else {
	        selectedMap[name] = isItemSelected;
	      }
	    });
	  }); // Return the event explicitly
	
	  return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
	    selected: selectedMap
	  } : {
	    name: payload.name,
	    selected: selectedMap
	  };
	}
	/**
	 * @event legendToggleSelect
	 * @type {Object}
	 * @property {string} type 'legendToggleSelect'
	 * @property {string} [from]
	 * @property {string} name Series name or data item name
	 */
	
	
	echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
	echarts.registerAction('legendAllSelect', 'legendselectall', zrUtil.curry(legendSelectActionHandler, 'allSelect'));
	echarts.registerAction('legendInverseSelect', 'legendinverseselect', zrUtil.curry(legendSelectActionHandler, 'inverseSelect'));
	/**
	 * @event legendSelect
	 * @type {Object}
	 * @property {string} type 'legendSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
	/**
	 * @event legendUnSelect
	 * @type {Object}
	 * @property {string} type 'legendUnSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (legendModels && legendModels.length) {
	    ecModel.filterSeries(function (series) {
	      // If in any legend component the status is not selected.
	      // Because in legend series is assumed selected when it is not in the legend data.
	      for (var i = 0; i < legendModels.length; i++) {
	        if (!legendModels[i].isSelected(series.name)) {
	          return false;
	        }
	      }
	
	      return true;
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @event legendScroll
	 * @type {Object}
	 * @property {string} type 'legendScroll'
	 * @property {string} scrollDataIndex
	 */
	echarts.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
	  var scrollDataIndex = payload.scrollDataIndex;
	  scrollDataIndex != null && ecModel.eachComponent({
	    mainType: 'legend',
	    subType: 'scroll',
	    query: payload
	  }, function (legendModel) {
	    legendModel.setScrollDataIndex(scrollDataIndex);
	  });
	});

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1771);
	
	__webpack_require__(1772);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markArea component is enabled
	  opt.markArea = opt.markArea || {};
	});

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1773);
	
	__webpack_require__(1774);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markLine component is enabled
	  opt.markLine = opt.markLine || {};
	});

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1775);
	
	__webpack_require__(1776);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// HINT Markpoint can't be used too much
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markPoint component is enabled
	  opt.markPoint = opt.markPoint || {};
	});

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(423);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markArea',
	  defaultOption: {
	    zlevel: 0,
	    // PENDING
	    z: 1,
	    tooltip: {
	      trigger: 'item'
	    },
	    // markArea should fixed on the coordinate system
	    animation: false,
	    label: {
	      show: true,
	      position: 'top'
	    },
	    itemStyle: {
	      // color and borderColor default to use color from series
	      // color: 'auto'
	      // borderColor: 'auto'
	      borderWidth: 0
	    },
	    emphasis: {
	      label: {
	        show: true,
	        position: 'top'
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var colorUtil = __webpack_require__(105);
	
	var List = __webpack_require__(88);
	
	var numberUtil = __webpack_require__(24);
	
	var graphic = __webpack_require__(17);
	
	var markerHelper = __webpack_require__(425);
	
	var MarkerView = __webpack_require__(424);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Better on polar
	var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
	  var lt = markerHelper.dataTransform(seriesModel, item[0]);
	  var rb = markerHelper.dataTransform(seriesModel, item[1]);
	  var retrieve = zrUtil.retrieve; // FIXME make sure lt is less than rb
	
	  var ltCoord = lt.coord;
	  var rbCoord = rb.coord;
	  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
	  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
	  rbCoord[0] = retrieve(rbCoord[0], Infinity);
	  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one
	
	  var result = zrUtil.mergeAll([{}, lt, rb]);
	  result.coord = [lt.coord, rb.coord];
	  result.x0 = lt.x;
	  result.y0 = lt.y;
	  result.x1 = rb.x;
	  result.y1 = rb.y;
	  return result;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markArea has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
	}
	
	function markAreaFilter(coordSys, item) {
	  var fromCoord = item.coord[0];
	  var toCoord = item.coord[1];
	
	  if (coordSys.type === 'cartesian2d') {
	    // In case
	    // {
	    //  markArea: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, {
	    coord: fromCoord,
	    x: item.x0,
	    y: item.y0
	  }) || markerHelper.dataFilter(coordSys, {
	    coord: toCoord,
	    x: item.x1,
	    y: item.y1
	  });
	} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
	
	
	function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get(dims[0]), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get(dims[1]), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
	    } else {
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      var pt = [x, y];
	      coordSys.clampData && coordSys.clampData(pt, pt);
	      point = coordSys.dataToPoint(pt, true);
	    }
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	
	      if (isInifinity(x)) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
	      } else if (isInifinity(y)) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  return point;
	}
	
	var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
	MarkerView.extend({
	  type: 'markArea',
	  // updateLayout: function (markAreaModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var maModel = seriesModel.markAreaModel;
	  //         if (maModel) {
	  //             var areaData = maModel.getData();
	  //             areaData.each(function (idx) {
	  //                 var points = zrUtil.map(dimPermutations, function (dim) {
	  //                     return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	  //                 });
	  //                 // Layout
	  //                 areaData.setItemLayout(idx, points);
	  //                 var el = areaData.getItemGraphicEl(idx);
	  //                 el.setShape('points', points);
	  //             });
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markAreaModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var maModel = seriesModel.markAreaModel;
	
	      if (maModel) {
	        var areaData = maModel.getData();
	        areaData.each(function (idx) {
	          var points = zrUtil.map(dimPermutations, function (dim) {
	            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	          }); // Layout
	
	          areaData.setItemLayout(idx, points);
	          var el = areaData.getItemGraphicEl(idx);
	          el.setShape('points', points);
	        });
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, maModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var areaGroupMap = this.markerGroupMap;
	    var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
	      group: new graphic.Group()
	    });
	    this.group.add(polygonGroup.group);
	    polygonGroup.__keep = true;
	    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
	
	    maModel.setData(areaData); // Update visual and layout of line
	
	    areaData.each(function (idx) {
	      // Layout
	      var points = zrUtil.map(dimPermutations, function (dim) {
	        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	      }); // If none of the area is inside coordSys, allClipped is set to be true
	      // in layout so that label will not be displayed. See #12591
	
	      var allClipped = true;
	      zrUtil.each(dimPermutations, function (dim) {
	        if (!allClipped) {
	          return;
	        }
	
	        var xValue = areaData.get(dim[0], idx);
	        var yValue = areaData.get(dim[1], idx); // If is infinity, the axis should be considered not clipped
	
	        if ((isInifinity(xValue) || coordSys.getAxis('x').containData(xValue)) && (isInifinity(yValue) || coordSys.getAxis('y').containData(yValue))) {
	          allClipped = false;
	        }
	      });
	      areaData.setItemLayout(idx, {
	        points: points,
	        allClipped: allClipped
	      }); // Visual
	
	      areaData.setItemVisual(idx, {
	        color: seriesData.getVisual('color')
	      });
	    });
	    areaData.diff(polygonGroup.__data).add(function (idx) {
	      var layout = areaData.getItemLayout(idx);
	
	      if (!layout.allClipped) {
	        var polygon = new graphic.Polygon({
	          shape: {
	            points: layout.points
	          }
	        });
	        areaData.setItemGraphicEl(idx, polygon);
	        polygonGroup.group.add(polygon);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);
	
	      var layout = areaData.getItemLayout(newIdx);
	
	      if (!layout.allClipped) {
	        if (polygon) {
	          graphic.updateProps(polygon, {
	            shape: {
	              points: layout.points
	            }
	          }, maModel, newIdx);
	        } else {
	          polygon = new graphic.Polygon({
	            shape: {
	              points: layout.points
	            }
	          });
	        }
	
	        areaData.setItemGraphicEl(newIdx, polygon);
	        polygonGroup.group.add(polygon);
	      } else if (polygon) {
	        polygonGroup.group.remove(polygon);
	      }
	    }).remove(function (idx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(idx);
	
	      polygonGroup.group.remove(polygon);
	    }).execute();
	    areaData.eachItemGraphicEl(function (polygon, idx) {
	      var itemModel = areaData.getItemModel(idx);
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var color = areaData.getItemVisual(idx, 'color');
	      polygon.useStyle(zrUtil.defaults(itemModel.getModel('itemStyle').getItemStyle(), {
	        fill: colorUtil.modifyAlpha(color, 0.4),
	        stroke: color
	      }));
	      polygon.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: maModel,
	        labelDataIndex: idx,
	        defaultText: areaData.getName(idx) || '',
	        isRectText: true,
	        autoColor: color
	      });
	      graphic.setHoverStyle(polygon, {});
	      polygon.dataModel = maModel;
	    });
	    polygonGroup.__data = areaData;
	    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	function createList(coordSys, seriesModel, maModel) {
	  var coordDimsInfos;
	  var areaData;
	  var dims = ['x0', 'y0', 'x1', 'y1'];
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var data = seriesModel.getData();
	      var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	    areaData = new List(zrUtil.map(dims, function (dim, idx) {
	      return {
	        name: dim,
	        type: coordDimsInfos[idx % 2].type
	      };
	    }), maModel);
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	    areaData = new List(coordDimsInfos, maModel);
	  }
	
	  var optData = zrUtil.map(maModel.get('data'), zrUtil.curry(markAreaTransform, seriesModel, coordSys, maModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markAreaFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
	    return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
	  } : function (item) {
	    return item.value;
	  };
	  areaData.initData(optData, null, dimValueGetter);
	  areaData.hasItemOption = true;
	  return areaData;
	}

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(423);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markLine',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: ['circle', 'arrow'],
	    symbolSize: [8, 16],
	    //symbolRotate: 0,
	    precision: 2,
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'end',
	      distance: 5
	    },
	    lineStyle: {
	      type: 'dashed'
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        width: 3
	      }
	    },
	    animationEasing: 'linear'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var List = __webpack_require__(88);
	
	var numberUtil = __webpack_require__(24);
	
	var markerHelper = __webpack_require__(425);
	
	var LineDraw = __webpack_require__(413);
	
	var MarkerView = __webpack_require__(424);
	
	var _dataStackHelper = __webpack_require__(102);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
	  var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average', 'median'
	
	  var mlType = item.type;
	
	  if (!zrUtil.isArray(item) && (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
	  // data: [{
	  //   yAxis: 10
	  // }]
	  || item.xAxis != null || item.yAxis != null)) {
	    var valueAxis;
	    var value;
	
	    if (item.yAxis != null || item.xAxis != null) {
	      valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
	      value = zrUtil.retrieve(item.yAxis, item.xAxis);
	    } else {
	      var axisInfo = markerHelper.getAxisInfo(item, data, coordSys, seriesModel);
	      valueAxis = axisInfo.valueAxis;
	      var valueDataDim = getStackedDimension(data, axisInfo.valueDataDim);
	      value = markerHelper.numCalculate(data, valueDataDim, mlType);
	    }
	
	    var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
	    var baseIndex = 1 - valueIndex;
	    var mlFrom = zrUtil.clone(item);
	    var mlTo = {};
	    mlFrom.type = null;
	    mlFrom.coord = [];
	    mlTo.coord = [];
	    mlFrom.coord[baseIndex] = -Infinity;
	    mlTo.coord[baseIndex] = Infinity;
	    var precision = mlModel.get('precision');
	
	    if (precision >= 0 && typeof value === 'number') {
	      value = +value.toFixed(Math.min(precision, 20));
	    }
	
	    mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
	    item = [mlFrom, mlTo, {
	      // Extra option for tooltip and label
	      type: mlType,
	      valueIndex: item.valueIndex,
	      // Force to use the value of calculated value.
	      value: value
	    }];
	  }
	
	  item = [markerHelper.dataTransform(seriesModel, item[0]), markerHelper.dataTransform(seriesModel, item[1]), zrUtil.extend({}, item[2])]; // Avoid line data type is extended by from(to) data type
	
	  item[2].type = item[2].type || ''; // Merge from option and to option into line option
	
	  zrUtil.merge(item[2], item[0]);
	  zrUtil.merge(item[2], item[1]);
	  return item;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markLine has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  var dimName = coordSys.dimensions[dimIndex];
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
	}
	
	function markLineFilter(coordSys, item) {
	  if (coordSys.type === 'cartesian2d') {
	    var fromCoord = item[0].coord;
	    var toCoord = item[1].coord; // In case
	    // {
	    //  markLine: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, item[0]) && markerHelper.dataFilter(coordSys, item[1]);
	}
	
	function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
	    } else {
	      var dims = coordSys.dimensions;
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      point = coordSys.dataToPoint([x, y]);
	    } // Expand line to the edge of grid if value on one axis is Inifnity
	    // In case
	    //  markLine: {
	    //    data: [{
	    //      yAxis: 2
	    //      // or
	    //      type: 'average'
	    //    }]
	    //  }
	
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var dims = coordSys.dimensions;
	
	      if (isInifinity(data.get(dims[0], idx))) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
	      } else if (isInifinity(data.get(dims[1], idx))) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  data.setItemLayout(idx, point);
	}
	
	var _default = MarkerView.extend({
	  type: 'markLine',
	  // updateLayout: function (markLineModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mlModel = seriesModel.markLineModel;
	  //         if (mlModel) {
	  //             var mlData = mlModel.getData();
	  //             var fromData = mlModel.__from;
	  //             var toData = mlModel.__to;
	  //             // Update visual and layout of from symbol and to symbol
	  //             fromData.each(function (idx) {
	  //                 updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	  //                 updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	  //             });
	  //             // Update layout of line
	  //             mlData.each(function (idx) {
	  //                 mlData.setItemLayout(idx, [
	  //                     fromData.getItemLayout(idx),
	  //                     toData.getItemLayout(idx)
	  //                 ]);
	  //             });
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout();
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markLineModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mlModel = seriesModel.markLineModel;
	
	      if (mlModel) {
	        var mlData = mlModel.getData();
	        var fromData = mlModel.__from;
	        var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol
	
	        fromData.each(function (idx) {
	          updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	          updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	        }); // Update layout of line
	
	        mlData.each(function (idx) {
	          mlData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	        });
	        this.markerGroupMap.get(seriesModel.id).updateLayout();
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mlModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var lineDrawMap = this.markerGroupMap;
	    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
	    this.group.add(lineDraw.group);
	    var mlData = createList(coordSys, seriesModel, mlModel);
	    var fromData = mlData.from;
	    var toData = mlData.to;
	    var lineData = mlData.line;
	    mlModel.__from = fromData;
	    mlModel.__to = toData; // Line data for tooltip and formatter
	
	    mlModel.setData(lineData);
	    var symbolType = mlModel.get('symbol');
	    var symbolSize = mlModel.get('symbolSize');
	
	    if (!zrUtil.isArray(symbolType)) {
	      symbolType = [symbolType, symbolType];
	    }
	
	    if (typeof symbolSize === 'number') {
	      symbolSize = [symbolSize, symbolSize];
	    } // Update visual and layout of from symbol and to symbol
	
	
	    mlData.from.each(function (idx) {
	      updateDataVisualAndLayout(fromData, idx, true);
	      updateDataVisualAndLayout(toData, idx, false);
	    }); // Update visual and layout of line
	
	    lineData.each(function (idx) {
	      var lineColor = lineData.getItemModel(idx).get('lineStyle.color');
	      lineData.setItemVisual(idx, {
	        color: lineColor || fromData.getItemVisual(idx, 'color')
	      });
	      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	      lineData.setItemVisual(idx, {
	        'fromSymbolRotate': fromData.getItemVisual(idx, 'symbolRotate'),
	        'fromSymbolSize': fromData.getItemVisual(idx, 'symbolSize'),
	        'fromSymbol': fromData.getItemVisual(idx, 'symbol'),
	        'toSymbolRotate': toData.getItemVisual(idx, 'symbolRotate'),
	        'toSymbolSize': toData.getItemVisual(idx, 'symbolSize'),
	        'toSymbol': toData.getItemVisual(idx, 'symbol')
	      });
	    });
	    lineDraw.updateData(lineData); // Set host model for tooltip
	    // FIXME
	
	    mlData.line.eachItemGraphicEl(function (el, idx) {
	      el.traverse(function (child) {
	        child.dataModel = mlModel;
	      });
	    });
	
	    function updateDataVisualAndLayout(data, idx, isFrom) {
	      var itemModel = data.getItemModel(idx);
	      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
	      data.setItemVisual(idx, {
	        symbolRotate: itemModel.get('symbolRotate'),
	        symbolSize: itemModel.get('symbolSize') || symbolSize[isFrom ? 0 : 1],
	        symbol: itemModel.get('symbol', true) || symbolType[isFrom ? 0 : 1],
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }
	
	    lineDraw.__keep = true;
	    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mlModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var fromData = new List(coordDimsInfos, mlModel);
	  var toData = new List(coordDimsInfos, mlModel); // No dimensions
	
	  var lineData = new List([], mlModel);
	  var optData = zrUtil.map(mlModel.get('data'), zrUtil.curry(markLineTransform, seriesModel, coordSys, mlModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markLineFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  };
	  fromData.initData(zrUtil.map(optData, function (item) {
	    return item[0];
	  }), null, dimValueGetter);
	  toData.initData(zrUtil.map(optData, function (item) {
	    return item[1];
	  }), null, dimValueGetter);
	  lineData.initData(zrUtil.map(optData, function (item) {
	    return item[2];
	  }));
	  lineData.hasItemOption = true;
	  return {
	    from: fromData,
	    to: toData,
	    line: lineData
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(423);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markPoint',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: 'pin',
	    symbolSize: 50,
	    //symbolRotate: 0,
	    //symbolOffset: [0, 0]
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'inside'
	    },
	    itemStyle: {
	      borderWidth: 2
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var SymbolDraw = __webpack_require__(214);
	
	var numberUtil = __webpack_require__(24);
	
	var List = __webpack_require__(88);
	
	var markerHelper = __webpack_require__(425);
	
	var MarkerView = __webpack_require__(424);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function updateMarkerLayout(mpData, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  mpData.each(function (idx) {
	    var itemModel = mpData.getItemModel(idx);
	    var point;
	    var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	    var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	    if (!isNaN(xPx) && !isNaN(yPx)) {
	      point = [xPx, yPx];
	    } // Chart like bar may have there own marker positioning logic
	    else if (seriesModel.getMarkerPosition) {
	        // Use the getMarkerPoisition
	        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
	      } else if (coordSys) {
	        var x = mpData.get(coordSys.dimensions[0], idx);
	        var y = mpData.get(coordSys.dimensions[1], idx);
	        point = coordSys.dataToPoint([x, y]);
	      } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	
	    mpData.setItemLayout(idx, point);
	  });
	}
	
	var _default = MarkerView.extend({
	  type: 'markPoint',
	  // updateLayout: function (markPointModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mpModel = seriesModel.markPointModel;
	  //         if (mpModel) {
	  //             updateMarkerLayout(mpModel.getData(), seriesModel, api);
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markPointModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mpModel = seriesModel.markPointModel;
	
	      if (mpModel) {
	        updateMarkerLayout(mpModel.getData(), seriesModel, api);
	        this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mpModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var symbolDrawMap = this.markerGroupMap;
	    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
	    var mpData = createList(coordSys, seriesModel, mpModel); // FIXME
	
	    mpModel.setData(mpData);
	    updateMarkerLayout(mpModel.getData(), seriesModel, api);
	    mpData.each(function (idx) {
	      var itemModel = mpData.getItemModel(idx);
	      var symbol = itemModel.getShallow('symbol');
	      var symbolSize = itemModel.getShallow('symbolSize');
	      var symbolRotate = itemModel.getShallow('symbolRotate');
	      var isFnSymbol = zrUtil.isFunction(symbol);
	      var isFnSymbolSize = zrUtil.isFunction(symbolSize);
	      var isFnSymbolRotate = zrUtil.isFunction(symbolRotate);
	
	      if (isFnSymbol || isFnSymbolSize || isFnSymbolRotate) {
	        var rawIdx = mpModel.getRawValue(idx);
	        var dataParams = mpModel.getDataParams(idx);
	
	        if (isFnSymbol) {
	          symbol = symbol(rawIdx, dataParams);
	        }
	
	        if (isFnSymbolSize) {
	          // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
	          symbolSize = symbolSize(rawIdx, dataParams);
	        }
	
	        if (isFnSymbolRotate) {
	          symbolRotate = symbolRotate(rawIdx, dataParams);
	        }
	      }
	
	      mpData.setItemVisual(idx, {
	        symbol: symbol,
	        symbolSize: symbolSize,
	        symbolRotate: symbolRotate,
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }); // TODO Text are wrong
	
	    symbolDraw.updateData(mpData);
	    this.group.add(symbolDraw.group); // Set host model for tooltip
	    // FIXME
	
	    mpData.eachItemGraphicEl(function (el) {
	      el.traverse(function (child) {
	        child.dataModel = mpModel;
	      });
	    });
	    symbolDraw.__keep = true;
	    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} [coordSys]
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mpModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var mpData = new List(coordDimsInfos, mpModel);
	  var dataOpt = zrUtil.map(mpModel.get('data'), zrUtil.curry(markerHelper.dataTransform, seriesModel));
	
	  if (coordSys) {
	    dataOpt = zrUtil.filter(dataOpt, zrUtil.curry(markerHelper.dataFilter, coordSys));
	  }
	
	  mpData.initData(dataOpt, null, coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  });
	  return mpData;
	}
	
	module.exports = _default;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(846);
	
	__webpack_require__(1739);
	
	__webpack_require__(1736);

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var barPolar = __webpack_require__(1850);
	
	__webpack_require__(430);
	
	__webpack_require__(1727);
	
	__webpack_require__(1781);
	
	__webpack_require__(216);
	
	__webpack_require__(1731);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// For reducing size of echarts.min, barLayoutPolar is required by polar.
	echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view
	
	echarts.extendComponentView({
	  type: 'polar'
	});

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1841);
	
	__webpack_require__(1842);
	
	__webpack_require__(1780);

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var AxisBuilder = __webpack_require__(127);
	
	var graphic = __webpack_require__(17);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	
	var _default = echarts.extendComponentView({
	  type: 'radar',
	  render: function (radarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	
	    this._buildAxes(radarModel);
	
	    this._buildSplitLineAndArea(radarModel);
	  },
	  _buildAxes: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	    var axisBuilders = zrUtil.map(indicatorAxes, function (indicatorAxis) {
	      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
	        position: [radar.cx, radar.cy],
	        rotation: indicatorAxis.angle,
	        labelDirection: -1,
	        tickDirection: -1,
	        nameDirection: 1
	      });
	      return axisBuilder;
	    });
	    zrUtil.each(axisBuilders, function (axisBuilder) {
	      zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	      this.group.add(axisBuilder.getGroup());
	    }, this);
	  },
	  _buildSplitLineAndArea: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	
	    if (!indicatorAxes.length) {
	      return;
	    }
	
	    var shape = radarModel.get('shape');
	    var splitLineModel = radarModel.getModel('splitLine');
	    var splitAreaModel = radarModel.getModel('splitArea');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var showSplitLine = splitLineModel.get('show');
	    var showSplitArea = splitAreaModel.get('show');
	    var splitLineColors = lineStyleModel.get('color');
	    var splitAreaColors = areaStyleModel.get('color');
	    splitLineColors = zrUtil.isArray(splitLineColors) ? splitLineColors : [splitLineColors];
	    splitAreaColors = zrUtil.isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
	    var splitLines = [];
	    var splitAreas = [];
	
	    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
	      var colorIndex = idx % areaOrLineColorList.length;
	      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
	      return colorIndex;
	    }
	
	    if (shape === 'circle') {
	      var ticksRadius = indicatorAxes[0].getTicksCoords();
	      var cx = radar.cx;
	      var cy = radar.cy;
	
	      for (var i = 0; i < ticksRadius.length; i++) {
	        if (showSplitLine) {
	          var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	          splitLines[colorIndex].push(new graphic.Circle({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r: ticksRadius[i].coord
	            }
	          }));
	        }
	
	        if (showSplitArea && i < ticksRadius.length - 1) {
	          var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
	          splitAreas[colorIndex].push(new graphic.Ring({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r0: ticksRadius[i].coord,
	              r: ticksRadius[i + 1].coord
	            }
	          }));
	        }
	      }
	    } // Polyyon
	    else {
	        var realSplitNumber;
	        var axesTicksPoints = zrUtil.map(indicatorAxes, function (indicatorAxis, idx) {
	          var ticksCoords = indicatorAxis.getTicksCoords();
	          realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
	          return zrUtil.map(ticksCoords, function (tickCoord) {
	            return radar.coordToPoint(tickCoord.coord, idx);
	          });
	        });
	        var prevPoints = [];
	
	        for (var i = 0; i <= realSplitNumber; i++) {
	          var points = [];
	
	          for (var j = 0; j < indicatorAxes.length; j++) {
	            points.push(axesTicksPoints[j][i]);
	          } // Close
	
	
	          if (points[0]) {
	            points.push(points[0].slice());
	          } else {}
	
	          if (showSplitLine) {
	            var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	            splitLines[colorIndex].push(new graphic.Polyline({
	              shape: {
	                points: points
	              }
	            }));
	          }
	
	          if (showSplitArea && prevPoints) {
	            var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
	            splitAreas[colorIndex].push(new graphic.Polygon({
	              shape: {
	                points: points.concat(prevPoints)
	              }
	            }));
	          }
	
	          prevPoints = points.slice().reverse();
	        }
	      }
	
	    var lineStyle = lineStyleModel.getLineStyle();
	    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine
	
	    zrUtil.each(splitAreas, function (splitAreas, idx) {
	      this.group.add(graphic.mergePath(splitAreas, {
	        style: zrUtil.defaults({
	          stroke: 'none',
	          fill: splitAreaColors[idx % splitAreaColors.length]
	        }, areaStyle),
	        silent: true
	      }));
	    }, this);
	    zrUtil.each(splitLines, function (splitLines, idx) {
	      this.group.add(graphic.mergePath(splitLines, {
	        style: zrUtil.defaults({
	          fill: 'none',
	          stroke: splitLineColors[idx % splitLineColors.length]
	        }, lineStyle),
	        silent: true
	      }));
	    }, this);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(430);
	
	__webpack_require__(1737);

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var preprocessor = __webpack_require__(1788);
	
	__webpack_require__(1790);
	
	__webpack_require__(1789);
	
	__webpack_require__(1783);
	
	__webpack_require__(1784);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var TimelineModel = __webpack_require__(1786);
	
	var dataFormatMixin = __webpack_require__(432);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderTimelineModel = TimelineModel.extend({
	  type: 'timeline.slider',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 时间轴背景颜色
	    borderColor: '#ccc',
	    // 时间轴边框颜色
	    borderWidth: 0,
	    // 时间轴边框线宽，单位px，默认为0（无边框）
	    orient: 'horizontal',
	    // 'vertical'
	    inverse: false,
	    tooltip: {
	      // boolean or Object
	      trigger: 'item' // data item may also have tootip attr.
	
	    },
	    symbol: 'emptyCircle',
	    symbolSize: 10,
	    lineStyle: {
	      show: true,
	      width: 2,
	      color: '#304654'
	    },
	    label: {
	      // 文本标签
	      position: 'auto',
	      // auto left right top bottom
	      // When using number, label position is not
	      // restricted by viewRect.
	      // positive: right/bottom, negative: left/top
	      show: true,
	      interval: 'auto',
	      rotate: 0,
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#304654'
	    },
	    itemStyle: {
	      color: '#304654',
	      borderWidth: 1
	    },
	    checkpointStyle: {
	      symbol: 'circle',
	      symbolSize: 13,
	      color: '#c23531',
	      borderWidth: 5,
	      borderColor: 'rgba(194,53,49, 0.5)',
	      animation: true,
	      animationDuration: 300,
	      animationEasing: 'quinticInOut'
	    },
	    controlStyle: {
	      show: true,
	      showPlayBtn: true,
	      showPrevBtn: true,
	      showNextBtn: true,
	      itemSize: 22,
	      itemGap: 12,
	      position: 'left',
	      // 'left' 'right' 'top' 'bottom'
	      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
	      // jshint ignore:line
	      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	      // jshint ignore:line
	      nextIcon: 'path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z',
	      // jshint ignore:line
	      prevIcon: 'path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z',
	      // jshint ignore:line
	      color: '#304654',
	      borderColor: '#304654',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true,
	        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	        color: '#c23531'
	      },
	      itemStyle: {
	        color: '#c23531'
	      },
	      controlStyle: {
	        color: '#c23531',
	        borderColor: '#c23531',
	        borderWidth: 2
	      }
	    },
	    data: []
	  }
	});
	zrUtil.mixin(SliderTimelineModel, dataFormatMixin);
	var _default = SliderTimelineModel;
	module.exports = _default;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var BoundingRect = __webpack_require__(51);
	
	var matrix = __webpack_require__(75);
	
	var graphic = __webpack_require__(17);
	
	var layout = __webpack_require__(47);
	
	var TimelineView = __webpack_require__(1787);
	
	var TimelineAxis = __webpack_require__(1785);
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var axisHelper = __webpack_require__(96);
	
	var numberUtil = __webpack_require__(24);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var PI = Math.PI;
	
	var _default = TimelineView.extend({
	  type: 'timeline.slider',
	  init: function (ecModel, api) {
	    this.api = api;
	    /**
	     * @private
	     * @type {module:echarts/component/timeline/TimelineAxis}
	     */
	
	    this._axis;
	    /**
	     * @private
	     * @type {module:zrender/core/BoundingRect}
	     */
	
	    this._viewRect;
	    /**
	     * @type {number}
	     */
	
	    this._timer;
	    /**
	     * @type {module:zrender/Element}
	     */
	
	    this._currentPointer;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._labelGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (timelineModel, ecModel, api, payload) {
	    this.model = timelineModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    this.group.removeAll();
	
	    if (timelineModel.get('show', true)) {
	      var layoutInfo = this._layout(timelineModel, api);
	
	      var mainGroup = this._createGroup('mainGroup');
	
	      var labelGroup = this._createGroup('labelGroup');
	      /**
	       * @private
	       * @type {module:echarts/component/timeline/TimelineAxis}
	       */
	
	
	      var axis = this._axis = this._createAxis(layoutInfo, timelineModel);
	
	      timelineModel.formatTooltip = function (dataIndex) {
	        return encodeHTML(axis.scale.getLabel(dataIndex));
	      };
	
	      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
	        this['_render' + name](layoutInfo, mainGroup, axis, timelineModel);
	      }, this);
	
	      this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);
	
	      this._position(layoutInfo, timelineModel);
	    }
	
	    this._doPlayStop();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearTimer();
	
	    this.group.removeAll();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearTimer();
	  },
	  _layout: function (timelineModel, api) {
	    var labelPosOpt = timelineModel.get('label.position');
	    var orient = timelineModel.get('orient');
	    var viewRect = getViewRect(timelineModel, api); // Auto label offset.
	
	    if (labelPosOpt == null || labelPosOpt === 'auto') {
	      labelPosOpt = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
	    } else if (isNaN(labelPosOpt)) {
	      labelPosOpt = {
	        horizontal: {
	          top: '-',
	          bottom: '+'
	        },
	        vertical: {
	          left: '-',
	          right: '+'
	        }
	      }[orient][labelPosOpt];
	    }
	
	    var labelAlignMap = {
	      horizontal: 'center',
	      vertical: labelPosOpt >= 0 || labelPosOpt === '+' ? 'left' : 'right'
	    };
	    var labelBaselineMap = {
	      horizontal: labelPosOpt >= 0 || labelPosOpt === '+' ? 'top' : 'bottom',
	      vertical: 'middle'
	    };
	    var rotationMap = {
	      horizontal: 0,
	      vertical: PI / 2
	    }; // Position
	
	    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
	    var controlModel = timelineModel.getModel('controlStyle');
	    var showControl = controlModel.get('show', true);
	    var controlSize = showControl ? controlModel.get('itemSize') : 0;
	    var controlGap = showControl ? controlModel.get('itemGap') : 0;
	    var sizePlusGap = controlSize + controlGap; // Special label rotate.
	
	    var labelRotation = timelineModel.get('label.rotate') || 0;
	    labelRotation = labelRotation * PI / 180; // To radian.
	
	    var playPosition;
	    var prevBtnPosition;
	    var nextBtnPosition;
	    var axisExtent;
	    var controlPosition = controlModel.get('position', true);
	    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
	    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
	    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
	    var xLeft = 0;
	    var xRight = mainLength; // position[0] means left, position[1] means middle.
	
	    if (controlPosition === 'left' || controlPosition === 'bottom') {
	      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    } else {
	      // 'top' 'right'
	      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    }
	
	    axisExtent = [xLeft, xRight];
	
	    if (timelineModel.get('inverse')) {
	      axisExtent.reverse();
	    }
	
	    return {
	      viewRect: viewRect,
	      mainLength: mainLength,
	      orient: orient,
	      rotation: rotationMap[orient],
	      labelRotation: labelRotation,
	      labelPosOpt: labelPosOpt,
	      labelAlign: timelineModel.get('label.align') || labelAlignMap[orient],
	      labelBaseline: timelineModel.get('label.verticalAlign') || timelineModel.get('label.baseline') || labelBaselineMap[orient],
	      // Based on mainGroup.
	      playPosition: playPosition,
	      prevBtnPosition: prevBtnPosition,
	      nextBtnPosition: nextBtnPosition,
	      axisExtent: axisExtent,
	      controlSize: controlSize,
	      controlGap: controlGap
	    };
	  },
	  _position: function (layoutInfo, timelineModel) {
	    // Position is be called finally, because bounding rect is needed for
	    // adapt content to fill viewRect (auto adapt offset).
	    // Timeline may be not all in the viewRect when 'offset' is specified
	    // as a number, because it is more appropriate that label aligns at
	    // 'offset' but not the other edge defined by viewRect.
	    var mainGroup = this._mainGroup;
	    var labelGroup = this._labelGroup;
	    var viewRect = layoutInfo.viewRect;
	
	    if (layoutInfo.orient === 'vertical') {
	      // transform to horizontal, inverse rotate by left-top point.
	      var m = matrix.create();
	      var rotateOriginX = viewRect.x;
	      var rotateOriginY = viewRect.y + viewRect.height;
	      matrix.translate(m, m, [-rotateOriginX, -rotateOriginY]);
	      matrix.rotate(m, m, -PI / 2);
	      matrix.translate(m, m, [rotateOriginX, rotateOriginY]);
	      viewRect = viewRect.clone();
	      viewRect.applyTransform(m);
	    }
	
	    var viewBound = getBound(viewRect);
	    var mainBound = getBound(mainGroup.getBoundingRect());
	    var labelBound = getBound(labelGroup.getBoundingRect());
	    var mainPosition = mainGroup.position;
	    var labelsPosition = labelGroup.position;
	    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
	    var labelPosOpt = layoutInfo.labelPosOpt;
	
	    if (isNaN(labelPosOpt)) {
	      // '+' or '-'
	      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
	    } else {
	      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      labelsPosition[1] = mainPosition[1] + labelPosOpt;
	    }
	
	    mainGroup.attr('position', mainPosition);
	    labelGroup.attr('position', labelsPosition);
	    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
	    setOrigin(mainGroup);
	    setOrigin(labelGroup);
	
	    function setOrigin(targetGroup) {
	      var pos = targetGroup.position;
	      targetGroup.origin = [viewBound[0][0] - pos[0], viewBound[1][0] - pos[1]];
	    }
	
	    function getBound(rect) {
	      // [[xmin, xmax], [ymin, ymax]]
	      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
	    }
	
	    function toBound(fromPos, from, to, dimIdx, boundIdx) {
	      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
	    }
	  },
	  _createAxis: function (layoutInfo, timelineModel) {
	    var data = timelineModel.getData();
	    var axisType = timelineModel.get('axisType');
	    var scale = axisHelper.createScaleByModel(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.
	
	    scale.getTicks = function () {
	      return data.mapArray(['value'], function (value) {
	        return value;
	      });
	    };
	
	    var dataExtent = data.getDataExtent('value');
	    scale.setExtent(dataExtent[0], dataExtent[1]);
	    scale.niceTicks();
	    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
	    axis.model = timelineModel;
	    return axis;
	  },
	  _createGroup: function (name) {
	    var newGroup = this['_' + name] = new graphic.Group();
	    this.group.add(newGroup);
	    return newGroup;
	  },
	  _renderAxisLine: function (layoutInfo, group, axis, timelineModel) {
	    var axisExtent = axis.getExtent();
	
	    if (!timelineModel.get('lineStyle.show')) {
	      return;
	    }
	
	    group.add(new graphic.Line({
	      shape: {
	        x1: axisExtent[0],
	        y1: 0,
	        x2: axisExtent[1],
	        y2: 0
	      },
	      style: zrUtil.extend({
	        lineCap: 'round'
	      }, timelineModel.getModel('lineStyle').getLineStyle()),
	      silent: true,
	      z2: 1
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisTick: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.
	
	    var ticks = axis.scale.getTicks(); // The value is dataIndex, see the costomized scale.
	
	    each(ticks, function (value) {
	      var tickCoord = axis.dataToCoord(value);
	      var itemModel = data.getItemModel(value);
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      var hoverStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var symbolOpt = {
	        position: [tickCoord, 0],
	        onclick: bind(this._changeTimeline, this, value)
	      };
	      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
	      graphic.setHoverStyle(el, hoverStyleModel.getItemStyle());
	
	      if (itemModel.get('tooltip')) {
	        el.dataIndex = value;
	        el.dataModel = timelineModel;
	      } else {
	        el.dataIndex = el.dataModel = null;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisLabel: function (layoutInfo, group, axis, timelineModel) {
	    var labelModel = axis.getLabelModel();
	
	    if (!labelModel.get('show')) {
	      return;
	    }
	
	    var data = timelineModel.getData();
	    var labels = axis.getViewLabels();
	    each(labels, function (labelItem) {
	      // The tickValue is dataIndex, see the costomized scale.
	      var dataIndex = labelItem.tickValue;
	      var itemModel = data.getItemModel(dataIndex);
	      var normalLabelModel = itemModel.getModel('label');
	      var hoverLabelModel = itemModel.getModel('emphasis.label');
	      var tickCoord = axis.dataToCoord(labelItem.tickValue);
	      var textEl = new graphic.Text({
	        position: [tickCoord, 0],
	        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
	        onclick: bind(this._changeTimeline, this, dataIndex),
	        silent: false
	      });
	      graphic.setTextStyle(textEl.style, normalLabelModel, {
	        text: labelItem.formattedLabel,
	        textAlign: layoutInfo.labelAlign,
	        textVerticalAlign: layoutInfo.labelBaseline
	      });
	      group.add(textEl);
	      graphic.setHoverStyle(textEl, graphic.setTextStyle({}, hoverLabelModel));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderControl: function (layoutInfo, group, axis, timelineModel) {
	    var controlSize = layoutInfo.controlSize;
	    var rotation = layoutInfo.rotation;
	    var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
	    var hoverStyle = timelineModel.getModel('emphasis.controlStyle').getItemStyle();
	    var rect = [0, -controlSize / 2, controlSize, controlSize];
	    var playState = timelineModel.getPlayState();
	    var inverse = timelineModel.get('inverse', true);
	    makeBtn(layoutInfo.nextBtnPosition, 'controlStyle.nextIcon', bind(this._changeTimeline, this, inverse ? '-' : '+'));
	    makeBtn(layoutInfo.prevBtnPosition, 'controlStyle.prevIcon', bind(this._changeTimeline, this, inverse ? '+' : '-'));
	    makeBtn(layoutInfo.playPosition, 'controlStyle.' + (playState ? 'stopIcon' : 'playIcon'), bind(this._handlePlayClick, this, !playState), true);
	
	    function makeBtn(position, iconPath, onclick, willRotate) {
	      if (!position) {
	        return;
	      }
	
	      var opt = {
	        position: position,
	        origin: [controlSize / 2, 0],
	        rotation: willRotate ? -rotation : 0,
	        rectHover: true,
	        style: itemStyle,
	        onclick: onclick
	      };
	      var btn = makeIcon(timelineModel, iconPath, rect, opt);
	      group.add(btn);
	      graphic.setHoverStyle(btn, hoverStyle);
	    }
	  },
	  _renderCurrentPointer: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData();
	    var currentIndex = timelineModel.getCurrentIndex();
	    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
	    var me = this;
	    var callback = {
	      onCreate: function (pointer) {
	        pointer.draggable = true;
	        pointer.drift = bind(me._handlePointerDrag, me);
	        pointer.ondragend = bind(me._handlePointerDragend, me);
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
	      },
	      onUpdate: function (pointer) {
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel);
	      }
	    }; // Reuse when exists, for animation and drag.
	
	    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
	  },
	  _handlePlayClick: function (nextState) {
	    this._clearTimer();
	
	    this.api.dispatchAction({
	      type: 'timelinePlayChange',
	      playState: nextState,
	      from: this.uid
	    });
	  },
	  _handlePointerDrag: function (dx, dy, e) {
	    this._clearTimer();
	
	    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
	  },
	  _handlePointerDragend: function (e) {
	    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
	  },
	  _pointerChangeTimeline: function (mousePos, trigger) {
	    var toCoord = this._toAxisCoord(mousePos)[0];
	
	    var axis = this._axis;
	    var axisExtent = numberUtil.asc(axis.getExtent().slice());
	    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
	    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
	    this._currentPointer.position[0] = toCoord;
	
	    this._currentPointer.dirty();
	
	    var targetDataIndex = this._findNearestTick(toCoord);
	
	    var timelineModel = this.model;
	
	    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
	      this._changeTimeline(targetDataIndex);
	    }
	  },
	  _doPlayStop: function () {
	    this._clearTimer();
	
	    if (this.model.getPlayState()) {
	      this._timer = setTimeout(bind(handleFrame, this), this.model.get('playInterval'));
	    }
	
	    function handleFrame() {
	      // Do not cache
	      var timelineModel = this.model;
	
	      this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
	    }
	  },
	  _toAxisCoord: function (vertex) {
	    var trans = this._mainGroup.getLocalTransform();
	
	    return graphic.applyTransform(vertex, trans, true);
	  },
	  _findNearestTick: function (axisCoord) {
	    var data = this.model.getData();
	    var dist = Infinity;
	    var targetDataIndex;
	    var axis = this._axis;
	    data.each(['value'], function (value, dataIndex) {
	      var coord = axis.dataToCoord(value);
	      var d = Math.abs(coord - axisCoord);
	
	      if (d < dist) {
	        dist = d;
	        targetDataIndex = dataIndex;
	      }
	    });
	    return targetDataIndex;
	  },
	  _clearTimer: function () {
	    if (this._timer) {
	      clearTimeout(this._timer);
	      this._timer = null;
	    }
	  },
	  _changeTimeline: function (nextIndex) {
	    var currentIndex = this.model.getCurrentIndex();
	
	    if (nextIndex === '+') {
	      nextIndex = currentIndex + 1;
	    } else if (nextIndex === '-') {
	      nextIndex = currentIndex - 1;
	    }
	
	    this.api.dispatchAction({
	      type: 'timelineChange',
	      currentIndex: nextIndex,
	      from: this.uid
	    });
	  }
	});
	
	function getViewRect(model, api) {
	  return layout.getLayoutRect(model.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  }, model.get('padding'));
	}
	
	function makeIcon(timelineModel, objPath, rect, opts) {
	  var style = opts.style;
	  var icon = graphic.createIcon(timelineModel.get(objPath), opts || {}, new BoundingRect(rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.
	
	  if (style) {
	    icon.setStyle(style);
	  }
	
	  return icon;
	}
	/**
	 * Create symbol or update symbol
	 * opt: basic position and event handlers
	 */
	
	
	function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
	  var color = itemStyleModel.get('color');
	
	  if (!symbol) {
	    var symbolType = hostModel.get('symbol');
	    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
	    symbol.setStyle('strokeNoScale', true);
	    group.add(symbol);
	    callback && callback.onCreate(symbol);
	  } else {
	    symbol.setColor(color);
	    group.add(symbol); // Group may be new, also need to add.
	
	    callback && callback.onUpdate(symbol);
	  } // Style
	
	
	  var itemStyle = itemStyleModel.getItemStyle(['color', 'symbol', 'symbolSize']);
	  symbol.setStyle(itemStyle); // Transform and events.
	
	  opt = zrUtil.merge({
	    rectHover: true,
	    z2: 100
	  }, opt, true);
	  var symbolSize = hostModel.get('symbolSize');
	  symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	  symbolSize[0] /= 2;
	  symbolSize[1] /= 2;
	  opt.scale = symbolSize;
	  var symbolOffset = hostModel.get('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = opt.position = opt.position || [0, 0];
	    pos[0] += numberUtil.parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] += numberUtil.parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = hostModel.get('symbolRotate');
	  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  symbol.attr(opt); // FIXME
	  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
	  // getBoundingRect will return wrong result.
	  // (This is supposed to be resolved in zrender, but it is a little difficult to
	  // leverage performance and auto updateTransform)
	  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
	
	  symbol.updateTransform();
	  return symbol;
	}
	
	function pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
	  if (pointer.dragging) {
	    return;
	  }
	
	  var pointerModel = timelineModel.getModel('checkpointStyle');
	  var toCoord = axis.dataToCoord(timelineModel.getData().get(['value'], dataIndex));
	
	  if (noAnimation || !pointerModel.get('animation', true)) {
	    pointer.attr({
	      position: [toCoord, 0]
	    });
	  } else {
	    pointer.stopAnimation(true);
	    pointer.animateTo({
	      position: [toCoord, 0]
	    }, pointerModel.get('animationDuration', true), pointerModel.get('animationEasing', true));
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Axis = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var TimelineAxis = function (dim, scale, coordExtent, axisType) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis model
	   * @param {module:echarts/component/TimelineModel}
	   */
	
	  this.model = null;
	};
	
	TimelineAxis.prototype = {
	  constructor: TimelineAxis,
	
	  /**
	   * @override
	   */
	  getLabelModel: function () {
	    return this.model.getModel('label');
	  },
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.model.get('orient') === 'horizontal';
	  }
	};
	zrUtil.inherits(TimelineAxis, Axis);
	var _default = TimelineAxis;
	module.exports = _default;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ComponentModel = __webpack_require__(65);
	
	var List = __webpack_require__(88);
	
	var modelUtil = __webpack_require__(27);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TimelineModel = ComponentModel.extend({
	  type: 'timeline',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 4,
	    // 二级层叠
	    show: true,
	    axisType: 'time',
	    // 模式是时间类型，支持 value, category
	    realtime: true,
	    left: '20%',
	    top: null,
	    right: '20%',
	    bottom: 0,
	    width: null,
	    height: 40,
	    padding: 5,
	    controlPosition: 'left',
	    // 'left' 'right' 'top' 'bottom' 'none'
	    autoPlay: false,
	    rewind: false,
	    // 反向播放
	    loop: true,
	    playInterval: 2000,
	    // 播放时间间隔，单位ms
	    currentIndex: 0,
	    itemStyle: {},
	    label: {
	      color: '#000'
	    },
	    data: []
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {module:echarts/data/List}
	     */
	    this._data;
	    /**
	     * @private
	     * @type {Array.<string>}
	     */
	
	    this._names;
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._initData();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    TimelineModel.superApply(this, 'mergeOption', arguments);
	
	    this._initData();
	  },
	
	  /**
	   * @param {number} [currentIndex]
	   */
	  setCurrentIndex: function (currentIndex) {
	    if (currentIndex == null) {
	      currentIndex = this.option.currentIndex;
	    }
	
	    var count = this._data.count();
	
	    if (this.option.loop) {
	      currentIndex = (currentIndex % count + count) % count;
	    } else {
	      currentIndex >= count && (currentIndex = count - 1);
	      currentIndex < 0 && (currentIndex = 0);
	    }
	
	    this.option.currentIndex = currentIndex;
	  },
	
	  /**
	   * @return {number} currentIndex
	   */
	  getCurrentIndex: function () {
	    return this.option.currentIndex;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isIndexMax: function () {
	    return this.getCurrentIndex() >= this._data.count() - 1;
	  },
	
	  /**
	   * @param {boolean} state true: play, false: stop
	   */
	  setPlayState: function (state) {
	    this.option.autoPlay = !!state;
	  },
	
	  /**
	   * @return {boolean} true: play, false: stop
	   */
	  getPlayState: function () {
	    return !!this.option.autoPlay;
	  },
	
	  /**
	   * @private
	   */
	  _initData: function () {
	    var thisOption = this.option;
	    var dataArr = thisOption.data || [];
	    var axisType = thisOption.axisType;
	    var names = this._names = [];
	
	    if (axisType === 'category') {
	      var idxArr = [];
	      zrUtil.each(dataArr, function (item, index) {
	        var value = modelUtil.getDataItemValue(item);
	        var newItem;
	
	        if (zrUtil.isObject(item)) {
	          newItem = zrUtil.clone(item);
	          newItem.value = index;
	        } else {
	          newItem = index;
	        }
	
	        idxArr.push(newItem);
	
	        if (!zrUtil.isString(value) && (value == null || isNaN(value))) {
	          value = '';
	        }
	
	        names.push(value + '');
	      });
	      dataArr = idxArr;
	    }
	
	    var dimType = {
	      category: 'ordinal',
	      time: 'time'
	    }[axisType] || 'number';
	    var data = this._data = new List([{
	      name: 'value',
	      type: dimType
	    }], this);
	    data.initData(dataArr, names);
	  },
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @public
	   * @return {Array.<string>} categoreis
	   */
	  getCategories: function () {
	    if (this.get('axisType') === 'category') {
	      return this._names.slice();
	    }
	  }
	});
	var _default = TimelineModel;
	module.exports = _default;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(275);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'timeline'
	});
	
	module.exports = _default;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  var timelineOpt = option && option.timeline;
	
	  if (!zrUtil.isArray(timelineOpt)) {
	    timelineOpt = timelineOpt ? [timelineOpt] : [];
	  }
	
	  zrUtil.each(timelineOpt, function (opt) {
	    if (!opt) {
	      return;
	    }
	
	    compatibleEC2(opt);
	  });
	}
	
	function compatibleEC2(opt) {
	  var type = opt.type;
	  var ec2Types = {
	    'number': 'value',
	    'time': 'time'
	  }; // Compatible with ec2
	
	  if (ec2Types[type]) {
	    opt.axisType = ec2Types[type];
	    delete opt.type;
	  }
	
	  transferItem(opt);
	
	  if (has(opt, 'controlPosition')) {
	    var controlStyle = opt.controlStyle || (opt.controlStyle = {});
	
	    if (!has(controlStyle, 'position')) {
	      controlStyle.position = opt.controlPosition;
	    }
	
	    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
	      controlStyle.show = false;
	      delete controlStyle.position;
	    }
	
	    delete opt.controlPosition;
	  }
	
	  zrUtil.each(opt.data || [], function (dataItem) {
	    if (zrUtil.isObject(dataItem) && !zrUtil.isArray(dataItem)) {
	      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
	        // In ec2, using name as value.
	        dataItem.value = dataItem.name;
	      }
	
	      transferItem(dataItem);
	    }
	  });
	}
	
	function transferItem(opt) {
	  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
	  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out
	
	  var label = opt.label || opt.label || {};
	  var labelNormal = label.normal || (label.normal = {});
	  var excludeLabelAttr = {
	    normal: 1,
	    emphasis: 1
	  };
	  zrUtil.each(label, function (value, name) {
	    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
	      labelNormal[name] = value;
	    }
	  });
	
	  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
	    label.emphasis = itemStyleEmphasis.label;
	    delete itemStyleEmphasis.label;
	  }
	}
	
	function has(obj, attr) {
	  return obj.hasOwnProperty(attr);
	}
	
	module.exports = _default;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'timelineChange',
	  event: 'timelineChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.currentIndex != null) {
	    timelineModel.setCurrentIndex(payload.currentIndex);
	
	    if (!timelineModel.get('loop', true) && timelineModel.isIndexMax()) {
	      timelineModel.setPlayState(false);
	    }
	  } // Set normalized currentIndex to payload.
	
	
	  ecModel.resetOption('timeline');
	  return zrUtil.defaults({
	    currentIndex: timelineModel.option.currentIndex
	  }, payload);
	});
	echarts.registerAction({
	  type: 'timelinePlayChange',
	  event: 'timelinePlayChanged',
	  update: 'update'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.playState != null) {
	    timelineModel.setPlayState(payload.playState);
	  }
	});

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(65);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('timeline', function () {
	  // Only slider now.
	  return 'slider';
	});

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var echarts = __webpack_require__(8);
	
	var graphic = __webpack_require__(17);
	
	var _layout = __webpack_require__(47);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _format = __webpack_require__(48);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Model
	echarts.extendComponentModel({
	  type: 'title',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 6,
	    show: true,
	    text: '',
	    // 超链接跳转
	    // link: null,
	    // 仅支持self | blank
	    target: 'blank',
	    subtext: '',
	    // 超链接跳转
	    // sublink: null,
	    // 仅支持self | blank
	    subtarget: 'blank',
	    // 'center' ¦ 'left' ¦ 'right'
	    // ¦ {number}（x坐标，单位px）
	    left: 0,
	    // 'top' ¦ 'bottom' ¦ 'center'
	    // ¦ {number}（y坐标，单位px）
	    top: 0,
	    // 水平对齐
	    // 'auto' | 'left' | 'right' | 'center'
	    // 默认根据 left 的位置判断是左对齐还是右对齐
	    // textAlign: null
	    //
	    // 垂直对齐
	    // 'auto' | 'top' | 'bottom' | 'middle'
	    // 默认根据 top 位置判断是上对齐还是下对齐
	    // textVerticalAlign: null
	    // textBaseline: null // The same as textVerticalAlign.
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 标题边框颜色
	    borderColor: '#ccc',
	    // 标题边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 标题内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 主副标题纵向间隔，单位px，默认为10，
	    itemGap: 10,
	    textStyle: {
	      fontSize: 18,
	      fontWeight: 'bolder',
	      color: '#333'
	    },
	    subtextStyle: {
	      color: '#aaa'
	    }
	  }
	}); // View
	
	echarts.extendComponentView({
	  type: 'title',
	  render: function (titleModel, ecModel, api) {
	    this.group.removeAll();
	
	    if (!titleModel.get('show')) {
	      return;
	    }
	
	    var group = this.group;
	    var textStyleModel = titleModel.getModel('textStyle');
	    var subtextStyleModel = titleModel.getModel('subtextStyle');
	    var textAlign = titleModel.get('textAlign');
	    var textVerticalAlign = zrUtil.retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
	    var textEl = new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: titleModel.get('text'),
	        textFill: textStyleModel.getTextColor()
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var textRect = textEl.getBoundingRect();
	    var subText = titleModel.get('subtext');
	    var subTextEl = new graphic.Text({
	      style: graphic.setTextStyle({}, subtextStyleModel, {
	        text: subText,
	        textFill: subtextStyleModel.getTextColor(),
	        y: textRect.height + titleModel.get('itemGap'),
	        textVerticalAlign: 'top'
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var link = titleModel.get('link');
	    var sublink = titleModel.get('sublink');
	    var triggerEvent = titleModel.get('triggerEvent', true);
	    textEl.silent = !link && !triggerEvent;
	    subTextEl.silent = !sublink && !triggerEvent;
	
	    if (link) {
	      textEl.on('click', function () {
	        windowOpen(link, '_' + titleModel.get('target'));
	      });
	    }
	
	    if (sublink) {
	      subTextEl.on('click', function () {
	        windowOpen(sublink, '_' + titleModel.get('subtarget'));
	      });
	    }
	
	    textEl.eventData = subTextEl.eventData = triggerEvent ? {
	      componentType: 'title',
	      componentIndex: titleModel.componentIndex
	    } : null;
	    group.add(textEl);
	    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.
	
	    var groupRect = group.getBoundingRect();
	    var layoutOption = titleModel.getBoxLayoutParams();
	    layoutOption.width = groupRect.width;
	    layoutOption.height = groupRect.height;
	    var layoutRect = getLayoutRect(layoutOption, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }, titleModel.get('padding')); // Adjust text align based on position
	
	    if (!textAlign) {
	      // Align left if title is on the left. center and right is same
	      textAlign = titleModel.get('left') || titleModel.get('right');
	
	      if (textAlign === 'middle') {
	        textAlign = 'center';
	      } // Adjust layout by text align
	
	
	      if (textAlign === 'right') {
	        layoutRect.x += layoutRect.width;
	      } else if (textAlign === 'center') {
	        layoutRect.x += layoutRect.width / 2;
	      }
	    }
	
	    if (!textVerticalAlign) {
	      textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
	
	      if (textVerticalAlign === 'center') {
	        textVerticalAlign = 'middle';
	      }
	
	      if (textVerticalAlign === 'bottom') {
	        layoutRect.y += layoutRect.height;
	      } else if (textVerticalAlign === 'middle') {
	        layoutRect.y += layoutRect.height / 2;
	      }
	
	      textVerticalAlign = textVerticalAlign || 'top';
	    }
	
	    group.attr('position', [layoutRect.x, layoutRect.y]);
	    var alignStyle = {
	      textAlign: textAlign,
	      textVerticalAlign: textVerticalAlign
	    };
	    textEl.setStyle(alignStyle);
	    subTextEl.setStyle(alignStyle); // Render background
	    // Get groupRect again because textAlign has been changed
	
	    groupRect = group.getBoundingRect();
	    var padding = layoutRect.margin;
	    var style = titleModel.getItemStyle(['color', 'opacity']);
	    style.fill = titleModel.get('backgroundColor');
	    var rect = new graphic.Rect({
	      shape: {
	        x: groupRect.x - padding[3],
	        y: groupRect.y - padding[0],
	        width: groupRect.width + padding[1] + padding[3],
	        height: groupRect.height + padding[0] + padding[2],
	        r: titleModel.get('borderRadius')
	      },
	      style: style,
	      subPixelOptimize: true,
	      silent: true
	    });
	    group.add(rect);
	  }
	});

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(1793);
	
	__webpack_require__(1794);
	
	__webpack_require__(1800);
	
	__webpack_require__(1798);
	
	__webpack_require__(1796);
	
	__webpack_require__(1797);
	
	__webpack_require__(1799);

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var featureManager = __webpack_require__(128);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ToolboxModel = echarts.extendComponentModel({
	  type: 'toolbox',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  optionUpdated: function () {
	    ToolboxModel.superApply(this, 'optionUpdated', arguments);
	    zrUtil.each(this.option.feature, function (featureOpt, featureName) {
	      var Feature = featureManager.get(featureName);
	      Feature && zrUtil.merge(featureOpt, Feature.defaultOption);
	    });
	  },
	  defaultOption: {
	    show: true,
	    z: 6,
	    zlevel: 0,
	    orient: 'horizontal',
	    left: 'right',
	    top: 'top',
	    // right
	    // bottom
	    backgroundColor: 'transparent',
	    borderColor: '#ccc',
	    borderRadius: 0,
	    borderWidth: 0,
	    padding: 5,
	    itemSize: 15,
	    itemGap: 8,
	    showTitle: true,
	    iconStyle: {
	      borderColor: '#666',
	      color: 'none'
	    },
	    emphasis: {
	      iconStyle: {
	        borderColor: '#3E98C5'
	      }
	    },
	    // textStyle: {},
	    // feature
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = ToolboxModel;
	module.exports = _default;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var textContain = __webpack_require__(86);
	
	var featureManager = __webpack_require__(128);
	
	var graphic = __webpack_require__(17);
	
	var Model = __webpack_require__(57);
	
	var DataDiffer = __webpack_require__(142);
	
	var listComponentHelper = __webpack_require__(826);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'toolbox',
	  render: function (toolboxModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	
	    if (!toolboxModel.get('show')) {
	      return;
	    }
	
	    var itemSize = +toolboxModel.get('itemSize');
	    var featureOpts = toolboxModel.get('feature') || {};
	    var features = this._features || (this._features = {});
	    var featureNames = [];
	    zrUtil.each(featureOpts, function (opt, name) {
	      featureNames.push(name);
	    });
	    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(zrUtil.curry(processFeature, null)).execute(); // Keep for diff.
	
	    this._featureNames = featureNames;
	
	    function processFeature(newIndex, oldIndex) {
	      var featureName = featureNames[newIndex];
	      var oldName = featureNames[oldIndex];
	      var featureOpt = featureOpts[featureName];
	      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
	      var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
	
	      if (payload && payload.newTitle != null && payload.featureName === featureName) {
	        featureOpt.title = payload.newTitle;
	      }
	
	      if (featureName && !oldName) {
	        // Create
	        if (isUserFeatureName(featureName)) {
	          feature = {
	            model: featureModel,
	            onclick: featureModel.option.onclick,
	            featureName: featureName
	          };
	        } else {
	          var Feature = featureManager.get(featureName);
	
	          if (!Feature) {
	            return;
	          }
	
	          feature = new Feature(featureModel, ecModel, api);
	        }
	
	        features[featureName] = feature;
	      } else {
	        feature = features[oldName]; // If feature does not exsit.
	
	        if (!feature) {
	          return;
	        }
	
	        feature.model = featureModel;
	        feature.ecModel = ecModel;
	        feature.api = api;
	      }
	
	      if (!featureName && oldName) {
	        feature.dispose && feature.dispose(ecModel, api);
	        return;
	      }
	
	      if (!featureModel.get('show') || feature.unusable) {
	        feature.remove && feature.remove(ecModel, api);
	        return;
	      }
	
	      createIconPaths(featureModel, feature, featureName);
	
	      featureModel.setIconStatus = function (iconName, status) {
	        var option = this.option;
	        var iconPaths = this.iconPaths;
	        option.iconStatus = option.iconStatus || {};
	        option.iconStatus[iconName] = status; // FIXME
	
	        iconPaths[iconName] && iconPaths[iconName].trigger(status);
	      };
	
	      if (feature.render) {
	        feature.render(featureModel, ecModel, api, payload);
	      }
	    }
	
	    function createIconPaths(featureModel, feature, featureName) {
	      var iconStyleModel = featureModel.getModel('iconStyle');
	      var iconStyleEmphasisModel = featureModel.getModel('emphasis.iconStyle'); // If one feature has mutiple icon. they are orginaized as
	      // {
	      //     icon: {
	      //         foo: '',
	      //         bar: ''
	      //     },
	      //     title: {
	      //         foo: '',
	      //         bar: ''
	      //     }
	      // }
	
	      var icons = feature.getIcons ? feature.getIcons() : featureModel.get('icon');
	      var titles = featureModel.get('title') || {};
	
	      if (typeof icons === 'string') {
	        var icon = icons;
	        var title = titles;
	        icons = {};
	        titles = {};
	        icons[featureName] = icon;
	        titles[featureName] = title;
	      }
	
	      var iconPaths = featureModel.iconPaths = {};
	      zrUtil.each(icons, function (iconStr, iconName) {
	        var path = graphic.createIcon(iconStr, {}, {
	          x: -itemSize / 2,
	          y: -itemSize / 2,
	          width: itemSize,
	          height: itemSize
	        });
	        path.setStyle(iconStyleModel.getItemStyle());
	        path.hoverStyle = iconStyleEmphasisModel.getItemStyle(); // Text position calculation
	
	        path.setStyle({
	          text: titles[iconName],
	          textAlign: iconStyleEmphasisModel.get('textAlign'),
	          textBorderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
	          textPadding: iconStyleEmphasisModel.get('textPadding'),
	          textFill: null
	        });
	        var tooltipModel = toolboxModel.getModel('tooltip');
	
	        if (tooltipModel && tooltipModel.get('show')) {
	          path.attr('tooltip', zrUtil.extend({
	            content: titles[iconName],
	            formatter: tooltipModel.get('formatter', true) || function () {
	              return titles[iconName];
	            },
	            formatterParams: {
	              componentType: 'toolbox',
	              name: iconName,
	              title: titles[iconName],
	              $vars: ['name', 'title']
	            },
	            position: tooltipModel.get('position', true) || 'bottom'
	          }, tooltipModel.option));
	        }
	
	        graphic.setHoverStyle(path);
	
	        if (toolboxModel.get('showTitle')) {
	          path.__title = titles[iconName];
	          path.on('mouseover', function () {
	            // Should not reuse above hoverStyle, which might be modified.
	            var hoverStyle = iconStyleEmphasisModel.getItemStyle();
	            var defaultTextPosition = toolboxModel.get('orient') === 'vertical' ? toolboxModel.get('right') == null ? 'right' : 'left' : toolboxModel.get('bottom') == null ? 'bottom' : 'top';
	            path.setStyle({
	              textFill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
	              textBackgroundColor: iconStyleEmphasisModel.get('textBackgroundColor'),
	              textPosition: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
	            });
	          }).on('mouseout', function () {
	            path.setStyle({
	              textFill: null,
	              textBackgroundColor: null
	            });
	          });
	        }
	
	        path.trigger(featureModel.get('iconStatus.' + iconName) || 'normal');
	        group.add(path);
	        path.on('click', zrUtil.bind(feature.onclick, feature, ecModel, api, iconName));
	        iconPaths[iconName] = path;
	      });
	    }
	
	    listComponentHelper.layout(group, toolboxModel, api); // Render background after group is layout
	    // FIXME
	
	    group.add(listComponentHelper.makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen
	
	    group.eachChild(function (icon) {
	      var titleText = icon.__title;
	      var hoverStyle = icon.hoverStyle; // May be background element
	
	      if (hoverStyle && titleText) {
	        var rect = textContain.getBoundingRect(titleText, textContain.makeFont(hoverStyle));
	        var offsetX = icon.position[0] + group.position[0];
	        var offsetY = icon.position[1] + group.position[1] + itemSize;
	        var needPutOnTop = false;
	
	        if (offsetY + rect.height > api.getHeight()) {
	          hoverStyle.textPosition = 'top';
	          needPutOnTop = true;
	        }
	
	        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;
	
	        if (offsetX + rect.width / 2 > api.getWidth()) {
	          hoverStyle.textPosition = ['100%', topOffset];
	          hoverStyle.textAlign = 'right';
	        } else if (offsetX - rect.width / 2 < 0) {
	          hoverStyle.textPosition = [0, topOffset];
	          hoverStyle.textAlign = 'left';
	        }
	      }
	    });
	  },
	  updateView: function (toolboxModel, ecModel, api, payload) {
	    zrUtil.each(this._features, function (feature) {
	      feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
	    });
	  },
	  // updateLayout: function (toolboxModel, ecModel, api, payload) {
	  //     zrUtil.each(this._features, function (feature) {
	  //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
	  //     });
	  // },
	  remove: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.remove && feature.remove(ecModel, api);
	    });
	    this.group.removeAll();
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.dispose && feature.dispose(ecModel, api);
	    });
	  }
	});
	
	function isUserFeatureName(featureName) {
	  return featureName.indexOf('my') === 0;
	}
	
	module.exports = _default;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var featureManager = __webpack_require__(128);
	
	var lang = __webpack_require__(130);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var brushLang = lang.toolbox.brush;
	
	function Brush(model, ecModel, api) {
	  this.model = model;
	  this.ecModel = ecModel;
	  this.api = api;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushMode;
	}
	
	Brush.defaultOption = {
	  show: true,
	  type: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
	  icon: {
	    /* eslint-disable */
	    rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
	    // jshint ignore:line
	    polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
	    // jshint ignore:line
	    lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
	    // jshint ignore:line
	    lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
	    // jshint ignore:line
	    keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
	    // jshint ignore:line
	    clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
	  title: zrUtil.clone(brushLang.title)
	};
	var proto = Brush.prototype; // proto.updateLayout = function (featureModel, ecModel, api) {
	
	/* eslint-disable */
	
	proto.render =
	/* eslint-enable */
	proto.updateView = function (featureModel, ecModel, api) {
	  var brushType;
	  var brushMode;
	  var isBrushed;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    brushType = brushModel.brushType;
	    brushMode = brushModel.brushOption.brushMode || 'single';
	    isBrushed |= brushModel.areas.length;
	  });
	  this._brushType = brushType;
	  this._brushMode = brushMode;
	  zrUtil.each(featureModel.get('type', true), function (type) {
	    featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
	  });
	};
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon', true);
	  var icons = {};
	  zrUtil.each(model.get('type', true), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	proto.onclick = function (ecModel, api, type) {
	  var brushType = this._brushType;
	  var brushMode = this._brushMode;
	
	  if (type === 'clear') {
	    // Trigger parallel action firstly
	    api.dispatchAction({
	      type: 'axisAreaSelect',
	      intervals: []
	    });
	    api.dispatchAction({
	      type: 'brush',
	      command: 'clear',
	      // Clear all areas of all brush components.
	      areas: []
	    });
	  } else {
	    api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'brush',
	      brushOption: {
	        brushType: type === 'keep' ? brushType : brushType === type ? false : type,
	        brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
	      }
	    });
	  }
	};
	
	featureManager.register('brush', Brush);
	var _default = Brush;
	module.exports = _default;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var eventTool = __webpack_require__(104);
	
	var lang = __webpack_require__(130);
	
	var featureManager = __webpack_require__(128);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var dataViewLang = lang.toolbox.dataView;
	var BLOCK_SPLITER = new Array(60).join('-');
	var ITEM_SPLITER = '\t';
	/**
	 * Group series into two types
	 *  1. on category axis, like line, bar
	 *  2. others, like scatter, pie
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object}
	 * @inner
	 */
	
	function groupSeries(ecModel) {
	  var seriesGroupByCategoryAxis = {};
	  var otherSeries = [];
	  var meta = [];
	  ecModel.eachRawSeries(function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
	      var baseAxis = coordSys.getBaseAxis();
	
	      if (baseAxis.type === 'category') {
	        var key = baseAxis.dim + '_' + baseAxis.index;
	
	        if (!seriesGroupByCategoryAxis[key]) {
	          seriesGroupByCategoryAxis[key] = {
	            categoryAxis: baseAxis,
	            valueAxis: coordSys.getOtherAxis(baseAxis),
	            series: []
	          };
	          meta.push({
	            axisDim: baseAxis.dim,
	            axisIndex: baseAxis.index
	          });
	        }
	
	        seriesGroupByCategoryAxis[key].series.push(seriesModel);
	      } else {
	        otherSeries.push(seriesModel);
	      }
	    } else {
	      otherSeries.push(seriesModel);
	    }
	  });
	  return {
	    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
	    other: otherSeries,
	    meta: meta
	  };
	}
	/**
	 * Assemble content of series on cateogory axis
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleSeriesWithCategoryAxis(series) {
	  var tables = [];
	  zrUtil.each(series, function (group, key) {
	    var categoryAxis = group.categoryAxis;
	    var valueAxis = group.valueAxis;
	    var valueAxisDim = valueAxis.dim;
	    var headers = [' '].concat(zrUtil.map(group.series, function (series) {
	      return series.name;
	    }));
	    var columns = [categoryAxis.model.getCategories()];
	    zrUtil.each(group.series, function (series) {
	      var rawData = series.getRawData();
	      columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function (val) {
	        return val;
	      }));
	    }); // Assemble table content
	
	    var lines = [headers.join(ITEM_SPLITER)];
	
	    for (var i = 0; i < columns[0].length; i++) {
	      var items = [];
	
	      for (var j = 0; j < columns.length; j++) {
	        items.push(columns[j][i]);
	      }
	
	      lines.push(items.join(ITEM_SPLITER));
	    }
	
	    tables.push(lines.join('\n'));
	  });
	  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * Assemble content of other series
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleOtherSeries(series) {
	  return zrUtil.map(series, function (series) {
	    var data = series.getRawData();
	    var lines = [series.name];
	    var vals = [];
	    data.each(data.dimensions, function () {
	      var argLen = arguments.length;
	      var dataIndex = arguments[argLen - 1];
	      var name = data.getName(dataIndex);
	
	      for (var i = 0; i < argLen - 1; i++) {
	        vals[i] = arguments[i];
	      }
	
	      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
	    });
	    return lines.join('\n');
	  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * @param {module:echarts/model/Global}
	 * @return {Object}
	 * @inner
	 */
	
	
	function getContentFromModel(ecModel) {
	  var result = groupSeries(ecModel);
	  return {
	    value: zrUtil.filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
	      return str.replace(/[\n\t\s]/g, '');
	    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
	    meta: result.meta
	  };
	}
	
	function trim(str) {
	  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	}
	/**
	 * If a block is tsv format
	 */
	
	
	function isTSVFormat(block) {
	  // Simple method to find out if a block is tsv format
	  var firstLine = block.slice(0, block.indexOf('\n'));
	
	  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
	    return true;
	  }
	}
	
	var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
	/**
	 * @param {string} tsv
	 * @return {Object}
	 */
	
	function parseTSVContents(tsv) {
	  var tsvLines = tsv.split(/\n+/g);
	  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
	  var categories = [];
	  var series = zrUtil.map(headers, function (header) {
	    return {
	      name: header,
	      data: []
	    };
	  });
	
	  for (var i = 0; i < tsvLines.length; i++) {
	    var items = trim(tsvLines[i]).split(itemSplitRegex);
	    categories.push(items.shift());
	
	    for (var j = 0; j < items.length; j++) {
	      series[j] && (series[j].data[i] = items[j]);
	    }
	  }
	
	  return {
	    series: series,
	    categories: categories
	  };
	}
	/**
	 * @param {string} str
	 * @return {Array.<Object>}
	 * @inner
	 */
	
	
	function parseListContents(str) {
	  var lines = str.split(/\n+/g);
	  var seriesName = trim(lines.shift());
	  var data = [];
	
	  for (var i = 0; i < lines.length; i++) {
	    // if line is empty, ignore it.
	    // there is a case that a user forgot to delete `\n`.
	    var line = trim(lines[i]);
	
	    if (!line) {
	      continue;
	    }
	
	    var items = line.split(itemSplitRegex);
	    var name = '';
	    var value;
	    var hasName = false;
	
	    if (isNaN(items[0])) {
	      // First item is name
	      hasName = true;
	      name = items[0];
	      items = items.slice(1);
	      data[i] = {
	        name: name,
	        value: []
	      };
	      value = data[i].value;
	    } else {
	      value = data[i] = [];
	    }
	
	    for (var j = 0; j < items.length; j++) {
	      value.push(+items[j]);
	    }
	
	    if (value.length === 1) {
	      hasName ? data[i].value = value[0] : data[i] = value[0];
	    }
	  }
	
	  return {
	    name: seriesName,
	    data: data
	  };
	}
	/**
	 * @param {string} str
	 * @param {Array.<Object>} blockMetaList
	 * @return {Object}
	 * @inner
	 */
	
	
	function parseContents(str, blockMetaList) {
	  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
	  var newOption = {
	    series: []
	  };
	  zrUtil.each(blocks, function (block, idx) {
	    if (isTSVFormat(block)) {
	      var result = parseTSVContents(block);
	      var blockMeta = blockMetaList[idx];
	      var axisKey = blockMeta.axisDim + 'Axis';
	
	      if (blockMeta) {
	        newOption[axisKey] = newOption[axisKey] || [];
	        newOption[axisKey][blockMeta.axisIndex] = {
	          data: result.categories
	        };
	        newOption.series = newOption.series.concat(result.series);
	      }
	    } else {
	      var result = parseListContents(block);
	      newOption.series.push(result);
	    }
	  });
	  return newOption;
	}
	/**
	 * @alias {module:echarts/component/toolbox/feature/DataView}
	 * @constructor
	 * @param {module:echarts/model/Model} model
	 */
	
	
	function DataView(model) {
	  this._dom = null;
	  this.model = model;
	}
	
	DataView.defaultOption = {
	  show: true,
	  readOnly: false,
	  optionToContent: null,
	  contentToOption: null,
	  icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
	  title: zrUtil.clone(dataViewLang.title),
	  lang: zrUtil.clone(dataViewLang.lang),
	  backgroundColor: '#fff',
	  textColor: '#000',
	  textareaColor: '#fff',
	  textareaBorderColor: '#333',
	  buttonColor: '#c23531',
	  buttonTextColor: '#fff'
	};
	
	DataView.prototype.onclick = function (ecModel, api) {
	  var container = api.getDom();
	  var model = this.model;
	
	  if (this._dom) {
	    container.removeChild(this._dom);
	  }
	
	  var root = document.createElement('div');
	  root.style.cssText = 'position:absolute;left:5px;top:5px;bottom:5px;right:5px;';
	  root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements
	
	  var header = document.createElement('h4');
	  var lang = model.get('lang') || [];
	  header.innerHTML = lang[0] || model.get('title');
	  header.style.cssText = 'margin: 10px 20px;';
	  header.style.color = model.get('textColor');
	  var viewMain = document.createElement('div');
	  var textarea = document.createElement('textarea');
	  viewMain.style.cssText = 'display:block;width:100%;overflow:auto;';
	  var optionToContent = model.get('optionToContent');
	  var contentToOption = model.get('contentToOption');
	  var result = getContentFromModel(ecModel);
	
	  if (typeof optionToContent === 'function') {
	    var htmlOrDom = optionToContent(api.getOption());
	
	    if (typeof htmlOrDom === 'string') {
	      viewMain.innerHTML = htmlOrDom;
	    } else if (zrUtil.isDom(htmlOrDom)) {
	      viewMain.appendChild(htmlOrDom);
	    }
	  } else {
	    // Use default textarea
	    viewMain.appendChild(textarea);
	    textarea.readOnly = model.get('readOnly');
	    textarea.style.cssText = 'width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;';
	    textarea.style.color = model.get('textColor');
	    textarea.style.borderColor = model.get('textareaBorderColor');
	    textarea.style.backgroundColor = model.get('textareaColor');
	    textarea.value = result.value;
	  }
	
	  var blockMetaList = result.meta;
	  var buttonContainer = document.createElement('div');
	  buttonContainer.style.cssText = 'position:absolute;bottom:0;left:0;right:0;';
	  var buttonStyle = 'float:right;margin-right:20px;border:none;' + 'cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
	  var closeButton = document.createElement('div');
	  var refreshButton = document.createElement('div');
	  buttonStyle += ';background-color:' + model.get('buttonColor');
	  buttonStyle += ';color:' + model.get('buttonTextColor');
	  var self = this;
	
	  function close() {
	    container.removeChild(root);
	    self._dom = null;
	  }
	
	  eventTool.addEventListener(closeButton, 'click', close);
	  eventTool.addEventListener(refreshButton, 'click', function () {
	    var newOption;
	
	    try {
	      if (typeof contentToOption === 'function') {
	        newOption = contentToOption(viewMain, api.getOption());
	      } else {
	        newOption = parseContents(textarea.value, blockMetaList);
	      }
	    } catch (e) {
	      close();
	      throw new Error('Data view format error ' + e);
	    }
	
	    if (newOption) {
	      api.dispatchAction({
	        type: 'changeDataView',
	        newOption: newOption
	      });
	    }
	
	    close();
	  });
	  closeButton.innerHTML = lang[1];
	  refreshButton.innerHTML = lang[2];
	  refreshButton.style.cssText = buttonStyle;
	  closeButton.style.cssText = buttonStyle;
	  !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
	  buttonContainer.appendChild(closeButton);
	  root.appendChild(header);
	  root.appendChild(viewMain);
	  root.appendChild(buttonContainer);
	  viewMain.style.height = container.clientHeight - 80 + 'px';
	  container.appendChild(root);
	  this._dom = root;
	};
	
	DataView.prototype.remove = function (ecModel, api) {
	  this._dom && api.getDom().removeChild(this._dom);
	};
	
	DataView.prototype.dispose = function (ecModel, api) {
	  this.remove(ecModel, api);
	};
	/**
	 * @inner
	 */
	
	
	function tryMergeDataOption(newData, originalData) {
	  return zrUtil.map(newData, function (newVal, idx) {
	    var original = originalData && originalData[idx];
	
	    if (zrUtil.isObject(original) && !zrUtil.isArray(original)) {
	      var newValIsObject = zrUtil.isObject(newVal) && !zrUtil.isArray(newVal);
	
	      if (!newValIsObject) {
	        newVal = {
	          value: newVal
	        };
	      } // original data has name but new data has no name
	
	
	      var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option
	
	      newVal = zrUtil.defaults(newVal, original);
	      shouldDeleteName && delete newVal.name;
	      return newVal;
	    } else {
	      return newVal;
	    }
	  });
	}
	
	featureManager.register('dataView', DataView);
	echarts.registerAction({
	  type: 'changeDataView',
	  event: 'dataViewChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var newSeriesOptList = [];
	  zrUtil.each(payload.newOption.series, function (seriesOpt) {
	    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
	
	    if (!seriesModel) {
	      // New created series
	      // Geuss the series type
	      newSeriesOptList.push(zrUtil.extend({
	        // Default is scatter
	        type: 'scatter'
	      }, seriesOpt));
	    } else {
	      var originalData = seriesModel.get('data');
	      newSeriesOptList.push({
	        name: seriesOpt.name,
	        data: tryMergeDataOption(seriesOpt.data, originalData)
	      });
	    }
	  });
	  ecModel.mergeOption(zrUtil.defaults({
	    series: newSeriesOptList
	  }, payload.newOption));
	});
	var _default = DataView;
	module.exports = _default;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var BrushController = __webpack_require__(420);
	
	var BrushTargetManager = __webpack_require__(822);
	
	var history = __webpack_require__(820);
	
	var sliderMove = __webpack_require__(174);
	
	var lang = __webpack_require__(130);
	
	var featureManager = __webpack_require__(128);
	
	__webpack_require__(1749);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Use dataZoomSelect
	var dataZoomLang = lang.toolbox.dataZoom;
	var each = zrUtil.each; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId
	
	var DATA_ZOOM_ID_BASE = '\0_ec_\0toolbox-dataZoom_';
	
	function DataZoom(model, ecModel, api) {
	  /**
	   * @private
	   * @type {module:echarts/component/helper/BrushController}
	   */
	  (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._isZoomActive;
	}
	
	DataZoom.defaultOption = {
	  show: true,
	  filterMode: 'filter',
	  // Icon group
	  icon: {
	    zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
	    back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
	  },
	  // `zoom`, `back`
	  title: zrUtil.clone(dataZoomLang.title),
	  brushStyle: {
	    borderWidth: 0,
	    color: 'rgba(0,0,0,0.2)'
	  }
	};
	var proto = DataZoom.prototype;
	
	proto.render = function (featureModel, ecModel, api, payload) {
	  this.model = featureModel;
	  this.ecModel = ecModel;
	  this.api = api;
	  updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
	  updateBackBtnStatus(featureModel, ecModel);
	};
	
	proto.onclick = function (ecModel, api, type) {
	  handlers[type].call(this);
	};
	
	proto.remove = function (ecModel, api) {
	  this._brushController.unmount();
	};
	
	proto.dispose = function (ecModel, api) {
	  this._brushController.dispose();
	};
	/**
	 * @private
	 */
	
	
	var handlers = {
	  zoom: function () {
	    var nextActive = !this._isZoomActive;
	    this.api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'dataZoomSelect',
	      dataZoomSelectActive: nextActive
	    });
	  },
	  back: function () {
	    this._dispatchZoomAction(history.pop(this.ecModel));
	  }
	};
	/**
	 * @private
	 */
	
	proto._onBrush = function (areas, opt) {
	  if (!opt.isEnd || !areas.length) {
	    return;
	  }
	
	  var snapshot = {};
	  var ecModel = this.ecModel;
	
	  this._brushController.updateCovers([]); // remove cover
	
	
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(this.model.option), ecModel, {
	    include: ['grid']
	  });
	  brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    if (coordSys.type !== 'cartesian2d') {
	      return;
	    }
	
	    var brushType = area.brushType;
	
	    if (brushType === 'rect') {
	      setBatch('x', coordSys, coordRange[0]);
	      setBatch('y', coordSys, coordRange[1]);
	    } else {
	      setBatch({
	        lineX: 'x',
	        lineY: 'y'
	      }[brushType], coordSys, coordRange);
	    }
	  });
	  history.push(ecModel, snapshot);
	
	  this._dispatchZoomAction(snapshot);
	
	  function setBatch(dimName, coordSys, minMax) {
	    var axis = coordSys.getAxis(dimName);
	    var axisModel = axis.model;
	    var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
	
	    if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
	      minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
	    }
	
	    dataZoomModel && (snapshot[dataZoomModel.id] = {
	      dataZoomId: dataZoomModel.id,
	      startValue: minMax[0],
	      endValue: minMax[1]
	    });
	  }
	
	  function findDataZoom(dimName, axisModel, ecModel) {
	    var found;
	    ecModel.eachComponent({
	      mainType: 'dataZoom',
	      subType: 'select'
	    }, function (dzModel) {
	      var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
	      has && (found = dzModel);
	    });
	    return found;
	  }
	};
	/**
	 * @private
	 */
	
	
	proto._dispatchZoomAction = function (snapshot) {
	  var batch = []; // Convert from hash map to array.
	
	  each(snapshot, function (batchItem, dataZoomId) {
	    batch.push(zrUtil.clone(batchItem));
	  });
	  batch.length && this.api.dispatchAction({
	    type: 'dataZoom',
	    from: this.uid,
	    batch: batch
	  });
	};
	
	function retrieveAxisSetting(option) {
	  var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.
	
	  zrUtil.each(['xAxisIndex', 'yAxisIndex'], function (name) {
	    setting[name] = option[name];
	    setting[name] == null && (setting[name] = 'all');
	    (setting[name] === false || setting[name] === 'none') && (setting[name] = []);
	  });
	  return setting;
	}
	
	function updateBackBtnStatus(featureModel, ecModel) {
	  featureModel.setIconStatus('back', history.count(ecModel) > 1 ? 'emphasis' : 'normal');
	}
	
	function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
	  var zoomActive = view._isZoomActive;
	
	  if (payload && payload.type === 'takeGlobalCursor') {
	    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
	  }
	
	  view._isZoomActive = zoomActive;
	  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(featureModel.option), ecModel, {
	    include: ['grid']
	  });
	
	  view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function (targetInfo) {
	    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
	  })).enableBrush(zoomActive ? {
	    brushType: 'auto',
	    brushStyle: featureModel.getModel('brushStyle').getItemStyle()
	  } : false);
	}
	
	featureManager.register('dataZoom', DataZoom); // Create special dataZoom option for select
	// FIXME consider the case of merge option, where axes options are not exists.
	
	echarts.registerPreprocessor(function (option) {
	  if (!option) {
	    return;
	  }
	
	  var dataZoomOpts = option.dataZoom || (option.dataZoom = []);
	
	  if (!zrUtil.isArray(dataZoomOpts)) {
	    option.dataZoom = dataZoomOpts = [dataZoomOpts];
	  }
	
	  var toolboxOpt = option.toolbox;
	
	  if (toolboxOpt) {
	    // Assume there is only one toolbox
	    if (zrUtil.isArray(toolboxOpt)) {
	      toolboxOpt = toolboxOpt[0];
	    }
	
	    if (toolboxOpt && toolboxOpt.feature) {
	      var dataZoomOpt = toolboxOpt.feature.dataZoom; // FIXME: If add dataZoom when setOption in merge mode,
	      // no axis info to be added. See `test/dataZoom-extreme.html`
	
	      addForAxis('xAxis', dataZoomOpt);
	      addForAxis('yAxis', dataZoomOpt);
	    }
	  }
	
	  function addForAxis(axisName, dataZoomOpt) {
	    if (!dataZoomOpt) {
	      return;
	    } // Try not to modify model, because it is not merged yet.
	
	
	    var axisIndicesName = axisName + 'Index';
	    var givenAxisIndices = dataZoomOpt[axisIndicesName];
	
	    if (givenAxisIndices != null && givenAxisIndices !== 'all' && !zrUtil.isArray(givenAxisIndices)) {
	      givenAxisIndices = givenAxisIndices === false || givenAxisIndices === 'none' ? [] : [givenAxisIndices];
	    }
	
	    forEachComponent(axisName, function (axisOpt, axisIndex) {
	      if (givenAxisIndices != null && givenAxisIndices !== 'all' && zrUtil.indexOf(givenAxisIndices, axisIndex) === -1) {
	        return;
	      }
	
	      var newOpt = {
	        type: 'select',
	        $fromToolbox: true,
	        // Default to be filter
	        filterMode: dataZoomOpt.filterMode || 'filter',
	        // Id for merge mapping.
	        id: DATA_ZOOM_ID_BASE + axisName + axisIndex
	      }; // FIXME
	      // Only support one axis now.
	
	      newOpt[axisIndicesName] = axisIndex;
	      dataZoomOpts.push(newOpt);
	    });
	  }
	
	  function forEachComponent(mainType, cb) {
	    var opts = option[mainType];
	
	    if (!zrUtil.isArray(opts)) {
	      opts = opts ? [opts] : [];
	    }
	
	    each(opts, cb);
	  }
	});
	var _default = DataZoom;
	module.exports = _default;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var lang = __webpack_require__(130);
	
	var featureManager = __webpack_require__(128);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var magicTypeLang = lang.toolbox.magicType;
	var INNER_STACK_KEYWORD = '__ec_magicType_stack__';
	
	function MagicType(model) {
	  this.model = model;
	}
	
	MagicType.defaultOption = {
	  show: true,
	  type: [],
	  // Icon group
	  icon: {
	    /* eslint-disable */
	    line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
	    bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
	    stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `line`, `bar`, `stack`, `tiled`
	  title: zrUtil.clone(magicTypeLang.title),
	  option: {},
	  seriesIndex: {}
	};
	var proto = MagicType.prototype;
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon');
	  var icons = {};
	  zrUtil.each(model.get('type'), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	var seriesOptGenreator = {
	  'line': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'line',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.line') || {}, true);
	    }
	  },
	  'bar': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'bar',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.bar') || {}, true);
	    }
	  },
	  'stack': function (seriesType, seriesId, seriesModel, model) {
	    var isStack = seriesModel.get('stack') === INNER_STACK_KEYWORD;
	
	    if (seriesType === 'line' || seriesType === 'bar') {
	      model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
	      return zrUtil.merge({
	        id: seriesId,
	        stack: isStack ? '' : INNER_STACK_KEYWORD
	      }, model.get('option.stack') || {}, true);
	    }
	  }
	};
	var radioTypes = [['line', 'bar'], ['stack']];
	
	proto.onclick = function (ecModel, api, type) {
	  var model = this.model;
	  var seriesIndex = model.get('seriesIndex.' + type); // Not supported magicType
	
	  if (!seriesOptGenreator[type]) {
	    return;
	  }
	
	  var newOption = {
	    series: []
	  };
	
	  var generateNewSeriesTypes = function (seriesModel) {
	    var seriesType = seriesModel.subType;
	    var seriesId = seriesModel.id;
	    var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
	
	    if (newSeriesOpt) {
	      // PENDING If merge original option?
	      zrUtil.defaults(newSeriesOpt, seriesModel.option);
	      newOption.series.push(newSeriesOpt);
	    } // Modify boundaryGap
	
	
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
	      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	      if (categoryAxis) {
	        var axisDim = categoryAxis.dim;
	        var axisType = axisDim + 'Axis';
	        var axisModel = ecModel.queryComponents({
	          mainType: axisType,
	          index: seriesModel.get(name + 'Index'),
	          id: seriesModel.get(name + 'Id')
	        })[0];
	        var axisIndex = axisModel.componentIndex;
	        newOption[axisType] = newOption[axisType] || [];
	
	        for (var i = 0; i <= axisIndex; i++) {
	          newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
	        }
	
	        newOption[axisType][axisIndex].boundaryGap = type === 'bar';
	      }
	    }
	  };
	
	  zrUtil.each(radioTypes, function (radio) {
	    if (zrUtil.indexOf(radio, type) >= 0) {
	      zrUtil.each(radio, function (item) {
	        model.setIconStatus(item, 'normal');
	      });
	    }
	  });
	  model.setIconStatus(type, 'emphasis');
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: seriesIndex == null ? null : {
	      seriesIndex: seriesIndex
	    }
	  }, generateNewSeriesTypes);
	  var newTitle; // Change title of stack
	
	  if (type === 'stack') {
	    var isStack = newOption.series && newOption.series[0] && newOption.series[0].stack === INNER_STACK_KEYWORD;
	    newTitle = isStack ? zrUtil.merge({
	      stack: magicTypeLang.title.tiled
	    }, magicTypeLang.title) : zrUtil.clone(magicTypeLang.title);
	  }
	
	  api.dispatchAction({
	    type: 'changeMagicType',
	    currentType: type,
	    newOption: newOption,
	    newTitle: newTitle,
	    featureName: 'magicType'
	  });
	};
	
	echarts.registerAction({
	  type: 'changeMagicType',
	  event: 'magicTypeChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.mergeOption(payload.newOption);
	});
	featureManager.register('magicType', MagicType);
	var _default = MagicType;
	module.exports = _default;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var history = __webpack_require__(820);
	
	var lang = __webpack_require__(130);
	
	var featureManager = __webpack_require__(128);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var restoreLang = lang.toolbox.restore;
	
	function Restore(model) {
	  this.model = model;
	}
	
	Restore.defaultOption = {
	  show: true,
	
	  /* eslint-disable */
	  icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
	
	  /* eslint-enable */
	  title: restoreLang.title
	};
	var proto = Restore.prototype;
	
	proto.onclick = function (ecModel, api, type) {
	  history.clear(ecModel);
	  api.dispatchAction({
	    type: 'restore',
	    from: this.uid
	  });
	};
	
	featureManager.register('restore', Restore);
	echarts.registerAction({
	  type: 'restore',
	  event: 'restore',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.resetOption('recreate');
	});
	var _default = Restore;
	module.exports = _default;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var env = __webpack_require__(58);
	
	var lang = __webpack_require__(130);
	
	var featureManager = __webpack_require__(128);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8Array */
	var saveAsImageLang = lang.toolbox.saveAsImage;
	
	function SaveAsImage(model) {
	  this.model = model;
	}
	
	SaveAsImage.defaultOption = {
	  show: true,
	  icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
	  title: saveAsImageLang.title,
	  type: 'png',
	  // Default use option.backgroundColor
	  // backgroundColor: '#fff',
	  connectedBackgroundColor: '#fff',
	  name: '',
	  excludeComponents: ['toolbox'],
	  pixelRatio: 1,
	  lang: saveAsImageLang.lang.slice()
	};
	SaveAsImage.prototype.unusable = !env.canvasSupported;
	var proto = SaveAsImage.prototype;
	
	proto.onclick = function (ecModel, api) {
	  var model = this.model;
	  var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
	  var isSvg = api.getZr().painter.getType() === 'svg';
	  var type = isSvg ? 'svg' : model.get('type', true) || 'png';
	  var url = api.getConnectedDataURL({
	    type: type,
	    backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
	    connectedBackgroundColor: model.get('connectedBackgroundColor'),
	    excludeComponents: model.get('excludeComponents'),
	    pixelRatio: model.get('pixelRatio')
	  }); // Chrome and Firefox
	
	  if (typeof MouseEvent === 'function' && !env.browser.ie && !env.browser.edge) {
	    var $a = document.createElement('a');
	    $a.download = title + '.' + type;
	    $a.target = '_blank';
	    $a.href = url;
	    var evt = new MouseEvent('click', {
	      // some micro front-end framework， window maybe is a Proxy
	      view: document.defaultView,
	      bubbles: true,
	      cancelable: false
	    });
	    $a.dispatchEvent(evt);
	  } // IE
	  else {
	      if (window.navigator.msSaveOrOpenBlob) {
	        var bstr = atob(url.split(',')[1]);
	        var n = bstr.length;
	        var u8arr = new Uint8Array(n);
	
	        while (n--) {
	          u8arr[n] = bstr.charCodeAt(n);
	        }
	
	        var blob = new Blob([u8arr]);
	        window.navigator.msSaveOrOpenBlob(blob, title + '.' + type);
	      } else {
	        var lang = model.get('lang');
	        var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
	        var tab = window.open();
	        tab.document.write(html);
	      }
	    }
	};
	
	featureManager.register('saveAsImage', SaveAsImage);
	var _default = SaveAsImage;
	module.exports = _default;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(216);
	
	__webpack_require__(1803);
	
	__webpack_require__(1805);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Better way to pack data in graphic element
	
	/**
	 * @action
	 * @property {string} type
	 * @property {number} seriesIndex
	 * @property {number} dataIndex
	 * @property {number} [x]
	 * @property {number} [y]
	 */
	echarts.registerAction({
	  type: 'showTip',
	  event: 'showTip',
	  update: 'tooltip:manuallyShowTip'
	}, // noop
	function () {});
	echarts.registerAction({
	  type: 'hideTip',
	  event: 'hideTip',
	  update: 'tooltip:manuallyHideTip'
	}, // noop
	function () {});

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var zrColor = __webpack_require__(105);
	
	var eventUtil = __webpack_require__(104);
	
	var domUtil = __webpack_require__(903);
	
	var env = __webpack_require__(58);
	
	var formatUtil = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var toCamelCase = formatUtil.toCamelCase;
	var vendors = ['', '-webkit-', '-moz-', '-o-'];
	var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
	/**
	 * @param {number} duration
	 * @return {string}
	 * @inner
	 */
	
	function assembleTransition(duration) {
	  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
	  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
	  return zrUtil.map(vendors, function (vendorPrefix) {
	    return vendorPrefix + 'transition:' + transitionText;
	  }).join(';');
	}
	/**
	 * @param {Object} textStyle
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleFont(textStyleModel) {
	  var cssText = [];
	  var fontSize = textStyleModel.get('fontSize');
	  var color = textStyleModel.getTextColor();
	  color && cssText.push('color:' + color);
	  cssText.push('font:' + textStyleModel.getFont());
	  var lineHeight = textStyleModel.get('lineHeight');
	
	  if (lineHeight == null) {
	    lineHeight = Math.round(fontSize * 3 / 2);
	  }
	
	  fontSize && cssText.push('line-height:' + lineHeight + 'px');
	  var shadowColor = textStyleModel.get('textShadowColor');
	  var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
	  var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
	  var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
	  shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
	  each(['decoration', 'align'], function (name) {
	    var val = textStyleModel.get(name);
	    val && cssText.push('text-' + name + ':' + val);
	  });
	  return cssText.join(';');
	}
	/**
	 * @param {Object} tooltipModel
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleCssText(tooltipModel) {
	  var cssText = [];
	  var transitionDuration = tooltipModel.get('transitionDuration');
	  var backgroundColor = tooltipModel.get('backgroundColor');
	  var textStyleModel = tooltipModel.getModel('textStyle');
	  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.
	
	  transitionDuration && cssText.push(assembleTransition(transitionDuration));
	
	  if (backgroundColor) {
	    if (env.canvasSupported) {
	      cssText.push('background-Color:' + backgroundColor);
	    } else {
	      // for ie
	      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
	      cssText.push('filter:alpha(opacity=70)');
	    }
	  } // Border style
	
	
	  each(['width', 'color', 'radius'], function (name) {
	    var borderName = 'border-' + name;
	    var camelCase = toCamelCase(borderName);
	    var val = tooltipModel.get(camelCase);
	    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
	  }); // Text style
	
	  cssText.push(assembleFont(textStyleModel)); // Padding
	
	  if (padding != null) {
	    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
	  }
	
	  return cssText.join(';') + ';';
	} // If not able to make, do not modify the input `out`.
	
	
	function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
	  var zrPainter = zr && zr.painter;
	
	  if (appendToBody) {
	    var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
	
	    if (zrViewportRoot) {
	      // Some APPs might use scale on body, so we support CSS transform here.
	      domUtil.transformLocalCoord(out, zrViewportRoot, document.body, zrX, zrY);
	    }
	  } else {
	    out[0] = zrX;
	    out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
	    // the sibling of canvas root. So padding of ec container
	    // should be considered here.
	
	    var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
	
	    if (viewportRootOffset) {
	      out[0] += viewportRootOffset.offsetLeft;
	      out[1] += viewportRootOffset.offsetTop;
	    }
	  }
	
	  out[2] = out[0] / zr.getWidth(); // The ratio of left to width
	
	  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipContent
	 * @param {HTMLElement} container
	 * @param {ExtensionAPI} api
	 * @param {Object} [opt]
	 * @param {boolean} [opt.appendToBody]
	 *        `false`: the DOM element will be inside the container. Default value.
	 *        `true`: the DOM element will be appended to HTML body, which avoid
	 *                some overflow clip but intrude outside of the container.
	 * @constructor
	 */
	
	
	function TooltipContent(container, api, opt) {
	  if (env.wxa) {
	    return null;
	  }
	
	  var el = document.createElement('div');
	  el.domBelongToZr = true;
	  this.el = el;
	  var zr = this._zr = api.getZr();
	  var appendToBody = this._appendToBody = opt && opt.appendToBody;
	  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]
	
	  makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
	
	  if (appendToBody) {
	    document.body.appendChild(el);
	  } else {
	    container.appendChild(el);
	  }
	
	  this._container = container;
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout; // FIXME
	  // Is it needed to trigger zr event manually if
	  // the browser do not support `pointer-events: none`.
	
	  var self = this;
	
	  el.onmouseenter = function () {
	    // clear the timeout in hideLater and keep showing tooltip
	    if (self._enterable) {
	      clearTimeout(self._hideTimeout);
	      self._show = true;
	    }
	
	    self._inContent = true;
	  };
	
	  el.onmousemove = function (e) {
	    e = e || window.event;
	
	    if (!self._enterable) {
	      // `pointer-events: none` is set to tooltip content div
	      // if `enterable` is set as `false`, and `el.onmousemove`
	      // can not be triggered. But in browser that do not
	      // support `pointer-events`, we need to do this:
	      // Try trigger zrender event to avoid mouse
	      // in and out shape too frequently
	      var handler = zr.handler;
	      var zrViewportRoot = zr.painter.getViewportRoot();
	      eventUtil.normalizeEvent(zrViewportRoot, e, true);
	      handler.dispatch('mousemove', e);
	    }
	  };
	
	  el.onmouseleave = function () {
	    if (self._enterable) {
	      if (self._show) {
	        self.hideLater(self._hideDelay);
	      }
	    }
	
	    self._inContent = false;
	  };
	}
	
	TooltipContent.prototype = {
	  constructor: TooltipContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function (tooltipModel) {
	    // FIXME
	    // Move this logic to ec main?
	    var container = this._container;
	    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
	    var domStyle = container.style;
	
	    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
	      domStyle.position = 'relative';
	    }
	
	    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    alwaysShowContent && this._moveTooltipIfResized(); // Hide the tooltip
	    // PENDING
	    // this.hide();
	  },
	
	  /**
	   * when `alwaysShowContent` is true,
	   * we should move the tooltip after chart resized
	   */
	  _moveTooltipIfResized: function () {
	    var ratioX = this._styleCoord[2]; // The ratio of left to width
	
	    var ratioY = this._styleCoord[3]; // The ratio of top to height
	
	    var realX = ratioX * this._zr.getWidth();
	
	    var realY = ratioY * this._zr.getHeight();
	
	    this.moveTo(realX, realY);
	  },
	  show: function (tooltipModel) {
	    clearTimeout(this._hideTimeout);
	    var el = this.el;
	    var styleCoord = this._styleCoord;
	    el.style.cssText = gCssText + assembleCssText(tooltipModel) // Because of the reason described in:
	    // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
	    // we should set initial value to `left` and `top`.
	    + ';left:' + styleCoord[0] + 'px;top:' + styleCoord[1] + 'px;' + (tooltipModel.get('extraCssText') || '');
	    el.style.display = el.innerHTML ? 'block' : 'none'; // If mouse occasionally move over the tooltip, a mouseout event will be
	    // triggered by canvas, and cause some unexpectable result like dragging
	    // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
	    // it. Although it is not supported by IE8~IE10, fortunately it is a rare
	    // scenario.
	
	    el.style.pointerEvents = this._enterable ? 'auto' : 'none';
	    this._show = true;
	  },
	  setContent: function (content) {
	    this.el.innerHTML = content == null ? '' : content;
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var el = this.el;
	    return [el.clientWidth, el.clientHeight];
	  },
	  moveTo: function (zrX, zrY) {
	    var styleCoord = this._styleCoord;
	    makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
	    var style = this.el.style;
	    style.left = styleCoord[0] + 'px';
	    style.top = styleCoord[1] + 'px';
	  },
	  hide: function () {
	    this.el.style.display = 'none';
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  dispose: function () {
	    this.el.parentNode.removeChild(this.el);
	  },
	  getOuterSize: function () {
	    var width = this.el.clientWidth;
	    var height = this.el.clientHeight; // Consider browser compatibility.
	    // IE8 does not support getComputedStyle.
	
	    if (document.defaultView && document.defaultView.getComputedStyle) {
	      var stl = document.defaultView.getComputedStyle(this.el);
	
	      if (stl) {
	        width += parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
	        height += parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
	      }
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  }
	};
	var _default = TooltipContent;
	module.exports = _default;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'tooltip',
	  dependencies: ['axisPointer'],
	  defaultOption: {
	    zlevel: 0,
	    z: 60,
	    show: true,
	    // tooltip主体内容
	    showContent: true,
	    // 'trigger' only works on coordinate system.
	    // 'item' | 'axis' | 'none'
	    trigger: 'item',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: 'mousemove|click',
	    alwaysShowContent: false,
	    displayMode: 'single',
	    // 'single' | 'multipleByCoordSys'
	    renderMode: 'auto',
	    // 'auto' | 'html' | 'richText'
	    // 'auto': use html by default, and use non-html if `document` is not defined
	    // 'html': use html for tooltip
	    // 'richText': use canvas, svg, and etc. for tooltip
	    // 位置 {Array} | {Function}
	    // position: null
	    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
	    // align: null,
	    // verticalAlign: null,
	    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
	    confine: false,
	    // 内容格式器：{string}（Template） ¦ {Function}
	    // formatter: null
	    showDelay: 0,
	    // 隐藏延迟，单位ms
	    hideDelay: 100,
	    // 动画变换时间，单位s
	    transitionDuration: 0.4,
	    enterable: false,
	    // 提示背景颜色，默认为透明度为0.7的黑色
	    backgroundColor: 'rgba(50,50,50,0.7)',
	    // 提示边框颜色
	    borderColor: '#333',
	    // 提示边框圆角，单位px，默认为4
	    borderRadius: 4,
	    // 提示边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 提示内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // Extra css text
	    extraCssText: '',
	    // 坐标轴指示器，坐标轴触发有效
	    axisPointer: {
	      // 默认为直线
	      // 可选为：'line' | 'shadow' | 'cross'
	      type: 'line',
	      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
	      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
	      // 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
	      // 极坐标系会默认选择 angle 轴
	      axis: 'auto',
	      animation: 'auto',
	      animationDurationUpdate: 200,
	      animationEasingUpdate: 'exponentialOut',
	      crossStyle: {
	        color: '#999',
	        width: 1,
	        type: 'dashed',
	        // TODO formatter
	        textStyle: {} // lineStyle and shadowStyle should not be specified here,
	        // otherwise it will always override those styles on option.axisPointer.
	
	      }
	    },
	    textStyle: {
	      color: '#fff',
	      fontSize: 14
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Text = __webpack_require__(147);
	
	var graphicUtil = __webpack_require__(17);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Group from 'zrender/src/container/Group';
	function makeStyleCoord(out, zr, zrX, zrY) {
	  out[0] = zrX;
	  out[1] = zrY;
	  out[2] = out[0] / zr.getWidth(); // The ratio of left to width
	
	  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipRichContent
	 * @constructor
	 */
	
	
	function TooltipRichContent(api) {
	  var zr = this._zr = api.getZr();
	  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]
	
	  makeStyleCoord(this._styleCoord, zr, api.getWidth() / 2, api.getHeight() / 2);
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout;
	}
	
	TooltipRichContent.prototype = {
	  constructor: TooltipRichContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function (tooltipModel) {
	    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    alwaysShowContent && this._moveTooltipIfResized();
	  },
	
	  /**
	   * when `alwaysShowContent` is true,
	   * we should move the tooltip after chart resized
	   */
	  _moveTooltipIfResized: function () {
	    var ratioX = this._styleCoord[2]; // The ratio of left to width
	
	    var ratioY = this._styleCoord[3]; // The ratio of top to height
	
	    var realX = ratioX * this._zr.getWidth();
	
	    var realY = ratioY * this._zr.getHeight();
	
	    this.moveTo(realX, realY);
	  },
	  show: function (tooltipModel) {
	    if (this._hideTimeout) {
	      clearTimeout(this._hideTimeout);
	    }
	
	    this.el.attr('show', true);
	    this._show = true;
	  },
	
	  /**
	   * Set tooltip content
	   *
	   * @param {string} content rich text string of content
	   * @param {Object} markerRich rich text style
	   * @param {Object} tooltipModel tooltip model
	   */
	  setContent: function (content, markerRich, tooltipModel) {
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	
	    var markers = {};
	    var text = content;
	    var prefix = '{marker';
	    var suffix = '|}';
	    var startId = text.indexOf(prefix);
	
	    while (startId >= 0) {
	      var endId = text.indexOf(suffix);
	      var name = text.substr(startId + prefix.length, endId - startId - prefix.length);
	
	      if (name.indexOf('sub') > -1) {
	        markers['marker' + name] = {
	          textWidth: 4,
	          textHeight: 4,
	          textBorderRadius: 2,
	          textBackgroundColor: markerRich[name],
	          // TODO: textOffset is not implemented for rich text
	          textOffset: [3, 0]
	        };
	      } else {
	        markers['marker' + name] = {
	          textWidth: 10,
	          textHeight: 10,
	          textBorderRadius: 5,
	          textBackgroundColor: markerRich[name]
	        };
	      }
	
	      text = text.substr(endId + 1);
	      startId = text.indexOf('{marker');
	    }
	
	    var textStyleModel = tooltipModel.getModel('textStyle');
	    var fontSize = textStyleModel.get('fontSize');
	    var lineHeight = tooltipModel.get('textLineHeight');
	
	    if (lineHeight == null) {
	      lineHeight = Math.round(fontSize * 3 / 2);
	    }
	
	    this.el = new Text({
	      style: graphicUtil.setTextStyle({}, textStyleModel, {
	        rich: markers,
	        text: content,
	        textBackgroundColor: tooltipModel.get('backgroundColor'),
	        textBorderRadius: tooltipModel.get('borderRadius'),
	        textFill: tooltipModel.get('textStyle.color'),
	        textPadding: tooltipModel.get('padding'),
	        textLineHeight: lineHeight
	      }),
	      z: tooltipModel.get('z')
	    });
	
	    this._zr.add(this.el);
	
	    var self = this;
	    this.el.on('mouseover', function () {
	      // clear the timeout in hideLater and keep showing tooltip
	      if (self._enterable) {
	        clearTimeout(self._hideTimeout);
	        self._show = true;
	      }
	
	      self._inContent = true;
	    });
	    this.el.on('mouseout', function () {
	      if (self._enterable) {
	        if (self._show) {
	          self.hideLater(self._hideDelay);
	        }
	      }
	
	      self._inContent = false;
	    });
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var bounding = this.el.getBoundingRect();
	    return [bounding.width, bounding.height];
	  },
	  moveTo: function (x, y) {
	    if (this.el) {
	      var styleCoord = this._styleCoord;
	      makeStyleCoord(styleCoord, this._zr, x, y);
	      this.el.attr('position', [styleCoord[0], styleCoord[1]]);
	    }
	  },
	  hide: function () {
	    if (this.el) {
	      this.el.hide();
	    }
	
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  dispose: function () {
	    clearTimeout(this._hideTimeout);
	
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	  },
	  getOuterSize: function () {
	    var size = this.getSize();
	    return {
	      width: size[0],
	      height: size[1]
	    };
	  }
	};
	var _default = TooltipRichContent;
	module.exports = _default;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	var TooltipContent = __webpack_require__(1802);
	
	var TooltipRichContent = __webpack_require__(1804);
	
	var formatUtil = __webpack_require__(48);
	
	var numberUtil = __webpack_require__(24);
	
	var graphic = __webpack_require__(17);
	
	var findPointFromSeries = __webpack_require__(814);
	
	var layoutUtil = __webpack_require__(47);
	
	var Model = __webpack_require__(57);
	
	var globalListener = __webpack_require__(815);
	
	var axisHelper = __webpack_require__(96);
	
	var axisPointerViewHelper = __webpack_require__(268);
	
	var _model = __webpack_require__(27);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var parsePercent = numberUtil.parsePercent;
	var proxyRect = new graphic.Rect({
	  shape: {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  }
	});
	
	var _default = echarts.extendComponentView({
	  type: 'tooltip',
	  init: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    var tooltipModel = ecModel.getComponent('tooltip');
	    var renderMode = tooltipModel.get('renderMode');
	    this._renderMode = getTooltipRenderMode(renderMode);
	    var tooltipContent;
	
	    if (this._renderMode === 'html') {
	      tooltipContent = new TooltipContent(api.getDom(), api, {
	        appendToBody: tooltipModel.get('appendToBody', true)
	      });
	      this._newLine = '<br/>';
	    } else {
	      tooltipContent = new TooltipRichContent(api);
	      this._newLine = '\n';
	    }
	
	    this._tooltipContent = tooltipContent;
	  },
	  render: function (tooltipModel, ecModel, api) {
	    if (env.node) {
	      return;
	    } // Reset
	
	
	    this.group.removeAll();
	    /**
	     * @private
	     * @type {module:echarts/component/tooltip/TooltipModel}
	     */
	
	    this._tooltipModel = tooltipModel;
	    /**
	     * @private
	     * @type {module:echarts/model/Global}
	     */
	
	    this._ecModel = ecModel;
	    /**
	     * @private
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this._api = api;
	    /**
	     * Should be cleaned when render.
	     * @private
	     * @type {Array.<Array.<Object>>}
	     */
	
	    this._lastDataByCoordSys = null;
	    /**
	     * @private
	     * @type {boolean}
	     */
	
	    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    var tooltipContent = this._tooltipContent;
	    tooltipContent.update(tooltipModel);
	    tooltipContent.setEnterable(tooltipModel.get('enterable'));
	
	    this._initGlobalListener();
	
	    this._keepShow();
	  },
	  _initGlobalListener: function () {
	    var tooltipModel = this._tooltipModel;
	    var triggerOn = tooltipModel.get('triggerOn');
	    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none') {
	        if (triggerOn.indexOf(currTrigger) >= 0) {
	          this._tryShow(e, dispatchAction);
	        } else if (currTrigger === 'leave') {
	          this._hide(dispatchAction);
	        }
	      }
	    }, this));
	  },
	  _keepShow: function () {
	    var tooltipModel = this._tooltipModel;
	    var ecModel = this._ecModel;
	    var api = this._api; // Try to keep the tooltip show when refreshing
	
	    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
	    // self.manuallyShowTip({x, y}) might cause tooltip hide,
	    // which is not expected.
	    && tooltipModel.get('triggerOn') !== 'none') {
	      var self = this;
	      clearTimeout(this._refreshUpdateTimeout);
	      this._refreshUpdateTimeout = setTimeout(function () {
	        // Show tip next tick after other charts are rendered
	        // In case highlight action has wrong result
	        // FIXME
	        !api.isDisposed() && self.manuallyShowTip(tooltipModel, ecModel, api, {
	          x: self._lastX,
	          y: self._lastY
	        });
	      });
	    }
	  },
	
	  /**
	   * Show tip manually by
	   * dispatchAction({
	   *     type: 'showTip',
	   *     x: 10,
	   *     y: 10
	   * });
	   * Or
	   * dispatchAction({
	   *      type: 'showTip',
	   *      seriesIndex: 0,
	   *      dataIndex or dataIndexInside or name
	   * });
	   *
	   *  TODO Batch
	   */
	  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
	    if (payload.from === this.uid || env.node) {
	      return;
	    }
	
	    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket
	
	    this._ticket = ''; // When triggered from axisPointer.
	
	    var dataByCoordSys = payload.dataByCoordSys;
	
	    if (payload.tooltip && payload.x != null && payload.y != null) {
	      var el = proxyRect;
	      el.position = [payload.x, payload.y];
	      el.update();
	      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        target: el
	      }, dispatchAction);
	    } else if (dataByCoordSys) {
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        dataByCoordSys: payload.dataByCoordSys,
	        tooltipOption: payload.tooltipOption
	      }, dispatchAction);
	    } else if (payload.seriesIndex != null) {
	      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
	        return;
	      }
	
	      var pointInfo = findPointFromSeries(payload, ecModel);
	      var cx = pointInfo.point[0];
	      var cy = pointInfo.point[1];
	
	      if (cx != null && cy != null) {
	        this._tryShow({
	          offsetX: cx,
	          offsetY: cy,
	          position: payload.position,
	          target: pointInfo.el
	        }, dispatchAction);
	      }
	    } else if (payload.x != null && payload.y != null) {
	      // FIXME
	      // should wrap dispatchAction like `axisPointer/globalListener` ?
	      api.dispatchAction({
	        type: 'updateAxisPointer',
	        x: payload.x,
	        y: payload.y
	      });
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        target: api.getZr().findHover(payload.x, payload.y).target
	      }, dispatchAction);
	    }
	  },
	  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
	    var tooltipContent = this._tooltipContent;
	
	    if (!this._alwaysShowContent && this._tooltipModel) {
	      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
	    }
	
	    this._lastX = this._lastY = null;
	
	    if (payload.from !== this.uid) {
	      this._hide(makeDispatchAction(payload, api));
	    }
	  },
	  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
	  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
	  // and tooltip.
	  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
	    var seriesIndex = payload.seriesIndex;
	    var dataIndex = payload.dataIndex;
	    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
	
	    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
	      return;
	    }
	
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	
	    if (!seriesModel) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);
	
	    if (tooltipModel.get('trigger') !== 'axis') {
	      return;
	    }
	
	    api.dispatchAction({
	      type: 'updateAxisPointer',
	      seriesIndex: seriesIndex,
	      dataIndex: dataIndex,
	      position: payload.position
	    });
	    return true;
	  },
	  _tryShow: function (e, dispatchAction) {
	    var el = e.target;
	    var tooltipModel = this._tooltipModel;
	
	    if (!tooltipModel) {
	      return;
	    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
	
	
	    this._lastX = e.offsetX;
	    this._lastY = e.offsetY;
	    var dataByCoordSys = e.dataByCoordSys;
	
	    if (dataByCoordSys && dataByCoordSys.length) {
	      this._showAxisTooltip(dataByCoordSys, e);
	    } // Always show item tooltip if mouse is on the element with dataIndex
	    else if (el && el.dataIndex != null) {
	        this._lastDataByCoordSys = null;
	
	        this._showSeriesItemTooltip(e, el, dispatchAction);
	      } // Tooltip provided directly. Like legend.
	      else if (el && el.tooltip) {
	          this._lastDataByCoordSys = null;
	
	          this._showComponentItemTooltip(e, el, dispatchAction);
	        } else {
	          this._lastDataByCoordSys = null;
	
	          this._hide(dispatchAction);
	        }
	  },
	  _showOrMove: function (tooltipModel, cb) {
	    // showDelay is used in this case: tooltip.enterable is set
	    // as true. User intent to move mouse into tooltip and click
	    // something. `showDelay` makes it easier to enter the content
	    // but tooltip do not move immediately.
	    var delay = tooltipModel.get('showDelay');
	    cb = zrUtil.bind(cb, this);
	    clearTimeout(this._showTimout);
	    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
	  },
	  _showAxisTooltip: function (dataByCoordSys, e) {
	    var ecModel = this._ecModel;
	    var globalTooltipModel = this._tooltipModel;
	    var point = [e.offsetX, e.offsetY];
	    var singleDefaultHTML = [];
	    var singleParamsList = [];
	    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
	    var renderMode = this._renderMode;
	    var newLine = this._newLine;
	    var markers = {};
	    each(dataByCoordSys, function (itemCoordSys) {
	      // var coordParamList = [];
	      // var coordDefaultHTML = [];
	      // var coordTooltipModel = buildTooltipModel([
	      //     e.tooltipOption,
	      //     itemCoordSys.tooltipOption,
	      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
	      //     globalTooltipModel
	      // ]);
	      // var displayMode = coordTooltipModel.get('displayMode');
	      // var paramsList = displayMode === 'single' ? singleParamsList : [];
	      each(itemCoordSys.dataByAxis, function (item) {
	        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
	        var axisValue = item.value;
	        var seriesDefaultHTML = [];
	
	        if (!axisModel || axisValue == null) {
	          return;
	        }
	
	        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
	        zrUtil.each(item.seriesDataIndices, function (idxItem) {
	          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	          var dataIndex = idxItem.dataIndexInside;
	          var dataParams = series && series.getDataParams(dataIndex);
	          dataParams.axisDim = item.axisDim;
	          dataParams.axisIndex = item.axisIndex;
	          dataParams.axisType = item.axisType;
	          dataParams.axisId = item.axisId;
	          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
	          dataParams.axisValueLabel = valueLabel;
	
	          if (dataParams) {
	            singleParamsList.push(dataParams);
	            var seriesTooltip = series.formatTooltip(dataIndex, true, null, renderMode);
	            var html;
	
	            if (zrUtil.isObject(seriesTooltip)) {
	              html = seriesTooltip.html;
	              var newMarkers = seriesTooltip.markers;
	              zrUtil.merge(markers, newMarkers);
	            } else {
	              html = seriesTooltip;
	            }
	
	            seriesDefaultHTML.push(html);
	          }
	        }); // Default tooltip content
	        // FIXME
	        // (1) should be the first data which has name?
	        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.
	
	        var firstLine = valueLabel;
	
	        if (renderMode !== 'html') {
	          singleDefaultHTML.push(seriesDefaultHTML.join(newLine));
	        } else {
	          singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + newLine : '') + seriesDefaultHTML.join(newLine));
	        }
	      });
	    }, this); // In most case, the second axis is shown upper than the first one.
	
	    singleDefaultHTML.reverse();
	    singleDefaultHTML = singleDefaultHTML.join(this._newLine + this._newLine);
	    var positionExpr = e.position;
	
	    this._showOrMove(singleTooltipModel, function () {
	      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
	        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
	      } else {
	        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr, undefined, markers);
	      }
	    }); // Do not trigger events here, because this branch only be entered
	    // from dispatchAction.
	
	  },
	  _showSeriesItemTooltip: function (e, el, dispatchAction) {
	    var ecModel = this._ecModel; // Use dataModel in element if possible
	    // Used when mouseover on a element like markPoint or edge
	    // In which case, the data is not main data in series.
	
	    var seriesIndex = el.seriesIndex;
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
	
	    var dataModel = el.dataModel || seriesModel;
	    var dataIndex = el.dataIndex;
	    var dataType = el.dataType;
	    var data = dataModel.getData(dataType);
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
	    var tooltipTrigger = tooltipModel.get('trigger');
	
	    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
	      return;
	    }
	
	    var params = dataModel.getDataParams(dataIndex, dataType);
	    var seriesTooltip = dataModel.formatTooltip(dataIndex, false, dataType, this._renderMode);
	    var defaultHtml;
	    var markers;
	
	    if (zrUtil.isObject(seriesTooltip)) {
	      defaultHtml = seriesTooltip.html;
	      markers = seriesTooltip.markers;
	    } else {
	      defaultHtml = seriesTooltip;
	      markers = null;
	    }
	
	    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
	
	    this._showOrMove(tooltipModel, function () {
	      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markers);
	    }); // FIXME
	    // duplicated showtip if manuallyShowTip is called from dispatchAction.
	
	
	    dispatchAction({
	      type: 'showTip',
	      dataIndexInside: dataIndex,
	      dataIndex: data.getRawIndex(dataIndex),
	      seriesIndex: seriesIndex,
	      from: this.uid
	    });
	  },
	  _showComponentItemTooltip: function (e, el, dispatchAction) {
	    var tooltipOpt = el.tooltip;
	
	    if (typeof tooltipOpt === 'string') {
	      var content = tooltipOpt;
	      tooltipOpt = {
	        content: content,
	        // Fixed formatter
	        formatter: content
	      };
	    }
	
	    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
	    var defaultHtml = subTooltipModel.get('content');
	    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
	    // only works on coordinate system. In fact, we have not found case
	    // that requires setting `trigger` nothing on component yet.
	
	    this._showOrMove(subTooltipModel, function () {
	      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
	    }); // If not dispatch showTip, tip may be hide triggered by axis.
	
	
	    dispatchAction({
	      type: 'showTip',
	      from: this.uid
	    });
	  },
	  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markers) {
	    // Reset ticket
	    this._ticket = '';
	
	    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
	      return;
	    }
	
	    var tooltipContent = this._tooltipContent;
	    var formatter = tooltipModel.get('formatter');
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var html = defaultHtml;
	
	    if (formatter && typeof formatter === 'string') {
	      html = formatUtil.formatTpl(formatter, params, true);
	    } else if (typeof formatter === 'function') {
	      var callback = bind(function (cbTicket, html) {
	        if (cbTicket === this._ticket) {
	          tooltipContent.setContent(html, markers, tooltipModel);
	
	          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	        }
	      }, this);
	      this._ticket = asyncTicket;
	      html = formatter(params, asyncTicket, callback);
	    }
	
	    tooltipContent.setContent(html, markers, tooltipModel);
	    tooltipContent.show(tooltipModel);
	
	    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	  },
	
	  /**
	   * @param  {string|Function|Array.<number>|Object} positionExpr
	   * @param  {number} x Mouse x
	   * @param  {number} y Mouse y
	   * @param  {boolean} confine Whether confine tooltip content in view rect.
	   * @param  {Object|<Array.<Object>} params
	   * @param  {module:zrender/Element} el target element
	   * @param  {module:echarts/ExtensionAPI} api
	   * @return {Array.<number>}
	   */
	  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
	    var viewWidth = this._api.getWidth();
	
	    var viewHeight = this._api.getHeight();
	
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var contentSize = content.getSize();
	    var align = tooltipModel.get('align');
	    var vAlign = tooltipModel.get('verticalAlign');
	    var rect = el && el.getBoundingRect().clone();
	    el && rect.applyTransform(el.transform);
	
	    if (typeof positionExpr === 'function') {
	      // Callback of position can be an array or a string specify the position
	      positionExpr = positionExpr([x, y], params, content.el, rect, {
	        viewSize: [viewWidth, viewHeight],
	        contentSize: contentSize.slice()
	      });
	    }
	
	    if (zrUtil.isArray(positionExpr)) {
	      x = parsePercent(positionExpr[0], viewWidth);
	      y = parsePercent(positionExpr[1], viewHeight);
	    } else if (zrUtil.isObject(positionExpr)) {
	      positionExpr.width = contentSize[0];
	      positionExpr.height = contentSize[1];
	      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
	        width: viewWidth,
	        height: viewHeight
	      });
	      x = layoutRect.x;
	      y = layoutRect.y;
	      align = null; // When positionExpr is left/top/right/bottom,
	      // align and verticalAlign will not work.
	
	      vAlign = null;
	    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
	    else if (typeof positionExpr === 'string' && el) {
	        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
	        x = pos[0];
	        y = pos[1];
	      } else {
	        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
	        x = pos[0];
	        y = pos[1];
	      }
	
	    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
	    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
	
	    if (tooltipModel.get('confine')) {
	      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
	      x = pos[0];
	      y = pos[1];
	    }
	
	    content.moveTo(x, y);
	  },
	  // FIXME
	  // Should we remove this but leave this to user?
	  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
	    var lastCoordSys = this._lastDataByCoordSys;
	    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
	    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
	      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
	      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
	      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
	      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
	      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
	        var thisItem = thisDataByAxis[indexAxis] || {};
	        var lastIndices = lastItem.seriesDataIndices || [];
	        var newIndices = thisItem.seriesDataIndices || [];
	        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
	        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
	          var newIdxItem = newIndices[j];
	          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
	        });
	      });
	    });
	    this._lastDataByCoordSys = dataByCoordSys;
	    return !!contentNotChanged;
	  },
	  _hide: function (dispatchAction) {
	    // Do not directly hideLater here, because this behavior may be prevented
	    // in dispatchAction when showTip is dispatched.
	    // FIXME
	    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
	    this._lastDataByCoordSys = null;
	    dispatchAction({
	      type: 'hideTip',
	      from: this.uid
	    });
	  },
	  dispose: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    this._tooltipContent.dispose();
	
	    globalListener.unregister('itemTooltip', api);
	  }
	});
	/**
	 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
	 * From top to bottom. (the last one should be globalTooltipModel);
	 */
	
	
	function buildTooltipModel(modelCascade) {
	  var resultModel = modelCascade.pop();
	
	  while (modelCascade.length) {
	    var tooltipOpt = modelCascade.pop();
	
	    if (tooltipOpt) {
	      if (Model.isInstance(tooltipOpt)) {
	        tooltipOpt = tooltipOpt.get('tooltip', true);
	      } // In each data item tooltip can be simply write:
	      // {
	      //  value: 10,
	      //  tooltip: 'Something you need to know'
	      // }
	
	
	      if (typeof tooltipOpt === 'string') {
	        tooltipOpt = {
	          formatter: tooltipOpt
	        };
	      }
	
	      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
	    }
	  }
	
	  return resultModel;
	}
	
	function makeDispatchAction(payload, api) {
	  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	}
	
	function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	
	  if (gapH != null) {
	    if (x + width + gapH > viewWidth) {
	      x -= width + gapH;
	    } else {
	      x += gapH;
	    }
	  }
	
	  if (gapV != null) {
	    if (y + height + gapV > viewHeight) {
	      y -= height + gapV;
	    } else {
	      y += gapV;
	    }
	  }
	
	  return [x, y];
	}
	
	function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	  x = Math.min(x + width, viewWidth) - width;
	  y = Math.min(y + height, viewHeight) - height;
	  x = Math.max(x, 0);
	  y = Math.max(y, 0);
	  return [x, y];
	}
	
	function calcTooltipPosition(position, rect, contentSize) {
	  var domWidth = contentSize[0];
	  var domHeight = contentSize[1];
	  var gap = 5;
	  var x = 0;
	  var y = 0;
	  var rectWidth = rect.width;
	  var rectHeight = rect.height;
	
	  switch (position) {
	    case 'inside':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'top':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y - domHeight - gap;
	      break;
	
	    case 'bottom':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight + gap;
	      break;
	
	    case 'left':
	      x = rect.x - domWidth - gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'right':
	      x = rect.x + rectWidth + gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	  }
	
	  return [x, y];
	}
	
	function isCenterAlign(align) {
	  return align === 'center' || align === 'middle';
	}
	
	module.exports = _default;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(832);
	
	__webpack_require__(833);

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var VisualMapModel = __webpack_require__(834);
	
	var numberUtil = __webpack_require__(24);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Constant
	var DEFAULT_BAR_BOUND = [20, 140];
	var ContinuousModel = VisualMapModel.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    align: 'auto',
	    // 'auto', 'left', 'right', 'top', 'bottom'
	    calculable: false,
	    // This prop effect default component type determine,
	    // See echarts/component/visualMap/typeDefaulter.
	    range: null,
	    // selected range. In default case `range` is [min, max]
	    // and can auto change along with modification of min max,
	    // util use specifid a range.
	    realtime: true,
	    // Whether realtime update.
	    itemHeight: null,
	    // The length of the range control edge.
	    itemWidth: null,
	    // The length of the other side.
	    hoverLink: true,
	    // Enable hover highlight.
	    hoverLinkDataSize: null,
	    // The size of hovered data.
	    hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
	    // If not specified, follow the value of `realtime`.
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    ContinuousModel.superApply(this, 'optionUpdated', arguments);
	    this.resetExtent();
	    this.resetVisual(function (mappingOption) {
	      mappingOption.mappingMethod = 'linear';
	      mappingOption.dataExtent = this.getExtent();
	    });
	
	    this._resetRange();
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  resetItemSize: function () {
	    ContinuousModel.superApply(this, 'resetItemSize', arguments);
	    var itemSize = this.itemSize;
	    this._orient === 'horizontal' && itemSize.reverse();
	    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
	    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
	  },
	
	  /**
	   * @private
	   */
	  _resetRange: function () {
	    var dataExtent = this.getExtent();
	    var range = this.option.range;
	
	    if (!range || range.auto) {
	      // `range` should always be array (so we dont use other
	      // value like 'auto') for user-friend. (consider getOption).
	      dataExtent.auto = 1;
	      this.option.range = dataExtent;
	    } else if (zrUtil.isArray(range)) {
	      if (range[0] > range[1]) {
	        range.reverse();
	      }
	
	      range[0] = Math.max(range[0], dataExtent[0]);
	      range[1] = Math.min(range[1], dataExtent[1]);
	    }
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	    zrUtil.each(this.stateList, function (state) {
	      var symbolSize = this.option.controller[state].symbolSize;
	
	      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
	        symbolSize[0] = 0; // For good looking.
	      }
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.range = selected.slice();
	
	    this._resetRange();
	  },
	
	  /**
	   * @public
	   */
	  getSelected: function () {
	    var dataExtent = this.getExtent();
	    var dataInterval = numberUtil.asc((this.get('range') || []).slice()); // Clamp
	
	    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
	    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
	    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
	    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
	    return dataInterval;
	  },
	
	  /**
	   * @override
	   */
	  getValueState: function (value) {
	    var range = this.option.range;
	    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
	    // range[1] is processed likewise.
	
	    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
	  },
	
	  /**
	   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
	   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (range) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @implement
	   */
	  getVisualMeta: function (getColorVisual) {
	    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
	    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
	    var stops = [];
	
	    function setStop(value, valueState) {
	      stops.push({
	        value: value,
	        color: getColorVisual(value, valueState)
	      });
	    } // Format to: outOfRange -- inRange -- outOfRange.
	
	
	    var iIdx = 0;
	    var oIdx = 0;
	    var iLen = iVals.length;
	    var oLen = oVals.length;
	
	    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
	      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
	      if (oVals[oIdx] < iVals[iIdx]) {
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
	      // If range is full, value beyond min, max will be clamped.
	      // make a singularity
	      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
	      setStop(iVals[iIdx], 'inRange');
	    }
	
	    for (var first = 1; oIdx < oLen; oIdx++) {
	      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
	        // make a singularity
	        if (first) {
	          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
	          first = 0;
	        }
	
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    var stopsLen = stops.length;
	    return {
	      stops: stops,
	      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
	    };
	  }
	});
	
	function getColorStopValues(visualMapModel, valueState, dataExtent) {
	  if (dataExtent[0] === dataExtent[1]) {
	    return dataExtent.slice();
	  } // When using colorHue mapping, it is not linear color any more.
	  // Moreover, canvas gradient seems not to be accurate linear.
	  // FIXME
	  // Should be arbitrary value 100? or based on pixel size?
	
	
	  var count = 200;
	  var step = (dataExtent[1] - dataExtent[0]) / count;
	  var value = dataExtent[0];
	  var stopValues = [];
	
	  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
	    stopValues.push(value);
	    value += step;
	  }
	
	  stopValues.push(dataExtent[1]);
	  return stopValues;
	}
	
	var _default = ContinuousModel;
	module.exports = _default;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var LinearGradient = __webpack_require__(448);
	
	var eventTool = __webpack_require__(104);
	
	var VisualMapView = __webpack_require__(835);
	
	var graphic = __webpack_require__(17);
	
	var numberUtil = __webpack_require__(24);
	
	var sliderMove = __webpack_require__(174);
	
	var helper = __webpack_require__(836);
	
	var modelUtil = __webpack_require__(27);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var linearMap = numberUtil.linearMap;
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max; // Arbitrary value
	
	var HOVER_LINK_SIZE = 12;
	var HOVER_LINK_OUT = 6; // Notice:
	// Any "interval" should be by the order of [low, high].
	// "handle0" (handleIndex === 0) maps to
	// low data value: this._dataInterval[0] and has low coord.
	// "handle1" (handleIndex === 1) maps to
	// high data value: this._dataInterval[1] and has high coord.
	// The logic of transform is implemented in this._createBarGroup.
	
	var ContinuousView = VisualMapView.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @override
	   */
	  init: function () {
	    ContinuousView.superApply(this, 'init', arguments);
	    /**
	     * @private
	     */
	
	    this._shapes = {};
	    /**
	     * @private
	     */
	
	    this._dataInterval = [];
	    /**
	     * @private
	     */
	
	    this._handleEnds = [];
	    /**
	     * @private
	     */
	
	    this._orient;
	    /**
	     * @private
	     */
	
	    this._useHandle;
	    /**
	     * @private
	     */
	
	    this._hoverLinkDataIndices = [];
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._hovering;
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function (visualMapModel, ecModel, api, payload) {
	    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
	      this._buildView();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _buildView: function () {
	    this.group.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var thisGroup = this.group;
	    this._orient = visualMapModel.get('orient');
	    this._useHandle = visualMapModel.get('calculable');
	
	    this._resetInterval();
	
	    this._renderBar(thisGroup);
	
	    var dataRangeText = visualMapModel.get('text');
	
	    this._renderEndsText(thisGroup, dataRangeText, 0);
	
	    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.
	
	
	    this._updateView(true); // After updating view, inner shapes is built completely,
	    // and then background can be rendered.
	
	
	    this.renderBackground(thisGroup); // Real update view
	
	    this._updateView();
	
	    this._enableHoverLinkToSeries();
	
	    this._enableHoverLinkFromSeries();
	
	    this.positionGroup(thisGroup);
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, dataRangeText, endsIndex) {
	    if (!dataRangeText) {
	      return;
	    } // Compatible with ec2, text[0] map to high value, text[1] map low value.
	
	
	    var text = dataRangeText[1 - endsIndex];
	    text = text != null ? text + '' : '';
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var itemSize = visualMapModel.itemSize;
	    var barGroup = this._shapes.barGroup;
	
	    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);
	
	    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
	
	    var orient = this._orient;
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    this.group.add(new graphic.Text({
	      style: {
	        x: position[0],
	        y: position[1],
	        textVerticalAlign: orient === 'horizontal' ? 'middle' : align,
	        textAlign: orient === 'horizontal' ? align : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderBar: function (targetGroup) {
	    var visualMapModel = this.visualMapModel;
	    var shapes = this._shapes;
	    var itemSize = visualMapModel.itemSize;
	    var orient = this._orient;
	    var useHandle = this._useHandle;
	    var itemAlign = helper.getItemAlign(visualMapModel, this.api, itemSize);
	
	    var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar
	
	
	    barGroup.add(shapes.outOfRange = createPolygon());
	    barGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, zrUtil.bind(this._dragHandle, this, 'all', false), zrUtil.bind(this._dragHandle, this, 'all', true)));
	    var textRect = visualMapModel.textStyleModel.getTextRect('国');
	    var textSize = mathMax(textRect.width, textRect.height); // Handle
	
	    if (useHandle) {
	      shapes.handleThumbs = [];
	      shapes.handleLabels = [];
	      shapes.handleLabelPoints = [];
	
	      this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);
	
	      this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
	    }
	
	    this._createIndicator(barGroup, itemSize, textSize, orient);
	
	    targetGroup.add(barGroup);
	  },
	
	  /**
	   * @private
	   */
	  _createHandle: function (barGroup, handleIndex, itemSize, textSize, orient) {
	    var onDrift = zrUtil.bind(this._dragHandle, this, handleIndex, false);
	    var onDragEnd = zrUtil.bind(this._dragHandle, this, handleIndex, true);
	    var handleThumb = createPolygon(createHandlePoints(handleIndex, textSize), getCursor(this._orient), onDrift, onDragEnd);
	    handleThumb.position[0] = itemSize[0];
	    barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
	    // transform (orient/inverse). So label is built separately but not
	    // use zrender/graphic/helper/RectText, and is located based on view
	    // group (according to handleLabelPoint) but not barGroup.
	
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var handleLabel = new graphic.Text({
	      draggable: true,
	      drift: onDrift,
	      onmousemove: function (e) {
	        // Fot mobile devicem, prevent screen slider on the button.
	        eventTool.stop(e.event);
	      },
	      ondragend: onDragEnd,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(handleLabel);
	    var handleLabelPoint = [orient === 'horizontal' ? textSize / 2 : textSize * 1.5, orient === 'horizontal' ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2];
	    var shapes = this._shapes;
	    shapes.handleThumbs[handleIndex] = handleThumb;
	    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
	    shapes.handleLabels[handleIndex] = handleLabel;
	  },
	
	  /**
	   * @private
	   */
	  _createIndicator: function (barGroup, itemSize, textSize, orient) {
	    var indicator = createPolygon([[0, 0]], 'move');
	    indicator.position[0] = itemSize[0];
	    indicator.attr({
	      invisible: true,
	      silent: true
	    });
	    barGroup.add(indicator);
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var indicatorLabel = new graphic.Text({
	      silent: true,
	      invisible: true,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(indicatorLabel);
	    var indicatorLabelPoint = [orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT + 3, 0];
	    var shapes = this._shapes;
	    shapes.indicator = indicator;
	    shapes.indicatorLabel = indicatorLabel;
	    shapes.indicatorLabelPoint = indicatorLabelPoint;
	  },
	
	  /**
	   * @private
	   */
	  _dragHandle: function (handleIndex, isEnd, dx, dy) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    this._dragging = !isEnd;
	
	    if (!isEnd) {
	      // Transform dx, dy to bar coordination.
	      var vertex = this._applyTransform([dx, dy], this._shapes.barGroup, true);
	
	      this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
	      // before dispatch action.
	
	
	      this._updateView();
	    } // dragEnd do not dispatch action when realtime.
	
	
	    if (isEnd === !this.visualMapModel.get('realtime')) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'selectDataRange',
	        from: this.uid,
	        visualMapId: this.visualMapModel.id,
	        selected: this._dataInterval.slice()
	      });
	    }
	
	    if (isEnd) {
	      !this._hovering && this._clearHoverLinkToSeries();
	    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
	      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var visualMapModel = this.visualMapModel;
	    var dataInterval = this._dataInterval = visualMapModel.getSelected();
	    var dataExtent = visualMapModel.getExtent();
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} dx
	   * @param {number} dy
	   */
	  _updateInterval: function (handleIndex, delta) {
	    delta = delta || 0;
	    var visualMapModel = this.visualMapModel;
	    var handleEnds = this._handleEnds;
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
	    0);
	    var dataExtent = visualMapModel.getExtent(); // Update data interval.
	
	    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (forSketch) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var shapes = this._shapes;
	    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
	    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
	
	    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
	
	    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
	
	    shapes.inRange.setStyle({
	      fill: visualInRange.barColor,
	      opacity: visualInRange.opacity
	    }).setShape('points', visualInRange.barPoints);
	    shapes.outOfRange.setStyle({
	      fill: visualOutOfRange.barColor,
	      opacity: visualOutOfRange.opacity
	    }).setShape('points', visualOutOfRange.barPoints);
	
	    this._updateHandle(inRangeHandleEnds, visualInRange);
	  },
	
	  /**
	   * @private
	   */
	  _createBarVisual: function (dataInterval, dataExtent, handleEnds, forceState) {
	    var opts = {
	      forceState: forceState,
	      convertOpacityToAlpha: true
	    };
	
	    var colorStops = this._makeColorGradient(dataInterval, opts);
	
	    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];
	
	    var barPoints = this._createBarPoints(handleEnds, symbolSizes);
	
	    return {
	      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
	      barPoints: barPoints,
	      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
	    };
	  },
	
	  /**
	   * @private
	   */
	  _makeColorGradient: function (dataInterval, opts) {
	    // Considering colorHue, which is not linear, so we have to sample
	    // to calculate gradient color stops, but not only caculate head
	    // and tail.
	    var sampleNumber = 100; // Arbitrary value.
	
	    var colorStops = [];
	    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[0], 'color', opts),
	      offset: 0
	    });
	
	    for (var i = 1; i < sampleNumber; i++) {
	      var currValue = dataInterval[0] + step * i;
	
	      if (currValue > dataInterval[1]) {
	        break;
	      }
	
	      colorStops.push({
	        color: this.getControllerVisual(currValue, 'color', opts),
	        offset: i / sampleNumber
	      });
	    }
	
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[1], 'color', opts),
	      offset: 1
	    });
	    return colorStops;
	  },
	
	  /**
	   * @private
	   */
	  _createBarPoints: function (handleEnds, symbolSizes) {
	    var itemSize = this.visualMapModel.itemSize;
	    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
	  },
	
	  /**
	   * @private
	   */
	  _createBarGroup: function (itemAlign) {
	    var orient = this._orient;
	    var inverse = this.visualMapModel.get('inverse');
	    return new graphic.Group(orient === 'horizontal' && !inverse ? {
	      scale: itemAlign === 'bottom' ? [1, 1] : [-1, 1],
	      rotation: Math.PI / 2
	    } : orient === 'horizontal' && inverse ? {
	      scale: itemAlign === 'bottom' ? [-1, 1] : [1, 1],
	      rotation: -Math.PI / 2
	    } : orient === 'vertical' && !inverse ? {
	      scale: itemAlign === 'left' ? [1, -1] : [-1, -1]
	    } : {
	      scale: itemAlign === 'left' ? [1, 1] : [-1, 1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _updateHandle: function (handleEnds, visualInRange) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    var shapes = this._shapes;
	    var visualMapModel = this.visualMapModel;
	    var handleThumbs = shapes.handleThumbs;
	    var handleLabels = shapes.handleLabels;
	    each([0, 1], function (handleIndex) {
	      var handleThumb = handleThumbs[handleIndex];
	      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
	      handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.
	
	      var textPoint = graphic.applyTransform(shapes.handleLabelPoints[handleIndex], graphic.getTransform(handleThumb, this.group));
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
	        textVerticalAlign: 'middle',
	        textAlign: this._applyTransform(this._orient === 'horizontal' ? handleIndex === 0 ? 'bottom' : 'top' : 'left', shapes.barGroup)
	      });
	    }, this);
	  },
	
	  /**
	   * @private
	   * @param {number} cursorValue
	   * @param {number} textValue
	   * @param {string} [rangeSymbol]
	   * @param {number} [halfHoverLinkSize]
	   */
	  _showIndicator: function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var itemSize = visualMapModel.itemSize;
	    var sizeExtent = [0, itemSize[1]];
	    var pos = linearMap(cursorValue, dataExtent, sizeExtent, true);
	    var shapes = this._shapes;
	    var indicator = shapes.indicator;
	
	    if (!indicator) {
	      return;
	    }
	
	    indicator.position[1] = pos;
	    indicator.attr('invisible', false);
	    indicator.setShape('points', createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
	    var opts = {
	      convertOpacityToAlpha: true
	    };
	    var color = this.getControllerVisual(cursorValue, 'color', opts);
	    indicator.setStyle('fill', color); // Update handle label position.
	
	    var textPoint = graphic.applyTransform(shapes.indicatorLabelPoint, graphic.getTransform(indicator, this.group));
	    var indicatorLabel = shapes.indicatorLabel;
	    indicatorLabel.attr('invisible', false);
	
	    var align = this._applyTransform('left', shapes.barGroup);
	
	    var orient = this._orient;
	    indicatorLabel.setStyle({
	      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
	      textVerticalAlign: orient === 'horizontal' ? align : 'middle',
	      textAlign: orient === 'horizontal' ? 'center' : align,
	      x: textPoint[0],
	      y: textPoint[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkToSeries: function () {
	    var self = this;
	
	    this._shapes.barGroup.on('mousemove', function (e) {
	      self._hovering = true;
	
	      if (!self._dragging) {
	        var itemSize = self.visualMapModel.itemSize;
	
	        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
	        // below or upper than sizeExtent.
	
	
	        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);
	
	        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
	      }
	    }).on('mouseout', function () {
	      // When mouse is out of handle, hoverLink still need
	      // to be displayed when realtime is set as false.
	      self._hovering = false;
	      !self._dragging && self._clearHoverLinkToSeries();
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkFromSeries: function () {
	    var zr = this.api.getZr();
	
	    if (this.visualMapModel.option.hoverLink) {
	      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
	      zr.on('mouseout', this._hideIndicator, this);
	    } else {
	      this._clearHoverLinkFromSeries();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doHoverLinkToSeries: function (cursorPos, hoverOnBar) {
	    var visualMapModel = this.visualMapModel;
	    var itemSize = visualMapModel.itemSize;
	
	    if (!visualMapModel.option.hoverLink) {
	      return;
	    }
	
	    var sizeExtent = [0, itemSize[1]];
	    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.
	
	    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
	    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
	    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
	    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
	    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
	    // where china and india has very large population.
	
	    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
	    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
	    // otherwise labels overlap, especially when dragging.
	
	    if (hoverOnBar) {
	      if (valueRange[0] === -Infinity) {
	        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
	      } else if (valueRange[1] === Infinity) {
	        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
	      } else {
	        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
	      }
	    } // When realtime is set as false, handles, which are in barGroup,
	    // also trigger hoverLink, which help user to realize where they
	    // focus on when dragging. (see test/heatmap-large.html)
	    // When realtime is set as true, highlight will not show when hover
	    // handle, because the label on handle, which displays a exact value
	    // but not range, might mislead users.
	
	
	    var oldBatch = this._hoverLinkDataIndices;
	    var newBatch = [];
	
	    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
	      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
	    }
	
	    var resultBatches = modelUtil.compressBatches(oldBatch, newBatch);
	
	    this._dispatchHighDown('downplay', helper.makeHighDownBatch(resultBatches[0], visualMapModel));
	
	    this._dispatchHighDown('highlight', helper.makeHighDownBatch(resultBatches[1], visualMapModel));
	  },
	
	  /**
	   * @private
	   */
	  _hoverLinkFromSeriesMouseOver: function (e) {
	    var el = e.target;
	    var visualMapModel = this.visualMapModel;
	
	    if (!el || el.dataIndex == null) {
	      return;
	    }
	
	    var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);
	
	    if (!visualMapModel.isTargetSeries(dataModel)) {
	      return;
	    }
	
	    var data = dataModel.getData(el.dataType);
	    var value = data.get(visualMapModel.getDataDimension(data), el.dataIndex, true);
	
	    if (!isNaN(value)) {
	      this._showIndicator(value, value);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _hideIndicator: function () {
	    var shapes = this._shapes;
	    shapes.indicator && shapes.indicator.attr('invisible', true);
	    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkToSeries: function () {
	    this._hideIndicator();
	
	    var indices = this._hoverLinkDataIndices;
	
	    this._dispatchHighDown('downplay', helper.makeHighDownBatch(indices, this.visualMapModel));
	
	    indices.length = 0;
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkFromSeries: function () {
	    this._hideIndicator();
	
	    var zr = this.api.getZr();
	    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
	    zr.off('mouseout', this._hideIndicator);
	  },
	
	  /**
	   * @private
	   */
	  _applyTransform: function (vertex, element, inverse, global) {
	    var transform = graphic.getTransform(element, global ? null : this.group);
	    return graphic[zrUtil.isArray(vertex) ? 'applyTransform' : 'transformDirection'](vertex, transform, inverse);
	  },
	
	  /**
	   * @private
	   */
	  _dispatchHighDown: function (type, batch) {
	    batch && batch.length && this.api.dispatchAction({
	      type: type,
	      batch: batch
	    });
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  }
	});
	
	function createPolygon(points, cursor, onDrift, onDragEnd) {
	  return new graphic.Polygon({
	    shape: {
	      points: points
	    },
	    draggable: !!onDrift,
	    cursor: cursor,
	    drift: onDrift,
	    onmousemove: function (e) {
	      // Fot mobile devicem, prevent screen slider on the button.
	      eventTool.stop(e.event);
	    },
	    ondragend: onDragEnd
	  });
	}
	
	function createHandlePoints(handleIndex, textSize) {
	  return handleIndex === 0 ? [[0, 0], [textSize, 0], [textSize, -textSize]] : [[0, 0], [textSize, 0], [textSize, textSize]];
	}
	
	function createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
	  return isRange ? [// indicate range
	  [0, -mathMin(halfHoverLinkSize, mathMax(pos, 0))], [HOVER_LINK_OUT, 0], [0, mathMin(halfHoverLinkSize, mathMax(extentMax - pos, 0))]] : [// indicate single value
	  [0, 0], [5, -5], [5, 5]];
	}
	
	function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
	  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
	  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
	
	  if (hoverLinkDataSize) {
	    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
	  }
	
	  return halfHoverLinkSize;
	}
	
	function useHoverLinkOnHandle(visualMapModel) {
	  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
	  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = ContinuousView;
	module.exports = _default;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var VisualMapModel = __webpack_require__(834);
	
	var VisualMapping = __webpack_require__(144);
	
	var visualDefault = __webpack_require__(857);
	
	var _number = __webpack_require__(24);
	
	var reformIntervals = _number.reformIntervals;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseModel = VisualMapModel.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * Order Rule:
	   *
	   * option.categories / option.pieces / option.text / option.selected:
	   *     If !option.inverse,
	   *     Order when vertical: ['top', ..., 'bottom'].
	   *     Order when horizontal: ['left', ..., 'right'].
	   *     If option.inverse, the meaning of
	   *     the order should be reversed.
	   *
	   * this._pieceList:
	   *     The order is always [low, ..., high].
	   *
	   * Mapping from location to low-high:
	   *     If !option.inverse
	   *     When vertical, top is high.
	   *     When horizontal, right is high.
	   *     If option.inverse, reverse.
	   */
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    selected: null,
	    // Object. If not specified, means selected.
	    // When pieces and splitNumber: {'0': true, '5': true}
	    // When categories: {'cate1': false, 'cate3': true}
	    // When selected === false, means all unselected.
	    minOpen: false,
	    // Whether include values that smaller than `min`.
	    maxOpen: false,
	    // Whether include values that bigger than `max`.
	    align: 'auto',
	    // 'auto', 'left', 'right'
	    itemWidth: 20,
	    // When put the controller vertically, it is the length of
	    // horizontal side of each item. Otherwise, vertical side.
	    itemHeight: 14,
	    // When put the controller vertically, it is the length of
	    // vertical side of each item. Otherwise, horizontal side.
	    itemSymbol: 'roundRect',
	    pieceList: null,
	    // Each item is Object, with some of those attrs:
	    // {min, max, lt, gt, lte, gte, value,
	    // color, colorSaturation, colorAlpha, opacity,
	    // symbol, symbolSize}, which customize the range or visual
	    // coding of the certain piece. Besides, see "Order Rule".
	    categories: null,
	    // category names, like: ['some1', 'some2', 'some3'].
	    // Attr min/max are ignored when categories set. See "Order Rule"
	    splitNumber: 5,
	    // If set to 5, auto split five pieces equally.
	    // If set to 0 and component type not set, component type will be
	    // determined as "continuous". (It is less reasonable but for ec2
	    // compatibility, see echarts/component/visualMap/typeDefaulter)
	    selectedMode: 'multiple',
	    // Can be 'multiple' or 'single'.
	    itemGap: 10,
	    // The gap between two items, in px.
	    hoverLink: true,
	    // Enable hover highlight.
	    showLabel: null // By default, when text is used, label will hide (the logic
	    // is remained for compatibility reason)
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    PiecewiseModel.superApply(this, 'optionUpdated', arguments);
	    /**
	     * The order is always [low, ..., high].
	     * [{text: string, interval: Array.<number>}, ...]
	     * @private
	     * @type {Array.<Object>}
	     */
	
	    this._pieceList = [];
	    this.resetExtent();
	    /**
	     * 'pieces', 'categories', 'splitNumber'
	     * @type {string}
	     */
	
	    var mode = this._mode = this._determineMode();
	
	    resetMethods[this._mode].call(this);
	
	    this._resetSelected(newOption, isInit);
	
	    var categories = this.option.categories;
	    this.resetVisual(function (mappingOption, state) {
	      if (mode === 'categories') {
	        mappingOption.mappingMethod = 'category';
	        mappingOption.categories = zrUtil.clone(categories);
	      } else {
	        mappingOption.dataExtent = this.getExtent();
	        mappingOption.mappingMethod = 'piecewise';
	        mappingOption.pieceList = zrUtil.map(this._pieceList, function (piece) {
	          var piece = zrUtil.clone(piece);
	
	          if (state !== 'inRange') {
	            // FIXME
	            // outOfRange do not support special visual in pieces.
	            piece.visual = null;
	          }
	
	          return piece;
	        });
	      }
	    });
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    // Consider this case:
	    // visualMap: {
	    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
	    // }
	    // where no inRange/outOfRange set but only pieces. So we should make
	    // default inRange/outOfRange for this case, otherwise visuals that only
	    // appear in `pieces` will not be taken into account in visual encoding.
	    var option = this.option;
	    var visualTypesInPieces = {};
	    var visualTypes = VisualMapping.listVisualTypes();
	    var isCategory = this.isCategory();
	    zrUtil.each(option.pieces, function (piece) {
	      zrUtil.each(visualTypes, function (visualType) {
	        if (piece.hasOwnProperty(visualType)) {
	          visualTypesInPieces[visualType] = 1;
	        }
	      });
	    });
	    zrUtil.each(visualTypesInPieces, function (v, visualType) {
	      var exists = 0;
	      zrUtil.each(this.stateList, function (state) {
	        exists |= has(option, state, visualType) || has(option.target, state, visualType);
	      }, this);
	      !exists && zrUtil.each(this.stateList, function (state) {
	        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
	      });
	    }, this);
	
	    function has(obj, state, visualType) {
	      return obj && obj[state] && (zrUtil.isObject(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
	      );
	    }
	
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	  },
	  _resetSelected: function (newOption, isInit) {
	    var thisOption = this.option;
	    var pieceList = this._pieceList; // Selected do not merge but all override.
	
	    var selected = (isInit ? thisOption : newOption).selected || {};
	    thisOption.selected = selected; // Consider 'not specified' means true.
	
	    zrUtil.each(pieceList, function (piece, index) {
	      var key = this.getSelectedMapKey(piece);
	
	      if (!selected.hasOwnProperty(key)) {
	        selected[key] = true;
	      }
	    }, this);
	
	    if (thisOption.selectedMode === 'single') {
	      // Ensure there is only one selected.
	      var hasSel = false;
	      zrUtil.each(pieceList, function (piece, index) {
	        var key = this.getSelectedMapKey(piece);
	
	        if (selected[key]) {
	          hasSel ? selected[key] = false : hasSel = true;
	        }
	      }, this);
	    } // thisOption.selectedMode === 'multiple', default: all selected.
	
	  },
	
	  /**
	   * @public
	   */
	  getSelectedMapKey: function (piece) {
	    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
	  },
	
	  /**
	   * @public
	   */
	  getPieceList: function () {
	    return this._pieceList;
	  },
	
	  /**
	   * @private
	   * @return {string}
	   */
	  _determineMode: function () {
	    var option = this.option;
	    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.selected = zrUtil.clone(selected);
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getValueState: function (value) {
	    var index = VisualMapping.findPieceIndex(value, this._pieceList);
	    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
	  },
	
	  /**
	   * @public
	   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
	   * @return {Array.<Object>} [{seriesId, dataIndex: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (pieceIndex) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        // Should always base on model pieceList, because it is order sensitive.
	        var pIdx = VisualMapping.findPieceIndex(value, this._pieceList);
	        pIdx === pieceIndex && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @private
	   * @param {Object} piece piece.value or piece.interval is required.
	   * @return {number} Can be Infinity or -Infinity
	   */
	  getRepresentValue: function (piece) {
	    var representValue;
	
	    if (this.isCategory()) {
	      representValue = piece.value;
	    } else {
	      if (piece.value != null) {
	        representValue = piece.value;
	      } else {
	        var pieceInterval = piece.interval || [];
	        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
	      }
	    }
	
	    return representValue;
	  },
	  getVisualMeta: function (getColorVisual) {
	    // Do not support category. (category axis is ordinal, numerical)
	    if (this.isCategory()) {
	      return;
	    }
	
	    var stops = [];
	    var outerColors = [];
	    var visualMapModel = this;
	
	    function setStop(interval, valueState) {
	      var representValue = visualMapModel.getRepresentValue({
	        interval: interval
	      });
	
	      if (!valueState) {
	        valueState = visualMapModel.getValueState(representValue);
	      }
	
	      var color = getColorVisual(representValue, valueState);
	
	      if (interval[0] === -Infinity) {
	        outerColors[0] = color;
	      } else if (interval[1] === Infinity) {
	        outerColors[1] = color;
	      } else {
	        stops.push({
	          value: interval[0],
	          color: color
	        }, {
	          value: interval[1],
	          color: color
	        });
	      }
	    } // Suplement
	
	
	    var pieceList = this._pieceList.slice();
	
	    if (!pieceList.length) {
	      pieceList.push({
	        interval: [-Infinity, Infinity]
	      });
	    } else {
	      var edge = pieceList[0].interval[0];
	      edge !== -Infinity && pieceList.unshift({
	        interval: [-Infinity, edge]
	      });
	      edge = pieceList[pieceList.length - 1].interval[1];
	      edge !== Infinity && pieceList.push({
	        interval: [edge, Infinity]
	      });
	    }
	
	    var curr = -Infinity;
	    zrUtil.each(pieceList, function (piece) {
	      var interval = piece.interval;
	
	      if (interval) {
	        // Fulfill gap.
	        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
	        setStop(interval.slice());
	        curr = interval[1];
	      }
	    }, this);
	    return {
	      stops: stops,
	      outerColors: outerColors
	    };
	  }
	});
	/**
	 * Key is this._mode
	 * @type {Object}
	 * @this {module:echarts/component/viusalMap/PiecewiseMode}
	 */
	
	var resetMethods = {
	  splitNumber: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    var precision = Math.min(thisOption.precision, 20);
	    var dataExtent = this.getExtent();
	    var splitNumber = thisOption.splitNumber;
	    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
	    thisOption.splitNumber = splitNumber;
	    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption
	
	    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
	      precision++;
	    }
	
	    thisOption.precision = precision;
	    splitStep = +splitStep.toFixed(precision);
	
	    if (thisOption.minOpen) {
	      pieceList.push({
	        interval: [-Infinity, dataExtent[0]],
	        close: [0, 0]
	      });
	    }
	
	    for (var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++) {
	      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
	      pieceList.push({
	        interval: [curr, max],
	        close: [1, 1]
	      });
	    }
	
	    if (thisOption.maxOpen) {
	      pieceList.push({
	        interval: [dataExtent[1], Infinity],
	        close: [0, 0]
	      });
	    }
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece, index) {
	      piece.index = index;
	      piece.text = this.formatValueText(piece.interval);
	    }, this);
	  },
	  categories: function () {
	    var thisOption = this.option;
	    zrUtil.each(thisOption.categories, function (cate) {
	      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
	      // 是否改一致。
	      this._pieceList.push({
	        text: this.formatValueText(cate, true),
	        value: cate
	      });
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, this._pieceList);
	  },
	  pieces: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    zrUtil.each(thisOption.pieces, function (pieceListItem, index) {
	      if (!zrUtil.isObject(pieceListItem)) {
	        pieceListItem = {
	          value: pieceListItem
	        };
	      }
	
	      var item = {
	        text: '',
	        index: index
	      };
	
	      if (pieceListItem.label != null) {
	        item.text = pieceListItem.label;
	      }
	
	      if (pieceListItem.hasOwnProperty('value')) {
	        var value = item.value = pieceListItem.value;
	        item.interval = [value, value];
	        item.close = [1, 1];
	      } else {
	        // `min` `max` is legacy option.
	        // `lt` `gt` `lte` `gte` is recommanded.
	        var interval = item.interval = [];
	        var close = item.close = [0, 0];
	        var closeList = [1, 0, 1];
	        var infinityList = [-Infinity, Infinity];
	        var useMinMax = [];
	
	        for (var lg = 0; lg < 2; lg++) {
	          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];
	
	          for (var i = 0; i < 3 && interval[lg] == null; i++) {
	            interval[lg] = pieceListItem[names[i]];
	            close[lg] = closeList[i];
	            useMinMax[lg] = i === 2;
	          }
	
	          interval[lg] == null && (interval[lg] = infinityList[lg]);
	        }
	
	        useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
	        useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);
	
	        if (interval[0] === interval[1] && close[0] && close[1]) {
	          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
	          // we use value to lift the priority when min === max
	          item.value = interval[0];
	        }
	      }
	
	      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
	      pieceList.push(item);
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, pieceList); // Only pieces
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece) {
	      var close = piece.close;
	      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
	      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
	    }, this);
	  }
	};
	
	function normalizeReverse(thisOption, pieceList) {
	  var inverse = thisOption.inverse;
	
	  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
	    pieceList.reverse();
	  }
	}
	
	var _default = PiecewiseModel;
	module.exports = _default;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var VisualMapView = __webpack_require__(835);
	
	var graphic = __webpack_require__(17);
	
	var _symbol = __webpack_require__(89);
	
	var createSymbol = _symbol.createSymbol;
	
	var layout = __webpack_require__(47);
	
	var helper = __webpack_require__(836);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseVisualMapView = VisualMapView.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var textStyleModel = visualMapModel.textStyleModel;
	    var textFont = textStyleModel.getFont();
	    var textFill = textStyleModel.getTextColor();
	
	    var itemAlign = this._getItemAlign();
	
	    var itemSize = visualMapModel.itemSize;
	
	    var viewData = this._getViewData();
	
	    var endsText = viewData.endsText;
	    var showLabel = zrUtil.retrieve(visualMapModel.get('showLabel', true), !endsText);
	    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
	    zrUtil.each(viewData.viewPieceList, renderItem, this);
	    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
	    layout.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
	    this.renderBackground(thisGroup);
	    this.positionGroup(thisGroup);
	
	    function renderItem(item) {
	      var piece = item.piece;
	      var itemGroup = new graphic.Group();
	      itemGroup.onclick = zrUtil.bind(this._onItemClick, this, piece);
	
	      this._enableHoverLink(itemGroup, item.indexInModelPieceList);
	
	      var representValue = visualMapModel.getRepresentValue(piece);
	
	      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);
	
	      if (showLabel) {
	        var visualState = this.visualMapModel.getValueState(representValue);
	        itemGroup.add(new graphic.Text({
	          style: {
	            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
	            y: itemSize[1] / 2,
	            text: piece.text,
	            textVerticalAlign: 'middle',
	            textAlign: itemAlign,
	            textFont: textFont,
	            textFill: textFill,
	            opacity: visualState === 'outOfRange' ? 0.5 : 1
	          }
	        }));
	      }
	
	      thisGroup.add(itemGroup);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLink: function (itemGroup, pieceIndex) {
	    itemGroup.on('mouseover', zrUtil.bind(onHoverLink, this, 'highlight')).on('mouseout', zrUtil.bind(onHoverLink, this, 'downplay'));
	
	    function onHoverLink(method) {
	      var visualMapModel = this.visualMapModel;
	      visualMapModel.option.hoverLink && this.api.dispatchAction({
	        type: method,
	        batch: helper.makeHighDownBatch(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _getItemAlign: function () {
	    var visualMapModel = this.visualMapModel;
	    var modelOption = visualMapModel.option;
	
	    if (modelOption.orient === 'vertical') {
	      return helper.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
	    } else {
	      // horizontal, most case left unless specifying right.
	      var align = modelOption.align;
	
	      if (!align || align === 'auto') {
	        align = 'left';
	      }
	
	      return align;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, text, itemSize, showLabel, itemAlign) {
	    if (!text) {
	      return;
	    }
	
	    var itemGroup = new graphic.Group();
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    itemGroup.add(new graphic.Text({
	      style: {
	        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
	        y: itemSize[1] / 2,
	        textVerticalAlign: 'middle',
	        textAlign: showLabel ? itemAlign : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	    group.add(itemGroup);
	  },
	
	  /**
	   * @private
	   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
	   */
	  _getViewData: function () {
	    var visualMapModel = this.visualMapModel;
	    var viewPieceList = zrUtil.map(visualMapModel.getPieceList(), function (piece, index) {
	      return {
	        piece: piece,
	        indexInModelPieceList: index
	      };
	    });
	    var endsText = visualMapModel.get('text'); // Consider orient and inverse.
	
	    var orient = visualMapModel.get('orient');
	    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]
	
	    if (orient === 'horizontal' ? inverse : !inverse) {
	      viewPieceList.reverse();
	    } // Origin order of endsText is [high, low]
	    else if (endsText) {
	        endsText = endsText.slice().reverse();
	      }
	
	    return {
	      viewPieceList: viewPieceList,
	      endsText: endsText
	    };
	  },
	
	  /**
	   * @private
	   */
	  _createItemSymbol: function (group, representValue, shapeParam) {
	    group.add(createSymbol(this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, 'color')));
	  },
	
	  /**
	   * @private
	   */
	  _onItemClick: function (piece) {
	    var visualMapModel = this.visualMapModel;
	    var option = visualMapModel.option;
	    var selected = zrUtil.clone(option.selected);
	    var newKey = visualMapModel.getSelectedMapKey(piece);
	
	    if (option.selectedMode === 'single') {
	      selected[newKey] = true;
	      zrUtil.each(selected, function (o, key) {
	        selected[key] = key === newKey;
	      });
	    } else {
	      selected[newKey] = !selected[newKey];
	    }
	
	    this.api.dispatchAction({
	      type: 'selectDataRange',
	      from: this.uid,
	      visualMapId: this.visualMapModel.id,
	      selected: selected
	    });
	  }
	});
	var _default = PiecewiseVisualMapView;
	module.exports = _default;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var textContain = __webpack_require__(86);
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	var _axisHelper = __webpack_require__(96);
	
	var makeLabelFormatter = _axisHelper.makeLabelFormatter;
	var getOptionCategoryInterval = _axisHelper.getOptionCategoryInterval;
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @return {Object} {
	 *     labels: [{
	 *         formattedLabel: string,
	 *         rawLabel: string,
	 *         tickValue: number
	 *     }, ...],
	 *     labelCategoryInterval: number
	 * }
	 */
	
	function createAxisLabels(axis) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
	}
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
	 * @return {Object} {
	 *     ticks: Array.<number>
	 *     tickCategoryInterval: number
	 * }
	 */
	
	
	function createAxisTicks(axis, tickModel) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
	    ticks: axis.scale.getTicks()
	  };
	}
	
	function makeCategoryLabels(axis) {
	  var labelModel = axis.getLabelModel();
	  var result = makeCategoryLabelsActually(axis, labelModel);
	  return !labelModel.get('show') || axis.scale.isBlank() ? {
	    labels: [],
	    labelCategoryInterval: result.labelCategoryInterval
	  } : result;
	}
	
	function makeCategoryLabelsActually(axis, labelModel) {
	  var labelsCache = getListCache(axis, 'labels');
	  var optionLabelInterval = getOptionCategoryInterval(labelModel);
	  var result = listCacheGet(labelsCache, optionLabelInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var labels;
	  var numericLabelInterval;
	
	  if (zrUtil.isFunction(optionLabelInterval)) {
	    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
	  } else {
	    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
	    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
	  } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(labelsCache, optionLabelInterval, {
	    labels: labels,
	    labelCategoryInterval: numericLabelInterval
	  });
	}
	
	function makeCategoryTicks(axis, tickModel) {
	  var ticksCache = getListCache(axis, 'ticks');
	  var optionTickInterval = getOptionCategoryInterval(tickModel);
	  var result = listCacheGet(ticksCache, optionTickInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var ticks;
	  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
	  // we should not return all ticks.
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    ticks = [];
	  }
	
	  if (zrUtil.isFunction(optionTickInterval)) {
	    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
	  } // Always use label interval by default despite label show. Consider this
	  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
	  // labels. `splitLine` and `axisTick` should be consistent in this case.
	  else if (optionTickInterval === 'auto') {
	      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
	      tickCategoryInterval = labelsResult.labelCategoryInterval;
	      ticks = zrUtil.map(labelsResult.labels, function (labelItem) {
	        return labelItem.tickValue;
	      });
	    } else {
	      tickCategoryInterval = optionTickInterval;
	      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
	    } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(ticksCache, optionTickInterval, {
	    ticks: ticks,
	    tickCategoryInterval: tickCategoryInterval
	  });
	}
	
	function makeRealNumberLabels(axis) {
	  var ticks = axis.scale.getTicks();
	  var labelFormatter = makeLabelFormatter(axis);
	  return {
	    labels: zrUtil.map(ticks, function (tickValue, idx) {
	      return {
	        formattedLabel: labelFormatter(tickValue, idx),
	        rawLabel: axis.scale.getLabel(tickValue),
	        tickValue: tickValue
	      };
	    })
	  };
	} // Large category data calculation is performence sensitive, and ticks and label
	// probably be fetched by multiple times. So we cache the result.
	// axis is created each time during a ec process, so we do not need to clear cache.
	
	
	function getListCache(axis, prop) {
	  // Because key can be funciton, and cache size always be small, we use array cache.
	  return inner(axis)[prop] || (inner(axis)[prop] = []);
	}
	
	function listCacheGet(cache, key) {
	  for (var i = 0; i < cache.length; i++) {
	    if (cache[i].key === key) {
	      return cache[i].value;
	    }
	  }
	}
	
	function listCacheSet(cache, key, value) {
	  cache.push({
	    key: key,
	    value: value
	  });
	  return value;
	}
	
	function makeAutoCategoryInterval(axis) {
	  var result = inner(axis).autoInterval;
	  return result != null ? result : inner(axis).autoInterval = axis.calculateCategoryInterval();
	}
	/**
	 * Calculate interval for category axis ticks and labels.
	 * To get precise result, at least one of `getRotate` and `isHorizontal`
	 * should be implemented in axis.
	 */
	
	
	function calculateCategoryInterval(axis) {
	  var params = fetchAutoCategoryIntervalCalculationParams(axis);
	  var labelFormatter = makeLabelFormatter(axis);
	  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	  // avoid generating a long array by `getTicks`
	  // in large category data case.
	
	  var tickCount = ordinalScale.count();
	
	  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	    return 0;
	  }
	
	  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
	
	  if (tickCount > 40) {
	    step = Math.max(1, Math.floor(tickCount / 40));
	  }
	
	  var tickValue = ordinalExtent[0];
	  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	  var unitW = Math.abs(unitSpan * Math.cos(rotation));
	  var unitH = Math.abs(unitSpan * Math.sin(rotation));
	  var maxW = 0;
	  var maxH = 0; // Caution: Performance sensitive for large category data.
	  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    var width = 0;
	    var height = 0; // Not precise, do not consider align and vertical align
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(labelFormatter(tickValue), params.font, 'center', 'top'); // Magic number
	
	    width = rect.width * 1.3;
	    height = rect.height * 1.3; // Min size, void long loop.
	
	    maxW = Math.max(maxW, width, 7);
	    maxH = Math.max(maxH, height, 7);
	  }
	
	  var dw = maxW / unitW;
	  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	  isNaN(dw) && (dw = Infinity);
	  isNaN(dh) && (dh = Infinity);
	  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
	  var cache = inner(axis.model);
	  var axisExtent = axis.getExtent();
	  var lastAutoInterval = cache.lastAutoInterval;
	  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	  // otherwise the calculated interval might jitter when the zoom
	  // window size is close to the interval-changing size.
	  // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
	  // The jitter will cause that sometimes the displayed labels are
	  // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
	
	  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	  // point is not the same when zooming in or zooming out.
	  && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
	  // be used. Otherwise some hiden labels might not be shown again.
	  && cache.axisExtend0 === axisExtent[0] && cache.axisExtend1 === axisExtent[1]) {
	    interval = lastAutoInterval;
	  } // Only update cache if cache not used, otherwise the
	  // changing of interval is too insensitive.
	  else {
	      cache.lastTickCount = tickCount;
	      cache.lastAutoInterval = interval;
	      cache.axisExtend0 = axisExtent[0];
	      cache.axisExtend1 = axisExtent[1];
	    }
	
	  return interval;
	}
	
	function fetchAutoCategoryIntervalCalculationParams(axis) {
	  var labelModel = axis.getLabelModel();
	  return {
	    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
	    labelRotate: labelModel.get('rotate') || 0,
	    font: labelModel.getFont()
	  };
	}
	
	function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
	  var labelFormatter = makeLabelFormatter(axis);
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent();
	  var labelModel = axis.getLabelModel();
	  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
	
	  var step = Math.max((categoryInterval || 0) + 1, 1);
	  var startTick = ordinalExtent[0];
	  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
	  // while zooming and moving while interval > 0. Otherwise the selection
	  // of displayable ticks and symbols probably keep changing.
	  // 3 is empirical value.
	
	  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
	    startTick = Math.round(Math.ceil(startTick / step) * step);
	  } // (1) Only add min max label here but leave overlap checking
	  // to render stage, which also ensure the returned list
	  // suitable for splitLine and splitArea rendering.
	  // (2) Scales except category always contain min max label so
	  // do not need to perform this process.
	
	
	  var showAllLabel = shouldShowAllLabels(axis);
	  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
	  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
	
	  if (includeMinLabel && startTick !== ordinalExtent[0]) {
	    addItem(ordinalExtent[0]);
	  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
	
	
	  var tickValue = startTick;
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    addItem(tickValue);
	  }
	
	  if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
	    addItem(ordinalExtent[1]);
	  }
	
	  function addItem(tVal) {
	    result.push(onlyTick ? tVal : {
	      formattedLabel: labelFormatter(tVal),
	      rawLabel: ordinalScale.getLabel(tVal),
	      tickValue: tVal
	    });
	  }
	
	  return result;
	} // When interval is function, the result `false` means ignore the tick.
	// It is time consuming for large category data.
	
	
	function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
	  var ordinalScale = axis.scale;
	  var labelFormatter = makeLabelFormatter(axis);
	  var result = [];
	  zrUtil.each(ordinalScale.getTicks(), function (tickValue) {
	    var rawLabel = ordinalScale.getLabel(tickValue);
	
	    if (categoryInterval(tickValue, rawLabel)) {
	      result.push(onlyTick ? tickValue : {
	        formattedLabel: labelFormatter(tickValue),
	        rawLabel: rawLabel,
	        tickValue: tickValue
	      });
	    }
	  });
	  return result;
	}
	
	exports.createAxisLabels = createAxisLabels;
	exports.createAxisTicks = createAxisTicks;
	exports.calculateCategoryInterval = calculateCategoryInterval;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var layout = __webpack_require__(47);
	
	var numberUtil = __webpack_require__(24);
	
	var CoordinateSystem = __webpack_require__(95);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (24*60*60*1000)
	var PROXIMATE_ONE_DAY = 86400000;
	/**
	 * Calendar
	 *
	 * @constructor
	 *
	 * @param {Object} calendarModel calendarModel
	 * @param {Object} ecModel       ecModel
	 * @param {Object} api           api
	 */
	
	function Calendar(calendarModel, ecModel, api) {
	  this._model = calendarModel;
	}
	
	Calendar.prototype = {
	  constructor: Calendar,
	  type: 'calendar',
	  dimensions: ['time', 'value'],
	  // Required in createListFromData
	  getDimensionsInfo: function () {
	    return [{
	      name: 'time',
	      type: 'time'
	    }, 'value'];
	  },
	  getRangeInfo: function () {
	    return this._rangeInfo;
	  },
	  getModel: function () {
	    return this._model;
	  },
	  getRect: function () {
	    return this._rect;
	  },
	  getCellWidth: function () {
	    return this._sw;
	  },
	  getCellHeight: function () {
	    return this._sh;
	  },
	  getOrient: function () {
	    return this._orient;
	  },
	
	  /**
	   * getFirstDayOfWeek
	   *
	   * @example
	   *     0 : start at Sunday
	   *     1 : start at Monday
	   *
	   * @return {number}
	   */
	  getFirstDayOfWeek: function () {
	    return this._firstDayOfWeek;
	  },
	
	  /**
	   * get date info
	   *
	   * @param  {string|number} date date
	   * @return {Object}
	   * {
	   *      y: string, local full year, eg., '1940',
	   *      m: string, local month, from '01' ot '12',
	   *      d: string, local date, from '01' to '31' (if exists),
	   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
	   *      time: timestamp,
	   *      formatedDate: string, yyyy-MM-dd,
	   *      date: original date object.
	   * }
	   */
	  getDateInfo: function (date) {
	    date = numberUtil.parseDate(date);
	    var y = date.getFullYear();
	    var m = date.getMonth() + 1;
	    m = m < 10 ? '0' + m : m;
	    var d = date.getDate();
	    d = d < 10 ? '0' + d : d;
	    var day = date.getDay();
	    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
	    return {
	      y: y,
	      m: m,
	      d: d,
	      day: day,
	      time: date.getTime(),
	      formatedDate: y + '-' + m + '-' + d,
	      date: date
	    };
	  },
	  getNextNDay: function (date, n) {
	    n = n || 0;
	
	    if (n === 0) {
	      return this.getDateInfo(date);
	    }
	
	    date = new Date(this.getDateInfo(date).time);
	    date.setDate(date.getDate() + n);
	    return this.getDateInfo(date);
	  },
	  update: function (ecModel, api) {
	    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
	    this._orient = this._model.get('orient');
	    this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
	    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
	    var weeks = this._rangeInfo.weeks || 1;
	    var whNames = ['width', 'height'];
	
	    var cellSize = this._model.get('cellSize').slice();
	
	    var layoutParams = this._model.getBoxLayoutParams();
	
	    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
	    zrUtil.each([0, 1], function (idx) {
	      if (cellSizeSpecified(cellSize, idx)) {
	        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
	      }
	    });
	    var whGlobal = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var calendarRect = this._rect = layout.getLayoutRect(layoutParams, whGlobal);
	    zrUtil.each([0, 1], function (idx) {
	      if (!cellSizeSpecified(cellSize, idx)) {
	        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
	      }
	    });
	
	    function cellSizeSpecified(cellSize, idx) {
	      return cellSize[idx] != null && cellSize[idx] !== 'auto';
	    }
	
	    this._sw = cellSize[0];
	    this._sh = cellSize[1];
	  },
	
	  /**
	   * Convert a time data(time, value) item to (x, y) point.
	   *
	   * @override
	   * @param  {Array|number} data data
	   * @param  {boolean} [clamp=true] out of range
	   * @return {Array} point
	   */
	  dataToPoint: function (data, clamp) {
	    zrUtil.isArray(data) && (data = data[0]);
	    clamp == null && (clamp = true);
	    var dayInfo = this.getDateInfo(data);
	    var range = this._rangeInfo;
	    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]
	
	    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
	      return [NaN, NaN];
	    }
	
	    var week = dayInfo.day;
	
	    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;
	
	    if (this._orient === 'vertical') {
	      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
	    }
	
	    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
	  },
	
	  /**
	   * Convert a (x, y) point to time data
	   *
	   * @override
	   * @param  {string} point point
	   * @return {string}       data
	   */
	  pointToData: function (point) {
	    var date = this.pointToDate(point);
	    return date && date.time;
	  },
	
	  /**
	   * Convert a time date item to (x, y) four point.
	   *
	   * @param  {Array} data  date[0] is date
	   * @param  {boolean} [clamp=true]  out of range
	   * @return {Object}       point
	   */
	  dataToRect: function (data, clamp) {
	    var point = this.dataToPoint(data, clamp);
	    return {
	      contentShape: {
	        x: point[0] - (this._sw - this._lineWidth) / 2,
	        y: point[1] - (this._sh - this._lineWidth) / 2,
	        width: this._sw - this._lineWidth,
	        height: this._sh - this._lineWidth
	      },
	      center: point,
	      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
	      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
	      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
	      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
	    };
	  },
	
	  /**
	   * Convert a (x, y) point to time date
	   *
	   * @param  {Array} point point
	   * @return {Object}       date
	   */
	  pointToDate: function (point) {
	    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
	    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
	    var range = this._rangeInfo.range;
	
	    if (this._orient === 'vertical') {
	      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
	    }
	
	    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
	  },
	
	  /**
	   * @inheritDoc
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @inheritDoc
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * initRange
	   *
	   * @private
	   * @return {Array} [start, end]
	   */
	  _initRangeOption: function () {
	    var range = this._model.get('range');
	
	    var rg = range;
	
	    if (zrUtil.isArray(rg) && rg.length === 1) {
	      rg = rg[0];
	    }
	
	    if (/^\d{4}$/.test(rg)) {
	      range = [rg + '-01-01', rg + '-12-31'];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
	      var start = this.getDateInfo(rg);
	      var firstDay = start.date;
	      firstDay.setMonth(firstDay.getMonth() + 1);
	      var end = this.getNextNDay(firstDay, -1);
	      range = [start.formatedDate, end.formatedDate];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) {
	      range = [rg, rg];
	    }
	
	    var tmp = this._getRangeInfo(range);
	
	    if (tmp.start.time > tmp.end.time) {
	      range.reverse();
	    }
	
	    return range;
	  },
	
	  /**
	   * range info
	   *
	   * @private
	   * @param  {Array} range range ['2017-01-01', '2017-07-08']
	   *  If range[0] > range[1], they will not be reversed.
	   * @return {Object}       obj
	   */
	  _getRangeInfo: function (range) {
	    range = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
	    var reversed;
	
	    if (range[0].time > range[1].time) {
	      reversed = true;
	      range.reverse();
	    }
	
	    var allDay = Math.floor(range[1].time / PROXIMATE_ONE_DAY) - Math.floor(range[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
	    // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
	    // Consider case2:
	    // Firstly set system timezone as "Time Zone: America/Toronto",
	    // ```
	    // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
	    // var second = new Date(1478412000000);
	    // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
	    // ```
	    // will get wrong result because of DST. So we should fix it.
	
	    var date = new Date(range[0].time);
	    var startDateNum = date.getDate();
	    var endDateNum = range[1].date.getDate();
	    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.
	
	    var dateNum = date.getDate();
	
	    if (dateNum !== endDateNum) {
	      var sign = date.getTime() - range[1].time > 0 ? 1 : -1;
	
	      while ((dateNum = date.getDate()) !== endDateNum && (date.getTime() - range[1].time) * sign > 0) {
	        allDay -= sign;
	        date.setDate(dateNum - sign);
	      }
	    }
	
	    var weeks = Math.floor((allDay + range[0].day + 6) / 7);
	    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
	    reversed && range.reverse();
	    return {
	      range: [range[0].formatedDate, range[1].formatedDate],
	      start: range[0],
	      end: range[1],
	      allDay: allDay,
	      weeks: weeks,
	      // From 0.
	      nthWeek: nthWeek,
	      fweek: range[0].day,
	      lweek: range[1].day
	    };
	  },
	
	  /**
	   * get date by nthWeeks and week day in range
	   *
	   * @private
	   * @param  {number} nthWeek the week
	   * @param  {number} day   the week day
	   * @param  {Array} range [d1, d2]
	   * @return {Object}
	   */
	  _getDateByWeeksAndDay: function (nthWeek, day, range) {
	    var rangeInfo = this._getRangeInfo(range);
	
	    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
	      return false;
	    }
	
	    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
	    var date = new Date(rangeInfo.start.time);
	    date.setDate(rangeInfo.start.d + nthDay);
	    return this.getDateInfo(date);
	  }
	};
	Calendar.dimensions = Calendar.prototype.dimensions;
	Calendar.getDimensionsInfo = Calendar.prototype.getDimensionsInfo;
	
	Calendar.create = function (ecModel, api) {
	  var calendarList = [];
	  ecModel.eachComponent('calendar', function (calendarModel) {
	    var calendar = new Calendar(calendarModel, ecModel, api);
	    calendarList.push(calendar);
	    calendarModel.coordinateSystem = calendar;
	  });
	  ecModel.eachSeries(function (calendarSeries) {
	    if (calendarSeries.get('coordinateSystem') === 'calendar') {
	      // Inject coordinate system
	      calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
	    }
	  });
	  return calendarList;
	};
	
	function doConvert(methodName, ecModel, finder, value) {
	  var calendarModel = finder.calendarModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	CoordinateSystem.register('calendar', Calendar);
	var _default = Calendar;
	module.exports = _default;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ComponentModel = __webpack_require__(65);
	
	var _layout = __webpack_require__(47);
	
	var getLayoutParams = _layout.getLayoutParams;
	var sizeCalculable = _layout.sizeCalculable;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CalendarModel = ComponentModel.extend({
	  type: 'calendar',
	
	  /**
	   * @type {module:echarts/coord/calendar/Calendar}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    left: 80,
	    top: 60,
	    cellSize: 20,
	    // horizontal vertical
	    orient: 'horizontal',
	    // month separate line style
	    splitLine: {
	      show: true,
	      lineStyle: {
	        color: '#000',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    // rect style  temporarily unused emphasis
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1,
	      borderColor: '#ccc'
	    },
	    // week text style
	    dayLabel: {
	      show: true,
	      // a week first day
	      firstDay: 0,
	      // start end
	      position: 'start',
	      margin: '50%',
	      // 50% of cellSize
	      nameMap: 'en',
	      color: '#000'
	    },
	    // month text style
	    monthLabel: {
	      show: true,
	      // start end
	      position: 'start',
	      margin: 5,
	      // center or left
	      align: 'center',
	      // cn en []
	      nameMap: 'en',
	      formatter: null,
	      color: '#000'
	    },
	    // year text style
	    yearLabel: {
	      show: true,
	      // top bottom left right
	      position: null,
	      margin: 30,
	      formatter: null,
	      color: '#ccc',
	      fontFamily: 'sans-serif',
	      fontWeight: 'bolder',
	      fontSize: 20
	    }
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    CalendarModel.superApply(this, 'init', arguments);
	    mergeAndNormalizeLayoutParams(option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    CalendarModel.superApply(this, 'mergeOption', arguments);
	    mergeAndNormalizeLayoutParams(this.option, option);
	  }
	});
	
	function mergeAndNormalizeLayoutParams(target, raw) {
	  // Normalize cellSize
	  var cellSize = target.cellSize;
	
	  if (!zrUtil.isArray(cellSize)) {
	    cellSize = target.cellSize = [cellSize, cellSize];
	  } else if (cellSize.length === 1) {
	    cellSize[1] = cellSize[0];
	  }
	
	  var ignoreSize = zrUtil.map([0, 1], function (hvIdx) {
	    // If user have set `width` or both `left` and `right`, cellSize
	    // will be automatically set to 'auto', otherwise the default
	    // setting of cellSize will make `width` setting not work.
	    if (sizeCalculable(raw, hvIdx)) {
	      cellSize[hvIdx] = 'auto';
	    }
	
	    return cellSize[hvIdx] != null && cellSize[hvIdx] !== 'auto';
	  });
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = CalendarModel;
	module.exports = _default;

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  var rangeInfo = coordSys.getRangeInfo();
	  return {
	    coordSys: {
	      type: 'calendar',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      cellWidth: coordSys.getCellWidth(),
	      cellHeight: coordSys.getCellHeight(),
	      rangeInfo: {
	        start: rangeInfo.start,
	        end: rangeInfo.end,
	        weeks: rangeInfo.weeks,
	        dayCount: rangeInfo.allDay
	      }
	    },
	    api: {
	      coord: function (data, clamp) {
	        return coordSys.dataToPoint(data, clamp);
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Axis = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var Axis2D = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   */
	
	  this.position = position || 'bottom';
	};
	
	Axis2D.prototype = {
	  constructor: Axis2D,
	
	  /**
	   * Index of axis, can be used as key
	   */
	  index: 0,
	
	  /**
	   * Implemented in <module:echarts/coord/cartesian/Grid>.
	   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
	   *         If not on zero of other axis, return null/undefined.
	   *         If no axes, return an empty array.
	   */
	  getAxesOnZeroOf: null,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/cartesian/AxisModel}
	   */
	  model: null,
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * Each item cooresponds to this.getExtent(), which
	   * means globalExtent[0] may greater than globalExtent[1],
	   * unless `asc` is input.
	   *
	   * @param {boolean} [asc]
	   * @return {Array.<number>}
	   */
	  getGlobalExtent: function (asc) {
	    var ret = this.getExtent();
	    ret[0] = this.toGlobalCoord(ret[0]);
	    ret[1] = this.toGlobalCoord(ret[1]);
	    asc && ret[0] > ret[1] && ret.reverse();
	    return ret;
	  },
	  getOtherAxis: function () {
	    this.grid.getOtherAxis();
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
	  },
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var localCoord = axis.toLocalCoord(80);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toLocalCoord: null,
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var globalCoord = axis.toLocalCoord(40);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toGlobalCoord: null
	};
	zrUtil.inherits(Axis2D, Axis);
	var _default = Axis2D;
	module.exports = _default;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Cartesian coordinate system
	 * @module  echarts/coord/Cartesian
	 *
	 */
	function dimAxisMapper(dim) {
	  return this._axes[dim];
	}
	/**
	 * @alias module:echarts/coord/Cartesian
	 * @constructor
	 */
	
	
	var Cartesian = function (name) {
	  this._axes = {};
	  this._dimList = [];
	  /**
	   * @type {string}
	   */
	
	  this.name = name || '';
	};
	
	Cartesian.prototype = {
	  constructor: Cartesian,
	  type: 'cartesian',
	
	  /**
	   * Get axis
	   * @param  {number|string} dim
	   * @return {module:echarts/coord/Cartesian~Axis}
	   */
	  getAxis: function (dim) {
	    return this._axes[dim];
	  },
	
	  /**
	   * Get axes list
	   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
	   */
	  getAxes: function () {
	    return zrUtil.map(this._dimList, dimAxisMapper, this);
	  },
	
	  /**
	   * Get axes list by given scale type
	   */
	  getAxesByScale: function (scaleType) {
	    scaleType = scaleType.toLowerCase();
	    return zrUtil.filter(this.getAxes(), function (axis) {
	      return axis.scale.type === scaleType;
	    });
	  },
	
	  /**
	   * Add axis
	   * @param {module:echarts/coord/Cartesian.Axis}
	   */
	  addAxis: function (axis) {
	    var dim = axis.dim;
	    this._axes[dim] = axis;
	
	    this._dimList.push(dim);
	  },
	
	  /**
	   * Convert data to coord in nd space
	   * @param {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  dataToCoord: function (val) {
	    return this._dataCoordConvert(val, 'dataToCoord');
	  },
	
	  /**
	   * Convert coord in nd space to data
	   * @param  {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  coordToData: function (val) {
	    return this._dataCoordConvert(val, 'coordToData');
	  },
	  _dataCoordConvert: function (input, method) {
	    var dimList = this._dimList;
	    var output = input instanceof Array ? [] : {};
	
	    for (var i = 0; i < dimList.length; i++) {
	      var dim = dimList[i];
	      var axis = this._axes[dim];
	      output[dim] = axis[method](input[dim]);
	    }
	
	    return output;
	  }
	};
	var _default = Cartesian;
	module.exports = _default;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var BoundingRect = __webpack_require__(51);
	
	var Cartesian = __webpack_require__(1816);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function Cartesian2D(name) {
	  Cartesian.call(this, name);
	}
	
	Cartesian2D.prototype = {
	  constructor: Cartesian2D,
	  type: 'cartesian2d',
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/cartesian/Axis2D}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
	  },
	
	  /**
	   * If contain point
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var axisX = this.getAxis('x');
	    var axisY = this.getAxis('y');
	    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, reserved, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));
	    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  clampData: function (data, out) {
	    var xScale = this.getAxis('x').scale;
	    var yScale = this.getAxis('y').scale;
	    var xAxisExtent = xScale.getExtent();
	    var yAxisExtent = yScale.getExtent();
	    var x = xScale.parse(data[0]);
	    var y = yScale.parse(data[1]);
	    out = out || [];
	    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
	    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]));
	    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]));
	    return out;
	  },
	
	  /**
	   * Get other axis
	   * @param {module:echarts/coord/cartesian/Axis2D} axis
	   */
	  getOtherAxis: function (axis) {
	    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
	  },
	
	  /**
	   * Get rect area of cartesian.
	   * Area will have a contain function to determine if a point is in the coordinate system.
	   * @return {BoundingRect}
	   */
	  getArea: function () {
	    var xExtent = this.getAxis('x').getGlobalExtent();
	    var yExtent = this.getAxis('y').getGlobalExtent();
	    var x = Math.min(xExtent[0], xExtent[1]);
	    var y = Math.min(yExtent[0], yExtent[1]);
	    var width = Math.max(xExtent[0], xExtent[1]) - x;
	    var height = Math.max(yExtent[0], yExtent[1]) - y;
	    var rect = new BoundingRect(x, y, width, height);
	    return rect;
	  }
	};
	zrUtil.inherits(Cartesian2D, Cartesian);
	var _default = Cartesian2D;
	module.exports = _default;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(842);
	
	var ComponentModel = __webpack_require__(65);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid 是在有直角坐标系的时候必须要存在的
	// 所以这里也要被 Cartesian2D 依赖
	var _default = ComponentModel.extend({
	  type: 'grid',
	  dependencies: ['xAxis', 'yAxis'],
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Grid}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    show: false,
	    zlevel: 0,
	    z: 0,
	    left: '10%',
	    top: 60,
	    right: '10%',
	    bottom: 60,
	    // If grid size contain label
	    containLabel: false,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderWidth: 1,
	    borderColor: '#ccc'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map(['x', 'y'], function (dim, dimIdx) {
	    var axis = this.getAxis(dim);
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.grid.getRect();
	  return {
	    coordSys: {
	      // The name exposed to user is always 'cartesian2d' but not 'grid'.
	      type: 'cartesian2d',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var BoundingRect = __webpack_require__(51);
	
	var View = __webpack_require__(426);
	
	var geoSourceManager = __webpack_require__(271);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Geo description]
	 * For backward compatibility, the orginal interface:
	 * `name, map, geoJson, specialAreas, nameMap` is kept.
	 *
	 * @param {string|Object} name
	 * @param {string} map Map type
	 *        Specify the positioned areas by left, top, width, height
	 * @param {Object.<string, string>} [nameMap]
	 *        Specify name alias
	 * @param {boolean} [invertLongitute=true]
	 */
	function Geo(name, map, nameMap, invertLongitute) {
	  View.call(this, name);
	  /**
	   * Map type
	   * @type {string}
	   */
	
	  this.map = map;
	  var source = geoSourceManager.load(map, nameMap);
	  this._nameCoordMap = source.nameCoordMap;
	  this._regionsMap = source.regionsMap;
	  this._invertLongitute = invertLongitute == null ? true : invertLongitute;
	  /**
	   * @readOnly
	   */
	
	  this.regions = source.regions;
	  /**
	   * @type {module:zrender/src/core/BoundingRect}
	   */
	
	  this._rect = source.boundingRect;
	}
	
	Geo.prototype = {
	  constructor: Geo,
	  type: 'geo',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['lng', 'lat'],
	
	  /**
	   * If contain given lng,lat coord
	   * @param {Array.<number>}
	   * @readOnly
	   */
	  containCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @override
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var invertLongitute = this._invertLongitute;
	    rect = rect.clone();
	
	    if (invertLongitute) {
	      // Longitute is inverted
	      rect.y = -rect.y - rect.height;
	    }
	
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransformable.decomposeTransform();
	
	    if (invertLongitute) {
	      var scale = rawTransformable.scale;
	      scale[1] = -scale[1];
	    }
	
	    rawTransformable.updateTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/coord/geo/Region}
	   */
	  getRegion: function (name) {
	    return this._regionsMap.get(name);
	  },
	  getRegionByCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return regions[i];
	      }
	    }
	  },
	
	  /**
	   * Add geoCoord for indexing by name
	   * @param {string} name
	   * @param {Array.<number>} geoCoord
	   */
	  addGeoCoord: function (name, geoCoord) {
	    this._nameCoordMap.set(name, geoCoord);
	  },
	
	  /**
	   * Get geoCoord by name
	   * @param {string} name
	   * @return {Array.<number>}
	   */
	  getGeoCoord: function (name) {
	    return this._nameCoordMap.get(name);
	  },
	
	  /**
	   * @override
	   */
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {string|Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    if (typeof data === 'string') {
	      // Map area name to geoCoord
	      data = this.getGeoCoord(data);
	    }
	
	    if (data) {
	      return View.prototype.dataToPoint.call(this, data, noRoam, out);
	    }
	  },
	
	  /**
	   * @override
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @override
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData')
	};
	zrUtil.mixin(Geo, View);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var geoModel = finder.geoModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
	  || (seriesModel.getReferringComponents('geo')[0] || {}).coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = Geo;
	module.exports = _default;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var modelUtil = __webpack_require__(27);
	
	var ComponentModel = __webpack_require__(65);
	
	var Model = __webpack_require__(57);
	
	var selectableMixin = __webpack_require__(422);
	
	var geoCreator = __webpack_require__(428);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GeoModel = ComponentModel.extend({
	  type: 'geo',
	
	  /**
	   * @type {module:echarts/coord/geo/Geo}
	   */
	  coordinateSystem: null,
	  layoutMode: 'box',
	  init: function (option) {
	    ComponentModel.prototype.init.apply(this, arguments); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	    var self = this;
	    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap);
	    this._optionModelMap = zrUtil.reduce(option.regions || [], function (optionModelMap, regionOpt) {
	      if (regionOpt.name) {
	        optionModelMap.set(regionOpt.name, new Model(regionOpt, self));
	      }
	
	      return optionModelMap;
	    }, zrUtil.createHashMap());
	    this.updateSelectedMap(option.regions);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    show: true,
	    left: 'center',
	    top: 'center',
	    // width:,
	    // height:,
	    // right
	    // bottom
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    // If svg used, aspectScale is 1 by default.
	    // aspectScale: 0.75,
	    aspectScale: null,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    silent: false,
	    // Map type
	    map: '',
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ]
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    // selectedMode: false
	    label: {
	      show: false,
	      color: '#000'
	    },
	    itemStyle: {
	      // color: 各异,
	      borderWidth: 0.5,
	      borderColor: '#444',
	      color: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        color: 'rgba(255,215,0,0.8)'
	      }
	    },
	    regions: []
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (name) {
	    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
	  },
	
	  /**
	   * Format label
	   * @param {string} name Region name
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @return {string}
	   */
	  getFormattedLabel: function (name, status) {
	    status = status || 'normal';
	    var regionModel = this.getRegionModel(name);
	    var formatter = regionModel.get((status === 'normal' ? '' : status + '.') + 'label.formatter');
	    var params = {
	      name: name
	    };
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      return formatter.replace('{a}', name != null ? name : '');
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  }
	});
	zrUtil.mixin(GeoModel, selectableMixin);
	var _default = GeoModel;
	module.exports = _default;

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 钓鱼岛
	// var Region = require('../Region');
	// var zrUtil = require('zrender/src/core/util');
	// var geoCoord = [126, 25];
	var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
	
	function _default(mapType, region) {
	  if (mapType === 'china' && region.name === '台湾') {
	    region.geometries.push({
	      type: 'polygon',
	      exterior: points[0]
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var geoCoordMap = {
	  'Russia': [100, 60],
	  'United States': [-99, 38],
	  'United States of America': [-99, 38]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'world') {
	    var geoCoord = geoCoordMap[region.name];
	
	    if (geoCoord) {
	      var cp = region.center;
	      cp[0] = geoCoord[0];
	      cp[1] = geoCoord[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Region = __webpack_require__(844);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 南海诸岛
	var geoCoord = [126, 25];
	var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];
	
	for (var i = 0; i < points.length; i++) {
	  for (var k = 0; k < points[i].length; k++) {
	    points[i][k][0] /= 10.5;
	    points[i][k][1] /= -10.5 / 0.75;
	    points[i][k][0] += geoCoord[0];
	    points[i][k][1] += geoCoord[1];
	  }
	}
	
	function _default(mapType, regions) {
	  if (mapType === 'china') {
	    regions.push(new Region('南海诸岛', zrUtil.map(points, function (exterior) {
	      return {
	        type: 'polygon',
	        exterior: exterior
	      };
	    }), geoCoord));
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordsOffsetMap = {
	  '南海诸岛': [32, 80],
	  // 全国
	  '广东': [0, -10],
	  '香港': [10, 5],
	  '澳门': [-10, 10],
	  //'北京': [-10, 0],
	  '天津': [5, 5]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'china') {
	    var coordFix = coordsOffsetMap[region.name];
	
	    if (coordFix) {
	      var cp = region.center;
	      cp[0] += coordFix[0] / 10.5;
	      cp[1] += -coordFix[1] / (10.5 / 0.75);
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	
	var parseGeoJson = __webpack_require__(845);
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	var fixNanhai = __webpack_require__(1824);
	
	var fixTextCoord = __webpack_require__(1825);
	
	var fixGeoCoord = __webpack_require__(1823);
	
	var fixDiaoyuIsland = __webpack_require__(1822);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Built-in GEO fixer.
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @param {string} nameProperty
	   * @return {Object} {regions, boundingRect}
	   */
	  load: function (mapName, mapRecord, nameProperty) {
	    var parsed = inner(mapRecord).parsed;
	
	    if (parsed) {
	      return parsed;
	    }
	
	    var specialAreas = mapRecord.specialAreas || {};
	    var geoJSON = mapRecord.geoJSON;
	    var regions; // https://jsperf.com/try-catch-performance-overhead
	
	    try {
	      regions = geoJSON ? parseGeoJson(geoJSON, nameProperty) : [];
	    } catch (e) {
	      throw new Error('Invalid geoJson format\n' + e.message);
	    }
	
	    fixNanhai(mapName, regions);
	    each(regions, function (region) {
	      var regionName = region.name;
	      fixTextCoord(mapName, region);
	      fixGeoCoord(mapName, region);
	      fixDiaoyuIsland(mapName, region); // Some area like Alaska in USA map needs to be tansformed
	      // to look better
	
	      var specialArea = specialAreas[regionName];
	
	      if (specialArea) {
	        region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
	      }
	    });
	    return inner(mapRecord).parsed = {
	      regions: regions,
	      boundingRect: getBoundingRect(regions)
	    };
	  }
	};
	
	function getBoundingRect(regions) {
	  var rect;
	
	  for (var i = 0; i < regions.length; i++) {
	    var regionRect = regions[i].getBoundingRect();
	    rect = rect || regionRect.clone();
	    rect.union(regionRect);
	  }
	
	  return rect;
	}
	
	module.exports = _default;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _parseSVG = __webpack_require__(915);
	
	var parseSVG = _parseSVG.parseSVG;
	var makeViewBoxTransform = _parseSVG.makeViewBoxTransform;
	
	var Group = __webpack_require__(146);
	
	var Rect = __webpack_require__(452);
	
	var _util = __webpack_require__(2);
	
	var assert = _util.assert;
	var createHashMap = _util.createHashMap;
	
	var BoundingRect = __webpack_require__(51);
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @return {Object} {root, boundingRect}
	   */
	  load: function (mapName, mapRecord) {
	    var originRoot = inner(mapRecord).originRoot;
	
	    if (originRoot) {
	      return {
	        root: originRoot,
	        boundingRect: inner(mapRecord).boundingRect
	      };
	    }
	
	    var graphic = buildGraphic(mapRecord);
	    inner(mapRecord).originRoot = graphic.root;
	    inner(mapRecord).boundingRect = graphic.boundingRect;
	    return graphic;
	  },
	  makeGraphic: function (mapName, mapRecord, hostKey) {
	    // For performance consideration (in large SVG), graphic only maked
	    // when necessary and reuse them according to hostKey.
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap || (field.rootMap = createHashMap());
	    var root = rootMap.get(hostKey);
	
	    if (root) {
	      return root;
	    }
	
	    var originRoot = field.originRoot;
	    var boundingRect = field.boundingRect; // For performance, if originRoot is not used by a view,
	    // assign it to a view, but not reproduce graphic elements.
	
	    if (!field.originRootHostKey) {
	      field.originRootHostKey = hostKey;
	      root = originRoot;
	    } else {
	      root = buildGraphic(mapRecord, boundingRect).root;
	    }
	
	    return rootMap.set(hostKey, root);
	  },
	  removeGraphic: function (mapName, mapRecord, hostKey) {
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap;
	    rootMap && rootMap.removeKey(hostKey);
	
	    if (hostKey === field.originRootHostKey) {
	      field.originRootHostKey = null;
	    }
	  }
	};
	
	function buildGraphic(mapRecord, boundingRect) {
	  var svgXML = mapRecord.svgXML;
	  var result;
	  var root;
	
	  try {
	    result = svgXML && parseSVG(svgXML, {
	      ignoreViewBox: true,
	      ignoreRootClip: true
	    }) || {};
	    root = result.root;
	    assert(root != null);
	  } catch (e) {
	    throw new Error('Invalid svg format\n' + e.message);
	  }
	
	  var svgWidth = result.width;
	  var svgHeight = result.height;
	  var viewBoxRect = result.viewBoxRect;
	
	  if (!boundingRect) {
	    boundingRect = svgWidth == null || svgHeight == null ? // If svg width / height not specified, calculate
	    // bounding rect as the width / height
	    root.getBoundingRect() : new BoundingRect(0, 0, 0, 0);
	
	    if (svgWidth != null) {
	      boundingRect.width = svgWidth;
	    }
	
	    if (svgHeight != null) {
	      boundingRect.height = svgHeight;
	    }
	  }
	
	  if (viewBoxRect) {
	    var viewBoxTransform = makeViewBoxTransform(viewBoxRect, boundingRect.width, boundingRect.height);
	    var elRoot = root;
	    root = new Group();
	    root.add(elRoot);
	    elRoot.scale = viewBoxTransform.scale;
	    elRoot.position = viewBoxTransform.position;
	  }
	
	  root.setClipPath(new Rect({
	    shape: boundingRect.plain()
	  }));
	  return {
	    root: root,
	    boundingRect: boundingRect
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map([0, 1], function (dimIdx) {
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var p1 = [];
	    var p2 = [];
	    p1[dimIdx] = val - halfSize;
	    p2[dimIdx] = val + halfSize;
	    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
	    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getBoundingRect();
	  return {
	    coordSys: {
	      type: 'geo',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      zoom: coordSys.getZoom()
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" and noRoam param,
	        // Compatible with this usage:
	        // echarts.util.map(item.points, api.coord)
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ComponentModel = __webpack_require__(65);
	
	var makeStyleMapper = __webpack_require__(177);
	
	var axisModelCreator = __webpack_require__(270);
	
	var numberUtil = __webpack_require__(24);
	
	var axisModelCommonMixin = __webpack_require__(175);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'baseParallelAxis',
	
	  /**
	   * @type {module:echarts/coord/parallel/Axis}
	   */
	  axis: null,
	
	  /**
	   * @type {Array.<Array.<number>}
	   * @readOnly
	   */
	  activeIntervals: [],
	
	  /**
	   * @return {Object}
	   */
	  getAreaSelectStyle: function () {
	    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity']])(this.getModel('areaSelectStyle'));
	  },
	
	  /**
	   * The code of this feature is put on AxisModel but not ParallelAxis,
	   * because axisModel can be alive after echarts updating but instance of
	   * ParallelAxis having been disposed. this._activeInterval should be kept
	   * when action dispatched (i.e. legend click).
	   *
	   * @param {Array.<Array<number>>} intervals interval.length === 0
	   *                                          means set all active.
	   * @public
	   */
	  setActiveIntervals: function (intervals) {
	    var activeIntervals = this.activeIntervals = zrUtil.clone(intervals); // Normalize
	
	    if (activeIntervals) {
	      for (var i = activeIntervals.length - 1; i >= 0; i--) {
	        numberUtil.asc(activeIntervals[i]);
	      }
	    }
	  },
	
	  /**
	   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
	   *                         value can not be input.
	   * @return {string} 'normal': no activeIntervals set,
	   *                  'active',
	   *                  'inactive'.
	   * @public
	   */
	  getActiveState: function (value) {
	    var activeIntervals = this.activeIntervals;
	
	    if (!activeIntervals.length) {
	      return 'normal';
	    }
	
	    if (value == null || isNaN(value)) {
	      return 'inactive';
	    } // Simple optimization
	
	
	    if (activeIntervals.length === 1) {
	      var interval = activeIntervals[0];
	
	      if (interval[0] <= value && value <= interval[1]) {
	        return 'active';
	      }
	    } else {
	      for (var i = 0, len = activeIntervals.length; i < len; i++) {
	        if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
	          return 'active';
	        }
	      }
	    }
	
	    return 'inactive';
	  }
	});
	var defaultOption = {
	  type: 'value',
	
	  /**
	   * @type {Array.<number>}
	   */
	  dim: null,
	  // 0, 1, 2, ...
	  // parallelIndex: null,
	  areaSelectStyle: {
	    width: 20,
	    borderWidth: 1,
	    borderColor: 'rgba(160,197,232)',
	    color: 'rgba(160,197,232)',
	    opacity: 0.3
	  },
	  realtime: true,
	  // Whether realtime update view when select.
	  z: 10
	};
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('parallel', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var matrix = __webpack_require__(75);
	
	var layoutUtil = __webpack_require__(47);
	
	var axisHelper = __webpack_require__(96);
	
	var ParallelAxis = __webpack_require__(1831);
	
	var graphic = __webpack_require__(17);
	
	var numberUtil = __webpack_require__(24);
	
	var sliderMove = __webpack_require__(174);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel Coordinates
	 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
	 */
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var round = numberUtil.round;
	var PI = Math.PI;
	
	function Parallel(parallelModel, ecModel, api) {
	  /**
	   * key: dimension
	   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
	   * @private
	   */
	  this._axesMap = zrUtil.createHashMap();
	  /**
	   * key: dimension
	   * value: {position: [], rotation, }
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._axesLayout = {};
	  /**
	   * Always follow axis order.
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = parallelModel.dimensions;
	  /**
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	  /**
	   * @type {module:echarts/coord/parallel/ParallelModel}
	   */
	
	  this._model = parallelModel;
	
	  this._init(parallelModel, ecModel, api);
	}
	
	Parallel.prototype = {
	  type: 'parallel',
	  constructor: Parallel,
	
	  /**
	   * Initialize cartesian coordinate systems
	   * @private
	   */
	  _init: function (parallelModel, ecModel, api) {
	    var dimensions = parallelModel.dimensions;
	    var parallelAxisIndex = parallelModel.parallelAxisIndex;
	    each(dimensions, function (dim, idx) {
	      var axisIndex = parallelAxisIndex[idx];
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	
	      var axis = this._axesMap.set(dim, new ParallelAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));
	
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Injection
	
	      axisModel.axis = axis;
	      axis.model = axisModel;
	      axis.coordinateSystem = axisModel.coordinateSystem = this;
	    }, this);
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    this._updateAxesFromSeries(this._model, ecModel);
	  },
	
	  /**
	   * @override
	   */
	  containPoint: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var axisBase = layoutInfo.axisBase;
	    var layoutBase = layoutInfo.layoutBase;
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var pAxis = point[1 - pixelDimIndex];
	    var pLayout = point[pixelDimIndex];
	    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
	  },
	  getModel: function () {
	    return this._model;
	  },
	
	  /**
	   * Update properties from series
	   * @private
	   */
	  _updateAxesFromSeries: function (parallelModel, ecModel) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (!parallelModel.contains(seriesModel, ecModel)) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      each(this.dimensions, function (dim) {
	        var axis = this._axesMap.get(dim);
	
	        axis.scale.unionExtentFromData(data, data.mapDimension(dim));
	        axisHelper.niceScaleExtent(axis.scale, axis.model);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * Resize the parallel coordinate system.
	   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
	   * @param {module:echarts/ExtensionAPI} api
	   */
	  resize: function (parallelModel, api) {
	    this._rect = layoutUtil.getLayoutRect(parallelModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._layoutAxes();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _makeLayoutInfo: function () {
	    var parallelModel = this._model;
	    var rect = this._rect;
	    var xy = ['x', 'y'];
	    var wh = ['width', 'height'];
	    var layout = parallelModel.get('layout');
	    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
	    var layoutLength = rect[wh[pixelDimIndex]];
	    var layoutExtent = [0, layoutLength];
	    var axisCount = this.dimensions.length;
	    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
	    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
	    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
	    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
	    // where collapsed axes should be overlapped.
	
	    var axisExpandWindow = parallelModel.get('axisExpandWindow');
	    var winSize;
	
	    if (!axisExpandWindow) {
	      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
	      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
	      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    } else {
	      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    }
	
	    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.
	
	    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].
	
	    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.
	
	    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
	    return {
	      layout: layout,
	      pixelDimIndex: pixelDimIndex,
	      layoutBase: rect[xy[pixelDimIndex]],
	      layoutLength: layoutLength,
	      axisBase: rect[xy[1 - pixelDimIndex]],
	      axisLength: rect[wh[1 - pixelDimIndex]],
	      axisExpandable: axisExpandable,
	      axisExpandWidth: axisExpandWidth,
	      axisCollapseWidth: axisCollapseWidth,
	      axisExpandWindow: axisExpandWindow,
	      axisCount: axisCount,
	      winInnerIndices: winInnerIndices,
	      axisExpandWindow0Pos: axisExpandWindow0Pos
	    };
	  },
	
	  /**
	   * @private
	   */
	  _layoutAxes: function () {
	    var rect = this._rect;
	    var axes = this._axesMap;
	    var dimensions = this.dimensions;
	
	    var layoutInfo = this._makeLayoutInfo();
	
	    var layout = layoutInfo.layout;
	    axes.each(function (axis) {
	      var axisExtent = [0, layoutInfo.axisLength];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
	    });
	    each(dimensions, function (dim, idx) {
	      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
	      var positionTable = {
	        horizontal: {
	          x: posInfo.position,
	          y: layoutInfo.axisLength
	        },
	        vertical: {
	          x: 0,
	          y: posInfo.position
	        }
	      };
	      var rotationTable = {
	        horizontal: PI / 2,
	        vertical: 0
	      };
	      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
	      var rotation = rotationTable[layout];
	      var transform = matrix.create();
	      matrix.rotate(transform, transform, rotation);
	      matrix.translate(transform, transform, position); // TODO
	      // tick等排布信息。
	      // TODO
	      // 根据axis order 更新 dimensions顺序。
	
	      this._axesLayout[dim] = {
	        position: position,
	        rotation: rotation,
	        transform: transform,
	        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
	        axisLabelShow: posInfo.axisLabelShow,
	        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
	        tickDirection: 1,
	        labelDirection: 1
	      };
	    }, this);
	  },
	
	  /**
	   * Get axis by dim.
	   * @param {string} dim
	   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
	   */
	  getAxis: function (dim) {
	    return this._axesMap.get(dim);
	  },
	
	  /**
	   * Convert a dim value of a single item of series data to Point.
	   * @param {*} value
	   * @param {string} dim
	   * @return {Array}
	   */
	  dataToPoint: function (value, dim) {
	    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
	  },
	
	  /**
	   * Travel data for one time, get activeState of each data item.
	   * @param {module:echarts/data/List} data
	   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
	   *                            {number} dataIndex
	   * @param {number} [start=0] the start dataIndex that travel from.
	   * @param {number} [end=data.count()] the next dataIndex of the last dataIndex will be travel.
	   */
	  eachActiveState: function (data, callback, start, end) {
	    start == null && (start = 0);
	    end == null && (end = data.count());
	    var axesMap = this._axesMap;
	    var dimensions = this.dimensions;
	    var dataDimensions = [];
	    var axisModels = [];
	    zrUtil.each(dimensions, function (axisDim) {
	      dataDimensions.push(data.mapDimension(axisDim));
	      axisModels.push(axesMap.get(axisDim).model);
	    });
	    var hasActiveSet = this.hasAxisBrushed();
	
	    for (var dataIndex = start; dataIndex < end; dataIndex++) {
	      var activeState;
	
	      if (!hasActiveSet) {
	        activeState = 'normal';
	      } else {
	        activeState = 'active';
	        var values = data.getValues(dataDimensions, dataIndex);
	
	        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	          var state = axisModels[j].getActiveState(values[j]);
	
	          if (state === 'inactive') {
	            activeState = 'inactive';
	            break;
	          }
	        }
	      }
	
	      callback(activeState, dataIndex);
	    }
	  },
	
	  /**
	   * Whether has any activeSet.
	   * @return {boolean}
	   */
	  hasAxisBrushed: function () {
	    var dimensions = this.dimensions;
	    var axesMap = this._axesMap;
	    var hasActiveSet = false;
	
	    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
	        hasActiveSet = true;
	      }
	    }
	
	    return hasActiveSet;
	  },
	
	  /**
	   * Convert coords of each axis to Point.
	   *  Return point. For example: [10, 20]
	   * @param {Array.<number>} coords
	   * @param {string} dim
	   * @return {Array.<number>}
	   */
	  axisCoordToPoint: function (coord, dim) {
	    var axisLayout = this._axesLayout[dim];
	    return graphic.applyTransform([coord, 0], axisLayout.transform);
	  },
	
	  /**
	   * Get axis layout.
	   */
	  getAxisLayout: function (dim) {
	    return zrUtil.clone(this._axesLayout[dim]);
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
	   */
	  getSlidedAxisExpandWindow: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
	    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.
	
	    if (!this.containPoint(point)) {
	      return {
	        behavior: 'none',
	        axisExpandWindow: axisExpandWindow
	      };
	    } // Conver the point from global to expand coordinates.
	
	
	    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
	    // slided when mouse is the center area of the window.
	
	    var delta;
	    var behavior = 'slide';
	    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	
	    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.
	
	
	    var useJump = triggerArea[0] != null;
	
	    if (axisCollapseWidth) {
	      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * triggerArea[2];
	      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * (1 - triggerArea[2]);
	      } else {
	        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
	      }
	
	      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
	      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
	      : behavior = 'none';
	    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
	    else {
	        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	        var pos = extent[1] * pointCoord / winSize;
	        axisExpandWindow = [mathMax(0, pos - winSize / 2)];
	        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize);
	        axisExpandWindow[0] = axisExpandWindow[1] - winSize;
	      }
	
	    return {
	      axisExpandWindow: axisExpandWindow,
	      behavior: behavior
	    };
	  }
	};
	
	function restrict(len, extent) {
	  return mathMin(mathMax(len, extent[0]), extent[1]);
	}
	
	function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
	  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
	  return {
	    position: step * axisIndex,
	    axisNameAvailableWidth: step,
	    axisLabelShow: true
	  };
	}
	
	function layoutAxisWithExpand(axisIndex, layoutInfo) {
	  var layoutLength = layoutInfo.layoutLength;
	  var axisExpandWidth = layoutInfo.axisExpandWidth;
	  var axisCount = layoutInfo.axisCount;
	  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	  var winInnerIndices = layoutInfo.winInnerIndices;
	  var position;
	  var axisNameAvailableWidth = axisCollapseWidth;
	  var axisLabelShow = false;
	  var nameTruncateMaxWidth;
	
	  if (axisIndex < winInnerIndices[0]) {
	    position = axisIndex * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  } else if (axisIndex <= winInnerIndices[1]) {
	    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
	    axisNameAvailableWidth = axisExpandWidth;
	    axisLabelShow = true;
	  } else {
	    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  }
	
	  return {
	    position: position,
	    axisNameAvailableWidth: axisNameAvailableWidth,
	    axisLabelShow: axisLabelShow,
	    nameTruncateMaxWidth: nameTruncateMaxWidth
	  };
	}
	
	var _default = Parallel;
	module.exports = _default;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Axis = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor module:echarts/coord/parallel/ParallelAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 */
	var ParallelAxis = function (dim, scale, coordExtent, axisType, axisIndex) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.axisIndex = axisIndex;
	};
	
	ParallelAxis.prototype = {
	  constructor: ParallelAxis,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/parallel/AxisModel}
	   */
	  model: null,
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
	  }
	};
	zrUtil.inherits(ParallelAxis, Axis);
	var _default = ParallelAxis;
	module.exports = _default;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Component = __webpack_require__(65);
	
	__webpack_require__(1829);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Component.extend({
	  type: 'parallel',
	  dependencies: ['parallelAxis'],
	
	  /**
	   * @type {module:echarts/coord/parallel/Parallel}
	   */
	  coordinateSystem: null,
	
	  /**
	   * Each item like: 'dim0', 'dim1', 'dim2', ...
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * Coresponding to dimensions.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	  parallelAxisIndex: null,
	  layoutMode: 'box',
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    layout: 'horizontal',
	    // 'horizontal' or 'vertical'
	    // FIXME
	    // naming?
	    axisExpandable: false,
	    axisExpandCenter: null,
	    axisExpandCount: 0,
	    axisExpandWidth: 50,
	    // FIXME '10%' ?
	    axisExpandRate: 17,
	    axisExpandDebounce: 50,
	    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
	    // Do not doc to user until necessary.
	    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
	    axisExpandTriggerOn: 'click',
	    // 'mousemove' or 'click'
	    parallelAxisDefault: null
	  },
	
	  /**
	   * @override
	   */
	  init: function () {
	    Component.prototype.init.apply(this, arguments);
	    this.mergeOption({});
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var thisOption = this.option;
	    newOption && zrUtil.merge(thisOption, newOption, true);
	
	    this._initDimensions();
	  },
	
	  /**
	   * Whether series or axis is in this coordinate system.
	   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
	   * @param {module:echarts/model/Global} ecModel
	   */
	  contains: function (model, ecModel) {
	    var parallelIndex = model.get('parallelIndex');
	    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
	  },
	  setAxisExpand: function (opt) {
	    zrUtil.each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
	      if (opt.hasOwnProperty(name)) {
	        this.option[name] = opt[name];
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _initDimensions: function () {
	    var dimensions = this.dimensions = [];
	    var parallelAxisIndex = this.parallelAxisIndex = [];
	    var axisModels = zrUtil.filter(this.dependentModels.parallelAxis, function (axisModel) {
	      // Can not use this.contains here, because
	      // initialization has not been completed yet.
	      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
	    }, this);
	    zrUtil.each(axisModels, function (axisModel) {
	      dimensions.push('dim' + axisModel.get('dim'));
	      parallelAxisIndex.push(axisModel.componentIndex);
	    });
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var modelUtil = __webpack_require__(27);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  createParallelIfNeeded(option);
	  mergeAxisOptionFromParallel(option);
	}
	/**
	 * Create a parallel coordinate if not exists.
	 * @inner
	 */
	
	
	function createParallelIfNeeded(option) {
	  if (option.parallel) {
	    return;
	  }
	
	  var hasParallelSeries = false;
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'parallel') {
	      hasParallelSeries = true;
	    }
	  });
	
	  if (hasParallelSeries) {
	    option.parallel = [{}];
	  }
	}
	/**
	 * Merge aixs definition from parallel option (if exists) to axis option.
	 * @inner
	 */
	
	
	function mergeAxisOptionFromParallel(option) {
	  var axes = modelUtil.normalizeToArray(option.parallelAxis);
	  zrUtil.each(axes, function (axisOption) {
	    if (!zrUtil.isObject(axisOption)) {
	      return;
	    }
	
	    var parallelIndex = axisOption.parallelIndex || 0;
	    var parallelOption = modelUtil.normalizeToArray(option.parallel)[parallelIndex];
	
	    if (parallelOption && parallelOption.parallelAxisDefault) {
	      zrUtil.merge(axisOption, parallelOption.parallelAxisDefault, false);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var textContain = __webpack_require__(86);
	
	var Axis = __webpack_require__(129);
	
	var _model = __webpack_require__(27);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function AngleAxis(scale, angleExtent) {
	  angleExtent = angleExtent || [0, 360];
	  Axis.call(this, 'angle', scale, angleExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	AngleAxis.prototype = {
	  constructor: AngleAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToAngle: Axis.prototype.dataToCoord,
	  angleToData: Axis.prototype.coordToData,
	
	  /**
	   * Only be called in category axis.
	   * Angle axis uses text height to decide interval
	   *
	   * @override
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    var axis = this;
	    var labelModel = axis.getLabelModel();
	    var ordinalScale = axis.scale;
	    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	    // avoid generating a long array by `getTicks`
	    // in large category data case.
	
	    var tickCount = ordinalScale.count();
	
	    if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	      return 0;
	    }
	
	    var tickValue = ordinalExtent[0];
	    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	    var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(tickValue, labelModel.getFont(), 'center', 'top');
	    var maxH = Math.max(rect.height, 7);
	    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	    isNaN(dh) && (dh = Infinity);
	    var interval = Math.max(0, Math.floor(dh));
	    var cache = inner(axis.model);
	    var lastAutoInterval = cache.lastAutoInterval;
	    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	    // otherwise the calculated interval might jitter when the zoom
	    // window size is close to the interval-changing size.
	
	    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	    // point is not the same when zooming in or zooming out.
	    && lastAutoInterval > interval) {
	      interval = lastAutoInterval;
	    } // Only update cache if cache not used, otherwise the
	    // changing of interval is too insensitive.
	    else {
	        cache.lastTickCount = tickCount;
	        cache.lastAutoInterval = interval;
	      }
	
	    return interval;
	  }
	};
	zrUtil.inherits(AngleAxis, Axis);
	var _default = AngleAxis;
	module.exports = _default;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ComponentModel = __webpack_require__(65);
	
	var axisModelCreator = __webpack_require__(270);
	
	var axisModelCommonMixin = __webpack_require__(175);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisModel = ComponentModel.extend({
	  type: 'polarAxis',
	
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'polar',
	      index: this.option.polarIndex,
	      id: this.option.polarId
	    })[0];
	  }
	});
	zrUtil.merge(PolarAxisModel.prototype, axisModelCommonMixin);
	var polarAxisDefaultExtendedOption = {
	  angle: {
	    // polarIndex: 0,
	    // polarId: '',
	    startAngle: 90,
	    clockwise: true,
	    splitNumber: 12,
	    axisLabel: {
	      rotate: false
	    }
	  },
	  radius: {
	    // polarIndex: 0,
	    // polarId: '',
	    splitNumber: 5
	  }
	};
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('angle', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.angle);
	axisModelCreator('radius', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.radius);

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var RadiusAxis = __webpack_require__(1838);
	
	var AngleAxis = __webpack_require__(1834);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/polar/Polar
	 */
	
	/**
	 * @alias {module:echarts/coord/polar/Polar}
	 * @constructor
	 * @param {string} name
	 */
	var Polar = function (name) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * x of polar center
	   * @type {number}
	   */
	
	  this.cx = 0;
	  /**
	   * y of polar center
	   * @type {number}
	   */
	
	  this.cy = 0;
	  /**
	   * @type {module:echarts/coord/polar/RadiusAxis}
	   * @private
	   */
	
	  this._radiusAxis = new RadiusAxis();
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis}
	   * @private
	   */
	
	  this._angleAxis = new AngleAxis();
	  this._radiusAxis.polar = this._angleAxis.polar = this;
	};
	
	Polar.prototype = {
	  type: 'polar',
	  axisPointerEnabled: true,
	  constructor: Polar,
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['radius', 'angle'],
	
	  /**
	   * @type {module:echarts/coord/PolarModel}
	   */
	  model: null,
	
	  /**
	   * If contain coord
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var coord = this.pointToCoord(point);
	    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
	  },
	
	  /**
	   * @param {string} dim
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxis: function (dim) {
	    return this['_' + dim + 'Axis'];
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._radiusAxis, this._angleAxis];
	  },
	
	  /**
	   * Get axes by type of scale
	   * @param {string} scaleType
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxesByScale: function (scaleType) {
	    var axes = [];
	    var angleAxis = this._angleAxis;
	    var radiusAxis = this._radiusAxis;
	    angleAxis.scale.type === scaleType && axes.push(angleAxis);
	    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
	    return axes;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/AngleAxis}
	   */
	  getAngleAxis: function () {
	    return this._angleAxis;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/RadiusAxis}
	   */
	  getRadiusAxis: function () {
	    return this._radiusAxis;
	  },
	
	  /**
	   * @param {module:echarts/coord/polar/Axis}
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getOtherAxis: function (axis) {
	    var angleAxis = this._angleAxis;
	    return axis === angleAxis ? this._radiusAxis : angleAxis;
	  },
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
	  },
	
	  /**
	   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function (dim) {
	    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
	    return {
	      baseAxes: [baseAxis],
	      otherAxes: [this.getOtherAxis(baseAxis)]
	    };
	  },
	
	  /**
	   * Convert a single data item to (x, y) point.
	   * Parameter data is an array which the first element is radius and the second is angle
	   * @param {Array.<number>} data
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, clamp) {
	    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
	  },
	
	  /**
	   * Convert a (x, y) point to data
	   * @param {Array.<number>} point
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, clamp) {
	    var coord = this.pointToCoord(point);
	    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
	  },
	
	  /**
	   * Convert a (x, y) point to (radius, angle) coord
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToCoord: function (point) {
	    var dx = point[0] - this.cx;
	    var dy = point[1] - this.cy;
	    var angleAxis = this.getAngleAxis();
	    var extent = angleAxis.getExtent();
	    var minAngle = Math.min(extent[0], extent[1]);
	    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
	    // FIXME
	
	    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
	    var radius = Math.sqrt(dx * dx + dy * dy);
	    dx /= radius;
	    dy /= radius;
	    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent
	
	    var dir = radian < minAngle ? 1 : -1;
	
	    while (radian < minAngle || radian > maxAngle) {
	      radian += dir * 360;
	    }
	
	    return [radius, radian];
	  },
	
	  /**
	   * Convert a (radius, angle) coord to (x, y) point
	   * @param {Array.<number>} coord
	   * @return {Array.<number>}
	   */
	  coordToPoint: function (coord) {
	    var radius = coord[0];
	    var radian = coord[1] / 180 * Math.PI;
	    var x = Math.cos(radian) * radius + this.cx; // Inverse the y
	
	    var y = -Math.sin(radian) * radius + this.cy;
	    return [x, y];
	  },
	
	  /**
	   * Get ring area of cartesian.
	   * Area will have a contain function to determine if a point is in the coordinate system.
	   * @return {Ring}
	   */
	  getArea: function () {
	    var angleAxis = this.getAngleAxis();
	    var radiusAxis = this.getRadiusAxis();
	    var radiusExtent = radiusAxis.getExtent().slice();
	    radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
	    var angleExtent = angleAxis.getExtent();
	    var RADIAN = Math.PI / 180;
	    return {
	      cx: this.cx,
	      cy: this.cy,
	      r0: radiusExtent[0],
	      r: radiusExtent[1],
	      startAngle: -angleExtent[0] * RADIAN,
	      endAngle: -angleExtent[1] * RADIAN,
	      clockwise: angleAxis.inverse,
	      contain: function (x, y) {
	        // It's a ring shape.
	        // Start angle and end angle don't matter
	        var dx = x - this.cx;
	        var dy = y - this.cy;
	        var d2 = dx * dx + dy * dy;
	        var r = this.r;
	        var r0 = this.r0;
	        return d2 <= r * r && d2 >= r0 * r0;
	      }
	    };
	  }
	};
	var _default = Polar;
	module.exports = _default;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	__webpack_require__(1835);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'polar',
	  dependencies: ['polarAxis', 'angleAxis'],
	
	  /**
	   * @type {module:echarts/coord/polar/Polar}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @param {string} axisType
	   * @return {module:echarts/coord/polar/AxisModel}
	   */
	  findAxisModel: function (axisType) {
	    var foundAxisModel;
	    var ecModel = this.ecModel;
	    ecModel.eachComponent(axisType, function (axisModel) {
	      if (axisModel.getCoordSysModel() === this) {
	        foundAxisModel = axisModel;
	      }
	    }, this);
	    return foundAxisModel;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '80%'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Axis = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function RadiusAxis(scale, radiusExtent) {
	  Axis.call(this, 'radius', scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	RadiusAxis.prototype = {
	  constructor: RadiusAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToRadius: Axis.prototype.dataToCoord,
	  radiusToData: Axis.prototype.coordToData
	};
	zrUtil.inherits(RadiusAxis, Axis);
	var _default = RadiusAxis;
	module.exports = _default;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  return zrUtil.map(['Radius', 'Angle'], function (dim, dimIdx) {
	    var axis = this['get' + dim + 'Axis']();
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var method = 'dataTo' + dim;
	    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));
	
	    if (dim === 'Angle') {
	      result = result * Math.PI / 180;
	    }
	
	    return result;
	  }, this);
	}
	
	function _default(coordSys) {
	  var radiusAxis = coordSys.getRadiusAxis();
	  var angleAxis = coordSys.getAngleAxis();
	  var radius = radiusAxis.getExtent();
	  radius[0] > radius[1] && radius.reverse();
	  return {
	    coordSys: {
	      type: 'polar',
	      cx: coordSys.cx,
	      cy: coordSys.cy,
	      r: radius[1],
	      r0: radius[0]
	    },
	    api: {
	      coord: zrUtil.bind(function (data) {
	        var radius = radiusAxis.dataToRadius(data[0]);
	        var angle = angleAxis.dataToAngle(data[1]);
	        var coord = coordSys.coordToPoint([radius, angle]);
	        coord.push(radius, angle * Math.PI / 180);
	        return coord;
	      }),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Axis = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function IndicatorAxis(dim, scale, radiusExtent) {
	  Axis.call(this, dim, scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'value';
	  this.angle = 0;
	  /**
	   * Indicator name
	   * @type {string}
	   */
	
	  this.name = '';
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.model;
	}
	
	zrUtil.inherits(IndicatorAxis, Axis);
	var _default = IndicatorAxis;
	module.exports = _default;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var IndicatorAxis = __webpack_require__(1840);
	
	var IntervalScale = __webpack_require__(273);
	
	var numberUtil = __webpack_require__(24);
	
	var _axisHelper = __webpack_require__(96);
	
	var getScaleExtent = _axisHelper.getScaleExtent;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(95);
	
	var LogScale = __webpack_require__(855);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO clockwise
	function Radar(radarModel, ecModel, api) {
	  this._model = radarModel;
	  /**
	   * Radar dimensions
	   * @type {Array.<string>}
	   */
	
	  this.dimensions = [];
	  this._indicatorAxes = zrUtil.map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
	    var dim = 'indicator_' + idx;
	    var indicatorAxis = new IndicatorAxis(dim, indicatorModel.get('axisType') === 'log' ? new LogScale() : new IntervalScale());
	    indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis
	
	    indicatorAxis.model = indicatorModel;
	    indicatorModel.axis = indicatorAxis;
	    this.dimensions.push(dim);
	    return indicatorAxis;
	  }, this);
	  this.resize(radarModel, api);
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cx;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cy;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r0;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.startAngle;
	}
	
	Radar.prototype.getIndicatorAxes = function () {
	  return this._indicatorAxes;
	};
	
	Radar.prototype.dataToPoint = function (value, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
	};
	
	Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  var angle = indicatorAxis.angle;
	  var x = this.cx + coord * Math.cos(angle);
	  var y = this.cy - coord * Math.sin(angle);
	  return [x, y];
	};
	
	Radar.prototype.pointToData = function (pt) {
	  var dx = pt[0] - this.cx;
	  var dy = pt[1] - this.cy;
	  var radius = Math.sqrt(dx * dx + dy * dy);
	  dx /= radius;
	  dy /= radius;
	  var radian = Math.atan2(-dy, dx); // Find the closest angle
	  // FIXME index can calculated directly
	
	  var minRadianDiff = Infinity;
	  var closestAxis;
	  var closestAxisIdx = -1;
	
	  for (var i = 0; i < this._indicatorAxes.length; i++) {
	    var indicatorAxis = this._indicatorAxes[i];
	    var diff = Math.abs(radian - indicatorAxis.angle);
	
	    if (diff < minRadianDiff) {
	      closestAxis = indicatorAxis;
	      closestAxisIdx = i;
	      minRadianDiff = diff;
	    }
	  }
	
	  return [closestAxisIdx, +(closestAxis && closestAxis.coordToData(radius))];
	};
	
	Radar.prototype.resize = function (radarModel, api) {
	  var center = radarModel.get('center');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var viewSize = Math.min(viewWidth, viewHeight) / 2;
	  this.cx = numberUtil.parsePercent(center[0], viewWidth);
	  this.cy = numberUtil.parsePercent(center[1], viewHeight);
	  this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
	
	  var radius = radarModel.get('radius');
	
	  if (typeof radius === 'string' || typeof radius === 'number') {
	    radius = [0, radius];
	  }
	
	  this.r0 = numberUtil.parsePercent(radius[0], viewSize);
	  this.r = numberUtil.parsePercent(radius[1], viewSize);
	  zrUtil.each(this._indicatorAxes, function (indicatorAxis, idx) {
	    indicatorAxis.setExtent(this.r0, this.r);
	    var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]
	
	    angle = Math.atan2(Math.sin(angle), Math.cos(angle));
	    indicatorAxis.angle = angle;
	  }, this);
	};
	
	Radar.prototype.update = function (ecModel, api) {
	  var indicatorAxes = this._indicatorAxes;
	  var radarModel = this._model;
	  zrUtil.each(indicatorAxes, function (indicatorAxis) {
	    indicatorAxis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
	    if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
	      return;
	    }
	
	    var data = radarSeries.getData();
	    zrUtil.each(indicatorAxes, function (indicatorAxis) {
	      indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
	    });
	  }, this);
	  var splitNumber = radarModel.get('splitNumber');
	
	  function increaseInterval(interval) {
	    var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval
	
	    var f = interval / exp10;
	
	    if (f === 2) {
	      f = 5;
	    } else {
	      // f is 2 or 5
	      f *= 2;
	    }
	
	    return f * exp10;
	  } // Force all the axis fixing the maxSplitNumber.
	
	
	  zrUtil.each(indicatorAxes, function (indicatorAxis, idx) {
	    var rawExtent = getScaleExtent(indicatorAxis.scale, indicatorAxis.model).extent;
	    niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
	    var axisModel = indicatorAxis.model;
	    var scale = indicatorAxis.scale;
	    var fixedMin = axisModel.getMin();
	    var fixedMax = axisModel.getMax();
	    var interval = scale.getInterval();
	
	    if (fixedMin != null && fixedMax != null) {
	      // User set min, max, divide to get new interval
	      scale.setExtent(+fixedMin, +fixedMax);
	      scale.setInterval((fixedMax - fixedMin) / splitNumber);
	    } else if (fixedMin != null) {
	      var max; // User set min, expand extent on the other side
	
	      do {
	        max = fixedMin + interval * splitNumber;
	        scale.setExtent(+fixedMin, max); // Interval must been set after extent
	        // FIXME
	
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
	    } else if (fixedMax != null) {
	      var min; // User set min, expand extent on the other side
	
	      do {
	        min = fixedMax - interval * splitNumber;
	        scale.setExtent(min, +fixedMax);
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
	    } else {
	      var nicedSplitNumber = scale.getTicks().length - 1;
	
	      if (nicedSplitNumber > splitNumber) {
	        interval = increaseInterval(interval);
	      } // TODO
	
	
	      var max = Math.ceil(rawExtent[1] / interval) * interval;
	      var min = numberUtil.round(max - interval * splitNumber);
	      scale.setExtent(min, max);
	      scale.setInterval(interval);
	    }
	  });
	};
	/**
	 * Radar dimensions is based on the data
	 * @type {Array}
	 */
	
	
	Radar.dimensions = [];
	
	Radar.create = function (ecModel, api) {
	  var radarList = [];
	  ecModel.eachComponent('radar', function (radarModel) {
	    var radar = new Radar(radarModel, ecModel, api);
	    radarList.push(radar);
	    radarModel.coordinateSystem = radar;
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries) {
	    if (radarSeries.get('coordinateSystem') === 'radar') {
	      // Inject coordinate system
	      radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
	    }
	  });
	  return radarList;
	};
	
	CoordinateSystem.register('radar', Radar);
	var _default = Radar;
	module.exports = _default;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(8);
	
	var zrUtil = __webpack_require__(2);
	
	var axisDefault = __webpack_require__(841);
	
	var Model = __webpack_require__(57);
	
	var axisModelCommonMixin = __webpack_require__(175);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var valueAxisDefault = axisDefault.valueAxis;
	
	function defaultsShow(opt, show) {
	  return zrUtil.defaults({
	    show: show
	  }, opt);
	}
	
	var RadarModel = echarts.extendComponentModel({
	  type: 'radar',
	  optionUpdated: function () {
	    var boundaryGap = this.get('boundaryGap');
	    var splitNumber = this.get('splitNumber');
	    var scale = this.get('scale');
	    var axisLine = this.get('axisLine');
	    var axisTick = this.get('axisTick');
	    var axisType = this.get('axisType');
	    var axisLabel = this.get('axisLabel');
	    var nameTextStyle = this.get('name');
	    var showName = this.get('name.show');
	    var nameFormatter = this.get('name.formatter');
	    var nameGap = this.get('nameGap');
	    var triggerEvent = this.get('triggerEvent');
	    var indicatorModels = zrUtil.map(this.get('indicator') || [], function (indicatorOpt) {
	      // PENDING
	      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
	        indicatorOpt.min = 0;
	      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
	        indicatorOpt.max = 0;
	      }
	
	      var iNameTextStyle = nameTextStyle;
	
	      if (indicatorOpt.color != null) {
	        iNameTextStyle = zrUtil.defaults({
	          color: indicatorOpt.color
	        }, nameTextStyle);
	      } // Use same configuration
	
	
	      indicatorOpt = zrUtil.merge(zrUtil.clone(indicatorOpt), {
	        boundaryGap: boundaryGap,
	        splitNumber: splitNumber,
	        scale: scale,
	        axisLine: axisLine,
	        axisTick: axisTick,
	        axisType: axisType,
	        axisLabel: axisLabel,
	        // Compatible with 2 and use text
	        name: indicatorOpt.text,
	        nameLocation: 'end',
	        nameGap: nameGap,
	        // min: 0,
	        nameTextStyle: iNameTextStyle,
	        triggerEvent: triggerEvent
	      }, false);
	
	      if (!showName) {
	        indicatorOpt.name = '';
	      }
	
	      if (typeof nameFormatter === 'string') {
	        var indName = indicatorOpt.name;
	        indicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
	      } else if (typeof nameFormatter === 'function') {
	        indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
	      }
	
	      var model = zrUtil.extend(new Model(indicatorOpt, null, this.ecModel), axisModelCommonMixin); // For triggerEvent.
	
	      model.mainType = 'radar';
	      model.componentIndex = this.componentIndex;
	      return model;
	    }, this);
	
	    this.getIndicatorModels = function () {
	      return indicatorModels;
	    };
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '75%',
	    startAngle: 90,
	    name: {
	      show: true // formatter: null
	      // textStyle: {}
	
	    },
	    boundaryGap: [0, 0],
	    splitNumber: 5,
	    nameGap: 15,
	    scale: false,
	    // Polygon or circle
	    shape: 'polygon',
	    axisLine: zrUtil.merge({
	      lineStyle: {
	        color: '#bbb'
	      }
	    }, valueAxisDefault.axisLine),
	    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
	    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
	    axisType: 'interval',
	    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
	    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
	    // {text, min, max}
	    indicator: []
	  }
	});
	var _default = RadarModel;
	module.exports = _default;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var ComponentModel = __webpack_require__(65);
	
	var axisModelCreator = __webpack_require__(270);
	
	var axisModelCommonMixin = __webpack_require__(175);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'singleAxis',
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/single/SingleAxis}
	   */
	  axis: null,
	
	  /**
	   * @type {module:echarts/coord/single/Single}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this;
	  }
	});
	var defaultOption = {
	  left: '5%',
	  top: '5%',
	  right: '5%',
	  bottom: '5%',
	  type: 'value',
	  position: 'bottom',
	  orient: 'horizontal',
	  axisLine: {
	    show: true,
	    lineStyle: {
	      width: 1,
	      type: 'solid'
	    }
	  },
	  // Single coordinate system and single axis is the,
	  // which is used as the parent tooltip model.
	  // same model, so we set default tooltip show as true.
	  tooltip: {
	    show: true
	  },
	  axisTick: {
	    show: true,
	    length: 6,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    interval: 'auto'
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      type: 'dashed',
	      opacity: 0.2
	    }
	  }
	};
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	axisModelCreator('single', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SingleAxis = __webpack_require__(1845);
	
	var axisHelper = __webpack_require__(96);
	
	var _layout = __webpack_require__(47);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinates system.
	 */
	
	/**
	 * Create a single coordinates system.
	 *
	 * @param {module:echarts/coord/single/AxisModel} axisModel
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function Single(axisModel, ecModel, api) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.dimension = 'single';
	  /**
	   * Add it just for draw tooltip.
	   *
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = ['single'];
	  /**
	   * @private
	   * @type {module:echarts/coord/single/SingleAxis}.
	   */
	
	  this._axis = null;
	  /**
	   * @private
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	
	  this._init(axisModel, ecModel, api);
	  /**
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	
	
	  this.model = axisModel;
	}
	
	Single.prototype = {
	  type: 'singleAxis',
	  axisPointerEnabled: true,
	  constructor: Single,
	
	  /**
	   * Initialize single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @private
	   */
	  _init: function (axisModel, ecModel, api) {
	    var dim = this.dimension;
	    var axis = new SingleAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
	    var isCategory = axis.type === 'category';
	    axis.onBand = isCategory && axisModel.get('boundaryGap');
	    axis.inverse = axisModel.get('inverse');
	    axis.orient = axisModel.get('orient');
	    axisModel.axis = axis;
	    axis.model = axisModel;
	    axis.coordinateSystem = this;
	    this._axis = axis;
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.coordinateSystem === this) {
	        var data = seriesModel.getData();
	        each(data.mapDimension(this.dimension, true), function (dim) {
	          this._axis.scale.unionExtentFromData(data, dim);
	        }, this);
	        axisHelper.niceScaleExtent(this._axis.scale, this._axis.model);
	      }
	    }, this);
	  },
	
	  /**
	   * Resize the single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  resize: function (axisModel, api) {
	    this._rect = getLayoutRect({
	      left: axisModel.get('left'),
	      top: axisModel.get('top'),
	      right: axisModel.get('right'),
	      bottom: axisModel.get('bottom'),
	      width: axisModel.get('width'),
	      height: axisModel.get('height')
	    }, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._adjustAxis();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _adjustAxis: function () {
	    var rect = this._rect;
	    var axis = this._axis;
	    var isHorizontal = axis.isHorizontal();
	    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
	    var idx = axis.reverse ? 1 : 0;
	    axis.setExtent(extent[idx], extent[1 - idx]);
	
	    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
	  },
	
	  /**
	   * @param  {module:echarts/coord/single/SingleAxis} axis
	   * @param  {number} coordBase
	   */
	  _updateAxisTransform: function (axis, coordBase) {
	    var axisExtent = axis.getExtent();
	    var extentSum = axisExtent[0] + axisExtent[1];
	    var isHorizontal = axis.isHorizontal();
	    axis.toGlobalCoord = isHorizontal ? function (coord) {
	      return coord + coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	    axis.toLocalCoord = isHorizontal ? function (coord) {
	      return coord - coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	  },
	
	  /**
	   * Get axis.
	   *
	   * @return {module:echarts/coord/single/SingleAxis}
	   */
	  getAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * Get axis, add it just for draw tooltip.
	   *
	   * @return {[type]} [description]
	   */
	  getBaseAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._axis];
	  },
	
	  /**
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function () {
	    return {
	      baseAxes: [this.getAxis()]
	    };
	  },
	
	  /**
	   * If contain point.
	   *
	   * @param  {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var rect = this.getRect();
	    var axis = this.getAxis();
	    var orient = axis.orient;
	
	    if (orient === 'horizontal') {
	      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
	    } else {
	      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
	    }
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var axis = this.getAxis();
	    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
	  },
	
	  /**
	   * Convert the series data to concrete point.
	   *
	   * @param  {number|Array.<number>} val
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (val) {
	    var axis = this.getAxis();
	    var rect = this.getRect();
	    var pt = [];
	    var idx = axis.orient === 'horizontal' ? 0 : 1;
	
	    if (val instanceof Array) {
	      val = val[0];
	    }
	
	    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
	    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
	    return pt;
	  }
	};
	var _default = Single;
	module.exports = _default;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Axis = __webpack_require__(129);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor  module:echarts/coord/single/SingleAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var SingleAxis = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   * - 'category'
	   * - 'value'
	   * - 'time'
	   * - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   *  @type {string}
	   */
	
	  this.position = position || 'bottom';
	  /**
	   * Axis orient
	   *  - 'horizontal'
	   *  - 'vertical'
	   * @type {[type]}
	   */
	
	  this.orient = null;
	};
	
	SingleAxis.prototype = {
	  constructor: SingleAxis,
	
	  /**
	   * Axis model
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	  model: null,
	
	  /**
	   * Judge the orient of the axis.
	   * @return {boolean}
	   */
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordinateSystem.pointToData(point, clamp)[0];
	  },
	
	  /**
	   * Convert the local coord(processed by dataToCoord())
	   * to global coord(concrete pixel coord).
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toGlobalCoord: null,
	
	  /**
	   * Convert the global coord to local coord.
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toLocalCoord: null
	};
	zrUtil.inherits(SingleAxis, Axis);
	var _default = SingleAxis;
	module.exports = _default;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  var axis = this.getAxis();
	  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
	  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
	  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  return {
	    coordSys: {
	      type: 'singleAxis',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (val) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(val);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Single = __webpack_require__(1844);
	
	var CoordinateSystem = __webpack_require__(95);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinate system creator.
	 */
	
	/**
	 * Create single coordinate system and inject it into seriesModel.
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Array.<module:echarts/coord/single/Single>}
	 */
	function create(ecModel, api) {
	  var singles = [];
	  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
	    var single = new Single(axisModel, ecModel, api);
	    single.name = 'single_' + idx;
	    single.resize(axisModel, api);
	    axisModel.coordinateSystem = single;
	    singles.push(single);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
	      var singleAxisModel = ecModel.queryComponents({
	        mainType: 'singleAxis',
	        index: seriesModel.get('singleAxisIndex'),
	        id: seriesModel.get('singleAxisId')
	      })[0];
	      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
	    }
	  });
	  return singles;
	}
	
	CoordinateSystem.register('single', {
	  create: create,
	  dimensions: Single.prototype.dimensions
	});

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(2);
	
	var _clazz = __webpack_require__(115);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// id may be function name of Object, add a prefix to avoid this problem.
	function generateNodeKey(id) {
	  return '_EC_' + id;
	}
	/**
	 * @alias module:echarts/data/Graph
	 * @constructor
	 * @param {boolean} directed
	 */
	
	
	var Graph = function (directed) {
	  /**
	   * 是否是有向图
	   * @type {boolean}
	   * @private
	   */
	  this._directed = directed || false;
	  /**
	   * @type {Array.<module:echarts/data/Graph.Node>}
	   * @readOnly
	   */
	
	  this.nodes = [];
	  /**
	   * @type {Array.<module:echarts/data/Graph.Edge>}
	   * @readOnly
	   */
	
	  this.edges = [];
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Node>}
	   * @private
	   */
	
	  this._nodesMap = {};
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Edge>}
	   * @private
	   */
	
	  this._edgesMap = {};
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.edgeData;
	};
	
	var graphProto = Graph.prototype;
	/**
	 * @type {string}
	 */
	
	graphProto.type = 'graph';
	/**
	 * If is directed graph
	 * @return {boolean}
	 */
	
	graphProto.isDirected = function () {
	  return this._directed;
	};
	/**
	 * Add a new node
	 * @param {string} id
	 * @param {number} [dataIndex]
	 */
	
	
	graphProto.addNode = function (id, dataIndex) {
	  id = id == null ? '' + dataIndex : '' + id;
	  var nodesMap = this._nodesMap;
	
	  if (nodesMap[generateNodeKey(id)]) {
	    return;
	  }
	
	  var node = new Node(id, dataIndex);
	  node.hostGraph = this;
	  this.nodes.push(node);
	  nodesMap[generateNodeKey(id)] = node;
	  return node;
	};
	/**
	 * Get node by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getNodeByIndex = function (dataIndex) {
	  var rawIdx = this.data.getRawIndex(dataIndex);
	  return this.nodes[rawIdx];
	};
	/**
	 * Get node by id
	 * @param  {string} id
	 * @return {module:echarts/data/Graph.Node}
	 */
	
	
	graphProto.getNodeById = function (id) {
	  return this._nodesMap[generateNodeKey(id)];
	};
	/**
	 * Add a new edge
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.addEdge = function (n1, n2, dataIndex) {
	  var nodesMap = this._nodesMap;
	  var edgesMap = this._edgesMap; // PNEDING
	
	  if (typeof n1 === 'number') {
	    n1 = this.nodes[n1];
	  }
	
	  if (typeof n2 === 'number') {
	    n2 = this.nodes[n2];
	  }
	
	  if (!Node.isInstance(n1)) {
	    n1 = nodesMap[generateNodeKey(n1)];
	  }
	
	  if (!Node.isInstance(n2)) {
	    n2 = nodesMap[generateNodeKey(n2)];
	  }
	
	  if (!n1 || !n2) {
	    return;
	  }
	
	  var key = n1.id + '-' + n2.id;
	  var edge = new Edge(n1, n2, dataIndex);
	  edge.hostGraph = this;
	
	  if (this._directed) {
	    n1.outEdges.push(edge);
	    n2.inEdges.push(edge);
	  }
	
	  n1.edges.push(edge);
	
	  if (n1 !== n2) {
	    n2.edges.push(edge);
	  }
	
	  this.edges.push(edge);
	  edgesMap[key] = edge;
	  return edge;
	};
	/**
	 * Get edge by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getEdgeByIndex = function (dataIndex) {
	  var rawIdx = this.edgeData.getRawIndex(dataIndex);
	  return this.edges[rawIdx];
	};
	/**
	 * Get edge by two linked nodes
	 * @param  {module:echarts/data/Graph.Node|string} n1
	 * @param  {module:echarts/data/Graph.Node|string} n2
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.getEdge = function (n1, n2) {
	  if (Node.isInstance(n1)) {
	    n1 = n1.id;
	  }
	
	  if (Node.isInstance(n2)) {
	    n2 = n2.id;
	  }
	
	  var edgesMap = this._edgesMap;
	
	  if (this._directed) {
	    return edgesMap[n1 + '-' + n2];
	  } else {
	    return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
	  }
	};
	/**
	 * Iterate all nodes
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachNode = function (cb, context) {
	  var nodes = this.nodes;
	  var len = nodes.length;
	
	  for (var i = 0; i < len; i++) {
	    if (nodes[i].dataIndex >= 0) {
	      cb.call(context, nodes[i], i);
	    }
	  }
	};
	/**
	 * Iterate all edges
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachEdge = function (cb, context) {
	  var edges = this.edges;
	  var len = edges.length;
	
	  for (var i = 0; i < len; i++) {
	    if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
	      cb.call(context, edges[i], i);
	    }
	  }
	};
	/**
	 * Breadth first traverse
	 * @param {Function} cb
	 * @param {module:echarts/data/Graph.Node} startNode
	 * @param {string} [direction='none'] 'none'|'in'|'out'
	 * @param {*} [context]
	 */
	
	
	graphProto.breadthFirstTraverse = function (cb, startNode, direction, context) {
	  if (!Node.isInstance(startNode)) {
	    startNode = this._nodesMap[generateNodeKey(startNode)];
	  }
	
	  if (!startNode) {
	    return;
	  }
	
	  var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
	
	  for (var i = 0; i < this.nodes.length; i++) {
	    this.nodes[i].__visited = false;
	  }
	
	  if (cb.call(context, startNode, null)) {
	    return;
	  }
	
	  var queue = [startNode];
	
	  while (queue.length) {
	    var currentNode = queue.shift();
	    var edges = currentNode[edgeType];
	
	    for (var i = 0; i < edges.length; i++) {
	      var e = edges[i];
	      var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
	
	      if (!otherNode.__visited) {
	        if (cb.call(context, otherNode, currentNode)) {
	          // Stop traversing
	          return;
	        }
	
	        queue.push(otherNode);
	        otherNode.__visited = true;
	      }
	    }
	  }
	}; // TODO
	// graphProto.depthFirstTraverse = function (
	//     cb, startNode, direction, context
	// ) {
	// };
	// Filter update
	
	
	graphProto.update = function () {
	  var data = this.data;
	  var edgeData = this.edgeData;
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    nodes[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    nodes[data.getRawIndex(i)].dataIndex = i;
	  }
	
	  edgeData.filterSelf(function (idx) {
	    var edge = edges[edgeData.getRawIndex(idx)];
	    return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
	  }); // Update edge
	
	  for (var i = 0, len = edges.length; i < len; i++) {
	    edges[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = edgeData.count(); i < len; i++) {
	    edges[edgeData.getRawIndex(i)].dataIndex = i;
	  }
	};
	/**
	 * @return {module:echarts/data/Graph}
	 */
	
	
	graphProto.clone = function () {
	  var graph = new Graph(this._directed);
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(nodes[i].id, nodes[i].dataIndex);
	  }
	
	  for (var i = 0; i < edges.length; i++) {
	    var e = edges[i];
	    graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
	  }
	
	  return graph;
	};
	/**
	 * @alias module:echarts/data/Graph.Node
	 */
	
	
	function Node(id, dataIndex) {
	  /**
	  * @type {string}
	  */
	  this.id = id == null ? '' : id;
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.inEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.outEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.edges = [];
	  /**
	   * @type {module:echarts/data/Graph}
	   */
	
	  this.hostGraph;
	  /**
	   * @type {number}
	   */
	
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	
	Node.prototype = {
	  constructor: Node,
	
	  /**
	   * @return {number}
	   */
	  degree: function () {
	    return this.edges.length;
	  },
	
	  /**
	   * @return {number}
	   */
	  inDegree: function () {
	    return this.inEdges.length;
	  },
	
	  /**
	  * @return {number}
	  */
	  outDegree: function () {
	    return this.outEdges.length;
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var graph = this.hostGraph;
	    var itemModel = graph.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  }
	};
	/**
	 * 图边
	 * @alias module:echarts/data/Graph.Edge
	 * @param {module:echarts/data/Graph.Node} n1
	 * @param {module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 */
	
	function Edge(n1, n2, dataIndex) {
	  /**
	   * 节点1，如果是有向图则为源节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	  this.node1 = n1;
	  /**
	   * 节点2，如果是有向图则为目标节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	
	  this.node2 = n2;
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	/**
	 * @param {string} [path]
	 * @return {module:echarts/model/Model}
	 */
	
	
	Edge.prototype.getModel = function (path) {
	  if (this.dataIndex < 0) {
	    return;
	  }
	
	  var graph = this.hostGraph;
	  var itemModel = graph.edgeData.getItemModel(this.dataIndex);
	  return itemModel.getModel(path);
	};
	
	var createGraphDataProxyMixin = function (hostName, dataName) {
	  return {
	    /**
	     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
	     * @return {number}
	     */
	    getValue: function (dimension) {
	      var data = this[hostName][dataName];
	      return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	    },
	
	    /**
	     * @param {Object|string} key
	     * @param {*} [value]
	     */
	    setVisual: function (key, value) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
	    },
	
	    /**
	     * @param {string} key
	     * @return {boolean}
	     */
	    getVisual: function (key, ignoreParent) {
	      return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
	    },
	
	    /**
	     * @param {Object} layout
	     * @return {boolean} [merge=false]
	     */
	    setLayout: function (layout, merge) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
	    },
	
	    /**
	     * @return {Object}
	     */
	    getLayout: function () {
	      return this[hostName][dataName].getItemLayout(this.dataIndex);
	    },
	
	    /**
	     * @return {module:zrender/Element}
	     */
	    getGraphicEl: function () {
	      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
	    },
	
	    /**
	     * @return {number}
	     */
	    getRawIndex: function () {
	      return this[hostName][dataName].getRawIndex(this.dataIndex);
	    }
	  };
	};
	
	zrUtil.mixin(Node, createGraphDataProxyMixin('hostGraph', 'data'));
	zrUtil.mixin(Edge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
	Graph.Node = Node;
	Graph.Edge = Edge;
	enableClassCheck(Node);
	enableClassCheck(Edge);
	var _default = Graph;
	module.exports = _default;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var createListFromArray = __webpack_require__(113);
	
	var axisHelper = __webpack_require__(96);
	
	var axisModelCommonMixin = __webpack_require__(175);
	
	var Model = __webpack_require__(57);
	
	var _layout = __webpack_require__(47);
	
	var getLayoutRect = _layout.getLayoutRect;
	exports.getLayoutRect = _layout.getLayoutRect;
	
	var _dataStackHelper = __webpack_require__(102);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	var _completeDimensions = __webpack_require__(850);
	
	exports.completeDimensions = _completeDimensions;
	
	var _createDimensions = __webpack_require__(176);
	
	exports.createDimensions = _createDimensions;
	
	var _symbol = __webpack_require__(89);
	
	exports.createSymbol = _symbol.createSymbol;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge';
	
	/**
	 * Create a muti dimension List structure from seriesModel.
	 * @param  {module:echarts/model/Model} seriesModel
	 * @return {module:echarts/data/List} list
	 */
	function createList(seriesModel) {
	  return createListFromArray(seriesModel.getSource(), seriesModel);
	} // export function createGraph(seriesModel) {
	//     var nodes = seriesModel.get('data');
	//     var links = seriesModel.get('links');
	//     return createGraphFromNodeEdge(nodes, links, seriesModel);
	// }
	
	
	var dataStack = {
	  isDimensionStacked: isDimensionStacked,
	  enableDataStack: enableDataStack,
	  getStackedDimension: getStackedDimension
	};
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolDesc
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 */
	
	/**
	 * Create scale
	 * @param {Array.<number>} dataExtent
	 * @param {Object|module:echarts/Model} option
	 */
	function createScale(dataExtent, option) {
	  var axisModel = option;
	
	  if (!Model.isInstance(option)) {
	    axisModel = new Model(option);
	    zrUtil.mixin(axisModel, axisModelCommonMixin);
	  }
	
	  var scale = axisHelper.createScaleByModel(axisModel);
	  scale.setExtent(dataExtent[0], dataExtent[1]);
	  axisHelper.niceScaleExtent(scale, axisModel);
	  return scale;
	}
	/**
	 * Mixin common methods to axis model,
	 *
	 * Inlcude methods
	 * `getFormattedLabels() => Array.<string>`
	 * `getCategories() => Array.<string>`
	 * `getMin(origin: boolean) => number`
	 * `getMax(origin: boolean) => number`
	 * `getNeedCrossZero() => boolean`
	 * `setRange(start: number, end: number)`
	 * `resetRange()`
	 */
	
	
	function mixinAxisModelCommonMethods(Model) {
	  zrUtil.mixin(Model, axisModelCommonMixin);
	}
	
	exports.createList = createList;
	exports.dataStack = dataStack;
	exports.createScale = createScale;
	exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var _number = __webpack_require__(24);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(102);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
	}
	
	function getAxisKey(polar, axis) {
	  return axis.dim + polar.model.componentIndex;
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function barLayoutPolar(seriesType, ecModel, api) {
	  var lastStackCoords = {};
	  var barWidthAndOffset = calRadialBar(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
	    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
	  }));
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for polar only
	    if (seriesModel.coordinateSystem.type !== 'polar') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisKey = getAxisKey(polar, baseAxis);
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = polar.getOtherAxis(baseAxis);
	    var cx = seriesModel.coordinateSystem.cx;
	    var cy = seriesModel.coordinateSystem.cy;
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    var barMinAngle = seriesModel.get('barMinAngle') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
	    var valueAxisStart = valueAxis.dim === 'radius' ? valueAxis.dataToRadius(0) : valueAxis.dataToAngle(0);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	      // Only ordinal axis can be stacked.
	
	      if (stacked) {
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var r0;
	      var r;
	      var startAngle;
	      var endAngle; // radial sector
	
	      if (valueAxis.dim === 'radius') {
	        var radiusSpan = valueAxis.dataToRadius(value) - valueAxisStart;
	        var angle = baseAxis.dataToAngle(baseValue);
	
	        if (Math.abs(radiusSpan) < barMinHeight) {
	          radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
	        }
	
	        r0 = baseCoord;
	        r = baseCoord + radiusSpan;
	        startAngle = angle - columnOffset;
	        endAngle = startAngle - columnWidth;
	        stacked && (lastStackCoords[stackId][baseValue][sign] = r);
	      } // tangential sector
	      else {
	          var angleSpan = valueAxis.dataToAngle(value, clampLayout) - valueAxisStart;
	          var radius = baseAxis.dataToRadius(baseValue);
	
	          if (Math.abs(angleSpan) < barMinAngle) {
	            angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
	          }
	
	          r0 = radius + columnOffset;
	          r = r0 + columnWidth;
	          startAngle = baseCoord;
	          endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
	          // add a round to differentiate it from origin
	          // var extent = angleAxis.getExtent();
	          // var stackCoord = angle;
	          // if (stackCoord === extent[0] && value > 0) {
	          //     stackCoord = extent[1];
	          // }
	          // else if (stackCoord === extent[1] && value < 0) {
	          //     stackCoord = extent[0];
	          // }
	
	          stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
	        }
	
	      data.setItemLayout(idx, {
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: r,
	        // Consider that positive angle is anti-clockwise,
	        // while positive radian of sector is clockwise
	        startAngle: -startAngle * Math.PI / 180,
	        endAngle: -endAngle * Math.PI / 180
	      });
	    }
	  }, this);
	}
	/**
	 * Calculate bar width and offset for radial bar charts
	 */
	
	
	function calRadialBar(barSeries, api) {
	  // Columns info on each category axis. Key is polar name
	  var columnsMap = {};
	  zrUtil.each(barSeries, function (seriesModel, idx) {
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisKey = getAxisKey(polar, baseAxis);
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = getSeriesStackId(seriesModel);
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    };
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	
	    if (barWidth && !stacks[stackId].width) {
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      stacks[stackId].width = barWidth;
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    barGap != null && (columnsOnAxis.gap = barGap);
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column, stack) {
	      var maxWidth = column.maxWidth;
	
	      if (maxWidth && maxWidth < autoWidth) {
	        maxWidth = Math.min(maxWidth, remainedWidth);
	
	        if (column.width) {
	          maxWidth = Math.min(maxWidth, column.width);
	        }
	
	        remainedWidth -= maxWidth;
	        column.width = maxWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	
	var _default = barLayoutPolar;
	module.exports = _default;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var graphic = __webpack_require__(17);
	
	var textContain = __webpack_require__(86);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} [opts]
	 * @param {string} [opts.text]
	 * @param {string} [opts.color]
	 * @param {string} [opts.textColor]
	 * @return {module:zrender/Element}
	 */
	
	function _default(api, opts) {
	  opts = opts || {};
	  zrUtil.defaults(opts, {
	    text: 'loading',
	    textColor: '#000',
	    fontSize: '12px',
	    maskColor: 'rgba(255, 255, 255, 0.8)',
	    showSpinner: true,
	    color: '#c23531',
	    spinnerRadius: 10,
	    lineWidth: 5,
	    zlevel: 0
	  });
	  var group = new graphic.Group();
	  var mask = new graphic.Rect({
	    style: {
	      fill: opts.maskColor
	    },
	    zlevel: opts.zlevel,
	    z: 10000
	  });
	  group.add(mask);
	  var font = opts.fontSize + ' sans-serif';
	  var labelRect = new graphic.Rect({
	    style: {
	      fill: 'none',
	      text: opts.text,
	      font: font,
	      textPosition: 'right',
	      textDistance: 10,
	      textFill: opts.textColor
	    },
	    zlevel: opts.zlevel,
	    z: 10001
	  });
	  group.add(labelRect);
	
	  if (opts.showSpinner) {
	    var arc = new graphic.Arc({
	      shape: {
	        startAngle: -PI / 2,
	        endAngle: -PI / 2 + 0.1,
	        r: opts.spinnerRadius
	      },
	      style: {
	        stroke: opts.color,
	        lineCap: 'round',
	        lineWidth: opts.lineWidth
	      },
	      zlevel: opts.zlevel,
	      z: 10001
	    });
	    arc.animateShape(true).when(1000, {
	      endAngle: PI * 3 / 2
	    }).start('circularInOut');
	    arc.animateShape(true).when(1000, {
	      startAngle: PI * 3 / 2
	    }).delay(300).start('circularInOut');
	    group.add(arc);
	  } // Inject resize
	
	
	  group.resize = function () {
	    var textWidth = textContain.getWidth(opts.text, font);
	    var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
	    // textDistance needs to be calculated when both animation and text exist
	
	    var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 // only show the text
	    - (opts.showSpinner ? 0 : textWidth / 2);
	    var cy = api.getHeight() / 2;
	    opts.showSpinner && arc.setShape({
	      cx: cx,
	      cy: cy
	    });
	    labelRect.setShape({
	      x: cx - r,
	      y: cy - r,
	      width: r * 2,
	      height: r * 2
	    });
	    mask.setShape({
	      x: 0,
	      y: 0,
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  };
	
	  group.resize();
	  return group;
	}
	
	module.exports = _default;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var modelUtil = __webpack_require__(27);
	
	var ComponentModel = __webpack_require__(65);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts option manager
	 *
	 * @module {echarts/model/OptionManager}
	 */
	var each = zrUtil.each;
	var clone = zrUtil.clone;
	var map = zrUtil.map;
	var merge = zrUtil.merge;
	var QUERY_REG = /^(min|max)?(.+)$/;
	/**
	 * TERM EXPLANATIONS:
	 *
	 * [option]:
	 *
	 *     An object that contains definitions of components. For example:
	 *     var option = {
	 *         title: {...},
	 *         legend: {...},
	 *         visualMap: {...},
	 *         series: [
	 *             {data: [...]},
	 *             {data: [...]},
	 *             ...
	 *         ]
	 *     };
	 *
	 * [rawOption]:
	 *
	 *     An object input to echarts.setOption. 'rawOption' may be an
	 *     'option', or may be an object contains multi-options. For example:
	 *     var option = {
	 *         baseOption: {
	 *             title: {...},
	 *             legend: {...},
	 *             series: [
	 *                 {data: [...]},
	 *                 {data: [...]},
	 *                 ...
	 *             ]
	 *         },
	 *         timeline: {...},
	 *         options: [
	 *             {title: {...}, series: {data: [...]}},
	 *             {title: {...}, series: {data: [...]}},
	 *             ...
	 *         ],
	 *         media: [
	 *             {
	 *                 query: {maxWidth: 320},
	 *                 option: {series: {x: 20}, visualMap: {show: false}}
	 *             },
	 *             {
	 *                 query: {minWidth: 320, maxWidth: 720},
	 *                 option: {series: {x: 500}, visualMap: {show: true}}
	 *             },
	 *             {
	 *                 option: {series: {x: 1200}, visualMap: {show: true}}
	 *             }
	 *         ]
	 *     };
	 *
	 * @alias module:echarts/model/OptionManager
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	function OptionManager(api) {
	  /**
	   * @private
	   * @type {module:echarts/ExtensionAPI}
	   */
	  this._api = api;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._timelineOptions = [];
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	
	  this._mediaList = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._mediaDefault;
	  /**
	   * -1, means default.
	   * empty means no media.
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._currentMediaIndices = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._optionBackup;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._newBaseOption;
	} // timeline.notMerge is not supported in ec3. Firstly there is rearly
	// case that notMerge is needed. Secondly supporting 'notMerge' requires
	// rawOption cloned and backuped when timeline changed, which does no
	// good to performance. What's more, that both timeline and setOption
	// method supply 'notMerge' brings complex and some problems.
	// Consider this case:
	// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
	// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
	
	
	OptionManager.prototype = {
	  constructor: OptionManager,
	
	  /**
	   * @public
	   * @param {Object} rawOption Raw option.
	   * @param {module:echarts/model/Global} ecModel
	   * @param {Array.<Function>} optionPreprocessorFuncs
	   * @return {Object} Init option
	   */
	  setOption: function (rawOption, optionPreprocessorFuncs) {
	    if (rawOption) {
	      // That set dat primitive is dangerous if user reuse the data when setOption again.
	      zrUtil.each(modelUtil.normalizeToArray(rawOption.series), function (series) {
	        series && series.data && zrUtil.isTypedArray(series.data) && zrUtil.setAsPrimitive(series.data);
	      });
	    } // Caution: some series modify option data, if do not clone,
	    // it should ensure that the repeat modify correctly
	    // (create a new object when modify itself).
	
	
	    rawOption = clone(rawOption); // FIXME
	    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。
	
	    var oldOptionBackup = this._optionBackup;
	    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
	    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
	
	    if (oldOptionBackup) {
	      // Only baseOption can be merged.
	      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
	      // that is, if you `setOption` twice and both has timeline options, the latter
	      // timeline opitons will not be merged to the formers, but just substitude them.
	
	      if (newParsedOption.timelineOptions.length) {
	        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
	      }
	
	      if (newParsedOption.mediaList.length) {
	        oldOptionBackup.mediaList = newParsedOption.mediaList;
	      }
	
	      if (newParsedOption.mediaDefault) {
	        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
	      }
	    } else {
	      this._optionBackup = newParsedOption;
	    }
	  },
	
	  /**
	   * @param {boolean} isRecreate
	   * @return {Object}
	   */
	  mountOption: function (isRecreate) {
	    var optionBackup = this._optionBackup; // TODO
	    // 如果没有reset功能则不clone。
	
	    this._timelineOptions = map(optionBackup.timelineOptions, clone);
	    this._mediaList = map(optionBackup.mediaList, clone);
	    this._mediaDefault = clone(optionBackup.mediaDefault);
	    this._currentMediaIndices = [];
	    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
	    // called, and is merged into every new option by inner method `mergeOption`
	    // each time `setOption` called, can be only used in `isRecreate`, because
	    // its reliability is under suspicion. In other cases option merge is
	    // performed by `model.mergeOption`.
	    ? optionBackup.baseOption : this._newBaseOption);
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Object}
	   */
	  getTimelineOption: function (ecModel) {
	    var option;
	    var timelineOptions = this._timelineOptions;
	
	    if (timelineOptions.length) {
	      // getTimelineOption can only be called after ecModel inited,
	      // so we can get currentIndex from timelineModel.
	      var timelineModel = ecModel.getComponent('timeline');
	
	      if (timelineModel) {
	        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
	      }
	    }
	
	    return option;
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Array.<Object>}
	   */
	  getMediaOption: function (ecModel) {
	    var ecWidth = this._api.getWidth();
	
	    var ecHeight = this._api.getHeight();
	
	    var mediaList = this._mediaList;
	    var mediaDefault = this._mediaDefault;
	    var indices = [];
	    var result = []; // No media defined.
	
	    if (!mediaList.length && !mediaDefault) {
	      return result;
	    } // Multi media may be applied, the latter defined media has higher priority.
	
	
	    for (var i = 0, len = mediaList.length; i < len; i++) {
	      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
	        indices.push(i);
	      }
	    } // FIXME
	    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。
	
	
	    if (!indices.length && mediaDefault) {
	      indices = [-1];
	    }
	
	    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
	      result = map(indices, function (index) {
	        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
	      });
	    } // Otherwise return nothing.
	
	
	    this._currentMediaIndices = indices;
	    return result;
	  }
	};
	
	function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
	  var timelineOptions = [];
	  var mediaList = [];
	  var mediaDefault;
	  var baseOption; // Compatible with ec2.
	
	  var timelineOpt = rawOption.timeline;
	
	  if (rawOption.baseOption) {
	    baseOption = rawOption.baseOption;
	  } // For timeline
	
	
	  if (timelineOpt || rawOption.options) {
	    baseOption = baseOption || {};
	    timelineOptions = (rawOption.options || []).slice();
	  } // For media query
	
	
	  if (rawOption.media) {
	    baseOption = baseOption || {};
	    var media = rawOption.media;
	    each(media, function (singleMedia) {
	      if (singleMedia && singleMedia.option) {
	        if (singleMedia.query) {
	          mediaList.push(singleMedia);
	        } else if (!mediaDefault) {
	          // Use the first media default.
	          mediaDefault = singleMedia;
	        }
	      }
	    });
	  } // For normal option
	
	
	  if (!baseOption) {
	    baseOption = rawOption;
	  } // Set timelineOpt to baseOption in ec3,
	  // which is convenient for merge option.
	
	
	  if (!baseOption.timeline) {
	    baseOption.timeline = timelineOpt;
	  } // Preprocess.
	
	
	  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
	    return media.option;
	  })), function (option) {
	    each(optionPreprocessorFuncs, function (preProcess) {
	      preProcess(option, isNew);
	    });
	  });
	  return {
	    baseOption: baseOption,
	    timelineOptions: timelineOptions,
	    mediaDefault: mediaDefault,
	    mediaList: mediaList
	  };
	}
	/**
	 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
	 * Support: width, height, aspectRatio
	 * Can use max or min as prefix.
	 */
	
	
	function applyMediaQuery(query, ecWidth, ecHeight) {
	  var realMap = {
	    width: ecWidth,
	    height: ecHeight,
	    aspectratio: ecWidth / ecHeight // lowser case for convenientce.
	
	  };
	  var applicatable = true;
	  zrUtil.each(query, function (value, attr) {
	    var matched = attr.match(QUERY_REG);
	
	    if (!matched || !matched[1] || !matched[2]) {
	      return;
	    }
	
	    var operator = matched[1];
	    var realAttr = matched[2].toLowerCase();
	
	    if (!compare(realMap[realAttr], value, operator)) {
	      applicatable = false;
	    }
	  });
	  return applicatable;
	}
	
	function compare(real, expect, operator) {
	  if (operator === 'min') {
	    return real >= expect;
	  } else if (operator === 'max') {
	    return real <= expect;
	  } else {
	    // Equals
	    return real === expect;
	  }
	}
	
	function indicesEquals(indices1, indices2) {
	  // indices is always order by asc and has only finite number.
	  return indices1.join(',') === indices2.join(',');
	}
	/**
	 * Consider case:
	 * `chart.setOption(opt1);`
	 * Then user do some interaction like dataZoom, dataView changing.
	 * `chart.setOption(opt2);`
	 * Then user press 'reset button' in toolbox.
	 *
	 * After doing that all of the interaction effects should be reset, the
	 * chart should be the same as the result of invoke
	 * `chart.setOption(opt1); chart.setOption(opt2);`.
	 *
	 * Although it is not able ensure that
	 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
	 * `chart.setOption(merge(opt1, opt2));` exactly,
	 * this might be the only simple way to implement that feature.
	 *
	 * MEMO: We've considered some other approaches:
	 * 1. Each model handle its self restoration but not uniform treatment.
	 *     (Too complex in logic and error-prone)
	 * 2. Use a shadow ecModel. (Performace expensive)
	 */
	
	
	function mergeOption(oldOption, newOption) {
	  newOption = newOption || {};
	  each(newOption, function (newCptOpt, mainType) {
	    if (newCptOpt == null) {
	      return;
	    }
	
	    var oldCptOpt = oldOption[mainType];
	
	    if (!ComponentModel.hasClass(mainType)) {
	      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
	    } else {
	      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
	      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
	      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
	      oldOption[mainType] = map(mapResult, function (item) {
	        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
	      });
	    }
	  });
	}
	
	var _default = OptionManager;
	module.exports = _default;

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var platform = ''; // Navigator not exists in node
	
	if (typeof navigator !== 'undefined') {
	  platform = navigator.platform || '';
	}
	
	var _default = {
	  // backgroundColor: 'rgba(0,0,0,0)',
	  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
	  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
	  // Light colors:
	  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
	  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
	  // Dark colors:
	  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
	  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
	  // If xAxis and yAxis declared, grid is created by default.
	  // grid: {},
	  textStyle: {
	    // color: '#000',
	    // decoration: 'none',
	    // PENDING
	    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
	    // fontFamily: 'Arial, Verdana, sans-serif',
	    fontSize: 12,
	    fontStyle: 'normal',
	    fontWeight: 'normal'
	  },
	  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
	  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	  // Default is source-over
	  blendMode: null,
	  animation: 'auto',
	  animationDuration: 1000,
	  animationDurationUpdate: 300,
	  animationEasing: 'exponentialOut',
	  animationEasingUpdate: 'cubicOut',
	  animationThreshold: 2000,
	  // Configuration for progressive/incremental rendering
	  progressiveThreshold: 3000,
	  progressive: 400,
	  // Threshold of if use single hover layer to optimize.
	  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
	  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
	  // which is unexpected.
	  // see example <echarts/test/heatmap-large.html>.
	  hoverLayerThreshold: 3000,
	  // See: module:echarts/scale/Time
	  useUTC: false
	};
	module.exports = _default;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
	var _default = {
	  getAreaStyle: function (excludes, includes) {
	    return getAreaStyle(this, excludes, includes);
	  }
	};
	module.exports = _default;

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  getBoxLayoutParams: function () {
	    return {
	      left: this.get('left'),
	      top: this.get('top'),
	      right: this.get('right'),
	      bottom: this.get('bottom'),
	      width: this.get('width'),
	      height: this.get('height')
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
	var _default = {
	  getItemStyle: function (excludes, includes) {
	    var style = getItemStyle(this, excludes, includes);
	    var lineDash = this.getBorderLineDash();
	    lineDash && (style.lineDash = lineDash);
	    return style;
	  },
	  getBorderLineDash: function () {
	    var lineType = this.get('borderType');
	    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
	  }
	};
	module.exports = _default;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getLineStyle: function (excludes) {
	    var style = getLineStyle(this, excludes); // Always set lineDash whether dashed, otherwise we can not
	    // erase the previous style when assigning to el.style.
	
	    style.lineDash = this.getLineDash(style.lineWidth);
	    return style;
	  },
	  getLineDash: function (lineWidth) {
	    if (lineWidth == null) {
	      lineWidth = 1;
	    }
	
	    var lineType = this.get('type');
	    var dotSize = Math.max(lineWidth, 2);
	    var dashSize = lineWidth * 4;
	    return lineType === 'solid' || lineType == null ? // Use `false` but not `null` for the solid line here, because `null` might be
	    // ignored when assigning to `el.style`. e.g., when setting `lineStyle.type` as
	    // `'dashed'` and `emphasis.lineStyle.type` as `'solid'` in graph series, the
	    // `lineDash` gotten form the latter one is not able to erase that from the former
	    // one if using `null` here according to the emhpsis strategy in `util/graphic.js`.
	    false : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
	  }
	};
	module.exports = _default;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(86);
	
	var graphicUtil = __webpack_require__(17);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PATH_COLOR = ['textStyle', 'color'];
	var _default = {
	  /**
	   * Get color property or get color from option.textStyle.color
	   * @param {boolean} [isEmphasis]
	   * @return {string}
	   */
	  getTextColor: function (isEmphasis) {
	    var ecModel = this.ecModel;
	    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
	  },
	
	  /**
	   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
	   * @return {string}
	   */
	  getFont: function () {
	    return graphicUtil.getFont({
	      fontStyle: this.getShallow('fontStyle'),
	      fontWeight: this.getShallow('fontWeight'),
	      fontSize: this.getShallow('fontSize'),
	      fontFamily: this.getShallow('fontFamily')
	    }, this.ecModel);
	  },
	  getTextRect: function (text) {
	    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('lineHeight'), this.getShallow('rich'), this.getShallow('truncateText'));
	  }
	};
	module.exports = _default;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(33);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	var retrieve = _util.retrieve;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Helper for model references.
	 * There are many manners to refer axis/coordSys.
	 */
	// TODO
	// merge relevant logic to this file?
	// check: "modelHelper" of tooltip and "BrushTargetManager".
	
	/**
	 * @class
	 * For example:
	 * {
	 *     coordSysName: 'cartesian2d',
	 *     coordSysDims: ['x', 'y', ...],
	 *     axisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: yAxisModel
	 *     }),
	 *     categoryAxisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: undefined
	 *     }),
	 *     // The index of the first category axis in `coordSysDims`.
	 *     // `null/undefined` means no category axis exists.
	 *     firstCategoryDimIndex: 1,
	 *     // To replace user specified encode.
	 * }
	 */
	function CoordSysInfo(coordSysName) {
	  /**
	   * @type {string}
	   */
	  this.coordSysName = coordSysName;
	  /**
	   * @type {Array.<string>}
	   */
	
	  this.coordSysDims = [];
	  /**
	   * @type {module:zrender/core/util#HashMap}
	   */
	
	  this.axisMap = createHashMap();
	  /**
	   * @type {module:zrender/core/util#HashMap}
	   */
	
	  this.categoryAxisMap = createHashMap();
	  /**
	   * @type {number}
	   */
	
	  this.firstCategoryDimIndex = null;
	}
	/**
	 * @return {module:model/referHelper#CoordSysInfo}
	 */
	
	
	function getCoordSysInfoBySeries(seriesModel) {
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var result = new CoordSysInfo(coordSysName);
	  var fetch = fetchers[coordSysName];
	
	  if (fetch) {
	    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
	    return result;
	  }
	}
	
	var fetchers = {
	  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var xAxisModel = seriesModel.getReferringComponents('xAxis')[0];
	    var yAxisModel = seriesModel.getReferringComponents('yAxis')[0];
	    result.coordSysDims = ['x', 'y'];
	    axisMap.set('x', xAxisModel);
	    axisMap.set('y', yAxisModel);
	
	    if (isCategory(xAxisModel)) {
	      categoryAxisMap.set('x', xAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(yAxisModel)) {
	      categoryAxisMap.set('y', yAxisModel);
	      result.firstCategoryDimIndex == null & (result.firstCategoryDimIndex = 1);
	    }
	  },
	  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var singleAxisModel = seriesModel.getReferringComponents('singleAxis')[0];
	    result.coordSysDims = ['single'];
	    axisMap.set('single', singleAxisModel);
	
	    if (isCategory(singleAxisModel)) {
	      categoryAxisMap.set('single', singleAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	  },
	  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var polarModel = seriesModel.getReferringComponents('polar')[0];
	    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	    var angleAxisModel = polarModel.findAxisModel('angleAxis');
	    result.coordSysDims = ['radius', 'angle'];
	    axisMap.set('radius', radiusAxisModel);
	    axisMap.set('angle', angleAxisModel);
	
	    if (isCategory(radiusAxisModel)) {
	      categoryAxisMap.set('radius', radiusAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(angleAxisModel)) {
	      categoryAxisMap.set('angle', angleAxisModel);
	      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
	    }
	  },
	  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
	    result.coordSysDims = ['lng', 'lat'];
	  },
	  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var ecModel = seriesModel.ecModel;
	    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
	    each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	      var axisDim = coordSysDims[index];
	      axisMap.set(axisDim, axisModel);
	
	      if (isCategory(axisModel) && result.firstCategoryDimIndex == null) {
	        categoryAxisMap.set(axisDim, axisModel);
	        result.firstCategoryDimIndex = index;
	      }
	    });
	  }
	};
	
	function isCategory(axisModel) {
	  return axisModel.get('type') === 'category';
	}
	
	exports.getCoordSysInfoBySeries = getCoordSysInfoBySeries;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	var isArray = _util.isArray;
	var isObject = _util.isObject;
	
	var compatStyle = __webpack_require__(1861);
	
	var _model = __webpack_require__(27);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Compatitable with 2.0
	function get(opt, path) {
	  path = path.split(',');
	  var obj = opt;
	
	  for (var i = 0; i < path.length; i++) {
	    obj = obj && obj[path[i]];
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  return obj;
	}
	
	function set(opt, path, val, overwrite) {
	  path = path.split(',');
	  var obj = opt;
	  var key;
	
	  for (var i = 0; i < path.length - 1; i++) {
	    key = path[i];
	
	    if (obj[key] == null) {
	      obj[key] = {};
	    }
	
	    obj = obj[key];
	  }
	
	  if (overwrite || obj[path[i]] == null) {
	    obj[path[i]] = val;
	  }
	}
	
	function compatLayoutProperties(option) {
	  each(LAYOUT_PROPERTIES, function (prop) {
	    if (prop[0] in option && !(prop[1] in option)) {
	      option[prop[1]] = option[prop[0]];
	    }
	  });
	}
	
	var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
	var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
	
	function _default(option, isTheme) {
	  compatStyle(option, isTheme); // Make sure series array for model initialization.
	
	  option.series = normalizeToArray(option.series);
	  each(option.series, function (seriesOpt) {
	    if (!isObject(seriesOpt)) {
	      return;
	    }
	
	    var seriesType = seriesOpt.type;
	
	    if (seriesType === 'line') {
	      if (seriesOpt.clipOverflow != null) {
	        seriesOpt.clip = seriesOpt.clipOverflow;
	      }
	    } else if (seriesType === 'pie' || seriesType === 'gauge') {
	      if (seriesOpt.clockWise != null) {
	        seriesOpt.clockwise = seriesOpt.clockWise;
	      }
	    } else if (seriesType === 'gauge') {
	      var pointerColor = get(seriesOpt, 'pointer.color');
	      pointerColor != null && set(seriesOpt, 'itemStyle.color', pointerColor);
	    }
	
	    compatLayoutProperties(seriesOpt);
	  }); // dataRange has changed to visualMap
	
	  if (option.dataRange) {
	    option.visualMap = option.dataRange;
	  }
	
	  each(COMPATITABLE_COMPONENTS, function (componentName) {
	    var options = option[componentName];
	
	    if (options) {
	      if (!isArray(options)) {
	        options = [options];
	      }
	
	      each(options, function (option) {
	        compatLayoutProperties(option);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var modelUtil = __webpack_require__(27);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];
	
	function compatEC2ItemStyle(opt) {
	  var itemStyleOpt = opt && opt.itemStyle;
	
	  if (!itemStyleOpt) {
	    return;
	  }
	
	  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
	    var styleName = POSSIBLE_STYLES[i];
	    var normalItemStyleOpt = itemStyleOpt.normal;
	    var emphasisItemStyleOpt = itemStyleOpt.emphasis;
	
	    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].normal) {
	        opt[styleName].normal = normalItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
	      }
	
	      normalItemStyleOpt[styleName] = null;
	    }
	
	    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].emphasis) {
	        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
	      }
	
	      emphasisItemStyleOpt[styleName] = null;
	    }
	  }
	}
	
	function convertNormalEmphasis(opt, optType, useExtend) {
	  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
	    var normalOpt = opt[optType].normal;
	    var emphasisOpt = opt[optType].emphasis;
	
	    if (normalOpt) {
	      // Timeline controlStyle has other properties besides normal and emphasis
	      if (useExtend) {
	        opt[optType].normal = opt[optType].emphasis = null;
	        zrUtil.defaults(opt[optType], normalOpt);
	      } else {
	        opt[optType] = normalOpt;
	      }
	    }
	
	    if (emphasisOpt) {
	      opt.emphasis = opt.emphasis || {};
	      opt.emphasis[optType] = emphasisOpt;
	    }
	  }
	}
	
	function removeEC3NormalStatus(opt) {
	  convertNormalEmphasis(opt, 'itemStyle');
	  convertNormalEmphasis(opt, 'lineStyle');
	  convertNormalEmphasis(opt, 'areaStyle');
	  convertNormalEmphasis(opt, 'label');
	  convertNormalEmphasis(opt, 'labelLine'); // treemap
	
	  convertNormalEmphasis(opt, 'upperLabel'); // graph
	
	  convertNormalEmphasis(opt, 'edgeLabel');
	}
	
	function compatTextStyle(opt, propName) {
	  // Check whether is not object (string\null\undefined ...)
	  var labelOptSingle = isObject(opt) && opt[propName];
	  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;
	
	  if (textStyle) {
	    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
	      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];
	
	      if (textStyle.hasOwnProperty(propName)) {
	        labelOptSingle[propName] = textStyle[propName];
	      }
	    }
	  }
	}
	
	function compatEC3CommonStyles(opt) {
	  if (opt) {
	    removeEC3NormalStatus(opt);
	    compatTextStyle(opt, 'label');
	    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
	  }
	}
	
	function processSeries(seriesOpt) {
	  if (!isObject(seriesOpt)) {
	    return;
	  }
	
	  compatEC2ItemStyle(seriesOpt);
	  removeEC3NormalStatus(seriesOpt);
	  compatTextStyle(seriesOpt, 'label'); // treemap
	
	  compatTextStyle(seriesOpt, 'upperLabel'); // graph
	
	  compatTextStyle(seriesOpt, 'edgeLabel');
	
	  if (seriesOpt.emphasis) {
	    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
	
	    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
	
	    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
	  }
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint) {
	    compatEC2ItemStyle(markPoint);
	    compatEC3CommonStyles(markPoint);
	  }
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine) {
	    compatEC2ItemStyle(markLine);
	    compatEC3CommonStyles(markLine);
	  }
	
	  var markArea = seriesOpt.markArea;
	
	  if (markArea) {
	    compatEC3CommonStyles(markArea);
	  }
	
	  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
	  // then the backward compat based on option type will not be performed.
	
	  if (seriesOpt.type === 'graph') {
	    data = data || seriesOpt.nodes;
	    var edgeData = seriesOpt.links || seriesOpt.edges;
	
	    if (edgeData && !zrUtil.isTypedArray(edgeData)) {
	      for (var i = 0; i < edgeData.length; i++) {
	        compatEC3CommonStyles(edgeData[i]);
	      }
	    }
	
	    zrUtil.each(seriesOpt.categories, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  }
	
	  if (data && !zrUtil.isTypedArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      compatEC3CommonStyles(data[i]);
	    }
	  } // mark point data
	
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint && markPoint.data) {
	    var mpData = markPoint.data;
	
	    for (var i = 0; i < mpData.length; i++) {
	      compatEC3CommonStyles(mpData[i]);
	    }
	  } // mark line data
	
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine && markLine.data) {
	    var mlData = markLine.data;
	
	    for (var i = 0; i < mlData.length; i++) {
	      if (zrUtil.isArray(mlData[i])) {
	        compatEC3CommonStyles(mlData[i][0]);
	        compatEC3CommonStyles(mlData[i][1]);
	      } else {
	        compatEC3CommonStyles(mlData[i]);
	      }
	    }
	  } // Series
	
	
	  if (seriesOpt.type === 'gauge') {
	    compatTextStyle(seriesOpt, 'axisLabel');
	    compatTextStyle(seriesOpt, 'title');
	    compatTextStyle(seriesOpt, 'detail');
	  } else if (seriesOpt.type === 'treemap') {
	    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
	    zrUtil.each(seriesOpt.levels, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  } else if (seriesOpt.type === 'tree') {
	    removeEC3NormalStatus(seriesOpt.leaves);
	  } // sunburst starts from ec4, so it does not need to compat levels.
	
	}
	
	function toArr(o) {
	  return zrUtil.isArray(o) ? o : o ? [o] : [];
	}
	
	function toObj(o) {
	  return (zrUtil.isArray(o) ? o[0] : o) || {};
	}
	
	function _default(option, isTheme) {
	  each(toArr(option.series), function (seriesOpt) {
	    isObject(seriesOpt) && processSeries(seriesOpt);
	  });
	  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
	  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
	  each(axes, function (axisName) {
	    each(toArr(option[axisName]), function (axisOpt) {
	      if (axisOpt) {
	        compatTextStyle(axisOpt, 'axisLabel');
	        compatTextStyle(axisOpt.axisPointer, 'label');
	      }
	    });
	  });
	  each(toArr(option.parallel), function (parallelOpt) {
	    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
	    compatTextStyle(parallelAxisDefault, 'axisLabel');
	    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
	  });
	  each(toArr(option.calendar), function (calendarOpt) {
	    convertNormalEmphasis(calendarOpt, 'itemStyle');
	    compatTextStyle(calendarOpt, 'dayLabel');
	    compatTextStyle(calendarOpt, 'monthLabel');
	    compatTextStyle(calendarOpt, 'yearLabel');
	  }); // radar.name.textStyle
	
	  each(toArr(option.radar), function (radarOpt) {
	    compatTextStyle(radarOpt, 'name');
	  });
	  each(toArr(option.geo), function (geoOpt) {
	    if (isObject(geoOpt)) {
	      compatEC3CommonStyles(geoOpt);
	      each(toArr(geoOpt.regions), function (regionObj) {
	        compatEC3CommonStyles(regionObj);
	      });
	    }
	  });
	  each(toArr(option.timeline), function (timelineOpt) {
	    compatEC3CommonStyles(timelineOpt);
	    convertNormalEmphasis(timelineOpt, 'label');
	    convertNormalEmphasis(timelineOpt, 'itemStyle');
	    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
	    var data = timelineOpt.data;
	    zrUtil.isArray(data) && zrUtil.each(data, function (item) {
	      if (zrUtil.isObject(item)) {
	        convertNormalEmphasis(item, 'label');
	        convertNormalEmphasis(item, 'itemStyle');
	      }
	    });
	  });
	  each(toArr(option.toolbox), function (toolboxOpt) {
	    convertNormalEmphasis(toolboxOpt, 'iconStyle');
	    each(toolboxOpt.feature, function (featureOpt) {
	      convertNormalEmphasis(featureOpt, 'iconStyle');
	    });
	  });
	  compatTextStyle(toObj(option.axisPointer), 'label');
	  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
	}
	
	module.exports = _default;

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var samplers = {
	  average: function (frame) {
	    var sum = 0;
	    var count = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      if (!isNaN(frame[i])) {
	        sum += frame[i];
	        count++;
	      }
	    } // Return NaN if count is 0
	
	
	    return count === 0 ? NaN : sum / count;
	  },
	  sum: function (frame) {
	    var sum = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      // Ignore NaN
	      sum += frame[i] || 0;
	    }
	
	    return sum;
	  },
	  max: function (frame) {
	    var max = -Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] > max && (max = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(max) ? max : NaN;
	  },
	  min: function (frame) {
	    var min = Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] < min && (min = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(min) ? min : NaN;
	  },
	  // TODO
	  // Median
	  nearest: function (frame) {
	    return frame[0];
	  }
	};
	
	var indexSampler = function (frame, value) {
	  return Math.round(frame.length / 2);
	};
	
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    modifyOutputEnd: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var sampling = seriesModel.get('sampling');
	      var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling
	
	      if (coordSys.type === 'cartesian2d' && sampling) {
	        var baseAxis = coordSys.getBaseAxis();
	        var valueAxis = coordSys.getOtherAxis(baseAxis);
	        var extent = baseAxis.getExtent(); // Coordinste system has been resized
	
	        var size = Math.abs(extent[1] - extent[0]);
	        var rate = Math.round(data.count() / size);
	
	        if (rate > 1) {
	          var sampler;
	
	          if (typeof sampling === 'string') {
	            sampler = samplers[sampling];
	          } else if (typeof sampling === 'function') {
	            sampler = sampling;
	          }
	
	          if (sampler) {
	            // Only support sample the first dim mapped from value axis.
	            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
	          }
	        }
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) [Caution]: the logic is correct based on the premises:
	//     data processing stage is blocked in stream.
	//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
	// (2) Only register once when import repeatly.
	//     Should be executed after series filtered and before stack calculation.
	function _default(ecModel) {
	  var stackInfoMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
	
	    if (stack) {
	      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
	      var data = seriesModel.getData();
	      var stackInfo = {
	        // Used for calculate axis extent automatically.
	        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
	        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
	        stackedDimension: data.getCalculationInfo('stackedDimension'),
	        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
	        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
	        data: data,
	        seriesModel: seriesModel
	      }; // If stacked on axis that do not support data stack.
	
	      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
	        return;
	      }
	
	      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
	      stackInfoList.push(stackInfo);
	    }
	  });
	  stackInfoMap.each(calculateStack);
	}
	
	function calculateStack(stackInfoList) {
	  each(stackInfoList, function (targetStackInfo, idxInStack) {
	    var resultVal = [];
	    var resultNaN = [NaN, NaN];
	    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
	    var targetData = targetStackInfo.data;
	    var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
	    // depending on legend selection.
	
	    var newData = targetData.map(dims, function (v0, v1, dataIndex) {
	      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
	      // should also be NaN, to draw a appropriate belt area.
	
	      if (isNaN(sum)) {
	        return resultNaN;
	      }
	
	      var byValue;
	      var stackedDataRawIndex;
	
	      if (isStackedByIndex) {
	        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
	      } else {
	        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
	      } // If stackOver is NaN, chart view will render point on value start.
	
	
	      var stackedOver = NaN;
	
	      for (var j = idxInStack - 1; j >= 0; j--) {
	        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
	
	        if (!isStackedByIndex) {
	          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
	        }
	
	        if (stackedDataRawIndex >= 0) {
	          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
	
	          if (sum >= 0 && val > 0 || // Positive stack
	          sum <= 0 && val < 0 // Negative stack
	          ) {
	              sum += val;
	              stackedOver = val;
	              break;
	            }
	        }
	      }
	
	      resultVal[0] = sum;
	      resultVal[1] = stackedOver;
	      return resultVal;
	    });
	    targetData.hostModel.setData(newData); // Update for consequent calculation
	
	    targetStackInfo.data = newData;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var Scale = __webpack_require__(274);
	
	var OrdinalMeta = __webpack_require__(849);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Linear continuous scale
	 * @module echarts/coord/scale/Ordinal
	 *
	 * http://en.wikipedia.org/wiki/Level_of_measurement
	 */
	// FIXME only one data
	var scaleProto = Scale.prototype;
	var OrdinalScale = Scale.extend({
	  type: 'ordinal',
	
	  /**
	   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
	   */
	  init: function (ordinalMeta, extent) {
	    // Caution: Should not use instanceof, consider ec-extensions using
	    // import approach to get OrdinalMeta class.
	    if (!ordinalMeta || zrUtil.isArray(ordinalMeta)) {
	      ordinalMeta = new OrdinalMeta({
	        categories: ordinalMeta
	      });
	    }
	
	    this._ordinalMeta = ordinalMeta;
	    this._extent = extent || [0, ordinalMeta.categories.length - 1];
	  },
	  parse: function (val) {
	    return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
	    : Math.round(val);
	  },
	  contain: function (rank) {
	    rank = this.parse(rank);
	    return scaleProto.contain.call(this, rank) && this._ordinalMeta.categories[rank] != null;
	  },
	
	  /**
	   * Normalize given rank or name to linear [0, 1]
	   * @param {number|string} [val]
	   * @return {number}
	   */
	  normalize: function (val) {
	    return scaleProto.normalize.call(this, this.parse(val));
	  },
	  scale: function (val) {
	    return Math.round(scaleProto.scale.call(this, val));
	  },
	
	  /**
	   * @return {Array}
	   */
	  getTicks: function () {
	    var ticks = [];
	    var extent = this._extent;
	    var rank = extent[0];
	
	    while (rank <= extent[1]) {
	      ticks.push(rank);
	      rank++;
	    }
	
	    return ticks;
	  },
	
	  /**
	   * Get item on rank n
	   * @param {number} n
	   * @return {string}
	   */
	  getLabel: function (n) {
	    if (!this.isBlank()) {
	      // Note that if no data, ordinalMeta.categories is an empty array.
	      return this._ordinalMeta.categories[n];
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  count: function () {
	    return this._extent[1] - this._extent[0] + 1;
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	  getOrdinalMeta: function () {
	    return this._ordinalMeta;
	  },
	  niceTicks: zrUtil.noop,
	  niceExtent: zrUtil.noop
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	OrdinalScale.create = function () {
	  return new OrdinalScale();
	};
	
	var _default = OrdinalScale;
	module.exports = _default;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var numberUtil = __webpack_require__(24);
	
	var formatUtil = __webpack_require__(48);
	
	var scaleHelper = __webpack_require__(856);
	
	var IntervalScale = __webpack_require__(273);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The "scaleLevels" was originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment on the definition of "scaleLevels" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	// [About UTC and local time zone]:
	// In most cases, `number.parseDate` will treat input data string as local time
	// (except time zone is specified in time string). And `format.formateTime` returns
	// local time by default. option.useUTC is false by default. This design have
	// concidered these common case:
	// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
	// in local time by default.
	// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
	// as its original time, without any time difference.
	var intervalScaleProto = IntervalScale.prototype;
	var mathCeil = Math.ceil;
	var mathFloor = Math.floor;
	var ONE_SECOND = 1000;
	var ONE_MINUTE = ONE_SECOND * 60;
	var ONE_HOUR = ONE_MINUTE * 60;
	var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？
	
	var bisect = function (a, x, lo, hi) {
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	
	    if (a[mid][1] < x) {
	      lo = mid + 1;
	    } else {
	      hi = mid;
	    }
	  }
	
	  return lo;
	};
	/**
	 * @alias module:echarts/coord/scale/Time
	 * @constructor
	 */
	
	
	var TimeScale = IntervalScale.extend({
	  type: 'time',
	
	  /**
	   * @override
	   */
	  getLabel: function (val) {
	    var stepLvl = this._stepLvl;
	    var date = new Date(val);
	    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
	  },
	
	  /**
	   * @override
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      // Expand extent
	      extent[0] -= ONE_DAY;
	      extent[1] += ONE_DAY;
	    } // If there are no data and extent are [Infinity, -Infinity]
	
	
	    if (extent[1] === -Infinity && extent[0] === Infinity) {
	      var d = new Date();
	      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
	      extent[0] = extent[1] - ONE_DAY;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
	    }
	  },
	
	  /**
	   * @override
	   */
	  niceTicks: function (approxTickNum, minInterval, maxInterval) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	    var approxInterval = span / approxTickNum;
	
	    if (minInterval != null && approxInterval < minInterval) {
	      approxInterval = minInterval;
	    }
	
	    if (maxInterval != null && approxInterval > maxInterval) {
	      approxInterval = maxInterval;
	    }
	
	    var scaleLevelsLen = scaleLevels.length;
	    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
	    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
	    var interval = level[1]; // Same with interval scale if span is much larger than 1 year
	
	    if (level[0] === 'year') {
	      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
	      // var niceYearSpan = numberUtil.nice(yearSpan, false);
	
	      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
	      interval *= yearStep;
	    }
	
	    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
	    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
	    scaleHelper.fixExtent(niceExtent, extent);
	    this._stepLvl = level; // Interval will be used in getTicks
	
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	  parse: function (val) {
	    // val might be float.
	    return +numberUtil.parseDate(val);
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  TimeScale.prototype[methodName] = function (val) {
	    return intervalScaleProto[methodName].call(this, this.parse(val));
	  };
	});
	/**
	 * This implementation was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	var scaleLevels = [// Format              interval
	['hh:mm:ss', ONE_SECOND], // 1s
	['hh:mm:ss', ONE_SECOND * 5], // 5s
	['hh:mm:ss', ONE_SECOND * 10], // 10s
	['hh:mm:ss', ONE_SECOND * 15], // 15s
	['hh:mm:ss', ONE_SECOND * 30], // 30s
	['hh:mm\nMM-dd', ONE_MINUTE], // 1m
	['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
	['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
	['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
	['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
	['hh:mm\nMM-dd', ONE_HOUR], // 1h
	['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
	['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
	['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
	['MM-dd\nyyyy', ONE_DAY], // 1d
	['MM-dd\nyyyy', ONE_DAY * 2], // 2d
	['MM-dd\nyyyy', ONE_DAY * 3], // 3d
	['MM-dd\nyyyy', ONE_DAY * 4], // 4d
	['MM-dd\nyyyy', ONE_DAY * 5], // 5d
	['MM-dd\nyyyy', ONE_DAY * 6], // 6d
	['week', ONE_DAY * 7], // 7d
	['MM-dd\nyyyy', ONE_DAY * 10], // 10d
	['week', ONE_DAY * 14], // 2w
	['week', ONE_DAY * 21], // 3w
	['month', ONE_DAY * 31], // 1M
	['week', ONE_DAY * 42], // 6w
	['month', ONE_DAY * 62], // 2M
	['week', ONE_DAY * 70], // 10w
	['quarter', ONE_DAY * 95], // 3M
	['month', ONE_DAY * 31 * 4], // 4M
	['month', ONE_DAY * 31 * 5], // 5M
	['half-year', ONE_DAY * 380 / 2], // 6M
	['month', ONE_DAY * 31 * 8], // 8M
	['month', ONE_DAY * 31 * 10], // 10M
	['year', ONE_DAY * 380] // 1Y
	];
	/**
	 * @param {module:echarts/model/Model}
	 * @return {module:echarts/scale/Time}
	 */
	
	TimeScale.create = function (model) {
	  return new TimeScale({
	    useUTC: model.ecModel.get('useUTC')
	  });
	};
	
	var _default = TimeScale;
	module.exports = _default;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	var map = _util.map;
	var isFunction = _util.isFunction;
	var createHashMap = _util.createHashMap;
	var noop = _util.noop;
	
	var _task = __webpack_require__(433);
	
	var createTask = _task.createTask;
	
	var _component = __webpack_require__(224);
	
	var getUID = _component.getUID;
	
	var GlobalModel = __webpack_require__(853);
	
	var ExtensionAPI = __webpack_require__(797);
	
	var _model = __webpack_require__(27);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/stream/Scheduler
	 */
	
	/**
	 * @constructor
	 */
	function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
	  this.ecInstance = ecInstance;
	  this.api = api;
	  this.unfinished; // Fix current processors in case that in some rear cases that
	  // processors might be registered after echarts instance created.
	  // Register processors incrementally for a echarts instance is
	  // not supported by this stream architecture.
	
	  var dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
	  var visualHandlers = this._visualHandlers = visualHandlers.slice();
	  this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
	  /**
	   * @private
	   * @type {
	   *     [handlerUID: string]: {
	   *         seriesTaskMap?: {
	   *             [seriesUID: string]: Task
	   *         },
	   *         overallTask?: Task
	   *     }
	   * }
	   */
	
	  this._stageTaskMap = createHashMap();
	}
	
	var proto = Scheduler.prototype;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} payload
	 */
	
	proto.restoreData = function (ecModel, payload) {
	  // TODO: Only restore needed series and components, but not all components.
	  // Currently `restoreData` of all of the series and component will be called.
	  // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
	  // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
	  // and some components like coordinate system, axes, dataZoom, visualMap only
	  // need their target series refresh.
	  // (1) If we are implementing this feature some day, we should consider these cases:
	  // if a data processor depends on a component (e.g., dataZoomProcessor depends
	  // on the settings of `dataZoom`), it should be re-performed if the component
	  // is modified by `setOption`.
	  // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
	  // it should be re-performed when the result array of `getTargetSeries` changed.
	  // We use `dependencies` to cover these issues.
	  // (3) How to update target series when coordinate system related components modified.
	  // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
	  // and this case all of the tasks will be set as dirty.
	  ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
	  // depends on all of the series.
	  // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
	  // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
	  // that the overall task is set as dirty and to be performed, otherwise it probably cause
	  // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
	  // probably cause state chaos (consider `dataZoomProcessor`).
	
	  this._stageTaskMap.each(function (taskRecord) {
	    var overallTask = taskRecord.overallTask;
	    overallTask && overallTask.dirty();
	  });
	}; // If seriesModel provided, incremental threshold is check by series data.
	
	
	proto.getPerformArgs = function (task, isBlock) {
	  // For overall task
	  if (!task.__pipeline) {
	    return;
	  }
	
	  var pipeline = this._pipelineMap.get(task.__pipeline.id);
	
	  var pCtx = pipeline.context;
	  var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
	  var step = incremental ? pipeline.step : null;
	  var modDataCount = pCtx && pCtx.modDataCount;
	  var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
	  return {
	    step: step,
	    modBy: modBy,
	    modDataCount: modDataCount
	  };
	};
	
	proto.getPipeline = function (pipelineId) {
	  return this._pipelineMap.get(pipelineId);
	};
	/**
	 * Current, progressive rendering starts from visual and layout.
	 * Always detect render mode in the same stage, avoiding that incorrect
	 * detection caused by data filtering.
	 * Caution:
	 * `updateStreamModes` use `seriesModel.getData()`.
	 */
	
	
	proto.updateStreamModes = function (seriesModel, view) {
	  var pipeline = this._pipelineMap.get(seriesModel.uid);
	
	  var data = seriesModel.getData();
	  var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
	  // animation frame. Note that some types of series do not provide
	  // `view.incrementalPrepareRender` but support `chart.appendData`. We
	  // use the term `incremental` but not `progressive` to describe the
	  // case that `chart.appendData`.
	
	  var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
	  var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
	  // see `test/candlestick-large3.html`
	
	  var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
	  seriesModel.pipelineContext = pipeline.context = {
	    progressiveRender: progressiveRender,
	    modDataCount: modDataCount,
	    large: large
	  };
	};
	
	proto.restorePipelines = function (ecModel) {
	  var scheduler = this;
	  var pipelineMap = scheduler._pipelineMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var progressive = seriesModel.getProgressive();
	    var pipelineId = seriesModel.uid;
	    pipelineMap.set(pipelineId, {
	      id: pipelineId,
	      head: null,
	      tail: null,
	      threshold: seriesModel.getProgressiveThreshold(),
	      progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
	      blockIndex: -1,
	      step: Math.round(progressive || 700),
	      count: 0
	    });
	    pipe(scheduler, seriesModel, seriesModel.dataTask);
	  });
	};
	
	proto.prepareStageTasks = function () {
	  var stageTaskMap = this._stageTaskMap;
	  var ecModel = this.ecInstance.getModel();
	  var api = this.api;
	  each(this._allHandlers, function (handler) {
	    var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, []);
	    handler.reset && createSeriesStageTask(this, handler, record, ecModel, api);
	    handler.overallReset && createOverallStageTask(this, handler, record, ecModel, api);
	  }, this);
	};
	
	proto.prepareView = function (view, model, ecModel, api) {
	  var renderTask = view.renderTask;
	  var context = renderTask.context;
	  context.model = model;
	  context.ecModel = ecModel;
	  context.api = api;
	  renderTask.__block = !view.incrementalPrepareRender;
	  pipe(this, model, renderTask);
	};
	
	proto.performDataProcessorTasks = function (ecModel, payload) {
	  // If we do not use `block` here, it should be considered when to update modes.
	  performStageTasks(this, this._dataProcessorHandlers, ecModel, payload, {
	    block: true
	  });
	}; // opt
	// opt.visualType: 'visual' or 'layout'
	// opt.setDirty
	
	
	proto.performVisualTasks = function (ecModel, payload, opt) {
	  performStageTasks(this, this._visualHandlers, ecModel, payload, opt);
	};
	
	function performStageTasks(scheduler, stageHandlers, ecModel, payload, opt) {
	  opt = opt || {};
	  var unfinished;
	  each(stageHandlers, function (stageHandler, idx) {
	    if (opt.visualType && opt.visualType !== stageHandler.visualType) {
	      return;
	    }
	
	    var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
	
	    var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
	    var overallTask = stageHandlerRecord.overallTask;
	
	    if (overallTask) {
	      var overallNeedDirty;
	      var agentStubMap = overallTask.agentStubMap;
	      agentStubMap.each(function (stub) {
	        if (needSetDirty(opt, stub)) {
	          stub.dirty();
	          overallNeedDirty = true;
	        }
	      });
	      overallNeedDirty && overallTask.dirty();
	      updatePayload(overallTask, payload);
	      var performArgs = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
	      // then execute the overall task. And stub will call seriesModel.setData,
	      // which ensures that in the overallTask seriesModel.getData() will not
	      // return incorrect data.
	
	      agentStubMap.each(function (stub) {
	        stub.perform(performArgs);
	      });
	      unfinished |= overallTask.perform(performArgs);
	    } else if (seriesTaskMap) {
	      seriesTaskMap.each(function (task, pipelineId) {
	        if (needSetDirty(opt, task)) {
	          task.dirty();
	        }
	
	        var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
	        // if intending to decalare `performRawSeries` in handlers, only
	        // stream-independent (specifically, data item independent) operations can be
	        // performed. Because is a series is filtered, most of the tasks will not
	        // be performed. A stream-dependent operation probably cause wrong biz logic.
	        // Perhaps we should not provide a separate callback for this case instead
	        // of providing the config `performRawSeries`. The stream-dependent operaions
	        // and stream-independent operations should better not be mixed.
	
	        performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
	        updatePayload(task, payload);
	        unfinished |= task.perform(performArgs);
	      });
	    }
	  });
	
	  function needSetDirty(opt, task) {
	    return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
	  }
	
	  scheduler.unfinished |= unfinished;
	}
	
	proto.performSeriesTasks = function (ecModel) {
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    // Progress to the end for dataInit and dataRestore.
	    unfinished |= seriesModel.dataTask.perform();
	  });
	  this.unfinished |= unfinished;
	};
	
	proto.plan = function () {
	  // Travel pipelines, check block.
	  this._pipelineMap.each(function (pipeline) {
	    var task = pipeline.tail;
	
	    do {
	      if (task.__block) {
	        pipeline.blockIndex = task.__idxInPipeline;
	        break;
	      }
	
	      task = task.getUpstream();
	    } while (task);
	  });
	};
	
	var updatePayload = proto.updatePayload = function (task, payload) {
	  payload !== 'remain' && (task.context.payload = payload);
	};
	
	function createSeriesStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var seriesTaskMap = stageHandlerRecord.seriesTaskMap || (stageHandlerRecord.seriesTaskMap = createHashMap());
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
	  // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
	  // it works but it may cause other irrelevant charts blocked.
	
	  if (stageHandler.createOnAllSeries) {
	    ecModel.eachRawSeries(create);
	  } else if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, create);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(create);
	  }
	
	  function create(seriesModel) {
	    var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
	    // Reuse original task instance.
	
	    var task = seriesTaskMap.get(pipelineId) || seriesTaskMap.set(pipelineId, createTask({
	      plan: seriesTaskPlan,
	      reset: seriesTaskReset,
	      count: seriesTaskCount
	    }));
	    task.context = {
	      model: seriesModel,
	      ecModel: ecModel,
	      api: api,
	      useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
	      plan: stageHandler.plan,
	      reset: stageHandler.reset,
	      scheduler: scheduler
	    };
	    pipe(scheduler, seriesModel, task);
	  } // Clear unused series tasks.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  seriesTaskMap.each(function (task, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      task.dispose();
	      seriesTaskMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function createOverallStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
	  || createTask({
	    reset: overallTaskReset
	  });
	  overallTask.context = {
	    ecModel: ecModel,
	    api: api,
	    overallReset: stageHandler.overallReset,
	    scheduler: scheduler
	  }; // Reuse orignal stubs.
	
	  var agentStubMap = overallTask.agentStubMap = overallTask.agentStubMap || createHashMap();
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries;
	  var overallProgress = true;
	  var modifyOutputEnd = stageHandler.modifyOutputEnd; // An overall task with seriesType detected or has `getTargetSeries`, we add
	  // stub in each pipelines, it will set the overall task dirty when the pipeline
	  // progress. Moreover, to avoid call the overall task each frame (too frequent),
	  // we set the pipeline block.
	
	  if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, createStub);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(createStub);
	  } // Otherwise, (usually it is legancy case), the overall task will only be
	  // executed when upstream dirty. Otherwise the progressive rendering of all
	  // pipelines will be disabled unexpectedly. But it still needs stubs to receive
	  // dirty info from upsteam.
	  else {
	      overallProgress = false;
	      each(ecModel.getSeries(), createStub);
	    }
	
	  function createStub(seriesModel) {
	    var pipelineId = seriesModel.uid;
	    var stub = agentStubMap.get(pipelineId);
	
	    if (!stub) {
	      stub = agentStubMap.set(pipelineId, createTask({
	        reset: stubReset,
	        onDirty: stubOnDirty
	      })); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	    }
	
	    stub.context = {
	      model: seriesModel,
	      overallProgress: overallProgress,
	      modifyOutputEnd: modifyOutputEnd
	    };
	    stub.agent = overallTask;
	    stub.__block = overallProgress;
	    pipe(scheduler, seriesModel, stub);
	  } // Clear unused stubs.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  agentStubMap.each(function (stub, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      stub.dispose(); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	      agentStubMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function overallTaskReset(context) {
	  context.overallReset(context.ecModel, context.api, context.payload);
	}
	
	function stubReset(context, upstreamContext) {
	  return context.overallProgress && stubProgress;
	}
	
	function stubProgress() {
	  this.agent.dirty();
	  this.getDownstream().dirty();
	}
	
	function stubOnDirty() {
	  this.agent && this.agent.dirty();
	}
	
	function seriesTaskPlan(context) {
	  return context.plan && context.plan(context.model, context.ecModel, context.api, context.payload);
	}
	
	function seriesTaskReset(context) {
	  if (context.useClearVisual) {
	    context.data.clearAllVisual();
	  }
	
	  var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
	  return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
	    return makeSeriesTaskProgress(idx);
	  }) : singleSeriesTaskProgress;
	}
	
	var singleSeriesTaskProgress = makeSeriesTaskProgress(0);
	
	function makeSeriesTaskProgress(resetDefineIdx) {
	  return function (params, context) {
	    var data = context.data;
	    var resetDefine = context.resetDefines[resetDefineIdx];
	
	    if (resetDefine && resetDefine.dataEach) {
	      for (var i = params.start; i < params.end; i++) {
	        resetDefine.dataEach(data, i);
	      }
	    } else if (resetDefine && resetDefine.progress) {
	      resetDefine.progress(params, data);
	    }
	  };
	}
	
	function seriesTaskCount(context) {
	  return context.data.count();
	}
	
	function pipe(scheduler, seriesModel, task) {
	  var pipelineId = seriesModel.uid;
	
	  var pipeline = scheduler._pipelineMap.get(pipelineId);
	
	  !pipeline.head && (pipeline.head = task);
	  pipeline.tail && pipeline.tail.pipe(task);
	  pipeline.tail = task;
	  task.__idxInPipeline = pipeline.count++;
	  task.__pipeline = pipeline;
	}
	
	Scheduler.wrapStageHandler = function (stageHandler, visualType) {
	  if (isFunction(stageHandler)) {
	    stageHandler = {
	      overallReset: stageHandler,
	      seriesType: detectSeriseType(stageHandler)
	    };
	  }
	
	  stageHandler.uid = getUID('stageHandler');
	  visualType && (stageHandler.visualType = visualType);
	  return stageHandler;
	};
	/**
	 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
	 * To ensure that they can work normally, they should work in block mode, that is,
	 * they should not be started util the previous tasks finished. So they cause the
	 * progressive rendering disabled. We try to detect the series type, to narrow down
	 * the block range to only the series type they concern, but not all series.
	 */
	
	
	function detectSeriseType(legacyFunc) {
	  seriesType = null;
	
	  try {
	    // Assume there is no async when calling `eachSeriesByType`.
	    legacyFunc(ecModelMock, apiMock);
	  } catch (e) {}
	
	  return seriesType;
	}
	
	var ecModelMock = {};
	var apiMock = {};
	var seriesType;
	mockMethods(ecModelMock, GlobalModel);
	mockMethods(apiMock, ExtensionAPI);
	
	ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
	  seriesType = type;
	};
	
	ecModelMock.eachComponent = function (cond) {
	  if (cond.mainType === 'series' && cond.subType) {
	    seriesType = cond.subType;
	  }
	};
	
	function mockMethods(target, Clz) {
	  /* eslint-disable */
	  for (var name in Clz.prototype) {
	    // Do not use hasOwnProperty
	    target[name] = noop;
	  }
	  /* eslint-enable */
	
	}
	
	var _default = Scheduler;
	module.exports = _default;

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var contrastColor = '#eee';
	
	var axisCommon = function () {
	  return {
	    axisLine: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisTick: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisLabel: {
	      textStyle: {
	        color: contrastColor
	      }
	    },
	    splitLine: {
	      lineStyle: {
	        type: 'dashed',
	        color: '#aaa'
	      }
	    },
	    splitArea: {
	      areaStyle: {
	        color: contrastColor
	      }
	    }
	  };
	};
	
	var colorPalette = ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc', '#7289ab', '#91ca8c', '#f49f42'];
	var theme = {
	  color: colorPalette,
	  backgroundColor: '#333',
	  tooltip: {
	    axisPointer: {
	      lineStyle: {
	        color: contrastColor
	      },
	      crossStyle: {
	        color: contrastColor
	      },
	      label: {
	        color: '#000'
	      }
	    }
	  },
	  legend: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  textStyle: {
	    color: contrastColor
	  },
	  title: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  toolbox: {
	    iconStyle: {
	      normal: {
	        borderColor: contrastColor
	      }
	    }
	  },
	  dataZoom: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  visualMap: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  timeline: {
	    lineStyle: {
	      color: contrastColor
	    },
	    itemStyle: {
	      normal: {
	        color: colorPalette[1]
	      }
	    },
	    label: {
	      normal: {
	        textStyle: {
	          color: contrastColor
	        }
	      }
	    },
	    controlStyle: {
	      normal: {
	        color: contrastColor,
	        borderColor: contrastColor
	      }
	    }
	  },
	  timeAxis: axisCommon(),
	  logAxis: axisCommon(),
	  valueAxis: axisCommon(),
	  categoryAxis: axisCommon(),
	  line: {
	    symbol: 'circle'
	  },
	  graph: {
	    color: colorPalette
	  },
	  gauge: {
	    title: {
	      textStyle: {
	        color: contrastColor
	      }
	    }
	  },
	  candlestick: {
	    itemStyle: {
	      normal: {
	        color: '#FD1050',
	        color0: '#0CF49B',
	        borderColor: '#FD1050',
	        borderColor0: '#0CF49B'
	      }
	    }
	  }
	};
	theme.categoryAxis.splitLine.show = false;
	var _default = theme;
	module.exports = _default;

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
	var _default = {
	  color: colorAll,
	  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
	};
	module.exports = _default;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {number} [time=500] Time in ms
	 * @param {string} [easing='linear']
	 * @param {number} [delay=0]
	 * @param {Function} [callback]
	 *
	 * @example
	 *  // Animate position
	 *  animation
	 *      .createWrap()
	 *      .add(el1, {position: [10, 10]})
	 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
	 *      .done(function () { // done })
	 *      .start('cubicOut');
	 */
	function createWrap() {
	  var storage = [];
	  var elExistsMap = {};
	  var doneCallback;
	  return {
	    /**
	     * Caution: a el can only be added once, otherwise 'done'
	     * might not be called. This method checks this (by el.id),
	     * suppresses adding and returns false when existing el found.
	     *
	     * @param {modele:zrender/Element} el
	     * @param {Object} target
	     * @param {number} [time=500]
	     * @param {number} [delay=0]
	     * @param {string} [easing='linear']
	     * @return {boolean} Whether adding succeeded.
	     *
	     * @example
	     *     add(el, target, time, delay, easing);
	     *     add(el, target, time, easing);
	     *     add(el, target, time);
	     *     add(el, target);
	     */
	    add: function (el, target, time, delay, easing) {
	      if (zrUtil.isString(delay)) {
	        easing = delay;
	        delay = 0;
	      }
	
	      if (elExistsMap[el.id]) {
	        return false;
	      }
	
	      elExistsMap[el.id] = 1;
	      storage.push({
	        el: el,
	        target: target,
	        time: time,
	        delay: delay,
	        easing: easing
	      });
	      return true;
	    },
	
	    /**
	     * Only execute when animation finished. Will not execute when any
	     * of 'stop' or 'stopAnimation' called.
	     *
	     * @param {Function} callback
	     */
	    done: function (callback) {
	      doneCallback = callback;
	      return this;
	    },
	
	    /**
	     * Will stop exist animation firstly.
	     */
	    start: function () {
	      var count = storage.length;
	
	      for (var i = 0, len = storage.length; i < len; i++) {
	        var item = storage[i];
	        item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
	      }
	
	      return this;
	
	      function done() {
	        count--;
	
	        if (!count) {
	          storage.length = 0;
	          elExistsMap = {};
	          doneCallback && doneCallback();
	        }
	      }
	    }
	  };
	}
	
	exports.createWrap = createWrap;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(17);
	
	var extendShape = _graphic.extendShape;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Sausage: similar to sector, but have half circle on both sides
	 * @public
	 */
	var _default = extendShape({
	  type: 'sausage',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var dr = (r - r0) * 0.5;
	    var rCenter = r0 + dr;
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitStartX = Math.cos(startAngle);
	    var unitStartY = Math.sin(startAngle);
	    var unitEndX = Math.cos(endAngle);
	    var unitEndY = Math.sin(endAngle);
	    var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
	
	    if (lessThanCircle) {
	      ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
	      ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
	    }
	
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
	    ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	      ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(2);
	
	var lang = __webpack_require__(130);
	
	var _dataProvider = __webpack_require__(143);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(dom, ecModel) {
	  var ariaModel = ecModel.getModel('aria');
	
	  if (!ariaModel.get('show')) {
	    return;
	  } else if (ariaModel.get('description')) {
	    dom.setAttribute('aria-label', ariaModel.get('description'));
	    return;
	  }
	
	  var seriesCnt = 0;
	  ecModel.eachSeries(function (seriesModel, idx) {
	    ++seriesCnt;
	  }, this);
	  var maxDataCnt = ariaModel.get('data.maxCount') || 10;
	  var maxSeriesCnt = ariaModel.get('series.maxCount') || 10;
	  var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
	  var ariaLabel;
	
	  if (seriesCnt < 1) {
	    // No series, no aria label
	    return;
	  } else {
	    var title = getTitle();
	
	    if (title) {
	      ariaLabel = replace(getConfig('general.withTitle'), {
	        title: title
	      });
	    } else {
	      ariaLabel = getConfig('general.withoutTitle');
	    }
	
	    var seriesLabels = [];
	    var prefix = seriesCnt > 1 ? 'series.multiple.prefix' : 'series.single.prefix';
	    ariaLabel += replace(getConfig(prefix), {
	      seriesCount: seriesCnt
	    });
	    ecModel.eachSeries(function (seriesModel, idx) {
	      if (idx < displaySeriesCnt) {
	        var seriesLabel;
	        var seriesName = seriesModel.get('name');
	        var seriesTpl = 'series.' + (seriesCnt > 1 ? 'multiple' : 'single') + '.';
	        seriesLabel = getConfig(seriesName ? seriesTpl + 'withName' : seriesTpl + 'withoutName');
	        seriesLabel = replace(seriesLabel, {
	          seriesId: seriesModel.seriesIndex,
	          seriesName: seriesModel.get('name'),
	          seriesType: getSeriesTypeName(seriesModel.subType)
	        });
	        var data = seriesModel.getData();
	        window.data = data;
	
	        if (data.count() > maxDataCnt) {
	          // Show part of data
	          seriesLabel += replace(getConfig('data.partialData'), {
	            displayCnt: maxDataCnt
	          });
	        } else {
	          seriesLabel += getConfig('data.allData');
	        }
	
	        var dataLabels = [];
	
	        for (var i = 0; i < data.count(); i++) {
	          if (i < maxDataCnt) {
	            var name = data.getName(i);
	            var value = retrieveRawValue(data, i);
	            dataLabels.push(replace(name ? getConfig('data.withName') : getConfig('data.withoutName'), {
	              name: name,
	              value: value
	            }));
	          }
	        }
	
	        seriesLabel += dataLabels.join(getConfig('data.separator.middle')) + getConfig('data.separator.end');
	        seriesLabels.push(seriesLabel);
	      }
	    });
	    ariaLabel += seriesLabels.join(getConfig('series.multiple.separator.middle')) + getConfig('series.multiple.separator.end');
	    dom.setAttribute('aria-label', ariaLabel);
	  }
	
	  function replace(str, keyValues) {
	    if (typeof str !== 'string') {
	      return str;
	    }
	
	    var result = str;
	    zrUtil.each(keyValues, function (value, key) {
	      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
	    });
	    return result;
	  }
	
	  function getConfig(path) {
	    var userConfig = ariaModel.get(path);
	
	    if (userConfig == null) {
	      var pathArr = path.split('.');
	      var result = lang.aria;
	
	      for (var i = 0; i < pathArr.length; ++i) {
	        result = result[pathArr[i]];
	      }
	
	      return result;
	    } else {
	      return userConfig;
	    }
	  }
	
	  function getTitle() {
	    var title = ecModel.getModel('title').option;
	
	    if (title && title.length) {
	      title = title[0];
	    }
	
	    return title && title.text;
	  }
	
	  function getSeriesTypeName(type) {
	    return lang.series.typeNames[type] || '自定义图';
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Gradient = __webpack_require__(281);
	
	var _util = __webpack_require__(2);
	
	var isFunction = _util.isFunction;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  createOnAllSeries: true,
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.color').split('.'); // Set in itemStyle
	
	    var color = seriesModel.get(colorAccessPath);
	    var colorCallback = isFunction(color) && !(color instanceof Gradient) ? color : null; // Default color
	
	    if (!color || colorCallback) {
	      color = seriesModel.getColorFromPalette( // TODO series count changed.
	      seriesModel.name, null, ecModel.getSeriesCount());
	    }
	
	    data.setVisual('color', color);
	    var borderColorAccessPath = (seriesModel.visualBorderColorAccessPath || 'itemStyle.borderColor').split('.');
	    var borderColor = seriesModel.get(borderColorAccessPath);
	    data.setVisual('borderColor', borderColor); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      if (colorCallback) {
	        data.each(function (idx) {
	          data.setItemVisual(idx, 'color', colorCallback(seriesModel.getDataParams(idx)));
	        });
	      } // itemStyle in each data item
	
	
	      var dataEach = function (data, idx) {
	        var itemModel = data.getItemModel(idx);
	        var color = itemModel.get(colorAccessPath, true);
	        var borderColor = itemModel.get(borderColorAccessPath, true);
	
	        if (color != null) {
	          data.setItemVisual(idx, 'color', color);
	        }
	
	        if (borderColor != null) {
	          data.setItemVisual(idx, 'borderColor', borderColor);
	        }
	      };
	
	      return {
	        dataEach: data.hasItemOption ? dataEach : null
	      };
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 1874 */
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	module.exports = function equal(a, b) {
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (!equal(a[key], b[key])) return false;
	    }
	
	    return true;
	  }
	
	  return a!==a && b!==b;
	};


/***/ }),
/* 1875 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(97);
	
	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];
	
	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;
	
	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }
	
	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(97);
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
	
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};
	


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = __webpack_require__(1909);
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	exports.compress = function(input, compressionOptions) {
	    return pako.deflateRaw(input, {
	        level : compressionOptions.level || -1 // default compression
	    });
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64 = __webpack_require__(434);
	
	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");
	
	   base64zip = zip.generate();
	
	**/
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZip(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) return new JSZip(data, options);
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    // NOTE: we use a null prototype because we do not
	    // want filenames like "toString" coming from a zip file
	    // to overwrite methods and attributes in a normal Object.
	    this.files = Object.create(null);
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(437);
	JSZip.prototype.load = __webpack_require__(1880);
	JSZip.support = __webpack_require__(178);
	JSZip.defaults = __webpack_require__(862);
	
	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZip.utils = __webpack_require__(1877);
	
	JSZip.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZip.compressions = __webpack_require__(435);
	module.exports = JSZip;


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var base64 = __webpack_require__(434);
	var utf8 = __webpack_require__(866);
	var utils = __webpack_require__(97);
	var ZipEntries = __webpack_require__(1884);
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = utils.extend(options || {}, {
	        base64: false,
	        checkCRC32: false,
	        optimizedBinaryString : false,
	        createFolders: false,
	        decodeFileName: utf8.utf8decode
	    });
	    if (options.base64) {
	        data = base64.decode(data);
	    }
	
	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileNameStr, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileCommentStr.length ? input.fileCommentStr : null,
	            unixPermissions : input.unixPermissions,
	            dosPermissions : input.dosPermissions,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }
	
	    return this;
	};


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Uint8ArrayReader = __webpack_require__(865);
	
	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(97);
	
	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};
	
	module.exports = StringWriter;


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(97);
	
	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};
	
	module.exports = Uint8ArrayWriter;


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(864);
	var NodeBufferReader = __webpack_require__(1881);
	var Uint8ArrayReader = __webpack_require__(865);
	var ArrayReader = __webpack_require__(859);
	var utils = __webpack_require__(97);
	var sig = __webpack_require__(863);
	var ZipEntry = __webpack_require__(1885);
	var support = __webpack_require__(178);
	var jszipProto = __webpack_require__(437);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Check if the given signature is at the given index.
	     * @param {number} askedIndex the index to check.
	     * @param {string} expectedSignature the signature to expect.
	     * @return {boolean} true if the signature is here, false otherwise.
	     */
	    isSignature: function(askedIndex, expectedSignature) {
	        var currentIndex = this.reader.index;
	        this.reader.setIndex(askedIndex);
	        var signature = this.reader.readString(4);
	        var result = signature === expectedSignature;
	        this.reader.setIndex(currentIndex);
	        return result;
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        var zipComment = this.reader.readData(this.zipCommentLength);
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded unless specified otherwise.
	        var decodeContent = utils.transformTo(decodeParamType, zipComment);
	        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	            file.processAttributes();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	
	        if (this.centralDirRecords !== this.files.length) {
	            if (this.centralDirRecords !== 0 && this.files.length === 0) {
	                // We expected some records but couldn't find ANY.
	                // This is really suspicious, as if something went wrong.
	                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
	            } else {
	                // We found some records but not all.
	                // Something is wrong but we got something for the user: no error here.
	                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
	            }
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset < 0) {
	            // Check if the content is a truncated zip or complete garbage.
	            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
	            // extractible zip for example) but it can give a good hint.
	            // If an ajax request was used without responseType, we will also
	            // get unreadable data.
	            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);
	
	            if (isGarbage) {
	                throw new Error("Can't find end of central directory : is this a zip file ? " +
	                                "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
	            } else {
	                throw new Error("Corrupted zip : can't find end of central directory");
	            }
	        }
	        this.reader.setIndex(offset);
	        var endOfCentralDirOffset = offset;
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset < 0) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
	                // console.warn("ZIP64 end of central directory not where expected.");
	                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
	                    throw new Error("Corrupted zip : can't find the ZIP64 end of central directory");
	                }
	            }
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	
	        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
	        if (this.zip64) {
	            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
	            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
	        }
	
	        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
	
	        if (extraBytes > 0) {
	            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
	            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
	                // The offsets seem wrong, but we have something at the specified offset.
	                // So… we keep it.
	            } else {
	                // the offset is wrong, update the "zero" of the reader
	                // this happens if data has been prepended (crx files for example)
	                this.reader.zero = extraBytes;
	            }
	        } else if (extraBytes < 0) {
	            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        utils.checkSupport(type);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else if (support.uint8array) {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        } else if (support.array) {
	            this.reader = new ArrayReader(utils.transformTo("array", data));
	        } else {
	            throw new Error("Unexpected error: unsupported type '" + type + "'");
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(864);
	var utils = __webpack_require__(97);
	var CompressedObject = __webpack_require__(860);
	var jszipProto = __webpack_require__(437);
	var support = __webpack_require__(178);
	
	var MADE_BY_DOS = 0x00;
	var MADE_BY_UNIX = 0x03;
	
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);
	
	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {
	
	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);
	
	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	
	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readData(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }
	
	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " +  utils.transformTo("string", this.fileName) + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
	
	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readInt(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        this.fileName = reader.readData(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readData(this.fileCommentLength);
	    },
	
	    /**
	     * Parse the external file attributes and get the unix/dos permissions.
	     */
	    processAttributes: function () {
	        this.unixPermissions = null;
	        this.dosPermissions = null;
	        var madeBy = this.versionMadeBy >> 8;
	
	        // Check if we have the DOS directory flag set.
	        // We look for it in the DOS and UNIX permissions
	        // but some unknown platform could set it as a compatibility flag.
	        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
	
	        if(madeBy === MADE_BY_DOS) {
	            // first 6 bits (0 to 5)
	            this.dosPermissions = this.externalFileAttributes & 0x3F;
	        }
	
	        if(madeBy === MADE_BY_UNIX) {
	            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
	            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
	        }
	
	        // fail safe : if the name ends with a / it probably means a folder
	        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
	            this.dir = true;
	        }
	    },
	
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        this.extraFields = this.extraFields || {};
	
	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        if (this.useUTF8()) {
	            this.fileNameStr = jszipProto.utf8decode(this.fileName);
	            this.fileCommentStr = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileNameStr = upath;
	            } else {
	                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
	                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
	            }
	
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileCommentStr = ucomment;
	            } else {
	                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
	                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(30)(module)))

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(286),
	    keys = __webpack_require__(491);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(286),
	    keysIn = __webpack_require__(498);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(2104),
	    arrayEach = __webpack_require__(867),
	    assignValue = __webpack_require__(2111),
	    baseAssign = __webpack_require__(1887),
	    baseAssignIn = __webpack_require__(1888),
	    cloneBuffer = __webpack_require__(2093),
	    copyArray = __webpack_require__(2113),
	    copySymbols = __webpack_require__(1896),
	    copySymbolsIn = __webpack_require__(1897),
	    getAllKeys = __webpack_require__(2095),
	    getAllKeysIn = __webpack_require__(1899),
	    getTag = __webpack_require__(497),
	    initCloneArray = __webpack_require__(1900),
	    initCloneByTag = __webpack_require__(1901),
	    initCloneObject = __webpack_require__(2096),
	    isArray = __webpack_require__(499),
	    isBuffer = __webpack_require__(2106),
	    isMap = __webpack_require__(1905),
	    isObject = __webpack_require__(927),
	    isSet = __webpack_require__(1906),
	    keys = __webpack_require__(491),
	    keysIn = __webpack_require__(498);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(497),
	    isObjectLike = __webpack_require__(928);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(497),
	    isObjectLike = __webpack_require__(928);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(868),
	    isArrayLike = __webpack_require__(922);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(919);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 1894 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(2100);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(286),
	    getSymbols = __webpack_require__(920);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(286),
	    getSymbolsIn = __webpack_require__(871);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(922);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(2092),
	    getSymbolsIn = __webpack_require__(871),
	    keysIn = __webpack_require__(498);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 1900 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(919),
	    cloneDataView = __webpack_require__(1893),
	    cloneRegExp = __webpack_require__(1894),
	    cloneSymbol = __webpack_require__(1895),
	    cloneTypedArray = __webpack_require__(2094);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(1889);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1904);


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(867),
	    baseEach = __webpack_require__(868),
	    castFunction = __webpack_require__(870),
	    isArray = __webpack_require__(499);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1890),
	    baseUnary = __webpack_require__(918),
	    nodeUtil = __webpack_require__(921);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1891),
	    baseUnary = __webpack_require__(918),
	    nodeUtil = __webpack_require__(921);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 1907 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(100),
	    isObject = __webpack_require__(927);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = __webpack_require__(133).assign;
	
	var deflate   = __webpack_require__(1910);
	var inflate   = __webpack_require__(1911);
	var constants = __webpack_require__(875);
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_deflate = __webpack_require__(1912);
	var utils        = __webpack_require__(133);
	var strings      = __webpack_require__(873);
	var msg          = __webpack_require__(439);
	var ZStream      = __webpack_require__(877);
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overridden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_inflate = __webpack_require__(1915);
	var utils        = __webpack_require__(133);
	var strings      = __webpack_require__(873);
	var c            = __webpack_require__(875);
	var msg          = __webpack_require__(439);
	var ZStream      = __webpack_require__(877);
	var GZheader     = __webpack_require__(1913);
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overridden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	
	  // Setup dictionary
	  if (opt.dictionary) {
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      opt.dictionary = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      opt.dictionary = new Uint8Array(opt.dictionary);
	    }
	    if (opt.raw) { //In raw mode we need to set the dictionary early
	      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
	      if (status !== c.Z_OK) {
	        throw new Error(msg[status]);
	      }
	    }
	  }
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 aligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils   = __webpack_require__(133);
	var trees   = __webpack_require__(1917);
	var adler32 = __webpack_require__(874);
	var crc32   = __webpack_require__(876);
	var msg     = __webpack_require__(439);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	        );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 1913 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;


/***/ }),
/* 1914 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils         = __webpack_require__(133);
	var adler32       = __webpack_require__(874);
	var crc32         = __webpack_require__(876);
	var inflate_fast  = __webpack_require__(1914);
	var inflate_table = __webpack_require__(1916);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	      case HEAD:
	        if (state.wrap === 0) {
	          state.mode = TYPEDO;
	          break;
	        }
	        //=== NEEDBITS(16);
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = FLAGS;
	          break;
	        }
	        state.flags = 0;           /* expect zlib header */
	        if (state.head) {
	          state.head.done = false;
	        }
	        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	          strm.msg = 'incorrect header check';
	          state.mode = BAD;
	          break;
	        }
	        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	        len = (hold & 0x0f)/*BITS(4)*/ + 8;
	        if (state.wbits === 0) {
	          state.wbits = len;
	        }
	        else if (len > state.wbits) {
	          strm.msg = 'invalid window size';
	          state.mode = BAD;
	          break;
	        }
	        state.dmax = 1 << len;
	        //Tracev((stderr, "inflate:   zlib header ok\n"));
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = hold & 0x200 ? DICTID : TYPE;
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        break;
	      case FLAGS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.flags = hold;
	        if ((state.flags & 0xff) !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        if (state.flags & 0xe000) {
	          strm.msg = 'unknown header flags set';
	          state.mode = BAD;
	          break;
	        }
	        if (state.head) {
	          state.head.text = ((hold >> 8) & 1);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = TIME;
	        /* falls through */
	      case TIME:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.time = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC4(state.check, hold)
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          hbuf[2] = (hold >>> 16) & 0xff;
	          hbuf[3] = (hold >>> 24) & 0xff;
	          state.check = crc32(state.check, hbuf, 4, 0);
	          //===
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = OS;
	        /* falls through */
	      case OS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.xflags = (hold & 0xff);
	          state.head.os = (hold >> 8);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = EXLEN;
	        /* falls through */
	      case EXLEN:
	        if (state.flags & 0x0400) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length = hold;
	          if (state.head) {
	            state.head.extra_len = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        else if (state.head) {
	          state.head.extra = null/*Z_NULL*/;
	        }
	        state.mode = EXTRA;
	        /* falls through */
	      case EXTRA:
	        if (state.flags & 0x0400) {
	          copy = state.length;
	          if (copy > have) { copy = have; }
	          if (copy) {
	            if (state.head) {
	              len = state.head.extra_len - state.length;
	              if (!state.head.extra) {
	                // Use untyped array for more convenient processing later
	                state.head.extra = new Array(state.head.extra_len);
	              }
	              utils.arraySet(
	                state.head.extra,
	                input,
	                next,
	                // extra field is limited to 65536 bytes
	                // - no need for additional size check
	                copy,
	                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                len
	              );
	              //zmemcpy(state.head.extra + len, next,
	              //        len + copy > state.head.extra_max ?
	              //        state.head.extra_max - len : copy);
	            }
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            state.length -= copy;
	          }
	          if (state.length) { break inf_leave; }
	        }
	        state.length = 0;
	        state.mode = NAME;
	        /* falls through */
	      case NAME:
	        if (state.flags & 0x0800) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            // TODO: 2 or 1 bytes?
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.name_max*/)) {
	              state.head.name += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.name = null;
	        }
	        state.length = 0;
	        state.mode = COMMENT;
	        /* falls through */
	      case COMMENT:
	        if (state.flags & 0x1000) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.comm_max*/)) {
	              state.head.comment += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.comment = null;
	        }
	        state.mode = HCRC;
	        /* falls through */
	      case HCRC:
	        if (state.flags & 0x0200) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.check & 0xffff)) {
	            strm.msg = 'header crc mismatch';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        if (state.head) {
	          state.head.hcrc = ((state.flags >> 9) & 1);
	          state.head.done = true;
	        }
	        strm.adler = state.check = 0;
	        state.mode = TYPE;
	        break;
	      case DICTID:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        strm.adler = state.check = zswap32(hold);
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = DICT;
	        /* falls through */
	      case DICT:
	        if (state.havedict === 0) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          return Z_NEED_DICT;
	        }
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = TYPE;
	        /* falls through */
	      case TYPE:
	        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case TYPEDO:
	        if (state.last) {
	          //--- BYTEBITS() ---//
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          state.mode = CHECK;
	          break;
	        }
	        //=== NEEDBITS(3); */
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.last = (hold & 0x01)/*BITS(1)*/;
	        //--- DROPBITS(1) ---//
	        hold >>>= 1;
	        bits -= 1;
	        //---//
	
	        switch ((hold & 0x03)/*BITS(2)*/) {
	          case 0:                             /* stored block */
	            //Tracev((stderr, "inflate:     stored block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = STORED;
	            break;
	          case 1:                             /* fixed block */
	            fixedtables(state);
	            //Tracev((stderr, "inflate:     fixed codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = LEN_;             /* decode codes */
	            if (flush === Z_TREES) {
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	              break inf_leave;
	            }
	            break;
	          case 2:                             /* dynamic block */
	            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = TABLE;
	            break;
	          case 3:
	            strm.msg = 'invalid block type';
	            state.mode = BAD;
	        }
	        //--- DROPBITS(2) ---//
	        hold >>>= 2;
	        bits -= 2;
	        //---//
	        break;
	      case STORED:
	        //--- BYTEBITS() ---// /* go to byte boundary */
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	          strm.msg = 'invalid stored block lengths';
	          state.mode = BAD;
	          break;
	        }
	        state.length = hold & 0xffff;
	        //Tracev((stderr, "inflate:       stored length %u\n",
	        //        state.length));
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = COPY_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case COPY_:
	        state.mode = COPY;
	        /* falls through */
	      case COPY:
	        copy = state.length;
	        if (copy) {
	          if (copy > have) { copy = have; }
	          if (copy > left) { copy = left; }
	          if (copy === 0) { break inf_leave; }
	          //--- zmemcpy(put, next, copy); ---
	          utils.arraySet(output, input, next, copy, put);
	          //---//
	          have -= copy;
	          next += copy;
	          left -= copy;
	          put += copy;
	          state.length -= copy;
	          break;
	        }
	        //Tracev((stderr, "inflate:       stored end\n"));
	        state.mode = TYPE;
	        break;
	      case TABLE:
	        //=== NEEDBITS(14); */
	        while (bits < 14) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	        if (state.nlen > 286 || state.ndist > 30) {
	          strm.msg = 'too many length or distance symbols';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracev((stderr, "inflate:       table sizes ok\n"));
	        state.have = 0;
	        state.mode = LENLENS;
	        /* falls through */
	      case LENLENS:
	        while (state.have < state.ncode) {
	          //=== NEEDBITS(3);
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	          //--- DROPBITS(3) ---//
	          hold >>>= 3;
	          bits -= 3;
	          //---//
	        }
	        while (state.have < 19) {
	          state.lens[order[state.have++]] = 0;
	        }
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        //state.next = state.codes;
	        //state.lencode = state.next;
	        // Switch to use dynamic table
	        state.lencode = state.lendyn;
	        state.lenbits = 7;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	        state.lenbits = opts.bits;
	
	        if (ret) {
	          strm.msg = 'invalid code lengths set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, "inflate:       code lengths ok\n"));
	        state.have = 0;
	        state.mode = CODELENS;
	        /* falls through */
	      case CODELENS:
	        while (state.have < state.nlen + state.ndist) {
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_val < 16) {
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            state.lens[state.have++] = here_val;
	          }
	          else {
	            if (here_val === 16) {
	              //=== NEEDBITS(here.bits + 2);
	              n = here_bits + 2;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              if (state.have === 0) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD;
	                break;
	              }
	              len = state.lens[state.have - 1];
	              copy = 3 + (hold & 0x03);//BITS(2);
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	            }
	            else if (here_val === 17) {
	              //=== NEEDBITS(here.bits + 3);
	              n = here_bits + 3;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 3 + (hold & 0x07);//BITS(3);
	              //--- DROPBITS(3) ---//
	              hold >>>= 3;
	              bits -= 3;
	              //---//
	            }
	            else {
	              //=== NEEDBITS(here.bits + 7);
	              n = here_bits + 7;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 11 + (hold & 0x7f);//BITS(7);
	              //--- DROPBITS(7) ---//
	              hold >>>= 7;
	              bits -= 7;
	              //---//
	            }
	            if (state.have + copy > state.nlen + state.ndist) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            while (copy--) {
	              state.lens[state.have++] = len;
	            }
	          }
	        }
	
	        /* handle error breaks in while */
	        if (state.mode === BAD) { break; }
	
	        /* check for end-of-block code (better have one) */
	        if (state.lens[256] === 0) {
	          strm.msg = 'invalid code -- missing end-of-block';
	          state.mode = BAD;
	          break;
	        }
	
	        /* build code tables -- note: do not change the lenbits or distbits
	           values here (9 and 6) without reading the comments in inftrees.h
	           concerning the ENOUGH constants, which depend on those values */
	        state.lenbits = 9;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.lenbits = opts.bits;
	        // state.lencode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid literal/lengths set';
	          state.mode = BAD;
	          break;
	        }
	
	        state.distbits = 6;
	        //state.distcode.copy(state.codes);
	        // Switch to use dynamic table
	        state.distcode = state.distdyn;
	        opts = { bits: state.distbits };
	        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.distbits = opts.bits;
	        // state.distcode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid distances set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, 'inflate:       codes ok\n'));
	        state.mode = LEN_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case LEN_:
	        state.mode = LEN;
	        /* falls through */
	      case LEN:
	        if (have >= 6 && left >= 258) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          inflate_fast(strm, _out);
	          //--- LOAD() ---
	          put = strm.next_out;
	          output = strm.output;
	          left = strm.avail_out;
	          next = strm.next_in;
	          input = strm.input;
	          have = strm.avail_in;
	          hold = state.hold;
	          bits = state.bits;
	          //---
	
	          if (state.mode === TYPE) {
	            state.back = -1;
	          }
	          break;
	        }
	        state.back = 0;
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if (here_bits <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_op && (here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.lencode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        state.length = here_val;
	        if (here_op === 0) {
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          state.mode = LIT;
	          break;
	        }
	        if (here_op & 32) {
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.back = -1;
	          state.mode = TYPE;
	          break;
	        }
	        if (here_op & 64) {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break;
	        }
	        state.extra = here_op & 15;
	        state.mode = LENEXT;
	        /* falls through */
	      case LENEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", state.length));
	        state.was = state.length;
	        state.mode = DIST;
	        /* falls through */
	      case DIST:
	        for (;;) {
	          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if ((here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.distcode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        if (here_op & 64) {
	          strm.msg = 'invalid distance code';
	          state.mode = BAD;
	          break;
	        }
	        state.offset = here_val;
	        state.extra = (here_op) & 15;
	        state.mode = DISTEXT;
	        /* falls through */
	      case DISTEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	//#ifdef INFLATE_STRICT
	        if (state.offset > state.dmax) {
	          strm.msg = 'invalid distance too far back';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	        state.mode = MATCH;
	        /* falls through */
	      case MATCH:
	        if (left === 0) { break inf_leave; }
	        copy = _out - left;
	        if (state.offset > copy) {         /* copy from window */
	          copy = state.offset - copy;
	          if (copy > state.whave) {
	            if (state.sane) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break;
	            }
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	          }
	          if (copy > state.wnext) {
	            copy -= state.wnext;
	            from = state.wsize - copy;
	          }
	          else {
	            from = state.wnext - copy;
	          }
	          if (copy > state.length) { copy = state.length; }
	          from_source = state.window;
	        }
	        else {                              /* copy from output */
	          from_source = output;
	          from = put - state.offset;
	          copy = state.length;
	        }
	        if (copy > left) { copy = left; }
	        left -= copy;
	        state.length -= copy;
	        do {
	          output[put++] = from_source[from++];
	        } while (--copy);
	        if (state.length === 0) { state.mode = LEN; }
	        break;
	      case LIT:
	        if (left === 0) { break inf_leave; }
	        output[put++] = state.length;
	        left--;
	        state.mode = LEN;
	        break;
	      case CHECK:
	        if (state.wrap) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            // Use '|' instead of '+' to make sure that result is signed
	            hold |= input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          _out -= left;
	          strm.total_out += _out;
	          state.total += _out;
	          if (_out) {
	            strm.adler = state.check =
	                /*UPDATE(state.check, put - _out, _out);*/
	                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	          }
	          _out = left;
	          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	            strm.msg = 'incorrect data check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   check matches trailer\n"));
	        }
	        state.mode = LENGTH;
	        /* falls through */
	      case LENGTH:
	        if (state.wrap && state.flags) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.total & 0xffffffff)) {
	            strm.msg = 'incorrect length check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   length matches trailer\n"));
	        }
	        state.mode = DONE;
	        /* falls through */
	      case DONE:
	        ret = Z_STREAM_END;
	        break inf_leave;
	      case BAD:
	        ret = Z_DATA_ERROR;
	        break inf_leave;
	      case MEM:
	        return Z_MEM_ERROR;
	      case SYNC:
	        /* falls through */
	      default:
	        return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(133);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  /* process all codes and make table entries */
	  for (;;) {
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	/* eslint-disable space-unary-ops */
	
	var utils = __webpack_require__(133);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
	 * License: MIT - http://mrgnrdrck.mit-license.org
	 *
	 * https://github.com/mroderick/PubSubJS
	 */
	
	(function (root, factory){
	    'use strict';
	
	    var PubSub = {};
	
	    if (root.PubSub) {
	        PubSub = root.PubSub;
	        console.warn("PubSub already loaded, using existing version");
	    } else {
	        root.PubSub = PubSub;
	        factory(PubSub);
	    }
	    // CommonJS and Node.js module support
	    if (true){
	        if (module !== undefined && module.exports) {
	            exports = module.exports = PubSub; // Node.js specific `module.exports`
	        }
	        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
	        module.exports = exports = PubSub; // CommonJS
	    }
	    // AMD support
	    /* eslint-disable no-undef */
	    else if (typeof define === 'function' && define.amd){
	        define(function() { return PubSub; });
	        /* eslint-enable no-undef */
	    }
	
	}(( typeof window === 'object' && window ) || this || global, function (PubSub){
	    'use strict';
	
	    var messages = {},
	        lastUid = -1,
	        ALL_SUBSCRIBING_MSG = '*';
	
	    function hasKeys(obj){
	        var key;
	
	        for (key in obj){
	            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
	                return true;
	            }
	        }
	        return false;
	    }
	
	    /**
	     * Returns a function that throws the passed exception, for use as argument for setTimeout
	     * @alias throwException
	     * @function
	     * @param { Object } ex An Error object
	     */
	    function throwException( ex ){
	        return function reThrowException(){
	            throw ex;
	        };
	    }
	
	    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
	        try {
	            subscriber( message, data );
	        } catch( ex ){
	            setTimeout( throwException( ex ), 0);
	        }
	    }
	
	    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
	        subscriber( message, data );
	    }
	
	    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
	        var subscribers = messages[matchedMessage],
	            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
	            s;
	
	        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
	            return;
	        }
	
	        for (s in subscribers){
	            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
	                callSubscriber( subscribers[s], originalMessage, data );
	            }
	        }
	    }
	
	    function createDeliveryFunction( message, data, immediateExceptions ){
	        return function deliverNamespaced(){
	            var topic = String( message ),
	                position = topic.lastIndexOf( '.' );
	
	            // deliver the message as it is now
	            deliverMessage(message, message, data, immediateExceptions);
	
	            // trim the hierarchy and deliver message to each level
	            while( position !== -1 ){
	                topic = topic.substr( 0, position );
	                position = topic.lastIndexOf('.');
	                deliverMessage( message, topic, data, immediateExceptions );
	            }
	
	            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
	        };
	    }
	
	    function hasDirectSubscribersFor( message ) {
	        var topic = String( message ),
	            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));
	
	        return found;
	    }
	
	    function messageHasSubscribers( message ){
	        var topic = String( message ),
	            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
	            position = topic.lastIndexOf( '.' );
	
	        while ( !found && position !== -1 ){
	            topic = topic.substr( 0, position );
	            position = topic.lastIndexOf( '.' );
	            found = hasDirectSubscribersFor(topic);
	        }
	
	        return found;
	    }
	
	    function publish( message, data, sync, immediateExceptions ){
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
	            hasSubscribers = messageHasSubscribers( message );
	
	        if ( !hasSubscribers ){
	            return false;
	        }
	
	        if ( sync === true ){
	            deliver();
	        } else {
	            setTimeout( deliver, 0 );
	        }
	        return true;
	    }
	
	    /**
	     * Publishes the message, passing the data to it's subscribers
	     * @function
	     * @alias publish
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publish = function( message, data ){
	        return publish( message, data, false, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Publishes the message synchronously, passing the data to it's subscribers
	     * @function
	     * @alias publishSync
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publishSync = function( message, data ){
	        return publish( message, data, true, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
	     * @function
	     * @alias subscribe
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { String }
	     */
	    PubSub.subscribe = function( message, func ){
	        if ( typeof func !== 'function'){
	            return false;
	        }
	
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        // message is not registered yet
	        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
	            messages[message] = {};
	        }
	
	        // forcing token as String, to allow for future expansions without breaking usage
	        // and allow for easy use as key names for the 'messages' object
	        var token = 'uid_' + String(++lastUid);
	        messages[message][token] = func;
	
	        // return token for unsubscribing
	        return token;
	    };
	
	    PubSub.subscribeAll = function( func ){
	        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
	    };
	
	    /**
	     * Subscribes the passed function to the passed message once
	     * @function
	     * @alias subscribeOnce
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { PubSub }
	     */
	    PubSub.subscribeOnce = function( message, func ){
	        var token = PubSub.subscribe( message, function(){
	            // before func apply, unsubscribe message
	            PubSub.unsubscribe( token );
	            func.apply( this, arguments );
	        });
	        return PubSub;
	    };
	
	    /**
	     * Clears all subscriptions
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     */
	    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
	        messages = {};
	    };
	
	    /**
	     * Clear subscriptions by the topic
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     * @return { int }
	     */
	    PubSub.clearSubscriptions = function clearSubscriptions(topic){
	        var m;
	        for (m in messages){
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
	                delete messages[m];
	            }
	        }
	    };
	
	    /**
	       Count subscriptions by the topic
	     * @function
	     * @public
	     * @alias countSubscriptions
	     * @return { Array }
	    */
	    PubSub.countSubscriptions = function countSubscriptions(topic){
	        var m;
	        // eslint-disable-next-line no-unused-vars
	        var token;
	        var count = 0;
	        for (m in messages) {
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
	                for (token in messages[m]) {
	                    count++;
	                }
	                break;
	            }
	        }
	        return count;
	    };
	
	
	    /**
	       Gets subscriptions by the topic
	     * @function
	     * @public
	     * @alias getSubscriptions
	    */
	    PubSub.getSubscriptions = function getSubscriptions(topic){
	        var m;
	        var list = [];
	        for (m in messages){
	            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
	                list.push(m);
	            }
	        }
	        return list;
	    };
	
	    /**
	     * Removes subscriptions
	     *
	     * - When passed a token, removes a specific subscription.
	     *
		 * - When passed a function, removes all subscriptions for that function
	     *
		 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
	     * @function
	     * @public
	     * @alias subscribeOnce
	     * @param { String | Function } value A token, function or topic to unsubscribe from
	     * @example // Unsubscribing with a token
	     * var token = PubSub.subscribe('mytopic', myFunc);
	     * PubSub.unsubscribe(token);
	     * @example // Unsubscribing with a function
	     * PubSub.unsubscribe(myFunc);
	     * @example // Unsubscribing from a topic
	     * PubSub.unsubscribe('mytopic');
	     */
	    PubSub.unsubscribe = function(value){
	        var descendantTopicExists = function(topic) {
	                var m;
	                for ( m in messages ){
	                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
	                        // a descendant of the topic exists:
	                        return true;
	                    }
	                }
	
	                return false;
	            },
	            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
	            isToken    = !isTopic && typeof value === 'string',
	            isFunction = typeof value === 'function',
	            result = false,
	            m, message, t;
	
	        if (isTopic){
	            PubSub.clearSubscriptions(value);
	            return;
	        }
	
	        for ( m in messages ){
	            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
	                message = messages[m];
	
	                if ( isToken && message[value] ){
	                    delete message[value];
	                    result = value;
	                    // tokens are unique, so we can just stop here
	                    break;
	                }
	
	                if (isFunction) {
	                    for ( t in message ){
	                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
	                            delete message[t];
	                            result = true;
	                        }
	                    }
	                }
	            }
	        }
	
	        return result;
	    };
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(30)(module)))

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  today: '今天',
	  now: '此刻',
	  backToToday: '返回今天',
	  ok: '确定',
	  timeSelect: '选择时间',
	  dateSelect: '选择日期',
	  weekSelect: '选择周',
	  clear: '清除',
	  month: '月',
	  year: '年',
	  previousMonth: '上个月 (翻页上键)',
	  nextMonth: '下个月 (翻页下键)',
	  monthSelect: '选择月份',
	  yearSelect: '选择年份',
	  decadeSelect: '选择年代',
	  yearFormat: 'YYYY年',
	  dayFormat: 'D日',
	  dateFormat: 'YYYY年M月D日',
	  dateTimeFormat: 'YYYY年M月D日 HH时mm分ss秒',
	  previousYear: '上一年 (Control键加左方向键)',
	  nextYear: '下一年 (Control键加右方向键)',
	  previousDecade: '上一年代',
	  nextDecade: '下一年代',
	  previousCentury: '上一世纪',
	  nextCentury: '下一世纪'
	};
	module.exports = exports['default'];

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(50);
	
	var _AlphaPointer = __webpack_require__(1921);
	
	var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
	  var rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      direction = _ref.direction,
	      style = _ref.style,
	      renderers = _ref.renderers,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      alpha: {
	        radius: '2px',
	        style: style
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'alpha-picker ' + className },
	    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
	      rgb: rgb,
	      hsl: hsl,
	      pointer: pointer,
	      renderers: renderers,
	      onChange: onChange,
	      direction: direction
	    }))
	  );
	};
	
	AlphaPicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _AlphaPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = AlphaPointer;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Block = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	var _BlockSwatches = __webpack_require__(1923);
	
	var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = exports.Block = function Block(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var transparent = hex === 'transparent';
	  var handleChange = function handleChange(hexCode, e) {
	    color.isValidHex(hexCode) && onChange({
	      hex: hexCode,
	      source: 'hex'
	    }, e);
	  };
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        boxShadow: '0 1px rgba(0,0,0,.1)',
	        borderRadius: '6px',
	        position: 'relative'
	      },
	      head: {
	        height: '110px',
	        background: hex,
	        borderRadius: '6px 6px 0 0',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        position: 'relative'
	      },
	      body: {
	        padding: '10px'
	      },
	      label: {
	        fontSize: '18px',
	        color: color.getContrastingColor(hex),
	        position: 'relative'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 10px 10px 10px',
	        borderColor: 'transparent transparent ' + hex + ' transparent',
	        position: 'absolute',
	        top: '-10px',
	        left: '50%',
	        marginLeft: '-10px'
	      },
	      input: {
	        width: '100%',
	        fontSize: '12px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '22px',
	        boxShadow: 'inset 0 0 0 1px #ddd',
	        borderRadius: '4px',
	        padding: '0 7px',
	        boxSizing: 'border-box'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      }
	    }
	  }, passedStyles), { 'hide-triangle': triangle === 'hide' });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'block-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.label },
	        hex
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex,
	        onChange: handleChange
	      })
	    )
	  );
	};
	
	Block.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['top', 'hide']),
	  styles: _propTypes2.default.object
	};
	
	Block.defaultProps = {
	  width: 170,
	  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
	  triangle: 'top',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Block);

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlockSwatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(132);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
	  var colors = _ref.colors,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginRight: '-10px'
	      },
	      swatch: {
	        width: '22px',
	        height: '22px',
	        float: 'left',
	        marginRight: '10px',
	        marginBottom: '10px',
	        borderRadius: '4px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_common.Swatch, {
	        key: c,
	        color: c,
	        style: styles.swatch,
	        onClick: onClick,
	        onHover: onSwatchHover,
	        focusStyle: {
	          boxShadow: '0 0 4px ' + c
	        }
	      });
	    }),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = BlockSwatches;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(50);
	
	var _ChromeFields = __webpack_require__(1925);
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__(1926);
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__(1927);
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chrome = exports.Chrome = function Chrome(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      renderers = _ref.renderers,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      defaultView = _ref.defaultView;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        background: '#fff',
	        borderRadius: '2px',
	        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	        boxSizing: 'initial',
	        fontFamily: 'Menlo'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '55%',
	        position: 'relative',
	        borderRadius: '2px 2px 0 0',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '2px 2px 0 0'
	      },
	      body: {
	        padding: '16px 16px 12px'
	      },
	      controls: {
	        display: 'flex'
	      },
	      color: {
	        width: '32px'
	      },
	      swatch: {
	        marginTop: '6px',
	        width: '16px',
	        height: '16px',
	        borderRadius: '8px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      active: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '8px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
	        zIndex: '2'
	      },
	      toggles: {
	        flex: '1'
	      },
	      hue: {
	        height: '10px',
	        position: 'relative',
	        marginBottom: '8px'
	      },
	      Hue: {
	        radius: '2px'
	      },
	      alpha: {
	        height: '10px',
	        position: 'relative'
	      },
	      Alpha: {
	        radius: '2px'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        width: '22px'
	      },
	      alpha: {
	        display: 'none'
	      },
	      hue: {
	        marginBottom: '0px'
	      },
	      swatch: {
	        width: '10px',
	        height: '10px',
	        marginTop: '0px'
	      }
	    }
	  }, passedStyles), { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'chrome-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _ChromePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.color },
	          _react2.default.createElement(
	            'div',
	            { style: styles.swatch },
	            _react2.default.createElement('div', { style: styles.active }),
	            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggles },
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              style: styles.Hue,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              onChange: onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.Alpha, {
	              style: styles.Alpha,
	              rgb: rgb,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              renderers: renderers,
	              onChange: onChange
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_ChromeFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        view: defaultView,
	        onChange: onChange,
	        disableAlpha: disableAlpha
	      })
	    )
	  );
	};
	
	Chrome.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  disableAlpha: _propTypes2.default.bool,
	  styles: _propTypes2.default.object,
	  defaultView: _propTypes2.default.oneOf(["hex", "rgb", "hsl"])
	};
	
	Chrome.defaultProps = {
	  width: 225,
	  disableAlpha: false,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	var _isUndefined = __webpack_require__(1907);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _common = __webpack_require__(50);
	
	var _UnfoldMoreHorizontalIcon = __webpack_require__(931);
	
	var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault(_UnfoldMoreHorizontalIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields(props) {
	    _classCallCheck(this, ChromeFields);
	
	    var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
	
	    _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    };
	
	    _this.handleChange = function (data, e) {
	      if (data.hex) {
	        color.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        }, e);
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        }, e);
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        }, e);
	      } else if (data.h || data.s || data.l) {
	        // Remove any occurances of '%'.
	        if (typeof data.s === 'string' && data.s.includes('%')) {
	          data.s = data.s.replace('%', '');
	        }
	        if (typeof data.l === 'string' && data.l.includes('%')) {
	          data.l = data.l.replace('%', '');
	        }
	
	        // We store HSL as a unit interval so we need to override the 1 input to 0.01
	        if (data.s == 1) {
	          data.s = 0.01;
	        } else if (data.l == 1) {
	          data.l = 0.01;
	        }
	
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: Number(!(0, _isUndefined2.default)(data.s) ? data.s : _this.props.hsl.s),
	          l: Number(!(0, _isUndefined2.default)(data.l) ? data.l : _this.props.hsl.l),
	          source: 'hsl'
	        }, e);
	      }
	    };
	
	    _this.showHighlight = function (e) {
	      e.currentTarget.style.background = '#eee';
	    };
	
	    _this.hideHighlight = function (e) {
	      e.currentTarget.style.background = 'transparent';
	    };
	
	    if (props.hsl.a !== 1 && props.view === "hex") {
	      _this.state = {
	        view: "rgb"
	      };
	    } else {
	      _this.state = {
	        view: props.view
	      };
	    }
	    return _this;
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          },
	          svg: {
	            fill: '#333',
	            width: '24px',
	            height: '24px',
	            border: '1px transparent solid',
	            borderRadius: '5px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields = void 0;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'hex', value: this.props.hex,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'r',
	              value: this.props.rgb.r,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'g',
	              value: this.props.rgb.g,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'b',
	              value: this.props.rgb.b,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.rgb.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'h',
	              value: Math.round(this.props.hsl.h),
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 's',
	              value: Math.round(this.props.hsl.s * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'l',
	              value: Math.round(this.props.hsl.l * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.hsl.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
	                return _this2.icon = icon;
	              } },
	            _react2.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
	              style: styles.svg,
	              onMouseOver: this.showHighlight,
	              onMouseEnter: this.showHighlight,
	              onMouseOut: this.hideHighlight
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, state) {
	      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
	        return { view: 'rgb' };
	      }
	      return null;
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	ChromeFields.defaultProps = {
	  view: "hex"
	};
	
	exports.default = ChromeFields;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointer = exports.ChromePointer = function ChromePointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        transform: 'translate(-6px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointer;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointerCircle;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Circle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(132);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _materialColors = __webpack_require__(872);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(50);
	
	var _CircleSwatch = __webpack_require__(1929);
	
	var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = exports.Circle = function Circle(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      circleSize = _ref.circleSize,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      circleSpacing = _ref.circleSpacing,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        display: 'flex',
	        flexWrap: 'wrap',
	        marginRight: -circleSpacing,
	        marginBottom: -circleSpacing
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(hexCode, e) {
	    return onChange({ hex: hexCode, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'circle-picker ' + className },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_CircleSwatch2.default, {
	        key: c,
	        color: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover,
	        active: hex === c.toLowerCase(),
	        circleSize: circleSize,
	        circleSpacing: circleSpacing
	      });
	    })
	  );
	};
	
	Circle.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  circleSize: _propTypes2.default.number,
	  circleSpacing: _propTypes2.default.number,
	  styles: _propTypes2.default.object
	};
	
	Circle.defaultProps = {
	  width: 252,
	  circleSize: 28,
	  circleSpacing: 14,
	  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Circle);

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      hover = _ref.hover,
	      active = _ref.active,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: circleSize,
	        height: circleSize,
	        marginRight: circleSpacing,
	        marginBottom: circleSpacing,
	        transform: 'scale(1)',
	        transition: '100ms transform ease'
	      },
	      Swatch: {
	        borderRadius: '50%',
	        background: 'transparent',
	        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
	        transition: '100ms box-shadow ease'
	      }
	    },
	    'hover': {
	      swatch: {
	        transform: 'scale(1.2)'
	      }
	    },
	    'active': {
	      Swatch: {
	        boxShadow: 'inset 0 0 0 3px ' + color
	      }
	    }
	  }, { hover: hover, active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      style: styles.Swatch,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
	    })
	  );
	};
	
	CircleSwatch.defaultProps = {
	  circleSize: 28,
	  circleSpacing: 14
	};
	
	exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _alpha = __webpack_require__(1965);
	
	var alpha = _interopRequireWildcard(_alpha);
	
	var _Checkboard = __webpack_require__(440);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_ref) {
	  _inherits(Alpha, _ref);
	
	  function Alpha() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Alpha);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var change = alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
	      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var rgb = this.props.rgb;
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden',
	            borderRadius: this.props.radius
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          gradient: {
	            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
	          },
	          pointer: {
	            left: 0,
	            top: rgb.a * 100 + '%'
	          }
	        },
	        'overwrite': _extends({}, this.props.style)
	      }, {
	        vertical: this.props.direction === 'vertical',
	        overwrite: true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Alpha;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_ARROW_OFFSET = 1;
	
	var UP_KEY_CODE = 38;
	var DOWN_KEY_CODE = 40;
	var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
	var isValidKeyCode = function isValidKeyCode(keyCode) {
	  return VALID_KEY_CODES.indexOf(keyCode) > -1;
	};
	var getNumberValue = function getNumberValue(value) {
	  return Number(String(value).replace(/%/g, ''));
	};
	
	var idCounter = 1;
	
	var EditableInput = exports.EditableInput = function (_ref) {
	  _inherits(EditableInput, _ref);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      _this.setUpdatedValue(e.target.value, e);
	    };
	
	    _this.handleKeyDown = function (e) {
	      // In case `e.target.value` is a percentage remove the `%` character
	      // and update accordingly with a percentage
	      // https://github.com/casesandberg/react-color/issues/383
	      var value = getNumberValue(e.target.value);
	      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
	        var offset = _this.getArrowOffset();
	        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
	
	        _this.setUpdatedValue(updatedValue, e);
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleDrag);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	
	    _this.inputId = 'rc-editable-input-' + idCounter++;
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
	        if (this.input === document.activeElement) {
	          this.setState({ blurValue: String(this.props.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'getValueObjectWithLabel',
	    value: function getValueObjectWithLabel(value) {
	      return _defineProperty({}, this.props.label, value);
	    }
	  }, {
	    key: 'getArrowOffset',
	    value: function getArrowOffset() {
	      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
	    }
	  }, {
	    key: 'setUpdatedValue',
	    value: function setUpdatedValue(value, e) {
	      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
	      this.props.onChange && this.props.onChange(onChangeValue, e);
	
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          }
	        },
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('input', {
	          id: this.inputId,
	          style: styles.input,
	          ref: function ref(input) {
	            return _this2.input = input;
	          },
	          value: this.state.value,
	          onKeyDown: this.handleKeyDown,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          placeholder: this.props.placeholder,
	          spellCheck: 'false'
	        }),
	        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
	          'label',
	          {
	            htmlFor: this.inputId,
	            style: styles.label,
	            onMouseDown: this.handleMouseDown
	          },
	          this.props.label
	        ) : null
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react.PureComponent || _react.Component);
	
	exports.default = EditableInput;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _hue = __webpack_require__(1967);
	
	var hue = _interopRequireWildcard(_hue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_ref) {
	  _inherits(Hue, _ref);
	
	  function Hue() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hue);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
	      var change = hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
	      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$direction = this.props.direction,
	          direction = _props$direction === undefined ? 'horizontal' : _props$direction;
	
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            padding: '0 2px',
	            position: 'relative',
	            height: '100%',
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, { vertical: direction === 'vertical' });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'hue-' + direction,
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'style',
	            null,
	            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Hue;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Raised = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Raised = exports.Raised = function Raised(_ref) {
	  var zDepth = _ref.zDepth,
	      radius = _ref.radius,
	      background = _ref.background,
	      children = _ref.children,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      wrap: {
	        position: 'relative',
	        display: 'inline-block'
	      },
	      content: {
	        position: 'relative'
	      },
	      bg: {
	        absolute: '0px 0px 0px 0px',
	        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
	        borderRadius: radius,
	        background: background
	      }
	    },
	    'zDepth-0': {
	      bg: {
	        boxShadow: 'none'
	      }
	    },
	
	    'zDepth-1': {
	      bg: {
	        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	      }
	    },
	    'zDepth-2': {
	      bg: {
	        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	      }
	    },
	    'zDepth-3': {
	      bg: {
	        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	      }
	    },
	    'zDepth-4': {
	      bg: {
	        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	      }
	    },
	    'zDepth-5': {
	      bg: {
	        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	      }
	    },
	    'square': {
	      bg: {
	        borderRadius: '0'
	      }
	    },
	    'circle': {
	      bg: {
	        borderRadius: '50%'
	      }
	    }
	  }, passedStyles), { 'zDepth-1': zDepth === 1 });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap },
	    _react2.default.createElement('div', { style: styles.bg }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.content },
	      children
	    )
	  );
	};
	
	Raised.propTypes = {
	  background: _propTypes2.default.string,
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
	  radius: _propTypes2.default.number,
	  styles: _propTypes2.default.object
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: 1,
	  radius: 2,
	  styles: {}
	};
	
	exports.default = Raised;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__(1908);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _saturation = __webpack_require__(1969);
	
	var saturation = _interopRequireWildcard(_saturation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_ref) {
	  _inherits(Saturation, _ref);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
	
	    _this.handleChange = function (e) {
	      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation.calculateChange(e, _this.props.hsl, _this.container), e);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e);
	      var renderWindow = _this.getContainerRenderWindow();
	      renderWindow.addEventListener('mousemove', _this.handleChange);
	      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
	      fn(data, e);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.throttle.cancel();
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'getContainerRenderWindow',
	    value: function getContainerRenderWindow() {
	      var container = this.container;
	
	      var renderWindow = window;
	      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
	        renderWindow = renderWindow.parent;
	      }
	      return renderWindow;
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      var renderWindow = this.getContainerRenderWindow();
	      renderWindow.removeEventListener('mousemove', this.handleChange);
	      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _ref2 = this.props.style || {},
	          color = _ref2.color,
	          white = _ref2.white,
	          black = _ref2.black,
	          pointer = _ref2.pointer,
	          circle = _ref2.circle;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        },
	        'custom': {
	          color: color,
	          white: white,
	          black: black,
	          pointer: pointer,
	          circle: circle
	        }
	      }, { 'custom': !!this.props.style });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles.color,
	          ref: function ref(container) {
	            return _this2.container = container;
	          },
	          onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange
	        },
	        _react2.default.createElement(
	          'style',
	          null,
	          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.white, className: 'saturation-white' },
	          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Saturation;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _interaction = __webpack_require__(1968);
	
	var _Checkboard = __webpack_require__(440);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENTER = 13;
	
	var Swatch = exports.Swatch = function Swatch(_ref) {
	  var color = _ref.color,
	      style = _ref.style,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onHover = _ref.onHover,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? color : _ref$title,
	      children = _ref.children,
	      focus = _ref.focus,
	      _ref$focusStyle = _ref.focusStyle,
	      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
	
	  var transparent = color === 'transparent';
	  var styles = (0, _reactcss2.default)({
	    default: {
	      swatch: _extends({
	        background: color,
	        height: '100%',
	        width: '100%',
	        cursor: 'pointer',
	        position: 'relative',
	        outline: 'none'
	      }, style, focus ? focusStyle : {})
	    }
	  });
	
	  var handleClick = function handleClick(e) {
	    return onClick(color, e);
	  };
	  var handleKeyDown = function handleKeyDown(e) {
	    return e.keyCode === ENTER && onClick(color, e);
	  };
	  var handleHover = function handleHover(e) {
	    return onHover(color, e);
	  };
	
	  var optionalEvents = {};
	  if (onHover) {
	    optionalEvents.onMouseOver = handleHover;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({
	      style: styles.swatch,
	      onClick: handleClick,
	      title: title,
	      tabIndex: 0,
	      onKeyDown: handleKeyDown
	    }, optionalEvents),
	    children,
	    transparent && _react2.default.createElement(_Checkboard2.default, {
	      borderRadius: styles.swatch.borderRadius,
	      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
	    })
	  );
	};
	
	exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(132);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	var _CompactColor = __webpack_require__(1937);
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__(1938);
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compact = exports.Compact = function Compact(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      Compact: {
	        background: '#f6f6f6',
	        radius: '4px'
	      },
	      compact: {
	        paddingTop: '5px',
	        paddingLeft: '5px',
	        boxSizing: 'initial',
	        width: '240px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else {
	      onChange(data, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    { style: styles.Compact, styles: passedStyles },
	    _react2.default.createElement(
	      'div',
	      { style: styles.compact, className: 'compact-picker ' + className },
	      _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(colors, function (c) {
	          return _react2.default.createElement(_CompactColor2.default, {
	            key: c,
	            color: c,
	            active: c.toLowerCase() === hex,
	            onClick: handleChange,
	            onSwatchHover: onSwatchHover
	          });
	        }),
	        _react2.default.createElement('div', { style: styles.clear })
	      ),
	      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
	    )
	  );
	};
	
	Compact.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  styles: _propTypes2.default.object
	};
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(98);
	
	var colorUtils = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactColor = exports.CompactColor = function CompactColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        background: color,
	        width: '15px',
	        height: '15px',
	        float: 'left',
	        marginRight: '5px',
	        marginBottom: '5px',
	        position: 'relative',
	        cursor: 'pointer'
	      },
	      dot: {
	        absolute: '5px 5px 5px 5px',
	        background: colorUtils.getContrastingColor(color),
	        borderRadius: '50%',
	        opacity: '0'
	      }
	    },
	    'active': {
	      dot: {
	        opacity: '1'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      dot: {
	        background: '#000'
	      }
	    },
	    'transparent': {
	      dot: {
	        background: '#000'
	      }
	    }
	  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      style: styles.color,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement('div', { style: styles.dot })
	  );
	};
	
	exports.default = CompactColor;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactFields = exports.CompactFields = function CompactFields(_ref) {
	  var hex = _ref.hex,
	      rgb = _ref.rgb,
	      onChange = _ref.onChange;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingBottom: '6px',
	        paddingRight: '5px',
	        position: 'relative'
	      },
	      active: {
	        position: 'absolute',
	        top: '6px',
	        left: '5px',
	        height: '9px',
	        width: '9px',
	        background: hex
	      },
	      HEXwrap: {
	        flex: '6',
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '80%',
	        padding: '0px',
	        paddingLeft: '20%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      HEXlabel: {
	        display: 'none'
	      },
	      RGBwrap: {
	        flex: '3',
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '70%',
	        padding: '0px',
	        paddingLeft: '30%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '3px',
	        left: '0px',
	        lineHeight: '16px',
	        textTransform: 'uppercase',
	        fontSize: '12px',
	        color: '#999'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else {
	      onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement('div', { style: styles.active }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: 'hex',
	      value: hex,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    })
	  );
	};
	
	exports.default = CompactFields;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Github = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(132);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(50);
	
	var _GithubSwatch = __webpack_require__(1940);
	
	var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Github = exports.Github = function Github(_ref) {
	  var width = _ref.width,
	      colors = _ref.colors,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '1px solid rgba(0,0,0,0.2)',
	        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
	        borderRadius: '4px',
	        position: 'relative',
	        padding: '5px',
	        display: 'flex',
	        flexWrap: 'wrap'
	      },
	      triangle: {
	        position: 'absolute',
	        border: '7px solid transparent',
	        borderBottomColor: '#fff'
	      },
	      triangleShadow: {
	        position: 'absolute',
	        border: '8px solid transparent',
	        borderBottomColor: 'rgba(0,0,0,0.15)'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-14px',
	        left: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        left: '9px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-14px',
	        right: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        right: '9px'
	      }
	    },
	    'bottom-left-triangle': {
	      triangle: {
	        top: '35px',
	        left: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        left: '9px',
	        transform: 'rotate(180deg)'
	      }
	    },
	    'bottom-right-triangle': {
	      triangle: {
	        top: '35px',
	        right: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        right: '9px',
	        transform: 'rotate(180deg)'
	      }
	    }
	  }, passedStyles), {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right',
	    'bottom-left-triangle': triangle === 'bottom-left',
	    'bottom-right-triangle': triangle === 'bottom-right'
	  });
	
	  var handleChange = function handleChange(hex, e) {
	    return onChange({ hex: hex, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'github-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_GithubSwatch2.default, {
	        color: c,
	        key: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	Github.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
	  styles: _propTypes2.default.object
	};
	
	Github.defaultProps = {
	  width: 200,
	  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
	  triangle: 'top-left',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Github);

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GithubSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
	  var hover = _ref.hover,
	      color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var hoverSwatch = {
	    position: 'relative',
	    zIndex: '2',
	    outline: '2px solid #fff',
	    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: '25px',
	        height: '25px',
	        fontSize: '0'
	      }
	    },
	    'hover': {
	      swatch: hoverSwatch
	    }
	  }, { hover: hover });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: hoverSwatch
	    })
	  );
	};
	
	exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Google = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(50);
	
	var _GooglePointerCircle = __webpack_require__(1944);
	
	var _GooglePointerCircle2 = _interopRequireDefault(_GooglePointerCircle);
	
	var _GooglePointer = __webpack_require__(1943);
	
	var _GooglePointer2 = _interopRequireDefault(_GooglePointer);
	
	var _GoogleFields = __webpack_require__(1942);
	
	var _GoogleFields2 = _interopRequireDefault(_GoogleFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Google = exports.Google = function Google(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      header = _ref.header,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        background: '#fff',
	        border: '1px solid #dfe1e5',
	        boxSizing: 'initial',
	        display: 'flex',
	        flexWrap: 'wrap',
	        borderRadius: '8px 8px 0px 0px'
	      },
	      head: {
	        height: '57px',
	        width: '100%',
	        paddingTop: '16px',
	        paddingBottom: '16px',
	        paddingLeft: '16px',
	        fontSize: '20px',
	        boxSizing: 'border-box',
	        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
	      },
	      saturation: {
	        width: '70%',
	        padding: '0px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      swatch: {
	        width: '30%',
	        height: '228px',
	        padding: '0px',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      body: {
	        margin: 'auto',
	        width: '95%'
	      },
	      controls: {
	        display: 'flex',
	        boxSizing: 'border-box',
	        height: '52px',
	        paddingTop: '22px'
	      },
	      color: {
	        width: '32px'
	      },
	      hue: {
	        height: '8px',
	        position: 'relative',
	        margin: '0px 16px 0px 16px',
	        width: '100%'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'google-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      header
	    ),
	    _react2.default.createElement('div', { style: styles.swatch }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _GooglePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            radius: '4px',
	            pointer: _GooglePointer2.default,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(_GoogleFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        hsv: hsv,
	        onChange: onChange
	      })
	    )
	  );
	};
	
	Google.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  styles: _propTypes2.default.object,
	  header: _propTypes2.default.string
	
	};
	
	Google.defaultProps = {
	  width: 652,
	  styles: {},
	  header: 'Color picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Google);

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GoogleFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleFields = exports.GoogleFields = function GoogleFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      hsv = _ref.hsv;
	
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.rgb) {
	      var values = data.rgb.split(',');
	      color.isvalidColorString(data.rgb, 'rgb') && onChange({
	        r: values[0],
	        g: values[1],
	        b: values[2],
	        a: 1,
	        source: 'rgb'
	      }, e);
	    } else if (data.hsv) {
	      var _values = data.hsv.split(',');
	      if (color.isvalidColorString(data.hsv, 'hsv')) {
	        _values[2] = _values[2].replace('%', '');
	        _values[1] = _values[1].replace('%', '');
	        _values[0] = _values[0].replace('°', '');
	        if (_values[1] == 1) {
	          _values[1] = 0.01;
	        } else if (_values[2] == 1) {
	          _values[2] = 0.01;
	        }
	        onChange({
	          h: Number(_values[0]),
	          s: Number(_values[1]),
	          v: Number(_values[2]),
	          source: 'hsv'
	        }, e);
	      }
	    } else if (data.hsl) {
	      var _values2 = data.hsl.split(',');
	      if (color.isvalidColorString(data.hsl, 'hsl')) {
	        _values2[2] = _values2[2].replace('%', '');
	        _values2[1] = _values2[1].replace('%', '');
	        _values2[0] = _values2[0].replace('°', '');
	        if (hsvValue[1] == 1) {
	          hsvValue[1] = 0.01;
	        } else if (hsvValue[2] == 1) {
	          hsvValue[2] = 0.01;
	        }
	        onChange({
	          h: Number(_values2[0]),
	          s: Number(_values2[1]),
	          v: Number(_values2[2]),
	          source: 'hsl'
	        }, e);
	      }
	    }
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      wrap: {
	        display: 'flex',
	        height: '100px',
	        marginTop: '4px'
	      },
	      fields: {
	        width: '100%'
	      },
	      column: {
	        paddingTop: '10px',
	        display: 'flex',
	        justifyContent: 'space-between'
	      },
	      double: {
	        padding: '0px 4.4px',
	        boxSizing: 'border-box'
	      },
	      input: {
	        width: '100%',
	        height: '38px',
	        boxSizing: 'border-box',
	        padding: '4px 10% 3px',
	        textAlign: 'center',
	        border: '1px solid #dadce0',
	        fontSize: '11px',
	        textTransform: 'lowercase',
	        borderRadius: '5px',
	        outline: 'none',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      input2: {
	        height: '38px',
	        width: '100%',
	        border: '1px solid #dadce0',
	        boxSizing: 'border-box',
	        fontSize: '11px',
	        textTransform: 'lowercase',
	        borderRadius: '5px',
	        outline: 'none',
	        paddingLeft: '10px',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      label: {
	        textAlign: 'center',
	        fontSize: '12px',
	        background: '#fff',
	        position: 'absolute',
	        textTransform: 'uppercase',
	        color: '#3c4043',
	        width: '35px',
	        top: '-6px',
	        left: '0',
	        right: '0',
	        marginLeft: 'auto',
	        marginRight: 'auto',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      label2: {
	        left: '10px',
	        textAlign: 'center',
	        fontSize: '12px',
	        background: '#fff',
	        position: 'absolute',
	        textTransform: 'uppercase',
	        color: '#3c4043',
	        width: '32px',
	        top: '-6px',
	        fontFamily: 'Roboto,Arial,sans-serif'
	      },
	      single: {
	        flexGrow: '1',
	        margin: '0px 4.4px'
	      }
	    }
	  });
	
	  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
	  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
	  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.fields },
	      _react2.default.createElement(
	        'div',
	        { style: styles.double },
	        _react2.default.createElement(_common.EditableInput, {
	          style: { input: styles.input, label: styles.label },
	          label: 'hex',
	          value: hex,
	          onChange: handleChange
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.column },
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'rgb',
	            value: rgbValue,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'hsv',
	            value: hsvValue,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.single },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { input: styles.input2, label: styles.label2 },
	            label: 'hsl',
	            value: hslValue,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = GoogleFields;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GooglePointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePointer = exports.GooglePointer = function GooglePointer(props) {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '20px',
	        height: '20px',
	        borderRadius: '22px',
	        transform: 'translate(-10px, -7px)',
	        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
	        border: '2px white solid'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	GooglePointer.propTypes = {
	  hsl: _propTypes2.default.shape({
	    h: _propTypes2.default.number,
	    s: _propTypes2.default.number,
	    l: _propTypes2.default.number,
	    a: _propTypes2.default.number
	  })
	};
	
	GooglePointer.defaultProps = {
	  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
	};
	
	exports.default = GooglePointer;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GooglePointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePointerCircle = exports.GooglePointerCircle = function GooglePointerCircle(props) {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '20px',
	        height: '20px',
	        borderRadius: '22px',
	        border: '2px #fff solid',
	        transform: 'translate(-12px, -13px)',
	        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	GooglePointerCircle.propTypes = {
	  hsl: _propTypes2.default.shape({
	    h: _propTypes2.default.number,
	    s: _propTypes2.default.number,
	    l: _propTypes2.default.number,
	    a: _propTypes2.default.number
	  })
	};
	
	GooglePointerCircle.defaultProps = {
	  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
	};
	
	exports.default = GooglePointerCircle;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HuePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(50);
	
	var _HuePointer = __webpack_require__(1946);
	
	var _HuePointer2 = _interopRequireDefault(_HuePointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HuePicker = exports.HuePicker = function HuePicker(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      hsl = _ref.hsl,
	      direction = _ref.direction,
	      pointer = _ref.pointer,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	
	  // Overwrite to provide pure hue color
	  var handleChange = function handleChange(data) {
	    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'hue-picker ' + className },
	    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
	      hsl: hsl,
	      pointer: pointer,
	      onChange: handleChange,
	      direction: direction
	    }))
	  );
	};
	
	HuePicker.propTypes = {
	  styles: _propTypes2.default.object
	};
	HuePicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _HuePointer2.default,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Material = exports.Material = function Material(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      material: {
	        width: '98px',
	        height: '98px',
	        padding: '16px',
	        fontFamily: 'Roboto'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '2px solid ' + hex,
	        outline: 'none',
	        height: '30px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      Hex: {
	        style: {}
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '1px solid #eee',
	        outline: 'none',
	        height: '30px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      split: {
	        display: 'flex',
	        marginRight: '-10px',
	        paddingTop: '11px'
	      },
	      third: {
	        flex: '1',
	        paddingRight: '10px'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    { styles: passedStyles },
	    _react2.default.createElement(
	      'div',
	      { style: styles.material, className: 'material-picker ' + className },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	        label: 'hex',
	        value: hex,
	        onChange: handleChange
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.split, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'r', value: rgb.r,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'g',
	            value: rgb.g,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'b',
	            value: rgb.b,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(50);
	
	var _PhotoshopFields = __webpack_require__(1950);
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__(1952);
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__(1951);
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	var _PhotoshopButton = __webpack_require__(1949);
	
	var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);
	
	var _PhotoshopPreviews = __webpack_require__(1953);
	
	var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$styles = _props.styles,
	          passedStyles = _props$styles === undefined ? {} : _props$styles,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className;
	
	      var styles = (0, _reactcss2.default)((0, _merge2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          }
	        }
	      }, passedStyles));
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker, className: 'photoshop-picker ' + className },
	        _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, {
	              hsl: this.props.hsl,
	              hsv: this.props.hsv,
	              pointer: _PhotoshopPointerCircle2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              direction: 'vertical',
	              hsl: this.props.hsl,
	              pointer: _PhotoshopPointer2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(_PhotoshopPreviews2.default, {
	                  rgb: this.props.rgb,
	                  currentColor: this.state.currentColor
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
	                _react2.default.createElement(_PhotoshopFields2.default, {
	                  onChange: this.props.onChange,
	                  rgb: this.props.rgb,
	                  hsv: this.props.hsv,
	                  hex: this.props.hex
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.propTypes = {
	  header: _propTypes2.default.string,
	  styles: _propTypes2.default.object
	};
	
	Photoshop.defaultProps = {
	  header: 'Color Picker',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopButton = exports.PhotoshopButton = function PhotoshopButton(_ref) {
	  var onClick = _ref.onClick,
	      label = _ref.label,
	      children = _ref.children,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      button: {
	        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	        border: '1px solid #878787',
	        borderRadius: '2px',
	        height: '20px',
	        boxShadow: '0 1px 0 0 #EAEAEA',
	        fontSize: '14px',
	        color: '#000',
	        lineHeight: '20px',
	        textAlign: 'center',
	        marginBottom: '10px',
	        cursor: 'pointer'
	      }
	    },
	    'active': {
	      button: {
	        boxShadow: '0 0 0 1px #878787'
	      }
	    }
	  }, { active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.button, onClick: onClick },
	    label || children
	  );
	};
	
	exports.default = PhotoshopButton;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsv = _ref.hsv,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        paddingTop: '5px',
	        paddingBottom: '9px',
	        width: '80px',
	        position: 'relative'
	      },
	      divider: {
	        height: '5px'
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        marginLeft: '40%',
	        width: '40%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '5px',
	        fontSize: '13px',
	        paddingLeft: '3px',
	        marginRight: '10px'
	      },
	      RGBlabel: {
	        left: '0px',
	        top: '0px',
	        width: '34px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px',
	        position: 'absolute'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        marginLeft: '20%',
	        width: '80%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '6px',
	        fontSize: '13px',
	        paddingLeft: '3px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        width: '14px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px'
	      },
	      fieldSymbols: {
	        position: 'absolute',
	        top: '5px',
	        right: '-7px',
	        fontSize: '13px'
	      },
	      symbol: {
	        height: '20px',
	        lineHeight: '22px',
	        paddingBottom: '7px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data['#']) {
	      color.isValidHex(data['#']) && onChange({
	        hex: data['#'],
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else if (data.h || data.s || data.v) {
	      onChange({
	        h: data.h || hsv.h,
	        s: data.s || hsv.s,
	        v: data.v || hsv.v,
	        source: 'hsv'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields },
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'h',
	      value: Math.round(hsv.h),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 's',
	      value: Math.round(hsv.s * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'v',
	      value: Math.round(hsv.v * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: '#',
	      value: hex.replace('#', ''),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.fieldSymbols },
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '\xB0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = PhotoshopPicker;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      triangle: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '4px 0 4px 6px',
	        borderColor: 'transparent transparent transparent #fff',
	        position: 'absolute',
	        top: '1px',
	        left: '1px'
	      },
	      triangleBorder: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '5px 0 5px 8px',
	        borderColor: 'transparent transparent transparent #555'
	      },
	
	      left: {
	        Extend: 'triangleBorder',
	        transform: 'translate(-13px, -4px)'
	      },
	      leftInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      },
	
	      right: {
	        Extend: 'triangleBorder',
	        transform: 'translate(20px, -14px) rotate(180deg)'
	      },
	      rightInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.pointer },
	    _react2.default.createElement(
	      'div',
	      { style: styles.left },
	      _react2.default.createElement('div', { style: styles.leftInside })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.right },
	      _react2.default.createElement('div', { style: styles.rightInside })
	    )
	  );
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
	  var hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    },
	    'black-outline': {
	      picker: {
	        boxShadow: 'inset 0 0 0 1px #000'
	      }
	    }
	  }, { 'black-outline': hsl.l > 0.5 });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPreviews = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
	  var rgb = _ref.rgb,
	      currentColor = _ref.currentColor;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        border: '1px solid #B3B3B3',
	        borderBottom: '1px solid #F0F0F0',
	        marginBottom: '2px',
	        marginTop: '1px'
	      },
	      new: {
	        height: '34px',
	        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	      },
	      current: {
	        height: '34px',
	        background: currentColor,
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	      },
	      label: {
	        fontSize: '14px',
	        color: '#000',
	        textAlign: 'center'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'new'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement('div', { style: styles.new }),
	      _react2.default.createElement('div', { style: styles.current })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'current'
	    )
	  );
	};
	
	exports.default = PhotoshopPreviews;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(50);
	
	var _SketchFields = __webpack_require__(1955);
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__(1956);
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sketch = exports.Sketch = function Sketch(_ref) {
	  var width = _ref.width,
	      rgb = _ref.rgb,
	      hex = _ref.hex,
	      hsv = _ref.hsv,
	      hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      disableAlpha = _ref.disableAlpha,
	      presetColors = _ref.presetColors,
	      renderers = _ref.renderers,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': _extends({
	      picker: {
	        width: width,
	        padding: '10px 10px 0',
	        boxSizing: 'initial',
	        background: '#fff',
	        borderRadius: '4px',
	        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '75%',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '3px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      controls: {
	        display: 'flex'
	      },
	      sliders: {
	        padding: '4px 0',
	        flex: '1'
	      },
	      color: {
	        width: '24px',
	        height: '24px',
	        position: 'relative',
	        marginTop: '4px',
	        marginLeft: '4px',
	        borderRadius: '3px'
	      },
	      activeColor: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '2px',
	        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      hue: {
	        position: 'relative',
	        height: '10px',
	        overflow: 'hidden'
	      },
	      Hue: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	
	      alpha: {
	        position: 'relative',
	        height: '10px',
	        marginTop: '4px',
	        overflow: 'hidden'
	      },
	      Alpha: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      }
	    }, passedStyles),
	    'disableAlpha': {
	      color: {
	        height: '10px'
	      },
	      hue: {
	        height: '10px'
	      },
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, passedStyles), { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'sketch-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.controls, className: 'flexbox-fix' },
	      _react2.default.createElement(
	        'div',
	        { style: styles.sliders },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            onChange: onChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.Alpha, {
	            style: styles.Alpha,
	            rgb: rgb,
	            hsl: hsl,
	            renderers: renderers,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.color },
	        _react2.default.createElement(_common.Checkboard, null),
	        _react2.default.createElement('div', { style: styles.activeColor })
	      )
	    ),
	    _react2.default.createElement(_SketchFields2.default, {
	      rgb: rgb,
	      hsl: hsl,
	      hex: hex,
	      onChange: onChange,
	      disableAlpha: disableAlpha
	    }),
	    _react2.default.createElement(_SketchPresetColors2.default, {
	      colors: presetColors,
	      onClick: onChange,
	      onSwatchHover: onSwatchHover
	    })
	  );
	};
	
	Sketch.propTypes = {
	  disableAlpha: _propTypes2.default.bool,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  styles: _propTypes2.default.object
	};
	
	Sketch.defaultProps = {
	  disableAlpha: false,
	  width: 200,
	  styles: {},
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-param-reassign */
	
	var SketchFields = exports.SketchFields = function SketchFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      disableAlpha = _ref.disableAlpha;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingTop: '4px'
	      },
	      single: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      alpha: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      double: {
	        flex: '2'
	      },
	      input: {
	        width: '80%',
	        padding: '4px 10% 3px',
	        border: 'none',
	        boxShadow: 'inset 0 0 0 1px #ccc',
	        fontSize: '11px'
	      },
	      label: {
	        display: 'block',
	        textAlign: 'center',
	        fontSize: '11px',
	        color: '#222',
	        paddingTop: '3px',
	        paddingBottom: '4px',
	        textTransform: 'capitalize'
	      }
	    },
	    'disableAlpha': {
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      color.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        a: rgb.a,
	        source: 'rgb'
	      }, e);
	    } else if (data.a) {
	      if (data.a < 0) {
	        data.a = 0;
	      } else if (data.a > 100) {
	        data.a = 100;
	      }
	
	      data.a /= 100;
	      onChange({
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: data.a,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.double },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'hex',
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'r',
	        value: rgb.r,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'g',
	        value: rgb.g,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'b',
	        value: rgb.b,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.alpha },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'a',
	        value: Math.round(rgb.a * 100),
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '100'
	      })
	    )
	  );
	};
	
	exports.default = SketchFields;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
	  var colors = _ref.colors,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      colors: {
	        margin: '0 -10px',
	        padding: '10px 0 0 10px',
	        borderTop: '1px solid #eee',
	        display: 'flex',
	        flexWrap: 'wrap',
	        position: 'relative'
	      },
	      swatchWrap: {
	        width: '16px',
	        height: '16px',
	        margin: '0 10px 10px 0'
	      },
	      swatch: {
	        borderRadius: '3px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	      }
	    },
	    'no-presets': {
	      colors: {
	        display: 'none'
	      }
	    }
	  }, {
	    'no-presets': !colors || !colors.length
	  });
	
	  var handleClick = function handleClick(hex, e) {
	    onClick({
	      hex: hex,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.colors, className: 'flexbox-fix' },
	    colors.map(function (colorObjOrString) {
	      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
	      var key = '' + c.color + (c.title || '');
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: styles.swatchWrap },
	        _react2.default.createElement(_common.Swatch, _extends({}, c, {
	          style: styles.swatch,
	          onClick: handleClick,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
	          }
	        }))
	      );
	    })
	  );
	};
	
	SketchPresetColors.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    color: _propTypes2.default.string,
	    title: _propTypes2.default.string
	  })])).isRequired
	};
	
	exports.default = SketchPresetColors;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _common = __webpack_require__(50);
	
	var _SliderSwatches = __webpack_require__(1960);
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__(1958);
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = exports.Slider = function Slider(_ref) {
	  var hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      pointer = _ref.pointer,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      hue: {
	        height: '12px',
	        position: 'relative'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  }, passedStyles));
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap || {}, className: 'slider-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.hue },
	      _react2.default.createElement(_common.Hue, {
	        style: styles.Hue,
	        hsl: hsl,
	        pointer: pointer,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
	    )
	  );
	};
	
	Slider.propTypes = {
	  styles: _propTypes2.default.object
	};
	Slider.defaultProps = {
	  pointer: _SliderPointer2.default,
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '14px',
	        height: '14px',
	        borderRadius: '6px',
	        transform: 'translate(-7px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
	  var hsl = _ref.hsl,
	      offset = _ref.offset,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      active = _ref.active,
	      first = _ref.first,
	      last = _ref.last;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        height: '12px',
	        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
	        cursor: 'pointer'
	      }
	    },
	    'first': {
	      swatch: {
	        borderRadius: '2px 0 0 2px'
	      }
	    },
	    'last': {
	      swatch: {
	        borderRadius: '0 2px 2px 0'
	      }
	    },
	    'active': {
	      swatch: {
	        transform: 'scaleY(1.8)',
	        borderRadius: '3.6px/2px'
	      }
	    }
	  }, { active: active, first: first, last: last });
	
	  var handleClick = function handleClick(e) {
	    return onClick({
	      h: hsl.h,
	      s: 0.5,
	      l: offset,
	      source: 'hsl'
	    }, e);
	  };
	
	  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
	};
	
	exports.default = SliderSwatch;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _SliderSwatch = __webpack_require__(1959);
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
	  var onClick = _ref.onClick,
	      hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginTop: '20px'
	      },
	      swatch: {
	        boxSizing: 'border-box',
	        width: '20%',
	        paddingRight: '1px',
	        float: 'left'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  // Acceptible difference in floating point equality
	  var epsilon = 0.1;
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.80',
	        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick,
	        first: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.65',
	        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.50',
	        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.35',
	        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.20',
	        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
	        onClick: onClick,
	        last: true
	      })
	    ),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = SliderSwatches;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(132);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _materialColors = __webpack_require__(872);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(50);
	
	var _SwatchesGroup = __webpack_require__(1963);
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swatches = exports.Swatches = function Swatches(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      picker: {
	        width: width,
	        height: height
	      },
	      overflow: {
	        height: height,
	        overflowY: 'scroll'
	      },
	      body: {
	        padding: '16px 0 6px 16px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  }, passedStyles));
	
	  var handleChange = function handleChange(data, e) {
	    return onChange({ hex: data, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'swatches-picker ' + className },
	    _react2.default.createElement(
	      _common.Raised,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: styles.overflow },
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          (0, _map2.default)(colors, function (group) {
	            return _react2.default.createElement(_SwatchesGroup2.default, {
	              key: group.toString(),
	              group: group,
	              active: hex,
	              onClick: handleChange,
	              onSwatchHover: onSwatchHover
	            });
	          }),
	          _react2.default.createElement('div', { style: styles.clear })
	        )
	      )
	    )
	  );
	};
	
	Swatches.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)),
	  styles: _propTypes2.default.object
	
	  /* eslint-disable max-len */
	};Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(98);
	
	var colorUtils = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	var _CheckIcon = __webpack_require__(930);
	
	var _CheckIcon2 = _interopRequireDefault(_CheckIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      first = _ref.first,
	      last = _ref.last,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        width: '40px',
	        height: '24px',
	        cursor: 'pointer',
	        background: color,
	        marginBottom: '1px'
	      },
	      check: {
	        color: colorUtils.getContrastingColor(color),
	        marginLeft: '8px',
	        display: 'none'
	      }
	    },
	    'first': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '2px 2px 0 0'
	      }
	    },
	    'last': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '0 0 2px 2px'
	      }
	    },
	    'active': {
	      check: {
	        display: 'block'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      check: {
	        color: '#333'
	      }
	    },
	    'transparent': {
	      check: {
	        color: '#333'
	      }
	    }
	  }, {
	    first: first,
	    last: last,
	    active: active,
	    'color-#FFFFFF': color === '#FFFFFF',
	    'transparent': color === 'transparent'
	  });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      color: color,
	      style: styles.color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: styles.check },
	      _react2.default.createElement(_CheckIcon2.default, null)
	    )
	  );
	};
	
	exports.default = SwatchesColor;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(132);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _SwatchesColor = __webpack_require__(1962);
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
	  var onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      group = _ref.group,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      group: {
	        paddingBottom: '10px',
	        width: '40px',
	        float: 'left',
	        marginRight: '10px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.group },
	    (0, _map2.default)(group, function (color, i) {
	      return _react2.default.createElement(_SwatchesColor2.default, {
	        key: color,
	        color: color,
	        active: color.toLowerCase() === active,
	        first: i === 0,
	        last: i === group.length - 1,
	        onClick: onClick,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	exports.default = SwatchesGroup;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(26);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(132);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(85);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _color = __webpack_require__(98);
	
	var color = _interopRequireWildcard(_color);
	
	var _common = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Twitter = exports.Twitter = function Twitter(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$styles = _ref.styles,
	      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)((0, _merge2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '0 solid rgba(0,0,0,0.25)',
	        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
	        borderRadius: '4px',
	        position: 'relative'
	      },
	      body: {
	        padding: '15px 9px 9px 15px'
	      },
	      label: {
	        fontSize: '18px',
	        color: '#fff'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent #fff transparent',
	        position: 'absolute'
	      },
	      triangleShadow: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
	        position: 'absolute'
	      },
	      hash: {
	        background: '#F0F0F0',
	        height: '30px',
	        width: '30px',
	        borderRadius: '4px 0 0 4px',
	        float: 'left',
	        color: '#98A1A4',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      input: {
	        width: '100px',
	        fontSize: '14px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '28px',
	        boxShadow: 'inset 0 0 0 1px #F0F0F0',
	        boxSizing: 'content-box',
	        borderRadius: '0 4px 4px 0',
	        float: 'left',
	        paddingLeft: '8px'
	      },
	      swatch: {
	        width: '30px',
	        height: '30px',
	        float: 'left',
	        borderRadius: '4px',
	        margin: '0 6px 6px 0'
	      },
	      clear: {
	        clear: 'both'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-10px',
	        left: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        left: '12px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-10px',
	        right: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        right: '12px'
	      }
	    }
	  }, passedStyles), {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right'
	  });
	
	  var handleChange = function handleChange(hexcode, e) {
	    color.isValidHex(hexcode) && onChange({
	      hex: hexcode,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'twitter-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      (0, _map2.default)(colors, function (c, i) {
	        return _react2.default.createElement(_common.Swatch, {
	          key: i,
	          color: c,
	          hex: c,
	          style: styles.swatch,
	          onClick: handleChange,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: '0 0 4px ' + c
	          }
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.hash },
	        '#'
	      ),
	      _react2.default.createElement(_common.EditableInput, {
	        label: null,
	        style: { input: styles.input },
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      }),
	      _react2.default.createElement('div', { style: styles.clear })
	    )
	  );
	};
	
	Twitter.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  styles: _propTypes2.default.object
	};
	
	Twitter.defaultProps = {
	  width: 276,
	  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
	  triangle: 'top-left',
	  styles: {}
	};
	
	exports.default = (0, _common.ColorWrap)(Twitter);

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (direction === 'vertical') {
	    var a = void 0;
	    if (top < 0) {
	      a = 0;
	    } else if (top > containerHeight) {
	      a = 1;
	    } else {
	      a = Math.round(top * 100 / containerHeight) / 100;
	    }
	
	    if (hsl.a !== a) {
	      return {
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _a = void 0;
	    if (left < 0) {
	      _a = 0;
	    } else if (left > containerWidth) {
	      _a = 1;
	    } else {
	      _a = Math.round(left * 100 / containerWidth) / 100;
	    }
	
	    if (initialA !== _a) {
	      return {
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: _a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	};

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var checkboardCache = {};
	
	var render = exports.render = function render(c1, c2, size, serverCanvas) {
	  if (typeof document === 'undefined' && !serverCanvas) {
	    return null;
	  }
	  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
	  canvas.width = size * 2;
	  canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) {
	    return null;
	  } // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	};
	
	var get = exports.get = function get(c1, c2, size, serverCanvas) {
	  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
	
	  if (checkboardCache[key]) {
	    return checkboardCache[key];
	  }
	
	  var checkboard = render(c1, c2, size, serverCanvas);
	  checkboardCache[key] = checkboard;
	  return checkboard;
	};

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, direction, hsl, container) {
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (direction === 'vertical') {
	    var h = void 0;
	    if (top < 0) {
	      h = 359;
	    } else if (top > containerHeight) {
	      h = 0;
	    } else {
	      var percent = -(top * 100 / containerHeight) + 100;
	      h = 360 * percent / 100;
	    }
	
	    if (hsl.h !== h) {
	      return {
	        h: h,
	        s: hsl.s,
	        l: hsl.l,
	        a: hsl.a,
	        source: 'hsl'
	      };
	    }
	  } else {
	    var _h = void 0;
	    if (left < 0) {
	      _h = 0;
	    } else if (left > containerWidth) {
	      _h = 359;
	    } else {
	      var _percent = left * 100 / containerWidth;
	      _h = 360 * _percent / 100;
	    }
	
	    if (hsl.h !== _h) {
	      return {
	        h: _h,
	        s: hsl.s,
	        l: hsl.l,
	        a: hsl.a,
	        source: 'hsl'
	      };
	    }
	  }
	  return null;
	};

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFocus = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */
	
	
	var handleFocus = exports.handleFocus = function handleFocus(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	  return function (_React$Component) {
	    _inherits(Focus, _React$Component);
	
	    function Focus() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Focus);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
	        return _this.setState({ focus: true });
	      }, _this.handleBlur = function () {
	        return _this.setState({ focus: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Focus, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          Span,
	          { onFocus: this.handleFocus, onBlur: this.handleBlur },
	          _react2.default.createElement(Component, _extends({}, this.props, this.state))
	        );
	      }
	    }]);
	
	    return Focus;
	  }(_react2.default.Component);
	};

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, hsl, container) {
	  var _container$getBoundin = container.getBoundingClientRect(),
	      containerWidth = _container$getBoundin.width,
	      containerHeight = _container$getBoundin.height;
	
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (left < 0) {
	    left = 0;
	  } else if (left > containerWidth) {
	    left = containerWidth;
	  }
	
	  if (top < 0) {
	    top = 0;
	  } else if (top > containerHeight) {
	    top = containerHeight;
	  }
	
	  var saturation = left / containerWidth;
	  var bright = 1 - top / containerHeight;
	
	  return {
	    h: hsl.h,
	    s: saturation,
	    v: bright,
	    a: hsl.a,
	    source: 'hsv'
	  };
	};

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomPicker = exports.GooglePicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;
	
	var _Alpha = __webpack_require__(1920);
	
	Object.defineProperty(exports, 'AlphaPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Block = __webpack_require__(1922);
	
	Object.defineProperty(exports, 'BlockPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Circle = __webpack_require__(1928);
	
	Object.defineProperty(exports, 'CirclePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Chrome = __webpack_require__(1924);
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__(1936);
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Github = __webpack_require__(1939);
	
	Object.defineProperty(exports, 'GithubPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Github).default;
	  }
	});
	
	var _Hue = __webpack_require__(1945);
	
	Object.defineProperty(exports, 'HuePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Material = __webpack_require__(1947);
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__(1948);
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__(1954);
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__(1957);
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__(1961);
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _Twitter = __webpack_require__(1964);
	
	Object.defineProperty(exports, 'TwitterPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitter).default;
	  }
	});
	
	var _Google = __webpack_require__(1941);
	
	Object.defineProperty(exports, 'GooglePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Google).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(879);
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DraggableCore", {
	  enumerable: true,
	  get: function get() {
	    return _DraggableCore.default;
	  }
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(16));
	
	var _clsx2 = _interopRequireDefault(__webpack_require__(1577));
	
	var _domFns = __webpack_require__(441);
	
	var _positionFns = __webpack_require__(882);
	
	var _shims = __webpack_require__(278);
	
	var _DraggableCore = _interopRequireDefault(__webpack_require__(1972));
	
	var _log = _interopRequireDefault(__webpack_require__(881));
	
	var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	//
	// Define <Draggable>
	//
	var Draggable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Draggable, _React$Component);
	
	  var _super = _createSuper(Draggable);
	
	  function Draggable(props
	  /*: DraggableProps*/
	  ) {
	    var _this;
	
	    _classCallCheck(this, Draggable);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
	      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.
	
	      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.
	
	
	      if (shouldStart === false) return false;
	
	      _this.setState({
	        dragging: true,
	        dragged: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
	      if (!_this.state.dragging) return false;
	      (0, _log.default)('Draggable: onDrag: %j', coreData);
	      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        x: uiData.x,
	        y: uiData.y
	      }; // Keep within bounds.
	
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var x = newState.x,
	            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.
	
	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.
	
	        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
	            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];
	
	        newState.x = newStateX;
	        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.
	
	        newState.slackX = _this.state.slackX + (x - newState.x);
	        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.
	
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      } // Short-circuit if user's callback killed it.
	
	
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	
	      if (shouldUpdate === false) return false;
	
	      _this.setState(newState);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
	      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.
	
	      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));
	
	      if (shouldContinue === false) return false;
	      (0, _log.default)('Draggable: onDragStop: %j', coreData);
	      var newState
	      /*: $Shape<DraggableState>*/
	      = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      }; // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	
	      var controlled = Boolean(_this.props.position);
	
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            x = _this$props$position.x,
	            y = _this$props$position.y;
	        newState.x = x;
	        newState.y = y;
	      }
	
	      _this.setState(newState);
	    });
	
	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,
	      // Whether or not we have been dragged before.
	      dragged: false,
	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,
	      prevPropsPosition: _objectSpread({}, props.position),
	      // Used for compensating for out-of-bounds drags
	      slackX: 0,
	      slackY: 0,
	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };
	
	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Draggable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
	        this.setState({
	          isElementSVG: true
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.setState({
	        dragging: false
	      }); // prevents invariant if unmounted while dragging
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
	
	      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: ReactElement<any>*/
	    {
	      var _clsx;
	
	      var _this$props2 = this.props,
	          axis = _this$props2.axis,
	          bounds = _this$props2.bounds,
	          children = _this$props2.children,
	          defaultPosition = _this$props2.defaultPosition,
	          defaultClassName = _this$props2.defaultClassName,
	          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
	          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
	          position = _this$props2.position,
	          positionOffset = _this$props2.positionOffset,
	          scale = _this$props2.scale,
	          draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);
	
	      var style = {};
	      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.
	
	      var controlled = Boolean(position);
	      var draggable = !controlled || this.state.dragging;
	      var validPosition = position || defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
	        // Set top if vertical drag is enabled
	        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
	      }; // If this element was SVG, we use the `transform` attribute.
	
	      if (this.state.isElementSVG) {
	        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
	      } // Mark with class while dragging
	
	
	      var className = (0, _clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	
	      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
	        onStart: this.onDragStart,
	        onDrag: this.onDrag,
	        onStop: this.onDragStop
	      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
	        className: className,
	        style: _objectSpread(_objectSpread({}, children.props.style), style),
	        transform: svgTransform
	      }));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: // React 16.3+
	    // Arity (props, state)
	    function getDerivedStateFromProps(_ref, _ref2)
	    /*: ?$Shape<DraggableState>*/
	    {
	      var position = _ref.position;
	      var prevPropsPosition = _ref2.prevPropsPosition;
	
	      // Set x/y if a new position is provided in props that is different than the previous.
	      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
	        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
	          position: position,
	          prevPropsPosition: prevPropsPosition
	        });
	        return {
	          x: position.x,
	          y: position.y,
	          prevPropsPosition: _objectSpread({}, position)
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Draggable;
	}(React.Component);
	
	exports.default = Draggable;
	
	_defineProperty(Draggable, "displayName", 'Draggable');
	
	_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
	
	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
	    left: _propTypes.default.number,
	    right: _propTypes.default.number,
	    top: _propTypes.default.number,
	    bottom: _propTypes.default.number
	  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
	  defaultClassName: _propTypes.default.string,
	  defaultClassNameDragging: _propTypes.default.string,
	  defaultClassNameDragged: _propTypes.default.string,
	
	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	  positionOffset: _propTypes.default.shape({
	    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  }),
	
	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }),
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	}));
	
	_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: {
	    x: 0,
	    y: 0
	  },
	  scale: 1
	}));

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(16));
	
	var _domFns = __webpack_require__(441);
	
	var _positionFns = __webpack_require__(882);
	
	var _shims = __webpack_require__(278);
	
	var _log = _interopRequireDefault(__webpack_require__(881));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Simple abstraction for dragging events names.
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	}; // Default to mouse events.
	
	var dragEventFor = eventsFor.mouse;
	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/
	
	/*:: export type ControlPosition = {x: number, y: number};*/
	
	/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/
	
	/*:: export type DraggableCoreDefaultProps = {
	  allowAnyClick: boolean,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	  scale: number,
	};*/
	
	/*:: export type DraggableCoreProps = {
	  ...DraggableCoreDefaultProps,
	  cancel: string,
	  children: ReactElement<any>,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  nodeRef?: ?React.ElementRef<any>,
	};*/
	
	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//
	var DraggableCore = /*#__PURE__*/function (_React$Component) {
	  _inherits(DraggableCore, _React$Component);
	
	  var _super = _createSuper(DraggableCore);
	
	  function DraggableCore() {
	    var _this;
	
	    _classCallCheck(this, DraggableCore);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN,
	      lastY: NaN,
	      touchIdentifier: null
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "mounted", false);
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e); // Only accept left-clicks.
	
	
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)
	
	      var thisNode = _this.findDOMNode();
	
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	
	      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.
	
	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
	        return;
	      } // Prevent scrolling on mobile devices, like ipad/iphone.
	      // Important that this is after handle/cancel.
	
	
	      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	
	      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
	
	      _this.setState({
	        touchIdentifier: touchIdentifier
	      }); // Get the current drag point from the event. This is used as the offset.
	
	
	      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return; // not possible but satisfies flow
	
	      var x = position.x,
	          y = position.y; // Create an event object with all the data parents need to make a decision here.
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.
	
	      (0, _log.default)('calling', _this.props.onStart);
	
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	
	      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	
	      _this.setState({
	        dragging: true,
	        lastX: x,
	        lastY: y
	      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	
	
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
	      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
	      // Get the current drag point from the event. This is used as the offset.
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y; // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var deltaX = x - _this.state.lastX,
	            deltaY = y - _this.state.lastY;
	
	        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
	
	        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
	
	        deltaX = _snapToGrid2[0];
	        deltaY = _snapToGrid2[1];
	        if (!deltaX && !deltaY) return; // skip useless drag
	
	        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
	      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.
	
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	
	      if (shouldUpdate === false || _this.mounted === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents')
	          /*: any*/
	          )
	          /*: MouseTouchEvent*/
	          ); // I see why this insanity was deprecated
	          // $FlowIgnore
	
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
	          _this.handleDragStop(event);
	        }
	
	        return;
	      }
	
	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
	      if (!_this.state.dragging) return;
	      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
	      if (position == null) return;
	      var x = position.x,
	          y = position.y; // Snap to grid if prop has been provided
	
	      if (Array.isArray(_this.props.grid)) {
	        var deltaX = x - _this.state.lastX || 0;
	        var deltaY = y - _this.state.lastY || 0;
	
	        var _snapToGrid3 = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
	
	        var _snapToGrid4 = _slicedToArray(_snapToGrid3, 2);
	
	        deltaX = _snapToGrid4[0];
	        deltaY = _snapToGrid4[1];
	        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
	      }
	
	      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler
	
	      var shouldContinue = _this.props.onStop(e, coreEvent);
	
	      if (shouldContinue === false || _this.mounted === false) return false;
	
	      var thisNode = _this.findDOMNode();
	
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
	      }
	
	      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.
	
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });
	
	      if (thisNode) {
	        // Remove event handlers
	        (0, _log.default)('DraggableCore: Removing handlers');
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
	
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
	      dragEventFor = eventsFor.mouse;
	      return _this.handleDragStop(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStart(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;
	      return _this.handleDragStop(e);
	    });
	
	    return _this;
	  }
	
	  _createClass(DraggableCore, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
	      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	
	      var thisNode = this.findDOMNode();
	
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
	          passive: false
	        });
	        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
	      }
	    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
	    // the underlying DOM node ourselves. See the README for more information.
	
	  }, {
	    key: "findDOMNode",
	    value: function findDOMNode()
	    /*: ?HTMLElement*/
	    {
	      var _this$props, _this$props2, _this$props2$nodeRef;
	
	      return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : _reactDom.default.findDOMNode(this);
	    }
	  }, {
	    key: "render",
	    value: function render()
	    /*: React.Element<any>*/
	    {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onMouseUp: this.onMouseUp,
	        // onTouchStart is added on `componentDidMount` so they can be added with
	        // {passive: false}, which allows it to cancel. See
	        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	
	  return DraggableCore;
	}(React.Component);
	
	exports.default = DraggableCore;
	
	_defineProperty(DraggableCore, "displayName", 'DraggableCore');
	
	_defineProperty(DraggableCore, "propTypes", {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: _propTypes.default.bool,
	
	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: _propTypes.default.bool,
	
	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props
	  /*: DraggableCoreProps*/
	  , propName
	  /*: $Keys<DraggableCoreProps>*/
	  ) {
	    if (props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },
	
	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: _propTypes.default.arrayOf(_propTypes.default.number),
	
	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: _propTypes.default.string,
	
	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: _propTypes.default.string,
	
	  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
	   * Unfortunately, in order for <Draggable> to work properly, we need raw access
	   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
	   * as in this example:
	   *
	   * function MyComponent() {
	   *   const nodeRef = React.useRef(null);
	   *   return (
	   *     <Draggable nodeRef={nodeRef}>
	   *       <div ref={nodeRef}>Example Target</div>
	   *     </Draggable>
	   *   );
	   * }
	   *
	   * This can be used for arbitrarily nested components, so long as the ref ends up
	   * pointing to the actual child DOM node and not a custom component.
	   */
	  nodeRef: _propTypes.default.object,
	
	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: _propTypes.default.func,
	
	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: _propTypes.default.func,
	
	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: _propTypes.default.func,
	
	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * `scale`, if set, applies scaling while dragging an element
	   */
	  scale: _propTypes.default.number,
	
	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: _shims.dontSetMe,
	  style: _shims.dontSetMe,
	  transform: _shims.dontSetMe
	});
	
	_defineProperty(DraggableCore, "defaultProps", {
	  allowAnyClick: false,
	  // by default only accept left click
	  disabled: false,
	  enableUserSelectHack: true,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {},
	  scale: 1
	});

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.browserPrefixToKey = browserPrefixToKey;
	exports.browserPrefixToStyle = browserPrefixToStyle;
	exports.default = void 0;
	exports.getPrefix = getPrefix;
	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	
	function getPrefix()
	/*: string*/
	{
	  var _window$document, _window$document$docu;
	
	  var prop
	  /*: string*/
	  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
	  // Ensure we're running in an environment where there is actually a global
	  // `window` obj
	  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
	  // path may not exist, so bail out if it doesn't.
	
	  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
	  if (!style) return '';
	  if (prop in style) return '';
	
	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }
	
	  return '';
	}
	
	function browserPrefixToKey(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
	}
	
	function browserPrefixToStyle(prop
	/*: string*/
	, prefix
	/*: string*/
	)
	/*: string*/
	{
	  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
	}
	
	function kebabToTitleCase(str
	/*: string*/
	)
	/*: string*/
	{
	  var out = '';
	  var shouldCapitalize = true;
	
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	
	  return out;
	} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	
	
	var _default = (getPrefix()
	/*: string*/
	);
	
	exports.default = _default;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _Resizable = _interopRequireDefault(__webpack_require__(883));
	
	var _propTypes2 = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ResizableBox = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ResizableBox, _React$Component);
	
	  function ResizableBox() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      width: _this.props.width,
	      height: _this.props.height,
	      propsWidth: _this.props.width,
	      propsHeight: _this.props.height
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onResize", function (e, data) {
	      var size = data.size;
	
	      if (_this.props.onResize) {
	        e.persist && e.persist();
	
	        _this.setState(size, function () {
	          return _this.props.onResize && _this.props.onResize(e, data);
	        });
	      } else {
	        _this.setState(size);
	      }
	    });
	
	    return _this;
	  }
	
	  ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    // If parent changes height/width, set that in our state.
	    if (state.propsWidth !== props.width || state.propsHeight !== props.height) {
	      return {
	        width: props.width,
	        height: props.height,
	        propsWidth: props.width,
	        propsHeight: props.height
	      };
	    }
	
	    return null;
	  };
	
	  var _proto = ResizableBox.prototype;
	
	  _proto.render = function render() {
	    // Basic wrapper around a Resizable instance.
	    // If you use Resizable directly, you are responsible for updating the child component
	    // with a new width and height.
	    var _this$props = this.props,
	        handle = _this$props.handle,
	        handleSize = _this$props.handleSize,
	        onResize = _this$props.onResize,
	        onResizeStart = _this$props.onResizeStart,
	        onResizeStop = _this$props.onResizeStop,
	        draggableOpts = _this$props.draggableOpts,
	        minConstraints = _this$props.minConstraints,
	        maxConstraints = _this$props.maxConstraints,
	        lockAspectRatio = _this$props.lockAspectRatio,
	        axis = _this$props.axis,
	        width = _this$props.width,
	        height = _this$props.height,
	        resizeHandles = _this$props.resizeHandles,
	        style = _this$props.style,
	        transformScale = _this$props.transformScale,
	        props = _objectWithoutPropertiesLoose(_this$props, ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"]);
	
	    return /*#__PURE__*/React.createElement(_Resizable.default, {
	      axis: axis,
	      draggableOpts: draggableOpts,
	      handle: handle,
	      handleSize: handleSize,
	      height: this.state.height,
	      lockAspectRatio: lockAspectRatio,
	      maxConstraints: maxConstraints,
	      minConstraints: minConstraints,
	      onResizeStart: onResizeStart,
	      onResize: this.onResize,
	      onResizeStop: onResizeStop,
	      resizeHandles: resizeHandles,
	      transformScale: transformScale,
	      width: this.state.width
	    }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
	      style: _objectSpread(_objectSpread({}, style), {}, {
	        width: this.state.width + 'px',
	        height: this.state.height + 'px'
	      })
	    })));
	  };
	
	  return ResizableBox;
	}(React.Component);
	
	exports.default = ResizableBox;
	
	_defineProperty(ResizableBox, "propTypes", _objectSpread(_objectSpread({}, _propTypes2.resizableProps), {}, {
	  children: _propTypes.default.element
	}));

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.cloneElement = cloneElement;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// React.addons.cloneWithProps look-alike that merges style & className.
	function cloneElement(element, props) {
	  if (props.style && element.props.style) {
	    props.style = _objectSpread(_objectSpread({}, element.props.style), props.style);
	  }
	
	  if (props.className && element.props.className) {
	    props.className = element.props.className + " " + props.className;
	  }
	
	  return /*#__PURE__*/_react.default.cloneElement(element, props);
	}

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _raf = __webpack_require__(87);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_PureComponent) {
	  _inherits(Container, _PureComponent);
	
	  function Container() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Container);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.events = ["resize", "scroll", "touchstart", "touchmove", "touchend", "pageshow", "load"], _this.subscribers = [], _this.rafHandle = null, _this.subscribe = function (handler) {
	      _this.subscribers = _this.subscribers.concat(handler);
	    }, _this.unsubscribe = function (handler) {
	      _this.subscribers = _this.subscribers.filter(function (current) {
	        return current !== handler;
	      });
	    }, _this.notifySubscribers = function (evt) {
	      if (!_this.framePending) {
	        var currentTarget = evt.currentTarget;
	
	
	        _this.rafHandle = (0, _raf2.default)(function () {
	          _this.framePending = false;
	
	          var _this$node$getBoundin = _this.node.getBoundingClientRect(),
	              top = _this$node$getBoundin.top,
	              bottom = _this$node$getBoundin.bottom;
	
	          _this.subscribers.forEach(function (handler) {
	            return handler({
	              distanceFromTop: top,
	              distanceFromBottom: bottom,
	              eventSource: currentTarget === window ? document.body : _this.node
	            });
	          });
	        });
	        _this.framePending = true;
	      }
	    }, _this.getParent = function () {
	      return _this.node;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Container, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        subscribe: this.subscribe,
	        unsubscribe: this.unsubscribe,
	        getParent: this.getParent
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.events.forEach(function (event) {
	        return window.addEventListener(event, _this2.notifySubscribers);
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (this.rafHandle) {
	        _raf2.default.cancel(this.rafHandle);
	        this.rafHandle = null;
	      }
	
	      this.events.forEach(function (event) {
	        return window.removeEventListener(event, _this3.notifySubscribers);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement("div", _extends({}, this.props, {
	        ref: function ref(node) {
	          return _this4.node = node;
	        },
	        onScroll: this.notifySubscribers,
	        onTouchStart: this.notifySubscribers,
	        onTouchMove: this.notifySubscribers,
	        onTouchEnd: this.notifySubscribers
	      }));
	    }
	  }]);
	
	  return Container;
	}(_react.PureComponent);
	
	Container.childContextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Container;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sticky = function (_Component) {
	  _inherits(Sticky, _Component);
	
	  function Sticky() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Sticky);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isSticky: false,
	      wasSticky: false,
	      style: {}
	    }, _this.handleContainerEvent = function (_ref2) {
	      var distanceFromTop = _ref2.distanceFromTop,
	          distanceFromBottom = _ref2.distanceFromBottom,
	          eventSource = _ref2.eventSource;
	
	      var parent = _this.context.getParent();
	
	      var preventingStickyStateChanges = false;
	      if (_this.props.relative) {
	        preventingStickyStateChanges = eventSource !== parent;
	        distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this.placeholder.offsetTop;
	      }
	
	      var placeholderClientRect = _this.placeholder.getBoundingClientRect();
	      var contentClientRect = _this.content.getBoundingClientRect();
	      var calculatedHeight = contentClientRect.height;
	
	      var bottomDifference = distanceFromBottom - _this.props.bottomOffset - calculatedHeight;
	
	      var wasSticky = !!_this.state.isSticky;
	      var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this.props.topOffset && distanceFromBottom > -_this.props.bottomOffset;
	
	      distanceFromBottom = (_this.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;
	
	      var style = !isSticky ? {} : {
	        position: "fixed",
	        top: bottomDifference > 0 ? _this.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference,
	        left: placeholderClientRect.left,
	        width: placeholderClientRect.width
	      };
	
	      if (!_this.props.disableHardwareAcceleration) {
	        style.transform = "translateZ(0)";
	      }
	
	      _this.setState({
	        isSticky: isSticky,
	        wasSticky: wasSticky,
	        distanceFromTop: distanceFromTop,
	        distanceFromBottom: distanceFromBottom,
	        calculatedHeight: calculatedHeight,
	        style: style
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sticky, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");
	
	      this.context.subscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.context.unsubscribe(this.handleContainerEvent);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + "px";
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var element = _react2.default.cloneElement(this.props.children({
	        isSticky: this.state.isSticky,
	        wasSticky: this.state.wasSticky,
	        distanceFromTop: this.state.distanceFromTop,
	        distanceFromBottom: this.state.distanceFromBottom,
	        calculatedHeight: this.state.calculatedHeight,
	        style: this.state.style
	      }), {
	        ref: function ref(content) {
	          _this2.content = _reactDom2.default.findDOMNode(content);
	        }
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement("div", { ref: function ref(placeholder) {
	            return _this2.placeholder = placeholder;
	          } }),
	        element
	      );
	    }
	  }]);
	
	  return Sticky;
	}(_react.Component);
	
	Sticky.propTypes = {
	  topOffset: _propTypes2.default.number,
	  bottomOffset: _propTypes2.default.number,
	  relative: _propTypes2.default.bool,
	  children: _propTypes2.default.func.isRequired
	};
	Sticky.defaultProps = {
	  relative: false,
	  topOffset: 0,
	  bottomOffset: 0,
	  disableCompensation: false,
	  disableHardwareAcceleration: false
	};
	Sticky.contextTypes = {
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func,
	  getParent: _propTypes2.default.func
	};
	exports.default = Sticky;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StickyContainer = exports.Sticky = undefined;
	
	var _Sticky = __webpack_require__(1977);
	
	var _Sticky2 = _interopRequireDefault(_Sticky);
	
	var _Container = __webpack_require__(1976);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sticky = _Sticky2.default;
	exports.StickyContainer = _Container2.default;
	exports.default = _Sticky2.default;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoprefix = undefined;
	
	var _forOwn2 = __webpack_require__(438);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  borderRadius: function borderRadius(value) {
	    return {
	      msBorderRadius: value,
	      MozBorderRadius: value,
	      OBorderRadius: value,
	      WebkitBorderRadius: value,
	      borderRadius: value
	    };
	  },
	  boxShadow: function boxShadow(value) {
	    return {
	      msBoxShadow: value,
	      MozBoxShadow: value,
	      OBoxShadow: value,
	      WebkitBoxShadow: value,
	      boxShadow: value
	    };
	  },
	  userSelect: function userSelect(value) {
	    return {
	      WebkitTouchCallout: value,
	      KhtmlUserSelect: value,
	      MozUserSelect: value,
	      msUserSelect: value,
	      WebkitUserSelect: value,
	      userSelect: value
	    };
	  },
	
	  flex: function flex(value) {
	    return {
	      WebkitBoxFlex: value,
	      MozBoxFlex: value,
	      WebkitFlex: value,
	      msFlex: value,
	      flex: value
	    };
	  },
	  flexBasis: function flexBasis(value) {
	    return {
	      WebkitFlexBasis: value,
	      flexBasis: value
	    };
	  },
	  justifyContent: function justifyContent(value) {
	    return {
	      WebkitJustifyContent: value,
	      justifyContent: value
	    };
	  },
	
	  transition: function transition(value) {
	    return {
	      msTransition: value,
	      MozTransition: value,
	      OTransition: value,
	      WebkitTransition: value,
	      transition: value
	    };
	  },
	
	  transform: function transform(value) {
	    return {
	      msTransform: value,
	      MozTransform: value,
	      OTransform: value,
	      WebkitTransform: value,
	      transform: value
	    };
	  },
	  absolute: function absolute(value) {
	    var direction = value && value.split(' ');
	    return {
	      position: 'absolute',
	      top: direction && direction[0],
	      right: direction && direction[1],
	      bottom: direction && direction[2],
	      left: direction && direction[3]
	    };
	  },
	  extend: function extend(name, otherElementStyles) {
	    var otherStyle = otherElementStyles[name];
	    if (otherStyle) {
	      return otherStyle;
	    }
	    return {
	      'extend': name
	    };
	  }
	};
	
	var autoprefix = exports.autoprefix = function autoprefix(elements) {
	  var prefixed = {};
	  (0, _forOwn3.default)(elements, function (styles, element) {
	    var expanded = {};
	    (0, _forOwn3.default)(styles, function (value, key) {
	      var transform = transforms[key];
	      if (transform) {
	        expanded = _extends({}, expanded, transform(value));
	      } else {
	        expanded[key] = value;
	      }
	    });
	    prefixed[element] = expanded;
	  });
	  return prefixed;
	};
	
	exports.default = autoprefix;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.active = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var active = exports.active = function active(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Active, _React$Component);
	
	    function Active() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Active);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
	        return _this.setState({ active: true });
	      }, _this.handleMouseUp = function () {
	        return _this.setState({ active: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Active;
	  }(_react2.default.Component);
	};
	
	exports.default = active;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hover = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hover = exports.hover = function hover(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Hover, _React$Component);
	
	    function Hover() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hover);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
	        return _this.setState({ hover: true });
	      }, _this.handleMouseOut = function () {
	        return _this.setState({ hover: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Hover;
	  }(_react2.default.Component);
	};
	
	exports.default = hover;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flattenNames = undefined;
	
	var _isString2 = __webpack_require__(2098);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _forOwn2 = __webpack_require__(438);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _isPlainObject2 = __webpack_require__(2097);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _map2 = __webpack_require__(132);
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenNames = exports.flattenNames = function flattenNames() {
	  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = [];
	
	  (0, _map3.default)(things, function (thing) {
	    if (Array.isArray(thing)) {
	      flattenNames(thing).map(function (name) {
	        return names.push(name);
	      });
	    } else if ((0, _isPlainObject3.default)(thing)) {
	      (0, _forOwn3.default)(thing, function (value, key) {
	        value === true && names.push(key);
	        names.push(key + '-' + value);
	      });
	    } else if ((0, _isString3.default)(thing)) {
	      names.push(thing);
	    }
	  });
	
	  return names;
	};
	
	exports.default = flattenNames;

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopable = function loopable(i, length) {
	  var props = {};
	  var setProp = function setProp(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    props[name] = value;
	  };
	
	  i === 0 && setProp('first-child');
	  i === length - 1 && setProp('last-child');
	  (i === 0 || i % 2 === 0) && setProp('even');
	  Math.abs(i % 2) === 1 && setProp('odd');
	  setProp('nth-child', i);
	
	  return props;
	};
	
	exports.default = loopable;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeClasses = undefined;
	
	var _forOwn2 = __webpack_require__(438);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _cloneDeep2 = __webpack_require__(1902);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
	  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
	  activeNames.map(function (name) {
	    var toMerge = classes[name];
	    if (toMerge) {
	      (0, _forOwn3.default)(toMerge, function (value, key) {
	        if (!styles[key]) {
	          styles[key] = {};
	        }
	
	        styles[key] = _extends({}, styles[key], toMerge[key]);
	      });
	    }
	
	    return name;
	  });
	  return styles;
	};
	
	exports.default = mergeClasses;

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	
	var id = 1;
	
	/**
	 * generate unique id in application
	 * @return {string}
	 */
	var _default = function _default() {
	  return "".concat(id++);
	};
	exports["default"] = _default;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ver = exports.clear = exports.bind = void 0;
	var _sensorPool = __webpack_require__(1987);
	/**
	 * Created by hustcc on 18/6/9.[高考时间]
	 * Contract: i@hust.cc
	 */
	
	/**
	 * bind an element with resize callback function
	 * @param {*} element
	 * @param {*} cb
	 */
	var bind = function bind(element, cb) {
	  var sensor = (0, _sensorPool.getSensor)(element);
	
	  // listen with callback
	  sensor.bind(cb);
	
	  // return unbind function
	  return function () {
	    sensor.unbind(cb);
	  };
	};
	
	/**
	 * clear all the listener and sensor of an element
	 * @param element
	 */
	exports.bind = bind;
	var clear = function clear(element) {
	  var sensor = (0, _sensorPool.getSensor)(element);
	  (0, _sensorPool.removeSensor)(sensor);
	};
	exports.clear = clear;
	var ver = "1.0.2";
	exports.ver = ver;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeSensor = exports.getSensor = exports.Sensors = void 0;
	var _id = _interopRequireDefault(__webpack_require__(1985));
	var _sensors = __webpack_require__(1988);
	var _constant = __webpack_require__(443);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	
	/**
	 * all the sensor objects.
	 * sensor pool
	 */
	var Sensors = {};
	
	/**
	 * When destroy the sensor, remove it from the pool
	 */
	exports.Sensors = Sensors;
	function clean(sensorId) {
	  // exist, then remove from pool
	  if (sensorId && Sensors[sensorId]) {
	    delete Sensors[sensorId];
	  }
	}
	
	/**
	 * get one sensor
	 * @param element
	 * @returns {*}
	 */
	var getSensor = function getSensor(element) {
	  var sensorId = element.getAttribute(_constant.SizeSensorId);
	
	  // 1. if the sensor exists, then use it
	  if (sensorId && Sensors[sensorId]) {
	    return Sensors[sensorId];
	  }
	
	  // 2. not exist, then create one
	  var newId = (0, _id["default"])();
	  element.setAttribute(_constant.SizeSensorId, newId);
	  var sensor = (0, _sensors.createSensor)(element, function () {
	    return clean(newId);
	  });
	  // add sensor into pool
	  Sensors[newId] = sensor;
	  return sensor;
	};
	
	/**
	 * 移除 sensor
	 * @param sensor
	 */
	exports.getSensor = getSensor;
	var removeSensor = function removeSensor(sensor) {
	  var sensorId = sensor.element.getAttribute(_constant.SizeSensorId);
	  // remove event, dom of the sensor used
	  sensor.destroy();
	  clean(sensorId);
	};
	exports.removeSensor = removeSensor;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSensor = void 0;
	var _object = __webpack_require__(1989);
	var _resizeObserver = __webpack_require__(1990);
	/**
	 * Created by hustcc on 18/7/5.
	 * Contract: i@hust.cc
	 */
	
	/**
	 * sensor strategies
	 */
	// export const createSensor = createObjectSensor;
	var createSensor = typeof ResizeObserver !== 'undefined' ? _resizeObserver.createSensor : _object.createSensor;
	exports.createSensor = createSensor;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSensor = void 0;
	var _debounce = _interopRequireDefault(__webpack_require__(885));
	var _constant = __webpack_require__(443);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	/**
	 * Created by hustcc on 18/6/9.
	 * Contract: i@hust.cc
	 */
	
	var createSensor = function createSensor(element, whenDestroy) {
	  var sensor = undefined;
	  // callback
	  var listeners = [];
	
	  /**
	   * create object DOM of sensor
	   * @returns {HTMLObjectElement}
	   */
	  var newSensor = function newSensor() {
	    // adjust style
	    if (getComputedStyle(element).position === 'static') {
	      element.style.position = 'relative';
	    }
	    var obj = document.createElement('object');
	    obj.onload = function () {
	      obj.contentDocument.defaultView.addEventListener('resize', resizeListener);
	      // 直接触发一次 resize
	      resizeListener();
	    };
	    obj.style.display = 'block';
	    obj.style.position = 'absolute';
	    obj.style.top = '0';
	    obj.style.left = '0';
	    obj.style.height = '100%';
	    obj.style.width = '100%';
	    obj.style.overflow = 'hidden';
	    obj.style.pointerEvents = 'none';
	    obj.style.zIndex = '-1';
	    obj.style.opacity = '0';
	    obj.setAttribute('class', _constant.SensorClassName);
	    obj.setAttribute('tabindex', _constant.SensorTabIndex);
	    obj.type = 'text/html';
	
	    // append into dom
	    element.appendChild(obj);
	    // for ie, should set data attribute delay, or will be white screen
	    obj.data = 'about:blank';
	    return obj;
	  };
	
	  /**
	   * trigger listeners
	   */
	  var resizeListener = (0, _debounce["default"])(function () {
	    // trigger all listener
	    listeners.forEach(function (listener) {
	      listener(element);
	    });
	  });
	
	  /**
	   * listen with one callback function
	   * @param cb
	   */
	  var bind = function bind(cb) {
	    // if not exist sensor, then create one
	    if (!sensor) {
	      sensor = newSensor();
	    }
	    if (listeners.indexOf(cb) === -1) {
	      listeners.push(cb);
	    }
	  };
	
	  /**
	   * destroy all
	   */
	  var destroy = function destroy() {
	    if (sensor && sensor.parentNode) {
	      if (sensor.contentDocument) {
	        // remote event
	        sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
	      }
	      // remove dom
	      sensor.parentNode.removeChild(sensor);
	      // initial variable
	      element.removeAttribute(_constant.SizeSensorId);
	      sensor = undefined;
	      listeners = [];
	      whenDestroy && whenDestroy();
	    }
	  };
	
	  /**
	   * cancel listener bind
	   * @param cb
	   */
	  var unbind = function unbind(cb) {
	    var idx = listeners.indexOf(cb);
	    if (idx !== -1) {
	      listeners.splice(idx, 1);
	    }
	
	    // no listener, and sensor is exist
	    // then destroy the sensor
	    if (listeners.length === 0 && sensor) {
	      destroy();
	    }
	  };
	  return {
	    element: element,
	    bind: bind,
	    destroy: destroy,
	    unbind: unbind
	  };
	};
	exports.createSensor = createSensor;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSensor = void 0;
	var _constant = __webpack_require__(443);
	var _debounce = _interopRequireDefault(__webpack_require__(885));
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	/**
	 * Created by hustcc on 18/7/5.
	 * Contract: i@hust.cc
	 */
	
	var createSensor = function createSensor(element, whenDestroy) {
	  var sensor = undefined;
	  // callback
	  var listeners = [];
	
	  /**
	   * trigger listeners
	   */
	  var resizeListener = (0, _debounce["default"])(function () {
	    // trigger all
	    listeners.forEach(function (listener) {
	      listener(element);
	    });
	  });
	
	  /**
	   * create ResizeObserver sensor
	   * @returns
	   */
	  var newSensor = function newSensor() {
	    var s = new ResizeObserver(resizeListener);
	    // listen element
	    s.observe(element);
	
	    // trigger once
	    resizeListener();
	    return s;
	  };
	
	  /**
	   * listen with callback
	   * @param cb
	   */
	  var bind = function bind(cb) {
	    if (!sensor) {
	      sensor = newSensor();
	    }
	    if (listeners.indexOf(cb) === -1) {
	      listeners.push(cb);
	    }
	  };
	
	  /**
	   * destroy
	   */
	  var destroy = function destroy() {
	    sensor.disconnect();
	    listeners = [];
	    sensor = undefined;
	    element.removeAttribute(_constant.SizeSensorId);
	    whenDestroy && whenDestroy();
	  };
	
	  /**
	   * cancel bind
	   * @param cb
	   */
	  var unbind = function unbind(cb) {
	    var idx = listeners.indexOf(cb);
	    if (idx !== -1) {
	      listeners.splice(idx, 1);
	    }
	
	    // no listener, and sensor is exist
	    // then destroy the sensor
	    if (listeners.length === 0 && sensor) {
	      destroy();
	    }
	  };
	  return {
	    element: element,
	    bind: bind,
	    destroy: destroy,
	    unbind: unbind
	  };
	};
	exports.createSensor = createSensor;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1579);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/dist/cjs.js!./DlCard.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/dist/cjs.js!./DlCard.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1580);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/dist/cjs.js!./DlMenu.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/dist/cjs.js!./DlMenu.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1581);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/dist/cjs.js!./Notice.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/dist/cjs.js!./Notice.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1582);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/dist/cjs.js!./indexPage.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/dist/cjs.js!./indexPage.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1583);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!../../../../../less-loader/dist/cjs.js!./editor.less", function() {
				var newContent = require("!!../../../../../css-loader/index.js!../../../../../less-loader/dist/cjs.js!./editor.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1584);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!../../less-loader/dist/cjs.js!./sgiEditor.less", function() {
				var newContent = require("!!../../css-loader/index.js!../../less-loader/dist/cjs.js!./sgiEditor.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1591);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!./jsoneditor.min.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!./jsoneditor.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1592);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!./foldgutter.css", function() {
				var newContent = require("!!../../../../../css-loader/index.js!./foldgutter.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1593);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!./show-hint.css", function() {
				var newContent = require("!!../../../../../css-loader/index.js!./show-hint.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1594);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!./lint.css", function() {
				var newContent = require("!!../../../../../css-loader/index.js!./lint.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1595);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../css-loader/index.js!./matchesonscrollbar.css", function() {
				var newContent = require("!!../../../../../css-loader/index.js!./matchesonscrollbar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1596);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js!./codemirror.css", function() {
				var newContent = require("!!../../../../css-loader/index.js!./codemirror.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1597);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules!./Login.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules!./Login.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1598);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules!./index.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1599);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules!./index.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1601);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules!./Main.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules!./Main.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1602);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules!./empty.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules!./empty.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1603);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules!./index.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1604);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules!./index.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1605);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules!./Login.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules!./Login.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1607);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../css-loader/index.js?modules!./antd.css", function() {
				var newContent = require("!!../../../../css-loader/index.js?modules!./antd.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1608);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(43)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js?modules!./SgiImg.css", function() {
				var newContent = require("!!../../css-loader/index.js?modules!./SgiImg.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2014 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2017 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2018 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2019 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8429a471b70855f7098ff5a682b1d608.png";

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2028 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2033 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAALCAYAAAAjg+5nAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMdJREFUeNrMlssNxCAMBWHvFABt0ACdQwOUARRAAawcKRLkt2Assj5x8psxSRxeSmE9FWMsSinOCMs5t4ULIZjWGt3He89yztvZGPPIyHuEQXY/U0rXfVNKKGmQlVKyXr5PLxQAHSEpC6ABfka2px5vuJaF6dcB1I/3MWtEdoTlVvgO4B+kZxguhX8Fvyk9m30SXjFlrDRFZiO86j3CSFNl8RBCc8Wj6+HqS0klX0tTDbYRXrULsbuaoi+31i7/28FIUw3xK8AAb7fRai8N7gIAAAAASUVORK5CYII="

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABzUlEQVQ4jZWRv4pTQRTGf2fmkk1EkqAY8ggiim8gNgn4DPEJtBJsLG0FsdROBLGwtLyQWoQUsmAlaAp1myVIJjf338wcC3N3EzYr6wcDM8x8v/nOOcJG0+n0LnCHfyjG+Hk0Gn3Ye5mm6dOyLNU5p1mWqXNOnXO6Wq3UOafL5VJns1lI0/T+ti/ZPtR1TZ7nAKgqACKCqqKqDAYDMxwO36Rpyng8fgtgtgEigrUWay3GmJ0lIiwWC6qqMv1+/3Xj3Umw/diYU7aqYq1lMBigqvR6vRPfDqBJsE8iQpL8fV6W5f4eGGPOBZynCye4MGC7doDDH+9x9VeW2TH3br74f4APOe1LBa4o+PLuMZevDPnlTm1nxtjMPcZIjBFVRUQRoG0LrnV/U+dufwLgxOy93+wDwZcEjRAi6j2HeYdnn76Fj99/PjJbRgMQY6Sua6qqoqoqvA8UviCoJ/pAXOcUKuTdqwDdpNPpGGtte71et+fz+ZkmlWXJ2uT4GFAP9WoNwDKPqKpNrLUGMJPJ5LmqvtyU1SQzT17dfnjj1vUHZV4Wq4xETCtR1So7Pmpp8Ejz08HBAa1WywCEEEiSpCkpAdoiYjbgqKpRRHyMsfgDWrD7zzxxYpgAAAAASUVORK5CYII="

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAA6klEQVQY05WRzwqCQBCH94GiS+Ah6A8EXXwQ7wsqKGqCStAz9B7R2TqZdpAMCopOvUPQ9huZhfLW4WOY3367jKNwXVeAAliO44ggCESSJG2lHvkCbMjTogInHA468gz5DbzJI9kCD7qAwyMkg+U5+jM/VJMneIwxuNi2rSCVWZatURvqkR+AocdowSsT3/f3kBSqCsOQ6ha5oZ1vWcRxvCJZStnKURRJ/shfGZh4qSSZINnzvBz5tCub4M4z52maLlErnrnWF/Qen7yNHaQ+b2OEvuJtXMkTvHAKChz2OnseIm/Aizzxzx/8AIvX4+gc2zPQAAAAAElFTkSuQmCC"

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpDMjMxMkI1RkY1ODZFMjExQkMwRkRBNzgyOEVCNzkwOCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo4Mjg5N0RBQ0I4NjgxMUUyOTc0NTlDMjIxODU5QjEwQSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4Mjg5N0RBQkI4NjgxMUUyOTc0NTlDMjIxODU5QjEwQSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1MzQyRDY5NERDQjdFMjExOEZBNUEwMUM5QzExOEVDOCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDMjMxMkI1RkY1ODZFMjExQkMwRkRBNzgyOEVCNzkwOCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pt5VKcYAAAAGUExURf///5O37kahItcAAAAySURBVHjaYmBEBwzkizBAxCEUEhsmzggTYmBANYeBgYGRgAiGLgyTsdhOJX+hAIAAAwCa7wEE/reQUwAAAABJRU5ErkJggg=="

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAAEsCAYAAAD93j5yAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKTWlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVN3WJP3Fj7f92UPVkLY8LGXbIEAIiOsCMgQWaIQkgBhhBASQMWFiApWFBURnEhVxILVCkidiOKgKLhnQYqIWotVXDjuH9yntX167+3t+9f7vOec5/zOec8PgBESJpHmomoAOVKFPDrYH49PSMTJvYACFUjgBCAQ5svCZwXFAADwA3l4fnSwP/wBr28AAgBw1S4kEsfh/4O6UCZXACCRAOAiEucLAZBSAMguVMgUAMgYALBTs2QKAJQAAGx5fEIiAKoNAOz0ST4FANipk9wXANiiHKkIAI0BAJkoRyQCQLsAYFWBUiwCwMIAoKxAIi4EwK4BgFm2MkcCgL0FAHaOWJAPQGAAgJlCLMwAIDgCAEMeE80DIEwDoDDSv+CpX3CFuEgBAMDLlc2XS9IzFLiV0Bp38vDg4iHiwmyxQmEXKRBmCeQinJebIxNI5wNMzgwAABr50cH+OD+Q5+bk4eZm52zv9MWi/mvwbyI+IfHf/ryMAgQAEE7P79pf5eXWA3DHAbB1v2upWwDaVgBo3/ldM9sJoFoK0Hr5i3k4/EAenqFQyDwdHAoLC+0lYqG9MOOLPv8z4W/gi372/EAe/tt68ABxmkCZrcCjg/1xYW52rlKO58sEQjFu9+cj/seFf/2OKdHiNLFcLBWK8ViJuFAiTcd5uVKRRCHJleIS6X8y8R+W/QmTdw0ArIZPwE62B7XLbMB+7gECiw5Y0nYAQH7zLYwaC5EAEGc0Mnn3AACTv/mPQCsBAM2XpOMAALzoGFyolBdMxggAAESggSqwQQcMwRSswA6cwR28wBcCYQZEQAwkwDwQQgbkgBwKoRiWQRlUwDrYBLWwAxqgEZrhELTBMTgN5+ASXIHrcBcGYBiewhi8hgkEQcgIE2EhOogRYo7YIs4IF5mOBCJhSDSSgKQg6YgUUSLFyHKkAqlCapFdSCPyLXIUOY1cQPqQ28ggMor8irxHMZSBslED1AJ1QLmoHxqKxqBz0XQ0D12AlqJr0Rq0Hj2AtqKn0UvodXQAfYqOY4DRMQ5mjNlhXIyHRWCJWBomxxZj5Vg1Vo81Yx1YN3YVG8CeYe8IJAKLgBPsCF6EEMJsgpCQR1hMWEOoJewjtBK6CFcJg4Qxwicik6hPtCV6EvnEeGI6sZBYRqwm7iEeIZ4lXicOE1+TSCQOyZLkTgohJZAySQtJa0jbSC2kU6Q+0hBpnEwm65Btyd7kCLKArCCXkbeQD5BPkvvJw+S3FDrFiOJMCaIkUqSUEko1ZT/lBKWfMkKZoKpRzame1AiqiDqfWkltoHZQL1OHqRM0dZolzZsWQ8ukLaPV0JppZ2n3aC/pdLoJ3YMeRZfQl9Jr6Afp5+mD9HcMDYYNg8dIYigZaxl7GacYtxkvmUymBdOXmchUMNcyG5lnmA+Yb1VYKvYqfBWRyhKVOpVWlX6V56pUVXNVP9V5qgtUq1UPq15WfaZGVbNQ46kJ1Bar1akdVbupNq7OUndSj1DPUV+jvl/9gvpjDbKGhUaghkijVGO3xhmNIRbGMmXxWELWclYD6yxrmE1iW7L57Ex2Bfsbdi97TFNDc6pmrGaRZp3mcc0BDsax4PA52ZxKziHODc57LQMtPy2x1mqtZq1+rTfaetq+2mLtcu0W7eva73VwnUCdLJ31Om0693UJuja6UbqFutt1z+o+02PreekJ9cr1Dund0Uf1bfSj9Rfq79bv0R83MDQINpAZbDE4Y/DMkGPoa5hpuNHwhOGoEctoupHEaKPRSaMnuCbuh2fjNXgXPmasbxxirDTeZdxrPGFiaTLbpMSkxeS+Kc2Ua5pmutG003TMzMgs3KzYrMnsjjnVnGueYb7ZvNv8jYWlRZzFSos2i8eW2pZ8ywWWTZb3rJhWPlZ5VvVW16xJ1lzrLOtt1ldsUBtXmwybOpvLtqitm63Edptt3xTiFI8p0in1U27aMez87ArsmuwG7Tn2YfYl9m32zx3MHBId1jt0O3xydHXMdmxwvOuk4TTDqcSpw+lXZxtnoXOd8zUXpkuQyxKXdpcXU22niqdun3rLleUa7rrStdP1o5u7m9yt2W3U3cw9xX2r+00umxvJXcM970H08PdY4nHM452nm6fC85DnL152Xlle+70eT7OcJp7WMG3I28Rb4L3Le2A6Pj1l+s7pAz7GPgKfep+Hvqa+It89viN+1n6Zfgf8nvs7+sv9j/i/4XnyFvFOBWABwQHlAb2BGoGzA2sDHwSZBKUHNQWNBbsGLww+FUIMCQ1ZH3KTb8AX8hv5YzPcZyya0RXKCJ0VWhv6MMwmTB7WEY6GzwjfEH5vpvlM6cy2CIjgR2yIuB9pGZkX+X0UKSoyqi7qUbRTdHF09yzWrORZ+2e9jvGPqYy5O9tqtnJ2Z6xqbFJsY+ybuIC4qriBeIf4RfGXEnQTJAntieTE2MQ9ieNzAudsmjOc5JpUlnRjruXcorkX5unOy553PFk1WZB8OIWYEpeyP+WDIEJQLxhP5aduTR0T8oSbhU9FvqKNolGxt7hKPJLmnVaV9jjdO31D+miGT0Z1xjMJT1IreZEZkrkj801WRNberM/ZcdktOZSclJyjUg1plrQr1zC3KLdPZisrkw3keeZtyhuTh8r35CP5c/PbFWyFTNGjtFKuUA4WTC+oK3hbGFt4uEi9SFrUM99m/ur5IwuCFny9kLBQuLCz2Lh4WfHgIr9FuxYji1MXdy4xXVK6ZHhp8NJ9y2jLspb9UOJYUlXyannc8o5Sg9KlpUMrglc0lamUycturvRauWMVYZVkVe9ql9VbVn8qF5VfrHCsqK74sEa45uJXTl/VfPV5bdra3kq3yu3rSOuk626s91m/r0q9akHV0IbwDa0b8Y3lG19tSt50oXpq9Y7NtM3KzQM1YTXtW8y2rNvyoTaj9nqdf13LVv2tq7e+2Sba1r/dd3vzDoMdFTve75TsvLUreFdrvUV99W7S7oLdjxpiG7q/5n7duEd3T8Wej3ulewf2Re/ranRvbNyvv7+yCW1SNo0eSDpw5ZuAb9qb7Zp3tXBaKg7CQeXBJ9+mfHvjUOihzsPcw83fmX+39QjrSHkr0jq/dawto22gPaG97+iMo50dXh1Hvrf/fu8x42N1xzWPV56gnSg98fnkgpPjp2Snnp1OPz3Umdx590z8mWtdUV29Z0PPnj8XdO5Mt1/3yfPe549d8Lxw9CL3Ytslt0utPa49R35w/eFIr1tv62X3y+1XPK509E3rO9Hv03/6asDVc9f41y5dn3m978bsG7duJt0cuCW69fh29u0XdwruTNxdeo94r/y+2v3qB/oP6n+0/rFlwG3g+GDAYM/DWQ/vDgmHnv6U/9OH4dJHzEfVI0YjjY+dHx8bDRq98mTOk+GnsqcTz8p+Vv9563Or59/94vtLz1j82PAL+YvPv655qfNy76uprzrHI8cfvM55PfGm/K3O233vuO+638e9H5ko/ED+UPPR+mPHp9BP9z7nfP78L/eE8/sl0p8zAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAECSSURBVHja7J13WFPX/8ffgbBEKThAq5YgomixjrpFhVI1DLd1tG6olWpt1QBqW/v7qlUptNVvRRzB4qijjmoVg6tJKw7c3zJEURJFVFRkb5Lz+wOIICEEuDcDz+t58jyaXO65Z7zP56z7+XAIIQQUCsUgMaJFQKFQAVMoFCpgCoVSH7j1uZgTIFH7Owlxa9TDsH1/CuWNFrA6EdUlPn25P4X5DpZ2rAYkYApzDbq+nZI+COX1Z6Adq247OypgHTdotsROMfy2oQkGvIglQ4SnJyJktKEYpIXicBr0oTQVCyw7h0OYhHAerUSmhnfaHLrr/vyQDBGeDvCL1tWzM5M+13D1ewiYFA6qX2aGd2/c0F12DodcxCAiN4NO30AFLEO5fql86Uig4QbAxVukUwPERPpctgudFSRh8HMJAuEZfkNq6qLT15GALMkF3r71uzejHQhD6XP1reFqkhlJVCgE3iF60ZDepNXhptNxSRAV74wF9chbQ+q59r+pmr6sUelzDa+BSBAVKgDD+n3DG/QbhiQK8ZMWsLp+orZtVEufpxQxK0Pohizds7rCKIlCvHABQjTsGanIKDWGr/eBSR48PUlf1qh7cXUqxvpnHRHB8TUWr96045f0SKOmnX0AOO6hAF8Iqci3wuKVL4A6+upL+ixbYP3qOpve3m9DOxldHGk0tI5DAm8Q4o0AjjvCJL4IcatoQy7eEOlN+ixb4Po0ErYrsqnt/RqixTSks9BubuXPukDIh0OUBCFuboAsCS7evnqUvpYtsO6GqxKE+bkgiDQV+VK0Bc9jEvh+wYhY4AbHqHg4L9Cn9LVogXU7HopCqMAbIbQ96nTobpgK9kWQwA/uYQEQxE/CAp4+pf+GzIHZ2Pt9U3kTF7vcFgjBd/BDvFCqkylY7em/ERZYf/Z+KQY6EuB5YBKfD+hq+6jW9N8ACyyLCEa8MJzV4bOhDSmbwhBYuyMBHnxFIh2WJzvpG4SAeb4itcv+jS18QxtS6vJ5m+LcWdf135j0ubTwKbSsDRfDfBuJQqGU65GGVqFQDBfq2J1CoQKmUChUwBQKhQqYQnlTYOxtJLrFQKHouYBrEyrdWmr66PpdYOrEgCEBU95cdP0uMI3LROfAFA24c+cONm3ahKtXr+ok/VOnTiE8PBwZGRm0MqiAKfWhqKgIv/32G7p164bc3Fytp3/58mXcvXsXdnZ2KC4uphXC9BCaDluaNteuXQMAeHh46CR9kUgEDw8PDBs2jFYG0wKmK83168wMsbzOnz+P7t276yTtsrIyJCcnY9GiRbRxsWWB2UQSwIF7aB0XCcR6JYym5tI2ISEB3t7eOklbKpVCoVCgVatWVJlsCFidwARigsbqyi1EDEGoO+KFUoh8eaqeAAEBtNLYIjMzE8+fP4eDg4NOOqVr167B1taWTt/YErBbCIHU2RP+CK9FYI3FDSFSITwd/BHhIULNJNwQ0oTc6sgiPOHgFw1+rR2WdoftiYmJMDY2RosWLXQyHbh69SqcnJzo9I3NITTPNxyTPB0Q4Kja4jb6tBbPF+HCQ3BwCIAjCYFbIxq0vlc6z1cEcRIHwXoybL969Srat2+vm85MJsOFCxcwevRoqkp258A8+IrECOAEQFKLwBp7WquyYbsHeGskwoamJwngwD2+atiLN5urV6+ib9++Wk/3yJEjSElJwZMnTxATE4M+ffrgrbfeohWiAQ3cB3ZDiBhwZ3FOUjkf9oyQsZuGPtWGJAAcDgecAAlkEZ7l/+YEQBszP0IIkpOT0atXL61m+datW5DL5fD29kbHjh3h5eWFEydOUGWyK2AAbt4QOrNpt8rnw/DzB4sarmGRy0XjWZGmBAGcyu844HhGsPsAbiGQCvlAqDv8EQ5CpBDyQxGshQJIT09HXl4eunXrptUG+OjRI3Tv3h3Xrl1Du3bt8P777yMzM5Mqk10ByxDhGQVHXx67T8fzRbgQSJJpRb1whxiEEEiFgF+YpCIahLhCSHwIw7UTUwcCccWiFg+OLtpJMjExES1atEDbtm212gB79eqF2NhYnDlzBn369MHZs2fRuXNnqkz25sCALCIMCK99gYmx5X5ZBPyTgiDSgm5k9+PBrwhaw/OYBP6h+5CFeEPg7g5OKAAIIOaxmFcd8++//6JLly5aT7dDhw4YNGgQvv/+e5ibm6Nnz57w8vKiymRNwJIA+GMBRLUYX+ZWfmWI8E9CkEg7Vo/n6ILoKBkAHiBLQrSLN3iSKEBMQNzYzqvuuX37Nvr166eTtDt37gxbW1ssX7681j1oCiNDaAkCorxr7lnKIhDBsCGSBPirtfLMpOGO0Gg/hEkAuC2AMN69fK7rDogrxBnq/moOXLmgxgmQVPswOhJIitZJQ3j8+LHOBJycnIwWLVqAx+NRRbJngWWI8HRHaDQQGqpq2ubLpLIQ7Bxeq5VnahjrFkJAlAdDePAVEVTNhSQqHkIpKT9QIouAZ1iFha5ifRsjYFmEZ8XJtop9dQRU/N8dAd5V/199353pTiMvLw8KhaLGGWhtvUR/584ddO3aFRwORyfpGzRE7xATgUBc+69CodaeRCrkEwAVHz4RSsu/R5Xng5pnNRRu3bpFZs2aVeN7VXljI79r1qwhkZGROkvfkNEzn1jlq9veopBaf7+fBGir/+X5ikB8m34nHh8fj549e+os/dTUVEyYMIFaU20sYrHpE0sS4AC/aKBi2Vc1fCF8ab0xSlJSEsaPH6/1dBUKBbKzs8HlcnWyAv5GCphNqs9J9ZumsH10+PBhZGRkoF27dlo/gSWXy/H999/jnXfegaenJ4yNjakaDV3ABrNu0EQWUYYOHYqEhAT0798fRkba9a5kZGSECRMmoLCwUGer31TAFIPG1tZW7fu3rI5gOBy4uLjQStC2gOlL1W8Wuq5v2t7qKB8aXpRCMVyoW1kKhQqYQqFQAVMoFCpgCoUKmEKhUAFTKBQqYAqFQgVMoVABUyhNGkkAB4ZyAKxhApZFwFPpevUN4U3M85spX0SFCuDtpr30AhrRW1ALTKFU01MUQgXeWnMaIYsIRmhocIMNAxWwnvX+AZ4RqLMuJQFN8JC/DBGe5c4DdZk1SVQoBNoyv7II+Pu5QCx2KfdDTgXcBHr/aD84qBOxLAKe7qFAaBR7IVdkEfCsCPGiPf2ew6EKh5yhwRp0YizlOzheiAVa0q8kzA8u4hC4VXhEbUhxUwHrE24hIEQMQW0ilkXA08EP0QIxCGHR5a4sCVp3bsvzwCR++T8FQboJNic7dwiY5KGdtKt1Fjz4hgsR34COiwpY/1SMEFUiripexj2CVMaAqlikc/OGAADfmafFoW25W19CGh8ovqFD+HL98rSSVoT/IUwKr9JR8XwR5OIH//pOhjV3q6r5h1/pf5Uxl66afl65ftVuuszkuYZ7XYCALyRSqZDwARZdqkqJkF+9DMUCPhFKq34P0qQ9ukqFhM8XEqk20hILaqlLMRFAQOpTzGhwZhkQi8FVsNbzXCFiVsWronFV7ZxYaNQN6yTr17Ab8kx8rVSumAjUtKP6PgcdQuv1wux9xOtgFRYA+Hw+e4NlXxEqjEc9PmyG2dHe8FkWEYx4YThqC+zJ8w3HpEOah9SlAtbfJWkEOPghmi+EVCoEP9SdxVXhV/Nc91A+hFKCIBdAKJVCCD84cHS/vcPycjD8XILgy2O/TsP8XBCkNiEefIM031aiAtZX8XLcEcoXQiryBY/nCxGrIpahPKYaH0KpCL48CaJCo3HoHOArIhALtLOIVNmJeGr5uJu29n4lAe6AWIORRH22legcWN/yXGXxSuUzaGE+XDkP1uaqVWXeWJp3qy9vdufXDVok0/B6aoH12fLWnCApLTGrVornDL62s15lH5ivrb3YcvOrhaOTMkT4+8GlPvvbFdtKdY2kqVtZvdJvADjBzqrF+/p17oCYhGjtzG7TLXIOorzZ3XuWRXjCwa+hR2MqpzVUwBSKihFPFLwNuCOkQ2gVvSWnYtW1Ph9P+p6hAepXu28esQG1wJQ3tatGhKc/EC7SwvYRFTCFQqFDaAqFCphCoVABUygUKmAKhQqYQqFQAVMoFCpgCoVCBUyhUAFTKBQqYAqFQgVMoVCogCkUKmAKpRFUhm/x1FEYFc0eEhGe+h2R0sjw24EnOJwA9uIEaQtJgAE0ZgY9U1a6B4qu8HqpV3mvjFThAL9oFzjy9LjdGL6juaYSMaCKE3dtOFnTq+fSk7zrzLFepS/B15zZa9CwDVrAYgGLnhOrRShQ36jEAiYbXc0wJ29OY64qZC3mvWpds2YNqubt9XRe1Xm1qAxiQZ1tDwasXvYq+fXwImobspgIWKr0qj2y1kYZVYWrs6GNdjqxqiFeWM2qVEj4rwuxSnykynpWGVKl1jhKGgr4zQsyVt54XpVZ9QBfr1e2WADWY+pULQvW0qrSafH1xuE3O8HVXnWM2rDyUiLk12JFxQIiEFZ2mLVb2vJAc03JAmswtGhMbylQVVpVLRPLwb+0OdTTmhVi5BkbKThlHWpxeC4VEn6tBVulg1JX+GJBrXVjgAIun0uwaYnUlWW1kYEOFjqYa4iv5mT6L1xmn1GrU5PaDEK1OqijHsWCWtu7wQm4vFK1sFKps0Us3VlgfRk6a2uIq5W8q7HAr9Kvo/00HQtc3mOx3mvqySKWrubAulq80u7cVFt5lxIhX1V+qlhfsTor3cg5MF3E0t0ilk5Woas2Zq1MEaqWr473v9naOquxCl1z20gqFKrOu9o5tCFZYG0d2tD5IpaO9kLV5pcNYenrwRW2nu21feAabVlMBK/Xt6rtJ0MVMKuHNvRhEYt1wehZh1LfcJu66cVqGf5qYzSiWfsyjMgMkgBw3OPVRmkzeDSNTKjTs9AOSApiN5IfpX4YgIArYuYKxCC05VAohvY2khtCCKHibaqvE9br08hX+3SRJrXAFArFgC0whUKhAqZQqIApFAoVMIVCoQKmUKiAKRQKFTCFQqECplAoVMAUChUwhUKhAqZQKGzBpUVAoQDFxcUoKSmp8X3lSw0WFhYwMmq4vVMoFCgoKAAAqHr9wMzMDKamplTAFEp9uHr1KsLCwvDvv/+CEAKFQlHtd0II2rdvj8jISNjZ2TU4nczMTHzyySdIS0ur1hFwOBwQQsDlcjFkyBDMmzcPLi4uGt+Xvo1EUVJaWor79+8jKysLHA6nRkNu06YNHB0dGUuvoKAAcXFxKn8zNjZG586dYW1tzVp+v//+e0RERGD69OkYNmwY2rdvr1LA5ubm4PF44HIbZ+/u3buHwsJClZb84cOHOHPmDI4dOwaBQAB/f38qYIpmZGdnY8OGDTh69ChMTU1hbm5eY5inUCgwYMAA/Pjjj4yle/HiRSxbtkzlb3K5HDk5OXBxccGyZcvQs2dPxsV7+PBh7N69G++++67e1MXly5cxZ84cLFmyBJ9++mndf1Afjz1nzpwhCxYsIOPGjSPjxo0jX375JZFIJKx6Cbp69SrZtWuX2mv27t1LYmJiGE33zp07JDg4mLx48aLWa06dOkU2b95MysrKWMv/3bt3yffff0+ePHnCyv2Tk5PJ4MGDiaenJzlx4gR5/Pgxyc3NJdnZ2dU+WVlZpLi4mPH0X08nOzub5OTkkJcvX5LY2Fjy9ddfk06dOtXZBurDrVu3SLdu3UhycrJeeuI6f/486dq1q0Z1rpGAS0pKyBdffEFGjRpFIiMjyeXLl8nly5fJ9u3byYgRI8iSJUtYa8S7d+8m8+fPV3vN3LlzyZ49exhNd+vWrQQAuXjxYq3XTJ48mTRv3pw8f/6ctcqsfI6TJ08yfu+srCwycOBA8t133+m1a7nz588Te3t7IhKJGLnfkiVLyNy5c/U6z+PGjSPBwcHMCDg0NJTMnj2byOVyleKeOnUq2bJlCysZ2bdvH/nyyy/VXuPv70/279/PaLqZmZlEIpGQoqKiWq+5f/8+uXLlClEoFKxVZEZGBjl9+jTJz89n/N7/+c9/iI+PD6vPzxQ7d+4kgwcPbvQooLS0lAwfPpwcP35cr/O7YcMG8tFHH9V5XZ3r4mVlZZBIJFi0aJHKybeJiQkWLlyIEydONKl5obW1NYYPHw4zM7Nar+nUqRP69etXY8GHSVq2bIkRI0agWbNmjN/73LlzmD9/PqvPzxRTp06FXC6HWCxu1H0UCgUKCwtZKU8mMTc3R1lZWZ3X1Sng0tJScLlcvPXWW7VeY2lpaRCNgFJz73PQoEEG8aympqZwcHDAv//+26j7mJiYwNHREVeuXNHr/N6+fRsdOnRovIArhSmXy9X2alTAhkljDifo4lkbu2nC4XAwZswYHD16FKWlpXqZz5cvX+LMmTOYPHly4wWsawghdXYOlZvhlPpbtdjYWIN41rKyMqSkpNTrkENtjBs3Di1btsTy5cv1Mq8LFy7E+++/r9HoSO8FzOVylUfQaqOwsJCOABrAsGHDsG3bNoN41sOHD4MQgg8++ICR+eW2bdtw8eJFTJ48GTdu3NC5ASgtLUVsbCxGjRqFrKwsbNq0CcbGxnXrQ98rbtCgQdi0aRNSU1PRsWPHGr+npaUhJSUF/fr1Y/U5MjIy4ObmhnHjxmH16tWspTNr1iykpaXh7NmzKn/Py8vDsGHD4O3t3ejnWLx4MUaOHIkffvgBgYGBetsGbty4geXLl+Pnn3+Gubk5I/fs0KED/vzzT6xZswbTpk2Dvb19rae+WrdujdWrV6NVq1aNGhZ//fXXyMjIUPn7ixcvkJ6ejokTJyIwMBDNmzfXzMBpclFJSYnaHkqhUKg8CM5UQfv5+WHmzJmYO3cuRowYgVatWinnCZVH4Tp16sT6UN7a2pqxBlQb1tbWKCwsVDsPbNWqFVq0aNHotFq1aoVdu3Zh9uzZuHLlCr744gu4uLigRYsWKo8UmpmZMT5nLioqUjklKisrg1QqxYkTJyAUChEYGIixY8cymnbr1q2xYcMGLF++HDExMXjw4EENq6dQKGBjY9Poem/RogUGDhyIjIyMamlU6qpTp04YOnQobGxs6jenr+soZWlpKQIDA7F48WK88847Kq9JTk7Gpk2bsHHjRtYadkxMDLZt24aMjAwUFxfDzMwMLVu2hJ+fH4YPH07Hw43g+fPn+OGHHyASidC8eXNYWlqqFHD//v3xww8/MJbupUuXsGLFCpUClsvleP78OZycnLB8+XIMHDiQVlRDBAyUbzeYmpqqnWcWFRWxbp0qhyI5OTlo0aJFo4Y0FNXD87t37yIzM7OGpVUoFGjbti2j54Zzc3Nx7do1laMdLpcLJycntGvXjlZMYwVMoTQl0tLScPLkSZSWlta5+Fk5hB43blyjDn9kZWXh2LFjyMvLq3MaUtmBTZkyRe35C4NYxKJQmCY9PR2nT5/W6KQTALRp0wYjR45slICzs7Px119/IScnRzPLyuHAx8enTgFTC0yhGDDUJxaFQgVMoVCogCkUChUwhUIFTKFQqIApFAoVMIVCoQKmUKiAVRIbG4u7d+/qJBOFhYU4ffp0ne8NUyhUwLUIaP78+ZBKpTrJxLlz5/TWu0JT4PHjxzh37hz1etJUBbxv3z7Y2Nhg1KhROsnE5s2bMWPGDL33NGio7Nu3DyKRiHo90UMa9DJDfn5+tfdFDx48CB8fH+Tn58PY2Jix1wpLSkpqdSZgZGQES0tLJCYm4unTp5g0aRKtTRZQKBS4fPkyFixYQAvDkAVcXFyM3bt3Y//+/Xj27JnSq0Bubi4ePXqEx48fIzIyElOnTlX5knZDiIqKwsqVK2u8flXpsaFz587IzMzE8OHDNXLBSak/9+7dQ15ensG4n6UCVsHDhw/h6+uL/Px8ZfhDS0tLGBsbY+nSpfDw8MBXX32FsrIy2NraMvZwI0eOhKOjYw03JxwOB0VFRbhw4QIWL16M3NxcJCYmonv37qwUklwuh1QqxfPnz5WdiVwuh4ODA+MvnBNCcO/ePbx48aJax+Xo6IjWrVtrrWGUlZXh0aNH2Lp1K2xsbHD79m0UFhbCyclJq89BUU+drxNmZWXB09MTrq6uWLt2LUxMTJS/ZWRkYMSIEdi1axcj7j4bMjfbt28fBg8ejP379yMqKgrt27dn7P7FxcXYsmULdu/eDaDcgX1lccnlcsyZMwd+fn6M5qmwsBCBgYG4efOmUsAcDgcvXryAg4MDli1bBldXV9bKND8/H5s2bcLBgwdhZGSEu3fvokuXLrCwsIBcLscXX3yBKVOmaK2OCSGIjY1Fp06dGDMOhBBcu3YN7du3x9tvv61XgiwsLMS1a9fQt29fWFhYaJQZtSxbtoxMmjRJ5W8bN24kPj4+Oosf4+7uroxa5+fnR+bNm8fYvZ89e0Y8PT2Jq6srOXz4MHn48GG1qH2ZmZmktLSUlXwVFxeTrKwsZVq5ubnkxo0bZN26daRTp07k559/ZiXd1NRU4u7uTjw8PMiff/5Jjh49Svh8Pnn27BnJyckhWVlZrEZiVIVCoSAfffQR2bhxI6MREfv37896ZM2GPtvAgQPJX3/9pdH1agWck5ND3nvvPXL+/Pkav+Xl5ZG+ffuSY8eO6SSjp06dIn369CFZWVnKcKDdu3cn9+/fb/S9i4qKiI+PD5k3bx5rIm0ocXFxxNnZmQiFQkbvm5+fT9zd3cmSJUuUQezWr19P1q5dy1gakZGRDRLNtm3byIcffsjYc5w+fZr06dOH5OXl6WVgs4ULFxJ/f3+NrlW7jXT9+nU0a9YM/fv3r/Hb5cuXUVpaCg8PD50MNX7//Xe4u7srXY506dIFrVu3bnTsHAD47bffkJGRgY0bNzY6KjvTuLi4YMuWLfj555/x5MkTxu5b6eA9ODgYRkZGKC0txfnz5+Hu7s5YGkeOHMGFCxfq/Xdjx45FRkYGDh8+zMjwec2aNZg+fTosLS31cl7r6+uLc+fOISEhoc5rjeoaj3M4HJiamtb4bdOmTZg8ebJOCuH+/fv4559/8Nlnn1X73szMTKWf4fouWB05cgSff/65VrxsNoThw4ejY8eOOHXqFCP3Ky0txfHjx7F48WJlh5WUlARzc3NG3blaWlo2qExtbW2xbNkyLF++HHFxcY16hiVLlsDExESvt8V69eqFqVOn4tNPP8WzZ88avgrdpUsXFBYWQiaTgcfjVdtakEqlCA0N1UkGjxw5gp49e6Jz587K73Jzc/Hs2TM4ODg06t6ZmZlITU3F6dOnkZiYWOvpo6KiIowePZqRUB+vd5pCoRAymUxlxwmU74GnpaUxdnQ1PT0djx8/xrFjx3Dp0iUYGxsjNjYWGRkZ+Oabb5SB7YqKijBlypRGiTo3NxdZWVn1/rtRo0bh1q1bGDduHLZu3YrBgwdrfHBHLpcjJycH3377Lc6ePYv9+/ejqKioQUdvjYyM0KJFC40OtRQUFKC4uLhBB2AWLlyIxMREZX67dOmiMtStWgE7Ojqiffv2OHDgAIKCgpTfC4VCuLi4wNHRUeviLS4uxr59+7B69epqBXPgwAHY2Nigb9++jKRTVFSE/Pz8WgVcWFjISnQ7QggKCwuRn59f6/0rh7hMplk1z/n5+fj3338xduxY5ObmVvtdU0+OKq0Fl4v/+7//w4kTJ+p9LJPL5YLL5eLhw4cYMWIE1qxZg8DAwGq7IrWRkpKCiRMnIi4uDk5OTvjqq6+Ql5dX7+cvKSkBj8dDZGQkWrZsWef1a9euxZEjRxp0QtDU1BRyuRxXrlxB7969ERkZienTp9dPwADwzTff4OOPP8bw4cMxcOBAFBYWQiQS4ZdfftGJ9T158iQsLCyqWb64uDisXbsW4eHhGgWEUoeNjQ3efvttTJgwAVOnTtV6/po1a6ZRnCIfHx/GOlA7Ozu0bdsWn3zyCTw9PREbG4u8vDxs3bqV0bzJ5XJ88sknmDt3br0FbGpqirNnz+L69esICgrCxIkTNa7rdu3a4ccff8SKFStQWFiIFStWwMTEpEb0ibpQKBSwtLTUOG7RtGnTMGzYsAa1SVNTU2zfvh3JyclYs2YNhg0b1rBtJEII2bVrF3F0dCTh4eHkl19+Id7e3jpboRszZgzZsWMHIYSQ9PR0sn37duLo6Eg2bdrEWBpbtmwhQ4cOJSUlJXq5Snnp0iXSvXt38vDhQ8buGRwcTEaNGkXkcjlZvnw5K1tV06ZNa3A9JSUlERcXF+W2YUN48eIFGTlyJBEIBETfOXHiBOnWrRv5559/1F6nsV/omJgYrFq1Cn///TccHR3Ro0cPlb3oyJEjGTvccObMGWzfvh1A+WGG0tJSiEQiDB8+HC1atIBUKgWXy8Xq1asxYsQIRuehY8eOxbvvvouff/5ZrxY47t+/j7Fjx2L+/PlYuHAhY/fNzc2Ft7c3Bg0ahHv37uGnn36Cvb09o8/+0UcfoW/fvtWmY5pOZ8aMGQNXV1esXLmy0fN9Nzc3BAcHY8yYMXq5iJWeno4PPvgAa9aswfjx4xu+iFUVV1dXrFixAg8fPsRXX32lMoKeXC5Hly5dGMuIg4MDBgwYAC6XCxMTE2zYsAEeHh7w8fGBXC7HsmXL8N5772k0D6oPFhYWyjnHyJEjERAQgJ49e8La2lo57FIoFLCwsGDlDR2FQoGioqJqJ7FkMhnOnj2LjRs3YtasWYyKFyiPnhcZGYnRo0cjNzcXKSkpsLS0hJWVVbU8N+aNL3t7+wYdPT137hwyMzOxZMkSRqYLixcvxn//+1+MHj1aL9+w2rFjB7p06VKneIF6RmZYtGgRAOC///2v1jMll8sxePBg/Pzzzxg8eLBW0szLy8PGjRuxf/9+mJub12jMs2bNwty5cxlfhV6+fHm1o5RGRkZ48uQJ2rZti2XLlmHkyJGs5VkgEOD27dt48uQJTExM0Lx582p5XrhwIT766COt1v3UqVNhb2+P4OBgRu737NkzDBw4EPv27cOAAQP0SryFhYUYOnQoli5dimnTpjEn4CdPnsDDwwNRUVGN3qppCJs3b0Z0dDT+/PNPraddUFCAe/fuVXsLq3K0UVvI1cZY34SEBKSnpyvTIoTAyclJZYBzJnn+/Dk+/vhj7Ny5E9bW1rhz5061eLZyuRzdu3fX6vlhQggOHz6MXr16Vds2bGwZHz16FD169ICTk5NeCTgvLw9Hjx6Fj49PrQHH6yXgv//+G0lJSYiLi8OxY8ewbNkyGBsbq5z/yuVy9O7dG0OGDGEkMzdv3sTFixdhYWGBsLAwtGvXDmPGjFHuS1alrKwMTk5O4PP5oDSMEydOYP/+/di9ezd9ed9AqHMO/L///Q+nTp2CRCLBoEGD8Ndff6ldfjcxMWFMwMnJyTh79iwePnyIlJQUODo6Ijo6utYtiKysLCrgRnDy5Em4ublR8RoQGg2hL126hKVLl+LChQs6qdxFixbBysoKa9asoTXGEpmZmRg/fjx27NiBTp060QJpKhZYLpdj7dq18PLy0ol4k5OTER0djePHj9PaYpGsrCyMHTuWirepWeCioiJs374dEyZMYPRleU2Jj4/H5cuXGX9xnkJ5Y4bQFApFP6GRGSgUKmAKhUIFTKFQqIApFCpgCoVCBUyhUKiAKRQKFTCFQgVMoVCogCkUChVwE+O3337DV199pfI3hUIBf39/REVF0YKi1F/AOTk5mDhxImQymV48/Jw5c3Du3DnG75uXl4eYmBi1UR7kcjliYmIa5KS8NsrKyrBnzx44OzurriwjI3To0EEZLZFCqZeAd+/ejaKiIsZj4jaUrl27YuvWrY1yNq6K2NhYBAYGoqSkpNZrFAoFVq9ejZMnTzKW7q5du6BQKDB//vxarxEIBEhLS8OhQ4do66Vo7pXyzp07iIyMxLZt21SGeNAFAQEB8PLywo4dOzBv3jzG7isSieDi4gIrK6tarzExMcHw4cNx5MgRfPzxx41O8/LlyxAIBFi5ciWuXLlSq9cTLpeLDz74AIsXL0a3bt3w7rvv0lb8BqPR64T379+Hp6cnhgwZgs8//1ylT6rasLW11fgl8czMTCQlJWnsOMDY2Bi3bt3CsmXLsGHDBsyYMaPRBZKcnAwvLy8cOHAAffr0UXutTCaDt7c3wsLC4Obm1uA0JRIJZs+ejdatW0Mul9cZNsXMzAxlZWUoKyvDjh079M6zIkWPBBwdHY1vv/0WpaWl4HK59Yr+V1ZWhpkzZ2LFihUaXX/p0iV89tlnkMvlGovYxMQEpqamyM7OxsyZM7F8+fIGew55/vw5Jk6ciOHDh2P16tUa/U14eDg2b96MY8eO1cubhVwuR2ZmJnbt2oVdu3ZBIBDAy8urXn9/8OBBCIVC+Pv7Y8KECbCxsVG6oqW8oQImhCAnJwdPnjzBpk2bcOXKFSxduhQffvhhvYVRGUvGwsJC4+uzs7OhUCjqlRaHw8GjR48QFBQELpeLL7/8Er169cJbb72lUXzfkpIS3L9/H76+vmjbti02b96scRhMQghWrFiB8+fPY9u2bejdu7dG+c3MzMS0adNw6tQpnD9/Hq6urg2qwOPHj2PMmDEYO3as0n815Q0WsFwux/r16/HNN9+gS5cuiI2N1cg/rb7g6+uLHTt2YOLEidiwYQM6dOhQ598cPXoUU6ZMQUlJCfr37w8ul4vi4mKNRwBGRka4ePEigHKn91988YVGfxsXF4ewsDBcv34dmzdvRr9+/eqV13PnziEwMBCurq747LPP0L17d9qi6RAaePr0Ka5fv47IyEjk5+dj/fr1eO+99/Q6Izk5OVi9ejViY2Mxffp0DB8+HJ07d9YoMtzjx48RFRWFwMBAeHp6wt/fX+0KdFVMTU1x+PBhCIVCfP311/joo4/q7YB806ZN2LJlC4YPH47c3Nw658Dm5uYwMjLC9evXsWTJEsycOZO2ZCpg1UPLLVu2ICIiAn379gWHw0F+fn695sA+Pj6YNWuWRtcnJiZi7dq1KCsr03gIzeVyYW1tjWvXrsHJyQk//fQTWrdu3aDCiImJgb+/P77//nuNA19duXIFs2fPxrp16zB27NgGV8T+/fsxbdo0zJ49Gzwer1bf1xwOBwkJCfjjjz9w4sQJjBo1irZiKmD1/P333xg9ejR69uyJUaNG1WvftW/fvvDx8dHo2rt372Lv3r31mvumpaVh+/btWLduHQIDAxu9iBMVFYWAgACcO3euzv3u3NxcjBgxAjNnzsTnn3/e6MpYsWIFMjIy6ozL+/HHH6Nnz571jvJHaYJoGq/06NGjxNXVlWRlZelVHNX58+eTRYsWMXrPyZMnk1WrVtV5XWRkJBk+fDgpKytjJN2MjAzSp08fEh0dXes1e/bsIYMHDyb5+fmEQtHYXI0dOxbvvfcevvrqK+iLJ9oDBw4gNjYW3333HaP3nTRpEo4cOYKCggK104O9e/fCx8enQRHYVdGyZUvMnDkTv//+e22dLU6ePIn58+c3Kswn5Q20wIQQ8vjxY+Lq6kpSUlL0ovcZP348OXDgAOP3ff78Odm7dy/Jzc2t9ZqSkhKyb98+8ujRI2oGKDqDOnanUAwYemyHQqECplAoVMAUCoUKmEKhAqZQKFTAFAqFCphCoVABUyhUwBQKhQqYQqFQAVMoVMAUCoUKmEKhUAFTKJQmJmBZhCc4HE6VTwAktP4oVMD6jySAAwc/QCglIISAECmE/FC4czwRIaOVSKEC1mfTi+BQgC8Mhy+v8ksefMOF4CMafmESFpOusPqeEZBV71HA4XDgyWbvIYuAZ7URBwcBTXbIIUFAlVGVJKBKvlnOtDItQy1cvfcZIhYQAEQgrvEDEQCEL5SylTARAAQVn6rpiwUggICI2cs0EfCFRJkzqZDwK56DvfzqiMq8VeZXKiR8ZdlW1EHVsmChbamqY7bzW7MeG5ZXo4b1lJzXLJAMEZ5anpdKohAKPiZ58NhLQyAuH7KLBQiNkijLICoU4AsXwI3N/Lk44tWAwxciqRB8LU5ZOK9Zf3ZGGzJE+PshGgKIRb7l+ZUlIZrvXJF3N4SIBUC0H9gYaEmiADEhKuq4KVrgyp6ySjclFlT2JBW9BxtdWFULXMUSsWsB1VhEsUArab8qW62aQyLkgwB88ippVd8xbH2rD29es0Istq0aZa6FNqUbC1ylpwx5ZXfcQqSYdCgMEkkUQgHwnXns9jY8X4iUPSbgrrV5oRu8XZIgAyCJCmXf+gJwCyEIhz84Wl2okyEpGoAgqPp6g4iAEFGV75hKLgnRdVc6nPkA4u9DxnLe78fH476BLYpqJmDZORyKBqAc2lSp3CAgODgeYHs4W7OFQywAQt2108B5zsB9mQRRoQIE+WonnzxfEYh0Eg45qFhIY6mjWiDkA6FRb94WnSQMftHROHRO1hQFXNFTVp2XKevcGy7R0QB/ErSp33JR8QFop9B5jkDSufuIF3izbn2rrnRz/IFwIoYg2g8OWrDG5Z2GM4JZn/+Wtx0B6rCuFcaDP8kDbDYvSVQoACA6qSkKuL6LLtoSsKOLNnsLxPsdwqQF7MtXFuEJTrAzpISAiHzBgxtCiBgCRMPPgd2FQkkABxyHQ5ik3HMnELE24qiw+GoWqWTnDiGa7dFdxVYlBEIIcR+yJidgnnOtK6CyiGCEAhB4u6FJw3OES7W5IWsSQphftAqLU9HYEQrWFkslAXAPfX0OzLbFD4eQD4S611zPkEV4wsEvGgKxiNXnkYT5IRp8CBf4wsM5CdoYRTNl6TUUsAcm8aFiblTe2MpHQdrvt8qHPVqae1cs1GkrHRdHnopqmAS+Dsq68kALOwuG5YtkUiEfoe4ccNxDgWg/OHA4cPBzgZgQhLixmrkK61veafEcAa2MoqtqSRYBT04w4vlV+1INR1r13vR+bRsJAOELha+2WaRCImByv6HKZnu1pfeK77W11SIWaGcro/aDK6+2INh7jMoto6ppvDrQopWDDjW2kbRQr1W3yKRCwmczo1Ih4fP5VbZDX20dSYX8eh8qQUP2sJQJV8n4q8QZ3kur0qCrZlBrDUrLe5Eq90ZJ1TJme6/ylYhV1XOTErDKspYSIb96u2a02hnOnwEfpdT+M2jL2ld2VDVHHFoUki7LWksCrmF9yevGiPnOSyrkM5o/+j5wPRbxVM1LWdvKEQsQ7efw6jhjsDOkRKS1xaUmz2tz3+rlH1S+vYXXX6JhINmkaCA6ibGVbr0PL/pqJZLlxQwKRRtrlAEcuMcLIa08+91IuIaRbT7YPqVJoWgDtxACJi0mDfBNoRgwdA5MoVABUygUKmAKhUIFTKFQAVMoFCpgCoVCBUyhUKiAKRQqYAqFoidwaRFQ9IWysjJUHgw0NjaGkRG1L1TABoZcLoexsbHy/wqFovqQqQk2aqlUCjMzM5w/fx7FxcUoLCxE27ZtYW9vj169emnlGbKzs7Fnzx7MnTsXFhYWBlN29Cy0nvHPP//gzJkzKCoqQuvWrdGiRQvI5XJwOBwoFAq8fPkSMpkM48aNw7hx41i3iKtWrcLixYthY2PDShrHjx/H5s2b8e2332Lw4MHK79PT07FixQq0a9cOK1asQLNmzVjvRHr27InffvsNo0ePZq1z3rVrF86cOQMzMzO11xYXF2Pq1KkYM2YMnQMbEsOGDUPHjh0RGhoKW1tbjBkzBj4+PvDx8YGnpyf69u2L1NRU7Ny5E2z3vVeuXMHq1asRFBRUYyTABHv37sX8+fOxdu3aauIFADs7O4SFheHGjRuYM2cOSkpKWM1rpfU/e/Ysq52EWCxGmzZtYGVlpfbTpk0bHD9+HBkZGepv2mA3JDpxbfNmEB8fTwCQmJgYlb8/fPiQBAUFkby8PNaeobi4mOzYsYPMmDGDmJmZkYSEBEbvHxcXR8zMzMimTZvUXpeWlkasrKzIqlWrWMurXC4n+/btI3PmzCEdO3YkWVlZrKRz9epVEh0drfH1+/btIykpKQx65JAEVDgar/QZLIYA5S5BPWmgXsYoLi4GAJSWlqr8vWPHjujfvz9kMvbK/NKlS3ByckJISAiMjY2xceNGRu+/fv162NnZYerUqWqve/vtt+Hv74+NGzfiwYMHrOT11q1b6NOnDyZNmoTU1FTcuHGDlXTat28PR0dHja93cXGpc+pSDwFLEOAeD2F4VU8ClQ7HgWg/fxajBlSPiqjyw1LoEWWkvsr7V4nbq8tOy8rKCkVFRazcu6CgALm5uXB2doadnR0WLFiAnTt34smTJ4zc/+nTp9i7dy9GjBiBVq1a1Xm9p6cnMjIycOzYMVby++TJEzRv3hwDBw5E586dERkZyUo67dq1Q+fOneslYGtra2YEXOnAvSaVDsdZCnEiCQCH464dn8wqOg33UEAgroyQAGWANamQX+6zSisxi2rC4/HQtm1bVu79+PFjWFhYoHXr1gCAGTNmgMvl4scff2Tk/qdPnwYhBC4uLsjOzlZ7bV5eHuzs7NCmTRscOXKE8bxmZGTAxMQEb731Flq2bAlXV1ccP34c+fn5BjFaY2QbqdzheDQLjydDRHCFdAViEKVTLBkiPP2BcPacvEkCyjuNqr64JAEcBDtLIfLlgecrghSecPDzg3+EB4vhR1RTn568vly+fBmTJ09W/r9Hjx7w8vJCZGQkFixYAAcHh0bdPykpCQBgb28PsViMGzduwMTEpMZ1CoUCpaWl+Oyzz9C+fXskJCQwntfnz59DoVDA0tISAODl5YX9+/fjzJkzrK3yp6WlwdbWVmWeKzut/Px82NnZaUfA7BnBMPhFvy5eoNybfxACOBwEsOHsrtJjIV+IV6GQygN7RwtkQMUkorLjivYLg8Q3RDtBz1jm6tWrsLW1hampabXvv/nmGxw8eBC//vorVq1a1ag0Kq0bh8NBRkYGdu3aVev+tpOTE+bPnw9CCONWkRCC58+fo1OnTsrvvLy8YG5ujqioKNYEnJiYCD8/P7Rs2VLl71lZWVizZo22BcxeiBPVcZfKh+4O7gHwJgyLR100xupDD0ziA9HR5XFl3XiGLd7i4mLExcXBy8urxm/vvfceZsyYgV9++QWffvopOnbs2OB0bG1tAQC5ubkYOHCg2sW4uLg4lJSUoLCwUKMGXR9KSkqQkpKCoUOHKr+ztLQEn8/HP//8g6dPn7IyTeFyuWjTpg3s7OxUbgVyuVyND+zUU8DR5XFjeK8bSj9EC8QQabkBl0cnDEWUJARuLJi/6gHLywNN85uwe8zbt2/Dzs6u1ka7ZMkSHD58GLt378aKFSsanM6gQYMAAKmpqZgxY4baa3v06IHbt2/j8ePHGDt2LKP5TU9PR7t27Wp8P3fuXOzfvx9xcXGsCLh79+7YvHkzmjdvrvL3zMxMyOVyje5V74Mcoe7Vgy7JIjzhHiqAmA2nzRXxY+sK5sVWsK/qEeR48Jgk0G4Qcy1SWlqKp0+fom/fvmrF5OPjg59++gkFBQUNTqt///6wsrLCpUuXat0qq0pCQgLy8vIYF/DFixfRr1+/Gt/37dsXrVu3xrFjx1g5LGNnZ1ereAHAxsZGuYDIsID5EIqrB392SAoCIWzN/9zgLUD5HFPVSPd+PDtD91oCT8uSQl+LXCdDUjR0EtycaZ49e4aysjK1w1RjY2P4+fkhIyMD4eHhDU6refPmCAwMxJkzZzTay/7111/RvXt3jBw5ktHhs6mpaY25fqWApkyZgoMHD6KwsFC/K65+8Xp0EZunMtjWa2mzHK+oMj6O8pSZWED4QikRC14FF6txDUNcv36dACBisfaOuO3atYtkZ2drdK2rqyvp3LkzefbsWYPTKywsJEOHDiWjR49We93vv/9OrKysyOnTpxnN782bN8m1a9eIQqFQ+fsff/xBADCabkFBgcZlTAghL1++JMXFxcwEN9OdgGuGGYWWjnBWC3L1SsnKcJtslceNGzcIACKRSLRStHfu3KnXEb/r168TLpdb5zHIukhNTSXDhg0jK1euJGVlZTV+//vvv8n7779Pdu7cyXieQ0NDybVr12r9PS8vj3Tt2pVMnz6d0SOyFy5c0Ph6kUhEHj16pPYajRexZEnRAARw1NVQ0S0EhIRod5HMVwTiW3NYH0II2HySyj1Jbb3WdvbsWVhbW+P69esaXa9QKPDuu+/ip59+wsyZM9GiRYsGpduhQwf8/vvv2LJlC7777jsMGDAAo0ePxv/+9z+cPXsWaWlpCAkJgbu7O2N5zcrKwurVq7FhwwZ8+OGHEAqFNVbUpVIp/vvf/yI1NRUpKSmwtbXF8uXLNZ6Xqkv7xo0bsLe312iL69q1a3UevdT4dUKmgzJRVHPs2DFs27YNJ0+ehJeXF/r16wdvb2+Viy1M0bVrV9y9excmJiYaLdoYGRlBLpdDLpdj586dmDlzZqOfITk5GRYWFujQoQMyMzPx9OlT2NvbM/4aYUlJCZKSksDlclFSUgInJydlh1lJXl4e7t27BzMzMxBCUFhYCBcXlzpfAayLxMREeHl51XqA43UBm5mZQSKRwNTUFG+99VbjBEzRDqmpqUhPT4eVlRXy8/NhZGSEDh06aHRmuDHbRxXTKY3/xsjICMbGxrCysmLtSGdTo6ysDMnJycqXVeqiWbNmcHJyQllZWa2ipwKmUAwY+kI/hUIFTKFQqIApFAoVMIVCBUyhUKiAKRQKFTCFQqECplCogCkUChUwhUJpLHW+jVRXsC1lT1Dhw6fyZCaHw6GlS6kXVb1z0OiEDAn4woULymBbdnZ2aNasWTV/PZVBt54/f47i4mJYW1tjxIgRjL49oy4uT1OtZEJItU6wtLSU9UZd+UJD1TS0kW5CQgJatWqFkydPwsTEBBkZGejYsSPeeecdODs7N/h1xTcBjV5mEAqF+PTTT7Fnzx64ublVCzRlZGSE/Px8TJs2DQCwe/du2Nvb1/r6k6aUlJRg9+7dSEpKQpcuXWpEIajsOHJycvDkyRMYGRlh6dKl4PF4jDSob7/9Fg8ePMCXX35Z43W50tJSbNiwAXv37kX79u2xatUq9OnTh7FKKSkpwR9//IHExEQUFBTA1NQUnTp1wocffqjRu6QN5d9//8Xp06dRUlKCly9fwsTEBJ07d8bQoUPRpUsXVtL85ZdfcPr0aaxcubJap5+Tk4P169fj3r17WLFihdbCjBpiT18niYmJBAA5f/68yt9LSkqIq6srmTJlCmPeC3JycgifzydcLpfExMQQqVRKUlJSlB+pVEqSk5PJ2bNnyffff09atWpFPvnkk0ane+bMGeLo6EjGjx9Pxo0bR6ytrUlQUBApKChQukUZP348adu2LZkwYQLx9vYmPXr0IElJSYzm/cGDB2Tbtm0EANm4caNWPHNkZ2cTqVRKDhw4QACQlStXspred999R9q0aUMePHhQ6zXLly8n77zzDomLi6NR7xrqUufmzZtqfTTl5+eTIUOGkIkTJzL6cElJScTc3JwsWLCgzmv//PPPRncgxcXF5D//+Q+5dOmS8rvbt28Te3t7snbtWmWj69SpE0lMTFRGtjt+/DhZt24dK9HsuFwuiYqKYqXyi4qKSGlpaY3vHzx4QCwsLMiBAwdqre/Gcu7cOY06p6KiItKqVSvi6elJCgsLqWIbFZ1Qy3Tt2hXr169HWFhYnXFbR48ejTZt2jQ6zUGDBmHgwIHK/zs7OyMsLAx//PEHUlNTceLECWzduhXdunVTTiE+/PBDDBgwgLF8X7t2DRKJRJnnP//8ExKJBBcvXtTYX7AmJCYmIjAwsEbQsMoXztPT06t9f+XKFSxcuJCRGLo7duwAl8vFiBEj1F5nZmaGadOmQSQSITU1lQ6ZX18D0vcH/PTTTzFo0CAsWbKkTl/EgwYNQlZWVoPTMjU1VdmgRo4cifbt2+OHH36Ag4MDPvzww2q/m5ubM+K3KTc3F0FBQThw4ACMjY0xcOBAcLlcuLq6okWLFvjnn3/g5+cHqVTKSNn27t0b77zzDqZOnaqMV1TbAmFubi6mTJmCkpKSOqPG10VZWRni4uJgbW2t0QJV5boGG0HGqYBZplmzZli/fj3i4uKwbt06tdcOGDBAI0fh9cXExAS9evXCzp070bt3b1bymZ+fj1mzZiEhIQGrVq3C0KFDYWVlBblcDi6Xi/fffx/Lli1Dhw4dMHr0aMZE7O3tDQsLC0RFRdU5KpDJZPjkk08av3LK4cDKygolJSUoKyur8/q8vDyqVEMVMAAMGzYMX3zxBdatW6fWc6KjoyMjw2hVODs7Izc3l5FVblXbN8HBwfjjjz+wfv16pTfKyuFy1Y2CL7/8Ei9fvoSvry9jnZO1tTVevnyp9rqXL1+Cy+WCy218OC1jY2N4eXkpdxDqKpsbN27AxsZGbTQDKmA959tvv0WHDh0QFBRUZ0xZNmjdujW4XG6jXYuqIjs7G3/88Qc6dOhQ53ZNy5Yt8cEHH0AsFjMSsV6hUEChUNQpTC6XC0IIY8NYb29vcLlc/PXXX3WOTM6ePYvx48fj7bffpoo1VAG3adMGv/zyC27dusVYpPj6NnS25mGFhYV48eIFbGxs6vQMaWRkpHSD+uLFi0an/fbbb6Ndu3a4c+eO2utSU1PRrl07lcHAGkKPHj0wc+ZM7NmzR+11p06dgpGRET7//HN6us+QBQwA77zzDo4ePQpnZ+cmVQk2Njbo1asXHjx4UOecsLS0FKmpqbC0tGTkcIW5uTm6deuGuLg4tdfFxMSgU6dOjFlBDoeDlStXoqioCFeuXKn1ut9++w2+vr54//33qVoNWcAZGRl49OgRBg8eXOs1BQUF+h+MqhYRzZs3D/n5+Th8+LDaaxMSEnD27FksX76csSOGc+bMQXp6Oi5duqTy9+fPn+PixYuYPn06o47W7e3tsWjRIuzcuVPl73fu3EFOTg5WrlxJlWrIAi4sLMSlS5cwZMgQtWdyL1y4gIyMDIOsiPHjx2Pz5s0ICwtDTEwMgFchVszNzQEAd+/exbJly7BkyRJ8/fXXjKU9dOhQfP7551i3bh2ePn0KKysrcDgcWFpaorS0FGvWrMGgQYMwe/ZsRtKTy+XKepoxYwZMTU3x9OnTGtedPn0a06dPrzWSPUXDAN+Vcw91c5DKcKNMI5fLcenSJXTr1g3W1tZqr71y5UqdBwP0mXnz5qFz5844c+YM0tPT8eDBAxBCEBMTA0II4uPjMXv2bEydOpXxtFetWoVff/0Vv/76q3IV/O+//0Z2djZatWqFtWvXahQSRNMOWSKRYOLEiWjdujU8PDwQGxtbLf5vXl6ecrW66joEfUOpAQKutAS1DZ8qv2ejcOPi4tC8efM6gzylpaUhMTGR9QJjeyHlgw8+gJubGxITE1FaWgoOhwM7Ozt06dIFI0eOZHUrZc6cOXjy5AmuXLkCQgjatGmDUaNGMb7mYGxsjKdPn+L27duwsbFBWVlZjcW7hw8fwsTEBAqFAo8ePcLx48fh5eXF6sscTVLAW7duhUgkAlC+lePj44PJkyfD1tYWACASiSASiXDz5k3cuXMHgYGBGDdunNq5qqa8fPkSCoUC/fv3V2uhExISsHLlSlZ752bNmoEQopWIgUZGRnBxcYGFhQUIIejevTtcXFy00iDatWuHYcOGQaFQwMXFhZUFQwsLC5iamsLV1RW2trbIysrCzJkzMX78+God5Y8//ogff/wRZWVlaN68ebXfKRXlVNfrhMnJycjNzUXz5s2Rl5cHS0tL2NvbK+dlaWlpSE9Ph7m5ORQKBUpKStCxY8dGH6jIzMyEv78/jIyMlGm9TnFxMZ49e4ZLly4hPz8fS5cuRWhoKKMFdObMGVy4cAHXr1/HiRMnMHLkSLi5uaF3797g8/msVEpCQgJOnDiB69ev4+DBg3B1dcWoUaPg7u6OIUOGsNYYbt68iT///BMymQyRkZHo06cPxo8fj65du2L8+PGMHOKoJD8/HykpKUqHEXZ2dkqjAJQft0xJSVEen7W2toa9vT3dSqqvgHVFSUkJ7t27h9zc3Fr3XjkcDoyNjZU9uq2tbZ3z5Pry5MkTPHv2TGk5CgoKwOVy0bJlS9YOFmRlZSEtLQ2lpaVo1qwZCgoKVDZypnn58iUePXoEhUJRLV0rKyt07NiRzj+pgCkUCqPTLVoEFAoVMIVCoQKmUChUwBQKFTCFQtF3/n8AzoAo/SfT0ioAAAAASUVORK5CYII="

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhFgAWAKECAN3q+8PZ/////////yH5BAEKAAIALAAAAAAWABYAAAJAlI+pFu0P3wmg2otBm7nbzXgeKFDAiaYqaaouyr6yFnCzG99rHepp7jsBg0NfUXe8JWdLGSsChUyiVN7iis1mCwA7"

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhFgAWAKECAPj4+Onp6f///////yH5BAEKAAIALAAAAAAWABYAAAJAlI+pFu0P3wmg2otBm7nbzXgeKFDAiaYqaaouyr6yFnCzG99rHepp7jsBg0NfUXe8JWdLGSsChUyiVN7iis1mCwA7"

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAAAlCAIAAACvYnI4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAvJJREFUeNrsWs9r01Acz0tf+vLSbOBlUISK1I2JitM5NwVBerCHKV7EqzfBk+DJf0EEDyJ4EATPMkSGQzYGmyi1/mJTtymrMifdYV5mbZLXNGlsbUm7rT+Sti9pMR++l7yX974fPnnf73vfJMAwDMbDLsDKi+8/Nmbm30iyQtVlQMDnzo7uDwUt3p/YkKbe/UorGlVWIobjI33hoFBFl+m5eCaj8jwGANBjkDOY+diidV2evd1UVIBwD1VWedVnPkmmLmxln6wQzo+oui9CIRnrN0tE5xB2gJWcKacUdkefA+6bgPOsYK2Oa1cutt3Z/UdPW5zhxoW+trO6M7m5u5F18iEoityBi5HIKZd16SJ4uni6eLp4uni6eLp0XN3I5GtrquV1c/O7wWqbLsY/o0igqfldYeXFkc36qJPgworpivziQiB1RX4pyEmTVZX5oRdGjddLh8ZRiTtt7b04sh9HZeb3Hk7QeY3UUt69/SRJ5D8OkIJ1HijmhU6QZQd4ocfp80sTK3Zk6OCxIwOLS6vxD8vUkpJh9+PfqcHek/3i+0T65UqqDXWjwPOlJWPZjh46gPzc0OGBrJq1PiqAeesUA7yPsUlrOCwijj3RL2pZYn2UyLPVdYlGxjBGRmnbqGl+xJn2NbGey+U+rySgD5iN9YfnXUTODFvXZXw0KCBgNALigGnLP6Vczlj4tgWBbjbWHy742ejxPaZT0MT36bsPHleO0grIwgK4Ysv1q5edP+XcmlivZKVrqpZVfZCDHCq23Ly0j259pCgSj8spOe86b66f/oiUqkzJEPrz5mzdSPv451R6roNtcfRlde357CuSURtvlrjBFk5qn30CAo5GTg+EQxYpLq39nowliaq3voXXOfuIGJ4f2zsY6q2yXqbnYqqmo3b8z1BHON1gXrxesK7LVDyZ1RmEAxZYGY2EE2t1aQwz+3Grui6yRAqiMIB2OZJO2/jFJk00hEUGANqhm1L0lvaj/wHee0xPFzv4K8AAP0DiDWBEKOoAAAAASUVORK5CYII="

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2045 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAYAAAAc0MJxAAAAAXNSR0IArs4c6QAAB8FJREFUeAHtnO9rHEUYx+82l6RJ7pJQS4nWpq21aFERKvhKUBD8d3wh+FIQ6gvxPxLEKr4QwYBoqVJrbforlLZcm0vSJJecn+9xs+5uZn//uNwlC5vdnZ155nk++8zMM7PZq9cq3nq9nvP8+fPFqampluM4c3t7e616vT7D3kAVs0urrnbya9+amJhY39/f39jZ2Vmfn59vk39fmara6lVUhKHN7e3tJcCcYj/Z7XYn8tTbaDT2gPaU/fH09PQa0Dp55CUpWxoo4Ey9ePHiDEa9itcsJlEmax68rQ38eydOnLgPtJ2scqLKFQ7q7t27M6dPn76I8st5PSdKcds9eRrb6qNHj26dPXt2y5Yna1phoG7evDm9vLz8Bp60jDKFyc1oWA/PWmX769KlS9sZZfiK5TYIMHWa2DKKXUbypE/68C920e8GTXIV/Xp51MkFam1tbW5hYeEKSpTaB+UxUGWB1X727NnK0tLSRlZZmUFtbGy8Qj/0LhVrSB+FrUv/9dvc3NyDLMqmBqWmRizzFscLWSocdhm8/zYx3PW0TTEVKOA4m5ubV/Ckl4dtcJ768ayHs7OzK8BKHLQmBgWkxtbW1vsEjC/lUfKwlCVYfTIzM/MLsDQDiN2c2BxkkCeNEyTZrAcum2RbEgaxmRBUV3MbF0/yQpFNsk02etNt57Gg1HGPep9kM9ykyTbZaK7DjpGgFAJAeyRHtzCDbemyUbba7pm0UFAKJgdxksk71kfZKpvDjLS2TbVZpiUfMCJkirhx5Q8Zgj9BzkUqng2rPGt6q9WqodvO7u7ulxx/zyonWA5920x3fkLmgemO1aOAdI7MmSBR9lNWDT6j0ndQpHBIxjj0m2L/ggeiSXghm2zWvNUm7AAorQJQ4E1b5rg0POkj4pOP4/IVeH+aOr/Cs84VJRPbL4tBUN4BUFoqIVOmVQA1t2AFZV/juQuAEqzzBdU1OWDgE+cDpUU3Kra6nq9UyAVlXwu5VXbyPKCu4s3ni6hIDMTCK8sHSiuT3LR28N5CEeel9UkRdZpb86zLXwVYEeFMfcDCyK65oKA4xRCZ2ZtciUM8wYZ5BpKr7Lk9WyzExJjjgqK3P1P1GrdRosgjxrUGzTAXLLEQE6ObC0pvS0ziqB+Bpddj8qzX89jiZdJfnRwIzhQ35VEkb1kMqbGuFCamyaT3a7zrG5rRz2GZotIZxRfFhpCh0/covZyMKnBY72FAbXJyMnQH0CQvSD/Po79h0/coyJ9iaM0jr9KyKF9jOTdpnbnW9MWGiv5u4FoOLnZylEARjde0J90immesCECdFCPRXhyH0S7W4owZxIYlmEWHIbCVUcaRKTb4zxuneWQszmgoza+p/mnkQSlM0OhX1iZGDYZY3+SvrMrKkquO2kDiRUGNuKnwqsRIoHINn4VrlUIgr8dr8qayNzFSLeXXVLAlKF4TJAJKV7JiqzK8aVDB6IGiY+1D0tFsgsTobS7LOFbgtwWqLQ+SJ8mjzMbb3lTBpymX9qhmp3fv5Q0ZaTUKya++SJC8W1mdt7eOwXm3ElC8AurXl7V5aFTzTkOYUtQEiajZYlMpSV3N9bpeVy66Gk1emcH3xarpMB1IVYXK818nbhlBkgxiGzet7BMxcvhT6H/PBpX2GmRrPsH83mt5oheSJu6dTqdSSNJHjByecqn/zC5Q3iaXFJYgGU+UspIjSMNY5YDRukPFpYKSkcHhOw6W+iMvJPVFgqRmN4wNRhsOT269isqTwtLIZqYk0ktBZNp+rWh7WPtaV9TW5glX0jNGwdKA0mw2fVMS5dfoNsxNbPSRkoOCeNb+06qUscESIO0aFc0WzGfSqz6KjRj15wFcPK5SgSAEAfJOSRRteweAKnUL1mXY9EHRca4FM5R9HYRl6lNTS7MebsqVdTRs+qBwrQ5PtV1WZWFyvbA0oqnTLnEFIEyN0HQxERtlcJdYGILvkVj5S1DBkgcNa+gPpcQNMTH3+x6lC8KE+1WNfqZyczyMkMRCTIyOLii8aYfod9XcOOpHsRATw8EFpQR9OclhOOGv0ehwHHsDFq42PlD6vBSKR96rxCD4qa0PlPDp81IOWV9lDDeMdp+/7yStTrsDBj4hB0DpG1w61xu+XAkveBL/JMxaWba0Osl223fIB0DJAnr7VQqkjquIO76tjEDCioj4E+skm2W7TbQVFE+hp29wKZBqrZXVyGso9p2tomGkSRci62sJ6+7KZtluy///6wzLXSJlfTf8nuVWZBIBZKmfeERWXqttYuwteTcP7oeYvO5twoFfWeJ54CYETiJBKS+R89u45IVAubG6BOxtPO+PKKOsTc9bgKdyHdoPvWnjdC7bZGOcTbGg1GZZml1hueFJnLBRuy+bZFtYv+S1JxaUMiNoXx8qjxMs2TL4+DrRP6/G9lFeqvRVx5/ze4FEnQPr+AciogAF7w1ChyPzkyOJ+qggJF0r5mi32z8qmrXdP0xp0lG6RsVJcfqm6qNswtQUeRGgT2v11ehh+68Y/SzSn0xL7iQZ2Wz2mbTMHmUESAFGj3/5EPB7zu+Qbp0CmPwVHXvSRTpJt7yQpHNujwoari8nj3+6LUgl4hqXP/4xwAg+1ltAO/55SSuZiESgeX+wtMlcS9/DJfnB0g7RdEf/MDGMHyz9Dzgp3MqdtIIVAAAAAElFTkSuQmCC"

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAYAAAAc0MJxAAAAAXNSR0IArs4c6QAABy9JREFUeAHtXE2MFEUUfq9nwMVhJLiwP1mEsESWZP1FNMSFCyQa9SAJEjHixZ9o4kVjPHjwYDQxhqh44ORqjGI0URM8ET1wEEwIoglGlD0IWaPJsOAqrOuB3enye1U7Y89M90z19HTPz85Leren+nW9V1+/evX7iilhUkotIZraQqRGyVUjxLwJKqzDlUUaLvmvaYaIcZFck6TUWXJ4AmlniPpOMfOcYUvmLychRqmLI0Tzu0jxDoCxjRRdG0ku078A7DixOkqUPsy8GgDGS7EBpdSVXqLZRwDOY7CGu2ItBvNJgPYRUeYT5uv+jENWw4FS6tIQufMvQvGnIltO2BKLpSl+l5z0fuZVf4R9vRp/w4CCBa0id/ZVYnocAC2tJjT2Z0xXocP75GRehoVdaoS8yEDBOTtwzk+Scl+Hctc3QqmG5cE0Tey8BOc/DufvRsk3ElBKXRiG//kY19YoSsT+LvMJtK6PMvefq1cWrKE+Aki7AdAPLQ+SFE8+JHTVOtdXXAoNlFQ1lc+9Ta77OYSvqFNu8q+JrtBZdDfuIpwKoaoeBCwllTsEX7QnnJgW42b6jHhgH/zWVVvNrIFSamo5HPaXsCJ0GjuAmI/C0T/I3PePTWmsqp6xpA4CSZCRD44Pr8tmgVRNoHR91tWtQyzJC4oGK3dIl9Gb7nNfEyhyL7zZ9j7Jp+DFJPG3UsYaVNVH6eZUWrfFQI7zEPpZXwQVNRCohc6k9JPapwsQVEqbdObL6JRuDuqU+lY945d0j3txgCRAikFglBHkr3yBwtgNI/8WH5bYWElYHl1mjFt9qKLq6VkANTvRsAHu5R8p/+tBUrPnfcTHl8S8lLh/Jzlr9xFds9pekB5IZ0bKZx0qLUqmSho5C7DiFkrdfpCcwfvtlW0Ap1JXyc0dofz3qBzTJ+1zlLILBmVUYlF60k3NnQNQkeaT3F9eIffSt1oUp7PkDO0mXvswuefHyf09sGEpU61xP5nTlLrtHaLlN9plKvNZvGTYO/lXalEyMxkRpHJN1PwM5Sc/IHdiPznrnyZn5R3lLLH/Vmqe3MkP7eUIBoKFh4pA6Tlumb6Nidypo6QufkPOhmfRCqdjkhKcrZo+FfzQ7wmwMPP+5mERKLMQEHF1xE+gJ039BV+xbA1xM6yK8h5NLG71ShEWRxbof6BktSQh4t6xhCRFFOPBRAOl193iXlLy6twz6P3VuvfAxKxJUmGGE4uTCRKno61/JqgqRBlsjFc1K7jJyUcznd7+dXLyokjS2NAbDsY2S/Qyd5TMOvpdtU0wgkVN3Ym+UyJ1QXrI+dPPJwgrU+rWt6LJE2x4aguAwq6ShEjN/U0kV0LEWLZuDKlRR2+9aUxunZuLqzY56CZjS06XqiIAjKTVk01ciVGcrd38sXviKsc66XBm48q9g/LNijNPFKgYv3qM30VluxZlB68Gyo51kXOJRcmu2y5VR2AGPkq2KCtsTE2G2rPV45muRdnZh1gUNrsT3WzHH52rPVs9mnSw0Bn7Zvbo8DY5B0RNOAibONtkNVpfPEJL4KP459bXtNka8hn4qL7viHPY8Z/MnFTbtXo67qbvlGOilBCA06UABPi4YCStHmofopQUxTb09mrQdq2ejuAqrsKkD3sL0733ImCwkQ4n5u4Q7yahXF0qRQCYFGIBTdWTxxLvpihcXN0VaTBVaeaSMtchw0cdA2iKV5x91xsS1OxvYVq//LF7wV4JVAVyTUqQxYXU9q/qky6tHWfWFgIlddWTnHSCBAWGoXQmDHd78QKLAkiieBEoXQpETuIjWMeHULvsIQj7iQQDwcJDJUDpHWYSOWlJnN1oydkktlRPfYKBgXe3nWRSApTOFeGlsKppGwnce7cNW/N4MhvCy5ayCwZlVAGU3g2rw0vLOH1+8srNxMuGfJ60RpIz+EB4RVB2jUHZmxVAmed94/DuJ8p4fX6m9L5MnwdNT2LsmOG+neH00GVG2X3IFygdqIwYXIB12eedkiTu3Uqp9bFt/SyRZfuDnR5KbXzBlt3wmRAPxB37B2n7AiVv6pgQ5idspPGaPZQafQ3V8AYb9lh5GG7XGcGG3sxwODkoa1AcjGRU7HAG5arjh0k9F/S8M9L5AKcGqu5Hqg2UnGugcp+iA97eccRBX9TEF+8NqnKF12oCJYzYcYag6wtHcLOj8GJH/Ndxxf33AaSanexAH+UFQmfEqV1wXDhdp0OoGHxdGyQpsZVFFaAxlrU4w/mtLKoAlLGsgb3A90Ahrf3+Q3ceEJ9Us7p5yxbKorwvLhw58h78VntEiZp+knQB6grvqhsoAW0h7rh7iI3XgvzuTae0f4wc5xnbgbRfPrGl6QGu6NY/Vq0zaSM/kkV5BegQ2+5BW15Iqt93j26rjk/FUxMU2D0MsAKYagnd4yWroRPwzAQp6QNLb1o4sFQCAmSvO3YnVz2wdGLhwNKfmnFg6X+VSXa+9xv7TAAAAABJRU5ErkJggg=="

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAYAAAAc0MJxAAAAAXNSR0IArs4c6QAABnRJREFUeAHtnD1oHEcUx1en749DELkzxKBGBiVNcELArlQEUkWgBGwSN4kDKZPChYtULkIIIeqduEmMA47BqdKpciA4JlUcrEaggDvbIJ10kk5f+f0vu8dqtbqd2a/bPd3Au5nbnZ1577dvZmd3Z7bPyTkcHh4OUuUFZPbg4GCmr6/vPOlzSNUnJJ2aT1Y57mmlUllm2xPkMcftEucW+vKoCSNnqGeeeI74EvFYknqBVOf4h8RLxA+IBTDTkBkoYEyh+RXiq8hbWVoBqEfIj9Rxl/hFFnWlDgooZ2lS11H4U9KJPMfWYOqsU+ctmug3pJ/ZHt8uf2qgUPAMgG6i4Mekh9pVmvU+dGigw22AfUn6eRr1JQaFQhUUuUb8FfJKGkqlVQaQXiI3KO974oMk5SYCBZhp5A7ydhIlsj4WSH8gHyIrceuSN8QKwFlA/io6JBknHV1dF2IZy0HWoKiwsr+//x390S+kJ+NWnPdx0lU6S3fZYFu/VdOjgiHkJ+QD24qKlJ8meA/5CGmY6mUMCjgTyK/InGnhRc4HpCXkPWTDRE8jUMCRJ/3WLZA8MC6sd4kjPSuyrQKngqi5dYUneZAUyybXtkgOkRnoAL+lsFL3SX44wbRsk43B7cH/bZsehSzoShE8qBv/M4p/nyZ4/yTbTgQFJA0mNU4qzRDgJCNNtgNpDXkDCR2UhjY94Khf0oj7VEASSNnq2hzKJHQjx+nOv9C3JSZeYpvHtfla2HHHmh6ZzyDLSCo3uHt7e87W1pZDXxdWf6bbhoaGnJGREYfmZFwPeXUjrSevR546HPMoDLqZFiRpNzAw4FSrVUdK5x0ajYazvr7u7O6aPzWW7WIQ1PUIajKdRVaQRFbV6/WWcjqb3pnd3t52dnZ2gjrk8n9iYsLp7+83qgudG8g00nr4d8SjIHk9KaSgJpTXhKPmp2YgD+tEsDlBYiAWfj1bHsXOKeRfJPHjW79H+SsbGxtrntVaTS9Y8g+Tk+YXcbypjryKNJ/B+z1KLwISQ2pnvjp2BnbO4KDeWBU7uCyueFq2QLHjqrcx67hTzc/WLj+TJig2zCCZvlLyKymvKkMQE7GRrp7G83kqTrvPs7qkdTXZNC9BUJtLWprN8bpM23SsNmWnnddl87Xu6dSzXkq7gi4qT1MABuVRb5LI9GrnQdMImYf73t9cYg00kwSxoau4IFCzSQqyOZZKcwdlo1+bvLMVRqDNXr1NplO/C0bnK7hVD1SEK4iRmp4mceUWsrzara2tZWXHOY2jqlmV3kXlVuVRuYLK8KxneV6qPY8yw9sEZZb1lOeSR3Xm4VC5wNfURwnUVF56l/SqV+t5lJmHND1qlbyvm+VPnqukV71VPT3IfDJ7crydLQFGWjVRedpZNYpfO4yW1Uf9U3xVO67hE131/uSmTzP+c3kmVbarntjA6LGeHuh988OOn7PiKqDFSbvyKE1iWMKj3slD17Jd9cRGXNRHKTz4P+r9hhBosmmCgtoy8igk06neJCZiIwieR6n5ab2bVdCLgjChGVuVU9TMfiatN5EYZz1Jowz9TdyrLJDCJ2mw4wWwbtmcXY6xyV6qvGIhJp7SRyxlp9VEso2NjcK/forjUQBqP5GMDM+AddujGBWbzmCLKqdo+8VALPx6HfEo7SCT8WRXzXfa3Nz0l1eotE6k7ZtiAJlNdiXjc+SGicWa51TkKTxxJtjKdjEI2n/Mo5QBr9Ljl9+RyLnmmk+gqYhFCzG9SUtqLyLH5nq3xlF+Q5UR0RrcyDeKmmaoSaxFC6Ojo1YqyVbX5mOQVFAoKO3goBXkE6WjwvDwsDM+Pl6YZuhNqo3S279ftspm/zZ/OrTp+TNoDS7/P/dv68L0Ik31i3Z2RYJy+6ufibtyzR5epPXFl5HQJufBiwSljEDqLZX1iLWLoa2R6jyy1C5fmfbJFkSLryPXE8uuEzvzoNEUWEO0UPlecF/Z/ssG1xajFeqyzxiUMlO4POsyyUX9L2lYlA2yxUZ/oz4qrED6LX1y5AfEfIFJWEE5bQOMxkkaAtyPU2VsUKoMSNOIltRGjuDjKJfWMcDp3EdsZAQKaFB6kfu9z4hfpmVYWuVIJ1c33ZacOJg0qS+RR/krwKt6H9ryA4lKA6z36bYoSP79ANOcq97HAP1QotJA631eMgpScD/QtEhJHyx9Tasm6GQF0eSDpcuaVULev5HcP1j6H5l0AsGGTETlAAAAAElFTkSuQmCC"

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(2);
	
	var vec2 = __webpack_require__(49);
	
	var Draggable = __webpack_require__(2080);
	
	var Eventful = __webpack_require__(148);
	
	var eventTool = __webpack_require__(104);
	
	var GestureMgr = __webpack_require__(2066);
	
	/**
	 * [The interface between `Handler` and `HandlerProxy`]:
	 *
	 * The default `HandlerProxy` only support the common standard web environment
	 * (e.g., standalone browser, headless browser, embed browser in mobild APP, ...).
	 * But `HandlerProxy` can be replaced to support more non-standard environment
	 * (e.g., mini app), or to support more feature that the default `HandlerProxy`
	 * not provided (like echarts-gl did).
	 * So the interface between `Handler` and `HandlerProxy` should be stable. Do not
	 * make break changes util inevitable. The interface include the public methods
	 * of `Handler` and the events listed in `handlerNames` below, by which `HandlerProxy`
	 * drives `Handler`.
	 */
	
	/**
	 * [Drag outside]:
	 *
	 * That is, triggering `mousemove` and `mouseup` event when the pointer is out of the
	 * zrender area when dragging. That is important for the improvement of the user experience
	 * when dragging something near the boundary without being terminated unexpectedly.
	 *
	 * We originally consider to introduce new events like `pagemovemove` and `pagemouseup`
	 * to resolve this issue. But some drawbacks of it is described in
	 * https://github.com/ecomfe/zrender/pull/536#issuecomment-560286899
	 *
	 * Instead, we referenced the specifications:
	 * https://www.w3.org/TR/touch-events/#the-touchmove-event
	 * https://www.w3.org/TR/2014/WD-DOM-Level-3-Events-20140925/#event-type-mousemove
	 * where the the mousemove/touchmove can be continue to fire if the user began a drag
	 * operation and the pointer has left the boundary. (for the mouse event, browsers
	 * only do it on `document` and when the pointer has left the boundary of the browser.)
	 *
	 * So the default `HandlerProxy` supports this feature similarly: if it is in the dragging
	 * state (see `pointerCapture` in `HandlerProxy`), the `mousemove` and `mouseup` continue
	 * to fire until release the pointer. That is implemented by listen to those event on
	 * `document`.
	 * If we implement some other `HandlerProxy` only for touch device, that would be easier.
	 * The touch event support this feature by default.
	 *
	 * Note:
	 * There might be some cases that the mouse event can not be
	 * received on `document`. For example,
	 * (A) `useCapture` is not supported and some user defined event listeners on the ancestor
	 * of zr dom throw Error .
	 * (B) `useCapture` is not supported Some user defined event listeners on the ancestor of
	 * zr dom call `stopPropagation`.
	 * In these cases, the `mousemove` event might be keep triggered event
	 * if the mouse is released. We try to reduce the side-effect in those cases.
	 * That is, do nothing (especially, `findHover`) in those cases. See `isOutsideBoundary`.
	 *
	 * Note:
	 * If `HandlerProxy` listens to `document` with `useCapture`, `HandlerProxy` needs to
	 * make sure `stopPropagation` and `preventDefault` doing nothing if and only if the event
	 * target is not zrender dom. Becuase it is dangerous to enable users to call them in
	 * `document` capture phase to prevent the propagation to any listener of the webpage.
	 * But they are needed to work when the pointer inside the zrender dom.
	 */
	var SILENT = 'silent';
	
	function makeEventPacket(eveType, targetInfo, event) {
	  return {
	    type: eveType,
	    event: event,
	    // target can only be an element that is not silent.
	    target: targetInfo.target,
	    // topTarget can be a silent element.
	    topTarget: targetInfo.topTarget,
	    cancelBubble: false,
	    offsetX: event.zrX,
	    offsetY: event.zrY,
	    gestureEvent: event.gestureEvent,
	    pinchX: event.pinchX,
	    pinchY: event.pinchY,
	    pinchScale: event.pinchScale,
	    wheelDelta: event.zrDelta,
	    zrByTouch: event.zrByTouch,
	    which: event.which,
	    stop: stopEvent
	  };
	}
	
	function stopEvent() {
	  eventTool.stop(this.event);
	}
	
	function EmptyProxy() {}
	
	EmptyProxy.prototype.dispose = function () {};
	
	var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	/**
	 * @alias module:zrender/Handler
	 * @constructor
	 * @extends module:zrender/mixin/Eventful
	 * @param {module:zrender/Storage} storage Storage instance.
	 * @param {module:zrender/Painter} painter Painter instance.
	 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
	 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
	 */
	
	var Handler = function (storage, painter, proxy, painterRoot) {
	  Eventful.call(this);
	  this.storage = storage;
	  this.painter = painter;
	  this.painterRoot = painterRoot;
	  proxy = proxy || new EmptyProxy();
	  /**
	   * Proxy of event. can be Dom, WebGLSurface, etc.
	   */
	
	  this.proxy = null;
	  /**
	   * {target, topTarget, x, y}
	   * @private
	   * @type {Object}
	   */
	
	  this._hovered = {};
	  /**
	   * @private
	   * @type {Date}
	   */
	
	  this._lastTouchMoment;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastX;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastY;
	  /**
	   * @private
	   * @type {module:zrender/core/GestureMgr}
	   */
	
	  this._gestureMgr;
	  Draggable.call(this);
	  this.setHandlerProxy(proxy);
	};
	
	Handler.prototype = {
	  constructor: Handler,
	  setHandlerProxy: function (proxy) {
	    if (this.proxy) {
	      this.proxy.dispose();
	    }
	
	    if (proxy) {
	      util.each(handlerNames, function (name) {
	        proxy.on && proxy.on(name, this[name], this);
	      }, this); // Attach handler
	
	      proxy.handler = this;
	    }
	
	    this.proxy = proxy;
	  },
	  mousemove: function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var isOutside = isOutsideBoundary(this, x, y);
	    var lastHovered = this._hovered;
	    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
	    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
	    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
	    // See #6198.
	
	    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
	      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
	      lastHoveredTarget = lastHovered.target;
	    }
	
	    var hovered = this._hovered = isOutside ? {
	      x: x,
	      y: y
	    } : this.findHover(x, y);
	    var hoveredTarget = hovered.target;
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element
	
	    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(lastHovered, 'mouseout', event);
	    } // Mouse moving on one element
	
	
	    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element
	
	    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(hovered, 'mouseover', event);
	    }
	  },
	  mouseout: function (event) {
	    var eventControl = event.zrEventControl;
	    var zrIsToLocalDOM = event.zrIsToLocalDOM;
	
	    if (eventControl !== 'only_globalout') {
	      this.dispatchToElement(this._hovered, 'mouseout', event);
	    }
	
	    if (eventControl !== 'no_globalout') {
	      // FIXME: if the pointer moving from the extra doms to realy "outside",
	      // the `globalout` should have been triggered. But currently not.
	      !zrIsToLocalDOM && this.trigger('globalout', {
	        type: 'globalout',
	        event: event
	      });
	    }
	  },
	
	  /**
	   * Resize
	   */
	  resize: function (event) {
	    this._hovered = {};
	  },
	
	  /**
	   * Dispatch event
	   * @param {string} eventName
	   * @param {event=} eventArgs
	   */
	  dispatch: function (eventName, eventArgs) {
	    var handler = this[eventName];
	    handler && handler.call(this, eventArgs);
	  },
	
	  /**
	   * Dispose
	   */
	  dispose: function () {
	    this.proxy.dispose();
	    this.storage = this.proxy = this.painter = null;
	  },
	
	  /**
	   * 设置默认的cursor style
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(cursorStyle);
	  },
	
	  /**
	   * 事件分发代理
	   *
	   * @private
	   * @param {Object} targetInfo {target, topTarget} 目标图形元素
	   * @param {string} eventName 事件名称
	   * @param {Object} event 事件对象
	   */
	  dispatchToElement: function (targetInfo, eventName, event) {
	    targetInfo = targetInfo || {};
	    var el = targetInfo.target;
	
	    if (el && el.silent) {
	      return;
	    }
	
	    var eventHandler = 'on' + eventName;
	    var eventPacket = makeEventPacket(eventName, targetInfo, event);
	
	    while (el) {
	      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
	      el.trigger(eventName, eventPacket);
	      el = el.parent;
	
	      if (eventPacket.cancelBubble) {
	        break;
	      }
	    }
	
	    if (!eventPacket.cancelBubble) {
	      // 冒泡到顶级 zrender 对象
	      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
	      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在
	
	      this.painter && this.painter.eachOtherLayer(function (layer) {
	        if (typeof layer[eventHandler] === 'function') {
	          layer[eventHandler].call(layer, eventPacket);
	        }
	
	        if (layer.trigger) {
	          layer.trigger(eventName, eventPacket);
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   * @param {number} x
	   * @param {number} y
	   * @param {module:zrender/graphic/Displayable} exclude
	   * @return {model:zrender/Element}
	   * @method
	   */
	  findHover: function (x, y, exclude) {
	    var list = this.storage.getDisplayList();
	    var out = {
	      x: x,
	      y: y
	    };
	
	    for (var i = list.length - 1; i >= 0; i--) {
	      var hoverCheckResult;
	
	      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
	      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
	        !out.topTarget && (out.topTarget = list[i]);
	
	        if (hoverCheckResult !== SILENT) {
	          out.target = list[i];
	          break;
	        }
	      }
	    }
	
	    return out;
	  },
	  processGesture: function (event, stage) {
	    if (!this._gestureMgr) {
	      this._gestureMgr = new GestureMgr();
	    }
	
	    var gestureMgr = this._gestureMgr;
	    stage === 'start' && gestureMgr.clear();
	    var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
	    stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.
	
	    if (gestureInfo) {
	      var type = gestureInfo.type;
	      event.gestureEvent = type;
	      this.dispatchToElement({
	        target: gestureInfo.target
	      }, type, gestureInfo.event);
	    }
	  }
	}; // Common handlers
	
	util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  Handler.prototype[name] = function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var isOutside = isOutsideBoundary(this, x, y);
	    var hovered;
	    var hoveredTarget;
	
	    if (name !== 'mouseup' || !isOutside) {
	      // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
	      hovered = this.findHover(x, y);
	      hoveredTarget = hovered.target;
	    }
	
	    if (name === 'mousedown') {
	      this._downEl = hoveredTarget;
	      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup
	
	      this._upEl = hoveredTarget;
	    } else if (name === 'mouseup') {
	      this._upEl = hoveredTarget;
	    } else if (name === 'click') {
	      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
	      // including the case that `mousedown` - `mousemove` - `mouseup`,
	      // which should be filtered, otherwise it will bring trouble to
	      // pan and zoom.
	      || !this._downPoint // Arbitrary value
	      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
	        return;
	      }
	
	      this._downPoint = null;
	    }
	
	    this.dispatchToElement(hovered, name, event);
	  };
	});
	
	function isHover(displayable, x, y) {
	  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
	    var el = displayable;
	    var isSilent;
	
	    while (el) {
	      // If clipped by ancestor.
	      // FIXME: If clipPath has neither stroke nor fill,
	      // el.clipPath.contain(x, y) will always return false.
	      if (el.clipPath && !el.clipPath.contain(x, y)) {
	        return false;
	      }
	
	      if (el.silent) {
	        isSilent = true;
	      }
	
	      el = el.parent;
	    }
	
	    return isSilent ? SILENT : true;
	  }
	
	  return false;
	}
	/**
	 * See [Drag outside].
	 */
	
	
	function isOutsideBoundary(handlerInstance, x, y) {
	  var painter = handlerInstance.painter;
	  return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
	}
	
	util.mixin(Handler, Eventful);
	util.mixin(Handler, Draggable);
	var _default = Handler;
	module.exports = _default;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(2);
	
	var _config = __webpack_require__(280);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var Style = __webpack_require__(449);
	
	var Pattern = __webpack_require__(905);
	
	/**
	 * @module zrender/Layer
	 * @author pissang(https://www.github.com/pissang)
	 */
	function returnFalse() {
	  return false;
	}
	/**
	 * 创建dom
	 *
	 * @inner
	 * @param {string} id dom id 待用
	 * @param {Painter} painter painter instance
	 * @param {number} number
	 */
	
	
	function createDom(id, painter, dpr) {
	  var newDom = util.createCanvas();
	  var width = painter.getWidth();
	  var height = painter.getHeight();
	  var newDomStyle = newDom.style;
	
	  if (newDomStyle) {
	    // In node or some other non-browser environment
	    newDomStyle.position = 'absolute';
	    newDomStyle.left = 0;
	    newDomStyle.top = 0;
	    newDomStyle.width = width + 'px';
	    newDomStyle.height = height + 'px';
	    newDom.setAttribute('data-zr-dom-id', id);
	  }
	
	  newDom.width = width * dpr;
	  newDom.height = height * dpr;
	  return newDom;
	}
	/**
	 * @alias module:zrender/Layer
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @param {string} id
	 * @param {module:zrender/Painter} painter
	 * @param {number} [dpr]
	 */
	
	
	var Layer = function (id, painter, dpr) {
	  var dom;
	  dpr = dpr || devicePixelRatio;
	
	  if (typeof id === 'string') {
	    dom = createDom(id, painter, dpr);
	  } // Not using isDom because in node it will return false
	  else if (util.isObject(id)) {
	      dom = id;
	      id = dom.id;
	    }
	
	  this.id = id;
	  this.dom = dom;
	  var domStyle = dom.style;
	
	  if (domStyle) {
	    // Not in node
	    dom.onselectstart = returnFalse; // 避免页面选中的尴尬
	
	    domStyle['-webkit-user-select'] = 'none';
	    domStyle['user-select'] = 'none';
	    domStyle['-webkit-touch-callout'] = 'none';
	    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
	    domStyle['padding'] = 0; // eslint-disable-line dot-notation
	
	    domStyle['margin'] = 0; // eslint-disable-line dot-notation
	
	    domStyle['border-width'] = 0;
	  }
	
	  this.domBack = null;
	  this.ctxBack = null;
	  this.painter = painter;
	  this.config = null; // Configs
	
	  /**
	   * 每次清空画布的颜色
	   * @type {string}
	   * @default 0
	   */
	
	  this.clearColor = 0;
	  /**
	   * 是否开启动态模糊
	   * @type {boolean}
	   * @default false
	   */
	
	  this.motionBlur = false;
	  /**
	   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   * @type {number}
	   * @default 0.7
	   */
	
	  this.lastFrameAlpha = 0.7;
	  /**
	   * Layer dpr
	   * @type {number}
	   */
	
	  this.dpr = dpr;
	};
	
	Layer.prototype = {
	  constructor: Layer,
	  __dirty: true,
	  __used: false,
	  __drawIndex: 0,
	  __startIndex: 0,
	  __endIndex: 0,
	  incremental: false,
	  getElementCount: function () {
	    return this.__endIndex - this.__startIndex;
	  },
	  initContext: function () {
	    this.ctx = this.dom.getContext('2d');
	    this.ctx.dpr = this.dpr;
	  },
	  createBackBuffer: function () {
	    var dpr = this.dpr;
	    this.domBack = createDom('back-' + this.id, this.painter, dpr);
	    this.ctxBack = this.domBack.getContext('2d');
	
	    if (dpr !== 1) {
	      this.ctxBack.scale(dpr, dpr);
	    }
	  },
	
	  /**
	   * @param  {number} width
	   * @param  {number} height
	   */
	  resize: function (width, height) {
	    var dpr = this.dpr;
	    var dom = this.dom;
	    var domStyle = dom.style;
	    var domBack = this.domBack;
	
	    if (domStyle) {
	      domStyle.width = width + 'px';
	      domStyle.height = height + 'px';
	    }
	
	    dom.width = width * dpr;
	    dom.height = height * dpr;
	
	    if (domBack) {
	      domBack.width = width * dpr;
	      domBack.height = height * dpr;
	
	      if (dpr !== 1) {
	        this.ctxBack.scale(dpr, dpr);
	      }
	    }
	  },
	
	  /**
	   * 清空该层画布
	   * @param {boolean} [clearAll]=false Clear all with out motion blur
	   * @param {Color} [clearColor]
	   */
	  clear: function (clearAll, clearColor) {
	    var dom = this.dom;
	    var ctx = this.ctx;
	    var width = dom.width;
	    var height = dom.height;
	    var clearColor = clearColor || this.clearColor;
	    var haveMotionBLur = this.motionBlur && !clearAll;
	    var lastFrameAlpha = this.lastFrameAlpha;
	    var dpr = this.dpr;
	
	    if (haveMotionBLur) {
	      if (!this.domBack) {
	        this.createBackBuffer();
	      }
	
	      this.ctxBack.globalCompositeOperation = 'copy';
	      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
	    }
	
	    ctx.clearRect(0, 0, width, height);
	
	    if (clearColor && clearColor !== 'transparent') {
	      var clearColorGradientOrPattern; // Gradient
	
	      if (clearColor.colorStops) {
	        // Cache canvas gradient
	        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        });
	        clearColor.__canvasGradient = clearColorGradientOrPattern;
	      } // Pattern
	      else if (clearColor.image) {
	          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
	        }
	
	      ctx.save();
	      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
	      ctx.fillRect(0, 0, width, height);
	      ctx.restore();
	    }
	
	    if (haveMotionBLur) {
	      var domBack = this.domBack;
	      ctx.save();
	      ctx.globalAlpha = lastFrameAlpha;
	      ctx.drawImage(domBack, 0, 0, width, height);
	      ctx.restore();
	    }
	  }
	};
	var _default = Layer;
	module.exports = _default;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(280);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var util = __webpack_require__(2);
	
	var logError = __webpack_require__(227);
	
	var BoundingRect = __webpack_require__(51);
	
	var timsort = __webpack_require__(446);
	
	var Layer = __webpack_require__(2057);
	
	var requestAnimationFrame = __webpack_require__(896);
	
	var Image = __webpack_require__(181);
	
	var env = __webpack_require__(58);
	
	var HOVER_LAYER_ZLEVEL = 1e5;
	var CANVAS_ZLEVEL = 314159;
	var EL_AFTER_INCREMENTAL_INC = 0.01;
	var INCREMENTAL_INC = 0.001;
	
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function isLayerValid(layer) {
	  if (!layer) {
	    return false;
	  }
	
	  if (layer.__builtin__) {
	    return true;
	  }
	
	  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
	    return false;
	  }
	
	  return true;
	}
	
	var tmpRect = new BoundingRect(0, 0, 0, 0);
	var viewRect = new BoundingRect(0, 0, 0, 0);
	
	function isDisplayableCulled(el, width, height) {
	  tmpRect.copy(el.getBoundingRect());
	
	  if (el.transform) {
	    tmpRect.applyTransform(el.transform);
	  }
	
	  viewRect.width = width;
	  viewRect.height = height;
	  return !tmpRect.intersect(viewRect);
	}
	
	function isClipPathChanged(clipPaths, prevClipPaths) {
	  // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
	  if (clipPaths === prevClipPaths) {
	    return false;
	  }
	
	  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
	    return true;
	  }
	
	  for (var i = 0; i < clipPaths.length; i++) {
	    if (clipPaths[i] !== prevClipPaths[i]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function doClip(clipPaths, ctx) {
	  for (var i = 0; i < clipPaths.length; i++) {
	    var clipPath = clipPaths[i];
	    clipPath.setTransform(ctx);
	    ctx.beginPath();
	    clipPath.buildPath(ctx, clipPath.shape);
	    ctx.clip(); // Transform back
	
	    clipPath.restoreTransform(ctx);
	  }
	}
	
	function createRoot(width, height) {
	  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // Avoid page selected
	
	  domRoot.style.cssText = ['position:relative', // IOS13 safari probably has a compositing bug (z order of the canvas and the consequent
	  // dom does not act as expected) when some of the parent dom has
	  // `-webkit-overflow-scrolling: touch;` and the webpage is longer than one screen and
	  // the canvas is not at the top part of the page.
	  // Check `https://bugs.webkit.org/show_bug.cgi?id=203681` for more details. We remove
	  // this `overflow:hidden` to avoid the bug.
	  // 'overflow:hidden',
	  'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
	  return domRoot;
	}
	/**
	 * @alias module:zrender/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var Painter = function (root, storage, opts) {
	  this.type = 'canvas'; // In node environment using node-canvas
	
	  var singleCanvas = !root.nodeName // In node ?
	  || root.nodeName.toUpperCase() === 'CANVAS';
	  this._opts = opts = util.extend({}, opts || {});
	  /**
	   * @type {number}
	   */
	
	  this.dpr = opts.devicePixelRatio || devicePixelRatio;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._singleCanvas = singleCanvas;
	  /**
	   * 绘图容器
	   * @type {HTMLElement}
	   */
	
	  this.root = root;
	  var rootStyle = root.style;
	
	  if (rootStyle) {
	    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
	    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
	    root.innerHTML = '';
	  }
	  /**
	   * @type {module:zrender/Storage}
	   */
	
	
	  this.storage = storage;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  var zlevelList = this._zlevelList = [];
	  /**
	   * @type {Object.<string, module:zrender/Layer>}
	   * @private
	   */
	
	  var layers = this._layers = {};
	  /**
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._layerConfig = {};
	  /**
	   * zrender will do compositing when root is a canvas and have multiple zlevels.
	   */
	
	  this._needsManuallyCompositing = false;
	
	  if (!singleCanvas) {
	    this._width = this._getSize(0);
	    this._height = this._getSize(1);
	    var domRoot = this._domRoot = createRoot(this._width, this._height);
	    root.appendChild(domRoot);
	  } else {
	    var width = root.width;
	    var height = root.height;
	
	    if (opts.width != null) {
	      width = opts.width;
	    }
	
	    if (opts.height != null) {
	      height = opts.height;
	    }
	
	    this.dpr = opts.devicePixelRatio || 1; // Use canvas width and height directly
	
	    root.width = width * this.dpr;
	    root.height = height * this.dpr;
	    this._width = width;
	    this._height = height; // Create layer if only one given canvas
	    // Device can be specified to create a high dpi image.
	
	    var mainLayer = new Layer(root, this, this.dpr);
	    mainLayer.__builtin__ = true;
	    mainLayer.initContext(); // FIXME Use canvas width and height
	    // mainLayer.resize(width, height);
	
	    layers[CANVAS_ZLEVEL] = mainLayer;
	    mainLayer.zlevel = CANVAS_ZLEVEL; // Not use common zlevel.
	
	    zlevelList.push(CANVAS_ZLEVEL);
	    this._domRoot = root;
	  }
	  /**
	   * @type {module:zrender/Layer}
	   * @private
	   */
	
	
	  this._hoverlayer = null;
	  this._hoverElements = [];
	};
	
	Painter.prototype = {
	  constructor: Painter,
	  getType: function () {
	    return 'canvas';
	  },
	
	  /**
	   * If painter use a single canvas
	   * @return {boolean}
	   */
	  isSingleCanvas: function () {
	    return this._singleCanvas;
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._domRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   * @param {boolean} [paintAll=false] 强制绘制所有displayable
	   */
	  refresh: function (paintAll) {
	    var list = this.storage.getDisplayList(true);
	    var zlevelList = this._zlevelList;
	    this._redrawId = Math.random();
	
	    this._paintList(list, paintAll, this._redrawId); // Paint custum layers
	
	
	    for (var i = 0; i < zlevelList.length; i++) {
	      var z = zlevelList[i];
	      var layer = this._layers[z];
	
	      if (!layer.__builtin__ && layer.refresh) {
	        var clearColor = i === 0 ? this._backgroundColor : null;
	        layer.refresh(clearColor);
	      }
	    }
	
	    this.refreshHover();
	    return this;
	  },
	  addHover: function (el, hoverStyle) {
	    if (el.__hoverMir) {
	      return;
	    }
	
	    var elMirror = new el.constructor({
	      style: el.style,
	      shape: el.shape,
	      z: el.z,
	      z2: el.z2,
	      silent: el.silent
	    });
	    elMirror.__from = el;
	    el.__hoverMir = elMirror;
	    hoverStyle && elMirror.setStyle(hoverStyle);
	
	    this._hoverElements.push(elMirror);
	
	    return elMirror;
	  },
	  removeHover: function (el) {
	    var elMirror = el.__hoverMir;
	    var hoverElements = this._hoverElements;
	    var idx = util.indexOf(hoverElements, elMirror);
	
	    if (idx >= 0) {
	      hoverElements.splice(idx, 1);
	    }
	
	    el.__hoverMir = null;
	  },
	  clearHover: function (el) {
	    var hoverElements = this._hoverElements;
	
	    for (var i = 0; i < hoverElements.length; i++) {
	      var from = hoverElements[i].__from;
	
	      if (from) {
	        from.__hoverMir = null;
	      }
	    }
	
	    hoverElements.length = 0;
	  },
	  refreshHover: function () {
	    var hoverElements = this._hoverElements;
	    var len = hoverElements.length;
	    var hoverLayer = this._hoverlayer;
	    hoverLayer && hoverLayer.clear();
	
	    if (!len) {
	      return;
	    }
	
	    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
	    // FIXME?
	
	    if (!hoverLayer) {
	      hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
	    }
	
	    var scope = {};
	    hoverLayer.ctx.save();
	
	    for (var i = 0; i < len;) {
	      var el = hoverElements[i];
	      var originalEl = el.__from; // Original el is removed
	      // PENDING
	
	      if (!(originalEl && originalEl.__zr)) {
	        hoverElements.splice(i, 1);
	        originalEl.__hoverMir = null;
	        len--;
	        continue;
	      }
	
	      i++; // Use transform
	      // FIXME style and shape ?
	
	      if (!originalEl.invisible) {
	        el.transform = originalEl.transform;
	        el.invTransform = originalEl.invTransform;
	        el.__clipPaths = originalEl.__clipPaths; // el.
	
	        this._doPaintEl(el, hoverLayer, true, scope);
	      }
	    }
	
	    hoverLayer.ctx.restore();
	  },
	  getHoverLayer: function () {
	    return this.getLayer(HOVER_LAYER_ZLEVEL);
	  },
	  _paintList: function (list, paintAll, redrawId) {
	    if (this._redrawId !== redrawId) {
	      return;
	    }
	
	    paintAll = paintAll || false;
	
	    this._updateLayerStatus(list);
	
	    var finished = this._doPaintList(list, paintAll);
	
	    if (this._needsManuallyCompositing) {
	      this._compositeManually();
	    }
	
	    if (!finished) {
	      var self = this;
	      requestAnimationFrame(function () {
	        self._paintList(list, paintAll, redrawId);
	      });
	    }
	  },
	  _compositeManually: function () {
	    var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
	    var width = this._domRoot.width;
	    var height = this._domRoot.height;
	    ctx.clearRect(0, 0, width, height); // PENDING, If only builtin layer?
	
	    this.eachBuiltinLayer(function (layer) {
	      if (layer.virtual) {
	        ctx.drawImage(layer.dom, 0, 0, width, height);
	      }
	    });
	  },
	  _doPaintList: function (list, paintAll) {
	    var layerList = [];
	
	    for (var zi = 0; zi < this._zlevelList.length; zi++) {
	      var zlevel = this._zlevelList[zi];
	      var layer = this._layers[zlevel];
	
	      if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) {
	        layerList.push(layer);
	      }
	    }
	
	    var finished = true;
	
	    for (var k = 0; k < layerList.length; k++) {
	      var layer = layerList[k];
	      var ctx = layer.ctx;
	      var scope = {};
	      ctx.save();
	      var start = paintAll ? layer.__startIndex : layer.__drawIndex;
	      var useTimer = !paintAll && layer.incremental && Date.now;
	      var startTime = useTimer && Date.now();
	      var clearColor = layer.zlevel === this._zlevelList[0] ? this._backgroundColor : null; // All elements in this layer are cleared.
	
	      if (layer.__startIndex === layer.__endIndex) {
	        layer.clear(false, clearColor);
	      } else if (start === layer.__startIndex) {
	        var firstEl = list[start];
	
	        if (!firstEl.incremental || !firstEl.notClear || paintAll) {
	          layer.clear(false, clearColor);
	        }
	      }
	
	      if (start === -1) {
	        console.error('For some unknown reason. drawIndex is -1');
	        start = layer.__startIndex;
	      }
	
	      for (var i = start; i < layer.__endIndex; i++) {
	        var el = list[i];
	
	        this._doPaintEl(el, layer, paintAll, scope);
	
	        el.__dirty = el.__dirtyText = false;
	
	        if (useTimer) {
	          // Date.now can be executed in 13,025,305 ops/second.
	          var dTime = Date.now() - startTime; // Give 15 millisecond to draw.
	          // The rest elements will be drawn in the next frame.
	
	          if (dTime > 15) {
	            break;
	          }
	        }
	      }
	
	      layer.__drawIndex = i;
	
	      if (layer.__drawIndex < layer.__endIndex) {
	        finished = false;
	      }
	
	      if (scope.prevElClipPaths) {
	        // Needs restore the state. If last drawn element is in the clipping area.
	        ctx.restore();
	      }
	
	      ctx.restore();
	    }
	
	    if (env.wxa) {
	      // Flush for weixin application
	      util.each(this._layers, function (layer) {
	        if (layer && layer.ctx && layer.ctx.draw) {
	          layer.ctx.draw();
	        }
	      });
	    }
	
	    return finished;
	  },
	  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
	    var ctx = currentLayer.ctx;
	    var m = el.transform;
	
	    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
	    !el.invisible // Ignore transparent element
	    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
	    // Draw a scale 0 element can cause all following draw wrong
	    // And setTransform with scale 0 will cause set back transform failed.
	    && !(m && !m[0] && !m[3]) // Ignore culled element
	    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
	      var clipPaths = el.__clipPaths;
	      var prevElClipPaths = scope.prevElClipPaths; // Optimize when clipping on group with several elements
	
	      if (!prevElClipPaths || isClipPathChanged(clipPaths, prevElClipPaths)) {
	        // If has previous clipping state, restore from it
	        if (prevElClipPaths) {
	          ctx.restore();
	          scope.prevElClipPaths = null; // Reset prevEl since context has been restored
	
	          scope.prevEl = null;
	        } // New clipping state
	
	
	        if (clipPaths) {
	          ctx.save();
	          doClip(clipPaths, ctx);
	          scope.prevElClipPaths = clipPaths;
	        }
	      }
	
	      el.beforeBrush && el.beforeBrush(ctx);
	      el.brush(ctx, scope.prevEl || null);
	      scope.prevEl = el;
	      el.afterBrush && el.afterBrush(ctx);
	    }
	  },
	
	  /**
	   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
	   * @param {number} zlevel
	   * @param {boolean} virtual Virtual layer will not be inserted into dom.
	   * @return {module:zrender/Layer}
	   */
	  getLayer: function (zlevel, virtual) {
	    if (this._singleCanvas && !this._needsManuallyCompositing) {
	      zlevel = CANVAS_ZLEVEL;
	    }
	
	    var layer = this._layers[zlevel];
	
	    if (!layer) {
	      // Create a new layer
	      layer = new Layer('zr_' + zlevel, this, this.dpr);
	      layer.zlevel = zlevel;
	      layer.__builtin__ = true;
	
	      if (this._layerConfig[zlevel]) {
	        util.merge(layer, this._layerConfig[zlevel], true);
	      } // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
	      else if (this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC]) {
	          util.merge(layer, this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC], true);
	        }
	
	      if (virtual) {
	        layer.virtual = virtual;
	      }
	
	      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
	      // Or excanvas will get 0px clientWidth and clientHeight
	
	      layer.initContext();
	    }
	
	    return layer;
	  },
	  insertLayer: function (zlevel, layer) {
	    var layersMap = this._layers;
	    var zlevelList = this._zlevelList;
	    var len = zlevelList.length;
	    var prevLayer = null;
	    var i = -1;
	    var domRoot = this._domRoot;
	
	    if (layersMap[zlevel]) {
	      logError('ZLevel ' + zlevel + ' has been used already');
	      return;
	    } // Check if is a valid layer
	
	
	    if (!isLayerValid(layer)) {
	      logError('Layer of zlevel ' + zlevel + ' is not valid');
	      return;
	    }
	
	    if (len > 0 && zlevel > zlevelList[0]) {
	      for (i = 0; i < len - 1; i++) {
	        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
	          break;
	        }
	      }
	
	      prevLayer = layersMap[zlevelList[i]];
	    }
	
	    zlevelList.splice(i + 1, 0, zlevel);
	    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
	    // (It can be a WebGL layer and assigned to a ZImage element)
	    // But it still under management of zrender.
	
	    if (!layer.virtual) {
	      if (prevLayer) {
	        var prevDom = prevLayer.dom;
	
	        if (prevDom.nextSibling) {
	          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      } else {
	        if (domRoot.firstChild) {
	          domRoot.insertBefore(layer.dom, domRoot.firstChild);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      }
	    }
	  },
	  // Iterate each layer
	  eachLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      cb.call(context, this._layers[z], z);
	    }
	  },
	  // Iterate each buildin layer
	  eachBuiltinLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	  // Iterate each other layer except buildin layer
	  eachOtherLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (!layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	
	  /**
	   * 获取所有已创建的层
	   * @param {Array.<module:zrender/Layer>} [prevLayer]
	   */
	  getLayers: function () {
	    return this._layers;
	  },
	  _updateLayerStatus: function (list) {
	    this.eachBuiltinLayer(function (layer, z) {
	      layer.__dirty = layer.__used = false;
	    });
	
	    function updatePrevLayer(idx) {
	      if (prevLayer) {
	        if (prevLayer.__endIndex !== idx) {
	          prevLayer.__dirty = true;
	        }
	
	        prevLayer.__endIndex = idx;
	      }
	    }
	
	    if (this._singleCanvas) {
	      for (var i = 1; i < list.length; i++) {
	        var el = list[i];
	
	        if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
	          this._needsManuallyCompositing = true;
	          break;
	        }
	      }
	    }
	
	    var prevLayer = null;
	    var incrementalLayerCount = 0;
	    var prevZlevel;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	      var zlevel = el.zlevel;
	      var layer;
	
	      if (prevZlevel !== zlevel) {
	        prevZlevel = zlevel;
	        incrementalLayerCount = 0;
	      } // TODO Not use magic number on zlevel.
	      // Each layer with increment element can be separated to 3 layers.
	      //          (Other Element drawn after incremental element)
	      // -----------------zlevel + EL_AFTER_INCREMENTAL_INC--------------------
	      //                      (Incremental element)
	      // ----------------------zlevel + INCREMENTAL_INC------------------------
	      //              (Element drawn before incremental element)
	      // --------------------------------zlevel--------------------------------
	
	
	      if (el.incremental) {
	        layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
	        layer.incremental = true;
	        incrementalLayerCount = 1;
	      } else {
	        layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
	      }
	
	      if (!layer.__builtin__) {
	        logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
	      }
	
	      if (layer !== prevLayer) {
	        layer.__used = true;
	
	        if (layer.__startIndex !== i) {
	          layer.__dirty = true;
	        }
	
	        layer.__startIndex = i;
	
	        if (!layer.incremental) {
	          layer.__drawIndex = i;
	        } else {
	          // Mark layer draw index needs to update.
	          layer.__drawIndex = -1;
	        }
	
	        updatePrevLayer(i);
	        prevLayer = layer;
	      }
	
	      if (el.__dirty) {
	        layer.__dirty = true;
	
	        if (layer.incremental && layer.__drawIndex < 0) {
	          // Start draw from the first dirty element.
	          layer.__drawIndex = i;
	        }
	      }
	    }
	
	    updatePrevLayer(i);
	    this.eachBuiltinLayer(function (layer, z) {
	      // Used in last frame but not in this frame. Needs clear
	      if (!layer.__used && layer.getElementCount() > 0) {
	        layer.__dirty = true;
	        layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
	      } // For incremental layer. In case start index changed and no elements are dirty.
	
	
	      if (layer.__dirty && layer.__drawIndex < 0) {
	        layer.__drawIndex = layer.__startIndex;
	      }
	    });
	  },
	
	  /**
	   * 清除hover层外所有内容
	   */
	  clear: function () {
	    this.eachBuiltinLayer(this._clearLayer);
	    return this;
	  },
	  _clearLayer: function (layer) {
	    layer.clear();
	  },
	  setBackgroundColor: function (backgroundColor) {
	    this._backgroundColor = backgroundColor;
	  },
	
	  /**
	   * 修改指定zlevel的绘制参数
	   *
	   * @param {string} zlevel
	   * @param {Object} config 配置对象
	   * @param {string} [config.clearColor=0] 每次清空画布的颜色
	   * @param {string} [config.motionBlur=false] 是否开启动态模糊
	   * @param {number} [config.lastFrameAlpha=0.7]
	   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   */
	  configLayer: function (zlevel, config) {
	    if (config) {
	      var layerConfig = this._layerConfig;
	
	      if (!layerConfig[zlevel]) {
	        layerConfig[zlevel] = config;
	      } else {
	        util.merge(layerConfig[zlevel], config, true);
	      }
	
	      for (var i = 0; i < this._zlevelList.length; i++) {
	        var _zlevel = this._zlevelList[i]; // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
	
	        if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
	          var layer = this._layers[_zlevel];
	          util.merge(layer, layerConfig[zlevel], true);
	        }
	      }
	    }
	  },
	
	  /**
	   * 删除指定层
	   * @param {number} zlevel 层所在的zlevel
	   */
	  delLayer: function (zlevel) {
	    var layers = this._layers;
	    var zlevelList = this._zlevelList;
	    var layer = layers[zlevel];
	
	    if (!layer) {
	      return;
	    }
	
	    layer.dom.parentNode.removeChild(layer.dom);
	    delete layers[zlevel];
	    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
	  },
	
	  /**
	   * 区域大小变化后重绘
	   */
	  resize: function (width, height) {
	    if (!this._domRoot.style) {
	      // Maybe in node or worker
	      if (width == null || height == null) {
	        return;
	      }
	
	      this._width = width;
	      this._height = height;
	      this.getLayer(CANVAS_ZLEVEL).resize(width, height);
	    } else {
	      var domRoot = this._domRoot; // FIXME Why ?
	
	      domRoot.style.display = 'none'; // Save input w/h
	
	      var opts = this._opts;
	      width != null && (opts.width = width);
	      height != null && (opts.height = height);
	      width = this._getSize(0);
	      height = this._getSize(1);
	      domRoot.style.display = ''; // 优化没有实际改变的resize
	
	      if (this._width !== width || height !== this._height) {
	        domRoot.style.width = width + 'px';
	        domRoot.style.height = height + 'px';
	
	        for (var id in this._layers) {
	          if (this._layers.hasOwnProperty(id)) {
	            this._layers[id].resize(width, height);
	          }
	        }
	
	        util.each(this._progressiveLayers, function (layer) {
	          layer.resize(width, height);
	        });
	        this.refresh(true);
	      }
	
	      this._width = width;
	      this._height = height;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清除单独的一个层
	   * @param {number} zlevel
	   */
	  clearLayer: function (zlevel) {
	    var layer = this._layers[zlevel];
	
	    if (layer) {
	      layer.clear();
	    }
	  },
	
	  /**
	   * 释放
	   */
	  dispose: function () {
	    this.root.innerHTML = '';
	    this.root = this.storage = this._domRoot = this._layers = null;
	  },
	
	  /**
	   * Get canvas which has all thing rendered
	   * @param {Object} opts
	   * @param {string} [opts.backgroundColor]
	   * @param {number} [opts.pixelRatio]
	   */
	  getRenderedCanvas: function (opts) {
	    opts = opts || {};
	
	    if (this._singleCanvas && !this._compositeManually) {
	      return this._layers[CANVAS_ZLEVEL].dom;
	    }
	
	    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
	    imageLayer.initContext();
	    imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
	
	    if (opts.pixelRatio <= this.dpr) {
	      this.refresh();
	      var width = imageLayer.dom.width;
	      var height = imageLayer.dom.height;
	      var ctx = imageLayer.ctx;
	      this.eachLayer(function (layer) {
	        if (layer.__builtin__) {
	          ctx.drawImage(layer.dom, 0, 0, width, height);
	        } else if (layer.renderToCanvas) {
	          imageLayer.ctx.save();
	          layer.renderToCanvas(imageLayer.ctx);
	          imageLayer.ctx.restore();
	        }
	      });
	    } else {
	      // PENDING, echarts-gl and incremental rendering.
	      var scope = {};
	      var displayList = this.storage.getDisplayList(true);
	
	      for (var i = 0; i < displayList.length; i++) {
	        var el = displayList[i];
	
	        this._doPaintEl(el, imageLayer, true, scope);
	      }
	    }
	
	    return imageLayer.dom;
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  pathToImage: function (path, dpr) {
	    dpr = dpr || this.dpr;
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    var rect = path.getBoundingRect();
	    var style = path.style;
	    var shadowBlurSize = style.shadowBlur * dpr;
	    var shadowOffsetX = style.shadowOffsetX * dpr;
	    var shadowOffsetY = style.shadowOffsetY * dpr;
	    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
	    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
	    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
	    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
	    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
	    var width = rect.width + leftMargin + rightMargin;
	    var height = rect.height + topMargin + bottomMargin;
	    canvas.width = width * dpr;
	    canvas.height = height * dpr;
	    ctx.scale(dpr, dpr);
	    ctx.clearRect(0, 0, width, height);
	    ctx.dpr = dpr;
	    var pathTransform = {
	      position: path.position,
	      rotation: path.rotation,
	      scale: path.scale
	    };
	    path.position = [leftMargin - rect.x, topMargin - rect.y];
	    path.rotation = 0;
	    path.scale = [1, 1];
	    path.updateTransform();
	
	    if (path) {
	      path.brush(ctx);
	    }
	
	    var ImageShape = Image;
	    var imgShape = new ImageShape({
	      style: {
	        x: 0,
	        y: 0,
	        image: canvas
	      }
	    });
	
	    if (pathTransform.position != null) {
	      imgShape.position = path.position = pathTransform.position;
	    }
	
	    if (pathTransform.rotation != null) {
	      imgShape.rotation = path.rotation = pathTransform.rotation;
	    }
	
	    if (pathTransform.scale != null) {
	      imgShape.scale = path.scale = pathTransform.scale;
	    }
	
	    return imgShape;
	  }
	};
	var _default = Painter;
	module.exports = _default;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(2);
	
	var env = __webpack_require__(58);
	
	var Group = __webpack_require__(146);
	
	var timsort = __webpack_require__(446);
	
	// Use timsort because in most case elements are partially sorted
	// https://jsfiddle.net/pissang/jr4x7mdm/8/
	function shapeCompareFunc(a, b) {
	  if (a.zlevel === b.zlevel) {
	    if (a.z === b.z) {
	      // if (a.z2 === b.z2) {
	      //     // FIXME Slow has renderidx compare
	      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
	      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
	      //     return a.__renderidx - b.__renderidx;
	      // }
	      return a.z2 - b.z2;
	    }
	
	    return a.z - b.z;
	  }
	
	  return a.zlevel - b.zlevel;
	}
	/**
	 * 内容仓库 (M)
	 * @alias module:zrender/Storage
	 * @constructor
	 */
	
	
	var Storage = function () {
	  // jshint ignore:line
	  this._roots = [];
	  this._displayList = [];
	  this._displayListLen = 0;
	};
	
	Storage.prototype = {
	  constructor: Storage,
	
	  /**
	   * @param  {Function} cb
	   *
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._roots.length; i++) {
	      this._roots[i].traverse(cb, context);
	    }
	  },
	
	  /**
	   * 返回所有图形的绘制队列
	   * @param {boolean} [update=false] 是否在返回前更新该数组
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
	   *
	   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
	   * @return {Array.<module:zrender/graphic/Displayable>}
	   */
	  getDisplayList: function (update, includeIgnore) {
	    includeIgnore = includeIgnore || false;
	
	    if (update) {
	      this.updateDisplayList(includeIgnore);
	    }
	
	    return this._displayList;
	  },
	
	  /**
	   * 更新图形的绘制队列。
	   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
	   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
	   */
	  updateDisplayList: function (includeIgnore) {
	    this._displayListLen = 0;
	    var roots = this._roots;
	    var displayList = this._displayList;
	
	    for (var i = 0, len = roots.length; i < len; i++) {
	      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
	    }
	
	    displayList.length = this._displayListLen;
	    env.canvasSupported && timsort(displayList, shapeCompareFunc);
	  },
	  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
	    if (el.ignore && !includeIgnore) {
	      return;
	    }
	
	    el.beforeUpdate();
	
	    if (el.__dirty) {
	      el.update();
	    }
	
	    el.afterUpdate();
	    var userSetClipPath = el.clipPath;
	
	    if (userSetClipPath) {
	      // FIXME 效率影响
	      if (clipPaths) {
	        clipPaths = clipPaths.slice();
	      } else {
	        clipPaths = [];
	      }
	
	      var currentClipPath = userSetClipPath;
	      var parentClipPath = el; // Recursively add clip path
	
	      while (currentClipPath) {
	        // clipPath 的变换是基于使用这个 clipPath 的元素
	        currentClipPath.parent = parentClipPath;
	        currentClipPath.updateTransform();
	        clipPaths.push(currentClipPath);
	        parentClipPath = currentClipPath;
	        currentClipPath = currentClipPath.clipPath;
	      }
	    }
	
	    if (el.isGroup) {
	      var children = el._children;
	
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i]; // Force to mark as dirty if group is dirty
	        // FIXME __dirtyPath ?
	
	        if (el.__dirty) {
	          child.__dirty = true;
	        }
	
	        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
	      } // Mark group clean here
	
	
	      el.__dirty = false;
	    } else {
	      el.__clipPaths = clipPaths;
	      this._displayList[this._displayListLen++] = el;
	    }
	  },
	
	  /**
	   * 添加图形(Shape)或者组(Group)到根节点
	   * @param {module:zrender/Element} el
	   */
	  addRoot: function (el) {
	    if (el.__storage === this) {
	      return;
	    }
	
	    if (el instanceof Group) {
	      el.addChildrenToStorage(this);
	    }
	
	    this.addToStorage(el);
	
	    this._roots.push(el);
	  },
	
	  /**
	   * 删除指定的图形(Shape)或者组(Group)
	   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
	   */
	  delRoot: function (el) {
	    if (el == null) {
	      // 不指定el清空
	      for (var i = 0; i < this._roots.length; i++) {
	        var root = this._roots[i];
	
	        if (root instanceof Group) {
	          root.delChildrenFromStorage(this);
	        }
	      }
	
	      this._roots = [];
	      this._displayList = [];
	      this._displayListLen = 0;
	      return;
	    }
	
	    if (el instanceof Array) {
	      for (var i = 0, l = el.length; i < l; i++) {
	        this.delRoot(el[i]);
	      }
	
	      return;
	    }
	
	    var idx = util.indexOf(this._roots, el);
	
	    if (idx >= 0) {
	      this.delFromStorage(el);
	
	      this._roots.splice(idx, 1);
	
	      if (el instanceof Group) {
	        el.delChildrenFromStorage(this);
	      }
	    }
	  },
	  addToStorage: function (el) {
	    if (el) {
	      el.__storage = this;
	      el.dirty(false);
	    }
	
	    return this;
	  },
	  delFromStorage: function (el) {
	    if (el) {
	      el.__storage = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清空并且释放Storage
	   */
	  dispose: function () {
	    this._renderList = this._roots = null;
	  },
	  displayableSortFunc: shapeCompareFunc
	};
	var _default = Storage;
	module.exports = _default;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(2);
	
	var _event = __webpack_require__(104);
	
	var Dispatcher = _event.Dispatcher;
	
	var requestAnimationFrame = __webpack_require__(896);
	
	var Animator = __webpack_require__(895);
	
	/**
	 * Animation main class, dispatch and manage all animation controllers
	 *
	 * @module zrender/animation/Animation
	 * @author pissang(https://github.com/pissang)
	 */
	// TODO Additive animation
	// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
	// https://developer.apple.com/videos/wwdc2014/#236
	
	/**
	 * @typedef {Object} IZRenderStage
	 * @property {Function} update
	 */
	
	/**
	 * @alias module:zrender/animation/Animation
	 * @constructor
	 * @param {Object} [options]
	 * @param {Function} [options.onframe]
	 * @param {IZRenderStage} [options.stage]
	 * @example
	 *     var animation = new Animation();
	 *     var obj = {
	 *         x: 100,
	 *         y: 100
	 *     };
	 *     animation.animate(node.position)
	 *         .when(1000, {
	 *             x: 500,
	 *             y: 500
	 *         })
	 *         .when(2000, {
	 *             x: 100,
	 *             y: 100
	 *         })
	 *         .start('spline');
	 */
	var Animation = function (options) {
	  options = options || {};
	  this.stage = options.stage || {};
	
	  this.onframe = options.onframe || function () {}; // private properties
	
	
	  this._clips = [];
	  this._running = false;
	  this._time;
	  this._pausedTime;
	  this._pauseStart;
	  this._paused = false;
	  Dispatcher.call(this);
	};
	
	Animation.prototype = {
	  constructor: Animation,
	
	  /**
	   * Add clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  addClip: function (clip) {
	    this._clips.push(clip);
	  },
	
	  /**
	   * Add animator
	   * @param {module:zrender/animation/Animator} animator
	   */
	  addAnimator: function (animator) {
	    animator.animation = this;
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.addClip(clips[i]);
	    }
	  },
	
	  /**
	   * Delete animation clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  removeClip: function (clip) {
	    var idx = util.indexOf(this._clips, clip);
	
	    if (idx >= 0) {
	      this._clips.splice(idx, 1);
	    }
	  },
	
	  /**
	   * Delete animation clip
	   * @param {module:zrender/animation/Animator} animator
	   */
	  removeAnimator: function (animator) {
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.removeClip(clips[i]);
	    }
	
	    animator.animation = null;
	  },
	  _update: function () {
	    var time = new Date().getTime() - this._pausedTime;
	
	    var delta = time - this._time;
	    var clips = this._clips;
	    var len = clips.length;
	    var deferredEvents = [];
	    var deferredClips = [];
	
	    for (var i = 0; i < len; i++) {
	      var clip = clips[i];
	      var e = clip.step(time, delta); // Throw out the events need to be called after
	      // stage.update, like destroy
	
	      if (e) {
	        deferredEvents.push(e);
	        deferredClips.push(clip);
	      }
	    } // Remove the finished clip
	
	
	    for (var i = 0; i < len;) {
	      if (clips[i]._needsRemove) {
	        clips[i] = clips[len - 1];
	        clips.pop();
	        len--;
	      } else {
	        i++;
	      }
	    }
	
	    len = deferredEvents.length;
	
	    for (var i = 0; i < len; i++) {
	      deferredClips[i].fire(deferredEvents[i]);
	    }
	
	    this._time = time;
	    this.onframe(delta); // 'frame' should be triggered before stage, because upper application
	    // depends on the sequence (e.g., echarts-stream and finish
	    // event judge)
	
	    this.trigger('frame', delta);
	
	    if (this.stage.update) {
	      this.stage.update();
	    }
	  },
	  _startLoop: function () {
	    var self = this;
	    this._running = true;
	
	    function step() {
	      if (self._running) {
	        requestAnimationFrame(step);
	        !self._paused && self._update();
	      }
	    }
	
	    requestAnimationFrame(step);
	  },
	
	  /**
	   * Start animation.
	   */
	  start: function () {
	    this._time = new Date().getTime();
	    this._pausedTime = 0;
	
	    this._startLoop();
	  },
	
	  /**
	   * Stop animation.
	   */
	  stop: function () {
	    this._running = false;
	  },
	
	  /**
	   * Pause animation.
	   */
	  pause: function () {
	    if (!this._paused) {
	      this._pauseStart = new Date().getTime();
	      this._paused = true;
	    }
	  },
	
	  /**
	   * Resume animation.
	   */
	  resume: function () {
	    if (this._paused) {
	      this._pausedTime += new Date().getTime() - this._pauseStart;
	      this._paused = false;
	    }
	  },
	
	  /**
	   * Clear animation.
	   */
	  clear: function () {
	    this._clips = [];
	  },
	
	  /**
	   * Whether animation finished.
	   */
	  isFinished: function () {
	    return !this._clips.length;
	  },
	
	  /**
	   * Creat animator for a target, whose props can be animated.
	   *
	   * @param  {Object} target
	   * @param  {Object} options
	   * @param  {boolean} [options.loop=false] Whether loop animation.
	   * @param  {Function} [options.getter=null] Get value from target.
	   * @param  {Function} [options.setter=null] Set value to target.
	   * @return {module:zrender/animation/Animation~Animator}
	   */
	  // TODO Gap
	  animate: function (target, options) {
	    options = options || {};
	    var animator = new Animator(target, options.loop, options.getter, options.setter);
	    this.addAnimator(animator);
	    return animator;
	  }
	};
	util.mixin(Animation, Dispatcher);
	var _default = Animation;
	module.exports = _default;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	var easingFuncs = __webpack_require__(2062);
	
	/**
	 * 动画主控制器
	 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
	 * @config life(1000) 动画时长
	 * @config delay(0) 动画延迟时间
	 * @config loop(true)
	 * @config gap(0) 循环的间隔时间
	 * @config onframe
	 * @config easing(optional)
	 * @config ondestroy(optional)
	 * @config onrestart(optional)
	 *
	 * TODO pause
	 */
	function Clip(options) {
	  this._target = options.target; // 生命周期
	
	  this._life = options.life || 1000; // 延时
	
	  this._delay = options.delay || 0; // 开始时间
	  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒
	
	  this._initialized = false; // 是否循环
	
	  this.loop = options.loop == null ? false : options.loop;
	  this.gap = options.gap || 0;
	  this.easing = options.easing || 'Linear';
	  this.onframe = options.onframe;
	  this.ondestroy = options.ondestroy;
	  this.onrestart = options.onrestart;
	  this._pausedTime = 0;
	  this._paused = false;
	}
	
	Clip.prototype = {
	  constructor: Clip,
	  step: function (globalTime, deltaTime) {
	    // Set startTime on first step, or _startTime may has milleseconds different between clips
	    // PENDING
	    if (!this._initialized) {
	      this._startTime = globalTime + this._delay;
	      this._initialized = true;
	    }
	
	    if (this._paused) {
	      this._pausedTime += deltaTime;
	      return;
	    }
	
	    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始
	
	    if (percent < 0) {
	      return;
	    }
	
	    percent = Math.min(percent, 1);
	    var easing = this.easing;
	    var easingFunc = typeof easing === 'string' ? easingFuncs[easing] : easing;
	    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
	    this.fire('frame', schedule); // 结束
	
	    if (percent === 1) {
	      if (this.loop) {
	        this.restart(globalTime); // 重新开始周期
	        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件
	
	        return 'restart';
	      } // 动画完成将这个控制器标识为待删除
	      // 在Animation.update中进行批量删除
	
	
	      this._needsRemove = true;
	      return 'destroy';
	    }
	
	    return null;
	  },
	  restart: function (globalTime) {
	    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
	    this._startTime = globalTime - remainder + this.gap;
	    this._pausedTime = 0;
	    this._needsRemove = false;
	  },
	  fire: function (eventType, arg) {
	    eventType = 'on' + eventType;
	
	    if (this[eventType]) {
	      this[eventType](this._target, arg);
	    }
	  },
	  pause: function () {
	    this._paused = true;
	  },
	  resume: function () {
	    this._paused = false;
	  }
	};
	var _default = Clip;
	module.exports = _default;

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

	/**
	 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
	 * @see http://sole.github.io/tween.js/examples/03_graphs.html
	 * @exports zrender/animation/easing
	 */
	var easing = {
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  linear: function (k) {
	    return k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticIn: function (k) {
	    return k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticOut: function (k) {
	    return k * (2 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k;
	    }
	
	    return -0.5 * (--k * (k - 2) - 1);
	  },
	  // 三次方的缓动（t^3）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicIn: function (k) {
	    return k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicOut: function (k) {
	    return --k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k + 2);
	  },
	  // 四次方的缓动（t^4）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticIn: function (k) {
	    return k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticOut: function (k) {
	    return 1 - --k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k;
	    }
	
	    return -0.5 * ((k -= 2) * k * k * k - 2);
	  },
	  // 五次方的缓动（t^5）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticIn: function (k) {
	    return k * k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticOut: function (k) {
	    return --k * k * k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k * k * k + 2);
	  },
	  // 正弦曲线的缓动（sin(t)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalIn: function (k) {
	    return 1 - Math.cos(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalOut: function (k) {
	    return Math.sin(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalInOut: function (k) {
	    return 0.5 * (1 - Math.cos(Math.PI * k));
	  },
	  // 指数曲线的缓动（2^t）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialIn: function (k) {
	    return k === 0 ? 0 : Math.pow(1024, k - 1);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialOut: function (k) {
	    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialInOut: function (k) {
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if ((k *= 2) < 1) {
	      return 0.5 * Math.pow(1024, k - 1);
	    }
	
	    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
	  },
	  // 圆形曲线的缓动（sqrt(1-t^2)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularIn: function (k) {
	    return 1 - Math.sqrt(1 - k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularOut: function (k) {
	    return Math.sqrt(1 - --k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return -0.5 * (Math.sqrt(1 - k * k) - 1);
	    }
	
	    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
	  },
	  // 创建类似于弹簧在停止前来回振荡的动画
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticIn: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticInOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    if ((k *= 2) < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	    }
	
	    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
	  },
	  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backIn: function (k) {
	    var s = 1.70158;
	    return k * k * ((s + 1) * k - s);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backOut: function (k) {
	    var s = 1.70158;
	    return --k * k * ((s + 1) * k + s) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backInOut: function (k) {
	    var s = 1.70158 * 1.525;
	
	    if ((k *= 2) < 1) {
	      return 0.5 * (k * k * ((s + 1) * k - s));
	    }
	
	    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
	  },
	  // 创建弹跳效果
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceIn: function (k) {
	    return 1 - easing.bounceOut(1 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceOut: function (k) {
	    if (k < 1 / 2.75) {
	      return 7.5625 * k * k;
	    } else if (k < 2 / 2.75) {
	      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
	    } else if (k < 2.5 / 2.75) {
	      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
	    } else {
	      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
	    }
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceInOut: function (k) {
	    if (k < 0.5) {
	      return easing.bounceIn(k * 2) * 0.5;
	    }
	
	    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
	  }
	};
	var _default = easing;
	module.exports = _default;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(900);
	
	var normalizeRadian = _util.normalizeRadian;
	var PI2 = Math.PI * 2;
	/**
	 * 圆弧描边包含判断
	 * @param  {number}  cx
	 * @param  {number}  cy
	 * @param  {number}  r
	 * @param  {number}  startAngle
	 * @param  {number}  endAngle
	 * @param  {boolean}  anticlockwise
	 * @param  {number} lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {Boolean}
	 */
	
	function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  x -= cx;
	  y -= cy;
	  var d = Math.sqrt(x * x + y * y);
	
	  if (d - _l > r || d + _l < r) {
	    return false;
	  }
	
	  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
	    // Is a circle
	    return true;
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var angle = Math.atan2(y, x);
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(134);
	
	/**
	 * 三次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  x3
	 * @param  {number}  y3
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
	    return false;
	  }
	
	  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(180);
	
	var line = __webpack_require__(897);
	
	var cubic = __webpack_require__(2064);
	
	var quadratic = __webpack_require__(899);
	
	var arc = __webpack_require__(2063);
	
	var _util = __webpack_require__(900);
	
	var normalizeRadian = _util.normalizeRadian;
	
	var curve = __webpack_require__(134);
	
	var windingLine = __webpack_require__(901);
	
	var CMD = PathProxy.CMD;
	var PI2 = Math.PI * 2;
	var EPSILON = 1e-4;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	} // 临时数组
	
	
	var roots = [-1, -1, -1];
	var extrema = [-1, -1];
	
	function swapExtrema() {
	  var tmp = extrema[0];
	  extrema[0] = extrema[1];
	  extrema[1] = tmp;
	}
	
	function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
	    return 0;
	  }
	
	  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var w = 0;
	    var nExtrema = -1;
	    var y0_;
	    var y1_;
	
	    for (var i = 0; i < nRoots; i++) {
	      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon
	
	      var unit = t === 0 || t === 1 ? 0.5 : 1;
	      var x_ = curve.cubicAt(x0, x1, x2, x3, t);
	
	      if (x_ < x) {
	        // Quick reject
	        continue;
	      }
	
	      if (nExtrema < 0) {
	        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);
	
	        if (extrema[1] < extrema[0] && nExtrema > 1) {
	          swapExtrema();
	        }
	
	        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);
	
	        if (nExtrema > 1) {
	          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
	        }
	      }
	
	      if (nExtrema === 2) {
	        // 分成三段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else if (t < extrema[1]) {
	          w += y1_ < y0_ ? unit : -unit;
	        } else {
	          w += y3 < y1_ ? unit : -unit;
	        }
	      } else {
	        // 分成两段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else {
	          w += y3 < y0_ ? unit : -unit;
	        }
	      }
	    }
	
	    return w;
	  }
	}
	
	function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
	    return 0;
	  }
	
	  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var t = curve.quadraticExtremum(y0, y1, y2);
	
	    if (t >= 0 && t <= 1) {
	      var w = 0;
	      var y_ = curve.quadraticAt(y0, y1, y2, t);
	
	      for (var i = 0; i < nRoots; i++) {
	        // Remove one endpoint.
	        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
	        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);
	
	        if (x_ < x) {
	          // Quick reject
	          continue;
	        }
	
	        if (roots[i] < t) {
	          w += y_ < y0 ? unit : -unit;
	        } else {
	          w += y2 < y_ ? unit : -unit;
	        }
	      }
	
	      return w;
	    } else {
	      // Remove one endpoint.
	      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
	      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);
	
	      if (x_ < x) {
	        // Quick reject
	        return 0;
	      }
	
	      return y2 < y0 ? unit : -unit;
	    }
	  }
	} // TODO
	// Arc 旋转
	
	
	function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
	  y -= cy;
	
	  if (y > r || y < -r) {
	    return 0;
	  }
	
	  var tmp = Math.sqrt(r * r - y * y);
	  roots[0] = -tmp;
	  roots[1] = tmp;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff < 1e-4) {
	    return 0;
	  }
	
	  if (diff % PI2 < 1e-4) {
	    // Is a circle
	    startAngle = 0;
	    endAngle = PI2;
	    var dir = anticlockwise ? 1 : -1;
	
	    if (x >= roots[0] + cx && x <= roots[1] + cx) {
	      return dir;
	    } else {
	      return 0;
	    }
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var w = 0;
	
	  for (var i = 0; i < 2; i++) {
	    var x_ = roots[i];
	
	    if (x_ + cx > x) {
	      var angle = Math.atan2(y, x_);
	      var dir = anticlockwise ? 1 : -1;
	
	      if (angle < 0) {
	        angle = PI2 + angle;
	      }
	
	      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
	        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
	          dir = -dir;
	        }
	
	        w += dir;
	      }
	    }
	  }
	
	  return w;
	}
	
	function containPath(data, lineWidth, isStroke, x, y) {
	  var w = 0;
	  var xi = 0;
	  var yi = 0;
	  var x0 = 0;
	  var y0 = 0;
	
	  for (var i = 0; i < data.length;) {
	    var cmd = data[i++]; // Begin a new subpath
	
	    if (cmd === CMD.M && i > 1) {
	      // Close previous subpath
	      if (!isStroke) {
	        w += windingLine(xi, yi, x0, y0, x, y);
	      } // 如果被任何一个 subpath 包含
	      // if (w !== 0) {
	      //     return true;
	      // }
	
	    }
	
	    if (i === 1) {
	      // 如果第一个命令是 L, C, Q
	      // 则 previous point 同绘制命令的第一个 point
	      //
	      // 第一个命令为 Arc 的情况下会在后面特殊处理
	      xi = data[i];
	      yi = data[i + 1];
	      x0 = xi;
	      y0 = yi;
	    }
	
	    switch (cmd) {
	      case CMD.M:
	        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	        // 在 closePath 的时候使用
	        x0 = data[i++];
	        y0 = data[i++];
	        xi = x0;
	        yi = y0;
	        break;
	
	      case CMD.L:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
	          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.C:
	        if (isStroke) {
	          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.Q:
	        if (isStroke) {
	          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.A:
	        // TODO Arc 判断的开销比较大
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++]; // TODO Arc 旋转
	
	        i += 1;
	        var anticlockwise = 1 - data[i++];
	        var x1 = Math.cos(theta) * rx + cx;
	        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
	
	        if (i > 1) {
	          w += windingLine(xi, yi, x1, y1, x, y);
	        } else {
	          // 第一个命令起点还未定义
	          x0 = x1;
	          y0 = y1;
	        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
	
	
	        var _x = (x - cx) * ry / rx + cx;
	
	        if (isStroke) {
	          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
	            return true;
	          }
	        } else {
	          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
	        }
	
	        xi = Math.cos(theta + dTheta) * rx + cx;
	        yi = Math.sin(theta + dTheta) * ry + cy;
	        break;
	
	      case CMD.R:
	        x0 = xi = data[i++];
	        y0 = yi = data[i++];
	        var width = data[i++];
	        var height = data[i++];
	        var x1 = x0 + width;
	        var y1 = y0 + height;
	
	        if (isStroke) {
	          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // FIXME Clockwise ?
	          w += windingLine(x1, y0, x1, y1, x, y);
	          w += windingLine(x0, y1, x0, y0, x, y);
	        }
	
	        break;
	
	      case CMD.Z:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // Close a subpath
	          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
	          // FIXME subpaths may overlap
	          // if (w !== 0) {
	          //     return true;
	          // }
	        }
	
	        xi = x0;
	        yi = y0;
	        break;
	    }
	  }
	
	  if (!isStroke && !isAroundEqual(yi, y0)) {
	    w += windingLine(xi, yi, x0, y0, x, y) || 0;
	  }
	
	  return w !== 0;
	}
	
	function contain(pathData, x, y) {
	  return containPath(pathData, 0, false, x, y);
	}
	
	function containStroke(pathData, lineWidth, x, y) {
	  return containPath(pathData, lineWidth, true, x, y);
	}
	
	exports.contain = contain;
	exports.containStroke = containStroke;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	var eventUtil = __webpack_require__(104);
	
	/**
	 * Only implements needed gestures for mobile.
	 */
	var GestureMgr = function () {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  this._track = [];
	};
	
	GestureMgr.prototype = {
	  constructor: GestureMgr,
	  recognize: function (event, target, root) {
	    this._doTrack(event, target, root);
	
	    return this._recognize(event);
	  },
	  clear: function () {
	    this._track.length = 0;
	    return this;
	  },
	  _doTrack: function (event, target, root) {
	    var touches = event.touches;
	
	    if (!touches) {
	      return;
	    }
	
	    var trackItem = {
	      points: [],
	      touches: [],
	      target: target,
	      event: event
	    };
	
	    for (var i = 0, len = touches.length; i < len; i++) {
	      var touch = touches[i];
	      var pos = eventUtil.clientToLocal(root, touch, {});
	      trackItem.points.push([pos.zrX, pos.zrY]);
	      trackItem.touches.push(touch);
	    }
	
	    this._track.push(trackItem);
	  },
	  _recognize: function (event) {
	    for (var eventName in recognizers) {
	      if (recognizers.hasOwnProperty(eventName)) {
	        var gestureInfo = recognizers[eventName](this._track, event);
	
	        if (gestureInfo) {
	          return gestureInfo;
	        }
	      }
	    }
	  }
	};
	
	function dist(pointPair) {
	  var dx = pointPair[1][0] - pointPair[0][0];
	  var dy = pointPair[1][1] - pointPair[0][1];
	  return Math.sqrt(dx * dx + dy * dy);
	}
	
	function center(pointPair) {
	  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
	}
	
	var recognizers = {
	  pinch: function (track, event) {
	    var trackLen = track.length;
	
	    if (!trackLen) {
	      return;
	    }
	
	    var pinchEnd = (track[trackLen - 1] || {}).points;
	    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;
	
	    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
	      var pinchScale = dist(pinchEnd) / dist(pinchPre);
	      !isFinite(pinchScale) && (pinchScale = 1);
	      event.pinchScale = pinchScale;
	      var pinchCenter = center(pinchEnd);
	      event.pinchX = pinchCenter[0];
	      event.pinchY = pinchCenter[1];
	      return {
	        type: 'pinch',
	        target: track[0].target,
	        event: event
	      };
	    }
	  } // Only pinch currently.
	
	};
	var _default = GestureMgr;
	module.exports = _default;

/***/ }),
/* 2067 */
/***/ (function(module, exports) {

	// Myers' Diff Algorithm
	// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
	function Diff() {}
	
	Diff.prototype = {
	  diff: function (oldArr, newArr, equals) {
	    if (!equals) {
	      equals = function (a, b) {
	        return a === b;
	      };
	    }
	
	    this.equals = equals;
	    var self = this;
	    oldArr = oldArr.slice();
	    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running
	
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{
	      newPos: -1,
	      components: []
	    }]; // Seed editLength = 0, i.e. the content starts with the same values
	
	    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);
	
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      var indices = [];
	
	      for (var i = 0; i < newArr.length; i++) {
	        indices.push(i);
	      } // Identity per the equality and tokenizer
	
	
	      return [{
	        indices: indices,
	        count: newArr.length
	      }];
	    } // Main worker method. checks all permutations of a given edit length for acceptance.
	
	
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath;
	        var addPath = bestPath[diagonalPath - 1];
	        var removePath = bestPath[diagonalPath + 1];
	        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }
	
	        var canAdd = addPath && addPath.newPos + 1 < newLen;
	        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
	
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        } // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	
	
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }
	
	        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done
	
	        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	          return buildValues(self, basePath.components, newArr, oldArr);
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }
	
	      editLength++;
	    }
	
	    while (editLength <= maxEditLength) {
	      var ret = execEditLength();
	
	      if (ret) {
	        return ret;
	      }
	    }
	  },
	  pushComponent: function (components, added, removed) {
	    var last = components[components.length - 1];
	
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = {
	        count: last.count + 1,
	        added: added,
	        removed: removed
	      };
	    } else {
	      components.push({
	        count: 1,
	        added: added,
	        removed: removed
	      });
	    }
	  },
	  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var newPos = basePath.newPos;
	    var oldPos = newPos - diagonalPath;
	    var commonCount = 0;
	
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }
	
	    if (commonCount) {
	      basePath.components.push({
	        count: commonCount
	      });
	    }
	
	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  tokenize: function (value) {
	    return value.slice();
	  },
	  join: function (value) {
	    return value.slice();
	  }
	};
	
	function buildValues(diff, components, newArr, oldArr) {
	  var componentPos = 0;
	  var componentLen = components.length;
	  var newPos = 0;
	  var oldPos = 0;
	
	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	
	    if (!component.removed) {
	      var indices = [];
	
	      for (var i = newPos; i < newPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      newPos += component.count; // Common case
	
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      var indices = [];
	
	      for (var i = oldPos; i < oldPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      oldPos += component.count;
	    }
	  }
	
	  return components;
	}
	
	function clonePath(path) {
	  return {
	    newPos: path.newPos,
	    components: path.components.slice(0)
	  };
	}
	
	var arrayDiff = new Diff();
	
	function _default(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	
	module.exports = _default;

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

	/**
	 * The algoritm is learnt from
	 * https://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
	 * And we made some optimization for matrix inversion.
	 * Other similar approaches:
	 * "cv::getPerspectiveTransform", "Direct Linear Transformation".
	 */
	var LN2 = Math.log(2);
	
	function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
	  var cacheKey = rowMask + '-' + colMask;
	  var fullRank = rows.length;
	
	  if (detCache.hasOwnProperty(cacheKey)) {
	    return detCache[cacheKey];
	  }
	
	  if (rank === 1) {
	    // In this case the colMask must be like: `11101111`. We can find the place of `0`.
	    var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / LN2);
	    return rows[rowStart][colStart];
	  }
	
	  var subRowMask = rowMask | 1 << rowStart;
	  var subRowStart = rowStart + 1;
	
	  while (rowMask & 1 << subRowStart) {
	    subRowStart++;
	  }
	
	  var sum = 0;
	
	  for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
	    var colTag = 1 << j;
	
	    if (!(colTag & colMask)) {
	      sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] // det(subMatrix(0, j))
	      * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
	      colLocalIdx++;
	    }
	  }
	
	  detCache[cacheKey] = sum;
	  return sum;
	}
	/**
	 * Usage:
	 * ```js
	 * var transformer = buildTransformer(
	 *     [10, 44, 100, 44, 100, 300, 10, 300],
	 *     [50, 54, 130, 14, 140, 330, 14, 220]
	 * );
	 * var out = [];
	 * transformer && transformer([11, 33], out);
	 * ```
	 *
	 * Notice: `buildTransformer` may take more than 10ms in some Android device.
	 *
	 * @param {Array.<number>} src source four points, [x0, y0, x1, y1, x2, y2, x3, y3]
	 * @param {Array.<number>} dest destination four points, [x0, y0, x1, y1, x2, y2, x3, y3]
	 * @return {Function} transformer If fail, return null/undefined.
	 */
	
	
	function buildTransformer(src, dest) {
	  var mA = [[src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]], [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]], [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]], [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]], [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]], [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]], [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]], [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]];
	  var detCache = {};
	  var det = determinant(mA, 8, 0, 0, 0, detCache);
	
	  if (det === 0) {
	    // can not make transformer when and only when
	    // any three of the markers are collinear.
	    return;
	  } // `invert(mA) * dest`, that is, `adj(mA) / det * dest`.
	
	
	  var vh = [];
	
	  for (var i = 0; i < 8; i++) {
	    for (var j = 0; j < 8; j++) {
	      vh[j] == null && (vh[j] = 0);
	      vh[j] += ((i + j) % 2 ? -1 : 1) * // det(subMatrix(i, j))
	      determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
	    }
	  }
	
	  return function (out, srcPointX, srcPointY) {
	    var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
	    out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
	    out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
	  };
	}
	
	exports.buildTransformer = buildTransformer;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	var _event = __webpack_require__(104);
	
	var addEventListener = _event.addEventListener;
	var removeEventListener = _event.removeEventListener;
	var normalizeEvent = _event.normalizeEvent;
	var getNativeEvent = _event.getNativeEvent;
	
	var zrUtil = __webpack_require__(2);
	
	var Eventful = __webpack_require__(148);
	
	var env = __webpack_require__(58);
	
	/* global document */
	var TOUCH_CLICK_DELAY = 300;
	var globalEventSupported = env.domSupported;
	
	var localNativeListenerNames = function () {
	  var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	  var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
	  var pointerEventNameMap = {
	    pointerdown: 1,
	    pointerup: 1,
	    pointermove: 1,
	    pointerout: 1
	  };
	  var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
	    var nm = name.replace('mouse', 'pointer');
	    return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
	  });
	  return {
	    mouse: mouseHandlerNames,
	    touch: touchHandlerNames,
	    pointer: pointerHandlerNames
	  };
	}();
	
	var globalNativeListenerNames = {
	  mouse: ['mousemove', 'mouseup'],
	  pointer: ['pointermove', 'pointerup']
	};
	
	function eventNameFix(name) {
	  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
	}
	
	function isPointerFromTouch(event) {
	  var pointerType = event.pointerType;
	  return pointerType === 'pen' || pointerType === 'touch';
	} // function useMSGuesture(handlerProxy, event) {
	//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
	// }
	// function onMSGestureChange(proxy, event) {
	//     if (event.translationX || event.translationY) {
	//         // mousemove is carried by MSGesture to reduce the sensitivity.
	//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
	//     }
	//     if (event.scale !== 1) {
	//         event.pinchX = event.offsetX;
	//         event.pinchY = event.offsetY;
	//         event.pinchScale = event.scale;
	//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
	//     }
	// }
	
	/**
	 * Prevent mouse event from being dispatched after Touch Events action
	 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
	 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
	 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
	 * Result: Blocking Mouse Events for 700ms.
	 *
	 * @param {DOMHandlerScope} scope
	 */
	
	
	function setTouchTimer(scope) {
	  scope.touching = true;
	
	  if (scope.touchTimer != null) {
	    clearTimeout(scope.touchTimer);
	    scope.touchTimer = null;
	  }
	
	  scope.touchTimer = setTimeout(function () {
	    scope.touching = false;
	    scope.touchTimer = null;
	  }, 700);
	} // Mark touch, which is useful in distinguish touch and
	// mouse event in upper applicatoin.
	
	
	function markTouch(event) {
	  event && (event.zrByTouch = true);
	} // function markTriggeredFromLocal(event) {
	//     event && (event.__zrIsFromLocal = true);
	// }
	// function isTriggeredFromLocal(instance, event) {
	//     return !!(event && event.__zrIsFromLocal);
	// }
	
	
	function normalizeGlobalEvent(instance, event) {
	  // offsetX, offsetY still need to be calculated. They are necessary in the event
	  // handlers of the upper applications. Set `true` to force calculate them.
	  return normalizeEvent(instance.dom, new FakeGlobalEvent(instance, event), true);
	}
	/**
	 * Detect whether the given el is in `painterRoot`.
	 */
	
	
	function isLocalEl(instance, el) {
	  var elTmp = el;
	  var isLocal = false;
	
	  while (elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot)) {
	    elTmp = elTmp.parentNode;
	  }
	
	  return isLocal;
	}
	/**
	 * Make a fake event but not change the original event,
	 * becuase the global event probably be used by other
	 * listeners not belonging to zrender.
	 * @class
	 */
	
	
	function FakeGlobalEvent(instance, event) {
	  this.type = event.type;
	  this.target = this.currentTarget = instance.dom;
	  this.pointerType = event.pointerType; // Necessray for the force calculation of zrX, zrY
	
	  this.clientX = event.clientX;
	  this.clientY = event.clientY; // Because we do not mount global listeners to touch events,
	  // we do not copy `targetTouches` and `changedTouches` here.
	}
	
	var fakeGlobalEventProto = FakeGlobalEvent.prototype; // we make the default methods on the event do nothing,
	// otherwise it is dangerous. See more details in
	// [Drag outside] in `Handler.js`.
	
	fakeGlobalEventProto.stopPropagation = fakeGlobalEventProto.stopImmediatePropagation = fakeGlobalEventProto.preventDefault = zrUtil.noop;
	/**
	 * Local DOM Handlers
	 * @this {HandlerProxy}
	 */
	
	var localDOMHandlers = {
	  mousedown: function (event) {
	    event = normalizeEvent(this.dom, event);
	    this._mayPointerCapture = [event.zrX, event.zrY];
	    this.trigger('mousedown', event);
	  },
	  mousemove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    var downPoint = this._mayPointerCapture;
	
	    if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
	      togglePointerCapture(this, true);
	    }
	
	    this.trigger('mousemove', event);
	  },
	  mouseup: function (event) {
	    event = normalizeEvent(this.dom, event);
	    togglePointerCapture(this, false);
	    this.trigger('mouseup', event);
	  },
	  mouseout: function (event) {
	    event = normalizeEvent(this.dom, event); // Similarly to the browser did on `document` and touch event,
	    // `globalout` will be delayed to final pointer cature release.
	
	    if (this._pointerCapturing) {
	      event.zrEventControl = 'no_globalout';
	    } // There might be some doms created by upper layer application
	    // at the same level of painter.getViewportRoot() (e.g., tooltip
	    // dom created by echarts), where 'globalout' event should not
	    // be triggered when mouse enters these doms. (But 'mouseout'
	    // should be triggered at the original hovered element as usual).
	
	
	    var element = event.toElement || event.relatedTarget;
	    event.zrIsToLocalDOM = isLocalEl(this, element);
	    this.trigger('mouseout', event);
	  },
	  touchstart: function (event) {
	    // Default mouse behaviour should not be disabled here.
	    // For example, page may needs to be slided.
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this._lastTouchMoment = new Date();
	    this.handler.processGesture(event, 'start'); // For consistent event listener for both touch device and mouse device,
	    // we simulate "mouseover-->mousedown" in touch device. So we trigger
	    // `mousemove` here (to trigger `mouseover` inside), and then trigger
	    // `mousedown`.
	
	    localDOMHandlers.mousemove.call(this, event);
	    localDOMHandlers.mousedown.call(this, event);
	  },
	  touchmove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this.handler.processGesture(event, 'change'); // Mouse move should always be triggered no matter whether
	    // there is gestrue event, because mouse move and pinch may
	    // be used at the same time.
	
	    localDOMHandlers.mousemove.call(this, event);
	  },
	  touchend: function (event) {
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this.handler.processGesture(event, 'end');
	    localDOMHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
	    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
	    // we can conveniently implement "hover style" in both PC and touch device just
	    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
	    // to remove "hover style" on an element, without any additional code for
	    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
	    // style" will remain for user view)
	    // click event should always be triggered no matter whether
	    // there is gestrue event. System click can not be prevented.
	
	    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
	      localDOMHandlers.click.call(this, event);
	    }
	  },
	  pointerdown: function (event) {
	    localDOMHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
	    //     this._msGesture.addPointer(event.pointerId);
	    // }
	  },
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      localDOMHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    localDOMHandlers.mouseup.call(this, event);
	  },
	  pointerout: function (event) {
	    // pointerout will be triggered when tap on touch screen
	    // (IE11+/Edge on MS Surface) after click event triggered,
	    // which is inconsistent with the mousout behavior we defined
	    // in touchend. So we unify them.
	    // (check localDOMHandlers.touchend for detailed explanation)
	    if (!isPointerFromTouch(event)) {
	      localDOMHandlers.mouseout.call(this, event);
	    }
	  }
	};
	/**
	 * Othere DOM UI Event handlers for zr dom.
	 * @this {HandlerProxy}
	 */
	
	zrUtil.each(['click', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  localDOMHandlers[name] = function (event) {
	    event = normalizeEvent(this.dom, event);
	    this.trigger(name, event);
	  };
	});
	/**
	 * DOM UI Event handlers for global page.
	 *
	 * [Caution]:
	 * those handlers should both support in capture phase and bubble phase!
	 *
	 * @this {HandlerProxy}
	 */
	
	var globalDOMHandlers = {
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      globalDOMHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    globalDOMHandlers.mouseup.call(this, event);
	  },
	  mousemove: function (event) {
	    this.trigger('mousemove', event);
	  },
	  mouseup: function (event) {
	    var pointerCaptureReleasing = this._pointerCapturing;
	    togglePointerCapture(this, false);
	    this.trigger('mouseup', event);
	
	    if (pointerCaptureReleasing) {
	      event.zrEventControl = 'only_globalout';
	      this.trigger('mouseout', event);
	    }
	  }
	};
	/**
	 * @param {HandlerProxy} instance
	 * @param {DOMHandlerScope} scope
	 */
	
	function mountLocalDOMEventListeners(instance, scope) {
	  var domHandlers = scope.domHandlers;
	
	  if (env.pointerEventsSupported) {
	    // Only IE11+/Edge
	    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
	    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
	    // at the same time.
	    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
	    // screen, which do not occurs in pointer event.
	    // So we use pointer event to both detect touch gesture and mouse behavior.
	    zrUtil.each(localNativeListenerNames.pointer, function (nativeEventName) {
	      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	        // markTriggeredFromLocal(event);
	        domHandlers[nativeEventName].call(instance, event);
	      });
	    }); // FIXME
	    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
	    // which does not prevent defuault behavior occasionally (which may cause view port
	    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
	    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
	    // touch screen. And we only support click behavior on MS touch screen now.
	    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
	    // We dont support touch on IE on win7.
	    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
	    // if (typeof MSGesture === 'function') {
	    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
	    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
	    // }
	  } else {
	    if (env.touchEventsSupported) {
	      zrUtil.each(localNativeListenerNames.touch, function (nativeEventName) {
	        mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	          // markTriggeredFromLocal(event);
	          domHandlers[nativeEventName].call(instance, event);
	          setTouchTimer(scope);
	        });
	      }); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
	      // addEventListener(root, 'mouseout', this._mouseoutHandler);
	    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
	    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
	    // mouse event can not be handle in those devices.
	    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
	    // mouseevent after touch event triggered, see `setTouchTimer`.
	
	
	    zrUtil.each(localNativeListenerNames.mouse, function (nativeEventName) {
	      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	        event = getNativeEvent(event);
	
	        if (!scope.touching) {
	          // markTriggeredFromLocal(event);
	          domHandlers[nativeEventName].call(instance, event);
	        }
	      });
	    });
	  }
	}
	/**
	 * @param {HandlerProxy} instance
	 * @param {DOMHandlerScope} scope
	 */
	
	
	function mountGlobalDOMEventListeners(instance, scope) {
	  // Only IE11+/Edge. See the comment in `mountLocalDOMEventListeners`.
	  if (env.pointerEventsSupported) {
	    zrUtil.each(globalNativeListenerNames.pointer, mount);
	  } // Touch event has implemented "drag outside" so we do not mount global listener for touch event.
	  // (see https://www.w3.org/TR/touch-events/#the-touchmove-event)
	  // We do not consider "both-support-touch-and-mouse device" for this feature (see the comment of
	  // `mountLocalDOMEventListeners`) to avoid bugs util some requirements come.
	  else if (!env.touchEventsSupported) {
	      zrUtil.each(globalNativeListenerNames.mouse, mount);
	    }
	
	  function mount(nativeEventName) {
	    function nativeEventListener(event) {
	      event = getNativeEvent(event); // See the reason in [Drag outside] in `Handler.js`
	      // This checking supports both `useCapture` or not.
	      // PENDING: if there is performance issue in some devices,
	      // we probably can not use `useCapture` and change a easier
	      // to judes whether local (mark).
	
	      if (!isLocalEl(instance, event.target)) {
	        event = normalizeGlobalEvent(instance, event);
	        scope.domHandlers[nativeEventName].call(instance, event);
	      }
	    }
	
	    mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
	      capture: true
	    } // See [Drag Outside] in `Handler.js`
	    );
	  }
	}
	
	function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
	  scope.mounted[nativeEventName] = listener;
	  scope.listenerOpts[nativeEventName] = opt;
	  addEventListener(scope.domTarget, eventNameFix(nativeEventName), listener, opt);
	}
	
	function unmountDOMEventListeners(scope) {
	  var mounted = scope.mounted;
	
	  for (var nativeEventName in mounted) {
	    if (mounted.hasOwnProperty(nativeEventName)) {
	      removeEventListener(scope.domTarget, eventNameFix(nativeEventName), mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
	    }
	  }
	
	  scope.mounted = {};
	}
	/**
	 * See [Drag Outside] in `Handler.js`.
	 * @implement
	 * @param {boolean} isPointerCapturing Should never be `null`/`undefined`.
	 *        `true`: start to capture pointer if it is not capturing.
	 *        `false`: end the capture if it is capturing.
	 */
	
	
	function togglePointerCapture(instance, isPointerCapturing) {
	  instance._mayPointerCapture = null;
	
	  if (globalEventSupported && instance._pointerCapturing ^ isPointerCapturing) {
	    instance._pointerCapturing = isPointerCapturing;
	    var globalHandlerScope = instance._globalHandlerScope;
	    isPointerCapturing ? mountGlobalDOMEventListeners(instance, globalHandlerScope) : unmountDOMEventListeners(globalHandlerScope);
	  }
	}
	/**
	 * @inner
	 * @class
	 */
	
	
	function DOMHandlerScope(domTarget, domHandlers) {
	  this.domTarget = domTarget;
	  this.domHandlers = domHandlers; // Key: eventName, value: mounted handler funcitons.
	  // Used for unmount.
	
	  this.mounted = {};
	  this.listenerOpts = {};
	  this.touchTimer = null;
	  this.touching = false;
	}
	/**
	 * @public
	 * @class
	 */
	
	
	function HandlerDomProxy(dom, painterRoot) {
	  Eventful.call(this);
	  this.dom = dom;
	  this.painterRoot = painterRoot;
	  this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);
	
	  if (globalEventSupported) {
	    this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
	  }
	  /**
	   * @type {boolean}
	   */
	
	
	  this._pointerCapturing = false;
	  /**
	   * @type {Array.<number>} [x, y] or null.
	   */
	
	  this._mayPointerCapture = null;
	  mountLocalDOMEventListeners(this, this._localHandlerScope);
	}
	
	var handlerDomProxyProto = HandlerDomProxy.prototype;
	
	handlerDomProxyProto.dispose = function () {
	  unmountDOMEventListeners(this._localHandlerScope);
	
	  if (globalEventSupported) {
	    unmountDOMEventListeners(this._globalHandlerScope);
	  }
	};
	
	handlerDomProxyProto.setCursor = function (cursorStyle) {
	  this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
	};
	
	zrUtil.mixin(HandlerDomProxy, Eventful);
	var _default = HandlerDomProxy;
	module.exports = _default;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	// CompoundPath to improve performance
	var _default = Path.extend({
	  type: 'compound',
	  shape: {
	    paths: null
	  },
	  _updatePathDirty: function () {
	    var dirtyPath = this.__dirtyPath;
	    var paths = this.shape.paths;
	
	    for (var i = 0; i < paths.length; i++) {
	      // Mark as dirty if any subpath is dirty
	      dirtyPath = dirtyPath || paths[i].__dirtyPath;
	    }
	
	    this.__dirtyPath = dirtyPath;
	    this.__dirty = this.__dirty || dirtyPath;
	  },
	  beforeBrush: function () {
	    this._updatePathDirty();
	
	    var paths = this.shape.paths || [];
	    var scale = this.getGlobalScale(); // Update path scale
	
	    for (var i = 0; i < paths.length; i++) {
	      if (!paths[i].path) {
	        paths[i].createPathProxy();
	      }
	
	      paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
	    }
	  },
	  buildPath: function (ctx, shape) {
	    var paths = shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].buildPath(ctx, paths[i].shape, true);
	    }
	  },
	  afterBrush: function () {
	    var paths = this.shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].__dirtyPath = false;
	    }
	  },
	  getBoundingRect: function () {
	    this._updatePathDirty();
	
	    return Path.prototype.getBoundingRect.call(this);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(2);
	
	var Gradient = __webpack_require__(281);
	
	/**
	 * x, y, r are all percent from 0 to 1
	 * @param {number} [x=0.5]
	 * @param {number} [y=0.5]
	 * @param {number} [r=0.5]
	 * @param {Array.<Object>} [colorStops]
	 * @param {boolean} [globalCoord=false]
	 */
	var RadialGradient = function (x, y, r, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'radial', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0.5 : x;
	  this.y = y == null ? 0.5 : y;
	  this.r = r == null ? 0.5 : r; // Can be cloned
	
	  this.type = 'radial'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	RadialGradient.prototype = {
	  constructor: RadialGradient
	};
	zrUtil.inherits(RadialGradient, Gradient);
	var _default = RadialGradient;
	module.exports = _default;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(49);
	
	var v2Min = _vector.min;
	var v2Max = _vector.max;
	var v2Scale = _vector.scale;
	var v2Distance = _vector.distance;
	var v2Add = _vector.add;
	var v2Clone = _vector.clone;
	var v2Sub = _vector.sub;
	
	/**
	 * 贝塞尔平滑曲线
	 * @module zrender/shape/util/smoothBezier
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * 贝塞尔平滑曲线
	 * @alias module:zrender/shape/util/smoothBezier
	 * @param {Array} points 线段顶点数组
	 * @param {number} smooth 平滑等级, 0-1
	 * @param {boolean} isLoop
	 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
	 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
	 *                           整个折线的包围盒做一个并集用来约束控制点。
	 * @param {Array} 计算出来的控制点数组
	 */
	function _default(points, smooth, isLoop, constraint) {
	  var cps = [];
	  var v = [];
	  var v1 = [];
	  var v2 = [];
	  var prevPoint;
	  var nextPoint;
	  var min;
	  var max;
	
	  if (constraint) {
	    min = [Infinity, Infinity];
	    max = [-Infinity, -Infinity];
	
	    for (var i = 0, len = points.length; i < len; i++) {
	      v2Min(min, min, points[i]);
	      v2Max(max, max, points[i]);
	    } // 与指定的包围盒做并集
	
	
	    v2Min(min, min, constraint[0]);
	    v2Max(max, max, constraint[1]);
	  }
	
	  for (var i = 0, len = points.length; i < len; i++) {
	    var point = points[i];
	
	    if (isLoop) {
	      prevPoint = points[i ? i - 1 : len - 1];
	      nextPoint = points[(i + 1) % len];
	    } else {
	      if (i === 0 || i === len - 1) {
	        cps.push(v2Clone(points[i]));
	        continue;
	      } else {
	        prevPoint = points[i - 1];
	        nextPoint = points[i + 1];
	      }
	    }
	
	    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length
	
	    v2Scale(v, v, smooth);
	    var d0 = v2Distance(point, prevPoint);
	    var d1 = v2Distance(point, nextPoint);
	    var sum = d0 + d1;
	
	    if (sum !== 0) {
	      d0 /= sum;
	      d1 /= sum;
	    }
	
	    v2Scale(v1, v, -d0);
	    v2Scale(v2, v, d1);
	    var cp0 = v2Add([], point, v1);
	    var cp1 = v2Add([], point, v2);
	
	    if (constraint) {
	      v2Max(cp0, cp0, min);
	      v2Min(cp0, cp0, max);
	      v2Max(cp1, cp1, min);
	      v2Min(cp1, cp1, max);
	    }
	
	    cps.push(cp0);
	    cps.push(cp1);
	  }
	
	  if (isLoop) {
	    cps.push(cps.shift());
	  }
	
	  return cps;
	}
	
	module.exports = _default;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(49);
	
	var v2Distance = _vector.distance;
	
	/**
	 * Catmull-Rom spline 插值折线
	 * @module zrender/shape/util/smoothSpline
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * @inner
	 */
	function interpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	/**
	 * @alias module:zrender/shape/util/smoothSpline
	 * @param {Array} points 线段顶点数组
	 * @param {boolean} isLoop
	 * @return {Array}
	 */
	
	
	function _default(points, isLoop) {
	  var len = points.length;
	  var ret = [];
	  var distance = 0;
	
	  for (var i = 1; i < len; i++) {
	    distance += v2Distance(points[i - 1], points[i]);
	  }
	
	  var segs = distance / 2;
	  segs = segs < len ? len : segs;
	
	  for (var i = 0; i < segs; i++) {
	    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
	    var idx = Math.floor(pos);
	    var w = pos - idx;
	    var p0;
	    var p1 = points[idx % len];
	    var p2;
	    var p3;
	
	    if (!isLoop) {
	      p0 = points[idx === 0 ? idx : idx - 1];
	      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
	      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
	    } else {
	      p0 = points[(idx - 1 + len) % len];
	      p2 = points[(idx + 1) % len];
	      p3 = points[(idx + 2) % len];
	    }
	
	    var w2 = w * w;
	    var w3 = w * w2;
	    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
	  }
	
	  return ret;
	}
	
	module.exports = _default;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	/**
	 * 圆弧
	 * @module zrender/graphic/shape/Arc
	 */
	var _default = Path.extend({
	  type: 'arc',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	var vec2 = __webpack_require__(49);
	
	var _curve = __webpack_require__(134);
	
	var quadraticSubdivide = _curve.quadraticSubdivide;
	var cubicSubdivide = _curve.cubicSubdivide;
	var quadraticAt = _curve.quadraticAt;
	var cubicAt = _curve.cubicAt;
	var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
	var cubicDerivativeAt = _curve.cubicDerivativeAt;
	
	/**
	 * 贝塞尔曲线
	 * @module zrender/shape/BezierCurve
	 */
	var out = [];
	
	function someVectorAt(shape, t, isTangent) {
	  var cpx2 = shape.cpx2;
	  var cpy2 = shape.cpy2;
	
	  if (cpx2 === null || cpy2 === null) {
	    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
	  } else {
	    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
	  }
	}
	
	var _default = Path.extend({
	  type: 'bezier-curve',
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    // cpx2: 0,
	    // cpy2: 0
	    // Curve show percent, for animating
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1 = shape.x1;
	    var y1 = shape.y1;
	    var x2 = shape.x2;
	    var y2 = shape.y2;
	    var cpx1 = shape.cpx1;
	    var cpy1 = shape.cpy1;
	    var cpx2 = shape.cpx2;
	    var cpy2 = shape.cpy2;
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (cpx2 == null || cpy2 == null) {
	      if (percent < 1) {
	        quadraticSubdivide(x1, cpx1, x2, percent, out);
	        cpx1 = out[1];
	        x2 = out[2];
	        quadraticSubdivide(y1, cpy1, y2, percent, out);
	        cpy1 = out[1];
	        y2 = out[2];
	      }
	
	      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
	    } else {
	      if (percent < 1) {
	        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
	        cpx1 = out[1];
	        cpx2 = out[2];
	        x2 = out[3];
	        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
	        cpy1 = out[1];
	        cpy2 = out[2];
	        y2 = out[3];
	      }
	
	      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	    }
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  pointAt: function (t) {
	    return someVectorAt(this.shape, t, false);
	  },
	
	  /**
	   * Get tangent at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  tangentAt: function (t) {
	    var p = someVectorAt(this.shape, t, true);
	    return vec2.normalize(p, p);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	/**
	 * 椭圆形状
	 * @module zrender/graphic/shape/Ellipse
	 */
	var _default = Path.extend({
	  type: 'ellipse',
	  shape: {
	    cx: 0,
	    cy: 0,
	    rx: 0,
	    ry: 0
	  },
	  buildPath: function (ctx, shape) {
	    var k = 0.5522848;
	    var x = shape.cx;
	    var y = shape.cy;
	    var a = shape.rx;
	    var b = shape.ry;
	    var ox = a * k; // 水平控制点偏移量
	
	    var oy = b * k; // 垂直控制点偏移量
	    // 从椭圆的左端点开始顺时针绘制四条三次贝塞尔曲线
	
	    ctx.moveTo(x - a, y);
	    ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
	    ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
	    ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
	    ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	/**
	 * 圆环
	 * @module zrender/graphic/shape/Ring
	 */
	var _default = Path.extend({
	  type: 'ring',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    r0: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var PI2 = Math.PI * 2;
	    ctx.moveTo(x + shape.r, y);
	    ctx.arc(x, y, shape.r, 0, PI2, false);
	    ctx.moveTo(x + shape.r0, y);
	    ctx.arc(x, y, shape.r0, 0, PI2, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(55);
	
	var fixClipWithShadow = __webpack_require__(906);
	
	/**
	 * 扇形
	 * @module zrender/graphic/shape/Sector
	 */
	var _default = Path.extend({
	  type: 'sector',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
	    ctx.lineTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	var Animator = __webpack_require__(895);
	
	var logError = __webpack_require__(227);
	
	var _util = __webpack_require__(2);
	
	var isString = _util.isString;
	var isFunction = _util.isFunction;
	var isObject = _util.isObject;
	var isArrayLike = _util.isArrayLike;
	var indexOf = _util.indexOf;
	
	/**
	 * @alias module:zrender/mixin/Animatable
	 * @constructor
	 */
	var Animatable = function () {
	  /**
	   * @type {Array.<module:zrender/animation/Animator>}
	   * @readOnly
	   */
	  this.animators = [];
	};
	
	Animatable.prototype = {
	  constructor: Animatable,
	
	  /**
	   * 动画
	   *
	   * @param {string} path The path to fetch value from object, like 'a.b.c'.
	   * @param {boolean} [loop] Whether to loop animation.
	   * @return {module:zrender/animation/Animator}
	   * @example:
	   *     el.animate('style', false)
	   *         .when(1000, {x: 10} )
	   *         .done(function(){ // Animation done })
	   *         .start()
	   */
	  animate: function (path, loop) {
	    var target;
	    var animatingShape = false;
	    var el = this;
	    var zr = this.__zr;
	
	    if (path) {
	      var pathSplitted = path.split('.');
	      var prop = el; // If animating shape
	
	      animatingShape = pathSplitted[0] === 'shape';
	
	      for (var i = 0, l = pathSplitted.length; i < l; i++) {
	        if (!prop) {
	          continue;
	        }
	
	        prop = prop[pathSplitted[i]];
	      }
	
	      if (prop) {
	        target = prop;
	      }
	    } else {
	      target = el;
	    }
	
	    if (!target) {
	      logError('Property "' + path + '" is not existed in element ' + el.id);
	      return;
	    }
	
	    var animators = el.animators;
	    var animator = new Animator(target, loop);
	    animator.during(function (target) {
	      el.dirty(animatingShape);
	    }).done(function () {
	      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
	      animators.splice(indexOf(animators, animator), 1);
	    });
	    animators.push(animator); // If animate after added to the zrender
	
	    if (zr) {
	      zr.animation.addAnimator(animator);
	    }
	
	    return animator;
	  },
	
	  /**
	   * 停止动画
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stopAnimation: function (forwardToLast) {
	    var animators = this.animators;
	    var len = animators.length;
	
	    for (var i = 0; i < len; i++) {
	      animators[i].stop(forwardToLast);
	    }
	
	    animators.length = 0;
	    return this;
	  },
	
	  /**
	   * Caution: this method will stop previous animation.
	   * So do not use this method to one element twice before
	   * animation starts, unless you know what you are doing.
	   * @param {Object} target
	   * @param {number} [time=500] Time in ms
	   * @param {string} [easing='linear']
	   * @param {number} [delay=0]
	   * @param {Function} [callback]
	   * @param {Function} [forceAnimate] Prevent stop animation and callback
	   *        immediently when target values are the same as current values.
	   *
	   * @example
	   *  // Animate position
	   *  el.animateTo({
	   *      position: [10, 10]
	   *  }, function () { // done })
	   *
	   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
	   *  el.animateTo({
	   *      shape: {
	   *          width: 500
	   *      },
	   *      style: {
	   *          fill: 'red'
	   *      }
	   *      position: [10, 10]
	   *  }, 100, 100, 'cubicOut', function () { // done })
	   */
	  // TODO Return animation key
	  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate);
	  },
	
	  /**
	   * Animate from the target state to current state.
	   * The params and the return value are the same as `this.animateTo`.
	   */
	  animateFrom: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate, true);
	  }
	};
	
	function animateTo(animatable, target, time, delay, easing, callback, forceAnimate, reverse) {
	  // animateTo(target, time, easing, callback);
	  if (isString(delay)) {
	    callback = easing;
	    easing = delay;
	    delay = 0;
	  } // animateTo(target, time, delay, callback);
	  else if (isFunction(easing)) {
	      callback = easing;
	      easing = 'linear';
	      delay = 0;
	    } // animateTo(target, time, callback);
	    else if (isFunction(delay)) {
	        callback = delay;
	        delay = 0;
	      } // animateTo(target, callback)
	      else if (isFunction(time)) {
	          callback = time;
	          time = 500;
	        } // animateTo(target)
	        else if (!time) {
	            time = 500;
	          } // Stop all previous animations
	
	
	  animatable.stopAnimation();
	  animateToShallow(animatable, '', animatable, target, time, delay, reverse); // Animators may be removed immediately after start
	  // if there is nothing to animate
	
	  var animators = animatable.animators.slice();
	  var count = animators.length;
	
	  function done() {
	    count--;
	
	    if (!count) {
	      callback && callback();
	    }
	  } // No animators. This should be checked before animators[i].start(),
	  // because 'done' may be executed immediately if no need to animate.
	
	
	  if (!count) {
	    callback && callback();
	  } // Start after all animators created
	  // Incase any animator is done immediately when all animation properties are not changed
	
	
	  for (var i = 0; i < animators.length; i++) {
	    animators[i].done(done).start(easing, forceAnimate);
	  }
	}
	/**
	 * @param {string} path=''
	 * @param {Object} source=animatable
	 * @param {Object} target
	 * @param {number} [time=500]
	 * @param {number} [delay=0]
	 * @param {boolean} [reverse] If `true`, animate
	 *        from the `target` to current state.
	 *
	 * @example
	 *  // Animate position
	 *  el._animateToShallow({
	 *      position: [10, 10]
	 *  })
	 *
	 *  // Animate shape, style and position in 100ms, delayed 100ms
	 *  el._animateToShallow({
	 *      shape: {
	 *          width: 500
	 *      },
	 *      style: {
	 *          fill: 'red'
	 *      }
	 *      position: [10, 10]
	 *  }, 100, 100)
	 */
	
	
	function animateToShallow(animatable, path, source, target, time, delay, reverse) {
	  var objShallow = {};
	  var propertyCount = 0;
	
	  for (var name in target) {
	    if (!target.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (source[name] != null) {
	      if (isObject(target[name]) && !isArrayLike(target[name])) {
	        animateToShallow(animatable, path ? path + '.' + name : name, source[name], target[name], time, delay, reverse);
	      } else {
	        if (reverse) {
	          objShallow[name] = source[name];
	          setAttrByPath(animatable, path, name, target[name]);
	        } else {
	          objShallow[name] = target[name];
	        }
	
	        propertyCount++;
	      }
	    } else if (target[name] != null && !reverse) {
	      setAttrByPath(animatable, path, name, target[name]);
	    }
	  }
	
	  if (propertyCount > 0) {
	    animatable.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
	  }
	}
	
	function setAttrByPath(el, path, name, value) {
	  // Attr directly if not has property
	  // FIXME, if some property not needed for element ?
	  if (!path) {
	    el.attr(name, value);
	  } else {
	    // Only support set shape or style
	    var props = {};
	    props[path] = {};
	    props[path][name] = value;
	    el.attr(props);
	  }
	}
	
	var _default = Animatable;
	module.exports = _default;

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

	// TODO Draggable for group
	// FIXME Draggable on element which has parent rotation or scale
	function Draggable() {
	  this.on('mousedown', this._dragStart, this);
	  this.on('mousemove', this._drag, this);
	  this.on('mouseup', this._dragEnd, this); // `mosuemove` and `mouseup` can be continue to fire when dragging.
	  // See [Drag outside] in `Handler.js`. So we do not need to trigger
	  // `_dragEnd` when globalout. That would brings better user experience.
	  // this.on('globalout', this._dragEnd, this);
	  // this._dropTarget = null;
	  // this._draggingTarget = null;
	  // this._x = 0;
	  // this._y = 0;
	}
	
	Draggable.prototype = {
	  constructor: Draggable,
	  _dragStart: function (e) {
	    var draggingTarget = e.target; // Find if there is draggable in the ancestor
	
	    while (draggingTarget && !draggingTarget.draggable) {
	      draggingTarget = draggingTarget.parent;
	    }
	
	    if (draggingTarget) {
	      this._draggingTarget = draggingTarget;
	      draggingTarget.dragging = true;
	      this._x = e.offsetX;
	      this._y = e.offsetY;
	      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
	    }
	  },
	  _drag: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      var x = e.offsetX;
	      var y = e.offsetY;
	      var dx = x - this._x;
	      var dy = y - this._y;
	      this._x = x;
	      this._y = y;
	      draggingTarget.drift(dx, dy, e);
	      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
	      var dropTarget = this.findHover(x, y, draggingTarget).target;
	      var lastDropTarget = this._dropTarget;
	      this._dropTarget = dropTarget;
	
	      if (draggingTarget !== dropTarget) {
	        if (lastDropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
	        }
	
	        if (dropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
	        }
	      }
	    }
	  },
	  _dragEnd: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      draggingTarget.dragging = false;
	    }
	
	    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);
	
	    if (this._dropTarget) {
	      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
	    }
	
	    this._draggingTarget = null;
	    this._dropTarget = null;
	  }
	};
	
	function param(target, e) {
	  return {
	    target: target,
	    topTarget: e && e.topTarget
	  };
	}
	
	var _default = Draggable;
	module.exports = _default;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(453);
	
	var createElement = _core.createElement;
	
	var util = __webpack_require__(2);
	
	var logError = __webpack_require__(227);
	
	var Path = __webpack_require__(55);
	
	var ZImage = __webpack_require__(181);
	
	var ZText = __webpack_require__(147);
	
	var arrayDiff = __webpack_require__(2067);
	
	var GradientManager = __webpack_require__(2083);
	
	var ClippathManager = __webpack_require__(2082);
	
	var ShadowManager = __webpack_require__(2084);
	
	var _graphic = __webpack_require__(454);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * SVG Painter
	 * @module zrender/svg/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function getSvgProxy(el) {
	  if (el instanceof Path) {
	    return svgPath;
	  } else if (el instanceof ZImage) {
	    return svgImage;
	  } else if (el instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	}
	
	function checkParentAvailable(parent, child) {
	  return child && parent && child.parentNode !== parent;
	}
	
	function insertAfter(parent, child, prevSibling) {
	  if (checkParentAvailable(parent, child) && prevSibling) {
	    var nextSibling = prevSibling.nextSibling;
	    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
	  }
	}
	
	function prepend(parent, child) {
	  if (checkParentAvailable(parent, child)) {
	    var firstChild = parent.firstChild;
	    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
	  }
	} // function append(parent, child) {
	//     if (checkParentAvailable(parent, child)) {
	//         parent.appendChild(child);
	//     }
	// }
	
	
	function remove(parent, child) {
	  if (child && parent && child.parentNode === parent) {
	    parent.removeChild(child);
	  }
	}
	
	function getTextSvgElement(displayable) {
	  return displayable.__textSvgEl;
	}
	
	function getSvgElement(displayable) {
	  return displayable.__svgEl;
	}
	/**
	 * @alias module:zrender/svg/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var SVGPainter = function (root, storage, opts, zrId) {
	  this.root = root;
	  this.storage = storage;
	  this._opts = opts = util.extend({}, opts || {});
	  var svgDom = createElement('svg');
	  svgDom.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	  svgDom.setAttribute('version', '1.1');
	  svgDom.setAttribute('baseProfile', 'full');
	  svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
	  var bgRoot = createElement('g');
	  svgDom.appendChild(bgRoot);
	  var svgRoot = createElement('g');
	  svgDom.appendChild(svgRoot);
	  this.gradientManager = new GradientManager(zrId, svgRoot);
	  this.clipPathManager = new ClippathManager(zrId, svgRoot);
	  this.shadowManager = new ShadowManager(zrId, svgRoot);
	  var viewport = document.createElement('div');
	  viewport.style.cssText = 'overflow:hidden;position:relative';
	  this._svgDom = svgDom;
	  this._svgRoot = svgRoot;
	  this._backgroundRoot = bgRoot;
	  this._viewport = viewport;
	  root.appendChild(viewport);
	  viewport.appendChild(svgDom);
	  this.resize(opts.width, opts.height);
	  this._visibleList = [];
	};
	
	SVGPainter.prototype = {
	  constructor: SVGPainter,
	  getType: function () {
	    return 'svg';
	  },
	  getViewportRoot: function () {
	    return this._viewport;
	  },
	  getSvgDom: function () {
	    return this._svgDom;
	  },
	  getSvgRoot: function () {
	    return this._svgRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	  refresh: function () {
	    var list = this.storage.getDisplayList(true);
	
	    this._paintList(list);
	  },
	  setBackgroundColor: function (backgroundColor) {
	    // TODO gradient
	    // Insert a bg rect instead of setting background to viewport.
	    // Otherwise, the exported SVG don't have background.
	    if (this._backgroundRoot && this._backgroundNode) {
	      this._backgroundRoot.removeChild(this._backgroundNode);
	    }
	
	    var bgNode = createElement('rect');
	    bgNode.setAttribute('width', this.getWidth());
	    bgNode.setAttribute('height', this.getHeight());
	    bgNode.setAttribute('x', 0);
	    bgNode.setAttribute('y', 0);
	    bgNode.setAttribute('id', 0);
	    bgNode.style.fill = backgroundColor;
	
	    this._backgroundRoot.appendChild(bgNode);
	
	    this._backgroundNode = bgNode;
	  },
	  _paintList: function (list) {
	    this.gradientManager.markAllUnused();
	    this.clipPathManager.markAllUnused();
	    this.shadowManager.markAllUnused();
	    var svgRoot = this._svgRoot;
	    var visibleList = this._visibleList;
	    var listLen = list.length;
	    var newVisibleList = [];
	    var i;
	
	    for (i = 0; i < listLen; i++) {
	      var displayable = list[i];
	      var svgProxy = getSvgProxy(displayable);
	      var svgElement = getSvgElement(displayable) || getTextSvgElement(displayable);
	
	      if (!displayable.invisible) {
	        if (displayable.__dirty) {
	          svgProxy && svgProxy.brush(displayable); // Update clipPath
	
	          this.clipPathManager.update(displayable); // Update gradient and shadow
	
	          if (displayable.style) {
	            this.gradientManager.update(displayable.style.fill);
	            this.gradientManager.update(displayable.style.stroke);
	            this.shadowManager.update(svgElement, displayable);
	          }
	
	          displayable.__dirty = false;
	        }
	
	        newVisibleList.push(displayable);
	      }
	    }
	
	    var diff = arrayDiff(visibleList, newVisibleList);
	    var prevSvgElement; // First do remove, in case element moved to the head and do remove
	    // after add
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = visibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          remove(svgRoot, svgElement);
	          remove(svgRoot, textSvgElement);
	        }
	      }
	    }
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.added) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);
	
	          if (svgElement) {
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          } else if (prevSvgElement) {
	            insertAfter(svgRoot, textSvgElement, prevSvgElement);
	          } else {
	            prepend(svgRoot, textSvgElement);
	          } // Insert text
	
	
	          insertAfter(svgRoot, textSvgElement, svgElement);
	          prevSvgElement = textSvgElement || svgElement || prevSvgElement; // zrender.Text only create textSvgElement.
	
	          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	        }
	      } else if (!item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          this.gradientManager.markUsed(displayable);
	          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.shadowManager.markUsed(displayable);
	          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	
	          if (textSvgElement) {
	            // Insert text.
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          }
	
	          prevSvgElement = svgElement || textSvgElement || prevSvgElement;
	        }
	      }
	    }
	
	    this.gradientManager.removeUnused();
	    this.clipPathManager.removeUnused();
	    this.shadowManager.removeUnused();
	    this._visibleList = newVisibleList;
	  },
	  _getDefs: function (isForceCreating) {
	    var svgRoot = this._svgDom;
	    var defs = svgRoot.getElementsByTagName('defs');
	
	    if (defs.length === 0) {
	      // Not exist
	      if (isForceCreating) {
	        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
	        svgRoot.firstChild // Insert in the front of svg
	        );
	
	        if (!defs.contains) {
	          // IE doesn't support contains method
	          defs.contains = function (el) {
	            var children = defs.children;
	
	            if (!children) {
	              return false;
	            }
	
	            for (var i = children.length - 1; i >= 0; --i) {
	              if (children[i] === el) {
	                return true;
	              }
	            }
	
	            return false;
	          };
	        }
	
	        return defs;
	      } else {
	        return null;
	      }
	    } else {
	      return defs[0];
	    }
	  },
	  resize: function (width, height) {
	    var viewport = this._viewport; // FIXME Why ?
	
	    viewport.style.display = 'none'; // Save input w/h
	
	    var opts = this._opts;
	    width != null && (opts.width = width);
	    height != null && (opts.height = height);
	    width = this._getSize(0);
	    height = this._getSize(1);
	    viewport.style.display = '';
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var viewportStyle = viewport.style;
	      viewportStyle.width = width + 'px';
	      viewportStyle.height = height + 'px';
	      var svgRoot = this._svgDom; // Set width by 'svgRoot.width = width' is invalid
	
	      svgRoot.setAttribute('width', width);
	      svgRoot.setAttribute('height', height);
	    }
	
	    if (this._backgroundNode) {
	      this._backgroundNode.setAttribute('width', width);
	
	      this._backgroundNode.setAttribute('height', height);
	    }
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
	  },
	  clear: function () {
	    if (this._viewport) {
	      this.root.removeChild(this._viewport);
	    }
	  },
	  toDataURL: function () {
	    this.refresh();
	    var html = encodeURIComponent(this._svgDom.outerHTML.replace(/></g, '>\n\r<'));
	    return 'data:image/svg+xml;charset=UTF-8,' + html;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    logError('In SVG mode painter not support method "' + method + '"');
	  };
	} // Unsuppoted methods
	
	
	util.each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'pathToImage'], function (name) {
	  SVGPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = SVGPainter;
	module.exports = _default;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(455);
	
	var zrUtil = __webpack_require__(2);
	
	var matrix = __webpack_require__(75);
	
	/**
	 * @file Manages SVG clipPath elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG clipPath elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ClippathManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__');
	}
	
	zrUtil.inherits(ClippathManager, Definable);
	/**
	 * Update clipPath.
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	ClippathManager.prototype.update = function (displayable) {
	  var svgEl = this.getSvgElement(displayable);
	
	  if (svgEl) {
	    this.updateDom(svgEl, displayable.__clipPaths, false);
	  }
	
	  var textEl = this.getTextSvgElement(displayable);
	
	  if (textEl) {
	    // Make another clipPath for text, since it's transform
	    // matrix is not the same with svgElement
	    this.updateDom(textEl, displayable.__clipPaths, true);
	  }
	
	  this.markUsed(displayable);
	};
	/**
	 * Create an SVGElement of displayable and create a <clipPath> of its
	 * clipPath
	 *
	 * @param {Displayable} parentEl  parent element
	 * @param {ClipPath[]}  clipPaths clipPaths of parent element
	 * @param {boolean}     isText    if parent element is Text
	 */
	
	
	ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
	  if (clipPaths && clipPaths.length > 0) {
	    // Has clipPath, create <clipPath> with the first clipPath
	    var defs = this.getDefs(true);
	    var clipPath = clipPaths[0];
	    var clipPathEl;
	    var id;
	    var dom = isText ? '_textDom' : '_dom';
	
	    if (clipPath[dom]) {
	      // Use a dom that is already in <defs>
	      id = clipPath[dom].getAttribute('id');
	      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>
	
	      if (!defs.contains(clipPathEl)) {
	        // This happens when set old clipPath that has
	        // been previously removed
	        defs.appendChild(clipPathEl);
	      }
	    } else {
	      // New <clipPath>
	      id = 'zr' + this._zrId + '-clip-' + this.nextId;
	      ++this.nextId;
	      clipPathEl = this.createElement('clipPath');
	      clipPathEl.setAttribute('id', id);
	      defs.appendChild(clipPathEl);
	      clipPath[dom] = clipPathEl;
	    } // Build path and add to <clipPath>
	
	
	    var svgProxy = this.getSvgProxy(clipPath);
	
	    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
	      /**
	       * If a clipPath has a parent with transform, the transform
	       * of parent should not be considered when setting transform
	       * of clipPath. So we need to transform back from parent's
	       * transform, which is done by multiplying parent's inverse
	       * transform.
	       */
	      // Store old transform
	      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path
	
	      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
	      svgProxy.brush(clipPath); // Set back transform of clipPath
	
	      clipPath.transform = transform;
	    } else {
	      svgProxy.brush(clipPath);
	    }
	
	    var pathEl = this.getSvgElement(clipPath);
	    clipPathEl.innerHTML = '';
	    /**
	     * Use `cloneNode()` here to appendChild to multiple parents,
	     * which may happend when Text and other shapes are using the same
	     * clipPath. Since Text will create an extra clipPath DOM due to
	     * different transform rules.
	     */
	
	    clipPathEl.appendChild(pathEl.cloneNode());
	    parentEl.setAttribute('clip-path', 'url(#' + id + ')');
	
	    if (clipPaths.length > 1) {
	      // Make the other clipPaths recursively
	      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
	    }
	  } else {
	    // No clipPath
	    if (parentEl) {
	      parentEl.setAttribute('clip-path', 'none');
	    }
	  }
	};
	/**
	 * Mark a single clipPath to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ClippathManager.prototype.markUsed = function (displayable) {
	  var that = this; // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
	
	  if (displayable.__clipPaths) {
	    zrUtil.each(displayable.__clipPaths, function (clipPath) {
	      if (clipPath._dom) {
	        Definable.prototype.markUsed.call(that, clipPath._dom);
	      }
	
	      if (clipPath._textDom) {
	        Definable.prototype.markUsed.call(that, clipPath._textDom);
	      }
	    });
	  }
	};
	
	var _default = ClippathManager;
	module.exports = _default;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(455);
	
	var zrUtil = __webpack_require__(2);
	
	var logError = __webpack_require__(227);
	
	var colorTool = __webpack_require__(105);
	
	/**
	 * @file Manages SVG gradient elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG gradient elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function GradientManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
	}
	
	zrUtil.inherits(GradientManager, Definable);
	/**
	 * Create new gradient DOM for fill or stroke if not exist,
	 * but will not update gradient if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && displayable.style) {
	    var that = this;
	    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
	      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
	        var gradient = displayable.style[fillOrStroke];
	        var defs = that.getDefs(true); // Create dom in <defs> if not exists
	
	        var dom;
	
	        if (gradient._dom) {
	          // Gradient exists
	          dom = gradient._dom;
	
	          if (!defs.contains(gradient._dom)) {
	            // _dom is no longer in defs, recreate
	            that.addDom(dom);
	          }
	        } else {
	          // New dom
	          dom = that.add(gradient);
	        }
	
	        that.markUsed(displayable);
	        var id = dom.getAttribute('id');
	        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
	      }
	    });
	  }
	};
	/**
	 * Add a new gradient tag in <defs>
	 *
	 * @param   {Gradient} gradient zr gradient instance
	 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
	 *                            created DOM
	 */
	
	
	GradientManager.prototype.add = function (gradient) {
	  var dom;
	
	  if (gradient.type === 'linear') {
	    dom = this.createElement('linearGradient');
	  } else if (gradient.type === 'radial') {
	    dom = this.createElement('radialGradient');
	  } else {
	    logError('Illegal gradient type.');
	    return null;
	  } // Set dom id with gradient id, since each gradient instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	
	  gradient.id = gradient.id || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
	  this.updateDom(gradient, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update gradient.
	 *
	 * @param {Gradient} gradient zr gradient instance
	 */
	
	
	GradientManager.prototype.update = function (gradient) {
	  var that = this;
	  Definable.prototype.update.call(this, gradient, function () {
	    var type = gradient.type;
	    var tagName = gradient._dom.tagName;
	
	    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
	      // Gradient type is not changed, update gradient
	      that.updateDom(gradient, gradient._dom);
	    } else {
	      // Remove and re-create if type is changed
	      that.removeDom(gradient);
	      that.add(gradient);
	    }
	  });
	};
	/**
	 * Update gradient dom
	 *
	 * @param {Gradient} gradient zr gradient instance
	 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
	 *                            DOM to update
	 */
	
	
	GradientManager.prototype.updateDom = function (gradient, dom) {
	  if (gradient.type === 'linear') {
	    dom.setAttribute('x1', gradient.x);
	    dom.setAttribute('y1', gradient.y);
	    dom.setAttribute('x2', gradient.x2);
	    dom.setAttribute('y2', gradient.y2);
	  } else if (gradient.type === 'radial') {
	    dom.setAttribute('cx', gradient.x);
	    dom.setAttribute('cy', gradient.y);
	    dom.setAttribute('r', gradient.r);
	  } else {
	    logError('Illegal gradient type.');
	    return;
	  }
	
	  if (gradient.global) {
	    // x1, x2, y1, y2 in range of 0 to canvas width or height
	    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
	  } else {
	    // x1, x2, y1, y2 in range of 0 to 1
	    dom.setAttribute('gradientUnits', 'objectBoundingBox');
	  } // Remove color stops if exists
	
	
	  dom.innerHTML = ''; // Add color stops
	
	  var colors = gradient.colorStops;
	
	  for (var i = 0, len = colors.length; i < len; ++i) {
	    var stop = this.createElement('stop');
	    stop.setAttribute('offset', colors[i].offset * 100 + '%');
	    var color = colors[i].color;
	
	    if (color.indexOf('rgba') > -1) {
	      // Fix Safari bug that stop-color not recognizing alpha #9014
	      var opacity = colorTool.parse(color)[3];
	      var hex = colorTool.toHex(color); // stop-color cannot be color, since:
	      // The opacity value used for the gradient calculation is the
	      // *product* of the value of stop-opacity and the opacity of the
	      // value of stop-color.
	      // See https://www.w3.org/TR/SVG2/pservers.html#StopOpacityProperty
	
	      stop.setAttribute('stop-color', '#' + hex);
	      stop.setAttribute('stop-opacity', opacity);
	    } else {
	      stop.setAttribute('stop-color', colors[i].color);
	    }
	
	    dom.appendChild(stop);
	  } // Store dom element in gradient, to avoid creating multiple
	  // dom instances for the same gradient element
	
	
	  gradient._dom = dom;
	};
	/**
	 * Mark a single gradient to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	GradientManager.prototype.markUsed = function (displayable) {
	  if (displayable.style) {
	    var gradient = displayable.style.fill;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	
	    gradient = displayable.style.stroke;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	  }
	};
	
	var _default = GradientManager;
	module.exports = _default;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(455);
	
	var zrUtil = __webpack_require__(2);
	
	/**
	 * @file Manages SVG shadow elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG shadow elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ShadowManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['filter'], '__filter_in_use__', '_shadowDom');
	}
	
	zrUtil.inherits(ShadowManager, Definable);
	/**
	 * Create new shadow DOM for fill or stroke if not exist,
	 * but will not update shadow if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	ShadowManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && hasShadow(displayable.style)) {
	    // Create dom in <defs> if not exists
	    var dom;
	
	    if (displayable._shadowDom) {
	      // Gradient exists
	      dom = displayable._shadowDom;
	      var defs = this.getDefs(true);
	
	      if (!defs.contains(displayable._shadowDom)) {
	        // _shadowDom is no longer in defs, recreate
	        this.addDom(dom);
	      }
	    } else {
	      // New dom
	      dom = this.add(displayable);
	    }
	
	    this.markUsed(displayable);
	    var id = dom.getAttribute('id');
	    svgElement.style.filter = 'url(#' + id + ')';
	  }
	};
	/**
	 * Add a new shadow tag in <defs>
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @return {SVGFilterElement} created DOM
	 */
	
	
	ShadowManager.prototype.add = function (displayable) {
	  var dom = this.createElement('filter'); // Set dom id with shadow id, since each shadow instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	  displayable._shadowDomId = displayable._shadowDomId || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + displayable._shadowDomId);
	  this.updateDom(displayable, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update shadow.
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	
	ShadowManager.prototype.update = function (svgElement, displayable) {
	  var style = displayable.style;
	
	  if (hasShadow(style)) {
	    var that = this;
	    Definable.prototype.update.call(this, displayable, function () {
	      that.updateDom(displayable, displayable._shadowDom);
	    });
	  } else {
	    // Remove shadow
	    this.remove(svgElement, displayable);
	  }
	};
	/**
	 * Remove DOM and clear parent filter
	 */
	
	
	ShadowManager.prototype.remove = function (svgElement, displayable) {
	  if (displayable._shadowDomId != null) {
	    this.removeDom(svgElement);
	    svgElement.style.filter = '';
	  }
	};
	/**
	 * Update shadow dom
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @param {SVGFilterElement} dom DOM to update
	 */
	
	
	ShadowManager.prototype.updateDom = function (displayable, dom) {
	  var domChild = dom.getElementsByTagName('feDropShadow');
	
	  if (domChild.length === 0) {
	    domChild = this.createElement('feDropShadow');
	  } else {
	    domChild = domChild[0];
	  }
	
	  var style = displayable.style;
	  var scaleX = displayable.scale ? displayable.scale[0] || 1 : 1;
	  var scaleY = displayable.scale ? displayable.scale[1] || 1 : 1; // TODO: textBoxShadowBlur is not supported yet
	
	  var offsetX;
	  var offsetY;
	  var blur;
	  var color;
	
	  if (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY) {
	    offsetX = style.shadowOffsetX || 0;
	    offsetY = style.shadowOffsetY || 0;
	    blur = style.shadowBlur;
	    color = style.shadowColor;
	  } else if (style.textShadowBlur) {
	    offsetX = style.textShadowOffsetX || 0;
	    offsetY = style.textShadowOffsetY || 0;
	    blur = style.textShadowBlur;
	    color = style.textShadowColor;
	  } else {
	    // Remove shadow
	    this.removeDom(dom, style);
	    return;
	  }
	
	  domChild.setAttribute('dx', offsetX / scaleX);
	  domChild.setAttribute('dy', offsetY / scaleY);
	  domChild.setAttribute('flood-color', color); // Divide by two here so that it looks the same as in canvas
	  // See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-shadowblur
	
	  var stdDx = blur / 2 / scaleX;
	  var stdDy = blur / 2 / scaleY;
	  var stdDeviation = stdDx + ' ' + stdDy;
	  domChild.setAttribute('stdDeviation', stdDeviation); // Fix filter clipping problem
	
	  dom.setAttribute('x', '-100%');
	  dom.setAttribute('y', '-100%');
	  dom.setAttribute('width', Math.ceil(blur / 2 * 200) + '%');
	  dom.setAttribute('height', Math.ceil(blur / 2 * 200) + '%');
	  dom.appendChild(domChild); // Store dom element in shadow, to avoid creating multiple
	  // dom instances for the same shadow element
	
	  displayable._shadowDom = dom;
	};
	/**
	 * Mark a single shadow to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ShadowManager.prototype.markUsed = function (displayable) {
	  if (displayable._shadowDom) {
	    Definable.prototype.markUsed.call(this, displayable._shadowDom);
	  }
	};
	
	function hasShadow(style) {
	  // TODO: textBoxShadowBlur is not supported yet
	  return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY || style.textShadowBlur || style.textShadowOffsetX || style.textShadowOffsetY);
	}
	
	var _default = ShadowManager;
	module.exports = _default;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(454);
	
	var _zrender = __webpack_require__(285);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(2081);
	
	registerPainter('svg', Painter);

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(180);
	
	var _vector = __webpack_require__(49);
	
	var v2ApplyTransform = _vector.applyTransform;
	var CMD = PathProxy.CMD;
	var points = [[], [], []];
	var mathSqrt = Math.sqrt;
	var mathAtan2 = Math.atan2;
	
	function _default(path, m) {
	  var data = path.data;
	  var cmd;
	  var nPoint;
	  var i;
	  var j;
	  var k;
	  var p;
	  var M = CMD.M;
	  var C = CMD.C;
	  var L = CMD.L;
	  var R = CMD.R;
	  var A = CMD.A;
	  var Q = CMD.Q;
	
	  for (i = 0, j = 0; i < data.length;) {
	    cmd = data[i++];
	    j = i;
	    nPoint = 0;
	
	    switch (cmd) {
	      case M:
	        nPoint = 1;
	        break;
	
	      case L:
	        nPoint = 1;
	        break;
	
	      case C:
	        nPoint = 3;
	        break;
	
	      case Q:
	        nPoint = 2;
	        break;
	
	      case A:
	        var x = m[4];
	        var y = m[5];
	        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
	        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
	        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx
	
	        data[i] *= sx;
	        data[i++] += x; // cy
	
	        data[i] *= sy;
	        data[i++] += y; // Scale rx and ry
	        // FIXME Assume psi is 0 here
	
	        data[i++] *= sx;
	        data[i++] *= sy; // Start angle
	
	        data[i++] += angle; // end angle
	
	        data[i++] += angle; // FIXME psi
	
	        i += 2;
	        j = i;
	        break;
	
	      case R:
	        // x0, y0
	        p[0] = data[i++];
	        p[1] = data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1]; // x1, y1
	
	        p[0] += data[i++];
	        p[1] += data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1];
	    }
	
	    for (k = 0; k < nPoint; k++) {
	      var p = points[k];
	      p[0] = data[i++];
	      p[1] = data[i++];
	      v2ApplyTransform(p, p, m); // Write back
	
	      data[j++] = p[0];
	      data[j++] = p[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	var logError = __webpack_require__(227);
	
	var vmlCore = __webpack_require__(917);
	
	var _util = __webpack_require__(2);
	
	var each = _util.each;
	
	/**
	 * VML Painter.
	 *
	 * @module zrender/vml/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	/**
	 * @alias module:zrender/vml/Painter
	 */
	
	
	function VMLPainter(root, storage) {
	  vmlCore.initVML();
	  this.root = root;
	  this.storage = storage;
	  var vmlViewport = document.createElement('div');
	  var vmlRoot = document.createElement('div');
	  vmlViewport.style.cssText = 'display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;';
	  vmlRoot.style.cssText = 'position:absolute;left:0;top:0;';
	  root.appendChild(vmlViewport);
	  this._vmlRoot = vmlRoot;
	  this._vmlViewport = vmlViewport;
	  this.resize(); // Modify storage
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	
	    if (el) {
	      el.onRemove && el.onRemove(vmlRoot);
	    }
	  };
	
	  storage.addToStorage = function (el) {
	    // Displayable already has a vml node
	    el.onAdd && el.onAdd(vmlRoot);
	    oldAddToStorage.call(storage, el);
	  };
	
	  this._firstPaint = true;
	}
	
	VMLPainter.prototype = {
	  constructor: VMLPainter,
	  getType: function () {
	    return 'vml';
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._vmlViewport;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   */
	  refresh: function () {
	    var list = this.storage.getDisplayList(true, true);
	
	    this._paintList(list);
	  },
	  _paintList: function (list) {
	    var vmlRoot = this._vmlRoot;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	
	      if (el.invisible || el.ignore) {
	        if (!el.__alreadyNotVisible) {
	          el.onRemove(vmlRoot);
	        } // Set as already invisible
	
	
	        el.__alreadyNotVisible = true;
	      } else {
	        if (el.__alreadyNotVisible) {
	          el.onAdd(vmlRoot);
	        }
	
	        el.__alreadyNotVisible = false;
	
	        if (el.__dirty) {
	          el.beforeBrush && el.beforeBrush();
	          (el.brushVML || el.brush).call(el, vmlRoot);
	          el.afterBrush && el.afterBrush();
	        }
	      }
	
	      el.__dirty = false;
	    }
	
	    if (this._firstPaint) {
	      // Detached from document at first time
	      // to avoid page refreshing too many times
	      // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
	      this._vmlViewport.appendChild(vmlRoot);
	
	      this._firstPaint = false;
	    }
	  },
	  resize: function (width, height) {
	    var width = width == null ? this._getWidth() : width;
	    var height = height == null ? this._getHeight() : height;
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var vmlViewportStyle = this._vmlViewport.style;
	      vmlViewportStyle.width = width + 'px';
	      vmlViewportStyle.height = height + 'px';
	    }
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._vmlRoot = this._vmlViewport = this.storage = null;
	  },
	  getWidth: function () {
	    return this._width;
	  },
	  getHeight: function () {
	    return this._height;
	  },
	  clear: function () {
	    if (this._vmlViewport) {
	      this.root.removeChild(this._vmlViewport);
	    }
	  },
	  _getWidth: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientWidth || parseInt10(stl.width)) - parseInt10(stl.paddingLeft) - parseInt10(stl.paddingRight) | 0;
	  },
	  _getHeight: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientHeight || parseInt10(stl.height)) - parseInt10(stl.paddingTop) - parseInt10(stl.paddingBottom) | 0;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    logError('In IE8.0 VML mode painter not support method "' + method + '"');
	  };
	} // Unsupported methods
	
	
	each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
	  VMLPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = VMLPainter;
	module.exports = _default;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(58);
	
	var _vector = __webpack_require__(49);
	
	var applyTransform = _vector.applyTransform;
	
	var BoundingRect = __webpack_require__(51);
	
	var colorTool = __webpack_require__(105);
	
	var textContain = __webpack_require__(86);
	
	var textHelper = __webpack_require__(283);
	
	var RectText = __webpack_require__(910);
	
	var Displayable = __webpack_require__(228);
	
	var ZImage = __webpack_require__(181);
	
	var Text = __webpack_require__(147);
	
	var Path = __webpack_require__(55);
	
	var PathProxy = __webpack_require__(180);
	
	var Gradient = __webpack_require__(281);
	
	var vmlCore = __webpack_require__(917);
	
	// http://www.w3.org/TR/NOTE-VML
	// TODO Use proxy like svg instead of overwrite brush methods
	var CMD = PathProxy.CMD;
	var round = Math.round;
	var sqrt = Math.sqrt;
	var abs = Math.abs;
	var cos = Math.cos;
	var sin = Math.sin;
	var mathMax = Math.max;
	
	if (!env.canvasSupported) {
	  var comma = ',';
	  var imageTransformPrefix = 'progid:DXImageTransform.Microsoft';
	  var Z = 21600;
	  var Z2 = Z / 2;
	  var ZLEVEL_BASE = 100000;
	  var Z_BASE = 1000;
	
	  var initRootElStyle = function (el) {
	    el.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;';
	    el.coordsize = Z + ',' + Z;
	    el.coordorigin = '0,0';
	  };
	
	  var encodeHtmlAttribute = function (s) {
	    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
	  };
	
	  var rgb2Str = function (r, g, b) {
	    return 'rgb(' + [r, g, b].join(',') + ')';
	  };
	
	  var append = function (parent, child) {
	    if (child && parent && child.parentNode !== parent) {
	      parent.appendChild(child);
	    }
	  };
	
	  var remove = function (parent, child) {
	    if (child && parent && child.parentNode === parent) {
	      parent.removeChild(child);
	    }
	  };
	
	  var getZIndex = function (zlevel, z, z2) {
	    // z 的取值范围为 [0, 1000]
	    return (parseFloat(zlevel) || 0) * ZLEVEL_BASE + (parseFloat(z) || 0) * Z_BASE + z2;
	  };
	
	  var parsePercent = textHelper.parsePercent;
	  /***************************************************
	   * PATH
	   **************************************************/
	
	  var setColorAndOpacity = function (el, color, opacity) {
	    var colorArr = colorTool.parse(color);
	    opacity = +opacity;
	
	    if (isNaN(opacity)) {
	      opacity = 1;
	    }
	
	    if (colorArr) {
	      el.color = rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
	      el.opacity = opacity * colorArr[3];
	    }
	  };
	
	  var getColorAndAlpha = function (color) {
	    var colorArr = colorTool.parse(color);
	    return [rgb2Str(colorArr[0], colorArr[1], colorArr[2]), colorArr[3]];
	  };
	
	  var updateFillNode = function (el, style, zrEl) {
	    // TODO pattern
	    var fill = style.fill;
	
	    if (fill != null) {
	      // Modified from excanvas
	      if (fill instanceof Gradient) {
	        var gradientType;
	        var angle = 0;
	        var focus = [0, 0]; // additional offset
	
	        var shift = 0; // scale factor for offset
	
	        var expansion = 1;
	        var rect = zrEl.getBoundingRect();
	        var rectWidth = rect.width;
	        var rectHeight = rect.height;
	
	        if (fill.type === 'linear') {
	          gradientType = 'gradient';
	          var transform = zrEl.transform;
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var p1 = [fill.x2 * rectWidth, fill.y2 * rectHeight];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	            applyTransform(p1, p1, transform);
	          }
	
	          var dx = p1[0] - p0[0];
	          var dy = p1[1] - p0[1];
	          angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.
	
	          if (angle < 0) {
	            angle += 360;
	          } // Very small angles produce an unexpected result because they are
	          // converted to a scientific notation string.
	
	
	          if (angle < 1e-6) {
	            angle = 0;
	          }
	        } else {
	          gradientType = 'gradientradial';
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var transform = zrEl.transform;
	          var scale = zrEl.scale;
	          var width = rectWidth;
	          var height = rectHeight;
	          focus = [// Percent in bounding rect
	          (p0[0] - rect.x) / width, (p0[1] - rect.y) / height];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	          }
	
	          width /= scale[0] * Z;
	          height /= scale[1] * Z;
	          var dimension = mathMax(width, height);
	          shift = 2 * 0 / dimension;
	          expansion = 2 * fill.r / dimension - shift;
	        } // We need to sort the color stops in ascending order by offset,
	        // otherwise IE won't interpret it correctly.
	
	
	        var stops = fill.colorStops.slice();
	        stops.sort(function (cs1, cs2) {
	          return cs1.offset - cs2.offset;
	        });
	        var length = stops.length; // Color and alpha list of first and last stop
	
	        var colorAndAlphaList = [];
	        var colors = [];
	
	        for (var i = 0; i < length; i++) {
	          var stop = stops[i];
	          var colorAndAlpha = getColorAndAlpha(stop.color);
	          colors.push(stop.offset * expansion + shift + ' ' + colorAndAlpha[0]);
	
	          if (i === 0 || i === length - 1) {
	            colorAndAlphaList.push(colorAndAlpha);
	          }
	        }
	
	        if (length >= 2) {
	          var color1 = colorAndAlphaList[0][0];
	          var color2 = colorAndAlphaList[1][0];
	          var opacity1 = colorAndAlphaList[0][1] * style.opacity;
	          var opacity2 = colorAndAlphaList[1][1] * style.opacity;
	          el.type = gradientType;
	          el.method = 'none';
	          el.focus = '100%';
	          el.angle = angle;
	          el.color = color1;
	          el.color2 = color2;
	          el.colors = colors.join(','); // When colors attribute is used, the meanings of opacity and o:opacity2
	          // are reversed.
	
	          el.opacity = opacity2; // FIXME g_o_:opacity ?
	
	          el.opacity2 = opacity1;
	        }
	
	        if (gradientType === 'radial') {
	          el.focusposition = focus.join(',');
	        }
	      } else {
	        // FIXME Change from Gradient fill to color fill
	        setColorAndOpacity(el, fill, style.opacity);
	      }
	    }
	  };
	
	  var updateStrokeNode = function (el, style) {
	    // if (style.lineJoin != null) {
	    //     el.joinstyle = style.lineJoin;
	    // }
	    // if (style.miterLimit != null) {
	    //     el.miterlimit = style.miterLimit * Z;
	    // }
	    // if (style.lineCap != null) {
	    //     el.endcap = style.lineCap;
	    // }
	    if (style.lineDash) {
	      el.dashstyle = style.lineDash.join(' ');
	    }
	
	    if (style.stroke != null && !(style.stroke instanceof Gradient)) {
	      setColorAndOpacity(el, style.stroke, style.opacity);
	    }
	  };
	
	  var updateFillAndStroke = function (vmlEl, type, style, zrEl) {
	    var isFill = type === 'fill';
	    var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth
	
	    if (style[type] != null && style[type] !== 'none' && (isFill || !isFill && style.lineWidth)) {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'true'; // FIXME Remove before updating, or set `colors` will throw error
	
	      if (style[type] instanceof Gradient) {
	        remove(vmlEl, el);
	      }
	
	      if (!el) {
	        el = vmlCore.createNode(type);
	      }
	
	      isFill ? updateFillNode(el, style, zrEl) : updateStrokeNode(el, style);
	      append(vmlEl, el);
	    } else {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'false';
	      remove(vmlEl, el);
	    }
	  };
	
	  var points = [[], [], []];
	
	  var pathDataToString = function (path, m) {
	    var M = CMD.M;
	    var C = CMD.C;
	    var L = CMD.L;
	    var A = CMD.A;
	    var Q = CMD.Q;
	    var str = [];
	    var nPoint;
	    var cmdStr;
	    var cmd;
	    var i;
	    var xi;
	    var yi;
	    var data = path.data;
	    var dataLength = path.len();
	
	    for (i = 0; i < dataLength;) {
	      cmd = data[i++];
	      cmdStr = '';
	      nPoint = 0;
	
	      switch (cmd) {
	        case M:
	          cmdStr = ' m ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case L:
	          cmdStr = ' l ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case Q:
	        case C:
	          cmdStr = ' c ';
	          nPoint = 3;
	          var x1 = data[i++];
	          var y1 = data[i++];
	          var x2 = data[i++];
	          var y2 = data[i++];
	          var x3;
	          var y3;
	
	          if (cmd === Q) {
	            // Convert quadratic to cubic using degree elevation
	            x3 = x2;
	            y3 = y2;
	            x2 = (x2 + 2 * x1) / 3;
	            y2 = (y2 + 2 * y1) / 3;
	            x1 = (xi + 2 * x1) / 3;
	            y1 = (yi + 2 * y1) / 3;
	          } else {
	            x3 = data[i++];
	            y3 = data[i++];
	          }
	
	          points[0][0] = x1;
	          points[0][1] = y1;
	          points[1][0] = x2;
	          points[1][1] = y2;
	          points[2][0] = x3;
	          points[2][1] = y3;
	          xi = x3;
	          yi = y3;
	          break;
	
	        case A:
	          var x = 0;
	          var y = 0;
	          var sx = 1;
	          var sy = 1;
	          var angle = 0;
	
	          if (m) {
	            // Extract SRT from matrix
	            x = m[4];
	            y = m[5];
	            sx = sqrt(m[0] * m[0] + m[1] * m[1]);
	            sy = sqrt(m[2] * m[2] + m[3] * m[3]);
	            angle = Math.atan2(-m[1] / sy, m[0] / sx);
	          }
	
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++] + angle;
	          var endAngle = data[i++] + startAngle + angle; // FIXME
	          // var psi = data[i++];
	
	          i++;
	          var clockwise = data[i++];
	          var x0 = cx + cos(startAngle) * rx;
	          var y0 = cy + sin(startAngle) * ry;
	          var x1 = cx + cos(endAngle) * rx;
	          var y1 = cy + sin(endAngle) * ry;
	          var type = clockwise ? ' wa ' : ' at ';
	
	          if (Math.abs(x0 - x1) < 1e-4) {
	            // IE won't render arches drawn counter clockwise if x0 == x1.
	            if (Math.abs(endAngle - startAngle) > 1e-2) {
	              // Offset x0 by 1/80 of a pixel. Use something
	              // that can be represented in binary
	              if (clockwise) {
	                x0 += 270 / Z;
	              }
	            } else {
	              // Avoid case draw full circle
	              if (Math.abs(y0 - cy) < 1e-4) {
	                if (clockwise && x0 < cx || !clockwise && x0 > cx) {
	                  y1 -= 270 / Z;
	                } else {
	                  y1 += 270 / Z;
	                }
	              } else if (clockwise && y0 < cy || !clockwise && y0 > cy) {
	                x1 += 270 / Z;
	              } else {
	                x1 -= 270 / Z;
	              }
	            }
	          }
	
	          str.push(type, round(((cx - rx) * sx + x) * Z - Z2), comma, round(((cy - ry) * sy + y) * Z - Z2), comma, round(((cx + rx) * sx + x) * Z - Z2), comma, round(((cy + ry) * sy + y) * Z - Z2), comma, round((x0 * sx + x) * Z - Z2), comma, round((y0 * sy + y) * Z - Z2), comma, round((x1 * sx + x) * Z - Z2), comma, round((y1 * sy + y) * Z - Z2));
	          xi = x1;
	          yi = y1;
	          break;
	
	        case CMD.R:
	          var p0 = points[0];
	          var p1 = points[1]; // x0, y0
	
	          p0[0] = data[i++];
	          p0[1] = data[i++]; // x1, y1
	
	          p1[0] = p0[0] + data[i++];
	          p1[1] = p0[1] + data[i++];
	
	          if (m) {
	            applyTransform(p0, p0, m);
	            applyTransform(p1, p1, m);
	          }
	
	          p0[0] = round(p0[0] * Z - Z2);
	          p1[0] = round(p1[0] * Z - Z2);
	          p0[1] = round(p0[1] * Z - Z2);
	          p1[1] = round(p1[1] * Z - Z2);
	          str.push( // x0, y0
	          ' m ', p0[0], comma, p0[1], // x1, y0
	          ' l ', p1[0], comma, p0[1], // x1, y1
	          ' l ', p1[0], comma, p1[1], // x0, y1
	          ' l ', p0[0], comma, p1[1]);
	          break;
	
	        case CMD.Z:
	          // FIXME Update xi, yi
	          str.push(' x ');
	      }
	
	      if (nPoint > 0) {
	        str.push(cmdStr);
	
	        for (var k = 0; k < nPoint; k++) {
	          var p = points[k];
	          m && applyTransform(p, p, m); // 不 round 会非常慢
	
	          str.push(round(p[0] * Z - Z2), comma, round(p[1] * Z - Z2), k < nPoint - 1 ? comma : '');
	        }
	      }
	    }
	
	    return str.join('');
	  }; // Rewrite the original path method
	
	
	  Path.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      vmlEl = vmlCore.createNode('shape');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    updateFillAndStroke(vmlEl, 'fill', style, this);
	    updateFillAndStroke(vmlEl, 'stroke', style, this);
	    var m = this.transform;
	    var needTransform = m != null;
	    var strokeEl = vmlEl.getElementsByTagName('stroke')[0];
	
	    if (strokeEl) {
	      var lineWidth = style.lineWidth; // Get the line scale.
	      // Determinant of this.m_ means how much the area is enlarged by the
	      // transformation. So its square root can be used as a scale factor
	      // for width.
	
	      if (needTransform && !style.strokeNoScale) {
	        var det = m[0] * m[3] - m[1] * m[2];
	        lineWidth *= sqrt(abs(det));
	      }
	
	      strokeEl.weight = lineWidth + 'px';
	    }
	
	    var path = this.path || (this.path = new PathProxy());
	
	    if (this.__dirtyPath) {
	      path.beginPath();
	      path.subPixelOptimize = false;
	      this.buildPath(path, this.shape);
	      path.toStatic();
	      this.__dirtyPath = false;
	    }
	
	    vmlEl.path = pathDataToString(path, this.transform);
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Path.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this.removeRectText(vmlRoot);
	  };
	
	  Path.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * IMAGE
	   **************************************************/
	
	
	  var isImage = function (img) {
	    // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
	    return typeof img === 'object' && img.tagName && img.tagName.toUpperCase() === 'IMG'; // return img instanceof Image;
	  }; // Rewrite the original path method
	
	
	  ZImage.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var image = style.image; // Image original width, height
	
	    var ow;
	    var oh;
	
	    if (isImage(image)) {
	      var src = image.src;
	
	      if (src === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      } else {
	        var imageRuntimeStyle = image.runtimeStyle;
	        var oldRuntimeWidth = imageRuntimeStyle.width;
	        var oldRuntimeHeight = imageRuntimeStyle.height;
	        imageRuntimeStyle.width = 'auto';
	        imageRuntimeStyle.height = 'auto'; // get the original size
	
	        ow = image.width;
	        oh = image.height; // and remove overides
	
	        imageRuntimeStyle.width = oldRuntimeWidth;
	        imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src
	
	        this._imageSrc = src;
	        this._imageWidth = ow;
	        this._imageHeight = oh;
	      }
	
	      image = src;
	    } else {
	      if (image === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      }
	    }
	
	    if (!image) {
	      return;
	    }
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var dw = style.width;
	    var dh = style.height;
	    var sw = style.sWidth;
	    var sh = style.sHeight;
	    var sx = style.sx || 0;
	    var sy = style.sy || 0;
	    var hasCrop = sw && sh;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
	      // vmlEl = vmlCore.createNode('group');
	      vmlEl = vmlCore.doc.createElement('div');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    var vmlElStyle = vmlEl.style;
	    var hasRotation = false;
	    var m;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    if (this.transform) {
	      m = this.transform;
	      scaleX = sqrt(m[0] * m[0] + m[1] * m[1]);
	      scaleY = sqrt(m[2] * m[2] + m[3] * m[3]);
	      hasRotation = m[1] || m[2];
	    }
	
	    if (hasRotation) {
	      // If filters are necessary (rotation exists), create them
	      // filters are bog-slow, so only create them if abbsolutely necessary
	      // The following check doesn't account for skews (which don't exist
	      // in the canvas spec (yet) anyway.
	      // From excanvas
	      var p0 = [x, y];
	      var p1 = [x + dw, y];
	      var p2 = [x, y + dh];
	      var p3 = [x + dw, y + dh];
	      applyTransform(p0, p0, m);
	      applyTransform(p1, p1, m);
	      applyTransform(p2, p2, m);
	      applyTransform(p3, p3, m);
	      var maxX = mathMax(p0[0], p1[0], p2[0], p3[0]);
	      var maxY = mathMax(p0[1], p1[1], p2[1], p3[1]);
	      var transformFilter = [];
	      transformFilter.push('M11=', m[0] / scaleX, comma, 'M12=', m[2] / scaleY, comma, 'M21=', m[1] / scaleX, comma, 'M22=', m[3] / scaleY, comma, 'Dx=', round(x * scaleX + m[4]), comma, 'Dy=', round(y * scaleY + m[5]));
	      vmlElStyle.padding = '0 ' + round(maxX) + 'px ' + round(maxY) + 'px 0'; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用
	
	      vmlElStyle.filter = imageTransformPrefix + '.Matrix(' + transformFilter.join('') + ', SizingMethod=clip)';
	    } else {
	      if (m) {
	        x = x * scaleX + m[4];
	        y = y * scaleY + m[5];
	      }
	
	      vmlElStyle.filter = '';
	      vmlElStyle.left = round(x) + 'px';
	      vmlElStyle.top = round(y) + 'px';
	    }
	
	    var imageEl = this._imageEl;
	    var cropEl = this._cropEl;
	
	    if (!imageEl) {
	      imageEl = vmlCore.doc.createElement('div');
	      this._imageEl = imageEl;
	    }
	
	    var imageELStyle = imageEl.style;
	
	    if (hasCrop) {
	      // Needs know image original width and height
	      if (!(ow && oh)) {
	        var tmpImage = new Image();
	        var self = this;
	
	        tmpImage.onload = function () {
	          tmpImage.onload = null;
	          ow = tmpImage.width;
	          oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize
	
	          imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	          imageELStyle.height = round(scaleY * oh * dh / sh) + 'px'; // Caching image original width, height and src
	
	          self._imageWidth = ow;
	          self._imageHeight = oh;
	          self._imageSrc = image;
	        };
	
	        tmpImage.src = image;
	      } else {
	        imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	        imageELStyle.height = round(scaleY * oh * dh / sh) + 'px';
	      }
	
	      if (!cropEl) {
	        cropEl = vmlCore.doc.createElement('div');
	        cropEl.style.overflow = 'hidden';
	        this._cropEl = cropEl;
	      }
	
	      var cropElStyle = cropEl.style;
	      cropElStyle.width = round((dw + sx * dw / sw) * scaleX);
	      cropElStyle.height = round((dh + sy * dh / sh) * scaleY);
	      cropElStyle.filter = imageTransformPrefix + '.Matrix(Dx=' + -sx * dw / sw * scaleX + ',Dy=' + -sy * dh / sh * scaleY + ')';
	
	      if (!cropEl.parentNode) {
	        vmlEl.appendChild(cropEl);
	      }
	
	      if (imageEl.parentNode !== cropEl) {
	        cropEl.appendChild(imageEl);
	      }
	    } else {
	      imageELStyle.width = round(scaleX * dw) + 'px';
	      imageELStyle.height = round(scaleY * dh) + 'px';
	      vmlEl.appendChild(imageEl);
	
	      if (cropEl && cropEl.parentNode) {
	        vmlEl.removeChild(cropEl);
	        this._cropEl = null;
	      }
	    }
	
	    var filterStr = '';
	    var alpha = style.opacity;
	
	    if (alpha < 1) {
	      filterStr += '.Alpha(opacity=' + round(alpha * 100) + ') ';
	    }
	
	    filterStr += imageTransformPrefix + '.AlphaImageLoader(src=' + image + ', SizingMethod=scale)';
	    imageELStyle.filter = filterStr;
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    }
	  };
	
	  ZImage.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this._vmlEl = null;
	    this._cropEl = null;
	    this._imageEl = null;
	    this.removeRectText(vmlRoot);
	  };
	
	  ZImage.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * TEXT
	   **************************************************/
	
	
	  var DEFAULT_STYLE_NORMAL = 'normal';
	  var fontStyleCache = {};
	  var fontStyleCacheCount = 0;
	  var MAX_FONT_CACHE_SIZE = 100;
	  var fontEl = document.createElement('div');
	
	  var getFontStyle = function (fontString) {
	    var fontStyle = fontStyleCache[fontString];
	
	    if (!fontStyle) {
	      // Clear cache
	      if (fontStyleCacheCount > MAX_FONT_CACHE_SIZE) {
	        fontStyleCacheCount = 0;
	        fontStyleCache = {};
	      }
	
	      var style = fontEl.style;
	      var fontFamily;
	
	      try {
	        style.font = fontString;
	        fontFamily = style.fontFamily.split(',')[0];
	      } catch (e) {}
	
	      fontStyle = {
	        style: style.fontStyle || DEFAULT_STYLE_NORMAL,
	        variant: style.fontVariant || DEFAULT_STYLE_NORMAL,
	        weight: style.fontWeight || DEFAULT_STYLE_NORMAL,
	        size: parseFloat(style.fontSize || 12) | 0,
	        family: fontFamily || 'Microsoft YaHei'
	      };
	      fontStyleCache[fontString] = fontStyle;
	      fontStyleCacheCount++;
	    }
	
	    return fontStyle;
	  };
	
	  var textMeasureEl; // Overwrite measure text method
	
	  textContain.$override('measureText', function (text, textFont) {
	    var doc = vmlCore.doc;
	
	    if (!textMeasureEl) {
	      textMeasureEl = doc.createElement('div');
	      textMeasureEl.style.cssText = 'position:absolute;top:-20000px;left:0;' + 'padding:0;margin:0;border:none;white-space:pre;';
	      vmlCore.doc.body.appendChild(textMeasureEl);
	    }
	
	    try {
	      textMeasureEl.style.font = textFont;
	    } catch (ex) {// Ignore failures to set to invalid font.
	    }
	
	    textMeasureEl.innerHTML = ''; // Don't use innerHTML or innerText because they allow markup/whitespace.
	
	    textMeasureEl.appendChild(doc.createTextNode(text));
	    return {
	      width: textMeasureEl.offsetWidth
	    };
	  });
	  var tmpRect = new BoundingRect();
	
	  var drawRectText = function (vmlRoot, rect, textRect, fromTextEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!text) {
	      return;
	    } // Convert rich text to plain text. Rich text is not supported in
	    // IE8-, but tags in rich text template will be removed.
	
	
	    if (style.rich) {
	      var contentBlock = textContain.parseRichText(text, style);
	      text = [];
	
	      for (var i = 0; i < contentBlock.lines.length; i++) {
	        var tokens = contentBlock.lines[i].tokens;
	        var textLine = [];
	
	        for (var j = 0; j < tokens.length; j++) {
	          textLine.push(tokens[j].text);
	        }
	
	        text.push(textLine.join(''));
	      }
	
	      text = text.join('\n');
	    }
	
	    var x;
	    var y;
	    var align = style.textAlign;
	    var verticalAlign = style.textVerticalAlign;
	    var fontStyle = getFontStyle(style.font); // FIXME encodeHtmlAttribute ?
	
	    var font = fontStyle.style + ' ' + fontStyle.variant + ' ' + fontStyle.weight + ' ' + fontStyle.size + 'px "' + fontStyle.family + '"';
	    textRect = textRect || textContain.getBoundingRect(text, font, align, verticalAlign, style.textPadding, style.textLineHeight); // Transform rect to view space
	
	    var m = this.transform; // Ignore transform for text in other element
	
	    if (m && !fromTextEl) {
	      tmpRect.copy(rect);
	      tmpRect.applyTransform(m);
	      rect = tmpRect;
	    }
	
	    if (!fromTextEl) {
	      var textPosition = style.textPosition; // Text position represented by coord
	
	      if (textPosition instanceof Array) {
	        x = rect.x + parsePercent(textPosition[0], rect.width);
	        y = rect.y + parsePercent(textPosition[1], rect.height);
	        align = align || 'left';
	      } else {
	        var res = this.calculateTextPosition ? this.calculateTextPosition({}, style, rect) : textContain.calculateTextPosition({}, style, rect);
	        x = res.x;
	        y = res.y; // Default align and baseline when has textPosition
	
	        align = align || res.textAlign;
	        verticalAlign = verticalAlign || res.textVerticalAlign;
	      }
	    } else {
	      x = rect.x;
	      y = rect.y;
	    }
	
	    x = textContain.adjustTextX(x, textRect.width, align);
	    y = textContain.adjustTextY(y, textRect.height, verticalAlign); // Force baseline 'middle'
	
	    y += textRect.height / 2; // var fontSize = fontStyle.size;
	    // 1.75 is an arbitrary number, as there is no info about the text baseline
	    // switch (baseline) {
	    // case 'hanging':
	    // case 'top':
	    //     y += fontSize / 1.75;
	    //     break;
	    //     case 'middle':
	    //         break;
	    //     default:
	    //     // case null:
	    //     // case 'alphabetic':
	    //     // case 'ideographic':
	    //     // case 'bottom':
	    //         y -= fontSize / 2.25;
	    //         break;
	    // }
	    // switch (align) {
	    //     case 'left':
	    //         break;
	    //     case 'center':
	    //         x -= textRect.width / 2;
	    //         break;
	    //     case 'right':
	    //         x -= textRect.width;
	    //         break;
	    // case 'end':
	    // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
	    // break;
	    // case 'start':
	    // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
	    // break;
	    // default:
	    //     align = 'left';
	    // }
	
	    var createNode = vmlCore.createNode;
	    var textVmlEl = this._textVmlEl;
	    var pathEl;
	    var textPathEl;
	    var skewEl;
	
	    if (!textVmlEl) {
	      textVmlEl = createNode('line');
	      pathEl = createNode('path');
	      textPathEl = createNode('textpath');
	      skewEl = createNode('skew'); // FIXME Why here is not cammel case
	      // Align 'center' seems wrong
	
	      textPathEl.style['v-text-align'] = 'left';
	      initRootElStyle(textVmlEl);
	      pathEl.textpathok = true;
	      textPathEl.on = true;
	      textVmlEl.from = '0 0';
	      textVmlEl.to = '1000 0.05';
	      append(textVmlEl, skewEl);
	      append(textVmlEl, pathEl);
	      append(textVmlEl, textPathEl);
	      this._textVmlEl = textVmlEl;
	    } else {
	      // 这里是在前面 appendChild 保证顺序的前提下
	      skewEl = textVmlEl.firstChild;
	      pathEl = skewEl.nextSibling;
	      textPathEl = pathEl.nextSibling;
	    }
	
	    var coords = [x, y];
	    var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element
	
	    if (m && fromTextEl) {
	      applyTransform(coords, coords, m);
	      skewEl.on = true;
	      skewEl.matrix = m[0].toFixed(3) + comma + m[2].toFixed(3) + comma + m[1].toFixed(3) + comma + m[3].toFixed(3) + ',0,0'; // Text position
	
	      skewEl.offset = (round(coords[0]) || 0) + ',' + (round(coords[1]) || 0); // Left top point as origin
	
	      skewEl.origin = '0 0';
	      textVmlElStyle.left = '0px';
	      textVmlElStyle.top = '0px';
	    } else {
	      skewEl.on = false;
	      textVmlElStyle.left = round(x) + 'px';
	      textVmlElStyle.top = round(y) + 'px';
	    }
	
	    textPathEl.string = encodeHtmlAttribute(text); // TODO
	
	    try {
	      textPathEl.style.font = font;
	    } // Error font format
	    catch (e) {}
	
	    updateFillAndStroke(textVmlEl, 'fill', {
	      fill: style.textFill,
	      opacity: style.opacity
	    }, this);
	    updateFillAndStroke(textVmlEl, 'stroke', {
	      stroke: style.textStroke,
	      opacity: style.opacity,
	      lineDash: style.lineDash || null // style.lineDash can be `false`.
	
	    }, this);
	    textVmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Attached to root
	
	    append(vmlRoot, textVmlEl);
	  };
	
	  var removeRectText = function (vmlRoot) {
	    remove(vmlRoot, this._textVmlEl);
	    this._textVmlEl = null;
	  };
	
	  var appendRectText = function (vmlRoot) {
	    append(vmlRoot, this._textVmlEl);
	  };
	
	  var list = [RectText, Displayable, ZImage, Path, Text]; // In case Displayable has been mixed in RectText
	
	  for (var i = 0; i < list.length; i++) {
	    var proto = list[i].prototype;
	    proto.drawRectText = drawRectText;
	    proto.removeRectText = removeRectText;
	    proto.appendRectText = appendRectText;
	  }
	
	  Text.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, {
	        x: style.x || 0,
	        y: style.y || 0,
	        width: 0,
	        height: 0
	      }, this.getBoundingRect(), true);
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Text.prototype.onRemove = function (vmlRoot) {
	    this.removeRectText(vmlRoot);
	  };
	
	  Text.prototype.onAdd = function (vmlRoot) {
	    this.appendRectText(vmlRoot);
	  };
	}

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2088);
	
	var _zrender = __webpack_require__(285);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(2087);
	
	registerPainter('vml', Painter);

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1000);

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1005);

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1006);

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1035);

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1036);

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1044);

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1054);

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1094);

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1095);

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1103);

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(117);

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1217);

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(143);

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(1435);

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(221);

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(229);

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(231);

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(372);

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(374);

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(375);

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(380);

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(382);

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(386);

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(390);

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(395);

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(664);

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(878);

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(968);

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(969);

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(5))(976);

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// main.js